
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire841a"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire841a"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("bibO8", function(module, exports) {
"use strict";

module.exports = (parcelRequire("65UUy"));

});
parcelRegister("65UUy", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $46ff5b13b45c702c$export$ffb0004e005737fa; }, function (v) { return $46ff5b13b45c702c$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $46ff5b13b45c702c$export$34b9dba7ce09269b; }, function (v) { return $46ff5b13b45c702c$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $46ff5b13b45c702c$export$25062201e9e25d76; }, function (v) { return $46ff5b13b45c702c$export$25062201e9e25d76 = v; });
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $46ff5b13b45c702c$export$ffb0004e005737fa;
var $46ff5b13b45c702c$export$34b9dba7ce09269b;
var $46ff5b13b45c702c$export$25062201e9e25d76;
"use strict";

var $dAx5m = parcelRequire("dAx5m");
var $46ff5b13b45c702c$var$k = Symbol.for("react.element"), $46ff5b13b45c702c$var$l = Symbol.for("react.fragment"), $46ff5b13b45c702c$var$m = Object.prototype.hasOwnProperty, $46ff5b13b45c702c$var$n = $dAx5m.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $46ff5b13b45c702c$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $46ff5b13b45c702c$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$46ff5b13b45c702c$var$m.call(a, b) && !$46ff5b13b45c702c$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $46ff5b13b45c702c$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $46ff5b13b45c702c$var$n.current
    };
}
$46ff5b13b45c702c$export$ffb0004e005737fa = $46ff5b13b45c702c$var$l;
$46ff5b13b45c702c$export$34b9dba7ce09269b = $46ff5b13b45c702c$var$q;
$46ff5b13b45c702c$export$25062201e9e25d76 = $46ff5b13b45c702c$var$q;

});
parcelRegister("dAx5m", function(module, exports) {
"use strict";

module.exports = (parcelRequire("798ka"));

});
parcelRegister("798ka", function(module, exports) {

$parcel$export(module.exports, "Children", function () { return $533fd4b62dc4d9df$export$dca3b0875bd9a954; }, function (v) { return $533fd4b62dc4d9df$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $533fd4b62dc4d9df$export$16fa2f45be04daa8; }, function (v) { return $533fd4b62dc4d9df$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $533fd4b62dc4d9df$export$ffb0004e005737fa; }, function (v) { return $533fd4b62dc4d9df$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $533fd4b62dc4d9df$export$e2c29f18771995cb; }, function (v) { return $533fd4b62dc4d9df$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $533fd4b62dc4d9df$export$221d75b3f55bb0bd; }, function (v) { return $533fd4b62dc4d9df$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $533fd4b62dc4d9df$export$5f8d39834fd61797; }, function (v) { return $533fd4b62dc4d9df$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $533fd4b62dc4d9df$export$74bf444e3cd11ea5; }, function (v) { return $533fd4b62dc4d9df$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $533fd4b62dc4d9df$export$ae55be85d98224ed; }, function (v) { return $533fd4b62dc4d9df$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "act", function () { return $533fd4b62dc4d9df$export$3ba232387fd5d6dd; }, function (v) { return $533fd4b62dc4d9df$export$3ba232387fd5d6dd = v; });
$parcel$export(module.exports, "cloneElement", function () { return $533fd4b62dc4d9df$export$e530037191fcd5d7; }, function (v) { return $533fd4b62dc4d9df$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $533fd4b62dc4d9df$export$fd42f52fd3ae1109; }, function (v) { return $533fd4b62dc4d9df$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $533fd4b62dc4d9df$export$c8a8987d4410bf2d; }, function (v) { return $533fd4b62dc4d9df$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createFactory", function () { return $533fd4b62dc4d9df$export$d38cd72104c1f0e9; }, function (v) { return $533fd4b62dc4d9df$export$d38cd72104c1f0e9 = v; });
$parcel$export(module.exports, "createRef", function () { return $533fd4b62dc4d9df$export$7d1e3a5e95ceca43; }, function (v) { return $533fd4b62dc4d9df$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $533fd4b62dc4d9df$export$257a8862b851cb5b; }, function (v) { return $533fd4b62dc4d9df$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $533fd4b62dc4d9df$export$a8257692ac88316c; }, function (v) { return $533fd4b62dc4d9df$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $533fd4b62dc4d9df$export$488013bae63b21da; }, function (v) { return $533fd4b62dc4d9df$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $533fd4b62dc4d9df$export$7c73462e0d25e514; }, function (v) { return $533fd4b62dc4d9df$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "startTransition", function () { return $533fd4b62dc4d9df$export$7568632d0d33d16d; }, function (v) { return $533fd4b62dc4d9df$export$7568632d0d33d16d = v; });
$parcel$export(module.exports, "unstable_act", function () { return $533fd4b62dc4d9df$export$88948ce120ea2619; }, function (v) { return $533fd4b62dc4d9df$export$88948ce120ea2619 = v; });
$parcel$export(module.exports, "useCallback", function () { return $533fd4b62dc4d9df$export$35808ee640e87ca7; }, function (v) { return $533fd4b62dc4d9df$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $533fd4b62dc4d9df$export$fae74005e78b1a27; }, function (v) { return $533fd4b62dc4d9df$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $533fd4b62dc4d9df$export$dc8fbce3eb94dc1e; }, function (v) { return $533fd4b62dc4d9df$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useDeferredValue", function () { return $533fd4b62dc4d9df$export$6a7bc4e911dc01cf; }, function (v) { return $533fd4b62dc4d9df$export$6a7bc4e911dc01cf = v; });
$parcel$export(module.exports, "useEffect", function () { return $533fd4b62dc4d9df$export$6d9c69b0de29b591; }, function (v) { return $533fd4b62dc4d9df$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useId", function () { return $533fd4b62dc4d9df$export$f680877a34711e37; }, function (v) { return $533fd4b62dc4d9df$export$f680877a34711e37 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $533fd4b62dc4d9df$export$d5a552a76deda3c2; }, function (v) { return $533fd4b62dc4d9df$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useInsertionEffect", function () { return $533fd4b62dc4d9df$export$aaabe4eda9ed9969; }, function (v) { return $533fd4b62dc4d9df$export$aaabe4eda9ed9969 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $533fd4b62dc4d9df$export$e5c5a5f917a5871c; }, function (v) { return $533fd4b62dc4d9df$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $533fd4b62dc4d9df$export$1538c33de8887b59; }, function (v) { return $533fd4b62dc4d9df$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useReducer", function () { return $533fd4b62dc4d9df$export$13e3392192263954; }, function (v) { return $533fd4b62dc4d9df$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $533fd4b62dc4d9df$export$b8f5890fc79d6aca; }, function (v) { return $533fd4b62dc4d9df$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $533fd4b62dc4d9df$export$60241385465d0a34; }, function (v) { return $533fd4b62dc4d9df$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "useSyncExternalStore", function () { return $533fd4b62dc4d9df$export$306c0aa65ff9ec16; }, function (v) { return $533fd4b62dc4d9df$export$306c0aa65ff9ec16 = v; });
$parcel$export(module.exports, "useTransition", function () { return $533fd4b62dc4d9df$export$7b286972b8d8ccbf; }, function (v) { return $533fd4b62dc4d9df$export$7b286972b8d8ccbf = v; });
$parcel$export(module.exports, "version", function () { return $533fd4b62dc4d9df$export$83d89fbfd8236492; }, function (v) { return $533fd4b62dc4d9df$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $533fd4b62dc4d9df$export$dca3b0875bd9a954;
var $533fd4b62dc4d9df$export$16fa2f45be04daa8;
var $533fd4b62dc4d9df$export$ffb0004e005737fa;
var $533fd4b62dc4d9df$export$e2c29f18771995cb;
var $533fd4b62dc4d9df$export$221d75b3f55bb0bd;
var $533fd4b62dc4d9df$export$5f8d39834fd61797;
var $533fd4b62dc4d9df$export$74bf444e3cd11ea5;
var $533fd4b62dc4d9df$export$ae55be85d98224ed;
var $533fd4b62dc4d9df$export$3ba232387fd5d6dd;
var $533fd4b62dc4d9df$export$e530037191fcd5d7;
var $533fd4b62dc4d9df$export$fd42f52fd3ae1109;
var $533fd4b62dc4d9df$export$c8a8987d4410bf2d;
var $533fd4b62dc4d9df$export$d38cd72104c1f0e9;
var $533fd4b62dc4d9df$export$7d1e3a5e95ceca43;
var $533fd4b62dc4d9df$export$257a8862b851cb5b;
var $533fd4b62dc4d9df$export$a8257692ac88316c;
var $533fd4b62dc4d9df$export$488013bae63b21da;
var $533fd4b62dc4d9df$export$7c73462e0d25e514;
var $533fd4b62dc4d9df$export$7568632d0d33d16d;
var $533fd4b62dc4d9df$export$88948ce120ea2619;
var $533fd4b62dc4d9df$export$35808ee640e87ca7;
var $533fd4b62dc4d9df$export$fae74005e78b1a27;
var $533fd4b62dc4d9df$export$dc8fbce3eb94dc1e;
var $533fd4b62dc4d9df$export$6a7bc4e911dc01cf;
var $533fd4b62dc4d9df$export$6d9c69b0de29b591;
var $533fd4b62dc4d9df$export$f680877a34711e37;
var $533fd4b62dc4d9df$export$d5a552a76deda3c2;
var $533fd4b62dc4d9df$export$aaabe4eda9ed9969;
var $533fd4b62dc4d9df$export$e5c5a5f917a5871c;
var $533fd4b62dc4d9df$export$1538c33de8887b59;
var $533fd4b62dc4d9df$export$13e3392192263954;
var $533fd4b62dc4d9df$export$b8f5890fc79d6aca;
var $533fd4b62dc4d9df$export$60241385465d0a34;
var $533fd4b62dc4d9df$export$306c0aa65ff9ec16;
var $533fd4b62dc4d9df$export$7b286972b8d8ccbf;
var $533fd4b62dc4d9df$export$83d89fbfd8236492;
"use strict";
var $533fd4b62dc4d9df$var$l = Symbol.for("react.element"), $533fd4b62dc4d9df$var$n = Symbol.for("react.portal"), $533fd4b62dc4d9df$var$p = Symbol.for("react.fragment"), $533fd4b62dc4d9df$var$q = Symbol.for("react.strict_mode"), $533fd4b62dc4d9df$var$r = Symbol.for("react.profiler"), $533fd4b62dc4d9df$var$t = Symbol.for("react.provider"), $533fd4b62dc4d9df$var$u = Symbol.for("react.context"), $533fd4b62dc4d9df$var$v = Symbol.for("react.forward_ref"), $533fd4b62dc4d9df$var$w = Symbol.for("react.suspense"), $533fd4b62dc4d9df$var$x = Symbol.for("react.memo"), $533fd4b62dc4d9df$var$y = Symbol.for("react.lazy"), $533fd4b62dc4d9df$var$z = Symbol.iterator;
function $533fd4b62dc4d9df$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $533fd4b62dc4d9df$var$z && a[$533fd4b62dc4d9df$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $533fd4b62dc4d9df$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $533fd4b62dc4d9df$var$C = Object.assign, $533fd4b62dc4d9df$var$D = {};
function $533fd4b62dc4d9df$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $533fd4b62dc4d9df$var$D;
    this.updater = e || $533fd4b62dc4d9df$var$B;
}
$533fd4b62dc4d9df$var$E.prototype.isReactComponent = {};
$533fd4b62dc4d9df$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$533fd4b62dc4d9df$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $533fd4b62dc4d9df$var$F() {}
$533fd4b62dc4d9df$var$F.prototype = $533fd4b62dc4d9df$var$E.prototype;
function $533fd4b62dc4d9df$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $533fd4b62dc4d9df$var$D;
    this.updater = e || $533fd4b62dc4d9df$var$B;
}
var $533fd4b62dc4d9df$var$H = $533fd4b62dc4d9df$var$G.prototype = new $533fd4b62dc4d9df$var$F;
$533fd4b62dc4d9df$var$H.constructor = $533fd4b62dc4d9df$var$G;
$533fd4b62dc4d9df$var$C($533fd4b62dc4d9df$var$H, $533fd4b62dc4d9df$var$E.prototype);
$533fd4b62dc4d9df$var$H.isPureReactComponent = !0;
var $533fd4b62dc4d9df$var$I = Array.isArray, $533fd4b62dc4d9df$var$J = Object.prototype.hasOwnProperty, $533fd4b62dc4d9df$var$K = {
    current: null
}, $533fd4b62dc4d9df$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $533fd4b62dc4d9df$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$533fd4b62dc4d9df$var$J.call(b, d) && !$533fd4b62dc4d9df$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $533fd4b62dc4d9df$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $533fd4b62dc4d9df$var$K.current
    };
}
function $533fd4b62dc4d9df$var$N(a, b) {
    return {
        $$typeof: $533fd4b62dc4d9df$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $533fd4b62dc4d9df$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $533fd4b62dc4d9df$var$l;
}
function $533fd4b62dc4d9df$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $533fd4b62dc4d9df$var$P = /\/+/g;
function $533fd4b62dc4d9df$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $533fd4b62dc4d9df$var$escape("" + a.key) : b.toString(36);
}
function $533fd4b62dc4d9df$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $533fd4b62dc4d9df$var$l:
                case $533fd4b62dc4d9df$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $533fd4b62dc4d9df$var$Q(h, 0) : d, $533fd4b62dc4d9df$var$I(c) ? (e = "", null != a && (e = a.replace($533fd4b62dc4d9df$var$P, "$&/") + "/"), $533fd4b62dc4d9df$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($533fd4b62dc4d9df$var$O(c) && (c = $533fd4b62dc4d9df$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($533fd4b62dc4d9df$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($533fd4b62dc4d9df$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $533fd4b62dc4d9df$var$Q(k, g);
        h += $533fd4b62dc4d9df$var$R(k, b, e, f, c);
    }
    else if (f = $533fd4b62dc4d9df$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $533fd4b62dc4d9df$var$Q(k, g++), h += $533fd4b62dc4d9df$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $533fd4b62dc4d9df$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $533fd4b62dc4d9df$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $533fd4b62dc4d9df$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $533fd4b62dc4d9df$var$U = {
    current: null
}, $533fd4b62dc4d9df$var$V = {
    transition: null
}, $533fd4b62dc4d9df$var$W = {
    ReactCurrentDispatcher: $533fd4b62dc4d9df$var$U,
    ReactCurrentBatchConfig: $533fd4b62dc4d9df$var$V,
    ReactCurrentOwner: $533fd4b62dc4d9df$var$K
};
function $533fd4b62dc4d9df$var$X() {
    throw Error("act(...) is not supported in production builds of React.");
}
$533fd4b62dc4d9df$export$dca3b0875bd9a954 = {
    map: $533fd4b62dc4d9df$var$S,
    forEach: function(a, b, e) {
        $533fd4b62dc4d9df$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $533fd4b62dc4d9df$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $533fd4b62dc4d9df$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$533fd4b62dc4d9df$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$533fd4b62dc4d9df$export$16fa2f45be04daa8 = $533fd4b62dc4d9df$var$E;
$533fd4b62dc4d9df$export$ffb0004e005737fa = $533fd4b62dc4d9df$var$p;
$533fd4b62dc4d9df$export$e2c29f18771995cb = $533fd4b62dc4d9df$var$r;
$533fd4b62dc4d9df$export$221d75b3f55bb0bd = $533fd4b62dc4d9df$var$G;
$533fd4b62dc4d9df$export$5f8d39834fd61797 = $533fd4b62dc4d9df$var$q;
$533fd4b62dc4d9df$export$74bf444e3cd11ea5 = $533fd4b62dc4d9df$var$w;
$533fd4b62dc4d9df$export$ae55be85d98224ed = $533fd4b62dc4d9df$var$W;
$533fd4b62dc4d9df$export$3ba232387fd5d6dd = $533fd4b62dc4d9df$var$X;
$533fd4b62dc4d9df$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $533fd4b62dc4d9df$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $533fd4b62dc4d9df$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$533fd4b62dc4d9df$var$J.call(b, f) && !$533fd4b62dc4d9df$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $533fd4b62dc4d9df$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$533fd4b62dc4d9df$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $533fd4b62dc4d9df$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $533fd4b62dc4d9df$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$533fd4b62dc4d9df$export$c8a8987d4410bf2d = $533fd4b62dc4d9df$var$M;
$533fd4b62dc4d9df$export$d38cd72104c1f0e9 = function(a) {
    var b = $533fd4b62dc4d9df$var$M.bind(null, a);
    b.type = a;
    return b;
};
$533fd4b62dc4d9df$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$533fd4b62dc4d9df$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $533fd4b62dc4d9df$var$v,
        render: a
    };
};
$533fd4b62dc4d9df$export$a8257692ac88316c = $533fd4b62dc4d9df$var$O;
$533fd4b62dc4d9df$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $533fd4b62dc4d9df$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $533fd4b62dc4d9df$var$T
    };
};
$533fd4b62dc4d9df$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $533fd4b62dc4d9df$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$533fd4b62dc4d9df$export$7568632d0d33d16d = function(a) {
    var b = $533fd4b62dc4d9df$var$V.transition;
    $533fd4b62dc4d9df$var$V.transition = {};
    try {
        a();
    } finally{
        $533fd4b62dc4d9df$var$V.transition = b;
    }
};
$533fd4b62dc4d9df$export$88948ce120ea2619 = $533fd4b62dc4d9df$var$X;
$533fd4b62dc4d9df$export$35808ee640e87ca7 = function(a, b) {
    return $533fd4b62dc4d9df$var$U.current.useCallback(a, b);
};
$533fd4b62dc4d9df$export$fae74005e78b1a27 = function(a) {
    return $533fd4b62dc4d9df$var$U.current.useContext(a);
};
$533fd4b62dc4d9df$export$dc8fbce3eb94dc1e = function() {};
$533fd4b62dc4d9df$export$6a7bc4e911dc01cf = function(a) {
    return $533fd4b62dc4d9df$var$U.current.useDeferredValue(a);
};
$533fd4b62dc4d9df$export$6d9c69b0de29b591 = function(a, b) {
    return $533fd4b62dc4d9df$var$U.current.useEffect(a, b);
};
$533fd4b62dc4d9df$export$f680877a34711e37 = function() {
    return $533fd4b62dc4d9df$var$U.current.useId();
};
$533fd4b62dc4d9df$export$d5a552a76deda3c2 = function(a, b, e) {
    return $533fd4b62dc4d9df$var$U.current.useImperativeHandle(a, b, e);
};
$533fd4b62dc4d9df$export$aaabe4eda9ed9969 = function(a, b) {
    return $533fd4b62dc4d9df$var$U.current.useInsertionEffect(a, b);
};
$533fd4b62dc4d9df$export$e5c5a5f917a5871c = function(a, b) {
    return $533fd4b62dc4d9df$var$U.current.useLayoutEffect(a, b);
};
$533fd4b62dc4d9df$export$1538c33de8887b59 = function(a, b) {
    return $533fd4b62dc4d9df$var$U.current.useMemo(a, b);
};
$533fd4b62dc4d9df$export$13e3392192263954 = function(a, b, e) {
    return $533fd4b62dc4d9df$var$U.current.useReducer(a, b, e);
};
$533fd4b62dc4d9df$export$b8f5890fc79d6aca = function(a) {
    return $533fd4b62dc4d9df$var$U.current.useRef(a);
};
$533fd4b62dc4d9df$export$60241385465d0a34 = function(a) {
    return $533fd4b62dc4d9df$var$U.current.useState(a);
};
$533fd4b62dc4d9df$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $533fd4b62dc4d9df$var$U.current.useSyncExternalStore(a, b, e);
};
$533fd4b62dc4d9df$export$7b286972b8d8ccbf = function() {
    return $533fd4b62dc4d9df$var$U.current.useTransition();
};
$533fd4b62dc4d9df$export$83d89fbfd8236492 = "18.3.1";

});




parcelRegister("1Bj4T", function(module, exports) {

$parcel$export(module.exports, "getConfig", function () { return $e41b043f0c3017e5$export$44487a86467333c3; });

var $6qH56 = parcelRequire("6qH56");

var $djcZD = parcelRequire("djcZD");
// default configs is also config for production env
const $e41b043f0c3017e5$var$defaultConfig = {
    stargateRoot: "/gateway/api",
    mediaApiClientId: "fad17e2e-9fbd-427c-b7eb-acabf78c258f",
    analytics: {
        scheme: "https",
        server: "analytics.atlassian.com"
    },
    identityProxyUrl: "/manage/rest",
    emailPreferencesUrl: "/gateway/api/marketing/email-preferences",
    atlassianAccountUrl: "https://id.atlassian.com",
    permsServiceUrl: "/gateway/api/permissions",
    mpacRoot: "https://marketplace.atlassian.com",
    haveISeenItUrl: "/gateway/api/flag/my",
    statsigApiKey: "85b8609a-422f-45b6-9f02-e143340a831e",
    statsigDynConfigUrl: "https://api.atlassian.com/flags"
};
const $e41b043f0c3017e5$var$stagingOverrides = {
    mediaApiClientId: "9650cd51-5e82-48e6-b5bd-e9ee499f3b80",
    atlassianAccountUrl: "https://id.stg.internal.atlassian.com",
    mpacRoot: "https://marketplace.stg.internal.atlassian.com",
    statsigApiKey: "fafc04ef-8b74-40f6-8049-dcc52b765447",
    statsigDynConfigUrl: "https://api.stg.atlassian.com/flags"
};
const $e41b043f0c3017e5$var$localAndTestOverrides = {
    stargateRoot: "https://id.stg.internal.atlassian.com/gateway/api",
    emailPreferencesUrl: "https://id.stg.internal.atlassian.com/gateway/api/marketing/email-preferences",
    permsServiceUrl: "https://id.stg.internal.atlassian.com/gateway/api/permissions",
    atlassianAccountUrl: "https://id.stg.internal.atlassian.com",
    mpacRoot: "https://marketplace.stg.internal.atlassian.com",
    // use same mock data as siteDirectory app
    identityProxyUrl: "/profile-rest",
    statsigApiKey: "ff4cf059-97be-4751-beb1-da318e29cbcc",
    statsigDynConfigUrl: "https://api.dev.atlassian.com/flags"
};
const $e41b043f0c3017e5$var$environmentOverrides = {
    local: {
        ...$e41b043f0c3017e5$var$localAndTestOverrides,
        mediaApiClientId: "9650cd51-5e82-48e6-b5bd-e9ee499f3b80",
        analytics: {
            scheme: "http",
            server: `${(0, (/*@__PURE__*/$parcel$interopDefault($6qH56))).location.hostname}:3000`
        }
    },
    test: {
        ...$e41b043f0c3017e5$var$localAndTestOverrides,
        analytics: {
            scheme: "http",
            server: "localhost:3000"
        }
    },
    ddev: {
        ...$e41b043f0c3017e5$var$stagingOverrides,
        atlassianAccountUrl: "https://id.dev.internal.atlassian.com"
    },
    fedex: {
        ...$e41b043f0c3017e5$var$stagingOverrides,
        atlassianAccountUrl: "https://id.atlassian-fex.com"
    },
    stg: $e41b043f0c3017e5$var$stagingOverrides,
    "stg-fedm": {
        ...$e41b043f0c3017e5$var$stagingOverrides,
        atlassianAccountUrl: "https://id.stg.atlassian-us-gov-mod.com",
        statsigApiKey: "bcb0e982-1aa9-46ec-ba11-12a80bbf3d00",
        statsigDynConfigUrl: "https://api.stg.atlassian-us-gov-mod.com/flags"
    },
    "prod-fedm": {
        ...$e41b043f0c3017e5$var$defaultConfig,
        atlassianAccountUrl: "https://id.atlassian-us-gov-mod.com",
        statsigApiKey: "9cd2f9f5-8320-4305-83ea-9e6deee60795",
        statsigDynConfigUrl: "https://api.atlassian-us-gov-mod.com/flags"
    }
};
const $e41b043f0c3017e5$var$cachedConfig = {};
function $e41b043f0c3017e5$export$44487a86467333c3() {
    const env = (0, $djcZD.getEnv)();
    if (!$e41b043f0c3017e5$var$cachedConfig[env]) $e41b043f0c3017e5$var$cachedConfig[env] = {
        ...$e41b043f0c3017e5$var$defaultConfig,
        ...$e41b043f0c3017e5$var$environmentOverrides[env]
    };
    return $e41b043f0c3017e5$var$cachedConfig[env];
}

});
parcelRegister("6qH56", function(module, exports) {
"use strict";
module.exports = typeof self === "object" && self.self === self && self || typeof $parcel$global === "object" && $parcel$global.global === $parcel$global && $parcel$global || module.exports;

});

parcelRegister("djcZD", function(module, exports) {

$parcel$export(module.exports, "getEnv", function () { return $1895031d7c74387b$export$4bd44a2aa29d3d6e; });
$parcel$export(module.exports, "isFedRamp", function () { return $1895031d7c74387b$export$64d6499adf9b2e51; });

var $6qH56 = parcelRequire("6qH56");
const $1895031d7c74387b$var$inferEnvFromHostname = (hostname)=>{
    if (hostname === "localhost") return "local";
    if (hostname.endsWith(".dev.internal.atlassian.com") || hostname.endsWith(".dev.atlassian.com")) return "ddev";
    if (hostname.endsWith(".stg.internal.atlassian.com") || hostname.endsWith(".stg.atlassian.com")) return "stg";
    if (hostname.endsWith(".atlassian-fex.com")) return "fedex";
    if (hostname.endsWith(".stg.atlassian-us-gov-mod.com")) return "stg-fedm";
    if (hostname.endsWith(".atlassian-us-gov-mod.com")) return "prod-fedm";
    if (hostname.endsWith(".atlassian.com")) return "prod";
    return undefined;
};
function $1895031d7c74387b$export$4bd44a2aa29d3d6e() {
    try {
        const inferredEnv = $1895031d7c74387b$var$inferEnvFromHostname((0, (/*@__PURE__*/$parcel$interopDefault($6qH56))).location.hostname);
        if (inferredEnv) return inferredEnv;
    } catch (e) {
    // No action, let it fall through to safe default
    }
    // Safe default:
    return "prod";
}
const $1895031d7c74387b$var$perimeters = {
    local: "commercial",
    test: "commercial",
    ddev: "commercial",
    stg: "commercial",
    fedex: "commercial",
    "stg-fedm": "fedramp-moderate",
    prod: "commercial",
    "prod-fedm": "fedramp-moderate"
};
const $1895031d7c74387b$export$84a0517db04c70cb = $1895031d7c74387b$var$perimeters[$1895031d7c74387b$export$4bd44a2aa29d3d6e()];
const $1895031d7c74387b$export$64d6499adf9b2e51 = ()=>$1895031d7c74387b$export$84a0517db04c70cb.includes("fedramp");

});


parcelRegister("1MpXQ", function(module, exports) {
"use strict";
function $14be6a1eccfb65d2$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($14be6a1eccfb65d2$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$14be6a1eccfb65d2$var$checkDCE();

module.exports = (parcelRequire("agml1"));

});
parcelRegister("agml1", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $778cb9e25548f7d6$export$ae55be85d98224ed; }, function (v) { return $778cb9e25548f7d6$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "createPortal", function () { return $778cb9e25548f7d6$export$d39a5bbd09211389; }, function (v) { return $778cb9e25548f7d6$export$d39a5bbd09211389 = v; });
$parcel$export(module.exports, "createRoot", function () { return $778cb9e25548f7d6$export$882461b6382ed46c; }, function (v) { return $778cb9e25548f7d6$export$882461b6382ed46c = v; });
$parcel$export(module.exports, "findDOMNode", function () { return $778cb9e25548f7d6$export$466bfc07425424d5; }, function (v) { return $778cb9e25548f7d6$export$466bfc07425424d5 = v; });
$parcel$export(module.exports, "flushSync", function () { return $778cb9e25548f7d6$export$cd75ccfd720a3cd4; }, function (v) { return $778cb9e25548f7d6$export$cd75ccfd720a3cd4 = v; });
$parcel$export(module.exports, "hydrate", function () { return $778cb9e25548f7d6$export$fa8d919ba61d84db; }, function (v) { return $778cb9e25548f7d6$export$fa8d919ba61d84db = v; });
$parcel$export(module.exports, "hydrateRoot", function () { return $778cb9e25548f7d6$export$757ceba2d55c277e; }, function (v) { return $778cb9e25548f7d6$export$757ceba2d55c277e = v; });
$parcel$export(module.exports, "render", function () { return $778cb9e25548f7d6$export$b3890eb0ae9dca99; }, function (v) { return $778cb9e25548f7d6$export$b3890eb0ae9dca99 = v; });
$parcel$export(module.exports, "unmountComponentAtNode", function () { return $778cb9e25548f7d6$export$502457920280e6be; }, function (v) { return $778cb9e25548f7d6$export$502457920280e6be = v; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $778cb9e25548f7d6$export$c78a37762a8d58e1; }, function (v) { return $778cb9e25548f7d6$export$c78a37762a8d58e1 = v; });
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", function () { return $778cb9e25548f7d6$export$dc54d992c10e8a18; }, function (v) { return $778cb9e25548f7d6$export$dc54d992c10e8a18 = v; });
$parcel$export(module.exports, "version", function () { return $778cb9e25548f7d6$export$83d89fbfd8236492; }, function (v) { return $778cb9e25548f7d6$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $778cb9e25548f7d6$export$ae55be85d98224ed;
var $778cb9e25548f7d6$export$d39a5bbd09211389;
var $778cb9e25548f7d6$export$882461b6382ed46c;
var $778cb9e25548f7d6$export$466bfc07425424d5;
var $778cb9e25548f7d6$export$cd75ccfd720a3cd4;
var $778cb9e25548f7d6$export$fa8d919ba61d84db;
var $778cb9e25548f7d6$export$757ceba2d55c277e;
var $778cb9e25548f7d6$export$b3890eb0ae9dca99;
var $778cb9e25548f7d6$export$502457920280e6be;
var $778cb9e25548f7d6$export$c78a37762a8d58e1;
var $778cb9e25548f7d6$export$dc54d992c10e8a18;
var $778cb9e25548f7d6$export$83d89fbfd8236492;
"use strict";

var $dAx5m = parcelRequire("dAx5m");

var $6zU53 = parcelRequire("6zU53");
function $778cb9e25548f7d6$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $778cb9e25548f7d6$var$da = new Set, $778cb9e25548f7d6$var$ea = {};
function $778cb9e25548f7d6$var$fa(a, b) {
    $778cb9e25548f7d6$var$ha(a, b);
    $778cb9e25548f7d6$var$ha(a + "Capture", b);
}
function $778cb9e25548f7d6$var$ha(a, b) {
    $778cb9e25548f7d6$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$778cb9e25548f7d6$var$da.add(b[a]);
}
var $778cb9e25548f7d6$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $778cb9e25548f7d6$var$ja = Object.prototype.hasOwnProperty, $778cb9e25548f7d6$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $778cb9e25548f7d6$var$la = {}, $778cb9e25548f7d6$var$ma = {};
function $778cb9e25548f7d6$var$oa(a) {
    if ($778cb9e25548f7d6$var$ja.call($778cb9e25548f7d6$var$ma, a)) return !0;
    if ($778cb9e25548f7d6$var$ja.call($778cb9e25548f7d6$var$la, a)) return !1;
    if ($778cb9e25548f7d6$var$ka.test(a)) return $778cb9e25548f7d6$var$ma[a] = !0;
    $778cb9e25548f7d6$var$la[a] = !0;
    return !1;
}
function $778cb9e25548f7d6$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $778cb9e25548f7d6$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $778cb9e25548f7d6$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $778cb9e25548f7d6$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $778cb9e25548f7d6$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $778cb9e25548f7d6$var$z[a] = new $778cb9e25548f7d6$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $778cb9e25548f7d6$var$z[b] = new $778cb9e25548f7d6$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $778cb9e25548f7d6$var$z[a] = new $778cb9e25548f7d6$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $778cb9e25548f7d6$var$z[a] = new $778cb9e25548f7d6$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $778cb9e25548f7d6$var$z[a] = new $778cb9e25548f7d6$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $778cb9e25548f7d6$var$z[a] = new $778cb9e25548f7d6$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $778cb9e25548f7d6$var$z[a] = new $778cb9e25548f7d6$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $778cb9e25548f7d6$var$z[a] = new $778cb9e25548f7d6$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $778cb9e25548f7d6$var$z[a] = new $778cb9e25548f7d6$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $778cb9e25548f7d6$var$ra = /[\-:]([a-z])/g;
function $778cb9e25548f7d6$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($778cb9e25548f7d6$var$ra, $778cb9e25548f7d6$var$sa);
    $778cb9e25548f7d6$var$z[b] = new $778cb9e25548f7d6$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($778cb9e25548f7d6$var$ra, $778cb9e25548f7d6$var$sa);
    $778cb9e25548f7d6$var$z[b] = new $778cb9e25548f7d6$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($778cb9e25548f7d6$var$ra, $778cb9e25548f7d6$var$sa);
    $778cb9e25548f7d6$var$z[b] = new $778cb9e25548f7d6$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $778cb9e25548f7d6$var$z[a] = new $778cb9e25548f7d6$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$778cb9e25548f7d6$var$z.xlinkHref = new $778cb9e25548f7d6$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $778cb9e25548f7d6$var$z[a] = new $778cb9e25548f7d6$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $778cb9e25548f7d6$var$ta(a, b, c, d) {
    var e = $778cb9e25548f7d6$var$z.hasOwnProperty(b) ? $778cb9e25548f7d6$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $778cb9e25548f7d6$var$qa(b, c, e, d) && (c = null), d || null === e ? $778cb9e25548f7d6$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $778cb9e25548f7d6$var$ua = $dAx5m.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $778cb9e25548f7d6$var$va = Symbol.for("react.element"), $778cb9e25548f7d6$var$wa = Symbol.for("react.portal"), $778cb9e25548f7d6$var$ya = Symbol.for("react.fragment"), $778cb9e25548f7d6$var$za = Symbol.for("react.strict_mode"), $778cb9e25548f7d6$var$Aa = Symbol.for("react.profiler"), $778cb9e25548f7d6$var$Ba = Symbol.for("react.provider"), $778cb9e25548f7d6$var$Ca = Symbol.for("react.context"), $778cb9e25548f7d6$var$Da = Symbol.for("react.forward_ref"), $778cb9e25548f7d6$var$Ea = Symbol.for("react.suspense"), $778cb9e25548f7d6$var$Fa = Symbol.for("react.suspense_list"), $778cb9e25548f7d6$var$Ga = Symbol.for("react.memo"), $778cb9e25548f7d6$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $778cb9e25548f7d6$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $778cb9e25548f7d6$var$Ja = Symbol.iterator;
function $778cb9e25548f7d6$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $778cb9e25548f7d6$var$Ja && a[$778cb9e25548f7d6$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $778cb9e25548f7d6$var$A = Object.assign, $778cb9e25548f7d6$var$La;
function $778cb9e25548f7d6$var$Ma(a) {
    if (void 0 === $778cb9e25548f7d6$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $778cb9e25548f7d6$var$La = b && b[1] || "";
    }
    return "\n" + $778cb9e25548f7d6$var$La + a;
}
var $778cb9e25548f7d6$var$Na = !1;
function $778cb9e25548f7d6$var$Oa(a, b) {
    if (!a || $778cb9e25548f7d6$var$Na) return "";
    $778cb9e25548f7d6$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $778cb9e25548f7d6$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $778cb9e25548f7d6$var$Ma(a) : "";
}
function $778cb9e25548f7d6$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $778cb9e25548f7d6$var$Ma(a.type);
        case 16:
            return $778cb9e25548f7d6$var$Ma("Lazy");
        case 13:
            return $778cb9e25548f7d6$var$Ma("Suspense");
        case 19:
            return $778cb9e25548f7d6$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $778cb9e25548f7d6$var$Oa(a.type, !1), a;
        case 11:
            return a = $778cb9e25548f7d6$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $778cb9e25548f7d6$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $778cb9e25548f7d6$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $778cb9e25548f7d6$var$ya:
            return "Fragment";
        case $778cb9e25548f7d6$var$wa:
            return "Portal";
        case $778cb9e25548f7d6$var$Aa:
            return "Profiler";
        case $778cb9e25548f7d6$var$za:
            return "StrictMode";
        case $778cb9e25548f7d6$var$Ea:
            return "Suspense";
        case $778cb9e25548f7d6$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $778cb9e25548f7d6$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $778cb9e25548f7d6$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $778cb9e25548f7d6$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $778cb9e25548f7d6$var$Ga:
            return b = a.displayName || null, null !== b ? b : $778cb9e25548f7d6$var$Qa(a.type) || "Memo";
        case $778cb9e25548f7d6$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $778cb9e25548f7d6$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $778cb9e25548f7d6$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $778cb9e25548f7d6$var$Qa(b);
        case 8:
            return b === $778cb9e25548f7d6$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $778cb9e25548f7d6$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $778cb9e25548f7d6$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $778cb9e25548f7d6$var$Ua(a) {
    var b = $778cb9e25548f7d6$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $778cb9e25548f7d6$var$Va(a) {
    a._valueTracker || (a._valueTracker = $778cb9e25548f7d6$var$Ua(a));
}
function $778cb9e25548f7d6$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $778cb9e25548f7d6$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $778cb9e25548f7d6$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $778cb9e25548f7d6$var$Ya(a, b) {
    var c = b.checked;
    return $778cb9e25548f7d6$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $778cb9e25548f7d6$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $778cb9e25548f7d6$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $778cb9e25548f7d6$var$ab(a, b) {
    b = b.checked;
    null != b && $778cb9e25548f7d6$var$ta(a, "checked", b, !1);
}
function $778cb9e25548f7d6$var$bb(a, b) {
    $778cb9e25548f7d6$var$ab(a, b);
    var c = $778cb9e25548f7d6$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $778cb9e25548f7d6$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $778cb9e25548f7d6$var$cb(a, b.type, $778cb9e25548f7d6$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $778cb9e25548f7d6$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $778cb9e25548f7d6$var$cb(a, b, c) {
    if ("number" !== b || $778cb9e25548f7d6$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $778cb9e25548f7d6$var$eb = Array.isArray;
function $778cb9e25548f7d6$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $778cb9e25548f7d6$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $778cb9e25548f7d6$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($778cb9e25548f7d6$var$p(91));
    return $778cb9e25548f7d6$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $778cb9e25548f7d6$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($778cb9e25548f7d6$var$p(92));
            if ($778cb9e25548f7d6$var$eb(c)) {
                if (1 < c.length) throw Error($778cb9e25548f7d6$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $778cb9e25548f7d6$var$Sa(c)
    };
}
function $778cb9e25548f7d6$var$ib(a, b) {
    var c = $778cb9e25548f7d6$var$Sa(b.value), d = $778cb9e25548f7d6$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $778cb9e25548f7d6$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $778cb9e25548f7d6$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $778cb9e25548f7d6$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $778cb9e25548f7d6$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $778cb9e25548f7d6$var$mb, $778cb9e25548f7d6$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $778cb9e25548f7d6$var$mb = $778cb9e25548f7d6$var$mb || document.createElement("div");
        $778cb9e25548f7d6$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $778cb9e25548f7d6$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $778cb9e25548f7d6$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $778cb9e25548f7d6$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $778cb9e25548f7d6$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($778cb9e25548f7d6$var$pb).forEach(function(a) {
    $778cb9e25548f7d6$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $778cb9e25548f7d6$var$pb[b] = $778cb9e25548f7d6$var$pb[a];
    });
});
function $778cb9e25548f7d6$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $778cb9e25548f7d6$var$pb.hasOwnProperty(a) && $778cb9e25548f7d6$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $778cb9e25548f7d6$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $778cb9e25548f7d6$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $778cb9e25548f7d6$var$tb = $778cb9e25548f7d6$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $778cb9e25548f7d6$var$ub(a, b) {
    if (b) {
        if ($778cb9e25548f7d6$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($778cb9e25548f7d6$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($778cb9e25548f7d6$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($778cb9e25548f7d6$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($778cb9e25548f7d6$var$p(62));
    }
}
function $778cb9e25548f7d6$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $778cb9e25548f7d6$var$wb = null;
function $778cb9e25548f7d6$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $778cb9e25548f7d6$var$yb = null, $778cb9e25548f7d6$var$zb = null, $778cb9e25548f7d6$var$Ab = null;
function $778cb9e25548f7d6$var$Bb(a) {
    if (a = $778cb9e25548f7d6$var$Cb(a)) {
        if ("function" !== typeof $778cb9e25548f7d6$var$yb) throw Error($778cb9e25548f7d6$var$p(280));
        var b = a.stateNode;
        b && (b = $778cb9e25548f7d6$var$Db(b), $778cb9e25548f7d6$var$yb(a.stateNode, a.type, b));
    }
}
function $778cb9e25548f7d6$var$Eb(a) {
    $778cb9e25548f7d6$var$zb ? $778cb9e25548f7d6$var$Ab ? $778cb9e25548f7d6$var$Ab.push(a) : $778cb9e25548f7d6$var$Ab = [
        a
    ] : $778cb9e25548f7d6$var$zb = a;
}
function $778cb9e25548f7d6$var$Fb() {
    if ($778cb9e25548f7d6$var$zb) {
        var a = $778cb9e25548f7d6$var$zb, b = $778cb9e25548f7d6$var$Ab;
        $778cb9e25548f7d6$var$Ab = $778cb9e25548f7d6$var$zb = null;
        $778cb9e25548f7d6$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$778cb9e25548f7d6$var$Bb(b[a]);
    }
}
function $778cb9e25548f7d6$var$Gb(a, b) {
    return a(b);
}
function $778cb9e25548f7d6$var$Hb() {}
var $778cb9e25548f7d6$var$Ib = !1;
function $778cb9e25548f7d6$var$Jb(a, b, c) {
    if ($778cb9e25548f7d6$var$Ib) return a(b, c);
    $778cb9e25548f7d6$var$Ib = !0;
    try {
        return $778cb9e25548f7d6$var$Gb(a, b, c);
    } finally{
        if ($778cb9e25548f7d6$var$Ib = !1, null !== $778cb9e25548f7d6$var$zb || null !== $778cb9e25548f7d6$var$Ab) $778cb9e25548f7d6$var$Hb(), $778cb9e25548f7d6$var$Fb();
    }
}
function $778cb9e25548f7d6$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $778cb9e25548f7d6$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($778cb9e25548f7d6$var$p(231, b, typeof c));
    return c;
}
var $778cb9e25548f7d6$var$Lb = !1;
if ($778cb9e25548f7d6$var$ia) try {
    var $778cb9e25548f7d6$var$Mb = {};
    Object.defineProperty($778cb9e25548f7d6$var$Mb, "passive", {
        get: function() {
            $778cb9e25548f7d6$var$Lb = !0;
        }
    });
    window.addEventListener("test", $778cb9e25548f7d6$var$Mb, $778cb9e25548f7d6$var$Mb);
    window.removeEventListener("test", $778cb9e25548f7d6$var$Mb, $778cb9e25548f7d6$var$Mb);
} catch (a) {
    $778cb9e25548f7d6$var$Lb = !1;
}
function $778cb9e25548f7d6$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $778cb9e25548f7d6$var$Ob = !1, $778cb9e25548f7d6$var$Pb = null, $778cb9e25548f7d6$var$Qb = !1, $778cb9e25548f7d6$var$Rb = null, $778cb9e25548f7d6$var$Sb = {
    onError: function(a) {
        $778cb9e25548f7d6$var$Ob = !0;
        $778cb9e25548f7d6$var$Pb = a;
    }
};
function $778cb9e25548f7d6$var$Tb(a, b, c, d, e, f, g, h, k) {
    $778cb9e25548f7d6$var$Ob = !1;
    $778cb9e25548f7d6$var$Pb = null;
    $778cb9e25548f7d6$var$Nb.apply($778cb9e25548f7d6$var$Sb, arguments);
}
function $778cb9e25548f7d6$var$Ub(a, b, c, d, e, f, g, h, k) {
    $778cb9e25548f7d6$var$Tb.apply(this, arguments);
    if ($778cb9e25548f7d6$var$Ob) {
        if ($778cb9e25548f7d6$var$Ob) {
            var l = $778cb9e25548f7d6$var$Pb;
            $778cb9e25548f7d6$var$Ob = !1;
            $778cb9e25548f7d6$var$Pb = null;
        } else throw Error($778cb9e25548f7d6$var$p(198));
        $778cb9e25548f7d6$var$Qb || ($778cb9e25548f7d6$var$Qb = !0, $778cb9e25548f7d6$var$Rb = l);
    }
}
function $778cb9e25548f7d6$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $778cb9e25548f7d6$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $778cb9e25548f7d6$var$Xb(a) {
    if ($778cb9e25548f7d6$var$Vb(a) !== a) throw Error($778cb9e25548f7d6$var$p(188));
}
function $778cb9e25548f7d6$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $778cb9e25548f7d6$var$Vb(a);
        if (null === b) throw Error($778cb9e25548f7d6$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $778cb9e25548f7d6$var$Xb(e), a;
                if (f === d) return $778cb9e25548f7d6$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($778cb9e25548f7d6$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($778cb9e25548f7d6$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($778cb9e25548f7d6$var$p(190));
    }
    if (3 !== c.tag) throw Error($778cb9e25548f7d6$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $778cb9e25548f7d6$var$Zb(a) {
    a = $778cb9e25548f7d6$var$Yb(a);
    return null !== a ? $778cb9e25548f7d6$var$$b(a) : null;
}
function $778cb9e25548f7d6$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $778cb9e25548f7d6$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $778cb9e25548f7d6$var$ac = $6zU53.unstable_scheduleCallback, $778cb9e25548f7d6$var$bc = $6zU53.unstable_cancelCallback, $778cb9e25548f7d6$var$cc = $6zU53.unstable_shouldYield, $778cb9e25548f7d6$var$dc = $6zU53.unstable_requestPaint, $778cb9e25548f7d6$var$B = $6zU53.unstable_now, $778cb9e25548f7d6$var$ec = $6zU53.unstable_getCurrentPriorityLevel, $778cb9e25548f7d6$var$fc = $6zU53.unstable_ImmediatePriority, $778cb9e25548f7d6$var$gc = $6zU53.unstable_UserBlockingPriority, $778cb9e25548f7d6$var$hc = $6zU53.unstable_NormalPriority, $778cb9e25548f7d6$var$ic = $6zU53.unstable_LowPriority, $778cb9e25548f7d6$var$jc = $6zU53.unstable_IdlePriority, $778cb9e25548f7d6$var$kc = null, $778cb9e25548f7d6$var$lc = null;
function $778cb9e25548f7d6$var$mc(a) {
    if ($778cb9e25548f7d6$var$lc && "function" === typeof $778cb9e25548f7d6$var$lc.onCommitFiberRoot) try {
        $778cb9e25548f7d6$var$lc.onCommitFiberRoot($778cb9e25548f7d6$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $778cb9e25548f7d6$var$oc = Math.clz32 ? Math.clz32 : $778cb9e25548f7d6$var$nc, $778cb9e25548f7d6$var$pc = Math.log, $778cb9e25548f7d6$var$qc = Math.LN2;
function $778cb9e25548f7d6$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($778cb9e25548f7d6$var$pc(a) / $778cb9e25548f7d6$var$qc | 0) | 0;
}
var $778cb9e25548f7d6$var$rc = 64, $778cb9e25548f7d6$var$sc = 4194304;
function $778cb9e25548f7d6$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $778cb9e25548f7d6$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $778cb9e25548f7d6$var$tc(h) : (f &= g, 0 !== f && (d = $778cb9e25548f7d6$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $778cb9e25548f7d6$var$tc(g) : 0 !== f && (d = $778cb9e25548f7d6$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $778cb9e25548f7d6$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $778cb9e25548f7d6$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $778cb9e25548f7d6$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $778cb9e25548f7d6$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $778cb9e25548f7d6$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $778cb9e25548f7d6$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $778cb9e25548f7d6$var$yc() {
    var a = $778cb9e25548f7d6$var$rc;
    $778cb9e25548f7d6$var$rc <<= 1;
    0 === ($778cb9e25548f7d6$var$rc & 4194240) && ($778cb9e25548f7d6$var$rc = 64);
    return a;
}
function $778cb9e25548f7d6$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $778cb9e25548f7d6$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $778cb9e25548f7d6$var$oc(b);
    a[b] = c;
}
function $778cb9e25548f7d6$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $778cb9e25548f7d6$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $778cb9e25548f7d6$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $778cb9e25548f7d6$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $778cb9e25548f7d6$var$C = 0;
function $778cb9e25548f7d6$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $778cb9e25548f7d6$var$Ec, $778cb9e25548f7d6$var$Fc, $778cb9e25548f7d6$var$Gc, $778cb9e25548f7d6$var$Hc, $778cb9e25548f7d6$var$Ic, $778cb9e25548f7d6$var$Jc = !1, $778cb9e25548f7d6$var$Kc = [], $778cb9e25548f7d6$var$Lc = null, $778cb9e25548f7d6$var$Mc = null, $778cb9e25548f7d6$var$Nc = null, $778cb9e25548f7d6$var$Oc = new Map, $778cb9e25548f7d6$var$Pc = new Map, $778cb9e25548f7d6$var$Qc = [], $778cb9e25548f7d6$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $778cb9e25548f7d6$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $778cb9e25548f7d6$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $778cb9e25548f7d6$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $778cb9e25548f7d6$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $778cb9e25548f7d6$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $778cb9e25548f7d6$var$Pc.delete(b.pointerId);
    }
}
function $778cb9e25548f7d6$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $778cb9e25548f7d6$var$Cb(b), null !== b && $778cb9e25548f7d6$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $778cb9e25548f7d6$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $778cb9e25548f7d6$var$Lc = $778cb9e25548f7d6$var$Tc($778cb9e25548f7d6$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $778cb9e25548f7d6$var$Mc = $778cb9e25548f7d6$var$Tc($778cb9e25548f7d6$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $778cb9e25548f7d6$var$Nc = $778cb9e25548f7d6$var$Tc($778cb9e25548f7d6$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $778cb9e25548f7d6$var$Oc.set(f, $778cb9e25548f7d6$var$Tc($778cb9e25548f7d6$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $778cb9e25548f7d6$var$Pc.set(f, $778cb9e25548f7d6$var$Tc($778cb9e25548f7d6$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $778cb9e25548f7d6$var$Vc(a) {
    var b = $778cb9e25548f7d6$var$Wc(a.target);
    if (null !== b) {
        var c = $778cb9e25548f7d6$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $778cb9e25548f7d6$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $778cb9e25548f7d6$var$Ic(a.priority, function() {
                        $778cb9e25548f7d6$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $778cb9e25548f7d6$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $778cb9e25548f7d6$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $778cb9e25548f7d6$var$wb = d;
            c.target.dispatchEvent(d);
            $778cb9e25548f7d6$var$wb = null;
        } else return b = $778cb9e25548f7d6$var$Cb(c), null !== b && $778cb9e25548f7d6$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $778cb9e25548f7d6$var$Zc(a, b, c) {
    $778cb9e25548f7d6$var$Xc(a) && c.delete(b);
}
function $778cb9e25548f7d6$var$$c() {
    $778cb9e25548f7d6$var$Jc = !1;
    null !== $778cb9e25548f7d6$var$Lc && $778cb9e25548f7d6$var$Xc($778cb9e25548f7d6$var$Lc) && ($778cb9e25548f7d6$var$Lc = null);
    null !== $778cb9e25548f7d6$var$Mc && $778cb9e25548f7d6$var$Xc($778cb9e25548f7d6$var$Mc) && ($778cb9e25548f7d6$var$Mc = null);
    null !== $778cb9e25548f7d6$var$Nc && $778cb9e25548f7d6$var$Xc($778cb9e25548f7d6$var$Nc) && ($778cb9e25548f7d6$var$Nc = null);
    $778cb9e25548f7d6$var$Oc.forEach($778cb9e25548f7d6$var$Zc);
    $778cb9e25548f7d6$var$Pc.forEach($778cb9e25548f7d6$var$Zc);
}
function $778cb9e25548f7d6$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $778cb9e25548f7d6$var$Jc || ($778cb9e25548f7d6$var$Jc = !0, $6zU53.unstable_scheduleCallback($6zU53.unstable_NormalPriority, $778cb9e25548f7d6$var$$c)));
}
function $778cb9e25548f7d6$var$bd(a) {
    function b(b) {
        return $778cb9e25548f7d6$var$ad(b, a);
    }
    if (0 < $778cb9e25548f7d6$var$Kc.length) {
        $778cb9e25548f7d6$var$ad($778cb9e25548f7d6$var$Kc[0], a);
        for(var c = 1; c < $778cb9e25548f7d6$var$Kc.length; c++){
            var d = $778cb9e25548f7d6$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $778cb9e25548f7d6$var$Lc && $778cb9e25548f7d6$var$ad($778cb9e25548f7d6$var$Lc, a);
    null !== $778cb9e25548f7d6$var$Mc && $778cb9e25548f7d6$var$ad($778cb9e25548f7d6$var$Mc, a);
    null !== $778cb9e25548f7d6$var$Nc && $778cb9e25548f7d6$var$ad($778cb9e25548f7d6$var$Nc, a);
    $778cb9e25548f7d6$var$Oc.forEach(b);
    $778cb9e25548f7d6$var$Pc.forEach(b);
    for(c = 0; c < $778cb9e25548f7d6$var$Qc.length; c++)d = $778cb9e25548f7d6$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $778cb9e25548f7d6$var$Qc.length && (c = $778cb9e25548f7d6$var$Qc[0], null === c.blockedOn);)$778cb9e25548f7d6$var$Vc(c), null === c.blockedOn && $778cb9e25548f7d6$var$Qc.shift();
}
var $778cb9e25548f7d6$var$cd = $778cb9e25548f7d6$var$ua.ReactCurrentBatchConfig, $778cb9e25548f7d6$var$dd = !0;
function $778cb9e25548f7d6$var$ed(a, b, c, d) {
    var e = $778cb9e25548f7d6$var$C, f = $778cb9e25548f7d6$var$cd.transition;
    $778cb9e25548f7d6$var$cd.transition = null;
    try {
        $778cb9e25548f7d6$var$C = 1, $778cb9e25548f7d6$var$fd(a, b, c, d);
    } finally{
        $778cb9e25548f7d6$var$C = e, $778cb9e25548f7d6$var$cd.transition = f;
    }
}
function $778cb9e25548f7d6$var$gd(a, b, c, d) {
    var e = $778cb9e25548f7d6$var$C, f = $778cb9e25548f7d6$var$cd.transition;
    $778cb9e25548f7d6$var$cd.transition = null;
    try {
        $778cb9e25548f7d6$var$C = 4, $778cb9e25548f7d6$var$fd(a, b, c, d);
    } finally{
        $778cb9e25548f7d6$var$C = e, $778cb9e25548f7d6$var$cd.transition = f;
    }
}
function $778cb9e25548f7d6$var$fd(a, b, c, d) {
    if ($778cb9e25548f7d6$var$dd) {
        var e = $778cb9e25548f7d6$var$Yc(a, b, c, d);
        if (null === e) $778cb9e25548f7d6$var$hd(a, b, d, $778cb9e25548f7d6$var$id, c), $778cb9e25548f7d6$var$Sc(a, d);
        else if ($778cb9e25548f7d6$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($778cb9e25548f7d6$var$Sc(a, d), b & 4 && -1 < $778cb9e25548f7d6$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $778cb9e25548f7d6$var$Cb(e);
                null !== f && $778cb9e25548f7d6$var$Ec(f);
                f = $778cb9e25548f7d6$var$Yc(a, b, c, d);
                null === f && $778cb9e25548f7d6$var$hd(a, b, d, $778cb9e25548f7d6$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $778cb9e25548f7d6$var$hd(a, b, d, null, c);
    }
}
var $778cb9e25548f7d6$var$id = null;
function $778cb9e25548f7d6$var$Yc(a, b, c, d) {
    $778cb9e25548f7d6$var$id = null;
    a = $778cb9e25548f7d6$var$xb(d);
    a = $778cb9e25548f7d6$var$Wc(a);
    if (null !== a) {
        if (b = $778cb9e25548f7d6$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $778cb9e25548f7d6$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $778cb9e25548f7d6$var$id = a;
    return null;
}
function $778cb9e25548f7d6$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($778cb9e25548f7d6$var$ec()){
                case $778cb9e25548f7d6$var$fc:
                    return 1;
                case $778cb9e25548f7d6$var$gc:
                    return 4;
                case $778cb9e25548f7d6$var$hc:
                case $778cb9e25548f7d6$var$ic:
                    return 16;
                case $778cb9e25548f7d6$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $778cb9e25548f7d6$var$kd = null, $778cb9e25548f7d6$var$ld = null, $778cb9e25548f7d6$var$md = null;
function $778cb9e25548f7d6$var$nd() {
    if ($778cb9e25548f7d6$var$md) return $778cb9e25548f7d6$var$md;
    var a, b = $778cb9e25548f7d6$var$ld, c = b.length, d, e = "value" in $778cb9e25548f7d6$var$kd ? $778cb9e25548f7d6$var$kd.value : $778cb9e25548f7d6$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $778cb9e25548f7d6$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $778cb9e25548f7d6$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $778cb9e25548f7d6$var$pd() {
    return !0;
}
function $778cb9e25548f7d6$var$qd() {
    return !1;
}
function $778cb9e25548f7d6$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $778cb9e25548f7d6$var$pd : $778cb9e25548f7d6$var$qd;
        this.isPropagationStopped = $778cb9e25548f7d6$var$qd;
        return this;
    }
    $778cb9e25548f7d6$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $778cb9e25548f7d6$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $778cb9e25548f7d6$var$pd);
        },
        persist: function() {},
        isPersistent: $778cb9e25548f7d6$var$pd
    });
    return b;
}
var $778cb9e25548f7d6$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $778cb9e25548f7d6$var$td = $778cb9e25548f7d6$var$rd($778cb9e25548f7d6$var$sd), $778cb9e25548f7d6$var$ud = $778cb9e25548f7d6$var$A({}, $778cb9e25548f7d6$var$sd, {
    view: 0,
    detail: 0
}), $778cb9e25548f7d6$var$vd = $778cb9e25548f7d6$var$rd($778cb9e25548f7d6$var$ud), $778cb9e25548f7d6$var$wd, $778cb9e25548f7d6$var$xd, $778cb9e25548f7d6$var$yd, $778cb9e25548f7d6$var$Ad = $778cb9e25548f7d6$var$A({}, $778cb9e25548f7d6$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $778cb9e25548f7d6$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $778cb9e25548f7d6$var$yd && ($778cb9e25548f7d6$var$yd && "mousemove" === a.type ? ($778cb9e25548f7d6$var$wd = a.screenX - $778cb9e25548f7d6$var$yd.screenX, $778cb9e25548f7d6$var$xd = a.screenY - $778cb9e25548f7d6$var$yd.screenY) : $778cb9e25548f7d6$var$xd = $778cb9e25548f7d6$var$wd = 0, $778cb9e25548f7d6$var$yd = a);
        return $778cb9e25548f7d6$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $778cb9e25548f7d6$var$xd;
    }
}), $778cb9e25548f7d6$var$Bd = $778cb9e25548f7d6$var$rd($778cb9e25548f7d6$var$Ad), $778cb9e25548f7d6$var$Cd = $778cb9e25548f7d6$var$A({}, $778cb9e25548f7d6$var$Ad, {
    dataTransfer: 0
}), $778cb9e25548f7d6$var$Dd = $778cb9e25548f7d6$var$rd($778cb9e25548f7d6$var$Cd), $778cb9e25548f7d6$var$Ed = $778cb9e25548f7d6$var$A({}, $778cb9e25548f7d6$var$ud, {
    relatedTarget: 0
}), $778cb9e25548f7d6$var$Fd = $778cb9e25548f7d6$var$rd($778cb9e25548f7d6$var$Ed), $778cb9e25548f7d6$var$Gd = $778cb9e25548f7d6$var$A({}, $778cb9e25548f7d6$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $778cb9e25548f7d6$var$Hd = $778cb9e25548f7d6$var$rd($778cb9e25548f7d6$var$Gd), $778cb9e25548f7d6$var$Id = $778cb9e25548f7d6$var$A({}, $778cb9e25548f7d6$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $778cb9e25548f7d6$var$Jd = $778cb9e25548f7d6$var$rd($778cb9e25548f7d6$var$Id), $778cb9e25548f7d6$var$Kd = $778cb9e25548f7d6$var$A({}, $778cb9e25548f7d6$var$sd, {
    data: 0
}), $778cb9e25548f7d6$var$Ld = $778cb9e25548f7d6$var$rd($778cb9e25548f7d6$var$Kd), $778cb9e25548f7d6$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $778cb9e25548f7d6$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $778cb9e25548f7d6$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $778cb9e25548f7d6$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $778cb9e25548f7d6$var$Od[a]) ? !!b[a] : !1;
}
function $778cb9e25548f7d6$var$zd() {
    return $778cb9e25548f7d6$var$Pd;
}
var $778cb9e25548f7d6$var$Qd = $778cb9e25548f7d6$var$A({}, $778cb9e25548f7d6$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $778cb9e25548f7d6$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $778cb9e25548f7d6$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $778cb9e25548f7d6$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $778cb9e25548f7d6$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $778cb9e25548f7d6$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $778cb9e25548f7d6$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $778cb9e25548f7d6$var$Rd = $778cb9e25548f7d6$var$rd($778cb9e25548f7d6$var$Qd), $778cb9e25548f7d6$var$Sd = $778cb9e25548f7d6$var$A({}, $778cb9e25548f7d6$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $778cb9e25548f7d6$var$Td = $778cb9e25548f7d6$var$rd($778cb9e25548f7d6$var$Sd), $778cb9e25548f7d6$var$Ud = $778cb9e25548f7d6$var$A({}, $778cb9e25548f7d6$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $778cb9e25548f7d6$var$zd
}), $778cb9e25548f7d6$var$Vd = $778cb9e25548f7d6$var$rd($778cb9e25548f7d6$var$Ud), $778cb9e25548f7d6$var$Wd = $778cb9e25548f7d6$var$A({}, $778cb9e25548f7d6$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $778cb9e25548f7d6$var$Xd = $778cb9e25548f7d6$var$rd($778cb9e25548f7d6$var$Wd), $778cb9e25548f7d6$var$Yd = $778cb9e25548f7d6$var$A({}, $778cb9e25548f7d6$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $778cb9e25548f7d6$var$Zd = $778cb9e25548f7d6$var$rd($778cb9e25548f7d6$var$Yd), $778cb9e25548f7d6$var$$d = [
    9,
    13,
    27,
    32
], $778cb9e25548f7d6$var$ae = $778cb9e25548f7d6$var$ia && "CompositionEvent" in window, $778cb9e25548f7d6$var$be = null;
$778cb9e25548f7d6$var$ia && "documentMode" in document && ($778cb9e25548f7d6$var$be = document.documentMode);
var $778cb9e25548f7d6$var$ce = $778cb9e25548f7d6$var$ia && "TextEvent" in window && !$778cb9e25548f7d6$var$be, $778cb9e25548f7d6$var$de = $778cb9e25548f7d6$var$ia && (!$778cb9e25548f7d6$var$ae || $778cb9e25548f7d6$var$be && 8 < $778cb9e25548f7d6$var$be && 11 >= $778cb9e25548f7d6$var$be), $778cb9e25548f7d6$var$ee = String.fromCharCode(32), $778cb9e25548f7d6$var$fe = !1;
function $778cb9e25548f7d6$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $778cb9e25548f7d6$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $778cb9e25548f7d6$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $778cb9e25548f7d6$var$ie = !1;
function $778cb9e25548f7d6$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $778cb9e25548f7d6$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $778cb9e25548f7d6$var$fe = !0;
            return $778cb9e25548f7d6$var$ee;
        case "textInput":
            return a = b.data, a === $778cb9e25548f7d6$var$ee && $778cb9e25548f7d6$var$fe ? null : a;
        default:
            return null;
    }
}
function $778cb9e25548f7d6$var$ke(a, b) {
    if ($778cb9e25548f7d6$var$ie) return "compositionend" === a || !$778cb9e25548f7d6$var$ae && $778cb9e25548f7d6$var$ge(a, b) ? (a = $778cb9e25548f7d6$var$nd(), $778cb9e25548f7d6$var$md = $778cb9e25548f7d6$var$ld = $778cb9e25548f7d6$var$kd = null, $778cb9e25548f7d6$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $778cb9e25548f7d6$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $778cb9e25548f7d6$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $778cb9e25548f7d6$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$778cb9e25548f7d6$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $778cb9e25548f7d6$var$ne(a, b, c, d) {
    $778cb9e25548f7d6$var$Eb(d);
    b = $778cb9e25548f7d6$var$oe(b, "onChange");
    0 < b.length && (c = new $778cb9e25548f7d6$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $778cb9e25548f7d6$var$pe = null, $778cb9e25548f7d6$var$qe = null;
function $778cb9e25548f7d6$var$re(a) {
    $778cb9e25548f7d6$var$se(a, 0);
}
function $778cb9e25548f7d6$var$te(a) {
    var b = $778cb9e25548f7d6$var$ue(a);
    if ($778cb9e25548f7d6$var$Wa(b)) return a;
}
function $778cb9e25548f7d6$var$ve(a, b) {
    if ("change" === a) return b;
}
var $778cb9e25548f7d6$var$we = !1;
if ($778cb9e25548f7d6$var$ia) {
    var $778cb9e25548f7d6$var$xe;
    if ($778cb9e25548f7d6$var$ia) {
        var $778cb9e25548f7d6$var$ye = "oninput" in document;
        if (!$778cb9e25548f7d6$var$ye) {
            var $778cb9e25548f7d6$var$ze = document.createElement("div");
            $778cb9e25548f7d6$var$ze.setAttribute("oninput", "return;");
            $778cb9e25548f7d6$var$ye = "function" === typeof $778cb9e25548f7d6$var$ze.oninput;
        }
        $778cb9e25548f7d6$var$xe = $778cb9e25548f7d6$var$ye;
    } else $778cb9e25548f7d6$var$xe = !1;
    $778cb9e25548f7d6$var$we = $778cb9e25548f7d6$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $778cb9e25548f7d6$var$Ae() {
    $778cb9e25548f7d6$var$pe && ($778cb9e25548f7d6$var$pe.detachEvent("onpropertychange", $778cb9e25548f7d6$var$Be), $778cb9e25548f7d6$var$qe = $778cb9e25548f7d6$var$pe = null);
}
function $778cb9e25548f7d6$var$Be(a) {
    if ("value" === a.propertyName && $778cb9e25548f7d6$var$te($778cb9e25548f7d6$var$qe)) {
        var b = [];
        $778cb9e25548f7d6$var$ne(b, $778cb9e25548f7d6$var$qe, a, $778cb9e25548f7d6$var$xb(a));
        $778cb9e25548f7d6$var$Jb($778cb9e25548f7d6$var$re, b);
    }
}
function $778cb9e25548f7d6$var$Ce(a, b, c) {
    "focusin" === a ? ($778cb9e25548f7d6$var$Ae(), $778cb9e25548f7d6$var$pe = b, $778cb9e25548f7d6$var$qe = c, $778cb9e25548f7d6$var$pe.attachEvent("onpropertychange", $778cb9e25548f7d6$var$Be)) : "focusout" === a && $778cb9e25548f7d6$var$Ae();
}
function $778cb9e25548f7d6$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $778cb9e25548f7d6$var$te($778cb9e25548f7d6$var$qe);
}
function $778cb9e25548f7d6$var$Ee(a, b) {
    if ("click" === a) return $778cb9e25548f7d6$var$te(b);
}
function $778cb9e25548f7d6$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $778cb9e25548f7d6$var$te(b);
}
function $778cb9e25548f7d6$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $778cb9e25548f7d6$var$He = "function" === typeof Object.is ? Object.is : $778cb9e25548f7d6$var$Ge;
function $778cb9e25548f7d6$var$Ie(a, b) {
    if ($778cb9e25548f7d6$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$778cb9e25548f7d6$var$ja.call(b, e) || !$778cb9e25548f7d6$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $778cb9e25548f7d6$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $778cb9e25548f7d6$var$Ke(a, b) {
    var c = $778cb9e25548f7d6$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $778cb9e25548f7d6$var$Je(c);
    }
}
function $778cb9e25548f7d6$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $778cb9e25548f7d6$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $778cb9e25548f7d6$var$Me() {
    for(var a = window, b = $778cb9e25548f7d6$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $778cb9e25548f7d6$var$Xa(a.document);
    }
    return b;
}
function $778cb9e25548f7d6$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $778cb9e25548f7d6$var$Oe(a) {
    var b = $778cb9e25548f7d6$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $778cb9e25548f7d6$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $778cb9e25548f7d6$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $778cb9e25548f7d6$var$Ke(c, f);
                var g = $778cb9e25548f7d6$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $778cb9e25548f7d6$var$Pe = $778cb9e25548f7d6$var$ia && "documentMode" in document && 11 >= document.documentMode, $778cb9e25548f7d6$var$Qe = null, $778cb9e25548f7d6$var$Re = null, $778cb9e25548f7d6$var$Se = null, $778cb9e25548f7d6$var$Te = !1;
function $778cb9e25548f7d6$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $778cb9e25548f7d6$var$Te || null == $778cb9e25548f7d6$var$Qe || $778cb9e25548f7d6$var$Qe !== $778cb9e25548f7d6$var$Xa(d) || (d = $778cb9e25548f7d6$var$Qe, "selectionStart" in d && $778cb9e25548f7d6$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $778cb9e25548f7d6$var$Se && $778cb9e25548f7d6$var$Ie($778cb9e25548f7d6$var$Se, d) || ($778cb9e25548f7d6$var$Se = d, d = $778cb9e25548f7d6$var$oe($778cb9e25548f7d6$var$Re, "onSelect"), 0 < d.length && (b = new $778cb9e25548f7d6$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $778cb9e25548f7d6$var$Qe)));
}
function $778cb9e25548f7d6$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $778cb9e25548f7d6$var$We = {
    animationend: $778cb9e25548f7d6$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $778cb9e25548f7d6$var$Ve("Animation", "AnimationIteration"),
    animationstart: $778cb9e25548f7d6$var$Ve("Animation", "AnimationStart"),
    transitionend: $778cb9e25548f7d6$var$Ve("Transition", "TransitionEnd")
}, $778cb9e25548f7d6$var$Xe = {}, $778cb9e25548f7d6$var$Ye = {};
$778cb9e25548f7d6$var$ia && ($778cb9e25548f7d6$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $778cb9e25548f7d6$var$We.animationend.animation, delete $778cb9e25548f7d6$var$We.animationiteration.animation, delete $778cb9e25548f7d6$var$We.animationstart.animation), "TransitionEvent" in window || delete $778cb9e25548f7d6$var$We.transitionend.transition);
function $778cb9e25548f7d6$var$Ze(a) {
    if ($778cb9e25548f7d6$var$Xe[a]) return $778cb9e25548f7d6$var$Xe[a];
    if (!$778cb9e25548f7d6$var$We[a]) return a;
    var b = $778cb9e25548f7d6$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $778cb9e25548f7d6$var$Ye) return $778cb9e25548f7d6$var$Xe[a] = b[c];
    return a;
}
var $778cb9e25548f7d6$var$$e = $778cb9e25548f7d6$var$Ze("animationend"), $778cb9e25548f7d6$var$af = $778cb9e25548f7d6$var$Ze("animationiteration"), $778cb9e25548f7d6$var$bf = $778cb9e25548f7d6$var$Ze("animationstart"), $778cb9e25548f7d6$var$cf = $778cb9e25548f7d6$var$Ze("transitionend"), $778cb9e25548f7d6$var$df = new Map, $778cb9e25548f7d6$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $778cb9e25548f7d6$var$ff(a, b) {
    $778cb9e25548f7d6$var$df.set(a, b);
    $778cb9e25548f7d6$var$fa(b, [
        a
    ]);
}
for(var $778cb9e25548f7d6$var$gf = 0; $778cb9e25548f7d6$var$gf < $778cb9e25548f7d6$var$ef.length; $778cb9e25548f7d6$var$gf++){
    var $778cb9e25548f7d6$var$hf = $778cb9e25548f7d6$var$ef[$778cb9e25548f7d6$var$gf], $778cb9e25548f7d6$var$jf = $778cb9e25548f7d6$var$hf.toLowerCase(), $778cb9e25548f7d6$var$kf = $778cb9e25548f7d6$var$hf[0].toUpperCase() + $778cb9e25548f7d6$var$hf.slice(1);
    $778cb9e25548f7d6$var$ff($778cb9e25548f7d6$var$jf, "on" + $778cb9e25548f7d6$var$kf);
}
$778cb9e25548f7d6$var$ff($778cb9e25548f7d6$var$$e, "onAnimationEnd");
$778cb9e25548f7d6$var$ff($778cb9e25548f7d6$var$af, "onAnimationIteration");
$778cb9e25548f7d6$var$ff($778cb9e25548f7d6$var$bf, "onAnimationStart");
$778cb9e25548f7d6$var$ff("dblclick", "onDoubleClick");
$778cb9e25548f7d6$var$ff("focusin", "onFocus");
$778cb9e25548f7d6$var$ff("focusout", "onBlur");
$778cb9e25548f7d6$var$ff($778cb9e25548f7d6$var$cf, "onTransitionEnd");
$778cb9e25548f7d6$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$778cb9e25548f7d6$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$778cb9e25548f7d6$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$778cb9e25548f7d6$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$778cb9e25548f7d6$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$778cb9e25548f7d6$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$778cb9e25548f7d6$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$778cb9e25548f7d6$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$778cb9e25548f7d6$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$778cb9e25548f7d6$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $778cb9e25548f7d6$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $778cb9e25548f7d6$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($778cb9e25548f7d6$var$lf));
function $778cb9e25548f7d6$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $778cb9e25548f7d6$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $778cb9e25548f7d6$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $778cb9e25548f7d6$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $778cb9e25548f7d6$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($778cb9e25548f7d6$var$Qb) throw a = $778cb9e25548f7d6$var$Rb, $778cb9e25548f7d6$var$Qb = !1, $778cb9e25548f7d6$var$Rb = null, a;
}
function $778cb9e25548f7d6$var$D(a, b) {
    var c = b[$778cb9e25548f7d6$var$of];
    void 0 === c && (c = b[$778cb9e25548f7d6$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($778cb9e25548f7d6$var$pf(b, a, 2, !1), c.add(d));
}
function $778cb9e25548f7d6$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $778cb9e25548f7d6$var$pf(c, a, d, b);
}
var $778cb9e25548f7d6$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $778cb9e25548f7d6$var$sf(a) {
    if (!a[$778cb9e25548f7d6$var$rf]) {
        a[$778cb9e25548f7d6$var$rf] = !0;
        $778cb9e25548f7d6$var$da.forEach(function(b) {
            "selectionchange" !== b && ($778cb9e25548f7d6$var$mf.has(b) || $778cb9e25548f7d6$var$qf(b, !1, a), $778cb9e25548f7d6$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$778cb9e25548f7d6$var$rf] || (b[$778cb9e25548f7d6$var$rf] = !0, $778cb9e25548f7d6$var$qf("selectionchange", !1, b));
    }
}
function $778cb9e25548f7d6$var$pf(a, b, c, d) {
    switch($778cb9e25548f7d6$var$jd(b)){
        case 1:
            var e = $778cb9e25548f7d6$var$ed;
            break;
        case 4:
            e = $778cb9e25548f7d6$var$gd;
            break;
        default:
            e = $778cb9e25548f7d6$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$778cb9e25548f7d6$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $778cb9e25548f7d6$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $778cb9e25548f7d6$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $778cb9e25548f7d6$var$Jb(function() {
        var d = f, e = $778cb9e25548f7d6$var$xb(c), g = [];
        a: {
            var h = $778cb9e25548f7d6$var$df.get(a);
            if (void 0 !== h) {
                var k = $778cb9e25548f7d6$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $778cb9e25548f7d6$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $778cb9e25548f7d6$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $778cb9e25548f7d6$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $778cb9e25548f7d6$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $778cb9e25548f7d6$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $778cb9e25548f7d6$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $778cb9e25548f7d6$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $778cb9e25548f7d6$var$Vd;
                        break;
                    case $778cb9e25548f7d6$var$$e:
                    case $778cb9e25548f7d6$var$af:
                    case $778cb9e25548f7d6$var$bf:
                        k = $778cb9e25548f7d6$var$Hd;
                        break;
                    case $778cb9e25548f7d6$var$cf:
                        k = $778cb9e25548f7d6$var$Xd;
                        break;
                    case "scroll":
                        k = $778cb9e25548f7d6$var$vd;
                        break;
                    case "wheel":
                        k = $778cb9e25548f7d6$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $778cb9e25548f7d6$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $778cb9e25548f7d6$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $778cb9e25548f7d6$var$Kb(w, x), null != F && t.push($778cb9e25548f7d6$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $778cb9e25548f7d6$var$wb && (n = c.relatedTarget || c.fromElement) && ($778cb9e25548f7d6$var$Wc(n) || n[$778cb9e25548f7d6$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $778cb9e25548f7d6$var$Wc(n) : null, null !== n && (J = $778cb9e25548f7d6$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $778cb9e25548f7d6$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $778cb9e25548f7d6$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $778cb9e25548f7d6$var$ue(k);
                        u = null == n ? h : $778cb9e25548f7d6$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $778cb9e25548f7d6$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $778cb9e25548f7d6$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $778cb9e25548f7d6$var$vf(F))u++;
                            for(; 0 < w - u;)t = $778cb9e25548f7d6$var$vf(t), w--;
                            for(; 0 < u - w;)x = $778cb9e25548f7d6$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $778cb9e25548f7d6$var$vf(t);
                                x = $778cb9e25548f7d6$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $778cb9e25548f7d6$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $778cb9e25548f7d6$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $778cb9e25548f7d6$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $778cb9e25548f7d6$var$ve;
                else if ($778cb9e25548f7d6$var$me(h)) {
                    if ($778cb9e25548f7d6$var$we) na = $778cb9e25548f7d6$var$Fe;
                    else {
                        na = $778cb9e25548f7d6$var$De;
                        var xa = $778cb9e25548f7d6$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $778cb9e25548f7d6$var$Ee);
                if (na && (na = na(a, d))) {
                    $778cb9e25548f7d6$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $778cb9e25548f7d6$var$cb(h, "number", h.value);
            }
            xa = d ? $778cb9e25548f7d6$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($778cb9e25548f7d6$var$me(xa) || "true" === xa.contentEditable) $778cb9e25548f7d6$var$Qe = xa, $778cb9e25548f7d6$var$Re = d, $778cb9e25548f7d6$var$Se = null;
                    break;
                case "focusout":
                    $778cb9e25548f7d6$var$Se = $778cb9e25548f7d6$var$Re = $778cb9e25548f7d6$var$Qe = null;
                    break;
                case "mousedown":
                    $778cb9e25548f7d6$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $778cb9e25548f7d6$var$Te = !1;
                    $778cb9e25548f7d6$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($778cb9e25548f7d6$var$Pe) break;
                case "keydown":
                case "keyup":
                    $778cb9e25548f7d6$var$Ue(g, c, e);
            }
            var $a;
            if ($778cb9e25548f7d6$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $778cb9e25548f7d6$var$ie ? $778cb9e25548f7d6$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($778cb9e25548f7d6$var$de && "ko" !== c.locale && ($778cb9e25548f7d6$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $778cb9e25548f7d6$var$ie && ($a = $778cb9e25548f7d6$var$nd()) : ($778cb9e25548f7d6$var$kd = e, $778cb9e25548f7d6$var$ld = "value" in $778cb9e25548f7d6$var$kd ? $778cb9e25548f7d6$var$kd.value : $778cb9e25548f7d6$var$kd.textContent, $778cb9e25548f7d6$var$ie = !0)), xa = $778cb9e25548f7d6$var$oe(d, ba), 0 < xa.length && (ba = new $778cb9e25548f7d6$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $778cb9e25548f7d6$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $778cb9e25548f7d6$var$ce ? $778cb9e25548f7d6$var$je(a, c) : $778cb9e25548f7d6$var$ke(a, c)) d = $778cb9e25548f7d6$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $778cb9e25548f7d6$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $778cb9e25548f7d6$var$se(g, b);
    });
}
function $778cb9e25548f7d6$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $778cb9e25548f7d6$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $778cb9e25548f7d6$var$Kb(a, c), null != f && d.unshift($778cb9e25548f7d6$var$tf(a, f, e)), f = $778cb9e25548f7d6$var$Kb(a, b), null != f && d.push($778cb9e25548f7d6$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $778cb9e25548f7d6$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $778cb9e25548f7d6$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $778cb9e25548f7d6$var$Kb(c, f), null != k && g.unshift($778cb9e25548f7d6$var$tf(c, k, h))) : e || (k = $778cb9e25548f7d6$var$Kb(c, f), null != k && g.push($778cb9e25548f7d6$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $778cb9e25548f7d6$var$xf = /\r\n?/g, $778cb9e25548f7d6$var$yf = /\u0000|\uFFFD/g;
function $778cb9e25548f7d6$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($778cb9e25548f7d6$var$xf, "\n").replace($778cb9e25548f7d6$var$yf, "");
}
function $778cb9e25548f7d6$var$Af(a, b, c) {
    b = $778cb9e25548f7d6$var$zf(b);
    if ($778cb9e25548f7d6$var$zf(a) !== b && c) throw Error($778cb9e25548f7d6$var$p(425));
}
function $778cb9e25548f7d6$var$Bf() {}
var $778cb9e25548f7d6$var$Cf = null, $778cb9e25548f7d6$var$Df = null;
function $778cb9e25548f7d6$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $778cb9e25548f7d6$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $778cb9e25548f7d6$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $778cb9e25548f7d6$var$Hf = "function" === typeof Promise ? Promise : void 0, $778cb9e25548f7d6$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $778cb9e25548f7d6$var$Hf ? function(a) {
    return $778cb9e25548f7d6$var$Hf.resolve(null).then(a).catch($778cb9e25548f7d6$var$If);
} : $778cb9e25548f7d6$var$Ff;
function $778cb9e25548f7d6$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $778cb9e25548f7d6$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $778cb9e25548f7d6$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $778cb9e25548f7d6$var$bd(b);
}
function $778cb9e25548f7d6$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $778cb9e25548f7d6$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $778cb9e25548f7d6$var$Nf = Math.random().toString(36).slice(2), $778cb9e25548f7d6$var$Of = "__reactFiber$" + $778cb9e25548f7d6$var$Nf, $778cb9e25548f7d6$var$Pf = "__reactProps$" + $778cb9e25548f7d6$var$Nf, $778cb9e25548f7d6$var$uf = "__reactContainer$" + $778cb9e25548f7d6$var$Nf, $778cb9e25548f7d6$var$of = "__reactEvents$" + $778cb9e25548f7d6$var$Nf, $778cb9e25548f7d6$var$Qf = "__reactListeners$" + $778cb9e25548f7d6$var$Nf, $778cb9e25548f7d6$var$Rf = "__reactHandles$" + $778cb9e25548f7d6$var$Nf;
function $778cb9e25548f7d6$var$Wc(a) {
    var b = a[$778cb9e25548f7d6$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$778cb9e25548f7d6$var$uf] || c[$778cb9e25548f7d6$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $778cb9e25548f7d6$var$Mf(a); null !== a;){
                if (c = a[$778cb9e25548f7d6$var$Of]) return c;
                a = $778cb9e25548f7d6$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $778cb9e25548f7d6$var$Cb(a) {
    a = a[$778cb9e25548f7d6$var$Of] || a[$778cb9e25548f7d6$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $778cb9e25548f7d6$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($778cb9e25548f7d6$var$p(33));
}
function $778cb9e25548f7d6$var$Db(a) {
    return a[$778cb9e25548f7d6$var$Pf] || null;
}
var $778cb9e25548f7d6$var$Sf = [], $778cb9e25548f7d6$var$Tf = -1;
function $778cb9e25548f7d6$var$Uf(a) {
    return {
        current: a
    };
}
function $778cb9e25548f7d6$var$E(a) {
    0 > $778cb9e25548f7d6$var$Tf || (a.current = $778cb9e25548f7d6$var$Sf[$778cb9e25548f7d6$var$Tf], $778cb9e25548f7d6$var$Sf[$778cb9e25548f7d6$var$Tf] = null, $778cb9e25548f7d6$var$Tf--);
}
function $778cb9e25548f7d6$var$G(a, b) {
    $778cb9e25548f7d6$var$Tf++;
    $778cb9e25548f7d6$var$Sf[$778cb9e25548f7d6$var$Tf] = a.current;
    a.current = b;
}
var $778cb9e25548f7d6$var$Vf = {}, $778cb9e25548f7d6$var$H = $778cb9e25548f7d6$var$Uf($778cb9e25548f7d6$var$Vf), $778cb9e25548f7d6$var$Wf = $778cb9e25548f7d6$var$Uf(!1), $778cb9e25548f7d6$var$Xf = $778cb9e25548f7d6$var$Vf;
function $778cb9e25548f7d6$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $778cb9e25548f7d6$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $778cb9e25548f7d6$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $778cb9e25548f7d6$var$$f() {
    $778cb9e25548f7d6$var$E($778cb9e25548f7d6$var$Wf);
    $778cb9e25548f7d6$var$E($778cb9e25548f7d6$var$H);
}
function $778cb9e25548f7d6$var$ag(a, b, c) {
    if ($778cb9e25548f7d6$var$H.current !== $778cb9e25548f7d6$var$Vf) throw Error($778cb9e25548f7d6$var$p(168));
    $778cb9e25548f7d6$var$G($778cb9e25548f7d6$var$H, b);
    $778cb9e25548f7d6$var$G($778cb9e25548f7d6$var$Wf, c);
}
function $778cb9e25548f7d6$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($778cb9e25548f7d6$var$p(108, $778cb9e25548f7d6$var$Ra(a) || "Unknown", e));
    return $778cb9e25548f7d6$var$A({}, c, d);
}
function $778cb9e25548f7d6$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $778cb9e25548f7d6$var$Vf;
    $778cb9e25548f7d6$var$Xf = $778cb9e25548f7d6$var$H.current;
    $778cb9e25548f7d6$var$G($778cb9e25548f7d6$var$H, a);
    $778cb9e25548f7d6$var$G($778cb9e25548f7d6$var$Wf, $778cb9e25548f7d6$var$Wf.current);
    return !0;
}
function $778cb9e25548f7d6$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($778cb9e25548f7d6$var$p(169));
    c ? (a = $778cb9e25548f7d6$var$bg(a, b, $778cb9e25548f7d6$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $778cb9e25548f7d6$var$E($778cb9e25548f7d6$var$Wf), $778cb9e25548f7d6$var$E($778cb9e25548f7d6$var$H), $778cb9e25548f7d6$var$G($778cb9e25548f7d6$var$H, a)) : $778cb9e25548f7d6$var$E($778cb9e25548f7d6$var$Wf);
    $778cb9e25548f7d6$var$G($778cb9e25548f7d6$var$Wf, c);
}
var $778cb9e25548f7d6$var$eg = null, $778cb9e25548f7d6$var$fg = !1, $778cb9e25548f7d6$var$gg = !1;
function $778cb9e25548f7d6$var$hg(a) {
    null === $778cb9e25548f7d6$var$eg ? $778cb9e25548f7d6$var$eg = [
        a
    ] : $778cb9e25548f7d6$var$eg.push(a);
}
function $778cb9e25548f7d6$var$ig(a) {
    $778cb9e25548f7d6$var$fg = !0;
    $778cb9e25548f7d6$var$hg(a);
}
function $778cb9e25548f7d6$var$jg() {
    if (!$778cb9e25548f7d6$var$gg && null !== $778cb9e25548f7d6$var$eg) {
        $778cb9e25548f7d6$var$gg = !0;
        var a = 0, b = $778cb9e25548f7d6$var$C;
        try {
            var c = $778cb9e25548f7d6$var$eg;
            for($778cb9e25548f7d6$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $778cb9e25548f7d6$var$eg = null;
            $778cb9e25548f7d6$var$fg = !1;
        } catch (e) {
            throw null !== $778cb9e25548f7d6$var$eg && ($778cb9e25548f7d6$var$eg = $778cb9e25548f7d6$var$eg.slice(a + 1)), $778cb9e25548f7d6$var$ac($778cb9e25548f7d6$var$fc, $778cb9e25548f7d6$var$jg), e;
        } finally{
            $778cb9e25548f7d6$var$C = b, $778cb9e25548f7d6$var$gg = !1;
        }
    }
    return null;
}
var $778cb9e25548f7d6$var$kg = [], $778cb9e25548f7d6$var$lg = 0, $778cb9e25548f7d6$var$mg = null, $778cb9e25548f7d6$var$ng = 0, $778cb9e25548f7d6$var$og = [], $778cb9e25548f7d6$var$pg = 0, $778cb9e25548f7d6$var$qg = null, $778cb9e25548f7d6$var$rg = 1, $778cb9e25548f7d6$var$sg = "";
function $778cb9e25548f7d6$var$tg(a, b) {
    $778cb9e25548f7d6$var$kg[$778cb9e25548f7d6$var$lg++] = $778cb9e25548f7d6$var$ng;
    $778cb9e25548f7d6$var$kg[$778cb9e25548f7d6$var$lg++] = $778cb9e25548f7d6$var$mg;
    $778cb9e25548f7d6$var$mg = a;
    $778cb9e25548f7d6$var$ng = b;
}
function $778cb9e25548f7d6$var$ug(a, b, c) {
    $778cb9e25548f7d6$var$og[$778cb9e25548f7d6$var$pg++] = $778cb9e25548f7d6$var$rg;
    $778cb9e25548f7d6$var$og[$778cb9e25548f7d6$var$pg++] = $778cb9e25548f7d6$var$sg;
    $778cb9e25548f7d6$var$og[$778cb9e25548f7d6$var$pg++] = $778cb9e25548f7d6$var$qg;
    $778cb9e25548f7d6$var$qg = a;
    var d = $778cb9e25548f7d6$var$rg;
    a = $778cb9e25548f7d6$var$sg;
    var e = 32 - $778cb9e25548f7d6$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $778cb9e25548f7d6$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $778cb9e25548f7d6$var$rg = 1 << 32 - $778cb9e25548f7d6$var$oc(b) + e | c << e | d;
        $778cb9e25548f7d6$var$sg = f + a;
    } else $778cb9e25548f7d6$var$rg = 1 << f | c << e | d, $778cb9e25548f7d6$var$sg = a;
}
function $778cb9e25548f7d6$var$vg(a) {
    null !== a.return && ($778cb9e25548f7d6$var$tg(a, 1), $778cb9e25548f7d6$var$ug(a, 1, 0));
}
function $778cb9e25548f7d6$var$wg(a) {
    for(; a === $778cb9e25548f7d6$var$mg;)$778cb9e25548f7d6$var$mg = $778cb9e25548f7d6$var$kg[--$778cb9e25548f7d6$var$lg], $778cb9e25548f7d6$var$kg[$778cb9e25548f7d6$var$lg] = null, $778cb9e25548f7d6$var$ng = $778cb9e25548f7d6$var$kg[--$778cb9e25548f7d6$var$lg], $778cb9e25548f7d6$var$kg[$778cb9e25548f7d6$var$lg] = null;
    for(; a === $778cb9e25548f7d6$var$qg;)$778cb9e25548f7d6$var$qg = $778cb9e25548f7d6$var$og[--$778cb9e25548f7d6$var$pg], $778cb9e25548f7d6$var$og[$778cb9e25548f7d6$var$pg] = null, $778cb9e25548f7d6$var$sg = $778cb9e25548f7d6$var$og[--$778cb9e25548f7d6$var$pg], $778cb9e25548f7d6$var$og[$778cb9e25548f7d6$var$pg] = null, $778cb9e25548f7d6$var$rg = $778cb9e25548f7d6$var$og[--$778cb9e25548f7d6$var$pg], $778cb9e25548f7d6$var$og[$778cb9e25548f7d6$var$pg] = null;
}
var $778cb9e25548f7d6$var$xg = null, $778cb9e25548f7d6$var$yg = null, $778cb9e25548f7d6$var$I = !1, $778cb9e25548f7d6$var$zg = null;
function $778cb9e25548f7d6$var$Ag(a, b) {
    var c = $778cb9e25548f7d6$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $778cb9e25548f7d6$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $778cb9e25548f7d6$var$xg = a, $778cb9e25548f7d6$var$yg = $778cb9e25548f7d6$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $778cb9e25548f7d6$var$xg = a, $778cb9e25548f7d6$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $778cb9e25548f7d6$var$qg ? {
                id: $778cb9e25548f7d6$var$rg,
                overflow: $778cb9e25548f7d6$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $778cb9e25548f7d6$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $778cb9e25548f7d6$var$xg = a, $778cb9e25548f7d6$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $778cb9e25548f7d6$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $778cb9e25548f7d6$var$Eg(a) {
    if ($778cb9e25548f7d6$var$I) {
        var b = $778cb9e25548f7d6$var$yg;
        if (b) {
            var c = b;
            if (!$778cb9e25548f7d6$var$Cg(a, b)) {
                if ($778cb9e25548f7d6$var$Dg(a)) throw Error($778cb9e25548f7d6$var$p(418));
                b = $778cb9e25548f7d6$var$Lf(c.nextSibling);
                var d = $778cb9e25548f7d6$var$xg;
                b && $778cb9e25548f7d6$var$Cg(a, b) ? $778cb9e25548f7d6$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $778cb9e25548f7d6$var$I = !1, $778cb9e25548f7d6$var$xg = a);
            }
        } else {
            if ($778cb9e25548f7d6$var$Dg(a)) throw Error($778cb9e25548f7d6$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $778cb9e25548f7d6$var$I = !1;
            $778cb9e25548f7d6$var$xg = a;
        }
    }
}
function $778cb9e25548f7d6$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $778cb9e25548f7d6$var$xg = a;
}
function $778cb9e25548f7d6$var$Gg(a) {
    if (a !== $778cb9e25548f7d6$var$xg) return !1;
    if (!$778cb9e25548f7d6$var$I) return $778cb9e25548f7d6$var$Fg(a), $778cb9e25548f7d6$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$778cb9e25548f7d6$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $778cb9e25548f7d6$var$yg)) {
        if ($778cb9e25548f7d6$var$Dg(a)) throw $778cb9e25548f7d6$var$Hg(), Error($778cb9e25548f7d6$var$p(418));
        for(; b;)$778cb9e25548f7d6$var$Ag(a, b), b = $778cb9e25548f7d6$var$Lf(b.nextSibling);
    }
    $778cb9e25548f7d6$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($778cb9e25548f7d6$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $778cb9e25548f7d6$var$yg = $778cb9e25548f7d6$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $778cb9e25548f7d6$var$yg = null;
        }
    } else $778cb9e25548f7d6$var$yg = $778cb9e25548f7d6$var$xg ? $778cb9e25548f7d6$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $778cb9e25548f7d6$var$Hg() {
    for(var a = $778cb9e25548f7d6$var$yg; a;)a = $778cb9e25548f7d6$var$Lf(a.nextSibling);
}
function $778cb9e25548f7d6$var$Ig() {
    $778cb9e25548f7d6$var$yg = $778cb9e25548f7d6$var$xg = null;
    $778cb9e25548f7d6$var$I = !1;
}
function $778cb9e25548f7d6$var$Jg(a) {
    null === $778cb9e25548f7d6$var$zg ? $778cb9e25548f7d6$var$zg = [
        a
    ] : $778cb9e25548f7d6$var$zg.push(a);
}
var $778cb9e25548f7d6$var$Kg = $778cb9e25548f7d6$var$ua.ReactCurrentBatchConfig;
function $778cb9e25548f7d6$var$Lg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($778cb9e25548f7d6$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($778cb9e25548f7d6$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($778cb9e25548f7d6$var$p(284));
        if (!c._owner) throw Error($778cb9e25548f7d6$var$p(290, a));
    }
    return a;
}
function $778cb9e25548f7d6$var$Mg(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($778cb9e25548f7d6$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $778cb9e25548f7d6$var$Ng(a) {
    var b = a._init;
    return b(a._payload);
}
function $778cb9e25548f7d6$var$Og(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $778cb9e25548f7d6$var$Pg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $778cb9e25548f7d6$var$Qg(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $778cb9e25548f7d6$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $778cb9e25548f7d6$var$Ha && $778cb9e25548f7d6$var$Ng(f) === b.type)) return d = e(b, c.props), d.ref = $778cb9e25548f7d6$var$Lg(a, b, c), d.return = a, d;
        d = $778cb9e25548f7d6$var$Rg(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $778cb9e25548f7d6$var$Lg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $778cb9e25548f7d6$var$Sg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $778cb9e25548f7d6$var$Tg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $778cb9e25548f7d6$var$Qg("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $778cb9e25548f7d6$var$va:
                    return c = $778cb9e25548f7d6$var$Rg(b.type, b.key, b.props, null, a.mode, c), c.ref = $778cb9e25548f7d6$var$Lg(a, null, b), c.return = a, c;
                case $778cb9e25548f7d6$var$wa:
                    return b = $778cb9e25548f7d6$var$Sg(b, a.mode, c), b.return = a, b;
                case $778cb9e25548f7d6$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($778cb9e25548f7d6$var$eb(b) || $778cb9e25548f7d6$var$Ka(b)) return b = $778cb9e25548f7d6$var$Tg(b, a.mode, c, null), b.return = a, b;
            $778cb9e25548f7d6$var$Mg(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $778cb9e25548f7d6$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $778cb9e25548f7d6$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $778cb9e25548f7d6$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($778cb9e25548f7d6$var$eb(c) || $778cb9e25548f7d6$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $778cb9e25548f7d6$var$Mg(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $778cb9e25548f7d6$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $778cb9e25548f7d6$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $778cb9e25548f7d6$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($778cb9e25548f7d6$var$eb(d) || $778cb9e25548f7d6$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $778cb9e25548f7d6$var$Mg(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $778cb9e25548f7d6$var$I && $778cb9e25548f7d6$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $778cb9e25548f7d6$var$I && $778cb9e25548f7d6$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $778cb9e25548f7d6$var$I && $778cb9e25548f7d6$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $778cb9e25548f7d6$var$Ka(h);
        if ("function" !== typeof l) throw Error($778cb9e25548f7d6$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($778cb9e25548f7d6$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $778cb9e25548f7d6$var$I && $778cb9e25548f7d6$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $778cb9e25548f7d6$var$I && $778cb9e25548f7d6$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $778cb9e25548f7d6$var$I && $778cb9e25548f7d6$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $778cb9e25548f7d6$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $778cb9e25548f7d6$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $778cb9e25548f7d6$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $778cb9e25548f7d6$var$Ha && $778cb9e25548f7d6$var$Ng(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $778cb9e25548f7d6$var$Lg(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $778cb9e25548f7d6$var$ya ? (d = $778cb9e25548f7d6$var$Tg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $778cb9e25548f7d6$var$Rg(f.type, f.key, f.props, null, a.mode, h), h.ref = $778cb9e25548f7d6$var$Lg(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $778cb9e25548f7d6$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $778cb9e25548f7d6$var$Sg(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $778cb9e25548f7d6$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($778cb9e25548f7d6$var$eb(f)) return n(a, d, f, h);
            if ($778cb9e25548f7d6$var$Ka(f)) return t(a, d, f, h);
            $778cb9e25548f7d6$var$Mg(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $778cb9e25548f7d6$var$Qg(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $778cb9e25548f7d6$var$Ug = $778cb9e25548f7d6$var$Og(!0), $778cb9e25548f7d6$var$Vg = $778cb9e25548f7d6$var$Og(!1), $778cb9e25548f7d6$var$Wg = $778cb9e25548f7d6$var$Uf(null), $778cb9e25548f7d6$var$Xg = null, $778cb9e25548f7d6$var$Yg = null, $778cb9e25548f7d6$var$Zg = null;
function $778cb9e25548f7d6$var$$g() {
    $778cb9e25548f7d6$var$Zg = $778cb9e25548f7d6$var$Yg = $778cb9e25548f7d6$var$Xg = null;
}
function $778cb9e25548f7d6$var$ah(a) {
    var b = $778cb9e25548f7d6$var$Wg.current;
    $778cb9e25548f7d6$var$E($778cb9e25548f7d6$var$Wg);
    a._currentValue = b;
}
function $778cb9e25548f7d6$var$bh(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $778cb9e25548f7d6$var$ch(a, b) {
    $778cb9e25548f7d6$var$Xg = a;
    $778cb9e25548f7d6$var$Zg = $778cb9e25548f7d6$var$Yg = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($778cb9e25548f7d6$var$dh = !0), a.firstContext = null);
}
function $778cb9e25548f7d6$var$eh(a) {
    var b = a._currentValue;
    if ($778cb9e25548f7d6$var$Zg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $778cb9e25548f7d6$var$Yg) {
            if (null === $778cb9e25548f7d6$var$Xg) throw Error($778cb9e25548f7d6$var$p(308));
            $778cb9e25548f7d6$var$Yg = a;
            $778cb9e25548f7d6$var$Xg.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $778cb9e25548f7d6$var$Yg = $778cb9e25548f7d6$var$Yg.next = a;
    }
    return b;
}
var $778cb9e25548f7d6$var$fh = null;
function $778cb9e25548f7d6$var$gh(a) {
    null === $778cb9e25548f7d6$var$fh ? $778cb9e25548f7d6$var$fh = [
        a
    ] : $778cb9e25548f7d6$var$fh.push(a);
}
function $778cb9e25548f7d6$var$hh(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $778cb9e25548f7d6$var$gh(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $778cb9e25548f7d6$var$ih(a, d);
}
function $778cb9e25548f7d6$var$ih(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $778cb9e25548f7d6$var$jh = !1;
function $778cb9e25548f7d6$var$kh(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $778cb9e25548f7d6$var$lh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $778cb9e25548f7d6$var$mh(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $778cb9e25548f7d6$var$nh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($778cb9e25548f7d6$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $778cb9e25548f7d6$var$ih(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $778cb9e25548f7d6$var$gh(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $778cb9e25548f7d6$var$ih(a, c);
}
function $778cb9e25548f7d6$var$oh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $778cb9e25548f7d6$var$Cc(a, c);
    }
}
function $778cb9e25548f7d6$var$ph(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $778cb9e25548f7d6$var$qh(a, b, c, d) {
    var e = a.updateQueue;
    $778cb9e25548f7d6$var$jh = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $778cb9e25548f7d6$var$A({}, q, r);
                            break a;
                        case 2:
                            $778cb9e25548f7d6$var$jh = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $778cb9e25548f7d6$var$rh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $778cb9e25548f7d6$var$sh(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($778cb9e25548f7d6$var$p(191, e));
            e.call(d);
        }
    }
}
var $778cb9e25548f7d6$var$th = {}, $778cb9e25548f7d6$var$uh = $778cb9e25548f7d6$var$Uf($778cb9e25548f7d6$var$th), $778cb9e25548f7d6$var$vh = $778cb9e25548f7d6$var$Uf($778cb9e25548f7d6$var$th), $778cb9e25548f7d6$var$wh = $778cb9e25548f7d6$var$Uf($778cb9e25548f7d6$var$th);
function $778cb9e25548f7d6$var$xh(a) {
    if (a === $778cb9e25548f7d6$var$th) throw Error($778cb9e25548f7d6$var$p(174));
    return a;
}
function $778cb9e25548f7d6$var$yh(a, b) {
    $778cb9e25548f7d6$var$G($778cb9e25548f7d6$var$wh, b);
    $778cb9e25548f7d6$var$G($778cb9e25548f7d6$var$vh, a);
    $778cb9e25548f7d6$var$G($778cb9e25548f7d6$var$uh, $778cb9e25548f7d6$var$th);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $778cb9e25548f7d6$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $778cb9e25548f7d6$var$lb(b, a);
    }
    $778cb9e25548f7d6$var$E($778cb9e25548f7d6$var$uh);
    $778cb9e25548f7d6$var$G($778cb9e25548f7d6$var$uh, b);
}
function $778cb9e25548f7d6$var$zh() {
    $778cb9e25548f7d6$var$E($778cb9e25548f7d6$var$uh);
    $778cb9e25548f7d6$var$E($778cb9e25548f7d6$var$vh);
    $778cb9e25548f7d6$var$E($778cb9e25548f7d6$var$wh);
}
function $778cb9e25548f7d6$var$Ah(a) {
    $778cb9e25548f7d6$var$xh($778cb9e25548f7d6$var$wh.current);
    var b = $778cb9e25548f7d6$var$xh($778cb9e25548f7d6$var$uh.current);
    var c = $778cb9e25548f7d6$var$lb(b, a.type);
    b !== c && ($778cb9e25548f7d6$var$G($778cb9e25548f7d6$var$vh, a), $778cb9e25548f7d6$var$G($778cb9e25548f7d6$var$uh, c));
}
function $778cb9e25548f7d6$var$Bh(a) {
    $778cb9e25548f7d6$var$vh.current === a && ($778cb9e25548f7d6$var$E($778cb9e25548f7d6$var$uh), $778cb9e25548f7d6$var$E($778cb9e25548f7d6$var$vh));
}
var $778cb9e25548f7d6$var$L = $778cb9e25548f7d6$var$Uf(0);
function $778cb9e25548f7d6$var$Ch(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $778cb9e25548f7d6$var$Dh = [];
function $778cb9e25548f7d6$var$Eh() {
    for(var a = 0; a < $778cb9e25548f7d6$var$Dh.length; a++)$778cb9e25548f7d6$var$Dh[a]._workInProgressVersionPrimary = null;
    $778cb9e25548f7d6$var$Dh.length = 0;
}
var $778cb9e25548f7d6$var$Fh = $778cb9e25548f7d6$var$ua.ReactCurrentDispatcher, $778cb9e25548f7d6$var$Gh = $778cb9e25548f7d6$var$ua.ReactCurrentBatchConfig, $778cb9e25548f7d6$var$Hh = 0, $778cb9e25548f7d6$var$M = null, $778cb9e25548f7d6$var$N = null, $778cb9e25548f7d6$var$O = null, $778cb9e25548f7d6$var$Ih = !1, $778cb9e25548f7d6$var$Jh = !1, $778cb9e25548f7d6$var$Kh = 0, $778cb9e25548f7d6$var$Lh = 0;
function $778cb9e25548f7d6$var$P() {
    throw Error($778cb9e25548f7d6$var$p(321));
}
function $778cb9e25548f7d6$var$Mh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$778cb9e25548f7d6$var$He(a[c], b[c])) return !1;
    return !0;
}
function $778cb9e25548f7d6$var$Nh(a, b, c, d, e, f) {
    $778cb9e25548f7d6$var$Hh = f;
    $778cb9e25548f7d6$var$M = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $778cb9e25548f7d6$var$Fh.current = null === a || null === a.memoizedState ? $778cb9e25548f7d6$var$Oh : $778cb9e25548f7d6$var$Ph;
    a = c(d, e);
    if ($778cb9e25548f7d6$var$Jh) {
        f = 0;
        do {
            $778cb9e25548f7d6$var$Jh = !1;
            $778cb9e25548f7d6$var$Kh = 0;
            if (25 <= f) throw Error($778cb9e25548f7d6$var$p(301));
            f += 1;
            $778cb9e25548f7d6$var$O = $778cb9e25548f7d6$var$N = null;
            b.updateQueue = null;
            $778cb9e25548f7d6$var$Fh.current = $778cb9e25548f7d6$var$Qh;
            a = c(d, e);
        }while ($778cb9e25548f7d6$var$Jh);
    }
    $778cb9e25548f7d6$var$Fh.current = $778cb9e25548f7d6$var$Rh;
    b = null !== $778cb9e25548f7d6$var$N && null !== $778cb9e25548f7d6$var$N.next;
    $778cb9e25548f7d6$var$Hh = 0;
    $778cb9e25548f7d6$var$O = $778cb9e25548f7d6$var$N = $778cb9e25548f7d6$var$M = null;
    $778cb9e25548f7d6$var$Ih = !1;
    if (b) throw Error($778cb9e25548f7d6$var$p(300));
    return a;
}
function $778cb9e25548f7d6$var$Sh() {
    var a = 0 !== $778cb9e25548f7d6$var$Kh;
    $778cb9e25548f7d6$var$Kh = 0;
    return a;
}
function $778cb9e25548f7d6$var$Th() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $778cb9e25548f7d6$var$O ? $778cb9e25548f7d6$var$M.memoizedState = $778cb9e25548f7d6$var$O = a : $778cb9e25548f7d6$var$O = $778cb9e25548f7d6$var$O.next = a;
    return $778cb9e25548f7d6$var$O;
}
function $778cb9e25548f7d6$var$Uh() {
    if (null === $778cb9e25548f7d6$var$N) {
        var a = $778cb9e25548f7d6$var$M.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $778cb9e25548f7d6$var$N.next;
    var b = null === $778cb9e25548f7d6$var$O ? $778cb9e25548f7d6$var$M.memoizedState : $778cb9e25548f7d6$var$O.next;
    if (null !== b) $778cb9e25548f7d6$var$O = b, $778cb9e25548f7d6$var$N = a;
    else {
        if (null === a) throw Error($778cb9e25548f7d6$var$p(310));
        $778cb9e25548f7d6$var$N = a;
        a = {
            memoizedState: $778cb9e25548f7d6$var$N.memoizedState,
            baseState: $778cb9e25548f7d6$var$N.baseState,
            baseQueue: $778cb9e25548f7d6$var$N.baseQueue,
            queue: $778cb9e25548f7d6$var$N.queue,
            next: null
        };
        null === $778cb9e25548f7d6$var$O ? $778cb9e25548f7d6$var$M.memoizedState = $778cb9e25548f7d6$var$O = a : $778cb9e25548f7d6$var$O = $778cb9e25548f7d6$var$O.next = a;
    }
    return $778cb9e25548f7d6$var$O;
}
function $778cb9e25548f7d6$var$Vh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $778cb9e25548f7d6$var$Wh(a) {
    var b = $778cb9e25548f7d6$var$Uh(), c = b.queue;
    if (null === c) throw Error($778cb9e25548f7d6$var$p(311));
    c.lastRenderedReducer = a;
    var d = $778cb9e25548f7d6$var$N, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($778cb9e25548f7d6$var$Hh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $778cb9e25548f7d6$var$M.lanes |= m;
                $778cb9e25548f7d6$var$rh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $778cb9e25548f7d6$var$He(d, b.memoizedState) || ($778cb9e25548f7d6$var$dh = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $778cb9e25548f7d6$var$M.lanes |= f, $778cb9e25548f7d6$var$rh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $778cb9e25548f7d6$var$Xh(a) {
    var b = $778cb9e25548f7d6$var$Uh(), c = b.queue;
    if (null === c) throw Error($778cb9e25548f7d6$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $778cb9e25548f7d6$var$He(f, b.memoizedState) || ($778cb9e25548f7d6$var$dh = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $778cb9e25548f7d6$var$Yh() {}
function $778cb9e25548f7d6$var$Zh(a, b) {
    var c = $778cb9e25548f7d6$var$M, d = $778cb9e25548f7d6$var$Uh(), e = b(), f = !$778cb9e25548f7d6$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $778cb9e25548f7d6$var$dh = !0);
    d = d.queue;
    $778cb9e25548f7d6$var$$h($778cb9e25548f7d6$var$ai.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $778cb9e25548f7d6$var$O && $778cb9e25548f7d6$var$O.memoizedState.tag & 1) {
        c.flags |= 2048;
        $778cb9e25548f7d6$var$bi(9, $778cb9e25548f7d6$var$ci.bind(null, c, d, e, b), void 0, null);
        if (null === $778cb9e25548f7d6$var$Q) throw Error($778cb9e25548f7d6$var$p(349));
        0 !== ($778cb9e25548f7d6$var$Hh & 30) || $778cb9e25548f7d6$var$di(c, b, e);
    }
    return e;
}
function $778cb9e25548f7d6$var$di(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $778cb9e25548f7d6$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $778cb9e25548f7d6$var$M.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $778cb9e25548f7d6$var$ci(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $778cb9e25548f7d6$var$ei(b) && $778cb9e25548f7d6$var$fi(a);
}
function $778cb9e25548f7d6$var$ai(a, b, c) {
    return c(function() {
        $778cb9e25548f7d6$var$ei(b) && $778cb9e25548f7d6$var$fi(a);
    });
}
function $778cb9e25548f7d6$var$ei(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$778cb9e25548f7d6$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $778cb9e25548f7d6$var$fi(a) {
    var b = $778cb9e25548f7d6$var$ih(a, 1);
    null !== b && $778cb9e25548f7d6$var$gi(b, a, 1, -1);
}
function $778cb9e25548f7d6$var$hi(a) {
    var b = $778cb9e25548f7d6$var$Th();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $778cb9e25548f7d6$var$Vh,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $778cb9e25548f7d6$var$ii.bind(null, $778cb9e25548f7d6$var$M, a);
    return [
        b.memoizedState,
        a
    ];
}
function $778cb9e25548f7d6$var$bi(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $778cb9e25548f7d6$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $778cb9e25548f7d6$var$M.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $778cb9e25548f7d6$var$ji() {
    return $778cb9e25548f7d6$var$Uh().memoizedState;
}
function $778cb9e25548f7d6$var$ki(a, b, c, d) {
    var e = $778cb9e25548f7d6$var$Th();
    $778cb9e25548f7d6$var$M.flags |= a;
    e.memoizedState = $778cb9e25548f7d6$var$bi(1 | b, c, void 0, void 0 === d ? null : d);
}
function $778cb9e25548f7d6$var$li(a, b, c, d) {
    var e = $778cb9e25548f7d6$var$Uh();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $778cb9e25548f7d6$var$N) {
        var g = $778cb9e25548f7d6$var$N.memoizedState;
        f = g.destroy;
        if (null !== d && $778cb9e25548f7d6$var$Mh(d, g.deps)) {
            e.memoizedState = $778cb9e25548f7d6$var$bi(b, c, f, d);
            return;
        }
    }
    $778cb9e25548f7d6$var$M.flags |= a;
    e.memoizedState = $778cb9e25548f7d6$var$bi(1 | b, c, f, d);
}
function $778cb9e25548f7d6$var$mi(a, b) {
    return $778cb9e25548f7d6$var$ki(8390656, 8, a, b);
}
function $778cb9e25548f7d6$var$$h(a, b) {
    return $778cb9e25548f7d6$var$li(2048, 8, a, b);
}
function $778cb9e25548f7d6$var$ni(a, b) {
    return $778cb9e25548f7d6$var$li(4, 2, a, b);
}
function $778cb9e25548f7d6$var$oi(a, b) {
    return $778cb9e25548f7d6$var$li(4, 4, a, b);
}
function $778cb9e25548f7d6$var$pi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $778cb9e25548f7d6$var$qi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $778cb9e25548f7d6$var$li(4, 4, $778cb9e25548f7d6$var$pi.bind(null, b, a), c);
}
function $778cb9e25548f7d6$var$ri() {}
function $778cb9e25548f7d6$var$si(a, b) {
    var c = $778cb9e25548f7d6$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $778cb9e25548f7d6$var$Mh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $778cb9e25548f7d6$var$ti(a, b) {
    var c = $778cb9e25548f7d6$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $778cb9e25548f7d6$var$Mh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $778cb9e25548f7d6$var$ui(a, b, c) {
    if (0 === ($778cb9e25548f7d6$var$Hh & 21)) return a.baseState && (a.baseState = !1, $778cb9e25548f7d6$var$dh = !0), a.memoizedState = c;
    $778cb9e25548f7d6$var$He(c, b) || (c = $778cb9e25548f7d6$var$yc(), $778cb9e25548f7d6$var$M.lanes |= c, $778cb9e25548f7d6$var$rh |= c, a.baseState = !0);
    return b;
}
function $778cb9e25548f7d6$var$vi(a, b) {
    var c = $778cb9e25548f7d6$var$C;
    $778cb9e25548f7d6$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $778cb9e25548f7d6$var$Gh.transition;
    $778cb9e25548f7d6$var$Gh.transition = {};
    try {
        a(!1), b();
    } finally{
        $778cb9e25548f7d6$var$C = c, $778cb9e25548f7d6$var$Gh.transition = d;
    }
}
function $778cb9e25548f7d6$var$wi() {
    return $778cb9e25548f7d6$var$Uh().memoizedState;
}
function $778cb9e25548f7d6$var$xi(a, b, c) {
    var d = $778cb9e25548f7d6$var$yi(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($778cb9e25548f7d6$var$zi(a)) $778cb9e25548f7d6$var$Ai(b, c);
    else if (c = $778cb9e25548f7d6$var$hh(a, b, c, d), null !== c) {
        var e = $778cb9e25548f7d6$var$R();
        $778cb9e25548f7d6$var$gi(c, a, d, e);
        $778cb9e25548f7d6$var$Bi(c, b, d);
    }
}
function $778cb9e25548f7d6$var$ii(a, b, c) {
    var d = $778cb9e25548f7d6$var$yi(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($778cb9e25548f7d6$var$zi(a)) $778cb9e25548f7d6$var$Ai(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($778cb9e25548f7d6$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $778cb9e25548f7d6$var$gh(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $778cb9e25548f7d6$var$hh(a, b, e, d);
        null !== c && (e = $778cb9e25548f7d6$var$R(), $778cb9e25548f7d6$var$gi(c, a, d, e), $778cb9e25548f7d6$var$Bi(c, b, d));
    }
}
function $778cb9e25548f7d6$var$zi(a) {
    var b = a.alternate;
    return a === $778cb9e25548f7d6$var$M || null !== b && b === $778cb9e25548f7d6$var$M;
}
function $778cb9e25548f7d6$var$Ai(a, b) {
    $778cb9e25548f7d6$var$Jh = $778cb9e25548f7d6$var$Ih = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $778cb9e25548f7d6$var$Bi(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $778cb9e25548f7d6$var$Cc(a, c);
    }
}
var $778cb9e25548f7d6$var$Rh = {
    readContext: $778cb9e25548f7d6$var$eh,
    useCallback: $778cb9e25548f7d6$var$P,
    useContext: $778cb9e25548f7d6$var$P,
    useEffect: $778cb9e25548f7d6$var$P,
    useImperativeHandle: $778cb9e25548f7d6$var$P,
    useInsertionEffect: $778cb9e25548f7d6$var$P,
    useLayoutEffect: $778cb9e25548f7d6$var$P,
    useMemo: $778cb9e25548f7d6$var$P,
    useReducer: $778cb9e25548f7d6$var$P,
    useRef: $778cb9e25548f7d6$var$P,
    useState: $778cb9e25548f7d6$var$P,
    useDebugValue: $778cb9e25548f7d6$var$P,
    useDeferredValue: $778cb9e25548f7d6$var$P,
    useTransition: $778cb9e25548f7d6$var$P,
    useMutableSource: $778cb9e25548f7d6$var$P,
    useSyncExternalStore: $778cb9e25548f7d6$var$P,
    useId: $778cb9e25548f7d6$var$P,
    unstable_isNewReconciler: !1
}, $778cb9e25548f7d6$var$Oh = {
    readContext: $778cb9e25548f7d6$var$eh,
    useCallback: function(a, b) {
        $778cb9e25548f7d6$var$Th().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $778cb9e25548f7d6$var$eh,
    useEffect: $778cb9e25548f7d6$var$mi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $778cb9e25548f7d6$var$ki(4194308, 4, $778cb9e25548f7d6$var$pi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $778cb9e25548f7d6$var$ki(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $778cb9e25548f7d6$var$ki(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $778cb9e25548f7d6$var$Th();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $778cb9e25548f7d6$var$Th();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $778cb9e25548f7d6$var$xi.bind(null, $778cb9e25548f7d6$var$M, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $778cb9e25548f7d6$var$Th();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $778cb9e25548f7d6$var$hi,
    useDebugValue: $778cb9e25548f7d6$var$ri,
    useDeferredValue: function(a) {
        return $778cb9e25548f7d6$var$Th().memoizedState = a;
    },
    useTransition: function() {
        var a = $778cb9e25548f7d6$var$hi(!1), b = a[0];
        a = $778cb9e25548f7d6$var$vi.bind(null, a[1]);
        $778cb9e25548f7d6$var$Th().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $778cb9e25548f7d6$var$M, e = $778cb9e25548f7d6$var$Th();
        if ($778cb9e25548f7d6$var$I) {
            if (void 0 === c) throw Error($778cb9e25548f7d6$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $778cb9e25548f7d6$var$Q) throw Error($778cb9e25548f7d6$var$p(349));
            0 !== ($778cb9e25548f7d6$var$Hh & 30) || $778cb9e25548f7d6$var$di(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $778cb9e25548f7d6$var$mi($778cb9e25548f7d6$var$ai.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $778cb9e25548f7d6$var$bi(9, $778cb9e25548f7d6$var$ci.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $778cb9e25548f7d6$var$Th(), b = $778cb9e25548f7d6$var$Q.identifierPrefix;
        if ($778cb9e25548f7d6$var$I) {
            var c = $778cb9e25548f7d6$var$sg;
            var d = $778cb9e25548f7d6$var$rg;
            c = (d & ~(1 << 32 - $778cb9e25548f7d6$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $778cb9e25548f7d6$var$Kh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $778cb9e25548f7d6$var$Lh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $778cb9e25548f7d6$var$Ph = {
    readContext: $778cb9e25548f7d6$var$eh,
    useCallback: $778cb9e25548f7d6$var$si,
    useContext: $778cb9e25548f7d6$var$eh,
    useEffect: $778cb9e25548f7d6$var$$h,
    useImperativeHandle: $778cb9e25548f7d6$var$qi,
    useInsertionEffect: $778cb9e25548f7d6$var$ni,
    useLayoutEffect: $778cb9e25548f7d6$var$oi,
    useMemo: $778cb9e25548f7d6$var$ti,
    useReducer: $778cb9e25548f7d6$var$Wh,
    useRef: $778cb9e25548f7d6$var$ji,
    useState: function() {
        return $778cb9e25548f7d6$var$Wh($778cb9e25548f7d6$var$Vh);
    },
    useDebugValue: $778cb9e25548f7d6$var$ri,
    useDeferredValue: function(a) {
        var b = $778cb9e25548f7d6$var$Uh();
        return $778cb9e25548f7d6$var$ui(b, $778cb9e25548f7d6$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $778cb9e25548f7d6$var$Wh($778cb9e25548f7d6$var$Vh)[0], b = $778cb9e25548f7d6$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $778cb9e25548f7d6$var$Yh,
    useSyncExternalStore: $778cb9e25548f7d6$var$Zh,
    useId: $778cb9e25548f7d6$var$wi,
    unstable_isNewReconciler: !1
}, $778cb9e25548f7d6$var$Qh = {
    readContext: $778cb9e25548f7d6$var$eh,
    useCallback: $778cb9e25548f7d6$var$si,
    useContext: $778cb9e25548f7d6$var$eh,
    useEffect: $778cb9e25548f7d6$var$$h,
    useImperativeHandle: $778cb9e25548f7d6$var$qi,
    useInsertionEffect: $778cb9e25548f7d6$var$ni,
    useLayoutEffect: $778cb9e25548f7d6$var$oi,
    useMemo: $778cb9e25548f7d6$var$ti,
    useReducer: $778cb9e25548f7d6$var$Xh,
    useRef: $778cb9e25548f7d6$var$ji,
    useState: function() {
        return $778cb9e25548f7d6$var$Xh($778cb9e25548f7d6$var$Vh);
    },
    useDebugValue: $778cb9e25548f7d6$var$ri,
    useDeferredValue: function(a) {
        var b = $778cb9e25548f7d6$var$Uh();
        return null === $778cb9e25548f7d6$var$N ? b.memoizedState = a : $778cb9e25548f7d6$var$ui(b, $778cb9e25548f7d6$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $778cb9e25548f7d6$var$Xh($778cb9e25548f7d6$var$Vh)[0], b = $778cb9e25548f7d6$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $778cb9e25548f7d6$var$Yh,
    useSyncExternalStore: $778cb9e25548f7d6$var$Zh,
    useId: $778cb9e25548f7d6$var$wi,
    unstable_isNewReconciler: !1
};
function $778cb9e25548f7d6$var$Ci(a, b) {
    if (a && a.defaultProps) {
        b = $778cb9e25548f7d6$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
function $778cb9e25548f7d6$var$Di(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $778cb9e25548f7d6$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $778cb9e25548f7d6$var$Ei = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $778cb9e25548f7d6$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $778cb9e25548f7d6$var$R(), e = $778cb9e25548f7d6$var$yi(a), f = $778cb9e25548f7d6$var$mh(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $778cb9e25548f7d6$var$nh(a, f, e);
        null !== b && ($778cb9e25548f7d6$var$gi(b, a, e, d), $778cb9e25548f7d6$var$oh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $778cb9e25548f7d6$var$R(), e = $778cb9e25548f7d6$var$yi(a), f = $778cb9e25548f7d6$var$mh(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $778cb9e25548f7d6$var$nh(a, f, e);
        null !== b && ($778cb9e25548f7d6$var$gi(b, a, e, d), $778cb9e25548f7d6$var$oh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $778cb9e25548f7d6$var$R(), d = $778cb9e25548f7d6$var$yi(a), e = $778cb9e25548f7d6$var$mh(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $778cb9e25548f7d6$var$nh(a, e, d);
        null !== b && ($778cb9e25548f7d6$var$gi(b, a, d, c), $778cb9e25548f7d6$var$oh(b, a, d));
    }
};
function $778cb9e25548f7d6$var$Fi(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$778cb9e25548f7d6$var$Ie(c, d) || !$778cb9e25548f7d6$var$Ie(e, f) : !0;
}
function $778cb9e25548f7d6$var$Gi(a, b, c) {
    var d = !1, e = $778cb9e25548f7d6$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $778cb9e25548f7d6$var$eh(f) : (e = $778cb9e25548f7d6$var$Zf(b) ? $778cb9e25548f7d6$var$Xf : $778cb9e25548f7d6$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $778cb9e25548f7d6$var$Yf(a, e) : $778cb9e25548f7d6$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $778cb9e25548f7d6$var$Ei;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $778cb9e25548f7d6$var$Hi(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $778cb9e25548f7d6$var$Ei.enqueueReplaceState(b, b.state, null);
}
function $778cb9e25548f7d6$var$Ii(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = {};
    $778cb9e25548f7d6$var$kh(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $778cb9e25548f7d6$var$eh(f) : (f = $778cb9e25548f7d6$var$Zf(b) ? $778cb9e25548f7d6$var$Xf : $778cb9e25548f7d6$var$H.current, e.context = $778cb9e25548f7d6$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($778cb9e25548f7d6$var$Di(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $778cb9e25548f7d6$var$Ei.enqueueReplaceState(e, e.state, null), $778cb9e25548f7d6$var$qh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $778cb9e25548f7d6$var$Ji(a, b) {
    try {
        var c = "", d = b;
        do c += $778cb9e25548f7d6$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $778cb9e25548f7d6$var$Ki(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $778cb9e25548f7d6$var$Li(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $778cb9e25548f7d6$var$Mi = "function" === typeof WeakMap ? WeakMap : Map;
function $778cb9e25548f7d6$var$Ni(a, b, c) {
    c = $778cb9e25548f7d6$var$mh(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $778cb9e25548f7d6$var$Oi || ($778cb9e25548f7d6$var$Oi = !0, $778cb9e25548f7d6$var$Pi = d);
        $778cb9e25548f7d6$var$Li(a, b);
    };
    return c;
}
function $778cb9e25548f7d6$var$Qi(a, b, c) {
    c = $778cb9e25548f7d6$var$mh(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $778cb9e25548f7d6$var$Li(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $778cb9e25548f7d6$var$Li(a, b);
        "function" !== typeof d && (null === $778cb9e25548f7d6$var$Ri ? $778cb9e25548f7d6$var$Ri = new Set([
            this
        ]) : $778cb9e25548f7d6$var$Ri.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $778cb9e25548f7d6$var$Si(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $778cb9e25548f7d6$var$Mi;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $778cb9e25548f7d6$var$Ti.bind(null, a, b, c), b.then(a, a));
}
function $778cb9e25548f7d6$var$Ui(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $778cb9e25548f7d6$var$Vi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $778cb9e25548f7d6$var$mh(-1, 1), b.tag = 2, $778cb9e25548f7d6$var$nh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $778cb9e25548f7d6$var$Wi = $778cb9e25548f7d6$var$ua.ReactCurrentOwner, $778cb9e25548f7d6$var$dh = !1;
function $778cb9e25548f7d6$var$Xi(a, b, c, d) {
    b.child = null === a ? $778cb9e25548f7d6$var$Vg(b, null, c, d) : $778cb9e25548f7d6$var$Ug(b, a.child, c, d);
}
function $778cb9e25548f7d6$var$Yi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $778cb9e25548f7d6$var$ch(b, e);
    d = $778cb9e25548f7d6$var$Nh(a, b, c, d, f, e);
    c = $778cb9e25548f7d6$var$Sh();
    if (null !== a && !$778cb9e25548f7d6$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $778cb9e25548f7d6$var$Zi(a, b, e);
    $778cb9e25548f7d6$var$I && c && $778cb9e25548f7d6$var$vg(b);
    b.flags |= 1;
    $778cb9e25548f7d6$var$Xi(a, b, d, e);
    return b.child;
}
function $778cb9e25548f7d6$var$$i(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$778cb9e25548f7d6$var$aj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $778cb9e25548f7d6$var$bj(a, b, f, d, e);
        a = $778cb9e25548f7d6$var$Rg(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $778cb9e25548f7d6$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $778cb9e25548f7d6$var$Zi(a, b, e);
    }
    b.flags |= 1;
    a = $778cb9e25548f7d6$var$Pg(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $778cb9e25548f7d6$var$bj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($778cb9e25548f7d6$var$Ie(f, d) && a.ref === b.ref) {
            if ($778cb9e25548f7d6$var$dh = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($778cb9e25548f7d6$var$dh = !0);
            else return b.lanes = a.lanes, $778cb9e25548f7d6$var$Zi(a, b, e);
        }
    }
    return $778cb9e25548f7d6$var$cj(a, b, c, d, e);
}
function $778cb9e25548f7d6$var$dj(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $778cb9e25548f7d6$var$G($778cb9e25548f7d6$var$ej, $778cb9e25548f7d6$var$fj), $778cb9e25548f7d6$var$fj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $778cb9e25548f7d6$var$G($778cb9e25548f7d6$var$ej, $778cb9e25548f7d6$var$fj), $778cb9e25548f7d6$var$fj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $778cb9e25548f7d6$var$G($778cb9e25548f7d6$var$ej, $778cb9e25548f7d6$var$fj);
            $778cb9e25548f7d6$var$fj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $778cb9e25548f7d6$var$G($778cb9e25548f7d6$var$ej, $778cb9e25548f7d6$var$fj), $778cb9e25548f7d6$var$fj |= d;
    $778cb9e25548f7d6$var$Xi(a, b, e, c);
    return b.child;
}
function $778cb9e25548f7d6$var$gj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $778cb9e25548f7d6$var$cj(a, b, c, d, e) {
    var f = $778cb9e25548f7d6$var$Zf(c) ? $778cb9e25548f7d6$var$Xf : $778cb9e25548f7d6$var$H.current;
    f = $778cb9e25548f7d6$var$Yf(b, f);
    $778cb9e25548f7d6$var$ch(b, e);
    c = $778cb9e25548f7d6$var$Nh(a, b, c, d, f, e);
    d = $778cb9e25548f7d6$var$Sh();
    if (null !== a && !$778cb9e25548f7d6$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $778cb9e25548f7d6$var$Zi(a, b, e);
    $778cb9e25548f7d6$var$I && d && $778cb9e25548f7d6$var$vg(b);
    b.flags |= 1;
    $778cb9e25548f7d6$var$Xi(a, b, c, e);
    return b.child;
}
function $778cb9e25548f7d6$var$hj(a, b, c, d, e) {
    if ($778cb9e25548f7d6$var$Zf(c)) {
        var f = !0;
        $778cb9e25548f7d6$var$cg(b);
    } else f = !1;
    $778cb9e25548f7d6$var$ch(b, e);
    if (null === b.stateNode) $778cb9e25548f7d6$var$ij(a, b), $778cb9e25548f7d6$var$Gi(b, c, d), $778cb9e25548f7d6$var$Ii(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $778cb9e25548f7d6$var$eh(l) : (l = $778cb9e25548f7d6$var$Zf(c) ? $778cb9e25548f7d6$var$Xf : $778cb9e25548f7d6$var$H.current, l = $778cb9e25548f7d6$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $778cb9e25548f7d6$var$Hi(b, g, d, l);
        $778cb9e25548f7d6$var$jh = !1;
        var r = b.memoizedState;
        g.state = r;
        $778cb9e25548f7d6$var$qh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $778cb9e25548f7d6$var$Wf.current || $778cb9e25548f7d6$var$jh ? ("function" === typeof m && ($778cb9e25548f7d6$var$Di(b, c, m, d), k = b.memoizedState), (h = $778cb9e25548f7d6$var$jh || $778cb9e25548f7d6$var$Fi(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $778cb9e25548f7d6$var$lh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $778cb9e25548f7d6$var$Ci(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $778cb9e25548f7d6$var$eh(k) : (k = $778cb9e25548f7d6$var$Zf(c) ? $778cb9e25548f7d6$var$Xf : $778cb9e25548f7d6$var$H.current, k = $778cb9e25548f7d6$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $778cb9e25548f7d6$var$Hi(b, g, d, k);
        $778cb9e25548f7d6$var$jh = !1;
        r = b.memoizedState;
        g.state = r;
        $778cb9e25548f7d6$var$qh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $778cb9e25548f7d6$var$Wf.current || $778cb9e25548f7d6$var$jh ? ("function" === typeof y && ($778cb9e25548f7d6$var$Di(b, c, y, d), n = b.memoizedState), (l = $778cb9e25548f7d6$var$jh || $778cb9e25548f7d6$var$Fi(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $778cb9e25548f7d6$var$jj(a, b, c, d, f, e);
}
function $778cb9e25548f7d6$var$jj(a, b, c, d, e, f) {
    $778cb9e25548f7d6$var$gj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $778cb9e25548f7d6$var$dg(b, c, !1), $778cb9e25548f7d6$var$Zi(a, b, f);
    d = b.stateNode;
    $778cb9e25548f7d6$var$Wi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $778cb9e25548f7d6$var$Ug(b, a.child, null, f), b.child = $778cb9e25548f7d6$var$Ug(b, null, h, f)) : $778cb9e25548f7d6$var$Xi(a, b, h, f);
    b.memoizedState = d.state;
    e && $778cb9e25548f7d6$var$dg(b, c, !0);
    return b.child;
}
function $778cb9e25548f7d6$var$kj(a) {
    var b = a.stateNode;
    b.pendingContext ? $778cb9e25548f7d6$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $778cb9e25548f7d6$var$ag(a, b.context, !1);
    $778cb9e25548f7d6$var$yh(a, b.containerInfo);
}
function $778cb9e25548f7d6$var$lj(a, b, c, d, e) {
    $778cb9e25548f7d6$var$Ig();
    $778cb9e25548f7d6$var$Jg(e);
    b.flags |= 256;
    $778cb9e25548f7d6$var$Xi(a, b, c, d);
    return b.child;
}
var $778cb9e25548f7d6$var$mj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $778cb9e25548f7d6$var$nj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $778cb9e25548f7d6$var$oj(a, b, c) {
    var d = b.pendingProps, e = $778cb9e25548f7d6$var$L.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $778cb9e25548f7d6$var$G($778cb9e25548f7d6$var$L, e & 1);
    if (null === a) {
        $778cb9e25548f7d6$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $778cb9e25548f7d6$var$pj(g, d, 0, null), a = $778cb9e25548f7d6$var$Tg(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $778cb9e25548f7d6$var$nj(c), b.memoizedState = $778cb9e25548f7d6$var$mj, a) : $778cb9e25548f7d6$var$qj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $778cb9e25548f7d6$var$rj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $778cb9e25548f7d6$var$Pg(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $778cb9e25548f7d6$var$Pg(h, f) : (f = $778cb9e25548f7d6$var$Tg(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $778cb9e25548f7d6$var$nj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $778cb9e25548f7d6$var$mj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $778cb9e25548f7d6$var$Pg(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $778cb9e25548f7d6$var$qj(a, b) {
    b = $778cb9e25548f7d6$var$pj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $778cb9e25548f7d6$var$sj(a, b, c, d) {
    null !== d && $778cb9e25548f7d6$var$Jg(d);
    $778cb9e25548f7d6$var$Ug(b, a.child, null, c);
    a = $778cb9e25548f7d6$var$qj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $778cb9e25548f7d6$var$rj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $778cb9e25548f7d6$var$Ki(Error($778cb9e25548f7d6$var$p(422))), $778cb9e25548f7d6$var$sj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $778cb9e25548f7d6$var$pj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $778cb9e25548f7d6$var$Tg(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $778cb9e25548f7d6$var$Ug(b, a.child, null, g);
        b.child.memoizedState = $778cb9e25548f7d6$var$nj(g);
        b.memoizedState = $778cb9e25548f7d6$var$mj;
        return f;
    }
    if (0 === (b.mode & 1)) return $778cb9e25548f7d6$var$sj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($778cb9e25548f7d6$var$p(419));
        d = $778cb9e25548f7d6$var$Ki(f, d, void 0);
        return $778cb9e25548f7d6$var$sj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($778cb9e25548f7d6$var$dh || h) {
        d = $778cb9e25548f7d6$var$Q;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $778cb9e25548f7d6$var$ih(a, e), $778cb9e25548f7d6$var$gi(d, a, e, -1));
        }
        $778cb9e25548f7d6$var$tj();
        d = $778cb9e25548f7d6$var$Ki(Error($778cb9e25548f7d6$var$p(421)));
        return $778cb9e25548f7d6$var$sj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $778cb9e25548f7d6$var$uj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $778cb9e25548f7d6$var$yg = $778cb9e25548f7d6$var$Lf(e.nextSibling);
    $778cb9e25548f7d6$var$xg = b;
    $778cb9e25548f7d6$var$I = !0;
    $778cb9e25548f7d6$var$zg = null;
    null !== a && ($778cb9e25548f7d6$var$og[$778cb9e25548f7d6$var$pg++] = $778cb9e25548f7d6$var$rg, $778cb9e25548f7d6$var$og[$778cb9e25548f7d6$var$pg++] = $778cb9e25548f7d6$var$sg, $778cb9e25548f7d6$var$og[$778cb9e25548f7d6$var$pg++] = $778cb9e25548f7d6$var$qg, $778cb9e25548f7d6$var$rg = a.id, $778cb9e25548f7d6$var$sg = a.overflow, $778cb9e25548f7d6$var$qg = b);
    b = $778cb9e25548f7d6$var$qj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $778cb9e25548f7d6$var$vj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $778cb9e25548f7d6$var$bh(a.return, b, c);
}
function $778cb9e25548f7d6$var$wj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $778cb9e25548f7d6$var$xj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $778cb9e25548f7d6$var$Xi(a, b, d.children, c);
    d = $778cb9e25548f7d6$var$L.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $778cb9e25548f7d6$var$vj(a, c, b);
            else if (19 === a.tag) $778cb9e25548f7d6$var$vj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $778cb9e25548f7d6$var$G($778cb9e25548f7d6$var$L, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $778cb9e25548f7d6$var$Ch(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $778cb9e25548f7d6$var$wj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $778cb9e25548f7d6$var$Ch(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $778cb9e25548f7d6$var$wj(b, !0, c, null, f);
            break;
        case "together":
            $778cb9e25548f7d6$var$wj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $778cb9e25548f7d6$var$ij(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $778cb9e25548f7d6$var$Zi(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $778cb9e25548f7d6$var$rh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($778cb9e25548f7d6$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $778cb9e25548f7d6$var$Pg(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $778cb9e25548f7d6$var$Pg(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $778cb9e25548f7d6$var$yj(a, b, c) {
    switch(b.tag){
        case 3:
            $778cb9e25548f7d6$var$kj(b);
            $778cb9e25548f7d6$var$Ig();
            break;
        case 5:
            $778cb9e25548f7d6$var$Ah(b);
            break;
        case 1:
            $778cb9e25548f7d6$var$Zf(b.type) && $778cb9e25548f7d6$var$cg(b);
            break;
        case 4:
            $778cb9e25548f7d6$var$yh(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $778cb9e25548f7d6$var$G($778cb9e25548f7d6$var$Wg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $778cb9e25548f7d6$var$G($778cb9e25548f7d6$var$L, $778cb9e25548f7d6$var$L.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $778cb9e25548f7d6$var$oj(a, b, c);
                $778cb9e25548f7d6$var$G($778cb9e25548f7d6$var$L, $778cb9e25548f7d6$var$L.current & 1);
                a = $778cb9e25548f7d6$var$Zi(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $778cb9e25548f7d6$var$G($778cb9e25548f7d6$var$L, $778cb9e25548f7d6$var$L.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $778cb9e25548f7d6$var$xj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $778cb9e25548f7d6$var$G($778cb9e25548f7d6$var$L, $778cb9e25548f7d6$var$L.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $778cb9e25548f7d6$var$dj(a, b, c);
    }
    return $778cb9e25548f7d6$var$Zi(a, b, c);
}
var $778cb9e25548f7d6$var$zj, $778cb9e25548f7d6$var$Aj, $778cb9e25548f7d6$var$Bj, $778cb9e25548f7d6$var$Cj;
$778cb9e25548f7d6$var$zj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$778cb9e25548f7d6$var$Aj = function() {};
$778cb9e25548f7d6$var$Bj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $778cb9e25548f7d6$var$xh($778cb9e25548f7d6$var$uh.current);
        var f = null;
        switch(c){
            case "input":
                e = $778cb9e25548f7d6$var$Ya(a, e);
                d = $778cb9e25548f7d6$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $778cb9e25548f7d6$var$A({}, e, {
                    value: void 0
                });
                d = $778cb9e25548f7d6$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $778cb9e25548f7d6$var$gb(a, e);
                d = $778cb9e25548f7d6$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $778cb9e25548f7d6$var$Bf);
        }
        $778cb9e25548f7d6$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($778cb9e25548f7d6$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($778cb9e25548f7d6$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $778cb9e25548f7d6$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$778cb9e25548f7d6$var$Cj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $778cb9e25548f7d6$var$Dj(a, b) {
    if (!$778cb9e25548f7d6$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $778cb9e25548f7d6$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $778cb9e25548f7d6$var$Ej(a, b, c) {
    var d = b.pendingProps;
    $778cb9e25548f7d6$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $778cb9e25548f7d6$var$S(b), null;
        case 1:
            return $778cb9e25548f7d6$var$Zf(b.type) && $778cb9e25548f7d6$var$$f(), $778cb9e25548f7d6$var$S(b), null;
        case 3:
            d = b.stateNode;
            $778cb9e25548f7d6$var$zh();
            $778cb9e25548f7d6$var$E($778cb9e25548f7d6$var$Wf);
            $778cb9e25548f7d6$var$E($778cb9e25548f7d6$var$H);
            $778cb9e25548f7d6$var$Eh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $778cb9e25548f7d6$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $778cb9e25548f7d6$var$zg && ($778cb9e25548f7d6$var$Fj($778cb9e25548f7d6$var$zg), $778cb9e25548f7d6$var$zg = null));
            $778cb9e25548f7d6$var$Aj(a, b);
            $778cb9e25548f7d6$var$S(b);
            return null;
        case 5:
            $778cb9e25548f7d6$var$Bh(b);
            var e = $778cb9e25548f7d6$var$xh($778cb9e25548f7d6$var$wh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $778cb9e25548f7d6$var$Bj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($778cb9e25548f7d6$var$p(166));
                    $778cb9e25548f7d6$var$S(b);
                    return null;
                }
                a = $778cb9e25548f7d6$var$xh($778cb9e25548f7d6$var$uh.current);
                if ($778cb9e25548f7d6$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$778cb9e25548f7d6$var$Of] = b;
                    d[$778cb9e25548f7d6$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $778cb9e25548f7d6$var$D("cancel", d);
                            $778cb9e25548f7d6$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $778cb9e25548f7d6$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $778cb9e25548f7d6$var$lf.length; e++)$778cb9e25548f7d6$var$D($778cb9e25548f7d6$var$lf[e], d);
                            break;
                        case "source":
                            $778cb9e25548f7d6$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $778cb9e25548f7d6$var$D("error", d);
                            $778cb9e25548f7d6$var$D("load", d);
                            break;
                        case "details":
                            $778cb9e25548f7d6$var$D("toggle", d);
                            break;
                        case "input":
                            $778cb9e25548f7d6$var$Za(d, f);
                            $778cb9e25548f7d6$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $778cb9e25548f7d6$var$D("invalid", d);
                            break;
                        case "textarea":
                            $778cb9e25548f7d6$var$hb(d, f), $778cb9e25548f7d6$var$D("invalid", d);
                    }
                    $778cb9e25548f7d6$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $778cb9e25548f7d6$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $778cb9e25548f7d6$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $778cb9e25548f7d6$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $778cb9e25548f7d6$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $778cb9e25548f7d6$var$Va(d);
                            $778cb9e25548f7d6$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $778cb9e25548f7d6$var$Va(d);
                            $778cb9e25548f7d6$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $778cb9e25548f7d6$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $778cb9e25548f7d6$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script></script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$778cb9e25548f7d6$var$Of] = b;
                    a[$778cb9e25548f7d6$var$Pf] = d;
                    $778cb9e25548f7d6$var$zj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $778cb9e25548f7d6$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $778cb9e25548f7d6$var$D("cancel", a);
                                $778cb9e25548f7d6$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $778cb9e25548f7d6$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $778cb9e25548f7d6$var$lf.length; e++)$778cb9e25548f7d6$var$D($778cb9e25548f7d6$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $778cb9e25548f7d6$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $778cb9e25548f7d6$var$D("error", a);
                                $778cb9e25548f7d6$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $778cb9e25548f7d6$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $778cb9e25548f7d6$var$Za(a, d);
                                e = $778cb9e25548f7d6$var$Ya(a, d);
                                $778cb9e25548f7d6$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $778cb9e25548f7d6$var$A({}, d, {
                                    value: void 0
                                });
                                $778cb9e25548f7d6$var$D("invalid", a);
                                break;
                            case "textarea":
                                $778cb9e25548f7d6$var$hb(a, d);
                                e = $778cb9e25548f7d6$var$gb(a, d);
                                $778cb9e25548f7d6$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $778cb9e25548f7d6$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $778cb9e25548f7d6$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $778cb9e25548f7d6$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $778cb9e25548f7d6$var$ob(a, k) : "number" === typeof k && $778cb9e25548f7d6$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($778cb9e25548f7d6$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $778cb9e25548f7d6$var$D("scroll", a) : null != k && $778cb9e25548f7d6$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $778cb9e25548f7d6$var$Va(a);
                                $778cb9e25548f7d6$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $778cb9e25548f7d6$var$Va(a);
                                $778cb9e25548f7d6$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $778cb9e25548f7d6$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $778cb9e25548f7d6$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $778cb9e25548f7d6$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $778cb9e25548f7d6$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $778cb9e25548f7d6$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $778cb9e25548f7d6$var$Cj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($778cb9e25548f7d6$var$p(166));
                c = $778cb9e25548f7d6$var$xh($778cb9e25548f7d6$var$wh.current);
                $778cb9e25548f7d6$var$xh($778cb9e25548f7d6$var$uh.current);
                if ($778cb9e25548f7d6$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$778cb9e25548f7d6$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $778cb9e25548f7d6$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $778cb9e25548f7d6$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $778cb9e25548f7d6$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$778cb9e25548f7d6$var$Of] = b, b.stateNode = d;
            }
            $778cb9e25548f7d6$var$S(b);
            return null;
        case 13:
            $778cb9e25548f7d6$var$E($778cb9e25548f7d6$var$L);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($778cb9e25548f7d6$var$I && null !== $778cb9e25548f7d6$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $778cb9e25548f7d6$var$Hg(), $778cb9e25548f7d6$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $778cb9e25548f7d6$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($778cb9e25548f7d6$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($778cb9e25548f7d6$var$p(317));
                        f[$778cb9e25548f7d6$var$Of] = b;
                    } else $778cb9e25548f7d6$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $778cb9e25548f7d6$var$S(b);
                    f = !1;
                } else null !== $778cb9e25548f7d6$var$zg && ($778cb9e25548f7d6$var$Fj($778cb9e25548f7d6$var$zg), $778cb9e25548f7d6$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($778cb9e25548f7d6$var$L.current & 1) ? 0 === $778cb9e25548f7d6$var$T && ($778cb9e25548f7d6$var$T = 3) : $778cb9e25548f7d6$var$tj()));
            null !== b.updateQueue && (b.flags |= 4);
            $778cb9e25548f7d6$var$S(b);
            return null;
        case 4:
            return $778cb9e25548f7d6$var$zh(), $778cb9e25548f7d6$var$Aj(a, b), null === a && $778cb9e25548f7d6$var$sf(b.stateNode.containerInfo), $778cb9e25548f7d6$var$S(b), null;
        case 10:
            return $778cb9e25548f7d6$var$ah(b.type._context), $778cb9e25548f7d6$var$S(b), null;
        case 17:
            return $778cb9e25548f7d6$var$Zf(b.type) && $778cb9e25548f7d6$var$$f(), $778cb9e25548f7d6$var$S(b), null;
        case 19:
            $778cb9e25548f7d6$var$E($778cb9e25548f7d6$var$L);
            f = b.memoizedState;
            if (null === f) return $778cb9e25548f7d6$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $778cb9e25548f7d6$var$Dj(f, !1);
                else {
                    if (0 !== $778cb9e25548f7d6$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $778cb9e25548f7d6$var$Ch(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $778cb9e25548f7d6$var$Dj(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $778cb9e25548f7d6$var$G($778cb9e25548f7d6$var$L, $778cb9e25548f7d6$var$L.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $778cb9e25548f7d6$var$B() > $778cb9e25548f7d6$var$Gj && (b.flags |= 128, d = !0, $778cb9e25548f7d6$var$Dj(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $778cb9e25548f7d6$var$Ch(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $778cb9e25548f7d6$var$Dj(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$778cb9e25548f7d6$var$I) return $778cb9e25548f7d6$var$S(b), null;
                    } else 2 * $778cb9e25548f7d6$var$B() - f.renderingStartTime > $778cb9e25548f7d6$var$Gj && 1073741824 !== c && (b.flags |= 128, d = !0, $778cb9e25548f7d6$var$Dj(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $778cb9e25548f7d6$var$B(), b.sibling = null, c = $778cb9e25548f7d6$var$L.current, $778cb9e25548f7d6$var$G($778cb9e25548f7d6$var$L, d ? c & 1 | 2 : c & 1), b;
            $778cb9e25548f7d6$var$S(b);
            return null;
        case 22:
        case 23:
            return $778cb9e25548f7d6$var$Hj(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($778cb9e25548f7d6$var$fj & 1073741824) && ($778cb9e25548f7d6$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $778cb9e25548f7d6$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($778cb9e25548f7d6$var$p(156, b.tag));
}
function $778cb9e25548f7d6$var$Ij(a, b) {
    $778cb9e25548f7d6$var$wg(b);
    switch(b.tag){
        case 1:
            return $778cb9e25548f7d6$var$Zf(b.type) && $778cb9e25548f7d6$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $778cb9e25548f7d6$var$zh(), $778cb9e25548f7d6$var$E($778cb9e25548f7d6$var$Wf), $778cb9e25548f7d6$var$E($778cb9e25548f7d6$var$H), $778cb9e25548f7d6$var$Eh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $778cb9e25548f7d6$var$Bh(b), null;
        case 13:
            $778cb9e25548f7d6$var$E($778cb9e25548f7d6$var$L);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($778cb9e25548f7d6$var$p(340));
                $778cb9e25548f7d6$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $778cb9e25548f7d6$var$E($778cb9e25548f7d6$var$L), null;
        case 4:
            return $778cb9e25548f7d6$var$zh(), null;
        case 10:
            return $778cb9e25548f7d6$var$ah(b.type._context), null;
        case 22:
        case 23:
            return $778cb9e25548f7d6$var$Hj(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $778cb9e25548f7d6$var$Jj = !1, $778cb9e25548f7d6$var$U = !1, $778cb9e25548f7d6$var$Kj = "function" === typeof WeakSet ? WeakSet : Set, $778cb9e25548f7d6$var$V = null;
function $778cb9e25548f7d6$var$Lj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $778cb9e25548f7d6$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $778cb9e25548f7d6$var$Mj(a, b, c) {
    try {
        c();
    } catch (d) {
        $778cb9e25548f7d6$var$W(a, b, d);
    }
}
var $778cb9e25548f7d6$var$Nj = !1;
function $778cb9e25548f7d6$var$Oj(a, b) {
    $778cb9e25548f7d6$var$Cf = $778cb9e25548f7d6$var$dd;
    a = $778cb9e25548f7d6$var$Me();
    if ($778cb9e25548f7d6$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $778cb9e25548f7d6$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $778cb9e25548f7d6$var$dd = !1;
    for($778cb9e25548f7d6$var$V = b; null !== $778cb9e25548f7d6$var$V;)if (b = $778cb9e25548f7d6$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $778cb9e25548f7d6$var$V = a;
    else for(; null !== $778cb9e25548f7d6$var$V;){
        b = $778cb9e25548f7d6$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $778cb9e25548f7d6$var$Ci(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($778cb9e25548f7d6$var$p(163));
            }
        } catch (F) {
            $778cb9e25548f7d6$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $778cb9e25548f7d6$var$V = a;
            break;
        }
        $778cb9e25548f7d6$var$V = b.return;
    }
    n = $778cb9e25548f7d6$var$Nj;
    $778cb9e25548f7d6$var$Nj = !1;
    return n;
}
function $778cb9e25548f7d6$var$Pj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $778cb9e25548f7d6$var$Mj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $778cb9e25548f7d6$var$Qj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $778cb9e25548f7d6$var$Rj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $778cb9e25548f7d6$var$Sj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $778cb9e25548f7d6$var$Sj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$778cb9e25548f7d6$var$Of], delete b[$778cb9e25548f7d6$var$Pf], delete b[$778cb9e25548f7d6$var$of], delete b[$778cb9e25548f7d6$var$Qf], delete b[$778cb9e25548f7d6$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $778cb9e25548f7d6$var$Tj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $778cb9e25548f7d6$var$Uj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $778cb9e25548f7d6$var$Tj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $778cb9e25548f7d6$var$Vj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $778cb9e25548f7d6$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($778cb9e25548f7d6$var$Vj(a, b, c), a = a.sibling; null !== a;)$778cb9e25548f7d6$var$Vj(a, b, c), a = a.sibling;
}
function $778cb9e25548f7d6$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($778cb9e25548f7d6$var$Wj(a, b, c), a = a.sibling; null !== a;)$778cb9e25548f7d6$var$Wj(a, b, c), a = a.sibling;
}
var $778cb9e25548f7d6$var$X = null, $778cb9e25548f7d6$var$Xj = !1;
function $778cb9e25548f7d6$var$Yj(a, b, c) {
    for(c = c.child; null !== c;)$778cb9e25548f7d6$var$Zj(a, b, c), c = c.sibling;
}
function $778cb9e25548f7d6$var$Zj(a, b, c) {
    if ($778cb9e25548f7d6$var$lc && "function" === typeof $778cb9e25548f7d6$var$lc.onCommitFiberUnmount) try {
        $778cb9e25548f7d6$var$lc.onCommitFiberUnmount($778cb9e25548f7d6$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $778cb9e25548f7d6$var$U || $778cb9e25548f7d6$var$Lj(c, b);
        case 6:
            var d = $778cb9e25548f7d6$var$X, e = $778cb9e25548f7d6$var$Xj;
            $778cb9e25548f7d6$var$X = null;
            $778cb9e25548f7d6$var$Yj(a, b, c);
            $778cb9e25548f7d6$var$X = d;
            $778cb9e25548f7d6$var$Xj = e;
            null !== $778cb9e25548f7d6$var$X && ($778cb9e25548f7d6$var$Xj ? (a = $778cb9e25548f7d6$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $778cb9e25548f7d6$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $778cb9e25548f7d6$var$X && ($778cb9e25548f7d6$var$Xj ? (a = $778cb9e25548f7d6$var$X, c = c.stateNode, 8 === a.nodeType ? $778cb9e25548f7d6$var$Kf(a.parentNode, c) : 1 === a.nodeType && $778cb9e25548f7d6$var$Kf(a, c), $778cb9e25548f7d6$var$bd(a)) : $778cb9e25548f7d6$var$Kf($778cb9e25548f7d6$var$X, c.stateNode));
            break;
        case 4:
            d = $778cb9e25548f7d6$var$X;
            e = $778cb9e25548f7d6$var$Xj;
            $778cb9e25548f7d6$var$X = c.stateNode.containerInfo;
            $778cb9e25548f7d6$var$Xj = !0;
            $778cb9e25548f7d6$var$Yj(a, b, c);
            $778cb9e25548f7d6$var$X = d;
            $778cb9e25548f7d6$var$Xj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$778cb9e25548f7d6$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $778cb9e25548f7d6$var$Mj(c, b, g) : 0 !== (f & 4) && $778cb9e25548f7d6$var$Mj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $778cb9e25548f7d6$var$Yj(a, b, c);
            break;
        case 1:
            if (!$778cb9e25548f7d6$var$U && ($778cb9e25548f7d6$var$Lj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $778cb9e25548f7d6$var$W(c, b, h);
            }
            $778cb9e25548f7d6$var$Yj(a, b, c);
            break;
        case 21:
            $778cb9e25548f7d6$var$Yj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($778cb9e25548f7d6$var$U = (d = $778cb9e25548f7d6$var$U) || null !== c.memoizedState, $778cb9e25548f7d6$var$Yj(a, b, c), $778cb9e25548f7d6$var$U = d) : $778cb9e25548f7d6$var$Yj(a, b, c);
            break;
        default:
            $778cb9e25548f7d6$var$Yj(a, b, c);
    }
}
function $778cb9e25548f7d6$var$ak(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $778cb9e25548f7d6$var$Kj);
        b.forEach(function(b) {
            var d = $778cb9e25548f7d6$var$bk.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $778cb9e25548f7d6$var$ck(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $778cb9e25548f7d6$var$X = h.stateNode;
                        $778cb9e25548f7d6$var$Xj = !1;
                        break a;
                    case 3:
                        $778cb9e25548f7d6$var$X = h.stateNode.containerInfo;
                        $778cb9e25548f7d6$var$Xj = !0;
                        break a;
                    case 4:
                        $778cb9e25548f7d6$var$X = h.stateNode.containerInfo;
                        $778cb9e25548f7d6$var$Xj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $778cb9e25548f7d6$var$X) throw Error($778cb9e25548f7d6$var$p(160));
            $778cb9e25548f7d6$var$Zj(f, g, e);
            $778cb9e25548f7d6$var$X = null;
            $778cb9e25548f7d6$var$Xj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $778cb9e25548f7d6$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$778cb9e25548f7d6$var$dk(b, a), b = b.sibling;
}
function $778cb9e25548f7d6$var$dk(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $778cb9e25548f7d6$var$ck(b, a);
            $778cb9e25548f7d6$var$ek(a);
            if (d & 4) {
                try {
                    $778cb9e25548f7d6$var$Pj(3, a, a.return), $778cb9e25548f7d6$var$Qj(3, a);
                } catch (t) {
                    $778cb9e25548f7d6$var$W(a, a.return, t);
                }
                try {
                    $778cb9e25548f7d6$var$Pj(5, a, a.return);
                } catch (t) {
                    $778cb9e25548f7d6$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $778cb9e25548f7d6$var$ck(b, a);
            $778cb9e25548f7d6$var$ek(a);
            d & 512 && null !== c && $778cb9e25548f7d6$var$Lj(c, c.return);
            break;
        case 5:
            $778cb9e25548f7d6$var$ck(b, a);
            $778cb9e25548f7d6$var$ek(a);
            d & 512 && null !== c && $778cb9e25548f7d6$var$Lj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $778cb9e25548f7d6$var$ob(e, "");
                } catch (t) {
                    $778cb9e25548f7d6$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $778cb9e25548f7d6$var$ab(e, f);
                    $778cb9e25548f7d6$var$vb(h, g);
                    var l = $778cb9e25548f7d6$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $778cb9e25548f7d6$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $778cb9e25548f7d6$var$nb(e, q) : "children" === m ? $778cb9e25548f7d6$var$ob(e, q) : $778cb9e25548f7d6$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $778cb9e25548f7d6$var$bb(e, f);
                            break;
                        case "textarea":
                            $778cb9e25548f7d6$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $778cb9e25548f7d6$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $778cb9e25548f7d6$var$fb(e, !!f.multiple, f.defaultValue, !0) : $778cb9e25548f7d6$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$778cb9e25548f7d6$var$Pf] = f;
                } catch (t) {
                    $778cb9e25548f7d6$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $778cb9e25548f7d6$var$ck(b, a);
            $778cb9e25548f7d6$var$ek(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($778cb9e25548f7d6$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $778cb9e25548f7d6$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $778cb9e25548f7d6$var$ck(b, a);
            $778cb9e25548f7d6$var$ek(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $778cb9e25548f7d6$var$bd(b.containerInfo);
            } catch (t) {
                $778cb9e25548f7d6$var$W(a, a.return, t);
            }
            break;
        case 4:
            $778cb9e25548f7d6$var$ck(b, a);
            $778cb9e25548f7d6$var$ek(a);
            break;
        case 13:
            $778cb9e25548f7d6$var$ck(b, a);
            $778cb9e25548f7d6$var$ek(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($778cb9e25548f7d6$var$fk = $778cb9e25548f7d6$var$B()));
            d & 4 && $778cb9e25548f7d6$var$ak(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($778cb9e25548f7d6$var$U = (l = $778cb9e25548f7d6$var$U) || m, $778cb9e25548f7d6$var$ck(b, a), $778cb9e25548f7d6$var$U = l) : $778cb9e25548f7d6$var$ck(b, a);
            $778cb9e25548f7d6$var$ek(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($778cb9e25548f7d6$var$V = a, m = a.child; null !== m;){
                    for(q = $778cb9e25548f7d6$var$V = m; null !== $778cb9e25548f7d6$var$V;){
                        r = $778cb9e25548f7d6$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $778cb9e25548f7d6$var$Pj(4, r, r.return);
                                break;
                            case 1:
                                $778cb9e25548f7d6$var$Lj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $778cb9e25548f7d6$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $778cb9e25548f7d6$var$Lj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $778cb9e25548f7d6$var$gk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $778cb9e25548f7d6$var$V = y) : $778cb9e25548f7d6$var$gk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $778cb9e25548f7d6$var$rb("display", g));
                            } catch (t) {
                                $778cb9e25548f7d6$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $778cb9e25548f7d6$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $778cb9e25548f7d6$var$ck(b, a);
            $778cb9e25548f7d6$var$ek(a);
            d & 4 && $778cb9e25548f7d6$var$ak(a);
            break;
        case 21:
            break;
        default:
            $778cb9e25548f7d6$var$ck(b, a), $778cb9e25548f7d6$var$ek(a);
    }
}
function $778cb9e25548f7d6$var$ek(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($778cb9e25548f7d6$var$Tj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($778cb9e25548f7d6$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($778cb9e25548f7d6$var$ob(e, ""), d.flags &= -33);
                    var f = $778cb9e25548f7d6$var$Uj(a);
                    $778cb9e25548f7d6$var$Wj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $778cb9e25548f7d6$var$Uj(a);
                    $778cb9e25548f7d6$var$Vj(a, h, g);
                    break;
                default:
                    throw Error($778cb9e25548f7d6$var$p(161));
            }
        } catch (k) {
            $778cb9e25548f7d6$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $778cb9e25548f7d6$var$hk(a, b, c) {
    $778cb9e25548f7d6$var$V = a;
    $778cb9e25548f7d6$var$ik(a, b, c);
}
function $778cb9e25548f7d6$var$ik(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $778cb9e25548f7d6$var$V;){
        var e = $778cb9e25548f7d6$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $778cb9e25548f7d6$var$Jj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $778cb9e25548f7d6$var$U;
                h = $778cb9e25548f7d6$var$Jj;
                var l = $778cb9e25548f7d6$var$U;
                $778cb9e25548f7d6$var$Jj = g;
                if (($778cb9e25548f7d6$var$U = k) && !l) for($778cb9e25548f7d6$var$V = e; null !== $778cb9e25548f7d6$var$V;)g = $778cb9e25548f7d6$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $778cb9e25548f7d6$var$jk(e) : null !== k ? (k.return = g, $778cb9e25548f7d6$var$V = k) : $778cb9e25548f7d6$var$jk(e);
                for(; null !== f;)$778cb9e25548f7d6$var$V = f, $778cb9e25548f7d6$var$ik(f, b, c), f = f.sibling;
                $778cb9e25548f7d6$var$V = e;
                $778cb9e25548f7d6$var$Jj = h;
                $778cb9e25548f7d6$var$U = l;
            }
            $778cb9e25548f7d6$var$kk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $778cb9e25548f7d6$var$V = f) : $778cb9e25548f7d6$var$kk(a, b, c);
    }
}
function $778cb9e25548f7d6$var$kk(a) {
    for(; null !== $778cb9e25548f7d6$var$V;){
        var b = $778cb9e25548f7d6$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $778cb9e25548f7d6$var$U || $778cb9e25548f7d6$var$Qj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$778cb9e25548f7d6$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $778cb9e25548f7d6$var$Ci(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $778cb9e25548f7d6$var$sh(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $778cb9e25548f7d6$var$sh(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $778cb9e25548f7d6$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($778cb9e25548f7d6$var$p(163));
                }
                $778cb9e25548f7d6$var$U || b.flags & 512 && $778cb9e25548f7d6$var$Rj(b);
            } catch (r) {
                $778cb9e25548f7d6$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $778cb9e25548f7d6$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $778cb9e25548f7d6$var$V = c;
            break;
        }
        $778cb9e25548f7d6$var$V = b.return;
    }
}
function $778cb9e25548f7d6$var$gk(a) {
    for(; null !== $778cb9e25548f7d6$var$V;){
        var b = $778cb9e25548f7d6$var$V;
        if (b === a) {
            $778cb9e25548f7d6$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $778cb9e25548f7d6$var$V = c;
            break;
        }
        $778cb9e25548f7d6$var$V = b.return;
    }
}
function $778cb9e25548f7d6$var$jk(a) {
    for(; null !== $778cb9e25548f7d6$var$V;){
        var b = $778cb9e25548f7d6$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $778cb9e25548f7d6$var$Qj(4, b);
                    } catch (k) {
                        $778cb9e25548f7d6$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $778cb9e25548f7d6$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $778cb9e25548f7d6$var$Rj(b);
                    } catch (k) {
                        $778cb9e25548f7d6$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $778cb9e25548f7d6$var$Rj(b);
                    } catch (k) {
                        $778cb9e25548f7d6$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $778cb9e25548f7d6$var$W(b, b.return, k);
        }
        if (b === a) {
            $778cb9e25548f7d6$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $778cb9e25548f7d6$var$V = h;
            break;
        }
        $778cb9e25548f7d6$var$V = b.return;
    }
}
var $778cb9e25548f7d6$var$lk = Math.ceil, $778cb9e25548f7d6$var$mk = $778cb9e25548f7d6$var$ua.ReactCurrentDispatcher, $778cb9e25548f7d6$var$nk = $778cb9e25548f7d6$var$ua.ReactCurrentOwner, $778cb9e25548f7d6$var$ok = $778cb9e25548f7d6$var$ua.ReactCurrentBatchConfig, $778cb9e25548f7d6$var$K = 0, $778cb9e25548f7d6$var$Q = null, $778cb9e25548f7d6$var$Y = null, $778cb9e25548f7d6$var$Z = 0, $778cb9e25548f7d6$var$fj = 0, $778cb9e25548f7d6$var$ej = $778cb9e25548f7d6$var$Uf(0), $778cb9e25548f7d6$var$T = 0, $778cb9e25548f7d6$var$pk = null, $778cb9e25548f7d6$var$rh = 0, $778cb9e25548f7d6$var$qk = 0, $778cb9e25548f7d6$var$rk = 0, $778cb9e25548f7d6$var$sk = null, $778cb9e25548f7d6$var$tk = null, $778cb9e25548f7d6$var$fk = 0, $778cb9e25548f7d6$var$Gj = Infinity, $778cb9e25548f7d6$var$uk = null, $778cb9e25548f7d6$var$Oi = !1, $778cb9e25548f7d6$var$Pi = null, $778cb9e25548f7d6$var$Ri = null, $778cb9e25548f7d6$var$vk = !1, $778cb9e25548f7d6$var$wk = null, $778cb9e25548f7d6$var$xk = 0, $778cb9e25548f7d6$var$yk = 0, $778cb9e25548f7d6$var$zk = null, $778cb9e25548f7d6$var$Ak = -1, $778cb9e25548f7d6$var$Bk = 0;
function $778cb9e25548f7d6$var$R() {
    return 0 !== ($778cb9e25548f7d6$var$K & 6) ? $778cb9e25548f7d6$var$B() : -1 !== $778cb9e25548f7d6$var$Ak ? $778cb9e25548f7d6$var$Ak : $778cb9e25548f7d6$var$Ak = $778cb9e25548f7d6$var$B();
}
function $778cb9e25548f7d6$var$yi(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($778cb9e25548f7d6$var$K & 2) && 0 !== $778cb9e25548f7d6$var$Z) return $778cb9e25548f7d6$var$Z & -$778cb9e25548f7d6$var$Z;
    if (null !== $778cb9e25548f7d6$var$Kg.transition) return 0 === $778cb9e25548f7d6$var$Bk && ($778cb9e25548f7d6$var$Bk = $778cb9e25548f7d6$var$yc()), $778cb9e25548f7d6$var$Bk;
    a = $778cb9e25548f7d6$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $778cb9e25548f7d6$var$jd(a.type);
    return a;
}
function $778cb9e25548f7d6$var$gi(a, b, c, d) {
    if (50 < $778cb9e25548f7d6$var$yk) throw $778cb9e25548f7d6$var$yk = 0, $778cb9e25548f7d6$var$zk = null, Error($778cb9e25548f7d6$var$p(185));
    $778cb9e25548f7d6$var$Ac(a, c, d);
    if (0 === ($778cb9e25548f7d6$var$K & 2) || a !== $778cb9e25548f7d6$var$Q) a === $778cb9e25548f7d6$var$Q && (0 === ($778cb9e25548f7d6$var$K & 2) && ($778cb9e25548f7d6$var$qk |= c), 4 === $778cb9e25548f7d6$var$T && $778cb9e25548f7d6$var$Ck(a, $778cb9e25548f7d6$var$Z)), $778cb9e25548f7d6$var$Dk(a, d), 1 === c && 0 === $778cb9e25548f7d6$var$K && 0 === (b.mode & 1) && ($778cb9e25548f7d6$var$Gj = $778cb9e25548f7d6$var$B() + 500, $778cb9e25548f7d6$var$fg && $778cb9e25548f7d6$var$jg());
}
function $778cb9e25548f7d6$var$Dk(a, b) {
    var c = a.callbackNode;
    $778cb9e25548f7d6$var$wc(a, b);
    var d = $778cb9e25548f7d6$var$uc(a, a === $778cb9e25548f7d6$var$Q ? $778cb9e25548f7d6$var$Z : 0);
    if (0 === d) null !== c && $778cb9e25548f7d6$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $778cb9e25548f7d6$var$bc(c);
        if (1 === b) 0 === a.tag ? $778cb9e25548f7d6$var$ig($778cb9e25548f7d6$var$Ek.bind(null, a)) : $778cb9e25548f7d6$var$hg($778cb9e25548f7d6$var$Ek.bind(null, a)), $778cb9e25548f7d6$var$Jf(function() {
            0 === ($778cb9e25548f7d6$var$K & 6) && $778cb9e25548f7d6$var$jg();
        }), c = null;
        else {
            switch($778cb9e25548f7d6$var$Dc(d)){
                case 1:
                    c = $778cb9e25548f7d6$var$fc;
                    break;
                case 4:
                    c = $778cb9e25548f7d6$var$gc;
                    break;
                case 16:
                    c = $778cb9e25548f7d6$var$hc;
                    break;
                case 536870912:
                    c = $778cb9e25548f7d6$var$jc;
                    break;
                default:
                    c = $778cb9e25548f7d6$var$hc;
            }
            c = $778cb9e25548f7d6$var$Fk(c, $778cb9e25548f7d6$var$Gk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $778cb9e25548f7d6$var$Gk(a, b) {
    $778cb9e25548f7d6$var$Ak = -1;
    $778cb9e25548f7d6$var$Bk = 0;
    if (0 !== ($778cb9e25548f7d6$var$K & 6)) throw Error($778cb9e25548f7d6$var$p(327));
    var c = a.callbackNode;
    if ($778cb9e25548f7d6$var$Hk() && a.callbackNode !== c) return null;
    var d = $778cb9e25548f7d6$var$uc(a, a === $778cb9e25548f7d6$var$Q ? $778cb9e25548f7d6$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $778cb9e25548f7d6$var$Ik(a, d);
    else {
        b = d;
        var e = $778cb9e25548f7d6$var$K;
        $778cb9e25548f7d6$var$K |= 2;
        var f = $778cb9e25548f7d6$var$Jk();
        if ($778cb9e25548f7d6$var$Q !== a || $778cb9e25548f7d6$var$Z !== b) $778cb9e25548f7d6$var$uk = null, $778cb9e25548f7d6$var$Gj = $778cb9e25548f7d6$var$B() + 500, $778cb9e25548f7d6$var$Kk(a, b);
        for(;;)try {
            $778cb9e25548f7d6$var$Lk();
            break;
        } catch (h) {
            $778cb9e25548f7d6$var$Mk(a, h);
        }
        $778cb9e25548f7d6$var$$g();
        $778cb9e25548f7d6$var$mk.current = f;
        $778cb9e25548f7d6$var$K = e;
        null !== $778cb9e25548f7d6$var$Y ? b = 0 : ($778cb9e25548f7d6$var$Q = null, $778cb9e25548f7d6$var$Z = 0, b = $778cb9e25548f7d6$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $778cb9e25548f7d6$var$xc(a), 0 !== e && (d = e, b = $778cb9e25548f7d6$var$Nk(a, e)));
        if (1 === b) throw c = $778cb9e25548f7d6$var$pk, $778cb9e25548f7d6$var$Kk(a, 0), $778cb9e25548f7d6$var$Ck(a, d), $778cb9e25548f7d6$var$Dk(a, $778cb9e25548f7d6$var$B()), c;
        if (6 === b) $778cb9e25548f7d6$var$Ck(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$778cb9e25548f7d6$var$Ok(e) && (b = $778cb9e25548f7d6$var$Ik(a, d), 2 === b && (f = $778cb9e25548f7d6$var$xc(a), 0 !== f && (d = f, b = $778cb9e25548f7d6$var$Nk(a, f))), 1 === b)) throw c = $778cb9e25548f7d6$var$pk, $778cb9e25548f7d6$var$Kk(a, 0), $778cb9e25548f7d6$var$Ck(a, d), $778cb9e25548f7d6$var$Dk(a, $778cb9e25548f7d6$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($778cb9e25548f7d6$var$p(345));
                case 2:
                    $778cb9e25548f7d6$var$Pk(a, $778cb9e25548f7d6$var$tk, $778cb9e25548f7d6$var$uk);
                    break;
                case 3:
                    $778cb9e25548f7d6$var$Ck(a, d);
                    if ((d & 130023424) === d && (b = $778cb9e25548f7d6$var$fk + 500 - $778cb9e25548f7d6$var$B(), 10 < b)) {
                        if (0 !== $778cb9e25548f7d6$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $778cb9e25548f7d6$var$R();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $778cb9e25548f7d6$var$Ff($778cb9e25548f7d6$var$Pk.bind(null, a, $778cb9e25548f7d6$var$tk, $778cb9e25548f7d6$var$uk), b);
                        break;
                    }
                    $778cb9e25548f7d6$var$Pk(a, $778cb9e25548f7d6$var$tk, $778cb9e25548f7d6$var$uk);
                    break;
                case 4:
                    $778cb9e25548f7d6$var$Ck(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $778cb9e25548f7d6$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $778cb9e25548f7d6$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $778cb9e25548f7d6$var$lk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $778cb9e25548f7d6$var$Ff($778cb9e25548f7d6$var$Pk.bind(null, a, $778cb9e25548f7d6$var$tk, $778cb9e25548f7d6$var$uk), d);
                        break;
                    }
                    $778cb9e25548f7d6$var$Pk(a, $778cb9e25548f7d6$var$tk, $778cb9e25548f7d6$var$uk);
                    break;
                case 5:
                    $778cb9e25548f7d6$var$Pk(a, $778cb9e25548f7d6$var$tk, $778cb9e25548f7d6$var$uk);
                    break;
                default:
                    throw Error($778cb9e25548f7d6$var$p(329));
            }
        }
    }
    $778cb9e25548f7d6$var$Dk(a, $778cb9e25548f7d6$var$B());
    return a.callbackNode === c ? $778cb9e25548f7d6$var$Gk.bind(null, a) : null;
}
function $778cb9e25548f7d6$var$Nk(a, b) {
    var c = $778cb9e25548f7d6$var$sk;
    a.current.memoizedState.isDehydrated && ($778cb9e25548f7d6$var$Kk(a, b).flags |= 256);
    a = $778cb9e25548f7d6$var$Ik(a, b);
    2 !== a && (b = $778cb9e25548f7d6$var$tk, $778cb9e25548f7d6$var$tk = c, null !== b && $778cb9e25548f7d6$var$Fj(b));
    return a;
}
function $778cb9e25548f7d6$var$Fj(a) {
    null === $778cb9e25548f7d6$var$tk ? $778cb9e25548f7d6$var$tk = a : $778cb9e25548f7d6$var$tk.push.apply($778cb9e25548f7d6$var$tk, a);
}
function $778cb9e25548f7d6$var$Ok(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$778cb9e25548f7d6$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $778cb9e25548f7d6$var$Ck(a, b) {
    b &= ~$778cb9e25548f7d6$var$rk;
    b &= ~$778cb9e25548f7d6$var$qk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $778cb9e25548f7d6$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $778cb9e25548f7d6$var$Ek(a) {
    if (0 !== ($778cb9e25548f7d6$var$K & 6)) throw Error($778cb9e25548f7d6$var$p(327));
    $778cb9e25548f7d6$var$Hk();
    var b = $778cb9e25548f7d6$var$uc(a, 0);
    if (0 === (b & 1)) return $778cb9e25548f7d6$var$Dk(a, $778cb9e25548f7d6$var$B()), null;
    var c = $778cb9e25548f7d6$var$Ik(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $778cb9e25548f7d6$var$xc(a);
        0 !== d && (b = d, c = $778cb9e25548f7d6$var$Nk(a, d));
    }
    if (1 === c) throw c = $778cb9e25548f7d6$var$pk, $778cb9e25548f7d6$var$Kk(a, 0), $778cb9e25548f7d6$var$Ck(a, b), $778cb9e25548f7d6$var$Dk(a, $778cb9e25548f7d6$var$B()), c;
    if (6 === c) throw Error($778cb9e25548f7d6$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $778cb9e25548f7d6$var$Pk(a, $778cb9e25548f7d6$var$tk, $778cb9e25548f7d6$var$uk);
    $778cb9e25548f7d6$var$Dk(a, $778cb9e25548f7d6$var$B());
    return null;
}
function $778cb9e25548f7d6$var$Qk(a, b) {
    var c = $778cb9e25548f7d6$var$K;
    $778cb9e25548f7d6$var$K |= 1;
    try {
        return a(b);
    } finally{
        $778cb9e25548f7d6$var$K = c, 0 === $778cb9e25548f7d6$var$K && ($778cb9e25548f7d6$var$Gj = $778cb9e25548f7d6$var$B() + 500, $778cb9e25548f7d6$var$fg && $778cb9e25548f7d6$var$jg());
    }
}
function $778cb9e25548f7d6$var$Rk(a) {
    null !== $778cb9e25548f7d6$var$wk && 0 === $778cb9e25548f7d6$var$wk.tag && 0 === ($778cb9e25548f7d6$var$K & 6) && $778cb9e25548f7d6$var$Hk();
    var b = $778cb9e25548f7d6$var$K;
    $778cb9e25548f7d6$var$K |= 1;
    var c = $778cb9e25548f7d6$var$ok.transition, d = $778cb9e25548f7d6$var$C;
    try {
        if ($778cb9e25548f7d6$var$ok.transition = null, $778cb9e25548f7d6$var$C = 1, a) return a();
    } finally{
        $778cb9e25548f7d6$var$C = d, $778cb9e25548f7d6$var$ok.transition = c, $778cb9e25548f7d6$var$K = b, 0 === ($778cb9e25548f7d6$var$K & 6) && $778cb9e25548f7d6$var$jg();
    }
}
function $778cb9e25548f7d6$var$Hj() {
    $778cb9e25548f7d6$var$fj = $778cb9e25548f7d6$var$ej.current;
    $778cb9e25548f7d6$var$E($778cb9e25548f7d6$var$ej);
}
function $778cb9e25548f7d6$var$Kk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $778cb9e25548f7d6$var$Gf(c));
    if (null !== $778cb9e25548f7d6$var$Y) for(c = $778cb9e25548f7d6$var$Y.return; null !== c;){
        var d = c;
        $778cb9e25548f7d6$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $778cb9e25548f7d6$var$$f();
                break;
            case 3:
                $778cb9e25548f7d6$var$zh();
                $778cb9e25548f7d6$var$E($778cb9e25548f7d6$var$Wf);
                $778cb9e25548f7d6$var$E($778cb9e25548f7d6$var$H);
                $778cb9e25548f7d6$var$Eh();
                break;
            case 5:
                $778cb9e25548f7d6$var$Bh(d);
                break;
            case 4:
                $778cb9e25548f7d6$var$zh();
                break;
            case 13:
                $778cb9e25548f7d6$var$E($778cb9e25548f7d6$var$L);
                break;
            case 19:
                $778cb9e25548f7d6$var$E($778cb9e25548f7d6$var$L);
                break;
            case 10:
                $778cb9e25548f7d6$var$ah(d.type._context);
                break;
            case 22:
            case 23:
                $778cb9e25548f7d6$var$Hj();
        }
        c = c.return;
    }
    $778cb9e25548f7d6$var$Q = a;
    $778cb9e25548f7d6$var$Y = a = $778cb9e25548f7d6$var$Pg(a.current, null);
    $778cb9e25548f7d6$var$Z = $778cb9e25548f7d6$var$fj = b;
    $778cb9e25548f7d6$var$T = 0;
    $778cb9e25548f7d6$var$pk = null;
    $778cb9e25548f7d6$var$rk = $778cb9e25548f7d6$var$qk = $778cb9e25548f7d6$var$rh = 0;
    $778cb9e25548f7d6$var$tk = $778cb9e25548f7d6$var$sk = null;
    if (null !== $778cb9e25548f7d6$var$fh) {
        for(b = 0; b < $778cb9e25548f7d6$var$fh.length; b++)if (c = $778cb9e25548f7d6$var$fh[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $778cb9e25548f7d6$var$fh = null;
    }
    return a;
}
function $778cb9e25548f7d6$var$Mk(a, b) {
    do {
        var c = $778cb9e25548f7d6$var$Y;
        try {
            $778cb9e25548f7d6$var$$g();
            $778cb9e25548f7d6$var$Fh.current = $778cb9e25548f7d6$var$Rh;
            if ($778cb9e25548f7d6$var$Ih) {
                for(var d = $778cb9e25548f7d6$var$M.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $778cb9e25548f7d6$var$Ih = !1;
            }
            $778cb9e25548f7d6$var$Hh = 0;
            $778cb9e25548f7d6$var$O = $778cb9e25548f7d6$var$N = $778cb9e25548f7d6$var$M = null;
            $778cb9e25548f7d6$var$Jh = !1;
            $778cb9e25548f7d6$var$Kh = 0;
            $778cb9e25548f7d6$var$nk.current = null;
            if (null === c || null === c.return) {
                $778cb9e25548f7d6$var$T = 1;
                $778cb9e25548f7d6$var$pk = b;
                $778cb9e25548f7d6$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $778cb9e25548f7d6$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $778cb9e25548f7d6$var$Ui(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $778cb9e25548f7d6$var$Vi(y, g, h, f, b);
                        y.mode & 1 && $778cb9e25548f7d6$var$Si(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $778cb9e25548f7d6$var$Si(f, l, b);
                            $778cb9e25548f7d6$var$tj();
                            break a;
                        }
                        k = Error($778cb9e25548f7d6$var$p(426));
                    }
                } else if ($778cb9e25548f7d6$var$I && h.mode & 1) {
                    var J = $778cb9e25548f7d6$var$Ui(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $778cb9e25548f7d6$var$Vi(J, g, h, f, b);
                        $778cb9e25548f7d6$var$Jg($778cb9e25548f7d6$var$Ji(k, h));
                        break a;
                    }
                }
                f = k = $778cb9e25548f7d6$var$Ji(k, h);
                4 !== $778cb9e25548f7d6$var$T && ($778cb9e25548f7d6$var$T = 2);
                null === $778cb9e25548f7d6$var$sk ? $778cb9e25548f7d6$var$sk = [
                    f
                ] : $778cb9e25548f7d6$var$sk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $778cb9e25548f7d6$var$Ni(f, k, b);
                            $778cb9e25548f7d6$var$ph(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $778cb9e25548f7d6$var$Ri || !$778cb9e25548f7d6$var$Ri.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $778cb9e25548f7d6$var$Qi(f, h, b);
                                $778cb9e25548f7d6$var$ph(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $778cb9e25548f7d6$var$Sk(c);
        } catch (na) {
            b = na;
            $778cb9e25548f7d6$var$Y === c && null !== c && ($778cb9e25548f7d6$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $778cb9e25548f7d6$var$Jk() {
    var a = $778cb9e25548f7d6$var$mk.current;
    $778cb9e25548f7d6$var$mk.current = $778cb9e25548f7d6$var$Rh;
    return null === a ? $778cb9e25548f7d6$var$Rh : a;
}
function $778cb9e25548f7d6$var$tj() {
    if (0 === $778cb9e25548f7d6$var$T || 3 === $778cb9e25548f7d6$var$T || 2 === $778cb9e25548f7d6$var$T) $778cb9e25548f7d6$var$T = 4;
    null === $778cb9e25548f7d6$var$Q || 0 === ($778cb9e25548f7d6$var$rh & 268435455) && 0 === ($778cb9e25548f7d6$var$qk & 268435455) || $778cb9e25548f7d6$var$Ck($778cb9e25548f7d6$var$Q, $778cb9e25548f7d6$var$Z);
}
function $778cb9e25548f7d6$var$Ik(a, b) {
    var c = $778cb9e25548f7d6$var$K;
    $778cb9e25548f7d6$var$K |= 2;
    var d = $778cb9e25548f7d6$var$Jk();
    if ($778cb9e25548f7d6$var$Q !== a || $778cb9e25548f7d6$var$Z !== b) $778cb9e25548f7d6$var$uk = null, $778cb9e25548f7d6$var$Kk(a, b);
    for(;;)try {
        $778cb9e25548f7d6$var$Tk();
        break;
    } catch (e) {
        $778cb9e25548f7d6$var$Mk(a, e);
    }
    $778cb9e25548f7d6$var$$g();
    $778cb9e25548f7d6$var$K = c;
    $778cb9e25548f7d6$var$mk.current = d;
    if (null !== $778cb9e25548f7d6$var$Y) throw Error($778cb9e25548f7d6$var$p(261));
    $778cb9e25548f7d6$var$Q = null;
    $778cb9e25548f7d6$var$Z = 0;
    return $778cb9e25548f7d6$var$T;
}
function $778cb9e25548f7d6$var$Tk() {
    for(; null !== $778cb9e25548f7d6$var$Y;)$778cb9e25548f7d6$var$Uk($778cb9e25548f7d6$var$Y);
}
function $778cb9e25548f7d6$var$Lk() {
    for(; null !== $778cb9e25548f7d6$var$Y && !$778cb9e25548f7d6$var$cc();)$778cb9e25548f7d6$var$Uk($778cb9e25548f7d6$var$Y);
}
function $778cb9e25548f7d6$var$Uk(a) {
    var b = $778cb9e25548f7d6$var$Vk(a.alternate, a, $778cb9e25548f7d6$var$fj);
    a.memoizedProps = a.pendingProps;
    null === b ? $778cb9e25548f7d6$var$Sk(a) : $778cb9e25548f7d6$var$Y = b;
    $778cb9e25548f7d6$var$nk.current = null;
}
function $778cb9e25548f7d6$var$Sk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $778cb9e25548f7d6$var$Ej(c, b, $778cb9e25548f7d6$var$fj), null !== c) {
                $778cb9e25548f7d6$var$Y = c;
                return;
            }
        } else {
            c = $778cb9e25548f7d6$var$Ij(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $778cb9e25548f7d6$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $778cb9e25548f7d6$var$T = 6;
                $778cb9e25548f7d6$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $778cb9e25548f7d6$var$Y = b;
            return;
        }
        $778cb9e25548f7d6$var$Y = b = a;
    }while (null !== b);
    0 === $778cb9e25548f7d6$var$T && ($778cb9e25548f7d6$var$T = 5);
}
function $778cb9e25548f7d6$var$Pk(a, b, c) {
    var d = $778cb9e25548f7d6$var$C, e = $778cb9e25548f7d6$var$ok.transition;
    try {
        $778cb9e25548f7d6$var$ok.transition = null, $778cb9e25548f7d6$var$C = 1, $778cb9e25548f7d6$var$Wk(a, b, c, d);
    } finally{
        $778cb9e25548f7d6$var$ok.transition = e, $778cb9e25548f7d6$var$C = d;
    }
    return null;
}
function $778cb9e25548f7d6$var$Wk(a, b, c, d) {
    do $778cb9e25548f7d6$var$Hk();
    while (null !== $778cb9e25548f7d6$var$wk);
    if (0 !== ($778cb9e25548f7d6$var$K & 6)) throw Error($778cb9e25548f7d6$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($778cb9e25548f7d6$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $778cb9e25548f7d6$var$Bc(a, f);
    a === $778cb9e25548f7d6$var$Q && ($778cb9e25548f7d6$var$Y = $778cb9e25548f7d6$var$Q = null, $778cb9e25548f7d6$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $778cb9e25548f7d6$var$vk || ($778cb9e25548f7d6$var$vk = !0, $778cb9e25548f7d6$var$Fk($778cb9e25548f7d6$var$hc, function() {
        $778cb9e25548f7d6$var$Hk();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $778cb9e25548f7d6$var$ok.transition;
        $778cb9e25548f7d6$var$ok.transition = null;
        var g = $778cb9e25548f7d6$var$C;
        $778cb9e25548f7d6$var$C = 1;
        var h = $778cb9e25548f7d6$var$K;
        $778cb9e25548f7d6$var$K |= 4;
        $778cb9e25548f7d6$var$nk.current = null;
        $778cb9e25548f7d6$var$Oj(a, c);
        $778cb9e25548f7d6$var$dk(c, a);
        $778cb9e25548f7d6$var$Oe($778cb9e25548f7d6$var$Df);
        $778cb9e25548f7d6$var$dd = !!$778cb9e25548f7d6$var$Cf;
        $778cb9e25548f7d6$var$Df = $778cb9e25548f7d6$var$Cf = null;
        a.current = c;
        $778cb9e25548f7d6$var$hk(c, a, e);
        $778cb9e25548f7d6$var$dc();
        $778cb9e25548f7d6$var$K = h;
        $778cb9e25548f7d6$var$C = g;
        $778cb9e25548f7d6$var$ok.transition = f;
    } else a.current = c;
    $778cb9e25548f7d6$var$vk && ($778cb9e25548f7d6$var$vk = !1, $778cb9e25548f7d6$var$wk = a, $778cb9e25548f7d6$var$xk = e);
    f = a.pendingLanes;
    0 === f && ($778cb9e25548f7d6$var$Ri = null);
    $778cb9e25548f7d6$var$mc(c.stateNode, d);
    $778cb9e25548f7d6$var$Dk(a, $778cb9e25548f7d6$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($778cb9e25548f7d6$var$Oi) throw $778cb9e25548f7d6$var$Oi = !1, a = $778cb9e25548f7d6$var$Pi, $778cb9e25548f7d6$var$Pi = null, a;
    0 !== ($778cb9e25548f7d6$var$xk & 1) && 0 !== a.tag && $778cb9e25548f7d6$var$Hk();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $778cb9e25548f7d6$var$zk ? $778cb9e25548f7d6$var$yk++ : ($778cb9e25548f7d6$var$yk = 0, $778cb9e25548f7d6$var$zk = a) : $778cb9e25548f7d6$var$yk = 0;
    $778cb9e25548f7d6$var$jg();
    return null;
}
function $778cb9e25548f7d6$var$Hk() {
    if (null !== $778cb9e25548f7d6$var$wk) {
        var a = $778cb9e25548f7d6$var$Dc($778cb9e25548f7d6$var$xk), b = $778cb9e25548f7d6$var$ok.transition, c = $778cb9e25548f7d6$var$C;
        try {
            $778cb9e25548f7d6$var$ok.transition = null;
            $778cb9e25548f7d6$var$C = 16 > a ? 16 : a;
            if (null === $778cb9e25548f7d6$var$wk) var d = !1;
            else {
                a = $778cb9e25548f7d6$var$wk;
                $778cb9e25548f7d6$var$wk = null;
                $778cb9e25548f7d6$var$xk = 0;
                if (0 !== ($778cb9e25548f7d6$var$K & 6)) throw Error($778cb9e25548f7d6$var$p(331));
                var e = $778cb9e25548f7d6$var$K;
                $778cb9e25548f7d6$var$K |= 4;
                for($778cb9e25548f7d6$var$V = a.current; null !== $778cb9e25548f7d6$var$V;){
                    var f = $778cb9e25548f7d6$var$V, g = f.child;
                    if (0 !== ($778cb9e25548f7d6$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($778cb9e25548f7d6$var$V = l; null !== $778cb9e25548f7d6$var$V;){
                                    var m = $778cb9e25548f7d6$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $778cb9e25548f7d6$var$Pj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $778cb9e25548f7d6$var$V = q;
                                    else for(; null !== $778cb9e25548f7d6$var$V;){
                                        m = $778cb9e25548f7d6$var$V;
                                        var r = m.sibling, y = m.return;
                                        $778cb9e25548f7d6$var$Sj(m);
                                        if (m === l) {
                                            $778cb9e25548f7d6$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $778cb9e25548f7d6$var$V = r;
                                            break;
                                        }
                                        $778cb9e25548f7d6$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $778cb9e25548f7d6$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $778cb9e25548f7d6$var$V = g;
                    else b: for(; null !== $778cb9e25548f7d6$var$V;){
                        f = $778cb9e25548f7d6$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $778cb9e25548f7d6$var$Pj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $778cb9e25548f7d6$var$V = x;
                            break b;
                        }
                        $778cb9e25548f7d6$var$V = f.return;
                    }
                }
                var w = a.current;
                for($778cb9e25548f7d6$var$V = w; null !== $778cb9e25548f7d6$var$V;){
                    g = $778cb9e25548f7d6$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $778cb9e25548f7d6$var$V = u;
                    else b: for(g = w; null !== $778cb9e25548f7d6$var$V;){
                        h = $778cb9e25548f7d6$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $778cb9e25548f7d6$var$Qj(9, h);
                            }
                        } catch (na) {
                            $778cb9e25548f7d6$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $778cb9e25548f7d6$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $778cb9e25548f7d6$var$V = F;
                            break b;
                        }
                        $778cb9e25548f7d6$var$V = h.return;
                    }
                }
                $778cb9e25548f7d6$var$K = e;
                $778cb9e25548f7d6$var$jg();
                if ($778cb9e25548f7d6$var$lc && "function" === typeof $778cb9e25548f7d6$var$lc.onPostCommitFiberRoot) try {
                    $778cb9e25548f7d6$var$lc.onPostCommitFiberRoot($778cb9e25548f7d6$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $778cb9e25548f7d6$var$C = c, $778cb9e25548f7d6$var$ok.transition = b;
        }
    }
    return !1;
}
function $778cb9e25548f7d6$var$Xk(a, b, c) {
    b = $778cb9e25548f7d6$var$Ji(c, b);
    b = $778cb9e25548f7d6$var$Ni(a, b, 1);
    a = $778cb9e25548f7d6$var$nh(a, b, 1);
    b = $778cb9e25548f7d6$var$R();
    null !== a && ($778cb9e25548f7d6$var$Ac(a, 1, b), $778cb9e25548f7d6$var$Dk(a, b));
}
function $778cb9e25548f7d6$var$W(a, b, c) {
    if (3 === a.tag) $778cb9e25548f7d6$var$Xk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $778cb9e25548f7d6$var$Xk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $778cb9e25548f7d6$var$Ri || !$778cb9e25548f7d6$var$Ri.has(d))) {
                a = $778cb9e25548f7d6$var$Ji(c, a);
                a = $778cb9e25548f7d6$var$Qi(b, a, 1);
                b = $778cb9e25548f7d6$var$nh(b, a, 1);
                a = $778cb9e25548f7d6$var$R();
                null !== b && ($778cb9e25548f7d6$var$Ac(b, 1, a), $778cb9e25548f7d6$var$Dk(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $778cb9e25548f7d6$var$Ti(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $778cb9e25548f7d6$var$R();
    a.pingedLanes |= a.suspendedLanes & c;
    $778cb9e25548f7d6$var$Q === a && ($778cb9e25548f7d6$var$Z & c) === c && (4 === $778cb9e25548f7d6$var$T || 3 === $778cb9e25548f7d6$var$T && ($778cb9e25548f7d6$var$Z & 130023424) === $778cb9e25548f7d6$var$Z && 500 > $778cb9e25548f7d6$var$B() - $778cb9e25548f7d6$var$fk ? $778cb9e25548f7d6$var$Kk(a, 0) : $778cb9e25548f7d6$var$rk |= c);
    $778cb9e25548f7d6$var$Dk(a, b);
}
function $778cb9e25548f7d6$var$Yk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $778cb9e25548f7d6$var$sc, $778cb9e25548f7d6$var$sc <<= 1, 0 === ($778cb9e25548f7d6$var$sc & 130023424) && ($778cb9e25548f7d6$var$sc = 4194304)));
    var c = $778cb9e25548f7d6$var$R();
    a = $778cb9e25548f7d6$var$ih(a, b);
    null !== a && ($778cb9e25548f7d6$var$Ac(a, b, c), $778cb9e25548f7d6$var$Dk(a, c));
}
function $778cb9e25548f7d6$var$uj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $778cb9e25548f7d6$var$Yk(a, c);
}
function $778cb9e25548f7d6$var$bk(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($778cb9e25548f7d6$var$p(314));
    }
    null !== d && d.delete(b);
    $778cb9e25548f7d6$var$Yk(a, c);
}
var $778cb9e25548f7d6$var$Vk;
$778cb9e25548f7d6$var$Vk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $778cb9e25548f7d6$var$Wf.current) $778cb9e25548f7d6$var$dh = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $778cb9e25548f7d6$var$dh = !1, $778cb9e25548f7d6$var$yj(a, b, c);
            $778cb9e25548f7d6$var$dh = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $778cb9e25548f7d6$var$dh = !1, $778cb9e25548f7d6$var$I && 0 !== (b.flags & 1048576) && $778cb9e25548f7d6$var$ug(b, $778cb9e25548f7d6$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $778cb9e25548f7d6$var$ij(a, b);
            a = b.pendingProps;
            var e = $778cb9e25548f7d6$var$Yf(b, $778cb9e25548f7d6$var$H.current);
            $778cb9e25548f7d6$var$ch(b, c);
            e = $778cb9e25548f7d6$var$Nh(null, b, d, a, e, c);
            var f = $778cb9e25548f7d6$var$Sh();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $778cb9e25548f7d6$var$Zf(d) ? (f = !0, $778cb9e25548f7d6$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $778cb9e25548f7d6$var$kh(b), e.updater = $778cb9e25548f7d6$var$Ei, b.stateNode = e, e._reactInternals = b, $778cb9e25548f7d6$var$Ii(b, d, a, c), b = $778cb9e25548f7d6$var$jj(null, b, d, !0, f, c)) : (b.tag = 0, $778cb9e25548f7d6$var$I && f && $778cb9e25548f7d6$var$vg(b), $778cb9e25548f7d6$var$Xi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $778cb9e25548f7d6$var$ij(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $778cb9e25548f7d6$var$Zk(d);
                a = $778cb9e25548f7d6$var$Ci(d, a);
                switch(e){
                    case 0:
                        b = $778cb9e25548f7d6$var$cj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $778cb9e25548f7d6$var$hj(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $778cb9e25548f7d6$var$Yi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $778cb9e25548f7d6$var$$i(null, b, d, $778cb9e25548f7d6$var$Ci(d.type, a), c);
                        break a;
                }
                throw Error($778cb9e25548f7d6$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $778cb9e25548f7d6$var$Ci(d, e), $778cb9e25548f7d6$var$cj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $778cb9e25548f7d6$var$Ci(d, e), $778cb9e25548f7d6$var$hj(a, b, d, e, c);
        case 3:
            a: {
                $778cb9e25548f7d6$var$kj(b);
                if (null === a) throw Error($778cb9e25548f7d6$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $778cb9e25548f7d6$var$lh(a, b);
                $778cb9e25548f7d6$var$qh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $778cb9e25548f7d6$var$Ji(Error($778cb9e25548f7d6$var$p(423)), b);
                        b = $778cb9e25548f7d6$var$lj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $778cb9e25548f7d6$var$Ji(Error($778cb9e25548f7d6$var$p(424)), b);
                        b = $778cb9e25548f7d6$var$lj(a, b, d, c, e);
                        break a;
                    } else for($778cb9e25548f7d6$var$yg = $778cb9e25548f7d6$var$Lf(b.stateNode.containerInfo.firstChild), $778cb9e25548f7d6$var$xg = b, $778cb9e25548f7d6$var$I = !0, $778cb9e25548f7d6$var$zg = null, c = $778cb9e25548f7d6$var$Vg(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $778cb9e25548f7d6$var$Ig();
                    if (d === e) {
                        b = $778cb9e25548f7d6$var$Zi(a, b, c);
                        break a;
                    }
                    $778cb9e25548f7d6$var$Xi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $778cb9e25548f7d6$var$Ah(b), null === a && $778cb9e25548f7d6$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $778cb9e25548f7d6$var$Ef(d, e) ? g = null : null !== f && $778cb9e25548f7d6$var$Ef(d, f) && (b.flags |= 32), $778cb9e25548f7d6$var$gj(a, b), $778cb9e25548f7d6$var$Xi(a, b, g, c), b.child;
        case 6:
            return null === a && $778cb9e25548f7d6$var$Eg(b), null;
        case 13:
            return $778cb9e25548f7d6$var$oj(a, b, c);
        case 4:
            return $778cb9e25548f7d6$var$yh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $778cb9e25548f7d6$var$Ug(b, null, d, c) : $778cb9e25548f7d6$var$Xi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $778cb9e25548f7d6$var$Ci(d, e), $778cb9e25548f7d6$var$Yi(a, b, d, e, c);
        case 7:
            return $778cb9e25548f7d6$var$Xi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $778cb9e25548f7d6$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $778cb9e25548f7d6$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $778cb9e25548f7d6$var$G($778cb9e25548f7d6$var$Wg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($778cb9e25548f7d6$var$He(f.value, g)) {
                        if (f.children === e.children && !$778cb9e25548f7d6$var$Wf.current) {
                            b = $778cb9e25548f7d6$var$Zi(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $778cb9e25548f7d6$var$mh(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $778cb9e25548f7d6$var$bh(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($778cb9e25548f7d6$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $778cb9e25548f7d6$var$bh(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $778cb9e25548f7d6$var$Xi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $778cb9e25548f7d6$var$ch(b, c), e = $778cb9e25548f7d6$var$eh(e), d = d(e), b.flags |= 1, $778cb9e25548f7d6$var$Xi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $778cb9e25548f7d6$var$Ci(d, b.pendingProps), e = $778cb9e25548f7d6$var$Ci(d.type, e), $778cb9e25548f7d6$var$$i(a, b, d, e, c);
        case 15:
            return $778cb9e25548f7d6$var$bj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $778cb9e25548f7d6$var$Ci(d, e), $778cb9e25548f7d6$var$ij(a, b), b.tag = 1, $778cb9e25548f7d6$var$Zf(d) ? (a = !0, $778cb9e25548f7d6$var$cg(b)) : a = !1, $778cb9e25548f7d6$var$ch(b, c), $778cb9e25548f7d6$var$Gi(b, d, e), $778cb9e25548f7d6$var$Ii(b, d, e, c), $778cb9e25548f7d6$var$jj(null, b, d, !0, a, c);
        case 19:
            return $778cb9e25548f7d6$var$xj(a, b, c);
        case 22:
            return $778cb9e25548f7d6$var$dj(a, b, c);
    }
    throw Error($778cb9e25548f7d6$var$p(156, b.tag));
};
function $778cb9e25548f7d6$var$Fk(a, b) {
    return $778cb9e25548f7d6$var$ac(a, b);
}
function $778cb9e25548f7d6$var$$k(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $778cb9e25548f7d6$var$Bg(a, b, c, d) {
    return new $778cb9e25548f7d6$var$$k(a, b, c, d);
}
function $778cb9e25548f7d6$var$aj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $778cb9e25548f7d6$var$Zk(a) {
    if ("function" === typeof a) return $778cb9e25548f7d6$var$aj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $778cb9e25548f7d6$var$Da) return 11;
        if (a === $778cb9e25548f7d6$var$Ga) return 14;
    }
    return 2;
}
function $778cb9e25548f7d6$var$Pg(a, b) {
    var c = a.alternate;
    null === c ? (c = $778cb9e25548f7d6$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $778cb9e25548f7d6$var$Rg(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $778cb9e25548f7d6$var$aj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $778cb9e25548f7d6$var$ya:
            return $778cb9e25548f7d6$var$Tg(c.children, e, f, b);
        case $778cb9e25548f7d6$var$za:
            g = 8;
            e |= 8;
            break;
        case $778cb9e25548f7d6$var$Aa:
            return a = $778cb9e25548f7d6$var$Bg(12, c, b, e | 2), a.elementType = $778cb9e25548f7d6$var$Aa, a.lanes = f, a;
        case $778cb9e25548f7d6$var$Ea:
            return a = $778cb9e25548f7d6$var$Bg(13, c, b, e), a.elementType = $778cb9e25548f7d6$var$Ea, a.lanes = f, a;
        case $778cb9e25548f7d6$var$Fa:
            return a = $778cb9e25548f7d6$var$Bg(19, c, b, e), a.elementType = $778cb9e25548f7d6$var$Fa, a.lanes = f, a;
        case $778cb9e25548f7d6$var$Ia:
            return $778cb9e25548f7d6$var$pj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $778cb9e25548f7d6$var$Ba:
                    g = 10;
                    break a;
                case $778cb9e25548f7d6$var$Ca:
                    g = 9;
                    break a;
                case $778cb9e25548f7d6$var$Da:
                    g = 11;
                    break a;
                case $778cb9e25548f7d6$var$Ga:
                    g = 14;
                    break a;
                case $778cb9e25548f7d6$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($778cb9e25548f7d6$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $778cb9e25548f7d6$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $778cb9e25548f7d6$var$Tg(a, b, c, d) {
    a = $778cb9e25548f7d6$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $778cb9e25548f7d6$var$pj(a, b, c, d) {
    a = $778cb9e25548f7d6$var$Bg(22, a, d, b);
    a.elementType = $778cb9e25548f7d6$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $778cb9e25548f7d6$var$Qg(a, b, c) {
    a = $778cb9e25548f7d6$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $778cb9e25548f7d6$var$Sg(a, b, c) {
    b = $778cb9e25548f7d6$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $778cb9e25548f7d6$var$al(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $778cb9e25548f7d6$var$zc(0);
    this.expirationTimes = $778cb9e25548f7d6$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $778cb9e25548f7d6$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $778cb9e25548f7d6$var$bl(a, b, c, d, e, f, g, h, k) {
    a = new $778cb9e25548f7d6$var$al(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $778cb9e25548f7d6$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $778cb9e25548f7d6$var$kh(f);
    return a;
}
function $778cb9e25548f7d6$var$cl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $778cb9e25548f7d6$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $778cb9e25548f7d6$var$dl(a) {
    if (!a) return $778cb9e25548f7d6$var$Vf;
    a = a._reactInternals;
    a: {
        if ($778cb9e25548f7d6$var$Vb(a) !== a || 1 !== a.tag) throw Error($778cb9e25548f7d6$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($778cb9e25548f7d6$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($778cb9e25548f7d6$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($778cb9e25548f7d6$var$Zf(c)) return $778cb9e25548f7d6$var$bg(a, c, b);
    }
    return b;
}
function $778cb9e25548f7d6$var$el(a, b, c, d, e, f, g, h, k) {
    a = $778cb9e25548f7d6$var$bl(c, d, !0, a, e, f, g, h, k);
    a.context = $778cb9e25548f7d6$var$dl(null);
    c = a.current;
    d = $778cb9e25548f7d6$var$R();
    e = $778cb9e25548f7d6$var$yi(c);
    f = $778cb9e25548f7d6$var$mh(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $778cb9e25548f7d6$var$nh(c, f, e);
    a.current.lanes = e;
    $778cb9e25548f7d6$var$Ac(a, e, d);
    $778cb9e25548f7d6$var$Dk(a, d);
    return a;
}
function $778cb9e25548f7d6$var$fl(a, b, c, d) {
    var e = b.current, f = $778cb9e25548f7d6$var$R(), g = $778cb9e25548f7d6$var$yi(e);
    c = $778cb9e25548f7d6$var$dl(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $778cb9e25548f7d6$var$mh(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $778cb9e25548f7d6$var$nh(e, b, g);
    null !== a && ($778cb9e25548f7d6$var$gi(a, e, g, f), $778cb9e25548f7d6$var$oh(a, e, g));
    return g;
}
function $778cb9e25548f7d6$var$gl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $778cb9e25548f7d6$var$hl(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $778cb9e25548f7d6$var$il(a, b) {
    $778cb9e25548f7d6$var$hl(a, b);
    (a = a.alternate) && $778cb9e25548f7d6$var$hl(a, b);
}
function $778cb9e25548f7d6$var$jl() {
    return null;
}
var $778cb9e25548f7d6$var$kl = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $778cb9e25548f7d6$var$ll(a) {
    this._internalRoot = a;
}
$778cb9e25548f7d6$var$ml.prototype.render = $778cb9e25548f7d6$var$ll.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($778cb9e25548f7d6$var$p(409));
    $778cb9e25548f7d6$var$fl(a, b, null, null);
};
$778cb9e25548f7d6$var$ml.prototype.unmount = $778cb9e25548f7d6$var$ll.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $778cb9e25548f7d6$var$Rk(function() {
            $778cb9e25548f7d6$var$fl(null, a, null, null);
        });
        b[$778cb9e25548f7d6$var$uf] = null;
    }
};
function $778cb9e25548f7d6$var$ml(a) {
    this._internalRoot = a;
}
$778cb9e25548f7d6$var$ml.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $778cb9e25548f7d6$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $778cb9e25548f7d6$var$Qc.length && 0 !== b && b < $778cb9e25548f7d6$var$Qc[c].priority; c++);
        $778cb9e25548f7d6$var$Qc.splice(c, 0, a);
        0 === c && $778cb9e25548f7d6$var$Vc(a);
    }
};
function $778cb9e25548f7d6$var$nl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $778cb9e25548f7d6$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $778cb9e25548f7d6$var$pl() {}
function $778cb9e25548f7d6$var$ql(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $778cb9e25548f7d6$var$gl(g);
                f.call(a);
            };
        }
        var g = $778cb9e25548f7d6$var$el(b, d, a, 0, null, !1, !1, "", $778cb9e25548f7d6$var$pl);
        a._reactRootContainer = g;
        a[$778cb9e25548f7d6$var$uf] = g.current;
        $778cb9e25548f7d6$var$sf(8 === a.nodeType ? a.parentNode : a);
        $778cb9e25548f7d6$var$Rk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $778cb9e25548f7d6$var$gl(k);
            h.call(a);
        };
    }
    var k = $778cb9e25548f7d6$var$bl(a, 0, !1, null, null, !1, !1, "", $778cb9e25548f7d6$var$pl);
    a._reactRootContainer = k;
    a[$778cb9e25548f7d6$var$uf] = k.current;
    $778cb9e25548f7d6$var$sf(8 === a.nodeType ? a.parentNode : a);
    $778cb9e25548f7d6$var$Rk(function() {
        $778cb9e25548f7d6$var$fl(b, k, c, d);
    });
    return k;
}
function $778cb9e25548f7d6$var$rl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $778cb9e25548f7d6$var$gl(g);
                h.call(a);
            };
        }
        $778cb9e25548f7d6$var$fl(b, g, a, e);
    } else g = $778cb9e25548f7d6$var$ql(c, b, a, e, d);
    return $778cb9e25548f7d6$var$gl(g);
}
$778cb9e25548f7d6$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $778cb9e25548f7d6$var$tc(b.pendingLanes);
                0 !== c && ($778cb9e25548f7d6$var$Cc(b, c | 1), $778cb9e25548f7d6$var$Dk(b, $778cb9e25548f7d6$var$B()), 0 === ($778cb9e25548f7d6$var$K & 6) && ($778cb9e25548f7d6$var$Gj = $778cb9e25548f7d6$var$B() + 500, $778cb9e25548f7d6$var$jg()));
            }
            break;
        case 13:
            $778cb9e25548f7d6$var$Rk(function() {
                var b = $778cb9e25548f7d6$var$ih(a, 1);
                if (null !== b) {
                    var c = $778cb9e25548f7d6$var$R();
                    $778cb9e25548f7d6$var$gi(b, a, 1, c);
                }
            }), $778cb9e25548f7d6$var$il(a, 1);
    }
};
$778cb9e25548f7d6$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $778cb9e25548f7d6$var$ih(a, 134217728);
        if (null !== b) {
            var c = $778cb9e25548f7d6$var$R();
            $778cb9e25548f7d6$var$gi(b, a, 134217728, c);
        }
        $778cb9e25548f7d6$var$il(a, 134217728);
    }
};
$778cb9e25548f7d6$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $778cb9e25548f7d6$var$yi(a), c = $778cb9e25548f7d6$var$ih(a, b);
        if (null !== c) {
            var d = $778cb9e25548f7d6$var$R();
            $778cb9e25548f7d6$var$gi(c, a, b, d);
        }
        $778cb9e25548f7d6$var$il(a, b);
    }
};
$778cb9e25548f7d6$var$Hc = function() {
    return $778cb9e25548f7d6$var$C;
};
$778cb9e25548f7d6$var$Ic = function(a, b) {
    var c = $778cb9e25548f7d6$var$C;
    try {
        return $778cb9e25548f7d6$var$C = a, b();
    } finally{
        $778cb9e25548f7d6$var$C = c;
    }
};
$778cb9e25548f7d6$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $778cb9e25548f7d6$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $778cb9e25548f7d6$var$Db(d);
                        if (!e) throw Error($778cb9e25548f7d6$var$p(90));
                        $778cb9e25548f7d6$var$Wa(d);
                        $778cb9e25548f7d6$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $778cb9e25548f7d6$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $778cb9e25548f7d6$var$fb(a, !!c.multiple, b, !1);
    }
};
$778cb9e25548f7d6$var$Gb = $778cb9e25548f7d6$var$Qk;
$778cb9e25548f7d6$var$Hb = $778cb9e25548f7d6$var$Rk;
var $778cb9e25548f7d6$var$sl = {
    usingClientEntryPoint: !1,
    Events: [
        $778cb9e25548f7d6$var$Cb,
        $778cb9e25548f7d6$var$ue,
        $778cb9e25548f7d6$var$Db,
        $778cb9e25548f7d6$var$Eb,
        $778cb9e25548f7d6$var$Fb,
        $778cb9e25548f7d6$var$Qk
    ]
}, $778cb9e25548f7d6$var$tl = {
    findFiberByHostInstance: $778cb9e25548f7d6$var$Wc,
    bundleType: 0,
    version: "18.3.1",
    rendererPackageName: "react-dom"
};
var $778cb9e25548f7d6$var$ul = {
    bundleType: $778cb9e25548f7d6$var$tl.bundleType,
    version: $778cb9e25548f7d6$var$tl.version,
    rendererPackageName: $778cb9e25548f7d6$var$tl.rendererPackageName,
    rendererConfig: $778cb9e25548f7d6$var$tl.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $778cb9e25548f7d6$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $778cb9e25548f7d6$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $778cb9e25548f7d6$var$tl.findFiberByHostInstance || $778cb9e25548f7d6$var$jl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.3.1-next-f1338f8080-20240426"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $778cb9e25548f7d6$var$vl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$778cb9e25548f7d6$var$vl.isDisabled && $778cb9e25548f7d6$var$vl.supportsFiber) try {
        $778cb9e25548f7d6$var$kc = $778cb9e25548f7d6$var$vl.inject($778cb9e25548f7d6$var$ul), $778cb9e25548f7d6$var$lc = $778cb9e25548f7d6$var$vl;
    } catch (a) {}
}
$778cb9e25548f7d6$export$ae55be85d98224ed = $778cb9e25548f7d6$var$sl;
$778cb9e25548f7d6$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$778cb9e25548f7d6$var$nl(b)) throw Error($778cb9e25548f7d6$var$p(200));
    return $778cb9e25548f7d6$var$cl(a, b, null, c);
};
$778cb9e25548f7d6$export$882461b6382ed46c = function(a, b) {
    if (!$778cb9e25548f7d6$var$nl(a)) throw Error($778cb9e25548f7d6$var$p(299));
    var c = !1, d = "", e = $778cb9e25548f7d6$var$kl;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $778cb9e25548f7d6$var$bl(a, 1, !1, null, null, c, !1, d, e);
    a[$778cb9e25548f7d6$var$uf] = b.current;
    $778cb9e25548f7d6$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $778cb9e25548f7d6$var$ll(b);
};
$778cb9e25548f7d6$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($778cb9e25548f7d6$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($778cb9e25548f7d6$var$p(268, a));
    }
    a = $778cb9e25548f7d6$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$778cb9e25548f7d6$export$cd75ccfd720a3cd4 = function(a) {
    return $778cb9e25548f7d6$var$Rk(a);
};
$778cb9e25548f7d6$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$778cb9e25548f7d6$var$ol(b)) throw Error($778cb9e25548f7d6$var$p(200));
    return $778cb9e25548f7d6$var$rl(null, a, b, !0, c);
};
$778cb9e25548f7d6$export$757ceba2d55c277e = function(a, b, c) {
    if (!$778cb9e25548f7d6$var$nl(a)) throw Error($778cb9e25548f7d6$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $778cb9e25548f7d6$var$kl;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $778cb9e25548f7d6$var$el(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$778cb9e25548f7d6$var$uf] = b.current;
    $778cb9e25548f7d6$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $778cb9e25548f7d6$var$ml(b);
};
$778cb9e25548f7d6$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$778cb9e25548f7d6$var$ol(b)) throw Error($778cb9e25548f7d6$var$p(200));
    return $778cb9e25548f7d6$var$rl(null, a, b, !1, c);
};
$778cb9e25548f7d6$export$502457920280e6be = function(a) {
    if (!$778cb9e25548f7d6$var$ol(a)) throw Error($778cb9e25548f7d6$var$p(40));
    return a._reactRootContainer ? ($778cb9e25548f7d6$var$Rk(function() {
        $778cb9e25548f7d6$var$rl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$778cb9e25548f7d6$var$uf] = null;
        });
    }), !0) : !1;
};
$778cb9e25548f7d6$export$c78a37762a8d58e1 = $778cb9e25548f7d6$var$Qk;
$778cb9e25548f7d6$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$778cb9e25548f7d6$var$ol(c)) throw Error($778cb9e25548f7d6$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($778cb9e25548f7d6$var$p(38));
    return $778cb9e25548f7d6$var$rl(a, b, c, !1, d);
};
$778cb9e25548f7d6$export$83d89fbfd8236492 = "18.3.1-next-f1338f8080-20240426";

});
parcelRegister("6zU53", function(module, exports) {
"use strict";

module.exports = (parcelRequire("7sQDP"));

});
parcelRegister("7sQDP", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $56f3fb6404565e1e$export$c4744153514ff05d; }, function (v) { return $56f3fb6404565e1e$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $56f3fb6404565e1e$export$3e506c1ccc9cc1a7; }, function (v) { return $56f3fb6404565e1e$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $56f3fb6404565e1e$export$e26fe2ed2fa76875; }, function (v) { return $56f3fb6404565e1e$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $56f3fb6404565e1e$export$502329bbf4b505b1; }, function (v) { return $56f3fb6404565e1e$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $56f3fb6404565e1e$export$6e3807111c4874c4; }, function (v) { return $56f3fb6404565e1e$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $56f3fb6404565e1e$export$c27134553091fb3a; }, function (v) { return $56f3fb6404565e1e$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $56f3fb6404565e1e$export$33ee1acdc04fd2a2; }, function (v) { return $56f3fb6404565e1e$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $56f3fb6404565e1e$export$b00a404bbd5edef2; }, function (v) { return $56f3fb6404565e1e$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_continueExecution", function () { return $56f3fb6404565e1e$export$8352ce38b91d0c62; }, function (v) { return $56f3fb6404565e1e$export$8352ce38b91d0c62 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $56f3fb6404565e1e$export$d66a1c1c77bd778b; }, function (v) { return $56f3fb6404565e1e$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $56f3fb6404565e1e$export$d3dfb8e4810cb555; }, function (v) { return $56f3fb6404565e1e$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_getFirstCallbackNode", function () { return $56f3fb6404565e1e$export$839f9183b0465a69; }, function (v) { return $56f3fb6404565e1e$export$839f9183b0465a69 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $56f3fb6404565e1e$export$72fdf0e06517287b; }, function (v) { return $56f3fb6404565e1e$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_pauseExecution", function () { return $56f3fb6404565e1e$export$4b844e58a3e414b4; }, function (v) { return $56f3fb6404565e1e$export$4b844e58a3e414b4 = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $56f3fb6404565e1e$export$816d2913ae6b83b1; }, function (v) { return $56f3fb6404565e1e$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $56f3fb6404565e1e$export$61bcfe829111a1d0; }, function (v) { return $56f3fb6404565e1e$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $56f3fb6404565e1e$export$7ee8c9beb337bc3f; }, function (v) { return $56f3fb6404565e1e$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $56f3fb6404565e1e$export$b5836b71941fa3ed; }, function (v) { return $56f3fb6404565e1e$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $56f3fb6404565e1e$export$cf845f2c119da08a; }, function (v) { return $56f3fb6404565e1e$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $56f3fb6404565e1e$export$c4744153514ff05d;
var $56f3fb6404565e1e$export$3e506c1ccc9cc1a7;
var $56f3fb6404565e1e$export$e26fe2ed2fa76875;
var $56f3fb6404565e1e$export$502329bbf4b505b1;
var $56f3fb6404565e1e$export$6e3807111c4874c4;
var $56f3fb6404565e1e$export$c27134553091fb3a;
var $56f3fb6404565e1e$export$33ee1acdc04fd2a2;
var $56f3fb6404565e1e$export$b00a404bbd5edef2;
var $56f3fb6404565e1e$export$8352ce38b91d0c62;
var $56f3fb6404565e1e$export$d66a1c1c77bd778b;
var $56f3fb6404565e1e$export$d3dfb8e4810cb555;
var $56f3fb6404565e1e$export$839f9183b0465a69;
var $56f3fb6404565e1e$export$72fdf0e06517287b;
var $56f3fb6404565e1e$export$4b844e58a3e414b4;
var $56f3fb6404565e1e$export$816d2913ae6b83b1;
var $56f3fb6404565e1e$export$61bcfe829111a1d0;
var $56f3fb6404565e1e$export$7ee8c9beb337bc3f;
var $56f3fb6404565e1e$export$b5836b71941fa3ed;
var $56f3fb6404565e1e$export$cf845f2c119da08a;
"use strict";
function $56f3fb6404565e1e$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $56f3fb6404565e1e$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $56f3fb6404565e1e$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $56f3fb6404565e1e$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $56f3fb6404565e1e$var$g(C, c)) n < e && 0 > $56f3fb6404565e1e$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $56f3fb6404565e1e$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $56f3fb6404565e1e$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $56f3fb6404565e1e$var$l = performance;
    $56f3fb6404565e1e$export$c4744153514ff05d = function() {
        return $56f3fb6404565e1e$var$l.now();
    };
} else {
    var $56f3fb6404565e1e$var$p = Date, $56f3fb6404565e1e$var$q = $56f3fb6404565e1e$var$p.now();
    $56f3fb6404565e1e$export$c4744153514ff05d = function() {
        return $56f3fb6404565e1e$var$p.now() - $56f3fb6404565e1e$var$q;
    };
}
var $56f3fb6404565e1e$var$r = [], $56f3fb6404565e1e$var$t = [], $56f3fb6404565e1e$var$u = 1, $56f3fb6404565e1e$var$v = null, $56f3fb6404565e1e$var$y = 3, $56f3fb6404565e1e$var$z = !1, $56f3fb6404565e1e$var$A = !1, $56f3fb6404565e1e$var$B = !1, $56f3fb6404565e1e$var$D = "function" === typeof setTimeout ? setTimeout : null, $56f3fb6404565e1e$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $56f3fb6404565e1e$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $56f3fb6404565e1e$var$G(a) {
    for(var b = $56f3fb6404565e1e$var$h($56f3fb6404565e1e$var$t); null !== b;){
        if (null === b.callback) $56f3fb6404565e1e$var$k($56f3fb6404565e1e$var$t);
        else if (b.startTime <= a) $56f3fb6404565e1e$var$k($56f3fb6404565e1e$var$t), b.sortIndex = b.expirationTime, $56f3fb6404565e1e$var$f($56f3fb6404565e1e$var$r, b);
        else break;
        b = $56f3fb6404565e1e$var$h($56f3fb6404565e1e$var$t);
    }
}
function $56f3fb6404565e1e$var$H(a) {
    $56f3fb6404565e1e$var$B = !1;
    $56f3fb6404565e1e$var$G(a);
    if (!$56f3fb6404565e1e$var$A) {
        if (null !== $56f3fb6404565e1e$var$h($56f3fb6404565e1e$var$r)) $56f3fb6404565e1e$var$A = !0, $56f3fb6404565e1e$var$I($56f3fb6404565e1e$var$J);
        else {
            var b = $56f3fb6404565e1e$var$h($56f3fb6404565e1e$var$t);
            null !== b && $56f3fb6404565e1e$var$K($56f3fb6404565e1e$var$H, b.startTime - a);
        }
    }
}
function $56f3fb6404565e1e$var$J(a, b) {
    $56f3fb6404565e1e$var$A = !1;
    $56f3fb6404565e1e$var$B && ($56f3fb6404565e1e$var$B = !1, $56f3fb6404565e1e$var$E($56f3fb6404565e1e$var$L), $56f3fb6404565e1e$var$L = -1);
    $56f3fb6404565e1e$var$z = !0;
    var c = $56f3fb6404565e1e$var$y;
    try {
        $56f3fb6404565e1e$var$G(b);
        for($56f3fb6404565e1e$var$v = $56f3fb6404565e1e$var$h($56f3fb6404565e1e$var$r); null !== $56f3fb6404565e1e$var$v && (!($56f3fb6404565e1e$var$v.expirationTime > b) || a && !$56f3fb6404565e1e$var$M());){
            var d = $56f3fb6404565e1e$var$v.callback;
            if ("function" === typeof d) {
                $56f3fb6404565e1e$var$v.callback = null;
                $56f3fb6404565e1e$var$y = $56f3fb6404565e1e$var$v.priorityLevel;
                var e = d($56f3fb6404565e1e$var$v.expirationTime <= b);
                b = $56f3fb6404565e1e$export$c4744153514ff05d();
                "function" === typeof e ? $56f3fb6404565e1e$var$v.callback = e : $56f3fb6404565e1e$var$v === $56f3fb6404565e1e$var$h($56f3fb6404565e1e$var$r) && $56f3fb6404565e1e$var$k($56f3fb6404565e1e$var$r);
                $56f3fb6404565e1e$var$G(b);
            } else $56f3fb6404565e1e$var$k($56f3fb6404565e1e$var$r);
            $56f3fb6404565e1e$var$v = $56f3fb6404565e1e$var$h($56f3fb6404565e1e$var$r);
        }
        if (null !== $56f3fb6404565e1e$var$v) var w = !0;
        else {
            var m = $56f3fb6404565e1e$var$h($56f3fb6404565e1e$var$t);
            null !== m && $56f3fb6404565e1e$var$K($56f3fb6404565e1e$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $56f3fb6404565e1e$var$v = null, $56f3fb6404565e1e$var$y = c, $56f3fb6404565e1e$var$z = !1;
    }
}
var $56f3fb6404565e1e$var$N = !1, $56f3fb6404565e1e$var$O = null, $56f3fb6404565e1e$var$L = -1, $56f3fb6404565e1e$var$P = 5, $56f3fb6404565e1e$var$Q = -1;
function $56f3fb6404565e1e$var$M() {
    return $56f3fb6404565e1e$export$c4744153514ff05d() - $56f3fb6404565e1e$var$Q < $56f3fb6404565e1e$var$P ? !1 : !0;
}
function $56f3fb6404565e1e$var$R() {
    if (null !== $56f3fb6404565e1e$var$O) {
        var a = $56f3fb6404565e1e$export$c4744153514ff05d();
        $56f3fb6404565e1e$var$Q = a;
        var b = !0;
        try {
            b = $56f3fb6404565e1e$var$O(!0, a);
        } finally{
            b ? $56f3fb6404565e1e$var$S() : ($56f3fb6404565e1e$var$N = !1, $56f3fb6404565e1e$var$O = null);
        }
    } else $56f3fb6404565e1e$var$N = !1;
}
var $56f3fb6404565e1e$var$S;
if ("function" === typeof $56f3fb6404565e1e$var$F) $56f3fb6404565e1e$var$S = function() {
    $56f3fb6404565e1e$var$F($56f3fb6404565e1e$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $56f3fb6404565e1e$var$T = new MessageChannel, $56f3fb6404565e1e$var$U = $56f3fb6404565e1e$var$T.port2;
    $56f3fb6404565e1e$var$T.port1.onmessage = $56f3fb6404565e1e$var$R;
    $56f3fb6404565e1e$var$S = function() {
        $56f3fb6404565e1e$var$U.postMessage(null);
    };
} else $56f3fb6404565e1e$var$S = function() {
    $56f3fb6404565e1e$var$D($56f3fb6404565e1e$var$R, 0);
};
function $56f3fb6404565e1e$var$I(a) {
    $56f3fb6404565e1e$var$O = a;
    $56f3fb6404565e1e$var$N || ($56f3fb6404565e1e$var$N = !0, $56f3fb6404565e1e$var$S());
}
function $56f3fb6404565e1e$var$K(a, b) {
    $56f3fb6404565e1e$var$L = $56f3fb6404565e1e$var$D(function() {
        a($56f3fb6404565e1e$export$c4744153514ff05d());
    }, b);
}
$56f3fb6404565e1e$export$3e506c1ccc9cc1a7 = 5;
$56f3fb6404565e1e$export$e26fe2ed2fa76875 = 1;
$56f3fb6404565e1e$export$502329bbf4b505b1 = 4;
$56f3fb6404565e1e$export$6e3807111c4874c4 = 3;
$56f3fb6404565e1e$export$c27134553091fb3a = null;
$56f3fb6404565e1e$export$33ee1acdc04fd2a2 = 2;
$56f3fb6404565e1e$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$56f3fb6404565e1e$export$8352ce38b91d0c62 = function() {
    $56f3fb6404565e1e$var$A || $56f3fb6404565e1e$var$z || ($56f3fb6404565e1e$var$A = !0, $56f3fb6404565e1e$var$I($56f3fb6404565e1e$var$J));
};
$56f3fb6404565e1e$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $56f3fb6404565e1e$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$56f3fb6404565e1e$export$d3dfb8e4810cb555 = function() {
    return $56f3fb6404565e1e$var$y;
};
$56f3fb6404565e1e$export$839f9183b0465a69 = function() {
    return $56f3fb6404565e1e$var$h($56f3fb6404565e1e$var$r);
};
$56f3fb6404565e1e$export$72fdf0e06517287b = function(a) {
    switch($56f3fb6404565e1e$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $56f3fb6404565e1e$var$y;
    }
    var c = $56f3fb6404565e1e$var$y;
    $56f3fb6404565e1e$var$y = b;
    try {
        return a();
    } finally{
        $56f3fb6404565e1e$var$y = c;
    }
};
$56f3fb6404565e1e$export$4b844e58a3e414b4 = function() {};
$56f3fb6404565e1e$export$816d2913ae6b83b1 = function() {};
$56f3fb6404565e1e$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $56f3fb6404565e1e$var$y;
    $56f3fb6404565e1e$var$y = a;
    try {
        return b();
    } finally{
        $56f3fb6404565e1e$var$y = c;
    }
};
$56f3fb6404565e1e$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $56f3fb6404565e1e$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $56f3fb6404565e1e$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $56f3fb6404565e1e$var$f($56f3fb6404565e1e$var$t, a), null === $56f3fb6404565e1e$var$h($56f3fb6404565e1e$var$r) && a === $56f3fb6404565e1e$var$h($56f3fb6404565e1e$var$t) && ($56f3fb6404565e1e$var$B ? ($56f3fb6404565e1e$var$E($56f3fb6404565e1e$var$L), $56f3fb6404565e1e$var$L = -1) : $56f3fb6404565e1e$var$B = !0, $56f3fb6404565e1e$var$K($56f3fb6404565e1e$var$H, c - d))) : (a.sortIndex = e, $56f3fb6404565e1e$var$f($56f3fb6404565e1e$var$r, a), $56f3fb6404565e1e$var$A || $56f3fb6404565e1e$var$z || ($56f3fb6404565e1e$var$A = !0, $56f3fb6404565e1e$var$I($56f3fb6404565e1e$var$J)));
    return a;
};
$56f3fb6404565e1e$export$b5836b71941fa3ed = $56f3fb6404565e1e$var$M;
$56f3fb6404565e1e$export$cf845f2c119da08a = function(a) {
    var b = $56f3fb6404565e1e$var$y;
    return function() {
        var c = $56f3fb6404565e1e$var$y;
        $56f3fb6404565e1e$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $56f3fb6404565e1e$var$y = c;
        }
    };
};

});




parcelRegister("jShba", function(module, exports) {
$parcel$export(module.exports, "AnalyticsEventActions", function () { return (parcelRequire("fjOHq")).AnalyticsEventActions; });
$parcel$export(module.exports, "AnalyticsEventSource", function () { return (parcelRequire("fjOHq")).AnalyticsEventSource; });
$parcel$export(module.exports, "AnalyticsEventSubjects", function () { return (parcelRequire("fjOHq")).AnalyticsEventSubjects; });
$parcel$export(module.exports, "AnalyticsProvider", function () { return (parcelRequire("hYcP6")).default; });
$parcel$export(module.exports, "useAnalytics", function () { return (parcelRequire("grRLU")).default; });
$parcel$export(module.exports, "withAnalyticsContext", function () { return (parcelRequire("58n8k")).default; });
$parcel$export(module.exports, "DialogProvider", function () { return (parcelRequire("9lQ50")).default; });
$parcel$export(module.exports, "withDialogTransition", function () { return (parcelRequire("btS3G")).default; });
$parcel$export(module.exports, "DialogsProvider", function () { return (parcelRequire("9Rq8g")).default; });
$parcel$export(module.exports, "DismissibleSectionMessage", function () { return (parcelRequire("gzP7h")).DismissibleSectionMessage; });
$parcel$export(module.exports, "ApdexStart", function () { return (parcelRequire("53PE4")).default; });
$parcel$export(module.exports, "ApdexStop", function () { return (parcelRequire("zFJ4O")).default; });
$parcel$export(module.exports, "ApdexTasks", function () { return (parcelRequire("7dUzb")).ApdexTasks; });
$parcel$export(module.exports, "GenericErrorPage", function () { return (parcelRequire("7pLec")).GenericErrorPage; });
$parcel$export(module.exports, "ellipsis", function () { return (parcelRequire("edxno")).ellipsis; });
$parcel$export(module.exports, "FieldType", function () { return (parcelRequire("h1Uju")).FieldType; });

$parcel$export(module.exports, "getEnv", function () { return (parcelRequire("djcZD")).getEnv; });
$parcel$export(module.exports, "getConfig", function () { return (parcelRequire("1Bj4T")).getConfig; });
$parcel$export(module.exports, "Anchor", function () { return (parcelRequire("1UxEK")).default; });
$parcel$export(module.exports, "RecordTransition", function () { return (parcelRequire("6e62a")).default; });
$parcel$export(module.exports, "Spinner", function () { return (parcelRequire("1QRhz")).default; });
$parcel$export(module.exports, "ProductIcon", function () { return (parcelRequire("blvGL")).default; });
$parcel$export(module.exports, "InlineHelpInfoIcon", function () { return (parcelRequire("aocz5")).default; });
$parcel$export(module.exports, "ProfileDetailsInlineEdit", function () { return (parcelRequire("8hGiD")).default; });
$parcel$export(module.exports, "ProfileAvatar", function () { return (parcelRequire("8zYsB")).default; });
$parcel$export(module.exports, "FocusedTask", function () { return (parcelRequire("2MTID")).default; });
$parcel$export(module.exports, "GenericInlineDialogContent", function () { return (parcelRequire("52IGI")).default; });
$parcel$export(module.exports, "I18nProvider", function () { return (parcelRequire("l5OgO")).default; });
$parcel$export(module.exports, "installSentry", function () { return (parcelRequire("77YRX")).installSentry; });
$parcel$export(module.exports, "logErrorMessage", function () { return (parcelRequire("77YRX")).logErrorMessage; });
$parcel$export(module.exports, "logException", function () { return (parcelRequire("77YRX")).logException; });
$parcel$export(module.exports, "logInfoMessage", function () { return (parcelRequire("77YRX")).logInfoMessage; });
$parcel$export(module.exports, "requestLoginCheckOrRedirect", function () { return (parcelRequire("iyr2L")).requestLoginCheckOrRedirect; });
$parcel$export(module.exports, "getAnalyticsClient", function () { return (parcelRequire("jLJT8")).getAnalyticsClient; });
$parcel$export(module.exports, "userInfoProvider", function () { return (parcelRequire("fCHnn")).userInfoProvider; });
$parcel$export(module.exports, "identityAvailableProductsClient", function () { return (parcelRequire("9S009")).default; });
$parcel$export(module.exports, "identityUserClient", function () { return (parcelRequire("9FKx7")).default; });
$parcel$export(module.exports, "getCurrentUser", function () { return (parcelRequire("h1RRU")).getCurrentUser; });
$parcel$export(module.exports, "setTsvDisabled", function () { return (parcelRequire("h1RRU")).setTsvDisabled; });
$parcel$export(module.exports, "addFlag", function () { return (parcelRequire("3kXiv")).addFlag; });
$parcel$export(module.exports, "removeFlag", function () { return (parcelRequire("3kXiv")).removeFlag; });
$parcel$export(module.exports, "updateUserEmail", function () { return (parcelRequire("4rjyH")).updateUserEmail; });
$parcel$export(module.exports, "revertUserEmail", function () { return (parcelRequire("4rjyH")).revertUserEmail; });
$parcel$export(module.exports, "updatePassword", function () { return (parcelRequire("9b2OC")).updatePassword; });
$parcel$export(module.exports, "getConnectedApps", function () { return (parcelRequire("ekBOb")).getConnectedApps; });
$parcel$export(module.exports, "removeAccessForApp", function () { return (parcelRequire("ekBOb")).removeAccessForApp; });
$parcel$export(module.exports, "removeAccessToThirdParty", function () { return (parcelRequire("ekBOb")).removeAccessToThirdParty; });
// config and constants

var $djcZD = parcelRequire("djcZD");

var $1Bj4T = parcelRequire("1Bj4T");
parcelRequire("adUiG");
parcelRequire("gA9bO");
parcelRequire("eMPgC");
parcelRequire("6VUb9");
parcelRequire("98XV1");
parcelRequire("lX9pQ");
var $1UxEK = parcelRequire("1UxEK");
parcelRequire("klc1a");
var $6e62a = parcelRequire("6e62a");
parcelRequire("7Wy6s");
var $1QRhz = parcelRequire("1QRhz");
parcelRequire("25utc");
var $blvGL = parcelRequire("blvGL");
parcelRequire("3R11C");
var $aocz5 = parcelRequire("aocz5");
parcelRequire("9TD2F");
var $8hGiD = parcelRequire("8hGiD");
parcelRequire("jXcEr");
parcelRequire("7IGS7");
parcelRequire("7M9Ou");
var $8zYsB = parcelRequire("8zYsB");
parcelRequire("i4h1u");
var $2MTID = parcelRequire("2MTID");

var $52IGI = parcelRequire("52IGI");
parcelRequire("hKSu6");
var $l5OgO = parcelRequire("l5OgO");
parcelRequire("hIpVk");
var $agSD9 = parcelRequire("agSD9");

var $77YRX = parcelRequire("77YRX");

var $7rBBG = parcelRequire("7rBBG");

var $aTv5x = parcelRequire("aTv5x");
parcelRequire("edxno");

var $iyr2L = parcelRequire("iyr2L");

var $jLJT8 = parcelRequire("jLJT8");

var $fCHnn = parcelRequire("fCHnn");

var $9S009 = parcelRequire("9S009");

var $9FKx7 = parcelRequire("9FKx7");

var $20U8t = parcelRequire("20U8t");

var $h1RRU = parcelRequire("h1RRU");

var $3kXiv = parcelRequire("3kXiv");

var $4rjyH = parcelRequire("4rjyH");

var $9b2OC = parcelRequire("9b2OC");

var $ekBOb = parcelRequire("ekBOb");

var $eDBap = parcelRequire("eDBap");

var $cdiBL = parcelRequire("cdiBL");
parcelRequire("h1Uju");
parcelRequire("5lc1q");
parcelRequire("8Bxc9");

});
parcelRegister("adUiG", function(module, exports) {
$parcel$export(module.exports, "AnalyticsEventActions", function () { return (parcelRequire("fjOHq")).AnalyticsEventActions; });
$parcel$export(module.exports, "AnalyticsEventSource", function () { return (parcelRequire("fjOHq")).AnalyticsEventSource; });
$parcel$export(module.exports, "AnalyticsEventSubjects", function () { return (parcelRequire("fjOHq")).AnalyticsEventSubjects; });

$parcel$export(module.exports, "withAnalyticsContext", function () { return (parcelRequire("58n8k")).default; });
$parcel$export(module.exports, "AnalyticsProvider", function () { return (parcelRequire("hYcP6")).default; });
$parcel$export(module.exports, "useAnalytics", function () { return (parcelRequire("grRLU")).default; });

var $58n8k = parcelRequire("58n8k");

var $hYcP6 = parcelRequire("hYcP6");

var $4oRum = parcelRequire("4oRum");

var $grRLU = parcelRequire("grRLU");
parcelRequire("fjOHq");
parcelRequire("fwDtJ");

});
parcelRegister("58n8k", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $03962d174cbbbd72$export$2e2bcd8739ae039; });

var $bibO8 = parcelRequire("bibO8");
parcelRequire("dAx5m");

var $4oRum = parcelRequire("4oRum");
const $03962d174cbbbd72$var$withAnalyticsContext = (WrappedComponent)=>{
    const name = WrappedComponent.displayName || WrappedComponent.name || "Component";
    const WithAnalyticsContext = (props)=>{
        return /*#__PURE__*/ (0, $bibO8.jsx)((0, $4oRum.default).Consumer, {
            children: ({ analytics: analytics })=>/*#__PURE__*/ (0, $bibO8.jsx)(WrappedComponent, {
                    ...props,
                    analytics: analytics
                })
        });
    };
    WithAnalyticsContext.displayName = `withAnalytics(${name})`;
    return WithAnalyticsContext;
};
var $03962d174cbbbd72$export$2e2bcd8739ae039 = $03962d174cbbbd72$var$withAnalyticsContext;

});
parcelRegister("4oRum", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f91902615d0f382f$export$2e2bcd8739ae039; });

var $dAx5m = parcelRequire("dAx5m");

var $77YRX = parcelRequire("77YRX");

var $1QfrT = parcelRequire("1QfrT");

var $jLJT8 = parcelRequire("jLJT8");
const $f91902615d0f382f$var$defaultAnalyticsMethod = ()=>{
    // tslint:disable-next-line no-console
    console.warn("No analytics client has been provided.");
    (0, $77YRX.logInfoMessage)("Analytics Context accessed before AnalyticsClient was loaded");
};
const $f91902615d0f382f$export$7fa70eb12a96b7d1 = {
    getAnalyticsWebClient: ()=>new (0, $1QfrT.default)({
            env: "local",
            product: (0, $jLJT8.DEFAULT_PRODUCT_NAME),
            subproduct: (0, $jLJT8.DEFAULT_SUB_PRODUCT_NAME)
        }),
    pushTrackEvent: $f91902615d0f382f$var$defaultAnalyticsMethod,
    pushScreenEvent: $f91902615d0f382f$var$defaultAnalyticsMethod,
    pushUIEvent: $f91902615d0f382f$var$defaultAnalyticsMethod,
    pushOperationalEvent: $f91902615d0f382f$var$defaultAnalyticsMethod,
    startUIViewedEvent: $f91902615d0f382f$var$defaultAnalyticsMethod,
    startApdexEvent: $f91902615d0f382f$var$defaultAnalyticsMethod,
    stopApdexEvent: $f91902615d0f382f$var$defaultAnalyticsMethod
};
const $f91902615d0f382f$var$AnalyticsContextState = {
    analytics: $f91902615d0f382f$export$7fa70eb12a96b7d1
};
const $f91902615d0f382f$var$AnalyticsContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createContext($f91902615d0f382f$var$AnalyticsContextState);
var $f91902615d0f382f$export$2e2bcd8739ae039 = $f91902615d0f382f$var$AnalyticsContext;

});
parcelRegister("77YRX", function(module, exports) {

$parcel$export(module.exports, "installSentry", function () { return $ead5c5c7f2089d26$export$b76869dec8415430; });
$parcel$export(module.exports, "logException", function () { return $ead5c5c7f2089d26$export$f86b2a1a2ce291b3; });
$parcel$export(module.exports, "logErrorMessage", function () { return $ead5c5c7f2089d26$export$ece28f5cfa04608; });
$parcel$export(module.exports, "logInfoMessage", function () { return $ead5c5c7f2089d26$export$386587bcf05ee8ea; });
// See Sentry accepted options in here https://docs.sentry.io/error-reporting/configuration/?platform=javascript

var $dyq1Y = parcelRequire("dyq1Y");
function $ead5c5c7f2089d26$export$5580e6304e95c792(options) {
    const { env: env, version: version, ...otherOptions } = options;
    return {
        ...otherOptions,
        debug: env !== "prod",
        ignoreErrors: [
            /^SentryIgnore:/,
            // Network related errors
            "The operation was aborted",
            "Software caused connection abort",
            "GraphQL error: Failed to fetch",
            "TypeError: Failed to fetch",
            "TypeError: NetworkError when attempting to fetch resource.",
            "AbortError: The user aborted a request."
        ],
        ignoreUrls: [
            // Chrome extensions
            /extensions\//i,
            /^chrome:\/\//i
        ],
        // VERSION comes from process.env and is set when building to deploy to production
        release: version || "---",
        environment: env || "prod"
    };
}
let $ead5c5c7f2089d26$var$sentryInitialised = false;

async function $ead5c5c7f2089d26$export$7a4bf5a3a405d61d() {
    // saving ~40K
    try {
        // @ts-ignore
        return (parcelRequire("36BXr"));
    } catch (error) {
        console.warn("Ignoring rejected promise when loading sentry resource.", error);
    }
}
async function $ead5c5c7f2089d26$export$b76869dec8415430(options) {
    if ($ead5c5c7f2089d26$var$sentryInitialised) return;
    const sentry = await $ead5c5c7f2089d26$export$7a4bf5a3a405d61d();
    if (!sentry) return;
    const finalSentryOption = $ead5c5c7f2089d26$export$5580e6304e95c792(options);
    sentry.init(finalSentryOption);
    $ead5c5c7f2089d26$var$sentryInitialised = true;
}
function $ead5c5c7f2089d26$var$decorateScope(scope, context) {
    const { securityPage: securityPage, tags: tags, ...otherContext } = context;
    if (tags) scope.setTags(tags);
    if (securityPage) scope.setTag("page", "security");
    if (Object.keys(otherContext).length) scope.setExtras(otherContext);
    return scope;
}
async function $ead5c5c7f2089d26$export$f86b2a1a2ce291b3(ex, name, context = {}) {
    if (console && console.error && true) console.error("Logged with Sentry:", ex);
    const sentry = await $ead5c5c7f2089d26$export$7a4bf5a3a405d61d();
    if (!sentry || typeof sentry.captureException !== "function") return;
    sentry.withScope((scope)=>{
        $ead5c5c7f2089d26$var$decorateScope(scope, context);
        scope.setTag("name", name);
        sentry.captureException(ex, undefined, scope);
    });
}
async function $ead5c5c7f2089d26$var$logMessage(severity, message, context = {}) {
    if (console && console.error && true) console.error("Logged with Sentry:", message);
    const sentry = await $ead5c5c7f2089d26$export$7a4bf5a3a405d61d();
    if (!sentry || typeof sentry.captureException !== "function") return;
    sentry.withScope((scope)=>{
        $ead5c5c7f2089d26$var$decorateScope(scope, context);
        sentry.captureMessage(message, severity, undefined, scope);
    });
}
async function $ead5c5c7f2089d26$export$ece28f5cfa04608(message, context = {}) {
    await $ead5c5c7f2089d26$var$logMessage((0, $dyq1Y.Severity).Error, message, context);
}
async function $ead5c5c7f2089d26$export$386587bcf05ee8ea(message, context = {}) {
    await $ead5c5c7f2089d26$var$logMessage((0, $dyq1Y.Severity).Info, message, context);
}

});
parcelRegister("dyq1Y", function(module, exports) {

$parcel$export(module.exports, "Severity", function () { return $9de2a4845e297428$export$918a9776c0a3cf27; });
/** JSDoc */ var $9de2a4845e297428$export$918a9776c0a3cf27;
(function(Severity) {
    /** JSDoc */ Severity["Fatal"] = "fatal";
    /** JSDoc */ Severity["Error"] = "error";
    /** JSDoc */ Severity["Warning"] = "warning";
    /** JSDoc */ Severity["Log"] = "log";
    /** JSDoc */ Severity["Info"] = "info";
    /** JSDoc */ Severity["Debug"] = "debug";
    /** JSDoc */ Severity["Critical"] = "critical";
})($9de2a4845e297428$export$918a9776c0a3cf27 || ($9de2a4845e297428$export$918a9776c0a3cf27 = {}));
// tslint:disable:completed-docs
// tslint:disable:no-unnecessary-qualifier no-namespace
(function(Severity) {
    /**
     * Converts a string-based level into a {@link Severity}.
     *
     * @param level string representation of Severity
     * @returns Severity
     */ function fromString(level) {
        switch(level){
            case "debug":
                return Severity.Debug;
            case "info":
                return Severity.Info;
            case "warn":
            case "warning":
                return Severity.Warning;
            case "error":
                return Severity.Error;
            case "fatal":
                return Severity.Fatal;
            case "critical":
                return Severity.Critical;
            case "log":
            default:
                return Severity.Log;
        }
    }
    Severity.fromString = fromString;
})($9de2a4845e297428$export$918a9776c0a3cf27 || ($9de2a4845e297428$export$918a9776c0a3cf27 = {}));

});

parcelRegister("36BXr", function(module, exports) {

var $6aCUT = parcelRequire("6aCUT");
module.exports = $6aCUT("hJhoy").then(()=>parcelRequire("5XPw5"));

});
parcelRegister("6aCUT", function(module, exports) {
"use strict";

function $47e1dd43196b1bc9$var$load(id) {
    // eslint-disable-next-line no-undef
    return import((parcelRequire("fSTeH")).resolve(id));
}
module.exports = $47e1dd43196b1bc9$var$load;

});



parcelRegister("1QfrT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1576a19ac8291bbe$export$2e2bcd8739ae039; });

var $gsv4E = parcelRequire("gsv4E");

var $dNSPy = parcelRequire("dNSPy");

var $fyxFC = parcelRequire("fyxFC");

var $f7O6S = parcelRequire("f7O6S");

var $3FbWL = parcelRequire("3FbWL");

var $8svgN = parcelRequire("8svgN");

var $f8NDg = parcelRequire("f8NDg");

var $98vWd = parcelRequire("98vWd");

var $9pJLQ = parcelRequire("9pJLQ");

var $eckKx = parcelRequire("eckKx");

var $5uWkR = parcelRequire("5uWkR");

var $hKBQC = parcelRequire("hKBQC");

var $b6g7e = parcelRequire("b6g7e");

var $ebXXj = parcelRequire("ebXXj");

var $et4UB = parcelRequire("et4UB");

var $64gRl = parcelRequire("64gRl");

var $4OGCN = parcelRequire("4OGCN");

var $gOtSJ = parcelRequire("gOtSJ");

var $bk1z1 = parcelRequire("bk1z1");

var $96itE = parcelRequire("96itE");

var $9v6BW = parcelRequire("9v6BW");
function $1576a19ac8291bbe$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $1576a19ac8291bbe$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $1576a19ac8291bbe$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($gsv4E)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $1576a19ac8291bbe$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $1576a19ac8291bbe$export$5df9262e102d0c32 = "/gateway/api/gasv3/api/v1";
const $1576a19ac8291bbe$var$LAST_SCREEN_EVENT_STORAGE_KEY = "last.screen.event";
class $1576a19ac8291bbe$export$2e2bcd8739ae039 {
    constructor(productInfo, settings = {}){
        (0, (/*@__PURE__*/$parcel$interopDefault($gsv4E)))(this, "_useStargate", (useStargate)=>{
            if (useStargate == null) return true;
            return useStargate;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($gsv4E)))(this, "_endsWith", (str, suffix)=>str.indexOf(suffix, str.length - suffix.length) !== -1);
        (0, (/*@__PURE__*/$parcel$interopDefault($gsv4E)))(this, "_changeInternalUserId", (userId, anonymousId)=>{
            this.eventProcessor.getUser().setUserId(userId);
            if (anonymousId && anonymousId !== this.eventProcessor.getUser().getAnonymousId()) // Setting anonymous id can take a long time. Reading is a lot faster.
            // Only update if it has changed.
            this.eventProcessor.getUser().setAnonymousId(anonymousId);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($gsv4E)))(this, "_createSubproductGetter", (subproduct)=>(0, $3FbWL.default)(subproduct, "Cannot get subproduct from the callback. Proceeding without it."));
        (0, (/*@__PURE__*/$parcel$interopDefault($gsv4E)))(this, "_createEmbeddedProductGetter", (embeddedProduct)=>(0, $3FbWL.default)(embeddedProduct, "Cannot get embeddedProduct from the callback. Proceeding without it."));
        (0, (/*@__PURE__*/$parcel$interopDefault($gsv4E)))(this, "_getLastScreenEvent", ()=>{
            try {
                return JSON.parse(this._safeSessionStorage.getItem($1576a19ac8291bbe$var$LAST_SCREEN_EVENT_STORAGE_KEY) || "");
            } catch (err) {
                this._safeSessionStorage.removeItem($1576a19ac8291bbe$var$LAST_SCREEN_EVENT_STORAGE_KEY);
                return null;
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($gsv4E)))(this, "_setLastScreenEvent", (event)=>{
            this._safeSessionStorage.setItem($1576a19ac8291bbe$var$LAST_SCREEN_EVENT_STORAGE_KEY, JSON.stringify({
                name: event.name,
                attributes: event.attributes
            }));
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($gsv4E)))(this, "_shouldEventBeDelayed", (event)=>{
            // TODO: this is a temporary restriction for the purposes of the Track All Changes project
            // The delay mechanism has a chance of event loss, which we can only accept for our own data at this point.
            // Once the delay queue implementation has been improved and measured to confirm that it is reliable enough,
            // then we will be able to open it up for other products to use by removing this check.
            if (!event.tags || event.tags.indexOf("measurement") === -1) return false;
            const isEventHighPriority = event.highPriority !== false; // defaults to true if excluded
            return this.eventDelayQueue.isDelayingLowPriorityEvents() && !isEventHighPriority;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($gsv4E)))(this, "_fireEvent", (identifier, builtEvent, context, callback)=>{
            switch(builtEvent.eventType){
                case (0, $fyxFC.eventType).UI:
                case (0, $fyxFC.eventType).OPERATIONAL:
                case (0, $fyxFC.eventType).TRACK:
                    return this.eventProcessor.track(identifier, builtEvent, context, callback);
                case (0, $fyxFC.eventType).SCREEN:
                    return this.eventProcessor.page(identifier, builtEvent, context, callback);
                case (0, $fyxFC.eventType).IDENTIFY:
                    return this.eventProcessor.identify(identifier, builtEvent, context, callback);
                default:
                    throw new Error(`No handler has been defined for events of type ${builtEvent.eventType}`);
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($gsv4E)))(this, "_fireDelayedEvent", (identifier, builtEvent, context, userInfo)=>{
            try {
                // User information can change while the delay period is active, so we need to restore the values that
                // were active when the event was originally fired.
                this._changeInternalUserId(userInfo.userId, userInfo.anonymousId);
                builtEvent.tags = [
                    ...builtEvent.tags || [],
                    "sentWithDelay"
                ];
                // The callbacks for delayed events are fired immediately, so there is nothing to pass through for this argument.
                this._fireEvent(identifier, builtEvent, context, undefined);
            } finally{
                this._changeInternalUserId(this._userInfo.userId, this._userInfo.anonymousId);
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($gsv4E)))(this, "_delayEvent", (identifier, builtEvent, context, userInfo, callback)=>{
            this.eventDelayQueue.push(identifier, builtEvent, context, userInfo);
            // Fire the callback immediately, as we can consider the event successfully processed at this point
            if (callback) callback();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($gsv4E)))(this, "_processEvent", (identifier, builtEvent, context, callback)=>{
            this._testingCache.saveEvent(builtEvent);
            if (this._shouldEventBeDelayed(builtEvent)) {
                this._delayEvent(identifier, builtEvent, context, this._userInfo, callback);
                return Promise.resolve();
            } else return this._fireEvent(identifier, builtEvent, context, callback);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($gsv4E)))(this, "setEmbeddedProduct", (embeddedProduct)=>{
            this._productInfo.embeddedProduct = this._createEmbeddedProductGetter(embeddedProduct);
            this.resetUIViewedTimers();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($gsv4E)))(this, "clearEmbeddedProduct", ()=>{
            this._productInfo.embeddedProduct = this._createEmbeddedProductGetter(null);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($gsv4E)))(this, "setSubproduct", (subproduct)=>{
            this._productInfo.subproduct = this._createSubproductGetter(subproduct);
            this.resetUIViewedTimers();
        });
        /**
      * Calling this function in the intialisation of the client in product
      * captures specified 'origin tracing' URL params and fires a single origin landed event
      * <p>
      * This function expects a mapping between the keys for any URL parameters
      *  that should be captured and removed for origin tracing
      * Multiple parameters may be captured simultaneously if multiple key: handler function pairs are provided
      * Each handler function should return an object with two items
      * a) 'originTracingAttributes' - an object that will be added to the 'origin landed' event's attributes under 'originTracing
      * b) 'taskSessionId' (optional) - an Id string that will be added to the tasksessions for any event that fires from the tab, with the key
      *    matching the URL parameter, for the purpose of attributing subsequent analytics event to the origin land.
      * </p>
      * The general use case for this feature is for allowing attributation of user behaviour to a out of product or cross product link,
      * e.g. from a share or email
      *
      * An example calling this function using an external decoding library, with taskSessionId specified to persist
      * analyticsWebClient.setOriginTracingHandlers({
           atlOrigin: encodedOrigin => {
               const { id, product } = OriginTracing.fromEncoded(encodedOrigin);
               return { originTracingAttributes: {'id': id, 'product': product}, taskSessionId: id };
           },
       });
      *
      * @param  {Object} originParamHandlerMapping a dictionary of mappings between origin url param keys and handler functions
      * @this {AnalyticsWebClient}
      */ (0, (/*@__PURE__*/$parcel$interopDefault($gsv4E)))(this, "setOriginTracingHandlers", (originParamHandlerMapping)=>{
            const capturedOriginTraces = this.originTracing.handleOriginParameters(originParamHandlerMapping, this._historyReplaceFn);
            Object.keys(capturedOriginTraces).forEach((x)=>{
                if (typeof capturedOriginTraces[x].taskSessionId !== "undefined") this.task.createTaskSessionWithProvidedId(x, capturedOriginTraces[x].taskSessionId);
            });
            const originAttributes = {};
            Object.keys(capturedOriginTraces).forEach((x)=>{
                if (capturedOriginTraces[x].originTracingAttributes) originAttributes[x] = capturedOriginTraces[x].originTracingAttributes;
                else // eslint-disable-next-line no-console
                console.warn(`Handling method for origin parameter ${x} has not returned any attributes`);
            });
            if (Object.keys(capturedOriginTraces).length > 0) return this.sendOperationalEvent({
                action: "landed",
                actionSubject: "origin",
                source: "webClient",
                attributes: {
                    originTracesLanded: originAttributes
                }
            }, // eslint-disable-next-line @typescript-eslint/no-empty-function
            ()=>{});
            return Promise.resolve();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($gsv4E)))(this, "setTenantInfo", (tenantIdType, tenantId)=>{
            if (!tenantIdType) throw new Error("Missing tenantIdType");
            if (tenantIdType !== (0, $fyxFC.tenantType).NONE && !tenantId) throw new Error("Missing tenantId");
            if (!(0, $fyxFC.isType)((0, $fyxFC.tenantType), tenantIdType)) throw new Error(`Invalid tenantIdType '${tenantIdType}', ` + `must be an tenantType: [${(0, $fyxFC.objectValues)((0, $fyxFC.tenantType))}]`);
            this._tenantInfo = {
                tenantIdType: tenantIdType,
                tenantId: tenantId
            };
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($gsv4E)))(this, "clearTenantInfo", ()=>{
            this._tenantInfo = {};
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($gsv4E)))(this, "setOrgInfo", (orgId)=>{
            if (!orgId) throw new Error("Missing orgId");
            this._orgInfo = {
                orgId: orgId
            };
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($gsv4E)))(this, "clearOrgInfo", ()=>{
            this._orgInfo = {};
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($gsv4E)))(this, "setWorkspaceInfo", (workspaceId)=>{
            if (!workspaceId) throw new Error("Missing workspaceId");
            this._workspaceInfo = {
                workspaceId: workspaceId
            };
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($gsv4E)))(this, "clearWorkspaceInfo", ()=>{
            this._workspaceInfo = {};
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($gsv4E)))(this, "setUserInfo", (userIdType, userId)=>{
            (0, $98vWd.validateIdentifyEvent)(userIdType, userId);
            this._changeInternalUserId(userId);
            this._userInfo = {
                userIdType: userIdType,
                userId: userId,
                anonymousId: this.eventProcessor.getUser().getAnonymousId()
            };
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($gsv4E)))(this, "clearUserInfo", ()=>{
            this._changeInternalUserId(undefined);
            this._userInfo = {
                anonymousId: this.eventProcessor.getUser().getAnonymousId()
            };
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($gsv4E)))(this, "setAlias", (aliasKeyType, alias)=>{
            if (!aliasKeyType) throw new Error("Missing aliasType");
            if (!(0, $fyxFC.isType)((0, $fyxFC.aliasType), aliasKeyType)) throw new Error(`Invalid aliasType '${aliasKeyType}', ` + `must be an aliasType: [${(0, $fyxFC.objectValues)((0, $fyxFC.aliasType))}]`);
            this._aliases[aliasKeyType] = alias;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($gsv4E)))(this, "clearAlias", ()=>{
            this._aliases = {};
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($gsv4E)))(this, "setGroup", (groupsKeyType, group)=>{
            if (!groupsKeyType) throw new Error("Missing groupType");
            if (!(0, $fyxFC.isType)((0, $fyxFC.groupType), groupsKeyType)) throw new Error(`Invalid groupType '${groupsKeyType}', ` + `must be an groupType: [${(0, $fyxFC.objectValues)((0, $fyxFC.groupType))}]`);
            this._groups[groupsKeyType] = group;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($gsv4E)))(this, "clearGroup", ()=>{
            this._groups = {};
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($gsv4E)))(this, "getAnonymousId", ()=>this._userInfo.anonymousId);
        (0, (/*@__PURE__*/$parcel$interopDefault($gsv4E)))(this, "setUIViewedAttributes", (uiViewedAttributes)=>{
            if (!uiViewedAttributes) throw new Error("Missing uiViewedAttributes");
            if (typeof uiViewedAttributes !== "object" || Array.isArray(uiViewedAttributes)) throw new Error("Invalid uiViewedAttributes type, should be a non array object");
            this._uiViewedAttributes = $1576a19ac8291bbe$var$_objectSpread({}, uiViewedAttributes);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($gsv4E)))(this, "getUIViewedAttributes", ()=>{
            return this._uiViewedAttributes;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($gsv4E)))(this, "clearUIViewedAttributes", ()=>{
            this._uiViewedAttributes = {};
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($gsv4E)))(this, "sendIdentifyEvent", (userIdType, userId, callback)=>{
            this.setUserInfo(userIdType, userId);
            const builtEvent = {
                userIdType: userIdType,
                eventType: (0, $fyxFC.eventType).IDENTIFY
            };
            return this._processEvent(userId, builtEvent, this._context, callback);
        });
        /**
     * @deprecated
     * please use {@link sendScreenEvent instead)
     */ (0, (/*@__PURE__*/$parcel$interopDefault($gsv4E)))(this, "sendPageEvent", (name, callback)=>{
            return this.sendScreenEvent(name, callback);
        });
        /**
     * send screen event
     * @param event The event / For retrocompatibility event name is still supported here.
     * @param callback
     * @param attributes. Deprecated, will get ignored if using an event object as first param.
     */ (0, (/*@__PURE__*/$parcel$interopDefault($gsv4E)))(this, "sendScreenEvent", (event, callback, attributes)=>{
            let screenName;
            let screenAttributes;
            let screenContainers;
            let screenTags;
            if (typeof event === "object") {
                /* This is for retrocompatibility */ screenName = event.name;
                screenAttributes = event.attributes;
                screenContainers = event.containers;
                screenTags = event.tags;
            } else {
                screenName = event;
                screenAttributes = attributes;
            }
            (0, $98vWd.validateScreenEvent)(screenName);
            (0, $98vWd.validateContainers)(screenContainers);
            const builtEvent = (0, $8svgN.buildScreenEvent)(this._productInfo, this._tenantInfo, this._userInfo, screenAttributes, // TODO: Remove the as any and move into a place where we know event is an object
            event.nonPrivacySafeAttributes, screenTags, this._tabTracking.getCurrentTabId(), this._sessionTracking.getCurrentSessionId(), this.task.getAllTaskSessions(), this._orgInfo, this._pageLoadId, this._workspaceInfo, event, screenContainers, this._aliases, this._groups);
            const builtEventWithName = $1576a19ac8291bbe$var$_objectSpread({
                name: screenName
            }, builtEvent);
            this._setLastScreenEvent(builtEventWithName);
            return this._processEvent(screenName, builtEventWithName, this._context, (0, $96itE.default)(callback, builtEventWithName));
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($gsv4E)))(this, "sendTrackEvent", (event, callback)=>{
            (0, $98vWd.validateTrackEvent)(event);
            const builtEvent = (0, $8svgN.buildActionEvent)(this._productInfo, this._tenantInfo, this._userInfo, event, (0, $fyxFC.eventType).TRACK, this._tabTracking.getCurrentTabId(), this._sessionTracking.getCurrentSessionId(), this.task.getAllTaskSessions(), this._orgInfo, this._pageLoadId, this._workspaceInfo, this._aliases, this._groups);
            return this._processEvent((0, $8svgN.buildActionName)(event), builtEvent, this._context, (0, $96itE.default)(callback, builtEvent));
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($gsv4E)))(this, "sendUIEvent", (event, callback)=>{
            (0, $98vWd.validateUIEvent)(event);
            const builtEvent = (0, $8svgN.buildActionEvent)(this._productInfo, this._tenantInfo, this._userInfo, event, (0, $fyxFC.eventType).UI, this._tabTracking.getCurrentTabId(), this._sessionTracking.getCurrentSessionId(), this.task.getAllTaskSessions(), this._orgInfo, this._pageLoadId, this._workspaceInfo, this._aliases, this._groups);
            return this._processEvent((0, $8svgN.buildActionName)(event), builtEvent, this._context, (0, $96itE.default)(callback, builtEvent));
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($gsv4E)))(this, "sendOperationalEvent", (event, callback)=>{
            (0, $98vWd.validateOperationalEvent)(event);
            const builtEvent = (0, $8svgN.buildActionEvent)(this._productInfo, this._tenantInfo, this._userInfo, event, (0, $fyxFC.eventType).OPERATIONAL, this._tabTracking.getCurrentTabId(), this._sessionTracking.getCurrentSessionId(), this.task.getAllTaskSessions(), this._orgInfo, this._pageLoadId, this._workspaceInfo, this._aliases, this._groups);
            return this._processEvent((0, $8svgN.buildActionName)(event), builtEvent, this._context, (0, $96itE.default)(callback, builtEvent));
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($gsv4E)))(this, "startUIViewedEvent", (callback)=>{
            this.stopUIViewedEvent();
            this._uiViewedEvent = new (0, $gOtSJ.default)(this._productInfo, ()=>({
                    embeddedProduct: this._productInfo.embeddedProduct(),
                    subproduct: this._productInfo.subproduct(),
                    tenantIdType: this._tenantInfo.tenantIdType,
                    tenantId: this._tenantInfo.tenantId,
                    userId: this._userInfo.userId,
                    lastScreenEvent: this._getLastScreenEvent(),
                    attributes: this._uiViewedAttributes
                }), (event)=>this.sendUIEvent(event, callback));
            this._uiViewedEvent.start();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($gsv4E)))(this, "stopUIViewedEvent", ()=>{
            if (this._uiViewedEvent) {
                this._uiViewedEvent.stop();
                this._uiViewedEvent = null;
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($gsv4E)))(this, "resetUIViewedTimers", ()=>{
            if (this._uiViewedEvent) this._uiViewedEvent.resetTimers();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($gsv4E)))(this, "startApdexEvent", (apdexEvent)=>{
            this._apdexEvent.start(apdexEvent);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($gsv4E)))(this, "getApdexStart", (apdexEvent)=>this._apdexEvent.getStart(apdexEvent));
        (0, (/*@__PURE__*/$parcel$interopDefault($gsv4E)))(this, "stopApdexEvent", (apdexEvent, callback)=>{
            this._apdexEvent.stop(apdexEvent, callback);
        });
        // TODO If we ever make another breaking change, merge these two optional args into an `options` object arg.
        (0, (/*@__PURE__*/$parcel$interopDefault($gsv4E)))(this, "startLowPriorityEventDelay", (timeout, callback)=>{
            this.eventDelayQueue.startLowPriorityEventDelay(timeout, callback);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($gsv4E)))(this, "stopLowPriorityEventDelay", ()=>{
            this.eventDelayQueue.stopLowPriorityEventDelay();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($gsv4E)))(this, "onEvent", (_analyticsId, analyticsData)=>{
            if (!analyticsData) throw new Error("Missing analyticsData");
            if (!analyticsData.eventType) throw new Error("Missing analyticsData.eventType");
            if (analyticsData.eventType === (0, $fyxFC.eventType).TRACK) return this.sendTrackEvent(analyticsData);
            else if (analyticsData.eventType === (0, $fyxFC.eventType).UI) return this.sendUIEvent(analyticsData);
            else if (analyticsData.eventType === (0, $fyxFC.eventType).OPERATIONAL) return this.sendOperationalEvent(analyticsData);
            else if (analyticsData.eventType === (0, $fyxFC.eventType).SCREEN) return this.sendScreenEvent(analyticsData.name, null, analyticsData.attributes);
            else if (analyticsData.eventType === (0, $fyxFC.eventType).IDENTIFY) return this.sendIdentifyEvent(analyticsData.userIdType, analyticsData.userId);
            throw new Error(`Invalid analyticsData.eventType '${analyticsData.eventType}', ` + `must be an eventType: [${(0, $fyxFC.objectValues)((0, $fyxFC.eventType))}]`);
        });
        if (!productInfo) throw new Error("Missing productInfo");
        if (!productInfo.env) throw new Error("Missing productInfo.env");
        if (!productInfo.product) throw new Error("Missing productInfo.product");
        if (!(0, $fyxFC.isType)((0, $fyxFC.envType), productInfo.env)) throw new Error(`Invalid productInfo.env '${productInfo.env}', ` + `must be an envType: [${(0, $fyxFC.objectValues)((0, $fyxFC.envType))}]`);
        if (productInfo.perimeter && !(0, $fyxFC.isType)((0, $fyxFC.perimeterType), productInfo.perimeter)) throw new Error(`Invalid productInfo.perimeter '${productInfo.perimeter}', ` + `must be an perimeterType: [${(0, $fyxFC.objectValues)((0, $fyxFC.perimeterType))}]`);
        if (!productInfo.origin) productInfo.origin = (0, $fyxFC.originType).WEB;
        else if (!(0, $fyxFC.isType)((0, $fyxFC.originType), productInfo.origin)) throw new Error(`Invalid productInfo.origin '${productInfo.origin}', ` + `must be an originType: [${(0, $fyxFC.objectValues)((0, $fyxFC.originType))}]`);
        if (!productInfo.platform) productInfo.platform = productInfo.origin === (0, $fyxFC.originType).WEB ? (0, $fyxFC.platformType).WEB : (0, $fyxFC.platformType).DESKTOP;
        else (0, $98vWd.validatePlatform)(productInfo);
        this.logger = settings.logger || console;
        this._productInfo = $1576a19ac8291bbe$var$_objectSpread($1576a19ac8291bbe$var$_objectSpread({}, productInfo), {}, {
            subproduct: this._createSubproductGetter(productInfo.subproduct),
            embeddedProduct: this._createEmbeddedProductGetter(productInfo.embeddedProduct)
        });
        this._tenantInfo = {};
        this._orgInfo = {};
        this._uiViewedAttributes = {};
        this._context = (0, $8svgN.buildContext)(this._productInfo);
        this._safeSessionStorage = new (0, $ebXXj.default)();
        const _useStargate = this._useStargate(settings.useStargate);
        const apiHost = settings.apiHost || (0, $hKBQC.selectHost)({
            useStargate: _useStargate,
            env: productInfo.env,
            useLegacyUrl: settings.useLegacyUrl,
            perimeter: productInfo.perimeter,
            envOverride: productInfo.envOverride
        });
        const apiHostProtocol = settings.apiHostProtocol || "https";
        const minRetryDelay = settings.minRetryDelay || 1000;
        const retryQueueOptions = {
            maxRetryDelay: 60000,
            minRetryDelay: minRetryDelay,
            backoffFactor: 2,
            flushWaitMs: settings.flushWaitInterval,
            flushBeforeUnload: settings.flushBeforeUnload
        };
        const retryQueuePrefix = `awc-${productInfo.env}`;
        const xidPromiseGetter = ()=>(0, $9v6BW.XIDPromise)(settings.xidConsent, settings.xidPromiseFn);
        const disableCookiePersistence = settings.disableCookiePersistence || false;
        this.eventProcessor = new (0, $9pJLQ.default)({
            apiHost: apiHost,
            apiHostProtocol: apiHostProtocol,
            product: productInfo.product,
            retryQueuePrefix: retryQueuePrefix,
            retryQueueOptions: retryQueueOptions,
            xidPromiseGetter: xidPromiseGetter,
            logger: this.logger,
            disableCookiePersistence: disableCookiePersistence
        });
        this._userInfo = {
            anonymousId: this.eventProcessor.getUser().getAnonymousId(settings === null || settings === void 0 ? void 0 : settings.customAnonymousIdGenerator)
        };
        this._pageVisibility = new (0, $5uWkR.default)();
        this._tabTracking = new (0, $et4UB.default)();
        this._sessionTracking = new (0, $b6g7e.default)({
            sessionExpiryTime: settings.sessionExpiryTime,
            onNewSessionStarted: settings.onNewSessionStarted
        });
        this.task = new (0, $64gRl.default)();
        this.originTracing = new (0, $eckKx.default)();
        // Init Apdex
        this._apdexEvent = new (0, $f7O6S.default)(this.sendOperationalEvent, this._pageVisibility);
        this._historyReplaceFn = typeof settings.historyReplaceFn === "function" ? settings.historyReplaceFn : (0, $bk1z1.defaultHistoryReplaceFn);
        this.eventDelayQueue = new (0, $f8NDg.default)(this._fireDelayedEvent, settings.delayQueueCompressors || []);
        this._testingCache = new (0, $4OGCN.default)();
        this._pageLoadId = (0, (/*@__PURE__*/$parcel$interopDefault($dNSPy)))();
        this._workspaceInfo = {};
        this._aliases = {};
        this._groups = {};
    }
}

});
parcelRegister("gsv4E", function(module, exports) {

var $e2uvJ = parcelRequire("e2uvJ");
function $bfb75d80faf4c701$var$_defineProperty(e, r, t) {
    return (r = $e2uvJ(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
module.exports = $bfb75d80faf4c701$var$_defineProperty, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("e2uvJ", function(module, exports) {

var $htX2j = parcelRequire("htX2j");
var $a388eb66bf70f0ce$var$_typeof = $htX2j.default;

var $cZ76r = parcelRequire("cZ76r");
function $a388eb66bf70f0ce$var$toPropertyKey(t) {
    var i = $cZ76r(t, "string");
    return "symbol" == $a388eb66bf70f0ce$var$_typeof(i) ? i : i + "";
}
module.exports = $a388eb66bf70f0ce$var$toPropertyKey, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("htX2j", function(module, exports) {
function $cba2f078bcbd0a8c$var$_typeof(o) {
    "@babel/helpers - typeof";
    return module.exports = $cba2f078bcbd0a8c$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $cba2f078bcbd0a8c$var$_typeof(o);
}
module.exports = $cba2f078bcbd0a8c$var$_typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("cZ76r", function(module, exports) {

var $htX2j = parcelRequire("htX2j");
var $9740b1032a299d00$var$_typeof = $htX2j.default;
function $9740b1032a299d00$var$toPrimitive(t, r) {
    if ("object" != $9740b1032a299d00$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $9740b1032a299d00$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
module.exports = $9740b1032a299d00$var$toPrimitive, module.exports.__esModule = true, module.exports["default"] = module.exports;

});



parcelRegister("dNSPy", function(module, exports) {

var $5egaI = parcelRequire("5egaI");

var $oykgN = parcelRequire("oykgN");
function $a0ca622aa0c5b1a3$var$v4(options, buf, offset) {
    var i = buf && offset || 0;
    if (typeof options == "string") {
        buf = options === "binary" ? new Array(16) : null;
        options = null;
    }
    options = options || {};
    var rnds = options.random || (options.rng || $5egaI)();
    // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80;
    // Copy bytes to buffer, if provided
    if (buf) for(var ii = 0; ii < 16; ++ii)buf[i + ii] = rnds[ii];
    return buf || $oykgN(rnds);
}
module.exports = $a0ca622aa0c5b1a3$var$v4;

});
parcelRegister("5egaI", function(module, exports) {
// Unique ID creation requires a high quality random # generator.  In the
// browser this is a little complicated due to unknown quality of Math.random()
// and inconsistent support for the `crypto` API.  We do the best we can via
// feature-detection
// getRandomValues needs to be invoked in a context where "this" is a Crypto
// implementation. Also, find the complete implementation of crypto on IE11.
var $3ceacdefbaa537d6$var$getRandomValues = typeof crypto != "undefined" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto != "undefined" && typeof window.msCrypto.getRandomValues == "function" && msCrypto.getRandomValues.bind(msCrypto);
if ($3ceacdefbaa537d6$var$getRandomValues) {
    // WHATWG crypto RNG - http://wiki.whatwg.org/wiki/Crypto
    var $3ceacdefbaa537d6$var$rnds8 = new Uint8Array(16); // eslint-disable-line no-undef
    module.exports = function whatwgRNG() {
        $3ceacdefbaa537d6$var$getRandomValues($3ceacdefbaa537d6$var$rnds8);
        return $3ceacdefbaa537d6$var$rnds8;
    };
} else {
    // Math.random()-based (RNG)
    //
    // If all else fails, use Math.random().  It's fast, but is of unspecified
    // quality.
    var $3ceacdefbaa537d6$var$rnds = new Array(16);
    module.exports = function mathRNG() {
        for(var i = 0, r; i < 16; i++){
            if ((i & 0x03) === 0) r = Math.random() * 0x100000000;
            $3ceacdefbaa537d6$var$rnds[i] = r >>> ((i & 0x03) << 3) & 0xff;
        }
        return $3ceacdefbaa537d6$var$rnds;
    };
}

});

parcelRegister("oykgN", function(module, exports) {
/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */ var $049cde6bb6e6a6f3$var$byteToHex = [];
for(var $049cde6bb6e6a6f3$var$i = 0; $049cde6bb6e6a6f3$var$i < 256; ++$049cde6bb6e6a6f3$var$i)$049cde6bb6e6a6f3$var$byteToHex[$049cde6bb6e6a6f3$var$i] = ($049cde6bb6e6a6f3$var$i + 0x100).toString(16).substr(1);
function $049cde6bb6e6a6f3$var$bytesToUuid(buf, offset) {
    var i = offset || 0;
    var bth = $049cde6bb6e6a6f3$var$byteToHex;
    // join used to fix memory issue caused by concatenation: https://bugs.chromium.org/p/v8/issues/detail?id=3175#c4
    return [
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        "-",
        bth[buf[i++]],
        bth[buf[i++]],
        "-",
        bth[buf[i++]],
        bth[buf[i++]],
        "-",
        bth[buf[i++]],
        bth[buf[i++]],
        "-",
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]]
    ].join("");
}
module.exports = $049cde6bb6e6a6f3$var$bytesToUuid;

});


parcelRegister("fyxFC", function(module, exports) {

$parcel$export(module.exports, "envType", function () { return $b534263017708392$export$56ac8ebc9870b1b9; });
$parcel$export(module.exports, "eventType", function () { return $b534263017708392$export$4c045e605d532c98; });
$parcel$export(module.exports, "platformType", function () { return $b534263017708392$export$6b4f396210e539f3; });
$parcel$export(module.exports, "originType", function () { return $b534263017708392$export$f73e9fcd368bb695; });
$parcel$export(module.exports, "tenantType", function () { return $b534263017708392$export$496f06ac2a964da2; });
$parcel$export(module.exports, "userType", function () { return $b534263017708392$export$1827adfd178b4870; });
$parcel$export(module.exports, "apdexType", function () { return $b534263017708392$export$99b37380a464d794; });
$parcel$export(module.exports, "desktopPlatforms", function () { return $b534263017708392$export$809831be6c4c6227; });
$parcel$export(module.exports, "webPlatforms", function () { return $b534263017708392$export$19c579398ad213e7; });
$parcel$export(module.exports, "originTracingType", function () { return $b534263017708392$export$62a500c02dc63ee; });
$parcel$export(module.exports, "objectValues", function () { return $b534263017708392$export$ad1854f4a08c15f8; });
$parcel$export(module.exports, "isType", function () { return $b534263017708392$export$26b9f946b448f23e; });
$parcel$export(module.exports, "perimeterType", function () { return $b534263017708392$export$bdd41749d2096e4b; });
$parcel$export(module.exports, "aliasType", function () { return $b534263017708392$export$a8c99e46b781d936; });
$parcel$export(module.exports, "groupType", function () { return $b534263017708392$export$e73680b18d9b7c6e; });
$parcel$export(module.exports, "envOverrides", function () { return $b534263017708392$export$12b75c708da5a04b; });
// These types have been converted from frozen objects to enums.
// We cannot change their name, or even capitalise them without breaking API.
let $b534263017708392$export$56ac8ebc9870b1b9 = /*#__PURE__*/ function(envType) {
    envType["LOCAL"] = "local";
    envType["DEV"] = "dev";
    envType["STAGING"] = "staging";
    envType["PROD"] = "prod";
    return envType;
}({});
let $b534263017708392$export$4c045e605d532c98 = /*#__PURE__*/ function(eventType) {
    eventType["TRACK"] = "track";
    eventType["UI"] = "ui";
    eventType["OPERATIONAL"] = "operational";
    eventType["SCREEN"] = "screen";
    eventType["IDENTIFY"] = "identify";
    return eventType;
}({});
let $b534263017708392$export$6b4f396210e539f3 = /*#__PURE__*/ function(platformType) {
    platformType["MAC"] = "mac";
    platformType["LINUX"] = "linux";
    platformType["WINDOWS"] = "windows";
    platformType["DESKTOP"] = "desktop";
    platformType["WEB"] = "web";
    platformType["MOBILE_WEB"] = "mobileWeb";
    return platformType;
}({});
let $b534263017708392$export$f73e9fcd368bb695 = /*#__PURE__*/ function(originType) {
    originType["DESKTOP"] = "desktop";
    originType["WEB"] = "web";
    return originType;
}({});
let $b534263017708392$export$496f06ac2a964da2 = /*#__PURE__*/ function(tenantType) {
    tenantType["CLOUD_ID"] = "cloudId";
    tenantType["ORG_ID"] = "orgId";
    tenantType["OPSGENIE_CUSTOMER_ID"] = "opsgenieCustomerId";
    tenantType["HALP_TEAM_ID"] = "halpTeamId";
    tenantType["TRANSACTION_ACCOUNT_ID"] = "transactionAccountId";
    tenantType["TRELLO_WORKSPACE_ID"] = "trelloWorkspaceId";
    tenantType["NONE"] = "none";
    return tenantType;
}({});
let $b534263017708392$export$1827adfd178b4870 = /*#__PURE__*/ function(userType) {
    userType["ATLASSIAN_ACCOUNT"] = "atlassianAccount";
    userType["HASHED_EMAIL"] = "hashedEmail";
    userType["TRELLO"] = "trello";
    userType["OPSGENIE"] = "opsgenie";
    userType["HALP"] = "halp";
    return userType;
}({});
let $b534263017708392$export$99b37380a464d794 = /*#__PURE__*/ function(apdexType) {
    apdexType["TRANSITION"] = "transition";
    apdexType["INITIAL_LOAD"] = "initialLoad";
    return apdexType;
}({});
const $b534263017708392$export$809831be6c4c6227 = Object.freeze([
    $b534263017708392$export$6b4f396210e539f3.DESKTOP,
    $b534263017708392$export$6b4f396210e539f3.MAC,
    $b534263017708392$export$6b4f396210e539f3.LINUX,
    $b534263017708392$export$6b4f396210e539f3.WINDOWS
]);
const $b534263017708392$export$19c579398ad213e7 = Object.freeze([
    $b534263017708392$export$6b4f396210e539f3.WEB,
    $b534263017708392$export$6b4f396210e539f3.MOBILE_WEB
]);
let $b534263017708392$export$62a500c02dc63ee = /*#__PURE__*/ function(originTracingType) {
    originTracingType["ATL_ORIGIN"] = "atlOrigin";
    return originTracingType;
}({});
function $b534263017708392$export$ad1854f4a08c15f8(object) {
    return Object.values(object);
}
function $b534263017708392$export$26b9f946b448f23e(type, value) {
    return Object.values(type).indexOf(value) > -1;
}
let $b534263017708392$export$bdd41749d2096e4b = /*#__PURE__*/ function(perimeterType) {
    perimeterType["C5"] = "c5";
    perimeterType["COMMERCIAL"] = "commercial";
    perimeterType["FEDRAMP_MODERATE"] = "fedramp-moderate";
    perimeterType["FEDRAMP_HIGH"] = "fedramp-high";
    return perimeterType;
}({});
let $b534263017708392$export$a8c99e46b781d936 = /*#__PURE__*/ function(aliasType) {
    return aliasType;
}({});
let $b534263017708392$export$e73680b18d9b7c6e = /*#__PURE__*/ function(groupType) {
    groupType["TRANSACTION_ACCOUNT_ID"] = "transactionAccountId";
    return groupType;
}({});
let $b534263017708392$export$12b75c708da5a04b = /*#__PURE__*/ function(envOverrides) {
    envOverrides["FEDRAMP_MODERATE_SANDBOX"] = "fedramp-moderate-sandbox";
    return envOverrides;
}({});

});

parcelRegister("f7O6S", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b02e613c96d0614b$export$2e2bcd8739ae039; });

var $gsv4E = parcelRequire("gsv4E");

var $fyxFC = parcelRequire("fyxFC");

var $5uWkR = parcelRequire("5uWkR");

var $3OUtw = parcelRequire("3OUtw");
function $b02e613c96d0614b$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $b02e613c96d0614b$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $b02e613c96d0614b$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($gsv4E)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $b02e613c96d0614b$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
class $b02e613c96d0614b$export$2e2bcd8739ae039 {
    constructor(onEvent, pageVisibility){
        (0, (/*@__PURE__*/$parcel$interopDefault($gsv4E)))(this, "_getEventKey", ({ task: task, taskId: taskId })=>taskId ? `${task}.${taskId}` : task);
        (0, (/*@__PURE__*/$parcel$interopDefault($gsv4E)))(this, "_getEventTimingByName", (name)=>{
            const eventTimings = this._performance.getEntriesByName(name);
            const eventTiming = eventTimings[eventTimings.length - 1];
            return eventTiming;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($gsv4E)))(this, "_getApdexFields", (event)=>{
            const apdexTimings = this._getApdexTimings(event);
            const apdexScore = this._calculateApdex({
                duration: apdexTimings.duration,
                threshold: event.threshold
            });
            return $b02e613c96d0614b$var$_objectSpread($b02e613c96d0614b$var$_objectSpread({}, apdexTimings), {}, {
                apdex: apdexScore
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($gsv4E)))(this, "_getApdexTimings", (event)=>{
            const eventKey = this._getEventKey(event);
            const eventStartName = `${eventKey}-start`;
            const startTime = event.startTime || this._getStartTime(event, eventStartName);
            const stopTime = event.stopTime || this._getStopTime();
            // We do some clean up of the marks and started events
            this._cleanApdexState(eventKey);
            return {
                startTime: startTime,
                stopTime: stopTime,
                duration: stopTime - startTime
            };
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($gsv4E)))(this, "_getStartTime", (event, eventName)=>{
            let startTime;
            const timeOrigin = this._performance.getTimeOrigin();
            if (event.type === (0, $fyxFC.apdexType).INITIAL_LOAD) startTime = timeOrigin;
            else {
                const eventTiming = this._getEventTimingByName(eventName);
                startTime = timeOrigin + eventTiming.startTime;
            }
            return startTime;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($gsv4E)))(this, "_getStopTime", ()=>this._performance.getTimeOrigin() + this._performance.now());
        (0, (/*@__PURE__*/$parcel$interopDefault($gsv4E)))(this, "_cleanApdexState", (eventKey)=>{
            this._performance.clearMarks(`${eventKey}-start`);
            this._performance.clearMarks(`${eventKey}-stop`);
            this._startedEvents.delete(eventKey);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($gsv4E)))(this, "_getVisibilityFields", (event)=>{
            let isActiveTab;
            /**
       * For initialLoad type:
       * 1. if tab was not ever hidden (!_wasPreviouslyHidden)
       *
       * For transition type:
       * 1. active status is tracked in active events map (_isActiveEvents)
       *
       * For any type, if startTime or stopTime is specified:
       * 1. If currently active (!_isHidden)
       */ if (event.type === (0, $fyxFC.apdexType).INITIAL_LOAD) isActiveTab = !this._wasPreviouslyHidden;
            else if (event.type === (0, $fyxFC.apdexType).TRANSITION) {
                const eventKey = this._getEventKey(event);
                isActiveTab = this._isActiveEvents.get(eventKey);
            }
            if (event.startTime || event.stopTime) isActiveTab = !this._pageVisibility.getIsHidden();
            return {
                isActiveTab: isActiveTab
            };
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($gsv4E)))(this, "_calculateApdex", ({ duration: duration, threshold: threshold = this._threshold })=>{
            let apdex;
            const satisfiedThreshold = threshold;
            const tolerableThreshold = threshold * 4;
            if (duration <= satisfiedThreshold) apdex = 1;
            else if (duration <= tolerableThreshold) apdex = 0.5;
            else apdex = 0;
            return apdex;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($gsv4E)))(this, "_validateStartEvent", (event)=>{
            if (!event) throw new Error('Missing "event" in Apdex start event');
            if (!event.task) throw new Error('Missing "task" in Apdex start event');
            if (typeof event.task !== "string") throw new Error('Invalid "task" in Apdex start event');
            if (event.taskId && typeof event.taskId !== "string") throw new Error('Invalid "taskId" in Apdex start event');
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($gsv4E)))(this, "_validateStopEvent", (event)=>{
            if (!event) throw new Error('Missing "event" in Apdex stop event');
            if (!event.task) throw new Error('Missing "task" in Apdex stop event');
            if (typeof event.task !== "string") throw new Error('Invalid "task" in Apdex stop event');
            if (event.taskId && typeof event.taskId !== "string") throw new Error('Invalid "taskId" in Apdex stop event');
            if (!event.type) throw new Error('Missing "type" in Apdex stop event');
            if (event.type && !(0, $fyxFC.isType)((0, $fyxFC.apdexType), event.type)) throw new Error('Invalid "type" in Apdex stop event');
            if (event.threshold && typeof event.threshold !== "number") throw new Error('Invalid "threshold" in Apdex stop event');
            /*
       * For a transition, if the startTime was not specified,
       * the start event should have been present.
       */ if (!event.startTime && event.type === (0, $fyxFC.apdexType).TRANSITION) {
                const eventKey = this._getEventKey(event);
                if (!this._startedEvents.has(eventKey)) throw new Error(`Apdex event transition "${eventKey}" was not started`);
            }
            if (event.startTime && !(typeof event.startTime === "number" && event.startTime >= 0)) throw new Error('Invalid "startTime" in Apdex stop event');
            if (event.stopTime && typeof event.stopTime !== "number") throw new Error('Invalid "stopTime" in Apdex stop event');
            if (event.stopTime <= event.startTime) throw new Error('"stopTime" should be greater than "startTime" in Apdex stop event');
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($gsv4E)))(this, "_shouldSendEvent", (event)=>{
            if (!event) return false;
            if (typeof event.apdex !== "number") return false;
            return true;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($gsv4E)))(this, "_sendEvent", (event, callback)=>{
            if (this._shouldSendEvent(event)) this._onEvent({
                source: "ui",
                action: "readyForUser",
                actionSubject: "ui",
                attributes: $b02e613c96d0614b$var$_objectSpread($b02e613c96d0614b$var$_objectSpread({}, event.additionalAttributes), {}, {
                    task: event.task,
                    taskId: event.taskId,
                    type: event.type,
                    threshold: event.threshold || this._threshold,
                    apdex: event.apdex,
                    startTime: event.startTime,
                    stopTime: event.stopTime,
                    duration: event.duration,
                    isActiveTab: event.isActiveTab
                })
            }, callback);
        });
        if (!onEvent) throw new Error("Missing onEvent callback");
        if (typeof onEvent !== "function") throw new Error("Invalid onEvent, must be function");
        if (!(pageVisibility instanceof (0, $5uWkR.default))) throw new Error("Invalid pageVisibility, must be PageVisibility class");
        this._startedEvents = new Map();
        this._performance = new (0, $3OUtw.default)();
        this._onEvent = onEvent;
        this._threshold = 1000;
        this._wasPreviouslyHidden = pageVisibility.getIsHidden();
        this._isActiveEvents = new Map();
        this._pageVisibility = pageVisibility;
        this._pageVisibility.addCallback("apdexEvent", (isHidden)=>{
            this.onVisibilityChange(!isHidden);
        });
    }
    start(event) {
        this._validateStartEvent(event);
        if (!this._performance.isAvailable()) return;
        const eventKey = this._getEventKey(event);
        const eventStartName = `${eventKey}-start`;
        this._startedEvents.set(eventKey, true);
        this._isActiveEvents.set(eventKey, !this._pageVisibility.getIsHidden());
        this._performance.clearMarks(eventStartName);
        this._performance.mark(eventStartName);
    }
    getStart(event) {
        this._validateStartEvent(event);
        if (!this._performance.isAvailable()) return undefined;
        const eventKey = this._getEventKey(event);
        const eventStartName = `${eventKey}-start`;
        return this._getEventTimingByName(eventStartName);
    }
    stop(event, callback) {
        this._validateStopEvent(event);
        if (!this._performance.isAvailable()) return;
        const apdexFields = this._getApdexFields(event);
        const visibilityFields = this._getVisibilityFields(event);
        this._sendEvent($b02e613c96d0614b$var$_objectSpread($b02e613c96d0614b$var$_objectSpread($b02e613c96d0614b$var$_objectSpread({}, event), apdexFields), visibilityFields), callback);
    }
    onVisibilityChange(isActive) {
        if (!isActive) {
            this._wasPreviouslyHidden = true;
            Array.from(this._isActiveEvents.keys()).forEach((key)=>this._isActiveEvents.set(key, false));
        }
    }
}

});
parcelRegister("5uWkR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $400d01506d96f3cb$export$2e2bcd8739ae039; });

var $gsv4E = parcelRequire("gsv4E");
class $400d01506d96f3cb$export$2e2bcd8739ae039 {
    constructor(){
        (0, (/*@__PURE__*/$parcel$interopDefault($gsv4E)))(this, "_bindEventListeners", ()=>{
            document.addEventListener(this._visibilityChange, this._handleVisibilityChange, false);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($gsv4E)))(this, "_handleVisibilityChange", ()=>{
            const isHidden = document[this._hidden];
            this._isHidden = isHidden;
            this._callbacks.forEach((callbackFn)=>callbackFn(isHidden));
        });
        this._isHidden = false;
        this._callbacks = new Map();
        this._hidden = undefined;
        this._visibilityChange = undefined;
        if (typeof document !== "undefined") {
            if (typeof document.hidden !== "undefined") {
                // Opera 12.10 and Firefox 18 and later support
                this._isHidden = document.hidden;
                this._hidden = "hidden";
                this._visibilityChange = "visibilitychange";
            } else if (typeof document.msHidden !== "undefined") {
                this._isHidden = document.msHidden;
                this._hidden = "msHidden";
                this._visibilityChange = "msvisibilitychange";
            } else if (typeof document.webkitHidden !== "undefined") {
                this._isHidden = document.webkitHidden;
                this._hidden = "webkitHidden";
                this._visibilityChange = "webkitvisibilitychange";
            }
            if (typeof document.addEventListener !== "undefined" && this._hidden !== undefined) this._bindEventListeners();
        }
    }
    addCallback(name, fn) {
        if (typeof name !== "string") throw new Error("Invalid name, must be string");
        if (typeof fn !== "function") throw new Error("Invalid callback, must be function");
        this._callbacks.set(name, fn);
    }
    removeCallback(name) {
        if (this._callbacks.has(name)) this._callbacks.delete(name);
    }
    getIsHidden() {
        return this._isHidden;
    }
}

});

parcelRegister("3OUtw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2c81d96088ee37da$export$2e2bcd8739ae039; });
class $2c81d96088ee37da$export$2e2bcd8739ae039 {
    constructor(){
        this._performance = window.performance;
    }
    clearMarks(...args) {
        if (!this._performance || !this._performance.clearMarks) return;
        this._performance.clearMarks(...args);
    }
    mark(...args) {
        if (!this._performance || !this._performance.mark) return;
        this._performance.mark(...args);
    }
    getEntriesByName(...args) {
        if (!this._performance || !this._performance.getEntriesByName) return [];
        return this._performance.getEntriesByName(...args);
    }
    getTimeOrigin() {
        if (!this._performance || !this._performance.timeOrigin && !this._performance.timing) return 0;
        return this._performance.timeOrigin || this._performance.timing.navigationStart;
    }
    now() {
        if (!this._performance || !this._performance.now) return Date.now ? Date.now() : +new Date();
        return this._performance.now();
    }
    isAvailable() {
        return !!this._performance && !!this._performance.clearMarks && !!this._performance.mark && !!this._performance.getEntriesByName && !!this._performance.timing;
    }
}

});


parcelRegister("3FbWL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2aae77cc74110f0f$export$2e2bcd8739ae039; });
/**
 * Wraps {possibleFn} into a error-safe function and handles cases where {possibleFn}
 * is a function or object
 *
 * @param possibleFn - function that returns and object or the object itself
 * @param errorMessage - error message to log if {possibleFn} is a function and
 *                        throws an error when called
 * @returns {Function}
 */ const $2aae77cc74110f0f$var$isFunction = (possibleFn)=>typeof possibleFn === "function";
var $2aae77cc74110f0f$export$2e2bcd8739ae039 = (possibleFn, errorMessage)=>{
    return ()=>{
        if ($2aae77cc74110f0f$var$isFunction(possibleFn)) try {
            return possibleFn();
        } catch (e) {
            // eslint-disable-next-line no-console
            console.error(`${errorMessage} - ${e instanceof Error ? e.message : String(e)}`);
            return undefined;
        }
        return possibleFn;
    };
};

});

parcelRegister("8svgN", function(module, exports) {

$parcel$export(module.exports, "buildActionFields", function () { return $628931d3d5fc9f15$export$655ecf7241feac42; });
$parcel$export(module.exports, "buildScreenEvent", function () { return $628931d3d5fc9f15$export$c7d9a5f56acc4b19; });
$parcel$export(module.exports, "buildActionName", function () { return $628931d3d5fc9f15$export$9c5623a792efc9b0; });
$parcel$export(module.exports, "buildContext", function () { return $628931d3d5fc9f15$export$3a7fe28f9bf4f3d9; });
$parcel$export(module.exports, "buildActionEvent", function () { return $628931d3d5fc9f15$export$7bf451af4a8e3dd9; });

var $gsv4E = parcelRequire("gsv4E");

var $fyxFC = parcelRequire("fyxFC");

var $8wrzl = parcelRequire("8wrzl");
function $628931d3d5fc9f15$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $628931d3d5fc9f15$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $628931d3d5fc9f15$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($gsv4E)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $628931d3d5fc9f15$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $628931d3d5fc9f15$var$libraryVersion = "4.23.1";
function $628931d3d5fc9f15$var$buildTenantFields(tenantInfo) {
    return {
        tenantIdType: tenantInfo.tenantIdType,
        tenantId: tenantInfo.tenantId
    };
}
function $628931d3d5fc9f15$var$buildUserFields(userInfo) {
    return {
        userIdType: userInfo.userIdType
    };
}
function $628931d3d5fc9f15$var$buildOrgFields(orgInfo) {
    return {
        orgId: orgInfo.orgId
    };
}
function $628931d3d5fc9f15$var$buildWorkspaceFields(workspaceInfo) {
    return {
        workspaceId: workspaceInfo.workspaceId
    };
}
function $628931d3d5fc9f15$var$buildAliases(aliases) {
    if ($628931d3d5fc9f15$var$isNotEmptyObject(aliases)) return {
        aliases: aliases
    };
    return undefined;
}
function $628931d3d5fc9f15$var$buildGroups(groups) {
    if ($628931d3d5fc9f15$var$isNotEmptyObject(groups)) return {
        groups: groups
    };
    return undefined;
}
function $628931d3d5fc9f15$var$buildEventOverrides(event) {
    if (event.anonymousId) return {
        anonymousId: event.anonymousId
    };
    return {};
}
function $628931d3d5fc9f15$var$getProductField(field, override) {
    return override === undefined ? field : override;
}
function $628931d3d5fc9f15$var$buildProductFields(productInfo, productOverrides) {
    const overrides = productOverrides || {};
    const env = $628931d3d5fc9f15$var$getProductField(productInfo.env, overrides.env);
    const product = $628931d3d5fc9f15$var$getProductField(productInfo.product, overrides.product);
    const subproduct = $628931d3d5fc9f15$var$getProductField(productInfo.subproduct(), overrides.subproduct);
    const version = $628931d3d5fc9f15$var$getProductField(productInfo.version, overrides.version);
    const origin = $628931d3d5fc9f15$var$getProductField(productInfo.origin, overrides.origin);
    const platform = $628931d3d5fc9f15$var$getProductField(productInfo.platform, overrides.platform);
    return {
        env: env,
        product: product,
        subproduct: subproduct,
        version: version,
        origin: origin,
        platform: platform
    };
}
function $628931d3d5fc9f15$var$isNotEmptyObject(obj) {
    return (0, $8wrzl.isPlainObject)(obj) && Object.keys(obj).length > 0;
}
function $628931d3d5fc9f15$var$buildAttributesWithName(name, attrObject) {
    return $628931d3d5fc9f15$var$isNotEmptyObject(attrObject) ? {
        [name]: attrObject
    } : undefined;
}
function $628931d3d5fc9f15$var$buildAttributes(attributes) {
    return $628931d3d5fc9f15$var$buildAttributesWithName("attributes", attributes);
}
function $628931d3d5fc9f15$export$3f5115a568819c1a(containers) {
    const validContainers = {};
    Object.keys(containers).forEach((key)=>{
        const value = containers[key];
        validContainers[key] = {
            id: value.id,
            type: value.type
        };
    });
    return validContainers;
}
function $628931d3d5fc9f15$export$f045f238d77c002a(containers) {
    if ($628931d3d5fc9f15$var$isNotEmptyObject(containers)) {
        const validContainers = $628931d3d5fc9f15$export$3f5115a568819c1a(containers);
        return $628931d3d5fc9f15$var$buildAttributesWithName("containers", validContainers);
    }
    return undefined;
}
function $628931d3d5fc9f15$export$655ecf7241feac42(event, actionEventType) {
    return $628931d3d5fc9f15$var$_objectSpread({
        containerType: event.containerType,
        containerId: event.containerId,
        source: event.source,
        objectType: event.objectType,
        objectId: event.objectId,
        actionSubject: event.actionSubject,
        action: event.action,
        actionSubjectId: event.actionSubjectId,
        attributes: event.attributes,
        nonPrivacySafeAttributes: event.nonPrivacySafeAttributes,
        tags: event.tags,
        highPriority: event.highPriority,
        eventType: actionEventType
    }, $628931d3d5fc9f15$export$f045f238d77c002a(event.containers));
}
function $628931d3d5fc9f15$var$buildNonPrivacySafeAttributes(nonPrivacySafeAttributes) {
    return $628931d3d5fc9f15$var$buildAttributesWithName("nonPrivacySafeAttributes", nonPrivacySafeAttributes);
}
function $628931d3d5fc9f15$export$c7d9a5f56acc4b19(productInfo, tenantInfo, userInfo, attributes, nonPrivacySafeAttributes, tags, tabId, sessionId, taskSessions, orgInfo, pageLoadId, workspaceInfo, event, containers, aliases, groups) {
    const productFields = $628931d3d5fc9f15$var$buildProductFields(productInfo);
    const tenantFields = $628931d3d5fc9f15$var$buildTenantFields(tenantInfo);
    const userFields = $628931d3d5fc9f15$var$buildUserFields(userInfo);
    const orgFields = $628931d3d5fc9f15$var$buildOrgFields(orgInfo);
    const workspaceFields = $628931d3d5fc9f15$var$buildWorkspaceFields(workspaceInfo);
    const overrides = {
        title: "",
        path: "",
        url: "",
        referrer: "",
        search: "",
        eventType: (0, $fyxFC.eventType).SCREEN
    };
    return $628931d3d5fc9f15$var$_objectSpread($628931d3d5fc9f15$var$_objectSpread($628931d3d5fc9f15$var$_objectSpread($628931d3d5fc9f15$var$_objectSpread($628931d3d5fc9f15$var$_objectSpread($628931d3d5fc9f15$var$_objectSpread($628931d3d5fc9f15$var$_objectSpread($628931d3d5fc9f15$var$_objectSpread($628931d3d5fc9f15$var$_objectSpread($628931d3d5fc9f15$var$_objectSpread($628931d3d5fc9f15$var$_objectSpread($628931d3d5fc9f15$var$_objectSpread({}, productFields), tenantFields), userFields), orgFields), overrides), $628931d3d5fc9f15$var$buildAttributes(attributes)), $628931d3d5fc9f15$var$buildNonPrivacySafeAttributes(nonPrivacySafeAttributes)), $628931d3d5fc9f15$export$f045f238d77c002a(containers)), $628931d3d5fc9f15$var$buildEventOverrides(event)), {}, {
        tags: tags,
        tabId: tabId,
        sessionId: sessionId,
        taskSessions: taskSessions,
        pageLoadId: pageLoadId
    }, workspaceFields), $628931d3d5fc9f15$var$buildAliases(aliases)), $628931d3d5fc9f15$var$buildGroups(groups));
}
function $628931d3d5fc9f15$export$9c5623a792efc9b0(event) {
    return `${event.actionSubject} ${event.action}`;
}
function $628931d3d5fc9f15$export$3a7fe28f9bf4f3d9(productInfo) {
    const screen = window.screen || {};
    return {
        context: {
            locale: productInfo.locale,
            screen: {
                width: screen.width,
                height: screen.height,
                density: window.devicePixelRatio
            },
            library: {
                name: "analytics.js",
                version: $628931d3d5fc9f15$var$libraryVersion
            }
        }
    };
}
function $628931d3d5fc9f15$export$e3d99b4bfec06f6e(event) {
    const { env: env, product: product, subproduct: subproduct, version: version, origin: origin, platform: platform } = event;
    return {
        env: env,
        product: product,
        subproduct: subproduct,
        version: version,
        origin: origin,
        platform: platform
    };
}
function $628931d3d5fc9f15$export$7bf451af4a8e3dd9(productInfo, tenantInfo, userInfo, event, actionEventType, tabId, sessionId, taskSessions, orgInfo, pageLoadId, workspaceInfo, aliases, groups) {
    const productFields = $628931d3d5fc9f15$var$buildProductFields(productInfo, $628931d3d5fc9f15$export$e3d99b4bfec06f6e(event));
    const tenantFields = $628931d3d5fc9f15$var$buildTenantFields(tenantInfo);
    const orgFields = $628931d3d5fc9f15$var$buildOrgFields(orgInfo);
    const workspaceFields = $628931d3d5fc9f15$var$buildWorkspaceFields(workspaceInfo);
    const userFields = $628931d3d5fc9f15$var$buildUserFields(userInfo);
    const actionFields = $628931d3d5fc9f15$export$655ecf7241feac42(event, actionEventType);
    return $628931d3d5fc9f15$var$_objectSpread($628931d3d5fc9f15$var$_objectSpread($628931d3d5fc9f15$var$_objectSpread($628931d3d5fc9f15$var$_objectSpread($628931d3d5fc9f15$var$_objectSpread($628931d3d5fc9f15$var$_objectSpread($628931d3d5fc9f15$var$_objectSpread($628931d3d5fc9f15$var$_objectSpread($628931d3d5fc9f15$var$_objectSpread({}, productFields), tenantFields), orgFields), userFields), actionFields), $628931d3d5fc9f15$var$buildEventOverrides(event)), {}, {
        tabId: tabId,
        sessionId: sessionId,
        taskSessions: taskSessions,
        pageLoadId: pageLoadId
    }, workspaceFields), $628931d3d5fc9f15$var$buildAliases(aliases)), $628931d3d5fc9f15$var$buildGroups(groups));
}

});
parcelRegister("8wrzl", function(module, exports) {

$parcel$export(module.exports, "isPlainObject", function () { return $6346b28ee89b6966$export$53b83ca8eaab0383; });
// Modified from https://github.com/jonschlinkert/is-plain-object/blob/master/index.js
function $6346b28ee89b6966$var$isObject(val) {
    return val !== null && typeof val === "object" && Array.isArray(val) === false;
}
function $6346b28ee89b6966$var$isObjectObject(o) {
    return $6346b28ee89b6966$var$isObject(o) === true && Object.prototype.toString.call(o) === "[object Object]";
}
function $6346b28ee89b6966$export$53b83ca8eaab0383(o) {
    if ($6346b28ee89b6966$var$isObjectObject(o) === false) return false;
    // If has modified constructor
    const ctor = o.constructor;
    if (typeof ctor !== "function") return false;
    // If has modified prototype
    const prot = ctor.prototype;
    if ($6346b28ee89b6966$var$isObjectObject(prot) === false) return false;
    // If constructor does not have an Object-specific method
    if (!("isPrototypeOf" in prot)) return false;
    // Most likely a plain Object
    return true;
}

});


parcelRegister("f8NDg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b05e1a496596d22f$export$2e2bcd8739ae039; });

var $gsv4E = parcelRequire("gsv4E");

var $5Ifak = parcelRequire("5Ifak");

var $hHjip = parcelRequire("hHjip");

var $fhBQf = parcelRequire("fhBQf");
class $b05e1a496596d22f$export$2e2bcd8739ae039 {
    constructor(fireDelayedEvent, compressors){
        (0, (/*@__PURE__*/$parcel$interopDefault($gsv4E)))(this, "push", (identifier, builtEvent, context, userInfo)=>{
            this.delayQueue.push(identifier, builtEvent, context, userInfo);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($gsv4E)))(this, "startLowPriorityEventDelay", (timeout = (0, $5Ifak.DEFAULT_DELAY_TIMEOUT), callback)=>{
            if (Number.isNaN(timeout) || timeout <= 0) throw new Error(`Invalid timeout period: ${timeout}, must be a number greater than 0`);
            if (this.delayTimeout) clearTimeout(this.delayTimeout);
            const delayTimeoutPeriod = timeout ? Math.min(timeout, (0, $5Ifak.MAX_DELAY_TIMEOUT)) : (0, $5Ifak.MAX_DELAY_TIMEOUT);
            this.delayCallback = callback;
            this.delayTimeout = setTimeout(()=>this.stopLowPriorityEventDelay((0, $fhBQf.StopLowPriorityEventDelayReason).TIMEOUT), delayTimeoutPeriod);
            // If the queue is still flushing from a previous delay period, then we should cancel that flush
            // to stop it from negatively impacting the performance of the new critical section
            this.delayQueue.cancelFlush();
            this.isDelaying = true;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($gsv4E)))(this, "stopLowPriorityEventDelay", (reason = (0, $fhBQf.StopLowPriorityEventDelayReason).MANUAL)=>{
            var _this$delayCallback;
            if (this.delayTimeout) {
                clearTimeout(this.delayTimeout);
                this.delayTimeout = undefined;
            }
            this.delayQueue.startFlush();
            this.isDelaying = false;
            (_this$delayCallback = this.delayCallback) === null || _this$delayCallback === void 0 || _this$delayCallback.call(this, reason);
            this.delayCallback = undefined;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($gsv4E)))(this, "isDelayingLowPriorityEvents", ()=>this.isDelaying);
        this.isDelaying = false;
        this.delayQueue = new (0, $hHjip.default)(fireDelayedEvent, compressors);
    }
}

});
parcelRegister("5Ifak", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_DELAY_TIMEOUT", function () { return $428cd364e45ee3d0$export$cf090d5281b5ae06; });
$parcel$export(module.exports, "MAX_DELAY_TIMEOUT", function () { return $428cd364e45ee3d0$export$8575e30be0feb909; });
const $428cd364e45ee3d0$export$cf090d5281b5ae06 = 10000;
const $428cd364e45ee3d0$export$8575e30be0feb909 = 30000;

});

parcelRegister("hHjip", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ce256b91e2c83c4c$export$2e2bcd8739ae039; });

var $gsv4E = parcelRequire("gsv4E");

var $8svgN = parcelRequire("8svgN");

var $gCau2 = parcelRequire("gCau2");

var $3eeXg = parcelRequire("3eeXg");
// We want to throttle the flush rate so that we don't have a huge upfront performance hit from starting the flush,
// and so that the underlying Segment client has some time to process some events in its queue before more are added.
const $ce256b91e2c83c4c$var$FLUSH_BATCH_SIZE = 7; // aligns with the default batch size of Segment's BatchableQueue
const $ce256b91e2c83c4c$var$FLUSH_BATCH_BACKOFF_PERIOD = 100;
class $ce256b91e2c83c4c$export$2e2bcd8739ae039 {
    constructor(processFn, compressionRules){
        (0, (/*@__PURE__*/$parcel$interopDefault($gsv4E)))(this, "push", (identifier, builtEvent, context, userInfo)=>{
            this.eventArgs.push({
                identifier: identifier,
                builtEvent: builtEvent,
                context: context,
                userInfo: userInfo
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($gsv4E)))(this, "size", ()=>this.eventArgs.length);
        (0, (/*@__PURE__*/$parcel$interopDefault($gsv4E)))(this, "startFlush", ()=>{
            try {
                this.eventArgs = this.compressEventArgs(this.eventArgs);
            } catch (e) {
                // eslint-disable-next-line no-console
                console.warn("Failed to perform compression on the delayed analytics events. " + `Error: ${e.message}. Sending ${this.eventArgs.length} uncompressed events instead`);
            }
            this.flushNextBatch();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($gsv4E)))(this, "cancelFlush", ()=>{
            if (this.flushBatchTimeout) {
                clearTimeout(this.flushBatchTimeout);
                this.flushBatchTimeout = null;
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($gsv4E)))(this, "flushNextBatch", ()=>{
            const batch = this.eventArgs.splice(0, $ce256b91e2c83c4c$var$FLUSH_BATCH_SIZE);
            batch.forEach((item)=>this.processFn(item.identifier, item.builtEvent, item.context, item.userInfo));
            if (this.eventArgs.length > 0) this.flushBatchTimeout = setTimeout(()=>this.flushNextBatch(), $ce256b91e2c83c4c$var$FLUSH_BATCH_BACKOFF_PERIOD);
            else this.flushBatchTimeout = null;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($gsv4E)))(this, "compressEventArgs", (eventArgs)=>{
            const [compressibleEventArgs, incompressibleEventArgs] = (0, $gCau2.partition)(eventArgs, (args)=>this.compressor.canCompress(args.builtEvent));
            // Events can only be compressed together if they share the same context and user info, since these are top-level
            // fields that need to exist on the fired event and can only be set to a single value.
            // We can achieve this by grouping our events by context prior to passing them to the compressor.
            const contextGroups = compressibleEventArgs.reduce((groups, args)=>{
                const matchingGroup = groups.find((group)=>(0, $gCau2.equals)(group.userInfo, args.userInfo) && (0, $gCau2.equals)(group.context, args.context));
                if (matchingGroup) matchingGroup.eventArgs.push(args);
                else groups.push({
                    userInfo: args.userInfo,
                    context: args.context,
                    eventArgs: [
                        args
                    ]
                });
                return groups;
            }, []);
            // Run the compressor on each group
            const allCompressedEventArgs = contextGroups.reduce((acc, group)=>{
                try {
                    const events = group.eventArgs.map((args)=>args.builtEvent);
                    const compressedEvents = this.compressor.compress(events);
                    const compressedEventArgs = compressedEvents.map((compressedEvent)=>({
                            identifier: (0, $8svgN.buildActionName)(compressedEvent),
                            builtEvent: compressedEvent,
                            userInfo: group.userInfo,
                            context: group.context
                        }));
                    return acc.concat(compressedEventArgs);
                } catch (e) {
                    // If anything goes wrong while compressing this group, then just fall back on the
                    // uncompressed events instead. The event compressor already handles errors with invalid
                    // generator functions or results, but this is an extra layer of defense to prevent data
                    // loss in the event of an unexpected error.
                    // eslint-disable-next-line no-console
                    console.warn("Failed to compress some analytics events. " + `Error: ${e.message}. Sending ${group.eventArgs.length} uncompressed events instead`);
                    return group.eventArgs;
                }
            }, []);
            incompressibleEventArgs.forEach((args)=>allCompressedEventArgs.push(args));
            return allCompressedEventArgs;
        });
        this.processFn = processFn;
        this.flushBatchTimeout = null;
        this.eventArgs = [];
        this.compressor = new (0, $3eeXg.default)(compressionRules);
    }
}

});
parcelRegister("gCau2", function(module, exports) {

$parcel$export(module.exports, "mapKeys", function () { return $c18853c476f131e7$export$781522908e4e76a1; });
$parcel$export(module.exports, "pick", function () { return $c18853c476f131e7$export$357523c63a2253b9; });
$parcel$export(module.exports, "omitBy", function () { return $c18853c476f131e7$export$d7a617dda645b4e3; });
$parcel$export(module.exports, "pickBy", function () { return $c18853c476f131e7$export$b460b275d6c6aa0; });
$parcel$export(module.exports, "omit", function () { return $c18853c476f131e7$export$30a06c8d3562193f; });
$parcel$export(module.exports, "equals", function () { return $c18853c476f131e7$export$e9bab7fafb253603; });
$parcel$export(module.exports, "partition", function () { return $c18853c476f131e7$export$b29f828819edca8d; });
/* eslint-disable no-return-assign, no-sequences */ // https://www.30secondsofcode.org/js/s/map-keys
const $c18853c476f131e7$export$781522908e4e76a1 = (obj, fn)=>Object.keys(obj).reduce((acc, k)=>{
        const key = fn(obj[k], k, obj);
        acc[key] = obj[k];
        return acc;
    }, {});
// https://www.30secondsofcode.org/js/s/pick
const $c18853c476f131e7$export$357523c63a2253b9 = (obj, arr)=>arr.reduce((acc, curr)=>(curr in obj && (acc[curr] = obj[curr]), acc), {});
// https://www.30secondsofcode.org/js/s/omit-by
const $c18853c476f131e7$export$d7a617dda645b4e3 = (obj, fn)=>Object.keys(obj).filter((k)=>!fn(obj[k], k)).reduce((acc, key)=>(acc[key] = obj[key], acc), {});
// https://www.30secondsofcode.org/js/s/pick-by
const $c18853c476f131e7$export$b460b275d6c6aa0 = (obj, fn)=>Object.keys(obj).filter((k)=>fn(obj[k], k)).reduce((acc, key)=>(acc[key] = obj[key], acc), {});
// https://www.30secondsofcode.org/js/s/omit
const $c18853c476f131e7$export$30a06c8d3562193f = (obj, arr)=>Object.keys(obj).filter((k)=>arr.indexOf(k) < 0).reduce((acc, key)=>(acc[key] = obj[key], acc), {});
// https://www.30secondsofcode.org/js/s/equals
const $c18853c476f131e7$export$e9bab7fafb253603 = (a, b)=>{
    if (a === b) return true;
    if (a instanceof Date && b instanceof Date) return a.getTime() === b.getTime();
    if (!a || !b || typeof a !== "object" && typeof b !== "object") return a === b;
    if (a.prototype !== b.prototype) return false;
    const keys = Object.keys(a);
    if (keys.length !== Object.keys(b).length) return false;
    return keys.every((k)=>$c18853c476f131e7$export$e9bab7fafb253603(a[k], b[k]));
};
// https://www.30secondsofcode.org/js/s/partition
const $c18853c476f131e7$export$b29f828819edca8d = (arr, fn)=>arr.reduce(// eslint-disable-next-line no-shadow
    (acc, val, i, arr)=>{
        acc[fn(val, i, arr) ? 0 : 1].push(val);
        return acc;
    }, [
        [],
        []
    ]);

});

parcelRegister("3eeXg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $259e47a1b64041e3$export$2e2bcd8739ae039; });

var $gsv4E = parcelRequire("gsv4E");

var $8svgN = parcelRequire("8svgN");

var $gCau2 = parcelRequire("gCau2");

var $1O17y = parcelRequire("1O17y");
function $259e47a1b64041e3$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $259e47a1b64041e3$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $259e47a1b64041e3$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($gsv4E)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $259e47a1b64041e3$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
class $259e47a1b64041e3$export$2e2bcd8739ae039 {
    constructor(compressionRules = []){
        (0, (/*@__PURE__*/$parcel$interopDefault($gsv4E)))(this, "canCompress", (event)=>this.compressionRules.some((compressionRule)=>compressionRule.canCompress(event)));
        (0, (/*@__PURE__*/$parcel$interopDefault($gsv4E)))(this, "compress", (events)=>{
            const groups = this.createGroups(events);
            return groups.reduce((allCompressedEvents, group)=>{
                const groupCompressedEvents = this.compressGroup(group);
                return allCompressedEvents.concat(groupCompressedEvents);
            }, []);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($gsv4E)))(this, "createGroups", (events)=>// Group events based on contextual fields. These fields are anything that is added by the client itself,
            // rather than passed in by the caller (eg. product, org. and tenant info)
            events.reduce((groups, event)=>{
                const matchingCompressor = this.compressionRules.find((compressor)=>compressor.canCompress(event));
                let contextFields;
                if (matchingCompressor) {
                    const actionFields = (0, $8svgN.buildActionFields)(event, event.eventType);
                    contextFields = (0, $gCau2.omit)(event, Object.keys(actionFields));
                }
                const matchingGroup = groups.find((group)=>matchingCompressor === group.compressor && (0, $gCau2.equals)(contextFields, group.contextFields));
                if (matchingGroup) matchingGroup.events.push(event);
                else groups.push({
                    contextFields: contextFields,
                    compressor: matchingCompressor,
                    events: [
                        event
                    ]
                });
                return groups;
            }, []));
        (0, (/*@__PURE__*/$parcel$interopDefault($gsv4E)))(this, "compressGroup", (group)=>{
            // If this group doesn't have any compressor, then the event args are already in their final format
            if (!group.compressor) return group.events;
            try {
                // Run the compressor on the group to generate some new events.
                // The compression function is only expected to return the action fields for each
                // event that it generates, since all other fields are generated by the client.
                const compressedEventActionFields = group.compressor.compress(group.events);
                // Add the context fields to each of the resulting events to inflate them into a full action event
                return compressedEventActionFields.map((actionFields)=>$259e47a1b64041e3$var$_objectSpread($259e47a1b64041e3$var$_objectSpread({}, actionFields), group.contextFields));
            } catch (e) {
                // If we fail to compress the events, then just fall back the uncompressed events
                // so that no data is lost. This can happen if the compression function throws an error
                // or returns some invalid event payloads.
                // eslint-disable-next-line no-console
                console.warn("Failed to compress some analytics events. " + `Error: ${e.message}. Sending ${group.events.length} uncompressed events instead`);
                return group.events;
            }
        });
        if (!Array.isArray(compressionRules)) throw new Error("Event compressors must be constructed with an array of CompressionRules");
        if (!compressionRules.every((rule)=>rule instanceof (0, $1O17y.CompressionRule))) throw new Error("Event compressors can only be constructed with instances of CompressionRule");
        this.compressionRules = compressionRules;
    }
}

});
parcelRegister("1O17y", function(module, exports) {

$parcel$export(module.exports, "CompressionRule", function () { return $150b548e97d1d942$export$89b3253ddfd2e6e8; });

var $gsv4E = parcelRequire("gsv4E");

var $98vWd = parcelRequire("98vWd");

var $gCau2 = parcelRequire("gCau2");
class $150b548e97d1d942$export$89b3253ddfd2e6e8 {
    /**
   * @callback EventPredicate
   * @param {object} event An analytics event
   * @returns {boolean} A flag indicating whether or not the event matches the conditions
   */ /**
   * @callback CompressionFunction
   * @param {Array.<Object>} events A collection of analytics events that match the predicate of this compression rule
   * @returns {Array.<Object>} compressedEvents The compressed analytics events to fire
   */ /**
   * This constructor defines a new rule for compressing analytics events.
   * @param {EventPredicate} predicate
   * @param {CompressionFunction} compressFn
   */ constructor(predicate, compressFn){
        /**
     * This function returns a flag indicating whether or not this instance is capable of compressing the given event.
     * @param event
     * @returns {boolean}
     */ (0, (/*@__PURE__*/$parcel$interopDefault($gsv4E)))(this, "canCompress", (event)=>{
            try {
                return event && (0, $98vWd.isActionEventType)(event.eventType) && this.predicate(event);
            } catch (e) {
                return false;
            }
        });
        /**
     * This function compresses as many events in the given collection as possible.<p>
     * Any events in the given collection that do not match the conditions of {@link canCompress} will be left uncompressed and
     * appended to the end of the resulting array.
     *
     * @param events A collection of analytic events to compress
     * @returns {Array.<Object>} The action fields for the resulting compressed events
     */ (0, (/*@__PURE__*/$parcel$interopDefault($gsv4E)))(this, "compress", (events)=>{
            const [compatibleEvents, incompatibleEvents] = (0, $gCau2.partition)(events, (event)=>this.canCompress(event));
            const compressedEvents = this.compressFn(compatibleEvents);
            if (!compressedEvents) throw new Error("No events were returned from the compression function");
            compressedEvents.forEach((event)=>{
                (0, $98vWd.validateActionEventType)(event.eventType);
                (0, $98vWd.validateActionEvent)(event);
            });
            return compressedEvents.concat(incompatibleEvents);
        });
        if (typeof predicate !== "function") throw new Error("Invalid predicate, must be a function that accepts an event and returns a boolean");
        if (typeof compressFn !== "function") throw new Error("Invalid compressFn, must be a function that both accepts and returns an array of events");
        this.predicate = predicate;
        this.compressFn = compressFn;
    }
}

});
parcelRegister("98vWd", function(module, exports) {

$parcel$export(module.exports, "validateContainers", function () { return $6a6da2a31eb09957$export$e63ea5d8477971d3; });
$parcel$export(module.exports, "isActionEventType", function () { return $6a6da2a31eb09957$export$d19cebda16f7579a; });
$parcel$export(module.exports, "validateActionEventType", function () { return $6a6da2a31eb09957$export$4a8d7476662aebcc; });
$parcel$export(module.exports, "validateActionEvent", function () { return $6a6da2a31eb09957$export$e0c121325c66ed4c; });
$parcel$export(module.exports, "validateScreenEvent", function () { return $6a6da2a31eb09957$export$dc993432a592dc27; });
$parcel$export(module.exports, "validateTrackEvent", function () { return $6a6da2a31eb09957$export$8c014fd74b0c8b99; });
$parcel$export(module.exports, "validateUIEvent", function () { return $6a6da2a31eb09957$export$e5bac0930c812e90; });
$parcel$export(module.exports, "validateOperationalEvent", function () { return $6a6da2a31eb09957$export$1e561554275607ef; });
$parcel$export(module.exports, "validateIdentifyEvent", function () { return $6a6da2a31eb09957$export$c16a4e16aa4026c0; });
$parcel$export(module.exports, "validatePlatform", function () { return $6a6da2a31eb09957$export$801b46c35394d316; });

var $fyxFC = parcelRequire("fyxFC");

var $8wrzl = parcelRequire("8wrzl");
const $6a6da2a31eb09957$var$actionEventTypes = Object.freeze([
    (0, $fyxFC.eventType).OPERATIONAL,
    (0, $fyxFC.eventType).TRACK,
    (0, $fyxFC.eventType).UI
]);
function $6a6da2a31eb09957$export$df8ff30e3c960006(container) {
    if (!(0, $8wrzl.isPlainObject)(container)) throw new Error("properties.containers must be an Object");
    if (!("id" in container)) throw new Error("properties.containers is missing field 'id'");
    if (typeof container.id !== "string") throw new Error("properties.containers.id must be of type String");
    if ("type" in container && typeof container.type !== "string") throw new Error("properties.containers.type must be of type String");
}
function $6a6da2a31eb09957$export$e63ea5d8477971d3(containers) {
    if (!containers) return;
    if (containers && containers.constructor !== Object) throw new Error("properties.containers must be an Object");
    Object.values(containers).forEach((container)=>$6a6da2a31eb09957$export$df8ff30e3c960006(container));
}
function $6a6da2a31eb09957$export$d19cebda16f7579a(type) {
    switch(type){
        case (0, $fyxFC.eventType).OPERATIONAL:
        case (0, $fyxFC.eventType).TRACK:
        case (0, $fyxFC.eventType).UI:
            return true;
        default:
            return false;
    }
}
function $6a6da2a31eb09957$export$4a8d7476662aebcc(type) {
    if (!$6a6da2a31eb09957$export$d19cebda16f7579a(type)) throw new Error(`Invalid action event type: ${type}, must be one of: [${$6a6da2a31eb09957$var$actionEventTypes}]`);
    return true;
}
function $6a6da2a31eb09957$export$e0c121325c66ed4c(event) {
    if (!event) throw new Error("Missing event");
    if (!event.source) throw new Error("Missing event.source");
    if (!event.actionSubject) throw new Error("Missing event.actionSubject");
    if (!event.action) throw new Error("Missing event.action");
    $6a6da2a31eb09957$export$e63ea5d8477971d3(event.containers);
}
function $6a6da2a31eb09957$export$dc993432a592dc27(name) {
    if (!name) throw new Error("Missing name");
}
function $6a6da2a31eb09957$export$8c014fd74b0c8b99(event) {
    $6a6da2a31eb09957$export$e0c121325c66ed4c(event);
}
function $6a6da2a31eb09957$export$39d6334da9a44984(event) {
    if (!event) throw new Error("Missing event");
    if (!event.source) throw new Error("Missing event.source");
    if (!event.actionSubject) throw new Error("Missing event.actionSubject");
}
function $6a6da2a31eb09957$export$e5bac0930c812e90(event) {
    $6a6da2a31eb09957$export$e0c121325c66ed4c(event);
}
function $6a6da2a31eb09957$export$1e561554275607ef(event) {
    $6a6da2a31eb09957$export$e0c121325c66ed4c(event);
}
function $6a6da2a31eb09957$export$c16a4e16aa4026c0(userIdType, userId) {
    if (!userIdType) throw new Error("Missing userIdType");
    if (!userId) throw new Error("Missing userId");
    if (!(0, $fyxFC.isType)((0, $fyxFC.userType), userIdType)) throw new Error(`Invalid userIdType '${userIdType}', ` + `must be an userType: [${(0, $fyxFC.objectValues)((0, $fyxFC.userType))}]`);
}
function $6a6da2a31eb09957$export$801b46c35394d316(productInfo) {
    if (!(0, $fyxFC.isType)((0, $fyxFC.platformType), productInfo.platform)) throw new Error(`Invalid productInfo.platform '${productInfo.platform}', ` + `must be a platformType: [${(0, $fyxFC.objectValues)((0, $fyxFC.platformType))}]`);
    if (productInfo.origin === (0, $fyxFC.originType).DESKTOP && !(0, $fyxFC.isType)((0, $fyxFC.desktopPlatforms), productInfo.platform)) throw new Error(`Invalid productInfo.platform '${productInfo.platform}', ` + "must be one of [mac, linux, windows]");
    if (productInfo.origin === (0, $fyxFC.originType).WEB && !(0, $fyxFC.isType)((0, $fyxFC.webPlatforms), productInfo.platform)) throw new Error(`Invalid productInfo.platform '${productInfo.platform}', must be one of [web, mobileWeb]`);
}

});




parcelRegister("fhBQf", function(module, exports) {

$parcel$export(module.exports, "StopLowPriorityEventDelayReason", function () { return $b205cc1a4b998d52$export$fa6e3729c21cb8f; });
let $b205cc1a4b998d52$export$fa6e3729c21cb8f = /*#__PURE__*/ function(StopLowPriorityEventDelayReason) {
    StopLowPriorityEventDelayReason["TIMEOUT"] = "timeout";
    StopLowPriorityEventDelayReason["MANUAL"] = "manual";
    return StopLowPriorityEventDelayReason;
}({});

});


parcelRegister("9pJLQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6da9f3ef858dc130$export$2e2bcd8739ae039; });

var $gsv4E = parcelRequire("gsv4E");

var $dNSPy = parcelRequire("dNSPy");

var $83IFS = parcelRequire("83IFS");

var $hGMny = parcelRequire("hGMny");

var $2Fl0n = parcelRequire("2Fl0n");

var $ibwVW = parcelRequire("ibwVW");

var $aq8he = parcelRequire("aq8he");

var $5sO2V = parcelRequire("5sO2V");

var $iXGL2 = parcelRequire("iXGL2");

var $94tE9 = parcelRequire("94tE9");
function $6da9f3ef858dc130$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $6da9f3ef858dc130$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $6da9f3ef858dc130$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($gsv4E)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $6da9f3ef858dc130$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
class $6da9f3ef858dc130$export$2e2bcd8739ae039 {
    constructor(options){
        var _this$options;
        // Using anonymous function so it can have the BatchFlushCallback type associated with it
        // And to allow it to not need bind when passing through to ResilieceQueue.
        (0, (/*@__PURE__*/$parcel$interopDefault($gsv4E)))(this, "sendEvents", async (items, callback)=>{
            const httpRetryCount = this.resilienceQueue.getGlobalRetryCount();
            const metricsPayload = this.metrics.getMetricsPayload();
            const metadata = $6da9f3ef858dc130$var$_objectSpread($6da9f3ef858dc130$var$_objectSpread({}, metricsPayload), {}, {
                httpRetryCount: httpRetryCount
            });
            for(let key in metadata)// @ts-ignore Some keys maybe a string, but these will never equal 0
            if (metadata[key] === 0) // @ts-ignore Save space in requests by removing metrics with no impact
            delete metadata[key];
            const eventsWithXID = await this.attachXIDs(items);
            // Calculating sentAt after the XID generation as this may take some time.
            const sentAt = new Date().toISOString();
            const unpackagedEvents = eventsWithXID.map((item)=>{
                item.msg.sentAt = sentAt;
                return item.msg;
            });
            const batchBody = {
                batch: unpackagedEvents,
                sentAt: sentAt,
                metadata: metadata
            };
            try {
                const response = await (0, $aq8he.sendEvents)({
                    url: this.gasv3BatchUrl,
                    batch: batchBody,
                    timeout: this.options.requestTimeout
                });
                this.metrics.subtractFromMetrics(metricsPayload);
                callback(null, response);
            } catch (error) {
                callback(error, null);
            }
        });
        this.options = $6da9f3ef858dc130$var$_objectSpread($6da9f3ef858dc130$var$_objectSpread({}, options), {}, {
            requestTimeout: options.requestTimeout || (0, $ibwVW.DEFAULT_REQUEST_TIMEOUT),
            retryQueueOptions: options.retryQueueOptions || {},
            logger: options.logger || console,
            disableCookiePersistence: options.disableCookiePersistence || false
        });
        this.user = new (0, $iXGL2.default)((_this$options = this.options) === null || _this$options === void 0 ? void 0 : _this$options.disableCookiePersistence);
        this.xidPromiseCallback = options.xidPromiseGetter();
        this.gasv3BatchUrl = `${options.apiHostProtocol}://${options.apiHost}/batch`;
        this.metrics = (0, $hGMny.default)();
        this.resilienceQueue = (0, $83IFS.default)(options.retryQueuePrefix, options.product, this.options.retryQueueOptions, this.options.logger);
        this.resilienceQueue.start(this.sendEvents);
    }
    getUser() {
        return this.user;
    }
    async track(eventName, builtEvent, context, callback) {
        const baseEvent = this.buildBaseEvent(context, (0, $5sO2V.SegmentEventTypes).TRACK, builtEvent);
        const eventWithoutMessageId = $6da9f3ef858dc130$var$_objectSpread($6da9f3ef858dc130$var$_objectSpread({}, baseEvent), {}, {
            type: (0, $5sO2V.SegmentEventTypes).TRACK,
            properties: (0, $94tE9.prepareEventProperties)(builtEvent),
            event: eventName
        });
        const event = $6da9f3ef858dc130$var$_objectSpread($6da9f3ef858dc130$var$_objectSpread({}, eventWithoutMessageId), {}, {
            messageId: this.createMessageId()
        });
        const packagedEvent = this.packageEvent(event);
        await this.resilienceQueue.addItem(packagedEvent);
        if (callback) callback();
    }
    async page(eventName, builtEvent, context, callback) {
        const baseEvent = this.buildBaseEvent(context, (0, $5sO2V.SegmentEventTypes).PAGE, builtEvent);
        const eventWithoutMessageId = $6da9f3ef858dc130$var$_objectSpread($6da9f3ef858dc130$var$_objectSpread({}, baseEvent), {}, {
            type: (0, $5sO2V.SegmentEventTypes).PAGE,
            properties: (0, $94tE9.prepareEventProperties)(builtEvent),
            name: eventName
        });
        const event = $6da9f3ef858dc130$var$_objectSpread($6da9f3ef858dc130$var$_objectSpread({}, eventWithoutMessageId), {}, {
            messageId: this.createMessageId()
        });
        const packagedEvent = this.packageEvent(event);
        await this.resilienceQueue.addItem(packagedEvent);
        if (callback) callback();
    }
    // Segment uses the identifier to update user id which we have already done in the analyticsWebClient.ts
    async identify(_identifier, builtEvent, context, callback) {
        const baseEvent = this.buildBaseEvent(context, (0, $5sO2V.SegmentEventTypes).IDENTIFY, builtEvent);
        const eventWithoutMessageId = $6da9f3ef858dc130$var$_objectSpread($6da9f3ef858dc130$var$_objectSpread({}, baseEvent), {}, {
            type: (0, $5sO2V.SegmentEventTypes).IDENTIFY,
            traits: (0, $94tE9.prepareEventProperties)(builtEvent)
        });
        const event = $6da9f3ef858dc130$var$_objectSpread($6da9f3ef858dc130$var$_objectSpread({}, eventWithoutMessageId), {}, {
            messageId: this.createMessageId()
        });
        const packagedEvent = this.packageEvent(event);
        await this.resilienceQueue.addItem(packagedEvent);
        if (callback) callback();
    }
    buildBaseEvent(context, type, overrides) {
        const clonedContext = (0, $94tE9.prepareEventProperties)(context);
        const segmentContext = (0, $94tE9.buildContext)(clonedContext);
        return {
            context: segmentContext,
            timestamp: new Date().toISOString(),
            type: type,
            userId: this.user.getUserId(),
            anonymousId: overrides.anonymousId || this.user.getAnonymousId()
        };
    }
    createMessageId() {
        return `ajs-${(0, (/*@__PURE__*/$parcel$interopDefault($dNSPy)))()}`;
    }
    packageEvent(event) {
        const { apiHost: apiHost, apiHostProtocol: apiHostProtocol } = this.options;
        return {
            headers: {
                "Content-Type": "text/plain"
            },
            msg: event,
            url: `${apiHostProtocol}://${apiHost}/${event.type.charAt(0)}`
        };
    }
    async attachXIDs(items) {
        if (this.xidPromiseCallback) return (0, $2Fl0n.attachXidToMultipleEvents)(items, this.xidPromiseCallback);
        return Promise.resolve(items);
    }
}

});
parcelRegister("83IFS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5de141f199309068$export$2e2bcd8739ae039; });

var $ctQpK = parcelRequire("ctQpK");

var $5de141f199309068$export$2e2bcd8739ae039 = (retryQueuePrefix, product, options, logger)=>{
    return new (0, $ctQpK.default)(retryQueuePrefix, product, options || {}, logger);
};

});
parcelRegister("ctQpK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9160d9db2f6c6872$export$2e2bcd8739ae039; });

var $gsv4E = parcelRequire("gsv4E");

var $iSYQt = parcelRequire("iSYQt");
var $jkXwx = parcelRequire("jkXwx");

var $cD9HP = parcelRequire("cD9HP");
var $fjy1X = parcelRequire("fjy1X");
var $gSeGD = parcelRequire("gSeGD");

var $hGMny = parcelRequire("hGMny");

var $3bJIO = parcelRequire("3bJIO");

var $bPP5g = parcelRequire("bPP5g");
var $lfwlA = parcelRequire("lfwlA");

var $5gKez = parcelRequire("5gKez");
function $9160d9db2f6c6872$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $9160d9db2f6c6872$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $9160d9db2f6c6872$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($gsv4E)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $9160d9db2f6c6872$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $9160d9db2f6c6872$var$ONE_MINUTE = 60000;
const $9160d9db2f6c6872$var$LONG_POLLING_OPTIONS = {
    backoffFactor: 0,
    backoffJitterPercentage: 0,
    flushWaitMs: $9160d9db2f6c6872$var$ONE_MINUTE,
    minRetryDelay: $9160d9db2f6c6872$var$ONE_MINUTE,
    maxRetryDelay: $9160d9db2f6c6872$var$ONE_MINUTE
};
const $9160d9db2f6c6872$export$d219df4fe04c04a7 = {
    backoffFactor: 2,
    backoffJitterPercentage: 0.2,
    batchFlushSize: 7,
    flushBeforeUnload: false,
    flushWaitMs: 500,
    maxAttempts: 10,
    // TODO figure out this number. For indexeddb we are sharing the queue with all tabs
    maxItems: 1000,
    maxRetryDelay: 30000,
    minRetryDelay: 1000
};
class $9160d9db2f6c6872$export$2e2bcd8739ae039 {
    constructor(queuePrefix, product, options, logger){
        this.queuePrefix = queuePrefix;
        // Avoiding using options in ResilienceDB at this stage as
        // the options are optimised for the PushBatchableQueue
        this.resilience = new (0, $fjy1X.default)(product, {
            logger: logger,
            maxAttempts: options === null || options === void 0 ? void 0 : options.maxAttempts,
            maxEventLimit: options === null || options === void 0 ? void 0 : options.maxItems
        });
        this.options = this.buildOptions(options);
        this.scheduler = new (0, $bPP5g.default)($9160d9db2f6c6872$var$_objectSpread($9160d9db2f6c6872$var$_objectSpread({}, this.options), {}, {
            waitInterval: options !== null && options !== void 0 && options.flushBeforeUnload ? 0 : this.options.flushWaitMs
        }), this.scheduleCallback.bind(this));
        this.longPollingScheduler = new (0, $bPP5g.default)($9160d9db2f6c6872$var$_objectSpread($9160d9db2f6c6872$var$_objectSpread({}, $9160d9db2f6c6872$var$LONG_POLLING_OPTIONS), {}, {
            waitInterval: $9160d9db2f6c6872$var$LONG_POLLING_OPTIONS.flushWaitMs
        }), this.scheduleLongCallBack.bind(this));
        this.metricsCollector = (0, $hGMny.default)();
        this.networkStatus = new (0, $3bJIO.default)((status)=>{
            if (status === (0, $5gKez.NetworkStatusEnum).OFFLINE) this.scheduler.stop();
            else this.checkEventCountAndReschedule();
        });
    }
    start(flushCallback) {
        this.batchFlushCallback = flushCallback;
        this.longPollingScheduler.schedule();
    }
    stop() {
        this.scheduler.stop();
        this.longPollingScheduler.stop();
    }
    async addItem(item) {
        // Since Jira and Confluence use `.toJSON` on objects that should be strings
        // And expect us to use `JSON.stringify` on these objects,
        // And indexeddb strips these functions from the objects when adding them to the DB,
        // We must run this silly stringify and parse before passing the event to the resilience meechanism.
        // Planning on removing this in v4
        const jsonStringifiedAndParsedItem = JSON.parse(JSON.stringify(item));
        const { numberOfEvictedItems: numberOfEvictedItems } = await this.resilience.addItem(jsonStringifiedAndParsedItem, {}, (0, $gSeGD.GuardPolicy).EVICT);
        this.scheduler.schedule();
        this.metricsCollector.addToEventCount();
        if (numberOfEvictedItems > 0) this.metricsCollector.addToItemsDiscardedByOverflowCounter(numberOfEvictedItems);
    }
    getGlobalRetryCount() {
        return this.scheduler.getFailureCount();
    }
    async scheduleCallback(done) {
        // Even though we stopped the scheduler, it can be restarted with a call to schedule.
        // This could be triggered by a new event or the longPollingScheduler
        if (this.networkStatus.getNetworkStatus() === (0, $5gKez.NetworkStatusEnum).OFFLINE) {
            done((0, $lfwlA.DoneState).NOOP);
            return;
        }
        try {
            const result = await this.resilience.processItems(this.flush.bind(this), this.options.batchFlushSize);
            done(result);
        } catch (error) {
            if (error.name === (0, $cD9HP.CallbackProcessingErrorName)) {
                done((0, $lfwlA.DoneState).ERROR);
                return;
            }
        // TODO we can probably log here but throwing is useless as it will just be shallowed by the Scheduler
        // In theory something else should catch all other errors from indexeddb and this should never happen.
        } finally{
            await this.checkEventCountAndReschedule();
        }
    }
    async checkEventCountAndReschedule() {
        const eventWaitingCount = await this.resilience.getItemCount();
        if (eventWaitingCount > 0) this.scheduler.schedule({
            immediate: eventWaitingCount >= this.options.batchFlushSize
        });
    }
    async scheduleLongCallBack(done) {
        // Eventually we will want to send data about how many queues were purged
        const numberOfQueuesPurged = (0, $iSYQt.default)(this.queuePrefix);
        this.metricsCollector.addToPurgedQueuesMetrics(numberOfQueuesPurged);
        // Eventually we will want to send data about how attempted reclaims and actual reclaims were made
        const reclaimMetrics = await (0, $jkXwx.default)(this.queuePrefix, async (localStorageItems)=>{
            const itemsToAdd = localStorageItems.map((localStorageItem)=>({
                    item: localStorageItem.item,
                    retryAttempts: localStorageItem.attemptNumber,
                    id: localStorageItem.id
                }));
            const { items: addedEvents } = await this.resilience.bulkAddItem(itemsToAdd, (0, $gSeGD.GuardPolicy).IGNORE);
            if (addedEvents.length === itemsToAdd.length) return {
                status: "successful"
            };
            else return {
                status: "partial",
                acceptedItemIds: addedEvents.map((event)=>event.id)
            };
        });
        this.metricsCollector.addToReclaimMetrics(reclaimMetrics);
        // We dont want to flush events from here as there maybe issues with analytics-service
        // Scheduler has all the context and can schedule the next batch accordingly
        await this.checkEventCountAndReschedule();
        done((0, $lfwlA.DoneState).SUCCESS);
        this.longPollingScheduler.schedule();
    }
    flush(wrappedItems, otherMetadata) {
        this.metricsCollector.setResilienceMechanism(this.resilience.storeType());
        const { batchFlushCallback: batchFlushCallback } = this;
        if (!batchFlushCallback) throw new Error("batchFlushCallback has not been set. Call PullBatchableQueue#start first.");
        return new Promise((resolve, reject)=>{
            if (wrappedItems.length <= 0) {
                resolve((0, $lfwlA.DoneState).NOOP);
                return;
            }
            const items = wrappedItems.map((wrappedItem)=>{
                const item = wrappedItem.item;
                if (wrappedItem.retryAttempts > 0 && item.msg) {
                    if (!item.msg._metadata) item.msg._metadata = {};
                    item.msg._metadata.failedAttempts = wrappedItem.retryAttempts;
                }
                return item;
            });
            batchFlushCallback(items, (error)=>{
                if (error) {
                    if (otherMetadata.numberOfDeletedItems > 0) this.metricsCollector.addToItemsDiscardedByRetryCounter(otherMetadata.numberOfDeletedItems);
                    reject(error);
                } else resolve((0, $lfwlA.DoneState).SUCCESS);
            });
        });
    }
    buildOptions(options) {
        return {
            backoffFactor: (options === null || options === void 0 ? void 0 : options.backoffFactor) || $9160d9db2f6c6872$export$d219df4fe04c04a7.backoffFactor,
            backoffJitterPercentage: (options === null || options === void 0 ? void 0 : options.backoffJitterPercentage) !== undefined ? options.backoffJitterPercentage : $9160d9db2f6c6872$export$d219df4fe04c04a7.backoffJitterPercentage,
            batchFlushSize: (options === null || options === void 0 ? void 0 : options.batchFlushSize) || $9160d9db2f6c6872$export$d219df4fe04c04a7.batchFlushSize,
            flushBeforeUnload: (options === null || options === void 0 ? void 0 : options.flushBeforeUnload) || $9160d9db2f6c6872$export$d219df4fe04c04a7.flushBeforeUnload,
            flushWaitMs: (options === null || options === void 0 ? void 0 : options.flushWaitMs) || $9160d9db2f6c6872$export$d219df4fe04c04a7.flushWaitMs,
            maxItems: (options === null || options === void 0 ? void 0 : options.maxItems) || $9160d9db2f6c6872$export$d219df4fe04c04a7.maxItems,
            maxAttempts: (options === null || options === void 0 ? void 0 : options.maxAttempts) || $9160d9db2f6c6872$export$d219df4fe04c04a7.maxAttempts,
            maxRetryDelay: (options === null || options === void 0 ? void 0 : options.maxRetryDelay) || $9160d9db2f6c6872$export$d219df4fe04c04a7.maxRetryDelay,
            minRetryDelay: (options === null || options === void 0 ? void 0 : options.minRetryDelay) || $9160d9db2f6c6872$export$d219df4fe04c04a7.minRetryDelay
        };
    }
}

});
parcelRegister("iSYQt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dbfc77c5ac3b3b99$export$2e2bcd8739ae039; });

var $bRiG0 = parcelRequire("bRiG0");

var $5ti4W = parcelRequire("5ti4W");
// For more details on this funciton, see https://hello.atlassian.net/wiki/spaces/MEASURE/pages/585086028/Investigation+Local+storage+full
// TL;DR
// If a queue looses its `ack` key in localstorage, it will never get claimed.
// There is a small chance that this can happen.
// This function is to run through queues and clean any that have been orphaned.
// Keys stolen from https://github.com/segmentio/localstorage-retry/blob/master/lib/index.js#L55
const $dbfc77c5ac3b3b99$var$validSuffixs = Object.values((0, $bRiG0.LocalStorageKeySuffix));
var $dbfc77c5ac3b3b99$export$2e2bcd8739ae039 = (prefix)=>{
    if (typeof prefix !== "string" || prefix.length === 0) // We do not want to start deleting everything in localstorage
    return 0;
    try {
        const queueStates = Object.keys(localStorage).filter((key)=>key && key.startsWith(`${prefix}.`) || false).map((key)=>key.split(".")).filter((splitKeys)=>splitKeys.length === 3 && $dbfc77c5ac3b3b99$var$validSuffixs.includes(splitKeys[2])).reduce((accumulator, currentKeys)=>{
            const [, id, suffix] = currentKeys;
            if (accumulator[id] === undefined) accumulator[id] = {};
            accumulator[id][suffix] = true;
            return accumulator;
        }, {});
        const queuesToPurge = Object.keys(queueStates).filter((id)=>queueStates[id][(0, $bRiG0.LocalStorageKeySuffix).ACK] !== true);
        queuesToPurge.forEach((id)=>{
            const { queue: queue, inProgress: inProgress, reclaimStart: reclaimStart, reclaimEnd: reclaimEnd } = (0, $5ti4W.createLocalStorageKeys)(prefix, id);
            localStorage.removeItem(inProgress);
            localStorage.removeItem(queue);
            localStorage.removeItem(reclaimStart);
            localStorage.removeItem(reclaimEnd);
        });
        return queuesToPurge.length;
    } catch (_error) {
    // Ignore errors from localStorage.
    }
    return 0;
};

});
parcelRegister("bRiG0", function(module, exports) {

$parcel$export(module.exports, "LocalStorageKeySuffix", function () { return $8a2321b03c6dac58$export$ecfa71cbc9b28241; });
$parcel$export(module.exports, "Timers", function () { return $8a2321b03c6dac58$export$8bb2c1fb2b1765a9; });
let $8a2321b03c6dac58$export$ecfa71cbc9b28241 = /*#__PURE__*/ function(LocalStorageKeySuffix) {
    LocalStorageKeySuffix["IN_PROGRESS"] = "inProgress";
    LocalStorageKeySuffix["QUEUE"] = "queue";
    LocalStorageKeySuffix["RECLAIM_START"] = "reclaimStart";
    LocalStorageKeySuffix["RECLAIM_END"] = "reclaimEnd";
    LocalStorageKeySuffix["ACK"] = "ack";
    return LocalStorageKeySuffix;
}({});
let $8a2321b03c6dac58$export$8bb2c1fb2b1765a9 = /*#__PURE__*/ function(Timers) {
    Timers[Timers["RECLAIM_TIMEOUT"] = 10000] = "RECLAIM_TIMEOUT";
    Timers[Timers["RECLAIM_WAIT"] = 500] = "RECLAIM_WAIT";
    Timers[Timers["RECLAIM_WAIT_THRESHOLD"] = 2000] = "RECLAIM_WAIT_THRESHOLD";
    return Timers;
}({});

});

parcelRegister("5ti4W", function(module, exports) {

$parcel$export(module.exports, "createLocalStorageKeys", function () { return $3fbdaf38d3b0fa47$export$8433d54f767cbec5; });

var $bRiG0 = parcelRequire("bRiG0");
const $3fbdaf38d3b0fa47$export$8433d54f767cbec5 = (queuePrefix, queueId)=>({
        [(0, $bRiG0.LocalStorageKeySuffix).ACK]: `${queuePrefix}.${queueId}.${(0, $bRiG0.LocalStorageKeySuffix).ACK}`,
        [(0, $bRiG0.LocalStorageKeySuffix).QUEUE]: `${queuePrefix}.${queueId}.${(0, $bRiG0.LocalStorageKeySuffix).QUEUE}`,
        [(0, $bRiG0.LocalStorageKeySuffix).IN_PROGRESS]: `${queuePrefix}.${queueId}.${(0, $bRiG0.LocalStorageKeySuffix).IN_PROGRESS}`,
        [(0, $bRiG0.LocalStorageKeySuffix).RECLAIM_START]: `${queuePrefix}.${queueId}.${(0, $bRiG0.LocalStorageKeySuffix).RECLAIM_START}`,
        [(0, $bRiG0.LocalStorageKeySuffix).RECLAIM_END]: `${queuePrefix}.${queueId}.${(0, $bRiG0.LocalStorageKeySuffix).RECLAIM_END}`
    });

});


parcelRegister("jkXwx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e13e0ebff4038e10$export$2e2bcd8739ae039; });

var $gsv4E = parcelRequire("gsv4E");

var $dNSPy = parcelRequire("dNSPy");

var $bRiG0 = parcelRequire("bRiG0");

var $5ti4W = parcelRequire("5ti4W");
function $e13e0ebff4038e10$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $e13e0ebff4038e10$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $e13e0ebff4038e10$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($gsv4E)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $e13e0ebff4038e10$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
// Code we need to mimic:
// https://github.com/segmentio/localstorage-retry/blob/master/lib/index.js#L262-L357
// Note we do not want to run this library due to the performance, duplication and memory leak issues.
const $e13e0ebff4038e10$var$promisedSetTimeout = (msToWait)=>new Promise((resolve)=>{
        setTimeout(resolve, msToWait);
    });
const $e13e0ebff4038e10$var$findOtherQueues = (queuePrefix)=>{
    try {
        return Object.keys(localStorage).filter((key)=>key.startsWith(queuePrefix)).map((key)=>key.split(".")).filter((split)=>{
            if (split.length === 3 && split[0] === queuePrefix && split[2] === (0, $bRiG0.LocalStorageKeySuffix).ACK) try {
                const ackTimestamp = localStorage.getItem(split.join("."));
                if (ackTimestamp) {
                    const ackTimestampNumber = parseInt(ackTimestamp);
                    return (0, $bRiG0.Timers).RECLAIM_TIMEOUT + ackTimestampNumber < Date.now();
                }
            } catch (error) {
            // ignore and drop value
            }
            return false;
        }).map((split)=>split[1]);
    } catch (_error) {
    // Ignore errors from accessing localStorage.
    }
    return [];
};
const $e13e0ebff4038e10$var$tryReclaim = async (options, callback)=>{
    const { ack: ack, reclaimStart: reclaimStart, reclaimEnd: reclaimEnd } = options.storageKeys;
    const start = Date.now();
    localStorage.setItem(reclaimStart, options.reclaimProcessId);
    localStorage.setItem(ack, start.toString());
    await $e13e0ebff4038e10$var$promisedSetTimeout((0, $bRiG0.Timers).RECLAIM_WAIT);
    if (// Prevent duplicates when extracting events from localstorage due to CPU / Memory pressure on client
    Date.now() > start + (0, $bRiG0.Timers).RECLAIM_WAIT_THRESHOLD || // Either the parent has caught up and removed our claim, or someone else started a claim instead
    localStorage.getItem(reclaimStart) !== options.reclaimProcessId) throw new Error("Took to long to callback, reclaim abandonded. After reclaimStart.");
    localStorage.setItem(reclaimEnd, options.reclaimProcessId);
    await $e13e0ebff4038e10$var$promisedSetTimeout((0, $bRiG0.Timers).RECLAIM_WAIT);
    if (// Prevent duplicates when extracting events from localstorage due to CPU / Memory pressure on client
    Date.now() > start + (0, $bRiG0.Timers).RECLAIM_WAIT_THRESHOLD || // Either the parent has caught up and removed our claim, or someone else started a claim instead
    localStorage.getItem(reclaimStart) !== options.reclaimProcessId || localStorage.getItem(reclaimEnd) !== options.reclaimProcessId) throw new Error("Took to long to callback, reclaim abandonded. After reclaimEnd.");
    return $e13e0ebff4038e10$var$reclaim(options, callback);
};
const $e13e0ebff4038e10$var$reclaim = async (options, callback)=>{
    const { queue: queue, inProgress: inProgress } = options.storageKeys;
    // Queue is an array of events while inProgress is an object with a uuid for key
    // Either of these queues may legitimately be missing.
    const eventsInQueue = JSON.parse(localStorage.getItem(queue) || "[]");
    const eventsInProgress = JSON.parse(localStorage.getItem(inProgress) || "{}");
    const arrayOfEventsInProgress = Object.entries(eventsInProgress).map(([key, item])=>{
        const itemWithId = $e13e0ebff4038e10$var$_objectSpread($e13e0ebff4038e10$var$_objectSpread({}, item), {}, {
            // LocalStorage-retry would add the attemptCounter after failure, rather than
            // as it was being processed
            attemptNumber: item.attemptNumber + 1,
            id: key
        });
        return itemWithId;
    });
    const eventsToProcess = [
        ...eventsInQueue,
        ...arrayOfEventsInProgress
    ];
    if (eventsToProcess.length > 0) {
        const result = await callback(eventsToProcess);
        if (result.status === "successful") $e13e0ebff4038e10$var$clearLocalStorageKeys(options.storageKeys);
        else if (result.status === "partial") {
            // Dont delete all events if we are only able to take some of them.
            const leftover = eventsToProcess.filter((event)=>!result.acceptedItemIds.includes(event.id));
            // This way around, we can almost ensure that we wont hit memory quota exceeded errors.
            // However, there is a very small chance that we may lose events if the process exits between these two commands.
            localStorage.removeItem(inProgress);
            localStorage.setItem(queue, JSON.stringify(leftover));
            return {
                fullReclaim: false
            };
        }
    } else $e13e0ebff4038e10$var$clearLocalStorageKeys(options.storageKeys);
    return {
        fullReclaim: true
    };
};
// Exterminate
const $e13e0ebff4038e10$var$clearLocalStorageKeys = (keys)=>{
    // Always good to do queue and inprogress first to reduce duplications
    // and to free up more space in localstorage
    localStorage.removeItem(keys.queue);
    localStorage.removeItem(keys.inProgress);
    localStorage.removeItem(keys.reclaimEnd);
    localStorage.removeItem(keys.reclaimStart);
    // This has to be last or we risk leaving things in localStorage that have to be purged
    localStorage.removeItem(keys.ack);
};
var $e13e0ebff4038e10$export$2e2bcd8739ae039 = async (queuePrefix, callback)=>{
    if (typeof queuePrefix !== "string" || queuePrefix.length === 0) // We do not want to start deleting everything in localstorage
    return {
        fullReclaims: 0,
        partialReclaims: 0,
        failedReclaims: 0
    };
    const reclaimProcessId = (0, (/*@__PURE__*/$parcel$interopDefault($dNSPy)))();
    const queuesToReclaim = $e13e0ebff4038e10$var$findOtherQueues(queuePrefix);
    const claims = queuesToReclaim.map((id)=>$e13e0ebff4038e10$var$tryReclaim({
            queuePrefix: queuePrefix,
            reclaimProcessId: reclaimProcessId,
            storageKeys: (0, $5ti4W.createLocalStorageKeys)(queuePrefix, id)
        }, callback));
    const settledClaims = await Promise.allSettled(claims);
    const failedReclaims = settledClaims.filter((claim)=>claim.status === "rejected");
    const successfulClaims = settledClaims.filter((settledValue)=>settledValue.status === "fulfilled").map((result)=>result.value);
    const fullReclaims = successfulClaims.filter((claim)=>claim.fullReclaim);
    const partialReclaims = successfulClaims.filter((claim)=>!claim.fullReclaim);
    return {
        failedReclaims: failedReclaims.length,
        partialReclaims: partialReclaims.length,
        fullReclaims: fullReclaims.length
    };
};

});

parcelRegister("cD9HP", function(module, exports) {

$parcel$export(module.exports, "CallbackProcessingErrorName", function () { return $9320a7f0c59ac3b7$export$a409c8de90e11e14; });
$parcel$export(module.exports, "default", function () { return $9320a7f0c59ac3b7$export$2e2bcd8739ae039; });
const $9320a7f0c59ac3b7$export$a409c8de90e11e14 = "CallbackProcessingError";
class $9320a7f0c59ac3b7$export$2e2bcd8739ae039 extends Error {
    constructor(error){
        const messageFromError = error && typeof error === "object" && "toString" in error && typeof error.toString === "function" && error.toString();
        const messageFromString = typeof error === "string" && error;
        const message = messageFromError || messageFromString || "Argument passed to CallbackProcessingError was not an Error or string.";
        super(`Error thrown while processing events in callback: ${message}`);
        // Must reset the prototypes after calling super of builtin classes
        // https://github.com/Microsoft/TypeScript/wiki/Breaking-Changes#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, $9320a7f0c59ac3b7$export$2e2bcd8739ae039.prototype);
        this.name = $9320a7f0c59ac3b7$export$a409c8de90e11e14;
    }
}

});

parcelRegister("fjy1X", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b26307220e839a5d$export$2e2bcd8739ae039; });

var $iZMkl = parcelRequire("iZMkl");

var $gSeGD = parcelRequire("gSeGD");

var $cD9HP = parcelRequire("cD9HP");
var $b26307220e839a5d$export$2e2bcd8739ae039 = (0, $iZMkl.default);

});
parcelRegister("iZMkl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dd436948347f09e2$export$2e2bcd8739ae039; });

var $gSeGD = parcelRequire("gSeGD");

var $5NRmD = parcelRequire("5NRmD");
var $1pIS3 = parcelRequire("1pIS3");

var $djlpt = parcelRequire("djlpt");

var $8LJQU = parcelRequire("8LJQU");

var $bZFva = parcelRequire("bZFva");
class $dd436948347f09e2$export$2e2bcd8739ae039 {
    constructor(namespace, options = {}){
        this.namespace = namespace;
        this.options = (0, $bZFva.createOptionsWithDefaults)(options);
        if (!namespace || namespace.length === 0 || typeof namespace !== "string") throw new Error("Invalid namespace provided");
        this.resilience = this.getResilienceMechanism(namespace, options);
    }
    getResilienceMechanism(namespace, options) {
        if (!options.useMemory) try {
            return new (0, $djlpt.default)(namespace, options);
        } catch (error) {
            if (!(error instanceof (0, $5NRmD.default))) {
                var _options$logger;
                (_options$logger = options.logger) === null || _options$logger === void 0 || _options$logger.warn("Attempted to create IndexedDbResilience but failed. Using memory instead.");
            }
        }
        return new (0, $8LJQU.default)(this.namespace, options);
    }
    addItem(item, options, policy = (0, $gSeGD.GuardPolicy).ABANDON) {
        return this.runOrFailOver(()=>this.resilience.addItem(item, options, policy));
    }
    bulkAddItem(itemOptions, policy = (0, $gSeGD.GuardPolicy).ABANDON) {
        return this.runOrFailOver(()=>this.resilience.bulkAddItem(itemOptions, policy));
    }
    getItems(count) {
        return this.runOrFailOver(()=>this.resilience.getItems(count));
    }
    deleteItems(itemIds) {
        return this.runOrFailOver(()=>this.resilience.deleteItems(itemIds));
    }
    getItemCount() {
        return this.runOrFailOver(()=>this.resilience.getItemCount());
    }
    processItems(processFn, count) {
        return this.runOrFailOver(()=>this.resilience.processItems(processFn, count));
    }
    storeType() {
        return this.resilience.storeType();
    }
    async runOrFailOver(runnable) {
        try {
            return await runnable();
        } catch (error) {
            if ((0, $1pIS3.shouldIgnoreResilienceDbError)(error)) throw error;
            else if (this.resilience.storeType() === (0, $gSeGD.StoreType).INDEXEDDB) await this.failOver();
            return runnable();
        }
    }
    async failOver() {
        // Attempt to get any events we can and put them into memory
        const oldResilience = this.resilience;
        const newResilience = new (0, $8LJQU.default)(this.namespace, this.options);
        this.resilience = newResilience;
        try {
            const { items: items } = await oldResilience.getItems(this.options.maxEventLimit);
            if (items.length > 0) {
                const bulkAddItemsResponse = await newResilience.bulkAddItemWrapperType(items, (0, $gSeGD.GuardPolicy).IGNORE);
                const addedItemIds = bulkAddItemsResponse.items.map((item)=>item.id);
                await oldResilience.deleteItems(addedItemIds);
            }
        } catch (error) {
            this.options.logger.warn("Unexpected error from ResilienceDb, switching to MemoryDb");
        // Dont need to catch. We are just getting events if we can
        }
    }
}

});
parcelRegister("gSeGD", function(module, exports) {

$parcel$export(module.exports, "NAMESPACE_AND_TIME_ADDED_INDEX", function () { return $c48d14f93a782cba$export$d21fbb25eb37b5bf; });
$parcel$export(module.exports, "RESILIENCE_DB_NAME", function () { return $c48d14f93a782cba$export$8cad224051643259; });
$parcel$export(module.exports, "RESILIENCE_STORE_NAME", function () { return $c48d14f93a782cba$export$3d8420be07b276ab; });
$parcel$export(module.exports, "TIME_TO_PROCESS_AFTER_INDEX", function () { return $c48d14f93a782cba$export$a512a65455fce2a6; });
$parcel$export(module.exports, "TIME_ADDED_INDEX", function () { return $c48d14f93a782cba$export$89d9c1ff8ac91862; });
$parcel$export(module.exports, "RETRY_INDEX", function () { return $c48d14f93a782cba$export$a37d385bcd713809; });
$parcel$export(module.exports, "INDEXEDDB_TIMEOUT", function () { return $c48d14f93a782cba$export$6d8635fed0e4b14d; });
$parcel$export(module.exports, "StoreType", function () { return $c48d14f93a782cba$export$39337ab5872e9457; });
$parcel$export(module.exports, "GuardPolicy", function () { return $c48d14f93a782cba$export$7710d69e6f450f20; });
const $c48d14f93a782cba$export$d21fbb25eb37b5bf = "namespace-timeAdded";
const $c48d14f93a782cba$export$8cad224051643259 = "analytics-web-client";
const $c48d14f93a782cba$export$3d8420be07b276ab = "analytics-resilience";
const $c48d14f93a782cba$export$a512a65455fce2a6 = "timeToBeProcessedAfter";
const $c48d14f93a782cba$export$89d9c1ff8ac91862 = "timeAdded";
const $c48d14f93a782cba$export$a37d385bcd713809 = "retryAttempts";
const $c48d14f93a782cba$export$6d8635fed0e4b14d = 15000;
let $c48d14f93a782cba$export$39337ab5872e9457 = /*#__PURE__*/ function(StoreType) {
    StoreType["INDEXEDDB"] = "indexeddb";
    StoreType["MEMORY"] = "memory";
    return StoreType;
}({});
let $c48d14f93a782cba$export$7710d69e6f450f20 = /*#__PURE__*/ function(GuardPolicy) {
    GuardPolicy["IGNORE"] = "ignore";
    GuardPolicy["ABANDON"] = "abandon";
    GuardPolicy["EVICT"] = "evict";
    return GuardPolicy;
}({});

});

parcelRegister("5NRmD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $011724d80abcf2eb$export$2e2bcd8739ae039; });
const $011724d80abcf2eb$export$fc14cf6dcea0f8ed = "NoIndexedDbError";
class $011724d80abcf2eb$export$2e2bcd8739ae039 extends Error {
    constructor(){
        super("window.indexeddb is undefined.");
        // Must reset the prototypes after calling super of builtin classes
        // https://github.com/Microsoft/TypeScript/wiki/Breaking-Changes#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, $011724d80abcf2eb$export$2e2bcd8739ae039.prototype);
        this.name = $011724d80abcf2eb$export$fc14cf6dcea0f8ed;
    }
}

});

parcelRegister("1pIS3", function(module, exports) {

$parcel$export(module.exports, "shouldIgnoreResilienceDbError", function () { return $107aeeadf4e9cc46$export$74101021e0969375; });

var $7JqDp = parcelRequire("7JqDp");

var $cD9HP = parcelRequire("cD9HP");

var $4cfS6 = parcelRequire("4cfS6");
const $107aeeadf4e9cc46$export$74101021e0969375 = (error)=>{
    if (error && typeof error === "object" && "name" in error) {
        const errorWithName = error;
        return typeof errorWithName.name === "string" && (errorWithName.name === (0, $7JqDp.AbandonWriteErrorName) || errorWithName.name === (0, $cD9HP.CallbackProcessingErrorName) || errorWithName.name === (0, $4cfS6.InvalidPolicyErrorName));
    }
    return false;
};

});
parcelRegister("7JqDp", function(module, exports) {

$parcel$export(module.exports, "AbandonWriteErrorName", function () { return $5a11656e9d80a3e2$export$ba95206613c96b28; });
$parcel$export(module.exports, "default", function () { return $5a11656e9d80a3e2$export$2e2bcd8739ae039; });
const $5a11656e9d80a3e2$export$ba95206613c96b28 = "AbandonWriteError";
class $5a11656e9d80a3e2$export$2e2bcd8739ae039 extends Error {
    constructor(source){
        super(`Event Limit reached. Abandoning write to: ${source}`);
        // Must reset the prototypes after calling super of builtin classes
        // https://github.com/Microsoft/TypeScript/wiki/Breaking-Changes#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, $5a11656e9d80a3e2$export$2e2bcd8739ae039.prototype);
        this.name = $5a11656e9d80a3e2$export$ba95206613c96b28;
    }
}

});

parcelRegister("4cfS6", function(module, exports) {

$parcel$export(module.exports, "InvalidPolicyErrorName", function () { return $30e4982badae4e71$export$7e7aee9a953465ec; });
$parcel$export(module.exports, "default", function () { return $30e4982badae4e71$export$2e2bcd8739ae039; });
const $30e4982badae4e71$export$7e7aee9a953465ec = "InvalidPolicyError";
class $30e4982badae4e71$export$2e2bcd8739ae039 extends Error {
    constructor(policy, method){
        super(`Method '${method}' cannot be called with policy '${policy}'.`);
        this.name = $30e4982badae4e71$export$7e7aee9a953465ec;
    }
}

});


parcelRegister("djlpt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9b0da846f2387669$export$2e2bcd8739ae039; });

var $krh40 = parcelRequire("krh40");

var $gsv4E = parcelRequire("gsv4E");

var $gSeGD = parcelRequire("gSeGD");

var $8qNBo = parcelRequire("8qNBo");

var $cD9HP = parcelRequire("cD9HP");
var $4cfS6 = parcelRequire("4cfS6");
var $5NRmD = parcelRequire("5NRmD");
var $1pIS3 = parcelRequire("1pIS3");

var $korym = parcelRequire("korym");

var $bZFva = parcelRequire("bZFva");
const $9b0da846f2387669$var$_excluded = [
    "item"
], $9b0da846f2387669$var$_excluded2 = [
    "items"
];
function $9b0da846f2387669$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $9b0da846f2387669$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $9b0da846f2387669$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($gsv4E)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $9b0da846f2387669$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
class $9b0da846f2387669$export$2e2bcd8739ae039 {
    constructor(_namespace, _options = {}){
        (0, (/*@__PURE__*/$parcel$interopDefault($gsv4E)))(this, "startDB", async ()=>{
            return new Promise(async (resolve, reject)=>{
                if (typeof window !== "undefined") {
                    const dbTimeout = window.setTimeout(()=>{
                        this.logger.warn("IndexedDB timed out.");
                        reject(new (0, $5NRmD.default)());
                    }, (0, $gSeGD.INDEXEDDB_TIMEOUT));
                    /*
           * The database version number can never change.
           * An upgrade transaction is limited to only one connection to the database.
           * Once this is done, we cannot open any connections with older versions of the schema.
           * https://www.w3.org/TR/IndexedDB/#upgrade-transaction-construct
           *
           * Due to the nature of how AWC is used (multiple tabs that are very long lived),
           * we will not be able to run version upgrades via indexeddb.
           *
           * This does not mean we cant change what is stored in the tables,
           * this limitation just prevents us from:
           *   - Creating new ObjectStores in this database connection, and
           *   - Creating new indexes on our ObjectStores
           *
           * Any upgrades we wish to run in the future will have to create a new database,
           * and migrate all the data from older databases.
           *
           * This also means any migrations we make will have to be supported until we have evidence
           * that no events are coming from old versions of the database.
           * This may take a long time.
           */ const request = window.indexedDB.open((0, $gSeGD.RESILIENCE_DB_NAME), 1);
                    request.onupgradeneeded = (event)=>{
                        if (event.oldVersion !== 0) throw new Error("We cannot upgrade the database. Do not do this.");
                        const db = request.result;
                        const store = db.createObjectStore((0, $gSeGD.RESILIENCE_STORE_NAME), {
                            keyPath: "id"
                        });
                        store.createIndex((0, $gSeGD.TIME_TO_PROCESS_AFTER_INDEX), (0, $gSeGD.TIME_TO_PROCESS_AFTER_INDEX), {
                            unique: false
                        });
                        store.createIndex((0, $gSeGD.RETRY_INDEX), (0, $gSeGD.RETRY_INDEX), {
                            unique: false
                        });
                        store.createIndex((0, $gSeGD.TIME_ADDED_INDEX), (0, $gSeGD.TIME_ADDED_INDEX), {
                            unique: false
                        });
                        // Compound key index of product - timeAdded.
                        store.createIndex((0, $gSeGD.NAMESPACE_AND_TIME_ADDED_INDEX), [
                            "namespace",
                            "timeAdded"
                        ], {
                            unique: false
                        });
                    };
                    try {
                        await (0, $bZFva.requestToPromise)(request);
                        return resolve(request.result);
                    } catch (error) {
                        this.logger.warn("IndexedDB failed to initialise.", error);
                        reject(new (0, $5NRmD.default)());
                    } finally{
                        window.clearTimeout(dbTimeout);
                    }
                } else {
                    this.logger.warn("IndexedDB failed to initialise. No 'window' object.");
                    reject(new (0, $5NRmD.default)());
                }
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($gsv4E)))(this, "addItem", async (item, options = {}, policy = (0, $gSeGD.GuardPolicy).ABANDON)=>{
            const { logger: logger, namespace: namespace } = this;
            const value = (0, $bZFva.convertToItemWrapper)(item, namespace, options);
            const { objectStore: objectStore } = await this.getObjectStoreAndTransaction("readwrite");
            if (policy === (0, $gSeGD.GuardPolicy).IGNORE) throw new (0, $4cfS6.default)(policy, "IndexedDbConnector#addItem");
            try {
                if (!value.namespace || value.namespace.length === 0 || typeof value.namespace !== "string") throw new Error("Namespace not specified");
                // Making space for 1 event, if required.
                const bulkAddResult = await this.globalEventLimitGuard.insertItems(objectStore, [
                    value
                ], policy);
                if (bulkAddResult.items.length === 1) return {
                    item: bulkAddResult.items[0],
                    numberOfEvictedItems: bulkAddResult.numberOfEvictedItems
                };
                // Should never happen as the Policy and EventCountGuard should cause another pathway
                throw new Error(`Incorrect number of items added. Expected: 1, got: ${bulkAddResult.items.length}`);
            } catch (error) {
                if ((0, $1pIS3.shouldIgnoreResilienceDbError)(error)) throw error;
                logger.log("Failed to add item to table", error);
                throw new Error("Request to add item to table failed");
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($gsv4E)))(this, "bulkAddItem", async (itemOptions, policy = (0, $gSeGD.GuardPolicy).ABANDON)=>{
            const { logger: logger, namespace: namespace } = this;
            const items = itemOptions.map((_ref)=>{
                let { item: item } = _ref, options = (0, (/*@__PURE__*/$parcel$interopDefault($krh40)))(_ref, $9b0da846f2387669$var$_excluded);
                return (0, $bZFva.convertToItemWrapper)(item, namespace, options);
            });
            const { objectStore: objectStore } = await this.getObjectStoreAndTransaction("readwrite");
            try {
                return await this.globalEventLimitGuard.insertItems(objectStore, items, policy);
            } catch (error) {
                if ((0, $1pIS3.shouldIgnoreResilienceDbError)(error)) throw error;
                logger.log("Failed to add item to table", error);
                throw new Error("Request to add item to table failed");
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($gsv4E)))(this, "getItems", async (count = (0, $8qNBo.GET_ITEM_COUNT))=>{
            const fixedCount = count > 0 ? count : (0, $8qNBo.GET_ITEM_COUNT);
            const { logger: logger } = this;
            const maxAttempts = this.options.maxAttempts;
            const { transaction: transaction, objectStore: objectStore } = await this.getObjectStoreAndTransaction("readwrite");
            const timeIndex = objectStore.index((0, $gSeGD.TIME_TO_PROCESS_AFTER_INDEX));
            const upperBoundOpenKeyRange = IDBKeyRange.upperBound(Date.now());
            const request = timeIndex.openCursor(upperBoundOpenKeyRange);
            const getResult = await new Promise(async (resolve, reject)=>{
                const items = [];
                let numberOfDeletedItems = 0;
                request.onerror = (error)=>{
                    logger.error("Failed to open cursor:", error);
                    reject("Failed to open cursor");
                };
                // Requests for Cursors call onsuccess multiple times and cannot be converted to promises
                request.onsuccess = (event)=>{
                    const cursor = event.target.result;
                    if (cursor) {
                        // Prevent mutation of the value we are returning
                        const value = $9b0da846f2387669$var$_objectSpread({}, cursor.value);
                        items.push(value);
                        // Mutations seem to be required for testing indexeddb library
                        const updatedValue = cursor.value;
                        updatedValue.retryAttempts += 1;
                        updatedValue.timeToBeProcessedAfter = Date.now() + (0, $8qNBo.VISIBILITY_TIMEOUT);
                        if (updatedValue.retryAttempts >= maxAttempts) {
                            ++numberOfDeletedItems;
                            const request = cursor.delete();
                            (0, $bZFva.monitorErrorsOnRequest)(request, logger);
                        } else {
                            const request = cursor.update(updatedValue);
                            (0, $bZFva.monitorErrorsOnRequest)(request, logger);
                        }
                        if (items.length < fixedCount) cursor.continue();
                        else resolve({
                            items: items,
                            numberOfDeletedItems: numberOfDeletedItems
                        });
                    } else resolve({
                        items: items,
                        numberOfDeletedItems: numberOfDeletedItems
                    });
                };
            });
            await (0, $bZFva.commitTransaction)(transaction, this.logger);
            return getResult;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($gsv4E)))(this, "deleteItems", async (itemIds)=>{
            const { transaction: transaction, objectStore: objectStore } = await this.getObjectStoreAndTransaction("readwrite");
            try {
                const deletePromises = itemIds.map((id)=>this.deleteItem(objectStore, id));
                await (0, $bZFva.commitTransaction)(transaction, this.logger);
                await Promise.all(deletePromises);
            } catch (error) {
                this.logger.warn("Failed to delete items from indexeddb.", error);
                throw error;
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($gsv4E)))(this, "getItemCount", async ()=>{
            const { transaction: transaction, objectStore: objectStore } = await this.getObjectStoreAndTransaction("readonly");
            const timeIndex = objectStore.index((0, $gSeGD.TIME_TO_PROCESS_AFTER_INDEX));
            const upperBoundOpenKeyRange = IDBKeyRange.upperBound(Date.now());
            const request = timeIndex.count(upperBoundOpenKeyRange);
            const event = await (0, $bZFva.requestToPromise)(request);
            await (0, $bZFva.commitTransaction)(transaction, this.logger);
            return event.target.result;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($gsv4E)))(this, "processItems", async (processFn, count = (0, $8qNBo.GET_ITEM_COUNT))=>{
            const _await$this$getItems = await this.getItems(count), { items: items } = _await$this$getItems, partialResult = (0, (/*@__PURE__*/$parcel$interopDefault($krh40)))(_await$this$getItems, $9b0da846f2387669$var$_excluded2);
            try {
                const result = await processFn(items, partialResult);
                const itemIds = items.map((item)=>item.id);
                // We should not await this delete as a rejected promise would get caught by the catch statement
                await this.deleteItems(itemIds);
                return result;
            } catch (error) {
                // Eventually we will need a intermediate class to catch all errors but we should ignore this error
                // This allows libraries beneath to distinguish between a success or failure in processing to update schedulers or anything else
                // To provide back off or any other mechanism to allow what ever is cauing the errors to recover
                throw new (0, $cD9HP.default)(error);
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($gsv4E)))(this, "deleteItem", async (objectStore, id)=>{
            const { logger: logger } = this;
            try {
                await (0, $bZFva.requestToPromise)(objectStore.delete(id));
            } catch (error) {
                logger.error("Failed to delete item:", id, error);
                throw error;
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($gsv4E)))(this, "getObjectStoreAndTransaction", async (mode)=>{
            const transaction = (await this.db).transaction((0, $gSeGD.RESILIENCE_STORE_NAME), mode);
            const objectStore = transaction.objectStore((0, $gSeGD.RESILIENCE_STORE_NAME));
            return {
                transaction: transaction,
                objectStore: objectStore
            };
        });
        this.options = (0, $bZFva.createOptionsWithDefaults)(_options);
        this.namespace = _namespace;
        this.logger = this.options.logger;
        if (!window.indexedDB) throw new (0, $5NRmD.default)();
        this.db = this.startDB();
        // We just swallow any errors as we know that these are intermittent errors
        // when switching from indexeddb -> localStorage
        this.db.catch(()=>{});
        /**
     *
     * This class will enforce the number of analytics events we can store in our IndexedDB object store
     * if asked before adding items to the object store.
     */ this.globalEventLimitGuard = new (0, $korym.default)(this.options.maxEventLimit, this.namespace, this.logger, this.deleteItem);
    }
    storeType() {
        return (0, $gSeGD.StoreType).INDEXEDDB;
    }
}

});
parcelRegister("krh40", function(module, exports) {

var $iYQ0h = parcelRequire("iYQ0h");
function $ee1390c365cd7e11$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $iYQ0h(e, t);
    if (Object.getOwnPropertySymbols) {
        var s = Object.getOwnPropertySymbols(e);
        for(r = 0; r < s.length; r++)o = s[r], t.includes(o) || ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
module.exports = $ee1390c365cd7e11$var$_objectWithoutProperties, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("iYQ0h", function(module, exports) {
function $dd162b6d9205d1a7$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.includes(n)) continue;
        t[n] = r[n];
    }
    return t;
}
module.exports = $dd162b6d9205d1a7$var$_objectWithoutPropertiesLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("8qNBo", function(module, exports) {

$parcel$export(module.exports, "GET_ITEM_COUNT", function () { return $62373a66ca055513$export$b6df3d334cec060f; });
$parcel$export(module.exports, "VISIBILITY_TIMEOUT", function () { return $62373a66ca055513$export$14ef152a03a4b6ee; });
$parcel$export(module.exports, "MAX_ATTEMPTS", function () { return $62373a66ca055513$export$da9ab7b2fd5998e8; });
$parcel$export(module.exports, "EVENT_COUNT_LIMIT", function () { return $62373a66ca055513$export$1188664dfff364c8; });
const $62373a66ca055513$export$b6df3d334cec060f = 7;
const $62373a66ca055513$export$14ef152a03a4b6ee = 60000;
const $62373a66ca055513$export$da9ab7b2fd5998e8 = 10;
const $62373a66ca055513$export$1188664dfff364c8 = 5000;

});

parcelRegister("korym", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $03d4d452c3906196$export$2e2bcd8739ae039; });

var $gsv4E = parcelRequire("gsv4E");

var $gSeGD = parcelRequire("gSeGD");

var $7JqDp = parcelRequire("7JqDp");

var $bZFva = parcelRequire("bZFva");
class $03d4d452c3906196$export$2e2bcd8739ae039 {
    constructor(eventLimit, namespace, logger, deleteItemHandler){
        /**
     * This query fetches the oldest events currently stored in AWC IndexedDb object store
     * and deletes them sequentially
     */ (0, (/*@__PURE__*/$parcel$interopDefault($gsv4E)))(this, "deleteOldestNEvents", async (objectStore, count)=>{
            var _target;
            const productTimeAddedIndex = objectStore.index((0, $gSeGD.NAMESPACE_AND_TIME_ADDED_INDEX));
            const keyRangeValues = IDBKeyRange.bound([
                this.namespace,
                0
            ], [
                this.namespace,
                Date.now()
            ]);
            const getAllRequest = productTimeAddedIndex.getAllKeys(keyRangeValues, count);
            const event = await (0, $bZFva.requestToPromise)(getAllRequest);
            const result = event === null || event === void 0 || (_target = event.target) === null || _target === void 0 ? void 0 : _target.result;
            // Adding extra safety
            if (result && Array.isArray(result) && result.length > 0) try {
                const deletePromises = result.map((item)=>this.deleteItemHandler(objectStore, item));
                await Promise.all(deletePromises);
            } catch (error) {
                this.logger.warn("Failed to delete items from indexeddb.", error);
                throw error;
            }
        });
        if (eventLimit > 0) this.eventLimit = eventLimit;
        else throw Error("Event Limit has to be set higher than 1");
        this.namespace = namespace;
        this.logger = logger;
        this.deleteItemHandler = deleteItemHandler;
    }
    /**
   * This function checks the number of events currently in AWC IndexedDB object store and if necessary,
   * will evict the oldest events in favour of the events we want to add.
   *
   * The indexed is treated as effectively: partitioned by product and sorted by timeAdded.
   *
   * This function can be re-used when the bulk add functionality is added in IndexedDbConnector.
   *
   * @param countOfEventsToAdd - The number of events we are proposing to add.
   */ async insertItems(objectStore, items, policy = (0, $gSeGD.GuardPolicy).ABANDON) {
        const itemsToAdd = [
            ...items
        ];
        let numberOfEvictedItems = 0;
        switch(policy){
            case (0, $gSeGD.GuardPolicy).ABANDON:
                await this.throwIfNotEnoughSpace(objectStore, items.length);
                break;
            case (0, $gSeGD.GuardPolicy).EVICT:
                numberOfEvictedItems = await this.evictIfNotEnoughSpace(objectStore, items.length);
                break;
            case (0, $gSeGD.GuardPolicy).IGNORE:
                // Removed items from `itemsToAdd` if there is insufficient space
                await this.calculateHowManyEventsWeCanAdd(objectStore, itemsToAdd);
                break;
        }
        const promises = itemsToAdd.map((item)=>(0, $bZFva.requestToPromise)(objectStore.add(item)));
        await Promise.all(promises);
        await (0, $bZFva.commitTransaction)(objectStore.transaction, this.logger);
        return {
            items: itemsToAdd,
            numberOfEvictedItems: numberOfEvictedItems
        };
    }
    async throwIfNotEnoughSpace(objectStore, requiredSpace) {
        const freeSpace = await this.calculateFreeSpace(objectStore);
        if (freeSpace < requiredSpace) throw new (0, $7JqDp.default)(`Not enough space in IndexedDb. Needed ${requiredSpace} but only had ${freeSpace}`);
    }
    async evictIfNotEnoughSpace(objectStore, requiredSpace) {
        const freeSpace = await this.calculateFreeSpace(objectStore);
        if (freeSpace < requiredSpace) {
            const extraSpace = requiredSpace - freeSpace;
            await this.deleteOldestNEvents(objectStore, extraSpace);
            return extraSpace;
        }
        return 0;
    }
    async calculateHowManyEventsWeCanAdd(objectStore, items) {
        const freeSpace = await this.calculateFreeSpace(objectStore);
        if (freeSpace < items.length) {
            const numberOfItemsToRemove = items.length - freeSpace;
            const start = items.length - numberOfItemsToRemove;
            items.splice(start, numberOfItemsToRemove);
        }
    }
    async calculateFreeSpace(objectStore) {
        const numberOfEventsInDb = await this.getCountofEventsInObjectStore(objectStore);
        return this.eventLimit - numberOfEventsInDb;
    }
    /**
   * This query returns the count of items held in AWC IndexedDB object store per product.
   */ async getCountofEventsInObjectStore(objectStore) {
        const productTimeAddedIndex = objectStore.index((0, $gSeGD.NAMESPACE_AND_TIME_ADDED_INDEX));
        const keyRangeValues = IDBKeyRange.bound([
            this.namespace,
            0
        ], [
            this.namespace,
            Date.now()
        ]);
        const request = productTimeAddedIndex.count(keyRangeValues);
        const event = await (0, $bZFva.requestToPromise)(request);
        return event.target.result;
    }
}

});
parcelRegister("bZFva", function(module, exports) {

$parcel$export(module.exports, "convertToItemWrapper", function () { return $8bb59597bc7d9b39$export$aec476f33d77be11; });
$parcel$export(module.exports, "createOptionsWithDefaults", function () { return $8bb59597bc7d9b39$export$ddc6718318090f71; });
$parcel$export(module.exports, "requestToPromise", function () { return $8bb59597bc7d9b39$export$85ceed0783e42041; });
$parcel$export(module.exports, "commitTransaction", function () { return $8bb59597bc7d9b39$export$feab8418f018df89; });
$parcel$export(module.exports, "monitorErrorsOnRequest", function () { return $8bb59597bc7d9b39$export$342d941b6f724995; });

var $dNSPy = parcelRequire("dNSPy");

var $8qNBo = parcelRequire("8qNBo");
const $8bb59597bc7d9b39$export$aec476f33d77be11 = (item, namespace, { id: id, retryAttempts: retryAttempts, timeToProcessOffset: timeToProcessOffset })=>({
        item: item,
        id: id || (0, (/*@__PURE__*/$parcel$interopDefault($dNSPy)))(),
        retryAttempts: retryAttempts || 0,
        timeToBeProcessedAfter: Date.now() + (timeToProcessOffset || 0),
        namespace: namespace,
        timeAdded: Date.now()
    });
const $8bb59597bc7d9b39$export$ddc6718318090f71 = (options)=>({
        logger: options.logger || console,
        useMemory: options.useMemory || false,
        maxAttempts: options.maxAttempts || (0, $8qNBo.MAX_ATTEMPTS),
        // This is so that we can customise `maxEventLimit`, primarily for testing.
        maxEventLimit: options.maxEventLimit || (0, $8qNBo.EVENT_COUNT_LIMIT)
    });
const $8bb59597bc7d9b39$export$85ceed0783e42041 = (request)=>{
    return new Promise((resolve, reject)=>{
        request.onsuccess = (event)=>{
            resolve(event);
        };
        request.onerror = (event)=>{
            reject(event);
        };
    });
};
const $8bb59597bc7d9b39$export$2a5213bce1720b42 = (transaction)=>{
    return new Promise((resolve, reject)=>{
        // We will have to see how much cost there is to waiting for the transaction to complete in the real world.
        // In theory in some cases we could return as soon as the request is complete and
        // just monitor errors on transactions with the logger.
        // This maybe more of an issue in Safari and other older browsers where commit isnt available
        // and we would have to wait for the transaction to complete itself.
        transaction.oncomplete = ()=>{
            resolve();
        };
        transaction.onerror = (event)=>{
            reject(event);
        };
        transaction.onabort = (event)=>{
            reject(event);
        };
    });
};
const $8bb59597bc7d9b39$export$feab8418f018df89 = (transaction, logger)=>{
    try {
        if (typeof transaction.commit === "function") transaction.commit();
    } catch (error) {
        logger.error("Failed to force commit transaction:", error);
        throw error;
    }
    return $8bb59597bc7d9b39$export$2a5213bce1720b42(transaction);
};
const $8bb59597bc7d9b39$export$342d941b6f724995 = (request, logger)=>{
    request.onerror = (event)=>{
        logger.warn("Error thrown from request:", event);
    };
};

});



parcelRegister("8LJQU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $662647da72e4839d$export$2e2bcd8739ae039; });

var $gsv4E = parcelRequire("gsv4E");

var $krh40 = parcelRequire("krh40");

var $gSeGD = parcelRequire("gSeGD");

var $8qNBo = parcelRequire("8qNBo");

var $cD9HP = parcelRequire("cD9HP");
var $4cfS6 = parcelRequire("4cfS6");

var $cPoIZ = parcelRequire("cPoIZ");

var $bZFva = parcelRequire("bZFva");
const $662647da72e4839d$var$_excluded = [
    "item"
], $662647da72e4839d$var$_excluded2 = [
    "items"
];
function $662647da72e4839d$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $662647da72e4839d$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $662647da72e4839d$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($gsv4E)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $662647da72e4839d$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
class $662647da72e4839d$export$2e2bcd8739ae039 {
    constructor(namespace, options = {}){
        this.namespace = namespace;
        this.memoryStore = [];
        this.options = (0, $bZFva.createOptionsWithDefaults)(options);
        /**
     * This class will enforce the number of analytics events we can store in our MemoryDb
     */ this.globalEventLimitGuard = new (0, $cPoIZ.default)(this.options.maxEventLimit, {
            addItems: this.addItems.bind(this),
            getItemCount: this.getItemCount.bind(this),
            evictEventsIfNeeded: this.evictEventsIfNeeded.bind(this)
        });
    }
    /**
   * This method is used mainly to write new events to MemoryDB and uses the MEMORY_DB_GUARD_POLICY.EVICT_OLDEST_IF_LIMIT_EXECEEDED policy
   * to removes oldest events when limit is reached.
   */ async addItem(item, options = {}, policy = (0, $gSeGD.GuardPolicy).ABANDON) {
        if (policy === (0, $gSeGD.GuardPolicy).IGNORE) throw new (0, $4cfS6.default)(policy, "IndexedDbConnector#addItem");
        const storedValue = (0, $bZFva.convertToItemWrapper)(item, this.namespace, options);
        // Delegated responsiblity to event limit guard to insert to memory stored
        const bulkAddItemsResult = await this.globalEventLimitGuard.insertItemsToMemoryStore([
            storedValue
        ], policy);
        return Promise.resolve({
            item: bulkAddItemsResult.items[0],
            numberOfEvictedItems: bulkAddItemsResult.numberOfEvictedItems
        });
    }
    bulkAddItem(itemOptions, policy = (0, $gSeGD.GuardPolicy).ABANDON) {
        const items = itemOptions.map((_ref)=>{
            let { item: item } = _ref, addOptions = (0, (/*@__PURE__*/$parcel$interopDefault($krh40)))(_ref, $662647da72e4839d$var$_excluded);
            return (0, $bZFva.convertToItemWrapper)(item, this.namespace, addOptions);
        });
        return this.bulkAddItemWrapperType(items, policy);
    }
    /**
   * This method is used mainly to write events to MemoryDB when unknown errors are thrown from IndexedDB.
   */ bulkAddItemWrapperType(items, policy = (0, $gSeGD.GuardPolicy).ABANDON) {
        return Promise.resolve(this.globalEventLimitGuard.insertItemsToMemoryStore(items, policy));
    }
    getItems(count = (0, $8qNBo.GET_ITEM_COUNT)) {
        return Promise.resolve(this.synchronousGetItems(count));
    }
    synchronousGetItems(count = (0, $8qNBo.GET_ITEM_COUNT)) {
        const fixedCount = count > 0 ? count : (0, $8qNBo.GET_ITEM_COUNT);
        const now = Date.now();
        const wrappedItems = [];
        const itemsToRemove = [];
        for (let wrappedItem of this.memoryStore){
            if (wrappedItem.timeToBeProcessedAfter <= now) {
                wrappedItems.push($662647da72e4839d$var$_objectSpread({}, wrappedItem));
                // Mutates the item in the memoryStore array, but not whats inside of wrappedItems
                wrappedItem.timeToBeProcessedAfter += (0, $8qNBo.VISIBILITY_TIMEOUT);
                wrappedItem.retryAttempts += 1;
                if (wrappedItem.retryAttempts >= this.options.maxAttempts) itemsToRemove.push(wrappedItem);
            }
            if (wrappedItems.length >= fixedCount) break;
        }
        itemsToRemove.forEach((item)=>{
            const index = this.memoryStore.indexOf(item);
            this.memoryStore.splice(index, 1);
        });
        return {
            items: wrappedItems,
            numberOfDeletedItems: itemsToRemove.length
        };
    }
    deleteItems(itemIds) {
        this.memoryStore = this.memoryStore.filter((item)=>!itemIds.includes(item.id));
        return Promise.resolve(void 0);
    }
    getItemCount() {
        const now = Date.now();
        const count = this.memoryStore.filter((item)=>item.timeToBeProcessedAfter <= now).length;
        return Promise.resolve(count);
    }
    async processItems(processFn, count) {
        const _this$synchronousGetI = this.synchronousGetItems(count), { items: items } = _this$synchronousGetI, partialGetResult = (0, (/*@__PURE__*/$parcel$interopDefault($krh40)))(_this$synchronousGetI, $662647da72e4839d$var$_excluded2);
        const itemIds = items.map((i)=>i.id);
        try {
            const result = await processFn(items, partialGetResult);
            await this.deleteItems(itemIds);
            return result;
        } catch (error) {
            throw new (0, $cD9HP.default)(error);
        }
    }
    storeType() {
        return (0, $gSeGD.StoreType).MEMORY;
    }
    /**
   * This function is adding items to the tail of the memoryStore and as it adds new items it keeps the
   * memory store sorted by timeAdded property. This makes evictions easier and adding elements to
   * memoryStore much faster.
   *
   * @param itemsToAdd
   */ addItems(itemsToAdd) {
        this.memoryStore.push(...itemsToAdd);
        // Sorting everytime, intentionally.
        this.memoryStore.sort(function(a, b) {
            return a.timeAdded - b.timeAdded;
        });
    }
    /**
   * This function checks the number of events currently in AWC MemoryDb and if necessary,
   * will evict the oldest events in favour of the events we want to add.
   *
   * @param countOfEventsToAdd - The number of events we are proposing to add.
   */ evictEventsIfNeeded(eventLimit) {
        const numberOfEventsInDb = this.memoryStore.length;
        // The number of analytics events currently in MemoryDb and
        // the Z events we are proposing to add will exceed our event count limit.
        if (numberOfEventsInDb > eventLimit) {
            const m = numberOfEventsInDb - eventLimit;
            // Removing oldest M events
            this.memoryStore.splice(0, m);
            return m;
        }
        return 0;
    }
}

});
parcelRegister("cPoIZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $956d6d434f5e7ecb$export$2e2bcd8739ae039; });

var $gsv4E = parcelRequire("gsv4E");

var $gSeGD = parcelRequire("gSeGD");

var $7JqDp = parcelRequire("7JqDp");
class $956d6d434f5e7ecb$export$2e2bcd8739ae039 {
    constructor(eventLimit, memoryItemHandlers){
        /**
     * Unlike IndexedDb, we cannot take advantage of any index. So we are,
     * treating the memory store as a sorted set when adding items.
     */ (0, (/*@__PURE__*/$parcel$interopDefault($gsv4E)))(this, "insertItemsToMemoryStore", (itemsToAdd, policy)=>{
            switch(policy){
                case (0, $gSeGD.GuardPolicy).ABANDON:
                    return this.handleAbandonIfLimitWillExceedPolicy(itemsToAdd);
                case (0, $gSeGD.GuardPolicy).EVICT:
                    return Promise.resolve(this.handleEvictOldestIfLimitExceededPolicy(itemsToAdd));
                case (0, $gSeGD.GuardPolicy).IGNORE:
                    return this.handleAddAsManyAsPossible(itemsToAdd);
            }
        });
        if (eventLimit > 0) this.eventLimit = eventLimit;
        else throw Error("Event Limit has to be set higher than 1");
        this.memoryItemHandlers = memoryItemHandlers;
    }
    async handleAbandonIfLimitWillExceedPolicy(itemsToAdd) {
        const itemCount = await this.memoryItemHandlers.getItemCount();
        if (itemCount + itemsToAdd.length > this.eventLimit) throw new (0, $7JqDp.default)((0, $gSeGD.StoreType).MEMORY);
        this.memoryItemHandlers.addItems(itemsToAdd);
        return {
            items: itemsToAdd,
            numberOfEvictedItems: 0
        };
    }
    handleEvictOldestIfLimitExceededPolicy(itemsToAdd) {
        this.memoryItemHandlers.addItems(itemsToAdd);
        const numberOfEvictedItems = this.memoryItemHandlers.evictEventsIfNeeded(this.eventLimit);
        return {
            items: itemsToAdd,
            numberOfEvictedItems: numberOfEvictedItems
        };
    }
    async handleAddAsManyAsPossible(itemsToAdd) {
        const freeSpace = this.eventLimit - await this.memoryItemHandlers.getItemCount();
        const partialEventsToAdd = freeSpace > itemsToAdd.length ? itemsToAdd : itemsToAdd.slice(0, freeSpace);
        this.memoryItemHandlers.addItems(partialEventsToAdd);
        return {
            items: partialEventsToAdd,
            numberOfEvictedItems: 0
        };
    }
}

});




parcelRegister("hGMny", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ce0be2f8093a05c0$export$2e2bcd8739ae039; });

var $gsv4E = parcelRequire("gsv4E");

var $5gKez = parcelRequire("5gKez");
class $ce0be2f8093a05c0$export$4b62ee5120ab50a8 {
    constructor(){
        // Number of events discarded due to exceeding retry limits.
        (0, (/*@__PURE__*/$parcel$interopDefault($gsv4E)))(this, "itemsDiscardedByRetry", 0);
        // Number of events created by the product in current tab.
        (0, (/*@__PURE__*/$parcel$interopDefault($gsv4E)))(this, "eventCount", 0);
        // Number of events discarded due to reaching queue max size.
        (0, (/*@__PURE__*/$parcel$interopDefault($gsv4E)))(this, "itemsDiscardedByOverflow", 0);
        // Will be used in the future when we get more resilience mechanisms
        (0, (/*@__PURE__*/$parcel$interopDefault($gsv4E)))(this, "resilienceMechanism", (0, $5gKez.ResilienceMechanism).INDEXEDDB);
        /* --- LocalStorage specific metrics --- */ // Emitted by purgeOrphanedQueues to tell us how many queues we have had to clean up due to
        // https://github.com/segmentio/localstorage-retry/pull/17
        (0, (/*@__PURE__*/$parcel$interopDefault($gsv4E)))(this, "localstorageNumberOfQueuesPurged", 0);
        // Emitted by reclaimEvents to tell us how many queues were seen in the process of reclaim.
        // We will only emit metrics for queues that are not currently being maintained (i.e. `ack` is not being updated).
        // Queue was found, all events removed and put into resilienceDb.
        (0, (/*@__PURE__*/$parcel$interopDefault($gsv4E)))(this, "localstorageNumberOfFullReclaims", 0);
        // Queue was found but not all events were able to be put into resilienceDb.
        (0, (/*@__PURE__*/$parcel$interopDefault($gsv4E)))(this, "localstorageNumberOfPartialReclaims", 0);
        // Reclaim failed for a queue and reclaim was abandonded.
        (0, (/*@__PURE__*/$parcel$interopDefault($gsv4E)))(this, "localstorageNumberOfFailedReclaims", 0);
    }
    addToItemsDiscardedByRetryCounter(numberOfDeletedEvents = 1) {
        this.itemsDiscardedByRetry += numberOfDeletedEvents;
    }
    addToEventCount() {
        this.eventCount++;
    }
    addToItemsDiscardedByOverflowCounter(numberOfDeletedEvents = 1) {
        this.itemsDiscardedByOverflow += numberOfDeletedEvents;
    }
    setResilienceMechanism(mechanism) {
        this.resilienceMechanism = mechanism;
    }
    /* <Localstorage specific> */ addToReclaimMetrics(reclaimMetrics) {
        this.localstorageNumberOfFullReclaims += reclaimMetrics.fullReclaims;
        this.localstorageNumberOfPartialReclaims += reclaimMetrics.partialReclaims;
        this.localstorageNumberOfFailedReclaims += reclaimMetrics.failedReclaims;
    }
    addToPurgedQueuesMetrics(numberOfQueuesPurged) {
        this.localstorageNumberOfQueuesPurged += numberOfQueuesPurged;
    }
    /* </Localstorage specific> */ subtractFromMetrics(sentMetrics) {
        this.itemsDiscardedByRetry = this.subtractFromCount(this.itemsDiscardedByRetry, sentMetrics.itemsDiscardedByRetry);
        this.eventCount = this.subtractFromCount(this.eventCount, sentMetrics.eventCount);
        this.itemsDiscardedByOverflow = this.subtractFromCount(this.itemsDiscardedByOverflow, sentMetrics.itemsDiscardedByOverflow);
        // Localstorage specific
        this.localstorageNumberOfFullReclaims = this.subtractFromCount(this.localstorageNumberOfFullReclaims, sentMetrics.fullReclaims);
        this.localstorageNumberOfPartialReclaims = this.subtractFromCount(this.localstorageNumberOfPartialReclaims, sentMetrics.partialReclaims);
        this.localstorageNumberOfFailedReclaims = this.subtractFromCount(this.localstorageNumberOfFailedReclaims, sentMetrics.failedReclaims);
        this.localstorageNumberOfQueuesPurged = this.subtractFromCount(this.localstorageNumberOfQueuesPurged, sentMetrics.localstorageQueuesPurged);
    }
    subtractFromCount(count, subtract) {
        return Math.max(count - (subtract || 0), 0);
    }
    getMetricsPayload() {
        return {
            itemsDiscardedByRetry: this.itemsDiscardedByRetry,
            eventCount: this.eventCount,
            itemsDiscardedByOverflow: this.itemsDiscardedByOverflow,
            resilienceMechanism: this.resilienceMechanism,
            // Localstorage specific
            localstorageQueuesPurged: this.localstorageNumberOfQueuesPurged,
            fullReclaims: this.localstorageNumberOfFullReclaims,
            partialReclaims: this.localstorageNumberOfPartialReclaims,
            failedReclaims: this.localstorageNumberOfFailedReclaims
        };
    }
}
let $ce0be2f8093a05c0$var$cachedMetricsClient = null;
var $ce0be2f8093a05c0$export$2e2bcd8739ae039 = ()=>{
    if (!$ce0be2f8093a05c0$var$cachedMetricsClient) $ce0be2f8093a05c0$var$cachedMetricsClient = new $ce0be2f8093a05c0$export$4b62ee5120ab50a8();
    return $ce0be2f8093a05c0$var$cachedMetricsClient;
};

});
parcelRegister("5gKez", function(module, exports) {

$parcel$export(module.exports, "ResilienceMechanism", function () { return $3d624f7ce1879350$export$c75161629e3ec34e; });
$parcel$export(module.exports, "NetworkStatusEnum", function () { return $3d624f7ce1879350$export$ee138fa712d11b84; });
let $3d624f7ce1879350$export$c75161629e3ec34e = /*#__PURE__*/ function(ResilienceMechanism) {
    ResilienceMechanism["INDEXEDDB"] = "indexeddb";
    ResilienceMechanism["MEMORY"] = "memory";
    return ResilienceMechanism;
}({});
let $3d624f7ce1879350$export$ee138fa712d11b84 = /*#__PURE__*/ function(NetworkStatusEnum) {
    NetworkStatusEnum[NetworkStatusEnum["ONLINE"] = 0] = "ONLINE";
    NetworkStatusEnum[NetworkStatusEnum["OFFLINE"] = 1] = "OFFLINE";
    return NetworkStatusEnum;
}({});

});


parcelRegister("3bJIO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2525dd90cc56c4b6$export$2e2bcd8739ae039; });

var $5gKez = parcelRequire("5gKez");
class $2525dd90cc56c4b6$export$2e2bcd8739ae039 {
    constructor(networkChangeCallback){
        if (typeof window !== "undefined") {
            window.addEventListener("offline", ()=>networkChangeCallback((0, $5gKez.NetworkStatusEnum).OFFLINE));
            window.addEventListener("online", ()=>networkChangeCallback((0, $5gKez.NetworkStatusEnum).ONLINE));
        }
    }
    getNetworkStatus() {
        if (window.navigator.onLine) return (0, $5gKez.NetworkStatusEnum).ONLINE;
        return (0, $5gKez.NetworkStatusEnum).OFFLINE;
    }
}

});

parcelRegister("bPP5g", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $89dc1551ed41ae80$export$2e2bcd8739ae039; });

var $gsv4E = parcelRequire("gsv4E");

var $9w9I9 = parcelRequire("9w9I9");

var $lfwlA = parcelRequire("lfwlA");
const $89dc1551ed41ae80$var$SCHEDULER_OPTIONS_DEFAULT = {
    minRetryDelay: 1000,
    maxRetryDelay: 30000,
    backoffFactor: 2,
    backoffJitterPercentage: 0,
    waitInterval: 500,
    callbackTimeoutPeriod: 5000
};
let $89dc1551ed41ae80$export$8bb92baee001fc60 = /*#__PURE__*/ function(QueuedScheduleTypes) {
    QueuedScheduleTypes[QueuedScheduleTypes["NONE"] = 0] = "NONE";
    QueuedScheduleTypes[QueuedScheduleTypes["IMMEDIATE"] = 1] = "IMMEDIATE";
    QueuedScheduleTypes[QueuedScheduleTypes["WAIT"] = 2] = "WAIT";
    return QueuedScheduleTypes;
}({});
class $89dc1551ed41ae80$export$2e2bcd8739ae039 {
    constructor(retryOptions, callback){
        (0, (/*@__PURE__*/$parcel$interopDefault($gsv4E)))(this, "schedule", ({ immediate: immediate } = {
            immediate: false
        })=>{
            if (typeof window === "undefined") return;
            if (this.operationInFlight) {
                if (immediate) this.queuedSchedule = $89dc1551ed41ae80$export$8bb92baee001fc60.IMMEDIATE;
                else if (this.queuedSchedule !== $89dc1551ed41ae80$export$8bb92baee001fc60.IMMEDIATE) this.queuedSchedule = $89dc1551ed41ae80$export$8bb92baee001fc60.WAIT;
            // Only run immediately if we have no failures
            } else if ((immediate || this.options.waitInterval <= 0) && this.failureCount === 0) {
                this.clearTimeout();
                this.run();
            // Backoff
            } else if (this.failureCount > 0 && this.scheduledTimeout === null) this.scheduledTimeout = window.setTimeout(this.run, this.calculateBackoff());
            else if (this.scheduledTimeout === null) this.scheduledTimeout = window.setTimeout(this.run, this.options.waitInterval);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($gsv4E)))(this, "stop", ()=>{
            this.clearTimeout();
            this.queuedSchedule = $89dc1551ed41ae80$export$8bb92baee001fc60.NONE;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($gsv4E)))(this, "getFailureCount", ()=>this.failureCount);
        (0, (/*@__PURE__*/$parcel$interopDefault($gsv4E)))(this, "getCallbackStatus", ()=>{
            return this.callbackTimer.getCallbackStatus();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($gsv4E)))(this, "clearTimeout", ()=>{
            if (typeof window !== "undefined" && this.scheduledTimeout !== null) {
                window.clearTimeout(this.scheduledTimeout);
                this.scheduledTimeout = null;
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($gsv4E)))(this, "run", ()=>{
            this.operationInFlight = true;
            this.clearTimeout();
            try {
                this.callbackTimer.executeCallbackWithTimeout(// callback to execute
                this.callback, // when callback completes, call this function
                this.done, // on timeout, do this instead
                ()=>this.done((0, $lfwlA.DoneState).ERROR));
            } catch (err) {
                this.done(err);
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($gsv4E)))(this, "done", (state)=>{
            this.operationInFlight = false;
            if (state === (0, $lfwlA.DoneState).ERROR || this.callbackTimer.getCallbackStatus() === (0, $9w9I9.CallbackStatus).TIMED_OUT) {
                this.failureCount++;
                this.clearTimeout();
            } else if (state === (0, $lfwlA.DoneState).SUCCESS) this.failureCount = 0;
            this.processQueuedSchedule();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($gsv4E)))(this, "processQueuedSchedule", ()=>{
            if (this.queuedSchedule !== $89dc1551ed41ae80$export$8bb92baee001fc60.NONE) {
                const immediate = this.queuedSchedule === $89dc1551ed41ae80$export$8bb92baee001fc60.IMMEDIATE;
                this.queuedSchedule = $89dc1551ed41ae80$export$8bb92baee001fc60.NONE;
                this.schedule({
                    immediate: immediate
                });
            } else if (this.failureCount > 0) // This will schedule tasks when this._done was called with a truthy value
            // For example, when this.callback(this._done) was not called within
            // this.callbackTimeoutPeriod
            this.schedule();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($gsv4E)))(this, "calculateBackoff", ()=>{
            const { minRetryDelay: minRetryDelay, maxRetryDelay: maxRetryDelay, backoffFactor: backoffFactor, backoffJitterPercentage: backoffJitterPercentage } = this.options;
            let ms = minRetryDelay * backoffFactor ** this.failureCount;
            if (backoffJitterPercentage) {
                const rand = Math.random();
                const deviation = Math.floor(rand * backoffJitterPercentage * ms);
                if (Math.floor(rand * 10) < 5) ms -= deviation;
                else ms += deviation;
            }
            return Number(Math.min(ms, maxRetryDelay).toPrecision(1));
        });
        this.options = {
            minRetryDelay: retryOptions.minRetryDelay || $89dc1551ed41ae80$var$SCHEDULER_OPTIONS_DEFAULT.minRetryDelay,
            maxRetryDelay: retryOptions.maxRetryDelay || $89dc1551ed41ae80$var$SCHEDULER_OPTIONS_DEFAULT.maxRetryDelay,
            backoffFactor: retryOptions.backoffFactor || $89dc1551ed41ae80$var$SCHEDULER_OPTIONS_DEFAULT.backoffFactor,
            backoffJitterPercentage: retryOptions.backoffJitterPercentage || $89dc1551ed41ae80$var$SCHEDULER_OPTIONS_DEFAULT.backoffJitterPercentage,
            waitInterval: retryOptions.waitInterval !== undefined ? retryOptions.waitInterval : $89dc1551ed41ae80$var$SCHEDULER_OPTIONS_DEFAULT.waitInterval,
            callbackTimeoutPeriod: retryOptions.callbackTimeoutPeriod || $89dc1551ed41ae80$var$SCHEDULER_OPTIONS_DEFAULT.callbackTimeoutPeriod
        };
        this.scheduledTimeout = null;
        this.failureCount = 0;
        this.callback = callback;
        this.operationInFlight = false;
        this.queuedSchedule = $89dc1551ed41ae80$export$8bb92baee001fc60.NONE;
        this.callbackTimer = new (0, $9w9I9.CallbackWithTimeout)(this.options.callbackTimeoutPeriod);
    }
}

});
parcelRegister("9w9I9", function(module, exports) {

$parcel$export(module.exports, "CallbackStatus", function () { return $6edea2a9664a1808$export$ef3353088fca369c; });
$parcel$export(module.exports, "CallbackWithTimeout", function () { return $6edea2a9664a1808$export$590a718599f8f8b3; });

var $gsv4E = parcelRequire("gsv4E");
let $6edea2a9664a1808$export$ef3353088fca369c = /*#__PURE__*/ function(CallbackStatus) {
    CallbackStatus["IDLE"] = "idle";
    CallbackStatus["RUNNING"] = "running";
    CallbackStatus["COMPLETED"] = "completed";
    CallbackStatus["TIMED_OUT"] = "timedOut";
    return CallbackStatus;
}({});
let $6edea2a9664a1808$export$def7d978353eaa0 = /*#__PURE__*/ function(CallbackEvent) {
    CallbackEvent["EXECUTE"] = "execute";
    CallbackEvent["COMPLETE"] = "complete";
    CallbackEvent["TIMEOUT"] = "timeout";
    return CallbackEvent;
}({});
class $6edea2a9664a1808$export$590a718599f8f8b3 {
    constructor(timeoutPeriod){
        // Milliseconds to wait
        // Tracks the settimeout; so that we can clear the timeout
        (0, (/*@__PURE__*/$parcel$interopDefault($gsv4E)))(this, "timeoutHandle", undefined);
        (0, (/*@__PURE__*/$parcel$interopDefault($gsv4E)))(this, "callbackStatus", $6edea2a9664a1808$export$ef3353088fca369c.IDLE);
        if (timeoutPeriod > 0) {
            this.timeoutPeriod = timeoutPeriod;
            return;
        }
        throw new Error("CallbackWithTimeout requires timeout period higher than 0");
    }
    // This is a state machine to control the flow of execution.
    // IDLE -> RUNNING -> COMPLETED
    // IDLE -> RUNNING -> TIMEDOUT
    transitionCallbackStatus(currentStatus, event) {
        switch(currentStatus){
            case $6edea2a9664a1808$export$ef3353088fca369c.IDLE:
            case $6edea2a9664a1808$export$ef3353088fca369c.TIMED_OUT:
            case $6edea2a9664a1808$export$ef3353088fca369c.COMPLETED:
                if (event === $6edea2a9664a1808$export$def7d978353eaa0.EXECUTE) this.callbackStatus = $6edea2a9664a1808$export$ef3353088fca369c.RUNNING;
                break;
            case $6edea2a9664a1808$export$ef3353088fca369c.RUNNING:
                switch(event){
                    case $6edea2a9664a1808$export$def7d978353eaa0.COMPLETE:
                        this.callbackStatus = $6edea2a9664a1808$export$ef3353088fca369c.COMPLETED;
                        break;
                    case $6edea2a9664a1808$export$def7d978353eaa0.TIMEOUT:
                        this.callbackStatus = $6edea2a9664a1808$export$ef3353088fca369c.TIMED_OUT;
                        break;
                }
                break;
            default:
                this.callbackStatus = currentStatus;
        }
    }
    // Start a timeout. If this.callback(this._done) does not finish
    // by this.options.callbackTimeoutPeriod time period,
    // we will call done with a true value.
    executeCallbackWithTimeout(callback, onDone, onTimeout) {
        if (typeof window === "undefined") return;
        this.transitionCallbackStatus(this.callbackStatus, $6edea2a9664a1808$export$def7d978353eaa0.EXECUTE);
        // Setting timeout
        this.timeoutHandle = window.setTimeout(()=>{
            this.transitionCallbackStatus(this.callbackStatus, $6edea2a9664a1808$export$def7d978353eaa0.TIMEOUT);
            onTimeout();
        }, this.timeoutPeriod);
        // Executing callback
        callback((state)=>{
            this.cancelTimeout();
            if (this.getCallbackStatus() !== $6edea2a9664a1808$export$ef3353088fca369c.TIMED_OUT) {
                this.transitionCallbackStatus(this.callbackStatus, $6edea2a9664a1808$export$def7d978353eaa0.COMPLETE);
                onDone(state);
            }
        });
    }
    getCallbackStatus() {
        return this.callbackStatus;
    }
    // This allows us to cancel the timeout function, for example, if the callback finishes before the timeout period
    // or, if the user wants to manually cancel the timeout
    cancelTimeout() {
        if (typeof window !== "undefined" && this.timeoutPeriod > 0 && this.timeoutHandle) {
            window.clearTimeout(this.timeoutHandle);
            this.timeoutHandle = undefined;
        }
    }
}

});

parcelRegister("lfwlA", function(module, exports) {

$parcel$export(module.exports, "DoneState", function () { return $f784172d5b18fead$export$f93c40fda808dd0c; });
// Clients can optionally provide the callbackTimeoutPeriod parameter
let $f784172d5b18fead$export$f93c40fda808dd0c = /*#__PURE__*/ function(DoneState) {
    DoneState[DoneState["NOOP"] = 0] = "NOOP";
    DoneState[DoneState["SUCCESS"] = 1] = "SUCCESS";
    DoneState[DoneState["ERROR"] = 2] = "ERROR";
    return DoneState;
}({});

});




parcelRegister("2Fl0n", function(module, exports) {

$parcel$export(module.exports, "attachXidToMultipleEvents", function () { return $1f0fb440e8855327$export$c21270cab66ab290; });

var $gsv4E = parcelRequire("gsv4E");

var $5sO2V = parcelRequire("5sO2V");
function $1f0fb440e8855327$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $1f0fb440e8855327$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $1f0fb440e8855327$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($gsv4E)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $1f0fb440e8855327$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $1f0fb440e8855327$export$c9c3aaf655d6f275(item, xidCallback) {
    if (!(xidCallback && xidCallback instanceof Function)) return item;
    if (item.msg.type === (0, $5sO2V.SegmentEventTypes).PAGE || item.msg.type === (0, $5sO2V.SegmentEventTypes).TRACK) {
        const xid = xidCallback();
        if (xid && Array.isArray(xid)) item.msg.properties = $1f0fb440e8855327$var$_objectSpread($1f0fb440e8855327$var$_objectSpread({}, item.msg.properties), {}, {
            xid: xid
        });
    } else if (item.msg.traits && item.msg.type === (0, $5sO2V.SegmentEventTypes).IDENTIFY) {
        const xid = xidCallback();
        if (xid && Array.isArray(xid)) item.msg.traits = $1f0fb440e8855327$var$_objectSpread($1f0fb440e8855327$var$_objectSpread({}, item.msg.traits), {}, {
            xid: xid
        });
    }
    return item;
}
async function $1f0fb440e8855327$export$c21270cab66ab290(items, xidItemPromiseCallback) {
    try {
        const xidCallback = await xidItemPromiseCallback;
        return items.map((item)=>$1f0fb440e8855327$export$c9c3aaf655d6f275(item, xidCallback));
    } catch (error) {
        return items;
    }
}

});
parcelRegister("5sO2V", function(module, exports) {

$parcel$export(module.exports, "SegmentEventTypes", function () { return $3fa66362ad3eebad$export$ddf929981dc6feb3; });
// Segment event types copied from our backend
// https://bitbucket.org/atlassian/analytics-service/src/master/api/src/main/java/com/atlassian/dataservices/analytics/service/api/segment/
let $3fa66362ad3eebad$export$ddf929981dc6feb3 = /*#__PURE__*/ function(SegmentEventTypes) {
    SegmentEventTypes["IDENTIFY"] = "identify";
    SegmentEventTypes["PAGE"] = "page";
    SegmentEventTypes["TRACK"] = "track";
    return SegmentEventTypes;
}({});
let $3fa66362ad3eebad$export$8d8db47b9b0efb63 = /*#__PURE__*/ function(CrossDomainIdentifierType) {
    CrossDomainIdentifierType["XC"] = "xc";
    CrossDomainIdentifierType["UID"] = "uid";
    return CrossDomainIdentifierType;
}({});
let $3fa66362ad3eebad$export$2140495465f9e528 = /*#__PURE__*/ function(CrossDomainIdentifierState) {
    CrossDomainIdentifierState["NEW"] = "NEW";
    CrossDomainIdentifierState["CHANGED"] = "CHANGED";
    CrossDomainIdentifierState["EXISTING"] = "EXISTING";
    CrossDomainIdentifierState["TIMEOUT"] = "TIMEOUT";
    CrossDomainIdentifierState["ERROR"] = "ERROR";
    CrossDomainIdentifierState["UNAVAILABLE"] = "UNAVAILABLE";
    CrossDomainIdentifierState["MALFORMED"] = "MALFORMED";
    CrossDomainIdentifierState["UNKNOWN"] = "UNKNOWN";
    return CrossDomainIdentifierState;
}({});

});


parcelRegister("ibwVW", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_REQUEST_TIMEOUT", function () { return $d3d2ccff5a829a88$export$9175ce0e1c95daf2; });
const $d3d2ccff5a829a88$export$9175ce0e1c95daf2 = 10000; // 10 seconds

});

parcelRegister("aq8he", function(module, exports) {

$parcel$export(module.exports, "sendEvents", function () { return $7962c0bbb739ae8f$export$8e8f0180c1b41fad; });

var $gsv4E = parcelRequire("gsv4E");

var $dHPoE = parcelRequire("dHPoE");
function $7962c0bbb739ae8f$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $7962c0bbb739ae8f$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $7962c0bbb739ae8f$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($gsv4E)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $7962c0bbb739ae8f$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $7962c0bbb739ae8f$export$8e8f0180c1b41fad = async (options)=>{
    var _createOrGetAbortCont;
    const signal = (_createOrGetAbortCont = $7962c0bbb739ae8f$var$createOrGetAbortController(options)) === null || _createOrGetAbortCont === void 0 ? void 0 : _createOrGetAbortCont.signal;
    const corsOptions = $7962c0bbb739ae8f$var$getCorsForUrl(options.url);
    const response = await fetch(options.url, $7962c0bbb739ae8f$var$_objectSpread({
        method: "POST",
        // Content-type has to be text/plain in order to prevent unnecessary `OPTIONS` requests.
        headers: {
            "Content-Type": "text/plain"
        },
        body: JSON.stringify(options.batch),
        signal: signal
    }, corsOptions));
    if (response.status === 429 || response.status >= 500 && response.status < 600) throw new Error(`HTTP Error ${response.status} (${response.statusText})`);
    return response;
};
const $7962c0bbb739ae8f$var$createOrGetAbortController = (options)=>{
    if (options.abortController) return options.abortController;
    else if (options.timeout) {
        const abortController = new AbortController();
        // After a fetch has completed, calling abort is ignored.
        setTimeout(()=>{
            abortController.abort();
        }, options.timeout);
        return abortController;
    }
};
// To ensure we always have cookies, we should check if the origins match.
// If they dont, we need to set mode to `cors` and credentials to `include`.
const $7962c0bbb739ae8f$var$getCorsForUrl = (0, $dHPoE.default)((url)=>{
    const origin = new URL(url).origin;
    if (origin === location.origin) return {};
    else return {
        mode: "cors",
        credentials: "include"
    };
});

});
parcelRegister("dHPoE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9fa728d524572754$export$2e2bcd8739ae039; });
var $9fa728d524572754$var$safeIsNaN = Number.isNaN || function ponyfill(value) {
    return typeof value === "number" && value !== value;
};
function $9fa728d524572754$var$isEqual(first, second) {
    if (first === second) return true;
    if ($9fa728d524572754$var$safeIsNaN(first) && $9fa728d524572754$var$safeIsNaN(second)) return true;
    return false;
}
function $9fa728d524572754$var$areInputsEqual(newInputs, lastInputs) {
    if (newInputs.length !== lastInputs.length) return false;
    for(var i = 0; i < newInputs.length; i++){
        if (!$9fa728d524572754$var$isEqual(newInputs[i], lastInputs[i])) return false;
    }
    return true;
}
function $9fa728d524572754$export$2e2bcd8739ae039(resultFn, isEqual) {
    if (isEqual === void 0) isEqual = $9fa728d524572754$var$areInputsEqual;
    var cache = null;
    function memoized() {
        var newArgs = [];
        for(var _i = 0; _i < arguments.length; _i++)newArgs[_i] = arguments[_i];
        if (cache && cache.lastThis === this && isEqual(newArgs, cache.lastArgs)) return cache.lastResult;
        var lastResult = resultFn.apply(this, newArgs);
        cache = {
            lastResult: lastResult,
            lastArgs: newArgs,
            lastThis: this
        };
        return lastResult;
    }
    memoized.clear = function clear() {
        cache = null;
    };
    return memoized;
}

});


parcelRegister("iXGL2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dcdee775690bc839$export$2e2bcd8739ae039; });

var $9G2ve = parcelRequire("9G2ve");

var $dNSPy = parcelRequire("dNSPy");

var $1lwuH = parcelRequire("1lwuH");
var $1nHwo = parcelRequire("1nHwo");

var $7n5Kg = parcelRequire("7n5Kg");
// Cookie is stale, if anonymousId was generated 7 days ago.
const $dcdee775690bc839$var$ANONYMOUS_ID_COOKIE_STALE_DAYS = 7;
const $dcdee775690bc839$var$SAFE = "SAFE";
const $dcdee775690bc839$var$UNSAFE = "UNSAFE";
const $dcdee775690bc839$var$NOT_FOUND = "NOT_FOUND";
const $dcdee775690bc839$var$COOKIE = "COOKIE";
const $dcdee775690bc839$var$LOCAL_STORAGE = "LOCAL_STORAGE";
class $dcdee775690bc839$export$2e2bcd8739ae039 {
    constructor(disableCookiePersistence){
        this.store = new (0, $7n5Kg.default)({
            useStoragePrefix: false
        });
        this.cookie = new (0, $1nHwo.default)(disableCookiePersistence);
    }
    getUserId() {
        return this.userId || null;
    }
    setUserId(userId) {
        this.userId = userId;
    }
    getAnonymousId(customAnonymousIdGenerator) {
        /**
     * Prefer localStorage as there cant be duplicate keys, and its faster. Also update cookie, if stale.
     * If not set in localStorage, check cookies. Also set localStorage for future attempts.
     * If not in cookies, generate a new one. Set both cookie and localStorage keys.
     */ return this.getAnonymousIdFromLocalStorageAndUpdateCookieIfStale() || this.getAnonymousIdFromCookieAndUpdateLocalStorage() || this.generateNewAnonymousId(customAnonymousIdGenerator);
    }
    setAnonymousId(anonymousId) {
        const stringifyAnonymosId = JSON.stringify(anonymousId);
        this.cookie.set((0, $1lwuH.AWCCookiesKeys).AJS_ANONYMOUS_ID, stringifyAnonymosId);
        this.lastAnonymousIdCookieUpdate = Date.now();
        return this.store.setItem((0, $1lwuH.AllAnalyticsCookies).AJS_ANONYMOUS_ID.getKey(), stringifyAnonymosId);
    }
    getAnonymousIdFromStorage(source) {
        const rawStorageAnonidValue = source === $dcdee775690bc839$var$LOCAL_STORAGE ? this.store.getItem((0, $1lwuH.AllAnalyticsCookies).AJS_ANONYMOUS_ID.getKey()) : this.cookie.get((0, $1lwuH.AWCCookiesKeys).AJS_ANONYMOUS_ID);
        if (rawStorageAnonidValue) {
            const unsafeValue = {
                type: $dcdee775690bc839$var$UNSAFE,
                anonymousId: rawStorageAnonidValue
            };
            try {
                const parsedAnonId = JSON.parse(rawStorageAnonidValue);
                if (parsedAnonId && typeof parsedAnonId === "string") return {
                    type: $dcdee775690bc839$var$SAFE,
                    anonymousId: parsedAnonId
                };
                return unsafeValue;
            } catch (err) {
                /*
         * Segments new Analytics-next client will store strings as strings without stringifing.
         * The legacy Segment client and AWC always stringify and parse cookies and values.
         * If the new Segment analytics-client stores a cookie and local storage value first, it will
         * breaking old clients.
         *
         * Additionally, JSON.parse can cause exceptions to be thrown in some browsers; see AAP-324.
         *
         * Intentionally swalling errors here and returning the original value found in storage to avoid ping-pong.
         */ return unsafeValue;
            }
        }
        return {
            type: $dcdee775690bc839$var$NOT_FOUND
        };
    }
    getAnonymousIdFromLocalStorageAndUpdateCookieIfStale() {
        const localStorageValue = this.getAnonymousIdFromStorage($dcdee775690bc839$var$LOCAL_STORAGE);
        let shouldUpdateCookie = false;
        if (!this.lastAnonymousIdCookieUpdate || (0, $9G2ve.default)(new Date(), new Date(this.lastAnonymousIdCookieUpdate)) >= $dcdee775690bc839$var$ANONYMOUS_ID_COOKIE_STALE_DAYS) shouldUpdateCookie = true;
        switch(localStorageValue.type){
            case $dcdee775690bc839$var$SAFE:
                if (shouldUpdateCookie) this.setAnonymousId(localStorageValue.anonymousId);
                return localStorageValue.anonymousId;
            case $dcdee775690bc839$var$UNSAFE:
                return localStorageValue.anonymousId;
            case $dcdee775690bc839$var$NOT_FOUND:
            default:
                return null;
        }
    }
    getAnonymousIdFromCookieAndUpdateLocalStorage() {
        const cookieValue = this.getAnonymousIdFromStorage($dcdee775690bc839$var$COOKIE);
        switch(cookieValue.type){
            case $dcdee775690bc839$var$SAFE:
            case $dcdee775690bc839$var$UNSAFE:
                this.store.setItem((0, $1lwuH.AllAnalyticsCookies).AJS_ANONYMOUS_ID.getKey(), JSON.stringify(cookieValue.anonymousId));
                return cookieValue.anonymousId;
            case $dcdee775690bc839$var$NOT_FOUND:
            default:
                return null;
        }
    }
    generateNewAnonymousId(customAnonymousIdGenerator = (0, (/*@__PURE__*/$parcel$interopDefault($dNSPy)))) {
        const newAnonId = customAnonymousIdGenerator();
        this.setAnonymousId(newAnonId);
        return newAnonId;
    }
}

});
parcelRegister("9G2ve", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $70b9fa4faf0dd51e$export$2e2bcd8739ae039; });

var $aS8if = parcelRequire("aS8if");

var $ddXYa = parcelRequire("ddXYa");

var $6LVeH = parcelRequire("6LVeH");
// for accurate equality comparisons of UTC timestamps that end up
// having the same representation in local time, e.g. one hour before
// DST ends vs. the instant that DST ends.
function $70b9fa4faf0dd51e$var$compareLocalAsc(dateLeft, dateRight) {
    var diff = dateLeft.getFullYear() - dateRight.getFullYear() || dateLeft.getMonth() - dateRight.getMonth() || dateLeft.getDate() - dateRight.getDate() || dateLeft.getHours() - dateRight.getHours() || dateLeft.getMinutes() - dateRight.getMinutes() || dateLeft.getSeconds() - dateRight.getSeconds() || dateLeft.getMilliseconds() - dateRight.getMilliseconds();
    if (diff < 0) return -1;
    else if (diff > 0) return 1;
    else return diff;
}
function $70b9fa4faf0dd51e$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $6LVeH.default)(2, arguments);
    var dateLeft = (0, $aS8if.default)(dirtyDateLeft);
    var dateRight = (0, $aS8if.default)(dirtyDateRight);
    var sign = $70b9fa4faf0dd51e$var$compareLocalAsc(dateLeft, dateRight);
    var difference = Math.abs((0, $ddXYa.default)(dateLeft, dateRight));
    dateLeft.setDate(dateLeft.getDate() - sign * difference);
    // Math.abs(diff in full days - diff in calendar days) === 1 if last calendar day is not full
    // If so, result must be decreased by 1 in absolute value
    var isLastDayNotFull = Number($70b9fa4faf0dd51e$var$compareLocalAsc(dateLeft, dateRight) === -sign);
    var result = sign * (difference - isLastDayNotFull);
    // Prevent negative zero
    return result === 0 ? 0 : result;
}

});
parcelRegister("aS8if", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7ea56166b087470d$export$2e2bcd8739ae039; });

var $gh6Ui = parcelRequire("gh6Ui");

var $6LVeH = parcelRequire("6LVeH");
function $7ea56166b087470d$export$2e2bcd8739ae039(argument) {
    (0, $6LVeH.default)(1, arguments);
    var argStr = Object.prototype.toString.call(argument);
    // Clone the date
    if (argument instanceof Date || (0, $gh6Ui.default)(argument) === "object" && argStr === "[object Date]") // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
    else if (typeof argument === "number" || argStr === "[object Number]") return new Date(argument);
    else {
        if ((typeof argument === "string" || argStr === "[object String]") && typeof console !== "undefined") {
            // eslint-disable-next-line no-console
            console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments");
            // eslint-disable-next-line no-console
            console.warn(new Error().stack);
        }
        return new Date(NaN);
    }
}

});
parcelRegister("gh6Ui", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bd93977572293fe4$export$2e2bcd8739ae039; });
function $bd93977572293fe4$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $bd93977572293fe4$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $bd93977572293fe4$export$2e2bcd8739ae039(o);
}

});

parcelRegister("6LVeH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4ee387c78d5ce5e5$export$2e2bcd8739ae039; });
function $4ee387c78d5ce5e5$export$2e2bcd8739ae039(required, args) {
    if (args.length < required) throw new TypeError(required + " argument" + (required > 1 ? "s" : "") + " required, but only " + args.length + " present");
}

});


parcelRegister("ddXYa", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9a0b01f429a685ac$export$2e2bcd8739ae039; });

var $zyeRg = parcelRequire("zyeRg");

var $2HzXa = parcelRequire("2HzXa");

var $6LVeH = parcelRequire("6LVeH");
var $9a0b01f429a685ac$var$MILLISECONDS_IN_DAY = 86400000;
function $9a0b01f429a685ac$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $6LVeH.default)(2, arguments);
    var startOfDayLeft = (0, $2HzXa.default)(dirtyDateLeft);
    var startOfDayRight = (0, $2HzXa.default)(dirtyDateRight);
    var timestampLeft = startOfDayLeft.getTime() - (0, $zyeRg.default)(startOfDayLeft);
    var timestampRight = startOfDayRight.getTime() - (0, $zyeRg.default)(startOfDayRight);
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a day is not constant
    // (e.g. it's different in the day of the daylight saving time clock shift)
    return Math.round((timestampLeft - timestampRight) / $9a0b01f429a685ac$var$MILLISECONDS_IN_DAY);
}

});
parcelRegister("zyeRg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $06add414d9e4b951$export$2e2bcd8739ae039; });
/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */ function $06add414d9e4b951$export$2e2bcd8739ae039(date) {
    var utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
    utcDate.setUTCFullYear(date.getFullYear());
    return date.getTime() - utcDate.getTime();
}

});

parcelRegister("2HzXa", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1f7b7c86364b8dba$export$2e2bcd8739ae039; });

var $aS8if = parcelRequire("aS8if");

var $6LVeH = parcelRequire("6LVeH");
function $1f7b7c86364b8dba$export$2e2bcd8739ae039(dirtyDate) {
    (0, $6LVeH.default)(1, arguments);
    var date = (0, $aS8if.default)(dirtyDate);
    date.setHours(0, 0, 0, 0);
    return date;
}

});



parcelRegister("1lwuH", function(module, exports) {

$parcel$export(module.exports, "AWCCookiesKeys", function () { return $0fb0f546f8544c7c$export$202d555a5dbfd90c; });
$parcel$export(module.exports, "AllAnalyticsCookies", function () { return $0fb0f546f8544c7c$export$d4cb17942ea57c95; });
let $0fb0f546f8544c7c$export$202d555a5dbfd90c = /*#__PURE__*/ function(AWCCookiesKeys) {
    AWCCookiesKeys["AWC_TLD_TEST"] = "AWC_TLD_TEST";
    AWCCookiesKeys["AWC_ANALYTICS_DEBUG"] = "AWC_ANALYTICS_DEBUG";
    AWCCookiesKeys["AJS_ANONYMOUS_ID"] = "AJS_ANONYMOUS_ID";
    return AWCCookiesKeys;
}({});
class $0fb0f546f8544c7c$var$CookieSchema {
    constructor(key, options){
        this.key = key;
        this.options = options;
    }
    getAttributes() {
        return this.options;
    }
    getKey() {
        return this.key;
    }
}
const $0fb0f546f8544c7c$export$d4cb17942ea57c95 = {
    [$0fb0f546f8544c7c$export$202d555a5dbfd90c.AWC_TLD_TEST]: new $0fb0f546f8544c7c$var$CookieSchema("__awc_tld_test__", {
        expires: 365,
        secure: window.location.protocol === "https:",
        path: "/"
    }),
    [$0fb0f546f8544c7c$export$202d555a5dbfd90c.AWC_ANALYTICS_DEBUG]: new $0fb0f546f8544c7c$var$CookieSchema("atlassian_analytics_debug", {
        expires: 365,
        secure: window.location.protocol === "https:",
        path: "/"
    }),
    [$0fb0f546f8544c7c$export$202d555a5dbfd90c.AJS_ANONYMOUS_ID]: new $0fb0f546f8544c7c$var$CookieSchema("ajs_anonymous_id", {
        expires: 365,
        secure: window.location.protocol === "https:",
        path: "/"
    })
};

});

parcelRegister("1nHwo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1019b2e01549e193$export$2e2bcd8739ae039; });

var $gsv4E = parcelRequire("gsv4E");

var $4nZ1y = parcelRequire("4nZ1y");

var $1lwuH = parcelRequire("1lwuH");

var $fI8Jj = parcelRequire("fI8Jj");

var $9aa6h = parcelRequire("9aa6h");
function $1019b2e01549e193$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $1019b2e01549e193$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $1019b2e01549e193$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($gsv4E)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $1019b2e01549e193$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
class $1019b2e01549e193$export$2e2bcd8739ae039 {
    constructor(disableCookiePersistence){
        this.cookieLike = (0, $9aa6h.canUseCookie)(disableCookiePersistence) ? (0, (/*@__PURE__*/$parcel$interopDefault($4nZ1y))) : new (0, $fI8Jj.default)();
    }
    set(name, value, options) {
        // no-op
        if (!(0, $1lwuH.AllAnalyticsCookies)[name]) {
            // eslint-disable-next-line no-console
            console.warn(`Unknown cookie key ${name} provided, not set.`);
            return;
        }
        return this.cookieLike.set((0, $1lwuH.AllAnalyticsCookies)[name].getKey(), value, $1019b2e01549e193$var$_objectSpread($1019b2e01549e193$var$_objectSpread({}, (0, $1lwuH.AllAnalyticsCookies)[name].getAttributes()), {}, {
            // Function is memoized so we only calculate this once per page load
            domain: (0, $9aa6h.getTld)()
        }, options));
    }
    get(name) {
        if (!(0, $1lwuH.AllAnalyticsCookies)[name]) {
            // eslint-disable-next-line no-console
            console.warn(`Unknown cookie key ${name} provided, not fetched.`);
            return;
        }
        return this.cookieLike.get((0, $1lwuH.AllAnalyticsCookies)[name].getKey());
    }
    remove(name, options) {
        if (!(0, $1lwuH.AllAnalyticsCookies)[name]) {
            // eslint-disable-next-line no-console
            console.warn(`Unknown cookie key ${name} provided, not removed.`);
            return;
        }
        this.cookieLike.remove((0, $1lwuH.AllAnalyticsCookies)[name].getKey(), $1019b2e01549e193$var$_objectSpread({}, options));
    }
}

});
parcelRegister("4nZ1y", function(module, exports) {
(function(factory) {
    var registeredInModuleLoader;
    if (typeof define === "function" && define.amd) {
        define(factory);
        registeredInModuleLoader = true;
    }
    module.exports = factory();
    registeredInModuleLoader = true;
    if (!registeredInModuleLoader) {
        var OldCookies = window.Cookies;
        var api = window.Cookies = factory();
        api.noConflict = function() {
            window.Cookies = OldCookies;
            return api;
        };
    }
})(function() {
    function extend() {
        var i = 0;
        var result = {};
        for(; i < arguments.length; i++){
            var attributes = arguments[i];
            for(var key in attributes)result[key] = attributes[key];
        }
        return result;
    }
    function decode(s) {
        return s.replace(/(%[0-9A-Z]{2})+/g, decodeURIComponent);
    }
    function init(converter) {
        function api() {}
        function set(key, value, attributes) {
            if (typeof document === "undefined") return;
            attributes = extend({
                path: "/"
            }, api.defaults, attributes);
            if (typeof attributes.expires === "number") attributes.expires = new Date(new Date() * 1 + attributes.expires * 864e+5);
            // We're using "expires" because "max-age" is not supported by IE
            attributes.expires = attributes.expires ? attributes.expires.toUTCString() : "";
            try {
                var result = JSON.stringify(value);
                if (/^[\{\[]/.test(result)) value = result;
            } catch (e) {}
            value = converter.write ? converter.write(value, key) : encodeURIComponent(String(value)).replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);
            key = encodeURIComponent(String(key)).replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent).replace(/[\(\)]/g, escape);
            var stringifiedAttributes = "";
            for(var attributeName in attributes){
                if (!attributes[attributeName]) continue;
                stringifiedAttributes += "; " + attributeName;
                if (attributes[attributeName] === true) continue;
                // Considers RFC 6265 section 5.2:
                // ...
                // 3.  If the remaining unparsed-attributes contains a %x3B (";")
                //     character:
                // Consume the characters of the unparsed-attributes up to,
                // not including, the first %x3B (";") character.
                // ...
                stringifiedAttributes += "=" + attributes[attributeName].split(";")[0];
            }
            return document.cookie = key + "=" + value + stringifiedAttributes;
        }
        function get(key, json) {
            if (typeof document === "undefined") return;
            var jar = {};
            // To prevent the for loop in the first place assign an empty array
            // in case there are no cookies at all.
            var cookies = document.cookie ? document.cookie.split("; ") : [];
            var i = 0;
            for(; i < cookies.length; i++){
                var parts = cookies[i].split("=");
                var cookie = parts.slice(1).join("=");
                if (!json && cookie.charAt(0) === '"') cookie = cookie.slice(1, -1);
                try {
                    var name = decode(parts[0]);
                    cookie = (converter.read || converter)(cookie, name) || decode(cookie);
                    if (json) try {
                        cookie = JSON.parse(cookie);
                    } catch (e) {}
                    jar[name] = cookie;
                    if (key === name) break;
                } catch (e) {}
            }
            return key ? jar[key] : jar;
        }
        api.set = set;
        api.get = function(key) {
            return get(key, false);
        };
        api.getJSON = function(key) {
            return get(key, true);
        };
        api.remove = function(key, attributes) {
            set(key, "", extend(attributes, {
                expires: -1
            }));
        };
        api.defaults = {};
        api.withConverter = init;
        return api;
    }
    return init(function() {});
});

});

parcelRegister("fI8Jj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b701bca0e1325828$export$2e2bcd8739ae039; });

var $7n5Kg = parcelRequire("7n5Kg");
class $b701bca0e1325828$export$2e2bcd8739ae039 {
    constructor(){
        this.safeStorage = new (0, $7n5Kg.default)({
            useStoragePrefix: false
        });
    }
    set(name, value) {
        this.safeStorage.setItem(name, value);
        return value;
    }
    get(name) {
        const value = this.safeStorage.getItem(name);
        return value || undefined;
    }
    remove(name) {
        this.safeStorage.removeItem(name);
    }
}

});
parcelRegister("7n5Kg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $55df234352e47bdf$export$2e2bcd8739ae039; });

var $eXtB3 = parcelRequire("eXtB3");

var $2HueP = parcelRequire("2HueP");
class $55df234352e47bdf$export$2e2bcd8739ae039 extends (0, $2HueP.default) {
    constructor(options){
        let storageToUse;
        try {
            storageToUse = window.localStorage || (0, $eXtB3.default);
        } catch (err) {
            storageToUse = (0, $eXtB3.default);
        }
        super(storageToUse, options);
    }
}

});
parcelRegister("eXtB3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ae3d88ad7abb02fb$export$2e2bcd8739ae039; });

var $gsv4E = parcelRequire("gsv4E");
class $ae3d88ad7abb02fb$export$90e3e001bcac59c7 {
    constructor(){
        (0, (/*@__PURE__*/$parcel$interopDefault($gsv4E)))(this, "_data", {});
        (0, (/*@__PURE__*/$parcel$interopDefault($gsv4E)))(this, "length", 0);
        (0, (/*@__PURE__*/$parcel$interopDefault($gsv4E)))(this, "setItem", (key, value)=>{
            this._data[key] = value;
            this.length = Object.keys(this._data).length;
            return value;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($gsv4E)))(this, "getItem", (key)=>{
            if (key in this._data) return this._data[key];
            return null;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($gsv4E)))(this, "removeItem", (key)=>{
            if (key in this._data) delete this._data[key];
            this.length = Object.keys(this._data).length;
            return null;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($gsv4E)))(this, "clear", ()=>{
            this._data = {};
            this.length = 0;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($gsv4E)))(this, "key", (index)=>Object.keys(this._data)[index]);
    }
}
var // eslint-disable-next-line import/no-anonymous-default-export
$ae3d88ad7abb02fb$export$2e2bcd8739ae039 = new $ae3d88ad7abb02fb$export$90e3e001bcac59c7();

});

parcelRegister("2HueP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1f770d9e8b0e657a$export$2e2bcd8739ae039; });

var $gsv4E = parcelRequire("gsv4E");

var $fyxFC = parcelRequire("fyxFC");

var $eXtB3 = parcelRequire("eXtB3");
const $1f770d9e8b0e657a$export$41c06fdd37b7e9a5 = "awc";
const $1f770d9e8b0e657a$export$770aa8bc07b3de03 = "awcInMemoryStorageFallback";
function $1f770d9e8b0e657a$export$48c17662a6902497(store) {
    const TEST_VALUE = "test_value";
    if (!store) return false;
    try {
        const key = "awc.storage.support";
        store.setItem(key, TEST_VALUE);
        const value = store.getItem(key);
        store.removeItem(key);
        // handle localStorage silently failing
        return value === TEST_VALUE;
    } catch (e) {
        // Can throw if localStorage is disabled
        return false;
    }
}
function $1f770d9e8b0e657a$export$6325979d1c67607f(e) {
    let quotaExceeded = false;
    if (e.code) switch(e.code){
        case 22:
            quotaExceeded = true;
            break;
        case 1014:
            // Firefox
            if (e.name === "NS_ERROR_DOM_QUOTA_REACHED") quotaExceeded = true;
            break;
        default:
            break;
    }
    else if (e.number === -2147024882) // Internet Explorer 8
    quotaExceeded = true;
    return quotaExceeded;
}
class $1f770d9e8b0e657a$export$2e2bcd8739ae039 {
    constructor(storageToUse, options = {}){
        (0, (/*@__PURE__*/$parcel$interopDefault($gsv4E)))(this, "getStore", ()=>this._store);
        (0, (/*@__PURE__*/$parcel$interopDefault($gsv4E)))(this, "getItem", (key)=>this._store.getItem(this.createKey(key)));
        (0, (/*@__PURE__*/$parcel$interopDefault($gsv4E)))(this, "removeItem", (key)=>this._store.removeItem(this.createKey(key)));
        (0, (/*@__PURE__*/$parcel$interopDefault($gsv4E)))(this, "setItem", (key, value)=>{
            try {
                this._store.setItem(this.createKey(key), value);
            } catch (err) {
                if ($1f770d9e8b0e657a$export$6325979d1c67607f(err)) {
                    this.swapToInMemory();
                    this._store.setItem(this.createKey(key), value);
                }
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($gsv4E)))(this, "swapToInMemory", ()=>{
            if (this._store === (0, $eXtB3.default) || typeof window === "undefined") return;
            const keys = Object.keys(this._store || {});
            let inMemoryStorage;
            if ($1f770d9e8b0e657a$export$48c17662a6902497(window[$1f770d9e8b0e657a$export$770aa8bc07b3de03])) inMemoryStorage = window[$1f770d9e8b0e657a$export$770aa8bc07b3de03];
            else {
                inMemoryStorage = (0, $eXtB3.default);
                if (!window[$1f770d9e8b0e657a$export$770aa8bc07b3de03]) // If not already attached to window then attach our instance of InMemoryStorage
                // We need to do this because if there are multiple instances of Analytics Client in multiple scopes,
                // there is no way to guarantee the throttling behaviour of the UI viewed event across those instances without a global singleton
                window[$1f770d9e8b0e657a$export$770aa8bc07b3de03] = (0, $eXtB3.default);
            }
            keys.forEach((key)=>{
                if (key.indexOf(this.getPrefix()) === 0) {
                    const value = this._store.getItem(key);
                    if (value) inMemoryStorage.setItem(key, value);
                }
            });
            this._store = inMemoryStorage;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($gsv4E)))(this, "clear", ()=>this._store.clear());
        (0, (/*@__PURE__*/$parcel$interopDefault($gsv4E)))(this, "key", (index)=>this._store.key(index));
        (0, (/*@__PURE__*/$parcel$interopDefault($gsv4E)))(this, "getPrefix", ()=>this._prefix);
        (0, (/*@__PURE__*/$parcel$interopDefault($gsv4E)))(this, "createKey", (key)=>{
            if (this._prefix) return `${this.getPrefix()}.${key}`;
            return key;
        });
        this.options = options;
        const prefixes = [];
        if (options.useStoragePrefix === undefined || options.useStoragePrefix) prefixes.push($1f770d9e8b0e657a$export$41c06fdd37b7e9a5);
        if (options.envPrefix && options.envPrefix !== (0, $fyxFC.envType).PROD) prefixes.push(options.envPrefix);
        this._prefix = prefixes.join("-");
        if ($1f770d9e8b0e657a$export$48c17662a6902497(storageToUse)) this._store = storageToUse;
        else this.swapToInMemory();
    }
}

});



parcelRegister("9aa6h", function(module, exports) {

$parcel$export(module.exports, "canUseCookie", function () { return $6abce1eeff8d1106$export$a9330601ee8f4d95; });
$parcel$export(module.exports, "getTld", function () { return $6abce1eeff8d1106$export$de6821eed3d5f32d; });

var $4nZ1y = parcelRequire("4nZ1y");

var $dHPoE = parcelRequire("dHPoE");

var $1lwuH = parcelRequire("1lwuH");
const $6abce1eeff8d1106$export$a9330601ee8f4d95 = (disableCookiePersistence = false)=>{
    if (disableCookiePersistence) return false;
    return !(location.protocol === "file:" || location.protocol === "chrome-extension:");
};
const $6abce1eeff8d1106$export$eb80e1beaa8dacf8 = (0, $1lwuH.AllAnalyticsCookies).AWC_TLD_TEST.getKey();
const $6abce1eeff8d1106$export$19164982d36535d8 = "tld_test";
const $6abce1eeff8d1106$export$de6821eed3d5f32d = (0, $dHPoE.default)(()=>{
    if (typeof location === "undefined") return "";
    const { hostname: hostname } = location;
    const splitHostname = hostname.split(".");
    for(let i = 1; i <= splitHostname.length; i++){
        const domainParts = splitHostname.slice(i * -1);
        const domain = `.${domainParts.join(".")}`;
        (0, (/*@__PURE__*/$parcel$interopDefault($4nZ1y))).set($6abce1eeff8d1106$export$eb80e1beaa8dacf8, $6abce1eeff8d1106$export$19164982d36535d8, {
            domain: domain
        });
        if ((0, (/*@__PURE__*/$parcel$interopDefault($4nZ1y))).get($6abce1eeff8d1106$export$eb80e1beaa8dacf8) === $6abce1eeff8d1106$export$19164982d36535d8) {
            (0, (/*@__PURE__*/$parcel$interopDefault($4nZ1y))).remove($6abce1eeff8d1106$export$eb80e1beaa8dacf8, {
                domain: domain
            });
            return domain;
        }
    }
    return hostname;
});

});



parcelRegister("94tE9", function(module, exports) {

$parcel$export(module.exports, "buildContext", function () { return $69ab7bf8d893fe22$export$3a7fe28f9bf4f3d9; });
$parcel$export(module.exports, "prepareEventProperties", function () { return $69ab7bf8d893fe22$export$44d22e5fb02cc68e; });

var $gsv4E = parcelRequire("gsv4E");

var $gIAiV = parcelRequire("gIAiV");
function $69ab7bf8d893fe22$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $69ab7bf8d893fe22$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $69ab7bf8d893fe22$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($gsv4E)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $69ab7bf8d893fe22$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $69ab7bf8d893fe22$export$3a7fe28f9bf4f3d9 = (context)=>{
    return $69ab7bf8d893fe22$var$_objectSpread($69ab7bf8d893fe22$var$_objectSpread({}, context.context), {}, {
        userAgent: navigator.userAgent
    });
};
const $69ab7bf8d893fe22$export$44d22e5fb02cc68e = (properties)=>{
    const propertiesWithoutUndefined = $69ab7bf8d893fe22$export$2250ccecd1e040fd(properties);
    return (0, (/*@__PURE__*/$parcel$interopDefault($gIAiV)))(propertiesWithoutUndefined);
};
const $69ab7bf8d893fe22$export$2250ccecd1e040fd = (obj)=>{
    if (obj === null || typeof obj !== "object") return obj;
    const clone = {};
    Object.keys(obj).forEach((key)=>{
        const value = $69ab7bf8d893fe22$var$getValueOfObject(obj, key);
        if (value !== undefined) {
            if (Array.isArray(value)) clone[key] = value.map((i)=>$69ab7bf8d893fe22$export$2250ccecd1e040fd(i));
            else if (typeof value === "object" && value !== null) clone[key] = $69ab7bf8d893fe22$export$2250ccecd1e040fd(value);
            else clone[key] = value;
        }
    });
    return clone;
};
// Using ts-ignore everywhere urked me
const $69ab7bf8d893fe22$var$getValueOfObject = (obj, key)=>{
    // @ts-ignore This is an object
    return obj[key];
};

});
parcelRegister("gIAiV", function(module, exports) {
"use strict";

var $7AYQl = parcelRequire("7AYQl");
/**
 * Expose `traverse`.
 */ module.exports = $c2bceaaebbf7b3f9$var$traverse;
/**
 * Recursively traverse an object or array, and convert
 * all ISO date strings parse into Date objects.
 *
 * @param {Object} input - object, array, or string to convert
 * @param {Boolean} strict - only convert strings with year, month, and date
 * @return {Object}
 */ function $c2bceaaebbf7b3f9$var$traverse(input, strict) {
    if (strict === undefined) strict = true;
    if (input && typeof input === "object") return $c2bceaaebbf7b3f9$var$traverseObject(input, strict);
    else if (Array.isArray(input)) return $c2bceaaebbf7b3f9$var$traverseArray(input, strict);
    else if ($7AYQl.is(input, strict)) return $7AYQl.parse(input);
    return input;
}
/**
 * Object traverser helper function.
 *
 * @param {Object} obj - object to traverse
 * @param {Boolean} strict - only convert strings with year, month, and date
 * @return {Object}
 */ function $c2bceaaebbf7b3f9$var$traverseObject(obj, strict) {
    Object.keys(obj).forEach(function(key) {
        obj[key] = $c2bceaaebbf7b3f9$var$traverse(obj[key], strict);
    });
    return obj;
}
/**
 * Array traverser helper function
 *
 * @param {Array} arr - array to traverse
 * @param {Boolean} strict - only convert strings with year, month, and date
 * @return {Array}
 */ function $c2bceaaebbf7b3f9$var$traverseArray(arr, strict) {
    arr.forEach(function(value, index) {
        arr[index] = $c2bceaaebbf7b3f9$var$traverse(value, strict);
    });
    return arr;
}

});
parcelRegister("7AYQl", function(module, exports) {

$parcel$export(module.exports, "parse", function () { return $587b1767e551d764$export$98e6a39c04603d36; }, function (v) { return $587b1767e551d764$export$98e6a39c04603d36 = v; });
$parcel$export(module.exports, "is", function () { return $587b1767e551d764$export$226b3eccf92c9ed9; }, function (v) { return $587b1767e551d764$export$226b3eccf92c9ed9 = v; });
/**
 * Convert an ISO date string to a date. Fallback to native `Date.parse`.
 *
 * https://github.com/csnover/js-iso8601/blob/lax/iso8601.js
 *
 * @param {String} iso
 * @return {Date}
 */ var $587b1767e551d764$export$98e6a39c04603d36;
/**
 * Checks whether a `string` is an ISO date string. `strict` mode requires that
 * the date string at least have a year, month and date.
 *
 * @param {String} string
 * @param {Boolean} strict
 * @return {Boolean}
 */ var $587b1767e551d764$export$226b3eccf92c9ed9;
"use strict";
/**
 * Matcher, slightly modified from:
 *
 * https://github.com/csnover/js-iso8601/blob/lax/iso8601.js
 */ var $587b1767e551d764$var$matcher = /^(\d{4})(?:-?(\d{2})(?:-?(\d{2}))?)?(?:([ T])(\d{2}):?(\d{2})(?::?(\d{2})(?:[,\.](\d{1,}))?)?(?:(Z)|([+\-])(\d{2})(?::?(\d{2}))?)?)?$/;
$587b1767e551d764$export$98e6a39c04603d36 = function(iso) {
    var numericKeys = [
        1,
        5,
        6,
        7,
        11,
        12
    ];
    var arr = $587b1767e551d764$var$matcher.exec(iso);
    var offset = 0;
    // fallback to native parsing
    if (!arr) return new Date(iso);
    /* eslint-disable no-cond-assign */ // remove undefined values
    for(var i = 0, val; val = numericKeys[i]; i++)arr[val] = parseInt(arr[val], 10) || 0;
    /* eslint-enable no-cond-assign */ // allow undefined days and months
    arr[2] = parseInt(arr[2], 10) || 1;
    arr[3] = parseInt(arr[3], 10) || 1;
    // month is 0-11
    arr[2]--;
    // allow abitrary sub-second precision
    arr[8] = arr[8] ? (arr[8] + "00").substring(0, 3) : 0;
    // apply timezone if one exists
    if (arr[4] === " ") offset = new Date().getTimezoneOffset();
    else if (arr[9] !== "Z" && arr[10]) {
        offset = arr[11] * 60 + arr[12];
        if (arr[10] === "+") offset = 0 - offset;
    }
    var millis = Date.UTC(arr[1], arr[2], arr[3], arr[5], arr[6] + offset, arr[7], arr[8]);
    return new Date(millis);
};
$587b1767e551d764$export$226b3eccf92c9ed9 = function(string, strict) {
    if (typeof string !== "string") return false;
    if (strict && /^\d{4}-\d{2}-\d{2}/.test(string) === false) return false;
    return $587b1767e551d764$var$matcher.test(string);
};

});




parcelRegister("eckKx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a5624823e4c1daea$export$2e2bcd8739ae039; });

var $gsv4E = parcelRequire("gsv4E");

var $fyxFC = parcelRequire("fyxFC");

var $bk1z1 = parcelRequire("bk1z1");
class $a5624823e4c1daea$export$2e2bcd8739ae039 {
    constructor(){
        (0, (/*@__PURE__*/$parcel$interopDefault($gsv4E)))(this, "handleOriginParameters", (originParamHandlerMapping, historyReplaceFn)=>{
            // Collect all the parameter labels to be handled
            const originParamLabelList = Object.keys(originParamHandlerMapping);
            if (!(originParamLabelList.length > 0)) throw new Error("Empty parameter mapping provided");
            // Check if the parameter labels are valid. If any invalid labels are found throw an exception.
            const invalidParams = originParamLabelList.filter((x)=>Object.values((0, $fyxFC.originTracingType)).indexOf(x) < 0);
            if (invalidParams.length > 0) throw new Error(`Invalid Origin Tracing Parameter(s) supplied: ${invalidParams.join()}!`);
            const isCaptureParam = (_, key)=>originParamLabelList.indexOf(key) >= 0;
            // Capture and remove params from URL
            const capturedURLParams = (0, $bk1z1.default)(isCaptureParam, historyReplaceFn);
            // Apply provided handler function to extract origin trace ID from each URL parameter
            const applyHandlerFunction = (key)=>{
                const x = originParamHandlerMapping[key](capturedURLParams[key]);
                return {
                    [key]: x
                };
            };
            const extractedOriginID = Object.keys(capturedURLParams).map(applyHandlerFunction).reduce((accumulator, currentValue)=>Object.assign(accumulator, currentValue), {});
            return extractedOriginID;
        });
        this._originStore = {};
    }
}

});
parcelRegister("bk1z1", function(module, exports) {

$parcel$export(module.exports, "defaultHistoryReplaceFn", function () { return $83e2c686bfccd2c4$export$600dd5bf1b049f11; });
$parcel$export(module.exports, "default", function () { return $83e2c686bfccd2c4$export$2e2bcd8739ae039; });

var $3N6J0 = parcelRequire("3N6J0");

var $gCau2 = parcelRequire("gCau2");
const $83e2c686bfccd2c4$export$600dd5bf1b049f11 = (newUrl)=>window.history.replaceState({}, "", newUrl);
const $83e2c686bfccd2c4$var$urlParamExtractor = (isCaptureParam, historyReplaceFn = $83e2c686bfccd2c4$export$600dd5bf1b049f11)=>{
    // Extract target parameters and values from URL if present
    const originalUrl = window.location.href;
    const fragmentHash = window.location.hash;
    const removedFragmentURL = fragmentHash !== "" ? originalUrl.replace(fragmentHash, "") : originalUrl;
    const { url: url, query: query } = (0, $3N6J0.parseUrl)(removedFragmentURL);
    const captureParams = (0, $gCau2.pickBy)(query, isCaptureParam);
    // Do not modify URL if no matches
    if (Object.keys(captureParams).length > 0) {
        const queryWithoutCaptureParams = (0, $gCau2.omitBy)(query, isCaptureParam);
        // Replace the URL minus captured parameters
        if (Object.keys(queryWithoutCaptureParams).length > 0) {
            const newUrl = `${url}?${(0, $3N6J0.stringify)(queryWithoutCaptureParams)}${fragmentHash}`;
            historyReplaceFn(newUrl);
        } else historyReplaceFn(`${url}${fragmentHash}`);
    }
    return captureParams;
};
var $83e2c686bfccd2c4$export$2e2bcd8739ae039 = $83e2c686bfccd2c4$var$urlParamExtractor;

});
parcelRegister("3N6J0", function(module, exports) {

$parcel$export(module.exports, "extract", function () { return $2c2b2a1a464bf285$export$f9380c9a627682d3; }, function (v) { return $2c2b2a1a464bf285$export$f9380c9a627682d3 = v; });
$parcel$export(module.exports, "parse", function () { return $2c2b2a1a464bf285$export$98e6a39c04603d36; }, function (v) { return $2c2b2a1a464bf285$export$98e6a39c04603d36 = v; });
$parcel$export(module.exports, "stringify", function () { return $2c2b2a1a464bf285$export$fac44ee5b035f737; }, function (v) { return $2c2b2a1a464bf285$export$fac44ee5b035f737 = v; });
$parcel$export(module.exports, "parseUrl", function () { return $2c2b2a1a464bf285$export$7a5253c0f62e0150; }, function (v) { return $2c2b2a1a464bf285$export$7a5253c0f62e0150 = v; });
$parcel$export(module.exports, "stringifyUrl", function () { return $2c2b2a1a464bf285$export$a8c1621ea79325d3; }, function (v) { return $2c2b2a1a464bf285$export$a8c1621ea79325d3 = v; });
$parcel$export(module.exports, "pick", function () { return $2c2b2a1a464bf285$export$357523c63a2253b9; }, function (v) { return $2c2b2a1a464bf285$export$357523c63a2253b9 = v; });
$parcel$export(module.exports, "exclude", function () { return $2c2b2a1a464bf285$export$44c361b8ec72ef7f; }, function (v) { return $2c2b2a1a464bf285$export$44c361b8ec72ef7f = v; });
var $2c2b2a1a464bf285$export$f9380c9a627682d3;
var $2c2b2a1a464bf285$export$98e6a39c04603d36;
var $2c2b2a1a464bf285$export$fac44ee5b035f737;
var $2c2b2a1a464bf285$export$7a5253c0f62e0150;
var $2c2b2a1a464bf285$export$a8c1621ea79325d3;
var $2c2b2a1a464bf285$export$357523c63a2253b9;
var $2c2b2a1a464bf285$export$44c361b8ec72ef7f;
"use strict";

var $dQEHF = parcelRequire("dQEHF");

var $5bsaJ = parcelRequire("5bsaJ");

var $710Zd = parcelRequire("710Zd");

var $cyVoW = parcelRequire("cyVoW");
const $2c2b2a1a464bf285$var$isNullOrUndefined = (value)=>value === null || value === undefined;
const $2c2b2a1a464bf285$var$encodeFragmentIdentifier = Symbol("encodeFragmentIdentifier");
function $2c2b2a1a464bf285$var$encoderForArrayFormat(options) {
    switch(options.arrayFormat){
        case "index":
            return (key)=>(result, value)=>{
                    const index = result.length;
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === "") return result;
                    if (value === null) return [
                        ...result,
                        [
                            $2c2b2a1a464bf285$var$encode(key, options),
                            "[",
                            index,
                            "]"
                        ].join("")
                    ];
                    return [
                        ...result,
                        [
                            $2c2b2a1a464bf285$var$encode(key, options),
                            "[",
                            $2c2b2a1a464bf285$var$encode(index, options),
                            "]=",
                            $2c2b2a1a464bf285$var$encode(value, options)
                        ].join("")
                    ];
                };
        case "bracket":
            return (key)=>(result, value)=>{
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === "") return result;
                    if (value === null) return [
                        ...result,
                        [
                            $2c2b2a1a464bf285$var$encode(key, options),
                            "[]"
                        ].join("")
                    ];
                    return [
                        ...result,
                        [
                            $2c2b2a1a464bf285$var$encode(key, options),
                            "[]=",
                            $2c2b2a1a464bf285$var$encode(value, options)
                        ].join("")
                    ];
                };
        case "colon-list-separator":
            return (key)=>(result, value)=>{
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === "") return result;
                    if (value === null) return [
                        ...result,
                        [
                            $2c2b2a1a464bf285$var$encode(key, options),
                            ":list="
                        ].join("")
                    ];
                    return [
                        ...result,
                        [
                            $2c2b2a1a464bf285$var$encode(key, options),
                            ":list=",
                            $2c2b2a1a464bf285$var$encode(value, options)
                        ].join("")
                    ];
                };
        case "comma":
        case "separator":
        case "bracket-separator":
            {
                const keyValueSep = options.arrayFormat === "bracket-separator" ? "[]=" : "=";
                return (key)=>(result, value)=>{
                        if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === "") return result;
                        // Translate null to an empty string so that it doesn't serialize as 'null'
                        value = value === null ? "" : value;
                        if (result.length === 0) return [
                            [
                                $2c2b2a1a464bf285$var$encode(key, options),
                                keyValueSep,
                                $2c2b2a1a464bf285$var$encode(value, options)
                            ].join("")
                        ];
                        return [
                            [
                                result,
                                $2c2b2a1a464bf285$var$encode(value, options)
                            ].join(options.arrayFormatSeparator)
                        ];
                    };
            }
        default:
            return (key)=>(result, value)=>{
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === "") return result;
                    if (value === null) return [
                        ...result,
                        $2c2b2a1a464bf285$var$encode(key, options)
                    ];
                    return [
                        ...result,
                        [
                            $2c2b2a1a464bf285$var$encode(key, options),
                            "=",
                            $2c2b2a1a464bf285$var$encode(value, options)
                        ].join("")
                    ];
                };
    }
}
function $2c2b2a1a464bf285$var$parserForArrayFormat(options) {
    let result;
    switch(options.arrayFormat){
        case "index":
            return (key, value, accumulator)=>{
                result = /\[(\d*)\]$/.exec(key);
                key = key.replace(/\[\d*\]$/, "");
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) accumulator[key] = {};
                accumulator[key][result[1]] = value;
            };
        case "bracket":
            return (key, value, accumulator)=>{
                result = /(\[\])$/.exec(key);
                key = key.replace(/\[\]$/, "");
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) {
                    accumulator[key] = [
                        value
                    ];
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
        case "colon-list-separator":
            return (key, value, accumulator)=>{
                result = /(:list)$/.exec(key);
                key = key.replace(/:list$/, "");
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) {
                    accumulator[key] = [
                        value
                    ];
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
        case "comma":
        case "separator":
            return (key, value, accumulator)=>{
                const isArray = typeof value === "string" && value.includes(options.arrayFormatSeparator);
                const isEncodedArray = typeof value === "string" && !isArray && $2c2b2a1a464bf285$var$decode(value, options).includes(options.arrayFormatSeparator);
                value = isEncodedArray ? $2c2b2a1a464bf285$var$decode(value, options) : value;
                const newValue = isArray || isEncodedArray ? value.split(options.arrayFormatSeparator).map((item)=>$2c2b2a1a464bf285$var$decode(item, options)) : value === null ? value : $2c2b2a1a464bf285$var$decode(value, options);
                accumulator[key] = newValue;
            };
        case "bracket-separator":
            return (key, value, accumulator)=>{
                const isArray = /(\[\])$/.test(key);
                key = key.replace(/\[\]$/, "");
                if (!isArray) {
                    accumulator[key] = value ? $2c2b2a1a464bf285$var$decode(value, options) : value;
                    return;
                }
                const arrayValue = value === null ? [] : value.split(options.arrayFormatSeparator).map((item)=>$2c2b2a1a464bf285$var$decode(item, options));
                if (accumulator[key] === undefined) {
                    accumulator[key] = arrayValue;
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], arrayValue);
            };
        default:
            return (key, value, accumulator)=>{
                if (accumulator[key] === undefined) {
                    accumulator[key] = value;
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
    }
}
function $2c2b2a1a464bf285$var$validateArrayFormatSeparator(value) {
    if (typeof value !== "string" || value.length !== 1) throw new TypeError("arrayFormatSeparator must be single character string");
}
function $2c2b2a1a464bf285$var$encode(value, options) {
    if (options.encode) return options.strict ? $dQEHF(value) : encodeURIComponent(value);
    return value;
}
function $2c2b2a1a464bf285$var$decode(value, options) {
    if (options.decode) return $5bsaJ(value);
    return value;
}
function $2c2b2a1a464bf285$var$keysSorter(input) {
    if (Array.isArray(input)) return input.sort();
    if (typeof input === "object") return $2c2b2a1a464bf285$var$keysSorter(Object.keys(input)).sort((a, b)=>Number(a) - Number(b)).map((key)=>input[key]);
    return input;
}
function $2c2b2a1a464bf285$var$removeHash(input) {
    const hashStart = input.indexOf("#");
    if (hashStart !== -1) input = input.slice(0, hashStart);
    return input;
}
function $2c2b2a1a464bf285$var$getHash(url) {
    let hash = "";
    const hashStart = url.indexOf("#");
    if (hashStart !== -1) hash = url.slice(hashStart);
    return hash;
}
function $2c2b2a1a464bf285$var$extract(input) {
    input = $2c2b2a1a464bf285$var$removeHash(input);
    const queryStart = input.indexOf("?");
    if (queryStart === -1) return "";
    return input.slice(queryStart + 1);
}
function $2c2b2a1a464bf285$var$parseValue(value, options) {
    if (options.parseNumbers && !Number.isNaN(Number(value)) && typeof value === "string" && value.trim() !== "") value = Number(value);
    else if (options.parseBooleans && value !== null && (value.toLowerCase() === "true" || value.toLowerCase() === "false")) value = value.toLowerCase() === "true";
    return value;
}
function $2c2b2a1a464bf285$var$parse(query, options) {
    options = Object.assign({
        decode: true,
        sort: true,
        arrayFormat: "none",
        arrayFormatSeparator: ",",
        parseNumbers: false,
        parseBooleans: false
    }, options);
    $2c2b2a1a464bf285$var$validateArrayFormatSeparator(options.arrayFormatSeparator);
    const formatter = $2c2b2a1a464bf285$var$parserForArrayFormat(options);
    // Create an object with no prototype
    const ret = Object.create(null);
    if (typeof query !== "string") return ret;
    query = query.trim().replace(/^[?#&]/, "");
    if (!query) return ret;
    for (const param of query.split("&")){
        if (param === "") continue;
        let [key, value] = $710Zd(options.decode ? param.replace(/\+/g, " ") : param, "=");
        // Missing `=` should be `null`:
        // http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
        value = value === undefined ? null : [
            "comma",
            "separator",
            "bracket-separator"
        ].includes(options.arrayFormat) ? value : $2c2b2a1a464bf285$var$decode(value, options);
        formatter($2c2b2a1a464bf285$var$decode(key, options), value, ret);
    }
    for (const key of Object.keys(ret)){
        const value = ret[key];
        if (typeof value === "object" && value !== null) for (const k of Object.keys(value))value[k] = $2c2b2a1a464bf285$var$parseValue(value[k], options);
        else ret[key] = $2c2b2a1a464bf285$var$parseValue(value, options);
    }
    if (options.sort === false) return ret;
    return (options.sort === true ? Object.keys(ret).sort() : Object.keys(ret).sort(options.sort)).reduce((result, key)=>{
        const value = ret[key];
        if (Boolean(value) && typeof value === "object" && !Array.isArray(value)) // Sort object keys, not values
        result[key] = $2c2b2a1a464bf285$var$keysSorter(value);
        else result[key] = value;
        return result;
    }, Object.create(null));
}
$2c2b2a1a464bf285$export$f9380c9a627682d3 = $2c2b2a1a464bf285$var$extract;
$2c2b2a1a464bf285$export$98e6a39c04603d36 = $2c2b2a1a464bf285$var$parse;
$2c2b2a1a464bf285$export$fac44ee5b035f737 = (object, options)=>{
    if (!object) return "";
    options = Object.assign({
        encode: true,
        strict: true,
        arrayFormat: "none",
        arrayFormatSeparator: ","
    }, options);
    $2c2b2a1a464bf285$var$validateArrayFormatSeparator(options.arrayFormatSeparator);
    const shouldFilter = (key)=>options.skipNull && $2c2b2a1a464bf285$var$isNullOrUndefined(object[key]) || options.skipEmptyString && object[key] === "";
    const formatter = $2c2b2a1a464bf285$var$encoderForArrayFormat(options);
    const objectCopy = {};
    for (const key of Object.keys(object))if (!shouldFilter(key)) objectCopy[key] = object[key];
    const keys = Object.keys(objectCopy);
    if (options.sort !== false) keys.sort(options.sort);
    return keys.map((key)=>{
        const value = object[key];
        if (value === undefined) return "";
        if (value === null) return $2c2b2a1a464bf285$var$encode(key, options);
        if (Array.isArray(value)) {
            if (value.length === 0 && options.arrayFormat === "bracket-separator") return $2c2b2a1a464bf285$var$encode(key, options) + "[]";
            return value.reduce(formatter(key), []).join("&");
        }
        return $2c2b2a1a464bf285$var$encode(key, options) + "=" + $2c2b2a1a464bf285$var$encode(value, options);
    }).filter((x)=>x.length > 0).join("&");
};
$2c2b2a1a464bf285$export$7a5253c0f62e0150 = (url, options)=>{
    options = Object.assign({
        decode: true
    }, options);
    const [url_, hash] = $710Zd(url, "#");
    return Object.assign({
        url: url_.split("?")[0] || "",
        query: $2c2b2a1a464bf285$var$parse($2c2b2a1a464bf285$var$extract(url), options)
    }, options && options.parseFragmentIdentifier && hash ? {
        fragmentIdentifier: $2c2b2a1a464bf285$var$decode(hash, options)
    } : {});
};
$2c2b2a1a464bf285$export$a8c1621ea79325d3 = (object, options)=>{
    options = Object.assign({
        encode: true,
        strict: true,
        [$2c2b2a1a464bf285$var$encodeFragmentIdentifier]: true
    }, options);
    const url = $2c2b2a1a464bf285$var$removeHash(object.url).split("?")[0] || "";
    const queryFromUrl = $2c2b2a1a464bf285$export$f9380c9a627682d3(object.url);
    const parsedQueryFromUrl = $2c2b2a1a464bf285$export$98e6a39c04603d36(queryFromUrl, {
        sort: false
    });
    const query = Object.assign(parsedQueryFromUrl, object.query);
    let queryString = $2c2b2a1a464bf285$export$fac44ee5b035f737(query, options);
    if (queryString) queryString = `?${queryString}`;
    let hash = $2c2b2a1a464bf285$var$getHash(object.url);
    if (object.fragmentIdentifier) hash = `#${options[$2c2b2a1a464bf285$var$encodeFragmentIdentifier] ? $2c2b2a1a464bf285$var$encode(object.fragmentIdentifier, options) : object.fragmentIdentifier}`;
    return `${url}${queryString}${hash}`;
};
$2c2b2a1a464bf285$export$357523c63a2253b9 = (input, filter, options)=>{
    options = Object.assign({
        parseFragmentIdentifier: true,
        [$2c2b2a1a464bf285$var$encodeFragmentIdentifier]: false
    }, options);
    const { url: url, query: query, fragmentIdentifier: fragmentIdentifier } = $2c2b2a1a464bf285$export$7a5253c0f62e0150(input, options);
    return $2c2b2a1a464bf285$export$a8c1621ea79325d3({
        url: url,
        query: $cyVoW(query, filter),
        fragmentIdentifier: fragmentIdentifier
    }, options);
};
$2c2b2a1a464bf285$export$44c361b8ec72ef7f = (input, filter, options)=>{
    const exclusionFilter = Array.isArray(filter) ? (key)=>!filter.includes(key) : (key, value)=>!filter(key, value);
    return $2c2b2a1a464bf285$export$357523c63a2253b9(input, exclusionFilter, options);
};

});
parcelRegister("dQEHF", function(module, exports) {
"use strict";
module.exports = (str)=>encodeURIComponent(str).replace(/[!'()*]/g, (x)=>`%${x.charCodeAt(0).toString(16).toUpperCase()}`);

});

parcelRegister("5bsaJ", function(module, exports) {
"use strict";
var $3c63d5326ea31a64$var$token = "%[a-f0-9]{2}";
var $3c63d5326ea31a64$var$singleMatcher = new RegExp("(" + $3c63d5326ea31a64$var$token + ")|([^%]+?)", "gi");
var $3c63d5326ea31a64$var$multiMatcher = new RegExp("(" + $3c63d5326ea31a64$var$token + ")+", "gi");
function $3c63d5326ea31a64$var$decodeComponents(components, split) {
    try {
        // Try to decode the entire string first
        return [
            decodeURIComponent(components.join(""))
        ];
    } catch (err) {
    // Do nothing
    }
    if (components.length === 1) return components;
    split = split || 1;
    // Split the array in 2 parts
    var left = components.slice(0, split);
    var right = components.slice(split);
    return Array.prototype.concat.call([], $3c63d5326ea31a64$var$decodeComponents(left), $3c63d5326ea31a64$var$decodeComponents(right));
}
function $3c63d5326ea31a64$var$decode(input) {
    try {
        return decodeURIComponent(input);
    } catch (err) {
        var tokens = input.match($3c63d5326ea31a64$var$singleMatcher) || [];
        for(var i = 1; i < tokens.length; i++){
            input = $3c63d5326ea31a64$var$decodeComponents(tokens, i).join("");
            tokens = input.match($3c63d5326ea31a64$var$singleMatcher) || [];
        }
        return input;
    }
}
function $3c63d5326ea31a64$var$customDecodeURIComponent(input) {
    // Keep track of all the replacements and prefill the map with the `BOM`
    var replaceMap = {
        "%FE%FF": "\uFFFD\uFFFD",
        "%FF%FE": "\uFFFD\uFFFD"
    };
    var match = $3c63d5326ea31a64$var$multiMatcher.exec(input);
    while(match){
        try {
            // Decode as big chunks as possible
            replaceMap[match[0]] = decodeURIComponent(match[0]);
        } catch (err) {
            var result = $3c63d5326ea31a64$var$decode(match[0]);
            if (result !== match[0]) replaceMap[match[0]] = result;
        }
        match = $3c63d5326ea31a64$var$multiMatcher.exec(input);
    }
    // Add `%C2` at the end of the map to make sure it does not replace the combinator before everything else
    replaceMap["%C2"] = "\uFFFD";
    var entries = Object.keys(replaceMap);
    for(var i = 0; i < entries.length; i++){
        // Replace all decoded components
        var key = entries[i];
        input = input.replace(new RegExp(key, "g"), replaceMap[key]);
    }
    return input;
}
module.exports = function(encodedURI) {
    if (typeof encodedURI !== "string") throw new TypeError("Expected `encodedURI` to be of type `string`, got `" + typeof encodedURI + "`");
    try {
        encodedURI = encodedURI.replace(/\+/g, " ");
        // Try the built in decoder first
        return decodeURIComponent(encodedURI);
    } catch (err) {
        // Fallback to a more advanced decoder
        return $3c63d5326ea31a64$var$customDecodeURIComponent(encodedURI);
    }
};

});

parcelRegister("710Zd", function(module, exports) {
"use strict";
module.exports = (string, separator)=>{
    if (!(typeof string === "string" && typeof separator === "string")) throw new TypeError("Expected the arguments to be of type `string`");
    if (separator === "") return [
        string
    ];
    const separatorIndex = string.indexOf(separator);
    if (separatorIndex === -1) return [
        string
    ];
    return [
        string.slice(0, separatorIndex),
        string.slice(separatorIndex + separator.length)
    ];
};

});

parcelRegister("cyVoW", function(module, exports) {
"use strict";
module.exports = function(obj, predicate) {
    var ret = {};
    var keys = Object.keys(obj);
    var isArr = Array.isArray(predicate);
    for(var i = 0; i < keys.length; i++){
        var key = keys[i];
        var val = obj[key];
        if (isArr ? predicate.indexOf(key) !== -1 : predicate(key, val, obj)) ret[key] = val;
    }
    return ret;
};

});




parcelRegister("hKBQC", function(module, exports) {

$parcel$export(module.exports, "selectHost", function () { return $cec41749d28db390$export$18c0b81944902eae; });

var $fyxFC = parcelRequire("fyxFC");
const $cec41749d28db390$var$PROD_HOST = "as.atlassian.com/api/v1";
const $cec41749d28db390$var$STARGATE_PROD_HOST = "api-private.atlassian.com/gasv3/api/v1";
const $cec41749d28db390$var$STAGING_HOST = "as.staging.atl-paas.net/api/v1";
const $cec41749d28db390$var$STARGATE_STAGING_HOST = "api-private.stg.atlassian.com/gasv3/api/v1";
const $cec41749d28db390$var$FEDRAMP_SANDBOX_HOST = "as.atlassian-fex.com/api/v1";
const $cec41749d28db390$var$FEDRAMP_STAGING_HOST = "as.staging.atl-paas-us-gov-mod.net/api/v1";
const $cec41749d28db390$var$FEDRAMP_PROD_HOST = "as.atlassian-us-gov-mod.com/api/v1";
const $cec41749d28db390$var$STARGATE_FEDRAMP_STAGING_HOST = "api.stg.atlassian-us-gov-mod.com/gasv3/api/v1";
const $cec41749d28db390$var$STARGATE_FEDRAMP_PROD_HOST = "api.atlassian-us-gov-mod.com/gasv3/api/v1";
const $cec41749d28db390$var$STARGATE_FEDRAMP_SANDBOX_HOST = "api-private.atlassian-fex.com/gasv3/api/v1";
const $cec41749d28db390$var$STARGATE_PROXY_PATH = "/gateway/api/gasv3/api/v1";
const $cec41749d28db390$var$handleFedRampStagingSandboxDirect = (envOverride)=>{
    if (envOverride && envOverride === (0, $fyxFC.envOverrides).FEDRAMP_MODERATE_SANDBOX) return $cec41749d28db390$var$FEDRAMP_SANDBOX_HOST;
    return $cec41749d28db390$var$FEDRAMP_STAGING_HOST;
};
const $cec41749d28db390$var$handleFedRampStagingSandboxStargate = (envOverride)=>{
    if (envOverride && envOverride === (0, $fyxFC.envOverrides).FEDRAMP_MODERATE_SANDBOX) return $cec41749d28db390$var$STARGATE_FEDRAMP_SANDBOX_HOST;
    return $cec41749d28db390$var$STARGATE_FEDRAMP_STAGING_HOST;
};
const $cec41749d28db390$var$handleFedRampModerate = ({ useStargate: useStargate, env: env, useLegacyUrl: useLegacyUrl, envOverride: envOverride })=>{
    if (env === (0, $fyxFC.envType).LOCAL || env === (0, $fyxFC.envType).DEV) throw Error("No LOCAL or DEV environments for FedRAMP.");
    if (env === (0, $fyxFC.envType).PROD && envOverride) throw Error("Cannot override to FedRAMP Sandbox for Prod.");
    if (!useStargate) return env === (0, $fyxFC.envType).PROD ? $cec41749d28db390$var$FEDRAMP_PROD_HOST : $cec41749d28db390$var$handleFedRampStagingSandboxDirect(envOverride);
    if (useLegacyUrl) return env === (0, $fyxFC.envType).PROD ? $cec41749d28db390$var$STARGATE_FEDRAMP_PROD_HOST : $cec41749d28db390$var$handleFedRampStagingSandboxStargate(envOverride);
    /**
   * Stargate proxy path now needs to be the default to work around browser restrictions with cookies.
   * For more details, see:
   *  - https://experimentation-platform.atlassian.net/browse/MHD-326, and
   *  - https://hello.atlassian.net/wiki/spaces/I/pages/1217206437/api-private+is+broken+is+your+product+impacted
   */ return window.location.host + $cec41749d28db390$var$STARGATE_PROXY_PATH;
};
const $cec41749d28db390$var$handleCommercial = ({ useStargate: useStargate, env: env, useLegacyUrl: useLegacyUrl })=>{
    if (!useStargate) return env === (0, $fyxFC.envType).PROD ? $cec41749d28db390$var$PROD_HOST : $cec41749d28db390$var$STAGING_HOST;
    if (useLegacyUrl) return env === (0, $fyxFC.envType).PROD ? $cec41749d28db390$var$STARGATE_PROD_HOST : $cec41749d28db390$var$STARGATE_STAGING_HOST;
    /**
   * Stargate proxy path now needs to be the default to work around browser restrictions with cookies.
   * For more details, see:
   *  - https://experimentation-platform.atlassian.net/browse/MHD-326, and
   *  - https://hello.atlassian.net/wiki/spaces/I/pages/1217206437/api-private+is+broken+is+your+product+impacted
   */ return window.location.host + $cec41749d28db390$var$STARGATE_PROXY_PATH;
};
function $cec41749d28db390$export$18c0b81944902eae({ useStargate: useStargate, env: env, useLegacyUrl: useLegacyUrl, perimeter: perimeter, envOverride: envOverride }) {
    if (perimeter === (0, $fyxFC.perimeterType).FEDRAMP_MODERATE) return $cec41749d28db390$var$handleFedRampModerate({
        useStargate: useStargate,
        env: env,
        useLegacyUrl: useLegacyUrl,
        envOverride: envOverride
    });
    return $cec41749d28db390$var$handleCommercial({
        useStargate: useStargate,
        env: env,
        useLegacyUrl: useLegacyUrl
    });
}

});

parcelRegister("b6g7e", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $814cc180045be993$export$2e2bcd8739ae039; });

var $gsv4E = parcelRequire("gsv4E");

var $7n5Kg = parcelRequire("7n5Kg");
const $814cc180045be993$var$SESSION_ID_STORAGE_KEY = "session.id";
const $814cc180045be993$var$SESSION_EXPIRY_STORAGE_KEY = "session.expiry";
const $814cc180045be993$var$ONLY_NUMBERS_REGEX = /^\d+$/;
const $814cc180045be993$export$285f6bddd927a06d = 1800000; // 30 minutes
const $814cc180045be993$export$a92e915d70316eb2 = 5000; // 5 seconds
const $814cc180045be993$export$de43760b2dc10c19 = 0.9; // 90% of expiry
const $814cc180045be993$export$5702a91a6f42969f = ()=>{};
class $814cc180045be993$export$2e2bcd8739ae039 {
    constructor(options = {}){
        (0, (/*@__PURE__*/$parcel$interopDefault($gsv4E)))(this, "_generateNewSessionId", ()=>{
            const newSessionId = Date.now().toString();
            this._safeLocalStorage.setItem($814cc180045be993$var$SESSION_ID_STORAGE_KEY, newSessionId);
            // COMMENTS-123 - When a new session starts, call the callback if it is given
            this._onNewSessionStarted && this._onNewSessionStarted();
            return newSessionId;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($gsv4E)))(this, "_updateSessionExpiry", ()=>{
            const expiry = Date.now() + this._sessionExpiryTime;
            this._safeLocalStorage.setItem($814cc180045be993$var$SESSION_EXPIRY_STORAGE_KEY, expiry.toString());
            return expiry;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($gsv4E)))(this, "_debouncedUpdateSessionExpiry", (currentExpiry)=>{
            const { _updateSessionExpiry: _updateSessionExpiry } = this;
            // If the current expiry is out of date by more than 10% of the expiry, update immediately
            if (currentExpiry < Date.now() + this._sessionExpiryDebounceThresholdPercentage * this._sessionExpiryTime) return _updateSessionExpiry();
            else {
                if (this._sessionExpiryDebounceTimer) clearTimeout(this._sessionExpiryDebounceTimer);
                // @ts-ignore Something wrong with our types... this is legit
                this._sessionExpiryDebounceTimer = setTimeout(()=>{
                    _updateSessionExpiry();
                }, this._sessionExpiryDebounce);
            }
        });
        this._sessionExpiryTime = options.sessionExpiryTime || $814cc180045be993$export$285f6bddd927a06d;
        this._sessionExpiryDebounce = options.sessionExpiryDebounce || $814cc180045be993$export$a92e915d70316eb2;
        this._sessionExpiryDebounceThresholdPercentage = options.sessionExpiryDebounceThresholdPercentage || $814cc180045be993$export$de43760b2dc10c19;
        this._onNewSessionStarted = options.onNewSessionStarted ? options.onNewSessionStarted : $814cc180045be993$export$5702a91a6f42969f;
        this._safeLocalStorage = new (0, $7n5Kg.default)();
    }
    getCurrentSessionId() {
        const sessionId = this._safeLocalStorage.getItem($814cc180045be993$var$SESSION_ID_STORAGE_KEY);
        const sessionExpiry = parseInt(this._safeLocalStorage.getItem($814cc180045be993$var$SESSION_EXPIRY_STORAGE_KEY) || "0", 10) || 0;
        this._debouncedUpdateSessionExpiry(sessionExpiry);
        if (!sessionId || sessionExpiry <= Date.now() || Number.isNaN(sessionExpiry)) return this._generateNewSessionId();
        // Old versions of sessionId were UUIDs which caused issues for Amplitude which only accepts
        // integers for this field. In these scenarios we want to regenerate the sessionId as an integer
        if (!$814cc180045be993$var$ONLY_NUMBERS_REGEX.test(sessionId)) return this._generateNewSessionId();
        return sessionId;
    }
}

});

parcelRegister("ebXXj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a55099bb10053536$export$2e2bcd8739ae039; });

var $eXtB3 = parcelRequire("eXtB3");

var $2HueP = parcelRequire("2HueP");
class $a55099bb10053536$export$2e2bcd8739ae039 extends (0, $2HueP.default) {
    constructor(options){
        let storageToUse;
        try {
            storageToUse = window.sessionStorage || (0, $eXtB3.default);
        } catch (err) {
            storageToUse = (0, $eXtB3.default);
        }
        super(storageToUse, options);
    }
}

});

parcelRegister("et4UB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a887958e6cd67500$export$2e2bcd8739ae039; });

var $gsv4E = parcelRequire("gsv4E");

var $dNSPy = parcelRequire("dNSPy");

var $ebXXj = parcelRequire("ebXXj");
const $a887958e6cd67500$var$STORAGE_KEY = "tab.id";
class $a887958e6cd67500$export$2e2bcd8739ae039 {
    constructor(){
        (0, (/*@__PURE__*/$parcel$interopDefault($gsv4E)))(this, "_generateNewTabId", ()=>{
            const newTabId = (0, (/*@__PURE__*/$parcel$interopDefault($dNSPy)))();
            this._safeSessionStorage.setItem($a887958e6cd67500$var$STORAGE_KEY, newTabId);
            return newTabId;
        });
        this._safeSessionStorage = new (0, $ebXXj.default)();
    }
    getCurrentTabId() {
        let tabId = this._safeSessionStorage.getItem($a887958e6cd67500$var$STORAGE_KEY);
        if (!tabId) tabId = this._generateNewTabId();
        return tabId;
    }
}

});

parcelRegister("64gRl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $46b031b6e98d9600$export$2e2bcd8739ae039; });

var $gsv4E = parcelRequire("gsv4E");

var $3N6J0 = parcelRequire("3N6J0");

var $dNSPy = parcelRequire("dNSPy");

var $fyxFC = parcelRequire("fyxFC");

var $gCau2 = parcelRequire("gCau2");

var $ebXXj = parcelRequire("ebXXj");

var $bk1z1 = parcelRequire("bk1z1");
function $46b031b6e98d9600$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $46b031b6e98d9600$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $46b031b6e98d9600$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($gsv4E)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $46b031b6e98d9600$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $46b031b6e98d9600$var$STORAGE_KEY = "taskSessions";
const $46b031b6e98d9600$var$INIT_KEY = "taskSessionsInit";
const $46b031b6e98d9600$var$AWC_PARAM_PREFIX = "awc.";
const $46b031b6e98d9600$var$TASK_SESSION_RELOAD_TIME = 3000;
class $46b031b6e98d9600$export$2e2bcd8739ae039 {
    constructor(){
        (0, (/*@__PURE__*/$parcel$interopDefault($gsv4E)))(this, "_taskSessionsNotRecentlyInitialised", (currentTimestamp)=>this._safeSessionStorage.getItem($46b031b6e98d9600$var$STORAGE_KEY) === null || this._safeSessionStorage.getItem($46b031b6e98d9600$var$INIT_KEY) === null || parseInt(this._safeSessionStorage.getItem($46b031b6e98d9600$var$INIT_KEY) || "0", 10) < currentTimestamp - $46b031b6e98d9600$var$TASK_SESSION_RELOAD_TIME);
        (0, (/*@__PURE__*/$parcel$interopDefault($gsv4E)))(this, "_removeTaskSessionPrefix", (_, taskSessionName)=>taskSessionName.split($46b031b6e98d9600$var$AWC_PARAM_PREFIX)[1]);
        (0, (/*@__PURE__*/$parcel$interopDefault($gsv4E)))(this, "_isTaskSessionQueryParam", (_, taskSessionName)=>taskSessionName.startsWith($46b031b6e98d9600$var$AWC_PARAM_PREFIX));
        (0, (/*@__PURE__*/$parcel$interopDefault($gsv4E)))(this, "getAllTaskSessions", ()=>{
            try {
                return JSON.parse(this._safeSessionStorage.getItem($46b031b6e98d9600$var$STORAGE_KEY) || "");
            } catch (e) {
                return {};
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($gsv4E)))(this, "_writeToSessionStorage", (taskSessions)=>{
            try {
                this._safeSessionStorage.setItem($46b031b6e98d9600$var$STORAGE_KEY, JSON.stringify(taskSessions));
            // eslint-disable-next-line no-empty
            } catch (e) {}
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($gsv4E)))(this, "_appendTaskSessions", (newTaskSessions)=>{
            const currentState = this.getAllTaskSessions();
            const newState = currentState === null ? newTaskSessions : Object.assign(currentState, newTaskSessions);
            this._writeToSessionStorage(newState);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($gsv4E)))(this, "_safelyRemoveKey", (currentState, taskSessionName)=>{
            if (currentState === null) return {};
            delete currentState[taskSessionName];
            return currentState;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($gsv4E)))(this, "createTaskSession", (taskSessionName)=>{
            const taskSessionId = (0, (/*@__PURE__*/$parcel$interopDefault($dNSPy)))();
            const newTaskSessions = {};
            newTaskSessions[taskSessionName] = taskSessionId;
            this._appendTaskSessions(newTaskSessions);
            return taskSessionId;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($gsv4E)))(this, "createTaskSessionWithProvidedId", (taskSessionName, taskSessionId)=>{
            if (typeof taskSessionId !== "string") throw new TypeError("invalid taskSessionId, must be string");
            const newTaskSessions = {};
            newTaskSessions[taskSessionName] = taskSessionId;
            this._appendTaskSessions(newTaskSessions);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($gsv4E)))(this, "completeTaskSession", (taskSessionName)=>{
            const currentState = this.getAllTaskSessions();
            const updatedState = this._safelyRemoveKey(currentState, taskSessionName);
            this._writeToSessionStorage(updatedState);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($gsv4E)))(this, "formatTaskSessionQueryString", ({ uri: uri, includedTaskSessions: includedTaskSessions })=>{
            const { url: url, query: query } = (0, $3N6J0.parseUrl)(uri);
            const currentState = this.getAllTaskSessions();
            // Use specified task sessions, otherwise all tasksessions excluding originTracing sessions
            const filteredTaskSessions = includedTaskSessions ? (0, $gCau2.pick)(currentState, includedTaskSessions) : (0, $gCau2.omit)(currentState, Object.values((0, $fyxFC.originTracingType)));
            if (Object.keys(filteredTaskSessions).length === 0) return uri;
            const queryWithTaskSessions = $46b031b6e98d9600$var$_objectSpread($46b031b6e98d9600$var$_objectSpread({}, (0, $gCau2.mapKeys)(filteredTaskSessions, (_, taskSessionName)=>$46b031b6e98d9600$var$AWC_PARAM_PREFIX + taskSessionName)), query);
            return `${url}?${(0, $3N6J0.stringify)(queryWithTaskSessions)}`;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($gsv4E)))(this, "stripQueryParameters", ()=>{
            const extractedTaskSessions = (0, $gCau2.mapKeys)((0, $bk1z1.default)(this._isTaskSessionQueryParam), this._removeTaskSessionPrefix);
            this._appendTaskSessions(extractedTaskSessions);
        });
        const _currentTimestamp = Date.now();
        this._safeSessionStorage = new (0, $ebXXj.default)();
        // Wrapping all sessionStorage calls in try catch to stop any error propogation, taskSessions should gracefully fail.
        try {
            if (this._taskSessionsNotRecentlyInitialised(_currentTimestamp)) {
                this._writeToSessionStorage({});
                this._safeSessionStorage.setItem($46b031b6e98d9600$var$INIT_KEY, _currentTimestamp.toString());
            }
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}

});

parcelRegister("4OGCN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $381ce54d4cfd1a0b$export$2e2bcd8739ae039; });

var $gsv4E = parcelRequire("gsv4E");

var $4nZ1y = parcelRequire("4nZ1y");

var $1lwuH = parcelRequire("1lwuH");
const $381ce54d4cfd1a0b$var$MAX_CACHE_SIZE = 100;
const $381ce54d4cfd1a0b$var$COOKIE_NAME = (0, $1lwuH.AllAnalyticsCookies).AWC_ANALYTICS_DEBUG.getKey();
const $381ce54d4cfd1a0b$var$DEBUG_TAG = "synthetic";
const $381ce54d4cfd1a0b$var$getDebugCookie = ()=>{
    try {
        return JSON.parse((0, (/*@__PURE__*/$parcel$interopDefault($4nZ1y))).get($381ce54d4cfd1a0b$var$COOKIE_NAME) || "false");
    } catch (error) {
        (0, (/*@__PURE__*/$parcel$interopDefault($4nZ1y))).remove($381ce54d4cfd1a0b$var$COOKIE_NAME);
    }
    return false;
};
class $381ce54d4cfd1a0b$var$TestingCache {
    constructor(){
        (0, (/*@__PURE__*/$parcel$interopDefault($gsv4E)))(this, "_bind", ()=>{
            if (typeof window === "undefined" || window.testAnalytics) return;
            window.testAnalytics = {
                eventCache: [],
                events: ()=>window.testAnalytics.eventCache,
                clear: ()=>{
                    window.testAnalytics.eventCache = [];
                    try {
                        localStorage.removeItem("awc.ui.viewed.last.sent");
                        localStorage.removeItem("awc-staging.ui.viewed.last.sent");
                        localStorage.removeItem("awc-dev.ui.viewed.last.sent");
                        localStorage.removeItem("awc-local.ui.viewed.last.sent");
                    } catch (_error) {
                    // Ignore errors from localStorage.
                    }
                }
            };
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($gsv4E)))(this, "_cache", (event)=>{
            if (typeof window === "undefined") return;
            if (window.testAnalytics.eventCache.length >= $381ce54d4cfd1a0b$var$MAX_CACHE_SIZE) window.testAnalytics.eventCache = window.testAnalytics.eventCache.slice(1, window.testAnalytics.eventCache.length);
            window.testAnalytics.eventCache.push(event);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($gsv4E)))(this, "_shouldCacheEvent", ()=>this._isDebugCookieEnabled);
        (0, (/*@__PURE__*/$parcel$interopDefault($gsv4E)))(this, "saveEvent", (event)=>{
            if (event && this._shouldCacheEvent()) {
                if (!window.testAnalytics) this._bind();
                if (event.tags instanceof Array) event.tags.push($381ce54d4cfd1a0b$var$DEBUG_TAG);
                else event.tags = [
                    $381ce54d4cfd1a0b$var$DEBUG_TAG
                ];
                this._cache(event);
            }
        });
        this._isDebugCookieEnabled = $381ce54d4cfd1a0b$var$getDebugCookie();
        if (this._isDebugCookieEnabled) this._bind();
    }
}
var $381ce54d4cfd1a0b$export$2e2bcd8739ae039 = $381ce54d4cfd1a0b$var$TestingCache;

});

parcelRegister("gOtSJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c3d87ec63c2ab3ac$export$2e2bcd8739ae039; });

var $krh40 = parcelRequire("krh40");

var $gsv4E = parcelRequire("gsv4E");

var $fyxFC = parcelRequire("fyxFC");

var $7n5Kg = parcelRequire("7n5Kg");
const $c3d87ec63c2ab3ac$var$_excluded = [
    "embeddedProduct"
];
function $c3d87ec63c2ab3ac$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $c3d87ec63c2ab3ac$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $c3d87ec63c2ab3ac$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($gsv4E)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $c3d87ec63c2ab3ac$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $c3d87ec63c2ab3ac$var$DEFAULT_DELAY = 2000; // 2 seconds
const $c3d87ec63c2ab3ac$var$DEFAULT_THROTTLE = 3600000; // 1 hour
const $c3d87ec63c2ab3ac$var$DEFAULT_STORAGE_KEY = "ui.viewed.last.sent";
class $c3d87ec63c2ab3ac$export$2e2bcd8739ae039 {
    constructor(productInfo, getContext, onEvent, settings = {}){
        (0, (/*@__PURE__*/$parcel$interopDefault($gsv4E)))(this, "start", ()=>{
            this._startInterval();
            this._bindEventListeners();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($gsv4E)))(this, "stop", ()=>{
            this._stopInterval();
            this._unbindEventListeners();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($gsv4E)))(this, "resetTimers", ()=>{
            if (this._intervalId) {
                this.stop();
                this.start();
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($gsv4E)))(this, "_bindEventListeners", ()=>{
            if (typeof window !== "undefined") {
                window.addEventListener("focus", this._focusListener);
                window.addEventListener("blur", this._blurListener);
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($gsv4E)))(this, "_unbindEventListeners", ()=>{
            if (typeof window !== "undefined") {
                window.removeEventListener("focus", this._focusListener);
                window.removeEventListener("blur", this._blurListener);
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($gsv4E)))(this, "_startInterval", ()=>{
            clearInterval(this._intervalId);
            this._intervalId = setInterval(this._handleInterval, this._delay);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($gsv4E)))(this, "_stopInterval", ()=>{
            if (this._intervalId) {
                clearInterval(this._intervalId);
                this._intervalId = null;
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($gsv4E)))(this, "_getProductKey", (product, subproduct)=>{
            let productKey = product;
            if (subproduct) productKey += `-${subproduct}`;
            return productKey;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($gsv4E)))(this, "_getLastSentTimestamp", (productKey, tenantId, userId)=>{
            const json = this._parseLocalStorageData() || {};
            const u = json[userId] || {};
            const t = u[tenantId] || {};
            const p = t[productKey] || null;
            return p;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($gsv4E)))(this, "_parseLocalStorageData", ()=>{
            const data = this._safeLocalStorage.getItem(this._storageKey);
            try {
                return JSON.parse(data || "");
            } catch (error) {
                this._safeLocalStorage.removeItem(this._storageKey);
                return null;
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($gsv4E)))(this, "_setLastSentTimestamp", (productKey, tenantId, userId)=>{
            const json = this._parseLocalStorageData() || {};
            const u = json[userId] || {};
            const t = u[tenantId] || {};
            t[productKey] = Date.now();
            u[tenantId] = t;
            json[userId] = u;
            this._safeLocalStorage.setItem(this._storageKey, JSON.stringify(json));
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($gsv4E)))(this, "_shouldSendEvent", (productKey, tenantIdType, tenantId, userId)=>{
            if (!document.hasFocus()) return false;
            if (tenantIdType !== (0, $fyxFC.tenantType).NONE && !tenantId || !userId) return false;
            const sinceLastSent = Date.now() - this._getLastSentTimestamp(productKey, tenantId, userId);
            return sinceLastSent > this._throttle;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($gsv4E)))(this, "_handleInterval", ()=>{
            const _this$_getContext = this._getContext(), { embeddedProduct: embeddedProduct } = _this$_getContext, context = (0, (/*@__PURE__*/$parcel$interopDefault($krh40)))(_this$_getContext, $c3d87ec63c2ab3ac$var$_excluded);
            this._sendEvent(this._product, context);
            if (embeddedProduct) this._sendEvent(embeddedProduct, context, true);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($gsv4E)))(this, "_sendEvent", (product, context, isEmbeddedProduct = false)=>{
            const { subproduct: subproduct, tenantIdType: tenantIdType, tenantId: tenantId, userId: userId, lastScreenEvent: lastScreenEvent, attributes: attributes } = context;
            const productKey = this._getProductKey(product, subproduct);
            if (this._shouldSendEvent(productKey, tenantIdType, tenantId, userId)) {
                this._setLastSentTimestamp(productKey, tenantId, userId);
                const event = this._createEvent(product, subproduct, isEmbeddedProduct, lastScreenEvent, attributes);
                this._onEvent(event);
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($gsv4E)))(this, "_createEvent", (product, subproduct, isEmbeddedProduct, lastScreenEvent, extraAttributes)=>{
            const event = {
                product: product,
                source: "ui",
                action: "viewed",
                actionSubject: "ui",
                attributes: extraAttributes
            };
            if (isEmbeddedProduct) {
                // Clear the subproduct and version as they don't relate to the embedded product
                event.subproduct = null;
                event.version = null;
                event.attributes = $c3d87ec63c2ab3ac$var$_objectSpread($c3d87ec63c2ab3ac$var$_objectSpread({}, event.attributes), {}, {
                    embeddedInEnv: this._productInfo.env,
                    embeddedInProduct: this._productInfo.product,
                    embeddedInSubproduct: subproduct,
                    embeddedInVersion: this._productInfo.version,
                    embeddedInOrigin: this._productInfo.origin,
                    embeddedInPlatform: this._productInfo.platform
                });
            }
            if (lastScreenEvent) event.attributes = $c3d87ec63c2ab3ac$var$_objectSpread($c3d87ec63c2ab3ac$var$_objectSpread({}, event.attributes), {}, {
                lastScreenEvent: {
                    name: lastScreenEvent.name,
                    attributes: lastScreenEvent.attributes
                }
            });
            return event;
        });
        if (!productInfo) throw new Error("Missing productInfo");
        if (!productInfo.product) throw new Error("Missing productInfo.product");
        if (!getContext) throw new Error("Missing getContext callback");
        if (typeof getContext !== "function") throw new Error("Invalid getContext, must be function");
        if (!onEvent) throw new Error("Missing onEvent callback");
        if (typeof onEvent !== "function") throw new Error("Invalid onEvent, must be function");
        this._productInfo = productInfo;
        this._product = productInfo.product;
        this._getContext = getContext;
        this._onEvent = onEvent;
        this._delay = settings.delay || $c3d87ec63c2ab3ac$var$DEFAULT_DELAY;
        this._throttle = settings.throttle || $c3d87ec63c2ab3ac$var$DEFAULT_THROTTLE;
        this._storageKey = settings.storageKey || $c3d87ec63c2ab3ac$var$DEFAULT_STORAGE_KEY;
        this._safeLocalStorage = new (0, $7n5Kg.default)({
            envPrefix: this._productInfo.env
        });
        this._focusListener = ()=>{
            this._startInterval();
        };
        this._blurListener = ()=>{
            this._stopInterval();
        };
    }
}

});

parcelRegister("96itE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6a0301c447069bf8$export$2e2bcd8739ae039; });
function $6a0301c447069bf8$export$2e2bcd8739ae039(callback, event) {
    if (!callback || typeof callback !== "function") return null;
    return ()=>{
        callback(event);
    };
}

});

parcelRegister("9v6BW", function(module, exports) {

$parcel$export(module.exports, "XIDPromise", function () { return $6eac231cfdfecc71$export$fbe53bbbe682bcdd; });

var $bH5dx = parcelRequire("bH5dx");
const $6eac231cfdfecc71$export$fbe53bbbe682bcdd = (xidConsent, xidPromiseFn)=>{
    if (xidConsent && xidPromiseFn && typeof xidPromiseFn === "function") {
        const timeoutPromise = ()=>{
            return new Promise((resolve)=>{
                setTimeout(()=>resolve(()=>(0, $bH5dx.createTimeoutXid)()), (0, $bH5dx.XID_TIMEOUT));
            });
        };
        const xidPromise = ()=>{
            return xidPromiseFn().catch(()=>()=>(0, $bH5dx.createUnknownXid)());
        };
        return Promise.race([
            xidPromise(),
            timeoutPromise()
        ]);
    }
    return undefined;
};

});
parcelRegister("bH5dx", function(module, exports) {

$parcel$export(module.exports, "XID_TIMEOUT", function () { return $8837c1e7250e4958$export$545bcbd53afabfa3; });
$parcel$export(module.exports, "createTimeoutXid", function () { return $8837c1e7250e4958$export$af4087e36d63846; });
$parcel$export(module.exports, "createUnknownXid", function () { return $8837c1e7250e4958$export$fa341d0c750d705b; });

var $blrc1 = parcelRequire("blrc1");
const $8837c1e7250e4958$export$545bcbd53afabfa3 = 5000;
const $8837c1e7250e4958$export$af4087e36d63846 = ()=>[
        {
            type: (0, $blrc1.XIDItemType).XC,
            state: "TIMEOUT"
        },
        {
            type: (0, $blrc1.XIDItemType).UID,
            state: "TIMEOUT"
        }
    ];
const $8837c1e7250e4958$export$fa341d0c750d705b = ()=>[
        {
            type: (0, $blrc1.XIDItemType).XC,
            state: "UNKNOWN"
        },
        {
            type: (0, $blrc1.XIDItemType).UID,
            state: "UNKNOWN"
        }
    ];

});
parcelRegister("blrc1", function(module, exports) {

$parcel$export(module.exports, "XIDItemType", function () { return $8426bfce5657a57a$export$92ca0438bcb0d396; });
let $8426bfce5657a57a$export$92ca0438bcb0d396 = /*#__PURE__*/ function(XIDItemType) {
    XIDItemType["XC"] = "xc";
    XIDItemType["UID"] = "uid";
    return XIDItemType;
}({});
let $8426bfce5657a57a$export$c9079017d1f5aab9 = /*#__PURE__*/ function(XIDState) {
    XIDState["NEW"] = "NEW";
    XIDState["CHANGED"] = "CHANGED";
    XIDState["EXISTING"] = "EXISTING";
    XIDState["TIMEOUT"] = "TIMEOUT";
    XIDState["ERROR"] = "ERROR";
    XIDState["UNAVAILABLE"] = "UNAVAILABLE";
    XIDState["MALFORMED"] = "MALFORMED";
    XIDState["UNKNOWN"] = "UNKNOWN";
    return XIDState;
}({});

});




parcelRegister("jLJT8", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_PRODUCT_NAME", function () { return $f06c599cd0d375d5$export$5dafcf018ef7e466; });
$parcel$export(module.exports, "DEFAULT_SUB_PRODUCT_NAME", function () { return $f06c599cd0d375d5$export$8d51d42d281f66d0; });
$parcel$export(module.exports, "getAnalyticsClient", function () { return $f06c599cd0d375d5$export$fde53e78fd93a54d; });

var $fyxFC = parcelRequire("fyxFC");
var $1QfrT = parcelRequire("1QfrT");

var $gm7kP = parcelRequire("gm7kP");

var $1Bj4T = parcelRequire("1Bj4T");

var $djcZD = parcelRequire("djcZD");

var $b1ORY = parcelRequire("b1ORY");

var $382Ai = parcelRequire("382Ai");

var $77YRX = parcelRequire("77YRX");
function $f06c599cd0d375d5$var$getServerName() {
    return window.location.hostname;
}
const { LOCAL: $f06c599cd0d375d5$var$LOCAL, DEV: $f06c599cd0d375d5$var$DEV, STAGING: $f06c599cd0d375d5$var$STAGING, PROD: $f06c599cd0d375d5$var$PROD } = (0, $fyxFC.envType);
const $f06c599cd0d375d5$var$ENV_MAP = {
    local: $f06c599cd0d375d5$var$LOCAL,
    test: $f06c599cd0d375d5$var$LOCAL,
    ddev: $f06c599cd0d375d5$var$DEV,
    fedex: $f06c599cd0d375d5$var$STAGING,
    stg: $f06c599cd0d375d5$var$STAGING,
    "stg-fedm": $f06c599cd0d375d5$var$STAGING,
    prod: $f06c599cd0d375d5$var$PROD,
    "prod-fedm": $f06c599cd0d375d5$var$PROD
};
const $f06c599cd0d375d5$var$analyticsConfig = (0, $1Bj4T.getConfig)().analytics;
const $f06c599cd0d375d5$export$5dafcf018ef7e466 = "identity";
const $f06c599cd0d375d5$export$8d51d42d281f66d0 = "manageProfile";
class $f06c599cd0d375d5$var$AnalyticsClient {
    constructor(store, options = {}){
        this.startApdexEvent = (apdexEvent)=>{
            this.analyticsWebClient.startApdexEvent(apdexEvent);
        };
        this.stopApdexEvent = (apdexEvent)=>{
            let taskType;
            if (this.isInitallLoad) {
                // TODO: setting taskType in here is not required since if type
                // is not defined, it should default to INITIAL_LOAD.
                // But a bug in the api of the analytics client prevents us
                // from passing empty values for type
                // TODO: remove type from apdexStopEventType
                taskType = (0, $fyxFC.apdexType).INITIAL_LOAD;
                this.isInitallLoad = false;
            } else taskType = (0, $fyxFC.apdexType).TRANSITION;
            try {
                this.analyticsWebClient.stopApdexEvent({
                    ...apdexEvent,
                    type: taskType
                });
            } catch (e) {
                // TODO as part of PTC-1283 - devise correct way to handle errors here
                // tslint:disable-next-line no-console
                console.warn(apdexEvent, e);
            }
        };
        this.accountIdPromise = (0, $gm7kP.whenDefined)(store, "user.data.accountId", {
            acceptNull: false,
            timeout: options.accountIdWaitTimeout
        });
        this.state = {
            analyticsscheme: $f06c599cd0d375d5$var$analyticsConfig.scheme,
            analyticsserver: $f06c599cd0d375d5$var$analyticsConfig.server,
            server: $f06c599cd0d375d5$var$getServerName(),
            product: $f06c599cd0d375d5$export$5dafcf018ef7e466,
            isReadyToSend: false,
            pendingEventsQueue: [],
            storage_key: "manage.profile.analytics",
            ...options
        };
        // New GAS pipeline client. Follow this docs https://bitbucket.org/atlassian/analytics-web-client/src/master/ for more detail
        this.analyticsWebClient = new (0, $1QfrT.default)({
            env: $f06c599cd0d375d5$var$ENV_MAP[(0, $djcZD.getEnv)()],
            product: $f06c599cd0d375d5$export$5dafcf018ef7e466,
            subproduct: $f06c599cd0d375d5$export$8d51d42d281f66d0
        });
        this.analyticsWebClient.setTenantInfo((0, $fyxFC.tenantType).NONE, undefined);
        // sending apdex events needs to know whether this is the initial load of the app or a transition.
        // Following variable helps us identify that.
        this.isInitallLoad = true;
    }
    getAnalyticsWebClient() {
        return this.analyticsWebClient;
    }
    sendTrackEvent(eventData) {
        this.analyticsWebClient.sendTrackEvent(eventData);
    }
    /**
   * Checks whether the library has been initialized and decides whether the event should be sent or cached
   * @param {*} eventType Values could be 'track', 'screen', 'operation, 'ui'
   * @param {*} eventData Data of the event
   * @param {Function} cb Callback is called when the event is sent successfully.
   */ canEventBeSent(eventType, eventData, cb) {
        if (this.state.isReadyToSend) return true;
        // add to `pendingEventsQueue` in order to send the event later
        this.state.pendingEventsQueue.push({
            eventType: eventType,
            eventData: eventData,
            // `eventCallback` is called when `pendingEventsQueue` is processed and eventData is sent
            eventCallback: cb
        });
        return false;
    }
    pushTrackEvent(eventData, cb) {
        if (this.canEventBeSent("track", eventData, cb)) {
            const event = this.buildEventPayload(eventData);
            this.analyticsWebClient.sendTrackEvent(event, cb);
        }
    }
    pushUIEvent(eventData, cb) {
        if (this.canEventBeSent("ui", eventData, cb)) {
            const event = this.buildEventPayload(eventData);
            this.analyticsWebClient.sendUIEvent(event, cb);
        }
    }
    pushOperationalEvent(eventData, cb) {
        if (this.canEventBeSent("operation", eventData, cb)) {
            const event = this.buildEventPayload(eventData);
            this.analyticsWebClient.sendOperationalEvent(event, cb);
        }
    }
    pushScreenEvent(eventData, cb) {
        const additionalAttributes = (0, $b1ORY.default).get();
        (0, $b1ORY.default).markUsed();
        if (eventData && additionalAttributes) eventData = {
            ...eventData,
            attributes: {
                ...additionalAttributes,
                ...eventData.attributes
            }
        };
        try {
            const pageMetric = (0, $382Ai.getPageLoadMetric)(eventData.name);
            if (pageMetric.getData().state !== "finished") pageMetric.stop();
        } catch (error) {
            (0, $77YRX.logException)(error, "browser metrics error");
        }
        if (this.canEventBeSent("screen", eventData, cb)) this.analyticsWebClient.sendScreenEvent(eventData, cb);
    }
    buildEventPayload(eventData) {
        return {
            containerType: null,
            containerId: null,
            objectType: null,
            objectId: null,
            source: null,
            actionSubject: null,
            action: null,
            actionSubjectId: null,
            attributes: null,
            tags: [],
            ...eventData
        };
    }
    /**
   *  Start up E-MAU events in the new analytics pipeline (GAS v3)
   *  See: https://extranet.atlassian.com/display/BPO/DACI%3A+E-MAU+Definition
   */ async startUIViewedEvent() {
        const accountId = await this.accountIdPromise;
        if (accountId) this.analyticsWebClient.setUserInfo((0, $fyxFC.userType).ATLASSIAN_ACCOUNT, accountId);
        this.analyticsWebClient.startUIViewedEvent();
        this.state.isReadyToSend = true;
        this.flushPendingEventsQueue();
    }
    /**
   * Flush all the pending events in the queue
   */ flushPendingEventsQueue() {
        this.state.pendingEventsQueue.forEach((element)=>{
            const { eventType: eventType, eventData: eventData, eventCallback: eventCallback } = element;
            switch(eventType){
                case "track":
                    this.pushTrackEvent(eventData, eventCallback);
                    break;
                case "ui":
                    this.pushUIEvent(eventData, eventCallback);
                    break;
                case "screen":
                    this.pushScreenEvent(eventData, eventCallback);
                    break;
                case "operation":
                    this.pushOperationalEvent(eventData, eventCallback);
                    break;
                default:
                    // tslint:disable-next-line no-console
                    console.error("Invalide Event :", element);
                    break;
            }
        });
    }
}
var $f06c599cd0d375d5$export$2e2bcd8739ae039 = $f06c599cd0d375d5$var$AnalyticsClient;
/**
 * In order for the app to have few stared usages of the same analytics client instances we'll preserve them in a local const
 */ let $f06c599cd0d375d5$var$preservedAnalyticsClients;
const $f06c599cd0d375d5$export$fde53e78fd93a54d = (store)=>{
    if (!$f06c599cd0d375d5$var$preservedAnalyticsClients || !store) $f06c599cd0d375d5$var$preservedAnalyticsClients = new $f06c599cd0d375d5$var$AnalyticsClient(store);
    return $f06c599cd0d375d5$var$preservedAnalyticsClients;
};

});
parcelRegister("gm7kP", function(module, exports) {

$parcel$export(module.exports, "whenDefined", function () { return $9f1a223c8c9dbaa4$export$785f9b878ae51e44; });

var $iXVrI = parcelRequire("iXVrI");
function $9f1a223c8c9dbaa4$var$getValue(store, objectPath) {
    const state = store.getState();
    return (0, (/*@__PURE__*/$parcel$interopDefault($iXVrI)))(state, objectPath);
}
function $9f1a223c8c9dbaa4$var$validValue(value, options) {
    const { acceptNull: acceptNull } = options;
    if (acceptNull) return value !== undefined;
    return value !== undefined && value !== null;
}
function $9f1a223c8c9dbaa4$export$785f9b878ae51e44(store, objectPath, { timeout: timeout = 10000, acceptNull: acceptNull = true } = {}) {
    let value = $9f1a223c8c9dbaa4$var$getValue(store, objectPath);
    if ($9f1a223c8c9dbaa4$var$validValue(value, {
        acceptNull: acceptNull
    })) return Promise.resolve(value);
    return new Promise((resolve, reject)=>{
        const unsubscribe = store.subscribe(()=>{
            value = $9f1a223c8c9dbaa4$var$getValue(store, objectPath);
            if ($9f1a223c8c9dbaa4$var$validValue(value, {
                acceptNull: acceptNull
            })) {
                unsubscribe();
                resolve(value);
            }
        });
        setTimeout(()=>{
            unsubscribe();
            reject(`Subscribe timeout reached for "${objectPath}".`);
        }, timeout);
    });
}

});
parcelRegister("iXVrI", function(module, exports) {

var $fPZ2B = parcelRequire("fPZ2B");
/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */ function $dcea4c437e577e23$var$get(object, path, defaultValue) {
    var result = object == null ? undefined : $fPZ2B(object, path);
    return result === undefined ? defaultValue : result;
}
module.exports = $dcea4c437e577e23$var$get;

});
parcelRegister("fPZ2B", function(module, exports) {

var $caOxv = parcelRequire("caOxv");

var $5dj07 = parcelRequire("5dj07");
/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */ function $b87af7e26a69bff8$var$baseGet(object, path) {
    path = $caOxv(path, object);
    var index = 0, length = path.length;
    while(object != null && index < length)object = object[$5dj07(path[index++])];
    return index && index == length ? object : undefined;
}
module.exports = $b87af7e26a69bff8$var$baseGet;

});
parcelRegister("caOxv", function(module, exports) {

var $jyoU0 = parcelRequire("jyoU0");

var $fBvk3 = parcelRequire("fBvk3");

var $72P8d = parcelRequire("72P8d");

var $feskK = parcelRequire("feskK");
/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */ function $8dcd9f42055b7b18$var$castPath(value, object) {
    if ($jyoU0(value)) return value;
    return $fBvk3(value, object) ? [
        value
    ] : $72P8d($feskK(value));
}
module.exports = $8dcd9f42055b7b18$var$castPath;

});
parcelRegister("jyoU0", function(module, exports) {
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var $e3c48262ce256792$var$isArray = Array.isArray;
module.exports = $e3c48262ce256792$var$isArray;

});

parcelRegister("fBvk3", function(module, exports) {

var $jyoU0 = parcelRequire("jyoU0");

var $aKvy8 = parcelRequire("aKvy8");
/** Used to match property names within property paths. */ var $b5c29bb7c31092ae$var$reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, $b5c29bb7c31092ae$var$reIsPlainProp = /^\w*$/;
/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */ function $b5c29bb7c31092ae$var$isKey(value, object) {
    if ($jyoU0(value)) return false;
    var type = typeof value;
    if (type == "number" || type == "symbol" || type == "boolean" || value == null || $aKvy8(value)) return true;
    return $b5c29bb7c31092ae$var$reIsPlainProp.test(value) || !$b5c29bb7c31092ae$var$reIsDeepProp.test(value) || object != null && value in Object(object);
}
module.exports = $b5c29bb7c31092ae$var$isKey;

});
parcelRegister("aKvy8", function(module, exports) {

var $lIXED = parcelRequire("lIXED");

var $bROf4 = parcelRequire("bROf4");
/** `Object#toString` result references. */ var $7d36ac5967c25e82$var$symbolTag = "[object Symbol]";
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $7d36ac5967c25e82$var$isSymbol(value) {
    return typeof value == "symbol" || $bROf4(value) && $lIXED(value) == $7d36ac5967c25e82$var$symbolTag;
}
module.exports = $7d36ac5967c25e82$var$isSymbol;

});
parcelRegister("lIXED", function(module, exports) {

var $8J6hk = parcelRequire("8J6hk");

var $a2Qhl = parcelRequire("a2Qhl");

var $hHnBF = parcelRequire("hHnBF");
/** `Object#toString` result references. */ var $fd0bfb2dc0be8e30$var$nullTag = "[object Null]", $fd0bfb2dc0be8e30$var$undefinedTag = "[object Undefined]";
/** Built-in value references. */ var $fd0bfb2dc0be8e30$var$symToStringTag = $8J6hk ? $8J6hk.toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $fd0bfb2dc0be8e30$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $fd0bfb2dc0be8e30$var$undefinedTag : $fd0bfb2dc0be8e30$var$nullTag;
    return $fd0bfb2dc0be8e30$var$symToStringTag && $fd0bfb2dc0be8e30$var$symToStringTag in Object(value) ? $a2Qhl(value) : $hHnBF(value);
}
module.exports = $fd0bfb2dc0be8e30$var$baseGetTag;

});
parcelRegister("8J6hk", function(module, exports) {

var $dLxmN = parcelRequire("dLxmN");
/** Built-in value references. */ var $65a765797021ba44$var$Symbol = $dLxmN.Symbol;
module.exports = $65a765797021ba44$var$Symbol;

});
parcelRegister("dLxmN", function(module, exports) {

var $kGCkG = parcelRequire("kGCkG");
/** Detect free variable `self`. */ var $a0598c0fa680d829$var$freeSelf = typeof self == "object" && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $a0598c0fa680d829$var$root = $kGCkG || $a0598c0fa680d829$var$freeSelf || Function("return this")();
module.exports = $a0598c0fa680d829$var$root;

});
parcelRegister("kGCkG", function(module, exports) {
/** Detect free variable `global` from Node.js. */ var $f0f576f76ba17da1$var$freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
module.exports = $f0f576f76ba17da1$var$freeGlobal;

});



parcelRegister("a2Qhl", function(module, exports) {

var $8J6hk = parcelRequire("8J6hk");
/** Used for built-in method references. */ var $7502a4c705135b9b$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $7502a4c705135b9b$var$hasOwnProperty = $7502a4c705135b9b$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $7502a4c705135b9b$var$nativeObjectToString = $7502a4c705135b9b$var$objectProto.toString;
/** Built-in value references. */ var $7502a4c705135b9b$var$symToStringTag = $8J6hk ? $8J6hk.toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $7502a4c705135b9b$var$getRawTag(value) {
    var isOwn = $7502a4c705135b9b$var$hasOwnProperty.call(value, $7502a4c705135b9b$var$symToStringTag), tag = value[$7502a4c705135b9b$var$symToStringTag];
    try {
        value[$7502a4c705135b9b$var$symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $7502a4c705135b9b$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$7502a4c705135b9b$var$symToStringTag] = tag;
        else delete value[$7502a4c705135b9b$var$symToStringTag];
    }
    return result;
}
module.exports = $7502a4c705135b9b$var$getRawTag;

});

parcelRegister("hHnBF", function(module, exports) {
/** Used for built-in method references. */ var $ce28c39b266aceb9$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $ce28c39b266aceb9$var$nativeObjectToString = $ce28c39b266aceb9$var$objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $ce28c39b266aceb9$var$objectToString(value) {
    return $ce28c39b266aceb9$var$nativeObjectToString.call(value);
}
module.exports = $ce28c39b266aceb9$var$objectToString;

});


parcelRegister("bROf4", function(module, exports) {
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $8a3b9dffa04d725f$var$isObjectLike(value) {
    return value != null && typeof value == "object";
}
module.exports = $8a3b9dffa04d725f$var$isObjectLike;

});



parcelRegister("72P8d", function(module, exports) {

var $3pPXU = parcelRequire("3pPXU");
/** Used to match property names within property paths. */ var $521061f8f60afe74$var$rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
/** Used to match backslashes in property paths. */ var $521061f8f60afe74$var$reEscapeChar = /\\(\\)?/g;
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var $521061f8f60afe74$var$stringToPath = $3pPXU(function(string) {
    var result = [];
    if (string.charCodeAt(0) === 46 /* . */ ) result.push("");
    string.replace($521061f8f60afe74$var$rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace($521061f8f60afe74$var$reEscapeChar, "$1") : number || match);
    });
    return result;
});
module.exports = $521061f8f60afe74$var$stringToPath;

});
parcelRegister("3pPXU", function(module, exports) {

var $k389X = parcelRequire("k389X");
/** Used as the maximum memoize cache size. */ var $27cc041e0b69f57e$var$MAX_MEMOIZE_SIZE = 500;
/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */ function $27cc041e0b69f57e$var$memoizeCapped(func) {
    var result = $k389X(func, function(key) {
        if (cache.size === $27cc041e0b69f57e$var$MAX_MEMOIZE_SIZE) cache.clear();
        return key;
    });
    var cache = result.cache;
    return result;
}
module.exports = $27cc041e0b69f57e$var$memoizeCapped;

});
parcelRegister("k389X", function(module, exports) {

var $ejB1j = parcelRequire("ejB1j");
/** Error message constants. */ var $e98a6aca6e71c501$var$FUNC_ERROR_TEXT = "Expected a function";
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */ function $e98a6aca6e71c501$var$memoize(func, resolver) {
    if (typeof func != "function" || resolver != null && typeof resolver != "function") throw new TypeError($e98a6aca6e71c501$var$FUNC_ERROR_TEXT);
    var memoized = function() {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key)) return cache.get(key);
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
    };
    memoized.cache = new ($e98a6aca6e71c501$var$memoize.Cache || $ejB1j);
    return memoized;
}
// Expose `MapCache`.
$e98a6aca6e71c501$var$memoize.Cache = $ejB1j;
module.exports = $e98a6aca6e71c501$var$memoize;

});
parcelRegister("ejB1j", function(module, exports) {

var $d3Lt2 = parcelRequire("d3Lt2");

var $4zws2 = parcelRequire("4zws2");

var $igEfU = parcelRequire("igEfU");

var $ituXc = parcelRequire("ituXc");

var $avlK8 = parcelRequire("avlK8");
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $a6bf8e725c65077a$var$MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `MapCache`.
$a6bf8e725c65077a$var$MapCache.prototype.clear = $d3Lt2;
$a6bf8e725c65077a$var$MapCache.prototype["delete"] = $4zws2;
$a6bf8e725c65077a$var$MapCache.prototype.get = $igEfU;
$a6bf8e725c65077a$var$MapCache.prototype.has = $ituXc;
$a6bf8e725c65077a$var$MapCache.prototype.set = $avlK8;
module.exports = $a6bf8e725c65077a$var$MapCache;

});
parcelRegister("d3Lt2", function(module, exports) {

var $hDZL4 = parcelRequire("hDZL4");

var $bE9pp = parcelRequire("bE9pp");

var $a1lZD = parcelRequire("a1lZD");
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function $982060396020ee3e$var$mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        "hash": new $hDZL4,
        "map": new ($a1lZD || $bE9pp),
        "string": new $hDZL4
    };
}
module.exports = $982060396020ee3e$var$mapCacheClear;

});
parcelRegister("hDZL4", function(module, exports) {

var $hbrRh = parcelRequire("hbrRh");

var $fMUWH = parcelRequire("fMUWH");

var $4VljD = parcelRequire("4VljD");

var $934WI = parcelRequire("934WI");

var $lav2R = parcelRequire("lav2R");
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $cd85fc0f8ded59e4$var$Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `Hash`.
$cd85fc0f8ded59e4$var$Hash.prototype.clear = $hbrRh;
$cd85fc0f8ded59e4$var$Hash.prototype["delete"] = $fMUWH;
$cd85fc0f8ded59e4$var$Hash.prototype.get = $4VljD;
$cd85fc0f8ded59e4$var$Hash.prototype.has = $934WI;
$cd85fc0f8ded59e4$var$Hash.prototype.set = $lav2R;
module.exports = $cd85fc0f8ded59e4$var$Hash;

});
parcelRegister("hbrRh", function(module, exports) {

var $iRGuQ = parcelRequire("iRGuQ");
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function $c82912d2db7d41ed$var$hashClear() {
    this.__data__ = $iRGuQ ? $iRGuQ(null) : {};
    this.size = 0;
}
module.exports = $c82912d2db7d41ed$var$hashClear;

});
parcelRegister("iRGuQ", function(module, exports) {

var $5jezD = parcelRequire("5jezD");
/* Built-in method references that are verified to be native. */ var $dbbe242311d0f8a5$var$nativeCreate = $5jezD(Object, "create");
module.exports = $dbbe242311d0f8a5$var$nativeCreate;

});
parcelRegister("5jezD", function(module, exports) {

var $7Qkwj = parcelRequire("7Qkwj");

var $8Zd1y = parcelRequire("8Zd1y");
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function $3dda0825ab22b646$var$getNative(object, key) {
    var value = $8Zd1y(object, key);
    return $7Qkwj(value) ? value : undefined;
}
module.exports = $3dda0825ab22b646$var$getNative;

});
parcelRegister("7Qkwj", function(module, exports) {

var $1qW2I = parcelRequire("1qW2I");

var $dID6g = parcelRequire("dID6g");

var $2fw24 = parcelRequire("2fw24");

var $b4rYu = parcelRequire("b4rYu");
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var $5b5d4e978fa0f551$var$reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var $5b5d4e978fa0f551$var$reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */ var $5b5d4e978fa0f551$var$funcProto = Function.prototype, $5b5d4e978fa0f551$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $5b5d4e978fa0f551$var$funcToString = $5b5d4e978fa0f551$var$funcProto.toString;
/** Used to check objects for own properties. */ var $5b5d4e978fa0f551$var$hasOwnProperty = $5b5d4e978fa0f551$var$objectProto.hasOwnProperty;
/** Used to detect if a method is native. */ var $5b5d4e978fa0f551$var$reIsNative = RegExp("^" + $5b5d4e978fa0f551$var$funcToString.call($5b5d4e978fa0f551$var$hasOwnProperty).replace($5b5d4e978fa0f551$var$reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function $5b5d4e978fa0f551$var$baseIsNative(value) {
    if (!$2fw24(value) || $dID6g(value)) return false;
    var pattern = $1qW2I(value) ? $5b5d4e978fa0f551$var$reIsNative : $5b5d4e978fa0f551$var$reIsHostCtor;
    return pattern.test($b4rYu(value));
}
module.exports = $5b5d4e978fa0f551$var$baseIsNative;

});
parcelRegister("1qW2I", function(module, exports) {

var $lIXED = parcelRequire("lIXED");

var $2fw24 = parcelRequire("2fw24");
/** `Object#toString` result references. */ var $10b53e3b8b4064ae$var$asyncTag = "[object AsyncFunction]", $10b53e3b8b4064ae$var$funcTag = "[object Function]", $10b53e3b8b4064ae$var$genTag = "[object GeneratorFunction]", $10b53e3b8b4064ae$var$proxyTag = "[object Proxy]";
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function $10b53e3b8b4064ae$var$isFunction(value) {
    if (!$2fw24(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = $lIXED(value);
    return tag == $10b53e3b8b4064ae$var$funcTag || tag == $10b53e3b8b4064ae$var$genTag || tag == $10b53e3b8b4064ae$var$asyncTag || tag == $10b53e3b8b4064ae$var$proxyTag;
}
module.exports = $10b53e3b8b4064ae$var$isFunction;

});
parcelRegister("2fw24", function(module, exports) {
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $1a35d479b1acd2e0$var$isObject(value) {
    var type = typeof value;
    return value != null && (type == "object" || type == "function");
}
module.exports = $1a35d479b1acd2e0$var$isObject;

});


parcelRegister("dID6g", function(module, exports) {

var $g786v = parcelRequire("g786v");
/** Used to detect methods masquerading as native. */ var $9fcdb6e1120223be$var$maskSrcKey = function() {
    var uid = /[^.]+$/.exec($g786v && $g786v.keys && $g786v.keys.IE_PROTO || "");
    return uid ? "Symbol(src)_1." + uid : "";
}();
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function $9fcdb6e1120223be$var$isMasked(func) {
    return !!$9fcdb6e1120223be$var$maskSrcKey && $9fcdb6e1120223be$var$maskSrcKey in func;
}
module.exports = $9fcdb6e1120223be$var$isMasked;

});
parcelRegister("g786v", function(module, exports) {

var $dLxmN = parcelRequire("dLxmN");
/** Used to detect overreaching core-js shims. */ var $bbb3960d6adfb70a$var$coreJsData = $dLxmN["__core-js_shared__"];
module.exports = $bbb3960d6adfb70a$var$coreJsData;

});


parcelRegister("b4rYu", function(module, exports) {
/** Used for built-in method references. */ var $80f5c4a0b500c4a9$var$funcProto = Function.prototype;
/** Used to resolve the decompiled source of functions. */ var $80f5c4a0b500c4a9$var$funcToString = $80f5c4a0b500c4a9$var$funcProto.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function $80f5c4a0b500c4a9$var$toSource(func) {
    if (func != null) {
        try {
            return $80f5c4a0b500c4a9$var$funcToString.call(func);
        } catch (e) {}
        try {
            return func + "";
        } catch (e) {}
    }
    return "";
}
module.exports = $80f5c4a0b500c4a9$var$toSource;

});


parcelRegister("8Zd1y", function(module, exports) {
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $68ae1f8b58f6b160$var$getValue(object, key) {
    return object == null ? undefined : object[key];
}
module.exports = $68ae1f8b58f6b160$var$getValue;

});




parcelRegister("fMUWH", function(module, exports) {
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $b7e782f05f938eb7$var$hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
module.exports = $b7e782f05f938eb7$var$hashDelete;

});

parcelRegister("4VljD", function(module, exports) {

var $iRGuQ = parcelRequire("iRGuQ");
/** Used to stand-in for `undefined` hash values. */ var $395d0524e2b42719$var$HASH_UNDEFINED = "__lodash_hash_undefined__";
/** Used for built-in method references. */ var $395d0524e2b42719$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $395d0524e2b42719$var$hasOwnProperty = $395d0524e2b42719$var$objectProto.hasOwnProperty;
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $395d0524e2b42719$var$hashGet(key) {
    var data = this.__data__;
    if ($iRGuQ) {
        var result = data[key];
        return result === $395d0524e2b42719$var$HASH_UNDEFINED ? undefined : result;
    }
    return $395d0524e2b42719$var$hasOwnProperty.call(data, key) ? data[key] : undefined;
}
module.exports = $395d0524e2b42719$var$hashGet;

});

parcelRegister("934WI", function(module, exports) {

var $iRGuQ = parcelRequire("iRGuQ");
/** Used for built-in method references. */ var $69683b076f7c6424$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $69683b076f7c6424$var$hasOwnProperty = $69683b076f7c6424$var$objectProto.hasOwnProperty;
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $69683b076f7c6424$var$hashHas(key) {
    var data = this.__data__;
    return $iRGuQ ? data[key] !== undefined : $69683b076f7c6424$var$hasOwnProperty.call(data, key);
}
module.exports = $69683b076f7c6424$var$hashHas;

});

parcelRegister("lav2R", function(module, exports) {

var $iRGuQ = parcelRequire("iRGuQ");
/** Used to stand-in for `undefined` hash values. */ var $f6929d0bd7509e9b$var$HASH_UNDEFINED = "__lodash_hash_undefined__";
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function $f6929d0bd7509e9b$var$hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = $iRGuQ && value === undefined ? $f6929d0bd7509e9b$var$HASH_UNDEFINED : value;
    return this;
}
module.exports = $f6929d0bd7509e9b$var$hashSet;

});


parcelRegister("bE9pp", function(module, exports) {

var $1Rhku = parcelRequire("1Rhku");

var $ghupa = parcelRequire("ghupa");

var $5JWij = parcelRequire("5JWij");

var $77kgJ = parcelRequire("77kgJ");

var $lzw70 = parcelRequire("lzw70");
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $87aaba8632f489da$var$ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `ListCache`.
$87aaba8632f489da$var$ListCache.prototype.clear = $1Rhku;
$87aaba8632f489da$var$ListCache.prototype["delete"] = $ghupa;
$87aaba8632f489da$var$ListCache.prototype.get = $5JWij;
$87aaba8632f489da$var$ListCache.prototype.has = $77kgJ;
$87aaba8632f489da$var$ListCache.prototype.set = $lzw70;
module.exports = $87aaba8632f489da$var$ListCache;

});
parcelRegister("1Rhku", function(module, exports) {
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function $15a82ef50869c3b2$var$listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
module.exports = $15a82ef50869c3b2$var$listCacheClear;

});

parcelRegister("ghupa", function(module, exports) {

var $7Np8k = parcelRequire("7Np8k");
/** Used for built-in method references. */ var $bda5d1a3045c9476$var$arrayProto = Array.prototype;
/** Built-in value references. */ var $bda5d1a3045c9476$var$splice = $bda5d1a3045c9476$var$arrayProto.splice;
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $bda5d1a3045c9476$var$listCacheDelete(key) {
    var data = this.__data__, index = $7Np8k(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else $bda5d1a3045c9476$var$splice.call(data, index, 1);
    --this.size;
    return true;
}
module.exports = $bda5d1a3045c9476$var$listCacheDelete;

});
parcelRegister("7Np8k", function(module, exports) {

var $b82f6 = parcelRequire("b82f6");
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $5ad09afbe9575a9a$var$assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if ($b82f6(array[length][0], key)) return length;
    }
    return -1;
}
module.exports = $5ad09afbe9575a9a$var$assocIndexOf;

});
parcelRegister("b82f6", function(module, exports) {
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function $81a22e64abcb7d67$var$eq(value, other) {
    return value === other || value !== value && other !== other;
}
module.exports = $81a22e64abcb7d67$var$eq;

});



parcelRegister("5JWij", function(module, exports) {

var $7Np8k = parcelRequire("7Np8k");
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $42de5fc73e7fa889$var$listCacheGet(key) {
    var data = this.__data__, index = $7Np8k(data, key);
    return index < 0 ? undefined : data[index][1];
}
module.exports = $42de5fc73e7fa889$var$listCacheGet;

});

parcelRegister("77kgJ", function(module, exports) {

var $7Np8k = parcelRequire("7Np8k");
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $52e8e8d19ce7430a$var$listCacheHas(key) {
    return $7Np8k(this.__data__, key) > -1;
}
module.exports = $52e8e8d19ce7430a$var$listCacheHas;

});

parcelRegister("lzw70", function(module, exports) {

var $7Np8k = parcelRequire("7Np8k");
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function $fb45c69fdf4908ac$var$listCacheSet(key, value) {
    var data = this.__data__, index = $7Np8k(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
module.exports = $fb45c69fdf4908ac$var$listCacheSet;

});


parcelRegister("a1lZD", function(module, exports) {

var $5jezD = parcelRequire("5jezD");

var $dLxmN = parcelRequire("dLxmN");
/* Built-in method references that are verified to be native. */ var $74bb0ec5981ea402$var$Map = $5jezD($dLxmN, "Map");
module.exports = $74bb0ec5981ea402$var$Map;

});


parcelRegister("4zws2", function(module, exports) {

var $dkL28 = parcelRequire("dkL28");
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $35439a6eef05636c$var$mapCacheDelete(key) {
    var result = $dkL28(this, key)["delete"](key);
    this.size -= result ? 1 : 0;
    return result;
}
module.exports = $35439a6eef05636c$var$mapCacheDelete;

});
parcelRegister("dkL28", function(module, exports) {

var $cbdJb = parcelRequire("cbdJb");
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function $9b51a07657f2f327$var$getMapData(map, key) {
    var data = map.__data__;
    return $cbdJb(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
}
module.exports = $9b51a07657f2f327$var$getMapData;

});
parcelRegister("cbdJb", function(module, exports) {
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function $8de129292125e716$var$isKeyable(value) {
    var type = typeof value;
    return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
}
module.exports = $8de129292125e716$var$isKeyable;

});



parcelRegister("igEfU", function(module, exports) {

var $dkL28 = parcelRequire("dkL28");
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $d4c8f28c171e4748$var$mapCacheGet(key) {
    return $dkL28(this, key).get(key);
}
module.exports = $d4c8f28c171e4748$var$mapCacheGet;

});

parcelRegister("ituXc", function(module, exports) {

var $dkL28 = parcelRequire("dkL28");
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $d732f23b59430fff$var$mapCacheHas(key) {
    return $dkL28(this, key).has(key);
}
module.exports = $d732f23b59430fff$var$mapCacheHas;

});

parcelRegister("avlK8", function(module, exports) {

var $dkL28 = parcelRequire("dkL28");
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function $7a5daa60291f1ed2$var$mapCacheSet(key, value) {
    var data = $dkL28(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
module.exports = $7a5daa60291f1ed2$var$mapCacheSet;

});





parcelRegister("feskK", function(module, exports) {

var $4YeKZ = parcelRequire("4YeKZ");
/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function $b16e2446f3b7fc98$var$toString(value) {
    return value == null ? "" : $4YeKZ(value);
}
module.exports = $b16e2446f3b7fc98$var$toString;

});
parcelRegister("4YeKZ", function(module, exports) {

var $8J6hk = parcelRequire("8J6hk");

var $ckpQO = parcelRequire("ckpQO");

var $jyoU0 = parcelRequire("jyoU0");

var $aKvy8 = parcelRequire("aKvy8");
/** Used as references for various `Number` constants. */ var $39e836723133641b$var$INFINITY = 1 / 0;
/** Used to convert symbols to primitives and strings. */ var $39e836723133641b$var$symbolProto = $8J6hk ? $8J6hk.prototype : undefined, $39e836723133641b$var$symbolToString = $39e836723133641b$var$symbolProto ? $39e836723133641b$var$symbolProto.toString : undefined;
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function $39e836723133641b$var$baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == "string") return value;
    if ($jyoU0(value)) // Recursively convert values (susceptible to call stack limits).
    return $ckpQO(value, $39e836723133641b$var$baseToString) + "";
    if ($aKvy8(value)) return $39e836723133641b$var$symbolToString ? $39e836723133641b$var$symbolToString.call(value) : "";
    var result = value + "";
    return result == "0" && 1 / value == -$39e836723133641b$var$INFINITY ? "-0" : result;
}
module.exports = $39e836723133641b$var$baseToString;

});
parcelRegister("ckpQO", function(module, exports) {
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $8f9b67b85abbfb6e$var$arrayMap(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length, result = Array(length);
    while(++index < length)result[index] = iteratee(array[index], index, array);
    return result;
}
module.exports = $8f9b67b85abbfb6e$var$arrayMap;

});




parcelRegister("5dj07", function(module, exports) {

var $aKvy8 = parcelRequire("aKvy8");
/** Used as references for various `Number` constants. */ var $3cbce7d861bb4f4a$var$INFINITY = 1 / 0;
/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */ function $3cbce7d861bb4f4a$var$toKey(value) {
    if (typeof value == "string" || $aKvy8(value)) return value;
    var result = value + "";
    return result == "0" && 1 / value == -$3cbce7d861bb4f4a$var$INFINITY ? "-0" : result;
}
module.exports = $3cbce7d861bb4f4a$var$toKey;

});




parcelRegister("b1ORY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5b578294fb32f588$export$2e2bcd8739ae039; });
/**
 * A singleton module that will store a referrer data in a closure
 * and retrieve that data in an analytics client untill the app has
 * a route transition happened.
 *
 * How it works:
 * 1. whenever we init our app with `src` or `ref` in the URL we gonna preserve them here
 * 2. in every screen event we gonna retrieve `src` and `ref` and add them to event attributes
 * 3. as soon as app transitions to any other route we gonna cleanup the stored referrer data
 *    to stop tracking it further.
 */ // the storage for our referrer info;
let $5b578294fb32f588$var$data = null;
const $5b578294fb32f588$var$referrerInfo = {
    // as we preserving the data, we should at least get it once to record in analytics before allowing cleanup
    isUsed: false,
    markUsed () {
        $5b578294fb32f588$var$referrerInfo.isUsed = true;
    },
    get () {
        return $5b578294fb32f588$var$data;
    },
    set ({ src: src, ref: ref }) {
        $5b578294fb32f588$var$data = {
            src: src,
            ref: ref
        };
    },
    cleanup (force) {
        if (!$5b578294fb32f588$var$referrerInfo.isUsed && !force) return;
        $5b578294fb32f588$var$data = null;
    }
};
var $5b578294fb32f588$export$2e2bcd8739ae039 = $5b578294fb32f588$var$referrerInfo;

});

parcelRegister("382Ai", function(module, exports) {

$parcel$export(module.exports, "getPageLoadMetric", function () { return $6fb520224bf6c8c9$export$74b8bc7a2c5f037b; });

var $fWKnh = parcelRequire("fWKnh");
const $6fb520224bf6c8c9$var$cachedMetrics = new Map();
const $6fb520224bf6c8c9$export$74b8bc7a2c5f037b = (pageId)=>{
    // Convert to kebab case to comply with naming convention:
    // https://hello.atlassian.net/wiki/spaces/APD/pages/1435310934/RUNBOOK+Get+the+Experience+Event+Key#Naming-conventions
    const page = // we have both manage-profile-ui and aid-frontend registered under 'identity' product in performance portal, so to avoid key collisions we have added mp prefix for the events originating from manage-profile-ui
    "mp-" + pageId.replace(/([a-z])([A-Z])/g, "$1-$2").replace(/[\s_]+/g, "-").toLowerCase();
    let metric = $6fb520224bf6c8c9$var$cachedMetrics.get(page);
    if (!metric) {
        metric = (0, $fWKnh.metrics).pageLoad({
            key: page
        });
        $6fb520224bf6c8c9$var$cachedMetrics.set(page, metric);
    }
    return metric;
};

});
parcelRegister("fWKnh", function(module, exports) {

$parcel$export(module.exports, "metrics", function () { return $b9c03ecbc19c51bb$export$b0c5c2fac8144e54; });

var $9E5HO = parcelRequire("9E5HO");

var $9XRvU = parcelRequire("9XRvU");
var $b9c03ecbc19c51bb$export$b0c5c2fac8144e54 = {
    pageLoad: (0, $9XRvU.pageLoad),
    pageSegmentLoad: (0, $9XRvU.pageSegmentLoad),
    interaction: (0, $9XRvU.interaction),
    custom: (0, $9XRvU.custom),
    concurrent: (0, $9E5HO.concurrent)
};

});
parcelRegister("9E5HO", function(module, exports) {

$parcel$export(module.exports, "concurrent", function () { return $705c4684eb7f4c7b$export$370df09ecc3de059; });

var $9Z3Ln = parcelRequire("9Z3Ln");

var $c2GEI = parcelRequire("c2GEI");

var $9XRvU = parcelRequire("9XRvU");
function $705c4684eb7f4c7b$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $705c4684eb7f4c7b$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $705c4684eb7f4c7b$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($9Z3Ln)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $705c4684eb7f4c7b$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $705c4684eb7f4c7b$var$concurrentMetrics = {};
var $705c4684eb7f4c7b$var$getKey = function getKey(config, type) {
    return "".concat(type, "--").concat(config.key);
};
var $705c4684eb7f4c7b$var$validateConfig = function validateConfig(config) {
    if (config.include) throw new Error('"include" is not supported in concurrent actions');
    if (config.until) throw new Error('"until" is not supported in concurrent actions');
};
var $705c4684eb7f4c7b$var$ensurePath = function ensurePath(config, type) {
    var key = $705c4684eb7f4c7b$var$getKey(config, type);
    if (!(key in $705c4684eb7f4c7b$var$concurrentMetrics)) $705c4684eb7f4c7b$var$concurrentMetrics[key] = {};
};
var $705c4684eb7f4c7b$var$getMetricFromCache = function getMetricFromCache(concurrentId, config, type) {
    var concurrentKey = $705c4684eb7f4c7b$var$getKey(config, type);
    if (concurrentKey in $705c4684eb7f4c7b$var$concurrentMetrics && $705c4684eb7f4c7b$var$concurrentMetrics[concurrentKey][String(concurrentId)]) return $705c4684eb7f4c7b$var$concurrentMetrics[concurrentKey][String(concurrentId)];
    if (!(concurrentKey in $705c4684eb7f4c7b$var$concurrentMetrics)) $705c4684eb7f4c7b$var$concurrentMetrics[concurrentKey] = {};
};
var $705c4684eb7f4c7b$var$makeConcurrentMetric = function makeConcurrentMetric(concurrentId, config, type) {
    $705c4684eb7f4c7b$var$validateConfig(config);
    $705c4684eb7f4c7b$var$ensurePath(config, type);
    var metricFromCache = $705c4684eb7f4c7b$var$getMetricFromCache(concurrentId, config, type);
    if (metricFromCache) return metricFromCache;
    var metricFactory = type === (0, $c2GEI.BMEventsType).INLINE_RESULT ? (0, $9XRvU.interaction) : (0, $9XRvU.custom);
    var metric = metricFactory(config);
    $705c4684eb7f4c7b$var$concurrentMetrics[$705c4684eb7f4c7b$var$getKey(config, type)][String(concurrentId)] = metric;
    return metric;
};
var $705c4684eb7f4c7b$export$370df09ecc3de059 = {
    pageSegmentLoad: function pageSegmentLoad(config) {
        return function(concurrentId) {
            return $705c4684eb7f4c7b$var$makeConcurrentMetric(concurrentId, $705c4684eb7f4c7b$var$_objectSpread({}, config), (0, $c2GEI.BMEventsType).PAGE_SEGMENT_LOAD);
        };
    },
    interaction: function interaction(config) {
        return function(concurrentId) {
            return $705c4684eb7f4c7b$var$makeConcurrentMetric(concurrentId, $705c4684eb7f4c7b$var$_objectSpread({}, config), (0, $c2GEI.BMEventsType).INLINE_RESULT);
        };
    },
    custom: function custom(config) {
        return function(concurrentId) {
            return $705c4684eb7f4c7b$var$makeConcurrentMetric(concurrentId, $705c4684eb7f4c7b$var$_objectSpread({}, config), (0, $c2GEI.BMEventsType).CUSTOM);
        };
    }
};

});
parcelRegister("9Z3Ln", function(module, exports) {

var $cwM6r = parcelRequire("cwM6r");
function $744cbadb13238576$var$_defineProperty(e, r, t) {
    return (r = $cwM6r(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
module.exports = $744cbadb13238576$var$_defineProperty, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("cwM6r", function(module, exports) {

var $lGj01 = parcelRequire("lGj01");
var $91edc96e9ee4d1dc$var$_typeof = $lGj01.default;

var $fDlAP = parcelRequire("fDlAP");
function $91edc96e9ee4d1dc$var$toPropertyKey(t) {
    var i = $fDlAP(t, "string");
    return "symbol" == $91edc96e9ee4d1dc$var$_typeof(i) ? i : i + "";
}
module.exports = $91edc96e9ee4d1dc$var$toPropertyKey, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("lGj01", function(module, exports) {
function $fc8c421bc4d9a6fd$var$_typeof(o) {
    "@babel/helpers - typeof";
    return module.exports = $fc8c421bc4d9a6fd$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $fc8c421bc4d9a6fd$var$_typeof(o);
}
module.exports = $fc8c421bc4d9a6fd$var$_typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("fDlAP", function(module, exports) {

var $lGj01 = parcelRequire("lGj01");
var $b61b3f7aea015395$var$_typeof = $lGj01.default;
function $b61b3f7aea015395$var$toPrimitive(t, r) {
    if ("object" != $b61b3f7aea015395$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $b61b3f7aea015395$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
module.exports = $b61b3f7aea015395$var$toPrimitive, module.exports.__esModule = true, module.exports["default"] = module.exports;

});



parcelRegister("c2GEI", function(module, exports) {

$parcel$export(module.exports, "BMEventsType", function () { return $8c46c274f3e98827$export$9c73e297d4be9159; });
$parcel$export(module.exports, "StorableBMEventsType", function () { return $8c46c274f3e98827$export$9b7037ec30489597; });
$parcel$export(module.exports, "BMPageLoadMetrics", function () { return $8c46c274f3e98827$export$74c1fb0997d51e2a; });
$parcel$export(module.exports, "BMPageSegmentLoadMetrics", function () { return $8c46c274f3e98827$export$88195ac8200d03a6; });
$parcel$export(module.exports, "BMInteractionMetrics", function () { return $8c46c274f3e98827$export$6e28252a002afdb2; });
$parcel$export(module.exports, "PageSegmentPageLoadMetricsOptions", function () { return $8c46c274f3e98827$export$474154836bfd8dd9; });
$parcel$export(module.exports, "PageVisibleFields", function () { return $8c46c274f3e98827$export$e89802082dab5633; });
$parcel$export(module.exports, "PageVisibleValueOrigin", function () { return $8c46c274f3e98827$export$983b017156c2aee2; });
$parcel$export(module.exports, "isDetailedPageLoadSlo", function () { return $8c46c274f3e98827$export$5866f95702a15142; });
$parcel$export(module.exports, "isDetailedPageSegmentLoadSlo", function () { return $8c46c274f3e98827$export$f087a59bd717e49d; });
$parcel$export(module.exports, "isInteractionMetricsSlo", function () { return $8c46c274f3e98827$export$b10c1d9a7db7765b; });
$parcel$export(module.exports, "IncludeSSRFeatureFlagsConfig", function () { return $8c46c274f3e98827$export$60c0193054fc3040; });

var $kB69W = parcelRequire("kB69W");
var $8c46c274f3e98827$export$9c73e297d4be9159 = /*#__PURE__*/ function(BMEventsType) {
    BMEventsType["PAGE_LOAD"] = "PAGE_LOAD";
    BMEventsType["PAGE_SEGMENT_LOAD"] = "PAGE_SEGMENT_LOAD";
    BMEventsType["INLINE_RESULT"] = "INLINE_RESULT";
    BMEventsType["CUSTOM"] = "CUSTOM";
    BMEventsType["WEB_VITALS"] = "WEB_VITALS";
    return BMEventsType;
}({});
var $8c46c274f3e98827$export$9b7037ec30489597 = /*#__PURE__*/ function(StorableBMEventsType) {
    StorableBMEventsType["PAGE_LOAD"] = "page-load";
    StorableBMEventsType["PAGE_SEGMENT_LOAD"] = "page-segment-load";
    StorableBMEventsType["INLINE_RESULT"] = "inline-result";
    StorableBMEventsType["CUSTOM"] = "custom";
    StorableBMEventsType["WEB_VITALS"] = "web-vitals";
    return StorableBMEventsType;
}({});
var $8c46c274f3e98827$export$74c1fb0997d51e2a = /*#__PURE__*/ function(BMPageLoadMetrics) {
    BMPageLoadMetrics["fmp"] = "fmp";
    BMPageLoadMetrics["tti"] = "tti";
    return BMPageLoadMetrics;
}({});
var $8c46c274f3e98827$export$88195ac8200d03a6 = /*#__PURE__*/ function(BMPageSegmentLoadMetrics) {
    BMPageSegmentLoadMetrics["fmp"] = "fmp";
    BMPageSegmentLoadMetrics["tti"] = "tti";
    return BMPageSegmentLoadMetrics;
}({});
var $8c46c274f3e98827$export$6e28252a002afdb2 = /*#__PURE__*/ function(BMInteractionMetrics) {
    BMInteractionMetrics["response"] = "response";
    BMInteractionMetrics["result"] = "result";
    return BMInteractionMetrics;
}({});
var $8c46c274f3e98827$export$474154836bfd8dd9 = /*#__PURE__*/ function(PageSegmentPageLoadMetricsOptions) {
    PageSegmentPageLoadMetricsOptions["OFF"] = "OFF";
    PageSegmentPageLoadMetricsOptions["IF_PRESENT"] = "IF_PRESENT";
    PageSegmentPageLoadMetricsOptions["WAIT_UNTIL_PRESENT"] = "WAIT_UNTIL_PRESENT";
    return PageSegmentPageLoadMetricsOptions;
}({});
var $8c46c274f3e98827$export$e89802082dab5633 = /*#__PURE__*/ function(PageVisibleFields) {
    PageVisibleFields["pageVisibleState"] = "page-visible-state";
    PageVisibleFields["pageVisibleValue"] = "page-visible-value";
    return PageVisibleFields;
}({});
var $8c46c274f3e98827$export$983b017156c2aee2 = /*#__PURE__*/ function(PageVisibleValueOrigin) {
    PageVisibleValueOrigin["documentHidden"] = "document-hidden";
    PageVisibleValueOrigin["pageVisibleState"] = "page-visible-state";
    return PageVisibleValueOrigin;
}({});
var $8c46c274f3e98827$export$5866f95702a15142 = function isDetailedPageLoadSlo(data) {
    return Boolean(data.initial);
};
var $8c46c274f3e98827$export$f087a59bd717e49d = function isDetailedPageSegmentLoadSlo(data) {
    return Boolean(data.initial);
};
var $8c46c274f3e98827$export$153c4c72fa5eeece = function isPageLoadMetricsSlo(data) {
    var obj = data;
    return Boolean(obj.fmp !== undefined || obj.tti !== undefined);
};
var $8c46c274f3e98827$export$b10c1d9a7db7765b = function isInteractionMetricsSlo(data) {
    var obj = data;
    return Boolean(obj.result !== undefined || obj.response !== undefined);
};
var $8c46c274f3e98827$export$60c0193054fc3040 = /*#__PURE__*/ function(IncludeSSRFeatureFlagsConfig) {
    IncludeSSRFeatureFlagsConfig["NEVER"] = "never";
    IncludeSSRFeatureFlagsConfig["WHEN_FMP"] = "when-fmp";
    IncludeSSRFeatureFlagsConfig["WHEN_AVAILABLE"] = "when-available";
    return IncludeSSRFeatureFlagsConfig;
}({});

});
parcelRegister("kB69W", function(module, exports) {

$parcel$export(module.exports, "MetricState", function () { return $efec0a72be0de295$export$1e458f18c0c7bfe3; });
$parcel$export(module.exports, "PageVisibleState", function () { return $efec0a72be0de295$export$a12c67b37a306b13; });
$parcel$export(module.exports, "BaseMetric", function () { return $efec0a72be0de295$export$2bce4ffdd840e878; });

var $VeSwC = parcelRequire("VeSwC");

var $3q6vl = parcelRequire("3q6vl");

var $1W8kW = parcelRequire("1W8kW");

var $ceJcC = parcelRequire("ceJcC");

var $9Z3Ln = parcelRequire("9Z3Ln");

var $633Sk = parcelRequire("633Sk");

var $7rgZR = parcelRequire("7rgZR");

var $eEAbY = parcelRequire("eEAbY");

var $98jP0 = parcelRequire("98jP0");
function $efec0a72be0de295$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $efec0a72be0de295$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $efec0a72be0de295$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($9Z3Ln)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $efec0a72be0de295$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $efec0a72be0de295$export$1e458f18c0c7bfe3 = /*#__PURE__*/ function(MetricState) {
    MetricState["NOT_STARTED"] = "not-started";
    MetricState["STARTED"] = "started";
    MetricState["FINISHED"] = "finished";
    MetricState["CANCELLED"] = "cancelled";
    return MetricState;
}({});
var $efec0a72be0de295$export$a12c67b37a306b13 = /*#__PURE__*/ function(PageVisibleState) {
    PageVisibleState["VISIBLE"] = "visible";
    PageVisibleState["MIXED"] = "mixed";
    PageVisibleState["HIDDEN"] = "hidden";
    return PageVisibleState;
}({});
function $efec0a72be0de295$var$getPageVisibleState() {
    return typeof document !== "undefined" && document.visibilityState === "visible" ? $efec0a72be0de295$export$a12c67b37a306b13.VISIBLE : $efec0a72be0de295$export$a12c67b37a306b13.HIDDEN;
}
var $efec0a72be0de295$export$2bce4ffdd840e878 = /*#__PURE__*/ function() {
    function BaseMetric(config) {
        var _this = this, _this$config$timings;
        (0, (/*@__PURE__*/$parcel$interopDefault($1W8kW)))(this, BaseMetric);
        (0, (/*@__PURE__*/$parcel$interopDefault($9Z3Ln)))(this, "state", $efec0a72be0de295$export$1e458f18c0c7bfe3.NOT_STARTED);
        (0, (/*@__PURE__*/$parcel$interopDefault($9Z3Ln)))(this, "startTime", null);
        (0, (/*@__PURE__*/$parcel$interopDefault($9Z3Ln)))(this, "stopTime", null);
        (0, (/*@__PURE__*/$parcel$interopDefault($9Z3Ln)))(this, "marks", {});
        (0, (/*@__PURE__*/$parcel$interopDefault($9Z3Ln)))(this, "onStopCallbacks", []);
        (0, (/*@__PURE__*/$parcel$interopDefault($9Z3Ln)))(this, "custom", null);
        (0, (/*@__PURE__*/$parcel$interopDefault($9Z3Ln)))(this, "submetrics", []);
        (0, (/*@__PURE__*/$parcel$interopDefault($9Z3Ln)))(this, "route", null);
        (0, (/*@__PURE__*/$parcel$interopDefault($9Z3Ln)))(this, "untilOnStopCallback", null);
        (0, (/*@__PURE__*/$parcel$interopDefault($9Z3Ln)))(this, "pageVisibleState", $efec0a72be0de295$var$getPageVisibleState());
        (0, (/*@__PURE__*/$parcel$interopDefault($9Z3Ln)))(this, "setPageVisibleStateToMixed", function() {
            _this.pageVisibleState = $efec0a72be0de295$export$a12c67b37a306b13.MIXED;
        });
        this.config = config;
        this.key = config.key.replace(/ /gi, "-");
        this.type = config.type;
        (_this$config$timings = this.config.timings) === null || _this$config$timings === void 0 || _this$config$timings.forEach(function(entry) {
            if ((0, $633Sk.restrictedTimingKeys).includes(entry.key)) {
                // eslint-disable-next-line no-console
                console.warn("Entry ".concat(entry.key, " is restricted and has been renamed to custom__").concat(entry.key));
                entry.key = "custom__".concat(entry.key);
            }
        });
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($ceJcC)))(BaseMetric, [
        {
            key: "untilMetrics",
            get: function get() {
                var until = this.config.until;
                if (!until) return [];
                else if (Array.isArray(until)) return this.getConfiguredUntilMetricArray(until);
                return this.getConfiguredUntilMetricArray([
                    until
                ]);
            }
        },
        {
            key: "start",
            value: function start() {
                var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref$startTime = _ref.startTime, startTime = _ref$startTime === void 0 ? window.performance.now() : _ref$startTime;
                this.clear();
                (0, $7rgZR.logger).logCond(!!this.config.debug, this.key, startTime);
                this.state = $efec0a72be0de295$export$1e458f18c0c7bfe3.STARTED;
                this.startTime = startTime;
                this.pageVisibleState = $efec0a72be0de295$var$getPageVisibleState();
                (0, $eEAbY.visibilityChangeObserver).subscribe(this.setPageVisibleStateToMixed);
                this.watchUntil();
            }
        },
        {
            key: "stop",
            value: function stop() {
                var stopArguments = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var _stopArguments$stopTi = stopArguments.stopTime, stopTime = _stopArguments$stopTi === void 0 ? window.performance.now() : _stopArguments$stopTi;
                if (this.state !== $efec0a72be0de295$export$1e458f18c0c7bfe3.STARTED || this.startTime === null) {
                    (0, $7rgZR.logger).log("metric ".concat(this.config.key, " has been stopped while not being started before; current state: ").concat(this.state));
                    return false;
                }
                if (stopTime < this.startTime) {
                    (0, $7rgZR.logger).log("metric ".concat(this.config.key, " has been stopped with stopTime lower than startTime; startTime: ").concat(this.startTime, "; stopTime: ").concat(stopTime));
                    return false;
                }
                this.stopTime = stopTime;
                this.state = $efec0a72be0de295$export$1e458f18c0c7bfe3.FINISHED;
                this.handleStop(stopArguments);
                (0, $eEAbY.visibilityChangeObserver).unsubscribe(this.setPageVisibleStateToMixed);
                return true;
            }
        },
        {
            key: "handleStop",
            value: function handleStop(stopArguments) {
                var _this2 = this;
                var _stopArguments$custom = stopArguments.customData, customData = _stopArguments$custom === void 0 ? null : _stopArguments$custom;
                if (customData) this.custom = $efec0a72be0de295$var$_objectSpread($efec0a72be0de295$var$_objectSpread({}, this.custom), customData);
                this.config.include && this.config.include.forEach(function(metric) {
                    var included = metric.getData();
                    if (included.state === $efec0a72be0de295$export$1e458f18c0c7bfe3.FINISHED && included.start !== null && included.start >= (_this2.startTime || 0)) _this2.addSubMetric(metric.getData());
                });
                this.onStopCallbacks.forEach(function(_ref2) {
                    var _ref3 = (0, (/*@__PURE__*/$parcel$interopDefault($3q6vl)))(_ref2, 1), success = _ref3[0];
                    success(stopArguments);
                });
                this.onStopCallbacks = [];
                (0, $7rgZR.logger).logCond(!!this.config.debug, this.key, this.config.debug && this.getData());
            }
        },
        {
            key: "mark",
            value: function mark(_mark) {
                var timestamp = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window.performance.now();
                this.marks[_mark] = timestamp;
            }
        },
        {
            key: "cancel",
            value: function cancel() {
                if (this.state !== $efec0a72be0de295$export$1e458f18c0c7bfe3.STARTED) return;
                this.state = $efec0a72be0de295$export$1e458f18c0c7bfe3.CANCELLED;
                this.cancelUntil();
                this.onStopCallbacks.forEach(function(_ref4) {
                    var _ref5 = (0, (/*@__PURE__*/$parcel$interopDefault($3q6vl)))(_ref4, 2), cancel = _ref5[1];
                    cancel();
                });
                this.onStopCallbacks = [];
                (0, $eEAbY.visibilityChangeObserver).unsubscribe(this.setPageVisibleStateToMixed);
            }
        },
        {
            key: "merge",
            value: function merge(mergeData) {
                this.state = mergeData.state;
                this.pageVisibleState = mergeData.pageVisibleState;
                this.startTime = mergeData.start;
                this.stopTime = mergeData.stop;
                this.marks = $efec0a72be0de295$var$_objectSpread($efec0a72be0de295$var$_objectSpread({}, this.marks), mergeData.marks);
                this.submetrics = [].concat((0, (/*@__PURE__*/$parcel$interopDefault($VeSwC)))(this.submetrics), (0, (/*@__PURE__*/$parcel$interopDefault($VeSwC)))(mergeData.submetrics));
                this.onStopCallbacks = [].concat((0, (/*@__PURE__*/$parcel$interopDefault($VeSwC)))(this.onStopCallbacks), (0, (/*@__PURE__*/$parcel$interopDefault($VeSwC)))(mergeData.onStopCallbacks));
            }
        },
        {
            key: "onStop",
            value: function onStop(success, cancel) {
                this.onStopCallbacks.push([
                    success,
                    cancel
                ]);
            }
        },
        {
            key: "removeOnStopCallback",
            value: function removeOnStopCallback(success) {
                var index = this.onStopCallbacks.findIndex(function(_ref6) {
                    var _ref7 = (0, (/*@__PURE__*/$parcel$interopDefault($3q6vl)))(_ref6, 1), successCallback = _ref7[0];
                    return success === successCallback;
                });
                if (index > -1) this.onStopCallbacks.splice(index, 1);
            }
        },
        {
            key: "getData",
            value: function getData() {
                return {
                    key: this.key,
                    state: this.state,
                    start: this.startTime,
                    stop: this.stopTime,
                    //todo ranges
                    // ranges: this.makeRanges()
                    marks: this.marks,
                    // todo make copy
                    custom: this.custom,
                    submetrics: this.submetrics,
                    config: this.config,
                    route: this.route,
                    pageVisibleState: this.pageVisibleState,
                    type: this.config.type
                };
            }
        },
        {
            key: "getDataToMerge",
            value: function getDataToMerge() {
                return $efec0a72be0de295$var$_objectSpread($efec0a72be0de295$var$_objectSpread({}, this.getData()), {}, {
                    onStopCallbacks: this.onStopCallbacks
                });
            }
        },
        {
            key: "addSubMetric",
            value: function addSubMetric(data) {
                this.submetrics.push(data);
            }
        },
        {
            key: "getConfiguredUntilMetric",
            value: function getConfiguredUntilMetric(metricOrConfig) {
                return metricOrConfig instanceof BaseMetric ? (0, $98jP0.UntilExperience).fromMetric(metricOrConfig) : (0, $98jP0.UntilExperience).fromConfig(metricOrConfig);
            }
        },
        {
            key: "getConfiguredUntilMetricArray",
            value: function getConfiguredUntilMetricArray(metricArray) {
                var _this3 = this;
                if (!metricArray.length) return [];
                return metricArray.map(function(metric) {
                    return _this3.getConfiguredUntilMetric(metric);
                });
            }
        },
        {
            key: "isUntilFinished",
            value: function isUntilFinished() {
                return this.untilMetrics.every(function(metric) {
                    return metric.experience.getData().state === $efec0a72be0de295$export$1e458f18c0c7bfe3.FINISHED;
                });
            }
        },
        {
            key: "handleAllUntilFinished",
            value: function handleAllUntilFinished() {
                // Order by ascending stop time
                var sorted = (0, (/*@__PURE__*/$parcel$interopDefault($VeSwC)))(this.untilMetrics).sort(function(m1, m2) {
                    return m1.getDependencyStopTime() - m2.getDependencyStopTime();
                });
                // Find the latest page segment to become fully interactive
                var latestFullyInteractiveSegment = (0, (/*@__PURE__*/$parcel$interopDefault($VeSwC)))(this.untilMetrics).reduce(function(currentLatestSegment, metric) {
                    var _currentLatestSegment, _metric$getFullyInter;
                    var currentLatestStopTime = (_currentLatestSegment = currentLatestSegment === null || currentLatestSegment === void 0 ? void 0 : currentLatestSegment.getFullyInteractiveStopTime()) !== null && _currentLatestSegment !== void 0 ? _currentLatestSegment : 0;
                    var metricStopTime = (_metric$getFullyInter = metric.getFullyInteractiveStopTime()) !== null && _metric$getFullyInter !== void 0 ? _metric$getFullyInter : 0;
                    return metricStopTime > currentLatestStopTime ? metric : currentLatestSegment;
                }, undefined);
                // Accumulate the custom data from each metric, later metrics take priority
                var accumulatedCustomData = {};
                sorted.forEach(function(metric) {
                    Object.assign(accumulatedCustomData, metric.experience.getData().custom);
                });
                var latestSegment = sorted[sorted.length - 1];
                var latestFullyInteractiveStopTime = latestFullyInteractiveSegment === null || latestFullyInteractiveSegment === void 0 ? void 0 : latestFullyInteractiveSegment.getFullyInteractiveStopTime();
                this.stop({
                    stopTime: latestSegment.getDependencyStopTime(),
                    customData: $efec0a72be0de295$var$_objectSpread($efec0a72be0de295$var$_objectSpread({}, accumulatedCustomData), {}, {
                        segment: latestSegment.getKey(),
                        segmentOverrided: latestSegment.getIsSegmentLoadOverrided()
                    }, latestFullyInteractiveStopTime ? {
                        latestFullyInteractiveSegment: latestFullyInteractiveSegment === null || latestFullyInteractiveSegment === void 0 ? void 0 : latestFullyInteractiveSegment.getKey(),
                        latestFullyInteractiveStopTime: latestFullyInteractiveStopTime
                    } : {})
                });
            }
        },
        {
            key: "watchUntil",
            value: function watchUntil() {
                var _this4 = this;
                if (!this.untilMetrics.length) return;
                if (this.isUntilFinished()) {
                    // Already finished, handle it immediately
                    this.handleAllUntilFinished();
                    return;
                }
                // If not currently finished, register stop callbacks to re-check
                this.untilOnStopCallback = function() {
                    if (_this4.isUntilFinished()) _this4.handleAllUntilFinished();
                };
                this.untilMetrics.forEach(function(metric) {
                    if (metric.experience.getData().state !== $efec0a72be0de295$export$1e458f18c0c7bfe3.FINISHED) metric.experience.onStop(_this4.untilOnStopCallback, function() {
                        return _this4.cancel();
                    });
                });
            }
        },
        {
            key: "cancelUntil",
            value: function cancelUntil() {
                var _this5 = this;
                this.untilMetrics.forEach(function(metric) {
                    if (metric.experience.getData().state !== $efec0a72be0de295$export$1e458f18c0c7bfe3.CANCELLED && _this5.untilOnStopCallback) metric.experience.removeOnStopCallback(_this5.untilOnStopCallback);
                });
            }
        },
        {
            key: "clear",
            value: function clear() {
                // todo before clearing - handle cancelling existing onStop / unsubscribe submetrics
                this.cancelUntil();
                this.state = $efec0a72be0de295$export$1e458f18c0c7bfe3.NOT_STARTED;
                this.startTime = null;
                this.stopTime = null;
                this.marks = {};
                this.custom = null;
                this.submetrics = [];
                this.route = null;
                this.pageVisibleState = $efec0a72be0de295$var$getPageVisibleState();
            }
        }
    ]);
    return BaseMetric;
}();
(0, (/*@__PURE__*/$parcel$interopDefault($9Z3Ln)))($efec0a72be0de295$export$2bce4ffdd840e878, "FMP", "fmp");

});
parcelRegister("VeSwC", function(module, exports) {

var $g8qgE = parcelRequire("g8qgE");

var $hR0Zw = parcelRequire("hR0Zw");

var $lI2Sk = parcelRequire("lI2Sk");

var $7qlWg = parcelRequire("7qlWg");
function $0ac0dd88ac3f239d$var$_toConsumableArray(r) {
    return $g8qgE(r) || $hR0Zw(r) || $lI2Sk(r) || $7qlWg();
}
module.exports = $0ac0dd88ac3f239d$var$_toConsumableArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("g8qgE", function(module, exports) {

var $ch91q = parcelRequire("ch91q");
function $bbf1c4de15ef4733$var$_arrayWithoutHoles(r) {
    if (Array.isArray(r)) return $ch91q(r);
}
module.exports = $bbf1c4de15ef4733$var$_arrayWithoutHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("ch91q", function(module, exports) {
function $8efe1227d97db881$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
module.exports = $8efe1227d97db881$var$_arrayLikeToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("hR0Zw", function(module, exports) {
function $cff827c6603e7d36$var$_iterableToArray(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
module.exports = $cff827c6603e7d36$var$_iterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("lI2Sk", function(module, exports) {

var $ch91q = parcelRequire("ch91q");
function $fcdff001e92d388c$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $ch91q(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $ch91q(r, a) : void 0;
    }
}
module.exports = $fcdff001e92d388c$var$_unsupportedIterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("7qlWg", function(module, exports) {
function $567bfaacab9f0169$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
module.exports = $567bfaacab9f0169$var$_nonIterableSpread, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("3q6vl", function(module, exports) {

var $1yPgJ = parcelRequire("1yPgJ");

var $7EJTd = parcelRequire("7EJTd");

var $lI2Sk = parcelRequire("lI2Sk");

var $h6kRR = parcelRequire("h6kRR");
function $27d8d87351459f51$var$_slicedToArray(r, e) {
    return $1yPgJ(r) || $7EJTd(r, e) || $lI2Sk(r, e) || $h6kRR();
}
module.exports = $27d8d87351459f51$var$_slicedToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("1yPgJ", function(module, exports) {
function $1230bc5e970bc1d9$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
module.exports = $1230bc5e970bc1d9$var$_arrayWithHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("7EJTd", function(module, exports) {
function $592fdd8ce4e54170$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
module.exports = $592fdd8ce4e54170$var$_iterableToArrayLimit, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("h6kRR", function(module, exports) {
function $c7332f1bd2121c78$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
module.exports = $c7332f1bd2121c78$var$_nonIterableRest, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("1W8kW", function(module, exports) {
function $1691acbe32a054d1$var$_classCallCheck(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
module.exports = $1691acbe32a054d1$var$_classCallCheck, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("ceJcC", function(module, exports) {

var $cwM6r = parcelRequire("cwM6r");
function $8e89db1abac5fba8$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, $cwM6r(o.key), o);
    }
}
function $8e89db1abac5fba8$var$_createClass(e, r, t) {
    return r && $8e89db1abac5fba8$var$_defineProperties(e.prototype, r), t && $8e89db1abac5fba8$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}
module.exports = $8e89db1abac5fba8$var$_createClass, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("633Sk", function(module, exports) {

$parcel$export(module.exports, "restrictedTimingKeys", function () { return $467607741158dafc$export$1d17377365286b00; });
$parcel$export(module.exports, "clsWaitTimeMs", function () { return $467607741158dafc$export$df21d285cfcda81e; });
var $467607741158dafc$export$1d17377365286b00 = [
    "ssr"
];
var $467607741158dafc$export$df21d285cfcda81e = 7500;

});

parcelRegister("7rgZR", function(module, exports) {

$parcel$export(module.exports, "logger", function () { return $56a83d32e2ad5158$export$af88d00dbe7f521; });
var $56a83d32e2ad5158$export$af88d00dbe7f521 = {
    enabled: false,
    enable: function enable() {
        this.enabled = true;
    },
    log: function log() {
        if (this.enabled) {
            var _console;
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            // eslint-disable-next-line no-console
            (_console = console).log.apply(_console, [
                "BM log: "
            ].concat(args));
        }
    },
    logCond: function logCond(condition) {
        for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
        if (this.enabled && condition && args.length > 1) this.log.apply(this, args);
    }
};

});

parcelRegister("eEAbY", function(module, exports) {

$parcel$export(module.exports, "visibilityChangeObserver", function () { return $aab0e0200c245879$export$13e680397ec8f3eb; });

var $1W8kW = parcelRequire("1W8kW");

var $ceJcC = parcelRequire("ceJcC");

var $9Z3Ln = parcelRequire("9Z3Ln");
var $aab0e0200c245879$var$VisibilityChangeObserver = /*#__PURE__*/ function() {
    function VisibilityChangeObserver() {
        var _this = this;
        (0, (/*@__PURE__*/$parcel$interopDefault($1W8kW)))(this, VisibilityChangeObserver);
        (0, (/*@__PURE__*/$parcel$interopDefault($9Z3Ln)))(this, "observers", []);
        (0, (/*@__PURE__*/$parcel$interopDefault($9Z3Ln)))(this, "broadcast", function() {
            _this.observers.forEach(function(fn) {
                return fn();
            });
            _this.observers = [];
        });
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($ceJcC)))(VisibilityChangeObserver, [
        {
            key: "start",
            value: function start() {
                document.addEventListener("visibilitychange", this.broadcast);
                /**
       * According to https://developer.mozilla.org/en-US/docs/Web/API/Document/visibilitychange_event
       * Safari doesn’t fire visibilitychange as expected when the value of the visibilityState property transitions to hidden;
       * so for that case, you need to also include code to listen for the pagehide event.
       */ window.addEventListener("pagehide", this.broadcast);
            }
        },
        {
            key: "subscribe",
            value: function subscribe(callback) {
                this.observers.push(callback);
            }
        },
        {
            key: "unsubscribe",
            value: function unsubscribe(callback) {
                this.observers = this.observers.filter(function(fn) {
                    return fn !== callback;
                });
            }
        }
    ]);
    return VisibilityChangeObserver;
}();
var $aab0e0200c245879$export$13e680397ec8f3eb = new $aab0e0200c245879$var$VisibilityChangeObserver();

});

parcelRegister("98jP0", function(module, exports) {

$parcel$export(module.exports, "UntilExperience", function () { return $6a643c8ed62bafee$export$3fcc0936ee2cc852; });

var $1W8kW = parcelRequire("1W8kW");

var $ceJcC = parcelRequire("ceJcC");

var $9Z3Ln = parcelRequire("9Z3Ln");
var $6a643c8ed62bafee$export$3fcc0936ee2cc852 = /*#__PURE__*/ function() {
    function UntilExperience(experience, useFmpAsUntilStopTime) {
        (0, (/*@__PURE__*/$parcel$interopDefault($1W8kW)))(this, UntilExperience);
        this.experience = experience;
        this.useFmpAsUntilStopTime = useFmpAsUntilStopTime;
    }
    /**
   * If FMP mark is present, return that
   * otherwise return the eventual load
   */ (0, (/*@__PURE__*/$parcel$interopDefault($ceJcC)))(UntilExperience, [
        {
            key: "getFmp",
            value: function getFmp() {
                var _marks$UntilExperienc;
                var _this$experience$getD = this.experience.getData(), marks = _this$experience$getD.marks, stop = _this$experience$getD.stop;
                return (_marks$UntilExperienc = marks[UntilExperience.FMP]) !== null && _marks$UntilExperienc !== void 0 ? _marks$UntilExperienc : stop;
            }
        },
        {
            key: "getDependencyStopTime",
            value: function getDependencyStopTime() {
                if (this.useFmpAsUntilStopTime) return this.getFmp();
                return this.experience.getData().stop;
            }
        },
        {
            key: "getFullyInteractiveStopTime",
            value: function getFullyInteractiveStopTime() {
                return this.experience.getData().stop;
            }
        },
        {
            key: "getIsSegmentLoadOverrided",
            value: function getIsSegmentLoadOverrided() {
                if (this.useFmpAsUntilStopTime) {
                    var _this$experience$getD2 = this.experience.getData(), marks = _this$experience$getD2.marks;
                    return marks[UntilExperience.FMP] ? true : false;
                }
                return false;
            }
        },
        {
            key: "getKey",
            value: function getKey() {
                return this.experience.getData().key;
            }
        }
    ], [
        {
            key: "fromConfig",
            value: function fromConfig(config) {
                return new UntilExperience(config.experience, config.useFmpAsUntilStopTime);
            }
        },
        {
            key: "fromMetric",
            value: function fromMetric(metric) {
                return new UntilExperience(metric);
            }
        }
    ]);
    return UntilExperience;
}();
(0, (/*@__PURE__*/$parcel$interopDefault($9Z3Ln)))($6a643c8ed62bafee$export$3fcc0936ee2cc852, "FMP", "fmp");

});



parcelRegister("9XRvU", function(module, exports) {

$parcel$export(module.exports, "pageLoad", function () { return $7413226cfc13a570$export$791d520f7e8058a5; });
$parcel$export(module.exports, "pageSegmentLoad", function () { return $7413226cfc13a570$export$94114666844d5f66; });
$parcel$export(module.exports, "interaction", function () { return $7413226cfc13a570$export$92473e6020ad89b4; });
$parcel$export(module.exports, "custom", function () { return $7413226cfc13a570$export$4c00f665f0d4b443; });

var $9Z3Ln = parcelRequire("9Z3Ln");

var $9vl78 = parcelRequire("9vl78");

var $k5uxT = parcelRequire("k5uxT");

var $f7Fa0 = parcelRequire("f7Fa0");

var $c2GEI = parcelRequire("c2GEI");
function $7413226cfc13a570$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $7413226cfc13a570$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $7413226cfc13a570$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($9Z3Ln)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $7413226cfc13a570$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $7413226cfc13a570$export$791d520f7e8058a5 = function pageLoad(config) {
    return new (0, $k5uxT.PageLoadMetric)($7413226cfc13a570$var$_objectSpread($7413226cfc13a570$var$_objectSpread({}, config), {}, {
        type: (0, $c2GEI.BMEventsType).PAGE_LOAD
    }));
};
var $7413226cfc13a570$export$94114666844d5f66 = function pageSegmentLoad(config) {
    return new (0, $f7Fa0.PageSegmentLoadMetric)($7413226cfc13a570$var$_objectSpread($7413226cfc13a570$var$_objectSpread({}, config), {}, {
        type: (0, $c2GEI.BMEventsType).PAGE_SEGMENT_LOAD
    }));
};
var $7413226cfc13a570$export$92473e6020ad89b4 = function interaction(config) {
    return new (0, $9vl78.Metric)($7413226cfc13a570$var$_objectSpread($7413226cfc13a570$var$_objectSpread({}, config), {}, {
        type: (0, $c2GEI.BMEventsType).INLINE_RESULT
    }));
};
var $7413226cfc13a570$export$4c00f665f0d4b443 = function custom(config) {
    return new (0, $9vl78.Metric)($7413226cfc13a570$var$_objectSpread($7413226cfc13a570$var$_objectSpread({}, config), {}, {
        type: (0, $c2GEI.BMEventsType).CUSTOM
    }));
};

});
parcelRegister("9vl78", function(module, exports) {

$parcel$export(module.exports, "Metric", function () { return $6eb7632522fc7622$export$efdd3e096bc27746; });

var $1W8kW = parcelRequire("1W8kW");

var $ceJcC = parcelRequire("ceJcC");

var $2CEPP = parcelRequire("2CEPP");

var $lVZ3G = parcelRequire("lVZ3G");

var $fV4YG = parcelRequire("fV4YG");

var $7mJzd = parcelRequire("7mJzd");

var $awgKP = parcelRequire("awgKP");

var $3TgUs = parcelRequire("3TgUs");

var $kB69W = parcelRequire("kB69W");
function $6eb7632522fc7622$var$_createSuper(t) {
    var r = $6eb7632522fc7622$var$_isNativeReflectConstruct();
    return function() {
        var e, o = (0, (/*@__PURE__*/$parcel$interopDefault($7mJzd)))(t);
        if (r) {
            var s = (0, (/*@__PURE__*/$parcel$interopDefault($7mJzd)))(this).constructor;
            e = Reflect.construct(o, arguments, s);
        } else e = o.apply(this, arguments);
        return (0, (/*@__PURE__*/$parcel$interopDefault($fV4YG)))(this, e);
    };
}
function $6eb7632522fc7622$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($6eb7632522fc7622$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $6eb7632522fc7622$export$efdd3e096bc27746 = /*#__PURE__*/ function(_BaseMetric) {
    (0, (/*@__PURE__*/$parcel$interopDefault($lVZ3G)))(Metric, _BaseMetric);
    var _super = $6eb7632522fc7622$var$_createSuper(Metric);
    function Metric() {
        (0, (/*@__PURE__*/$parcel$interopDefault($1W8kW)))(this, Metric);
        return _super.apply(this, arguments);
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($ceJcC)))(Metric, [
        {
            key: "start",
            value: function start() {
                var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, startTime = _ref.startTime;
                (0, (/*@__PURE__*/$parcel$interopDefault($2CEPP)))((0, (/*@__PURE__*/$parcel$interopDefault($7mJzd)))(Metric.prototype), "start", this).call(this, {
                    startTime: startTime
                });
                this.route = (0, $awgKP.Route).getRoute();
            }
        },
        {
            key: "stop",
            value: function stop() {
                var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var stoppedSuccessfully = (0, (/*@__PURE__*/$parcel$interopDefault($2CEPP)))((0, (/*@__PURE__*/$parcel$interopDefault($7mJzd)))(Metric.prototype), "stop", this).call(this, params);
                if (stoppedSuccessfully && !this.config.virtual) (0, $3TgUs.submitter).queue(this.getData());
                return stoppedSuccessfully;
            }
        }
    ]);
    return Metric;
}((0, $kB69W.BaseMetric));

});
parcelRegister("2CEPP", function(module, exports) {

var $63PxK = parcelRequire("63PxK");
function $1e8ece5555c7bd5c$var$_get() {
    return module.exports = $1e8ece5555c7bd5c$var$_get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function(e, t, r) {
        var p = $63PxK(e, t);
        if (p) {
            var n = Object.getOwnPropertyDescriptor(p, t);
            return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value;
        }
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $1e8ece5555c7bd5c$var$_get.apply(null, arguments);
}
module.exports = $1e8ece5555c7bd5c$var$_get, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("63PxK", function(module, exports) {

var $7mJzd = parcelRequire("7mJzd");
function $469b01584e42fb9b$var$_superPropBase(t, o) {
    for(; !({}).hasOwnProperty.call(t, o) && null !== (t = $7mJzd(t)););
    return t;
}
module.exports = $469b01584e42fb9b$var$_superPropBase, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("7mJzd", function(module, exports) {
function $55cdef24be9f2630$var$_getPrototypeOf(t) {
    return module.exports = $55cdef24be9f2630$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $55cdef24be9f2630$var$_getPrototypeOf(t);
}
module.exports = $55cdef24be9f2630$var$_getPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

});



parcelRegister("lVZ3G", function(module, exports) {

var $kaKJF = parcelRequire("kaKJF");
function $ff7e48c4f59d1b1e$var$_inherits(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && $kaKJF(t, e);
}
module.exports = $ff7e48c4f59d1b1e$var$_inherits, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("kaKJF", function(module, exports) {
function $eaf8fe87a850be64$var$_setPrototypeOf(t, e) {
    return module.exports = $eaf8fe87a850be64$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $eaf8fe87a850be64$var$_setPrototypeOf(t, e);
}
module.exports = $eaf8fe87a850be64$var$_setPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("fV4YG", function(module, exports) {

var $lGj01 = parcelRequire("lGj01");
var $b9700a61ba369f20$var$_typeof = $lGj01.default;

var $gNgok = parcelRequire("gNgok");
function $b9700a61ba369f20$var$_possibleConstructorReturn(t, e) {
    if (e && ("object" == $b9700a61ba369f20$var$_typeof(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return $gNgok(t);
}
module.exports = $b9700a61ba369f20$var$_possibleConstructorReturn, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("gNgok", function(module, exports) {
function $c39deff186d6e990$var$_assertThisInitialized(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}
module.exports = $c39deff186d6e990$var$_assertThisInitialized, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("awgKP", function(module, exports) {

$parcel$export(module.exports, "Route", function () { return $7a89e39851439cdf$export$e7b0ac011bb776c6; });
var $7a89e39851439cdf$export$e7b0ac011bb776c6 = {
    route: "",
    setRoute: function setRoute(newRoute) {
        this.route = newRoute;
    },
    getRoute: function getRoute() {
        return this.route;
    }
};

});

parcelRegister("3TgUs", function(module, exports) {

$parcel$export(module.exports, "submitter", function () { return $2d53a00b010906be$export$c21a25872e3f5a2b; });

var $4BwFW = parcelRequire("4BwFW");

var $c39NH = parcelRequire("c39NH");

var $2dXOu = parcelRequire("2dXOu");

var $c2GEI = parcelRequire("c2GEI");

var $ld7xY = parcelRequire("ld7xY");

var $5D1NT = parcelRequire("5D1NT");
var $2d53a00b010906be$export$c21a25872e3f5a2b = {
    debug: false,
    config: {
        gasv3: undefined,
        configChunk: null,
        useVisibleState: false,
        histogram: {},
        enableReactUFOTracker: false
    },
    configure: function configure(config) {
        this.config.gasv3 = config.endpoints.eventPipelineClient;
        this.config.enableReactUFOTracker = config.enableReactUFOTracker;
        this.config.configChunk = (0, $5D1NT.makeShareableGlobalConfig)(config);
        if (config.events.all && config.events.all.sfxEvents) this.config.useVisibleState = config.events.all.sfxEvents.activeTab === (0, $c2GEI.PageVisibleFields).pageVisibleState;
    },
    setDebug: function setDebug(debug) {
        this.debug = debug;
    },
    queue: function queue(data) {
        var _this = this;
        return (0, (/*@__PURE__*/$parcel$interopDefault($4BwFW)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($c39NH))).mark(function _callee() {
            var chunk, payload, client, attributes;
            return (0, (/*@__PURE__*/$parcel$interopDefault($c39NH))).wrap(function _callee$(_context) {
                while(true)switch(_context.prev = _context.next){
                    case 0:
                        if (_this.config.enableReactUFOTracker) (0, $2dXOu.addBrowserMetricEvent)(data);
                        if (_this.config.configChunk) {
                            _context.next = 4;
                            break;
                        }
                        // eslint-disable-next-line no-console
                        _this.debug && console.warn("Submitter is not configured");
                        return _context.abrupt("return", null);
                    case 4:
                        _context.next = 6;
                        return _this.config.configChunk;
                    case 6:
                        chunk = _context.sent;
                        _context.next = 9;
                        return (0, $ld7xY.eventDataProcessor)(chunk[data.config.type], data);
                    case 9:
                        payload = _context.sent;
                        if (!(payload === null)) {
                            _context.next = 12;
                            break;
                        }
                        return _context.abrupt("return");
                    case 12:
                        if (!(_this.config.gasv3 !== undefined)) {
                            _context.next = 18;
                            break;
                        }
                        _context.next = 15;
                        return _this.config.gasv3;
                    case 15:
                        client = _context.sent;
                        attributes = {
                            task: payload["event:key"],
                            properties: payload
                        };
                        client && client.sendOperationalEvent({
                            actionSubject: "performance",
                            attributes: attributes,
                            source: "performance",
                            action: "measured"
                        });
                    case 18:
                    case "end":
                        return _context.stop();
                }
            }, _callee);
        }))();
    }
};

});
parcelRegister("4BwFW", function(module, exports) {
function $35a3f6cfe725643d$var$asyncGeneratorStep(n, t, e, r, o, a, c) {
    try {
        var i = n[a](c), u = i.value;
    } catch (n) {
        return void e(n);
    }
    i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function $35a3f6cfe725643d$var$_asyncToGenerator(n) {
    return function() {
        var t = this, e = arguments;
        return new Promise(function(r, o) {
            var a = n.apply(t, e);
            function _next(n) {
                $35a3f6cfe725643d$var$asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
            }
            function _throw(n) {
                $35a3f6cfe725643d$var$asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
            }
            _next(void 0);
        });
    };
}
module.exports = $35a3f6cfe725643d$var$_asyncToGenerator, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("c39NH", function(module, exports) {
// TODO(Babel 8): Remove this file.

var $8c5d5e052b7e812b$var$runtime = (parcelRequire("2NXNl"))();
module.exports = $8c5d5e052b7e812b$var$runtime;
// Copied from https://github.com/facebook/regenerator/blob/main/packages/runtime/runtime.js#L736=
try {
    regeneratorRuntime = $8c5d5e052b7e812b$var$runtime;
} catch (accidentalStrictMode) {
    if (typeof globalThis === "object") globalThis.regeneratorRuntime = $8c5d5e052b7e812b$var$runtime;
    else Function("r", "regeneratorRuntime = r")($8c5d5e052b7e812b$var$runtime);
}

});
parcelRegister("2NXNl", function(module, exports) {

var $lGj01 = parcelRequire("lGj01");
var $20ae8a6abfa2e1c6$var$_typeof = $lGj01.default;
function $20ae8a6abfa2e1c6$var$_regeneratorRuntime() {
    "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ 
    module.exports = $20ae8a6abfa2e1c6$var$_regeneratorRuntime = function _regeneratorRuntime() {
        return e;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports;
    var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function(t, e, r) {
        t[e] = r.value;
    }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag";
    function define(t, e, r) {
        return Object.defineProperty(t, e, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }), t[e];
    }
    try {
        define({}, "");
    } catch (t) {
        define = function define(t, e, r) {
            return t[e] = r;
        };
    }
    function wrap(t, e, r, n) {
        var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []);
        return o(a, "_invoke", {
            value: makeInvokeMethod(t, r, c)
        }), a;
    }
    function tryCatch(t, e, r) {
        try {
            return {
                type: "normal",
                arg: t.call(e, r)
            };
        } catch (t) {
            return {
                type: "throw",
                arg: t
            };
        }
    }
    e.wrap = wrap;
    var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {};
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    var p = {};
    define(p, a, function() {
        return this;
    });
    var d = Object.getPrototypeOf, v = d && d(d(values([])));
    v && v !== r && n.call(v, a) && (p = v);
    var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
    function defineIteratorMethods(t) {
        [
            "next",
            "throw",
            "return"
        ].forEach(function(e) {
            define(t, e, function(t) {
                return this._invoke(e, t);
            });
        });
    }
    function AsyncIterator(t, e) {
        function invoke(r, o, i, a) {
            var c = tryCatch(t[r], t, o);
            if ("throw" !== c.type) {
                var u = c.arg, h = u.value;
                return h && "object" == $20ae8a6abfa2e1c6$var$_typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function(t) {
                    invoke("next", t, i, a);
                }, function(t) {
                    invoke("throw", t, i, a);
                }) : e.resolve(h).then(function(t) {
                    u.value = t, i(u);
                }, function(t) {
                    return invoke("throw", t, i, a);
                });
            }
            a(c.arg);
        }
        var r;
        o(this, "_invoke", {
            value: function value(t, n) {
                function callInvokeWithMethodAndArg() {
                    return new e(function(e, r) {
                        invoke(t, n, e, r);
                    });
                }
                return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
            }
        });
    }
    function makeInvokeMethod(e, r, n) {
        var o = h;
        return function(i, a) {
            if (o === f) throw Error("Generator is already running");
            if (o === s) {
                if ("throw" === i) throw a;
                return {
                    value: t,
                    done: !0
                };
            }
            for(n.method = i, n.arg = a;;){
                var c = n.delegate;
                if (c) {
                    var u = maybeInvokeDelegate(c, n);
                    if (u) {
                        if (u === y) continue;
                        return u;
                    }
                }
                if ("next" === n.method) n.sent = n._sent = n.arg;
                else if ("throw" === n.method) {
                    if (o === h) throw o = s, n.arg;
                    n.dispatchException(n.arg);
                } else "return" === n.method && n.abrupt("return", n.arg);
                o = f;
                var p = tryCatch(e, r, n);
                if ("normal" === p.type) {
                    if (o = n.done ? s : l, p.arg === y) continue;
                    return {
                        value: p.arg,
                        done: n.done
                    };
                }
                "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
            }
        };
    }
    function maybeInvokeDelegate(e, r) {
        var n = r.method, o = e.iterator[n];
        if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
        var i = tryCatch(o, e.iterator, r.arg);
        if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
        var a = i.arg;
        return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
    }
    function pushTryEntry(t) {
        var e = {
            tryLoc: t[0]
        };
        1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
    }
    function resetTryEntry(t) {
        var e = t.completion || {};
        e.type = "normal", delete e.arg, t.completion = e;
    }
    function Context(t) {
        this.tryEntries = [
            {
                tryLoc: "root"
            }
        ], t.forEach(pushTryEntry, this), this.reset(!0);
    }
    function values(e) {
        if (e || "" === e) {
            var r = e[a];
            if (r) return r.call(e);
            if ("function" == typeof e.next) return e;
            if (!isNaN(e.length)) {
                var o = -1, i = function next() {
                    for(; ++o < e.length;)if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
                    return next.value = t, next.done = !0, next;
                };
                return i.next = i;
            }
        }
        throw new TypeError($20ae8a6abfa2e1c6$var$_typeof(e) + " is not iterable");
    }
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
        value: GeneratorFunctionPrototype,
        configurable: !0
    }), o(GeneratorFunctionPrototype, "constructor", {
        value: GeneratorFunction,
        configurable: !0
    }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function(t) {
        var e = "function" == typeof t && t.constructor;
        return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
    }, e.mark = function(t) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
    }, e.awrap = function(t) {
        return {
            __await: t
        };
    }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function() {
        return this;
    }), e.AsyncIterator = AsyncIterator, e.async = function(t, r, n, o, i) {
        void 0 === i && (i = Promise);
        var a = new AsyncIterator(wrap(t, r, n, o), i);
        return e.isGeneratorFunction(r) ? a : a.next().then(function(t) {
            return t.done ? t.value : a.next();
        });
    }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function() {
        return this;
    }), define(g, "toString", function() {
        return "[object Generator]";
    }), e.keys = function(t) {
        var e = Object(t), r = [];
        for(var n in e)r.push(n);
        return r.reverse(), function next() {
            for(; r.length;){
                var t = r.pop();
                if (t in e) return next.value = t, next.done = !1, next;
            }
            return next.done = !0, next;
        };
    }, e.values = values, Context.prototype = {
        constructor: Context,
        reset: function reset(e) {
            if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for(var r in this)"t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
        },
        stop: function stop() {
            this.done = !0;
            var t = this.tryEntries[0].completion;
            if ("throw" === t.type) throw t.arg;
            return this.rval;
        },
        dispatchException: function dispatchException(e) {
            if (this.done) throw e;
            var r = this;
            function handle(n, o) {
                return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
            }
            for(var o = this.tryEntries.length - 1; o >= 0; --o){
                var i = this.tryEntries[o], a = i.completion;
                if ("root" === i.tryLoc) return handle("end");
                if (i.tryLoc <= this.prev) {
                    var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc");
                    if (c && u) {
                        if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                        if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
                    } else if (c) {
                        if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                    } else {
                        if (!u) throw Error("try statement without catch or finally");
                        if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
                    }
                }
            }
        },
        abrupt: function abrupt(t, e) {
            for(var r = this.tryEntries.length - 1; r >= 0; --r){
                var o = this.tryEntries[r];
                if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
                    var i = o;
                    break;
                }
            }
            i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
            var a = i ? i.completion : {};
            return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
        },
        complete: function complete(t, e) {
            if ("throw" === t.type) throw t.arg;
            return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
        },
        finish: function finish(t) {
            for(var e = this.tryEntries.length - 1; e >= 0; --e){
                var r = this.tryEntries[e];
                if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
            }
        },
        "catch": function _catch(t) {
            for(var e = this.tryEntries.length - 1; e >= 0; --e){
                var r = this.tryEntries[e];
                if (r.tryLoc === t) {
                    var n = r.completion;
                    if ("throw" === n.type) {
                        var o = n.arg;
                        resetTryEntry(r);
                    }
                    return o;
                }
            }
            throw Error("illegal catch attempt");
        },
        delegateYield: function delegateYield(e, r, n) {
            return this.delegate = {
                iterator: values(e),
                resultName: r,
                nextLoc: n
            }, "next" === this.method && (this.arg = t), y;
        }
    }, e;
}
module.exports = $20ae8a6abfa2e1c6$var$_regeneratorRuntime, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("2dXOu", function(module, exports) {

$parcel$export(module.exports, "addBrowserMetricEvent", function () { return $19eb315acfe824c7$export$4a759336b50e86e3; });

var $9mn8h = parcelRequire("9mn8h");

var $5yl5q = parcelRequire("5yl5q");

var $lxu1t = parcelRequire("lxu1t");

var $816lv = parcelRequire("816lv");

var $l1yK8 = parcelRequire("l1yK8");

var $j1psf = parcelRequire("j1psf");

var $k7hWa = parcelRequire("k7hWa");

var $f6Lit = parcelRequire("f6Lit");

var $e4sM6 = parcelRequire("e4sM6");

var $5dLtD = parcelRequire("5dLtD");

var $91opC = parcelRequire("91opC");

var $5L5Ad = parcelRequire("5L5Ad");
function $19eb315acfe824c7$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $19eb315acfe824c7$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $19eb315acfe824c7$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($5yl5q)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $19eb315acfe824c7$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $19eb315acfe824c7$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $19eb315acfe824c7$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $19eb315acfe824c7$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $19eb315acfe824c7$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $19eb315acfe824c7$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $19eb315acfe824c7$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
var $19eb315acfe824c7$var$PreviousInteractionLog = {
    name: undefined,
    isAborted: undefined
};
var $19eb315acfe824c7$export$d8f52e8f804021e8 = new (0, $5L5Ad.default)();
var $19eb315acfe824c7$var$interactionQueue = [];
var $19eb315acfe824c7$var$segmentCache = new Map();
var $19eb315acfe824c7$var$CLEANUP_TIMEOUT = 60000;
var $19eb315acfe824c7$var$CLEANUP_TIMEOUT_AFTER_APDEX = 15000;
var $19eb315acfe824c7$var$segmentObservers = [];
function $19eb315acfe824c7$export$2b3954d2e8509985() {
    var interactionId = (0, $e4sM6.getInteractionId)();
    if (!interactionId.current) return;
    return (0, $91opC.default).get(interactionId.current);
}
function $19eb315acfe824c7$var$isPerformanceTracingEnabled() {
    var _getConfig;
    return ((_getConfig = (0, $j1psf.getConfig)()) === null || _getConfig === void 0 ? void 0 : _getConfig.enableAdditionalPerformanceMarks) || window.__REACT_UFO_ENABLE_PERF_TRACING || false;
}
function $19eb315acfe824c7$var$labelStackToString(labelStack, name) {
    var _stack$map;
    var stack = (0, (/*@__PURE__*/$parcel$interopDefault($lxu1t)))(labelStack !== null && labelStack !== void 0 ? labelStack : []);
    if (name) stack.push({
        name: name
    });
    return (_stack$map = stack.map(function(l) {
        return l.name;
    })) === null || _stack$map === void 0 ? void 0 : _stack$map.join("/");
}
function $19eb315acfe824c7$var$labelStackToIdString(labelStack) {
    var _labelStack$map;
    return labelStack === null || labelStack === void 0 || (_labelStack$map = labelStack.map(function(l) {
        return "segmentId" in l ? "".concat(l.name, ":").concat(l.segmentId) : "".concat(l.name);
    })) === null || _labelStack$map === void 0 ? void 0 : _labelStack$map.join("/");
}
function $19eb315acfe824c7$var$addSegmentObserver(observer) {
    $19eb315acfe824c7$var$segmentObservers.push(observer);
    var _iterator = $19eb315acfe824c7$var$_createForOfIteratorHelper($19eb315acfe824c7$var$segmentCache.values()), _step;
    try {
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var segmentInfo = _step.value;
            observer.onAdd(segmentInfo);
        }
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
}
function $19eb315acfe824c7$var$removeSegmentObserver(observer) {
    var index = $19eb315acfe824c7$var$segmentObservers.findIndex(function(obs) {
        return obs === observer;
    });
    if (index !== -1) $19eb315acfe824c7$var$segmentObservers.splice(index, 1);
}
function $19eb315acfe824c7$export$cd7f480d6b8286c3(interactionId) {
    (0, $91opC.default).delete(interactionId);
}
function $19eb315acfe824c7$export$f6f1cf5bedf83c71(ufoName) {
    var routeName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ufoName;
    var interaction = $19eb315acfe824c7$export$2b3954d2e8509985();
    if (!interaction || interaction.type !== "page_load" && interaction.type !== "transition") return;
    interaction.ufoName = ufoName;
    interaction.routeName = routeName;
}
function $19eb315acfe824c7$export$12f2b6cb85d59904(interactionId, data) {
    var interaction = (0, $91opC.default).get(interactionId);
    if (interaction != null) Object.keys(data).forEach(function(key) {
        interaction.metaData[key] = data[key];
    });
}
function $19eb315acfe824c7$export$e4380431c2bdabee(interactionId, labelStack, data) {
    var interaction = (0, $91opC.default).get(interactionId);
    if (interaction != null) Object.keys(data).forEach(function(i) {
        interaction.customData.push({
            labelStack: labelStack,
            data: (0, (/*@__PURE__*/$parcel$interopDefault($5yl5q)))({}, i, data[i])
        });
    });
}
function $19eb315acfe824c7$export$27cacb7d7f3fe20a(interactionId, labelStack, data) {
    var interaction = (0, $91opC.default).get(interactionId);
    if (interaction != null) {
        interaction.customTimings.push({
            labelStack: labelStack,
            data: data
        });
        if ($19eb315acfe824c7$var$isPerformanceTracingEnabled()) for(var _i = 0, _Object$entries = Object.entries(data); _i < _Object$entries.length; _i++){
            var _Object$entries$_i = (0, (/*@__PURE__*/$parcel$interopDefault($9mn8h)))(_Object$entries[_i], 2), key = _Object$entries$_i[0], timingData = _Object$entries$_i[1];
            var startTime = timingData.startTime, endTime = timingData.endTime;
            try {
                // for Firefox 102 and older
                performance.measure("\uD83D\uDEF8 ".concat($19eb315acfe824c7$var$labelStackToString(labelStack, key), " [custom_timing]"), {
                    start: startTime,
                    end: endTime
                });
            } catch (e) {
            // do nothing
            }
        }
    }
}
function $19eb315acfe824c7$export$728e28c22a0fba4(interactionId, type, name, labelStack) {
    var time = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : performance.now();
    var interaction = (0, $91opC.default).get(interactionId);
    if (interaction != null) interaction.marks.push({
        type: type,
        name: name,
        labelStack: labelStack,
        time: time
    });
    if ($19eb315acfe824c7$var$isPerformanceTracingEnabled()) performance.mark("\uD83D\uDEF8 ".concat($19eb315acfe824c7$var$labelStackToString(labelStack, name), " [").concat(type, "]"), {
        startTime: time
    });
}
function $19eb315acfe824c7$export$c4b23cc624bd2fb(type, name, labelStack) {
    var time = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : performance.now();
    (0, $91opC.default).forEach(function(interaction) {
        interaction.marks.push({
            type: type,
            name: name,
            labelStack: labelStack,
            time: time
        });
    });
    if ($19eb315acfe824c7$var$isPerformanceTracingEnabled()) performance.mark("\uD83D\uDEF8 ".concat($19eb315acfe824c7$var$labelStackToString(labelStack, name), " [").concat(type, "]"), {
        startTime: time
    });
}
function $19eb315acfe824c7$export$2c1d6e17cfa9bbc7(interactionId, type, name, labelStack, start) {
    var end = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : performance.now();
    var size = arguments.length > 6 ? arguments[6] : undefined;
    var interaction = (0, $91opC.default).get(interactionId);
    if (interaction != null) {
        interaction.spans.push({
            type: type,
            name: name,
            labelStack: labelStack,
            start: start,
            end: end,
            size: size
        });
        if ($19eb315acfe824c7$var$isPerformanceTracingEnabled()) try {
            // for Firefox 102 and older
            performance.measure("\uD83D\uDEF8 ".concat($19eb315acfe824c7$var$labelStackToString(labelStack, name), " [").concat(type, "]"), {
                start: start,
                end: end
            });
        } catch (e) {
        // do nothing
        }
    }
}
function $19eb315acfe824c7$export$943a8b2b5d6b1809(type, name, labelStack, start) {
    var end = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : performance.now();
    var size = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;
    (0, $91opC.default).forEach(function(interaction) {
        interaction.spans.push({
            type: type,
            name: name,
            labelStack: labelStack,
            start: start,
            end: end,
            size: size
        });
    });
    if ($19eb315acfe824c7$var$isPerformanceTracingEnabled()) try {
        // for Firefox 102 and older
        performance.measure("\uD83D\uDEF8 ".concat($19eb315acfe824c7$var$labelStackToString(labelStack, name), " [").concat(type, "]"), {
            start: start,
            end: end
        });
    } catch (e) {
    // do nothing
    }
}
function $19eb315acfe824c7$export$9e04fe1a58571ec(moduleId, timestamp) {
    $19eb315acfe824c7$export$c4b23cc624bd2fb("bundle_preload", moduleId, null, timestamp);
}
function $19eb315acfe824c7$export$6f228d1fdc911d7(identifier, start, end) {
    $19eb315acfe824c7$export$943a8b2b5d6b1809("bundle_load", identifier, null, start, end - start);
}
var $19eb315acfe824c7$var$moduleLoadingRequests = {};
function $19eb315acfe824c7$export$f5a8f10de74904da(input) {
    var result = input !== null && input !== void 0 ? input : "";
    result = result.replace(/^\.\/src\/packages\//, "");
    result = result.replace(/^\.\/node_modules\//, "");
    result = result.replace(/(\/src)?\/(index|main)\.(tsx|ts|js|jsx)$/, "");
    return result;
}
function $19eb315acfe824c7$var$addHoldCriterion(id, labelStack, name, startTime) {
    var _window$__CRITERION__;
    if (!((_window$__CRITERION__ = window.__CRITERION__) !== null && _window$__CRITERION__ !== void 0 && _window$__CRITERION__.addUFOHold)) return;
    window.__CRITERION__.addUFOHold(id, $19eb315acfe824c7$var$labelStackToString(labelStack), name, startTime);
}
function $19eb315acfe824c7$var$removeHoldCriterion(id) {
    var _window$__CRITERION__2;
    if (!((_window$__CRITERION__2 = window.__CRITERION__) !== null && _window$__CRITERION__2 !== void 0 && _window$__CRITERION__2.removeUFOHold)) return;
    window.__CRITERION__.removeUFOHold(id);
}
function $19eb315acfe824c7$export$7606887303596f82(interactionId, labelStack, name) {
    var interaction = (0, $91opC.default).get(interactionId);
    var id = (0, $816lv.v4)();
    if (interaction != null) {
        var start = performance.now();
        interaction.holdActive.set(id, {
            labelStack: labelStack,
            name: name,
            start: start
        });
        $19eb315acfe824c7$var$addHoldCriterion(id, labelStack, name, start);
        return function() {
            var end = performance.now();
            if ($19eb315acfe824c7$var$isPerformanceTracingEnabled()) try {
                // for Firefox 102 and older
                performance.measure("\uD83D\uDEF8 ".concat($19eb315acfe824c7$var$labelStackToString(labelStack, name), " [hold]"), {
                    start: start,
                    end: end
                });
            } catch (e) {
            // do nothing
            }
            $19eb315acfe824c7$var$removeHoldCriterion(id);
            var currentInteraction = (0, $91opC.default).get(interactionId);
            var currentHold = interaction.holdActive.get(id);
            if (currentInteraction != null && currentHold != null) {
                currentInteraction.holdInfo.push($19eb315acfe824c7$var$_objectSpread($19eb315acfe824c7$var$_objectSpread({}, currentHold), {}, {
                    end: end
                }));
                interaction.holdActive.delete(id);
            }
        };
    }
    return function() {};
}
function $19eb315acfe824c7$export$10582acd678c213(interactionId, labelStack, name, id, ignoreOnSubmit) {
    var interaction = (0, $91opC.default).get(interactionId);
    if (interaction != null) {
        var start = performance.now();
        interaction.holdActive.set(id, {
            labelStack: labelStack,
            name: name,
            start: start,
            ignoreOnSubmit: ignoreOnSubmit
        });
        $19eb315acfe824c7$var$addHoldCriterion(id, labelStack, name, start);
    }
    return function() {};
}
function $19eb315acfe824c7$export$4983dfbbb996f7ae(interactionId, id) {
    var interaction = (0, $91opC.default).get(interactionId);
    if (interaction != null) {
        var end = performance.now();
        var currentInteraction = (0, $91opC.default).get(interactionId);
        var currentHold = interaction.holdActive.get(id);
        if (currentInteraction != null && currentHold != null) {
            currentInteraction.holdInfo.push($19eb315acfe824c7$var$_objectSpread($19eb315acfe824c7$var$_objectSpread({}, currentHold), {}, {
                end: end
            }));
            interaction.holdActive.delete(id);
            $19eb315acfe824c7$var$removeHoldCriterion(id);
        }
    }
}
function $19eb315acfe824c7$export$2df109852219d16e(interactionId) {
    var interaction = (0, $91opC.default).get(interactionId);
    if (interaction) return interaction.type;
    return null;
}
var $19eb315acfe824c7$export$9591b52b33ccc510 = {
    onPreload: function onPreload(moduleId, _priority) {
        $19eb315acfe824c7$export$9e04fe1a58571ec($19eb315acfe824c7$export$f5a8f10de74904da(moduleId), performance.now());
    },
    onLoadStart: function onLoadStart(info) {
        var timeoutId = setTimeout(function() {
            delete $19eb315acfe824c7$var$moduleLoadingRequests[info.identifier];
        }, 30000);
        var request = {
            start: performance.now(),
            timeoutId: timeoutId
        };
        $19eb315acfe824c7$var$moduleLoadingRequests[info.identifier] = request;
    },
    onLoadComplete: function onLoadComplete(info) {
        var request = $19eb315acfe824c7$var$moduleLoadingRequests[info.identifier];
        if (request) {
            clearTimeout(request.timeoutId);
            delete $19eb315acfe824c7$var$moduleLoadingRequests[info.identifier];
            $19eb315acfe824c7$export$6f228d1fdc911d7($19eb315acfe824c7$export$f5a8f10de74904da(info.identifier), request.start, performance.now());
        }
    },
    placeholderFallBackMounted: function placeholderFallBackMounted(id, moduleId) {
        var interactionId = (0, $e4sM6.getInteractionId)();
        var currentInteractionId = interactionId.current;
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        $19eb315acfe824c7$export$10582acd678c213(currentInteractionId, [], moduleId, id);
    },
    placeholderFallBackUnmounted: function placeholderFallBackUnmounted(id) {
        var interactionId = (0, $e4sM6.getInteractionId)();
        var currentInteractionId = interactionId.current;
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        $19eb315acfe824c7$export$4983dfbbb996f7ae(currentInteractionId, id);
    }
};
function $19eb315acfe824c7$export$239c33984d9b1367(interactionId, name, labelStack, errorType, errorMessage, errorStack, forcedError) {
    var interaction = (0, $91opC.default).get(interactionId);
    if (interaction != null) interaction.errors.push({
        name: name,
        labelStack: labelStack,
        errorType: errorType,
        errorMessage: errorMessage,
        errorStack: errorStack,
        forcedError: forcedError
    });
}
function $19eb315acfe824c7$export$7379c15afd3840fa(name, labelStack, errorType, errorMessage, errorStack) {
    (0, $91opC.default).forEach(function(interaction) {
        interaction.errors.push({
            name: name,
            labelStack: labelStack,
            errorType: errorType,
            errorMessage: errorMessage,
            errorStack: errorStack
        });
    });
}
var $19eb315acfe824c7$export$53d6f611de951a13 = function addProfilerTimings(interactionId, labelStack, type, actualDuration, baseDuration, startTime, commitTime) {
    var _getConfig2;
    if ($19eb315acfe824c7$var$isPerformanceTracingEnabled()) try {
        // for Firefox 102 and older
        performance.measure("\uD83D\uDEF8 ".concat($19eb315acfe824c7$var$labelStackToString(labelStack), " [react-profiler] ").concat(type), {
            start: startTime,
            duration: actualDuration
        });
    } catch (e) {
    // do nothing
    }
    var interaction = (0, $91opC.default).get(interactionId);
    if (interaction != null) interaction.reactProfilerTimings.push({
        labelStack: labelStack,
        type: type,
        actualDuration: actualDuration,
        baseDuration: baseDuration,
        startTime: startTime,
        commitTime: commitTime
    });
    else if ((_getConfig2 = (0, $j1psf.getConfig)()) !== null && _getConfig2 !== void 0 && (_getConfig2 = _getConfig2.postInteractionLog) !== null && _getConfig2 !== void 0 && _getConfig2.enabled) $19eb315acfe824c7$export$d8f52e8f804021e8.addProfilerTimings(labelStack, type, actualDuration, baseDuration, startTime, commitTime);
};
var $19eb315acfe824c7$var$pushToQueue = function pushToQueue(id, data) {
    $19eb315acfe824c7$var$interactionQueue.push({
        id: id,
        data: data
    });
};
var $19eb315acfe824c7$var$handleInteraction = $19eb315acfe824c7$var$pushToQueue;
function $19eb315acfe824c7$var$callCleanUpCallbacks(interaction) {
    interaction.cleanupCallbacks.reverse().forEach(function(cleanUpCallback) {
        cleanUpCallback();
    });
}
var $19eb315acfe824c7$var$finishInteraction = function finishInteraction(id, data) {
    var _getConfig3;
    var endTime = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : performance.now();
    // eslint-disable-next-line no-param-reassign
    data.end = endTime;
    try {
        // for Firefox 102 and older
        performance.measure("\uD83D\uDEF8 [".concat(data.type, "] ").concat(data.ufoName, " [ttai]"), {
            start: data.start,
            end: data.end
        });
    } catch (e) {
    // do nothing
    }
    if (data.featureFlags) // eslint-disable-next-line no-param-reassign
    data.featureFlags.during = Object.fromEntries((0, $f6Lit.currentFeatureFlagsAccessed));
    (0, $k7hWa.clearActiveTrace)();
    $19eb315acfe824c7$var$callCleanUpCallbacks(data);
    if ((_getConfig3 = (0, $j1psf.getConfig)()) !== null && _getConfig3 !== void 0 && (_getConfig3 = _getConfig3.vc) !== null && _getConfig3 !== void 0 && _getConfig3.stopVCAtInteractionFinish) data.vc = (0, $5dLtD.getVCObserver)().getVCRawData();
    $19eb315acfe824c7$export$cd7f480d6b8286c3(id);
    $19eb315acfe824c7$var$PreviousInteractionLog.name = data.ufoName || "unknown";
    $19eb315acfe824c7$var$PreviousInteractionLog.isAborted = data.abortReason != null;
    if (data.ufoName) $19eb315acfe824c7$var$handleInteraction(id, data);
    if ($19eb315acfe824c7$var$isPerformanceTracingEnabled()) {
        var profilerTimingMap = new Map();
        data.reactProfilerTimings.forEach(function(profilerTiming) {
            var labelStackId = $19eb315acfe824c7$var$labelStackToIdString(profilerTiming.labelStack);
            if (labelStackId) {
                var _profilerTimingMap$ge, _timing$start, _timing$end;
                var timing = (_profilerTimingMap$ge = profilerTimingMap.get(labelStackId)) !== null && _profilerTimingMap$ge !== void 0 ? _profilerTimingMap$ge : {
                    labelStack: profilerTiming.labelStack
                };
                timing.start = profilerTiming.startTime < ((_timing$start = timing.start) !== null && _timing$start !== void 0 ? _timing$start : Number.MAX_SAFE_INTEGER) ? profilerTiming.startTime : timing.start;
                timing.end = profilerTiming.commitTime > ((_timing$end = timing.end) !== null && _timing$end !== void 0 ? _timing$end : Number.MIN_SAFE_INTEGER) ? profilerTiming.commitTime : timing.end;
                profilerTimingMap.set(labelStackId, timing);
            }
        });
        try {
            // for Firefox 102 and older
            var _iterator2 = $19eb315acfe824c7$var$_createForOfIteratorHelper(profilerTimingMap.entries()), _step2;
            try {
                for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                    var _step2$value = (0, (/*@__PURE__*/$parcel$interopDefault($9mn8h)))(_step2.value, 2), _step2$value$ = _step2$value[1], labelStack = _step2$value$.labelStack, start = _step2$value$.start, end = _step2$value$.end;
                    performance.measure("\uD83D\uDEF8 ".concat($19eb315acfe824c7$var$labelStackToString(labelStack), " [segment_ttai]"), {
                        start: start,
                        end: end
                    });
                }
            } catch (err) {
                _iterator2.e(err);
            } finally{
                _iterator2.f();
            }
        } catch (e) {
        // do nothing
        }
    }
    try {
        // dispatch a global window event to notify the measure is completed
        window.dispatchEvent(new CustomEvent("UFO_FINISH_INTERACTION", {
            detail: data
        }));
    } catch (error) {
    // do nothing
    }
};
var $19eb315acfe824c7$export$9e614a29a1ac213e = function sinkInteractionHandler(sinkFn) {
    if ($19eb315acfe824c7$var$handleInteraction === $19eb315acfe824c7$var$pushToQueue) {
        $19eb315acfe824c7$var$handleInteraction = sinkFn;
        $19eb315acfe824c7$var$interactionQueue.forEach(function(interaction) {
            sinkFn(interaction.id, interaction.data);
        });
        $19eb315acfe824c7$var$interactionQueue.length = 0;
    }
};
var $19eb315acfe824c7$export$8a1ba7bef607358a = function sinkPostInteractionLogHandler(sinkFn) {
    $19eb315acfe824c7$export$d8f52e8f804021e8.sinkHandler(sinkFn);
};
function $19eb315acfe824c7$export$673be905888f8839(interactionId, endTime) {
    var interaction = (0, $91opC.default).get(interactionId);
    if (interaction != null) {
        var noMoreHolds = interaction.holdActive.size === 0;
        if (noMoreHolds) {
            var _getConfig4;
            $19eb315acfe824c7$var$finishInteraction(interactionId, interaction, endTime);
            if ((_getConfig4 = (0, $j1psf.getConfig)()) !== null && _getConfig4 !== void 0 && (_getConfig4 = _getConfig4.postInteractionLog) !== null && _getConfig4 !== void 0 && _getConfig4.enabled) $19eb315acfe824c7$export$d8f52e8f804021e8.onInteractionComplete(interaction);
        }
    }
}
function $19eb315acfe824c7$var$callCancelCallbacks(interaction) {
    interaction.cancelCallbacks.reverse().forEach(function(cancelCallback) {
        cancelCallback();
    });
}
function $19eb315acfe824c7$export$5def58af4fd46132(interactionId, abortReason) {
    var interaction = (0, $91opC.default).get(interactionId);
    if (interaction != null) {
        $19eb315acfe824c7$var$callCancelCallbacks(interaction);
        interaction.abortReason = abortReason;
        $19eb315acfe824c7$var$finishInteraction(interactionId, interaction);
    }
}
function $19eb315acfe824c7$export$c4a545284f55edf2(interactionId, interactionName) {
    var interaction = (0, $91opC.default).get(interactionId);
    if (interaction != null) {
        $19eb315acfe824c7$var$callCancelCallbacks(interaction);
        interaction.abortReason = "new_interaction";
        interaction.abortedByInteractionName = interactionName;
        $19eb315acfe824c7$var$finishInteraction(interactionId, interaction);
    }
}
function $19eb315acfe824c7$export$614a7af2affc5dff(abortReason, abortedByInteractionName) {
    (0, $91opC.default).forEach(function(interaction, interactionId) {
        var noMoreHolds = interaction.holdActive.size === 0;
        if (!noMoreHolds) {
            $19eb315acfe824c7$var$callCancelCallbacks(interaction);
            // eslint-disable-next-line no-param-reassign
            interaction.abortReason = abortReason;
            if (abortedByInteractionName != null) // eslint-disable-next-line no-param-reassign
            interaction.abortedByInteractionName = abortedByInteractionName;
        }
        $19eb315acfe824c7$var$finishInteraction(interactionId, interaction);
    });
}
function $19eb315acfe824c7$export$7b9261a96cfe427b(id, cancelCallback) {
    var interaction = (0, $91opC.default).get(id);
    interaction === null || interaction === void 0 || interaction.cancelCallbacks.push(cancelCallback);
}
function $19eb315acfe824c7$export$1a1ed1e1fdb2006b(interactionId, ufoName, type, startTime, rate, labelStack, routeName) {
    var _getConfig5;
    var trace = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : null;
    if ((_getConfig5 = (0, $j1psf.getConfig)()) !== null && _getConfig5 !== void 0 && (_getConfig5 = _getConfig5.postInteractionLog) !== null && _getConfig5 !== void 0 && _getConfig5.enabled) $19eb315acfe824c7$export$d8f52e8f804021e8.reset();
    var previousTime = startTime;
    var timeoutTime = $19eb315acfe824c7$var$CLEANUP_TIMEOUT;
    var timerID = setTimeout(function() {
        $19eb315acfe824c7$export$5def58af4fd46132(interactionId, "timeout");
    }, $19eb315acfe824c7$var$CLEANUP_TIMEOUT);
    function changeTimeout(newTime) {
        // we compare if the time left is lower than the new time to no
        // extend the timeout beyond the initial waiting time
        var currentTime = performance.now();
        var timeLeft = timeoutTime - (currentTime - previousTime);
        if (timeLeft < newTime) return;
        clearTimeout(this.timerID);
        var newTimerID = setTimeout(function() {
            $19eb315acfe824c7$export$5def58af4fd46132(interactionId, "timeout");
        }, newTime);
        timeoutTime = newTime;
        previousTime = currentTime;
        this.timerID = newTimerID;
    }
    var addFeatureFlagsToInteraction = (0, $l1yK8.default)((0, $j1psf.getCapabilityRate)("feature_flag_access"));
    var metrics = {
        id: interactionId,
        start: startTime,
        end: 0,
        ufoName: ufoName,
        type: type,
        previousInteractionName: $19eb315acfe824c7$var$PreviousInteractionLog.name,
        isPreviousInteractionAborted: $19eb315acfe824c7$var$PreviousInteractionLog.isAborted === true,
        marks: [],
        customData: [],
        customTimings: [],
        spans: [],
        requestInfo: [],
        reactProfilerTimings: [],
        holdInfo: [],
        holdActive: new Map(),
        // measure when we execute this code
        // from this we can measure the input delay -
        // how long the browser took to hand execution back to JS)
        measureStart: performance.now(),
        rate: rate,
        cancelCallbacks: [],
        metaData: {},
        errors: [],
        apdex: [],
        labelStack: labelStack,
        routeName: routeName !== null && routeName !== void 0 ? routeName : ufoName,
        featureFlags: addFeatureFlagsToInteraction ? {
            prior: Object.fromEntries((0, $f6Lit.allFeatureFlagsAccessed)),
            during: {}
        } : undefined,
        knownSegments: [],
        cleanupCallbacks: [],
        awaitReactProfilerCount: 0,
        redirects: [],
        timerID: timerID,
        changeTimeout: changeTimeout,
        trace: trace
    };
    if (addFeatureFlagsToInteraction) (0, $f6Lit.currentFeatureFlagsAccessed).clear();
    (0, $91opC.default).set(interactionId, metrics);
    var segmentObserver = {
        onAdd: function onAdd(segment) {
            metrics.knownSegments.push(segment);
        },
        onRemove: function onRemove() {}
    };
    $19eb315acfe824c7$var$addSegmentObserver(segmentObserver);
    metrics.cleanupCallbacks.push(function() {
        $19eb315acfe824c7$var$removeSegmentObserver(segmentObserver);
    });
    metrics.cleanupCallbacks.push(function() {
        clearTimeout(metrics.timerID);
    });
    var awaitBM3TTIList = (0, $j1psf.getAwaitBM3TTIList)();
    if (awaitBM3TTIList.includes(ufoName)) $19eb315acfe824c7$export$10582acd678c213(interactionId, [], ufoName, ufoName, true);
    if (type === "transition") {
        (0, $5dLtD.getVCObserver)().start({
            startTime: startTime
        });
        $19eb315acfe824c7$export$d8f52e8f804021e8.startVCObserver({
            startTime: startTime
        });
    }
}
function $19eb315acfe824c7$export$4a759336b50e86e3(event) {
    var interaction = $19eb315acfe824c7$export$2b3954d2e8509985();
    if (interaction) {
        var _event$config;
        interaction.legacyMetrics = interaction.legacyMetrics || [];
        interaction.legacyMetrics.push(event);
        if ((interaction.type === "page_load" || interaction.type === "transition") && ((_event$config = event.config) === null || _event$config === void 0 ? void 0 : _event$config.type) === "PAGE_LOAD") {
            interaction.changeTimeout($19eb315acfe824c7$var$CLEANUP_TIMEOUT_AFTER_APDEX);
            $19eb315acfe824c7$export$4983dfbbb996f7ae(interaction.id, interaction.ufoName);
        }
    }
}
function $19eb315acfe824c7$export$ad216cc25852d44b(apdex) {
    (0, $91opC.default).forEach(function(interaction, key) {
        interaction.apdex.push(apdex);
        try {
            var _apdex$startTime;
            // for Firefox 102 and older
            performance.measure("\uD83D\uDEF8 ".concat(apdex.key, " [bm3_tti]"), {
                start: (_apdex$startTime = apdex.startTime) !== null && _apdex$startTime !== void 0 ? _apdex$startTime : interaction.start,
                end: apdex.stopTime
            });
        } catch (e) {
        // do nothing
        }
        if (interaction.type === "page_load" || interaction.type === "transition") {
            interaction.changeTimeout($19eb315acfe824c7$var$CLEANUP_TIMEOUT_AFTER_APDEX);
            $19eb315acfe824c7$export$4983dfbbb996f7ae(key, interaction.ufoName);
        }
    });
}
function $19eb315acfe824c7$export$35220fd6cdd1b731(interactionId, apdexInfo) {
    var interaction = (0, $91opC.default).get(interactionId);
    if (interaction != null) {
        interaction.apdex.push(apdexInfo);
        try {
            var _apdexInfo$startTime;
            // for Firefox 102 and older
            performance.measure("\uD83D\uDEF8 ".concat(apdexInfo.key, " [bm3_tti]"), {
                start: (_apdexInfo$startTime = apdexInfo.startTime) !== null && _apdexInfo$startTime !== void 0 ? _apdexInfo$startTime : interaction.start,
                end: apdexInfo.stopTime
            });
        } catch (e) {
        // do nothing
        }
        if (interaction.type === "page_load" || interaction.type === "transition") {
            interaction.changeTimeout($19eb315acfe824c7$var$CLEANUP_TIMEOUT_AFTER_APDEX);
            $19eb315acfe824c7$export$4983dfbbb996f7ae(interactionId, interaction.ufoName);
        }
    }
}
function $19eb315acfe824c7$export$57d55b4569823d8f(interactionId, labelStack, requestInfo) {
    var interaction = (0, $91opC.default).get(interactionId);
    if (interaction != null) interaction.requestInfo.push($19eb315acfe824c7$var$_objectSpread({
        labelStack: labelStack
    }, requestInfo));
}
function $19eb315acfe824c7$var$isSegmentLabel(obj) {
    return obj && typeof obj.name === "string" && typeof obj.segmentId === "string";
}
function $19eb315acfe824c7$var$getSegmentCacheKey(labelStack) {
    return labelStack.map(function(l) {
        if ($19eb315acfe824c7$var$isSegmentLabel(l)) return "".concat(l.name, "_").concat(l.segmentId);
        return l.name;
    }).join("|");
}
function $19eb315acfe824c7$export$1c43f9ac826b6462(labelStack) {
    var key = $19eb315acfe824c7$var$getSegmentCacheKey(labelStack);
    var existingSegment = $19eb315acfe824c7$var$segmentCache.get(key);
    if (!existingSegment) {
        var segmentInfo = {
            labelStack: labelStack
        };
        $19eb315acfe824c7$var$segmentCache.set(key, segmentInfo);
        $19eb315acfe824c7$var$segmentObservers.forEach(function(observer) {
            observer.onAdd(segmentInfo);
        });
    }
}
function $19eb315acfe824c7$export$d0365e48b58231c3(labelStack) {
    var key = $19eb315acfe824c7$var$getSegmentCacheKey(labelStack);
    var segmentInfo = $19eb315acfe824c7$var$segmentCache.get(key);
    if (segmentInfo) {
        $19eb315acfe824c7$var$segmentCache.delete(JSON.stringify(labelStack));
        $19eb315acfe824c7$var$segmentObservers.forEach(function(observer) {
            observer.onRemove(segmentInfo);
        });
    }
}
function $19eb315acfe824c7$export$bbf14d79614d9818(interactionId, fromUfoName, nextUfoName, nextRouteName, time) {
    var interaction = (0, $91opC.default).get(interactionId);
    if (interaction != null) {
        interaction.ufoName = nextUfoName;
        interaction.routeName = nextRouteName;
        interaction.redirects.push({
            fromInteractionName: fromUfoName,
            time: time
        });
        if ($19eb315acfe824c7$var$isPerformanceTracingEnabled()) {
            var prevRedirect = interaction.redirects.at(-2);
            try {
                var _prevRedirect$time;
                // for Firefox 102 and older
                performance.measure("\uD83D\uDEF8 ".concat(nextUfoName, " [redirect]"), {
                    start: (_prevRedirect$time = prevRedirect === null || prevRedirect === void 0 ? void 0 : prevRedirect.time) !== null && _prevRedirect$time !== void 0 ? _prevRedirect$time : interaction.start,
                    end: time
                });
            } catch (e) {
            // do nothing
            }
        }
    }
}
var $19eb315acfe824c7$export$6ce04c7ca6810a7e = [];
var $19eb315acfe824c7$var$defaultLabelStack = [
    {
        name: "custom"
    }
];
function $19eb315acfe824c7$export$5342dcad19138a1c(name, start) {
    var end = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : performance.now();
    var size = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
    var labelStack = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : $19eb315acfe824c7$var$defaultLabelStack;
    var customSpan = {
        type: "custom",
        name: name,
        start: start,
        end: end,
        labelStack: labelStack,
        size: size
    };
    $19eb315acfe824c7$export$6ce04c7ca6810a7e.push(customSpan);
}

});
parcelRegister("9mn8h", function(module, exports) {

var $29E19 = parcelRequire("29E19");

var $eDwHv = parcelRequire("eDwHv");

var $fnW2a = parcelRequire("fnW2a");

var $egg6m = parcelRequire("egg6m");
function $6d081cc9326462e0$var$_slicedToArray(r, e) {
    return $29E19(r) || $eDwHv(r, e) || $fnW2a(r, e) || $egg6m();
}
module.exports = $6d081cc9326462e0$var$_slicedToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("29E19", function(module, exports) {
function $191b76b5a73612cc$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
module.exports = $191b76b5a73612cc$var$_arrayWithHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("eDwHv", function(module, exports) {
function $aa7e12de456a27f4$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
module.exports = $aa7e12de456a27f4$var$_iterableToArrayLimit, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("fnW2a", function(module, exports) {

var $aRoWj = parcelRequire("aRoWj");
function $b3360556585e6ec1$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $aRoWj(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $aRoWj(r, a) : void 0;
    }
}
module.exports = $b3360556585e6ec1$var$_unsupportedIterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("aRoWj", function(module, exports) {
function $7e82331423d44848$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
module.exports = $7e82331423d44848$var$_arrayLikeToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("egg6m", function(module, exports) {
function $a61f0cc3bde1fd3e$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
module.exports = $a61f0cc3bde1fd3e$var$_nonIterableRest, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("5yl5q", function(module, exports) {

var $cvE54 = parcelRequire("cvE54");
function $40b07c0b32d14690$var$_defineProperty(e, r, t) {
    return (r = $cvE54(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
module.exports = $40b07c0b32d14690$var$_defineProperty, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("cvE54", function(module, exports) {

var $jsTe9 = parcelRequire("jsTe9");
var $91b77883c13524a3$var$_typeof = $jsTe9.default;

var $b7MFC = parcelRequire("b7MFC");
function $91b77883c13524a3$var$toPropertyKey(t) {
    var i = $b7MFC(t, "string");
    return "symbol" == $91b77883c13524a3$var$_typeof(i) ? i : i + "";
}
module.exports = $91b77883c13524a3$var$toPropertyKey, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("jsTe9", function(module, exports) {
function $e2bb78d0d075319c$var$_typeof(o) {
    "@babel/helpers - typeof";
    return module.exports = $e2bb78d0d075319c$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $e2bb78d0d075319c$var$_typeof(o);
}
module.exports = $e2bb78d0d075319c$var$_typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("b7MFC", function(module, exports) {

var $jsTe9 = parcelRequire("jsTe9");
var $81961a13f32afd76$var$_typeof = $jsTe9.default;
function $81961a13f32afd76$var$toPrimitive(t, r) {
    if ("object" != $81961a13f32afd76$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $81961a13f32afd76$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
module.exports = $81961a13f32afd76$var$toPrimitive, module.exports.__esModule = true, module.exports["default"] = module.exports;

});



parcelRegister("lxu1t", function(module, exports) {

var $aBsYk = parcelRequire("aBsYk");

var $i7fQE = parcelRequire("i7fQE");

var $fnW2a = parcelRequire("fnW2a");

var $fZ1TK = parcelRequire("fZ1TK");
function $fae3f7ef684b9bf0$var$_toConsumableArray(r) {
    return $aBsYk(r) || $i7fQE(r) || $fnW2a(r) || $fZ1TK();
}
module.exports = $fae3f7ef684b9bf0$var$_toConsumableArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("aBsYk", function(module, exports) {

var $aRoWj = parcelRequire("aRoWj");
function $7b83d5500b7d4897$var$_arrayWithoutHoles(r) {
    if (Array.isArray(r)) return $aRoWj(r);
}
module.exports = $7b83d5500b7d4897$var$_arrayWithoutHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("i7fQE", function(module, exports) {
function $d3052c91ae5cd33f$var$_iterableToArray(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
module.exports = $d3052c91ae5cd33f$var$_iterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("fZ1TK", function(module, exports) {
function $ba2e067566e7f661$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
module.exports = $ba2e067566e7f661$var$_nonIterableSpread, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("816lv", function(module, exports) {

var $fELlv = parcelRequire("fELlv");

var $dNSPy = parcelRequire("dNSPy");
var $5d6356e699a969c7$var$uuid = $dNSPy;
$5d6356e699a969c7$var$uuid.v1 = $fELlv;
$5d6356e699a969c7$var$uuid.v4 = $dNSPy;
module.exports = $5d6356e699a969c7$var$uuid;

});
parcelRegister("fELlv", function(module, exports) {

var $5egaI = parcelRequire("5egaI");

var $oykgN = parcelRequire("oykgN");
// **`v1()` - Generate time-based UUID**
//
// Inspired by https://github.com/LiosK/UUID.js
// and http://docs.python.org/library/uuid.html
var $b65f515eb13355b4$var$_nodeId;
var $b65f515eb13355b4$var$_clockseq;
// Previous uuid creation time
var $b65f515eb13355b4$var$_lastMSecs = 0;
var $b65f515eb13355b4$var$_lastNSecs = 0;
// See https://github.com/uuidjs/uuid for API details
function $b65f515eb13355b4$var$v1(options, buf, offset) {
    var i = buf && offset || 0;
    var b = buf || [];
    options = options || {};
    var node = options.node || $b65f515eb13355b4$var$_nodeId;
    var clockseq = options.clockseq !== undefined ? options.clockseq : $b65f515eb13355b4$var$_clockseq;
    // node and clockseq need to be initialized to random values if they're not
    // specified.  We do this lazily to minimize issues related to insufficient
    // system entropy.  See #189
    if (node == null || clockseq == null) {
        var seedBytes = $5egaI();
        if (node == null) // Per 4.5, create and 48-bit node id, (47 random bits + multicast bit = 1)
        node = $b65f515eb13355b4$var$_nodeId = [
            seedBytes[0] | 0x01,
            seedBytes[1],
            seedBytes[2],
            seedBytes[3],
            seedBytes[4],
            seedBytes[5]
        ];
        if (clockseq == null) // Per 4.2.2, randomize (14 bit) clockseq
        clockseq = $b65f515eb13355b4$var$_clockseq = (seedBytes[6] << 8 | seedBytes[7]) & 0x3fff;
    }
    // UUID timestamps are 100 nano-second units since the Gregorian epoch,
    // (1582-10-15 00:00).  JSNumbers aren't precise enough for this, so
    // time is handled internally as 'msecs' (integer milliseconds) and 'nsecs'
    // (100-nanoseconds offset from msecs) since unix epoch, 1970-01-01 00:00.
    var msecs = options.msecs !== undefined ? options.msecs : new Date().getTime();
    // Per 4.2.1.2, use count of uuid's generated during the current clock
    // cycle to simulate higher resolution clock
    var nsecs = options.nsecs !== undefined ? options.nsecs : $b65f515eb13355b4$var$_lastNSecs + 1;
    // Time since last uuid creation (in msecs)
    var dt = msecs - $b65f515eb13355b4$var$_lastMSecs + (nsecs - $b65f515eb13355b4$var$_lastNSecs) / 10000;
    // Per 4.2.1.2, Bump clockseq on clock regression
    if (dt < 0 && options.clockseq === undefined) clockseq = clockseq + 1 & 0x3fff;
    // Reset nsecs if clock regresses (new clockseq) or we've moved onto a new
    // time interval
    if ((dt < 0 || msecs > $b65f515eb13355b4$var$_lastMSecs) && options.nsecs === undefined) nsecs = 0;
    // Per 4.2.1.2 Throw error if too many uuids are requested
    if (nsecs >= 10000) throw new Error("uuid.v1(): Can't create more than 10M uuids/sec");
    $b65f515eb13355b4$var$_lastMSecs = msecs;
    $b65f515eb13355b4$var$_lastNSecs = nsecs;
    $b65f515eb13355b4$var$_clockseq = clockseq;
    // Per 4.1.4 - Convert from unix epoch to Gregorian epoch
    msecs += 12219292800000;
    // `time_low`
    var tl = ((msecs & 0xfffffff) * 10000 + nsecs) % 0x100000000;
    b[i++] = tl >>> 24 & 0xff;
    b[i++] = tl >>> 16 & 0xff;
    b[i++] = tl >>> 8 & 0xff;
    b[i++] = tl & 0xff;
    // `time_mid`
    var tmh = msecs / 0x100000000 * 10000 & 0xfffffff;
    b[i++] = tmh >>> 8 & 0xff;
    b[i++] = tmh & 0xff;
    // `time_high_and_version`
    b[i++] = tmh >>> 24 & 0xf | 0x10; // include version
    b[i++] = tmh >>> 16 & 0xff;
    // `clock_seq_hi_and_reserved` (Per 4.2.2 - include variant)
    b[i++] = clockseq >>> 8 | 0x80;
    // `clock_seq_low`
    b[i++] = clockseq & 0xff;
    // `node`
    for(var n = 0; n < 6; ++n)b[i + n] = node[n];
    return buf ? buf : $oykgN(b);
}
module.exports = $b65f515eb13355b4$var$v1;

});


parcelRegister("l1yK8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f4e4a43d642c19a5$export$2e2bcd8739ae039; });
/**
 * A random function that passes one in rate times.
 * E.g. coinflip(2) is the same as if you flipped a coin.
 * It will pass 50% of the time
 * @param rate The change that it will pass (1 in <rate> times)
 * @returns bool, if it passes or not
 */ function $f4e4a43d642c19a5$export$2e2bcd8739ae039(rate) {
    if (rate === 0) return false;
    else if (rate === 1) return true;
    else return Math.random() * rate <= 1;
}

});

parcelRegister("j1psf", function(module, exports) {

$parcel$export(module.exports, "getConfig", function () { return $dd91db0ca60704ba$export$44487a86467333c3; });
$parcel$export(module.exports, "getCapabilityRate", function () { return $dd91db0ca60704ba$export$29b9ffb14861a1d; });
$parcel$export(module.exports, "getAwaitBM3TTIList", function () { return $dd91db0ca60704ba$export$2d311b3fd18dcab1; });
var $dd91db0ca60704ba$var$config;
function $dd91db0ca60704ba$export$10d6139a8fb42158(newConfig) {
    $dd91db0ca60704ba$var$config = newConfig;
}
function $dd91db0ca60704ba$export$44487a86467333c3() {
    return $dd91db0ca60704ba$var$config;
}
function $dd91db0ca60704ba$export$9466a8f085fa7d4e(name, interactionKind) {
    try {
        if (!$dd91db0ca60704ba$var$config) return 0;
        var _config = $dd91db0ca60704ba$var$config, killswitch = _config.killswitch, rates = _config.rates, rules = _config.rules, kind = _config.kind, autoGeneratedRate = _config.autoGeneratedRate;
        if (killswitch != null) {
            // Specifically kill certain events
            if (killswitch.includes(name)) return 0;
        }
        if (rates != null) {
            // Decide the rate explicitly
            if (rates[name] != null) return rates[name];
        }
        if (rules != null) for(var i = 0; i < rules.length; i++){
            var rule = rules[i];
            var test = rule.test, rate = rule.rate;
            if (test != null && rate != null) {
                var regexp = new RegExp(test, "ig");
                if (regexp.test(name)) return rate;
            }
        }
        var isAutogenerated = name === null || name === void 0 ? void 0 : name.startsWith("auto-generated");
        if (isAutogenerated) {
            var _rate = autoGeneratedRate;
            if (_rate != null) return _rate;
        }
        if (kind != null) {
            var _rate2 = kind[interactionKind];
            if (_rate2 != null) return _rate2;
        }
        return 0;
    } catch (e) {
        // Fallback
        return 0;
    }
}
function $dd91db0ca60704ba$export$1d459f020c06ae34(name, interactionType) {
    try {
        if (!$dd91db0ca60704ba$var$config) return 0;
        var _config2 = $dd91db0ca60704ba$var$config, postInteractionLog = _config2.postInteractionLog;
        if (!(postInteractionLog !== null && postInteractionLog !== void 0 && postInteractionLog.enabled)) return 0;
        if (postInteractionLog.rates && typeof postInteractionLog.rates[name] === "number") return postInteractionLog.rates[name];
        if (postInteractionLog.kind && typeof postInteractionLog.kind[interactionType] === "number") return postInteractionLog.kind[interactionType];
        return 0;
    } catch (e) {
        return 0;
    }
}
function $dd91db0ca60704ba$export$29b9ffb14861a1d(capability) {
    try {
        if (!$dd91db0ca60704ba$var$config) return 0;
        var _config3 = $dd91db0ca60704ba$var$config, capabilityRate = _config3.capability;
        if (capabilityRate != null) {
            var rate = capabilityRate[capability];
            if (rate != null) return rate;
        }
        return 0;
    } catch (_unused) {
        return 0;
    }
}
var $dd91db0ca60704ba$var$validTypingMethods = [
    "timeout",
    "timeoutNoAlloc",
    "mutationObserver"
];
function $dd91db0ca60704ba$export$7e32aae12bf9b50f() {
    var defaultMethod = "timeout";
    try {
        if (!$dd91db0ca60704ba$var$config) return defaultMethod;
        var _config4 = $dd91db0ca60704ba$var$config, typingMethod = _config4.typingMethod;
        if (typingMethod != null && $dd91db0ca60704ba$var$validTypingMethods.find(function(m) {
            return m === typingMethod;
        })) return typingMethod;
        else return defaultMethod;
    } catch (e) {
        return defaultMethod;
    }
}
function $dd91db0ca60704ba$export$2d311b3fd18dcab1() {
    try {
        if (!$dd91db0ca60704ba$var$config) return [];
        var _config5 = $dd91db0ca60704ba$var$config, awaitBM3TTI = _config5.awaitBM3TTI;
        if (awaitBM3TTI != null) return awaitBM3TTI;
        else return [];
    } catch (e) {
        return [];
    }
}
function $dd91db0ca60704ba$export$e2ea675800536898() {
    try {
        if (!$dd91db0ca60704ba$var$config) return false;
        var _config6 = $dd91db0ca60704ba$var$config, removePageSegmentsUFOPrefixes = _config6.removePageSegmentsUFOPrefixes;
        if (removePageSegmentsUFOPrefixes != null) return removePageSegmentsUFOPrefixes;
        else return false;
    } catch (e) {
        return false;
    }
}
function $dd91db0ca60704ba$export$525ba53ca98e9db() {
    try {
        if (!$dd91db0ca60704ba$var$config) return false;
        var _config7 = $dd91db0ca60704ba$var$config, removeInteractionsUFOPrefixes = _config7.removeInteractionsUFOPrefixes;
        if (removeInteractionsUFOPrefixes != null) return removeInteractionsUFOPrefixes;
        else return false;
    } catch (e) {
        return false;
    }
}
function $dd91db0ca60704ba$export$4f4649ef27b6f5d6() {
    try {
        if (!$dd91db0ca60704ba$var$config) return undefined;
        var _config8 = $dd91db0ca60704ba$var$config, ufoNameOverrides = _config8.ufoNameOverrides;
        if (ufoNameOverrides != null) return ufoNameOverrides;
        return undefined;
    } catch (e) {
        return undefined;
    }
}
function $dd91db0ca60704ba$export$3c170167645a0eff() {
    try {
        if (!$dd91db0ca60704ba$var$config) return undefined;
        var _config9 = $dd91db0ca60704ba$var$config, doNotAbortActivePressInteraction = _config9.doNotAbortActivePressInteraction;
        return doNotAbortActivePressInteraction;
    } catch (e) {
        return undefined;
    }
}
function $dd91db0ca60704ba$export$d6dc9444bd15f70f() {
    try {
        if (!$dd91db0ca60704ba$var$config) return undefined;
        var _config10 = $dd91db0ca60704ba$var$config, doNotAbortActivePressInteractionOnTransition = _config10.doNotAbortActivePressInteractionOnTransition;
        return doNotAbortActivePressInteractionOnTransition;
    } catch (e) {
        return undefined;
    }
}

});

parcelRegister("k7hWa", function(module, exports) {

$parcel$export(module.exports, "clearActiveTrace", function () { return $ea526004fa4f83e5$export$17ab21d7be720b; });

var $9Cyz1 = parcelRequire("9Cyz1");
var $ea526004fa4f83e5$var$state = {
    context: null
};
var $ea526004fa4f83e5$export$295213bc4d0c54ad = function generateSpanId() {
    return Array.from(new Array(16), function() {
        return Math.floor(Math.random() * 16).toString(16);
    }).join("");
};
var $ea526004fa4f83e5$export$f2e521e495a88544 = function setInteractionActiveTrace(interactionId, experienceType) {
    $ea526004fa4f83e5$export$a1002be327997103(interactionId.replace(/-/g, ""), $ea526004fa4f83e5$export$295213bc4d0c54ad(), experienceType);
};
var $ea526004fa4f83e5$export$a1002be327997103 = function setActiveTrace(traceId, spanId, type) {
    $ea526004fa4f83e5$var$state.context = {
        traceId: traceId,
        spanId: spanId,
        type: type
    };
};
var $ea526004fa4f83e5$export$b6ac780db3a3cc77 = function getActiveTrace() {
    return $ea526004fa4f83e5$var$state.context || undefined;
};
var $ea526004fa4f83e5$export$17ab21d7be720b = function clearActiveTrace() {
    $ea526004fa4f83e5$var$state.context = null;
};
var $ea526004fa4f83e5$export$6e17cce6446848f9 = function getActiveTraceHttpRequestHeaders(_url) {
    if ($ea526004fa4f83e5$var$state.context === null) return null;
    var _state$context = $ea526004fa4f83e5$var$state.context, traceId = _state$context.traceId, spanId = _state$context.spanId;
    return (0, $9Cyz1.makeTraceHttpRequestHeaders)(traceId, spanId);
};

});
parcelRegister("9Cyz1", function(module, exports) {

$parcel$export(module.exports, "makeTraceHttpRequestHeaders", function () { return $701279570ae2a309$export$1115c5277eb10d5e; });
var $701279570ae2a309$export$1115c5277eb10d5e = function makeTraceHttpRequestHeaders(traceId, spanId) {
    return {
        "X-B3-TraceId": traceId,
        "X-B3-SpanId": spanId
    };
};

});


parcelRegister("f6Lit", function(module, exports) {

$parcel$export(module.exports, "allFeatureFlagsAccessed", function () { return $affc1abe748f6e75$export$5b78c989c8db2561; });
$parcel$export(module.exports, "currentFeatureFlagsAccessed", function () { return $affc1abe748f6e75$export$2a5c8df26bb89760; });

var $7purs = parcelRequire("7purs");
var $affc1abe748f6e75$export$5b78c989c8db2561 = new Map();
var $affc1abe748f6e75$export$2a5c8df26bb89760 = new Map();
var $affc1abe748f6e75$export$47fade9662f71000 = function addFeatureFlagAccessed(featureFlagName, featureFlagValue) {
    try {
        // Inform Criterion about FF being accessed
        if (globalThis.__CRITERION__ && typeof globalThis.__CRITERION__.addFeatureFlagAccessed === "function") globalThis.__CRITERION__.addFeatureFlagAccessed(featureFlagName, featureFlagValue);
    } catch (_e) {
    // ignore the criterion error
    }
    var value = (0, $7purs.redactValue)(featureFlagValue);
    $affc1abe748f6e75$export$5b78c989c8db2561.set(featureFlagName, value);
    $affc1abe748f6e75$export$2a5c8df26bb89760.set(featureFlagName, value);
};

});
parcelRegister("7purs", function(module, exports) {

$parcel$export(module.exports, "redactValue", function () { return $56527b55487b3a64$export$fcc03ee4c944962f; });

var $jsTe9 = parcelRequire("jsTe9");

var $iA75q = parcelRequire("iA75q");
var $56527b55487b3a64$var$startsAsObject = function startsAsObject(value) {
    try {
        if (value.charAt(0) === "{") return true;
    } catch (e) {
        return false;
    }
    return false;
};
var $56527b55487b3a64$var$isObject = function isObject(value) {
    return value && (0, (/*@__PURE__*/$parcel$interopDefault($jsTe9)))(value) === "object" && value.constructor === Object;
};
var $56527b55487b3a64$var$isString = function isString(input) {
    var result;
    try {
        result = typeof input === "string" || input instanceof String;
    } catch (err) {
        // swallow any errors
        result = false;
    }
    return result;
};
var $56527b55487b3a64$export$7b4abba432e57989 = function shouldRedactValue(value) {
    return $56527b55487b3a64$var$isString(value) && $56527b55487b3a64$var$startsAsObject(value) || $56527b55487b3a64$var$isObject(value);
};
var $56527b55487b3a64$export$fcc03ee4c944962f = function redactValue(featureFlagValue) {
    return $56527b55487b3a64$export$7b4abba432e57989(featureFlagValue) ? (0, $iA75q.NON_BOOLEAN_VALUE) : featureFlagValue;
};

});
parcelRegister("iA75q", function(module, exports) {

$parcel$export(module.exports, "NON_BOOLEAN_VALUE", function () { return $d871160b54a3d0a8$export$42f4885608027d0c; });
var $d871160b54a3d0a8$export$42f4885608027d0c = "non_boolean";

});



parcelRegister("e4sM6", function(module, exports) {

$parcel$export(module.exports, "getInteractionId", function () { return $a3e7c280e2c8cfed$export$37bca3107733ac1e; });

var $dAx5m = parcelRequire("dAx5m");
var $a3e7c280e2c8cfed$export$3109542b68df9ba1 = {
    current: null
};
var // We use a context to allow modals to have their own lifecycle
$a3e7c280e2c8cfed$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $dAx5m.createContext)($a3e7c280e2c8cfed$export$3109542b68df9ba1);
var $a3e7c280e2c8cfed$export$37bca3107733ac1e = function getInteractionId() {
    return $a3e7c280e2c8cfed$export$3109542b68df9ba1;
};
var $a3e7c280e2c8cfed$export$9f6000531b78127e = function useInteractionId() {
    return $a3e7c280e2c8cfed$export$3109542b68df9ba1;
};

});

parcelRegister("5dLtD", function(module, exports) {

$parcel$export(module.exports, "getVCObserver", function () { return $3cd2fe9482e996b6$export$b3bc47985717b49e; });

var $fxIAZ = parcelRequire("fxIAZ");
var $3cd2fe9482e996b6$export$b3bc47985717b49e = function getVCObserver() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    if (!globalThis.__vcObserver) globalThis.__vcObserver = new (0, $fxIAZ.VCObserver)(opts);
    return globalThis.__vcObserver;
};

});
parcelRegister("fxIAZ", function(module, exports) {

$parcel$export(module.exports, "VCObserver", function () { return $b50c87d57f455df5$export$1f70d263701b1d01; });

var $3YpK2 = parcelRequire("3YpK2");

var $6KIrE = parcelRequire("6KIrE");

var $5yl5q = parcelRequire("5yl5q");

var $2CTYY = parcelRequire("2CTYY");

var $9mn8h = parcelRequire("9mn8h");

var $4UMOL = parcelRequire("4UMOL");

var $gq0QJ = parcelRequire("gq0QJ");

var $3skLW = parcelRequire("3skLW");
var $b50c87d57f455df5$var$_excluded = [
    "__debug__element"
];
function $b50c87d57f455df5$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $b50c87d57f455df5$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $b50c87d57f455df5$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($5yl5q)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $b50c87d57f455df5$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $b50c87d57f455df5$var$abortReason = {
    scroll: "scroll",
    keypress: "keypress",
    resize: "resize",
    error: "error"
};
var $b50c87d57f455df5$var$UNUSED_SECTOR = 0;
function $b50c87d57f455df5$var$filterComponentsLog(log) {
    return Object.fromEntries(Object.entries(log).map(function(_ref) {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($9mn8h)))(_ref, 2), timestamp = _ref2[0], entries = _ref2[1];
        return [
            Number(timestamp),
            entries.map(function(entry) {
                var __debug__element = entry.__debug__element, rest = (0, (/*@__PURE__*/$parcel$interopDefault($2CTYY)))(entry, $b50c87d57f455df5$var$_excluded);
                return rest;
            })
        ];
    }));
}
var $b50c87d57f455df5$export$1f70d263701b1d01 = /*#__PURE__*/ function() {
    function VCObserver(options) {
        var _this = this;
        (0, (/*@__PURE__*/$parcel$interopDefault($3YpK2)))(this, VCObserver);
        /* abort logic */ (0, (/*@__PURE__*/$parcel$interopDefault($5yl5q)))(this, "abortReason", {
            reason: null,
            info: "",
            timestamp: -1,
            blocking: false
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($5yl5q)))(this, "outOfBoundaryInfo", "");
        (0, (/*@__PURE__*/$parcel$interopDefault($5yl5q)))(this, "viewport", {
            w: 0,
            h: 0
        });
        /* heatmap */ (0, (/*@__PURE__*/$parcel$interopDefault($5yl5q)))(this, "arraySize", 0);
        (0, (/*@__PURE__*/$parcel$interopDefault($5yl5q)))(this, "componentsLog", {});
        (0, (/*@__PURE__*/$parcel$interopDefault($5yl5q)))(this, "vcRatios", {});
        (0, (/*@__PURE__*/$parcel$interopDefault($5yl5q)))(this, "active", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($5yl5q)))(this, "totalTime", 0);
        (0, (/*@__PURE__*/$parcel$interopDefault($5yl5q)))(this, "startTime", 0);
        (0, (/*@__PURE__*/$parcel$interopDefault($5yl5q)))(this, "_startMeasureTimestamp", -1);
        (0, (/*@__PURE__*/$parcel$interopDefault($5yl5q)))(this, "ssr", {
            reactRendered: -1
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($5yl5q)))(this, "unbind", []);
        (0, (/*@__PURE__*/$parcel$interopDefault($5yl5q)))(this, "getAbortReasonInfo", function() {
            if (_this.abortReason.reason === null) return null;
            var info = _this.abortReason.info !== "" ? " ".concat(_this.abortReason.info) : "";
            return "".concat(_this.abortReason.reason).concat(info);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($5yl5q)))(this, "getVCRawData", function() {
            _this.measureStart();
            if (!_this.active) {
                _this.measureStop();
                return null;
            }
            _this.stop();
            var abortReasonInfo = _this.getAbortReasonInfo();
            _this.measureStop();
            return {
                abortReasonInfo: abortReasonInfo,
                abortReason: $b50c87d57f455df5$var$_objectSpread({}, _this.abortReason),
                heatmap: _this.heatmap,
                heatmapNext: _this.heatmapNext,
                outOfBoundaryInfo: _this.outOfBoundaryInfo,
                totalTime: Math.round(_this.totalTime + _this.observers.getTotalTime()),
                componentsLog: $b50c87d57f455df5$var$_objectSpread({}, _this.componentsLog),
                viewport: $b50c87d57f455df5$var$_objectSpread({}, _this.viewport),
                oldDomUpdatesEnabled: _this.oldDomUpdatesEnabled,
                devToolsEnabled: _this.devToolsEnabled,
                ratios: _this.vcRatios
            };
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($5yl5q)))(this, "getVCResult", function(_ref3) {
            var _objectSpread2, _objectSpread3;
            var start = _ref3.start, stop = _ref3.stop, tti = _ref3.tti, prefix = _ref3.prefix, ssr = _ref3.ssr, vc = _ref3.vc;
            var startTime = performance.now();
            // add local measurement
            var fullPrefix = prefix !== undefined && prefix !== "" ? "".concat(prefix, ":") : "";
            var rawData = vc !== undefined ? vc : _this.getVCRawData();
            if (rawData === null) return {};
            var abortReason = rawData.abortReason, abortReasonInfo = rawData.abortReasonInfo, heatmap = rawData.heatmap, heatmapNext = rawData.heatmapNext, outOfBoundaryInfo = rawData.outOfBoundaryInfo, totalTime = rawData.totalTime, componentsLog = rawData.componentsLog, viewport = rawData.viewport, devToolsEnabled = rawData.devToolsEnabled, ratios = rawData.ratios;
            if (abortReasonInfo !== null && abortReason.blocking) {
                var _ref4;
                // exposing data to devtools
                try {
                    if (devToolsEnabled && !_this.isPostInteraction) window.__vcNotAvailableReason = abortReasonInfo;
                } catch (e) {}
                return _ref4 = {}, (0, (/*@__PURE__*/$parcel$interopDefault($5yl5q)))(_ref4, "".concat(fullPrefix, "vc:state"), false), (0, (/*@__PURE__*/$parcel$interopDefault($5yl5q)))(_ref4, "".concat(fullPrefix, "vc:abort:reason"), abortReasonInfo), (0, (/*@__PURE__*/$parcel$interopDefault($5yl5q)))(_ref4, "".concat(fullPrefix, "vc:abort:timestamp"), abortReason.timestamp), _ref4;
            }
            var _VCObserver$calculate = VCObserver.calculateVC({
                heatmap: heatmap,
                ssr: ssr,
                componentsLog: $b50c87d57f455df5$var$_objectSpread({}, componentsLog),
                viewport: viewport
            }), VC = _VCObserver$calculate.VC, VCBox = _VCObserver$calculate.VCBox, VCEntries = _VCObserver$calculate.VCEntries, totalPainted = _VCObserver$calculate.totalPainted;
            try {
                if (!_this.isPostInteraction) VCObserver.VCParts.forEach(function(key) {
                    var duration = VC[key];
                    if (duration !== null && duration !== undefined) performance.measure("VC".concat(key), {
                        start: start,
                        duration: duration
                    });
                });
            } catch (e) {
            /* empty */ }
            var vcNext = VCObserver.calculateVC({
                heatmap: heatmapNext,
                ssr: ssr,
                componentsLog: $b50c87d57f455df5$var$_objectSpread({}, componentsLog),
                viewport: viewport
            });
            var outOfBoundary = outOfBoundaryInfo ? (0, (/*@__PURE__*/$parcel$interopDefault($5yl5q)))({}, "".concat(fullPrefix, "vc:oob"), outOfBoundaryInfo) : {};
            //const oldDomUpdates = oldDomUpdatesEnabled ? { [`${fullPrefix}vc:old:dom`]: vcNext.VCBox } : {};
            var stopTime = performance.now();
            // exposing data to devtools
            try {
                if (!_this.isPostInteraction && devToolsEnabled) {
                    window.__vc = {
                        entries: VCEntries.rel,
                        log: componentsLog,
                        metrics: {
                            "75": VC["75"],
                            "80": VC["80"],
                            "85": VC["85"],
                            "90": VC["90"],
                            "95": VC["95"],
                            "98": VC["98"],
                            "99": VC["99"],
                            tti: tti,
                            ttai: stop - start
                        },
                        heatmap: heatmap,
                        ratios: ratios
                    };
                    // Emitting a custom event to make it available in the Chrome extension
                    window.dispatchEvent(new CustomEvent("vcReady", {
                        detail: {
                            log: $b50c87d57f455df5$var$filterComponentsLog(componentsLog),
                            entries: VCEntries.rel
                        }
                    }));
                }
            } catch (e) {
            /*  do nothing */ }
            return $b50c87d57f455df5$var$_objectSpread($b50c87d57f455df5$var$_objectSpread((_objectSpread2 = {
                "metrics:vc": VC
            }, (0, (/*@__PURE__*/$parcel$interopDefault($5yl5q)))(_objectSpread2, "".concat(fullPrefix, "vc:state"), true), (0, (/*@__PURE__*/$parcel$interopDefault($5yl5q)))(_objectSpread2, "".concat(fullPrefix, "vc:clean"), !abortReasonInfo), (0, (/*@__PURE__*/$parcel$interopDefault($5yl5q)))(_objectSpread2, "".concat(fullPrefix, "vc:dom"), VCBox), (0, (/*@__PURE__*/$parcel$interopDefault($5yl5q)))(_objectSpread2, "".concat(fullPrefix, "vc:updates"), VCEntries.rel.slice(0, 50)), (0, (/*@__PURE__*/$parcel$interopDefault($5yl5q)))(_objectSpread2, "".concat(fullPrefix, "vc:size"), viewport), (0, (/*@__PURE__*/$parcel$interopDefault($5yl5q)))(_objectSpread2, "".concat(fullPrefix, "vc:time"), Math.round(totalTime + (stopTime - startTime))), (0, (/*@__PURE__*/$parcel$interopDefault($5yl5q)))(_objectSpread2, "".concat(fullPrefix, "vc:total"), totalPainted), (0, (/*@__PURE__*/$parcel$interopDefault($5yl5q)))(_objectSpread2, "".concat(fullPrefix, "vc:ratios"), ratios), _objectSpread2), outOfBoundary), {}, (_objectSpread3 = {}, (0, (/*@__PURE__*/$parcel$interopDefault($5yl5q)))(_objectSpread3, "".concat(fullPrefix, "vc:next"), vcNext.VC), (0, (/*@__PURE__*/$parcel$interopDefault($5yl5q)))(_objectSpread3, "".concat(fullPrefix, "vc:ignored"), _this.getIgnoredElements(componentsLog)), _objectSpread3));
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($5yl5q)))(this, "handleUpdate", function(rawTime, intersectionRect, targetName, element, type, ignoreReason) {
            _this.measureStart();
            if (_this.abortReason.reason === null || _this.abortReason.blocking === false) {
                var time = Math.round(rawTime - _this.startTime);
                var mappedValues = _this.mapPixelsToHeatmap(intersectionRect.left, intersectionRect.top, intersectionRect.width, intersectionRect.height);
                _this.vcRatios[targetName] = _this.getElementRatio(mappedValues);
                if (!ignoreReason) _this.applyChangesToHeatMap(mappedValues, time, _this.heatmapNext);
                if ((!ignoreReason || ignoreReason === "not-visible") && type !== "attr") _this.applyChangesToHeatMap(mappedValues, time, _this.heatmap);
                if (!_this.componentsLog[time]) _this.componentsLog[time] = [];
                _this.componentsLog[time].push({
                    __debug__element: _this.devToolsEnabled ? new WeakRef(element) : null,
                    intersectionRect: intersectionRect,
                    targetName: targetName,
                    ignoreReason: ignoreReason
                });
            }
            // devtools export
            _this.measureStop();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($5yl5q)))(this, "mapPixelsToHeatmap", function(left, top, width, height) {
            var _this$viewport = _this.viewport, w = _this$viewport.w, h = _this$viewport.h;
            var l = Math.floor(left / w * _this.arraySize);
            var t = Math.floor(top / h * _this.arraySize);
            var r = Math.ceil((left + width) / w * _this.arraySize);
            var b = Math.ceil((top + height) / h * _this.arraySize);
            // that info is temporary to get info why it goes over boundary
            if (_this.outOfBoundaryInfo === "") {
                var outOfBoundaryInfo = "";
                if (r > _this.arraySize) outOfBoundaryInfo += " r ".concat(r, " ! ").concat(left, " ").concat(width);
                if (b > _this.arraySize) outOfBoundaryInfo += " r ".concat(r, " ! ").concat(top, " ").concat(height);
                _this.outOfBoundaryInfo = outOfBoundaryInfo;
            }
            // correct values to min - 0, max - arraySize
            var result = {
                l: Math.max(0, l),
                t: Math.max(0, t),
                r: Math.min(_this.arraySize, r),
                b: Math.min(_this.arraySize, b)
            };
            return result;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($5yl5q)))(this, "getElementRatio", function(mappedValues) {
            var r = mappedValues.r, l = mappedValues.l, b = mappedValues.b, t = mappedValues.t;
            return (r - l) * (b - t) / (_this.arraySize * _this.arraySize);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($5yl5q)))(this, "abortReasonCallback", function(key, time) {
            switch(key){
                case "wheel":
                    _this.setAbortReason($b50c87d57f455df5$var$abortReason.scroll, time);
                    break;
                case "keydown":
                    _this.setAbortReason($b50c87d57f455df5$var$abortReason.keypress, time);
                    break;
                case "resize":
                    _this.setAbortReason($b50c87d57f455df5$var$abortReason.resize, time);
                    break;
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($5yl5q)))(this, "attachAbortListeners", function() {
            var _window;
            _this.detachAbortListeners();
            var unbinds = (0, $4UMOL.attachAbortListeners)(window, _this.viewport, _this.abortReasonCallback);
            if ((_window = window) !== null && _window !== void 0 && _window.__SSR_ABORT_LISTENERS__) {
                var _window2;
                Object.entries(window.__SSR_ABORT_LISTENERS__.aborts).forEach(function(_ref6) {
                    var _ref7 = (0, (/*@__PURE__*/$parcel$interopDefault($9mn8h)))(_ref6, 2), key = _ref7[0], time = _ref7[1];
                    if (time) _this.abortReasonCallback(key, time);
                });
                unbinds = unbinds.concat(window.__SSR_ABORT_LISTENERS__.unbinds);
                (_window2 = window) === null || _window2 === void 0 || delete _window2.__SSR_ABORT_LISTENERS__;
            }
            _this.unbind = unbinds;
        });
        this.arraySize = options.heatmapSize || 200;
        this.devToolsEnabled = options.devToolsEnabled || false;
        this.oldDomUpdatesEnabled = options.oldDomUpdates || false;
        this.observers = new (0, $3skLW.Observers)({
            selectorConfig: options.selectorConfig || {
                id: false,
                testId: false,
                role: false,
                className: true,
                dataVC: true
            }
        });
        this.heatmap = this.getCleanHeatmap();
        this.heatmapNext = this.getCleanHeatmap();
        this.isPostInteraction = options.isPostInteraction || false;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($6KIrE)))(VCObserver, [
        {
            key: "start",
            value: function start(_ref8) {
                var startTime = _ref8.startTime;
                this.active = true;
                if (this.observers.isBrowserSupported()) {
                    this.setViewportSize();
                    this.resetState();
                    this.startTime = startTime;
                    this.attachAbortListeners();
                    this.observers.subscribeResults(this.handleUpdate);
                    this.observers.observe();
                } else this.setAbortReason("not-supported", startTime);
            }
        },
        {
            key: "stop",
            value: function stop() {
                this.observers.disconnect();
                this.detachAbortListeners();
            }
        },
        {
            key: "getIgnoredElements",
            value: function getIgnoredElements(componentsLog) {
                return Object.values(componentsLog).flat().filter(function(_ref9) {
                    var ignoreReason = _ref9.ignoreReason;
                    return Boolean(ignoreReason);
                }).map(function(_ref10) {
                    var targetName = _ref10.targetName, ignoreReason = _ref10.ignoreReason;
                    return {
                        targetName: targetName,
                        ignoreReason: ignoreReason
                    };
                });
            }
        },
        {
            key: "setSSRElement",
            value: function setSSRElement(element) {
                this.observers.setReactRootElement(element);
            }
        },
        {
            key: "setReactRootRenderStart",
            value: function setReactRootRenderStart() {
                var startTime = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : performance.now();
                this.observers.setReactRootRenderStart(startTime);
            }
        },
        {
            key: "setReactRootRenderStop",
            value: function setReactRootRenderStop() {
                var stopTime = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : performance.now();
                this.observers.setReactRootRenderStop(stopTime);
            }
        },
        {
            key: "abortObservation",
            value: function abortObservation() {
                var abortReason = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "custom";
                this.setAbortReason(abortReason, performance.now());
            }
        },
        {
            key: "setAbortReason",
            value: function setAbortReason(abort, timestamp) {
                var info = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "";
                if (this.abortReason.reason === null || this.abortReason.blocking === false) {
                    this.abortReason.reason = abort;
                    this.abortReason.info = info;
                    this.abortReason.timestamp = timestamp;
                    this.abortReason.blocking = abort !== $b50c87d57f455df5$var$abortReason.scroll;
                    if (this.abortReason.blocking) this.detachAbortListeners();
                }
            }
        },
        {
            key: "resetState",
            value: function resetState() {
                this.abortReason = {
                    reason: null,
                    info: "",
                    timestamp: -1,
                    blocking: false
                };
                this.detachAbortListeners();
                this.heatmap = this.getCleanHeatmap();
                this.heatmapNext = this.getCleanHeatmap();
                this.totalTime = 0;
                this.componentsLog = {};
                this.vcRatios = {};
            }
        },
        {
            key: "getCleanHeatmap",
            value: function getCleanHeatmap() {
                var _this2 = this;
                return Array(this.arraySize).fill("").map(function() {
                    return Array(_this2.arraySize).fill($b50c87d57f455df5$var$UNUSED_SECTOR);
                });
            }
        },
        {
            key: "setViewportSize",
            value: function setViewportSize() {
                this.viewport.w = (0, $gq0QJ.getViewportWidth)();
                this.viewport.h = (0, $gq0QJ.getViewportHeight)();
            }
        },
        {
            key: "applyChangesToHeatMap",
            value: function applyChangesToHeatMap(a, time, heatmap) {
                var l = a.l, t = a.t, r = a.r, b = a.b;
                var localHeatmap = heatmap;
                for(var row = t; row < b; row++){
                    for(var col = l; col < r; col++)if (localHeatmap[row] === undefined) {
                        try {
                            this.setAbortReason($b50c87d57f455df5$var$abortReason.error, time, "index - ".concat(row));
                        } catch (e) {
                            this.setAbortReason($b50c87d57f455df5$var$abortReason.error, time, "row error");
                        }
                        return;
                    } else localHeatmap[row][col] = time;
                }
            }
        },
        {
            key: "detachAbortListeners",
            value: function detachAbortListeners() {
                this.unbind.forEach(function(fn) {
                    return fn();
                });
                this.unbind = [];
            }
        },
        {
            key: "measureStart",
            value: function measureStart() {
                this._startMeasureTimestamp = performance.now();
            }
        },
        {
            key: "measureStop",
            value: function measureStop() {
                if (this._startMeasureTimestamp === -1) return;
                this.totalTime += performance.now() - this._startMeasureTimestamp;
                this._startMeasureTimestamp = -1;
            }
        }
    ], [
        {
            key: "calculateVC",
            value: function calculateVC(_ref11) {
                var heatmap = _ref11.heatmap, _ref11$ssr = _ref11.ssr, ssr = _ref11$ssr === void 0 ? $b50c87d57f455df5$var$UNUSED_SECTOR : _ref11$ssr, componentsLog = _ref11.componentsLog, viewport = _ref11.viewport;
                var lastUpdate = {};
                var totalPainted = 0;
                if (ssr !== $b50c87d57f455df5$var$UNUSED_SECTOR) {
                    var _window$document;
                    var element = {
                        __debug__element: new WeakRef((_window$document = window.document) === null || _window$document === void 0 ? void 0 : _window$document.body),
                        intersectionRect: {
                            top: 0,
                            left: 0,
                            right: 0,
                            bottom: 0,
                            x: 0,
                            y: 0,
                            width: viewport.w,
                            height: viewport.h,
                            toJSON: function toJSON() {
                                return {};
                            }
                        },
                        targetName: "SSR"
                    };
                    if (!componentsLog[ssr]) componentsLog[ssr] = [];
                    componentsLog[ssr].push(element);
                }
                heatmap.forEach(function(line) {
                    line.forEach(function(entry) {
                        var rounded = Math.floor(entry === $b50c87d57f455df5$var$UNUSED_SECTOR && ssr !== $b50c87d57f455df5$var$UNUSED_SECTOR ? ssr : entry);
                        totalPainted += rounded !== $b50c87d57f455df5$var$UNUSED_SECTOR ? 1 : 0;
                        if (rounded !== $b50c87d57f455df5$var$UNUSED_SECTOR) lastUpdate[rounded] = lastUpdate[rounded] ? lastUpdate[rounded] + 1 : 1;
                    });
                });
                var entries = Object.entries(lastUpdate).map(function(a) {
                    return [
                        parseInt(a[0], 10),
                        a[1]
                    ];
                }).sort(function(a, b) {
                    return a[0] > b[0] ? 1 : -1;
                });
                var VC = VCObserver.makeVCReturnObj();
                var VCBox = VCObserver.makeVCReturnObj();
                entries.reduce(function() {
                    var acc = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
                    var v = arguments.length > 1 ? arguments[1] : undefined;
                    var VCRatio = v[1] / totalPainted + acc;
                    var time = v[0];
                    VCObserver.VCParts.forEach(function(key) {
                        var value = parseInt(key, 10);
                        if ((VC[key] === null || VC[key] === undefined) && VCRatio >= value / 100) {
                            var _componentsLog$time;
                            VC[key] = time;
                            VCBox[key] = (_componentsLog$time = componentsLog[time]) === null || _componentsLog$time === void 0 ? void 0 : _componentsLog$time.map(function(v) {
                                return v.targetName;
                            });
                        }
                    });
                    return VCRatio;
                }, 0);
                var VCEntries = entries.reduce(function(acc, _ref12, i) {
                    var _acc$abs, _componentsLog$timest;
                    var _ref13 = (0, (/*@__PURE__*/$parcel$interopDefault($9mn8h)))(_ref12, 2), timestamp = _ref13[0], entryPainted = _ref13[1];
                    var currentlyPainted = entryPainted + (((_acc$abs = acc.abs[i - 1]) === null || _acc$abs === void 0 ? void 0 : _acc$abs[1]) || 0);
                    var currentlyPaintedRatio = Math.round(currentlyPainted / totalPainted * 1000) / 10;
                    var logEntry = (_componentsLog$timest = componentsLog[timestamp]) === null || _componentsLog$timest === void 0 ? void 0 : _componentsLog$timest.map(function(v) {
                        return v.targetName;
                    });
                    acc.abs.push([
                        timestamp,
                        currentlyPainted
                    ]);
                    acc.rel.push({
                        time: timestamp,
                        vc: currentlyPaintedRatio,
                        elements: logEntry
                    });
                    return acc;
                }, {
                    abs: [],
                    rel: []
                });
                return {
                    VC: VC,
                    VCBox: VCBox,
                    VCEntries: VCEntries,
                    totalPainted: totalPainted
                };
            }
        },
        {
            key: "makeVCReturnObj",
            value: function makeVCReturnObj() {
                var vc = {};
                VCObserver.VCParts.forEach(function(v) {
                    vc[v] = null;
                });
                return vc;
            }
        }
    ]);
    return VCObserver;
}();
/** config * */ (0, (/*@__PURE__*/$parcel$interopDefault($5yl5q)))($b50c87d57f455df5$export$1f70d263701b1d01, "VCParts", [
    "25",
    "50",
    "75",
    "80",
    "85",
    "90",
    "95",
    "98",
    "99"
]);

});
parcelRegister("3YpK2", function(module, exports) {
function $2e4af172573aad27$var$_classCallCheck(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
module.exports = $2e4af172573aad27$var$_classCallCheck, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("6KIrE", function(module, exports) {

var $cvE54 = parcelRequire("cvE54");
function $4ea983cabfbf430e$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, $cvE54(o.key), o);
    }
}
function $4ea983cabfbf430e$var$_createClass(e, r, t) {
    return r && $4ea983cabfbf430e$var$_defineProperties(e.prototype, r), t && $4ea983cabfbf430e$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}
module.exports = $4ea983cabfbf430e$var$_createClass, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("2CTYY", function(module, exports) {

var $4Zbit = parcelRequire("4Zbit");
function $1e9a8e59c731398a$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $4Zbit(e, t);
    if (Object.getOwnPropertySymbols) {
        var s = Object.getOwnPropertySymbols(e);
        for(r = 0; r < s.length; r++)o = s[r], t.includes(o) || ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
module.exports = $1e9a8e59c731398a$var$_objectWithoutProperties, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("4Zbit", function(module, exports) {
function $3a159f4afe961020$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.includes(n)) continue;
        t[n] = r[n];
    }
    return t;
}
module.exports = $3a159f4afe961020$var$_objectWithoutPropertiesLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("4UMOL", function(module, exports) {

$parcel$export(module.exports, "attachAbortListeners", function () { return $394242942db704eb$export$9010aa71841a6887; });

var $dd4sf = parcelRequire("dd4sf");

var $5W38a = parcelRequire("5W38a");

var $gq0QJ = parcelRequire("gq0QJ");
var $394242942db704eb$export$9010aa71841a6887 = function attachAbortListeners(window, initialViewPort, callback) {
    var unbindWheel = (0, $dd4sf.bind)(window, {
        type: (0, $5W38a.AbortEvent).wheel,
        listener: function listener(e) {
            callback((0, $5W38a.AbortEvent).wheel, e.timeStamp);
        },
        options: {
            passive: true,
            once: true
        }
    });
    var unbindKeydown = (0, $dd4sf.bind)(window, {
        type: (0, $5W38a.AbortEvent).keydown,
        listener: function listener(e) {
            callback((0, $5W38a.AbortEvent).keydown, e.timeStamp);
        },
        options: {
            once: true
        }
    });
    var unbindResize = (0, $dd4sf.bind)(window, {
        type: (0, $5W38a.AbortEvent).resize,
        listener: function listener(e) {
            if ((0, $gq0QJ.getViewportWidth)() !== initialViewPort.w || (0, $gq0QJ.getViewportHeight)() !== initialViewPort.h) {
                callback((0, $5W38a.AbortEvent).resize, e.timeStamp);
                unbindResize();
            }
        }
    });
    return [
        unbindWheel,
        unbindKeydown,
        unbindResize
    ];
};

});
parcelRegister("dd4sf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.bindAll = module.exports.bind = void 0;

var $jLWPC = parcelRequire("jLWPC");
Object.defineProperty(module.exports, "bind", {
    enumerable: true,
    get: function() {
        return $jLWPC.bind;
    }
});

var $4VKCu = parcelRequire("4VKCu");
Object.defineProperty(module.exports, "bindAll", {
    enumerable: true,
    get: function() {
        return $4VKCu.bindAll;
    }
});

});
parcelRegister("jLWPC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.bind = void 0;
function $e6500ad3b432a9ce$var$bind(target, _a) {
    var type = _a.type, listener = _a.listener, options = _a.options;
    target.addEventListener(type, listener, options);
    return function unbind() {
        target.removeEventListener(type, listener, options);
    };
}
module.exports.bind = $e6500ad3b432a9ce$var$bind;

});

parcelRegister("4VKCu", function(module, exports) {
"use strict";
var $3970a5ff5da5242c$var$__assign = module.exports && module.exports.__assign || function() {
    $3970a5ff5da5242c$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $3970a5ff5da5242c$var$__assign.apply(this, arguments);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.bindAll = void 0;

var $jLWPC = parcelRequire("jLWPC");
function $3970a5ff5da5242c$var$toOptions(value) {
    if (typeof value === "undefined") return undefined;
    if (typeof value === "boolean") return {
        capture: value
    };
    return value;
}
function $3970a5ff5da5242c$var$getBinding(original, sharedOptions) {
    if (sharedOptions == null) return original;
    var binding = $3970a5ff5da5242c$var$__assign($3970a5ff5da5242c$var$__assign({}, original), {
        options: $3970a5ff5da5242c$var$__assign($3970a5ff5da5242c$var$__assign({}, $3970a5ff5da5242c$var$toOptions(sharedOptions)), $3970a5ff5da5242c$var$toOptions(original.options))
    });
    return binding;
}
function $3970a5ff5da5242c$var$bindAll(target, bindings, sharedOptions) {
    var unbinds = bindings.map(function(original) {
        var binding = $3970a5ff5da5242c$var$getBinding(original, sharedOptions);
        return (0, $jLWPC.bind)(target, binding);
    });
    return function unbindAll() {
        unbinds.forEach(function(unbind) {
            return unbind();
        });
    };
}
module.exports.bindAll = $3970a5ff5da5242c$var$bindAll;

});


parcelRegister("5W38a", function(module, exports) {

$parcel$export(module.exports, "AbortEvent", function () { return $4524cc347895e01b$export$199edc0307b5587f; });
var $4524cc347895e01b$export$199edc0307b5587f = {
    wheel: "wheel",
    keydown: "keydown",
    resize: "resize"
};

});

parcelRegister("gq0QJ", function(module, exports) {

$parcel$export(module.exports, "getViewportWidth", function () { return $bf3fbbbb9e4befc0$export$a497a1dcb4408212; });
$parcel$export(module.exports, "getViewportHeight", function () { return $bf3fbbbb9e4befc0$export$4f01c15d21ef9cc6; });
function $bf3fbbbb9e4befc0$export$a497a1dcb4408212() {
    var document = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.document;
    var documentWidth;
    try {
        documentWidth = document.documentElement.clientWidth || 0;
    } catch (e) {
        documentWidth = 0;
    }
    return Math.max(documentWidth, window.innerWidth || 0);
}
function $bf3fbbbb9e4befc0$export$4f01c15d21ef9cc6() {
    var document = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.document;
    var documentHeight;
    try {
        documentHeight = document.documentElement.clientHeight || 0;
    } catch (e) {
        documentHeight = 0;
    }
    return Math.max(documentHeight, window.innerHeight || 0);
}

});


parcelRegister("3skLW", function(module, exports) {

$parcel$export(module.exports, "Observers", function () { return $2844198ff4e3b73b$export$b65d046240060e78; });

var $9mn8h = parcelRequire("9mn8h");

var $3YpK2 = parcelRequire("3YpK2");

var $6KIrE = parcelRequire("6KIrE");

var $5yl5q = parcelRequire("5yl5q");

var $jED4u = parcelRequire("jED4u");

var $lmeW1 = parcelRequire("lmeW1");

var $4NDaq = parcelRequire("4NDaq");

var $535hQ = parcelRequire("535hQ");
function $2844198ff4e3b73b$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $2844198ff4e3b73b$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $2844198ff4e3b73b$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $2844198ff4e3b73b$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $2844198ff4e3b73b$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $2844198ff4e3b73b$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $2844198ff4e3b73b$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $2844198ff4e3b73b$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $2844198ff4e3b73b$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($5yl5q)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $2844198ff4e3b73b$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $2844198ff4e3b73b$var$state = {
    normal: 1,
    waitingForFirstRender: 2,
    ignoring: 3
};
var $2844198ff4e3b73b$export$b65d046240060e78 = /*#__PURE__*/ function() {
    function Observers(opts) {
        var _this = this;
        (0, (/*@__PURE__*/$parcel$interopDefault($3YpK2)))(this, Observers);
        (0, (/*@__PURE__*/$parcel$interopDefault($5yl5q)))(this, "observedMutations", new WeakMap());
        (0, (/*@__PURE__*/$parcel$interopDefault($5yl5q)))(this, "elementsInView", new Set());
        (0, (/*@__PURE__*/$parcel$interopDefault($5yl5q)))(this, "callbacks", new Set());
        (0, (/*@__PURE__*/$parcel$interopDefault($5yl5q)))(this, "totalTime", 0);
        (0, (/*@__PURE__*/$parcel$interopDefault($5yl5q)))(this, "_startMeasureTimestamp", -1);
        (0, (/*@__PURE__*/$parcel$interopDefault($5yl5q)))(this, "ssr", {
            state: $2844198ff4e3b73b$var$state.normal,
            reactRootElement: null,
            renderStart: -1,
            renderStop: -1
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($5yl5q)))(this, "selectorConfig", {
            id: false,
            testId: false,
            role: false,
            className: true,
            dataVC: true
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($5yl5q)))(this, "subscribeResults", function(cb) {
            _this.callbacks.add(cb);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($5yl5q)))(this, "observeElement", function(node, mutation, type, ignoreReason) {
            var _this$intersectionObs;
            (_this$intersectionObs = _this.intersectionObserver) === null || _this$intersectionObs === void 0 || _this$intersectionObs.observe(node);
            _this.observedMutations.set(node, {
                mutation: mutation,
                ignoreReason: ignoreReason,
                type: type
            });
        });
        this.selectorConfig = $2844198ff4e3b73b$var$_objectSpread($2844198ff4e3b73b$var$_objectSpread({}, this.selectorConfig), opts.selectorConfig);
        this.intersectionObserver = this.getIntersectionObserver();
        this.mutationObserver = this.getMutationObserver();
        this.ssrPlaceholderHandler = new (0, $535hQ.SSRPlaceholderHandlers)();
        this.editorLnvHandler = new (0, $4NDaq.EditorLnvHandler)();
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($6KIrE)))(Observers, [
        {
            key: "isBrowserSupported",
            value: function isBrowserSupported() {
                return typeof window.IntersectionObserver === "function" && typeof window.MutationObserver === "function";
            }
        },
        {
            key: "observe",
            value: function observe() {
                var _this$mutationObserve;
                this.totalTime = 0;
                this.ssr = {
                    state: $2844198ff4e3b73b$var$state.normal,
                    reactRootElement: null,
                    renderStart: -1,
                    renderStop: -1
                };
                (_this$mutationObserve = this.mutationObserver) === null || _this$mutationObserve === void 0 || _this$mutationObserve.observe(document.body, {
                    attributeFilter: [
                        "hidden",
                        "style",
                        "src"
                    ],
                    attributeOldValue: true,
                    attributes: true,
                    childList: true,
                    subtree: true
                });
            }
        },
        {
            key: "disconnect",
            value: function disconnect() {
                var _this$mutationObserve2, _this$intersectionObs2;
                (_this$mutationObserve2 = this.mutationObserver) === null || _this$mutationObserve2 === void 0 || _this$mutationObserve2.disconnect();
                (_this$intersectionObs2 = this.intersectionObserver) === null || _this$intersectionObs2 === void 0 || _this$intersectionObs2.disconnect();
                this.observedMutations = new WeakMap();
                this.elementsInView = new Set();
                this.callbacks = new Set();
                this.ssr.reactRootElement = null;
                this.ssrPlaceholderHandler.clear();
                this.editorLnvHandler.clear();
            }
        },
        {
            key: "getTotalTime",
            value: function getTotalTime() {
                return this.totalTime;
            }
        },
        {
            key: "setReactRootElement",
            value: function setReactRootElement(element) {
                this.ssr.reactRootElement = element;
            }
        },
        {
            key: "setReactRootRenderStart",
            value: function setReactRootRenderStart() {
                var startTime = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : performance.now();
                this.ssr.renderStart = startTime;
                this.ssr.state = $2844198ff4e3b73b$var$state.waitingForFirstRender;
            }
        },
        {
            key: "setReactRootRenderStop",
            value: function setReactRootRenderStop() {
                var stopTime = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : performance.now();
                this.ssr.renderStop = stopTime;
            }
        },
        {
            key: "getMutationObserver",
            value: function getMutationObserver() {
                var _this2 = this;
                return this.isBrowserSupported() ? new MutationObserver(function(mutations) {
                    _this2.measureStart();
                    mutations.forEach(function(mutation) {
                        // patching element if timestamp not automatically added
                        // eslint-disable-next-line no-param-reassign
                        mutation.timestamp = mutation.timestamp === undefined ? performance.now() : mutation.timestamp;
                        var ignoreReason = "";
                        if (_this2.ssr.state === $2844198ff4e3b73b$var$state.waitingForFirstRender && mutation.timestamp > _this2.ssr.renderStart && mutation.target === _this2.ssr.reactRootElement) {
                            _this2.ssr.state = $2844198ff4e3b73b$var$state.ignoring;
                            if (_this2.ssr.renderStop === -1) // arbitrary 500ms DOM update window
                            _this2.ssr.renderStop = mutation.timestamp + 500;
                            ignoreReason = "ssr-hydration";
                        }
                        if (_this2.ssr.state === $2844198ff4e3b73b$var$state.ignoring && mutation.timestamp > _this2.ssr.renderStart && mutation.target === _this2.ssr.reactRootElement) {
                            if (mutation.timestamp <= _this2.ssr.renderStop) ignoreReason = "ssr-hydration";
                            else _this2.ssr.state = $2844198ff4e3b73b$var$state.normal;
                        }
                        if (mutation.type === "childList") {
                            mutation.addedNodes.forEach(function(node) {
                                if ((0, $lmeW1.isContainedWithinMediaWrapper)(node)) ignoreReason = "image";
                                if (node instanceof HTMLElement) {
                                    if (_this2.ssrPlaceholderHandler.isPlaceholder(node) || _this2.ssrPlaceholderHandler.isPlaceholderIgnored(node)) {
                                        _this2.ssrPlaceholderHandler.checkIfExistedAndSizeMatching(node).then(function(result) {
                                            if (result === false) _this2.observeElement(node, mutation, "html", ignoreReason);
                                        });
                                        return;
                                    }
                                    if (_this2.ssrPlaceholderHandler.isPlaceholderReplacement(node) || _this2.ssrPlaceholderHandler.isPlaceholderIgnored(node)) {
                                        _this2.ssrPlaceholderHandler.validateReactComponentMatchToPlaceholder(node).then(function(result) {
                                            if (result === false) _this2.observeElement(node, mutation, "html", ignoreReason);
                                        });
                                        return;
                                    }
                                    if ((0, $jED4u.fg)("platform_editor_ed-25557_lnv_add_ssr_placeholder")) {
                                        if (_this2.editorLnvHandler.shouldHandleAddedNode(node)) {
                                            _this2.editorLnvHandler.handleAddedNode(node).then(function(_ref) {
                                                var shouldIgnore = _ref.shouldIgnore;
                                                _this2.observeElement(node, mutation, "html", shouldIgnore ? "editor-lazy-node-view" : ignoreReason);
                                            });
                                            return;
                                        }
                                    }
                                    _this2.observeElement(node, mutation, "html", ignoreReason);
                                }
                                if (node instanceof Text && node.parentElement != null) _this2.observeElement(node.parentElement, mutation, "text", ignoreReason);
                            });
                            mutation.removedNodes.forEach(function(node) {
                                if (node instanceof Element) {
                                    var _this2$intersectionOb;
                                    _this2.elementsInView.delete(node);
                                    (_this2$intersectionOb = _this2.intersectionObserver) === null || _this2$intersectionOb === void 0 || _this2$intersectionOb.unobserve(node);
                                }
                            });
                        } else if (mutation.type === "attributes") {
                            if (mutation.target instanceof HTMLElement) // Commenting the following line temporarily.
                            // this.observeElement(mutation.target, mutation, 'attr', ignoreReason);
                            // using the if below to collect data
                            // how would VC90 changes if only style display changes are accounted for
                            {
                                if (mutation.attributeName === "style" && _this2.getStyleDisplay(mutation.target.getAttribute("style")) !== _this2.getStyleDisplay(mutation.oldValue)) _this2.observeElement(mutation.target, mutation, "attr", ignoreReason);
                            }
                        }
                    });
                    _this2.measureStop();
                }) : null;
            }
        },
        {
            key: "getStyleDisplay",
            value: function getStyleDisplay(styleAttributeValue) {
                if (!styleAttributeValue) return undefined;
                // Split the style string into individual declarations
                var declarations = styleAttributeValue.split(";");
                // Iterate over each declaration
                var _iterator = $2844198ff4e3b73b$var$_createForOfIteratorHelper(declarations), _step;
                try {
                    for(_iterator.s(); !(_step = _iterator.n()).done;){
                        var declaration = _step.value;
                        // Trim whitespace and split into property and value
                        var _declaration$split$ma = declaration.split(":").map(function(part) {
                            return part.trim();
                        }), _declaration$split$ma2 = (0, (/*@__PURE__*/$parcel$interopDefault($9mn8h)))(_declaration$split$ma, 2), property = _declaration$split$ma2[0], value = _declaration$split$ma2[1];
                        // Check if the property is 'display'
                        if (property && property.toLowerCase() === "display") return value;
                    }
                } catch (err) {
                    _iterator.e(err);
                } finally{
                    _iterator.f();
                }
                return undefined;
            }
        },
        {
            key: "getElementName",
            value: function getElementName(element) {
                try {
                    var tagName = element.localName;
                    var dataVCAttr = element.getAttribute("data-vc");
                    var dataVC = this.selectorConfig.dataVC && dataVCAttr ? '[data-vc="'.concat(dataVCAttr, '"]') : "";
                    var id = this.selectorConfig.id && element.id ? "#".concat(element.id) : "";
                    var testId = this.selectorConfig.testId ? element.getAttribute("data-testid") || element.getAttribute("data-test-id") : "";
                    testId = testId ? "[testid=".concat(testId, "]") : "";
                    var role = this.selectorConfig.role ? element.getAttribute("role") : "";
                    role = role ? "[role=".concat(role, "]") : "";
                    var classList = this.selectorConfig.className ? Array.from(element.classList).join(".") : "";
                    classList = classList === "" ? "" : ".".concat(classList);
                    var attrs = dataVC ? dataVC : [
                        id,
                        testId,
                        role
                    ].join("");
                    var idString = "";
                    if (attrs === "" && classList === "") {
                        var parent = element.parentElement ? this.getElementName(element.parentElement) : "unknown";
                        idString = "".concat(parent, " > ").concat(tagName);
                    } else idString = [
                        tagName,
                        attrs || classList
                    ].join("");
                    return idString;
                } catch (e) {
                    return "error";
                }
            }
        },
        {
            key: "getIntersectionObserver",
            value: function getIntersectionObserver() {
                var _this3 = this;
                return this.isBrowserSupported() ? new IntersectionObserver(function(entries) {
                    _this3.measureStart();
                    entries.forEach(function(_ref2) {
                        var isIntersecting = _ref2.isIntersecting, ir = _ref2.intersectionRect, target = _ref2.target;
                        var data = _this3.observedMutations.get(target);
                        _this3.observedMutations.delete(target);
                        if (isIntersecting && ir.width > 0 && ir.height > 0) {
                            if (!(target instanceof HTMLElement)) return;
                            if (!(data !== null && data !== void 0 && data.mutation)) // ignore intersection report without recent mutation
                            return;
                            if ((0, $jED4u.fg)("platform-ufo-invisible-element-vc-calculations")) {
                                var isVisible = target.checkVisibility({
                                    contentVisibilityAuto: true,
                                    opacityProperty: true,
                                    visibilityProperty: true
                                });
                                if (!isVisible) data.ignoreReason = "not-visible";
                            }
                            _this3.callbacks.forEach(function(callback) {
                                var elementName;
                                try {
                                    elementName = _this3.getElementName(target);
                                } catch (e) {
                                    elementName = "error";
                                }
                                callback(data.mutation.timestamp || performance.now(), ir, elementName, target, data.type, data.ignoreReason);
                            });
                            _this3.elementsInView.add(target);
                        } else _this3.elementsInView.delete(target);
                    });
                    _this3.measureStop();
                }) : null;
            }
        },
        {
            key: "measureStart",
            value: function measureStart() {
                this._startMeasureTimestamp = performance.now();
            }
        },
        {
            key: "measureStop",
            value: function measureStop() {
                if (this._startMeasureTimestamp === -1) return;
                this.totalTime += performance.now() - this._startMeasureTimestamp;
                this._startMeasureTimestamp = -1;
            }
        }
    ]);
    return Observers;
}();

});
parcelRegister("jED4u", function(module, exports) {

$parcel$export(module.exports, "fg", function () { return $e4f00f8071b001fb$export$b40ec24ac8275656; });

var $3sYFg = parcelRequire("3sYFg");
function $e4f00f8071b001fb$export$ba05d765b8392e5e(flagResolver) {
    (0, $3sYFg.setBooleanResolver)(flagResolver);
}
function $e4f00f8071b001fb$export$470e5c2be1411c89(name) {
    return (0, $3sYFg.resolveBooleanFlag)(name);
}
function $e4f00f8071b001fb$export$b40ec24ac8275656(name) {
    return (0, $3sYFg.resolveBooleanFlag)(name);
}

});
parcelRegister("3sYFg", function(module, exports) {

$parcel$export(module.exports, "setBooleanResolver", function () { return $28630b555d1a1822$export$f2b591175b3e424c; });
$parcel$export(module.exports, "resolveBooleanFlag", function () { return $28630b555d1a1822$export$6333b6aff9fc6275; });

var $5Tzdr = parcelRequire("5Tzdr");

var $ahJoN = parcelRequire("ahJoN");
var $28630b555d1a1822$var$pkgName = "@atlaskit/platform-feature-flags";
var $28630b555d1a1822$export$7e41b1b2bdee3f98 = "__PLATFORM_FEATURE_FLAGS__";
var $28630b555d1a1822$var$hasProcessEnv = typeof $ahJoN !== "undefined" && typeof $ahJoN.env !== "undefined";
// FF global overrides can be configured by test runners or Storybook
var $28630b555d1a1822$var$ENV_ENABLE_PLATFORM_FF = $28630b555d1a1822$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
// STORYBOOK_ENABLE_PLATFORM_FF is included as storybook only allows env vars prefixed with STORYBOOK
// https://github.com/storybookjs/storybook/issues/12270
var $28630b555d1a1822$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF = $28630b555d1a1822$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
var $28630b555d1a1822$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE = $28630b555d1a1822$var$ENV_ENABLE_PLATFORM_FF || $28630b555d1a1822$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF;
var $28630b555d1a1822$var$DEFAULT_PFF_GLOBAL = {
    // In development mode we want to capture any feature flag checks that happen using the default resolver and log this result when the resolver is replaced.
    // This is because evaluating feature flags when the resolver/FF client is loaded asynchronously could cause unexpected issues.
    earlyResolvedFlags: new Map(),
    booleanResolver: function booleanResolver(flagKey) {
        var unresolvedFlagCount;
        return false;
    }
};
var $28630b555d1a1822$var$globalVar = typeof window !== "undefined" ? window : globalThis;
$28630b555d1a1822$var$globalVar[$28630b555d1a1822$export$7e41b1b2bdee3f98] = $28630b555d1a1822$var$globalVar[$28630b555d1a1822$export$7e41b1b2bdee3f98] || $28630b555d1a1822$var$DEFAULT_PFF_GLOBAL;
function $28630b555d1a1822$export$f2b591175b3e424c(resolver) {
    $28630b555d1a1822$var$globalVar[$28630b555d1a1822$export$7e41b1b2bdee3f98].booleanResolver = resolver;
    var _globalVar$PFF_GLOBAL;
}
function $28630b555d1a1822$export$6333b6aff9fc6275(flagKey) {
    if ($28630b555d1a1822$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE) {
        (0, $5Tzdr.debug)('[%s]: The feature flags were enabled while running tests. The flag "%s" will be always enabled.', $28630b555d1a1822$var$pkgName, flagKey);
        return true;
    }
    try {
        var _globalVar$PFF_GLOBAL2;
        var result = (_globalVar$PFF_GLOBAL2 = $28630b555d1a1822$var$globalVar[$28630b555d1a1822$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL2 === void 0 ? void 0 : _globalVar$PFF_GLOBAL2.booleanResolver(flagKey);
        if (typeof result !== "boolean") {
            // eslint-disable-next-line no-console
            console.warn("".concat(flagKey, " resolved to a non-boolean value, returning false for safety"));
            return false;
        }
        return result;
    } catch (e) {
        return false;
    }
}

});
parcelRegister("5Tzdr", function(module, exports) {

$parcel$export(module.exports, "debug", function () { return $44ad67f277b5a1b5$export$1c9f709888824e05; });
var $44ad67f277b5a1b5$var$_ref, $44ad67f277b5a1b5$var$_process, $44ad67f277b5a1b5$var$_process2;
// We can't rely on NODE_ENV === 'test' if its value is already configured by the consumer to some other value, so better to use JEST_WORKER_ID
// https://jestjs.io/docs/environment-variables#jest_worker_id
var $44ad67f277b5a1b5$var$TESTS_MODE = ($44ad67f277b5a1b5$var$_ref = (globalThis === null || globalThis === void 0 || ($44ad67f277b5a1b5$var$_process = globalThis.process) === null || $44ad67f277b5a1b5$var$_process === void 0 || ($44ad67f277b5a1b5$var$_process = $44ad67f277b5a1b5$var$_process.env) === null || $44ad67f277b5a1b5$var$_process === void 0 ? void 0 : $44ad67f277b5a1b5$var$_process.JEST_WORKER_ID) !== undefined, $44ad67f277b5a1b5$var$_ref !== void 0) ? $44ad67f277b5a1b5$var$_ref : false;
var $44ad67f277b5a1b5$var$DEBUG_MODE = !$44ad67f277b5a1b5$var$TESTS_MODE && (globalThis === null || globalThis === void 0 || ($44ad67f277b5a1b5$var$_process2 = globalThis.process) === null || $44ad67f277b5a1b5$var$_process2 === void 0 || ($44ad67f277b5a1b5$var$_process2 = $44ad67f277b5a1b5$var$_process2.env) === null || $44ad67f277b5a1b5$var$_process2 === void 0 ? void 0 : $44ad67f277b5a1b5$var$_process2.NODE_ENV) !== "production";
var $44ad67f277b5a1b5$export$1c9f709888824e05 = function debug() {
    var _console;
    if (!$44ad67f277b5a1b5$var$DEBUG_MODE) return;
    // eslint-disable-next-line no-console
    (_console = console).debug.apply(_console, arguments);
};

});

parcelRegister("ahJoN", function(module, exports) {
// shim for using process in browser
var $77ceb534f52a249d$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $77ceb534f52a249d$var$cachedSetTimeout;
var $77ceb534f52a249d$var$cachedClearTimeout;
function $77ceb534f52a249d$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $77ceb534f52a249d$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $77ceb534f52a249d$var$cachedSetTimeout = setTimeout;
        else $77ceb534f52a249d$var$cachedSetTimeout = $77ceb534f52a249d$var$defaultSetTimout;
    } catch (e) {
        $77ceb534f52a249d$var$cachedSetTimeout = $77ceb534f52a249d$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $77ceb534f52a249d$var$cachedClearTimeout = clearTimeout;
        else $77ceb534f52a249d$var$cachedClearTimeout = $77ceb534f52a249d$var$defaultClearTimeout;
    } catch (e) {
        $77ceb534f52a249d$var$cachedClearTimeout = $77ceb534f52a249d$var$defaultClearTimeout;
    }
})();
function $77ceb534f52a249d$var$runTimeout(fun) {
    if ($77ceb534f52a249d$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($77ceb534f52a249d$var$cachedSetTimeout === $77ceb534f52a249d$var$defaultSetTimout || !$77ceb534f52a249d$var$cachedSetTimeout) && setTimeout) {
        $77ceb534f52a249d$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $77ceb534f52a249d$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $77ceb534f52a249d$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $77ceb534f52a249d$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $77ceb534f52a249d$var$runClearTimeout(marker) {
    if ($77ceb534f52a249d$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($77ceb534f52a249d$var$cachedClearTimeout === $77ceb534f52a249d$var$defaultClearTimeout || !$77ceb534f52a249d$var$cachedClearTimeout) && clearTimeout) {
        $77ceb534f52a249d$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $77ceb534f52a249d$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $77ceb534f52a249d$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $77ceb534f52a249d$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $77ceb534f52a249d$var$queue = [];
var $77ceb534f52a249d$var$draining = false;
var $77ceb534f52a249d$var$currentQueue;
var $77ceb534f52a249d$var$queueIndex = -1;
function $77ceb534f52a249d$var$cleanUpNextTick() {
    if (!$77ceb534f52a249d$var$draining || !$77ceb534f52a249d$var$currentQueue) return;
    $77ceb534f52a249d$var$draining = false;
    if ($77ceb534f52a249d$var$currentQueue.length) $77ceb534f52a249d$var$queue = $77ceb534f52a249d$var$currentQueue.concat($77ceb534f52a249d$var$queue);
    else $77ceb534f52a249d$var$queueIndex = -1;
    if ($77ceb534f52a249d$var$queue.length) $77ceb534f52a249d$var$drainQueue();
}
function $77ceb534f52a249d$var$drainQueue() {
    if ($77ceb534f52a249d$var$draining) return;
    var timeout = $77ceb534f52a249d$var$runTimeout($77ceb534f52a249d$var$cleanUpNextTick);
    $77ceb534f52a249d$var$draining = true;
    var len = $77ceb534f52a249d$var$queue.length;
    while(len){
        $77ceb534f52a249d$var$currentQueue = $77ceb534f52a249d$var$queue;
        $77ceb534f52a249d$var$queue = [];
        while(++$77ceb534f52a249d$var$queueIndex < len)if ($77ceb534f52a249d$var$currentQueue) $77ceb534f52a249d$var$currentQueue[$77ceb534f52a249d$var$queueIndex].run();
        $77ceb534f52a249d$var$queueIndex = -1;
        len = $77ceb534f52a249d$var$queue.length;
    }
    $77ceb534f52a249d$var$currentQueue = null;
    $77ceb534f52a249d$var$draining = false;
    $77ceb534f52a249d$var$runClearTimeout(timeout);
}
$77ceb534f52a249d$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $77ceb534f52a249d$var$queue.push(new $77ceb534f52a249d$var$Item(fun, args));
    if ($77ceb534f52a249d$var$queue.length === 1 && !$77ceb534f52a249d$var$draining) $77ceb534f52a249d$var$runTimeout($77ceb534f52a249d$var$drainQueue);
};
// v8 likes predictible objects
function $77ceb534f52a249d$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$77ceb534f52a249d$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$77ceb534f52a249d$var$process.title = "browser";
$77ceb534f52a249d$var$process.browser = true;
$77ceb534f52a249d$var$process.env = {};
$77ceb534f52a249d$var$process.argv = [];
$77ceb534f52a249d$var$process.version = ""; // empty string to avoid regexp issues
$77ceb534f52a249d$var$process.versions = {};
function $77ceb534f52a249d$var$noop() {}
$77ceb534f52a249d$var$process.on = $77ceb534f52a249d$var$noop;
$77ceb534f52a249d$var$process.addListener = $77ceb534f52a249d$var$noop;
$77ceb534f52a249d$var$process.once = $77ceb534f52a249d$var$noop;
$77ceb534f52a249d$var$process.off = $77ceb534f52a249d$var$noop;
$77ceb534f52a249d$var$process.removeListener = $77ceb534f52a249d$var$noop;
$77ceb534f52a249d$var$process.removeAllListeners = $77ceb534f52a249d$var$noop;
$77ceb534f52a249d$var$process.emit = $77ceb534f52a249d$var$noop;
$77ceb534f52a249d$var$process.prependListener = $77ceb534f52a249d$var$noop;
$77ceb534f52a249d$var$process.prependOnceListener = $77ceb534f52a249d$var$noop;
$77ceb534f52a249d$var$process.listeners = function(name) {
    return [];
};
$77ceb534f52a249d$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$77ceb534f52a249d$var$process.cwd = function() {
    return "/";
};
$77ceb534f52a249d$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$77ceb534f52a249d$var$process.umask = function() {
    return 0;
};

});



parcelRegister("lmeW1", function(module, exports) {

$parcel$export(module.exports, "isContainedWithinMediaWrapper", function () { return $f8c73cca5b4d4edb$export$f61fbc3b9c4a9019; });

var $4zYxT = parcelRequire("4zYxT");
var $f8c73cca5b4d4edb$export$f61fbc3b9c4a9019 = function isContainedWithinMediaWrapper(node) {
    while(node){
        if (node instanceof Element && node.hasAttribute((0, $4zYxT.MEDIA_WRAPPER_TAG))) return true;
        node = node.parentNode;
    }
    return false;
};

});
parcelRegister("4zYxT", function(module, exports) {

$parcel$export(module.exports, "MEDIA_WRAPPER_TAG", function () { return $3559656c3fa1dd72$export$7674290405cc25b0; });

var $5yl5q = parcelRequire("5yl5q");

var $dAx5m = parcelRequire("dAx5m");
var $3559656c3fa1dd72$export$7674290405cc25b0 = "data-media-vc-wrapper";
var $3559656c3fa1dd72$export$7028e9efe569888c = (0, (/*@__PURE__*/$parcel$interopDefault($5yl5q)))({}, $3559656c3fa1dd72$export$7674290405cc25b0, true);
function $3559656c3fa1dd72$export$2e2bcd8739ae039(_ref) {
    var children = _ref.children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement("div", $3559656c3fa1dd72$export$7028e9efe569888c, children);
}

});


parcelRegister("4NDaq", function(module, exports) {

$parcel$export(module.exports, "EditorLnvHandler", function () { return $37ea1ecb7b9770cc$export$569bcb41b9a84ec8; });

var $3YpK2 = parcelRequire("3YpK2");

var $6KIrE = parcelRequire("6KIrE");

var $5yl5q = parcelRequire("5yl5q");
var $37ea1ecb7b9770cc$var$placeholderDataKey = "editorLnvPlaceholder"; // data-editor-lnv-placeholder
var $37ea1ecb7b9770cc$var$replaceDataKey = "editorLnvPlaceholderReplace"; // data-editor-lnv-placeholder-replace
var $37ea1ecb7b9770cc$export$569bcb41b9a84ec8 = /*#__PURE__*/ function() {
    function EditorLnvHandler() {
        var _this = this;
        (0, (/*@__PURE__*/$parcel$interopDefault($3YpK2)))(this, EditorLnvHandler);
        (0, (/*@__PURE__*/$parcel$interopDefault($5yl5q)))(this, "placeholders", new Map());
        (0, (/*@__PURE__*/$parcel$interopDefault($5yl5q)))(this, "getSizeCallbacks", new Map());
        (0, (/*@__PURE__*/$parcel$interopDefault($5yl5q)))(this, "isAddedPlaceholderMatchingSizeCallbacks", new Map());
        (0, (/*@__PURE__*/$parcel$interopDefault($5yl5q)))(this, "isAddedReplaceMatchingSizeCallbacks", new Map());
        (0, (/*@__PURE__*/$parcel$interopDefault($5yl5q)))(this, "intersectionObserverCallback", function(_ref) {
            var _target$dataset, _target$dataset2;
            var target = _ref.target, boundingClientRect = _ref.boundingClientRect;
            _this.intersectionObserver.unobserve(target);
            if (!(target instanceof HTMLElement)) return;
            var placeholderId = (_target$dataset = target.dataset) === null || _target$dataset === void 0 ? void 0 : _target$dataset[$37ea1ecb7b9770cc$var$placeholderDataKey];
            if (placeholderId && _this.getSizeCallbacks.has(placeholderId)) {
                var _resolve = _this.getSizeCallbacks.get(placeholderId);
                _this.getSizeCallbacks.delete(placeholderId);
                if (!_resolve) return;
                _resolve({
                    x: boundingClientRect.x,
                    y: boundingClientRect.y,
                    width: boundingClientRect.width,
                    height: boundingClientRect.height
                });
                return;
            }
            if (placeholderId && _this.isAddedPlaceholderMatchingSizeCallbacks.has(placeholderId)) {
                var _resolve2 = _this.isAddedPlaceholderMatchingSizeCallbacks.get(placeholderId);
                _this.isAddedPlaceholderMatchingSizeCallbacks.delete(placeholderId);
                if (!_resolve2) return;
                var placeholder = _this.placeholders.get(placeholderId);
                if (!placeholder) {
                    _resolve2(false);
                    return;
                }
                _resolve2(_this.areRectsSameSize(placeholder, boundingClientRect));
                return;
            }
            var replaceId = (_target$dataset2 = target.dataset) === null || _target$dataset2 === void 0 ? void 0 : _target$dataset2[$37ea1ecb7b9770cc$var$replaceDataKey];
            if (replaceId && _this.isAddedReplaceMatchingSizeCallbacks.has(replaceId)) {
                var _resolve3 = _this.isAddedReplaceMatchingSizeCallbacks.get(replaceId);
                _this.isAddedReplaceMatchingSizeCallbacks.delete(replaceId);
                if (!_resolve3) return;
                var _placeholder = _this.placeholders.get(replaceId);
                if (!_placeholder) {
                    _resolve3(false);
                    return;
                }
                _this.placeholders.delete(replaceId);
                _resolve3(_this.areRectsSameSize(_placeholder, boundingClientRect));
                return;
            }
        });
        this.intersectionObserver = new IntersectionObserver(function(entries) {
            return entries.filter(function(entry) {
                return entry.intersectionRatio > 0;
            }).forEach(_this.intersectionObserverCallback);
        });
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($6KIrE)))(EditorLnvHandler, [
        {
            key: "shouldHandleAddedNode",
            value: function shouldHandleAddedNode(el) {
                var _el$dataset, _el$dataset2;
                return ((_el$dataset = el.dataset) === null || _el$dataset === void 0 ? void 0 : _el$dataset[$37ea1ecb7b9770cc$var$placeholderDataKey]) || ((_el$dataset2 = el.dataset) === null || _el$dataset2 === void 0 ? void 0 : _el$dataset2[$37ea1ecb7b9770cc$var$replaceDataKey]);
            }
        },
        {
            key: "handleAddedNode",
            value: function handleAddedNode(el) {
                var _el$dataset3, _el$dataset4;
                // If it placeholder does not already exist, add it to the map
                var placeholderId = (_el$dataset3 = el.dataset) === null || _el$dataset3 === void 0 ? void 0 : _el$dataset3[$37ea1ecb7b9770cc$var$placeholderDataKey];
                if (placeholderId) return this.handleAddedPlaceholderNode(el, placeholderId);
                var replaceId = (_el$dataset4 = el.dataset) === null || _el$dataset4 === void 0 ? void 0 : _el$dataset4[$37ea1ecb7b9770cc$var$replaceDataKey];
                if (replaceId) return this.handleAddedReplaceNode(el, replaceId);
                return Promise.resolve({
                    shouldIgnore: false
                });
            }
        },
        {
            key: "clear",
            value: function clear() {
                this.placeholders.clear();
                this.intersectionObserver.disconnect();
            }
        },
        {
            key: "handleAddedPlaceholderNode",
            value: function handleAddedPlaceholderNode(el, placeholderId) {
                if (this.isExistingPlaceholder(placeholderId)) return this.isAddedPlaceholderMatchingSize(el, placeholderId).then(function(isMatching) {
                    return {
                        shouldIgnore: isMatching
                    };
                });
                return this.registerPlaceholder(el, placeholderId).then(function() {
                    return {
                        shouldIgnore: false
                    };
                });
            }
        },
        {
            key: "handleAddedReplaceNode",
            value: function handleAddedReplaceNode(el, placeholderId) {
                if (this.isExistingPlaceholder(placeholderId)) return this.isAddedReplaceMatchingSize(el, placeholderId).then(function(isMatching) {
                    return {
                        shouldIgnore: isMatching
                    };
                });
                return Promise.resolve({
                    shouldIgnore: false
                });
            }
        },
        {
            key: "isExistingPlaceholder",
            value: function isExistingPlaceholder(placeholderId) {
                return this.placeholders.has(placeholderId);
            }
        },
        {
            key: "registerPlaceholder",
            value: function registerPlaceholder(el, placeholderId) {
                var _this2 = this;
                return this.getSize(el, placeholderId).then(function(size) {
                    _this2.placeholders.set(placeholderId, size);
                });
            }
        },
        {
            key: "getSize",
            value: function getSize(el, placeholderId) {
                var _this3 = this;
                return new Promise(function(resolve) {
                    _this3.getSizeCallbacks.set(placeholderId, resolve);
                    _this3.intersectionObserver.observe(el);
                });
            }
        },
        {
            key: "isAddedPlaceholderMatchingSize",
            value: function isAddedPlaceholderMatchingSize(el, placeholderId) {
                var _this4 = this;
                return new Promise(function(resolve) {
                    _this4.isAddedPlaceholderMatchingSizeCallbacks.set(placeholderId, resolve);
                    _this4.intersectionObserver.observe(el);
                });
            }
        },
        {
            key: "isAddedReplaceMatchingSize",
            value: function isAddedReplaceMatchingSize(el, placeholderId) {
                var _this5 = this;
                return new Promise(function(resolve) {
                    _this5.isAddedReplaceMatchingSizeCallbacks.set(placeholderId, resolve);
                    _this5.intersectionObserver.observe(el);
                });
            }
        },
        {
            key: "areRectsSameSize",
            value: function areRectsSameSize(a, b) {
                return Math.abs(a.width - b.width) < 1 && Math.abs(a.height - b.height) < 1;
            }
        }
    ]);
    return EditorLnvHandler;
}();

});

parcelRegister("535hQ", function(module, exports) {

$parcel$export(module.exports, "SSRPlaceholderHandlers", function () { return $3ad1556e3b622847$export$c0102f1a1198d10f; });

var $3YpK2 = parcelRequire("3YpK2");

var $6KIrE = parcelRequire("6KIrE");

var $5yl5q = parcelRequire("5yl5q");
var $3ad1556e3b622847$var$EQUALITY_THRESHOLD = 0.1;
var $3ad1556e3b622847$var$ANCESTOR_LOOKUP_LIMIT = 10;
var $3ad1556e3b622847$export$c0102f1a1198d10f = /*#__PURE__*/ function() {
    function SSRPlaceholderHandlers() {
        var _this = this;
        (0, (/*@__PURE__*/$parcel$interopDefault($3YpK2)))(this, SSRPlaceholderHandlers);
        (0, (/*@__PURE__*/$parcel$interopDefault($5yl5q)))(this, "staticPlaceholders", new Map());
        (0, (/*@__PURE__*/$parcel$interopDefault($5yl5q)))(this, "callbacks", new Map());
        (0, (/*@__PURE__*/$parcel$interopDefault($5yl5q)))(this, "getSizeCallbacks", new Map());
        (0, (/*@__PURE__*/$parcel$interopDefault($5yl5q)))(this, "reactValidateCallbacks", new Map());
        (0, (/*@__PURE__*/$parcel$interopDefault($5yl5q)))(this, "intersectionObserverCallback", function(_ref) {
            var target = _ref.target, boundingClientRect = _ref.boundingClientRect;
            _this.intersectionObserver.unobserve(target);
            if (!(target instanceof HTMLElement)) // impossible case - keep typescript healthy
            return;
            var staticKey = target.dataset.ssrPlaceholder || "";
            if (staticKey) {
                if (_this.staticPlaceholders.has(staticKey) && _this.callbacks.has(staticKey)) {
                    // validation
                    var _resolve = _this.callbacks.get(staticKey);
                    if (!_resolve) return;
                    var rect = _this.staticPlaceholders.get(staticKey);
                    var hasSameSizePosition = _this.hasSameSizePosition(rect, boundingClientRect);
                    _resolve(hasSameSizePosition);
                    _this.callbacks.delete(staticKey);
                }
            } else {
                var key = target.dataset.ssrPlaceholderReplace || "";
                var _resolve2 = _this.reactValidateCallbacks.get(key);
                if (!_resolve2) return;
                var _rect = _this.staticPlaceholders.get(key);
                var _hasSameSizePosition = _this.hasSameSizePosition(_rect, boundingClientRect);
                _resolve2(_hasSameSizePosition);
                _this.staticPlaceholders.delete(staticKey);
                _this.reactValidateCallbacks.delete(staticKey);
            }
        });
        this.intersectionObserver = new IntersectionObserver(function(entries) {
            return entries.filter(function(entry) {
                return entry.intersectionRatio > 0;
            }).forEach(_this.intersectionObserverCallback);
        });
        if (window.document) try {
            var existingElements = document.querySelectorAll("[data-ssr-placeholder]");
            existingElements.forEach(function(el) {
                var _el$dataset;
                if (el instanceof HTMLElement && el !== null && el !== void 0 && (_el$dataset = el.dataset) !== null && _el$dataset !== void 0 && _el$dataset.ssrPlaceholder) {
                    var _window$__SSR_PLACEHO;
                    var width = -1;
                    var height = -1;
                    var x = -1;
                    var y = -1;
                    var boundingClientRect = (_window$__SSR_PLACEHO = window.__SSR_PLACEHOLDERS_DIMENSIONS__) === null || _window$__SSR_PLACEHO === void 0 ? void 0 : _window$__SSR_PLACEHO[el.dataset.ssrPlaceholder];
                    if (boundingClientRect) {
                        width = boundingClientRect.width;
                        height = boundingClientRect.height;
                        x = boundingClientRect.x;
                        y = boundingClientRect.y;
                    }
                    _this.staticPlaceholders.set(el.dataset.ssrPlaceholder, {
                        width: width,
                        height: height,
                        x: x,
                        y: y
                    });
                    _this.intersectionObserver.observe(el);
                }
            });
        } catch (e) {} finally{
            delete window.__SSR_PLACEHOLDERS_DIMENSIONS__;
        }
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($6KIrE)))(SSRPlaceholderHandlers, [
        {
            key: "clear",
            value: function clear() {
                this.staticPlaceholders = new Map();
                this.callbacks = new Map();
                this.getSizeCallbacks = new Map();
                this.reactValidateCallbacks = new Map();
            }
        },
        {
            key: "isPlaceholder",
            value: function isPlaceholder(element) {
                return Boolean(element.dataset.ssrPlaceholder);
            }
        },
        {
            key: "isPlaceholderReplacement",
            value: function isPlaceholderReplacement(element) {
                return Boolean(element.dataset.ssrPlaceholderReplace);
            }
        },
        {
            key: "isPlaceholderIgnored",
            value: function isPlaceholderIgnored(element) {
                // data-ssr-placeholder-ignored doesn't have a value.
                return "ssrPlaceholderIgnored" in element.dataset;
            }
        },
        {
            key: "findNearestPlaceholderContainerIfIgnored",
            value: function findNearestPlaceholderContainerIfIgnored(element) {
                if (!this.isPlaceholderIgnored(element)) return element;
                var ancestor = element.parentElement;
                var i = 0;
                while(ancestor && i < $3ad1556e3b622847$var$ANCESTOR_LOOKUP_LIMIT){
                    if (this.isPlaceholder(ancestor) || this.isPlaceholderReplacement(ancestor)) return ancestor;
                    ancestor = ancestor.parentElement;
                    i++;
                }
                return element;
            }
        },
        {
            key: "checkIfExistedAndSizeMatching",
            value: function checkIfExistedAndSizeMatching(el) {
                var _this2 = this;
                el = this.findNearestPlaceholderContainerIfIgnored(el);
                var id = el.dataset.ssrPlaceholder || "";
                return new Promise(function(resolve) {
                    if (!_this2.staticPlaceholders.has(id)) {
                        resolve(false);
                        return;
                    } else {
                        _this2.callbacks.set(id, resolve);
                        _this2.intersectionObserver.observe(el);
                    }
                });
            }
        },
        {
            key: "getSize",
            value: function getSize(el) {
                var _this3 = this;
                return new Promise(function(resolve) {
                    _this3.getSizeCallbacks.set(el.dataset.ssrPlaceholder || "", resolve);
                    _this3.intersectionObserver.observe(el);
                });
            }
        },
        {
            key: "validateReactComponentMatchToPlaceholder",
            value: function validateReactComponentMatchToPlaceholder(el) {
                var _this4 = this;
                el = this.findNearestPlaceholderContainerIfIgnored(el);
                var id = el.dataset.ssrPlaceholderReplace || "";
                return new Promise(function(resolve) {
                    if (!_this4.staticPlaceholders.has(id)) {
                        resolve(false);
                        return;
                    } else {
                        _this4.reactValidateCallbacks.set(id, resolve);
                        _this4.intersectionObserver.observe(el);
                    }
                });
            }
        },
        {
            key: "hasSameSizePosition",
            value: function hasSameSizePosition(rect, boundingClientRect) {
                return rect && Math.abs(rect.x - boundingClientRect.x) < $3ad1556e3b622847$var$EQUALITY_THRESHOLD && Math.abs(rect.y - boundingClientRect.y) < $3ad1556e3b622847$var$EQUALITY_THRESHOLD && Math.abs(rect.width - boundingClientRect.width) < $3ad1556e3b622847$var$EQUALITY_THRESHOLD && Math.abs(rect.height - boundingClientRect.height) < $3ad1556e3b622847$var$EQUALITY_THRESHOLD || false;
            }
        }
    ]);
    return SSRPlaceholderHandlers;
}();

});




parcelRegister("91opC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $691724cb4458483b$export$2e2bcd8739ae039; });
var $691724cb4458483b$var$interactions = new Map();
var $691724cb4458483b$export$2e2bcd8739ae039 = $691724cb4458483b$var$interactions;

});

parcelRegister("5L5Ad", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4315ac3a00228f3b$export$2e2bcd8739ae039; });

var $3YpK2 = parcelRequire("3YpK2");

var $6KIrE = parcelRequire("6KIrE");

var $5yl5q = parcelRequire("5yl5q");

var $j1psf = parcelRequire("j1psf");

var $fxIAZ = parcelRequire("fxIAZ");
function $4315ac3a00228f3b$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $4315ac3a00228f3b$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $4315ac3a00228f3b$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($5yl5q)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $4315ac3a00228f3b$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $4315ac3a00228f3b$var$POST_INTERACTION_LOG_SEND_DEFAULT_TIMEOUT = 3000;
var $4315ac3a00228f3b$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function PostInteractionLog() {
        (0, (/*@__PURE__*/$parcel$interopDefault($3YpK2)))(this, PostInteractionLog);
        /**
     * Basic info about interaction that has just finished
     */ (0, (/*@__PURE__*/$parcel$interopDefault($5yl5q)))(this, "lastInteractionFinish", null);
        /**
     * Array of observed react render timings
     */ (0, (/*@__PURE__*/$parcel$interopDefault($5yl5q)))(this, "reactProfilerTimings", []);
        /**
     * Store the scheduled sink timeout Id so that it can be cancelled when needed
     */ (0, (/*@__PURE__*/$parcel$interopDefault($5yl5q)))(this, "sinkTimeoutId", null);
        /**
     * independent VC observer, that observes until `custom.post-interaction-logs` event is sent
     */ (0, (/*@__PURE__*/$parcel$interopDefault($5yl5q)))(this, "vcObserver", null);
        (0, (/*@__PURE__*/$parcel$interopDefault($5yl5q)))(this, "vcObserverSSRConfig", null);
        /**
     * Handler function to process / send the observation data
     */ (0, (/*@__PURE__*/$parcel$interopDefault($5yl5q)))(this, "sinkHandlerFn", function() {});
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($6KIrE)))(PostInteractionLog, [
        {
            key: "initializeVCObserver",
            value: function initializeVCObserver(options) {
                if (this.vcObserver === null) this.vcObserver = new (0, $fxIAZ.VCObserver)($4315ac3a00228f3b$var$_objectSpread($4315ac3a00228f3b$var$_objectSpread({}, options), {}, {
                    isPostInteraction: true
                }));
            }
        },
        {
            key: "startVCObserver",
            value: function startVCObserver(_ref) {
                var _this$vcObserver;
                var startTime = _ref.startTime;
                (_this$vcObserver = this.vcObserver) === null || _this$vcObserver === void 0 || _this$vcObserver.start({
                    startTime: startTime
                });
            }
        },
        {
            key: "setVCObserverSSRConfig",
            value: function setVCObserverSSRConfig(vcObserverSSRConfig) {
                this.vcObserverSSRConfig = vcObserverSSRConfig;
            }
        },
        {
            key: "setLastInteractionFinishVCResult",
            value: function setLastInteractionFinishVCResult(result) {
                this.lastInteractionFinishVCResult = result;
            }
        },
        {
            key: "sinkHandler",
            value: /**
     * Set the fn that would be invoked to process / send the observation data
     */ function sinkHandler(sinkHandlerFn) {
                this.sinkHandlerFn = sinkHandlerFn;
            }
        },
        {
            key: "reset",
            value: function reset() {
                this.lastInteractionFinish = null;
                this.reactProfilerTimings = [];
                if (this.sinkTimeoutId != null) {
                    clearTimeout(this.sinkTimeoutId);
                    this.sinkTimeoutId = null;
                }
                this.setVCObserverSSRConfig(null);
            }
        },
        {
            key: "hasData",
            value: function hasData() {
                var _this$reactProfilerTi;
                return ((_this$reactProfilerTi = this.reactProfilerTimings) === null || _this$reactProfilerTi === void 0 ? void 0 : _this$reactProfilerTi.length) > 0;
            }
        },
        {
            key: "sendPostInteractionLog",
            value: function sendPostInteractionLog() {
                var _this$vcObserver2;
                if (!this.hasData() || !this.lastInteractionFinish || !this.sinkHandlerFn) {
                    this.reset();
                    return;
                }
                this.sinkHandlerFn({
                    lastInteractionFinish: this.lastInteractionFinish,
                    reactProfilerTimings: this.reactProfilerTimings,
                    // NOTE: invoking `getVCResult` at latest possible point in time here (not earlier) to get the most accurate result (from performance.now())
                    postInteractionFinishVCResult: (_this$vcObserver2 = this.vcObserver) === null || _this$vcObserver2 === void 0 ? void 0 : _this$vcObserver2.getVCResult($4315ac3a00228f3b$var$_objectSpread({
                        start: this.lastInteractionFinish.start,
                        stop: performance.now(),
                        tti: -1,
                        // no need for TTI value here
                        prefix: "ufo"
                    }, this.vcObserverSSRConfig)),
                    lastInteractionFinishVCResult: this.lastInteractionFinishVCResult
                });
                this.reset();
            }
        },
        {
            key: "onInteractionComplete",
            value: function onInteractionComplete(_ref2) {
                var _getConfig, _this = this;
                var ufoName = _ref2.ufoName, start = _ref2.start, end = _ref2.end, id = _ref2.id, abortReason = _ref2.abortReason, abortedByInteractionName = _ref2.abortedByInteractionName, routeName = _ref2.routeName, type = _ref2.type;
                this.lastInteractionFinish = {
                    ufoName: ufoName,
                    start: start,
                    end: end,
                    id: id,
                    abortReason: abortReason,
                    abortedByInteractionName: abortedByInteractionName,
                    routeName: routeName,
                    type: type
                };
                var timeout = ((_getConfig = (0, $j1psf.getConfig)()) === null || _getConfig === void 0 ? void 0 : _getConfig.timeWindowForLateMutationsInMilliseconds) || $4315ac3a00228f3b$var$POST_INTERACTION_LOG_SEND_DEFAULT_TIMEOUT;
                this.sinkTimeoutId = window.setTimeout(function() {
                    _this.sendPostInteractionLog();
                }, timeout);
            }
        },
        {
            key: "addProfilerTimings",
            value: function addProfilerTimings(labelStack, type, actualDuration, baseDuration, startTime, commitTime) {
                if (this.lastInteractionFinish != null) this.reactProfilerTimings.push({
                    type: type,
                    actualDuration: actualDuration,
                    baseDuration: baseDuration,
                    startTime: startTime,
                    commitTime: commitTime,
                    labelStack: labelStack
                });
            }
        }
    ]);
    return PostInteractionLog;
}();

});


parcelRegister("ld7xY", function(module, exports) {

$parcel$export(module.exports, "eventDataProcessor", function () { return $f710aa8f9b30ce97$export$896b6e121bbaec25; });

var $4BwFW = parcelRequire("4BwFW");

var $VeSwC = parcelRequire("VeSwC");

var $c39NH = parcelRequire("c39NH");

var $633Sk = parcelRequire("633Sk");

var $7rgZR = parcelRequire("7rgZR");

var $8xhEx = parcelRequire("8xhEx");

var $l6qdL = parcelRequire("l6qdL");

var $5Cf6U = parcelRequire("5Cf6U");

var $hDaJP = parcelRequire("hDaJP");

var $2r1YN = parcelRequire("2r1YN");

var $hAuux = parcelRequire("hAuux");

var $930nD = parcelRequire("930nD");

var $cxcgy = parcelRequire("cxcgy");

var $2KzCU = parcelRequire("2KzCU");

var $1c48R = parcelRequire("1c48R");

var $afLyZ = parcelRequire("afLyZ");

var $byc2l = parcelRequire("byc2l");

var $5roNT = parcelRequire("5roNT");

var $9wN85 = parcelRequire("9wN85");

var $ek9MI = parcelRequire("ek9MI");

var $48zWn = parcelRequire("48zWn");

var $cYu67 = parcelRequire("cYu67");

var $j2vLh = parcelRequire("j2vLh");

var $jx4t8 = parcelRequire("jx4t8");

var $hyQxC = parcelRequire("hyQxC");

var $8btua = parcelRequire("8btua");

var $8LnAj = parcelRequire("8LnAj");

var $5z2oW = parcelRequire("5z2oW");

var $iyv26 = parcelRequire("iyv26");

var $iSYNK = parcelRequire("iSYNK");

var $gQNe1 = parcelRequire("gQNe1");

var $ga5Vr = parcelRequire("ga5Vr");

var $7ojrT = parcelRequire("7ojrT");

var $1xsz9 = parcelRequire("1xsz9");

var $3UnzA = parcelRequire("3UnzA");

var $hppIa = parcelRequire("hppIa");

var $2jJXz = parcelRequire("2jJXz");

var $hWbKv = parcelRequire("hWbKv");

var $dKmTc = parcelRequire("dKmTc");

var $c2GEI = parcelRequire("c2GEI");
function $f710aa8f9b30ce97$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $f710aa8f9b30ce97$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $f710aa8f9b30ce97$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $f710aa8f9b30ce97$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $f710aa8f9b30ce97$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $f710aa8f9b30ce97$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
var $f710aa8f9b30ce97$var$defaultSet = [
    (0, $cxcgy.eventKey),
    (0, $5roNT.eventType),
    (0, $1c48R.eventProduct),
    (0, $byc2l.eventRoute),
    (0, $hAuux.eventId),
    (0, $2KzCU.eventLocalTime),
    (0, $afLyZ.eventRegion),
    (0, $l6qdL.appFramework),
    (0, $5Cf6U.appVersion),
    (0, $hDaJP.bmVersion),
    (0, $7ojrT.telemetryBrowser),
    (0, $1xsz9.telemetryCpu),
    (0, $3UnzA.telemetryMemory),
    (0, $hppIa.telemetryNetwork),
    (0, $2r1YN.customData),
    (0, $9wN85.featureFlags),
    (0, $ek9MI.hostname),
    (0, $iSYNK.productCustomData),
    (0, $2jJXz.appTimings),
    (0, $dKmTc.resourceTimings)
];
var $f710aa8f9b30ce97$var$pageLoadCommon = [].concat($f710aa8f9b30ce97$var$defaultSet, [
    (0, $5z2oW.pageVisibleState),
    (0, $iyv26.pageVisibleValue),
    (0, $930nD.eventInitial),
    (0, $hyQxC.pageLoadMetrics),
    (0, $hWbKv.bundleEvalTimings)
]);
var $f710aa8f9b30ce97$var$initialPageLoadSet = [].concat((0, (/*@__PURE__*/$parcel$interopDefault($VeSwC)))($f710aa8f9b30ce97$var$pageLoadCommon), [
    (0, $cYu67.initialPageLoadMetrics),
    (0, $jx4t8.navigationMetrics),
    (0, $ga5Vr.ssrSuccess),
    (0, $gQNe1.ssrFeatureFlags)
]);
var $f710aa8f9b30ce97$var$spaTransitionSet = (0, (/*@__PURE__*/$parcel$interopDefault($VeSwC)))($f710aa8f9b30ce97$var$pageLoadCommon);
var $f710aa8f9b30ce97$var$pageSegmentLoadSet = [].concat($f710aa8f9b30ce97$var$defaultSet, [
    (0, $8btua.pageSegmentLoadMetrics),
    (0, $5z2oW.pageVisibleState),
    (0, $iyv26.pageVisibleValue),
    (0, $930nD.eventInitial),
    (0, $hWbKv.bundleEvalTimings)
]);
var $f710aa8f9b30ce97$var$interactionSet = [].concat($f710aa8f9b30ce97$var$defaultSet, [
    (0, $5z2oW.pageVisibleState),
    (0, $iyv26.pageVisibleValue),
    (0, $j2vLh.interactionMetrics)
]);
var $f710aa8f9b30ce97$var$customMetricSet = [].concat($f710aa8f9b30ce97$var$defaultSet, [
    (0, $5z2oW.pageVisibleState),
    (0, $iyv26.pageVisibleValue),
    (0, $48zWn.customEventMetrics)
]);
// pageVisibleState and pageVisibleValue has been handled within webVitalsMetrics.
var $f710aa8f9b30ce97$var$webVitalsMetricSet = [].concat($f710aa8f9b30ce97$var$defaultSet, [
    (0, $8LnAj.webVitalsMetrics)
]);
// Function that returns a promise which resolves after clsWaitTimeMs + 500ms
// so that clsData is guaranteed to be attached to window
var $f710aa8f9b30ce97$var$waitForCLS = function waitForCLS() {
    var delay = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, $633Sk.clsWaitTimeMs) + 500;
    return new Promise(function(resolve) {
        return setTimeout(resolve, delay);
    });
};
var $f710aa8f9b30ce97$export$896b6e121bbaec25 = /*#__PURE__*/ function() {
    var _ref = (0, (/*@__PURE__*/$parcel$interopDefault($4BwFW)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($c39NH))).mark(function _callee(globalConfig, data) {
        var set, plugins, _iterator, _step, plugin, result, pluginResults, generated;
        return (0, (/*@__PURE__*/$parcel$interopDefault($c39NH))).wrap(function _callee$(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    if (!(data.start === null || data.stop === null)) {
                        _context.next = 3;
                        break;
                    }
                    (0, $7rgZR.logger).log('eventDataProcessor: Metric "'.concat(data.key, '" start or stop are incorrect; start: ').concat(data.start, "; stop: ").concat(data.stop));
                    return _context.abrupt("return", null);
                case 3:
                    set = [];
                    if (data.config.type === (0, $c2GEI.BMEventsType).PAGE_LOAD && (0, $8xhEx.isPageLoadMetricData)(data) && data.isInitial) set = $f710aa8f9b30ce97$var$initialPageLoadSet;
                    if (data.config.type === (0, $c2GEI.BMEventsType).PAGE_LOAD && (0, $8xhEx.isPageLoadMetricData)(data) && !data.isInitial) set = $f710aa8f9b30ce97$var$spaTransitionSet;
                    if (data.config.type === (0, $c2GEI.BMEventsType).PAGE_SEGMENT_LOAD && (0, $8xhEx.isPageSegmentLoadMetricData)(data)) set = $f710aa8f9b30ce97$var$pageSegmentLoadSet;
                    if (data.config.type === (0, $c2GEI.BMEventsType).INLINE_RESULT) set = $f710aa8f9b30ce97$var$interactionSet;
                    if (data.config.type === (0, $c2GEI.BMEventsType).CUSTOM) set = $f710aa8f9b30ce97$var$customMetricSet;
                    if (!(data.config.type === (0, $c2GEI.BMEventsType).WEB_VITALS)) {
                        _context.next = 13;
                        break;
                    }
                    set = $f710aa8f9b30ce97$var$webVitalsMetricSet;
                    // Wait for CLS to be recorded before proceeding to run plugin and attach CLS data
                    _context.next = 13;
                    return $f710aa8f9b30ce97$var$waitForCLS();
                case 13:
                    //TODO if type is different - do not send at all
                    plugins = [];
                    _iterator = $f710aa8f9b30ce97$var$_createForOfIteratorHelper(set);
                    _context.prev = 15;
                    _iterator.s();
                case 17:
                    if ((_step = _iterator.n()).done) {
                        _context.next = 25;
                        break;
                    }
                    plugin = _step.value;
                    _context.next = 21;
                    return plugin(data.config, data, // some plugins support page load specific data with special check
                    globalConfig);
                case 21:
                    result = _context.sent;
                    if (result) plugins.push(result);
                case 23:
                    _context.next = 17;
                    break;
                case 25:
                    _context.next = 30;
                    break;
                case 27:
                    _context.prev = 27;
                    _context.t0 = _context["catch"](15);
                    _iterator.e(_context.t0);
                case 30:
                    _context.prev = 30;
                    _iterator.f();
                    return _context.finish(30);
                case 33:
                    _context.next = 35;
                    return Promise.all(plugins);
                case 35:
                    pluginResults = _context.sent;
                    generated = {};
                    pluginResults.forEach(function(pluginResult) {
                        if (pluginResult === null) return;
                        Object.keys(pluginResult).forEach(function(key) {
                            var keyResult = pluginResult[key];
                            if (keyResult !== null && keyResult !== undefined) generated[key] = keyResult;
                        });
                    });
                    return _context.abrupt("return", generated);
                case 39:
                case "end":
                    return _context.stop();
            }
        }, _callee, null, [
            [
                15,
                27,
                30,
                33
            ]
        ]);
    }));
    return function eventDataProcessor(_x, _x2) {
        return _ref.apply(this, arguments);
    };
}();

});
parcelRegister("8xhEx", function(module, exports) {

$parcel$export(module.exports, "isPageLoadMetricData", function () { return $636f194505bcf2e6$export$b0e12e7abb0bff11; });
$parcel$export(module.exports, "isPageSegmentLoadMetricData", function () { return $636f194505bcf2e6$export$83d0099ee6dbb5b0; });
$parcel$export(module.exports, "isPageLoadConfig", function () { return $636f194505bcf2e6$export$8672fa27ba8bba88; });
$parcel$export(module.exports, "isPageSegmentLoadConfig", function () { return $636f194505bcf2e6$export$abe063537ef4987b; });
$parcel$export(module.exports, "isInteractionConfig", function () { return $636f194505bcf2e6$export$ae68674b6a9353be; });
$parcel$export(module.exports, "isCustomConfig", function () { return $636f194505bcf2e6$export$b493eb8b2ba87421; });

var $c2GEI = parcelRequire("c2GEI");
var $636f194505bcf2e6$export$b0e12e7abb0bff11 = function isPageLoadMetricData(data) {
    return data.type === (0, $c2GEI.BMEventsType).PAGE_LOAD;
};
var $636f194505bcf2e6$export$83d0099ee6dbb5b0 = function isPageSegmentLoadMetricData(data) {
    return data.type === (0, $c2GEI.BMEventsType).PAGE_SEGMENT_LOAD;
};
var $636f194505bcf2e6$export$8672fa27ba8bba88 = function isPageLoadConfig(data) {
    return data.type === (0, $c2GEI.BMEventsType).PAGE_LOAD;
};
var $636f194505bcf2e6$export$abe063537ef4987b = function isPageSegmentLoadConfig(data) {
    return data.type === (0, $c2GEI.BMEventsType).PAGE_SEGMENT_LOAD;
};
var $636f194505bcf2e6$export$ae68674b6a9353be = function isInteractionConfig(data) {
    return data.type === (0, $c2GEI.BMEventsType).INLINE_RESULT;
};
var $636f194505bcf2e6$export$b493eb8b2ba87421 = function isCustomConfig(data) {
    return data.type === (0, $c2GEI.BMEventsType).CUSTOM;
};

});

parcelRegister("l6qdL", function(module, exports) {

$parcel$export(module.exports, "appFramework", function () { return $f5ce7f764aec5f52$export$e34e4529b979f74c; });
var $f5ce7f764aec5f52$export$e34e4529b979f74c = function appFramework(_config, _data, globalConfig) {
    if (!globalConfig.app.framework) return null;
    return {
        "app:framework:name": globalConfig.app.framework.name,
        "app:framework:version": globalConfig.app.framework.version
    };
};

});

parcelRegister("5Cf6U", function(module, exports) {

$parcel$export(module.exports, "appVersion", function () { return $416c390064af7d0c$export$82ae485178b37419; });
var $416c390064af7d0c$export$82ae485178b37419 = function appVersion(_config, _data, globalConfig) {
    var pluginData = {
        "app:web:version": globalConfig.app.version.web
    };
    if (globalConfig.app.version.ssr) pluginData["app:ssr:version"] = globalConfig.app.version.ssr;
    return pluginData;
};

});

parcelRegister("hDaJP", function(module, exports) {

$parcel$export(module.exports, "bmVersion", function () { return $cd5e688a4afad49a$export$5cafa465fc876895; });
var $cd5e688a4afad49a$export$5cafa465fc876895 = function bmVersion() {
    return {
        "bm:version": 3
    };
};

});

parcelRegister("2r1YN", function(module, exports) {

$parcel$export(module.exports, "customData", function () { return $1c5fa37ea7ce8497$export$f7e743c7db162193; });

var $3q6vl = parcelRequire("3q6vl");
var $1c5fa37ea7ce8497$export$f7e743c7db162193 = function customData(_config, data) {
    var custom = {};
    var changed = false;
    if (data.custom) Object.entries(data.custom).forEach(function(_ref) {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($3q6vl)))(_ref, 2), key = _ref2[0], value = _ref2[1];
        changed = true;
        custom["custom:".concat(key)] = value;
    });
    return changed ? custom : null;
};

});

parcelRegister("hAuux", function(module, exports) {

$parcel$export(module.exports, "eventId", function () { return $ccdd736c25d541e0$export$aed28df7ac07d79a; });
var $ccdd736c25d541e0$export$aed28df7ac07d79a = function eventId(config) {
    return {
        "event:id": config.key
    };
};

});

parcelRegister("930nD", function(module, exports) {

$parcel$export(module.exports, "eventInitial", function () { return $6964b0655f522d9e$export$fa8e91d436b3ef8b; });

var $8xhEx = parcelRequire("8xhEx");
var $6964b0655f522d9e$export$fa8e91d436b3ef8b = function eventInitial(_config, data) {
    if (!(0, $8xhEx.isPageLoadMetricData)(data) && !(0, $8xhEx.isPageSegmentLoadMetricData)(data)) return null;
    return {
        "event:initial": data.isInitial
    };
};

});

parcelRegister("cxcgy", function(module, exports) {

$parcel$export(module.exports, "eventKey", function () { return $920214e5f09dd3dc$export$10be2d3a558d3f88; });

var $3pH2k = parcelRequire("3pH2k");
var $920214e5f09dd3dc$export$10be2d3a558d3f88 = function eventKey(config, _data, globalConfig) {
    return {
        "event:key": "".concat(globalConfig.product, ".fe.").concat((0, $3pH2k.mapEventType)(config.type), ".").concat(config.key)
    };
};

});
parcelRegister("3pH2k", function(module, exports) {

$parcel$export(module.exports, "mapEventType", function () { return $27c5170c7b462f02$export$b334d07f11140768; });

var $c2GEI = parcelRequire("c2GEI");
var $27c5170c7b462f02$export$b334d07f11140768 = function mapEventType(type) {
    switch(type){
        case (0, $c2GEI.BMEventsType).CUSTOM:
            return (0, $c2GEI.StorableBMEventsType).CUSTOM;
        case (0, $c2GEI.BMEventsType).INLINE_RESULT:
            return (0, $c2GEI.StorableBMEventsType).INLINE_RESULT;
        case (0, $c2GEI.BMEventsType).PAGE_LOAD:
            return (0, $c2GEI.StorableBMEventsType).PAGE_LOAD;
        case (0, $c2GEI.BMEventsType).PAGE_SEGMENT_LOAD:
            return (0, $c2GEI.StorableBMEventsType).PAGE_SEGMENT_LOAD;
        case (0, $c2GEI.BMEventsType).WEB_VITALS:
            return (0, $c2GEI.StorableBMEventsType).WEB_VITALS;
        default:
            return "unknown";
    }
};

});


parcelRegister("2KzCU", function(module, exports) {

$parcel$export(module.exports, "eventLocalTime", function () { return $200b835e5cfb1001$export$5219854ae7ec45da; });

var $24p43 = parcelRequire("24p43");
var $200b835e5cfb1001$export$5219854ae7ec45da = function eventLocalTime() {
    return {
        "event:localHour": parseInt((0, $24p43.default)(new Date(), "H"), 10),
        "event:localDayOfWeek": parseInt((0, $24p43.default)(new Date(), "i"), 10)
    };
};

});
parcelRegister("24p43", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $181f65c407645373$export$2e2bcd8739ae039; });

var $d1c2L = parcelRequire("d1c2L");

var $9IsgA = parcelRequire("9IsgA");

var $aS8if = parcelRequire("aS8if");

var $lsAN2 = parcelRequire("lsAN2");

var $8XvFh = parcelRequire("8XvFh");

var $zyeRg = parcelRequire("zyeRg");

var $7GH3R = parcelRequire("7GH3R");

var $b7jxr = parcelRequire("b7jxr");

var $6LVeH = parcelRequire("6LVeH");

var $NIBAi = parcelRequire("NIBAi");

var $8n1Xk = parcelRequire("8n1Xk");
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
var $181f65c407645373$var$formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
var $181f65c407645373$var$longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var $181f65c407645373$var$escapedStringRegExp = /^'([^]*?)'?$/;
var $181f65c407645373$var$doubleQuoteRegExp = /''/g;
var $181f65c407645373$var$unescapedLatinCharacterRegExp = /[a-zA-Z]/;
function $181f65c407645373$export$2e2bcd8739ae039(dirtyDate, dirtyFormatStr, options) {
    var _ref, _options$locale, _ref2, _ref3, _ref4, _options$firstWeekCon, _options$locale2, _options$locale2$opti, _defaultOptions$local, _defaultOptions$local2, _ref5, _ref6, _ref7, _options$weekStartsOn, _options$locale3, _options$locale3$opti, _defaultOptions$local3, _defaultOptions$local4;
    (0, $6LVeH.default)(2, arguments);
    var formatStr = String(dirtyFormatStr);
    var defaultOptions = (0, $NIBAi.getDefaultOptions)();
    var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : (0, $8n1Xk.default);
    var firstWeekContainsDate = (0, $b7jxr.default)((_ref2 = (_ref3 = (_ref4 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale2 = options.locale) === null || _options$locale2 === void 0 ? void 0 : (_options$locale2$opti = _options$locale2.options) === null || _options$locale2$opti === void 0 ? void 0 : _options$locale2$opti.firstWeekContainsDate) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : 1);
    // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
    var weekStartsOn = (0, $b7jxr.default)((_ref5 = (_ref6 = (_ref7 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale3 = options.locale) === null || _options$locale3 === void 0 ? void 0 : (_options$locale3$opti = _options$locale3.options) === null || _options$locale3$opti === void 0 ? void 0 : _options$locale3$opti.weekStartsOn) !== null && _ref7 !== void 0 ? _ref7 : defaultOptions.weekStartsOn) !== null && _ref6 !== void 0 ? _ref6 : (_defaultOptions$local3 = defaultOptions.locale) === null || _defaultOptions$local3 === void 0 ? void 0 : (_defaultOptions$local4 = _defaultOptions$local3.options) === null || _defaultOptions$local4 === void 0 ? void 0 : _defaultOptions$local4.weekStartsOn) !== null && _ref5 !== void 0 ? _ref5 : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
    if (!locale.localize) throw new RangeError("locale must contain localize property");
    if (!locale.formatLong) throw new RangeError("locale must contain formatLong property");
    var originalDate = (0, $aS8if.default)(dirtyDate);
    if (!(0, $d1c2L.default)(originalDate)) throw new RangeError("Invalid time value");
    // Convert the date in system timezone to the same date in UTC+00:00 timezone.
    // This ensures that when UTC functions will be implemented, locales will be compatible with them.
    // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/376
    var timezoneOffset = (0, $zyeRg.default)(originalDate);
    var utcDate = (0, $9IsgA.default)(originalDate, timezoneOffset);
    var formatterOptions = {
        firstWeekContainsDate: firstWeekContainsDate,
        weekStartsOn: weekStartsOn,
        locale: locale,
        _originalDate: originalDate
    };
    var result = formatStr.match($181f65c407645373$var$longFormattingTokensRegExp).map(function(substring) {
        var firstCharacter = substring[0];
        if (firstCharacter === "p" || firstCharacter === "P") {
            var longFormatter = (0, $8XvFh.default)[firstCharacter];
            return longFormatter(substring, locale.formatLong);
        }
        return substring;
    }).join("").match($181f65c407645373$var$formattingTokensRegExp).map(function(substring) {
        // Replace two single quote characters with one single quote character
        if (substring === "''") return "'";
        var firstCharacter = substring[0];
        if (firstCharacter === "'") return $181f65c407645373$var$cleanEscapedString(substring);
        var formatter = (0, $lsAN2.default)[firstCharacter];
        if (formatter) {
            if (!(options !== null && options !== void 0 && options.useAdditionalWeekYearTokens) && (0, $7GH3R.isProtectedWeekYearToken)(substring)) (0, $7GH3R.throwProtectedError)(substring, dirtyFormatStr, String(dirtyDate));
            if (!(options !== null && options !== void 0 && options.useAdditionalDayOfYearTokens) && (0, $7GH3R.isProtectedDayOfYearToken)(substring)) (0, $7GH3R.throwProtectedError)(substring, dirtyFormatStr, String(dirtyDate));
            return formatter(utcDate, substring, locale.localize, formatterOptions);
        }
        if (firstCharacter.match($181f65c407645373$var$unescapedLatinCharacterRegExp)) throw new RangeError("Format string contains an unescaped latin alphabet character `" + firstCharacter + "`");
        return substring;
    }).join("");
    return result;
}
function $181f65c407645373$var$cleanEscapedString(input) {
    var matched = input.match($181f65c407645373$var$escapedStringRegExp);
    if (!matched) return input;
    return matched[1].replace($181f65c407645373$var$doubleQuoteRegExp, "'");
}

});
parcelRegister("d1c2L", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $97a4b5f1151087db$export$2e2bcd8739ae039; });

var $as9Zx = parcelRequire("as9Zx");

var $aS8if = parcelRequire("aS8if");

var $6LVeH = parcelRequire("6LVeH");
function $97a4b5f1151087db$export$2e2bcd8739ae039(dirtyDate) {
    (0, $6LVeH.default)(1, arguments);
    if (!(0, $as9Zx.default)(dirtyDate) && typeof dirtyDate !== "number") return false;
    var date = (0, $aS8if.default)(dirtyDate);
    return !isNaN(Number(date));
}

});
parcelRegister("as9Zx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $79c445008befa5f9$export$2e2bcd8739ae039; });

var $gh6Ui = parcelRequire("gh6Ui");

var $6LVeH = parcelRequire("6LVeH");
function $79c445008befa5f9$export$2e2bcd8739ae039(value) {
    (0, $6LVeH.default)(1, arguments);
    return value instanceof Date || (0, $gh6Ui.default)(value) === "object" && Object.prototype.toString.call(value) === "[object Date]";
}

});


parcelRegister("9IsgA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $712e26431bbec7c6$export$2e2bcd8739ae039; });

var $lHpFP = parcelRequire("lHpFP");

var $6LVeH = parcelRequire("6LVeH");

var $b7jxr = parcelRequire("b7jxr");
function $712e26431bbec7c6$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $6LVeH.default)(2, arguments);
    var amount = (0, $b7jxr.default)(dirtyAmount);
    return (0, $lHpFP.default)(dirtyDate, -amount);
}

});
parcelRegister("lHpFP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fcc187648c5532c5$export$2e2bcd8739ae039; });

var $b7jxr = parcelRequire("b7jxr");

var $aS8if = parcelRequire("aS8if");

var $6LVeH = parcelRequire("6LVeH");
function $fcc187648c5532c5$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $6LVeH.default)(2, arguments);
    var timestamp = (0, $aS8if.default)(dirtyDate).getTime();
    var amount = (0, $b7jxr.default)(dirtyAmount);
    return new Date(timestamp + amount);
}

});
parcelRegister("b7jxr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $817f8111c3fb9279$export$2e2bcd8739ae039; });
function $817f8111c3fb9279$export$2e2bcd8739ae039(dirtyNumber) {
    if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) return NaN;
    var number = Number(dirtyNumber);
    if (isNaN(number)) return number;
    return number < 0 ? Math.ceil(number) : Math.floor(number);
}

});



parcelRegister("lsAN2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f9f8c03d22ef626e$export$2e2bcd8739ae039; });

var $bLrBS = parcelRequire("bLrBS");

var $Yw69Q = parcelRequire("Yw69Q");

var $lO2ve = parcelRequire("lO2ve");

var $9lbiU = parcelRequire("9lbiU");

var $fZpHh = parcelRequire("fZpHh");

var $iuBXe = parcelRequire("iuBXe");

var $diPJn = parcelRequire("diPJn");
var $f9f8c03d22ef626e$var$dayPeriodEnum = {
    am: "am",
    pm: "pm",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
};
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
 * |  d  | Day of month                   |  D  | Day of year                    |
 * |  e  | Local day of week              |  E  | Day of week                    |
 * |  f  |                                |  F* | Day of week in month           |
 * |  g* | Modified Julian day            |  G  | Era                            |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  i! | ISO day of week                |  I! | ISO week of year               |
 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
 * |  m  | Minute                         |  M  | Month                          |
 * |  n  |                                |  N  |                                |
 * |  o! | Ordinal number modifier        |  O  | Timezone (GMT)                 |
 * |  p! | Long localized time            |  P! | Long localized date            |
 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
 * |  u  | Extended year                  |  U* | Cyclic year                    |
 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
 * |  w  | Local week of year             |  W* | Week of month                  |
 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
 * |  z  | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 *
 * Letters marked by ! are non-standard, but implemented by date-fns:
 * - `o` modifies the previous token to turn it into an ordinal (see `format` docs)
 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
 *   i.e. 7 for Sunday, 1 for Monday, etc.
 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
 *   `R` is supposed to be used in conjunction with `I` and `i`
 *   for universal ISO week-numbering date, whereas
 *   `Y` is supposed to be used in conjunction with `w` and `e`
 *   for week-numbering date specific to the locale.
 * - `P` is long localized date format
 * - `p` is long localized time format
 */ var $f9f8c03d22ef626e$var$formatters = {
    // Era
    G: function G(date, token, localize) {
        var era = date.getUTCFullYear() > 0 ? 1 : 0;
        switch(token){
            // AD, BC
            case "G":
            case "GG":
            case "GGG":
                return localize.era(era, {
                    width: "abbreviated"
                });
            // A, B
            case "GGGGG":
                return localize.era(era, {
                    width: "narrow"
                });
            // Anno Domini, Before Christ
            case "GGGG":
            default:
                return localize.era(era, {
                    width: "wide"
                });
        }
    },
    // Year
    y: function y(date, token, localize) {
        // Ordinal number
        if (token === "yo") {
            var signedYear = date.getUTCFullYear();
            // Returns 1 for 1 BC (which is year 0 in JavaScript)
            var year = signedYear > 0 ? signedYear : 1 - signedYear;
            return localize.ordinalNumber(year, {
                unit: "year"
            });
        }
        return (0, $diPJn.default).y(date, token);
    },
    // Local week-numbering year
    Y: function Y(date, token, localize, options) {
        var signedWeekYear = (0, $fZpHh.default)(date, options);
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        var weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear;
        // Two digit year
        if (token === "YY") {
            var twoDigitYear = weekYear % 100;
            return (0, $iuBXe.default)(twoDigitYear, 2);
        }
        // Ordinal number
        if (token === "Yo") return localize.ordinalNumber(weekYear, {
            unit: "year"
        });
        // Padding
        return (0, $iuBXe.default)(weekYear, token.length);
    },
    // ISO week-numbering year
    R: function R(date, token) {
        var isoWeekYear = (0, $lO2ve.default)(date);
        // Padding
        return (0, $iuBXe.default)(isoWeekYear, token.length);
    },
    // Extended year. This is a single number designating the year of this calendar system.
    // The main difference between `y` and `u` localizers are B.C. years:
    // | Year | `y` | `u` |
    // |------|-----|-----|
    // | AC 1 |   1 |   1 |
    // | BC 1 |   1 |   0 |
    // | BC 2 |   2 |  -1 |
    // Also `yy` always returns the last two digits of a year,
    // while `uu` pads single digit years to 2 characters and returns other years unchanged.
    u: function u(date, token) {
        var year = date.getUTCFullYear();
        return (0, $iuBXe.default)(year, token.length);
    },
    // Quarter
    Q: function Q(date, token, localize) {
        var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case "Q":
                return String(quarter);
            // 01, 02, 03, 04
            case "QQ":
                return (0, $iuBXe.default)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case "Qo":
                return localize.ordinalNumber(quarter, {
                    unit: "quarter"
                });
            // Q1, Q2, Q3, Q4
            case "QQQ":
                return localize.quarter(quarter, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case "QQQQQ":
                return localize.quarter(quarter, {
                    width: "narrow",
                    context: "formatting"
                });
            // 1st quarter, 2nd quarter, ...
            case "QQQQ":
            default:
                return localize.quarter(quarter, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone quarter
    q: function q(date, token, localize) {
        var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case "q":
                return String(quarter);
            // 01, 02, 03, 04
            case "qq":
                return (0, $iuBXe.default)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case "qo":
                return localize.ordinalNumber(quarter, {
                    unit: "quarter"
                });
            // Q1, Q2, Q3, Q4
            case "qqq":
                return localize.quarter(quarter, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case "qqqqq":
                return localize.quarter(quarter, {
                    width: "narrow",
                    context: "standalone"
                });
            // 1st quarter, 2nd quarter, ...
            case "qqqq":
            default:
                return localize.quarter(quarter, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // Month
    M: function M(date, token, localize) {
        var month = date.getUTCMonth();
        switch(token){
            case "M":
            case "MM":
                return (0, $diPJn.default).M(date, token);
            // 1st, 2nd, ..., 12th
            case "Mo":
                return localize.ordinalNumber(month + 1, {
                    unit: "month"
                });
            // Jan, Feb, ..., Dec
            case "MMM":
                return localize.month(month, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // J, F, ..., D
            case "MMMMM":
                return localize.month(month, {
                    width: "narrow",
                    context: "formatting"
                });
            // January, February, ..., December
            case "MMMM":
            default:
                return localize.month(month, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone month
    L: function L(date, token, localize) {
        var month = date.getUTCMonth();
        switch(token){
            // 1, 2, ..., 12
            case "L":
                return String(month + 1);
            // 01, 02, ..., 12
            case "LL":
                return (0, $iuBXe.default)(month + 1, 2);
            // 1st, 2nd, ..., 12th
            case "Lo":
                return localize.ordinalNumber(month + 1, {
                    unit: "month"
                });
            // Jan, Feb, ..., Dec
            case "LLL":
                return localize.month(month, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // J, F, ..., D
            case "LLLLL":
                return localize.month(month, {
                    width: "narrow",
                    context: "standalone"
                });
            // January, February, ..., December
            case "LLLL":
            default:
                return localize.month(month, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // Local week of year
    w: function w(date, token, localize, options) {
        var week = (0, $9lbiU.default)(date, options);
        if (token === "wo") return localize.ordinalNumber(week, {
            unit: "week"
        });
        return (0, $iuBXe.default)(week, token.length);
    },
    // ISO week of year
    I: function I(date, token, localize) {
        var isoWeek = (0, $Yw69Q.default)(date);
        if (token === "Io") return localize.ordinalNumber(isoWeek, {
            unit: "week"
        });
        return (0, $iuBXe.default)(isoWeek, token.length);
    },
    // Day of the month
    d: function d(date, token, localize) {
        if (token === "do") return localize.ordinalNumber(date.getUTCDate(), {
            unit: "date"
        });
        return (0, $diPJn.default).d(date, token);
    },
    // Day of year
    D: function D(date, token, localize) {
        var dayOfYear = (0, $bLrBS.default)(date);
        if (token === "Do") return localize.ordinalNumber(dayOfYear, {
            unit: "dayOfYear"
        });
        return (0, $iuBXe.default)(dayOfYear, token.length);
    },
    // Day of week
    E: function E(date, token, localize) {
        var dayOfWeek = date.getUTCDay();
        switch(token){
            // Tue
            case "E":
            case "EE":
            case "EEE":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "EEEEE":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "EEEEEE":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "EEEE":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Local day of week
    e: function e(date, token, localize, options) {
        var dayOfWeek = date.getUTCDay();
        var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (Nth day of week with current locale or weekStartsOn)
            case "e":
                return String(localDayOfWeek);
            // Padded numerical value
            case "ee":
                return (0, $iuBXe.default)(localDayOfWeek, 2);
            // 1st, 2nd, ..., 7th
            case "eo":
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: "day"
                });
            case "eee":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "eeeee":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "eeeeee":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "eeee":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone local day of week
    c: function c(date, token, localize, options) {
        var dayOfWeek = date.getUTCDay();
        var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (same as in `e`)
            case "c":
                return String(localDayOfWeek);
            // Padded numerical value
            case "cc":
                return (0, $iuBXe.default)(localDayOfWeek, token.length);
            // 1st, 2nd, ..., 7th
            case "co":
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: "day"
                });
            case "ccc":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // T
            case "ccccc":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "standalone"
                });
            // Tu
            case "cccccc":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "standalone"
                });
            // Tuesday
            case "cccc":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // ISO day of week
    i: function i(date, token, localize) {
        var dayOfWeek = date.getUTCDay();
        var isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
        switch(token){
            // 2
            case "i":
                return String(isoDayOfWeek);
            // 02
            case "ii":
                return (0, $iuBXe.default)(isoDayOfWeek, token.length);
            // 2nd
            case "io":
                return localize.ordinalNumber(isoDayOfWeek, {
                    unit: "day"
                });
            // Tue
            case "iii":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "iiiii":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "iiiiii":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "iiii":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // AM or PM
    a: function a(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "a":
            case "aa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "aaa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                }).toLowerCase();
            case "aaaaa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "aaaa":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // AM, PM, midnight, noon
    b: function b(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue;
        if (hours === 12) dayPeriodEnumValue = $f9f8c03d22ef626e$var$dayPeriodEnum.noon;
        else if (hours === 0) dayPeriodEnumValue = $f9f8c03d22ef626e$var$dayPeriodEnum.midnight;
        else dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "b":
            case "bb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "bbb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                }).toLowerCase();
            case "bbbbb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "bbbb":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // in the morning, in the afternoon, in the evening, at night
    B: function B(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue;
        if (hours >= 17) dayPeriodEnumValue = $f9f8c03d22ef626e$var$dayPeriodEnum.evening;
        else if (hours >= 12) dayPeriodEnumValue = $f9f8c03d22ef626e$var$dayPeriodEnum.afternoon;
        else if (hours >= 4) dayPeriodEnumValue = $f9f8c03d22ef626e$var$dayPeriodEnum.morning;
        else dayPeriodEnumValue = $f9f8c03d22ef626e$var$dayPeriodEnum.night;
        switch(token){
            case "B":
            case "BB":
            case "BBB":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "BBBBB":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "BBBB":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Hour [1-12]
    h: function h(date, token, localize) {
        if (token === "ho") {
            var hours = date.getUTCHours() % 12;
            if (hours === 0) hours = 12;
            return localize.ordinalNumber(hours, {
                unit: "hour"
            });
        }
        return (0, $diPJn.default).h(date, token);
    },
    // Hour [0-23]
    H: function H(date, token, localize) {
        if (token === "Ho") return localize.ordinalNumber(date.getUTCHours(), {
            unit: "hour"
        });
        return (0, $diPJn.default).H(date, token);
    },
    // Hour [0-11]
    K: function K(date, token, localize) {
        var hours = date.getUTCHours() % 12;
        if (token === "Ko") return localize.ordinalNumber(hours, {
            unit: "hour"
        });
        return (0, $iuBXe.default)(hours, token.length);
    },
    // Hour [1-24]
    k: function k(date, token, localize) {
        var hours = date.getUTCHours();
        if (hours === 0) hours = 24;
        if (token === "ko") return localize.ordinalNumber(hours, {
            unit: "hour"
        });
        return (0, $iuBXe.default)(hours, token.length);
    },
    // Minute
    m: function m(date, token, localize) {
        if (token === "mo") return localize.ordinalNumber(date.getUTCMinutes(), {
            unit: "minute"
        });
        return (0, $diPJn.default).m(date, token);
    },
    // Second
    s: function s(date, token, localize) {
        if (token === "so") return localize.ordinalNumber(date.getUTCSeconds(), {
            unit: "second"
        });
        return (0, $diPJn.default).s(date, token);
    },
    // Fraction of second
    S: function S(date, token) {
        return (0, $diPJn.default).S(date, token);
    },
    // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
    X: function X(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        if (timezoneOffset === 0) return "Z";
        switch(token){
            // Hours and optional minutes
            case "X":
                return $f9f8c03d22ef626e$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XX`
            case "XXXX":
            case "XX":
                // Hours and minutes without `:` delimiter
                return $f9f8c03d22ef626e$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XXX`
            case "XXXXX":
            case "XXX":
            default:
                return $f9f8c03d22ef626e$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
    x: function x(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Hours and optional minutes
            case "x":
                return $f9f8c03d22ef626e$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xx`
            case "xxxx":
            case "xx":
                // Hours and minutes without `:` delimiter
                return $f9f8c03d22ef626e$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xxx`
            case "xxxxx":
            case "xxx":
            default:
                return $f9f8c03d22ef626e$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (GMT)
    O: function O(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Short
            case "O":
            case "OO":
            case "OOO":
                return "GMT" + $f9f8c03d22ef626e$var$formatTimezoneShort(timezoneOffset, ":");
            // Long
            case "OOOO":
            default:
                return "GMT" + $f9f8c03d22ef626e$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (specific non-location)
    z: function z(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Short
            case "z":
            case "zz":
            case "zzz":
                return "GMT" + $f9f8c03d22ef626e$var$formatTimezoneShort(timezoneOffset, ":");
            // Long
            case "zzzz":
            default:
                return "GMT" + $f9f8c03d22ef626e$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Seconds timestamp
    t: function t(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timestamp = Math.floor(originalDate.getTime() / 1000);
        return (0, $iuBXe.default)(timestamp, token.length);
    },
    // Milliseconds timestamp
    T: function T(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timestamp = originalDate.getTime();
        return (0, $iuBXe.default)(timestamp, token.length);
    }
};
function $f9f8c03d22ef626e$var$formatTimezoneShort(offset, dirtyDelimiter) {
    var sign = offset > 0 ? "-" : "+";
    var absOffset = Math.abs(offset);
    var hours = Math.floor(absOffset / 60);
    var minutes = absOffset % 60;
    if (minutes === 0) return sign + String(hours);
    var delimiter = dirtyDelimiter || "";
    return sign + String(hours) + delimiter + (0, $iuBXe.default)(minutes, 2);
}
function $f9f8c03d22ef626e$var$formatTimezoneWithOptionalMinutes(offset, dirtyDelimiter) {
    if (offset % 60 === 0) {
        var sign = offset > 0 ? "-" : "+";
        return sign + (0, $iuBXe.default)(Math.abs(offset) / 60, 2);
    }
    return $f9f8c03d22ef626e$var$formatTimezone(offset, dirtyDelimiter);
}
function $f9f8c03d22ef626e$var$formatTimezone(offset, dirtyDelimiter) {
    var delimiter = dirtyDelimiter || "";
    var sign = offset > 0 ? "-" : "+";
    var absOffset = Math.abs(offset);
    var hours = (0, $iuBXe.default)(Math.floor(absOffset / 60), 2);
    var minutes = (0, $iuBXe.default)(absOffset % 60, 2);
    return sign + hours + delimiter + minutes;
}
var $f9f8c03d22ef626e$export$2e2bcd8739ae039 = $f9f8c03d22ef626e$var$formatters;

});
parcelRegister("bLrBS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8909803a09aa4287$export$2e2bcd8739ae039; });

var $aS8if = parcelRequire("aS8if");

var $6LVeH = parcelRequire("6LVeH");
var $8909803a09aa4287$var$MILLISECONDS_IN_DAY = 86400000;
function $8909803a09aa4287$export$2e2bcd8739ae039(dirtyDate) {
    (0, $6LVeH.default)(1, arguments);
    var date = (0, $aS8if.default)(dirtyDate);
    var timestamp = date.getTime();
    date.setUTCMonth(0, 1);
    date.setUTCHours(0, 0, 0, 0);
    var startOfYearTimestamp = date.getTime();
    var difference = timestamp - startOfYearTimestamp;
    return Math.floor(difference / $8909803a09aa4287$var$MILLISECONDS_IN_DAY) + 1;
}

});

parcelRegister("Yw69Q", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0b5e80c4d8f404f8$export$2e2bcd8739ae039; });

var $aS8if = parcelRequire("aS8if");

var $1D7tP = parcelRequire("1D7tP");

var $ghU15 = parcelRequire("ghU15");

var $6LVeH = parcelRequire("6LVeH");
var $0b5e80c4d8f404f8$var$MILLISECONDS_IN_WEEK = 604800000;
function $0b5e80c4d8f404f8$export$2e2bcd8739ae039(dirtyDate) {
    (0, $6LVeH.default)(1, arguments);
    var date = (0, $aS8if.default)(dirtyDate);
    var diff = (0, $1D7tP.default)(date).getTime() - (0, $ghU15.default)(date).getTime();
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / $0b5e80c4d8f404f8$var$MILLISECONDS_IN_WEEK) + 1;
}

});
parcelRegister("1D7tP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $12ff3c58c88dd911$export$2e2bcd8739ae039; });

var $aS8if = parcelRequire("aS8if");

var $6LVeH = parcelRequire("6LVeH");
function $12ff3c58c88dd911$export$2e2bcd8739ae039(dirtyDate) {
    (0, $6LVeH.default)(1, arguments);
    var weekStartsOn = 1;
    var date = (0, $aS8if.default)(dirtyDate);
    var day = date.getUTCDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setUTCDate(date.getUTCDate() - diff);
    date.setUTCHours(0, 0, 0, 0);
    return date;
}

});

parcelRegister("ghU15", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bdb9af951ce68cc8$export$2e2bcd8739ae039; });

var $lO2ve = parcelRequire("lO2ve");

var $1D7tP = parcelRequire("1D7tP");

var $6LVeH = parcelRequire("6LVeH");
function $bdb9af951ce68cc8$export$2e2bcd8739ae039(dirtyDate) {
    (0, $6LVeH.default)(1, arguments);
    var year = (0, $lO2ve.default)(dirtyDate);
    var fourthOfJanuary = new Date(0);
    fourthOfJanuary.setUTCFullYear(year, 0, 4);
    fourthOfJanuary.setUTCHours(0, 0, 0, 0);
    var date = (0, $1D7tP.default)(fourthOfJanuary);
    return date;
}

});
parcelRegister("lO2ve", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fe003573db643fbd$export$2e2bcd8739ae039; });

var $aS8if = parcelRequire("aS8if");

var $6LVeH = parcelRequire("6LVeH");

var $1D7tP = parcelRequire("1D7tP");
function $fe003573db643fbd$export$2e2bcd8739ae039(dirtyDate) {
    (0, $6LVeH.default)(1, arguments);
    var date = (0, $aS8if.default)(dirtyDate);
    var year = date.getUTCFullYear();
    var fourthOfJanuaryOfNextYear = new Date(0);
    fourthOfJanuaryOfNextYear.setUTCFullYear(year + 1, 0, 4);
    fourthOfJanuaryOfNextYear.setUTCHours(0, 0, 0, 0);
    var startOfNextYear = (0, $1D7tP.default)(fourthOfJanuaryOfNextYear);
    var fourthOfJanuaryOfThisYear = new Date(0);
    fourthOfJanuaryOfThisYear.setUTCFullYear(year, 0, 4);
    fourthOfJanuaryOfThisYear.setUTCHours(0, 0, 0, 0);
    var startOfThisYear = (0, $1D7tP.default)(fourthOfJanuaryOfThisYear);
    if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}

});



parcelRegister("9lbiU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6cced7f5392963e2$export$2e2bcd8739ae039; });

var $aS8if = parcelRequire("aS8if");

var $aGqcG = parcelRequire("aGqcG");

var $2bLXn = parcelRequire("2bLXn");

var $6LVeH = parcelRequire("6LVeH");
var $6cced7f5392963e2$var$MILLISECONDS_IN_WEEK = 604800000;
function $6cced7f5392963e2$export$2e2bcd8739ae039(dirtyDate, options) {
    (0, $6LVeH.default)(1, arguments);
    var date = (0, $aS8if.default)(dirtyDate);
    var diff = (0, $aGqcG.default)(date, options).getTime() - (0, $2bLXn.default)(date, options).getTime();
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / $6cced7f5392963e2$var$MILLISECONDS_IN_WEEK) + 1;
}

});
parcelRegister("aGqcG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7c7227172a26b1eb$export$2e2bcd8739ae039; });

var $aS8if = parcelRequire("aS8if");

var $6LVeH = parcelRequire("6LVeH");

var $b7jxr = parcelRequire("b7jxr");

var $NIBAi = parcelRequire("NIBAi");
function $7c7227172a26b1eb$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $6LVeH.default)(1, arguments);
    var defaultOptions = (0, $NIBAi.getDefaultOptions)();
    var weekStartsOn = (0, $b7jxr.default)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
    var date = (0, $aS8if.default)(dirtyDate);
    var day = date.getUTCDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setUTCDate(date.getUTCDate() - diff);
    date.setUTCHours(0, 0, 0, 0);
    return date;
}

});
parcelRegister("NIBAi", function(module, exports) {

$parcel$export(module.exports, "getDefaultOptions", function () { return $09572d61c5329767$export$430a3269e24b912e; });
var $09572d61c5329767$var$defaultOptions = {};
function $09572d61c5329767$export$430a3269e24b912e() {
    return $09572d61c5329767$var$defaultOptions;
}
function $09572d61c5329767$export$95365be1b0704abc(newOptions) {
    $09572d61c5329767$var$defaultOptions = newOptions;
}

});


parcelRegister("2bLXn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1981cf0ceeb5dc91$export$2e2bcd8739ae039; });

var $fZpHh = parcelRequire("fZpHh");

var $6LVeH = parcelRequire("6LVeH");

var $aGqcG = parcelRequire("aGqcG");

var $b7jxr = parcelRequire("b7jxr");

var $NIBAi = parcelRequire("NIBAi");
function $1981cf0ceeb5dc91$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $6LVeH.default)(1, arguments);
    var defaultOptions = (0, $NIBAi.getDefaultOptions)();
    var firstWeekContainsDate = (0, $b7jxr.default)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
    var year = (0, $fZpHh.default)(dirtyDate, options);
    var firstWeek = new Date(0);
    firstWeek.setUTCFullYear(year, 0, firstWeekContainsDate);
    firstWeek.setUTCHours(0, 0, 0, 0);
    var date = (0, $aGqcG.default)(firstWeek, options);
    return date;
}

});
parcelRegister("fZpHh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ba407c67b4cf025c$export$2e2bcd8739ae039; });

var $aS8if = parcelRequire("aS8if");

var $6LVeH = parcelRequire("6LVeH");

var $aGqcG = parcelRequire("aGqcG");

var $b7jxr = parcelRequire("b7jxr");

var $NIBAi = parcelRequire("NIBAi");
function $ba407c67b4cf025c$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $6LVeH.default)(1, arguments);
    var date = (0, $aS8if.default)(dirtyDate);
    var year = date.getUTCFullYear();
    var defaultOptions = (0, $NIBAi.getDefaultOptions)();
    var firstWeekContainsDate = (0, $b7jxr.default)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
    // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
    var firstWeekOfNextYear = new Date(0);
    firstWeekOfNextYear.setUTCFullYear(year + 1, 0, firstWeekContainsDate);
    firstWeekOfNextYear.setUTCHours(0, 0, 0, 0);
    var startOfNextYear = (0, $aGqcG.default)(firstWeekOfNextYear, options);
    var firstWeekOfThisYear = new Date(0);
    firstWeekOfThisYear.setUTCFullYear(year, 0, firstWeekContainsDate);
    firstWeekOfThisYear.setUTCHours(0, 0, 0, 0);
    var startOfThisYear = (0, $aGqcG.default)(firstWeekOfThisYear, options);
    if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}

});



parcelRegister("iuBXe", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d768784c0a8a64b7$export$2e2bcd8739ae039; });
function $d768784c0a8a64b7$export$2e2bcd8739ae039(number, targetLength) {
    var sign = number < 0 ? "-" : "";
    var output = Math.abs(number).toString();
    while(output.length < targetLength)output = "0" + output;
    return sign + output;
}

});

parcelRegister("diPJn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9af5157b6ab43e56$export$2e2bcd8739ae039; });

var $iuBXe = parcelRequire("iuBXe");
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* |                                |
 * |  d  | Day of month                   |  D  |                                |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  m  | Minute                         |  M  | Month                          |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  y  | Year (abs)                     |  Y  |                                |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 */ var $9af5157b6ab43e56$var$formatters = {
    // Year
    y: function y(date, token) {
        // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
        // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
        // |----------|-------|----|-------|-------|-------|
        // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
        // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
        // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
        // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
        // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
        var signedYear = date.getUTCFullYear();
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        var year = signedYear > 0 ? signedYear : 1 - signedYear;
        return (0, $iuBXe.default)(token === "yy" ? year % 100 : year, token.length);
    },
    // Month
    M: function M(date, token) {
        var month = date.getUTCMonth();
        return token === "M" ? String(month + 1) : (0, $iuBXe.default)(month + 1, 2);
    },
    // Day of the month
    d: function d(date, token) {
        return (0, $iuBXe.default)(date.getUTCDate(), token.length);
    },
    // AM or PM
    a: function a(date, token) {
        var dayPeriodEnumValue = date.getUTCHours() / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "a":
            case "aa":
                return dayPeriodEnumValue.toUpperCase();
            case "aaa":
                return dayPeriodEnumValue;
            case "aaaaa":
                return dayPeriodEnumValue[0];
            case "aaaa":
            default:
                return dayPeriodEnumValue === "am" ? "a.m." : "p.m.";
        }
    },
    // Hour [1-12]
    h: function h(date, token) {
        return (0, $iuBXe.default)(date.getUTCHours() % 12 || 12, token.length);
    },
    // Hour [0-23]
    H: function H(date, token) {
        return (0, $iuBXe.default)(date.getUTCHours(), token.length);
    },
    // Minute
    m: function m(date, token) {
        return (0, $iuBXe.default)(date.getUTCMinutes(), token.length);
    },
    // Second
    s: function s(date, token) {
        return (0, $iuBXe.default)(date.getUTCSeconds(), token.length);
    },
    // Fraction of second
    S: function S(date, token) {
        var numberOfDigits = token.length;
        var milliseconds = date.getUTCMilliseconds();
        var fractionalSeconds = Math.floor(milliseconds * Math.pow(10, numberOfDigits - 3));
        return (0, $iuBXe.default)(fractionalSeconds, token.length);
    }
};
var $9af5157b6ab43e56$export$2e2bcd8739ae039 = $9af5157b6ab43e56$var$formatters;

});


parcelRegister("8XvFh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $685c655ecaa6b29e$export$2e2bcd8739ae039; });
var $685c655ecaa6b29e$var$dateLongFormatter = function dateLongFormatter(pattern, formatLong) {
    switch(pattern){
        case "P":
            return formatLong.date({
                width: "short"
            });
        case "PP":
            return formatLong.date({
                width: "medium"
            });
        case "PPP":
            return formatLong.date({
                width: "long"
            });
        case "PPPP":
        default:
            return formatLong.date({
                width: "full"
            });
    }
};
var $685c655ecaa6b29e$var$timeLongFormatter = function timeLongFormatter(pattern, formatLong) {
    switch(pattern){
        case "p":
            return formatLong.time({
                width: "short"
            });
        case "pp":
            return formatLong.time({
                width: "medium"
            });
        case "ppp":
            return formatLong.time({
                width: "long"
            });
        case "pppp":
        default:
            return formatLong.time({
                width: "full"
            });
    }
};
var $685c655ecaa6b29e$var$dateTimeLongFormatter = function dateTimeLongFormatter(pattern, formatLong) {
    var matchResult = pattern.match(/(P+)(p+)?/) || [];
    var datePattern = matchResult[1];
    var timePattern = matchResult[2];
    if (!timePattern) return $685c655ecaa6b29e$var$dateLongFormatter(pattern, formatLong);
    var dateTimeFormat;
    switch(datePattern){
        case "P":
            dateTimeFormat = formatLong.dateTime({
                width: "short"
            });
            break;
        case "PP":
            dateTimeFormat = formatLong.dateTime({
                width: "medium"
            });
            break;
        case "PPP":
            dateTimeFormat = formatLong.dateTime({
                width: "long"
            });
            break;
        case "PPPP":
        default:
            dateTimeFormat = formatLong.dateTime({
                width: "full"
            });
            break;
    }
    return dateTimeFormat.replace("{{date}}", $685c655ecaa6b29e$var$dateLongFormatter(datePattern, formatLong)).replace("{{time}}", $685c655ecaa6b29e$var$timeLongFormatter(timePattern, formatLong));
};
var $685c655ecaa6b29e$var$longFormatters = {
    p: $685c655ecaa6b29e$var$timeLongFormatter,
    P: $685c655ecaa6b29e$var$dateTimeLongFormatter
};
var $685c655ecaa6b29e$export$2e2bcd8739ae039 = $685c655ecaa6b29e$var$longFormatters;

});

parcelRegister("7GH3R", function(module, exports) {

$parcel$export(module.exports, "isProtectedDayOfYearToken", function () { return $598ddbbced7a1fab$export$c6cc36aa33304772; });
$parcel$export(module.exports, "isProtectedWeekYearToken", function () { return $598ddbbced7a1fab$export$c6b49d6dceb604a1; });
$parcel$export(module.exports, "throwProtectedError", function () { return $598ddbbced7a1fab$export$8073c1ae88f0e727; });
var $598ddbbced7a1fab$var$protectedDayOfYearTokens = [
    "D",
    "DD"
];
var $598ddbbced7a1fab$var$protectedWeekYearTokens = [
    "YY",
    "YYYY"
];
function $598ddbbced7a1fab$export$c6cc36aa33304772(token) {
    return $598ddbbced7a1fab$var$protectedDayOfYearTokens.indexOf(token) !== -1;
}
function $598ddbbced7a1fab$export$c6b49d6dceb604a1(token) {
    return $598ddbbced7a1fab$var$protectedWeekYearTokens.indexOf(token) !== -1;
}
function $598ddbbced7a1fab$export$8073c1ae88f0e727(token, format, input) {
    if (token === "YYYY") throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    else if (token === "YY") throw new RangeError("Use `yy` instead of `YY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    else if (token === "D") throw new RangeError("Use `d` instead of `D` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    else if (token === "DD") throw new RangeError("Use `dd` instead of `DD` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
}

});

parcelRegister("8n1Xk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6181fd21424f6a09$export$2e2bcd8739ae039; });

var $cPWcw = parcelRequire("cPWcw");
var $6181fd21424f6a09$export$2e2bcd8739ae039 = (0, $cPWcw.default);

});
parcelRegister("cPWcw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $958764eea3826478$export$2e2bcd8739ae039; });

var $lyk5H = parcelRequire("lyk5H");

var $9NEzZ = parcelRequire("9NEzZ");

var $8VBrn = parcelRequire("8VBrn");

var $cYo4N = parcelRequire("cYo4N");

var $3AKwa = parcelRequire("3AKwa");
/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (United States).
 * @language English
 * @iso-639-2 eng
 * @author Sasha Koss [@kossnocorp]{@link https://github.com/kossnocorp}
 * @author Lesha Koss [@leshakoss]{@link https://github.com/leshakoss}
 */ var $958764eea3826478$var$locale = {
    code: "en-US",
    formatDistance: (0, $lyk5H.default),
    formatLong: (0, $9NEzZ.default),
    formatRelative: (0, $8VBrn.default),
    localize: (0, $cYo4N.default),
    match: (0, $3AKwa.default),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
var $958764eea3826478$export$2e2bcd8739ae039 = $958764eea3826478$var$locale;

});
parcelRegister("lyk5H", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fb0c5b949b3e934a$export$2e2bcd8739ae039; });
var $fb0c5b949b3e934a$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "less than a second",
        other: "less than {{count}} seconds"
    },
    xSeconds: {
        one: "1 second",
        other: "{{count}} seconds"
    },
    halfAMinute: "half a minute",
    lessThanXMinutes: {
        one: "less than a minute",
        other: "less than {{count}} minutes"
    },
    xMinutes: {
        one: "1 minute",
        other: "{{count}} minutes"
    },
    aboutXHours: {
        one: "about 1 hour",
        other: "about {{count}} hours"
    },
    xHours: {
        one: "1 hour",
        other: "{{count}} hours"
    },
    xDays: {
        one: "1 day",
        other: "{{count}} days"
    },
    aboutXWeeks: {
        one: "about 1 week",
        other: "about {{count}} weeks"
    },
    xWeeks: {
        one: "1 week",
        other: "{{count}} weeks"
    },
    aboutXMonths: {
        one: "about 1 month",
        other: "about {{count}} months"
    },
    xMonths: {
        one: "1 month",
        other: "{{count}} months"
    },
    aboutXYears: {
        one: "about 1 year",
        other: "about {{count}} years"
    },
    xYears: {
        one: "1 year",
        other: "{{count}} years"
    },
    overXYears: {
        one: "over 1 year",
        other: "over {{count}} years"
    },
    almostXYears: {
        one: "almost 1 year",
        other: "almost {{count}} years"
    }
};
var $fb0c5b949b3e934a$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $fb0c5b949b3e934a$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", count.toString());
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "in " + result;
        else return result + " ago";
    }
    return result;
};
var $fb0c5b949b3e934a$export$2e2bcd8739ae039 = $fb0c5b949b3e934a$var$formatDistance;

});

parcelRegister("9NEzZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $72282ae32dffee1f$export$2e2bcd8739ae039; });

var $bjutF = parcelRequire("bjutF");
var $72282ae32dffee1f$var$dateFormats = {
    full: "EEEE, MMMM do, y",
    long: "MMMM do, y",
    medium: "MMM d, y",
    short: "MM/dd/yyyy"
};
var $72282ae32dffee1f$var$timeFormats = {
    full: "h:mm:ss a zzzz",
    long: "h:mm:ss a z",
    medium: "h:mm:ss a",
    short: "h:mm a"
};
var $72282ae32dffee1f$var$dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
var $72282ae32dffee1f$var$formatLong = {
    date: (0, $bjutF.default)({
        formats: $72282ae32dffee1f$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $bjutF.default)({
        formats: $72282ae32dffee1f$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $bjutF.default)({
        formats: $72282ae32dffee1f$var$dateTimeFormats,
        defaultWidth: "full"
    })
};
var $72282ae32dffee1f$export$2e2bcd8739ae039 = $72282ae32dffee1f$var$formatLong;

});
parcelRegister("bjutF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $83c91c438baae4c3$export$2e2bcd8739ae039; });
function $83c91c438baae4c3$export$2e2bcd8739ae039(args) {
    return function() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        // TODO: Remove String()
        var width = options.width ? String(options.width) : args.defaultWidth;
        var format = args.formats[width] || args.formats[args.defaultWidth];
        return format;
    };
}

});


parcelRegister("8VBrn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6800b083e0b6b4b5$export$2e2bcd8739ae039; });
var $6800b083e0b6b4b5$var$formatRelativeLocale = {
    lastWeek: "'last' eeee 'at' p",
    yesterday: "'yesterday at' p",
    today: "'today at' p",
    tomorrow: "'tomorrow at' p",
    nextWeek: "eeee 'at' p",
    other: "P"
};
var $6800b083e0b6b4b5$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $6800b083e0b6b4b5$var$formatRelativeLocale[token];
};
var $6800b083e0b6b4b5$export$2e2bcd8739ae039 = $6800b083e0b6b4b5$var$formatRelative;

});

parcelRegister("cYo4N", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $971dc3b69175e7e0$export$2e2bcd8739ae039; });

var $8YvD9 = parcelRequire("8YvD9");
var $971dc3b69175e7e0$var$eraValues = {
    narrow: [
        "B",
        "A"
    ],
    abbreviated: [
        "BC",
        "AD"
    ],
    wide: [
        "Before Christ",
        "Anno Domini"
    ]
};
var $971dc3b69175e7e0$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "Q1",
        "Q2",
        "Q3",
        "Q4"
    ],
    wide: [
        "1st quarter",
        "2nd quarter",
        "3rd quarter",
        "4th quarter"
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var $971dc3b69175e7e0$var$monthValues = {
    narrow: [
        "J",
        "F",
        "M",
        "A",
        "M",
        "J",
        "J",
        "A",
        "S",
        "O",
        "N",
        "D"
    ],
    abbreviated: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
    ],
    wide: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
    ]
};
var $971dc3b69175e7e0$var$dayValues = {
    narrow: [
        "S",
        "M",
        "T",
        "W",
        "T",
        "F",
        "S"
    ],
    short: [
        "Su",
        "Mo",
        "Tu",
        "We",
        "Th",
        "Fr",
        "Sa"
    ],
    abbreviated: [
        "Sun",
        "Mon",
        "Tue",
        "Wed",
        "Thu",
        "Fri",
        "Sat"
    ],
    wide: [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
    ]
};
var $971dc3b69175e7e0$var$dayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mi",
        noon: "n",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "midnight",
        noon: "noon",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnight",
        noon: "noon",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    }
};
var $971dc3b69175e7e0$var$formattingDayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mi",
        noon: "n",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "midnight",
        noon: "noon",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnight",
        noon: "noon",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    }
};
var $971dc3b69175e7e0$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    // If ordinal numbers depend on context, for example,
    // if they are different for different grammatical genders,
    // use `options.unit`.
    //
    // `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
    // 'day', 'hour', 'minute', 'second'.
    var rem100 = number % 100;
    if (rem100 > 20 || rem100 < 10) switch(rem100 % 10){
        case 1:
            return number + "st";
        case 2:
            return number + "nd";
        case 3:
            return number + "rd";
    }
    return number + "th";
};
var $971dc3b69175e7e0$var$localize = {
    ordinalNumber: $971dc3b69175e7e0$var$ordinalNumber,
    era: (0, $8YvD9.default)({
        values: $971dc3b69175e7e0$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $8YvD9.default)({
        values: $971dc3b69175e7e0$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $8YvD9.default)({
        values: $971dc3b69175e7e0$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $8YvD9.default)({
        values: $971dc3b69175e7e0$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $8YvD9.default)({
        values: $971dc3b69175e7e0$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $971dc3b69175e7e0$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};
var $971dc3b69175e7e0$export$2e2bcd8739ae039 = $971dc3b69175e7e0$var$localize;

});
parcelRegister("8YvD9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $688c767c2d534fc0$export$2e2bcd8739ae039; });
function $688c767c2d534fc0$export$2e2bcd8739ae039(args) {
    return function(dirtyIndex, options) {
        var context = options !== null && options !== void 0 && options.context ? String(options.context) : "standalone";
        var valuesArray;
        if (context === "formatting" && args.formattingValues) {
            var defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
            var width = options !== null && options !== void 0 && options.width ? String(options.width) : defaultWidth;
            valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
        } else {
            var _defaultWidth = args.defaultWidth;
            var _width = options !== null && options !== void 0 && options.width ? String(options.width) : args.defaultWidth;
            valuesArray = args.values[_width] || args.values[_defaultWidth];
        }
        var index = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex;
        // @ts-ignore: For some reason TypeScript just don't want to match it, no matter how hard we try. I challenge you to try to remove it!
        return valuesArray[index];
    };
}

});


parcelRegister("3AKwa", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $29d8d16147360636$export$2e2bcd8739ae039; });

var $dogs2 = parcelRequire("dogs2");

var $jGyAe = parcelRequire("jGyAe");
var $29d8d16147360636$var$matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var $29d8d16147360636$var$parseOrdinalNumberPattern = /\d+/i;
var $29d8d16147360636$var$matchEraPatterns = {
    narrow: /^(b|a)/i,
    abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
    wide: /^(before christ|before common era|anno domini|common era)/i
};
var $29d8d16147360636$var$parseEraPatterns = {
    any: [
        /^b/i,
        /^(a|c)/i
    ]
};
var $29d8d16147360636$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](th|st|nd|rd)? quarter/i
};
var $29d8d16147360636$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $29d8d16147360636$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
    wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
var $29d8d16147360636$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^may/i,
        /^jun/i,
        /^jul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $29d8d16147360636$var$matchDayPatterns = {
    narrow: /^[smtwf]/i,
    short: /^(su|mo|tu|we|th|fr|sa)/i,
    abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
    wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
var $29d8d16147360636$var$parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^t/i,
        /^w/i,
        /^t/i,
        /^f/i,
        /^s/i
    ],
    any: [
        /^su/i,
        /^m/i,
        /^tu/i,
        /^w/i,
        /^th/i,
        /^f/i,
        /^sa/i
    ]
};
var $29d8d16147360636$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
    any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var $29d8d16147360636$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mi/i,
        noon: /^no/i,
        morning: /morning/i,
        afternoon: /afternoon/i,
        evening: /evening/i,
        night: /night/i
    }
};
var $29d8d16147360636$var$match = {
    ordinalNumber: (0, $jGyAe.default)({
        matchPattern: $29d8d16147360636$var$matchOrdinalNumberPattern,
        parsePattern: $29d8d16147360636$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $dogs2.default)({
        matchPatterns: $29d8d16147360636$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $29d8d16147360636$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $dogs2.default)({
        matchPatterns: $29d8d16147360636$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $29d8d16147360636$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $dogs2.default)({
        matchPatterns: $29d8d16147360636$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $29d8d16147360636$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $dogs2.default)({
        matchPatterns: $29d8d16147360636$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $29d8d16147360636$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $dogs2.default)({
        matchPatterns: $29d8d16147360636$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $29d8d16147360636$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};
var $29d8d16147360636$export$2e2bcd8739ae039 = $29d8d16147360636$var$match;

});
parcelRegister("dogs2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9bfa471f0396a59e$export$2e2bcd8739ae039; });
function $9bfa471f0396a59e$export$2e2bcd8739ae039(args) {
    return function(string) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var width = options.width;
        var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
        var matchResult = string.match(matchPattern);
        if (!matchResult) return null;
        var matchedString = matchResult[0];
        var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
        var key = Array.isArray(parsePatterns) ? $9bfa471f0396a59e$var$findIndex(parsePatterns, function(pattern) {
            return pattern.test(matchedString);
        }) : $9bfa471f0396a59e$var$findKey(parsePatterns, function(pattern) {
            return pattern.test(matchedString);
        });
        var value;
        value = args.valueCallback ? args.valueCallback(key) : key;
        value = options.valueCallback ? options.valueCallback(value) : value;
        var rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}
function $9bfa471f0396a59e$var$findKey(object, predicate) {
    for(var key in object){
        if (object.hasOwnProperty(key) && predicate(object[key])) return key;
    }
    return undefined;
}
function $9bfa471f0396a59e$var$findIndex(array, predicate) {
    for(var key = 0; key < array.length; key++){
        if (predicate(array[key])) return key;
    }
    return undefined;
}

});

parcelRegister("jGyAe", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e54cc41ee1327c3d$export$2e2bcd8739ae039; });
function $e54cc41ee1327c3d$export$2e2bcd8739ae039(args) {
    return function(string) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var matchResult = string.match(args.matchPattern);
        if (!matchResult) return null;
        var matchedString = matchResult[0];
        var parseResult = string.match(args.parsePattern);
        if (!parseResult) return null;
        var value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
        value = options.valueCallback ? options.valueCallback(value) : value;
        var rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}

});






parcelRegister("1c48R", function(module, exports) {

$parcel$export(module.exports, "eventProduct", function () { return $0dea1ff3d815f3a7$export$a7df4e8088db8843; });
var $0dea1ff3d815f3a7$export$a7df4e8088db8843 = function eventProduct(_config, _data, globalConfig) {
    return {
        "event:product": "".concat(globalConfig.product)
    };
};

});

parcelRegister("afLyZ", function(module, exports) {

$parcel$export(module.exports, "eventRegion", function () { return $7770332de2dccfa8$export$d0117b71adcdebc0; });
var $7770332de2dccfa8$export$d0117b71adcdebc0 = function eventRegion(_config, _data, globalConfig) {
    return {
        "event:region": "".concat(globalConfig.region)
    };
};

});

parcelRegister("byc2l", function(module, exports) {

$parcel$export(module.exports, "eventRoute", function () { return $868c34ec28004215$export$44d3627af289ca16; });
var $868c34ec28004215$export$44d3627af289ca16 = function eventRoute(_config, data) {
    if (!data.route) return null;
    return {
        "event:route": data.route
    };
};

});

parcelRegister("5roNT", function(module, exports) {

$parcel$export(module.exports, "eventType", function () { return $3f62b6db1f756390$export$4c045e605d532c98; });

var $3pH2k = parcelRequire("3pH2k");
var $3f62b6db1f756390$export$4c045e605d532c98 = function eventType(config) {
    return {
        "event:type": (0, $3pH2k.mapEventType)(config.type)
    };
};

});

parcelRegister("9wN85", function(module, exports) {

$parcel$export(module.exports, "featureFlags", function () { return $6efd3650c6732c4a$export$e62953d023125748; });

var $9Z3Ln = parcelRequire("9Z3Ln");
function $6efd3650c6732c4a$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $6efd3650c6732c4a$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $6efd3650c6732c4a$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($9Z3Ln)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $6efd3650c6732c4a$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $6efd3650c6732c4a$export$e62953d023125748 = function featureFlags(config, _data, globalConfig) {
    var _config$featureFlags;
    var localFeatureFlags = ((_config$featureFlags = config.featureFlags) === null || _config$featureFlags === void 0 ? void 0 : _config$featureFlags.reduce(function(acc, ffName) {
        acc[ffName] = globalConfig.ffClient.getValue(ffName);
        return acc;
    }, {})) || null;
    if ((!globalConfig.featureFlags || Object.keys(globalConfig.featureFlags).length === 0) && (!localFeatureFlags || Object.keys(localFeatureFlags).length === 0)) return null;
    return {
        featureFlags: $6efd3650c6732c4a$var$_objectSpread($6efd3650c6732c4a$var$_objectSpread({}, localFeatureFlags), globalConfig.featureFlags)
    };
};

});

parcelRegister("ek9MI", function(module, exports) {

$parcel$export(module.exports, "hostname", function () { return $a6da85f9aec677ee$export$640106f6dc7d2706; });
var $a6da85f9aec677ee$export$640106f6dc7d2706 = function hostname(_config, _data, globalConfig) {
    return {
        hostname: globalConfig.hostname
    };
};

});

parcelRegister("48zWn", function(module, exports) {

$parcel$export(module.exports, "customEventMetrics", function () { return $3033c9d95c0277e3$export$cab039265c52a2e9; });

var $8xhEx = parcelRequire("8xhEx");
var $3033c9d95c0277e3$export$cab039265c52a2e9 = function customEventMetrics(config, data, globalConfig) {
    var _config$slo, _config$histogram;
    if (!(0, $8xhEx.isCustomConfig)(config)) return null;
    var payload = {
        "metric:duration": Math.round(data.stop - data.start)
    };
    if (((_config$slo = config.slo) === null || _config$slo === void 0 ? void 0 : _config$slo.threshold) !== undefined) {
        var _config$slo2, _config$slo3;
        payload["metric:duration:slo"] = payload["metric:duration"] <= ((_config$slo2 = config.slo) === null || _config$slo2 === void 0 ? void 0 : _config$slo2.threshold);
        payload["metric:duration:slo:threshold"] = (_config$slo3 = config.slo) === null || _config$slo3 === void 0 ? void 0 : _config$slo3.threshold;
    }
    if ((_config$histogram = config.histogram) !== null && _config$histogram !== void 0 && _config$histogram.duration) payload["metric:duration:histogramBuckets"] = config.histogram.duration;
    else if (globalConfig.histogram) payload["metric:duration:histogramBuckets"] = globalConfig.histogram.duration;
    return payload;
};

});

parcelRegister("cYu67", function(module, exports) {

$parcel$export(module.exports, "initialPageLoadMetrics", function () { return $97226f688a60586d$export$cc95aa3f6ea8e5cb; });
var $97226f688a60586d$export$cc95aa3f6ea8e5cb = function initialPageLoadMetrics() {
    var metrics = {};
    performance.getEntriesByType("paint").forEach(function(entry) {
        if (entry.name === "first-paint") metrics["metric:fp"] = Math.round(entry.startTime);
        if (entry.name === "first-contentful-paint") metrics["metric:fcp"] = Math.round(entry.startTime);
    });
    return metrics;
};

});

parcelRegister("j2vLh", function(module, exports) {

$parcel$export(module.exports, "interactionMetrics", function () { return $ddc6d76edf53e589$export$86db56030b57ba34; });

var $8xhEx = parcelRequire("8xhEx");

var $c2GEI = parcelRequire("c2GEI");
var $ddc6d76edf53e589$export$86db56030b57ba34 = function interactionMetrics(config, data, globalConfig) {
    var _config$histogram;
    if (!(0, $8xhEx.isInteractionConfig)(config)) return null;
    var result = {
        "metric:result": Math.round(data.stop - data.start)
    };
    if ((_config$histogram = config.histogram) !== null && _config$histogram !== void 0 && _config$histogram.result) result["metric:result:histogramBuckets"] = config.histogram.result;
    else if (globalConfig.histogram) {
        var histogram = globalConfig.histogram;
        if (histogram.result !== undefined) result["metric:result:histogramBuckets"] = histogram[(0, $c2GEI.BMInteractionMetrics).result];
    }
    if (config.slo && (0, $c2GEI.isInteractionMetricsSlo)(config.slo) && config.slo.result) {
        result["metric:result:slo"] = result["metric:result"] <= config.slo.result.threshold;
        result["metric:result:slo:threshold"] = config.slo.result.threshold;
    }
    if (data.marks["feedback"]) {
        var _config$histogram2;
        result["metric:response"] = Math.round((data.marks["feedback"] || data.stop) - data.start);
        if ((_config$histogram2 = config.histogram) !== null && _config$histogram2 !== void 0 && _config$histogram2.response) result["metric:response:histogramBuckets"] = config.histogram[(0, $c2GEI.BMInteractionMetrics).response];
        else if (globalConfig.histogram) {
            var _histogram = globalConfig.histogram;
            if (_histogram.result !== undefined) result["metric:response:histogramBuckets"] = _histogram[(0, $c2GEI.BMInteractionMetrics).response];
        }
        if (config.slo && (0, $c2GEI.isInteractionMetricsSlo)(config.slo) && config.slo.response) {
            result["metric:response:slo"] = result["metric:response"] <= config.slo.response.threshold;
            result["metric:response:slo:threshold"] = config.slo.response.threshold;
        }
    }
    return result;
};

});

parcelRegister("jx4t8", function(module, exports) {

$parcel$export(module.exports, "navigationMetrics", function () { return $e38490cf41abe973$export$b88d990436be0f8a; });
var $e38490cf41abe973$export$b88d990436be0f8a = function navigationMetrics() {
    var entries = performance.getEntriesByType("navigation");
    if (entries.length === 0) return null;
    var navigation = entries[0];
    var metrics = {
        // From https://www.w3.org/TR/resource-timing/
        redirectStart: Math.round(navigation.redirectStart),
        redirectEnd: Math.round(navigation.redirectEnd),
        fetchStart: Math.round(navigation.fetchStart),
        domainLookupStart: Math.round(navigation.domainLookupStart),
        domainLookupEnd: Math.round(navigation.domainLookupEnd),
        connectStart: Math.round(navigation.connectStart),
        connectEnd: Math.round(navigation.connectEnd),
        secureConnectionStart: Math.round(navigation.secureConnectionStart),
        requestStart: Math.round(navigation.requestStart),
        responseStart: Math.round(navigation.responseStart),
        responseEnd: Math.round(navigation.responseEnd),
        encodedBodySize: Math.round(navigation.encodedBodySize),
        decodedBodySize: Math.round(navigation.decodedBodySize),
        transferSize: Math.round(navigation.transferSize),
        // From https://www.w3.org/TR/navigation-timing-2/
        redirectCount: navigation.redirectCount,
        type: navigation.type,
        unloadEventEnd: Math.round(navigation.unloadEventEnd),
        unloadEventStart: Math.round(navigation.unloadEventStart),
        workerStart: Math.round(navigation.workerStart)
    };
    return {
        "metrics:navigation": metrics
    };
};

});

parcelRegister("hyQxC", function(module, exports) {

$parcel$export(module.exports, "pageLoadMetrics", function () { return $cc8e5e37d2978a23$export$2878bf482e539059; });

var $8xhEx = parcelRequire("8xhEx");

var $c2GEI = parcelRequire("c2GEI");
var $cc8e5e37d2978a23$var$getThreshold = function getThreshold(isInitial, metric) {
    return (0, $c2GEI.isDetailedPageLoadSlo)(metric) ? isInitial ? metric.initial.threshold : metric.transition.threshold : metric.threshold;
};
var $cc8e5e37d2978a23$var$getHistogram = function getHistogram(isInitial, metric, histogram) {
    return isInitial ? histogram.initial[metric] : histogram.transition[metric];
};
var $cc8e5e37d2978a23$export$2878bf482e539059 = function pageLoadMetrics(config, data, globalConfig) {
    if (!(0, $8xhEx.isPageLoadConfig)(config)) throw new Error("Browser Metrics: cannot gather page load data for non-page-load config");
    var fmp = data.marks[(0, $c2GEI.BMPageLoadMetrics).fmp] || data.stop;
    var result = {
        "metric:fmp": Math.round(fmp - data.start),
        "metric:tti": Math.round(data.stop - data.start)
    };
    if (config.histogram) {
        result["metric:fmp:histogramBuckets"] = $cc8e5e37d2978a23$var$getHistogram(data.isInitial, (0, $c2GEI.BMPageLoadMetrics).fmp, config.histogram);
        result["metric:tti:histogramBuckets"] = $cc8e5e37d2978a23$var$getHistogram(data.isInitial, (0, $c2GEI.BMPageLoadMetrics).tti, config.histogram);
    } else if (globalConfig.histogram) {
        var histogram = globalConfig.histogram;
        result["metric:fmp:histogramBuckets"] = $cc8e5e37d2978a23$var$getHistogram(data.isInitial, (0, $c2GEI.BMPageLoadMetrics).fmp, histogram);
        result["metric:tti:histogramBuckets"] = $cc8e5e37d2978a23$var$getHistogram(data.isInitial, (0, $c2GEI.BMPageLoadMetrics).tti, histogram);
    }
    if (config.slo && config.slo.fmp) {
        var threshold = $cc8e5e37d2978a23$var$getThreshold(data.isInitial, config.slo.fmp);
        result["metric:fmp:slo"] = result["metric:fmp"] <= threshold;
        result["metric:fmp:slo:threshold"] = threshold;
    }
    if (config.slo && config.slo.tti) {
        var _threshold = $cc8e5e37d2978a23$var$getThreshold(data.isInitial, config.slo.tti);
        result["metric:tti:slo"] = result["metric:tti"] <= _threshold;
        result["metric:tti:slo:threshold"] = _threshold;
    }
    return result;
};

});

parcelRegister("8btua", function(module, exports) {

$parcel$export(module.exports, "pageSegmentLoadMetrics", function () { return $5f5639048bc31499$export$ba86cb47f2f22db5; });

var $f9YR6 = parcelRequire("f9YR6");

var $8xhEx = parcelRequire("8xhEx");

var $c2GEI = parcelRequire("c2GEI");
var $5f5639048bc31499$var$getThreshold = function getThreshold(isInitial, metric) {
    return (0, $c2GEI.isDetailedPageSegmentLoadSlo)(metric) ? isInitial ? metric.initial.threshold : metric.transition.threshold : metric.threshold;
};
var $5f5639048bc31499$var$getHistogram = function getHistogram(isInitial, metric, histogram) {
    return isInitial ? histogram.initial[metric] : histogram.transition[metric];
};
var $5f5639048bc31499$export$ba86cb47f2f22db5 = function pageSegmentLoadMetrics(config, data, globalConfig) {
    var _config$slo, _config$slo2;
    if (!(0, $8xhEx.isPageSegmentLoadConfig)(config)) throw new Error("Browser Metrics: cannot gather page segment load data for non-page-segment-load config");
    var fmp = data.marks[(0, $c2GEI.BMPageSegmentLoadMetrics).fmp] || data.stop;
    var result = {
        "metric:fmp": Math.round(fmp - data.start),
        "metric:tti": Math.round(data.stop - data.start)
    };
    if (config.histogram) {
        result["metric:fmp:histogramBuckets"] = $5f5639048bc31499$var$getHistogram(data.isInitial, (0, $c2GEI.BMPageSegmentLoadMetrics).fmp, config.histogram);
        result["metric:tti:histogramBuckets"] = $5f5639048bc31499$var$getHistogram(data.isInitial, (0, $c2GEI.BMPageSegmentLoadMetrics).tti, config.histogram);
    } else if (globalConfig.histogram) {
        var histogram = globalConfig.histogram;
        result["metric:fmp:histogramBuckets"] = $5f5639048bc31499$var$getHistogram(data.isInitial, (0, $c2GEI.BMPageSegmentLoadMetrics).fmp, histogram);
        result["metric:tti:histogramBuckets"] = $5f5639048bc31499$var$getHistogram(data.isInitial, (0, $c2GEI.BMPageSegmentLoadMetrics).tti, histogram);
    }
    if ((_config$slo = config.slo) !== null && _config$slo !== void 0 && _config$slo.fmp) {
        var threshold = $5f5639048bc31499$var$getThreshold(data.isInitial, config.slo.fmp);
        result["metric:fmp:slo"] = result["metric:fmp"] <= threshold;
        result["metric:fmp:slo:threshold"] = threshold;
    }
    if ((_config$slo2 = config.slo) !== null && _config$slo2 !== void 0 && _config$slo2.tti) {
        var _threshold = $5f5639048bc31499$var$getThreshold(data.isInitial, config.slo.tti);
        result["metric:tti:slo"] = result["metric:tti"] <= _threshold;
        result["metric:tti:slo:threshold"] = _threshold;
    }
    if (config.includePageLoadTimings === (0, $c2GEI.PageSegmentPageLoadMetricsOptions).IF_PRESENT || config.includePageLoadTimings === (0, $c2GEI.PageSegmentPageLoadMetricsOptions).WAIT_UNTIL_PRESENT) {
        var pageLoadData = (0, $f9YR6.pageLoadMetaMetric).getData();
        var _fmp = pageLoadData.stop !== null && pageLoadData.start !== null ? Math.round((pageLoadData.marks[(0, $c2GEI.BMPageLoadMetrics).fmp] || pageLoadData.stop) - pageLoadData.start) : null;
        var tti = pageLoadData.stop !== null && pageLoadData.start !== null ? Math.round(pageLoadData.stop - pageLoadData.start) : null;
        result["pageLoad"] = {
            fmp: _fmp,
            tti: tti
        };
    }
    return result;
};

});
parcelRegister("f9YR6", function(module, exports) {

$parcel$export(module.exports, "pageLoadMetaMetric", function () { return $b096e6e31ce17a51$export$24b7a1a311eb05dc; });

var $gZv0y = parcelRequire("gZv0y");

var $1W8kW = parcelRequire("1W8kW");

var $ceJcC = parcelRequire("ceJcC");

var $gNgok = parcelRequire("gNgok");

var $2CEPP = parcelRequire("2CEPP");

var $lVZ3G = parcelRequire("lVZ3G");

var $fV4YG = parcelRequire("fV4YG");

var $7mJzd = parcelRequire("7mJzd");

var $9Z3Ln = parcelRequire("9Z3Ln");

var $c2GEI = parcelRequire("c2GEI");

var $kB69W = parcelRequire("kB69W");

var $2seMB = parcelRequire("2seMB");
var $b096e6e31ce17a51$var$_excluded = [
    "cancelStarted"
];
function $b096e6e31ce17a51$var$_createSuper(t) {
    var r = $b096e6e31ce17a51$var$_isNativeReflectConstruct();
    return function() {
        var e, o = (0, (/*@__PURE__*/$parcel$interopDefault($7mJzd)))(t);
        if (r) {
            var s = (0, (/*@__PURE__*/$parcel$interopDefault($7mJzd)))(this).constructor;
            e = Reflect.construct(o, arguments, s);
        } else e = o.apply(this, arguments);
        return (0, (/*@__PURE__*/$parcel$interopDefault($fV4YG)))(this, e);
    };
}
function $b096e6e31ce17a51$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($b096e6e31ce17a51$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $b096e6e31ce17a51$export$9609608c00ea5077 = /*#__PURE__*/ function(_BasePageLoadMetric) {
    (0, (/*@__PURE__*/$parcel$interopDefault($lVZ3G)))(PageLoadMetaMetric, _BasePageLoadMetric);
    var _super = $b096e6e31ce17a51$var$_createSuper(PageLoadMetaMetric);
    function PageLoadMetaMetric() {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($1W8kW)))(this, PageLoadMetaMetric);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, (/*@__PURE__*/$parcel$interopDefault($9Z3Ln)))((0, (/*@__PURE__*/$parcel$interopDefault($gNgok)))(_this), "activePageLoadMetric", null);
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($ceJcC)))(PageLoadMetaMetric, [
        {
            key: "startPageLoad",
            value: function startPageLoad() {
                var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
                    isInitial: false,
                    cancelStarted: false
                };
                var cancelStarted = _ref.cancelStarted, startPageLoadParams = (0, (/*@__PURE__*/$parcel$interopDefault($gZv0y)))(_ref, $b096e6e31ce17a51$var$_excluded);
                if (cancelStarted || this.state !== (0, $kB69W.MetricState).STARTED) (0, (/*@__PURE__*/$parcel$interopDefault($2CEPP)))((0, (/*@__PURE__*/$parcel$interopDefault($7mJzd)))(PageLoadMetaMetric.prototype), "startPageLoad", this).call(this, startPageLoadParams);
            }
        },
        {
            key: "setActive",
            value: function setActive(metric) {
                this.activePageLoadMetric = metric;
            }
        },
        {
            key: "setDebug",
            value: function setDebug(debug) {
                this.config.debug = debug;
            }
        },
        {
            key: "isDebugMode",
            value: function isDebugMode() {
                return this.config.debug;
            }
        },
        {
            key: "isInitialLoad",
            value: function isInitialLoad() {
                return this.isInitial;
            }
        },
        {
            key: "clear",
            value: function clear() {
                this.activePageLoadMetric && this.activePageLoadMetric.cancel();
                (0, (/*@__PURE__*/$parcel$interopDefault($2CEPP)))((0, (/*@__PURE__*/$parcel$interopDefault($7mJzd)))(PageLoadMetaMetric.prototype), "clear", this).call(this);
            }
        },
        {
            key: "include",
            value: function include(metric) {
                if (!this.config.include) this.config.include = [
                    metric
                ];
                else this.config.include.push(metric);
            }
        },
        {
            key: "experimental__addExplicitTiming",
            value: function experimental__addExplicitTiming(name, timing) {
                if (this.explicitTimings === null) this.explicitTimings = {};
                this.explicitTimings[name] = timing;
            }
        }
    ]);
    return PageLoadMetaMetric;
}((0, $2seMB.BasePageLoadMetric));
var $b096e6e31ce17a51$export$24b7a1a311eb05dc = new $b096e6e31ce17a51$export$9609608c00ea5077({
    type: (0, $c2GEI.BMEventsType).PAGE_LOAD,
    key: "page_load_meta_metric"
});

});
parcelRegister("gZv0y", function(module, exports) {

var $jlg2R = parcelRequire("jlg2R");
function $c5ea6564123b4fa5$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $jlg2R(e, t);
    if (Object.getOwnPropertySymbols) {
        var s = Object.getOwnPropertySymbols(e);
        for(r = 0; r < s.length; r++)o = s[r], t.includes(o) || ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
module.exports = $c5ea6564123b4fa5$var$_objectWithoutProperties, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("jlg2R", function(module, exports) {
function $e14c6cb3639c8ee2$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.includes(n)) continue;
        t[n] = r[n];
    }
    return t;
}
module.exports = $e14c6cb3639c8ee2$var$_objectWithoutPropertiesLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("2seMB", function(module, exports) {

$parcel$export(module.exports, "BasePageLoadMetric", function () { return $1c99a9d9f9084479$export$fd1447b187f590fe; });

var $VeSwC = parcelRequire("VeSwC");

var $iPXoY = parcelRequire("iPXoY");

var $1W8kW = parcelRequire("1W8kW");

var $ceJcC = parcelRequire("ceJcC");

var $gNgok = parcelRequire("gNgok");

var $2CEPP = parcelRequire("2CEPP");

var $lVZ3G = parcelRequire("lVZ3G");

var $fV4YG = parcelRequire("fV4YG");

var $7mJzd = parcelRequire("7mJzd");

var $9Z3Ln = parcelRequire("9Z3Ln");

var $7rgZR = parcelRequire("7rgZR");

var $kB69W = parcelRequire("kB69W");
function $1c99a9d9f9084479$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $1c99a9d9f9084479$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $1c99a9d9f9084479$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($9Z3Ln)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $1c99a9d9f9084479$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $1c99a9d9f9084479$var$_createSuper(t) {
    var r = $1c99a9d9f9084479$var$_isNativeReflectConstruct();
    return function() {
        var e, o = (0, (/*@__PURE__*/$parcel$interopDefault($7mJzd)))(t);
        if (r) {
            var s = (0, (/*@__PURE__*/$parcel$interopDefault($7mJzd)))(this).constructor;
            e = Reflect.construct(o, arguments, s);
        } else e = o.apply(this, arguments);
        return (0, (/*@__PURE__*/$parcel$interopDefault($fV4YG)))(this, e);
    };
}
function $1c99a9d9f9084479$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($1c99a9d9f9084479$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $1c99a9d9f9084479$export$fd1447b187f590fe = /*#__PURE__*/ function(_BaseMetric) {
    (0, (/*@__PURE__*/$parcel$interopDefault($lVZ3G)))(BasePageLoadMetric, _BaseMetric);
    var _super = $1c99a9d9f9084479$var$_createSuper(BasePageLoadMetric);
    function BasePageLoadMetric(args) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($1W8kW)))(this, BasePageLoadMetric);
        _this = _super.call(this, args);
        (0, (/*@__PURE__*/$parcel$interopDefault($9Z3Ln)))((0, (/*@__PURE__*/$parcel$interopDefault($gNgok)))(_this), "isInitial", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($9Z3Ln)))((0, (/*@__PURE__*/$parcel$interopDefault($gNgok)))(_this), "explicitTimings", null);
        _this.config = args;
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($ceJcC)))(BasePageLoadMetric, [
        {
            key: "start",
            value: function start() {
                (0, (/*@__PURE__*/$parcel$interopDefault($iPXoY)))(arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {});
                // please use startPageLoad
                return;
            }
        },
        {
            key: "startPageLoad",
            value: function startPageLoad() {
                var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
                    isInitial: false
                };
                // todo this should update meta page load metric
                this.isInitial = params.isInitial;
                if (params.isInitial) (0, (/*@__PURE__*/$parcel$interopDefault($2CEPP)))((0, (/*@__PURE__*/$parcel$interopDefault($7mJzd)))(BasePageLoadMetric.prototype), "start", this).call(this, {
                    startTime: 0
                });
                else (0, (/*@__PURE__*/$parcel$interopDefault($2CEPP)))((0, (/*@__PURE__*/$parcel$interopDefault($7mJzd)))(BasePageLoadMetric.prototype), "start", this).call(this, params);
                (0, $7rgZR.logger).logCond(!!this.config.debug, this.key, this.startTime);
            }
        },
        {
            key: "stopPageLoad",
            value: function stopPageLoad(pageLoadMetaMetricData) {
                var stopArguments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
                    stopTime: window.performance.now()
                };
                if (pageLoadMetaMetricData.state !== (0, $kB69W.MetricState).STARTED || pageLoadMetaMetricData.start === null || stopArguments.stopTime === undefined) {
                    (0, $7rgZR.logger).log("meta metric has been stopped while not being started before; current state: ".concat(this.state));
                    return false;
                }
                if (stopArguments.stopTime < pageLoadMetaMetricData.start) {
                    (0, $7rgZR.logger).log("metric ".concat(this.config.key, " has been stopped with stopTime lower than startTime; startTime: ").concat(pageLoadMetaMetricData.start, "; stopTime: ").concat(stopArguments.stopTime));
                    return false;
                }
                this.merge(pageLoadMetaMetricData);
                this.stopTime = stopArguments.stopTime;
                this.state = (0, $kB69W.MetricState).FINISHED;
                this.handleStop(stopArguments);
                return true;
            }
        },
        {
            key: "handleStop",
            value: function handleStop(stopArguments) {
                var until = this.config.until;
                var fmpWasMarked = BasePageLoadMetric.FMP in this.marks;
                if (!fmpWasMarked && until) {
                    // Extract the maximum FMP value from the until metrics
                    var untilArr = Array.isArray(until) ? this.getConfiguredUntilMetricArray(until) : this.getConfiguredUntilMetricArray([
                        until
                    ]);
                    var untilFmpMarks = untilArr.map(function(metric) {
                        return metric.getFmp();
                    });
                    if (untilFmpMarks.every(Number.isFinite)) this.markFMP(Math.max.apply(Math, (0, (/*@__PURE__*/$parcel$interopDefault($VeSwC)))(untilFmpMarks)));
                }
                (0, (/*@__PURE__*/$parcel$interopDefault($2CEPP)))((0, (/*@__PURE__*/$parcel$interopDefault($7mJzd)))(BasePageLoadMetric.prototype), "handleStop", this).call(this, stopArguments);
            }
        },
        {
            key: "mark",
            value: function mark(_mark) {
                var timestamp = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window.performance.now();
                if (_mark === BasePageLoadMetric.FMP) return;
                (0, (/*@__PURE__*/$parcel$interopDefault($2CEPP)))((0, (/*@__PURE__*/$parcel$interopDefault($7mJzd)))(BasePageLoadMetric.prototype), "mark", this).call(this, _mark, timestamp);
            }
        },
        {
            key: "merge",
            value: function merge(mergeData) {
                (0, (/*@__PURE__*/$parcel$interopDefault($2CEPP)))((0, (/*@__PURE__*/$parcel$interopDefault($7mJzd)))(BasePageLoadMetric.prototype), "merge", this).call(this, mergeData);
                this.isInitial = mergeData.isInitial;
                this.explicitTimings = this.explicitTimings || mergeData.explicitTimings ? $1c99a9d9f9084479$var$_objectSpread($1c99a9d9f9084479$var$_objectSpread({}, mergeData.explicitTimings), this.explicitTimings) : null;
            }
        },
        {
            key: "markFMP",
            value: function markFMP(timestamp) {
                (0, (/*@__PURE__*/$parcel$interopDefault($2CEPP)))((0, (/*@__PURE__*/$parcel$interopDefault($7mJzd)))(BasePageLoadMetric.prototype), "mark", this).call(this, BasePageLoadMetric.FMP, timestamp);
            }
        },
        {
            key: "getPageLoadData",
            value: function getPageLoadData() {
                return {
                    isInitial: this.isInitial,
                    explicitTimings: this.explicitTimings
                };
            }
        },
        {
            key: "getData",
            value: function getData() {
                return $1c99a9d9f9084479$var$_objectSpread($1c99a9d9f9084479$var$_objectSpread({}, (0, (/*@__PURE__*/$parcel$interopDefault($2CEPP)))((0, (/*@__PURE__*/$parcel$interopDefault($7mJzd)))(BasePageLoadMetric.prototype), "getData", this).call(this)), this.getPageLoadData());
            }
        },
        {
            key: "getDataToMerge",
            value: function getDataToMerge() {
                return $1c99a9d9f9084479$var$_objectSpread($1c99a9d9f9084479$var$_objectSpread({}, (0, (/*@__PURE__*/$parcel$interopDefault($2CEPP)))((0, (/*@__PURE__*/$parcel$interopDefault($7mJzd)))(BasePageLoadMetric.prototype), "getDataToMerge", this).call(this)), this.getPageLoadData());
            }
        },
        {
            key: "clear",
            value: function clear() {
                this.explicitTimings = null;
                (0, (/*@__PURE__*/$parcel$interopDefault($2CEPP)))((0, (/*@__PURE__*/$parcel$interopDefault($7mJzd)))(BasePageLoadMetric.prototype), "clear", this).call(this);
            }
        }
    ]);
    return BasePageLoadMetric;
}((0, $kB69W.BaseMetric));
(0, (/*@__PURE__*/$parcel$interopDefault($9Z3Ln)))($1c99a9d9f9084479$export$fd1447b187f590fe, "FMP", "fmp");

});
parcelRegister("iPXoY", function(module, exports) {
function $db6b11654940cfb2$var$_objectDestructuringEmpty(t) {
    if (null == t) throw new TypeError("Cannot destructure " + t);
}
module.exports = $db6b11654940cfb2$var$_objectDestructuringEmpty, module.exports.__esModule = true, module.exports["default"] = module.exports;

});




parcelRegister("8LnAj", function(module, exports) {

$parcel$export(module.exports, "webVitalsMetrics", function () { return $661501f5d9f50836$export$3731db279f590f30; });

var $9Z3Ln = parcelRequire("9Z3Ln");

var $4BwFW = parcelRequire("4BwFW");

var $c39NH = parcelRequire("c39NH");

var $kB69W = parcelRequire("kB69W");

var $eEAbY = parcelRequire("eEAbY");

var $8TkP5 = parcelRequire("8TkP5");

var $iyv26 = parcelRequire("iyv26");
function $661501f5d9f50836$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $661501f5d9f50836$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $661501f5d9f50836$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($9Z3Ln)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $661501f5d9f50836$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $661501f5d9f50836$export$3731db279f590f30 = /*#__PURE__*/ function() {
    var _ref = (0, (/*@__PURE__*/$parcel$interopDefault($4BwFW)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($c39NH))).mark(function _callee(config, data, globalConfig) {
        var _globalConfig$webVita, _globalConfig$webVita2, _globalConfig$webVita3;
        var pageVisibleState, setPageVisibleStateToMixed, ttciEnabled, webVitalMetrics;
        return (0, (/*@__PURE__*/$parcel$interopDefault($c39NH))).wrap(function _callee$(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    pageVisibleState = data.pageVisibleState;
                    setPageVisibleStateToMixed = function setPageVisibleStateToMixed() {
                        pageVisibleState = (0, $kB69W.PageVisibleState).MIXED;
                    };
                    (0, $eEAbY.visibilityChangeObserver).subscribe(setPageVisibleStateToMixed);
                    ttciEnabled = ((_globalConfig$webVita = globalConfig.webVitals) === null || _globalConfig$webVita === void 0 ? void 0 : _globalConfig$webVita.ttciEnabled) !== undefined ? (_globalConfig$webVita2 = globalConfig.webVitals) === null || _globalConfig$webVita2 === void 0 ? void 0 : _globalConfig$webVita2.ttciEnabled : true;
                    _context.next = 6;
                    return $661501f5d9f50836$export$193ae490b52081dd(ttciEnabled, ((_globalConfig$webVita3 = globalConfig.webVitals) === null || _globalConfig$webVita3 === void 0 ? void 0 : _globalConfig$webVita3.timeout) || 30000);
                case 6:
                    webVitalMetrics = _context.sent;
                    (0, $eEAbY.visibilityChangeObserver).unsubscribe(setPageVisibleStateToMixed);
                    return _context.abrupt("return", $661501f5d9f50836$var$_objectSpread($661501f5d9f50836$var$_objectSpread({}, webVitalMetrics), {}, {
                        "pageVisible:state": pageVisibleState
                    }, (0, $iyv26.pageVisibleValue)(config, data, globalConfig)));
                case 9:
                case "end":
                    return _context.stop();
            }
        }, _callee);
    }));
    return function webVitalsMetrics(_x, _x2, _x3) {
        return _ref.apply(this, arguments);
    };
}();
var $661501f5d9f50836$export$193ae490b52081dd = /*#__PURE__*/ function() {
    var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($4BwFW)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($c39NH))).mark(function _callee2(ttciEnabled, timeout) {
        var timeoutWindow;
        return (0, (/*@__PURE__*/$parcel$interopDefault($c39NH))).wrap(function _callee2$(_context2) {
            while(true)switch(_context2.prev = _context2.next){
                case 0:
                    _context2.next = 2;
                    return ttciEnabled ? (0, $8TkP5.webVitalsObserver).ttciDetermined : Promise.resolve();
                case 2:
                    // wait up to $timeout ms longer for web-vitals until returning
                    timeoutWindow = new Promise(function(resolve) {
                        return setTimeout(resolve, timeout);
                    });
                    _context2.next = 5;
                    return Promise.race([
                        timeoutWindow,
                        (0, $8TkP5.webVitalsObserver).webVitalsDetermined
                    ]);
                case 5:
                    return _context2.abrupt("return", (0, $8TkP5.webVitalsObserver).data);
                case 6:
                case "end":
                    return _context2.stop();
            }
        }, _callee2);
    }));
    return function webVitalsMetricCustomTimeout(_x4, _x5) {
        return _ref2.apply(this, arguments);
    };
}();

});
parcelRegister("8TkP5", function(module, exports) {

$parcel$export(module.exports, "webVitalsObserver", function () { return $67939cc85985dd49$export$253d38dccbb37615; });

var $4BwFW = parcelRequire("4BwFW");

var $1W8kW = parcelRequire("1W8kW");

var $ceJcC = parcelRequire("ceJcC");

var $9Z3Ln = parcelRequire("9Z3Ln");

var $c39NH = parcelRequire("c39NH");


var $67939cc85985dd49$var$WebVitalsObserver = /*#__PURE__*/ function() {
    function WebVitalsObserver() {
        (0, (/*@__PURE__*/$parcel$interopDefault($1W8kW)))(this, WebVitalsObserver);
        (0, (/*@__PURE__*/$parcel$interopDefault($9Z3Ln)))(this, "data", {
            "metric:ttci": null,
            "metric:ttfb": null,
            "metric:fid": null,
            "metric:fcp": null,
            "metric:lcp": null,
            "metric:cls": null
        });
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($ceJcC)))(WebVitalsObserver, [
        {
            key: "start",
            value: function start() {
                this.ttciDetermined = this.registerTTCI();
                this.webVitalsDetermined = this.registerWebVitals();
            }
        },
        {
            key: "registerWebVitals",
            value: function() {
                var _registerWebVitals = (0, (/*@__PURE__*/$parcel$interopDefault($4BwFW)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($c39NH))).mark(function _callee() {
                    var _this = this;
                    var _yield$import, getCLS, getFCP, getFID, getLCP, getTTFB;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($c39NH))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                _context.prev = 0;
                                _context.next = 3;
                                return (parcelRequire("81oJe"));
                            case 3:
                                _yield$import = _context.sent;
                                getCLS = _yield$import.getCLS;
                                getFCP = _yield$import.getFCP;
                                getFID = _yield$import.getFID;
                                getLCP = _yield$import.getLCP;
                                getTTFB = _yield$import.getTTFB;
                                _context.next = 11;
                                return Promise.all([
                                    getTTFB,
                                    getFID,
                                    getFCP,
                                    getLCP,
                                    getCLS
                                ].map(function(fx) {
                                    return new Promise(function(resolve) {
                                        fx(function(_ref) {
                                            var name = _ref.name, value = _ref.value;
                                            // round FCP, FID, LCP, TTFB to nearest integer.
                                            // CLS is rounded to two decimal places.
                                            var metricName = name.toLowerCase();
                                            var metricValue = metricName === "cls" ? parseFloat(value.toFixed(2)) : Math.round(value);
                                            _this.data["metric:".concat(metricName)] = metricValue;
                                            resolve();
                                        });
                                    });
                                }));
                            case 11:
                                _context.next = 15;
                                break;
                            case 13:
                                _context.prev = 13;
                                _context.t0 = _context["catch"](0);
                            case 15:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, null, [
                        [
                            0,
                            13
                        ]
                    ]);
                }));
                function registerWebVitals() {
                    return _registerWebVitals.apply(this, arguments);
                }
                return registerWebVitals;
            }()
        },
        {
            key: "registerTTCI",
            value: function() {
                var _registerTTCI = (0, (/*@__PURE__*/$parcel$interopDefault($4BwFW)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($c39NH))).mark(function _callee2() {
                    var _this2 = this;
                    var ttiPolyfill;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($c39NH))).wrap(function _callee2$(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                _context2.prev = 0;
                                _context2.next = 3;
                                return (parcelRequire("buBue"));
                            case 3:
                                ttiPolyfill = _context2.sent;
                                _context2.next = 6;
                                return ttiPolyfill.getFirstConsistentlyInteractive().then(function(value) {
                                    // according to the docs:
                                    // If no TTI value can be found, or if the browser doesn't support all the APIs required to detect TTI,
                                    // the promise resolves to null.
                                    _this2.data["metric:ttci"] = typeof value === "number" ? Math.round(value) : value;
                                    return true;
                                });
                            case 6:
                                _context2.next = 10;
                                break;
                            case 8:
                                _context2.prev = 8;
                                _context2.t0 = _context2["catch"](0);
                            case 10:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, null, [
                        [
                            0,
                            8
                        ]
                    ]);
                }));
                function registerTTCI() {
                    return _registerTTCI.apply(this, arguments);
                }
                return registerTTCI;
            }()
        }
    ]);
    return WebVitalsObserver;
}();
var $67939cc85985dd49$export$253d38dccbb37615 = new $67939cc85985dd49$var$WebVitalsObserver();

});
parcelRegister("81oJe", function(module, exports) {

var $6aCUT = parcelRequire("6aCUT");
module.exports = $6aCUT("4AjDb").then(()=>parcelRequire("dIqE3"));

});

parcelRegister("buBue", function(module, exports) {

var $6aCUT = parcelRequire("6aCUT");
module.exports = $6aCUT("cRhdY").then(()=>parcelRequire("40m1W"));

});


parcelRegister("iyv26", function(module, exports) {

$parcel$export(module.exports, "pageVisibleValue", function () { return $d82379740f802603$export$177b923114656380; });

var $kB69W = parcelRequire("kB69W");
var $c2GEI = parcelRequire("c2GEI");
var $d82379740f802603$export$177b923114656380 = function pageVisibleValue(_config, data, globalConfig) {
    var value = globalConfig.pageVisibleValueOrigin === (0, $c2GEI.PageVisibleValueOrigin).documentHidden ? !document.hidden || false : data.pageVisibleState === (0, $kB69W.PageVisibleState).VISIBLE;
    return {
        "pageVisible:value": value
    };
};

});


parcelRegister("5z2oW", function(module, exports) {

$parcel$export(module.exports, "pageVisibleState", function () { return $40d2157e35f8dac5$export$723b4c298aca63af; });
var $40d2157e35f8dac5$export$723b4c298aca63af = function pageVisibleState(_config, data) {
    return {
        "pageVisible:state": data.pageVisibleState
    };
};

});

parcelRegister("iSYNK", function(module, exports) {

$parcel$export(module.exports, "productCustomData", function () { return $dbfc6f02d2422604$export$fa2af6e412815a74; });

var $3q6vl = parcelRequire("3q6vl");

var $4BwFW = parcelRequire("4BwFW");

var $c39NH = parcelRequire("c39NH");
var $dbfc6f02d2422604$export$fa2af6e412815a74 = /*#__PURE__*/ function() {
    var _ref = (0, (/*@__PURE__*/$parcel$interopDefault($4BwFW)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($c39NH))).mark(function _callee(_config, data, globalConfig) {
        var result, pluginOutputs;
        return (0, (/*@__PURE__*/$parcel$interopDefault($c39NH))).wrap(function _callee$(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    if (!(!globalConfig.custom && !globalConfig.plugins)) {
                        _context.next = 2;
                        break;
                    }
                    return _context.abrupt("return", null);
                case 2:
                    result = {};
                    if (globalConfig.custom) Object.entries(globalConfig.custom).forEach(function(_ref2) {
                        var _ref3 = (0, (/*@__PURE__*/$parcel$interopDefault($3q6vl)))(_ref2, 2), key = _ref3[0], value = _ref3[1];
                        result["".concat(globalConfig.product, ":").concat(key)] = value;
                    });
                    if (!globalConfig.plugins) {
                        _context.next = 9;
                        break;
                    }
                    _context.next = 7;
                    return Promise.all(globalConfig.plugins.map(function(plugin) {
                        return plugin({
                            start: data.start,
                            stop: data.stop,
                            key: data.key
                        });
                    }));
                case 7:
                    pluginOutputs = _context.sent;
                    pluginOutputs.forEach(function(pluginOutput) {
                        if (pluginOutput === null) return;
                        Object.entries(pluginOutput).forEach(function(_ref4) {
                            var _ref5 = (0, (/*@__PURE__*/$parcel$interopDefault($3q6vl)))(_ref4, 2), key = _ref5[0], value = _ref5[1];
                            result["".concat(globalConfig.product, ":").concat(key)] = value;
                        });
                    });
                case 9:
                    return _context.abrupt("return", result);
                case 10:
                case "end":
                    return _context.stop();
            }
        }, _callee);
    }));
    return function productCustomData(_x, _x2, _x3) {
        return _ref.apply(this, arguments);
    };
}();

});

parcelRegister("gQNe1", function(module, exports) {

$parcel$export(module.exports, "ssrFeatureFlags", function () { return $c447afbe85cbae6a$export$fdbea518c19dfa8; });

var $4BwFW = parcelRequire("4BwFW");

var $c39NH = parcelRequire("c39NH");

var $c2GEI = parcelRequire("c2GEI");
var $c447afbe85cbae6a$var$retrieveFeatureFlags = /*#__PURE__*/ function() {
    var _ref = (0, (/*@__PURE__*/$parcel$interopDefault($4BwFW)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($c39NH))).mark(function _callee(getFeatureFlags) {
        var featureFlags;
        return (0, (/*@__PURE__*/$parcel$interopDefault($c39NH))).wrap(function _callee$(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    _context.prev = 0;
                    _context.next = 3;
                    return getFeatureFlags();
                case 3:
                    featureFlags = _context.sent;
                    if (!featureFlags) {
                        _context.next = 6;
                        break;
                    }
                    return _context.abrupt("return", {
                        "ssr:featureFlags": featureFlags
                    });
                case 6:
                    _context.next = 10;
                    break;
                case 8:
                    _context.prev = 8;
                    _context.t0 = _context["catch"](0);
                case 10:
                    return _context.abrupt("return", null);
                case 11:
                case "end":
                    return _context.stop();
            }
        }, _callee, null, [
            [
                0,
                8
            ]
        ]);
    }));
    return function retrieveFeatureFlags(_x) {
        return _ref.apply(this, arguments);
    };
}();
var $c447afbe85cbae6a$export$fdbea518c19dfa8 = /*#__PURE__*/ function() {
    var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($4BwFW)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($c39NH))).mark(function _callee2(config, _data, globalConfig) {
        var _globalConfig$ssr, _config$ssr, _globalConfig$ssr2, _config$ssr2;
        var includeFeatureFlags;
        return (0, (/*@__PURE__*/$parcel$interopDefault($c39NH))).wrap(function _callee2$(_context2) {
            while(true)switch(_context2.prev = _context2.next){
                case 0:
                    if ((_globalConfig$ssr = globalConfig.ssr) !== null && _globalConfig$ssr !== void 0 && _globalConfig$ssr.getFeatureFlags) {
                        _context2.next = 2;
                        break;
                    }
                    return _context2.abrupt("return", null);
                case 2:
                    includeFeatureFlags = ((_config$ssr = config.ssr) === null || _config$ssr === void 0 ? void 0 : _config$ssr.includeFeatureFlags) || ((_globalConfig$ssr2 = globalConfig.ssr) === null || _globalConfig$ssr2 === void 0 ? void 0 : _globalConfig$ssr2.includeFeatureFlags) || (0, $c2GEI.IncludeSSRFeatureFlagsConfig).WHEN_FMP;
                    if (!(includeFeatureFlags === (0, $c2GEI.IncludeSSRFeatureFlagsConfig).WHEN_AVAILABLE || (_config$ssr2 = config.ssr) !== null && _config$ssr2 !== void 0 && _config$ssr2.doneAsFmp && includeFeatureFlags === (0, $c2GEI.IncludeSSRFeatureFlagsConfig).WHEN_FMP)) {
                        _context2.next = 7;
                        break;
                    }
                    _context2.next = 6;
                    return $c447afbe85cbae6a$var$retrieveFeatureFlags(globalConfig.ssr.getFeatureFlags);
                case 6:
                    return _context2.abrupt("return", _context2.sent);
                case 7:
                    return _context2.abrupt("return", null);
                case 8:
                case "end":
                    return _context2.stop();
            }
        }, _callee2);
    }));
    return function ssrFeatureFlags(_x2, _x3, _x4) {
        return _ref2.apply(this, arguments);
    };
}();

});

parcelRegister("ga5Vr", function(module, exports) {

$parcel$export(module.exports, "ssrSuccess", function () { return $bc422d29fa1afef2$export$a3dc8251cf55b2e0; });
var $bc422d29fa1afef2$export$a3dc8251cf55b2e0 = function ssrSuccess(config, _data, globalConfig) {
    if (config.ssr && config.ssr.doneAsFmp && globalConfig.ssr && globalConfig.ssr.getDoneMark && globalConfig.ssr.getDoneMark()) return {
        "ssr:success": true
    };
    return null;
};

});

parcelRegister("7ojrT", function(module, exports) {

$parcel$export(module.exports, "telemetryBrowser", function () { return $5619dc6e349878a8$export$386b10ac64a50b1; });

var $4psuI = parcelRequire("4psuI");
var $5619dc6e349878a8$export$386b10ac64a50b1 = function telemetryBrowser() {
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($4psuI))).getParser) return null;
    var browser = (0, (/*@__PURE__*/$parcel$interopDefault($4psuI))).getParser(window.navigator.userAgent);
    return {
        "telemetry:browser:name": browser.getBrowserName(),
        "telemetry:browser:version": browser.getBrowserVersion()
    };
};

});
parcelRegister("4psuI", function(module, exports) {
!function(e, r) {
    module.exports = r();
}(module.exports, function() {
    return function(e) {
        var r = {};
        function t(n) {
            if (r[n]) return r[n].exports;
            var i = r[n] = {
                i: n,
                l: !1,
                exports: {}
            };
            return e[n].call(i.exports, i, i.exports, t), i.l = !0, i.exports;
        }
        return t.m = e, t.c = r, t.d = function(e, r, n) {
            t.o(e, r) || Object.defineProperty(e, r, {
                enumerable: !0,
                get: n
            });
        }, t.r = function(e) {
            "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
                value: "Module"
            }), Object.defineProperty(e, "__esModule", {
                value: !0
            });
        }, t.t = function(e, r) {
            if (1 & r && (e = t(e)), 8 & r) return e;
            if (4 & r && "object" == typeof e && e && e.__esModule) return e;
            var n = Object.create(null);
            if (t.r(n), Object.defineProperty(n, "default", {
                enumerable: !0,
                value: e
            }), 2 & r && "string" != typeof e) for(var i in e)t.d(n, i, (function(r) {
                return e[r];
            }).bind(null, i));
            return n;
        }, t.n = function(e) {
            var r = e && e.__esModule ? function() {
                return e.default;
            } : function() {
                return e;
            };
            return t.d(r, "a", r), r;
        }, t.o = function(e, r) {
            return Object.prototype.hasOwnProperty.call(e, r);
        }, t.p = "", t(t.s = 0);
    }([
        function(e, r, t) {
            "use strict";
            r.__esModule = !0, r.default = void 0;
            var n, i = (n = t(1)) && n.__esModule ? n : {
                default: n
            };
            /*!
 * Bowser - a browser detector
 * https://github.com/lancedikson/bowser
 * MIT License | (c) Dustin Diaz 2012-2015
 * MIT License | (c) Denis Demchenko 2015-2019
 */ var o = function() {
                function e() {}
                return e.getParser = function(e, r) {
                    if (void 0 === r && (r = !1), "string" != typeof e) throw new Error("UserAgent should be a string");
                    return new i.default(e, r);
                }, e.parse = function(e) {
                    return new i.default(e).getResult();
                }, e;
            }();
            r.default = o, e.exports = r.default;
        },
        function(e, r, t) {
            "use strict";
            r.__esModule = !0, r.default = void 0;
            var n, i = (n = t(2)) && n.__esModule ? n : {
                default: n
            };
            var o = function() {
                function e(e, r) {
                    if (void 0 === r && (r = !1), null == e || "" === e) throw new Error("UserAgent parameter can't be empty");
                    this._ua = e, this.parsedResult = {}, !0 !== r && this.parse();
                }
                var r = e.prototype;
                return r.getUA = function() {
                    return this._ua;
                }, r.test = function(e) {
                    return e.test(this._ua);
                }, r.parseBrowser = function() {
                    var e = this;
                    this.parsedResult.browser = {};
                    var r = i.default.find(function(r) {
                        if ("function" == typeof r.test) return r.test(e);
                        if (r.test instanceof Array) return r.test.some(function(r) {
                            return e.test(r);
                        });
                        throw new Error("Browser's test function is not valid");
                    });
                    return r && (this.parsedResult.browser = r.describe(this.getUA())), this.parsedResult.browser;
                }, r.isMobile = function() {
                    return this.test(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i);
                }, r.getBrowser = function() {
                    return this.parsedResult.browser ? this.parsedResult.browser : this.parseBrowser();
                }, r.getBrowserName = function(e) {
                    return e ? String(this.getBrowser().name).toLowerCase() || "" : this.getBrowser().name || "";
                }, r.getBrowserVersion = function() {
                    return this.getBrowser().version;
                }, r.parse = function() {
                    return this.parseBrowser(), this;
                }, r.getResult = function() {
                    return Object.assign({}, this.parsedResult);
                }, e;
            }();
            r.default = o, e.exports = r.default;
        },
        function(e, r, t) {
            "use strict";
            function n(e, r) {
                var t = "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
                if (t) return (t = t.call(e)).next.bind(t);
                if (Array.isArray(e) || (t = function(e, r) {
                    if (!e) return;
                    if ("string" == typeof e) return i(e, r);
                    var t = Object.prototype.toString.call(e).slice(8, -1);
                    "Object" === t && e.constructor && (t = e.constructor.name);
                    if ("Map" === t || "Set" === t) return Array.from(e);
                    if ("Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t)) return i(e, r);
                }(e)) || r && e && "number" == typeof e.length) {
                    t && (e = t);
                    var n = 0;
                    return function() {
                        return n >= e.length ? {
                            done: !0
                        } : {
                            done: !1,
                            value: e[n++]
                        };
                    };
                }
                throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
            }
            function i(e, r) {
                (null == r || r > e.length) && (r = e.length);
                for(var t = 0, n = new Array(r); t < r; t++)n[t] = e[t];
                return n;
            }
            r.__esModule = !0, r.default = void 0;
            var o = function(e, r) {
                var t = r.match(e);
                return t && t.length > 0 && t[1] || "";
            }, s = function(e, r) {
                var t = r.match(e);
                return t && t.length > 1 && t[2] || "";
            }, u = /version\/(\d+(\.?_?\d+)+)/i, a = function(e, r) {
                void 0 === e && (e = []);
                for(var t, i = n(e); !(t = i()).done;){
                    var s = t.value, u = o(s, r);
                    if (u) return u;
                }
                return null;
            }, d = [
                {
                    test: [
                        /googlebot/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Googlebot",
                            version: a([
                                /googlebot\/(\d+(\.\d+))/i,
                                u
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /opera/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Opera",
                            version: a([
                                u,
                                /(?:opera)[\s/](\d+(\.?_?\d+)+)/i
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /opr\/|opios/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Opera",
                            version: a([
                                /(?:opr|opios)[\s/](\S+)/i,
                                u
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /SamsungBrowser/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Samsung Internet for Android",
                            version: a([
                                u,
                                /(?:SamsungBrowser)[\s/](\d+(\.?_?\d+)+)/i
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /Whale/i
                    ],
                    describe: function(e) {
                        return {
                            name: "NAVER Whale Browser",
                            version: a([
                                u,
                                /(?:whale)[\s/](\d+(?:\.\d+)+)/i
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /coast/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Opera Coast",
                            version: a([
                                u,
                                /(?:coast)[\s/](\d+(\.?_?\d+)+)/i
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /opt\/\d+(?:.?_?\d+)+/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Opera Touch",
                            version: a([
                                /(?:opt)[\s/](\d+(\.?_?\d+)+)/i,
                                u
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /msie|trident/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Internet Explorer",
                            version: a([
                                /(?:msie |rv:)(\d+(\.?_?\d+)+)/i
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /\sedg\//i
                    ],
                    describe: function(e) {
                        return {
                            name: "Microsoft Edge",
                            version: a([
                                /\sedg\/(\d+(\.?_?\d+)+)/i
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /edg([ea]|ios)/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Microsoft Edge",
                            version: s(/edg([ea]|ios)\/(\d+(\.?_?\d+)+)/i, e)
                        };
                    }
                },
                {
                    test: [
                        /vivaldi/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Vivaldi",
                            version: a([
                                /vivaldi\/(\d+(\.?_?\d+)+)/i
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /tizen/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Tizen",
                            version: a([
                                /(?:tizen\s?)?browser\/(\d+(\.?_?\d+)+)/i,
                                u
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /firefox|iceweasel|fxios/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Firefox",
                            version: a([
                                /(?:firefox|iceweasel|fxios)[\s/](\d+(\.?_?\d+)+)/i
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /electron/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Electron",
                            version: a([
                                /(?:electron)\/(\d+(\.?_?\d+)+)/i
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /chromium/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Chromium",
                            version: a([
                                /(?:chromium)[\s/](\d+(\.?_?\d+)+)/i,
                                u
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /chrome|crios|crmo/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Chrome",
                            version: a([
                                /(?:chrome|crios|crmo)\/(\d+(\.?_?\d+)+)/i
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /GSA/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Google Search",
                            version: a([
                                /(?:GSA)\/(\d+(\.?_?\d+)+)/i
                            ], e)
                        };
                    }
                },
                {
                    test: function(e) {
                        var r = !e.test(/like android/i), t = e.test(/android/i);
                        return r && t;
                    },
                    describe: function(e) {
                        return {
                            name: "Android Browser",
                            version: a([
                                u
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /safari|applewebkit/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Safari",
                            version: a([
                                u
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /.*/i
                    ],
                    describe: function(e) {
                        var r = -1 !== e.search("\\(") ? /^(.*)\/(.*)[ \t]\((.*)/ : /^(.*)\/(.*) /;
                        return {
                            name: o(r, e),
                            version: s(r, e)
                        };
                    }
                }
            ];
            r.default = d, e.exports = r.default;
        }
    ]);
});

});


parcelRegister("1xsz9", function(module, exports) {

$parcel$export(module.exports, "telemetryCpu", function () { return $11ef081fff4f7e13$export$9f84cb359ed29139; });
var $11ef081fff4f7e13$export$9f84cb359ed29139 = function telemetryCpu() {
    if (!navigator.hardwareConcurrency) return null;
    return {
        "telemetry:cpus": navigator.hardwareConcurrency
    };
};

});

parcelRegister("3UnzA", function(module, exports) {

$parcel$export(module.exports, "telemetryMemory", function () { return $2d88e32910886864$export$496c14d72b257e07; });
var $2d88e32910886864$export$496c14d72b257e07 = function telemetryMemory() {
    // @ts-ignore: deviceMemory is exposed in some browsers
    if (!navigator.deviceMemory) return null;
    return {
        // @ts-ignore
        "telemetry:memory": navigator.deviceMemory
    };
};

});

parcelRegister("hppIa", function(module, exports) {

$parcel$export(module.exports, "telemetryNetwork", function () { return $cac8b739b7464a1d$export$88bf7b55f7fc4e8e; });
var $cac8b739b7464a1d$export$88bf7b55f7fc4e8e = function telemetryNetwork() {
    // @ts-ignore: connection is available in some browsers
    // eslint-disable-next-line compat/compat
    if (!navigator.connection) return null;
    return {
        // @ts-ignore: connection is available in some browsers
        // eslint-disable-next-line compat/compat
        "telemetry:network:effectiveType": navigator.connection.effectiveType,
        // @ts-ignore: connection is available in some browsers
        // eslint-disable-next-line compat/compat
        "telemetry:network:rtt": navigator.connection.rtt,
        // @ts-ignore: connection is available in some browsers
        // eslint-disable-next-line compat/compat
        "telemetry:network:downlink": navigator.connection.downlink
    };
};

});

parcelRegister("2jJXz", function(module, exports) {

$parcel$export(module.exports, "appTimings", function () { return $1b0101cbf76d618b$export$e952f50a4f2d02da; });

var $9Z3Ln = parcelRequire("9Z3Ln");

var $c2GEI = parcelRequire("c2GEI");

var $6CFNx = parcelRequire("6CFNx");

var $ewk9V = parcelRequire("ewk9V");
function $1b0101cbf76d618b$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $1b0101cbf76d618b$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $1b0101cbf76d618b$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($9Z3Ln)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $1b0101cbf76d618b$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $1b0101cbf76d618b$export$e952f50a4f2d02da = function appTimings(config, data, globalConfig) {
    var explicitTimings = config.type === (0, $c2GEI.BMEventsType).PAGE_LOAD && data.explicitTimings || null;
    var timings = (0, $6CFNx.customTimings)(config, data);
    var ssr = config.type === (0, $c2GEI.BMEventsType).PAGE_LOAD && data.isInitial ? (0, $ewk9V.ssrTimings)(config, data, globalConfig) : null;
    var timingsApp = (explicitTimings || timings || ssr) && $1b0101cbf76d618b$var$_objectSpread($1b0101cbf76d618b$var$_objectSpread($1b0101cbf76d618b$var$_objectSpread({}, explicitTimings), timings), ssr);
    if (!timingsApp) return null;
    return {
        "timings:app": timingsApp
    };
};

});
parcelRegister("6CFNx", function(module, exports) {

$parcel$export(module.exports, "customTimings", function () { return $4d26b6e179f42b62$export$6126f85083a72c6e; });

var $7F23o = parcelRequire("7F23o");
var $4d26b6e179f42b62$var$retrieveTimings = function retrieveTimings(config, data) {
    var relativeTo = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
    var prefix = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "";
    var configTimings = config.timings || [];
    var timings = configTimings.reduce(function(entries, timing) {
        if (timing.startMark && !data.marks[timing.startMark]) return entries;
        if (timing.endMark && !data.marks[timing.endMark]) return entries;
        if (data.start === null || data.stop === null) return null;
        var startTime = Math.round((data.marks[timing.startMark] !== undefined ? data.marks[timing.startMark] : data.start) - data.start + relativeTo);
        var duration = Math.round((data.marks[timing.endMark] !== undefined ? data.marks[timing.endMark] : data.stop) - data.start - startTime + relativeTo);
        entries["".concat(prefix).concat(timing.key)] = {
            startTime: startTime,
            duration: duration
        };
        return entries;
    }, {});
    return timings;
};
var $4d26b6e179f42b62$export$6126f85083a72c6e = function customTimings(config, data) {
    if (!config.timings && data.submetrics.length === 0) return null;
    var timings = $4d26b6e179f42b62$var$retrieveTimings(config, data);
    data.submetrics.forEach(function(submetric) {
        if (submetric.start !== null && submetric.stop !== null) {
            var submetricPrefix = "include:".concat(submetric.config.key);
            timings[submetricPrefix] = {
                startTime: Math.round(submetric.start - data.start),
                duration: Math.round(submetric.stop - submetric.start)
            };
            Object.assign(timings, $4d26b6e179f42b62$var$retrieveTimings(submetric.config, submetric, submetric.start - data.start, submetricPrefix + (0, $7F23o.NESTED_METRIC_SEPARATOR)));
        }
    });
    if (Object.keys(timings).length === 0) return null;
    return timings;
};

});
parcelRegister("7F23o", function(module, exports) {

$parcel$export(module.exports, "NESTED_METRIC_SEPARATOR", function () { return $593df4922c42f2a0$export$b98e411ae80c806f; });
var $593df4922c42f2a0$export$b98e411ae80c806f = "/";

});


parcelRegister("ewk9V", function(module, exports) {

$parcel$export(module.exports, "ssrTimings", function () { return $a923b10321033713$export$130f411261a599c5; });

var $lGj01 = parcelRequire("lGj01");

var $7F23o = parcelRequire("7F23o");
var $a923b10321033713$var$filterEntry = function filterEntry(entry) {
    return !(!entry || (0, (/*@__PURE__*/$parcel$interopDefault($lGj01)))(entry) !== "object" || entry.startTime < 0 || entry.duration < 0);
};
var $a923b10321033713$var$mapEntry = function mapEntry(entry) {
    return {
        startTime: Math.round(entry.startTime),
        duration: Math.round(entry.duration)
    };
};
var $a923b10321033713$var$SSR_PREFIX = "ssr";
var $a923b10321033713$var$mapKey = function mapKey(key) {
    if (key === "total") return $a923b10321033713$var$SSR_PREFIX;
    return "".concat($a923b10321033713$var$SSR_PREFIX).concat((0, $7F23o.NESTED_METRIC_SEPARATOR)).concat(key);
};
var $a923b10321033713$export$130f411261a599c5 = function ssrTimings(_config, _data, globalConfig) {
    if (!globalConfig.ssr || !globalConfig.ssr.getTimings) return null;
    var timings = globalConfig.ssr.getTimings();
    if (!timings) return null;
    var ssrTimings = Object.entries(timings).reduce(function(acc, entry) {
        if ($a923b10321033713$var$filterEntry(entry[1])) acc[$a923b10321033713$var$mapKey(entry[0])] = $a923b10321033713$var$mapEntry(entry[1]);
        return acc;
    }, {});
    if (!ssrTimings || Object.keys(ssrTimings).length === 0) return null;
    return ssrTimings;
};

});


parcelRegister("hWbKv", function(module, exports) {

$parcel$export(module.exports, "bundleEvalTimings", function () { return $d0f0f78e47e8327c$export$1a2bb347935fc536; });

var $3q6vl = parcelRequire("3q6vl");
var $d0f0f78e47e8327c$var$bundleEvalTimingsInternal = function bundleEvalTimingsInternal(_config, data, globalConfig) {
    var _globalConfig$enableB;
    var performance = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : window.performance;
    var started = {};
    var timings = {};
    var enableBundleEvalTimings = (_globalConfig$enableB = globalConfig === null || globalConfig === void 0 ? void 0 : globalConfig.enableBundleEvalTimings) !== null && _globalConfig$enableB !== void 0 ? _globalConfig$enableB : true;
    performance.getEntriesByType("mark").forEach(function(mark) {
        if (!globalConfig.bundleEvalTimings) return;
        var result = globalConfig.bundleEvalTimings.mapPerformanceMark(mark.name);
        if (!result) return;
        var type = result.type, name = result.name;
        if (type === "start" && data.start !== null && mark.startTime >= data.start) {
            started[name] = mark;
            return;
        }
        if (type === "end" && started[name]) {
            timings[name] = {
                startTime: Math.round(started[name].startTime - data.start),
                duration: Math.round(mark.startTime - started[name].startTime)
            };
            delete started[name];
        }
    });
    if (globalConfig.bundleEvalTimings && globalConfig.bundleEvalTimings.additionalTimings && data.start !== null && enableBundleEvalTimings) {
        var result = globalConfig.bundleEvalTimings.additionalTimings(data.start);
        if (result) Object.entries(result).forEach(function(_ref) {
            var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($3q6vl)))(_ref, 2), key = _ref2[0], value = _ref2[1];
            timings[key] = value;
        });
    }
    if (Object.keys(timings).length === 0) return null;
    return {
        "timings:bundleEval": timings
    };
};
var $d0f0f78e47e8327c$export$1a2bb347935fc536 = function bundleEvalTimings() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return new Promise(function(resolve) {
        setTimeout(function() {
            resolve($d0f0f78e47e8327c$var$bundleEvalTimingsInternal.apply(void 0, args));
        });
    });
};

});

parcelRegister("dKmTc", function(module, exports) {

$parcel$export(module.exports, "resourceTimings", function () { return $a0215396f84a2fff$export$81a7d52441a06b50; });

var $9Z3Ln = parcelRequire("9Z3Ln");
function $a0215396f84a2fff$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $a0215396f84a2fff$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $a0215396f84a2fff$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($9Z3Ln)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $a0215396f84a2fff$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $a0215396f84a2fff$var$cacheableTypes = [
    "script",
    "link"
];
var $a0215396f84a2fff$var$resourceTypes = [
    "fetch",
    "xmlhttprequest"
];
var $a0215396f84a2fff$var$CACHE_NETWORK = "network";
var $a0215396f84a2fff$var$CACHE_MEMORY = "memory";
var $a0215396f84a2fff$var$CACHE_DISK = "disk";
var $a0215396f84a2fff$var$calculateTransferType = function calculateTransferType(type, duration, size) {
    if (!$a0215396f84a2fff$var$cacheableTypes.includes(type)) return $a0215396f84a2fff$var$CACHE_NETWORK;
    if ((size === undefined || size === 0) && duration === 0) return $a0215396f84a2fff$var$CACHE_MEMORY;
    if (size === 0 && duration > 0) return $a0215396f84a2fff$var$CACHE_DISK;
    if (size === undefined) return null;
    return $a0215396f84a2fff$var$CACHE_NETWORK;
};
var $a0215396f84a2fff$var$hasAccessToResourceSize = function hasAccessToResourceSize(url, type, hasTimingHeaders) {
    return !$a0215396f84a2fff$var$cacheableTypes.includes(type) || url.includes("localhost") || url.includes(window.location.hostname) || hasTimingHeaders(url);
};
var $a0215396f84a2fff$var$getReportedInitiatorTypes = function getReportedInitiatorTypes(xhrEnabled) {
    if (xhrEnabled) return [
        "script",
        "link",
        "fetch",
        "xmlhttprequest"
    ];
    return [
        "script",
        "link",
        "fetch"
    ];
};
var $a0215396f84a2fff$var$withoutHeaders = function withoutHeaders() {
    return false;
};
var $a0215396f84a2fff$var$evaluateAccessToResourceTimings = function evaluateAccessToResourceTimings(entry) {
    if (entry.responseStart === 0 && entry.startTime > entry.responseStart) return false;
    return true;
};
var $a0215396f84a2fff$var$getEvaluatedTimingHeader = function getEvaluatedTimingHeader(entry) {
    var enabled = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var hasTimingHeaders = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : $a0215396f84a2fff$var$withoutHeaders;
    if (!enabled) return null;
    var manualResolution = entry.name.includes("localhost") || entry.name.includes(window.location.hostname) || hasTimingHeaders(entry.name);
    var autoResolution = $a0215396f84a2fff$var$evaluateAccessToResourceTimings(entry);
    return {
        m_h: manualResolution,
        a_h: autoResolution
    };
};
var $a0215396f84a2fff$var$getSizeObject = function getSizeObject(size) {
    return size !== undefined ? {
        size: size
    } : null;
};
var $a0215396f84a2fff$var$getNetworkData = function getNetworkData(item, eventStart) {
    var hasTimingHeaders = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : $a0215396f84a2fff$var$withoutHeaders;
    var name = item.name, duration = item.duration, size = item.transferSize, type = item.initiatorType, responseStart = item.responseStart;
    var ttfb = Math.round(responseStart - eventStart);
    if (!$a0215396f84a2fff$var$hasAccessToResourceSize(name, type, hasTimingHeaders)) return {};
    if ($a0215396f84a2fff$var$cacheableTypes.includes(type)) {
        var transferType = $a0215396f84a2fff$var$calculateTransferType(type, duration, size);
        if (!transferType) return $a0215396f84a2fff$var$_objectSpread({
            ttfb: ttfb
        }, $a0215396f84a2fff$var$getSizeObject(size));
        if (transferType !== $a0215396f84a2fff$var$CACHE_NETWORK) return {
            transferType: transferType
        };
        return $a0215396f84a2fff$var$_objectSpread({
            ttfb: ttfb,
            transferType: transferType
        }, $a0215396f84a2fff$var$getSizeObject(size));
    }
    return $a0215396f84a2fff$var$_objectSpread({
        ttfb: ttfb
    }, $a0215396f84a2fff$var$getSizeObject(size));
};
var $a0215396f84a2fff$export$81a7d52441a06b50 = function resourceTimings(_config, data, globalConfig) {
    var performance = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : window.performance;
    if (data.start === null) return null;
    var resources = performance.getEntriesByType("resource").filter(function(entry) {
        return entry.startTime >= data.start;
    });
    if (!resources.length) return null;
    var resourceTiming = {};
    var xhrFilter = globalConfig.resourceTimings.xhrFilter;
    var reportedInitiatorTypes = $a0215396f84a2fff$var$getReportedInitiatorTypes(!!xhrFilter);
    resources.forEach(function(item) {
        if (!reportedInitiatorTypes.includes(item.initiatorType)) return;
        var name = item.name, startTime = item.startTime, duration = item.duration, workerStart = item.workerStart, fetchStart = item.fetchStart, type = item.initiatorType;
        if (!name) return;
        if (type === "xmlhttprequest" && (xhrFilter === undefined || xhrFilter(name) === false)) return;
        var url = $a0215396f84a2fff$var$resourceTypes.includes(type) ? globalConfig.resourceTimings.sanitiseEndpoints(name) : globalConfig.resourceTimings.mapResources(name);
        if (resourceTiming[url]) return;
        resourceTiming[url] = $a0215396f84a2fff$var$_objectSpread($a0215396f84a2fff$var$_objectSpread({
            startTime: Math.round(startTime - data.start),
            duration: Math.round(duration),
            workerStart: Math.max(Math.round(workerStart - data.start), 0),
            fetchStart: Math.max(Math.round(fetchStart - data.start), 0),
            type: type
        }, $a0215396f84a2fff$var$getNetworkData(item, data.start, globalConfig.resourceTimings.hasTimingHeaders)), $a0215396f84a2fff$var$getEvaluatedTimingHeader(item, globalConfig.resourceTimings.experimental__reportEvaluatedTimingHeaders, globalConfig.resourceTimings.hasTimingHeaders));
    });
    return {
        "timings:resource": resourceTiming
    };
};

});


parcelRegister("5D1NT", function(module, exports) {

$parcel$export(module.exports, "makeShareableGlobalConfig", function () { return $4191fe7034e39d78$export$5b4fb14409a2a825; });

var $4BwFW = parcelRequire("4BwFW");

var $9Z3Ln = parcelRequire("9Z3Ln");

var $VeSwC = parcelRequire("VeSwC");

var $c39NH = parcelRequire("c39NH");

var $c2GEI = parcelRequire("c2GEI");
function $4191fe7034e39d78$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $4191fe7034e39d78$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $4191fe7034e39d78$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($9Z3Ln)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $4191fe7034e39d78$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $4191fe7034e39d78$var$makeFeatureFlags = function makeFeatureFlags(allFeatureFlags, eventTypeFeatureFlags) {
    var featureFlagsForType = [];
    if (allFeatureFlags) featureFlagsForType.push.apply(featureFlagsForType, (0, (/*@__PURE__*/$parcel$interopDefault($VeSwC)))(allFeatureFlags));
    if (eventTypeFeatureFlags) featureFlagsForType.push.apply(featureFlagsForType, (0, (/*@__PURE__*/$parcel$interopDefault($VeSwC)))(eventTypeFeatureFlags));
    return featureFlagsForType;
};
var $4191fe7034e39d78$var$makeGlobalConfigPerType = function makeGlobalConfigPerType(global, ffClient, allEventsConfig, eventConfig) {
    var _ref, _eventConfig$pageVisi;
    var allEventsConfigCustom = allEventsConfig && allEventsConfig.custom;
    var eventConfigCustom = eventConfig && eventConfig.custom;
    var custom = (allEventsConfigCustom || eventConfigCustom) && $4191fe7034e39d78$var$_objectSpread($4191fe7034e39d78$var$_objectSpread({}, allEventsConfigCustom), eventConfigCustom) || undefined;
    var allEventsConfigPlugins = allEventsConfig && allEventsConfig.plugins;
    var eventConfigPlugins = eventConfig && eventConfig.plugins;
    var plugins = (allEventsConfigPlugins || eventConfigPlugins) && [].concat((0, (/*@__PURE__*/$parcel$interopDefault($VeSwC)))(allEventsConfigPlugins || []), (0, (/*@__PURE__*/$parcel$interopDefault($VeSwC)))(eventConfigPlugins || [])) || undefined;
    var pageVisibleValueOrigin = (_ref = (_eventConfig$pageVisi = eventConfig === null || eventConfig === void 0 ? void 0 : eventConfig.pageVisibleValueOrigin) !== null && _eventConfig$pageVisi !== void 0 ? _eventConfig$pageVisi : allEventsConfig === null || allEventsConfig === void 0 ? void 0 : allEventsConfig.pageVisibleValueOrigin) !== null && _ref !== void 0 ? _ref : (0, $c2GEI.PageVisibleValueOrigin).documentHidden;
    return Object.freeze($4191fe7034e39d78$var$_objectSpread($4191fe7034e39d78$var$_objectSpread({}, global), {}, {
        featureFlags: Object.freeze($4191fe7034e39d78$var$makeFeatureFlags(allEventsConfig && allEventsConfig.featureFlags, eventConfig && eventConfig.featureFlags).reduce(function(acc, value) {
            acc[value] = ffClient.getValue(value);
            return acc;
        }, {})),
        custom: custom,
        plugins: plugins,
        histogram: eventConfig === null || eventConfig === void 0 ? void 0 : eventConfig.histogram,
        pageVisibleValueOrigin: pageVisibleValueOrigin,
        enableBundleEvalTimings: eventConfig === null || eventConfig === void 0 ? void 0 : eventConfig.enableBundleEvalTimings
    }));
};
var $4191fe7034e39d78$export$5b4fb14409a2a825 = /*#__PURE__*/ function() {
    var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($4BwFW)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($c39NH))).mark(function _callee(globalConfig) {
        var _globalConfig$events$, _globalConfig$events$2, _globalConfig$events$3, _ref3;
        var ffClient, global;
        return (0, (/*@__PURE__*/$parcel$interopDefault($c39NH))).wrap(function _callee$(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    _context.next = 2;
                    return globalConfig.plugins.featureFlags.client;
                case 2:
                    ffClient = _context.sent;
                    global = {
                        app: globalConfig.info.app,
                        product: globalConfig.info.product,
                        region: globalConfig.info.region,
                        resourceTimings: globalConfig.plugins.resourceTimings,
                        bundleEvalTimings: globalConfig.plugins.bundleEvalTimings,
                        ffClient: ffClient,
                        hostname: globalConfig.info.hostname || window.location.hostname,
                        ssr: globalConfig.ssr,
                        enableReactUFOTracker: globalConfig.enableReactUFOTracker,
                        webVitals: {
                            enabled: (_globalConfig$events$ = globalConfig.events[(0, $c2GEI.BMEventsType).WEB_VITALS]) === null || _globalConfig$events$ === void 0 ? void 0 : _globalConfig$events$.enabled,
                            timeout: (_globalConfig$events$2 = globalConfig.events[(0, $c2GEI.BMEventsType).WEB_VITALS]) === null || _globalConfig$events$2 === void 0 ? void 0 : _globalConfig$events$2.timeout,
                            ttciEnabled: (_globalConfig$events$3 = globalConfig.events[(0, $c2GEI.BMEventsType).WEB_VITALS]) === null || _globalConfig$events$3 === void 0 ? void 0 : _globalConfig$events$3.ttciEnabled
                        }
                    };
                    return _context.abrupt("return", (_ref3 = {}, (0, (/*@__PURE__*/$parcel$interopDefault($9Z3Ln)))(_ref3, (0, $c2GEI.BMEventsType).PAGE_LOAD, $4191fe7034e39d78$var$makeGlobalConfigPerType(global, ffClient, globalConfig.events.all, globalConfig.events[(0, $c2GEI.BMEventsType).PAGE_LOAD])), (0, (/*@__PURE__*/$parcel$interopDefault($9Z3Ln)))(_ref3, (0, $c2GEI.BMEventsType).PAGE_SEGMENT_LOAD, $4191fe7034e39d78$var$makeGlobalConfigPerType(global, ffClient, globalConfig.events.all, globalConfig.events[(0, $c2GEI.BMEventsType).PAGE_SEGMENT_LOAD])), (0, (/*@__PURE__*/$parcel$interopDefault($9Z3Ln)))(_ref3, (0, $c2GEI.BMEventsType).INLINE_RESULT, $4191fe7034e39d78$var$makeGlobalConfigPerType(global, ffClient, globalConfig.events.all, globalConfig.events[(0, $c2GEI.BMEventsType).INLINE_RESULT])), (0, (/*@__PURE__*/$parcel$interopDefault($9Z3Ln)))(_ref3, (0, $c2GEI.BMEventsType).CUSTOM, $4191fe7034e39d78$var$makeGlobalConfigPerType(global, ffClient, globalConfig.events.all, globalConfig.events[(0, $c2GEI.BMEventsType).CUSTOM])), (0, (/*@__PURE__*/$parcel$interopDefault($9Z3Ln)))(_ref3, (0, $c2GEI.BMEventsType).WEB_VITALS, $4191fe7034e39d78$var$makeGlobalConfigPerType(global, ffClient, globalConfig.events.all, globalConfig.events[(0, $c2GEI.BMEventsType).WEB_VITALS])), _ref3));
                case 5:
                case "end":
                    return _context.stop();
            }
        }, _callee);
    }));
    return function makeShareableGlobalConfig(_x) {
        return _ref2.apply(this, arguments);
    };
}();

});



parcelRegister("k5uxT", function(module, exports) {

$parcel$export(module.exports, "PageLoadMetric", function () { return $e9fbf804de49ac49$export$3c51073271a9eac3; });

var $4BwFW = parcelRequire("4BwFW");

var $9Z3Ln = parcelRequire("9Z3Ln");

var $1W8kW = parcelRequire("1W8kW");

var $ceJcC = parcelRequire("ceJcC");

var $2CEPP = parcelRequire("2CEPP");

var $lVZ3G = parcelRequire("lVZ3G");

var $fV4YG = parcelRequire("fV4YG");

var $7mJzd = parcelRequire("7mJzd");

var $c39NH = parcelRequire("c39NH");

var $gVKiB = parcelRequire("gVKiB");

var $7rgZR = parcelRequire("7rgZR");

var $awgKP = parcelRequire("awgKP");

var $3TgUs = parcelRequire("3TgUs");

var $c2GEI = parcelRequire("c2GEI");

var $2seMB = parcelRequire("2seMB");

var $f9YR6 = parcelRequire("f9YR6");

var $jYamt = parcelRequire("jYamt");
function $e9fbf804de49ac49$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $e9fbf804de49ac49$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $e9fbf804de49ac49$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($9Z3Ln)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $e9fbf804de49ac49$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $e9fbf804de49ac49$var$_createSuper(t) {
    var r = $e9fbf804de49ac49$var$_isNativeReflectConstruct();
    return function() {
        var e, o = (0, (/*@__PURE__*/$parcel$interopDefault($7mJzd)))(t);
        if (r) {
            var s = (0, (/*@__PURE__*/$parcel$interopDefault($7mJzd)))(this).constructor;
            e = Reflect.construct(o, arguments, s);
        } else e = o.apply(this, arguments);
        return (0, (/*@__PURE__*/$parcel$interopDefault($fV4YG)))(this, e);
    };
}
function $e9fbf804de49ac49$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($e9fbf804de49ac49$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $e9fbf804de49ac49$export$3c51073271a9eac3 = /*#__PURE__*/ function(_BasePageLoadMetric) {
    (0, (/*@__PURE__*/$parcel$interopDefault($lVZ3G)))(PageLoadMetric, _BasePageLoadMetric);
    var _super = $e9fbf804de49ac49$var$_createSuper(PageLoadMetric);
    function PageLoadMetric() {
        (0, (/*@__PURE__*/$parcel$interopDefault($1W8kW)))(this, PageLoadMetric);
        return _super.apply(this, arguments);
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($ceJcC)))(PageLoadMetric, [
        {
            key: "startPageLoad",
            value: function startPageLoad() {
                var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
                    isInitial: false
                };
                (0, $f9YR6.pageLoadMetaMetric).startPageLoad($e9fbf804de49ac49$var$_objectSpread($e9fbf804de49ac49$var$_objectSpread({}, params), {}, {
                    cancelStarted: "startTime" in params
                }));
                this.watchUntil();
            }
        },
        {
            key: "stop",
            value: function stop() {
                var _this$config$ssr;
                var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var stopTime = params.stopTime || window.performance.now();
                var pageLoadData = (0, $f9YR6.pageLoadMetaMetric).getDataToMerge();
                var metaMetricStopped = (0, $f9YR6.pageLoadMetaMetric).stop(params);
                if (!metaMetricStopped) return false;
                if (pageLoadData.isInitial && (_this$config$ssr = this.config.ssr) !== null && _this$config$ssr !== void 0 && _this$config$ssr.doneAsFmp) {
                    if (!this.marks[(0, $2seMB.BasePageLoadMetric).FMP]) {
                        var mark = (0, $gVKiB.SSRGetDoneMark).getDoneMark();
                        if (mark) (0, $f9YR6.pageLoadMetaMetric).markFMP(mark);
                    } else (0, $f9YR6.pageLoadMetaMetric).markFMP(this.marks[(0, $2seMB.BasePageLoadMetric).FMP]);
                }
                this.route = (0, $awgKP.Route).getRoute();
                var metricStopped = this.stopPageLoad(pageLoadData, $e9fbf804de49ac49$var$_objectSpread($e9fbf804de49ac49$var$_objectSpread({}, params), {}, {
                    stopTime: stopTime
                }));
                if (!metricStopped) return false;
                var data = this.getData();
                if (!this.config.virtual) (0, $3TgUs.submitter).queue(data);
                (0, $7rgZR.logger).logCond(!!this.config.debug, "page-load", "stop", this.getData);
                this.enqueueWebVitals();
                return true;
            }
        },
        {
            key: "mark",
            value: function mark(_mark) {
                var timestamp = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window.performance.now();
                (0, $f9YR6.pageLoadMetaMetric).mark(_mark, timestamp);
            }
        },
        {
            key: "markFMP",
            value: function markFMP(timestamp) {
                (0, $f9YR6.pageLoadMetaMetric).markFMP(timestamp);
            }
        },
        {
            key: "getData",
            value: function getData() {
                var pageLoadMetaData = (0, $f9YR6.pageLoadMetaMetric).getData();
                return $e9fbf804de49ac49$var$_objectSpread($e9fbf804de49ac49$var$_objectSpread({}, (0, (/*@__PURE__*/$parcel$interopDefault($2CEPP)))((0, (/*@__PURE__*/$parcel$interopDefault($7mJzd)))(PageLoadMetric.prototype), "getData", this).call(this)), {}, {
                    // marks and explicitTimings are available only in pageLoadMeta
                    marks: pageLoadMetaData.marks,
                    explicitTimings: pageLoadMetaData.explicitTimings
                });
            }
        },
        {
            key: "enqueueWebVitals",
            value: function() {
                var _enqueueWebVitals = (0, (/*@__PURE__*/$parcel$interopDefault($4BwFW)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($c39NH))).mark(function _callee() {
                    var _configChunk$BMEvents;
                    var configChunk, webVitalMetric;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($c39NH))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                if (!(this.config.virtual || !this.isInitial)) {
                                    _context.next = 2;
                                    break;
                                }
                                return _context.abrupt("return", false);
                            case 2:
                                _context.next = 4;
                                return (0, $3TgUs.submitter).config.configChunk;
                            case 4:
                                configChunk = _context.sent;
                                if (configChunk !== null && configChunk !== void 0 && (_configChunk$BMEvents = configChunk[(0, $c2GEI.BMEventsType).WEB_VITALS].webVitals) !== null && _configChunk$BMEvents !== void 0 && _configChunk$BMEvents.enabled) {
                                    _context.next = 7;
                                    break;
                                }
                                return _context.abrupt("return", false);
                            case 7:
                                webVitalMetric = new (0, $jYamt.WebVitalsMetric)({
                                    key: this.config.key,
                                    route: this.route,
                                    startTime: this.startTime,
                                    stopTime: this.stopTime,
                                    pageVisibleState: this.pageVisibleState
                                });
                                (0, $3TgUs.submitter).queue(webVitalMetric.getData());
                                (0, $7rgZR.logger).logCond(!!this.config.debug, "web-vitals", webVitalMetric.getData);
                                return _context.abrupt("return", true);
                            case 11:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this);
                }));
                function enqueueWebVitals() {
                    return _enqueueWebVitals.apply(this, arguments);
                }
                return enqueueWebVitals;
            }()
        }
    ]);
    return PageLoadMetric;
}((0, $2seMB.BasePageLoadMetric));

});
parcelRegister("gVKiB", function(module, exports) {

$parcel$export(module.exports, "SSRGetDoneMark", function () { return $c535e241254c8b8e$export$9e87a201397ac0a9; });
var $c535e241254c8b8e$export$9e87a201397ac0a9 = {
    getDoneMark: function() {
        return null;
    },
    setGetDoneMark: function setGetDoneMark(fn) {
        $c535e241254c8b8e$export$9e87a201397ac0a9.getDoneMark = fn;
    }
};

});

parcelRegister("jYamt", function(module, exports) {

$parcel$export(module.exports, "WebVitalsMetric", function () { return $e89ba879c2a5c506$export$dc0d85d4d6503cd7; });

var $ceJcC = parcelRequire("ceJcC");

var $1W8kW = parcelRequire("1W8kW");

var $lVZ3G = parcelRequire("lVZ3G");

var $fV4YG = parcelRequire("fV4YG");

var $7mJzd = parcelRequire("7mJzd");

var $c2GEI = parcelRequire("c2GEI");

var $kB69W = parcelRequire("kB69W");
function $e89ba879c2a5c506$var$_createSuper(t) {
    var r = $e89ba879c2a5c506$var$_isNativeReflectConstruct();
    return function() {
        var e, o = (0, (/*@__PURE__*/$parcel$interopDefault($7mJzd)))(t);
        if (r) {
            var s = (0, (/*@__PURE__*/$parcel$interopDefault($7mJzd)))(this).constructor;
            e = Reflect.construct(o, arguments, s);
        } else e = o.apply(this, arguments);
        return (0, (/*@__PURE__*/$parcel$interopDefault($fV4YG)))(this, e);
    };
}
function $e89ba879c2a5c506$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($e89ba879c2a5c506$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $e89ba879c2a5c506$export$dc0d85d4d6503cd7 = /*#__PURE__*/ function(_BaseMetric) {
    (0, (/*@__PURE__*/$parcel$interopDefault($lVZ3G)))(WebVitalsMetric, _BaseMetric);
    var _super = $e89ba879c2a5c506$var$_createSuper(WebVitalsMetric);
    function WebVitalsMetric(_ref) {
        var _this;
        var key = _ref.key, route = _ref.route, startTime = _ref.startTime, stopTime = _ref.stopTime, pageVisibleState = _ref.pageVisibleState;
        (0, (/*@__PURE__*/$parcel$interopDefault($1W8kW)))(this, WebVitalsMetric);
        _this = _super.call(this, {
            type: (0, $c2GEI.BMEventsType).WEB_VITALS,
            key: key
        });
        _this.route = route;
        _this.startTime = startTime;
        _this.stopTime = stopTime;
        _this.state = (0, $kB69W.MetricState).FINISHED;
        _this.pageVisibleState = pageVisibleState;
        return _this;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($ceJcC)))(WebVitalsMetric);
}((0, $kB69W.BaseMetric));

});


parcelRegister("f7Fa0", function(module, exports) {

$parcel$export(module.exports, "PageSegmentLoadMetric", function () { return $b027700c27346617$export$24c8bfcd77494cc1; });

var $1W8kW = parcelRequire("1W8kW");

var $ceJcC = parcelRequire("ceJcC");

var $gNgok = parcelRequire("gNgok");

var $2CEPP = parcelRequire("2CEPP");

var $lVZ3G = parcelRequire("lVZ3G");

var $fV4YG = parcelRequire("fV4YG");

var $7mJzd = parcelRequire("7mJzd");

var $9Z3Ln = parcelRequire("9Z3Ln");

var $gVKiB = parcelRequire("gVKiB");

var $c2GEI = parcelRequire("c2GEI");

var $kB69W = parcelRequire("kB69W");

var $9vl78 = parcelRequire("9vl78");

var $f9YR6 = parcelRequire("f9YR6");
function $b027700c27346617$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $b027700c27346617$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $b027700c27346617$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($9Z3Ln)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $b027700c27346617$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $b027700c27346617$var$_createSuper(t) {
    var r = $b027700c27346617$var$_isNativeReflectConstruct();
    return function() {
        var e, o = (0, (/*@__PURE__*/$parcel$interopDefault($7mJzd)))(t);
        if (r) {
            var s = (0, (/*@__PURE__*/$parcel$interopDefault($7mJzd)))(this).constructor;
            e = Reflect.construct(o, arguments, s);
        } else e = o.apply(this, arguments);
        return (0, (/*@__PURE__*/$parcel$interopDefault($fV4YG)))(this, e);
    };
}
function $b027700c27346617$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($b027700c27346617$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $b027700c27346617$export$24c8bfcd77494cc1 = /*#__PURE__*/ function(_Metric) {
    (0, (/*@__PURE__*/$parcel$interopDefault($lVZ3G)))(PageSegmentLoadMetric, _Metric);
    var _super = $b027700c27346617$var$_createSuper(PageSegmentLoadMetric);
    function PageSegmentLoadMetric(config) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($1W8kW)))(this, PageSegmentLoadMetric);
        _this = _super.call(this, config);
        (0, (/*@__PURE__*/$parcel$interopDefault($9Z3Ln)))((0, (/*@__PURE__*/$parcel$interopDefault($gNgok)))(_this), "isInitial", true);
        _this.config = config;
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($ceJcC)))(PageSegmentLoadMetric, [
        {
            key: "startFromPageLoad",
            value: function startFromPageLoad() {
                var _pageLoadMetaData$sta;
                var pageLoadMetaData = (0, $f9YR6.pageLoadMetaMetric).getData();
                this.start({
                    startTime: (_pageLoadMetaData$sta = pageLoadMetaData.start) !== null && _pageLoadMetaData$sta !== void 0 ? _pageLoadMetaData$sta : undefined
                });
                this.isInitial = pageLoadMetaData.isInitial;
                this.pageVisibleState = pageLoadMetaData.pageVisibleState;
            }
        },
        {
            key: "mark",
            value: function mark(_mark) {
                var timestamp = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window.performance.now();
                if (_mark === PageSegmentLoadMetric.FMP) return;
                (0, (/*@__PURE__*/$parcel$interopDefault($2CEPP)))((0, (/*@__PURE__*/$parcel$interopDefault($7mJzd)))(PageSegmentLoadMetric.prototype), "mark", this).call(this, _mark, timestamp);
            }
        },
        {
            key: "markFMP",
            value: function markFMP(timestamp) {
                (0, (/*@__PURE__*/$parcel$interopDefault($2CEPP)))((0, (/*@__PURE__*/$parcel$interopDefault($7mJzd)))(PageSegmentLoadMetric.prototype), "mark", this).call(this, PageSegmentLoadMetric.FMP, timestamp);
            }
        },
        {
            key: "getPageSegmentLoadData",
            value: function getPageSegmentLoadData() {
                return {
                    isInitial: this.isInitial
                };
            }
        },
        {
            key: "getData",
            value: function getData() {
                return $b027700c27346617$var$_objectSpread($b027700c27346617$var$_objectSpread({}, (0, (/*@__PURE__*/$parcel$interopDefault($2CEPP)))((0, (/*@__PURE__*/$parcel$interopDefault($7mJzd)))(PageSegmentLoadMetric.prototype), "getData", this).call(this)), this.getPageSegmentLoadData());
            }
        },
        {
            key: "getDataToMerge",
            value: function getDataToMerge() {
                return $b027700c27346617$var$_objectSpread($b027700c27346617$var$_objectSpread({}, (0, (/*@__PURE__*/$parcel$interopDefault($2CEPP)))((0, (/*@__PURE__*/$parcel$interopDefault($7mJzd)))(PageSegmentLoadMetric.prototype), "getDataToMerge", this).call(this)), this.getPageSegmentLoadData());
            }
        },
        {
            key: "merge",
            value: function merge(mergeData) {
                (0, (/*@__PURE__*/$parcel$interopDefault($2CEPP)))((0, (/*@__PURE__*/$parcel$interopDefault($7mJzd)))(PageSegmentLoadMetric.prototype), "merge", this).call(this, mergeData);
                this.isInitial = mergeData.isInitial;
            }
        },
        {
            key: "stop",
            value: function stop() {
                var _this$config$ssr, _this2 = this;
                var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var pageLoadData = (0, $f9YR6.pageLoadMetaMetric).getData();
                if (pageLoadData.isInitial && (_this$config$ssr = this.config.ssr) !== null && _this$config$ssr !== void 0 && _this$config$ssr.doneAsFmp) {
                    if (!this.marks[PageSegmentLoadMetric.FMP]) {
                        var mark = (0, $gVKiB.SSRGetDoneMark).getDoneMark();
                        if (mark) this.markFMP(mark);
                    }
                }
                if (this.config.includePageLoadTimings !== (0, $c2GEI.PageSegmentPageLoadMetricsOptions).WAIT_UNTIL_PRESENT || pageLoadData.state === (0, $kB69W.MetricState).FINISHED) return (0, (/*@__PURE__*/$parcel$interopDefault($2CEPP)))((0, (/*@__PURE__*/$parcel$interopDefault($7mJzd)))(PageSegmentLoadMetric.prototype), "stop", this).call(this, params);
                var now = performance.now();
                if (pageLoadData.state === (0, $kB69W.MetricState).STARTED) (0, $f9YR6.pageLoadMetaMetric).onStop(function() {
                    (0, (/*@__PURE__*/$parcel$interopDefault($2CEPP)))((0, (/*@__PURE__*/$parcel$interopDefault($7mJzd)))(PageSegmentLoadMetric.prototype), "stop", _this2).call(_this2, $b027700c27346617$var$_objectSpread($b027700c27346617$var$_objectSpread({}, params), {}, {
                        stopTime: params.stopTime || now
                    }));
                }, function() {
                    _this2.cancel();
                });
                return true;
            }
        }
    ]);
    return PageSegmentLoadMetric;
}((0, $9vl78.Metric));
(0, (/*@__PURE__*/$parcel$interopDefault($9Z3Ln)))($b027700c27346617$export$24c8bfcd77494cc1, "FMP", "fmp");

});








parcelRegister("hYcP6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6bf47b46f500eb32$export$2e2bcd8739ae039; });

var $bibO8 = parcelRequire("bibO8");
parcelRequire("dAx5m");

var $4oRum = parcelRequire("4oRum");
const $6bf47b46f500eb32$var$AnalyticsProvider = ({ analytics: analytics, children: children })=>{
    const state = {
        analytics: analytics
    };
    return /*#__PURE__*/ (0, $bibO8.jsx)((0, $4oRum.default).Provider, {
        value: state,
        children: children
    });
};
var $6bf47b46f500eb32$export$2e2bcd8739ae039 = $6bf47b46f500eb32$var$AnalyticsProvider;

});

parcelRegister("grRLU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f50bee3921534b27$export$2e2bcd8739ae039; });

var $dAx5m = parcelRequire("dAx5m");

var $4oRum = parcelRequire("4oRum");
const $f50bee3921534b27$var$useAnalytics = ()=>(0, $dAx5m.useContext)((0, $4oRum.default)).analytics;
var $f50bee3921534b27$export$2e2bcd8739ae039 = $f50bee3921534b27$var$useAnalytics;

});

parcelRegister("fjOHq", function(module, exports) {

$parcel$export(module.exports, "AnalyticsEventSource", function () { return $b480da57750db81b$export$2102531865f3e90e; });
$parcel$export(module.exports, "AnalyticsEventActions", function () { return $b480da57750db81b$export$74eee170ad238aae; });
$parcel$export(module.exports, "AnalyticsEventSubjects", function () { return $b480da57750db81b$export$670f80b77450980d; });
const $b480da57750db81b$export$e8d1ded05852e864 = {
    ACTIVITY_ALL_VIEW: "activity.all.view",
    ACTIVITY_WATCHING_VIEW: "activity.watching.view",
    HISTORY_VIEW: "history.view",
    PROFILE_SETTINGS_CLOSE_ACCOUNT_VIEW: "profile-settings.close-account.view",
    PROFILE_SETTINGS_EMAIL_VIEW: "profile-settings.email.view",
    PROFILE_SETTINGS_GENERAL_VIEW: "profile-settings.general.view",
    PROFILE_SETTINGS_PROFILE_AND_VISIBILITY_VIEW: "profile-settings.profile-and-visibility.view",
    PROFILE_SETTINGS_PRIVACY_VIEW: "profile-settings.privacy.view",
    PROFILE_SETTINGS_PRODUCT_VIEW: "profile-settings.product.view",
    PROFILE_SETTINGS_SECURITY_VIEW: "profile-settings.security.view",
    PROFILE_SETTINGS_TWO_STEP_VERIFICATION_VIEW: "profile-settings.security.two-step-verification.view",
    PROFILE_SETTINGS_API_TOKENS_VIEW: "profile-settings.security.api-tokens.view",
    PROFILE_SETTINGS_RECENT_DEVICES_VIEW: "profile-settings.security.recent-devices.view",
    PROFILE_SETTINGS_CONNECTED_APPS_VIEW: "profile-settings.connected-apps.view",
    // TODO: remove these once we move to a new analytics platform
    LEGACY_ACTIVITY_ALL_VIEW: "newsfeed.view"
};
var $b480da57750db81b$export$2102531865f3e90e;
(function(AnalyticsEventSource) {
    AnalyticsEventSource["MANAGE_ACCOUNT_PROFILE_AND_VISIBILITY_TAB"] = "manageAccountProfileAndVisibilityTab";
    AnalyticsEventSource["MANAGE_ACCOUNT_PREFERENCES_TAB"] = "manageAccountPreferencesTab";
    AnalyticsEventSource["MANAGE_ACCOUNT_EMAIL_TAB"] = "manageAccountEmailTab";
    AnalyticsEventSource["MANAGE_ACCOUNT_SECURITY_TAB"] = "manageAccountSecurityTab";
    AnalyticsEventSource["MANAGE_ACCOUNT_RECENT_DEVICES_TAB"] = "manageAccountRecentDevicesTab";
    AnalyticsEventSource["MANAGE_ACCOUNT_API_TOKENS_TAB"] = "manageAccountApiTokensTab";
    AnalyticsEventSource["MANAGE_ACCOUNT_TWO_STEP_VERIFICATION_TAB"] = "manageAccount2svTab";
    AnalyticsEventSource["MANAGE_ACCOUNT_PRIVACY_TAB"] = "manageAccountPrivacyTab";
    AnalyticsEventSource["MANAGE_ACCOUNT_PRODUCTS_TAB"] = "manageAccountProductsTab";
    AnalyticsEventSource["MANAGE_ACCOUNT_CONNECTED_APPS_TAB"] = "manageAccountConnectedAppsTab";
    AnalyticsEventSource["MANAGE_ACCOUNT_LINK_PREFERENCES_TAB"] = "manageAccountSmartLinkPreferencesScreen";
    AnalyticsEventSource["MANAGE_ACCOUNT_CLOSE_ACCOUNT_TAB"] = "manageAccountCloseAccountTab";
    AnalyticsEventSource["MANAGE_ACCOUNT_CHANGE_EMAIL_MODAL"] = "manageAccountChangeEmailModal";
    AnalyticsEventSource["MANAGE_ACCOUNT_CUSTOM_INITIAL_MODAL"] = "avatarInitialsPicker";
    AnalyticsEventSource["MANAGE_ACCOUNT_REGENERATE_RECOVERY_KEY_SCREEN"] = "2svCreateNewRecoveryKeyScreen";
    AnalyticsEventSource["MANAGE_ACCOUNT_SAVE_RECOVERY_KEY_SCREEN"] = "2svSaveRecoveryKeyScreen";
    AnalyticsEventSource["MANAGE_ACCOUNT_TWO_STEP_VERIFICATION_SECURITY_KEYS"] = "2svSecurityKeys";
    // inside avatar menu
    AnalyticsEventSource["USER_MENU"] = "userMenu";
    // close account flow
    AnalyticsEventSource["DELETE_ACCOUNT_FOCUSED_TASK"] = "deleteAccountFocusedTask";
    AnalyticsEventSource["DELETE_ACCOUNT_WARNING_MODAL"] = "deleteAccountWarningModal";
    // generic metrics
    AnalyticsEventSource["CLIENT_METRICS"] = "clientMetrics";
    // generic metrics
    AnalyticsEventSource["DIRECTORY_APP"] = "directoryApp";
    // events sent from Atlassian switcher
    AnalyticsEventSource["SWITCHER"] = "switcher";
    // events from switching theme
    AnalyticsEventSource["THEME_SWITCHER"] = "themeSwitcher";
})($b480da57750db81b$export$2102531865f3e90e || ($b480da57750db81b$export$2102531865f3e90e = {}));
var $b480da57750db81b$export$74eee170ad238aae;
(function(AnalyticsEventActions) {
    AnalyticsEventActions["ACCEPTED"] = "accepted";
    AnalyticsEventActions["CLICKED"] = "clicked";
    AnalyticsEventActions["CLOSED"] = "closed";
    AnalyticsEventActions["CREATED"] = "created";
    AnalyticsEventActions["DECLINED"] = "declined";
    AnalyticsEventActions["DELETED"] = "deleted";
    AnalyticsEventActions["DRAGGED"] = "dragged";
    AnalyticsEventActions["EDITED"] = "edited";
    AnalyticsEventActions["EXPOSED"] = "exposed";
    AnalyticsEventActions["FAILED"] = "failed";
    AnalyticsEventActions["JOINED"] = "joined";
    AnalyticsEventActions["LIMITED"] = "limited";
    AnalyticsEventActions["MOUNTED"] = "mounted";
    AnalyticsEventActions["MOVED"] = "moved";
    AnalyticsEventActions["OPENED"] = "opened";
    AnalyticsEventActions["REDIRECTED"] = "redirected";
    AnalyticsEventActions["REMOVED"] = "removed";
    AnalyticsEventActions["SENT"] = "sent";
    AnalyticsEventActions["SHOWN"] = "shown";
    AnalyticsEventActions["SORTED"] = "sorted";
    AnalyticsEventActions["STARTED"] = "started";
    AnalyticsEventActions["SUBMITTED"] = "submitted";
    AnalyticsEventActions["SUCCEEDED"] = "succeeded";
    AnalyticsEventActions["TRIGGERED"] = "triggered";
    AnalyticsEventActions["TYPED"] = "typed";
    AnalyticsEventActions["UPDATED"] = "updated";
    AnalyticsEventActions["VIEWED"] = "viewed";
    AnalyticsEventActions["LOADED"] = "loaded";
    AnalyticsEventActions["CHANGED_THEME"] = "changedTheme";
    AnalyticsEventActions["REDIRECT_TRIGGERED"] = "redirectTriggered";
})($b480da57750db81b$export$74eee170ad238aae || ($b480da57750db81b$export$74eee170ad238aae = {}));
var $b480da57750db81b$export$670f80b77450980d;
(function(AnalyticsEventSubjects) {
    AnalyticsEventSubjects["AVATAR_PICKER"] = "avatarPicker";
    AnalyticsEventSubjects["BUTTON"] = "button";
    AnalyticsEventSubjects["ERROR"] = "error";
    AnalyticsEventSubjects["FORM"] = "form";
    AnalyticsEventSubjects["LINK"] = "link";
    AnalyticsEventSubjects["MENU"] = "menu";
    AnalyticsEventSubjects["MODAL_DIALOG"] = "modalDialog";
    AnalyticsEventSubjects["SCOPED_TOKEN_CREATION"] = "scopedTokenCreation";
    AnalyticsEventSubjects["NOTIFICATION"] = "notification";
    AnalyticsEventSubjects["SMART_LINK_DEFAULT_ALL"] = "smartLinkDefaultAll";
    AnalyticsEventSubjects["SMART_LINK_DEFAULT_EXCEPTION"] = "smartLinkDefaultException";
    AnalyticsEventSubjects["THEME_STATE"] = "themeState";
    AnalyticsEventSubjects["NEW_API_TOKEN"] = "NewApiToken";
    AnalyticsEventSubjects["STEP_UP_VERIFIER"] = "stepUpVerifier";
})($b480da57750db81b$export$670f80b77450980d || ($b480da57750db81b$export$670f80b77450980d = {}));

});

parcelRegister("fwDtJ", function(module, exports) {
// @ts-ignore

});


parcelRegister("gA9bO", function(module, exports) {

$parcel$export(module.exports, "DialogProvider", function () { return (parcelRequire("9lQ50")).default; });
$parcel$export(module.exports, "withDialogTransition", function () { return (parcelRequire("btS3G")).default; });

var $ado8n = parcelRequire("ado8n");

var $9lQ50 = parcelRequire("9lQ50");
parcelRequire("koykG");

var $btS3G = parcelRequire("btS3G");

});
parcelRegister("ado8n", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fa21191cfd3be17b$export$2e2bcd8739ae039; });

var $dAx5m = parcelRequire("dAx5m");
const $fa21191cfd3be17b$var$defaultState = {
    openDialogKey: null,
    openDialog: ()=>null,
    closeDialog: ()=>null,
    options: {}
};
var $fa21191cfd3be17b$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createContext($fa21191cfd3be17b$var$defaultState);

});

parcelRegister("9lQ50", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ec6eda173622af00$export$2e2bcd8739ae039; });

var $bibO8 = parcelRequire("bibO8");

var $dAx5m = parcelRequire("dAx5m");

var $ado8n = parcelRequire("ado8n");
const $ec6eda173622af00$var$DialogProvider = ({ children: children })=>{
    const [openDialogKey, setOpenDialogKey] = (0, $dAx5m.useState)(null);
    const [options, setOptions] = (0, $dAx5m.useState)(null);
    const closeDialog = ()=>{
        setOpenDialogKey(null);
    };
    const openDialog = (openDialogKey, options)=>{
        setOpenDialogKey(openDialogKey);
        setOptions(options || null);
    };
    return /*#__PURE__*/ (0, $bibO8.jsx)((0, $ado8n.default).Provider, {
        value: {
            openDialogKey: openDialogKey,
            openDialog: openDialog,
            closeDialog: closeDialog,
            options: options
        },
        children: children
    });
};
var $ec6eda173622af00$export$2e2bcd8739ae039 = $ec6eda173622af00$var$DialogProvider;

});

parcelRegister("koykG", function(module, exports) {

});

parcelRegister("btS3G", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $275aa833885d8251$export$2e2bcd8739ae039; });
// This file will add transition to normal dialogs based on their `isOpen` prop
// It's a temporary solution before we made all dialogs to use the same pattern.
// After this ticket is done - https://product-fabric.atlassian.net/browse/PTC-1866
// there will be once place that has ModalTransition - the HOC for dialog
// ^ NO LONGER TRUE (But still valid thing)
// Once used embeddable-directory inside Confluence dialogs aren't closing if we keep them wrapped in transition components
// Bring back dialog transitions: https://product-fabric.atlassian.net/browse/PTC-2321

var $bibO8 = parcelRequire("bibO8");
parcelRequire("dAx5m");
const $275aa833885d8251$var$withDialogTransition = (WrappedComponent)=>{
    const name = WrappedComponent.displayName || WrappedComponent.name || "Component";
    const ModalDialogWithTransition = (props)=>{
        const { isOpen: isOpen } = props;
        return /*#__PURE__*/ (0, $bibO8.jsx)((0, $bibO8.Fragment), {
            children: isOpen && /*#__PURE__*/ (0, $bibO8.jsx)(WrappedComponent, {
                ...props
            })
        });
    };
    ModalDialogWithTransition.displayName = `withDialogTransition(${name})`;
    return ModalDialogWithTransition;
};
var $275aa833885d8251$export$2e2bcd8739ae039 = $275aa833885d8251$var$withDialogTransition;

});


parcelRegister("eMPgC", function(module, exports) {

$parcel$export(module.exports, "DialogsProvider", function () { return (parcelRequire("9Rq8g")).default; });

var $gkiri = parcelRequire("gkiri");

var $9Rq8g = parcelRequire("9Rq8g");
parcelRequire("cfWL4");

});
parcelRegister("gkiri", function(module, exports) {

$parcel$export(module.exports, "DialogsContext", function () { return $8bb782bb26894b1f$export$412f7f691e39b0da; });

var $dAx5m = parcelRequire("dAx5m");
const $8bb782bb26894b1f$var$dialogsContextState = {
    openDialog: ()=>null,
    closeDialog: ()=>null
};
const $8bb782bb26894b1f$export$412f7f691e39b0da = (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createContext($8bb782bb26894b1f$var$dialogsContextState);

});

parcelRegister("9Rq8g", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $64a8c78e5f02d7a0$export$2e2bcd8739ae039; });

var $bibO8 = parcelRequire("bibO8");

var $dAx5m = parcelRequire("dAx5m");

var $gkiri = parcelRequire("gkiri");

var $1UVUi = parcelRequire("1UVUi");
const $64a8c78e5f02d7a0$var$initialStates = {
    DialogComponent: null,
    dialogProps: null,
    isOpen: false
};
function $64a8c78e5f02d7a0$var$dialogReducer(state, action) {
    switch(action.type){
        case "open":
            return {
                ...state,
                DialogComponent: action.payload?.DialogComponent || null,
                dialogProps: action.payload?.dialogProps || null,
                isOpen: true
            };
        case "close":
            return {
                ...state,
                DialogComponent: null,
                dialogProps: null,
                isOpen: false
            };
        default:
            throw new Error();
    }
}
function $64a8c78e5f02d7a0$export$2e2bcd8739ae039(props) {
    const { children: children } = props;
    const [stateDialogProvider, dispatch] = (0, $dAx5m.useReducer)($64a8c78e5f02d7a0$var$dialogReducer, $64a8c78e5f02d7a0$var$initialStates);
    const valueProvider = (0, $dAx5m.useMemo)(()=>({
            openDialog: (DialogComponent, dialogProps = null)=>dispatch({
                    type: "open",
                    payload: {
                        DialogComponent: DialogComponent,
                        dialogProps: dialogProps
                    }
                }),
            closeDialog: ()=>dispatch({
                    type: "close"
                })
        }), []);
    return /*#__PURE__*/ (0, $bibO8.jsxs)((0, $gkiri.DialogsContext).Provider, {
        value: valueProvider,
        children: [
            children,
            /*#__PURE__*/ (0, $bibO8.jsx)((0, $1UVUi.default), {
                ...stateDialogProvider
            })
        ]
    });
}

});
parcelRegister("1UVUi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f817a83a0ae7a901$export$2e2bcd8739ae039; });

var $bibO8 = parcelRequire("bibO8");
parcelRequire("dAx5m");

var $kJBrw = parcelRequire("kJBrw");

var $5fi8x = parcelRequire("5fi8x");
function $f817a83a0ae7a901$export$2e2bcd8739ae039(props) {
    const { DialogComponent: DialogComponent, isOpen: isOpen, onClose: onClose, dialogProps: dialogProps } = props;
    const { closeDialog: closeDialog } = (0, $5fi8x.default)();
    if (!DialogComponent) return null;
    const handleCloseDialog = ()=>{
        closeDialog();
        if (onClose) onClose();
    };
    return /*#__PURE__*/ (0, $bibO8.jsx)((0, $kJBrw.default), {
        children: isOpen && /*#__PURE__*/ (0, $bibO8.jsx)(DialogComponent, {
            ...dialogProps,
            onClose: handleCloseDialog
        })
    });
}

});
parcelRegister("kJBrw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f1850dfa5f7e6759$export$2e2bcd8739ae039; });

var $dAx5m = parcelRequire("dAx5m");

var $fwCJE = parcelRequire("fwCJE");
/**
 * __Modal transition__
 *
 * A modal transition wraps a modal to provide a fluid transition upon opening and closing.
 *
 * - [Examples](https://atlassian.design/components/modal-dialog/examples)
 * - [Code](https://atlassian.design/components/modal-dialog/code)
 * - [Usage](https://atlassian.design/components/modal-dialog/usage)
 */ var $f1850dfa5f7e6759$var$ModalTransition = function ModalTransition(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $fwCJE.default), {
        appear: true
    }, props.children);
};
var $f1850dfa5f7e6759$export$2e2bcd8739ae039 = $f1850dfa5f7e6759$var$ModalTransition;

});
parcelRegister("fwCJE", function(module, exports) {

$parcel$export(module.exports, "useExitingPersistence", function () { return $b4d7e42cbed017ae$export$3b6f38abbdcbd000; });
$parcel$export(module.exports, "default", function () { return $b4d7e42cbed017ae$export$2e2bcd8739ae039; });

var $ctLsC = parcelRequire("ctLsC");

var $dAx5m = parcelRequire("dAx5m");

var $iqJ5D = parcelRequire("iqJ5D");
/**
 * Internally we will be playing with an element that will always have a key defined.
 */ /**
 * Internal data passed to child motions.
 */ // We define empty context here so the object doesn't change.
var $b4d7e42cbed017ae$var$emptyContext = {
    // Motions will always appear if not inside a exiting persistence component.
    appear: true,
    isExiting: false
};
/**
 * __Exiting context__
 *
 * An exiting context.
 */ var $b4d7e42cbed017ae$var$ExitingContext = /*#__PURE__*/ (0, $dAx5m.createContext)($b4d7e42cbed017ae$var$emptyContext);
/**
 * This method will wrap any React element with a context provider. We're using context (instead of
 * cloneElement) so we can communicate between multiple elements without the need of prop drilling
 * (results in a better API for consumers).
 */ var $b4d7e42cbed017ae$var$wrapChildWithContextProvider = function wrapChildWithContextProvider(child) {
    var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $b4d7e42cbed017ae$var$emptyContext;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement($b4d7e42cbed017ae$var$ExitingContext.Provider, {
        key: "".concat(child.key, "-provider"),
        value: value
    }, child);
};
/**
 * This function will convert all children types to an array while also filtering out non-valid React elements.
 */ var $b4d7e42cbed017ae$var$childrenToArray = function childrenToArray(children) {
    var childrenAsArray = [];
    // We convert children to an array using this helper method as it will add keys to children that do not
    // have them, such as when we have hardcoded children that are conditionally rendered.
    (0, $dAx5m.Children).toArray(children).forEach(function(child) {
        // We ignore any boolean children to make our code a little more simple later on,
        // and also filter out any falsies (empty strings, nulls, and undefined).
        if (typeof child !== "boolean" && Boolean(child)) // Children WILL have a key after being forced into an array using the React.Children helper.
        childrenAsArray.push(child);
    });
    return childrenAsArray;
};
var $b4d7e42cbed017ae$var$spliceNewElementsIntoPrevious = function spliceNewElementsIntoPrevious(current, previous) {
    var splicedChildren = previous.concat([]);
    var previousMap = $b4d7e42cbed017ae$var$childrenToObj(previous);
    for(var i = 0; i < current.length; i++){
        var child = current[i];
        var childIsNew = !previousMap[child.key];
        if (childIsNew) // This will insert the new element after the previous element.
        splicedChildren.splice(i + 1, 0, child);
    }
    return splicedChildren;
};
var $b4d7e42cbed017ae$var$childrenToObj = function childrenToObj(children) {
    return children.reduce(function(acc, child) {
        acc[child.key] = child;
        return acc;
    }, {});
};
var $b4d7e42cbed017ae$var$getMissingKeys = function getMissingKeys(current, previous) {
    var currentMapKeys = new Set(current.map(function(child) {
        return child.key;
    }));
    var missing = new Set();
    for(var i = 0; i < previous.length; i++){
        var element = previous[i];
        var _key = element.key;
        if (!currentMapKeys.has(_key)) missing.add(_key);
    }
    return missing;
};
/**
 * __ExitingPersistence__
 *
 * Useful for enabling elements to persist and animate away when they are removed from the DOM.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motions)
 */ var $b4d7e42cbed017ae$var$ExitingPersistence = /*#__PURE__*/ (0, $dAx5m.memo)(function(_ref) {
    var _ref$appear = _ref.appear, appear = _ref$appear === void 0 ? false : _ref$appear, children = _ref.children, exitThenEnter = _ref.exitThenEnter;
    var _useState = (0, $dAx5m.useState)([
        null,
        children
    ]), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($ctLsC)))(_useState, 2), stateChildren = _useState2[0], setChildren = _useState2[1];
    var _useState3 = (0, $dAx5m.useState)([]), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($ctLsC)))(_useState3, 2), exitingChildren = _useState4[0], setExitingChildren = _useState4[1];
    var _useState5 = (0, $dAx5m.useState)(function() {
        return {
            appear: appear,
            isExiting: false
        };
    }), _useState6 = (0, (/*@__PURE__*/$parcel$interopDefault($ctLsC)))(_useState5, 2), defaultContext = _useState6[0], setDefaultContext = _useState6[1];
    (0, $dAx5m.useEffect)(function() {
        if (!defaultContext.appear) setDefaultContext({
            appear: true,
            isExiting: false
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    if ((0, $iqJ5D.isReducedMotion)()) return children;
    /**
   * NOTE: This is a workaround for the test case written in Jira where the stateChildren is a boolean value because
   * useState is mocked to return a boolean value.
   */ if (typeof stateChildren === "boolean") return children;
    var _stateChildren = (0, (/*@__PURE__*/$parcel$interopDefault($ctLsC)))(stateChildren, 2), previousChildren = _stateChildren[0], currentChildren = _stateChildren[1];
    var previous = $b4d7e42cbed017ae$var$childrenToArray(previousChildren);
    var current = $b4d7e42cbed017ae$var$childrenToArray(currentChildren);
    if (currentChildren !== children) setChildren([
        currentChildren,
        children
    ]);
    var missingKeys = $b4d7e42cbed017ae$var$getMissingKeys(current, previous);
    var isSomeChildRemoved = !!missingKeys.size;
    var visibleChildren = current;
    if (isSomeChildRemoved) visibleChildren = $b4d7e42cbed017ae$var$spliceNewElementsIntoPrevious(current, previous);
    if (exitThenEnter) {
        if (exitingChildren.length) visibleChildren = exitingChildren;
        else {
            var nextExitingChildren = visibleChildren.filter(function(child) {
                return missingKeys.has(child.key);
            });
            if (nextExitingChildren.length) setExitingChildren(nextExitingChildren);
        }
    }
    if (missingKeys.size) visibleChildren = visibleChildren.map(function(child) {
        var isExiting = missingKeys.has(child.key);
        return $b4d7e42cbed017ae$var$wrapChildWithContextProvider(child, {
            appear: true,
            isExiting: isExiting,
            onFinish: isExiting ? function() {
                missingKeys.delete(child.key);
                if (missingKeys.size === 0) {
                    setChildren([
                        null,
                        children
                    ]);
                    setExitingChildren([]);
                }
            } : undefined
        });
    });
    else visibleChildren = visibleChildren.map(function(child) {
        return $b4d7e42cbed017ae$var$wrapChildWithContextProvider(child, defaultContext);
    });
    return visibleChildren;
});
var $b4d7e42cbed017ae$export$3b6f38abbdcbd000 = function useExitingPersistence() {
    return (0, $dAx5m.useContext)($b4d7e42cbed017ae$var$ExitingContext);
};
$b4d7e42cbed017ae$var$ExitingPersistence.displayName = "ExitingPersistence";
var $b4d7e42cbed017ae$export$2e2bcd8739ae039 = $b4d7e42cbed017ae$var$ExitingPersistence;

});
parcelRegister("ctLsC", function(module, exports) {

var $hs11e = parcelRequire("hs11e");

var $9RfGH = parcelRequire("9RfGH");

var $54MKV = parcelRequire("54MKV");

var $5ufyZ = parcelRequire("5ufyZ");
function $915d0222a9189f20$var$_slicedToArray(r, e) {
    return $hs11e(r) || $9RfGH(r, e) || $54MKV(r, e) || $5ufyZ();
}
module.exports = $915d0222a9189f20$var$_slicedToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("hs11e", function(module, exports) {
function $cb45d786fcc527e8$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
module.exports = $cb45d786fcc527e8$var$_arrayWithHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("9RfGH", function(module, exports) {
function $72d53b89658d60aa$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
module.exports = $72d53b89658d60aa$var$_iterableToArrayLimit, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("54MKV", function(module, exports) {

var $3nozA = parcelRequire("3nozA");
function $3b23255e6ed01078$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $3nozA(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $3nozA(r, a) : void 0;
    }
}
module.exports = $3b23255e6ed01078$var$_unsupportedIterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("3nozA", function(module, exports) {
function $275694c05a28d1e9$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
module.exports = $275694c05a28d1e9$var$_arrayLikeToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("5ufyZ", function(module, exports) {
function $3febd3a30869bbb1$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
module.exports = $3febd3a30869bbb1$var$_nonIterableRest, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("iqJ5D", function(module, exports) {

$parcel$export(module.exports, "isReducedMotion", function () { return $d6ada19bbed51fc1$export$b7baf7667a68d87c; });
$parcel$export(module.exports, "reduceMotionAsPerUserPreference", function () { return $d6ada19bbed51fc1$export$f0f789643ba5a83c; });

var $ctLsC = parcelRequire("ctLsC");

var $dAx5m = parcelRequire("dAx5m");

var $dd4sf = parcelRequire("dd4sf");
var $d6ada19bbed51fc1$var$isMatchMediaAvailable = function isMatchMediaAvailable() {
    return typeof window !== "undefined" && "matchMedia" in window;
};
var $d6ada19bbed51fc1$export$b7baf7667a68d87c = function isReducedMotion() {
    if (!$d6ada19bbed51fc1$var$isMatchMediaAvailable()) return false;
    var _window$matchMedia = window.matchMedia("(prefers-reduced-motion: reduce)"), matches = _window$matchMedia.matches;
    return matches;
};
var $d6ada19bbed51fc1$export$c537e63161742ce3 = function useIsReducedMotion() {
    var _useState = (0, $dAx5m.useState)($d6ada19bbed51fc1$export$b7baf7667a68d87c), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($ctLsC)))(_useState, 2), prefersReducedMotion = _useState2[0], setPrefersReducedMotion = _useState2[1];
    (0, $dAx5m.useEffect)(function() {
        if (!$d6ada19bbed51fc1$var$isMatchMediaAvailable()) return;
        var mediaQueryList = window.matchMedia("(prefers-reduced-motion: reduce)");
        var onChange = function onChange(event) {
            return setPrefersReducedMotion(event.matches);
        };
        return (0, $dd4sf.bind)(mediaQueryList, {
            type: "change",
            listener: onChange
        });
    }, []);
    return prefersReducedMotion;
};
var $d6ada19bbed51fc1$export$f0f789643ba5a83c = {
    "@media (prefers-reduced-motion: reduce)": {
        animation: "none",
        transition: "none"
    }
};
var $d6ada19bbed51fc1$export$ff7706047246b98b = function prefersReducedMotion() {
    return $d6ada19bbed51fc1$export$f0f789643ba5a83c;
};

});



parcelRegister("5fi8x", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $85565975d37f5e94$export$2e2bcd8739ae039; });

var $gkiri = parcelRequire("gkiri");

var $dAx5m = parcelRequire("dAx5m");
const $85565975d37f5e94$var$useDialogs = ()=>(0, $dAx5m.useContext)((0, $gkiri.DialogsContext));
var $85565975d37f5e94$export$2e2bcd8739ae039 = $85565975d37f5e94$var$useDialogs;

});



parcelRegister("cfWL4", function(module, exports) {

});


parcelRegister("6VUb9", function(module, exports) {

$parcel$export(module.exports, "DismissibleSectionMessage", function () { return (parcelRequire("gzP7h")).DismissibleSectionMessage; });

var $gzP7h = parcelRequire("gzP7h");

});
parcelRegister("gzP7h", function(module, exports) {

$parcel$export(module.exports, "DismissibleSectionMessage", function () { return $cbf8ffc06035f9bf$export$4b0dee9a00173e22; });

var $bibO8 = parcelRequire("bibO8");

var $dAx5m = parcelRequire("dAx5m");

var $fhHY5 = parcelRequire("fhHY5");

var $lNmBx = parcelRequire("lNmBx");

var $02zM4 = parcelRequire("02zM4");
var $2Ofzn = parcelRequire("2Ofzn");

var $bhj8u = parcelRequire("bhj8u");
const $cbf8ffc06035f9bf$export$4b0dee9a00173e22 = ({ message: message, icon: icon, actions: actions, testId: testId, onDismiss: onDismiss })=>{
    const [isVisible, setIsVisible] = (0, $dAx5m.useState)(true);
    const hide = ()=>{
        setIsVisible(false);
        if (onDismiss) onDismiss();
    };
    return /*#__PURE__*/ (0, $bibO8.jsx)((0, $02zM4.default), {
        appear: true,
        children: isVisible && /*#__PURE__*/ (0, $bibO8.jsx)((0, $2Ofzn.default), {
            entranceDirection: "left",
            children: (props)=>/*#__PURE__*/ (0, $bibO8.jsxs)((0, $bhj8u.SectionMessageContainer), {
                    "data-testid": testId,
                    ...props,
                    children: [
                        icon && /*#__PURE__*/ (0, $bibO8.jsx)((0, $bhj8u.IconWrapper), {
                            children: icon
                        }),
                        /*#__PURE__*/ (0, $bibO8.jsxs)((0, $bhj8u.MessageWrapper), {
                            hasIcon: !!icon,
                            children: [
                                message,
                                actions && actions.length ? /*#__PURE__*/ (0, $bibO8.jsx)((0, $bhj8u.ActionsWrapper), {
                                    children: actions.map((action, i)=>/*#__PURE__*/ (0, $bibO8.jsx)((0, $bhj8u.Action), {
                                            children: action
                                        }, i))
                                }) : null
                            ]
                        }),
                        /*#__PURE__*/ (0, $bibO8.jsx)((0, $bhj8u.CloseButtonWrapper), {
                            children: /*#__PURE__*/ (0, $bibO8.jsx)((0, $fhHY5.default), {
                                shouldFitContainer: true,
                                appearance: "subtle",
                                spacing: "compact",
                                iconAfter: /*#__PURE__*/ (0, $bibO8.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($lNmBx))), {
                                    label: "dismiss",
                                    size: "small"
                                }),
                                type: "button",
                                onClick: hide
                            })
                        })
                    ]
                })
        })
    });
};

});
parcelRegister("fhHY5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b20a8cb853a4c505$export$2e2bcd8739ae039; });

var $jIMDT = parcelRequire("jIMDT");

var $91np6 = parcelRequire("91np6");

var $aZB6k = parcelRequire("aZB6k");

var $dAx5m = parcelRequire("dAx5m");

var $Bb0he = parcelRequire("Bb0he");

var $iGzks = parcelRequire("iGzks");

var $92Uwu = parcelRequire("92Uwu");

var $gje9J = parcelRequire("gje9J");

var $3qE8l = parcelRequire("3qE8l");
var $b20a8cb853a4c505$var$_excluded = [
    "appearance",
    "children",
    "iconBefore",
    "iconAfter",
    "isSelected",
    "onMouseDown",
    "onMouseUp",
    "shouldFitContainer",
    "spacing"
];
var $b20a8cb853a4c505$var$isFirefox = typeof navigator !== "undefined" && navigator.userAgent.toLowerCase().indexOf("firefox") > -1;
/**
 * __Button__
 *
 * A button triggers an event or action. They let users know what will happen next.
 *
 * - [Examples](https://atlassian.design/components/button/examples)
 * - [Code](https://atlassian.design/components/button/code)
 * - [Usage](https://atlassian.design/components/button/usage)
 */ var $b20a8cb853a4c505$var$Button = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).forwardRef(function Button(_ref, ref) {
    var _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "default" : _ref$appearance, children = _ref.children, iconBefore = _ref.iconBefore, iconAfter = _ref.iconAfter, _ref$isSelected = _ref.isSelected, isSelected = _ref$isSelected === void 0 ? false : _ref$isSelected, _ref$onMouseDown = _ref.onMouseDown, providedOnMouseDown = _ref$onMouseDown === void 0 ? (0, $Bb0he.default) : _ref$onMouseDown, _ref$onMouseUp = _ref.onMouseUp, providedOnMouseUp = _ref$onMouseUp === void 0 ? (0, $Bb0he.default) : _ref$onMouseUp, _ref$shouldFitContain = _ref.shouldFitContainer, shouldFitContainer = _ref$shouldFitContain === void 0 ? false : _ref$shouldFitContain, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? "default" : _ref$spacing, rest = (0, (/*@__PURE__*/$parcel$interopDefault($aZB6k)))(_ref, $b20a8cb853a4c505$var$_excluded);
    var _useGlobalTheme = (0, $iGzks.useGlobalTheme)(), mode = _useGlobalTheme.mode;
    var isOnlySingleIcon = (0, $3qE8l.default)({
        children: children,
        iconBefore: iconBefore,
        iconAfter: iconAfter
    });
    var _useState = (0, $dAx5m.useState)(false), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($91np6)))(_useState, 2), isActive = _useState2[0], setIsActive = _useState2[1];
    // Wrap onMouseDown / onMouseUp to manually trigger active state
    //  in Firefox
    var onMouseDown = (0, $dAx5m.useCallback)(function(event) {
        providedOnMouseDown(event);
        if ($b20a8cb853a4c505$var$isFirefox) setIsActive(true);
    }, [
        providedOnMouseDown,
        setIsActive
    ]);
    var onMouseUp = (0, $dAx5m.useCallback)(function(event) {
        providedOnMouseUp(event);
        if ($b20a8cb853a4c505$var$isFirefox) setIsActive(false);
    }, [
        providedOnMouseUp,
        setIsActive
    ]);
    var buttonCss = (0, $dAx5m.useMemo)(function() {
        return (0, $gje9J.getCss)({
            appearance: appearance,
            spacing: spacing,
            mode: mode,
            isSelected: isSelected,
            shouldFitContainer: shouldFitContainer,
            isOnlySingleIcon: isOnlySingleIcon
        });
    }, [
        appearance,
        spacing,
        mode,
        isSelected,
        shouldFitContainer,
        isOnlySingleIcon
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $92Uwu.default), (0, (/*@__PURE__*/$parcel$interopDefault($jIMDT)))({}, rest, {
        ref: ref,
        appearance: appearance,
        buttonCss: buttonCss,
        children: children,
        "data-firefox-is-active": isActive ? true : undefined,
        iconAfter: iconAfter,
        iconBefore: iconBefore,
        isSelected: isSelected,
        onMouseDown: onMouseDown,
        onMouseUp: onMouseUp,
        spacing: spacing
    }));
}));
// Tools including enzyme rely on components having a display name
$b20a8cb853a4c505$var$Button.displayName = "Button";
var $b20a8cb853a4c505$export$2e2bcd8739ae039 = $b20a8cb853a4c505$var$Button;

});
parcelRegister("jIMDT", function(module, exports) {
function $e5b7dbbea81b3abc$var$_extends() {
    return module.exports = $e5b7dbbea81b3abc$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $e5b7dbbea81b3abc$var$_extends.apply(null, arguments);
}
module.exports = $e5b7dbbea81b3abc$var$_extends, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("91np6", function(module, exports) {

var $hMeFF = parcelRequire("hMeFF");

var $iy3iQ = parcelRequire("iy3iQ");

var $gcqBP = parcelRequire("gcqBP");

var $2jsSc = parcelRequire("2jsSc");
function $01b1e8b81936de97$var$_slicedToArray(r, e) {
    return $hMeFF(r) || $iy3iQ(r, e) || $gcqBP(r, e) || $2jsSc();
}
module.exports = $01b1e8b81936de97$var$_slicedToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("hMeFF", function(module, exports) {
function $cf124cb6e548bf1a$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
module.exports = $cf124cb6e548bf1a$var$_arrayWithHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("iy3iQ", function(module, exports) {
function $d80df6de5e88297a$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
module.exports = $d80df6de5e88297a$var$_iterableToArrayLimit, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("gcqBP", function(module, exports) {

var $5QEqJ = parcelRequire("5QEqJ");
function $bcb26854e2678e09$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $5QEqJ(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $5QEqJ(r, a) : void 0;
    }
}
module.exports = $bcb26854e2678e09$var$_unsupportedIterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("5QEqJ", function(module, exports) {
function $44212ba607c70b74$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
module.exports = $44212ba607c70b74$var$_arrayLikeToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("2jsSc", function(module, exports) {
function $1af3c0bf1661a1c8$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
module.exports = $1af3c0bf1661a1c8$var$_nonIterableRest, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("aZB6k", function(module, exports) {

var $lX31J = parcelRequire("lX31J");
function $800c615f6276cfb6$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $lX31J(e, t);
    if (Object.getOwnPropertySymbols) {
        var s = Object.getOwnPropertySymbols(e);
        for(r = 0; r < s.length; r++)o = s[r], t.includes(o) || ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
module.exports = $800c615f6276cfb6$var$_objectWithoutProperties, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("lX31J", function(module, exports) {
function $ffb174c3e0850843$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.includes(n)) continue;
        t[n] = r[n];
    }
    return t;
}
module.exports = $ffb174c3e0850843$var$_objectWithoutPropertiesLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("Bb0he", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $06fbfde011a3d53b$export$2e2bcd8739ae039; });
/**
 * An empty function which does nothing.
 */ // eslint-disable-next-line @repo/internal/react/use-noop
function $06fbfde011a3d53b$export$2e2bcd8739ae039() {}

});

parcelRegister("iGzks", function(module, exports) {

$parcel$export(module.exports, "useGlobalTheme", function () { return $d9a78ddb70570cdd$export$7692396083754928; });
$parcel$export(module.exports, "default", function () { return $d9a78ddb70570cdd$export$2e2bcd8739ae039; });

var $cAxNV = parcelRequire("cAxNV");
// Create default global light theme
var $d9a78ddb70570cdd$var$_createTheme = (0, $cAxNV.createTheme)(function() {
    return {
        mode: "light"
    };
}), $d9a78ddb70570cdd$var$Provider = $d9a78ddb70570cdd$var$_createTheme.Provider, $d9a78ddb70570cdd$var$Consumer = $d9a78ddb70570cdd$var$_createTheme.Consumer, $d9a78ddb70570cdd$export$7692396083754928 = $d9a78ddb70570cdd$var$_createTheme.useTheme;
var $d9a78ddb70570cdd$var$Theme = {
    Provider: $d9a78ddb70570cdd$var$Provider,
    Consumer: $d9a78ddb70570cdd$var$Consumer
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$d9a78ddb70570cdd$export$2e2bcd8739ae039 = $d9a78ddb70570cdd$var$Theme;

});
parcelRegister("cAxNV", function(module, exports) {

$parcel$export(module.exports, "createTheme", function () { return $92a311a9af69b769$export$25d302a5b900a763; });

var $aZB6k = parcelRequire("aZB6k");

var $dAx5m = parcelRequire("dAx5m");
var $92a311a9af69b769$var$_excluded = [
    "children"
];
function $92a311a9af69b769$export$25d302a5b900a763(defaultGetTokens) {
    var emptyThemeFn = function emptyThemeFn(getTokens, props) {
        return getTokens(props);
    };
    /**
   * Internally, Theme uses React Context, with internal providers and consumers.
   * The React Context passes only a function that gets props, and turns them into tokens. This
   * function gets mixed as more Providers with their own themes are added. This mixed function
   * is ultimately picked up by Consumers, which implement a context consumer internally to fetch
   * the theme.
   */ var ThemeContext = /*#__PURE__*/ (0, $dAx5m.createContext)(defaultGetTokens);
    function useTheme(themeProps) {
        var theme = (0, $dAx5m.useContext)(ThemeContext);
        var themeFn = theme || emptyThemeFn;
        var tokens = themeFn(themeProps);
        return tokens;
    }
    // The Theme Consumer takes a function as its child - this function takes tokens, and the
    // return value is generally a set of nodes with the tokens applied appropriately.
    function Consumer(props) {
        var children = props.children, themeProps = (0, (/*@__PURE__*/$parcel$interopDefault($aZB6k)))(props, $92a311a9af69b769$var$_excluded);
        // @ts-ignore See issue for more info: https://github.com/Microsoft/TypeScript/issues/10727
        // Argument of type 'Pick<ThemeProps & { children: (tokens: ThemeTokens) => ReactNode; }, Exclude<keyof ThemeProps, "children">>' is not assignable to parameter of type 'ThemeProps'.ts(2345)
        var tokens = useTheme(themeProps);
        // We add a fragment to ensure we don't break people upgrading.
        // Previously they may have been able to pass in undefined without things blowing up.
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).Fragment, null, children(tokens));
    }
    /**
   * The Theme Provider takes regular nodes as its children, but also takes a *theme function*
   * - The theme function takes a set of props, as well as a function (getTokens) that can turn props into tokens.
   * - The getTokens function isn't called immediately - instead the props are passed
   *    through a mix of parent theming functions
   * Children of this provider will receive this mixed theme
   */ function Provider(props) {
        var themeFn = (0, $dAx5m.useContext)(ThemeContext);
        var valueFn = props.value || emptyThemeFn;
        var mixedFn = (0, $dAx5m.useCallback)(function(themeProps) {
            return valueFn(themeFn, themeProps);
        }, [
            themeFn,
            valueFn
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement(ThemeContext.Provider, {
            value: mixedFn
        }, props.children);
    }
    return {
        Consumer: Consumer,
        Provider: Provider,
        useTheme: useTheme
    };
}

});


parcelRegister("92Uwu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $01b3196012655e61$export$2e2bcd8739ae039; });

var $jIMDT = parcelRequire("jIMDT");

var $aZB6k = parcelRequire("aZB6k");

var $dAx5m = parcelRequire("dAx5m");

var $jVTBW = parcelRequire("jVTBW");

var $87inS = parcelRequire("87inS");

var $Bb0he = parcelRequire("Bb0he");

var $gMIYi = parcelRequire("gMIYi");

var $iAyBE = parcelRequire("iAyBE");

var $kqsmh = parcelRequire("kqsmh");

var $apQ6e = parcelRequire("apQ6e");

var $9dX6I = parcelRequire("9dX6I");

var $gje9J = parcelRequire("gje9J");

var $d6LjR = parcelRequire("d6LjR");
var $01b3196012655e61$var$_excluded = [
    "analyticsContext",
    "appearance",
    "autoFocus",
    "buttonCss",
    "children",
    "className",
    "href",
    "component",
    "iconAfter",
    "iconBefore",
    "interactionName",
    "isDisabled",
    "isSelected",
    "onBlur",
    "onClick",
    "onFocus",
    "onMouseDown",
    "overlay",
    "shouldFitContainer",
    "spacing",
    "tabIndex",
    "type",
    "testId"
];
// Disabled buttons will still publish events for nested elements in webkit.
// We are disabling pointer events on child elements so that
// the button will always be the target of events
// Note: firefox does not have this behaviour for child elements
var $01b3196012655e61$var$noPointerEventsOnChildrenCss = {
    "> *": {
        pointerEvents: "none"
    }
};
var $01b3196012655e61$var$iconBeforeSpacingFixStyle = (0, $jVTBW.css)({
    marginInlineStart: "var(--ds-space-negative-025, -2px)"
});
var $01b3196012655e61$var$iconAfterSpacingFixStyle = (0, $jVTBW.css)({
    marginInlineEnd: "var(--ds-space-negative-025, -2px)"
});
var $01b3196012655e61$var$getSpacingFix = function getSpacingFix(children, spacingStyles) {
    if (!children || (0, $d6LjR.getIfVisuallyHiddenChildren)(children)) return null;
    return spacingStyles;
};
var $01b3196012655e61$var$getChildren = function getChildren(children, childrenStyles) {
    if ((0, $d6LjR.getIfVisuallyHiddenChildren)(children)) return children;
    return children ? (0, $jVTBW.jsx)("span", {
        css: childrenStyles
    }, children) : null;
};
var $01b3196012655e61$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).forwardRef(function ButtonBase(props, ref) {
    var analyticsContext = props.analyticsContext, _props$appearance = props.appearance, appearance = _props$appearance === void 0 ? "default" : _props$appearance, _props$autoFocus = props.autoFocus, autoFocus = _props$autoFocus === void 0 ? false : _props$autoFocus, buttonCss = props.buttonCss, children = props.children, className = props.className, href = props.href, _props$component = props.component, Component = _props$component === void 0 ? href ? "a" : "button" : _props$component, iconAfter = props.iconAfter, iconBefore = props.iconBefore, interactionName = props.interactionName, _props$isDisabled = props.isDisabled, isDisabled = _props$isDisabled === void 0 ? false : _props$isDisabled, _props$isSelected = props.isSelected, isSelected = _props$isSelected === void 0 ? false : _props$isSelected, onBlur = props.onBlur, _props$onClick = props.onClick, providedOnClick = _props$onClick === void 0 ? (0, $Bb0he.default) : _props$onClick, onFocus = props.onFocus, _props$onMouseDown = props.onMouseDown, providedOnMouseDown = _props$onMouseDown === void 0 ? (0, $Bb0he.default) : _props$onMouseDown, overlay = props.overlay, shouldFitContainer = props.shouldFitContainer, _props$spacing = props.spacing, spacing = _props$spacing === void 0 ? "default" : _props$spacing, _props$tabIndex = props.tabIndex, tabIndex = _props$tabIndex === void 0 ? 0 : _props$tabIndex, _props$type = props.type, type = _props$type === void 0 ? !href ? "button" : undefined : _props$type, testId = props.testId, rest = (0, (/*@__PURE__*/$parcel$interopDefault($aZB6k)))(props, $01b3196012655e61$var$_excluded);
    var ourRef = (0, $dAx5m.useRef)();
    var setRef = (0, $dAx5m.useCallback)(function(node) {
        ourRef.current = node;
        if (ref == null) return;
        if (typeof ref === "function") {
            ref(node);
            return;
        }
        // We can write to ref's `current` property, but Typescript does not like it.
        // @ts-ignore
        ref.current = node;
    }, [
        ourRef,
        ref
    ]);
    // Cross browser auto focusing is pretty broken, so we are doing it ourselves
    (0, $gMIYi.default)(ourRef, autoFocus);
    var interactionContext = (0, $dAx5m.useContext)((0, $kqsmh.default));
    var handleClick = (0, $dAx5m.useCallback)(function(e, analyticsEvent) {
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    var onClick = (0, $87inS.usePlatformLeafEventHandler)({
        fn: handleClick,
        action: "clicked",
        componentName: "button",
        packageName: "@atlaskit/button",
        packageVersion: "17.14.0",
        analyticsData: analyticsContext
    });
    // Button currently calls preventDefault, which is not standard button behaviour
    var onMouseDown = (0, $dAx5m.useCallback)(function(event) {
        event.preventDefault();
        providedOnMouseDown(event);
    }, [
        providedOnMouseDown
    ]);
    // Lose focus when becoming disabled (standard button behaviour)
    (0, $dAx5m.useEffect)(function() {
        var el = ourRef.current;
        if (isDisabled && el && el === document.activeElement) el.blur();
    }, [
        isDisabled
    ]);
    // we are 'disabling' input with a button when there is an overlay
    var hasOverlay = Boolean(overlay);
    var fadeStyles = (0, $jVTBW.css)((0, $gje9J.getFadingCss)({
        hasOverlay: hasOverlay
    }));
    var isInteractive = !isDisabled && !hasOverlay;
    /**
   * HACK: Spinner needs to have different colours in the "new" tokens design compared to the old design.
   * For now, while we support both, these styles reach into Spinner when a theme is set, applies the right color.
   * Ticket to remove: https://product-fabric.atlassian.net/browse/DSP-2067.
   */ var spinnerHackCss = {};
    if (isSelected || isDisabled || appearance === "warning") spinnerHackCss = {
        "[data-theme] & circle": {
            stroke: "".concat(isSelected || isDisabled ? "var(--ds-icon-subtle, ".concat((0, $apQ6e.N500), ")") : "var(--ds-icon-warning-inverse, ".concat((0, $apQ6e.N500), ")"), " !important")
        }
    };
    return (0, $jVTBW.jsx)((0, $iAyBE.default), null, (0, $jVTBW.jsx)(Component, (0, (/*@__PURE__*/$parcel$interopDefault($jIMDT)))({}, rest, {
        ref: setRef,
        className: className,
        css: [
            buttonCss,
            isInteractive ? null : $01b3196012655e61$var$noPointerEventsOnChildrenCss
        ],
        "data-has-overlay": hasOverlay ? true : undefined,
        "data-testid": testId,
        disabled: isDisabled,
        href: isInteractive ? href : undefined,
        onBlur: onBlur,
        onClick: onClick,
        onFocus: onFocus,
        onMouseDown: onMouseDown,
        tabIndex: isDisabled ? -1 : tabIndex,
        type: type
    }, (0, $9dX6I.default)({
        isInteractive: isInteractive
    })), iconBefore ? (0, $jVTBW.jsx)("span", {
        css: [
            fadeStyles,
            (0, $gje9J.getIconStyle)({
                spacing: spacing
            }),
            $01b3196012655e61$var$getSpacingFix(children, $01b3196012655e61$var$iconBeforeSpacingFixStyle)
        ]
    }, iconBefore) : null, $01b3196012655e61$var$getChildren(children, [
        fadeStyles,
        (0, $gje9J.getContentStyle)({
            spacing: spacing
        })
    ]), iconAfter ? (0, $jVTBW.jsx)("span", {
        css: [
            fadeStyles,
            (0, $gje9J.getIconStyle)({
                spacing: spacing
            }),
            $01b3196012655e61$var$getSpacingFix(children, $01b3196012655e61$var$iconAfterSpacingFixStyle)
        ]
    }, iconAfter) : null, overlay ? (0, $jVTBW.jsx)("span", {
        css: [
            (0, $gje9J.overlayCss),
            spinnerHackCss
        ]
    }, overlay) : null));
});

});
parcelRegister("jVTBW", function(module, exports) {

$parcel$export(module.exports, "createElement", function () { return $e82e7a5cf085a888$export$c8a8987d4410bf2d; });
$parcel$export(module.exports, "Global", function () { return $e82e7a5cf085a888$export$98f03c5d19621d70; });
$parcel$export(module.exports, "css", function () { return $e82e7a5cf085a888$export$dbf350e5966cf602; });
$parcel$export(module.exports, "keyframes", function () { return $e82e7a5cf085a888$export$d25ddfdf17c3ad3e; });
$parcel$export(module.exports, "ClassNames", function () { return $e82e7a5cf085a888$export$9b9c0f9d9f3552b8; });
$parcel$export(module.exports, "jsx", function () { return $e82e7a5cf085a888$export$c8a8987d4410bf2d; });
$parcel$export(module.exports, "CacheProvider", function () { return (parcelRequire("2wjNk")).C; });
$parcel$export(module.exports, "ThemeContext", function () { return (parcelRequire("2wjNk")).T; });
$parcel$export(module.exports, "ThemeProvider", function () { return (parcelRequire("2wjNk")).a; });
$parcel$export(module.exports, "__unsafe_useEmotionCache", function () { return (parcelRequire("2wjNk"))._; });
$parcel$export(module.exports, "useTheme", function () { return (parcelRequire("2wjNk")).u; });
$parcel$export(module.exports, "withEmotionCache", function () { return (parcelRequire("2wjNk")).w; });
$parcel$export(module.exports, "withTheme", function () { return (parcelRequire("2wjNk")).b; });

var $2wjNk = parcelRequire("2wjNk");

var $dAx5m = parcelRequire("dAx5m");

var $3Ao1t = parcelRequire("3Ao1t");

var $fDu2l = parcelRequire("fDu2l");

var $2EoW8 = parcelRequire("2EoW8");
parcelRequire("3Wdxg");
parcelRequire("dML2Y");
parcelRequire("1Pk4E");

parcelRequire("NP1E6");
var $e82e7a5cf085a888$var$pkg = {
    name: "@emotion/react",
    version: "11.12.0",
    main: "dist/emotion-react.cjs.js",
    module: "dist/emotion-react.esm.js",
    browser: {
        "./dist/emotion-react.esm.js": "./dist/emotion-react.browser.esm.js"
    },
    exports: {
        ".": {
            module: {
                worker: "./dist/emotion-react.worker.esm.js",
                browser: "./dist/emotion-react.browser.esm.js",
                "default": "./dist/emotion-react.esm.js"
            },
            "import": "./dist/emotion-react.cjs.mjs",
            "default": "./dist/emotion-react.cjs.js"
        },
        "./jsx-runtime": {
            module: {
                worker: "./jsx-runtime/dist/emotion-react-jsx-runtime.worker.esm.js",
                browser: "./jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js",
                "default": "./jsx-runtime/dist/emotion-react-jsx-runtime.esm.js"
            },
            "import": "./jsx-runtime/dist/emotion-react-jsx-runtime.cjs.mjs",
            "default": "./jsx-runtime/dist/emotion-react-jsx-runtime.cjs.js"
        },
        "./_isolated-hnrs": {
            module: {
                worker: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.worker.esm.js",
                browser: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.browser.esm.js",
                "default": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.esm.js"
            },
            "import": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.cjs.mjs",
            "default": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.cjs.js"
        },
        "./jsx-dev-runtime": {
            module: {
                worker: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.worker.esm.js",
                browser: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.browser.esm.js",
                "default": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.esm.js"
            },
            "import": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.cjs.mjs",
            "default": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.cjs.js"
        },
        "./package.json": "./package.json",
        "./types/css-prop": "./types/css-prop.d.ts",
        "./macro": {
            types: {
                "import": "./macro.d.mts",
                "default": "./macro.d.ts"
            },
            "default": "./macro.js"
        }
    },
    types: "types/index.d.ts",
    files: [
        "src",
        "dist",
        "jsx-runtime",
        "jsx-dev-runtime",
        "_isolated-hnrs",
        "types/*.d.ts",
        "macro.*"
    ],
    sideEffects: false,
    author: "Emotion Contributors",
    license: "MIT",
    scripts: {
        "test:typescript": "dtslint types"
    },
    dependencies: {
        "@babel/runtime": "^7.18.3",
        "@emotion/babel-plugin": "^11.12.0",
        "@emotion/cache": "^11.12.0",
        "@emotion/serialize": "^1.2.0",
        "@emotion/use-insertion-effect-with-fallbacks": "^1.0.1",
        "@emotion/utils": "^1.3.0",
        "@emotion/weak-memoize": "^0.4.0",
        "hoist-non-react-statics": "^3.3.1"
    },
    peerDependencies: {
        react: ">=16.8.0"
    },
    peerDependenciesMeta: {
        "@types/react": {
            optional: true
        }
    },
    devDependencies: {
        "@definitelytyped/dtslint": "0.0.112",
        "@emotion/css": "11.12.0",
        "@emotion/css-prettifier": "1.1.4",
        "@emotion/server": "11.11.0",
        "@emotion/styled": "11.12.0",
        "html-tag-names": "^1.1.2",
        react: "16.14.0",
        "svg-tag-names": "^1.1.1",
        typescript: "^5.4.5"
    },
    repository: "https://github.com/emotion-js/emotion/tree/main/packages/react",
    publishConfig: {
        access: "public"
    },
    "umd:main": "dist/emotion-react.umd.min.js",
    preconstruct: {
        entrypoints: [
            "./index.js",
            "./jsx-runtime.js",
            "./jsx-dev-runtime.js",
            "./_isolated-hnrs.js"
        ],
        umdName: "emotionReact",
        exports: {
            envConditions: [
                "browser",
                "worker"
            ],
            extra: {
                "./types/css-prop": "./types/css-prop.d.ts",
                "./macro": {
                    types: {
                        "import": "./macro.d.mts",
                        "default": "./macro.d.ts"
                    },
                    "default": "./macro.js"
                }
            }
        }
    }
};
var $e82e7a5cf085a888$export$c8a8987d4410bf2d = function jsx(type, props) {
    var args = arguments;
    if (props == null || !(0, $2wjNk.h).call(props, "css")) return $dAx5m.createElement.apply(undefined, args);
    var argsLength = args.length;
    var createElementArgArray = new Array(argsLength);
    createElementArgArray[0] = (0, $2wjNk.E);
    createElementArgArray[1] = (0, $2wjNk.c)(type, props);
    for(var i = 2; i < argsLength; i++)createElementArgArray[i] = args[i];
    return $dAx5m.createElement.apply(null, createElementArgArray);
};
/*
type Styles = Object | Array<Object>

type GlobalProps = {
  +styles: Styles | (Object => Styles)
}
*/ var $e82e7a5cf085a888$var$warnedAboutCssPropForGlobal = false; // maintain place over rerenders.
// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
// initial client-side render from SSR, use place of hydrating tag
var $e82e7a5cf085a888$export$98f03c5d19621d70 = /* #__PURE__ */ (0, $2wjNk.w)(function(props, cache) {
    var styles = props.styles;
    var serialized = (0, $2EoW8.serializeStyles)([
        styles
    ], undefined, $dAx5m.useContext((0, $2wjNk.T)));
    if (!(0, $2wjNk.i)) {
        var _ref;
        var serializedNames = serialized.name;
        var serializedStyles = serialized.styles;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += " " + next.name;
            serializedStyles += next.styles;
            next = next.next;
        }
        var shouldCache = cache.compat === true;
        var rules = cache.insert("", {
            name: serializedNames,
            styles: serializedStyles
        }, cache.sheet, shouldCache);
        if (shouldCache) return null;
        return /*#__PURE__*/ $dAx5m.createElement("style", (_ref = {}, _ref["data-emotion"] = cache.key + "-global " + serializedNames, _ref.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref.nonce = cache.sheet.nonce, _ref));
    } // yes, i know these hooks are used conditionally
    // but it is based on a constant that will never change at runtime
    // it's effectively like having two implementations and switching them out
    // so it's not actually breaking anything
    var sheetRef = $dAx5m.useRef();
    (0, $fDu2l.useInsertionEffectWithLayoutFallback)(function() {
        var key = cache.key + "-global"; // use case of https://github.com/emotion-js/emotion/issues/2675
        var sheet = new cache.sheet.constructor({
            key: key,
            nonce: cache.sheet.nonce,
            container: cache.sheet.container,
            speedy: cache.sheet.isSpeedy
        });
        var rehydrating = false;
        var node = document.querySelector('style[data-emotion="' + key + " " + serialized.name + '"]');
        if (cache.sheet.tags.length) sheet.before = cache.sheet.tags[0];
        if (node !== null) {
            rehydrating = true; // clear the hash so this node won't be recognizable as rehydratable by other <Global/>s
            node.setAttribute("data-emotion", key);
            sheet.hydrate([
                node
            ]);
        }
        sheetRef.current = [
            sheet,
            rehydrating
        ];
        return function() {
            sheet.flush();
        };
    }, [
        cache
    ]);
    (0, $fDu2l.useInsertionEffectWithLayoutFallback)(function() {
        var sheetRefCurrent = sheetRef.current;
        var sheet = sheetRefCurrent[0], rehydrating = sheetRefCurrent[1];
        if (rehydrating) {
            sheetRefCurrent[1] = false;
            return;
        }
        if (serialized.next !== undefined) // insert keyframes
        (0, $3Ao1t.insertStyles)(cache, serialized.next, true);
        if (sheet.tags.length) {
            // if this doesn't exist then it will be null so the style element will be appended
            var element = sheet.tags[sheet.tags.length - 1].nextElementSibling;
            sheet.before = element;
            sheet.flush();
        }
        cache.insert("", serialized, sheet, false);
    }, [
        cache,
        serialized.name
    ]);
    return null;
});
/* import type { Interpolation, SerializedStyles } from '@emotion/utils' */ function $e82e7a5cf085a888$export$dbf350e5966cf602() /*: SerializedStyles */ {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return (0, $2EoW8.serializeStyles)(args);
}
/*
type Keyframes = {|
  name: string,
  styles: string,
  anim: 1,
  toString: () => string
|} & string
*/ var $e82e7a5cf085a888$export$d25ddfdf17c3ad3e = function /*: Keyframes */ keyframes() {
    var insertable = $e82e7a5cf085a888$export$dbf350e5966cf602.apply(void 0, arguments);
    var name = "animation-" + insertable.name;
    return {
        name: name,
        styles: "@keyframes " + name + "{" + insertable.styles + "}",
        anim: 1,
        toString: function toString() {
            return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
        }
    };
};
/*
type ClassNameArg =
  | string
  | boolean
  | { [key: string]: boolean }
  | Array<ClassNameArg>
  | null
  | void
*/ var $e82e7a5cf085a888$var$classnames = function /*: string */ classnames(args) {
    var len = args.length;
    var i = 0;
    var cls = "";
    for(; i < len; i++){
        var arg = args[i];
        if (arg == null) continue;
        var toAdd = void 0;
        switch(typeof arg){
            case "boolean":
                break;
            case "object":
                if (Array.isArray(arg)) toAdd = classnames(arg);
                else {
                    toAdd = "";
                    for(var k in arg)if (arg[k] && k) {
                        toAdd && (toAdd += " ");
                        toAdd += k;
                    }
                }
                break;
            default:
                toAdd = arg;
        }
        if (toAdd) {
            cls && (cls += " ");
            cls += toAdd;
        }
    }
    return cls;
};
function $e82e7a5cf085a888$var$merge(registered, css, className) {
    var registeredStyles = [];
    var rawClassName = (0, $3Ao1t.getRegisteredStyles)(registered, registeredStyles, className);
    if (registeredStyles.length < 2) return className;
    return rawClassName + css(registeredStyles);
}
var $e82e7a5cf085a888$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serializedArr = _ref.serializedArr;
    (0, $fDu2l.useInsertionEffectAlwaysWithSyncFallback)(function() {
        for(var i = 0; i < serializedArr.length; i++)(0, $3Ao1t.insertStyles)(cache, serializedArr[i], false);
    });
    return null;
};
/*
type Props = {
  children: ({
    css: (...args: any) => string,
    cx: (...args: Array<ClassNameArg>) => string,
    theme: Object
  }) => React.Node
} */ var $e82e7a5cf085a888$export$9b9c0f9d9f3552b8 = /* #__PURE__ */ (0, $2wjNk.w)(function(props, cache) {
    var hasRendered = false;
    var serializedArr = [];
    var css = function css() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var serialized = (0, $2EoW8.serializeStyles)(args, cache.registered);
        serializedArr.push(serialized); // registration has to happen here as the result of this might get consumed by `cx`
        (0, $3Ao1t.registerStyles)(cache, serialized, false);
        return cache.key + "-" + serialized.name;
    };
    var cx = function cx() {
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        return $e82e7a5cf085a888$var$merge(cache.registered, css, $e82e7a5cf085a888$var$classnames(args));
    };
    var content = {
        css: css,
        cx: cx,
        theme: $dAx5m.useContext((0, $2wjNk.T))
    };
    var ele = props.children(content);
    hasRendered = true;
    return /*#__PURE__*/ $dAx5m.createElement($dAx5m.Fragment, null, /*#__PURE__*/ $dAx5m.createElement($e82e7a5cf085a888$var$Insertion, {
        cache: cache,
        serializedArr: serializedArr
    }), ele);
});
var $e82e7a5cf085a888$var$isBrowser, $e82e7a5cf085a888$var$isTestEnv, $e82e7a5cf085a888$var$globalContext, $e82e7a5cf085a888$var$globalKey;

});
parcelRegister("2wjNk", function(module, exports) {

$parcel$export(module.exports, "i", function () { return $1d5decb718c9ecdd$export$23f2a1d2818174ef; });
$parcel$export(module.exports, "h", function () { return $1d5decb718c9ecdd$export$dda1d9f60106f0e9; });
$parcel$export(module.exports, "C", function () { return $1d5decb718c9ecdd$export$e7094788287c5e9b; });
$parcel$export(module.exports, "_", function () { return $1d5decb718c9ecdd$export$71511d61b312f219; });
$parcel$export(module.exports, "w", function () { return $1d5decb718c9ecdd$export$efccba1c4a2ef57b; });
$parcel$export(module.exports, "T", function () { return $1d5decb718c9ecdd$export$971d5caa766a69d7; });
$parcel$export(module.exports, "u", function () { return $1d5decb718c9ecdd$export$3b14a55fb2447963; });
$parcel$export(module.exports, "a", function () { return $1d5decb718c9ecdd$export$407448d2b89b1813; });
$parcel$export(module.exports, "b", function () { return $1d5decb718c9ecdd$export$8b22cf2602fb60ce; });
$parcel$export(module.exports, "c", function () { return $1d5decb718c9ecdd$export$db3b6bfb95261072; });
$parcel$export(module.exports, "E", function () { return $1d5decb718c9ecdd$export$a9c23c6ac3fc3eca; });

var $dAx5m = parcelRequire("dAx5m");

var $3Wdxg = parcelRequire("3Wdxg");

var $4dWgq = parcelRequire("4dWgq");

var $1Pk4E = parcelRequire("1Pk4E");

var $2Fyhd = parcelRequire("2Fyhd");

var $3Ao1t = parcelRequire("3Ao1t");

var $2EoW8 = parcelRequire("2EoW8");

var $fDu2l = parcelRequire("fDu2l");
var $1d5decb718c9ecdd$export$23f2a1d2818174ef = true;
var $1d5decb718c9ecdd$export$dda1d9f60106f0e9 = {}.hasOwnProperty;
/* import { type EmotionCache } from '@emotion/utils' */ var $1d5decb718c9ecdd$var$EmotionCacheContext = /* #__PURE__ */ $dAx5m.createContext(// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== "undefined" ? /* #__PURE__ */ (0, $3Wdxg.default)({
    key: "css"
}) : null);
var $1d5decb718c9ecdd$export$e7094788287c5e9b = $1d5decb718c9ecdd$var$EmotionCacheContext.Provider;
var $1d5decb718c9ecdd$export$71511d61b312f219 = function useEmotionCache() /*: EmotionCache | null*/ {
    return (0, $dAx5m.useContext)($1d5decb718c9ecdd$var$EmotionCacheContext);
};
var $1d5decb718c9ecdd$export$efccba1c4a2ef57b = function withEmotionCache(func) /*: React.AbstractComponent<Props> */ {
    return /*#__PURE__*/ (0, $dAx5m.forwardRef)(function(props, ref) {
        // the cache will never be null in the browser
        var cache = (0, $dAx5m.useContext)($1d5decb718c9ecdd$var$EmotionCacheContext);
        return func(props, cache, ref);
    });
};
if (!$1d5decb718c9ecdd$export$23f2a1d2818174ef) $1d5decb718c9ecdd$export$efccba1c4a2ef57b = function withEmotionCache(func) /*: React.StatelessFunctionalComponent<Props> */ {
    return function(props) {
        var cache = (0, $dAx5m.useContext)($1d5decb718c9ecdd$var$EmotionCacheContext);
        if (cache === null) {
            // yes, we're potentially creating this on every render
            // it doesn't actually matter though since it's only on the server
            // so there will only every be a single render
            // that could change in the future because of suspense and etc. but for now,
            // this works and i don't want to optimise for a future thing that we aren't sure about
            cache = (0, $3Wdxg.default)({
                key: "css"
            });
            return /*#__PURE__*/ $dAx5m.createElement($1d5decb718c9ecdd$var$EmotionCacheContext.Provider, {
                value: cache
            }, func(props, cache));
        } else return func(props, cache);
    };
};
var $1d5decb718c9ecdd$export$971d5caa766a69d7 = /* #__PURE__ */ $dAx5m.createContext({});
var $1d5decb718c9ecdd$export$3b14a55fb2447963 = function useTheme() {
    return $dAx5m.useContext($1d5decb718c9ecdd$export$971d5caa766a69d7);
};
var $1d5decb718c9ecdd$var$getTheme = function getTheme(outerTheme, theme) {
    if (typeof theme === "function") {
        var mergedTheme = theme(outerTheme);
        return mergedTheme;
    }
    return (0, $4dWgq.default)({}, outerTheme, theme);
};
var $1d5decb718c9ecdd$var$createCacheWithTheme = /* #__PURE__ */ (0, $1Pk4E.default)(function(outerTheme) {
    return (0, $1Pk4E.default)(function(theme) {
        return $1d5decb718c9ecdd$var$getTheme(outerTheme, theme);
    });
});
/*
type ThemeProviderProps = {
  theme: Object | (Object => Object),
  children: React.Node
}
*/ var $1d5decb718c9ecdd$export$407448d2b89b1813 = function ThemeProvider(props) {
    var theme = $dAx5m.useContext($1d5decb718c9ecdd$export$971d5caa766a69d7);
    if (props.theme !== theme) theme = $1d5decb718c9ecdd$var$createCacheWithTheme(theme)(props.theme);
    return /*#__PURE__*/ $dAx5m.createElement($1d5decb718c9ecdd$export$971d5caa766a69d7.Provider, {
        value: theme
    }, props.children);
};
function $1d5decb718c9ecdd$export$8b22cf2602fb60ce(Component) /*: React.AbstractComponent<$Diff<Config, { theme: Object }>> */ {
    var componentName = Component.displayName || Component.name || "Component";
    var render = function render(props, ref) {
        var theme = $dAx5m.useContext($1d5decb718c9ecdd$export$971d5caa766a69d7);
        return /*#__PURE__*/ $dAx5m.createElement(Component, (0, $4dWgq.default)({
            theme: theme,
            ref: ref
        }, props));
    };
    var WithTheme = /*#__PURE__*/ $dAx5m.forwardRef(render);
    WithTheme.displayName = "WithTheme(" + componentName + ")";
    return (0, $2Fyhd.default)(WithTheme, Component);
}
var $1d5decb718c9ecdd$var$getLastPart = function /* : string */ getLastPart(functionName) {
    // The match may be something like 'Object.createEmotionProps' or
    // 'Loader.prototype.render'
    var parts = functionName.split(".");
    return parts[parts.length - 1];
};
var $1d5decb718c9ecdd$var$getFunctionNameFromStackTraceLine = function /*: ?string*/ getFunctionNameFromStackTraceLine(line) {
    // V8
    var match = /^\s+at\s+([A-Za-z0-9$.]+)\s/.exec(line);
    if (match) return $1d5decb718c9ecdd$var$getLastPart(match[1]); // Safari / Firefox
    match = /^([A-Za-z0-9$.]+)@/.exec(line);
    if (match) return $1d5decb718c9ecdd$var$getLastPart(match[1]);
    return undefined;
};
var $1d5decb718c9ecdd$var$internalReactFunctionNames = /* #__PURE__ */ new Set([
    "renderWithHooks",
    "processChild",
    "finishClassComponent",
    "renderToString"
]); // These identifiers come from error stacks, so they have to be valid JS
// identifiers, thus we only need to replace what is a valid character for JS,
// but not for CSS.
var $1d5decb718c9ecdd$var$sanitizeIdentifier = function sanitizeIdentifier(identifier) {
    return identifier.replace(/\$/g, "-");
};
var $1d5decb718c9ecdd$var$getLabelFromStackTrace = function getLabelFromStackTrace(stackTrace) {
    if (!stackTrace) return undefined;
    var lines = stackTrace.split("\n");
    for(var i = 0; i < lines.length; i++){
        var functionName = $1d5decb718c9ecdd$var$getFunctionNameFromStackTraceLine(lines[i]); // The first line of V8 stack traces is just "Error"
        if (!functionName) continue; // If we reach one of these, we have gone too far and should quit
        if ($1d5decb718c9ecdd$var$internalReactFunctionNames.has(functionName)) break; // The component name is the first function in the stack that starts with an
        // uppercase letter
        if (/^[A-Z]/.test(functionName)) return $1d5decb718c9ecdd$var$sanitizeIdentifier(functionName);
    }
    return undefined;
};
var $1d5decb718c9ecdd$var$typePropName = "__EMOTION_TYPE_PLEASE_DO_NOT_USE__";
var $1d5decb718c9ecdd$var$labelPropName = "__EMOTION_LABEL_PLEASE_DO_NOT_USE__";
var $1d5decb718c9ecdd$export$db3b6bfb95261072 = function createEmotionProps(type, props) {
    var newProps = {};
    for(var key in props)if ($1d5decb718c9ecdd$export$dda1d9f60106f0e9.call(props, key)) newProps[key] = props[key];
    newProps[$1d5decb718c9ecdd$var$typePropName] = type; // Runtime labeling is an opt-in feature because:
    var label;
    return newProps;
};
var $1d5decb718c9ecdd$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $3Ao1t.registerStyles)(cache, serialized, isStringTag);
    (0, $fDu2l.useInsertionEffectAlwaysWithSyncFallback)(function() {
        return (0, $3Ao1t.insertStyles)(cache, serialized, isStringTag);
    });
    return null;
};
var $1d5decb718c9ecdd$var$Emotion = /* #__PURE__ */ $1d5decb718c9ecdd$export$efccba1c4a2ef57b(/* <any, any> */ function(props, cache, ref) {
    var cssProp = props.css; // so that using `css` from `emotion` and passing the result to the css prop works
    // not passing the registered cache to serializeStyles because it would
    // make certain babel optimisations not possible
    if (typeof cssProp === "string" && cache.registered[cssProp] !== undefined) cssProp = cache.registered[cssProp];
    var WrappedComponent = props[$1d5decb718c9ecdd$var$typePropName];
    var registeredStyles = [
        cssProp
    ];
    var className = "";
    if (typeof props.className === "string") className = (0, $3Ao1t.getRegisteredStyles)(cache.registered, registeredStyles, props.className);
    else if (props.className != null) className = props.className + " ";
    var serialized = (0, $2EoW8.serializeStyles)(registeredStyles, undefined, $dAx5m.useContext($1d5decb718c9ecdd$export$971d5caa766a69d7));
    var labelFromStack;
    className += cache.key + "-" + serialized.name;
    var newProps = {};
    for(var key in props)if ($1d5decb718c9ecdd$export$dda1d9f60106f0e9.call(props, key) && key !== "css" && key !== $1d5decb718c9ecdd$var$typePropName && true) newProps[key] = props[key];
    newProps.className = className;
    if (ref) newProps.ref = ref;
    return /*#__PURE__*/ $dAx5m.createElement($dAx5m.Fragment, null, /*#__PURE__*/ $dAx5m.createElement($1d5decb718c9ecdd$var$Insertion, {
        cache: cache,
        serialized: serialized,
        isStringTag: typeof WrappedComponent === "string"
    }), /*#__PURE__*/ $dAx5m.createElement(WrappedComponent, newProps));
});
var $1d5decb718c9ecdd$export$a9c23c6ac3fc3eca = $1d5decb718c9ecdd$var$Emotion;

});
parcelRegister("3Wdxg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2de149c390cefcd1$export$2e2bcd8739ae039; });

var $7nt93 = parcelRequire("7nt93");

var $17n7v = parcelRequire("17n7v");
parcelRequire("1Pk4E");
parcelRequire("8cVSc");
var $2de149c390cefcd1$var$identifierWithPointTracking = function identifierWithPointTracking(begin, points, index) {
    var previous = 0;
    var character = 0;
    while(true){
        previous = character;
        character = (0, $17n7v.peek)(); // &\f
        if (previous === 38 && character === 12) points[index] = 1;
        if ((0, $17n7v.token)(character)) break;
        (0, $17n7v.next)();
    }
    return (0, $17n7v.slice)(begin, (0, $17n7v.position));
};
var $2de149c390cefcd1$var$toRules = function toRules(parsed, points) {
    // pretend we've started with a comma
    var index = -1;
    var character = 44;
    do switch((0, $17n7v.token)(character)){
        case 0:
            // &\f
            if (character === 38 && (0, $17n7v.peek)() === 12) // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
            // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
            // and when it should just concatenate the outer and inner selectors
            // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
            points[index] = 1;
            parsed[index] += $2de149c390cefcd1$var$identifierWithPointTracking((0, $17n7v.position) - 1, points, index);
            break;
        case 2:
            parsed[index] += (0, $17n7v.delimit)(character);
            break;
        case 4:
            // comma
            if (character === 44) {
                // colon
                parsed[++index] = (0, $17n7v.peek)() === 58 ? "&\f" : "";
                points[index] = parsed[index].length;
                break;
            }
        // fallthrough
        default:
            parsed[index] += (0, $17n7v.from)(character);
    }
    while (character = (0, $17n7v.next)());
    return parsed;
};
var $2de149c390cefcd1$var$getRules = function getRules(value, points) {
    return (0, $17n7v.dealloc)($2de149c390cefcd1$var$toRules((0, $17n7v.alloc)(value), points));
}; // WeakSet would be more appropriate, but only WeakMap is supported in IE11
var $2de149c390cefcd1$var$fixedElements = /* #__PURE__ */ new WeakMap();
var $2de149c390cefcd1$var$compat = function compat(element) {
    if (element.type !== "rule" || !element.parent || // positive .length indicates that this rule contains pseudo
    // negative .length indicates that this rule has been already prefixed
    element.length < 1) return;
    var value = element.value, parent = element.parent;
    var isImplicitRule = element.column === parent.column && element.line === parent.line;
    while(parent.type !== "rule"){
        parent = parent.parent;
        if (!parent) return;
    } // short-circuit for the simplest case
    if (element.props.length === 1 && value.charCodeAt(0) !== 58 && !$2de149c390cefcd1$var$fixedElements.get(parent)) return;
     // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
    // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"
    if (isImplicitRule) return;
    $2de149c390cefcd1$var$fixedElements.set(element, true);
    var points = [];
    var rules = $2de149c390cefcd1$var$getRules(value, points);
    var parentRules = parent.props;
    for(var i = 0, k = 0; i < rules.length; i++)for(var j = 0; j < parentRules.length; j++, k++)element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
};
var $2de149c390cefcd1$var$removeLabel = function removeLabel(element) {
    if (element.type === "decl") {
        var value = element.value;
        if (value.charCodeAt(0) === 108 && // charcode for b
        value.charCodeAt(2) === 98) {
            // this ignores label
            element["return"] = "";
            element.value = "";
        }
    }
};
var $2de149c390cefcd1$var$ignoreFlag = "emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason";
var $2de149c390cefcd1$var$isIgnoringComment = function isIgnoringComment(element) {
    return element.type === "comm" && element.children.indexOf($2de149c390cefcd1$var$ignoreFlag) > -1;
};
var $2de149c390cefcd1$var$createUnsafeSelectorsAlarm = function createUnsafeSelectorsAlarm(cache) {
    return function(element, index, children) {
        if (element.type !== "rule" || cache.compat) return;
        var unsafePseudoClasses = element.value.match(/(:first|:nth|:nth-last)-child/g);
        if (unsafePseudoClasses) {
            var isNested = !!element.parent; // in nested rules comments become children of the "auto-inserted" rule and that's always the `element.parent`
            //
            // considering this input:
            // .a {
            //   .b /* comm */ {}
            //   color: hotpink;
            // }
            // we get output corresponding to this:
            // .a {
            //   & {
            //     /* comm */
            //     color: hotpink;
            //   }
            //   .b {}
            // }
            var commentContainer = isNested ? element.parent.children : children;
            for(var i = commentContainer.length - 1; i >= 0; i--){
                var node = commentContainer[i];
                if (node.line < element.line) break;
                 // it is quite weird but comments are *usually* put at `column: element.column - 1`
                // so we seek *from the end* for the node that is earlier than the rule's `element` and check that
                // this will also match inputs like this:
                // .a {
                //   /* comm */
                //   .b {}
                // }
                //
                // but that is fine
                //
                // it would be the easiest to change the placement of the comment to be the first child of the rule:
                // .a {
                //   .b { /* comm */ }
                // }
                // with such inputs we wouldn't have to search for the comment at all
                // TODO: consider changing this comment placement in the next major version
                if (node.column < element.column) {
                    if ($2de149c390cefcd1$var$isIgnoringComment(node)) return;
                    break;
                }
            }
            unsafePseudoClasses.forEach(function(unsafePseudoClass) {
                console.error('The pseudo class "' + unsafePseudoClass + '" is potentially unsafe when doing server-side rendering. Try changing it to "' + unsafePseudoClass.split("-child")[0] + '-of-type".');
            });
        }
    };
};
var $2de149c390cefcd1$var$isImportRule = function isImportRule(element) {
    return element.type.charCodeAt(1) === 105 && element.type.charCodeAt(0) === 64;
};
var $2de149c390cefcd1$var$isPrependedWithRegularRules = function isPrependedWithRegularRules(index, children) {
    for(var i = index - 1; i >= 0; i--){
        if (!$2de149c390cefcd1$var$isImportRule(children[i])) return true;
    }
    return false;
}; // use this to remove incorrect elements from further processing
// so they don't get handed to the `sheet` (or anything else)
// as that could potentially lead to additional logs which in turn could be overhelming to the user
var $2de149c390cefcd1$var$nullifyElement = function nullifyElement(element) {
    element.type = "";
    element.value = "";
    element["return"] = "";
    element.children = "";
    element.props = "";
};
var $2de149c390cefcd1$var$incorrectImportAlarm = function incorrectImportAlarm(element, index, children) {
    if (!$2de149c390cefcd1$var$isImportRule(element)) return;
    if (element.parent) {
        console.error("`@import` rules can't be nested inside other rules. Please move it to the top level and put it before regular rules. Keep in mind that they can only be used within global styles.");
        $2de149c390cefcd1$var$nullifyElement(element);
    } else if ($2de149c390cefcd1$var$isPrependedWithRegularRules(index, children)) {
        console.error("`@import` rules can't be after other rules. Please put your `@import` rules before your other rules.");
        $2de149c390cefcd1$var$nullifyElement(element);
    }
};
/* eslint-disable no-fallthrough */ function $2de149c390cefcd1$var$prefix(value, length) {
    switch((0, $17n7v.hash)(value, length)){
        // color-adjust
        case 5103:
            return (0, $17n7v.WEBKIT) + "print-" + value + value;
        // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return (0, $17n7v.WEBKIT) + value + value;
        // appearance, user-select, transform, hyphens, text-size-adjust
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return (0, $17n7v.WEBKIT) + value + (0, $17n7v.MOZ) + value + (0, $17n7v.MS) + value + value;
        // flex, flex-direction
        case 6828:
        case 4268:
            return (0, $17n7v.WEBKIT) + value + (0, $17n7v.MS) + value + value;
        // order
        case 6165:
            return (0, $17n7v.WEBKIT) + value + (0, $17n7v.MS) + "flex-" + value + value;
        // align-items
        case 5187:
            return (0, $17n7v.WEBKIT) + value + (0, $17n7v.replace)(value, /(\w+).+(:[^]+)/, (0, $17n7v.WEBKIT) + "box-$1$2" + (0, $17n7v.MS) + "flex-$1$2") + value;
        // align-self
        case 5443:
            return (0, $17n7v.WEBKIT) + value + (0, $17n7v.MS) + "flex-item-" + (0, $17n7v.replace)(value, /flex-|-self/, "") + value;
        // align-content
        case 4675:
            return (0, $17n7v.WEBKIT) + value + (0, $17n7v.MS) + "flex-line-pack" + (0, $17n7v.replace)(value, /align-content|flex-|-self/, "") + value;
        // flex-shrink
        case 5548:
            return (0, $17n7v.WEBKIT) + value + (0, $17n7v.MS) + (0, $17n7v.replace)(value, "shrink", "negative") + value;
        // flex-basis
        case 5292:
            return (0, $17n7v.WEBKIT) + value + (0, $17n7v.MS) + (0, $17n7v.replace)(value, "basis", "preferred-size") + value;
        // flex-grow
        case 6060:
            return (0, $17n7v.WEBKIT) + "box-" + (0, $17n7v.replace)(value, "-grow", "") + (0, $17n7v.WEBKIT) + value + (0, $17n7v.MS) + (0, $17n7v.replace)(value, "grow", "positive") + value;
        // transition
        case 4554:
            return (0, $17n7v.WEBKIT) + (0, $17n7v.replace)(value, /([^-])(transform)/g, "$1" + (0, $17n7v.WEBKIT) + "$2") + value;
        // cursor
        case 6187:
            return (0, $17n7v.replace)((0, $17n7v.replace)((0, $17n7v.replace)(value, /(zoom-|grab)/, (0, $17n7v.WEBKIT) + "$1"), /(image-set)/, (0, $17n7v.WEBKIT) + "$1"), value, "") + value;
        // background, background-image
        case 5495:
        case 3959:
            return (0, $17n7v.replace)(value, /(image-set\([^]*)/, (0, $17n7v.WEBKIT) + "$1" + "$`$1");
        // justify-content
        case 4968:
            return (0, $17n7v.replace)((0, $17n7v.replace)(value, /(.+:)(flex-)?(.*)/, (0, $17n7v.WEBKIT) + "box-pack:$3" + (0, $17n7v.MS) + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + (0, $17n7v.WEBKIT) + value + value;
        // (margin|padding)-inline-(start|end)
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return (0, $17n7v.replace)(value, /(.+)-inline(.+)/, (0, $17n7v.WEBKIT) + "$1$2") + value;
        // (min|max)?(width|height|inline-size|block-size)
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            // stretch, max-content, min-content, fill-available
            if ((0, $17n7v.strlen)(value) - 1 - length > 6) switch((0, $17n7v.charat)(value, length + 1)){
                // (m)ax-content, (m)in-content
                case 109:
                    // -
                    if ((0, $17n7v.charat)(value, length + 4) !== 45) break;
                // (f)ill-available, (f)it-content
                case 102:
                    return (0, $17n7v.replace)(value, /(.+:)(.+)-([^]+)/, "$1" + (0, $17n7v.WEBKIT) + "$2-$3" + "$1" + (0, $17n7v.MOZ) + ((0, $17n7v.charat)(value, length + 3) == 108 ? "$3" : "$2-$3")) + value;
                // (s)tretch
                case 115:
                    return ~(0, $17n7v.indexof)(value, "stretch") ? $2de149c390cefcd1$var$prefix((0, $17n7v.replace)(value, "stretch", "fill-available"), length) + value : value;
            }
            break;
        // position: sticky
        case 4949:
            // (s)ticky?
            if ((0, $17n7v.charat)(value, length + 1) !== 115) break;
        // display: (flex|inline-flex)
        case 6444:
            switch((0, $17n7v.charat)(value, (0, $17n7v.strlen)(value) - 3 - (~(0, $17n7v.indexof)(value, "!important") && 10))){
                // stic(k)y
                case 107:
                    return (0, $17n7v.replace)(value, ":", ":" + (0, $17n7v.WEBKIT)) + value;
                // (inline-)?fl(e)x
                case 101:
                    return (0, $17n7v.replace)(value, /(.+:)([^;!]+)(;|!.+)?/, "$1" + (0, $17n7v.WEBKIT) + ((0, $17n7v.charat)(value, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + (0, $17n7v.WEBKIT) + "$2$3" + "$1" + (0, $17n7v.MS) + "$2box$3") + value;
            }
            break;
        // writing-mode
        case 5936:
            switch((0, $17n7v.charat)(value, length + 11)){
                // vertical-l(r)
                case 114:
                    return (0, $17n7v.WEBKIT) + value + (0, $17n7v.MS) + (0, $17n7v.replace)(value, /[svh]\w+-[tblr]{2}/, "tb") + value;
                // vertical-r(l)
                case 108:
                    return (0, $17n7v.WEBKIT) + value + (0, $17n7v.MS) + (0, $17n7v.replace)(value, /[svh]\w+-[tblr]{2}/, "tb-rl") + value;
                // horizontal(-)tb
                case 45:
                    return (0, $17n7v.WEBKIT) + value + (0, $17n7v.MS) + (0, $17n7v.replace)(value, /[svh]\w+-[tblr]{2}/, "lr") + value;
            }
            return (0, $17n7v.WEBKIT) + value + (0, $17n7v.MS) + value + value;
    }
    return value;
}
var $2de149c390cefcd1$var$prefixer = function prefixer(element, index, children, callback) {
    if (element.length > -1) {
        if (!element["return"]) switch(element.type){
            case 0, $17n7v.DECLARATION:
                element["return"] = $2de149c390cefcd1$var$prefix(element.value, element.length);
                break;
            case 0, $17n7v.KEYFRAMES:
                return (0, $17n7v.serialize)([
                    (0, $17n7v.copy)(element, {
                        value: (0, $17n7v.replace)(element.value, "@", "@" + (0, $17n7v.WEBKIT))
                    })
                ], callback);
            case 0, $17n7v.RULESET:
                if (element.length) return (0, $17n7v.combine)(element.props, function(value) {
                    switch((0, $17n7v.match)(value, /(::plac\w+|:read-\w+)/)){
                        // :read-(only|write)
                        case ":read-only":
                        case ":read-write":
                            return (0, $17n7v.serialize)([
                                (0, $17n7v.copy)(element, {
                                    props: [
                                        (0, $17n7v.replace)(value, /:(read-\w+)/, ":" + (0, $17n7v.MOZ) + "$1")
                                    ]
                                })
                            ], callback);
                        // :placeholder
                        case "::placeholder":
                            return (0, $17n7v.serialize)([
                                (0, $17n7v.copy)(element, {
                                    props: [
                                        (0, $17n7v.replace)(value, /:(plac\w+)/, ":" + (0, $17n7v.WEBKIT) + "input-$1")
                                    ]
                                }),
                                (0, $17n7v.copy)(element, {
                                    props: [
                                        (0, $17n7v.replace)(value, /:(plac\w+)/, ":" + (0, $17n7v.MOZ) + "$1")
                                    ]
                                }),
                                (0, $17n7v.copy)(element, {
                                    props: [
                                        (0, $17n7v.replace)(value, /:(plac\w+)/, (0, $17n7v.MS) + "input-$1")
                                    ]
                                })
                            ], callback);
                    }
                    return "";
                });
        }
    }
};
var $2de149c390cefcd1$var$defaultStylisPlugins = [
    $2de149c390cefcd1$var$prefixer
];
var $2de149c390cefcd1$export$2e2bcd8739ae039 = function /*: EmotionCache */ createCache(options) {
    var key = options.key;
    if (key === "css") {
        var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
        // document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
        // note this very very intentionally targets all style elements regardless of the key to ensure
        // that creating a cache works inside of render of a React component
        Array.prototype.forEach.call(ssrStyles, function(node) {
            // we want to only move elements which have a space in the data-emotion attribute value
            // because that indicates that it is an Emotion 11 server-side rendered style elements
            // while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
            // Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
            // so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
            // will not result in the Emotion 10 styles being destroyed
            var dataEmotionAttribute = node.getAttribute("data-emotion");
            if (dataEmotionAttribute.indexOf(" ") === -1) return;
            document.head.appendChild(node);
            node.setAttribute("data-s", "");
        });
    }
    var stylisPlugins = options.stylisPlugins || $2de149c390cefcd1$var$defaultStylisPlugins;
    var inserted = {};
    var container;
    /* : Node */ var nodesToHydrate = [];
    container = options.container || document.head;
    Array.prototype.forEach.call(// means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll('style[data-emotion^="' + key + ' "]'), function(node) {
        var attrib = node.getAttribute("data-emotion").split(" ");
        for(var i = 1; i < attrib.length; i++)inserted[attrib[i]] = true;
        nodesToHydrate.push(node);
    });
    var _insert;
    /*: (
  selector: string,
  serialized: SerializedStyles,
  sheet: StyleSheet,
  shouldCache: boolean
  ) => string | void */ var omnipresentPlugins = [
        $2de149c390cefcd1$var$compat,
        $2de149c390cefcd1$var$removeLabel
    ];
    var currentSheet;
    var finalizingPlugins = [
        (0, $17n7v.stringify),
        (0, $17n7v.rulesheet)(function(rule) {
            currentSheet.insert(rule);
        })
    ];
    var serializer = (0, $17n7v.middleware)(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));
    var stylis = function stylis(styles) {
        return (0, $17n7v.serialize)((0, $17n7v.compile)(styles), serializer);
    };
    _insert = function /*: void */ insert(selector, serialized, sheet, shouldCache) {
        currentSheet = sheet;
        stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
        if (shouldCache) cache.inserted[serialized.name] = true;
    };
    var cache = {
        key: key,
        sheet: new (0, $7nt93.StyleSheet)({
            key: key,
            container: container,
            nonce: options.nonce,
            speedy: options.speedy,
            prepend: options.prepend,
            insertionPoint: options.insertionPoint
        }),
        nonce: options.nonce,
        inserted: inserted,
        registered: {},
        insert: _insert
    };
    cache.sheet.hydrate(nodesToHydrate);
    return cache;
};

});
parcelRegister("7nt93", function(module, exports) {

$parcel$export(module.exports, "StyleSheet", function () { return $55f149fc637bada8$export$9d753cd7ae895cce; });
var $55f149fc637bada8$var$isDevelopment = false;
/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/ function $55f149fc637bada8$var$sheetForTag(tag) {
    if (tag.sheet) return tag.sheet;
     // this weirdness brought to you by firefox
    /* istanbul ignore next */ for(var i = 0; i < document.styleSheets.length; i++){
        if (document.styleSheets[i].ownerNode === tag) return document.styleSheets[i];
    } // this function should always return with a value
    // TS can't understand it though so we make it stop complaining here
    return undefined;
}
function $55f149fc637bada8$var$createStyleElement(options) {
    var tag = document.createElement("style");
    tag.setAttribute("data-emotion", options.key);
    if (options.nonce !== undefined) tag.setAttribute("nonce", options.nonce);
    tag.appendChild(document.createTextNode(""));
    tag.setAttribute("data-s", "");
    return tag;
}
var $55f149fc637bada8$export$9d753cd7ae895cce = /*#__PURE__*/ function() {
    // Using Node instead of HTMLElement since container may be a ShadowRoot
    function StyleSheet(options) {
        var _this = this;
        this._insertTag = function(tag) {
            var before;
            if (_this.tags.length === 0) {
                if (_this.insertionPoint) before = _this.insertionPoint.nextSibling;
                else if (_this.prepend) before = _this.container.firstChild;
                else before = _this.before;
            } else before = _this.tags[_this.tags.length - 1].nextSibling;
            _this.container.insertBefore(tag, before);
            _this.tags.push(tag);
        };
        this.isSpeedy = options.speedy === undefined ? !$55f149fc637bada8$var$isDevelopment : options.speedy;
        this.tags = [];
        this.ctr = 0;
        this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets
        this.key = options.key;
        this.container = options.container;
        this.prepend = options.prepend;
        this.insertionPoint = options.insertionPoint;
        this.before = null;
    }
    var _proto = StyleSheet.prototype;
    _proto.hydrate = function hydrate(nodes) {
        nodes.forEach(this._insertTag);
    };
    _proto.insert = function insert(rule) {
        // the max length is how many rules we have per style tag, it's 65000 in speedy mode
        // it's 1 in dev because we insert source maps that map a single rule to a location
        // and you can only have one source map per style tag
        if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) this._insertTag($55f149fc637bada8$var$createStyleElement(this));
        var tag = this.tags[this.tags.length - 1];
        if (this.isSpeedy) {
            var sheet = $55f149fc637bada8$var$sheetForTag(tag);
            try {
                // this is the ultrafast version, works across browsers
                // the big drawback is that the css won't be editable in devtools
                sheet.insertRule(rule, sheet.cssRules.length);
            } catch (e) {}
        } else tag.appendChild(document.createTextNode(rule));
        this.ctr++;
    };
    _proto.flush = function flush() {
        this.tags.forEach(function(tag) {
            var _tag$parentNode;
            return (_tag$parentNode = tag.parentNode) == null ? void 0 : _tag$parentNode.removeChild(tag);
        });
        this.tags = [];
        this.ctr = 0;
    };
    return StyleSheet;
}();

});

parcelRegister("17n7v", function(module, exports) {

$parcel$export(module.exports, "MS", function () { return $0df3b0b2864d92e9$export$71ad59f2e432cfe8; });
$parcel$export(module.exports, "MOZ", function () { return $0df3b0b2864d92e9$export$2c0f367103c8d01c; });
$parcel$export(module.exports, "WEBKIT", function () { return $0df3b0b2864d92e9$export$39dfd62a25e0fe93; });
$parcel$export(module.exports, "RULESET", function () { return $0df3b0b2864d92e9$export$aa3a2e812ca8570d; });
$parcel$export(module.exports, "DECLARATION", function () { return $0df3b0b2864d92e9$export$527d108ccf083c2b; });
$parcel$export(module.exports, "KEYFRAMES", function () { return $0df3b0b2864d92e9$export$b44a8529a35fcb60; });
$parcel$export(module.exports, "from", function () { return $0df3b0b2864d92e9$export$6788812c4e6611e6; });
$parcel$export(module.exports, "hash", function () { return $0df3b0b2864d92e9$export$d6af199866bfb566; });
$parcel$export(module.exports, "charat", function () { return $0df3b0b2864d92e9$export$a9db5e087081082d; });
$parcel$export(module.exports, "match", function () { return $0df3b0b2864d92e9$export$4659b591c19bdf3d; });
$parcel$export(module.exports, "replace", function () { return $0df3b0b2864d92e9$export$77ad94ebf1c2b9ed; });
$parcel$export(module.exports, "indexof", function () { return $0df3b0b2864d92e9$export$f8e21b1e77979a08; });
$parcel$export(module.exports, "strlen", function () { return $0df3b0b2864d92e9$export$36776f635604f274; });
$parcel$export(module.exports, "combine", function () { return $0df3b0b2864d92e9$export$1be1fc439b849fdf; });
$parcel$export(module.exports, "position", function () { return $0df3b0b2864d92e9$export$5880b8b5730aff45; });
$parcel$export(module.exports, "copy", function () { return $0df3b0b2864d92e9$export$784d13d8ee351f07; });
$parcel$export(module.exports, "next", function () { return $0df3b0b2864d92e9$export$48cfd1e771a65c4f; });
$parcel$export(module.exports, "peek", function () { return $0df3b0b2864d92e9$export$4d3fb11e950abb9e; });
$parcel$export(module.exports, "slice", function () { return $0df3b0b2864d92e9$export$58adb3bec8346d0f; });
$parcel$export(module.exports, "token", function () { return $0df3b0b2864d92e9$export$9e1725a4cfeada27; });
$parcel$export(module.exports, "alloc", function () { return $0df3b0b2864d92e9$export$2de70f21292aac9e; });
$parcel$export(module.exports, "dealloc", function () { return $0df3b0b2864d92e9$export$45918ac1574455b1; });
$parcel$export(module.exports, "delimit", function () { return $0df3b0b2864d92e9$export$410ac95b9ec204b8; });
$parcel$export(module.exports, "compile", function () { return $0df3b0b2864d92e9$export$ef7acd7185315e22; });
$parcel$export(module.exports, "serialize", function () { return $0df3b0b2864d92e9$export$dfdc1655ccc5b9cb; });
$parcel$export(module.exports, "stringify", function () { return $0df3b0b2864d92e9$export$fac44ee5b035f737; });
$parcel$export(module.exports, "middleware", function () { return $0df3b0b2864d92e9$export$5a7767152ae0305f; });
$parcel$export(module.exports, "rulesheet", function () { return $0df3b0b2864d92e9$export$38bcb760f1d4871c; });
var $0df3b0b2864d92e9$export$71ad59f2e432cfe8 = "-ms-";
var $0df3b0b2864d92e9$export$2c0f367103c8d01c = "-moz-";
var $0df3b0b2864d92e9$export$39dfd62a25e0fe93 = "-webkit-";
var $0df3b0b2864d92e9$export$a29989082612d0d9 = "comm";
var $0df3b0b2864d92e9$export$aa3a2e812ca8570d = "rule";
var $0df3b0b2864d92e9$export$527d108ccf083c2b = "decl";
var $0df3b0b2864d92e9$export$d3d35020fa5b54f0 = "@page";
var $0df3b0b2864d92e9$export$500415a86c544f73 = "@media";
var $0df3b0b2864d92e9$export$a763edbf796b780a = "@import";
var $0df3b0b2864d92e9$export$2790aeb8b4e5c826 = "@charset";
var $0df3b0b2864d92e9$export$1cc683e23b84b133 = "@viewport";
var $0df3b0b2864d92e9$export$9447a5efea57e862 = "@supports";
var $0df3b0b2864d92e9$export$ef011b4e114b1fba = "@document";
var $0df3b0b2864d92e9$export$6aad947bda0f3f46 = "@namespace";
var $0df3b0b2864d92e9$export$b44a8529a35fcb60 = "@keyframes";
var $0df3b0b2864d92e9$export$2c16de31893252e6 = "@font-face";
var $0df3b0b2864d92e9$export$3d846dd52e150c6f = "@counter-style";
var $0df3b0b2864d92e9$export$22314bfbb57653fe = "@font-feature-values";
var $0df3b0b2864d92e9$export$d773506282b3cfe6 = "@layer";
var $0df3b0b2864d92e9$export$2335f513bbd82c6d = Math.abs;
var $0df3b0b2864d92e9$export$6788812c4e6611e6 = String.fromCharCode;
var $0df3b0b2864d92e9$export$e6e34fd1f2686227 = Object.assign;
function $0df3b0b2864d92e9$export$d6af199866bfb566(e, r) {
    return $0df3b0b2864d92e9$export$a9db5e087081082d(e, 0) ^ 45 ? (((r << 2 ^ $0df3b0b2864d92e9$export$a9db5e087081082d(e, 0)) << 2 ^ $0df3b0b2864d92e9$export$a9db5e087081082d(e, 1)) << 2 ^ $0df3b0b2864d92e9$export$a9db5e087081082d(e, 2)) << 2 ^ $0df3b0b2864d92e9$export$a9db5e087081082d(e, 3) : 0;
}
function $0df3b0b2864d92e9$export$87c2784dc9fc4ab(e) {
    return e.trim();
}
function $0df3b0b2864d92e9$export$4659b591c19bdf3d(e, r) {
    return (e = r.exec(e)) ? e[0] : e;
}
function $0df3b0b2864d92e9$export$77ad94ebf1c2b9ed(e, r, a) {
    return e.replace(r, a);
}
function $0df3b0b2864d92e9$export$f8e21b1e77979a08(e, r) {
    return e.indexOf(r);
}
function $0df3b0b2864d92e9$export$a9db5e087081082d(e, r) {
    return e.charCodeAt(r) | 0;
}
function $0df3b0b2864d92e9$export$2f35ab04d2335697(e, r, a) {
    return e.slice(r, a);
}
function $0df3b0b2864d92e9$export$36776f635604f274(e) {
    return e.length;
}
function $0df3b0b2864d92e9$export$f9084667e487ed46(e) {
    return e.length;
}
function $0df3b0b2864d92e9$export$10d8903dec122b9d(e, r) {
    return r.push(e), e;
}
function $0df3b0b2864d92e9$export$1be1fc439b849fdf(e, r) {
    return e.map(r).join("");
}
var $0df3b0b2864d92e9$export$53f1d5ea8de3d7c = 1;
var $0df3b0b2864d92e9$export$4e0c71f277ca26b3 = 1;
var $0df3b0b2864d92e9$export$f24224f1c91d8156 = 0;
var $0df3b0b2864d92e9$export$5880b8b5730aff45 = 0;
var $0df3b0b2864d92e9$export$c0306caf338ac095 = 0;
var $0df3b0b2864d92e9$export$30a86d91af8ff6e6 = "";
function $0df3b0b2864d92e9$export$35059013cd4a06db(e, r, a, n, c, s, t) {
    return {
        value: e,
        root: r,
        parent: a,
        type: n,
        props: c,
        children: s,
        line: $0df3b0b2864d92e9$export$53f1d5ea8de3d7c,
        column: $0df3b0b2864d92e9$export$4e0c71f277ca26b3,
        length: t,
        return: ""
    };
}
function $0df3b0b2864d92e9$export$784d13d8ee351f07(e, r) {
    return $0df3b0b2864d92e9$export$e6e34fd1f2686227($0df3b0b2864d92e9$export$35059013cd4a06db("", null, null, "", null, null, 0), e, {
        length: -e.length
    }, r);
}
function $0df3b0b2864d92e9$export$eba6f6f03b0a92e7() {
    return $0df3b0b2864d92e9$export$c0306caf338ac095;
}
function $0df3b0b2864d92e9$export$232faf9add678146() {
    $0df3b0b2864d92e9$export$c0306caf338ac095 = $0df3b0b2864d92e9$export$5880b8b5730aff45 > 0 ? $0df3b0b2864d92e9$export$a9db5e087081082d($0df3b0b2864d92e9$export$30a86d91af8ff6e6, --$0df3b0b2864d92e9$export$5880b8b5730aff45) : 0;
    if ($0df3b0b2864d92e9$export$4e0c71f277ca26b3--, $0df3b0b2864d92e9$export$c0306caf338ac095 === 10) $0df3b0b2864d92e9$export$4e0c71f277ca26b3 = 1, $0df3b0b2864d92e9$export$53f1d5ea8de3d7c--;
    return $0df3b0b2864d92e9$export$c0306caf338ac095;
}
function $0df3b0b2864d92e9$export$48cfd1e771a65c4f() {
    $0df3b0b2864d92e9$export$c0306caf338ac095 = $0df3b0b2864d92e9$export$5880b8b5730aff45 < $0df3b0b2864d92e9$export$f24224f1c91d8156 ? $0df3b0b2864d92e9$export$a9db5e087081082d($0df3b0b2864d92e9$export$30a86d91af8ff6e6, $0df3b0b2864d92e9$export$5880b8b5730aff45++) : 0;
    if ($0df3b0b2864d92e9$export$4e0c71f277ca26b3++, $0df3b0b2864d92e9$export$c0306caf338ac095 === 10) $0df3b0b2864d92e9$export$4e0c71f277ca26b3 = 1, $0df3b0b2864d92e9$export$53f1d5ea8de3d7c++;
    return $0df3b0b2864d92e9$export$c0306caf338ac095;
}
function $0df3b0b2864d92e9$export$4d3fb11e950abb9e() {
    return $0df3b0b2864d92e9$export$a9db5e087081082d($0df3b0b2864d92e9$export$30a86d91af8ff6e6, $0df3b0b2864d92e9$export$5880b8b5730aff45);
}
function $0df3b0b2864d92e9$export$e88cb2efb12ae807() {
    return $0df3b0b2864d92e9$export$5880b8b5730aff45;
}
function $0df3b0b2864d92e9$export$58adb3bec8346d0f(e, r) {
    return $0df3b0b2864d92e9$export$2f35ab04d2335697($0df3b0b2864d92e9$export$30a86d91af8ff6e6, e, r);
}
function $0df3b0b2864d92e9$export$9e1725a4cfeada27(e) {
    switch(e){
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
            return 5;
        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        case 59:
        case 123:
        case 125:
            return 4;
        case 58:
            return 3;
        case 34:
        case 39:
        case 40:
        case 91:
            return 2;
        case 41:
        case 93:
            return 1;
    }
    return 0;
}
function $0df3b0b2864d92e9$export$2de70f21292aac9e(e) {
    return $0df3b0b2864d92e9$export$53f1d5ea8de3d7c = $0df3b0b2864d92e9$export$4e0c71f277ca26b3 = 1, $0df3b0b2864d92e9$export$f24224f1c91d8156 = $0df3b0b2864d92e9$export$36776f635604f274($0df3b0b2864d92e9$export$30a86d91af8ff6e6 = e), $0df3b0b2864d92e9$export$5880b8b5730aff45 = 0, [];
}
function $0df3b0b2864d92e9$export$45918ac1574455b1(e) {
    return $0df3b0b2864d92e9$export$30a86d91af8ff6e6 = "", e;
}
function $0df3b0b2864d92e9$export$410ac95b9ec204b8(e) {
    return $0df3b0b2864d92e9$export$87c2784dc9fc4ab($0df3b0b2864d92e9$export$58adb3bec8346d0f($0df3b0b2864d92e9$export$5880b8b5730aff45 - 1, $0df3b0b2864d92e9$export$c889f2fcc19dbf12(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function $0df3b0b2864d92e9$export$660b2ee2d4fb4eff(e) {
    return $0df3b0b2864d92e9$export$45918ac1574455b1($0df3b0b2864d92e9$export$5f8c09e3ae6f64e1($0df3b0b2864d92e9$export$2de70f21292aac9e(e)));
}
function $0df3b0b2864d92e9$export$7af1228ff777d175(e) {
    while($0df3b0b2864d92e9$export$c0306caf338ac095 = $0df3b0b2864d92e9$export$4d3fb11e950abb9e())if ($0df3b0b2864d92e9$export$c0306caf338ac095 < 33) $0df3b0b2864d92e9$export$48cfd1e771a65c4f();
    else break;
    return $0df3b0b2864d92e9$export$9e1725a4cfeada27(e) > 2 || $0df3b0b2864d92e9$export$9e1725a4cfeada27($0df3b0b2864d92e9$export$c0306caf338ac095) > 3 ? "" : " ";
}
function $0df3b0b2864d92e9$export$5f8c09e3ae6f64e1(e) {
    while($0df3b0b2864d92e9$export$48cfd1e771a65c4f())switch($0df3b0b2864d92e9$export$9e1725a4cfeada27($0df3b0b2864d92e9$export$c0306caf338ac095)){
        case 0:
            $0df3b0b2864d92e9$export$10d8903dec122b9d($0df3b0b2864d92e9$export$c2ab62c7bf24634($0df3b0b2864d92e9$export$5880b8b5730aff45 - 1), e);
            break;
        case 2:
            $0df3b0b2864d92e9$export$10d8903dec122b9d($0df3b0b2864d92e9$export$410ac95b9ec204b8($0df3b0b2864d92e9$export$c0306caf338ac095), e);
            break;
        default:
            $0df3b0b2864d92e9$export$10d8903dec122b9d($0df3b0b2864d92e9$export$6788812c4e6611e6($0df3b0b2864d92e9$export$c0306caf338ac095), e);
    }
    return e;
}
function $0df3b0b2864d92e9$export$955ba06d119e085e(e, r) {
    while(--r && $0df3b0b2864d92e9$export$48cfd1e771a65c4f())if ($0df3b0b2864d92e9$export$c0306caf338ac095 < 48 || $0df3b0b2864d92e9$export$c0306caf338ac095 > 102 || $0df3b0b2864d92e9$export$c0306caf338ac095 > 57 && $0df3b0b2864d92e9$export$c0306caf338ac095 < 65 || $0df3b0b2864d92e9$export$c0306caf338ac095 > 70 && $0df3b0b2864d92e9$export$c0306caf338ac095 < 97) break;
    return $0df3b0b2864d92e9$export$58adb3bec8346d0f(e, $0df3b0b2864d92e9$export$e88cb2efb12ae807() + (r < 6 && $0df3b0b2864d92e9$export$4d3fb11e950abb9e() == 32 && $0df3b0b2864d92e9$export$48cfd1e771a65c4f() == 32));
}
function $0df3b0b2864d92e9$export$c889f2fcc19dbf12(e) {
    while($0df3b0b2864d92e9$export$48cfd1e771a65c4f())switch($0df3b0b2864d92e9$export$c0306caf338ac095){
        case e:
            return $0df3b0b2864d92e9$export$5880b8b5730aff45;
        case 34:
        case 39:
            if (e !== 34 && e !== 39) $0df3b0b2864d92e9$export$c889f2fcc19dbf12($0df3b0b2864d92e9$export$c0306caf338ac095);
            break;
        case 40:
            if (e === 41) $0df3b0b2864d92e9$export$c889f2fcc19dbf12(e);
            break;
        case 92:
            $0df3b0b2864d92e9$export$48cfd1e771a65c4f();
            break;
    }
    return $0df3b0b2864d92e9$export$5880b8b5730aff45;
}
function $0df3b0b2864d92e9$export$4254d4e2b3745c4c(e, r) {
    while($0df3b0b2864d92e9$export$48cfd1e771a65c4f())if (e + $0df3b0b2864d92e9$export$c0306caf338ac095 === 57) break;
    else if (e + $0df3b0b2864d92e9$export$c0306caf338ac095 === 84 && $0df3b0b2864d92e9$export$4d3fb11e950abb9e() === 47) break;
    return "/*" + $0df3b0b2864d92e9$export$58adb3bec8346d0f(r, $0df3b0b2864d92e9$export$5880b8b5730aff45 - 1) + "*" + $0df3b0b2864d92e9$export$6788812c4e6611e6(e === 47 ? e : $0df3b0b2864d92e9$export$48cfd1e771a65c4f());
}
function $0df3b0b2864d92e9$export$c2ab62c7bf24634(e) {
    while(!$0df3b0b2864d92e9$export$9e1725a4cfeada27($0df3b0b2864d92e9$export$4d3fb11e950abb9e()))$0df3b0b2864d92e9$export$48cfd1e771a65c4f();
    return $0df3b0b2864d92e9$export$58adb3bec8346d0f(e, $0df3b0b2864d92e9$export$5880b8b5730aff45);
}
function $0df3b0b2864d92e9$export$ef7acd7185315e22(e) {
    return $0df3b0b2864d92e9$export$45918ac1574455b1($0df3b0b2864d92e9$export$98e6a39c04603d36("", null, null, null, [
        ""
    ], e = $0df3b0b2864d92e9$export$2de70f21292aac9e(e), 0, [
        0
    ], e));
}
function $0df3b0b2864d92e9$export$98e6a39c04603d36(e, r, a, n, c, s, t, u, i) {
    var f = 0;
    var o = 0;
    var l = t;
    var v = 0;
    var p = 0;
    var h = 0;
    var b = 1;
    var w = 1;
    var d = 1;
    var $ = 0;
    var g = "";
    var m = c;
    var x = s;
    var y = n;
    var j = g;
    while(w)switch(h = $, $ = $0df3b0b2864d92e9$export$48cfd1e771a65c4f()){
        case 40:
            if (h != 108 && $0df3b0b2864d92e9$export$a9db5e087081082d(j, l - 1) == 58) {
                if ($0df3b0b2864d92e9$export$f8e21b1e77979a08(j += $0df3b0b2864d92e9$export$77ad94ebf1c2b9ed($0df3b0b2864d92e9$export$410ac95b9ec204b8($), "&", "&\f"), "&\f") != -1) d = -1;
                break;
            }
        case 34:
        case 39:
        case 91:
            j += $0df3b0b2864d92e9$export$410ac95b9ec204b8($);
            break;
        case 9:
        case 10:
        case 13:
        case 32:
            j += $0df3b0b2864d92e9$export$7af1228ff777d175(h);
            break;
        case 92:
            j += $0df3b0b2864d92e9$export$955ba06d119e085e($0df3b0b2864d92e9$export$e88cb2efb12ae807() - 1, 7);
            continue;
        case 47:
            switch($0df3b0b2864d92e9$export$4d3fb11e950abb9e()){
                case 42:
                case 47:
                    $0df3b0b2864d92e9$export$10d8903dec122b9d($0df3b0b2864d92e9$export$4a34f930e789283c($0df3b0b2864d92e9$export$4254d4e2b3745c4c($0df3b0b2864d92e9$export$48cfd1e771a65c4f(), $0df3b0b2864d92e9$export$e88cb2efb12ae807()), r, a), i);
                    break;
                default:
                    j += "/";
            }
            break;
        case 123 * b:
            u[f++] = $0df3b0b2864d92e9$export$36776f635604f274(j) * d;
        case 125 * b:
        case 59:
        case 0:
            switch($){
                case 0:
                case 125:
                    w = 0;
                case 59 + o:
                    if (d == -1) j = $0df3b0b2864d92e9$export$77ad94ebf1c2b9ed(j, /\f/g, "");
                    if (p > 0 && $0df3b0b2864d92e9$export$36776f635604f274(j) - l) $0df3b0b2864d92e9$export$10d8903dec122b9d(p > 32 ? $0df3b0b2864d92e9$export$f8483753829ec8f3(j + ";", n, a, l - 1) : $0df3b0b2864d92e9$export$f8483753829ec8f3($0df3b0b2864d92e9$export$77ad94ebf1c2b9ed(j, " ", "") + ";", n, a, l - 2), i);
                    break;
                case 59:
                    j += ";";
                default:
                    $0df3b0b2864d92e9$export$10d8903dec122b9d(y = $0df3b0b2864d92e9$export$3307ffa7023ede1e(j, r, a, f, o, c, u, g, m = [], x = [], l), s);
                    if ($ === 123) {
                        if (o === 0) $0df3b0b2864d92e9$export$98e6a39c04603d36(j, r, y, y, m, s, l, u, x);
                        else switch(v === 99 && $0df3b0b2864d92e9$export$a9db5e087081082d(j, 3) === 110 ? 100 : v){
                            case 100:
                            case 108:
                            case 109:
                            case 115:
                                $0df3b0b2864d92e9$export$98e6a39c04603d36(e, y, y, n && $0df3b0b2864d92e9$export$10d8903dec122b9d($0df3b0b2864d92e9$export$3307ffa7023ede1e(e, y, y, 0, 0, c, u, g, c, m = [], l), x), c, x, l, u, n ? m : x);
                                break;
                            default:
                                $0df3b0b2864d92e9$export$98e6a39c04603d36(j, y, y, y, [
                                    ""
                                ], x, 0, u, x);
                        }
                    }
            }
            f = o = p = 0, b = d = 1, g = j = "", l = t;
            break;
        case 58:
            l = 1 + $0df3b0b2864d92e9$export$36776f635604f274(j), p = h;
        default:
            if (b < 1) {
                if ($ == 123) --b;
                else if ($ == 125 && b++ == 0 && $0df3b0b2864d92e9$export$232faf9add678146() == 125) continue;
            }
            switch(j += $0df3b0b2864d92e9$export$6788812c4e6611e6($), $ * b){
                case 38:
                    d = o > 0 ? 1 : (j += "\f", -1);
                    break;
                case 44:
                    u[f++] = ($0df3b0b2864d92e9$export$36776f635604f274(j) - 1) * d, d = 1;
                    break;
                case 64:
                    if ($0df3b0b2864d92e9$export$4d3fb11e950abb9e() === 45) j += $0df3b0b2864d92e9$export$410ac95b9ec204b8($0df3b0b2864d92e9$export$48cfd1e771a65c4f());
                    v = $0df3b0b2864d92e9$export$4d3fb11e950abb9e(), o = l = $0df3b0b2864d92e9$export$36776f635604f274(g = j += $0df3b0b2864d92e9$export$c2ab62c7bf24634($0df3b0b2864d92e9$export$e88cb2efb12ae807())), $++;
                    break;
                case 45:
                    if (h === 45 && $0df3b0b2864d92e9$export$36776f635604f274(j) == 2) b = 0;
            }
    }
    return s;
}
function $0df3b0b2864d92e9$export$3307ffa7023ede1e(e, r, a, n, s, t, u, i, f, o, l) {
    var v = s - 1;
    var p = s === 0 ? t : [
        ""
    ];
    var h = $0df3b0b2864d92e9$export$f9084667e487ed46(p);
    for(var b = 0, w = 0, d = 0; b < n; ++b)for(var $ = 0, k = $0df3b0b2864d92e9$export$2f35ab04d2335697(e, v + 1, v = $0df3b0b2864d92e9$export$2335f513bbd82c6d(w = u[b])), m = e; $ < h; ++$)if (m = $0df3b0b2864d92e9$export$87c2784dc9fc4ab(w > 0 ? p[$] + " " + k : $0df3b0b2864d92e9$export$77ad94ebf1c2b9ed(k, /&\f/g, p[$]))) f[d++] = m;
    return $0df3b0b2864d92e9$export$35059013cd4a06db(e, r, a, s === 0 ? $0df3b0b2864d92e9$export$aa3a2e812ca8570d : i, f, o, l);
}
function $0df3b0b2864d92e9$export$4a34f930e789283c(e, r, a) {
    return $0df3b0b2864d92e9$export$35059013cd4a06db(e, r, a, $0df3b0b2864d92e9$export$a29989082612d0d9, $0df3b0b2864d92e9$export$6788812c4e6611e6($0df3b0b2864d92e9$export$eba6f6f03b0a92e7()), $0df3b0b2864d92e9$export$2f35ab04d2335697(e, 2, -2), 0);
}
function $0df3b0b2864d92e9$export$f8483753829ec8f3(e, r, a, n) {
    return $0df3b0b2864d92e9$export$35059013cd4a06db(e, r, a, $0df3b0b2864d92e9$export$527d108ccf083c2b, $0df3b0b2864d92e9$export$2f35ab04d2335697(e, 0, n), $0df3b0b2864d92e9$export$2f35ab04d2335697(e, n + 1, -1), n);
}
function $0df3b0b2864d92e9$export$82e9f45cca5ba907(n, c, s) {
    switch($0df3b0b2864d92e9$export$d6af199866bfb566(n, c)){
        case 5103:
            return $0df3b0b2864d92e9$export$39dfd62a25e0fe93 + "print-" + n + n;
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return $0df3b0b2864d92e9$export$39dfd62a25e0fe93 + n + n;
        case 4789:
            return $0df3b0b2864d92e9$export$2c0f367103c8d01c + n + n;
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return $0df3b0b2864d92e9$export$39dfd62a25e0fe93 + n + $0df3b0b2864d92e9$export$2c0f367103c8d01c + n + $0df3b0b2864d92e9$export$71ad59f2e432cfe8 + n + n;
        case 5936:
            switch($0df3b0b2864d92e9$export$a9db5e087081082d(n, c + 11)){
                case 114:
                    return $0df3b0b2864d92e9$export$39dfd62a25e0fe93 + n + $0df3b0b2864d92e9$export$71ad59f2e432cfe8 + $0df3b0b2864d92e9$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb") + n;
                case 108:
                    return $0df3b0b2864d92e9$export$39dfd62a25e0fe93 + n + $0df3b0b2864d92e9$export$71ad59f2e432cfe8 + $0df3b0b2864d92e9$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb-rl") + n;
                case 45:
                    return $0df3b0b2864d92e9$export$39dfd62a25e0fe93 + n + $0df3b0b2864d92e9$export$71ad59f2e432cfe8 + $0df3b0b2864d92e9$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "lr") + n;
            }
        case 6828:
        case 4268:
        case 2903:
            return $0df3b0b2864d92e9$export$39dfd62a25e0fe93 + n + $0df3b0b2864d92e9$export$71ad59f2e432cfe8 + n + n;
        case 6165:
            return $0df3b0b2864d92e9$export$39dfd62a25e0fe93 + n + $0df3b0b2864d92e9$export$71ad59f2e432cfe8 + "flex-" + n + n;
        case 5187:
            return $0df3b0b2864d92e9$export$39dfd62a25e0fe93 + n + $0df3b0b2864d92e9$export$77ad94ebf1c2b9ed(n, /(\w+).+(:[^]+)/, $0df3b0b2864d92e9$export$39dfd62a25e0fe93 + "box-$1$2" + $0df3b0b2864d92e9$export$71ad59f2e432cfe8 + "flex-$1$2") + n;
        case 5443:
            return $0df3b0b2864d92e9$export$39dfd62a25e0fe93 + n + $0df3b0b2864d92e9$export$71ad59f2e432cfe8 + "flex-item-" + $0df3b0b2864d92e9$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") + (!$0df3b0b2864d92e9$export$4659b591c19bdf3d(n, /flex-|baseline/) ? $0df3b0b2864d92e9$export$71ad59f2e432cfe8 + "grid-row-" + $0df3b0b2864d92e9$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") : "") + n;
        case 4675:
            return $0df3b0b2864d92e9$export$39dfd62a25e0fe93 + n + $0df3b0b2864d92e9$export$71ad59f2e432cfe8 + "flex-line-pack" + $0df3b0b2864d92e9$export$77ad94ebf1c2b9ed(n, /align-content|flex-|-self/g, "") + n;
        case 5548:
            return $0df3b0b2864d92e9$export$39dfd62a25e0fe93 + n + $0df3b0b2864d92e9$export$71ad59f2e432cfe8 + $0df3b0b2864d92e9$export$77ad94ebf1c2b9ed(n, "shrink", "negative") + n;
        case 5292:
            return $0df3b0b2864d92e9$export$39dfd62a25e0fe93 + n + $0df3b0b2864d92e9$export$71ad59f2e432cfe8 + $0df3b0b2864d92e9$export$77ad94ebf1c2b9ed(n, "basis", "preferred-size") + n;
        case 6060:
            return $0df3b0b2864d92e9$export$39dfd62a25e0fe93 + "box-" + $0df3b0b2864d92e9$export$77ad94ebf1c2b9ed(n, "-grow", "") + $0df3b0b2864d92e9$export$39dfd62a25e0fe93 + n + $0df3b0b2864d92e9$export$71ad59f2e432cfe8 + $0df3b0b2864d92e9$export$77ad94ebf1c2b9ed(n, "grow", "positive") + n;
        case 4554:
            return $0df3b0b2864d92e9$export$39dfd62a25e0fe93 + $0df3b0b2864d92e9$export$77ad94ebf1c2b9ed(n, /([^-])(transform)/g, "$1" + $0df3b0b2864d92e9$export$39dfd62a25e0fe93 + "$2") + n;
        case 6187:
            return $0df3b0b2864d92e9$export$77ad94ebf1c2b9ed($0df3b0b2864d92e9$export$77ad94ebf1c2b9ed($0df3b0b2864d92e9$export$77ad94ebf1c2b9ed(n, /(zoom-|grab)/, $0df3b0b2864d92e9$export$39dfd62a25e0fe93 + "$1"), /(image-set)/, $0df3b0b2864d92e9$export$39dfd62a25e0fe93 + "$1"), n, "") + n;
        case 5495:
        case 3959:
            return $0df3b0b2864d92e9$export$77ad94ebf1c2b9ed(n, /(image-set\([^]*)/, $0df3b0b2864d92e9$export$39dfd62a25e0fe93 + "$1" + "$`$1");
        case 4968:
            return $0df3b0b2864d92e9$export$77ad94ebf1c2b9ed($0df3b0b2864d92e9$export$77ad94ebf1c2b9ed(n, /(.+:)(flex-)?(.*)/, $0df3b0b2864d92e9$export$39dfd62a25e0fe93 + "box-pack:$3" + $0df3b0b2864d92e9$export$71ad59f2e432cfe8 + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + $0df3b0b2864d92e9$export$39dfd62a25e0fe93 + n + n;
        case 4200:
            if (!$0df3b0b2864d92e9$export$4659b591c19bdf3d(n, /flex-|baseline/)) return $0df3b0b2864d92e9$export$71ad59f2e432cfe8 + "grid-column-align" + $0df3b0b2864d92e9$export$2f35ab04d2335697(n, c) + n;
            break;
        case 2592:
        case 3360:
            return $0df3b0b2864d92e9$export$71ad59f2e432cfe8 + $0df3b0b2864d92e9$export$77ad94ebf1c2b9ed(n, "template-", "") + n;
        case 4384:
        case 3616:
            if (s && s.some(function(e, r) {
                return c = r, $0df3b0b2864d92e9$export$4659b591c19bdf3d(e.props, /grid-\w+-end/);
            })) return ~$0df3b0b2864d92e9$export$f8e21b1e77979a08(n + (s = s[c].value), "span") ? n : $0df3b0b2864d92e9$export$71ad59f2e432cfe8 + $0df3b0b2864d92e9$export$77ad94ebf1c2b9ed(n, "-start", "") + n + $0df3b0b2864d92e9$export$71ad59f2e432cfe8 + "grid-row-span:" + (~$0df3b0b2864d92e9$export$f8e21b1e77979a08(s, "span") ? $0df3b0b2864d92e9$export$4659b591c19bdf3d(s, /\d+/) : +$0df3b0b2864d92e9$export$4659b591c19bdf3d(s, /\d+/) - +$0df3b0b2864d92e9$export$4659b591c19bdf3d(n, /\d+/)) + ";";
            return $0df3b0b2864d92e9$export$71ad59f2e432cfe8 + $0df3b0b2864d92e9$export$77ad94ebf1c2b9ed(n, "-start", "") + n;
        case 4896:
        case 4128:
            return s && s.some(function(e) {
                return $0df3b0b2864d92e9$export$4659b591c19bdf3d(e.props, /grid-\w+-start/);
            }) ? n : $0df3b0b2864d92e9$export$71ad59f2e432cfe8 + $0df3b0b2864d92e9$export$77ad94ebf1c2b9ed($0df3b0b2864d92e9$export$77ad94ebf1c2b9ed(n, "-end", "-span"), "span ", "") + n;
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return $0df3b0b2864d92e9$export$77ad94ebf1c2b9ed(n, /(.+)-inline(.+)/, $0df3b0b2864d92e9$export$39dfd62a25e0fe93 + "$1$2") + n;
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            if ($0df3b0b2864d92e9$export$36776f635604f274(n) - 1 - c > 6) switch($0df3b0b2864d92e9$export$a9db5e087081082d(n, c + 1)){
                case 109:
                    if ($0df3b0b2864d92e9$export$a9db5e087081082d(n, c + 4) !== 45) break;
                case 102:
                    return $0df3b0b2864d92e9$export$77ad94ebf1c2b9ed(n, /(.+:)(.+)-([^]+)/, "$1" + $0df3b0b2864d92e9$export$39dfd62a25e0fe93 + "$2-$3" + "$1" + $0df3b0b2864d92e9$export$2c0f367103c8d01c + ($0df3b0b2864d92e9$export$a9db5e087081082d(n, c + 3) == 108 ? "$3" : "$2-$3")) + n;
                case 115:
                    return ~$0df3b0b2864d92e9$export$f8e21b1e77979a08(n, "stretch") ? $0df3b0b2864d92e9$export$82e9f45cca5ba907($0df3b0b2864d92e9$export$77ad94ebf1c2b9ed(n, "stretch", "fill-available"), c, s) + n : n;
            }
            break;
        case 5152:
        case 5920:
            return $0df3b0b2864d92e9$export$77ad94ebf1c2b9ed(n, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(r, a, c, s, t, u, i) {
                return $0df3b0b2864d92e9$export$71ad59f2e432cfe8 + a + ":" + c + i + (s ? $0df3b0b2864d92e9$export$71ad59f2e432cfe8 + a + "-span:" + (t ? u : +u - +c) + i : "") + n;
            });
        case 4949:
            if ($0df3b0b2864d92e9$export$a9db5e087081082d(n, c + 6) === 121) return $0df3b0b2864d92e9$export$77ad94ebf1c2b9ed(n, ":", ":" + $0df3b0b2864d92e9$export$39dfd62a25e0fe93) + n;
            break;
        case 6444:
            switch($0df3b0b2864d92e9$export$a9db5e087081082d(n, $0df3b0b2864d92e9$export$a9db5e087081082d(n, 14) === 45 ? 18 : 11)){
                case 120:
                    return $0df3b0b2864d92e9$export$77ad94ebf1c2b9ed(n, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, "$1" + $0df3b0b2864d92e9$export$39dfd62a25e0fe93 + ($0df3b0b2864d92e9$export$a9db5e087081082d(n, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + $0df3b0b2864d92e9$export$39dfd62a25e0fe93 + "$2$3" + "$1" + $0df3b0b2864d92e9$export$71ad59f2e432cfe8 + "$2box$3") + n;
                case 100:
                    return $0df3b0b2864d92e9$export$77ad94ebf1c2b9ed(n, ":", ":" + $0df3b0b2864d92e9$export$71ad59f2e432cfe8) + n;
            }
            break;
        case 5719:
        case 2647:
        case 2135:
        case 3927:
        case 2391:
            return $0df3b0b2864d92e9$export$77ad94ebf1c2b9ed(n, "scroll-", "scroll-snap-") + n;
    }
    return n;
}
function $0df3b0b2864d92e9$export$dfdc1655ccc5b9cb(e, r) {
    var a = "";
    var n = $0df3b0b2864d92e9$export$f9084667e487ed46(e);
    for(var c = 0; c < n; c++)a += r(e[c], c, e, r) || "";
    return a;
}
function $0df3b0b2864d92e9$export$fac44ee5b035f737(e, r, a, t) {
    switch(e.type){
        case $0df3b0b2864d92e9$export$d773506282b3cfe6:
            if (e.children.length) break;
        case $0df3b0b2864d92e9$export$a763edbf796b780a:
        case $0df3b0b2864d92e9$export$527d108ccf083c2b:
            return e.return = e.return || e.value;
        case $0df3b0b2864d92e9$export$a29989082612d0d9:
            return "";
        case $0df3b0b2864d92e9$export$b44a8529a35fcb60:
            return e.return = e.value + "{" + $0df3b0b2864d92e9$export$dfdc1655ccc5b9cb(e.children, t) + "}";
        case $0df3b0b2864d92e9$export$aa3a2e812ca8570d:
            e.value = e.props.join(",");
    }
    return $0df3b0b2864d92e9$export$36776f635604f274(a = $0df3b0b2864d92e9$export$dfdc1655ccc5b9cb(e.children, t)) ? e.return = e.value + "{" + a + "}" : "";
}
function $0df3b0b2864d92e9$export$5a7767152ae0305f(e) {
    var r = $0df3b0b2864d92e9$export$f9084667e487ed46(e);
    return function(a, n, c, s) {
        var t = "";
        for(var u = 0; u < r; u++)t += e[u](a, n, c, s) || "";
        return t;
    };
}
function $0df3b0b2864d92e9$export$38bcb760f1d4871c(e) {
    return function(r) {
        if (!r.root) {
            if (r = r.return) e(r);
        }
    };
}
function $0df3b0b2864d92e9$export$e08c7d021b829b7a(n, t, u, i) {
    if (n.length > -1) {
        if (!n.return) switch(n.type){
            case $0df3b0b2864d92e9$export$527d108ccf083c2b:
                n.return = $0df3b0b2864d92e9$export$82e9f45cca5ba907(n.value, n.length, u);
                return;
            case $0df3b0b2864d92e9$export$b44a8529a35fcb60:
                return $0df3b0b2864d92e9$export$dfdc1655ccc5b9cb([
                    $0df3b0b2864d92e9$export$784d13d8ee351f07(n, {
                        value: $0df3b0b2864d92e9$export$77ad94ebf1c2b9ed(n.value, "@", "@" + $0df3b0b2864d92e9$export$39dfd62a25e0fe93)
                    })
                ], i);
            case $0df3b0b2864d92e9$export$aa3a2e812ca8570d:
                if (n.length) return $0df3b0b2864d92e9$export$1be1fc439b849fdf(n.props, function(c) {
                    switch($0df3b0b2864d92e9$export$4659b591c19bdf3d(c, /(::plac\w+|:read-\w+)/)){
                        case ":read-only":
                        case ":read-write":
                            return $0df3b0b2864d92e9$export$dfdc1655ccc5b9cb([
                                $0df3b0b2864d92e9$export$784d13d8ee351f07(n, {
                                    props: [
                                        $0df3b0b2864d92e9$export$77ad94ebf1c2b9ed(c, /:(read-\w+)/, ":" + $0df3b0b2864d92e9$export$2c0f367103c8d01c + "$1")
                                    ]
                                })
                            ], i);
                        case "::placeholder":
                            return $0df3b0b2864d92e9$export$dfdc1655ccc5b9cb([
                                $0df3b0b2864d92e9$export$784d13d8ee351f07(n, {
                                    props: [
                                        $0df3b0b2864d92e9$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $0df3b0b2864d92e9$export$39dfd62a25e0fe93 + "input-$1")
                                    ]
                                }),
                                $0df3b0b2864d92e9$export$784d13d8ee351f07(n, {
                                    props: [
                                        $0df3b0b2864d92e9$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $0df3b0b2864d92e9$export$2c0f367103c8d01c + "$1")
                                    ]
                                }),
                                $0df3b0b2864d92e9$export$784d13d8ee351f07(n, {
                                    props: [
                                        $0df3b0b2864d92e9$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, $0df3b0b2864d92e9$export$71ad59f2e432cfe8 + "input-$1")
                                    ]
                                })
                            ], i);
                    }
                    return "";
                });
        }
    }
}
function $0df3b0b2864d92e9$export$76a88f7de6507443(e) {
    switch(e.type){
        case $0df3b0b2864d92e9$export$aa3a2e812ca8570d:
            e.props = e.props.map(function(r) {
                return $0df3b0b2864d92e9$export$1be1fc439b849fdf($0df3b0b2864d92e9$export$660b2ee2d4fb4eff(r), function(r, a, n) {
                    switch($0df3b0b2864d92e9$export$a9db5e087081082d(r, 0)){
                        case 12:
                            return $0df3b0b2864d92e9$export$2f35ab04d2335697(r, 1, $0df3b0b2864d92e9$export$36776f635604f274(r));
                        case 0:
                        case 40:
                        case 43:
                        case 62:
                        case 126:
                            return r;
                        case 58:
                            if (n[++a] === "global") n[a] = "", n[++a] = "\f" + $0df3b0b2864d92e9$export$2f35ab04d2335697(n[a], a = 1, -1);
                        case 32:
                            return a === 1 ? "" : r;
                        default:
                            switch(a){
                                case 0:
                                    e = r;
                                    return $0df3b0b2864d92e9$export$f9084667e487ed46(n) > 1 ? "" : r;
                                case a = $0df3b0b2864d92e9$export$f9084667e487ed46(n) - 1:
                                case 2:
                                    return a === 2 ? r + e + e : r + e;
                                default:
                                    return r;
                            }
                    }
                });
            });
    }
}

});

parcelRegister("1Pk4E", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $154a202a875b35dd$export$2e2bcd8739ae039; });
var $154a202a875b35dd$export$2e2bcd8739ae039 = function weakMemoize(func) {
    var cache = new WeakMap();
    return function(arg) {
        if (cache.has(arg)) // Use non-null assertion because we just checked that the cache `has` it
        // This allows us to remove `undefined` from the return value
        return cache.get(arg);
        var ret = func(arg);
        cache.set(arg, ret);
        return ret;
    };
};

});

parcelRegister("8cVSc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5f9c561f8cc1b03e$export$2e2bcd8739ae039; });
function $5f9c561f8cc1b03e$export$2e2bcd8739ae039(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

});


parcelRegister("4dWgq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $31359256ab759f65$export$2e2bcd8739ae039; });
function $31359256ab759f65$export$2e2bcd8739ae039() {
    return $31359256ab759f65$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $31359256ab759f65$export$2e2bcd8739ae039.apply(null, arguments);
}

});

parcelRegister("2Fyhd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1f19ffbac176b0eb$export$2e2bcd8739ae039; });

var $NP1E6 = parcelRequire("NP1E6");
// this file isolates this package that is not tree-shakeable
// and if this module doesn't actually contain any logic of its own
// then Rollup just use 'hoist-non-react-statics' directly in other chunks
var $1f19ffbac176b0eb$export$2e2bcd8739ae039 = function(targetComponent, sourceComponent) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($NP1E6)))(targetComponent, sourceComponent);
};

});
parcelRegister("NP1E6", function(module, exports) {
"use strict";

var $cGNdg = parcelRequire("cGNdg");
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $095c285409a71df1$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $095c285409a71df1$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $095c285409a71df1$var$FORWARD_REF_STATICS = {
    "$$typeof": true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $095c285409a71df1$var$MEMO_STATICS = {
    "$$typeof": true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $095c285409a71df1$var$TYPE_STATICS = {};
$095c285409a71df1$var$TYPE_STATICS[$cGNdg.ForwardRef] = $095c285409a71df1$var$FORWARD_REF_STATICS;
$095c285409a71df1$var$TYPE_STATICS[$cGNdg.Memo] = $095c285409a71df1$var$MEMO_STATICS;
function $095c285409a71df1$var$getStatics(component) {
    // React v16.11 and below
    if ($cGNdg.isMemo(component)) return $095c285409a71df1$var$MEMO_STATICS;
     // React v16.12 and above
    return $095c285409a71df1$var$TYPE_STATICS[component["$$typeof"]] || $095c285409a71df1$var$REACT_STATICS;
}
var $095c285409a71df1$var$defineProperty = Object.defineProperty;
var $095c285409a71df1$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $095c285409a71df1$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $095c285409a71df1$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $095c285409a71df1$var$getPrototypeOf = Object.getPrototypeOf;
var $095c285409a71df1$var$objectPrototype = Object.prototype;
function $095c285409a71df1$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== "string") {
        // don't hoist over string (html) components
        if ($095c285409a71df1$var$objectPrototype) {
            var inheritedComponent = $095c285409a71df1$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $095c285409a71df1$var$objectPrototype) $095c285409a71df1$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $095c285409a71df1$var$getOwnPropertyNames(sourceComponent);
        if ($095c285409a71df1$var$getOwnPropertySymbols) keys = keys.concat($095c285409a71df1$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $095c285409a71df1$var$getStatics(targetComponent);
        var sourceStatics = $095c285409a71df1$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$095c285409a71df1$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $095c285409a71df1$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $095c285409a71df1$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
module.exports = $095c285409a71df1$var$hoistNonReactStatics;

});
parcelRegister("cGNdg", function(module, exports) {
"use strict";

module.exports = (parcelRequire("3Waf6"));

});
parcelRegister("3Waf6", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", function () { return $2ddebbd5e279ed5d$export$2b8d127b894957b9; }, function (v) { return $2ddebbd5e279ed5d$export$2b8d127b894957b9 = v; });
$parcel$export(module.exports, "ConcurrentMode", function () { return $2ddebbd5e279ed5d$export$cea3a54a6425200c; }, function (v) { return $2ddebbd5e279ed5d$export$cea3a54a6425200c = v; });
$parcel$export(module.exports, "ContextConsumer", function () { return $2ddebbd5e279ed5d$export$a7c73072b1a182ae; }, function (v) { return $2ddebbd5e279ed5d$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $2ddebbd5e279ed5d$export$9f27bc3417b4524d; }, function (v) { return $2ddebbd5e279ed5d$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $2ddebbd5e279ed5d$export$db77ccec0bb4ccac; }, function (v) { return $2ddebbd5e279ed5d$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $2ddebbd5e279ed5d$export$8392c0c9d3dcbd35; }, function (v) { return $2ddebbd5e279ed5d$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $2ddebbd5e279ed5d$export$ffb0004e005737fa; }, function (v) { return $2ddebbd5e279ed5d$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $2ddebbd5e279ed5d$export$b624eff549462981; }, function (v) { return $2ddebbd5e279ed5d$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $2ddebbd5e279ed5d$export$7897aa7841a5380c; }, function (v) { return $2ddebbd5e279ed5d$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $2ddebbd5e279ed5d$export$602eac185826482c; }, function (v) { return $2ddebbd5e279ed5d$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $2ddebbd5e279ed5d$export$e2c29f18771995cb; }, function (v) { return $2ddebbd5e279ed5d$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $2ddebbd5e279ed5d$export$5f8d39834fd61797; }, function (v) { return $2ddebbd5e279ed5d$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $2ddebbd5e279ed5d$export$74bf444e3cd11ea5; }, function (v) { return $2ddebbd5e279ed5d$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $2ddebbd5e279ed5d$export$92387174baf9b227; }, function (v) { return $2ddebbd5e279ed5d$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $2ddebbd5e279ed5d$export$ec112efeb987d9c6; }, function (v) { return $2ddebbd5e279ed5d$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $2ddebbd5e279ed5d$export$b706b080d889d2c9; }, function (v) { return $2ddebbd5e279ed5d$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $2ddebbd5e279ed5d$export$5be5a87408f70ddc; }, function (v) { return $2ddebbd5e279ed5d$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $2ddebbd5e279ed5d$export$45a5e7f76e0caa8d; }, function (v) { return $2ddebbd5e279ed5d$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $2ddebbd5e279ed5d$export$455c2e768291efa6; }, function (v) { return $2ddebbd5e279ed5d$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $2ddebbd5e279ed5d$export$9522e17588c12572; }, function (v) { return $2ddebbd5e279ed5d$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $2ddebbd5e279ed5d$export$2110ac352bb060b9; }, function (v) { return $2ddebbd5e279ed5d$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $2ddebbd5e279ed5d$export$56885ab8b9c456ab; }, function (v) { return $2ddebbd5e279ed5d$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $2ddebbd5e279ed5d$export$d927fcb6adf8f9de; }, function (v) { return $2ddebbd5e279ed5d$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $2ddebbd5e279ed5d$export$b82d16f27459e05a; }, function (v) { return $2ddebbd5e279ed5d$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $2ddebbd5e279ed5d$export$522c17b4f5e123e8; }, function (v) { return $2ddebbd5e279ed5d$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $2ddebbd5e279ed5d$export$1aabd8a0274ecfd6; }, function (v) { return $2ddebbd5e279ed5d$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $2ddebbd5e279ed5d$export$9b621391a187a31a; }, function (v) { return $2ddebbd5e279ed5d$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $2ddebbd5e279ed5d$export$f5bbd400c2f4426f; }, function (v) { return $2ddebbd5e279ed5d$export$f5bbd400c2f4426f = v; });
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $2ddebbd5e279ed5d$export$2b8d127b894957b9;
var $2ddebbd5e279ed5d$export$cea3a54a6425200c;
var $2ddebbd5e279ed5d$export$a7c73072b1a182ae;
var $2ddebbd5e279ed5d$export$9f27bc3417b4524d;
var $2ddebbd5e279ed5d$export$db77ccec0bb4ccac;
var $2ddebbd5e279ed5d$export$8392c0c9d3dcbd35;
var $2ddebbd5e279ed5d$export$ffb0004e005737fa;
var $2ddebbd5e279ed5d$export$b624eff549462981;
var $2ddebbd5e279ed5d$export$7897aa7841a5380c;
var $2ddebbd5e279ed5d$export$602eac185826482c;
var $2ddebbd5e279ed5d$export$e2c29f18771995cb;
var $2ddebbd5e279ed5d$export$5f8d39834fd61797;
var $2ddebbd5e279ed5d$export$74bf444e3cd11ea5;
var $2ddebbd5e279ed5d$export$92387174baf9b227;
var $2ddebbd5e279ed5d$export$ec112efeb987d9c6;
var $2ddebbd5e279ed5d$export$b706b080d889d2c9;
var $2ddebbd5e279ed5d$export$5be5a87408f70ddc;
var $2ddebbd5e279ed5d$export$45a5e7f76e0caa8d;
var $2ddebbd5e279ed5d$export$455c2e768291efa6;
var $2ddebbd5e279ed5d$export$9522e17588c12572;
var $2ddebbd5e279ed5d$export$2110ac352bb060b9;
var $2ddebbd5e279ed5d$export$56885ab8b9c456ab;
var $2ddebbd5e279ed5d$export$d927fcb6adf8f9de;
var $2ddebbd5e279ed5d$export$b82d16f27459e05a;
var $2ddebbd5e279ed5d$export$522c17b4f5e123e8;
var $2ddebbd5e279ed5d$export$1aabd8a0274ecfd6;
var $2ddebbd5e279ed5d$export$9b621391a187a31a;
var $2ddebbd5e279ed5d$export$f5bbd400c2f4426f;
"use strict";
var $2ddebbd5e279ed5d$var$b = "function" === typeof Symbol && Symbol.for, $2ddebbd5e279ed5d$var$c = $2ddebbd5e279ed5d$var$b ? Symbol.for("react.element") : 60103, $2ddebbd5e279ed5d$var$d = $2ddebbd5e279ed5d$var$b ? Symbol.for("react.portal") : 60106, $2ddebbd5e279ed5d$var$e = $2ddebbd5e279ed5d$var$b ? Symbol.for("react.fragment") : 60107, $2ddebbd5e279ed5d$var$f = $2ddebbd5e279ed5d$var$b ? Symbol.for("react.strict_mode") : 60108, $2ddebbd5e279ed5d$var$g = $2ddebbd5e279ed5d$var$b ? Symbol.for("react.profiler") : 60114, $2ddebbd5e279ed5d$var$h = $2ddebbd5e279ed5d$var$b ? Symbol.for("react.provider") : 60109, $2ddebbd5e279ed5d$var$k = $2ddebbd5e279ed5d$var$b ? Symbol.for("react.context") : 60110, $2ddebbd5e279ed5d$var$l = $2ddebbd5e279ed5d$var$b ? Symbol.for("react.async_mode") : 60111, $2ddebbd5e279ed5d$var$m = $2ddebbd5e279ed5d$var$b ? Symbol.for("react.concurrent_mode") : 60111, $2ddebbd5e279ed5d$var$n = $2ddebbd5e279ed5d$var$b ? Symbol.for("react.forward_ref") : 60112, $2ddebbd5e279ed5d$var$p = $2ddebbd5e279ed5d$var$b ? Symbol.for("react.suspense") : 60113, $2ddebbd5e279ed5d$var$q = $2ddebbd5e279ed5d$var$b ? Symbol.for("react.suspense_list") : 60120, $2ddebbd5e279ed5d$var$r = $2ddebbd5e279ed5d$var$b ? Symbol.for("react.memo") : 60115, $2ddebbd5e279ed5d$var$t = $2ddebbd5e279ed5d$var$b ? Symbol.for("react.lazy") : 60116, $2ddebbd5e279ed5d$var$v = $2ddebbd5e279ed5d$var$b ? Symbol.for("react.block") : 60121, $2ddebbd5e279ed5d$var$w = $2ddebbd5e279ed5d$var$b ? Symbol.for("react.fundamental") : 60117, $2ddebbd5e279ed5d$var$x = $2ddebbd5e279ed5d$var$b ? Symbol.for("react.responder") : 60118, $2ddebbd5e279ed5d$var$y = $2ddebbd5e279ed5d$var$b ? Symbol.for("react.scope") : 60119;
function $2ddebbd5e279ed5d$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $2ddebbd5e279ed5d$var$c:
                switch(a = a.type, a){
                    case $2ddebbd5e279ed5d$var$l:
                    case $2ddebbd5e279ed5d$var$m:
                    case $2ddebbd5e279ed5d$var$e:
                    case $2ddebbd5e279ed5d$var$g:
                    case $2ddebbd5e279ed5d$var$f:
                    case $2ddebbd5e279ed5d$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $2ddebbd5e279ed5d$var$k:
                            case $2ddebbd5e279ed5d$var$n:
                            case $2ddebbd5e279ed5d$var$t:
                            case $2ddebbd5e279ed5d$var$r:
                            case $2ddebbd5e279ed5d$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $2ddebbd5e279ed5d$var$d:
                return u;
        }
    }
}
function $2ddebbd5e279ed5d$var$A(a) {
    return $2ddebbd5e279ed5d$var$z(a) === $2ddebbd5e279ed5d$var$m;
}
$2ddebbd5e279ed5d$export$2b8d127b894957b9 = $2ddebbd5e279ed5d$var$l;
$2ddebbd5e279ed5d$export$cea3a54a6425200c = $2ddebbd5e279ed5d$var$m;
$2ddebbd5e279ed5d$export$a7c73072b1a182ae = $2ddebbd5e279ed5d$var$k;
$2ddebbd5e279ed5d$export$9f27bc3417b4524d = $2ddebbd5e279ed5d$var$h;
$2ddebbd5e279ed5d$export$db77ccec0bb4ccac = $2ddebbd5e279ed5d$var$c;
$2ddebbd5e279ed5d$export$8392c0c9d3dcbd35 = $2ddebbd5e279ed5d$var$n;
$2ddebbd5e279ed5d$export$ffb0004e005737fa = $2ddebbd5e279ed5d$var$e;
$2ddebbd5e279ed5d$export$b624eff549462981 = $2ddebbd5e279ed5d$var$t;
$2ddebbd5e279ed5d$export$7897aa7841a5380c = $2ddebbd5e279ed5d$var$r;
$2ddebbd5e279ed5d$export$602eac185826482c = $2ddebbd5e279ed5d$var$d;
$2ddebbd5e279ed5d$export$e2c29f18771995cb = $2ddebbd5e279ed5d$var$g;
$2ddebbd5e279ed5d$export$5f8d39834fd61797 = $2ddebbd5e279ed5d$var$f;
$2ddebbd5e279ed5d$export$74bf444e3cd11ea5 = $2ddebbd5e279ed5d$var$p;
$2ddebbd5e279ed5d$export$92387174baf9b227 = function(a) {
    return $2ddebbd5e279ed5d$var$A(a) || $2ddebbd5e279ed5d$var$z(a) === $2ddebbd5e279ed5d$var$l;
};
$2ddebbd5e279ed5d$export$ec112efeb987d9c6 = $2ddebbd5e279ed5d$var$A;
$2ddebbd5e279ed5d$export$b706b080d889d2c9 = function(a) {
    return $2ddebbd5e279ed5d$var$z(a) === $2ddebbd5e279ed5d$var$k;
};
$2ddebbd5e279ed5d$export$5be5a87408f70ddc = function(a) {
    return $2ddebbd5e279ed5d$var$z(a) === $2ddebbd5e279ed5d$var$h;
};
$2ddebbd5e279ed5d$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $2ddebbd5e279ed5d$var$c;
};
$2ddebbd5e279ed5d$export$455c2e768291efa6 = function(a) {
    return $2ddebbd5e279ed5d$var$z(a) === $2ddebbd5e279ed5d$var$n;
};
$2ddebbd5e279ed5d$export$9522e17588c12572 = function(a) {
    return $2ddebbd5e279ed5d$var$z(a) === $2ddebbd5e279ed5d$var$e;
};
$2ddebbd5e279ed5d$export$2110ac352bb060b9 = function(a) {
    return $2ddebbd5e279ed5d$var$z(a) === $2ddebbd5e279ed5d$var$t;
};
$2ddebbd5e279ed5d$export$56885ab8b9c456ab = function(a) {
    return $2ddebbd5e279ed5d$var$z(a) === $2ddebbd5e279ed5d$var$r;
};
$2ddebbd5e279ed5d$export$d927fcb6adf8f9de = function(a) {
    return $2ddebbd5e279ed5d$var$z(a) === $2ddebbd5e279ed5d$var$d;
};
$2ddebbd5e279ed5d$export$b82d16f27459e05a = function(a) {
    return $2ddebbd5e279ed5d$var$z(a) === $2ddebbd5e279ed5d$var$g;
};
$2ddebbd5e279ed5d$export$522c17b4f5e123e8 = function(a) {
    return $2ddebbd5e279ed5d$var$z(a) === $2ddebbd5e279ed5d$var$f;
};
$2ddebbd5e279ed5d$export$1aabd8a0274ecfd6 = function(a) {
    return $2ddebbd5e279ed5d$var$z(a) === $2ddebbd5e279ed5d$var$p;
};
$2ddebbd5e279ed5d$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $2ddebbd5e279ed5d$var$e || a === $2ddebbd5e279ed5d$var$m || a === $2ddebbd5e279ed5d$var$g || a === $2ddebbd5e279ed5d$var$f || a === $2ddebbd5e279ed5d$var$p || a === $2ddebbd5e279ed5d$var$q || "object" === typeof a && null !== a && (a.$$typeof === $2ddebbd5e279ed5d$var$t || a.$$typeof === $2ddebbd5e279ed5d$var$r || a.$$typeof === $2ddebbd5e279ed5d$var$h || a.$$typeof === $2ddebbd5e279ed5d$var$k || a.$$typeof === $2ddebbd5e279ed5d$var$n || a.$$typeof === $2ddebbd5e279ed5d$var$w || a.$$typeof === $2ddebbd5e279ed5d$var$x || a.$$typeof === $2ddebbd5e279ed5d$var$y || a.$$typeof === $2ddebbd5e279ed5d$var$v);
};
$2ddebbd5e279ed5d$export$f5bbd400c2f4426f = $2ddebbd5e279ed5d$var$z;

});




parcelRegister("3Ao1t", function(module, exports) {

$parcel$export(module.exports, "getRegisteredStyles", function () { return $29c75e4adcd6723c$export$95d99596f328fd52; });
$parcel$export(module.exports, "registerStyles", function () { return $29c75e4adcd6723c$export$580009a5da2a8b4b; });
$parcel$export(module.exports, "insertStyles", function () { return $29c75e4adcd6723c$export$6f077d94b33a01aa; });
var $29c75e4adcd6723c$var$isBrowser = typeof document !== "undefined";
function $29c75e4adcd6723c$export$95d99596f328fd52(registered, registeredStyles, classNames) {
    var rawClassName = "";
    classNames.split(" ").forEach(function(className) {
        if (registered[className] !== undefined) registeredStyles.push(registered[className] + ";");
        else if (className) rawClassName += className + " ";
    });
    return rawClassName;
}
var $29c75e4adcd6723c$export$580009a5da2a8b4b = function registerStyles(cache, serialized, isStringTag) {
    var className = cache.key + "-" + serialized.name;
    if (// class name could be used further down
    // the tree but if it's a string tag, we know it won't
    // so we don't have to add it to registered cache.
    // this improves memory usage since we can avoid storing the whole style string
    (isStringTag === false || // we need to always store it if we're in compat mode and
    // in node since emotion-server relies on whether a style is in
    // the registered cache to know whether a style is global or not
    // also, note that this check will be dead code eliminated in the browser
    $29c75e4adcd6723c$var$isBrowser === false && cache.compat !== undefined) && cache.registered[className] === undefined) cache.registered[className] = serialized.styles;
};
var $29c75e4adcd6723c$export$6f077d94b33a01aa = function insertStyles(cache, serialized, isStringTag) {
    $29c75e4adcd6723c$export$580009a5da2a8b4b(cache, serialized, isStringTag);
    var className = cache.key + "-" + serialized.name;
    if (cache.inserted[serialized.name] === undefined) {
        var stylesForSSR = "";
        var current = serialized;
        do {
            var maybeStyles = cache.insert(serialized === current ? "." + className : "", current, cache.sheet, true);
            if (!$29c75e4adcd6723c$var$isBrowser && maybeStyles !== undefined) stylesForSSR += maybeStyles;
            current = current.next;
        }while (current !== undefined);
        if (!$29c75e4adcd6723c$var$isBrowser && stylesForSSR.length !== 0) return stylesForSSR;
    }
};

});

parcelRegister("2EoW8", function(module, exports) {

$parcel$export(module.exports, "serializeStyles", function () { return $1ee2a91bd1567dbf$export$6321afa313b251b5; });

var $iIZdw = parcelRequire("iIZdw");

var $eYY3d = parcelRequire("eYY3d");

var $8cVSc = parcelRequire("8cVSc");
var $1ee2a91bd1567dbf$var$ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var $1ee2a91bd1567dbf$var$UNDEFINED_AS_OBJECT_KEY_ERROR = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).";
var $1ee2a91bd1567dbf$var$hyphenateRegex = /[A-Z]|^ms/g;
var $1ee2a91bd1567dbf$var$animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var $1ee2a91bd1567dbf$var$isCustomProperty = function isCustomProperty(property) {
    return property.charCodeAt(1) === 45;
};
var $1ee2a91bd1567dbf$var$isProcessableValue = function isProcessableValue(value) {
    return value != null && typeof value !== "boolean";
};
var $1ee2a91bd1567dbf$var$processStyleName = /* #__PURE__ */ (0, $8cVSc.default)(function(styleName) {
    return $1ee2a91bd1567dbf$var$isCustomProperty(styleName) ? styleName : styleName.replace($1ee2a91bd1567dbf$var$hyphenateRegex, "-$&").toLowerCase();
});
var $1ee2a91bd1567dbf$var$processStyleValue = function processStyleValue(key, value) {
    switch(key){
        case "animation":
        case "animationName":
            if (typeof value === "string") return value.replace($1ee2a91bd1567dbf$var$animationRegex, function(match, p1, p2) {
                $1ee2a91bd1567dbf$var$cursor = {
                    name: p1,
                    styles: p2,
                    next: $1ee2a91bd1567dbf$var$cursor
                };
                return p1;
            });
    }
    if ((0, $eYY3d.default)[key] !== 1 && !$1ee2a91bd1567dbf$var$isCustomProperty(key) && typeof value === "number" && value !== 0) return value + "px";
    return value;
};
var $1ee2a91bd1567dbf$var$contentValuePattern, $1ee2a91bd1567dbf$var$contentValues, $1ee2a91bd1567dbf$var$oldProcessStyleValue, $1ee2a91bd1567dbf$var$msPattern, $1ee2a91bd1567dbf$var$hyphenPattern, $1ee2a91bd1567dbf$var$hyphenatedCache;
var $1ee2a91bd1567dbf$var$noComponentSelectorMessage = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function $1ee2a91bd1567dbf$var$handleInterpolation(mergedProps, registered, interpolation) {
    if (interpolation == null) return "";
    var componentSelector = interpolation;
    if (componentSelector.__emotion_styles !== undefined) return componentSelector;
    switch(typeof interpolation){
        case "boolean":
            return "";
        case "object":
            var keyframes = interpolation;
            if (keyframes.anim === 1) {
                $1ee2a91bd1567dbf$var$cursor = {
                    name: keyframes.name,
                    styles: keyframes.styles,
                    next: $1ee2a91bd1567dbf$var$cursor
                };
                return keyframes.name;
            }
            var serializedStyles = interpolation;
            if (serializedStyles.styles !== undefined) {
                var next = serializedStyles.next;
                if (next !== undefined) // not the most efficient thing ever but this is a pretty rare case
                // and there will be very few iterations of this generally
                while(next !== undefined){
                    $1ee2a91bd1567dbf$var$cursor = {
                        name: next.name,
                        styles: next.styles,
                        next: $1ee2a91bd1567dbf$var$cursor
                    };
                    next = next.next;
                }
                var styles = serializedStyles.styles + ";";
                return styles;
            }
            return $1ee2a91bd1567dbf$var$createStringFromObject(mergedProps, registered, interpolation);
        case "function":
            if (mergedProps !== undefined) {
                var previousCursor = $1ee2a91bd1567dbf$var$cursor;
                var result = interpolation(mergedProps);
                $1ee2a91bd1567dbf$var$cursor = previousCursor;
                return $1ee2a91bd1567dbf$var$handleInterpolation(mergedProps, registered, result);
            }
            break;
        case "string":
            var matched, replaced;
            break;
    } // finalize string values (regular strings and functions interpolated into css calls)
    var asString = interpolation;
    if (registered == null) return asString;
    var cached = registered[asString];
    return cached !== undefined ? cached : asString;
}
function $1ee2a91bd1567dbf$var$createStringFromObject(mergedProps, registered, obj) {
    var string = "";
    if (Array.isArray(obj)) for(var i = 0; i < obj.length; i++)string += $1ee2a91bd1567dbf$var$handleInterpolation(mergedProps, registered, obj[i]) + ";";
    else for(var key in obj){
        var value = obj[key];
        if (typeof value !== "object") {
            var asString = value;
            if (registered != null && registered[asString] !== undefined) string += key + "{" + registered[asString] + "}";
            else if ($1ee2a91bd1567dbf$var$isProcessableValue(asString)) string += $1ee2a91bd1567dbf$var$processStyleName(key) + ":" + $1ee2a91bd1567dbf$var$processStyleValue(key, asString) + ";";
        } else if (Array.isArray(value) && typeof value[0] === "string" && (registered == null || registered[value[0]] === undefined)) {
            for(var _i = 0; _i < value.length; _i++)if ($1ee2a91bd1567dbf$var$isProcessableValue(value[_i])) string += $1ee2a91bd1567dbf$var$processStyleName(key) + ":" + $1ee2a91bd1567dbf$var$processStyleValue(key, value[_i]) + ";";
        } else {
            var interpolated = $1ee2a91bd1567dbf$var$handleInterpolation(mergedProps, registered, value);
            switch(key){
                case "animation":
                case "animationName":
                    string += $1ee2a91bd1567dbf$var$processStyleName(key) + ":" + interpolated + ";";
                    break;
                default:
                    string += key + "{" + interpolated + "}";
            }
        }
    }
    return string;
}
var $1ee2a91bd1567dbf$var$labelPattern = /label:\s*([^\s;\n{]+)\s*(;|$)/g;
var $1ee2a91bd1567dbf$var$sourceMapPattern;
// keyframes are stored on the SerializedStyles object as a linked list
var $1ee2a91bd1567dbf$var$cursor;
function $1ee2a91bd1567dbf$export$6321afa313b251b5(args, registered, mergedProps) {
    if (args.length === 1 && typeof args[0] === "object" && args[0] !== null && args[0].styles !== undefined) return args[0];
    var stringMode = true;
    var styles = "";
    $1ee2a91bd1567dbf$var$cursor = undefined;
    var strings = args[0];
    if (strings == null || strings.raw === undefined) {
        stringMode = false;
        styles += $1ee2a91bd1567dbf$var$handleInterpolation(mergedProps, registered, strings);
    } else {
        var asTemplateStringsArr = strings;
        styles += asTemplateStringsArr[0];
    } // we start at 1 since we've already handled the first arg
    for(var i = 1; i < args.length; i++){
        styles += $1ee2a91bd1567dbf$var$handleInterpolation(mergedProps, registered, args[i]);
        if (stringMode) {
            var templateStringsArr = strings;
            styles += templateStringsArr[i];
        }
    }
    var sourceMap;
    $1ee2a91bd1567dbf$var$labelPattern.lastIndex = 0;
    var identifierName = "";
    var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5
    while((match = $1ee2a91bd1567dbf$var$labelPattern.exec(styles)) !== null)identifierName += "-" + match[1];
    var name = (0, $iIZdw.default)(styles) + identifierName;
    var devStyles;
    return {
        name: name,
        styles: styles,
        next: $1ee2a91bd1567dbf$var$cursor
    };
}

});
parcelRegister("iIZdw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $da1bd2791f279fa1$export$2e2bcd8739ae039; });
/* eslint-disable */ // Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function $da1bd2791f279fa1$export$2e2bcd8739ae039(str) {
    // 'm' and 'r' are mixing constants generated offline.
    // They're not really 'magic', they just happen to work well.
    // const m = 0x5bd1e995;
    // const r = 24;
    // Initialize the hash
    var h = 0; // Mix 4 bytes at a time into the hash
    var k, i = 0, len = str.length;
    for(; len >= 4; ++i, len -= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
        k ^= /* k >>> r: */ k >>> 24;
        h = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^ /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Handle the last few bytes of the input array
    switch(len){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Do a few final mixes of the hash to ensure the last few
    // bytes are well-incorporated.
    h ^= h >>> 13;
    h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    return ((h ^ h >>> 15) >>> 0).toString(36);
}

});

parcelRegister("eYY3d", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ae854021535ddfd0$export$2e2bcd8739ae039; });
var $ae854021535ddfd0$export$2e2bcd8739ae039 = {
    animationIterationCount: 1,
    aspectRatio: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};

});


parcelRegister("fDu2l", function(module, exports) {

$parcel$export(module.exports, "useInsertionEffectAlwaysWithSyncFallback", function () { return $b621cc33618478bb$export$db21c7ffa21794e7; });
$parcel$export(module.exports, "useInsertionEffectWithLayoutFallback", function () { return $b621cc33618478bb$export$811a713a7276cb9d; });

var $dAx5m = parcelRequire("dAx5m");
var $b621cc33618478bb$var$isBrowser = typeof document !== "undefined";
var $b621cc33618478bb$var$syncFallback = function syncFallback(create) {
    return create();
};
var $b621cc33618478bb$var$useInsertionEffect = $dAx5m.useInsertionEffect ? $dAx5m.useInsertionEffect : false;
var $b621cc33618478bb$export$db21c7ffa21794e7 = !$b621cc33618478bb$var$isBrowser ? $b621cc33618478bb$var$syncFallback : $b621cc33618478bb$var$useInsertionEffect || $b621cc33618478bb$var$syncFallback;
var $b621cc33618478bb$export$811a713a7276cb9d = $b621cc33618478bb$var$useInsertionEffect || $dAx5m.useLayoutEffect;

});


parcelRegister("dML2Y", function(module, exports) {
function $a094409e22cd7650$var$_extends() {
    return module.exports = $a094409e22cd7650$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $a094409e22cd7650$var$_extends.apply(null, arguments);
}
module.exports = $a094409e22cd7650$var$_extends, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("87inS", function(module, exports) {

$parcel$export(module.exports, "usePlatformLeafEventHandler", function () { return $5e8d3ce3ddb2edbe$export$a4687b0234b40e28; });

var $b6jao = parcelRequire("b6jao");

var $dAx5m = parcelRequire("dAx5m");

var $iFwlO = parcelRequire("iFwlO");

var $IF6Sy = parcelRequire("IF6Sy");
function $5e8d3ce3ddb2edbe$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $5e8d3ce3ddb2edbe$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $5e8d3ce3ddb2edbe$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($b6jao)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $5e8d3ce3ddb2edbe$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $5e8d3ce3ddb2edbe$export$a4687b0234b40e28(_ref) {
    var fn = _ref.fn, action = _ref.action, componentName = _ref.componentName, actionSubject = _ref.actionSubject, packageName = _ref.packageName, packageVersion = _ref.packageVersion, analyticsData = _ref.analyticsData;
    var _useAnalyticsEvents = (0, $iFwlO.useAnalyticsEvents)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    // We put analyticsData and fn in a ref so that we don't need to break
    // memoization.
    // Generally these could be defined by consumers inline
    // and so we do this to avoid breaking memoization of useCallback
    var dataRef = (0, $IF6Sy.useTrackedRef)(analyticsData);
    var fnRef = (0, $IF6Sy.useTrackedRef)(fn);
    var handler = (0, $dAx5m.useCallback)(function(value) {
        var analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: actionSubject || componentName,
            attributes: {
                componentName: componentName,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
        // To avoid wrapping this component in AnalyticsContext we manually
        // push the parent context's meta data into the context.
        // Note: this new 'context'
        var context = $5e8d3ce3ddb2edbe$var$_objectSpread({
            componentName: componentName,
            packageName: packageName,
            packageVersion: packageVersion
        }, dataRef.current);
        analyticsEvent.context.push(context);
        // fire an event on the atlaskit channel
        var clone = analyticsEvent.clone();
        if (clone) clone.fire("atlaskit");
        fnRef.current(value, analyticsEvent);
    }, [
        // These are strings and won't change
        action,
        componentName,
        actionSubject,
        packageName,
        packageVersion,
        // This function is memoized in the context
        createAnalyticsEvent,
        // these are a stable ref because of the useTrackedRef hook
        dataRef,
        fnRef
    ]);
    return handler;
}

});
parcelRegister("b6jao", function(module, exports) {

var $fTxEv = parcelRequire("fTxEv");
function $814f1f520a19ce4e$var$_defineProperty(e, r, t) {
    return (r = $fTxEv(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
module.exports = $814f1f520a19ce4e$var$_defineProperty, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("fTxEv", function(module, exports) {

var $6zXtn = parcelRequire("6zXtn");
var $b92618b20773f0ad$var$_typeof = $6zXtn.default;

var $iJz1y = parcelRequire("iJz1y");
function $b92618b20773f0ad$var$toPropertyKey(t) {
    var i = $iJz1y(t, "string");
    return "symbol" == $b92618b20773f0ad$var$_typeof(i) ? i : i + "";
}
module.exports = $b92618b20773f0ad$var$toPropertyKey, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("6zXtn", function(module, exports) {
function $4ca42503be5280e8$var$_typeof(o) {
    "@babel/helpers - typeof";
    return module.exports = $4ca42503be5280e8$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $4ca42503be5280e8$var$_typeof(o);
}
module.exports = $4ca42503be5280e8$var$_typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("iJz1y", function(module, exports) {

var $6zXtn = parcelRequire("6zXtn");
var $da379905375e3976$var$_typeof = $6zXtn.default;
function $da379905375e3976$var$toPrimitive(t, r) {
    if ("object" != $da379905375e3976$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $da379905375e3976$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
module.exports = $da379905375e3976$var$toPrimitive, module.exports.__esModule = true, module.exports["default"] = module.exports;

});



parcelRegister("iFwlO", function(module, exports) {

$parcel$export(module.exports, "useAnalyticsEvents", function () { return $0381e3b7c1ae6ebd$export$5bf35293e545f20c; });

var $tWuif = parcelRequire("tWuif");

var $hk1TB = parcelRequire("hk1TB");

var $icPob = parcelRequire("icPob");
function $0381e3b7c1ae6ebd$export$5bf35293e545f20c() {
    var analyticsContext = (0, $icPob.useAnalyticsContext)();
    var createAnalyticsEvent = (0, $tWuif.useCallbackOne)(function(payload) {
        return new (0, $hk1TB.default)({
            context: analyticsContext.getAtlaskitAnalyticsContext(),
            handlers: analyticsContext.getAtlaskitAnalyticsEventHandlers(),
            payload: payload
        });
    }, [
        analyticsContext
    ]);
    return {
        createAnalyticsEvent: createAnalyticsEvent
    };
}

});
parcelRegister("tWuif", function(module, exports) {

$parcel$export(module.exports, "useCallbackOne", function () { return $05a013f7b59b2371$export$33752cf3ee811995; });

var $dAx5m = parcelRequire("dAx5m");
function $05a013f7b59b2371$var$areInputsEqual(newInputs, lastInputs) {
    if (newInputs.length !== lastInputs.length) return false;
    for(var i = 0; i < newInputs.length; i++){
        if (newInputs[i] !== lastInputs[i]) return false;
    }
    return true;
}
function $05a013f7b59b2371$export$b6feb8998cd9b342(getResult, inputs) {
    var initial = (0, $dAx5m.useState)(function() {
        return {
            inputs: inputs,
            result: getResult()
        };
    })[0];
    var isFirstRun = (0, $dAx5m.useRef)(true);
    var committed = (0, $dAx5m.useRef)(initial);
    var useCache = isFirstRun.current || Boolean(inputs && committed.current.inputs && $05a013f7b59b2371$var$areInputsEqual(inputs, committed.current.inputs));
    var cache = useCache ? committed.current : {
        inputs: inputs,
        result: getResult()
    };
    (0, $dAx5m.useEffect)(function() {
        isFirstRun.current = false;
        committed.current = cache;
    }, [
        cache
    ]);
    return cache.result;
}
function $05a013f7b59b2371$export$33752cf3ee811995(callback, inputs) {
    return $05a013f7b59b2371$export$b6feb8998cd9b342(function() {
        return callback;
    }, inputs);
}
var $05a013f7b59b2371$export$1538c33de8887b59 = $05a013f7b59b2371$export$b6feb8998cd9b342;
var $05a013f7b59b2371$export$35808ee640e87ca7 = $05a013f7b59b2371$export$33752cf3ee811995;

});

parcelRegister("hk1TB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c9c5c668c6e20030$export$2e2bcd8739ae039; });

var $gbuCj = parcelRequire("gbuCj");

var $kw16e = parcelRequire("kw16e");

var $ghqwD = parcelRequire("ghqwD");

var $2S0zF = parcelRequire("2S0zF");

var $2BH0G = parcelRequire("2BH0G");

var $AaHPd = parcelRequire("AaHPd");

var $biIOW = parcelRequire("biIOW");

var $goLRL = parcelRequire("goLRL");

var $b6jao = parcelRequire("b6jao");

var $4lqhP = parcelRequire("4lqhP");
function $c9c5c668c6e20030$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $c9c5c668c6e20030$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, (/*@__PURE__*/$parcel$interopDefault($goLRL)))(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, (/*@__PURE__*/$parcel$interopDefault($goLRL)))(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, (/*@__PURE__*/$parcel$interopDefault($biIOW)))(this, result);
    };
}
function $c9c5c668c6e20030$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($c9c5c668c6e20030$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $c9c5c668c6e20030$export$35f8383928ba8d7 = function isUIAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $c9c5c668c6e20030$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isUIAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === "UIAnalyticsEvent";
};
var $c9c5c668c6e20030$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_AnalyticsEvent) {
    (0, (/*@__PURE__*/$parcel$interopDefault($AaHPd)))(UIAnalyticsEvent, _AnalyticsEvent);
    var _super = $c9c5c668c6e20030$var$_createSuper(UIAnalyticsEvent);
    function UIAnalyticsEvent(props) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($kw16e)))(this, UIAnalyticsEvent);
        _this = _super.call(this, props);
        (0, (/*@__PURE__*/$parcel$interopDefault($b6jao)))((0, (/*@__PURE__*/$parcel$interopDefault($2S0zF)))(_this), "_isUIAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($b6jao)))((0, (/*@__PURE__*/$parcel$interopDefault($2S0zF)))(_this), "clone", function() {
            if (_this.hasFired) return null;
            var context = (0, (/*@__PURE__*/$parcel$interopDefault($gbuCj)))(_this.context);
            var handlers = (0, (/*@__PURE__*/$parcel$interopDefault($gbuCj)))(_this.handlers);
            /**
       * A hacky "deep clone" of the object. This is limited in that it wont
       * support functions, regexs, Maps, Sets, etc, but none of those need to
       * be represented in our payload.
       */ var payload = JSON.parse(JSON.stringify(_this.payload));
            return new UIAnalyticsEvent({
                context: context,
                handlers: handlers,
                payload: payload
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($b6jao)))((0, (/*@__PURE__*/$parcel$interopDefault($2S0zF)))(_this), "fire", function(channel) {
            if (_this.hasFired) return;
            _this.handlers.forEach(function(handler) {
                return handler((0, (/*@__PURE__*/$parcel$interopDefault($2S0zF)))(_this), channel);
            });
            _this.hasFired = true;
        });
        _this.context = props.context || [];
        _this.handlers = props.handlers || [];
        _this.hasFired = false;
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($ghqwD)))(UIAnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (this.hasFired) return this;
                return (0, (/*@__PURE__*/$parcel$interopDefault($2BH0G)))((0, (/*@__PURE__*/$parcel$interopDefault($goLRL)))(UIAnalyticsEvent.prototype), "update", this).call(this, updater);
            }
        }
    ]);
    return UIAnalyticsEvent;
}((0, $4lqhP.default));

});
parcelRegister("gbuCj", function(module, exports) {

var $heOFo = parcelRequire("heOFo");

var $9toLC = parcelRequire("9toLC");

var $gcqBP = parcelRequire("gcqBP");

var $l9dKQ = parcelRequire("l9dKQ");
function $bc856c544a9ab291$var$_toConsumableArray(r) {
    return $heOFo(r) || $9toLC(r) || $gcqBP(r) || $l9dKQ();
}
module.exports = $bc856c544a9ab291$var$_toConsumableArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("heOFo", function(module, exports) {

var $5QEqJ = parcelRequire("5QEqJ");
function $c8cb0bd255f4a80f$var$_arrayWithoutHoles(r) {
    if (Array.isArray(r)) return $5QEqJ(r);
}
module.exports = $c8cb0bd255f4a80f$var$_arrayWithoutHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("9toLC", function(module, exports) {
function $6e5a08b0021b82e8$var$_iterableToArray(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
module.exports = $6e5a08b0021b82e8$var$_iterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("l9dKQ", function(module, exports) {
function $f6551b94a2ff3f26$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
module.exports = $f6551b94a2ff3f26$var$_nonIterableSpread, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("kw16e", function(module, exports) {
function $eef7a62934fab28a$var$_classCallCheck(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
module.exports = $eef7a62934fab28a$var$_classCallCheck, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("ghqwD", function(module, exports) {

var $fTxEv = parcelRequire("fTxEv");
function $030f0357de6b4636$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, $fTxEv(o.key), o);
    }
}
function $030f0357de6b4636$var$_createClass(e, r, t) {
    return r && $030f0357de6b4636$var$_defineProperties(e.prototype, r), t && $030f0357de6b4636$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}
module.exports = $030f0357de6b4636$var$_createClass, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("2S0zF", function(module, exports) {
function $217111f63ec6ed0f$var$_assertThisInitialized(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}
module.exports = $217111f63ec6ed0f$var$_assertThisInitialized, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("2BH0G", function(module, exports) {

var $9lmhu = parcelRequire("9lmhu");
function $1e60666269d3b0ca$var$_get() {
    return module.exports = $1e60666269d3b0ca$var$_get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function(e, t, r) {
        var p = $9lmhu(e, t);
        if (p) {
            var n = Object.getOwnPropertyDescriptor(p, t);
            return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value;
        }
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $1e60666269d3b0ca$var$_get.apply(null, arguments);
}
module.exports = $1e60666269d3b0ca$var$_get, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("9lmhu", function(module, exports) {

var $goLRL = parcelRequire("goLRL");
function $6cd75bc4616a030b$var$_superPropBase(t, o) {
    for(; !({}).hasOwnProperty.call(t, o) && null !== (t = $goLRL(t)););
    return t;
}
module.exports = $6cd75bc4616a030b$var$_superPropBase, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("goLRL", function(module, exports) {
function $bf04047a3c6dba16$var$_getPrototypeOf(t) {
    return module.exports = $bf04047a3c6dba16$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $bf04047a3c6dba16$var$_getPrototypeOf(t);
}
module.exports = $bf04047a3c6dba16$var$_getPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

});



parcelRegister("AaHPd", function(module, exports) {

var $2gqIB = parcelRequire("2gqIB");
function $06cbaade1613a4d1$var$_inherits(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && $2gqIB(t, e);
}
module.exports = $06cbaade1613a4d1$var$_inherits, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("2gqIB", function(module, exports) {
function $1a61cd202dc1b520$var$_setPrototypeOf(t, e) {
    return module.exports = $1a61cd202dc1b520$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $1a61cd202dc1b520$var$_setPrototypeOf(t, e);
}
module.exports = $1a61cd202dc1b520$var$_setPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("biIOW", function(module, exports) {

var $6zXtn = parcelRequire("6zXtn");
var $021f8cfa2c60eb73$var$_typeof = $6zXtn.default;

var $2S0zF = parcelRequire("2S0zF");
function $021f8cfa2c60eb73$var$_possibleConstructorReturn(t, e) {
    if (e && ("object" == $021f8cfa2c60eb73$var$_typeof(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return $2S0zF(t);
}
module.exports = $021f8cfa2c60eb73$var$_possibleConstructorReturn, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("4lqhP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $329d838d73c0fab2$export$2e2bcd8739ae039; });

var $6zXtn = parcelRequire("6zXtn");

var $kw16e = parcelRequire("kw16e");

var $ghqwD = parcelRequire("ghqwD");

var $b6jao = parcelRequire("b6jao");
function $329d838d73c0fab2$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $329d838d73c0fab2$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $329d838d73c0fab2$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($b6jao)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $329d838d73c0fab2$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $329d838d73c0fab2$export$ad4be5c2ec28cecf = function isAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $329d838d73c0fab2$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === "AnalyticsEvent";
};
var $329d838d73c0fab2$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function AnalyticsEvent(props) {
        var _this = this;
        (0, (/*@__PURE__*/$parcel$interopDefault($kw16e)))(this, AnalyticsEvent);
        (0, (/*@__PURE__*/$parcel$interopDefault($b6jao)))(this, "_isAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($b6jao)))(this, "clone", function() {
            // just a shallow clone, don't change sub refs unless you want to
            // affect the original's too
            var payload = $329d838d73c0fab2$var$_objectSpread({}, _this.payload);
            return new AnalyticsEvent({
                payload: payload
            });
        });
        this.payload = props.payload;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($ghqwD)))(AnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (typeof updater === "function") this.payload = updater(this.payload);
                if ((0, (/*@__PURE__*/$parcel$interopDefault($6zXtn)))(updater) === "object") this.payload = $329d838d73c0fab2$var$_objectSpread($329d838d73c0fab2$var$_objectSpread({}, this.payload), updater);
                return this;
            }
        }
    ]);
    return AnalyticsEvent;
}();

});


parcelRegister("icPob", function(module, exports) {

$parcel$export(module.exports, "useAnalyticsContext", function () { return $d41135c247b0de0a$export$d1f587f82ad51c4; });

var $dAx5m = parcelRequire("dAx5m");

var $h0bf1 = parcelRequire("h0bf1");
var $d41135c247b0de0a$export$d1f587f82ad51c4 = function useAnalyticsContext() {
    return (0, $dAx5m.useContext)((0, $h0bf1.default));
};

});
parcelRegister("h0bf1", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $c60b280d03c5ad11$export$2e2bcd8739ae039; });

var $9HGtr = parcelRequire("9HGtr");
var $c60b280d03c5ad11$export$2e2bcd8739ae039 = (0, $9HGtr.default);

});
parcelRegister("9HGtr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7109139e6ef9303c$export$2e2bcd8739ae039; });

var $dAx5m = parcelRequire("dAx5m");
var $7109139e6ef9303c$var$AnalyticsNextContext = (0, $dAx5m.createContext)({
    getAtlaskitAnalyticsContext: function() {
        return [];
    },
    getAtlaskitAnalyticsEventHandlers: function() {
        return [];
    }
});
var $7109139e6ef9303c$export$2e2bcd8739ae039 = $7109139e6ef9303c$var$AnalyticsNextContext;

});




parcelRegister("IF6Sy", function(module, exports) {

$parcel$export(module.exports, "useTrackedRef", function () { return $0863ffc159aaa01d$export$1d27a74659855e44; });

var $dAx5m = parcelRequire("dAx5m");
var $0863ffc159aaa01d$export$1d27a74659855e44 = function useTrackedRef(value) {
    var ref = (0, $dAx5m.useRef)(value);
    ref.current = value;
    return ref;
};

});


parcelRegister("gMIYi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c384036e6f2d3e3d$export$2e2bcd8739ae039; });

var $dAx5m = parcelRequire("dAx5m");
function $c384036e6f2d3e3d$export$2e2bcd8739ae039(ref, autoFocus) {
    var initialMount = (0, $dAx5m.useRef)(true);
    (0, $dAx5m.useEffect)(function() {
        if (ref && initialMount.current && autoFocus && ref.current) ref.current.focus();
        initialMount.current = false;
    }, [
        autoFocus,
        ref
    ]);
}

});

parcelRegister("iAyBE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d8866eda5b8cc798$export$2e2bcd8739ae039; });
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $dAx5m = parcelRequire("dAx5m");

var $jVTBW = parcelRequire("jVTBW");
var $d8866eda5b8cc798$var$BORDER_WIDTH = 2;
var $d8866eda5b8cc798$var$baseFocusOutsideStyles = (0, $jVTBW.css)({
    outline: "".concat($d8866eda5b8cc798$var$BORDER_WIDTH, "px solid ", "var(--ds-border-focused, #2684FF)"),
    outlineOffset: $d8866eda5b8cc798$var$BORDER_WIDTH
});
var $d8866eda5b8cc798$var$baseInsetStyles = (0, $jVTBW.css)({
    outlineColor: "var(--ds-border-focused, #2684FF)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    outlineOffset: -$d8866eda5b8cc798$var$BORDER_WIDTH,
    outlineStyle: "solid",
    outlineWidth: "var(--ds-border-width-outline, 2px)"
});
var $d8866eda5b8cc798$var$focusRingStyles = (0, $jVTBW.css)({
    // Focus styles used when :focus-visible isn't supported
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    "&:focus": $d8866eda5b8cc798$var$baseFocusOutsideStyles,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    "&:focus-visible": $d8866eda5b8cc798$var$baseFocusOutsideStyles,
    // Remove default focus styles for mouse interactions if :focus-visible is supported
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    "&:focus:not(:focus-visible)": {
        outline: "none"
    },
    "@media screen and (forced-colors: active), screen and (-ms-high-contrast: active)": {
        "&:focus-visible": {
            outline: "1px solid"
        }
    }
});
var $d8866eda5b8cc798$var$insetFocusRingStyles = (0, $jVTBW.css)({
    // Focus styles used when :focus-visible isn't supported
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    "&:focus": $d8866eda5b8cc798$var$baseInsetStyles,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    "&:focus-visible": $d8866eda5b8cc798$var$baseInsetStyles,
    // Remove default focus styles for mouse interactions if :focus-visible is supported
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    "&:focus:not(:focus-visible)": {
        outline: "none"
    },
    "@media screen and (forced-colors: active), screen and (-ms-high-contrast: active)": {
        "&:focus-visible": {
            outline: "1px solid",
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
            outlineOffset: "-1px"
        }
    }
});
/**
 * __Focus ring__
 *
 * A focus ring visually indicates the currently focused item.
 *
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/focus-ring)
 *
 * @example
 * ```jsx
 * import FocusRing from '@atlaskit/focus-ring';
 *
 * const InteractiveComponent = () => (
 *   <FocusRing>
 *     <button type="button">Hello</button>
 *   </FocusRing>
 * )
 * ```
 */ var $d8866eda5b8cc798$var$FocusRing = /*#__PURE__*/ (0, $dAx5m.memo)(function(_ref) {
    var children = _ref.children, isInset = _ref.isInset, focus = _ref.focus;
    var controlledStyles = isInset ? $d8866eda5b8cc798$var$baseInsetStyles : $d8866eda5b8cc798$var$baseFocusOutsideStyles;
    var uncontrolledStyles = isInset ? $d8866eda5b8cc798$var$insetFocusRingStyles : $d8866eda5b8cc798$var$focusRingStyles;
    var focusCls = typeof focus === "undefined" ? uncontrolledStyles : focus === "on" && controlledStyles;
    return (0, $jVTBW.jsx)((0, $jVTBW.ClassNames), null, function(_ref2) {
        var css = _ref2.css, cx = _ref2.cx;
        return (0, $dAx5m.Children).only(// This may look unwieldy but means we skip applying styles / cloning if no className is applicable
        focusCls ? /*#__PURE__*/ // eslint-disable-next-line @repo/internal/react/no-clone-element
        (0, $dAx5m.cloneElement)(children, {
            className: cx([
                css(focusCls),
                children.props.className
            ])
        }) : children);
    });
});
$d8866eda5b8cc798$var$FocusRing.displayName = "FocusRing";
var $d8866eda5b8cc798$export$2e2bcd8739ae039 = $d8866eda5b8cc798$var$FocusRing;

});

parcelRegister("kqsmh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $edec3bb9fe381c68$export$2e2bcd8739ae039; });

var $dAx5m = parcelRequire("dAx5m");
var $edec3bb9fe381c68$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $dAx5m.createContext)(null);

});

parcelRegister("apQ6e", function(module, exports) {

$parcel$export(module.exports, "R300", function () { return $7954a712b92c9fbd$export$4a7404f376229999; });
$parcel$export(module.exports, "R400", function () { return $7954a712b92c9fbd$export$2010d0fb4295b346; });
$parcel$export(module.exports, "R500", function () { return $7954a712b92c9fbd$export$2837b5a1a71d5c02; });
$parcel$export(module.exports, "Y200", function () { return $7954a712b92c9fbd$export$5aae31392d72caaa; });
$parcel$export(module.exports, "Y300", function () { return $7954a712b92c9fbd$export$c6930421db9fa514; });
$parcel$export(module.exports, "Y400", function () { return $7954a712b92c9fbd$export$59619663aa6500fb; });
$parcel$export(module.exports, "B50", function () { return $7954a712b92c9fbd$export$226de0355ed012f8; });
$parcel$export(module.exports, "B75", function () { return $7954a712b92c9fbd$export$8c13c2ee36917869; });
$parcel$export(module.exports, "B100", function () { return $7954a712b92c9fbd$export$ecfc1dff386a3e7a; });
$parcel$export(module.exports, "B200", function () { return $7954a712b92c9fbd$export$215b7063051591f1; });
$parcel$export(module.exports, "B300", function () { return $7954a712b92c9fbd$export$e62e8919cca44969; });
$parcel$export(module.exports, "B400", function () { return $7954a712b92c9fbd$export$b3de0ae08da2ce64; });
$parcel$export(module.exports, "B500", function () { return $7954a712b92c9fbd$export$a6ee3d71bc067634; });
$parcel$export(module.exports, "N0", function () { return $7954a712b92c9fbd$export$29a4f05edc054374; });
$parcel$export(module.exports, "N20", function () { return $7954a712b92c9fbd$export$9fdfb749e33cdf97; });
$parcel$export(module.exports, "N70", function () { return $7954a712b92c9fbd$export$5f71e19f3a7ad9de; });
$parcel$export(module.exports, "N90", function () { return $7954a712b92c9fbd$export$7c87d337fb91a97d; });
$parcel$export(module.exports, "N200", function () { return $7954a712b92c9fbd$export$f563ee71e9ee74cd; });
$parcel$export(module.exports, "N400", function () { return $7954a712b92c9fbd$export$eece5f492e429f08; });
$parcel$export(module.exports, "N500", function () { return $7954a712b92c9fbd$export$c39c0fe0f26207ae; });
$parcel$export(module.exports, "N700", function () { return $7954a712b92c9fbd$export$ad0bacf983b7ddaa; });
$parcel$export(module.exports, "N800", function () { return $7954a712b92c9fbd$export$7d61b15e0da132af; });
$parcel$export(module.exports, "N20A", function () { return $7954a712b92c9fbd$export$8d43898f60b96a82; });
$parcel$export(module.exports, "N30A", function () { return $7954a712b92c9fbd$export$920c0d5c49070351; });
$parcel$export(module.exports, "DN400", function () { return $7954a712b92c9fbd$export$abcf8c38338b4aa5; });
$parcel$export(module.exports, "DN300", function () { return $7954a712b92c9fbd$export$97e81faa16a182c7; });
$parcel$export(module.exports, "DN100", function () { return $7954a712b92c9fbd$export$ee82aa2ea6a1558; });
$parcel$export(module.exports, "DN70", function () { return $7954a712b92c9fbd$export$d281fbfe3cff2df6; });
$parcel$export(module.exports, "DN60", function () { return $7954a712b92c9fbd$export$3902c91d8b98a753; });
$parcel$export(module.exports, "DN30", function () { return $7954a712b92c9fbd$export$633847cf062b69e0; });
$parcel$export(module.exports, "DN0", function () { return $7954a712b92c9fbd$export$3d4f271a500072a; });
$parcel$export(module.exports, "skeleton", function () { return $7954a712b92c9fbd$export$2a0674ff2eb10214; });
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ 
var $8RXtT = parcelRequire("8RXtT");
var $7954a712b92c9fbd$export$4b84fd0e2c617bd = "#FFEBE6";
var $7954a712b92c9fbd$export$b34b069eff244586 = "#FFBDAD";
var $7954a712b92c9fbd$export$be802dd0d8b57f35 = "#FF8F73";
var $7954a712b92c9fbd$export$60847d42f9da92a6 = "#FF7452";
var $7954a712b92c9fbd$export$4a7404f376229999 = "#FF5630";
var $7954a712b92c9fbd$export$2010d0fb4295b346 = "#DE350B";
var $7954a712b92c9fbd$export$2837b5a1a71d5c02 = "#BF2600";
var $7954a712b92c9fbd$export$8d9596b529bbb9cf = "#FFFAE6";
var $7954a712b92c9fbd$export$41060a744ab0b7ae = "#FFF0B3";
var $7954a712b92c9fbd$export$1cc05bbbf340e559 = "#FFE380";
var $7954a712b92c9fbd$export$5aae31392d72caaa = "#FFC400";
var $7954a712b92c9fbd$export$c6930421db9fa514 = "#FFAB00";
var $7954a712b92c9fbd$export$59619663aa6500fb = "#FF991F";
var $7954a712b92c9fbd$export$874739ea9e379ab6 = "#FF8B00";
var $7954a712b92c9fbd$export$8a6341c32b6a3ee6 = "#E3FCEF";
var $7954a712b92c9fbd$export$69a3bf21b9686c2b = "#ABF5D1";
var $7954a712b92c9fbd$export$afbce1382ec95f73 = "#79F2C0";
var $7954a712b92c9fbd$export$747d86715d4175de = "#57D9A3";
var $7954a712b92c9fbd$export$940e1f69e873f202 = "#36B37E";
var $7954a712b92c9fbd$export$a49394138f7b8e85 = "#00875A";
var $7954a712b92c9fbd$export$6fa04827ac68a4fb = "#006644";
var $7954a712b92c9fbd$export$226de0355ed012f8 = "#DEEBFF";
var $7954a712b92c9fbd$export$8c13c2ee36917869 = "#B3D4FF";
var $7954a712b92c9fbd$export$ecfc1dff386a3e7a = "#4C9AFF";
var $7954a712b92c9fbd$export$215b7063051591f1 = "#2684FF";
var $7954a712b92c9fbd$export$e62e8919cca44969 = "#0065FF";
var $7954a712b92c9fbd$export$b3de0ae08da2ce64 = "#0052CC";
var $7954a712b92c9fbd$export$a6ee3d71bc067634 = "#0747A6";
var $7954a712b92c9fbd$export$363e4475840015bb = "#EAE6FF";
var $7954a712b92c9fbd$export$4b0a4417ed59760f = "#C0B6F2";
var $7954a712b92c9fbd$export$6011520a64d9a187 = "#998DD9";
var $7954a712b92c9fbd$export$a7175d4e9206bc80 = "#8777D9";
var $7954a712b92c9fbd$export$b48405b95304b5a1 = "#6554C0";
var $7954a712b92c9fbd$export$c71e4279dd54a18d = "#5243AA";
var $7954a712b92c9fbd$export$147899de772240ec = "#403294";
var $7954a712b92c9fbd$export$2cf711fe14c66f06 = "#E6FCFF";
var $7954a712b92c9fbd$export$7a8f4d33f6f9772c = "#B3F5FF";
var $7954a712b92c9fbd$export$776c9c497ef08533 = "#79E2F2";
var $7954a712b92c9fbd$export$69cb3ca10c1e330e = "#00C7E6";
var $7954a712b92c9fbd$export$9dc1ef0f3f48059b = "#00B8D9";
var $7954a712b92c9fbd$export$7c835c78b6fcdef8 = "#00A3BF";
var $7954a712b92c9fbd$export$6036577f95c3877e = "#008DA6";
var $7954a712b92c9fbd$export$29a4f05edc054374 = "#FFFFFF";
var $7954a712b92c9fbd$export$e655ef011c4aa1a2 = "#FAFBFC";
var $7954a712b92c9fbd$export$9fdfb749e33cdf97 = "#F4F5F7";
var $7954a712b92c9fbd$export$3e51e8f1440314ba = "#EBECF0";
var $7954a712b92c9fbd$export$1ce2d1575d444ceb = "#DFE1E6";
var $7954a712b92c9fbd$export$8754fc7e6d8b3000 = "#C1C7D0";
var $7954a712b92c9fbd$export$c2e91cbeada39b8b = "#B3BAC5";
var $7954a712b92c9fbd$export$5f71e19f3a7ad9de = "#A5ADBA";
var $7954a712b92c9fbd$export$eaa8c8a70ac22806 = "#97A0AF";
var $7954a712b92c9fbd$export$7c87d337fb91a97d = "#8993A4";
var $7954a712b92c9fbd$export$d6447c357493214f = "#7A869A";
var $7954a712b92c9fbd$export$f563ee71e9ee74cd = "#6B778C";
var $7954a712b92c9fbd$export$e2ef2124cf4024b1 = "#5E6C84";
var $7954a712b92c9fbd$export$eece5f492e429f08 = "#505F79";
var $7954a712b92c9fbd$export$c39c0fe0f26207ae = "#42526E";
var $7954a712b92c9fbd$export$7090862dc3038a9f = "#344563";
var $7954a712b92c9fbd$export$ad0bacf983b7ddaa = "#253858";
var $7954a712b92c9fbd$export$7d61b15e0da132af = "#172B4D";
var $7954a712b92c9fbd$export$fbda843f0a27fe96 = "#091E42";
var $7954a712b92c9fbd$export$791e57b27ca738ef = "rgba(9, 30, 66, 0.02)";
var $7954a712b92c9fbd$export$8d43898f60b96a82 = "rgba(9, 30, 66, 0.04)";
var $7954a712b92c9fbd$export$920c0d5c49070351 = "rgba(9, 30, 66, 0.08)";
var $7954a712b92c9fbd$export$46987b49aab6d1a8 = "rgba(9, 30, 66, 0.13)";
var $7954a712b92c9fbd$export$7d3359664e8bb0e5 = "rgba(9, 30, 66, 0.25)";
var $7954a712b92c9fbd$export$d2d3bedfb276cac0 = "rgba(9, 30, 66, 0.31)";
var $7954a712b92c9fbd$export$6e5e7499ff054f6d = "rgba(9, 30, 66, 0.36)";
var $7954a712b92c9fbd$export$59264b346c877fa7 = "rgba(9, 30, 66, 0.42)";
var $7954a712b92c9fbd$export$d092757d7c64925c = "rgba(9, 30, 66, 0.48)";
var $7954a712b92c9fbd$export$486ab785e4bac3c6 = "rgba(9, 30, 66, 0.54)";
var $7954a712b92c9fbd$export$fba592bbc6419fea = "rgba(9, 30, 66, 0.60)";
var $7954a712b92c9fbd$export$13609db0e6812ab8 = "rgba(9, 30, 66, 0.66)";
var $7954a712b92c9fbd$export$fbae4efaa892d883 = "rgba(9, 30, 66, 0.71)";
var $7954a712b92c9fbd$export$f13946d26f440ce6 = "rgba(9, 30, 66, 0.77)";
var $7954a712b92c9fbd$export$19f58225ac52a306 = "rgba(9, 30, 66, 0.82)";
var $7954a712b92c9fbd$export$6384f09da70e7b62 = "rgba(9, 30, 66, 0.89)";
var $7954a712b92c9fbd$export$d0dccc730683edc2 = "rgba(9, 30, 66, 0.95)";
var $7954a712b92c9fbd$export$2f6319cf7d736c2a = "#E6EDFA";
var $7954a712b92c9fbd$export$95126bc8884d6634 = "#DCE5F5";
var $7954a712b92c9fbd$export$8338d8c35d44ff1 = "#CED9EB";
var $7954a712b92c9fbd$export$5368d76ae4fbbda7 = "#B8C7E0";
var $7954a712b92c9fbd$export$9f0a771d16ec8d36 = "#ABBBD6";
var $7954a712b92c9fbd$export$abcf8c38338b4aa5 = "#9FB0CC";
var $7954a712b92c9fbd$export$97e81faa16a182c7 = "#8C9CB8";
var $7954a712b92c9fbd$export$bfe21c59123ecf33 = "#7988A3";
var $7954a712b92c9fbd$export$ee82aa2ea6a1558 = "#67758F";
var $7954a712b92c9fbd$export$682927c6ed76be02 = "#56637A";
var $7954a712b92c9fbd$export$91fd9994c5be9757 = "#455166";
var $7954a712b92c9fbd$export$d281fbfe3cff2df6 = "#3B475C";
var $7954a712b92c9fbd$export$3902c91d8b98a753 = "#313D52";
var $7954a712b92c9fbd$export$8e8133c1ba5845b5 = "#283447";
var $7954a712b92c9fbd$export$33ff357f6620b39 = "#202B3D";
var $7954a712b92c9fbd$export$633847cf062b69e0 = "#1B2638";
var $7954a712b92c9fbd$export$9776a6e503bdbf76 = "#121A29";
var $7954a712b92c9fbd$export$6c813d5160dff5db = "#0E1624";
var $7954a712b92c9fbd$export$3d4f271a500072a = "#0D1424";
var $7954a712b92c9fbd$export$fe151285c22759ec = "rgba(13, 20, 36, 0.06)";
var $7954a712b92c9fbd$export$a101c6190d0da34 = "rgba(13, 20, 36, 0.14)";
var $7954a712b92c9fbd$export$4b16f52932fda51 = "rgba(13, 20, 36, 0.18)";
var $7954a712b92c9fbd$export$a74bcd7b9845b0d8 = "rgba(13, 20, 36, 0.29)";
var $7954a712b92c9fbd$export$9209c179316d1751 = "rgba(13, 20, 36, 0.36)";
var $7954a712b92c9fbd$export$88f55133f636c8dd = "rgba(13, 20, 36, 0.40)";
var $7954a712b92c9fbd$export$51126f85d1009512 = "rgba(13, 20, 36, 0.47)";
var $7954a712b92c9fbd$export$a069b547bd23af78 = "rgba(13, 20, 36, 0.53)";
var $7954a712b92c9fbd$export$40cce05af3b2600a = "rgba(13, 20, 36, 0.63)";
var $7954a712b92c9fbd$export$b78942185925a0d = "rgba(13, 20, 36, 0.73)";
var $7954a712b92c9fbd$export$e058fb44b8eaafca = "rgba(13, 20, 36, 0.78)";
var $7954a712b92c9fbd$export$92b0b8de26920c18 = "rgba(13, 20, 36, 0.81)";
var $7954a712b92c9fbd$export$67564f7459d3fc9e = "rgba(13, 20, 36, 0.85)";
var $7954a712b92c9fbd$export$77868e1ca884ffa3 = "rgba(13, 20, 36, 0.89)";
var $7954a712b92c9fbd$export$2afd71d7d3ea2cd5 = "rgba(13, 20, 36, 0.92)";
var $7954a712b92c9fbd$export$f2a0acaab9972c70 = "rgba(13, 20, 36, 0.95)";
var $7954a712b92c9fbd$export$9ab70e67d6475361 = "rgba(13, 20, 36, 0.97)";
var $7954a712b92c9fbd$export$8ce1fd94bee2f412 = (0, $8RXtT.default)({
    light: "var(--ds-surface, ".concat($7954a712b92c9fbd$export$29a4f05edc054374, ")"),
    dark: "var(--ds-surface, ".concat($7954a712b92c9fbd$export$633847cf062b69e0, ")")
});
var $7954a712b92c9fbd$export$b861914ea877b580 = (0, $8RXtT.default)({
    light: "var(--ds-background-selected, ".concat($7954a712b92c9fbd$export$226de0355ed012f8, ")"),
    dark: "var(--ds-background-selected, ".concat($7954a712b92c9fbd$export$8c13c2ee36917869, ")")
});
var $7954a712b92c9fbd$export$3f1b020df94387af = (0, $8RXtT.default)({
    light: "var(--ds-background-neutral-hovered, ".concat($7954a712b92c9fbd$export$3e51e8f1440314ba, ")"),
    dark: "var(--ds-background-neutral-hovered, ".concat($7954a712b92c9fbd$export$d281fbfe3cff2df6, ")")
});
var $7954a712b92c9fbd$export$c0183dbab98ca63e = (0, $8RXtT.default)({
    light: "var(--ds-surface-overlay, ".concat($7954a712b92c9fbd$export$29a4f05edc054374, ")"),
    dark: "var(--ds-surface-overlay, ".concat($7954a712b92c9fbd$export$8e8133c1ba5845b5, ")")
});
var $7954a712b92c9fbd$export$6f093cfa640b7166 = (0, $8RXtT.default)({
    light: "var(--ds-text, ".concat($7954a712b92c9fbd$export$fbda843f0a27fe96, ")"),
    dark: "var(--ds-text, ".concat($7954a712b92c9fbd$export$5368d76ae4fbbda7, ")")
});
var $7954a712b92c9fbd$export$42f8e9c698766e7a = (0, $8RXtT.default)({
    light: "var(--ds-text, ".concat($7954a712b92c9fbd$export$7d61b15e0da132af, ")"),
    dark: "var(--ds-text, ".concat($7954a712b92c9fbd$export$5368d76ae4fbbda7, ")")
});
var $7954a712b92c9fbd$export$c2d157ca1c34b6e3 = (0, $8RXtT.default)({
    light: "var(--ds-text-selected, ".concat($7954a712b92c9fbd$export$b3de0ae08da2ce64, ")"),
    dark: "var(--ds-text-selected, ".concat($7954a712b92c9fbd$export$b3de0ae08da2ce64, ")")
});
var $7954a712b92c9fbd$export$1905ba28d7cf066f = (0, $8RXtT.default)({
    light: "var(--ds-text-subtlest, ".concat($7954a712b92c9fbd$export$f563ee71e9ee74cd, ")"),
    dark: "var(--ds-text-subtlest, ".concat($7954a712b92c9fbd$export$97e81faa16a182c7, ")")
});
var $7954a712b92c9fbd$export$bd9002130d306d39 = (0, $8RXtT.default)({
    light: "var(--ds-text-subtlest, ".concat($7954a712b92c9fbd$export$f563ee71e9ee74cd, ")"),
    dark: "var(--ds-text-subtlest, ".concat($7954a712b92c9fbd$export$bfe21c59123ecf33, ")")
});
var $7954a712b92c9fbd$export$46e4a324ac90507f = (0, $8RXtT.default)({
    light: "var(--ds-text, ".concat($7954a712b92c9fbd$export$7d61b15e0da132af, ")"),
    dark: "var(--ds-text, ".concat($7954a712b92c9fbd$export$5368d76ae4fbbda7, ")")
});
var $7954a712b92c9fbd$export$79f3f2b82beb0d36 = (0, $8RXtT.default)({
    light: "var(--ds-text-subtlest, ".concat($7954a712b92c9fbd$export$f563ee71e9ee74cd, ")"),
    dark: "var(--ds-text-subtlest, ".concat($7954a712b92c9fbd$export$97e81faa16a182c7, ")")
});
var $7954a712b92c9fbd$export$7bb0d5c671655cc4 = (0, $8RXtT.default)({
    light: $7954a712b92c9fbd$export$9fdfb749e33cdf97,
    dark: $7954a712b92c9fbd$export$8e8133c1ba5845b5
});
var $7954a712b92c9fbd$export$9c30223ca0a664fb = (0, $8RXtT.default)({
    light: "var(--ds-link, ".concat($7954a712b92c9fbd$export$b3de0ae08da2ce64, ")"),
    dark: "var(--ds-link, ".concat($7954a712b92c9fbd$export$ecfc1dff386a3e7a, ")")
});
var $7954a712b92c9fbd$export$7ed258b0728b004b = (0, $8RXtT.default)({
    light: "var(--ds-link-pressed, ".concat($7954a712b92c9fbd$export$e62e8919cca44969, ")"),
    dark: "var(--ds-link-pressed, ".concat($7954a712b92c9fbd$export$215b7063051591f1, ")")
});
var $7954a712b92c9fbd$export$dfa920d8decc8a59 = (0, $8RXtT.default)({
    light: "var(--ds-link-pressed, ".concat($7954a712b92c9fbd$export$a6ee3d71bc067634, ")"),
    dark: "var(--ds-link-pressed, ".concat($7954a712b92c9fbd$export$ecfc1dff386a3e7a, ")")
});
var $7954a712b92c9fbd$export$6069e6ad5c78f632 = (0, $8RXtT.default)({
    light: "var(--ds-border-focused, ".concat($7954a712b92c9fbd$export$215b7063051591f1, ")"),
    dark: "var(--ds-border-focused, ".concat($7954a712b92c9fbd$export$215b7063051591f1, ")")
});
var $7954a712b92c9fbd$export$9ad721cf3b3debe0 = (0, $8RXtT.default)({
    light: "var(--ds-background-brand-bold, ".concat($7954a712b92c9fbd$export$b3de0ae08da2ce64, ")"),
    dark: "var(--ds-background-brand-bold, ".concat($7954a712b92c9fbd$export$ecfc1dff386a3e7a, ")")
});
var $7954a712b92c9fbd$export$2aa0182783e7e9de = (0, $8RXtT.default)({
    light: $7954a712b92c9fbd$export$b3de0ae08da2ce64,
    dark: $7954a712b92c9fbd$export$ecfc1dff386a3e7a
});
var $7954a712b92c9fbd$export$8bf7dff220b82b4a = (0, $8RXtT.default)({
    light: $7954a712b92c9fbd$export$9dc1ef0f3f48059b,
    dark: $7954a712b92c9fbd$export$69cb3ca10c1e330e
});
var $7954a712b92c9fbd$export$e13cce2a2d16a9d4 = (0, $8RXtT.default)({
    light: $7954a712b92c9fbd$export$b48405b95304b5a1,
    dark: $7954a712b92c9fbd$export$6011520a64d9a187
});
var $7954a712b92c9fbd$export$a90204d1394caf30 = (0, $8RXtT.default)({
    light: $7954a712b92c9fbd$export$4a7404f376229999,
    dark: $7954a712b92c9fbd$export$4a7404f376229999
});
var $7954a712b92c9fbd$export$594c5a8758200c32 = (0, $8RXtT.default)({
    light: $7954a712b92c9fbd$export$c6930421db9fa514,
    dark: $7954a712b92c9fbd$export$c6930421db9fa514
});
var $7954a712b92c9fbd$export$955a2ebd2fb142ae = (0, $8RXtT.default)({
    light: $7954a712b92c9fbd$export$940e1f69e873f202,
    dark: $7954a712b92c9fbd$export$940e1f69e873f202
});
var $7954a712b92c9fbd$export$2a0674ff2eb10214 = function skeleton() {
    return "var(--ds-skeleton, ".concat($7954a712b92c9fbd$export$8d43898f60b96a82, ")");
};

});
parcelRegister("8RXtT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $675169ac06056715$export$2e2bcd8739ae039; });
/* eslint-disable prefer-rest-params */ 
var $iP7bd = parcelRequire("iP7bd");
// Unpack custom variants, and get correct value for the current theme
function $675169ac06056715$var$themedVariants(variantProp, variants) {
    return function(props) {
        var theme = (0, $iP7bd.default)(props);
        if (props && props[variantProp] && variants) {
            var modes = variants[props[variantProp]];
            if (modes && modes[theme.mode]) {
                var value = modes[theme.mode];
                if (value) return value;
                 // TS believes value can be undefined
            }
        }
        return "";
    };
}
function $675169ac06056715$export$2e2bcd8739ae039(modesOrVariant, variantModes) {
    if (typeof modesOrVariant === "string") return $675169ac06056715$var$themedVariants(modesOrVariant, variantModes);
    var modes = modesOrVariant;
    return function(props) {
        // Get theme from the user's props
        var theme = (0, $iP7bd.default)(props);
        // User isn't required to provide both light and dark values
        if (theme.mode in modes) {
            var value = modes[theme.mode]; // TS believes value can be undefined
            if (value) return value;
        }
        return "";
    };
}

});
parcelRegister("iP7bd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $db428f2e85920ac4$export$2e2bcd8739ae039; });

var $6LKMY = parcelRequire("6LKMY");
function $db428f2e85920ac4$export$2e2bcd8739ae039(props) {
    if (props && props.theme) {
        // Theme is the global Atlaskit theme
        if ((0, $6LKMY.CHANNEL) in props.theme) return props.theme[0, $6LKMY.CHANNEL];
        else if ("mode" in props.theme && (0, $6LKMY.THEME_MODES).includes(props.theme.mode)) return props.theme;
    }
    // If format not supported (or no theme provided), return standard theme
    return {
        mode: (0, $6LKMY.DEFAULT_THEME_MODE)
    };
}

});
parcelRegister("6LKMY", function(module, exports) {

$parcel$export(module.exports, "CHANNEL", function () { return $4edb6d2d9b0f439a$export$44ffba16bd48dac6; });
$parcel$export(module.exports, "DEFAULT_THEME_MODE", function () { return $4edb6d2d9b0f439a$export$c93026a968943f95; });
$parcel$export(module.exports, "THEME_MODES", function () { return $4edb6d2d9b0f439a$export$6ba72c8346b4c57e; });
$parcel$export(module.exports, "gridSize", function () { return $4edb6d2d9b0f439a$export$6d8204c2cb2e06b8; });
$parcel$export(module.exports, "fontSize", function () { return $4edb6d2d9b0f439a$export$85e3c3ca0c6fb93; });

var $e2xkU = parcelRequire("e2xkU");

var $apQ6e = parcelRequire("apQ6e");
var $4edb6d2d9b0f439a$export$44ffba16bd48dac6 = "__ATLASKIT_THEME__";
var $4edb6d2d9b0f439a$export$c93026a968943f95 = "light";
var $4edb6d2d9b0f439a$export$6ba72c8346b4c57e = [
    "light",
    "dark"
];
var $4edb6d2d9b0f439a$export$7a57f79000377ca2 = function borderRadius() {
    return 3;
};
var $4edb6d2d9b0f439a$export$6d8204c2cb2e06b8 = function gridSize() {
    return 8;
};
var $4edb6d2d9b0f439a$export$85e3c3ca0c6fb93 = function fontSize() {
    return 14;
};
var $4edb6d2d9b0f439a$export$6746fe0d9c9fab54 = function fontSizeSmall() {
    return 11;
};
var $4edb6d2d9b0f439a$export$a5975749f0374264 = function fontFamily() {
    return "-apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif";
};
var $4edb6d2d9b0f439a$export$356129969ee49c55 = function codeFontFamily() {
    return "'SFMono-Medium', 'SF Mono', 'Segoe UI Mono', 'Roboto Mono', 'Ubuntu Mono', Menlo, Consolas, Courier, monospace";
};
var $4edb6d2d9b0f439a$export$8e24544ddba725ee = function focusRing() {
    var color = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "var(--ds-border-focused, ".concat((0, $apQ6e.B200), ")");
    var outlineWidth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $4edb6d2d9b0f439a$export$6d8204c2cb2e06b8() / 4;
    (0, $e2xkU.default)("@atlaskit/theme", "focus ring mixin", "Please use `@atlaskit/focus-ring` instead.");
    return "\n  &:focus {\n    outline: none;\n    box-shadow: 0px 0px 0px ".concat(outlineWidth, "px ").concat(color, ";\n  }\n");
};
var $4edb6d2d9b0f439a$export$c0dd343266bc3261 = function noFocusRing() {
    return "\n  box-shadow: none;\n";
};
var $4edb6d2d9b0f439a$export$7be255094ccdc533 = {
    card: function card() {
        return 100;
    },
    navigation: function navigation() {
        return 200;
    },
    dialog: function dialog() {
        return 300;
    },
    layer: function layer() {
        return 400;
    },
    blanket: function blanket() {
        return 500;
    },
    modal: function modal() {
        return 510;
    },
    flag: function flag() {
        return 600;
    },
    spotlight: function spotlight() {
        return 700;
    },
    tooltip: function tooltip() {
        return 9999;
    }
};
var $4edb6d2d9b0f439a$export$a1b3edb637fb4f35 = function visuallyHidden() {
    (0, $e2xkU.default)("@atlaskit/theme", "visually hidden mixin", "Please use `@atlaskit/visually-hidden` instead.");
    return {
        border: "0 !important",
        clip: "rect(1px, 1px, 1px, 1px) !important",
        height: "1px !important",
        overflow: "hidden !important",
        padding: "0 !important",
        position: "absolute !important",
        width: "1px !important",
        whiteSpace: "nowrap !important"
    };
};
var $4edb6d2d9b0f439a$export$ba1d834b86d72a09 = $4edb6d2d9b0f439a$export$a1b3edb637fb4f35;
var $4edb6d2d9b0f439a$export$e497e856b4f89fcd = function skeletonShimmer() {
    return {
        css: {
            backgroundColor: "var(--ds-skeleton, ".concat((0, $apQ6e.skeleton)(), ")"),
            animationDuration: "1.5s",
            animationIterationCount: "infinite",
            animationTimingFunction: "linear",
            animationDirection: "alternate"
        },
        keyframes: {
            from: {
                backgroundColor: "var(--ds-skeleton, ".concat((0, $apQ6e.skeleton)(), ")")
            },
            to: {
                backgroundColor: "var(--ds-skeleton-subtle, ".concat((0, $apQ6e.N30A), ")")
            }
        }
    };
};

});
parcelRegister("e2xkU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a38b1c773694b7ef$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "propDeprecationWarning", function () { return $a38b1c773694b7ef$export$eb1decd851a5ae56; });

var $7EIka = parcelRequire("7EIka");

var $ahJoN = parcelRequire("ahJoN");
function $a38b1c773694b7ef$export$2e2bcd8739ae039(packageName, api, additionalMessage) {
    (0, $7EIka.default)("[".concat(packageName, "]: The ").concat(api, " is deprecated.").concat(additionalMessage && " ".concat(additionalMessage)));
}
function $a38b1c773694b7ef$export$eb1decd851a5ae56(packageName, propName, predicate, deprecationAnnouncementOnDAC) {
    typeof $ahJoN;
}

});
parcelRegister("7EIka", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $592ea6b4dcc8a092$export$2e2bcd8739ae039; });
/* eslint-disable no-console */ var $592ea6b4dcc8a092$var$printed = {};
function $592ea6b4dcc8a092$export$2e2bcd8739ae039(message) {
    if ($592ea6b4dcc8a092$var$printed[message]) return;
    $592ea6b4dcc8a092$var$printed[message] = true;
    if (typeof window !== "undefined") console.warn(message);
}

});






parcelRegister("9dX6I", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6b732d6c376718e0$export$2e2bcd8739ae039; });
function $6b732d6c376718e0$var$abort(event) {
    event.preventDefault();
    event.stopPropagation();
}
var $6b732d6c376718e0$var$tabKeyCode = 9;
function $6b732d6c376718e0$var$onKey(event) {
    // Allowing tab so that a user can move focus away
    if (event.keyCode === $6b732d6c376718e0$var$tabKeyCode) return;
    $6b732d6c376718e0$var$abort(event);
}
var $6b732d6c376718e0$var$block = {
    onMouseDownCapture: $6b732d6c376718e0$var$abort,
    onMouseUpCapture: $6b732d6c376718e0$var$abort,
    // because we have tabIndex = -1 when disabled,
    // keyboard events can only occur when there is an overlay
    onKeyDownCapture: $6b732d6c376718e0$var$onKey,
    onKeyUpCapture: $6b732d6c376718e0$var$onKey,
    onTouchStartCapture: $6b732d6c376718e0$var$abort,
    onTouchEndCapture: $6b732d6c376718e0$var$abort,
    onPointerDownCapture: $6b732d6c376718e0$var$abort,
    onPointerUpCapture: $6b732d6c376718e0$var$abort,
    onClickCapture: $6b732d6c376718e0$var$abort,
    // Just smashing the existing onClick for good measure
    onClick: $6b732d6c376718e0$var$abort
};
var $6b732d6c376718e0$var$doNotBlock = {};
function $6b732d6c376718e0$export$2e2bcd8739ae039(_ref) {
    var isInteractive = _ref.isInteractive;
    return isInteractive ? $6b732d6c376718e0$var$doNotBlock : $6b732d6c376718e0$var$block;
}

});

parcelRegister("gje9J", function(module, exports) {

$parcel$export(module.exports, "getCss", function () { return $bdf966c050d5db00$export$955358618f994a11; });
$parcel$export(module.exports, "getIconStyle", function () { return $bdf966c050d5db00$export$864eea3f4ec3368f; });
$parcel$export(module.exports, "getContentStyle", function () { return $bdf966c050d5db00$export$7ad0316cc0dd65a; });
$parcel$export(module.exports, "getFadingCss", function () { return $bdf966c050d5db00$export$1b5827d324e945b1; });
$parcel$export(module.exports, "overlayCss", function () { return $bdf966c050d5db00$export$1a9fe1b84c876bb5; });

var $b6jao = parcelRequire("b6jao");

var $jVTBW = parcelRequire("jVTBW");

var $6LKMY = parcelRequire("6LKMY");

var $dMpnm = parcelRequire("dMpnm");
function $bdf966c050d5db00$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $bdf966c050d5db00$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $bdf966c050d5db00$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($b6jao)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $bdf966c050d5db00$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $bdf966c050d5db00$var$gridSize = (0, $6LKMY.gridSize)();
var $bdf966c050d5db00$var$fontSize = (0, $6LKMY.fontSize)();
// ## Button layout
//
// /------------------------------------------------------------------------------------------------------------------\
// |       →  |  ←      |          |      →  |  ←      |           |      →  |  ←      |         |      →  |  ←       |
// |  10px →  |  ← 2px  |   icon   |  2px →  |  ← 2px  |           |  2px →  |  ← 2px  |  icon   |  2px →  |  ← 10px  |
// |  padding |  margin |  before  |  margin |  margin |  content  |  margin |  margin |  after  |  margin |  padding |
// |    (12px total)    |          |    (4px total)    |           |    (4px total)    |         |    (12px total)    |
// |       →  |  ←      |          |      →  |  ←      |           |      →  |  ←      |         |      →  |  ←       |
// \------------------------------------------------------------------------------------------------------------------/
//                                           ↑                               ↑
//                                        Margins don't collapse with inline-flex
//
var $bdf966c050d5db00$var$heights = {
    default: "".concat($bdf966c050d5db00$var$gridSize * 4 / $bdf966c050d5db00$var$fontSize, "em"),
    // 32px
    compact: "".concat($bdf966c050d5db00$var$gridSize * 3 / $bdf966c050d5db00$var$fontSize, "em"),
    none: "auto"
};
var $bdf966c050d5db00$var$lineHeights = {
    default: $bdf966c050d5db00$var$heights.default,
    compact: $bdf966c050d5db00$var$heights.compact,
    none: "inherit"
};
var $bdf966c050d5db00$var$padding = {
    // 10px gutter
    default: "0 ".concat($bdf966c050d5db00$var$gridSize + $bdf966c050d5db00$var$gridSize / 4, "px"),
    compact: "0 ".concat($bdf966c050d5db00$var$gridSize + $bdf966c050d5db00$var$gridSize / 4, "px"),
    none: "0"
};
var $bdf966c050d5db00$var$singleIconPadding = {
    // 2px gutter
    compact: "0 ".concat($bdf966c050d5db00$var$gridSize / 4, "px"),
    default: "0 ".concat($bdf966c050d5db00$var$gridSize / 4, "px"),
    none: "0"
};
var $bdf966c050d5db00$var$verticalAlign = {
    default: "middle",
    compact: "middle",
    none: "baseline"
};
var $bdf966c050d5db00$var$innerMargin = {
    content: "0 ".concat($bdf966c050d5db00$var$gridSize / 4, "px"),
    icon: "0 ".concat($bdf966c050d5db00$var$gridSize / 4, "px")
};
function $bdf966c050d5db00$var$getColor(_ref) {
    var group = _ref.group, key = _ref.key, mode = _ref.mode;
    var rule = group[key] || group.default;
    return rule[mode];
}
function $bdf966c050d5db00$var$getColors(_ref2) {
    var appearance = _ref2.appearance, key = _ref2.key, mode = _ref2.mode;
    return {
        background: $bdf966c050d5db00$var$getColor({
            group: (0, $dMpnm.default).background[appearance],
            key: key,
            mode: mode
        }),
        // Needing to add !important to overcome specificity issue caused by deprecated AtlaskitThemeProvider
        color: "".concat($bdf966c050d5db00$var$getColor({
            group: (0, $dMpnm.default).color[appearance],
            key: key,
            mode: mode
        }), " !important")
    };
}
function $bdf966c050d5db00$export$955358618f994a11(_ref3) {
    var appearance = _ref3.appearance, spacing = _ref3.spacing, mode = _ref3.mode, isSelected = _ref3.isSelected, shouldFitContainer = _ref3.shouldFitContainer, isOnlySingleIcon = _ref3.isOnlySingleIcon;
    var baseColors = $bdf966c050d5db00$var$getColors({
        appearance: appearance,
        key: isSelected ? "selected" : "default",
        mode: mode
    });
    return $bdf966c050d5db00$var$_objectSpread($bdf966c050d5db00$var$_objectSpread({
        // 0px margin added to css-reset
        alignItems: "baseline",
        borderWidth: 0,
        borderRadius: "var(--ds-border-radius, 3px)",
        boxSizing: "border-box",
        display: "inline-flex",
        fontSize: "inherit",
        fontStyle: "normal",
        // Chrome recently changed button so that they use 'arial' as the font family
        fontFamily: "inherit",
        fontWeight: 500,
        // margin for button has been applied to css reset
        maxWidth: "100%",
        // Needed to position overlay
        position: "relative",
        textAlign: "center",
        textDecoration: "none",
        transition: "background 0.1s ease-out, box-shadow 0.15s cubic-bezier(0.47, 0.03, 0.49, 1.38)",
        whiteSpace: "nowrap"
    }, baseColors), {}, {
        cursor: "pointer",
        height: $bdf966c050d5db00$var$heights[spacing],
        lineHeight: $bdf966c050d5db00$var$lineHeights[spacing],
        padding: isOnlySingleIcon ? $bdf966c050d5db00$var$singleIconPadding[spacing] : $bdf966c050d5db00$var$padding[spacing],
        verticalAlign: $bdf966c050d5db00$var$verticalAlign[spacing],
        width: shouldFitContainer ? "100%" : "auto",
        // justifyContent required for shouldFitContainer buttons with an icon inside
        justifyContent: "center",
        // Note: we cannot disable pointer events when there is an overlay.
        // That would be easy for styling, but it would start letting events through on disabled buttons
        // Disabling visited styles (just using the base colors)
        "&:visited": $bdf966c050d5db00$var$_objectSpread({}, baseColors),
        "&:hover": $bdf966c050d5db00$var$_objectSpread($bdf966c050d5db00$var$_objectSpread({}, $bdf966c050d5db00$var$getColors({
            appearance: appearance,
            key: isSelected ? "selected" : "hover",
            mode: mode
        })), {}, {
            textDecoration: !isSelected && (appearance === "link" || appearance === "subtle-link") ? "underline" : "inherit",
            // background, box-shadow
            transitionDuration: "0s, 0.15s"
        }),
        // giving active styles preference by listing them after focus
        "&:active": $bdf966c050d5db00$var$_objectSpread($bdf966c050d5db00$var$_objectSpread({}, $bdf966c050d5db00$var$getColors({
            appearance: appearance,
            key: isSelected ? "selected" : "active",
            mode: mode
        })), {}, {
            // background, box-shadow
            transitionDuration: "0s, 0s"
        }),
        // preventDefault prevents regular active styles from applying in Firefox
        '&[data-firefox-is-active="true"]': $bdf966c050d5db00$var$_objectSpread($bdf966c050d5db00$var$_objectSpread({}, $bdf966c050d5db00$var$getColors({
            appearance: appearance,
            key: isSelected ? "selected" : "active",
            mode: mode
        })), {}, {
            // background, box-shadow
            transitionDuration: "0s, 0s"
        }),
        // Giving disabled styles preference over active by listing them after.
        // Not using '&:disabled' because :disabled is not a valid state for all element types
        // so we are targeting the attribute
        // Attributes have the same specificity a pseudo classes so we are overriding :disabled here
        "&[disabled]": $bdf966c050d5db00$var$_objectSpread($bdf966c050d5db00$var$_objectSpread({}, $bdf966c050d5db00$var$getColors({
            appearance: appearance,
            key: "disabled",
            mode: mode
        })), {}, {
            cursor: "not-allowed",
            textDecoration: "none"
        }),
        '&[data-has-overlay="true"]': {
            cursor: "default",
            textDecoration: "none"
        },
        // disabling hover and active color changes when there is an overlay, but the button is not disabled
        '&[data-has-overlay="true"]:not([disabled]):hover, &[data-has-overlay="true"]:not([disabled]):active': $bdf966c050d5db00$var$_objectSpread({}, $bdf966c050d5db00$var$getColors({
            appearance: appearance,
            key: isSelected ? "selected" : "default",
            mode: mode
        })),
        "&::-moz-focus-inner": {
            border: 0,
            margin: 0,
            padding: 0
        }
    });
}
function $bdf966c050d5db00$export$864eea3f4ec3368f(_ref4) {
    var spacing = _ref4.spacing;
    return (0, $jVTBW.css)({
        display: "flex",
        // icon size cannot grow and shrink
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
        margin: spacing === "none" ? 0 : $bdf966c050d5db00$var$innerMargin.icon,
        flexGrow: 0,
        flexShrink: 0,
        alignSelf: "center",
        fontSize: 0,
        lineHeight: 0,
        userSelect: "none"
    });
}
function $bdf966c050d5db00$export$7ad0316cc0dd65a(_ref5) {
    var spacing = _ref5.spacing;
    return (0, $jVTBW.css)({
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
        margin: spacing === "none" ? 0 : $bdf966c050d5db00$var$innerMargin.content,
        // content can grow and shrink
        flexGrow: 1,
        flexShrink: 1,
        // ellipsis for overflow text
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap"
    });
}
function $bdf966c050d5db00$export$1b5827d324e945b1(_ref6) {
    var hasOverlay = _ref6.hasOverlay;
    return (0, $jVTBW.css)({
        opacity: hasOverlay ? 0 : 1,
        transition: "opacity 0.3s"
    });
}
var $bdf966c050d5db00$export$1a9fe1b84c876bb5 = {
    // stretching to full width / height of button
    // this is important as we need it to still block
    // event if clicking in the button's own padding
    position: "absolute",
    left: 0,
    top: 0,
    right: 0,
    bottom: 0,
    // Putting all children in the center
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
};

});
parcelRegister("dMpnm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a0837128b6d69c97$export$2e2bcd8739ae039; });

var $apQ6e = parcelRequire("apQ6e");
// Hard coding the active rgba color value rather than using a helper to convert it
// With helper it would be: hex2rgba(colors.B75, 0.6)
var $a0837128b6d69c97$var$fadedB75 = "rgba(179, 212, 255, 0.6)";
var $a0837128b6d69c97$var$values = {
    // Default appearance
    background: {
        default: {
            default: {
                light: "var(--ds-background-neutral, ".concat($apQ6e.N20A, ")"),
                dark: "var(--ds-background-neutral, ".concat($apQ6e.DN70, ")")
            },
            hover: {
                light: "var(--ds-background-neutral-hovered, ".concat($apQ6e.N30A, ")"),
                dark: "var(--ds-background-neutral-hovered, ".concat($apQ6e.DN60, ")")
            },
            active: {
                light: "var(--ds-background-neutral-pressed, ".concat($a0837128b6d69c97$var$fadedB75, ")"),
                dark: "var(--ds-background-neutral-pressed, ".concat($apQ6e.B75, ")")
            },
            disabled: {
                light: "var(--ds-background-disabled, ".concat($apQ6e.N20A, ")"),
                dark: "var(--ds-background-disabled, ".concat($apQ6e.DN70, ")")
            },
            selected: {
                light: "var(--ds-background-selected, ".concat($apQ6e.N700, ")"),
                dark: "var(--ds-background-selected, ".concat($apQ6e.DN0, ")")
            },
            focusSelected: {
                light: "var(--ds-background-selected, ".concat($apQ6e.N700, ")"),
                dark: "var(--ds-background-selected, ".concat($apQ6e.DN0, ")")
            }
        },
        primary: {
            default: {
                light: "var(--ds-background-brand-bold, ".concat($apQ6e.B400, ")"),
                dark: "var(--ds-background-brand-bold, ".concat($apQ6e.B100, ")")
            },
            hover: {
                light: "var(--ds-background-brand-bold-hovered, ".concat($apQ6e.B300, ")"),
                dark: "var(--ds-background-brand-bold-hovered, ".concat($apQ6e.B75, ")")
            },
            active: {
                light: "var(--ds-background-brand-bold-pressed, ".concat($apQ6e.B500, ")"),
                dark: "var(--ds-background-brand-bold-pressed, ".concat($apQ6e.B200, ")")
            },
            disabled: {
                light: "var(--ds-background-disabled, ".concat($apQ6e.N20A, ")"),
                dark: "var(--ds-background-disabled, ".concat($apQ6e.DN70, ")")
            },
            selected: {
                light: "var(--ds-background-selected, ".concat($apQ6e.N700, ")"),
                dark: "var(--ds-background-selected, ".concat($apQ6e.DN0, ")")
            },
            focusSelected: {
                light: "var(--ds-background-selected, ".concat($apQ6e.N700, ")"),
                dark: "var(--ds-background-selected, ".concat($apQ6e.DN0, ")")
            }
        },
        warning: {
            default: {
                light: "var(--ds-background-warning-bold, ".concat($apQ6e.Y300, ")"),
                dark: "var(--ds-background-warning-bold, ".concat($apQ6e.Y300, ")")
            },
            hover: {
                light: "var(--ds-background-warning-bold-hovered, ".concat($apQ6e.Y200, ")"),
                dark: "var(--ds-background-warning-bold-hovered, ".concat($apQ6e.Y200, ")")
            },
            active: {
                light: "var(--ds-background-warning-bold-pressed, ".concat($apQ6e.Y400, ")"),
                dark: "var(--ds-background-warning-bold-pressed, ".concat($apQ6e.Y400, ")")
            },
            disabled: {
                light: "var(--ds-background-disabled, ".concat($apQ6e.N20A, ")"),
                dark: "var(--ds-background-disabled, ".concat($apQ6e.DN70, ")")
            },
            selected: {
                light: "var(--ds-background-selected, ".concat($apQ6e.Y400, ")"),
                dark: "var(--ds-background-selected, ".concat($apQ6e.Y400, ")")
            },
            focusSelected: {
                light: "var(--ds-background-selected, ".concat($apQ6e.Y400, ")"),
                dark: "var(--ds-background-selected, ".concat($apQ6e.Y400, ")")
            }
        },
        danger: {
            default: {
                light: "var(--ds-background-danger-bold, ".concat($apQ6e.R400, ")"),
                dark: "var(--ds-background-danger-bold, ".concat($apQ6e.R400, ")")
            },
            hover: {
                light: "var(--ds-background-danger-bold-hovered, ".concat($apQ6e.R300, ")"),
                dark: "var(--ds-background-danger-bold-hovered, ".concat($apQ6e.R300, ")")
            },
            active: {
                light: "var(--ds-background-danger-bold-pressed, ".concat($apQ6e.R500, ")"),
                dark: "var(--ds-background-danger-bold-pressed, ".concat($apQ6e.R500, ")")
            },
            disabled: {
                light: "var(--ds-background-disabled, ".concat($apQ6e.N20A, ")"),
                dark: "var(--ds-background-disabled, ".concat($apQ6e.DN70, ")")
            },
            selected: {
                light: "var(--ds-background-selected, ".concat($apQ6e.R500, ")"),
                dark: "var(--ds-background-selected, ".concat($apQ6e.R500, ")")
            },
            focusSelected: {
                light: "var(--ds-background-selected, ".concat($apQ6e.R500, ")"),
                dark: "var(--ds-background-selected, ".concat($apQ6e.R500, ")")
            }
        },
        link: {
            default: {
                light: "var(--ds-background-neutral-subtle, none)",
                dark: "var(--ds-background-neutral-subtle, none)"
            },
            selected: {
                light: "var(--ds-background-selected, ".concat($apQ6e.N700, ")"),
                dark: "var(--ds-background-selected, ".concat($apQ6e.N20, ")")
            },
            focusSelected: {
                light: "var(--ds-background-selected, ".concat($apQ6e.N700, ")"),
                dark: "var(--ds-background-selected, ".concat($apQ6e.N20, ")")
            }
        },
        subtle: {
            default: {
                light: "var(--ds-background-neutral-subtle, none)",
                dark: "var(--ds-background-neutral-subtle, none)"
            },
            hover: {
                light: "var(--ds-background-neutral-subtle-hovered, ".concat($apQ6e.N30A, ")"),
                dark: "var(--ds-background-neutral-subtle-hovered, ".concat($apQ6e.DN60, ")")
            },
            active: {
                light: "var(--ds-background-neutral-subtle-pressed, ".concat($a0837128b6d69c97$var$fadedB75, ")"),
                dark: "var(--ds-background-neutral-subtle-pressed, ".concat($apQ6e.B75, ")")
            },
            disabled: {
                light: "var(--ds-background-neutral-subtle, none)",
                dark: "var(--ds-background-neutral-subtle, none)"
            },
            selected: {
                light: "var(--ds-background-selected, ".concat($apQ6e.N700, ")"),
                dark: "var(--ds-background-selected, ".concat($apQ6e.DN0, ")")
            },
            focusSelected: {
                light: "var(--ds-background-selected, ".concat($apQ6e.N700, ")"),
                dark: "var(--ds-background-selected, ".concat($apQ6e.DN0, ")")
            }
        },
        "subtle-link": {
            default: {
                light: "var(--ds-background-neutral-subtle, none)",
                dark: "var(--ds-background-neutral-subtle, none)"
            },
            selected: {
                light: "var(--ds-background-selected, ".concat($apQ6e.N700, ")"),
                dark: "var(--ds-background-selected, ".concat($apQ6e.N20, ")")
            },
            focusSelected: {
                light: "var(--ds-background-selected, ".concat($apQ6e.N700, ")"),
                dark: "var(--ds-background-selected, ".concat($apQ6e.N20, ")")
            }
        }
    },
    color: {
        default: {
            default: {
                light: "var(--ds-text, ".concat($apQ6e.N500, ")"),
                dark: "var(--ds-text, ".concat($apQ6e.DN400, ")")
            },
            active: {
                light: "var(--ds-text, ".concat($apQ6e.B400, ")"),
                dark: "var(--ds-text, ".concat($apQ6e.B400, ")")
            },
            disabled: {
                light: "var(--ds-text-disabled, ".concat($apQ6e.N70, ")"),
                dark: "var(--ds-text-disabled, ".concat($apQ6e.DN30, ")")
            },
            selected: {
                light: "var(--ds-text-selected, ".concat($apQ6e.N20, ")"),
                dark: "var(--ds-text-selected, ".concat($apQ6e.DN400, ")")
            },
            focusSelected: {
                light: "var(--ds-text-selected, ".concat($apQ6e.N20, ")"),
                dark: "var(--ds-text-selected, ".concat($apQ6e.DN400, ")")
            }
        },
        primary: {
            default: {
                light: "var(--ds-text-inverse, ".concat($apQ6e.N0, ")"),
                dark: "var(--ds-text-inverse, ".concat($apQ6e.DN30, ")")
            },
            disabled: {
                light: "var(--ds-text-disabled, ".concat($apQ6e.N70, ")"),
                dark: "var(--ds-text-disabled, ".concat($apQ6e.DN30, ")")
            },
            selected: {
                light: "var(--ds-text-selected, ".concat($apQ6e.N20, ")"),
                dark: "var(--ds-text-selected, ".concat($apQ6e.DN400, ")")
            },
            focusSelected: {
                light: "var(--ds-text-selected, ".concat($apQ6e.N20, ")"),
                dark: "var(--ds-text-selected, ".concat($apQ6e.DN400, ")")
            }
        },
        warning: {
            default: {
                light: "var(--ds-text-warning-inverse, ".concat($apQ6e.N800, ")"),
                dark: "var(--ds-text-warning-inverse, ".concat($apQ6e.N800, ")")
            },
            disabled: {
                light: "var(--ds-text-disabled, ".concat($apQ6e.N70, ")"),
                dark: "var(--ds-text-disabled, ".concat($apQ6e.DN30, ")")
            },
            selected: {
                light: "var(--ds-text-selected, ".concat($apQ6e.N800, ")"),
                dark: "var(--ds-text-selected, ".concat($apQ6e.N800, ")")
            },
            focusSelected: {
                light: "var(--ds-text-selected, ".concat($apQ6e.N800, ")"),
                dark: "var(--ds-text-selected, ".concat($apQ6e.N800, ")")
            }
        },
        danger: {
            default: {
                light: "var(--ds-text-inverse, ".concat($apQ6e.N0, ")"),
                dark: "var(--ds-text-inverse, ".concat($apQ6e.N0, ")")
            },
            disabled: {
                light: "var(--ds-text-disabled, ".concat($apQ6e.N70, ")"),
                dark: "var(--ds-text-disabled, ".concat($apQ6e.DN30, ")")
            },
            selected: {
                light: "var(--ds-text-selected, ".concat($apQ6e.N0, ")"),
                dark: "var(--ds-text-selected, ".concat($apQ6e.N0, ")")
            },
            focusSelected: {
                light: "var(--ds-text-selected, ".concat($apQ6e.N0, ")"),
                dark: "var(--ds-text-selected, ".concat($apQ6e.N0, ")")
            }
        },
        link: {
            default: {
                light: "var(--ds-link, ".concat($apQ6e.B400, ")"),
                dark: "var(--ds-link, ".concat($apQ6e.B100, ")")
            },
            hover: {
                light: "var(--ds-link, ".concat($apQ6e.B300, ")"),
                dark: "var(--ds-link, ".concat($apQ6e.B75, ")")
            },
            active: {
                light: "var(--ds-link-pressed, ".concat($apQ6e.B500, ")"),
                dark: "var(--ds-link-pressed, ".concat($apQ6e.B200, ")")
            },
            disabled: {
                light: "var(--ds-text-disabled, ".concat($apQ6e.N70, ")"),
                dark: "var(--ds-text-disabled, ".concat($apQ6e.DN100, ")")
            },
            selected: {
                light: "var(--ds-text-selected, ".concat($apQ6e.N20, ")"),
                dark: "var(--ds-text-selected, ".concat($apQ6e.N700, ")")
            },
            focusSelected: {
                light: "var(--ds-text-selected, ".concat($apQ6e.N20, ")"),
                dark: "var(--ds-text-selected, ".concat($apQ6e.N700, ")")
            }
        },
        subtle: {
            default: {
                light: "var(--ds-text, ".concat($apQ6e.N500, ")"),
                dark: "var(--ds-text, ".concat($apQ6e.DN400, ")")
            },
            active: {
                light: "var(--ds-text, ".concat($apQ6e.B400, ")"),
                dark: "var(--ds-text, ".concat($apQ6e.B400, ")")
            },
            disabled: {
                light: "var(--ds-text-disabled, ".concat($apQ6e.N70, ")"),
                dark: "var(--ds-text-disabled, ".concat($apQ6e.DN100, ")")
            },
            selected: {
                light: "var(--ds-text-selected, ".concat($apQ6e.N20, ")"),
                dark: "var(--ds-text-selected, ".concat($apQ6e.DN400, ")")
            },
            focusSelected: {
                light: "var(--ds-text-selected, ".concat($apQ6e.N20, ")"),
                dark: "var(--ds-text-selected, ".concat($apQ6e.DN400, ")")
            }
        },
        "subtle-link": {
            default: {
                light: "var(--ds-text-subtle, ".concat($apQ6e.N200, ")"),
                dark: "var(--ds-text-subtle, ".concat($apQ6e.DN400, ")")
            },
            hover: {
                light: "var(--ds-text-subtle, ".concat($apQ6e.N90, ")"),
                dark: "var(--ds-text-subtle, ".concat($apQ6e.B50, ")")
            },
            active: {
                light: "var(--ds-text, ".concat($apQ6e.N400, ")"),
                dark: "var(--ds-text, ".concat($apQ6e.DN300, ")")
            },
            disabled: {
                light: "var(--ds-text-disabled, ".concat($apQ6e.N70, ")"),
                dark: "var(--ds-text-disabled, ".concat($apQ6e.DN100, ")")
            },
            selected: {
                light: "var(--ds-text-selected, ".concat($apQ6e.N20, ")"),
                dark: "var(--ds-text-selected, ".concat($apQ6e.DN400, ")")
            },
            focusSelected: {
                light: "var(--ds-text-selected, ".concat($apQ6e.N20, ")"),
                dark: "var(--ds-text-selected, ".concat($apQ6e.DN400, ")")
            }
        }
    }
};
var $a0837128b6d69c97$export$2e2bcd8739ae039 = $a0837128b6d69c97$var$values;

});


parcelRegister("d6LjR", function(module, exports) {

$parcel$export(module.exports, "getIfVisuallyHiddenChildren", function () { return $98b08a8a112f2a54$export$20bbd2efb0d734c4; });

var $dAx5m = parcelRequire("dAx5m");

var $ez4n6 = parcelRequire("ez4n6");
var $98b08a8a112f2a54$export$20bbd2efb0d734c4 = function getIfVisuallyHiddenChildren(children) {
    return children && /*#__PURE__*/ (0, $dAx5m.isValidElement)(children) && children.type === (0, $ez4n6.default);
};

});
parcelRegister("ez4n6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a9a7b9a9c3c610bf$export$2e2bcd8739ae039; });
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $jVTBW = parcelRequire("jVTBW");
// eslint-disable-next-line @atlaskit/design-system/use-visually-hidden
var $a9a7b9a9c3c610bf$var$visuallyHiddenStyles = (0, $jVTBW.css)({
    width: "1px",
    height: "1px",
    padding: "0",
    position: "absolute",
    border: "0",
    clip: "rect(1px, 1px, 1px, 1px)",
    overflow: "hidden",
    whiteSpace: "nowrap"
});
/**
 * __Visually hidden__
 *
 * A composable element to apply a visually hidden effect to children.
 * Useful for accessibility compliance.
 *
 * @example
 * ```jsx
 * import VisuallyHidden from '@atlaskit/visually-hidden';
 *
 * export default () => (
 *   <div style={{ border: '1px solid black' }}>
 *      There is text hidden between the brackets [
 *      <VisuallyHidden>Can't see me!</VisuallyHidden>]
 *   </div>
 * );
 * ```
 */ var $a9a7b9a9c3c610bf$var$VisuallyHidden = function VisuallyHidden(_ref) {
    var children = _ref.children, testId = _ref.testId, role = _ref.role, id = _ref.id;
    return (0, $jVTBW.jsx)("span", {
        id: id,
        "data-testid": testId,
        css: $a9a7b9a9c3c610bf$var$visuallyHiddenStyles,
        role: role
    }, children);
};
var $a9a7b9a9c3c610bf$export$2e2bcd8739ae039 = $a9a7b9a9c3c610bf$var$VisuallyHidden;

});



parcelRegister("3qE8l", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $27f2ee7d190d2066$export$2e2bcd8739ae039; });

var $d6LjR = parcelRequire("d6LjR");
function $27f2ee7d190d2066$export$2e2bcd8739ae039(_ref) {
    var children = _ref.children, iconBefore = _ref.iconBefore, iconAfter = _ref.iconAfter;
    if ((0, $d6LjR.getIfVisuallyHiddenChildren)(children)) return true;
    if (children) return false;
    if (iconBefore && !iconAfter) return true;
    if (!iconBefore && iconAfter) return true;
    return false;
}

});


parcelRegister("lNmBx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $fddfb55564577c2c$var$_react = $fddfb55564577c2c$var$_interopRequireDefault((parcelRequire("dAx5m")));

var $9eGJl = parcelRequire("9eGJl");
function $fddfb55564577c2c$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $fddfb55564577c2c$var$CrossIcon = (props)=>/*#__PURE__*/ $fddfb55564577c2c$var$_react.default.createElement($9eGJl.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path d="M12 10.586L6.707 5.293a1 1 0 00-1.414 1.414L10.586 12l-5.293 5.293a1 1 0 001.414 1.414L12 13.414l5.293 5.293a1 1 0 001.414-1.414L13.414 12l5.293-5.293a1 1 0 10-1.414-1.414L12 10.586z" fill="currentColor"/></svg>`
    }, props));
$fddfb55564577c2c$var$CrossIcon.displayName = "CrossIcon";
var $fddfb55564577c2c$var$_default = $fddfb55564577c2c$var$CrossIcon;
module.exports.default = $fddfb55564577c2c$var$_default;

});
parcelRegister("9eGJl", function(module, exports) {

$parcel$export(module.exports, "Icon", function () { return $6b96913a2f9ffe26$export$f04a61298a47a40f; });
$parcel$export(module.exports, "default", function () { return $6b96913a2f9ffe26$export$2e2bcd8739ae039; });

var $5JZwS = parcelRequire("5JZwS");

var $hbrLb = parcelRequire("hbrLb");

var $dAx5m = parcelRequire("dAx5m");

var $jVTBW = parcelRequire("jVTBW");

var $fuUDU = parcelRequire("fuUDU");

var $fEt5F = parcelRequire("fEt5F");
function $6b96913a2f9ffe26$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $6b96913a2f9ffe26$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $6b96913a2f9ffe26$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($hbrLb)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $6b96913a2f9ffe26$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
/**
 * We are hiding these props from consumers as they're used to
 * hack around icon sizing specifically for icon-file-type.
 */ var $6b96913a2f9ffe26$var$iconStyles = (0, $jVTBW.css)({
    display: "inline-block",
    flexShrink: 0,
    lineHeight: 1,
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
    "> svg": $6b96913a2f9ffe26$var$_objectSpread($6b96913a2f9ffe26$var$_objectSpread({}, (0, $fEt5F.commonSVGStyles)), {}, {
        maxWidth: "100%",
        maxHeight: "100%",
        color: "var(--icon-primary-color)",
        fill: "var(--icon-secondary-color)",
        verticalAlign: "bottom"
    })
});
/**
 * For windows high contrast mode
 */ var $6b96913a2f9ffe26$var$baseHcmStyles = (0, $jVTBW.css)({
    "@media screen and (forced-colors: active)": {
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
        "> svg": {
            filter: "grayscale(1)",
            "--icon-primary-color": "CanvasText",
            // foreground
            "--icon-secondary-color": "Canvas" // background
        }
    }
});
var $6b96913a2f9ffe26$var$primaryEqualsSecondaryHcmStyles = (0, $jVTBW.css)({
    "@media screen and (forced-colors: active)": {
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
        "> svg": {
            // if the primaryColor is the same as the secondaryColor we
            // set the --icon-primary-color to Canvas
            // this is usually to convey state i.e. Checkbox checked -> not checked
            "--icon-primary-color": "Canvas" // foreground
        }
    }
});
var $6b96913a2f9ffe26$var$secondaryTransparentHcmStyles = (0, $jVTBW.css)({
    "@media screen and (forced-colors: active)": {
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
        "> svg": {
            "--icon-secondary-color": "transparent" // background
        }
    }
});
var $6b96913a2f9ffe26$export$f04a61298a47a40f = /*#__PURE__*/ (0, $dAx5m.memo)(function Icon(props) {
    var _ref = props, Glyph = _ref.glyph, dangerouslySetGlyph = _ref.dangerouslySetGlyph, _ref$primaryColor = _ref.primaryColor, primaryColor = _ref$primaryColor === void 0 ? "currentColor" : _ref$primaryColor, secondaryColor = _ref.secondaryColor, size = _ref.size, testId = _ref.testId, label = _ref.label, width = _ref.width, height = _ref.height;
    var glyphProps = dangerouslySetGlyph ? {
        dangerouslySetInnerHTML: {
            __html: dangerouslySetGlyph
        }
    } : {
        children: Glyph ? (0, $jVTBW.jsx)(Glyph, {
            role: "presentation"
        }) : null
    };
    var dimensions = (0, $fEt5F.getIconSize)({
        width: width,
        height: height,
        size: size
    });
    return (0, $jVTBW.jsx)("span", (0, (/*@__PURE__*/$parcel$interopDefault($5JZwS)))({
        "data-testid": testId,
        role: label ? "img" : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: {
            "--icon-primary-color": primaryColor,
            "--icon-secondary-color": secondaryColor || (0, $fuUDU.getBackground)()
        }
    }, glyphProps, {
        css: [
            $6b96913a2f9ffe26$var$iconStyles,
            $6b96913a2f9ffe26$var$baseHcmStyles,
            primaryColor === secondaryColor && $6b96913a2f9ffe26$var$primaryEqualsSecondaryHcmStyles,
            secondaryColor === "transparent" && $6b96913a2f9ffe26$var$secondaryTransparentHcmStyles,
            // NB: This can be resolved if this component, composes base SVG / and/or skeleton
            // We could then simplify how common styles are dealt with simply by encapsulating them
            // at their appropriate level and/or having a singular approach to css variables in the package
            dimensions && // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
            (0, $jVTBW.css)({
                width: dimensions.width,
                height: dimensions.height,
                "> svg": dimensions
            })
        ]
    }));
});
var $6b96913a2f9ffe26$export$2e2bcd8739ae039 = $6b96913a2f9ffe26$export$f04a61298a47a40f;

});
parcelRegister("5JZwS", function(module, exports) {
function $42e0e226be071ffa$var$_extends() {
    return module.exports = $42e0e226be071ffa$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $42e0e226be071ffa$var$_extends.apply(null, arguments);
}
module.exports = $42e0e226be071ffa$var$_extends, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("hbrLb", function(module, exports) {

var $lT2vV = parcelRequire("lT2vV");
function $c828ff49a9eda07a$var$_defineProperty(e, r, t) {
    return (r = $lT2vV(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
module.exports = $c828ff49a9eda07a$var$_defineProperty, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("lT2vV", function(module, exports) {

var $4xh3z = parcelRequire("4xh3z");
var $fef0af372b03de12$var$_typeof = $4xh3z.default;

var $4hn4u = parcelRequire("4hn4u");
function $fef0af372b03de12$var$toPropertyKey(t) {
    var i = $4hn4u(t, "string");
    return "symbol" == $fef0af372b03de12$var$_typeof(i) ? i : i + "";
}
module.exports = $fef0af372b03de12$var$toPropertyKey, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("4xh3z", function(module, exports) {
function $34d779940ce9381c$var$_typeof(o) {
    "@babel/helpers - typeof";
    return module.exports = $34d779940ce9381c$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $34d779940ce9381c$var$_typeof(o);
}
module.exports = $34d779940ce9381c$var$_typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("4hn4u", function(module, exports) {

var $4xh3z = parcelRequire("4xh3z");
var $31daa579a9fce6f0$var$_typeof = $4xh3z.default;
function $31daa579a9fce6f0$var$toPrimitive(t, r) {
    if ("object" != $31daa579a9fce6f0$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $31daa579a9fce6f0$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
module.exports = $31daa579a9fce6f0$var$toPrimitive, module.exports.__esModule = true, module.exports["default"] = module.exports;

});



parcelRegister("fuUDU", function(module, exports) {

$parcel$export(module.exports, "getBackground", function () { return $b4859866ffbf269e$export$18cb9425622d4e06; });
var $b4859866ffbf269e$export$18cb9425622d4e06 = function getBackground() {
    return "var(--ds-surface, #FFFFFF)";
};

});

parcelRegister("fEt5F", function(module, exports) {

$parcel$export(module.exports, "commonSVGStyles", function () { return $b651283335dc96b6$export$16374db1c3e6dfba; });
$parcel$export(module.exports, "getIconSize", function () { return $b651283335dc96b6$export$3eb7d6130acfda37; });

var $7S0zF = parcelRequire("7S0zF");

var $jVTBW = parcelRequire("jVTBW");
var $b651283335dc96b6$export$16374db1c3e6dfba = {
    overflow: "hidden",
    pointerEvents: "none",
    /**
   * Stop-color doesn't properly apply in chrome when the inherited/current color changes.
   * We have to initially set stop-color to inherit (either via DOM attribute or an initial CSS
   * rule) and then override it with currentColor for the color changes to be picked up.
   */ stop: {
        stopColor: "currentColor"
    }
};
var $b651283335dc96b6$var$smallStyles = (0, $jVTBW.css)((0, $7S0zF.dimensions).small);
var $b651283335dc96b6$var$mediumStyles = (0, $jVTBW.css)((0, $7S0zF.dimensions).medium);
var $b651283335dc96b6$var$largeStyles = (0, $jVTBW.css)((0, $7S0zF.dimensions).large);
var $b651283335dc96b6$var$xlargeStyles = (0, $jVTBW.css)((0, $7S0zF.dimensions).xlarge);
var $b651283335dc96b6$export$ef0ad74202575b64 = {
    small: $b651283335dc96b6$var$smallStyles,
    medium: $b651283335dc96b6$var$mediumStyles,
    large: $b651283335dc96b6$var$largeStyles,
    xlarge: $b651283335dc96b6$var$xlargeStyles
};
var $b651283335dc96b6$export$3eb7d6130acfda37 = function getIconSize(_ref) {
    var width = _ref.width, height = _ref.height, size = _ref.size;
    if (width && height) return {
        width: width,
        height: height
    };
    if (size) return (0, $7S0zF.dimensions)[size];
    return undefined;
};

});
parcelRegister("7S0zF", function(module, exports) {

$parcel$export(module.exports, "dimensions", function () { return $5bae059880a8a587$export$62ad7b0c781000e9; });
var $5bae059880a8a587$export$c647cb0ee6e282fe = {
    small: "16px",
    medium: "24px",
    large: "32px",
    xlarge: "48px"
};
var $5bae059880a8a587$export$7bd66fc94c81bf84 = {
    small: "small",
    medium: "medium",
    large: "large",
    xlarge: "xlarge"
};
var $5bae059880a8a587$export$62ad7b0c781000e9 = {
    small: {
        width: $5bae059880a8a587$export$c647cb0ee6e282fe.small,
        height: $5bae059880a8a587$export$c647cb0ee6e282fe.small
    },
    medium: {
        width: $5bae059880a8a587$export$c647cb0ee6e282fe.medium,
        height: $5bae059880a8a587$export$c647cb0ee6e282fe.medium
    },
    large: {
        width: $5bae059880a8a587$export$c647cb0ee6e282fe.large,
        height: $5bae059880a8a587$export$c647cb0ee6e282fe.large
    },
    xlarge: {
        width: $5bae059880a8a587$export$c647cb0ee6e282fe.xlarge,
        height: $5bae059880a8a587$export$c647cb0ee6e282fe.xlarge
    }
};

});




parcelRegister("02zM4", function(module, exports) {

$parcel$export(module.exports, "useExitingPersistence", function () { return $007bf00b52f2e2de$export$3b6f38abbdcbd000; });
$parcel$export(module.exports, "default", function () { return $007bf00b52f2e2de$export$2e2bcd8739ae039; });

var $dAx5m = parcelRequire("dAx5m");

var $jV6vz = parcelRequire("jV6vz");

var $bRFkb = parcelRequire("bRFkb");
/**
 * Internally we will be playing with an element that will always have a key defined.
 */ /**
 * Internal data passed to child motions.
 */ // We define empty context here so the object doesn't change.
var $007bf00b52f2e2de$var$emptyContext = {
    // Motions will always appear if not inside a exiting persistence component.
    appear: true,
    isExiting: false
};
var $007bf00b52f2e2de$var$ExitingContext = /*#__PURE__*/ (0, $dAx5m.createContext)($007bf00b52f2e2de$var$emptyContext);
var $007bf00b52f2e2de$var$isAnyPreviousKeysMissingFromCurrent = function isAnyPreviousKeysMissingFromCurrent(currentMap, previous) {
    for(var i = 0; i < previous.length; i++){
        var element = previous[i];
        var _key = element.key;
        if (!currentMap[_key]) return true;
    }
    return false;
};
/**
 * This method will wrap any React element with a context provider. We're using context (instead of
 * cloneElement) so we can communicate between multiple elements without the need of prop drilling
 * (results in a better API for consumers).
 */ var $007bf00b52f2e2de$var$wrapChildWithContextProvider = function wrapChildWithContextProvider(child) {
    var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $007bf00b52f2e2de$var$emptyContext;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement($007bf00b52f2e2de$var$ExitingContext.Provider, {
        key: "".concat(child.key, "-provider"),
        value: value
    }, child);
};
var $007bf00b52f2e2de$var$childrenToObj = function childrenToObj(children) {
    return children.reduce(function(acc, child) {
        acc[child.key] = child;
        return acc;
    }, {});
};
var $007bf00b52f2e2de$var$spliceNewElementsIntoPrevious = function spliceNewElementsIntoPrevious(current, previous) {
    var splicedChildren = previous.concat([]);
    var previousMap = $007bf00b52f2e2de$var$childrenToObj(previous);
    for(var i = 0; i < current.length; i++){
        var child = current[i];
        var childIsNew = !previousMap[child.key];
        if (childIsNew) // This will insert the new element after the previous element.
        splicedChildren.splice(i + 1, 0, child);
    }
    return splicedChildren;
};
/**
 * This function will convert all children types to an array while also filtering out non-valid React elements.
 */ var $007bf00b52f2e2de$var$childrenToArray = function childrenToArray(children) {
    var childrenAsArray = [];
    // We convert children to an array using this helper method as it will add keys to children that do not
    // have them, such as when we have hardcoded children that are conditionally rendered.
    (0, $dAx5m.Children).toArray(children).forEach(function(child) {
        // We ignore any boolean children to make our code a little more simple later on,
        // and also filter out any falsies (empty strings, nulls, and undefined).
        if (typeof child !== "boolean" && Boolean(child)) // Children WILL have a key after being forced into an array using the React.Children helper.
        childrenAsArray.push(child);
    });
    return childrenAsArray;
};
/**
 * This handles the case when a render updates during an exit motion.
 * If any child is mounted again we removed them from the exiting children object and return true.
 */ var $007bf00b52f2e2de$var$hasAnyExitingChildMountedAgain = function hasAnyExitingChildMountedAgain(exitingChildren, children) {
    var exitingChildMountedAgain = false;
    children.forEach(function(child) {
        if (exitingChildren.current[child.key]) {
            exitingChildMountedAgain = true;
            delete exitingChildren.current[child.key];
        }
    });
    return exitingChildMountedAgain;
};
/**
 * __ExitingPersistence__
 *
 * Useful for enabling elements to persist and animate away when they are removed from the DOM.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motions)
 */ var $007bf00b52f2e2de$var$ExitingPersistence = /*#__PURE__*/ (0, $dAx5m.memo)(function(_ref) {
    var _ref$appear = _ref.appear, appearFromProp = _ref$appear === void 0 ? false : _ref$appear, childs = _ref.children, exitThenEnter = _ref.exitThenEnter;
    var children = $007bf00b52f2e2de$var$childrenToArray(childs);
    var childrenObj = $007bf00b52f2e2de$var$childrenToObj(children);
    var previousChildren = (0, $dAx5m.useRef)([]);
    var persistedChildren = (0, $dAx5m.useRef)([]);
    var forceRender = (0, $bRFkb.useForceRender)();
    var exitingChildren = (0, $dAx5m.useRef)({});
    var appear = (0, $dAx5m.useRef)(appearFromProp);
    var defaultContextValue = (0, $dAx5m.useMemo)(function() {
        return {
            appear: appear.current,
            isExiting: false
        };
    }, // React rules of hooks says this isn't needed because mutating appear won't cause a re-render.
    // While technically true - it will trigger this to make a new object on the _next_ render which is what we want.
    // Remove this or use appear instead of appear.current and you will notice a test breaks.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        appear.current
    ]);
    if ((0, $jV6vz.isReducedMotion)()) return children;
    if (!appear.current) // We always want child motions to appear after the initial mount.
    appear.current = true;
    // This entire block can't be an effect because we need it to run synchronously during a render
    // else when elements are being removed they will be remounted instead of being updated.
    if (previousChildren.current.length && $007bf00b52f2e2de$var$isAnyPreviousKeysMissingFromCurrent(childrenObj, previousChildren.current)) {
        if (persistedChildren.current.length === 0 || $007bf00b52f2e2de$var$hasAnyExitingChildMountedAgain(exitingChildren, children)) persistedChildren.current = previousChildren.current;
        // We have persisted children now set from previous children.
        // Let's update previous children so we have it available next render.
        previousChildren.current = children;
        return (exitThenEnter ? persistedChildren.current : $007bf00b52f2e2de$var$spliceNewElementsIntoPrevious(children, persistedChildren.current)).map(function(child) {
            // eslint-disable-next-line @repo/internal/react/no-children-properties-access
            var currentChild = childrenObj[child.key];
            if (!currentChild) {
                // We've found an exiting child - mark it!
                exitingChildren.current[child.key] = true;
                return $007bf00b52f2e2de$var$wrapChildWithContextProvider(child, {
                    isExiting: true,
                    appear: true,
                    onFinish: function onFinish() {
                        delete exitingChildren.current[child.key];
                        // We will only remove the exiting elements when any subsequent exiting elements have also finished.
                        // Think of removing many items from a todo list - when removing a few over a few clicks we don't
                        // want the list jumping around when they exit.
                        if (Object.keys(exitingChildren.current).length === 0) {
                            // Set previous children to nothing.
                            // This let's us skip the next render check as it's assumed children and previous will be the same.
                            previousChildren.current = [];
                            persistedChildren.current = [];
                            // Re-render after the element(s) have animated away which will end up rendering the latest children.
                            forceRender();
                        }
                    }
                });
            }
            // This element isn't exiting.
            // Wrap context and let's continue on our way.
            return $007bf00b52f2e2de$var$wrapChildWithContextProvider(currentChild, defaultContextValue);
        });
    } else previousChildren.current = children;
    return children.map(function(child) {
        return $007bf00b52f2e2de$var$wrapChildWithContextProvider(child, defaultContextValue);
    });
});
var $007bf00b52f2e2de$export$3b6f38abbdcbd000 = function useExitingPersistence() {
    return (0, $dAx5m.useContext)($007bf00b52f2e2de$var$ExitingContext);
};
$007bf00b52f2e2de$var$ExitingPersistence.displayName = "ExitingPersistence";
var $007bf00b52f2e2de$export$2e2bcd8739ae039 = $007bf00b52f2e2de$var$ExitingPersistence;

});
parcelRegister("jV6vz", function(module, exports) {

$parcel$export(module.exports, "isReducedMotion", function () { return $e8086397af4e6d14$export$b7baf7667a68d87c; });
$parcel$export(module.exports, "reduceMotionAsPerUserPreference", function () { return $e8086397af4e6d14$export$f0f789643ba5a83c; });

var $6XrQK = parcelRequire("6XrQK");

var $dAx5m = parcelRequire("dAx5m");

var $dd4sf = parcelRequire("dd4sf");
var $e8086397af4e6d14$var$isMatchMediaAvailable = function isMatchMediaAvailable() {
    return typeof window !== "undefined" && "matchMedia" in window;
};
var $e8086397af4e6d14$export$b7baf7667a68d87c = function isReducedMotion() {
    if (!$e8086397af4e6d14$var$isMatchMediaAvailable()) return false;
    var _window$matchMedia = window.matchMedia("(prefers-reduced-motion: reduce)"), matches = _window$matchMedia.matches;
    return matches;
};
var $e8086397af4e6d14$export$c537e63161742ce3 = function useIsReducedMotion() {
    var _useState = (0, $dAx5m.useState)($e8086397af4e6d14$export$b7baf7667a68d87c), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($6XrQK)))(_useState, 2), prefersReducedMotion = _useState2[0], setPrefersReducedMotion = _useState2[1];
    (0, $dAx5m.useEffect)(function() {
        if (!$e8086397af4e6d14$var$isMatchMediaAvailable()) return;
        var mediaQueryList = window.matchMedia("(prefers-reduced-motion: reduce)");
        var onChange = function onChange(event) {
            return setPrefersReducedMotion(event.matches);
        };
        return (0, $dd4sf.bind)(mediaQueryList, {
            type: "change",
            listener: onChange
        });
    }, []);
    return prefersReducedMotion;
};
var $e8086397af4e6d14$export$f0f789643ba5a83c = {
    "@media (prefers-reduced-motion: reduce)": {
        animation: "none",
        transition: "none"
    }
};
var $e8086397af4e6d14$export$ff7706047246b98b = function prefersReducedMotion() {
    return $e8086397af4e6d14$export$f0f789643ba5a83c;
};

});
parcelRegister("6XrQK", function(module, exports) {

var $2XryK = parcelRequire("2XryK");

var $2CCzh = parcelRequire("2CCzh");

var $iu5XX = parcelRequire("iu5XX");

var $j4TPc = parcelRequire("j4TPc");
function $510ddb2afeac4197$var$_slicedToArray(r, e) {
    return $2XryK(r) || $2CCzh(r, e) || $iu5XX(r, e) || $j4TPc();
}
module.exports = $510ddb2afeac4197$var$_slicedToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("2XryK", function(module, exports) {
function $22767833b05384be$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
module.exports = $22767833b05384be$var$_arrayWithHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("2CCzh", function(module, exports) {
function $1e8d0c2d4a8aa8c9$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
module.exports = $1e8d0c2d4a8aa8c9$var$_iterableToArrayLimit, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("iu5XX", function(module, exports) {

var $044Qa = parcelRequire("044Qa");
function $d74fa80dbf80abae$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $044Qa(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $044Qa(r, a) : void 0;
    }
}
module.exports = $d74fa80dbf80abae$var$_unsupportedIterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("044Qa", function(module, exports) {
function $00c4211005e119ee$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
module.exports = $00c4211005e119ee$var$_arrayLikeToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("j4TPc", function(module, exports) {
function $de39b1aef65d3547$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
module.exports = $de39b1aef65d3547$var$_nonIterableRest, module.exports.__esModule = true, module.exports["default"] = module.exports;

});



parcelRegister("bRFkb", function(module, exports) {

$parcel$export(module.exports, "useForceRender", function () { return $8a34b31d432122de$export$b902f6ef73d6633a; });

var $6XrQK = parcelRequire("6XrQK");

var $dAx5m = parcelRequire("dAx5m");
var $8a34b31d432122de$export$b902f6ef73d6633a = function useForceRender() {
    var _useState = (0, $dAx5m.useState)({}), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($6XrQK)))(_useState, 2), updateState = _useState2[1];
    var forceRender = (0, $dAx5m.useCallback)(function() {
        return updateState({});
    }, []);
    return forceRender;
};

});


parcelRegister("2Ofzn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $20bc540fe8cd6b89$export$2e2bcd8739ae039; });

var $3ajGO = parcelRequire("3ajGO");

var $dAx5m = parcelRequire("dAx5m");

var $f6pXr = parcelRequire("f6pXr");

var $7OV8o = parcelRequire("7OV8o");

var $9xdNc = parcelRequire("9xdNc");
function $20bc540fe8cd6b89$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $20bc540fe8cd6b89$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $20bc540fe8cd6b89$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($3ajGO)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $20bc540fe8cd6b89$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $20bc540fe8cd6b89$var$directionMotions = {
    proportional: {
        bottom: "translate3d(0, calc(5% + 4px), 0)",
        left: "translate3d(calc(-5% - 4px), 0, 0)",
        right: "translate3d(calc(5% + 4px), 0, 0)",
        top: "translate3d(0, calc(-5% - 4px), 0)"
    },
    constant: {
        bottom: "translate3d(0, 4px, 0)",
        left: "translate3d(-4px, 0, 0)",
        right: "translate3d(4px, 0, 0)",
        top: "translate3d(0, -4px, 0)"
    }
};
var $20bc540fe8cd6b89$var$invertedDirection = {
    top: "bottom",
    bottom: "top",
    left: "right",
    right: "left"
};
var $20bc540fe8cd6b89$export$8497679fcaaeceb = function fadeInAnimation(direction) {
    var distance = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "proportional";
    return {
        from: $20bc540fe8cd6b89$var$_objectSpread({
            opacity: 0
        }, direction !== undefined && {
            transform: $20bc540fe8cd6b89$var$directionMotions[distance][direction]
        }),
        "50%": {
            opacity: 1
        },
        to: {
            transform: direction !== undefined ? "none" : undefined
        }
    };
};
var $20bc540fe8cd6b89$export$c9190c6659ea755b = function fadeOutAnimation(direction) {
    var distance = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "proportional";
    return {
        from: {
            opacity: 1,
            transform: direction !== undefined ? "translate3d(0, 0, 0)" : undefined
        },
        to: $20bc540fe8cd6b89$var$_objectSpread({
            opacity: 0
        }, direction !== undefined && {
            transform: $20bc540fe8cd6b89$var$directionMotions[distance][direction]
        })
    };
};
/**
 * Props for controlling the behavior of the FadeIn animation
 */ /**
 * __FadeIn__
 *
 * Useful for fading in one or more elements.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motions)
 */ var $20bc540fe8cd6b89$var$FadeIn = function FadeIn(_ref) {
    var children = _ref.children, _ref$duration = _ref.duration, duration = _ref$duration === void 0 ? (0, $7OV8o.largeDurationMs) : _ref$duration, entranceDirection = _ref.entranceDirection, exitDirection = _ref.exitDirection, _ref$distance = _ref.distance, distance = _ref$distance === void 0 ? "proportional" : _ref$distance, onFinish = _ref.onFinish, isPaused = _ref.isPaused;
    var invertedEntranceDirection = entranceDirection && $20bc540fe8cd6b89$var$invertedDirection[entranceDirection];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $9xdNc.default), {
        duration: duration,
        enteringAnimation: $20bc540fe8cd6b89$export$8497679fcaaeceb(entranceDirection, distance),
        exitingAnimation: $20bc540fe8cd6b89$export$c9190c6659ea755b(exitDirection || invertedEntranceDirection, distance),
        animationTimingFunction: function animationTimingFunction() {
            return 0, $f6pXr.easeInOut;
        },
        onFinish: onFinish,
        isPaused: isPaused
    }, children);
};
var $20bc540fe8cd6b89$export$2e2bcd8739ae039 = $20bc540fe8cd6b89$var$FadeIn;

});
parcelRegister("3ajGO", function(module, exports) {

var $hBnVL = parcelRequire("hBnVL");
function $24e194362835ae21$var$_defineProperty(e, r, t) {
    return (r = $hBnVL(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
module.exports = $24e194362835ae21$var$_defineProperty, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("hBnVL", function(module, exports) {

var $kbK6v = parcelRequire("kbK6v");
var $cd08747ef12f6ab3$var$_typeof = $kbK6v.default;

var $8Z9Rx = parcelRequire("8Z9Rx");
function $cd08747ef12f6ab3$var$toPropertyKey(t) {
    var i = $8Z9Rx(t, "string");
    return "symbol" == $cd08747ef12f6ab3$var$_typeof(i) ? i : i + "";
}
module.exports = $cd08747ef12f6ab3$var$toPropertyKey, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("kbK6v", function(module, exports) {
function $eb289907d25c9349$var$_typeof(o) {
    "@babel/helpers - typeof";
    return module.exports = $eb289907d25c9349$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $eb289907d25c9349$var$_typeof(o);
}
module.exports = $eb289907d25c9349$var$_typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("8Z9Rx", function(module, exports) {

var $kbK6v = parcelRequire("kbK6v");
var $68ababbb601059ea$var$_typeof = $kbK6v.default;
function $68ababbb601059ea$var$toPrimitive(t, r) {
    if ("object" != $68ababbb601059ea$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $68ababbb601059ea$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
module.exports = $68ababbb601059ea$var$toPrimitive, module.exports.__esModule = true, module.exports["default"] = module.exports;

});



parcelRegister("f6pXr", function(module, exports) {

$parcel$export(module.exports, "easeInOut", function () { return $afeb8d3795020f2f$export$c07234257a03d5e9; });
var $afeb8d3795020f2f$export$c07234257a03d5e9 = "cubic-bezier(0.15,1,0.3,1)";
var $afeb8d3795020f2f$export$57636bb43b1ccbb0 = "cubic-bezier(0.2,0,0,1)";
var $afeb8d3795020f2f$export$929e5a82286172a6 = "cubic-bezier(0.8,0,0,0.8)";

});

parcelRegister("7OV8o", function(module, exports) {

$parcel$export(module.exports, "largeDurationMs", function () { return $5b19859a1604ebc5$export$9424640c29bc466d; });
/**
 * Think of this as the motion equivalent of the @atlaskit/theme `grid()`.
 */ var $5b19859a1604ebc5$export$368bacef0dacbe05 = 25;
var $5b19859a1604ebc5$export$2023a81c8547415f = $5b19859a1604ebc5$export$368bacef0dacbe05 * 4;
var $5b19859a1604ebc5$export$6fa259be09e118a7 = $5b19859a1604ebc5$export$368bacef0dacbe05 * 14;
var $5b19859a1604ebc5$export$9424640c29bc466d = $5b19859a1604ebc5$export$368bacef0dacbe05 * 28;

});

parcelRegister("9xdNc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6f11e50b548bfac4$export$2e2bcd8739ae039; });

var $3ajGO = parcelRequire("3ajGO");

var $6XrQK = parcelRequire("6XrQK");

var $dAx5m = parcelRequire("dAx5m");

var $jVTBW = parcelRequire("jVTBW");

var $jV6vz = parcelRequire("jV6vz");

var $7OV8o = parcelRequire("7OV8o");

var $ipspl = parcelRequire("ipspl");

var $02zM4 = parcelRequire("02zM4");

var $XZdHq = parcelRequire("XZdHq");
function $6f11e50b548bfac4$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $6f11e50b548bfac4$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $6f11e50b548bfac4$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($3ajGO)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $6f11e50b548bfac4$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
/**
 * These are props that motions should use as their external props for consumers.
 * See [FadeIn](packages/helpers/motion/src/entering/fade-in.tsx) for an example usage.
 */ /**
 * Used to multiply the initial duration for exiting motions.
 */ var $6f11e50b548bfac4$var$EXITING_MOTION_MULTIPLIER = 0.5;
/**
 * This is the base INTERNAL component used for all other entering motions.
 * This does not need Javascript to execute on the client so it will run immediately
 * for any SSR rendered React apps before the JS has executed.
 */ var $6f11e50b548bfac4$var$EnteringMotion = function EnteringMotion(_ref) {
    var children = _ref.children, animationTimingFunction = _ref.animationTimingFunction, enteringAnimation = _ref.enteringAnimation, exitingAnimation = _ref.exitingAnimation, isPaused = _ref.isPaused, onFinishMotion = _ref.onFinish, _ref$duration = _ref.duration, duration = _ref$duration === void 0 ? (0, $7OV8o.largeDurationMs) : _ref$duration;
    var staggered = (0, $XZdHq.useStaggeredEntrance)();
    var _useExitingPersistenc = (0, $02zM4.useExitingPersistence)(), isExiting = _useExitingPersistenc.isExiting, onExitFinished = _useExitingPersistenc.onFinish, appear = _useExitingPersistenc.appear;
    var setTimeout = (0, $ipspl.useSetTimeout)();
    var paused = isPaused || !staggered.isReady;
    var delay = isExiting ? 0 : staggered.delay;
    var state = isExiting ? "exiting" : "entering";
    var _useState = (0, $dAx5m.useState)(appear), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($6XrQK)))(_useState, 2), hasAnimationStyles = _useState2[0], setHasAnimationStyles = _useState2[1];
    (0, $dAx5m.useEffect)(function() {
        // Tracking this to prevent changing state on an unmounted component
        var isCancelled = false;
        if (paused) return;
        // On initial mount if elements aren't set to animate on appear, we return early and callback
        if (!appear) {
            onFinishMotion && onFinishMotion(state);
            return;
        }
        // Elements may need animation styles back after initial mount (they could animate out)
        setHasAnimationStyles(true);
        setTimeout(function() {
            if (state === "exiting") onExitFinished && onExitFinished();
            if (!isCancelled) setHasAnimationStyles(false);
            onFinishMotion && onFinishMotion(state);
        }, isExiting ? duration * $6f11e50b548bfac4$var$EXITING_MOTION_MULTIPLIER : duration + delay);
        return function() {
            isCancelled = true;
        };
    // We ignore this for onFinishMotion as consumers could potentially inline the function
    // which would then trigger this effect every re-render.
    // We want to make it easier for consumers so we go down this path unfortunately.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        onExitFinished,
        state,
        isExiting,
        duration,
        delay,
        paused,
        setTimeout
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $jVTBW.ClassNames), null, function(_ref2) {
        var css = _ref2.css;
        return children({
            ref: staggered.ref,
            className: hasAnimationStyles ? css($6f11e50b548bfac4$var$_objectSpread($6f11e50b548bfac4$var$_objectSpread({}, (0, $jV6vz.reduceMotionAsPerUserPreference)), {}, {
                animationDelay: "".concat(delay, "ms"),
                animationDuration: "".concat(isExiting ? duration * $6f11e50b548bfac4$var$EXITING_MOTION_MULTIPLIER : duration, "ms"),
                animationFillMode: isExiting ? "forwards" : "backwards",
                animationName: "".concat((0, $jVTBW.keyframes)(isExiting ? exitingAnimation || enteringAnimation : enteringAnimation)),
                animationPlayState: paused ? "paused" : "running",
                animationTimingFunction: animationTimingFunction(state)
            })) : ""
        }, state);
    });
};
var $6f11e50b548bfac4$export$2e2bcd8739ae039 = $6f11e50b548bfac4$var$EnteringMotion;

});
parcelRegister("ipspl", function(module, exports) {

$parcel$export(module.exports, "useSetTimeout", function () { return $d67098fca9add7e2$export$4f34107a2b00f39c; });

var $dAx5m = parcelRequire("dAx5m");
var $d67098fca9add7e2$var$getHookDeps = function getHookDeps(opts) {
    switch(opts.cleanup){
        case "next-effect":
            return undefined;
        case "unmount":
        default:
            return [];
    }
};
var $d67098fca9add7e2$export$1775f27e7c8051ca = function useRequestAnimationFrame() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        cleanup: "unmount"
    };
    var frames = (0, $dAx5m.useRef)([]);
    (0, $dAx5m.useEffect)(function() {
        return function() {
            if (frames.current.length) {
                frames.current.forEach(function(id) {
                    return cancelAnimationFrame(id);
                });
                frames.current = [];
            }
        };
    // We dynamically set this so we either clean up on the next effect - or on unmount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, $d67098fca9add7e2$var$getHookDeps(opts));
    return (0, $dAx5m.useCallback)(function(handler) {
        var id = requestAnimationFrame(function(time) {
            frames.current = frames.current.filter(function(frameId) {
                return frameId !== id;
            });
            handler(time);
        });
        frames.current.push(id);
    }, []);
};
var $d67098fca9add7e2$export$4f34107a2b00f39c = function useSetTimeout() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        cleanup: "unmount"
    };
    var timeouts = (0, $dAx5m.useRef)([]);
    (0, $dAx5m.useEffect)(function() {
        return function() {
            if (timeouts.current.length) {
                timeouts.current.forEach(function(id) {
                    return clearTimeout(id);
                });
                timeouts.current = [];
            }
        };
    // We dynamically set this so we either clean up on the next effect - or on unmount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, $d67098fca9add7e2$var$getHookDeps(opts));
    return (0, $dAx5m.useCallback)(function(handler, timeout) {
        for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
        var id = setTimeout.apply(void 0, [
            function() {
                timeouts.current = timeouts.current.filter(function(timeoutId) {
                    return timeoutId !== id;
                });
                handler();
            },
            timeout
        ].concat(args));
        timeouts.current.push(id);
    }, []);
};

});

parcelRegister("XZdHq", function(module, exports) {

$parcel$export(module.exports, "useStaggeredEntrance", function () { return $0b44ffcfae3e736a$export$25c7213fc07ec080; });

var $6XrQK = parcelRequire("6XrQK");

var $dAx5m = parcelRequire("dAx5m");

var $Bb0he = parcelRequire("Bb0he");

var $jYq5S = parcelRequire("jYq5S");

var $7yBWn = parcelRequire("7yBWn");
var $0b44ffcfae3e736a$var$StaggeredEntranceContext = /*#__PURE__*/ (0, $dAx5m.createContext)(function() {
    return {
        isReady: true,
        delay: 0,
        ref: (0, $Bb0he.default)
    };
});
var $0b44ffcfae3e736a$export$25c7213fc07ec080 = function useStaggeredEntrance() {
    var indentifier = (0, $7yBWn.useUniqueId)();
    var context = (0, $dAx5m.useContext)($0b44ffcfae3e736a$var$StaggeredEntranceContext);
    return context(indentifier);
};
/**
 * For a list of elements that need to animate in,
 * this should be used in conjunction with entering components.
 * This does not need Javascript to execute so it will run immediately for any SSR rendered React apps before the JS has executed.
 *
 * Will dynamically add delay to each child entering component.
 * Unfortunately all entering components _NEED_ to be a direct descendant.
 */ var $0b44ffcfae3e736a$var$StaggeredEntrance = function StaggeredEntrance(_ref) {
    var children = _ref.children, column = _ref.column, _ref$columns = _ref.columns, columns = _ref$columns === void 0 ? "responsive" : _ref$columns, _ref$delayStep = _ref.delayStep, delayStep = _ref$delayStep === void 0 ? 50 : _ref$delayStep;
    var elementRefs = (0, $dAx5m.useRef)([]);
    var indexes = [];
    var _useState = (0, $dAx5m.useState)(function() {
        if (typeof columns === "number") // A hardcoded columns is set so bail out and set it to that!
        return columns;
        if (typeof column === "number") // A hardcoded column is set so we will set actualColumns to be 1.
        return 1;
        // We are in "responsive" mode.
        // So we will be calculating when the Javascript executes on the client how many columns there will be.
        return 0;
    }), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($6XrQK)))(_useState, 2), actualColumns = _useState2[0], setActualColumns = _useState2[1];
    (0, $jYq5S.useLayoutEffect)(function() {
        // We want to only run this code when we are in "responsive" mode.
        // It is assumed we are in responsive mode if `columns` is "responsive",
        // we have children element refs ready to be read (i.e. if there are no children this won't run as well)
        // and finally that `actualColumns` is `0` - this is because for the first render cycle `actualColumns` will be `0` (set above)
        // and then after this layout effect runs the value for `actualColumns` will then be calculated and set.
        if (columns === "responsive" && elementRefs.current.length && actualColumns === 0) {
            var currentTop = 0;
            var numberColumns = 0;
            if (elementRefs.current.length <= 1) {
                setActualColumns(1);
                return;
            }
            // We set the current top to the first elements.
            // We will be comparing this and incrementing the column count
            // until we hit an element that has a different offset top (or we run out of elements).
            currentTop = elementRefs.current[0] ? elementRefs.current[0].offsetTop : 0;
            for(var i = 0; i < elementRefs.current.length; i++){
                var child = elementRefs.current[i];
                if (!child) break;
                if (currentTop === child.offsetTop) {
                    numberColumns += 1;
                    if (elementRefs.current.length - 1 === i) setActualColumns(numberColumns);
                    continue;
                }
                setActualColumns(numberColumns);
                break;
            }
        }
    // We only want this effect to run once - on initial mount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement($0b44ffcfae3e736a$var$StaggeredEntranceContext.Provider, {
        value: function value(id) {
            if (!indexes.includes(id)) indexes.push(id);
            var isReady = actualColumns > 0;
            var index = indexes.indexOf(id);
            var currentColumn = column || index % actualColumns;
            var currentRow = Math.floor(index / actualColumns);
            var distanceFromTopLeftElement = currentRow + currentColumn;
            // We don't want loads of elements to have the same staggered delay as it ends up looking slow for users.
            // To get around that we calculate the logarithm using `distanceFromTopLeftElement` which ends making
            // elements appear faster the further away from the top left element.
            var delay = Math.ceil(Math.log(distanceFromTopLeftElement + 1) * delayStep * 1.5) || 0;
            return {
                delay: delay,
                isReady: isReady,
                ref: function ref(element) {
                    return elementRefs.current[index] = element;
                }
            };
        }
    }, children);
};
var $0b44ffcfae3e736a$export$2e2bcd8739ae039 = $0b44ffcfae3e736a$var$StaggeredEntrance;

});
parcelRegister("jYq5S", function(module, exports) {

$parcel$export(module.exports, "useLayoutEffect", function () { return $e8a7dc9de8a0d499$export$e5c5a5f917a5871c; });

var $dAx5m = parcelRequire("dAx5m");
var $e8a7dc9de8a0d499$export$e5c5a5f917a5871c = typeof window === "undefined" ? (0, $dAx5m.useEffect) : (0, $dAx5m.useLayoutEffect);

});

parcelRegister("7yBWn", function(module, exports) {

$parcel$export(module.exports, "useUniqueId", function () { return $58092399eaae366a$export$c485849f2e393253; });
/* eslint-disable @repo/internal/react/disallow-unstable-values */ 
var $dAx5m = parcelRequire("dAx5m");
function $58092399eaae366a$export$c485849f2e393253() {
    var identifier = (0, $dAx5m.useRef)("");
    if (!identifier.current) identifier.current = "_" + (Number(String(Math.random()).slice(2)) + Date.now() + Math.round(performance.now())).toString(36);
    return identifier.current;
}

});




parcelRegister("bhj8u", function(module, exports) {

$parcel$export(module.exports, "SectionMessageContainer", function () { return $395fe6c13b059fd2$export$e24f31d167719f38; });
$parcel$export(module.exports, "IconWrapper", function () { return $395fe6c13b059fd2$export$be58b4326e23250f; });
$parcel$export(module.exports, "MessageWrapper", function () { return $395fe6c13b059fd2$export$ec445f12f63100a5; });
$parcel$export(module.exports, "ActionsWrapper", function () { return $395fe6c13b059fd2$export$c8223871eecc8f3a; });
$parcel$export(module.exports, "Action", function () { return $395fe6c13b059fd2$export$e19cd5f9376f8cee; });
$parcel$export(module.exports, "CloseButtonWrapper", function () { return $395fe6c13b059fd2$export$be3e3d1f3a97d19a; });

var $ku6eE = parcelRequire("ku6eE");

var $5MUVm = parcelRequire("5MUVm");

var $gbKg7 = parcelRequire("gbKg7");
const $395fe6c13b059fd2$export$e24f31d167719f38 = (0, $ku6eE.default).div`
  background-color: ${(0, $gbKg7.default)("color.background.discovery", (0, $5MUVm).P50)};
  border-radius: 3px;
  width: 100%;
  padding: ${(0, $gbKg7.default)("space.200", "16px")};
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  box-sizing: border-box;

  & > button {
    padding: 7.25px;
    height: ${(0, $gbKg7.default)("space.300", "24px")};
    width: ${(0, $gbKg7.default)("space.300", "24px")};
    align-items: center;
    justify-content: center;
    & span {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      height: 100%;
      & path {
        transform: scale(calc(9.5 / 5.54));
        transform-origin: center;
      }
    }
  }
`;
const $395fe6c13b059fd2$export$be58b4326e23250f = (0, $ku6eE.default).span`
  padding-right: ${(0, $gbKg7.default)("space.200", "16px")};
`;
const $395fe6c13b059fd2$export$ec445f12f63100a5 = (0, $ku6eE.default).span`
  flex: 1;
  padding-top: ${({ hasIcon: hasIcon })=>hasIcon ? `${(0, $gbKg7.default)("space.025", "2px")}` : 0};
`;
const $395fe6c13b059fd2$export$c8223871eecc8f3a = (0, $ku6eE.default).ul`
  display: flex;
  list-style: none;
  margin-top: 0;
  padding-left: 0;
  padding-top: ${(0, $gbKg7.default)("space.100", "8px")};
`;
const $395fe6c13b059fd2$export$e19cd5f9376f8cee = (0, $ku6eE.default).li`
  display: flex;
  align-items: center;
  margin: 0;
  & + &::before {
    color: ${(0, $gbKg7.default)("color.text.subtle", (0, $5MUVm).N500)};
    content: '·';
    display: inline-block;
    text-align: center;
    vertical-align: middle;
    width: ${(0, $gbKg7.default)("space.200", "16px")};
  }
`;
const $395fe6c13b059fd2$export$be3e3d1f3a97d19a = (0, $ku6eE.default).div`
  width: ${(0, $gbKg7.default)("space.300", "24px")};
  height: ${(0, $gbKg7.default)("space.300", "24px")};
  margin-left: ${(0, $gbKg7.default)("space.200", "16px")};
`;

});
parcelRegister("ku6eE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ee9b722fff0f8785$export$2e2bcd8739ae039; });

var $g9tBT = parcelRequire("g9tBT");
parcelRequire("l0LOM");
parcelRequire("dAx5m");
parcelRequire("8ycZZ");

parcelRequire("3Ao1t");
parcelRequire("2EoW8");
parcelRequire("fDu2l");
var $ee9b722fff0f8785$var$tags = [
    "a",
    "abbr",
    "address",
    "area",
    "article",
    "aside",
    "audio",
    "b",
    "base",
    "bdi",
    "bdo",
    "big",
    "blockquote",
    "body",
    "br",
    "button",
    "canvas",
    "caption",
    "cite",
    "code",
    "col",
    "colgroup",
    "data",
    "datalist",
    "dd",
    "del",
    "details",
    "dfn",
    "dialog",
    "div",
    "dl",
    "dt",
    "em",
    "embed",
    "fieldset",
    "figcaption",
    "figure",
    "footer",
    "form",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "head",
    "header",
    "hgroup",
    "hr",
    "html",
    "i",
    "iframe",
    "img",
    "input",
    "ins",
    "kbd",
    "keygen",
    "label",
    "legend",
    "li",
    "link",
    "main",
    "map",
    "mark",
    "marquee",
    "menu",
    "menuitem",
    "meta",
    "meter",
    "nav",
    "noscript",
    "object",
    "ol",
    "optgroup",
    "option",
    "output",
    "p",
    "param",
    "picture",
    "pre",
    "progress",
    "q",
    "rp",
    "rt",
    "ruby",
    "s",
    "samp",
    "script",
    "section",
    "select",
    "small",
    "source",
    "span",
    "strong",
    "style",
    "sub",
    "summary",
    "sup",
    "table",
    "tbody",
    "td",
    "textarea",
    "tfoot",
    "th",
    "thead",
    "time",
    "title",
    "tr",
    "track",
    "u",
    "ul",
    "var",
    "video",
    "wbr",
    "circle",
    "clipPath",
    "defs",
    "ellipse",
    "foreignObject",
    "g",
    "image",
    "line",
    "linearGradient",
    "mask",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "radialGradient",
    "rect",
    "stop",
    "svg",
    "text",
    "tspan"
];
var $ee9b722fff0f8785$export$2e2bcd8739ae039 = (0, $g9tBT.default).bind();
$ee9b722fff0f8785$var$tags.forEach(function(tagName) {
    $ee9b722fff0f8785$export$2e2bcd8739ae039[tagName] = $ee9b722fff0f8785$export$2e2bcd8739ae039(tagName);
});

});
parcelRegister("g9tBT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bc247497ffc7b077$export$2e2bcd8739ae039; });

var $lW5Mj = parcelRequire("lW5Mj");

var $dAx5m = parcelRequire("dAx5m");

var $8ycZZ = parcelRequire("8ycZZ");
parcelRequire("jVTBW");
var $2wjNk = parcelRequire("2wjNk");

var $3Ao1t = parcelRequire("3Ao1t");

var $2EoW8 = parcelRequire("2EoW8");

var $fDu2l = parcelRequire("fDu2l");
/* import type {
  ElementType,
  StatelessFunctionalComponent,
  AbstractComponent
} from 'react' */ /*
export type Interpolations = Array<any>

export type StyledElementType<Props> =
  | string
  | AbstractComponent<{ ...Props, className: string }, mixed>

export type StyledOptions = {
  label?: string,
  shouldForwardProp?: string => boolean,
  target?: string
}

export type StyledComponent<Props> = StatelessFunctionalComponent<Props> & {
  defaultProps: any,
  toString: () => string,
  withComponent: (
    nextTag: StyledElementType<Props>,
    nextOptions?: StyledOptions
  ) => StyledComponent<Props>
}

export type PrivateStyledComponent<Props> = StyledComponent<Props> & {
  __emotion_real: StyledComponent<Props>,
  __emotion_base: any,
  __emotion_styles: any,
  __emotion_forwardProp: any
}
*/ var $bc247497ffc7b077$var$testOmitPropsOnStringTag = (0, $8ycZZ.default);
var $bc247497ffc7b077$var$testOmitPropsOnComponent = function testOmitPropsOnComponent(key) {
    return key !== "theme";
};
var $bc247497ffc7b077$var$getDefaultShouldForwardProp = function getDefaultShouldForwardProp(tag) {
    return typeof tag === "string" && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96 ? $bc247497ffc7b077$var$testOmitPropsOnStringTag : $bc247497ffc7b077$var$testOmitPropsOnComponent;
};
var $bc247497ffc7b077$var$composeShouldForwardProps = function composeShouldForwardProps(tag, options, isReal) {
    var shouldForwardProp;
    if (options) {
        var optionsShouldForwardProp = options.shouldForwardProp;
        shouldForwardProp = tag.__emotion_forwardProp && optionsShouldForwardProp ? function(propName) {
            return tag.__emotion_forwardProp(propName) && optionsShouldForwardProp(propName);
        } : optionsShouldForwardProp;
    }
    if (typeof shouldForwardProp !== "function" && isReal) shouldForwardProp = tag.__emotion_forwardProp;
    return shouldForwardProp;
};
/*
export type CreateStyledComponent = <Props>(
  ...args: Interpolations
) => StyledComponent<Props>

export type CreateStyled = {
  <Props>(
    tag: StyledElementType<Props>,
    options?: StyledOptions
  ): (...args: Interpolations) => StyledComponent<Props>,
  [key: string]: CreateStyledComponent,
  bind: () => CreateStyled
}
*/ var $bc247497ffc7b077$var$ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var $bc247497ffc7b077$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $3Ao1t.registerStyles)(cache, serialized, isStringTag);
    (0, $fDu2l.useInsertionEffectAlwaysWithSyncFallback)(function() {
        return (0, $3Ao1t.insertStyles)(cache, serialized, isStringTag);
    });
    return null;
};
var $bc247497ffc7b077$export$2e2bcd8739ae039 = function createStyled(tag, options) {
    var isReal = tag.__emotion_real === tag;
    var baseTag = isReal && tag.__emotion_base || tag;
    var identifierName;
    var targetClassName;
    if (options !== undefined) {
        identifierName = options.label;
        targetClassName = options.target;
    }
    var shouldForwardProp = $bc247497ffc7b077$var$composeShouldForwardProps(tag, options, isReal);
    var defaultShouldForwardProp = shouldForwardProp || $bc247497ffc7b077$var$getDefaultShouldForwardProp(baseTag);
    var shouldUseAs = !defaultShouldForwardProp("as");
    /* return function<Props>(): PrivateStyledComponent<Props> { */ return function() {
        var args = arguments;
        var styles = isReal && tag.__emotion_styles !== undefined ? tag.__emotion_styles.slice(0) : [];
        if (identifierName !== undefined) styles.push("label:" + identifierName + ";");
        if (args[0] == null || args[0].raw === undefined) styles.push.apply(styles, args);
        else {
            styles.push(args[0][0]);
            var len = args.length;
            var i = 1;
            for(; i < len; i++)styles.push(args[i], args[0][i]);
        }
        var Styled = (0, $2wjNk.w)(function(props, cache, ref) {
            var FinalTag = shouldUseAs && props.as || baseTag;
            var className = "";
            var classInterpolations = [];
            var mergedProps = props;
            if (props.theme == null) {
                mergedProps = {};
                for(var key in props)mergedProps[key] = props[key];
                mergedProps.theme = $dAx5m.useContext((0, $2wjNk.T));
            }
            if (typeof props.className === "string") className = (0, $3Ao1t.getRegisteredStyles)(cache.registered, classInterpolations, props.className);
            else if (props.className != null) className = props.className + " ";
            var serialized = (0, $2EoW8.serializeStyles)(styles.concat(classInterpolations), cache.registered, mergedProps);
            className += cache.key + "-" + serialized.name;
            if (targetClassName !== undefined) className += " " + targetClassName;
            var finalShouldForwardProp = shouldUseAs && shouldForwardProp === undefined ? $bc247497ffc7b077$var$getDefaultShouldForwardProp(FinalTag) : defaultShouldForwardProp;
            var newProps = {};
            for(var _key in props){
                if (shouldUseAs && _key === "as") continue;
                if (finalShouldForwardProp(_key)) newProps[_key] = props[_key];
            }
            newProps.className = className;
            if (ref) newProps.ref = ref;
            return /*#__PURE__*/ $dAx5m.createElement($dAx5m.Fragment, null, /*#__PURE__*/ $dAx5m.createElement($bc247497ffc7b077$var$Insertion, {
                cache: cache,
                serialized: serialized,
                isStringTag: typeof FinalTag === "string"
            }), /*#__PURE__*/ $dAx5m.createElement(FinalTag, newProps));
        });
        Styled.displayName = identifierName !== undefined ? identifierName : "Styled(" + (typeof baseTag === "string" ? baseTag : baseTag.displayName || baseTag.name || "Component") + ")";
        Styled.defaultProps = tag.defaultProps;
        Styled.__emotion_real = Styled;
        Styled.__emotion_base = baseTag;
        Styled.__emotion_styles = styles;
        Styled.__emotion_forwardProp = shouldForwardProp;
        Object.defineProperty(Styled, "toString", {
            value: function value() {
                return "." + targetClassName;
            }
        });
        Styled.withComponent = function(nextTag, nextOptions) {
            return createStyled(nextTag, (0, $lW5Mj.default)({}, options, nextOptions, {
                shouldForwardProp: $bc247497ffc7b077$var$composeShouldForwardProps(Styled, nextOptions, true)
            })).apply(void 0, styles);
        };
        return Styled;
    };
};

});
parcelRegister("lW5Mj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ff837f2bd541c6ab$export$2e2bcd8739ae039; });
function $ff837f2bd541c6ab$export$2e2bcd8739ae039() {
    return $ff837f2bd541c6ab$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $ff837f2bd541c6ab$export$2e2bcd8739ae039.apply(null, arguments);
}

});

parcelRegister("8ycZZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $639b94ff5163a9ae$export$2e2bcd8739ae039; });

var $8cVSc = parcelRequire("8cVSc");
// eslint-disable-next-line no-undef
var $639b94ff5163a9ae$var$reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|fetchpriority|fetchPriority|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var $639b94ff5163a9ae$export$2e2bcd8739ae039 = /* #__PURE__ */ (0, $8cVSc.default)(function(prop) {
    return $639b94ff5163a9ae$var$reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});

});


parcelRegister("l0LOM", function(module, exports) {
function $f4beb0c07a8ba470$var$_extends() {
    return module.exports = $f4beb0c07a8ba470$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $f4beb0c07a8ba470$var$_extends.apply(null, arguments);
}
module.exports = $f4beb0c07a8ba470$var$_extends, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("5MUVm", function(module, exports) {

$parcel$export(module.exports, "R50", function () { return $436d9765f490c608$export$4b84fd0e2c617bd; });
$parcel$export(module.exports, "R75", function () { return $436d9765f490c608$export$b34b069eff244586; });
$parcel$export(module.exports, "R100", function () { return $436d9765f490c608$export$be802dd0d8b57f35; });
$parcel$export(module.exports, "R200", function () { return $436d9765f490c608$export$60847d42f9da92a6; });
$parcel$export(module.exports, "R300", function () { return $436d9765f490c608$export$4a7404f376229999; });
$parcel$export(module.exports, "R400", function () { return $436d9765f490c608$export$2010d0fb4295b346; });
$parcel$export(module.exports, "R500", function () { return $436d9765f490c608$export$2837b5a1a71d5c02; });
$parcel$export(module.exports, "Y50", function () { return $436d9765f490c608$export$8d9596b529bbb9cf; });
$parcel$export(module.exports, "Y75", function () { return $436d9765f490c608$export$41060a744ab0b7ae; });
$parcel$export(module.exports, "Y100", function () { return $436d9765f490c608$export$1cc05bbbf340e559; });
$parcel$export(module.exports, "Y200", function () { return $436d9765f490c608$export$5aae31392d72caaa; });
$parcel$export(module.exports, "Y300", function () { return $436d9765f490c608$export$c6930421db9fa514; });
$parcel$export(module.exports, "Y400", function () { return $436d9765f490c608$export$59619663aa6500fb; });
$parcel$export(module.exports, "Y500", function () { return $436d9765f490c608$export$874739ea9e379ab6; });
$parcel$export(module.exports, "G50", function () { return $436d9765f490c608$export$8a6341c32b6a3ee6; });
$parcel$export(module.exports, "G75", function () { return $436d9765f490c608$export$69a3bf21b9686c2b; });
$parcel$export(module.exports, "G100", function () { return $436d9765f490c608$export$afbce1382ec95f73; });
$parcel$export(module.exports, "G200", function () { return $436d9765f490c608$export$747d86715d4175de; });
$parcel$export(module.exports, "G300", function () { return $436d9765f490c608$export$940e1f69e873f202; });
$parcel$export(module.exports, "G400", function () { return $436d9765f490c608$export$a49394138f7b8e85; });
$parcel$export(module.exports, "G500", function () { return $436d9765f490c608$export$6fa04827ac68a4fb; });
$parcel$export(module.exports, "B50", function () { return $436d9765f490c608$export$226de0355ed012f8; });
$parcel$export(module.exports, "B75", function () { return $436d9765f490c608$export$8c13c2ee36917869; });
$parcel$export(module.exports, "B100", function () { return $436d9765f490c608$export$ecfc1dff386a3e7a; });
$parcel$export(module.exports, "B200", function () { return $436d9765f490c608$export$215b7063051591f1; });
$parcel$export(module.exports, "B300", function () { return $436d9765f490c608$export$e62e8919cca44969; });
$parcel$export(module.exports, "B400", function () { return $436d9765f490c608$export$b3de0ae08da2ce64; });
$parcel$export(module.exports, "B500", function () { return $436d9765f490c608$export$a6ee3d71bc067634; });
$parcel$export(module.exports, "P50", function () { return $436d9765f490c608$export$363e4475840015bb; });
$parcel$export(module.exports, "P75", function () { return $436d9765f490c608$export$4b0a4417ed59760f; });
$parcel$export(module.exports, "P100", function () { return $436d9765f490c608$export$6011520a64d9a187; });
$parcel$export(module.exports, "P200", function () { return $436d9765f490c608$export$a7175d4e9206bc80; });
$parcel$export(module.exports, "P300", function () { return $436d9765f490c608$export$b48405b95304b5a1; });
$parcel$export(module.exports, "P400", function () { return $436d9765f490c608$export$c71e4279dd54a18d; });
$parcel$export(module.exports, "P500", function () { return $436d9765f490c608$export$147899de772240ec; });
$parcel$export(module.exports, "T50", function () { return $436d9765f490c608$export$2cf711fe14c66f06; });
$parcel$export(module.exports, "T75", function () { return $436d9765f490c608$export$7a8f4d33f6f9772c; });
$parcel$export(module.exports, "T100", function () { return $436d9765f490c608$export$776c9c497ef08533; });
$parcel$export(module.exports, "T200", function () { return $436d9765f490c608$export$69cb3ca10c1e330e; });
$parcel$export(module.exports, "T300", function () { return $436d9765f490c608$export$9dc1ef0f3f48059b; });
$parcel$export(module.exports, "T400", function () { return $436d9765f490c608$export$7c835c78b6fcdef8; });
$parcel$export(module.exports, "T500", function () { return $436d9765f490c608$export$6036577f95c3877e; });
$parcel$export(module.exports, "N0", function () { return $436d9765f490c608$export$29a4f05edc054374; });
$parcel$export(module.exports, "N10", function () { return $436d9765f490c608$export$e655ef011c4aa1a2; });
$parcel$export(module.exports, "N20", function () { return $436d9765f490c608$export$9fdfb749e33cdf97; });
$parcel$export(module.exports, "N30", function () { return $436d9765f490c608$export$3e51e8f1440314ba; });
$parcel$export(module.exports, "N40", function () { return $436d9765f490c608$export$1ce2d1575d444ceb; });
$parcel$export(module.exports, "N50", function () { return $436d9765f490c608$export$8754fc7e6d8b3000; });
$parcel$export(module.exports, "N60", function () { return $436d9765f490c608$export$c2e91cbeada39b8b; });
$parcel$export(module.exports, "N70", function () { return $436d9765f490c608$export$5f71e19f3a7ad9de; });
$parcel$export(module.exports, "N80", function () { return $436d9765f490c608$export$eaa8c8a70ac22806; });
$parcel$export(module.exports, "N90", function () { return $436d9765f490c608$export$7c87d337fb91a97d; });
$parcel$export(module.exports, "N100", function () { return $436d9765f490c608$export$d6447c357493214f; });
$parcel$export(module.exports, "N200", function () { return $436d9765f490c608$export$f563ee71e9ee74cd; });
$parcel$export(module.exports, "N300", function () { return $436d9765f490c608$export$e2ef2124cf4024b1; });
$parcel$export(module.exports, "N400", function () { return $436d9765f490c608$export$eece5f492e429f08; });
$parcel$export(module.exports, "N500", function () { return $436d9765f490c608$export$c39c0fe0f26207ae; });
$parcel$export(module.exports, "N600", function () { return $436d9765f490c608$export$7090862dc3038a9f; });
$parcel$export(module.exports, "N700", function () { return $436d9765f490c608$export$ad0bacf983b7ddaa; });
$parcel$export(module.exports, "N800", function () { return $436d9765f490c608$export$7d61b15e0da132af; });
$parcel$export(module.exports, "N900", function () { return $436d9765f490c608$export$fbda843f0a27fe96; });
$parcel$export(module.exports, "N10A", function () { return $436d9765f490c608$export$791e57b27ca738ef; });
$parcel$export(module.exports, "N20A", function () { return $436d9765f490c608$export$8d43898f60b96a82; });
$parcel$export(module.exports, "N30A", function () { return $436d9765f490c608$export$920c0d5c49070351; });
$parcel$export(module.exports, "N40A", function () { return $436d9765f490c608$export$46987b49aab6d1a8; });
$parcel$export(module.exports, "N50A", function () { return $436d9765f490c608$export$7d3359664e8bb0e5; });
$parcel$export(module.exports, "N60A", function () { return $436d9765f490c608$export$d2d3bedfb276cac0; });
$parcel$export(module.exports, "N70A", function () { return $436d9765f490c608$export$6e5e7499ff054f6d; });
$parcel$export(module.exports, "N80A", function () { return $436d9765f490c608$export$59264b346c877fa7; });
$parcel$export(module.exports, "N90A", function () { return $436d9765f490c608$export$d092757d7c64925c; });
$parcel$export(module.exports, "N100A", function () { return $436d9765f490c608$export$486ab785e4bac3c6; });
$parcel$export(module.exports, "N200A", function () { return $436d9765f490c608$export$fba592bbc6419fea; });
$parcel$export(module.exports, "N300A", function () { return $436d9765f490c608$export$13609db0e6812ab8; });
$parcel$export(module.exports, "N400A", function () { return $436d9765f490c608$export$fbae4efaa892d883; });
$parcel$export(module.exports, "N500A", function () { return $436d9765f490c608$export$f13946d26f440ce6; });
$parcel$export(module.exports, "N600A", function () { return $436d9765f490c608$export$19f58225ac52a306; });
$parcel$export(module.exports, "N700A", function () { return $436d9765f490c608$export$6384f09da70e7b62; });
$parcel$export(module.exports, "N800A", function () { return $436d9765f490c608$export$d0dccc730683edc2; });
$parcel$export(module.exports, "DN900", function () { return $436d9765f490c608$export$2f6319cf7d736c2a; });
$parcel$export(module.exports, "DN800", function () { return $436d9765f490c608$export$95126bc8884d6634; });
$parcel$export(module.exports, "DN700", function () { return $436d9765f490c608$export$8338d8c35d44ff1; });
$parcel$export(module.exports, "DN600", function () { return $436d9765f490c608$export$5368d76ae4fbbda7; });
$parcel$export(module.exports, "DN500", function () { return $436d9765f490c608$export$9f0a771d16ec8d36; });
$parcel$export(module.exports, "DN400", function () { return $436d9765f490c608$export$abcf8c38338b4aa5; });
$parcel$export(module.exports, "DN300", function () { return $436d9765f490c608$export$97e81faa16a182c7; });
$parcel$export(module.exports, "DN200", function () { return $436d9765f490c608$export$bfe21c59123ecf33; });
$parcel$export(module.exports, "DN100", function () { return $436d9765f490c608$export$ee82aa2ea6a1558; });
$parcel$export(module.exports, "DN90", function () { return $436d9765f490c608$export$682927c6ed76be02; });
$parcel$export(module.exports, "DN80", function () { return $436d9765f490c608$export$91fd9994c5be9757; });
$parcel$export(module.exports, "DN70", function () { return $436d9765f490c608$export$d281fbfe3cff2df6; });
$parcel$export(module.exports, "DN60", function () { return $436d9765f490c608$export$3902c91d8b98a753; });
$parcel$export(module.exports, "DN50", function () { return $436d9765f490c608$export$8e8133c1ba5845b5; });
$parcel$export(module.exports, "DN40", function () { return $436d9765f490c608$export$33ff357f6620b39; });
$parcel$export(module.exports, "DN30", function () { return $436d9765f490c608$export$633847cf062b69e0; });
$parcel$export(module.exports, "DN20", function () { return $436d9765f490c608$export$9776a6e503bdbf76; });
$parcel$export(module.exports, "DN10", function () { return $436d9765f490c608$export$6c813d5160dff5db; });
$parcel$export(module.exports, "DN0", function () { return $436d9765f490c608$export$3d4f271a500072a; });
$parcel$export(module.exports, "DN800A", function () { return $436d9765f490c608$export$fe151285c22759ec; });
$parcel$export(module.exports, "DN700A", function () { return $436d9765f490c608$export$a101c6190d0da34; });
$parcel$export(module.exports, "DN600A", function () { return $436d9765f490c608$export$4b16f52932fda51; });
$parcel$export(module.exports, "DN500A", function () { return $436d9765f490c608$export$a74bcd7b9845b0d8; });
$parcel$export(module.exports, "DN400A", function () { return $436d9765f490c608$export$9209c179316d1751; });
$parcel$export(module.exports, "DN300A", function () { return $436d9765f490c608$export$88f55133f636c8dd; });
$parcel$export(module.exports, "DN200A", function () { return $436d9765f490c608$export$51126f85d1009512; });
$parcel$export(module.exports, "DN100A", function () { return $436d9765f490c608$export$a069b547bd23af78; });
$parcel$export(module.exports, "DN90A", function () { return $436d9765f490c608$export$40cce05af3b2600a; });
$parcel$export(module.exports, "DN80A", function () { return $436d9765f490c608$export$b78942185925a0d; });
$parcel$export(module.exports, "DN70A", function () { return $436d9765f490c608$export$e058fb44b8eaafca; });
$parcel$export(module.exports, "DN60A", function () { return $436d9765f490c608$export$92b0b8de26920c18; });
$parcel$export(module.exports, "DN50A", function () { return $436d9765f490c608$export$67564f7459d3fc9e; });
$parcel$export(module.exports, "DN40A", function () { return $436d9765f490c608$export$77868e1ca884ffa3; });
$parcel$export(module.exports, "DN30A", function () { return $436d9765f490c608$export$2afd71d7d3ea2cd5; });
$parcel$export(module.exports, "DN20A", function () { return $436d9765f490c608$export$f2a0acaab9972c70; });
$parcel$export(module.exports, "DN10A", function () { return $436d9765f490c608$export$9ab70e67d6475361; });
$parcel$export(module.exports, "background", function () { return $436d9765f490c608$export$8ce1fd94bee2f412; });
$parcel$export(module.exports, "backgroundActive", function () { return $436d9765f490c608$export$b861914ea877b580; });
$parcel$export(module.exports, "backgroundHover", function () { return $436d9765f490c608$export$3f1b020df94387af; });
$parcel$export(module.exports, "backgroundOnLayer", function () { return $436d9765f490c608$export$c0183dbab98ca63e; });
$parcel$export(module.exports, "text", function () { return $436d9765f490c608$export$6f093cfa640b7166; });
$parcel$export(module.exports, "textHover", function () { return $436d9765f490c608$export$42f8e9c698766e7a; });
$parcel$export(module.exports, "textActive", function () { return $436d9765f490c608$export$c2d157ca1c34b6e3; });
$parcel$export(module.exports, "subtleText", function () { return $436d9765f490c608$export$1905ba28d7cf066f; });
$parcel$export(module.exports, "placeholderText", function () { return $436d9765f490c608$export$bd9002130d306d39; });
$parcel$export(module.exports, "heading", function () { return $436d9765f490c608$export$46e4a324ac90507f; });
$parcel$export(module.exports, "subtleHeading", function () { return $436d9765f490c608$export$79f3f2b82beb0d36; });
$parcel$export(module.exports, "codeBlock", function () { return $436d9765f490c608$export$7bb0d5c671655cc4; });
$parcel$export(module.exports, "link", function () { return $436d9765f490c608$export$9c30223ca0a664fb; });
$parcel$export(module.exports, "linkHover", function () { return $436d9765f490c608$export$7ed258b0728b004b; });
$parcel$export(module.exports, "linkActive", function () { return $436d9765f490c608$export$dfa920d8decc8a59; });
$parcel$export(module.exports, "linkOutline", function () { return $436d9765f490c608$export$6069e6ad5c78f632; });
$parcel$export(module.exports, "primary", function () { return $436d9765f490c608$export$9ad721cf3b3debe0; });
$parcel$export(module.exports, "blue", function () { return $436d9765f490c608$export$2aa0182783e7e9de; });
$parcel$export(module.exports, "teal", function () { return $436d9765f490c608$export$8bf7dff220b82b4a; });
$parcel$export(module.exports, "purple", function () { return $436d9765f490c608$export$e13cce2a2d16a9d4; });
$parcel$export(module.exports, "red", function () { return $436d9765f490c608$export$a90204d1394caf30; });
$parcel$export(module.exports, "yellow", function () { return $436d9765f490c608$export$594c5a8758200c32; });
$parcel$export(module.exports, "green", function () { return $436d9765f490c608$export$955a2ebd2fb142ae; });
$parcel$export(module.exports, "skeleton", function () { return $436d9765f490c608$export$2a0674ff2eb10214; });
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ 
var $5LEHS = parcelRequire("5LEHS");
var $436d9765f490c608$export$4b84fd0e2c617bd = "#FFEBE6";
var $436d9765f490c608$export$b34b069eff244586 = "#FFBDAD";
var $436d9765f490c608$export$be802dd0d8b57f35 = "#FF8F73";
var $436d9765f490c608$export$60847d42f9da92a6 = "#FF7452";
var $436d9765f490c608$export$4a7404f376229999 = "#FF5630";
var $436d9765f490c608$export$2010d0fb4295b346 = "#DE350B";
var $436d9765f490c608$export$2837b5a1a71d5c02 = "#BF2600";
var $436d9765f490c608$export$8d9596b529bbb9cf = "#FFFAE6";
var $436d9765f490c608$export$41060a744ab0b7ae = "#FFF0B3";
var $436d9765f490c608$export$1cc05bbbf340e559 = "#FFE380";
var $436d9765f490c608$export$5aae31392d72caaa = "#FFC400";
var $436d9765f490c608$export$c6930421db9fa514 = "#FFAB00";
var $436d9765f490c608$export$59619663aa6500fb = "#FF991F";
var $436d9765f490c608$export$874739ea9e379ab6 = "#FF8B00";
var $436d9765f490c608$export$8a6341c32b6a3ee6 = "#E3FCEF";
var $436d9765f490c608$export$69a3bf21b9686c2b = "#ABF5D1";
var $436d9765f490c608$export$afbce1382ec95f73 = "#79F2C0";
var $436d9765f490c608$export$747d86715d4175de = "#57D9A3";
var $436d9765f490c608$export$940e1f69e873f202 = "#36B37E";
var $436d9765f490c608$export$a49394138f7b8e85 = "#00875A";
var $436d9765f490c608$export$6fa04827ac68a4fb = "#006644";
var $436d9765f490c608$export$226de0355ed012f8 = "#DEEBFF";
var $436d9765f490c608$export$8c13c2ee36917869 = "#B3D4FF";
var $436d9765f490c608$export$ecfc1dff386a3e7a = "#4C9AFF";
var $436d9765f490c608$export$215b7063051591f1 = "#2684FF";
var $436d9765f490c608$export$e62e8919cca44969 = "#0065FF";
var $436d9765f490c608$export$b3de0ae08da2ce64 = "#0052CC";
var $436d9765f490c608$export$a6ee3d71bc067634 = "#0747A6";
var $436d9765f490c608$export$363e4475840015bb = "#EAE6FF";
var $436d9765f490c608$export$4b0a4417ed59760f = "#C0B6F2";
var $436d9765f490c608$export$6011520a64d9a187 = "#998DD9";
var $436d9765f490c608$export$a7175d4e9206bc80 = "#8777D9";
var $436d9765f490c608$export$b48405b95304b5a1 = "#6554C0";
var $436d9765f490c608$export$c71e4279dd54a18d = "#5243AA";
var $436d9765f490c608$export$147899de772240ec = "#403294";
var $436d9765f490c608$export$2cf711fe14c66f06 = "#E6FCFF";
var $436d9765f490c608$export$7a8f4d33f6f9772c = "#B3F5FF";
var $436d9765f490c608$export$776c9c497ef08533 = "#79E2F2";
var $436d9765f490c608$export$69cb3ca10c1e330e = "#00C7E6";
var $436d9765f490c608$export$9dc1ef0f3f48059b = "#00B8D9";
var $436d9765f490c608$export$7c835c78b6fcdef8 = "#00A3BF";
var $436d9765f490c608$export$6036577f95c3877e = "#008DA6";
var $436d9765f490c608$export$29a4f05edc054374 = "#FFFFFF";
var $436d9765f490c608$export$e655ef011c4aa1a2 = "#FAFBFC";
var $436d9765f490c608$export$9fdfb749e33cdf97 = "#F4F5F7";
var $436d9765f490c608$export$3e51e8f1440314ba = "#EBECF0";
var $436d9765f490c608$export$1ce2d1575d444ceb = "#DFE1E6";
var $436d9765f490c608$export$8754fc7e6d8b3000 = "#C1C7D0";
var $436d9765f490c608$export$c2e91cbeada39b8b = "#B3BAC5";
var $436d9765f490c608$export$5f71e19f3a7ad9de = "#A5ADBA";
var $436d9765f490c608$export$eaa8c8a70ac22806 = "#97A0AF";
var $436d9765f490c608$export$7c87d337fb91a97d = "#8993A4";
var $436d9765f490c608$export$d6447c357493214f = "#7A869A";
var $436d9765f490c608$export$f563ee71e9ee74cd = "#6B778C";
var $436d9765f490c608$export$e2ef2124cf4024b1 = "#5E6C84";
var $436d9765f490c608$export$eece5f492e429f08 = "#505F79";
var $436d9765f490c608$export$c39c0fe0f26207ae = "#42526E";
var $436d9765f490c608$export$7090862dc3038a9f = "#344563";
var $436d9765f490c608$export$ad0bacf983b7ddaa = "#253858";
var $436d9765f490c608$export$7d61b15e0da132af = "#172B4D";
var $436d9765f490c608$export$fbda843f0a27fe96 = "#091E42";
var $436d9765f490c608$export$791e57b27ca738ef = "rgba(9, 30, 66, 0.02)";
var $436d9765f490c608$export$8d43898f60b96a82 = "rgba(9, 30, 66, 0.04)";
var $436d9765f490c608$export$920c0d5c49070351 = "rgba(9, 30, 66, 0.08)";
var $436d9765f490c608$export$46987b49aab6d1a8 = "rgba(9, 30, 66, 0.13)";
var $436d9765f490c608$export$7d3359664e8bb0e5 = "rgba(9, 30, 66, 0.25)";
var $436d9765f490c608$export$d2d3bedfb276cac0 = "rgba(9, 30, 66, 0.31)";
var $436d9765f490c608$export$6e5e7499ff054f6d = "rgba(9, 30, 66, 0.36)";
var $436d9765f490c608$export$59264b346c877fa7 = "rgba(9, 30, 66, 0.42)";
var $436d9765f490c608$export$d092757d7c64925c = "rgba(9, 30, 66, 0.48)";
var $436d9765f490c608$export$486ab785e4bac3c6 = "rgba(9, 30, 66, 0.54)";
var $436d9765f490c608$export$fba592bbc6419fea = "rgba(9, 30, 66, 0.60)";
var $436d9765f490c608$export$13609db0e6812ab8 = "rgba(9, 30, 66, 0.66)";
var $436d9765f490c608$export$fbae4efaa892d883 = "rgba(9, 30, 66, 0.71)";
var $436d9765f490c608$export$f13946d26f440ce6 = "rgba(9, 30, 66, 0.77)";
var $436d9765f490c608$export$19f58225ac52a306 = "rgba(9, 30, 66, 0.82)";
var $436d9765f490c608$export$6384f09da70e7b62 = "rgba(9, 30, 66, 0.89)";
var $436d9765f490c608$export$d0dccc730683edc2 = "rgba(9, 30, 66, 0.95)";
var $436d9765f490c608$export$2f6319cf7d736c2a = "#E6EDFA";
var $436d9765f490c608$export$95126bc8884d6634 = "#DCE5F5";
var $436d9765f490c608$export$8338d8c35d44ff1 = "#CED9EB";
var $436d9765f490c608$export$5368d76ae4fbbda7 = "#B8C7E0";
var $436d9765f490c608$export$9f0a771d16ec8d36 = "#ABBBD6";
var $436d9765f490c608$export$abcf8c38338b4aa5 = "#9FB0CC";
var $436d9765f490c608$export$97e81faa16a182c7 = "#8C9CB8";
var $436d9765f490c608$export$bfe21c59123ecf33 = "#7988A3";
var $436d9765f490c608$export$ee82aa2ea6a1558 = "#67758F";
var $436d9765f490c608$export$682927c6ed76be02 = "#56637A";
var $436d9765f490c608$export$91fd9994c5be9757 = "#455166";
var $436d9765f490c608$export$d281fbfe3cff2df6 = "#3B475C";
var $436d9765f490c608$export$3902c91d8b98a753 = "#313D52";
var $436d9765f490c608$export$8e8133c1ba5845b5 = "#283447";
var $436d9765f490c608$export$33ff357f6620b39 = "#202B3D";
var $436d9765f490c608$export$633847cf062b69e0 = "#1B2638";
var $436d9765f490c608$export$9776a6e503bdbf76 = "#121A29";
var $436d9765f490c608$export$6c813d5160dff5db = "#0E1624";
var $436d9765f490c608$export$3d4f271a500072a = "#0D1424";
var $436d9765f490c608$export$fe151285c22759ec = "rgba(13, 20, 36, 0.06)";
var $436d9765f490c608$export$a101c6190d0da34 = "rgba(13, 20, 36, 0.14)";
var $436d9765f490c608$export$4b16f52932fda51 = "rgba(13, 20, 36, 0.18)";
var $436d9765f490c608$export$a74bcd7b9845b0d8 = "rgba(13, 20, 36, 0.29)";
var $436d9765f490c608$export$9209c179316d1751 = "rgba(13, 20, 36, 0.36)";
var $436d9765f490c608$export$88f55133f636c8dd = "rgba(13, 20, 36, 0.40)";
var $436d9765f490c608$export$51126f85d1009512 = "rgba(13, 20, 36, 0.47)";
var $436d9765f490c608$export$a069b547bd23af78 = "rgba(13, 20, 36, 0.53)";
var $436d9765f490c608$export$40cce05af3b2600a = "rgba(13, 20, 36, 0.63)";
var $436d9765f490c608$export$b78942185925a0d = "rgba(13, 20, 36, 0.73)";
var $436d9765f490c608$export$e058fb44b8eaafca = "rgba(13, 20, 36, 0.78)";
var $436d9765f490c608$export$92b0b8de26920c18 = "rgba(13, 20, 36, 0.81)";
var $436d9765f490c608$export$67564f7459d3fc9e = "rgba(13, 20, 36, 0.85)";
var $436d9765f490c608$export$77868e1ca884ffa3 = "rgba(13, 20, 36, 0.89)";
var $436d9765f490c608$export$2afd71d7d3ea2cd5 = "rgba(13, 20, 36, 0.92)";
var $436d9765f490c608$export$f2a0acaab9972c70 = "rgba(13, 20, 36, 0.95)";
var $436d9765f490c608$export$9ab70e67d6475361 = "rgba(13, 20, 36, 0.97)";
var $436d9765f490c608$export$8ce1fd94bee2f412 = (0, $5LEHS.default)({
    light: "var(--ds-surface, ".concat($436d9765f490c608$export$29a4f05edc054374, ")"),
    dark: "var(--ds-surface, ".concat($436d9765f490c608$export$633847cf062b69e0, ")")
});
var $436d9765f490c608$export$b861914ea877b580 = (0, $5LEHS.default)({
    light: "var(--ds-background-selected, ".concat($436d9765f490c608$export$226de0355ed012f8, ")"),
    dark: "var(--ds-background-selected, ".concat($436d9765f490c608$export$8c13c2ee36917869, ")")
});
var $436d9765f490c608$export$3f1b020df94387af = (0, $5LEHS.default)({
    light: "var(--ds-background-neutral-hovered, ".concat($436d9765f490c608$export$3e51e8f1440314ba, ")"),
    dark: "var(--ds-background-neutral-hovered, ".concat($436d9765f490c608$export$d281fbfe3cff2df6, ")")
});
var $436d9765f490c608$export$c0183dbab98ca63e = (0, $5LEHS.default)({
    light: "var(--ds-surface-overlay, ".concat($436d9765f490c608$export$29a4f05edc054374, ")"),
    dark: "var(--ds-surface-overlay, ".concat($436d9765f490c608$export$8e8133c1ba5845b5, ")")
});
var $436d9765f490c608$export$6f093cfa640b7166 = (0, $5LEHS.default)({
    light: "var(--ds-text, ".concat($436d9765f490c608$export$fbda843f0a27fe96, ")"),
    dark: "var(--ds-text, ".concat($436d9765f490c608$export$5368d76ae4fbbda7, ")")
});
var $436d9765f490c608$export$42f8e9c698766e7a = (0, $5LEHS.default)({
    light: "var(--ds-text, ".concat($436d9765f490c608$export$7d61b15e0da132af, ")"),
    dark: "var(--ds-text, ".concat($436d9765f490c608$export$5368d76ae4fbbda7, ")")
});
var $436d9765f490c608$export$c2d157ca1c34b6e3 = (0, $5LEHS.default)({
    light: "var(--ds-text-selected, ".concat($436d9765f490c608$export$b3de0ae08da2ce64, ")"),
    dark: "var(--ds-text-selected, ".concat($436d9765f490c608$export$b3de0ae08da2ce64, ")")
});
var $436d9765f490c608$export$1905ba28d7cf066f = (0, $5LEHS.default)({
    light: "var(--ds-text-subtlest, ".concat($436d9765f490c608$export$f563ee71e9ee74cd, ")"),
    dark: "var(--ds-text-subtlest, ".concat($436d9765f490c608$export$97e81faa16a182c7, ")")
});
var $436d9765f490c608$export$bd9002130d306d39 = (0, $5LEHS.default)({
    light: "var(--ds-text-subtlest, ".concat($436d9765f490c608$export$f563ee71e9ee74cd, ")"),
    dark: "var(--ds-text-subtlest, ".concat($436d9765f490c608$export$bfe21c59123ecf33, ")")
});
var $436d9765f490c608$export$46e4a324ac90507f = (0, $5LEHS.default)({
    light: "var(--ds-text, ".concat($436d9765f490c608$export$7d61b15e0da132af, ")"),
    dark: "var(--ds-text, ".concat($436d9765f490c608$export$5368d76ae4fbbda7, ")")
});
var $436d9765f490c608$export$79f3f2b82beb0d36 = (0, $5LEHS.default)({
    light: "var(--ds-text-subtlest, ".concat($436d9765f490c608$export$f563ee71e9ee74cd, ")"),
    dark: "var(--ds-text-subtlest, ".concat($436d9765f490c608$export$97e81faa16a182c7, ")")
});
var $436d9765f490c608$export$7bb0d5c671655cc4 = (0, $5LEHS.default)({
    light: $436d9765f490c608$export$9fdfb749e33cdf97,
    dark: $436d9765f490c608$export$8e8133c1ba5845b5
});
var $436d9765f490c608$export$9c30223ca0a664fb = (0, $5LEHS.default)({
    light: "var(--ds-link, ".concat($436d9765f490c608$export$b3de0ae08da2ce64, ")"),
    dark: "var(--ds-link, ".concat($436d9765f490c608$export$ecfc1dff386a3e7a, ")")
});
var $436d9765f490c608$export$7ed258b0728b004b = (0, $5LEHS.default)({
    light: "var(--ds-link-pressed, ".concat($436d9765f490c608$export$e62e8919cca44969, ")"),
    dark: "var(--ds-link-pressed, ".concat($436d9765f490c608$export$215b7063051591f1, ")")
});
var $436d9765f490c608$export$dfa920d8decc8a59 = (0, $5LEHS.default)({
    light: "var(--ds-link-pressed, ".concat($436d9765f490c608$export$a6ee3d71bc067634, ")"),
    dark: "var(--ds-link-pressed, ".concat($436d9765f490c608$export$ecfc1dff386a3e7a, ")")
});
var $436d9765f490c608$export$6069e6ad5c78f632 = (0, $5LEHS.default)({
    light: "var(--ds-border-focused, ".concat($436d9765f490c608$export$215b7063051591f1, ")"),
    dark: "var(--ds-border-focused, ".concat($436d9765f490c608$export$215b7063051591f1, ")")
});
var $436d9765f490c608$export$9ad721cf3b3debe0 = (0, $5LEHS.default)({
    light: "var(--ds-background-brand-bold, ".concat($436d9765f490c608$export$b3de0ae08da2ce64, ")"),
    dark: "var(--ds-background-brand-bold, ".concat($436d9765f490c608$export$ecfc1dff386a3e7a, ")")
});
var $436d9765f490c608$export$2aa0182783e7e9de = (0, $5LEHS.default)({
    light: $436d9765f490c608$export$b3de0ae08da2ce64,
    dark: $436d9765f490c608$export$ecfc1dff386a3e7a
});
var $436d9765f490c608$export$8bf7dff220b82b4a = (0, $5LEHS.default)({
    light: $436d9765f490c608$export$9dc1ef0f3f48059b,
    dark: $436d9765f490c608$export$69cb3ca10c1e330e
});
var $436d9765f490c608$export$e13cce2a2d16a9d4 = (0, $5LEHS.default)({
    light: $436d9765f490c608$export$b48405b95304b5a1,
    dark: $436d9765f490c608$export$6011520a64d9a187
});
var $436d9765f490c608$export$a90204d1394caf30 = (0, $5LEHS.default)({
    light: $436d9765f490c608$export$4a7404f376229999,
    dark: $436d9765f490c608$export$4a7404f376229999
});
var $436d9765f490c608$export$594c5a8758200c32 = (0, $5LEHS.default)({
    light: $436d9765f490c608$export$c6930421db9fa514,
    dark: $436d9765f490c608$export$c6930421db9fa514
});
var $436d9765f490c608$export$955a2ebd2fb142ae = (0, $5LEHS.default)({
    light: $436d9765f490c608$export$940e1f69e873f202,
    dark: $436d9765f490c608$export$940e1f69e873f202
});
var $436d9765f490c608$export$2a0674ff2eb10214 = function skeleton() {
    return "var(--ds-skeleton, ".concat($436d9765f490c608$export$8d43898f60b96a82, ")");
};

});
parcelRegister("5LEHS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4330eb0e80e835ae$export$2e2bcd8739ae039; });
/* eslint-disable prefer-rest-params */ 
var $9huEy = parcelRequire("9huEy");
// Unpack custom variants, and get correct value for the current theme
function $4330eb0e80e835ae$var$themedVariants(variantProp, variants) {
    return function(props) {
        var theme = (0, $9huEy.default)(props);
        if (props && props[variantProp] && variants) {
            var modes = variants[props[variantProp]];
            if (modes && modes[theme.mode]) {
                var value = modes[theme.mode];
                if (value) return value;
                 // TS believes value can be undefined
            }
        }
        return "";
    };
}
function $4330eb0e80e835ae$export$2e2bcd8739ae039(modesOrVariant, variantModes) {
    if (typeof modesOrVariant === "string") return $4330eb0e80e835ae$var$themedVariants(modesOrVariant, variantModes);
    var modes = modesOrVariant;
    return function(props) {
        // Get theme from the user's props
        var theme = (0, $9huEy.default)(props);
        // User isn't required to provide both light and dark values
        if (theme.mode in modes) {
            var value = modes[theme.mode]; // TS believes value can be undefined
            if (value) return value;
        }
        return "";
    };
}

});
parcelRegister("9huEy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6c1d7aa8f216a5b1$export$2e2bcd8739ae039; });

var $6W4m7 = parcelRequire("6W4m7");
function $6c1d7aa8f216a5b1$export$2e2bcd8739ae039(props) {
    if (props && props.theme) {
        // Theme is the global Atlaskit theme
        if ((0, $6W4m7.CHANNEL) in props.theme) return props.theme[0, $6W4m7.CHANNEL];
        else if ("mode" in props.theme && (0, $6W4m7.THEME_MODES).includes(props.theme.mode)) return props.theme;
    }
    // If format not supported (or no theme provided), return standard theme
    return {
        mode: (0, $6W4m7.DEFAULT_THEME_MODE)
    };
}

});
parcelRegister("6W4m7", function(module, exports) {

$parcel$export(module.exports, "CHANNEL", function () { return $50cb89cbb6bfb308$export$44ffba16bd48dac6; });
$parcel$export(module.exports, "DEFAULT_THEME_MODE", function () { return $50cb89cbb6bfb308$export$c93026a968943f95; });
$parcel$export(module.exports, "THEME_MODES", function () { return $50cb89cbb6bfb308$export$6ba72c8346b4c57e; });
$parcel$export(module.exports, "borderRadius", function () { return $50cb89cbb6bfb308$export$7a57f79000377ca2; });
$parcel$export(module.exports, "gridSize", function () { return $50cb89cbb6bfb308$export$6d8204c2cb2e06b8; });
$parcel$export(module.exports, "fontSize", function () { return $50cb89cbb6bfb308$export$85e3c3ca0c6fb93; });
$parcel$export(module.exports, "fontFamily", function () { return $50cb89cbb6bfb308$export$a5975749f0374264; });
$parcel$export(module.exports, "codeFontFamily", function () { return $50cb89cbb6bfb308$export$356129969ee49c55; });
$parcel$export(module.exports, "layers", function () { return $50cb89cbb6bfb308$export$7be255094ccdc533; });

var $e2xkU = parcelRequire("e2xkU");

var $5MUVm = parcelRequire("5MUVm");
var $50cb89cbb6bfb308$export$44ffba16bd48dac6 = "__ATLASKIT_THEME__";
var $50cb89cbb6bfb308$export$c93026a968943f95 = "light";
var $50cb89cbb6bfb308$export$6ba72c8346b4c57e = [
    "light",
    "dark"
];
var $50cb89cbb6bfb308$export$7a57f79000377ca2 = function borderRadius() {
    return 3;
};
var $50cb89cbb6bfb308$export$6d8204c2cb2e06b8 = function gridSize() {
    return 8;
};
var $50cb89cbb6bfb308$export$85e3c3ca0c6fb93 = function fontSize() {
    return 14;
};
var $50cb89cbb6bfb308$export$6746fe0d9c9fab54 = function fontSizeSmall() {
    return 11;
};
var $50cb89cbb6bfb308$export$a5975749f0374264 = function fontFamily() {
    return "-apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif";
};
var $50cb89cbb6bfb308$export$356129969ee49c55 = function codeFontFamily() {
    return "'SFMono-Medium', 'SF Mono', 'Segoe UI Mono', 'Roboto Mono', 'Ubuntu Mono', Menlo, Consolas, Courier, monospace";
};
var $50cb89cbb6bfb308$export$8e24544ddba725ee = function focusRing() {
    var color = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "var(--ds-border-focused, ".concat((0, $5MUVm.B200), ")");
    var outlineWidth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $50cb89cbb6bfb308$export$6d8204c2cb2e06b8() / 4;
    (0, $e2xkU.default)("@atlaskit/theme", "focus ring mixin", "Please use `@atlaskit/focus-ring` instead.");
    return "\n  &:focus {\n    outline: none;\n    box-shadow: 0px 0px 0px ".concat(outlineWidth, "px ").concat(color, ";\n  }\n");
};
var $50cb89cbb6bfb308$export$c0dd343266bc3261 = function noFocusRing() {
    return "\n  box-shadow: none;\n";
};
var $50cb89cbb6bfb308$export$7be255094ccdc533 = {
    card: function card() {
        return 100;
    },
    navigation: function navigation() {
        return 200;
    },
    dialog: function dialog() {
        return 300;
    },
    layer: function layer() {
        return 400;
    },
    blanket: function blanket() {
        return 500;
    },
    modal: function modal() {
        return 510;
    },
    flag: function flag() {
        return 600;
    },
    spotlight: function spotlight() {
        return 700;
    },
    tooltip: function tooltip() {
        return 9999;
    }
};
var $50cb89cbb6bfb308$export$a1b3edb637fb4f35 = function visuallyHidden() {
    (0, $e2xkU.default)("@atlaskit/theme", "visually hidden mixin", "Please use `@atlaskit/visually-hidden` instead.");
    return {
        border: "0 !important",
        clip: "rect(1px, 1px, 1px, 1px) !important",
        height: "1px !important",
        overflow: "hidden !important",
        padding: "0 !important",
        position: "absolute !important",
        width: "1px !important",
        whiteSpace: "nowrap !important"
    };
};
var $50cb89cbb6bfb308$export$ba1d834b86d72a09 = $50cb89cbb6bfb308$export$a1b3edb637fb4f35;
var $50cb89cbb6bfb308$export$e497e856b4f89fcd = function skeletonShimmer() {
    return {
        css: {
            backgroundColor: "var(--ds-skeleton, ".concat((0, $5MUVm.skeleton)(), ")"),
            animationDuration: "1.5s",
            animationIterationCount: "infinite",
            animationTimingFunction: "linear",
            animationDirection: "alternate"
        },
        keyframes: {
            from: {
                backgroundColor: "var(--ds-skeleton, ".concat((0, $5MUVm.skeleton)(), ")")
            },
            to: {
                backgroundColor: "var(--ds-skeleton-subtle, ".concat((0, $5MUVm.N30A), ")")
            }
        }
    };
};

});




parcelRegister("gbKg7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bc918e7f551c4b17$export$2e2bcd8739ae039; });



var $8iKWE = parcelRequire("8iKWE");

var $da8nl = parcelRequire("da8nl");

var $ahJoN = parcelRequire("ahJoN");
/**
 * Takes a dot-separated token name and an optional fallback, and returns the CSS custom property for the corresponding token.
 * This should be used to implement design decisions throughout your application.
 *
 * Note: With `@atlaskit/babel-plugin-tokens`, this function can be pre-compiled and a fallback value automatically inserted.
 *
 * @param {string} path - A dot-separated token name (example: `'color.background.brand'` or `'spacing.scale.100'`).
 * @param {string} [fallback] - The fallback value that should render when token CSS is not present in your app.
 *
 * @example
 * ```
 * <div
 *   css={{
 *     backgroundColor: token('elevation.surface.raised', N0),
 *     boxShadow: token('elevation.shadow.raised', `0 20px 32px -8px ${N50A}, 0 0 1px ${N60A}`),
 *     padding: token('spacing.scale.100', '8px'),
 *     fontWeight: token('font.weight.regular', '400'),
 *   }}
 * />
 * ```
 *
 */ function $bc918e7f551c4b17$var$token(path, fallback) {
    var token = (0, $8iKWE.default)[path];
    typeof $ahJoN;
    // if the token is not found - replacing it with variable name without any value, to avoid it being undefined which would result in invalid css
    if (!token) token = (0, $da8nl.TOKEN_NOT_FOUND_CSS_VAR);
    var tokenCall = fallback ? "var(".concat(token, ", ").concat(fallback, ")") : "var(".concat(token, ")");
    return tokenCall;
}
var $bc918e7f551c4b17$export$2e2bcd8739ae039 = $bc918e7f551c4b17$var$token;

});
parcelRegister("8iKWE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $60b46b7d0858aab2$export$2e2bcd8739ae039; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::02412877f3dbfda4dbaee7a917f24b6c>>
 * @codegenCommand yarn build tokens
 */ var $60b46b7d0858aab2$var$tokens = {
    "color.text": "--ds-text",
    "color.text.accent.lime": "--ds-text-accent-lime",
    "color.text.accent.lime.bolder": "--ds-text-accent-lime-bolder",
    "color.text.accent.red": "--ds-text-accent-red",
    "color.text.accent.red.bolder": "--ds-text-accent-red-bolder",
    "color.text.accent.orange": "--ds-text-accent-orange",
    "color.text.accent.orange.bolder": "--ds-text-accent-orange-bolder",
    "color.text.accent.yellow": "--ds-text-accent-yellow",
    "color.text.accent.yellow.bolder": "--ds-text-accent-yellow-bolder",
    "color.text.accent.green": "--ds-text-accent-green",
    "color.text.accent.green.bolder": "--ds-text-accent-green-bolder",
    "color.text.accent.teal": "--ds-text-accent-teal",
    "color.text.accent.teal.bolder": "--ds-text-accent-teal-bolder",
    "color.text.accent.blue": "--ds-text-accent-blue",
    "color.text.accent.blue.bolder": "--ds-text-accent-blue-bolder",
    "color.text.accent.purple": "--ds-text-accent-purple",
    "color.text.accent.purple.bolder": "--ds-text-accent-purple-bolder",
    "color.text.accent.magenta": "--ds-text-accent-magenta",
    "color.text.accent.magenta.bolder": "--ds-text-accent-magenta-bolder",
    "color.text.accent.gray": "--ds-text-accent-gray",
    "color.text.accent.gray.bolder": "--ds-text-accent-gray-bolder",
    "color.text.disabled": "--ds-text-disabled",
    "color.text.inverse": "--ds-text-inverse",
    "color.text.selected": "--ds-text-selected",
    "color.text.brand": "--ds-text-brand",
    "color.text.danger": "--ds-text-danger",
    "color.text.warning": "--ds-text-warning",
    "color.text.warning.inverse": "--ds-text-warning-inverse",
    "color.text.success": "--ds-text-success",
    "color.text.discovery": "--ds-text-discovery",
    "color.text.information": "--ds-text-information",
    "color.text.subtlest": "--ds-text-subtlest",
    "color.text.subtle": "--ds-text-subtle",
    "color.link": "--ds-link",
    "color.link.pressed": "--ds-link-pressed",
    "color.link.visited": "--ds-link-visited",
    "color.link.visited.pressed": "--ds-link-visited-pressed",
    "color.icon": "--ds-icon",
    "color.icon.accent.lime": "--ds-icon-accent-lime",
    "color.icon.accent.red": "--ds-icon-accent-red",
    "color.icon.accent.orange": "--ds-icon-accent-orange",
    "color.icon.accent.yellow": "--ds-icon-accent-yellow",
    "color.icon.accent.green": "--ds-icon-accent-green",
    "color.icon.accent.teal": "--ds-icon-accent-teal",
    "color.icon.accent.blue": "--ds-icon-accent-blue",
    "color.icon.accent.purple": "--ds-icon-accent-purple",
    "color.icon.accent.magenta": "--ds-icon-accent-magenta",
    "color.icon.accent.gray": "--ds-icon-accent-gray",
    "color.icon.disabled": "--ds-icon-disabled",
    "color.icon.inverse": "--ds-icon-inverse",
    "color.icon.selected": "--ds-icon-selected",
    "color.icon.brand": "--ds-icon-brand",
    "color.icon.danger": "--ds-icon-danger",
    "color.icon.warning": "--ds-icon-warning",
    "color.icon.warning.inverse": "--ds-icon-warning-inverse",
    "color.icon.success": "--ds-icon-success",
    "color.icon.discovery": "--ds-icon-discovery",
    "color.icon.information": "--ds-icon-information",
    "color.icon.subtlest": "--ds-icon-subtlest",
    "color.icon.subtle": "--ds-icon-subtle",
    "color.border": "--ds-border",
    "color.border.accent.lime": "--ds-border-accent-lime",
    "color.border.accent.red": "--ds-border-accent-red",
    "color.border.accent.orange": "--ds-border-accent-orange",
    "color.border.accent.yellow": "--ds-border-accent-yellow",
    "color.border.accent.green": "--ds-border-accent-green",
    "color.border.accent.teal": "--ds-border-accent-teal",
    "color.border.accent.blue": "--ds-border-accent-blue",
    "color.border.accent.purple": "--ds-border-accent-purple",
    "color.border.accent.magenta": "--ds-border-accent-magenta",
    "color.border.accent.gray": "--ds-border-accent-gray",
    "color.border.disabled": "--ds-border-disabled",
    "color.border.focused": "--ds-border-focused",
    "color.border.input": "--ds-border-input",
    "color.border.inverse": "--ds-border-inverse",
    "color.border.selected": "--ds-border-selected",
    "color.border.brand": "--ds-border-brand",
    "color.border.danger": "--ds-border-danger",
    "color.border.warning": "--ds-border-warning",
    "color.border.success": "--ds-border-success",
    "color.border.discovery": "--ds-border-discovery",
    "color.border.information": "--ds-border-information",
    "color.border.bold": "--ds-border-bold",
    "color.background.accent.lime.subtlest": "--ds-background-accent-lime-subtlest",
    "color.background.accent.lime.subtlest.hovered": "--ds-background-accent-lime-subtlest-hovered",
    "color.background.accent.lime.subtlest.pressed": "--ds-background-accent-lime-subtlest-pressed",
    "color.background.accent.lime.subtler": "--ds-background-accent-lime-subtler",
    "color.background.accent.lime.subtler.hovered": "--ds-background-accent-lime-subtler-hovered",
    "color.background.accent.lime.subtler.pressed": "--ds-background-accent-lime-subtler-pressed",
    "color.background.accent.lime.subtle": "--ds-background-accent-lime-subtle",
    "color.background.accent.lime.subtle.hovered": "--ds-background-accent-lime-subtle-hovered",
    "color.background.accent.lime.subtle.pressed": "--ds-background-accent-lime-subtle-pressed",
    "color.background.accent.lime.bolder": "--ds-background-accent-lime-bolder",
    "color.background.accent.lime.bolder.hovered": "--ds-background-accent-lime-bolder-hovered",
    "color.background.accent.lime.bolder.pressed": "--ds-background-accent-lime-bolder-pressed",
    "color.background.accent.red.subtlest": "--ds-background-accent-red-subtlest",
    "color.background.accent.red.subtlest.hovered": "--ds-background-accent-red-subtlest-hovered",
    "color.background.accent.red.subtlest.pressed": "--ds-background-accent-red-subtlest-pressed",
    "color.background.accent.red.subtler": "--ds-background-accent-red-subtler",
    "color.background.accent.red.subtler.hovered": "--ds-background-accent-red-subtler-hovered",
    "color.background.accent.red.subtler.pressed": "--ds-background-accent-red-subtler-pressed",
    "color.background.accent.red.subtle": "--ds-background-accent-red-subtle",
    "color.background.accent.red.subtle.hovered": "--ds-background-accent-red-subtle-hovered",
    "color.background.accent.red.subtle.pressed": "--ds-background-accent-red-subtle-pressed",
    "color.background.accent.red.bolder": "--ds-background-accent-red-bolder",
    "color.background.accent.red.bolder.hovered": "--ds-background-accent-red-bolder-hovered",
    "color.background.accent.red.bolder.pressed": "--ds-background-accent-red-bolder-pressed",
    "color.background.accent.orange.subtlest": "--ds-background-accent-orange-subtlest",
    "color.background.accent.orange.subtlest.hovered": "--ds-background-accent-orange-subtlest-hovered",
    "color.background.accent.orange.subtlest.pressed": "--ds-background-accent-orange-subtlest-pressed",
    "color.background.accent.orange.subtler": "--ds-background-accent-orange-subtler",
    "color.background.accent.orange.subtler.hovered": "--ds-background-accent-orange-subtler-hovered",
    "color.background.accent.orange.subtler.pressed": "--ds-background-accent-orange-subtler-pressed",
    "color.background.accent.orange.subtle": "--ds-background-accent-orange-subtle",
    "color.background.accent.orange.subtle.hovered": "--ds-background-accent-orange-subtle-hovered",
    "color.background.accent.orange.subtle.pressed": "--ds-background-accent-orange-subtle-pressed",
    "color.background.accent.orange.bolder": "--ds-background-accent-orange-bolder",
    "color.background.accent.orange.bolder.hovered": "--ds-background-accent-orange-bolder-hovered",
    "color.background.accent.orange.bolder.pressed": "--ds-background-accent-orange-bolder-pressed",
    "color.background.accent.yellow.subtlest": "--ds-background-accent-yellow-subtlest",
    "color.background.accent.yellow.subtlest.hovered": "--ds-background-accent-yellow-subtlest-hovered",
    "color.background.accent.yellow.subtlest.pressed": "--ds-background-accent-yellow-subtlest-pressed",
    "color.background.accent.yellow.subtler": "--ds-background-accent-yellow-subtler",
    "color.background.accent.yellow.subtler.hovered": "--ds-background-accent-yellow-subtler-hovered",
    "color.background.accent.yellow.subtler.pressed": "--ds-background-accent-yellow-subtler-pressed",
    "color.background.accent.yellow.subtle": "--ds-background-accent-yellow-subtle",
    "color.background.accent.yellow.subtle.hovered": "--ds-background-accent-yellow-subtle-hovered",
    "color.background.accent.yellow.subtle.pressed": "--ds-background-accent-yellow-subtle-pressed",
    "color.background.accent.yellow.bolder": "--ds-background-accent-yellow-bolder",
    "color.background.accent.yellow.bolder.hovered": "--ds-background-accent-yellow-bolder-hovered",
    "color.background.accent.yellow.bolder.pressed": "--ds-background-accent-yellow-bolder-pressed",
    "color.background.accent.green.subtlest": "--ds-background-accent-green-subtlest",
    "color.background.accent.green.subtlest.hovered": "--ds-background-accent-green-subtlest-hovered",
    "color.background.accent.green.subtlest.pressed": "--ds-background-accent-green-subtlest-pressed",
    "color.background.accent.green.subtler": "--ds-background-accent-green-subtler",
    "color.background.accent.green.subtler.hovered": "--ds-background-accent-green-subtler-hovered",
    "color.background.accent.green.subtler.pressed": "--ds-background-accent-green-subtler-pressed",
    "color.background.accent.green.subtle": "--ds-background-accent-green-subtle",
    "color.background.accent.green.subtle.hovered": "--ds-background-accent-green-subtle-hovered",
    "color.background.accent.green.subtle.pressed": "--ds-background-accent-green-subtle-pressed",
    "color.background.accent.green.bolder": "--ds-background-accent-green-bolder",
    "color.background.accent.green.bolder.hovered": "--ds-background-accent-green-bolder-hovered",
    "color.background.accent.green.bolder.pressed": "--ds-background-accent-green-bolder-pressed",
    "color.background.accent.teal.subtlest": "--ds-background-accent-teal-subtlest",
    "color.background.accent.teal.subtlest.hovered": "--ds-background-accent-teal-subtlest-hovered",
    "color.background.accent.teal.subtlest.pressed": "--ds-background-accent-teal-subtlest-pressed",
    "color.background.accent.teal.subtler": "--ds-background-accent-teal-subtler",
    "color.background.accent.teal.subtler.hovered": "--ds-background-accent-teal-subtler-hovered",
    "color.background.accent.teal.subtler.pressed": "--ds-background-accent-teal-subtler-pressed",
    "color.background.accent.teal.subtle": "--ds-background-accent-teal-subtle",
    "color.background.accent.teal.subtle.hovered": "--ds-background-accent-teal-subtle-hovered",
    "color.background.accent.teal.subtle.pressed": "--ds-background-accent-teal-subtle-pressed",
    "color.background.accent.teal.bolder": "--ds-background-accent-teal-bolder",
    "color.background.accent.teal.bolder.hovered": "--ds-background-accent-teal-bolder-hovered",
    "color.background.accent.teal.bolder.pressed": "--ds-background-accent-teal-bolder-pressed",
    "color.background.accent.blue.subtlest": "--ds-background-accent-blue-subtlest",
    "color.background.accent.blue.subtlest.hovered": "--ds-background-accent-blue-subtlest-hovered",
    "color.background.accent.blue.subtlest.pressed": "--ds-background-accent-blue-subtlest-pressed",
    "color.background.accent.blue.subtler": "--ds-background-accent-blue-subtler",
    "color.background.accent.blue.subtler.hovered": "--ds-background-accent-blue-subtler-hovered",
    "color.background.accent.blue.subtler.pressed": "--ds-background-accent-blue-subtler-pressed",
    "color.background.accent.blue.subtle": "--ds-background-accent-blue-subtle",
    "color.background.accent.blue.subtle.hovered": "--ds-background-accent-blue-subtle-hovered",
    "color.background.accent.blue.subtle.pressed": "--ds-background-accent-blue-subtle-pressed",
    "color.background.accent.blue.bolder": "--ds-background-accent-blue-bolder",
    "color.background.accent.blue.bolder.hovered": "--ds-background-accent-blue-bolder-hovered",
    "color.background.accent.blue.bolder.pressed": "--ds-background-accent-blue-bolder-pressed",
    "color.background.accent.purple.subtlest": "--ds-background-accent-purple-subtlest",
    "color.background.accent.purple.subtlest.hovered": "--ds-background-accent-purple-subtlest-hovered",
    "color.background.accent.purple.subtlest.pressed": "--ds-background-accent-purple-subtlest-pressed",
    "color.background.accent.purple.subtler": "--ds-background-accent-purple-subtler",
    "color.background.accent.purple.subtler.hovered": "--ds-background-accent-purple-subtler-hovered",
    "color.background.accent.purple.subtler.pressed": "--ds-background-accent-purple-subtler-pressed",
    "color.background.accent.purple.subtle": "--ds-background-accent-purple-subtle",
    "color.background.accent.purple.subtle.hovered": "--ds-background-accent-purple-subtle-hovered",
    "color.background.accent.purple.subtle.pressed": "--ds-background-accent-purple-subtle-pressed",
    "color.background.accent.purple.bolder": "--ds-background-accent-purple-bolder",
    "color.background.accent.purple.bolder.hovered": "--ds-background-accent-purple-bolder-hovered",
    "color.background.accent.purple.bolder.pressed": "--ds-background-accent-purple-bolder-pressed",
    "color.background.accent.magenta.subtlest": "--ds-background-accent-magenta-subtlest",
    "color.background.accent.magenta.subtlest.hovered": "--ds-background-accent-magenta-subtlest-hovered",
    "color.background.accent.magenta.subtlest.pressed": "--ds-background-accent-magenta-subtlest-pressed",
    "color.background.accent.magenta.subtler": "--ds-background-accent-magenta-subtler",
    "color.background.accent.magenta.subtler.hovered": "--ds-background-accent-magenta-subtler-hovered",
    "color.background.accent.magenta.subtler.pressed": "--ds-background-accent-magenta-subtler-pressed",
    "color.background.accent.magenta.subtle": "--ds-background-accent-magenta-subtle",
    "color.background.accent.magenta.subtle.hovered": "--ds-background-accent-magenta-subtle-hovered",
    "color.background.accent.magenta.subtle.pressed": "--ds-background-accent-magenta-subtle-pressed",
    "color.background.accent.magenta.bolder": "--ds-background-accent-magenta-bolder",
    "color.background.accent.magenta.bolder.hovered": "--ds-background-accent-magenta-bolder-hovered",
    "color.background.accent.magenta.bolder.pressed": "--ds-background-accent-magenta-bolder-pressed",
    "color.background.accent.gray.subtlest": "--ds-background-accent-gray-subtlest",
    "color.background.accent.gray.subtlest.hovered": "--ds-background-accent-gray-subtlest-hovered",
    "color.background.accent.gray.subtlest.pressed": "--ds-background-accent-gray-subtlest-pressed",
    "color.background.accent.gray.subtler": "--ds-background-accent-gray-subtler",
    "color.background.accent.gray.subtler.hovered": "--ds-background-accent-gray-subtler-hovered",
    "color.background.accent.gray.subtler.pressed": "--ds-background-accent-gray-subtler-pressed",
    "color.background.accent.gray.subtle": "--ds-background-accent-gray-subtle",
    "color.background.accent.gray.subtle.hovered": "--ds-background-accent-gray-subtle-hovered",
    "color.background.accent.gray.subtle.pressed": "--ds-background-accent-gray-subtle-pressed",
    "color.background.accent.gray.bolder": "--ds-background-accent-gray-bolder",
    "color.background.accent.gray.bolder.hovered": "--ds-background-accent-gray-bolder-hovered",
    "color.background.accent.gray.bolder.pressed": "--ds-background-accent-gray-bolder-pressed",
    "color.background.disabled": "--ds-background-disabled",
    "color.background.input": "--ds-background-input",
    "color.background.input.hovered": "--ds-background-input-hovered",
    "color.background.input.pressed": "--ds-background-input-pressed",
    "color.background.inverse.subtle": "--ds-background-inverse-subtle",
    "color.background.inverse.subtle.hovered": "--ds-background-inverse-subtle-hovered",
    "color.background.inverse.subtle.pressed": "--ds-background-inverse-subtle-pressed",
    "color.background.neutral": "--ds-background-neutral",
    "color.background.neutral.hovered": "--ds-background-neutral-hovered",
    "color.background.neutral.pressed": "--ds-background-neutral-pressed",
    "color.background.neutral.subtle": "--ds-background-neutral-subtle",
    "color.background.neutral.subtle.hovered": "--ds-background-neutral-subtle-hovered",
    "color.background.neutral.subtle.pressed": "--ds-background-neutral-subtle-pressed",
    "color.background.neutral.bold": "--ds-background-neutral-bold",
    "color.background.neutral.bold.hovered": "--ds-background-neutral-bold-hovered",
    "color.background.neutral.bold.pressed": "--ds-background-neutral-bold-pressed",
    "color.background.selected": "--ds-background-selected",
    "color.background.selected.hovered": "--ds-background-selected-hovered",
    "color.background.selected.pressed": "--ds-background-selected-pressed",
    "color.background.selected.bold": "--ds-background-selected-bold",
    "color.background.selected.bold.hovered": "--ds-background-selected-bold-hovered",
    "color.background.selected.bold.pressed": "--ds-background-selected-bold-pressed",
    "color.background.brand.subtlest": "--ds-background-brand-subtlest",
    "color.background.brand.subtlest.hovered": "--ds-background-brand-subtlest-hovered",
    "color.background.brand.subtlest.pressed": "--ds-background-brand-subtlest-pressed",
    "color.background.brand.bold": "--ds-background-brand-bold",
    "color.background.brand.bold.hovered": "--ds-background-brand-bold-hovered",
    "color.background.brand.bold.pressed": "--ds-background-brand-bold-pressed",
    "color.background.brand.boldest": "--ds-background-brand-boldest",
    "color.background.brand.boldest.hovered": "--ds-background-brand-boldest-hovered",
    "color.background.brand.boldest.pressed": "--ds-background-brand-boldest-pressed",
    "color.background.danger": "--ds-background-danger",
    "color.background.danger.hovered": "--ds-background-danger-hovered",
    "color.background.danger.pressed": "--ds-background-danger-pressed",
    "color.background.danger.bold": "--ds-background-danger-bold",
    "color.background.danger.bold.hovered": "--ds-background-danger-bold-hovered",
    "color.background.danger.bold.pressed": "--ds-background-danger-bold-pressed",
    "color.background.warning": "--ds-background-warning",
    "color.background.warning.hovered": "--ds-background-warning-hovered",
    "color.background.warning.pressed": "--ds-background-warning-pressed",
    "color.background.warning.bold": "--ds-background-warning-bold",
    "color.background.warning.bold.hovered": "--ds-background-warning-bold-hovered",
    "color.background.warning.bold.pressed": "--ds-background-warning-bold-pressed",
    "color.background.success": "--ds-background-success",
    "color.background.success.hovered": "--ds-background-success-hovered",
    "color.background.success.pressed": "--ds-background-success-pressed",
    "color.background.success.bold": "--ds-background-success-bold",
    "color.background.success.bold.hovered": "--ds-background-success-bold-hovered",
    "color.background.success.bold.pressed": "--ds-background-success-bold-pressed",
    "color.background.discovery": "--ds-background-discovery",
    "color.background.discovery.hovered": "--ds-background-discovery-hovered",
    "color.background.discovery.pressed": "--ds-background-discovery-pressed",
    "color.background.discovery.bold": "--ds-background-discovery-bold",
    "color.background.discovery.bold.hovered": "--ds-background-discovery-bold-hovered",
    "color.background.discovery.bold.pressed": "--ds-background-discovery-bold-pressed",
    "color.background.information": "--ds-background-information",
    "color.background.information.hovered": "--ds-background-information-hovered",
    "color.background.information.pressed": "--ds-background-information-pressed",
    "color.background.information.bold": "--ds-background-information-bold",
    "color.background.information.bold.hovered": "--ds-background-information-bold-hovered",
    "color.background.information.bold.pressed": "--ds-background-information-bold-pressed",
    "color.blanket": "--ds-blanket",
    "color.blanket.selected": "--ds-blanket-selected",
    "color.blanket.danger": "--ds-blanket-danger",
    "color.interaction.hovered": "--ds-interaction-hovered",
    "color.interaction.pressed": "--ds-interaction-pressed",
    "color.skeleton": "--ds-skeleton",
    "color.skeleton.subtle": "--ds-skeleton-subtle",
    "color.chart.categorical.1": "--ds-chart-categorical-1",
    "color.chart.categorical.1.hovered": "--ds-chart-categorical-1-hovered",
    "color.chart.categorical.2": "--ds-chart-categorical-2",
    "color.chart.categorical.2.hovered": "--ds-chart-categorical-2-hovered",
    "color.chart.categorical.3": "--ds-chart-categorical-3",
    "color.chart.categorical.3.hovered": "--ds-chart-categorical-3-hovered",
    "color.chart.categorical.4": "--ds-chart-categorical-4",
    "color.chart.categorical.4.hovered": "--ds-chart-categorical-4-hovered",
    "color.chart.categorical.5": "--ds-chart-categorical-5",
    "color.chart.categorical.5.hovered": "--ds-chart-categorical-5-hovered",
    "color.chart.categorical.6": "--ds-chart-categorical-6",
    "color.chart.categorical.6.hovered": "--ds-chart-categorical-6-hovered",
    "color.chart.categorical.7": "--ds-chart-categorical-7",
    "color.chart.categorical.7.hovered": "--ds-chart-categorical-7-hovered",
    "color.chart.categorical.8": "--ds-chart-categorical-8",
    "color.chart.categorical.8.hovered": "--ds-chart-categorical-8-hovered",
    "color.chart.lime.bold": "--ds-chart-lime-bold",
    "color.chart.lime.bold.hovered": "--ds-chart-lime-bold-hovered",
    "color.chart.lime.bolder": "--ds-chart-lime-bolder",
    "color.chart.lime.bolder.hovered": "--ds-chart-lime-bolder-hovered",
    "color.chart.lime.boldest": "--ds-chart-lime-boldest",
    "color.chart.lime.boldest.hovered": "--ds-chart-lime-boldest-hovered",
    "color.chart.neutral": "--ds-chart-neutral",
    "color.chart.neutral.hovered": "--ds-chart-neutral-hovered",
    "color.chart.red.bold": "--ds-chart-red-bold",
    "color.chart.red.bold.hovered": "--ds-chart-red-bold-hovered",
    "color.chart.red.bolder": "--ds-chart-red-bolder",
    "color.chart.red.bolder.hovered": "--ds-chart-red-bolder-hovered",
    "color.chart.red.boldest": "--ds-chart-red-boldest",
    "color.chart.red.boldest.hovered": "--ds-chart-red-boldest-hovered",
    "color.chart.orange.bold": "--ds-chart-orange-bold",
    "color.chart.orange.bold.hovered": "--ds-chart-orange-bold-hovered",
    "color.chart.orange.bolder": "--ds-chart-orange-bolder",
    "color.chart.orange.bolder.hovered": "--ds-chart-orange-bolder-hovered",
    "color.chart.orange.boldest": "--ds-chart-orange-boldest",
    "color.chart.orange.boldest.hovered": "--ds-chart-orange-boldest-hovered",
    "color.chart.yellow.bold": "--ds-chart-yellow-bold",
    "color.chart.yellow.bold.hovered": "--ds-chart-yellow-bold-hovered",
    "color.chart.yellow.bolder": "--ds-chart-yellow-bolder",
    "color.chart.yellow.bolder.hovered": "--ds-chart-yellow-bolder-hovered",
    "color.chart.yellow.boldest": "--ds-chart-yellow-boldest",
    "color.chart.yellow.boldest.hovered": "--ds-chart-yellow-boldest-hovered",
    "color.chart.green.bold": "--ds-chart-green-bold",
    "color.chart.green.bold.hovered": "--ds-chart-green-bold-hovered",
    "color.chart.green.bolder": "--ds-chart-green-bolder",
    "color.chart.green.bolder.hovered": "--ds-chart-green-bolder-hovered",
    "color.chart.green.boldest": "--ds-chart-green-boldest",
    "color.chart.green.boldest.hovered": "--ds-chart-green-boldest-hovered",
    "color.chart.teal.bold": "--ds-chart-teal-bold",
    "color.chart.teal.bold.hovered": "--ds-chart-teal-bold-hovered",
    "color.chart.teal.bolder": "--ds-chart-teal-bolder",
    "color.chart.teal.bolder.hovered": "--ds-chart-teal-bolder-hovered",
    "color.chart.teal.boldest": "--ds-chart-teal-boldest",
    "color.chart.teal.boldest.hovered": "--ds-chart-teal-boldest-hovered",
    "color.chart.blue.bold": "--ds-chart-blue-bold",
    "color.chart.blue.bold.hovered": "--ds-chart-blue-bold-hovered",
    "color.chart.blue.bolder": "--ds-chart-blue-bolder",
    "color.chart.blue.bolder.hovered": "--ds-chart-blue-bolder-hovered",
    "color.chart.blue.boldest": "--ds-chart-blue-boldest",
    "color.chart.blue.boldest.hovered": "--ds-chart-blue-boldest-hovered",
    "color.chart.purple.bold": "--ds-chart-purple-bold",
    "color.chart.purple.bold.hovered": "--ds-chart-purple-bold-hovered",
    "color.chart.purple.bolder": "--ds-chart-purple-bolder",
    "color.chart.purple.bolder.hovered": "--ds-chart-purple-bolder-hovered",
    "color.chart.purple.boldest": "--ds-chart-purple-boldest",
    "color.chart.purple.boldest.hovered": "--ds-chart-purple-boldest-hovered",
    "color.chart.magenta.bold": "--ds-chart-magenta-bold",
    "color.chart.magenta.bold.hovered": "--ds-chart-magenta-bold-hovered",
    "color.chart.magenta.bolder": "--ds-chart-magenta-bolder",
    "color.chart.magenta.bolder.hovered": "--ds-chart-magenta-bolder-hovered",
    "color.chart.magenta.boldest": "--ds-chart-magenta-boldest",
    "color.chart.magenta.boldest.hovered": "--ds-chart-magenta-boldest-hovered",
    "color.chart.gray.bold": "--ds-chart-gray-bold",
    "color.chart.gray.bold.hovered": "--ds-chart-gray-bold-hovered",
    "color.chart.gray.bolder": "--ds-chart-gray-bolder",
    "color.chart.gray.bolder.hovered": "--ds-chart-gray-bolder-hovered",
    "color.chart.gray.boldest": "--ds-chart-gray-boldest",
    "color.chart.gray.boldest.hovered": "--ds-chart-gray-boldest-hovered",
    "color.chart.brand": "--ds-chart-brand",
    "color.chart.brand.hovered": "--ds-chart-brand-hovered",
    "color.chart.danger": "--ds-chart-danger",
    "color.chart.danger.hovered": "--ds-chart-danger-hovered",
    "color.chart.danger.bold": "--ds-chart-danger-bold",
    "color.chart.danger.bold.hovered": "--ds-chart-danger-bold-hovered",
    "color.chart.warning": "--ds-chart-warning",
    "color.chart.warning.hovered": "--ds-chart-warning-hovered",
    "color.chart.warning.bold": "--ds-chart-warning-bold",
    "color.chart.warning.bold.hovered": "--ds-chart-warning-bold-hovered",
    "color.chart.success": "--ds-chart-success",
    "color.chart.success.hovered": "--ds-chart-success-hovered",
    "color.chart.success.bold": "--ds-chart-success-bold",
    "color.chart.success.bold.hovered": "--ds-chart-success-bold-hovered",
    "color.chart.discovery": "--ds-chart-discovery",
    "color.chart.discovery.hovered": "--ds-chart-discovery-hovered",
    "color.chart.discovery.bold": "--ds-chart-discovery-bold",
    "color.chart.discovery.bold.hovered": "--ds-chart-discovery-bold-hovered",
    "color.chart.information": "--ds-chart-information",
    "color.chart.information.hovered": "--ds-chart-information-hovered",
    "color.chart.information.bold": "--ds-chart-information-bold",
    "color.chart.information.bold.hovered": "--ds-chart-information-bold-hovered",
    "elevation.surface": "--ds-surface",
    "elevation.surface.hovered": "--ds-surface-hovered",
    "elevation.surface.pressed": "--ds-surface-pressed",
    "elevation.surface.overlay": "--ds-surface-overlay",
    "elevation.surface.overlay.hovered": "--ds-surface-overlay-hovered",
    "elevation.surface.overlay.pressed": "--ds-surface-overlay-pressed",
    "elevation.surface.raised": "--ds-surface-raised",
    "elevation.surface.raised.hovered": "--ds-surface-raised-hovered",
    "elevation.surface.raised.pressed": "--ds-surface-raised-pressed",
    "elevation.surface.sunken": "--ds-surface-sunken",
    "elevation.shadow.overflow": "--ds-shadow-overflow",
    "elevation.shadow.overflow.perimeter": "--ds-shadow-overflow-perimeter",
    "elevation.shadow.overflow.spread": "--ds-shadow-overflow-spread",
    "elevation.shadow.overlay": "--ds-shadow-overlay",
    "elevation.shadow.raised": "--ds-shadow-raised",
    "opacity.disabled": "--ds-opacity-disabled",
    "opacity.loading": "--ds-opacity-loading",
    "utility.UNSAFE.textTransformUppercase": "--ds-UNSAFE-textTransformUppercase",
    "utility.UNSAFE.transparent": "--ds-UNSAFE-transparent",
    "utility.elevation.surface.current": "--ds-elevation-surface-current",
    "border.radius.050": "--ds-border-radius-050",
    "border.radius": "--ds-border-radius",
    "border.radius.100": "--ds-border-radius-100",
    "border.radius.200": "--ds-border-radius-200",
    "border.radius.300": "--ds-border-radius-300",
    "border.radius.400": "--ds-border-radius-400",
    "border.radius.circle": "--ds-border-radius-circle",
    "border.width": "--ds-border-width",
    "border.width.0": "--ds-border-width-0",
    "border.width.indicator": "--ds-border-width-indicator",
    "border.width.outline": "--ds-border-width-outline",
    "space.0": "--ds-space-0",
    "space.025": "--ds-space-025",
    "space.050": "--ds-space-050",
    "space.075": "--ds-space-075",
    "space.100": "--ds-space-100",
    "space.150": "--ds-space-150",
    "space.200": "--ds-space-200",
    "space.250": "--ds-space-250",
    "space.300": "--ds-space-300",
    "space.400": "--ds-space-400",
    "space.500": "--ds-space-500",
    "space.600": "--ds-space-600",
    "space.800": "--ds-space-800",
    "space.1000": "--ds-space-1000",
    "space.negative.025": "--ds-space-negative-025",
    "space.negative.050": "--ds-space-negative-050",
    "space.negative.075": "--ds-space-negative-075",
    "space.negative.100": "--ds-space-negative-100",
    "space.negative.150": "--ds-space-negative-150",
    "space.negative.200": "--ds-space-negative-200",
    "space.negative.250": "--ds-space-negative-250",
    "space.negative.300": "--ds-space-negative-300",
    "space.negative.400": "--ds-space-negative-400",
    "font.heading.xxlarge": "--ds-font-heading-xxlarge",
    "font.heading.xlarge": "--ds-font-heading-xlarge",
    "font.heading.large": "--ds-font-heading-large",
    "font.heading.medium": "--ds-font-heading-medium",
    "font.heading.small": "--ds-font-heading-small",
    "font.heading.xsmall": "--ds-font-heading-xsmall",
    "font.heading.xxsmall": "--ds-font-heading-xxsmall",
    "font.body.large": "--ds-font-body-large",
    "font.body": "--ds-font-body",
    "font.body.small": "--ds-font-body-small",
    "font.body.UNSAFE_small": "--ds-font-body-UNSAFE_small",
    "font.code": "--ds-font-code",
    "font.weight.regular": "--ds-font-weight-regular",
    "font.weight.medium": "--ds-font-weight-medium",
    "font.weight.semibold": "--ds-font-weight-semibold",
    "font.weight.bold": "--ds-font-weight-bold",
    "font.family.heading": "--ds-font-family-heading",
    "font.family.body": "--ds-font-family-body",
    "font.family.code": "--ds-font-family-code",
    "font.family.brand.heading": "--ds-font-family-brand-heading",
    "font.family.brand.body": "--ds-font-family-brand-body"
};
var $60b46b7d0858aab2$export$2e2bcd8739ae039 = $60b46b7d0858aab2$var$tokens;

});

parcelRegister("da8nl", function(module, exports) {

$parcel$export(module.exports, "THEME_DATA_ATTRIBUTE", function () { return $9952b4bcb2aa6015$export$4ef52930e33717cd; });
$parcel$export(module.exports, "COLOR_MODE_ATTRIBUTE", function () { return $9952b4bcb2aa6015$export$a00eac3f8684bcd0; });
$parcel$export(module.exports, "CONTRAST_MODE_ATTRIBUTE", function () { return $9952b4bcb2aa6015$export$2112803007239c61; });
$parcel$export(module.exports, "CUSTOM_THEME_ATTRIBUTE", function () { return $9952b4bcb2aa6015$export$352e418ed5b6193a; });
$parcel$export(module.exports, "TOKEN_NOT_FOUND_CSS_VAR", function () { return $9952b4bcb2aa6015$export$dddac1532e822863; });
$parcel$export(module.exports, "CURRENT_SURFACE_CSS_VAR", function () { return $9952b4bcb2aa6015$export$9d7b58831ae93caa; });
var $9952b4bcb2aa6015$export$4ef52930e33717cd = "data-theme";
var $9952b4bcb2aa6015$export$a00eac3f8684bcd0 = "data-color-mode";
var $9952b4bcb2aa6015$export$2112803007239c61 = "data-contrast-mode";
var $9952b4bcb2aa6015$export$352e418ed5b6193a = "data-custom-theme";
var $9952b4bcb2aa6015$export$2faeed762aac6741 = "light";
var $9952b4bcb2aa6015$export$6f0c6fb8c80fcc92 = "ds";
var $9952b4bcb2aa6015$export$4d0c7bbf80185957 = [
    "opacity",
    "font",
    "space",
    "border"
];
var $9952b4bcb2aa6015$export$dddac1532e822863 = "--".concat($9952b4bcb2aa6015$export$6f0c6fb8c80fcc92, "-token-not-found");
var $9952b4bcb2aa6015$export$9d7b58831ae93caa = "--".concat($9952b4bcb2aa6015$export$6f0c6fb8c80fcc92, "-elevation-surface-current");

});





parcelRegister("98XV1", function(module, exports) {

$parcel$export(module.exports, "ApdexStart", function () { return (parcelRequire("53PE4")).default; });
$parcel$export(module.exports, "ApdexStop", function () { return (parcelRequire("zFJ4O")).default; });
$parcel$export(module.exports, "ApdexTasks", function () { return (parcelRequire("7dUzb")).ApdexTasks; });

var $53PE4 = parcelRequire("53PE4");

var $zFJ4O = parcelRequire("zFJ4O");

var $7dUzb = parcelRequire("7dUzb");

});
parcelRegister("53PE4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c46f81320e72cc1f$export$2e2bcd8739ae039; });

var $dAx5m = parcelRequire("dAx5m");
parcelRequire("adUiG");
var $58n8k = parcelRequire("58n8k");
const $c46f81320e72cc1f$export$bb2cae3fef58e038 = ({ analytics: analytics, task: task })=>{
    (0, $dAx5m.useEffect)(()=>{
        analytics.startApdexEvent({
            task: task
        });
    });
    return null;
};
var $c46f81320e72cc1f$export$2e2bcd8739ae039 = (0, $58n8k.default)($c46f81320e72cc1f$export$bb2cae3fef58e038);

});

parcelRegister("zFJ4O", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2931dc6e77f1bcfa$export$2e2bcd8739ae039; });

var $dAx5m = parcelRequire("dAx5m");
parcelRequire("adUiG");
var $58n8k = parcelRequire("58n8k");
const $2931dc6e77f1bcfa$export$6721348313394ccf = ({ analytics: analytics, task: task, taskId: taskId, threshold: threshold })=>{
    (0, $dAx5m.useEffect)(()=>{
        setTimeout(()=>{
            analytics.stopApdexEvent({
                task: task,
                taskId: taskId,
                threshold: threshold
            });
        }, 0);
    }, [
        analytics.stopApdexEvent,
        task,
        taskId,
        threshold
    ]);
    return null;
};
var $2931dc6e77f1bcfa$export$2e2bcd8739ae039 = (0, $58n8k.default)($2931dc6e77f1bcfa$export$6721348313394ccf);

});

parcelRegister("7dUzb", function(module, exports) {

$parcel$export(module.exports, "ApdexTasks", function () { return $52732740cb928e21$export$c9a001620fbc9a96; });
/**
 * Task names should start with a verb e.g. viewProfile, createTeam, makeMemes
 */ var $52732740cb928e21$export$c9a001620fbc9a96;
(function(ApdexTasks) {
    ApdexTasks["VIEW_APPS_SETTINGS"] = "viewAppsSettings";
    ApdexTasks["VIEW_LINK_PREFERENCES_SETTINGS"] = "viewLinkPreferencesSettings";
    ApdexTasks["VIEW_CLOSE_ACCOUNT_SETTINGS"] = "viewCloseAccountSettings";
    ApdexTasks["VIEW_EMAIL_SETTINGS"] = "viewEmailSettings";
    ApdexTasks["VIEW_GENERAL_SETTINGS"] = "viewGeneralSettings";
    ApdexTasks["VIEW_PROFILE_AND_VISIBILITY_SETTINGS"] = "viewProfileAndVisibilitySettings";
    ApdexTasks["VIEW_PRIVACY_SETTINGS"] = "viewPrivacySettings";
    ApdexTasks["VIEW_PRODUCT_SETTINGS"] = "viewProductSettings";
    ApdexTasks["VIEW_SECURITY_SETTINGS"] = "viewSecuritySettings";
    ApdexTasks["VIEW_TWO_STEP_VERIFICATION"] = "viewTwoStepVerification";
    ApdexTasks["VIEW_API_TOKENS"] = "viewApiTokens";
    ApdexTasks["VIEW_RECENT_DEVICES"] = "viewRecentDevices";
    ApdexTasks["VIEW_ACCOUNT_PREFERENCES_SETTINGS"] = "viewAccountPreferencesSettings";
    ApdexTasks["VIEW_UNIFIED_USER_PROFILE"] = "viewUnifiedUserProfile";
    ApdexTasks["VIEW_USER_WORKED_ON_PAGE"] = "viewUserWorkedOnPage";
    ApdexTasks["VIEW_TEAM_PROFILE"] = "viewTeamProfile";
    ApdexTasks["VIEW_SEARCH_PAGE"] = "viewSearchPage";
    ApdexTasks["VIEW_PROFILE_CARD"] = "viewProfileCard";
})($52732740cb928e21$export$c9a001620fbc9a96 || ($52732740cb928e21$export$c9a001620fbc9a96 = {}));

});


parcelRegister("lX9pQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return (parcelRequire("1UxEK")).default; });

var $1UxEK = parcelRequire("1UxEK");

});
parcelRegister("1UxEK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $839edfa815de26e8$export$2e2bcd8739ae039; });

var $bibO8 = parcelRequire("bibO8");
parcelRequire("dAx5m");

var $5Zreo = parcelRequire("5Zreo");

var $4ml7i = parcelRequire("4ml7i");
const $839edfa815de26e8$var$getStyledLink = (LinkComponent)=>(0, $4ml7i.getStyledAnchor)(LinkComponent);
const $839edfa815de26e8$var$StyledAnchor = $839edfa815de26e8$var$getStyledLink("a");
const $839edfa815de26e8$var$Anchor = ({ LinkComponent: LinkComponent = (0, $5Zreo.Link), children: children, to: to, appearance: appearance = "default", onMouseDown: onMouseDown = ()=>null, ...props })=>{
    const StyledLink = $839edfa815de26e8$var$getStyledLink(LinkComponent);
    const handleInternalMouseDown = (event)=>{
        event.preventDefault();
        onMouseDown(event);
    };
    const { href: href, target: target, ...linkProps } = props;
    if (to) return /*#__PURE__*/ (0, $bibO8.jsx)(StyledLink, {
        ...linkProps,
        onMouseDown: handleInternalMouseDown,
        to: to,
        appearance: appearance,
        children: children
    });
    return /*#__PURE__*/ (0, $bibO8.jsx)($839edfa815de26e8$var$StyledAnchor, {
        rel: "noopener noreferrer",
        href: href,
        target: target,
        ...linkProps,
        appearance: appearance,
        onMouseDown: handleInternalMouseDown,
        children: children
    });
};
var $839edfa815de26e8$export$2e2bcd8739ae039 = $839edfa815de26e8$var$Anchor;

});
parcelRegister("5Zreo", function(module, exports) {

$parcel$export(module.exports, "BrowserRouter", function () { return $45c7c5cc0b99fadb$export$9ba4e89fdfa1fc54; });
$parcel$export(module.exports, "Link", function () { return $45c7c5cc0b99fadb$export$a6c7ac8248d6e38a; });
$parcel$export(module.exports, "useLocation", function () { return (parcelRequire("lairn")).useLocation; });
$parcel$export(module.exports, "useNavigate", function () { return (parcelRequire("lairn")).useNavigate; });
/**
 * React Router DOM v6.28.2
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $dAx5m = parcelRequire("dAx5m");

var $1MpXQ = parcelRequire("1MpXQ");

var $7IVBD = parcelRequire("7IVBD");
var $lairn = parcelRequire("lairn");

var $7IVBD = parcelRequire("7IVBD");
function $45c7c5cc0b99fadb$var$_extends() {
    $45c7c5cc0b99fadb$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $45c7c5cc0b99fadb$var$_extends.apply(this, arguments);
}
function $45c7c5cc0b99fadb$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const $45c7c5cc0b99fadb$var$defaultMethod = "get";
const $45c7c5cc0b99fadb$var$defaultEncType = "application/x-www-form-urlencoded";
function $45c7c5cc0b99fadb$var$isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function $45c7c5cc0b99fadb$var$isButtonElement(object) {
    return $45c7c5cc0b99fadb$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $45c7c5cc0b99fadb$var$isFormElement(object) {
    return $45c7c5cc0b99fadb$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $45c7c5cc0b99fadb$var$isInputElement(object) {
    return $45c7c5cc0b99fadb$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $45c7c5cc0b99fadb$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $45c7c5cc0b99fadb$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$45c7c5cc0b99fadb$var$isModifiedEvent(event) // Ignore clicks with modifier keys
    ;
}
/**
 * Creates a URLSearchParams object using the given initializer.
 *
 * This is identical to `new URLSearchParams(init)` except it also
 * supports arrays as values in the object form of the initializer
 * instead of just strings. This is convenient when you need multiple
 * values for a given key, but don't want to use an array initializer.
 *
 * For example, instead of:
 *
 *   let searchParams = new URLSearchParams([
 *     ['sort', 'name'],
 *     ['sort', 'price']
 *   ]);
 *
 * you can do:
 *
 *   let searchParams = createSearchParams({
 *     sort: ['name', 'price']
 *   });
 */ function $45c7c5cc0b99fadb$export$a2e4e2dcc7b1f22f(init) {
    if (init === void 0) init = "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo, key)=>{
        let value = init[key];
        return memo.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $45c7c5cc0b99fadb$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = $45c7c5cc0b99fadb$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) // Use `defaultSearchParams.forEach(...)` here instead of iterating of
    // `defaultSearchParams.keys()` to work-around a bug in Firefox related to
    // web extensions. Relevant Bugzilla tickets:
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1414602
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1023984
    defaultSearchParams.forEach((_, key)=>{
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
// One-time check for submitter support
let $45c7c5cc0b99fadb$var$_formDataSupportsSubmitter = null;
function $45c7c5cc0b99fadb$var$isFormDataSubmitterSupported() {
    if ($45c7c5cc0b99fadb$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $45c7c5cc0b99fadb$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $45c7c5cc0b99fadb$var$_formDataSupportsSubmitter = true;
    }
    return $45c7c5cc0b99fadb$var$_formDataSupportsSubmitter;
}
const $45c7c5cc0b99fadb$var$supportedFormEncTypes = new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $45c7c5cc0b99fadb$var$getFormEncType(encType) {
    if (encType != null && !$45c7c5cc0b99fadb$var$supportedFormEncTypes.has(encType)) return null;
    return encType;
}
function $45c7c5cc0b99fadb$var$getFormSubmissionInfo(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if ($45c7c5cc0b99fadb$var$isFormElement(target)) {
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("action");
        action = attr ? (0, $7IVBD.stripBasename)(attr, basename) : null;
        method = target.getAttribute("method") || $45c7c5cc0b99fadb$var$defaultMethod;
        encType = $45c7c5cc0b99fadb$var$getFormEncType(target.getAttribute("enctype")) || $45c7c5cc0b99fadb$var$defaultEncType;
        formData = new FormData(target);
    } else if ($45c7c5cc0b99fadb$var$isButtonElement(target) || $45c7c5cc0b99fadb$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error('Cannot submit a <button> or <input type="submit"> without a <form>');
        // <button>/<input type="submit"> may override attributes of <form>
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? (0, $7IVBD.stripBasename)(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $45c7c5cc0b99fadb$var$defaultMethod;
        encType = $45c7c5cc0b99fadb$var$getFormEncType(target.getAttribute("formenctype")) || $45c7c5cc0b99fadb$var$getFormEncType(form.getAttribute("enctype")) || $45c7c5cc0b99fadb$var$defaultEncType;
        // Build a FormData object populated from a form and submitter
        formData = new FormData(form, target);
        // If this browser doesn't support the `FormData(el, submitter)` format,
        // then tack on the submitter value at the end.  This is a lightweight
        // solution that is not 100% spec compliant.  For complete support in older
        // browsers, consider using the `formdata-submitter-polyfill` package
        if (!$45c7c5cc0b99fadb$var$isFormDataSubmitterSupported()) {
            let { name: name, type: type, value: value } = target;
            if (type === "image") {
                let prefix = name ? name + "." : "";
                formData.append(prefix + "x", "0");
                formData.append(prefix + "y", "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($45c7c5cc0b99fadb$var$isHtmlElement(target)) throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    else {
        method = $45c7c5cc0b99fadb$var$defaultMethod;
        action = null;
        encType = $45c7c5cc0b99fadb$var$defaultEncType;
        body = target;
    }
    // Send body for <Form encType="text/plain" so we encode it into text
    if (formData && encType === "text/plain") {
        body = formData;
        formData = undefined;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
const $45c7c5cc0b99fadb$var$_excluded = [
    "onClick",
    "relative",
    "reloadDocument",
    "replace",
    "state",
    "target",
    "to",
    "preventScrollReset",
    "viewTransition"
], $45c7c5cc0b99fadb$var$_excluded2 = [
    "aria-current",
    "caseSensitive",
    "className",
    "end",
    "style",
    "to",
    "viewTransition",
    "children"
], $45c7c5cc0b99fadb$var$_excluded3 = [
    "fetcherKey",
    "navigate",
    "reloadDocument",
    "replace",
    "state",
    "method",
    "action",
    "onSubmit",
    "relative",
    "preventScrollReset",
    "viewTransition"
];
// HEY YOU! DON'T TOUCH THIS VARIABLE!
//
// It is replaced with the proper version at build time via a babel plugin in
// the rollup config.
//
// Export a global property onto the window for React Router detection by the
// Core Web Vitals Technology Report.  This way they can configure the `wappalyzer`
// to detect and properly classify live websites as being built with React Router:
// https://github.com/HTTPArchive/wappalyzer/blob/main/src/technologies/r.json
const $45c7c5cc0b99fadb$var$REACT_ROUTER_VERSION = "6";
try {
    window.__reactRouterVersion = $45c7c5cc0b99fadb$var$REACT_ROUTER_VERSION;
} catch (e) {
// no-op
}
function $45c7c5cc0b99fadb$export$1f3f55432a00e06d(routes, opts) {
    return (0, $7IVBD.createRouter)({
        basename: opts == null ? void 0 : opts.basename,
        future: $45c7c5cc0b99fadb$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $7IVBD.createBrowserHistory)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $45c7c5cc0b99fadb$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $lairn.UNSAFE_mapRouteProperties),
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $45c7c5cc0b99fadb$export$1ba7ed8a3a7b3765(routes, opts) {
    return (0, $7IVBD.createRouter)({
        basename: opts == null ? void 0 : opts.basename,
        future: $45c7c5cc0b99fadb$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $7IVBD.createHashHistory)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $45c7c5cc0b99fadb$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $lairn.UNSAFE_mapRouteProperties),
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $45c7c5cc0b99fadb$var$parseHydrationData() {
    var _window;
    let state = (_window = window) == null ? void 0 : _window.__staticRouterHydrationData;
    if (state && state.errors) state = $45c7c5cc0b99fadb$var$_extends({}, state, {
        errors: $45c7c5cc0b99fadb$var$deserializeErrors(state.errors)
    });
    return state;
}
function $45c7c5cc0b99fadb$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        // Hey you!  If you change this, please change the corresponding logic in
        // serializeErrors in react-router-dom/server.tsx :)
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new (0, $7IVBD.UNSAFE_ErrorResponseImpl)(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            // Attempt to reconstruct the right type of Error (i.e., ReferenceError)
            if (val.__subType) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    // @ts-expect-error
                    let error = new ErrorConstructor(val.message);
                    // Wipe away the client-side stack trace.  Nothing to fill it in with
                    // because we don't serialize SSR stack traces for security reasons
                    error.stack = "";
                    serialized[key] = error;
                } catch (e) {
                // no-op - fall through and create a normal Error
                }
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                // Wipe away the client-side stack trace.  Nothing to fill it in with
                // because we don't serialize SSR stack traces for security reasons
                error.stack = "";
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}
const $45c7c5cc0b99fadb$export$7ad602f0e94e62d1 = /*#__PURE__*/ $dAx5m.createContext({
    isTransitioning: false
});
const $45c7c5cc0b99fadb$export$148fd98d095596d4 = /*#__PURE__*/ $dAx5m.createContext(new Map());
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Components
////////////////////////////////////////////////////////////////////////////////
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $45c7c5cc0b99fadb$var$START_TRANSITION = "startTransition";
const $45c7c5cc0b99fadb$var$startTransitionImpl = $dAx5m[$45c7c5cc0b99fadb$var$START_TRANSITION];
const $45c7c5cc0b99fadb$var$FLUSH_SYNC = "flushSync";
const $45c7c5cc0b99fadb$var$flushSyncImpl = $1MpXQ[$45c7c5cc0b99fadb$var$FLUSH_SYNC];
const $45c7c5cc0b99fadb$var$USE_ID = "useId";
const $45c7c5cc0b99fadb$var$useIdImpl = $dAx5m[$45c7c5cc0b99fadb$var$USE_ID];
function $45c7c5cc0b99fadb$var$startTransitionSafe(cb) {
    if ($45c7c5cc0b99fadb$var$startTransitionImpl) $45c7c5cc0b99fadb$var$startTransitionImpl(cb);
    else cb();
}
function $45c7c5cc0b99fadb$var$flushSyncSafe(cb) {
    if ($45c7c5cc0b99fadb$var$flushSyncImpl) $45c7c5cc0b99fadb$var$flushSyncImpl(cb);
    else cb();
}
class $45c7c5cc0b99fadb$var$Deferred {
    constructor(){
        this.status = "pending";
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = (value)=>{
                if (this.status === "pending") {
                    this.status = "resolved";
                    resolve(value);
                }
            };
            this.reject = (reason)=>{
                if (this.status === "pending") {
                    this.status = "rejected";
                    reject(reason);
                }
            };
        });
    }
}
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $45c7c5cc0b99fadb$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $dAx5m.useState(router.state);
    let [pendingState, setPendingState] = $dAx5m.useState();
    let [vtContext, setVtContext] = $dAx5m.useState({
        isTransitioning: false
    });
    let [renderDfd, setRenderDfd] = $dAx5m.useState();
    let [transition, setTransition] = $dAx5m.useState();
    let [interruption, setInterruption] = $dAx5m.useState();
    let fetcherData = $dAx5m.useRef(new Map());
    let { v7_startTransition: v7_startTransition } = future || {};
    let optInStartTransition = $dAx5m.useCallback((cb)=>{
        if (v7_startTransition) $45c7c5cc0b99fadb$var$startTransitionSafe(cb);
        else cb();
    }, [
        v7_startTransition
    ]);
    let setState = $dAx5m.useCallback((newState, _ref2)=>{
        let { deletedFetchers: deletedFetchers, flushSync: flushSync, viewTransitionOpts: viewTransitionOpts } = _ref2;
        newState.fetchers.forEach((fetcher, key)=>{
            if (fetcher.data !== undefined) fetcherData.current.set(key, fetcher.data);
        });
        deletedFetchers.forEach((key)=>fetcherData.current.delete(key));
        let isViewTransitionUnavailable = router.window == null || router.window.document == null || typeof router.window.document.startViewTransition !== "function";
        // If this isn't a view transition or it's not available in this browser,
        // just update and be done with it
        if (!viewTransitionOpts || isViewTransitionUnavailable) {
            if (flushSync) $45c7c5cc0b99fadb$var$flushSyncSafe(()=>setStateImpl(newState));
            else optInStartTransition(()=>setStateImpl(newState));
            return;
        }
        // flushSync + startViewTransition
        if (flushSync) {
            // Flush through the context to mark DOM elements as transition=ing
            $45c7c5cc0b99fadb$var$flushSyncSafe(()=>{
                // Cancel any pending transitions
                if (transition) {
                    renderDfd && renderDfd.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            // Update the DOM
            let t = router.window.document.startViewTransition(()=>{
                $45c7c5cc0b99fadb$var$flushSyncSafe(()=>setStateImpl(newState));
            });
            // Clean up after the animation completes
            t.finished.finally(()=>{
                $45c7c5cc0b99fadb$var$flushSyncSafe(()=>{
                    setRenderDfd(undefined);
                    setTransition(undefined);
                    setPendingState(undefined);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            $45c7c5cc0b99fadb$var$flushSyncSafe(()=>setTransition(t));
            return;
        }
        // startTransition + startViewTransition
        if (transition) {
            // Interrupting an in-progress transition, cancel and let everything flush
            // out, and then kick off a new transition from the interruption state
            renderDfd && renderDfd.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            // Completed navigation update with opted-in view transitions, let 'er rip
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        transition,
        renderDfd,
        fetcherData,
        optInStartTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $dAx5m.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    // When we start a view transition, create a Deferred we can use for the
    // eventual "completed" render
    $dAx5m.useEffect(()=>{
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new $45c7c5cc0b99fadb$var$Deferred());
    }, [
        vtContext
    ]);
    // Once the deferred is created, kick off startViewTransition() to update the
    // DOM and then wait on the Deferred to resolve (indicating the DOM update has
    // happened)
    $dAx5m.useEffect(()=>{
        if (renderDfd && pendingState && router.window) {
            let newState = pendingState;
            let renderPromise = renderDfd.promise;
            let transition = router.window.document.startViewTransition(async ()=>{
                optInStartTransition(()=>setStateImpl(newState));
                await renderPromise;
            });
            transition.finished.finally(()=>{
                setRenderDfd(undefined);
                setTransition(undefined);
                setPendingState(undefined);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition);
        }
    }, [
        optInStartTransition,
        pendingState,
        renderDfd,
        router.window
    ]);
    // When the new location finally renders and is committed to the DOM, this
    // effect will run to resolve the transition
    $dAx5m.useEffect(()=>{
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    // If we get interrupted with a new navigation during a transition, we skip
    // the active transition, let it cleanup, then kick it off again here
    $dAx5m.useEffect(()=>{
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(undefined);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    $dAx5m.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $dAx5m.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $dAx5m.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    let routerFuture = $dAx5m.useMemo(()=>({
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }), [
        router.future.v7_relativeSplatPath
    ]);
    $dAx5m.useEffect(()=>(0, $lairn.UNSAFE_logV6DeprecationWarnings)(future, router.future), [
        future,
        router.future
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $dAx5m.createElement($dAx5m.Fragment, null, /*#__PURE__*/ $dAx5m.createElement((0, $lairn.UNSAFE_DataRouterContext).Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $dAx5m.createElement((0, $lairn.UNSAFE_DataRouterStateContext).Provider, {
        value: state
    }, /*#__PURE__*/ $dAx5m.createElement($45c7c5cc0b99fadb$export$148fd98d095596d4.Provider, {
        value: fetcherData.current
    }, /*#__PURE__*/ $dAx5m.createElement($45c7c5cc0b99fadb$export$7ad602f0e94e62d1.Provider, {
        value: vtContext
    }, /*#__PURE__*/ $dAx5m.createElement((0, $lairn.Router), {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: routerFuture
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $dAx5m.createElement($45c7c5cc0b99fadb$var$MemoizedDataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))))), null);
}
// Memoize to avoid re-renders when updating `ViewTransitionContext`
const $45c7c5cc0b99fadb$var$MemoizedDataRoutes = /*#__PURE__*/ $dAx5m.memo($45c7c5cc0b99fadb$var$DataRoutes);
function $45c7c5cc0b99fadb$var$DataRoutes(_ref3) {
    let { routes: routes, future: future, state: state } = _ref3;
    return (0, $lairn.UNSAFE_useRoutesImpl)(routes, undefined, state, future);
}
/**
 * A `<Router>` for use in web browsers. Provides the cleanest URLs.
 */ function $45c7c5cc0b99fadb$export$9ba4e89fdfa1fc54(_ref4) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref4;
    let historyRef = $dAx5m.useRef();
    if (historyRef.current == null) historyRef.current = (0, $7IVBD.createBrowserHistory)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $dAx5m.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $dAx5m.useCallback((newState)=>{
        v7_startTransition && $45c7c5cc0b99fadb$var$startTransitionImpl ? $45c7c5cc0b99fadb$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $dAx5m.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $dAx5m.useEffect(()=>(0, $lairn.UNSAFE_logV6DeprecationWarnings)(future), [
        future
    ]);
    return /*#__PURE__*/ $dAx5m.createElement((0, $lairn.Router), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` for use in web browsers. Stores the location in the hash
 * portion of the URL so it is not sent to the server.
 */ function $45c7c5cc0b99fadb$export$7221d69dcfc8e36b(_ref5) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref5;
    let historyRef = $dAx5m.useRef();
    if (historyRef.current == null) historyRef.current = (0, $7IVBD.createHashHistory)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $dAx5m.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $dAx5m.useCallback((newState)=>{
        v7_startTransition && $45c7c5cc0b99fadb$var$startTransitionImpl ? $45c7c5cc0b99fadb$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $dAx5m.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $dAx5m.useEffect(()=>(0, $lairn.UNSAFE_logV6DeprecationWarnings)(future), [
        future
    ]);
    return /*#__PURE__*/ $dAx5m.createElement((0, $lairn.Router), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` that accepts a pre-instantiated history object. It's important
 * to note that using your own history object is highly discouraged and may add
 * two versions of the history library to your bundles unless you use the same
 * version of the history library that React Router uses internally.
 */ function $45c7c5cc0b99fadb$export$eefb0c834599897e(_ref6) {
    let { basename: basename, children: children, future: future, history: history } = _ref6;
    let [state, setStateImpl] = $dAx5m.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $dAx5m.useCallback((newState)=>{
        v7_startTransition && $45c7c5cc0b99fadb$var$startTransitionImpl ? $45c7c5cc0b99fadb$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $dAx5m.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $dAx5m.useEffect(()=>(0, $lairn.UNSAFE_logV6DeprecationWarnings)(future), [
        future
    ]);
    return /*#__PURE__*/ $dAx5m.createElement((0, $lairn.Router), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
const $45c7c5cc0b99fadb$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
const $45c7c5cc0b99fadb$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
/**
 * The public API for rendering a history-aware `<a>`.
 */ const $45c7c5cc0b99fadb$export$a6c7ac8248d6e38a = /*#__PURE__*/ $dAx5m.forwardRef(function LinkWithRef(_ref7, ref) {
    let { onClick: onClick, relative: relative, reloadDocument: reloadDocument, replace: replace, state: state, target: target, to: to, preventScrollReset: preventScrollReset, viewTransition: viewTransition } = _ref7, rest = $45c7c5cc0b99fadb$var$_objectWithoutPropertiesLoose(_ref7, $45c7c5cc0b99fadb$var$_excluded);
    let { basename: basename } = $dAx5m.useContext((0, $lairn.UNSAFE_NavigationContext));
    // Rendered into <a href> for absolute URLs
    let absoluteHref;
    let isExternal = false;
    if (typeof to === "string" && $45c7c5cc0b99fadb$var$ABSOLUTE_URL_REGEX.test(to)) {
        // Render the absolute href server- and client-side
        absoluteHref = to;
        // Only check for external origins client-side
        if ($45c7c5cc0b99fadb$var$isBrowser) try {
            let currentUrl = new URL(window.location.href);
            let targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            let path = (0, $7IVBD.stripBasename)(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) // Strip the protocol/origin/basename for same-origin absolute URLs
            to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        } catch (e) {}
    }
    // Rendered into <a href> for relative URLs
    let href = (0, $lairn.useHref)(to, {
        relative: relative
    });
    let internalOnClick = $45c7c5cc0b99fadb$export$67621102c14d847(to, {
        replace: replace,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative,
        viewTransition: viewTransition
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/anchor-has-content
    $dAx5m.createElement("a", $45c7c5cc0b99fadb$var$_extends({}, rest, {
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: ref,
        target: target
    })));
});
/**
 * A `<Link>` wrapper that knows if it's "active" or not.
 */ const $45c7c5cc0b99fadb$export$b0d92dbee9b5b60d = /*#__PURE__*/ $dAx5m.forwardRef(function NavLinkWithRef(_ref8, ref) {
    let { "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, viewTransition: viewTransition, children: children } = _ref8, rest = $45c7c5cc0b99fadb$var$_objectWithoutPropertiesLoose(_ref8, $45c7c5cc0b99fadb$var$_excluded2);
    let path = (0, $lairn.useResolvedPath)(to, {
        relative: rest.relative
    });
    let location = (0, $lairn.useLocation)();
    let routerState = $dAx5m.useContext((0, $lairn.UNSAFE_DataRouterStateContext));
    let { navigator: navigator, basename: basename } = $dAx5m.useContext((0, $lairn.UNSAFE_NavigationContext));
    let isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $45c7c5cc0b99fadb$export$e262bd1977bea848(path) && viewTransition === true;
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    if (nextLocationPathname && basename) nextLocationPathname = (0, $7IVBD.stripBasename)(nextLocationPathname, basename) || nextLocationPathname;
    // If the `to` has a trailing slash, look at that exact spot.  Otherwise,
    // we're looking for a slash _after_ what's in `to`.  For example:
    //
    // <NavLink to="/users"> and <NavLink to="/users/">
    // both want to look for a / at index 6 to match URL `/users/matt`
    const endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let renderProps = {
        isActive: isActive,
        isPending: isPending,
        isTransitioning: isTransitioning
    };
    let ariaCurrent = isActive ? ariaCurrentProp : undefined;
    let className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else // If the className prop is not a function, we use a default `active`
    // class for <NavLink />s that are active. In v5 `active` was the default
    // value for `activeClassName`, but we are removing that API and can still
    // use the old default behavior for a cleaner upgrade path and keep the
    // simple styling rules working as they currently do.
    className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /*#__PURE__*/ $dAx5m.createElement($45c7c5cc0b99fadb$export$a6c7ac8248d6e38a, $45c7c5cc0b99fadb$var$_extends({}, rest, {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        viewTransition: viewTransition
    }), typeof children === "function" ? children(renderProps) : children);
});
/**
 * A `@remix-run/router`-aware `<form>`. It behaves like a normal form except
 * that the interaction with the server is with `fetch` instead of new document
 * requests, allowing components to add nicer UX to the page as the form is
 * submitted and returns with data.
 */ const $45c7c5cc0b99fadb$export$a7fed597f4b8afd8 = /*#__PURE__*/ $dAx5m.forwardRef((_ref9, forwardedRef)=>{
    let { fetcherKey: fetcherKey, navigate: navigate, reloadDocument: reloadDocument, replace: replace, state: state, method: method = $45c7c5cc0b99fadb$var$defaultMethod, action: action, onSubmit: onSubmit, relative: relative, preventScrollReset: preventScrollReset, viewTransition: viewTransition } = _ref9, props = $45c7c5cc0b99fadb$var$_objectWithoutPropertiesLoose(_ref9, $45c7c5cc0b99fadb$var$_excluded3);
    let submit = $45c7c5cc0b99fadb$export$47c85c6e3a081d3();
    let formAction = $45c7c5cc0b99fadb$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = (submitter == null ? void 0 : submitter.getAttribute("formmethod")) || method;
        submit(submitter || event.currentTarget, {
            fetcherKey: fetcherKey,
            method: submitMethod,
            navigate: navigate,
            replace: replace,
            state: state,
            relative: relative,
            preventScrollReset: preventScrollReset,
            viewTransition: viewTransition
        });
    };
    return /*#__PURE__*/ $dAx5m.createElement("form", $45c7c5cc0b99fadb$var$_extends({
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler
    }, props));
});
/**
 * This component will emulate the browser's scroll restoration on location
 * changes.
 */ function $45c7c5cc0b99fadb$export$11aac1aab828f1fa(_ref10) {
    let { getKey: getKey, storageKey: storageKey } = _ref10;
    $45c7c5cc0b99fadb$export$25057cfe5591e3e9({
        getKey: getKey,
        storageKey: storageKey
    });
    return null;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Hooks
////////////////////////////////////////////////////////////////////////////////
var $45c7c5cc0b99fadb$var$DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseScrollRestoration"] = "useScrollRestoration";
    DataRouterHook["UseSubmit"] = "useSubmit";
    DataRouterHook["UseSubmitFetcher"] = "useSubmitFetcher";
    DataRouterHook["UseFetcher"] = "useFetcher";
    DataRouterHook["useViewTransitionState"] = "useViewTransitionState";
})($45c7c5cc0b99fadb$var$DataRouterHook || ($45c7c5cc0b99fadb$var$DataRouterHook = {}));
var $45c7c5cc0b99fadb$var$DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseFetcher"] = "useFetcher";
    DataRouterStateHook["UseFetchers"] = "useFetchers";
    DataRouterStateHook["UseScrollRestoration"] = "useScrollRestoration";
})($45c7c5cc0b99fadb$var$DataRouterStateHook || ($45c7c5cc0b99fadb$var$DataRouterStateHook = {}));
// Internal hooks
function $45c7c5cc0b99fadb$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/v6/routers/picking-a-router.";
}
function $45c7c5cc0b99fadb$var$useDataRouterContext(hookName) {
    let ctx = $dAx5m.useContext((0, $lairn.UNSAFE_DataRouterContext));
    !ctx && (0, $7IVBD.UNSAFE_invariant)(false);
    return ctx;
}
function $45c7c5cc0b99fadb$var$useDataRouterState(hookName) {
    let state = $dAx5m.useContext((0, $lairn.UNSAFE_DataRouterStateContext));
    !state && (0, $7IVBD.UNSAFE_invariant)(false);
    return state;
}
// External hooks
/**
 * Handles the click behavior for router `<Link>` components. This is useful if
 * you need to create custom `<Link>` components with the same click behavior we
 * use in our exported `<Link>`.
 */ function $45c7c5cc0b99fadb$export$67621102c14d847(to, _temp) {
    let { target: target, replace: replaceProp, state: state, preventScrollReset: preventScrollReset, relative: relative, viewTransition: viewTransition } = _temp === void 0 ? {} : _temp;
    let navigate = (0, $lairn.useNavigate)();
    let location = (0, $lairn.useLocation)();
    let path = (0, $lairn.useResolvedPath)(to, {
        relative: relative
    });
    return $dAx5m.useCallback((event)=>{
        if ($45c7c5cc0b99fadb$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            // If the URL hasn't changed, a regular <a> will do a replace instead of
            // a push, so do the same here unless the replace prop is explicitly set
            let replace = replaceProp !== undefined ? replaceProp : (0, $7IVBD.createPath)(location) === (0, $7IVBD.createPath)(path);
            navigate(to, {
                replace: replace,
                state: state,
                preventScrollReset: preventScrollReset,
                relative: relative,
                viewTransition: viewTransition
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        viewTransition
    ]);
}
/**
 * A convenient wrapper for reading and writing search parameters via the
 * URLSearchParams interface.
 */ function $45c7c5cc0b99fadb$export$f1a78c17382fe22a(defaultInit) {
    let defaultSearchParamsRef = $dAx5m.useRef($45c7c5cc0b99fadb$export$a2e4e2dcc7b1f22f(defaultInit));
    let hasSetSearchParamsRef = $dAx5m.useRef(false);
    let location = (0, $lairn.useLocation)();
    let searchParams = $dAx5m.useMemo(()=>// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $45c7c5cc0b99fadb$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = (0, $lairn.useNavigate)();
    let setSearchParams = $dAx5m.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = $45c7c5cc0b99fadb$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
function $45c7c5cc0b99fadb$var$validateClientSideSubmission() {
    if (typeof document === "undefined") throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
}
let $45c7c5cc0b99fadb$var$fetcherId = 0;
let $45c7c5cc0b99fadb$var$getUniqueFetcherId = ()=>"__" + String(++$45c7c5cc0b99fadb$var$fetcherId) + "__";
/**
 * Returns a function that may be used to programmatically submit a form (or
 * some arbitrary data) to the server.
 */ function $45c7c5cc0b99fadb$export$47c85c6e3a081d3() {
    let { router: router } = $45c7c5cc0b99fadb$var$useDataRouterContext($45c7c5cc0b99fadb$var$DataRouterHook.UseSubmit);
    let { basename: basename } = $dAx5m.useContext((0, $lairn.UNSAFE_NavigationContext));
    let currentRouteId = (0, $lairn.UNSAFE_useRouteId)();
    return $dAx5m.useCallback(function(target, options) {
        if (options === void 0) options = {};
        $45c7c5cc0b99fadb$var$validateClientSideSubmission();
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $45c7c5cc0b99fadb$var$getFormSubmissionInfo(target, basename);
        if (options.navigate === false) {
            let key = options.fetcherKey || $45c7c5cc0b99fadb$var$getUniqueFetcherId();
            router.fetch(key, currentRouteId, options.action || action, {
                preventScrollReset: options.preventScrollReset,
                formData: formData,
                body: body,
                formMethod: options.method || method,
                formEncType: options.encType || encType,
                flushSync: options.flushSync
            });
        } else router.navigate(options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            flushSync: options.flushSync,
            viewTransition: options.viewTransition
        });
    }, [
        router,
        basename,
        currentRouteId
    ]);
}
// v7: Eventually we should deprecate this entirely in favor of using the
// router method directly?
function $45c7c5cc0b99fadb$export$89a6bd6db0d97c56(action, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { basename: basename } = $dAx5m.useContext((0, $lairn.UNSAFE_NavigationContext));
    let routeContext = $dAx5m.useContext((0, $lairn.UNSAFE_RouteContext));
    !routeContext && (0, $7IVBD.UNSAFE_invariant)(false);
    let [match] = routeContext.matches.slice(-1);
    // Shallow clone path so we can modify it below, otherwise we modify the
    // object referenced by useMemo inside useResolvedPath
    let path = $45c7c5cc0b99fadb$var$_extends({}, (0, $lairn.useResolvedPath)(action ? action : ".", {
        relative: relative
    }));
    // If no action was specified, browsers will persist current search params
    // when determining the path, so match that behavior
    // https://github.com/remix-run/remix/issues/927
    let location = (0, $lairn.useLocation)();
    if (action == null) {
        // Safe to write to this directly here since if action was undefined, we
        // would have called useResolvedPath(".") which will never include a search
        path.search = location.search;
        // When grabbing search params from the URL, remove any included ?index param
        // since it might not apply to our contextual route.  We add it back based
        // on match.route.index below
        let params = new URLSearchParams(path.search);
        let indexValues = params.getAll("index");
        let hasNakedIndexParam = indexValues.some((v)=>v === "");
        if (hasNakedIndexParam) {
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? "?" + qs : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the form action.  If this is a root navigation, then just use
    // the raw basename which allows the basename to have full control over the
    // presence of a trailing slash on root actions
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $7IVBD.joinPaths)([
        basename,
        path.pathname
    ]);
    return (0, $7IVBD.createPath)(path);
}
// TODO: (v7) Change the useFetcher generic default from `any` to `unknown`
/**
 * Interacts with route loaders and actions without causing a navigation. Great
 * for any interaction that stays on the same page.
 */ function $45c7c5cc0b99fadb$export$5b0d2d9a9921565a(_temp3) {
    var _route$matches;
    let { key: key } = _temp3 === void 0 ? {} : _temp3;
    let { router: router } = $45c7c5cc0b99fadb$var$useDataRouterContext($45c7c5cc0b99fadb$var$DataRouterHook.UseFetcher);
    let state = $45c7c5cc0b99fadb$var$useDataRouterState($45c7c5cc0b99fadb$var$DataRouterStateHook.UseFetcher);
    let fetcherData = $dAx5m.useContext($45c7c5cc0b99fadb$export$148fd98d095596d4);
    let route = $dAx5m.useContext((0, $lairn.UNSAFE_RouteContext));
    let routeId = (_route$matches = route.matches[route.matches.length - 1]) == null ? void 0 : _route$matches.route.id;
    !fetcherData && (0, $7IVBD.UNSAFE_invariant)(false);
    !route && (0, $7IVBD.UNSAFE_invariant)(false);
    !(routeId != null) && (0, $7IVBD.UNSAFE_invariant)(false);
    // Fetcher key handling
    // OK to call conditionally to feature detect `useId`
    // eslint-disable-next-line react-hooks/rules-of-hooks
    let defaultKey = $45c7c5cc0b99fadb$var$useIdImpl ? $45c7c5cc0b99fadb$var$useIdImpl() : "";
    let [fetcherKey, setFetcherKey] = $dAx5m.useState(key || defaultKey);
    if (key && key !== fetcherKey) setFetcherKey(key);
    else if (!fetcherKey) // We will only fall through here when `useId` is not available
    setFetcherKey($45c7c5cc0b99fadb$var$getUniqueFetcherId());
    // Registration/cleanup
    $dAx5m.useEffect(()=>{
        router.getFetcher(fetcherKey);
        return ()=>{
            // Tell the router we've unmounted - if v7_fetcherPersist is enabled this
            // will not delete immediately but instead queue up a delete after the
            // fetcher returns to an `idle` state
            router.deleteFetcher(fetcherKey);
        };
    }, [
        router,
        fetcherKey
    ]);
    // Fetcher additions
    let load = $dAx5m.useCallback((href, opts)=>{
        !routeId && (0, $7IVBD.UNSAFE_invariant)(false);
        router.fetch(fetcherKey, routeId, href, opts);
    }, [
        fetcherKey,
        routeId,
        router
    ]);
    let submitImpl = $45c7c5cc0b99fadb$export$47c85c6e3a081d3();
    let submit = $dAx5m.useCallback((target, opts)=>{
        submitImpl(target, $45c7c5cc0b99fadb$var$_extends({}, opts, {
            navigate: false,
            fetcherKey: fetcherKey
        }));
    }, [
        fetcherKey,
        submitImpl
    ]);
    let FetcherForm = $dAx5m.useMemo(()=>{
        let FetcherForm = /*#__PURE__*/ $dAx5m.forwardRef((props, ref)=>{
            return /*#__PURE__*/ $dAx5m.createElement($45c7c5cc0b99fadb$export$a7fed597f4b8afd8, $45c7c5cc0b99fadb$var$_extends({}, props, {
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            }));
        });
        return FetcherForm;
    }, [
        fetcherKey
    ]);
    // Exposed FetcherWithComponents
    let fetcher = state.fetchers.get(fetcherKey) || (0, $7IVBD.IDLE_FETCHER);
    let data = fetcherData.get(fetcherKey);
    let fetcherWithComponents = $dAx5m.useMemo(()=>$45c7c5cc0b99fadb$var$_extends({
            Form: FetcherForm,
            submit: submit,
            load: load
        }, fetcher, {
            data: data
        }), [
        FetcherForm,
        submit,
        load,
        fetcher,
        data
    ]);
    return fetcherWithComponents;
}
/**
 * Provides all fetchers currently on the page. Useful for layouts and parent
 * routes that need to provide pending/optimistic UI regarding the fetch.
 */ function $45c7c5cc0b99fadb$export$fa996778a3a31087() {
    let state = $45c7c5cc0b99fadb$var$useDataRouterState($45c7c5cc0b99fadb$var$DataRouterStateHook.UseFetchers);
    return Array.from(state.fetchers.entries()).map((_ref11)=>{
        let [key, fetcher] = _ref11;
        return $45c7c5cc0b99fadb$var$_extends({}, fetcher, {
            key: key
        });
    });
}
const $45c7c5cc0b99fadb$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
let $45c7c5cc0b99fadb$var$savedScrollPositions = {};
/**
 * When rendered inside a RouterProvider, will restore scroll positions on navigations
 */ function $45c7c5cc0b99fadb$export$25057cfe5591e3e9(_temp4) {
    let { getKey: getKey, storageKey: storageKey } = _temp4 === void 0 ? {} : _temp4;
    let { router: router } = $45c7c5cc0b99fadb$var$useDataRouterContext($45c7c5cc0b99fadb$var$DataRouterHook.UseScrollRestoration);
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = $45c7c5cc0b99fadb$var$useDataRouterState($45c7c5cc0b99fadb$var$DataRouterStateHook.UseScrollRestoration);
    let { basename: basename } = $dAx5m.useContext((0, $lairn.UNSAFE_NavigationContext));
    let location = (0, $lairn.useLocation)();
    let matches = (0, $lairn.useMatches)();
    let navigation = (0, $lairn.useNavigation)();
    // Trigger manual scroll restoration while we're active
    $dAx5m.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    // Save positions on pagehide
    $45c7c5cc0b99fadb$var$usePageHide($dAx5m.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = (getKey ? getKey(location, matches) : null) || location.key;
            $45c7c5cc0b99fadb$var$savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || $45c7c5cc0b99fadb$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($45c7c5cc0b99fadb$var$savedScrollPositions));
        } catch (error) {}
        window.history.scrollRestoration = "auto";
    }, [
        storageKey,
        getKey,
        navigation.state,
        location,
        matches
    ]));
    // Read in any saved scroll locations
    if (typeof document !== "undefined") {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $dAx5m.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $45c7c5cc0b99fadb$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $45c7c5cc0b99fadb$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {
            // no-op, use default empty object
            }
        }, [
            storageKey
        ]);
        // Enable scroll restoration in the router
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $dAx5m.useLayoutEffect(()=>{
            let getKeyWithoutBasename = getKey && basename !== "/" ? (location, matches)=>getKey($45c7c5cc0b99fadb$var$_extends({}, location, {
                    pathname: (0, $7IVBD.stripBasename)(location.pathname, basename) || location.pathname
                }), matches) : getKey;
            let disableScrollRestoration = router == null ? void 0 : router.enableScrollRestoration($45c7c5cc0b99fadb$var$savedScrollPositions, ()=>window.scrollY, getKeyWithoutBasename);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        // Restore scrolling when state.restoreScrollPosition changes
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $dAx5m.useLayoutEffect(()=>{
            // Explicit false means don't do anything (used for submissions)
            if (restoreScrollPosition === false) return;
            // been here before, scroll to it
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            // try to scroll to the hash
            if (location.hash) {
                let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                if (el) {
                    el.scrollIntoView();
                    return;
                }
            }
            // Don't reset if this navigation opted out
            if (preventScrollReset === true) return;
            // otherwise go to the top on new locations
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
/**
 * Setup a callback to be fired on the window's `beforeunload` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $45c7c5cc0b99fadb$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $dAx5m.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Setup a callback to be fired on the window's `pagehide` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.  This event is better supported than beforeunload across browsers.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $45c7c5cc0b99fadb$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $dAx5m.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Wrapper around useBlocker to show a window.confirm prompt to users instead
 * of building a custom UI with useBlocker.
 *
 * Warning: This has *a lot of rough edges* and behaves very differently (and
 * very incorrectly in some cases) across browsers if user click addition
 * back/forward navigations while the confirm is open.  Use at your own risk.
 */ function $45c7c5cc0b99fadb$export$39f4eb3dbd812741(_ref12) {
    let { when: when, message: message } = _ref12;
    let blocker = (0, $lairn.useBlocker)(when);
    $dAx5m.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) // This timeout is needed to avoid a weird "race" on POP navigations
            // between the `window.history` revert navigation and the result of
            // `window.confirm`
            setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $dAx5m.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
/**
 * Return a boolean indicating if there is an active view transition to the
 * given href.  You can use this value to render CSS classes or viewTransitionName
 * styles onto your elements
 *
 * @param href The destination href
 * @param [opts.relative] Relative routing type ("route" | "path")
 */ function $45c7c5cc0b99fadb$export$e262bd1977bea848(to, opts) {
    if (opts === void 0) opts = {};
    let vtContext = $dAx5m.useContext($45c7c5cc0b99fadb$export$7ad602f0e94e62d1);
    !(vtContext != null) && (0, $7IVBD.UNSAFE_invariant)(false);
    let { basename: basename } = $45c7c5cc0b99fadb$var$useDataRouterContext($45c7c5cc0b99fadb$var$DataRouterHook.useViewTransitionState);
    let path = (0, $lairn.useResolvedPath)(to, {
        relative: opts.relative
    });
    if (!vtContext.isTransitioning) return false;
    let currentPath = (0, $7IVBD.stripBasename)(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    let nextPath = (0, $7IVBD.stripBasename)(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    // Transition is active if we're going to or coming from the indicated
    // destination.  This ensures that other PUSH navigations that reverse
    // an indicated transition apply.  I.e., on the list view you have:
    //
    //   <NavLink to="/details/1" viewTransition>
    //
    // If you click the breadcrumb back to the list view:
    //
    //   <NavLink to="/list" viewTransition>
    //
    // We should apply the transition because it's indicated as active going
    // from /list -> /details/1 and therefore should be active on the reverse
    // (even though this isn't strictly a POP reverse)
    return (0, $7IVBD.matchPath)(path.pathname, nextPath) != null || (0, $7IVBD.matchPath)(path.pathname, currentPath) != null;
}

});
parcelRegister("7IVBD", function(module, exports) {

$parcel$export(module.exports, "Action", function () { return $59f953d2a895fdbb$export$e19cd5f9376f8cee; });
$parcel$export(module.exports, "createMemoryHistory", function () { return $59f953d2a895fdbb$export$2b76ad033c6e6d08; });
$parcel$export(module.exports, "createPath", function () { return $59f953d2a895fdbb$export$fe53371bee54353d; });
$parcel$export(module.exports, "parsePath", function () { return $59f953d2a895fdbb$export$8ccf933b0513f8d0; });
$parcel$export(module.exports, "createBrowserHistory", function () { return $59f953d2a895fdbb$export$719fc203c4e16dee; });
$parcel$export(module.exports, "createHashHistory", function () { return $59f953d2a895fdbb$export$b71fdd3798280242; });
$parcel$export(module.exports, "UNSAFE_invariant", function () { return $59f953d2a895fdbb$export$3e9cee6b33872309; });
$parcel$export(module.exports, "matchRoutes", function () { return $59f953d2a895fdbb$export$2708184779ceb39d; });
$parcel$export(module.exports, "stripBasename", function () { return $59f953d2a895fdbb$export$b69e3301ce081aa3; });
$parcel$export(module.exports, "UNSAFE_decodePath", function () { return $59f953d2a895fdbb$export$30d21fd6d7295f52; });
$parcel$export(module.exports, "UNSAFE_convertRouteMatchToUiMatch", function () { return $59f953d2a895fdbb$export$b3fac024fad9e8ff; });
$parcel$export(module.exports, "joinPaths", function () { return $59f953d2a895fdbb$export$86d9a7913e44197e; });
$parcel$export(module.exports, "matchPath", function () { return $59f953d2a895fdbb$export$81336c211d5ff295; });
$parcel$export(module.exports, "UNSAFE_getResolveToMatches", function () { return $59f953d2a895fdbb$export$a5784978eca585fa; });
$parcel$export(module.exports, "resolveTo", function () { return $59f953d2a895fdbb$export$cae722b0cc860f13; });
$parcel$export(module.exports, "AbortedDeferredError", function () { return $59f953d2a895fdbb$export$42a99a7a4bc0e76a; });
$parcel$export(module.exports, "UNSAFE_ErrorResponseImpl", function () { return $59f953d2a895fdbb$export$6c6580e81da25755; });
$parcel$export(module.exports, "isRouteErrorResponse", function () { return $59f953d2a895fdbb$export$972111febbeef05b; });
$parcel$export(module.exports, "IDLE_FETCHER", function () { return $59f953d2a895fdbb$export$52eace9c284d3585; });
$parcel$export(module.exports, "IDLE_BLOCKER", function () { return $59f953d2a895fdbb$export$386d57f03f0b2883; });
$parcel$export(module.exports, "createRouter", function () { return $59f953d2a895fdbb$export$baddd0131ee8c05b; });
/**
 * @remix-run/router v1.21.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ function $59f953d2a895fdbb$var$_extends() {
    $59f953d2a895fdbb$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $59f953d2a895fdbb$var$_extends.apply(this, arguments);
}
////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */ var $59f953d2a895fdbb$export$e19cd5f9376f8cee;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})($59f953d2a895fdbb$export$e19cd5f9376f8cee || ($59f953d2a895fdbb$export$e19cd5f9376f8cee = {}));
const $59f953d2a895fdbb$var$PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */ function $59f953d2a895fdbb$export$2b76ad033c6e6d08(options) {
    if (options === void 0) options = {};
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries; // Declare so we can access from createMemoryLocation
    entries = initialEntries.map((entry, index)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : undefined));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = $59f953d2a895fdbb$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state, key) {
        if (state === void 0) state = null;
        let location = $59f953d2a895fdbb$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        $59f953d2a895fdbb$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : $59f953d2a895fdbb$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref,
        createURL (to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $59f953d2a895fdbb$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = $59f953d2a895fdbb$export$e19cd5f9376f8cee.Push;
            let nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = $59f953d2a895fdbb$export$e19cd5f9376f8cee.Replace;
            let nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = $59f953d2a895fdbb$export$e19cd5f9376f8cee.Pop;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function $59f953d2a895fdbb$export$719fc203c4e16dee(options) {
    if (options === void 0) options = {};
    function createBrowserLocation(window1, globalHistory) {
        let { pathname: pathname, search: search, hash: hash } = window1.location;
        return $59f953d2a895fdbb$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window1, to) {
        return typeof to === "string" ? to : $59f953d2a895fdbb$export$fe53371bee54353d(to);
    }
    return $59f953d2a895fdbb$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function $59f953d2a895fdbb$export$b71fdd3798280242(options) {
    if (options === void 0) options = {};
    function createHashLocation(window1, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $59f953d2a895fdbb$export$8ccf933b0513f8d0(window1.location.hash.substr(1));
        // Hash URL should always have a leading / just like window.location.pathname
        // does, so if an app ends up at a route like /#something then we add a
        // leading slash so all of our path-matching behaves the same as if it would
        // in a browser router.  This is particularly important when there exists a
        // root splat route (<Route path="*">) since that matches internally against
        // "/*" and we'd expect /#something to 404 in a hash router app.
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $59f953d2a895fdbb$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window1, to) {
        let base = window1.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window1.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $59f953d2a895fdbb$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $59f953d2a895fdbb$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
    }
    return $59f953d2a895fdbb$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $59f953d2a895fdbb$export$3e9cee6b33872309(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $59f953d2a895fdbb$export$c0e02632e14916fd(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience, so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message);
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
function $59f953d2a895fdbb$var$createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */ function $59f953d2a895fdbb$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
/**
 * Creates a Location object with a unique key from the given Path
 */ function $59f953d2a895fdbb$var$createLocation(current, to, state, key) {
    if (state === void 0) state = null;
    let location = $59f953d2a895fdbb$var$_extends({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? $59f953d2a895fdbb$export$8ccf933b0513f8d0(to) : to, {
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $59f953d2a895fdbb$var$createKey()
    });
    return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */ function $59f953d2a895fdbb$export$fe53371bee54353d(_ref) {
    let { pathname: pathname = "/", search: search = "", hash: hash = "" } = _ref;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */ function $59f953d2a895fdbb$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $59f953d2a895fdbb$var$getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
    if (options === void 0) options = {};
    let { window: window1 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window1.history;
    let action = $59f953d2a895fdbb$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    let index = getIndex();
    // Index should only be null when we initialize. If not, it's because the
    // user called history.pushState or history.replaceState directly, in which
    // case we should log a warning as it will result in bugs.
    if (index == null) {
        index = 0;
        globalHistory.replaceState($59f953d2a895fdbb$var$_extends({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = $59f953d2a895fdbb$export$e19cd5f9376f8cee.Pop;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = $59f953d2a895fdbb$export$e19cd5f9376f8cee.Push;
        let location = $59f953d2a895fdbb$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $59f953d2a895fdbb$var$getHistoryState(location, index);
        let url = history.createHref(location);
        // try...catch because iOS limits us to 100 pushState calls :/
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            // If the exception is because `state` can't be serialized, let that throw
            // outwards just like a replace call would so the dev knows the cause
            // https://html.spec.whatwg.org/multipage/nav-history-apis.html#shared-history-push/replace-state-steps
            // https://html.spec.whatwg.org/multipage/structured-data.html#structuredserializeinternal
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            // They are going to lose state here, but there is no real
            // way to warn them about it since the page will refresh...
            window1.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = $59f953d2a895fdbb$export$e19cd5f9376f8cee.Replace;
        let location = $59f953d2a895fdbb$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $59f953d2a895fdbb$var$getHistoryState(location, index);
        let url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        // window.location.origin is "null" (the literal string value) in Firefox
        // under certain conditions, notably when serving from a local HTML file
        // See https://bugzilla.mozilla.org/show_bug.cgi?id=878297
        let base = window1.location.origin !== "null" ? window1.location.origin : window1.location.href;
        let href = typeof to === "string" ? to : $59f953d2a895fdbb$export$fe53371bee54353d(to);
        // Treating this as a full URL will strip any trailing spaces so we need to
        // pre-encode them since they might be part of a matching splat param from
        // an ancestor route
        href = href.replace(/ $/, "%20");
        $59f953d2a895fdbb$export$3e9cee6b33872309(base, "No window.location.(origin|href) available to create URL for href: " + href);
        return new URL(href, base);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window1, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window1.addEventListener($59f953d2a895fdbb$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window1.removeEventListener($59f953d2a895fdbb$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref(window1, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            // Encode a Location the same way window.location would
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
//#endregion
var $59f953d2a895fdbb$var$ResultType;
(function(ResultType) {
    ResultType["data"] = "data";
    ResultType["deferred"] = "deferred";
    ResultType["redirect"] = "redirect";
    ResultType["error"] = "error";
})($59f953d2a895fdbb$var$ResultType || ($59f953d2a895fdbb$var$ResultType = {}));
const $59f953d2a895fdbb$var$immutableRouteKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $59f953d2a895fdbb$var$isIndexRoute(route) {
    return route.index === true;
}
// Walk the route tree generating unique IDs where necessary, so we are working
// solely with AgnosticDataRouteObject's within the Router
function $59f953d2a895fdbb$export$4a6d22b32134ea5d(routes, mapRouteProperties, parentPath, manifest) {
    if (parentPath === void 0) parentPath = [];
    if (manifest === void 0) manifest = {};
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            String(index)
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $59f953d2a895fdbb$export$3e9cee6b33872309(route.index !== true || !route.children, "Cannot specify children on an index route");
        $59f953d2a895fdbb$export$3e9cee6b33872309(!manifest[id], 'Found a route id collision on id "' + id + '".  Route ' + "id's must be globally unique within Data Router usages");
        if ($59f953d2a895fdbb$var$isIndexRoute(route)) {
            let indexRoute = $59f953d2a895fdbb$var$_extends({}, route, mapRouteProperties(route), {
                id: id
            });
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            let pathOrLayoutRoute = $59f953d2a895fdbb$var$_extends({}, route, mapRouteProperties(route), {
                id: id,
                children: undefined
            });
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = $59f953d2a895fdbb$export$4a6d22b32134ea5d(route.children, mapRouteProperties, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/v6/utils/match-routes
 */ function $59f953d2a895fdbb$export$2708184779ceb39d(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    return $59f953d2a895fdbb$var$matchRoutesImpl(routes, locationArg, basename, false);
}
function $59f953d2a895fdbb$var$matchRoutesImpl(routes, locationArg, basename, allowPartial) {
    let location = typeof locationArg === "string" ? $59f953d2a895fdbb$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $59f953d2a895fdbb$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = $59f953d2a895fdbb$var$flattenRoutes(routes);
    $59f953d2a895fdbb$var$rankRouteBranches(branches);
    let matches = null;
    for(let i = 0; matches == null && i < branches.length; ++i){
        // Incoming pathnames are generally encoded from either window.location
        // or from router.navigate, but we want to match against the unencoded
        // paths in the route definitions.  Memory router locations won't be
        // encoded here but there also shouldn't be anything to decode so this
        // should be a safe operation.  This avoids needing matchRoutes to be
        // history-aware.
        let decoded = $59f953d2a895fdbb$export$30d21fd6d7295f52(pathname);
        matches = $59f953d2a895fdbb$var$matchRouteBranch(branches[i], decoded, allowPartial);
    }
    return matches;
}
function $59f953d2a895fdbb$export$b3fac024fad9e8ff(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function $59f953d2a895fdbb$var$flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    let flattenRoute = (route, index, relativePath)=>{
        let meta = {
            relativePath: relativePath === undefined ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            $59f953d2a895fdbb$export$3e9cee6b33872309(meta.relativePath.startsWith(parentPath), 'Absolute route path "' + meta.relativePath + '" nested under path ' + ('"' + parentPath + '" is not valid. An absolute child route path ') + "must start with the combined path of all its parent routes.");
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $59f953d2a895fdbb$export$86d9a7913e44197e([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        // Add the children before adding this route to the array, so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            $59f953d2a895fdbb$export$3e9cee6b33872309(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, "Index routes must not have child routes. Please remove " + ('all child routes from route path "' + path + '".'));
            $59f953d2a895fdbb$var$flattenRoutes(route.children, branches, routesMeta, path);
        }
        // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $59f953d2a895fdbb$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach((route, index)=>{
        var _route$path;
        // coarse-grain check for optional params
        if (route.path === "" || !((_route$path = route.path) != null && _route$path.includes("?"))) flattenRoute(route, index);
        else for (let exploded of $59f953d2a895fdbb$var$explodeOptionalSegments(route.path))flattenRoute(route, index, exploded);
    });
    return branches;
}
/**
 * Computes all combinations of optional path segments for a given path,
 * excluding combinations that are ambiguous and of lower priority.
 *
 * For example, `/one/:two?/three/:four?/:five?` explodes to:
 * - `/one/three`
 * - `/one/:two/three`
 * - `/one/three/:four`
 * - `/one/three/:five`
 * - `/one/:two/three/:four`
 * - `/one/:two/three/:five`
 * - `/one/three/:four/:five`
 * - `/one/:two/three/:four/:five`
 */ function $59f953d2a895fdbb$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    // Optional path segments are denoted by a trailing `?`
    let isOptional = first.endsWith("?");
    // Compute the corresponding required segment: `foo?` -> `foo`
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) // Intepret empty string as omitting an optional segment
    // `["one", "", "three"]` corresponds to omitting `:two` from `/one/:two?/three` -> `/one/three`
    return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $59f953d2a895fdbb$var$explodeOptionalSegments(rest.join("/"));
    let result = [];
    // All child paths with the prefix.  Do this for all children before the
    // optional version for all children, so we get consistent ordering where the
    // parent optional aspect is preferred as required.  Otherwise, we can get
    // child sections interspersed where deeper optional segments are higher than
    // parent optional segments, where for example, /:two would explode _earlier_
    // then /:one.  By always including the parent as required _for all children_
    // first, we avoid this issue
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    // Then, if this is an optional value, add all child versions without
    if (isOptional) result.push(...restExploded);
    // for absolute paths, ensure `/` instead of empty segment
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $59f953d2a895fdbb$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score // Higher score first
         : $59f953d2a895fdbb$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
const $59f953d2a895fdbb$var$paramRe = /^:[\w-]+$/;
const $59f953d2a895fdbb$var$dynamicSegmentValue = 3;
const $59f953d2a895fdbb$var$indexRouteValue = 2;
const $59f953d2a895fdbb$var$emptySegmentValue = 1;
const $59f953d2a895fdbb$var$staticSegmentValue = 10;
const $59f953d2a895fdbb$var$splatPenalty = -2;
const $59f953d2a895fdbb$var$isSplat = (s)=>s === "*";
function $59f953d2a895fdbb$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($59f953d2a895fdbb$var$isSplat)) initialScore += $59f953d2a895fdbb$var$splatPenalty;
    if (index) initialScore += $59f953d2a895fdbb$var$indexRouteValue;
    return segments.filter((s)=>!$59f953d2a895fdbb$var$isSplat(s)).reduce((score, segment)=>score + ($59f953d2a895fdbb$var$paramRe.test(segment) ? $59f953d2a895fdbb$var$dynamicSegmentValue : segment === "" ? $59f953d2a895fdbb$var$emptySegmentValue : $59f953d2a895fdbb$var$staticSegmentValue), initialScore);
}
function $59f953d2a895fdbb$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $59f953d2a895fdbb$var$matchRouteBranch(branch, pathname, allowPartial) {
    if (allowPartial === void 0) allowPartial = false;
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = $59f953d2a895fdbb$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        let route = meta.route;
        if (!match && end && allowPartial && !routesMeta[routesMeta.length - 1].route.index) match = $59f953d2a895fdbb$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: false
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $59f953d2a895fdbb$export$86d9a7913e44197e([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $59f953d2a895fdbb$export$a5c6d149b50c1d86($59f953d2a895fdbb$export$86d9a7913e44197e([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $59f953d2a895fdbb$export$86d9a7913e44197e([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/v6/utils/generate-path
 */ function $59f953d2a895fdbb$export$82476f982757e71e(originalPath, params) {
    if (params === void 0) params = {};
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $59f953d2a895fdbb$export$c0e02632e14916fd(false, 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
        path = path.replace(/\*$/, "/*");
    }
    // ensure `/` is added at the beginning if the path is absolute
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        // only apply the splat if it's the last segment
        if (isLastSegment && segment === "*") {
            const star = "*";
            // Apply the splat
            return stringify(params[star]);
        }
        const keyMatch = segment.match(/^:([\w-]+)(\??)$/);
        if (keyMatch) {
            const [, key, optional] = keyMatch;
            let param = params[key];
            $59f953d2a895fdbb$export$3e9cee6b33872309(optional === "?" || param != null, 'Missing ":' + key + '" param');
            return stringify(param);
        }
        // Remove any optional markers from optional static segments
        return segment.replace(/\?$/g, "");
    })// Remove empty segments
    .filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/v6/utils/match-path
 */ function $59f953d2a895fdbb$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, compiledParams] = $59f953d2a895fdbb$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = compiledParams.reduce((memo, _ref, index)=>{
        let { paramName: paramName, isOptional: isOptional } = _ref;
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        const value = captureGroups[index];
        if (isOptional && !value) memo[paramName] = undefined;
        else memo[paramName] = (value || "").replace(/%2F/g, "/");
        return memo;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $59f953d2a895fdbb$var$compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    $59f953d2a895fdbb$export$c0e02632e14916fd(path === "*" || !path.endsWith("*") || path.endsWith("/*"), 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
    let params = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^${}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/\/:([\w-]+)(\?)?/g, (_, paramName, isOptional)=>{
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        return isOptional ? "/?([^\\/]+)?" : "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else if (end) // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex, so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        params
    ];
}
function $59f953d2a895fdbb$export$30d21fd6d7295f52(value) {
    try {
        return value.split("/").map((v)=>decodeURIComponent(v).replace(/\//g, "%2F")).join("/");
    } catch (error) {
        $59f953d2a895fdbb$export$c0e02632e14916fd(false, 'The URL path "' + value + '" could not be decoded because it is is a ' + "malformed URL segment. This is probably due to a bad percent " + ("encoding (" + error + ")."));
        return value;
    }
}
/**
 * @private
 */ function $59f953d2a895fdbb$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(startIndex) || "/";
}
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/v6/utils/resolve-path
 */ function $59f953d2a895fdbb$export$b09f2ff0bbcb43c7(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $59f953d2a895fdbb$export$8ccf933b0513f8d0(to) : to;
    let pathname = toPathname ? toPathname.startsWith("/") ? toPathname : $59f953d2a895fdbb$var$resolvePathname(toPathname, fromPathname) : fromPathname;
    return {
        pathname: pathname,
        search: $59f953d2a895fdbb$var$normalizeSearch(search),
        hash: $59f953d2a895fdbb$var$normalizeHash(hash)
    };
}
function $59f953d2a895fdbb$var$resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $59f953d2a895fdbb$var$getInvalidPathError(char, field, dest, path) {
    return "Cannot include a '" + char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + 'a string in <Link to="..."> and the router will parse it for you.';
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */ function $59f953d2a895fdbb$var$getPathContributingMatches(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
// Return the array of pathnames for the current route matches - used to
// generate the routePathnames input for resolveTo()
function $59f953d2a895fdbb$export$a5784978eca585fa(matches, v7_relativeSplatPath) {
    let pathMatches = $59f953d2a895fdbb$var$getPathContributingMatches(matches);
    // When v7_relativeSplatPath is enabled, use the full pathname for the leaf
    // match so we include splat values for "." links.  See:
    // https://github.com/remix-run/react-router/issues/11052#issuecomment-1836589329
    if (v7_relativeSplatPath) return pathMatches.map((match, idx)=>idx === pathMatches.length - 1 ? match.pathname : match.pathnameBase);
    return pathMatches.map((match)=>match.pathnameBase);
}
/**
 * @private
 */ function $59f953d2a895fdbb$export$cae722b0cc860f13(toArg, routePathnames, locationPathname, isPathRelative) {
    if (isPathRelative === void 0) isPathRelative = false;
    let to;
    if (typeof toArg === "string") to = $59f953d2a895fdbb$export$8ccf933b0513f8d0(toArg);
    else {
        to = $59f953d2a895fdbb$var$_extends({}, toArg);
        $59f953d2a895fdbb$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("?"), $59f953d2a895fdbb$var$getInvalidPathError("?", "pathname", "search", to));
        $59f953d2a895fdbb$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("#"), $59f953d2a895fdbb$var$getInvalidPathError("#", "pathname", "hash", to));
        $59f953d2a895fdbb$export$3e9cee6b33872309(!to.search || !to.search.includes("#"), $59f953d2a895fdbb$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    // Routing is relative to the current pathname if explicitly requested.
    //
    // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    if (toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        // With relative="route" (the default), each leading .. segment means
        // "go up one route" instead of "go up one URL segment".  This is a key
        // difference from how <a href> works and a major reason we call this a
        // "to" value instead of a "href".
        if (!isPathRelative && toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $59f953d2a895fdbb$export$b09f2ff0bbcb43c7(to, from);
    // Ensure the pathname has a trailing slash if the original "to" had one
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    // Or if this was a link to the current path which has a trailing slash
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
/**
 * @private
 */ function $59f953d2a895fdbb$export$f5655dfea9d981c7(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? $59f953d2a895fdbb$export$8ccf933b0513f8d0(to).pathname : to.pathname;
}
/**
 * @private
 */ const $59f953d2a895fdbb$export$86d9a7913e44197e = (paths)=>paths.join("/").replace(/\/\/+/g, "/");
/**
 * @private
 */ const $59f953d2a895fdbb$export$a5c6d149b50c1d86 = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
/**
 * @private
 */ const $59f953d2a895fdbb$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
/**
 * @private
 */ const $59f953d2a895fdbb$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 *
 * @deprecated The `json` method is deprecated in favor of returning raw objects.
 * This method will be removed in v7.
 */ const $59f953d2a895fdbb$export$7b419323e6ed4f31 = function json(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    let headers = new Headers(responseInit.headers);
    if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json; charset=utf-8");
    return new Response(JSON.stringify(data), $59f953d2a895fdbb$var$_extends({}, responseInit, {
        headers: headers
    }));
};
class $59f953d2a895fdbb$var$DataWithResponseInit {
    constructor(data, init){
        this.type = "DataWithResponseInit";
        this.data = data;
        this.init = init || null;
    }
}
/**
 * Create "responses" that contain `status`/`headers` without forcing
 * serialization into an actual `Response` - used by Remix single fetch
 */ function $59f953d2a895fdbb$export$4051a07651545597(data, init) {
    return new $59f953d2a895fdbb$var$DataWithResponseInit(data, typeof init === "number" ? {
        status: init
    } : init);
}
class $59f953d2a895fdbb$export$42a99a7a4bc0e76a extends Error {
}
class $59f953d2a895fdbb$export$61d759255b4eec65 {
    constructor(data, responseInit){
        this.pendingKeysSet = new Set();
        this.subscribers = new Set();
        this.deferredKeys = [];
        $59f953d2a895fdbb$export$3e9cee6b33872309(data && typeof data === "object" && !Array.isArray(data), "defer() only accepts plain objects");
        // Set up an AbortController + Promise we can race against to exit early
        // cancellation
        let reject;
        this.abortPromise = new Promise((_, r)=>reject = r);
        this.controller = new AbortController();
        let onAbort = ()=>reject(new $59f953d2a895fdbb$export$42a99a7a4bc0e76a("Deferred data aborted"));
        this.unlistenAbortSignal = ()=>this.controller.signal.removeEventListener("abort", onAbort);
        this.controller.signal.addEventListener("abort", onAbort);
        this.data = Object.entries(data).reduce((acc, _ref2)=>{
            let [key, value] = _ref2;
            return Object.assign(acc, {
                [key]: this.trackPromise(key, value)
            });
        }, {});
        if (this.done) // All incoming values were resolved
        this.unlistenAbortSignal();
        this.init = responseInit;
    }
    trackPromise(key, value) {
        if (!(value instanceof Promise)) return value;
        this.deferredKeys.push(key);
        this.pendingKeysSet.add(key);
        // We store a little wrapper promise that will be extended with
        // _data/_error props upon resolve/reject
        let promise = Promise.race([
            value,
            this.abortPromise
        ]).then((data)=>this.onSettle(promise, key, undefined, data), (error)=>this.onSettle(promise, key, error));
        // Register rejection listeners to avoid uncaught promise rejections on
        // errors or aborted deferred values
        promise.catch(()=>{});
        Object.defineProperty(promise, "_tracked", {
            get: ()=>true
        });
        return promise;
    }
    onSettle(promise, key, error, data) {
        if (this.controller.signal.aborted && error instanceof $59f953d2a895fdbb$export$42a99a7a4bc0e76a) {
            this.unlistenAbortSignal();
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            return Promise.reject(error);
        }
        this.pendingKeysSet.delete(key);
        if (this.done) // Nothing left to abort!
        this.unlistenAbortSignal();
        // If the promise was resolved/rejected with undefined, we'll throw an error as you
        // should always resolve with a value or null
        if (error === undefined && data === undefined) {
            let undefinedError = new Error('Deferred data for key "' + key + '" resolved/rejected with `undefined`, ' + "you must resolve/reject with a value or `null`.");
            Object.defineProperty(promise, "_error", {
                get: ()=>undefinedError
            });
            this.emit(false, key);
            return Promise.reject(undefinedError);
        }
        if (data === undefined) {
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            this.emit(false, key);
            return Promise.reject(error);
        }
        Object.defineProperty(promise, "_data", {
            get: ()=>data
        });
        this.emit(false, key);
        return data;
    }
    emit(aborted, settledKey) {
        this.subscribers.forEach((subscriber)=>subscriber(aborted, settledKey));
    }
    subscribe(fn) {
        this.subscribers.add(fn);
        return ()=>this.subscribers.delete(fn);
    }
    cancel() {
        this.controller.abort();
        this.pendingKeysSet.forEach((v, k)=>this.pendingKeysSet.delete(k));
        this.emit(true);
    }
    async resolveData(signal) {
        let aborted = false;
        if (!this.done) {
            let onAbort = ()=>this.cancel();
            signal.addEventListener("abort", onAbort);
            aborted = await new Promise((resolve)=>{
                this.subscribe((aborted)=>{
                    signal.removeEventListener("abort", onAbort);
                    if (aborted || this.done) resolve(aborted);
                });
            });
        }
        return aborted;
    }
    get done() {
        return this.pendingKeysSet.size === 0;
    }
    get unwrappedData() {
        $59f953d2a895fdbb$export$3e9cee6b33872309(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
        return Object.entries(this.data).reduce((acc, _ref3)=>{
            let [key, value] = _ref3;
            return Object.assign(acc, {
                [key]: $59f953d2a895fdbb$var$unwrapTrackedPromise(value)
            });
        }, {});
    }
    get pendingKeys() {
        return Array.from(this.pendingKeysSet);
    }
}
function $59f953d2a895fdbb$var$isTrackedPromise(value) {
    return value instanceof Promise && value._tracked === true;
}
function $59f953d2a895fdbb$var$unwrapTrackedPromise(value) {
    if (!$59f953d2a895fdbb$var$isTrackedPromise(value)) return value;
    if (value._error) throw value._error;
    return value._data;
}
/**
 * @deprecated The `defer` method is deprecated in favor of returning raw
 * objects. This method will be removed in v7.
 */ const $59f953d2a895fdbb$export$260e5c0943f31606 = function defer(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    return new $59f953d2a895fdbb$export$61d759255b4eec65(data, responseInit);
};
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $59f953d2a895fdbb$export$89e12c5b50f7529d = function redirect(url, init) {
    if (init === void 0) init = 302;
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, $59f953d2a895fdbb$var$_extends({}, responseInit, {
        headers: headers
    }));
};
/**
 * A redirect response that will force a document reload to the new location.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $59f953d2a895fdbb$export$a6cd19cd1951a23c = (url, init)=>{
    let response = $59f953d2a895fdbb$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
/**
 * A redirect response that will perform a `history.replaceState` instead of a
 * `history.pushState` for client-side navigation redirects.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $59f953d2a895fdbb$export$77ad94ebf1c2b9ed = (url, init)=>{
    let response = $59f953d2a895fdbb$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Replace", "true");
    return response;
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 *
 * We don't export the class for public use since it's an implementation
 * detail, but we export the interface above so folks can build their own
 * abstractions around instances via isRouteErrorResponse()
 */ class $59f953d2a895fdbb$export$6c6580e81da25755 {
    constructor(status, statusText, data, internal){
        if (internal === void 0) internal = false;
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data instanceof Error) {
            this.data = data.toString();
            this.error = data;
        } else this.data = data;
    }
}
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response thrown from an action/loader
 */ function $59f953d2a895fdbb$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
const $59f953d2a895fdbb$var$validMutationMethodsArr = [
    "post",
    "put",
    "patch",
    "delete"
];
const $59f953d2a895fdbb$var$validMutationMethods = new Set($59f953d2a895fdbb$var$validMutationMethodsArr);
const $59f953d2a895fdbb$var$validRequestMethodsArr = [
    "get",
    ...$59f953d2a895fdbb$var$validMutationMethodsArr
];
const $59f953d2a895fdbb$var$validRequestMethods = new Set($59f953d2a895fdbb$var$validRequestMethodsArr);
const $59f953d2a895fdbb$var$redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
const $59f953d2a895fdbb$var$redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
const $59f953d2a895fdbb$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $59f953d2a895fdbb$export$52eace9c284d3585 = {
    state: "idle",
    data: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $59f953d2a895fdbb$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: undefined,
    reset: undefined,
    location: undefined
};
const $59f953d2a895fdbb$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const $59f953d2a895fdbb$var$defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
const $59f953d2a895fdbb$var$TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a router and listen to history POP navigations
 */ function $59f953d2a895fdbb$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : undefined;
    const isBrowser = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    const isServer = !isBrowser;
    $59f953d2a895fdbb$export$3e9cee6b33872309(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let mapRouteProperties;
    if (init.mapRouteProperties) mapRouteProperties = init.mapRouteProperties;
    else if (init.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = init.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $59f953d2a895fdbb$var$defaultMapRouteProperties;
    // Routes keyed by ID
    let manifest = {};
    // Routes in tree format for matching
    let dataRoutes = $59f953d2a895fdbb$export$4a6d22b32134ea5d(init.routes, mapRouteProperties, undefined, manifest);
    let inFlightDataRoutes;
    let basename = init.basename || "/";
    let dataStrategyImpl = init.dataStrategy || $59f953d2a895fdbb$var$defaultDataStrategy;
    let patchRoutesOnNavigationImpl = init.patchRoutesOnNavigation;
    // Config driven behavior flags
    let future = $59f953d2a895fdbb$var$_extends({
        v7_fetcherPersist: false,
        v7_normalizeFormMethod: false,
        v7_partialHydration: false,
        v7_prependBasename: false,
        v7_relativeSplatPath: false,
        v7_skipActionErrorRevalidation: false
    }, init.future);
    // Cleanup function for history
    let unlistenHistory = null;
    // Externally-provided functions to call on all state changes
    let subscribers = new Set();
    // Externally-provided object to hold scroll restoration locations during routing
    let savedScrollPositions = null;
    // Externally-provided function to get scroll restoration keys
    let getScrollRestorationKey = null;
    // Externally-provided function to get current scroll position
    let getScrollPosition = null;
    // One-time flag to control the initial hydration scroll restoration.  Because
    // we don't get the saved positions from <ScrollRestoration /> until _after_
    // the initial render, we need to manually trigger a separate updateState to
    // send along the restoreScrollPosition
    // Set to true if we have `hydrationData` since we assume we were SSR'd and that
    // SSR did the initial scroll restoration.
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $59f953d2a895fdbb$export$2708184779ceb39d(dataRoutes, init.history.location, basename);
    let initialErrors = null;
    if (initialMatches == null && !patchRoutesOnNavigationImpl) {
        // If we do not match a user-provided-route, fall back to the root
        // to allow the error boundary to take over
        let error = $59f953d2a895fdbb$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $59f953d2a895fdbb$var$getShortCircuitMatches(dataRoutes);
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    }
    // In SPA apps, if the user provided a patchRoutesOnNavigation implementation and
    // our initial match is a splat route, clear them out so we run through lazy
    // discovery on hydration in case there's a more accurate lazy route match.
    // In SSR apps (with `hydrationData`), we expect that the server will send
    // up the proper matched routes so we don't want to run lazy discovery on
    // initial hydration and want to hydrate into the splat route.
    if (initialMatches && !init.hydrationData) {
        let fogOfWar = checkFogOfWar(initialMatches, dataRoutes, init.history.location.pathname);
        if (fogOfWar.active) initialMatches = null;
    }
    let initialized;
    if (!initialMatches) {
        initialized = false;
        initialMatches = [];
        // If partial hydration and fog of war is enabled, we will be running
        // `patchRoutesOnNavigation` during hydration so include any partial matches as
        // the initial matches so we can properly render `HydrateFallback`'s
        if (future.v7_partialHydration) {
            let fogOfWar = checkFogOfWar(null, dataRoutes, init.history.location.pathname);
            if (fogOfWar.active && fogOfWar.matches) initialMatches = fogOfWar.matches;
        }
    } else if (initialMatches.some((m)=>m.route.lazy)) // All initialMatches need to be loaded before we're ready.  If we have lazy
    // functions around still then we'll need to run them in initialize()
    initialized = false;
    else if (!initialMatches.some((m)=>m.route.loader)) // If we've got no loaders to run, then we're good to go
    initialized = true;
    else if (future.v7_partialHydration) {
        // If partial hydration is enabled, we're initialized so long as we were
        // provided with hydrationData for every route with a loader, and no loaders
        // were marked for explicit hydration
        let loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
        let errors = init.hydrationData ? init.hydrationData.errors : null;
        // If errors exist, don't consider routes below the boundary
        if (errors) {
            let idx = initialMatches.findIndex((m)=>errors[m.route.id] !== undefined);
            initialized = initialMatches.slice(0, idx + 1).every((m)=>!$59f953d2a895fdbb$var$shouldLoadRouteOnHydration(m.route, loaderData, errors));
        } else initialized = initialMatches.every((m)=>!$59f953d2a895fdbb$var$shouldLoadRouteOnHydration(m.route, loaderData, errors));
    } else // Without partial hydration - we're initialized if we were provided any
    // hydrationData - which is expected to be complete
    initialized = init.hydrationData != null;
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: $59f953d2a895fdbb$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: new Map(),
        blockers: new Map()
    };
    // -- Stateful internal variables to manage navigations --
    // Current navigation in progress (to be committed in completeNavigation)
    let pendingAction = $59f953d2a895fdbb$export$e19cd5f9376f8cee.Pop;
    // Should the current navigation prevent the scroll reset if scroll cannot
    // be restored?
    let pendingPreventScrollReset = false;
    // AbortController for the active navigation
    let pendingNavigationController;
    // Should the current navigation enable document.startViewTransition?
    let pendingViewTransitionEnabled = false;
    // Store applied view transitions so we can apply them on POP
    let appliedViewTransitions = new Map();
    // Cleanup function for persisting applied transitions to sessionStorage
    let removePageHideEventListener = null;
    // We use this to avoid touching history in completeNavigation if a
    // revalidation is entirely uninterrupted
    let isUninterruptedRevalidation = false;
    // Use this internal flag to force revalidation of all loaders:
    //  - submissions (completed or interrupted)
    //  - useRevalidator()
    //  - X-Remix-Revalidate (from redirect)
    let isRevalidationRequired = false;
    // Use this internal array to capture routes that require revalidation due
    // to a cancelled deferred on action submission
    let cancelledDeferredRoutes = [];
    // Use this internal array to capture fetcher loads that were cancelled by an
    // action navigation and require revalidation
    let cancelledFetcherLoads = new Set();
    // AbortControllers for any in-flight fetchers
    let fetchControllers = new Map();
    // Track loads based on the order in which they started
    let incrementingLoadId = 0;
    // Track the outstanding pending navigation data load to be compared against
    // the globally incrementing load when a fetcher load lands after a completed
    // navigation
    let pendingNavigationLoadId = -1;
    // Fetchers that triggered data reloads as a result of their actions
    let fetchReloadIds = new Map();
    // Fetchers that triggered redirect navigations
    let fetchRedirectIds = new Set();
    // Most recent href/match for fetcher.load calls for fetchers
    let fetchLoadMatches = new Map();
    // Ref-count mounted fetchers so we know when it's ok to clean them up
    let activeFetchers = new Map();
    // Fetchers that have requested a delete when using v7_fetcherPersist,
    // they'll be officially removed after they return to idle
    let deletedFetchers = new Set();
    // Store DeferredData instances for active route matches.  When a
    // route loader returns defer() we stick one in here.  Then, when a nested
    // promise resolves we update loaderData.  If a new navigation starts we
    // cancel active deferreds for eliminated routes.
    let activeDeferreds = new Map();
    // Store blocker functions in a separate Map outside of router state since
    // we don't need to update UI state if they change
    let blockerFunctions = new Map();
    // Flag to ignore the next history update, so we can revert the URL change on
    // a POP navigation that was blocked by the user without touching router state
    let unblockBlockerHistoryUpdate = undefined;
    // Initialize the router, all side effects should be kicked off from here.
    // Implemented as a Fluent API for ease of:
    //   let router = createRouter(init).initialize();
    function initialize() {
        // If history informs us of a POP navigation, start the navigation but do not update
        // state.  We'll update our own state once the navigation completes
        unlistenHistory = init.history.listen((_ref)=>{
            let { action: historyAction, location: location, delta: delta } = _ref;
            // Ignore this event if it was just us resetting the URL from a
            // blocked POP navigation
            if (unblockBlockerHistoryUpdate) {
                unblockBlockerHistoryUpdate();
                unblockBlockerHistoryUpdate = undefined;
                return;
            }
            $59f953d2a895fdbb$export$c0e02632e14916fd(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                // Restore the URL to match the current UI, but don't update router state
                let nextHistoryUpdatePromise = new Promise((resolve)=>{
                    unblockBlockerHistoryUpdate = resolve;
                });
                init.history.go(delta * -1);
                // Put the blocker into a blocked state
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: undefined,
                            reset: undefined,
                            location: location
                        });
                        // Re-do the same POP navigation we just blocked, after the url
                        // restoration is also complete.  See:
                        // https://github.com/remix-run/react-router/issues/11613
                        nextHistoryUpdatePromise.then(()=>init.history.go(delta));
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $59f953d2a895fdbb$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser) {
            // FIXME: This feels gross.  How can we cleanup the lines between
            // scrollRestoration/appliedTransitions persistance?
            $59f953d2a895fdbb$var$restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>$59f953d2a895fdbb$var$persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        // Kick off initial data load if needed.  Use Pop to avoid modifying history
        // Note we don't do any handling of lazy here.  For SPA's it'll get handled
        // in the normal navigation flow.  For SSR it's expected that lazy modules are
        // resolved prior to router creation since we can't go into a fallbackElement
        // UI for SSR'd apps
        if (!state.initialized) startNavigation($59f953d2a895fdbb$export$e19cd5f9376f8cee.Pop, state.location, {
            initialHydration: true
        });
        return router;
    }
    // Clean up a router and it's side effects
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    // Subscribe to state updates for the router
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    }
    // Update our state and notify the calling context of the change
    function updateState(newState, opts) {
        if (opts === void 0) opts = {};
        state = $59f953d2a895fdbb$var$_extends({}, state, newState);
        // Prep fetcher cleanup so we can tell the UI which fetcher data entries
        // can be removed
        let completedFetchers = [];
        let deletedFetchersKeys = [];
        if (future.v7_fetcherPersist) state.fetchers.forEach((fetcher, key)=>{
            if (fetcher.state === "idle") {
                if (deletedFetchers.has(key)) // Unmounted from the UI and can be totally removed
                deletedFetchersKeys.push(key);
                else // Returned to idle but still mounted in the UI, so semi-remains for
                // revalidations and such
                completedFetchers.push(key);
            }
        });
        // Remove any lingering deleted fetchers that have already been removed
        // from state.fetchers
        deletedFetchers.forEach((key)=>{
            if (!state.fetchers.has(key) && !fetchControllers.has(key)) deletedFetchersKeys.push(key);
        });
        // Iterate over a local copy so that if flushSync is used and we end up
        // removing and adding a new subscriber due to the useCallback dependencies,
        // we don't get ourselves into a loop calling the new subscriber immediately
        [
            ...subscribers
        ].forEach((subscriber)=>subscriber(state, {
                deletedFetchers: deletedFetchersKeys,
                viewTransitionOpts: opts.viewTransitionOpts,
                flushSync: opts.flushSync === true
            }));
        // Remove idle fetchers from state since we only care about in-flight fetchers.
        if (future.v7_fetcherPersist) {
            completedFetchers.forEach((key)=>state.fetchers.delete(key));
            deletedFetchersKeys.forEach((key)=>deleteFetcher(key));
        } else // We already called deleteFetcher() on these, can remove them from this
        // Set now that we've handed the keys off to the data layer
        deletedFetchersKeys.forEach((key)=>deletedFetchers.delete(key));
    }
    // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
    // and setting state.[historyAction/location/matches] to the new route.
    // - Location is a required param
    // - Navigation will always be set to IDLE_NAVIGATION
    // - Can pass any other state in newState
    function completeNavigation(location, newState, _temp) {
        var _location$state, _location$state2;
        let { flushSync: flushSync } = _temp === void 0 ? {} : _temp;
        // Deduce if we're in a loading/actionReload state:
        // - We have committed actionData in the store
        // - The current navigation was a mutation submission
        // - We're past the submitting state and into the loading state
        // - The location being loaded is not the result of a redirect
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $59f953d2a895fdbb$var$isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location$state = location.state) == null ? void 0 : _location$state._isRedirect) !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else // Empty actionData -> clear prior actionData due to an action error
            actionData = null;
        } else if (isActionReload) // Keep the current data if we're wrapping up the action reload
        actionData = state.actionData;
        else // Clear actionData on any other completed navigations
        actionData = null;
        // Always preserve any existing loaderData from re-used routes
        let loaderData = newState.loaderData ? $59f953d2a895fdbb$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        // On a successful navigation we can assume we got through all blockers
        // so we can start fresh
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $59f953d2a895fdbb$export$386d57f03f0b2883));
        }
        // Always respect the user flag.  Otherwise don't reset on mutation
        // submission navigations unless they redirect
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $59f953d2a895fdbb$var$isMutationMethod(state.navigation.formMethod) && ((_location$state2 = location.state) == null ? void 0 : _location$state2._isRedirect) !== true;
        // Commit any in-flight routes at the end of the HMR revalidation "navigation"
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = undefined;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === $59f953d2a895fdbb$export$e19cd5f9376f8cee.Pop) ;
        else if (pendingAction === $59f953d2a895fdbb$export$e19cd5f9376f8cee.Push) init.history.push(location, location.state);
        else if (pendingAction === $59f953d2a895fdbb$export$e19cd5f9376f8cee.Replace) init.history.replace(location, location.state);
        let viewTransitionOpts;
        // On POP, enable transitions if they were enabled on the original navigation
        if (pendingAction === $59f953d2a895fdbb$export$e19cd5f9376f8cee.Pop) {
            // Forward takes precedence so they behave like the original navigation
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) // If we don't have a previous forward nav, assume we're popping back to
            // the new location and enable if that location previously enabled
            viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            // Store the applied transition on PUSH/REPLACE
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState($59f953d2a895fdbb$var$_extends({}, newState, {
            actionData: actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: $59f953d2a895fdbb$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }), {
            viewTransitionOpts: viewTransitionOpts,
            flushSync: flushSync === true
        });
        // Reset stateful navigation vars
        pendingAction = $59f953d2a895fdbb$export$e19cd5f9376f8cee.Pop;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        cancelledDeferredRoutes = [];
    }
    // Trigger a navigation event, which can either be a numerical POP or a PUSH
    // replace with an optional submission
    async function navigate(to, opts) {
        if (typeof to === "number") {
            init.history.go(to);
            return;
        }
        let normalizedPath = $59f953d2a895fdbb$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, to, future.v7_relativeSplatPath, opts == null ? void 0 : opts.fromRouteId, opts == null ? void 0 : opts.relative);
        let { path: path, submission: submission, error: error } = $59f953d2a895fdbb$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, false, normalizedPath, opts);
        let currentLocation = state.location;
        let nextLocation = $59f953d2a895fdbb$var$createLocation(state.location, path, opts && opts.state);
        // When using navigate as a PUSH/REPLACE we aren't reading an already-encoded
        // URL from window.location, so we need to encode it here so the behavior
        // remains the same as POP and non-data-router usages.  new URL() does all
        // the same encoding we'd get from a history.pushState/window.location read
        // without having to touch history
        nextLocation = $59f953d2a895fdbb$var$_extends({}, nextLocation, init.history.encodeLocation(nextLocation));
        let userReplace = opts && opts.replace != null ? opts.replace : undefined;
        let historyAction = $59f953d2a895fdbb$export$e19cd5f9376f8cee.Push;
        if (userReplace === true) historyAction = $59f953d2a895fdbb$export$e19cd5f9376f8cee.Replace;
        else if (userReplace === false) ;
        else if (submission != null && $59f953d2a895fdbb$var$isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) // By default on submissions to the current location we REPLACE so that
        // users don't have to double-click the back button to get to the prior
        // location.  If the user redirects to a different location from the
        // action/loader this will be ignored and the redirect will be a PUSH
        historyAction = $59f953d2a895fdbb$export$e19cd5f9376f8cee.Replace;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
        let flushSync = (opts && opts.flushSync) === true;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            // Put the blocker into a blocked state
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: undefined,
                        reset: undefined,
                        location: nextLocation
                    });
                    // Send the same navigation through
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $59f953d2a895fdbb$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        return await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.viewTransition,
            flushSync: flushSync
        });
    }
    // Revalidate all current loaders.  If a navigation is in progress or if this
    // is interrupted by a navigation, allow this to "succeed" by calling all
    // loaders during the next loader round
    function revalidate() {
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        // If we're currently submitting an action, we don't need to start a new
        // navigation, we'll just let the follow up loader execution call all loaders
        if (state.navigation.state === "submitting") return;
        // If we're currently in an idle state, start a new navigation for the current
        // action/location and mark it as uninterrupted, which will skip the history
        // update in completeNavigation
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return;
        }
        // Otherwise, if we're currently in a loading state, just start a new
        // navigation to the navigation.location but do not trigger an uninterrupted
        // revalidation so that history correctly updates once the navigation completes
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation,
            // Proxy through any rending view transition
            enableViewTransition: pendingViewTransitionEnabled === true
        });
    }
    // Start a navigation to the given action/location.  Can optionally provide a
    // overrideNavigation which will override the normalLoad in the case of a redirect
    // navigation
    async function startNavigation(historyAction, location, opts) {
        // Abort any in-progress navigations and start a new one. Unset any ongoing
        // uninterrupted revalidations unless told otherwise, since we want this
        // new navigation to update history normally
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        // Save the current scroll position every time we start a new navigation,
        // and track whether we should reset scroll on completion
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = $59f953d2a895fdbb$export$2708184779ceb39d(routesToUse, location, basename);
        let flushSync = (opts && opts.flushSync) === true;
        let fogOfWar = checkFogOfWar(matches, routesToUse, location.pathname);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        // Short circuit with a 404 on the root error boundary if we match nothing
        if (!matches) {
            let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Short circuit if it's only a hash change and not a revalidation or
        // mutation submission.
        //
        // Ignore on initial page loads because since the initial hydration will always
        // be "same hash".  For example, on /page#hash and submit a <Form method="post">
        // which will default to a navigation to /page
        if (state.initialized && !isRevalidationRequired && $59f953d2a895fdbb$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $59f953d2a895fdbb$var$isMutationMethod(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Create a controller/Request for this navigation
        pendingNavigationController = new AbortController();
        let request = $59f953d2a895fdbb$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let pendingActionResult;
        if (opts && opts.pendingError) // If we have a pendingError, it means the user attempted a GET submission
        // with binary FormData so assign here and skip to handleLoaders.  That
        // way we handle calling loaders above the boundary etc.  It's not really
        // different from an actionError in that sense.
        pendingActionResult = [
            $59f953d2a895fdbb$var$findNearestBoundary(matches).route.id,
            {
                type: $59f953d2a895fdbb$var$ResultType.error,
                error: opts.pendingError
            }
        ];
        else if (opts && opts.submission && $59f953d2a895fdbb$var$isMutationMethod(opts.submission.formMethod)) {
            // Call action if we received an action submission
            let actionResult = await handleAction(request, location, opts.submission, matches, fogOfWar.active, {
                replace: opts.replace,
                flushSync: flushSync
            });
            if (actionResult.shortCircuited) return;
            // If we received a 404 from handleAction, it's because we couldn't lazily
            // discover the destination route so we don't want to call loaders
            if (actionResult.pendingActionResult) {
                let [routeId, result] = actionResult.pendingActionResult;
                if ($59f953d2a895fdbb$var$isErrorResult(result) && $59f953d2a895fdbb$export$972111febbeef05b(result.error) && result.error.status === 404) {
                    pendingNavigationController = null;
                    completeNavigation(location, {
                        matches: actionResult.matches,
                        loaderData: {},
                        errors: {
                            [routeId]: result.error
                        }
                    });
                    return;
                }
            }
            matches = actionResult.matches || matches;
            pendingActionResult = actionResult.pendingActionResult;
            loadingNavigation = $59f953d2a895fdbb$var$getLoadingNavigation(location, opts.submission);
            flushSync = false;
            // No need to do fog of war matching again on loader execution
            fogOfWar.active = false;
            // Create a GET request for the loaders
            request = $59f953d2a895fdbb$var$createClientSideRequest(init.history, request.url, request.signal);
        }
        // Call loaders
        let { shortCircuited: shortCircuited, matches: updatedMatches, loaderData: loaderData, errors: errors } = await handleLoaders(request, location, matches, fogOfWar.active, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionResult);
        if (shortCircuited) return;
        // Clean up now that the action/loaders have completed.  Don't clean up if
        // we short circuited because pendingNavigationController will have already
        // been assigned to a new controller for the next navigation
        pendingNavigationController = null;
        completeNavigation(location, $59f953d2a895fdbb$var$_extends({
            matches: updatedMatches || matches
        }, $59f953d2a895fdbb$var$getActionDataForCommit(pendingActionResult), {
            loaderData: loaderData,
            errors: errors
        }));
    }
    // Call the action matched by the leaf route for this navigation and handle
    // redirects/errors
    async function handleAction(request, location, submission, matches, isFogOfWar, opts) {
        if (opts === void 0) opts = {};
        interruptActiveLoads();
        // Put us in a submitting state
        let navigation = $59f953d2a895fdbb$var$getSubmittingNavigation(location, submission);
        updateState({
            navigation: navigation
        }, {
            flushSync: opts.flushSync === true
        });
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let boundaryId = $59f953d2a895fdbb$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    pendingActionResult: [
                        boundaryId,
                        {
                            type: $59f953d2a895fdbb$var$ResultType.error,
                            error: discoverResult.error
                        }
                    ]
                };
            } else if (!discoverResult.matches) {
                let { notFoundMatches: notFoundMatches, error: error, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    pendingActionResult: [
                        route.id,
                        {
                            type: $59f953d2a895fdbb$var$ResultType.error,
                            error: error
                        }
                    ]
                };
            } else matches = discoverResult.matches;
        }
        // Call our action and get the result
        let result;
        let actionMatch = $59f953d2a895fdbb$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: $59f953d2a895fdbb$var$ResultType.error,
            error: $59f953d2a895fdbb$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            let results = await callDataStrategy("action", state, request, [
                actionMatch
            ], matches, null);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($59f953d2a895fdbb$var$isRedirectResult(result)) {
            let replace;
            if (opts && opts.replace != null) replace = opts.replace;
            else {
                // If the user didn't explicity indicate replace behavior, replace if
                // we redirected to the exact same location we're currently at to avoid
                // double back-buttons
                let location = $59f953d2a895fdbb$var$normalizeRedirectLocation(result.response.headers.get("Location"), new URL(request.url), basename);
                replace = location === state.location.pathname + state.location.search;
            }
            await startRedirectNavigation(request, result, true, {
                submission: submission,
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        if ($59f953d2a895fdbb$var$isDeferredResult(result)) throw $59f953d2a895fdbb$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        if ($59f953d2a895fdbb$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $59f953d2a895fdbb$var$findNearestBoundary(matches, actionMatch.route.id);
            // By default, all submissions to the current location are REPLACE
            // navigations, but if the action threw an error that'll be rendered in
            // an errorElement, we fall back to PUSH so that the user can use the
            // back button to get back to the pre-submission form location to try
            // again
            if ((opts && opts.replace) !== true) pendingAction = $59f953d2a895fdbb$export$e19cd5f9376f8cee.Push;
            return {
                matches: matches,
                pendingActionResult: [
                    boundaryMatch.route.id,
                    result
                ]
            };
        }
        return {
            matches: matches,
            pendingActionResult: [
                actionMatch.route.id,
                result
            ]
        };
    }
    // Call all applicable loaders for the given matches, handling redirects,
    // errors, etc.
    async function handleLoaders(request, location, matches, isFogOfWar, overrideNavigation, submission, fetcherSubmission, replace, initialHydration, flushSync, pendingActionResult) {
        // Figure out the right navigation we want to use for data loading
        let loadingNavigation = overrideNavigation || $59f953d2a895fdbb$var$getLoadingNavigation(location, submission);
        // If this was a redirect from an action we don't have a "submission" but
        // we have it on the loading navigation so use that if available
        let activeSubmission = submission || fetcherSubmission || $59f953d2a895fdbb$var$getSubmissionFromNavigation(loadingNavigation);
        // If this is an uninterrupted revalidation, we remain in our current idle
        // state.  If not, we need to switch to our loading state and load data,
        // preserving any new action data or existing action data (in the case of
        // a revalidation interrupting an actionReload)
        // If we have partialHydration enabled, then don't update the state for the
        // initial data load since it's not a "navigation"
        let shouldUpdateNavigationState = !isUninterruptedRevalidation && (!future.v7_partialHydration || !initialHydration);
        // When fog of war is enabled, we enter our `loading` state earlier so we
        // can discover new routes during the `loading` state.  We skip this if
        // we've already run actions since we would have done our matching already.
        // If the children() function threw then, we want to proceed with the
        // partial matches it discovered.
        if (isFogOfWar) {
            if (shouldUpdateNavigationState) {
                let actionData = getUpdatedActionData(pendingActionResult);
                updateState($59f953d2a895fdbb$var$_extends({
                    navigation: loadingNavigation
                }, actionData !== undefined ? {
                    actionData: actionData
                } : {}), {
                    flushSync: flushSync
                });
            }
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let boundaryId = $59f953d2a895fdbb$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    loaderData: {},
                    errors: {
                        [boundaryId]: discoverResult.error
                    }
                };
            } else if (!discoverResult.matches) {
                let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    loaderData: {},
                    errors: {
                        [route.id]: error
                    }
                };
            } else matches = discoverResult.matches;
        }
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let [matchesToLoad, revalidatingFetchers] = $59f953d2a895fdbb$var$getMatchesToLoad(init.history, state, matches, activeSubmission, location, future.v7_partialHydration && initialHydration === true, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult);
        // Cancel pending deferreds for no-longer-matched routes or routes we're
        // about to reload.  Note that if this is an action reload we would have
        // already cancelled all pending deferreds so this would be a no-op
        cancelActiveDeferreds((routeId)=>!(matches && matches.some((m)=>m.route.id === routeId)) || matchesToLoad && matchesToLoad.some((m)=>m.route.id === routeId));
        pendingNavigationLoadId = ++incrementingLoadId;
        // Short circuit if we have no loaders to run
        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
            let updatedFetchers = markFetchRedirectsDone();
            completeNavigation(location, $59f953d2a895fdbb$var$_extends({
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingActionResult && $59f953d2a895fdbb$var$isErrorResult(pendingActionResult[1]) ? {
                    [pendingActionResult[0]]: pendingActionResult[1].error
                } : null
            }, $59f953d2a895fdbb$var$getActionDataForCommit(pendingActionResult), updatedFetchers ? {
                fetchers: new Map(state.fetchers)
            } : {}), {
                flushSync: flushSync
            });
            return {
                shortCircuited: true
            };
        }
        if (shouldUpdateNavigationState) {
            let updates = {};
            if (!isFogOfWar) {
                // Only update navigation/actionNData if we didn't already do it above
                updates.navigation = loadingNavigation;
                let actionData = getUpdatedActionData(pendingActionResult);
                if (actionData !== undefined) updates.actionData = actionData;
            }
            if (revalidatingFetchers.length > 0) updates.fetchers = getUpdatedRevalidatingFetchers(revalidatingFetchers);
            updateState(updates, {
                flushSync: flushSync
            });
        }
        revalidatingFetchers.forEach((rf)=>{
            abortFetcher(rf.key);
            if (rf.controller) // Fetchers use an independent AbortController so that aborting a fetcher
            // (via deleteFetcher) does not abort the triggering navigation that
            // triggered the revalidation
            fetchControllers.set(rf.key, rf.controller);
        });
        // Proxy navigation abort through to revalidation fetchers
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, request);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        // Clean up _after_ loaders have completed.  Don't clean up if we short
        // circuited because fetchControllers would have been aborted and
        // reassigned to new controllers for the next navigation
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        // If any loaders returned a redirect Response, start a new REPLACE navigation
        let redirect = $59f953d2a895fdbb$var$findRedirect(loaderResults);
        if (redirect) {
            await startRedirectNavigation(request, redirect.result, true, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        redirect = $59f953d2a895fdbb$var$findRedirect(fetcherResults);
        if (redirect) {
            // If this redirect came from a fetcher make sure we mark it in
            // fetchRedirectIds so it doesn't get revalidated on the next set of
            // loader executions
            fetchRedirectIds.add(redirect.key);
            await startRedirectNavigation(request, redirect.result, true, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $59f953d2a895fdbb$var$processLoaderData(state, matches, loaderResults, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Wire up subscribers to update loaderData as promises settle
        activeDeferreds.forEach((deferredData, routeId)=>{
            deferredData.subscribe((aborted)=>{
                // Note: No need to updateState here since the TrackedPromise on
                // loaderData is stable across resolve/reject
                // Remove this instance if we were aborted or if promises have settled
                if (aborted || deferredData.done) activeDeferreds.delete(routeId);
            });
        });
        // Preserve SSR errors during partial hydration
        if (future.v7_partialHydration && initialHydration && state.errors) errors = $59f953d2a895fdbb$var$_extends({}, state.errors, errors);
        let updatedFetchers = markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        let shouldUpdateFetchers = updatedFetchers || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return $59f953d2a895fdbb$var$_extends({
            matches: matches,
            loaderData: loaderData,
            errors: errors
        }, shouldUpdateFetchers ? {
            fetchers: new Map(state.fetchers)
        } : {});
    }
    function getUpdatedActionData(pendingActionResult) {
        if (pendingActionResult && !$59f953d2a895fdbb$var$isErrorResult(pendingActionResult[1])) // This is cast to `any` currently because `RouteData`uses any and it
        // would be a breaking change to use any.
        // TODO: v7 - change `RouteData` to use `unknown` instead of `any`
        return {
            [pendingActionResult[0]]: pendingActionResult[1].data
        };
        else if (state.actionData) {
            if (Object.keys(state.actionData).length === 0) return null;
            else return state.actionData;
        }
    }
    function getUpdatedRevalidatingFetchers(revalidatingFetchers) {
        revalidatingFetchers.forEach((rf)=>{
            let fetcher = state.fetchers.get(rf.key);
            let revalidatingFetcher = $59f953d2a895fdbb$var$getLoadingFetcher(undefined, fetcher ? fetcher.data : undefined);
            state.fetchers.set(rf.key, revalidatingFetcher);
        });
        return new Map(state.fetchers);
    }
    // Trigger a fetcher load/submit for the given fetcher key
    function fetch(key, routeId, href, opts) {
        if (isServer) throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
        abortFetcher(key);
        let flushSync = (opts && opts.flushSync) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let normalizedPath = $59f953d2a895fdbb$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, href, future.v7_relativeSplatPath, routeId, opts == null ? void 0 : opts.relative);
        let matches = $59f953d2a895fdbb$export$2708184779ceb39d(routesToUse, normalizedPath, basename);
        let fogOfWar = checkFogOfWar(matches, routesToUse, normalizedPath);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (!matches) {
            setFetcherError(key, routeId, $59f953d2a895fdbb$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync: flushSync
            });
            return;
        }
        let { path: path, submission: submission, error: error } = $59f953d2a895fdbb$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        let match = $59f953d2a895fdbb$var$getTargetMatch(matches, path);
        let preventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $59f953d2a895fdbb$var$isMutationMethod(submission.formMethod)) {
            handleFetcherAction(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
            return;
        }
        // Store off the match so we can call it's shouldRevalidate on subsequent
        // revalidations
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        handleFetcherLoader(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
    }
    // Call the action for the matched fetcher.submit(), and then handle redirects,
    // errors, and revalidation
    async function handleFetcherAction(key, routeId, path, match, requestMatches, isFogOfWar, flushSync, preventScrollReset, submission) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        function detectAndHandle405Error(m) {
            if (!m.route.action && !m.route.lazy) {
                let error = $59f953d2a895fdbb$var$getInternalRouterError(405, {
                    method: submission.formMethod,
                    pathname: path,
                    routeId: routeId
                });
                setFetcherError(key, routeId, error, {
                    flushSync: flushSync
                });
                return true;
            }
            return false;
        }
        if (!isFogOfWar && detectAndHandle405Error(match)) return;
        // Put this fetcher into it's submitting state
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $59f953d2a895fdbb$var$getSubmittingFetcher(submission, existingFetcher), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $59f953d2a895fdbb$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(requestMatches, path, fetchRequest.signal);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $59f953d2a895fdbb$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                requestMatches = discoverResult.matches;
                match = $59f953d2a895fdbb$var$getTargetMatch(requestMatches, path);
                if (detectAndHandle405Error(match)) return;
            }
        }
        // Call the action for the fetcher
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let actionResults = await callDataStrategy("action", state, fetchRequest, [
            match
        ], requestMatches, key);
        let actionResult = actionResults[match.route.id];
        if (fetchRequest.signal.aborted) {
            // We can delete this so long as we weren't aborted by our own fetcher
            // re-submit which would have put _new_ controller is in fetchControllers
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        // When using v7_fetcherPersist, we don't want errors bubbling up to the UI
        // or redirects processed for unmounted fetchers so we just revert them to
        // idle
        if (future.v7_fetcherPersist && deletedFetchers.has(key)) {
            if ($59f953d2a895fdbb$var$isRedirectResult(actionResult) || $59f953d2a895fdbb$var$isErrorResult(actionResult)) {
                updateFetcherState(key, $59f953d2a895fdbb$var$getDoneFetcher(undefined));
                return;
            }
        } else {
            if ($59f953d2a895fdbb$var$isRedirectResult(actionResult)) {
                fetchControllers.delete(key);
                if (pendingNavigationLoadId > originatingLoadId) {
                    // A new navigation was kicked off after our action started, so that
                    // should take precedence over this redirect navigation.  We already
                    // set isRevalidationRequired so all loaders for the new route should
                    // fire unless opted out via shouldRevalidate
                    updateFetcherState(key, $59f953d2a895fdbb$var$getDoneFetcher(undefined));
                    return;
                } else {
                    fetchRedirectIds.add(key);
                    updateFetcherState(key, $59f953d2a895fdbb$var$getLoadingFetcher(submission));
                    return startRedirectNavigation(fetchRequest, actionResult, false, {
                        fetcherSubmission: submission,
                        preventScrollReset: preventScrollReset
                    });
                }
            }
            // Process any non-redirect errors thrown
            if ($59f953d2a895fdbb$var$isErrorResult(actionResult)) {
                setFetcherError(key, routeId, actionResult.error);
                return;
            }
        }
        if ($59f953d2a895fdbb$var$isDeferredResult(actionResult)) throw $59f953d2a895fdbb$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        // Start the data load for current matches, or the next location if we're
        // in the middle of a navigation
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $59f953d2a895fdbb$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let matches = state.navigation.state !== "idle" ? $59f953d2a895fdbb$export$2708184779ceb39d(routesToUse, state.navigation.location, basename) : state.matches;
        $59f953d2a895fdbb$export$3e9cee6b33872309(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = $59f953d2a895fdbb$var$getLoadingFetcher(submission, actionResult.data);
        state.fetchers.set(key, loadFetcher);
        let [matchesToLoad, revalidatingFetchers] = $59f953d2a895fdbb$var$getMatchesToLoad(init.history, state, matches, submission, nextLocation, false, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, [
            match.route.id,
            actionResult
        ]);
        // Put all revalidating fetchers into the loading state, except for the
        // current fetcher which we want to keep in it's current loading state which
        // contains it's action submission info + action data
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher = state.fetchers.get(staleKey);
            let revalidatingFetcher = $59f953d2a895fdbb$var$getLoadingFetcher(undefined, existingFetcher ? existingFetcher.data : undefined);
            state.fetchers.set(staleKey, revalidatingFetcher);
            abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, revalidationRequest);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let redirect = $59f953d2a895fdbb$var$findRedirect(loaderResults);
        if (redirect) return startRedirectNavigation(revalidationRequest, redirect.result, false, {
            preventScrollReset: preventScrollReset
        });
        redirect = $59f953d2a895fdbb$var$findRedirect(fetcherResults);
        if (redirect) {
            // If this redirect came from a fetcher make sure we mark it in
            // fetchRedirectIds so it doesn't get revalidated on the next set of
            // loader executions
            fetchRedirectIds.add(redirect.key);
            return startRedirectNavigation(revalidationRequest, redirect.result, false, {
                preventScrollReset: preventScrollReset
            });
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $59f953d2a895fdbb$var$processLoaderData(state, matches, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Since we let revalidations complete even if the submitting fetcher was
        // deleted, only put it back to idle if it hasn't been deleted
        if (state.fetchers.has(key)) {
            let doneFetcher = $59f953d2a895fdbb$var$getDoneFetcher(actionResult.data);
            state.fetchers.set(key, doneFetcher);
        }
        abortStaleFetchLoads(loadId);
        // If we are currently in a navigation loading state and this fetcher is
        // more recent than the navigation, we want the newer data so abort the
        // navigation and complete it with the fetcher data
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $59f953d2a895fdbb$export$3e9cee6b33872309(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            // otherwise just update with the fetcher data, preserving any existing
            // loaderData for loaders that did not need to reload.  We have to
            // manually merge here since we aren't going through completeNavigation
            updateState({
                errors: errors,
                loaderData: $59f953d2a895fdbb$var$mergeLoaderData(state.loaderData, loaderData, matches, errors),
                fetchers: new Map(state.fetchers)
            });
            isRevalidationRequired = false;
        }
    }
    // Call the matched loader for fetcher.load(), handling redirects, errors, etc.
    async function handleFetcherLoader(key, routeId, path, match, matches, isFogOfWar, flushSync, preventScrollReset, submission) {
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $59f953d2a895fdbb$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : undefined), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $59f953d2a895fdbb$var$createClientSideRequest(init.history, path, abortController.signal);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, path, fetchRequest.signal);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $59f953d2a895fdbb$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                matches = discoverResult.matches;
                match = $59f953d2a895fdbb$var$getTargetMatch(matches, path);
            }
        }
        // Call the loader for this fetcher route match
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let results = await callDataStrategy("loader", state, fetchRequest, [
            match
        ], matches, key);
        let result = results[match.route.id];
        // Deferred isn't supported for fetcher loads, await everything and treat it
        // as a normal load.  resolveDeferredData will return undefined if this
        // fetcher gets aborted, so we just leave result untouched and short circuit
        // below if that happens
        if ($59f953d2a895fdbb$var$isDeferredResult(result)) result = await $59f953d2a895fdbb$var$resolveDeferredData(result, fetchRequest.signal, true) || result;
        // We can delete this so long as we weren't aborted by our our own fetcher
        // re-load which would have put _new_ controller is in fetchControllers
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        // We don't want errors bubbling up or redirects followed for unmounted
        // fetchers, so short circuit here if it was removed from the UI
        if (deletedFetchers.has(key)) {
            updateFetcherState(key, $59f953d2a895fdbb$var$getDoneFetcher(undefined));
            return;
        }
        // If the loader threw a redirect Response, start a new REPLACE navigation
        if ($59f953d2a895fdbb$var$isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                // A new navigation was kicked off after our loader started, so that
                // should take precedence over this redirect navigation
                updateFetcherState(key, $59f953d2a895fdbb$var$getDoneFetcher(undefined));
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(fetchRequest, result, false, {
                    preventScrollReset: preventScrollReset
                });
                return;
            }
        }
        // Process any non-redirect errors thrown
        if ($59f953d2a895fdbb$var$isErrorResult(result)) {
            setFetcherError(key, routeId, result.error);
            return;
        }
        $59f953d2a895fdbb$export$3e9cee6b33872309(!$59f953d2a895fdbb$var$isDeferredResult(result), "Unhandled fetcher deferred data");
        // Put the fetcher back into an idle state
        updateFetcherState(key, $59f953d2a895fdbb$var$getDoneFetcher(result.data));
    }
    /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */ async function startRedirectNavigation(request, redirect, isNavigation, _temp2) {
        let { submission: submission, fetcherSubmission: fetcherSubmission, preventScrollReset: preventScrollReset, replace: replace } = _temp2 === void 0 ? {} : _temp2;
        if (redirect.response.headers.has("X-Remix-Revalidate")) isRevalidationRequired = true;
        let location = redirect.response.headers.get("Location");
        $59f953d2a895fdbb$export$3e9cee6b33872309(location, "Expected a Location header on the redirect Response");
        location = $59f953d2a895fdbb$var$normalizeRedirectLocation(location, new URL(request.url), basename);
        let redirectLocation = $59f953d2a895fdbb$var$createLocation(state.location, location, {
            _isRedirect: true
        });
        if (isBrowser) {
            let isDocumentReload = false;
            if (redirect.response.headers.has("X-Remix-Reload-Document")) // Hard reload if the response contained X-Remix-Reload-Document
            isDocumentReload = true;
            else if ($59f953d2a895fdbb$var$ABSOLUTE_URL_REGEX.test(location)) {
                const url = init.history.createURL(location);
                isDocumentReload = // Hard reload if it's an absolute URL to a new origin
                url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                $59f953d2a895fdbb$export$b69e3301ce081aa3(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace) routerWindow.location.replace(location);
                else routerWindow.location.assign(location);
                return;
            }
        }
        // There's no need to abort on redirects, since we don't detect the
        // redirect until the action/loaders have settled
        pendingNavigationController = null;
        let redirectHistoryAction = replace === true || redirect.response.headers.has("X-Remix-Replace") ? $59f953d2a895fdbb$export$e19cd5f9376f8cee.Replace : $59f953d2a895fdbb$export$e19cd5f9376f8cee.Push;
        // Use the incoming submission if provided, fallback on the active one in
        // state.navigation
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $59f953d2a895fdbb$var$getSubmissionFromNavigation(state.navigation);
        // If this was a 307/308 submission we want to preserve the HTTP method and
        // re-submit the GET/POST/PUT/PATCH/DELETE as a submission navigation to the
        // redirected location
        let activeSubmission = submission || fetcherSubmission;
        if ($59f953d2a895fdbb$var$redirectPreserveMethodStatusCodes.has(redirect.response.status) && activeSubmission && $59f953d2a895fdbb$var$isMutationMethod(activeSubmission.formMethod)) await startNavigation(redirectHistoryAction, redirectLocation, {
            submission: $59f953d2a895fdbb$var$_extends({}, activeSubmission, {
                formAction: location
            }),
            // Preserve these flags across redirects
            preventScrollReset: preventScrollReset || pendingPreventScrollReset,
            enableViewTransition: isNavigation ? pendingViewTransitionEnabled : undefined
        });
        else {
            // If we have a navigation submission, we will preserve it through the
            // redirect navigation
            let overrideNavigation = $59f953d2a895fdbb$var$getLoadingNavigation(redirectLocation, submission);
            await startNavigation(redirectHistoryAction, redirectLocation, {
                overrideNavigation: overrideNavigation,
                fetcherSubmission: // Send fetcher submissions through for shouldRevalidate
                fetcherSubmission,
                // Preserve these flags across redirects
                preventScrollReset: preventScrollReset || pendingPreventScrollReset,
                enableViewTransition: isNavigation ? pendingViewTransitionEnabled : undefined
            });
        }
    }
    // Utility wrapper for calling dataStrategy client-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, state, request, matchesToLoad, matches, fetcherKey) {
        let results;
        let dataResults = {};
        try {
            results = await $59f953d2a895fdbb$var$callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties);
        } catch (e) {
            // If the outer dataStrategy method throws, just return the error for all
            // matches - and it'll naturally bubble to the root
            matchesToLoad.forEach((m)=>{
                dataResults[m.route.id] = {
                    type: $59f953d2a895fdbb$var$ResultType.error,
                    error: e
                };
            });
            return dataResults;
        }
        for (let [routeId, result] of Object.entries(results))if ($59f953d2a895fdbb$var$isRedirectDataStrategyResultResult(result)) {
            let response = result.result;
            dataResults[routeId] = {
                type: $59f953d2a895fdbb$var$ResultType.redirect,
                response: $59f953d2a895fdbb$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, future.v7_relativeSplatPath)
            };
        } else dataResults[routeId] = await $59f953d2a895fdbb$var$convertDataStrategyResultToDataResult(result);
        return dataResults;
    }
    async function callLoadersAndMaybeResolveData(state, matches, matchesToLoad, fetchersToLoad, request) {
        let currentMatches = state.matches;
        // Kick off loaders and fetchers in parallel
        let loaderResultsPromise = callDataStrategy("loader", state, request, matchesToLoad, matches, null);
        let fetcherResultsPromise = Promise.all(fetchersToLoad.map(async (f)=>{
            if (f.matches && f.match && f.controller) {
                let results = await callDataStrategy("loader", state, $59f953d2a895fdbb$var$createClientSideRequest(init.history, f.path, f.controller.signal), [
                    f.match
                ], f.matches, f.key);
                let result = results[f.match.route.id];
                // Fetcher results are keyed by fetcher key from here on out, not routeId
                return {
                    [f.key]: result
                };
            } else return Promise.resolve({
                [f.key]: {
                    type: $59f953d2a895fdbb$var$ResultType.error,
                    error: $59f953d2a895fdbb$var$getInternalRouterError(404, {
                        pathname: f.path
                    })
                }
            });
        }));
        let loaderResults = await loaderResultsPromise;
        let fetcherResults = (await fetcherResultsPromise).reduce((acc, r)=>Object.assign(acc, r), {});
        await Promise.all([
            $59f953d2a895fdbb$var$resolveNavigationDeferredResults(matches, loaderResults, request.signal, currentMatches, state.loaderData),
            $59f953d2a895fdbb$var$resolveFetcherDeferredResults(matches, fetcherResults, fetchersToLoad)
        ]);
        return {
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        // Every interruption triggers a revalidation
        isRevalidationRequired = true;
        // Cancel pending route-level deferreds and mark cancelled routes for
        // revalidation
        cancelledDeferredRoutes.push(...cancelActiveDeferreds());
        // Abort in-flight fetcher loads
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) cancelledFetcherLoads.add(key);
            abortFetcher(key);
        });
    }
    function updateFetcherState(key, fetcher, opts) {
        if (opts === void 0) opts = {};
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts) {
        if (opts === void 0) opts = {};
        let boundaryMatch = $59f953d2a895fdbb$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
        // If this fetcher was previously marked for deletion, unmark it since we
        // have a new instance
        if (deletedFetchers.has(key)) deletedFetchers.delete(key);
        return state.fetchers.get(key) || $59f953d2a895fdbb$export$52eace9c284d3585;
    }
    function deleteFetcher(key) {
        let fetcher = state.fetchers.get(key);
        // Don't abort the controller if this is a deletion of a fetcher.submit()
        // in it's loading phase since - we don't want to abort the corresponding
        // revalidation and want them to complete and land
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        // If we opted into the flag we can clear this now since we're calling
        // deleteFetcher() at the end of updateState() and we've already handed the
        // deleted fetcher keys off to the data layer.
        // If not, we're eagerly calling deleteFetcher() and we need to keep this
        // Set populated until the next updateState call, and we'll clear
        // `deletedFetchers` then
        if (future.v7_fetcherPersist) deletedFetchers.delete(key);
        cancelledFetcherLoads.delete(key);
        state.fetchers.delete(key);
    }
    function deleteFetcherAndUpdateState(key) {
        let count = (activeFetchers.get(key) || 0) - 1;
        if (count <= 0) {
            activeFetchers.delete(key);
            deletedFetchers.add(key);
            if (!future.v7_fetcherPersist) deleteFetcher(key);
        } else activeFetchers.set(key, count);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key) {
        let controller = fetchControllers.get(key);
        if (controller) {
            controller.abort();
            fetchControllers.delete(key);
        }
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = $59f953d2a895fdbb$var$getDoneFetcher(fetcher.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        let updatedFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            $59f953d2a895fdbb$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                updatedFetchers = true;
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            $59f953d2a895fdbb$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $59f953d2a895fdbb$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    // Utility function to update blockers, ensuring valid state transitions
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $59f953d2a895fdbb$export$386d57f03f0b2883;
        // Poor mans state machine :)
        // https://mermaid.live/edit#pako:eNqVkc9OwzAMxl8l8nnjAYrEtDIOHEBIgwvKJTReGy3_lDpIqO27k6awMG0XcrLlnz87nwdonESogKXXBuE79rq75XZO3-yHds0RJVuv70YrPlUrCEe2HfrORS3rubqZfuhtpg5C9wk5tZ4VKcRUq88q9Z8RS0-48cE1iHJkL0ugbHuFLus9L6spZy8nX9MP2CNdomVaposqu3fGayT8T8-jJQwhepo_UtpgBQaDEUom04dZhAN1aJBDlUKJBxE1ceB2Smj0Mln-IBW5AFU2dwUiktt_2Qaq2dBfaKdEup85UV7Yd-dKjlnkabl2Pvr0DTkTreM
        $59f953d2a895fdbb$export$3e9cee6b33872309(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: " + blocker.state + " -> " + newBlocker.state);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation(_ref2) {
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = _ref2;
        if (blockerFunctions.size === 0) return;
        // We ony support a single active blocker at the moment since we don't have
        // any compelling use cases for multi-blocker yet
        if (blockerFunctions.size > 1) $59f953d2a895fdbb$export$c0e02632e14916fd(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") // If the blocker is currently proceeding, we don't need to re-check
        // it and can let this navigation continue
        return;
        // At this point, we know we're unblocked/blocked so we need to check the
        // user-provided blocker function
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function handleNavigational404(pathname) {
        let error = $59f953d2a895fdbb$var$getInternalRouterError(404, {
            pathname: pathname
        });
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let { matches: matches, route: route } = $59f953d2a895fdbb$var$getShortCircuitMatches(routesToUse);
        // Cancel all pending deferred on 404s since we don't keep any routes
        cancelActiveDeferreds();
        return {
            notFoundMatches: matches,
            route: route,
            error: error
        };
    }
    function cancelActiveDeferreds(predicate) {
        let cancelledRouteIds = [];
        activeDeferreds.forEach((dfd, routeId)=>{
            if (!predicate || predicate(routeId)) {
                // Cancel the deferred - but do not remove from activeDeferreds here -
                // we rely on the subscribers to do that so our tests can assert proper
                // cleanup via _internalActiveDeferreds
                dfd.cancel();
                cancelledRouteIds.push(routeId);
                activeDeferreds.delete(routeId);
            }
        });
        return cancelledRouteIds;
    }
    // Opt in to capturing and reporting scroll positions during navigations,
    // used by the <ScrollRestoration> component
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || null;
        // Perform initial hydration scroll restoration, since we miss the boat on
        // the initial updateState() because we've not yet rendered <ScrollRestoration/>
        // and therefore have no savedScrollPositions available
        if (!initialScrollRestored && state.navigation === $59f953d2a895fdbb$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey) {
            let key = getScrollRestorationKey(location, matches.map((m)=>$59f953d2a895fdbb$export$b3fac024fad9e8ff(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function checkFogOfWar(matches, routesToUse, pathname) {
        if (patchRoutesOnNavigationImpl) {
            if (!matches) {
                let fogMatches = $59f953d2a895fdbb$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: fogMatches || []
                };
            } else if (Object.keys(matches[0].params).length > 0) {
                // If we matched a dynamic param or a splat, it might only be because
                // we haven't yet discovered other routes that would match with a
                // higher score.  Call patchRoutesOnNavigation just to be sure
                let partialMatches = $59f953d2a895fdbb$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: partialMatches
                };
            }
        }
        return {
            active: false,
            matches: null
        };
    }
    async function discoverRoutes(matches, pathname, signal) {
        if (!patchRoutesOnNavigationImpl) return {
            type: "success",
            matches: matches
        };
        let partialMatches = matches;
        while(true){
            let isNonHMR = inFlightDataRoutes == null;
            let routesToUse = inFlightDataRoutes || dataRoutes;
            let localManifest = manifest;
            try {
                await patchRoutesOnNavigationImpl({
                    path: pathname,
                    matches: partialMatches,
                    patch: (routeId, children)=>{
                        if (signal.aborted) return;
                        $59f953d2a895fdbb$var$patchRoutesImpl(routeId, children, routesToUse, localManifest, mapRouteProperties);
                    }
                });
            } catch (e) {
                return {
                    type: "error",
                    error: e,
                    partialMatches: partialMatches
                };
            } finally{
                // If we are not in the middle of an HMR revalidation and we changed the
                // routes, provide a new identity so when we `updateState` at the end of
                // this navigation/fetch `router.routes` will be a new identity and
                // trigger a re-run of memoized `router.routes` dependencies.
                // HMR will already update the identity and reflow when it lands
                // `inFlightDataRoutes` in `completeNavigation`
                if (isNonHMR && !signal.aborted) dataRoutes = [
                    ...dataRoutes
                ];
            }
            if (signal.aborted) return {
                type: "aborted"
            };
            let newMatches = $59f953d2a895fdbb$export$2708184779ceb39d(routesToUse, pathname, basename);
            if (newMatches) return {
                type: "success",
                matches: newMatches
            };
            let newPartialMatches = $59f953d2a895fdbb$var$matchRoutesImpl(routesToUse, pathname, basename, true);
            // Avoid loops if the second pass results in the same partial matches
            if (!newPartialMatches || partialMatches.length === newPartialMatches.length && partialMatches.every((m, i)=>m.route.id === newPartialMatches[i].route.id)) return {
                type: "success",
                matches: null
            };
            partialMatches = newPartialMatches;
        }
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = $59f953d2a895fdbb$export$4a6d22b32134ea5d(newRoutes, mapRouteProperties, undefined, manifest);
    }
    function patchRoutes(routeId, children) {
        let isNonHMR = inFlightDataRoutes == null;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        $59f953d2a895fdbb$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties);
        // If we are not in the middle of an HMR revalidation and we changed the
        // routes, provide a new identity and trigger a reflow via `updateState`
        // to re-run memoized `router.routes` dependencies.
        // HMR will already update the identity and reflow when it lands
        // `inFlightDataRoutes` in `completeNavigation`
        if (isNonHMR) {
            dataRoutes = [
                ...dataRoutes
            ];
            updateState({});
        }
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        deleteFetcher: deleteFetcherAndUpdateState,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        patchRoutes: patchRoutes,
        _internalFetchControllers: fetchControllers,
        _internalActiveDeferreds: activeDeferreds,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes
    };
    return router;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////
const $59f953d2a895fdbb$export$4d0306f8f6a4585b = Symbol("deferred");
function $59f953d2a895fdbb$export$3336b097a6fbc59a(routes, opts) {
    $59f953d2a895fdbb$export$3e9cee6b33872309(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let mapRouteProperties;
    if (opts != null && opts.mapRouteProperties) mapRouteProperties = opts.mapRouteProperties;
    else if (opts != null && opts.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = opts.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $59f953d2a895fdbb$var$defaultMapRouteProperties;
    // Config driven behavior flags
    let future = $59f953d2a895fdbb$var$_extends({
        v7_relativeSplatPath: false,
        v7_throwAbortReason: false
    }, opts ? opts.future : null);
    let dataRoutes = $59f953d2a895fdbb$export$4a6d22b32134ea5d(routes, mapRouteProperties, undefined, manifest);
    /**
   * The query() method is intended for document requests, in which we want to
   * call an optional action and potentially multiple loaders for all nested
   * routes.  It returns a StaticHandlerContext object, which is very similar
   * to the router state (location, loaderData, actionData, errors, etc.) and
   * also adds SSR-specific information such as the statusCode and headers
   * from action/loaders Responses.
   *
   * It _should_ never throw and should report all errors through the
   * returned context.errors object, properly associating errors to their error
   * boundary.  Additionally, it tracks _deepestRenderedBoundaryId which can be
   * used to emulate React error boundaries during SSr by performing a second
   * pass only down to the boundaryId.
   *
   * The one exception where we do not return a StaticHandlerContext is when a
   * redirect response is returned or thrown from any action/loader.  We
   * propagate that out and return the raw Response so the HTTP server can
   * return it directly.
   *
   * - `opts.requestContext` is an optional server context that will be passed
   *   to actions/loaders in the `context` parameter
   * - `opts.skipLoaderErrorBubbling` is an optional parameter that will prevent
   *   the bubbling of errors which allows single-fetch-type implementations
   *   where the client will handle the bubbling and we may need to return data
   *   for the handling route
   */ async function query(request, _temp3) {
        let { requestContext: requestContext, skipLoaderErrorBubbling: skipLoaderErrorBubbling, dataStrategy: dataStrategy } = _temp3 === void 0 ? {} : _temp3;
        let url = new URL(request.url);
        let method = request.method;
        let location = $59f953d2a895fdbb$var$createLocation("", $59f953d2a895fdbb$export$fe53371bee54353d(url), null, "default");
        let matches = $59f953d2a895fdbb$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$59f953d2a895fdbb$var$isValidMethod(method) && method !== "HEAD") {
            let error = $59f953d2a895fdbb$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $59f953d2a895fdbb$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        } else if (!matches) {
            let error = $59f953d2a895fdbb$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $59f953d2a895fdbb$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, skipLoaderErrorBubbling === true, null);
        if ($59f953d2a895fdbb$var$isResponse(result)) return result;
        // When returning StaticHandlerContext, we patch back in the location here
        // since we need it for React Context.  But this helps keep our submit and
        // loadRouteData operating on a Request instead of a Location
        return $59f953d2a895fdbb$var$_extends({
            location: location,
            basename: basename
        }, result);
    }
    /**
   * The queryRoute() method is intended for targeted route requests, either
   * for fetch ?_data requests or resource route requests.  In this case, we
   * are only ever calling a single action or loader, and we are returning the
   * returned value directly.  In most cases, this will be a Response returned
   * from the action/loader, but it may be a primitive or other value as well -
   * and in such cases the calling context should handle that accordingly.
   *
   * We do respect the throw/return differentiation, so if an action/loader
   * throws, then this method will throw the value.  This is important so we
   * can do proper boundary identification in Remix where a thrown Response
   * must go to the Catch Boundary but a returned Response is happy-path.
   *
   * One thing to note is that any Router-initiated Errors that make sense
   * to associate with a status code will be thrown as an ErrorResponse
   * instance which include the raw Error, such that the calling context can
   * serialize the error as they see fit while including the proper response
   * code.  Examples here are 404 and 405 errors that occur prior to reaching
   * any user-defined loaders.
   *
   * - `opts.routeId` allows you to specify the specific route handler to call.
   *   If not provided the handler will determine the proper route by matching
   *   against `request.url`
   * - `opts.requestContext` is an optional server context that will be passed
   *    to actions/loaders in the `context` parameter
   */ async function queryRoute(request, _temp4) {
        let { routeId: routeId, requestContext: requestContext, dataStrategy: dataStrategy } = _temp4 === void 0 ? {} : _temp4;
        let url = new URL(request.url);
        let method = request.method;
        let location = $59f953d2a895fdbb$var$createLocation("", $59f953d2a895fdbb$export$fe53371bee54353d(url), null, "default");
        let matches = $59f953d2a895fdbb$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$59f953d2a895fdbb$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $59f953d2a895fdbb$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $59f953d2a895fdbb$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $59f953d2a895fdbb$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $59f953d2a895fdbb$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) // This should never hit I don't think?
        throw $59f953d2a895fdbb$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, false, match);
        if ($59f953d2a895fdbb$var$isResponse(result)) return result;
        let error = result.errors ? Object.values(result.errors)[0] : undefined;
        if (error !== undefined) // If we got back result.errors, that means the loader/action threw
        // _something_ that wasn't a Response, but it's not guaranteed/required
        // to be an `instanceof Error` either, so we have to use throw here to
        // preserve the "error" state outside of queryImpl.
        throw error;
        // Pick off the right state value to return
        if (result.actionData) return Object.values(result.actionData)[0];
        if (result.loaderData) {
            var _result$activeDeferre;
            let data = Object.values(result.loaderData)[0];
            if ((_result$activeDeferre = result.activeDeferreds) != null && _result$activeDeferre[match.route.id]) data[$59f953d2a895fdbb$export$4d0306f8f6a4585b] = result.activeDeferreds[match.route.id];
            return data;
        }
        return undefined;
    }
    async function queryImpl(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch) {
        $59f953d2a895fdbb$export$3e9cee6b33872309(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($59f953d2a895fdbb$var$isMutationMethod(request.method.toLowerCase())) {
                let result = await submit(request, matches, routeMatch || $59f953d2a895fdbb$var$getTargetMatch(matches, location), requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch != null);
                return result;
            }
            let result = await loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch);
            return $59f953d2a895fdbb$var$isResponse(result) ? result : $59f953d2a895fdbb$var$_extends({}, result, {
                actionData: null,
                actionHeaders: {}
            });
        } catch (e) {
            // If the user threw/returned a Response in callLoaderOrAction for a
            // `queryRoute` call, we throw the `DataStrategyResult` to bail out early
            // and then return or throw the raw Response here accordingly
            if ($59f953d2a895fdbb$var$isDataStrategyResult(e) && $59f953d2a895fdbb$var$isResponse(e.result)) {
                if (e.type === $59f953d2a895fdbb$var$ResultType.error) throw e.result;
                return e.result;
            }
            // Redirects are always returned since they don't propagate to catch
            // boundaries
            if ($59f953d2a895fdbb$var$isRedirectResponse(e)) return e;
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, requestContext, dataStrategy, skipLoaderErrorBubbling, isRouteRequest) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $59f953d2a895fdbb$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: $59f953d2a895fdbb$var$ResultType.error,
                error: error
            };
        } else {
            let results = await callDataStrategy("action", request, [
                actionMatch
            ], matches, isRouteRequest, requestContext, dataStrategy);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) $59f953d2a895fdbb$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        }
        if ($59f953d2a895fdbb$var$isRedirectResult(result)) // Uhhhh - this should never happen, we should always throw these from
        // callLoaderOrAction, but the type narrowing here keeps TS happy and we
        // can get back on the "throw all redirect responses" train here should
        // this ever happen :/
        throw new Response(null, {
            status: result.response.status,
            headers: {
                Location: result.response.headers.get("Location")
            }
        });
        if ($59f953d2a895fdbb$var$isDeferredResult(result)) {
            let error = $59f953d2a895fdbb$var$getInternalRouterError(400, {
                type: "defer-action"
            });
            if (isRouteRequest) throw error;
            result = {
                type: $59f953d2a895fdbb$var$ResultType.error,
                error: error
            };
        }
        if (isRouteRequest) {
            // Note: This should only be non-Response values if we get here, since
            // isRouteRequest should throw any Response received in callLoaderOrAction
            if ($59f953d2a895fdbb$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        // Create a GET request for the loaders
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        if ($59f953d2a895fdbb$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : $59f953d2a895fdbb$var$findNearestBoundary(matches, actionMatch.route.id);
            let context = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null, [
                boundaryMatch.route.id,
                result
            ]);
            // action status codes take precedence over loader status codes
            return $59f953d2a895fdbb$var$_extends({}, context, {
                statusCode: $59f953d2a895fdbb$export$972111febbeef05b(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                actionData: null,
                actionHeaders: $59f953d2a895fdbb$var$_extends({}, result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {})
            });
        }
        let context = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null);
        return $59f953d2a895fdbb$var$_extends({}, context, {
            actionData: {
                [actionMatch.route.id]: result.data
            }
        }, result.statusCode ? {
            statusCode: result.statusCode
        } : {}, {
            actionHeaders: result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {}
        });
    }
    async function loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, pendingActionResult) {
        let isRouteRequest = routeMatch != null;
        // Short circuit if we have no loaders to run (queryRoute())
        if (isRouteRequest && !(routeMatch != null && routeMatch.route.loader) && !(routeMatch != null && routeMatch.route.lazy)) throw $59f953d2a895fdbb$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch == null ? void 0 : routeMatch.route.id
        });
        let requestMatches = routeMatch ? [
            routeMatch
        ] : pendingActionResult && $59f953d2a895fdbb$var$isErrorResult(pendingActionResult[1]) ? $59f953d2a895fdbb$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]) : matches;
        let matchesToLoad = requestMatches.filter((m)=>m.route.loader || m.route.lazy);
        // Short circuit if we have no loaders to run (query())
        if (matchesToLoad.length === 0) return {
            matches: matches,
            // Add a null for all matched routes for proper revalidation on the client
            loaderData: matches.reduce((acc, m)=>Object.assign(acc, {
                    [m.route.id]: null
                }), {}),
            errors: pendingActionResult && $59f953d2a895fdbb$var$isErrorResult(pendingActionResult[1]) ? {
                [pendingActionResult[0]]: pendingActionResult[1].error
            } : null,
            statusCode: 200,
            loaderHeaders: {},
            activeDeferreds: null
        };
        let results = await callDataStrategy("loader", request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy);
        if (request.signal.aborted) $59f953d2a895fdbb$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        // Process and commit output from loaders
        let activeDeferreds = new Map();
        let context = $59f953d2a895fdbb$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling);
        // Add a null for any non-loader matches for proper revalidation on the client
        let executedLoaders = new Set(matchesToLoad.map((match)=>match.route.id));
        matches.forEach((match)=>{
            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
        });
        return $59f953d2a895fdbb$var$_extends({}, context, {
            matches: matches,
            activeDeferreds: activeDeferreds.size > 0 ? Object.fromEntries(activeDeferreds.entries()) : null
        });
    }
    // Utility wrapper for calling dataStrategy server-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy) {
        let results = await $59f953d2a895fdbb$var$callDataStrategyImpl(dataStrategy || $59f953d2a895fdbb$var$defaultDataStrategy, type, null, request, matchesToLoad, matches, null, manifest, mapRouteProperties, requestContext);
        let dataResults = {};
        await Promise.all(matches.map(async (match)=>{
            if (!(match.route.id in results)) return;
            let result = results[match.route.id];
            if ($59f953d2a895fdbb$var$isRedirectDataStrategyResultResult(result)) {
                let response = result.result;
                // Throw redirects and let the server handle them with an HTTP redirect
                throw $59f953d2a895fdbb$var$normalizeRelativeRoutingRedirectResponse(response, request, match.route.id, matches, basename, future.v7_relativeSplatPath);
            }
            if ($59f953d2a895fdbb$var$isResponse(result.result) && isRouteRequest) // For SSR single-route requests, we want to hand Responses back
            // directly without unwrapping
            throw result;
            dataResults[match.route.id] = await $59f953d2a895fdbb$var$convertDataStrategyResultToDataResult(result);
        }));
        return dataResults;
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////
/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */ function $59f953d2a895fdbb$export$fec11da027c70692(routes, context, error) {
    let newContext = $59f953d2a895fdbb$var$_extends({}, context, {
        statusCode: $59f953d2a895fdbb$export$972111febbeef05b(error) ? error.status : 500,
        errors: {
            [context._deepestRenderedBoundaryId || routes[0].id]: error
        }
    });
    return newContext;
}
function $59f953d2a895fdbb$var$throwStaticHandlerAbortedError(request, isRouteRequest, future) {
    if (future.v7_throwAbortReason && request.signal.reason !== undefined) throw request.signal.reason;
    let method = isRouteRequest ? "queryRoute" : "query";
    throw new Error(method + "() call aborted: " + request.method + " " + request.url);
}
function $59f953d2a895fdbb$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== undefined);
}
function $59f953d2a895fdbb$var$normalizeTo(location, matches, basename, prependBasename, to, v7_relativeSplatPath, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId) {
        // Grab matches up to the calling route so our route-relative logic is
        // relative to the correct source route
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    // Resolve the relative path
    let path = $59f953d2a895fdbb$export$cae722b0cc860f13(to ? to : ".", $59f953d2a895fdbb$export$a5784978eca585fa(contextualMatches, v7_relativeSplatPath), $59f953d2a895fdbb$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    // When `to` is not specified we inherit search/hash from the current
    // location, unlike when to="." and we just inherit the path.
    // See https://github.com/remix-run/remix/issues/927
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    // Account for `?index` params when routing to the current location
    if ((to == null || to === "" || to === ".") && activeRouteMatch) {
        let nakedIndex = $59f953d2a895fdbb$var$hasNakedIndexQuery(path.search);
        if (activeRouteMatch.route.index && !nakedIndex) // Add one when we're targeting an index route
        path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
        else if (!activeRouteMatch.route.index && nakedIndex) {
            // Remove existing ones when we're not
            let params = new URLSearchParams(path.search);
            let indexValues = params.getAll("index");
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? "?" + qs : "";
        }
    }
    // If we're operating within a basename, prepend it to the pathname.  If
    // this is a root navigation, then just use the raw basename which allows
    // the basename to have full control over the presence of a trailing slash
    // on root actions
    if (prependBasename && basename !== "/") path.pathname = path.pathname === "/" ? basename : $59f953d2a895fdbb$export$86d9a7913e44197e([
        basename,
        path.pathname
    ]);
    return $59f953d2a895fdbb$export$fe53371bee54353d(path);
}
// Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params
function $59f953d2a895fdbb$var$normalizeNavigateOptions(normalizeFormMethod, isFetcher, path, opts) {
    // Return location verbatim on non-submission navigations
    if (!opts || !$59f953d2a895fdbb$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$59f953d2a895fdbb$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $59f953d2a895fdbb$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $59f953d2a895fdbb$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    // Create a Submission on non-GET navigations
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = normalizeFormMethod ? rawFormMethod.toUpperCase() : rawFormMethod.toLowerCase();
    let formAction = $59f953d2a895fdbb$var$stripHashFromPath(path);
    if (opts.body !== undefined) {
        if (opts.formEncType === "text/plain") {
            // text only support POST/PUT/PATCH/DELETE submissions
            if (!$59f953d2a895fdbb$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, _ref3)=>{
                let [name, value] = _ref3;
                return "" + acc + name + "=" + value + "\n";
            }, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: undefined,
                    json: undefined,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            // json only supports POST/PUT/PATCH/DELETE submissions
            if (!$59f953d2a895fdbb$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: undefined,
                        json: json,
                        text: undefined
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $59f953d2a895fdbb$export$3e9cee6b33872309(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $59f953d2a895fdbb$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $59f953d2a895fdbb$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $59f953d2a895fdbb$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $59f953d2a895fdbb$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: undefined,
        text: undefined
    };
    if ($59f953d2a895fdbb$var$isMutationMethod(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    // Flatten submission onto URLSearchParams for GET submissions
    let parsedPath = $59f953d2a895fdbb$export$8ccf933b0513f8d0(path);
    // On GET navigation submissions we can drop the ?index param from the
    // resulting location since all loaders will run.  But fetcher GET submissions
    // only run a single loader so we need to preserve any incoming ?index params
    if (isFetcher && parsedPath.search && $59f953d2a895fdbb$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = "?" + searchParams;
    return {
        path: $59f953d2a895fdbb$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
// Filter out all routes at/below any caught error as they aren't going to
// render so we don't need to load them
function $59f953d2a895fdbb$var$getLoaderMatchesUntilBoundary(matches, boundaryId, includeBoundary) {
    if (includeBoundary === void 0) includeBoundary = false;
    let index = matches.findIndex((m)=>m.route.id === boundaryId);
    if (index >= 0) return matches.slice(0, includeBoundary ? index + 1 : index);
    return matches;
}
function $59f953d2a895fdbb$var$getMatchesToLoad(history, state, matches, submission, location, initialHydration, skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult) {
    let actionResult = pendingActionResult ? $59f953d2a895fdbb$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : pendingActionResult[1].data : undefined;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    // Pick navigation matches that are net-new or qualify for revalidation
    let boundaryMatches = matches;
    if (initialHydration && state.errors) // On initial hydration, only consider matches up to _and including_ the boundary.
    // This is inclusive to handle cases where a server loader ran successfully,
    // a child server loader bubbled up to this route, but this route has
    // `clientLoader.hydrate` so we want to still run the `clientLoader` so that
    // we have a complete version of `loaderData`
    boundaryMatches = $59f953d2a895fdbb$var$getLoaderMatchesUntilBoundary(matches, Object.keys(state.errors)[0], true);
    else if (pendingActionResult && $59f953d2a895fdbb$var$isErrorResult(pendingActionResult[1])) // If an action threw an error, we call loaders up to, but not including the
    // boundary
    boundaryMatches = $59f953d2a895fdbb$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]);
    // Don't revalidate loaders by default after action 4xx/5xx responses
    // when the flag is enabled.  They can still opt-into revalidation via
    // `shouldRevalidate` via `actionResult`
    let actionStatus = pendingActionResult ? pendingActionResult[1].statusCode : undefined;
    let shouldSkipRevalidation = skipActionErrorRevalidation && actionStatus && actionStatus >= 400;
    let navigationMatches = boundaryMatches.filter((match, index)=>{
        let { route: route } = match;
        if (route.lazy) // We haven't loaded this route yet so we don't know if it's got a loader!
        return true;
        if (route.loader == null) return false;
        if (initialHydration) return $59f953d2a895fdbb$var$shouldLoadRouteOnHydration(route, state.loaderData, state.errors);
        // Always call the loader on new route instances and pending defer cancellations
        if ($59f953d2a895fdbb$var$isNewLoader(state.loaderData, state.matches[index], match) || cancelledDeferredRoutes.some((id)=>id === match.route.id)) return true;
        // This is the default implementation for when we revalidate.  If the route
        // provides it's own implementation, then we give them full control but
        // provide this value so they can leverage it if needed after they check
        // their own specific use cases
        let currentRouteMatch = state.matches[index];
        let nextRouteMatch = match;
        return $59f953d2a895fdbb$var$shouldRevalidateLoader(match, $59f953d2a895fdbb$var$_extends({
            currentUrl: currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl: nextUrl,
            nextParams: nextRouteMatch.params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
            isRevalidationRequired || currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
            currentUrl.search !== nextUrl.search || $59f953d2a895fdbb$var$isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        }));
    });
    // Pick fetcher.loads that need to be revalidated
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        // Don't revalidate:
        //  - on initial hydration (shouldn't be any fetchers then anyway)
        //  - if fetcher won't be present in the subsequent render
        //    - no longer matches the URL (v7_fetcherPersist=false)
        //    - was unmounted but persisted due to v7_fetcherPersist=true
        if (initialHydration || !matches.some((m)=>m.route.id === f.routeId) || deletedFetchers.has(key)) return;
        let fetcherMatches = $59f953d2a895fdbb$export$2708184779ceb39d(routesToUse, f.path, basename);
        // If the fetcher path no longer matches, push it in with null matches so
        // we can trigger a 404 in callLoadersAndMaybeResolveData.  Note this is
        // currently only a use-case for Remix HMR where the route tree can change
        // at runtime and remove a route previously loaded via a fetcher
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                controller: null
            });
            return;
        }
        // Revalidating fetchers are decoupled from the route matches since they
        // load from a static href.  They revalidate based on explicit revalidation
        // (submission, useRevalidator, or X-Remix-Revalidate)
        let fetcher = state.fetchers.get(key);
        let fetcherMatch = $59f953d2a895fdbb$var$getTargetMatch(fetcherMatches, f.path);
        let shouldRevalidate = false;
        if (fetchRedirectIds.has(key)) // Never trigger a revalidation of an actively redirecting fetcher
        shouldRevalidate = false;
        else if (cancelledFetcherLoads.has(key)) {
            // Always mark for revalidation if the fetcher was cancelled
            cancelledFetcherLoads.delete(key);
            shouldRevalidate = true;
        } else if (fetcher && fetcher.state !== "idle" && fetcher.data === undefined) // If the fetcher hasn't ever completed loading yet, then this isn't a
        // revalidation, it would just be a brand new load if an explicit
        // revalidation is required
        shouldRevalidate = isRevalidationRequired;
        else // Otherwise fall back on any user-defined shouldRevalidate, defaulting
        // to explicit revalidations only
        shouldRevalidate = $59f953d2a895fdbb$var$shouldRevalidateLoader(fetcherMatch, $59f953d2a895fdbb$var$_extends({
            currentUrl: currentUrl,
            currentParams: state.matches[state.matches.length - 1].params,
            nextUrl: nextUrl,
            nextParams: matches[matches.length - 1].params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : isRevalidationRequired
        }));
        if (shouldRevalidate) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherMatches,
            match: fetcherMatch,
            controller: new AbortController()
        });
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function $59f953d2a895fdbb$var$shouldLoadRouteOnHydration(route, loaderData, errors) {
    // We dunno if we have a loader - gotta find out!
    if (route.lazy) return true;
    // No loader, nothing to initialize
    if (!route.loader) return false;
    let hasData = loaderData != null && loaderData[route.id] !== undefined;
    let hasError = errors != null && errors[route.id] !== undefined;
    // Don't run if we error'd during SSR
    if (!hasData && hasError) return false;
    // Explicitly opting-in to running on hydration
    if (typeof route.loader === "function" && route.loader.hydrate === true) return true;
    // Otherwise, run if we're not yet initialized with anything
    return !hasData && !hasError;
}
function $59f953d2a895fdbb$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    // Handle the case that we don't have data for a re-used route, potentially
    // from a prior error or from a cancelled pending deferred
    let isMissingData = currentLoaderData[match.route.id] === undefined;
    // Always load if this is a net-new route or we don't yet have data
    return isNew || isMissingData;
}
function $59f953d2a895fdbb$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $59f953d2a895fdbb$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
function $59f953d2a895fdbb$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties) {
    var _childrenToPatch;
    let childrenToPatch;
    if (routeId) {
        let route = manifest[routeId];
        $59f953d2a895fdbb$export$3e9cee6b33872309(route, "No route found to patch children into: routeId = " + routeId);
        if (!route.children) route.children = [];
        childrenToPatch = route.children;
    } else childrenToPatch = routesToUse;
    // Don't patch in routes we already know about so that `patch` is idempotent
    // to simplify user-land code. This is useful because we re-call the
    // `patchRoutesOnNavigation` function for matched routes with params.
    let uniqueChildren = children.filter((newRoute)=>!childrenToPatch.some((existingRoute)=>$59f953d2a895fdbb$var$isSameRoute(newRoute, existingRoute)));
    let newRoutes = $59f953d2a895fdbb$export$4a6d22b32134ea5d(uniqueChildren, mapRouteProperties, [
        routeId || "_",
        "patch",
        String(((_childrenToPatch = childrenToPatch) == null ? void 0 : _childrenToPatch.length) || "0")
    ], manifest);
    childrenToPatch.push(...newRoutes);
}
function $59f953d2a895fdbb$var$isSameRoute(newRoute, existingRoute) {
    // Most optimal check is by id
    if ("id" in newRoute && "id" in existingRoute && newRoute.id === existingRoute.id) return true;
    // Second is by pathing differences
    if (!(newRoute.index === existingRoute.index && newRoute.path === existingRoute.path && newRoute.caseSensitive === existingRoute.caseSensitive)) return false;
    // Pathless layout routes are trickier since we need to check children.
    // If they have no children then they're the same as far as we can tell
    if ((!newRoute.children || newRoute.children.length === 0) && (!existingRoute.children || existingRoute.children.length === 0)) return true;
    // Otherwise, we look to see if every child in the new route is already
    // represented in the existing route's children
    return newRoute.children.every((aChild, i)=>{
        var _existingRoute$childr;
        return (_existingRoute$childr = existingRoute.children) == null ? void 0 : _existingRoute$childr.some((bChild)=>$59f953d2a895fdbb$var$isSameRoute(aChild, bChild));
    });
}
/**
 * Execute route.lazy() methods to lazily load route modules (loader, action,
 * shouldRevalidate) and update the routeManifest in place which shares objects
 * with dataRoutes so those get updated as well.
 */ async function $59f953d2a895fdbb$var$loadLazyRouteModule(route, mapRouteProperties, manifest) {
    if (!route.lazy) return;
    let lazyRoute = await route.lazy();
    // If the lazy route function was executed and removed by another parallel
    // call then we can return - first lazy() to finish wins because the return
    // value of lazy is expected to be static
    if (!route.lazy) return;
    let routeToUpdate = manifest[route.id];
    $59f953d2a895fdbb$export$3e9cee6b33872309(routeToUpdate, "No route found in manifest");
    // Update the route in place.  This should be safe because there's no way
    // we could yet be sitting on this route as we can't get there without
    // resolving lazy() first.
    //
    // This is different than the HMR "update" use-case where we may actively be
    // on the route being updated.  The main concern boils down to "does this
    // mutation affect any ongoing navigations or any current state.matches
    // values?".  If not, it should be safe to update in place.
    let routeUpdates = {};
    for(let lazyRouteProperty in lazyRoute){
        let staticRouteValue = routeToUpdate[lazyRouteProperty];
        let isPropertyStaticallyDefined = staticRouteValue !== undefined && // This property isn't static since it should always be updated based
        // on the route updates
        lazyRouteProperty !== "hasErrorBoundary";
        $59f953d2a895fdbb$export$c0e02632e14916fd(!isPropertyStaticallyDefined, 'Route "' + routeToUpdate.id + '" has a static property "' + lazyRouteProperty + '" ' + "defined but its lazy function is also returning a value for this property. " + ('The lazy route property "' + lazyRouteProperty + '" will be ignored.'));
        if (!isPropertyStaticallyDefined && !$59f953d2a895fdbb$var$immutableRouteKeys.has(lazyRouteProperty)) routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
    }
    // Mutate the route with the provided updates.  Do this first so we pass
    // the updated version to mapRouteProperties
    Object.assign(routeToUpdate, routeUpdates);
    // Mutate the `hasErrorBoundary` property on the route based on the route
    // updates and remove the `lazy` function so we don't resolve the lazy
    // route again.
    Object.assign(routeToUpdate, $59f953d2a895fdbb$var$_extends({}, mapRouteProperties(routeToUpdate), {
        lazy: undefined
    }));
}
// Default implementation of `dataStrategy` which fetches all loaders in parallel
async function $59f953d2a895fdbb$var$defaultDataStrategy(_ref4) {
    let { matches: matches } = _ref4;
    let matchesToLoad = matches.filter((m)=>m.shouldLoad);
    let results = await Promise.all(matchesToLoad.map((m)=>m.resolve()));
    return results.reduce((acc, result, i)=>Object.assign(acc, {
            [matchesToLoad[i].route.id]: result
        }), {});
}
async function $59f953d2a895fdbb$var$callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties, requestContext) {
    let loadRouteDefinitionsPromises = matches.map((m)=>m.route.lazy ? $59f953d2a895fdbb$var$loadLazyRouteModule(m.route, mapRouteProperties, manifest) : undefined);
    let dsMatches = matches.map((match, i)=>{
        let loadRoutePromise = loadRouteDefinitionsPromises[i];
        let shouldLoad = matchesToLoad.some((m)=>m.route.id === match.route.id);
        // `resolve` encapsulates route.lazy(), executing the loader/action,
        // and mapping return values/thrown errors to a `DataStrategyResult`.  Users
        // can pass a callback to take fine-grained control over the execution
        // of the loader/action
        let resolve = async (handlerOverride)=>{
            if (handlerOverride && request.method === "GET" && (match.route.lazy || match.route.loader)) shouldLoad = true;
            return shouldLoad ? $59f953d2a895fdbb$var$callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, requestContext) : Promise.resolve({
                type: $59f953d2a895fdbb$var$ResultType.data,
                result: undefined
            });
        };
        return $59f953d2a895fdbb$var$_extends({}, match, {
            shouldLoad: shouldLoad,
            resolve: resolve
        });
    });
    // Send all matches here to allow for a middleware-type implementation.
    // handler will be a no-op for unneeded routes and we filter those results
    // back out below.
    let results = await dataStrategyImpl({
        matches: dsMatches,
        request: request,
        params: matches[0].params,
        fetcherKey: fetcherKey,
        context: requestContext
    });
    // Wait for all routes to load here but 'swallow the error since we want
    // it to bubble up from the `await loadRoutePromise` in `callLoaderOrAction` -
    // called from `match.resolve()`
    try {
        await Promise.all(loadRouteDefinitionsPromises);
    } catch (e) {
    // No-op
    }
    return results;
}
// Default logic for calling a loader/action is the user has no specified a dataStrategy
async function $59f953d2a895fdbb$var$callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, staticContext) {
    let result;
    let onReject;
    let runHandler = (handler)=>{
        // Setup a promise we can race against so that abort signals short circuit
        let reject;
        // This will never resolve so safe to type it as Promise<DataStrategyResult> to
        // satisfy the function return value
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        let actualHandler = (ctx)=>{
            if (typeof handler !== "function") return Promise.reject(new Error("You cannot call the handler for a route which defines a boolean " + ('"' + type + '" [routeId: ' + match.route.id + "]")));
            return handler({
                request: request,
                params: match.params,
                context: staticContext
            }, ...ctx !== undefined ? [
                ctx
            ] : []);
        };
        let handlerPromise = (async ()=>{
            try {
                let val = await (handlerOverride ? handlerOverride((ctx)=>actualHandler(ctx)) : actualHandler());
                return {
                    type: "data",
                    result: val
                };
            } catch (e) {
                return {
                    type: "error",
                    result: e
                };
            }
        })();
        return Promise.race([
            handlerPromise,
            abortPromise
        ]);
    };
    try {
        let handler = match.route[type];
        // If we have a route.lazy promise, await that first
        if (loadRoutePromise) {
            if (handler) {
                // Run statically defined handler in parallel with lazy()
                let handlerError;
                let [value] = await Promise.all([
                    // If the handler throws, don't let it immediately bubble out,
                    // since we need to let the lazy() execution finish so we know if this
                    // route has a boundary that can handle the error
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    loadRoutePromise
                ]);
                if (handlerError !== undefined) throw handlerError;
                result = value;
            } else {
                // Load lazy route module, then run any returned handler
                await loadRoutePromise;
                handler = match.route[type];
                if (handler) // Handler still runs even if we got interrupted to maintain consistency
                // with un-abortable behavior of handler execution on non-lazy or
                // previously-lazy-loaded routes
                result = await runHandler(handler);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $59f953d2a895fdbb$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else // lazy() route has no loader to run.  Short circuit here so we don't
                // hit the invariant below that errors on returning undefined.
                return {
                    type: $59f953d2a895fdbb$var$ResultType.data,
                    result: undefined
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw $59f953d2a895fdbb$var$getInternalRouterError(404, {
                pathname: pathname
            });
        } else result = await runHandler(handler);
        $59f953d2a895fdbb$export$3e9cee6b33872309(result.result !== undefined, "You defined " + (type === "action" ? "an action" : "a loader") + " for route " + ('"' + match.route.id + "\" but didn't return anything from your `" + type + "` ") + "function. Please return a value or `null`.");
    } catch (e) {
        // We should already be catching and converting normal handler executions to
        // DataStrategyResults and returning them, so anything that throws here is an
        // unexpected error we still need to wrap
        return {
            type: $59f953d2a895fdbb$var$ResultType.error,
            result: e
        };
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    return result;
}
async function $59f953d2a895fdbb$var$convertDataStrategyResultToDataResult(dataStrategyResult) {
    let { result: result, type: type } = dataStrategyResult;
    if ($59f953d2a895fdbb$var$isResponse(result)) {
        let data;
        try {
            let contentType = result.headers.get("Content-Type");
            // Check between word boundaries instead of startsWith() due to the last
            // paragraph of https://httpwg.org/specs/rfc9110.html#field.content-type
            if (contentType && /\bapplication\/json\b/.test(contentType)) {
                if (result.body == null) data = null;
                else data = await result.json();
            } else data = await result.text();
        } catch (e) {
            return {
                type: $59f953d2a895fdbb$var$ResultType.error,
                error: e
            };
        }
        if (type === $59f953d2a895fdbb$var$ResultType.error) return {
            type: $59f953d2a895fdbb$var$ResultType.error,
            error: new $59f953d2a895fdbb$export$6c6580e81da25755(result.status, result.statusText, data),
            statusCode: result.status,
            headers: result.headers
        };
        return {
            type: $59f953d2a895fdbb$var$ResultType.data,
            data: data,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (type === $59f953d2a895fdbb$var$ResultType.error) {
        if ($59f953d2a895fdbb$export$e0163cfdf7bc9cfa(result)) {
            var _result$init2;
            if (result.data instanceof Error) {
                var _result$init;
                return {
                    type: $59f953d2a895fdbb$var$ResultType.error,
                    error: result.data,
                    statusCode: (_result$init = result.init) == null ? void 0 : _result$init.status
                };
            }
            // Convert thrown data() to ErrorResponse instances
            result = new $59f953d2a895fdbb$export$6c6580e81da25755(((_result$init2 = result.init) == null ? void 0 : _result$init2.status) || 500, undefined, result.data);
        }
        return {
            type: $59f953d2a895fdbb$var$ResultType.error,
            error: result,
            statusCode: $59f953d2a895fdbb$export$972111febbeef05b(result) ? result.status : undefined
        };
    }
    if ($59f953d2a895fdbb$export$fbcedacb60443473(result)) {
        var _result$init3, _result$init4;
        return {
            type: $59f953d2a895fdbb$var$ResultType.deferred,
            deferredData: result,
            statusCode: (_result$init3 = result.init) == null ? void 0 : _result$init3.status,
            headers: ((_result$init4 = result.init) == null ? void 0 : _result$init4.headers) && new Headers(result.init.headers)
        };
    }
    if ($59f953d2a895fdbb$export$e0163cfdf7bc9cfa(result)) {
        var _result$init5, _result$init6;
        return {
            type: $59f953d2a895fdbb$var$ResultType.data,
            data: result.data,
            statusCode: (_result$init5 = result.init) == null ? void 0 : _result$init5.status,
            headers: (_result$init6 = result.init) != null && _result$init6.headers ? new Headers(result.init.headers) : undefined
        };
    }
    return {
        type: $59f953d2a895fdbb$var$ResultType.data,
        data: result
    };
}
// Support relative routing in internal redirects
function $59f953d2a895fdbb$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, v7_relativeSplatPath) {
    let location = response.headers.get("Location");
    $59f953d2a895fdbb$export$3e9cee6b33872309(location, "Redirects returned/thrown from loaders/actions must have a Location header");
    if (!$59f953d2a895fdbb$var$ABSOLUTE_URL_REGEX.test(location)) {
        let trimmedMatches = matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1);
        location = $59f953d2a895fdbb$var$normalizeTo(new URL(request.url), trimmedMatches, basename, true, location, v7_relativeSplatPath);
        response.headers.set("Location", location);
    }
    return response;
}
function $59f953d2a895fdbb$var$normalizeRedirectLocation(location, currentUrl, basename) {
    if ($59f953d2a895fdbb$var$ABSOLUTE_URL_REGEX.test(location)) {
        // Strip off the protocol+origin for same-origin + same-basename absolute redirects
        let normalizedLocation = location;
        let url = normalizedLocation.startsWith("//") ? new URL(currentUrl.protocol + normalizedLocation) : new URL(normalizedLocation);
        let isSameBasename = $59f953d2a895fdbb$export$b69e3301ce081aa3(url.pathname, basename) != null;
        if (url.origin === currentUrl.origin && isSameBasename) return url.pathname + url.search + url.hash;
    }
    return location;
}
// Utility method for creating the Request instances for loaders/actions during
// client-side navigations and fetches.  During SSR we will always have a
// Request instance from the static handler (query/queryRoute)
function $59f953d2a895fdbb$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($59f953d2a895fdbb$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $59f953d2a895fdbb$var$isMutationMethod(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        // Didn't think we needed this but it turns out unlike other methods, patch
        // won't be properly normalized to uppercase and results in a 405 error.
        // See: https://fetch.spec.whatwg.org/#concept-method
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = $59f953d2a895fdbb$var$convertFormDataToSearchParams(submission.formData);
        else // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.formData;
    }
    return new Request(url, init);
}
function $59f953d2a895fdbb$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())// https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#converting-an-entry-list-to-a-list-of-name-value-pairs
    searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $59f953d2a895fdbb$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $59f953d2a895fdbb$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling) {
    // Fill in loaderData/errors from our loaders
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    let pendingError = pendingActionResult && $59f953d2a895fdbb$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : undefined;
    // Process loader results into state.loaderData/state.errors
    matches.forEach((match)=>{
        if (!(match.route.id in results)) return;
        let id = match.route.id;
        let result = results[id];
        $59f953d2a895fdbb$export$3e9cee6b33872309(!$59f953d2a895fdbb$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($59f953d2a895fdbb$var$isErrorResult(result)) {
            let error = result.error;
            // If we have a pending action error, we report it at the highest-route
            // that throws a loader error, and then clear it out to indicate that
            // it was consumed
            if (pendingError !== undefined) {
                error = pendingError;
                pendingError = undefined;
            }
            errors = errors || {};
            if (skipLoaderErrorBubbling) errors[id] = error;
            else {
                // Look upwards from the matched route for the closest ancestor error
                // boundary, defaulting to the root match.  Prefer higher error values
                // if lower errors bubble to the same boundary
                let boundaryMatch = $59f953d2a895fdbb$var$findNearestBoundary(matches, id);
                if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            }
            // Clear our any prior loaderData for the throwing route
            loaderData[id] = undefined;
            // Once we find our first (highest) error, we set the status code and
            // prevent deeper status codes from overriding
            if (!foundError) {
                foundError = true;
                statusCode = $59f953d2a895fdbb$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else if ($59f953d2a895fdbb$var$isDeferredResult(result)) {
            activeDeferreds.set(id, result.deferredData);
            loaderData[id] = result.deferredData.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode != null && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            loaderData[id] = result.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    // If we didn't consume the pending action error (i.e., all loaders
    // resolved), then consume it here.  Also clear out any loaderData for the
    // throwing route
    if (pendingError !== undefined && pendingActionResult) {
        errors = {
            [pendingActionResult[0]]: pendingError
        };
        loaderData[pendingActionResult[0]] = undefined;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $59f953d2a895fdbb$var$processLoaderData(state, matches, results, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds) {
    let { loaderData: loaderData, errors: errors } = $59f953d2a895fdbb$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, false // This method is only called client side so we always want to bubble
    );
    // Process results from our revalidating fetchers
    revalidatingFetchers.forEach((rf)=>{
        let { key: key, match: match, controller: controller } = rf;
        let result = fetcherResults[key];
        $59f953d2a895fdbb$export$3e9cee6b33872309(result, "Did not find corresponding fetcher result");
        // Process fetcher non-redirect errors
        if (controller && controller.signal.aborted) // Nothing to do for aborted fetchers
        return;
        else if ($59f953d2a895fdbb$var$isErrorResult(result)) {
            let boundaryMatch = $59f953d2a895fdbb$var$findNearestBoundary(state.matches, match == null ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = $59f953d2a895fdbb$var$_extends({}, errors, {
                [boundaryMatch.route.id]: result.error
            });
            state.fetchers.delete(key);
        } else if ($59f953d2a895fdbb$var$isRedirectResult(result)) // Should never get here, redirects should get processed above, but we
        // keep this to type narrow to a success result in the else
        $59f953d2a895fdbb$export$3e9cee6b33872309(false, "Unhandled fetcher revalidation redirect");
        else if ($59f953d2a895fdbb$var$isDeferredResult(result)) // Should never get here, deferred data should be awaited for fetchers
        // in resolveDeferredResults
        $59f953d2a895fdbb$export$3e9cee6b33872309(false, "Unhandled fetcher deferred data");
        else {
            let doneFetcher = $59f953d2a895fdbb$var$getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    });
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $59f953d2a895fdbb$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = $59f953d2a895fdbb$var$_extends({}, newLoaderData);
    for (let match of matches){
        let id = match.route.id;
        if (newLoaderData.hasOwnProperty(id)) {
            if (newLoaderData[id] !== undefined) mergedLoaderData[id] = newLoaderData[id];
        } else if (loaderData[id] !== undefined && match.route.loader) // Preserve existing keys not included in newLoaderData and where a loader
        // wasn't removed by HMR
        mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
function $59f953d2a895fdbb$var$getActionDataForCommit(pendingActionResult) {
    if (!pendingActionResult) return {};
    return $59f953d2a895fdbb$var$isErrorResult(pendingActionResult[1]) ? {
        // Clear out prior actionData on errors
        actionData: {}
    } : {
        actionData: {
            [pendingActionResult[0]]: pendingActionResult[1].data
        }
    };
}
// Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match
function $59f953d2a895fdbb$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $59f953d2a895fdbb$var$getShortCircuitMatches(routes) {
    // Prefer a root layout route if present, otherwise shim in a route object
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $59f953d2a895fdbb$var$getInternalRouterError(status, _temp5) {
    let { pathname: pathname, routeId: routeId, method: method, type: type, message: message } = _temp5 === void 0 ? {} : _temp5;
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = "You made a " + method + ' request to "' + pathname + '" but ' + ('did not provide a `loader` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (type === "defer-action") errorMessage = "defer() is not supported in actions";
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = 'Route "' + routeId + '" does not match URL "' + pathname + '"';
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = 'No route matches URL "' + pathname + '"';
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a " + method.toUpperCase() + ' request to "' + pathname + '" but ' + ('did not provide an `action` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (method) errorMessage = 'Invalid request method "' + method.toUpperCase() + '"';
    }
    return new $59f953d2a895fdbb$export$6c6580e81da25755(status || 500, statusText, new Error(errorMessage), true);
}
// Find any returned redirect errors, starting from the lowest match
function $59f953d2a895fdbb$var$findRedirect(results) {
    let entries = Object.entries(results);
    for(let i = entries.length - 1; i >= 0; i--){
        let [key, result] = entries[i];
        if ($59f953d2a895fdbb$var$isRedirectResult(result)) return {
            key: key,
            result: result
        };
    }
}
function $59f953d2a895fdbb$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $59f953d2a895fdbb$export$8ccf933b0513f8d0(path) : path;
    return $59f953d2a895fdbb$export$fe53371bee54353d($59f953d2a895fdbb$var$_extends({}, parsedPath, {
        hash: ""
    }));
}
function $59f953d2a895fdbb$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") // /page -> /page#hash
    return b.hash !== "";
    else if (a.hash === b.hash) // /page#hash -> /page#hash
    return true;
    else if (b.hash !== "") // /page#hash -> /page#other
    return true;
    // If the hash is removed the browser will re-perform a request to the server
    // /page#hash -> /page
    return false;
}
function $59f953d2a895fdbb$var$isDataStrategyResult(result) {
    return result != null && typeof result === "object" && "type" in result && "result" in result && (result.type === $59f953d2a895fdbb$var$ResultType.data || result.type === $59f953d2a895fdbb$var$ResultType.error);
}
function $59f953d2a895fdbb$var$isRedirectDataStrategyResultResult(result) {
    return $59f953d2a895fdbb$var$isResponse(result.result) && $59f953d2a895fdbb$var$redirectStatusCodes.has(result.result.status);
}
function $59f953d2a895fdbb$var$isDeferredResult(result) {
    return result.type === $59f953d2a895fdbb$var$ResultType.deferred;
}
function $59f953d2a895fdbb$var$isErrorResult(result) {
    return result.type === $59f953d2a895fdbb$var$ResultType.error;
}
function $59f953d2a895fdbb$var$isRedirectResult(result) {
    return (result && result.type) === $59f953d2a895fdbb$var$ResultType.redirect;
}
function $59f953d2a895fdbb$export$e0163cfdf7bc9cfa(value) {
    return typeof value === "object" && value != null && "type" in value && "data" in value && "init" in value && value.type === "DataWithResponseInit";
}
function $59f953d2a895fdbb$export$fbcedacb60443473(value) {
    let deferred = value;
    return deferred && typeof deferred === "object" && typeof deferred.data === "object" && typeof deferred.subscribe === "function" && typeof deferred.cancel === "function" && typeof deferred.resolveData === "function";
}
function $59f953d2a895fdbb$var$isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $59f953d2a895fdbb$var$isRedirectResponse(result) {
    if (!$59f953d2a895fdbb$var$isResponse(result)) return false;
    let status = result.status;
    let location = result.headers.get("Location");
    return status >= 300 && status <= 399 && location != null;
}
function $59f953d2a895fdbb$var$isValidMethod(method) {
    return $59f953d2a895fdbb$var$validRequestMethods.has(method.toLowerCase());
}
function $59f953d2a895fdbb$var$isMutationMethod(method) {
    return $59f953d2a895fdbb$var$validMutationMethods.has(method.toLowerCase());
}
async function $59f953d2a895fdbb$var$resolveNavigationDeferredResults(matches, results, signal, currentMatches, currentLoaderData) {
    let entries = Object.entries(results);
    for(let index = 0; index < entries.length; index++){
        let [routeId, result] = entries[index];
        let match = matches.find((m)=>(m == null ? void 0 : m.route.id) === routeId);
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        let currentMatch = currentMatches.find((m)=>m.route.id === match.route.id);
        let isRevalidatingLoader = currentMatch != null && !$59f953d2a895fdbb$var$isNewRouteInstance(currentMatch, match) && (currentLoaderData && currentLoaderData[match.route.id]) !== undefined;
        if ($59f953d2a895fdbb$var$isDeferredResult(result) && isRevalidatingLoader) // Note: we do not have to touch activeDeferreds here since we race them
        // against the signal in resolveDeferredData and they'll get aborted
        // there if needed
        await $59f953d2a895fdbb$var$resolveDeferredData(result, signal, false).then((result)=>{
            if (result) results[routeId] = result;
        });
    }
}
async function $59f953d2a895fdbb$var$resolveFetcherDeferredResults(matches, results, revalidatingFetchers) {
    for(let index = 0; index < revalidatingFetchers.length; index++){
        let { key: key, routeId: routeId, controller: controller } = revalidatingFetchers[index];
        let result = results[key];
        let match = matches.find((m)=>(m == null ? void 0 : m.route.id) === routeId);
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        if ($59f953d2a895fdbb$var$isDeferredResult(result)) {
            // Note: we do not have to touch activeDeferreds here since we race them
            // against the signal in resolveDeferredData and they'll get aborted
            // there if needed
            $59f953d2a895fdbb$export$3e9cee6b33872309(controller, "Expected an AbortController for revalidating fetcher deferred result");
            await $59f953d2a895fdbb$var$resolveDeferredData(result, controller.signal, true).then((result)=>{
                if (result) results[key] = result;
            });
        }
    }
}
async function $59f953d2a895fdbb$var$resolveDeferredData(result, signal, unwrap) {
    if (unwrap === void 0) unwrap = false;
    let aborted = await result.deferredData.resolveData(signal);
    if (aborted) return;
    if (unwrap) try {
        return {
            type: $59f953d2a895fdbb$var$ResultType.data,
            data: result.deferredData.unwrappedData
        };
    } catch (e) {
        // Handle any TrackedPromise._error values encountered while unwrapping
        return {
            type: $59f953d2a895fdbb$var$ResultType.error,
            error: e
        };
    }
    return {
        type: $59f953d2a895fdbb$var$ResultType.data,
        data: result.deferredData.data
    };
}
function $59f953d2a895fdbb$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function $59f953d2a895fdbb$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $59f953d2a895fdbb$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $59f953d2a895fdbb$var$hasNakedIndexQuery(search || "")) // Return the leaf index route when index is present
    return matches[matches.length - 1];
    // Otherwise grab the deepest "path contributing" match (ignoring index and
    // pathless layout routes)
    let pathMatches = $59f953d2a895fdbb$var$getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function $59f953d2a895fdbb$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: undefined,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: undefined,
        text: undefined
    };
    else if (json !== undefined) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: json,
        text: undefined
    };
}
function $59f953d2a895fdbb$var$getLoadingNavigation(location, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined
        };
        return navigation;
    }
}
function $59f953d2a895fdbb$var$getSubmittingNavigation(location, submission) {
    let navigation = {
        state: "submitting",
        location: location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $59f953d2a895fdbb$var$getLoadingFetcher(submission, data) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined,
            data: data
        };
        return fetcher;
    }
}
function $59f953d2a895fdbb$var$getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : undefined
    };
    return fetcher;
}
function $59f953d2a895fdbb$var$getDoneFetcher(data) {
    let fetcher = {
        state: "idle",
        formMethod: undefined,
        formAction: undefined,
        formEncType: undefined,
        formData: undefined,
        json: undefined,
        text: undefined,
        data: data
    };
    return fetcher;
}
function $59f953d2a895fdbb$var$restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem($59f953d2a895fdbb$var$TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch (e) {
    // no-op, use default empty object
    }
}
function $59f953d2a895fdbb$var$persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem($59f953d2a895fdbb$var$TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            $59f953d2a895fdbb$export$c0e02632e14916fd(false, "Failed to save applied view transitions in sessionStorage (" + error + ").");
        }
    }
}

});

parcelRegister("lairn", function(module, exports) {

$parcel$export(module.exports, "UNSAFE_DataRouterContext", function () { return $f688d60f0daea755$export$3add0d5dce533e2e; });
$parcel$export(module.exports, "UNSAFE_DataRouterStateContext", function () { return $f688d60f0daea755$export$145dfa71566a64dc; });
$parcel$export(module.exports, "UNSAFE_NavigationContext", function () { return $f688d60f0daea755$export$26749e8557646306; });
$parcel$export(module.exports, "UNSAFE_RouteContext", function () { return $f688d60f0daea755$export$9072aa6dd1f93057; });
$parcel$export(module.exports, "useHref", function () { return $f688d60f0daea755$export$b66bb29c5006f12f; });
$parcel$export(module.exports, "useResolvedPath", function () { return $f688d60f0daea755$export$e75d2a2d1b3c245b; });
$parcel$export(module.exports, "useLocation", function () { return $f688d60f0daea755$export$45d76561a5302f2b; });
$parcel$export(module.exports, "useNavigate", function () { return $f688d60f0daea755$export$9770f232ac06a008; });
$parcel$export(module.exports, "UNSAFE_useRoutesImpl", function () { return $f688d60f0daea755$export$5fcee62552a12fbf; });
$parcel$export(module.exports, "UNSAFE_useRouteId", function () { return $f688d60f0daea755$export$5fc8298006ad9e58; });
$parcel$export(module.exports, "useNavigation", function () { return $f688d60f0daea755$export$d0fd4b7106de2769; });
$parcel$export(module.exports, "useMatches", function () { return $f688d60f0daea755$export$2378eb7f5ff86053; });
$parcel$export(module.exports, "useBlocker", function () { return $f688d60f0daea755$export$b273b3273281a049; });
$parcel$export(module.exports, "UNSAFE_logV6DeprecationWarnings", function () { return $f688d60f0daea755$export$db5148ec97d6af7a; });
$parcel$export(module.exports, "Router", function () { return $f688d60f0daea755$export$55185c17a0fcbe46; });
$parcel$export(module.exports, "Navigate", function () { return $f688d60f0daea755$export$444b3ab0cb9aec40; });
$parcel$export(module.exports, "Route", function () { return $f688d60f0daea755$export$e7b0ac011bb776c6; });
$parcel$export(module.exports, "Routes", function () { return $f688d60f0daea755$export$3565eb3d00ca5a74; });
$parcel$export(module.exports, "UNSAFE_mapRouteProperties", function () { return $f688d60f0daea755$export$52b333d321859367; });
/**
 * React Router v6.28.2
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $dAx5m = parcelRequire("dAx5m");

var $7IVBD = parcelRequire("7IVBD");
function $f688d60f0daea755$var$_extends() {
    $f688d60f0daea755$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $f688d60f0daea755$var$_extends.apply(this, arguments);
}
// Create react-specific types from the agnostic types in @remix-run/router to
// export from react-router
const $f688d60f0daea755$export$3add0d5dce533e2e = /*#__PURE__*/ $dAx5m.createContext(null);
const $f688d60f0daea755$export$145dfa71566a64dc = /*#__PURE__*/ $dAx5m.createContext(null);
const $f688d60f0daea755$var$AwaitContext = /*#__PURE__*/ $dAx5m.createContext(null);
/**
 * A Navigator is a "location changer"; it's how you get to different locations.
 *
 * Every history instance conforms to the Navigator interface, but the
 * distinction is useful primarily when it comes to the low-level `<Router>` API
 * where both the location and a navigator must be provided separately in order
 * to avoid "tearing" that may occur in a suspense-enabled app if the action
 * and/or location were to be read directly from the history instance.
 */ const $f688d60f0daea755$export$26749e8557646306 = /*#__PURE__*/ $dAx5m.createContext(null);
const $f688d60f0daea755$export$c7914228fb69b0f5 = /*#__PURE__*/ $dAx5m.createContext(null);
const $f688d60f0daea755$export$9072aa6dd1f93057 = /*#__PURE__*/ $dAx5m.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
const $f688d60f0daea755$var$RouteErrorContext = /*#__PURE__*/ $dAx5m.createContext(null);
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/v6/hooks/use-href
 */ function $f688d60f0daea755$export$b66bb29c5006f12f(to, _temp) {
    let { relative: relative } = _temp === void 0 ? {} : _temp;
    !$f688d60f0daea755$export$9c954a9d03d32f4a() && (0, $7IVBD.UNSAFE_invariant)(false);
    let { basename: basename, navigator: navigator } = $dAx5m.useContext($f688d60f0daea755$export$26749e8557646306);
    let { hash: hash, pathname: pathname, search: search } = $f688d60f0daea755$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the href.  If this is a root navigation, then just use the raw
    // basename which allows the basename to have full control over the presence
    // of a trailing slash on root links
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, $7IVBD.joinPaths)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
/**
 * Returns true if this component is a descendant of a `<Router>`.
 *
 * @see https://reactrouter.com/v6/hooks/use-in-router-context
 */ function $f688d60f0daea755$export$9c954a9d03d32f4a() {
    return $dAx5m.useContext($f688d60f0daea755$export$c7914228fb69b0f5) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/v6/hooks/use-location
 */ function $f688d60f0daea755$export$45d76561a5302f2b() {
    !$f688d60f0daea755$export$9c954a9d03d32f4a() && (0, $7IVBD.UNSAFE_invariant)(false);
    return $dAx5m.useContext($f688d60f0daea755$export$c7914228fb69b0f5).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/v6/hooks/use-navigation-type
 */ function $f688d60f0daea755$export$1b3f31771c5d07c() {
    return $dAx5m.useContext($f688d60f0daea755$export$c7914228fb69b0f5).navigationType;
}
/**
 * Returns a PathMatch object if the given pattern matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * `<NavLink>`.
 *
 * @see https://reactrouter.com/v6/hooks/use-match
 */ function $f688d60f0daea755$export$6c330e8992e8a295(pattern) {
    !$f688d60f0daea755$export$9c954a9d03d32f4a() && (0, $7IVBD.UNSAFE_invariant)(false);
    let { pathname: pathname } = $f688d60f0daea755$export$45d76561a5302f2b();
    return $dAx5m.useMemo(()=>(0, $7IVBD.matchPath)(pattern, (0, $7IVBD.UNSAFE_decodePath)(pathname)), [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ const $f688d60f0daea755$var$navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
// Mute warnings for calls to useNavigate in SSR environments
function $f688d60f0daea755$var$useIsomorphicLayoutEffect(cb) {
    let isStatic = $dAx5m.useContext($f688d60f0daea755$export$26749e8557646306).static;
    if (!isStatic) // We should be able to get rid of this once react 18.3 is released
    // See: https://github.com/facebook/react/pull/26395
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $dAx5m.useLayoutEffect(cb);
}
/**
 * Returns an imperative method for changing the location. Used by `<Link>`s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/v6/hooks/use-navigate
 */ function $f688d60f0daea755$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute } = $dAx5m.useContext($f688d60f0daea755$export$9072aa6dd1f93057);
    // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return isDataRoute ? $f688d60f0daea755$var$useNavigateStable() : $f688d60f0daea755$var$useNavigateUnstable();
}
function $f688d60f0daea755$var$useNavigateUnstable() {
    !$f688d60f0daea755$export$9c954a9d03d32f4a() && (0, $7IVBD.UNSAFE_invariant)(false);
    let dataRouterContext = $dAx5m.useContext($f688d60f0daea755$export$3add0d5dce533e2e);
    let { basename: basename, future: future, navigator: navigator } = $dAx5m.useContext($f688d60f0daea755$export$26749e8557646306);
    let { matches: matches } = $dAx5m.useContext($f688d60f0daea755$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $f688d60f0daea755$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $7IVBD.UNSAFE_getResolveToMatches)(matches, future.v7_relativeSplatPath));
    let activeRef = $dAx5m.useRef(false);
    $f688d60f0daea755$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $dAx5m.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our history listener yet
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = (0, $7IVBD.resolveTo)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        // If we're operating within a basename, prepend it to the pathname prior
        // to handing off to history (but only if we're not in a data router,
        // otherwise it'll prepend the basename inside of the router).
        // If this is a root navigation, then we navigate to the raw basename
        // which allows the basename to have full control over the presence of a
        // trailing slash on root links
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $7IVBD.joinPaths)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
const $f688d60f0daea755$var$OutletContext = /*#__PURE__*/ $dAx5m.createContext(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/v6/hooks/use-outlet-context
 */ function $f688d60f0daea755$export$4138103a3ae699cc() {
    return $dAx5m.useContext($f688d60f0daea755$var$OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by `<Outlet>` to render child routes.
 *
 * @see https://reactrouter.com/v6/hooks/use-outlet
 */ function $f688d60f0daea755$export$a3be3530d8e40d0b(context) {
    let outlet = $dAx5m.useContext($f688d60f0daea755$export$9072aa6dd1f93057).outlet;
    if (outlet) return /*#__PURE__*/ $dAx5m.createElement($f688d60f0daea755$var$OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/v6/hooks/use-params
 */ function $f688d60f0daea755$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $dAx5m.useContext($f688d60f0daea755$export$9072aa6dd1f93057);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/v6/hooks/use-resolved-path
 */ function $f688d60f0daea755$export$e75d2a2d1b3c245b(to, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { future: future } = $dAx5m.useContext($f688d60f0daea755$export$26749e8557646306);
    let { matches: matches } = $dAx5m.useContext($f688d60f0daea755$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $f688d60f0daea755$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $7IVBD.UNSAFE_getResolveToMatches)(matches, future.v7_relativeSplatPath));
    return $dAx5m.useMemo(()=>(0, $7IVBD.resolveTo)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an `<Outlet>` to render their child route's
 * element.
 *
 * @see https://reactrouter.com/v6/hooks/use-routes
 */ function $f688d60f0daea755$export$5d3fca4a98652595(routes, locationArg) {
    return $f688d60f0daea755$export$5fcee62552a12fbf(routes, locationArg);
}
// Internal implementation with accept optional param for RouterProvider usage
function $f688d60f0daea755$export$5fcee62552a12fbf(routes, locationArg, dataRouterState, future) {
    !$f688d60f0daea755$export$9c954a9d03d32f4a() && (0, $7IVBD.UNSAFE_invariant)(false);
    let { navigator: navigator } = $dAx5m.useContext($f688d60f0daea755$export$26749e8557646306);
    let { matches: parentMatches } = $dAx5m.useContext($f688d60f0daea755$export$9072aa6dd1f93057);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    let locationFromContext = $f688d60f0daea755$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        let parsedLocationArg = typeof locationArg === "string" ? (0, $7IVBD.parsePath)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && (0, $7IVBD.UNSAFE_invariant)(false);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = pathname;
    if (parentPathnameBase !== "/") {
        // Determine the remaining pathname by removing the # of URL segments the
        // parentPathnameBase has, instead of removing based on character count.
        // This is because we can't guarantee that incoming/outgoing encodings/
        // decodings will match exactly.
        // We decode paths before matching on a per-segment basis with
        // decodeURIComponent(), but we re-encode pathnames via `new URL()` so they
        // match what `window.location.pathname` would reflect.  Those don't 100%
        // align when it comes to encoded URI characters such as % and &.
        //
        // So we may end up with:
        //   pathname:           "/descendant/a%25b/match"
        //   parentPathnameBase: "/descendant/a%b"
        //
        // And the direct substring removal approach won't work :/
        let parentSegments = parentPathnameBase.replace(/^\//, "").split("/");
        let segments = pathname.replace(/^\//, "").split("/");
        remainingPathname = "/" + segments.slice(parentSegments.length).join("/");
    }
    let matches = (0, $7IVBD.matchRoutes)(routes, {
        pathname: remainingPathname
    });
    let renderedMatches = $f688d60f0daea755$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, $7IVBD.joinPaths)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, $7IVBD.joinPaths)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterState, future);
    // When a user passes in a `locationArg`, the associated routes need to
    // be wrapped in a new `LocationContext.Provider` in order for `useLocation`
    // to use the scoped location instead of the global location.
    if (locationArg && renderedMatches) return /*#__PURE__*/ $dAx5m.createElement($f688d60f0daea755$export$c7914228fb69b0f5.Provider, {
        value: {
            location: $f688d60f0daea755$var$_extends({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: (0, $7IVBD.Action).Pop
        }
    }, renderedMatches);
    return renderedMatches;
}
function $f688d60f0daea755$var$DefaultErrorComponent() {
    let error = $f688d60f0daea755$export$ed527bf60f6e05f2();
    let message = (0, $7IVBD.isRouteErrorResponse)(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    return /*#__PURE__*/ $dAx5m.createElement($dAx5m.Fragment, null, /*#__PURE__*/ $dAx5m.createElement("h2", null, "Unexpected Application Error!"), /*#__PURE__*/ $dAx5m.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /*#__PURE__*/ $dAx5m.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
const $f688d60f0daea755$var$defaultErrorElement = /*#__PURE__*/ $dAx5m.createElement($f688d60f0daea755$var$DefaultErrorComponent, null);
class $f688d60f0daea755$var$RenderErrorBoundary extends $dAx5m.Component {
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        // When we get into an error state, the user will likely click "back" to the
        // previous page that didn't have an error. Because this wraps the entire
        // application, that will have no effect--the error page continues to display.
        // This gives us a mechanism to recover from the error when the location changes.
        //
        // Whether we're in an error state or not, we update the location in state
        // so that when we are in an error state, it gets reset when a new location
        // comes in and the user recovers from the error.
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        // If we're not changing locations, preserve the location but still surface
        // any new errors that may come through. We retain the existing error, we do
        // this because the error provided from the app state may be cleared without
        // the location changing.
        return {
            error: props.error !== undefined ? props.error : state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("React Router caught the following error during render", error, errorInfo);
    }
    render() {
        return this.state.error !== undefined ? /*#__PURE__*/ $dAx5m.createElement($f688d60f0daea755$export$9072aa6dd1f93057.Provider, {
            value: this.props.routeContext
        }, /*#__PURE__*/ $dAx5m.createElement($f688d60f0daea755$var$RouteErrorContext.Provider, {
            value: this.state.error,
            children: this.props.component
        })) : this.props.children;
    }
}
function $f688d60f0daea755$var$RenderedRoute(_ref) {
    let { routeContext: routeContext, match: match, children: children } = _ref;
    let dataRouterContext = $dAx5m.useContext($f688d60f0daea755$export$3add0d5dce533e2e);
    // Track how deep we got in our render pass to emulate SSR componentDidCatch
    // in a DataStaticRouter
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /*#__PURE__*/ $dAx5m.createElement($f688d60f0daea755$export$9072aa6dd1f93057.Provider, {
        value: routeContext
    }, children);
}
function $f688d60f0daea755$var$_renderMatches(matches, parentMatches, dataRouterState, future) {
    var _dataRouterState;
    if (parentMatches === void 0) parentMatches = [];
    if (dataRouterState === void 0) dataRouterState = null;
    if (future === void 0) future = null;
    if (matches == null) {
        var _future;
        if (!dataRouterState) return null;
        if (dataRouterState.errors) // Don't bail if we have data router errors so we can render them in the
        // boundary.  Use the pre-matched (or shimmed) matches
        matches = dataRouterState.matches;
        else if ((_future = future) != null && _future.v7_partialHydration && parentMatches.length === 0 && !dataRouterState.initialized && dataRouterState.matches.length > 0) // Don't bail if we're initializing with partial hydration and we have
        // router matches.  That means we're actively running `patchRoutesOnNavigation`
        // so we should render down the partial matches to the appropriate
        // `HydrateFallback`.  We only do this if `parentMatches` is empty so it
        // only impacts the root matches for `RouterProvider` and no descendant
        // `<Routes>`
        matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    // If we have data errors, trim matches to the highest error boundary
    let errors = (_dataRouterState = dataRouterState) == null ? void 0 : _dataRouterState.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && (errors == null ? void 0 : errors[m.route.id]) !== undefined);
        !(errorIndex >= 0) && (0, $7IVBD.UNSAFE_invariant)(false);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    // If we're in a partial hydration mode, detect if we need to render down to
    // a given HydrateFallback while we load the rest of the hydration data
    let renderFallback = false;
    let fallbackIndex = -1;
    if (dataRouterState && future && future.v7_partialHydration) for(let i = 0; i < renderedMatches.length; i++){
        let match = renderedMatches[i];
        // Track the deepest fallback up until the first route without data
        if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
        if (match.route.id) {
            let { loaderData: loaderData, errors: errors } = dataRouterState;
            let needsToRunLoader = match.route.loader && loaderData[match.route.id] === undefined && (!errors || errors[match.route.id] === undefined);
            if (match.route.lazy || needsToRunLoader) {
                // We found the first route that's not ready to render (waiting on
                // lazy, or has a loader that hasn't run yet).  Flag that we need to
                // render a fallback and render up until the appropriate fallback
                renderFallback = true;
                if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                else renderedMatches = [
                    renderedMatches[0]
                ];
                break;
            }
        }
    }
    return renderedMatches.reduceRight((outlet, match, index)=>{
        // Only data routers handle errors/fallbacks
        let error;
        let shouldRenderHydrateFallback = false;
        let errorElement = null;
        let hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : undefined;
            errorElement = match.route.errorElement || $f688d60f0daea755$var$defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    $f688d60f0daea755$var$warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        let matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) // Note: This is a de-optimized path since React won't re-use the
            // ReactElement since it's identity changes with each new
            // React.createElement call.  We keep this so folks can use
            // `<Route Component={...}>` in `<Routes>` but generally `Component`
            // usage is only advised in `RouterProvider` when we can convert it to
            // `element` ahead of time.
            children = /*#__PURE__*/ $dAx5m.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /*#__PURE__*/ $dAx5m.createElement($f688d60f0daea755$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        // Only wrap in an error boundary within data router usages when we have an
        // ErrorBoundary/errorElement on this route.  Otherwise let it bubble up to
        // an ancestor ErrorBoundary/errorElement
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /*#__PURE__*/ $dAx5m.createElement($f688d60f0daea755$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches,
                isDataRoute: true
            }
        }) : getChildren();
    }, null);
}
var $f688d60f0daea755$var$DataRouterHook = /*#__PURE__*/ function(DataRouterHook) {
    DataRouterHook["UseBlocker"] = "useBlocker";
    DataRouterHook["UseRevalidator"] = "useRevalidator";
    DataRouterHook["UseNavigateStable"] = "useNavigate";
    return DataRouterHook;
}($f688d60f0daea755$var$DataRouterHook || {});
var $f688d60f0daea755$var$DataRouterStateHook = /*#__PURE__*/ function(DataRouterStateHook) {
    DataRouterStateHook["UseBlocker"] = "useBlocker";
    DataRouterStateHook["UseLoaderData"] = "useLoaderData";
    DataRouterStateHook["UseActionData"] = "useActionData";
    DataRouterStateHook["UseRouteError"] = "useRouteError";
    DataRouterStateHook["UseNavigation"] = "useNavigation";
    DataRouterStateHook["UseRouteLoaderData"] = "useRouteLoaderData";
    DataRouterStateHook["UseMatches"] = "useMatches";
    DataRouterStateHook["UseRevalidator"] = "useRevalidator";
    DataRouterStateHook["UseNavigateStable"] = "useNavigate";
    DataRouterStateHook["UseRouteId"] = "useRouteId";
    return DataRouterStateHook;
}($f688d60f0daea755$var$DataRouterStateHook || {});
function $f688d60f0daea755$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/v6/routers/picking-a-router.";
}
function $f688d60f0daea755$var$useDataRouterContext(hookName) {
    let ctx = $dAx5m.useContext($f688d60f0daea755$export$3add0d5dce533e2e);
    !ctx && (0, $7IVBD.UNSAFE_invariant)(false);
    return ctx;
}
function $f688d60f0daea755$var$useDataRouterState(hookName) {
    let state = $dAx5m.useContext($f688d60f0daea755$export$145dfa71566a64dc);
    !state && (0, $7IVBD.UNSAFE_invariant)(false);
    return state;
}
function $f688d60f0daea755$var$useRouteContext(hookName) {
    let route = $dAx5m.useContext($f688d60f0daea755$export$9072aa6dd1f93057);
    !route && (0, $7IVBD.UNSAFE_invariant)(false);
    return route;
}
// Internal version with hookName-aware debugging
function $f688d60f0daea755$var$useCurrentRouteId(hookName) {
    let route = $f688d60f0daea755$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    !thisRoute.route.id && (0, $7IVBD.UNSAFE_invariant)(false);
    return thisRoute.route.id;
}
/**
 * Returns the ID for the nearest contextual route
 */ function $f688d60f0daea755$export$5fc8298006ad9e58() {
    return $f688d60f0daea755$var$useCurrentRouteId($f688d60f0daea755$var$DataRouterStateHook.UseRouteId);
}
/**
 * Returns the current navigation, defaulting to an "idle" navigation when
 * no navigation is in progress
 */ function $f688d60f0daea755$export$d0fd4b7106de2769() {
    let state = $f688d60f0daea755$var$useDataRouterState($f688d60f0daea755$var$DataRouterStateHook.UseNavigation);
    return state.navigation;
}
/**
 * Returns a revalidate function for manually triggering revalidation, as well
 * as the current state of any manual revalidations
 */ function $f688d60f0daea755$export$600dc272ed516c15() {
    let dataRouterContext = $f688d60f0daea755$var$useDataRouterContext($f688d60f0daea755$var$DataRouterHook.UseRevalidator);
    let state = $f688d60f0daea755$var$useDataRouterState($f688d60f0daea755$var$DataRouterStateHook.UseRevalidator);
    return $dAx5m.useMemo(()=>({
            revalidate: dataRouterContext.router.revalidate,
            state: state.revalidation
        }), [
        dataRouterContext.router.revalidate,
        state.revalidation
    ]);
}
/**
 * Returns the active route matches, useful for accessing loaderData for
 * parent/child routes or the route "handle" property
 */ function $f688d60f0daea755$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $f688d60f0daea755$var$useDataRouterState($f688d60f0daea755$var$DataRouterStateHook.UseMatches);
    return $dAx5m.useMemo(()=>matches.map((m)=>(0, $7IVBD.UNSAFE_convertRouteMatchToUiMatch)(m, loaderData)), [
        matches,
        loaderData
    ]);
}
/**
 * Returns the loader data for the nearest ancestor Route loader
 */ function $f688d60f0daea755$export$1448a5050d252c4d() {
    let state = $f688d60f0daea755$var$useDataRouterState($f688d60f0daea755$var$DataRouterStateHook.UseLoaderData);
    let routeId = $f688d60f0daea755$var$useCurrentRouteId($f688d60f0daea755$var$DataRouterStateHook.UseLoaderData);
    if (state.errors && state.errors[routeId] != null) {
        console.error("You cannot `useLoaderData` in an errorElement (routeId: " + routeId + ")");
        return undefined;
    }
    return state.loaderData[routeId];
}
/**
 * Returns the loaderData for the given routeId
 */ function $f688d60f0daea755$export$fd5d37484eab868d(routeId) {
    let state = $f688d60f0daea755$var$useDataRouterState($f688d60f0daea755$var$DataRouterStateHook.UseRouteLoaderData);
    return state.loaderData[routeId];
}
/**
 * Returns the action data for the nearest ancestor Route action
 */ function $f688d60f0daea755$export$fdc00f3f26066d5e() {
    let state = $f688d60f0daea755$var$useDataRouterState($f688d60f0daea755$var$DataRouterStateHook.UseActionData);
    let routeId = $f688d60f0daea755$var$useCurrentRouteId($f688d60f0daea755$var$DataRouterStateHook.UseLoaderData);
    return state.actionData ? state.actionData[routeId] : undefined;
}
/**
 * Returns the nearest ancestor Route error, which could be a loader/action
 * error or a render error.  This is intended to be called from your
 * ErrorBoundary/errorElement to display a proper error message.
 */ function $f688d60f0daea755$export$ed527bf60f6e05f2() {
    var _state$errors;
    let error = $dAx5m.useContext($f688d60f0daea755$var$RouteErrorContext);
    let state = $f688d60f0daea755$var$useDataRouterState($f688d60f0daea755$var$DataRouterStateHook.UseRouteError);
    let routeId = $f688d60f0daea755$var$useCurrentRouteId($f688d60f0daea755$var$DataRouterStateHook.UseRouteError);
    // If this was a render error, we put it in a RouteError context inside
    // of RenderErrorBoundary
    if (error !== undefined) return error;
    // Otherwise look for errors from our data router state
    return (_state$errors = state.errors) == null ? void 0 : _state$errors[routeId];
}
/**
 * Returns the happy-path data from the nearest ancestor `<Await />` value
 */ function $f688d60f0daea755$export$78a72ddb39bdd145() {
    let value = $dAx5m.useContext($f688d60f0daea755$var$AwaitContext);
    return value == null ? void 0 : value._data;
}
/**
 * Returns the error from the nearest ancestor `<Await />` value
 */ function $f688d60f0daea755$export$17f53340677d5831() {
    let value = $dAx5m.useContext($f688d60f0daea755$var$AwaitContext);
    return value == null ? void 0 : value._error;
}
let $f688d60f0daea755$var$blockerId = 0;
/**
 * Allow the application to block navigations within the SPA and present the
 * user a confirmation dialog to confirm the navigation.  Mostly used to avoid
 * using half-filled form data.  This does not handle hard-reloads or
 * cross-origin navigations.
 */ function $f688d60f0daea755$export$b273b3273281a049(shouldBlock) {
    let { router: router, basename: basename } = $f688d60f0daea755$var$useDataRouterContext($f688d60f0daea755$var$DataRouterHook.UseBlocker);
    let state = $f688d60f0daea755$var$useDataRouterState($f688d60f0daea755$var$DataRouterStateHook.UseBlocker);
    let [blockerKey, setBlockerKey] = $dAx5m.useState("");
    let blockerFunction = $dAx5m.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        // If they provided us a function and we've got an active basename, strip
        // it from the locations we expose to the user to match the behavior of
        // useLocation
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: $f688d60f0daea755$var$_extends({}, currentLocation, {
                pathname: (0, $7IVBD.stripBasename)(currentLocation.pathname, basename) || currentLocation.pathname
            }),
            nextLocation: $f688d60f0daea755$var$_extends({}, nextLocation, {
                pathname: (0, $7IVBD.stripBasename)(nextLocation.pathname, basename) || nextLocation.pathname
            }),
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    // This effect is in charge of blocker key assignment and deletion (which is
    // tightly coupled to the key)
    $dAx5m.useEffect(()=>{
        let key = String(++$f688d60f0daea755$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    // This effect handles assigning the blockerFunction.  This is to handle
    // unstable blocker function identities, and happens only after the prior
    // effect so we don't get an orphaned blockerFunction in the router with a
    // key of "".  Until then we just have the IDLE_BLOCKER.
    $dAx5m.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    // Prefer the blocker from `state` not `router.state` since DataRouterContext
    // is memoized so this ensures we update on blocker state updates
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : (0, $7IVBD.IDLE_BLOCKER);
}
/**
 * Stable version of useNavigate that is used when we are in the context of
 * a RouterProvider.
 */ function $f688d60f0daea755$var$useNavigateStable() {
    let { router: router } = $f688d60f0daea755$var$useDataRouterContext($f688d60f0daea755$var$DataRouterHook.UseNavigateStable);
    let id = $f688d60f0daea755$var$useCurrentRouteId($f688d60f0daea755$var$DataRouterStateHook.UseNavigateStable);
    let activeRef = $dAx5m.useRef(false);
    $f688d60f0daea755$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $dAx5m.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our router subscriber yet
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else router.navigate(to, $f688d60f0daea755$var$_extends({
            fromRouteId: id
        }, options));
    }, [
        router,
        id
    ]);
    return navigate;
}
const $f688d60f0daea755$var$alreadyWarned$1 = {};
function $f688d60f0daea755$var$warningOnce(key, cond, message) {
    if (!cond && !$f688d60f0daea755$var$alreadyWarned$1[key]) $f688d60f0daea755$var$alreadyWarned$1[key] = true;
}
const $f688d60f0daea755$var$alreadyWarned = {};
function $f688d60f0daea755$var$warnOnce(key, message) {
    if (!$f688d60f0daea755$var$alreadyWarned[message]) {
        $f688d60f0daea755$var$alreadyWarned[message] = true;
        console.warn(message);
    }
}
const $f688d60f0daea755$var$logDeprecation = (flag, msg, link)=>$f688d60f0daea755$var$warnOnce(flag, "\u26A0\uFE0F React Router Future Flag Warning: " + msg + ". " + ("You can use the `" + flag + "` future flag to opt-in early. ") + ("For more information, see " + link + "."));
function $f688d60f0daea755$export$db5148ec97d6af7a(renderFuture, routerFuture) {
    if ((renderFuture == null ? void 0 : renderFuture.v7_startTransition) === undefined) $f688d60f0daea755$var$logDeprecation("v7_startTransition", "React Router will begin wrapping state updates in `React.startTransition` in v7", "https://reactrouter.com/v6/upgrading/future#v7_starttransition");
    if ((renderFuture == null ? void 0 : renderFuture.v7_relativeSplatPath) === undefined && (!routerFuture || !routerFuture.v7_relativeSplatPath)) $f688d60f0daea755$var$logDeprecation("v7_relativeSplatPath", "Relative route resolution within Splat routes is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_relativesplatpath");
    if (routerFuture) {
        if (routerFuture.v7_fetcherPersist === undefined) $f688d60f0daea755$var$logDeprecation("v7_fetcherPersist", "The persistence behavior of fetchers is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_fetcherpersist");
        if (routerFuture.v7_normalizeFormMethod === undefined) $f688d60f0daea755$var$logDeprecation("v7_normalizeFormMethod", "Casing of `formMethod` fields is being normalized to uppercase in v7", "https://reactrouter.com/v6/upgrading/future#v7_normalizeformmethod");
        if (routerFuture.v7_partialHydration === undefined) $f688d60f0daea755$var$logDeprecation("v7_partialHydration", "`RouterProvider` hydration behavior is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_partialhydration");
        if (routerFuture.v7_skipActionErrorRevalidation === undefined) $f688d60f0daea755$var$logDeprecation("v7_skipActionErrorRevalidation", "The revalidation behavior after 4xx/5xx `action` responses is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_skipactionerrorrevalidation");
    }
}
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $f688d60f0daea755$var$START_TRANSITION = "startTransition";
const $f688d60f0daea755$var$startTransitionImpl = $dAx5m[$f688d60f0daea755$var$START_TRANSITION];
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $f688d60f0daea755$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $dAx5m.useState(router.state);
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $dAx5m.useCallback((newState)=>{
        if (v7_startTransition && $f688d60f0daea755$var$startTransitionImpl) $f688d60f0daea755$var$startTransitionImpl(()=>setStateImpl(newState));
        else setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $dAx5m.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    $dAx5m.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $dAx5m.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $dAx5m.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    $dAx5m.useEffect(()=>$f688d60f0daea755$export$db5148ec97d6af7a(future, router.future), [
        router,
        future
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $dAx5m.createElement($dAx5m.Fragment, null, /*#__PURE__*/ $dAx5m.createElement($f688d60f0daea755$export$3add0d5dce533e2e.Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $dAx5m.createElement($f688d60f0daea755$export$145dfa71566a64dc.Provider, {
        value: state
    }, /*#__PURE__*/ $dAx5m.createElement($f688d60f0daea755$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $dAx5m.createElement($f688d60f0daea755$var$DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))), null);
}
function $f688d60f0daea755$var$DataRoutes(_ref2) {
    let { routes: routes, future: future, state: state } = _ref2;
    return $f688d60f0daea755$export$5fcee62552a12fbf(routes, undefined, state, future);
}
/**
 * A `<Router>` that stores all entries in memory.
 *
 * @see https://reactrouter.com/v6/router-components/memory-router
 */ function $f688d60f0daea755$export$ae46f04cfaffe093(_ref3) {
    let { basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex, future: future } = _ref3;
    let historyRef = $dAx5m.useRef();
    if (historyRef.current == null) historyRef.current = (0, $7IVBD.createMemoryHistory)({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $dAx5m.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $dAx5m.useCallback((newState)=>{
        v7_startTransition && $f688d60f0daea755$var$startTransitionImpl ? $f688d60f0daea755$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $dAx5m.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $dAx5m.useEffect(()=>$f688d60f0daea755$export$db5148ec97d6af7a(future), [
        future
    ]);
    return /*#__PURE__*/ $dAx5m.createElement($f688d60f0daea755$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/v6/components/navigate
 */ function $f688d60f0daea755$export$444b3ab0cb9aec40(_ref4) {
    let { to: to, replace: replace, state: state, relative: relative } = _ref4;
    !$f688d60f0daea755$export$9c954a9d03d32f4a() && (0, $7IVBD.UNSAFE_invariant)(false);
    let { future: future, static: isStatic } = $dAx5m.useContext($f688d60f0daea755$export$26749e8557646306);
    let { matches: matches } = $dAx5m.useContext($f688d60f0daea755$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $f688d60f0daea755$export$45d76561a5302f2b();
    let navigate = $f688d60f0daea755$export$9770f232ac06a008();
    // Resolve the path outside of the effect so that when effects run twice in
    // StrictMode they navigate to the same place
    let path = (0, $7IVBD.resolveTo)(to, (0, $7IVBD.UNSAFE_getResolveToMatches)(matches, future.v7_relativeSplatPath), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    $dAx5m.useEffect(()=>navigate(JSON.parse(jsonPath), {
            replace: replace,
            state: state,
            relative: relative
        }), [
        navigate,
        jsonPath,
        relative,
        replace,
        state
    ]);
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/v6/components/outlet
 */ function $f688d60f0daea755$export$910ae8079b2c2852(props) {
    return $f688d60f0daea755$export$a3be3530d8e40d0b(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/v6/components/route
 */ function $f688d60f0daea755$export$e7b0ac011bb776c6(_props) {
    (0, $7IVBD.UNSAFE_invariant)(false);
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a `<Router>` directly. Instead, you'll render a
 * router that is more specific to your environment such as a `<BrowserRouter>`
 * in web browsers or a `<StaticRouter>` for server rendering.
 *
 * @see https://reactrouter.com/v6/router-components/router
 */ function $f688d60f0daea755$export$55185c17a0fcbe46(_ref5) {
    let { basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = (0, $7IVBD.Action).Pop, navigator: navigator, static: staticProp = false, future: future } = _ref5;
    !!$f688d60f0daea755$export$9c954a9d03d32f4a() && (0, $7IVBD.UNSAFE_invariant)(false);
    // Preserve trailing slashes on basename, so we can let the user control
    // the enforcement of trailing slashes throughout the app
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $dAx5m.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp,
            future: $f688d60f0daea755$var$_extends({
                v7_relativeSplatPath: false
            }, future)
        }), [
        basename,
        future,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, $7IVBD.parsePath)(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default" } = locationProp;
    let locationContext = $dAx5m.useMemo(()=>{
        let trailingPathname = (0, $7IVBD.stripBasename)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    if (locationContext == null) return null;
    return /*#__PURE__*/ $dAx5m.createElement($f688d60f0daea755$export$26749e8557646306.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ $dAx5m.createElement($f688d60f0daea755$export$c7914228fb69b0f5.Provider, {
        children: children,
        value: locationContext
    }));
}
/**
 * A container for a nested tree of `<Route>` elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/v6/components/routes
 */ function $f688d60f0daea755$export$3565eb3d00ca5a74(_ref6) {
    let { children: children, location: location } = _ref6;
    return $f688d60f0daea755$export$5d3fca4a98652595($f688d60f0daea755$export$16da398f5434bdec(children), location);
}
/**
 * Component to use for rendering lazily loaded data from returning defer()
 * in a loader function
 */ function $f688d60f0daea755$export$6ddabde395c8c576(_ref7) {
    let { children: children, errorElement: errorElement, resolve: resolve } = _ref7;
    return /*#__PURE__*/ $dAx5m.createElement($f688d60f0daea755$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /*#__PURE__*/ $dAx5m.createElement($f688d60f0daea755$var$ResolveAwait, null, children));
}
var $f688d60f0daea755$var$AwaitRenderStatus = /*#__PURE__*/ function(AwaitRenderStatus) {
    AwaitRenderStatus[AwaitRenderStatus["pending"] = 0] = "pending";
    AwaitRenderStatus[AwaitRenderStatus["success"] = 1] = "success";
    AwaitRenderStatus[AwaitRenderStatus["error"] = 2] = "error";
    return AwaitRenderStatus;
}($f688d60f0daea755$var$AwaitRenderStatus || {});
const $f688d60f0daea755$var$neverSettledPromise = new Promise(()=>{});
class $f688d60f0daea755$var$AwaitErrorBoundary extends $dAx5m.Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = $f688d60f0daea755$var$AwaitRenderStatus.pending;
        if (!(resolve instanceof Promise)) {
            // Didn't get a promise - provide as a resolved promise
            status = $f688d60f0daea755$var$AwaitRenderStatus.success;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            // Caught a render error, provide it as a rejected promise
            status = $f688d60f0daea755$var$AwaitRenderStatus.error;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{}); // Avoid unhandled rejection warnings
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            // Already tracked promise - check contents
            promise = resolve;
            status = "_error" in promise ? $f688d60f0daea755$var$AwaitRenderStatus.error : "_data" in promise ? $f688d60f0daea755$var$AwaitRenderStatus.success : $f688d60f0daea755$var$AwaitRenderStatus.pending;
        } else {
            // Raw (untracked) promise - track it
            status = $f688d60f0daea755$var$AwaitRenderStatus.pending;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data
                }), (error)=>Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                }));
        }
        if (status === $f688d60f0daea755$var$AwaitRenderStatus.error && promise._error instanceof (0, $7IVBD.AbortedDeferredError)) // Freeze the UI by throwing a never resolved promise
        throw $f688d60f0daea755$var$neverSettledPromise;
        if (status === $f688d60f0daea755$var$AwaitRenderStatus.error && !errorElement) // No errorElement, throw to the nearest route-level error boundary
        throw promise._error;
        if (status === $f688d60f0daea755$var$AwaitRenderStatus.error) // Render via our errorElement
        return /*#__PURE__*/ $dAx5m.createElement($f688d60f0daea755$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === $f688d60f0daea755$var$AwaitRenderStatus.success) // Render children with resolved value
        return /*#__PURE__*/ $dAx5m.createElement($f688d60f0daea755$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
        // Throw to the suspense boundary
        throw promise;
    }
}
/**
 * @private
 * Indirection to leverage useAsyncValue for a render-prop API on `<Await>`
 */ function $f688d60f0daea755$var$ResolveAwait(_ref8) {
    let { children: children } = _ref8;
    let data = $f688d60f0daea755$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data) : children;
    return /*#__PURE__*/ $dAx5m.createElement($dAx5m.Fragment, null, toRender);
}
///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/v6/utils/create-routes-from-children
 */ function $f688d60f0daea755$export$16da398f5434bdec(children, parentPath) {
    if (parentPath === void 0) parentPath = [];
    let routes = [];
    $dAx5m.Children.forEach(children, (element, index)=>{
        if (!/*#__PURE__*/ $dAx5m.isValidElement(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $dAx5m.Fragment) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, $f688d60f0daea755$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        !(element.type === $f688d60f0daea755$export$e7b0ac011bb776c6) && (0, $7IVBD.UNSAFE_invariant)(false);
        !(!element.props.index || !element.props.children) && (0, $7IVBD.UNSAFE_invariant)(false);
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $f688d60f0daea755$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function $f688d60f0daea755$export$daf73786167a7f72(matches) {
    return $f688d60f0daea755$var$_renderMatches(matches);
}
function $f688d60f0daea755$export$52b333d321859367(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) Object.assign(updates, {
        element: /*#__PURE__*/ $dAx5m.createElement(route.Component),
        Component: undefined
    });
    if (route.HydrateFallback) Object.assign(updates, {
        hydrateFallbackElement: /*#__PURE__*/ $dAx5m.createElement(route.HydrateFallback),
        HydrateFallback: undefined
    });
    if (route.ErrorBoundary) Object.assign(updates, {
        errorElement: /*#__PURE__*/ $dAx5m.createElement(route.ErrorBoundary),
        ErrorBoundary: undefined
    });
    return updates;
}
function $f688d60f0daea755$export$f30f7e456d254e83(routes, opts) {
    return (0, $7IVBD.createRouter)({
        basename: opts == null ? void 0 : opts.basename,
        future: $f688d60f0daea755$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $7IVBD.createMemoryHistory)({
            initialEntries: opts == null ? void 0 : opts.initialEntries,
            initialIndex: opts == null ? void 0 : opts.initialIndex
        }),
        hydrationData: opts == null ? void 0 : opts.hydrationData,
        routes: routes,
        mapRouteProperties: $f688d60f0daea755$export$52b333d321859367,
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation
    }).initialize();
}

});


parcelRegister("4ml7i", function(module, exports) {

$parcel$export(module.exports, "getStyledAnchor", function () { return $6abcb8ce261c84dc$export$3be0f6439edf8fb0; });
/**
 * Use this component whenever you would need <a> or <Link>.
 * Use with `href` property to create an <a> tag and with `to` property
 * to create a <Link> tag.
 *
 * With using this component for all link elements we make sure links have
 * the proper hover and focus styles. Atlaskit/button with link appearance
 * does not have a correct focus style and is harder to deal with as it might
 * need additional props like spacing depending on where it's used.
 */ 
var $ku6eE = parcelRequire("ku6eE");

var $5MUVm = parcelRequire("5MUVm");

var $gbKg7 = parcelRequire("gbKg7");
const $6abcb8ce261c84dc$var$getColor = (props)=>props.appearance === "subtle" ? (0, $gbKg7.default)("color.text.subtlest", (0, $5MUVm).N200) : (0, $gbKg7.default)("color.link", (0, $5MUVm).B400);
const $6abcb8ce261c84dc$var$getHoverColor = (props)=>props.appearance === "subtle" ? (0, $gbKg7.default)("color.text.subtle", (0, $5MUVm).N90) : (0, $gbKg7.default)("color.link", (0, $5MUVm).B300);
const $6abcb8ce261c84dc$export$3be0f6439edf8fb0 = (component)=>(0, $ku6eE.default)(component)`
  color: ${(props)=>$6abcb8ce261c84dc$var$getColor(props)};

  &&:hover {
    color: ${(props)=>$6abcb8ce261c84dc$var$getHoverColor(props)};
    text-decoration: underline;
  }

  &&:focus {
    outline: 2px solid ${(0, $gbKg7.default)("color.border.focused", (0, $5MUVm).B100)};
    outline-offset: 2px;
  }

  &&:active {
    outline: none;
    text-decoration: none;
  }
`;

});



parcelRegister("klc1a", function(module, exports) {

$parcel$export(module.exports, "default", function () { return (parcelRequire("6e62a")).default; });

var $6e62a = parcelRequire("6e62a");

});
parcelRegister("6e62a", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c29344d6edf13fd6$export$2e2bcd8739ae039; });

var $dAx5m = parcelRequire("dAx5m");
parcelRequire("5Zreo");
var $lairn = parcelRequire("lairn");

var $b1ORY = parcelRequire("b1ORY");
let $c29344d6edf13fd6$var$initialLoadTracked = false;
const $c29344d6edf13fd6$var$RecordTransition = ()=>{
    const navigate = (0, $lairn.useNavigate)();
    const onInitialLoad = ()=>{
        $c29344d6edf13fd6$var$initialLoadTracked = true;
        // stores referrer info
        recordPageVisitOrigin();
    };
    const onTransition = ()=>{
        // cleanup stored referrer info on transition
        (0, $b1ORY.default).cleanup();
    };
    const recordPageVisitOrigin = ()=>{
        const url = new URL(window.location.href);
        // ref contains a product like confluence, jira etc.
        const ref = url.searchParams.get("ref") || "";
        // src contains a location like appswitcher, peopledrawer etc.
        const src = url.searchParams.get("src") || null;
        if (!ref && !src) return;
        // save referrer info for retrieving it in further screen events
        (0, $b1ORY.default).set({
            src: src,
            ref: ref
        });
        url.searchParams.delete("ref");
        url.searchParams.delete("src");
        // replace location if it changed after removing ref and src query params
        const path = `${url.pathname}${url.search}`;
        navigate(path, {
            replace: true
        });
    };
    (0, $dAx5m.useEffect)(()=>{
        if (!$c29344d6edf13fd6$var$initialLoadTracked) onInitialLoad();
        else onTransition();
    });
    return null;
};
var $c29344d6edf13fd6$export$2e2bcd8739ae039 = $c29344d6edf13fd6$var$RecordTransition;

});


parcelRegister("7Wy6s", function(module, exports) {

$parcel$export(module.exports, "default", function () { return (parcelRequire("1QRhz")).default; });

var $1QRhz = parcelRequire("1QRhz");

});
parcelRegister("1QRhz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c77f1174922f230a$export$2e2bcd8739ae039; });

var $bibO8 = parcelRequire("bibO8");
parcelRequire("dAx5m");

var $fL9T3 = parcelRequire("fL9T3");

var $gQsRD = parcelRequire("gQsRD");
const $c77f1174922f230a$var$Spinner = ({ wrapperHeight: wrapperHeight, ...props })=>/*#__PURE__*/ (0, $bibO8.jsx)($gQsRD.SpinnerWrapper, {
        height: wrapperHeight,
        "data-test-selector": "spinner",
        "data-testid": "spinner",
        children: /*#__PURE__*/ (0, $bibO8.jsx)((0, $fL9T3.default), {
            ...props
        })
    });
var $c77f1174922f230a$export$2e2bcd8739ae039 = $c77f1174922f230a$var$Spinner;

});
parcelRegister("fL9T3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b792ea24d757d546$export$2e2bcd8739ae039; });
/** @jsx jsx */ 
var $dAx5m = parcelRequire("dAx5m");

var $jVTBW = parcelRequire("jVTBW");

var $kqsmh = parcelRequire("kqsmh");

var $5MUVm = parcelRequire("5MUVm");

var $5y8p7 = parcelRequire("5y8p7");
/**
 * Returns the appropriate circle stroke color.
 */ function $b792ea24d757d546$var$getStrokeColor(appearance) {
    return appearance === "inherit" ? "var(--ds-icon-subtle, ".concat((0, $5MUVm.N500), ")") : "var(--ds-icon-inverse, ".concat((0, $5MUVm.N0), ")");
}
var $b792ea24d757d546$var$rotate = (0, $jVTBW.keyframes)({
    to: {
        transform: "rotate(360deg)"
    }
});
var $b792ea24d757d546$var$rotateStyles = (0, $jVTBW.css)({
    animation: "".concat($b792ea24d757d546$var$rotate, " 0.86s infinite"),
    animationTimingFunction: "cubic-bezier(0.4, 0.15, 0.6, 0.85)",
    transformOrigin: "center"
});
/**
 * There are three parts to the load in animation:
 * 1. Fade in
 * 2. Accelerated spin
 * 3. Stretch the spinner line
 */ var $b792ea24d757d546$var$loadIn = (0, $jVTBW.keyframes)({
    from: {
        transform: "rotate(50deg)",
        opacity: 0,
        strokeDashoffset: 60
    },
    to: {
        transform: "rotate(230deg)",
        opacity: 1,
        strokeDashoffset: 50
    }
});
var $b792ea24d757d546$var$loadInStyles = (0, $jVTBW.css)({
    animation: "".concat($b792ea24d757d546$var$loadIn, " 1s ease-in-out"),
    /**
   * When the animation completes, stay at the last frame of the animation.
   */ animationFillMode: "forwards",
    /**
   * We are going to animate this in.
   */ opacity: 0
});
var $b792ea24d757d546$var$wrapperStyles = (0, $jVTBW.css)({
    display: "inline-flex",
    /**
   * Align better inline with text.
   */ verticalAlign: "middle"
});
var $b792ea24d757d546$var$circleStyles = (0, $jVTBW.css)({
    fill: "none",
    strokeDasharray: 60,
    strokeDashoffset: "inherit",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    "@media screen and (forced-colors: active)": {
        filter: "grayscale(100%)",
        stroke: "CanvasText"
    }
});
/**
 * `useLayoutEffect` is being used in SSR safe form. On the server, this work doesn’t need to run.
 * `useEffect` is used in-place, because `useEffect` is not run on the server and it matches types
 * which makes things simpler than doing an `isServer` check or a `null` check.
 *
 * @see https://hello.atlassian.net/wiki/spaces/DST/pages/2081696628/DSTDACI-010+-+Interaction+Tracing+hooks+in+DS+components
 */ var $b792ea24d757d546$var$useLayoutEffect = typeof window === "undefined" ? (0, $dAx5m.useEffect) : (0, $dAx5m.useLayoutEffect);
var $b792ea24d757d546$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).forwardRef(function Spinner(_ref, ref) {
    var _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "inherit" : _ref$appearance, _ref$delay = _ref.delay, delay = _ref$delay === void 0 ? 0 : _ref$delay, interactionName = _ref.interactionName, label = _ref.label, _ref$size = _ref.size, providedSize = _ref$size === void 0 ? "medium" : _ref$size, testId = _ref.testId;
    var size = typeof providedSize === "number" ? providedSize : (0, $5y8p7.presetSizes)[providedSize];
    var animationDelay = "".concat(delay, "ms");
    var stroke = $b792ea24d757d546$var$getStrokeColor(appearance);
    var context = (0, $dAx5m.useContext)((0, $kqsmh.default));
    $b792ea24d757d546$var$useLayoutEffect(function() {
        if (context != null) return context.hold(interactionName);
    }, [
        context,
        interactionName
    ]);
    /**
   * The Spinner animation uses a combination of two
   * css animations on two separate elements.
   */ return (0, $jVTBW.jsx)("span", {
        /**
     * This span exists to off-load animations from the circle element,
     * which were causing performance issues (style recalculations)
     * on Safari and older versions of Chrome.
     *
     * This can be removed and styles placed back on the circle element once
     * Safari fixes this bug and off-loads rendering to the GPU from the CPU.
     */ css: [
            $b792ea24d757d546$var$wrapperStyles,
            $b792ea24d757d546$var$rotateStyles
        ],
        "data-testid": testId && "".concat(testId, "-wrapper"),
        style: {
            animationDelay: animationDelay,
            width: size,
            height: size
        }
    }, (0, $jVTBW.jsx)("svg", {
        height: size,
        width: size,
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        "data-testid": testId,
        ref: ref,
        "aria-label": label,
        css: $b792ea24d757d546$var$loadInStyles,
        style: {
            animationDelay: animationDelay
        }
    }, (0, $jVTBW.jsx)("circle", {
        cx: "8",
        cy: "8",
        r: "7",
        css: $b792ea24d757d546$var$circleStyles,
        style: {
            stroke: stroke
        }
    })));
}));

});
parcelRegister("5y8p7", function(module, exports) {

$parcel$export(module.exports, "presetSizes", function () { return $40a6a59cd86b62ee$export$4e9f1640bbe7a1a8; });
var $40a6a59cd86b62ee$export$4e9f1640bbe7a1a8 = {
    xsmall: 8,
    small: 16,
    medium: 24,
    large: 48,
    xlarge: 96
};

});


parcelRegister("gQsRD", function(module, exports) {

$parcel$export(module.exports, "SpinnerWrapper", function () { return $d8686668bd043937$export$52b4dfd89a6b3a1b; });

var $ku6eE = parcelRequire("ku6eE");
const $d8686668bd043937$var$getHeight = ({ height: height })=>{
    if (typeof height === "number") return `${height}px`;
    return height;
};
const $d8686668bd043937$export$52b4dfd89a6b3a1b = (0, $ku6eE.default).div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 16px 0;
  height: ${$d8686668bd043937$var$getHeight};
`;

});



parcelRegister("25utc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return (parcelRequire("blvGL")).default; });

var $blvGL = parcelRequire("blvGL");

});
parcelRegister("blvGL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $25491c76a95c2ab1$export$2e2bcd8739ae039; });

var $bibO8 = parcelRequire("bibO8");
parcelRequire("dAx5m");

var $iA1lA = parcelRequire("iA1lA");
var $gkVPj = parcelRequire("gkVPj");
var $cjNyl = parcelRequire("cjNyl");
var $fm50k = parcelRequire("fm50k");
var $jYYr1 = parcelRequire("jYYr1");
var $bBEQj = parcelRequire("bBEQj");
var $21RuB = parcelRequire("21RuB");

var $5lc1q = parcelRequire("5lc1q");
const $25491c76a95c2ab1$var$ProductIcon = ({ defaultIcon: defaultIcon = null, productKey: productKey, productName: productName, size: size = "small" })=>{
    const mapProductKeyToIcon = {
        [(0, $5lc1q.ShortProductKey).JIRA]: /*#__PURE__*/ (0, $bibO8.jsx)((0, $cjNyl.JiraIcon), {
            size: size,
            label: productName || "Jira"
        }),
        [(0, $5lc1q.ShortProductKey).CONFLUENCE]: /*#__PURE__*/ (0, $bibO8.jsx)((0, $gkVPj.ConfluenceIcon), {
            size: size,
            label: productName || "Confluence"
        }),
        [(0, $5lc1q.ShortProductKey).JIRA_SOFTWARE]: /*#__PURE__*/ (0, $bibO8.jsx)((0, $jYYr1.JiraSoftwareIcon), {
            size: size,
            label: productName || "Jira"
        }),
        [(0, $5lc1q.ShortProductKey).JIRA_SERVICE_DESK]: /*#__PURE__*/ (0, $bibO8.jsx)((0, $fm50k.JiraServiceManagementIcon), {
            size: size,
            label: productName || "Jira"
        }),
        [(0, $5lc1q.ShortProductKey).JIRA_CORE]: /*#__PURE__*/ (0, $bibO8.jsx)((0, $bBEQj.JiraWorkManagementIcon), {
            size: size,
            label: productName || "Jira"
        }),
        [(0, $5lc1q.ShortProductKey).BITBUCKET]: /*#__PURE__*/ (0, $bibO8.jsx)((0, $iA1lA.BitbucketIcon), {
            size: size,
            label: productName || "Bitbucket"
        }),
        [(0, $5lc1q.ShortProductKey).TRELLO]: /*#__PURE__*/ (0, $bibO8.jsx)((0, $21RuB.TrelloIcon), {
            size: size,
            label: productName || "Trello"
        })
    };
    return productKey && mapProductKeyToIcon[productKey] ? mapProductKeyToIcon[productKey] : /*#__PURE__*/ (0, $bibO8.jsx)((0, $bibO8.Fragment), {
        children: defaultIcon
    });
};
var $25491c76a95c2ab1$export$2e2bcd8739ae039 = $25491c76a95c2ab1$var$ProductIcon;

});
parcelRegister("iA1lA", function(module, exports) {

$parcel$export(module.exports, "BitbucketIcon", function () { return $d86ca25095e38485$export$5fc1066e677788d4; });
/* eslint-disable max-len */ 
var $dAx5m = parcelRequire("dAx5m");

var $h0JxK = parcelRequire("h0JxK");

var $2na4u = parcelRequire("2na4u");

var $8sWx6 = parcelRequire("8sWx6");

var $c546B = parcelRequire("c546B");
var $d86ca25095e38485$var$svg = function svg(_ref) {
    var appearance = _ref.appearance, iconGradientStart = _ref.iconGradientStart, iconGradientStop = _ref.iconGradientStop, iconColor = _ref.iconColor;
    var colors = {
        iconGradientStart: iconGradientStart,
        iconGradientStop: iconGradientStop,
        iconColor: iconColor
    };
    // Will be fixed upon removal of deprecated iconGradientStart and
    // iconGradientStop props, or with React 18's useId() hook when we update.
    // eslint-disable-next-line @repo/internal/react/disallow-unstable-values
    var id = (0, $h0JxK.uid)({
        iconGradientStart: iconGradientStop
    });
    if (appearance) colors = (0, $8sWx6.getColorsFromAppearance)(appearance);
    return '\n  <svg viewBox="0 0 32 32" height="32" xmlns="http://www.w3.org/2000/svg" focusable="false" aria-hidden="true">\n    <defs>\n      <linearGradient id="'.concat(id, '" x1="100%" x2="45.339%" y1="29.23%" y2="75.038%">\n        <stop stop-color="').concat(colors.iconGradientStart, '" ').concat(colors.iconGradientStart === "inherit" ? 'stop-opacity="0.4"' : "", ' offset="0%"></stop>\n        <stop stop-color="').concat(colors.iconGradientStop, '" offset="100%"></stop>\n      </linearGradient>\n    </defs>\n    <g stroke="none" stroke-width="1" fill-rule="nonzero">\n      <path fill="').concat(colors.iconColor, '" d="M4.78580435,5 C4.55423538,4.99701333 4.33319771,5.09657765 4.18198458,5.27198488 C4.03077145,5.44739211 3.96486141,5.68068714 4.00193478,5.9092887 L7.32946109,26.1096074 C7.3703589,26.355373 7.49665951,26.578828 7.68612174,26.7406224 C7.87680866,26.9055104 8.11992598,26.9972003 8.37200761,26.9992993 L14.5488998,19.5995707 L13.6827239,19.5995707 L12.3227102,12.3958093 L27.3886833,12.3958093 L28.4469072,5.91712739 C28.4862006,5.68935393 28.4229655,5.45584955 28.2741046,5.27903 C28.1252437,5.10221045 27.9059335,5.00010264 27.6747957,5 L4.78580435,5 Z" />\n      <path fill="url(#').concat(id, ')" d="M27.3886833,12.3958093 L20.0320674,12.3958093 L18.7974728,19.5995707 L13.7023207,19.5995707 L7.68612174,26.7445417 C7.87680866,26.9094297 8.11992598,27.0011197 8.37200761,27.0032187 L24.3394307,27.0032187 C24.727754,27.0082167 25.0611955,26.7281258 25.1233002,26.3447683 L27.3886833,12.3958093 Z"/>\n    </g>\n  </svg>');
};
var $d86ca25095e38485$export$5fc1066e677788d4 = function BitbucketIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? "Bitbucket" : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $2na4u.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $2na4u.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$iconGradientSta = _ref2.iconGradientStart, iconGradientStart = _ref2$iconGradientSta === void 0 ? (0, $2na4u.defaultLogoParams).iconGradientStart : _ref2$iconGradientSta, _ref2$iconGradientSto = _ref2.iconGradientStop, iconGradientStop = _ref2$iconGradientSto === void 0 ? (0, $2na4u.defaultLogoParams).iconGradientStop : _ref2$iconGradientSto, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $2na4u.defaultLogoParams).textColor : _ref2$textColor;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $c546B.default), {
        appearance: appearance,
        label: label,
        svg: $d86ca25095e38485$var$svg({
            appearance: appearance,
            iconGradientStart: iconGradientStart,
            iconGradientStop: iconGradientStop,
            iconColor: iconColor
        }),
        iconColor: iconColor,
        iconGradientStart: iconGradientStart,
        iconGradientStop: iconGradientStop,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});
parcelRegister("h0JxK", function(module, exports) {

$parcel$export(module.exports, "generateUID", function () { return $c625c3b90095eade$export$bdbb4cbb3078e58d; });
$parcel$export(module.exports, "uid", function () { return $c625c3b90095eade$export$e2a22331486dcca0; });
/**
 * generates a UID factory
 * @internal
 * @example
 * const uid = generateUID();
 * uid(object) = 1;
 * uid(object) = 1;
 * uid(anotherObject) = 2;
 */ var $c625c3b90095eade$export$bdbb4cbb3078e58d = function() {
    var counter = 1;
    var map = new WeakMap();
    /**
     * @borrows {uid}
     */ var uid = function(item, index) {
        if (typeof item === "number" || typeof item === "string") return index ? "idx-".concat(index) : "val-".concat(item);
        if (!map.has(item)) {
            map.set(item, counter++);
            return uid(item);
        }
        return "uid" + map.get(item);
    };
    return uid;
};
var $c625c3b90095eade$export$e2a22331486dcca0 = $c625c3b90095eade$export$bdbb4cbb3078e58d();

});

parcelRegister("2na4u", function(module, exports) {

$parcel$export(module.exports, "defaultLogoParams", function () { return $1ba58ab61f8b26f0$export$438460117ae6b7ee; });
$parcel$export(module.exports, "sizes", function () { return $1ba58ab61f8b26f0$export$c647cb0ee6e282fe; });
/**
 * These are the default parameters for LogoProps if the user does not specify values.
 */ var $1ba58ab61f8b26f0$export$438460117ae6b7ee = {
    iconColor: "inherit",
    iconGradientStart: "inherit",
    iconGradientStop: "inherit",
    label: "",
    size: "medium",
    textColor: "currentColor"
};
var $1ba58ab61f8b26f0$export$c647cb0ee6e282fe = {
    xsmall: 16,
    small: 24,
    medium: 32,
    large: 40,
    xlarge: 48
};
var $1ba58ab61f8b26f0$export$31d7044b7540a6d8 = $1ba58ab61f8b26f0$export$438460117ae6b7ee;

});

parcelRegister("8sWx6", function(module, exports) {

$parcel$export(module.exports, "getColorsFromAppearance", function () { return $629e57afaaf032c8$export$bbacc3980e0f3029; });
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ 
var $5MUVm = parcelRequire("5MUVm");
var $629e57afaaf032c8$export$bbacc3980e0f3029 = function getColorsFromAppearance(appearance) {
    var iconGradientStart, iconGradientStop, iconColor, textColor, atlassianLogoTextColor;
    switch(appearance){
        case "brand":
            iconGradientStart = (0, $5MUVm.B400);
            iconGradientStop = (0, $5MUVm.B200);
            iconColor = (0, $5MUVm.B200);
            textColor = "var(--ds-text, ".concat((0, $5MUVm.N800), ")");
            // This is only used for the top level Atlassian wordmark (see AtlassianLogo
            // or AtlassianStartLogo for example), and is only different for the Brand
            // appearance - a bold brand color. For other appearances,
            // atlassianLogoTextColor is the same as textColor.
            atlassianLogoTextColor = (0, $5MUVm.B400);
            break;
        case "neutral":
            iconGradientStart = (0, $5MUVm.N600);
            iconGradientStop = (0, $5MUVm.N100);
            iconColor = (0, $5MUVm.N100);
            textColor = (0, $5MUVm.N400);
            atlassianLogoTextColor = (0, $5MUVm.N400);
            break;
        case "inverse":
            iconGradientStart = (0, $5MUVm.N50);
            iconGradientStop = (0, $5MUVm.N0);
            iconColor = (0, $5MUVm.N0);
            textColor = "var(--ds-text-inverse, ".concat((0, $5MUVm.N0), ")");
            atlassianLogoTextColor = "var(--ds-text-inverse, ".concat((0, $5MUVm.N0), ")");
            break;
    }
    return {
        iconGradientStart: iconGradientStart,
        iconGradientStop: iconGradientStop,
        iconColor: iconColor,
        textColor: textColor,
        atlassianLogoTextColor: atlassianLogoTextColor
    };
};

});

parcelRegister("c546B", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8cb922e7df2e9fad$export$2e2bcd8739ae039; });

var $3FjmS = parcelRequire("3FjmS");

var $gqGpE = parcelRequire("gqGpE");

var $8yhux = parcelRequire("8yhux");

var $lODxv = parcelRequire("lODxv");

var $jVTBW = parcelRequire("jVTBW");

var $2na4u = parcelRequire("2na4u");
var $8cb922e7df2e9fad$var$_excluded = [
    "label",
    "svg",
    "size",
    "appearance",
    "iconGradientStart",
    "iconGradientStop",
    "iconColor",
    "textColor",
    "testId"
];
var $8cb922e7df2e9fad$var$CSS_VAR_COLOR = "--logo-color";
var $8cb922e7df2e9fad$var$CSS_VAR_FILL = "--logo-fill";
var $8cb922e7df2e9fad$var$baseWrapperStyles = (0, $jVTBW.css)({
    display: "inline-block",
    position: "relative",
    color: "var(".concat($8cb922e7df2e9fad$var$CSS_VAR_COLOR, ")"),
    fill: "var(".concat($8cb922e7df2e9fad$var$CSS_VAR_FILL, ")"),
    lineHeight: 1,
    userSelect: "none",
    whiteSpace: "normal",
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
    "> svg": {
        height: "100%",
        fill: "inherit"
    }
});
var $8cb922e7df2e9fad$var$stopColorStyles = (0, $jVTBW.css)({
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
    stop: {
        stopColor: "currentColor"
    }
});
var $8cb922e7df2e9fad$var$sizeStyles = Object.entries((0, $2na4u.sizes)).reduce(function(acc, _ref) {
    var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($lODxv)))(_ref, 2), key = _ref2[0], val = _ref2[1];
    acc[key] = (0, $jVTBW.css)({
        height: "".concat(val, "px")
    });
    return acc;
}, {});
/**
 * __Wrapper__
 *
 * An internal component used by `@atlaskit/logo` to render logo SVGs with correct styles.
 */ var $8cb922e7df2e9fad$var$Wrapper = function Wrapper(_ref3) {
    var _ref4;
    var label = _ref3.label, svg = _ref3.svg, size = _ref3.size, appearance = _ref3.appearance, iconGradientStart = _ref3.iconGradientStart, iconGradientStop = _ref3.iconGradientStop, iconColor = _ref3.iconColor, textColor = _ref3.textColor, userDefinedTestId = _ref3.testId, rest = (0, (/*@__PURE__*/$parcel$interopDefault($8yhux)))(_ref3, $8cb922e7df2e9fad$var$_excluded);
    var shouldApplyStopColor = iconGradientStart === "inherit" && iconGradientStop === "inherit" && appearance === undefined;
    var testId = userDefinedTestId && "".concat(userDefinedTestId, "--wrapper");
    return (0, $jVTBW.jsx)("span", (0, (/*@__PURE__*/$parcel$interopDefault($3FjmS)))({
        css: [
            $8cb922e7df2e9fad$var$baseWrapperStyles,
            shouldApplyStopColor && $8cb922e7df2e9fad$var$stopColorStyles,
            size && $8cb922e7df2e9fad$var$sizeStyles[size]
        ],
        "data-testid": testId,
        style: (_ref4 = {}, (0, (/*@__PURE__*/$parcel$interopDefault($gqGpE)))(_ref4, $8cb922e7df2e9fad$var$CSS_VAR_COLOR, iconColor), (0, (/*@__PURE__*/$parcel$interopDefault($gqGpE)))(_ref4, $8cb922e7df2e9fad$var$CSS_VAR_FILL, textColor), _ref4),
        "aria-label": label ? label : undefined,
        role: label ? "img" : undefined,
        dangerouslySetInnerHTML: {
            __html: svg
        }
    }, rest));
};
var $8cb922e7df2e9fad$export$2e2bcd8739ae039 = $8cb922e7df2e9fad$var$Wrapper;

});
parcelRegister("3FjmS", function(module, exports) {
function $2ab4397e79770c30$var$_extends() {
    return module.exports = $2ab4397e79770c30$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $2ab4397e79770c30$var$_extends.apply(null, arguments);
}
module.exports = $2ab4397e79770c30$var$_extends, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("gqGpE", function(module, exports) {

var $6mYjV = parcelRequire("6mYjV");
function $bf5ff953b6f57557$var$_defineProperty(e, r, t) {
    return (r = $6mYjV(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
module.exports = $bf5ff953b6f57557$var$_defineProperty, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("6mYjV", function(module, exports) {

var $27z3j = parcelRequire("27z3j");
var $4a33968ba4583e3c$var$_typeof = $27z3j.default;

var $6hTPs = parcelRequire("6hTPs");
function $4a33968ba4583e3c$var$toPropertyKey(t) {
    var i = $6hTPs(t, "string");
    return "symbol" == $4a33968ba4583e3c$var$_typeof(i) ? i : i + "";
}
module.exports = $4a33968ba4583e3c$var$toPropertyKey, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("27z3j", function(module, exports) {
function $18b76ce45a202292$var$_typeof(o) {
    "@babel/helpers - typeof";
    return module.exports = $18b76ce45a202292$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $18b76ce45a202292$var$_typeof(o);
}
module.exports = $18b76ce45a202292$var$_typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("6hTPs", function(module, exports) {

var $27z3j = parcelRequire("27z3j");
var $493fa319d318c509$var$_typeof = $27z3j.default;
function $493fa319d318c509$var$toPrimitive(t, r) {
    if ("object" != $493fa319d318c509$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $493fa319d318c509$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
module.exports = $493fa319d318c509$var$toPrimitive, module.exports.__esModule = true, module.exports["default"] = module.exports;

});



parcelRegister("8yhux", function(module, exports) {

var $gWcAt = parcelRequire("gWcAt");
function $639f11249cd6e1d5$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $gWcAt(e, t);
    if (Object.getOwnPropertySymbols) {
        var s = Object.getOwnPropertySymbols(e);
        for(r = 0; r < s.length; r++)o = s[r], t.includes(o) || ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
module.exports = $639f11249cd6e1d5$var$_objectWithoutProperties, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("gWcAt", function(module, exports) {
function $c54bd3ae5eb125c6$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.includes(n)) continue;
        t[n] = r[n];
    }
    return t;
}
module.exports = $c54bd3ae5eb125c6$var$_objectWithoutPropertiesLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("lODxv", function(module, exports) {

var $b99y9 = parcelRequire("b99y9");

var $bLbQz = parcelRequire("bLbQz");

var $18hpl = parcelRequire("18hpl");

var $bGzBS = parcelRequire("bGzBS");
function $fe1cf02f750a7a68$var$_slicedToArray(r, e) {
    return $b99y9(r) || $bLbQz(r, e) || $18hpl(r, e) || $bGzBS();
}
module.exports = $fe1cf02f750a7a68$var$_slicedToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("b99y9", function(module, exports) {
function $81d7f159ac35bb0d$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
module.exports = $81d7f159ac35bb0d$var$_arrayWithHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("bLbQz", function(module, exports) {
function $88fd460f334c1303$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
module.exports = $88fd460f334c1303$var$_iterableToArrayLimit, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("18hpl", function(module, exports) {

var $6oQR4 = parcelRequire("6oQR4");
function $0d340a9b991d384e$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $6oQR4(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $6oQR4(r, a) : void 0;
    }
}
module.exports = $0d340a9b991d384e$var$_unsupportedIterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("6oQR4", function(module, exports) {
function $4a8dfbdaec683ea0$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
module.exports = $4a8dfbdaec683ea0$var$_arrayLikeToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("bGzBS", function(module, exports) {
function $881f3d5582b415ad$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
module.exports = $881f3d5582b415ad$var$_nonIterableRest, module.exports.__esModule = true, module.exports["default"] = module.exports;

});




parcelRegister("gkVPj", function(module, exports) {

$parcel$export(module.exports, "ConfluenceIcon", function () { return $be4b5ec8b911f7f6$export$68f3db7f6af48bcb; });
/* eslint-disable max-len */ 
var $dAx5m = parcelRequire("dAx5m");

var $h0JxK = parcelRequire("h0JxK");

var $2na4u = parcelRequire("2na4u");

var $8sWx6 = parcelRequire("8sWx6");

var $c546B = parcelRequire("c546B");
var $be4b5ec8b911f7f6$var$svg = function svg(_ref) {
    var appearance = _ref.appearance, iconGradientStart = _ref.iconGradientStart, iconGradientStop = _ref.iconGradientStop, iconColor = _ref.iconColor;
    var colors = {
        iconGradientStart: iconGradientStart,
        iconGradientStop: iconGradientStop,
        iconColor: iconColor
    };
    // Will be fixed upon removal of deprecated iconGradientStart and
    // iconGradientStop props, or with React 18's useId() hook when we update.
    // eslint-disable-next-line @repo/internal/react/disallow-unstable-values
    var id = (0, $h0JxK.uid)({
        iconGradientStart: iconGradientStop
    });
    if (appearance) colors = (0, $8sWx6.getColorsFromAppearance)(appearance);
    return '\n  <svg viewBox="0 0 32 32" height="32" xmlns="http://www.w3.org/2000/svg" focusable="false" aria-hidden="true">\n    <defs>\n      <linearGradient x1="60.6779047%" y1="137.626433%" x2="14.341981%" y2="112.08042%" id="'.concat(id, '-1">\n        <stop stop-color="').concat(colors.iconGradientStart, '" ').concat(colors.iconGradientStart === "inherit" ? 'stop-opacity="0.4"' : "", ' offset="0%"></stop>\n        <stop stop-color="').concat(colors.iconGradientStop, '" offset="100%"></stop>\n      </linearGradient>\n      <linearGradient x1="12.3282701%" y1="-53.9760846%" x2="74.1300776%" y2="-33.2553066%" id="').concat(id, '-2">\n        <stop stop-color="').concat(colors.iconGradientStart, '" ').concat(colors.iconGradientStart === "inherit" ? 'stop-opacity="0.4"' : "", ' offset="0%"></stop>\n        <stop stop-color="').concat(colors.iconGradientStop, '" offset="100%"></stop>\n      </linearGradient>\n    </defs>\n    <g stroke="none" stroke-width="1" fill-rule="nonzero">\n      <path fill="url(#').concat(id, '-1)" d="M5.21454927,22.0245336 C4.97082816,22.4219865 4.69711061,22.8831818 4.46463817,23.2506383 C4.25655728,23.602269 4.36826343,24.0557627 4.71585838,24.2705174 L9.59028054,27.2701618 C9.76138278,27.3758032 9.96774369,27.4083016 10.1630326,27.3603607 C10.3583215,27.3124197 10.5261749,27.1880564 10.6289074,27.015192 C10.8238843,26.6889807 11.0751045,26.2652809 11.3488221,25.8115847 C13.2798432,22.6244625 15.2221129,23.0144163 18.7241978,24.686718 L23.5573748,26.9851956 C23.7404243,27.0723219 23.9509502,27.0816253 24.1409716,27.0109854 C24.3309931,26.9403455 24.4843191,26.7957811 24.5660052,26.61024 L26.8869801,21.3608623 C27.0509607,20.9859459 26.8841076,20.5487907 26.5120245,20.3784788 C25.4921454,19.8985357 23.4636359,18.942399 21.6376024,18.0612535 C15.0683811,14.8741313 9.48529299,15.0841064 5.21454927,22.0245336 Z"></path>\n      <path fill="url(#').concat(id, '-2)" d="M27.0752616,9.74267061 C27.3190367,9.34512979 27.5928148,8.88383241 27.8253387,8.51629467 C28.0334656,8.1645861 27.9217347,7.71099215 27.5740629,7.4961899 L22.6985622,4.49588177 C22.5250856,4.3802891 22.3113292,4.3421035 22.1085604,4.39048341 C21.9057917,4.43886333 21.7323024,4.56944439 21.6297024,4.75090796 C21.4346824,5.07719147 21.1834066,5.50098499 20.9096284,5.9547816 C18.9781801,9.14260899 17.0354806,8.75256893 13.5326208,7.07989715 L8.71337588,4.78466143 C8.53028584,4.69751579 8.31971336,4.68821035 8.1296499,4.75886591 C7.93958645,4.82952147 7.78622651,4.97411777 7.70452227,5.15969994 L5.38303386,10.4102392 C5.21901692,10.7852385 5.38590698,11.2224905 5.75807237,11.3928401 C6.77817714,11.8728894 8.80713551,12.8292376 10.6335731,13.7105781 C17.2192494,16.8946551 22.8035729,16.6846336 27.0752616,9.74267061 Z"></path>\n    </g>\n  </svg>');
};
var $be4b5ec8b911f7f6$export$68f3db7f6af48bcb = function ConfluenceIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? "Confluence" : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $2na4u.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $2na4u.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$iconGradientSta = _ref2.iconGradientStart, iconGradientStart = _ref2$iconGradientSta === void 0 ? (0, $2na4u.defaultLogoParams).iconGradientStart : _ref2$iconGradientSta, _ref2$iconGradientSto = _ref2.iconGradientStop, iconGradientStop = _ref2$iconGradientSto === void 0 ? (0, $2na4u.defaultLogoParams).iconGradientStop : _ref2$iconGradientSto, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $2na4u.defaultLogoParams).textColor : _ref2$textColor;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $c546B.default), {
        appearance: appearance,
        label: label,
        svg: $be4b5ec8b911f7f6$var$svg({
            appearance: appearance,
            iconGradientStart: iconGradientStart,
            iconGradientStop: iconGradientStop,
            iconColor: iconColor
        }),
        iconColor: iconColor,
        iconGradientStart: iconGradientStart,
        iconGradientStop: iconGradientStop,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("cjNyl", function(module, exports) {

$parcel$export(module.exports, "JiraIcon", function () { return $8f7db294f128cdb6$export$c4b5b1f965d8b3eb; });
/* eslint-disable max-len */ 
var $dAx5m = parcelRequire("dAx5m");

var $h0JxK = parcelRequire("h0JxK");

var $2na4u = parcelRequire("2na4u");

var $8sWx6 = parcelRequire("8sWx6");

var $c546B = parcelRequire("c546B");
var $8f7db294f128cdb6$var$svg = function svg(_ref) {
    var appearance = _ref.appearance, iconGradientStart = _ref.iconGradientStart, iconGradientStop = _ref.iconGradientStop, iconColor = _ref.iconColor;
    var colors = {
        iconGradientStart: iconGradientStart,
        iconGradientStop: iconGradientStop,
        iconColor: iconColor
    };
    // Will be fixed upon removal of deprecated iconGradientStart and
    // iconGradientStop props, or with React 18's useId() hook when we update.
    // eslint-disable-next-line @repo/internal/react/disallow-unstable-values
    var id = (0, $h0JxK.uid)({
        iconGradientStart: iconGradientStop
    });
    if (appearance) colors = (0, $8sWx6.getColorsFromAppearance)(appearance);
    return '\n  <svg viewBox="0 0 32 32" height="32" xmlns="http://www.w3.org/2000/svg" focusable="false" aria-hidden="true">\n    <defs>\n      <linearGradient x1="94.092%" x2="56.535%" y1="6.033%" y2="43.087%" id="'.concat(id, '">\n        <stop stop-color="').concat(colors.iconGradientStart, '" ').concat(colors.iconGradientStart === "inherit" ? 'stop-opacity="0.4"' : "", ' offset="18%"></stop>\n        <stop stop-color="').concat(colors.iconGradientStop, '" offset="100%"></stop>\n      </linearGradient>\n    </defs>\n    <g stroke="none" stroke-width="1" fill-rule="nonzero">\n      <path fill="').concat(colors.iconColor, '" d="M26.0406546,5 L14.9983562,5 C14.9983562,6.32163748 15.5233746,7.58914413 16.4579134,8.52368295 C17.3924523,9.45822178 18.6599589,9.98324022 19.9815964,9.98324022 L22.0151159,9.98324022 L22.0151159,11.9465283 C22.0168782,14.6974491 24.2474348,16.9265768 26.9983562,16.9265762 L26.9983562,5.95770152 C26.9983562,5.42877757 26.5695786,5 26.0406546,5 Z"></path>\n      <path fill="url(#').concat(id, ')" d="M20.0420436,11 L9,11 C9.00176139,13.7504065 11.2309666,15.9796117 13.9813731,15.9813731 L16.0154337,15.9813731 L16.0154337,17.9451836 C16.0154337,19.2671728 16.5405919,20.5350167 17.4753794,21.4698042 C18.4101669,22.4045917 19.6780108,22.9297499 21,22.9297499 L21,11.9579564 C21,11.4288917 20.5711083,11 20.0420436,11 Z"></path>\n      <path fill="url(#').concat(id, ')" d="M14.0420436,17 L3,17 C3.00176275,19.7516528 5.23291286,21.9813736 7.98456626,21.9813731 L10.0250133,21.9813731 L10.0250133,23.9451836 C10.0250082,26.6943468 12.2508419,28.9244664 15,28.9297499 L15,17.9579564 C15,17.4288917 14.5711083,17 14.0420436,17 Z"></path>\n    </g>\n  </svg>');
};
var $8f7db294f128cdb6$export$c4b5b1f965d8b3eb = function JiraIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? "Jira" : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $2na4u.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $2na4u.defaultLogoParams).textColor : _ref2$textColor, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $2na4u.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$iconGradientSta = _ref2.iconGradientStart, iconGradientStart = _ref2$iconGradientSta === void 0 ? (0, $2na4u.defaultLogoParams).iconGradientStart : _ref2$iconGradientSta, _ref2$iconGradientSto = _ref2.iconGradientStop, iconGradientStop = _ref2$iconGradientSto === void 0 ? (0, $2na4u.defaultLogoParams).iconGradientStop : _ref2$iconGradientSto;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $c546B.default), {
        appearance: appearance,
        label: label,
        svg: $8f7db294f128cdb6$var$svg({
            appearance: appearance,
            iconGradientStart: iconGradientStart,
            iconGradientStop: iconGradientStop,
            iconColor: iconColor
        }),
        iconColor: iconColor,
        iconGradientStart: iconGradientStart,
        iconGradientStop: iconGradientStop,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("fm50k", function(module, exports) {

$parcel$export(module.exports, "JiraServiceManagementIcon", function () { return $b2dccad2855345da$export$3c6158790f5e01c4; });
/* eslint-disable max-len */ 
var $dAx5m = parcelRequire("dAx5m");

var $h0JxK = parcelRequire("h0JxK");

var $2na4u = parcelRequire("2na4u");

var $8sWx6 = parcelRequire("8sWx6");

var $c546B = parcelRequire("c546B");
var $b2dccad2855345da$var$svg = function svg(_ref) {
    var appearance = _ref.appearance, iconGradientStart = _ref.iconGradientStart, iconGradientStop = _ref.iconGradientStop, iconColor = _ref.iconColor;
    var colors = {
        iconGradientStart: iconGradientStart,
        iconGradientStop: iconGradientStop,
        iconColor: iconColor
    };
    // Will be fixed upon removal of deprecated iconGradientStart and
    // iconGradientStop props, or with React 18's useId() hook when we update.
    // eslint-disable-next-line @repo/internal/react/disallow-unstable-values
    var id = (0, $h0JxK.uid)({
        iconGradientStart: iconGradientStop
    });
    if (appearance) colors = (0, $8sWx6.getColorsFromAppearance)(appearance);
    return '\n  <svg viewBox="0 0 32 32" height="32" xmlns="http://www.w3.org/2000/svg" focusable="false" aria-hidden="true">\n    <defs>\n      <linearGradient x1="40.063%" x2="69.955%" y1="0%" y2="50%" id="'.concat(id, '">\n        <stop stop-color="').concat(colors.iconGradientStart, '" ').concat(colors.iconGradientStart === "inherit" ? 'stop-opacity="0.4"' : "", ' offset="0%"></stop>\n        <stop stop-color="').concat(colors.iconGradientStop, '" offset="100%"></stop>\n      </linearGradient>\n    </defs>\n    <g stroke="none" stroke-width="1" fill-rule="nonzero">\n      <path fill="url(#').concat(id, ')" d="M18.4838727,13.07 L26.3504842,13.1005351 C26.8138769,13.102696 27.2364009,13.3661074 27.4423455,13.781227 C27.64829,14.1963467 27.6024124,14.6921363 27.3237913,15.0624169 L15.7128101,30.5666265 C13.9597489,29.2574035 12.7986975,27.3052951 12.485161,25.1398891 C12.1716246,22.974483 12.731296,20.7732253 14.041012,19.0205325 L18.4838727,13.07 Z"></path>\n      <path fill="').concat(colors.iconColor, '" d="M14.0396053,19.0156579 L6.22105263,18.9660526 C5.75779361,18.9638923 5.33539149,18.700557 5.12950634,18.2855571 C4.92362119,17.8705572 4.96948557,17.3749106 5.24802632,17.0047368 L16.7411842,1.65 C18.4937397,2.9588453 19.6544561,4.91039056 19.9679021,7.0751719 C20.2813481,9.23995324 19.7218382,11.4405759 18.4125,13.1927632 L14.0396053,19.0156579 Z"></path>\n    </g>\n  </svg>');
};
var $b2dccad2855345da$export$3c6158790f5e01c4 = function JiraServiceManagementIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? "Jira Service Management" : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $2na4u.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $2na4u.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$iconGradientSta = _ref2.iconGradientStart, iconGradientStart = _ref2$iconGradientSta === void 0 ? (0, $2na4u.defaultLogoParams).iconGradientStart : _ref2$iconGradientSta, _ref2$iconGradientSto = _ref2.iconGradientStop, iconGradientStop = _ref2$iconGradientSto === void 0 ? (0, $2na4u.defaultLogoParams).iconGradientStop : _ref2$iconGradientSto, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $2na4u.defaultLogoParams).textColor : _ref2$textColor;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $c546B.default), {
        appearance: appearance,
        label: label,
        svg: $b2dccad2855345da$var$svg({
            appearance: appearance,
            iconGradientStart: iconGradientStart,
            iconGradientStop: iconGradientStop,
            iconColor: iconColor
        }),
        iconColor: iconColor,
        iconGradientStart: iconGradientStart,
        iconGradientStop: iconGradientStop,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("jYYr1", function(module, exports) {

$parcel$export(module.exports, "JiraSoftwareIcon", function () { return $e8c27ffed798c214$export$c3835feba2a66e67; });
/* eslint-disable max-len */ 
var $dAx5m = parcelRequire("dAx5m");

var $h0JxK = parcelRequire("h0JxK");

var $2na4u = parcelRequire("2na4u");

var $8sWx6 = parcelRequire("8sWx6");

var $c546B = parcelRequire("c546B");
var $e8c27ffed798c214$var$svg = function svg(_ref) {
    var appearance = _ref.appearance, iconGradientStart = _ref.iconGradientStart, iconGradientStop = _ref.iconGradientStop, iconColor = _ref.iconColor;
    var colors = {
        iconGradientStart: iconGradientStart,
        iconGradientStop: iconGradientStop,
        iconColor: iconColor
    };
    // Will be fixed upon removal of deprecated iconGradientStart and
    // iconGradientStop props, or with React 18's useId() hook when we update.
    // eslint-disable-next-line @repo/internal/react/disallow-unstable-values
    var id = (0, $h0JxK.uid)({
        iconGradientStart: iconGradientStop
    });
    if (appearance) colors = (0, $8sWx6.getColorsFromAppearance)(appearance);
    return '\n  <svg viewBox="0 0 32 32" height="32" xmlns="http://www.w3.org/2000/svg" focusable="false" aria-hidden="true">\n    <defs>\n      <linearGradient x1="108.695%" x2="12.439%" y1="-14.936%" y2="45.215%" id="'.concat(id, '-1">\n        <stop stop-color="').concat(colors.iconGradientStart, '" ').concat(colors.iconGradientStart === "inherit" ? 'stop-opacity="0.4"' : "", ' offset="0%"></stop>\n        <stop stop-color="').concat(colors.iconGradientStop, '" offset="100%"></stop>\n      </linearGradient>\n      <linearGradient x1="0%" x2="91.029%" y1="118.55%" y2="63.971%" id="').concat(id, '-2">\n        <stop stop-color="').concat(colors.iconGradientStart, '" ').concat(colors.iconGradientStart === "inherit" ? 'stop-opacity="0.4"' : "", ' offset="0%"></stop>\n        <stop stop-color="').concat(colors.iconGradientStop, '" offset="100%"></stop>\n      </linearGradient>\n    </defs>\n    <g stroke="none" stroke-width="1" fill-rule="nonzero">\n      <path fill="').concat(colors.iconColor, '" d="M15.9669691 29.3616152C17.2195568 28.1097726 17.9233158 26.4114623 17.9233158 24.6405626 17.9233158 22.8696629 17.2195568 21.1713527 15.9669691 19.91951L7.26805808 11.2489111 3.31143376 15.2055354C2.89743442 15.6200502 2.89743442 16.291565 3.31143376 16.7060799L15.9669691 29.3616152zM28.6225045 15.2055354L15.9669691 2.55 15.9280399 2.58892922C13.3485687 5.19994003 13.3612164 9.40374108 15.9563521 11.9991833L24.6623412 20.6662432 28.6225045 16.7060799C29.0365039 16.291565 29.0365039 15.6200502 28.6225045 15.2055354z" />\n      <path fill="url(#').concat(id, '-1" d="M15.9669691,11.9921053 C13.3718335,9.39666304 13.3591857,5.19286199 15.938657,2.58185118 L6.91061706,11.6063521 L11.6316697,16.3274047 L15.9669691,11.9921053 Z" />\n      <path fill="url(#').concat(id, '-2" d="M20.2951906,15.5912886 L15.9669691,19.91951 C17.2195568,21.1713527 17.9233158,22.8696629 17.9233158,24.6405626 C17.9233158,26.4114623 17.2195568,28.1097726 15.9669691,29.3616152 L25.0162432,20.3123412 L20.2951906,15.5912886 Z" />\n    </g>\n  </svg>');
};
var $e8c27ffed798c214$export$c3835feba2a66e67 = function JiraSoftwareIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? "Jira Software" : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $2na4u.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $2na4u.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$iconGradientSta = _ref2.iconGradientStart, iconGradientStart = _ref2$iconGradientSta === void 0 ? (0, $2na4u.defaultLogoParams).iconGradientStart : _ref2$iconGradientSta, _ref2$iconGradientSto = _ref2.iconGradientStop, iconGradientStop = _ref2$iconGradientSto === void 0 ? (0, $2na4u.defaultLogoParams).iconGradientStop : _ref2$iconGradientSto, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $2na4u.defaultLogoParams).textColor : _ref2$textColor;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $c546B.default), {
        appearance: appearance,
        label: label,
        svg: $e8c27ffed798c214$var$svg({
            appearance: appearance,
            iconGradientStart: iconGradientStart,
            iconGradientStop: iconGradientStop,
            iconColor: iconColor
        }),
        iconColor: iconColor,
        iconGradientStart: iconGradientStart,
        iconGradientStop: iconGradientStop,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("bBEQj", function(module, exports) {

$parcel$export(module.exports, "JiraWorkManagementIcon", function () { return $8732d4ef66564456$export$7330b9fc5718fd30; });
/* eslint-disable max-len */ 
var $dAx5m = parcelRequire("dAx5m");

var $h0JxK = parcelRequire("h0JxK");

var $2na4u = parcelRequire("2na4u");

var $8sWx6 = parcelRequire("8sWx6");

var $c546B = parcelRequire("c546B");
var $8732d4ef66564456$var$svg = function svg(_ref) {
    var appearance = _ref.appearance, iconGradientStart = _ref.iconGradientStart, iconGradientStop = _ref.iconGradientStop, iconColor = _ref.iconColor;
    var colors = {
        iconGradientStart: iconGradientStart,
        iconGradientStop: iconGradientStop,
        iconColor: iconColor
    };
    // Will be fixed upon removal of deprecated iconGradientStart and
    // iconGradientStop props, or with React 18's useId() hook when we update.
    // eslint-disable-next-line @repo/internal/react/disallow-unstable-values
    var id = (0, $h0JxK.uid)({
        iconGradientStart: iconGradientStop
    });
    if (appearance) colors = (0, $8sWx6.getColorsFromAppearance)(appearance);
    return '\n    <svg\n      fill="none"\n      height="32"\n      viewBox="0 0 32 32"\n      xmlns="http://www.w3.org/2000/svg"\n    >\n      <linearGradient\n        id="'.concat(id, '"\n        gradientUnits="userSpaceOnUse"\n        x1="13.9485"\n        x2="20.7792"\n        y1="20.2388"\n        y2="11.8277"\n      >\n        <stop offset="0" stop-color="').concat(colors.iconGradientStart, '" ').concat(colors.iconGradientStart === "inherit" ? 'stop-opacity="0.4"' : "", ' />\n        <stop offset="100%" stop-color="').concat(colors.iconGradientStop, '" />\n      </linearGradient>\n      <path\n        d="m18.3893 7-3.4257 13.1867c4.3592 1.2052 7.8383-.3558 9.1709-5.4802l1.9988-7.6973z"\n        fill="url(#').concat(id, ')"\n      />\n      <path\n      fill="').concat(colors.iconColor, '"\n      d="m13.7566 24.8265 3.4257-13.1866c-4.3623-1.196-7.8383.3649-9.17087 5.4985l-2.01143 7.6881z"\n      />\n    </svg>');
};
var $8732d4ef66564456$export$7330b9fc5718fd30 = function JiraWorkManagementIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? "Jira Work Management" : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $2na4u.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $2na4u.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$iconGradientSta = _ref2.iconGradientStart, iconGradientStart = _ref2$iconGradientSta === void 0 ? (0, $2na4u.defaultLogoParams).iconGradientStart : _ref2$iconGradientSta, _ref2$iconGradientSto = _ref2.iconGradientStop, iconGradientStop = _ref2$iconGradientSto === void 0 ? (0, $2na4u.defaultLogoParams).iconGradientStop : _ref2$iconGradientSto, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $2na4u.defaultLogoParams).textColor : _ref2$textColor;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $c546B.default), {
        appearance: appearance,
        label: label,
        svg: $8732d4ef66564456$var$svg({
            appearance: appearance,
            iconGradientStart: iconGradientStart,
            iconGradientStop: iconGradientStop,
            iconColor: iconColor
        }),
        iconColor: iconColor,
        iconGradientStart: iconGradientStart,
        iconGradientStop: iconGradientStop,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("21RuB", function(module, exports) {

$parcel$export(module.exports, "TrelloIcon", function () { return $17a52b448f3d04c2$export$4384da9b8b140bf4; });
/* eslint-disable max-len */ 
var $dAx5m = parcelRequire("dAx5m");

var $h0JxK = parcelRequire("h0JxK");

var $2na4u = parcelRequire("2na4u");

var $8sWx6 = parcelRequire("8sWx6");

var $c546B = parcelRequire("c546B");
var $17a52b448f3d04c2$var$svg = function svg(_ref) {
    var appearance = _ref.appearance, iconGradientStart = _ref.iconGradientStart, iconGradientStop = _ref.iconGradientStop;
    var colors = {
        iconGradientStart: iconGradientStart,
        iconGradientStop: iconGradientStop
    };
    // Will be fixed upon removal of deprecated iconGradientStart and
    // iconGradientStop props, or with React 18's useId() hook when we update.
    // eslint-disable-next-line @repo/internal/react/disallow-unstable-values
    var id = (0, $h0JxK.uid)({
        iconGradientStart: iconGradientStop
    });
    if (appearance) colors = (0, $8sWx6.getColorsFromAppearance)(appearance);
    return '\n<svg viewBox="0 0 32 32" height="32" xmlns="http://www.w3.org/2000/svg" focusable="false" aria-hidden="true">\n  <defs>\n    <linearGradient id="'.concat(id, '" x1="16.3382" y1="25.6824" x2="16.3382" y2="7.00599" gradientUnits="userSpaceOnUse">\n      <stop stop-color="').concat(colors.iconGradientStart, ' "').concat(colors.iconGradientStart === "inherit" ? 'stop-opacity="0.4"' : "", ' />\n      <stop offset="100%" stop-color="').concat(colors.iconGradientStop, '"/>\n    </linearGradient>\n  </defs>\n  <path\n    fill-rule="evenodd"\n    clip-rule="evenodd"\n    d="M23.4579 7H9.21854C8.63014 7 8.06585 7.23374 7.64979 7.64979C7.23374 8.06585 7 8.63014 7 9.21854V23.4669C7 24.0553 7.23374 24.6196 7.64979 25.0356C8.06585 25.4517 8.63014 25.6854 9.21854 25.6854H23.4579C24.0463 25.6854 24.6106 25.4517 25.0266 25.0356C25.4427 24.6196 25.6764 24.0553 25.6764 23.4669V9.22452C25.6772 8.93268 25.6204 8.64354 25.5093 8.37369C25.3981 8.10383 25.2348 7.85855 25.0287 7.65191C24.8227 7.44527 24.5778 7.28131 24.3083 7.16945C24.0387 7.05758 23.7497 7 23.4579 7V7ZM15.0448 20.4729C15.0448 20.6685 14.9673 20.8561 14.8293 20.9947C14.6912 21.1333 14.5039 21.2116 14.3083 21.2124H11.1856C10.9897 21.2116 10.802 21.1334 10.6635 20.9949C10.525 20.8564 10.4469 20.6688 10.4461 20.4729V11.1916C10.4469 10.9957 10.525 10.808 10.6635 10.6695C10.802 10.531 10.9897 10.4528 11.1856 10.4521H14.3083C14.5039 10.4528 14.6912 10.5311 14.8293 10.6697C14.9673 10.8083 15.0448 10.996 15.0448 11.1916V20.4729ZM22.2304 16.2185C22.2296 16.4143 22.1514 16.602 22.0129 16.7405C21.8744 16.879 21.6867 16.9572 21.4908 16.958H18.3681C18.1725 16.9572 17.9852 16.8789 17.8471 16.7403C17.7091 16.6017 17.6316 16.4141 17.6316 16.2185V11.1916C17.6316 10.996 17.7091 10.8083 17.8471 10.6697C17.9852 10.5311 18.1725 10.4528 18.3681 10.4521H21.4908C21.6867 10.4528 21.8744 10.531 22.0129 10.6695C22.1514 10.808 22.2296 10.9957 22.2304 11.1916V16.2185Z"\n    fill="url(#').concat(id, ')"\n  />\n</svg>\n');
};
var $17a52b448f3d04c2$export$4384da9b8b140bf4 = function TrelloIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? "Trello" : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $2na4u.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $2na4u.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$iconGradientSta = _ref2.iconGradientStart, iconGradientStart = _ref2$iconGradientSta === void 0 ? (0, $2na4u.defaultLogoParams).iconGradientStart : _ref2$iconGradientSta, _ref2$iconGradientSto = _ref2.iconGradientStop, iconGradientStop = _ref2$iconGradientSto === void 0 ? (0, $2na4u.defaultLogoParams).iconGradientStop : _ref2$iconGradientSto, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $2na4u.defaultLogoParams).textColor : _ref2$textColor;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $c546B.default), {
        appearance: appearance,
        label: label,
        svg: $17a52b448f3d04c2$var$svg({
            appearance: appearance,
            iconGradientStart: iconGradientStart,
            iconGradientStop: iconGradientStop
        }),
        iconColor: iconColor,
        iconGradientStart: iconGradientStart,
        iconGradientStop: iconGradientStop,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("5lc1q", function(module, exports) {

$parcel$export(module.exports, "ShortProductKey", function () { return $7c3a230f0051405f$export$736dd0bf2ecc436f; });
$parcel$export(module.exports, "ProductName", function () { return $7c3a230f0051405f$export$acdfad52bc8c6626; });
$parcel$export(module.exports, "LongProductKey", function () { return $7c3a230f0051405f$export$fc3a4bf3fb08b1b4; });
/**
 * ShortProductKey is used in code. It should not have a special characters or empty space
 */ var $7c3a230f0051405f$export$736dd0bf2ecc436f;
(function(ShortProductKey) {
    ShortProductKey["CONFLUENCE"] = "confluence";
    ShortProductKey["JIRA"] = "jira";
    ShortProductKey["JIRA_CORE"] = "jira_core";
    ShortProductKey["JIRA_SOFTWARE"] = "jira_software";
    ShortProductKey["JIRA_SERVICE_DESK"] = "jira_service_key";
    ShortProductKey["BITBUCKET"] = "bitbucket";
    ShortProductKey["TRELLO"] = "trello";
})($7c3a230f0051405f$export$736dd0bf2ecc436f || ($7c3a230f0051405f$export$736dd0bf2ecc436f = {}));
var $7c3a230f0051405f$export$acdfad52bc8c6626;
(function(ProductName) {
    ProductName["CONFLUENCE"] = "Confluence";
    ProductName["JIRA"] = "Jira";
    ProductName["JIRA_CORE"] = "Jira Core";
    ProductName["JIRA_SOFTWARE"] = "Jira Software";
    ProductName["JIRA_SERVICE_DESK"] = "Jira Service Desk";
    ProductName["BITBUCKET"] = "Bitbucket";
    ProductName["TRELLO"] = "Trello";
})($7c3a230f0051405f$export$acdfad52bc8c6626 || ($7c3a230f0051405f$export$acdfad52bc8c6626 = {}));
var $7c3a230f0051405f$export$fc3a4bf3fb08b1b4;
(function(LongProductKey) {
    LongProductKey["JIRA_CORE"] = "jira-core.ondemand";
    LongProductKey["JIRA_SOFTWARE"] = "jira-software.ondemand";
    LongProductKey["CONFLUENCE"] = "confluence.ondemand";
    LongProductKey["JIRA_SERVICE_DESK"] = "jira-servicedesk.ondemand";
    LongProductKey["BITBUCKET"] = "bitbucket";
    LongProductKey["TRELLO"] = "trello";
})($7c3a230f0051405f$export$fc3a4bf3fb08b1b4 || ($7c3a230f0051405f$export$fc3a4bf3fb08b1b4 = {}));

});



parcelRegister("3R11C", function(module, exports) {

$parcel$export(module.exports, "default", function () { return (parcelRequire("aocz5")).default; });

var $aocz5 = parcelRequire("aocz5");

});
parcelRegister("aocz5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $898512501346540f$export$2e2bcd8739ae039; });

var $bibO8 = parcelRequire("bibO8");

var $dAx5m = parcelRequire("dAx5m");

var $34Y0p = parcelRequire("34Y0p");

var $gUp5b = parcelRequire("gUp5b");

var $4FNod = parcelRequire("4FNod");
const $898512501346540f$var$InlineHelpInfoIcon = ({ message: message, position: position = "bottom-start", appearance: appearance = "light" })=>{
    const [isOpen, setIsOpen] = (0, $dAx5m.useState)(false);
    const showInlineDialog = ()=>{
        setIsOpen(true);
    };
    const hideInlineDialog = ()=>{
        setIsOpen(false);
    };
    const renderInlineDialogContent = ()=>{
        return /*#__PURE__*/ (0, $bibO8.jsx)($34Y0p.DialogContent, {
            children: /*#__PURE__*/ (0, $bibO8.jsx)($34Y0p.DialogMessage, {
                children: message
            })
        });
    };
    return /*#__PURE__*/ (0, $bibO8.jsx)($34Y0p.Root, {
        onMouseEnter: showInlineDialog,
        onMouseLeave: hideInlineDialog,
        children: /*#__PURE__*/ (0, $bibO8.jsx)((0, $4FNod.default), {
            content: renderInlineDialogContent(),
            isOpen: isOpen,
            placement: position,
            children: /*#__PURE__*/ (0, $bibO8.jsx)($34Y0p.DisclaimerIconWrapper, {
                appearance: appearance,
                tabIndex: 0,
                onFocus: showInlineDialog,
                onBlur: hideInlineDialog,
                children: /*#__PURE__*/ (0, $bibO8.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gUp5b))), {
                    size: "small",
                    label: "Editor info"
                })
            })
        })
    });
};
var $898512501346540f$export$2e2bcd8739ae039 = $898512501346540f$var$InlineHelpInfoIcon;

});
parcelRegister("34Y0p", function(module, exports) {

$parcel$export(module.exports, "Root", function () { return $f1894f6725880608$export$be92b6f5f03c0fe9; });
$parcel$export(module.exports, "DisclaimerIconWrapper", function () { return $f1894f6725880608$export$d2292681c113e6d5; });
$parcel$export(module.exports, "DialogContent", function () { return $f1894f6725880608$export$b6d9565de1e068cf; });
$parcel$export(module.exports, "DialogMessage", function () { return $f1894f6725880608$export$5764b090197204dc; });

var $ku6eE = parcelRequire("ku6eE");

var $5MUVm = parcelRequire("5MUVm");

var $gbKg7 = parcelRequire("gbKg7");
const $f1894f6725880608$export$be92b6f5f03c0fe9 = (0, $ku6eE.default).span`
  cursor: pointer;
  display: inline-block;
  margin-left: ${(0, $gbKg7.default)("space.050", "4px")};
  vertical-align: middle;
`;
const $f1894f6725880608$export$d2292681c113e6d5 = (0, $ku6eE.default).span`
  color: ${(props)=>props.appearance === "dark" ? (0, $gbKg7.default)("color.icon", (0, $5MUVm).N200) : (0, $gbKg7.default)("color.icon.subtle", (0, $5MUVm).N90)};

  &:focus {
    outline: none;
    box-shadow: 0 0 0 2px ${(0, $gbKg7.default)("elevation.shadow.overlay", (0, $5MUVm).B100)}
      inset;
  }
`;
const $f1894f6725880608$export$b6d9565de1e068cf = (0, $ku6eE.default).div`
  font-size: 14px;
  font-weight: normal;
  width: 280px;
`;
const $f1894f6725880608$export$5764b090197204dc = (0, $ku6eE.default).p`
  margin-top: ${(0, $gbKg7.default)("space.150", "12px")};
  line-height: ${(0, $gbKg7.default)("space.250", "20px")};
`;

});

parcelRegister("gUp5b", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c4f55530b8a950ce$var$_react = $c4f55530b8a950ce$var$_interopRequireDefault((parcelRequire("dAx5m")));

var $9eGJl = parcelRequire("9eGJl");
function $c4f55530b8a950ce$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $c4f55530b8a950ce$var$EditorInfoIcon = (props)=>/*#__PURE__*/ $c4f55530b8a950ce$var$_react.default.createElement($9eGJl.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path d="M12 20a8 8 0 110-16 8 8 0 010 16zm0-8.5a1 1 0 00-1 1V15a1 1 0 002 0v-2.5a1 1 0 00-1-1zm0-1.125a1.375 1.375 0 100-2.75 1.375 1.375 0 000 2.75z" fill="currentColor" fill-rule="evenodd"/></svg>`
    }, props));
$c4f55530b8a950ce$var$EditorInfoIcon.displayName = "EditorInfoIcon";
var $c4f55530b8a950ce$var$_default = $c4f55530b8a950ce$var$EditorInfoIcon;
module.exports.default = $c4f55530b8a950ce$var$_default;

});

parcelRegister("4FNod", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $36714d8400c5a336$export$2e2bcd8739ae039; });
/** @jsx jsx */ 
var $dAx5m = parcelRequire("dAx5m");

var $jVTBW = parcelRequire("jVTBW");

var $dd4sf = parcelRequire("dd4sf");

var $9TKQ2 = parcelRequire("9TKQ2");

var $dKICx = parcelRequire("dKICx");
var $7zI9Y = parcelRequire("7zI9Y");
var $22J5O = parcelRequire("22J5O");

var $Bb0he = parcelRequire("Bb0he");

var $2f6fs = parcelRequire("2f6fs");

var $2Uxik = parcelRequire("2Uxik");

var $expeE = parcelRequire("expeE");
var $hl98J = parcelRequire("hl98J");
var $4Yjoy = parcelRequire("4Yjoy");

var $ia4mY = parcelRequire("ia4mY");
var $36714d8400c5a336$var$packageName = "@atlaskit/inline-dialog";
var $36714d8400c5a336$var$packageVersion = "14.1.2";
var $36714d8400c5a336$var$checkIsChildOfPortal = function checkIsChildOfPortal(node) {
    if (!node) return false;
    return node.classList && node.classList.contains("atlaskit-portal-container") || checkIsChildOfPortal(node.parentElement);
};
var $36714d8400c5a336$export$513033cc22e3bc20 = /*#__PURE__*/ (0, $dAx5m.memo)(function InlineDialog(_ref) {
    var _ref$isOpen = _ref.isOpen, isOpen = _ref$isOpen === void 0 ? false : _ref$isOpen, _ref$onContentBlur = _ref.onContentBlur, onContentBlur = _ref$onContentBlur === void 0 ? (0, $Bb0he.default) : _ref$onContentBlur, _ref$onContentClick = _ref.onContentClick, onContentClick = _ref$onContentClick === void 0 ? (0, $Bb0he.default) : _ref$onContentClick, _ref$onContentFocus = _ref.onContentFocus, onContentFocus = _ref$onContentFocus === void 0 ? (0, $Bb0he.default) : _ref$onContentFocus, _ref$onClose = _ref.onClose, onClose = _ref$onClose === void 0 ? (0, $Bb0he.default) : _ref$onClose, _ref$placement = _ref.placement, placement = _ref$placement === void 0 ? "bottom-start" : _ref$placement, _ref$strategy = _ref.strategy, strategy = _ref$strategy === void 0 ? "fixed" : _ref$strategy, testId = _ref.testId, content = _ref.content, children = _ref.children;
    var containerRef = (0, $dAx5m.useRef)(null);
    var triggerRef = (0, $dAx5m.useRef)(null);
    // we put this into a ref to avoid handleCloseRequest having this as a dependency
    var onCloseRef = (0, $dAx5m.useRef)(onClose);
    (0, $dAx5m.useEffect)(function() {
        onCloseRef.current = onClose;
    });
    var _UNSAFE_useLayering = (0, $2f6fs.UNSAFE_useLayering)(), isLayerDisabled = _UNSAFE_useLayering.isLayerDisabled;
    var handleCloseRequest = (0, $dAx5m.useCallback)(function(event) {
        var target = event.target;
        // checks for when target is not HTMLElement
        if (!(target instanceof HTMLElement)) return;
        // TODO: This is to handle the case where the target is no longer in the DOM.
        // This happens with react-select in datetime picker. There might be other
        // edge cases for this.
        if (!document.body.contains(target)) return;
        if ((0, $2Uxik.getBooleanFF)("platform.design-system-team.inline-message-layering_wfp1p")) {
            if (!isLayerDisabled()) {
                var _onCloseRef$current;
                (_onCloseRef$current = onCloseRef.current) === null || _onCloseRef$current === void 0 || _onCloseRef$current.call(onCloseRef, {
                    isOpen: false,
                    event: event
                });
            }
        } else {
            // handles the case where inline dialog opens portalled elements such as modal
            if ($36714d8400c5a336$var$checkIsChildOfPortal(target)) return;
            // call onClose if the click originated from outside the dialog
            if (containerRef.current && !containerRef.current.contains(target)) {
                var _onCloseRef$current2;
                (_onCloseRef$current2 = onCloseRef.current) === null || _onCloseRef$current2 === void 0 || _onCloseRef$current2.call(onCloseRef, {
                    isOpen: false,
                    event: event
                });
            }
        }
    }, [
        isLayerDisabled
    ]);
    var handleClick = (0, $dAx5m.useCallback)(function(event) {
        var _containerRef$current;
        // exit if we click outside but on the trigger — it can handle the clicks itself
        if (triggerRef.current && triggerRef.current.contains(event.target)) return;
        // if feature flag is enabled we won't file the close event when clicking inside dialog
        if ((0, $2Uxik.getBooleanFF)("platform.design-system-team.inline-message-layering_wfp1p") && (_containerRef$current = containerRef.current) !== null && _containerRef$current !== void 0 && _containerRef$current.contains(event.target)) return;
        handleCloseRequest(event);
    }, [
        handleCloseRequest
    ]);
    (0, $dAx5m.useEffect)(function() {
        if (!isOpen) return;
        var unbind = (0, $dd4sf.bind)(window, {
            type: "click",
            listener: handleClick,
            options: {
                capture: true
            }
        });
        return unbind;
    }, [
        isOpen,
        handleClick
    ]);
    var handleKeyDown = (0, $dAx5m.useCallback)(function(event) {
        if (event.key === "Escape") handleCloseRequest(event);
    }, [
        handleCloseRequest
    ]);
    (0, $dAx5m.useEffect)(function() {
        if (!isOpen) return;
        var unbind = (0, $dd4sf.bind)(window, {
            type: "keydown",
            listener: handleKeyDown,
            options: {
                capture: true
            }
        });
        return unbind;
    }, [
        isOpen,
        handleKeyDown
    ]);
    var popper = isOpen ? (0, $jVTBW.jsx)((0, $hl98J.Popper), {
        placement: placement,
        strategy: strategy
    }, function(_ref2) {
        var _ref3 = _ref2.ref, style = _ref2.style;
        return (0, $jVTBW.jsx)((0, $ia4mY.Container), {
            onBlur: onContentBlur,
            onFocus: onContentFocus,
            onClick: onContentClick,
            ref: function ref(node) {
                if (node) {
                    containerRef.current = node;
                    if (typeof _ref3 === "function") _ref3(node);
                    else _ref3.current = node;
                }
            },
            style: style,
            testId: testId
        }, content);
    }) : null;
    return (0, $jVTBW.jsx)((0, $expeE.Manager), null, (0, $jVTBW.jsx)((0, $4Yjoy.Reference), null, function(_ref4) {
        var ref = _ref4.ref;
        return (0, $jVTBW.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9TKQ2))), {
            innerRef: function innerRef(node) {
                triggerRef.current = node;
                if (typeof ref === "function") ref(node);
                else ref.current = node;
            }
        }, (0, $jVTBW.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).Fragment, null, children));
    }), popper);
});
$36714d8400c5a336$export$513033cc22e3bc20.displayName = "InlineDialog";
var $36714d8400c5a336$var$createAndFireEventOnAtlaskit = (0, $dKICx.default)("atlaskit");
var $36714d8400c5a336$export$2e2bcd8739ae039 = (0, $7zI9Y.default)({
    componentName: "inlineDialog",
    packageName: $36714d8400c5a336$var$packageName,
    packageVersion: $36714d8400c5a336$var$packageVersion
})((0, $22J5O.default)({
    onClose: $36714d8400c5a336$var$createAndFireEventOnAtlaskit({
        action: "closed",
        actionSubject: "inlineDialog",
        attributes: {
            componentName: "inlineDialog",
            packageName: $36714d8400c5a336$var$packageName,
            packageVersion: $36714d8400c5a336$var$packageVersion
        }
    })
})($36714d8400c5a336$export$513033cc22e3bc20));

});
parcelRegister("9TKQ2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $gn9qB = parcelRequire("gn9qB");
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function get() {
        return $734d953e6353df2e$var$_interopRequireDefault($gn9qB).default;
    }
});
function $734d953e6353df2e$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}

});
parcelRegister("gn9qB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $beb61b8dcb9a3cb3$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $dAx5m = parcelRequire("dAx5m");

var $1MpXQ = parcelRequire("1MpXQ");
function $beb61b8dcb9a3cb3$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $beb61b8dcb9a3cb3$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $beb61b8dcb9a3cb3$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $beb61b8dcb9a3cb3$var$NodeResolver = function(_Component) {
    $beb61b8dcb9a3cb3$var$_inherits(NodeResolver, _Component);
    function NodeResolver() {
        $beb61b8dcb9a3cb3$var$_classCallCheck(this, NodeResolver);
        return $beb61b8dcb9a3cb3$var$_possibleConstructorReturn(this, (NodeResolver.__proto__ || Object.getPrototypeOf(NodeResolver)).apply(this, arguments));
    }
    $beb61b8dcb9a3cb3$var$_createClass(NodeResolver, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.props.innerRef((0, $1MpXQ.findDOMNode)(this));
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.props.innerRef(null);
            }
        },
        {
            key: "render",
            value: function render() {
                return this.props.children;
            }
        }
    ]);
    return NodeResolver;
}($dAx5m.Component);
module.exports.default = $beb61b8dcb9a3cb3$var$NodeResolver;

});


parcelRegister("dKICx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a0322efabe908114$export$2e2bcd8739ae039; });
var $a0322efabe908114$export$2e2bcd8739ae039 = function(channel) {
    return function(payload) {
        return function(createAnalyticsEvent) {
            var consumerEvent = createAnalyticsEvent(payload);
            var clonedEvent = consumerEvent.clone();
            if (clonedEvent) clonedEvent.fire(channel);
            return consumerEvent;
        };
    };
};

});

parcelRegister("7zI9Y", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $583e0e8356e25b3a$export$2e2bcd8739ae039; });

var $5ErLv = parcelRequire("5ErLv");

var $9NvhG = parcelRequire("9NvhG");

var $kVdVk = parcelRequire("kVdVk");

var $dAx5m = parcelRequire("dAx5m");

var $jfBGx = parcelRequire("jfBGx");
var $583e0e8356e25b3a$var$_excluded = [
    "analyticsContext"
];
function $583e0e8356e25b3a$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $583e0e8356e25b3a$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $583e0e8356e25b3a$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($9NvhG)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $583e0e8356e25b3a$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $583e0e8356e25b3a$var$withAnalyticsContext = function withAnalyticsContext(defaultData) {
    return function(WrappedComponent) {
        var WithAnalyticsContext = /*#__PURE__*/ (0, $dAx5m.forwardRef)(function(_ref, ref) {
            var analyticsContext = _ref.analyticsContext, rest = (0, (/*@__PURE__*/$parcel$interopDefault($kVdVk)))(_ref, $583e0e8356e25b3a$var$_excluded);
            var analyticsData = (0, $dAx5m.useMemo)(function() {
                return $583e0e8356e25b3a$var$_objectSpread($583e0e8356e25b3a$var$_objectSpread({}, defaultData), analyticsContext);
            }, [
                analyticsContext
            ]);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $jfBGx.default), {
                data: analyticsData
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement(WrappedComponent, (0, (/*@__PURE__*/$parcel$interopDefault($5ErLv)))({}, rest, {
                ref: ref
            })));
        });
        WithAnalyticsContext.displayName = "WithAnalyticsContext(".concat(WrappedComponent.displayName || WrappedComponent.name, ")");
        return WithAnalyticsContext;
    };
};
var $583e0e8356e25b3a$export$2e2bcd8739ae039 = $583e0e8356e25b3a$var$withAnalyticsContext;

});
parcelRegister("5ErLv", function(module, exports) {
function $41d639cb9fda6dec$var$_extends() {
    return module.exports = $41d639cb9fda6dec$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $41d639cb9fda6dec$var$_extends.apply(null, arguments);
}
module.exports = $41d639cb9fda6dec$var$_extends, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("9NvhG", function(module, exports) {

var $jauPp = parcelRequire("jauPp");
function $7220f50ff29c99e5$var$_defineProperty(e, r, t) {
    return (r = $jauPp(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
module.exports = $7220f50ff29c99e5$var$_defineProperty, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("jauPp", function(module, exports) {

var $4rA6e = parcelRequire("4rA6e");
var $df46dd51a8c6b110$var$_typeof = $4rA6e.default;

var $buoM1 = parcelRequire("buoM1");
function $df46dd51a8c6b110$var$toPropertyKey(t) {
    var i = $buoM1(t, "string");
    return "symbol" == $df46dd51a8c6b110$var$_typeof(i) ? i : i + "";
}
module.exports = $df46dd51a8c6b110$var$toPropertyKey, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("4rA6e", function(module, exports) {
function $33c5afa43d6a7639$var$_typeof(o) {
    "@babel/helpers - typeof";
    return module.exports = $33c5afa43d6a7639$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $33c5afa43d6a7639$var$_typeof(o);
}
module.exports = $33c5afa43d6a7639$var$_typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("buoM1", function(module, exports) {

var $4rA6e = parcelRequire("4rA6e");
var $85d5b692da83d8f4$var$_typeof = $4rA6e.default;
function $85d5b692da83d8f4$var$toPrimitive(t, r) {
    if ("object" != $85d5b692da83d8f4$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $85d5b692da83d8f4$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
module.exports = $85d5b692da83d8f4$var$toPrimitive, module.exports.__esModule = true, module.exports["default"] = module.exports;

});



parcelRegister("kVdVk", function(module, exports) {

var $jhtPl = parcelRequire("jhtPl");
function $f3b3ee737d303cd8$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $jhtPl(e, t);
    if (Object.getOwnPropertySymbols) {
        var s = Object.getOwnPropertySymbols(e);
        for(r = 0; r < s.length; r++)o = s[r], t.includes(o) || ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
module.exports = $f3b3ee737d303cd8$var$_objectWithoutProperties, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("jhtPl", function(module, exports) {
function $e096bde921f0e1cb$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.includes(n)) continue;
        t[n] = r[n];
    }
    return t;
}
module.exports = $e096bde921f0e1cb$var$_objectWithoutPropertiesLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("jfBGx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e03ca6888567e361$export$2e2bcd8739ae039; });

var $dAx5m = parcelRequire("dAx5m");

var $4l6L2 = parcelRequire("4l6L2");

var $4fVTG = parcelRequire("4fVTG");

var $eTxpk = parcelRequire("eTxpk");

var $57BQR = parcelRequire("57BQR");
var $e03ca6888567e361$var$ExportedAnalyticsContext = function ExportedAnalyticsContext(props) {
    var isModernContext = (0, $4fVTG.default) || (0, $4l6L2.fg)("platform.analytics-next-use-modern-context_fqgbx");
    return isModernContext ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $57BQR.default), props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $eTxpk.default), props);
};
var $e03ca6888567e361$export$2e2bcd8739ae039 = $e03ca6888567e361$var$ExportedAnalyticsContext;

});
parcelRegister("4l6L2", function(module, exports) {

$parcel$export(module.exports, "fg", function () { return $328e5d88b6719f52$export$b40ec24ac8275656; });

var $bJRAZ = parcelRequire("bJRAZ");
function $328e5d88b6719f52$export$ba05d765b8392e5e(flagResolver) {
    (0, $bJRAZ.setBooleanResolver)(flagResolver);
}
function $328e5d88b6719f52$export$470e5c2be1411c89(name) {
    return (0, $bJRAZ.resolveBooleanFlag)(name);
}
function $328e5d88b6719f52$export$b40ec24ac8275656(name) {
    return (0, $bJRAZ.resolveBooleanFlag)(name);
}

});
parcelRegister("bJRAZ", function(module, exports) {

$parcel$export(module.exports, "setBooleanResolver", function () { return $88bd78a80a4e2d95$export$f2b591175b3e424c; });
$parcel$export(module.exports, "resolveBooleanFlag", function () { return $88bd78a80a4e2d95$export$6333b6aff9fc6275; });

var $6gF74 = parcelRequire("6gF74");

var $ahJoN = parcelRequire("ahJoN");
var $88bd78a80a4e2d95$var$pkgName = "@atlaskit/platform-feature-flags";
var $88bd78a80a4e2d95$export$7e41b1b2bdee3f98 = "__PLATFORM_FEATURE_FLAGS__";
var $88bd78a80a4e2d95$var$hasProcessEnv = typeof $ahJoN !== "undefined" && typeof $ahJoN.env !== "undefined";
// FF global overrides can be configured by test runners or Storybook
var $88bd78a80a4e2d95$var$ENV_ENABLE_PLATFORM_FF = $88bd78a80a4e2d95$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
// STORYBOOK_ENABLE_PLATFORM_FF is included as storybook only allows env vars prefixed with STORYBOOK
// https://github.com/storybookjs/storybook/issues/12270
var $88bd78a80a4e2d95$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF = $88bd78a80a4e2d95$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
var $88bd78a80a4e2d95$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE = $88bd78a80a4e2d95$var$ENV_ENABLE_PLATFORM_FF || $88bd78a80a4e2d95$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF;
var $88bd78a80a4e2d95$var$DEFAULT_PFF_GLOBAL = {
    // In development mode we want to capture any feature flag checks that happen using the default resolver and log this result when the resolver is replaced.
    // This is because evaluating feature flags when the resolver/FF client is loaded asynchronously could cause unexpected issues.
    earlyResolvedFlags: new Map(),
    booleanResolver: function booleanResolver(flagKey) {
        var unresolvedFlagCount;
        return false;
    }
};
var $88bd78a80a4e2d95$var$globalVar = typeof window !== "undefined" ? window : globalThis;
$88bd78a80a4e2d95$var$globalVar[$88bd78a80a4e2d95$export$7e41b1b2bdee3f98] = $88bd78a80a4e2d95$var$globalVar[$88bd78a80a4e2d95$export$7e41b1b2bdee3f98] || $88bd78a80a4e2d95$var$DEFAULT_PFF_GLOBAL;
function $88bd78a80a4e2d95$export$f2b591175b3e424c(resolver) {
    $88bd78a80a4e2d95$var$globalVar[$88bd78a80a4e2d95$export$7e41b1b2bdee3f98].booleanResolver = resolver;
    var _globalVar$PFF_GLOBAL;
}
function $88bd78a80a4e2d95$export$6333b6aff9fc6275(flagKey) {
    if ($88bd78a80a4e2d95$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE) {
        (0, $6gF74.debug)('[%s]: The feature flags were enabled while running tests. The flag "%s" will be always enabled.', $88bd78a80a4e2d95$var$pkgName, flagKey);
        return true;
    }
    try {
        var _globalVar$PFF_GLOBAL2;
        var result = (_globalVar$PFF_GLOBAL2 = $88bd78a80a4e2d95$var$globalVar[$88bd78a80a4e2d95$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL2 === void 0 ? void 0 : _globalVar$PFF_GLOBAL2.booleanResolver(flagKey);
        if (typeof result !== "boolean") {
            // eslint-disable-next-line no-console
            console.warn("".concat(flagKey, " resolved to a non-boolean value, returning false for safety"));
            return false;
        }
        return result;
    } catch (e) {
        return false;
    }
}

});
parcelRegister("6gF74", function(module, exports) {

$parcel$export(module.exports, "debug", function () { return $490420e599e2f2dc$export$1c9f709888824e05; });
var $490420e599e2f2dc$var$_ref, $490420e599e2f2dc$var$_process, $490420e599e2f2dc$var$_process2;
// We can't rely on NODE_ENV === 'test' if its value is already configured by the consumer to some other value, so better to use JEST_WORKER_ID
// https://jestjs.io/docs/environment-variables#jest_worker_id
var $490420e599e2f2dc$var$TESTS_MODE = ($490420e599e2f2dc$var$_ref = (globalThis === null || globalThis === void 0 || ($490420e599e2f2dc$var$_process = globalThis.process) === null || $490420e599e2f2dc$var$_process === void 0 || ($490420e599e2f2dc$var$_process = $490420e599e2f2dc$var$_process.env) === null || $490420e599e2f2dc$var$_process === void 0 ? void 0 : $490420e599e2f2dc$var$_process.JEST_WORKER_ID) !== undefined, $490420e599e2f2dc$var$_ref !== void 0) ? $490420e599e2f2dc$var$_ref : false;
var $490420e599e2f2dc$var$DEBUG_MODE = !$490420e599e2f2dc$var$TESTS_MODE && (globalThis === null || globalThis === void 0 || ($490420e599e2f2dc$var$_process2 = globalThis.process) === null || $490420e599e2f2dc$var$_process2 === void 0 || ($490420e599e2f2dc$var$_process2 = $490420e599e2f2dc$var$_process2.env) === null || $490420e599e2f2dc$var$_process2 === void 0 ? void 0 : $490420e599e2f2dc$var$_process2.NODE_ENV) !== "production";
var $490420e599e2f2dc$export$1c9f709888824e05 = function debug() {
    var _console;
    if (!$490420e599e2f2dc$var$DEBUG_MODE) return;
    // eslint-disable-next-line no-console
    (_console = console).debug.apply(_console, arguments);
};

});



parcelRegister("4fVTG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3195794851eabb06$export$2e2bcd8739ae039; });

var $ahJoN = parcelRequire("ahJoN");
var $3195794851eabb06$var$_process$env;
var $3195794851eabb06$export$2e2bcd8739ae039 = typeof $ahJoN !== "undefined" && $ahJoN !== null && (($3195794851eabb06$var$_process$env = {}, $3195794851eabb06$var$_process$env === void 0) ? void 0 : $3195794851eabb06$var$_process$env["ANALYTICS_NEXT_MODERN_CONTEXT"]);

});

parcelRegister("eTxpk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ad801dc1f2cb7965$export$2e2bcd8739ae039; });

var $alkT7 = parcelRequire("alkT7");

var $iFl3Y = parcelRequire("iFl3Y");

var $kirtm = parcelRequire("kirtm");

var $iwmvD = parcelRequire("iwmvD");

var $bqUiy = parcelRequire("bqUiy");

var $atbFx = parcelRequire("atbFx");

var $lIcHa = parcelRequire("lIcHa");

var $9NvhG = parcelRequire("9NvhG");

var $dAx5m = parcelRequire("dAx5m");

var $hyn2k = parcelRequire("hyn2k");

var $h0bf1 = parcelRequire("h0bf1");
function $ad801dc1f2cb7965$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $ad801dc1f2cb7965$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, (/*@__PURE__*/$parcel$interopDefault($lIcHa)))(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, (/*@__PURE__*/$parcel$interopDefault($lIcHa)))(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, (/*@__PURE__*/$parcel$interopDefault($atbFx)))(this, result);
    };
}
function $ad801dc1f2cb7965$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($ad801dc1f2cb7965$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $ad801dc1f2cb7965$var$ContextTypes = {
    getAtlaskitAnalyticsContext: (0, (/*@__PURE__*/$parcel$interopDefault($hyn2k))).func,
    getAtlaskitAnalyticsEventHandlers: (0, (/*@__PURE__*/$parcel$interopDefault($hyn2k))).func
};
var $ad801dc1f2cb7965$var$noop = function noop() {
    return [];
};
// eslint-disable-next-line @repo/internal/react/no-class-components
var $ad801dc1f2cb7965$var$AnalyticsContext = /*#__PURE__*/ function(_Component) {
    (0, (/*@__PURE__*/$parcel$interopDefault($bqUiy)))(AnalyticsContext, _Component);
    var _super = $ad801dc1f2cb7965$var$_createSuper(AnalyticsContext);
    function AnalyticsContext(props) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($iFl3Y)))(this, AnalyticsContext);
        _this = _super.call(this, props);
        (0, (/*@__PURE__*/$parcel$interopDefault($9NvhG)))((0, (/*@__PURE__*/$parcel$interopDefault($iwmvD)))(_this), "getChildContext", function() {
            return {
                getAtlaskitAnalyticsContext: _this.getAnalyticsContext
            };
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($9NvhG)))((0, (/*@__PURE__*/$parcel$interopDefault($iwmvD)))(_this), "getAnalyticsContext", function() {
            var data = _this.props.data;
            var _this$context$getAtla = _this.context.getAtlaskitAnalyticsContext, getAtlaskitAnalyticsContext = _this$context$getAtla === void 0 ? $ad801dc1f2cb7965$var$noop : _this$context$getAtla;
            return [].concat((0, (/*@__PURE__*/$parcel$interopDefault($alkT7)))(getAtlaskitAnalyticsContext()), [
                data
            ]);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($9NvhG)))((0, (/*@__PURE__*/$parcel$interopDefault($iwmvD)))(_this), "getAnalyticsEventHandlers", function() {
            var _this$context$getAtla2 = _this.context.getAtlaskitAnalyticsEventHandlers, getAtlaskitAnalyticsEventHandlers = _this$context$getAtla2 === void 0 ? $ad801dc1f2cb7965$var$noop : _this$context$getAtla2;
            return getAtlaskitAnalyticsEventHandlers();
        });
        _this.contextValue = {
            getAtlaskitAnalyticsContext: _this.getAnalyticsContext,
            getAtlaskitAnalyticsEventHandlers: _this.getAnalyticsEventHandlers
        };
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($kirtm)))(AnalyticsContext, [
        {
            key: "render",
            value: function render() {
                var children = this.props.children;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $h0bf1.default).Provider, {
                    value: this.contextValue
                }, children);
            }
        }
    ]);
    return AnalyticsContext;
}((0, $dAx5m.Component));
(0, (/*@__PURE__*/$parcel$interopDefault($9NvhG)))($ad801dc1f2cb7965$var$AnalyticsContext, "contextTypes", $ad801dc1f2cb7965$var$ContextTypes);
(0, (/*@__PURE__*/$parcel$interopDefault($9NvhG)))($ad801dc1f2cb7965$var$AnalyticsContext, "childContextTypes", $ad801dc1f2cb7965$var$ContextTypes);
var $ad801dc1f2cb7965$export$2e2bcd8739ae039 = $ad801dc1f2cb7965$var$AnalyticsContext;

});
parcelRegister("alkT7", function(module, exports) {

var $56zqD = parcelRequire("56zqD");

var $1S5zf = parcelRequire("1S5zf");

var $e9GhI = parcelRequire("e9GhI");

var $d7Ixz = parcelRequire("d7Ixz");
function $787c117f1a3a6f88$var$_toConsumableArray(r) {
    return $56zqD(r) || $1S5zf(r) || $e9GhI(r) || $d7Ixz();
}
module.exports = $787c117f1a3a6f88$var$_toConsumableArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("56zqD", function(module, exports) {

var $6L1i3 = parcelRequire("6L1i3");
function $3b78fea964e4c02f$var$_arrayWithoutHoles(r) {
    if (Array.isArray(r)) return $6L1i3(r);
}
module.exports = $3b78fea964e4c02f$var$_arrayWithoutHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("6L1i3", function(module, exports) {
function $4eb8220ec5246a1a$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
module.exports = $4eb8220ec5246a1a$var$_arrayLikeToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("1S5zf", function(module, exports) {
function $15cf2733044428a5$var$_iterableToArray(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
module.exports = $15cf2733044428a5$var$_iterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("e9GhI", function(module, exports) {

var $6L1i3 = parcelRequire("6L1i3");
function $a4e2b4cedcdf9231$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $6L1i3(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $6L1i3(r, a) : void 0;
    }
}
module.exports = $a4e2b4cedcdf9231$var$_unsupportedIterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("d7Ixz", function(module, exports) {
function $98de7a9f6c9250c3$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
module.exports = $98de7a9f6c9250c3$var$_nonIterableSpread, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("iFl3Y", function(module, exports) {
function $d96c64ff690507f9$var$_classCallCheck(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
module.exports = $d96c64ff690507f9$var$_classCallCheck, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("kirtm", function(module, exports) {

var $jauPp = parcelRequire("jauPp");
function $ec6acc93fb0975a0$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, $jauPp(o.key), o);
    }
}
function $ec6acc93fb0975a0$var$_createClass(e, r, t) {
    return r && $ec6acc93fb0975a0$var$_defineProperties(e.prototype, r), t && $ec6acc93fb0975a0$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}
module.exports = $ec6acc93fb0975a0$var$_createClass, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("iwmvD", function(module, exports) {
function $d7bcad035b6e899c$var$_assertThisInitialized(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}
module.exports = $d7bcad035b6e899c$var$_assertThisInitialized, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("bqUiy", function(module, exports) {

var $1dbvD = parcelRequire("1dbvD");
function $852dcb12bd5fc27f$var$_inherits(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && $1dbvD(t, e);
}
module.exports = $852dcb12bd5fc27f$var$_inherits, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("1dbvD", function(module, exports) {
function $0e1feedd0b2e6e7f$var$_setPrototypeOf(t, e) {
    return module.exports = $0e1feedd0b2e6e7f$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $0e1feedd0b2e6e7f$var$_setPrototypeOf(t, e);
}
module.exports = $0e1feedd0b2e6e7f$var$_setPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("atbFx", function(module, exports) {

var $4rA6e = parcelRequire("4rA6e");
var $79f5aa0e596a03bc$var$_typeof = $4rA6e.default;

var $iwmvD = parcelRequire("iwmvD");
function $79f5aa0e596a03bc$var$_possibleConstructorReturn(t, e) {
    if (e && ("object" == $79f5aa0e596a03bc$var$_typeof(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return $iwmvD(t);
}
module.exports = $79f5aa0e596a03bc$var$_possibleConstructorReturn, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("lIcHa", function(module, exports) {
function $fce78e086d8fbc32$var$_getPrototypeOf(t) {
    return module.exports = $fce78e086d8fbc32$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $fce78e086d8fbc32$var$_getPrototypeOf(t);
}
module.exports = $fce78e086d8fbc32$var$_getPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("hyn2k", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $cc777b3441cfdc93$var$ReactIs, $cc777b3441cfdc93$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
module.exports = (parcelRequire("365gO"))();

});
parcelRegister("365gO", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";

var $bSHkX = parcelRequire("bSHkX");
function $2416052f3092513f$var$emptyFunction() {}
function $2416052f3092513f$var$emptyFunctionWithReset() {}
$2416052f3092513f$var$emptyFunctionWithReset.resetWarningCache = $2416052f3092513f$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $bSHkX) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = "Invariant Violation";
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $2416052f3092513f$var$emptyFunctionWithReset,
        resetWarningCache: $2416052f3092513f$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("bSHkX", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var $8a665ab4f63b0a7e$var$ReactPropTypesSecret = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
module.exports = $8a665ab4f63b0a7e$var$ReactPropTypesSecret;

});




parcelRegister("57BQR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3baaf7bf510af443$export$2e2bcd8739ae039; });

var $alkT7 = parcelRequire("alkT7");

var $dAx5m = parcelRequire("dAx5m");

var $h0bf1 = parcelRequire("h0bf1");

var $dKZB3 = parcelRequire("dKZB3");

var $8ZXHz = parcelRequire("8ZXHz");
var $3baaf7bf510af443$var$AnalyticsContext = function AnalyticsContext(_ref) {
    var data = _ref.data, children = _ref.children;
    var dataRef = (0, $8ZXHz.useTrackedRef)(data);
    var _useAnalyticsContext = (0, $dKZB3.useAnalyticsContext)(), getAtlaskitAnalyticsEventHandlers = _useAnalyticsContext.getAtlaskitAnalyticsEventHandlers, getOriginalAnalyticsContext = _useAnalyticsContext.getAtlaskitAnalyticsContext;
    var getAtlaskitAnalyticsContext = (0, $dAx5m.useCallback)(function() {
        return [].concat((0, (/*@__PURE__*/$parcel$interopDefault($alkT7)))(getOriginalAnalyticsContext()), [
            dataRef.current
        ]);
    }, [
        getOriginalAnalyticsContext,
        dataRef
    ]);
    var value = (0, $dAx5m.useMemo)(function() {
        return {
            getAtlaskitAnalyticsContext: getAtlaskitAnalyticsContext,
            getAtlaskitAnalyticsEventHandlers: getAtlaskitAnalyticsEventHandlers
        };
    }, [
        getAtlaskitAnalyticsContext,
        getAtlaskitAnalyticsEventHandlers
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $h0bf1.default).Provider, {
        value: value
    }, children);
};
var $3baaf7bf510af443$export$2e2bcd8739ae039 = $3baaf7bf510af443$var$AnalyticsContext;

});
parcelRegister("dKZB3", function(module, exports) {

$parcel$export(module.exports, "useAnalyticsContext", function () { return $a03f5a0b90593914$export$d1f587f82ad51c4; });

var $dAx5m = parcelRequire("dAx5m");

var $h0bf1 = parcelRequire("h0bf1");
var $a03f5a0b90593914$export$d1f587f82ad51c4 = function useAnalyticsContext() {
    return (0, $dAx5m.useContext)((0, $h0bf1.default));
};

});

parcelRegister("8ZXHz", function(module, exports) {

$parcel$export(module.exports, "useTrackedRef", function () { return $68d254bfdcfda85e$export$1d27a74659855e44; });

var $dAx5m = parcelRequire("dAx5m");
var $68d254bfdcfda85e$export$1d27a74659855e44 = function useTrackedRef(value) {
    var ref = (0, $dAx5m.useRef)(value);
    ref.current = value;
    return ref;
};

});




parcelRegister("22J5O", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $17cebf29cc507b9d$export$2e2bcd8739ae039; });

var $5ErLv = parcelRequire("5ErLv");

var $dAx5m = parcelRequire("dAx5m");

var $c8OCt = parcelRequire("c8OCt");

var $gGvgA = parcelRequire("gGvgA");
var $17cebf29cc507b9d$var$withAnalyticsEvents = function withAnalyticsEvents() {
    var createEventMap = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return function(WrappedComponent) {
        var WithAnalyticsEvents = /*#__PURE__*/ (0, $dAx5m.forwardRef)(function(props, ref) {
            var _usePatchedProps = (0, $gGvgA.usePatchedProps)(createEventMap, props), patchedEventProps = _usePatchedProps.patchedEventProps;
            var _useAnalyticsEvents = (0, $c8OCt.useAnalyticsEvents)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement(WrappedComponent, (0, (/*@__PURE__*/$parcel$interopDefault($5ErLv)))({}, props, patchedEventProps, {
                createAnalyticsEvent: createAnalyticsEvent,
                ref: ref
            }));
        });
        WithAnalyticsEvents.displayName = "WithAnalyticsEvents(".concat(WrappedComponent.displayName || WrappedComponent.name, ")");
        return WithAnalyticsEvents;
    };
};
var $17cebf29cc507b9d$export$2e2bcd8739ae039 = $17cebf29cc507b9d$var$withAnalyticsEvents;

});
parcelRegister("c8OCt", function(module, exports) {

$parcel$export(module.exports, "useAnalyticsEvents", function () { return $8d6d7f65c951dca3$export$5bf35293e545f20c; });

var $tWuif = parcelRequire("tWuif");

var $gwHZY = parcelRequire("gwHZY");

var $dKZB3 = parcelRequire("dKZB3");
function $8d6d7f65c951dca3$export$5bf35293e545f20c() {
    var analyticsContext = (0, $dKZB3.useAnalyticsContext)();
    var createAnalyticsEvent = (0, $tWuif.useCallbackOne)(function(payload) {
        return new (0, $gwHZY.default)({
            context: analyticsContext.getAtlaskitAnalyticsContext(),
            handlers: analyticsContext.getAtlaskitAnalyticsEventHandlers(),
            payload: payload
        });
    }, [
        analyticsContext
    ]);
    return {
        createAnalyticsEvent: createAnalyticsEvent
    };
}

});
parcelRegister("gwHZY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c081c3b1833d944c$export$2e2bcd8739ae039; });

var $alkT7 = parcelRequire("alkT7");

var $iFl3Y = parcelRequire("iFl3Y");

var $kirtm = parcelRequire("kirtm");

var $iwmvD = parcelRequire("iwmvD");

var $kOUZd = parcelRequire("kOUZd");

var $bqUiy = parcelRequire("bqUiy");

var $atbFx = parcelRequire("atbFx");

var $lIcHa = parcelRequire("lIcHa");

var $9NvhG = parcelRequire("9NvhG");

var $bD09g = parcelRequire("bD09g");
function $c081c3b1833d944c$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $c081c3b1833d944c$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, (/*@__PURE__*/$parcel$interopDefault($lIcHa)))(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, (/*@__PURE__*/$parcel$interopDefault($lIcHa)))(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, (/*@__PURE__*/$parcel$interopDefault($atbFx)))(this, result);
    };
}
function $c081c3b1833d944c$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($c081c3b1833d944c$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $c081c3b1833d944c$export$35f8383928ba8d7 = function isUIAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $c081c3b1833d944c$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isUIAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === "UIAnalyticsEvent";
};
var $c081c3b1833d944c$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_AnalyticsEvent) {
    (0, (/*@__PURE__*/$parcel$interopDefault($bqUiy)))(UIAnalyticsEvent, _AnalyticsEvent);
    var _super = $c081c3b1833d944c$var$_createSuper(UIAnalyticsEvent);
    function UIAnalyticsEvent(props) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($iFl3Y)))(this, UIAnalyticsEvent);
        _this = _super.call(this, props);
        (0, (/*@__PURE__*/$parcel$interopDefault($9NvhG)))((0, (/*@__PURE__*/$parcel$interopDefault($iwmvD)))(_this), "_isUIAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($9NvhG)))((0, (/*@__PURE__*/$parcel$interopDefault($iwmvD)))(_this), "clone", function() {
            if (_this.hasFired) return null;
            var context = (0, (/*@__PURE__*/$parcel$interopDefault($alkT7)))(_this.context);
            var handlers = (0, (/*@__PURE__*/$parcel$interopDefault($alkT7)))(_this.handlers);
            /**
       * A hacky "deep clone" of the object. This is limited in that it wont
       * support functions, regexs, Maps, Sets, etc, but none of those need to
       * be represented in our payload.
       */ var payload = JSON.parse(JSON.stringify(_this.payload));
            return new UIAnalyticsEvent({
                context: context,
                handlers: handlers,
                payload: payload
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($9NvhG)))((0, (/*@__PURE__*/$parcel$interopDefault($iwmvD)))(_this), "fire", function(channel) {
            if (_this.hasFired) return;
            _this.handlers.forEach(function(handler) {
                return handler((0, (/*@__PURE__*/$parcel$interopDefault($iwmvD)))(_this), channel);
            });
            _this.hasFired = true;
        });
        _this.context = props.context || [];
        _this.handlers = props.handlers || [];
        _this.hasFired = false;
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($kirtm)))(UIAnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (this.hasFired) return this;
                return (0, (/*@__PURE__*/$parcel$interopDefault($kOUZd)))((0, (/*@__PURE__*/$parcel$interopDefault($lIcHa)))(UIAnalyticsEvent.prototype), "update", this).call(this, updater);
            }
        }
    ]);
    return UIAnalyticsEvent;
}((0, $bD09g.default));

});
parcelRegister("kOUZd", function(module, exports) {

var $hRddk = parcelRequire("hRddk");
function $f284ae70ecbd86de$var$_get() {
    return module.exports = $f284ae70ecbd86de$var$_get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function(e, t, r) {
        var p = $hRddk(e, t);
        if (p) {
            var n = Object.getOwnPropertyDescriptor(p, t);
            return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value;
        }
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $f284ae70ecbd86de$var$_get.apply(null, arguments);
}
module.exports = $f284ae70ecbd86de$var$_get, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("hRddk", function(module, exports) {

var $lIcHa = parcelRequire("lIcHa");
function $d001a2eab47aa148$var$_superPropBase(t, o) {
    for(; !({}).hasOwnProperty.call(t, o) && null !== (t = $lIcHa(t)););
    return t;
}
module.exports = $d001a2eab47aa148$var$_superPropBase, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("bD09g", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $877373b9f52b94b6$export$2e2bcd8739ae039; });

var $4rA6e = parcelRequire("4rA6e");

var $iFl3Y = parcelRequire("iFl3Y");

var $kirtm = parcelRequire("kirtm");

var $9NvhG = parcelRequire("9NvhG");
function $877373b9f52b94b6$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $877373b9f52b94b6$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $877373b9f52b94b6$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($9NvhG)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $877373b9f52b94b6$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $877373b9f52b94b6$export$ad4be5c2ec28cecf = function isAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $877373b9f52b94b6$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === "AnalyticsEvent";
};
var $877373b9f52b94b6$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function AnalyticsEvent(props) {
        var _this = this;
        (0, (/*@__PURE__*/$parcel$interopDefault($iFl3Y)))(this, AnalyticsEvent);
        (0, (/*@__PURE__*/$parcel$interopDefault($9NvhG)))(this, "_isAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($9NvhG)))(this, "clone", function() {
            // just a shallow clone, don't change sub refs unless you want to
            // affect the original's too
            var payload = $877373b9f52b94b6$var$_objectSpread({}, _this.payload);
            return new AnalyticsEvent({
                payload: payload
            });
        });
        this.payload = props.payload;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($kirtm)))(AnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (typeof updater === "function") this.payload = updater(this.payload);
                if ((0, (/*@__PURE__*/$parcel$interopDefault($4rA6e)))(updater) === "object") this.payload = $877373b9f52b94b6$var$_objectSpread($877373b9f52b94b6$var$_objectSpread({}, this.payload), updater);
                return this;
            }
        }
    ]);
    return AnalyticsEvent;
}();

});



parcelRegister("gGvgA", function(module, exports) {

$parcel$export(module.exports, "usePatchedProps", function () { return $c258d2734ca5834d$export$9ebb5a84d17e5d18; });

var $9NvhG = parcelRequire("9NvhG");

var $4rA6e = parcelRequire("4rA6e");

var $dAx5m = parcelRequire("dAx5m");

var $c8OCt = parcelRequire("c8OCt");
function $c258d2734ca5834d$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $c258d2734ca5834d$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $c258d2734ca5834d$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($9NvhG)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $c258d2734ca5834d$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $c258d2734ca5834d$export$9ebb5a84d17e5d18() {
    var createEventMap = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var wrappedComponentProps = arguments.length > 1 ? arguments[1] : undefined;
    var _useAnalyticsEvents = (0, $c8OCt.useAnalyticsEvents)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    var handlerCache = (0, $dAx5m.useRef)({});
    var patchedProps = (0, $dAx5m.useMemo)(function() {
        var cache = handlerCache.current;
        // Clean up no longer used handlers in cache
        Object.keys(cache).filter(function(key) {
            return !(key in createEventMap);
        }).forEach(function(key) {
            return delete cache[key];
        });
        return Object.keys(createEventMap).reduce(function(p, k) {
            var eventCreator = createEventMap[k];
            if (![
                "object",
                "function"
            ].includes((0, (/*@__PURE__*/$parcel$interopDefault($4rA6e)))(eventCreator))) return p;
            var propValue = wrappedComponentProps[k];
            if (k in cache && cache[k].eventCreator === eventCreator && cache[k].propValue === propValue) return $c258d2734ca5834d$var$_objectSpread($c258d2734ca5834d$var$_objectSpread({}, p), {}, (0, (/*@__PURE__*/$parcel$interopDefault($9NvhG)))({}, k, cache[k].wrappedCallback));
            var wrappedCallback = function wrappedCallback() {
                var analyticsEvent = typeof eventCreator === "function" ? eventCreator(createAnalyticsEvent, wrappedComponentProps) : createAnalyticsEvent(eventCreator);
                if (propValue && typeof propValue === "function") {
                    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                    propValue.apply(void 0, args.concat([
                        analyticsEvent
                    ]));
                }
            };
            cache[k] = {
                eventCreator: eventCreator,
                wrappedCallback: wrappedCallback,
                propValue: propValue
            };
            return $c258d2734ca5834d$var$_objectSpread($c258d2734ca5834d$var$_objectSpread({}, p), {}, (0, (/*@__PURE__*/$parcel$interopDefault($9NvhG)))({}, k, wrappedCallback));
        }, {});
    }, [
        createEventMap,
        wrappedComponentProps,
        createAnalyticsEvent,
        handlerCache
    ]);
    return {
        patchedEventProps: patchedProps
    };
}

});


parcelRegister("2f6fs", function(module, exports) {

$parcel$export(module.exports, "UNSAFE_useLayering", function () { return $1a21d444aa67e0b5$export$cec37b93989366d4; });

var $dAx5m = parcelRequire("dAx5m");

var $dd4sf = parcelRequire("dd4sf");

var $csfNu = parcelRequire("csfNu");
var $1a21d444aa67e0b5$var$ESCAPE = "Escape";
function $1a21d444aa67e0b5$export$4a4bf067ea9e7886(_ref) {
    var onClose = _ref.onClose, isDisabled = _ref.isDisabled;
    var escapePressed = (0, $dAx5m.useRef)(false);
    var _UNSAFE_useLayering = $1a21d444aa67e0b5$export$cec37b93989366d4(), isLayerDisabled = _UNSAFE_useLayering.isLayerDisabled;
    var onKeyDown = (0, $dAx5m.useCallback)(function(e) {
        var isDisabledLayer = isLayerDisabled();
        if (isDisabled || escapePressed.current || e.key !== $1a21d444aa67e0b5$var$ESCAPE || isDisabledLayer) // We're either already handling the key down event or it's not escape or disabled.
        // Bail early!
        return;
        escapePressed.current = true;
        onClose(e);
    }, [
        onClose,
        isDisabled,
        isLayerDisabled
    ]);
    var onKeyUp = (0, $dAx5m.useCallback)(function() {
        escapePressed.current = false;
    }, []);
    (0, $dAx5m.useEffect)(function() {
        return (0, $dd4sf.bindAll)(document, [
            {
                type: "keydown",
                listener: onKeyDown
            },
            {
                type: "keyup",
                listener: onKeyUp
            }
        ], {
            capture: false
        });
    }, [
        onKeyDown,
        onKeyUp
    ]);
}
function $1a21d444aa67e0b5$export$cec37b93989366d4() {
    var currentLevel = (0, $dAx5m.useContext)((0, $csfNu.LevelContext));
    var _useContext = (0, $dAx5m.useContext)((0, $csfNu.TopLevelContext)), topLevelRef = _useContext.topLevelRef;
    var isLayerDisabled = (0, $dAx5m.useCallback)(function() {
        return !!topLevelRef.current && currentLevel !== topLevelRef.current;
    }, [
        currentLevel,
        topLevelRef
    ]);
    return {
        currentLevel: currentLevel,
        topLevelRef: topLevelRef,
        isLayerDisabled: isLayerDisabled
    };
}

});
parcelRegister("csfNu", function(module, exports) {

$parcel$export(module.exports, "LevelContext", function () { return $91145a8e67140522$export$650d12d3c2ddb8fc; });
$parcel$export(module.exports, "TopLevelContext", function () { return $91145a8e67140522$export$48b383b280e20440; });

var $dAx5m = parcelRequire("dAx5m");

var $Bb0he = parcelRequire("Bb0he");
var $91145a8e67140522$export$650d12d3c2ddb8fc = /*#__PURE__*/ (0, $dAx5m.createContext)(0);
var $91145a8e67140522$export$48b383b280e20440 = /*#__PURE__*/ (0, $dAx5m.createContext)({
    topLevelRef: {
        current: null
    },
    setTopLevel: (0, $Bb0he.default)
});
/**
 *
 *  @internal
 * Context Provider Component which provider the current level of nested layers
 * It handles level management when it mounts and unmounts
 *
 */ var $91145a8e67140522$var$LevelProvider = function LevelProvider(_ref) {
    var children = _ref.children, currentLevel = _ref.currentLevel;
    var _useContext = (0, $dAx5m.useContext)($91145a8e67140522$export$48b383b280e20440), setTopLevel = _useContext.setTopLevel;
    setTopLevel(currentLevel);
    (0, $dAx5m.useEffect)(function() {
        // avoid immediate cleanup using setTimeout when component unmount
        // this will make sure non-top layer components can get the correct top level value
        // when multiple layers trigger onClose in sequence.
        // From React 17, the useEffect cleanup functions are delayed till the commit phase is completed. In other words, the useEffect cleanup functions run asynchronously - for example, if the component is unmounting, the cleanup runs after the screen has been updated.
        // TODO revisit after we migrate to react 18. https://product-fabric.atlassian.net/browse/DSP-13139
        return function() {
            setTimeout(function() {
                setTopLevel(currentLevel - 1);
            }, 0);
        };
    }, [
        setTopLevel,
        currentLevel
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement($91145a8e67140522$export$650d12d3c2ddb8fc.Provider, {
        value: currentLevel
    }, children);
};
/**
 *
 *  @internal
 * Context Provider Component which provides the top level of all nested layers
 * It provides initial top level ref value as 0 and set top level method
 *
 */ var $91145a8e67140522$var$LayeringProvider = function LayeringProvider(_ref2) {
    var children = _ref2.children;
    var topLevelRef = (0, $dAx5m.useRef)(0);
    var value = (0, $dAx5m.useMemo)(function() {
        return {
            topLevelRef: topLevelRef,
            setTopLevel: function setTopLevel(level) {
                topLevelRef.current = level;
            }
        };
    }, [
        topLevelRef
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement($91145a8e67140522$export$48b383b280e20440.Provider, {
        value: value
    }, children);
};
var $91145a8e67140522$export$a183686c3f6f4ea8 = function UNSAFE_LAYERING(_ref3) {
    var children = _ref3.children, _ref3$isDisabled = _ref3.isDisabled, isDisabled = _ref3$isDisabled === void 0 ? true : _ref3$isDisabled;
    var currentLevel = (0, $dAx5m.useContext)($91145a8e67140522$export$650d12d3c2ddb8fc);
    if (isDisabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).Fragment, null, children);
    var isNested = currentLevel > 0;
    var content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement($91145a8e67140522$var$LevelProvider, {
        currentLevel: currentLevel + 1
    }, children);
    return isNested ? content : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement($91145a8e67140522$var$LayeringProvider, null, content);
};

});


parcelRegister("2Uxik", function(module, exports) {

$parcel$export(module.exports, "getBooleanFF", function () { return $21eaa3561eb959a5$export$470e5c2be1411c89; });

var $8A3Po = parcelRequire("8A3Po");
function $21eaa3561eb959a5$export$ba05d765b8392e5e(flagResolver) {
    (0, $8A3Po.setBooleanResolver)(flagResolver);
}
function $21eaa3561eb959a5$export$470e5c2be1411c89(name) {
    return (0, $8A3Po.resolveBooleanFlag)(name);
}
function $21eaa3561eb959a5$export$b40ec24ac8275656(name) {
    return (0, $8A3Po.resolveBooleanFlag)(name);
}

});
parcelRegister("8A3Po", function(module, exports) {

$parcel$export(module.exports, "setBooleanResolver", function () { return $63f4a7ac2fe51e58$export$f2b591175b3e424c; });
$parcel$export(module.exports, "resolveBooleanFlag", function () { return $63f4a7ac2fe51e58$export$6333b6aff9fc6275; });

var $iZsSw = parcelRequire("iZsSw");

var $ahJoN = parcelRequire("ahJoN");
var $63f4a7ac2fe51e58$var$pkgName = "@atlaskit/platform-feature-flags";
var $63f4a7ac2fe51e58$export$7e41b1b2bdee3f98 = "__PLATFORM_FEATURE_FLAGS__";
var $63f4a7ac2fe51e58$var$hasProcessEnv = typeof $ahJoN !== "undefined" && typeof $ahJoN.env !== "undefined";
// FF global overrides can be configured by test runners or Storybook
var $63f4a7ac2fe51e58$var$ENV_ENABLE_PLATFORM_FF = $63f4a7ac2fe51e58$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
// STORYBOOK_ENABLE_PLATFORM_FF is included as storybook only allows env vars prefixed with STORYBOOK
// https://github.com/storybookjs/storybook/issues/12270
var $63f4a7ac2fe51e58$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF = $63f4a7ac2fe51e58$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
var $63f4a7ac2fe51e58$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE = $63f4a7ac2fe51e58$var$ENV_ENABLE_PLATFORM_FF || $63f4a7ac2fe51e58$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF;
var $63f4a7ac2fe51e58$var$DEFAULT_PFF_GLOBAL = {
    // In development mode we want to capture any feature flag checks that happen using the default resolver and log this result when the resolver is replaced.
    // This is because evaluating feature flags when the resolver/FF client is loaded asynchronously could cause unexpected issues.
    earlyResolvedFlags: new Map(),
    booleanResolver: function booleanResolver(flagKey) {
        var unresolvedFlagCount;
        return false;
    }
};
var $63f4a7ac2fe51e58$var$globalVar = typeof window !== "undefined" ? window : globalThis;
$63f4a7ac2fe51e58$var$globalVar[$63f4a7ac2fe51e58$export$7e41b1b2bdee3f98] = $63f4a7ac2fe51e58$var$globalVar[$63f4a7ac2fe51e58$export$7e41b1b2bdee3f98] || $63f4a7ac2fe51e58$var$DEFAULT_PFF_GLOBAL;
function $63f4a7ac2fe51e58$export$f2b591175b3e424c(resolver) {
    $63f4a7ac2fe51e58$var$globalVar[$63f4a7ac2fe51e58$export$7e41b1b2bdee3f98].booleanResolver = resolver;
    var _globalVar$PFF_GLOBAL;
}
function $63f4a7ac2fe51e58$export$6333b6aff9fc6275(flagKey) {
    if ($63f4a7ac2fe51e58$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE) {
        (0, $iZsSw.debug)('[%s]: The feature flags were enabled while running tests. The flag "%s" will be always enabled.', $63f4a7ac2fe51e58$var$pkgName, flagKey);
        return true;
    }
    try {
        var _globalVar$PFF_GLOBAL2;
        var result = (_globalVar$PFF_GLOBAL2 = $63f4a7ac2fe51e58$var$globalVar[$63f4a7ac2fe51e58$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL2 === void 0 ? void 0 : _globalVar$PFF_GLOBAL2.booleanResolver(flagKey);
        if (typeof result !== "boolean") {
            // eslint-disable-next-line no-console
            console.warn("".concat(flagKey, " resolved to a non-boolean value, returning false for safety"));
            return false;
        }
        return result;
    } catch (e) {
        return false;
    }
}

});
parcelRegister("iZsSw", function(module, exports) {

$parcel$export(module.exports, "debug", function () { return $dd345321bba946ee$export$1c9f709888824e05; });
var $dd345321bba946ee$var$_ref, $dd345321bba946ee$var$_process, $dd345321bba946ee$var$_process2;
// We can't rely on NODE_ENV === 'test' if its value is already configured by the consumer to some other value, so better to use JEST_WORKER_ID
// https://jestjs.io/docs/environment-variables#jest_worker_id
var $dd345321bba946ee$var$TESTS_MODE = ($dd345321bba946ee$var$_ref = (globalThis === null || globalThis === void 0 || ($dd345321bba946ee$var$_process = globalThis.process) === null || $dd345321bba946ee$var$_process === void 0 || ($dd345321bba946ee$var$_process = $dd345321bba946ee$var$_process.env) === null || $dd345321bba946ee$var$_process === void 0 ? void 0 : $dd345321bba946ee$var$_process.JEST_WORKER_ID) !== undefined, $dd345321bba946ee$var$_ref !== void 0) ? $dd345321bba946ee$var$_ref : false;
var $dd345321bba946ee$var$DEBUG_MODE = !$dd345321bba946ee$var$TESTS_MODE && (globalThis === null || globalThis === void 0 || ($dd345321bba946ee$var$_process2 = globalThis.process) === null || $dd345321bba946ee$var$_process2 === void 0 || ($dd345321bba946ee$var$_process2 = $dd345321bba946ee$var$_process2.env) === null || $dd345321bba946ee$var$_process2 === void 0 ? void 0 : $dd345321bba946ee$var$_process2.NODE_ENV) !== "production";
var $dd345321bba946ee$export$1c9f709888824e05 = function debug() {
    var _console;
    if (!$dd345321bba946ee$var$DEBUG_MODE) return;
    // eslint-disable-next-line no-console
    (_console = console).debug.apply(_console, arguments);
};

});



parcelRegister("expeE", function(module, exports) {

$parcel$export(module.exports, "ManagerReferenceNodeContext", function () { return $a957b8fc89b575f7$export$3dbd3405086fec7b; });
$parcel$export(module.exports, "ManagerReferenceNodeSetterContext", function () { return $a957b8fc89b575f7$export$cbabb21c2529b130; });
$parcel$export(module.exports, "Manager", function () { return $a957b8fc89b575f7$export$d0d38e7dec7a1a61; });

var $dAx5m = parcelRequire("dAx5m");
var $a957b8fc89b575f7$export$3dbd3405086fec7b = $dAx5m.createContext();
var $a957b8fc89b575f7$export$cbabb21c2529b130 = $dAx5m.createContext();
function $a957b8fc89b575f7$export$d0d38e7dec7a1a61(_ref) {
    var children = _ref.children;
    var _React$useState = $dAx5m.useState(null), referenceNode = _React$useState[0], setReferenceNode = _React$useState[1];
    var hasUnmounted = $dAx5m.useRef(false);
    $dAx5m.useEffect(function() {
        return function() {
            hasUnmounted.current = true;
        };
    }, []);
    var handleSetReferenceNode = $dAx5m.useCallback(function(node) {
        if (!hasUnmounted.current) setReferenceNode(node);
    }, []);
    return /*#__PURE__*/ $dAx5m.createElement($a957b8fc89b575f7$export$3dbd3405086fec7b.Provider, {
        value: referenceNode
    }, /*#__PURE__*/ $dAx5m.createElement($a957b8fc89b575f7$export$cbabb21c2529b130.Provider, {
        value: handleSetReferenceNode
    }, children));
}

});

parcelRegister("hl98J", function(module, exports) {

$parcel$export(module.exports, "Popper", function () { return $c9fb7ccade7cc916$export$badac9ada3a0bdf9; });

var $alkT7 = parcelRequire("alkT7");

var $lBoJt = parcelRequire("lBoJt");

var $dAx5m = parcelRequire("dAx5m");

var $2BQLr = parcelRequire("2BQLr");

var $9WK43 = parcelRequire("9WK43");

// Export types from PopperJS / React Popper
var $c9fb7ccade7cc916$var$viewportPadding = 5;
var $c9fb7ccade7cc916$var$constantModifiers = [
    {
        name: "flip",
        options: {
            flipVariations: false,
            padding: $c9fb7ccade7cc916$var$viewportPadding,
            boundary: "clippingParents",
            rootBoundary: "viewport"
        }
    }
];
function $c9fb7ccade7cc916$var$defaultChildrenFn() {
    return null;
}
var $c9fb7ccade7cc916$var$defaultOffset = [
    0,
    8
];
function $c9fb7ccade7cc916$export$badac9ada3a0bdf9(_ref) {
    var _ref$children = _ref.children, children = _ref$children === void 0 ? $c9fb7ccade7cc916$var$defaultChildrenFn : _ref$children, _ref$offset = _ref.offset, offset = _ref$offset === void 0 ? $c9fb7ccade7cc916$var$defaultOffset : _ref$offset, _ref$placement = _ref.placement, placement = _ref$placement === void 0 ? "bottom-start" : _ref$placement, _ref$referenceElement = _ref.referenceElement, referenceElement = _ref$referenceElement === void 0 ? undefined : _ref$referenceElement, modifiers = _ref.modifiers, _ref$strategy = _ref.strategy, strategy = _ref$strategy === void 0 ? "fixed" : _ref$strategy, _ref$shouldFitViewpor = _ref.shouldFitViewport, shouldFitViewport = _ref$shouldFitViewpor === void 0 ? false : _ref$shouldFitViewpor;
    var _offset = (0, (/*@__PURE__*/$parcel$interopDefault($lBoJt)))(offset, 2), offsetX = _offset[0], offsetY = _offset[1];
    var internalModifiers = (0, $dAx5m.useMemo)(function() {
        var preventOverflowModifier = {
            name: "preventOverflow",
            options: {
                padding: $c9fb7ccade7cc916$var$viewportPadding,
                rootBoundary: shouldFitViewport ? "viewport" : "document"
            }
        };
        var offsetModifier = {
            name: "offset",
            options: {
                offset: [
                    offsetX,
                    offsetY
                ]
            }
        };
        var maxSizeModifiers = shouldFitViewport ? (0, $9WK43.getMaxSizeModifiers)({
            viewportPadding: $c9fb7ccade7cc916$var$viewportPadding
        }) : [];
        return [].concat($c9fb7ccade7cc916$var$constantModifiers, [
            preventOverflowModifier,
            offsetModifier
        ], (0, (/*@__PURE__*/$parcel$interopDefault($alkT7)))(maxSizeModifiers));
    }, [
        offsetX,
        offsetY,
        shouldFitViewport
    ]);
    // Merge custom props and memoize
    var mergedModifiers = (0, $dAx5m.useMemo)(function() {
        if (modifiers == null) return internalModifiers;
        return [].concat((0, (/*@__PURE__*/$parcel$interopDefault($alkT7)))(internalModifiers), (0, (/*@__PURE__*/$parcel$interopDefault($alkT7)))(modifiers));
    }, [
        internalModifiers,
        modifiers
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $2BQLr.Popper), {
        modifiers: mergedModifiers,
        placement: placement,
        strategy: strategy,
        referenceElement: referenceElement
    }, children);
}

});
parcelRegister("lBoJt", function(module, exports) {

var $1wpZ6 = parcelRequire("1wpZ6");

var $bXNtv = parcelRequire("bXNtv");

var $e9GhI = parcelRequire("e9GhI");

var $0WjIs = parcelRequire("0WjIs");
function $fba03d0bb8a208fa$var$_slicedToArray(r, e) {
    return $1wpZ6(r) || $bXNtv(r, e) || $e9GhI(r, e) || $0WjIs();
}
module.exports = $fba03d0bb8a208fa$var$_slicedToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("1wpZ6", function(module, exports) {
function $11bcef992e6c03e7$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
module.exports = $11bcef992e6c03e7$var$_arrayWithHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("bXNtv", function(module, exports) {
function $8b5b9516bf8b9af4$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
module.exports = $8b5b9516bf8b9af4$var$_iterableToArrayLimit, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("0WjIs", function(module, exports) {
function $002d3cbe4ed7335b$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
module.exports = $002d3cbe4ed7335b$var$_nonIterableRest, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("2BQLr", function(module, exports) {

$parcel$export(module.exports, "Popper", function () { return $1e67f75bb8542b6a$export$badac9ada3a0bdf9; });

var $dAx5m = parcelRequire("dAx5m");

var $expeE = parcelRequire("expeE");

var $wMbSc = parcelRequire("wMbSc");

var $fAeb4 = parcelRequire("fAeb4");
var $1e67f75bb8542b6a$var$NOOP = function NOOP() {
    return void 0;
};
var $1e67f75bb8542b6a$var$NOOP_PROMISE = function NOOP_PROMISE() {
    return Promise.resolve(null);
};
var $1e67f75bb8542b6a$var$EMPTY_MODIFIERS = [];
function $1e67f75bb8542b6a$export$badac9ada3a0bdf9(_ref) {
    var _ref$placement = _ref.placement, placement = _ref$placement === void 0 ? "bottom" : _ref$placement, _ref$strategy = _ref.strategy, strategy = _ref$strategy === void 0 ? "absolute" : _ref$strategy, _ref$modifiers = _ref.modifiers, modifiers = _ref$modifiers === void 0 ? $1e67f75bb8542b6a$var$EMPTY_MODIFIERS : _ref$modifiers, referenceElement = _ref.referenceElement, onFirstUpdate = _ref.onFirstUpdate, innerRef = _ref.innerRef, children = _ref.children;
    var referenceNode = $dAx5m.useContext((0, $expeE.ManagerReferenceNodeContext));
    var _React$useState = $dAx5m.useState(null), popperElement = _React$useState[0], setPopperElement = _React$useState[1];
    var _React$useState2 = $dAx5m.useState(null), arrowElement = _React$useState2[0], setArrowElement = _React$useState2[1];
    $dAx5m.useEffect(function() {
        (0, $wMbSc.setRef)(innerRef, popperElement);
    }, [
        innerRef,
        popperElement
    ]);
    var options = $dAx5m.useMemo(function() {
        return {
            placement: placement,
            strategy: strategy,
            onFirstUpdate: onFirstUpdate,
            modifiers: [].concat(modifiers, [
                {
                    name: "arrow",
                    enabled: arrowElement != null,
                    options: {
                        element: arrowElement
                    }
                }
            ])
        };
    }, [
        placement,
        strategy,
        onFirstUpdate,
        modifiers,
        arrowElement
    ]);
    var _usePopper = (0, $fAeb4.usePopper)(referenceElement || referenceNode, popperElement, options), state = _usePopper.state, styles = _usePopper.styles, forceUpdate = _usePopper.forceUpdate, update = _usePopper.update;
    var childrenProps = $dAx5m.useMemo(function() {
        return {
            ref: setPopperElement,
            style: styles.popper,
            placement: state ? state.placement : placement,
            hasPopperEscaped: state && state.modifiersData.hide ? state.modifiersData.hide.hasPopperEscaped : null,
            isReferenceHidden: state && state.modifiersData.hide ? state.modifiersData.hide.isReferenceHidden : null,
            arrowProps: {
                style: styles.arrow,
                ref: setArrowElement
            },
            forceUpdate: forceUpdate || $1e67f75bb8542b6a$var$NOOP,
            update: update || $1e67f75bb8542b6a$var$NOOP_PROMISE
        };
    }, [
        setPopperElement,
        setArrowElement,
        placement,
        state,
        styles,
        update,
        forceUpdate
    ]);
    return (0, $wMbSc.unwrapArray)(children)(childrenProps);
}

});
parcelRegister("wMbSc", function(module, exports) {

$parcel$export(module.exports, "unwrapArray", function () { return $06285ee752bc3fef$export$f52c55943429c8b6; });
$parcel$export(module.exports, "safeInvoke", function () { return $06285ee752bc3fef$export$3dfa7c28635fe028; });
$parcel$export(module.exports, "setRef", function () { return $06285ee752bc3fef$export$4bb192c7cacf928f; });
$parcel$export(module.exports, "fromEntries", function () { return $06285ee752bc3fef$export$5150077fc2e7c662; });
$parcel$export(module.exports, "useIsomorphicLayoutEffect", function () { return $06285ee752bc3fef$export$700979bc83e7db82; });

var $dAx5m = parcelRequire("dAx5m");
var $06285ee752bc3fef$export$f52c55943429c8b6 = function unwrapArray(arg) {
    return Array.isArray(arg) ? arg[0] : arg;
};
var $06285ee752bc3fef$export$3dfa7c28635fe028 = function safeInvoke(fn) {
    if (typeof fn === "function") {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
        return fn.apply(void 0, args);
    }
};
var $06285ee752bc3fef$export$4bb192c7cacf928f = function setRef(ref, node) {
    // if its a function call it
    if (typeof ref === "function") return $06285ee752bc3fef$export$3dfa7c28635fe028(ref, node);
    else if (ref != null) ref.current = node;
};
var $06285ee752bc3fef$export$5150077fc2e7c662 = function fromEntries(entries) {
    return entries.reduce(function(acc, _ref) {
        var key = _ref[0], value = _ref[1];
        acc[key] = value;
        return acc;
    }, {});
};
var $06285ee752bc3fef$export$700979bc83e7db82 = typeof window !== "undefined" && window.document && window.document.createElement ? $dAx5m.useLayoutEffect : $dAx5m.useEffect;

});

parcelRegister("fAeb4", function(module, exports) {

$parcel$export(module.exports, "usePopper", function () { return $b585372bb216d157$export$f4d5bf230a36dd6e; });

var $dAx5m = parcelRequire("dAx5m");

var $1MpXQ = parcelRequire("1MpXQ");

var $i6yrt = parcelRequire("i6yrt");

var $856WZ = parcelRequire("856WZ");

var $wMbSc = parcelRequire("wMbSc");
var $b585372bb216d157$var$EMPTY_MODIFIERS = [];
var $b585372bb216d157$export$f4d5bf230a36dd6e = function usePopper(referenceElement, popperElement, options) {
    if (options === void 0) options = {};
    var prevOptions = $dAx5m.useRef(null);
    var optionsWithDefaults = {
        onFirstUpdate: options.onFirstUpdate,
        placement: options.placement || "bottom",
        strategy: options.strategy || "absolute",
        modifiers: options.modifiers || $b585372bb216d157$var$EMPTY_MODIFIERS
    };
    var _React$useState = $dAx5m.useState({
        styles: {
            popper: {
                position: optionsWithDefaults.strategy,
                left: "0",
                top: "0"
            },
            arrow: {
                position: "absolute"
            }
        },
        attributes: {}
    }), state = _React$useState[0], setState = _React$useState[1];
    var updateStateModifier = $dAx5m.useMemo(function() {
        return {
            name: "updateState",
            enabled: true,
            phase: "write",
            fn: function fn(_ref) {
                var state = _ref.state;
                var elements = Object.keys(state.elements);
                $1MpXQ.flushSync(function() {
                    setState({
                        styles: (0, $wMbSc.fromEntries)(elements.map(function(element) {
                            return [
                                element,
                                state.styles[element] || {}
                            ];
                        })),
                        attributes: (0, $wMbSc.fromEntries)(elements.map(function(element) {
                            return [
                                element,
                                state.attributes[element]
                            ];
                        }))
                    });
                });
            },
            requires: [
                "computeStyles"
            ]
        };
    }, []);
    var popperOptions = $dAx5m.useMemo(function() {
        var newOptions = {
            onFirstUpdate: optionsWithDefaults.onFirstUpdate,
            placement: optionsWithDefaults.placement,
            strategy: optionsWithDefaults.strategy,
            modifiers: [].concat(optionsWithDefaults.modifiers, [
                updateStateModifier,
                {
                    name: "applyStyles",
                    enabled: false
                }
            ])
        };
        if ((0, (/*@__PURE__*/$parcel$interopDefault($856WZ)))(prevOptions.current, newOptions)) return prevOptions.current || newOptions;
        else {
            prevOptions.current = newOptions;
            return newOptions;
        }
    }, [
        optionsWithDefaults.onFirstUpdate,
        optionsWithDefaults.placement,
        optionsWithDefaults.strategy,
        optionsWithDefaults.modifiers,
        updateStateModifier
    ]);
    var popperInstanceRef = $dAx5m.useRef();
    (0, $wMbSc.useIsomorphicLayoutEffect)(function() {
        if (popperInstanceRef.current) popperInstanceRef.current.setOptions(popperOptions);
    }, [
        popperOptions
    ]);
    (0, $wMbSc.useIsomorphicLayoutEffect)(function() {
        if (referenceElement == null || popperElement == null) return;
        var createPopper = options.createPopper || (0, $i6yrt.createPopper);
        var popperInstance = createPopper(referenceElement, popperElement, popperOptions);
        popperInstanceRef.current = popperInstance;
        return function() {
            popperInstance.destroy();
            popperInstanceRef.current = null;
        };
    }, [
        referenceElement,
        popperElement,
        options.createPopper
    ]);
    return {
        state: popperInstanceRef.current ? popperInstanceRef.current.state : null,
        styles: state.styles,
        attributes: state.attributes,
        update: popperInstanceRef.current ? popperInstanceRef.current.update : null,
        forceUpdate: popperInstanceRef.current ? popperInstanceRef.current.forceUpdate : null
    };
};

});
parcelRegister("i6yrt", function(module, exports) {

$parcel$export(module.exports, "createPopper", function () { return $d2e380ff3ffd946a$export$8f7491d57c8f97a9; });

var $1RLdU = parcelRequire("1RLdU");

var $amvtV = parcelRequire("amvtV");

var $ePJsJ = parcelRequire("ePJsJ");

var $6s5nj = parcelRequire("6s5nj");

var $8zmlI = parcelRequire("8zmlI");

var $ijb9m = parcelRequire("ijb9m");

var $b8yhw = parcelRequire("b8yhw");

var $7OxmF = parcelRequire("7OxmF");

var $jHxow = parcelRequire("jHxow");

var $4DDjm = parcelRequire("4DDjm");


var $d2e380ff3ffd946a$export$d34966752335dd47 = [
    (0, $amvtV.default),
    (0, $ePJsJ.default),
    (0, $6s5nj.default),
    (0, $8zmlI.default),
    (0, $ijb9m.default),
    (0, $b8yhw.default),
    (0, $7OxmF.default),
    (0, $jHxow.default),
    (0, $4DDjm.default)
];
var $d2e380ff3ffd946a$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $1RLdU.popperGenerator)({
    defaultModifiers: $d2e380ff3ffd946a$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules

});
parcelRegister("1RLdU", function(module, exports) {

$parcel$export(module.exports, "popperGenerator", function () { return $15bf5f3eb487c1b8$export$ed5e13716264f202; });

var $hf6dK = parcelRequire("hf6dK");

var $bq1TO = parcelRequire("bq1TO");

var $jUpWD = parcelRequire("jUpWD");

var $hGJnA = parcelRequire("hGJnA");

var $jJ2uu = parcelRequire("jJ2uu");

var $a1VC0 = parcelRequire("a1VC0");

var $lFSfa = parcelRequire("lFSfa");


var $3PA3h = parcelRequire("3PA3h");
var $15bf5f3eb487c1b8$var$DEFAULT_OPTIONS = {
    placement: "bottom",
    modifiers: [],
    strategy: "absolute"
};
function $15bf5f3eb487c1b8$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === "function");
    });
}
function $15bf5f3eb487c1b8$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $15bf5f3eb487c1b8$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: "bottom",
            orderedModifiers: [],
            options: Object.assign({}, $15bf5f3eb487c1b8$var$DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var options = typeof setOptionsAction === "function" ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, options);
                state.scrollParents = {
                    reference: (0, $3PA3h.isElement)(reference) ? (0, $jUpWD.default)(reference) : reference.contextElement ? (0, $jUpWD.default)(reference.contextElement) : [],
                    popper: (0, $jUpWD.default)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $jJ2uu.default)((0, $lFSfa.default)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$15bf5f3eb487c1b8$var$areValidElements(reference, popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $hf6dK.default)(reference, (0, $hGJnA.default)(popper), state.options.strategy === "fixed"),
                    popper: (0, $bq1TO.default)(popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === "function") state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $a1VC0.default)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$15bf5f3eb487c1b8$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === "function") {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $15bf5f3eb487c1b8$export$8f7491d57c8f97a9 = /*#__PURE__*/ $15bf5f3eb487c1b8$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules

});
parcelRegister("hf6dK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c8d8a9b27fbd3880$export$2e2bcd8739ae039; });

var $6PkDU = parcelRequire("6PkDU");

var $it7jG = parcelRequire("it7jG");

var $1Ppz2 = parcelRequire("1Ppz2");

var $3PA3h = parcelRequire("3PA3h");

var $l5VsU = parcelRequire("l5VsU");

var $h7fHt = parcelRequire("h7fHt");

var $aptsW = parcelRequire("aptsW");

var $47C1l = parcelRequire("47C1l");
function $c8d8a9b27fbd3880$var$isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, $47C1l.round)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, $47C1l.round)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function $c8d8a9b27fbd3880$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, $3PA3h.isHTMLElement)(offsetParent);
    var offsetParentIsScaled = (0, $3PA3h.isHTMLElement)(offsetParent) && $c8d8a9b27fbd3880$var$isElementScaled(offsetParent);
    var documentElement = (0, $h7fHt.default)(offsetParent);
    var rect = (0, $6PkDU.default)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $1Ppz2.default)(offsetParent) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
        (0, $aptsW.default)(documentElement)) scroll = (0, $it7jG.default)(offsetParent);
        if ((0, $3PA3h.isHTMLElement)(offsetParent)) {
            offsets = (0, $6PkDU.default)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $l5VsU.default)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}

});
parcelRegister("6PkDU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4f8784b8cff40288$export$2e2bcd8739ae039; });

var $3PA3h = parcelRequire("3PA3h");

var $47C1l = parcelRequire("47C1l");

var $8p2rb = parcelRequire("8p2rb");

var $fJYPL = parcelRequire("fJYPL");
function $4f8784b8cff40288$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, $3PA3h.isHTMLElement)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, $47C1l.round)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, $47C1l.round)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, $3PA3h.isElement)(element) ? (0, $8p2rb.default)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, $fJYPL.default)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}

});
parcelRegister("3PA3h", function(module, exports) {

$parcel$export(module.exports, "isElement", function () { return $2ca219aa1143615c$export$45a5e7f76e0caa8d; });
$parcel$export(module.exports, "isHTMLElement", function () { return $2ca219aa1143615c$export$1b3bfaa9684536aa; });
$parcel$export(module.exports, "isShadowRoot", function () { return $2ca219aa1143615c$export$af51f0f06c0f328a; });

var $8p2rb = parcelRequire("8p2rb");
function $2ca219aa1143615c$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $8p2rb.default)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function $2ca219aa1143615c$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $8p2rb.default)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function $2ca219aa1143615c$export$af51f0f06c0f328a(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === "undefined") return false;
    var OwnElement = (0, $8p2rb.default)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}

});
parcelRegister("8p2rb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $61e28c8b05289dae$export$2e2bcd8739ae039; });
function $61e28c8b05289dae$export$2e2bcd8739ae039(node) {
    if (node == null) return window;
    if (node.toString() !== "[object Window]") {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}

});


parcelRegister("47C1l", function(module, exports) {

$parcel$export(module.exports, "max", function () { return $30054efb0c6daaba$export$8960430cfd85939f; });
$parcel$export(module.exports, "min", function () { return $30054efb0c6daaba$export$96ec731ed4dcb222; });
$parcel$export(module.exports, "round", function () { return $30054efb0c6daaba$export$2077e0241d6afd3c; });
var $30054efb0c6daaba$export$8960430cfd85939f = Math.max;
var $30054efb0c6daaba$export$96ec731ed4dcb222 = Math.min;
var $30054efb0c6daaba$export$2077e0241d6afd3c = Math.round;

});

parcelRegister("fJYPL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b75a3f51e04b1aa8$export$2e2bcd8739ae039; });

var $iPXqj = parcelRequire("iPXqj");
function $b75a3f51e04b1aa8$export$2e2bcd8739ae039() {
    return !/^((?!chrome|android).)*safari/i.test((0, $iPXqj.default)());
}

});
parcelRegister("iPXqj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $db6b15ae15d7bdca$export$2e2bcd8739ae039; });
function $db6b15ae15d7bdca$export$2e2bcd8739ae039() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(" ");
    return navigator.userAgent;
}

});



parcelRegister("it7jG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d7209c53ab677b25$export$2e2bcd8739ae039; });

var $beXsS = parcelRequire("beXsS");

var $8p2rb = parcelRequire("8p2rb");

var $3PA3h = parcelRequire("3PA3h");

var $ulAWo = parcelRequire("ulAWo");
function $d7209c53ab677b25$export$2e2bcd8739ae039(node) {
    if (node === (0, $8p2rb.default)(node) || !(0, $3PA3h.isHTMLElement)(node)) return (0, $beXsS.default)(node);
    else return (0, $ulAWo.default)(node);
}

});
parcelRegister("beXsS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $82ef20f6da5301c3$export$2e2bcd8739ae039; });

var $8p2rb = parcelRequire("8p2rb");
function $82ef20f6da5301c3$export$2e2bcd8739ae039(node) {
    var win = (0, $8p2rb.default)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}

});

parcelRegister("ulAWo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $05b38dbcd86c85d7$export$2e2bcd8739ae039; });
function $05b38dbcd86c85d7$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}

});


parcelRegister("1Ppz2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $154e625cde01308a$export$2e2bcd8739ae039; });
function $154e625cde01308a$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || "").toLowerCase() : null;
}

});

parcelRegister("l5VsU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f5b6a3fe878797f3$export$2e2bcd8739ae039; });

var $6PkDU = parcelRequire("6PkDU");

var $h7fHt = parcelRequire("h7fHt");

var $beXsS = parcelRequire("beXsS");
function $f5b6a3fe878797f3$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $6PkDU.default)((0, $h7fHt.default)(element)).left + (0, $beXsS.default)(element).scrollLeft;
}

});
parcelRegister("h7fHt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c75f44dc2c2084eb$export$2e2bcd8739ae039; });

var $3PA3h = parcelRequire("3PA3h");
function $c75f44dc2c2084eb$export$2e2bcd8739ae039(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, $3PA3h.isElement)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}

});


parcelRegister("aptsW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7943187a14693511$export$2e2bcd8739ae039; });

var $5uA9p = parcelRequire("5uA9p");
function $7943187a14693511$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $5uA9p.default)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}

});
parcelRegister("5uA9p", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3ffbcbdb4184c1f4$export$2e2bcd8739ae039; });

var $8p2rb = parcelRequire("8p2rb");
function $3ffbcbdb4184c1f4$export$2e2bcd8739ae039(element) {
    return (0, $8p2rb.default)(element).getComputedStyle(element);
}

});



parcelRegister("bq1TO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8503988e1855a0ba$export$2e2bcd8739ae039; });

var $6PkDU = parcelRequire("6PkDU");
function $8503988e1855a0ba$export$2e2bcd8739ae039(element) {
    var clientRect = (0, $6PkDU.default)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}

});

parcelRegister("jUpWD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e7e75f6180ef7c5a$export$2e2bcd8739ae039; });

var $a1Dlc = parcelRequire("a1Dlc");

var $l09bP = parcelRequire("l09bP");

var $8p2rb = parcelRequire("8p2rb");

var $aptsW = parcelRequire("aptsW");
function $e7e75f6180ef7c5a$export$2e2bcd8739ae039(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, $a1Dlc.default)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, $8p2rb.default)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $aptsW.default)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($e7e75f6180ef7c5a$export$2e2bcd8739ae039((0, $l09bP.default)(target)));
}

});
parcelRegister("a1Dlc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $74c883a861c6c7a3$export$2e2bcd8739ae039; });

var $l09bP = parcelRequire("l09bP");

var $aptsW = parcelRequire("aptsW");

var $1Ppz2 = parcelRequire("1Ppz2");

var $3PA3h = parcelRequire("3PA3h");
function $74c883a861c6c7a3$export$2e2bcd8739ae039(node) {
    if ([
        "html",
        "body",
        "#document"
    ].indexOf((0, $1Ppz2.default)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, $3PA3h.isHTMLElement)(node) && (0, $aptsW.default)(node)) return node;
    return $74c883a861c6c7a3$export$2e2bcd8739ae039((0, $l09bP.default)(node));
}

});
parcelRegister("l09bP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f4a0b9f5e31f0fe0$export$2e2bcd8739ae039; });

var $1Ppz2 = parcelRequire("1Ppz2");

var $h7fHt = parcelRequire("h7fHt");

var $3PA3h = parcelRequire("3PA3h");
function $f4a0b9f5e31f0fe0$export$2e2bcd8739ae039(element) {
    if ((0, $1Ppz2.default)(element) === "html") return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, $3PA3h.isShadowRoot)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, $h7fHt.default)(element) // fallback
    );
}

});



parcelRegister("hGJnA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ce098f568ac87a7a$export$2e2bcd8739ae039; });

var $8p2rb = parcelRequire("8p2rb");

var $1Ppz2 = parcelRequire("1Ppz2");

var $5uA9p = parcelRequire("5uA9p");

var $3PA3h = parcelRequire("3PA3h");

var $gzPt4 = parcelRequire("gzPt4");

var $l09bP = parcelRequire("l09bP");

var $iPXqj = parcelRequire("iPXqj");
function $ce098f568ac87a7a$var$getTrueOffsetParent(element) {
    if (!(0, $3PA3h.isHTMLElement)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $5uA9p.default)(element).position === "fixed") return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $ce098f568ac87a7a$var$getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, $iPXqj.default)());
    var isIE = /Trident/i.test((0, $iPXqj.default)());
    if (isIE && (0, $3PA3h.isHTMLElement)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, $5uA9p.default)(element);
        if (elementCss.position === "fixed") return null;
    }
    var currentNode = (0, $l09bP.default)(element);
    if ((0, $3PA3h.isShadowRoot)(currentNode)) currentNode = currentNode.host;
    while((0, $3PA3h.isHTMLElement)(currentNode) && [
        "html",
        "body"
    ].indexOf((0, $1Ppz2.default)(currentNode)) < 0){
        var css = (0, $5uA9p.default)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== "none" || css.perspective !== "none" || css.contain === "paint" || [
            "transform",
            "perspective"
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === "filter" || isFirefox && css.filter && css.filter !== "none") return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $ce098f568ac87a7a$export$2e2bcd8739ae039(element) {
    var window = (0, $8p2rb.default)(element);
    var offsetParent = $ce098f568ac87a7a$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $gzPt4.default)(offsetParent) && (0, $5uA9p.default)(offsetParent).position === "static")offsetParent = $ce098f568ac87a7a$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, $1Ppz2.default)(offsetParent) === "html" || (0, $1Ppz2.default)(offsetParent) === "body" && (0, $5uA9p.default)(offsetParent).position === "static")) return window;
    return offsetParent || $ce098f568ac87a7a$var$getContainingBlock(element) || window;
}

});
parcelRegister("gzPt4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c117d6a6c7b8f23e$export$2e2bcd8739ae039; });

var $1Ppz2 = parcelRequire("1Ppz2");
function $c117d6a6c7b8f23e$export$2e2bcd8739ae039(element) {
    return [
        "table",
        "td",
        "th"
    ].indexOf((0, $1Ppz2.default)(element)) >= 0;
}

});


parcelRegister("jJ2uu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e5c426e163ae6d7e$export$2e2bcd8739ae039; });

var $8JsOw = parcelRequire("8JsOw");
function $e5c426e163ae6d7e$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $e5c426e163ae6d7e$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $e5c426e163ae6d7e$var$order(modifiers); // order based on phase
    return (0, $8JsOw.modifierPhases).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}

});
parcelRegister("8JsOw", function(module, exports) {

$parcel$export(module.exports, "top", function () { return $65b8e082bfc86648$export$1e95b668f3b82d; });
$parcel$export(module.exports, "bottom", function () { return $65b8e082bfc86648$export$40e543e69a8b3fbb; });
$parcel$export(module.exports, "right", function () { return $65b8e082bfc86648$export$79ffe56a765070d2; });
$parcel$export(module.exports, "left", function () { return $65b8e082bfc86648$export$eabcd2c8791e7bf4; });
$parcel$export(module.exports, "auto", function () { return $65b8e082bfc86648$export$dfb5619354ba860; });
$parcel$export(module.exports, "basePlacements", function () { return $65b8e082bfc86648$export$aec2ce47c367b8c3; });
$parcel$export(module.exports, "start", function () { return $65b8e082bfc86648$export$b3571188c770cc5a; });
$parcel$export(module.exports, "end", function () { return $65b8e082bfc86648$export$bd5df0f255a350f8; });
$parcel$export(module.exports, "clippingParents", function () { return $65b8e082bfc86648$export$390fd549c5303b4d; });
$parcel$export(module.exports, "viewport", function () { return $65b8e082bfc86648$export$d7b7311ec04a3e8f; });
$parcel$export(module.exports, "popper", function () { return $65b8e082bfc86648$export$ae5ab1c730825774; });
$parcel$export(module.exports, "reference", function () { return $65b8e082bfc86648$export$ca50aac9f3ba507f; });
$parcel$export(module.exports, "variationPlacements", function () { return $65b8e082bfc86648$export$368f9a87e87fa4e1; });
$parcel$export(module.exports, "placements", function () { return $65b8e082bfc86648$export$803cd8101b6c182b; });
$parcel$export(module.exports, "modifierPhases", function () { return $65b8e082bfc86648$export$d087d3878fdf71d5; });
var $65b8e082bfc86648$export$1e95b668f3b82d = "top";
var $65b8e082bfc86648$export$40e543e69a8b3fbb = "bottom";
var $65b8e082bfc86648$export$79ffe56a765070d2 = "right";
var $65b8e082bfc86648$export$eabcd2c8791e7bf4 = "left";
var $65b8e082bfc86648$export$dfb5619354ba860 = "auto";
var $65b8e082bfc86648$export$aec2ce47c367b8c3 = [
    $65b8e082bfc86648$export$1e95b668f3b82d,
    $65b8e082bfc86648$export$40e543e69a8b3fbb,
    $65b8e082bfc86648$export$79ffe56a765070d2,
    $65b8e082bfc86648$export$eabcd2c8791e7bf4
];
var $65b8e082bfc86648$export$b3571188c770cc5a = "start";
var $65b8e082bfc86648$export$bd5df0f255a350f8 = "end";
var $65b8e082bfc86648$export$390fd549c5303b4d = "clippingParents";
var $65b8e082bfc86648$export$d7b7311ec04a3e8f = "viewport";
var $65b8e082bfc86648$export$ae5ab1c730825774 = "popper";
var $65b8e082bfc86648$export$ca50aac9f3ba507f = "reference";
var $65b8e082bfc86648$export$368f9a87e87fa4e1 = /*#__PURE__*/ $65b8e082bfc86648$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $65b8e082bfc86648$export$b3571188c770cc5a,
        placement + "-" + $65b8e082bfc86648$export$bd5df0f255a350f8
    ]);
}, []);
var $65b8e082bfc86648$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($65b8e082bfc86648$export$aec2ce47c367b8c3, [
    $65b8e082bfc86648$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $65b8e082bfc86648$export$b3571188c770cc5a,
        placement + "-" + $65b8e082bfc86648$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $65b8e082bfc86648$export$421679a7c3d56e = "beforeRead";
var $65b8e082bfc86648$export$aafa59e2e03f2942 = "read";
var $65b8e082bfc86648$export$6964f6c886723980 = "afterRead"; // pure-logic modifiers
var $65b8e082bfc86648$export$c65e99957a05207c = "beforeMain";
var $65b8e082bfc86648$export$f22da7240b7add18 = "main";
var $65b8e082bfc86648$export$bab79516f2d662fe = "afterMain"; // modifier with the purpose to write to the DOM (or write into a framework state)
var $65b8e082bfc86648$export$8d4d2d70e7d46032 = "beforeWrite";
var $65b8e082bfc86648$export$68d8715fc104d294 = "write";
var $65b8e082bfc86648$export$70a6e5159acce2e6 = "afterWrite";
var $65b8e082bfc86648$export$d087d3878fdf71d5 = [
    $65b8e082bfc86648$export$421679a7c3d56e,
    $65b8e082bfc86648$export$aafa59e2e03f2942,
    $65b8e082bfc86648$export$6964f6c886723980,
    $65b8e082bfc86648$export$c65e99957a05207c,
    $65b8e082bfc86648$export$f22da7240b7add18,
    $65b8e082bfc86648$export$bab79516f2d662fe,
    $65b8e082bfc86648$export$8d4d2d70e7d46032,
    $65b8e082bfc86648$export$68d8715fc104d294,
    $65b8e082bfc86648$export$70a6e5159acce2e6
];

});


parcelRegister("a1VC0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $74d6afedf58e0195$export$2e2bcd8739ae039; });
function $74d6afedf58e0195$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}

});

parcelRegister("lFSfa", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fc7780f7122b406d$export$2e2bcd8739ae039; });
function $fc7780f7122b406d$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}

});


parcelRegister("amvtV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $78b4610efb0e29c9$export$2e2bcd8739ae039; });

var $8p2rb = parcelRequire("8p2rb");
var $78b4610efb0e29c9$var$passive = {
    passive: true
};
function $78b4610efb0e29c9$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $8p2rb.default)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener("scroll", instance.update, $78b4610efb0e29c9$var$passive);
    });
    if (resize) window.addEventListener("resize", instance.update, $78b4610efb0e29c9$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener("scroll", instance.update, $78b4610efb0e29c9$var$passive);
        });
        if (resize) window.removeEventListener("resize", instance.update, $78b4610efb0e29c9$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $78b4610efb0e29c9$export$2e2bcd8739ae039 = {
    name: "eventListeners",
    enabled: true,
    phase: "write",
    fn: function fn() {},
    effect: $78b4610efb0e29c9$var$effect,
    data: {}
};

});

parcelRegister("ePJsJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $acc917fa994160fd$export$2e2bcd8739ae039; });

var $jKICF = parcelRequire("jKICF");
function $acc917fa994160fd$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $jKICF.default)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: "absolute",
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $acc917fa994160fd$export$2e2bcd8739ae039 = {
    name: "popperOffsets",
    enabled: true,
    phase: "read",
    fn: $acc917fa994160fd$var$popperOffsets,
    data: {}
};

});
parcelRegister("jKICF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e614ed52388654cb$export$2e2bcd8739ae039; });

var $58k8I = parcelRequire("58k8I");

var $k7JE3 = parcelRequire("k7JE3");

var $1InXb = parcelRequire("1InXb");

var $8JsOw = parcelRequire("8JsOw");
function $e614ed52388654cb$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $58k8I.default)(placement) : null;
    var variation = placement ? (0, $k7JE3.default)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $8JsOw.top:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $8JsOw.bottom:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $8JsOw.right:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $8JsOw.left:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $1InXb.default)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === "y" ? "height" : "width";
        switch(variation){
            case 0, $8JsOw.start:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, $8JsOw.end:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}

});
parcelRegister("58k8I", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3bcd5262b21d8376$export$2e2bcd8739ae039; });

function $3bcd5262b21d8376$export$2e2bcd8739ae039(placement) {
    return placement.split("-")[0];
}

});

parcelRegister("k7JE3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ea67de3ebbbbf66c$export$2e2bcd8739ae039; });
function $ea67de3ebbbbf66c$export$2e2bcd8739ae039(placement) {
    return placement.split("-")[1];
}

});

parcelRegister("1InXb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $13fc7b349e124117$export$2e2bcd8739ae039; });
function $13fc7b349e124117$export$2e2bcd8739ae039(placement) {
    return [
        "top",
        "bottom"
    ].indexOf(placement) >= 0 ? "x" : "y";
}

});



parcelRegister("6s5nj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4b2986faf69f8b00$export$2e2bcd8739ae039; });

var $8JsOw = parcelRequire("8JsOw");

var $hGJnA = parcelRequire("hGJnA");

var $8p2rb = parcelRequire("8p2rb");

var $h7fHt = parcelRequire("h7fHt");

var $5uA9p = parcelRequire("5uA9p");

var $58k8I = parcelRequire("58k8I");

var $k7JE3 = parcelRequire("k7JE3");

var $47C1l = parcelRequire("47C1l");
var $4b2986faf69f8b00$var$unsetSides = {
    top: "auto",
    right: "auto",
    bottom: "auto",
    left: "auto"
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $4b2986faf69f8b00$var$roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, $47C1l.round)(x * dpr) / dpr || 0,
        y: (0, $47C1l.round)(y * dpr) / dpr || 0
    };
}
function $4b2986faf69f8b00$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === "function" ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty("x");
    var hasY = offsets.hasOwnProperty("y");
    var sideX = (0, $8JsOw.left);
    var sideY = (0, $8JsOw.top);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $hGJnA.default)(popper);
        var heightProp = "clientHeight";
        var widthProp = "clientWidth";
        if (offsetParent === (0, $8p2rb.default)(popper)) {
            offsetParent = (0, $h7fHt.default)(popper);
            if ((0, $5uA9p.default)(offsetParent).position !== "static" && position === "absolute") {
                heightProp = "scrollHeight";
                widthProp = "scrollWidth";
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, $8JsOw.top) || (placement === (0, $8JsOw.left) || placement === (0, $8JsOw.right)) && variation === (0, $8JsOw.end)) {
            sideY = (0, $8JsOw.bottom);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $8JsOw.left) || (placement === (0, $8JsOw.top) || placement === (0, $8JsOw.bottom)) && variation === (0, $8JsOw.end)) {
            sideX = (0, $8JsOw.right);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $4b2986faf69f8b00$var$unsetSides);
    var _ref4 = roundOffsets === true ? $4b2986faf69f8b00$var$roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, $8p2rb.default)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? "0" : "", _Object$assign[sideX] = hasX ? "0" : "", _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : "", _Object$assign2[sideX] = hasX ? x + "px" : "", _Object$assign2.transform = "", _Object$assign2));
}
function $4b2986faf69f8b00$var$computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: (0, $58k8I.default)(state.placement),
        variation: (0, $k7JE3.default)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === "fixed"
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $4b2986faf69f8b00$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $4b2986faf69f8b00$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: "absolute",
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        "data-popper-placement": state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $4b2986faf69f8b00$export$2e2bcd8739ae039 = {
    name: "computeStyles",
    enabled: true,
    phase: "beforeWrite",
    fn: $4b2986faf69f8b00$var$computeStyles,
    data: {}
};

});

parcelRegister("8zmlI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $63d2edb5de4a1a51$export$2e2bcd8739ae039; });

var $1Ppz2 = parcelRequire("1Ppz2");

var $3PA3h = parcelRequire("3PA3h");
// and applies them to the HTMLElements such as popper and arrow
function $63d2edb5de4a1a51$var$applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function(name) {
        var style = state.styles[name] || {};
        var attributes = state.attributes[name] || {};
        var element = state.elements[name]; // arrow is optional + virtual elements
        if (!(0, $3PA3h.isHTMLElement)(element) || !(0, $1Ppz2.default)(element)) return;
         // Flow doesn't support to extend this property, but it's the most
        // effective way to apply styles to an HTMLElement
        // $FlowFixMe[cannot-write]
        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function(name) {
            var value = attributes[name];
            if (value === false) element.removeAttribute(name);
            else element.setAttribute(name, value === true ? "" : value);
        });
    });
}
function $63d2edb5de4a1a51$var$effect(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
        popper: {
            position: state.options.strategy,
            left: "0",
            top: "0",
            margin: "0"
        },
        arrow: {
            position: "absolute"
        },
        reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;
    if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
    return function() {
        Object.keys(state.elements).forEach(function(name) {
            var element = state.elements[name];
            var attributes = state.attributes[name] || {};
            var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them
            var style = styleProperties.reduce(function(style, property) {
                style[property] = "";
                return style;
            }, {}); // arrow is optional + virtual elements
            if (!(0, $3PA3h.isHTMLElement)(element) || !(0, $1Ppz2.default)(element)) return;
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(attribute) {
                element.removeAttribute(attribute);
            });
        });
    };
} // eslint-disable-next-line import/no-unused-modules
var $63d2edb5de4a1a51$export$2e2bcd8739ae039 = {
    name: "applyStyles",
    enabled: true,
    phase: "write",
    fn: $63d2edb5de4a1a51$var$applyStyles,
    effect: $63d2edb5de4a1a51$var$effect,
    requires: [
        "computeStyles"
    ]
};

});

parcelRegister("ijb9m", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d542a67fc2db7771$export$2e2bcd8739ae039; });

var $58k8I = parcelRequire("58k8I");

var $8JsOw = parcelRequire("8JsOw");
function $d542a67fc2db7771$export$7fa02d8595b015ed(placement, rects, offset) {
    var basePlacement = (0, $58k8I.default)(placement);
    var invertDistance = [
        (0, $8JsOw.left),
        (0, $8JsOw.top)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === "function" ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, $8JsOw.left),
        (0, $8JsOw.right)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function $d542a67fc2db7771$var$offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, $8JsOw.placements).reduce(function(acc, placement) {
        acc[placement] = $d542a67fc2db7771$export$7fa02d8595b015ed(placement, state.rects, offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $d542a67fc2db7771$export$2e2bcd8739ae039 = {
    name: "offset",
    enabled: true,
    phase: "main",
    requires: [
        "popperOffsets"
    ],
    fn: $d542a67fc2db7771$var$offset
};

});

parcelRegister("b8yhw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $81bb08b0b3018c6a$export$2e2bcd8739ae039; });

var $6kOUH = parcelRequire("6kOUH");

var $58k8I = parcelRequire("58k8I");

var $1Jv87 = parcelRequire("1Jv87");

var $2pZ9S = parcelRequire("2pZ9S");

var $8fKRg = parcelRequire("8fKRg");

var $8JsOw = parcelRequire("8JsOw");

var $k7JE3 = parcelRequire("k7JE3");
function $81bb08b0b3018c6a$var$getExpandedFallbackPlacements(placement) {
    if ((0, $58k8I.default)(placement) === (0, $8JsOw.auto)) return [];
    var oppositePlacement = (0, $6kOUH.default)(placement);
    return [
        (0, $1Jv87.default)(placement),
        oppositePlacement,
        (0, $1Jv87.default)(oppositePlacement)
    ];
}
function $81bb08b0b3018c6a$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, $58k8I.default)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, $6kOUH.default)(preferredPlacement)
    ] : $81bb08b0b3018c6a$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, $58k8I.default)(placement) === (0, $8JsOw.auto) ? (0, $8fKRg.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, $58k8I.default)(placement);
        var isStartVariation = (0, $k7JE3.default)(placement) === (0, $8JsOw.start);
        var isVertical = [
            (0, $8JsOw.top),
            (0, $8JsOw.bottom)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? "width" : "height";
        var overflow = (0, $2pZ9S.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, $8JsOw.right) : (0, $8JsOw.left) : isStartVariation ? (0, $8JsOw.bottom) : (0, $8JsOw.top);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, $6kOUH.default)(mainVariationSide);
        var altVariationSide = (0, $6kOUH.default)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
var $81bb08b0b3018c6a$export$2e2bcd8739ae039 = {
    name: "flip",
    enabled: true,
    phase: "main",
    fn: $81bb08b0b3018c6a$var$flip,
    requiresIfExists: [
        "offset"
    ],
    data: {
        _skip: false
    }
};

});
parcelRegister("6kOUH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $49cc1aac6f8ce75b$export$2e2bcd8739ae039; });
var $49cc1aac6f8ce75b$var$hash = {
    left: "right",
    right: "left",
    bottom: "top",
    top: "bottom"
};
function $49cc1aac6f8ce75b$export$2e2bcd8739ae039(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $49cc1aac6f8ce75b$var$hash[matched];
    });
}

});

parcelRegister("1Jv87", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $14322428d3184e73$export$2e2bcd8739ae039; });
var $14322428d3184e73$var$hash = {
    start: "end",
    end: "start"
};
function $14322428d3184e73$export$2e2bcd8739ae039(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $14322428d3184e73$var$hash[matched];
    });
}

});

parcelRegister("2pZ9S", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1c2d5b54957b0968$export$2e2bcd8739ae039; });

var $n4cS2 = parcelRequire("n4cS2");

var $h7fHt = parcelRequire("h7fHt");

var $6PkDU = parcelRequire("6PkDU");

var $jKICF = parcelRequire("jKICF");

var $4XPft = parcelRequire("4XPft");

var $8JsOw = parcelRequire("8JsOw");

var $3PA3h = parcelRequire("3PA3h");

var $2m6qL = parcelRequire("2m6qL");

var $381gb = parcelRequire("381gb");
function $1c2d5b54957b0968$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, $8JsOw.clippingParents) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, $8JsOw.viewport) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, $8JsOw.popper) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, $2m6qL.default)(typeof padding !== "number" ? padding : (0, $381gb.default)(padding, (0, $8JsOw.basePlacements)));
    var altContext = elementContext === (0, $8JsOw.popper) ? (0, $8JsOw.reference) : (0, $8JsOw.popper);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, $n4cS2.default)((0, $3PA3h.isElement)(element) ? element : element.contextElement || (0, $h7fHt.default)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, $6PkDU.default)(state.elements.reference);
    var popperOffsets = (0, $jKICF.default)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: "absolute",
        placement: placement
    });
    var popperClientRect = (0, $4XPft.default)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, $8JsOw.popper) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, $8JsOw.popper) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, $8JsOw.right),
                (0, $8JsOw.bottom)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, $8JsOw.top),
                (0, $8JsOw.bottom)
            ].indexOf(key) >= 0 ? "y" : "x";
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}

});
parcelRegister("n4cS2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $045569703d107531$export$2e2bcd8739ae039; });

var $8JsOw = parcelRequire("8JsOw");

var $6NZOd = parcelRequire("6NZOd");

var $7j6Sv = parcelRequire("7j6Sv");

var $jUpWD = parcelRequire("jUpWD");

var $hGJnA = parcelRequire("hGJnA");

var $h7fHt = parcelRequire("h7fHt");

var $5uA9p = parcelRequire("5uA9p");

var $3PA3h = parcelRequire("3PA3h");

var $6PkDU = parcelRequire("6PkDU");

var $l09bP = parcelRequire("l09bP");

var $1Lfsb = parcelRequire("1Lfsb");

var $1Ppz2 = parcelRequire("1Ppz2");

var $4XPft = parcelRequire("4XPft");

var $47C1l = parcelRequire("47C1l");
function $045569703d107531$var$getInnerBoundingClientRect(element, strategy) {
    var rect = (0, $6PkDU.default)(element, false, strategy === "fixed");
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $045569703d107531$var$getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, $8JsOw.viewport) ? (0, $4XPft.default)((0, $6NZOd.default)(element, strategy)) : (0, $3PA3h.isElement)(clippingParent) ? $045569703d107531$var$getInnerBoundingClientRect(clippingParent, strategy) : (0, $4XPft.default)((0, $7j6Sv.default)((0, $h7fHt.default)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $045569703d107531$var$getClippingParents(element) {
    var clippingParents = (0, $jUpWD.default)((0, $l09bP.default)(element));
    var canEscapeClipping = [
        "absolute",
        "fixed"
    ].indexOf((0, $5uA9p.default)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, $3PA3h.isHTMLElement)(element) ? (0, $hGJnA.default)(element) : element;
    if (!(0, $3PA3h.isElement)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, $3PA3h.isElement)(clippingParent) && (0, $1Lfsb.default)(clippingParent, clipperElement) && (0, $1Ppz2.default)(clippingParent) !== "body";
    });
} // Gets the maximum area that the element is visible in due to any number of
function $045569703d107531$export$2e2bcd8739ae039(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === "clippingParents" ? $045569703d107531$var$getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = $045569703d107531$var$getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, $47C1l.max)(rect.top, accRect.top);
        accRect.right = (0, $47C1l.min)(rect.right, accRect.right);
        accRect.bottom = (0, $47C1l.min)(rect.bottom, accRect.bottom);
        accRect.left = (0, $47C1l.max)(rect.left, accRect.left);
        return accRect;
    }, $045569703d107531$var$getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}

});
parcelRegister("6NZOd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4f4743a91d25eaa2$export$2e2bcd8739ae039; });

var $8p2rb = parcelRequire("8p2rb");

var $h7fHt = parcelRequire("h7fHt");

var $l5VsU = parcelRequire("l5VsU");

var $fJYPL = parcelRequire("fJYPL");
function $4f4743a91d25eaa2$export$2e2bcd8739ae039(element, strategy) {
    var win = (0, $8p2rb.default)(element);
    var html = (0, $h7fHt.default)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, $fJYPL.default)();
        if (layoutViewport || !layoutViewport && strategy === "fixed") {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, $l5VsU.default)(element),
        y: y
    };
}

});

parcelRegister("7j6Sv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $551fa49b22c1bb98$export$2e2bcd8739ae039; });

var $h7fHt = parcelRequire("h7fHt");

var $5uA9p = parcelRequire("5uA9p");

var $l5VsU = parcelRequire("l5VsU");

var $beXsS = parcelRequire("beXsS");

var $47C1l = parcelRequire("47C1l");
function $551fa49b22c1bb98$export$2e2bcd8739ae039(element) {
    var _element$ownerDocumen;
    var html = (0, $h7fHt.default)(element);
    var winScroll = (0, $beXsS.default)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, $47C1l.max)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, $47C1l.max)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, $l5VsU.default)(element);
    var y = -winScroll.scrollTop;
    if ((0, $5uA9p.default)(body || html).direction === "rtl") x += (0, $47C1l.max)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}

});

parcelRegister("1Lfsb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $14862afda9b2070f$export$2e2bcd8739ae039; });

var $3PA3h = parcelRequire("3PA3h");
function $14862afda9b2070f$export$2e2bcd8739ae039(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, $3PA3h.isShadowRoot)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}

});

parcelRegister("4XPft", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $39d46cfe4e321251$export$2e2bcd8739ae039; });
function $39d46cfe4e321251$export$2e2bcd8739ae039(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}

});


parcelRegister("2m6qL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1b729fdca8061602$export$2e2bcd8739ae039; });

var $aM8PK = parcelRequire("aM8PK");
function $1b729fdca8061602$export$2e2bcd8739ae039(paddingObject) {
    return Object.assign({}, (0, $aM8PK.default)(), paddingObject);
}

});
parcelRegister("aM8PK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7d853d426e707108$export$2e2bcd8739ae039; });
function $7d853d426e707108$export$2e2bcd8739ae039() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}

});


parcelRegister("381gb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $247318a5636ebc02$export$2e2bcd8739ae039; });
function $247318a5636ebc02$export$2e2bcd8739ae039(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}

});


parcelRegister("8fKRg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $60241279445a5f7d$export$2e2bcd8739ae039; });

var $k7JE3 = parcelRequire("k7JE3");

var $8JsOw = parcelRequire("8JsOw");

var $2pZ9S = parcelRequire("2pZ9S");

var $58k8I = parcelRequire("58k8I");
function $60241279445a5f7d$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, $8JsOw.placements) : _options$allowedAutoP;
    var variation = (0, $k7JE3.default)(placement);
    var placements = variation ? flipVariations ? (0, $8JsOw.variationPlacements) : (0, $8JsOw.variationPlacements).filter(function(placement) {
        return (0, $k7JE3.default)(placement) === variation;
    }) : (0, $8JsOw.basePlacements);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, $2pZ9S.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, $58k8I.default)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}

});


parcelRegister("7OxmF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5b0715703f3337b3$export$2e2bcd8739ae039; });

var $8JsOw = parcelRequire("8JsOw");

var $58k8I = parcelRequire("58k8I");

var $1InXb = parcelRequire("1InXb");

var $4QQhU = parcelRequire("4QQhU");

var $cyMex = parcelRequire("cyMex");

var $bq1TO = parcelRequire("bq1TO");

var $hGJnA = parcelRequire("hGJnA");

var $2pZ9S = parcelRequire("2pZ9S");

var $k7JE3 = parcelRequire("k7JE3");

var $aM8PK = parcelRequire("aM8PK");

var $47C1l = parcelRequire("47C1l");
function $5b0715703f3337b3$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, $2pZ9S.default)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, $58k8I.default)(state.placement);
    var variation = (0, $k7JE3.default)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, $1InXb.default)(basePlacement);
    var altAxis = (0, $4QQhU.default)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === "function" ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === "number" ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === "y" ? (0, $8JsOw.top) : (0, $8JsOw.left);
        var altSide = mainAxis === "y" ? (0, $8JsOw.bottom) : (0, $8JsOw.right);
        var len = mainAxis === "y" ? "height" : "width";
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, $8JsOw.start) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, $8JsOw.start) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, $bq1TO.default)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData["arrow#persistent"] ? state.modifiersData["arrow#persistent"].padding : (0, $aM8PK.default)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, $cyMex.within)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, $hGJnA.default)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === "y" ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, $cyMex.within)(tether ? (0, $47C1l.min)(min, tetherMin) : min, offset, tether ? (0, $47C1l.max)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === "x" ? (0, $8JsOw.top) : (0, $8JsOw.left);
        var _altSide = mainAxis === "x" ? (0, $8JsOw.bottom) : (0, $8JsOw.right);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === "y" ? "height" : "width";
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, $8JsOw.top),
            (0, $8JsOw.left)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, $cyMex.withinMaxClamp)(_tetherMin, _offset, _tetherMax) : (0, $cyMex.within)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $5b0715703f3337b3$export$2e2bcd8739ae039 = {
    name: "preventOverflow",
    enabled: true,
    phase: "main",
    fn: $5b0715703f3337b3$var$preventOverflow,
    requiresIfExists: [
        "offset"
    ]
};

});
parcelRegister("4QQhU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3884940e8aa69681$export$2e2bcd8739ae039; });
function $3884940e8aa69681$export$2e2bcd8739ae039(axis) {
    return axis === "x" ? "y" : "x";
}

});

parcelRegister("cyMex", function(module, exports) {

$parcel$export(module.exports, "within", function () { return $924e13283eed6eae$export$f28d906d67a997f3; });
$parcel$export(module.exports, "withinMaxClamp", function () { return $924e13283eed6eae$export$86c8af6d3ef0b4a; });

var $47C1l = parcelRequire("47C1l");
function $924e13283eed6eae$export$f28d906d67a997f3(min, value, max) {
    return (0, $47C1l.max)(min, (0, $47C1l.min)(value, max));
}
function $924e13283eed6eae$export$86c8af6d3ef0b4a(min, value, max) {
    var v = $924e13283eed6eae$export$f28d906d67a997f3(min, value, max);
    return v > max ? max : v;
}

});


parcelRegister("jHxow", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e57beff33488db08$export$2e2bcd8739ae039; });

var $58k8I = parcelRequire("58k8I");

var $bq1TO = parcelRequire("bq1TO");

var $1Lfsb = parcelRequire("1Lfsb");

var $hGJnA = parcelRequire("hGJnA");

var $1InXb = parcelRequire("1InXb");

var $cyMex = parcelRequire("cyMex");

var $2m6qL = parcelRequire("2m6qL");

var $381gb = parcelRequire("381gb");

var $8JsOw = parcelRequire("8JsOw");
var $e57beff33488db08$var$toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === "function" ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, $2m6qL.default)(typeof padding !== "number" ? padding : (0, $381gb.default)(padding, (0, $8JsOw.basePlacements)));
};
function $e57beff33488db08$var$arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, $58k8I.default)(state.placement);
    var axis = (0, $1InXb.default)(basePlacement);
    var isVertical = [
        (0, $8JsOw.left),
        (0, $8JsOw.right)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? "height" : "width";
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = $e57beff33488db08$var$toPaddingObject(options.padding, state);
    var arrowRect = (0, $bq1TO.default)(arrowElement);
    var minProp = axis === "y" ? (0, $8JsOw.top) : (0, $8JsOw.left);
    var maxProp = axis === "y" ? (0, $8JsOw.bottom) : (0, $8JsOw.right);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, $hGJnA.default)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === "y" ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, $cyMex.within)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function $e57beff33488db08$var$effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? "[data-popper-arrow]" : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === "string") {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, $1Lfsb.default)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
var $e57beff33488db08$export$2e2bcd8739ae039 = {
    name: "arrow",
    enabled: true,
    phase: "main",
    fn: $e57beff33488db08$var$arrow,
    effect: $e57beff33488db08$var$effect,
    requires: [
        "popperOffsets"
    ],
    requiresIfExists: [
        "preventOverflow"
    ]
};

});

parcelRegister("4DDjm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $36094c57e07f8c02$export$2e2bcd8739ae039; });

var $8JsOw = parcelRequire("8JsOw");

var $2pZ9S = parcelRequire("2pZ9S");
function $36094c57e07f8c02$var$getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function $36094c57e07f8c02$var$isAnySideFullyClipped(overflow) {
    return [
        (0, $8JsOw.top),
        (0, $8JsOw.right),
        (0, $8JsOw.bottom),
        (0, $8JsOw.left)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function $36094c57e07f8c02$var$hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, $2pZ9S.default)(state, {
        elementContext: "reference"
    });
    var popperAltOverflow = (0, $2pZ9S.default)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = $36094c57e07f8c02$var$getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = $36094c57e07f8c02$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = $36094c57e07f8c02$var$isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = $36094c57e07f8c02$var$isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        "data-popper-reference-hidden": isReferenceHidden,
        "data-popper-escaped": hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
var $36094c57e07f8c02$export$2e2bcd8739ae039 = {
    name: "hide",
    enabled: true,
    phase: "main",
    requiresIfExists: [
        "preventOverflow"
    ],
    fn: $36094c57e07f8c02$var$hide
};

});


parcelRegister("856WZ", function(module, exports) {
/* global Map:readonly, Set:readonly, ArrayBuffer:readonly */ var $5e242e91fc89c74f$var$hasElementType = typeof Element !== "undefined";
var $5e242e91fc89c74f$var$hasMap = typeof Map === "function";
var $5e242e91fc89c74f$var$hasSet = typeof Set === "function";
var $5e242e91fc89c74f$var$hasArrayBuffer = typeof ArrayBuffer === "function" && !!ArrayBuffer.isView;
// Note: We **don't** need `envHasBigInt64Array` in fde es6/index.js
function $5e242e91fc89c74f$var$equal(a, b) {
    // START: fast-deep-equal es6/index.js 3.1.3
    if (a === b) return true;
    if (a && b && typeof a == "object" && typeof b == "object") {
        if (a.constructor !== b.constructor) return false;
        var length, i, keys;
        if (Array.isArray(a)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!$5e242e91fc89c74f$var$equal(a[i], b[i])) return false;
            return true;
        }
        // START: Modifications:
        // 1. Extra `has<Type> &&` helpers in initial condition allow es6 code
        //    to co-exist with es5.
        // 2. Replace `for of` with es5 compliant iteration using `for`.
        //    Basically, take:
        //
        //    ```js
        //    for (i of a.entries())
        //      if (!b.has(i[0])) return false;
        //    ```
        //
        //    ... and convert to:
        //
        //    ```js
        //    it = a.entries();
        //    while (!(i = it.next()).done)
        //      if (!b.has(i.value[0])) return false;
        //    ```
        //
        //    **Note**: `i` access switches to `i.value`.
        var it;
        if ($5e242e91fc89c74f$var$hasMap && a instanceof Map && b instanceof Map) {
            if (a.size !== b.size) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!b.has(i.value[0])) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!$5e242e91fc89c74f$var$equal(i.value[1], b.get(i.value[0]))) return false;
            return true;
        }
        if ($5e242e91fc89c74f$var$hasSet && a instanceof Set && b instanceof Set) {
            if (a.size !== b.size) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!b.has(i.value[0])) return false;
            return true;
        }
        // END: Modifications
        if ($5e242e91fc89c74f$var$hasArrayBuffer && ArrayBuffer.isView(a) && ArrayBuffer.isView(b)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (a[i] !== b[i]) return false;
            return true;
        }
        if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
        // START: Modifications:
        // Apply guards for `Object.create(null)` handling. See:
        // - https://github.com/FormidableLabs/react-fast-compare/issues/64
        // - https://github.com/epoberezkin/fast-deep-equal/issues/49
        if (a.valueOf !== Object.prototype.valueOf && typeof a.valueOf === "function" && typeof b.valueOf === "function") return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString && typeof a.toString === "function" && typeof b.toString === "function") return a.toString() === b.toString();
        // END: Modifications
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;)if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
        // END: fast-deep-equal
        // START: react-fast-compare
        // custom handling for DOM elements
        if ($5e242e91fc89c74f$var$hasElementType && a instanceof Element) return false;
        // custom handling for React/Preact
        for(i = length; i-- !== 0;){
            if ((keys[i] === "_owner" || keys[i] === "__v" || keys[i] === "__o") && a.$$typeof) continue;
            // all other properties should be traversed as usual
            if (!$5e242e91fc89c74f$var$equal(a[keys[i]], b[keys[i]])) return false;
        }
        // END: react-fast-compare
        // START: fast-deep-equal
        return true;
    }
    return a !== a && b !== b;
}
// end fast-deep-equal
module.exports = function isEqual(a, b) {
    try {
        return $5e242e91fc89c74f$var$equal(a, b);
    } catch (error) {
        if ((error.message || "").match(/stack|recursion/i)) {
            // warn on circular references, don't crash
            // browsers give this different errors name and messages:
            // chrome/safari: "RangeError", "Maximum call stack size exceeded"
            // firefox: "InternalError", too much recursion"
            // edge: "Error", "Out of stack space"
            console.warn("react-fast-compare cannot handle circular refs");
            return false;
        }
        // some other error. we should definitely know about these
        throw error;
    }
};

});



parcelRegister("9WK43", function(module, exports) {

$parcel$export(module.exports, "getMaxSizeModifiers", function () { return $73dd434964a46c07$export$6d8c2b45c99d6e3f; });

var $lBoJt = parcelRequire("lBoJt");
function $73dd434964a46c07$export$6d8c2b45c99d6e3f(_ref) {
    var viewportPadding = _ref.viewportPadding;
    return [
        {
            /**
     * Performing DOM measurements in the 'read' phase,
     * which is the convention for popper modifiers
     */ name: "maxSizeData",
            enabled: true,
            phase: "read",
            fn: function fn(_ref2) {
                var state = _ref2.state, name = _ref2.name;
                if (!window.visualViewport) return;
                state.modifiersData[name] = {
                    viewport: {
                        width: window.visualViewport.width,
                        height: window.visualViewport.height
                    }
                };
            }
        },
        {
            /**
     * Applying max size CSS
     */ name: "maxSize",
            enabled: true,
            phase: "beforeWrite",
            requiresIfExists: [
                "offset",
                "preventOverflow",
                "flip"
            ],
            fn: function fn(_ref3) {
                var _data$viewport, _data$viewport2, _state$modifiersData$2, _state$modifiersData;
                var state = _ref3.state;
                var data = state.modifiersData.maxSizeData;
                if (typeof (data === null || data === void 0 || (_data$viewport = data.viewport) === null || _data$viewport === void 0 ? void 0 : _data$viewport.width) !== "number" || typeof (data === null || data === void 0 || (_data$viewport2 = data.viewport) === null || _data$viewport2 === void 0 ? void 0 : _data$viewport2.height) !== "number") // This shouldn't occur in a real browser but might in non-browser test environments
                return;
                var viewport = data.viewport;
                var _state$modifiersData$ = state.modifiersData.popperOffsets, popperOffsets = _state$modifiersData$ === void 0 ? {
                    x: 0,
                    y: 0
                } : _state$modifiersData$;
                var _state$placement$spli = state.placement.split("-"), _state$placement$spli2 = (0, (/*@__PURE__*/$parcel$interopDefault($lBoJt)))(_state$placement$spli, 1), basePlacement = _state$placement$spli2[0];
                var placementOffset = (_state$modifiersData$2 = (_state$modifiersData = state.modifiersData) === null || _state$modifiersData === void 0 || (_state$modifiersData = _state$modifiersData.offset) === null || _state$modifiersData === void 0 ? void 0 : _state$modifiersData[state.placement]) !== null && _state$modifiersData$2 !== void 0 ? _state$modifiersData$2 : {
                    x: 0,
                    y: 0
                };
                // By default we set these to the entire viewport (minus padding)
                // Each placement direction will overwrite one of these
                var maxWidth = viewport.width - 2 * viewportPadding;
                var maxHeight = viewport.height - 2 * viewportPadding;
                if (basePlacement === "top") maxHeight = state.rects.reference.y + // Viewport-relative position of reference element
                placementOffset.y - // Space between popper and reference
                viewportPadding;
                if (basePlacement === "bottom") maxHeight = viewport.height - popperOffsets.y - // Viewport-relative position of popper
                viewportPadding;
                if (basePlacement === "left") maxWidth = state.rects.reference.x + // Viewport-relative position of reference element
                placementOffset.x - // Space between popper and reference
                viewportPadding;
                if (basePlacement === "right") maxWidth = viewport.width - popperOffsets.x - // Viewport-relative position of popper
                viewportPadding;
                state.styles.popper.maxWidth = "".concat(maxWidth, "px");
                state.styles.popper.maxHeight = "".concat(maxHeight, "px");
            }
        }
    ];
}

});


parcelRegister("4Yjoy", function(module, exports) {

$parcel$export(module.exports, "Reference", function () { return $39ebcf7835a1ba1d$export$e0be378c32fb70a7; });

var $dAx5m = parcelRequire("dAx5m");

var $4qKMg = parcelRequire("4qKMg");

var $expeE = parcelRequire("expeE");

var $wMbSc = parcelRequire("wMbSc");
function $39ebcf7835a1ba1d$export$e0be378c32fb70a7(_ref) {
    var children = _ref.children, innerRef = _ref.innerRef;
    var setReferenceNode = $dAx5m.useContext((0, $expeE.ManagerReferenceNodeSetterContext));
    var refHandler = $dAx5m.useCallback(function(node) {
        (0, $wMbSc.setRef)(innerRef, node);
        (0, $wMbSc.safeInvoke)(setReferenceNode, node);
    }, [
        innerRef,
        setReferenceNode
    ]); // ran on unmount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    $dAx5m.useEffect(function() {
        return function() {
            return (0, $wMbSc.setRef)(innerRef, null);
        };
    }, []);
    $dAx5m.useEffect(function() {
        (0, (/*@__PURE__*/$parcel$interopDefault($4qKMg)))(Boolean(setReferenceNode), "`Reference` should not be used outside of a `Manager` component.");
    }, [
        setReferenceNode
    ]);
    return (0, $wMbSc.unwrapArray)(children)({
        ref: refHandler
    });
}

});
parcelRegister("4qKMg", function(module, exports) {
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */ var $339de0265402b4c3$var$__DEV__ = false;
var $339de0265402b4c3$var$warning = function() {};
if ($339de0265402b4c3$var$__DEV__) {
    var $339de0265402b4c3$var$printWarning = function printWarning(format, args) {
        var len = arguments.length;
        args = new Array(len > 1 ? len - 1 : 0);
        for(var key = 1; key < len; key++)args[key - 1] = arguments[key];
        var argIndex = 0;
        var message = "Warning: " + format.replace(/%s/g, function() {
            return args[argIndex++];
        });
        if (typeof console !== "undefined") console.error(message);
        try {
            // --- Welcome to debugging React ---
            // This error was thrown as a convenience so that you can use this stack
            // to find the callsite that caused this warning to fire.
            throw new Error(message);
        } catch (x) {}
    };
    $339de0265402b4c3$var$warning = function(condition, format, args) {
        var len = arguments.length;
        args = new Array(len > 2 ? len - 2 : 0);
        for(var key = 2; key < len; key++)args[key - 2] = arguments[key];
        if (format === undefined) throw new Error("`warning(condition, format, ...args)` requires a warning message argument");
        if (!condition) $339de0265402b4c3$var$printWarning.apply(null, [
            format
        ].concat(args));
    };
}
module.exports = $339de0265402b4c3$var$warning;

});


parcelRegister("ia4mY", function(module, exports) {

$parcel$export(module.exports, "Container", function () { return $d38c8ce1af0d89cb$export$42a852a2b6b56249; });

var $9NvhG = parcelRequire("9NvhG");

var $dAx5m = parcelRequire("dAx5m");

var $jVTBW = parcelRequire("jVTBW");

var $1dsgc = parcelRequire("1dsgc");

var $erlI2 = parcelRequire("erlI2");
function $d38c8ce1af0d89cb$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $d38c8ce1af0d89cb$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $d38c8ce1af0d89cb$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($9NvhG)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $d38c8ce1af0d89cb$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $d38c8ce1af0d89cb$var$CSS_THEME_BACKGROUND = "--theme-background";
var $d38c8ce1af0d89cb$var$CSS_THEME_COLOR = "--theme-color";
var $d38c8ce1af0d89cb$var$CSS_THEME_BOX_SHADOW = "--theme-box-shadow";
var $d38c8ce1af0d89cb$var$containerStyles = (0, $jVTBW.css)({
    boxSizing: "content-box",
    maxWidth: "".concat(448, "px"),
    maxHeight: "".concat(448, "px"),
    padding: "var(--ds-space-200, 16px)".concat(" ", "var(--ds-space-300, 24px)"),
    zIndex: (0, $erlI2.layers).dialog(),
    background: "var(".concat($d38c8ce1af0d89cb$var$CSS_THEME_BACKGROUND, ")"),
    borderRadius: "var(--ds-border-radius, 3px)",
    boxShadow: "var(".concat($d38c8ce1af0d89cb$var$CSS_THEME_BOX_SHADOW, ")"),
    color: "var(".concat($d38c8ce1af0d89cb$var$CSS_THEME_COLOR, ")"),
    "&:focus": {
        outline: "none"
    }
});
var $d38c8ce1af0d89cb$export$42a852a2b6b56249 = /*#__PURE__*/ (0, $dAx5m.forwardRef)(function(_ref, ref) {
    var _objectSpread2;
    var children = _ref.children, onBlur = _ref.onBlur, onClick = _ref.onClick, onFocus = _ref.onFocus, style = _ref.style, testId = _ref.testId;
    return(// Unfortunately, these are used for products to pass through. Inline Dialog is being deprecated anyway
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
    (0, $jVTBW.jsx)("div", {
        css: $d38c8ce1af0d89cb$var$containerStyles,
        "data-testid": testId,
        onBlur: onBlur,
        onClick: onClick,
        onFocus: onFocus,
        ref: ref,
        style: $d38c8ce1af0d89cb$var$_objectSpread((_objectSpread2 = {}, (0, (/*@__PURE__*/$parcel$interopDefault($9NvhG)))(_objectSpread2, $d38c8ce1af0d89cb$var$CSS_THEME_BACKGROUND, "var(--ds-surface-overlay, ".concat((0, $1dsgc.N0), ")")), (0, (/*@__PURE__*/$parcel$interopDefault($9NvhG)))(_objectSpread2, $d38c8ce1af0d89cb$var$CSS_THEME_COLOR, "var(--ds-text, ".concat((0, $1dsgc.N900), ")")), (0, (/*@__PURE__*/$parcel$interopDefault($9NvhG)))(_objectSpread2, $d38c8ce1af0d89cb$var$CSS_THEME_BOX_SHADOW, "var(--ds-shadow-overlay, ".concat("0 4px 8px -2px ".concat((0, $1dsgc.N50A), ", 0 0 1px ").concat((0, $1dsgc.N60A)), ")")), _objectSpread2), style)
    }, children));
});

});
parcelRegister("1dsgc", function(module, exports) {

$parcel$export(module.exports, "B200", function () { return $0e2ced3ccc4a16e6$export$215b7063051591f1; });
$parcel$export(module.exports, "N0", function () { return $0e2ced3ccc4a16e6$export$29a4f05edc054374; });
$parcel$export(module.exports, "N900", function () { return $0e2ced3ccc4a16e6$export$fbda843f0a27fe96; });
$parcel$export(module.exports, "N30A", function () { return $0e2ced3ccc4a16e6$export$920c0d5c49070351; });
$parcel$export(module.exports, "N50A", function () { return $0e2ced3ccc4a16e6$export$7d3359664e8bb0e5; });
$parcel$export(module.exports, "N60A", function () { return $0e2ced3ccc4a16e6$export$d2d3bedfb276cac0; });
$parcel$export(module.exports, "skeleton", function () { return $0e2ced3ccc4a16e6$export$2a0674ff2eb10214; });
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ 
var $loWqx = parcelRequire("loWqx");
var $0e2ced3ccc4a16e6$export$4b84fd0e2c617bd = "#FFEBE6";
var $0e2ced3ccc4a16e6$export$b34b069eff244586 = "#FFBDAD";
var $0e2ced3ccc4a16e6$export$be802dd0d8b57f35 = "#FF8F73";
var $0e2ced3ccc4a16e6$export$60847d42f9da92a6 = "#FF7452";
var $0e2ced3ccc4a16e6$export$4a7404f376229999 = "#FF5630";
var $0e2ced3ccc4a16e6$export$2010d0fb4295b346 = "#DE350B";
var $0e2ced3ccc4a16e6$export$2837b5a1a71d5c02 = "#BF2600";
var $0e2ced3ccc4a16e6$export$8d9596b529bbb9cf = "#FFFAE6";
var $0e2ced3ccc4a16e6$export$41060a744ab0b7ae = "#FFF0B3";
var $0e2ced3ccc4a16e6$export$1cc05bbbf340e559 = "#FFE380";
var $0e2ced3ccc4a16e6$export$5aae31392d72caaa = "#FFC400";
var $0e2ced3ccc4a16e6$export$c6930421db9fa514 = "#FFAB00";
var $0e2ced3ccc4a16e6$export$59619663aa6500fb = "#FF991F";
var $0e2ced3ccc4a16e6$export$874739ea9e379ab6 = "#FF8B00";
var $0e2ced3ccc4a16e6$export$8a6341c32b6a3ee6 = "#E3FCEF";
var $0e2ced3ccc4a16e6$export$69a3bf21b9686c2b = "#ABF5D1";
var $0e2ced3ccc4a16e6$export$afbce1382ec95f73 = "#79F2C0";
var $0e2ced3ccc4a16e6$export$747d86715d4175de = "#57D9A3";
var $0e2ced3ccc4a16e6$export$940e1f69e873f202 = "#36B37E";
var $0e2ced3ccc4a16e6$export$a49394138f7b8e85 = "#00875A";
var $0e2ced3ccc4a16e6$export$6fa04827ac68a4fb = "#006644";
var $0e2ced3ccc4a16e6$export$226de0355ed012f8 = "#DEEBFF";
var $0e2ced3ccc4a16e6$export$8c13c2ee36917869 = "#B3D4FF";
var $0e2ced3ccc4a16e6$export$ecfc1dff386a3e7a = "#4C9AFF";
var $0e2ced3ccc4a16e6$export$215b7063051591f1 = "#2684FF";
var $0e2ced3ccc4a16e6$export$e62e8919cca44969 = "#0065FF";
var $0e2ced3ccc4a16e6$export$b3de0ae08da2ce64 = "#0052CC";
var $0e2ced3ccc4a16e6$export$a6ee3d71bc067634 = "#0747A6";
var $0e2ced3ccc4a16e6$export$363e4475840015bb = "#EAE6FF";
var $0e2ced3ccc4a16e6$export$4b0a4417ed59760f = "#C0B6F2";
var $0e2ced3ccc4a16e6$export$6011520a64d9a187 = "#998DD9";
var $0e2ced3ccc4a16e6$export$a7175d4e9206bc80 = "#8777D9";
var $0e2ced3ccc4a16e6$export$b48405b95304b5a1 = "#6554C0";
var $0e2ced3ccc4a16e6$export$c71e4279dd54a18d = "#5243AA";
var $0e2ced3ccc4a16e6$export$147899de772240ec = "#403294";
var $0e2ced3ccc4a16e6$export$2cf711fe14c66f06 = "#E6FCFF";
var $0e2ced3ccc4a16e6$export$7a8f4d33f6f9772c = "#B3F5FF";
var $0e2ced3ccc4a16e6$export$776c9c497ef08533 = "#79E2F2";
var $0e2ced3ccc4a16e6$export$69cb3ca10c1e330e = "#00C7E6";
var $0e2ced3ccc4a16e6$export$9dc1ef0f3f48059b = "#00B8D9";
var $0e2ced3ccc4a16e6$export$7c835c78b6fcdef8 = "#00A3BF";
var $0e2ced3ccc4a16e6$export$6036577f95c3877e = "#008DA6";
var $0e2ced3ccc4a16e6$export$29a4f05edc054374 = "#FFFFFF";
var $0e2ced3ccc4a16e6$export$e655ef011c4aa1a2 = "#FAFBFC";
var $0e2ced3ccc4a16e6$export$9fdfb749e33cdf97 = "#F4F5F7";
var $0e2ced3ccc4a16e6$export$3e51e8f1440314ba = "#EBECF0";
var $0e2ced3ccc4a16e6$export$1ce2d1575d444ceb = "#DFE1E6";
var $0e2ced3ccc4a16e6$export$8754fc7e6d8b3000 = "#C1C7D0";
var $0e2ced3ccc4a16e6$export$c2e91cbeada39b8b = "#B3BAC5";
var $0e2ced3ccc4a16e6$export$5f71e19f3a7ad9de = "#A5ADBA";
var $0e2ced3ccc4a16e6$export$eaa8c8a70ac22806 = "#97A0AF";
var $0e2ced3ccc4a16e6$export$7c87d337fb91a97d = "#8993A4";
var $0e2ced3ccc4a16e6$export$d6447c357493214f = "#7A869A";
var $0e2ced3ccc4a16e6$export$f563ee71e9ee74cd = "#6B778C";
var $0e2ced3ccc4a16e6$export$e2ef2124cf4024b1 = "#5E6C84";
var $0e2ced3ccc4a16e6$export$eece5f492e429f08 = "#505F79";
var $0e2ced3ccc4a16e6$export$c39c0fe0f26207ae = "#42526E";
var $0e2ced3ccc4a16e6$export$7090862dc3038a9f = "#344563";
var $0e2ced3ccc4a16e6$export$ad0bacf983b7ddaa = "#253858";
var $0e2ced3ccc4a16e6$export$7d61b15e0da132af = "#172B4D";
var $0e2ced3ccc4a16e6$export$fbda843f0a27fe96 = "#091E42";
var $0e2ced3ccc4a16e6$export$791e57b27ca738ef = "rgba(9, 30, 66, 0.02)";
var $0e2ced3ccc4a16e6$export$8d43898f60b96a82 = "rgba(9, 30, 66, 0.04)";
var $0e2ced3ccc4a16e6$export$920c0d5c49070351 = "rgba(9, 30, 66, 0.08)";
var $0e2ced3ccc4a16e6$export$46987b49aab6d1a8 = "rgba(9, 30, 66, 0.13)";
var $0e2ced3ccc4a16e6$export$7d3359664e8bb0e5 = "rgba(9, 30, 66, 0.25)";
var $0e2ced3ccc4a16e6$export$d2d3bedfb276cac0 = "rgba(9, 30, 66, 0.31)";
var $0e2ced3ccc4a16e6$export$6e5e7499ff054f6d = "rgba(9, 30, 66, 0.36)";
var $0e2ced3ccc4a16e6$export$59264b346c877fa7 = "rgba(9, 30, 66, 0.42)";
var $0e2ced3ccc4a16e6$export$d092757d7c64925c = "rgba(9, 30, 66, 0.48)";
var $0e2ced3ccc4a16e6$export$486ab785e4bac3c6 = "rgba(9, 30, 66, 0.54)";
var $0e2ced3ccc4a16e6$export$fba592bbc6419fea = "rgba(9, 30, 66, 0.60)";
var $0e2ced3ccc4a16e6$export$13609db0e6812ab8 = "rgba(9, 30, 66, 0.66)";
var $0e2ced3ccc4a16e6$export$fbae4efaa892d883 = "rgba(9, 30, 66, 0.71)";
var $0e2ced3ccc4a16e6$export$f13946d26f440ce6 = "rgba(9, 30, 66, 0.77)";
var $0e2ced3ccc4a16e6$export$19f58225ac52a306 = "rgba(9, 30, 66, 0.82)";
var $0e2ced3ccc4a16e6$export$6384f09da70e7b62 = "rgba(9, 30, 66, 0.89)";
var $0e2ced3ccc4a16e6$export$d0dccc730683edc2 = "rgba(9, 30, 66, 0.95)";
var $0e2ced3ccc4a16e6$export$2f6319cf7d736c2a = "#E6EDFA";
var $0e2ced3ccc4a16e6$export$95126bc8884d6634 = "#DCE5F5";
var $0e2ced3ccc4a16e6$export$8338d8c35d44ff1 = "#CED9EB";
var $0e2ced3ccc4a16e6$export$5368d76ae4fbbda7 = "#B8C7E0";
var $0e2ced3ccc4a16e6$export$9f0a771d16ec8d36 = "#ABBBD6";
var $0e2ced3ccc4a16e6$export$abcf8c38338b4aa5 = "#9FB0CC";
var $0e2ced3ccc4a16e6$export$97e81faa16a182c7 = "#8C9CB8";
var $0e2ced3ccc4a16e6$export$bfe21c59123ecf33 = "#7988A3";
var $0e2ced3ccc4a16e6$export$ee82aa2ea6a1558 = "#67758F";
var $0e2ced3ccc4a16e6$export$682927c6ed76be02 = "#56637A";
var $0e2ced3ccc4a16e6$export$91fd9994c5be9757 = "#455166";
var $0e2ced3ccc4a16e6$export$d281fbfe3cff2df6 = "#3B475C";
var $0e2ced3ccc4a16e6$export$3902c91d8b98a753 = "#313D52";
var $0e2ced3ccc4a16e6$export$8e8133c1ba5845b5 = "#283447";
var $0e2ced3ccc4a16e6$export$33ff357f6620b39 = "#202B3D";
var $0e2ced3ccc4a16e6$export$633847cf062b69e0 = "#1B2638";
var $0e2ced3ccc4a16e6$export$9776a6e503bdbf76 = "#121A29";
var $0e2ced3ccc4a16e6$export$6c813d5160dff5db = "#0E1624";
var $0e2ced3ccc4a16e6$export$3d4f271a500072a = "#0D1424";
var $0e2ced3ccc4a16e6$export$fe151285c22759ec = "rgba(13, 20, 36, 0.06)";
var $0e2ced3ccc4a16e6$export$a101c6190d0da34 = "rgba(13, 20, 36, 0.14)";
var $0e2ced3ccc4a16e6$export$4b16f52932fda51 = "rgba(13, 20, 36, 0.18)";
var $0e2ced3ccc4a16e6$export$a74bcd7b9845b0d8 = "rgba(13, 20, 36, 0.29)";
var $0e2ced3ccc4a16e6$export$9209c179316d1751 = "rgba(13, 20, 36, 0.36)";
var $0e2ced3ccc4a16e6$export$88f55133f636c8dd = "rgba(13, 20, 36, 0.40)";
var $0e2ced3ccc4a16e6$export$51126f85d1009512 = "rgba(13, 20, 36, 0.47)";
var $0e2ced3ccc4a16e6$export$a069b547bd23af78 = "rgba(13, 20, 36, 0.53)";
var $0e2ced3ccc4a16e6$export$40cce05af3b2600a = "rgba(13, 20, 36, 0.63)";
var $0e2ced3ccc4a16e6$export$b78942185925a0d = "rgba(13, 20, 36, 0.73)";
var $0e2ced3ccc4a16e6$export$e058fb44b8eaafca = "rgba(13, 20, 36, 0.78)";
var $0e2ced3ccc4a16e6$export$92b0b8de26920c18 = "rgba(13, 20, 36, 0.81)";
var $0e2ced3ccc4a16e6$export$67564f7459d3fc9e = "rgba(13, 20, 36, 0.85)";
var $0e2ced3ccc4a16e6$export$77868e1ca884ffa3 = "rgba(13, 20, 36, 0.89)";
var $0e2ced3ccc4a16e6$export$2afd71d7d3ea2cd5 = "rgba(13, 20, 36, 0.92)";
var $0e2ced3ccc4a16e6$export$f2a0acaab9972c70 = "rgba(13, 20, 36, 0.95)";
var $0e2ced3ccc4a16e6$export$9ab70e67d6475361 = "rgba(13, 20, 36, 0.97)";
var $0e2ced3ccc4a16e6$export$8ce1fd94bee2f412 = (0, $loWqx.default)({
    light: "var(--ds-surface, ".concat($0e2ced3ccc4a16e6$export$29a4f05edc054374, ")"),
    dark: "var(--ds-surface, ".concat($0e2ced3ccc4a16e6$export$633847cf062b69e0, ")")
});
var $0e2ced3ccc4a16e6$export$b861914ea877b580 = (0, $loWqx.default)({
    light: "var(--ds-background-selected, ".concat($0e2ced3ccc4a16e6$export$226de0355ed012f8, ")"),
    dark: "var(--ds-background-selected, ".concat($0e2ced3ccc4a16e6$export$8c13c2ee36917869, ")")
});
var $0e2ced3ccc4a16e6$export$3f1b020df94387af = (0, $loWqx.default)({
    light: "var(--ds-background-neutral-hovered, ".concat($0e2ced3ccc4a16e6$export$3e51e8f1440314ba, ")"),
    dark: "var(--ds-background-neutral-hovered, ".concat($0e2ced3ccc4a16e6$export$d281fbfe3cff2df6, ")")
});
var $0e2ced3ccc4a16e6$export$c0183dbab98ca63e = (0, $loWqx.default)({
    light: "var(--ds-surface-overlay, ".concat($0e2ced3ccc4a16e6$export$29a4f05edc054374, ")"),
    dark: "var(--ds-surface-overlay, ".concat($0e2ced3ccc4a16e6$export$8e8133c1ba5845b5, ")")
});
var $0e2ced3ccc4a16e6$export$6f093cfa640b7166 = (0, $loWqx.default)({
    light: "var(--ds-text, ".concat($0e2ced3ccc4a16e6$export$fbda843f0a27fe96, ")"),
    dark: "var(--ds-text, ".concat($0e2ced3ccc4a16e6$export$5368d76ae4fbbda7, ")")
});
var $0e2ced3ccc4a16e6$export$42f8e9c698766e7a = (0, $loWqx.default)({
    light: "var(--ds-text, ".concat($0e2ced3ccc4a16e6$export$7d61b15e0da132af, ")"),
    dark: "var(--ds-text, ".concat($0e2ced3ccc4a16e6$export$5368d76ae4fbbda7, ")")
});
var $0e2ced3ccc4a16e6$export$c2d157ca1c34b6e3 = (0, $loWqx.default)({
    light: "var(--ds-text-selected, ".concat($0e2ced3ccc4a16e6$export$b3de0ae08da2ce64, ")"),
    dark: "var(--ds-text-selected, ".concat($0e2ced3ccc4a16e6$export$b3de0ae08da2ce64, ")")
});
var $0e2ced3ccc4a16e6$export$1905ba28d7cf066f = (0, $loWqx.default)({
    light: "var(--ds-text-subtlest, ".concat($0e2ced3ccc4a16e6$export$f563ee71e9ee74cd, ")"),
    dark: "var(--ds-text-subtlest, ".concat($0e2ced3ccc4a16e6$export$97e81faa16a182c7, ")")
});
var $0e2ced3ccc4a16e6$export$bd9002130d306d39 = (0, $loWqx.default)({
    light: "var(--ds-text-subtlest, ".concat($0e2ced3ccc4a16e6$export$f563ee71e9ee74cd, ")"),
    dark: "var(--ds-text-subtlest, ".concat($0e2ced3ccc4a16e6$export$bfe21c59123ecf33, ")")
});
var $0e2ced3ccc4a16e6$export$46e4a324ac90507f = (0, $loWqx.default)({
    light: "var(--ds-text, ".concat($0e2ced3ccc4a16e6$export$7d61b15e0da132af, ")"),
    dark: "var(--ds-text, ".concat($0e2ced3ccc4a16e6$export$5368d76ae4fbbda7, ")")
});
var $0e2ced3ccc4a16e6$export$79f3f2b82beb0d36 = (0, $loWqx.default)({
    light: "var(--ds-text-subtlest, ".concat($0e2ced3ccc4a16e6$export$f563ee71e9ee74cd, ")"),
    dark: "var(--ds-text-subtlest, ".concat($0e2ced3ccc4a16e6$export$97e81faa16a182c7, ")")
});
var $0e2ced3ccc4a16e6$export$7bb0d5c671655cc4 = (0, $loWqx.default)({
    light: $0e2ced3ccc4a16e6$export$9fdfb749e33cdf97,
    dark: $0e2ced3ccc4a16e6$export$8e8133c1ba5845b5
});
var $0e2ced3ccc4a16e6$export$9c30223ca0a664fb = (0, $loWqx.default)({
    light: "var(--ds-link, ".concat($0e2ced3ccc4a16e6$export$b3de0ae08da2ce64, ")"),
    dark: "var(--ds-link, ".concat($0e2ced3ccc4a16e6$export$ecfc1dff386a3e7a, ")")
});
var $0e2ced3ccc4a16e6$export$7ed258b0728b004b = (0, $loWqx.default)({
    light: "var(--ds-link-pressed, ".concat($0e2ced3ccc4a16e6$export$e62e8919cca44969, ")"),
    dark: "var(--ds-link-pressed, ".concat($0e2ced3ccc4a16e6$export$215b7063051591f1, ")")
});
var $0e2ced3ccc4a16e6$export$dfa920d8decc8a59 = (0, $loWqx.default)({
    light: "var(--ds-link-pressed, ".concat($0e2ced3ccc4a16e6$export$a6ee3d71bc067634, ")"),
    dark: "var(--ds-link-pressed, ".concat($0e2ced3ccc4a16e6$export$ecfc1dff386a3e7a, ")")
});
var $0e2ced3ccc4a16e6$export$6069e6ad5c78f632 = (0, $loWqx.default)({
    light: "var(--ds-border-focused, ".concat($0e2ced3ccc4a16e6$export$215b7063051591f1, ")"),
    dark: "var(--ds-border-focused, ".concat($0e2ced3ccc4a16e6$export$215b7063051591f1, ")")
});
var $0e2ced3ccc4a16e6$export$9ad721cf3b3debe0 = (0, $loWqx.default)({
    light: "var(--ds-background-brand-bold, ".concat($0e2ced3ccc4a16e6$export$b3de0ae08da2ce64, ")"),
    dark: "var(--ds-background-brand-bold, ".concat($0e2ced3ccc4a16e6$export$ecfc1dff386a3e7a, ")")
});
var $0e2ced3ccc4a16e6$export$2aa0182783e7e9de = (0, $loWqx.default)({
    light: $0e2ced3ccc4a16e6$export$b3de0ae08da2ce64,
    dark: $0e2ced3ccc4a16e6$export$ecfc1dff386a3e7a
});
var $0e2ced3ccc4a16e6$export$8bf7dff220b82b4a = (0, $loWqx.default)({
    light: $0e2ced3ccc4a16e6$export$9dc1ef0f3f48059b,
    dark: $0e2ced3ccc4a16e6$export$69cb3ca10c1e330e
});
var $0e2ced3ccc4a16e6$export$e13cce2a2d16a9d4 = (0, $loWqx.default)({
    light: $0e2ced3ccc4a16e6$export$b48405b95304b5a1,
    dark: $0e2ced3ccc4a16e6$export$6011520a64d9a187
});
var $0e2ced3ccc4a16e6$export$a90204d1394caf30 = (0, $loWqx.default)({
    light: $0e2ced3ccc4a16e6$export$4a7404f376229999,
    dark: $0e2ced3ccc4a16e6$export$4a7404f376229999
});
var $0e2ced3ccc4a16e6$export$594c5a8758200c32 = (0, $loWqx.default)({
    light: $0e2ced3ccc4a16e6$export$c6930421db9fa514,
    dark: $0e2ced3ccc4a16e6$export$c6930421db9fa514
});
var $0e2ced3ccc4a16e6$export$955a2ebd2fb142ae = (0, $loWqx.default)({
    light: $0e2ced3ccc4a16e6$export$940e1f69e873f202,
    dark: $0e2ced3ccc4a16e6$export$940e1f69e873f202
});
var $0e2ced3ccc4a16e6$export$2a0674ff2eb10214 = function skeleton() {
    return "var(--ds-skeleton, ".concat($0e2ced3ccc4a16e6$export$8d43898f60b96a82, ")");
};

});
parcelRegister("loWqx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f9492944f83aacca$export$2e2bcd8739ae039; });
/* eslint-disable prefer-rest-params */ 
var $ihdbT = parcelRequire("ihdbT");
// Unpack custom variants, and get correct value for the current theme
function $f9492944f83aacca$var$themedVariants(variantProp, variants) {
    return function(props) {
        var theme = (0, $ihdbT.default)(props);
        if (props && props[variantProp] && variants) {
            var modes = variants[props[variantProp]];
            if (modes && modes[theme.mode]) {
                var value = modes[theme.mode];
                if (value) return value;
                 // TS believes value can be undefined
            }
        }
        return "";
    };
}
function $f9492944f83aacca$export$2e2bcd8739ae039(modesOrVariant, variantModes) {
    if (typeof modesOrVariant === "string") return $f9492944f83aacca$var$themedVariants(modesOrVariant, variantModes);
    var modes = modesOrVariant;
    return function(props) {
        // Get theme from the user's props
        var theme = (0, $ihdbT.default)(props);
        // User isn't required to provide both light and dark values
        if (theme.mode in modes) {
            var value = modes[theme.mode]; // TS believes value can be undefined
            if (value) return value;
        }
        return "";
    };
}

});
parcelRegister("ihdbT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d4e40bf7d4b537c2$export$2e2bcd8739ae039; });

var $erlI2 = parcelRequire("erlI2");
function $d4e40bf7d4b537c2$export$2e2bcd8739ae039(props) {
    if (props && props.theme) {
        // Theme is the global Atlaskit theme
        if ((0, $erlI2.CHANNEL) in props.theme) return props.theme[0, $erlI2.CHANNEL];
        else if ("mode" in props.theme && (0, $erlI2.THEME_MODES).includes(props.theme.mode)) return props.theme;
    }
    // If format not supported (or no theme provided), return standard theme
    return {
        mode: (0, $erlI2.DEFAULT_THEME_MODE)
    };
}

});
parcelRegister("erlI2", function(module, exports) {

$parcel$export(module.exports, "CHANNEL", function () { return $02b685e47efdc8c5$export$44ffba16bd48dac6; });
$parcel$export(module.exports, "DEFAULT_THEME_MODE", function () { return $02b685e47efdc8c5$export$c93026a968943f95; });
$parcel$export(module.exports, "THEME_MODES", function () { return $02b685e47efdc8c5$export$6ba72c8346b4c57e; });
$parcel$export(module.exports, "layers", function () { return $02b685e47efdc8c5$export$7be255094ccdc533; });

var $e2xkU = parcelRequire("e2xkU");

var $1dsgc = parcelRequire("1dsgc");
var $02b685e47efdc8c5$export$44ffba16bd48dac6 = "__ATLASKIT_THEME__";
var $02b685e47efdc8c5$export$c93026a968943f95 = "light";
var $02b685e47efdc8c5$export$6ba72c8346b4c57e = [
    "light",
    "dark"
];
var $02b685e47efdc8c5$export$7a57f79000377ca2 = function borderRadius() {
    return 3;
};
var $02b685e47efdc8c5$export$6d8204c2cb2e06b8 = function gridSize() {
    return 8;
};
var $02b685e47efdc8c5$export$85e3c3ca0c6fb93 = function fontSize() {
    return 14;
};
var $02b685e47efdc8c5$export$6746fe0d9c9fab54 = function fontSizeSmall() {
    return 11;
};
var $02b685e47efdc8c5$export$a5975749f0374264 = function fontFamily() {
    return "-apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif";
};
var $02b685e47efdc8c5$export$356129969ee49c55 = function codeFontFamily() {
    return "'SFMono-Medium', 'SF Mono', 'Segoe UI Mono', 'Roboto Mono', 'Ubuntu Mono', Menlo, Consolas, Courier, monospace";
};
var $02b685e47efdc8c5$export$8e24544ddba725ee = function focusRing() {
    var color = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "var(--ds-border-focused, ".concat((0, $1dsgc.B200), ")");
    var outlineWidth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $02b685e47efdc8c5$export$6d8204c2cb2e06b8() / 4;
    (0, $e2xkU.default)("@atlaskit/theme", "focus ring mixin", "Please use `@atlaskit/focus-ring` instead.");
    return "\n  &:focus {\n    outline: none;\n    box-shadow: 0px 0px 0px ".concat(outlineWidth, "px ").concat(color, ";\n  }\n");
};
var $02b685e47efdc8c5$export$c0dd343266bc3261 = function noFocusRing() {
    return "\n  box-shadow: none;\n";
};
var $02b685e47efdc8c5$export$7be255094ccdc533 = {
    card: function card() {
        return 100;
    },
    navigation: function navigation() {
        return 200;
    },
    dialog: function dialog() {
        return 300;
    },
    layer: function layer() {
        return 400;
    },
    blanket: function blanket() {
        return 500;
    },
    modal: function modal() {
        return 510;
    },
    flag: function flag() {
        return 600;
    },
    spotlight: function spotlight() {
        return 700;
    },
    tooltip: function tooltip() {
        return 9999;
    }
};
var $02b685e47efdc8c5$export$a1b3edb637fb4f35 = function visuallyHidden() {
    (0, $e2xkU.default)("@atlaskit/theme", "visually hidden mixin", "Please use `@atlaskit/visually-hidden` instead.");
    return {
        border: "0 !important",
        clip: "rect(1px, 1px, 1px, 1px) !important",
        height: "1px !important",
        overflow: "hidden !important",
        padding: "0 !important",
        position: "absolute !important",
        width: "1px !important",
        whiteSpace: "nowrap !important"
    };
};
var $02b685e47efdc8c5$export$ba1d834b86d72a09 = $02b685e47efdc8c5$export$a1b3edb637fb4f35;
var $02b685e47efdc8c5$export$e497e856b4f89fcd = function skeletonShimmer() {
    return {
        css: {
            backgroundColor: "var(--ds-skeleton, ".concat((0, $1dsgc.skeleton)(), ")"),
            animationDuration: "1.5s",
            animationIterationCount: "infinite",
            animationTimingFunction: "linear",
            animationDirection: "alternate"
        },
        keyframes: {
            from: {
                backgroundColor: "var(--ds-skeleton, ".concat((0, $1dsgc.skeleton)(), ")")
            },
            to: {
                backgroundColor: "var(--ds-skeleton-subtle, ".concat((0, $1dsgc.N30A), ")")
            }
        }
    };
};

});








parcelRegister("9TD2F", function(module, exports) {

$parcel$export(module.exports, "default", function () { return (parcelRequire("8hGiD")).default; });

var $8hGiD = parcelRequire("8hGiD");
 // export * from './types';

});
parcelRegister("8hGiD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2c24b31c3cfa09bf$export$2e2bcd8739ae039; });

var $bibO8 = parcelRequire("bibO8");

var $dAx5m = parcelRequire("dAx5m");

var $4FNod = parcelRequire("4FNod");

var $1KXxV = parcelRequire("1KXxV");

var $czpuE = parcelRequire("czpuE");
parcelRequire("3R11C");
var $aocz5 = parcelRequire("aocz5");
parcelRequire("bXKOB");
var $7YADa = parcelRequire("7YADa");

var $dk9DI = parcelRequire("dk9DI");
const $2c24b31c3cfa09bf$export$95598ecadc03a242 = (previousValue, currentValue)=>{
    if (previousValue === null && currentValue === "") // Empty fields are coming in as `null` from GraphQl but are
    // empty strings when returned from the inline edit fields.
    // They're considered unchanged.
    return false;
    return previousValue !== currentValue;
};
const $2c24b31c3cfa09bf$var$ProfileDetailsInlineEdit = ({ icon: icon, infoHelperMessage: infoHelperMessage, inlineDialogContent: inlineDialogContent = null, inlineDialogContentPosition: inlineDialogContentPosition, isReadOnly: isReadOnly, isRequired: isRequired, label: label, onSubmit: onSubmit = ()=>null, placeholder: placeholder, readStyle: readStyle = {}, readValue: readValue, requiredInvalidMessage: requiredInvalidMessage, toolTipContent: toolTipContent = null, value: value })=>{
    const [isHovering, setIsHovering] = (0, $dAx5m.useState)(false);
    const leavingInlineDialogTimeout = (0, $dAx5m.useRef)();
    /* Select all text in the field on focus */ const handleEditFocus = (0, $dAx5m.useCallback)((e)=>{
        const inputRef = e.currentTarget;
        inputRef.setSelectionRange(0, inputRef.value.length);
    }, []);
    const handleConfirm = (0, $dAx5m.useCallback)((newValue)=>{
        // FIXME: Value is still null sometimes
        const trimmedValue = (newValue || "").trim();
        if (isRequired && !trimmedValue) return;
        if ($2c24b31c3cfa09bf$export$95598ecadc03a242(value, trimmedValue)) onSubmit(trimmedValue);
    }, [
        isRequired,
        onSubmit,
        value
    ]);
    const handleReadViewMouseEnter = ()=>{
        clearTimeout(leavingInlineDialogTimeout.current);
        setIsHovering(true);
    };
    const handleReadViewMouseLeave = ()=>{
        leavingInlineDialogTimeout.current = window.setTimeout(()=>{
            setIsHovering(false);
        }, 150);
    };
    const interactionProps = {
        onMouseEnter: handleReadViewMouseEnter,
        onMouseLeave: handleReadViewMouseLeave,
        onFocus: handleReadViewMouseEnter,
        onBlur: handleReadViewMouseLeave
    };
    const getEditView = (fieldProps)=>{
        return /*#__PURE__*/ (0, $bibO8.jsx)((0, $7YADa.default), {
            placeholder: placeholder || "",
            ...fieldProps,
            onFocus: handleEditFocus
        });
    };
    const getReadOnlyView = ()=>{
        return /*#__PURE__*/ (0, $bibO8.jsx)($dk9DI.ReadOnlyViewWrapper, {
            "data-testid": "read-only-view",
            isEmpty: !value,
            children: readValue || value || placeholder
        });
    };
    const getReadView = ()=>{
        return /*#__PURE__*/ (0, $bibO8.jsx)($dk9DI.ReadViewWrapper, {
            isEmpty: !value,
            style: readStyle,
            "data-test-selector": "profile-about-item-read-view",
            children: readValue || value || placeholder
        });
    };
    const renderFieldLabel = ()=>{
        return /*#__PURE__*/ (0, $bibO8.jsxs)($dk9DI.Label, {
            children: [
                /*#__PURE__*/ (0, $bibO8.jsx)($dk9DI.LabelText, {
                    children: label
                }),
                infoHelperMessage && /*#__PURE__*/ (0, $bibO8.jsx)((0, $aocz5.default), {
                    appearance: "dark",
                    message: infoHelperMessage
                })
            ]
        });
    };
    const renderInlineEdit = (hasToolTip = false)=>{
        const fieldName = (label || "").toLowerCase().replace(/ /g, "-");
        return /*#__PURE__*/ (0, $bibO8.jsxs)($dk9DI.InlineEditWrapper, {
            "data-test-selector": `field-wrapper-${fieldName}`,
            children: [
                icon && /*#__PURE__*/ (0, $bibO8.jsx)($dk9DI.IconWrapper, {
                    children: icon
                }),
                /*#__PURE__*/ (0, $bibO8.jsx)("div", {
                    "data-test-selector": `field-edit-${fieldName}`,
                    children: renderEditor(hasToolTip)
                })
            ]
        });
    };
    const renderEditor = (hasToolTip = false)=>{
        if (isReadOnly) return /*#__PURE__*/ (0, $bibO8.jsxs)($dk9DI.InlineEditInnerWrapper, {
            children: [
                label && renderFieldLabel(),
                getReadOnlyView()
            ]
        });
        const tooltip = hasToolTip ? toolTipContent : null;
        return /*#__PURE__*/ (0, $bibO8.jsx)((0, $czpuE.default), {
            position: "right",
            content: tooltip,
            children: /*#__PURE__*/ (0, $bibO8.jsx)((0, $1KXxV.default), {
                label: renderFieldLabel(),
                readViewFitContainerWidth: true,
                defaultValue: value || "",
                editView: getEditView,
                readView: getReadView,
                onConfirm: handleConfirm,
                validate: validateInput
            })
        });
    };
    const validateInput = (value)=>{
        if (!value && isRequired) return requiredInvalidMessage;
    };
    if (inlineDialogContent) {
        // when user is hovering out of current field to hover into its associated inline dialog,
        // we want the inline-dialog still appears
        const content = /*#__PURE__*/ (0, $bibO8.jsx)("div", {
            ...interactionProps,
            children: inlineDialogContent
        });
        return /*#__PURE__*/ (0, $bibO8.jsx)((0, $4FNod.default), {
            content: content,
            placement: inlineDialogContentPosition || "right",
            isOpen: isHovering,
            children: /*#__PURE__*/ (0, $bibO8.jsx)($dk9DI.InlineDialogDisabledTrigger, {
                "data-test-selector": "interaction-wrapper",
                ...interactionProps,
                children: renderInlineEdit()
            })
        });
    } else {
        if (isReadOnly || !toolTipContent) return renderInlineEdit();
        return renderInlineEdit(true);
    }
};
var $2c24b31c3cfa09bf$export$2e2bcd8739ae039 = $2c24b31c3cfa09bf$var$ProfileDetailsInlineEdit;

});
parcelRegister("1KXxV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $147846f4457b7b55$export$2e2bcd8739ae039; });

var $fjHlV = parcelRequire("fjHlV");

var $axuhP = parcelRequire("axuhP");

var $dAx5m = parcelRequire("dAx5m");

var $jVTBW = parcelRequire("jVTBW");

var $lB4om = parcelRequire("lB4om");

var $1Ykwy = parcelRequire("1Ykwy");

var $awY96 = parcelRequire("awY96");

var $8Duts = parcelRequire("8Duts");

var $ez4n6 = parcelRequire("ez4n6");

var $aySbK = parcelRequire("aySbK");

var $kY0Db = parcelRequire("kY0Db");

var $8lpsA = parcelRequire("8lpsA");
function $147846f4457b7b55$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $147846f4457b7b55$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $147846f4457b7b55$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($fjHlV)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $147846f4457b7b55$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $147846f4457b7b55$var$fieldStyles = (0, $jVTBW.css)({
    maxWidth: "100%",
    position: "relative"
});
var $147846f4457b7b55$var$analyticsAttributes = {
    componentName: "inlineEdit",
    packageName: "@atlaskit/inline-edit",
    packageVersion: "13.4.0"
};
var $147846f4457b7b55$var$noop = function noop() {};
var $147846f4457b7b55$var$InnerInlineEdit = function InnerInlineEdit(props) {
    var _props$startWithEditV = props.startWithEditViewOpen, startWithEditViewOpen = _props$startWithEditV === void 0 ? false : _props$startWithEditV, _props$keepEditViewOp = props.keepEditViewOpenOnBlur, keepEditViewOpenOnBlur = _props$keepEditViewOp === void 0 ? false : _props$keepEditViewOp, _props$hideActionButt = props.hideActionButtons, hideActionButtons = _props$hideActionButt === void 0 ? false : _props$hideActionButt, _props$isRequired = props.isRequired, isRequired = _props$isRequired === void 0 ? false : _props$isRequired, _props$readViewFitCon = props.readViewFitContainerWidth, readViewFitContainerWidth = _props$readViewFitCon === void 0 ? false : _props$readViewFitCon, _props$editButtonLabe = props.editButtonLabel, editButtonLabel = _props$editButtonLabe === void 0 ? "Edit" : _props$editButtonLabe, _props$confirmButtonL = props.confirmButtonLabel, confirmButtonLabel = _props$confirmButtonL === void 0 ? "Confirm" : _props$confirmButtonL, _props$cancelButtonLa = props.cancelButtonLabel, cancelButtonLabel = _props$cancelButtonLa === void 0 ? "Cancel" : _props$cancelButtonLa, defaultValue = props.defaultValue, isEditing = props.isEditing, label = props.label, validate = props.validate, readView = props.readView, editView = props.editView, analyticsContext = props.analyticsContext, providedOnConfirm = props.onConfirm, _props$onCancel = props.onCancel, providedOnCancel = _props$onCancel === void 0 ? $147846f4457b7b55$var$noop : _props$onCancel, _props$onEdit = props.onEdit, providedOnEdit = _props$onEdit === void 0 ? $147846f4457b7b55$var$noop : _props$onEdit, testId = props.testId;
    var wasFocusReceivedSinceLastBlurRef = (0, $dAx5m.useRef)(false);
    var isControlled = typeof isEditing === "undefined";
    var _useState = (0, $dAx5m.useState)(startWithEditViewOpen), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($axuhP)))(_useState, 2), isEditingState = _useState2[0], setEditingState = _useState2[1];
    var timerRef = (0, $dAx5m.useRef)();
    var _useButtonFocusHook = (0, $kY0Db.default)(isEditing, isEditingState), editButtonRef = _useButtonFocusHook.editButtonRef, editViewRef = _useButtonFocusHook.editViewRef, shouldBeEditing = _useButtonFocusHook.shouldBeEditing, doNotFocusOnEditButton = _useButtonFocusHook.doNotFocusOnEditButton;
    var onCancel = (0, $dAx5m.useCallback)(function() {
        if (isControlled) setEditingState(false);
        providedOnCancel();
    }, [
        isControlled,
        providedOnCancel
    ]);
    var onEditRequested = (0, $dAx5m.useCallback)(function() {
        if (isControlled) setEditingState(true);
        providedOnEdit();
        if (shouldBeEditing && editViewRef.current) editViewRef.current.focus();
    }, [
        isControlled,
        shouldBeEditing,
        editViewRef,
        providedOnEdit
    ]);
    var onConfirm = (0, $lB4om.usePlatformLeafEventHandler)($147846f4457b7b55$var$_objectSpread({
        fn: function fn(value, analyticsEvent) {
            if (isControlled) setEditingState(false);
            providedOnConfirm(value, analyticsEvent);
        },
        action: "confirmed",
        analyticsData: analyticsContext
    }, $147846f4457b7b55$var$analyticsAttributes));
    var _onCancelClick = (0, $dAx5m.useCallback)(function(event) {
        event.preventDefault();
        onCancel();
    }, [
        onCancel
    ]);
    var tryAutoSubmitWhenBlur = (0, $dAx5m.useCallback)(function(isFieldInvalid, onSubmit, formRef) {
        if (!isFieldInvalid && !wasFocusReceivedSinceLastBlurRef.current && formRef.current) {
            doNotFocusOnEditButton();
            if (formRef.current.checkValidity()) onSubmit();
        }
    }, [
        doNotFocusOnEditButton
    ]);
    /** If keepEditViewOpenOnBlur prop is set to false, will call confirmIfUnfocused() which
   *  confirms the value, if the focus is not transferred to the action buttons.
   *
   *  When you're in `editing` state, the focus will be on the input field. And if you use keyboard
   *  to navigate to `submit` button, this function will be invoked. Then function `onEditViewWrapperFocus`
   *  will be called, the timeout used here is making sure `onEditViewWrapperFocus` is always called before
   *  `autoSubmitWhenBlur`.
   *
   *  There are two paths here the function can be triggered:
   *
   *  - focus on input first, and then use keyboard to `submit`
   *  - focus on input first, and then click anywhere else on the page (outside of edit view wrapper) to `submit` (auto save).
   */ var onEditViewWrapperBlur = (0, $dAx5m.useCallback)(function(isFieldInvalid, onSubmit, formRef) {
        if (!keepEditViewOpenOnBlur) {
            wasFocusReceivedSinceLastBlurRef.current = false;
            timerRef.current = setTimeout(function() {
                return tryAutoSubmitWhenBlur(isFieldInvalid, onSubmit, formRef);
            }, 0);
        }
    }, [
        keepEditViewOpenOnBlur,
        tryAutoSubmitWhenBlur
    ]);
    /** Gets called when focus is transferred to the editView, or action buttons.
   *
   * There are three paths here the function can be called:
   *
   * - when a user click the `editView`
   * - when a user use keyboard to tab into `editView`
   * - when a user use keyboard to tab into `submit` when they were on input field.
   */ var onEditViewWrapperFocus = (0, $dAx5m.useCallback)(function() {
        wasFocusReceivedSinceLastBlurRef.current = true;
    }, []);
    var renderReadView = function renderReadView() {
        return (0, $jVTBW.jsx)((0, $8lpsA.default), {
            editButtonLabel: editButtonLabel,
            onEditRequested: onEditRequested,
            postReadViewClick: doNotFocusOnEditButton,
            editButtonRef: editButtonRef,
            readViewFitContainerWidth: readViewFitContainerWidth,
            readView: readView,
            testId: testId
        });
    };
    return (0, $jVTBW.jsx)((0, $awY96.default), {
        onSubmit: function onSubmit(data) {
            return onConfirm(data.inlineEdit);
        }
    }, function(_ref) {
        var _ref$formProps = _ref.formProps, _onKeyDown = _ref$formProps.onKeyDown, onSubmit = _ref$formProps.onSubmit, formRef = _ref$formProps.ref, reset = _ref.reset;
        return (0, $jVTBW.jsx)("form", {
            /**
       * It is not normally acceptable to add key handlers to non-interactive elements
       * as this is an accessibility anti-pattern. However, because this instance is
       * to add support for keyboard functionality instead of creating an inaccessible
       * custom element, we can add role="presentation" so that there is no negative
       * impacts to assistive technologies.
       */ role: "presentation",
            onKeyDown: function onKeyDown(e) {
                _onKeyDown(e);
                if (e.key === "Esc" || e.key === "Escape") onCancel();
            },
            onSubmit: onSubmit,
            ref: formRef
        }, shouldBeEditing ? (0, $jVTBW.jsx)((0, $1Ykwy.default), {
            name: "inlineEdit",
            label: label,
            defaultValue: defaultValue,
            validate: validate,
            isRequired: isRequired,
            key: "edit-view" // used for reset to default value
        }, function(_ref2) {
            var fieldProps = _ref2.fieldProps, error = _ref2.error;
            return (0, $jVTBW.jsx)("div", {
                css: $147846f4457b7b55$var$fieldStyles,
                onBlur: function onBlur() {
                    onEditViewWrapperBlur(fieldProps.isInvalid, onSubmit, formRef);
                },
                onFocus: onEditViewWrapperFocus
            }, editView($147846f4457b7b55$var$_objectSpread($147846f4457b7b55$var$_objectSpread({}, fieldProps), {}, {
                errorMessage: error
            }), editViewRef), !hideActionButtons ? (0, $jVTBW.jsx)((0, $aySbK.default), {
                testId: testId,
                cancelButtonLabel: cancelButtonLabel,
                confirmButtonLabel: confirmButtonLabel,
                onMouseDown: function onMouseDown() {
                    /** Prevents focus on edit button only if mouse is used to click button, but not when keyboard is used */ doNotFocusOnEditButton();
                },
                onCancelClick: function onCancelClick(e) {
                    reset();
                    _onCancelClick(e);
                }
            }) : /** This is to allow Ctrl + Enter to submit without action buttons */ (0, $jVTBW.jsx)((0, $8Duts.default), {
                hidden: true,
                type: "submit"
            }, (0, $jVTBW.jsx)((0, $ez4n6.default), null, "Submit")));
        }) : /** Field is used here only for the label and spacing */ (0, $jVTBW.jsx)((0, $1Ykwy.default), {
            name: "inlineEdit",
            label: label,
            defaultValue: "",
            isRequired: isRequired,
            key: "read-view" // used for reset to default value
        }, renderReadView));
    });
};
var $147846f4457b7b55$var$InlineEdit = function InlineEdit(props) {
    return (0, $jVTBW.jsx)($147846f4457b7b55$var$InnerInlineEdit, props);
};
var $147846f4457b7b55$export$2e2bcd8739ae039 = $147846f4457b7b55$var$InlineEdit;

});
parcelRegister("fjHlV", function(module, exports) {

var $9uw6A = parcelRequire("9uw6A");
function $b26a424bf1cea1d0$var$_defineProperty(e, r, t) {
    return (r = $9uw6A(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
module.exports = $b26a424bf1cea1d0$var$_defineProperty, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("9uw6A", function(module, exports) {

var $0kBKE = parcelRequire("0kBKE");
var $6e8fd1d9cf2f6567$var$_typeof = $0kBKE.default;

var $goK3g = parcelRequire("goK3g");
function $6e8fd1d9cf2f6567$var$toPropertyKey(t) {
    var i = $goK3g(t, "string");
    return "symbol" == $6e8fd1d9cf2f6567$var$_typeof(i) ? i : i + "";
}
module.exports = $6e8fd1d9cf2f6567$var$toPropertyKey, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("0kBKE", function(module, exports) {
function $000ffc8033434942$var$_typeof(o) {
    "@babel/helpers - typeof";
    return module.exports = $000ffc8033434942$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $000ffc8033434942$var$_typeof(o);
}
module.exports = $000ffc8033434942$var$_typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("goK3g", function(module, exports) {

var $0kBKE = parcelRequire("0kBKE");
var $bf029c2493c1f25d$var$_typeof = $0kBKE.default;
function $bf029c2493c1f25d$var$toPrimitive(t, r) {
    if ("object" != $bf029c2493c1f25d$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $bf029c2493c1f25d$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
module.exports = $bf029c2493c1f25d$var$toPrimitive, module.exports.__esModule = true, module.exports["default"] = module.exports;

});



parcelRegister("axuhP", function(module, exports) {

var $j7rBP = parcelRequire("j7rBP");

var $elDL5 = parcelRequire("elDL5");

var $9oq4U = parcelRequire("9oq4U");

var $7Luan = parcelRequire("7Luan");
function $7ac47ac0c386e295$var$_slicedToArray(r, e) {
    return $j7rBP(r) || $elDL5(r, e) || $9oq4U(r, e) || $7Luan();
}
module.exports = $7ac47ac0c386e295$var$_slicedToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("j7rBP", function(module, exports) {
function $deb4165f7c97f342$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
module.exports = $deb4165f7c97f342$var$_arrayWithHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("elDL5", function(module, exports) {
function $a721de13d41be33f$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
module.exports = $a721de13d41be33f$var$_iterableToArrayLimit, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("9oq4U", function(module, exports) {

var $5Iykd = parcelRequire("5Iykd");
function $6d6a9581c643dd46$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $5Iykd(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $5Iykd(r, a) : void 0;
    }
}
module.exports = $6d6a9581c643dd46$var$_unsupportedIterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("5Iykd", function(module, exports) {
function $429bb009df7c80d3$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
module.exports = $429bb009df7c80d3$var$_arrayLikeToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("7Luan", function(module, exports) {
function $5a745298292c3669$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
module.exports = $5a745298292c3669$var$_nonIterableRest, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("lB4om", function(module, exports) {

$parcel$export(module.exports, "usePlatformLeafEventHandler", function () { return $fb9075d7e4e30b5f$export$a4687b0234b40e28; });

var $fjHlV = parcelRequire("fjHlV");

var $dAx5m = parcelRequire("dAx5m");

var $5b2dw = parcelRequire("5b2dw");

var $8zmUP = parcelRequire("8zmUP");
function $fb9075d7e4e30b5f$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $fb9075d7e4e30b5f$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $fb9075d7e4e30b5f$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($fjHlV)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $fb9075d7e4e30b5f$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $fb9075d7e4e30b5f$export$a4687b0234b40e28(_ref) {
    var fn = _ref.fn, action = _ref.action, componentName = _ref.componentName, actionSubject = _ref.actionSubject, packageName = _ref.packageName, packageVersion = _ref.packageVersion, analyticsData = _ref.analyticsData;
    var _useAnalyticsEvents = (0, $5b2dw.useAnalyticsEvents)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    // We put analyticsData and fn in a ref so that we don't need to break
    // memoization.
    // Generally these could be defined by consumers inline
    // and so we do this to avoid breaking memoization of useCallback
    var dataRef = (0, $8zmUP.useTrackedRef)(analyticsData);
    var fnRef = (0, $8zmUP.useTrackedRef)(fn);
    var handler = (0, $dAx5m.useCallback)(function(value) {
        var analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: actionSubject || componentName,
            attributes: {
                componentName: componentName,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
        // To avoid wrapping this component in AnalyticsContext we manually
        // push the parent context's meta data into the context.
        // Note: this new 'context'
        var context = $fb9075d7e4e30b5f$var$_objectSpread({
            componentName: componentName,
            packageName: packageName,
            packageVersion: packageVersion
        }, dataRef.current);
        analyticsEvent.context.push(context);
        // fire an event on the atlaskit channel
        var clone = analyticsEvent.clone();
        if (clone) clone.fire("atlaskit");
        fnRef.current(value, analyticsEvent);
    }, [
        // These are strings and won't change
        action,
        componentName,
        actionSubject,
        packageName,
        packageVersion,
        // This function is memoized in the context
        createAnalyticsEvent,
        // these are a stable ref because of the useTrackedRef hook
        dataRef,
        fnRef
    ]);
    return handler;
}

});
parcelRegister("5b2dw", function(module, exports) {

$parcel$export(module.exports, "useAnalyticsEvents", function () { return $3c4fb31eb47abbb8$export$5bf35293e545f20c; });

var $tWuif = parcelRequire("tWuif");

var $98Au4 = parcelRequire("98Au4");

var $8WeFD = parcelRequire("8WeFD");
function $3c4fb31eb47abbb8$export$5bf35293e545f20c() {
    var analyticsContext = (0, $8WeFD.useAnalyticsContext)();
    var createAnalyticsEvent = (0, $tWuif.useCallbackOne)(function(payload) {
        return new (0, $98Au4.default)({
            context: analyticsContext.getAtlaskitAnalyticsContext(),
            handlers: analyticsContext.getAtlaskitAnalyticsEventHandlers(),
            payload: payload
        });
    }, [
        analyticsContext
    ]);
    return {
        createAnalyticsEvent: createAnalyticsEvent
    };
}

});
parcelRegister("98Au4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6a71295e7c6a488d$export$2e2bcd8739ae039; });

var $lcV3t = parcelRequire("lcV3t");

var $85VYo = parcelRequire("85VYo");

var $lxWQZ = parcelRequire("lxWQZ");

var $exjKi = parcelRequire("exjKi");

var $8ndhX = parcelRequire("8ndhX");

var $aJt6T = parcelRequire("aJt6T");

var $haY3g = parcelRequire("haY3g");

var $7Ejzv = parcelRequire("7Ejzv");

var $fjHlV = parcelRequire("fjHlV");

var $3fc7r = parcelRequire("3fc7r");
function $6a71295e7c6a488d$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $6a71295e7c6a488d$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, (/*@__PURE__*/$parcel$interopDefault($7Ejzv)))(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, (/*@__PURE__*/$parcel$interopDefault($7Ejzv)))(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, (/*@__PURE__*/$parcel$interopDefault($haY3g)))(this, result);
    };
}
function $6a71295e7c6a488d$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($6a71295e7c6a488d$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $6a71295e7c6a488d$export$35f8383928ba8d7 = function isUIAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $6a71295e7c6a488d$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isUIAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === "UIAnalyticsEvent";
};
var $6a71295e7c6a488d$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_AnalyticsEvent) {
    (0, (/*@__PURE__*/$parcel$interopDefault($aJt6T)))(UIAnalyticsEvent, _AnalyticsEvent);
    var _super = $6a71295e7c6a488d$var$_createSuper(UIAnalyticsEvent);
    function UIAnalyticsEvent(props) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($85VYo)))(this, UIAnalyticsEvent);
        _this = _super.call(this, props);
        (0, (/*@__PURE__*/$parcel$interopDefault($fjHlV)))((0, (/*@__PURE__*/$parcel$interopDefault($exjKi)))(_this), "_isUIAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($fjHlV)))((0, (/*@__PURE__*/$parcel$interopDefault($exjKi)))(_this), "clone", function() {
            if (_this.hasFired) return null;
            var context = (0, (/*@__PURE__*/$parcel$interopDefault($lcV3t)))(_this.context);
            var handlers = (0, (/*@__PURE__*/$parcel$interopDefault($lcV3t)))(_this.handlers);
            /**
       * A hacky "deep clone" of the object. This is limited in that it wont
       * support functions, regexs, Maps, Sets, etc, but none of those need to
       * be represented in our payload.
       */ var payload = JSON.parse(JSON.stringify(_this.payload));
            return new UIAnalyticsEvent({
                context: context,
                handlers: handlers,
                payload: payload
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($fjHlV)))((0, (/*@__PURE__*/$parcel$interopDefault($exjKi)))(_this), "fire", function(channel) {
            if (_this.hasFired) return;
            _this.handlers.forEach(function(handler) {
                return handler((0, (/*@__PURE__*/$parcel$interopDefault($exjKi)))(_this), channel);
            });
            _this.hasFired = true;
        });
        _this.context = props.context || [];
        _this.handlers = props.handlers || [];
        _this.hasFired = false;
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($lxWQZ)))(UIAnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (this.hasFired) return this;
                return (0, (/*@__PURE__*/$parcel$interopDefault($8ndhX)))((0, (/*@__PURE__*/$parcel$interopDefault($7Ejzv)))(UIAnalyticsEvent.prototype), "update", this).call(this, updater);
            }
        }
    ]);
    return UIAnalyticsEvent;
}((0, $3fc7r.default));

});
parcelRegister("lcV3t", function(module, exports) {

var $25dLP = parcelRequire("25dLP");

var $joAcw = parcelRequire("joAcw");

var $9oq4U = parcelRequire("9oq4U");

var $bUv06 = parcelRequire("bUv06");
function $f706f9e7d0a04dd8$var$_toConsumableArray(r) {
    return $25dLP(r) || $joAcw(r) || $9oq4U(r) || $bUv06();
}
module.exports = $f706f9e7d0a04dd8$var$_toConsumableArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("25dLP", function(module, exports) {

var $5Iykd = parcelRequire("5Iykd");
function $1846bae69a473eb1$var$_arrayWithoutHoles(r) {
    if (Array.isArray(r)) return $5Iykd(r);
}
module.exports = $1846bae69a473eb1$var$_arrayWithoutHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("joAcw", function(module, exports) {
function $e1ec56f331308d23$var$_iterableToArray(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
module.exports = $e1ec56f331308d23$var$_iterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("bUv06", function(module, exports) {
function $8abcf8c4f6866a2e$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
module.exports = $8abcf8c4f6866a2e$var$_nonIterableSpread, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("85VYo", function(module, exports) {
function $5e4bc2985cb64c61$var$_classCallCheck(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
module.exports = $5e4bc2985cb64c61$var$_classCallCheck, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("lxWQZ", function(module, exports) {

var $9uw6A = parcelRequire("9uw6A");
function $fafa55259d14e6f7$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, $9uw6A(o.key), o);
    }
}
function $fafa55259d14e6f7$var$_createClass(e, r, t) {
    return r && $fafa55259d14e6f7$var$_defineProperties(e.prototype, r), t && $fafa55259d14e6f7$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}
module.exports = $fafa55259d14e6f7$var$_createClass, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("exjKi", function(module, exports) {
function $a95376dc591fa03b$var$_assertThisInitialized(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}
module.exports = $a95376dc591fa03b$var$_assertThisInitialized, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("8ndhX", function(module, exports) {

var $9o2YZ = parcelRequire("9o2YZ");
function $618ac794be0026ec$var$_get() {
    return module.exports = $618ac794be0026ec$var$_get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function(e, t, r) {
        var p = $9o2YZ(e, t);
        if (p) {
            var n = Object.getOwnPropertyDescriptor(p, t);
            return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value;
        }
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $618ac794be0026ec$var$_get.apply(null, arguments);
}
module.exports = $618ac794be0026ec$var$_get, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("9o2YZ", function(module, exports) {

var $7Ejzv = parcelRequire("7Ejzv");
function $6d58ab3a2c32fcdf$var$_superPropBase(t, o) {
    for(; !({}).hasOwnProperty.call(t, o) && null !== (t = $7Ejzv(t)););
    return t;
}
module.exports = $6d58ab3a2c32fcdf$var$_superPropBase, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("7Ejzv", function(module, exports) {
function $591b735d5402ff01$var$_getPrototypeOf(t) {
    return module.exports = $591b735d5402ff01$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $591b735d5402ff01$var$_getPrototypeOf(t);
}
module.exports = $591b735d5402ff01$var$_getPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

});



parcelRegister("aJt6T", function(module, exports) {

var $k9uof = parcelRequire("k9uof");
function $7d04b0010c714faf$var$_inherits(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && $k9uof(t, e);
}
module.exports = $7d04b0010c714faf$var$_inherits, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("k9uof", function(module, exports) {
function $eabc38c5761191b4$var$_setPrototypeOf(t, e) {
    return module.exports = $eabc38c5761191b4$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $eabc38c5761191b4$var$_setPrototypeOf(t, e);
}
module.exports = $eabc38c5761191b4$var$_setPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("haY3g", function(module, exports) {

var $0kBKE = parcelRequire("0kBKE");
var $c811f3d68e8d7b55$var$_typeof = $0kBKE.default;

var $exjKi = parcelRequire("exjKi");
function $c811f3d68e8d7b55$var$_possibleConstructorReturn(t, e) {
    if (e && ("object" == $c811f3d68e8d7b55$var$_typeof(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return $exjKi(t);
}
module.exports = $c811f3d68e8d7b55$var$_possibleConstructorReturn, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("3fc7r", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $25cc2c670e53dabe$export$2e2bcd8739ae039; });

var $0kBKE = parcelRequire("0kBKE");

var $85VYo = parcelRequire("85VYo");

var $lxWQZ = parcelRequire("lxWQZ");

var $fjHlV = parcelRequire("fjHlV");
function $25cc2c670e53dabe$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $25cc2c670e53dabe$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $25cc2c670e53dabe$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($fjHlV)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $25cc2c670e53dabe$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $25cc2c670e53dabe$export$ad4be5c2ec28cecf = function isAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $25cc2c670e53dabe$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === "AnalyticsEvent";
};
var $25cc2c670e53dabe$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function AnalyticsEvent(props) {
        var _this = this;
        (0, (/*@__PURE__*/$parcel$interopDefault($85VYo)))(this, AnalyticsEvent);
        (0, (/*@__PURE__*/$parcel$interopDefault($fjHlV)))(this, "_isAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($fjHlV)))(this, "clone", function() {
            // just a shallow clone, don't change sub refs unless you want to
            // affect the original's too
            var payload = $25cc2c670e53dabe$var$_objectSpread({}, _this.payload);
            return new AnalyticsEvent({
                payload: payload
            });
        });
        this.payload = props.payload;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($lxWQZ)))(AnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (typeof updater === "function") this.payload = updater(this.payload);
                if ((0, (/*@__PURE__*/$parcel$interopDefault($0kBKE)))(updater) === "object") this.payload = $25cc2c670e53dabe$var$_objectSpread($25cc2c670e53dabe$var$_objectSpread({}, this.payload), updater);
                return this;
            }
        }
    ]);
    return AnalyticsEvent;
}();

});


parcelRegister("8WeFD", function(module, exports) {

$parcel$export(module.exports, "useAnalyticsContext", function () { return $681f1ec0e7c38895$export$d1f587f82ad51c4; });

var $dAx5m = parcelRequire("dAx5m");

var $h0bf1 = parcelRequire("h0bf1");
var $681f1ec0e7c38895$export$d1f587f82ad51c4 = function useAnalyticsContext() {
    return (0, $dAx5m.useContext)((0, $h0bf1.default));
};

});


parcelRegister("8zmUP", function(module, exports) {

$parcel$export(module.exports, "useTrackedRef", function () { return $63d35e2b42e66eb0$export$1d27a74659855e44; });

var $dAx5m = parcelRequire("dAx5m");
var $63d35e2b42e66eb0$export$1d27a74659855e44 = function useTrackedRef(value) {
    var ref = (0, $dAx5m.useRef)(value);
    ref.current = value;
    return ref;
};

});


parcelRegister("1Ykwy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $16fb50ab2f8e35e5$export$2e2bcd8739ae039; });

var $ljkoo = parcelRequire("ljkoo");

var $6cZFk = parcelRequire("6cZFk");

var $hNdt5 = parcelRequire("hNdt5");

var $dAx5m = parcelRequire("dAx5m");

var $jVTBW = parcelRequire("jVTBW");

var $h0JxK = parcelRequire("h0JxK");


var $aiTCW = parcelRequire("aiTCW");

var $awY96 = parcelRequire("awY96");

var $hb374 = parcelRequire("hb374");

var $8WIPl = parcelRequire("8WIPl");

var $ahJoN = parcelRequire("ahJoN");
function $16fb50ab2f8e35e5$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $16fb50ab2f8e35e5$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $16fb50ab2f8e35e5$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($ljkoo)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $16fb50ab2f8e35e5$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $16fb50ab2f8e35e5$var$fieldWrapperStyles = (0, $jVTBW.css)({
    marginBlockStart: "var(--ds-space-100, 8px)"
});
function $16fb50ab2f8e35e5$var$isEvent(event) {
    return Boolean(event && event.target);
}
function $16fb50ab2f8e35e5$var$isFunction(x) {
    return typeof x === "function";
}
function $16fb50ab2f8e35e5$var$usePreviousRef(current) {
    var ref = (0, $dAx5m.useRef)(current);
    // will be updated on the next render
    (0, $dAx5m.useEffect)(function() {
        ref.current = current;
    });
    // return the existing current (pre render)
    return ref;
}
function $16fb50ab2f8e35e5$var$isShallowEqual(previousValue, currentValue) {
    if (previousValue === currentValue) return true;
    // not checking functions
    if (typeof previousValue === "function" && typeof currentValue === "function") return true;
    if (Array.isArray(previousValue) && Array.isArray(currentValue)) return JSON.stringify(previousValue) === JSON.stringify(currentValue);
    if ((0, (/*@__PURE__*/$parcel$interopDefault($hNdt5)))(previousValue) === "object" && (0, (/*@__PURE__*/$parcel$interopDefault($hNdt5)))(currentValue) === "object") return JSON.stringify(previousValue) === JSON.stringify(currentValue);
    return false;
}
function $16fb50ab2f8e35e5$export$2e2bcd8739ae039(props) {
    var _getCurrentValue;
    var _useContext = (0, $dAx5m.useContext)((0, $awY96.FormContext)), registerField = _useContext.registerField, getCurrentValue = _useContext.getCurrentValue;
    var isDisabled = (0, $dAx5m.useContext)((0, $awY96.IsDisabledContext)) || props.isDisabled || false;
    var defaultValue = $16fb50ab2f8e35e5$var$isFunction(props.defaultValue) ? props.defaultValue() : props.defaultValue;
    var latestPropsRef = $16fb50ab2f8e35e5$var$usePreviousRef(props);
    /**
   * HACK: defaultValue can potentially be an array or object which cannot be
   * passed directly into a `useEffect` dependency array, since it will trigger
   * the hook every time.
   */ var isDefaultValueChanged = !$16fb50ab2f8e35e5$var$isShallowEqual(latestPropsRef.current.defaultValue, props.defaultValue);
    var _useState = (0, $dAx5m.useState)({
        fieldProps: {
            onChange: function onChange() {},
            onBlur: function onBlur() {},
            onFocus: function onFocus() {},
            /* Previously, defaultValue was being set as undefined in Field.defaultProps, which
         * effectively made it an optional prop to external consumers of Field. However the
         * prop types defined defaultValue as required, so inside the component it was not
         * valid for defaultValue to be undefined. We need to suppress the error
         * after changing defaultValue to explictly be an optional prop.
         * If default value has changed we are using new default value.
         * Otherwise we need to check if we already have value for this field
         * (because we are using changing key prop to re-run field level validation, and that
         * cause the component re-mounting) to not override the actual value with the default value.
         */ // @ts-ignore
            value: isDefaultValueChanged ? defaultValue : (_getCurrentValue = getCurrentValue(props.name)) !== null && _getCurrentValue !== void 0 ? _getCurrentValue : defaultValue
        },
        error: undefined,
        valid: false,
        meta: {
            dirty: false,
            dirtySinceLastSubmit: false,
            touched: false,
            valid: false,
            validating: false,
            submitting: false,
            submitFailed: false,
            error: undefined,
            submitError: undefined
        }
    }), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($6cZFk)))(_useState, 2), state = _useState2[0], setState = _useState2[1];
    var latestStateRef = $16fb50ab2f8e35e5$var$usePreviousRef(state);
    (0, $dAx5m.useEffect)(function() {
        typeof $ahJoN;
        function fieldStateToMeta() {
            var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            return {
                dirty: value.dirty || false,
                dirtySinceLastSubmit: value.dirtySinceLastSubmit || false,
                touched: value.touched || false,
                valid: value.valid || false,
                submitting: value.submitting || false,
                submitFailed: value.submitFailed || false,
                error: value.error,
                submitError: value.submitError,
                validating: !!value.validating
            };
        }
        var unregister = registerField(latestPropsRef.current.name, /**
     * Similar as for setting initial state value.
     * Additionally we are checking if the default value is a function,
     * it is used in checkbox fields, where fields with same name and
     * defaultIsChecked should create array of values. In this situation we can't
     * override the default value on re-registering, but also we don't need to change
     * the key prop to re-run validation.
     */ // @ts-ignore
        isDefaultValueChanged || // @ts-ignore
        $16fb50ab2f8e35e5$var$isFunction(latestPropsRef.current.defaultValue) ? latestPropsRef.current.defaultValue : latestStateRef.current.fieldProps.value, function(fieldState) {
            /**
       * Do not update dirtySinceLastSubmit until submission has finished.
       */ var modifiedDirtySinceLastSubmit = fieldState.submitting ? latestStateRef.current.meta.dirtySinceLastSubmit : fieldState.dirtySinceLastSubmit;
            /**
       * Do not update submitFailed until submission has finished.
       */ var modifiedSubmitFailed = fieldState.submitting ? latestStateRef.current.meta.submitFailed : fieldState.submitFailed;
            /**
       * Do not use submitError if the value has changed.
       */ var modifiedSubmitError = modifiedDirtySinceLastSubmit && latestPropsRef.current.validate ? undefined : fieldState.submitError;
            var modifiedError = modifiedSubmitError || (fieldState.touched || fieldState.dirty) && fieldState.error;
            /**
       * If there has been a submit error, then use logic in modifiedError to determine validity,
       * so we can determine when there is a submit error which we do not want to display
       * because the value has been changed.
       */ var modifiedValid = modifiedSubmitFailed ? modifiedError === undefined : fieldState.valid;
            function getTransform(eventOrValue, currentValue) {
                if (latestPropsRef.current.transform) return latestPropsRef.current.transform(eventOrValue, currentValue);
                if ($16fb50ab2f8e35e5$var$isEvent(eventOrValue)) {
                    var currentTarget = eventOrValue.currentTarget;
                    if (currentTarget.type === "checkbox") {
                        if (currentTarget.checked) return currentTarget.value || true;
                        return currentTarget.value ? undefined : false;
                    } else if (currentTarget) return currentTarget.value;
                } else return eventOrValue;
            }
            setState({
                fieldProps: {
                    onChange: function onChange(e) {
                        fieldState.change(getTransform(e, fieldState.value));
                    },
                    onBlur: fieldState.blur,
                    onFocus: fieldState.focus,
                    value: fieldState.value
                },
                error: modifiedError || undefined,
                /**
         * The following parameters are optionally typed in final-form to indicate that not all parameters need
         * to be subscribed to. We cast them as booleans (using || false), since this is what they are semantically.
         */ valid: modifiedValid || false,
                meta: fieldStateToMeta(fieldState)
            });
        }, {
            dirty: true,
            dirtySinceLastSubmit: true,
            touched: true,
            valid: true,
            submitting: true,
            submitFailed: true,
            value: true,
            error: true,
            submitError: true,
            validating: true
        }, {
            getValidator: function getValidator() {
                return function validate(value, formState, fieldState) {
                    var supplied = latestPropsRef.current.validate;
                    if (supplied && fieldState) return supplied(value, formState, fieldStateToMeta(fieldState));
                };
            }
        });
        return unregister;
    }, [
        latestPropsRef,
        latestStateRef,
        registerField,
        props.name,
        isDefaultValueChanged
    ]);
    var fieldId = (0, $dAx5m.useMemo)(// eslint-disable-next-line @repo/internal/react/disallow-unstable-values
    function() {
        return props.id ? props.id : "".concat(props.name, "-").concat((0, $h0JxK.uid)({
            id: props.name
        }));
    }, [
        props.id,
        props.name
    ]);
    var getDescribedBy = function getDescribedBy() {
        var value = "";
        if (state.error) value += "".concat(fieldId, "-error ");
        if (state.valid) value += "".concat(fieldId, "-valid ");
        return "".concat(value).concat(fieldId, "-helper");
    };
    var extendedFieldProps = $16fb50ab2f8e35e5$var$_objectSpread($16fb50ab2f8e35e5$var$_objectSpread({}, state.fieldProps), {}, {
        name: props.name,
        isDisabled: isDisabled,
        isInvalid: Boolean(state.error),
        isRequired: Boolean(props.isRequired),
        "aria-invalid": state.error ? "true" : "false",
        "aria-describedby": getDescribedBy(),
        "aria-labelledby": "".concat(fieldId, "-label"),
        id: fieldId
    });
    return (0, $jVTBW.jsx)("div", {
        css: $16fb50ab2f8e35e5$var$fieldWrapperStyles,
        "data-testid": props.testId
    }, props.label && (0, $jVTBW.jsx)((0, $hb374.Label), {
        htmlFor: fieldId,
        id: "".concat(fieldId, "-label"),
        testId: props.testId && "".concat(props.testId, "--label")
    }, props.label, props.isRequired && (0, $jVTBW.jsx)((0, $8WIPl.default), null), props.elementAfterLabel), (0, $jVTBW.jsx)((0, $aiTCW.FieldId).Provider, {
        value: fieldId
    }, props.children({
        fieldProps: extendedFieldProps,
        error: state.error,
        valid: state.valid,
        meta: state.meta
    })));
}

});
parcelRegister("ljkoo", function(module, exports) {

var $hJHh7 = parcelRequire("hJHh7");
function $f83b30d049914a74$var$_defineProperty(e, r, t) {
    return (r = $hJHh7(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
module.exports = $f83b30d049914a74$var$_defineProperty, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("hJHh7", function(module, exports) {

var $hNdt5 = parcelRequire("hNdt5");
var $ce98352ce17fdac9$var$_typeof = $hNdt5.default;

var $a2Olv = parcelRequire("a2Olv");
function $ce98352ce17fdac9$var$toPropertyKey(t) {
    var i = $a2Olv(t, "string");
    return "symbol" == $ce98352ce17fdac9$var$_typeof(i) ? i : i + "";
}
module.exports = $ce98352ce17fdac9$var$toPropertyKey, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("hNdt5", function(module, exports) {
function $cf4175c5854cbc0a$var$_typeof(o) {
    "@babel/helpers - typeof";
    return module.exports = $cf4175c5854cbc0a$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $cf4175c5854cbc0a$var$_typeof(o);
}
module.exports = $cf4175c5854cbc0a$var$_typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("a2Olv", function(module, exports) {

var $hNdt5 = parcelRequire("hNdt5");
var $750124f1fa521821$var$_typeof = $hNdt5.default;
function $750124f1fa521821$var$toPrimitive(t, r) {
    if ("object" != $750124f1fa521821$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $750124f1fa521821$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
module.exports = $750124f1fa521821$var$toPrimitive, module.exports.__esModule = true, module.exports["default"] = module.exports;

});



parcelRegister("6cZFk", function(module, exports) {

var $lhMNI = parcelRequire("lhMNI");

var $eYo3A = parcelRequire("eYo3A");

var $8dNzR = parcelRequire("8dNzR");

var $lMp2W = parcelRequire("lMp2W");
function $4853b29413a28741$var$_slicedToArray(r, e) {
    return $lhMNI(r) || $eYo3A(r, e) || $8dNzR(r, e) || $lMp2W();
}
module.exports = $4853b29413a28741$var$_slicedToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("lhMNI", function(module, exports) {
function $f7f10a54049da6d8$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
module.exports = $f7f10a54049da6d8$var$_arrayWithHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("eYo3A", function(module, exports) {
function $ae69547e3c6442a9$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
module.exports = $ae69547e3c6442a9$var$_iterableToArrayLimit, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("8dNzR", function(module, exports) {

var $7PxRK = parcelRequire("7PxRK");
function $5fc5fea8e8040ff4$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $7PxRK(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $7PxRK(r, a) : void 0;
    }
}
module.exports = $5fc5fea8e8040ff4$var$_unsupportedIterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("7PxRK", function(module, exports) {
function $5b3790dde6e9e83c$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
module.exports = $5b3790dde6e9e83c$var$_arrayLikeToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("lMp2W", function(module, exports) {
function $fdb1825eb29cb796$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
module.exports = $fdb1825eb29cb796$var$_nonIterableRest, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("aiTCW", function(module, exports) {

$parcel$export(module.exports, "FieldId", function () { return $7806bc38995b0ace$export$3c4232819458a302; });

var $dAx5m = parcelRequire("dAx5m");
var $7806bc38995b0ace$export$3c4232819458a302 = /*#__PURE__*/ (0, $dAx5m.createContext)(undefined);

});

parcelRegister("awY96", function(module, exports) {

$parcel$export(module.exports, "FormContext", function () { return $7aab8c426e6be399$export$c24727297075ec6a; });
$parcel$export(module.exports, "IsDisabledContext", function () { return $7aab8c426e6be399$export$c17cf6b332a82dbc; });
$parcel$export(module.exports, "default", function () { return $7aab8c426e6be399$export$2e2bcd8739ae039; });

var $6cZFk = parcelRequire("6cZFk");

var $dAx5m = parcelRequire("dAx5m");

var $azh4v = parcelRequire("azh4v");

var $58WqL = parcelRequire("58WqL");

var $4WAzU = parcelRequire("4WAzU");
var $7aab8c426e6be399$export$c24727297075ec6a = /*#__PURE__*/ (0, $dAx5m.createContext)({
    registerField: function registerField() {
        return function() {};
    },
    getCurrentValue: function getCurrentValue() {
        return undefined;
    },
    subscribe: function subscribe() {
        return function() {};
    }
});
var $7aab8c426e6be399$export$c17cf6b332a82dbc = /*#__PURE__*/ (0, $dAx5m.createContext)(false);
function $7aab8c426e6be399$export$2e2bcd8739ae039(props) {
    var formRef = (0, $dAx5m.useRef)(null);
    var onSubmitRef = (0, $dAx5m.useRef)(props.onSubmit);
    onSubmitRef.current = props.onSubmit;
    var _useState = (0, $dAx5m.useState)(function() {
        // Types here would break the existing API
        var finalForm = (0, $azh4v.createForm)({
            onSubmit: function onSubmit() {
                return onSubmitRef.current.apply(onSubmitRef, arguments);
            },
            destroyOnUnregister: true,
            initialValues: {},
            mutators: {
                setDefaultValue: function setDefaultValue(_ref, state) {
                    var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($6cZFk)))(_ref, 2), name = _ref2[0], defaultValue = _ref2[1];
                    if (state.formState.initialValues) {
                        var _initialValues = state.formState.initialValues;
                        var values = state.formState.values;
                        var _value = name && typeof defaultValue === "function" ? defaultValue(_initialValues[name]) : defaultValue;
                        /* eslint-disable no-param-reassign */ (0, (/*@__PURE__*/$parcel$interopDefault($4WAzU)))(_initialValues, name, _value);
                        (0, (/*@__PURE__*/$parcel$interopDefault($4WAzU)))(values, name, _value);
                    /* eslint-enable */ }
                }
            }
        });
        (0, $58WqL.default)(function() {
            return formRef.current ? Array.from(formRef.current.querySelectorAll("input")) : [];
        })(finalForm);
        return finalForm;
    }), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($6cZFk)))(_useState, 1), form = _useState2[0];
    var _useState3 = (0, $dAx5m.useState)({
        dirty: false,
        submitting: false
    }), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($6cZFk)))(_useState3, 2), state = _useState4[0], setState = _useState4[1];
    (0, $dAx5m.useEffect)(function() {
        var unsubscribe = form.subscribe(function(_ref3) {
            var dirty = _ref3.dirty, submitting = _ref3.submitting;
            setState({
                dirty: dirty,
                submitting: submitting
            });
        }, {
            dirty: true,
            submitting: true
        });
        return unsubscribe;
    }, [
        form
    ]);
    var registerField = (0, $dAx5m.useCallback)(function(name, defaultValue, subscriber, subscription, config) {
        form.pauseValidation();
        var unsubscribe = form.registerField(name, subscriber, subscription, config);
        form.mutators.setDefaultValue(name, defaultValue);
        form.resumeValidation();
        return unsubscribe;
    }, [
        form
    ]);
    var handleSubmit = function handleSubmit(e) {
        if (e) e.preventDefault();
        form.submit();
    };
    var handleReset = function handleReset(initialValues) {
        form.reset(initialValues);
    };
    var handleKeyDown = function handleKeyDown(e) {
        if (e.key === "Enter" && (e.ctrlKey || e.metaKey) && formRef.current) {
            var submitButton = formRef.current.querySelector('button:not([type]), button[type="submit"], input[type="submit"]');
            if (submitButton) submitButton.click();
            e.preventDefault();
        }
    };
    var _props$isDisabled = props.isDisabled, isDisabled = _props$isDisabled === void 0 ? false : _props$isDisabled, children = props.children;
    var dirty = state.dirty, submitting = state.submitting;
    /**
   * This method is needed in FormContext to use it on the field level
   * to check the current value of the field in case of the component re-mounting.
   */ var getCurrentValue = (0, $dAx5m.useCallback)(function(name) {
        var formState = form.getState();
        return (formState === null || formState === void 0 ? void 0 : formState.values[name]) || undefined;
    }, [
        form
    ]);
    var FormContextValue = (0, $dAx5m.useMemo)(function() {
        return {
            registerField: registerField,
            getCurrentValue: getCurrentValue,
            subscribe: form.subscribe
        };
    }, [
        registerField,
        getCurrentValue,
        form.subscribe
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement($7aab8c426e6be399$export$c24727297075ec6a.Provider, {
        value: FormContextValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement($7aab8c426e6be399$export$c17cf6b332a82dbc.Provider, {
        value: isDisabled
    }, children({
        formProps: {
            onSubmit: handleSubmit,
            ref: formRef,
            onKeyDown: handleKeyDown
        },
        dirty: dirty,
        reset: handleReset,
        submitting: submitting,
        disabled: isDisabled,
        getState: function getState() {
            return form.getState();
        },
        getValues: function getValues() {
            return form.getState().values;
        },
        // TODO: deprecate
        setFieldValue: form.change
    })));
}

});
parcelRegister("azh4v", function(module, exports) {

$parcel$export(module.exports, "getIn", function () { return $7b1a6a5c74dca0b1$export$c52e5867d5879e24; });
$parcel$export(module.exports, "createForm", function () { return $7b1a6a5c74dca0b1$export$f681a8129d2e9d28; });

var $qmYJK = parcelRequire("qmYJK");

var $8NIwR = parcelRequire("8NIwR");
//      
var $7b1a6a5c74dca0b1$var$charCodeOfDot = ".".charCodeAt(0);
var $7b1a6a5c74dca0b1$var$reEscapeChar = /\\(\\)?/g;
var $7b1a6a5c74dca0b1$var$rePropName = RegExp(// Match anything that isn't a dot or bracket.
"[^.[\\]]+|\\[(?:([^\"'][^[]*)|([\"'])((?:(?!\\2)[^\\\\]|\\\\.)*?)\\2)\\]|(?=(?:\\.|\\[\\])(?:\\.|\\[\\]|$))", "g");
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var $7b1a6a5c74dca0b1$var$stringToPath = function stringToPath(string) {
    var result = [];
    if (string.charCodeAt(0) === $7b1a6a5c74dca0b1$var$charCodeOfDot) result.push("");
    string.replace($7b1a6a5c74dca0b1$var$rePropName, function(match, expression, quote, subString) {
        var key = match;
        if (quote) key = subString.replace($7b1a6a5c74dca0b1$var$reEscapeChar, "$1");
        else if (expression) key = expression.trim();
        result.push(key);
    });
    return result;
};
var $7b1a6a5c74dca0b1$var$keysCache = {};
var $7b1a6a5c74dca0b1$var$keysRegex = /[.[\]]+/;
var $7b1a6a5c74dca0b1$var$toPath = function toPath(key) {
    if (key === null || key === undefined || !key.length) return [];
    if (typeof key !== "string") throw new Error("toPath() expects a string");
    if ($7b1a6a5c74dca0b1$var$keysCache[key] == null) {
        /**
     * The following patch fixes issue 456, introduced since v4.20.3:
     *
     * Before v4.20.3, i.e. in v4.20.2, a `key` like 'choices[]' would map to ['choices']
     * (e.g. an array of choices used where 'choices[]' is name attribute of an input of type checkbox).
     *
     * Since v4.20.3, a `key` like 'choices[]' would map to ['choices', ''] which is wrong and breaks
     * this kind of inputs e.g. in React.
     *
     * v4.20.3 introduced an unwanted breaking change, this patch fixes it, see the issue at the link below.
     *
     * @see https://github.com/final-form/final-form/issues/456
     */ if (key.endsWith("[]")) // v4.20.2 (a `key` like 'choices[]' should map to ['choices'], which is fine).
        $7b1a6a5c74dca0b1$var$keysCache[key] = key.split($7b1a6a5c74dca0b1$var$keysRegex).filter(Boolean);
        else // v4.20.3 (a `key` like 'choices[]' maps to ['choices', ''], which breaks applications relying on inputs like `<input type="checkbox" name="choices[]" />`).
        $7b1a6a5c74dca0b1$var$keysCache[key] = $7b1a6a5c74dca0b1$var$stringToPath(key);
    }
    return $7b1a6a5c74dca0b1$var$keysCache[key];
};
//      
var $7b1a6a5c74dca0b1$export$c52e5867d5879e24 = function getIn(state, complexKey) {
    // Intentionally using iteration rather than recursion
    var path = $7b1a6a5c74dca0b1$var$toPath(complexKey);
    var current = state;
    for(var i = 0; i < path.length; i++){
        var key = path[i];
        if (current === undefined || current === null || typeof current !== "object" || Array.isArray(current) && isNaN(key)) return undefined;
        current = current[key];
    }
    return current;
};
function $7b1a6a5c74dca0b1$var$_toPropertyKey(arg) {
    var key = $7b1a6a5c74dca0b1$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $7b1a6a5c74dca0b1$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $7b1a6a5c74dca0b1$var$setInRecursor = function setInRecursor(current, index, path, value1, destroyArrays) {
    if (index >= path.length) // end of recursion
    return value1;
    var key = path[index];
    // determine type of key
    if (isNaN(key)) {
        var _extends2;
        // object set
        if (current === undefined || current === null) {
            var _ref;
            // recurse
            var _result = setInRecursor(undefined, index + 1, path, value1, destroyArrays);
            // delete or create an object
            return _result === undefined ? undefined : (_ref = {}, _ref[key] = _result, _ref);
        }
        if (Array.isArray(current)) throw new Error("Cannot set a non-numeric property on an array");
        // current exists, so make a copy of all its values, and add/update the new one
        var _result2 = setInRecursor(current[key], index + 1, path, value1, destroyArrays);
        if (_result2 === undefined) {
            var numKeys = Object.keys(current).length;
            if (current[key] === undefined && numKeys === 0) // object was already empty
            return undefined;
            if (current[key] !== undefined && numKeys <= 1) {
                // only key we had was the one we are deleting
                if (!isNaN(path[index - 1]) && !destroyArrays) // we are in an array, so return an empty object
                return {};
                else return undefined;
            }
            current[key];
            var _final = (0, $8NIwR.default)(current, [
                key
            ].map($7b1a6a5c74dca0b1$var$_toPropertyKey));
            return _final;
        }
        // set result in key
        return (0, $qmYJK.default)({}, current, (_extends2 = {}, _extends2[key] = _result2, _extends2));
    }
    // array set
    var numericKey = Number(key);
    if (current === undefined || current === null) {
        // recurse
        var _result3 = setInRecursor(undefined, index + 1, path, value1, destroyArrays);
        // if nothing returned, delete it
        if (_result3 === undefined) return undefined;
        // create an array
        var _array = [];
        _array[numericKey] = _result3;
        return _array;
    }
    if (!Array.isArray(current)) throw new Error("Cannot set a numeric property on an object");
    // recurse
    var existingValue = current[numericKey];
    var result = setInRecursor(existingValue, index + 1, path, value1, destroyArrays);
    // current exists, so make a copy of all its values, and add/update the new one
    var array = [].concat(current);
    if (destroyArrays && result === undefined) {
        array.splice(numericKey, 1);
        if (array.length === 0) return undefined;
    } else array[numericKey] = result;
    return array;
};
var $7b1a6a5c74dca0b1$export$e6bdf135a54e021b = function setIn(state, key, value1, destroyArrays) {
    if (destroyArrays === void 0) destroyArrays = false;
    if (state === undefined || state === null) throw new Error("Cannot call setIn() with " + String(state) + " state");
    if (key === undefined || key === null) throw new Error("Cannot call setIn() with " + String(key) + " key");
    // Recursive function needs to accept and return State, but public API should
    // only deal with Objects
    return $7b1a6a5c74dca0b1$var$setInRecursor(state, 0, $7b1a6a5c74dca0b1$var$toPath(key), value1, destroyArrays);
};
var $7b1a6a5c74dca0b1$export$97cd7fc25dd32915 = "FINAL_FORM/form-error";
var $7b1a6a5c74dca0b1$export$735bebc8ffabf28a = "FINAL_FORM/array-error";
//      
/**
 * Converts internal field state to published field state
 */ function $7b1a6a5c74dca0b1$var$publishFieldState(formState, field) {
    var errors = formState.errors, initialValues = formState.initialValues, lastSubmittedValues = formState.lastSubmittedValues, submitErrors = formState.submitErrors, submitFailed = formState.submitFailed, submitSucceeded = formState.submitSucceeded, submitting = formState.submitting, values = formState.values;
    var active = field.active, blur = field.blur, change = field.change, data = field.data, focus = field.focus, modified = field.modified, modifiedSinceLastSubmit = field.modifiedSinceLastSubmit, name = field.name, touched = field.touched, validating = field.validating, visited = field.visited;
    var value1 = $7b1a6a5c74dca0b1$export$c52e5867d5879e24(values, name);
    var error = $7b1a6a5c74dca0b1$export$c52e5867d5879e24(errors, name);
    if (error && error[$7b1a6a5c74dca0b1$export$735bebc8ffabf28a]) error = error[$7b1a6a5c74dca0b1$export$735bebc8ffabf28a];
    var submitError = submitErrors && $7b1a6a5c74dca0b1$export$c52e5867d5879e24(submitErrors, name);
    var initial = initialValues && $7b1a6a5c74dca0b1$export$c52e5867d5879e24(initialValues, name);
    var pristine = field.isEqual(initial, value1);
    var dirtySinceLastSubmit = !!(lastSubmittedValues && !field.isEqual($7b1a6a5c74dca0b1$export$c52e5867d5879e24(lastSubmittedValues, name), value1));
    var valid = !error && !submitError;
    return {
        active: active,
        blur: blur,
        change: change,
        data: data,
        dirty: !pristine,
        dirtySinceLastSubmit: dirtySinceLastSubmit,
        error: error,
        focus: focus,
        initial: initial,
        invalid: !valid,
        length: Array.isArray(value1) ? value1.length : undefined,
        modified: modified,
        modifiedSinceLastSubmit: modifiedSinceLastSubmit,
        name: name,
        pristine: pristine,
        submitError: submitError,
        submitFailed: submitFailed,
        submitSucceeded: submitSucceeded,
        submitting: submitting,
        touched: touched,
        valid: valid,
        value: value1,
        visited: visited,
        validating: validating
    };
}
//      
var $7b1a6a5c74dca0b1$export$41e855cb628c1b55 = [
    "active",
    "data",
    "dirty",
    "dirtySinceLastSubmit",
    "error",
    "initial",
    "invalid",
    "length",
    "modified",
    "modifiedSinceLastSubmit",
    "pristine",
    "submitError",
    "submitFailed",
    "submitSucceeded",
    "submitting",
    "touched",
    "valid",
    "value",
    "visited",
    "validating"
];
//      
var $7b1a6a5c74dca0b1$var$shallowEqual = function shallowEqual(a, b) {
    if (a === b) return true;
    if (typeof a !== "object" || !a || typeof b !== "object" || !b) return false;
    var keysA = Object.keys(a);
    var keysB = Object.keys(b);
    if (keysA.length !== keysB.length) return false;
    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(b);
    for(var idx = 0; idx < keysA.length; idx++){
        var key = keysA[idx];
        if (!bHasOwnProperty(key) || a[key] !== b[key]) return false;
    }
    return true;
};
//      
function $7b1a6a5c74dca0b1$var$subscriptionFilter(dest, src, previous, subscription, keys, shallowEqualKeys) {
    var different = false;
    keys.forEach(function(key) {
        if (subscription[key]) {
            dest[key] = src[key];
            if (!previous || (~shallowEqualKeys.indexOf(key) ? !$7b1a6a5c74dca0b1$var$shallowEqual(src[key], previous[key]) : src[key] !== previous[key])) different = true;
        }
    });
    return different;
}
//      
var $7b1a6a5c74dca0b1$var$shallowEqualKeys$1 = [
    "data"
];
/**
 * Filters items in a FieldState based on a FieldSubscription
 */ var $7b1a6a5c74dca0b1$var$filterFieldState = function filterFieldState(state, previousState, subscription, force) {
    var result = {
        blur: state.blur,
        change: state.change,
        focus: state.focus,
        name: state.name
    };
    var different = $7b1a6a5c74dca0b1$var$subscriptionFilter(result, state, previousState, subscription, $7b1a6a5c74dca0b1$export$41e855cb628c1b55, $7b1a6a5c74dca0b1$var$shallowEqualKeys$1) || !previousState;
    return different || force ? result : undefined;
};
//      
var $7b1a6a5c74dca0b1$export$f1ff97b9d1c7a3c3 = [
    "active",
    "dirty",
    "dirtyFields",
    "dirtyFieldsSinceLastSubmit",
    "dirtySinceLastSubmit",
    "error",
    "errors",
    "hasSubmitErrors",
    "hasValidationErrors",
    "initialValues",
    "invalid",
    "modified",
    "modifiedSinceLastSubmit",
    "pristine",
    "submitting",
    "submitError",
    "submitErrors",
    "submitFailed",
    "submitSucceeded",
    "touched",
    "valid",
    "validating",
    "values",
    "visited"
];
//      
var $7b1a6a5c74dca0b1$var$shallowEqualKeys = [
    "touched",
    "visited"
];
/**
 * Filters items in a FormState based on a FormSubscription
 */ function $7b1a6a5c74dca0b1$var$filterFormState(state, previousState, subscription, force) {
    var result = {};
    var different = $7b1a6a5c74dca0b1$var$subscriptionFilter(result, state, previousState, subscription, $7b1a6a5c74dca0b1$export$f1ff97b9d1c7a3c3, $7b1a6a5c74dca0b1$var$shallowEqualKeys) || !previousState;
    return different || force ? result : undefined;
}
//      
var $7b1a6a5c74dca0b1$var$memoize = function memoize(fn) {
    var lastArgs;
    var lastResult;
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        if (!lastArgs || args.length !== lastArgs.length || args.some(function(arg, index) {
            return !$7b1a6a5c74dca0b1$var$shallowEqual(lastArgs[index], arg);
        })) {
            lastArgs = args;
            lastResult = fn.apply(void 0, args);
        }
        return lastResult;
    };
};
var $7b1a6a5c74dca0b1$var$isPromise = function(obj) {
    return !!obj && (typeof obj === "object" || typeof obj === "function") && typeof obj.then === "function";
};
var $7b1a6a5c74dca0b1$export$83d89fbfd8236492 = "4.20.10";
var $7b1a6a5c74dca0b1$export$480bc304a47a3b09 = [
    "debug",
    "initialValues",
    "keepDirtyOnReinitialize",
    "mutators",
    "onSubmit",
    "validate",
    "validateOnBlur"
];
var $7b1a6a5c74dca0b1$var$tripleEquals = function tripleEquals(a, b) {
    return a === b;
};
var $7b1a6a5c74dca0b1$var$hasAnyError = function hasAnyError(errors) {
    return Object.keys(errors).some(function(key) {
        var value1 = errors[key];
        if (value1 && typeof value1 === "object" && !(value1 instanceof Error)) return hasAnyError(value1);
        return typeof value1 !== "undefined";
    });
};
function $7b1a6a5c74dca0b1$var$convertToExternalFormState(_ref) {
    var active = _ref.active, dirtySinceLastSubmit = _ref.dirtySinceLastSubmit, modifiedSinceLastSubmit = _ref.modifiedSinceLastSubmit, error = _ref.error, errors = _ref.errors, initialValues = _ref.initialValues, pristine = _ref.pristine, submitting = _ref.submitting, submitFailed = _ref.submitFailed, submitSucceeded = _ref.submitSucceeded, submitError = _ref.submitError, submitErrors = _ref.submitErrors, valid = _ref.valid, validating = _ref.validating, values = _ref.values;
    return {
        active: active,
        dirty: !pristine,
        dirtySinceLastSubmit: dirtySinceLastSubmit,
        modifiedSinceLastSubmit: modifiedSinceLastSubmit,
        error: error,
        errors: errors,
        hasSubmitErrors: !!(submitError || submitErrors && $7b1a6a5c74dca0b1$var$hasAnyError(submitErrors)),
        hasValidationErrors: !!(error || $7b1a6a5c74dca0b1$var$hasAnyError(errors)),
        invalid: !valid,
        initialValues: initialValues,
        pristine: pristine,
        submitting: submitting,
        submitFailed: submitFailed,
        submitSucceeded: submitSucceeded,
        submitError: submitError,
        submitErrors: submitErrors,
        valid: valid,
        validating: validating > 0,
        values: values
    };
}
function $7b1a6a5c74dca0b1$var$notifySubscriber(subscriber, subscription, state, lastState, filter, force) {
    var notification = filter(state, lastState, subscription, force);
    if (notification) {
        subscriber(notification);
        return true;
    }
    return false;
}
function $7b1a6a5c74dca0b1$var$notify(_ref2, state, lastState, filter, force) {
    var entries = _ref2.entries;
    Object.keys(entries).forEach(function(key) {
        var entry = entries[Number(key)];
        // istanbul ignore next
        if (entry) {
            var subscription = entry.subscription, subscriber = entry.subscriber, notified = entry.notified;
            if ($7b1a6a5c74dca0b1$var$notifySubscriber(subscriber, subscription, state, lastState, filter, force || !notified)) entry.notified = true;
        }
    });
}
function $7b1a6a5c74dca0b1$export$f681a8129d2e9d28(config) {
    if (!config) throw new Error("No config specified");
    var debug = config.debug, destroyOnUnregister = config.destroyOnUnregister, keepDirtyOnReinitialize = config.keepDirtyOnReinitialize, initialValues = config.initialValues, mutators = config.mutators, onSubmit = config.onSubmit, validate = config.validate, validateOnBlur = config.validateOnBlur;
    if (!onSubmit) throw new Error("No onSubmit function specified");
    var state = {
        subscribers: {
            index: 0,
            entries: {}
        },
        fieldSubscribers: {},
        fields: {},
        formState: {
            asyncErrors: {},
            dirtySinceLastSubmit: false,
            modifiedSinceLastSubmit: false,
            errors: {},
            initialValues: initialValues && (0, $qmYJK.default)({}, initialValues),
            invalid: false,
            pristine: true,
            submitting: false,
            submitFailed: false,
            submitSucceeded: false,
            resetWhileSubmitting: false,
            valid: true,
            validating: 0,
            values: initialValues ? (0, $qmYJK.default)({}, initialValues) : {}
        },
        lastFormState: undefined
    };
    var inBatch = 0;
    var validationPaused = false;
    var validationBlocked = false;
    var preventNotificationWhileValidationPaused = false;
    var nextAsyncValidationKey = 0;
    var asyncValidationPromises = {};
    var clearAsyncValidationPromise = function clearAsyncValidationPromise(key) {
        return function(result) {
            delete asyncValidationPromises[key];
            return result;
        };
    };
    var changeValue = function changeValue(state, name, mutate) {
        var before = $7b1a6a5c74dca0b1$export$c52e5867d5879e24(state.formState.values, name);
        var after = mutate(before);
        state.formState.values = $7b1a6a5c74dca0b1$export$e6bdf135a54e021b(state.formState.values, name, after) || {};
    };
    var renameField = function renameField(state, from, to) {
        if (state.fields[from]) {
            var _extends2, _extends3;
            state.fields = (0, $qmYJK.default)({}, state.fields, (_extends2 = {}, _extends2[to] = (0, $qmYJK.default)({}, state.fields[from], {
                name: to,
                // rebind event handlers
                blur: function blur() {
                    return api.blur(to);
                },
                change: function change(value1) {
                    return api.change(to, value1);
                },
                focus: function focus() {
                    return api.focus(to);
                },
                lastFieldState: undefined
            }), _extends2));
            delete state.fields[from];
            state.fieldSubscribers = (0, $qmYJK.default)({}, state.fieldSubscribers, (_extends3 = {}, _extends3[to] = state.fieldSubscribers[from], _extends3));
            delete state.fieldSubscribers[from];
            var value1 = $7b1a6a5c74dca0b1$export$c52e5867d5879e24(state.formState.values, from);
            state.formState.values = $7b1a6a5c74dca0b1$export$e6bdf135a54e021b(state.formState.values, from, undefined) || {};
            state.formState.values = $7b1a6a5c74dca0b1$export$e6bdf135a54e021b(state.formState.values, to, value1);
            delete state.lastFormState;
        }
    };
    // bind state to mutators
    var getMutatorApi = function getMutatorApi(key) {
        return function() {
            // istanbul ignore next
            if (mutators) {
                // ^^ causes branch coverage warning, but needed to appease the Flow gods
                var mutatableState = {
                    formState: state.formState,
                    fields: state.fields,
                    fieldSubscribers: state.fieldSubscribers,
                    lastFormState: state.lastFormState
                };
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                var returnValue = mutators[key](args, mutatableState, {
                    changeValue: changeValue,
                    getIn: $7b1a6a5c74dca0b1$export$c52e5867d5879e24,
                    renameField: renameField,
                    resetFieldState: api.resetFieldState,
                    setIn: $7b1a6a5c74dca0b1$export$e6bdf135a54e021b,
                    shallowEqual: $7b1a6a5c74dca0b1$var$shallowEqual
                });
                state.formState = mutatableState.formState;
                state.fields = mutatableState.fields;
                state.fieldSubscribers = mutatableState.fieldSubscribers;
                state.lastFormState = mutatableState.lastFormState;
                runValidation(undefined, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
                return returnValue;
            }
        };
    };
    var mutatorsApi = mutators ? Object.keys(mutators).reduce(function(result, key) {
        result[key] = getMutatorApi(key);
        return result;
    }, {}) : {};
    var runRecordLevelValidation = function runRecordLevelValidation(setErrors) {
        var promises = [];
        if (validate) {
            var errorsOrPromise = validate((0, $qmYJK.default)({}, state.formState.values)); // clone to avoid writing
            if ($7b1a6a5c74dca0b1$var$isPromise(errorsOrPromise)) promises.push(errorsOrPromise.then(function(errors) {
                return setErrors(errors, true);
            }));
            else setErrors(errorsOrPromise, false);
        }
        return promises;
    };
    var getValidators = function getValidators(field) {
        return Object.keys(field.validators).reduce(function(result, index) {
            var validator = field.validators[Number(index)]();
            if (validator) result.push(validator);
            return result;
        }, []);
    };
    var runFieldLevelValidation = function runFieldLevelValidation(field, setError) {
        var promises = [];
        var validators = getValidators(field);
        if (validators.length) {
            var error;
            validators.forEach(function(validator) {
                var errorOrPromise = validator($7b1a6a5c74dca0b1$export$c52e5867d5879e24(state.formState.values, field.name), state.formState.values, validator.length === 0 || validator.length === 3 ? $7b1a6a5c74dca0b1$var$publishFieldState(state.formState, state.fields[field.name]) : undefined);
                if (errorOrPromise && $7b1a6a5c74dca0b1$var$isPromise(errorOrPromise)) {
                    field.validating = true;
                    var promise = errorOrPromise.then(function(error) {
                        if (state.fields[field.name]) {
                            state.fields[field.name].validating = false;
                            setError(error);
                        }
                    }); // errors must be resolved, not rejected
                    promises.push(promise);
                } else if (!error) // first registered validator wins
                error = errorOrPromise;
            });
            setError(error);
        }
        return promises;
    };
    var runValidation = function runValidation(fieldChanged, callback) {
        if (validationPaused) {
            validationBlocked = true;
            callback();
            return;
        }
        var fields = state.fields, formState = state.formState;
        var safeFields = (0, $qmYJK.default)({}, fields);
        var fieldKeys = Object.keys(safeFields);
        if (!validate && !fieldKeys.some(function(key) {
            return getValidators(safeFields[key]).length;
        })) {
            callback();
            return; // no validation rules
        }
        // pare down field keys to actually validate
        var limitedFieldLevelValidation = false;
        if (fieldChanged) {
            var changedField = safeFields[fieldChanged];
            if (changedField) {
                var validateFields = changedField.validateFields;
                if (validateFields) {
                    limitedFieldLevelValidation = true;
                    fieldKeys = validateFields.length ? validateFields.concat(fieldChanged) : [
                        fieldChanged
                    ];
                }
            }
        }
        var recordLevelErrors = {};
        var asyncRecordLevelErrors = {};
        var fieldLevelErrors = {};
        var promises = [].concat(runRecordLevelValidation(function(errors, wasAsync) {
            if (wasAsync) asyncRecordLevelErrors = errors || {};
            else recordLevelErrors = errors || {};
        }), fieldKeys.reduce(function(result, name) {
            return result.concat(runFieldLevelValidation(fields[name], function(error) {
                fieldLevelErrors[name] = error;
            }));
        }, []));
        var hasAsyncValidations = promises.length > 0;
        var asyncValidationPromiseKey = ++nextAsyncValidationKey;
        var promise = Promise.all(promises).then(clearAsyncValidationPromise(asyncValidationPromiseKey));
        // backwards-compat: add promise to submit-blocking promises iff there are any promises to await
        if (hasAsyncValidations) asyncValidationPromises[asyncValidationPromiseKey] = promise;
        var processErrors = function processErrors(afterAsync) {
            var merged = (0, $qmYJK.default)({}, limitedFieldLevelValidation ? formState.errors : {}, recordLevelErrors, afterAsync ? asyncRecordLevelErrors // new async errors
             : formState.asyncErrors);
            var forEachError = function forEachError(fn) {
                fieldKeys.forEach(function(name) {
                    if (fields[name]) {
                        // make sure field is still registered
                        // field-level errors take precedent over record-level errors
                        var recordLevelError = $7b1a6a5c74dca0b1$export$c52e5867d5879e24(recordLevelErrors, name);
                        var errorFromParent = $7b1a6a5c74dca0b1$export$c52e5867d5879e24(merged, name);
                        var hasFieldLevelValidation = getValidators(safeFields[name]).length;
                        var fieldLevelError = fieldLevelErrors[name];
                        fn(name, hasFieldLevelValidation && fieldLevelError || validate && recordLevelError || (!recordLevelError && !limitedFieldLevelValidation ? errorFromParent : undefined));
                    }
                });
            };
            forEachError(function(name, error) {
                merged = $7b1a6a5c74dca0b1$export$e6bdf135a54e021b(merged, name, error) || {};
            });
            forEachError(function(name, error) {
                if (error && error[$7b1a6a5c74dca0b1$export$735bebc8ffabf28a]) {
                    var existing = $7b1a6a5c74dca0b1$export$c52e5867d5879e24(merged, name);
                    var copy = [].concat(existing);
                    copy[$7b1a6a5c74dca0b1$export$735bebc8ffabf28a] = error[$7b1a6a5c74dca0b1$export$735bebc8ffabf28a];
                    merged = $7b1a6a5c74dca0b1$export$e6bdf135a54e021b(merged, name, copy);
                }
            });
            if (!$7b1a6a5c74dca0b1$var$shallowEqual(formState.errors, merged)) formState.errors = merged;
            if (afterAsync) formState.asyncErrors = asyncRecordLevelErrors;
            formState.error = recordLevelErrors[$7b1a6a5c74dca0b1$export$97cd7fc25dd32915];
        };
        if (hasAsyncValidations) {
            // async validations are running, ensure validating is true before notifying
            state.formState.validating++;
            callback();
        }
        // process sync errors
        processErrors(false);
        // sync errors have been set. notify listeners while we wait for others
        callback();
        if (hasAsyncValidations) {
            var afterPromise = function afterPromise() {
                state.formState.validating--;
                callback();
                // field async validation may affect formState validating
                // so force notifyFormListeners if validating is still 0 after callback finished
                // and lastFormState validating is true
                if (state.formState.validating === 0 && state.lastFormState.validating) notifyFormListeners();
            };
            promise.then(function() {
                if (nextAsyncValidationKey > asyncValidationPromiseKey) // if this async validator has been superseded by another, ignore its results
                return;
                processErrors(true);
            }).then(afterPromise, afterPromise);
        }
    };
    var notifyFieldListeners = function notifyFieldListeners(name) {
        if (inBatch) return;
        var fields = state.fields, fieldSubscribers = state.fieldSubscribers, formState = state.formState;
        var safeFields = (0, $qmYJK.default)({}, fields);
        var notifyField = function notifyField(name) {
            var field = safeFields[name];
            var fieldState = $7b1a6a5c74dca0b1$var$publishFieldState(formState, field);
            var lastFieldState = field.lastFieldState;
            field.lastFieldState = fieldState;
            var fieldSubscriber = fieldSubscribers[name];
            if (fieldSubscriber) $7b1a6a5c74dca0b1$var$notify(fieldSubscriber, fieldState, lastFieldState, $7b1a6a5c74dca0b1$var$filterFieldState, lastFieldState === undefined);
        };
        if (name) notifyField(name);
        else Object.keys(safeFields).forEach(notifyField);
    };
    var markAllFieldsTouched = function markAllFieldsTouched() {
        Object.keys(state.fields).forEach(function(key) {
            state.fields[key].touched = true;
        });
    };
    var hasSyncErrors = function hasSyncErrors() {
        return !!(state.formState.error || $7b1a6a5c74dca0b1$var$hasAnyError(state.formState.errors));
    };
    var calculateNextFormState = function calculateNextFormState() {
        var fields = state.fields, formState = state.formState, lastFormState = state.lastFormState;
        var safeFields = (0, $qmYJK.default)({}, fields);
        var safeFieldKeys = Object.keys(safeFields);
        // calculate dirty/pristine
        var foundDirty = false;
        var dirtyFields = safeFieldKeys.reduce(function(result, key) {
            var dirty = !safeFields[key].isEqual($7b1a6a5c74dca0b1$export$c52e5867d5879e24(formState.values, key), $7b1a6a5c74dca0b1$export$c52e5867d5879e24(formState.initialValues || {}, key));
            if (dirty) {
                foundDirty = true;
                result[key] = true;
            }
            return result;
        }, {});
        var dirtyFieldsSinceLastSubmit = safeFieldKeys.reduce(function(result, key) {
            // istanbul ignore next
            var nonNullLastSubmittedValues = formState.lastSubmittedValues || {}; // || {} is for flow, but causes branch coverage complaint
            if (!safeFields[key].isEqual($7b1a6a5c74dca0b1$export$c52e5867d5879e24(formState.values, key), $7b1a6a5c74dca0b1$export$c52e5867d5879e24(nonNullLastSubmittedValues, key))) result[key] = true;
            return result;
        }, {});
        formState.pristine = !foundDirty;
        formState.dirtySinceLastSubmit = !!(formState.lastSubmittedValues && Object.values(dirtyFieldsSinceLastSubmit).some(function(value1) {
            return value1;
        }));
        formState.modifiedSinceLastSubmit = !!(formState.lastSubmittedValues && // Object.values would treat values as mixed (facebook/flow#2221)
        Object.keys(safeFields).some(function(value1) {
            return safeFields[value1].modifiedSinceLastSubmit;
        }));
        formState.valid = !formState.error && !formState.submitError && !$7b1a6a5c74dca0b1$var$hasAnyError(formState.errors) && !(formState.submitErrors && $7b1a6a5c74dca0b1$var$hasAnyError(formState.submitErrors));
        var nextFormState = $7b1a6a5c74dca0b1$var$convertToExternalFormState(formState);
        var _safeFieldKeys$reduce = safeFieldKeys.reduce(function(result, key) {
            result.modified[key] = safeFields[key].modified;
            result.touched[key] = safeFields[key].touched;
            result.visited[key] = safeFields[key].visited;
            return result;
        }, {
            modified: {},
            touched: {},
            visited: {}
        }), modified = _safeFieldKeys$reduce.modified, touched = _safeFieldKeys$reduce.touched, visited = _safeFieldKeys$reduce.visited;
        nextFormState.dirtyFields = lastFormState && $7b1a6a5c74dca0b1$var$shallowEqual(lastFormState.dirtyFields, dirtyFields) ? lastFormState.dirtyFields : dirtyFields;
        nextFormState.dirtyFieldsSinceLastSubmit = lastFormState && $7b1a6a5c74dca0b1$var$shallowEqual(lastFormState.dirtyFieldsSinceLastSubmit, dirtyFieldsSinceLastSubmit) ? lastFormState.dirtyFieldsSinceLastSubmit : dirtyFieldsSinceLastSubmit;
        nextFormState.modified = lastFormState && $7b1a6a5c74dca0b1$var$shallowEqual(lastFormState.modified, modified) ? lastFormState.modified : modified;
        nextFormState.touched = lastFormState && $7b1a6a5c74dca0b1$var$shallowEqual(lastFormState.touched, touched) ? lastFormState.touched : touched;
        nextFormState.visited = lastFormState && $7b1a6a5c74dca0b1$var$shallowEqual(lastFormState.visited, visited) ? lastFormState.visited : visited;
        return lastFormState && $7b1a6a5c74dca0b1$var$shallowEqual(lastFormState, nextFormState) ? lastFormState : nextFormState;
    };
    var callDebug = function callDebug() {
        return debug && true && debug(calculateNextFormState(), Object.keys(state.fields).reduce(function(result, key) {
            result[key] = state.fields[key];
            return result;
        }, {}));
    };
    var notifying = false;
    var scheduleNotification = false;
    var notifyFormListeners = function notifyFormListeners() {
        if (notifying) scheduleNotification = true;
        else {
            notifying = true;
            callDebug();
            if (!inBatch && !(validationPaused && preventNotificationWhileValidationPaused)) {
                var lastFormState = state.lastFormState;
                var nextFormState = calculateNextFormState();
                if (nextFormState !== lastFormState) {
                    state.lastFormState = nextFormState;
                    $7b1a6a5c74dca0b1$var$notify(state.subscribers, nextFormState, lastFormState, $7b1a6a5c74dca0b1$var$filterFormState);
                }
            }
            notifying = false;
            if (scheduleNotification) {
                scheduleNotification = false;
                notifyFormListeners();
            }
        }
    };
    var beforeSubmit = function beforeSubmit() {
        return Object.keys(state.fields).some(function(name) {
            return state.fields[name].beforeSubmit && state.fields[name].beforeSubmit() === false;
        });
    };
    var afterSubmit = function afterSubmit() {
        return Object.keys(state.fields).forEach(function(name) {
            return state.fields[name].afterSubmit && state.fields[name].afterSubmit();
        });
    };
    var resetModifiedAfterSubmit = function resetModifiedAfterSubmit() {
        return Object.keys(state.fields).forEach(function(key) {
            return state.fields[key].modifiedSinceLastSubmit = false;
        });
    };
    // generate initial errors
    runValidation(undefined, function() {
        notifyFormListeners();
    });
    var api = {
        batch: function batch(fn) {
            inBatch++;
            fn();
            inBatch--;
            notifyFieldListeners();
            notifyFormListeners();
        },
        blur: function blur(name) {
            var fields = state.fields, formState = state.formState;
            var previous = fields[name];
            if (previous) {
                // can only blur registered fields
                delete formState.active;
                fields[name] = (0, $qmYJK.default)({}, previous, {
                    active: false,
                    touched: true
                });
                if (validateOnBlur) runValidation(name, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
                else {
                    notifyFieldListeners();
                    notifyFormListeners();
                }
            }
        },
        change: function change(name, value1) {
            var fields = state.fields, formState = state.formState;
            if ($7b1a6a5c74dca0b1$export$c52e5867d5879e24(formState.values, name) !== value1) {
                changeValue(state, name, function() {
                    return value1;
                });
                var previous = fields[name];
                if (previous) // only track modified for registered fields
                fields[name] = (0, $qmYJK.default)({}, previous, {
                    modified: true,
                    modifiedSinceLastSubmit: !!formState.lastSubmittedValues
                });
                if (validateOnBlur) {
                    notifyFieldListeners();
                    notifyFormListeners();
                } else runValidation(name, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
            }
        },
        get destroyOnUnregister () {
            return !!destroyOnUnregister;
        },
        set destroyOnUnregister (value){
            destroyOnUnregister = value;
        },
        focus: function focus(name) {
            var field = state.fields[name];
            if (field && !field.active) {
                state.formState.active = name;
                field.active = true;
                field.visited = true;
                notifyFieldListeners();
                notifyFormListeners();
            }
        },
        mutators: mutatorsApi,
        getFieldState: function getFieldState(name) {
            var field = state.fields[name];
            return field && field.lastFieldState;
        },
        getRegisteredFields: function getRegisteredFields() {
            return Object.keys(state.fields);
        },
        getState: function getState() {
            return calculateNextFormState();
        },
        initialize: function initialize(data) {
            var fields = state.fields, formState = state.formState;
            var safeFields = (0, $qmYJK.default)({}, fields);
            var values = typeof data === "function" ? data(formState.values) : data;
            if (!keepDirtyOnReinitialize) formState.values = values;
            /**
       * Hello, inquisitive code reader! Thanks for taking the time to dig in!
       *
       * The following code is the way it is to allow for non-registered deep
       * field values to be set via initialize()
       */ // save dirty values
            var savedDirtyValues = keepDirtyOnReinitialize ? Object.keys(safeFields).reduce(function(result, key) {
                var field = safeFields[key];
                var pristine = field.isEqual($7b1a6a5c74dca0b1$export$c52e5867d5879e24(formState.values, key), $7b1a6a5c74dca0b1$export$c52e5867d5879e24(formState.initialValues || {}, key));
                if (!pristine) result[key] = $7b1a6a5c74dca0b1$export$c52e5867d5879e24(formState.values, key);
                return result;
            }, {}) : {};
            // update initalValues and values
            formState.initialValues = values;
            formState.values = values;
            // restore the dirty values
            Object.keys(savedDirtyValues).forEach(function(key) {
                formState.values = $7b1a6a5c74dca0b1$export$e6bdf135a54e021b(formState.values, key, savedDirtyValues[key]) || {};
            });
            runValidation(undefined, function() {
                notifyFieldListeners();
                notifyFormListeners();
            });
        },
        isValidationPaused: function isValidationPaused() {
            return validationPaused;
        },
        pauseValidation: function pauseValidation(preventNotification) {
            if (preventNotification === void 0) preventNotification = true;
            validationPaused = true;
            preventNotificationWhileValidationPaused = preventNotification;
        },
        registerField: function registerField(name, subscriber, subscription, fieldConfig) {
            if (subscription === void 0) subscription = {};
            if (!state.fieldSubscribers[name]) state.fieldSubscribers[name] = {
                index: 0,
                entries: {}
            };
            var index = state.fieldSubscribers[name].index++;
            // save field subscriber callback
            state.fieldSubscribers[name].entries[index] = {
                subscriber: $7b1a6a5c74dca0b1$var$memoize(subscriber),
                subscription: subscription,
                notified: false
            };
            // create initial field state if not exists
            var field = state.fields[name] || {
                active: false,
                afterSubmit: fieldConfig && fieldConfig.afterSubmit,
                beforeSubmit: fieldConfig && fieldConfig.beforeSubmit,
                data: fieldConfig && fieldConfig.data || {},
                isEqual: fieldConfig && fieldConfig.isEqual || $7b1a6a5c74dca0b1$var$tripleEquals,
                lastFieldState: undefined,
                modified: false,
                modifiedSinceLastSubmit: false,
                name: name,
                touched: false,
                valid: true,
                validateFields: fieldConfig && fieldConfig.validateFields,
                validators: {},
                validating: false,
                visited: false
            };
            // Mutators can create a field in order to keep the field states
            // We must update this field when registerField is called afterwards
            field.blur = field.blur || function() {
                return api.blur(name);
            };
            field.change = field.change || function(value1) {
                return api.change(name, value1);
            };
            field.focus = field.focus || function() {
                return api.focus(name);
            };
            state.fields[name] = field;
            var haveValidator = false;
            var silent = fieldConfig && fieldConfig.silent;
            var notify = function notify() {
                if (silent && state.fields[name]) notifyFieldListeners(name);
                else {
                    notifyFormListeners();
                    notifyFieldListeners();
                }
            };
            if (fieldConfig) {
                haveValidator = !!(fieldConfig.getValidator && fieldConfig.getValidator());
                if (fieldConfig.getValidator) state.fields[name].validators[index] = fieldConfig.getValidator;
                var noValueInFormState = $7b1a6a5c74dca0b1$export$c52e5867d5879e24(state.formState.values, name) === undefined;
                if (fieldConfig.initialValue !== undefined && (noValueInFormState || $7b1a6a5c74dca0b1$export$c52e5867d5879e24(state.formState.values, name) === $7b1a6a5c74dca0b1$export$c52e5867d5879e24(state.formState.initialValues, name))) {
                    state.formState.initialValues = $7b1a6a5c74dca0b1$export$e6bdf135a54e021b(state.formState.initialValues || {}, name, fieldConfig.initialValue);
                    state.formState.values = $7b1a6a5c74dca0b1$export$e6bdf135a54e021b(state.formState.values, name, fieldConfig.initialValue);
                    runValidation(undefined, notify);
                }
                // only use defaultValue if we don't yet have any value for this field
                if (fieldConfig.defaultValue !== undefined && fieldConfig.initialValue === undefined && $7b1a6a5c74dca0b1$export$c52e5867d5879e24(state.formState.initialValues, name) === undefined && noValueInFormState) state.formState.values = $7b1a6a5c74dca0b1$export$e6bdf135a54e021b(state.formState.values, name, fieldConfig.defaultValue);
            }
            if (haveValidator) runValidation(undefined, notify);
            else notify();
            return function() {
                var validatorRemoved = false;
                // istanbul ignore next
                if (state.fields[name]) {
                    // state.fields[name] may have been removed by a mutator
                    validatorRemoved = !!(state.fields[name].validators[index] && state.fields[name].validators[index]());
                    delete state.fields[name].validators[index];
                }
                var hasFieldSubscribers = !!state.fieldSubscribers[name];
                if (hasFieldSubscribers) // state.fieldSubscribers[name] may have been removed by a mutator
                delete state.fieldSubscribers[name].entries[index];
                var lastOne = hasFieldSubscribers && !Object.keys(state.fieldSubscribers[name].entries).length;
                if (lastOne) {
                    delete state.fieldSubscribers[name];
                    delete state.fields[name];
                    if (validatorRemoved) state.formState.errors = $7b1a6a5c74dca0b1$export$e6bdf135a54e021b(state.formState.errors, name, undefined) || {};
                    if (destroyOnUnregister) state.formState.values = $7b1a6a5c74dca0b1$export$e6bdf135a54e021b(state.formState.values, name, undefined, true) || {};
                }
                if (!silent) {
                    if (validatorRemoved) runValidation(undefined, function() {
                        notifyFormListeners();
                        notifyFieldListeners();
                    });
                    else if (lastOne) // values or errors may have changed
                    notifyFormListeners();
                }
            };
        },
        reset: function reset(initialValues) {
            if (initialValues === void 0) initialValues = state.formState.initialValues;
            if (state.formState.submitting) state.formState.resetWhileSubmitting = true;
            state.formState.submitFailed = false;
            state.formState.submitSucceeded = false;
            delete state.formState.submitError;
            delete state.formState.submitErrors;
            delete state.formState.lastSubmittedValues;
            api.initialize(initialValues || {});
        },
        /**
     * Resets all field flags (e.g. touched, visited, etc.) to their initial state
     */ resetFieldState: function resetFieldState(name) {
            state.fields[name] = (0, $qmYJK.default)({}, state.fields[name], {
                active: false,
                lastFieldState: undefined,
                modified: false,
                touched: false,
                valid: true,
                validating: false,
                visited: false
            });
            runValidation(undefined, function() {
                notifyFieldListeners();
                notifyFormListeners();
            });
        },
        /**
     * Returns the form to a clean slate; that is:
     * - Clear all values
     * - Resets all fields to their initial state
     */ restart: function restart(initialValues) {
            if (initialValues === void 0) initialValues = state.formState.initialValues;
            api.batch(function() {
                for(var name in state.fields){
                    api.resetFieldState(name);
                    state.fields[name] = (0, $qmYJK.default)({}, state.fields[name], {
                        active: false,
                        lastFieldState: undefined,
                        modified: false,
                        modifiedSinceLastSubmit: false,
                        touched: false,
                        valid: true,
                        validating: false,
                        visited: false
                    });
                }
                api.reset(initialValues);
            });
        },
        resumeValidation: function resumeValidation() {
            validationPaused = false;
            preventNotificationWhileValidationPaused = false;
            if (validationBlocked) // validation was attempted while it was paused, so run it now
            runValidation(undefined, function() {
                notifyFieldListeners();
                notifyFormListeners();
            });
            validationBlocked = false;
        },
        setConfig: function setConfig(name, value1) {
            switch(name){
                case "debug":
                    debug = value1;
                    break;
                case "destroyOnUnregister":
                    destroyOnUnregister = value1;
                    break;
                case "initialValues":
                    api.initialize(value1);
                    break;
                case "keepDirtyOnReinitialize":
                    keepDirtyOnReinitialize = value1;
                    break;
                case "mutators":
                    mutators = value1;
                    if (value1) {
                        Object.keys(mutatorsApi).forEach(function(key) {
                            if (!(key in value1)) delete mutatorsApi[key];
                        });
                        Object.keys(value1).forEach(function(key) {
                            mutatorsApi[key] = getMutatorApi(key);
                        });
                    } else Object.keys(mutatorsApi).forEach(function(key) {
                        delete mutatorsApi[key];
                    });
                    break;
                case "onSubmit":
                    onSubmit = value1;
                    break;
                case "validate":
                    validate = value1;
                    runValidation(undefined, function() {
                        notifyFieldListeners();
                        notifyFormListeners();
                    });
                    break;
                case "validateOnBlur":
                    validateOnBlur = value1;
                    break;
                default:
                    throw new Error("Unrecognised option " + name);
            }
        },
        submit: function submit() {
            var formState = state.formState;
            if (formState.submitting) return;
            delete formState.submitErrors;
            delete formState.submitError;
            formState.lastSubmittedValues = (0, $qmYJK.default)({}, formState.values);
            if (hasSyncErrors()) {
                markAllFieldsTouched();
                resetModifiedAfterSubmit();
                state.formState.submitFailed = true;
                notifyFormListeners();
                notifyFieldListeners();
                return; // no submit for you!!
            }
            var asyncValidationPromisesKeys = Object.keys(asyncValidationPromises);
            if (asyncValidationPromisesKeys.length) {
                // still waiting on async validation to complete...
                Promise.all(asyncValidationPromisesKeys.map(function(key) {
                    return asyncValidationPromises[Number(key)];
                })).then(api.submit, console.error);
                return;
            }
            var submitIsBlocked = beforeSubmit();
            if (submitIsBlocked) return;
            var resolvePromise;
            var completeCalled = false;
            var complete = function complete(errors) {
                formState.submitting = false;
                var resetWhileSubmitting = formState.resetWhileSubmitting;
                if (resetWhileSubmitting) formState.resetWhileSubmitting = false;
                if (errors && $7b1a6a5c74dca0b1$var$hasAnyError(errors)) {
                    formState.submitFailed = true;
                    formState.submitSucceeded = false;
                    formState.submitErrors = errors;
                    formState.submitError = errors[$7b1a6a5c74dca0b1$export$97cd7fc25dd32915];
                    markAllFieldsTouched();
                } else {
                    if (!resetWhileSubmitting) {
                        formState.submitFailed = false;
                        formState.submitSucceeded = true;
                    }
                    afterSubmit();
                }
                notifyFormListeners();
                notifyFieldListeners();
                completeCalled = true;
                if (resolvePromise) resolvePromise(errors);
                return errors;
            };
            formState.submitting = true;
            formState.submitFailed = false;
            formState.submitSucceeded = false;
            formState.lastSubmittedValues = (0, $qmYJK.default)({}, formState.values);
            resetModifiedAfterSubmit();
            // onSubmit is either sync, callback or async with a Promise
            var result = onSubmit(formState.values, api, complete);
            if (!completeCalled) {
                if (result && $7b1a6a5c74dca0b1$var$isPromise(result)) {
                    // onSubmit is async with a Promise
                    notifyFormListeners(); // let everyone know we are submitting
                    notifyFieldListeners(); // notify fields also
                    return result.then(complete, function(error) {
                        complete();
                        throw error;
                    });
                } else if (onSubmit.length >= 3) {
                    // must be async, so we should return a Promise
                    notifyFormListeners(); // let everyone know we are submitting
                    notifyFieldListeners(); // notify fields also
                    return new Promise(function(resolve) {
                        resolvePromise = resolve;
                    });
                } else // onSubmit is sync
                complete(result);
            }
        },
        subscribe: function subscribe(subscriber, subscription) {
            if (!subscriber) throw new Error("No callback given.");
            if (!subscription) throw new Error("No subscription provided. What values do you want to listen to?");
            var memoized = $7b1a6a5c74dca0b1$var$memoize(subscriber);
            var subscribers = state.subscribers;
            var index = subscribers.index++;
            subscribers.entries[index] = {
                subscriber: memoized,
                subscription: subscription,
                notified: false
            };
            var nextFormState = calculateNextFormState();
            $7b1a6a5c74dca0b1$var$notifySubscriber(memoized, subscription, nextFormState, nextFormState, $7b1a6a5c74dca0b1$var$filterFormState, true);
            return function() {
                delete subscribers.entries[index];
            };
        }
    };
    return api;
}

});
parcelRegister("qmYJK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $04f440e6517e6da7$export$2e2bcd8739ae039; });
function $04f440e6517e6da7$export$2e2bcd8739ae039() {
    return $04f440e6517e6da7$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $04f440e6517e6da7$export$2e2bcd8739ae039.apply(null, arguments);
}

});

parcelRegister("8NIwR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $668570e1e28a2d88$export$2e2bcd8739ae039; });
function $668570e1e28a2d88$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.includes(n)) continue;
        t[n] = r[n];
    }
    return t;
}

});


parcelRegister("58WqL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3beb06376bd0c949$export$2e2bcd8739ae039; });

var $azh4v = parcelRequire("azh4v");
//      
/**
 * Predicate to identify inputs that can have focus() called on them
 */ var $3beb06376bd0c949$var$isFocusableInput = function isFocusableInput(wtf) {
    return !!(wtf && typeof wtf.focus === "function");
};
//      
/**
 * Gets all the inputs inside all forms on the page
 */ var $3beb06376bd0c949$var$getAllInputs = function getAllInputs() {
    if (typeof document === "undefined") return [];
    return Array.prototype.slice.call(document.forms).reduce(function(accumulator, form) {
        return accumulator.concat(Array.prototype.slice.call(form).filter($3beb06376bd0c949$var$isFocusableInput));
    }, []);
};
//      
/**
 * Finds the input by looking if the name attribute path is existing in the errors object
 */ var $3beb06376bd0c949$var$findInput = function findInput(inputs, errors) {
    return inputs.find(function(input) {
        return input.name && (0, $azh4v.getIn)(errors, input.name);
    });
};
//      
var $3beb06376bd0c949$var$noop = function noop() {};
var $3beb06376bd0c949$var$createDecorator = function createDecorator(getInputs, findInput$$1) {
    return function(form) {
        var focusOnFirstError = function focusOnFirstError(errors) {
            if (!getInputs) getInputs = $3beb06376bd0c949$var$getAllInputs;
            if (!findInput$$1) findInput$$1 = $3beb06376bd0c949$var$findInput;
            var firstInput = findInput$$1(getInputs(), errors);
            if (firstInput) firstInput.focus();
        }; // Save original submit function
        var originalSubmit = form.submit; // Subscribe to errors, and keep a local copy of them
        var state = {};
        var unsubscribe = form.subscribe(function(nextState) {
            state = nextState;
        }, {
            errors: true,
            submitErrors: true
        }); // What to do after submit
        var afterSubmit = function afterSubmit() {
            var _state = state, errors = _state.errors, submitErrors = _state.submitErrors;
            if (errors && Object.keys(errors).length) focusOnFirstError(errors);
            else if (submitErrors && Object.keys(submitErrors).length) focusOnFirstError(submitErrors);
        }; // Rewrite submit function
        form.submit = function() {
            var result = originalSubmit.call(form);
            if (result && typeof result.then === "function") // async
            result.then(afterSubmit, $3beb06376bd0c949$var$noop);
            else // sync
            afterSubmit();
            return result;
        };
        return function() {
            unsubscribe();
            form.submit = originalSubmit;
        };
    };
};
//      
/**
 * Generates a function to get all the inputs in a form with the specified name
 */ var $3beb06376bd0c949$export$a53c79cbd9f0d029 = function getFormInputs(name) {
    return function() {
        if (typeof document === "undefined") return [];
         // $FlowFixMe
        var form = document.forms[name];
        return form && form.length ? Array.prototype.slice.call(form).filter($3beb06376bd0c949$var$isFocusableInput) : []; // cast cheat to get from HTMLFormElement children to FocusableInput
    };
};
var //
$3beb06376bd0c949$export$2e2bcd8739ae039 = $3beb06376bd0c949$var$createDecorator;

});

parcelRegister("4WAzU", function(module, exports) {

var $lQs1E = parcelRequire("lQs1E");
/**
 * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
 * it's created. Arrays are created for missing index properties while objects
 * are created for all other missing properties. Use `_.setWith` to customize
 * `path` creation.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.set(object, 'a[0].b.c', 4);
 * console.log(object.a[0].b.c);
 * // => 4
 *
 * _.set(object, ['x', '0', 'y', 'z'], 5);
 * console.log(object.x[0].y.z);
 * // => 5
 */ function $3998f3e4b1fecef2$var$set(object, path, value) {
    return object == null ? object : $lQs1E(object, path, value);
}
module.exports = $3998f3e4b1fecef2$var$set;

});
parcelRegister("lQs1E", function(module, exports) {

var $1E0vf = parcelRequire("1E0vf");

var $caOxv = parcelRequire("caOxv");

var $cJfGN = parcelRequire("cJfGN");

var $2fw24 = parcelRequire("2fw24");

var $5dj07 = parcelRequire("5dj07");
/**
 * The base implementation of `_.set`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @param {Function} [customizer] The function to customize path creation.
 * @returns {Object} Returns `object`.
 */ function $fe74319d2355d399$var$baseSet(object, path, value, customizer) {
    if (!$2fw24(object)) return object;
    path = $caOxv(path, object);
    var index = -1, length = path.length, lastIndex = length - 1, nested = object;
    while(nested != null && ++index < length){
        var key = $5dj07(path[index]), newValue = value;
        if (key === "__proto__" || key === "constructor" || key === "prototype") return object;
        if (index != lastIndex) {
            var objValue = nested[key];
            newValue = customizer ? customizer(objValue, key, nested) : undefined;
            if (newValue === undefined) newValue = $2fw24(objValue) ? objValue : $cJfGN(path[index + 1]) ? [] : {};
        }
        $1E0vf(nested, key, newValue);
        nested = nested[key];
    }
    return object;
}
module.exports = $fe74319d2355d399$var$baseSet;

});
parcelRegister("1E0vf", function(module, exports) {

var $frkSI = parcelRequire("frkSI");

var $b82f6 = parcelRequire("b82f6");
/** Used for built-in method references. */ var $1329eac76658be7a$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $1329eac76658be7a$var$hasOwnProperty = $1329eac76658be7a$var$objectProto.hasOwnProperty;
/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $1329eac76658be7a$var$assignValue(object, key, value) {
    var objValue = object[key];
    if (!($1329eac76658be7a$var$hasOwnProperty.call(object, key) && $b82f6(objValue, value)) || value === undefined && !(key in object)) $frkSI(object, key, value);
}
module.exports = $1329eac76658be7a$var$assignValue;

});
parcelRegister("frkSI", function(module, exports) {

var $jC19Y = parcelRequire("jC19Y");
/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $b3d99340a5b8d407$var$baseAssignValue(object, key, value) {
    if (key == "__proto__" && $jC19Y) $jC19Y(object, key, {
        "configurable": true,
        "enumerable": true,
        "value": value,
        "writable": true
    });
    else object[key] = value;
}
module.exports = $b3d99340a5b8d407$var$baseAssignValue;

});
parcelRegister("jC19Y", function(module, exports) {

var $5jezD = parcelRequire("5jezD");
var $e472773e3da147d5$var$defineProperty = function() {
    try {
        var func = $5jezD(Object, "defineProperty");
        func({}, "", {});
        return func;
    } catch (e) {}
}();
module.exports = $e472773e3da147d5$var$defineProperty;

});



parcelRegister("cJfGN", function(module, exports) {
/** Used as references for various `Number` constants. */ var $9445db8ccbcb75eb$var$MAX_SAFE_INTEGER = 9007199254740991;
/** Used to detect unsigned integer values. */ var $9445db8ccbcb75eb$var$reIsUint = /^(?:0|[1-9]\d*)$/;
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function $9445db8ccbcb75eb$var$isIndex(value, length) {
    var type = typeof value;
    length = length == null ? $9445db8ccbcb75eb$var$MAX_SAFE_INTEGER : length;
    return !!length && (type == "number" || type != "symbol" && $9445db8ccbcb75eb$var$reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
module.exports = $9445db8ccbcb75eb$var$isIndex;

});




parcelRegister("hb374", function(module, exports) {

$parcel$export(module.exports, "Label", function () { return $c815e0eaec6c36cc$export$b04be29aa201d4f5; });
/** @jsx jsx */ 
var $jVTBW = parcelRequire("jVTBW");

var $e3GJB = parcelRequire("e3GJB");

var $64ilH = parcelRequire("64ilH");
var $c815e0eaec6c36cc$var$fieldsetLabelStyles = (0, $jVTBW.css)({
    display: "inline-block",
    font: 'var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    marginBlockEnd: "var(--ds-space-050, 4px)",
    marginBlockStart: "var(--ds-space-0, 0px)"
});
var $c815e0eaec6c36cc$var$oldFieldsetLabelStyles = (0, $jVTBW.css)({
    color: "var(--ds-text-subtle, ".concat((0, $64ilH.N200), ")"),
    fontWeight: "var(--ds-font-weight-semibold, 600)"
});
var $c815e0eaec6c36cc$var$newFieldsetLabelStyles = (0, $jVTBW.css)({
    color: "var(--ds-text-subtle, #44546F)",
    fontWeight: "var(--ds-font-weight-bold, 700)"
});
var $c815e0eaec6c36cc$export$b04be29aa201d4f5 = function Label(_ref) {
    var children = _ref.children, htmlFor = _ref.htmlFor, id = _ref.id, testId = _ref.testId;
    return (0, $jVTBW.jsx)("label", {
        css: [
            $c815e0eaec6c36cc$var$fieldsetLabelStyles,
            (0, $e3GJB.getBooleanFF)("platform.design-system-team.form-label-typography-updates") ? $c815e0eaec6c36cc$var$newFieldsetLabelStyles : $c815e0eaec6c36cc$var$oldFieldsetLabelStyles
        ],
        id: id,
        htmlFor: htmlFor,
        "data-testid": testId
    }, children);
};
var $c815e0eaec6c36cc$export$ed247974535929c7 = function Legend(_ref2) {
    var children = _ref2.children;
    return (0, $jVTBW.jsx)("legend", {
        css: [
            $c815e0eaec6c36cc$var$fieldsetLabelStyles,
            (0, $e3GJB.getBooleanFF)("platform.design-system-team.form-label-typography-updates") ? $c815e0eaec6c36cc$var$newFieldsetLabelStyles : $c815e0eaec6c36cc$var$oldFieldsetLabelStyles
        ]
    }, children);
};
var $c815e0eaec6c36cc$export$2e2bcd8739ae039 = $c815e0eaec6c36cc$export$b04be29aa201d4f5;

});
parcelRegister("e3GJB", function(module, exports) {

$parcel$export(module.exports, "getBooleanFF", function () { return $a3c27eab6f4edcd7$export$470e5c2be1411c89; });

var $2mRfe = parcelRequire("2mRfe");
function $a3c27eab6f4edcd7$export$ba05d765b8392e5e(flagResolver) {
    (0, $2mRfe.setBooleanResolver)(flagResolver);
}
function $a3c27eab6f4edcd7$export$470e5c2be1411c89(name) {
    return (0, $2mRfe.resolveBooleanFlag)(name);
}

});
parcelRegister("2mRfe", function(module, exports) {

$parcel$export(module.exports, "setBooleanResolver", function () { return $1b96f0246c867cd0$export$f2b591175b3e424c; });
$parcel$export(module.exports, "resolveBooleanFlag", function () { return $1b96f0246c867cd0$export$6333b6aff9fc6275; });

var $iuhII = parcelRequire("iuhII");

var $ahJoN = parcelRequire("ahJoN");
var $1b96f0246c867cd0$var$pkgName = "@atlaskit/platform-feature-flags";
var $1b96f0246c867cd0$export$7e41b1b2bdee3f98 = "__PLATFORM_FEATURE_FLAGS__";
var $1b96f0246c867cd0$var$hasProcessEnv = typeof $ahJoN !== "undefined" && typeof $ahJoN.env !== "undefined";
// FF global overrides can be configured by test runners or Storybook
var $1b96f0246c867cd0$var$ENV_ENABLE_PLATFORM_FF = $1b96f0246c867cd0$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
// STORYBOOK_ENABLE_PLATFORM_FF is included as storybook only allows env vars prefixed with STORYBOOK
// https://github.com/storybookjs/storybook/issues/12270
var $1b96f0246c867cd0$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF = $1b96f0246c867cd0$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
var $1b96f0246c867cd0$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE = $1b96f0246c867cd0$var$ENV_ENABLE_PLATFORM_FF || $1b96f0246c867cd0$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF;
var $1b96f0246c867cd0$var$DEFAULT_PFF_GLOBAL = {
    // In development mode we want to capture any feature flag checks that happen using the default resolver and log this result when the resolver is replaced.
    // This is because evaluating feature flags when the resolver/FF client is loaded asynchronously could cause unexpected issues.
    earlyResolvedFlags: new Map(),
    booleanResolver: function booleanResolver(flagKey) {
        var unresolvedFlagCount;
        return false;
    }
};
var $1b96f0246c867cd0$var$globalVar = typeof window !== "undefined" ? window : globalThis;
$1b96f0246c867cd0$var$globalVar[$1b96f0246c867cd0$export$7e41b1b2bdee3f98] = $1b96f0246c867cd0$var$globalVar[$1b96f0246c867cd0$export$7e41b1b2bdee3f98] || $1b96f0246c867cd0$var$DEFAULT_PFF_GLOBAL;
function $1b96f0246c867cd0$export$f2b591175b3e424c(resolver) {
    $1b96f0246c867cd0$var$globalVar[$1b96f0246c867cd0$export$7e41b1b2bdee3f98].booleanResolver = resolver;
    var _globalVar$PFF_GLOBAL;
}
function $1b96f0246c867cd0$export$6333b6aff9fc6275(flagKey) {
    if ($1b96f0246c867cd0$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE) {
        (0, $iuhII.debug)('[%s]: The feature flags were enabled while running tests. The flag "%s" will be always enabled.', $1b96f0246c867cd0$var$pkgName, flagKey);
        return true;
    }
    try {
        var _globalVar$PFF_GLOBAL2;
        var result = (_globalVar$PFF_GLOBAL2 = $1b96f0246c867cd0$var$globalVar[$1b96f0246c867cd0$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL2 === void 0 ? void 0 : _globalVar$PFF_GLOBAL2.booleanResolver(flagKey);
        if (typeof result !== "boolean") {
            // eslint-disable-next-line no-console
            console.warn("".concat(flagKey, " resolved to a non-boolean value, returning false for safety"));
            return false;
        }
        return result;
    } catch (e) {
        return false;
    }
}

});
parcelRegister("iuhII", function(module, exports) {

$parcel$export(module.exports, "debug", function () { return $d758c63a2c8ef180$export$1c9f709888824e05; });
var $d758c63a2c8ef180$var$_ref, $d758c63a2c8ef180$var$_process, $d758c63a2c8ef180$var$_process2;
// We can't rely on NODE_ENV === 'test' if its value is already configured by the consumer to some other value, so better to use JEST_WORKER_ID
// https://jestjs.io/docs/environment-variables#jest_worker_id
var $d758c63a2c8ef180$var$TESTS_MODE = ($d758c63a2c8ef180$var$_ref = (globalThis === null || globalThis === void 0 || ($d758c63a2c8ef180$var$_process = globalThis.process) === null || $d758c63a2c8ef180$var$_process === void 0 || ($d758c63a2c8ef180$var$_process = $d758c63a2c8ef180$var$_process.env) === null || $d758c63a2c8ef180$var$_process === void 0 ? void 0 : $d758c63a2c8ef180$var$_process.JEST_WORKER_ID) !== undefined, $d758c63a2c8ef180$var$_ref !== void 0) ? $d758c63a2c8ef180$var$_ref : false;
var $d758c63a2c8ef180$var$DEBUG_MODE = !$d758c63a2c8ef180$var$TESTS_MODE && (globalThis === null || globalThis === void 0 || ($d758c63a2c8ef180$var$_process2 = globalThis.process) === null || $d758c63a2c8ef180$var$_process2 === void 0 || ($d758c63a2c8ef180$var$_process2 = $d758c63a2c8ef180$var$_process2.env) === null || $d758c63a2c8ef180$var$_process2 === void 0 ? void 0 : $d758c63a2c8ef180$var$_process2.NODE_ENV) !== "production";
var $d758c63a2c8ef180$export$1c9f709888824e05 = function debug() {
    var _console;
    if (!$d758c63a2c8ef180$var$DEBUG_MODE) return;
    // eslint-disable-next-line no-console
    (_console = console).debug.apply(_console, arguments);
};

});



parcelRegister("64ilH", function(module, exports) {

$parcel$export(module.exports, "R400", function () { return $46b15980a4aa84f8$export$2010d0fb4295b346; });
$parcel$export(module.exports, "B200", function () { return $46b15980a4aa84f8$export$215b7063051591f1; });
$parcel$export(module.exports, "N200", function () { return $46b15980a4aa84f8$export$f563ee71e9ee74cd; });
$parcel$export(module.exports, "N30A", function () { return $46b15980a4aa84f8$export$920c0d5c49070351; });
$parcel$export(module.exports, "skeleton", function () { return $46b15980a4aa84f8$export$2a0674ff2eb10214; });
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ 
var $3YadW = parcelRequire("3YadW");
var $46b15980a4aa84f8$export$4b84fd0e2c617bd = "#FFEBE6";
var $46b15980a4aa84f8$export$b34b069eff244586 = "#FFBDAD";
var $46b15980a4aa84f8$export$be802dd0d8b57f35 = "#FF8F73";
var $46b15980a4aa84f8$export$60847d42f9da92a6 = "#FF7452";
var $46b15980a4aa84f8$export$4a7404f376229999 = "#FF5630";
var $46b15980a4aa84f8$export$2010d0fb4295b346 = "#DE350B";
var $46b15980a4aa84f8$export$2837b5a1a71d5c02 = "#BF2600";
var $46b15980a4aa84f8$export$8d9596b529bbb9cf = "#FFFAE6";
var $46b15980a4aa84f8$export$41060a744ab0b7ae = "#FFF0B3";
var $46b15980a4aa84f8$export$1cc05bbbf340e559 = "#FFE380";
var $46b15980a4aa84f8$export$5aae31392d72caaa = "#FFC400";
var $46b15980a4aa84f8$export$c6930421db9fa514 = "#FFAB00";
var $46b15980a4aa84f8$export$59619663aa6500fb = "#FF991F";
var $46b15980a4aa84f8$export$874739ea9e379ab6 = "#FF8B00";
var $46b15980a4aa84f8$export$8a6341c32b6a3ee6 = "#E3FCEF";
var $46b15980a4aa84f8$export$69a3bf21b9686c2b = "#ABF5D1";
var $46b15980a4aa84f8$export$afbce1382ec95f73 = "#79F2C0";
var $46b15980a4aa84f8$export$747d86715d4175de = "#57D9A3";
var $46b15980a4aa84f8$export$940e1f69e873f202 = "#36B37E";
var $46b15980a4aa84f8$export$a49394138f7b8e85 = "#00875A";
var $46b15980a4aa84f8$export$6fa04827ac68a4fb = "#006644";
var $46b15980a4aa84f8$export$226de0355ed012f8 = "#DEEBFF";
var $46b15980a4aa84f8$export$8c13c2ee36917869 = "#B3D4FF";
var $46b15980a4aa84f8$export$ecfc1dff386a3e7a = "#4C9AFF";
var $46b15980a4aa84f8$export$215b7063051591f1 = "#2684FF";
var $46b15980a4aa84f8$export$e62e8919cca44969 = "#0065FF";
var $46b15980a4aa84f8$export$b3de0ae08da2ce64 = "#0052CC";
var $46b15980a4aa84f8$export$a6ee3d71bc067634 = "#0747A6";
var $46b15980a4aa84f8$export$363e4475840015bb = "#EAE6FF";
var $46b15980a4aa84f8$export$4b0a4417ed59760f = "#C0B6F2";
var $46b15980a4aa84f8$export$6011520a64d9a187 = "#998DD9";
var $46b15980a4aa84f8$export$a7175d4e9206bc80 = "#8777D9";
var $46b15980a4aa84f8$export$b48405b95304b5a1 = "#6554C0";
var $46b15980a4aa84f8$export$c71e4279dd54a18d = "#5243AA";
var $46b15980a4aa84f8$export$147899de772240ec = "#403294";
var $46b15980a4aa84f8$export$2cf711fe14c66f06 = "#E6FCFF";
var $46b15980a4aa84f8$export$7a8f4d33f6f9772c = "#B3F5FF";
var $46b15980a4aa84f8$export$776c9c497ef08533 = "#79E2F2";
var $46b15980a4aa84f8$export$69cb3ca10c1e330e = "#00C7E6";
var $46b15980a4aa84f8$export$9dc1ef0f3f48059b = "#00B8D9";
var $46b15980a4aa84f8$export$7c835c78b6fcdef8 = "#00A3BF";
var $46b15980a4aa84f8$export$6036577f95c3877e = "#008DA6";
var $46b15980a4aa84f8$export$29a4f05edc054374 = "#FFFFFF";
var $46b15980a4aa84f8$export$e655ef011c4aa1a2 = "#FAFBFC";
var $46b15980a4aa84f8$export$9fdfb749e33cdf97 = "#F4F5F7";
var $46b15980a4aa84f8$export$3e51e8f1440314ba = "#EBECF0";
var $46b15980a4aa84f8$export$1ce2d1575d444ceb = "#DFE1E6";
var $46b15980a4aa84f8$export$8754fc7e6d8b3000 = "#C1C7D0";
var $46b15980a4aa84f8$export$c2e91cbeada39b8b = "#B3BAC5";
var $46b15980a4aa84f8$export$5f71e19f3a7ad9de = "#A5ADBA";
var $46b15980a4aa84f8$export$eaa8c8a70ac22806 = "#97A0AF";
var $46b15980a4aa84f8$export$7c87d337fb91a97d = "#8993A4";
var $46b15980a4aa84f8$export$d6447c357493214f = "#7A869A";
var $46b15980a4aa84f8$export$f563ee71e9ee74cd = "#6B778C";
var $46b15980a4aa84f8$export$e2ef2124cf4024b1 = "#5E6C84";
var $46b15980a4aa84f8$export$eece5f492e429f08 = "#505F79";
var $46b15980a4aa84f8$export$c39c0fe0f26207ae = "#42526E";
var $46b15980a4aa84f8$export$7090862dc3038a9f = "#344563";
var $46b15980a4aa84f8$export$ad0bacf983b7ddaa = "#253858";
var $46b15980a4aa84f8$export$7d61b15e0da132af = "#172B4D";
var $46b15980a4aa84f8$export$fbda843f0a27fe96 = "#091E42";
var $46b15980a4aa84f8$export$791e57b27ca738ef = "rgba(9, 30, 66, 0.02)";
var $46b15980a4aa84f8$export$8d43898f60b96a82 = "rgba(9, 30, 66, 0.04)";
var $46b15980a4aa84f8$export$920c0d5c49070351 = "rgba(9, 30, 66, 0.08)";
var $46b15980a4aa84f8$export$46987b49aab6d1a8 = "rgba(9, 30, 66, 0.13)";
var $46b15980a4aa84f8$export$7d3359664e8bb0e5 = "rgba(9, 30, 66, 0.25)";
var $46b15980a4aa84f8$export$d2d3bedfb276cac0 = "rgba(9, 30, 66, 0.31)";
var $46b15980a4aa84f8$export$6e5e7499ff054f6d = "rgba(9, 30, 66, 0.36)";
var $46b15980a4aa84f8$export$59264b346c877fa7 = "rgba(9, 30, 66, 0.42)";
var $46b15980a4aa84f8$export$d092757d7c64925c = "rgba(9, 30, 66, 0.48)";
var $46b15980a4aa84f8$export$486ab785e4bac3c6 = "rgba(9, 30, 66, 0.54)";
var $46b15980a4aa84f8$export$fba592bbc6419fea = "rgba(9, 30, 66, 0.60)";
var $46b15980a4aa84f8$export$13609db0e6812ab8 = "rgba(9, 30, 66, 0.66)";
var $46b15980a4aa84f8$export$fbae4efaa892d883 = "rgba(9, 30, 66, 0.71)";
var $46b15980a4aa84f8$export$f13946d26f440ce6 = "rgba(9, 30, 66, 0.77)";
var $46b15980a4aa84f8$export$19f58225ac52a306 = "rgba(9, 30, 66, 0.82)";
var $46b15980a4aa84f8$export$6384f09da70e7b62 = "rgba(9, 30, 66, 0.89)";
var $46b15980a4aa84f8$export$d0dccc730683edc2 = "rgba(9, 30, 66, 0.95)";
var $46b15980a4aa84f8$export$2f6319cf7d736c2a = "#E6EDFA";
var $46b15980a4aa84f8$export$95126bc8884d6634 = "#DCE5F5";
var $46b15980a4aa84f8$export$8338d8c35d44ff1 = "#CED9EB";
var $46b15980a4aa84f8$export$5368d76ae4fbbda7 = "#B8C7E0";
var $46b15980a4aa84f8$export$9f0a771d16ec8d36 = "#ABBBD6";
var $46b15980a4aa84f8$export$abcf8c38338b4aa5 = "#9FB0CC";
var $46b15980a4aa84f8$export$97e81faa16a182c7 = "#8C9CB8";
var $46b15980a4aa84f8$export$bfe21c59123ecf33 = "#7988A3";
var $46b15980a4aa84f8$export$ee82aa2ea6a1558 = "#67758F";
var $46b15980a4aa84f8$export$682927c6ed76be02 = "#56637A";
var $46b15980a4aa84f8$export$91fd9994c5be9757 = "#455166";
var $46b15980a4aa84f8$export$d281fbfe3cff2df6 = "#3B475C";
var $46b15980a4aa84f8$export$3902c91d8b98a753 = "#313D52";
var $46b15980a4aa84f8$export$8e8133c1ba5845b5 = "#283447";
var $46b15980a4aa84f8$export$33ff357f6620b39 = "#202B3D";
var $46b15980a4aa84f8$export$633847cf062b69e0 = "#1B2638";
var $46b15980a4aa84f8$export$9776a6e503bdbf76 = "#121A29";
var $46b15980a4aa84f8$export$6c813d5160dff5db = "#0E1624";
var $46b15980a4aa84f8$export$3d4f271a500072a = "#0D1424";
var $46b15980a4aa84f8$export$fe151285c22759ec = "rgba(13, 20, 36, 0.06)";
var $46b15980a4aa84f8$export$a101c6190d0da34 = "rgba(13, 20, 36, 0.14)";
var $46b15980a4aa84f8$export$4b16f52932fda51 = "rgba(13, 20, 36, 0.18)";
var $46b15980a4aa84f8$export$a74bcd7b9845b0d8 = "rgba(13, 20, 36, 0.29)";
var $46b15980a4aa84f8$export$9209c179316d1751 = "rgba(13, 20, 36, 0.36)";
var $46b15980a4aa84f8$export$88f55133f636c8dd = "rgba(13, 20, 36, 0.40)";
var $46b15980a4aa84f8$export$51126f85d1009512 = "rgba(13, 20, 36, 0.47)";
var $46b15980a4aa84f8$export$a069b547bd23af78 = "rgba(13, 20, 36, 0.53)";
var $46b15980a4aa84f8$export$40cce05af3b2600a = "rgba(13, 20, 36, 0.63)";
var $46b15980a4aa84f8$export$b78942185925a0d = "rgba(13, 20, 36, 0.73)";
var $46b15980a4aa84f8$export$e058fb44b8eaafca = "rgba(13, 20, 36, 0.78)";
var $46b15980a4aa84f8$export$92b0b8de26920c18 = "rgba(13, 20, 36, 0.81)";
var $46b15980a4aa84f8$export$67564f7459d3fc9e = "rgba(13, 20, 36, 0.85)";
var $46b15980a4aa84f8$export$77868e1ca884ffa3 = "rgba(13, 20, 36, 0.89)";
var $46b15980a4aa84f8$export$2afd71d7d3ea2cd5 = "rgba(13, 20, 36, 0.92)";
var $46b15980a4aa84f8$export$f2a0acaab9972c70 = "rgba(13, 20, 36, 0.95)";
var $46b15980a4aa84f8$export$9ab70e67d6475361 = "rgba(13, 20, 36, 0.97)";
var $46b15980a4aa84f8$export$8ce1fd94bee2f412 = (0, $3YadW.default)({
    light: "var(--ds-surface, ".concat($46b15980a4aa84f8$export$29a4f05edc054374, ")"),
    dark: "var(--ds-surface, ".concat($46b15980a4aa84f8$export$633847cf062b69e0, ")")
});
var $46b15980a4aa84f8$export$b861914ea877b580 = (0, $3YadW.default)({
    light: "var(--ds-background-selected, ".concat($46b15980a4aa84f8$export$226de0355ed012f8, ")"),
    dark: "var(--ds-background-selected, ".concat($46b15980a4aa84f8$export$8c13c2ee36917869, ")")
});
var $46b15980a4aa84f8$export$3f1b020df94387af = (0, $3YadW.default)({
    light: "var(--ds-background-neutral-hovered, ".concat($46b15980a4aa84f8$export$3e51e8f1440314ba, ")"),
    dark: "var(--ds-background-neutral-hovered, ".concat($46b15980a4aa84f8$export$d281fbfe3cff2df6, ")")
});
var $46b15980a4aa84f8$export$c0183dbab98ca63e = (0, $3YadW.default)({
    light: "var(--ds-surface-overlay, ".concat($46b15980a4aa84f8$export$29a4f05edc054374, ")"),
    dark: "var(--ds-surface-overlay, ".concat($46b15980a4aa84f8$export$8e8133c1ba5845b5, ")")
});
var $46b15980a4aa84f8$export$6f093cfa640b7166 = (0, $3YadW.default)({
    light: "var(--ds-text, ".concat($46b15980a4aa84f8$export$fbda843f0a27fe96, ")"),
    dark: "var(--ds-text, ".concat($46b15980a4aa84f8$export$5368d76ae4fbbda7, ")")
});
var $46b15980a4aa84f8$export$42f8e9c698766e7a = (0, $3YadW.default)({
    light: "var(--ds-text, ".concat($46b15980a4aa84f8$export$7d61b15e0da132af, ")"),
    dark: "var(--ds-text, ".concat($46b15980a4aa84f8$export$5368d76ae4fbbda7, ")")
});
var $46b15980a4aa84f8$export$c2d157ca1c34b6e3 = (0, $3YadW.default)({
    light: "var(--ds-text-selected, ".concat($46b15980a4aa84f8$export$b3de0ae08da2ce64, ")"),
    dark: "var(--ds-text-selected, ".concat($46b15980a4aa84f8$export$b3de0ae08da2ce64, ")")
});
var $46b15980a4aa84f8$export$1905ba28d7cf066f = (0, $3YadW.default)({
    light: "var(--ds-text-subtlest, ".concat($46b15980a4aa84f8$export$f563ee71e9ee74cd, ")"),
    dark: "var(--ds-text-subtlest, ".concat($46b15980a4aa84f8$export$97e81faa16a182c7, ")")
});
var $46b15980a4aa84f8$export$bd9002130d306d39 = (0, $3YadW.default)({
    light: "var(--ds-text-subtlest, ".concat($46b15980a4aa84f8$export$f563ee71e9ee74cd, ")"),
    dark: "var(--ds-text-subtlest, ".concat($46b15980a4aa84f8$export$bfe21c59123ecf33, ")")
});
var $46b15980a4aa84f8$export$46e4a324ac90507f = (0, $3YadW.default)({
    light: "var(--ds-text, ".concat($46b15980a4aa84f8$export$7d61b15e0da132af, ")"),
    dark: "var(--ds-text, ".concat($46b15980a4aa84f8$export$5368d76ae4fbbda7, ")")
});
var $46b15980a4aa84f8$export$79f3f2b82beb0d36 = (0, $3YadW.default)({
    light: "var(--ds-text-subtlest, ".concat($46b15980a4aa84f8$export$f563ee71e9ee74cd, ")"),
    dark: "var(--ds-text-subtlest, ".concat($46b15980a4aa84f8$export$97e81faa16a182c7, ")")
});
var $46b15980a4aa84f8$export$7bb0d5c671655cc4 = (0, $3YadW.default)({
    light: $46b15980a4aa84f8$export$9fdfb749e33cdf97,
    dark: $46b15980a4aa84f8$export$8e8133c1ba5845b5
});
var $46b15980a4aa84f8$export$9c30223ca0a664fb = (0, $3YadW.default)({
    light: "var(--ds-link, ".concat($46b15980a4aa84f8$export$b3de0ae08da2ce64, ")"),
    dark: "var(--ds-link, ".concat($46b15980a4aa84f8$export$ecfc1dff386a3e7a, ")")
});
var $46b15980a4aa84f8$export$7ed258b0728b004b = (0, $3YadW.default)({
    light: "var(--ds-link-pressed, ".concat($46b15980a4aa84f8$export$e62e8919cca44969, ")"),
    dark: "var(--ds-link-pressed, ".concat($46b15980a4aa84f8$export$215b7063051591f1, ")")
});
var $46b15980a4aa84f8$export$dfa920d8decc8a59 = (0, $3YadW.default)({
    light: "var(--ds-link-pressed, ".concat($46b15980a4aa84f8$export$a6ee3d71bc067634, ")"),
    dark: "var(--ds-link-pressed, ".concat($46b15980a4aa84f8$export$ecfc1dff386a3e7a, ")")
});
var $46b15980a4aa84f8$export$6069e6ad5c78f632 = (0, $3YadW.default)({
    light: "var(--ds-border-focused, ".concat($46b15980a4aa84f8$export$215b7063051591f1, ")"),
    dark: "var(--ds-border-focused, ".concat($46b15980a4aa84f8$export$215b7063051591f1, ")")
});
var $46b15980a4aa84f8$export$9ad721cf3b3debe0 = (0, $3YadW.default)({
    light: "var(--ds-background-brand-bold, ".concat($46b15980a4aa84f8$export$b3de0ae08da2ce64, ")"),
    dark: "var(--ds-background-brand-bold, ".concat($46b15980a4aa84f8$export$ecfc1dff386a3e7a, ")")
});
var $46b15980a4aa84f8$export$2aa0182783e7e9de = (0, $3YadW.default)({
    light: $46b15980a4aa84f8$export$b3de0ae08da2ce64,
    dark: $46b15980a4aa84f8$export$ecfc1dff386a3e7a
});
var $46b15980a4aa84f8$export$8bf7dff220b82b4a = (0, $3YadW.default)({
    light: $46b15980a4aa84f8$export$9dc1ef0f3f48059b,
    dark: $46b15980a4aa84f8$export$69cb3ca10c1e330e
});
var $46b15980a4aa84f8$export$e13cce2a2d16a9d4 = (0, $3YadW.default)({
    light: $46b15980a4aa84f8$export$b48405b95304b5a1,
    dark: $46b15980a4aa84f8$export$6011520a64d9a187
});
var $46b15980a4aa84f8$export$a90204d1394caf30 = (0, $3YadW.default)({
    light: $46b15980a4aa84f8$export$4a7404f376229999,
    dark: $46b15980a4aa84f8$export$4a7404f376229999
});
var $46b15980a4aa84f8$export$594c5a8758200c32 = (0, $3YadW.default)({
    light: $46b15980a4aa84f8$export$c6930421db9fa514,
    dark: $46b15980a4aa84f8$export$c6930421db9fa514
});
var $46b15980a4aa84f8$export$955a2ebd2fb142ae = (0, $3YadW.default)({
    light: $46b15980a4aa84f8$export$940e1f69e873f202,
    dark: $46b15980a4aa84f8$export$940e1f69e873f202
});
var $46b15980a4aa84f8$export$2a0674ff2eb10214 = function skeleton() {
    return "var(--ds-skeleton, ".concat($46b15980a4aa84f8$export$8d43898f60b96a82, ")");
};

});
parcelRegister("3YadW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2e3ee7f1461cdef2$export$2e2bcd8739ae039; });
/* eslint-disable prefer-rest-params */ 
var $8Y9pc = parcelRequire("8Y9pc");
// Unpack custom variants, and get correct value for the current theme
function $2e3ee7f1461cdef2$var$themedVariants(variantProp, variants) {
    return function(props) {
        var theme = (0, $8Y9pc.default)(props);
        if (props && props[variantProp] && variants) {
            var modes = variants[props[variantProp]];
            if (modes && modes[theme.mode]) {
                var value = modes[theme.mode];
                if (value) return value;
                 // TS believes value can be undefined
            }
        }
        return "";
    };
}
function $2e3ee7f1461cdef2$export$2e2bcd8739ae039(modesOrVariant, variantModes) {
    if (typeof modesOrVariant === "string") return $2e3ee7f1461cdef2$var$themedVariants(modesOrVariant, variantModes);
    var modes = modesOrVariant;
    return function(props) {
        // Get theme from the user's props
        var theme = (0, $8Y9pc.default)(props);
        // User isn't required to provide both light and dark values
        if (theme.mode in modes) {
            var value = modes[theme.mode]; // TS believes value can be undefined
            if (value) return value;
        }
        return "";
    };
}

});
parcelRegister("8Y9pc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $687b39125086c44e$export$2e2bcd8739ae039; });

var $axjPu = parcelRequire("axjPu");
function $687b39125086c44e$export$2e2bcd8739ae039(props) {
    if (props && props.theme) {
        // Theme is the global Atlaskit theme
        if ((0, $axjPu.CHANNEL) in props.theme) return props.theme[0, $axjPu.CHANNEL];
        else if ("mode" in props.theme && (0, $axjPu.THEME_MODES).includes(props.theme.mode)) return props.theme;
    }
    // If format not supported (or no theme provided), return standard theme
    return {
        mode: (0, $axjPu.DEFAULT_THEME_MODE)
    };
}

});
parcelRegister("axjPu", function(module, exports) {

$parcel$export(module.exports, "CHANNEL", function () { return $7abc5e2d7c3296ac$export$44ffba16bd48dac6; });
$parcel$export(module.exports, "DEFAULT_THEME_MODE", function () { return $7abc5e2d7c3296ac$export$c93026a968943f95; });
$parcel$export(module.exports, "THEME_MODES", function () { return $7abc5e2d7c3296ac$export$6ba72c8346b4c57e; });

var $e2xkU = parcelRequire("e2xkU");

var $64ilH = parcelRequire("64ilH");
var $7abc5e2d7c3296ac$export$44ffba16bd48dac6 = "__ATLASKIT_THEME__";
var $7abc5e2d7c3296ac$export$c93026a968943f95 = "light";
var $7abc5e2d7c3296ac$export$6ba72c8346b4c57e = [
    "light",
    "dark"
];
var $7abc5e2d7c3296ac$export$7a57f79000377ca2 = function borderRadius() {
    return 3;
};
var $7abc5e2d7c3296ac$export$6d8204c2cb2e06b8 = function gridSize() {
    return 8;
};
var $7abc5e2d7c3296ac$export$85e3c3ca0c6fb93 = function fontSize() {
    return 14;
};
var $7abc5e2d7c3296ac$export$6746fe0d9c9fab54 = function fontSizeSmall() {
    return 11;
};
var $7abc5e2d7c3296ac$export$a5975749f0374264 = function fontFamily() {
    return "-apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif";
};
var $7abc5e2d7c3296ac$export$356129969ee49c55 = function codeFontFamily() {
    return "'SFMono-Medium', 'SF Mono', 'Segoe UI Mono', 'Roboto Mono', 'Ubuntu Mono', Menlo, Consolas, Courier, monospace";
};
var $7abc5e2d7c3296ac$export$8e24544ddba725ee = function focusRing() {
    var color = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "var(--ds-border-focused, ".concat((0, $64ilH.B200), ")");
    var outlineWidth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $7abc5e2d7c3296ac$export$6d8204c2cb2e06b8() / 4;
    (0, $e2xkU.default)("@atlaskit/theme", "focus ring mixin", "Please use `@atlaskit/focus-ring` instead.");
    return "\n  &:focus {\n    outline: none;\n    box-shadow: 0px 0px 0px ".concat(outlineWidth, "px ").concat(color, ";\n  }\n");
};
var $7abc5e2d7c3296ac$export$c0dd343266bc3261 = function noFocusRing() {
    return "\n  box-shadow: none;\n";
};
var $7abc5e2d7c3296ac$export$7be255094ccdc533 = {
    card: function card() {
        return 100;
    },
    navigation: function navigation() {
        return 200;
    },
    dialog: function dialog() {
        return 300;
    },
    layer: function layer() {
        return 400;
    },
    blanket: function blanket() {
        return 500;
    },
    modal: function modal() {
        return 510;
    },
    flag: function flag() {
        return 600;
    },
    spotlight: function spotlight() {
        return 700;
    },
    tooltip: function tooltip() {
        return 9999;
    }
};
var $7abc5e2d7c3296ac$export$a1b3edb637fb4f35 = function visuallyHidden() {
    (0, $e2xkU.default)("@atlaskit/theme", "visually hidden mixin", "Please use `@atlaskit/visually-hidden` instead.");
    return {
        border: "0 !important",
        clip: "rect(1px, 1px, 1px, 1px) !important",
        height: "1px !important",
        overflow: "hidden !important",
        padding: "0 !important",
        position: "absolute !important",
        width: "1px !important",
        whiteSpace: "nowrap !important"
    };
};
var $7abc5e2d7c3296ac$export$ba1d834b86d72a09 = $7abc5e2d7c3296ac$export$a1b3edb637fb4f35;
var $7abc5e2d7c3296ac$export$e497e856b4f89fcd = function skeletonShimmer() {
    return {
        css: {
            backgroundColor: "var(--ds-skeleton, ".concat((0, $64ilH.skeleton)(), ")"),
            animationDuration: "1.5s",
            animationIterationCount: "infinite",
            animationTimingFunction: "linear",
            animationDirection: "alternate"
        },
        keyframes: {
            from: {
                backgroundColor: "var(--ds-skeleton, ".concat((0, $64ilH.skeleton)(), ")")
            },
            to: {
                backgroundColor: "var(--ds-skeleton-subtle, ".concat((0, $64ilH.N30A), ")")
            }
        }
    };
};

});





parcelRegister("8WIPl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $683683399096c953$export$2e2bcd8739ae039; });
/** @jsx jsx */ 
var $jVTBW = parcelRequire("jVTBW");

var $64ilH = parcelRequire("64ilH");
var $683683399096c953$var$requiredIndicatorStyles = (0, $jVTBW.css)({
    color: "var(--ds-text-danger, ".concat((0, $64ilH.R400), ")"),
    fontFamily: 'var(--ds-font-family-body, ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    paddingInlineStart: "var(--ds-space-025, 2px)"
});
function $683683399096c953$export$2e2bcd8739ae039() {
    return (0, $jVTBW.jsx)("span", {
        css: $683683399096c953$var$requiredIndicatorStyles,
        "aria-hidden": "true",
        title: "required"
    }, "*");
}

});


parcelRegister("8Duts", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $64999ac1c84ce5ec$export$2e2bcd8739ae039; });

var $bIiWW = parcelRequire("bIiWW");

var $lcV3t = parcelRequire("lcV3t");

var $9EJk3 = parcelRequire("9EJk3");

var $dAx5m = parcelRequire("dAx5m");

var $lB4om = parcelRequire("lB4om");

var $Bb0he = parcelRequire("Bb0he");

var $kqsmh = parcelRequire("kqsmh");

var $5BICO = parcelRequire("5BICO");

var $8WEMR = parcelRequire("8WEMR");
var $64999ac1c84ce5ec$var$_excluded = [
    "children",
    "backgroundColor",
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    "isDisabled",
    "type",
    "testId",
    "xcss",
    "onClick",
    "interactionName",
    "componentName",
    "analyticsContext"
];
// TODO: Duplicated FocusRing styles due to lack of `xcss` support
// and to prevent additional dependency
var $64999ac1c84ce5ec$var$baseFocusRingStyles = {
    outlineColor: "color.border.focused",
    outlineWidth: "border.width.outline",
    outlineStyle: "solid",
    outlineOffset: "space.025"
};
var $64999ac1c84ce5ec$var$focusRingStyles = (0, $5BICO.xcss)({
    ":focus-visible": $64999ac1c84ce5ec$var$baseFocusRingStyles,
    "@supports not selector(*:focus-visible)": {
        ":focus": $64999ac1c84ce5ec$var$baseFocusRingStyles
    },
    "@media screen and (forced-colors: active), screen and (-ms-high-contrast: active)": {
        ":focus-visible": {
            outline: "1px solid"
        }
    }
});
/**
 * __Pressable__
 *
 * A primitive for building custom buttons.
 *
 * - [Examples](https://atlassian.design/components/primitives/pressable/examples)
 * - [Code](https://atlassian.design/components/primitives/pressable/code)
 * - [Usage](https://atlassian.design/components/primitives/pressable/usage)
 */ var $64999ac1c84ce5ec$var$Pressable = /*#__PURE__*/ (0, $dAx5m.forwardRef)(function(_ref, ref) {
    var children = _ref.children, backgroundColor = _ref.backgroundColor, padding = _ref.padding, paddingBlock = _ref.paddingBlock, paddingBlockStart = _ref.paddingBlockStart, paddingBlockEnd = _ref.paddingBlockEnd, paddingInline = _ref.paddingInline, paddingInlineStart = _ref.paddingInlineStart, paddingInlineEnd = _ref.paddingInlineEnd, isDisabled = _ref.isDisabled, _ref$type = _ref.type, type = _ref$type === void 0 ? "button" : _ref$type, testId = _ref.testId, xcssStyles = _ref.xcss, _ref$onClick = _ref.onClick, providedOnClick = _ref$onClick === void 0 ? (0, $Bb0he.default) : _ref$onClick, interactionName = _ref.interactionName, componentName = _ref.componentName, analyticsContext = _ref.analyticsContext, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($9EJk3)))(_ref, $64999ac1c84ce5ec$var$_excluded);
    var interactionContext = (0, $dAx5m.useContext)((0, $kqsmh.default));
    var handleClick = (0, $dAx5m.useCallback)(function(e, analyticsEvent) {
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    var onClick = (0, $lB4om.usePlatformLeafEventHandler)({
        fn: handleClick,
        action: "clicked",
        componentName: componentName || "Pressable",
        packageName: "@atlaskit/primitives",
        packageVersion: "6.3.0",
        analyticsData: analyticsContext,
        actionSubject: "button"
    });
    // Combine default styles with supplied styles. XCSS does not support deep nested arrays
    var styles = [
        (0, $5BICO.xcss)({
            cursor: isDisabled ? "not-allowed" : "pointer"
        }),
        $64999ac1c84ce5ec$var$focusRingStyles
    ];
    // We're type coercing this as Compiled styles in an array isn't supported by the types
    // But the runtime accepts it none-the-wiser. We can remove this entire block and replace
    // it with cx(defaultStyles, focusRingStyles, xcssStyles) when we've moved away from Emotion.
    styles = Array.isArray(xcssStyles) ? [].concat((0, (/*@__PURE__*/$parcel$interopDefault($lcV3t)))(styles), (0, (/*@__PURE__*/$parcel$interopDefault($lcV3t)))(xcssStyles)) : [].concat((0, (/*@__PURE__*/$parcel$interopDefault($lcV3t)))(styles), [
        xcssStyles
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $8WEMR.default), (0, (/*@__PURE__*/$parcel$interopDefault($bIiWW)))({}, htmlAttributes, {
        as: "button",
        ref: ref,
        testId: testId,
        type: type,
        onClick: onClick,
        backgroundColor: backgroundColor,
        padding: padding,
        paddingBlock: paddingBlock,
        paddingBlockStart: paddingBlockStart,
        paddingBlockEnd: paddingBlockEnd,
        paddingInline: paddingInline,
        paddingInlineStart: paddingInlineStart,
        paddingInlineEnd: paddingInlineEnd,
        xcss: styles,
        disabled: isDisabled
    }), children);
});
var $64999ac1c84ce5ec$export$2e2bcd8739ae039 = $64999ac1c84ce5ec$var$Pressable;

});
parcelRegister("bIiWW", function(module, exports) {
function $887280c8b4651357$var$_extends() {
    return module.exports = $887280c8b4651357$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $887280c8b4651357$var$_extends.apply(null, arguments);
}
module.exports = $887280c8b4651357$var$_extends, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("9EJk3", function(module, exports) {

var $bSCCx = parcelRequire("bSCCx");
function $707b019694caea75$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $bSCCx(e, t);
    if (Object.getOwnPropertySymbols) {
        var s = Object.getOwnPropertySymbols(e);
        for(r = 0; r < s.length; r++)o = s[r], t.includes(o) || ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
module.exports = $707b019694caea75$var$_objectWithoutProperties, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("bSCCx", function(module, exports) {
function $8a62b2131e9b5e9b$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.includes(n)) continue;
        t[n] = r[n];
    }
    return t;
}
module.exports = $8a62b2131e9b5e9b$var$_objectWithoutPropertiesLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("5BICO", function(module, exports) {

$parcel$export(module.exports, "parseXcss", function () { return $4153060c14d7ff9a$export$a9c84988c8f81f2d; });
$parcel$export(module.exports, "xcss", function () { return $4153060c14d7ff9a$export$f6c783d06584602c; });

var $lcV3t = parcelRequire("lcV3t");

var $fjHlV = parcelRequire("fjHlV");

var $axuhP = parcelRequire("axuhP");

var $0kBKE = parcelRequire("0kBKE");

var $jVTBW = parcelRequire("jVTBW");

var $hyLoy = parcelRequire("hyLoy");

var $ahJoN = parcelRequire("ahJoN");
function $4153060c14d7ff9a$var$_createForOfIteratorHelper(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (!it) {
        if (Array.isArray(o) || (it = $4153060c14d7ff9a$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
            if (it) o = it;
            var i = 0;
            var F = function F() {};
            return {
                s: F,
                n: function n() {
                    if (i >= o.length) return {
                        done: true
                    };
                    return {
                        done: false,
                        value: o[i++]
                    };
                },
                e: function e(_e) {
                    throw _e;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var normalCompletion = true, didErr = false, err;
    return {
        s: function s() {
            it = it.call(o);
        },
        n: function n() {
            var step = it.next();
            normalCompletion = step.done;
            return step;
        },
        e: function e(_e2) {
            didErr = true;
            err = _e2;
        },
        f: function f() {
            try {
                if (!normalCompletion && it.return != null) it.return();
            } finally{
                if (didErr) throw err;
            }
        }
    };
}
function $4153060c14d7ff9a$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $4153060c14d7ff9a$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $4153060c14d7ff9a$var$_arrayLikeToArray(o, minLen);
}
function $4153060c14d7ff9a$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $4153060c14d7ff9a$export$9a199fbafee0014e = {
    backgroundColor: (0, $hyLoy.backgroundColorMap),
    blockSize: (0, $hyLoy.dimensionMap),
    borderBlockColor: (0, $hyLoy.borderColorMap),
    borderBlockEndColor: (0, $hyLoy.borderColorMap),
    borderBlockEndWidth: (0, $hyLoy.borderWidthMap),
    borderBlockStartColor: (0, $hyLoy.borderColorMap),
    borderBlockStartWidth: (0, $hyLoy.borderWidthMap),
    borderBlockWidth: (0, $hyLoy.borderWidthMap),
    borderBottomColor: (0, $hyLoy.borderColorMap),
    borderBottomLeftRadius: (0, $hyLoy.borderRadiusMap),
    borderBottomRightRadius: (0, $hyLoy.borderRadiusMap),
    borderBottomWidth: (0, $hyLoy.borderWidthMap),
    borderColor: (0, $hyLoy.borderColorMap),
    borderEndEndRadius: (0, $hyLoy.borderRadiusMap),
    borderEndStartRadius: (0, $hyLoy.borderRadiusMap),
    borderInlineColor: (0, $hyLoy.borderColorMap),
    borderInlineEndColor: (0, $hyLoy.borderColorMap),
    borderInlineEndWidth: (0, $hyLoy.borderWidthMap),
    borderInlineStartColor: (0, $hyLoy.borderColorMap),
    borderInlineStartWidth: (0, $hyLoy.borderWidthMap),
    borderInlineWidth: (0, $hyLoy.borderWidthMap),
    borderLeftColor: (0, $hyLoy.borderColorMap),
    borderLeftWidth: (0, $hyLoy.borderWidthMap),
    borderRadius: (0, $hyLoy.borderRadiusMap),
    borderRightColor: (0, $hyLoy.borderColorMap),
    borderRightWidth: (0, $hyLoy.borderWidthMap),
    borderStartEndRadius: (0, $hyLoy.borderRadiusMap),
    borderStartStartRadius: (0, $hyLoy.borderRadiusMap),
    borderTopColor: (0, $hyLoy.borderColorMap),
    borderTopLeftRadius: (0, $hyLoy.borderRadiusMap),
    borderTopRightRadius: (0, $hyLoy.borderRadiusMap),
    borderTopWidth: (0, $hyLoy.borderWidthMap),
    borderWidth: (0, $hyLoy.borderWidthMap),
    bottom: (0, $hyLoy.allSpaceMap),
    boxShadow: (0, $hyLoy.shadowMap),
    color: (0, $hyLoy.textColorMap),
    columnGap: (0, $hyLoy.positiveSpaceMap),
    gap: (0, $hyLoy.positiveSpaceMap),
    height: (0, $hyLoy.dimensionMap),
    inlineSize: (0, $hyLoy.dimensionMap),
    inset: (0, $hyLoy.allSpaceMap),
    insetBlock: (0, $hyLoy.allSpaceMap),
    insetBlockEnd: (0, $hyLoy.allSpaceMap),
    insetBlockStart: (0, $hyLoy.allSpaceMap),
    insetInline: (0, $hyLoy.allSpaceMap),
    insetInlineEnd: (0, $hyLoy.allSpaceMap),
    insetInlineStart: (0, $hyLoy.allSpaceMap),
    left: (0, $hyLoy.allSpaceMap),
    margin: (0, $hyLoy.allSpaceMap),
    marginBlock: (0, $hyLoy.allSpaceMap),
    marginBlockEnd: (0, $hyLoy.allSpaceMap),
    marginBlockStart: (0, $hyLoy.allSpaceMap),
    marginBottom: (0, $hyLoy.allSpaceMap),
    marginInline: (0, $hyLoy.allSpaceMap),
    marginInlineEnd: (0, $hyLoy.allSpaceMap),
    marginInlineStart: (0, $hyLoy.allSpaceMap),
    marginLeft: (0, $hyLoy.allSpaceMap),
    marginRight: (0, $hyLoy.allSpaceMap),
    marginTop: (0, $hyLoy.allSpaceMap),
    maxBlockSize: (0, $hyLoy.dimensionMap),
    maxHeight: (0, $hyLoy.dimensionMap),
    maxInlineSize: (0, $hyLoy.dimensionMap),
    maxWidth: (0, $hyLoy.dimensionMap),
    minBlockSize: (0, $hyLoy.dimensionMap),
    minHeight: (0, $hyLoy.dimensionMap),
    minInlineSize: (0, $hyLoy.dimensionMap),
    minWidth: (0, $hyLoy.dimensionMap),
    opacity: (0, $hyLoy.opacityMap),
    outlineColor: (0, $hyLoy.borderColorMap),
    outlineOffset: (0, $hyLoy.positiveSpaceMap),
    outlineWidth: (0, $hyLoy.borderWidthMap),
    padding: (0, $hyLoy.positiveSpaceMap),
    paddingBlock: (0, $hyLoy.positiveSpaceMap),
    paddingBlockEnd: (0, $hyLoy.positiveSpaceMap),
    paddingBlockStart: (0, $hyLoy.positiveSpaceMap),
    paddingBottom: (0, $hyLoy.positiveSpaceMap),
    paddingInline: (0, $hyLoy.positiveSpaceMap),
    paddingInlineEnd: (0, $hyLoy.positiveSpaceMap),
    paddingInlineStart: (0, $hyLoy.positiveSpaceMap),
    paddingLeft: (0, $hyLoy.positiveSpaceMap),
    paddingRight: (0, $hyLoy.positiveSpaceMap),
    paddingTop: (0, $hyLoy.positiveSpaceMap),
    right: (0, $hyLoy.allSpaceMap),
    rowGap: (0, $hyLoy.positiveSpaceMap),
    top: (0, $hyLoy.allSpaceMap),
    width: (0, $hyLoy.dimensionMap),
    zIndex: (0, $hyLoy.layerMap)
};
var $4153060c14d7ff9a$var$uniqueSymbol = Symbol("UNSAFE_INTERNAL_styles");
var $4153060c14d7ff9a$var$isSafeEnvToThrow = function isSafeEnvToThrow() {
    return (typeof $ahJoN === "undefined" ? "undefined" : (0, (/*@__PURE__*/$parcel$interopDefault($0kBKE)))($ahJoN)) === "object" && (0, (/*@__PURE__*/$parcel$interopDefault($0kBKE)))($ahJoN.env) === "object" && false;
};
var $4153060c14d7ff9a$var$reNestedSelectors = /(\.|\s|&+|\*\>|#|\[.*\])/;
var $4153060c14d7ff9a$var$safeSelectors = /^@media .*$|^::?.*$|^@supports .*$/;
var $4153060c14d7ff9a$var$transformStyles = function transformStyles(styleObj) {
    if (!styleObj || (0, (/*@__PURE__*/$parcel$interopDefault($0kBKE)))(styleObj) !== "object") return styleObj;
    // If styles are defined as a CSSObject[], recursively call on each element until we reach CSSObject
    if (Array.isArray(styleObj)) return styleObj.map(transformStyles);
    // Modifies styleObj in place. Be careful.
    Object.entries(styleObj).forEach(function(_ref) {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($axuhP)))(_ref, 2), key = _ref2[0], value = _ref2[1];
        // If key is a pseudo class or a pseudo element, then value should be an object.
        // So, call transformStyles on the value
        if ((0, (/*@__PURE__*/$parcel$interopDefault($0kBKE)))(value) === "object" && $4153060c14d7ff9a$var$safeSelectors.test(key)) {
            styleObj[key] = transformStyles(value);
            return;
        }
        if ($4153060c14d7ff9a$var$isSafeEnvToThrow()) {
            // We don't support `.class`, `[data-testid]`, `> *`, `#some-id`
            if ($4153060c14d7ff9a$var$reNestedSelectors.test(key)) throw new Error("Styles not supported for key '".concat(key, "'."));
        }
        // We have now dealt with all the special cases, so,
        // check whether what remains is a style property
        // that can be transformed.
        if (!(key in $4153060c14d7ff9a$export$9a199fbafee0014e)) return;
        var tokenValue = $4153060c14d7ff9a$export$9a199fbafee0014e[key][value];
        styleObj[key] = tokenValue !== null && tokenValue !== void 0 ? tokenValue : value;
    });
    return styleObj;
};
var $4153060c14d7ff9a$var$baseXcss = function baseXcss(style) {
    var transformedStyles = $4153060c14d7ff9a$var$transformStyles(style);
    return (0, (/*@__PURE__*/$parcel$interopDefault($fjHlV)))({}, $4153060c14d7ff9a$var$uniqueSymbol, (0, $jVTBW.css)(transformedStyles));
};
var $4153060c14d7ff9a$export$a9c84988c8f81f2d = function parseXcss(args) {
    if (Array.isArray(args)) {
        var emotion = [];
        var staticArr = [];
        var _iterator = $4153060c14d7ff9a$var$_createForOfIteratorHelper(args), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var arg = _step.value;
                var result = parseXcss(arg);
                if (result.emotion) emotion.push.apply(emotion, (0, (/*@__PURE__*/$parcel$interopDefault($lcV3t)))(result.emotion));
                if (result.static) staticArr.push(result.static);
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        return {
            emotion: emotion,
            static: staticArr.join(" ")
        };
    }
    var objArgs = args;
    var _ref4 = objArgs || {}, styles = _ref4[$4153060c14d7ff9a$var$uniqueSymbol];
    if (styles) return {
        emotion: [
            styles
        ]
    };
    if (args) {
        // We use string interpolation here instead of .toString() just
        // in case the resulting object doesn't have the method available.
        var stringifiedArgs = "".concat(args);
        if (stringifiedArgs) return {
            static: stringifiedArgs
        };
    }
    return {};
};
function $4153060c14d7ff9a$export$f6c783d06584602c(style) {
    return $4153060c14d7ff9a$var$baseXcss(style);
}

});
parcelRegister("hyLoy", function(module, exports) {

$parcel$export(module.exports, "dimensionMap", function () { return $cc8a6054a629f7de$export$6ccdbebca2ee545f; });
$parcel$export(module.exports, "positiveSpaceMap", function () { return $cc8a6054a629f7de$export$958d0ae7f2977ae4; });
$parcel$export(module.exports, "allSpaceMap", function () { return $cc8a6054a629f7de$export$632685d741f3dbbf; });
$parcel$export(module.exports, "opacityMap", function () { return $cc8a6054a629f7de$export$daf94a976c798b4f; });
$parcel$export(module.exports, "shadowMap", function () { return $cc8a6054a629f7de$export$7aff6e7ba39bb774; });
$parcel$export(module.exports, "borderColorMap", function () { return $cc8a6054a629f7de$export$1531ad5bb3fbedac; });
$parcel$export(module.exports, "backgroundColorMap", function () { return $cc8a6054a629f7de$export$d1d79bf68ac056bd; });
$parcel$export(module.exports, "textColorMap", function () { return $cc8a6054a629f7de$export$8473307aa00d6ea1; });
$parcel$export(module.exports, "layerMap", function () { return $cc8a6054a629f7de$export$b5f31a7e431d2eab; });
$parcel$export(module.exports, "borderWidthMap", function () { return $cc8a6054a629f7de$export$e1b83c5210c471b8; });
$parcel$export(module.exports, "borderRadiusMap", function () { return $cc8a6054a629f7de$export$3c0a6c3e64bb180d; });
$parcel$export(module.exports, "paddingStylesMap", function () { return $cc8a6054a629f7de$export$e615f061ca585a6c; });
$parcel$export(module.exports, "backgroundColorStylesMap", function () { return $cc8a6054a629f7de$export$e7af83bafe7f9e63; });
$parcel$export(module.exports, "surfaceColorStylesMap", function () { return $cc8a6054a629f7de$export$ff257d957d48c421; });
$parcel$export(module.exports, "isSurfaceColorToken", function () { return $cc8a6054a629f7de$export$5e65a44e5b6ecadb; });

var $fjHlV = parcelRequire("fjHlV");

var $jVTBW = parcelRequire("jVTBW");

var $93Bl8 = parcelRequire("93Bl8");
function $cc8a6054a629f7de$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $cc8a6054a629f7de$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $cc8a6054a629f7de$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($fjHlV)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $cc8a6054a629f7de$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $cc8a6054a629f7de$export$6ccdbebca2ee545f = {
    "100%": "100%",
    "size.100": "1rem",
    "size.200": "1.5rem",
    "size.300": "2rem",
    "size.400": "2.5rem",
    "size.500": "3rem",
    "size.600": "6rem",
    "size.1000": "12rem"
};
var $cc8a6054a629f7de$export$958d0ae7f2977ae4 = {
    "space.0": "var(--ds-space-0, 0px)",
    "space.025": "var(--ds-space-025, 2px)",
    "space.050": "var(--ds-space-050, 4px)",
    "space.075": "var(--ds-space-075, 6px)",
    "space.100": "var(--ds-space-100, 8px)",
    "space.150": "var(--ds-space-150, 12px)",
    "space.200": "var(--ds-space-200, 16px)",
    "space.250": "var(--ds-space-250, 20px)",
    "space.300": "var(--ds-space-300, 24px)",
    "space.400": "var(--ds-space-400, 32px)",
    "space.500": "var(--ds-space-500, 40px)",
    "space.600": "var(--ds-space-600, 48px)",
    "space.800": "var(--ds-space-800, 64px)",
    "space.1000": "var(--ds-space-1000, 80px)"
};
var $cc8a6054a629f7de$export$d2dc61f58390201c = {
    "space.negative.025": "var(--ds-space-negative-025, -2px)",
    "space.negative.050": "var(--ds-space-negative-050, -4px)",
    "space.negative.075": "var(--ds-space-negative-075, -6px)",
    "space.negative.100": "var(--ds-space-negative-100, -8px)",
    "space.negative.150": "var(--ds-space-negative-150, -12px)",
    "space.negative.200": "var(--ds-space-negative-200, -16px)",
    "space.negative.250": "var(--ds-space-negative-250, -20px)",
    "space.negative.300": "var(--ds-space-negative-300, -24px)",
    "space.negative.400": "var(--ds-space-negative-400, -32px)"
};
var $cc8a6054a629f7de$export$632685d741f3dbbf = $cc8a6054a629f7de$var$_objectSpread($cc8a6054a629f7de$var$_objectSpread({}, $cc8a6054a629f7de$export$958d0ae7f2977ae4), $cc8a6054a629f7de$export$d2dc61f58390201c);
var $cc8a6054a629f7de$export$2185ce37f9bdd963 = {
    "color.background.neutral.bold": "color.text.inverse",
    "color.background.neutral.bold.hovered": "color.text.inverse",
    "color.background.neutral.bold.pressed": "color.text.inverse",
    "color.background.selected.bold": "color.text.inverse",
    "color.background.selected.bold.hovered": "color.text.inverse",
    "color.background.selected.bold.pressed": "color.text.inverse",
    "color.background.brand.bold": "color.text.inverse",
    "color.background.brand.bold.hovered": "color.text.inverse",
    "color.background.brand.bold.pressed": "color.text.inverse",
    "color.background.brand.boldest": "color.text.inverse",
    "color.background.brand.boldest.hovered": "color.text.inverse",
    "color.background.brand.boldest.pressed": "color.text.inverse",
    "color.background.danger.bold": "color.text.inverse",
    "color.background.danger.bold.hovered": "color.text.inverse",
    "color.background.danger.bold.pressed": "color.text.inverse",
    "color.background.warning.bold": "color.text.warning.inverse",
    "color.background.warning.bold.hovered": "color.text.warning.inverse",
    "color.background.warning.bold.pressed": "color.text.warning.inverse",
    "color.background.success.bold": "color.text.inverse",
    "color.background.success.bold.hovered": "color.text.inverse",
    "color.background.success.bold.pressed": "color.text.inverse",
    "color.background.discovery.bold": "color.text.inverse",
    "color.background.discovery.bold.hovered": "color.text.inverse",
    "color.background.discovery.bold.pressed": "color.text.inverse",
    "color.background.information.bold": "color.text.inverse",
    "color.background.information.bold.hovered": "color.text.inverse",
    "color.background.information.bold.pressed": "color.text.inverse"
};
var $cc8a6054a629f7de$export$daf94a976c798b4f = {
    "opacity.disabled": "var(--ds-opacity-disabled, 0.4)",
    "opacity.loading": "var(--ds-opacity-loading, 0.2)"
};
var $cc8a6054a629f7de$export$7aff6e7ba39bb774 = {
    "elevation.shadow.overflow": "var(--ds-shadow-overflow, 0px 0px 8px #091e423f, 0px 0px 1px #091e424f)",
    "elevation.shadow.overflow.perimeter": "var(--ds-shadow-overflow-perimeter, #091e421f)",
    "elevation.shadow.overflow.spread": "var(--ds-shadow-overflow-spread, #091e4229)",
    "elevation.shadow.overlay": "var(--ds-shadow-overlay, 0px 8px 12px #091e423f, 0px 0px 1px #091e424f)",
    "elevation.shadow.raised": "var(--ds-shadow-raised, 0px 1px 1px #091e423f, 0px 0px 1px #091e4221)"
};
var $cc8a6054a629f7de$export$41a358c9c2356760 = {
    "elevation.surface": "var(--ds-surface, #FFFFFF)",
    "elevation.surface.hovered": "var(--ds-surface-hovered, #FAFBFC)",
    "elevation.surface.pressed": "var(--ds-surface-pressed, #F4F5F7)",
    "elevation.surface.overlay": "var(--ds-surface-overlay, #FFFFFF)",
    "elevation.surface.overlay.hovered": "var(--ds-surface-overlay-hovered, #FAFBFC)",
    "elevation.surface.overlay.pressed": "var(--ds-surface-overlay-pressed, #F4F5F7)",
    "elevation.surface.raised": "var(--ds-surface-raised, #FFFFFF)",
    "elevation.surface.raised.hovered": "var(--ds-surface-raised-hovered, #FAFBFC)",
    "elevation.surface.raised.pressed": "var(--ds-surface-raised-pressed, #F4F5F7)",
    "elevation.surface.sunken": "var(--ds-surface-sunken, #F4F5F7)"
};
var $cc8a6054a629f7de$export$1531ad5bb3fbedac = {
    "color.border": "var(--ds-border, #091e4221)",
    "color.border.accent.lime": "var(--ds-border-accent-lime, #6A9A23)",
    "color.border.accent.red": "var(--ds-border-accent-red, #FF5630)",
    "color.border.accent.orange": "var(--ds-border-accent-orange, #D94008)",
    "color.border.accent.yellow": "var(--ds-border-accent-yellow, #FFAB00)",
    "color.border.accent.green": "var(--ds-border-accent-green, #36B37E)",
    "color.border.accent.teal": "var(--ds-border-accent-teal, #00B8D9)",
    "color.border.accent.blue": "var(--ds-border-accent-blue, #0065FF)",
    "color.border.accent.purple": "var(--ds-border-accent-purple, #6554C0)",
    "color.border.accent.magenta": "var(--ds-border-accent-magenta, #CD519D)",
    "color.border.accent.gray": "var(--ds-border-accent-gray, #5E6C84)",
    "color.border.disabled": "var(--ds-border-disabled, #FAFBFC)",
    "color.border.focused": "var(--ds-border-focused, #2684FF)",
    "color.border.input": "var(--ds-border-input, #FAFBFC)",
    "color.border.inverse": "var(--ds-border-inverse, #FFFFFF)",
    "color.border.selected": "var(--ds-border-selected, #0052CC)",
    "color.border.brand": "var(--ds-border-brand, #0052CC)",
    "color.border.danger": "var(--ds-border-danger, #FF5630)",
    "color.border.warning": "var(--ds-border-warning, #FFC400)",
    "color.border.success": "var(--ds-border-success, #00875A)",
    "color.border.discovery": "var(--ds-border-discovery, #998DD9)",
    "color.border.information": "var(--ds-border-information, #0065FF)",
    "color.border.bold": "var(--ds-border-bold, #344563)"
};
var $cc8a6054a629f7de$export$d1d79bf68ac056bd = {
    "color.background.accent.lime.subtlest": "var(--ds-background-accent-lime-subtlest, #EEFBDA)",
    "color.background.accent.lime.subtlest.hovered": "var(--ds-background-accent-lime-subtlest-hovered, #D3F1A7)",
    "color.background.accent.lime.subtlest.pressed": "var(--ds-background-accent-lime-subtlest-pressed, #B3DF72)",
    "color.background.accent.lime.subtler": "var(--ds-background-accent-lime-subtler, #D3F1A7)",
    "color.background.accent.lime.subtler.hovered": "var(--ds-background-accent-lime-subtler-hovered, #B3DF72)",
    "color.background.accent.lime.subtler.pressed": "var(--ds-background-accent-lime-subtler-pressed, #94C748)",
    "color.background.accent.lime.subtle": "var(--ds-background-accent-lime-subtle, #94C748)",
    "color.background.accent.lime.subtle.hovered": "var(--ds-background-accent-lime-subtle-hovered, #B3DF72)",
    "color.background.accent.lime.subtle.pressed": "var(--ds-background-accent-lime-subtle-pressed, #D3F1A7)",
    "color.background.accent.lime.bolder": "var(--ds-background-accent-lime-bolder, #5B7F24)",
    "color.background.accent.lime.bolder.hovered": "var(--ds-background-accent-lime-bolder-hovered, #37471F)",
    "color.background.accent.lime.bolder.pressed": "var(--ds-background-accent-lime-bolder-pressed, #37471F)",
    "color.background.accent.red.subtlest": "var(--ds-background-accent-red-subtlest, #FF8F73)",
    "color.background.accent.red.subtlest.hovered": "var(--ds-background-accent-red-subtlest-hovered, #FF7452)",
    "color.background.accent.red.subtlest.pressed": "var(--ds-background-accent-red-subtlest-pressed, #FF5630)",
    "color.background.accent.red.subtler": "var(--ds-background-accent-red-subtler, #FF7452)",
    "color.background.accent.red.subtler.hovered": "var(--ds-background-accent-red-subtler-hovered, #FF5630)",
    "color.background.accent.red.subtler.pressed": "var(--ds-background-accent-red-subtler-pressed, #DE350B)",
    "color.background.accent.red.subtle": "var(--ds-background-accent-red-subtle, #DE350B)",
    "color.background.accent.red.subtle.hovered": "var(--ds-background-accent-red-subtle-hovered, #FF5630)",
    "color.background.accent.red.subtle.pressed": "var(--ds-background-accent-red-subtle-pressed, #FF7452)",
    "color.background.accent.red.bolder": "var(--ds-background-accent-red-bolder, #DE350B)",
    "color.background.accent.red.bolder.hovered": "var(--ds-background-accent-red-bolder-hovered, #FF5630)",
    "color.background.accent.red.bolder.pressed": "var(--ds-background-accent-red-bolder-pressed, #FF7452)",
    "color.background.accent.orange.subtlest": "var(--ds-background-accent-orange-subtlest, #F18D13)",
    "color.background.accent.orange.subtlest.hovered": "var(--ds-background-accent-orange-subtlest-hovered, #FEC57B)",
    "color.background.accent.orange.subtlest.pressed": "var(--ds-background-accent-orange-subtlest-pressed, #FFE2BD)",
    "color.background.accent.orange.subtler": "var(--ds-background-accent-orange-subtler, #B65C02)",
    "color.background.accent.orange.subtler.hovered": "var(--ds-background-accent-orange-subtler-hovered, #F18D13)",
    "color.background.accent.orange.subtler.pressed": "var(--ds-background-accent-orange-subtler-pressed, #FEC57B)",
    "color.background.accent.orange.subtle": "var(--ds-background-accent-orange-subtle, #5F3811)",
    "color.background.accent.orange.subtle.hovered": "var(--ds-background-accent-orange-subtle-hovered, #974F0C)",
    "color.background.accent.orange.subtle.pressed": "var(--ds-background-accent-orange-subtle-pressed, #B65C02)",
    "color.background.accent.orange.bolder": "var(--ds-background-accent-orange-bolder, #43290F)",
    "color.background.accent.orange.bolder.hovered": "var(--ds-background-accent-orange-bolder-hovered, #5F3811)",
    "color.background.accent.orange.bolder.pressed": "var(--ds-background-accent-orange-bolder-pressed, #974F0C)",
    "color.background.accent.yellow.subtlest": "var(--ds-background-accent-yellow-subtlest, #FFE380)",
    "color.background.accent.yellow.subtlest.hovered": "var(--ds-background-accent-yellow-subtlest-hovered, #FFC400)",
    "color.background.accent.yellow.subtlest.pressed": "var(--ds-background-accent-yellow-subtlest-pressed, #FFAB00)",
    "color.background.accent.yellow.subtler": "var(--ds-background-accent-yellow-subtler, #FFC400)",
    "color.background.accent.yellow.subtler.hovered": "var(--ds-background-accent-yellow-subtler-hovered, #FFAB00)",
    "color.background.accent.yellow.subtler.pressed": "var(--ds-background-accent-yellow-subtler-pressed, #FF991F)",
    "color.background.accent.yellow.subtle": "var(--ds-background-accent-yellow-subtle, #FF991F)",
    "color.background.accent.yellow.subtle.hovered": "var(--ds-background-accent-yellow-subtle-hovered, #FFAB00)",
    "color.background.accent.yellow.subtle.pressed": "var(--ds-background-accent-yellow-subtle-pressed, #FFC400)",
    "color.background.accent.yellow.bolder": "var(--ds-background-accent-yellow-bolder, #FF991F)",
    "color.background.accent.yellow.bolder.hovered": "var(--ds-background-accent-yellow-bolder-hovered, #FFAB00)",
    "color.background.accent.yellow.bolder.pressed": "var(--ds-background-accent-yellow-bolder-pressed, #FFC400)",
    "color.background.accent.green.subtlest": "var(--ds-background-accent-green-subtlest, #79F2C0)",
    "color.background.accent.green.subtlest.hovered": "var(--ds-background-accent-green-subtlest-hovered, #57D9A3)",
    "color.background.accent.green.subtlest.pressed": "var(--ds-background-accent-green-subtlest-pressed, #36B37E)",
    "color.background.accent.green.subtler": "var(--ds-background-accent-green-subtler, #57D9A3)",
    "color.background.accent.green.subtler.hovered": "var(--ds-background-accent-green-subtler-hovered, #36B37E)",
    "color.background.accent.green.subtler.pressed": "var(--ds-background-accent-green-subtler-pressed, #00875A)",
    "color.background.accent.green.subtle": "var(--ds-background-accent-green-subtle, #00875A)",
    "color.background.accent.green.subtle.hovered": "var(--ds-background-accent-green-subtle-hovered, #36B37E)",
    "color.background.accent.green.subtle.pressed": "var(--ds-background-accent-green-subtle-pressed, #57D9A3)",
    "color.background.accent.green.bolder": "var(--ds-background-accent-green-bolder, #00875A)",
    "color.background.accent.green.bolder.hovered": "var(--ds-background-accent-green-bolder-hovered, #36B37E)",
    "color.background.accent.green.bolder.pressed": "var(--ds-background-accent-green-bolder-pressed, #57D9A3)",
    "color.background.accent.teal.subtlest": "var(--ds-background-accent-teal-subtlest, #79E2F2)",
    "color.background.accent.teal.subtlest.hovered": "var(--ds-background-accent-teal-subtlest-hovered, #00C7E6)",
    "color.background.accent.teal.subtlest.pressed": "var(--ds-background-accent-teal-subtlest-pressed, #00B8D9)",
    "color.background.accent.teal.subtler": "var(--ds-background-accent-teal-subtler, #00C7E6)",
    "color.background.accent.teal.subtler.hovered": "var(--ds-background-accent-teal-subtler-hovered, #00B8D9)",
    "color.background.accent.teal.subtler.pressed": "var(--ds-background-accent-teal-subtler-pressed, #00A3BF)",
    "color.background.accent.teal.subtle": "var(--ds-background-accent-teal-subtle, #00A3BF)",
    "color.background.accent.teal.subtle.hovered": "var(--ds-background-accent-teal-subtle-hovered, #00B8D9)",
    "color.background.accent.teal.subtle.pressed": "var(--ds-background-accent-teal-subtle-pressed, #00C7E6)",
    "color.background.accent.teal.bolder": "var(--ds-background-accent-teal-bolder, #00A3BF)",
    "color.background.accent.teal.bolder.hovered": "var(--ds-background-accent-teal-bolder-hovered, #00B8D9)",
    "color.background.accent.teal.bolder.pressed": "var(--ds-background-accent-teal-bolder-pressed, #00C7E6)",
    "color.background.accent.blue.subtlest": "var(--ds-background-accent-blue-subtlest, #4C9AFF)",
    "color.background.accent.blue.subtlest.hovered": "var(--ds-background-accent-blue-subtlest-hovered, #2684FF)",
    "color.background.accent.blue.subtlest.pressed": "var(--ds-background-accent-blue-subtlest-pressed, #0065FF)",
    "color.background.accent.blue.subtler": "var(--ds-background-accent-blue-subtler, #2684FF)",
    "color.background.accent.blue.subtler.hovered": "var(--ds-background-accent-blue-subtler-hovered, #0065FF)",
    "color.background.accent.blue.subtler.pressed": "var(--ds-background-accent-blue-subtler-pressed, #0052CC)",
    "color.background.accent.blue.subtle": "var(--ds-background-accent-blue-subtle, #0052CC)",
    "color.background.accent.blue.subtle.hovered": "var(--ds-background-accent-blue-subtle-hovered, #0065FF)",
    "color.background.accent.blue.subtle.pressed": "var(--ds-background-accent-blue-subtle-pressed, #2684FF)",
    "color.background.accent.blue.bolder": "var(--ds-background-accent-blue-bolder, #0052CC)",
    "color.background.accent.blue.bolder.hovered": "var(--ds-background-accent-blue-bolder-hovered, #0065FF)",
    "color.background.accent.blue.bolder.pressed": "var(--ds-background-accent-blue-bolder-pressed, #2684FF)",
    "color.background.accent.purple.subtlest": "var(--ds-background-accent-purple-subtlest, #998DD9)",
    "color.background.accent.purple.subtlest.hovered": "var(--ds-background-accent-purple-subtlest-hovered, #8777D9)",
    "color.background.accent.purple.subtlest.pressed": "var(--ds-background-accent-purple-subtlest-pressed, #6554C0)",
    "color.background.accent.purple.subtler": "var(--ds-background-accent-purple-subtler, #8777D9)",
    "color.background.accent.purple.subtler.hovered": "var(--ds-background-accent-purple-subtler-hovered, #6554C0)",
    "color.background.accent.purple.subtler.pressed": "var(--ds-background-accent-purple-subtler-pressed, #5243AA)",
    "color.background.accent.purple.subtle": "var(--ds-background-accent-purple-subtle, #5243AA)",
    "color.background.accent.purple.subtle.hovered": "var(--ds-background-accent-purple-subtle-hovered, #6554C0)",
    "color.background.accent.purple.subtle.pressed": "var(--ds-background-accent-purple-subtle-pressed, #8777D9)",
    "color.background.accent.purple.bolder": "var(--ds-background-accent-purple-bolder, #5243AA)",
    "color.background.accent.purple.bolder.hovered": "var(--ds-background-accent-purple-bolder-hovered, #6554C0)",
    "color.background.accent.purple.bolder.pressed": "var(--ds-background-accent-purple-bolder-pressed, #8777D9)",
    "color.background.accent.magenta.subtlest": "var(--ds-background-accent-magenta-subtlest, #FFECF8)",
    "color.background.accent.magenta.subtlest.hovered": "var(--ds-background-accent-magenta-subtlest-hovered, #FDD0EC)",
    "color.background.accent.magenta.subtlest.pressed": "var(--ds-background-accent-magenta-subtlest-pressed, #F797D2)",
    "color.background.accent.magenta.subtler": "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
    "color.background.accent.magenta.subtler.hovered": "var(--ds-background-accent-magenta-subtler-hovered, #F797D2)",
    "color.background.accent.magenta.subtler.pressed": "var(--ds-background-accent-magenta-subtler-pressed, #E774BB)",
    "color.background.accent.magenta.subtle": "var(--ds-background-accent-magenta-subtle, #E774BB)",
    "color.background.accent.magenta.subtle.hovered": "var(--ds-background-accent-magenta-subtle-hovered, #F797D2)",
    "color.background.accent.magenta.subtle.pressed": "var(--ds-background-accent-magenta-subtle-pressed, #FDD0EC)",
    "color.background.accent.magenta.bolder": "var(--ds-background-accent-magenta-bolder, #AE4787)",
    "color.background.accent.magenta.bolder.hovered": "var(--ds-background-accent-magenta-bolder-hovered, #943D73)",
    "color.background.accent.magenta.bolder.pressed": "var(--ds-background-accent-magenta-bolder-pressed, #50253F)",
    "color.background.accent.gray.subtlest": "var(--ds-background-accent-gray-subtlest, #6B778C)",
    "color.background.accent.gray.subtlest.hovered": "var(--ds-background-accent-gray-subtlest-hovered, #5E6C84)",
    "color.background.accent.gray.subtlest.pressed": "var(--ds-background-accent-gray-subtlest-pressed, #505F79)",
    "color.background.accent.gray.subtler": "var(--ds-background-accent-gray-subtler, #5E6C84)",
    "color.background.accent.gray.subtler.hovered": "var(--ds-background-accent-gray-subtler-hovered, #505F79)",
    "color.background.accent.gray.subtler.pressed": "var(--ds-background-accent-gray-subtler-pressed, #42526E)",
    "color.background.accent.gray.subtle": "var(--ds-background-accent-gray-subtle, #505F79)",
    "color.background.accent.gray.subtle.hovered": "var(--ds-background-accent-gray-subtle-hovered, #5E6C84)",
    "color.background.accent.gray.subtle.pressed": "var(--ds-background-accent-gray-subtle-pressed, #6B778C)",
    "color.background.accent.gray.bolder": "var(--ds-background-accent-gray-bolder, #42526E)",
    "color.background.accent.gray.bolder.hovered": "var(--ds-background-accent-gray-bolder-hovered, #344563)",
    "color.background.accent.gray.bolder.pressed": "var(--ds-background-accent-gray-bolder-pressed, #253858)",
    "color.background.disabled": "var(--ds-background-disabled, #091e4289)",
    "color.background.input": "var(--ds-background-input, #FAFBFC)",
    "color.background.input.hovered": "var(--ds-background-input-hovered, #EBECF0)",
    "color.background.input.pressed": "var(--ds-background-input-pressed, #FFFFFF)",
    "color.background.inverse.subtle": "var(--ds-background-inverse-subtle, #00000029)",
    "color.background.inverse.subtle.hovered": "var(--ds-background-inverse-subtle-hovered, #0000003D)",
    "color.background.inverse.subtle.pressed": "var(--ds-background-inverse-subtle-pressed, #00000052)",
    "color.background.neutral": "var(--ds-background-neutral, #DFE1E6)",
    "color.background.neutral.hovered": "var(--ds-background-neutral-hovered, #091e4214)",
    "color.background.neutral.pressed": "var(--ds-background-neutral-pressed, #B3D4FF)",
    "color.background.neutral.subtle": "var(--ds-background-neutral-subtle, transparent)",
    "color.background.neutral.subtle.hovered": "var(--ds-background-neutral-subtle-hovered, #091e4214)",
    "color.background.neutral.subtle.pressed": "var(--ds-background-neutral-subtle-pressed, #B3D4FF)",
    "color.background.neutral.bold": "var(--ds-background-neutral-bold, #42526E)",
    "color.background.neutral.bold.hovered": "var(--ds-background-neutral-bold-hovered, #505F79)",
    "color.background.neutral.bold.pressed": "var(--ds-background-neutral-bold-pressed, #344563)",
    "color.background.selected": "var(--ds-background-selected, #DEEBFF)",
    "color.background.selected.hovered": "var(--ds-background-selected-hovered, #B3D4FF)",
    "color.background.selected.pressed": "var(--ds-background-selected-pressed, #4C9AFF)",
    "color.background.selected.bold": "var(--ds-background-selected-bold, #0052CC)",
    "color.background.selected.bold.hovered": "var(--ds-background-selected-bold-hovered, #2684FF)",
    "color.background.selected.bold.pressed": "var(--ds-background-selected-bold-pressed, #0052CC)",
    "color.background.brand.subtlest": "var(--ds-background-brand-subtlest, #B3D4FF)",
    "color.background.brand.subtlest.hovered": "var(--ds-background-brand-subtlest-hovered, #DEEBFF)",
    "color.background.brand.subtlest.pressed": "var(--ds-background-brand-subtlest-pressed, #4C9AFF)",
    "color.background.brand.bold": "var(--ds-background-brand-bold, #0052CC)",
    "color.background.brand.bold.hovered": "var(--ds-background-brand-bold-hovered, #0065FF)",
    "color.background.brand.bold.pressed": "var(--ds-background-brand-bold-pressed, #0747A6)",
    "color.background.brand.boldest": "var(--ds-background-brand-boldest, #0747A6)",
    "color.background.brand.boldest.hovered": "var(--ds-background-brand-boldest-hovered, #0052CC)",
    "color.background.brand.boldest.pressed": "var(--ds-background-brand-boldest-pressed, #0747A6)",
    "color.background.danger": "var(--ds-background-danger, #FFEBE6)",
    "color.background.danger.hovered": "var(--ds-background-danger-hovered, #FFBDAD)",
    "color.background.danger.pressed": "var(--ds-background-danger-pressed, #FF8F73)",
    "color.background.danger.bold": "var(--ds-background-danger-bold, #DE350B)",
    "color.background.danger.bold.hovered": "var(--ds-background-danger-bold-hovered, #FF5630)",
    "color.background.danger.bold.pressed": "var(--ds-background-danger-bold-pressed, #BF2600)",
    "color.background.warning": "var(--ds-background-warning, #FFFAE6)",
    "color.background.warning.hovered": "var(--ds-background-warning-hovered, #FFF0B3)",
    "color.background.warning.pressed": "var(--ds-background-warning-pressed, #FFE380)",
    "color.background.warning.bold": "var(--ds-background-warning-bold, #FFAB00)",
    "color.background.warning.bold.hovered": "var(--ds-background-warning-bold-hovered, #FFC400)",
    "color.background.warning.bold.pressed": "var(--ds-background-warning-bold-pressed, #FF991F)",
    "color.background.success": "var(--ds-background-success, #E3FCEF)",
    "color.background.success.hovered": "var(--ds-background-success-hovered, #ABF5D1)",
    "color.background.success.pressed": "var(--ds-background-success-pressed, #79F2C0)",
    "color.background.success.bold": "var(--ds-background-success-bold, #00875A)",
    "color.background.success.bold.hovered": "var(--ds-background-success-bold-hovered, #57D9A3)",
    "color.background.success.bold.pressed": "var(--ds-background-success-bold-pressed, #00875A)",
    "color.background.discovery": "var(--ds-background-discovery, #EAE6FF)",
    "color.background.discovery.hovered": "var(--ds-background-discovery-hovered, #C0B6F2)",
    "color.background.discovery.pressed": "var(--ds-background-discovery-pressed, #998DD9)",
    "color.background.discovery.bold": "var(--ds-background-discovery-bold, #5243AA)",
    "color.background.discovery.bold.hovered": "var(--ds-background-discovery-bold-hovered, #8777D9)",
    "color.background.discovery.bold.pressed": "var(--ds-background-discovery-bold-pressed, #5243AA)",
    "color.background.information": "var(--ds-background-information, #DEEBFF)",
    "color.background.information.hovered": "var(--ds-background-information-hovered, #B3D4FF)",
    "color.background.information.pressed": "var(--ds-background-information-pressed, #4C9AFF)",
    "color.background.information.bold": "var(--ds-background-information-bold, #0052CC)",
    "color.background.information.bold.hovered": "var(--ds-background-information-bold-hovered, #2684FF)",
    "color.background.information.bold.pressed": "var(--ds-background-information-bold-pressed, #0052CC)",
    "color.blanket": "var(--ds-blanket, #091e4289)",
    "color.blanket.selected": "var(--ds-blanket-selected, #388BFF14)",
    "color.blanket.danger": "var(--ds-blanket-danger, #EF5C4814)",
    "elevation.surface": "var(--ds-surface, #FFFFFF)",
    "elevation.surface.hovered": "var(--ds-surface-hovered, #FAFBFC)",
    "elevation.surface.pressed": "var(--ds-surface-pressed, #F4F5F7)",
    "elevation.surface.overlay": "var(--ds-surface-overlay, #FFFFFF)",
    "elevation.surface.overlay.hovered": "var(--ds-surface-overlay-hovered, #FAFBFC)",
    "elevation.surface.overlay.pressed": "var(--ds-surface-overlay-pressed, #F4F5F7)",
    "elevation.surface.raised": "var(--ds-surface-raised, #FFFFFF)",
    "elevation.surface.raised.hovered": "var(--ds-surface-raised-hovered, #FAFBFC)",
    "elevation.surface.raised.pressed": "var(--ds-surface-raised-pressed, #F4F5F7)",
    "elevation.surface.sunken": "var(--ds-surface-sunken, #F4F5F7)",
    "utility.elevation.surface.current": "var(--ds-elevation-surface-current, #FFFFFF)"
};
var $cc8a6054a629f7de$export$8473307aa00d6ea1 = {
    "color.text": "var(--ds-text, #172B4D)",
    "color.text.accent.lime": "var(--ds-text-accent-lime, #4C6B1F)",
    "color.text.accent.lime.bolder": "var(--ds-text-accent-lime-bolder, #37471F)",
    "color.text.accent.red": "var(--ds-text-accent-red, #DE350B)",
    "color.text.accent.red.bolder": "var(--ds-text-accent-red-bolder, #BF2600)",
    "color.text.accent.orange": "var(--ds-text-accent-orange, #F18D13)",
    "color.text.accent.orange.bolder": "var(--ds-text-accent-orange-bolder, #B65C02)",
    "color.text.accent.yellow": "var(--ds-text-accent-yellow, #FF991F)",
    "color.text.accent.yellow.bolder": "var(--ds-text-accent-yellow-bolder, #FF8B00)",
    "color.text.accent.green": "var(--ds-text-accent-green, #00875A)",
    "color.text.accent.green.bolder": "var(--ds-text-accent-green-bolder, #006644)",
    "color.text.accent.teal": "var(--ds-text-accent-teal, #00A3BF)",
    "color.text.accent.teal.bolder": "var(--ds-text-accent-teal-bolder, #008DA6)",
    "color.text.accent.blue": "var(--ds-text-accent-blue, #0052CC)",
    "color.text.accent.blue.bolder": "var(--ds-text-accent-blue-bolder, #0747A6)",
    "color.text.accent.purple": "var(--ds-text-accent-purple, #5243AA)",
    "color.text.accent.purple.bolder": "var(--ds-text-accent-purple-bolder, #403294)",
    "color.text.accent.magenta": "var(--ds-text-accent-magenta, #E774BB)",
    "color.text.accent.magenta.bolder": "var(--ds-text-accent-magenta-bolder, #DA62AC)",
    "color.text.accent.gray": "var(--ds-text-accent-gray, #505F79)",
    "color.text.accent.gray.bolder": "var(--ds-text-accent-gray-bolder, #172B4D)",
    "color.text.disabled": "var(--ds-text-disabled, #A5ADBA)",
    "color.text.inverse": "var(--ds-text-inverse, #FFFFFF)",
    "color.text.selected": "var(--ds-text-selected, #0052CC)",
    "color.text.brand": "var(--ds-text-brand, #0065FF)",
    "color.text.danger": "var(--ds-text-danger, #DE350B)",
    "color.text.warning": "var(--ds-text-warning, #974F0C)",
    "color.text.warning.inverse": "var(--ds-text-warning-inverse, #172B4D)",
    "color.text.success": "var(--ds-text-success, #006644)",
    "color.text.discovery": "var(--ds-text-discovery, #403294)",
    "color.text.information": "var(--ds-text-information, #0052CC)",
    "color.text.subtlest": "var(--ds-text-subtlest, #7A869A)",
    "color.text.subtle": "var(--ds-text-subtle, #42526E)",
    "color.link": "var(--ds-link, #0052CC)",
    "color.link.pressed": "var(--ds-link-pressed, #0747A6)",
    "color.link.visited": "var(--ds-link-visited, #403294)",
    "color.link.visited.pressed": "var(--ds-link-visited-pressed, #403294)"
};
var $cc8a6054a629f7de$export$498780f74be9af68 = {
    "color.icon": "var(--ds-icon, #505F79)",
    "color.icon.accent.lime": "var(--ds-icon-accent-lime, #6A9A23)",
    "color.icon.accent.red": "var(--ds-icon-accent-red, #FF5630)",
    "color.icon.accent.orange": "var(--ds-icon-accent-orange, #D94008)",
    "color.icon.accent.yellow": "var(--ds-icon-accent-yellow, #FFAB00)",
    "color.icon.accent.green": "var(--ds-icon-accent-green, #36B37E)",
    "color.icon.accent.teal": "var(--ds-icon-accent-teal, #00B8D9)",
    "color.icon.accent.blue": "var(--ds-icon-accent-blue, #0065FF)",
    "color.icon.accent.purple": "var(--ds-icon-accent-purple, #6554C0)",
    "color.icon.accent.magenta": "var(--ds-icon-accent-magenta, #CD519D)",
    "color.icon.accent.gray": "var(--ds-icon-accent-gray, #5E6C84)",
    "color.icon.disabled": "var(--ds-icon-disabled, #8993A4)",
    "color.icon.inverse": "var(--ds-icon-inverse, #FFFFFF)",
    "color.icon.selected": "var(--ds-icon-selected, #0052CC)",
    "color.icon.brand": "var(--ds-icon-brand, #0065FF)",
    "color.icon.danger": "var(--ds-icon-danger, #DE350B)",
    "color.icon.warning": "var(--ds-icon-warning, #FFC400)",
    "color.icon.warning.inverse": "var(--ds-icon-warning-inverse, #253858)",
    "color.icon.success": "var(--ds-icon-success, #00875A)",
    "color.icon.discovery": "var(--ds-icon-discovery, #8777D9)",
    "color.icon.information": "var(--ds-icon-information, #0747A6)",
    "color.icon.subtle": "var(--ds-icon-subtle, #6B778C)"
};
var $cc8a6054a629f7de$export$b5f31a7e431d2eab = {
    card: 100,
    navigation: 200,
    dialog: 300,
    layer: 400,
    blanket: 500,
    modal: 510,
    flag: 600,
    spotlight: 700,
    tooltip: 800
};
var $cc8a6054a629f7de$export$e1b83c5210c471b8 = {
    "border.width": "var(--ds-border-width, 1px)",
    "border.width.0": "var(--ds-border-width-0, 0px)",
    "border.width.indicator": "var(--ds-border-width-indicator, 3px)",
    "border.width.outline": "var(--ds-border-width-outline, 2px)"
};
var $cc8a6054a629f7de$export$3c0a6c3e64bb180d = {
    "border.radius.050": "var(--ds-border-radius-050, 2px)",
    "border.radius": "var(--ds-border-radius, 3px)",
    "border.radius.100": "var(--ds-border-radius-100, 3px)",
    "border.radius.200": "var(--ds-border-radius-200, 8px)",
    "border.radius.300": "var(--ds-border-radius-300, 12px)",
    "border.radius.400": "var(--ds-border-radius-400, 16px)",
    "border.radius.circle": "var(--ds-border-radius-circle, 32032px)"
};
var $cc8a6054a629f7de$export$6cc560b4dedf3816 = {
    medium: 'var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    UNSAFE_small: 'var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    large: 'var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    small: 'var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)'
};
var $cc8a6054a629f7de$export$303e322c6b1ed114 = {
    bold: "var(--ds-font-weight-bold, 700)",
    medium: "var(--ds-font-weight-medium, 500)",
    regular: "var(--ds-font-weight-regular, 400)",
    semibold: "var(--ds-font-weight-semibold, 600)"
};
var $cc8a6054a629f7de$export$3c7e9587132614b4 = {
    "font.family.body": 'var(--ds-font-family-body, ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.family.brand.body": 'var(--ds-font-family-brand-body, "Charlie Text", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.family.brand.heading": 'var(--ds-font-family-brand-heading, "Charlie Display", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.family.code": 'var(--ds-font-family-code, ui-monospace, Menlo, "Segoe UI Mono", "Ubuntu Mono", monospace)',
    "font.family.heading": 'var(--ds-font-family-heading, ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)'
};
/**
 * @codegenEnd
 */ // Generate maps for Box props. backgroundColor, padding, etc
var $cc8a6054a629f7de$var$spacingProperties = [
    // Used by Box
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    // Used by Inline and Stack
    "gap",
    "rowGap",
    "columnGap"
];
var $cc8a6054a629f7de$var$getSerializedStylesMap = function getSerializedStylesMap(cssProperty, tokenMap) {
    return Object.keys(tokenMap).reduce(function(emotionSpacingMap, token) {
        emotionSpacingMap[token] = (0, $jVTBW.css)((0, (/*@__PURE__*/$parcel$interopDefault($fjHlV)))({}, cssProperty, tokenMap[token]));
        return emotionSpacingMap;
    }, {});
};
var $cc8a6054a629f7de$export$e615f061ca585a6c = $cc8a6054a629f7de$var$spacingProperties.reduce(function(styleMap, spacingProperty) {
    styleMap[spacingProperty] = $cc8a6054a629f7de$var$getSerializedStylesMap(spacingProperty, $cc8a6054a629f7de$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
var $cc8a6054a629f7de$export$bf46c3f9eeafc71f = $cc8a6054a629f7de$var$spacingProperties.reduce(function(styleMap, spacingProperty) {
    styleMap[spacingProperty] = $cc8a6054a629f7de$var$getSerializedStylesMap(spacingProperty, $cc8a6054a629f7de$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
var $cc8a6054a629f7de$export$e7af83bafe7f9e63 = $cc8a6054a629f7de$var$getSerializedStylesMap("backgroundColor", $cc8a6054a629f7de$export$d1d79bf68ac056bd);
var $cc8a6054a629f7de$export$3a1bcba60b23d7f0 = $cc8a6054a629f7de$var$getSerializedStylesMap("color", $cc8a6054a629f7de$export$8473307aa00d6ea1);
var $cc8a6054a629f7de$export$45f3f4fe16f9f7d5 = $cc8a6054a629f7de$var$getSerializedStylesMap("fontWeight", $cc8a6054a629f7de$export$303e322c6b1ed114);
var $cc8a6054a629f7de$export$68cc305da27dbaa4 = $cc8a6054a629f7de$var$getSerializedStylesMap("fontFamily", $cc8a6054a629f7de$export$3c7e9587132614b4);
var $cc8a6054a629f7de$export$128f10c238242f83 = $cc8a6054a629f7de$var$getSerializedStylesMap("font", $cc8a6054a629f7de$export$6cc560b4dedf3816);
var $cc8a6054a629f7de$export$ff257d957d48c421 = $cc8a6054a629f7de$var$getSerializedStylesMap((0, $93Bl8.CURRENT_SURFACE_CSS_VAR), $cc8a6054a629f7de$export$41a358c9c2356760);
var $cc8a6054a629f7de$export$5e65a44e5b6ecadb = function isSurfaceColorToken(color) {
    return $cc8a6054a629f7de$export$41a358c9c2356760[color] !== undefined;
};

});
parcelRegister("93Bl8", function(module, exports) {

$parcel$export(module.exports, "CURRENT_SURFACE_CSS_VAR", function () { return $69815bcb0d2332a3$export$9d7b58831ae93caa; });
var $69815bcb0d2332a3$export$4ef52930e33717cd = "data-theme";
var $69815bcb0d2332a3$export$a00eac3f8684bcd0 = "data-color-mode";
var $69815bcb0d2332a3$export$2112803007239c61 = "data-contrast-mode";
var $69815bcb0d2332a3$export$352e418ed5b6193a = "data-custom-theme";
var $69815bcb0d2332a3$export$2faeed762aac6741 = "light";
var $69815bcb0d2332a3$export$6f0c6fb8c80fcc92 = "ds";
var $69815bcb0d2332a3$export$4d0c7bbf80185957 = [
    "opacity",
    "font",
    "space",
    "border"
];
var $69815bcb0d2332a3$export$dddac1532e822863 = "--".concat($69815bcb0d2332a3$export$6f0c6fb8c80fcc92, "-token-not-found");
var $69815bcb0d2332a3$export$9d7b58831ae93caa = "--".concat($69815bcb0d2332a3$export$6f0c6fb8c80fcc92, "-elevation-surface-current");

});



parcelRegister("8WEMR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $683360f822ad076b$export$2e2bcd8739ae039; });

var $bIiWW = parcelRequire("bIiWW");

var $9EJk3 = parcelRequire("9EJk3");

var $dAx5m = parcelRequire("dAx5m");

var $jVTBW = parcelRequire("jVTBW");

var $hyLoy = parcelRequire("hyLoy");

var $5BICO = parcelRequire("5BICO");

var $6ySEz = parcelRequire("6ySEz");
var $683360f822ad076b$var$_excluded = [
    "as",
    "children",
    "backgroundColor",
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    "style",
    "testId",
    "xcss"
], $683360f822ad076b$var$_excluded2 = [
    "className"
];
var $683360f822ad076b$export$e71c4d32a2263218 = /*#__PURE__*/ (0, $dAx5m.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? "div" : _ref$as, children = _ref.children, backgroundColor = _ref.backgroundColor, padding = _ref.padding, paddingBlock = _ref.paddingBlock, paddingBlockStart = _ref.paddingBlockStart, paddingBlockEnd = _ref.paddingBlockEnd, paddingInline = _ref.paddingInline, paddingInlineStart = _ref.paddingInlineStart, paddingInlineEnd = _ref.paddingInlineEnd, style = _ref.style, testId = _ref.testId, xcss = _ref.xcss, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($9EJk3)))(_ref, $683360f822ad076b$var$_excluded);
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($9EJk3)))(htmlAttributes, $683360f822ad076b$var$_excluded2);
    var resolvedStyles = (0, $5BICO.parseXcss)(xcss);
    var node = // @ts-expect-error Expression produces a union type that is too complex to represent. I think this is unavoidable
    (0, $jVTBW.jsx)(Component, (0, (/*@__PURE__*/$parcel$interopDefault($bIiWW)))({
        style: style,
        ref: ref,
        className: resolvedStyles.static
    }, safeHtmlAttributes, {
        css: [
            $683360f822ad076b$var$baseStyles,
            backgroundColor && (0, $hyLoy.backgroundColorStylesMap)[backgroundColor],
            (0, $hyLoy.isSurfaceColorToken)(backgroundColor) && (0, $hyLoy.surfaceColorStylesMap)[backgroundColor],
            padding && (0, $hyLoy.paddingStylesMap).padding[padding],
            paddingBlock && (0, $hyLoy.paddingStylesMap).paddingBlock[paddingBlock],
            paddingBlockStart && (0, $hyLoy.paddingStylesMap).paddingBlockStart[paddingBlockStart],
            paddingBlockEnd && (0, $hyLoy.paddingStylesMap).paddingBlockEnd[paddingBlockEnd],
            paddingInline && (0, $hyLoy.paddingStylesMap).paddingInline[paddingInline],
            paddingInlineStart && (0, $hyLoy.paddingStylesMap).paddingInlineStart[paddingInlineStart],
            paddingInlineEnd && (0, $hyLoy.paddingStylesMap).paddingInlineEnd[paddingInlineEnd],
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
            resolvedStyles.emotion
        ],
        "data-testid": testId
    }), children);
    return backgroundColor ? (0, $jVTBW.jsx)((0, $6ySEz.SurfaceContext).Provider, {
        value: backgroundColor
    }, node) : node;
});
var $683360f822ad076b$export$2e2bcd8739ae039 = $683360f822ad076b$export$e71c4d32a2263218;
var $683360f822ad076b$var$baseStyles = (0, $jVTBW.css)({
    boxSizing: "border-box",
    appearance: "none",
    border: "none"
});

});
parcelRegister("6ySEz", function(module, exports) {

$parcel$export(module.exports, "SurfaceContext", function () { return $4c70500df3c18dcf$export$1ca2a26fecb070ae; });

var $dAx5m = parcelRequire("dAx5m");
var $4c70500df3c18dcf$export$1ca2a26fecb070ae = /*#__PURE__*/ (0, $dAx5m.createContext)("elevation.surface");
var $4c70500df3c18dcf$export$1aeb4f6b93c4540d = function useSurface() {
    return (0, $dAx5m.useContext)($4c70500df3c18dcf$export$1ca2a26fecb070ae);
};
$4c70500df3c18dcf$export$1ca2a26fecb070ae.displayName = "SurfaceProvider";

});



parcelRegister("aySbK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7b071d14b7c5751d$export$2e2bcd8739ae039; });
/** @jsx jsx */ 
var $jVTBW = parcelRequire("jVTBW");

var $kfy0B = parcelRequire("kfy0B");

var $dgKpN = parcelRequire("dgKpN");

var $g3ZdF = parcelRequire("g3ZdF");

var $8D3jt = parcelRequire("8D3jt");

var $dvUey = parcelRequire("dvUey");
var $7b071d14b7c5751d$var$buttonsContainerStyles = (0, $jVTBW.css)({
    display: "flex",
    marginBlockStart: "var(--ds-space-075, 6px)",
    position: "absolute",
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
    insetBlockStart: "100%",
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
    insetInlineEnd: 0,
    flexShrink: 0
});
var $7b071d14b7c5751d$var$buttonWrapperBaseStyles = (0, $jVTBW.css)({
    boxSizing: "border-box",
    width: "var(--ds-space-400, 32px)",
    zIndex: 200,
    backgroundColor: "var(--ds-surface-overlay, ".concat((0, $8D3jt.N0), ")"),
    borderRadius: "var(--ds-border-radius, 3px)",
    fontSize: (0, $dvUey.fontSize),
    "&:last-child": {
        marginInlineStart: "var(--ds-space-050, 4px)"
    },
    boxShadow: "var(--ds-shadow-overlay, ".concat("0 4px 8px -2px ".concat((0, $8D3jt.N50A), ", 0 0 1px ").concat((0, $8D3jt.N60A)), ")"),
    // These buttons are floating, so they need an override to overlay interaction states
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
    "& > button": {
        backgroundColor: "var(--ds-surface-overlay, ".concat((0, $8D3jt.N20A), ")")
    },
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
    "& > button:hover": {
        backgroundColor: "var(--ds-surface-overlay-hovered, ".concat((0, $8D3jt.N30A), ")")
    },
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
    "& > button:active": {
        backgroundColor: "var(--ds-surface-overlay-pressed, rgba(179, 212, 255, 0.6))",
        color: "var(--ds-text, ".concat((0, $8D3jt.B400), ")")
    }
});
var $7b071d14b7c5751d$var$Buttons = function Buttons(_ref) {
    var confirmButtonLabel = _ref.confirmButtonLabel, cancelButtonLabel = _ref.cancelButtonLabel, onMouseDown = _ref.onMouseDown, onCancelClick = _ref.onCancelClick, testId = _ref.testId;
    return (0, $jVTBW.jsx)("div", {
        css: $7b071d14b7c5751d$var$buttonsContainerStyles
    }, (0, $jVTBW.jsx)("div", {
        css: $7b071d14b7c5751d$var$buttonWrapperBaseStyles
    }, (0, $jVTBW.jsx)((0, $kfy0B.default), {
        type: "submit",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($dgKpN))),
        UNSAFE_size: "small",
        onMouseDown: onMouseDown,
        label: confirmButtonLabel,
        testId: testId && "".concat(testId, "--confirm")
    })), (0, $jVTBW.jsx)("div", {
        css: $7b071d14b7c5751d$var$buttonWrapperBaseStyles
    }, (0, $jVTBW.jsx)((0, $kfy0B.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($g3ZdF))),
        UNSAFE_size: "small",
        label: cancelButtonLabel,
        onClick: onCancelClick,
        onMouseDown: onMouseDown,
        testId: testId && "".concat(testId, "--cancel")
    })));
};
var $7b071d14b7c5751d$export$2e2bcd8739ae039 = $7b071d14b7c5751d$var$Buttons;

});
parcelRegister("kfy0B", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ebdf96c30f8b4ff8$export$2e2bcd8739ae039; });

var $bIiWW = parcelRequire("bIiWW");

var $9EJk3 = parcelRequire("9EJk3");

var $dAx5m = parcelRequire("dAx5m");

var $8Duts = parcelRequire("8Duts");

var $addpY = parcelRequire("addpY");

var $5B70h = parcelRequire("5B70h");
var $ebdf96c30f8b4ff8$var$_excluded = [
    "aria-label",
    "analyticsContext",
    "appearance",
    "autoFocus",
    "icon",
    "interactionName",
    "isDisabled",
    "isLoading",
    "isSelected",
    "isTooltipDisabled",
    "label",
    "onClick",
    "onClickCapture",
    "onKeyDownCapture",
    "onKeyUpCapture",
    "onMouseDownCapture",
    "onMouseUpCapture",
    "onPointerDownCapture",
    "onPointerUpCapture",
    "onTouchEndCapture",
    "onTouchStartCapture",
    "overlay",
    "shape",
    "spacing",
    "testId",
    "tooltip",
    "type",
    "UNSAFE_size"
];
/**
 * __Icon Button__
 *
 * TODO: Description
 *
 * - [Examples](https://atlassian.design/components/icon-button/examples)
 * - [Code](https://atlassian.design/components/icon-button/code)
 * - [Usage](https://atlassian.design/components/icon-button/usage)
 */ var $ebdf96c30f8b4ff8$var$IconButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).forwardRef(function Button(_ref, ref) {
    var preventedAriaLabel = _ref["aria-label"], analyticsContext = _ref.analyticsContext, appearance = _ref.appearance, autoFocus = _ref.autoFocus, icon = _ref.icon, interactionName = _ref.interactionName, isDisabled = _ref.isDisabled, isLoading = _ref.isLoading, isSelected = _ref.isSelected, _ref$isTooltipDisable = _ref.isTooltipDisabled, isTooltipDisabled = _ref$isTooltipDisable === void 0 ? true : _ref$isTooltipDisable, label = _ref.label, onClick = _ref.onClick, onClickCapture = _ref.onClickCapture, onKeyDownCapture = _ref.onKeyDownCapture, onKeyUpCapture = _ref.onKeyUpCapture, onMouseDownCapture = _ref.onMouseDownCapture, onMouseUpCapture = _ref.onMouseUpCapture, onPointerDownCapture = _ref.onPointerDownCapture, onPointerUpCapture = _ref.onPointerUpCapture, onTouchEndCapture = _ref.onTouchEndCapture, onTouchStartCapture = _ref.onTouchStartCapture, overlay = _ref.overlay, shape = _ref.shape, spacing = _ref.spacing, testId = _ref.testId, tooltip = _ref.tooltip, _ref$type = _ref.type, type = _ref$type === void 0 ? "button" : _ref$type, UNSAFE_size = _ref.UNSAFE_size, rest = (0, (/*@__PURE__*/$parcel$interopDefault($9EJk3)))(_ref, $ebdf96c30f8b4ff8$var$_excluded);
    /**
   * TODO: At some stage I'll look into re-using more logic across 'default' and 'icon'
   * buttons. It's currently duplicated and mostly the same.
   */ var baseProps = (0, $5B70h.default)({
        analyticsContext: analyticsContext,
        appearance: appearance,
        autoFocus: autoFocus,
        buttonType: "button",
        icon: icon,
        interactionName: interactionName,
        isDisabled: isDisabled,
        isSelected: isSelected,
        isLoading: isLoading,
        label: label,
        onClick: onClick,
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onTouchStartCapture: onTouchStartCapture,
        onTouchEndCapture: onTouchEndCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onClickCapture: onClickCapture,
        overlay: overlay,
        ref: ref,
        shape: shape,
        spacing: spacing,
        UNSAFE_size: UNSAFE_size
    });
    if (!isTooltipDisabled) {
        var _tooltip$content;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $addpY.default), {
            content: (_tooltip$content = tooltip === null || tooltip === void 0 ? void 0 : tooltip.content) !== null && _tooltip$content !== void 0 ? _tooltip$content : label,
            testId: tooltip === null || tooltip === void 0 ? void 0 : tooltip.testId,
            position: tooltip === null || tooltip === void 0 ? void 0 : tooltip.position,
            delay: tooltip === null || tooltip === void 0 ? void 0 : tooltip.delay,
            onShow: tooltip === null || tooltip === void 0 ? void 0 : tooltip.onShow,
            onHide: tooltip === null || tooltip === void 0 ? void 0 : tooltip.onHide,
            mousePosition: tooltip === null || tooltip === void 0 ? void 0 : tooltip.mousePosition,
            analyticsContext: tooltip === null || tooltip === void 0 ? void 0 : tooltip.analyticsContext,
            strategy: tooltip === null || tooltip === void 0 ? void 0 : tooltip.strategy,
            tag: tooltip === null || tooltip === void 0 ? void 0 : tooltip.tag,
            truncate: tooltip === null || tooltip === void 0 ? void 0 : tooltip.truncate,
            component: tooltip === null || tooltip === void 0 ? void 0 : tooltip.component,
            hideTooltipOnClick: tooltip === null || tooltip === void 0 ? void 0 : tooltip.hideTooltipOnClick,
            hideTooltipOnMouseDown: tooltip === null || tooltip === void 0 ? void 0 : tooltip.hideTooltipOnMouseDown
        }, function(triggerProps) {
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $8Duts.default), (0, (/*@__PURE__*/$parcel$interopDefault($bIiWW)))({}, rest, {
                type: type,
                testId: testId,
                componentName: "IconButton",
                analyticsContext: analyticsContext,
                interactionName: interactionName,
                onMouseOver: function onMouseOver(e) {
                    var _triggerProps$onMouse, _rest$onMouseOver;
                    (_triggerProps$onMouse = triggerProps.onMouseOver) === null || _triggerProps$onMouse === void 0 || _triggerProps$onMouse.call(triggerProps, e);
                    (_rest$onMouseOver = rest.onMouseOver) === null || _rest$onMouseOver === void 0 || _rest$onMouseOver.call(rest, e);
                },
                onMouseOut: function onMouseOut(e) {
                    var _triggerProps$onMouse2, _rest$onMouseOut;
                    (_triggerProps$onMouse2 = triggerProps.onMouseOut) === null || _triggerProps$onMouse2 === void 0 || _triggerProps$onMouse2.call(triggerProps, e);
                    (_rest$onMouseOut = rest.onMouseOut) === null || _rest$onMouseOut === void 0 || _rest$onMouseOut.call(rest, e);
                },
                onMouseMove: function onMouseMove(e) {
                    var _triggerProps$onMouse3, _rest$onMouseMove;
                    (_triggerProps$onMouse3 = triggerProps.onMouseMove) === null || _triggerProps$onMouse3 === void 0 || _triggerProps$onMouse3.call(triggerProps, e);
                    (_rest$onMouseMove = rest.onMouseMove) === null || _rest$onMouseMove === void 0 || _rest$onMouseMove.call(rest, e);
                },
                onMouseDown: function onMouseDown(e) {
                    var _triggerProps$onMouse4, _rest$onMouseDown;
                    (_triggerProps$onMouse4 = triggerProps.onMouseDown) === null || _triggerProps$onMouse4 === void 0 || _triggerProps$onMouse4.call(triggerProps, e);
                    (_rest$onMouseDown = rest.onMouseDown) === null || _rest$onMouseDown === void 0 || _rest$onMouseDown.call(rest, e);
                },
                onFocus: function onFocus(e) {
                    var _triggerProps$onFocus, _rest$onFocus;
                    (_triggerProps$onFocus = triggerProps.onFocus) === null || _triggerProps$onFocus === void 0 || _triggerProps$onFocus.call(triggerProps, e);
                    (_rest$onFocus = rest.onFocus) === null || _rest$onFocus === void 0 || _rest$onFocus.call(rest, e);
                },
                onBlur: function onBlur(e) {
                    var _triggerProps$onBlur, _rest$onBlur;
                    (_triggerProps$onBlur = triggerProps.onBlur) === null || _triggerProps$onBlur === void 0 || _triggerProps$onBlur.call(triggerProps, e);
                    (_rest$onBlur = rest.onBlur) === null || _rest$onBlur === void 0 || _rest$onBlur.call(rest, e);
                },
                onClick: function onClick(event, analyticsEvent) {
                    var _baseProps$onClick, _triggerProps$onClick;
                    baseProps === null || baseProps === void 0 || (_baseProps$onClick = baseProps.onClick) === null || _baseProps$onClick === void 0 || _baseProps$onClick.call(baseProps, event, analyticsEvent);
                    triggerProps === null || triggerProps === void 0 || (_triggerProps$onClick = triggerProps.onClick) === null || _triggerProps$onClick === void 0 || _triggerProps$onClick.call(triggerProps, event);
                },
                ref: function ref(_ref2) {
                    var _triggerProps$ref;
                    baseProps.ref(_ref2);
                    triggerProps === null || triggerProps === void 0 || (_triggerProps$ref = triggerProps.ref) === null || _triggerProps$ref === void 0 || _triggerProps$ref.call(triggerProps, _ref2);
                },
                xcss: baseProps.xcss,
                isDisabled: baseProps.isDisabled,
                onMouseDownCapture: baseProps.onMouseDownCapture,
                onMouseUpCapture: baseProps.onMouseUpCapture,
                onKeyDownCapture: baseProps.onKeyDownCapture,
                onKeyUpCapture: baseProps.onKeyUpCapture,
                onTouchStartCapture: baseProps.onTouchStartCapture,
                onTouchEndCapture: baseProps.onTouchEndCapture,
                onPointerDownCapture: baseProps.onPointerDownCapture,
                onPointerUpCapture: baseProps.onPointerUpCapture,
                onClickCapture: baseProps.onClickCapture
            }), baseProps.children);
        });
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $8Duts.default), (0, (/*@__PURE__*/$parcel$interopDefault($bIiWW)))({}, rest, {
        ref: baseProps.ref,
        xcss: baseProps.xcss,
        isDisabled: baseProps.isDisabled,
        onClick: baseProps.onClick,
        onMouseDownCapture: baseProps.onMouseDownCapture,
        onMouseUpCapture: baseProps.onMouseUpCapture,
        onKeyDownCapture: baseProps.onKeyDownCapture,
        onKeyUpCapture: baseProps.onKeyUpCapture,
        onTouchStartCapture: baseProps.onTouchStartCapture,
        onTouchEndCapture: baseProps.onTouchEndCapture,
        onPointerDownCapture: baseProps.onPointerDownCapture,
        onPointerUpCapture: baseProps.onPointerUpCapture,
        onClickCapture: baseProps.onClickCapture,
        type: type,
        testId: testId,
        componentName: "IconButton",
        analyticsContext: analyticsContext,
        interactionName: interactionName
    }), baseProps.children);
}));
$ebdf96c30f8b4ff8$var$IconButton.displayName = "IconButton";
var $ebdf96c30f8b4ff8$export$2e2bcd8739ae039 = $ebdf96c30f8b4ff8$var$IconButton;

});
parcelRegister("addpY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $76f586c7dcd45f64$export$2e2bcd8739ae039; });

var $bIiWW = parcelRequire("bIiWW");

var $axuhP = parcelRequire("axuhP");

var $fjHlV = parcelRequire("fjHlV");

var $dAx5m = parcelRequire("dAx5m");

var $dd4sf = parcelRequire("dd4sf");

var $gu35Q = parcelRequire("gu35Q");

var $Bb0he = parcelRequire("Bb0he");

var $6Oq6X = parcelRequire("6Oq6X");

var $511gE = parcelRequire("511gE");
var $5sQqE = parcelRequire("5sQqE");

var $iJx1D = parcelRequire("iJx1D");

var $jiEo7 = parcelRequire("jiEo7");

var $wQmdi = parcelRequire("wQmdi");

var $lEqKj = parcelRequire("lEqKj");

var $9AZ5w = parcelRequire("9AZ5w");

var $eOCYS = parcelRequire("eOCYS");

var $fGXut = parcelRequire("fGXut");

var $4Z9A5 = parcelRequire("4Z9A5");

var $505JK = parcelRequire("505JK");
function $76f586c7dcd45f64$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $76f586c7dcd45f64$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $76f586c7dcd45f64$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($fjHlV)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $76f586c7dcd45f64$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $76f586c7dcd45f64$var$tooltipZIndex = (0, $lEqKj.layers).tooltip();
var $76f586c7dcd45f64$var$analyticsAttributes = {
    componentName: "tooltip",
    packageName: "@atlaskit/tooltip",
    packageVersion: "18.5.1"
};
// Inverts motion direction
var $76f586c7dcd45f64$var$invertedDirection = {
    top: "bottom",
    bottom: "top",
    left: "right",
    right: "left"
};
/**
 * Converts a Popper placement to it's general direction.
 *
 * @param placement - Popper Placement value, e.g. 'top-start'
 * @returns Popper Direction, e.g. 'top'
 */ var $76f586c7dcd45f64$var$getDirectionFromPlacement = function getDirectionFromPlacement(placement) {
    return placement.split("-")[0];
};
function $76f586c7dcd45f64$var$Tooltip(_ref) {
    var children = _ref.children, _ref$position = _ref.position, position = _ref$position === void 0 ? "bottom" : _ref$position, _ref$mousePosition = _ref.mousePosition, mousePosition = _ref$mousePosition === void 0 ? "bottom" : _ref$mousePosition, content = _ref.content, _ref$truncate = _ref.truncate, truncate = _ref$truncate === void 0 ? false : _ref$truncate, _ref$component = _ref.component, Container = _ref$component === void 0 ? (0, $4Z9A5.default) : _ref$component, _ref$tag = _ref.tag, TargetContainer = _ref$tag === void 0 ? "div" : _ref$tag, testId = _ref.testId, _ref$delay = _ref.delay, delay = _ref$delay === void 0 ? 300 : _ref$delay, _ref$onShow = _ref.onShow, onShow = _ref$onShow === void 0 ? (0, $Bb0he.default) : _ref$onShow, _ref$onHide = _ref.onHide, onHide = _ref$onHide === void 0 ? (0, $Bb0he.default) : _ref$onHide, _ref$hideTooltipOnCli = _ref.hideTooltipOnClick, hideTooltipOnClick = _ref$hideTooltipOnCli === void 0 ? false : _ref$hideTooltipOnCli, _ref$hideTooltipOnMou = _ref.hideTooltipOnMouseDown, hideTooltipOnMouseDown = _ref$hideTooltipOnMou === void 0 ? false : _ref$hideTooltipOnMou, analyticsContext = _ref.analyticsContext, _ref$strategy = _ref.strategy, strategy = _ref$strategy === void 0 ? "fixed" : _ref$strategy, _ref$ignoreTooltipPoi = _ref.ignoreTooltipPointerEvents, ignoreTooltipPointerEvents = _ref$ignoreTooltipPoi === void 0 ? false : _ref$ignoreTooltipPoi;
    var tooltipPosition = position === "mouse" ? mousePosition : position;
    var onShowHandler = (0, $gu35Q.usePlatformLeafSyntheticEventHandler)($76f586c7dcd45f64$var$_objectSpread({
        fn: onShow,
        action: "displayed",
        analyticsData: analyticsContext
    }, $76f586c7dcd45f64$var$analyticsAttributes));
    var onHideHandler = (0, $gu35Q.usePlatformLeafSyntheticEventHandler)($76f586c7dcd45f64$var$_objectSpread({
        fn: onHide,
        action: "hidden",
        analyticsData: analyticsContext
    }, $76f586c7dcd45f64$var$analyticsAttributes));
    var apiRef = (0, $dAx5m.useRef)(null);
    var _useState = (0, $dAx5m.useState)("hide"), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($axuhP)))(_useState, 2), state = _useState2[0], setState = _useState2[1];
    var targetRef = (0, $dAx5m.useRef)(null);
    var containerRef = (0, $dAx5m.useRef)(null);
    // This function is deliberately _not_ memoized as it needs to re-run every render
    // to pick up any child ref changes. If you use render props you don't have this issue.
    var setImplicitRefFromChildren = function setImplicitRefFromChildren(node) {
        containerRef.current = node;
        targetRef.current = node ? node.firstElementChild : null;
    };
    // This is memoized and passed into the render props callback.
    var setDirectRef = (0, $dAx5m.useCallback)(function(node) {
        targetRef.current = node;
    }, []);
    // Putting a few things into refs so that we don't have to break memoization
    var lastState = (0, $dAx5m.useRef)(state);
    var lastDelay = (0, $dAx5m.useRef)(delay);
    var lastHandlers = (0, $dAx5m.useRef)({
        onShowHandler: onShowHandler,
        onHideHandler: onHideHandler
    });
    var hasCalledShowHandler = (0, $dAx5m.useRef)(false);
    (0, $dAx5m.useEffect)(function() {
        lastState.current = state;
        lastDelay.current = delay;
        lastHandlers.current = {
            onShowHandler: onShowHandler,
            onHideHandler: onHideHandler
        };
    }, [
        delay,
        onHideHandler,
        onShowHandler,
        state
    ]);
    var start = (0, $dAx5m.useCallback)(function(api) {
        // @ts-ignore
        apiRef.current = api;
        hasCalledShowHandler.current = false;
    }, []);
    var done = (0, $dAx5m.useCallback)(function() {
        if (!apiRef.current) return;
        // Only call onHideHandler if we have called onShowHandler
        if (hasCalledShowHandler.current) lastHandlers.current.onHideHandler();
        // @ts-ignore
        apiRef.current = null;
        // @ts-ignore
        hasCalledShowHandler.current = false;
        // just in case
        setState("hide");
    }, []);
    var abort = (0, $dAx5m.useCallback)(function() {
        if (!apiRef.current) return;
        apiRef.current.abort();
        // Only call onHideHandler if we have called onShowHandler
        if (hasCalledShowHandler.current) lastHandlers.current.onHideHandler();
        // @ts-ignore
        apiRef.current = null;
    }, []);
    (0, $dAx5m.useEffect)(function mount() {
        return function unmount() {
            if (apiRef.current) abort();
        };
    }, [
        abort
    ]);
    var isDraggingRef = (0, $dAx5m.useRef)(false);
    (0, $dAx5m.useEffect)(function() {
        return (0, $9AZ5w.register)({
            onRegister: function onRegister(_ref2) {
                var isDragging = _ref2.isDragging;
                isDraggingRef.current = isDragging;
            },
            onDragStart: function onDragStart() {
                var _apiRef$current;
                /**
         * Hiding any visible tooltips when a drag starts because otherwise it
         * looks janky (disappears and reappears), and is not required.
         */ (_apiRef$current = apiRef.current) === null || _apiRef$current === void 0 || _apiRef$current.requestHide({
                    isImmediate: true
                });
                isDraggingRef.current = true;
            },
            onDragEnd: function onDragEnd() {
                isDraggingRef.current = false;
            }
        });
    }, []);
    var showTooltip = (0, $dAx5m.useCallback)(function(source) {
        /**
     * Prevent tooltips from being shown during a drag. This can occur with
     * the native drag and drop API, where some pointer events can fire
     * when they should not and lead to jank with tooltips.
     */ if (isDraggingRef.current) return;
        if (apiRef.current && !apiRef.current.isActive()) abort();
        // Tell the tooltip to keep showing
        if (apiRef.current && apiRef.current.isActive()) {
            apiRef.current.keep();
            return;
        }
        var entry = {
            source: source,
            delay: lastDelay.current,
            show: function show(_ref3) {
                var isImmediate = _ref3.isImmediate;
                // Call the onShow handler if it hasn't been called yet
                if (!hasCalledShowHandler.current) {
                    hasCalledShowHandler.current = true;
                    lastHandlers.current.onShowHandler();
                }
                setState(isImmediate ? "show-immediate" : "fade-in");
            },
            hide: function hide(_ref4) {
                var isImmediate = _ref4.isImmediate;
                if (isImmediate) setState("hide");
                else setState("before-fade-out");
            },
            done: done
        };
        var api = (0, $eOCYS.show)(entry);
        start(api);
    }, [
        abort,
        done,
        start
    ]);
    var hideTooltipOnEsc = (0, $dAx5m.useCallback)(function() {
        var _apiRef$current2;
        (_apiRef$current2 = apiRef.current) === null || _apiRef$current2 === void 0 || _apiRef$current2.requestHide({
            isImmediate: true
        });
    }, [
        apiRef
    ]);
    (0, $6Oq6X.default)({
        onClose: hideTooltipOnEsc,
        isDisabled: state === "hide" || state === "fade-out"
    });
    (0, $dAx5m.useEffect)(function() {
        if (state === "hide") return 0, $Bb0he.default;
        if (state === "before-fade-out") setState("fade-out");
        var unbind = (0, $dd4sf.bind)(window, {
            type: "scroll",
            listener: function listener() {
                if (apiRef.current) apiRef.current.requestHide({
                    isImmediate: true
                });
            },
            options: {
                capture: true,
                passive: true,
                once: true
            }
        });
        return unbind;
    }, [
        state
    ]);
    var onMouseDown = (0, $dAx5m.useCallback)(function() {
        if (hideTooltipOnMouseDown && apiRef.current) apiRef.current.requestHide({
            isImmediate: true
        });
    }, [
        hideTooltipOnMouseDown
    ]);
    var onClick = (0, $dAx5m.useCallback)(function() {
        if (hideTooltipOnClick && apiRef.current) apiRef.current.requestHide({
            isImmediate: true
        });
    }, [
        hideTooltipOnClick
    ]);
    // Ideally we would be using onMouseEnter here, but
    // because we are binding the event to the target parent
    // we need to listen for the mouseover of all sub elements
    // This means when moving along a tooltip we are quickly toggling
    // between api.requestHide and api.keep. This it not ideal
    var onMouseOver = (0, $dAx5m.useCallback)(function(event) {
        // Ignoring events from the container ref
        if (containerRef.current && event.target === containerRef.current) return;
        // Using prevent default as a signal that parent tooltips
        if (event.defaultPrevented) return;
        event.preventDefault();
        var source = position === "mouse" ? {
            type: "mouse",
            // TODO: ideally not recalculating this object each time
            mouse: (0, $505JK.getMousePosition)({
                left: event.clientX,
                top: event.clientY
            })
        } : {
            type: "keyboard"
        };
        showTooltip(source);
    }, [
        position,
        showTooltip
    ]);
    // Ideally we would be using onMouseEnter here, but
    // because we are binding the event to the target parent
    // we need to listen for the mouseout of all sub elements
    // This means when moving along a tooltip we are quickly toggling
    // between api.requestHide and api.keep. This it not ideal
    var onMouseOut = (0, $dAx5m.useCallback)(function(event) {
        // Ignoring events from the container ref
        if (containerRef.current && event.target === containerRef.current) return;
        // Using prevent default as a signal that parent tooltips
        if (event.defaultPrevented) return;
        event.preventDefault();
        if (apiRef.current) apiRef.current.requestHide({
            isImmediate: false
        });
    }, []);
    var onMouseMove = position === "mouse" ? function(event) {
        var _apiRef$current3;
        if ((_apiRef$current3 = apiRef.current) !== null && _apiRef$current3 !== void 0 && _apiRef$current3.isActive()) apiRef.current.mousePosition = (0, $505JK.getMousePosition)({
            left: event.clientX,
            top: event.clientY
        });
    } : undefined;
    var onMouseOverTooltip = (0, $dAx5m.useCallback)(function() {
        if (apiRef.current && apiRef.current.isActive()) {
            apiRef.current.keep();
            return;
        }
    }, []);
    var onFocus = (0, $dAx5m.useCallback)(function() {
        showTooltip({
            type: "keyboard"
        });
    }, [
        showTooltip
    ]);
    var onBlur = (0, $dAx5m.useCallback)(function() {
        if (apiRef.current) apiRef.current.requestHide({
            isImmediate: false
        });
    }, []);
    var onAnimationFinished = (0, $dAx5m.useCallback)(function(transition) {
        // Using lastState here because motion is not picking up the latest value
        if (transition === "exiting" && lastState.current === "fade-out" && apiRef.current) // @ts-ignore: refs are writeable
        apiRef.current.finishHideAnimation();
    }, []);
    // Doing a cast because typescript is struggling to narrow the type
    var CastTargetContainer = TargetContainer;
    var shouldRenderTooltipContainer = state !== "hide" && Boolean(content);
    var shouldRenderTooltipChildren = state !== "hide" && state !== "fade-out";
    var getReferenceElement = function getReferenceElement() {
        var _apiRef$current4;
        if (position === "mouse" && (_apiRef$current4 = apiRef.current) !== null && _apiRef$current4 !== void 0 && _apiRef$current4.mousePosition) {
            var _apiRef$current5;
            return (_apiRef$current5 = apiRef.current) === null || _apiRef$current5 === void 0 ? void 0 : _apiRef$current5.mousePosition;
        }
        return targetRef.current || undefined;
    };
    var tooltipId = (0, $fGXut.default)("tooltip", shouldRenderTooltipContainer);
    var tooltipTriggerProps = {
        onMouseOver: onMouseOver,
        onMouseOut: onMouseOut,
        onMouseMove: onMouseMove,
        onMouseDown: onMouseDown,
        onClick: onClick,
        onFocus: onFocus,
        onBlur: onBlur
    };
    // Don't set `data-testid` unless it's defined, as it's not in the interface.
    if (testId) // @ts-expect-error - Adding `data-testid` to the TriggerProps interface breaks Buttons.
    tooltipTriggerProps["data-testid"] = "".concat(testId, "--container");
    // This useEffect is purely for managing the aria attribute when using the
    // wrapped children approach.
    (0, $dAx5m.useEffect)(function() {
        // If there is no container element, we should exit early, because that
        // means they are using the render prop API, and that is implemented in a
        // different way. If there is no target element yet or tooltipId, we also
        // shouldn't do anything because there is nothing to operate on or with.
        if (!containerRef.current || !targetRef.current || !tooltipId) return;
        var target = targetRef.current;
        if (shouldRenderTooltipContainer) target.setAttribute("aria-describedby", tooltipId);
        else target.removeAttribute("aria-describedby");
    }, [
        shouldRenderTooltipContainer,
        tooltipId
    ]);
    var hiddenContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement("span", {
        "data-testid": testId ? "".concat(testId, "-hidden") : undefined,
        hidden: true,
        id: tooltipId
    }, typeof content === "function" ? content({}) : content);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).Fragment, null, typeof children === "function" ? /*#__PURE__*/ // once we deprecate the wrapped approach, we can put the aria
    // attribute back into the tooltipTriggerProps and make it required
    // instead of optional in `types`
    (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).Fragment, null, children($76f586c7dcd45f64$var$_objectSpread($76f586c7dcd45f64$var$_objectSpread({}, tooltipTriggerProps), {}, {
        "aria-describedby": tooltipId,
        ref: setDirectRef
    })), shouldRenderTooltipContainer && hiddenContent) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement(CastTargetContainer, (0, (/*@__PURE__*/$parcel$interopDefault($bIiWW)))({}, tooltipTriggerProps, {
        ref: setImplicitRefFromChildren,
        role: "presentation"
    }), children, shouldRenderTooltipContainer && hiddenContent), shouldRenderTooltipContainer ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $wQmdi.default), {
        zIndex: $76f586c7dcd45f64$var$tooltipZIndex
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $jiEo7.Popper), {
        placement: tooltipPosition,
        referenceElement: getReferenceElement(),
        strategy: strategy
    }, function(_ref5) {
        var ref = _ref5.ref, style = _ref5.style, update = _ref5.update, placement = _ref5.placement;
        // Invert the entrance and exit directions.
        // E.g. a tooltip's position is on the 'right', it should enter from and exit to the 'left'
        // This gives the effect the tooltip is appearing from the target
        var direction = position === "mouse" ? undefined : $76f586c7dcd45f64$var$invertedDirection[$76f586c7dcd45f64$var$getDirectionFromPlacement(placement)];
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $511gE.default), {
            appear: true
        }, shouldRenderTooltipChildren && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $5sQqE.default), {
            distance: "constant",
            entranceDirection: direction,
            exitDirection: direction,
            onFinish: onAnimationFinished,
            duration: state === "show-immediate" ? 0 : (0, $iJx1D.mediumDurationMs)
        }, function(_ref6) {
            var className = _ref6.className;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement(Container, {
                ref: ref,
                className: "Tooltip ".concat(className),
                style: $76f586c7dcd45f64$var$_objectSpread($76f586c7dcd45f64$var$_objectSpread({}, style), ignoreTooltipPointerEvents && {
                    pointerEvents: "none"
                }),
                truncate: truncate,
                placement: tooltipPosition,
                testId: getReferenceElement() ? testId : testId && "".concat(testId, "--unresolved"),
                onMouseOut: onMouseOut,
                onMouseOver: onMouseOverTooltip
            }, typeof content === "function" ? content({
                update: update
            }) : content);
        }));
    })) : null);
}
$76f586c7dcd45f64$var$Tooltip.displayName = "Tooltip";
var $76f586c7dcd45f64$export$2e2bcd8739ae039 = $76f586c7dcd45f64$var$Tooltip;

});
parcelRegister("gu35Q", function(module, exports) {

$parcel$export(module.exports, "usePlatformLeafSyntheticEventHandler", function () { return $c001d8f50f25851b$export$1a04351537078b55; });

var $fjHlV = parcelRequire("fjHlV");

var $dAx5m = parcelRequire("dAx5m");

var $5b2dw = parcelRequire("5b2dw");

var $8zmUP = parcelRequire("8zmUP");
function $c001d8f50f25851b$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $c001d8f50f25851b$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $c001d8f50f25851b$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($fjHlV)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $c001d8f50f25851b$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $c001d8f50f25851b$export$1a04351537078b55(_ref) {
    var fn = _ref.fn, action = _ref.action, componentName = _ref.componentName, packageName = _ref.packageName, packageVersion = _ref.packageVersion, analyticsData = _ref.analyticsData;
    var _useAnalyticsEvents = (0, $5b2dw.useAnalyticsEvents)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    // We put analyticsData and fn in a ref so that we don't need to break
    // memoization.
    // Generally these could be defined by consumers inline
    // and so we do this to avoid breaking memoization of useCallback
    var dataRef = (0, $8zmUP.useTrackedRef)(analyticsData);
    var fnRef = (0, $8zmUP.useTrackedRef)(fn);
    var handler = (0, $dAx5m.useCallback)(function() {
        var analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: componentName,
            attributes: {
                componentName: componentName,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
        // To avoid wrapping this component in AnalyticsContext we manually
        // push the parent context's meta data into the context.
        // Note: this new 'context'
        var context = $c001d8f50f25851b$var$_objectSpread({
            componentName: componentName,
            packageName: packageName,
            packageVersion: packageVersion
        }, dataRef.current);
        analyticsEvent.context.push(context);
        // fire an event on the atlaskit channel
        var clone = analyticsEvent.clone();
        if (clone) clone.fire("atlaskit");
        fnRef.current(analyticsEvent);
    }, [
        // These are strings and won't change
        action,
        componentName,
        packageName,
        packageVersion,
        // This function is memoized in the context
        createAnalyticsEvent,
        // these are a stable ref because of the useTrackedRef hook
        dataRef,
        fnRef
    ]);
    return handler;
}

});

parcelRegister("6Oq6X", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4f5baabd77669efd$export$2e2bcd8739ae039; });

var $dAx5m = parcelRequire("dAx5m");

var $dd4sf = parcelRequire("dd4sf");

var $76DDk = parcelRequire("76DDk");
function $4f5baabd77669efd$export$2e2bcd8739ae039(_ref) {
    var onClose = _ref.onClose, isDisabled = _ref.isDisabled;
    var escapePressed = (0, $dAx5m.useRef)(false);
    var onKeyDown = (0, $dAx5m.useCallback)(function(e) {
        if (isDisabled || escapePressed.current || e.key !== (0, $76DDk.ESCAPE)) // We're either already handling the key down event or it's not escape.
        // Bail early!
        return;
        escapePressed.current = true;
        onClose(e);
    }, [
        onClose,
        isDisabled
    ]);
    var onKeyUp = (0, $dAx5m.useCallback)(function() {
        escapePressed.current = false;
    }, []);
    (0, $dAx5m.useEffect)(function() {
        return (0, $dd4sf.bindAll)(document, [
            {
                type: "keydown",
                listener: onKeyDown
            },
            {
                type: "keyup",
                listener: onKeyUp
            }
        ], {
            capture: false
        });
    }, [
        onKeyDown,
        onKeyUp
    ]);
}

});
parcelRegister("76DDk", function(module, exports) {

$parcel$export(module.exports, "KEY_UP", function () { return $52c7d64974cbbfd0$export$390330c10ff2b9a1; });
$parcel$export(module.exports, "KEY_DOWN", function () { return $52c7d64974cbbfd0$export$a80636c6f41931fe; });
$parcel$export(module.exports, "KEY_HOME", function () { return $52c7d64974cbbfd0$export$4af703091671bc; });
$parcel$export(module.exports, "KEY_END", function () { return $52c7d64974cbbfd0$export$e2bc30913faa5db7; });
$parcel$export(module.exports, "KEY_TAB", function () { return $52c7d64974cbbfd0$export$10f6869ed0a7d75b; });
$parcel$export(module.exports, "KEY_ENTER", function () { return $52c7d64974cbbfd0$export$8152f929a25a0ff4; });
$parcel$export(module.exports, "KEY_SPACE", function () { return $52c7d64974cbbfd0$export$e51a3576c045c8d5; });
$parcel$export(module.exports, "ESCAPE", function () { return $52c7d64974cbbfd0$export$2bb790b9008907b4; });
/**
 * Character key codes which can be used in keyboard events.
 */ var $52c7d64974cbbfd0$export$390330c10ff2b9a1 = "ArrowUp";
var $52c7d64974cbbfd0$export$a80636c6f41931fe = "ArrowDown";
var $52c7d64974cbbfd0$export$4af703091671bc = "Home";
var $52c7d64974cbbfd0$export$e2bc30913faa5db7 = "End";
var $52c7d64974cbbfd0$export$10f6869ed0a7d75b = "Tab";
var $52c7d64974cbbfd0$export$8152f929a25a0ff4 = "Enter";
var $52c7d64974cbbfd0$export$e51a3576c045c8d5 = "Space";
var $52c7d64974cbbfd0$export$2bb790b9008907b4 = "Escape";

});


parcelRegister("511gE", function(module, exports) {

$parcel$export(module.exports, "wrapChildWithContextProvider", function () { return $3a6e0776a04afd43$export$e4c4c45693c3a7c; });
$parcel$export(module.exports, "childrenToArray", function () { return $3a6e0776a04afd43$export$7032ae6d9d98bedd; });
$parcel$export(module.exports, "spliceNewElementsIntoPrevious", function () { return $3a6e0776a04afd43$export$2ccbe4ff092af328; });
$parcel$export(module.exports, "childrenToObj", function () { return $3a6e0776a04afd43$export$1d8c49f95a162a41; });
$parcel$export(module.exports, "useExitingPersistence", function () { return $3a6e0776a04afd43$export$3b6f38abbdcbd000; });
$parcel$export(module.exports, "default", function () { return $3a6e0776a04afd43$export$2e2bcd8739ae039; });

var $dAx5m = parcelRequire("dAx5m");

var $8vWLu = parcelRequire("8vWLu");

var $4jv9C = parcelRequire("4jv9C");

var $5HhCe = parcelRequire("5HhCe");
var $3a6e0776a04afd43$export$d1e013d71d2e2121 = {
    // Motions will always appear if not inside a exiting persistence component.
    appear: true,
    isExiting: false
};
var $3a6e0776a04afd43$export$b9c4904d7a6929e6 = /*#__PURE__*/ (0, $dAx5m.createContext)($3a6e0776a04afd43$export$d1e013d71d2e2121);
var $3a6e0776a04afd43$export$e4c4c45693c3a7c = function wrapChildWithContextProvider(child) {
    var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $3a6e0776a04afd43$export$d1e013d71d2e2121;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement($3a6e0776a04afd43$export$b9c4904d7a6929e6.Provider, {
        key: "".concat(child.key, "-provider"),
        value: value
    }, child);
};
var $3a6e0776a04afd43$export$7032ae6d9d98bedd = function childrenToArray(children) {
    var childrenAsArray = [];
    // We convert children to an array using this helper method as it will add keys to children that do not
    // have them, such as when we have hardcoded children that are conditionally rendered.
    (0, $dAx5m.Children).toArray(children).forEach(function(child) {
        // We ignore any boolean children to make our code a little more simple later on,
        // and also filter out any falsies (empty strings, nulls, and undefined).
        if (typeof child !== "boolean" && Boolean(child)) // Children WILL have a key after being forced into an array using the React.Children helper.
        childrenAsArray.push(child);
    });
    return childrenAsArray;
};
var $3a6e0776a04afd43$export$2ccbe4ff092af328 = function spliceNewElementsIntoPrevious(current, previous) {
    var splicedChildren = previous.concat([]);
    var previousMap = $3a6e0776a04afd43$export$1d8c49f95a162a41(previous);
    for(var i = 0; i < current.length; i++){
        var child = current[i];
        var childIsNew = !previousMap[child.key];
        if (childIsNew) // This will insert the new element after the previous element.
        splicedChildren.splice(i + 1, 0, child);
    }
    return splicedChildren;
};
var $3a6e0776a04afd43$export$1d8c49f95a162a41 = function childrenToObj(children) {
    return children.reduce(function(acc, child) {
        acc[child.key] = child;
        return acc;
    }, {});
};
/**
 * __ExitingPersistence__
 *
 * Useful for enabling elements to persist and animate away when they are removed from the DOM.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motions)
 */ var $3a6e0776a04afd43$var$ExitingPersistence = /*#__PURE__*/ (0, $dAx5m.memo)(function(_ref) {
    var _ref$appear = _ref.appear, appear = _ref$appear === void 0 ? false : _ref$appear, children = _ref.children, exitThenEnter = _ref.exitThenEnter;
    return (0, $8vWLu.getBooleanFF)("platform.design-system-team.update-motion-for-strict-mode_p6qs0") ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $4jv9C.default), {
        appear: appear,
        children: children,
        exitThenEnter: exitThenEnter
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $5HhCe.default), {
        appear: appear,
        children: children,
        exitThenEnter: exitThenEnter
    });
});
var $3a6e0776a04afd43$export$3b6f38abbdcbd000 = function useExitingPersistence() {
    return (0, $dAx5m.useContext)($3a6e0776a04afd43$export$b9c4904d7a6929e6);
};
$3a6e0776a04afd43$var$ExitingPersistence.displayName = "ExitingPersistence";
var $3a6e0776a04afd43$export$2e2bcd8739ae039 = $3a6e0776a04afd43$var$ExitingPersistence;

});
parcelRegister("8vWLu", function(module, exports) {

$parcel$export(module.exports, "getBooleanFF", function () { return $632ecd7d34344b21$export$470e5c2be1411c89; });

var $6BJKO = parcelRequire("6BJKO");
function $632ecd7d34344b21$export$ba05d765b8392e5e(flagResolver) {
    (0, $6BJKO.setBooleanResolver)(flagResolver);
}
function $632ecd7d34344b21$export$470e5c2be1411c89(name) {
    return (0, $6BJKO.resolveBooleanFlag)(name);
}

});
parcelRegister("6BJKO", function(module, exports) {

$parcel$export(module.exports, "setBooleanResolver", function () { return $4cf9b096c17ffc8a$export$f2b591175b3e424c; });
$parcel$export(module.exports, "resolveBooleanFlag", function () { return $4cf9b096c17ffc8a$export$6333b6aff9fc6275; });

var $kwMQ7 = parcelRequire("kwMQ7");

var $ahJoN = parcelRequire("ahJoN");
var $4cf9b096c17ffc8a$var$pkgName = "@atlaskit/platform-feature-flags";
var $4cf9b096c17ffc8a$export$7e41b1b2bdee3f98 = "__PLATFORM_FEATURE_FLAGS__";
var $4cf9b096c17ffc8a$var$hasProcessEnv = typeof $ahJoN !== "undefined" && typeof $ahJoN.env !== "undefined";
// FF global overrides can be configured by test runners or Storybook
var $4cf9b096c17ffc8a$var$ENV_ENABLE_PLATFORM_FF = $4cf9b096c17ffc8a$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
// STORYBOOK_ENABLE_PLATFORM_FF is included as storybook only allows env vars prefixed with STORYBOOK
// https://github.com/storybookjs/storybook/issues/12270
var $4cf9b096c17ffc8a$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF = $4cf9b096c17ffc8a$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
var $4cf9b096c17ffc8a$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE = $4cf9b096c17ffc8a$var$ENV_ENABLE_PLATFORM_FF || $4cf9b096c17ffc8a$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF;
var $4cf9b096c17ffc8a$var$DEFAULT_PFF_GLOBAL = {
    // In development mode we want to capture any feature flag checks that happen using the default resolver and log this result when the resolver is replaced.
    // This is because evaluating feature flags when the resolver/FF client is loaded asynchronously could cause unexpected issues.
    earlyResolvedFlags: new Map(),
    booleanResolver: function booleanResolver(flagKey) {
        var unresolvedFlagCount;
        return false;
    }
};
var $4cf9b096c17ffc8a$var$globalVar = typeof window !== "undefined" ? window : globalThis;
$4cf9b096c17ffc8a$var$globalVar[$4cf9b096c17ffc8a$export$7e41b1b2bdee3f98] = $4cf9b096c17ffc8a$var$globalVar[$4cf9b096c17ffc8a$export$7e41b1b2bdee3f98] || $4cf9b096c17ffc8a$var$DEFAULT_PFF_GLOBAL;
function $4cf9b096c17ffc8a$export$f2b591175b3e424c(resolver) {
    $4cf9b096c17ffc8a$var$globalVar[$4cf9b096c17ffc8a$export$7e41b1b2bdee3f98].booleanResolver = resolver;
    var _globalVar$PFF_GLOBAL;
}
function $4cf9b096c17ffc8a$export$6333b6aff9fc6275(flagKey) {
    if ($4cf9b096c17ffc8a$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE) {
        (0, $kwMQ7.debug)('[%s]: The feature flags were enabled while running tests. The flag "%s" will be always enabled.', $4cf9b096c17ffc8a$var$pkgName, flagKey);
        return true;
    }
    try {
        var _globalVar$PFF_GLOBAL2;
        var result = (_globalVar$PFF_GLOBAL2 = $4cf9b096c17ffc8a$var$globalVar[$4cf9b096c17ffc8a$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL2 === void 0 ? void 0 : _globalVar$PFF_GLOBAL2.booleanResolver(flagKey);
        if (typeof result !== "boolean") {
            // eslint-disable-next-line no-console
            console.warn("".concat(flagKey, " resolved to a non-boolean value, returning false for safety"));
            return false;
        }
        return result;
    } catch (e) {
        return false;
    }
}

});
parcelRegister("kwMQ7", function(module, exports) {

$parcel$export(module.exports, "debug", function () { return $ef1cae5040f5d66e$export$1c9f709888824e05; });
var $ef1cae5040f5d66e$var$_ref, $ef1cae5040f5d66e$var$_process, $ef1cae5040f5d66e$var$_process2;
// We can't rely on NODE_ENV === 'test' if its value is already configured by the consumer to some other value, so better to use JEST_WORKER_ID
// https://jestjs.io/docs/environment-variables#jest_worker_id
var $ef1cae5040f5d66e$var$TESTS_MODE = ($ef1cae5040f5d66e$var$_ref = (globalThis === null || globalThis === void 0 || ($ef1cae5040f5d66e$var$_process = globalThis.process) === null || $ef1cae5040f5d66e$var$_process === void 0 || ($ef1cae5040f5d66e$var$_process = $ef1cae5040f5d66e$var$_process.env) === null || $ef1cae5040f5d66e$var$_process === void 0 ? void 0 : $ef1cae5040f5d66e$var$_process.JEST_WORKER_ID) !== undefined, $ef1cae5040f5d66e$var$_ref !== void 0) ? $ef1cae5040f5d66e$var$_ref : false;
var $ef1cae5040f5d66e$var$DEBUG_MODE = !$ef1cae5040f5d66e$var$TESTS_MODE && (globalThis === null || globalThis === void 0 || ($ef1cae5040f5d66e$var$_process2 = globalThis.process) === null || $ef1cae5040f5d66e$var$_process2 === void 0 || ($ef1cae5040f5d66e$var$_process2 = $ef1cae5040f5d66e$var$_process2.env) === null || $ef1cae5040f5d66e$var$_process2 === void 0 ? void 0 : $ef1cae5040f5d66e$var$_process2.NODE_ENV) !== "production";
var $ef1cae5040f5d66e$export$1c9f709888824e05 = function debug() {
    var _console;
    if (!$ef1cae5040f5d66e$var$DEBUG_MODE) return;
    // eslint-disable-next-line no-console
    (_console = console).debug.apply(_console, arguments);
};

});



parcelRegister("4jv9C", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $32411a4f8a5db3bf$export$2e2bcd8739ae039; });

var $axuhP = parcelRequire("axuhP");

var $dAx5m = parcelRequire("dAx5m");

var $4RWMe = parcelRequire("4RWMe");

var $511gE = parcelRequire("511gE");
var $32411a4f8a5db3bf$var$getMissingKeys = function getMissingKeys(current, previous) {
    var currentMapKeys = new Set(current.map(function(child) {
        return child.key;
    }));
    var missing = new Set();
    for(var i = 0; i < previous.length; i++){
        var element = previous[i];
        var key = element.key;
        if (!currentMapKeys.has(key)) missing.add(key);
    }
    return missing;
};
/**
 * __WithStrictModeSupport__
 *
 * Useful for enabling elements to persist and animate away when they are removed from the DOM.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motions)
 */ var $32411a4f8a5db3bf$var$WithStrictModeSupport = /*#__PURE__*/ (0, $dAx5m.memo)(function(_ref) {
    var _ref$appear = _ref.appear, appear = _ref$appear === void 0 ? false : _ref$appear, children = _ref.children, exitThenEnter = _ref.exitThenEnter;
    var _useState = (0, $dAx5m.useState)([
        null,
        children
    ]), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($axuhP)))(_useState, 2), stateChildren = _useState2[0], setChildren = _useState2[1];
    var _useState3 = (0, $dAx5m.useState)([]), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($axuhP)))(_useState3, 2), exitingChildren = _useState4[0], setExitingChildren = _useState4[1];
    var _useState5 = (0, $dAx5m.useState)(function() {
        return {
            appear: appear,
            isExiting: false
        };
    }), _useState6 = (0, (/*@__PURE__*/$parcel$interopDefault($axuhP)))(_useState5, 2), defaultContext = _useState6[0], setDefaultContext = _useState6[1];
    (0, $dAx5m.useEffect)(function() {
        if (!defaultContext.appear) setDefaultContext({
            appear: true,
            isExiting: false
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    if ((0, $4RWMe.isReducedMotion)()) return children;
    /**
   * NOTE: This is a workaround for the test case written in Jira where the stateChildren is a boolean value because
   * useState is mocked to return a boolean value.
   */ if (typeof stateChildren === "boolean") return children;
    var _stateChildren = (0, (/*@__PURE__*/$parcel$interopDefault($axuhP)))(stateChildren, 2), previousChildren = _stateChildren[0], currentChildren = _stateChildren[1];
    var previous = (0, $511gE.childrenToArray)(previousChildren);
    var current = (0, $511gE.childrenToArray)(currentChildren);
    if (currentChildren !== children) setChildren([
        currentChildren,
        children
    ]);
    var missingKeys = $32411a4f8a5db3bf$var$getMissingKeys(current, previous);
    var isSomeChildRemoved = !!missingKeys.size;
    var visibleChildren = current;
    if (isSomeChildRemoved) visibleChildren = (0, $511gE.spliceNewElementsIntoPrevious)(current, previous);
    if (exitThenEnter) {
        if (exitingChildren.length) visibleChildren = exitingChildren;
        else {
            var nextExitingChildren = visibleChildren.filter(function(child) {
                return missingKeys.has(child.key);
            });
            if (nextExitingChildren.length) setExitingChildren(nextExitingChildren);
        }
    }
    if (missingKeys.size) visibleChildren = visibleChildren.map(function(child) {
        var isExiting = missingKeys.has(child.key);
        return (0, $511gE.wrapChildWithContextProvider)(child, {
            appear: true,
            isExiting: isExiting,
            onFinish: isExiting ? function() {
                missingKeys.delete(child.key);
                if (missingKeys.size === 0) {
                    setChildren([
                        null,
                        children
                    ]);
                    setExitingChildren([]);
                }
            } : undefined
        });
    });
    else visibleChildren = visibleChildren.map(function(child) {
        return (0, $511gE.wrapChildWithContextProvider)(child, defaultContext);
    });
    return visibleChildren;
});
var $32411a4f8a5db3bf$export$2e2bcd8739ae039 = $32411a4f8a5db3bf$var$WithStrictModeSupport;

});
parcelRegister("4RWMe", function(module, exports) {

$parcel$export(module.exports, "isReducedMotion", function () { return $38b9b4830afdb778$export$b7baf7667a68d87c; });
$parcel$export(module.exports, "reduceMotionAsPerUserPreference", function () { return $38b9b4830afdb778$export$f0f789643ba5a83c; });

var $axuhP = parcelRequire("axuhP");

var $dAx5m = parcelRequire("dAx5m");

var $dd4sf = parcelRequire("dd4sf");
var $38b9b4830afdb778$var$isMatchMediaAvailable = function isMatchMediaAvailable() {
    return typeof window !== "undefined" && "matchMedia" in window;
};
var $38b9b4830afdb778$export$b7baf7667a68d87c = function isReducedMotion() {
    if (!$38b9b4830afdb778$var$isMatchMediaAvailable()) return false;
    var _window$matchMedia = window.matchMedia("(prefers-reduced-motion: reduce)"), matches = _window$matchMedia.matches;
    return matches;
};
var $38b9b4830afdb778$export$c537e63161742ce3 = function useIsReducedMotion() {
    var _useState = (0, $dAx5m.useState)($38b9b4830afdb778$export$b7baf7667a68d87c), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($axuhP)))(_useState, 2), prefersReducedMotion = _useState2[0], setPrefersReducedMotion = _useState2[1];
    (0, $dAx5m.useEffect)(function() {
        if (!$38b9b4830afdb778$var$isMatchMediaAvailable()) return;
        var mediaQueryList = window.matchMedia("(prefers-reduced-motion: reduce)");
        var onChange = function onChange(event) {
            return setPrefersReducedMotion(event.matches);
        };
        return (0, $dd4sf.bind)(mediaQueryList, {
            type: "change",
            listener: onChange
        });
    }, []);
    return prefersReducedMotion;
};
var $38b9b4830afdb778$export$f0f789643ba5a83c = {
    "@media (prefers-reduced-motion: reduce)": {
        animation: "none",
        transition: "none"
    }
};
var $38b9b4830afdb778$export$ff7706047246b98b = function prefersReducedMotion() {
    return $38b9b4830afdb778$export$f0f789643ba5a83c;
};

});


parcelRegister("5HhCe", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $425ea20186b491d0$export$2e2bcd8739ae039; });

var $dAx5m = parcelRequire("dAx5m");

var $4RWMe = parcelRequire("4RWMe");

var $fVN5T = parcelRequire("fVN5T");

var $511gE = parcelRequire("511gE");
var $425ea20186b491d0$var$isAnyPreviousKeysMissingFromCurrent = function isAnyPreviousKeysMissingFromCurrent(currentMap, previous) {
    for(var i = 0; i < previous.length; i++){
        var element = previous[i];
        var _key = element.key;
        if (!currentMap[_key]) return true;
    }
    return false;
};
/**
 * This handles the case when a render updates during an exit motion.
 * If any child is mounted again we removed them from the exiting children object and return true.
 */ var $425ea20186b491d0$var$hasAnyExitingChildMountedAgain = function hasAnyExitingChildMountedAgain(exitingChildren, children) {
    var exitingChildMountedAgain = false;
    children.forEach(function(child) {
        if (exitingChildren.current[child.key]) {
            exitingChildMountedAgain = true;
            delete exitingChildren.current[child.key];
        }
    });
    return exitingChildMountedAgain;
};
/**
 * __ExitingPersistence__
 *
 * Useful for enabling elements to persist and animate away when they are removed from the DOM.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motions)
 */ var $425ea20186b491d0$var$WithoutStrictModeSupport = /*#__PURE__*/ (0, $dAx5m.memo)(function(_ref) {
    var _ref$appear = _ref.appear, appearFromProp = _ref$appear === void 0 ? false : _ref$appear, childs = _ref.children, exitThenEnter = _ref.exitThenEnter;
    var children = (0, $511gE.childrenToArray)(childs);
    var childrenObj = (0, $511gE.childrenToObj)(children);
    var previousChildren = (0, $dAx5m.useRef)([]);
    var persistedChildren = (0, $dAx5m.useRef)([]);
    var forceRender = (0, $fVN5T.useForceRender)();
    var exitingChildren = (0, $dAx5m.useRef)({});
    var appear = (0, $dAx5m.useRef)(appearFromProp);
    var defaultContextValue = (0, $dAx5m.useMemo)(function() {
        return {
            appear: appear.current,
            isExiting: false
        };
    }, // React rules of hooks says this isn't needed because mutating appear won't cause a re-render.
    // While technically true - it will trigger this to make a new object on the _next_ render which is what we want.
    // Remove this or use appear instead of appear.current and you will notice a test breaks.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        appear.current
    ]);
    if ((0, $4RWMe.isReducedMotion)()) return children;
    if (!appear.current) // We always want child motions to appear after the initial mount.
    appear.current = true;
    // This entire block can't be an effect because we need it to run synchronously during a render
    // else when elements are being removed they will be remounted instead of being updated.
    if (previousChildren.current.length && $425ea20186b491d0$var$isAnyPreviousKeysMissingFromCurrent(childrenObj, previousChildren.current)) {
        if (persistedChildren.current.length === 0 || $425ea20186b491d0$var$hasAnyExitingChildMountedAgain(exitingChildren, children)) persistedChildren.current = previousChildren.current;
        // We have persisted children now set from previous children.
        // Let's update previous children so we have it available next render.
        previousChildren.current = children;
        return (exitThenEnter ? persistedChildren.current : (0, $511gE.spliceNewElementsIntoPrevious)(children, persistedChildren.current)).map(function(child) {
            // eslint-disable-next-line @repo/internal/react/no-children-properties-access
            var currentChild = childrenObj[child.key];
            if (!currentChild) {
                // We've found an exiting child - mark it!
                exitingChildren.current[child.key] = true;
                return (0, $511gE.wrapChildWithContextProvider)(child, {
                    isExiting: true,
                    appear: true,
                    onFinish: function onFinish() {
                        delete exitingChildren.current[child.key];
                        // We will only remove the exiting elements when any subsequent exiting elements have also finished.
                        // Think of removing many items from a todo list - when removing a few over a few clicks we don't
                        // want the list jumping around when they exit.
                        if (Object.keys(exitingChildren.current).length === 0) {
                            // Set previous children to nothing.
                            // This let's us skip the next render check as it's assumed children and previous will be the same.
                            previousChildren.current = [];
                            persistedChildren.current = [];
                            // Re-render after the element(s) have animated away which will end up rendering the latest children.
                            forceRender();
                        }
                    }
                });
            }
            // This element isn't exiting.
            // Wrap context and let's continue on our way.
            return (0, $511gE.wrapChildWithContextProvider)(currentChild, defaultContextValue);
        });
    } else previousChildren.current = children;
    return children.map(function(child) {
        return (0, $511gE.wrapChildWithContextProvider)(child, defaultContextValue);
    });
});
var $425ea20186b491d0$export$2e2bcd8739ae039 = $425ea20186b491d0$var$WithoutStrictModeSupport;

});
parcelRegister("fVN5T", function(module, exports) {

$parcel$export(module.exports, "useForceRender", function () { return $b99242ea7ffff007$export$b902f6ef73d6633a; });

var $axuhP = parcelRequire("axuhP");

var $dAx5m = parcelRequire("dAx5m");
var $b99242ea7ffff007$export$b902f6ef73d6633a = function useForceRender() {
    var _useState = (0, $dAx5m.useState)({}), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($axuhP)))(_useState, 2), updateState = _useState2[1];
    var forceRender = (0, $dAx5m.useCallback)(function() {
        return updateState({});
    }, []);
    return forceRender;
};

});



parcelRegister("5sQqE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3fa83c916ef43430$export$2e2bcd8739ae039; });

var $fjHlV = parcelRequire("fjHlV");

var $dAx5m = parcelRequire("dAx5m");

var $jXhRX = parcelRequire("jXhRX");

var $iJx1D = parcelRequire("iJx1D");

var $zJeqA = parcelRequire("zJeqA");
function $3fa83c916ef43430$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $3fa83c916ef43430$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $3fa83c916ef43430$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($fjHlV)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $3fa83c916ef43430$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $3fa83c916ef43430$var$directionMotions = {
    proportional: {
        bottom: "translate3d(0, calc(5% + 4px), 0)",
        left: "translate3d(calc(-5% - 4px), 0, 0)",
        right: "translate3d(calc(5% + 4px), 0, 0)",
        top: "translate3d(0, calc(-5% - 4px), 0)"
    },
    constant: {
        bottom: "translate3d(0, 4px, 0)",
        left: "translate3d(-4px, 0, 0)",
        right: "translate3d(4px, 0, 0)",
        top: "translate3d(0, -4px, 0)"
    }
};
var $3fa83c916ef43430$var$invertedDirection = {
    top: "bottom",
    bottom: "top",
    left: "right",
    right: "left"
};
var $3fa83c916ef43430$export$8497679fcaaeceb = function fadeInAnimation(direction) {
    var distance = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "proportional";
    return {
        from: $3fa83c916ef43430$var$_objectSpread({
            opacity: 0
        }, direction !== undefined && {
            transform: $3fa83c916ef43430$var$directionMotions[distance][direction]
        }),
        "50%": {
            opacity: 1
        },
        to: {
            transform: direction !== undefined ? "none" : undefined
        }
    };
};
var $3fa83c916ef43430$export$c9190c6659ea755b = function fadeOutAnimation(direction) {
    var distance = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "proportional";
    return {
        from: {
            opacity: 1,
            transform: direction !== undefined ? "translate3d(0, 0, 0)" : undefined
        },
        to: $3fa83c916ef43430$var$_objectSpread({
            opacity: 0
        }, direction !== undefined && {
            transform: $3fa83c916ef43430$var$directionMotions[distance][direction]
        })
    };
};
/**
 * Props for controlling the behavior of the FadeIn animation
 */ /**
 * __FadeIn__
 *
 * Useful for fading in one or more elements.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motions)
 */ var $3fa83c916ef43430$var$FadeIn = function FadeIn(_ref) {
    var children = _ref.children, _ref$duration = _ref.duration, duration = _ref$duration === void 0 ? (0, $iJx1D.largeDurationMs) : _ref$duration, entranceDirection = _ref.entranceDirection, exitDirection = _ref.exitDirection, _ref$distance = _ref.distance, distance = _ref$distance === void 0 ? "proportional" : _ref$distance, onFinish = _ref.onFinish, isPaused = _ref.isPaused;
    var invertedEntranceDirection = entranceDirection && $3fa83c916ef43430$var$invertedDirection[entranceDirection];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $zJeqA.default), {
        duration: duration,
        enteringAnimation: $3fa83c916ef43430$export$8497679fcaaeceb(entranceDirection, distance),
        exitingAnimation: $3fa83c916ef43430$export$c9190c6659ea755b(exitDirection || invertedEntranceDirection, distance),
        animationTimingFunction: function animationTimingFunction() {
            return 0, $jXhRX.easeInOut;
        },
        onFinish: onFinish,
        isPaused: isPaused
    }, children);
};
var $3fa83c916ef43430$export$2e2bcd8739ae039 = $3fa83c916ef43430$var$FadeIn;

});
parcelRegister("jXhRX", function(module, exports) {

$parcel$export(module.exports, "easeInOut", function () { return $e871637e1472b10b$export$c07234257a03d5e9; });
var $e871637e1472b10b$export$c07234257a03d5e9 = "cubic-bezier(0.15,1,0.3,1)";
var $e871637e1472b10b$export$57636bb43b1ccbb0 = "cubic-bezier(0.2,0,0,1)";
var $e871637e1472b10b$export$929e5a82286172a6 = "cubic-bezier(0.8,0,0,0.8)";

});

parcelRegister("iJx1D", function(module, exports) {

$parcel$export(module.exports, "mediumDurationMs", function () { return $da360c1c8a9c35cb$export$6fa259be09e118a7; });
$parcel$export(module.exports, "largeDurationMs", function () { return $da360c1c8a9c35cb$export$9424640c29bc466d; });
/**
 * Think of this as the motion equivalent of the @atlaskit/theme `grid()`.
 */ var $da360c1c8a9c35cb$export$368bacef0dacbe05 = 25;
var $da360c1c8a9c35cb$export$2023a81c8547415f = $da360c1c8a9c35cb$export$368bacef0dacbe05 * 4;
var $da360c1c8a9c35cb$export$6fa259be09e118a7 = $da360c1c8a9c35cb$export$368bacef0dacbe05 * 14;
var $da360c1c8a9c35cb$export$9424640c29bc466d = $da360c1c8a9c35cb$export$368bacef0dacbe05 * 28;

});

parcelRegister("zJeqA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $06b65b12d67f70db$export$2e2bcd8739ae039; });

var $fjHlV = parcelRequire("fjHlV");

var $axuhP = parcelRequire("axuhP");

var $dAx5m = parcelRequire("dAx5m");

var $jVTBW = parcelRequire("jVTBW");

var $4RWMe = parcelRequire("4RWMe");

var $iJx1D = parcelRequire("iJx1D");

var $8M3Mf = parcelRequire("8M3Mf");

var $511gE = parcelRequire("511gE");

var $1S6W2 = parcelRequire("1S6W2");
function $06b65b12d67f70db$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $06b65b12d67f70db$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $06b65b12d67f70db$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($fjHlV)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $06b65b12d67f70db$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
/**
 * These are props that motions should use as their external props for consumers.
 * See [FadeIn](packages/helpers/motion/src/entering/fade-in.tsx) for an example usage.
 */ /**
 * Used to multiply the initial duration for exiting motions.
 */ var $06b65b12d67f70db$var$EXITING_MOTION_MULTIPLIER = 0.5;
/**
 * This is the base INTERNAL component used for all other entering motions.
 * This does not need Javascript to execute on the client so it will run immediately
 * for any SSR rendered React apps before the JS has executed.
 */ var $06b65b12d67f70db$var$EnteringMotion = function EnteringMotion(_ref) {
    var children = _ref.children, animationTimingFunction = _ref.animationTimingFunction, enteringAnimation = _ref.enteringAnimation, exitingAnimation = _ref.exitingAnimation, isPaused = _ref.isPaused, onFinishMotion = _ref.onFinish, _ref$duration = _ref.duration, duration = _ref$duration === void 0 ? (0, $iJx1D.largeDurationMs) : _ref$duration;
    var staggered = (0, $1S6W2.useStaggeredEntrance)();
    var _useExitingPersistenc = (0, $511gE.useExitingPersistence)(), isExiting = _useExitingPersistenc.isExiting, onExitFinished = _useExitingPersistenc.onFinish, appear = _useExitingPersistenc.appear;
    var setTimeout = (0, $8M3Mf.useSetTimeout)();
    var paused = isPaused || !staggered.isReady;
    var delay = isExiting ? 0 : staggered.delay;
    var state = isExiting ? "exiting" : "entering";
    var _useState = (0, $dAx5m.useState)(appear), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($axuhP)))(_useState, 2), hasAnimationStyles = _useState2[0], setHasAnimationStyles = _useState2[1];
    (0, $dAx5m.useEffect)(function() {
        // Tracking this to prevent changing state on an unmounted component
        var isCancelled = false;
        if (paused) return;
        // On initial mount if elements aren't set to animate on appear, we return early and callback
        if (!appear) {
            onFinishMotion && onFinishMotion(state);
            return;
        }
        // Elements may need animation styles back after initial mount (they could animate out)
        setHasAnimationStyles(true);
        setTimeout(function() {
            if (state === "exiting") onExitFinished && onExitFinished();
            if (!isCancelled) setHasAnimationStyles(false);
            onFinishMotion && onFinishMotion(state);
        }, isExiting ? duration * $06b65b12d67f70db$var$EXITING_MOTION_MULTIPLIER : duration + delay);
        return function() {
            isCancelled = true;
        };
    // We ignore this for onFinishMotion as consumers could potentially inline the function
    // which would then trigger this effect every re-render.
    // We want to make it easier for consumers so we go down this path unfortunately.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        onExitFinished,
        state,
        isExiting,
        duration,
        delay,
        paused,
        setTimeout
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $jVTBW.ClassNames), null, function(_ref2) {
        var css = _ref2.css;
        return children({
            ref: staggered.ref,
            className: hasAnimationStyles ? css($06b65b12d67f70db$var$_objectSpread($06b65b12d67f70db$var$_objectSpread({}, (0, $4RWMe.reduceMotionAsPerUserPreference)), {}, {
                animationDelay: "".concat(delay, "ms"),
                animationDuration: "".concat(isExiting ? duration * $06b65b12d67f70db$var$EXITING_MOTION_MULTIPLIER : duration, "ms"),
                animationFillMode: isExiting ? "forwards" : "backwards",
                animationName: "".concat((0, $jVTBW.keyframes)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                isExiting ? exitingAnimation || enteringAnimation : enteringAnimation)),
                animationPlayState: paused ? "paused" : "running",
                animationTimingFunction: animationTimingFunction(state)
            })) : ""
        }, state);
    });
};
var $06b65b12d67f70db$export$2e2bcd8739ae039 = $06b65b12d67f70db$var$EnteringMotion;

});
parcelRegister("8M3Mf", function(module, exports) {

$parcel$export(module.exports, "useSetTimeout", function () { return $6635bc7bd22b3199$export$4f34107a2b00f39c; });

var $dAx5m = parcelRequire("dAx5m");
var $6635bc7bd22b3199$var$getHookDeps = function getHookDeps(opts) {
    switch(opts.cleanup){
        case "next-effect":
            return undefined;
        case "unmount":
        default:
            return [];
    }
};
var $6635bc7bd22b3199$export$1775f27e7c8051ca = function useRequestAnimationFrame() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        cleanup: "unmount"
    };
    var frames = (0, $dAx5m.useRef)([]);
    (0, $dAx5m.useEffect)(function() {
        return function() {
            if (frames.current.length) {
                frames.current.forEach(function(id) {
                    return cancelAnimationFrame(id);
                });
                frames.current = [];
            }
        };
    // We dynamically set this so we either clean up on the next effect - or on unmount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, $6635bc7bd22b3199$var$getHookDeps(opts));
    return (0, $dAx5m.useCallback)(function(handler) {
        var id = requestAnimationFrame(function(time) {
            frames.current = frames.current.filter(function(frameId) {
                return frameId !== id;
            });
            handler(time);
        });
        frames.current.push(id);
    }, []);
};
var $6635bc7bd22b3199$export$4f34107a2b00f39c = function useSetTimeout() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        cleanup: "unmount"
    };
    var timeouts = (0, $dAx5m.useRef)([]);
    (0, $dAx5m.useEffect)(function() {
        return function() {
            if (timeouts.current.length) {
                timeouts.current.forEach(function(id) {
                    return clearTimeout(id);
                });
                timeouts.current = [];
            }
        };
    // We dynamically set this so we either clean up on the next effect - or on unmount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, $6635bc7bd22b3199$var$getHookDeps(opts));
    return (0, $dAx5m.useCallback)(function(handler, timeout) {
        for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
        var id = setTimeout.apply(void 0, [
            function() {
                timeouts.current = timeouts.current.filter(function(timeoutId) {
                    return timeoutId !== id;
                });
                handler();
            },
            timeout
        ].concat(args));
        timeouts.current.push(id);
    }, []);
};

});

parcelRegister("1S6W2", function(module, exports) {

$parcel$export(module.exports, "useStaggeredEntrance", function () { return $15d036bf0a5d7ecf$export$25c7213fc07ec080; });

var $axuhP = parcelRequire("axuhP");

var $dAx5m = parcelRequire("dAx5m");

var $Bb0he = parcelRequire("Bb0he");

var $fWaAn = parcelRequire("fWaAn");

var $1p8A2 = parcelRequire("1p8A2");
var $15d036bf0a5d7ecf$var$StaggeredEntranceContext = /*#__PURE__*/ (0, $dAx5m.createContext)(function() {
    return {
        isReady: true,
        delay: 0,
        ref: (0, $Bb0he.default)
    };
});
var $15d036bf0a5d7ecf$export$25c7213fc07ec080 = function useStaggeredEntrance() {
    var indentifier = (0, $1p8A2.useUniqueId)();
    var context = (0, $dAx5m.useContext)($15d036bf0a5d7ecf$var$StaggeredEntranceContext);
    return context(indentifier);
};
/**
 * For a list of elements that need to animate in,
 * this should be used in conjunction with entering components.
 * This does not need Javascript to execute so it will run immediately for any SSR rendered React apps before the JS has executed.
 *
 * Will dynamically add delay to each child entering component.
 * Unfortunately all entering components _NEED_ to be a direct descendant.
 */ var $15d036bf0a5d7ecf$var$StaggeredEntrance = function StaggeredEntrance(_ref) {
    var children = _ref.children, column = _ref.column, _ref$columns = _ref.columns, columns = _ref$columns === void 0 ? "responsive" : _ref$columns, _ref$delayStep = _ref.delayStep, delayStep = _ref$delayStep === void 0 ? 50 : _ref$delayStep;
    var elementRefs = (0, $dAx5m.useRef)([]);
    var indexes = [];
    var _useState = (0, $dAx5m.useState)(function() {
        if (typeof columns === "number") // A hardcoded columns is set so bail out and set it to that!
        return columns;
        if (typeof column === "number") // A hardcoded column is set so we will set actualColumns to be 1.
        return 1;
        // We are in "responsive" mode.
        // So we will be calculating when the Javascript executes on the client how many columns there will be.
        return 0;
    }), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($axuhP)))(_useState, 2), actualColumns = _useState2[0], setActualColumns = _useState2[1];
    (0, $fWaAn.useLayoutEffect)(function() {
        // We want to only run this code when we are in "responsive" mode.
        // It is assumed we are in responsive mode if `columns` is "responsive",
        // we have children element refs ready to be read (i.e. if there are no children this won't run as well)
        // and finally that `actualColumns` is `0` - this is because for the first render cycle `actualColumns` will be `0` (set above)
        // and then after this layout effect runs the value for `actualColumns` will then be calculated and set.
        if (columns === "responsive" && elementRefs.current.length && actualColumns === 0) {
            var currentTop = 0;
            var numberColumns = 0;
            if (elementRefs.current.length <= 1) {
                setActualColumns(1);
                return;
            }
            // We set the current top to the first elements.
            // We will be comparing this and incrementing the column count
            // until we hit an element that has a different offset top (or we run out of elements).
            currentTop = elementRefs.current[0] ? elementRefs.current[0].offsetTop : 0;
            for(var i = 0; i < elementRefs.current.length; i++){
                var child = elementRefs.current[i];
                if (!child) break;
                if (currentTop === child.offsetTop) {
                    numberColumns += 1;
                    if (elementRefs.current.length - 1 === i) setActualColumns(numberColumns);
                    continue;
                }
                setActualColumns(numberColumns);
                break;
            }
        }
    // We only want this effect to run once - on initial mount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement($15d036bf0a5d7ecf$var$StaggeredEntranceContext.Provider, {
        value: function value(id) {
            if (!indexes.includes(id)) indexes.push(id);
            var isReady = actualColumns > 0;
            var index = indexes.indexOf(id);
            var currentColumn = column || index % actualColumns;
            var currentRow = Math.floor(index / actualColumns);
            var distanceFromTopLeftElement = currentRow + currentColumn;
            // We don't want loads of elements to have the same staggered delay as it ends up looking slow for users.
            // To get around that we calculate the logarithm using `distanceFromTopLeftElement` which ends making
            // elements appear faster the further away from the top left element.
            var delay = Math.ceil(Math.log(distanceFromTopLeftElement + 1) * delayStep * 1.5) || 0;
            return {
                delay: delay,
                isReady: isReady,
                ref: function ref(element) {
                    return elementRefs.current[index] = element;
                }
            };
        }
    }, children);
};
var $15d036bf0a5d7ecf$export$2e2bcd8739ae039 = $15d036bf0a5d7ecf$var$StaggeredEntrance;

});
parcelRegister("fWaAn", function(module, exports) {

$parcel$export(module.exports, "useLayoutEffect", function () { return $b9a47be51fae362a$export$e5c5a5f917a5871c; });

var $dAx5m = parcelRequire("dAx5m");
var $b9a47be51fae362a$export$e5c5a5f917a5871c = typeof window === "undefined" ? (0, $dAx5m.useEffect) : (0, $dAx5m.useLayoutEffect);

});

parcelRegister("1p8A2", function(module, exports) {

$parcel$export(module.exports, "useUniqueId", function () { return $105ec81ced7af616$export$c485849f2e393253; });
/* eslint-disable @repo/internal/react/disallow-unstable-values */ 
var $dAx5m = parcelRequire("dAx5m");
function $105ec81ced7af616$export$c485849f2e393253() {
    var identifier = (0, $dAx5m.useRef)("");
    if (!identifier.current) identifier.current = "_" + (Number(String(Math.random()).slice(2)) + Date.now() + Math.round(performance.now())).toString(36);
    return identifier.current;
}

});




parcelRegister("jiEo7", function(module, exports) {

$parcel$export(module.exports, "Popper", function () { return $e0cf06ff3ac1b4ff$export$badac9ada3a0bdf9; });

var $lcV3t = parcelRequire("lcV3t");

var $axuhP = parcelRequire("axuhP");

var $dAx5m = parcelRequire("dAx5m");

var $2BQLr = parcelRequire("2BQLr");

// Export types from PopperJS / React Popper
var $e0cf06ff3ac1b4ff$var$constantModifiers = [
    {
        name: "flip",
        options: {
            flipVariations: false,
            padding: 5,
            boundary: "clippingParents",
            rootBoundary: "viewport"
        }
    },
    {
        name: "preventOverflow",
        options: {
            padding: 5,
            rootBoundary: "document"
        }
    }
];
function $e0cf06ff3ac1b4ff$var$defaultChildrenFn() {
    return null;
}
var $e0cf06ff3ac1b4ff$var$defaultOffset = [
    0,
    8
];
function $e0cf06ff3ac1b4ff$export$badac9ada3a0bdf9(_ref) {
    var _ref$children = _ref.children, children = _ref$children === void 0 ? $e0cf06ff3ac1b4ff$var$defaultChildrenFn : _ref$children, _ref$offset = _ref.offset, offset = _ref$offset === void 0 ? $e0cf06ff3ac1b4ff$var$defaultOffset : _ref$offset, _ref$placement = _ref.placement, placement = _ref$placement === void 0 ? "bottom-start" : _ref$placement, _ref$referenceElement = _ref.referenceElement, referenceElement = _ref$referenceElement === void 0 ? undefined : _ref$referenceElement, modifiers = _ref.modifiers, _ref$strategy = _ref.strategy, strategy = _ref$strategy === void 0 ? "fixed" : _ref$strategy;
    var _offset = (0, (/*@__PURE__*/$parcel$interopDefault($axuhP)))(offset, 2), offsetX = _offset[0], offsetY = _offset[1];
    // Merge a new offset modifier only if new offset values passed in
    var internalModifiers = (0, $dAx5m.useMemo)(function() {
        var offsetModifier = {
            name: "offset",
            options: {
                offset: [
                    offsetX,
                    offsetY
                ]
            }
        };
        return [].concat($e0cf06ff3ac1b4ff$var$constantModifiers, [
            offsetModifier
        ]);
    }, [
        offsetX,
        offsetY
    ]);
    // Merge custom props and memoize
    var mergedModifiers = (0, $dAx5m.useMemo)(function() {
        if (modifiers == null) return internalModifiers;
        return [].concat((0, (/*@__PURE__*/$parcel$interopDefault($lcV3t)))(internalModifiers), (0, (/*@__PURE__*/$parcel$interopDefault($lcV3t)))(modifiers));
    }, [
        internalModifiers,
        modifiers
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $2BQLr.Popper), {
        modifiers: mergedModifiers,
        placement: placement,
        strategy: strategy,
        referenceElement: referenceElement
    }, children);
}

});

parcelRegister("wQmdi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $062b9a56c8104b22$export$2e2bcd8739ae039; });

var $dAx5m = parcelRequire("dAx5m");

var $iZ5Vm = parcelRequire("iZ5Vm");

var $9tgGi = parcelRequire("9tgGi");

var $lkocG = parcelRequire("lkocG");
function $062b9a56c8104b22$export$2e2bcd8739ae039(_ref) {
    var _ref$zIndex = _ref.zIndex, zIndex = _ref$zIndex === void 0 ? 0 : _ref$zIndex, children = _ref.children, _ref$mountStrategy = _ref.mountStrategy, mountStrategy = _ref$mountStrategy === void 0 ? "effect" : _ref$mountStrategy;
    var isSubsequentRender = (0, $9tgGi.default)(mountStrategy);
    (0, $lkocG.default)(zIndex);
    return isSubsequentRender ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $iZ5Vm.default), {
        zIndex: zIndex
    }, children) : null;
}

});
parcelRegister("iZ5Vm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dd2284e7e1528e36$export$2e2bcd8739ae039; });

var $dAx5m = parcelRequire("dAx5m");

var $1MpXQ = parcelRequire("1MpXQ");

var $c9PXP = parcelRequire("c9PXP");
function $dd2284e7e1528e36$export$2e2bcd8739ae039(props) {
    var zIndex = props.zIndex, children = props.children;
    var container = (0, $dAx5m.useMemo)(function() {
        return (0, $c9PXP.createContainer)(zIndex);
    }, [
        zIndex
    ]);
    // This is in the render method instead of useEffect so that
    // the portal will be added to the DOM before the children render.
    // For any further changes, ensure that the container does not have a
    // parent besides the portal parent.
    (0, $c9PXP.appendPortalContainerIfNotAppended)(container);
    (0, $dAx5m.useEffect)(function() {
        return function() {
            (0, $c9PXP.removePortalContainer)(container);
        };
    }, [
        container
    ]);
    return /*#__PURE__*/ (0, $1MpXQ.createPortal)(children, container);
}

});
parcelRegister("c9PXP", function(module, exports) {

$parcel$export(module.exports, "createContainer", function () { return $8d9ea248d3a51238$export$26ae5ca175b4ec5a; });
$parcel$export(module.exports, "removePortalContainer", function () { return $8d9ea248d3a51238$export$da99f98bf3fe55b3; });
$parcel$export(module.exports, "appendPortalContainerIfNotAppended", function () { return $8d9ea248d3a51238$export$c582005add11e141; });

var $kqlBK = parcelRequire("kqlBK");
var $8d9ea248d3a51238$export$26ae5ca175b4ec5a = function createContainer(zIndex) {
    var container = document.createElement("div");
    container.className = (0, $kqlBK.portalClassName);
    container.style.zIndex = "".concat(zIndex);
    return container;
};
/**
 * Returns document body element
 * @return {number} - The document body element
 */ var $8d9ea248d3a51238$var$getBody = function getBody() {
    return document.body;
};
/**
 * Returns portal parent container. If no container exists already then it creates a new container with class name 'atlaskit-portal-container'
 * @return {Element} - The portal parent container div element
 */ var $8d9ea248d3a51238$var$getPortalParent = function getPortalParent() {
    var parentElement = document.querySelector((0, $kqlBK.portalParentSelector));
    if (!parentElement) {
        var _getBody;
        var parent = document.createElement("div");
        parent.className = (0, $kqlBK.portalParentClassName);
        // we are setting display to flex because we want each portal to create a new stacking context
        // See https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Positioning/Understanding_z_index/The_stacking_context
        parent.style.display = "flex";
        (_getBody = $8d9ea248d3a51238$var$getBody()) === null || _getBody === void 0 || _getBody.appendChild(parent);
        return parent;
    }
    return parentElement;
};
var $8d9ea248d3a51238$export$da99f98bf3fe55b3 = function removePortalContainer(container) {
    $8d9ea248d3a51238$var$getPortalParent().removeChild(container);
};
var $8d9ea248d3a51238$export$c582005add11e141 = function appendPortalContainerIfNotAppended(container) {
    if (!container.parentElement) $8d9ea248d3a51238$var$getPortalParent().appendChild(container);
};

});
parcelRegister("kqlBK", function(module, exports) {

$parcel$export(module.exports, "portalParentClassName", function () { return $ede6ff38921f266f$export$e4c79eb95c23a0da; });
$parcel$export(module.exports, "portalParentSelector", function () { return $ede6ff38921f266f$export$72f415121273627e; });
$parcel$export(module.exports, "portalClassName", function () { return $ede6ff38921f266f$export$13f57c02915787b3; });
var $ede6ff38921f266f$export$e4c79eb95c23a0da = "atlaskit-portal-container";
var $ede6ff38921f266f$export$72f415121273627e = "body > .atlaskit-portal-container";
var $ede6ff38921f266f$export$13f57c02915787b3 = "atlaskit-portal";

});



parcelRegister("9tgGi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6e53c30358844136$export$2e2bcd8739ae039; });

var $axuhP = parcelRequire("axuhP");

var $dAx5m = parcelRequire("dAx5m");

var $7zSvN = parcelRequire("7zSvN");
var $6e53c30358844136$var$useIsSubsequentRender = function useIsSubsequentRender(mountStrategy) {
    var _useState = (0, $dAx5m.useState)(false), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($axuhP)))(_useState, 2), isSubsequentRender = _useState2[0], setIsSubsequentRender = _useState2[1];
    var _useState3 = (0, $dAx5m.useState)(function() {
        return mountStrategy === "layoutEffect" ? (0, $7zSvN.useIsomorphicLayoutEffect) : (0, $dAx5m.useEffect);
    }), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($axuhP)))(_useState3, 1), useMountEffect = _useState4[0];
    useMountEffect(function() {
        setIsSubsequentRender(true);
    }, []);
    return isSubsequentRender;
};
var $6e53c30358844136$export$2e2bcd8739ae039 = $6e53c30358844136$var$useIsSubsequentRender;

});
parcelRegister("7zSvN", function(module, exports) {

$parcel$export(module.exports, "useIsomorphicLayoutEffect", function () { return $58461630bb68fd6e$export$700979bc83e7db82; });

var $dAx5m = parcelRequire("dAx5m");
var $58461630bb68fd6e$export$700979bc83e7db82 = typeof window !== "undefined" ? (0, $dAx5m.useLayoutEffect) : (0, $dAx5m.useEffect);

});


parcelRegister("lkocG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f86e3d88af9924e0$export$2e2bcd8739ae039; });

var $dAx5m = parcelRequire("dAx5m");

var $7AODJ = parcelRequire("7AODJ");

var $hsVWv = parcelRequire("hsVWv");
var $f86e3d88af9924e0$var$useFirePortalEvent = function useFirePortalEvent(zIndex) {
    var zIndexNumber = Number(zIndex);
    (0, $dAx5m.useEffect)(function() {
        (0, $hsVWv.default)((0, $7AODJ.PORTAL_MOUNT_EVENT), zIndexNumber);
        return function() {
            (0, $hsVWv.default)((0, $7AODJ.PORTAL_UNMOUNT_EVENT), zIndexNumber);
        };
    }, [
        zIndexNumber
    ]);
};
var $f86e3d88af9924e0$export$2e2bcd8739ae039 = $f86e3d88af9924e0$var$useFirePortalEvent;

});
parcelRegister("7AODJ", function(module, exports) {

$parcel$export(module.exports, "PORTAL_MOUNT_EVENT", function () { return $58732d32378e50f7$export$ed5835cc67e87f72; });
$parcel$export(module.exports, "PORTAL_UNMOUNT_EVENT", function () { return $58732d32378e50f7$export$80816bd900e5bd00; });
var $58732d32378e50f7$export$ed5835cc67e87f72 = "akPortalMount";
var $58732d32378e50f7$export$80816bd900e5bd00 = "akPortalUnmount";

});

parcelRegister("hsVWv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cb71ff665a223a7d$export$2e2bcd8739ae039; });
var $cb71ff665a223a7d$var$zIndexToName = {
    100: "card",
    200: "navigation",
    300: "dialog",
    400: "layer",
    500: "blanket",
    510: "modal",
    600: "flag",
    700: "spotlight",
    9999: "tooltip"
};
/**
 * return layer name in Atlassian design system corresponding to given z-index
 * @param {number} zIndex - z-index value for which layer name is needed
 * @returns {LayerName | null} - The layer name for given z-index. If layer name is not found then null is returned
 */ var $cb71ff665a223a7d$var$getLayerName = function getLayerName(zIndex) {
    return $cb71ff665a223a7d$var$zIndexToName.hasOwnProperty(zIndex) ? $cb71ff665a223a7d$var$zIndexToName[zIndex] : null;
};
/**
 * Creates a PortalEvent object with given eventName, given zIndex and corresponding layer
 * @param {string} eventName - either of Mount or Unmount event name
 * @param {number} zIndex - z-index value which will be included in the event to be dispatched
 * @returns {PortalEvent} - The newly created PortalEvent object
 */ var $cb71ff665a223a7d$var$getEvent = function getEvent(eventName, zIndex) {
    var detail = {
        layer: $cb71ff665a223a7d$var$getLayerName(Number(zIndex)),
        zIndex: zIndex
    };
    return new CustomEvent(eventName, {
        detail: detail
    });
};
function $cb71ff665a223a7d$export$2e2bcd8739ae039(eventName, zIndex) {
    var event = $cb71ff665a223a7d$var$getEvent(eventName, zIndex);
    window.dispatchEvent(event);
}

});



parcelRegister("lEqKj", function(module, exports) {

$parcel$export(module.exports, "CHANNEL", function () { return $fc32149b0d213357$export$44ffba16bd48dac6; });
$parcel$export(module.exports, "DEFAULT_THEME_MODE", function () { return $fc32149b0d213357$export$c93026a968943f95; });
$parcel$export(module.exports, "THEME_MODES", function () { return $fc32149b0d213357$export$6ba72c8346b4c57e; });
$parcel$export(module.exports, "borderRadius", function () { return $fc32149b0d213357$export$7a57f79000377ca2; });
$parcel$export(module.exports, "fontSize", function () { return $fc32149b0d213357$export$85e3c3ca0c6fb93; });
$parcel$export(module.exports, "layers", function () { return $fc32149b0d213357$export$7be255094ccdc533; });

var $e2xkU = parcelRequire("e2xkU");

var $8D3jt = parcelRequire("8D3jt");
var $fc32149b0d213357$export$44ffba16bd48dac6 = "__ATLASKIT_THEME__";
var $fc32149b0d213357$export$c93026a968943f95 = "light";
var $fc32149b0d213357$export$6ba72c8346b4c57e = [
    "light",
    "dark"
];
var $fc32149b0d213357$export$7a57f79000377ca2 = function borderRadius() {
    return 3;
};
var $fc32149b0d213357$export$6d8204c2cb2e06b8 = function gridSize() {
    return 8;
};
var $fc32149b0d213357$export$85e3c3ca0c6fb93 = function fontSize() {
    return 14;
};
var $fc32149b0d213357$export$6746fe0d9c9fab54 = function fontSizeSmall() {
    return 11;
};
var $fc32149b0d213357$export$a5975749f0374264 = function fontFamily() {
    return "-apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif";
};
var $fc32149b0d213357$export$356129969ee49c55 = function codeFontFamily() {
    return "'SFMono-Medium', 'SF Mono', 'Segoe UI Mono', 'Roboto Mono', 'Ubuntu Mono', Menlo, Consolas, Courier, monospace";
};
var $fc32149b0d213357$export$8e24544ddba725ee = function focusRing() {
    var color = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "var(--ds-border-focused, ".concat((0, $8D3jt.B200), ")");
    var outlineWidth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $fc32149b0d213357$export$6d8204c2cb2e06b8() / 4;
    (0, $e2xkU.default)("@atlaskit/theme", "focus ring mixin", "Please use `@atlaskit/focus-ring` instead.");
    return "\n  &:focus {\n    outline: none;\n    box-shadow: 0px 0px 0px ".concat(outlineWidth, "px ").concat(color, ";\n  }\n");
};
var $fc32149b0d213357$export$c0dd343266bc3261 = function noFocusRing() {
    return "\n  box-shadow: none;\n";
};
var $fc32149b0d213357$export$7be255094ccdc533 = {
    card: function card() {
        return 100;
    },
    navigation: function navigation() {
        return 200;
    },
    dialog: function dialog() {
        return 300;
    },
    layer: function layer() {
        return 400;
    },
    blanket: function blanket() {
        return 500;
    },
    modal: function modal() {
        return 510;
    },
    flag: function flag() {
        return 600;
    },
    spotlight: function spotlight() {
        return 700;
    },
    tooltip: function tooltip() {
        return 9999;
    }
};
var $fc32149b0d213357$export$a1b3edb637fb4f35 = function visuallyHidden() {
    (0, $e2xkU.default)("@atlaskit/theme", "visually hidden mixin", "Please use `@atlaskit/visually-hidden` instead.");
    return {
        border: "0 !important",
        clip: "rect(1px, 1px, 1px, 1px) !important",
        height: "1px !important",
        overflow: "hidden !important",
        padding: "0 !important",
        position: "absolute !important",
        width: "1px !important",
        whiteSpace: "nowrap !important"
    };
};
var $fc32149b0d213357$export$ba1d834b86d72a09 = $fc32149b0d213357$export$a1b3edb637fb4f35;
var $fc32149b0d213357$export$e497e856b4f89fcd = function skeletonShimmer() {
    return {
        css: {
            backgroundColor: "var(--ds-skeleton, ".concat((0, $8D3jt.skeleton)(), ")"),
            animationDuration: "1.5s",
            animationIterationCount: "infinite",
            animationTimingFunction: "linear",
            animationDirection: "alternate"
        },
        keyframes: {
            from: {
                backgroundColor: "var(--ds-skeleton, ".concat((0, $8D3jt.skeleton)(), ")")
            },
            to: {
                backgroundColor: "var(--ds-skeleton-subtle, ".concat((0, $8D3jt.N30A), ")")
            }
        }
    };
};

});
parcelRegister("8D3jt", function(module, exports) {

$parcel$export(module.exports, "R500", function () { return $648489225e9ca456$export$2837b5a1a71d5c02; });
$parcel$export(module.exports, "Y400", function () { return $648489225e9ca456$export$59619663aa6500fb; });
$parcel$export(module.exports, "B75", function () { return $648489225e9ca456$export$8c13c2ee36917869; });
$parcel$export(module.exports, "B200", function () { return $648489225e9ca456$export$215b7063051591f1; });
$parcel$export(module.exports, "B300", function () { return $648489225e9ca456$export$e62e8919cca44969; });
$parcel$export(module.exports, "B400", function () { return $648489225e9ca456$export$b3de0ae08da2ce64; });
$parcel$export(module.exports, "N0", function () { return $648489225e9ca456$export$29a4f05edc054374; });
$parcel$export(module.exports, "N20", function () { return $648489225e9ca456$export$9fdfb749e33cdf97; });
$parcel$export(module.exports, "N30", function () { return $648489225e9ca456$export$3e51e8f1440314ba; });
$parcel$export(module.exports, "N90", function () { return $648489225e9ca456$export$7c87d337fb91a97d; });
$parcel$export(module.exports, "N200", function () { return $648489225e9ca456$export$f563ee71e9ee74cd; });
$parcel$export(module.exports, "N400", function () { return $648489225e9ca456$export$eece5f492e429f08; });
$parcel$export(module.exports, "N500", function () { return $648489225e9ca456$export$c39c0fe0f26207ae; });
$parcel$export(module.exports, "N700", function () { return $648489225e9ca456$export$ad0bacf983b7ddaa; });
$parcel$export(module.exports, "N800", function () { return $648489225e9ca456$export$7d61b15e0da132af; });
$parcel$export(module.exports, "N20A", function () { return $648489225e9ca456$export$8d43898f60b96a82; });
$parcel$export(module.exports, "N30A", function () { return $648489225e9ca456$export$920c0d5c49070351; });
$parcel$export(module.exports, "N50A", function () { return $648489225e9ca456$export$7d3359664e8bb0e5; });
$parcel$export(module.exports, "N60A", function () { return $648489225e9ca456$export$d2d3bedfb276cac0; });
$parcel$export(module.exports, "skeleton", function () { return $648489225e9ca456$export$2a0674ff2eb10214; });
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ 
var $jWWwa = parcelRequire("jWWwa");
var $648489225e9ca456$export$4b84fd0e2c617bd = "#FFEBE6";
var $648489225e9ca456$export$b34b069eff244586 = "#FFBDAD";
var $648489225e9ca456$export$be802dd0d8b57f35 = "#FF8F73";
var $648489225e9ca456$export$60847d42f9da92a6 = "#FF7452";
var $648489225e9ca456$export$4a7404f376229999 = "#FF5630";
var $648489225e9ca456$export$2010d0fb4295b346 = "#DE350B";
var $648489225e9ca456$export$2837b5a1a71d5c02 = "#BF2600";
var $648489225e9ca456$export$8d9596b529bbb9cf = "#FFFAE6";
var $648489225e9ca456$export$41060a744ab0b7ae = "#FFF0B3";
var $648489225e9ca456$export$1cc05bbbf340e559 = "#FFE380";
var $648489225e9ca456$export$5aae31392d72caaa = "#FFC400";
var $648489225e9ca456$export$c6930421db9fa514 = "#FFAB00";
var $648489225e9ca456$export$59619663aa6500fb = "#FF991F";
var $648489225e9ca456$export$874739ea9e379ab6 = "#FF8B00";
var $648489225e9ca456$export$8a6341c32b6a3ee6 = "#E3FCEF";
var $648489225e9ca456$export$69a3bf21b9686c2b = "#ABF5D1";
var $648489225e9ca456$export$afbce1382ec95f73 = "#79F2C0";
var $648489225e9ca456$export$747d86715d4175de = "#57D9A3";
var $648489225e9ca456$export$940e1f69e873f202 = "#36B37E";
var $648489225e9ca456$export$a49394138f7b8e85 = "#00875A";
var $648489225e9ca456$export$6fa04827ac68a4fb = "#006644";
var $648489225e9ca456$export$226de0355ed012f8 = "#DEEBFF";
var $648489225e9ca456$export$8c13c2ee36917869 = "#B3D4FF";
var $648489225e9ca456$export$ecfc1dff386a3e7a = "#4C9AFF";
var $648489225e9ca456$export$215b7063051591f1 = "#2684FF";
var $648489225e9ca456$export$e62e8919cca44969 = "#0065FF";
var $648489225e9ca456$export$b3de0ae08da2ce64 = "#0052CC";
var $648489225e9ca456$export$a6ee3d71bc067634 = "#0747A6";
var $648489225e9ca456$export$363e4475840015bb = "#EAE6FF";
var $648489225e9ca456$export$4b0a4417ed59760f = "#C0B6F2";
var $648489225e9ca456$export$6011520a64d9a187 = "#998DD9";
var $648489225e9ca456$export$a7175d4e9206bc80 = "#8777D9";
var $648489225e9ca456$export$b48405b95304b5a1 = "#6554C0";
var $648489225e9ca456$export$c71e4279dd54a18d = "#5243AA";
var $648489225e9ca456$export$147899de772240ec = "#403294";
var $648489225e9ca456$export$2cf711fe14c66f06 = "#E6FCFF";
var $648489225e9ca456$export$7a8f4d33f6f9772c = "#B3F5FF";
var $648489225e9ca456$export$776c9c497ef08533 = "#79E2F2";
var $648489225e9ca456$export$69cb3ca10c1e330e = "#00C7E6";
var $648489225e9ca456$export$9dc1ef0f3f48059b = "#00B8D9";
var $648489225e9ca456$export$7c835c78b6fcdef8 = "#00A3BF";
var $648489225e9ca456$export$6036577f95c3877e = "#008DA6";
var $648489225e9ca456$export$29a4f05edc054374 = "#FFFFFF";
var $648489225e9ca456$export$e655ef011c4aa1a2 = "#FAFBFC";
var $648489225e9ca456$export$9fdfb749e33cdf97 = "#F4F5F7";
var $648489225e9ca456$export$3e51e8f1440314ba = "#EBECF0";
var $648489225e9ca456$export$1ce2d1575d444ceb = "#DFE1E6";
var $648489225e9ca456$export$8754fc7e6d8b3000 = "#C1C7D0";
var $648489225e9ca456$export$c2e91cbeada39b8b = "#B3BAC5";
var $648489225e9ca456$export$5f71e19f3a7ad9de = "#A5ADBA";
var $648489225e9ca456$export$eaa8c8a70ac22806 = "#97A0AF";
var $648489225e9ca456$export$7c87d337fb91a97d = "#8993A4";
var $648489225e9ca456$export$d6447c357493214f = "#7A869A";
var $648489225e9ca456$export$f563ee71e9ee74cd = "#6B778C";
var $648489225e9ca456$export$e2ef2124cf4024b1 = "#5E6C84";
var $648489225e9ca456$export$eece5f492e429f08 = "#505F79";
var $648489225e9ca456$export$c39c0fe0f26207ae = "#42526E";
var $648489225e9ca456$export$7090862dc3038a9f = "#344563";
var $648489225e9ca456$export$ad0bacf983b7ddaa = "#253858";
var $648489225e9ca456$export$7d61b15e0da132af = "#172B4D";
var $648489225e9ca456$export$fbda843f0a27fe96 = "#091E42";
var $648489225e9ca456$export$791e57b27ca738ef = "rgba(9, 30, 66, 0.02)";
var $648489225e9ca456$export$8d43898f60b96a82 = "rgba(9, 30, 66, 0.04)";
var $648489225e9ca456$export$920c0d5c49070351 = "rgba(9, 30, 66, 0.08)";
var $648489225e9ca456$export$46987b49aab6d1a8 = "rgba(9, 30, 66, 0.13)";
var $648489225e9ca456$export$7d3359664e8bb0e5 = "rgba(9, 30, 66, 0.25)";
var $648489225e9ca456$export$d2d3bedfb276cac0 = "rgba(9, 30, 66, 0.31)";
var $648489225e9ca456$export$6e5e7499ff054f6d = "rgba(9, 30, 66, 0.36)";
var $648489225e9ca456$export$59264b346c877fa7 = "rgba(9, 30, 66, 0.42)";
var $648489225e9ca456$export$d092757d7c64925c = "rgba(9, 30, 66, 0.48)";
var $648489225e9ca456$export$486ab785e4bac3c6 = "rgba(9, 30, 66, 0.54)";
var $648489225e9ca456$export$fba592bbc6419fea = "rgba(9, 30, 66, 0.60)";
var $648489225e9ca456$export$13609db0e6812ab8 = "rgba(9, 30, 66, 0.66)";
var $648489225e9ca456$export$fbae4efaa892d883 = "rgba(9, 30, 66, 0.71)";
var $648489225e9ca456$export$f13946d26f440ce6 = "rgba(9, 30, 66, 0.77)";
var $648489225e9ca456$export$19f58225ac52a306 = "rgba(9, 30, 66, 0.82)";
var $648489225e9ca456$export$6384f09da70e7b62 = "rgba(9, 30, 66, 0.89)";
var $648489225e9ca456$export$d0dccc730683edc2 = "rgba(9, 30, 66, 0.95)";
var $648489225e9ca456$export$2f6319cf7d736c2a = "#E6EDFA";
var $648489225e9ca456$export$95126bc8884d6634 = "#DCE5F5";
var $648489225e9ca456$export$8338d8c35d44ff1 = "#CED9EB";
var $648489225e9ca456$export$5368d76ae4fbbda7 = "#B8C7E0";
var $648489225e9ca456$export$9f0a771d16ec8d36 = "#ABBBD6";
var $648489225e9ca456$export$abcf8c38338b4aa5 = "#9FB0CC";
var $648489225e9ca456$export$97e81faa16a182c7 = "#8C9CB8";
var $648489225e9ca456$export$bfe21c59123ecf33 = "#7988A3";
var $648489225e9ca456$export$ee82aa2ea6a1558 = "#67758F";
var $648489225e9ca456$export$682927c6ed76be02 = "#56637A";
var $648489225e9ca456$export$91fd9994c5be9757 = "#455166";
var $648489225e9ca456$export$d281fbfe3cff2df6 = "#3B475C";
var $648489225e9ca456$export$3902c91d8b98a753 = "#313D52";
var $648489225e9ca456$export$8e8133c1ba5845b5 = "#283447";
var $648489225e9ca456$export$33ff357f6620b39 = "#202B3D";
var $648489225e9ca456$export$633847cf062b69e0 = "#1B2638";
var $648489225e9ca456$export$9776a6e503bdbf76 = "#121A29";
var $648489225e9ca456$export$6c813d5160dff5db = "#0E1624";
var $648489225e9ca456$export$3d4f271a500072a = "#0D1424";
var $648489225e9ca456$export$fe151285c22759ec = "rgba(13, 20, 36, 0.06)";
var $648489225e9ca456$export$a101c6190d0da34 = "rgba(13, 20, 36, 0.14)";
var $648489225e9ca456$export$4b16f52932fda51 = "rgba(13, 20, 36, 0.18)";
var $648489225e9ca456$export$a74bcd7b9845b0d8 = "rgba(13, 20, 36, 0.29)";
var $648489225e9ca456$export$9209c179316d1751 = "rgba(13, 20, 36, 0.36)";
var $648489225e9ca456$export$88f55133f636c8dd = "rgba(13, 20, 36, 0.40)";
var $648489225e9ca456$export$51126f85d1009512 = "rgba(13, 20, 36, 0.47)";
var $648489225e9ca456$export$a069b547bd23af78 = "rgba(13, 20, 36, 0.53)";
var $648489225e9ca456$export$40cce05af3b2600a = "rgba(13, 20, 36, 0.63)";
var $648489225e9ca456$export$b78942185925a0d = "rgba(13, 20, 36, 0.73)";
var $648489225e9ca456$export$e058fb44b8eaafca = "rgba(13, 20, 36, 0.78)";
var $648489225e9ca456$export$92b0b8de26920c18 = "rgba(13, 20, 36, 0.81)";
var $648489225e9ca456$export$67564f7459d3fc9e = "rgba(13, 20, 36, 0.85)";
var $648489225e9ca456$export$77868e1ca884ffa3 = "rgba(13, 20, 36, 0.89)";
var $648489225e9ca456$export$2afd71d7d3ea2cd5 = "rgba(13, 20, 36, 0.92)";
var $648489225e9ca456$export$f2a0acaab9972c70 = "rgba(13, 20, 36, 0.95)";
var $648489225e9ca456$export$9ab70e67d6475361 = "rgba(13, 20, 36, 0.97)";
var $648489225e9ca456$export$8ce1fd94bee2f412 = (0, $jWWwa.default)({
    light: "var(--ds-surface, ".concat($648489225e9ca456$export$29a4f05edc054374, ")"),
    dark: "var(--ds-surface, ".concat($648489225e9ca456$export$633847cf062b69e0, ")")
});
var $648489225e9ca456$export$b861914ea877b580 = (0, $jWWwa.default)({
    light: "var(--ds-background-selected, ".concat($648489225e9ca456$export$226de0355ed012f8, ")"),
    dark: "var(--ds-background-selected, ".concat($648489225e9ca456$export$8c13c2ee36917869, ")")
});
var $648489225e9ca456$export$3f1b020df94387af = (0, $jWWwa.default)({
    light: "var(--ds-background-neutral-hovered, ".concat($648489225e9ca456$export$3e51e8f1440314ba, ")"),
    dark: "var(--ds-background-neutral-hovered, ".concat($648489225e9ca456$export$d281fbfe3cff2df6, ")")
});
var $648489225e9ca456$export$c0183dbab98ca63e = (0, $jWWwa.default)({
    light: "var(--ds-surface-overlay, ".concat($648489225e9ca456$export$29a4f05edc054374, ")"),
    dark: "var(--ds-surface-overlay, ".concat($648489225e9ca456$export$8e8133c1ba5845b5, ")")
});
var $648489225e9ca456$export$6f093cfa640b7166 = (0, $jWWwa.default)({
    light: "var(--ds-text, ".concat($648489225e9ca456$export$fbda843f0a27fe96, ")"),
    dark: "var(--ds-text, ".concat($648489225e9ca456$export$5368d76ae4fbbda7, ")")
});
var $648489225e9ca456$export$42f8e9c698766e7a = (0, $jWWwa.default)({
    light: "var(--ds-text, ".concat($648489225e9ca456$export$7d61b15e0da132af, ")"),
    dark: "var(--ds-text, ".concat($648489225e9ca456$export$5368d76ae4fbbda7, ")")
});
var $648489225e9ca456$export$c2d157ca1c34b6e3 = (0, $jWWwa.default)({
    light: "var(--ds-text-selected, ".concat($648489225e9ca456$export$b3de0ae08da2ce64, ")"),
    dark: "var(--ds-text-selected, ".concat($648489225e9ca456$export$b3de0ae08da2ce64, ")")
});
var $648489225e9ca456$export$1905ba28d7cf066f = (0, $jWWwa.default)({
    light: "var(--ds-text-subtlest, ".concat($648489225e9ca456$export$f563ee71e9ee74cd, ")"),
    dark: "var(--ds-text-subtlest, ".concat($648489225e9ca456$export$97e81faa16a182c7, ")")
});
var $648489225e9ca456$export$bd9002130d306d39 = (0, $jWWwa.default)({
    light: "var(--ds-text-subtlest, ".concat($648489225e9ca456$export$f563ee71e9ee74cd, ")"),
    dark: "var(--ds-text-subtlest, ".concat($648489225e9ca456$export$bfe21c59123ecf33, ")")
});
var $648489225e9ca456$export$46e4a324ac90507f = (0, $jWWwa.default)({
    light: "var(--ds-text, ".concat($648489225e9ca456$export$7d61b15e0da132af, ")"),
    dark: "var(--ds-text, ".concat($648489225e9ca456$export$5368d76ae4fbbda7, ")")
});
var $648489225e9ca456$export$79f3f2b82beb0d36 = (0, $jWWwa.default)({
    light: "var(--ds-text-subtlest, ".concat($648489225e9ca456$export$f563ee71e9ee74cd, ")"),
    dark: "var(--ds-text-subtlest, ".concat($648489225e9ca456$export$97e81faa16a182c7, ")")
});
var $648489225e9ca456$export$7bb0d5c671655cc4 = (0, $jWWwa.default)({
    light: $648489225e9ca456$export$9fdfb749e33cdf97,
    dark: $648489225e9ca456$export$8e8133c1ba5845b5
});
var $648489225e9ca456$export$9c30223ca0a664fb = (0, $jWWwa.default)({
    light: "var(--ds-link, ".concat($648489225e9ca456$export$b3de0ae08da2ce64, ")"),
    dark: "var(--ds-link, ".concat($648489225e9ca456$export$ecfc1dff386a3e7a, ")")
});
var $648489225e9ca456$export$7ed258b0728b004b = (0, $jWWwa.default)({
    light: "var(--ds-link-pressed, ".concat($648489225e9ca456$export$e62e8919cca44969, ")"),
    dark: "var(--ds-link-pressed, ".concat($648489225e9ca456$export$215b7063051591f1, ")")
});
var $648489225e9ca456$export$dfa920d8decc8a59 = (0, $jWWwa.default)({
    light: "var(--ds-link-pressed, ".concat($648489225e9ca456$export$a6ee3d71bc067634, ")"),
    dark: "var(--ds-link-pressed, ".concat($648489225e9ca456$export$ecfc1dff386a3e7a, ")")
});
var $648489225e9ca456$export$6069e6ad5c78f632 = (0, $jWWwa.default)({
    light: "var(--ds-border-focused, ".concat($648489225e9ca456$export$215b7063051591f1, ")"),
    dark: "var(--ds-border-focused, ".concat($648489225e9ca456$export$215b7063051591f1, ")")
});
var $648489225e9ca456$export$9ad721cf3b3debe0 = (0, $jWWwa.default)({
    light: "var(--ds-background-brand-bold, ".concat($648489225e9ca456$export$b3de0ae08da2ce64, ")"),
    dark: "var(--ds-background-brand-bold, ".concat($648489225e9ca456$export$ecfc1dff386a3e7a, ")")
});
var $648489225e9ca456$export$2aa0182783e7e9de = (0, $jWWwa.default)({
    light: $648489225e9ca456$export$b3de0ae08da2ce64,
    dark: $648489225e9ca456$export$ecfc1dff386a3e7a
});
var $648489225e9ca456$export$8bf7dff220b82b4a = (0, $jWWwa.default)({
    light: $648489225e9ca456$export$9dc1ef0f3f48059b,
    dark: $648489225e9ca456$export$69cb3ca10c1e330e
});
var $648489225e9ca456$export$e13cce2a2d16a9d4 = (0, $jWWwa.default)({
    light: $648489225e9ca456$export$b48405b95304b5a1,
    dark: $648489225e9ca456$export$6011520a64d9a187
});
var $648489225e9ca456$export$a90204d1394caf30 = (0, $jWWwa.default)({
    light: $648489225e9ca456$export$4a7404f376229999,
    dark: $648489225e9ca456$export$4a7404f376229999
});
var $648489225e9ca456$export$594c5a8758200c32 = (0, $jWWwa.default)({
    light: $648489225e9ca456$export$c6930421db9fa514,
    dark: $648489225e9ca456$export$c6930421db9fa514
});
var $648489225e9ca456$export$955a2ebd2fb142ae = (0, $jWWwa.default)({
    light: $648489225e9ca456$export$940e1f69e873f202,
    dark: $648489225e9ca456$export$940e1f69e873f202
});
var $648489225e9ca456$export$2a0674ff2eb10214 = function skeleton() {
    return "var(--ds-skeleton, ".concat($648489225e9ca456$export$8d43898f60b96a82, ")");
};

});
parcelRegister("jWWwa", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e860d384d312ae7c$export$2e2bcd8739ae039; });
/* eslint-disable prefer-rest-params */ 
var $7mDHj = parcelRequire("7mDHj");
// Unpack custom variants, and get correct value for the current theme
function $e860d384d312ae7c$var$themedVariants(variantProp, variants) {
    return function(props) {
        var theme = (0, $7mDHj.default)(props);
        if (props && props[variantProp] && variants) {
            var modes = variants[props[variantProp]];
            if (modes && modes[theme.mode]) {
                var value = modes[theme.mode];
                if (value) return value;
                 // TS believes value can be undefined
            }
        }
        return "";
    };
}
function $e860d384d312ae7c$export$2e2bcd8739ae039(modesOrVariant, variantModes) {
    if (typeof modesOrVariant === "string") return $e860d384d312ae7c$var$themedVariants(modesOrVariant, variantModes);
    var modes = modesOrVariant;
    return function(props) {
        // Get theme from the user's props
        var theme = (0, $7mDHj.default)(props);
        // User isn't required to provide both light and dark values
        if (theme.mode in modes) {
            var value = modes[theme.mode]; // TS believes value can be undefined
            if (value) return value;
        }
        return "";
    };
}

});
parcelRegister("7mDHj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $55c96195a66c584c$export$2e2bcd8739ae039; });

var $lEqKj = parcelRequire("lEqKj");
function $55c96195a66c584c$export$2e2bcd8739ae039(props) {
    if (props && props.theme) {
        // Theme is the global Atlaskit theme
        if ((0, $lEqKj.CHANNEL) in props.theme) return props.theme[0, $lEqKj.CHANNEL];
        else if ("mode" in props.theme && (0, $lEqKj.THEME_MODES).includes(props.theme.mode)) return props.theme;
    }
    // If format not supported (or no theme provided), return standard theme
    return {
        mode: (0, $lEqKj.DEFAULT_THEME_MODE)
    };
}

});




parcelRegister("9AZ5w", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $6fc6dca95aa05e4e$export$6503ec6e8aabbaf; });
/* eslint-disable @atlaskit/design-system/no-direct-use-of-web-platform-drag-and-drop */ /**
 * We are listening directly to drag events instead of using a monitor from
 * `@atlaskit/pragmatic-drag-and-drop` to avoid the bundle size cost, as it
 * would affect almost every view in every product.
 *
 * We can reconsider this choice in the future.
 */ 
var $dd4sf = parcelRequire("dd4sf");
var $6fc6dca95aa05e4e$var$registrations = new Set();
var $6fc6dca95aa05e4e$var$cleanupEndEventListeners = null;
function $6fc6dca95aa05e4e$var$onDragStart() {
    if ($6fc6dca95aa05e4e$var$cleanupEndEventListeners) // If the cleanup function exists then we've already run this
    return;
    $6fc6dca95aa05e4e$var$cleanupEndEventListeners = (0, $dd4sf.bindAll)(window, [
        {
            type: "dragend",
            listener: $6fc6dca95aa05e4e$var$onDragEnd
        },
        {
            type: "pointerdown",
            listener: $6fc6dca95aa05e4e$var$onDragEnd
        },
        {
            type: "pointermove",
            listener: function() {
                var callCount = 0;
                return function listener() {
                    // Using 20 as it is far bigger than the most observed (3)
                    if (callCount < 20) {
                        callCount++;
                        return;
                    }
                    $6fc6dca95aa05e4e$var$onDragEnd();
                };
            }()
        }
    ]);
    var clone = Array.from($6fc6dca95aa05e4e$var$registrations);
    clone.forEach(function(subscriber) {
        subscriber.onDragStart();
    });
}
function $6fc6dca95aa05e4e$var$onDragEnd() {
    var _cleanupEndEventListe;
    (_cleanupEndEventListe = $6fc6dca95aa05e4e$var$cleanupEndEventListeners) === null || _cleanupEndEventListe === void 0 || _cleanupEndEventListe();
    $6fc6dca95aa05e4e$var$cleanupEndEventListeners = null;
    var clone = Array.from($6fc6dca95aa05e4e$var$registrations);
    clone.forEach(function(subscriber) {
        subscriber.onDragEnd();
    });
}
function $6fc6dca95aa05e4e$var$bindStartEvents() {
    return (0, $dd4sf.bindAll)(window, [
        {
            type: "dragstart",
            listener: $6fc6dca95aa05e4e$var$onDragStart
        },
        {
            type: "dragenter",
            listener: $6fc6dca95aa05e4e$var$onDragStart
        }
    ]);
}
var $6fc6dca95aa05e4e$var$cleanupStartEventListeners = null;
function $6fc6dca95aa05e4e$export$6503ec6e8aabbaf(registration) {
    // if first registration, bind event listeners
    if (!$6fc6dca95aa05e4e$var$cleanupStartEventListeners) // note: currently never unbinding these event listeners
    $6fc6dca95aa05e4e$var$cleanupStartEventListeners = $6fc6dca95aa05e4e$var$bindStartEvents();
    $6fc6dca95aa05e4e$var$registrations.add(registration);
    /**
   * The reasoning for this behavior is so that if a tooltip mounts during
   * a drag it can still be suppressed.
   *
   * We use a separate callback instead of onDragStart to avoid infinite loops.
   */ registration.onRegister({
        isDragging: $6fc6dca95aa05e4e$var$cleanupEndEventListeners !== null
    });
    return function unregister() {
        $6fc6dca95aa05e4e$var$registrations.delete(registration);
        if ($6fc6dca95aa05e4e$var$registrations.size === 0) {
            var _cleanupStartEventLis;
            (_cleanupStartEventLis = $6fc6dca95aa05e4e$var$cleanupStartEventListeners) === null || _cleanupStartEventLis === void 0 || _cleanupStartEventLis();
            $6fc6dca95aa05e4e$var$cleanupStartEventListeners = null;
        }
    };
}

});

parcelRegister("eOCYS", function(module, exports) {

$parcel$export(module.exports, "show", function () { return $ac93f900776bcd12$export$57bf213be019eeb0; });

var $j1yDb = parcelRequire("j1yDb");
// This file is a singleton for managing tooltips
var $ac93f900776bcd12$var$active = null;
function $ac93f900776bcd12$export$57bf213be019eeb0(entry) {
    var phase = "waiting-to-show";
    function isActive() {
        return Boolean($ac93f900776bcd12$var$active && $ac93f900776bcd12$var$active.entry === entry);
    }
    function cleanup() {
        if (isActive()) {
            (0, $j1yDb.clearScheduled)();
            $ac93f900776bcd12$var$active = null;
        }
    }
    function done() {
        if (isActive()) entry.done();
        phase = "done";
        cleanup();
    }
    function immediatelyHideAndDone() {
        if (isActive()) entry.hide({
            isImmediate: true
        });
        done();
    }
    function keep() {
        if (!isActive()) return;
        // aborting a wait to hide
        if (phase === "waiting-to-hide") {
            phase = "shown";
            (0, $j1yDb.clearScheduled)();
            return;
        }
        // aborting hide animation
        if (phase === "hide-animating") {
            phase = "shown";
            (0, $j1yDb.clearScheduled)();
            entry.show({
                isImmediate: false
            });
            return;
        }
    }
    function requestHide(_ref) {
        var isImmediate = _ref.isImmediate;
        if (!isActive()) return;
        // If we were not showing yet anyway; finish straight away
        if (phase === "waiting-to-show") {
            immediatelyHideAndDone();
            return;
        }
        // already waiting to hide
        if (phase === "waiting-to-hide") return;
        if (isImmediate) {
            immediatelyHideAndDone();
            return;
        }
        phase = "waiting-to-hide";
        (0, $j1yDb.scheduleTimeout)(function() {
            phase = "hide-animating";
            entry.hide({
                isImmediate: false
            });
        }, entry.delay);
    }
    function finishHideAnimation() {
        if (isActive() && phase === "hide-animating") done();
    }
    function isVisible() {
        return phase === "shown" || phase === "waiting-to-hide" || phase === "hide-animating";
    }
    function getInitialMouse() {
        if (entry.source.type === "mouse") return entry.source.mouse;
        return null;
    }
    function start() {
        var showImmediately = Boolean($ac93f900776bcd12$var$active && $ac93f900776bcd12$var$active.isVisible());
        // If there was an active tooltip; we tell it to remove itself at once!
        if ($ac93f900776bcd12$var$active) {
            (0, $j1yDb.clearScheduled)();
            $ac93f900776bcd12$var$active.entry.hide({
                isImmediate: true
            });
            $ac93f900776bcd12$var$active.entry.done();
            $ac93f900776bcd12$var$active = null;
        }
        // this tooltip is now the active tooltip
        $ac93f900776bcd12$var$active = {
            entry: entry,
            isVisible: isVisible
        };
        function show() {
            phase = "shown";
            entry.show({
                isImmediate: showImmediately
            });
        }
        if (showImmediately) {
            show();
            return;
        }
        phase = "waiting-to-show";
        (0, $j1yDb.scheduleTimeout)(show, entry.delay);
    }
    // let's get started!
    start();
    var result = {
        keep: keep,
        abort: cleanup,
        isActive: isActive,
        requestHide: requestHide,
        finishHideAnimation: finishHideAnimation,
        mousePosition: getInitialMouse()
    };
    return result;
}

});
parcelRegister("j1yDb", function(module, exports) {

$parcel$export(module.exports, "clearScheduled", function () { return $dd98f94fe801c32f$export$eaf678f6f93f5250; });
$parcel$export(module.exports, "scheduleTimeout", function () { return $dd98f94fe801c32f$export$5f4d6617421d489b; });
var $dd98f94fe801c32f$var$delayId = null;
function $dd98f94fe801c32f$export$eaf678f6f93f5250() {
    if ($dd98f94fe801c32f$var$delayId != null) {
        window.clearTimeout($dd98f94fe801c32f$var$delayId);
        $dd98f94fe801c32f$var$delayId = null;
    }
}
function $dd98f94fe801c32f$export$5f4d6617421d489b(fn, delay) {
    $dd98f94fe801c32f$export$eaf678f6f93f5250();
    $dd98f94fe801c32f$var$delayId = window.setTimeout(function() {
        $dd98f94fe801c32f$var$delayId = null;
        fn();
    }, delay);
}

});


parcelRegister("fGXut", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b6c8ecd990d760c3$export$2e2bcd8739ae039; });

var $D9YLo = parcelRequire("D9YLo");
function $b6c8ecd990d760c3$export$2e2bcd8739ae039(prefix, shouldRenderId) {
    var seed = (0, $D9YLo.useUIDSeed)();
    return shouldRenderId ? "".concat(seed(prefix)) : undefined;
}

});
parcelRegister("D9YLo", function(module, exports) {

$parcel$export(module.exports, "useUID", function () { return $075b62440a902bef$export$87d05f07e65211f1; });
$parcel$export(module.exports, "useUIDSeed", function () { return $075b62440a902bef$export$bb5ca5fba6fb4f1f; });

var $dAx5m = parcelRequire("dAx5m");

var $fYuPx = parcelRequire("fYuPx");
var $075b62440a902bef$var$generateUID = function(context) {
    var quartz = context || (0, $fYuPx.counter);
    var prefix = (0, $fYuPx.getPrefix)(quartz);
    var id = (0, $fYuPx.getId)(quartz);
    var uid = prefix + id;
    var gen = function(item) {
        return uid + quartz.uid(item);
    };
    return {
        uid: uid,
        gen: gen
    };
};
var $075b62440a902bef$var$useUIDState = function() {
    var context = (0, $dAx5m.useContext)((0, $fYuPx.source));
    var uid = (0, $dAx5m.useState)(function() {
        return $075b62440a902bef$var$generateUID(context);
    })[0];
    return uid;
};
var $075b62440a902bef$export$87d05f07e65211f1 = function() {
    var uid = $075b62440a902bef$var$useUIDState().uid;
    return uid;
};
var $075b62440a902bef$export$bb5ca5fba6fb4f1f = function() {
    var gen = $075b62440a902bef$var$useUIDState().gen;
    return gen;
};

});
parcelRegister("fYuPx", function(module, exports) {

$parcel$export(module.exports, "counter", function () { return $ba145fdd12779c7b$export$e575061ef2a070eb; });
$parcel$export(module.exports, "source", function () { return $ba145fdd12779c7b$export$b4d5da5f34fb77ad; });
$parcel$export(module.exports, "getId", function () { return $ba145fdd12779c7b$export$218c8c3169c024d2; });
$parcel$export(module.exports, "getPrefix", function () { return $ba145fdd12779c7b$export$36e24695f02d4503; });

var $dAx5m = parcelRequire("dAx5m");

var $h0JxK = parcelRequire("h0JxK");
var $ba145fdd12779c7b$export$1921362e86c73c88 = function(prefix) {
    if (prefix === void 0) prefix = "";
    return {
        value: 1,
        prefix: prefix,
        uid: (0, $h0JxK.generateUID)()
    };
};
var $ba145fdd12779c7b$export$e575061ef2a070eb = $ba145fdd12779c7b$export$1921362e86c73c88();
var $ba145fdd12779c7b$export$b4d5da5f34fb77ad = $dAx5m.createContext($ba145fdd12779c7b$export$1921362e86c73c88());
var $ba145fdd12779c7b$export$218c8c3169c024d2 = function(source) {
    return source.value++;
};
var $ba145fdd12779c7b$export$36e24695f02d4503 = function(source) {
    return source ? source.prefix : "";
};

});



parcelRegister("4Z9A5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3a144a876d3696a3$export$2e2bcd8739ae039; });
/**
 * @jsxRuntime classic
 */ /** @jsx jsx */ 
var $dAx5m = parcelRequire("dAx5m");

var $jVTBW = parcelRequire("jVTBW");

var $8D3jt = parcelRequire("8D3jt");

var $iWTkj = parcelRequire("iWTkj");
var $3a144a876d3696a3$var$baseStyles = (0, $jVTBW.css)({
    boxSizing: "border-box",
    maxWidth: "240px",
    padding: "var(--ds-space-025, 2px)".concat(" ", "var(--ds-space-075, 6px)"),
    insetBlockStart: "var(--ds-space-0, 0px)",
    insetInlineStart: "var(--ds-space-0, 0px)",
    borderRadius: "var(--ds-border-radius, 3px)",
    font: 'var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    overflowWrap: "break-word",
    wordWrap: "break-word",
    backgroundColor: "var(--ds-background-neutral-bold, ".concat((0, $8D3jt.N800), ")"),
    color: "var(--ds-text-inverse, ".concat((0, $8D3jt.N0), ")")
});
var $3a144a876d3696a3$var$truncateStyles = (0, $jVTBW.css)({
    maxWidth: "420px",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap"
});
var $3a144a876d3696a3$var$TooltipContainer = /*#__PURE__*/ (0, $dAx5m.forwardRef)(function TooltipContainer(_ref, ref) {
    var style = _ref.style, className = _ref.className, children = _ref.children, truncate = _ref.truncate, placement = _ref.placement, testId = _ref.testId, onMouseOut = _ref.onMouseOut, onMouseOver = _ref.onMouseOver, id = _ref.id;
    return (0, $jVTBW.jsx)((0, $iWTkj.default), {
        ref: ref,
        style: style,
        className: className,
        placement: placement,
        testId: testId,
        id: id,
        onMouseOut: onMouseOut,
        onMouseOver: onMouseOver,
        css: [
            $3a144a876d3696a3$var$baseStyles,
            truncate ? $3a144a876d3696a3$var$truncateStyles : null
        ]
    }, children);
});
$3a144a876d3696a3$var$TooltipContainer.displayName = "TooltipContainer";
var $3a144a876d3696a3$export$2e2bcd8739ae039 = $3a144a876d3696a3$var$TooltipContainer;

});
parcelRegister("iWTkj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dcb88f833990d4ae$export$2e2bcd8739ae039; });

var $fjHlV = parcelRequire("fjHlV");

var $dAx5m = parcelRequire("dAx5m");

var $jVTBW = parcelRequire("jVTBW");

var $lEqKj = parcelRequire("lEqKj");
function $dcb88f833990d4ae$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $dcb88f833990d4ae$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $dcb88f833990d4ae$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($fjHlV)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $dcb88f833990d4ae$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $dcb88f833990d4ae$var$VAR_PRIMITIVE_ZINDEX = "tooltipPrimitiveZindex";
var $dcb88f833990d4ae$var$primitiveStyles = (0, $jVTBW.css)({
    zindex: "var(".concat($dcb88f833990d4ae$var$VAR_PRIMITIVE_ZINDEX, ")"),
    cursor: "default"
});
var $dcb88f833990d4ae$var$TooltipPrimitive = /*#__PURE__*/ (0, $dAx5m.forwardRef)(function TooltipPrimitive(_ref, ref) {
    var style = _ref.style, className = _ref.className, children = _ref.children, placement = _ref.placement, testId = _ref.testId, onMouseOut = _ref.onMouseOut, onMouseOver = _ref.onMouseOver, id = _ref.id;
    var styleWithZIndex = $dcb88f833990d4ae$var$_objectSpread($dcb88f833990d4ae$var$_objectSpread({}, style), {}, (0, (/*@__PURE__*/$parcel$interopDefault($fjHlV)))({}, $dcb88f833990d4ae$var$VAR_PRIMITIVE_ZINDEX, (0, $lEqKj.layers).tooltip()));
    return (0, $jVTBW.jsx)("div", {
        ref: ref,
        style: styleWithZIndex,
        "data-testid": testId ? "".concat(testId, "--wrapper") : undefined
    }, (0, $jVTBW.jsx)("div", {
        role: "tooltip",
        className: className,
        onMouseOut: onMouseOut,
        onMouseOver: onMouseOver,
        css: $dcb88f833990d4ae$var$primitiveStyles,
        "data-placement": placement,
        "data-testid": testId,
        id: id
    }, children));
});
$dcb88f833990d4ae$var$TooltipPrimitive.displayName = "TooltipPrimitive";
var $dcb88f833990d4ae$export$2e2bcd8739ae039 = $dcb88f833990d4ae$var$TooltipPrimitive;

});


parcelRegister("505JK", function(module, exports) {

$parcel$export(module.exports, "getMousePosition", function () { return $3a4167096bd56646$export$642213d516a9b928; });
function $3a4167096bd56646$export$642213d516a9b928(mouseCoordinates) {
    var safeMouse = mouseCoordinates || {
        top: 0,
        left: 0
    };
    var getBoundingClientRect = function getBoundingClientRect() {
        return {
            top: safeMouse.top,
            left: safeMouse.left,
            bottom: safeMouse.top,
            right: safeMouse.left,
            width: 0,
            height: 0
        };
    };
    return {
        getBoundingClientRect: getBoundingClientRect,
        clientWidth: 0,
        clientHeight: 0
    };
}

});


parcelRegister("5B70h", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4135d73767ff1e66$export$2e2bcd8739ae039; });

var $dAx5m = parcelRequire("dAx5m");

var $ez4n6 = parcelRequire("ez4n6");

var $7ntpK = parcelRequire("7ntpK");

var $dl9Ux = parcelRequire("dl9Ux");

var $2H0O3 = parcelRequire("2H0O3");
/**
 * __Use icon button__
 *
 * A React hook that accepts a set of icon Button props,
 * and processes them to return consistent base props for usage
 * across IconButton and LinkIconButton variants.
 *
 * @private
 */ var $4135d73767ff1e66$var$useIconButton = function useIconButton(_ref) {
    var analyticsContext = _ref.analyticsContext, appearance = _ref.appearance, autoFocus = _ref.autoFocus, buttonType = _ref.buttonType, Icon = _ref.icon, interactionName = _ref.interactionName, isDisabled = _ref.isDisabled, isSelected = _ref.isSelected, isLoading = _ref.isLoading, label = _ref.label, onClick = _ref.onClick, onMouseDownCapture = _ref.onMouseDownCapture, onMouseUpCapture = _ref.onMouseUpCapture, onKeyDownCapture = _ref.onKeyDownCapture, onKeyUpCapture = _ref.onKeyUpCapture, onTouchStartCapture = _ref.onTouchStartCapture, onTouchEndCapture = _ref.onTouchEndCapture, onPointerDownCapture = _ref.onPointerDownCapture, onPointerUpCapture = _ref.onPointerUpCapture, onClickCapture = _ref.onClickCapture, overlay = _ref.overlay, ref = _ref.ref, shape = _ref.shape, shouldFitContainer = _ref.shouldFitContainer, spacing = _ref.spacing, UNSAFE_size = _ref.UNSAFE_size;
    var hasOverlay = Boolean(overlay || isLoading);
    var isCircle = shape === "circle";
    var baseProps = (0, $2H0O3.default)({
        analyticsContext: analyticsContext,
        appearance: appearance,
        autoFocus: autoFocus,
        buttonType: buttonType,
        children: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $7ntpK.default), {
            type: "icon",
            hasOverlay: hasOverlay
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement(Icon, {
            label: "",
            size: UNSAFE_size,
            color: "currentColor"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $ez4n6.default), null, label)),
        interactionName: interactionName,
        isDisabled: isDisabled,
        isLoading: isLoading,
        isSelected: isSelected,
        isIconButton: true,
        isCircle: isCircle,
        onClick: onClick,
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onTouchStartCapture: onTouchStartCapture,
        onTouchEndCapture: onTouchEndCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onClickCapture: onClickCapture,
        overlay: isLoading ? (0, $dl9Ux.default)({
            spacing: spacing,
            appearance: appearance,
            isDisabled: isDisabled,
            isSelected: isSelected
        }) : overlay,
        ref: ref,
        shouldFitContainer: shouldFitContainer,
        spacing: spacing
    });
    return baseProps;
};
var $4135d73767ff1e66$export$2e2bcd8739ae039 = $4135d73767ff1e66$var$useIconButton;

});
parcelRegister("7ntpK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $55f17f73d74c64e5$export$2e2bcd8739ae039; });

var $lcV3t = parcelRequire("lcV3t");

var $dAx5m = parcelRequire("dAx5m");

var $8WEMR = parcelRequire("8WEMR");
var $5BICO = parcelRequire("5BICO");
var $55f17f73d74c64e5$var$textStyles = (0, $5BICO.xcss)({
    // content can grow and shrink
    flexGrow: 1,
    flexShrink: 1,
    // ellipsis for overflow text
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap"
});
var $55f17f73d74c64e5$var$iconStyles = (0, $5BICO.xcss)({
    display: "flex",
    // icon size cannot grow and shrink
    flexGrow: 0,
    flexShrink: 0,
    alignSelf: "center",
    fontSize: 0,
    lineHeight: 0,
    userSelect: "none"
});
var $55f17f73d74c64e5$var$commonStyles = (0, $5BICO.xcss)({
    transition: "opacity 0.3s"
});
var $55f17f73d74c64e5$var$fadeStyles = (0, $5BICO.xcss)({
    opacity: 0
});
/**
 * These CSS variables consumed by the new icons, to allow them to have appropriate
 * padding inside Button while also maintaining spacing for the existing icons.
 *
 * These styles can be removed once the new icons are fully rolled out, feature flag
 * platform.design-system-team.enable-new-icons is cleaned up,
 * and we bump Button to set padding based on the new icons.
 */ var $55f17f73d74c64e5$var$beforeIconStyles = (0, $5BICO.xcss)({
    // @ts-ignore
    "--ds--button--new-icon-padding-start": "var(--ds-space-050, 4px)",
    // @ts-ignore
    "--ds--button--new-icon-padding-end": "var(--ds-space-025, 2px)"
});
var $55f17f73d74c64e5$var$afterIconStyles = (0, $5BICO.xcss)({
    // @ts-ignore
    "--ds--button--new-icon-padding-start": "var(--ds-space-025, 2px)",
    // @ts-ignore
    "--ds--button--new-icon-padding-end": "var(--ds-space-050, 4px)"
});
/**
 * __Content__
 *
 * Used for slots within a Button, including icons and text content.
 */ var $55f17f73d74c64e5$var$Content = function Content(_ref) {
    var children = _ref.children, _ref$type = _ref.type, type = _ref$type === void 0 ? "text" : _ref$type, hasOverlay = _ref.hasOverlay, position = _ref.position;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $8WEMR.default), {
        as: "span",
        xcss: [
            $55f17f73d74c64e5$var$commonStyles
        ].concat((0, (/*@__PURE__*/$parcel$interopDefault($lcV3t)))(type === "text" ? [
            $55f17f73d74c64e5$var$textStyles
        ] : [
            $55f17f73d74c64e5$var$iconStyles
        ]), (0, (/*@__PURE__*/$parcel$interopDefault($lcV3t)))(hasOverlay ? [
            $55f17f73d74c64e5$var$fadeStyles
        ] : []), (0, (/*@__PURE__*/$parcel$interopDefault($lcV3t)))(position === "before" ? [
            $55f17f73d74c64e5$var$beforeIconStyles
        ] : []), (0, (/*@__PURE__*/$parcel$interopDefault($lcV3t)))(position === "after" ? [
            $55f17f73d74c64e5$var$afterIconStyles
        ] : []))
    }, children);
};
var $55f17f73d74c64e5$export$2e2bcd8739ae039 = $55f17f73d74c64e5$var$Content;

});

parcelRegister("dl9Ux", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9b64eca42c588533$export$2e2bcd8739ae039; });

var $dAx5m = parcelRequire("dAx5m");

var $3BH8Y = parcelRequire("3BH8Y");
function $9b64eca42c588533$var$getIconSpacing(spacing) {
    switch(spacing){
        case "compact":
            return "small";
        case "none":
            return "xsmall";
        default:
            return "medium";
    }
}
function $9b64eca42c588533$var$getSpinnerAppearance(_ref) {
    var appearance = _ref.appearance, isDisabled = _ref.isDisabled, isSelected = _ref.isSelected;
    if (isDisabled || isSelected) return "inherit";
    if (appearance === "primary" || appearance === "danger" || appearance === "discovery") return "invert";
    return "inherit";
}
function $9b64eca42c588533$export$2e2bcd8739ae039(_ref2) {
    var appearance = _ref2.appearance, spacing = _ref2.spacing, isDisabled = _ref2.isDisabled, isSelected = _ref2.isSelected;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $3BH8Y.default), {
        label: ", Loading",
        size: $9b64eca42c588533$var$getIconSpacing(spacing),
        appearance: $9b64eca42c588533$var$getSpinnerAppearance({
            appearance: appearance,
            isDisabled: isDisabled,
            isSelected: isSelected
        })
    });
}

});
parcelRegister("3BH8Y", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2a064b390394b2b4$export$2e2bcd8739ae039; });
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $dAx5m = parcelRequire("dAx5m");

var $jVTBW = parcelRequire("jVTBW");

var $kqsmh = parcelRequire("kqsmh");

var $bS5a2 = parcelRequire("bS5a2");

var $aAJhf = parcelRequire("aAJhf");
/**
 * Returns the appropriate circle stroke color.
 */ function $2a064b390394b2b4$var$getStrokeColor(appearance) {
    return appearance === "inherit" ? "var(--ds-icon-subtle, ".concat((0, $bS5a2.N500), ")") : "var(--ds-icon-inverse, ".concat((0, $bS5a2.N0), ")");
}
var $2a064b390394b2b4$var$rotate = (0, $jVTBW.keyframes)({
    to: {
        transform: "rotate(360deg)"
    }
});
var $2a064b390394b2b4$var$rotateStyles = (0, $jVTBW.css)({
    animation: "".concat($2a064b390394b2b4$var$rotate, " 0.86s infinite"),
    animationTimingFunction: "cubic-bezier(0.4, 0.15, 0.6, 0.85)",
    transformOrigin: "center"
});
/**
 * There are three parts to the load in animation:
 * 1. Fade in
 * 2. Accelerated spin
 * 3. Stretch the spinner line
 */ var $2a064b390394b2b4$var$loadIn = (0, $jVTBW.keyframes)({
    from: {
        transform: "rotate(50deg)",
        opacity: 0,
        strokeDashoffset: 60
    },
    to: {
        transform: "rotate(230deg)",
        opacity: 1,
        strokeDashoffset: 50
    }
});
var $2a064b390394b2b4$var$loadInStyles = (0, $jVTBW.css)({
    animation: "".concat($2a064b390394b2b4$var$loadIn, " 1s ease-in-out"),
    /**
   * When the animation completes, stay at the last frame of the animation.
   */ animationFillMode: "forwards",
    /**
   * We are going to animate this in.
   */ opacity: 0
});
var $2a064b390394b2b4$var$wrapperStyles = (0, $jVTBW.css)({
    display: "inline-flex",
    /**
   * Align better inline with text.
   */ verticalAlign: "middle"
});
var $2a064b390394b2b4$var$circleStyles = (0, $jVTBW.css)({
    fill: "none",
    strokeDasharray: 60,
    strokeDashoffset: "inherit",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    "@media screen and (forced-colors: active)": {
        filter: "grayscale(100%)",
        stroke: "CanvasText"
    }
});
/**
 * `useLayoutEffect` is being used in SSR safe form. On the server, this work doesn’t need to run.
 * `useEffect` is used in-place, because `useEffect` is not run on the server and it matches types
 * which makes things simpler than doing an `isServer` check or a `null` check.
 *
 * @see https://hello.atlassian.net/wiki/spaces/DST/pages/2081696628/DSTDACI-010+-+Interaction+Tracing+hooks+in+DS+components
 */ var $2a064b390394b2b4$var$useLayoutEffect = typeof window === "undefined" ? (0, $dAx5m.useEffect) : (0, $dAx5m.useLayoutEffect);
/**
 * __Spinner__
 *
 * A spinner is an animated spinning icon that lets users know content is being loaded.
 *
 * - [Examples](https://atlassian.design/components/spinner/examples)
 * - [Code](https://atlassian.design/components/spinner/code)
 * - [Usage](https://atlassian.design/components/spinner/usage)
 */ var $2a064b390394b2b4$var$Spinner = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).forwardRef(function Spinner(_ref, ref) {
    var _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "inherit" : _ref$appearance, _ref$delay = _ref.delay, delay = _ref$delay === void 0 ? 0 : _ref$delay, interactionName = _ref.interactionName, label = _ref.label, _ref$size = _ref.size, providedSize = _ref$size === void 0 ? "medium" : _ref$size, testId = _ref.testId;
    var size = typeof providedSize === "number" ? providedSize : (0, $aAJhf.presetSizes)[providedSize];
    var animationDelay = "".concat(delay, "ms");
    var stroke = $2a064b390394b2b4$var$getStrokeColor(appearance);
    var context = (0, $dAx5m.useContext)((0, $kqsmh.default));
    $2a064b390394b2b4$var$useLayoutEffect(function() {
        if (context != null) return context.hold(interactionName);
    }, [
        context,
        interactionName
    ]);
    /**
   * The Spinner animation uses a combination of two
   * css animations on two separate elements.
   */ return (0, $jVTBW.jsx)("span", {
        /**
     * This span exists to off-load animations from the circle element,
     * which were causing performance issues (style recalculations)
     * on Safari and older versions of Chrome.
     *
     * This can be removed and styles placed back on the circle element once
     * Safari fixes this bug and off-loads rendering to the GPU from the CPU.
     */ css: [
            $2a064b390394b2b4$var$wrapperStyles,
            $2a064b390394b2b4$var$rotateStyles
        ],
        "data-testid": testId && "".concat(testId, "-wrapper"),
        style: {
            animationDelay: animationDelay,
            width: size,
            height: size
        }
    }, (0, $jVTBW.jsx)("svg", {
        height: size,
        width: size,
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        "data-testid": testId,
        ref: ref,
        "aria-label": label || undefined,
        css: $2a064b390394b2b4$var$loadInStyles,
        style: {
            animationDelay: animationDelay
        },
        role: label ? "img" : "none"
    }, (0, $jVTBW.jsx)("circle", {
        cx: "8",
        cy: "8",
        r: "7",
        css: $2a064b390394b2b4$var$circleStyles,
        style: {
            stroke: stroke
        }
    })));
}));
var $2a064b390394b2b4$export$2e2bcd8739ae039 = $2a064b390394b2b4$var$Spinner;

});
parcelRegister("bS5a2", function(module, exports) {

$parcel$export(module.exports, "N0", function () { return $8a48bdafdbb6e6d4$export$29a4f05edc054374; });
$parcel$export(module.exports, "N500", function () { return $8a48bdafdbb6e6d4$export$c39c0fe0f26207ae; });
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // Reds
var $8a48bdafdbb6e6d4$export$4b84fd0e2c617bd = "#FFEBE6";
var $8a48bdafdbb6e6d4$export$b34b069eff244586 = "#FFBDAD";
var $8a48bdafdbb6e6d4$export$be802dd0d8b57f35 = "#FF8F73";
var $8a48bdafdbb6e6d4$export$60847d42f9da92a6 = "#FF7452";
var $8a48bdafdbb6e6d4$export$4a7404f376229999 = "#FF5630";
var $8a48bdafdbb6e6d4$export$2010d0fb4295b346 = "#DE350B";
var $8a48bdafdbb6e6d4$export$2837b5a1a71d5c02 = "#BF2600";
var $8a48bdafdbb6e6d4$export$8d9596b529bbb9cf = "#FFFAE6";
var $8a48bdafdbb6e6d4$export$41060a744ab0b7ae = "#FFF0B3";
var $8a48bdafdbb6e6d4$export$1cc05bbbf340e559 = "#FFE380";
var $8a48bdafdbb6e6d4$export$5aae31392d72caaa = "#FFC400";
var $8a48bdafdbb6e6d4$export$c6930421db9fa514 = "#FFAB00";
var $8a48bdafdbb6e6d4$export$59619663aa6500fb = "#FF991F";
var $8a48bdafdbb6e6d4$export$874739ea9e379ab6 = "#FF8B00";
var $8a48bdafdbb6e6d4$export$8a6341c32b6a3ee6 = "#E3FCEF";
var $8a48bdafdbb6e6d4$export$69a3bf21b9686c2b = "#ABF5D1";
var $8a48bdafdbb6e6d4$export$afbce1382ec95f73 = "#79F2C0";
var $8a48bdafdbb6e6d4$export$747d86715d4175de = "#57D9A3";
var $8a48bdafdbb6e6d4$export$940e1f69e873f202 = "#36B37E";
var $8a48bdafdbb6e6d4$export$a49394138f7b8e85 = "#00875A";
var $8a48bdafdbb6e6d4$export$6fa04827ac68a4fb = "#006644";
var $8a48bdafdbb6e6d4$export$226de0355ed012f8 = "#DEEBFF";
var $8a48bdafdbb6e6d4$export$8c13c2ee36917869 = "#B3D4FF";
var $8a48bdafdbb6e6d4$export$ecfc1dff386a3e7a = "#4C9AFF";
var $8a48bdafdbb6e6d4$export$215b7063051591f1 = "#2684FF";
var $8a48bdafdbb6e6d4$export$e62e8919cca44969 = "#0065FF";
var $8a48bdafdbb6e6d4$export$b3de0ae08da2ce64 = "#0052CC";
var $8a48bdafdbb6e6d4$export$a6ee3d71bc067634 = "#0747A6";
var $8a48bdafdbb6e6d4$export$363e4475840015bb = "#EAE6FF";
var $8a48bdafdbb6e6d4$export$4b0a4417ed59760f = "#C0B6F2";
var $8a48bdafdbb6e6d4$export$6011520a64d9a187 = "#998DD9";
var $8a48bdafdbb6e6d4$export$a7175d4e9206bc80 = "#8777D9";
var $8a48bdafdbb6e6d4$export$b48405b95304b5a1 = "#6554C0";
var $8a48bdafdbb6e6d4$export$c71e4279dd54a18d = "#5243AA";
var $8a48bdafdbb6e6d4$export$147899de772240ec = "#403294";
var $8a48bdafdbb6e6d4$export$2cf711fe14c66f06 = "#E6FCFF";
var $8a48bdafdbb6e6d4$export$7a8f4d33f6f9772c = "#B3F5FF";
var $8a48bdafdbb6e6d4$export$776c9c497ef08533 = "#79E2F2";
var $8a48bdafdbb6e6d4$export$69cb3ca10c1e330e = "#00C7E6";
var $8a48bdafdbb6e6d4$export$9dc1ef0f3f48059b = "#00B8D9";
var $8a48bdafdbb6e6d4$export$7c835c78b6fcdef8 = "#00A3BF";
var $8a48bdafdbb6e6d4$export$6036577f95c3877e = "#008DA6";
var $8a48bdafdbb6e6d4$export$29a4f05edc054374 = "#FFFFFF";
var $8a48bdafdbb6e6d4$export$e655ef011c4aa1a2 = "#FAFBFC";
var $8a48bdafdbb6e6d4$export$9fdfb749e33cdf97 = "#F4F5F7";
var $8a48bdafdbb6e6d4$export$3e51e8f1440314ba = "#EBECF0";
var $8a48bdafdbb6e6d4$export$1ce2d1575d444ceb = "#DFE1E6";
var $8a48bdafdbb6e6d4$export$8754fc7e6d8b3000 = "#C1C7D0";
var $8a48bdafdbb6e6d4$export$c2e91cbeada39b8b = "#B3BAC5";
var $8a48bdafdbb6e6d4$export$5f71e19f3a7ad9de = "#A5ADBA";
var $8a48bdafdbb6e6d4$export$eaa8c8a70ac22806 = "#97A0AF";
var $8a48bdafdbb6e6d4$export$7c87d337fb91a97d = "#8993A4";
var $8a48bdafdbb6e6d4$export$d6447c357493214f = "#7A869A";
var $8a48bdafdbb6e6d4$export$f563ee71e9ee74cd = "#6B778C";
var $8a48bdafdbb6e6d4$export$e2ef2124cf4024b1 = "#5E6C84";
var $8a48bdafdbb6e6d4$export$eece5f492e429f08 = "#505F79";
var $8a48bdafdbb6e6d4$export$c39c0fe0f26207ae = "#42526E";
var $8a48bdafdbb6e6d4$export$7090862dc3038a9f = "#344563";
var $8a48bdafdbb6e6d4$export$ad0bacf983b7ddaa = "#253858";
var $8a48bdafdbb6e6d4$export$7d61b15e0da132af = "#172B4D";
var $8a48bdafdbb6e6d4$export$fbda843f0a27fe96 = "#091E42";
var $8a48bdafdbb6e6d4$export$791e57b27ca738ef = "rgba(9, 30, 66, 0.02)";
var $8a48bdafdbb6e6d4$export$8d43898f60b96a82 = "rgba(9, 30, 66, 0.04)";
var $8a48bdafdbb6e6d4$export$920c0d5c49070351 = "rgba(9, 30, 66, 0.08)";
var $8a48bdafdbb6e6d4$export$46987b49aab6d1a8 = "rgba(9, 30, 66, 0.13)";
var $8a48bdafdbb6e6d4$export$7d3359664e8bb0e5 = "rgba(9, 30, 66, 0.25)";
var $8a48bdafdbb6e6d4$export$d2d3bedfb276cac0 = "rgba(9, 30, 66, 0.31)";
var $8a48bdafdbb6e6d4$export$6e5e7499ff054f6d = "rgba(9, 30, 66, 0.36)";
var $8a48bdafdbb6e6d4$export$59264b346c877fa7 = "rgba(9, 30, 66, 0.42)";
var $8a48bdafdbb6e6d4$export$d092757d7c64925c = "rgba(9, 30, 66, 0.48)";
var $8a48bdafdbb6e6d4$export$486ab785e4bac3c6 = "rgba(9, 30, 66, 0.54)";
var $8a48bdafdbb6e6d4$export$fba592bbc6419fea = "rgba(9, 30, 66, 0.60)";
var $8a48bdafdbb6e6d4$export$13609db0e6812ab8 = "rgba(9, 30, 66, 0.66)";
var $8a48bdafdbb6e6d4$export$fbae4efaa892d883 = "rgba(9, 30, 66, 0.71)";
var $8a48bdafdbb6e6d4$export$f13946d26f440ce6 = "rgba(9, 30, 66, 0.77)";
var $8a48bdafdbb6e6d4$export$19f58225ac52a306 = "rgba(9, 30, 66, 0.82)";
var $8a48bdafdbb6e6d4$export$6384f09da70e7b62 = "rgba(9, 30, 66, 0.89)";
var $8a48bdafdbb6e6d4$export$d0dccc730683edc2 = "rgba(9, 30, 66, 0.95)";
var $8a48bdafdbb6e6d4$export$2f6319cf7d736c2a = "#E6EDFA";
var $8a48bdafdbb6e6d4$export$95126bc8884d6634 = "#DCE5F5";
var $8a48bdafdbb6e6d4$export$8338d8c35d44ff1 = "#CED9EB";
var $8a48bdafdbb6e6d4$export$5368d76ae4fbbda7 = "#B8C7E0";
var $8a48bdafdbb6e6d4$export$9f0a771d16ec8d36 = "#ABBBD6";
var $8a48bdafdbb6e6d4$export$abcf8c38338b4aa5 = "#9FB0CC";
var $8a48bdafdbb6e6d4$export$97e81faa16a182c7 = "#8C9CB8";
var $8a48bdafdbb6e6d4$export$bfe21c59123ecf33 = "#7988A3";
var $8a48bdafdbb6e6d4$export$ee82aa2ea6a1558 = "#67758F";
var $8a48bdafdbb6e6d4$export$682927c6ed76be02 = "#56637A";
var $8a48bdafdbb6e6d4$export$91fd9994c5be9757 = "#455166";
var $8a48bdafdbb6e6d4$export$d281fbfe3cff2df6 = "#3B475C";
var $8a48bdafdbb6e6d4$export$3902c91d8b98a753 = "#313D52";
var $8a48bdafdbb6e6d4$export$8e8133c1ba5845b5 = "#283447";
var $8a48bdafdbb6e6d4$export$33ff357f6620b39 = "#202B3D";
var $8a48bdafdbb6e6d4$export$633847cf062b69e0 = "#1B2638";
var $8a48bdafdbb6e6d4$export$9776a6e503bdbf76 = "#121A29";
var $8a48bdafdbb6e6d4$export$6c813d5160dff5db = "#0E1624";
var $8a48bdafdbb6e6d4$export$3d4f271a500072a = "#0D1424";
var $8a48bdafdbb6e6d4$export$fe151285c22759ec = "rgba(13, 20, 36, 0.06)";
var $8a48bdafdbb6e6d4$export$a101c6190d0da34 = "rgba(13, 20, 36, 0.14)";
var $8a48bdafdbb6e6d4$export$4b16f52932fda51 = "rgba(13, 20, 36, 0.18)";
var $8a48bdafdbb6e6d4$export$a74bcd7b9845b0d8 = "rgba(13, 20, 36, 0.29)";
var $8a48bdafdbb6e6d4$export$9209c179316d1751 = "rgba(13, 20, 36, 0.36)";
var $8a48bdafdbb6e6d4$export$88f55133f636c8dd = "rgba(13, 20, 36, 0.40)";
var $8a48bdafdbb6e6d4$export$51126f85d1009512 = "rgba(13, 20, 36, 0.47)";
var $8a48bdafdbb6e6d4$export$a069b547bd23af78 = "rgba(13, 20, 36, 0.53)";
var $8a48bdafdbb6e6d4$export$40cce05af3b2600a = "rgba(13, 20, 36, 0.63)";
var $8a48bdafdbb6e6d4$export$b78942185925a0d = "rgba(13, 20, 36, 0.73)";
var $8a48bdafdbb6e6d4$export$e058fb44b8eaafca = "rgba(13, 20, 36, 0.78)";
var $8a48bdafdbb6e6d4$export$92b0b8de26920c18 = "rgba(13, 20, 36, 0.81)";
var $8a48bdafdbb6e6d4$export$67564f7459d3fc9e = "rgba(13, 20, 36, 0.85)";
var $8a48bdafdbb6e6d4$export$77868e1ca884ffa3 = "rgba(13, 20, 36, 0.89)";
var $8a48bdafdbb6e6d4$export$2afd71d7d3ea2cd5 = "rgba(13, 20, 36, 0.92)";
var $8a48bdafdbb6e6d4$export$f2a0acaab9972c70 = "rgba(13, 20, 36, 0.95)";
var $8a48bdafdbb6e6d4$export$9ab70e67d6475361 = "rgba(13, 20, 36, 0.97)";

});

parcelRegister("aAJhf", function(module, exports) {

$parcel$export(module.exports, "presetSizes", function () { return $7b6063439e3d6367$export$4e9f1640bbe7a1a8; });
var $7b6063439e3d6367$export$4e9f1640bbe7a1a8 = {
    xsmall: 8,
    small: 16,
    medium: 24,
    large: 48,
    xlarge: 96
};

});



parcelRegister("2H0O3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1f603905e59a1e7f$export$2e2bcd8739ae039; });

var $fjHlV = parcelRequire("fjHlV");

var $dAx5m = parcelRequire("dAx5m");

var $2Dg3J = parcelRequire("2Dg3J");

var $gMIYi = parcelRequire("gMIYi");

var $8vWLu = parcelRequire("8vWLu");

var $8WEMR = parcelRequire("8WEMR");
var $5BICO = parcelRequire("5BICO");

var $8D3jt = parcelRequire("8D3jt");

var $lEqKj = parcelRequire("lEqKj");

var $6rjas = parcelRequire("6rjas");

var $7cR6G = parcelRequire("7cR6G");
function $1f603905e59a1e7f$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $1f603905e59a1e7f$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $1f603905e59a1e7f$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($fjHlV)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $1f603905e59a1e7f$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $1f603905e59a1e7f$var$fontSize = (0, $lEqKj.fontSize)();
var $1f603905e59a1e7f$var$buttonStyles = (0, $5BICO.xcss)({
    display: "inline-flex",
    boxSizing: "border-box",
    width: "auto",
    maxWidth: "100%",
    position: "relative",
    alignItems: "baseline",
    justifyContent: "center",
    columnGap: "space.050",
    background: "var(--ds-background-neutral, ".concat($8D3jt.N20A, ")"),
    borderRadius: "border.radius.100",
    borderWidth: "border.width.0",
    // @ts-expect-error
    color: "var(--ds-text, ".concat($8D3jt.N500, ")"),
    flexShrink: 0,
    height: "".concat(32 / $1f603905e59a1e7f$var$fontSize, "em"),
    paddingInlineEnd: "space.150",
    paddingInlineStart: "space.150",
    textAlign: "center",
    transition: "background 0.1s ease-out, box-shadow 0.15s cubic-bezier(0.47, 0.03, 0.49, 1.38)",
    verticalAlign: "middle",
    ":visited": {
        // @ts-expect-error
        color: "var(--ds-text, ".concat($8D3jt.N500, ")")
    }
});
var $1f603905e59a1e7f$var$baseButtonStyles = (0, $5BICO.xcss)({
    fontFamily: "inherit",
    fontSize: "inherit",
    fontStyle: "normal",
    fontWeight: 500,
    lineHeight: "".concat(32 / $1f603905e59a1e7f$var$fontSize, "em"),
    paddingBlock: "space.0"
});
var $1f603905e59a1e7f$var$tokenizedButtonStyles = (0, $5BICO.xcss)({
    font: 'var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    fontWeight: "var(--ds-font-weight-medium, 500)",
    paddingBlock: "space.075"
});
var $1f603905e59a1e7f$var$defaultInteractiveStyles = (0, $5BICO.xcss)({
    ":hover": {
        background: "var(--ds-background-neutral-hovered, #091e4214)",
        // @ts-expect-error
        color: "var(--ds-text, ".concat($8D3jt.N500, ")"),
        transitionDuration: "0s, 0.15s"
    },
    ":active": {
        background: "var(--ds-background-neutral-pressed, ".concat($8D3jt.B75, ")"),
        // @ts-expect-error
        color: "var(--ds-text, ".concat($8D3jt.B400, ")"),
        transitionDuration: "0s, 0s"
    }
});
var $1f603905e59a1e7f$var$primaryStyles = (0, $5BICO.xcss)({
    background: "var(--ds-background-brand-bold, #0052CC)",
    // @ts-expect-error
    color: "var(--ds-text-inverse, #FFFFFF)",
    ":visited": {
        // @ts-expect-error
        color: "var(--ds-text-inverse, #FFFFFF)"
    }
});
var $1f603905e59a1e7f$var$primaryInteractiveStyles = (0, $5BICO.xcss)({
    ":hover": {
        // @ts-expect-error
        color: "var(--ds-text-inverse, #FFFFFF)",
        background: "var(--ds-background-brand-bold-hovered, #0065FF)"
    },
    ":active": {
        // @ts-expect-error
        color: "var(--ds-text-inverse, #FFFFFF)",
        background: "var(--ds-background-brand-bold-pressed, #0747A6)"
    }
});
var $1f603905e59a1e7f$var$warningStyles = (0, $5BICO.xcss)({
    background: "var(--ds-background-warning-bold, #FFAB00)",
    // @ts-expect-error
    color: "var(--ds-text-warning-inverse, #172B4D)",
    ":visited": {
        // @ts-expect-error
        color: "var(--ds-text-warning-inverse, #172B4D)"
    }
});
var $1f603905e59a1e7f$var$warningInteractiveStyles = (0, $5BICO.xcss)({
    ":hover": {
        // @ts-expect-error
        color: "var(--ds-text-warning-inverse, #172B4D)",
        background: "var(--ds-background-warning-bold-hovered, #FFC400)"
    },
    ":active": {
        // @ts-expect-error
        color: "var(--ds-text-warning-inverse, #172B4D)",
        background: "var(--ds-background-warning-bold-pressed, #FF991F)"
    }
});
var $1f603905e59a1e7f$var$dangerStyles = (0, $5BICO.xcss)({
    background: "var(--ds-background-danger-bold, #DE350B)",
    color: "color.text.inverse",
    ":visited": {
        color: "color.text.inverse"
    }
});
var $1f603905e59a1e7f$var$dangerInteractiveStyles = (0, $5BICO.xcss)({
    ":hover": {
        color: "color.text.inverse",
        background: "var(--ds-background-danger-bold-hovered, #FF5630)"
    },
    ":active": {
        color: "color.text.inverse",
        background: "var(--ds-background-danger-bold-pressed, #BF2600)"
    }
});
var $1f603905e59a1e7f$var$discoveryStyles = (0, $5BICO.xcss)({
    background: "var(--ds-background-discovery-bold, #5243AA)",
    color: "color.text.inverse",
    ":visited": {
        color: "color.text.inverse"
    }
});
var $1f603905e59a1e7f$var$discoveryInteractiveStyles = (0, $5BICO.xcss)({
    ":hover": {
        color: "color.text.inverse",
        background: "var(--ds-background-discovery-bold-hovered, #8777D9)"
    },
    ":active": {
        color: "color.text.inverse",
        background: "var(--ds-background-discovery-bold-pressed, #5243AA)"
    }
});
var $1f603905e59a1e7f$var$subtleStyles = (0, $5BICO.xcss)({
    background: "var(--ds-background-neutral-subtle, transparent)",
    // @ts-expect-error
    color: "var(--ds-text, #42526E)",
    ":visited": {
        // @ts-expect-error
        color: "var(--ds-text, #42526E)"
    }
});
var $1f603905e59a1e7f$var$subtleInteractiveStyles = (0, $5BICO.xcss)({
    ":hover": {
        background: "var(--ds-background-neutral-subtle-hovered, #091e4214)",
        // @ts-expect-error
        color: "var(--ds-text, #42526E)"
    },
    ":active": {
        background: "var(--ds-background-neutral-subtle-pressed, #B3D4FF)",
        // @ts-expect-error
        color: "var(--ds-text, #42526E)"
    }
});
var $1f603905e59a1e7f$var$linkStyles = (0, $5BICO.xcss)({
    // @ts-expect-error
    color: "var(--ds-link, ".concat($8D3jt.B400, ")"),
    background: "var(--ds-background-neutral-subtle, transparent)",
    textDecoration: "none",
    ":hover": {
        // @ts-expect-error
        color: "var(--ds-link, ".concat($8D3jt.B300, ")"),
        background: "var(--ds-background-neutral-subtle, transparent)"
    },
    ":active": {
        // @ts-expect-error
        color: "var(--ds-link-pressed, #0055CC)",
        background: "var(--ds-background-neutral-subtle, transparent)"
    },
    ":visited": {
        // @ts-expect-error
        color: "var(--ds-link, ".concat($8D3jt.B400, ")")
    }
});
var $1f603905e59a1e7f$var$subtleLinkStyles = (0, $5BICO.xcss)({
    // @ts-expect-error
    color: "var(--ds-text-subtle, ".concat($8D3jt.N200, ")"),
    background: "var(--ds-background-neutral-subtle, transparent)",
    textDecoration: "none",
    ":hover": {
        // @ts-expect-error
        color: "var(--ds-text-subtle, ".concat($8D3jt.N90, ")"),
        background: "var(--ds-background-neutral-subtle, transparent)"
    },
    ":active": {
        // @ts-expect-error
        color: "var(--ds-text, ".concat($8D3jt.N400, ")"),
        background: "var(--ds-background-neutral-subtle, transparent)"
    },
    ":visited": {
        // @ts-expect-error
        color: "var(--ds-text-subtle, ".concat($8D3jt.N200, ")")
    }
});
// Required due to Jira's AUI CSS reset: https://product-fabric.atlassian.net/browse/DSP-15687
var $1f603905e59a1e7f$var$linkDecorationUnsetStyles = (0, $5BICO.xcss)({
    textDecoration: "none",
    ":hover": {
        textDecoration: "none"
    },
    ":active": {
        textDecoration: "none"
    },
    ":focus": {
        textDecoration: "none"
    }
});
var $1f603905e59a1e7f$var$linkDecorationStyles = (0, $5BICO.xcss)({
    ":hover": {
        textDecoration: "underline"
    },
    ":focus": {
        textDecoration: "underline"
    }
});
var $1f603905e59a1e7f$var$disabledStyles = (0, $5BICO.xcss)({
    background: "var(--ds-background-disabled, ".concat($8D3jt.N20A, ")"),
    // @ts-expect-error
    color: "var(--ds-text-disabled, #091E424F)",
    ":hover": {
        background: "var(--ds-background-disabled, ".concat($8D3jt.N20A, ")"),
        // @ts-expect-error
        color: "var(--ds-text-disabled, #091E424F)"
    },
    ":active": {
        background: "var(--ds-background-disabled, ".concat($8D3jt.N20A, ")"),
        // @ts-expect-error
        color: "var(--ds-text-disabled, #091E424F)"
    }
});
var $1f603905e59a1e7f$var$selectedStyles = (0, $5BICO.xcss)({
    background: "var(--ds-background-selected, ".concat($8D3jt.N700, ")"),
    // @ts-expect-error
    color: "var(--ds-text-selected, ".concat($8D3jt.N20, ")"),
    ":visited": {
        // @ts-expect-error
        color: "var(--ds-text-selected, ".concat($8D3jt.N20, ")")
    }
});
var $1f603905e59a1e7f$var$selectedInteractiveStyles = (0, $5BICO.xcss)({
    ":hover": {
        // @ts-expect-error
        color: "var(--ds-text-selected, ".concat($8D3jt.N20, ")"),
        background: "var(--ds-background-selected-hovered, ".concat($8D3jt.N700, ")")
    },
    ":active": {
        // @ts-expect-error
        color: "var(--ds-text-selected, ".concat($8D3jt.N20, ")"),
        background: "var(--ds-background-selected-pressed, ".concat($8D3jt.N700, ")")
    }
});
// TODO: Remove me once we kill color fallbacks
var $1f603905e59a1e7f$var$selectedWarningStyles = (0, $5BICO.xcss)({
    background: "var(--ds-background-selected, ".concat($8D3jt.Y400, ")"),
    // @ts-expect-error
    color: "var(--ds-text-selected, ".concat($8D3jt.N800, ")"),
    ":hover": {
        // @ts-expect-error
        color: "var(--ds-text-selected, ".concat($8D3jt.N20, ")"),
        background: "var(--ds-background-selected, ".concat($8D3jt.Y400, ")")
    },
    ":active": {
        // @ts-expect-error
        color: "var(--ds-text-selected, ".concat($8D3jt.N20, ")"),
        background: "var(--ds-background-selected, ".concat($8D3jt.Y400, ")")
    }
});
// TODO: Remove me once we kill color fallbacks
var $1f603905e59a1e7f$var$selectedDangerStyles = (0, $5BICO.xcss)({
    background: "var(--ds-background-selected, ".concat($8D3jt.R500, ")"),
    // @ts-expect-error
    color: "var(--ds-text-selected, ".concat($8D3jt.N20, ")"),
    ":hover": {
        // @ts-expect-error
        color: "var(--ds-text-selected, ".concat($8D3jt.N20, ")"),
        background: "var(--ds-background-selected, ".concat($8D3jt.R500, ")")
    },
    ":active": {
        // @ts-expect-error
        color: "var(--ds-text-selected, ".concat($8D3jt.N20, ")"),
        background: "var(--ds-background-selected, ".concat($8D3jt.R500, ")")
    }
});
// TODO: Remove me once we kill color fallbacks
var $1f603905e59a1e7f$var$selectedDiscoveryStyles = (0, $5BICO.xcss)({
    background: "var(--ds-background-selected, #403294)",
    // @ts-expect-error
    color: "var(--ds-text-selected, ".concat($8D3jt.N20, ")"),
    ":hover": {
        // @ts-expect-error
        color: "var(--ds-text-selected, ".concat($8D3jt.N20, ")"),
        background: "var(--ds-background-selected, #403294)"
    },
    ":active": {
        // @ts-expect-error
        color: "var(--ds-text-selected, ".concat($8D3jt.N20, ")"),
        background: "var(--ds-background-selected, #403294)"
    }
});
var $1f603905e59a1e7f$var$spacingCompactStyles = (0, $5BICO.xcss)({
    columnGap: "space.050",
    height: "".concat(24 / $1f603905e59a1e7f$var$fontSize, "em"),
    paddingInlineEnd: "space.150",
    paddingInlineStart: "space.150",
    verticalAlign: "middle"
});
var $1f603905e59a1e7f$var$baseSpacingCompactStyles = (0, $5BICO.xcss)({
    lineHeight: "".concat(24 / $1f603905e59a1e7f$var$fontSize, "em")
});
var $1f603905e59a1e7f$var$tokenizedSpacingCompactStyles = (0, $5BICO.xcss)({
    paddingBlock: "space.025"
});
var $1f603905e59a1e7f$var$spacingNoneStyles = (0, $5BICO.xcss)({
    columnGap: "space.0",
    height: "auto",
    lineHeight: "inherit",
    paddingInlineEnd: "space.0",
    paddingInlineStart: "space.0",
    verticalAlign: "baseline"
});
var $1f603905e59a1e7f$var$tokenizedSpacingNoneStyles = (0, $5BICO.xcss)({
    paddingBlock: "space.0"
});
var $1f603905e59a1e7f$var$circleStyles = (0, $5BICO.xcss)({
    borderRadius: "border.radius.circle"
});
var $1f603905e59a1e7f$var$fullWidthStyles = (0, $5BICO.xcss)({
    width: "100%"
});
var $1f603905e59a1e7f$var$loadingOverlayStyles = (0, $5BICO.xcss)({
    cursor: "progress"
});
var $1f603905e59a1e7f$var$nonInteractiveStyles = (0, $5BICO.xcss)({
    cursor: "not-allowed"
});
var $1f603905e59a1e7f$var$iconButtonStyles = (0, $5BICO.xcss)({
    height: "".concat(32 / $1f603905e59a1e7f$var$fontSize, "em"),
    width: "".concat(32 / $1f603905e59a1e7f$var$fontSize, "em"),
    paddingInlineEnd: "space.0",
    paddingInlineStart: "space.0"
});
var $1f603905e59a1e7f$var$iconButtonCompactStyles = (0, $5BICO.xcss)({
    width: "".concat(24 / $1f603905e59a1e7f$var$fontSize, "em"),
    height: "".concat(24 / $1f603905e59a1e7f$var$fontSize, "em")
});
var $1f603905e59a1e7f$var$buttonIconBeforeStyles = (0, $5BICO.xcss)({
    paddingInlineStart: "space.100"
});
var $1f603905e59a1e7f$var$buttonIconAfterStyles = (0, $5BICO.xcss)({
    paddingInlineEnd: "space.100"
});
var $1f603905e59a1e7f$var$splitButtonStyles = (0, $5BICO.xcss)({
    ":focus-visible": {
        zIndex: "card"
    }
});
var $1f603905e59a1e7f$var$navigationSplitButtonStyles = (0, $5BICO.xcss)({
    width: "24px",
    backgroundColor: "color.background.neutral.subtle",
    paddingInlineEnd: "space.075",
    paddingInlineStart: "space.075"
});
var $1f603905e59a1e7f$var$overlayStyles = (0, $5BICO.xcss)({
    display: "flex",
    position: "absolute",
    alignItems: "center",
    justifyContent: "center",
    insetBlockEnd: "space.0",
    insetBlockStart: "space.0",
    insetInlineEnd: "space.0",
    insetInlineStart: "space.0"
});
/**
 * __Use button base__
 *
 * A React hook that accepts a set of common Button props,
 * and processes them to return consistent base props for usage
 * across various Button components.
 *
 * It also:
 * - Implements auto focus when enabled.
 * - Appends the `onClick` event with UFO analytics tracking.
 *
 * @private
 */ var $1f603905e59a1e7f$var$useButtonBase = function useButtonBase(_ref) {
    var _ref$appearance = _ref.appearance, propAppearance = _ref$appearance === void 0 ? "default" : _ref$appearance, _ref$autoFocus = _ref.autoFocus, autoFocus = _ref$autoFocus === void 0 ? false : _ref$autoFocus, _ref$isDisabled = _ref.isDisabled, propIsDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled, _ref$isLoading = _ref.isLoading, isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading, _ref$isSelected = _ref.isSelected, isSelected = _ref$isSelected === void 0 ? false : _ref$isSelected, _ref$isIconButton = _ref.isIconButton, isIconButton = _ref$isIconButton === void 0 ? false : _ref$isIconButton, _ref$isCircle = _ref.isCircle, isCircle = _ref$isCircle === void 0 ? false : _ref$isCircle, _ref$hasIconBefore = _ref.hasIconBefore, hasIconBefore = _ref$hasIconBefore === void 0 ? false : _ref$hasIconBefore, _ref$hasIconAfter = _ref.hasIconAfter, hasIconAfter = _ref$hasIconAfter === void 0 ? false : _ref$hasIconAfter, children = _ref.children, onClick = _ref.onClick, onMouseDownCapture = _ref.onMouseDownCapture, onMouseUpCapture = _ref.onMouseUpCapture, onKeyDownCapture = _ref.onKeyDownCapture, onKeyUpCapture = _ref.onKeyUpCapture, onTouchStartCapture = _ref.onTouchStartCapture, onTouchEndCapture = _ref.onTouchEndCapture, onPointerDownCapture = _ref.onPointerDownCapture, onPointerUpCapture = _ref.onPointerUpCapture, onClickCapture = _ref.onClickCapture, overlay = _ref.overlay, ref = _ref.ref, _ref$shouldFitContain = _ref.shouldFitContainer, shouldFitContainer = _ref$shouldFitContain === void 0 ? false : _ref$shouldFitContain, _ref$spacing = _ref.spacing, propSpacing = _ref$spacing === void 0 ? "default" : _ref$spacing;
    var localRef = (0, $dAx5m.useRef)(null);
    var splitButtonContext = (0, $6rjas.useSplitButtonContext)();
    var isSplitButton = Boolean(splitButtonContext);
    var isNavigationSplitButton = (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.isNavigationSplitButton) || false;
    var appearance = (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.appearance) || propAppearance;
    var spacing = (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.spacing) || propSpacing;
    var isDisabled = (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.isDisabled) || propIsDisabled;
    var hasOverlay = Boolean(overlay);
    var isInteractive = !isDisabled && !isLoading && !hasOverlay;
    var isEffectivelyDisabled = isDisabled || Boolean(overlay);
    (0, $gMIYi.default)(localRef, autoFocus);
    return $1f603905e59a1e7f$var$_objectSpread({
        ref: (0, $2Dg3J.default)([
            localRef,
            ref
        ]),
        xcss: [
            (0, $8vWLu.getBooleanFF)("platform.design-system-team.button-tokenised-typography-styles") ? $1f603905e59a1e7f$var$tokenizedButtonStyles : $1f603905e59a1e7f$var$baseButtonStyles,
            $1f603905e59a1e7f$var$buttonStyles,
            appearance === "default" && isInteractive && $1f603905e59a1e7f$var$defaultInteractiveStyles,
            appearance === "primary" && $1f603905e59a1e7f$var$primaryStyles,
            appearance === "primary" && isInteractive && $1f603905e59a1e7f$var$primaryInteractiveStyles,
            appearance === "warning" && $1f603905e59a1e7f$var$warningStyles,
            appearance === "warning" && isInteractive && $1f603905e59a1e7f$var$warningInteractiveStyles,
            appearance === "danger" && $1f603905e59a1e7f$var$dangerStyles,
            appearance === "danger" && isInteractive && $1f603905e59a1e7f$var$dangerInteractiveStyles,
            appearance === "discovery" && $1f603905e59a1e7f$var$discoveryStyles,
            appearance === "discovery" && isInteractive && $1f603905e59a1e7f$var$discoveryInteractiveStyles,
            appearance === "subtle" && $1f603905e59a1e7f$var$subtleStyles,
            appearance === "subtle" && isInteractive && $1f603905e59a1e7f$var$subtleInteractiveStyles,
            appearance === "link" && $1f603905e59a1e7f$var$linkStyles,
            appearance === "subtle-link" && $1f603905e59a1e7f$var$subtleLinkStyles,
            !isSelected && (appearance === "link" || appearance === "subtle-link") ? $1f603905e59a1e7f$var$linkDecorationStyles : $1f603905e59a1e7f$var$linkDecorationUnsetStyles,
            isSelected && $1f603905e59a1e7f$var$selectedStyles,
            isSelected && isInteractive && $1f603905e59a1e7f$var$selectedInteractiveStyles,
            // TODO: remove me once we kill color fallbacks
            isSelected && appearance === "danger" && $1f603905e59a1e7f$var$selectedDangerStyles,
            // TODO: remove me once we kill color fallbacks
            isSelected && appearance === "warning" && $1f603905e59a1e7f$var$selectedWarningStyles,
            // TODO: remove me once we kill color fallbacks
            isSelected && appearance === "discovery" && $1f603905e59a1e7f$var$selectedDiscoveryStyles,
            isDisabled && $1f603905e59a1e7f$var$disabledStyles,
            isCircle && !isSplitButton && $1f603905e59a1e7f$var$circleStyles,
            spacing === "compact" && $1f603905e59a1e7f$var$spacingCompactStyles,
            spacing === "compact" && ((0, $8vWLu.getBooleanFF)("platform.design-system-team.button-tokenised-typography-styles") ? $1f603905e59a1e7f$var$tokenizedSpacingCompactStyles : $1f603905e59a1e7f$var$baseSpacingCompactStyles),
            spacing === "none" && $1f603905e59a1e7f$var$spacingNoneStyles,
            spacing === "none" && (0, $8vWLu.getBooleanFF)("platform.design-system-team.button-tokenised-typography-styles") && $1f603905e59a1e7f$var$tokenizedSpacingNoneStyles,
            spacing !== "none" && hasIconBefore && $1f603905e59a1e7f$var$buttonIconBeforeStyles,
            spacing !== "none" && hasIconAfter && $1f603905e59a1e7f$var$buttonIconAfterStyles,
            isIconButton && $1f603905e59a1e7f$var$iconButtonStyles,
            isIconButton && spacing === "compact" && $1f603905e59a1e7f$var$iconButtonCompactStyles,
            shouldFitContainer && $1f603905e59a1e7f$var$fullWidthStyles,
            isLoading && $1f603905e59a1e7f$var$loadingOverlayStyles,
            (isDisabled || hasOverlay && !isLoading) && $1f603905e59a1e7f$var$nonInteractiveStyles,
            isSplitButton && $1f603905e59a1e7f$var$splitButtonStyles,
            isNavigationSplitButton && $1f603905e59a1e7f$var$navigationSplitButtonStyles
        ],
        // Consider overlay buttons to be effectively disabled
        isDisabled: isEffectivelyDisabled,
        children: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $dAx5m.Fragment), null, children, overlay ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $8WEMR.default), {
            as: "span",
            xcss: $1f603905e59a1e7f$var$overlayStyles
        }, overlay) : null)
    }, (0, $7cR6G.default)(isEffectivelyDisabled, {
        onClick: onClick,
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onTouchStartCapture: onTouchStartCapture,
        onTouchEndCapture: onTouchEndCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onClickCapture: onClickCapture
    }));
};
var $1f603905e59a1e7f$export$2e2bcd8739ae039 = $1f603905e59a1e7f$var$useButtonBase;

});
parcelRegister("2Dg3J", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1eabae533c146962$export$2e2bcd8739ae039; });
/**
 * Assigns the node to all the refs passed in the argument.
 *
 * @param refs: An array of refs (as function or ref object)
 */ function $1eabae533c146962$export$2e2bcd8739ae039(refs) {
    return function(value) {
        refs.forEach(function(ref) {
            if (typeof ref === "function") ref(value);
            else if (ref !== null) ref.current = value;
        });
    };
}

});

parcelRegister("6rjas", function(module, exports) {

$parcel$export(module.exports, "useSplitButtonContext", function () { return $4b04220330f2a7da$export$47e2c6fdb142d947; });

var $dAx5m = parcelRequire("dAx5m");
var $4b04220330f2a7da$export$4b86304b2c0d7e71 = /*#__PURE__*/ (0, $dAx5m.createContext)(undefined);
var $4b04220330f2a7da$export$47e2c6fdb142d947 = function useSplitButtonContext() {
    var context = (0, $dAx5m.useContext)($4b04220330f2a7da$export$4b86304b2c0d7e71);
    if (!context) return undefined;
    if (context.appearance === "navigation") {
        var newContext = {
            spacing: "default",
            appearance: "subtle",
            isDisabled: false,
            isActiveOverSelected: false,
            isNavigationSplitButton: true,
            isHighlighted: context.isHighlighted
        };
        return newContext;
    }
    var splitButtonContext = {
        spacing: context.spacing,
        appearance: context.appearance,
        isDisabled: context.isDisabled,
        isActiveOverSelected: true,
        isNavigationSplitButton: false,
        isHighlighted: false
    };
    return splitButtonContext;
};

});

parcelRegister("7cR6G", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $53f2d94f240971d0$export$2e2bcd8739ae039; });
function $53f2d94f240971d0$var$abort(event) {
    event.preventDefault();
    event.stopPropagation();
}
var $53f2d94f240971d0$var$tabKeyCode = 9;
function $53f2d94f240971d0$var$onKey(event) {
    // Allowing tab so that a user can move focus away
    if (event.keyCode === $53f2d94f240971d0$var$tabKeyCode) return;
    $53f2d94f240971d0$var$abort(event);
}
function $53f2d94f240971d0$export$2e2bcd8739ae039(shouldBlockEvents, events) {
    return shouldBlockEvents ? {
        onMouseDownCapture: $53f2d94f240971d0$var$abort,
        onMouseUpCapture: $53f2d94f240971d0$var$abort,
        onKeyDownCapture: $53f2d94f240971d0$var$onKey,
        onKeyUpCapture: $53f2d94f240971d0$var$onKey,
        onTouchStartCapture: $53f2d94f240971d0$var$abort,
        onTouchEndCapture: $53f2d94f240971d0$var$abort,
        onPointerDownCapture: $53f2d94f240971d0$var$abort,
        onPointerUpCapture: $53f2d94f240971d0$var$abort,
        onClickCapture: $53f2d94f240971d0$var$abort,
        // Just smashing the existing onClick for good measure
        onClick: $53f2d94f240971d0$var$abort
    } : events;
}

});




parcelRegister("dgKpN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9a90c60e1262136f$var$_react = $9a90c60e1262136f$var$_interopRequireDefault((parcelRequire("dAx5m")));

var $1w6Fe = parcelRequire("1w6Fe");

var $9a90c60e1262136f$var$_checkMark = $9a90c60e1262136f$var$_interopRequireDefault((parcelRequire("2ZOdk")));
function $9a90c60e1262136f$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $9a90c60e1262136f$var$CheckIcon = (props)=>/*#__PURE__*/ $9a90c60e1262136f$var$_react.default.createElement($1w6Fe.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M6.735 12.322a1 1 0 0 0-1.47 1.356l3.612 3.919c.537.526 1.337.526 1.834.03l.364-.359a2336 2336 0 0 0 3.939-3.883l.04-.04a493 493 0 0 0 3.658-3.643 1 1 0 0 0-1.424-1.404 518 518 0 0 1-3.64 3.625l-.04.04a2049 2049 0 0 1-3.775 3.722z"/></svg>`
    }, props, {
        newIcon: $9a90c60e1262136f$var$_checkMark.default
    }));
$9a90c60e1262136f$var$CheckIcon.displayName = "CheckIcon";
var $9a90c60e1262136f$var$_default = module.exports.default = $9a90c60e1262136f$var$CheckIcon;

});
parcelRegister("1w6Fe", function(module, exports) {

$parcel$export(module.exports, "IconFacade", function () { return $11adf2eb68513f85$export$3cfb73f70dfca966; });

var $bIiWW = parcelRequire("bIiWW");

var $9EJk3 = parcelRequire("9EJk3");

var $dAx5m = parcelRequire("dAx5m");

var $1a8nN = parcelRequire("1a8nN");

var $ck5lj = parcelRequire("ck5lj");
var $11adf2eb68513f85$var$_excluded = [
    "dangerouslySetGlyph"
];
var $11adf2eb68513f85$var$sizesEligibleForNewIcons = [
    "small",
    "medium"
];
var $11adf2eb68513f85$export$3cfb73f70dfca966 = /*#__PURE__*/ (0, $dAx5m.memo)(function IconFacade(_ref) {
    var _props$size;
    var dangerouslySetGlyph = _ref.dangerouslySetGlyph, props = (0, (/*@__PURE__*/$parcel$interopDefault($9EJk3)))(_ref, $11adf2eb68513f85$var$_excluded);
    var NewIcon = props.newIcon;
    // By default, the icon size will be medium and spacing will be none for small icons
    var size = (_props$size = props.size) !== null && _props$size !== void 0 ? _props$size : "medium";
    var spacing = size === "small" ? "none" : "spacious";
    var useNewIcon = !props.isFacadeDisabled && // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
    (0, $1a8nN.fg)("platform-visual-refresh-icons-legacy-facade") && $11adf2eb68513f85$var$sizesEligibleForNewIcons.includes(size);
    if (useNewIcon && NewIcon) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement(NewIcon, (0, (/*@__PURE__*/$parcel$interopDefault($bIiWW)))({}, props, {
        spacing: spacing,
        color: props.primaryColor || "currentColor",
        type: props.iconType
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $ck5lj.default), (0, (/*@__PURE__*/$parcel$interopDefault($bIiWW)))({
        dangerouslySetGlyph: dangerouslySetGlyph
    }, props));
});
var $11adf2eb68513f85$export$2e2bcd8739ae039 = $11adf2eb68513f85$export$3cfb73f70dfca966;

});
parcelRegister("1a8nN", function(module, exports) {

$parcel$export(module.exports, "fg", function () { return $0d8d3a4651fcf392$export$b40ec24ac8275656; });

var $i9tsR = parcelRequire("i9tsR");
function $0d8d3a4651fcf392$export$ba05d765b8392e5e(flagResolver) {
    (0, $i9tsR.setBooleanResolver)(flagResolver);
}
function $0d8d3a4651fcf392$export$470e5c2be1411c89(name) {
    return (0, $i9tsR.resolveBooleanFlag)(name);
}
function $0d8d3a4651fcf392$export$b40ec24ac8275656(name) {
    return (0, $i9tsR.resolveBooleanFlag)(name);
}

});
parcelRegister("i9tsR", function(module, exports) {

$parcel$export(module.exports, "setBooleanResolver", function () { return $d36fec45dcf31511$export$f2b591175b3e424c; });
$parcel$export(module.exports, "resolveBooleanFlag", function () { return $d36fec45dcf31511$export$6333b6aff9fc6275; });

var $hVFy5 = parcelRequire("hVFy5");

var $ahJoN = parcelRequire("ahJoN");
var $d36fec45dcf31511$var$pkgName = "@atlaskit/platform-feature-flags";
var $d36fec45dcf31511$export$7e41b1b2bdee3f98 = "__PLATFORM_FEATURE_FLAGS__";
var $d36fec45dcf31511$var$hasProcessEnv = typeof $ahJoN !== "undefined" && typeof $ahJoN.env !== "undefined";
// FF global overrides can be configured by test runners or Storybook
var $d36fec45dcf31511$var$ENV_ENABLE_PLATFORM_FF = $d36fec45dcf31511$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
// STORYBOOK_ENABLE_PLATFORM_FF is included as storybook only allows env vars prefixed with STORYBOOK
// https://github.com/storybookjs/storybook/issues/12270
var $d36fec45dcf31511$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF = $d36fec45dcf31511$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
var $d36fec45dcf31511$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE = $d36fec45dcf31511$var$ENV_ENABLE_PLATFORM_FF || $d36fec45dcf31511$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF;
var $d36fec45dcf31511$var$DEFAULT_PFF_GLOBAL = {
    // In development mode we want to capture any feature flag checks that happen using the default resolver and log this result when the resolver is replaced.
    // This is because evaluating feature flags when the resolver/FF client is loaded asynchronously could cause unexpected issues.
    earlyResolvedFlags: new Map(),
    booleanResolver: function booleanResolver(flagKey) {
        var unresolvedFlagCount;
        return false;
    }
};
var $d36fec45dcf31511$var$globalVar = typeof window !== "undefined" ? window : globalThis;
$d36fec45dcf31511$var$globalVar[$d36fec45dcf31511$export$7e41b1b2bdee3f98] = $d36fec45dcf31511$var$globalVar[$d36fec45dcf31511$export$7e41b1b2bdee3f98] || $d36fec45dcf31511$var$DEFAULT_PFF_GLOBAL;
function $d36fec45dcf31511$export$f2b591175b3e424c(resolver) {
    $d36fec45dcf31511$var$globalVar[$d36fec45dcf31511$export$7e41b1b2bdee3f98].booleanResolver = resolver;
    var _globalVar$PFF_GLOBAL;
}
function $d36fec45dcf31511$export$6333b6aff9fc6275(flagKey) {
    if ($d36fec45dcf31511$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE) {
        (0, $hVFy5.debug)('[%s]: The feature flags were enabled while running tests. The flag "%s" will be always enabled.', $d36fec45dcf31511$var$pkgName, flagKey);
        return true;
    }
    try {
        var _globalVar$PFF_GLOBAL2;
        var result = (_globalVar$PFF_GLOBAL2 = $d36fec45dcf31511$var$globalVar[$d36fec45dcf31511$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL2 === void 0 ? void 0 : _globalVar$PFF_GLOBAL2.booleanResolver(flagKey);
        if (typeof result !== "boolean") {
            // eslint-disable-next-line no-console
            console.warn("".concat(flagKey, " resolved to a non-boolean value, returning false for safety"));
            return false;
        }
        return result;
    } catch (e) {
        return false;
    }
}

});
parcelRegister("hVFy5", function(module, exports) {

$parcel$export(module.exports, "debug", function () { return $d0d7fd4937851492$export$1c9f709888824e05; });
var $d0d7fd4937851492$var$_ref, $d0d7fd4937851492$var$_process, $d0d7fd4937851492$var$_process2;
// We can't rely on NODE_ENV === 'test' if its value is already configured by the consumer to some other value, so better to use JEST_WORKER_ID
// https://jestjs.io/docs/environment-variables#jest_worker_id
var $d0d7fd4937851492$var$TESTS_MODE = ($d0d7fd4937851492$var$_ref = (globalThis === null || globalThis === void 0 || ($d0d7fd4937851492$var$_process = globalThis.process) === null || $d0d7fd4937851492$var$_process === void 0 || ($d0d7fd4937851492$var$_process = $d0d7fd4937851492$var$_process.env) === null || $d0d7fd4937851492$var$_process === void 0 ? void 0 : $d0d7fd4937851492$var$_process.JEST_WORKER_ID) !== undefined, $d0d7fd4937851492$var$_ref !== void 0) ? $d0d7fd4937851492$var$_ref : false;
var $d0d7fd4937851492$var$DEBUG_MODE = !$d0d7fd4937851492$var$TESTS_MODE && (globalThis === null || globalThis === void 0 || ($d0d7fd4937851492$var$_process2 = globalThis.process) === null || $d0d7fd4937851492$var$_process2 === void 0 || ($d0d7fd4937851492$var$_process2 = $d0d7fd4937851492$var$_process2.env) === null || $d0d7fd4937851492$var$_process2 === void 0 ? void 0 : $d0d7fd4937851492$var$_process2.NODE_ENV) !== "production";
var $d0d7fd4937851492$export$1c9f709888824e05 = function debug() {
    var _console;
    if (!$d0d7fd4937851492$var$DEBUG_MODE) return;
    // eslint-disable-next-line no-console
    (_console = console).debug.apply(_console, arguments);
};

});



parcelRegister("ck5lj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8f8b7f450f820c03$export$2e2bcd8739ae039; });

var $bIiWW = parcelRequire("bIiWW");

var $fjHlV = parcelRequire("fjHlV");

var $dAx5m = parcelRequire("dAx5m");

var $jVTBW = parcelRequire("jVTBW");

var $HvR6N = parcelRequire("HvR6N");

var $hG4dL = parcelRequire("hG4dL");
function $8f8b7f450f820c03$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $8f8b7f450f820c03$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $8f8b7f450f820c03$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($fjHlV)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $8f8b7f450f820c03$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
/**
 * We are hiding these props from consumers as they're used to
 * hack around icon sizing specifically for icon-file-type.
 */ var $8f8b7f450f820c03$var$iconStyles = (0, $jVTBW.css)({
    display: "inline-block",
    flexShrink: 0,
    lineHeight: 1,
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    "> svg": $8f8b7f450f820c03$var$_objectSpread($8f8b7f450f820c03$var$_objectSpread({}, (0, $HvR6N.commonSVGStyles)), {}, {
        maxWidth: "100%",
        maxHeight: "100%",
        color: "var(--icon-primary-color)",
        fill: "var(--icon-secondary-color)",
        verticalAlign: "bottom"
    })
});
/**
 * For windows high contrast mode
 */ var $8f8b7f450f820c03$var$baseHcmStyles = (0, $jVTBW.css)({
    "@media screen and (forced-colors: active)": {
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        "> svg": {
            filter: "grayscale(1)",
            "--icon-primary-color": "CanvasText",
            // foreground
            "--icon-secondary-color": "Canvas" // background
        }
    }
});
var $8f8b7f450f820c03$var$primaryEqualsSecondaryHcmStyles = (0, $jVTBW.css)({
    "@media screen and (forced-colors: active)": {
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        "> svg": {
            // if the primaryColor is the same as the secondaryColor we
            // set the --icon-primary-color to Canvas
            // this is usually to convey state i.e. Checkbox checked -> not checked
            "--icon-primary-color": "Canvas" // foreground
        }
    }
});
var $8f8b7f450f820c03$var$secondaryTransparentHcmStyles = (0, $jVTBW.css)({
    "@media screen and (forced-colors: active)": {
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        "> svg": {
            "--icon-secondary-color": "transparent" // background
        }
    }
});
var $8f8b7f450f820c03$export$f04a61298a47a40f = /*#__PURE__*/ (0, $dAx5m.memo)(function Icon(props) {
    var _ref = props, Glyph = _ref.glyph, dangerouslySetGlyph = _ref.dangerouslySetGlyph, _ref$primaryColor = _ref.primaryColor, primaryColor = _ref$primaryColor === void 0 ? "currentColor" : _ref$primaryColor, secondaryColor = _ref.secondaryColor, size = _ref.size, testId = _ref.testId, label = _ref.label, width = _ref.width, height = _ref.height, UNSAFE_margin = _ref.UNSAFE_margin;
    var glyphProps = dangerouslySetGlyph ? {
        dangerouslySetInnerHTML: {
            __html: dangerouslySetGlyph
        }
    } : {
        children: Glyph ? (0, $jVTBW.jsx)(Glyph, {
            role: "presentation"
        }) : null
    };
    var dimensions = (0, $HvR6N.getIconSize)({
        width: width,
        height: height,
        size: size
    });
    return (0, $jVTBW.jsx)("span", (0, (/*@__PURE__*/$parcel$interopDefault($bIiWW)))({
        "data-testid": testId,
        "data-vc": "icon-".concat(testId),
        role: label ? "img" : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: $8f8b7f450f820c03$var$_objectSpread({
            "--icon-primary-color": primaryColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            "--icon-secondary-color": secondaryColor || (0, $hG4dL.getBackground)()
        }, UNSAFE_margin ? {
            margin: UNSAFE_margin
        } : {})
    }, glyphProps, {
        css: [
            $8f8b7f450f820c03$var$iconStyles,
            $8f8b7f450f820c03$var$baseHcmStyles,
            primaryColor === secondaryColor && $8f8b7f450f820c03$var$primaryEqualsSecondaryHcmStyles,
            secondaryColor === "transparent" && $8f8b7f450f820c03$var$secondaryTransparentHcmStyles,
            // NB: This can be resolved if this component, composes base SVG / and/or skeleton
            // We could then simplify how common styles are dealt with simply by encapsulating them
            // at their appropriate level and/or having a singular approach to css variables in the package
            dimensions && // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $jVTBW.css)({
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                width: dimensions.width,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                height: dimensions.height,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                "> svg": dimensions
            })
        ]
    }));
});
var $8f8b7f450f820c03$export$2e2bcd8739ae039 = $8f8b7f450f820c03$export$f04a61298a47a40f;

});
parcelRegister("HvR6N", function(module, exports) {

$parcel$export(module.exports, "commonSVGStyles", function () { return $082cba1f94e72101$export$16374db1c3e6dfba; });
$parcel$export(module.exports, "getIconSize", function () { return $082cba1f94e72101$export$3eb7d6130acfda37; });

var $gCBKL = parcelRequire("gCBKL");

var $jVTBW = parcelRequire("jVTBW");
var $082cba1f94e72101$export$16374db1c3e6dfba = {
    overflow: "hidden",
    pointerEvents: "none",
    /**
   * Stop-color doesn't properly apply in chrome when the inherited/current color changes.
   * We have to initially set stop-color to inherit (either via DOM attribute or an initial CSS
   * rule) and then override it with currentColor for the color changes to be picked up.
   */ stop: {
        stopColor: "currentColor"
    }
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
var $082cba1f94e72101$var$smallStyles = (0, $jVTBW.css)((0, $gCBKL.dimensions).small);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
var $082cba1f94e72101$var$mediumStyles = (0, $jVTBW.css)((0, $gCBKL.dimensions).medium);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
var $082cba1f94e72101$var$largeStyles = (0, $jVTBW.css)((0, $gCBKL.dimensions).large);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
var $082cba1f94e72101$var$xlargeStyles = (0, $jVTBW.css)((0, $gCBKL.dimensions).xlarge);
var $082cba1f94e72101$export$ef0ad74202575b64 = {
    small: $082cba1f94e72101$var$smallStyles,
    medium: $082cba1f94e72101$var$mediumStyles,
    large: $082cba1f94e72101$var$largeStyles,
    xlarge: $082cba1f94e72101$var$xlargeStyles
};
var $082cba1f94e72101$export$3eb7d6130acfda37 = function getIconSize(_ref) {
    var width = _ref.width, height = _ref.height, size = _ref.size;
    if (width && height) return {
        width: width,
        height: height
    };
    if (size) return (0, $gCBKL.dimensions)[size];
    return undefined;
};

});
parcelRegister("gCBKL", function(module, exports) {

$parcel$export(module.exports, "dimensions", function () { return $c19d7af332f4d0e3$export$62ad7b0c781000e9; });
var $c19d7af332f4d0e3$export$c647cb0ee6e282fe = {
    small: "16px",
    medium: "24px",
    large: "32px",
    xlarge: "48px"
};
var $c19d7af332f4d0e3$export$7bd66fc94c81bf84 = {
    small: "small",
    medium: "medium",
    large: "large",
    xlarge: "xlarge"
};
var $c19d7af332f4d0e3$export$62ad7b0c781000e9 = {
    small: {
        width: $c19d7af332f4d0e3$export$c647cb0ee6e282fe.small,
        height: $c19d7af332f4d0e3$export$c647cb0ee6e282fe.small
    },
    medium: {
        width: $c19d7af332f4d0e3$export$c647cb0ee6e282fe.medium,
        height: $c19d7af332f4d0e3$export$c647cb0ee6e282fe.medium
    },
    large: {
        width: $c19d7af332f4d0e3$export$c647cb0ee6e282fe.large,
        height: $c19d7af332f4d0e3$export$c647cb0ee6e282fe.large
    },
    xlarge: {
        width: $c19d7af332f4d0e3$export$c647cb0ee6e282fe.xlarge,
        height: $c19d7af332f4d0e3$export$c647cb0ee6e282fe.xlarge
    }
};

});


parcelRegister("hG4dL", function(module, exports) {

$parcel$export(module.exports, "getBackground", function () { return $cde9a21868ca0428$export$18cb9425622d4e06; });
var $cde9a21868ca0428$export$18cb9425622d4e06 = function getBackground() {
    return "var(--ds-surface, #FFFFFF)";
};

});



parcelRegister("2ZOdk", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::43db9d99c93083272e0c42b874af3704>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $22e83abe9442c488$var$_react = $22e83abe9442c488$var$_interopRequireDefault((parcelRequire("dAx5m")));

var $22e83abe9442c488$var$_UNSAFE_baseNew = $22e83abe9442c488$var$_interopRequireDefault((parcelRequire("3yuTI")));
function $22e83abe9442c488$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "CheckMark".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: table cells, checkboxes.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $22e83abe9442c488$var$CheckMarkIcon = (props)=>/*#__PURE__*/ $22e83abe9442c488$var$_react.default.createElement($22e83abe9442c488$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="m1.5 8 4.25 5.25 8.75-10.5"/>`
    }, props));
$22e83abe9442c488$var$CheckMarkIcon.displayName = "CheckMarkIcon";
var $22e83abe9442c488$var$_default = module.exports.default = $22e83abe9442c488$var$CheckMarkIcon;

});
parcelRegister("3yuTI", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("63tp8")).default; });
$parcel$export(module.exports, "Icon", function () { return (parcelRequire("63tp8")).Icon; });

var $63tp8 = parcelRequire("63tp8");

});
parcelRegister("63tp8", function(module, exports) {

$parcel$export(module.exports, "Icon", function () { return $4689d500f917b930$export$f04a61298a47a40f; });
$parcel$export(module.exports, "default", function () { return $4689d500f917b930$export$2e2bcd8739ae039; });
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $dAx5m = parcelRequire("dAx5m");

var $jVTBW = parcelRequire("jVTBW");

var $1a8nN = parcelRequire("1a8nN");
/**
 * We are hiding this props from consumers as it's reserved
 * for use by Icon Tile.
 */ var $4689d500f917b930$var$commonSVGStyles = (0, $jVTBW.css)({
    overflow: "hidden",
    pointerEvents: "none",
    /**
   * Stop-color doesn't properly apply in chrome when the inherited/current color changes.
   * We have to initially set stop-color to inherit (either via DOM attribute or an initial CSS
   * rule) and then override it with currentColor for the color changes to be picked up.
   */ // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    stop: {
        stopColor: "currentColor"
    }
});
var $4689d500f917b930$var$svgStyles = (0, $jVTBW.css)({
    color: "currentColor",
    verticalAlign: "bottom"
});
var $4689d500f917b930$var$iconStyles = (0, $jVTBW.css)({
    display: "inline-block",
    boxSizing: "border-box",
    flexShrink: 0,
    lineHeight: 1,
    paddingInlineEnd: "var(--ds--button--new-icon-padding-end, 0)",
    paddingInlineStart: "var(--ds--button--new-icon-padding-start, 0)"
});
var $4689d500f917b930$var$utilityIconStyles = (0, $jVTBW.css)({
    lineHeight: "var(--ds-space-150, 12px)"
});
var $4689d500f917b930$var$scaleStyles = (0, $jVTBW.css)({
    width: "inherit",
    height: "inherit"
});
/**
 * For windows high contrast mode
 */ var $4689d500f917b930$var$baseHcmStyles = (0, $jVTBW.css)({
    "@media screen and (forced-colors: active)": {
        color: "CanvasText",
        filter: "grayscale(1)"
    }
});
var $4689d500f917b930$var$sizeMap = {
    scale: (0, $jVTBW.css)({
        width: "inherit",
        height: "inherit"
    }),
    utility: (0, $jVTBW.css)({
        width: "var(--ds-space-150, 12px)",
        height: "var(--ds-space-150, 12px)"
    }),
    none: (0, $jVTBW.css)({
        width: "var(--ds-space-200, 16px)",
        height: "var(--ds-space-200, 16px)"
    }),
    spacious: (0, $jVTBW.css)({
        width: "var(--ds-space-300, 24px)",
        height: "var(--ds-space-300, 24px)"
    })
};
var $4689d500f917b930$var$baseSizeMap = {
    global: 16,
    utility: 12
};
var $4689d500f917b930$export$f04a61298a47a40f = /*#__PURE__*/ (0, $dAx5m.memo)(function Icon(props) {
    var _ref = props, providedColor = _ref.color, _ref$spacing = _ref.spacing, providedSpacing = _ref$spacing === void 0 ? "none" : _ref$spacing, testId = _ref.testId, label = _ref.label, LEGACY_primaryColor = _ref.LEGACY_primaryColor, LEGACY_secondaryColor = _ref.LEGACY_secondaryColor, LEGACY_size = _ref.LEGACY_size, FallbackIcon = _ref.LEGACY_fallbackIcon, _ref$type = _ref.type, type = _ref$type === void 0 ? "global" : _ref$type, dangerouslySetGlyph = _ref.dangerouslySetGlyph, shouldScale = _ref.shouldScale, LEGACY_margin = _ref.LEGACY_margin;
    var fallbackColor = "var(--ds-icon, #44546F)";
    if ((0, $1a8nN.fg)("platform-design-system-new-icon-default-color") || (0, $1a8nN.fg)("platform-design-system-new-icon-default-color-2")) fallbackColor = "currentColor";
    var color = providedColor !== null && providedColor !== void 0 ? providedColor : fallbackColor;
    var dangerouslySetInnerHTML = dangerouslySetGlyph ? {
        __html: dangerouslySetGlyph
    } : undefined;
    // Fall back to old icon
    if (FallbackIcon && !(0, $1a8nN.fg)("platform.design-system-team.enable-new-icons")) // parse out unnecessary props
    return (0, $jVTBW.jsx)(FallbackIcon, {
        primaryColor: LEGACY_primaryColor !== null && LEGACY_primaryColor !== void 0 ? LEGACY_primaryColor : color,
        secondaryColor: LEGACY_secondaryColor,
        size: LEGACY_size,
        label: label,
        testId: testId,
        UNSAFE_margin: LEGACY_margin
    });
    // Utility icons don't have 'spacing' as a type, but in case it's provided, we default to 'none'
    var spacing = type === "utility" ? "none" : providedSpacing;
    var baseSize = $4689d500f917b930$var$baseSizeMap[type];
    var size = type === "utility" ? "utility" : shouldScale ? "scale" : spacing;
    var viewBoxPadding = spacing === "spacious" ? 4 : 0;
    var viewBoxSize = baseSize + 2 * viewBoxPadding;
    // Workaround for the transparency in our disabled icon token.
    // Because we have multiple strokes in icons, opacities overlap
    // This filter has an impact on render performance, but this is
    // acceptable as icons aren't commonly disabled en-masse
    var iconColor = color;
    if (dangerouslySetInnerHTML && color === "var(--ds-icon-disabled, #091E424F)") {
        dangerouslySetInnerHTML.__html = '\n<filter id="ds-newIconOpacityFilter">\n  <feFlood flood-color="var(--ds-icon-disabled)" />\n  <feComposite in2="SourceGraphic" operator="in" />\n</filter>\n<g filter="url(#ds-newIconOpacityFilter)">\n  '.concat(dangerouslySetInnerHTML.__html, "\n</g>");
        iconColor = "var(--ds-icon, #44546F)";
    }
    return (0, $jVTBW.jsx)("span", {
        "data-testid": testId,
        role: label ? "img" : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: {
            color: iconColor
        },
        css: [
            $4689d500f917b930$var$iconStyles,
            $4689d500f917b930$var$baseHcmStyles,
            shouldScale && $4689d500f917b930$var$scaleStyles,
            type === "utility" && $4689d500f917b930$var$utilityIconStyles
        ]
    }, (0, $jVTBW.jsx)("svg", {
        fill: "none",
        viewBox: "".concat(0 - viewBoxPadding, " ").concat(0 - viewBoxPadding, " ").concat(viewBoxSize, " ").concat(viewBoxSize),
        role: "presentation",
        css: [
            $4689d500f917b930$var$commonSVGStyles,
            $4689d500f917b930$var$svgStyles,
            $4689d500f917b930$var$sizeMap[size]
        ],
        dangerouslySetInnerHTML: dangerouslySetInnerHTML
    }));
});
var $4689d500f917b930$export$2e2bcd8739ae039 = $4689d500f917b930$export$f04a61298a47a40f;

});




parcelRegister("g3ZdF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $bb1c6a0a86217551$var$_react = $bb1c6a0a86217551$var$_interopRequireDefault((parcelRequire("dAx5m")));

var $1w6Fe = parcelRequire("1w6Fe");

var $bb1c6a0a86217551$var$_close = $bb1c6a0a86217551$var$_interopRequireDefault((parcelRequire("b2XVJ")));
function $bb1c6a0a86217551$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $bb1c6a0a86217551$var$CrossIcon = (props)=>/*#__PURE__*/ $bb1c6a0a86217551$var$_react.default.createElement($1w6Fe.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M12 10.586 6.707 5.293a1 1 0 0 0-1.414 1.414L10.586 12l-5.293 5.293a1 1 0 0 0 1.414 1.414L12 13.414l5.293 5.293a1 1 0 0 0 1.414-1.414L13.414 12l5.293-5.293a1 1 0 1 0-1.414-1.414z"/></svg>`
    }, props, {
        newIcon: $bb1c6a0a86217551$var$_close.default
    }));
$bb1c6a0a86217551$var$CrossIcon.displayName = "CrossIcon";
var $bb1c6a0a86217551$var$_default = module.exports.default = $bb1c6a0a86217551$var$CrossIcon;

});
parcelRegister("b2XVJ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e1d767c2bf4320bb7e127b754b192d24>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $80ae5e7f8654e8d9$var$_react = $80ae5e7f8654e8d9$var$_interopRequireDefault((parcelRequire("dAx5m")));

var $80ae5e7f8654e8d9$var$_UNSAFE_baseNew = $80ae5e7f8654e8d9$var$_interopRequireDefault((parcelRequire("3yuTI")));
function $80ae5e7f8654e8d9$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Close".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for closing an element.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $80ae5e7f8654e8d9$var$CloseIcon = (props)=>/*#__PURE__*/ $80ae5e7f8654e8d9$var$_react.default.createElement($80ae5e7f8654e8d9$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M2.5 13.5 8 8m5.5-5.5L8 8m0 0L2.5 2.5M8 8l5.5 5.5"/>`
    }, props));
$80ae5e7f8654e8d9$var$CloseIcon.displayName = "CloseIcon";
var $80ae5e7f8654e8d9$var$_default = module.exports.default = $80ae5e7f8654e8d9$var$CloseIcon;

});


parcelRegister("dvUey", function(module, exports) {

$parcel$export(module.exports, "fontSize", function () { return $9d69ca7c526141c8$export$85e3c3ca0c6fb93; });
$parcel$export(module.exports, "borderRadius", function () { return $9d69ca7c526141c8$export$7a57f79000377ca2; });

var $lEqKj = parcelRequire("lEqKj");
var $9d69ca7c526141c8$export$85e3c3ca0c6fb93 = (0, $lEqKj.fontSize)();
var $9d69ca7c526141c8$export$7a57f79000377ca2 = (0, $lEqKj.borderRadius)();

});


parcelRegister("kY0Db", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f439e68ed472c663$export$2e2bcd8739ae039; });

var $dAx5m = parcelRequire("dAx5m");
var $f439e68ed472c663$var$usePrevious = function usePrevious(value) {
    var ref = (0, $dAx5m.useRef)();
    (0, $dAx5m.useEffect)(function() {
        ref.current = value;
    }, [
        value
    ]);
    return ref.current;
};
var $f439e68ed472c663$var$useButtonFocusHook = function useButtonFocusHook(isEditing, isEditingState) {
    var editButtonRef = (0, $dAx5m.useRef)(null);
    var editViewRef = (0, $dAx5m.useRef)();
    var preventFocusOnEditButtonRef = (0, $dAx5m.useRef)(false);
    var isControlled = typeof isEditing === "undefined";
    var shouldBeEditing = isControlled ? isEditingState : isEditing;
    var prevIsEditing = $f439e68ed472c663$var$usePrevious(shouldBeEditing);
    (0, $dAx5m.useEffect)(function() {
        if (isEditingState && editViewRef.current) editViewRef.current.focus();
    }, [
        editViewRef,
        isEditingState
    ]);
    (0, $dAx5m.useEffect)(function() {
        /**
     * This logic puts the focus on the edit button after confirming using
     * the confirm button or using the keyboard to confirm, but not when
     * it is confirmed by wrapper blur
     */ if (prevIsEditing && !shouldBeEditing) {
            if (preventFocusOnEditButtonRef && preventFocusOnEditButtonRef.current) preventFocusOnEditButtonRef.current = false;
            else if (editButtonRef && editButtonRef.current) // @ts-ignore
            editButtonRef.current.focus();
        }
    }, [
        prevIsEditing,
        shouldBeEditing
    ]);
    var doNotFocusOnEditButton = function doNotFocusOnEditButton() {
        return preventFocusOnEditButtonRef.current = true;
    };
    return {
        editButtonRef: editButtonRef,
        editViewRef: editViewRef,
        shouldBeEditing: shouldBeEditing,
        doNotFocusOnEditButton: doNotFocusOnEditButton
    };
};
var $f439e68ed472c663$export$2e2bcd8739ae039 = $f439e68ed472c663$var$useButtonFocusHook;

});

parcelRegister("8lpsA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $613408bbbe4883b9$export$2e2bcd8739ae039; });
/** @jsx jsx */ 
var $dAx5m = parcelRequire("dAx5m");

var $jVTBW = parcelRequire("jVTBW");

var $8Duts = parcelRequire("8Duts");
var $5BICO = parcelRequire("5BICO");

var $8D3jt = parcelRequire("8D3jt");

var $ez4n6 = parcelRequire("ez4n6");

var $dvUey = parcelRequire("dvUey");
var $613408bbbe4883b9$var$readViewContainerStyles = (0, $jVTBW.css)({
    lineHeight: 1
});
var $613408bbbe4883b9$var$editButtonStyles = (0, $5BICO.xcss)({
    display: "block",
    margin: "space.0",
    padding: "space.0",
    appearance: "none",
    background: "transparent",
    border: 0,
    lineHeight: 1,
    outline: 0,
    ":focus-visible": {
        outline: 0
    },
    // @ts-expect-error
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    ":focus + div": {
        borderColor: "color.border.focused",
        borderWidth: "border.width.outline",
        borderStyle: "solid"
    }
});
var $613408bbbe4883b9$var$readViewWrapperStyles = (0, $jVTBW.css)({
    display: "inline-block",
    boxSizing: "border-box",
    width: "auto",
    maxWidth: "100%",
    border: "2px solid transparent",
    borderRadius: (0, $dvUey.borderRadius),
    transition: "background 0.2s",
    "&:hover": {
        background: "var(--ds-background-neutral-subtle-hovered, ".concat((0, $8D3jt.N30), ")")
    }
});
var $613408bbbe4883b9$var$readViewFitContainerWidthStyles = (0, $jVTBW.css)({
    width: "100%"
});
var $613408bbbe4883b9$var$DRAG_THRESHOLD = 5;
var $613408bbbe4883b9$var$ReadView = function ReadView(_ref) {
    var editButtonLabel = _ref.editButtonLabel, onEditRequested = _ref.onEditRequested, postReadViewClick = _ref.postReadViewClick, editButtonRef = _ref.editButtonRef, readViewFitContainerWidth = _ref.readViewFitContainerWidth, readView = _ref.readView, testId = _ref.testId;
    var startX = (0, $dAx5m.useRef)(0);
    var startY = (0, $dAx5m.useRef)(0);
    var mouseHasMovedAfterMouseDown = function mouseHasMovedAfterMouseDown(event) {
        return Math.abs(startX.current - event.clientX) >= $613408bbbe4883b9$var$DRAG_THRESHOLD || Math.abs(startY.current - event.clientY) >= $613408bbbe4883b9$var$DRAG_THRESHOLD;
    };
    var onReadViewClick = function onReadViewClick(event) {
        var element = event.target;
        /** If a link is clicked in the read view, default action should be taken */ if (element.tagName.toLowerCase() !== "a" && !mouseHasMovedAfterMouseDown(event)) {
            event.preventDefault();
            onEditRequested();
            postReadViewClick();
        }
    };
    return (0, $jVTBW.jsx)("div", {
        css: $613408bbbe4883b9$var$readViewContainerStyles
    }, (0, $jVTBW.jsx)((0, $8Duts.default), {
        xcss: $613408bbbe4883b9$var$editButtonStyles,
        onClick: onEditRequested,
        ref: editButtonRef,
        testId: testId && "".concat(testId, "--edit-button")
    }, (0, $jVTBW.jsx)((0, $ez4n6.default), null, editButtonLabel)), (0, $jVTBW.jsx)("div", {
        css: [
            $613408bbbe4883b9$var$readViewWrapperStyles,
            readViewFitContainerWidth && $613408bbbe4883b9$var$readViewFitContainerWidthStyles
        ],
        role: "presentation",
        onClick: onReadViewClick,
        onMouseDown: function onMouseDown(e) {
            startX.current = e.clientX;
            startY.current = e.clientY;
        },
        "data-read-view-fit-container-width": readViewFitContainerWidth
    }, readView()));
};
var $613408bbbe4883b9$export$2e2bcd8739ae039 = $613408bbbe4883b9$var$ReadView;

});


parcelRegister("czpuE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $926c875d21b49466$export$2e2bcd8739ae039; });

var $k6VpY = parcelRequire("k6VpY");

var $lC3Ri = parcelRequire("lC3Ri");

var $6t1ly = parcelRequire("6t1ly");

var $dAx5m = parcelRequire("dAx5m");

var $bXeVH = parcelRequire("bXeVH");

var $iaDRR = parcelRequire("iaDRR");

var $Bb0he = parcelRequire("Bb0he");

var $6Oq6X = parcelRequire("6Oq6X");

var $54CNN = parcelRequire("54CNN");
var $5hsVF = parcelRequire("5hsVF");

var $6zP7W = parcelRequire("6zP7W");

var $7RqjY = parcelRequire("7RqjY");

var $k4dMs = parcelRequire("k4dMs");

var $iUykl = parcelRequire("iUykl");

var $1GoHh = parcelRequire("1GoHh");

var $iyyrs = parcelRequire("iyyrs");

var $lvFV9 = parcelRequire("lvFV9");

var $jO0LC = parcelRequire("jO0LC");

var $eKJc1 = parcelRequire("eKJc1");
function $926c875d21b49466$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $926c875d21b49466$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $926c875d21b49466$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($6t1ly)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $926c875d21b49466$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $926c875d21b49466$var$tooltipZIndex = (0, $iUykl.layers).tooltip();
var $926c875d21b49466$var$analyticsAttributes = {
    componentName: "tooltip",
    packageName: "@atlaskit/tooltip",
    packageVersion: "18.2.1"
};
// Inverts motion direction
var $926c875d21b49466$var$invertedDirection = {
    top: "bottom",
    bottom: "top",
    left: "right",
    right: "left"
};
/**
 * Converts a Popper placement to it's general direction.
 *
 * @param position - Popper Placement value, e.g. 'top-start'
 * @returns Popper Direction, e.g. 'top'
 */ var $926c875d21b49466$var$getDirectionFromPlacement = function getDirectionFromPlacement(placement) {
    return placement.split("-")[0];
};
function $926c875d21b49466$var$Tooltip(_ref) {
    var children = _ref.children, _ref$position = _ref.position, position = _ref$position === void 0 ? "bottom" : _ref$position, _ref$mousePosition = _ref.mousePosition, mousePosition = _ref$mousePosition === void 0 ? "bottom" : _ref$mousePosition, content = _ref.content, _ref$truncate = _ref.truncate, truncate = _ref$truncate === void 0 ? false : _ref$truncate, _ref$component = _ref.component, Container = _ref$component === void 0 ? (0, $jO0LC.default) : _ref$component, _ref$tag = _ref.tag, TargetContainer = _ref$tag === void 0 ? "div" : _ref$tag, testId = _ref.testId, _ref$delay = _ref.delay, delay = _ref$delay === void 0 ? 300 : _ref$delay, _ref$onShow = _ref.onShow, onShow = _ref$onShow === void 0 ? (0, $Bb0he.default) : _ref$onShow, _ref$onHide = _ref.onHide, onHide = _ref$onHide === void 0 ? (0, $Bb0he.default) : _ref$onHide, _ref$hideTooltipOnCli = _ref.hideTooltipOnClick, hideTooltipOnClick = _ref$hideTooltipOnCli === void 0 ? false : _ref$hideTooltipOnCli, _ref$hideTooltipOnMou = _ref.hideTooltipOnMouseDown, hideTooltipOnMouseDown = _ref$hideTooltipOnMou === void 0 ? false : _ref$hideTooltipOnMou, analyticsContext = _ref.analyticsContext, _ref$strategy = _ref.strategy, strategy = _ref$strategy === void 0 ? "fixed" : _ref$strategy;
    var tooltipPosition = position === "mouse" ? mousePosition : position;
    var onShowHandler = (0, $iaDRR.usePlatformLeafSyntheticEventHandler)($926c875d21b49466$var$_objectSpread({
        fn: onShow,
        action: "displayed",
        analyticsData: analyticsContext
    }, $926c875d21b49466$var$analyticsAttributes));
    var onHideHandler = (0, $iaDRR.usePlatformLeafSyntheticEventHandler)($926c875d21b49466$var$_objectSpread({
        fn: onHide,
        action: "hidden",
        analyticsData: analyticsContext
    }, $926c875d21b49466$var$analyticsAttributes));
    var apiRef = (0, $dAx5m.useRef)(null);
    var _useState = (0, $dAx5m.useState)("hide"), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($lC3Ri)))(_useState, 2), state = _useState2[0], setState = _useState2[1];
    var targetRef = (0, $dAx5m.useRef)(null);
    var containerRef = (0, $dAx5m.useRef)(null);
    // This function is deliberately _not_ memoized as it needs to re-run every render
    // to pick up any child ref changes. If you use render props you don't have this issue.
    var setImplicitRefFromChildren = function setImplicitRefFromChildren(node) {
        containerRef.current = node;
        targetRef.current = node ? node.firstElementChild : null;
    };
    // This is memoized and passed into the render props callback.
    var setDirectRef = (0, $dAx5m.useCallback)(function(node) {
        targetRef.current = node;
    }, []);
    // Putting a few things into refs so that we don't have to break memoization
    var lastState = (0, $dAx5m.useRef)(state);
    var lastDelay = (0, $dAx5m.useRef)(delay);
    var lastHandlers = (0, $dAx5m.useRef)({
        onShowHandler: onShowHandler,
        onHideHandler: onHideHandler
    });
    var hasCalledShowHandler = (0, $dAx5m.useRef)(false);
    (0, $dAx5m.useEffect)(function() {
        lastState.current = state;
        lastDelay.current = delay;
        lastHandlers.current = {
            onShowHandler: onShowHandler,
            onHideHandler: onHideHandler
        };
    }, [
        delay,
        onHideHandler,
        onShowHandler,
        state
    ]);
    var start = (0, $dAx5m.useCallback)(function(api) {
        // @ts-ignore
        apiRef.current = api;
        hasCalledShowHandler.current = false;
    }, []);
    var done = (0, $dAx5m.useCallback)(function() {
        if (!apiRef.current) return;
        // Only call onHideHandler if we have called onShowHandler
        if (hasCalledShowHandler.current) lastHandlers.current.onHideHandler();
        // @ts-ignore
        apiRef.current = null;
        // @ts-ignore
        hasCalledShowHandler.current = false;
        // just in case
        setState("hide");
    }, []);
    var abort = (0, $dAx5m.useCallback)(function() {
        if (!apiRef.current) return;
        apiRef.current.abort();
        // Only call onHideHandler if we have called onShowHandler
        if (hasCalledShowHandler.current) lastHandlers.current.onHideHandler();
        // @ts-ignore
        apiRef.current = null;
    }, []);
    (0, $dAx5m.useEffect)(function mount() {
        return function unmount() {
            if (apiRef.current) abort();
        };
    }, [
        abort
    ]);
    var isDraggingRef = (0, $dAx5m.useRef)(false);
    (0, $dAx5m.useEffect)(function() {
        return (0, $1GoHh.register)({
            onRegister: function onRegister(_ref2) {
                var isDragging = _ref2.isDragging;
                isDraggingRef.current = isDragging;
            },
            onDragStart: function onDragStart() {
                var _apiRef$current;
                /**
         * Hiding any visible tooltips when a drag starts because otherwise it
         * looks janky (disappears and reappears), and is not required.
         */ (_apiRef$current = apiRef.current) === null || _apiRef$current === void 0 || _apiRef$current.requestHide({
                    isImmediate: true
                });
                isDraggingRef.current = true;
            },
            onDragEnd: function onDragEnd() {
                isDraggingRef.current = false;
            }
        });
    }, []);
    var showTooltip = (0, $dAx5m.useCallback)(function(source) {
        /**
     * Prevent tooltips from being shown during a drag. This can occur with
     * the native drag and drop API, where some pointer events can fire
     * when they should not and lead to jank with tooltips.
     */ if (isDraggingRef.current) return;
        if (apiRef.current && !apiRef.current.isActive()) abort();
        // Tell the tooltip to keep showing
        if (apiRef.current && apiRef.current.isActive()) {
            apiRef.current.keep();
            return;
        }
        var entry = {
            source: source,
            delay: lastDelay.current,
            show: function show(_ref3) {
                var isImmediate = _ref3.isImmediate;
                // Call the onShow handler if it hasn't been called yet
                if (!hasCalledShowHandler.current) {
                    hasCalledShowHandler.current = true;
                    lastHandlers.current.onShowHandler();
                }
                setState(isImmediate ? "show-immediate" : "fade-in");
            },
            hide: function hide(_ref4) {
                var isImmediate = _ref4.isImmediate;
                if (isImmediate) setState("hide");
                else setState("before-fade-out");
            },
            done: done
        };
        var api = (0, $iyyrs.show)(entry);
        start(api);
    }, [
        abort,
        done,
        start
    ]);
    var hideTooltipOnEsc = (0, $dAx5m.useCallback)(function() {
        var _apiRef$current2;
        (_apiRef$current2 = apiRef.current) === null || _apiRef$current2 === void 0 || _apiRef$current2.requestHide({
            isImmediate: true
        });
    }, [
        apiRef
    ]);
    (0, $6Oq6X.default)({
        onClose: hideTooltipOnEsc,
        isDisabled: state === "hide" || state === "fade-out"
    });
    (0, $dAx5m.useEffect)(function() {
        if (state === "hide") return 0, $Bb0he.default;
        if (state === "before-fade-out") setState("fade-out");
        var unbind = (0, $bXeVH.bind)(window, {
            type: "scroll",
            listener: function listener() {
                if (apiRef.current) apiRef.current.requestHide({
                    isImmediate: true
                });
            },
            options: {
                capture: true,
                passive: true,
                once: true
            }
        });
        return unbind;
    }, [
        state
    ]);
    var onMouseDown = (0, $dAx5m.useCallback)(function() {
        if (hideTooltipOnMouseDown && apiRef.current) apiRef.current.requestHide({
            isImmediate: true
        });
    }, [
        hideTooltipOnMouseDown
    ]);
    var onClick = (0, $dAx5m.useCallback)(function() {
        if (hideTooltipOnClick && apiRef.current) apiRef.current.requestHide({
            isImmediate: true
        });
    }, [
        hideTooltipOnClick
    ]);
    // Ideally we would be using onMouseEnter here, but
    // because we are binding the event to the target parent
    // we need to listen for the mouseover of all sub elements
    // This means when moving along a tooltip we are quickly toggling
    // between api.requestHide and api.keep. This it not ideal
    var onMouseOver = (0, $dAx5m.useCallback)(function(event) {
        // Ignoring events from the container ref
        if (containerRef.current && event.target === containerRef.current) return;
        // Using prevent default as a signal that parent tooltips
        if (event.defaultPrevented) return;
        event.preventDefault();
        var source = position === "mouse" ? {
            type: "mouse",
            // TODO: ideally not recalculating this object each time
            mouse: (0, $eKJc1.getMousePosition)({
                left: event.clientX,
                top: event.clientY
            })
        } : {
            type: "keyboard"
        };
        showTooltip(source);
    }, [
        position,
        showTooltip
    ]);
    // Ideally we would be using onMouseEnter here, but
    // because we are binding the event to the target parent
    // we need to listen for the mouseout of all sub elements
    // This means when moving along a tooltip we are quickly toggling
    // between api.requestHide and api.keep. This it not ideal
    var onMouseOut = (0, $dAx5m.useCallback)(function(event) {
        // Ignoring events from the container ref
        if (containerRef.current && event.target === containerRef.current) return;
        // Using prevent default as a signal that parent tooltips
        if (event.defaultPrevented) return;
        event.preventDefault();
        if (apiRef.current) apiRef.current.requestHide({
            isImmediate: false
        });
    }, []);
    var onMouseMove = position === "mouse" ? function(event) {
        var _apiRef$current3;
        if ((_apiRef$current3 = apiRef.current) !== null && _apiRef$current3 !== void 0 && _apiRef$current3.isActive()) apiRef.current.mousePosition = (0, $eKJc1.getMousePosition)({
            left: event.clientX,
            top: event.clientY
        });
    } : undefined;
    var onMouseOverTooltip = (0, $dAx5m.useCallback)(function() {
        if (apiRef.current && apiRef.current.isActive()) {
            apiRef.current.keep();
            return;
        }
    }, []);
    var onFocus = (0, $dAx5m.useCallback)(function() {
        showTooltip({
            type: "keyboard"
        });
    }, [
        showTooltip
    ]);
    var onBlur = (0, $dAx5m.useCallback)(function() {
        if (apiRef.current) apiRef.current.requestHide({
            isImmediate: false
        });
    }, []);
    var onAnimationFinished = (0, $dAx5m.useCallback)(function(transition) {
        // Using lastState here because motion is not picking up the latest value
        if (transition === "exiting" && lastState.current === "fade-out" && apiRef.current) // @ts-ignore: refs are writeable
        apiRef.current.finishHideAnimation();
    }, []);
    // Doing a cast because typescript is struggling to narrow the type
    var CastTargetContainer = TargetContainer;
    var shouldRenderTooltipContainer = state !== "hide" && Boolean(content);
    var shouldRenderTooltipChildren = state !== "hide" && state !== "fade-out";
    var getReferenceElement = function getReferenceElement() {
        var _apiRef$current4;
        if (position === "mouse" && (_apiRef$current4 = apiRef.current) !== null && _apiRef$current4 !== void 0 && _apiRef$current4.mousePosition) {
            var _apiRef$current5;
            return (_apiRef$current5 = apiRef.current) === null || _apiRef$current5 === void 0 ? void 0 : _apiRef$current5.mousePosition;
        }
        return targetRef.current || undefined;
    };
    var tooltipId = (0, $lvFV9.default)("tooltip", shouldRenderTooltipContainer);
    var tooltipTriggerProps = {
        onMouseOver: onMouseOver,
        onMouseOut: onMouseOut,
        onMouseMove: onMouseMove,
        onMouseDown: onMouseDown,
        onClick: onClick,
        onFocus: onFocus,
        onBlur: onBlur
    };
    // Don't set `data-testid` unless it's defined, as it's not in the interface.
    if (testId) // @ts-expect-error - Adding `data-testid` to the TriggerProps interface breaks Buttons.
    tooltipTriggerProps["data-testid"] = "".concat(testId, "--container");
    // This useEffect is purely for managing the aria attribute when using the
    // wrapped children approach.
    (0, $dAx5m.useEffect)(function() {
        // If there is no container element, we should exit early, because that
        // means they are using the render prop API, and that is implemented in a
        // different way. If there is no target element yet or tooltipId, we also
        // shouldn't do anything because there is nothing to operate on or with.
        if (!containerRef.current || !targetRef.current || !tooltipId) return;
        var target = targetRef.current;
        if (shouldRenderTooltipContainer) target.setAttribute("aria-describedby", tooltipId);
        else target.removeAttribute("aria-describedby");
    }, [
        shouldRenderTooltipContainer,
        tooltipId
    ]);
    var hiddenContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement("span", {
        "data-testid": testId ? "".concat(testId, "-hidden") : undefined,
        hidden: true,
        id: tooltipId
    }, typeof content === "function" ? content({}) : content);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).Fragment, null, typeof children === "function" ? /*#__PURE__*/ // once we deprecate the wrapped approach, we can put the aria
    // attribute back into the tooltipTriggerProps and make it required
    // instead of optional in `types`
    (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).Fragment, null, children($926c875d21b49466$var$_objectSpread($926c875d21b49466$var$_objectSpread({}, tooltipTriggerProps), {}, {
        "aria-describedby": tooltipId,
        ref: setDirectRef
    })), shouldRenderTooltipContainer && hiddenContent) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement(CastTargetContainer, (0, (/*@__PURE__*/$parcel$interopDefault($k6VpY)))({}, tooltipTriggerProps, {
        ref: setImplicitRefFromChildren,
        role: "presentation"
    }), children, shouldRenderTooltipContainer && hiddenContent), shouldRenderTooltipContainer ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $k4dMs.default), {
        zIndex: $926c875d21b49466$var$tooltipZIndex
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $7RqjY.Popper), {
        placement: tooltipPosition,
        referenceElement: getReferenceElement(),
        strategy: strategy
    }, function(_ref5) {
        var ref = _ref5.ref, style = _ref5.style, update = _ref5.update, placement = _ref5.placement;
        // Invert the entrance and exit directions.
        // E.g. a tooltip's position is on the 'right', it should enter from and exit to the 'left'
        // This gives the effect the tooltip is appearing from the target
        var direction = position === "mouse" ? undefined : $926c875d21b49466$var$invertedDirection[$926c875d21b49466$var$getDirectionFromPlacement(placement)];
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $54CNN.default), {
            appear: true
        }, shouldRenderTooltipChildren && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $5hsVF.default), {
            distance: "constant",
            entranceDirection: direction,
            exitDirection: direction,
            onFinish: onAnimationFinished,
            duration: state === "show-immediate" ? 0 : (0, $6zP7W.mediumDurationMs)
        }, function(_ref6) {
            var className = _ref6.className;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement(Container, {
                ref: ref,
                className: "Tooltip ".concat(className),
                style: style,
                truncate: truncate,
                placement: tooltipPosition,
                testId: getReferenceElement() ? testId : testId && "".concat(testId, "--unresolved"),
                onMouseOut: onMouseOut,
                onMouseOver: onMouseOverTooltip
            }, typeof content === "function" ? content({
                update: update
            }) : content);
        }));
    })) : null);
}
$926c875d21b49466$var$Tooltip.displayName = "Tooltip";
var $926c875d21b49466$export$2e2bcd8739ae039 = $926c875d21b49466$var$Tooltip;

});
parcelRegister("k6VpY", function(module, exports) {
function $ea40e831c83ecc84$var$_extends() {
    return module.exports = $ea40e831c83ecc84$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $ea40e831c83ecc84$var$_extends.apply(null, arguments);
}
module.exports = $ea40e831c83ecc84$var$_extends, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("lC3Ri", function(module, exports) {

var $iuy6t = parcelRequire("iuy6t");

var $5iFOJ = parcelRequire("5iFOJ");

var $66ykm = parcelRequire("66ykm");

var $jn6ql = parcelRequire("jn6ql");
function $fbc023d30269c3b3$var$_slicedToArray(r, e) {
    return $iuy6t(r) || $5iFOJ(r, e) || $66ykm(r, e) || $jn6ql();
}
module.exports = $fbc023d30269c3b3$var$_slicedToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("iuy6t", function(module, exports) {
function $d7657b8e36666475$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
module.exports = $d7657b8e36666475$var$_arrayWithHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("5iFOJ", function(module, exports) {
function $3dbf12394cd7f646$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
module.exports = $3dbf12394cd7f646$var$_iterableToArrayLimit, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("66ykm", function(module, exports) {

var $3tdEM = parcelRequire("3tdEM");
function $471dee58723ed058$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $3tdEM(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $3tdEM(r, a) : void 0;
    }
}
module.exports = $471dee58723ed058$var$_unsupportedIterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("3tdEM", function(module, exports) {
function $286eac7a1a25236f$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
module.exports = $286eac7a1a25236f$var$_arrayLikeToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("jn6ql", function(module, exports) {
function $e1a525f514181562$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
module.exports = $e1a525f514181562$var$_nonIterableRest, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("6t1ly", function(module, exports) {

var $3SYNQ = parcelRequire("3SYNQ");
function $4b567ee7364f1f5e$var$_defineProperty(e, r, t) {
    return (r = $3SYNQ(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
module.exports = $4b567ee7364f1f5e$var$_defineProperty, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("3SYNQ", function(module, exports) {

var $kGODg = parcelRequire("kGODg");
var $2d45946c11ca753c$var$_typeof = $kGODg.default;

var $3Y4GB = parcelRequire("3Y4GB");
function $2d45946c11ca753c$var$toPropertyKey(t) {
    var i = $3Y4GB(t, "string");
    return "symbol" == $2d45946c11ca753c$var$_typeof(i) ? i : i + "";
}
module.exports = $2d45946c11ca753c$var$toPropertyKey, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("kGODg", function(module, exports) {
function $f0ff0168049625c3$var$_typeof(o) {
    "@babel/helpers - typeof";
    return module.exports = $f0ff0168049625c3$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $f0ff0168049625c3$var$_typeof(o);
}
module.exports = $f0ff0168049625c3$var$_typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("3Y4GB", function(module, exports) {

var $kGODg = parcelRequire("kGODg");
var $2e3a9c44ce12057f$var$_typeof = $kGODg.default;
function $2e3a9c44ce12057f$var$toPrimitive(t, r) {
    if ("object" != $2e3a9c44ce12057f$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $2e3a9c44ce12057f$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
module.exports = $2e3a9c44ce12057f$var$toPrimitive, module.exports.__esModule = true, module.exports["default"] = module.exports;

});



parcelRegister("bXeVH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.bindAll = module.exports.bind = void 0;

var $jKwrJ = parcelRequire("jKwrJ");
Object.defineProperty(module.exports, "bind", {
    enumerable: true,
    get: function() {
        return $jKwrJ.bind;
    }
});

var $1cFYr = parcelRequire("1cFYr");
Object.defineProperty(module.exports, "bindAll", {
    enumerable: true,
    get: function() {
        return $1cFYr.bindAll;
    }
});

});
parcelRegister("jKwrJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.bind = void 0;
function $e60b7b56fd2316e1$var$bind(target, _a) {
    var type = _a.type, listener = _a.listener, options = _a.options;
    target.addEventListener(type, listener, options);
    return function unbind() {
        target.removeEventListener(type, listener, options);
    };
}
module.exports.bind = $e60b7b56fd2316e1$var$bind;

});

parcelRegister("1cFYr", function(module, exports) {
"use strict";
var $0e07788c84d45b4f$var$__assign = module.exports && module.exports.__assign || function() {
    $0e07788c84d45b4f$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $0e07788c84d45b4f$var$__assign.apply(this, arguments);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.bindAll = void 0;

var $jKwrJ = parcelRequire("jKwrJ");
function $0e07788c84d45b4f$var$toOptions(value) {
    if (typeof value === "undefined") return undefined;
    if (typeof value === "boolean") return {
        capture: value
    };
    return value;
}
function $0e07788c84d45b4f$var$getBinding(original, sharedOptions) {
    if (sharedOptions == null) return original;
    var binding = $0e07788c84d45b4f$var$__assign($0e07788c84d45b4f$var$__assign({}, original), {
        options: $0e07788c84d45b4f$var$__assign($0e07788c84d45b4f$var$__assign({}, $0e07788c84d45b4f$var$toOptions(sharedOptions)), $0e07788c84d45b4f$var$toOptions(original.options))
    });
    return binding;
}
function $0e07788c84d45b4f$var$bindAll(target, bindings, sharedOptions) {
    var unbinds = bindings.map(function(original) {
        var binding = $0e07788c84d45b4f$var$getBinding(original, sharedOptions);
        return (0, $jKwrJ.bind)(target, binding);
    });
    return function unbindAll() {
        unbinds.forEach(function(unbind) {
            return unbind();
        });
    };
}
module.exports.bindAll = $0e07788c84d45b4f$var$bindAll;

});


parcelRegister("iaDRR", function(module, exports) {

$parcel$export(module.exports, "usePlatformLeafSyntheticEventHandler", function () { return $d3a8160f0a8cba76$export$1a04351537078b55; });

var $6t1ly = parcelRequire("6t1ly");

var $dAx5m = parcelRequire("dAx5m");

var $gJYt2 = parcelRequire("gJYt2");

var $16W6n = parcelRequire("16W6n");
function $d3a8160f0a8cba76$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $d3a8160f0a8cba76$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $d3a8160f0a8cba76$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($6t1ly)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $d3a8160f0a8cba76$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $d3a8160f0a8cba76$export$1a04351537078b55(_ref) {
    var fn = _ref.fn, action = _ref.action, componentName = _ref.componentName, packageName = _ref.packageName, packageVersion = _ref.packageVersion, analyticsData = _ref.analyticsData;
    var _useAnalyticsEvents = (0, $gJYt2.useAnalyticsEvents)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    // We put analyticsData and fn in a ref so that we don't need to break
    // memoization.
    // Generally these could be defined by consumers inline
    // and so we do this to avoid breaking memoization of useCallback
    var dataRef = (0, $16W6n.useTrackedRef)(analyticsData);
    var fnRef = (0, $16W6n.useTrackedRef)(fn);
    var handler = (0, $dAx5m.useCallback)(function() {
        var analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: componentName,
            attributes: {
                componentName: componentName,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
        // To avoid wrapping this component in AnalyticsContext we manually
        // push the parent context's meta data into the context.
        // Note: this new 'context'
        var context = $d3a8160f0a8cba76$var$_objectSpread({
            componentName: componentName,
            packageName: packageName,
            packageVersion: packageVersion
        }, dataRef.current);
        analyticsEvent.context.push(context);
        // fire an event on the atlaskit channel
        var clone = analyticsEvent.clone();
        if (clone) clone.fire("atlaskit");
        fnRef.current(analyticsEvent);
    }, [
        // These are strings and won't change
        action,
        componentName,
        packageName,
        packageVersion,
        // This function is memoized in the context
        createAnalyticsEvent,
        // these are a stable ref because of the useTrackedRef hook
        dataRef,
        fnRef
    ]);
    return handler;
}

});
parcelRegister("gJYt2", function(module, exports) {

$parcel$export(module.exports, "useAnalyticsEvents", function () { return $c2ffc0e199535087$export$5bf35293e545f20c; });

var $tWuif = parcelRequire("tWuif");

var $exMUA = parcelRequire("exMUA");

var $j573s = parcelRequire("j573s");
function $c2ffc0e199535087$export$5bf35293e545f20c() {
    var analyticsContext = (0, $j573s.useAnalyticsContext)();
    var createAnalyticsEvent = (0, $tWuif.useCallbackOne)(function(payload) {
        return new (0, $exMUA.default)({
            context: analyticsContext.getAtlaskitAnalyticsContext(),
            handlers: analyticsContext.getAtlaskitAnalyticsEventHandlers(),
            payload: payload
        });
    }, [
        analyticsContext
    ]);
    return {
        createAnalyticsEvent: createAnalyticsEvent
    };
}

});
parcelRegister("exMUA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a96a16934760a9ff$export$2e2bcd8739ae039; });

var $KeJeu = parcelRequire("KeJeu");

var $5su8H = parcelRequire("5su8H");

var $gjHmq = parcelRequire("gjHmq");

var $fC8op = parcelRequire("fC8op");

var $hJnjI = parcelRequire("hJnjI");

var $bvRn5 = parcelRequire("bvRn5");

var $aMm5n = parcelRequire("aMm5n");

var $k7rR7 = parcelRequire("k7rR7");

var $6t1ly = parcelRequire("6t1ly");

var $edhzq = parcelRequire("edhzq");
function $a96a16934760a9ff$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $a96a16934760a9ff$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, (/*@__PURE__*/$parcel$interopDefault($k7rR7)))(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, (/*@__PURE__*/$parcel$interopDefault($k7rR7)))(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, (/*@__PURE__*/$parcel$interopDefault($aMm5n)))(this, result);
    };
}
function $a96a16934760a9ff$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($a96a16934760a9ff$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $a96a16934760a9ff$export$35f8383928ba8d7 = function isUIAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $a96a16934760a9ff$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isUIAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === "UIAnalyticsEvent";
};
var $a96a16934760a9ff$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_AnalyticsEvent) {
    (0, (/*@__PURE__*/$parcel$interopDefault($bvRn5)))(UIAnalyticsEvent, _AnalyticsEvent);
    var _super = $a96a16934760a9ff$var$_createSuper(UIAnalyticsEvent);
    function UIAnalyticsEvent(props) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($5su8H)))(this, UIAnalyticsEvent);
        _this = _super.call(this, props);
        (0, (/*@__PURE__*/$parcel$interopDefault($6t1ly)))((0, (/*@__PURE__*/$parcel$interopDefault($fC8op)))(_this), "_isUIAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($6t1ly)))((0, (/*@__PURE__*/$parcel$interopDefault($fC8op)))(_this), "clone", function() {
            if (_this.hasFired) return null;
            var context = (0, (/*@__PURE__*/$parcel$interopDefault($KeJeu)))(_this.context);
            var handlers = (0, (/*@__PURE__*/$parcel$interopDefault($KeJeu)))(_this.handlers);
            /**
       * A hacky "deep clone" of the object. This is limited in that it wont
       * support functions, regexs, Maps, Sets, etc, but none of those need to
       * be represented in our payload.
       */ var payload = JSON.parse(JSON.stringify(_this.payload));
            return new UIAnalyticsEvent({
                context: context,
                handlers: handlers,
                payload: payload
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6t1ly)))((0, (/*@__PURE__*/$parcel$interopDefault($fC8op)))(_this), "fire", function(channel) {
            if (_this.hasFired) return;
            _this.handlers.forEach(function(handler) {
                return handler((0, (/*@__PURE__*/$parcel$interopDefault($fC8op)))(_this), channel);
            });
            _this.hasFired = true;
        });
        _this.context = props.context || [];
        _this.handlers = props.handlers || [];
        _this.hasFired = false;
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($gjHmq)))(UIAnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (this.hasFired) return this;
                return (0, (/*@__PURE__*/$parcel$interopDefault($hJnjI)))((0, (/*@__PURE__*/$parcel$interopDefault($k7rR7)))(UIAnalyticsEvent.prototype), "update", this).call(this, updater);
            }
        }
    ]);
    return UIAnalyticsEvent;
}((0, $edhzq.default));

});
parcelRegister("KeJeu", function(module, exports) {

var $5xPrf = parcelRequire("5xPrf");

var $14hLL = parcelRequire("14hLL");

var $66ykm = parcelRequire("66ykm");

var $hBdcv = parcelRequire("hBdcv");
function $08afb8c7122ec7af$var$_toConsumableArray(r) {
    return $5xPrf(r) || $14hLL(r) || $66ykm(r) || $hBdcv();
}
module.exports = $08afb8c7122ec7af$var$_toConsumableArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("5xPrf", function(module, exports) {

var $3tdEM = parcelRequire("3tdEM");
function $4097ef70d918e609$var$_arrayWithoutHoles(r) {
    if (Array.isArray(r)) return $3tdEM(r);
}
module.exports = $4097ef70d918e609$var$_arrayWithoutHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("14hLL", function(module, exports) {
function $0c73f2c8b26ec2ba$var$_iterableToArray(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
module.exports = $0c73f2c8b26ec2ba$var$_iterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("hBdcv", function(module, exports) {
function $cd0021c2dbbc125f$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
module.exports = $cd0021c2dbbc125f$var$_nonIterableSpread, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("5su8H", function(module, exports) {
function $3f96f255e36d748e$var$_classCallCheck(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
module.exports = $3f96f255e36d748e$var$_classCallCheck, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("gjHmq", function(module, exports) {

var $3SYNQ = parcelRequire("3SYNQ");
function $be100e324e09a5fe$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, $3SYNQ(o.key), o);
    }
}
function $be100e324e09a5fe$var$_createClass(e, r, t) {
    return r && $be100e324e09a5fe$var$_defineProperties(e.prototype, r), t && $be100e324e09a5fe$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}
module.exports = $be100e324e09a5fe$var$_createClass, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("fC8op", function(module, exports) {
function $b5e0ea39cd14545d$var$_assertThisInitialized(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}
module.exports = $b5e0ea39cd14545d$var$_assertThisInitialized, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("hJnjI", function(module, exports) {

var $2U4fZ = parcelRequire("2U4fZ");
function $ce88b9e72ef1d4e0$var$_get() {
    return module.exports = $ce88b9e72ef1d4e0$var$_get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function(e, t, r) {
        var p = $2U4fZ(e, t);
        if (p) {
            var n = Object.getOwnPropertyDescriptor(p, t);
            return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value;
        }
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $ce88b9e72ef1d4e0$var$_get.apply(null, arguments);
}
module.exports = $ce88b9e72ef1d4e0$var$_get, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("2U4fZ", function(module, exports) {

var $k7rR7 = parcelRequire("k7rR7");
function $21d41d1414b0f42b$var$_superPropBase(t, o) {
    for(; !({}).hasOwnProperty.call(t, o) && null !== (t = $k7rR7(t)););
    return t;
}
module.exports = $21d41d1414b0f42b$var$_superPropBase, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("k7rR7", function(module, exports) {
function $ea5a11af2ed9ce16$var$_getPrototypeOf(t) {
    return module.exports = $ea5a11af2ed9ce16$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $ea5a11af2ed9ce16$var$_getPrototypeOf(t);
}
module.exports = $ea5a11af2ed9ce16$var$_getPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

});



parcelRegister("bvRn5", function(module, exports) {

var $5SV94 = parcelRequire("5SV94");
function $861bfd6843bb144c$var$_inherits(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && $5SV94(t, e);
}
module.exports = $861bfd6843bb144c$var$_inherits, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("5SV94", function(module, exports) {
function $448e52c95fc5f3de$var$_setPrototypeOf(t, e) {
    return module.exports = $448e52c95fc5f3de$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $448e52c95fc5f3de$var$_setPrototypeOf(t, e);
}
module.exports = $448e52c95fc5f3de$var$_setPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("aMm5n", function(module, exports) {

var $kGODg = parcelRequire("kGODg");
var $7d8f84d36159153e$var$_typeof = $kGODg.default;

var $fC8op = parcelRequire("fC8op");
function $7d8f84d36159153e$var$_possibleConstructorReturn(t, e) {
    if (e && ("object" == $7d8f84d36159153e$var$_typeof(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return $fC8op(t);
}
module.exports = $7d8f84d36159153e$var$_possibleConstructorReturn, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("edhzq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a58fe8ac396566e4$export$2e2bcd8739ae039; });

var $kGODg = parcelRequire("kGODg");

var $5su8H = parcelRequire("5su8H");

var $gjHmq = parcelRequire("gjHmq");

var $6t1ly = parcelRequire("6t1ly");
function $a58fe8ac396566e4$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $a58fe8ac396566e4$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $a58fe8ac396566e4$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($6t1ly)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $a58fe8ac396566e4$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $a58fe8ac396566e4$export$ad4be5c2ec28cecf = function isAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $a58fe8ac396566e4$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === "AnalyticsEvent";
};
var $a58fe8ac396566e4$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function AnalyticsEvent(props) {
        var _this = this;
        (0, (/*@__PURE__*/$parcel$interopDefault($5su8H)))(this, AnalyticsEvent);
        (0, (/*@__PURE__*/$parcel$interopDefault($6t1ly)))(this, "_isAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($6t1ly)))(this, "clone", function() {
            // just a shallow clone, don't change sub refs unless you want to
            // affect the original's too
            var payload = $a58fe8ac396566e4$var$_objectSpread({}, _this.payload);
            return new AnalyticsEvent({
                payload: payload
            });
        });
        this.payload = props.payload;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($gjHmq)))(AnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (typeof updater === "function") this.payload = updater(this.payload);
                if ((0, (/*@__PURE__*/$parcel$interopDefault($kGODg)))(updater) === "object") this.payload = $a58fe8ac396566e4$var$_objectSpread($a58fe8ac396566e4$var$_objectSpread({}, this.payload), updater);
                return this;
            }
        }
    ]);
    return AnalyticsEvent;
}();

});


parcelRegister("j573s", function(module, exports) {

$parcel$export(module.exports, "useAnalyticsContext", function () { return $de43f4e7b6850672$export$d1f587f82ad51c4; });

var $dAx5m = parcelRequire("dAx5m");

var $h0bf1 = parcelRequire("h0bf1");
var $de43f4e7b6850672$export$d1f587f82ad51c4 = function useAnalyticsContext() {
    return (0, $dAx5m.useContext)((0, $h0bf1.default));
};

});


parcelRegister("16W6n", function(module, exports) {

$parcel$export(module.exports, "useTrackedRef", function () { return $0cf36bcb8303a203$export$1d27a74659855e44; });

var $dAx5m = parcelRequire("dAx5m");
var $0cf36bcb8303a203$export$1d27a74659855e44 = function useTrackedRef(value) {
    var ref = (0, $dAx5m.useRef)(value);
    ref.current = value;
    return ref;
};

});


parcelRegister("54CNN", function(module, exports) {

$parcel$export(module.exports, "useExitingPersistence", function () { return $3b1b6cc2be16a2f2$export$3b6f38abbdcbd000; });
$parcel$export(module.exports, "default", function () { return $3b1b6cc2be16a2f2$export$2e2bcd8739ae039; });

var $lC3Ri = parcelRequire("lC3Ri");

var $dAx5m = parcelRequire("dAx5m");

var $k9HgZ = parcelRequire("k9HgZ");
var $3b1b6cc2be16a2f2$export$d1e013d71d2e2121 = {
    // Motions will always appear if not inside a exiting persistence component.
    appear: true,
    isExiting: false
};
var $3b1b6cc2be16a2f2$export$b9c4904d7a6929e6 = /*#__PURE__*/ (0, $dAx5m.createContext)($3b1b6cc2be16a2f2$export$d1e013d71d2e2121);
var $3b1b6cc2be16a2f2$export$e4c4c45693c3a7c = function wrapChildWithContextProvider(child) {
    var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $3b1b6cc2be16a2f2$export$d1e013d71d2e2121;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement($3b1b6cc2be16a2f2$export$b9c4904d7a6929e6.Provider, {
        key: "".concat(child.key, "-provider"),
        value: value
    }, child);
};
var $3b1b6cc2be16a2f2$export$7032ae6d9d98bedd = function childrenToArray(children) {
    var childrenAsArray = [];
    // We convert children to an array using this helper method as it will add keys to children that do not
    // have them, such as when we have hardcoded children that are conditionally rendered.
    (0, $dAx5m.Children).toArray(children).forEach(function(child) {
        // We ignore any boolean children to make our code a little more simple later on,
        // and also filter out any falsies (empty strings, nulls, and undefined).
        if (typeof child !== "boolean" && Boolean(child)) // Children WILL have a key after being forced into an array using the React.Children helper.
        childrenAsArray.push(child);
    });
    return childrenAsArray;
};
var $3b1b6cc2be16a2f2$export$2ccbe4ff092af328 = function spliceNewElementsIntoPrevious(current, previous) {
    var splicedChildren = previous.concat([]);
    var previousMap = $3b1b6cc2be16a2f2$export$1d8c49f95a162a41(previous);
    for(var i = 0; i < current.length; i++){
        var child = current[i];
        var childIsNew = !previousMap[child.key];
        if (childIsNew) // This will insert the new element after the previous element.
        splicedChildren.splice(i + 1, 0, child);
    }
    return splicedChildren;
};
var $3b1b6cc2be16a2f2$export$1d8c49f95a162a41 = function childrenToObj(children) {
    return children.reduce(function(acc, child) {
        acc[child.key] = child;
        return acc;
    }, {});
};
var $3b1b6cc2be16a2f2$var$getMissingKeys = function getMissingKeys(current, previous) {
    var currentMapKeys = new Set(current.map(function(child) {
        return child.key;
    }));
    var missing = new Set();
    for(var i = 0; i < previous.length; i++){
        var element = previous[i];
        var _key = element.key;
        if (!currentMapKeys.has(_key)) missing.add(_key);
    }
    return missing;
};
/**
 * __ExitingPersistence__
 *
 * Useful for enabling elements to persist and animate away when they are removed from the DOM.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motions)
 */ var $3b1b6cc2be16a2f2$var$ExitingPersistence = /*#__PURE__*/ (0, $dAx5m.memo)(function(_ref) {
    var _ref$appear = _ref.appear, appear = _ref$appear === void 0 ? false : _ref$appear, children = _ref.children, exitThenEnter = _ref.exitThenEnter;
    var _useState = (0, $dAx5m.useState)([
        null,
        children
    ]), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($lC3Ri)))(_useState, 2), stateChildren = _useState2[0], setChildren = _useState2[1];
    var _useState3 = (0, $dAx5m.useState)([]), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($lC3Ri)))(_useState3, 2), exitingChildren = _useState4[0], setExitingChildren = _useState4[1];
    var _useState5 = (0, $dAx5m.useState)(function() {
        return {
            appear: appear,
            isExiting: false
        };
    }), _useState6 = (0, (/*@__PURE__*/$parcel$interopDefault($lC3Ri)))(_useState5, 2), defaultContext = _useState6[0], setDefaultContext = _useState6[1];
    (0, $dAx5m.useEffect)(function() {
        if (!defaultContext.appear) setDefaultContext({
            appear: true,
            isExiting: false
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    if ((0, $k9HgZ.isReducedMotion)()) return children;
    /**
   * NOTE: This is a workaround for the test case written in Jira where the stateChildren is a boolean value because
   * useState is mocked to return a boolean value.
   */ if (typeof stateChildren === "boolean") return children;
    var _stateChildren = (0, (/*@__PURE__*/$parcel$interopDefault($lC3Ri)))(stateChildren, 2), previousChildren = _stateChildren[0], currentChildren = _stateChildren[1];
    var previous = $3b1b6cc2be16a2f2$export$7032ae6d9d98bedd(previousChildren);
    var current = $3b1b6cc2be16a2f2$export$7032ae6d9d98bedd(currentChildren);
    if (currentChildren !== children) setChildren([
        currentChildren,
        children
    ]);
    var missingKeys = $3b1b6cc2be16a2f2$var$getMissingKeys(current, previous);
    var isSomeChildRemoved = !!missingKeys.size;
    var visibleChildren = current;
    if (isSomeChildRemoved) visibleChildren = $3b1b6cc2be16a2f2$export$2ccbe4ff092af328(current, previous);
    if (exitThenEnter) {
        if (exitingChildren.length) visibleChildren = exitingChildren;
        else {
            var nextExitingChildren = visibleChildren.filter(function(child) {
                return missingKeys.has(child.key);
            });
            if (nextExitingChildren.length) setExitingChildren(nextExitingChildren);
        }
    }
    if (missingKeys.size) visibleChildren = visibleChildren.map(function(child) {
        var isExiting = missingKeys.has(child.key);
        return $3b1b6cc2be16a2f2$export$e4c4c45693c3a7c(child, {
            appear: true,
            isExiting: isExiting,
            onFinish: isExiting ? function() {
                missingKeys.delete(child.key);
                if (missingKeys.size === 0) {
                    setChildren([
                        null,
                        children
                    ]);
                    setExitingChildren([]);
                }
            } : undefined
        });
    });
    else visibleChildren = visibleChildren.map(function(child) {
        return $3b1b6cc2be16a2f2$export$e4c4c45693c3a7c(child, defaultContext);
    });
    return visibleChildren;
});
var $3b1b6cc2be16a2f2$export$3b6f38abbdcbd000 = function useExitingPersistence() {
    return (0, $dAx5m.useContext)($3b1b6cc2be16a2f2$export$b9c4904d7a6929e6);
};
$3b1b6cc2be16a2f2$var$ExitingPersistence.displayName = "ExitingPersistence";
var $3b1b6cc2be16a2f2$export$2e2bcd8739ae039 = $3b1b6cc2be16a2f2$var$ExitingPersistence;

});
parcelRegister("k9HgZ", function(module, exports) {

$parcel$export(module.exports, "isReducedMotion", function () { return $eac63707943c4b0f$export$b7baf7667a68d87c; });
$parcel$export(module.exports, "reduceMotionAsPerUserPreference", function () { return $eac63707943c4b0f$export$f0f789643ba5a83c; });

var $lC3Ri = parcelRequire("lC3Ri");

var $dAx5m = parcelRequire("dAx5m");

var $5k48h = parcelRequire("5k48h");
var $eac63707943c4b0f$var$isMatchMediaAvailable = function isMatchMediaAvailable() {
    return typeof window !== "undefined" && "matchMedia" in window;
};
var $eac63707943c4b0f$export$b7baf7667a68d87c = function isReducedMotion() {
    if (!$eac63707943c4b0f$var$isMatchMediaAvailable()) return false;
    var _window$matchMedia = window.matchMedia("(prefers-reduced-motion: reduce)"), matches = _window$matchMedia.matches;
    return matches;
};
var $eac63707943c4b0f$export$c537e63161742ce3 = function useIsReducedMotion() {
    var _useState = (0, $dAx5m.useState)($eac63707943c4b0f$export$b7baf7667a68d87c), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($lC3Ri)))(_useState, 2), prefersReducedMotion = _useState2[0], setPrefersReducedMotion = _useState2[1];
    (0, $dAx5m.useEffect)(function() {
        if (!$eac63707943c4b0f$var$isMatchMediaAvailable()) return;
        var mediaQueryList = window.matchMedia("(prefers-reduced-motion: reduce)");
        var onChange = function onChange(event) {
            return setPrefersReducedMotion(event.matches);
        };
        return (0, $5k48h.bind)(mediaQueryList, {
            type: "change",
            listener: onChange
        });
    }, []);
    return prefersReducedMotion;
};
var $eac63707943c4b0f$export$f0f789643ba5a83c = {
    "@media (prefers-reduced-motion: reduce)": {
        animation: "none",
        transition: "none"
    }
};
var $eac63707943c4b0f$export$ff7706047246b98b = function prefersReducedMotion() {
    return $eac63707943c4b0f$export$f0f789643ba5a83c;
};

});
parcelRegister("5k48h", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.bindAll = module.exports.bind = void 0;

var $32Llf = parcelRequire("32Llf");
Object.defineProperty(module.exports, "bind", {
    enumerable: true,
    get: function() {
        return $32Llf.bind;
    }
});

var $hD2IA = parcelRequire("hD2IA");
Object.defineProperty(module.exports, "bindAll", {
    enumerable: true,
    get: function() {
        return $hD2IA.bindAll;
    }
});

});
parcelRegister("32Llf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.bind = void 0;
function $2376481106a70fd2$var$bind(target, _a) {
    var type = _a.type, listener = _a.listener, options = _a.options;
    target.addEventListener(type, listener, options);
    return function unbind() {
        target.removeEventListener(type, listener, options);
    };
}
module.exports.bind = $2376481106a70fd2$var$bind;

});

parcelRegister("hD2IA", function(module, exports) {
"use strict";
var $cd582ff4dca9c62c$var$__assign = module.exports && module.exports.__assign || function() {
    $cd582ff4dca9c62c$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $cd582ff4dca9c62c$var$__assign.apply(this, arguments);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.bindAll = void 0;

var $32Llf = parcelRequire("32Llf");
function $cd582ff4dca9c62c$var$toOptions(value) {
    if (typeof value === "undefined") return undefined;
    if (typeof value === "boolean") return {
        capture: value
    };
    return value;
}
function $cd582ff4dca9c62c$var$getBinding(original, sharedOptions) {
    if (sharedOptions == null) return original;
    var binding = $cd582ff4dca9c62c$var$__assign($cd582ff4dca9c62c$var$__assign({}, original), {
        options: $cd582ff4dca9c62c$var$__assign($cd582ff4dca9c62c$var$__assign({}, $cd582ff4dca9c62c$var$toOptions(sharedOptions)), $cd582ff4dca9c62c$var$toOptions(original.options))
    });
    return binding;
}
function $cd582ff4dca9c62c$var$bindAll(target, bindings, sharedOptions) {
    var unbinds = bindings.map(function(original) {
        var binding = $cd582ff4dca9c62c$var$getBinding(original, sharedOptions);
        return (0, $32Llf.bind)(target, binding);
    });
    return function unbindAll() {
        unbinds.forEach(function(unbind) {
            return unbind();
        });
    };
}
module.exports.bindAll = $cd582ff4dca9c62c$var$bindAll;

});




parcelRegister("5hsVF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3d84fb01b1c7c627$export$2e2bcd8739ae039; });

var $6t1ly = parcelRequire("6t1ly");

var $dAx5m = parcelRequire("dAx5m");

var $8w3vm = parcelRequire("8w3vm");

var $6zP7W = parcelRequire("6zP7W");

var $6MiVe = parcelRequire("6MiVe");
function $3d84fb01b1c7c627$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $3d84fb01b1c7c627$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $3d84fb01b1c7c627$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($6t1ly)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $3d84fb01b1c7c627$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $3d84fb01b1c7c627$var$directionMotions = {
    proportional: {
        bottom: "translate3d(0, calc(5% + 4px), 0)",
        left: "translate3d(calc(-5% - 4px), 0, 0)",
        right: "translate3d(calc(5% + 4px), 0, 0)",
        top: "translate3d(0, calc(-5% - 4px), 0)"
    },
    constant: {
        bottom: "translate3d(0, 4px, 0)",
        left: "translate3d(-4px, 0, 0)",
        right: "translate3d(4px, 0, 0)",
        top: "translate3d(0, -4px, 0)"
    }
};
var $3d84fb01b1c7c627$var$invertedDirection = {
    top: "bottom",
    bottom: "top",
    left: "right",
    right: "left"
};
var $3d84fb01b1c7c627$export$8497679fcaaeceb = function fadeInAnimation(direction) {
    var distance = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "proportional";
    return {
        from: $3d84fb01b1c7c627$var$_objectSpread({
            opacity: 0
        }, direction !== undefined && {
            transform: $3d84fb01b1c7c627$var$directionMotions[distance][direction]
        }),
        "50%": {
            opacity: 1
        },
        to: {
            transform: direction !== undefined ? "none" : undefined
        }
    };
};
var $3d84fb01b1c7c627$export$c9190c6659ea755b = function fadeOutAnimation(direction) {
    var distance = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "proportional";
    return {
        from: {
            opacity: 1,
            transform: direction !== undefined ? "translate3d(0, 0, 0)" : undefined
        },
        to: $3d84fb01b1c7c627$var$_objectSpread({
            opacity: 0
        }, direction !== undefined && {
            transform: $3d84fb01b1c7c627$var$directionMotions[distance][direction]
        })
    };
};
/**
 * Props for controlling the behavior of the FadeIn animation
 */ /**
 * __FadeIn__
 *
 * Useful for fading in one or more elements.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motions)
 */ var $3d84fb01b1c7c627$var$FadeIn = function FadeIn(_ref) {
    var children = _ref.children, _ref$duration = _ref.duration, duration = _ref$duration === void 0 ? (0, $6zP7W.largeDurationMs) : _ref$duration, entranceDirection = _ref.entranceDirection, exitDirection = _ref.exitDirection, _ref$distance = _ref.distance, distance = _ref$distance === void 0 ? "proportional" : _ref$distance, onFinish = _ref.onFinish, isPaused = _ref.isPaused;
    var invertedEntranceDirection = entranceDirection && $3d84fb01b1c7c627$var$invertedDirection[entranceDirection];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $6MiVe.default), {
        duration: duration,
        enteringAnimation: $3d84fb01b1c7c627$export$8497679fcaaeceb(entranceDirection, distance),
        exitingAnimation: $3d84fb01b1c7c627$export$c9190c6659ea755b(exitDirection || invertedEntranceDirection, distance),
        animationTimingFunction: function animationTimingFunction() {
            return 0, $8w3vm.easeInOut;
        },
        onFinish: onFinish,
        isPaused: isPaused
    }, children);
};
var $3d84fb01b1c7c627$export$2e2bcd8739ae039 = $3d84fb01b1c7c627$var$FadeIn;

});
parcelRegister("8w3vm", function(module, exports) {

$parcel$export(module.exports, "easeInOut", function () { return $633407e46ee86efa$export$c07234257a03d5e9; });
var $633407e46ee86efa$export$c07234257a03d5e9 = "cubic-bezier(0.15,1,0.3,1)";
var $633407e46ee86efa$export$57636bb43b1ccbb0 = "cubic-bezier(0.2,0,0,1)";
var $633407e46ee86efa$export$929e5a82286172a6 = "cubic-bezier(0.8,0,0,0.8)";

});

parcelRegister("6zP7W", function(module, exports) {

$parcel$export(module.exports, "mediumDurationMs", function () { return $4c9dabc176b6b882$export$6fa259be09e118a7; });
$parcel$export(module.exports, "largeDurationMs", function () { return $4c9dabc176b6b882$export$9424640c29bc466d; });
/**
 * Think of this as the motion equivalent of the @atlaskit/theme `grid()`.
 */ var $4c9dabc176b6b882$export$368bacef0dacbe05 = 25;
var $4c9dabc176b6b882$export$2023a81c8547415f = $4c9dabc176b6b882$export$368bacef0dacbe05 * 4;
var $4c9dabc176b6b882$export$6fa259be09e118a7 = $4c9dabc176b6b882$export$368bacef0dacbe05 * 14;
var $4c9dabc176b6b882$export$9424640c29bc466d = $4c9dabc176b6b882$export$368bacef0dacbe05 * 28;

});

parcelRegister("6MiVe", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4ef5e74ed28ea788$export$2e2bcd8739ae039; });

var $6t1ly = parcelRequire("6t1ly");

var $lC3Ri = parcelRequire("lC3Ri");

var $dAx5m = parcelRequire("dAx5m");

var $jVTBW = parcelRequire("jVTBW");

var $k9HgZ = parcelRequire("k9HgZ");

var $6zP7W = parcelRequire("6zP7W");

var $bruj7 = parcelRequire("bruj7");

var $54CNN = parcelRequire("54CNN");

var $dA2p0 = parcelRequire("dA2p0");
function $4ef5e74ed28ea788$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $4ef5e74ed28ea788$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $4ef5e74ed28ea788$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($6t1ly)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $4ef5e74ed28ea788$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
/**
 * These are props that motions should use as their external props for consumers.
 * See [FadeIn](packages/helpers/motion/src/entering/fade-in.tsx) for an example usage.
 */ /**
 * Used to multiply the initial duration for exiting motions.
 */ var $4ef5e74ed28ea788$var$EXITING_MOTION_MULTIPLIER = 0.5;
/**
 * This is the base INTERNAL component used for all other entering motions.
 * This does not need Javascript to execute on the client so it will run immediately
 * for any SSR rendered React apps before the JS has executed.
 */ var $4ef5e74ed28ea788$var$EnteringMotion = function EnteringMotion(_ref) {
    var children = _ref.children, animationTimingFunction = _ref.animationTimingFunction, enteringAnimation = _ref.enteringAnimation, exitingAnimation = _ref.exitingAnimation, isPaused = _ref.isPaused, onFinishMotion = _ref.onFinish, _ref$duration = _ref.duration, duration = _ref$duration === void 0 ? (0, $6zP7W.largeDurationMs) : _ref$duration;
    var staggered = (0, $dA2p0.useStaggeredEntrance)();
    var _useExitingPersistenc = (0, $54CNN.useExitingPersistence)(), isExiting = _useExitingPersistenc.isExiting, onExitFinished = _useExitingPersistenc.onFinish, appear = _useExitingPersistenc.appear;
    var setTimeout = (0, $bruj7.useSetTimeout)();
    var paused = isPaused || !staggered.isReady;
    var delay = isExiting ? 0 : staggered.delay;
    var state = isExiting ? "exiting" : "entering";
    var _useState = (0, $dAx5m.useState)(appear), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($lC3Ri)))(_useState, 2), hasAnimationStyles = _useState2[0], setHasAnimationStyles = _useState2[1];
    (0, $dAx5m.useEffect)(function() {
        // Tracking this to prevent changing state on an unmounted component
        var isCancelled = false;
        if (paused) return;
        // On initial mount if elements aren't set to animate on appear, we return early and callback
        if (!appear) {
            onFinishMotion && onFinishMotion(state);
            return;
        }
        // Elements may need animation styles back after initial mount (they could animate out)
        setHasAnimationStyles(true);
        setTimeout(function() {
            if (state === "exiting") onExitFinished && onExitFinished();
            if (!isCancelled) setHasAnimationStyles(false);
            onFinishMotion && onFinishMotion(state);
        }, isExiting ? duration * $4ef5e74ed28ea788$var$EXITING_MOTION_MULTIPLIER : duration + delay);
        return function() {
            isCancelled = true;
        };
    // We ignore this for onFinishMotion as consumers could potentially inline the function
    // which would then trigger this effect every re-render.
    // We want to make it easier for consumers so we go down this path unfortunately.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        onExitFinished,
        state,
        isExiting,
        duration,
        delay,
        paused,
        setTimeout
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $jVTBW.ClassNames), null, function(_ref2) {
        var css = _ref2.css;
        return children({
            ref: staggered.ref,
            className: hasAnimationStyles ? css($4ef5e74ed28ea788$var$_objectSpread($4ef5e74ed28ea788$var$_objectSpread({}, (0, $k9HgZ.reduceMotionAsPerUserPreference)), {}, {
                animationDelay: "".concat(delay, "ms"),
                animationDuration: "".concat(isExiting ? duration * $4ef5e74ed28ea788$var$EXITING_MOTION_MULTIPLIER : duration, "ms"),
                animationFillMode: isExiting ? "forwards" : "backwards",
                animationName: "".concat((0, $jVTBW.keyframes)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                isExiting ? exitingAnimation || enteringAnimation : enteringAnimation)),
                animationPlayState: paused ? "paused" : "running",
                animationTimingFunction: animationTimingFunction(state)
            })) : ""
        }, state);
    });
};
var $4ef5e74ed28ea788$export$2e2bcd8739ae039 = $4ef5e74ed28ea788$var$EnteringMotion;

});
parcelRegister("bruj7", function(module, exports) {

$parcel$export(module.exports, "useSetTimeout", function () { return $8549b9bd1c415a42$export$4f34107a2b00f39c; });

var $dAx5m = parcelRequire("dAx5m");
var $8549b9bd1c415a42$var$getHookDeps = function getHookDeps(opts) {
    switch(opts.cleanup){
        case "next-effect":
            return undefined;
        case "unmount":
        default:
            return [];
    }
};
var $8549b9bd1c415a42$export$1775f27e7c8051ca = function useRequestAnimationFrame() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        cleanup: "unmount"
    };
    var frames = (0, $dAx5m.useRef)([]);
    (0, $dAx5m.useEffect)(function() {
        return function() {
            if (frames.current.length) {
                frames.current.forEach(function(id) {
                    return cancelAnimationFrame(id);
                });
                frames.current = [];
            }
        };
    // We dynamically set this so we either clean up on the next effect - or on unmount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, $8549b9bd1c415a42$var$getHookDeps(opts));
    return (0, $dAx5m.useCallback)(function(handler) {
        var id = requestAnimationFrame(function(time) {
            frames.current = frames.current.filter(function(frameId) {
                return frameId !== id;
            });
            handler(time);
        });
        frames.current.push(id);
    }, []);
};
var $8549b9bd1c415a42$export$4f34107a2b00f39c = function useSetTimeout() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        cleanup: "unmount"
    };
    var timeouts = (0, $dAx5m.useRef)([]);
    (0, $dAx5m.useEffect)(function() {
        return function() {
            if (timeouts.current.length) {
                timeouts.current.forEach(function(id) {
                    return clearTimeout(id);
                });
                timeouts.current = [];
            }
        };
    // We dynamically set this so we either clean up on the next effect - or on unmount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, $8549b9bd1c415a42$var$getHookDeps(opts));
    return (0, $dAx5m.useCallback)(function(handler, timeout) {
        for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
        var id = setTimeout.apply(void 0, [
            function() {
                timeouts.current = timeouts.current.filter(function(timeoutId) {
                    return timeoutId !== id;
                });
                handler();
            },
            timeout
        ].concat(args));
        timeouts.current.push(id);
    }, []);
};

});

parcelRegister("dA2p0", function(module, exports) {

$parcel$export(module.exports, "useStaggeredEntrance", function () { return $9e30803b3378f516$export$25c7213fc07ec080; });

var $lC3Ri = parcelRequire("lC3Ri");

var $dAx5m = parcelRequire("dAx5m");

var $Bb0he = parcelRequire("Bb0he");

var $eGpcf = parcelRequire("eGpcf");

var $e1K3V = parcelRequire("e1K3V");
var $9e30803b3378f516$var$StaggeredEntranceContext = /*#__PURE__*/ (0, $dAx5m.createContext)(function() {
    return {
        isReady: true,
        delay: 0,
        ref: (0, $Bb0he.default)
    };
});
var $9e30803b3378f516$export$25c7213fc07ec080 = function useStaggeredEntrance() {
    var indentifier = (0, $e1K3V.useUniqueId)();
    var context = (0, $dAx5m.useContext)($9e30803b3378f516$var$StaggeredEntranceContext);
    return context(indentifier);
};
/**
 * For a list of elements that need to animate in,
 * this should be used in conjunction with entering components.
 * This does not need Javascript to execute so it will run immediately for any SSR rendered React apps before the JS has executed.
 *
 * Will dynamically add delay to each child entering component.
 * Unfortunately all entering components _NEED_ to be a direct descendant.
 */ var $9e30803b3378f516$var$StaggeredEntrance = function StaggeredEntrance(_ref) {
    var children = _ref.children, column = _ref.column, _ref$columns = _ref.columns, columns = _ref$columns === void 0 ? "responsive" : _ref$columns, _ref$delayStep = _ref.delayStep, delayStep = _ref$delayStep === void 0 ? 50 : _ref$delayStep;
    var elementRefs = (0, $dAx5m.useRef)([]);
    var indexes = [];
    var _useState = (0, $dAx5m.useState)(function() {
        if (typeof columns === "number") // A hardcoded columns is set so bail out and set it to that!
        return columns;
        if (typeof column === "number") // A hardcoded column is set so we will set actualColumns to be 1.
        return 1;
        // We are in "responsive" mode.
        // So we will be calculating when the Javascript executes on the client how many columns there will be.
        return 0;
    }), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($lC3Ri)))(_useState, 2), actualColumns = _useState2[0], setActualColumns = _useState2[1];
    (0, $eGpcf.useLayoutEffect)(function() {
        // We want to only run this code when we are in "responsive" mode.
        // It is assumed we are in responsive mode if `columns` is "responsive",
        // we have children element refs ready to be read (i.e. if there are no children this won't run as well)
        // and finally that `actualColumns` is `0` - this is because for the first render cycle `actualColumns` will be `0` (set above)
        // and then after this layout effect runs the value for `actualColumns` will then be calculated and set.
        if (columns === "responsive" && elementRefs.current.length && actualColumns === 0) {
            var currentTop = 0;
            var numberColumns = 0;
            if (elementRefs.current.length <= 1) {
                setActualColumns(1);
                return;
            }
            // We set the current top to the first elements.
            // We will be comparing this and incrementing the column count
            // until we hit an element that has a different offset top (or we run out of elements).
            currentTop = elementRefs.current[0] ? elementRefs.current[0].offsetTop : 0;
            for(var i = 0; i < elementRefs.current.length; i++){
                var child = elementRefs.current[i];
                if (!child) break;
                if (currentTop === child.offsetTop) {
                    numberColumns += 1;
                    if (elementRefs.current.length - 1 === i) setActualColumns(numberColumns);
                    continue;
                }
                setActualColumns(numberColumns);
                break;
            }
        }
    // We only want this effect to run once - on initial mount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement($9e30803b3378f516$var$StaggeredEntranceContext.Provider, {
        value: function value(id) {
            if (!indexes.includes(id)) indexes.push(id);
            var isReady = actualColumns > 0;
            var index = indexes.indexOf(id);
            var currentColumn = column || index % actualColumns;
            var currentRow = Math.floor(index / actualColumns);
            var distanceFromTopLeftElement = currentRow + currentColumn;
            // We don't want loads of elements to have the same staggered delay as it ends up looking slow for users.
            // To get around that we calculate the logarithm using `distanceFromTopLeftElement` which ends making
            // elements appear faster the further away from the top left element.
            var delay = Math.ceil(Math.log(distanceFromTopLeftElement + 1) * delayStep * 1.5) || 0;
            return {
                delay: delay,
                isReady: isReady,
                ref: function ref(element) {
                    return elementRefs.current[index] = element;
                }
            };
        }
    }, children);
};
var $9e30803b3378f516$export$2e2bcd8739ae039 = $9e30803b3378f516$var$StaggeredEntrance;

});
parcelRegister("eGpcf", function(module, exports) {

$parcel$export(module.exports, "useLayoutEffect", function () { return $ab08887635a9be44$export$e5c5a5f917a5871c; });

var $dAx5m = parcelRequire("dAx5m");
var $ab08887635a9be44$export$e5c5a5f917a5871c = typeof window === "undefined" ? (0, $dAx5m.useEffect) : (0, $dAx5m.useLayoutEffect);

});

parcelRegister("e1K3V", function(module, exports) {

$parcel$export(module.exports, "useUniqueId", function () { return $a364e3b1007e72f7$export$c485849f2e393253; });
/* eslint-disable @repo/internal/react/disallow-unstable-values */ 
var $dAx5m = parcelRequire("dAx5m");
function $a364e3b1007e72f7$export$c485849f2e393253() {
    var identifier = (0, $dAx5m.useRef)("");
    if (!identifier.current) identifier.current = "_" + (Number(String(Math.random()).slice(2)) + Date.now() + Math.round(performance.now())).toString(36);
    return identifier.current;
}

});




parcelRegister("7RqjY", function(module, exports) {

$parcel$export(module.exports, "Popper", function () { return $5b91e674ddcba1db$export$badac9ada3a0bdf9; });

var $KeJeu = parcelRequire("KeJeu");

var $lC3Ri = parcelRequire("lC3Ri");

var $dAx5m = parcelRequire("dAx5m");

var $2BQLr = parcelRequire("2BQLr");

// Export types from PopperJS / React Popper
var $5b91e674ddcba1db$var$constantModifiers = [
    {
        name: "flip",
        options: {
            flipVariations: false,
            padding: 5,
            boundary: "clippingParents",
            rootBoundary: "viewport"
        }
    },
    {
        name: "preventOverflow",
        options: {
            padding: 5,
            rootBoundary: "document"
        }
    }
];
function $5b91e674ddcba1db$var$defaultChildrenFn() {
    return null;
}
var $5b91e674ddcba1db$var$defaultOffset = [
    0,
    8
];
function $5b91e674ddcba1db$export$badac9ada3a0bdf9(_ref) {
    var _ref$children = _ref.children, children = _ref$children === void 0 ? $5b91e674ddcba1db$var$defaultChildrenFn : _ref$children, _ref$offset = _ref.offset, offset = _ref$offset === void 0 ? $5b91e674ddcba1db$var$defaultOffset : _ref$offset, _ref$placement = _ref.placement, placement = _ref$placement === void 0 ? "bottom-start" : _ref$placement, _ref$referenceElement = _ref.referenceElement, referenceElement = _ref$referenceElement === void 0 ? undefined : _ref$referenceElement, modifiers = _ref.modifiers, _ref$strategy = _ref.strategy, strategy = _ref$strategy === void 0 ? "fixed" : _ref$strategy;
    var _offset = (0, (/*@__PURE__*/$parcel$interopDefault($lC3Ri)))(offset, 2), offsetX = _offset[0], offsetY = _offset[1];
    // Merge a new offset modifier only if new offset values passed in
    var internalModifiers = (0, $dAx5m.useMemo)(function() {
        var offsetModifier = {
            name: "offset",
            options: {
                offset: [
                    offsetX,
                    offsetY
                ]
            }
        };
        return [].concat($5b91e674ddcba1db$var$constantModifiers, [
            offsetModifier
        ]);
    }, [
        offsetX,
        offsetY
    ]);
    // Merge custom props and memoize
    var mergedModifiers = (0, $dAx5m.useMemo)(function() {
        if (modifiers == null) return internalModifiers;
        return [].concat((0, (/*@__PURE__*/$parcel$interopDefault($KeJeu)))(internalModifiers), (0, (/*@__PURE__*/$parcel$interopDefault($KeJeu)))(modifiers));
    }, [
        internalModifiers,
        modifiers
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $2BQLr.Popper), {
        modifiers: mergedModifiers,
        placement: placement,
        strategy: strategy,
        referenceElement: referenceElement
    }, children);
}

});

parcelRegister("k4dMs", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e9bedeedd62a0bde$export$2e2bcd8739ae039; });

var $dAx5m = parcelRequire("dAx5m");

var $2oCKV = parcelRequire("2oCKV");

var $iwJWS = parcelRequire("iwJWS");

var $30aVI = parcelRequire("30aVI");

var $hFXDJ = parcelRequire("hFXDJ");

var $5NvzW = parcelRequire("5NvzW");
function $e9bedeedd62a0bde$export$2e2bcd8739ae039(_ref) {
    var _ref$zIndex = _ref.zIndex, zIndex = _ref$zIndex === void 0 ? 0 : _ref$zIndex, children = _ref.children, _ref$mountStrategy = _ref.mountStrategy, mountStrategy = _ref$mountStrategy === void 0 ? "effect" : _ref$mountStrategy;
    var isSubsequentRender = (0, $hFXDJ.default)(mountStrategy);
    (0, $5NvzW.default)(zIndex);
    // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
    return !(0, $2oCKV.fg)("dsp-19516-design-system-portal-logic-update") ? isSubsequentRender ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $iwJWS.default), {
        zIndex: zIndex
    }, children) : null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $30aVI.default), {
        zIndex: zIndex
    }, children);
}

});
parcelRegister("2oCKV", function(module, exports) {

$parcel$export(module.exports, "fg", function () { return $1bebe2cb135a47da$export$b40ec24ac8275656; });

var $3Fqck = parcelRequire("3Fqck");
function $1bebe2cb135a47da$export$ba05d765b8392e5e(flagResolver) {
    (0, $3Fqck.setBooleanResolver)(flagResolver);
}
function $1bebe2cb135a47da$export$470e5c2be1411c89(name) {
    return (0, $3Fqck.resolveBooleanFlag)(name);
}
function $1bebe2cb135a47da$export$b40ec24ac8275656(name) {
    return (0, $3Fqck.resolveBooleanFlag)(name);
}

});
parcelRegister("3Fqck", function(module, exports) {

$parcel$export(module.exports, "setBooleanResolver", function () { return $2ab985cc4ae027ea$export$f2b591175b3e424c; });
$parcel$export(module.exports, "resolveBooleanFlag", function () { return $2ab985cc4ae027ea$export$6333b6aff9fc6275; });

var $gvClt = parcelRequire("gvClt");

var $ahJoN = parcelRequire("ahJoN");
var $2ab985cc4ae027ea$var$pkgName = "@atlaskit/platform-feature-flags";
var $2ab985cc4ae027ea$export$7e41b1b2bdee3f98 = "__PLATFORM_FEATURE_FLAGS__";
var $2ab985cc4ae027ea$var$hasProcessEnv = typeof $ahJoN !== "undefined" && typeof $ahJoN.env !== "undefined";
// FF global overrides can be configured by test runners or Storybook
var $2ab985cc4ae027ea$var$ENV_ENABLE_PLATFORM_FF = $2ab985cc4ae027ea$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
// STORYBOOK_ENABLE_PLATFORM_FF is included as storybook only allows env vars prefixed with STORYBOOK
// https://github.com/storybookjs/storybook/issues/12270
var $2ab985cc4ae027ea$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF = $2ab985cc4ae027ea$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
var $2ab985cc4ae027ea$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE = $2ab985cc4ae027ea$var$ENV_ENABLE_PLATFORM_FF || $2ab985cc4ae027ea$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF;
var $2ab985cc4ae027ea$var$DEFAULT_PFF_GLOBAL = {
    // In development mode we want to capture any feature flag checks that happen using the default resolver and log this result when the resolver is replaced.
    // This is because evaluating feature flags when the resolver/FF client is loaded asynchronously could cause unexpected issues.
    earlyResolvedFlags: new Map(),
    booleanResolver: function booleanResolver(flagKey) {
        var unresolvedFlagCount;
        return false;
    }
};
var $2ab985cc4ae027ea$var$globalVar = typeof window !== "undefined" ? window : globalThis;
$2ab985cc4ae027ea$var$globalVar[$2ab985cc4ae027ea$export$7e41b1b2bdee3f98] = $2ab985cc4ae027ea$var$globalVar[$2ab985cc4ae027ea$export$7e41b1b2bdee3f98] || $2ab985cc4ae027ea$var$DEFAULT_PFF_GLOBAL;
function $2ab985cc4ae027ea$export$f2b591175b3e424c(resolver) {
    $2ab985cc4ae027ea$var$globalVar[$2ab985cc4ae027ea$export$7e41b1b2bdee3f98].booleanResolver = resolver;
    var _globalVar$PFF_GLOBAL;
}
function $2ab985cc4ae027ea$export$6333b6aff9fc6275(flagKey) {
    if ($2ab985cc4ae027ea$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE) {
        (0, $gvClt.debug)('[%s]: The feature flags were enabled while running tests. The flag "%s" will be always enabled.', $2ab985cc4ae027ea$var$pkgName, flagKey);
        return true;
    }
    try {
        var _globalVar$PFF_GLOBAL2;
        var result = (_globalVar$PFF_GLOBAL2 = $2ab985cc4ae027ea$var$globalVar[$2ab985cc4ae027ea$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL2 === void 0 ? void 0 : _globalVar$PFF_GLOBAL2.booleanResolver(flagKey);
        if (typeof result !== "boolean") {
            // eslint-disable-next-line no-console
            console.warn("".concat(flagKey, " resolved to a non-boolean value, returning false for safety"));
            return false;
        }
        return result;
    } catch (e) {
        return false;
    }
}

});
parcelRegister("gvClt", function(module, exports) {

$parcel$export(module.exports, "debug", function () { return $c04d492813e04895$export$1c9f709888824e05; });
var $c04d492813e04895$var$_ref, $c04d492813e04895$var$_process, $c04d492813e04895$var$_process2;
// We can't rely on NODE_ENV === 'test' if its value is already configured by the consumer to some other value, so better to use JEST_WORKER_ID
// https://jestjs.io/docs/environment-variables#jest_worker_id
var $c04d492813e04895$var$TESTS_MODE = ($c04d492813e04895$var$_ref = (globalThis === null || globalThis === void 0 || ($c04d492813e04895$var$_process = globalThis.process) === null || $c04d492813e04895$var$_process === void 0 || ($c04d492813e04895$var$_process = $c04d492813e04895$var$_process.env) === null || $c04d492813e04895$var$_process === void 0 ? void 0 : $c04d492813e04895$var$_process.JEST_WORKER_ID) !== undefined, $c04d492813e04895$var$_ref !== void 0) ? $c04d492813e04895$var$_ref : false;
var $c04d492813e04895$var$DEBUG_MODE = !$c04d492813e04895$var$TESTS_MODE && (globalThis === null || globalThis === void 0 || ($c04d492813e04895$var$_process2 = globalThis.process) === null || $c04d492813e04895$var$_process2 === void 0 || ($c04d492813e04895$var$_process2 = $c04d492813e04895$var$_process2.env) === null || $c04d492813e04895$var$_process2 === void 0 ? void 0 : $c04d492813e04895$var$_process2.NODE_ENV) !== "production";
var $c04d492813e04895$export$1c9f709888824e05 = function debug() {
    var _console;
    if (!$c04d492813e04895$var$DEBUG_MODE) return;
    // eslint-disable-next-line no-console
    (_console = console).debug.apply(_console, arguments);
};

});



parcelRegister("iwJWS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d7cedb92f63023a0$export$2e2bcd8739ae039; });

var $dAx5m = parcelRequire("dAx5m");

var $1MpXQ = parcelRequire("1MpXQ");

var $aGDMo = parcelRequire("aGDMo");
function $d7cedb92f63023a0$export$2e2bcd8739ae039(props) {
    var zIndex = props.zIndex, children = props.children;
    var container = (0, $dAx5m.useMemo)(function() {
        return (0, $aGDMo.createContainer)(zIndex);
    }, [
        zIndex
    ]);
    // This is in the render method instead of useEffect so that
    // the portal will be added to the DOM before the children render.
    // For any further changes, ensure that the container does not have a
    // parent besides the portal parent.
    (0, $aGDMo.appendPortalContainerIfNotAppended)(container);
    (0, $dAx5m.useEffect)(function() {
        return function() {
            (0, $aGDMo.removePortalContainer)(container);
        };
    }, [
        container
    ]);
    return /*#__PURE__*/ (0, $1MpXQ.createPortal)(children, container);
}

});
parcelRegister("aGDMo", function(module, exports) {

$parcel$export(module.exports, "createContainer", function () { return $7c7caf070659881b$export$26ae5ca175b4ec5a; });
$parcel$export(module.exports, "removePortalContainer", function () { return $7c7caf070659881b$export$da99f98bf3fe55b3; });
$parcel$export(module.exports, "appendPortalContainerIfNotAppended", function () { return $7c7caf070659881b$export$c582005add11e141; });
$parcel$export(module.exports, "createAtlaskitPortal", function () { return $7c7caf070659881b$export$fef014d7cef9e543; });
$parcel$export(module.exports, "createPortalParent", function () { return $7c7caf070659881b$export$95029ca7aca2989e; });

var $fTAVk = parcelRequire("fTAVk");
var $7c7caf070659881b$export$26ae5ca175b4ec5a = function createContainer(zIndex) {
    var container = document.createElement("div");
    container.className = (0, $fTAVk.portalClassName);
    container.style.zIndex = "".concat(zIndex);
    return container;
};
/**
 * Returns document body element
 * @return {number} - The document body element
 */ var $7c7caf070659881b$var$getBody = function getBody() {
    return document.body;
};
/**
 * Returns portal parent container. If no container exists already then it creates a new container with class name 'atlaskit-portal-container'
 * @return {Element} - The portal parent container div element
 */ var $7c7caf070659881b$var$getPortalParent = function getPortalParent() {
    var parentElement = document.querySelector((0, $fTAVk.portalParentSelector));
    if (!parentElement) {
        var _getBody;
        var parent = document.createElement("div");
        parent.className = (0, $fTAVk.portalParentClassName);
        // we are setting display to flex because we want each portal to create a new stacking context
        // See https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Positioning/Understanding_z_index/The_stacking_context
        parent.style.display = "flex";
        (_getBody = $7c7caf070659881b$var$getBody()) === null || _getBody === void 0 || _getBody.appendChild(parent);
        return parent;
    }
    return parentElement;
};
var $7c7caf070659881b$export$da99f98bf3fe55b3 = function removePortalContainer(container) {
    $7c7caf070659881b$var$getPortalParent().removeChild(container);
};
var $7c7caf070659881b$export$c582005add11e141 = function appendPortalContainerIfNotAppended(container) {
    if (!container.parentElement) $7c7caf070659881b$var$getPortalParent().appendChild(container);
};
var $7c7caf070659881b$export$842dfe7a9f24298 = function isDocumentDefined() {
    return document !== undefined;
};
var $7c7caf070659881b$export$fef014d7cef9e543 = function createAtlaskitPortal(zIndex) {
    //atlaskit-portal div
    if ($7c7caf070659881b$export$842dfe7a9f24298()) {
        var atlaskitportal = document.createElement("div");
        atlaskitportal.className = (0, $fTAVk.portalClassName);
        atlaskitportal.style.zIndex = "".concat(zIndex);
        return atlaskitportal;
    }
};
var $7c7caf070659881b$export$95029ca7aca2989e = function createPortalParent() {
    //atlaskit-portal-container div
    if ($7c7caf070659881b$export$842dfe7a9f24298()) {
        var parentElement = document.querySelector((0, $fTAVk.portalParentSelector));
        if (!parentElement) {
            var _getBody2;
            var parent = document.createElement("div");
            parent.className = (0, $fTAVk.portalParentClassName);
            parent.style.display = "flex";
            (_getBody2 = $7c7caf070659881b$var$getBody()) === null || _getBody2 === void 0 || _getBody2.appendChild(parent);
            return parent;
        }
        return parentElement;
    }
};

});
parcelRegister("fTAVk", function(module, exports) {

$parcel$export(module.exports, "portalParentClassName", function () { return $b928a25837cd30c6$export$e4c79eb95c23a0da; });
$parcel$export(module.exports, "portalParentSelector", function () { return $b928a25837cd30c6$export$72f415121273627e; });
$parcel$export(module.exports, "portalClassName", function () { return $b928a25837cd30c6$export$13f57c02915787b3; });
var $b928a25837cd30c6$export$e4c79eb95c23a0da = "atlaskit-portal-container";
var $b928a25837cd30c6$export$72f415121273627e = "body > .atlaskit-portal-container";
var $b928a25837cd30c6$export$13f57c02915787b3 = "atlaskit-portal";

});



parcelRegister("30aVI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $22f9d9a1b7b080c7$export$2e2bcd8739ae039; });

var $jPHQh = parcelRequire("jPHQh");

var $dAx5m = parcelRequire("dAx5m");

var $1MpXQ = parcelRequire("1MpXQ");

var $k2fEG = parcelRequire("k2fEG");

var $aGDMo = parcelRequire("aGDMo");
function $22f9d9a1b7b080c7$export$2e2bcd8739ae039(props) {
    var zIndex = props.zIndex, children = props.children;
    var _useState = (0, $dAx5m.useState)(null), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($jPHQh)))(_useState, 2), atlaskitPortal = _useState2[0], setAtlaskitPortal = _useState2[1];
    (0, $k2fEG.useIsomorphicLayoutEffect)(function() {
        var tempPortalContainer = (0, $aGDMo.createAtlaskitPortal)(zIndex);
        setAtlaskitPortal(tempPortalContainer);
        var portalParent = (0, $aGDMo.createPortalParent)();
        if (!tempPortalContainer || !portalParent) return;
        portalParent.appendChild(tempPortalContainer);
        return function() {
            if (tempPortalContainer) portalParent.removeChild(tempPortalContainer);
            setAtlaskitPortal(null);
        };
    }, [
        zIndex
    ]);
    return atlaskitPortal ? /*#__PURE__*/ (0, $1MpXQ.createPortal)(children, atlaskitPortal) : null;
}

});
parcelRegister("jPHQh", function(module, exports) {

var $4Wx7h = parcelRequire("4Wx7h");

var $cv85f = parcelRequire("cv85f");

var $53SQL = parcelRequire("53SQL");

var $7p7os = parcelRequire("7p7os");
function $e704c9e968e0e228$var$_slicedToArray(r, e) {
    return $4Wx7h(r) || $cv85f(r, e) || $53SQL(r, e) || $7p7os();
}
module.exports = $e704c9e968e0e228$var$_slicedToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("4Wx7h", function(module, exports) {
function $399644711f358760$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
module.exports = $399644711f358760$var$_arrayWithHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("cv85f", function(module, exports) {
function $919ea682c62df422$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
module.exports = $919ea682c62df422$var$_iterableToArrayLimit, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("53SQL", function(module, exports) {

var $ePsO1 = parcelRequire("ePsO1");
function $3af7c7a875596877$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $ePsO1(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $ePsO1(r, a) : void 0;
    }
}
module.exports = $3af7c7a875596877$var$_unsupportedIterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("ePsO1", function(module, exports) {
function $acbc2c5c260e4b26$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
module.exports = $acbc2c5c260e4b26$var$_arrayLikeToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("7p7os", function(module, exports) {
function $56409a6123e9ddd4$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
module.exports = $56409a6123e9ddd4$var$_nonIterableRest, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("k2fEG", function(module, exports) {

$parcel$export(module.exports, "useIsomorphicLayoutEffect", function () { return $e96023539d72ac84$export$700979bc83e7db82; });

var $dAx5m = parcelRequire("dAx5m");
var $e96023539d72ac84$export$700979bc83e7db82 = typeof window !== "undefined" ? (0, $dAx5m.useLayoutEffect) : (0, $dAx5m.useEffect);

});


parcelRegister("hFXDJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cde487416ad22ba5$export$2e2bcd8739ae039; });

var $jPHQh = parcelRequire("jPHQh");

var $dAx5m = parcelRequire("dAx5m");

var $k2fEG = parcelRequire("k2fEG");
var $cde487416ad22ba5$var$useIsSubsequentRender = function useIsSubsequentRender(mountStrategy) {
    var _useState = (0, $dAx5m.useState)(false), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($jPHQh)))(_useState, 2), isSubsequentRender = _useState2[0], setIsSubsequentRender = _useState2[1];
    var _useState3 = (0, $dAx5m.useState)(function() {
        return mountStrategy === "layoutEffect" ? (0, $k2fEG.useIsomorphicLayoutEffect) : (0, $dAx5m.useEffect);
    }), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($jPHQh)))(_useState3, 1), useMountEffect = _useState4[0];
    useMountEffect(function() {
        setIsSubsequentRender(true);
    }, []);
    return isSubsequentRender;
};
var $cde487416ad22ba5$export$2e2bcd8739ae039 = $cde487416ad22ba5$var$useIsSubsequentRender;

});

parcelRegister("5NvzW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $438a063bafabfa87$export$2e2bcd8739ae039; });

var $dAx5m = parcelRequire("dAx5m");

var $emSTx = parcelRequire("emSTx");

var $9BrmY = parcelRequire("9BrmY");
var $438a063bafabfa87$var$useFirePortalEvent = function useFirePortalEvent(zIndex) {
    var zIndexNumber = Number(zIndex);
    (0, $dAx5m.useEffect)(function() {
        (0, $9BrmY.default)((0, $emSTx.PORTAL_MOUNT_EVENT), zIndexNumber);
        return function() {
            (0, $9BrmY.default)((0, $emSTx.PORTAL_UNMOUNT_EVENT), zIndexNumber);
        };
    }, [
        zIndexNumber
    ]);
};
var $438a063bafabfa87$export$2e2bcd8739ae039 = $438a063bafabfa87$var$useFirePortalEvent;

});
parcelRegister("emSTx", function(module, exports) {

$parcel$export(module.exports, "PORTAL_MOUNT_EVENT", function () { return $a75db3b6671ffd0e$export$ed5835cc67e87f72; });
$parcel$export(module.exports, "PORTAL_UNMOUNT_EVENT", function () { return $a75db3b6671ffd0e$export$80816bd900e5bd00; });
var $a75db3b6671ffd0e$export$ed5835cc67e87f72 = "akPortalMount";
var $a75db3b6671ffd0e$export$80816bd900e5bd00 = "akPortalUnmount";

});

parcelRegister("9BrmY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6fdcccc1ec812ccf$export$2e2bcd8739ae039; });
var $6fdcccc1ec812ccf$var$zIndexToName = {
    100: "card",
    200: "navigation",
    300: "dialog",
    400: "layer",
    500: "blanket",
    510: "modal",
    600: "flag",
    700: "spotlight",
    9999: "tooltip"
};
/**
 * return layer name in Atlassian design system corresponding to given z-index
 * @param {number} zIndex - z-index value for which layer name is needed
 * @returns {LayerName | null} - The layer name for given z-index. If layer name is not found then null is returned
 */ var $6fdcccc1ec812ccf$var$getLayerName = function getLayerName(zIndex) {
    return $6fdcccc1ec812ccf$var$zIndexToName.hasOwnProperty(zIndex) ? $6fdcccc1ec812ccf$var$zIndexToName[zIndex] : null;
};
/**
 * Creates a PortalEvent object with given eventName, given zIndex and corresponding layer
 * @param {string} eventName - either of Mount or Unmount event name
 * @param {number} zIndex - z-index value which will be included in the event to be dispatched
 * @returns {PortalEvent} - The newly created PortalEvent object
 */ var $6fdcccc1ec812ccf$var$getEvent = function getEvent(eventName, zIndex) {
    var detail = {
        layer: $6fdcccc1ec812ccf$var$getLayerName(Number(zIndex)),
        zIndex: zIndex
    };
    return new CustomEvent(eventName, {
        detail: detail
    });
};
function $6fdcccc1ec812ccf$export$2e2bcd8739ae039(eventName, zIndex) {
    var event = $6fdcccc1ec812ccf$var$getEvent(eventName, zIndex);
    window.dispatchEvent(event);
}

});



parcelRegister("iUykl", function(module, exports) {

$parcel$export(module.exports, "CHANNEL", function () { return $dc48159ce243b9e7$export$44ffba16bd48dac6; });
$parcel$export(module.exports, "DEFAULT_THEME_MODE", function () { return $dc48159ce243b9e7$export$c93026a968943f95; });
$parcel$export(module.exports, "THEME_MODES", function () { return $dc48159ce243b9e7$export$6ba72c8346b4c57e; });
$parcel$export(module.exports, "layers", function () { return $dc48159ce243b9e7$export$7be255094ccdc533; });

var $e2xkU = parcelRequire("e2xkU");

var $d7jha = parcelRequire("d7jha");
var $dc48159ce243b9e7$export$44ffba16bd48dac6 = "__ATLASKIT_THEME__";
var $dc48159ce243b9e7$export$c93026a968943f95 = "light";
var $dc48159ce243b9e7$export$6ba72c8346b4c57e = [
    "light",
    "dark"
];
var $dc48159ce243b9e7$export$7a57f79000377ca2 = function borderRadius() {
    return 3;
};
var $dc48159ce243b9e7$export$6d8204c2cb2e06b8 = function gridSize() {
    return 8;
};
var $dc48159ce243b9e7$export$85e3c3ca0c6fb93 = function fontSize() {
    return 14;
};
var $dc48159ce243b9e7$export$6746fe0d9c9fab54 = function fontSizeSmall() {
    return 11;
};
var $dc48159ce243b9e7$export$a5975749f0374264 = function fontFamily() {
    return "-apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif";
};
var $dc48159ce243b9e7$export$356129969ee49c55 = function codeFontFamily() {
    return "'SFMono-Medium', 'SF Mono', 'Segoe UI Mono', 'Roboto Mono', 'Ubuntu Mono', Menlo, Consolas, Courier, monospace";
};
var $dc48159ce243b9e7$export$8e24544ddba725ee = function focusRing() {
    var color = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "var(--ds-border-focused, ".concat((0, $d7jha.B200), ")");
    var outlineWidth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $dc48159ce243b9e7$export$6d8204c2cb2e06b8() / 4;
    (0, $e2xkU.default)("@atlaskit/theme", "focus ring mixin", "Please use `@atlaskit/focus-ring` instead.");
    return "\n  &:focus {\n    outline: none;\n    box-shadow: 0px 0px 0px ".concat(outlineWidth, "px ").concat(color, ";\n  }\n");
};
var $dc48159ce243b9e7$export$c0dd343266bc3261 = function noFocusRing() {
    return "\n  box-shadow: none;\n";
};
var $dc48159ce243b9e7$export$7be255094ccdc533 = {
    card: function card() {
        return 100;
    },
    navigation: function navigation() {
        return 200;
    },
    dialog: function dialog() {
        return 300;
    },
    layer: function layer() {
        return 400;
    },
    blanket: function blanket() {
        return 500;
    },
    modal: function modal() {
        return 510;
    },
    flag: function flag() {
        return 600;
    },
    spotlight: function spotlight() {
        return 700;
    },
    tooltip: function tooltip() {
        return 9999;
    }
};
var $dc48159ce243b9e7$export$a1b3edb637fb4f35 = function visuallyHidden() {
    (0, $e2xkU.default)("@atlaskit/theme", "visually hidden mixin", "Please use `@atlaskit/visually-hidden` instead.");
    return {
        border: "0 !important",
        clip: "rect(1px, 1px, 1px, 1px) !important",
        height: "1px !important",
        overflow: "hidden !important",
        padding: "0 !important",
        position: "absolute !important",
        width: "1px !important",
        whiteSpace: "nowrap !important"
    };
};
var $dc48159ce243b9e7$export$ba1d834b86d72a09 = $dc48159ce243b9e7$export$a1b3edb637fb4f35;
var $dc48159ce243b9e7$export$e497e856b4f89fcd = function skeletonShimmer() {
    return {
        css: {
            backgroundColor: "var(--ds-skeleton, ".concat((0, $d7jha.skeleton)(), ")"),
            animationDuration: "1.5s",
            animationIterationCount: "infinite",
            animationTimingFunction: "linear",
            animationDirection: "alternate"
        },
        keyframes: {
            from: {
                backgroundColor: "var(--ds-skeleton, ".concat((0, $d7jha.skeleton)(), ")")
            },
            to: {
                backgroundColor: "var(--ds-skeleton-subtle, ".concat((0, $d7jha.N30A), ")")
            }
        }
    };
};

});
parcelRegister("d7jha", function(module, exports) {

$parcel$export(module.exports, "B200", function () { return $98cae194668288ef$export$215b7063051591f1; });
$parcel$export(module.exports, "N0", function () { return $98cae194668288ef$export$29a4f05edc054374; });
$parcel$export(module.exports, "N800", function () { return $98cae194668288ef$export$7d61b15e0da132af; });
$parcel$export(module.exports, "N30A", function () { return $98cae194668288ef$export$920c0d5c49070351; });
$parcel$export(module.exports, "skeleton", function () { return $98cae194668288ef$export$2a0674ff2eb10214; });
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ 
var $f3r45 = parcelRequire("f3r45");
var $98cae194668288ef$export$4b84fd0e2c617bd = "#FFEBE6";
var $98cae194668288ef$export$b34b069eff244586 = "#FFBDAD";
var $98cae194668288ef$export$be802dd0d8b57f35 = "#FF8F73";
var $98cae194668288ef$export$60847d42f9da92a6 = "#FF7452";
var $98cae194668288ef$export$4a7404f376229999 = "#FF5630";
var $98cae194668288ef$export$2010d0fb4295b346 = "#DE350B";
var $98cae194668288ef$export$2837b5a1a71d5c02 = "#BF2600";
var $98cae194668288ef$export$8d9596b529bbb9cf = "#FFFAE6";
var $98cae194668288ef$export$41060a744ab0b7ae = "#FFF0B3";
var $98cae194668288ef$export$1cc05bbbf340e559 = "#FFE380";
var $98cae194668288ef$export$5aae31392d72caaa = "#FFC400";
var $98cae194668288ef$export$c6930421db9fa514 = "#FFAB00";
var $98cae194668288ef$export$59619663aa6500fb = "#FF991F";
var $98cae194668288ef$export$874739ea9e379ab6 = "#FF8B00";
var $98cae194668288ef$export$8a6341c32b6a3ee6 = "#E3FCEF";
var $98cae194668288ef$export$69a3bf21b9686c2b = "#ABF5D1";
var $98cae194668288ef$export$afbce1382ec95f73 = "#79F2C0";
var $98cae194668288ef$export$747d86715d4175de = "#57D9A3";
var $98cae194668288ef$export$940e1f69e873f202 = "#36B37E";
var $98cae194668288ef$export$a49394138f7b8e85 = "#00875A";
var $98cae194668288ef$export$6fa04827ac68a4fb = "#006644";
var $98cae194668288ef$export$226de0355ed012f8 = "#DEEBFF";
var $98cae194668288ef$export$8c13c2ee36917869 = "#B3D4FF";
var $98cae194668288ef$export$ecfc1dff386a3e7a = "#4C9AFF";
var $98cae194668288ef$export$215b7063051591f1 = "#2684FF";
var $98cae194668288ef$export$e62e8919cca44969 = "#0065FF";
var $98cae194668288ef$export$b3de0ae08da2ce64 = "#0052CC";
var $98cae194668288ef$export$a6ee3d71bc067634 = "#0747A6";
var $98cae194668288ef$export$363e4475840015bb = "#EAE6FF";
var $98cae194668288ef$export$4b0a4417ed59760f = "#C0B6F2";
var $98cae194668288ef$export$6011520a64d9a187 = "#998DD9";
var $98cae194668288ef$export$a7175d4e9206bc80 = "#8777D9";
var $98cae194668288ef$export$b48405b95304b5a1 = "#6554C0";
var $98cae194668288ef$export$c71e4279dd54a18d = "#5243AA";
var $98cae194668288ef$export$147899de772240ec = "#403294";
var $98cae194668288ef$export$2cf711fe14c66f06 = "#E6FCFF";
var $98cae194668288ef$export$7a8f4d33f6f9772c = "#B3F5FF";
var $98cae194668288ef$export$776c9c497ef08533 = "#79E2F2";
var $98cae194668288ef$export$69cb3ca10c1e330e = "#00C7E6";
var $98cae194668288ef$export$9dc1ef0f3f48059b = "#00B8D9";
var $98cae194668288ef$export$7c835c78b6fcdef8 = "#00A3BF";
var $98cae194668288ef$export$6036577f95c3877e = "#008DA6";
var $98cae194668288ef$export$29a4f05edc054374 = "#FFFFFF";
var $98cae194668288ef$export$e655ef011c4aa1a2 = "#FAFBFC";
var $98cae194668288ef$export$9fdfb749e33cdf97 = "#F4F5F7";
var $98cae194668288ef$export$3e51e8f1440314ba = "#EBECF0";
var $98cae194668288ef$export$1ce2d1575d444ceb = "#DFE1E6";
var $98cae194668288ef$export$8754fc7e6d8b3000 = "#C1C7D0";
var $98cae194668288ef$export$c2e91cbeada39b8b = "#B3BAC5";
var $98cae194668288ef$export$5f71e19f3a7ad9de = "#A5ADBA";
var $98cae194668288ef$export$eaa8c8a70ac22806 = "#97A0AF";
var $98cae194668288ef$export$7c87d337fb91a97d = "#8993A4";
var $98cae194668288ef$export$d6447c357493214f = "#7A869A";
var $98cae194668288ef$export$f563ee71e9ee74cd = "#6B778C";
var $98cae194668288ef$export$e2ef2124cf4024b1 = "#5E6C84";
var $98cae194668288ef$export$eece5f492e429f08 = "#505F79";
var $98cae194668288ef$export$c39c0fe0f26207ae = "#42526E";
var $98cae194668288ef$export$7090862dc3038a9f = "#344563";
var $98cae194668288ef$export$ad0bacf983b7ddaa = "#253858";
var $98cae194668288ef$export$7d61b15e0da132af = "#172B4D";
var $98cae194668288ef$export$fbda843f0a27fe96 = "#091E42";
var $98cae194668288ef$export$791e57b27ca738ef = "rgba(9, 30, 66, 0.02)";
var $98cae194668288ef$export$8d43898f60b96a82 = "rgba(9, 30, 66, 0.04)";
var $98cae194668288ef$export$920c0d5c49070351 = "rgba(9, 30, 66, 0.08)";
var $98cae194668288ef$export$46987b49aab6d1a8 = "rgba(9, 30, 66, 0.13)";
var $98cae194668288ef$export$7d3359664e8bb0e5 = "rgba(9, 30, 66, 0.25)";
var $98cae194668288ef$export$d2d3bedfb276cac0 = "rgba(9, 30, 66, 0.31)";
var $98cae194668288ef$export$6e5e7499ff054f6d = "rgba(9, 30, 66, 0.36)";
var $98cae194668288ef$export$59264b346c877fa7 = "rgba(9, 30, 66, 0.42)";
var $98cae194668288ef$export$d092757d7c64925c = "rgba(9, 30, 66, 0.48)";
var $98cae194668288ef$export$486ab785e4bac3c6 = "rgba(9, 30, 66, 0.54)";
var $98cae194668288ef$export$fba592bbc6419fea = "rgba(9, 30, 66, 0.60)";
var $98cae194668288ef$export$13609db0e6812ab8 = "rgba(9, 30, 66, 0.66)";
var $98cae194668288ef$export$fbae4efaa892d883 = "rgba(9, 30, 66, 0.71)";
var $98cae194668288ef$export$f13946d26f440ce6 = "rgba(9, 30, 66, 0.77)";
var $98cae194668288ef$export$19f58225ac52a306 = "rgba(9, 30, 66, 0.82)";
var $98cae194668288ef$export$6384f09da70e7b62 = "rgba(9, 30, 66, 0.89)";
var $98cae194668288ef$export$d0dccc730683edc2 = "rgba(9, 30, 66, 0.95)";
var $98cae194668288ef$export$2f6319cf7d736c2a = "#E6EDFA";
var $98cae194668288ef$export$95126bc8884d6634 = "#DCE5F5";
var $98cae194668288ef$export$8338d8c35d44ff1 = "#CED9EB";
var $98cae194668288ef$export$5368d76ae4fbbda7 = "#B8C7E0";
var $98cae194668288ef$export$9f0a771d16ec8d36 = "#ABBBD6";
var $98cae194668288ef$export$abcf8c38338b4aa5 = "#9FB0CC";
var $98cae194668288ef$export$97e81faa16a182c7 = "#8C9CB8";
var $98cae194668288ef$export$bfe21c59123ecf33 = "#7988A3";
var $98cae194668288ef$export$ee82aa2ea6a1558 = "#67758F";
var $98cae194668288ef$export$682927c6ed76be02 = "#56637A";
var $98cae194668288ef$export$91fd9994c5be9757 = "#455166";
var $98cae194668288ef$export$d281fbfe3cff2df6 = "#3B475C";
var $98cae194668288ef$export$3902c91d8b98a753 = "#313D52";
var $98cae194668288ef$export$8e8133c1ba5845b5 = "#283447";
var $98cae194668288ef$export$33ff357f6620b39 = "#202B3D";
var $98cae194668288ef$export$633847cf062b69e0 = "#1B2638";
var $98cae194668288ef$export$9776a6e503bdbf76 = "#121A29";
var $98cae194668288ef$export$6c813d5160dff5db = "#0E1624";
var $98cae194668288ef$export$3d4f271a500072a = "#0D1424";
var $98cae194668288ef$export$fe151285c22759ec = "rgba(13, 20, 36, 0.06)";
var $98cae194668288ef$export$a101c6190d0da34 = "rgba(13, 20, 36, 0.14)";
var $98cae194668288ef$export$4b16f52932fda51 = "rgba(13, 20, 36, 0.18)";
var $98cae194668288ef$export$a74bcd7b9845b0d8 = "rgba(13, 20, 36, 0.29)";
var $98cae194668288ef$export$9209c179316d1751 = "rgba(13, 20, 36, 0.36)";
var $98cae194668288ef$export$88f55133f636c8dd = "rgba(13, 20, 36, 0.40)";
var $98cae194668288ef$export$51126f85d1009512 = "rgba(13, 20, 36, 0.47)";
var $98cae194668288ef$export$a069b547bd23af78 = "rgba(13, 20, 36, 0.53)";
var $98cae194668288ef$export$40cce05af3b2600a = "rgba(13, 20, 36, 0.63)";
var $98cae194668288ef$export$b78942185925a0d = "rgba(13, 20, 36, 0.73)";
var $98cae194668288ef$export$e058fb44b8eaafca = "rgba(13, 20, 36, 0.78)";
var $98cae194668288ef$export$92b0b8de26920c18 = "rgba(13, 20, 36, 0.81)";
var $98cae194668288ef$export$67564f7459d3fc9e = "rgba(13, 20, 36, 0.85)";
var $98cae194668288ef$export$77868e1ca884ffa3 = "rgba(13, 20, 36, 0.89)";
var $98cae194668288ef$export$2afd71d7d3ea2cd5 = "rgba(13, 20, 36, 0.92)";
var $98cae194668288ef$export$f2a0acaab9972c70 = "rgba(13, 20, 36, 0.95)";
var $98cae194668288ef$export$9ab70e67d6475361 = "rgba(13, 20, 36, 0.97)";
var $98cae194668288ef$export$8ce1fd94bee2f412 = (0, $f3r45.default)({
    light: "var(--ds-surface, ".concat($98cae194668288ef$export$29a4f05edc054374, ")"),
    dark: "var(--ds-surface, ".concat($98cae194668288ef$export$633847cf062b69e0, ")")
});
var $98cae194668288ef$export$b861914ea877b580 = (0, $f3r45.default)({
    light: "var(--ds-background-selected, ".concat($98cae194668288ef$export$226de0355ed012f8, ")"),
    dark: "var(--ds-background-selected, ".concat($98cae194668288ef$export$8c13c2ee36917869, ")")
});
var $98cae194668288ef$export$3f1b020df94387af = (0, $f3r45.default)({
    light: "var(--ds-background-neutral-hovered, ".concat($98cae194668288ef$export$3e51e8f1440314ba, ")"),
    dark: "var(--ds-background-neutral-hovered, ".concat($98cae194668288ef$export$d281fbfe3cff2df6, ")")
});
var $98cae194668288ef$export$c0183dbab98ca63e = (0, $f3r45.default)({
    light: "var(--ds-surface-overlay, ".concat($98cae194668288ef$export$29a4f05edc054374, ")"),
    dark: "var(--ds-surface-overlay, ".concat($98cae194668288ef$export$8e8133c1ba5845b5, ")")
});
var $98cae194668288ef$export$6f093cfa640b7166 = (0, $f3r45.default)({
    light: "var(--ds-text, ".concat($98cae194668288ef$export$fbda843f0a27fe96, ")"),
    dark: "var(--ds-text, ".concat($98cae194668288ef$export$5368d76ae4fbbda7, ")")
});
var $98cae194668288ef$export$42f8e9c698766e7a = (0, $f3r45.default)({
    light: "var(--ds-text, ".concat($98cae194668288ef$export$7d61b15e0da132af, ")"),
    dark: "var(--ds-text, ".concat($98cae194668288ef$export$5368d76ae4fbbda7, ")")
});
var $98cae194668288ef$export$c2d157ca1c34b6e3 = (0, $f3r45.default)({
    light: "var(--ds-text-selected, ".concat($98cae194668288ef$export$b3de0ae08da2ce64, ")"),
    dark: "var(--ds-text-selected, ".concat($98cae194668288ef$export$b3de0ae08da2ce64, ")")
});
var $98cae194668288ef$export$1905ba28d7cf066f = (0, $f3r45.default)({
    light: "var(--ds-text-subtlest, ".concat($98cae194668288ef$export$f563ee71e9ee74cd, ")"),
    dark: "var(--ds-text-subtlest, ".concat($98cae194668288ef$export$97e81faa16a182c7, ")")
});
var $98cae194668288ef$export$bd9002130d306d39 = (0, $f3r45.default)({
    light: "var(--ds-text-subtlest, ".concat($98cae194668288ef$export$f563ee71e9ee74cd, ")"),
    dark: "var(--ds-text-subtlest, ".concat($98cae194668288ef$export$bfe21c59123ecf33, ")")
});
var $98cae194668288ef$export$46e4a324ac90507f = (0, $f3r45.default)({
    light: "var(--ds-text, ".concat($98cae194668288ef$export$7d61b15e0da132af, ")"),
    dark: "var(--ds-text, ".concat($98cae194668288ef$export$5368d76ae4fbbda7, ")")
});
var $98cae194668288ef$export$79f3f2b82beb0d36 = (0, $f3r45.default)({
    light: "var(--ds-text-subtlest, ".concat($98cae194668288ef$export$f563ee71e9ee74cd, ")"),
    dark: "var(--ds-text-subtlest, ".concat($98cae194668288ef$export$97e81faa16a182c7, ")")
});
var $98cae194668288ef$export$7bb0d5c671655cc4 = (0, $f3r45.default)({
    light: $98cae194668288ef$export$9fdfb749e33cdf97,
    dark: $98cae194668288ef$export$8e8133c1ba5845b5
});
var $98cae194668288ef$export$9c30223ca0a664fb = (0, $f3r45.default)({
    light: "var(--ds-link, ".concat($98cae194668288ef$export$b3de0ae08da2ce64, ")"),
    dark: "var(--ds-link, ".concat($98cae194668288ef$export$ecfc1dff386a3e7a, ")")
});
var $98cae194668288ef$export$7ed258b0728b004b = (0, $f3r45.default)({
    light: "var(--ds-link-pressed, ".concat($98cae194668288ef$export$e62e8919cca44969, ")"),
    dark: "var(--ds-link-pressed, ".concat($98cae194668288ef$export$215b7063051591f1, ")")
});
var $98cae194668288ef$export$dfa920d8decc8a59 = (0, $f3r45.default)({
    light: "var(--ds-link-pressed, ".concat($98cae194668288ef$export$a6ee3d71bc067634, ")"),
    dark: "var(--ds-link-pressed, ".concat($98cae194668288ef$export$ecfc1dff386a3e7a, ")")
});
var $98cae194668288ef$export$6069e6ad5c78f632 = (0, $f3r45.default)({
    light: "var(--ds-border-focused, ".concat($98cae194668288ef$export$215b7063051591f1, ")"),
    dark: "var(--ds-border-focused, ".concat($98cae194668288ef$export$215b7063051591f1, ")")
});
var $98cae194668288ef$export$9ad721cf3b3debe0 = (0, $f3r45.default)({
    light: "var(--ds-background-brand-bold, ".concat($98cae194668288ef$export$b3de0ae08da2ce64, ")"),
    dark: "var(--ds-background-brand-bold, ".concat($98cae194668288ef$export$ecfc1dff386a3e7a, ")")
});
var $98cae194668288ef$export$2aa0182783e7e9de = (0, $f3r45.default)({
    light: $98cae194668288ef$export$b3de0ae08da2ce64,
    dark: $98cae194668288ef$export$ecfc1dff386a3e7a
});
var $98cae194668288ef$export$8bf7dff220b82b4a = (0, $f3r45.default)({
    light: $98cae194668288ef$export$9dc1ef0f3f48059b,
    dark: $98cae194668288ef$export$69cb3ca10c1e330e
});
var $98cae194668288ef$export$e13cce2a2d16a9d4 = (0, $f3r45.default)({
    light: $98cae194668288ef$export$b48405b95304b5a1,
    dark: $98cae194668288ef$export$6011520a64d9a187
});
var $98cae194668288ef$export$a90204d1394caf30 = (0, $f3r45.default)({
    light: $98cae194668288ef$export$4a7404f376229999,
    dark: $98cae194668288ef$export$4a7404f376229999
});
var $98cae194668288ef$export$594c5a8758200c32 = (0, $f3r45.default)({
    light: $98cae194668288ef$export$c6930421db9fa514,
    dark: $98cae194668288ef$export$c6930421db9fa514
});
var $98cae194668288ef$export$955a2ebd2fb142ae = (0, $f3r45.default)({
    light: $98cae194668288ef$export$940e1f69e873f202,
    dark: $98cae194668288ef$export$940e1f69e873f202
});
var $98cae194668288ef$export$2a0674ff2eb10214 = function skeleton() {
    return "var(--ds-skeleton, ".concat($98cae194668288ef$export$8d43898f60b96a82, ")");
};

});
parcelRegister("f3r45", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $af5c216089bbcb8d$export$2e2bcd8739ae039; });
/* eslint-disable prefer-rest-params */ 
var $9gB1Y = parcelRequire("9gB1Y");
// Unpack custom variants, and get correct value for the current theme
function $af5c216089bbcb8d$var$themedVariants(variantProp, variants) {
    return function(props) {
        var theme = (0, $9gB1Y.default)(props);
        if (props && props[variantProp] && variants) {
            var modes = variants[props[variantProp]];
            if (modes && modes[theme.mode]) {
                var value = modes[theme.mode];
                if (value) return value;
                 // TS believes value can be undefined
            }
        }
        return "";
    };
}
function $af5c216089bbcb8d$export$2e2bcd8739ae039(modesOrVariant, variantModes) {
    if (typeof modesOrVariant === "string") return $af5c216089bbcb8d$var$themedVariants(modesOrVariant, variantModes);
    var modes = modesOrVariant;
    return function(props) {
        // Get theme from the user's props
        var theme = (0, $9gB1Y.default)(props);
        // User isn't required to provide both light and dark values
        if (theme.mode in modes) {
            var value = modes[theme.mode]; // TS believes value can be undefined
            if (value) return value;
        }
        return "";
    };
}

});
parcelRegister("9gB1Y", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6bf2553b80b9a4ff$export$2e2bcd8739ae039; });

var $iUykl = parcelRequire("iUykl");
function $6bf2553b80b9a4ff$export$2e2bcd8739ae039(props) {
    if (props && props.theme) {
        // Theme is the global Atlaskit theme
        if ((0, $iUykl.CHANNEL) in props.theme) return props.theme[0, $iUykl.CHANNEL];
        else if ("mode" in props.theme && (0, $iUykl.THEME_MODES).includes(props.theme.mode)) return props.theme;
    }
    // If format not supported (or no theme provided), return standard theme
    return {
        mode: (0, $iUykl.DEFAULT_THEME_MODE)
    };
}

});




parcelRegister("1GoHh", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $139cdf02776a1173$export$6503ec6e8aabbaf; });
/* eslint-disable @atlaskit/design-system/no-direct-use-of-web-platform-drag-and-drop */ /**
 * We are listening directly to drag events instead of using a monitor from
 * `@atlaskit/pragmatic-drag-and-drop` to avoid the bundle size cost, as it
 * would affect almost every view in every product.
 *
 * We can reconsider this choice in the future.
 */ 
var $bXeVH = parcelRequire("bXeVH");
var $139cdf02776a1173$var$registrations = new Set();
var $139cdf02776a1173$var$cleanupEndEventListeners = null;
function $139cdf02776a1173$var$onDragStart() {
    if ($139cdf02776a1173$var$cleanupEndEventListeners) // If the cleanup function exists then we've already run this
    return;
    $139cdf02776a1173$var$cleanupEndEventListeners = (0, $bXeVH.bindAll)(window, [
        {
            type: "dragend",
            listener: $139cdf02776a1173$var$onDragEnd
        },
        {
            type: "pointerdown",
            listener: $139cdf02776a1173$var$onDragEnd
        },
        {
            type: "pointermove",
            listener: function() {
                var callCount = 0;
                return function listener() {
                    // Using 20 as it is far bigger than the most observed (3)
                    if (callCount < 20) {
                        callCount++;
                        return;
                    }
                    $139cdf02776a1173$var$onDragEnd();
                };
            }()
        }
    ]);
    var clone = Array.from($139cdf02776a1173$var$registrations);
    clone.forEach(function(subscriber) {
        subscriber.onDragStart();
    });
}
function $139cdf02776a1173$var$onDragEnd() {
    var _cleanupEndEventListe;
    (_cleanupEndEventListe = $139cdf02776a1173$var$cleanupEndEventListeners) === null || _cleanupEndEventListe === void 0 || _cleanupEndEventListe();
    $139cdf02776a1173$var$cleanupEndEventListeners = null;
    var clone = Array.from($139cdf02776a1173$var$registrations);
    clone.forEach(function(subscriber) {
        subscriber.onDragEnd();
    });
}
function $139cdf02776a1173$var$bindStartEvents() {
    return (0, $bXeVH.bindAll)(window, [
        {
            type: "dragstart",
            listener: $139cdf02776a1173$var$onDragStart
        },
        {
            type: "dragenter",
            listener: $139cdf02776a1173$var$onDragStart
        }
    ]);
}
var $139cdf02776a1173$var$cleanupStartEventListeners = null;
function $139cdf02776a1173$export$6503ec6e8aabbaf(registration) {
    // if first registration, bind event listeners
    if (!$139cdf02776a1173$var$cleanupStartEventListeners) // note: currently never unbinding these event listeners
    $139cdf02776a1173$var$cleanupStartEventListeners = $139cdf02776a1173$var$bindStartEvents();
    $139cdf02776a1173$var$registrations.add(registration);
    /**
   * The reasoning for this behavior is so that if a tooltip mounts during
   * a drag it can still be suppressed.
   *
   * We use a separate callback instead of onDragStart to avoid infinite loops.
   */ registration.onRegister({
        isDragging: $139cdf02776a1173$var$cleanupEndEventListeners !== null
    });
    return function unregister() {
        $139cdf02776a1173$var$registrations.delete(registration);
        if ($139cdf02776a1173$var$registrations.size === 0) {
            var _cleanupStartEventLis;
            (_cleanupStartEventLis = $139cdf02776a1173$var$cleanupStartEventListeners) === null || _cleanupStartEventLis === void 0 || _cleanupStartEventLis();
            $139cdf02776a1173$var$cleanupStartEventListeners = null;
        }
    };
}

});

parcelRegister("iyyrs", function(module, exports) {

$parcel$export(module.exports, "show", function () { return $d8261e6ae7972e03$export$57bf213be019eeb0; });

var $l04XY = parcelRequire("l04XY");
// This file is a singleton for managing tooltips
var $d8261e6ae7972e03$var$active = null;
function $d8261e6ae7972e03$export$57bf213be019eeb0(entry) {
    var phase = "waiting-to-show";
    function isActive() {
        return Boolean($d8261e6ae7972e03$var$active && $d8261e6ae7972e03$var$active.entry === entry);
    }
    function cleanup() {
        if (isActive()) {
            (0, $l04XY.clearScheduled)();
            $d8261e6ae7972e03$var$active = null;
        }
    }
    function done() {
        if (isActive()) entry.done();
        phase = "done";
        cleanup();
    }
    function immediatelyHideAndDone() {
        if (isActive()) entry.hide({
            isImmediate: true
        });
        done();
    }
    function keep() {
        if (!isActive()) return;
        // aborting a wait to hide
        if (phase === "waiting-to-hide") {
            phase = "shown";
            (0, $l04XY.clearScheduled)();
            return;
        }
        // aborting hide animation
        if (phase === "hide-animating") {
            phase = "shown";
            (0, $l04XY.clearScheduled)();
            entry.show({
                isImmediate: false
            });
            return;
        }
    }
    function requestHide(_ref) {
        var isImmediate = _ref.isImmediate;
        if (!isActive()) return;
        // If we were not showing yet anyway; finish straight away
        if (phase === "waiting-to-show") {
            immediatelyHideAndDone();
            return;
        }
        // already waiting to hide
        if (phase === "waiting-to-hide") return;
        if (isImmediate) {
            immediatelyHideAndDone();
            return;
        }
        phase = "waiting-to-hide";
        (0, $l04XY.scheduleTimeout)(function() {
            phase = "hide-animating";
            entry.hide({
                isImmediate: false
            });
        }, entry.delay);
    }
    function finishHideAnimation() {
        if (isActive() && phase === "hide-animating") done();
    }
    function isVisible() {
        return phase === "shown" || phase === "waiting-to-hide" || phase === "hide-animating";
    }
    function getInitialMouse() {
        if (entry.source.type === "mouse") return entry.source.mouse;
        return null;
    }
    function start() {
        var showImmediately = Boolean($d8261e6ae7972e03$var$active && $d8261e6ae7972e03$var$active.isVisible());
        // If there was an active tooltip; we tell it to remove itself at once!
        if ($d8261e6ae7972e03$var$active) {
            (0, $l04XY.clearScheduled)();
            $d8261e6ae7972e03$var$active.entry.hide({
                isImmediate: true
            });
            $d8261e6ae7972e03$var$active.entry.done();
            $d8261e6ae7972e03$var$active = null;
        }
        // this tooltip is now the active tooltip
        $d8261e6ae7972e03$var$active = {
            entry: entry,
            isVisible: isVisible
        };
        function show() {
            phase = "shown";
            entry.show({
                isImmediate: showImmediately
            });
        }
        if (showImmediately) {
            show();
            return;
        }
        phase = "waiting-to-show";
        (0, $l04XY.scheduleTimeout)(show, entry.delay);
    }
    // let's get started!
    start();
    var result = {
        keep: keep,
        abort: cleanup,
        isActive: isActive,
        requestHide: requestHide,
        finishHideAnimation: finishHideAnimation,
        mousePosition: getInitialMouse()
    };
    return result;
}

});
parcelRegister("l04XY", function(module, exports) {

$parcel$export(module.exports, "clearScheduled", function () { return $f49d733f8812d1b6$export$eaf678f6f93f5250; });
$parcel$export(module.exports, "scheduleTimeout", function () { return $f49d733f8812d1b6$export$5f4d6617421d489b; });
var $f49d733f8812d1b6$var$delayId = null;
function $f49d733f8812d1b6$export$eaf678f6f93f5250() {
    if ($f49d733f8812d1b6$var$delayId != null) {
        window.clearTimeout($f49d733f8812d1b6$var$delayId);
        $f49d733f8812d1b6$var$delayId = null;
    }
}
function $f49d733f8812d1b6$export$5f4d6617421d489b(fn, delay) {
    $f49d733f8812d1b6$export$eaf678f6f93f5250();
    $f49d733f8812d1b6$var$delayId = window.setTimeout(function() {
        $f49d733f8812d1b6$var$delayId = null;
        fn();
    }, delay);
}

});


parcelRegister("lvFV9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fa8d02cd0f34d287$export$2e2bcd8739ae039; });

var $D9YLo = parcelRequire("D9YLo");
function $fa8d02cd0f34d287$export$2e2bcd8739ae039(prefix, shouldRenderId) {
    var seed = (0, $D9YLo.useUIDSeed)();
    return shouldRenderId ? "".concat(seed(prefix)) : undefined;
}

});

parcelRegister("jO0LC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e6b34823219a773c$export$2e2bcd8739ae039; });
/** @jsx jsx */ 
var $dAx5m = parcelRequire("dAx5m");

var $jVTBW = parcelRequire("jVTBW");

var $d7jha = parcelRequire("d7jha");

var $2AX7m = parcelRequire("2AX7m");
var $e6b34823219a773c$var$baseStyles = (0, $jVTBW.css)({
    boxSizing: "border-box",
    maxWidth: "240px",
    padding: "var(--ds-space-025, 2px)".concat(" ", "var(--ds-space-075, 6px)"),
    insetBlockStart: "var(--ds-space-0, 0px)",
    insetInlineStart: "var(--ds-space-0, 0px)",
    borderRadius: "var(--ds-border-radius, 3px)",
    font: 'var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    overflowWrap: "break-word",
    wordWrap: "break-word",
    backgroundColor: "var(--ds-background-neutral-bold, ".concat((0, $d7jha.N800), ")"),
    color: "var(--ds-text-inverse, ".concat((0, $d7jha.N0), ")")
});
var $e6b34823219a773c$var$truncateStyles = (0, $jVTBW.css)({
    maxWidth: "420px",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap"
});
var $e6b34823219a773c$var$TooltipContainer = /*#__PURE__*/ (0, $dAx5m.forwardRef)(function TooltipContainer(_ref, ref) {
    var style = _ref.style, className = _ref.className, children = _ref.children, truncate = _ref.truncate, placement = _ref.placement, testId = _ref.testId, onMouseOut = _ref.onMouseOut, onMouseOver = _ref.onMouseOver, id = _ref.id;
    return (0, $jVTBW.jsx)((0, $2AX7m.default), {
        ref: ref,
        style: style,
        className: className,
        placement: placement,
        testId: testId,
        id: id,
        onMouseOut: onMouseOut,
        onMouseOver: onMouseOver,
        css: [
            $e6b34823219a773c$var$baseStyles,
            truncate ? $e6b34823219a773c$var$truncateStyles : null
        ]
    }, children);
});
$e6b34823219a773c$var$TooltipContainer.displayName = "TooltipContainer";
var $e6b34823219a773c$export$2e2bcd8739ae039 = $e6b34823219a773c$var$TooltipContainer;

});
parcelRegister("2AX7m", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1e3ccd1acc107e12$export$2e2bcd8739ae039; });

var $6t1ly = parcelRequire("6t1ly");

var $dAx5m = parcelRequire("dAx5m");

var $jVTBW = parcelRequire("jVTBW");

var $iUykl = parcelRequire("iUykl");
function $1e3ccd1acc107e12$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $1e3ccd1acc107e12$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $1e3ccd1acc107e12$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($6t1ly)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $1e3ccd1acc107e12$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $1e3ccd1acc107e12$var$VAR_PRIMITIVE_ZINDEX = "tooltipPrimitiveZindex";
var $1e3ccd1acc107e12$var$primitiveStyles = (0, $jVTBW.css)({
    zindex: "var(".concat($1e3ccd1acc107e12$var$VAR_PRIMITIVE_ZINDEX, ")"),
    cursor: "default"
});
var $1e3ccd1acc107e12$var$TooltipPrimitive = /*#__PURE__*/ (0, $dAx5m.forwardRef)(function TooltipPrimitive(_ref, ref) {
    var style = _ref.style, className = _ref.className, children = _ref.children, placement = _ref.placement, testId = _ref.testId, onMouseOut = _ref.onMouseOut, onMouseOver = _ref.onMouseOver, id = _ref.id;
    var styleWithZIndex = $1e3ccd1acc107e12$var$_objectSpread($1e3ccd1acc107e12$var$_objectSpread({}, style), {}, (0, (/*@__PURE__*/$parcel$interopDefault($6t1ly)))({}, $1e3ccd1acc107e12$var$VAR_PRIMITIVE_ZINDEX, (0, $iUykl.layers).tooltip()));
    return (0, $jVTBW.jsx)("div", {
        ref: ref,
        style: styleWithZIndex,
        "data-testid": testId ? "".concat(testId, "--wrapper") : undefined
    }, (0, $jVTBW.jsx)("div", {
        role: "tooltip",
        className: className,
        onMouseOut: onMouseOut,
        onMouseOver: onMouseOver,
        css: $1e3ccd1acc107e12$var$primitiveStyles,
        "data-placement": placement,
        "data-testid": testId,
        id: id
    }, children));
});
$1e3ccd1acc107e12$var$TooltipPrimitive.displayName = "TooltipPrimitive";
var $1e3ccd1acc107e12$export$2e2bcd8739ae039 = $1e3ccd1acc107e12$var$TooltipPrimitive;

});


parcelRegister("eKJc1", function(module, exports) {

$parcel$export(module.exports, "getMousePosition", function () { return $abd86aee83595938$export$642213d516a9b928; });
function $abd86aee83595938$export$642213d516a9b928(mouseCoordinates) {
    var safeMouse = mouseCoordinates || {
        top: 0,
        left: 0
    };
    var getBoundingClientRect = function getBoundingClientRect() {
        return {
            top: safeMouse.top,
            left: safeMouse.left,
            bottom: safeMouse.top,
            right: safeMouse.left,
            width: 0,
            height: 0
        };
    };
    return {
        getBoundingClientRect: getBoundingClientRect,
        clientWidth: 0,
        clientHeight: 0
    };
}

});


parcelRegister("bXKOB", function(module, exports) {

$parcel$export(module.exports, "TextEditView", function () { return (parcelRequire("7YADa")).default; });
parcelRequire("jDzz8");
var $7YADa = parcelRequire("7YADa");

});
parcelRegister("jDzz8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return (parcelRequire("7YADa")).default; });

var $7YADa = parcelRequire("7YADa");

});
parcelRegister("7YADa", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b6af9dcdde6745ff$export$2e2bcd8739ae039; });

var $bibO8 = parcelRequire("bibO8");
parcelRequire("dAx5m");

var $3wbWe = parcelRequire("3wbWe");

var $c3Ngf = parcelRequire("c3Ngf");
const $b6af9dcdde6745ff$var$TextEditView = (fieldProps)=>/*#__PURE__*/ (0, $bibO8.jsx)($c3Ngf.Wrapper, {
        isEmpty: !fieldProps.value,
        children: /*#__PURE__*/ (0, $bibO8.jsx)((0, $3wbWe.default), {
            autoFocus: true,
            ...fieldProps
        })
    });
var $b6af9dcdde6745ff$export$2e2bcd8739ae039 = $b6af9dcdde6745ff$var$TextEditView;

});
parcelRegister("3wbWe", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $28fd9ef2bf4087fc$export$2e2bcd8739ae039; });

var $c2KpP = parcelRequire("c2KpP");

var $gFTAr = parcelRequire("gFTAr");

var $jTmBQ = parcelRequire("jTmBQ");

var $ag9Mq = parcelRequire("ag9Mq");

var $dAx5m = parcelRequire("dAx5m");

var $jVTBW = parcelRequire("jVTBW");

var $3CSEr = parcelRequire("3CSEr");

var $58ITB = parcelRequire("58ITB");
var $28fd9ef2bf4087fc$var$_excluded = [
    "appearance",
    "className",
    "elemAfterInput",
    "elemBeforeInput",
    "isCompact",
    "isDisabled",
    "isInvalid",
    "isMonospaced",
    "isReadOnly",
    "isRequired",
    "name",
    "onBlur",
    "onChange",
    "onFocus",
    "onMouseDown",
    "placeholder",
    "testId",
    "width"
];
function $28fd9ef2bf4087fc$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $28fd9ef2bf4087fc$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $28fd9ef2bf4087fc$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($jTmBQ)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $28fd9ef2bf4087fc$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $28fd9ef2bf4087fc$var$analyticsParams = {
    componentName: "textField",
    packageName: "@atlaskit/textfield",
    packageVersion: "6.1.3"
};
var $28fd9ef2bf4087fc$var$TextfieldComponent = /*#__PURE__*/ (0, $dAx5m.forwardRef)(function(props, ref) {
    var _props$appearance = props.appearance, appearance = _props$appearance === void 0 ? "standard" : _props$appearance, className = props.className, elemAfterInput = props.elemAfterInput, elemBeforeInput = props.elemBeforeInput, _props$isCompact = props.isCompact, isCompact = _props$isCompact === void 0 ? false : _props$isCompact, _props$isDisabled = props.isDisabled, isDisabled = _props$isDisabled === void 0 ? false : _props$isDisabled, _props$isInvalid = props.isInvalid, isInvalid = _props$isInvalid === void 0 ? false : _props$isInvalid, _props$isMonospaced = props.isMonospaced, isMonospaced = _props$isMonospaced === void 0 ? false : _props$isMonospaced, _props$isReadOnly = props.isReadOnly, isReadOnly = _props$isReadOnly === void 0 ? false : _props$isReadOnly, _props$isRequired = props.isRequired, isRequired = _props$isRequired === void 0 ? false : _props$isRequired, name = props.name, onBlur = props.onBlur, onChange = props.onChange, onFocus = props.onFocus, onMouseDown = props.onMouseDown, placeholder = props.placeholder, testId = props.testId, width = props.width, spreadProps = (0, (/*@__PURE__*/$parcel$interopDefault($ag9Mq)))(props, $28fd9ef2bf4087fc$var$_excluded);
    var inputRef = (0, $dAx5m.useRef)(null);
    var handleOnFocus = (0, $3CSEr.usePlatformLeafEventHandler)($28fd9ef2bf4087fc$var$_objectSpread({
        fn: function fn(event) {
            onFocus && onFocus(event);
        },
        action: "focused"
    }, $28fd9ef2bf4087fc$var$analyticsParams));
    var handleOnBlur = (0, $3CSEr.usePlatformLeafEventHandler)($28fd9ef2bf4087fc$var$_objectSpread({
        fn: function fn(event) {
            onBlur && onBlur(event);
        },
        action: "blurred"
    }, $28fd9ef2bf4087fc$var$analyticsParams));
    var handleOnMouseDown = (0, $dAx5m.useCallback)(function(event) {
        // Running e.preventDefault() on the INPUT prevents double click behaviour
        // Sadly we needed this cast as the target type is being correctly set
        var target = event.target;
        if (target.tagName !== "INPUT") event.preventDefault();
        if (inputRef && inputRef.current && !isDisabled && document.activeElement !== inputRef.current) inputRef.current.focus();
        onMouseDown && onMouseDown(event);
    }, [
        onMouseDown,
        isDisabled
    ]);
    var setInputRef = (0, $dAx5m.useCallback)(function(inputElement) {
        inputRef.current = inputElement;
        if (!ref) return;
        if ((0, (/*@__PURE__*/$parcel$interopDefault($gFTAr)))(ref) === "object") ref.current = inputElement;
        if (typeof ref === "function") ref(inputElement);
    }, [
        ref
    ]);
    var containerStyles = (0, $dAx5m.useMemo)(function() {
        return (0, $58ITB.containerStyles)(appearance, width);
    }, [
        appearance,
        width
    ]);
    var inputStyle = (0, $58ITB.inputStyles)();
    return(/**
     * It is not normally acceptable to add click and key handlers to
     * non-interactive elements as this is an accessibility anti-pattern.
     * However, because this instance is to handle events on all children that
     * should be associated with the input, we can add role="presentation" so
     * that there are no negative impacts to assistive technologies.
     */ (0, $jVTBW.jsx)("div", {
        role: "presentation",
        "data-disabled": isDisabled ? isDisabled : undefined,
        "data-invalid": isInvalid ? isInvalid : undefined,
        "data-ds--text-field--container": true,
        "data-testid": testId && "".concat(testId, "-container"),
        onMouseDown: handleOnMouseDown,
        css: containerStyles,
        className: className
    }, elemBeforeInput, (0, $jVTBW.jsx)("input", (0, (/*@__PURE__*/$parcel$interopDefault($c2KpP)))({}, spreadProps, {
        "aria-invalid": isInvalid ? isInvalid : undefined,
        css: inputStyle,
        "data-compact": isCompact ? isCompact : undefined,
        "data-ds--text-field--input": true,
        "data-monospaced": isMonospaced ? isMonospaced : undefined,
        "data-testid": testId,
        disabled: isDisabled,
        name: name,
        onBlur: handleOnBlur,
        onChange: onChange,
        onFocus: handleOnFocus,
        placeholder: placeholder,
        readOnly: isReadOnly,
        ref: setInputRef,
        required: isRequired
    })), elemAfterInput));
});
$28fd9ef2bf4087fc$var$TextfieldComponent.displayName = "Textfield";
/**
 * __Textfield__
 *
 * A text field is an input that allows a user to write or edit text.
 *
 * - [Examples](https://atlassian.design/components/textfield/examples)
 * - [Code](https://atlassian.design/components/textfield/code)
 * - [Usage](https://atlassian.design/components/textfield/usage)
 */ var $28fd9ef2bf4087fc$var$Textfield = /*#__PURE__*/ (0, $dAx5m.memo)($28fd9ef2bf4087fc$var$TextfieldComponent);
var // The above generic is used to let ERTC know what props to extract.
// See: https://github.com/atlassian/extract-react-types/issues/201
$28fd9ef2bf4087fc$export$2e2bcd8739ae039 = $28fd9ef2bf4087fc$var$Textfield;

});
parcelRegister("c2KpP", function(module, exports) {
function $8c49ad16afb6a7d2$var$_extends() {
    return module.exports = $8c49ad16afb6a7d2$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $8c49ad16afb6a7d2$var$_extends.apply(null, arguments);
}
module.exports = $8c49ad16afb6a7d2$var$_extends, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("gFTAr", function(module, exports) {
function $c23b980fe87b0618$var$_typeof(o) {
    "@babel/helpers - typeof";
    return module.exports = $c23b980fe87b0618$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $c23b980fe87b0618$var$_typeof(o);
}
module.exports = $c23b980fe87b0618$var$_typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("jTmBQ", function(module, exports) {

var $e50id = parcelRequire("e50id");
function $e7b4b124c714e0ea$var$_defineProperty(e, r, t) {
    return (r = $e50id(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
module.exports = $e7b4b124c714e0ea$var$_defineProperty, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("e50id", function(module, exports) {

var $gFTAr = parcelRequire("gFTAr");
var $a401c277835aa3cc$var$_typeof = $gFTAr.default;

var $c6eNU = parcelRequire("c6eNU");
function $a401c277835aa3cc$var$toPropertyKey(t) {
    var i = $c6eNU(t, "string");
    return "symbol" == $a401c277835aa3cc$var$_typeof(i) ? i : i + "";
}
module.exports = $a401c277835aa3cc$var$toPropertyKey, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("c6eNU", function(module, exports) {

var $gFTAr = parcelRequire("gFTAr");
var $8cf18758b9930f86$var$_typeof = $gFTAr.default;
function $8cf18758b9930f86$var$toPrimitive(t, r) {
    if ("object" != $8cf18758b9930f86$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $8cf18758b9930f86$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
module.exports = $8cf18758b9930f86$var$toPrimitive, module.exports.__esModule = true, module.exports["default"] = module.exports;

});



parcelRegister("ag9Mq", function(module, exports) {

var $i9zti = parcelRequire("i9zti");
function $7782fc1f18fbe9d7$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $i9zti(e, t);
    if (Object.getOwnPropertySymbols) {
        var s = Object.getOwnPropertySymbols(e);
        for(r = 0; r < s.length; r++)o = s[r], t.includes(o) || ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
module.exports = $7782fc1f18fbe9d7$var$_objectWithoutProperties, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("i9zti", function(module, exports) {
function $03691b2e05c790e1$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.includes(n)) continue;
        t[n] = r[n];
    }
    return t;
}
module.exports = $03691b2e05c790e1$var$_objectWithoutPropertiesLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("3CSEr", function(module, exports) {

$parcel$export(module.exports, "usePlatformLeafEventHandler", function () { return $2a3f504cdf13b054$export$a4687b0234b40e28; });

var $jTmBQ = parcelRequire("jTmBQ");

var $dAx5m = parcelRequire("dAx5m");

var $6hY6j = parcelRequire("6hY6j");

var $3iMRT = parcelRequire("3iMRT");
function $2a3f504cdf13b054$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $2a3f504cdf13b054$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $2a3f504cdf13b054$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($jTmBQ)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $2a3f504cdf13b054$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $2a3f504cdf13b054$export$a4687b0234b40e28(_ref) {
    var fn = _ref.fn, action = _ref.action, componentName = _ref.componentName, actionSubject = _ref.actionSubject, packageName = _ref.packageName, packageVersion = _ref.packageVersion, analyticsData = _ref.analyticsData;
    var _useAnalyticsEvents = (0, $6hY6j.useAnalyticsEvents)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    // We put analyticsData and fn in a ref so that we don't need to break
    // memoization.
    // Generally these could be defined by consumers inline
    // and so we do this to avoid breaking memoization of useCallback
    var dataRef = (0, $3iMRT.useTrackedRef)(analyticsData);
    var fnRef = (0, $3iMRT.useTrackedRef)(fn);
    var handler = (0, $dAx5m.useCallback)(function(value) {
        var analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: actionSubject || componentName,
            attributes: {
                componentName: componentName,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
        // To avoid wrapping this component in AnalyticsContext we manually
        // push the parent context's meta data into the context.
        // Note: this new 'context'
        var context = $2a3f504cdf13b054$var$_objectSpread({
            componentName: componentName,
            packageName: packageName,
            packageVersion: packageVersion
        }, dataRef.current);
        analyticsEvent.context.push(context);
        // fire an event on the atlaskit channel
        var clone = analyticsEvent.clone();
        if (clone) clone.fire("atlaskit");
        fnRef.current(value, analyticsEvent);
    }, [
        // These are strings and won't change
        action,
        componentName,
        actionSubject,
        packageName,
        packageVersion,
        // This function is memoized in the context
        createAnalyticsEvent,
        // these are a stable ref because of the useTrackedRef hook
        dataRef,
        fnRef
    ]);
    return handler;
}

});
parcelRegister("6hY6j", function(module, exports) {

$parcel$export(module.exports, "useAnalyticsEvents", function () { return $4942f36210fcb748$export$5bf35293e545f20c; });

var $tWuif = parcelRequire("tWuif");

var $dJ50T = parcelRequire("dJ50T");

var $bft9c = parcelRequire("bft9c");
function $4942f36210fcb748$export$5bf35293e545f20c() {
    var analyticsContext = (0, $bft9c.useAnalyticsContext)();
    var createAnalyticsEvent = (0, $tWuif.useCallbackOne)(function(payload) {
        return new (0, $dJ50T.default)({
            context: analyticsContext.getAtlaskitAnalyticsContext(),
            handlers: analyticsContext.getAtlaskitAnalyticsEventHandlers(),
            payload: payload
        });
    }, [
        analyticsContext
    ]);
    return {
        createAnalyticsEvent: createAnalyticsEvent
    };
}

});
parcelRegister("dJ50T", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9fe35de8d12fb6a0$export$2e2bcd8739ae039; });

var $f0r7S = parcelRequire("f0r7S");

var $kbP8y = parcelRequire("kbP8y");

var $6HZkP = parcelRequire("6HZkP");

var $bqogt = parcelRequire("bqogt");

var $7g5cl = parcelRequire("7g5cl");

var $d8Na8 = parcelRequire("d8Na8");

var $56nKN = parcelRequire("56nKN");

var $7EVxl = parcelRequire("7EVxl");

var $jTmBQ = parcelRequire("jTmBQ");

var $g8eU6 = parcelRequire("g8eU6");
function $9fe35de8d12fb6a0$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $9fe35de8d12fb6a0$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, (/*@__PURE__*/$parcel$interopDefault($7EVxl)))(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, (/*@__PURE__*/$parcel$interopDefault($7EVxl)))(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, (/*@__PURE__*/$parcel$interopDefault($56nKN)))(this, result);
    };
}
function $9fe35de8d12fb6a0$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($9fe35de8d12fb6a0$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $9fe35de8d12fb6a0$export$35f8383928ba8d7 = function isUIAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $9fe35de8d12fb6a0$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isUIAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === "UIAnalyticsEvent";
};
var $9fe35de8d12fb6a0$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_AnalyticsEvent) {
    (0, (/*@__PURE__*/$parcel$interopDefault($d8Na8)))(UIAnalyticsEvent, _AnalyticsEvent);
    var _super = $9fe35de8d12fb6a0$var$_createSuper(UIAnalyticsEvent);
    function UIAnalyticsEvent(props) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($kbP8y)))(this, UIAnalyticsEvent);
        _this = _super.call(this, props);
        (0, (/*@__PURE__*/$parcel$interopDefault($jTmBQ)))((0, (/*@__PURE__*/$parcel$interopDefault($bqogt)))(_this), "_isUIAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($jTmBQ)))((0, (/*@__PURE__*/$parcel$interopDefault($bqogt)))(_this), "clone", function() {
            if (_this.hasFired) return null;
            var context = (0, (/*@__PURE__*/$parcel$interopDefault($f0r7S)))(_this.context);
            var handlers = (0, (/*@__PURE__*/$parcel$interopDefault($f0r7S)))(_this.handlers);
            /**
       * A hacky "deep clone" of the object. This is limited in that it wont
       * support functions, regexs, Maps, Sets, etc, but none of those need to
       * be represented in our payload.
       */ var payload = JSON.parse(JSON.stringify(_this.payload));
            return new UIAnalyticsEvent({
                context: context,
                handlers: handlers,
                payload: payload
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($jTmBQ)))((0, (/*@__PURE__*/$parcel$interopDefault($bqogt)))(_this), "fire", function(channel) {
            if (_this.hasFired) return;
            _this.handlers.forEach(function(handler) {
                return handler((0, (/*@__PURE__*/$parcel$interopDefault($bqogt)))(_this), channel);
            });
            _this.hasFired = true;
        });
        _this.context = props.context || [];
        _this.handlers = props.handlers || [];
        _this.hasFired = false;
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($6HZkP)))(UIAnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (this.hasFired) return this;
                return (0, (/*@__PURE__*/$parcel$interopDefault($7g5cl)))((0, (/*@__PURE__*/$parcel$interopDefault($7EVxl)))(UIAnalyticsEvent.prototype), "update", this).call(this, updater);
            }
        }
    ]);
    return UIAnalyticsEvent;
}((0, $g8eU6.default));

});
parcelRegister("f0r7S", function(module, exports) {

var $70atm = parcelRequire("70atm");

var $ba8dh = parcelRequire("ba8dh");

var $i7IfR = parcelRequire("i7IfR");

var $20BTq = parcelRequire("20BTq");
function $aecbe5bf34af23a5$var$_toConsumableArray(r) {
    return $70atm(r) || $ba8dh(r) || $i7IfR(r) || $20BTq();
}
module.exports = $aecbe5bf34af23a5$var$_toConsumableArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("70atm", function(module, exports) {

var $jSCZ5 = parcelRequire("jSCZ5");
function $5190a823e665a451$var$_arrayWithoutHoles(r) {
    if (Array.isArray(r)) return $jSCZ5(r);
}
module.exports = $5190a823e665a451$var$_arrayWithoutHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("jSCZ5", function(module, exports) {
function $e7914ce918bca2ae$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
module.exports = $e7914ce918bca2ae$var$_arrayLikeToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("ba8dh", function(module, exports) {
function $8206ffdc9bbd87a5$var$_iterableToArray(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
module.exports = $8206ffdc9bbd87a5$var$_iterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("i7IfR", function(module, exports) {

var $jSCZ5 = parcelRequire("jSCZ5");
function $d31b358744cd0375$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $jSCZ5(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $jSCZ5(r, a) : void 0;
    }
}
module.exports = $d31b358744cd0375$var$_unsupportedIterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("20BTq", function(module, exports) {
function $1768f9a2179941ad$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
module.exports = $1768f9a2179941ad$var$_nonIterableSpread, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("kbP8y", function(module, exports) {
function $eb2c8077c6ae03b9$var$_classCallCheck(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
module.exports = $eb2c8077c6ae03b9$var$_classCallCheck, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("6HZkP", function(module, exports) {

var $e50id = parcelRequire("e50id");
function $4e265611582e9714$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, $e50id(o.key), o);
    }
}
function $4e265611582e9714$var$_createClass(e, r, t) {
    return r && $4e265611582e9714$var$_defineProperties(e.prototype, r), t && $4e265611582e9714$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}
module.exports = $4e265611582e9714$var$_createClass, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("bqogt", function(module, exports) {
function $8514f1dde611d9e7$var$_assertThisInitialized(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}
module.exports = $8514f1dde611d9e7$var$_assertThisInitialized, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("7g5cl", function(module, exports) {

var $dEaSV = parcelRequire("dEaSV");
function $548e0f456885801c$var$_get() {
    return module.exports = $548e0f456885801c$var$_get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function(e, t, r) {
        var p = $dEaSV(e, t);
        if (p) {
            var n = Object.getOwnPropertyDescriptor(p, t);
            return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value;
        }
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $548e0f456885801c$var$_get.apply(null, arguments);
}
module.exports = $548e0f456885801c$var$_get, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("dEaSV", function(module, exports) {

var $7EVxl = parcelRequire("7EVxl");
function $9ef7744dacf352a7$var$_superPropBase(t, o) {
    for(; !({}).hasOwnProperty.call(t, o) && null !== (t = $7EVxl(t)););
    return t;
}
module.exports = $9ef7744dacf352a7$var$_superPropBase, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("7EVxl", function(module, exports) {
function $5938e672dc99e3a5$var$_getPrototypeOf(t) {
    return module.exports = $5938e672dc99e3a5$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $5938e672dc99e3a5$var$_getPrototypeOf(t);
}
module.exports = $5938e672dc99e3a5$var$_getPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

});



parcelRegister("d8Na8", function(module, exports) {

var $5UyTW = parcelRequire("5UyTW");
function $991228591882b82a$var$_inherits(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && $5UyTW(t, e);
}
module.exports = $991228591882b82a$var$_inherits, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("5UyTW", function(module, exports) {
function $44dd415bb10d8061$var$_setPrototypeOf(t, e) {
    return module.exports = $44dd415bb10d8061$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $44dd415bb10d8061$var$_setPrototypeOf(t, e);
}
module.exports = $44dd415bb10d8061$var$_setPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("56nKN", function(module, exports) {

var $gFTAr = parcelRequire("gFTAr");
var $3b6ff04b889eb3ad$var$_typeof = $gFTAr.default;

var $bqogt = parcelRequire("bqogt");
function $3b6ff04b889eb3ad$var$_possibleConstructorReturn(t, e) {
    if (e && ("object" == $3b6ff04b889eb3ad$var$_typeof(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return $bqogt(t);
}
module.exports = $3b6ff04b889eb3ad$var$_possibleConstructorReturn, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("g8eU6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bbe8f44e9fe47022$export$2e2bcd8739ae039; });

var $gFTAr = parcelRequire("gFTAr");

var $kbP8y = parcelRequire("kbP8y");

var $6HZkP = parcelRequire("6HZkP");

var $jTmBQ = parcelRequire("jTmBQ");
function $bbe8f44e9fe47022$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $bbe8f44e9fe47022$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $bbe8f44e9fe47022$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($jTmBQ)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $bbe8f44e9fe47022$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $bbe8f44e9fe47022$export$ad4be5c2ec28cecf = function isAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $bbe8f44e9fe47022$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === "AnalyticsEvent";
};
var $bbe8f44e9fe47022$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function AnalyticsEvent(props) {
        var _this = this;
        (0, (/*@__PURE__*/$parcel$interopDefault($kbP8y)))(this, AnalyticsEvent);
        (0, (/*@__PURE__*/$parcel$interopDefault($jTmBQ)))(this, "_isAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($jTmBQ)))(this, "clone", function() {
            // just a shallow clone, don't change sub refs unless you want to
            // affect the original's too
            var payload = $bbe8f44e9fe47022$var$_objectSpread({}, _this.payload);
            return new AnalyticsEvent({
                payload: payload
            });
        });
        this.payload = props.payload;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($6HZkP)))(AnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (typeof updater === "function") this.payload = updater(this.payload);
                if ((0, (/*@__PURE__*/$parcel$interopDefault($gFTAr)))(updater) === "object") this.payload = $bbe8f44e9fe47022$var$_objectSpread($bbe8f44e9fe47022$var$_objectSpread({}, this.payload), updater);
                return this;
            }
        }
    ]);
    return AnalyticsEvent;
}();

});


parcelRegister("bft9c", function(module, exports) {

$parcel$export(module.exports, "useAnalyticsContext", function () { return $8307b47aacc845b9$export$d1f587f82ad51c4; });

var $dAx5m = parcelRequire("dAx5m");

var $h0bf1 = parcelRequire("h0bf1");
var $8307b47aacc845b9$export$d1f587f82ad51c4 = function useAnalyticsContext() {
    return (0, $dAx5m.useContext)((0, $h0bf1.default));
};

});


parcelRegister("3iMRT", function(module, exports) {

$parcel$export(module.exports, "useTrackedRef", function () { return $2678f5c62a729262$export$1d27a74659855e44; });

var $dAx5m = parcelRequire("dAx5m");
var $2678f5c62a729262$export$1d27a74659855e44 = function useTrackedRef(value) {
    var ref = (0, $dAx5m.useRef)(value);
    ref.current = value;
    return ref;
};

});


parcelRegister("58ITB", function(module, exports) {

$parcel$export(module.exports, "containerStyles", function () { return $3be0867d4f5e01c3$export$5972a68b6e54f38f; });
$parcel$export(module.exports, "inputStyles", function () { return $3be0867d4f5e01c3$export$3eeb47dc8e6249d9; });

var $jTmBQ = parcelRequire("jTmBQ");

var $kCu53 = parcelRequire("kCu53");

var $5MUVm = parcelRequire("5MUVm");

var $6W4m7 = parcelRequire("6W4m7");
function $3be0867d4f5e01c3$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $3be0867d4f5e01c3$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $3be0867d4f5e01c3$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($jTmBQ)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $3be0867d4f5e01c3$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $3be0867d4f5e01c3$var$fontSize = (0, $6W4m7.fontSize)();
var $3be0867d4f5e01c3$var$gridSize = (0, $6W4m7.gridSize)();
var $3be0867d4f5e01c3$var$backgroundColor = {
    standard: "var(--ds-background-input, ".concat((0, $5MUVm.N10), ")"),
    subtle: "transparent",
    none: "transparent"
};
var $3be0867d4f5e01c3$var$backgroundColorFocus = {
    standard: "var(--ds-background-input-pressed, ".concat((0, $5MUVm.N0), ")"),
    subtle: "var(--ds-background-input-pressed, ".concat((0, $5MUVm.N0), ")"),
    none: "transparent"
};
var $3be0867d4f5e01c3$var$backgroundColorHover = {
    standard: "var(--ds-background-input-hovered, ".concat((0, $5MUVm.N30), ")"),
    subtle: "var(--ds-background-input-hovered, ".concat((0, $5MUVm.N30), ")"),
    none: "transparent"
};
var $3be0867d4f5e01c3$var$borderColor = {
    standard: "var(--ds-border-input, ".concat((0, $kCu53.getBooleanFF)("platform.design-system-team.border-checkbox_nyoiu") ? (0, $5MUVm.N100) : (0, $5MUVm.N40), ")"),
    subtle: "transparent",
    none: "transparent"
};
var $3be0867d4f5e01c3$var$borderColorFocus = {
    standard: "var(--ds-border-focused, ".concat((0, $5MUVm.B200), ")"),
    subtle: "var(--ds-border-focused, ".concat((0, $5MUVm.B200), ")"),
    none: "transparent"
};
var $3be0867d4f5e01c3$var$borderColorHover = {
    standard: "var(--ds-border-input, ".concat((0, $kCu53.getBooleanFF)("platform.design-system-team.border-checkbox_nyoiu") ? (0, $5MUVm.N100) : (0, $5MUVm.N40), ")"),
    subtle: "var(--ds-border-input, transparent)",
    none: "transparent"
};
var $3be0867d4f5e01c3$var$getContainerTextBgAndBorderColor = function getContainerTextBgAndBorderColor(appearance) {
    return {
        backgroundColor: $3be0867d4f5e01c3$var$backgroundColor[appearance],
        borderColor: $3be0867d4f5e01c3$var$borderColor[appearance],
        color: "var(--ds-text, ".concat((0, $5MUVm.N900), ")"),
        cursor: "text",
        "&:hover:not([data-disabled])": {
            backgroundColor: $3be0867d4f5e01c3$var$backgroundColorHover[appearance],
            borderColor: $3be0867d4f5e01c3$var$borderColorHover[appearance]
        },
        "&:focus-within:not([data-disabled])": {
            backgroundColor: $3be0867d4f5e01c3$var$backgroundColorFocus[appearance],
            borderColor: $3be0867d4f5e01c3$var$borderColorFocus[appearance],
            boxShadow: (0, $kCu53.getBooleanFF)("platform.design-system-team.update-input-border-wdith_5abwv") ? "inset 0 0 0 ".concat("var(--ds-border-width, 1px)", " ", $3be0867d4f5e01c3$var$borderColorFocus[appearance]) : undefined
        },
        "&[data-disabled]": $3be0867d4f5e01c3$var$_objectSpread({
            color: "var(--ds-text-disabled, ".concat((0, $5MUVm.N70), ")"),
            cursor: "not-allowed"
        }, appearance === "standard" && {
            backgroundColor: "var(--ds-background-disabled, ".concat((0, $5MUVm.N10), ")"),
            borderColor: "var(--ds-background-disabled, ".concat((0, $5MUVm.N10), ")")
        }),
        "&[data-invalid], &[data-invalid]:hover": {
            borderColor: "var(--ds-border-danger, ".concat((0, $5MUVm.R400), ")"),
            boxShadow: (0, $kCu53.getBooleanFF)("platform.design-system-team.update-input-border-wdith_5abwv") ? "inset 0 0 0 ".concat("var(--ds-border-width, 1px)", " ", "var(--ds-border-danger, ".concat((0, $5MUVm.R400), ")")) : undefined
        },
        "&[data-invalid]:focus-within": {
            backgroundColor: "var(--ds-background-input-pressed, ".concat((0, $5MUVm.N0), ")"),
            borderColor: "var(--ds-border-focused, ".concat((0, $5MUVm.B200), ")"),
            boxShadow: (0, $kCu53.getBooleanFF)("platform.design-system-team.update-input-border-wdith_5abwv") ? "inset 0 0 0 ".concat("var(--ds-border-width, 1px)", " ", "var(--ds-border-focused, ".concat((0, $5MUVm.B200), ")")) : undefined
        },
        "@media screen and (-ms-high-contrast: active)": {
            "&[data-invalid]:focus-within": {
                borderColor: "Highlight"
            },
            "&:focus-within": {
                borderColor: "Highlight"
            },
            "&[data-disabled]": {
                borderColor: "GrayText"
            }
        }
    };
};
var $3be0867d4f5e01c3$var$widthMap = {
    xsmall: 80,
    small: 160,
    medium: 240,
    large: 320,
    xlarge: 480
};
var $3be0867d4f5e01c3$var$getMaxWidth = function getMaxWidth(width) {
    return !width ? "100%" : width in $3be0867d4f5e01c3$var$widthMap ? $3be0867d4f5e01c3$var$widthMap[width] : +width;
};
var $3be0867d4f5e01c3$export$5972a68b6e54f38f = function containerStyles(appearance, width) {
    return $3be0867d4f5e01c3$var$_objectSpread($3be0867d4f5e01c3$var$_objectSpread($3be0867d4f5e01c3$var$_objectSpread({
        alignItems: "center"
    }, $3be0867d4f5e01c3$var$getContainerTextBgAndBorderColor(appearance)), {}, {
        borderRadius: 3,
        borderWidth: (0, $kCu53.getBooleanFF)("platform.design-system-team.update-input-border-wdith_5abwv") ? "var(--ds-border-width, 1px)" : 2
    }, (0, $kCu53.getBooleanFF)("platform.design-system-team.update-input-border-wdith_5abwv") && appearance !== "none" ? {
        padding: "var(--ds-border-width, 1px)".concat(" 0")
    } : {}), {}, {
        borderStyle: appearance === "none" ? "none" : "solid",
        boxSizing: "border-box",
        display: "flex",
        flex: "1 1 100%",
        fontSize: $3be0867d4f5e01c3$var$fontSize,
        justifyContent: "space-between",
        maxWidth: $3be0867d4f5e01c3$var$getMaxWidth(width),
        overflow: "hidden",
        transition: "background-color 0.2s ease-in-out, border-color 0.2s ease-in-out",
        wordWrap: "break-word",
        verticalAlign: "top",
        pointerEvents: "auto"
    });
};
var $3be0867d4f5e01c3$export$3eeb47dc8e6249d9 = function inputStyles() {
    return {
        backgroundColor: "transparent",
        border: 0,
        boxSizing: "border-box",
        color: "inherit",
        cursor: "inherit",
        fontSize: $3be0867d4f5e01c3$var$fontSize,
        minWidth: "0",
        outline: "none",
        width: "100%",
        lineHeight: $3be0867d4f5e01c3$var$gridSize * 2.5 / $3be0867d4f5e01c3$var$fontSize,
        fontFamily: (0, $6W4m7.fontFamily)(),
        "&[data-monospaced]": {
            fontFamily: (0, $6W4m7.codeFontFamily)()
        },
        "&[data-compact]": {
            padding: "var(--ds-space-050, 4px)".concat(" ", "var(--ds-space-075, 6px)"),
            height: "".concat(($3be0867d4f5e01c3$var$gridSize * 3.5 / $3be0867d4f5e01c3$var$fontSize).toFixed(2), "em")
        },
        "&:not([data-compact])": {
            padding: "var(--ds-space-100, 8px)".concat(" ", "var(--ds-space-075, 6px)"),
            height: "".concat(($3be0867d4f5e01c3$var$gridSize * 4.5 / $3be0867d4f5e01c3$var$fontSize).toFixed(2), "em")
        },
        "&[disabled]": {
            // Safari (WebKit) adds a -webkit-text-fill-color style to disabled inputs
            // which takes priority over color and makes the text unreadable. Need to
            // override it with the color we want.
            WebkitTextFillColor: "var(--ds-text-disabled, ".concat((0, $5MUVm.N70), ")")
        },
        // Hide the clear indicator on Edge (Windows only)
        "&::-ms-clear": {
            display: "none"
        },
        "&:invalid": {
            boxShadow: "none"
        },
        "&:placeholder-shown": {
            textOverflow: "ellipsis"
        },
        "&::placeholder": {
            color: "var(--ds-text-subtlest, ".concat((0, $5MUVm.N200), ")"),
            "&:disabled": {
                color: "var(--ds-text-disabled, ".concat((0, $5MUVm.N70), ")")
            }
        },
        "@media screen and (-ms-high-contrast: active)": {
            "&[disabled]": {
                color: "GrayText"
            }
        }
    };
};

});
parcelRegister("kCu53", function(module, exports) {

$parcel$export(module.exports, "getBooleanFF", function () { return $f02eb09b3d3bac6d$export$470e5c2be1411c89; });

var $1WovP = parcelRequire("1WovP");
function $f02eb09b3d3bac6d$export$ba05d765b8392e5e(flagResolver) {
    (0, $1WovP.setBooleanResolver)(flagResolver);
}
function $f02eb09b3d3bac6d$export$470e5c2be1411c89(name) {
    return (0, $1WovP.resolveBooleanFlag)(name);
}
function $f02eb09b3d3bac6d$export$b40ec24ac8275656(name) {
    return (0, $1WovP.resolveBooleanFlag)(name);
}

});
parcelRegister("1WovP", function(module, exports) {

$parcel$export(module.exports, "setBooleanResolver", function () { return $169e38e3b524a6e1$export$f2b591175b3e424c; });
$parcel$export(module.exports, "resolveBooleanFlag", function () { return $169e38e3b524a6e1$export$6333b6aff9fc6275; });

var $aNFxs = parcelRequire("aNFxs");

var $ahJoN = parcelRequire("ahJoN");
var $169e38e3b524a6e1$var$pkgName = "@atlaskit/platform-feature-flags";
var $169e38e3b524a6e1$export$7e41b1b2bdee3f98 = "__PLATFORM_FEATURE_FLAGS__";
var $169e38e3b524a6e1$var$hasProcessEnv = typeof $ahJoN !== "undefined" && typeof $ahJoN.env !== "undefined";
// FF global overrides can be configured by test runners or Storybook
var $169e38e3b524a6e1$var$ENV_ENABLE_PLATFORM_FF = $169e38e3b524a6e1$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
// STORYBOOK_ENABLE_PLATFORM_FF is included as storybook only allows env vars prefixed with STORYBOOK
// https://github.com/storybookjs/storybook/issues/12270
var $169e38e3b524a6e1$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF = $169e38e3b524a6e1$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
var $169e38e3b524a6e1$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE = $169e38e3b524a6e1$var$ENV_ENABLE_PLATFORM_FF || $169e38e3b524a6e1$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF;
var $169e38e3b524a6e1$var$DEFAULT_PFF_GLOBAL = {
    // In development mode we want to capture any feature flag checks that happen using the default resolver and log this result when the resolver is replaced.
    // This is because evaluating feature flags when the resolver/FF client is loaded asynchronously could cause unexpected issues.
    earlyResolvedFlags: new Map(),
    booleanResolver: function booleanResolver(flagKey) {
        var unresolvedFlagCount;
        return false;
    }
};
var $169e38e3b524a6e1$var$globalVar = typeof window !== "undefined" ? window : globalThis;
$169e38e3b524a6e1$var$globalVar[$169e38e3b524a6e1$export$7e41b1b2bdee3f98] = $169e38e3b524a6e1$var$globalVar[$169e38e3b524a6e1$export$7e41b1b2bdee3f98] || $169e38e3b524a6e1$var$DEFAULT_PFF_GLOBAL;
function $169e38e3b524a6e1$export$f2b591175b3e424c(resolver) {
    $169e38e3b524a6e1$var$globalVar[$169e38e3b524a6e1$export$7e41b1b2bdee3f98].booleanResolver = resolver;
    var _globalVar$PFF_GLOBAL;
}
function $169e38e3b524a6e1$export$6333b6aff9fc6275(flagKey) {
    if ($169e38e3b524a6e1$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE) {
        (0, $aNFxs.debug)('[%s]: The feature flags were enabled while running tests. The flag "%s" will be always enabled.', $169e38e3b524a6e1$var$pkgName, flagKey);
        return true;
    }
    try {
        var _globalVar$PFF_GLOBAL2;
        var result = (_globalVar$PFF_GLOBAL2 = $169e38e3b524a6e1$var$globalVar[$169e38e3b524a6e1$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL2 === void 0 ? void 0 : _globalVar$PFF_GLOBAL2.booleanResolver(flagKey);
        if (typeof result !== "boolean") {
            // eslint-disable-next-line no-console
            console.warn("".concat(flagKey, " resolved to a non-boolean value, returning false for safety"));
            return false;
        }
        return result;
    } catch (e) {
        return false;
    }
}

});
parcelRegister("aNFxs", function(module, exports) {

$parcel$export(module.exports, "debug", function () { return $7dceb3afafa156f3$export$1c9f709888824e05; });
var $7dceb3afafa156f3$var$_ref, $7dceb3afafa156f3$var$_process, $7dceb3afafa156f3$var$_process2;
// We can't rely on NODE_ENV === 'test' if its value is already configured by the consumer to some other value, so better to use JEST_WORKER_ID
// https://jestjs.io/docs/environment-variables#jest_worker_id
var $7dceb3afafa156f3$var$TESTS_MODE = ($7dceb3afafa156f3$var$_ref = (globalThis === null || globalThis === void 0 || ($7dceb3afafa156f3$var$_process = globalThis.process) === null || $7dceb3afafa156f3$var$_process === void 0 || ($7dceb3afafa156f3$var$_process = $7dceb3afafa156f3$var$_process.env) === null || $7dceb3afafa156f3$var$_process === void 0 ? void 0 : $7dceb3afafa156f3$var$_process.JEST_WORKER_ID) !== undefined, $7dceb3afafa156f3$var$_ref !== void 0) ? $7dceb3afafa156f3$var$_ref : false;
var $7dceb3afafa156f3$var$DEBUG_MODE = !$7dceb3afafa156f3$var$TESTS_MODE && (globalThis === null || globalThis === void 0 || ($7dceb3afafa156f3$var$_process2 = globalThis.process) === null || $7dceb3afafa156f3$var$_process2 === void 0 || ($7dceb3afafa156f3$var$_process2 = $7dceb3afafa156f3$var$_process2.env) === null || $7dceb3afafa156f3$var$_process2 === void 0 ? void 0 : $7dceb3afafa156f3$var$_process2.NODE_ENV) !== "production";
var $7dceb3afafa156f3$export$1c9f709888824e05 = function debug() {
    var _console;
    if (!$7dceb3afafa156f3$var$DEBUG_MODE) return;
    // eslint-disable-next-line no-console
    (_console = console).debug.apply(_console, arguments);
};

});





parcelRegister("c3Ngf", function(module, exports) {

$parcel$export(module.exports, "Wrapper", function () { return $2df39713614ab2a3$export$e6dfd72ab29f8598; });

var $ku6eE = parcelRequire("ku6eE");

var $5MUVm = parcelRequire("5MUVm");

var $gbKg7 = parcelRequire("gbKg7");
const $2df39713614ab2a3$export$e6dfd72ab29f8598 = (0, $ku6eE.default).div`
  /**
   * Grey out field if empty.
   */
  color: ${(props)=>props.isEmpty ? (0, $gbKg7.default)("color.text.subtlest", (0, $5MUVm).N90) : "inherit"};
  & input {
    padding-left: ${(0, $gbKg7.default)("space.100", "8px")};
  }
`;

});




parcelRegister("dk9DI", function(module, exports) {

$parcel$export(module.exports, "Label", function () { return $92191f82b1165b37$export$b04be29aa201d4f5; });
$parcel$export(module.exports, "LabelText", function () { return $92191f82b1165b37$export$dd990dc3b6fbefe1; });
$parcel$export(module.exports, "InlineEditWrapper", function () { return $92191f82b1165b37$export$663ed42385f12929; });
$parcel$export(module.exports, "InlineEditInnerWrapper", function () { return $92191f82b1165b37$export$b6624aa45dba4879; });
$parcel$export(module.exports, "ReadViewWrapper", function () { return $92191f82b1165b37$export$aec005df8122ed41; });
$parcel$export(module.exports, "ReadOnlyViewWrapper", function () { return $92191f82b1165b37$export$f97410adba8e2673; });
$parcel$export(module.exports, "IconWrapper", function () { return $92191f82b1165b37$export$be58b4326e23250f; });
$parcel$export(module.exports, "InlineDialogDisabledTrigger", function () { return $92191f82b1165b37$export$20ecd43d08addce8; });

var $ku6eE = parcelRequire("ku6eE");

var $5MUVm = parcelRequire("5MUVm");

var $gbKg7 = parcelRequire("gbKg7");
const $92191f82b1165b37$export$e1faab0803786bcf = (0, $ku6eE.default).h5`
  margin: 0;
`;
const $92191f82b1165b37$export$f69c19e57285b83a = (0, $ku6eE.default).p`
  margin-top: ${(0, $gbKg7.default)("space.150", "12px")};
`;
const $92191f82b1165b37$export$b04be29aa201d4f5 = (0, $ku6eE.default).label`
  font-size: 12px;
  color: ${(0, $gbKg7.default)("color.text.subtle", (0, $5MUVm).N200)};
  line-height: ${(0, $gbKg7.default)("space.200", "16px")};
  vertical-align: middle;
  margin-bottom: ${(0, $gbKg7.default)("space.050", "4px")};
`;
const $92191f82b1165b37$export$dd990dc3b6fbefe1 = (0, $ku6eE.default).span`
  font-weight: 600;
  padding: 0;
`;
const $92191f82b1165b37$export$663ed42385f12929 = (0, $ku6eE.default).div`
  display: flex;
  align-items: flex-start;
  color: ${(0, $gbKg7.default)("color.text", (0, $5MUVm).N800)};
`;
const $92191f82b1165b37$export$b6624aa45dba4879 = (0, $ku6eE.default).div`
  width: 100%;
  margin-right: -8px;
  display: flex;
  flex-direction: column;
`;
const $92191f82b1165b37$export$aec005df8122ed41 = (0, $ku6eE.default).div`
  /* Align with edit view */
  padding: 8px 6px 8px 8px;
  line-height: 20px;
  font-size: 14px;
  overflow-wrap: break-word;
  word-break: break-word;
  white-space: nowrap;
  color: ${(props)=>props.isEmpty ? (0, $gbKg7.default)("color.text.subtlest", (0, $5MUVm).N100) : "inherit"};
`;
const $92191f82b1165b37$export$f97410adba8e2673 = (0, $ku6eE.default)($92191f82b1165b37$export$aec005df8122ed41)`
  margin-top: 10px;
  margin-left: 2px;
`;
const $92191f82b1165b37$export$be58b4326e23250f = (0, $ku6eE.default).span`
  display: flex;
  align-items: center;
  height: 40px;

  margin-right: ${(0, $gbKg7.default)("space.200", "16px")};
  color: ${(0, $gbKg7.default)("color.text.subtle", (0, $5MUVm).N200)};
`;
const $92191f82b1165b37$export$20ecd43d08addce8 = (0, $ku6eE.default).div`
  cursor: not-allowed;
`;

});



parcelRegister("jXcEr", function(module, exports) {

$parcel$export(module.exports, "FieldInputType", function () { return $439a75d8daa9b1c9$export$c47ae8e69a270a0c; });
var $439a75d8daa9b1c9$var$PrivacyLevel;
// PrivacyLevel && FieldConfig are fully copied from PrivacyLevelDropdown and ProfileDetailsForm
(function(PrivacyLevel) {
    PrivacyLevel["PUBLIC"] = "public";
    PrivacyLevel["ORGANISATION"] = "organisation";
    PrivacyLevel["PRIVATE"] = "private";
})($439a75d8daa9b1c9$var$PrivacyLevel || ($439a75d8daa9b1c9$var$PrivacyLevel = {}));
var $439a75d8daa9b1c9$export$c47ae8e69a270a0c;
(function(FieldInputType) {
    FieldInputType[FieldInputType["Text"] = 0] = "Text";
    FieldInputType[FieldInputType["Timezone"] = 1] = "Timezone";
})($439a75d8daa9b1c9$export$c47ae8e69a270a0c || ($439a75d8daa9b1c9$export$c47ae8e69a270a0c = {}));

});

parcelRegister("7IGS7", function(module, exports) {
$parcel$export(module.exports, "GenericErrorPage", function () { return (parcelRequire("7pLec")).GenericErrorPage; });
parcelRequire("7pLec");

});
parcelRegister("7pLec", function(module, exports) {

$parcel$export(module.exports, "GenericErrorPage", function () { return $dff7729e03ed2da4$export$5d76009b056f3e5d; });

var $bibO8 = parcelRequire("bibO8");
parcelRequire("dAx5m");

var $55TWT = parcelRequire("55TWT");

var $fhHY5 = parcelRequire("fhHY5");

var $lUIfp = parcelRequire("lUIfp");

var $cSdLY = parcelRequire("cSdLY");
const $dff7729e03ed2da4$export$2369ec80391a4c8c = /*#__PURE__*/ (0, $bibO8.jsx)($cSdLY.ErrorImage, {
    src: (0, (/*@__PURE__*/$parcel$interopDefault($lUIfp)))
});
const $dff7729e03ed2da4$var$ErrorPage = ({ title: title, body: body, image: image, actions: actions })=>{
    return /*#__PURE__*/ (0, $bibO8.jsxs)($cSdLY.Container, {
        "data-test-selector": "error-page",
        children: [
            /*#__PURE__*/ (0, $bibO8.jsx)($cSdLY.ImageOuter, {
                children: image || $dff7729e03ed2da4$export$2369ec80391a4c8c
            }),
            /*#__PURE__*/ (0, $bibO8.jsxs)($cSdLY.ErrorTextContainer, {
                children: [
                    /*#__PURE__*/ (0, $bibO8.jsx)($cSdLY.TitleWrapper, {
                        children: /*#__PURE__*/ (0, $bibO8.jsx)($cSdLY.Title, {
                            children: title
                        })
                    }),
                    body && /*#__PURE__*/ (0, $bibO8.jsx)($cSdLY.DescriptionWrapper, {
                        children: /*#__PURE__*/ (0, $bibO8.jsx)($cSdLY.Description, {
                            children: body
                        })
                    })
                ]
            }),
            actions && /*#__PURE__*/ (0, $bibO8.jsx)($cSdLY.ButtonContainer, {
                children: actions
            })
        ]
    });
};
const $dff7729e03ed2da4$export$5d76009b056f3e5d = (props)=>{
    const actions = props.hasSupportLink && /*#__PURE__*/ (0, $bibO8.jsx)((0, $fhHY5.default), {
        rel: "noopener noreferrer",
        target: "_blank",
        href: "https://support.atlassian.com/contact/#/",
        children: /*#__PURE__*/ (0, $bibO8.jsx)((0, $55TWT.default), {
            id: "ptc-directory.error-boundary.message-link-text",
            defaultMessage: "Contact support",
            description: "The text of the link leading to the Atlassian support website, shown below the error description on the error pages"
        })
    });
    return /*#__PURE__*/ (0, $bibO8.jsx)($dff7729e03ed2da4$var$ErrorPage, {
        title: /*#__PURE__*/ (0, $bibO8.jsx)((0, $55TWT.default), {
            id: "pf-home.generic-error-title",
            defaultMessage: "Something went wrong"
        }),
        body: /*#__PURE__*/ (0, $bibO8.jsx)((0, $55TWT.default), {
            id: "pf-home.generic-error-description",
            defaultMessage: "We keep track of these errors, but feel free to contact us if refreshing doesn\u2019t fix things."
        }),
        actions: actions || undefined
    });
};
var $dff7729e03ed2da4$export$2e2bcd8739ae039 = $dff7729e03ed2da4$var$ErrorPage;

});
parcelRegister("55TWT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3b58d1a4f1876e71$export$2e2bcd8739ae039; });
/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */ 
var $evtaG = parcelRequire("evtaG");

var $dAx5m = parcelRequire("dAx5m");

var $dZHnD = parcelRequire("dZHnD");

var $hJU20 = parcelRequire("hJU20");
function $3b58d1a4f1876e71$var$areEqual(prevProps, nextProps) {
    var values = prevProps.values, otherProps = (0, $evtaG.__rest)(prevProps, [
        "values"
    ]);
    var nextValues = nextProps.values, nextOtherProps = (0, $evtaG.__rest)(nextProps, [
        "values"
    ]);
    return (0, $hJU20.shallowEqual)(nextValues, values) && (0, $hJU20.shallowEqual)(otherProps, nextOtherProps);
}
function $3b58d1a4f1876e71$var$FormattedMessage(props) {
    var intl = (0, $dZHnD.default)();
    var formatMessage = intl.formatMessage, _a = intl.textComponent, Text = _a === void 0 ? $dAx5m.Fragment : _a;
    var id = props.id, description = props.description, defaultMessage = props.defaultMessage, values = props.values, children = props.children, _b = props.tagName, Component = _b === void 0 ? Text : _b, ignoreTag = props.ignoreTag;
    var descriptor = {
        id: id,
        description: description,
        defaultMessage: defaultMessage
    };
    var nodes = formatMessage(descriptor, values, {
        ignoreTag: ignoreTag
    });
    if (typeof children === "function") return children(Array.isArray(nodes) ? nodes : [
        nodes
    ]);
    if (Component) return $dAx5m.createElement(Component, null, $dAx5m.Children.toArray(nodes));
    return $dAx5m.createElement($dAx5m.Fragment, null, nodes);
}
$3b58d1a4f1876e71$var$FormattedMessage.displayName = "FormattedMessage";
var $3b58d1a4f1876e71$var$MemoizedFormattedMessage = $dAx5m.memo($3b58d1a4f1876e71$var$FormattedMessage, $3b58d1a4f1876e71$var$areEqual);
$3b58d1a4f1876e71$var$MemoizedFormattedMessage.displayName = "MemoizedFormattedMessage";
var $3b58d1a4f1876e71$export$2e2bcd8739ae039 = $3b58d1a4f1876e71$var$MemoizedFormattedMessage;

});
parcelRegister("evtaG", function(module, exports) {

$parcel$export(module.exports, "__extends", function () { return $a8fa96ba8b3974f1$export$a8ba968b8961cb8a; });
$parcel$export(module.exports, "__assign", function () { return $a8fa96ba8b3974f1$export$18ce0697a983be9b; });
$parcel$export(module.exports, "__rest", function () { return $a8fa96ba8b3974f1$export$3c9a16f847548506; });
$parcel$export(module.exports, "__awaiter", function () { return $a8fa96ba8b3974f1$export$1050f835b63b671e; });
$parcel$export(module.exports, "__generator", function () { return $a8fa96ba8b3974f1$export$67ebef60e6f28a6; });
$parcel$export(module.exports, "__spreadArray", function () { return $a8fa96ba8b3974f1$export$1216008129fb82ed; });
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ var $a8fa96ba8b3974f1$var$extendStatics = function(d, b) {
    $a8fa96ba8b3974f1$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $a8fa96ba8b3974f1$var$extendStatics(d, b);
};
function $a8fa96ba8b3974f1$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $a8fa96ba8b3974f1$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $a8fa96ba8b3974f1$export$18ce0697a983be9b = function() {
    $a8fa96ba8b3974f1$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $a8fa96ba8b3974f1$export$18ce0697a983be9b.apply(this, arguments);
};
function $a8fa96ba8b3974f1$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $a8fa96ba8b3974f1$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $a8fa96ba8b3974f1$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $a8fa96ba8b3974f1$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $a8fa96ba8b3974f1$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $a8fa96ba8b3974f1$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $a8fa96ba8b3974f1$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $a8fa96ba8b3974f1$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $a8fa96ba8b3974f1$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $a8fa96ba8b3974f1$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $a8fa96ba8b3974f1$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $a8fa96ba8b3974f1$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $a8fa96ba8b3974f1$export$45d3717a4c69092e(o, m, p);
}
function $a8fa96ba8b3974f1$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $a8fa96ba8b3974f1$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $a8fa96ba8b3974f1$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($a8fa96ba8b3974f1$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $a8fa96ba8b3974f1$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $a8fa96ba8b3974f1$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $a8fa96ba8b3974f1$export$10c90e4f7922046c(v) {
    return this instanceof $a8fa96ba8b3974f1$export$10c90e4f7922046c ? (this.v = v, this) : new $a8fa96ba8b3974f1$export$10c90e4f7922046c(v);
}
function $a8fa96ba8b3974f1$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $a8fa96ba8b3974f1$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $a8fa96ba8b3974f1$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $a8fa96ba8b3974f1$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $a8fa96ba8b3974f1$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $a8fa96ba8b3974f1$export$19a8beecd37a4c45 === "function" ? $a8fa96ba8b3974f1$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $a8fa96ba8b3974f1$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $a8fa96ba8b3974f1$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $a8fa96ba8b3974f1$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $a8fa96ba8b3974f1$export$45d3717a4c69092e(result, mod, k);
    }
    $a8fa96ba8b3974f1$var$__setModuleDefault(result, mod);
    return result;
}
function $a8fa96ba8b3974f1$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $a8fa96ba8b3974f1$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $a8fa96ba8b3974f1$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $a8fa96ba8b3974f1$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $a8fa96ba8b3974f1$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $a8fa96ba8b3974f1$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $a8fa96ba8b3974f1$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $a8fa96ba8b3974f1$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    function next() {
        while(env.stack.length){
            var rec = env.stack.pop();
            try {
                var result = rec.dispose && rec.dispose.call(rec.value);
                if (rec.async) return Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } catch (e) {
                fail(e);
            }
        }
        if (env.hasError) throw env.error;
    }
    return next();
}
var $a8fa96ba8b3974f1$export$2e2bcd8739ae039 = {
    __extends: $a8fa96ba8b3974f1$export$a8ba968b8961cb8a,
    __assign: $a8fa96ba8b3974f1$export$18ce0697a983be9b,
    __rest: $a8fa96ba8b3974f1$export$3c9a16f847548506,
    __decorate: $a8fa96ba8b3974f1$export$29e00dfd3077644b,
    __param: $a8fa96ba8b3974f1$export$d5ad3fd78186038f,
    __metadata: $a8fa96ba8b3974f1$export$f1db080c865becb9,
    __awaiter: $a8fa96ba8b3974f1$export$1050f835b63b671e,
    __generator: $a8fa96ba8b3974f1$export$67ebef60e6f28a6,
    __createBinding: $a8fa96ba8b3974f1$export$45d3717a4c69092e,
    __exportStar: $a8fa96ba8b3974f1$export$f33643c0debef087,
    __values: $a8fa96ba8b3974f1$export$19a8beecd37a4c45,
    __read: $a8fa96ba8b3974f1$export$8d051b38c9118094,
    __spread: $a8fa96ba8b3974f1$export$afc72e2116322959,
    __spreadArrays: $a8fa96ba8b3974f1$export$6388937ca91ccae8,
    __spreadArray: $a8fa96ba8b3974f1$export$1216008129fb82ed,
    __await: $a8fa96ba8b3974f1$export$10c90e4f7922046c,
    __asyncGenerator: $a8fa96ba8b3974f1$export$e427f37a30a4de9b,
    __asyncDelegator: $a8fa96ba8b3974f1$export$bbd80228419bb833,
    __asyncValues: $a8fa96ba8b3974f1$export$e3b29a3d6162315f,
    __makeTemplateObject: $a8fa96ba8b3974f1$export$4fb47efe1390b86f,
    __importStar: $a8fa96ba8b3974f1$export$c21735bcef00d192,
    __importDefault: $a8fa96ba8b3974f1$export$da59b14a69baef04,
    __classPrivateFieldGet: $a8fa96ba8b3974f1$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $a8fa96ba8b3974f1$export$d40a35129aaff81f,
    __classPrivateFieldIn: $a8fa96ba8b3974f1$export$81fdc39f203e4e04,
    __addDisposableResource: $a8fa96ba8b3974f1$export$88ac25d8e944e405,
    __disposeResources: $a8fa96ba8b3974f1$export$8f076105dc360e92
};

});

parcelRegister("dZHnD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a3029f402c09c53d$export$2e2bcd8739ae039; });

var $dAx5m = parcelRequire("dAx5m");

var $ja4jS = parcelRequire("ja4jS");

var $hJU20 = parcelRequire("hJU20");
function $a3029f402c09c53d$export$2e2bcd8739ae039() {
    var intl = $dAx5m.useContext((0, $ja4jS.Context));
    (0, $hJU20.invariantIntlContext)(intl);
    return intl;
}

});
parcelRegister("ja4jS", function(module, exports) {

$parcel$export(module.exports, "Provider", function () { return $df324d411caed6b4$export$2881499e37b75b9a; });
$parcel$export(module.exports, "Context", function () { return $df324d411caed6b4$export$841858b892ce1f4c; });
$parcel$export(module.exports, "default", function () { return $df324d411caed6b4$export$2e2bcd8739ae039; });

var $evtaG = parcelRequire("evtaG");

var $dAx5m = parcelRequire("dAx5m");

var $NP1E6 = parcelRequire("NP1E6");

var $hJU20 = parcelRequire("hJU20");
function $df324d411caed6b4$var$getDisplayName(Component) {
    return Component.displayName || Component.name || "Component";
}
// TODO: We should provide initial value here
var $df324d411caed6b4$var$IntlContext = $dAx5m.createContext(null);
var $df324d411caed6b4$var$IntlConsumer = $df324d411caed6b4$var$IntlContext.Consumer, $df324d411caed6b4$var$IntlProvider = $df324d411caed6b4$var$IntlContext.Provider;
var $df324d411caed6b4$export$2881499e37b75b9a = $df324d411caed6b4$var$IntlProvider;
var $df324d411caed6b4$export$841858b892ce1f4c = $df324d411caed6b4$var$IntlContext;
function $df324d411caed6b4$export$2e2bcd8739ae039(WrappedComponent, options) {
    var _a = options || {}, _b = _a.intlPropName, intlPropName = _b === void 0 ? "intl" : _b, _c = _a.forwardRef, forwardRef = _c === void 0 ? false : _c, _d = _a.enforceContext, enforceContext = _d === void 0 ? true : _d;
    var WithIntl = function(props) {
        return $dAx5m.createElement($df324d411caed6b4$var$IntlConsumer, null, function(intl) {
            var _a;
            if (enforceContext) (0, $hJU20.invariantIntlContext)(intl);
            var intlProp = (_a = {}, _a[intlPropName] = intl, _a);
            return $dAx5m.createElement(WrappedComponent, (0, $evtaG.__assign)({}, props, intlProp, {
                ref: forwardRef ? props.forwardedRef : null
            }));
        });
    };
    WithIntl.displayName = "injectIntl(".concat($df324d411caed6b4$var$getDisplayName(WrappedComponent), ")");
    WithIntl.WrappedComponent = WrappedComponent;
    if (forwardRef) return (0, (/*@__PURE__*/$parcel$interopDefault($NP1E6)))($dAx5m.forwardRef(function(props, ref) {
        return $dAx5m.createElement(WithIntl, (0, $evtaG.__assign)({}, props, {
            forwardedRef: ref
        }));
    }), WrappedComponent);
    return (0, (/*@__PURE__*/$parcel$interopDefault($NP1E6)))(WithIntl, WrappedComponent);
}

});
parcelRegister("hJU20", function(module, exports) {

$parcel$export(module.exports, "invariantIntlContext", function () { return $cea21a4cf0120e17$export$45c4bbf6e55bba1f; });
$parcel$export(module.exports, "DEFAULT_INTL_CONFIG", function () { return $cea21a4cf0120e17$export$b52f8d6fc0d47415; });
$parcel$export(module.exports, "assignUniqueKeysToParts", function () { return $cea21a4cf0120e17$export$cfec03d26465fa63; });
$parcel$export(module.exports, "shallowEqual", function () { return $cea21a4cf0120e17$export$d36bdfa510afb180; });

var $evtaG = parcelRequire("evtaG");

var $dAx5m = parcelRequire("dAx5m");

var $gDrm5 = parcelRequire("gDrm5");

var $kIkDA = parcelRequire("kIkDA");
function $cea21a4cf0120e17$export$45c4bbf6e55bba1f(intl) {
    (0, $gDrm5.invariant)(intl, "[React Intl] Could not find required `intl` object. <IntlProvider> needs to exist in the component ancestry.");
}
var $cea21a4cf0120e17$export$b52f8d6fc0d47415 = (0, $evtaG.__assign)((0, $evtaG.__assign)({}, (0, $kIkDA.DEFAULT_INTL_CONFIG)), {
    textComponent: $dAx5m.Fragment
});
function $cea21a4cf0120e17$export$cfec03d26465fa63(formatXMLElementFn) {
    return function(parts) {
        // eslint-disable-next-line prefer-rest-params
        return formatXMLElementFn($dAx5m.Children.toArray(parts));
    };
}
function $cea21a4cf0120e17$export$d36bdfa510afb180(objA, objB) {
    if (objA === objB) return true;
    if (!objA || !objB) return false;
    var aKeys = Object.keys(objA);
    var bKeys = Object.keys(objB);
    var len = aKeys.length;
    if (bKeys.length !== len) return false;
    for(var i = 0; i < len; i++){
        var key = aKeys[i];
        if (objA[key] !== objB[key] || !Object.prototype.hasOwnProperty.call(objB, key)) return false;
    }
    return true;
}

});
parcelRegister("gDrm5", function(module, exports) {

$parcel$export(module.exports, "invariant", function () { return $c1c5820560f900fd$export$f5708dca728d7177; });
/**
 * Cannot do Math.log(x) / Math.log(10) bc if IEEE floating point issue
 * @param x number
 */ function $c1c5820560f900fd$export$f535bb00660c42db(x) {
    // Cannot count string length via Number.toString because it may use scientific notation
    // for very small or very large numbers.
    return Math.floor(Math.log(x) * Math.LOG10E);
}
function $c1c5820560f900fd$export$76d90c956114f2c2(s, times) {
    if (typeof s.repeat === "function") return s.repeat(times);
    var arr = new Array(times);
    for(var i = 0; i < arr.length; i++)arr[i] = s;
    return arr.join("");
}
function $c1c5820560f900fd$export$489176b9ebc725cc(map, pl, field, value) {
    if (!map.get(pl)) map.set(pl, Object.create(null));
    var slots = map.get(pl);
    slots[field] = value;
}
function $c1c5820560f900fd$export$d21499e79b5c28e2(map, pl, props) {
    for(var _i = 0, _a = Object.keys(props); _i < _a.length; _i++){
        var k = _a[_i];
        $c1c5820560f900fd$export$489176b9ebc725cc(map, pl, k, props[k]);
    }
}
function $c1c5820560f900fd$export$3fae2929ed23c202(map, pl, field) {
    return $c1c5820560f900fd$export$ca4e2274c058dd9f(map, pl, field)[field];
}
function $c1c5820560f900fd$export$ca4e2274c058dd9f(map, pl) {
    var fields = [];
    for(var _i = 2; _i < arguments.length; _i++)fields[_i - 2] = arguments[_i];
    var slots = map.get(pl);
    if (!slots) throw new TypeError("".concat(pl, " InternalSlot has not been initialized"));
    return fields.reduce(function(all, f) {
        all[f] = slots[f];
        return all;
    }, Object.create(null));
}
function $c1c5820560f900fd$export$25c75e09b890f24e(patternPart) {
    return patternPart.type === "literal";
}
function $c1c5820560f900fd$export$fdab3c20aae16ddf(target, name, _a) {
    var value = _a.value;
    Object.defineProperty(target, name, {
        configurable: true,
        enumerable: false,
        writable: true,
        value: value
    });
}
var $c1c5820560f900fd$export$9049a02e759202e4 = /-u(?:-[0-9a-z]{2,8})+/gi;
function $c1c5820560f900fd$export$f5708dca728d7177(condition, message, Err) {
    if (Err === void 0) Err = Error;
    if (!condition) throw new Err(message);
}

});

parcelRegister("kIkDA", function(module, exports) {

$parcel$export(module.exports, "filterProps", function () { return $f147ece550cbcfbe$export$d697c39a2985a4c; });
$parcel$export(module.exports, "DEFAULT_INTL_CONFIG", function () { return $f147ece550cbcfbe$export$b52f8d6fc0d47415; });
$parcel$export(module.exports, "createIntlCache", function () { return $f147ece550cbcfbe$export$51c4f4e973f2dc00; });
$parcel$export(module.exports, "createFormatters", function () { return $f147ece550cbcfbe$export$c3f4cd5551df13fd; });
$parcel$export(module.exports, "getNamedFormat", function () { return $f147ece550cbcfbe$export$4ee1db8ce44a209b; });

var $evtaG = parcelRequire("evtaG");

var $hvf2d = parcelRequire("hvf2d");

var $ar8lY = parcelRequire("ar8lY");

var $5Ygy2 = parcelRequire("5Ygy2");
function $f147ece550cbcfbe$export$d697c39a2985a4c(props, allowlist, defaults) {
    if (defaults === void 0) defaults = {};
    return allowlist.reduce(function(filtered, name) {
        if (name in props) filtered[name] = props[name];
        else if (name in defaults) filtered[name] = defaults[name];
        return filtered;
    }, {});
}
var $f147ece550cbcfbe$var$defaultErrorHandler = function(error) {};
var $f147ece550cbcfbe$var$defaultWarnHandler = function(warning) {};
var $f147ece550cbcfbe$export$b52f8d6fc0d47415 = {
    formats: {},
    messages: {},
    timeZone: undefined,
    defaultLocale: "en",
    defaultFormats: {},
    fallbackOnEmptyString: true,
    onError: $f147ece550cbcfbe$var$defaultErrorHandler,
    onWarn: $f147ece550cbcfbe$var$defaultWarnHandler
};
function $f147ece550cbcfbe$export$51c4f4e973f2dc00() {
    return {
        dateTime: {},
        number: {},
        message: {},
        relativeTime: {},
        pluralRules: {},
        list: {},
        displayNames: {}
    };
}
function $f147ece550cbcfbe$var$createFastMemoizeCache(store) {
    return {
        create: function() {
            return {
                get: function(key) {
                    return store[key];
                },
                set: function(key, value) {
                    store[key] = value;
                }
            };
        }
    };
}
function $f147ece550cbcfbe$export$c3f4cd5551df13fd(cache) {
    if (cache === void 0) cache = $f147ece550cbcfbe$export$51c4f4e973f2dc00();
    var RelativeTimeFormat = Intl.RelativeTimeFormat;
    var ListFormat = Intl.ListFormat;
    var DisplayNames = Intl.DisplayNames;
    var getDateTimeFormat = (0, $ar8lY.default)(function() {
        var _a;
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return new ((_a = Intl.DateTimeFormat).bind.apply(_a, (0, $evtaG.__spreadArray)([
            void 0
        ], args, false)))();
    }, {
        cache: $f147ece550cbcfbe$var$createFastMemoizeCache(cache.dateTime),
        strategy: (0, $ar8lY.strategies).variadic
    });
    var getNumberFormat = (0, $ar8lY.default)(function() {
        var _a;
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return new ((_a = Intl.NumberFormat).bind.apply(_a, (0, $evtaG.__spreadArray)([
            void 0
        ], args, false)))();
    }, {
        cache: $f147ece550cbcfbe$var$createFastMemoizeCache(cache.number),
        strategy: (0, $ar8lY.strategies).variadic
    });
    var getPluralRules = (0, $ar8lY.default)(function() {
        var _a;
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return new ((_a = Intl.PluralRules).bind.apply(_a, (0, $evtaG.__spreadArray)([
            void 0
        ], args, false)))();
    }, {
        cache: $f147ece550cbcfbe$var$createFastMemoizeCache(cache.pluralRules),
        strategy: (0, $ar8lY.strategies).variadic
    });
    return {
        getDateTimeFormat: getDateTimeFormat,
        getNumberFormat: getNumberFormat,
        getMessageFormat: (0, $ar8lY.default)(function(message, locales, overrideFormats, opts) {
            return new (0, $hvf2d.IntlMessageFormat)(message, locales, overrideFormats, (0, $evtaG.__assign)({
                formatters: {
                    getNumberFormat: getNumberFormat,
                    getDateTimeFormat: getDateTimeFormat,
                    getPluralRules: getPluralRules
                }
            }, opts || {}));
        }, {
            cache: $f147ece550cbcfbe$var$createFastMemoizeCache(cache.message),
            strategy: (0, $ar8lY.strategies).variadic
        }),
        getRelativeTimeFormat: (0, $ar8lY.default)(function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new (RelativeTimeFormat.bind.apply(RelativeTimeFormat, (0, $evtaG.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $f147ece550cbcfbe$var$createFastMemoizeCache(cache.relativeTime),
            strategy: (0, $ar8lY.strategies).variadic
        }),
        getPluralRules: getPluralRules,
        getListFormat: (0, $ar8lY.default)(function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new (ListFormat.bind.apply(ListFormat, (0, $evtaG.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $f147ece550cbcfbe$var$createFastMemoizeCache(cache.list),
            strategy: (0, $ar8lY.strategies).variadic
        }),
        getDisplayNames: (0, $ar8lY.default)(function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new (DisplayNames.bind.apply(DisplayNames, (0, $evtaG.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $f147ece550cbcfbe$var$createFastMemoizeCache(cache.displayNames),
            strategy: (0, $ar8lY.strategies).variadic
        })
    };
}
function $f147ece550cbcfbe$export$4ee1db8ce44a209b(formats, type, name, onError) {
    var formatType = formats && formats[type];
    var format;
    if (formatType) format = formatType[name];
    if (format) return format;
    onError(new (0, $5Ygy2.UnsupportedFormatterError)("No ".concat(type, " format named: ").concat(name)));
}

});
parcelRegister("hvf2d", function(module, exports) {

$parcel$export(module.exports, "IntlMessageFormat", function () { return $cbe0fe8733a23119$export$d342343268debc40; });
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/ 
var $evtaG = parcelRequire("evtaG");

var $fcnnD = parcelRequire("fcnnD");

var $ar8lY = parcelRequire("ar8lY");

var $l1ayF = parcelRequire("l1ayF");
// -- MessageFormat --------------------------------------------------------
function $cbe0fe8733a23119$var$mergeConfig(c1, c2) {
    if (!c2) return c1;
    return (0, $evtaG.__assign)((0, $evtaG.__assign)((0, $evtaG.__assign)({}, c1 || {}), c2 || {}), Object.keys(c1).reduce(function(all, k) {
        all[k] = (0, $evtaG.__assign)((0, $evtaG.__assign)({}, c1[k]), c2[k] || {});
        return all;
    }, {}));
}
function $cbe0fe8733a23119$var$mergeConfigs(defaultConfig, configs) {
    if (!configs) return defaultConfig;
    return Object.keys(defaultConfig).reduce(function(all, k) {
        all[k] = $cbe0fe8733a23119$var$mergeConfig(defaultConfig[k], configs[k]);
        return all;
    }, (0, $evtaG.__assign)({}, defaultConfig));
}
function $cbe0fe8733a23119$var$createFastMemoizeCache(store) {
    return {
        create: function() {
            return {
                get: function(key) {
                    return store[key];
                },
                set: function(key, value) {
                    store[key] = value;
                }
            };
        }
    };
}
function $cbe0fe8733a23119$var$createDefaultFormatters(cache) {
    if (cache === void 0) cache = {
        number: {},
        dateTime: {},
        pluralRules: {}
    };
    return {
        getNumberFormat: (0, $ar8lY.default)(function() {
            var _a;
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new ((_a = Intl.NumberFormat).bind.apply(_a, (0, $evtaG.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $cbe0fe8733a23119$var$createFastMemoizeCache(cache.number),
            strategy: (0, $ar8lY.strategies).variadic
        }),
        getDateTimeFormat: (0, $ar8lY.default)(function() {
            var _a;
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new ((_a = Intl.DateTimeFormat).bind.apply(_a, (0, $evtaG.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $cbe0fe8733a23119$var$createFastMemoizeCache(cache.dateTime),
            strategy: (0, $ar8lY.strategies).variadic
        }),
        getPluralRules: (0, $ar8lY.default)(function() {
            var _a;
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new ((_a = Intl.PluralRules).bind.apply(_a, (0, $evtaG.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $cbe0fe8733a23119$var$createFastMemoizeCache(cache.pluralRules),
            strategy: (0, $ar8lY.strategies).variadic
        })
    };
}
var $cbe0fe8733a23119$export$d342343268debc40 = /** @class */ function() {
    function IntlMessageFormat(message, locales, overrideFormats, opts) {
        var _this = this;
        if (locales === void 0) locales = IntlMessageFormat.defaultLocale;
        this.formatterCache = {
            number: {},
            dateTime: {},
            pluralRules: {}
        };
        this.format = function(values) {
            var parts = _this.formatToParts(values);
            // Hot path for straight simple msg translations
            if (parts.length === 1) return parts[0].value;
            var result = parts.reduce(function(all, part) {
                if (!all.length || part.type !== (0, $l1ayF.PART_TYPE).literal || typeof all[all.length - 1] !== "string") all.push(part.value);
                else all[all.length - 1] += part.value;
                return all;
            }, []);
            if (result.length <= 1) return result[0] || "";
            return result;
        };
        this.formatToParts = function(values) {
            return (0, $l1ayF.formatToParts)(_this.ast, _this.locales, _this.formatters, _this.formats, values, undefined, _this.message);
        };
        this.resolvedOptions = function() {
            return {
                locale: _this.resolvedLocale.toString()
            };
        };
        this.getAst = function() {
            return _this.ast;
        };
        // Defined first because it's used to build the format pattern.
        this.locales = locales;
        this.resolvedLocale = IntlMessageFormat.resolveLocale(locales);
        if (typeof message === "string") {
            this.message = message;
            if (!IntlMessageFormat.__parse) throw new TypeError("IntlMessageFormat.__parse must be set to process `message` of type `string`");
            // Parse string messages into an AST.
            this.ast = IntlMessageFormat.__parse(message, {
                ignoreTag: opts === null || opts === void 0 ? void 0 : opts.ignoreTag,
                locale: this.resolvedLocale
            });
        } else this.ast = message;
        if (!Array.isArray(this.ast)) throw new TypeError("A message must be provided as a String or AST.");
        // Creates a new object with the specified `formats` merged with the default
        // formats.
        this.formats = $cbe0fe8733a23119$var$mergeConfigs(IntlMessageFormat.formats, overrideFormats);
        this.formatters = opts && opts.formatters || $cbe0fe8733a23119$var$createDefaultFormatters(this.formatterCache);
    }
    Object.defineProperty(IntlMessageFormat, "defaultLocale", {
        get: function() {
            if (!IntlMessageFormat.memoizedDefaultLocale) IntlMessageFormat.memoizedDefaultLocale = new Intl.NumberFormat().resolvedOptions().locale;
            return IntlMessageFormat.memoizedDefaultLocale;
        },
        enumerable: false,
        configurable: true
    });
    IntlMessageFormat.memoizedDefaultLocale = null;
    IntlMessageFormat.resolveLocale = function(locales) {
        var supportedLocales = Intl.NumberFormat.supportedLocalesOf(locales);
        if (supportedLocales.length > 0) return new Intl.Locale(supportedLocales[0]);
        return new Intl.Locale(typeof locales === "string" ? locales : locales[0]);
    };
    IntlMessageFormat.__parse = (0, $fcnnD.parse);
    // Default format options used as the prototype of the `formats` provided to the
    // constructor. These are used when constructing the internal Intl.NumberFormat
    // and Intl.DateTimeFormat instances.
    IntlMessageFormat.formats = {
        number: {
            integer: {
                maximumFractionDigits: 0
            },
            currency: {
                style: "currency"
            },
            percent: {
                style: "percent"
            }
        },
        date: {
            short: {
                month: "numeric",
                day: "numeric",
                year: "2-digit"
            },
            medium: {
                month: "short",
                day: "numeric",
                year: "numeric"
            },
            long: {
                month: "long",
                day: "numeric",
                year: "numeric"
            },
            full: {
                weekday: "long",
                month: "long",
                day: "numeric",
                year: "numeric"
            }
        },
        time: {
            short: {
                hour: "numeric",
                minute: "numeric"
            },
            medium: {
                hour: "numeric",
                minute: "numeric",
                second: "numeric"
            },
            long: {
                hour: "numeric",
                minute: "numeric",
                second: "numeric",
                timeZoneName: "short"
            },
            full: {
                hour: "numeric",
                minute: "numeric",
                second: "numeric",
                timeZoneName: "short"
            }
        }
    };
    return IntlMessageFormat;
}();

});
parcelRegister("fcnnD", function(module, exports) {
$parcel$export(module.exports, "isArgumentElement", function () { return (parcelRequire("bOKth")).isArgumentElement; });
$parcel$export(module.exports, "isDateElement", function () { return (parcelRequire("bOKth")).isDateElement; });
$parcel$export(module.exports, "isDateTimeSkeleton", function () { return (parcelRequire("bOKth")).isDateTimeSkeleton; });
$parcel$export(module.exports, "isLiteralElement", function () { return (parcelRequire("bOKth")).isLiteralElement; });
$parcel$export(module.exports, "isNumberElement", function () { return (parcelRequire("bOKth")).isNumberElement; });
$parcel$export(module.exports, "isNumberSkeleton", function () { return (parcelRequire("bOKth")).isNumberSkeleton; });
$parcel$export(module.exports, "isPluralElement", function () { return (parcelRequire("bOKth")).isPluralElement; });
$parcel$export(module.exports, "isPoundElement", function () { return (parcelRequire("bOKth")).isPoundElement; });
$parcel$export(module.exports, "isSelectElement", function () { return (parcelRequire("bOKth")).isSelectElement; });
$parcel$export(module.exports, "isTagElement", function () { return (parcelRequire("bOKth")).isTagElement; });
$parcel$export(module.exports, "isTimeElement", function () { return (parcelRequire("bOKth")).isTimeElement; });
$parcel$export(module.exports, "TYPE", function () { return (parcelRequire("bOKth")).TYPE; });

$parcel$export(module.exports, "parse", function () { return $b10a1cceccfe4c82$export$98e6a39c04603d36; });

var $evtaG = parcelRequire("evtaG");

var $7isxo = parcelRequire("7isxo");

var $naCx5 = parcelRequire("naCx5");

var $bOKth = parcelRequire("bOKth");
function $b10a1cceccfe4c82$var$pruneLocation(els) {
    els.forEach(function(el) {
        delete el.location;
        if ((0, $bOKth.isSelectElement)(el) || (0, $bOKth.isPluralElement)(el)) for(var k in el.options){
            delete el.options[k].location;
            $b10a1cceccfe4c82$var$pruneLocation(el.options[k].value);
        }
        else if ((0, $bOKth.isNumberElement)(el) && (0, $bOKth.isNumberSkeleton)(el.style)) delete el.style.location;
        else if (((0, $bOKth.isDateElement)(el) || (0, $bOKth.isTimeElement)(el)) && (0, $bOKth.isDateTimeSkeleton)(el.style)) delete el.style.location;
        else if ((0, $bOKth.isTagElement)(el)) $b10a1cceccfe4c82$var$pruneLocation(el.children);
    });
}
function $b10a1cceccfe4c82$export$98e6a39c04603d36(message, opts) {
    if (opts === void 0) opts = {};
    opts = (0, $evtaG.__assign)({
        shouldParseSkeletons: true,
        requiresOtherClause: true
    }, opts);
    var result = new (0, $naCx5.Parser)(message, opts).parse();
    if (result.err) {
        var error = SyntaxError((0, $7isxo.ErrorKind)[result.err.kind]);
        // @ts-expect-error Assign to error object
        error.location = result.err.location;
        // @ts-expect-error Assign to error object
        error.originalMessage = result.err.message;
        throw error;
    }
    if (!(opts === null || opts === void 0 ? void 0 : opts.captureLocation)) $b10a1cceccfe4c82$var$pruneLocation(result.val);
    return result.val;
}

});
parcelRegister("7isxo", function(module, exports) {

$parcel$export(module.exports, "ErrorKind", function () { return $550059cb9bc5987e$export$896afd8541959ee5; });
var $550059cb9bc5987e$export$896afd8541959ee5;
(function(ErrorKind) {
    /** Argument is unclosed (e.g. `{0`) */ ErrorKind[ErrorKind["EXPECT_ARGUMENT_CLOSING_BRACE"] = 1] = "EXPECT_ARGUMENT_CLOSING_BRACE";
    /** Argument is empty (e.g. `{}`). */ ErrorKind[ErrorKind["EMPTY_ARGUMENT"] = 2] = "EMPTY_ARGUMENT";
    /** Argument is malformed (e.g. `{foo!}``) */ ErrorKind[ErrorKind["MALFORMED_ARGUMENT"] = 3] = "MALFORMED_ARGUMENT";
    /** Expect an argument type (e.g. `{foo,}`) */ ErrorKind[ErrorKind["EXPECT_ARGUMENT_TYPE"] = 4] = "EXPECT_ARGUMENT_TYPE";
    /** Unsupported argument type (e.g. `{foo,foo}`) */ ErrorKind[ErrorKind["INVALID_ARGUMENT_TYPE"] = 5] = "INVALID_ARGUMENT_TYPE";
    /** Expect an argument style (e.g. `{foo, number, }`) */ ErrorKind[ErrorKind["EXPECT_ARGUMENT_STYLE"] = 6] = "EXPECT_ARGUMENT_STYLE";
    /** The number skeleton is invalid. */ ErrorKind[ErrorKind["INVALID_NUMBER_SKELETON"] = 7] = "INVALID_NUMBER_SKELETON";
    /** The date time skeleton is invalid. */ ErrorKind[ErrorKind["INVALID_DATE_TIME_SKELETON"] = 8] = "INVALID_DATE_TIME_SKELETON";
    /** Exepct a number skeleton following the `::` (e.g. `{foo, number, ::}`) */ ErrorKind[ErrorKind["EXPECT_NUMBER_SKELETON"] = 9] = "EXPECT_NUMBER_SKELETON";
    /** Exepct a date time skeleton following the `::` (e.g. `{foo, date, ::}`) */ ErrorKind[ErrorKind["EXPECT_DATE_TIME_SKELETON"] = 10] = "EXPECT_DATE_TIME_SKELETON";
    /** Unmatched apostrophes in the argument style (e.g. `{foo, number, 'test`) */ ErrorKind[ErrorKind["UNCLOSED_QUOTE_IN_ARGUMENT_STYLE"] = 11] = "UNCLOSED_QUOTE_IN_ARGUMENT_STYLE";
    /** Missing select argument options (e.g. `{foo, select}`) */ ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_OPTIONS"] = 12] = "EXPECT_SELECT_ARGUMENT_OPTIONS";
    /** Expecting an offset value in `plural` or `selectordinal` argument (e.g `{foo, plural, offset}`) */ ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE"] = 13] = "EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE";
    /** Offset value in `plural` or `selectordinal` is invalid (e.g. `{foo, plural, offset: x}`) */ ErrorKind[ErrorKind["INVALID_PLURAL_ARGUMENT_OFFSET_VALUE"] = 14] = "INVALID_PLURAL_ARGUMENT_OFFSET_VALUE";
    /** Expecting a selector in `select` argument (e.g `{foo, select}`) */ ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_SELECTOR"] = 15] = "EXPECT_SELECT_ARGUMENT_SELECTOR";
    /** Expecting a selector in `plural` or `selectordinal` argument (e.g `{foo, plural}`) */ ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_SELECTOR"] = 16] = "EXPECT_PLURAL_ARGUMENT_SELECTOR";
    /** Expecting a message fragment after the `select` selector (e.g. `{foo, select, apple}`) */ ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT"] = 17] = "EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT";
    /**
     * Expecting a message fragment after the `plural` or `selectordinal` selector
     * (e.g. `{foo, plural, one}`)
     */ ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT"] = 18] = "EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT";
    /** Selector in `plural` or `selectordinal` is malformed (e.g. `{foo, plural, =x {#}}`) */ ErrorKind[ErrorKind["INVALID_PLURAL_ARGUMENT_SELECTOR"] = 19] = "INVALID_PLURAL_ARGUMENT_SELECTOR";
    /**
     * Duplicate selectors in `plural` or `selectordinal` argument.
     * (e.g. {foo, plural, one {#} one {#}})
     */ ErrorKind[ErrorKind["DUPLICATE_PLURAL_ARGUMENT_SELECTOR"] = 20] = "DUPLICATE_PLURAL_ARGUMENT_SELECTOR";
    /** Duplicate selectors in `select` argument.
     * (e.g. {foo, select, apple {apple} apple {apple}})
     */ ErrorKind[ErrorKind["DUPLICATE_SELECT_ARGUMENT_SELECTOR"] = 21] = "DUPLICATE_SELECT_ARGUMENT_SELECTOR";
    /** Plural or select argument option must have `other` clause. */ ErrorKind[ErrorKind["MISSING_OTHER_CLAUSE"] = 22] = "MISSING_OTHER_CLAUSE";
    /** The tag is malformed. (e.g. `<bold!>foo</bold!>) */ ErrorKind[ErrorKind["INVALID_TAG"] = 23] = "INVALID_TAG";
    /** The tag name is invalid. (e.g. `<123>foo</123>`) */ ErrorKind[ErrorKind["INVALID_TAG_NAME"] = 25] = "INVALID_TAG_NAME";
    /** The closing tag does not match the opening tag. (e.g. `<bold>foo</italic>`) */ ErrorKind[ErrorKind["UNMATCHED_CLOSING_TAG"] = 26] = "UNMATCHED_CLOSING_TAG";
    /** The opening tag has unmatched closing tag. (e.g. `<bold>foo`) */ ErrorKind[ErrorKind["UNCLOSED_TAG"] = 27] = "UNCLOSED_TAG";
})($550059cb9bc5987e$export$896afd8541959ee5 || ($550059cb9bc5987e$export$896afd8541959ee5 = {}));

});

parcelRegister("naCx5", function(module, exports) {

$parcel$export(module.exports, "Parser", function () { return $045a631b43d1af4f$export$7acfa6ed01010e37; });

var $evtaG = parcelRequire("evtaG");

var $7isxo = parcelRequire("7isxo");

var $bOKth = parcelRequire("bOKth");

var $56Hba = parcelRequire("56Hba");
parcelRequire("e1fFB");
var $g5wyq = parcelRequire("g5wyq");
var $6ac0E = parcelRequire("6ac0E");

var $8LaoG = parcelRequire("8LaoG");
var $045a631b43d1af4f$var$_a;
var $045a631b43d1af4f$var$SPACE_SEPARATOR_START_REGEX = new RegExp("^".concat((0, $56Hba.SPACE_SEPARATOR_REGEX).source, "*"));
var $045a631b43d1af4f$var$SPACE_SEPARATOR_END_REGEX = new RegExp("".concat((0, $56Hba.SPACE_SEPARATOR_REGEX).source, "*$"));
function $045a631b43d1af4f$var$createLocation(start, end) {
    return {
        start: start,
        end: end
    };
}
// #region Ponyfills
// Consolidate these variables up top for easier toggling during debugging
var $045a631b43d1af4f$var$hasNativeStartsWith = !!String.prototype.startsWith;
var $045a631b43d1af4f$var$hasNativeFromCodePoint = !!String.fromCodePoint;
var $045a631b43d1af4f$var$hasNativeFromEntries = !!Object.fromEntries;
var $045a631b43d1af4f$var$hasNativeCodePointAt = !!String.prototype.codePointAt;
var $045a631b43d1af4f$var$hasTrimStart = !!String.prototype.trimStart;
var $045a631b43d1af4f$var$hasTrimEnd = !!String.prototype.trimEnd;
var $045a631b43d1af4f$var$hasNativeIsSafeInteger = !!Number.isSafeInteger;
var $045a631b43d1af4f$var$isSafeInteger = $045a631b43d1af4f$var$hasNativeIsSafeInteger ? Number.isSafeInteger : function(n) {
    return typeof n === "number" && isFinite(n) && Math.floor(n) === n && Math.abs(n) <= 0x1fffffffffffff;
};
// IE11 does not support y and u.
var $045a631b43d1af4f$var$REGEX_SUPPORTS_U_AND_Y = true;
try {
    var $045a631b43d1af4f$var$re = $045a631b43d1af4f$var$RE("([^\\p{White_Space}\\p{Pattern_Syntax}]*)", "yu");
    /**
     * legacy Edge or Xbox One browser
     * Unicode flag support: supported
     * Pattern_Syntax support: not supported
     * See https://github.com/formatjs/formatjs/issues/2822
     */ $045a631b43d1af4f$var$REGEX_SUPPORTS_U_AND_Y = (($045a631b43d1af4f$var$_a = $045a631b43d1af4f$var$re.exec("a")) === null || $045a631b43d1af4f$var$_a === void 0 ? void 0 : $045a631b43d1af4f$var$_a[0]) === "a";
} catch (_) {
    $045a631b43d1af4f$var$REGEX_SUPPORTS_U_AND_Y = false;
}
var $045a631b43d1af4f$var$startsWith = $045a631b43d1af4f$var$hasNativeStartsWith ? function startsWith(s, search, position) {
    return s.startsWith(search, position);
} : function startsWith(s, search, position) {
    return s.slice(position, position + search.length) === search;
};
var $045a631b43d1af4f$var$fromCodePoint = $045a631b43d1af4f$var$hasNativeFromCodePoint ? String.fromCodePoint : function fromCodePoint() {
    var codePoints = [];
    for(var _i = 0; _i < arguments.length; _i++)codePoints[_i] = arguments[_i];
    var elements = "";
    var length = codePoints.length;
    var i = 0;
    var code;
    while(length > i){
        code = codePoints[i++];
        if (code > 0x10ffff) throw RangeError(code + " is not a valid code point");
        elements += code < 0x10000 ? String.fromCharCode(code) : String.fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00);
    }
    return elements;
};
var $045a631b43d1af4f$var$fromEntries = // native
$045a631b43d1af4f$var$hasNativeFromEntries ? Object.fromEntries : function fromEntries(entries) {
    var obj = {};
    for(var _i = 0, entries_1 = entries; _i < entries_1.length; _i++){
        var _a = entries_1[_i], k = _a[0], v = _a[1];
        obj[k] = v;
    }
    return obj;
};
var $045a631b43d1af4f$var$codePointAt = $045a631b43d1af4f$var$hasNativeCodePointAt ? function codePointAt(s, index) {
    return s.codePointAt(index);
} : function codePointAt(s, index) {
    var size = s.length;
    if (index < 0 || index >= size) return undefined;
    var first = s.charCodeAt(index);
    var second;
    return first < 0xd800 || first > 0xdbff || index + 1 === size || (second = s.charCodeAt(index + 1)) < 0xdc00 || second > 0xdfff ? first : (first - 0xd800 << 10) + (second - 0xdc00) + 0x10000;
};
var $045a631b43d1af4f$var$trimStart = $045a631b43d1af4f$var$hasTrimStart ? function trimStart(s) {
    return s.trimStart();
} : function trimStart(s) {
    return s.replace($045a631b43d1af4f$var$SPACE_SEPARATOR_START_REGEX, "");
};
var $045a631b43d1af4f$var$trimEnd = $045a631b43d1af4f$var$hasTrimEnd ? function trimEnd(s) {
    return s.trimEnd();
} : function trimEnd(s) {
    return s.replace($045a631b43d1af4f$var$SPACE_SEPARATOR_END_REGEX, "");
};
// Prevent minifier to translate new RegExp to literal form that might cause syntax error on IE11.
function $045a631b43d1af4f$var$RE(s, flag) {
    return new RegExp(s, flag);
}
// #endregion
var $045a631b43d1af4f$var$matchIdentifierAtIndex;
if ($045a631b43d1af4f$var$REGEX_SUPPORTS_U_AND_Y) {
    // Native
    var $045a631b43d1af4f$var$IDENTIFIER_PREFIX_RE_1 = $045a631b43d1af4f$var$RE("([^\\p{White_Space}\\p{Pattern_Syntax}]*)", "yu");
    $045a631b43d1af4f$var$matchIdentifierAtIndex = function matchIdentifierAtIndex(s, index) {
        var _a;
        $045a631b43d1af4f$var$IDENTIFIER_PREFIX_RE_1.lastIndex = index;
        var match = $045a631b43d1af4f$var$IDENTIFIER_PREFIX_RE_1.exec(s);
        return (_a = match[1]) !== null && _a !== void 0 ? _a : "";
    };
} else // IE11
$045a631b43d1af4f$var$matchIdentifierAtIndex = function matchIdentifierAtIndex(s, index) {
    var match = [];
    while(true){
        var c = $045a631b43d1af4f$var$codePointAt(s, index);
        if (c === undefined || $045a631b43d1af4f$var$_isWhiteSpace(c) || $045a631b43d1af4f$var$_isPatternSyntax(c)) break;
        match.push(c);
        index += c >= 0x10000 ? 2 : 1;
    }
    return $045a631b43d1af4f$var$fromCodePoint.apply(void 0, match);
};
var $045a631b43d1af4f$export$7acfa6ed01010e37 = /** @class */ function() {
    function Parser(message, options) {
        if (options === void 0) options = {};
        this.message = message;
        this.position = {
            offset: 0,
            line: 1,
            column: 1
        };
        this.ignoreTag = !!options.ignoreTag;
        this.locale = options.locale;
        this.requiresOtherClause = !!options.requiresOtherClause;
        this.shouldParseSkeletons = !!options.shouldParseSkeletons;
    }
    Parser.prototype.parse = function() {
        if (this.offset() !== 0) throw Error("parser can only be used once");
        return this.parseMessage(0, "", false);
    };
    Parser.prototype.parseMessage = function(nestingLevel, parentArgType, expectingCloseTag) {
        var elements = [];
        while(!this.isEOF()){
            var char = this.char();
            if (char === 123 /* `{` */ ) {
                var result = this.parseArgument(nestingLevel, expectingCloseTag);
                if (result.err) return result;
                elements.push(result.val);
            } else if (char === 125 /* `}` */  && nestingLevel > 0) break;
            else if (char === 35 /* `#` */  && (parentArgType === "plural" || parentArgType === "selectordinal")) {
                var position = this.clonePosition();
                this.bump();
                elements.push({
                    type: (0, $bOKth.TYPE).pound,
                    location: $045a631b43d1af4f$var$createLocation(position, this.clonePosition())
                });
            } else if (char === 60 /* `<` */  && !this.ignoreTag && this.peek() === 47 // char code for '/'
            ) {
                if (expectingCloseTag) break;
                else return this.error((0, $7isxo.ErrorKind).UNMATCHED_CLOSING_TAG, $045a631b43d1af4f$var$createLocation(this.clonePosition(), this.clonePosition()));
            } else if (char === 60 /* `<` */  && !this.ignoreTag && $045a631b43d1af4f$var$_isAlpha(this.peek() || 0)) {
                var result = this.parseTag(nestingLevel, parentArgType);
                if (result.err) return result;
                elements.push(result.val);
            } else {
                var result = this.parseLiteral(nestingLevel, parentArgType);
                if (result.err) return result;
                elements.push(result.val);
            }
        }
        return {
            val: elements,
            err: null
        };
    };
    /**
     * A tag name must start with an ASCII lower/upper case letter. The grammar is based on the
     * [custom element name][] except that a dash is NOT always mandatory and uppercase letters
     * are accepted:
     *
     * ```
     * tag ::= "<" tagName (whitespace)* "/>" | "<" tagName (whitespace)* ">" message "</" tagName (whitespace)* ">"
     * tagName ::= [a-z] (PENChar)*
     * PENChar ::=
     *     "-" | "." | [0-9] | "_" | [a-z] | [A-Z] | #xB7 | [#xC0-#xD6] | [#xD8-#xF6] | [#xF8-#x37D] |
     *     [#x37F-#x1FFF] | [#x200C-#x200D] | [#x203F-#x2040] | [#x2070-#x218F] | [#x2C00-#x2FEF] |
     *     [#x3001-#xD7FF] | [#xF900-#xFDCF] | [#xFDF0-#xFFFD] | [#x10000-#xEFFFF]
     * ```
     *
     * [custom element name]: https://html.spec.whatwg.org/multipage/custom-elements.html#valid-custom-element-name
     * NOTE: We're a bit more lax here since HTML technically does not allow uppercase HTML element but we do
     * since other tag-based engines like React allow it
     */ Parser.prototype.parseTag = function(nestingLevel, parentArgType) {
        var startPosition = this.clonePosition();
        this.bump(); // `<`
        var tagName = this.parseTagName();
        this.bumpSpace();
        if (this.bumpIf("/>")) // Self closing tag
        return {
            val: {
                type: (0, $bOKth.TYPE).literal,
                value: "<".concat(tagName, "/>"),
                location: $045a631b43d1af4f$var$createLocation(startPosition, this.clonePosition())
            },
            err: null
        };
        else if (this.bumpIf(">")) {
            var childrenResult = this.parseMessage(nestingLevel + 1, parentArgType, true);
            if (childrenResult.err) return childrenResult;
            var children = childrenResult.val;
            // Expecting a close tag
            var endTagStartPosition = this.clonePosition();
            if (this.bumpIf("</")) {
                if (this.isEOF() || !$045a631b43d1af4f$var$_isAlpha(this.char())) return this.error((0, $7isxo.ErrorKind).INVALID_TAG, $045a631b43d1af4f$var$createLocation(endTagStartPosition, this.clonePosition()));
                var closingTagNameStartPosition = this.clonePosition();
                var closingTagName = this.parseTagName();
                if (tagName !== closingTagName) return this.error((0, $7isxo.ErrorKind).UNMATCHED_CLOSING_TAG, $045a631b43d1af4f$var$createLocation(closingTagNameStartPosition, this.clonePosition()));
                this.bumpSpace();
                if (!this.bumpIf(">")) return this.error((0, $7isxo.ErrorKind).INVALID_TAG, $045a631b43d1af4f$var$createLocation(endTagStartPosition, this.clonePosition()));
                return {
                    val: {
                        type: (0, $bOKth.TYPE).tag,
                        value: tagName,
                        children: children,
                        location: $045a631b43d1af4f$var$createLocation(startPosition, this.clonePosition())
                    },
                    err: null
                };
            } else return this.error((0, $7isxo.ErrorKind).UNCLOSED_TAG, $045a631b43d1af4f$var$createLocation(startPosition, this.clonePosition()));
        } else return this.error((0, $7isxo.ErrorKind).INVALID_TAG, $045a631b43d1af4f$var$createLocation(startPosition, this.clonePosition()));
    };
    /**
     * This method assumes that the caller has peeked ahead for the first tag character.
     */ Parser.prototype.parseTagName = function() {
        var startOffset = this.offset();
        this.bump(); // the first tag name character
        while(!this.isEOF() && $045a631b43d1af4f$var$_isPotentialElementNameChar(this.char()))this.bump();
        return this.message.slice(startOffset, this.offset());
    };
    Parser.prototype.parseLiteral = function(nestingLevel, parentArgType) {
        var start = this.clonePosition();
        var value = "";
        while(true){
            var parseQuoteResult = this.tryParseQuote(parentArgType);
            if (parseQuoteResult) {
                value += parseQuoteResult;
                continue;
            }
            var parseUnquotedResult = this.tryParseUnquoted(nestingLevel, parentArgType);
            if (parseUnquotedResult) {
                value += parseUnquotedResult;
                continue;
            }
            var parseLeftAngleResult = this.tryParseLeftAngleBracket();
            if (parseLeftAngleResult) {
                value += parseLeftAngleResult;
                continue;
            }
            break;
        }
        var location = $045a631b43d1af4f$var$createLocation(start, this.clonePosition());
        return {
            val: {
                type: (0, $bOKth.TYPE).literal,
                value: value,
                location: location
            },
            err: null
        };
    };
    Parser.prototype.tryParseLeftAngleBracket = function() {
        if (!this.isEOF() && this.char() === 60 /* `<` */  && (this.ignoreTag || // If at the opening tag or closing tag position, bail.
        !$045a631b43d1af4f$var$_isAlphaOrSlash(this.peek() || 0))) {
            this.bump(); // `<`
            return "<";
        }
        return null;
    };
    /**
     * Starting with ICU 4.8, an ASCII apostrophe only starts quoted text if it immediately precedes
     * a character that requires quoting (that is, "only where needed"), and works the same in
     * nested messages as on the top level of the pattern. The new behavior is otherwise compatible.
     */ Parser.prototype.tryParseQuote = function(parentArgType) {
        if (this.isEOF() || this.char() !== 39 /* `'` */ ) return null;
        // Parse escaped char following the apostrophe, or early return if there is no escaped char.
        // Check if is valid escaped character
        switch(this.peek()){
            case 39 /* `'` */ :
                // double quote, should return as a single quote.
                this.bump();
                this.bump();
                return "'";
            // '{', '<', '>', '}'
            case 123:
            case 60:
            case 62:
            case 125:
                break;
            case 35:
                if (parentArgType === "plural" || parentArgType === "selectordinal") break;
                return null;
            default:
                return null;
        }
        this.bump(); // apostrophe
        var codePoints = [
            this.char()
        ]; // escaped char
        this.bump();
        // read chars until the optional closing apostrophe is found
        while(!this.isEOF()){
            var ch = this.char();
            if (ch === 39 /* `'` */ ) {
                if (this.peek() === 39 /* `'` */ ) {
                    codePoints.push(39);
                    // Bump one more time because we need to skip 2 characters.
                    this.bump();
                } else {
                    // Optional closing apostrophe.
                    this.bump();
                    break;
                }
            } else codePoints.push(ch);
            this.bump();
        }
        return $045a631b43d1af4f$var$fromCodePoint.apply(void 0, codePoints);
    };
    Parser.prototype.tryParseUnquoted = function(nestingLevel, parentArgType) {
        if (this.isEOF()) return null;
        var ch = this.char();
        if (ch === 60 /* `<` */  || ch === 123 /* `{` */  || ch === 35 /* `#` */  && (parentArgType === "plural" || parentArgType === "selectordinal") || ch === 125 /* `}` */  && nestingLevel > 0) return null;
        else {
            this.bump();
            return $045a631b43d1af4f$var$fromCodePoint(ch);
        }
    };
    Parser.prototype.parseArgument = function(nestingLevel, expectingCloseTag) {
        var openingBracePosition = this.clonePosition();
        this.bump(); // `{`
        this.bumpSpace();
        if (this.isEOF()) return this.error((0, $7isxo.ErrorKind).EXPECT_ARGUMENT_CLOSING_BRACE, $045a631b43d1af4f$var$createLocation(openingBracePosition, this.clonePosition()));
        if (this.char() === 125 /* `}` */ ) {
            this.bump();
            return this.error((0, $7isxo.ErrorKind).EMPTY_ARGUMENT, $045a631b43d1af4f$var$createLocation(openingBracePosition, this.clonePosition()));
        }
        // argument name
        var value = this.parseIdentifierIfPossible().value;
        if (!value) return this.error((0, $7isxo.ErrorKind).MALFORMED_ARGUMENT, $045a631b43d1af4f$var$createLocation(openingBracePosition, this.clonePosition()));
        this.bumpSpace();
        if (this.isEOF()) return this.error((0, $7isxo.ErrorKind).EXPECT_ARGUMENT_CLOSING_BRACE, $045a631b43d1af4f$var$createLocation(openingBracePosition, this.clonePosition()));
        switch(this.char()){
            // Simple argument: `{name}`
            case 125 /* `}` */ :
                this.bump(); // `}`
                return {
                    val: {
                        type: (0, $bOKth.TYPE).argument,
                        // value does not include the opening and closing braces.
                        value: value,
                        location: $045a631b43d1af4f$var$createLocation(openingBracePosition, this.clonePosition())
                    },
                    err: null
                };
            // Argument with options: `{name, format, ...}`
            case 44 /* `,` */ :
                this.bump(); // `,`
                this.bumpSpace();
                if (this.isEOF()) return this.error((0, $7isxo.ErrorKind).EXPECT_ARGUMENT_CLOSING_BRACE, $045a631b43d1af4f$var$createLocation(openingBracePosition, this.clonePosition()));
                return this.parseArgumentOptions(nestingLevel, expectingCloseTag, value, openingBracePosition);
            default:
                return this.error((0, $7isxo.ErrorKind).MALFORMED_ARGUMENT, $045a631b43d1af4f$var$createLocation(openingBracePosition, this.clonePosition()));
        }
    };
    /**
     * Advance the parser until the end of the identifier, if it is currently on
     * an identifier character. Return an empty string otherwise.
     */ Parser.prototype.parseIdentifierIfPossible = function() {
        var startingPosition = this.clonePosition();
        var startOffset = this.offset();
        var value = $045a631b43d1af4f$var$matchIdentifierAtIndex(this.message, startOffset);
        var endOffset = startOffset + value.length;
        this.bumpTo(endOffset);
        var endPosition = this.clonePosition();
        var location = $045a631b43d1af4f$var$createLocation(startingPosition, endPosition);
        return {
            value: value,
            location: location
        };
    };
    Parser.prototype.parseArgumentOptions = function(nestingLevel, expectingCloseTag, value, openingBracePosition) {
        var _a;
        // Parse this range:
        // {name, type, style}
        //        ^---^
        var typeStartPosition = this.clonePosition();
        var argType = this.parseIdentifierIfPossible().value;
        var typeEndPosition = this.clonePosition();
        switch(argType){
            case "":
                // Expecting a style string number, date, time, plural, selectordinal, or select.
                return this.error((0, $7isxo.ErrorKind).EXPECT_ARGUMENT_TYPE, $045a631b43d1af4f$var$createLocation(typeStartPosition, typeEndPosition));
            case "number":
            case "date":
            case "time":
                // Parse this range:
                // {name, number, style}
                //              ^-------^
                this.bumpSpace();
                var styleAndLocation = null;
                if (this.bumpIf(",")) {
                    this.bumpSpace();
                    var styleStartPosition = this.clonePosition();
                    var result = this.parseSimpleArgStyleIfPossible();
                    if (result.err) return result;
                    var style = $045a631b43d1af4f$var$trimEnd(result.val);
                    if (style.length === 0) return this.error((0, $7isxo.ErrorKind).EXPECT_ARGUMENT_STYLE, $045a631b43d1af4f$var$createLocation(this.clonePosition(), this.clonePosition()));
                    var styleLocation = $045a631b43d1af4f$var$createLocation(styleStartPosition, this.clonePosition());
                    styleAndLocation = {
                        style: style,
                        styleLocation: styleLocation
                    };
                }
                var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
                if (argCloseResult.err) return argCloseResult;
                var location_1 = $045a631b43d1af4f$var$createLocation(openingBracePosition, this.clonePosition());
                // Extract style or skeleton
                if (styleAndLocation && $045a631b43d1af4f$var$startsWith(styleAndLocation === null || styleAndLocation === void 0 ? void 0 : styleAndLocation.style, "::", 0)) {
                    // Skeleton starts with `::`.
                    var skeleton = $045a631b43d1af4f$var$trimStart(styleAndLocation.style.slice(2));
                    if (argType === "number") {
                        var result = this.parseNumberSkeletonFromString(skeleton, styleAndLocation.styleLocation);
                        if (result.err) return result;
                        return {
                            val: {
                                type: (0, $bOKth.TYPE).number,
                                value: value,
                                location: location_1,
                                style: result.val
                            },
                            err: null
                        };
                    } else {
                        if (skeleton.length === 0) return this.error((0, $7isxo.ErrorKind).EXPECT_DATE_TIME_SKELETON, location_1);
                        var dateTimePattern = skeleton;
                        // Get "best match" pattern only if locale is passed, if not, let it
                        // pass as-is where `parseDateTimeSkeleton()` will throw an error
                        // for unsupported patterns.
                        if (this.locale) dateTimePattern = (0, $8LaoG.getBestPattern)(skeleton, this.locale);
                        var style = {
                            type: (0, $bOKth.SKELETON_TYPE).dateTime,
                            pattern: dateTimePattern,
                            location: styleAndLocation.styleLocation,
                            parsedOptions: this.shouldParseSkeletons ? (0, $g5wyq.parseDateTimeSkeleton)(dateTimePattern) : {}
                        };
                        var type = argType === "date" ? (0, $bOKth.TYPE).date : (0, $bOKth.TYPE).time;
                        return {
                            val: {
                                type: type,
                                value: value,
                                location: location_1,
                                style: style
                            },
                            err: null
                        };
                    }
                }
                // Regular style or no style.
                return {
                    val: {
                        type: argType === "number" ? (0, $bOKth.TYPE).number : argType === "date" ? (0, $bOKth.TYPE).date : (0, $bOKth.TYPE).time,
                        value: value,
                        location: location_1,
                        style: (_a = styleAndLocation === null || styleAndLocation === void 0 ? void 0 : styleAndLocation.style) !== null && _a !== void 0 ? _a : null
                    },
                    err: null
                };
            case "plural":
            case "selectordinal":
            case "select":
                // Parse this range:
                // {name, plural, options}
                //              ^---------^
                var typeEndPosition_1 = this.clonePosition();
                this.bumpSpace();
                if (!this.bumpIf(",")) return this.error((0, $7isxo.ErrorKind).EXPECT_SELECT_ARGUMENT_OPTIONS, $045a631b43d1af4f$var$createLocation(typeEndPosition_1, (0, $evtaG.__assign)({}, typeEndPosition_1)));
                this.bumpSpace();
                // Parse offset:
                // {name, plural, offset:1, options}
                //                ^-----^
                //
                // or the first option:
                //
                // {name, plural, one {...} other {...}}
                //                ^--^
                var identifierAndLocation = this.parseIdentifierIfPossible();
                var pluralOffset = 0;
                if (argType !== "select" && identifierAndLocation.value === "offset") {
                    if (!this.bumpIf(":")) return this.error((0, $7isxo.ErrorKind).EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE, $045a631b43d1af4f$var$createLocation(this.clonePosition(), this.clonePosition()));
                    this.bumpSpace();
                    var result = this.tryParseDecimalInteger((0, $7isxo.ErrorKind).EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE, (0, $7isxo.ErrorKind).INVALID_PLURAL_ARGUMENT_OFFSET_VALUE);
                    if (result.err) return result;
                    // Parse another identifier for option parsing
                    this.bumpSpace();
                    identifierAndLocation = this.parseIdentifierIfPossible();
                    pluralOffset = result.val;
                }
                var optionsResult = this.tryParsePluralOrSelectOptions(nestingLevel, argType, expectingCloseTag, identifierAndLocation);
                if (optionsResult.err) return optionsResult;
                var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
                if (argCloseResult.err) return argCloseResult;
                var location_2 = $045a631b43d1af4f$var$createLocation(openingBracePosition, this.clonePosition());
                if (argType === "select") return {
                    val: {
                        type: (0, $bOKth.TYPE).select,
                        value: value,
                        options: $045a631b43d1af4f$var$fromEntries(optionsResult.val),
                        location: location_2
                    },
                    err: null
                };
                else return {
                    val: {
                        type: (0, $bOKth.TYPE).plural,
                        value: value,
                        options: $045a631b43d1af4f$var$fromEntries(optionsResult.val),
                        offset: pluralOffset,
                        pluralType: argType === "plural" ? "cardinal" : "ordinal",
                        location: location_2
                    },
                    err: null
                };
            default:
                return this.error((0, $7isxo.ErrorKind).INVALID_ARGUMENT_TYPE, $045a631b43d1af4f$var$createLocation(typeStartPosition, typeEndPosition));
        }
    };
    Parser.prototype.tryParseArgumentClose = function(openingBracePosition) {
        // Parse: {value, number, ::currency/GBP }
        //
        if (this.isEOF() || this.char() !== 125 /* `}` */ ) return this.error((0, $7isxo.ErrorKind).EXPECT_ARGUMENT_CLOSING_BRACE, $045a631b43d1af4f$var$createLocation(openingBracePosition, this.clonePosition()));
        this.bump(); // `}`
        return {
            val: true,
            err: null
        };
    };
    /**
     * See: https://github.com/unicode-org/icu/blob/af7ed1f6d2298013dc303628438ec4abe1f16479/icu4c/source/common/messagepattern.cpp#L659
     */ Parser.prototype.parseSimpleArgStyleIfPossible = function() {
        var nestedBraces = 0;
        var startPosition = this.clonePosition();
        while(!this.isEOF()){
            var ch = this.char();
            switch(ch){
                case 39 /* `'` */ :
                    // Treat apostrophe as quoting but include it in the style part.
                    // Find the end of the quoted literal text.
                    this.bump();
                    var apostrophePosition = this.clonePosition();
                    if (!this.bumpUntil("'")) return this.error((0, $7isxo.ErrorKind).UNCLOSED_QUOTE_IN_ARGUMENT_STYLE, $045a631b43d1af4f$var$createLocation(apostrophePosition, this.clonePosition()));
                    this.bump();
                    break;
                case 123 /* `{` */ :
                    nestedBraces += 1;
                    this.bump();
                    break;
                case 125 /* `}` */ :
                    if (nestedBraces > 0) nestedBraces -= 1;
                    else return {
                        val: this.message.slice(startPosition.offset, this.offset()),
                        err: null
                    };
                    break;
                default:
                    this.bump();
                    break;
            }
        }
        return {
            val: this.message.slice(startPosition.offset, this.offset()),
            err: null
        };
    };
    Parser.prototype.parseNumberSkeletonFromString = function(skeleton, location) {
        var tokens = [];
        try {
            tokens = (0, $6ac0E.parseNumberSkeletonFromString)(skeleton);
        } catch (e) {
            return this.error((0, $7isxo.ErrorKind).INVALID_NUMBER_SKELETON, location);
        }
        return {
            val: {
                type: (0, $bOKth.SKELETON_TYPE).number,
                tokens: tokens,
                location: location,
                parsedOptions: this.shouldParseSkeletons ? (0, $6ac0E.parseNumberSkeleton)(tokens) : {}
            },
            err: null
        };
    };
    /**
     * @param nesting_level The current nesting level of messages.
     *     This can be positive when parsing message fragment in select or plural argument options.
     * @param parent_arg_type The parent argument's type.
     * @param parsed_first_identifier If provided, this is the first identifier-like selector of
     *     the argument. It is a by-product of a previous parsing attempt.
     * @param expecting_close_tag If true, this message is directly or indirectly nested inside
     *     between a pair of opening and closing tags. The nested message will not parse beyond
     *     the closing tag boundary.
     */ Parser.prototype.tryParsePluralOrSelectOptions = function(nestingLevel, parentArgType, expectCloseTag, parsedFirstIdentifier) {
        var _a;
        var hasOtherClause = false;
        var options = [];
        var parsedSelectors = new Set();
        var selector = parsedFirstIdentifier.value, selectorLocation = parsedFirstIdentifier.location;
        // Parse:
        // one {one apple}
        // ^--^
        while(true){
            if (selector.length === 0) {
                var startPosition = this.clonePosition();
                if (parentArgType !== "select" && this.bumpIf("=")) {
                    // Try parse `={number}` selector
                    var result = this.tryParseDecimalInteger((0, $7isxo.ErrorKind).EXPECT_PLURAL_ARGUMENT_SELECTOR, (0, $7isxo.ErrorKind).INVALID_PLURAL_ARGUMENT_SELECTOR);
                    if (result.err) return result;
                    selectorLocation = $045a631b43d1af4f$var$createLocation(startPosition, this.clonePosition());
                    selector = this.message.slice(startPosition.offset, this.offset());
                } else break;
            }
            // Duplicate selector clauses
            if (parsedSelectors.has(selector)) return this.error(parentArgType === "select" ? (0, $7isxo.ErrorKind).DUPLICATE_SELECT_ARGUMENT_SELECTOR : (0, $7isxo.ErrorKind).DUPLICATE_PLURAL_ARGUMENT_SELECTOR, selectorLocation);
            if (selector === "other") hasOtherClause = true;
            // Parse:
            // one {one apple}
            //     ^----------^
            this.bumpSpace();
            var openingBracePosition = this.clonePosition();
            if (!this.bumpIf("{")) return this.error(parentArgType === "select" ? (0, $7isxo.ErrorKind).EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT : (0, $7isxo.ErrorKind).EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT, $045a631b43d1af4f$var$createLocation(this.clonePosition(), this.clonePosition()));
            var fragmentResult = this.parseMessage(nestingLevel + 1, parentArgType, expectCloseTag);
            if (fragmentResult.err) return fragmentResult;
            var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
            if (argCloseResult.err) return argCloseResult;
            options.push([
                selector,
                {
                    value: fragmentResult.val,
                    location: $045a631b43d1af4f$var$createLocation(openingBracePosition, this.clonePosition())
                }
            ]);
            // Keep track of the existing selectors
            parsedSelectors.add(selector);
            // Prep next selector clause.
            this.bumpSpace();
            _a = this.parseIdentifierIfPossible(), selector = _a.value, selectorLocation = _a.location;
        }
        if (options.length === 0) return this.error(parentArgType === "select" ? (0, $7isxo.ErrorKind).EXPECT_SELECT_ARGUMENT_SELECTOR : (0, $7isxo.ErrorKind).EXPECT_PLURAL_ARGUMENT_SELECTOR, $045a631b43d1af4f$var$createLocation(this.clonePosition(), this.clonePosition()));
        if (this.requiresOtherClause && !hasOtherClause) return this.error((0, $7isxo.ErrorKind).MISSING_OTHER_CLAUSE, $045a631b43d1af4f$var$createLocation(this.clonePosition(), this.clonePosition()));
        return {
            val: options,
            err: null
        };
    };
    Parser.prototype.tryParseDecimalInteger = function(expectNumberError, invalidNumberError) {
        var sign = 1;
        var startingPosition = this.clonePosition();
        if (this.bumpIf("+")) ;
        else if (this.bumpIf("-")) sign = -1;
        var hasDigits = false;
        var decimal = 0;
        while(!this.isEOF()){
            var ch = this.char();
            if (ch >= 48 /* `0` */  && ch <= 57 /* `9` */ ) {
                hasDigits = true;
                decimal = decimal * 10 + (ch - 48);
                this.bump();
            } else break;
        }
        var location = $045a631b43d1af4f$var$createLocation(startingPosition, this.clonePosition());
        if (!hasDigits) return this.error(expectNumberError, location);
        decimal *= sign;
        if (!$045a631b43d1af4f$var$isSafeInteger(decimal)) return this.error(invalidNumberError, location);
        return {
            val: decimal,
            err: null
        };
    };
    Parser.prototype.offset = function() {
        return this.position.offset;
    };
    Parser.prototype.isEOF = function() {
        return this.offset() === this.message.length;
    };
    Parser.prototype.clonePosition = function() {
        // This is much faster than `Object.assign` or spread.
        return {
            offset: this.position.offset,
            line: this.position.line,
            column: this.position.column
        };
    };
    /**
     * Return the code point at the current position of the parser.
     * Throws if the index is out of bound.
     */ Parser.prototype.char = function() {
        var offset = this.position.offset;
        if (offset >= this.message.length) throw Error("out of bound");
        var code = $045a631b43d1af4f$var$codePointAt(this.message, offset);
        if (code === undefined) throw Error("Offset ".concat(offset, " is at invalid UTF-16 code unit boundary"));
        return code;
    };
    Parser.prototype.error = function(kind, location) {
        return {
            val: null,
            err: {
                kind: kind,
                message: this.message,
                location: location
            }
        };
    };
    /** Bump the parser to the next UTF-16 code unit. */ Parser.prototype.bump = function() {
        if (this.isEOF()) return;
        var code = this.char();
        if (code === 10 /* '\n' */ ) {
            this.position.line += 1;
            this.position.column = 1;
            this.position.offset += 1;
        } else {
            this.position.column += 1;
            // 0 ~ 0x10000 -> unicode BMP, otherwise skip the surrogate pair.
            this.position.offset += code < 0x10000 ? 1 : 2;
        }
    };
    /**
     * If the substring starting at the current position of the parser has
     * the given prefix, then bump the parser to the character immediately
     * following the prefix and return true. Otherwise, don't bump the parser
     * and return false.
     */ Parser.prototype.bumpIf = function(prefix) {
        if ($045a631b43d1af4f$var$startsWith(this.message, prefix, this.offset())) {
            for(var i = 0; i < prefix.length; i++)this.bump();
            return true;
        }
        return false;
    };
    /**
     * Bump the parser until the pattern character is found and return `true`.
     * Otherwise bump to the end of the file and return `false`.
     */ Parser.prototype.bumpUntil = function(pattern) {
        var currentOffset = this.offset();
        var index = this.message.indexOf(pattern, currentOffset);
        if (index >= 0) {
            this.bumpTo(index);
            return true;
        } else {
            this.bumpTo(this.message.length);
            return false;
        }
    };
    /**
     * Bump the parser to the target offset.
     * If target offset is beyond the end of the input, bump the parser to the end of the input.
     */ Parser.prototype.bumpTo = function(targetOffset) {
        if (this.offset() > targetOffset) throw Error("targetOffset ".concat(targetOffset, " must be greater than or equal to the current offset ").concat(this.offset()));
        targetOffset = Math.min(targetOffset, this.message.length);
        while(true){
            var offset = this.offset();
            if (offset === targetOffset) break;
            if (offset > targetOffset) throw Error("targetOffset ".concat(targetOffset, " is at invalid UTF-16 code unit boundary"));
            this.bump();
            if (this.isEOF()) break;
        }
    };
    /** advance the parser through all whitespace to the next non-whitespace code unit. */ Parser.prototype.bumpSpace = function() {
        while(!this.isEOF() && $045a631b43d1af4f$var$_isWhiteSpace(this.char()))this.bump();
    };
    /**
     * Peek at the *next* Unicode codepoint in the input without advancing the parser.
     * If the input has been exhausted, then this returns null.
     */ Parser.prototype.peek = function() {
        if (this.isEOF()) return null;
        var code = this.char();
        var offset = this.offset();
        var nextCode = this.message.charCodeAt(offset + (code >= 0x10000 ? 2 : 1));
        return nextCode !== null && nextCode !== void 0 ? nextCode : null;
    };
    return Parser;
}();
/**
 * This check if codepoint is alphabet (lower & uppercase)
 * @param codepoint
 * @returns
 */ function $045a631b43d1af4f$var$_isAlpha(codepoint) {
    return codepoint >= 97 && codepoint <= 122 || codepoint >= 65 && codepoint <= 90;
}
function $045a631b43d1af4f$var$_isAlphaOrSlash(codepoint) {
    return $045a631b43d1af4f$var$_isAlpha(codepoint) || codepoint === 47; /* '/' */ 
}
/** See `parseTag` function docs. */ function $045a631b43d1af4f$var$_isPotentialElementNameChar(c) {
    return c === 45 /* '-' */  || c === 46 /* '.' */  || c >= 48 && c <= 57 || c === 95 /* '_' */  || c >= 97 && c <= 122 || c >= 65 && c <= 90 || c == 0xb7 || c >= 0xc0 && c <= 0xd6 || c >= 0xd8 && c <= 0xf6 || c >= 0xf8 && c <= 0x37d || c >= 0x37f && c <= 0x1fff || c >= 0x200c && c <= 0x200d || c >= 0x203f && c <= 0x2040 || c >= 0x2070 && c <= 0x218f || c >= 0x2c00 && c <= 0x2fef || c >= 0x3001 && c <= 0xd7ff || c >= 0xf900 && c <= 0xfdcf || c >= 0xfdf0 && c <= 0xfffd || c >= 0x10000 && c <= 0xeffff;
}
/**
 * Code point equivalent of regex `\p{White_Space}`.
 * From: https://www.unicode.org/Public/UCD/latest/ucd/PropList.txt
 */ function $045a631b43d1af4f$var$_isWhiteSpace(c) {
    return c >= 0x0009 && c <= 0x000d || c === 0x0020 || c === 0x0085 || c >= 0x200e && c <= 0x200f || c === 0x2028 || c === 0x2029;
}
/**
 * Code point equivalent of regex `\p{Pattern_Syntax}`.
 * See https://www.unicode.org/Public/UCD/latest/ucd/PropList.txt
 */ function $045a631b43d1af4f$var$_isPatternSyntax(c) {
    return c >= 0x0021 && c <= 0x0023 || c === 0x0024 || c >= 0x0025 && c <= 0x0027 || c === 0x0028 || c === 0x0029 || c === 0x002a || c === 0x002b || c === 0x002c || c === 0x002d || c >= 0x002e && c <= 0x002f || c >= 0x003a && c <= 0x003b || c >= 0x003c && c <= 0x003e || c >= 0x003f && c <= 0x0040 || c === 0x005b || c === 0x005c || c === 0x005d || c === 0x005e || c === 0x0060 || c === 0x007b || c === 0x007c || c === 0x007d || c === 0x007e || c === 0x00a1 || c >= 0x00a2 && c <= 0x00a5 || c === 0x00a6 || c === 0x00a7 || c === 0x00a9 || c === 0x00ab || c === 0x00ac || c === 0x00ae || c === 0x00b0 || c === 0x00b1 || c === 0x00b6 || c === 0x00bb || c === 0x00bf || c === 0x00d7 || c === 0x00f7 || c >= 0x2010 && c <= 0x2015 || c >= 0x2016 && c <= 0x2017 || c === 0x2018 || c === 0x2019 || c === 0x201a || c >= 0x201b && c <= 0x201c || c === 0x201d || c === 0x201e || c === 0x201f || c >= 0x2020 && c <= 0x2027 || c >= 0x2030 && c <= 0x2038 || c === 0x2039 || c === 0x203a || c >= 0x203b && c <= 0x203e || c >= 0x2041 && c <= 0x2043 || c === 0x2044 || c === 0x2045 || c === 0x2046 || c >= 0x2047 && c <= 0x2051 || c === 0x2052 || c === 0x2053 || c >= 0x2055 && c <= 0x205e || c >= 0x2190 && c <= 0x2194 || c >= 0x2195 && c <= 0x2199 || c >= 0x219a && c <= 0x219b || c >= 0x219c && c <= 0x219f || c === 0x21a0 || c >= 0x21a1 && c <= 0x21a2 || c === 0x21a3 || c >= 0x21a4 && c <= 0x21a5 || c === 0x21a6 || c >= 0x21a7 && c <= 0x21ad || c === 0x21ae || c >= 0x21af && c <= 0x21cd || c >= 0x21ce && c <= 0x21cf || c >= 0x21d0 && c <= 0x21d1 || c === 0x21d2 || c === 0x21d3 || c === 0x21d4 || c >= 0x21d5 && c <= 0x21f3 || c >= 0x21f4 && c <= 0x22ff || c >= 0x2300 && c <= 0x2307 || c === 0x2308 || c === 0x2309 || c === 0x230a || c === 0x230b || c >= 0x230c && c <= 0x231f || c >= 0x2320 && c <= 0x2321 || c >= 0x2322 && c <= 0x2328 || c === 0x2329 || c === 0x232a || c >= 0x232b && c <= 0x237b || c === 0x237c || c >= 0x237d && c <= 0x239a || c >= 0x239b && c <= 0x23b3 || c >= 0x23b4 && c <= 0x23db || c >= 0x23dc && c <= 0x23e1 || c >= 0x23e2 && c <= 0x2426 || c >= 0x2427 && c <= 0x243f || c >= 0x2440 && c <= 0x244a || c >= 0x244b && c <= 0x245f || c >= 0x2500 && c <= 0x25b6 || c === 0x25b7 || c >= 0x25b8 && c <= 0x25c0 || c === 0x25c1 || c >= 0x25c2 && c <= 0x25f7 || c >= 0x25f8 && c <= 0x25ff || c >= 0x2600 && c <= 0x266e || c === 0x266f || c >= 0x2670 && c <= 0x2767 || c === 0x2768 || c === 0x2769 || c === 0x276a || c === 0x276b || c === 0x276c || c === 0x276d || c === 0x276e || c === 0x276f || c === 0x2770 || c === 0x2771 || c === 0x2772 || c === 0x2773 || c === 0x2774 || c === 0x2775 || c >= 0x2794 && c <= 0x27bf || c >= 0x27c0 && c <= 0x27c4 || c === 0x27c5 || c === 0x27c6 || c >= 0x27c7 && c <= 0x27e5 || c === 0x27e6 || c === 0x27e7 || c === 0x27e8 || c === 0x27e9 || c === 0x27ea || c === 0x27eb || c === 0x27ec || c === 0x27ed || c === 0x27ee || c === 0x27ef || c >= 0x27f0 && c <= 0x27ff || c >= 0x2800 && c <= 0x28ff || c >= 0x2900 && c <= 0x2982 || c === 0x2983 || c === 0x2984 || c === 0x2985 || c === 0x2986 || c === 0x2987 || c === 0x2988 || c === 0x2989 || c === 0x298a || c === 0x298b || c === 0x298c || c === 0x298d || c === 0x298e || c === 0x298f || c === 0x2990 || c === 0x2991 || c === 0x2992 || c === 0x2993 || c === 0x2994 || c === 0x2995 || c === 0x2996 || c === 0x2997 || c === 0x2998 || c >= 0x2999 && c <= 0x29d7 || c === 0x29d8 || c === 0x29d9 || c === 0x29da || c === 0x29db || c >= 0x29dc && c <= 0x29fb || c === 0x29fc || c === 0x29fd || c >= 0x29fe && c <= 0x2aff || c >= 0x2b00 && c <= 0x2b2f || c >= 0x2b30 && c <= 0x2b44 || c >= 0x2b45 && c <= 0x2b46 || c >= 0x2b47 && c <= 0x2b4c || c >= 0x2b4d && c <= 0x2b73 || c >= 0x2b74 && c <= 0x2b75 || c >= 0x2b76 && c <= 0x2b95 || c === 0x2b96 || c >= 0x2b97 && c <= 0x2bff || c >= 0x2e00 && c <= 0x2e01 || c === 0x2e02 || c === 0x2e03 || c === 0x2e04 || c === 0x2e05 || c >= 0x2e06 && c <= 0x2e08 || c === 0x2e09 || c === 0x2e0a || c === 0x2e0b || c === 0x2e0c || c === 0x2e0d || c >= 0x2e0e && c <= 0x2e16 || c === 0x2e17 || c >= 0x2e18 && c <= 0x2e19 || c === 0x2e1a || c === 0x2e1b || c === 0x2e1c || c === 0x2e1d || c >= 0x2e1e && c <= 0x2e1f || c === 0x2e20 || c === 0x2e21 || c === 0x2e22 || c === 0x2e23 || c === 0x2e24 || c === 0x2e25 || c === 0x2e26 || c === 0x2e27 || c === 0x2e28 || c === 0x2e29 || c >= 0x2e2a && c <= 0x2e2e || c === 0x2e2f || c >= 0x2e30 && c <= 0x2e39 || c >= 0x2e3a && c <= 0x2e3b || c >= 0x2e3c && c <= 0x2e3f || c === 0x2e40 || c === 0x2e41 || c === 0x2e42 || c >= 0x2e43 && c <= 0x2e4f || c >= 0x2e50 && c <= 0x2e51 || c === 0x2e52 || c >= 0x2e53 && c <= 0x2e7f || c >= 0x3001 && c <= 0x3003 || c === 0x3008 || c === 0x3009 || c === 0x300a || c === 0x300b || c === 0x300c || c === 0x300d || c === 0x300e || c === 0x300f || c === 0x3010 || c === 0x3011 || c >= 0x3012 && c <= 0x3013 || c === 0x3014 || c === 0x3015 || c === 0x3016 || c === 0x3017 || c === 0x3018 || c === 0x3019 || c === 0x301a || c === 0x301b || c === 0x301c || c === 0x301d || c >= 0x301e && c <= 0x301f || c === 0x3020 || c === 0x3030 || c === 0xfd3e || c === 0xfd3f || c >= 0xfe45 && c <= 0xfe46;
}

});
parcelRegister("bOKth", function(module, exports) {

$parcel$export(module.exports, "TYPE", function () { return $89a8696d27bf2955$export$b87f371cbc396fcf; });
$parcel$export(module.exports, "SKELETON_TYPE", function () { return $89a8696d27bf2955$export$906452485466fa53; });
$parcel$export(module.exports, "isLiteralElement", function () { return $89a8696d27bf2955$export$cfa10c5697238752; });
$parcel$export(module.exports, "isArgumentElement", function () { return $89a8696d27bf2955$export$4f55724281bdfaf9; });
$parcel$export(module.exports, "isNumberElement", function () { return $89a8696d27bf2955$export$e11187b219e191e1; });
$parcel$export(module.exports, "isDateElement", function () { return $89a8696d27bf2955$export$32d811605da75f40; });
$parcel$export(module.exports, "isTimeElement", function () { return $89a8696d27bf2955$export$34ec46f596b1702f; });
$parcel$export(module.exports, "isSelectElement", function () { return $89a8696d27bf2955$export$dcfe1c11d168b5a1; });
$parcel$export(module.exports, "isPluralElement", function () { return $89a8696d27bf2955$export$6c796d116f0a4fbc; });
$parcel$export(module.exports, "isPoundElement", function () { return $89a8696d27bf2955$export$c0ece297bdd0c082; });
$parcel$export(module.exports, "isTagElement", function () { return $89a8696d27bf2955$export$5c83de34745812b; });
$parcel$export(module.exports, "isNumberSkeleton", function () { return $89a8696d27bf2955$export$3f9a19cd4152eda3; });
$parcel$export(module.exports, "isDateTimeSkeleton", function () { return $89a8696d27bf2955$export$7680c41f1a55f4cf; });
var $89a8696d27bf2955$export$b87f371cbc396fcf;
(function(TYPE) {
    /**
     * Raw text
     */ TYPE[TYPE["literal"] = 0] = "literal";
    /**
     * Variable w/o any format, e.g `var` in `this is a {var}`
     */ TYPE[TYPE["argument"] = 1] = "argument";
    /**
     * Variable w/ number format
     */ TYPE[TYPE["number"] = 2] = "number";
    /**
     * Variable w/ date format
     */ TYPE[TYPE["date"] = 3] = "date";
    /**
     * Variable w/ time format
     */ TYPE[TYPE["time"] = 4] = "time";
    /**
     * Variable w/ select format
     */ TYPE[TYPE["select"] = 5] = "select";
    /**
     * Variable w/ plural format
     */ TYPE[TYPE["plural"] = 6] = "plural";
    /**
     * Only possible within plural argument.
     * This is the `#` symbol that will be substituted with the count.
     */ TYPE[TYPE["pound"] = 7] = "pound";
    /**
     * XML-like tag
     */ TYPE[TYPE["tag"] = 8] = "tag";
})($89a8696d27bf2955$export$b87f371cbc396fcf || ($89a8696d27bf2955$export$b87f371cbc396fcf = {}));
var $89a8696d27bf2955$export$906452485466fa53;
(function(SKELETON_TYPE) {
    SKELETON_TYPE[SKELETON_TYPE["number"] = 0] = "number";
    SKELETON_TYPE[SKELETON_TYPE["dateTime"] = 1] = "dateTime";
})($89a8696d27bf2955$export$906452485466fa53 || ($89a8696d27bf2955$export$906452485466fa53 = {}));
function $89a8696d27bf2955$export$cfa10c5697238752(el) {
    return el.type === $89a8696d27bf2955$export$b87f371cbc396fcf.literal;
}
function $89a8696d27bf2955$export$4f55724281bdfaf9(el) {
    return el.type === $89a8696d27bf2955$export$b87f371cbc396fcf.argument;
}
function $89a8696d27bf2955$export$e11187b219e191e1(el) {
    return el.type === $89a8696d27bf2955$export$b87f371cbc396fcf.number;
}
function $89a8696d27bf2955$export$32d811605da75f40(el) {
    return el.type === $89a8696d27bf2955$export$b87f371cbc396fcf.date;
}
function $89a8696d27bf2955$export$34ec46f596b1702f(el) {
    return el.type === $89a8696d27bf2955$export$b87f371cbc396fcf.time;
}
function $89a8696d27bf2955$export$dcfe1c11d168b5a1(el) {
    return el.type === $89a8696d27bf2955$export$b87f371cbc396fcf.select;
}
function $89a8696d27bf2955$export$6c796d116f0a4fbc(el) {
    return el.type === $89a8696d27bf2955$export$b87f371cbc396fcf.plural;
}
function $89a8696d27bf2955$export$c0ece297bdd0c082(el) {
    return el.type === $89a8696d27bf2955$export$b87f371cbc396fcf.pound;
}
function $89a8696d27bf2955$export$5c83de34745812b(el) {
    return el.type === $89a8696d27bf2955$export$b87f371cbc396fcf.tag;
}
function $89a8696d27bf2955$export$3f9a19cd4152eda3(el) {
    return !!(el && typeof el === "object" && el.type === $89a8696d27bf2955$export$906452485466fa53.number);
}
function $89a8696d27bf2955$export$7680c41f1a55f4cf(el) {
    return !!(el && typeof el === "object" && el.type === $89a8696d27bf2955$export$906452485466fa53.dateTime);
}
function $89a8696d27bf2955$export$f0ac572c1121c662(value) {
    return {
        type: $89a8696d27bf2955$export$b87f371cbc396fcf.literal,
        value: value
    };
}
function $89a8696d27bf2955$export$425e864b0ba114f1(value, style) {
    return {
        type: $89a8696d27bf2955$export$b87f371cbc396fcf.number,
        value: value,
        style: style
    };
}

});

parcelRegister("56Hba", function(module, exports) {

$parcel$export(module.exports, "SPACE_SEPARATOR_REGEX", function () { return $3b7f01c10c4d2b07$export$523451f94304dd6c; });
// @generated from regex-gen.ts
var $3b7f01c10c4d2b07$export$523451f94304dd6c = /[ \xA0\u1680\u2000-\u200A\u202F\u205F\u3000]/;
var $3b7f01c10c4d2b07$export$2b8db14d8bcaece7 = /[\t-\r \x85\u200E\u200F\u2028\u2029]/;

});

parcelRegister("e1fFB", function(module, exports) {
$parcel$export(module.exports, "parseDateTimeSkeleton", function () { return (parcelRequire("g5wyq")).parseDateTimeSkeleton; });
$parcel$export(module.exports, "parseNumberSkeleton", function () { return (parcelRequire("6ac0E")).parseNumberSkeleton; });
$parcel$export(module.exports, "parseNumberSkeletonFromString", function () { return (parcelRequire("6ac0E")).parseNumberSkeletonFromString; });
parcelRequire("g5wyq");
parcelRequire("6ac0E");

});
parcelRegister("g5wyq", function(module, exports) {

$parcel$export(module.exports, "parseDateTimeSkeleton", function () { return $bb665d94280f8213$export$f7b99fb377fe69fa; });
/**
 * https://unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * Credit: https://github.com/caridy/intl-datetimeformat-pattern/blob/master/index.js
 * with some tweaks
 */ var $bb665d94280f8213$var$DATE_TIME_REGEX = /(?:[Eec]{1,6}|G{1,5}|[Qq]{1,5}|(?:[yYur]+|U{1,5})|[ML]{1,5}|d{1,2}|D{1,3}|F{1}|[abB]{1,5}|[hkHK]{1,2}|w{1,2}|W{1}|m{1,2}|s{1,2}|[zZOvVxX]{1,4})(?=([^']*'[^']*')*[^']*$)/g;
function $bb665d94280f8213$export$f7b99fb377fe69fa(skeleton) {
    var result = {};
    skeleton.replace($bb665d94280f8213$var$DATE_TIME_REGEX, function(match) {
        var len = match.length;
        switch(match[0]){
            // Era
            case "G":
                result.era = len === 4 ? "long" : len === 5 ? "narrow" : "short";
                break;
            // Year
            case "y":
                result.year = len === 2 ? "2-digit" : "numeric";
                break;
            case "Y":
            case "u":
            case "U":
            case "r":
                throw new RangeError("`Y/u/U/r` (year) patterns are not supported, use `y` instead");
            // Quarter
            case "q":
            case "Q":
                throw new RangeError("`q/Q` (quarter) patterns are not supported");
            // Month
            case "M":
            case "L":
                result.month = [
                    "numeric",
                    "2-digit",
                    "short",
                    "long",
                    "narrow"
                ][len - 1];
                break;
            // Week
            case "w":
            case "W":
                throw new RangeError("`w/W` (week) patterns are not supported");
            case "d":
                result.day = [
                    "numeric",
                    "2-digit"
                ][len - 1];
                break;
            case "D":
            case "F":
            case "g":
                throw new RangeError("`D/F/g` (day) patterns are not supported, use `d` instead");
            // Weekday
            case "E":
                result.weekday = len === 4 ? "short" : len === 5 ? "narrow" : "short";
                break;
            case "e":
                if (len < 4) throw new RangeError("`e..eee` (weekday) patterns are not supported");
                result.weekday = [
                    "short",
                    "long",
                    "narrow",
                    "short"
                ][len - 4];
                break;
            case "c":
                if (len < 4) throw new RangeError("`c..ccc` (weekday) patterns are not supported");
                result.weekday = [
                    "short",
                    "long",
                    "narrow",
                    "short"
                ][len - 4];
                break;
            // Period
            case "a":
                result.hour12 = true;
                break;
            case "b":
            case "B":
                throw new RangeError("`b/B` (period) patterns are not supported, use `a` instead");
            // Hour
            case "h":
                result.hourCycle = "h12";
                result.hour = [
                    "numeric",
                    "2-digit"
                ][len - 1];
                break;
            case "H":
                result.hourCycle = "h23";
                result.hour = [
                    "numeric",
                    "2-digit"
                ][len - 1];
                break;
            case "K":
                result.hourCycle = "h11";
                result.hour = [
                    "numeric",
                    "2-digit"
                ][len - 1];
                break;
            case "k":
                result.hourCycle = "h24";
                result.hour = [
                    "numeric",
                    "2-digit"
                ][len - 1];
                break;
            case "j":
            case "J":
            case "C":
                throw new RangeError("`j/J/C` (hour) patterns are not supported, use `h/H/K/k` instead");
            // Minute
            case "m":
                result.minute = [
                    "numeric",
                    "2-digit"
                ][len - 1];
                break;
            // Second
            case "s":
                result.second = [
                    "numeric",
                    "2-digit"
                ][len - 1];
                break;
            case "S":
            case "A":
                throw new RangeError("`S/A` (second) patterns are not supported, use `s` instead");
            // Zone
            case "z":
                result.timeZoneName = len < 4 ? "short" : "long";
                break;
            case "Z":
            case "O":
            case "v":
            case "V":
            case "X":
            case "x":
                throw new RangeError("`Z/O/v/V/X/x` (timeZone) patterns are not supported, use `z` instead");
        }
        return "";
    });
    return result;
}

});

parcelRegister("6ac0E", function(module, exports) {

$parcel$export(module.exports, "parseNumberSkeletonFromString", function () { return $47ccfe11ac904267$export$71cee2f16fba2480; });
$parcel$export(module.exports, "parseNumberSkeleton", function () { return $47ccfe11ac904267$export$47c6f8480bda3e11; });

var $evtaG = parcelRequire("evtaG");

var $hQloo = parcelRequire("hQloo");
function $47ccfe11ac904267$export$71cee2f16fba2480(skeleton) {
    if (skeleton.length === 0) throw new Error("Number skeleton cannot be empty");
    // Parse the skeleton
    var stringTokens = skeleton.split((0, $hQloo.WHITE_SPACE_REGEX)).filter(function(x) {
        return x.length > 0;
    });
    var tokens = [];
    for(var _i = 0, stringTokens_1 = stringTokens; _i < stringTokens_1.length; _i++){
        var stringToken = stringTokens_1[_i];
        var stemAndOptions = stringToken.split("/");
        if (stemAndOptions.length === 0) throw new Error("Invalid number skeleton");
        var stem = stemAndOptions[0], options = stemAndOptions.slice(1);
        for(var _a = 0, options_1 = options; _a < options_1.length; _a++){
            var option = options_1[_a];
            if (option.length === 0) throw new Error("Invalid number skeleton");
        }
        tokens.push({
            stem: stem,
            options: options
        });
    }
    return tokens;
}
function $47ccfe11ac904267$var$icuUnitToEcma(unit) {
    return unit.replace(/^(.*?)-/, "");
}
var $47ccfe11ac904267$var$FRACTION_PRECISION_REGEX = /^\.(?:(0+)(\*)?|(#+)|(0+)(#+))$/g;
var $47ccfe11ac904267$var$SIGNIFICANT_PRECISION_REGEX = /^(@+)?(\+|#+)?[rs]?$/g;
var $47ccfe11ac904267$var$INTEGER_WIDTH_REGEX = /(\*)(0+)|(#+)(0+)|(0+)/g;
var $47ccfe11ac904267$var$CONCISE_INTEGER_WIDTH_REGEX = /^(0+)$/;
function $47ccfe11ac904267$var$parseSignificantPrecision(str) {
    var result = {};
    if (str[str.length - 1] === "r") result.roundingPriority = "morePrecision";
    else if (str[str.length - 1] === "s") result.roundingPriority = "lessPrecision";
    str.replace($47ccfe11ac904267$var$SIGNIFICANT_PRECISION_REGEX, function(_, g1, g2) {
        // @@@ case
        if (typeof g2 !== "string") {
            result.minimumSignificantDigits = g1.length;
            result.maximumSignificantDigits = g1.length;
        } else if (g2 === "+") result.minimumSignificantDigits = g1.length;
        else if (g1[0] === "#") result.maximumSignificantDigits = g1.length;
        else {
            result.minimumSignificantDigits = g1.length;
            result.maximumSignificantDigits = g1.length + (typeof g2 === "string" ? g2.length : 0);
        }
        return "";
    });
    return result;
}
function $47ccfe11ac904267$var$parseSign(str) {
    switch(str){
        case "sign-auto":
            return {
                signDisplay: "auto"
            };
        case "sign-accounting":
        case "()":
            return {
                currencySign: "accounting"
            };
        case "sign-always":
        case "+!":
            return {
                signDisplay: "always"
            };
        case "sign-accounting-always":
        case "()!":
            return {
                signDisplay: "always",
                currencySign: "accounting"
            };
        case "sign-except-zero":
        case "+?":
            return {
                signDisplay: "exceptZero"
            };
        case "sign-accounting-except-zero":
        case "()?":
            return {
                signDisplay: "exceptZero",
                currencySign: "accounting"
            };
        case "sign-never":
        case "+_":
            return {
                signDisplay: "never"
            };
    }
}
function $47ccfe11ac904267$var$parseConciseScientificAndEngineeringStem(stem) {
    // Engineering
    var result;
    if (stem[0] === "E" && stem[1] === "E") {
        result = {
            notation: "engineering"
        };
        stem = stem.slice(2);
    } else if (stem[0] === "E") {
        result = {
            notation: "scientific"
        };
        stem = stem.slice(1);
    }
    if (result) {
        var signDisplay = stem.slice(0, 2);
        if (signDisplay === "+!") {
            result.signDisplay = "always";
            stem = stem.slice(2);
        } else if (signDisplay === "+?") {
            result.signDisplay = "exceptZero";
            stem = stem.slice(2);
        }
        if (!$47ccfe11ac904267$var$CONCISE_INTEGER_WIDTH_REGEX.test(stem)) throw new Error("Malformed concise eng/scientific notation");
        result.minimumIntegerDigits = stem.length;
    }
    return result;
}
function $47ccfe11ac904267$var$parseNotationOptions(opt) {
    var result = {};
    var signOpts = $47ccfe11ac904267$var$parseSign(opt);
    if (signOpts) return signOpts;
    return result;
}
function $47ccfe11ac904267$export$47c6f8480bda3e11(tokens) {
    var result = {};
    for(var _i = 0, tokens_1 = tokens; _i < tokens_1.length; _i++){
        var token = tokens_1[_i];
        switch(token.stem){
            case "percent":
            case "%":
                result.style = "percent";
                continue;
            case "%x100":
                result.style = "percent";
                result.scale = 100;
                continue;
            case "currency":
                result.style = "currency";
                result.currency = token.options[0];
                continue;
            case "group-off":
            case ",_":
                result.useGrouping = false;
                continue;
            case "precision-integer":
            case ".":
                result.maximumFractionDigits = 0;
                continue;
            case "measure-unit":
            case "unit":
                result.style = "unit";
                result.unit = $47ccfe11ac904267$var$icuUnitToEcma(token.options[0]);
                continue;
            case "compact-short":
            case "K":
                result.notation = "compact";
                result.compactDisplay = "short";
                continue;
            case "compact-long":
            case "KK":
                result.notation = "compact";
                result.compactDisplay = "long";
                continue;
            case "scientific":
                result = (0, $evtaG.__assign)((0, $evtaG.__assign)((0, $evtaG.__assign)({}, result), {
                    notation: "scientific"
                }), token.options.reduce(function(all, opt) {
                    return (0, $evtaG.__assign)((0, $evtaG.__assign)({}, all), $47ccfe11ac904267$var$parseNotationOptions(opt));
                }, {}));
                continue;
            case "engineering":
                result = (0, $evtaG.__assign)((0, $evtaG.__assign)((0, $evtaG.__assign)({}, result), {
                    notation: "engineering"
                }), token.options.reduce(function(all, opt) {
                    return (0, $evtaG.__assign)((0, $evtaG.__assign)({}, all), $47ccfe11ac904267$var$parseNotationOptions(opt));
                }, {}));
                continue;
            case "notation-simple":
                result.notation = "standard";
                continue;
            // https://github.com/unicode-org/icu/blob/master/icu4c/source/i18n/unicode/unumberformatter.h
            case "unit-width-narrow":
                result.currencyDisplay = "narrowSymbol";
                result.unitDisplay = "narrow";
                continue;
            case "unit-width-short":
                result.currencyDisplay = "code";
                result.unitDisplay = "short";
                continue;
            case "unit-width-full-name":
                result.currencyDisplay = "name";
                result.unitDisplay = "long";
                continue;
            case "unit-width-iso-code":
                result.currencyDisplay = "symbol";
                continue;
            case "scale":
                result.scale = parseFloat(token.options[0]);
                continue;
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#integer-width
            case "integer-width":
                if (token.options.length > 1) throw new RangeError("integer-width stems only accept a single optional option");
                token.options[0].replace($47ccfe11ac904267$var$INTEGER_WIDTH_REGEX, function(_, g1, g2, g3, g4, g5) {
                    if (g1) result.minimumIntegerDigits = g2.length;
                    else if (g3 && g4) throw new Error("We currently do not support maximum integer digits");
                    else if (g5) throw new Error("We currently do not support exact integer digits");
                    return "";
                });
                continue;
        }
        // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#integer-width
        if ($47ccfe11ac904267$var$CONCISE_INTEGER_WIDTH_REGEX.test(token.stem)) {
            result.minimumIntegerDigits = token.stem.length;
            continue;
        }
        if ($47ccfe11ac904267$var$FRACTION_PRECISION_REGEX.test(token.stem)) {
            // Precision
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#fraction-precision
            // precision-integer case
            if (token.options.length > 1) throw new RangeError("Fraction-precision stems only accept a single optional option");
            token.stem.replace($47ccfe11ac904267$var$FRACTION_PRECISION_REGEX, function(_, g1, g2, g3, g4, g5) {
                // .000* case (before ICU67 it was .000+)
                if (g2 === "*") result.minimumFractionDigits = g1.length;
                else if (g3 && g3[0] === "#") result.maximumFractionDigits = g3.length;
                else if (g4 && g5) {
                    result.minimumFractionDigits = g4.length;
                    result.maximumFractionDigits = g4.length + g5.length;
                } else {
                    result.minimumFractionDigits = g1.length;
                    result.maximumFractionDigits = g1.length;
                }
                return "";
            });
            var opt = token.options[0];
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#trailing-zero-display
            if (opt === "w") result = (0, $evtaG.__assign)((0, $evtaG.__assign)({}, result), {
                trailingZeroDisplay: "stripIfInteger"
            });
            else if (opt) result = (0, $evtaG.__assign)((0, $evtaG.__assign)({}, result), $47ccfe11ac904267$var$parseSignificantPrecision(opt));
            continue;
        }
        // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#significant-digits-precision
        if ($47ccfe11ac904267$var$SIGNIFICANT_PRECISION_REGEX.test(token.stem)) {
            result = (0, $evtaG.__assign)((0, $evtaG.__assign)({}, result), $47ccfe11ac904267$var$parseSignificantPrecision(token.stem));
            continue;
        }
        var signOpts = $47ccfe11ac904267$var$parseSign(token.stem);
        if (signOpts) result = (0, $evtaG.__assign)((0, $evtaG.__assign)({}, result), signOpts);
        var conciseScientificAndEngineeringOpts = $47ccfe11ac904267$var$parseConciseScientificAndEngineeringStem(token.stem);
        if (conciseScientificAndEngineeringOpts) result = (0, $evtaG.__assign)((0, $evtaG.__assign)({}, result), conciseScientificAndEngineeringOpts);
    }
    return result;
}

});
parcelRegister("hQloo", function(module, exports) {

$parcel$export(module.exports, "WHITE_SPACE_REGEX", function () { return $cfd7e312addf7d6b$export$2b8db14d8bcaece7; });
// @generated from regex-gen.ts
var $cfd7e312addf7d6b$export$2b8db14d8bcaece7 = /[\t-\r \x85\u200E\u200F\u2028\u2029]/i;

});



parcelRegister("8LaoG", function(module, exports) {

$parcel$export(module.exports, "getBestPattern", function () { return $660ac72b80d93bd2$export$29c5368be8904d27; });

var $dFQuE = parcelRequire("dFQuE");
function $660ac72b80d93bd2$export$29c5368be8904d27(skeleton, locale) {
    var skeletonCopy = "";
    for(var patternPos = 0; patternPos < skeleton.length; patternPos++){
        var patternChar = skeleton.charAt(patternPos);
        if (patternChar === "j") {
            var extraLength = 0;
            while(patternPos + 1 < skeleton.length && skeleton.charAt(patternPos + 1) === patternChar){
                extraLength++;
                patternPos++;
            }
            var hourLen = 1 + (extraLength & 1);
            var dayPeriodLen = extraLength < 2 ? 1 : 3 + (extraLength >> 1);
            var dayPeriodChar = "a";
            var hourChar = $660ac72b80d93bd2$var$getDefaultHourSymbolFromLocale(locale);
            if (hourChar == "H" || hourChar == "k") dayPeriodLen = 0;
            while(dayPeriodLen-- > 0)skeletonCopy += dayPeriodChar;
            while(hourLen-- > 0)skeletonCopy = hourChar + skeletonCopy;
        } else if (patternChar === "J") skeletonCopy += "H";
        else skeletonCopy += patternChar;
    }
    return skeletonCopy;
}
/**
 * Maps the [hour cycle type](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/Locale/hourCycle)
 * of the given `locale` to the corresponding time pattern.
 * @param locale
 */ function $660ac72b80d93bd2$var$getDefaultHourSymbolFromLocale(locale) {
    var hourCycle = locale.hourCycle;
    if (hourCycle === undefined && // @ts-ignore hourCycle(s) is not identified yet
    locale.hourCycles && // @ts-ignore
    locale.hourCycles.length) // @ts-ignore
    hourCycle = locale.hourCycles[0];
    if (hourCycle) switch(hourCycle){
        case "h24":
            return "k";
        case "h23":
            return "H";
        case "h12":
            return "h";
        case "h11":
            return "K";
        default:
            throw new Error("Invalid hourCycle");
    }
    // TODO: Once hourCycle is fully supported remove the following with data generation
    var languageTag = locale.language;
    var regionTag;
    if (languageTag !== "root") regionTag = locale.maximize().region;
    var hourCycles = (0, $dFQuE.timeData)[regionTag || ""] || (0, $dFQuE.timeData)[languageTag || ""] || (0, $dFQuE.timeData)["".concat(languageTag, "-001")] || (0, $dFQuE.timeData)["001"];
    return hourCycles[0];
}

});
parcelRegister("dFQuE", function(module, exports) {

$parcel$export(module.exports, "timeData", function () { return $9f47d2c9db32ca63$export$a8c9209db4084317; });
// @generated from time-data-gen.ts
// prettier-ignore  
var $9f47d2c9db32ca63$export$a8c9209db4084317 = {
    "AX": [
        "H"
    ],
    "BQ": [
        "H"
    ],
    "CP": [
        "H"
    ],
    "CZ": [
        "H"
    ],
    "DK": [
        "H"
    ],
    "FI": [
        "H"
    ],
    "ID": [
        "H"
    ],
    "IS": [
        "H"
    ],
    "ML": [
        "H"
    ],
    "NE": [
        "H"
    ],
    "RU": [
        "H"
    ],
    "SE": [
        "H"
    ],
    "SJ": [
        "H"
    ],
    "SK": [
        "H"
    ],
    "AS": [
        "h",
        "H"
    ],
    "BT": [
        "h",
        "H"
    ],
    "DJ": [
        "h",
        "H"
    ],
    "ER": [
        "h",
        "H"
    ],
    "GH": [
        "h",
        "H"
    ],
    "IN": [
        "h",
        "H"
    ],
    "LS": [
        "h",
        "H"
    ],
    "PG": [
        "h",
        "H"
    ],
    "PW": [
        "h",
        "H"
    ],
    "SO": [
        "h",
        "H"
    ],
    "TO": [
        "h",
        "H"
    ],
    "VU": [
        "h",
        "H"
    ],
    "WS": [
        "h",
        "H"
    ],
    "001": [
        "H",
        "h"
    ],
    "AL": [
        "h",
        "H",
        "hB"
    ],
    "TD": [
        "h",
        "H",
        "hB"
    ],
    "ca-ES": [
        "H",
        "h",
        "hB"
    ],
    "CF": [
        "H",
        "h",
        "hB"
    ],
    "CM": [
        "H",
        "h",
        "hB"
    ],
    "fr-CA": [
        "H",
        "h",
        "hB"
    ],
    "gl-ES": [
        "H",
        "h",
        "hB"
    ],
    "it-CH": [
        "H",
        "h",
        "hB"
    ],
    "it-IT": [
        "H",
        "h",
        "hB"
    ],
    "LU": [
        "H",
        "h",
        "hB"
    ],
    "NP": [
        "H",
        "h",
        "hB"
    ],
    "PF": [
        "H",
        "h",
        "hB"
    ],
    "SC": [
        "H",
        "h",
        "hB"
    ],
    "SM": [
        "H",
        "h",
        "hB"
    ],
    "SN": [
        "H",
        "h",
        "hB"
    ],
    "TF": [
        "H",
        "h",
        "hB"
    ],
    "VA": [
        "H",
        "h",
        "hB"
    ],
    "CY": [
        "h",
        "H",
        "hb",
        "hB"
    ],
    "GR": [
        "h",
        "H",
        "hb",
        "hB"
    ],
    "CO": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "DO": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "KP": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "KR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "NA": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "PA": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "PR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "VE": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "AC": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "AI": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "BW": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "BZ": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CC": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CX": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "DG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "FK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GB": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GI": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IE": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IM": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IO": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "JE": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "LT": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "MK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "MN": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "MS": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NF": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NR": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NU": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "PN": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "SH": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "SX": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "TA": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "ZA": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "af-ZA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "AR": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "CL": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "CR": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "CU": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "EA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-BO": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-BR": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-EC": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-ES": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-GQ": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-PE": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "GT": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "HN": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "IC": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "KG": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "KM": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "LK": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "MA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "MX": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "NI": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "PY": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "SV": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "UY": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "JP": [
        "H",
        "h",
        "K"
    ],
    "AD": [
        "H",
        "hB"
    ],
    "AM": [
        "H",
        "hB"
    ],
    "AO": [
        "H",
        "hB"
    ],
    "AT": [
        "H",
        "hB"
    ],
    "AW": [
        "H",
        "hB"
    ],
    "BE": [
        "H",
        "hB"
    ],
    "BF": [
        "H",
        "hB"
    ],
    "BJ": [
        "H",
        "hB"
    ],
    "BL": [
        "H",
        "hB"
    ],
    "BR": [
        "H",
        "hB"
    ],
    "CG": [
        "H",
        "hB"
    ],
    "CI": [
        "H",
        "hB"
    ],
    "CV": [
        "H",
        "hB"
    ],
    "DE": [
        "H",
        "hB"
    ],
    "EE": [
        "H",
        "hB"
    ],
    "FR": [
        "H",
        "hB"
    ],
    "GA": [
        "H",
        "hB"
    ],
    "GF": [
        "H",
        "hB"
    ],
    "GN": [
        "H",
        "hB"
    ],
    "GP": [
        "H",
        "hB"
    ],
    "GW": [
        "H",
        "hB"
    ],
    "HR": [
        "H",
        "hB"
    ],
    "IL": [
        "H",
        "hB"
    ],
    "IT": [
        "H",
        "hB"
    ],
    "KZ": [
        "H",
        "hB"
    ],
    "MC": [
        "H",
        "hB"
    ],
    "MD": [
        "H",
        "hB"
    ],
    "MF": [
        "H",
        "hB"
    ],
    "MQ": [
        "H",
        "hB"
    ],
    "MZ": [
        "H",
        "hB"
    ],
    "NC": [
        "H",
        "hB"
    ],
    "NL": [
        "H",
        "hB"
    ],
    "PM": [
        "H",
        "hB"
    ],
    "PT": [
        "H",
        "hB"
    ],
    "RE": [
        "H",
        "hB"
    ],
    "RO": [
        "H",
        "hB"
    ],
    "SI": [
        "H",
        "hB"
    ],
    "SR": [
        "H",
        "hB"
    ],
    "ST": [
        "H",
        "hB"
    ],
    "TG": [
        "H",
        "hB"
    ],
    "TR": [
        "H",
        "hB"
    ],
    "WF": [
        "H",
        "hB"
    ],
    "YT": [
        "H",
        "hB"
    ],
    "BD": [
        "h",
        "hB",
        "H"
    ],
    "PK": [
        "h",
        "hB",
        "H"
    ],
    "AZ": [
        "H",
        "hB",
        "h"
    ],
    "BA": [
        "H",
        "hB",
        "h"
    ],
    "BG": [
        "H",
        "hB",
        "h"
    ],
    "CH": [
        "H",
        "hB",
        "h"
    ],
    "GE": [
        "H",
        "hB",
        "h"
    ],
    "LI": [
        "H",
        "hB",
        "h"
    ],
    "ME": [
        "H",
        "hB",
        "h"
    ],
    "RS": [
        "H",
        "hB",
        "h"
    ],
    "UA": [
        "H",
        "hB",
        "h"
    ],
    "UZ": [
        "H",
        "hB",
        "h"
    ],
    "XK": [
        "H",
        "hB",
        "h"
    ],
    "AG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "AU": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BB": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BS": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "CA": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "DM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "en-001": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "FJ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "FM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GD": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GU": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GY": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "JM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KI": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KN": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KY": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "LC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "LR": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MH": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MP": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MW": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "NZ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SB": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SL": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SS": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SZ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "TC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "TT": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "UM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "US": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VI": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "ZM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BO": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "EC": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "ES": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "GQ": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "PE": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "AE": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "ar-001": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "BH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "DZ": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "EG": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "EH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "HK": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "IQ": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "JO": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "KW": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "LB": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "LY": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "MO": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "MR": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "OM": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "PH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "PS": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "QA": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SA": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SD": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SY": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "TN": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "YE": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "AF": [
        "H",
        "hb",
        "hB",
        "h"
    ],
    "LA": [
        "H",
        "hb",
        "hB",
        "h"
    ],
    "CN": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "LV": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "TL": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "zu-ZA": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "CD": [
        "hB",
        "H"
    ],
    "IR": [
        "hB",
        "H"
    ],
    "hi-IN": [
        "hB",
        "h",
        "H"
    ],
    "kn-IN": [
        "hB",
        "h",
        "H"
    ],
    "ml-IN": [
        "hB",
        "h",
        "H"
    ],
    "te-IN": [
        "hB",
        "h",
        "H"
    ],
    "KH": [
        "hB",
        "h",
        "H",
        "hb"
    ],
    "ta-IN": [
        "hB",
        "h",
        "hb",
        "H"
    ],
    "BN": [
        "hb",
        "hB",
        "h",
        "H"
    ],
    "MY": [
        "hb",
        "hB",
        "h",
        "H"
    ],
    "ET": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "gu-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "mr-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "pa-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "TW": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "KE": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "MM": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "TZ": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "UG": [
        "hB",
        "hb",
        "H",
        "h"
    ]
};

});




parcelRegister("ar8lY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7992e7cf30f6f781$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "strategies", function () { return $7992e7cf30f6f781$export$c5491a8691a23b9e; });
//
// Main
//
function $7992e7cf30f6f781$export$2e2bcd8739ae039(fn, options) {
    var cache = options && options.cache ? options.cache : $7992e7cf30f6f781$var$cacheDefault;
    var serializer = options && options.serializer ? options.serializer : $7992e7cf30f6f781$var$serializerDefault;
    var strategy = options && options.strategy ? options.strategy : $7992e7cf30f6f781$var$strategyDefault;
    return strategy(fn, {
        cache: cache,
        serializer: serializer
    });
}
//
// Strategy
//
function $7992e7cf30f6f781$var$isPrimitive(value) {
    return value == null || typeof value === "number" || typeof value === "boolean"; // || typeof value === "string" 'unsafe' primitive for our needs
}
function $7992e7cf30f6f781$var$monadic(fn, cache, serializer, arg) {
    var cacheKey = $7992e7cf30f6f781$var$isPrimitive(arg) ? arg : serializer(arg);
    var computedValue = cache.get(cacheKey);
    if (typeof computedValue === "undefined") {
        computedValue = fn.call(this, arg);
        cache.set(cacheKey, computedValue);
    }
    return computedValue;
}
function $7992e7cf30f6f781$var$variadic(fn, cache, serializer) {
    var args = Array.prototype.slice.call(arguments, 3);
    var cacheKey = serializer(args);
    var computedValue = cache.get(cacheKey);
    if (typeof computedValue === "undefined") {
        computedValue = fn.apply(this, args);
        cache.set(cacheKey, computedValue);
    }
    return computedValue;
}
function $7992e7cf30f6f781$var$assemble(fn, context, strategy, cache, serialize) {
    return strategy.bind(context, fn, cache, serialize);
}
function $7992e7cf30f6f781$var$strategyDefault(fn, options) {
    var strategy = fn.length === 1 ? $7992e7cf30f6f781$var$monadic : $7992e7cf30f6f781$var$variadic;
    return $7992e7cf30f6f781$var$assemble(fn, this, strategy, options.cache.create(), options.serializer);
}
function $7992e7cf30f6f781$var$strategyVariadic(fn, options) {
    return $7992e7cf30f6f781$var$assemble(fn, this, $7992e7cf30f6f781$var$variadic, options.cache.create(), options.serializer);
}
function $7992e7cf30f6f781$var$strategyMonadic(fn, options) {
    return $7992e7cf30f6f781$var$assemble(fn, this, $7992e7cf30f6f781$var$monadic, options.cache.create(), options.serializer);
}
//
// Serializer
//
var $7992e7cf30f6f781$var$serializerDefault = function() {
    return JSON.stringify(arguments);
};
//
// Cache
//
function $7992e7cf30f6f781$var$ObjectWithoutPrototypeCache() {
    this.cache = Object.create(null);
}
$7992e7cf30f6f781$var$ObjectWithoutPrototypeCache.prototype.get = function(key) {
    return this.cache[key];
};
$7992e7cf30f6f781$var$ObjectWithoutPrototypeCache.prototype.set = function(key, value) {
    this.cache[key] = value;
};
var $7992e7cf30f6f781$var$cacheDefault = {
    create: function create() {
        // @ts-ignore
        return new $7992e7cf30f6f781$var$ObjectWithoutPrototypeCache();
    }
};
var $7992e7cf30f6f781$export$c5491a8691a23b9e = {
    variadic: $7992e7cf30f6f781$var$strategyVariadic,
    monadic: $7992e7cf30f6f781$var$strategyMonadic
};

});

parcelRegister("l1ayF", function(module, exports) {

$parcel$export(module.exports, "PART_TYPE", function () { return $f4d1e19d68205d9b$export$49694c2877b44c57; });
$parcel$export(module.exports, "isFormatXMLElementFn", function () { return $f4d1e19d68205d9b$export$df0c12a2d414a163; });
$parcel$export(module.exports, "formatToParts", function () { return $f4d1e19d68205d9b$export$275d4a3bb5f66fda; });
parcelRequire("fcnnD");
var $bOKth = parcelRequire("bOKth");

var $71hur = parcelRequire("71hur");
var $f4d1e19d68205d9b$export$49694c2877b44c57;
(function(PART_TYPE) {
    PART_TYPE[PART_TYPE["literal"] = 0] = "literal";
    PART_TYPE[PART_TYPE["object"] = 1] = "object";
})($f4d1e19d68205d9b$export$49694c2877b44c57 || ($f4d1e19d68205d9b$export$49694c2877b44c57 = {}));
function $f4d1e19d68205d9b$var$mergeLiteral(parts) {
    if (parts.length < 2) return parts;
    return parts.reduce(function(all, part) {
        var lastPart = all[all.length - 1];
        if (!lastPart || lastPart.type !== $f4d1e19d68205d9b$export$49694c2877b44c57.literal || part.type !== $f4d1e19d68205d9b$export$49694c2877b44c57.literal) all.push(part);
        else lastPart.value += part.value;
        return all;
    }, []);
}
function $f4d1e19d68205d9b$export$df0c12a2d414a163(el) {
    return typeof el === "function";
}
function $f4d1e19d68205d9b$export$275d4a3bb5f66fda(els, locales, formatters, formats, values, currentPluralValue, // For debugging
originalMessage) {
    // Hot path for straight simple msg translations
    if (els.length === 1 && (0, $bOKth.isLiteralElement)(els[0])) return [
        {
            type: $f4d1e19d68205d9b$export$49694c2877b44c57.literal,
            value: els[0].value
        }
    ];
    var result = [];
    for(var _i = 0, els_1 = els; _i < els_1.length; _i++){
        var el = els_1[_i];
        // Exit early for string parts.
        if ((0, $bOKth.isLiteralElement)(el)) {
            result.push({
                type: $f4d1e19d68205d9b$export$49694c2877b44c57.literal,
                value: el.value
            });
            continue;
        }
        // TODO: should this part be literal type?
        // Replace `#` in plural rules with the actual numeric value.
        if ((0, $bOKth.isPoundElement)(el)) {
            if (typeof currentPluralValue === "number") result.push({
                type: $f4d1e19d68205d9b$export$49694c2877b44c57.literal,
                value: formatters.getNumberFormat(locales).format(currentPluralValue)
            });
            continue;
        }
        var varName = el.value;
        // Enforce that all required values are provided by the caller.
        if (!(values && varName in values)) throw new (0, $71hur.MissingValueError)(varName, originalMessage);
        var value = values[varName];
        if ((0, $bOKth.isArgumentElement)(el)) {
            if (!value || typeof value === "string" || typeof value === "number") value = typeof value === "string" || typeof value === "number" ? String(value) : "";
            result.push({
                type: typeof value === "string" ? $f4d1e19d68205d9b$export$49694c2877b44c57.literal : $f4d1e19d68205d9b$export$49694c2877b44c57.object,
                value: value
            });
            continue;
        }
        // Recursively format plural and select parts' option — which can be a
        // nested pattern structure. The choosing of the option to use is
        // abstracted-by and delegated-to the part helper object.
        if ((0, $bOKth.isDateElement)(el)) {
            var style = typeof el.style === "string" ? formats.date[el.style] : (0, $bOKth.isDateTimeSkeleton)(el.style) ? el.style.parsedOptions : undefined;
            result.push({
                type: $f4d1e19d68205d9b$export$49694c2877b44c57.literal,
                value: formatters.getDateTimeFormat(locales, style).format(value)
            });
            continue;
        }
        if ((0, $bOKth.isTimeElement)(el)) {
            var style = typeof el.style === "string" ? formats.time[el.style] : (0, $bOKth.isDateTimeSkeleton)(el.style) ? el.style.parsedOptions : formats.time.medium;
            result.push({
                type: $f4d1e19d68205d9b$export$49694c2877b44c57.literal,
                value: formatters.getDateTimeFormat(locales, style).format(value)
            });
            continue;
        }
        if ((0, $bOKth.isNumberElement)(el)) {
            var style = typeof el.style === "string" ? formats.number[el.style] : (0, $bOKth.isNumberSkeleton)(el.style) ? el.style.parsedOptions : undefined;
            if (style && style.scale) value = value * (style.scale || 1);
            result.push({
                type: $f4d1e19d68205d9b$export$49694c2877b44c57.literal,
                value: formatters.getNumberFormat(locales, style).format(value)
            });
            continue;
        }
        if ((0, $bOKth.isTagElement)(el)) {
            var children = el.children, value_1 = el.value;
            var formatFn = values[value_1];
            if (!$f4d1e19d68205d9b$export$df0c12a2d414a163(formatFn)) throw new (0, $71hur.InvalidValueTypeError)(value_1, "function", originalMessage);
            var parts = $f4d1e19d68205d9b$export$275d4a3bb5f66fda(children, locales, formatters, formats, values, currentPluralValue);
            var chunks = formatFn(parts.map(function(p) {
                return p.value;
            }));
            if (!Array.isArray(chunks)) chunks = [
                chunks
            ];
            result.push.apply(result, chunks.map(function(c) {
                return {
                    type: typeof c === "string" ? $f4d1e19d68205d9b$export$49694c2877b44c57.literal : $f4d1e19d68205d9b$export$49694c2877b44c57.object,
                    value: c
                };
            }));
        }
        if ((0, $bOKth.isSelectElement)(el)) {
            var opt = el.options[value] || el.options.other;
            if (!opt) throw new (0, $71hur.InvalidValueError)(el.value, value, Object.keys(el.options), originalMessage);
            result.push.apply(result, $f4d1e19d68205d9b$export$275d4a3bb5f66fda(opt.value, locales, formatters, formats, values));
            continue;
        }
        if ((0, $bOKth.isPluralElement)(el)) {
            var opt = el.options["=".concat(value)];
            if (!opt) {
                if (!Intl.PluralRules) throw new (0, $71hur.FormatError)('Intl.PluralRules is not available in this environment.\nTry polyfilling it using "@formatjs/intl-pluralrules"\n', (0, $71hur.ErrorCode).MISSING_INTL_API, originalMessage);
                var rule = formatters.getPluralRules(locales, {
                    type: el.pluralType
                }).select(value - (el.offset || 0));
                opt = el.options[rule] || el.options.other;
            }
            if (!opt) throw new (0, $71hur.InvalidValueError)(el.value, value, Object.keys(el.options), originalMessage);
            result.push.apply(result, $f4d1e19d68205d9b$export$275d4a3bb5f66fda(opt.value, locales, formatters, formats, values, value - (el.offset || 0)));
            continue;
        }
    }
    return $f4d1e19d68205d9b$var$mergeLiteral(result);
}

});
parcelRegister("71hur", function(module, exports) {

$parcel$export(module.exports, "ErrorCode", function () { return $51c63191f7a33d6b$export$d4e71bc0b80dc0fb; });
$parcel$export(module.exports, "FormatError", function () { return $51c63191f7a33d6b$export$7369836851cc1329; });
$parcel$export(module.exports, "InvalidValueError", function () { return $51c63191f7a33d6b$export$565c3afc07dfa382; });
$parcel$export(module.exports, "InvalidValueTypeError", function () { return $51c63191f7a33d6b$export$cbc0db47c750f7c9; });
$parcel$export(module.exports, "MissingValueError", function () { return $51c63191f7a33d6b$export$8bfc137e4d23fdf0; });

var $evtaG = parcelRequire("evtaG");
var $51c63191f7a33d6b$export$d4e71bc0b80dc0fb;
(function(ErrorCode) {
    // When we have a placeholder but no value to format
    ErrorCode["MISSING_VALUE"] = "MISSING_VALUE";
    // When value supplied is invalid
    ErrorCode["INVALID_VALUE"] = "INVALID_VALUE";
    // When we need specific Intl API but it's not available
    ErrorCode["MISSING_INTL_API"] = "MISSING_INTL_API";
})($51c63191f7a33d6b$export$d4e71bc0b80dc0fb || ($51c63191f7a33d6b$export$d4e71bc0b80dc0fb = {}));
var $51c63191f7a33d6b$export$7369836851cc1329 = /** @class */ function(_super) {
    (0, $evtaG.__extends)(FormatError, _super);
    function FormatError(msg, code, originalMessage) {
        var _this = _super.call(this, msg) || this;
        _this.code = code;
        _this.originalMessage = originalMessage;
        return _this;
    }
    FormatError.prototype.toString = function() {
        return "[formatjs Error: ".concat(this.code, "] ").concat(this.message);
    };
    return FormatError;
}(Error);
var $51c63191f7a33d6b$export$565c3afc07dfa382 = /** @class */ function(_super) {
    (0, $evtaG.__extends)(InvalidValueError, _super);
    function InvalidValueError(variableId, value, options, originalMessage) {
        return _super.call(this, 'Invalid values for "'.concat(variableId, '": "').concat(value, '". Options are "').concat(Object.keys(options).join('", "'), '"'), $51c63191f7a33d6b$export$d4e71bc0b80dc0fb.INVALID_VALUE, originalMessage) || this;
    }
    return InvalidValueError;
}($51c63191f7a33d6b$export$7369836851cc1329);
var $51c63191f7a33d6b$export$cbc0db47c750f7c9 = /** @class */ function(_super) {
    (0, $evtaG.__extends)(InvalidValueTypeError, _super);
    function InvalidValueTypeError(value, type, originalMessage) {
        return _super.call(this, 'Value for "'.concat(value, '" must be of type ').concat(type), $51c63191f7a33d6b$export$d4e71bc0b80dc0fb.INVALID_VALUE, originalMessage) || this;
    }
    return InvalidValueTypeError;
}($51c63191f7a33d6b$export$7369836851cc1329);
var $51c63191f7a33d6b$export$8bfc137e4d23fdf0 = /** @class */ function(_super) {
    (0, $evtaG.__extends)(MissingValueError, _super);
    function MissingValueError(variableId, originalMessage) {
        return _super.call(this, 'The intl string context variable "'.concat(variableId, '" was not provided to the string "').concat(originalMessage, '"'), $51c63191f7a33d6b$export$d4e71bc0b80dc0fb.MISSING_VALUE, originalMessage) || this;
    }
    return MissingValueError;
}($51c63191f7a33d6b$export$7369836851cc1329);

});



parcelRegister("5Ygy2", function(module, exports) {

$parcel$export(module.exports, "IntlErrorCode", function () { return $458f6472b4f2f49b$export$557d6acb76e8a244; });
$parcel$export(module.exports, "IntlError", function () { return $458f6472b4f2f49b$export$c016d36112f6ddf8; });
$parcel$export(module.exports, "UnsupportedFormatterError", function () { return $458f6472b4f2f49b$export$549f97e137a05c90; });
$parcel$export(module.exports, "InvalidConfigError", function () { return $458f6472b4f2f49b$export$3ca04dd7fb305893; });
$parcel$export(module.exports, "MissingDataError", function () { return $458f6472b4f2f49b$export$c1eaf877d81384b6; });
$parcel$export(module.exports, "IntlFormatError", function () { return $458f6472b4f2f49b$export$e3b7eee1dbc44895; });
$parcel$export(module.exports, "MessageFormatError", function () { return $458f6472b4f2f49b$export$74a601a3d3f31621; });
$parcel$export(module.exports, "MissingTranslationError", function () { return $458f6472b4f2f49b$export$2ddcb436d0aa3688; });

var $evtaG = parcelRequire("evtaG");
var $458f6472b4f2f49b$export$557d6acb76e8a244;
(function(IntlErrorCode) {
    IntlErrorCode["FORMAT_ERROR"] = "FORMAT_ERROR";
    IntlErrorCode["UNSUPPORTED_FORMATTER"] = "UNSUPPORTED_FORMATTER";
    IntlErrorCode["INVALID_CONFIG"] = "INVALID_CONFIG";
    IntlErrorCode["MISSING_DATA"] = "MISSING_DATA";
    IntlErrorCode["MISSING_TRANSLATION"] = "MISSING_TRANSLATION";
})($458f6472b4f2f49b$export$557d6acb76e8a244 || ($458f6472b4f2f49b$export$557d6acb76e8a244 = {}));
var $458f6472b4f2f49b$export$c016d36112f6ddf8 = /** @class */ function(_super) {
    (0, $evtaG.__extends)(IntlError, _super);
    function IntlError(code, message, exception) {
        var _this = this;
        var err = exception ? exception instanceof Error ? exception : new Error(String(exception)) : undefined;
        _this = _super.call(this, "[@formatjs/intl Error ".concat(code, "] ").concat(message, " \n").concat(err ? "\n".concat(err.message, "\n").concat(err.stack) : "")) || this;
        _this.code = code;
        // @ts-ignore just so we don't need to declare dep on @types/node
        if (typeof Error.captureStackTrace === "function") // @ts-ignore just so we don't need to declare dep on @types/node
        Error.captureStackTrace(_this, IntlError);
        return _this;
    }
    return IntlError;
}(Error);
var $458f6472b4f2f49b$export$549f97e137a05c90 = /** @class */ function(_super) {
    (0, $evtaG.__extends)(UnsupportedFormatterError, _super);
    function UnsupportedFormatterError(message, exception) {
        return _super.call(this, $458f6472b4f2f49b$export$557d6acb76e8a244.UNSUPPORTED_FORMATTER, message, exception) || this;
    }
    return UnsupportedFormatterError;
}($458f6472b4f2f49b$export$c016d36112f6ddf8);
var $458f6472b4f2f49b$export$3ca04dd7fb305893 = /** @class */ function(_super) {
    (0, $evtaG.__extends)(InvalidConfigError, _super);
    function InvalidConfigError(message, exception) {
        return _super.call(this, $458f6472b4f2f49b$export$557d6acb76e8a244.INVALID_CONFIG, message, exception) || this;
    }
    return InvalidConfigError;
}($458f6472b4f2f49b$export$c016d36112f6ddf8);
var $458f6472b4f2f49b$export$c1eaf877d81384b6 = /** @class */ function(_super) {
    (0, $evtaG.__extends)(MissingDataError, _super);
    function MissingDataError(message, exception) {
        return _super.call(this, $458f6472b4f2f49b$export$557d6acb76e8a244.MISSING_DATA, message, exception) || this;
    }
    return MissingDataError;
}($458f6472b4f2f49b$export$c016d36112f6ddf8);
var $458f6472b4f2f49b$export$e3b7eee1dbc44895 = /** @class */ function(_super) {
    (0, $evtaG.__extends)(IntlFormatError, _super);
    function IntlFormatError(message, locale, exception) {
        return _super.call(this, $458f6472b4f2f49b$export$557d6acb76e8a244.FORMAT_ERROR, "".concat(message, " \nLocale: ").concat(locale, "\n"), exception) || this;
    }
    return IntlFormatError;
}($458f6472b4f2f49b$export$c016d36112f6ddf8);
var $458f6472b4f2f49b$export$74a601a3d3f31621 = /** @class */ function(_super) {
    (0, $evtaG.__extends)(MessageFormatError, _super);
    function MessageFormatError(message, locale, descriptor, exception) {
        var _this = _super.call(this, "".concat(message, " \nMessageID: ").concat(descriptor === null || descriptor === void 0 ? void 0 : descriptor.id, "\nDefault Message: ").concat(descriptor === null || descriptor === void 0 ? void 0 : descriptor.defaultMessage, "\nDescription: ").concat(descriptor === null || descriptor === void 0 ? void 0 : descriptor.description, " \n"), locale, exception) || this;
        _this.descriptor = descriptor;
        return _this;
    }
    return MessageFormatError;
}($458f6472b4f2f49b$export$e3b7eee1dbc44895);
var $458f6472b4f2f49b$export$2ddcb436d0aa3688 = /** @class */ function(_super) {
    (0, $evtaG.__extends)(MissingTranslationError, _super);
    function MissingTranslationError(descriptor, locale) {
        var _this = _super.call(this, $458f6472b4f2f49b$export$557d6acb76e8a244.MISSING_TRANSLATION, 'Missing message: "'.concat(descriptor.id, '" for locale "').concat(locale, '", using ').concat(descriptor.defaultMessage ? "default message" : "id", " as fallback.")) || this;
        _this.descriptor = descriptor;
        return _this;
    }
    return MissingTranslationError;
}($458f6472b4f2f49b$export$c016d36112f6ddf8);

});






parcelRegister("lUIfp", function(module, exports) {
module.exports = new URL("svg-error-window.ffce7d1e.svg", import.meta.url).toString();

});

parcelRegister("cSdLY", function(module, exports) {

$parcel$export(module.exports, "ErrorImage", function () { return $8806c699fe2cf862$export$7326e6d938a8137b; });
$parcel$export(module.exports, "Container", function () { return $8806c699fe2cf862$export$42a852a2b6b56249; });
$parcel$export(module.exports, "ImageOuter", function () { return $8806c699fe2cf862$export$6cce79b2fcc860dc; });
$parcel$export(module.exports, "TitleWrapper", function () { return $8806c699fe2cf862$export$585a3b23e887288b; });
$parcel$export(module.exports, "ButtonContainer", function () { return $8806c699fe2cf862$export$eddf54ea3db8d0f0; });
$parcel$export(module.exports, "Title", function () { return $8806c699fe2cf862$export$f99233281efd08a0; });
$parcel$export(module.exports, "DescriptionWrapper", function () { return $8806c699fe2cf862$export$2bf1f2b0d31b60fc; });
$parcel$export(module.exports, "Description", function () { return $8806c699fe2cf862$export$393edc798c47379d; });
$parcel$export(module.exports, "ErrorTextContainer", function () { return $8806c699fe2cf862$export$5086488b1ac4411e; });

var $ku6eE = parcelRequire("ku6eE");

var $5MUVm = parcelRequire("5MUVm");

var $gbKg7 = parcelRequire("gbKg7");
const $8806c699fe2cf862$export$7326e6d938a8137b = (0, $ku6eE.default).img`
  width: 263px;
  margin: 0 0 56px 0;
  display: flex;
`;
const $8806c699fe2cf862$export$42a852a2b6b56249 = (0, $ku6eE.default).div`
  align-items: center;
  justify-content: center;
  display: flex;
  flex-wrap: wrap;
  margin: 100px auto 0;
  max-width: 600px;
  flex-direction: column;

  @media (max-width: 640px) {
    flex-direction: column;
  }
`;
const $8806c699fe2cf862$export$6cce79b2fcc860dc = (0, $ku6eE.default).div`
  flex: none;
  flex-basis: 200px;
  justify-content: center;

  @media (max-width: 640px) {
    margin-right: 0;
    flex-basis: auto;

    & img {
      max-width: 100%;
      padding: 0 24px;
    }
  }
`;
const $8806c699fe2cf862$export$585a3b23e887288b = (0, $ku6eE.default).div`
  display: flex;
  margin-bottom: 12px;

  @media (max-width: 640px) {
    text-align: center;
  }
`;
const $8806c699fe2cf862$export$eddf54ea3db8d0f0 = (0, $ku6eE.default).div`
  display: flex;
  justify-content: center;
  text-align: center;
  margin-top: 16px;
`;
const $8806c699fe2cf862$export$f99233281efd08a0 = (0, $ku6eE.default).h1``;
const $8806c699fe2cf862$export$2bf1f2b0d31b60fc = (0, $ku6eE.default).div`
  display: flex;
  flex-wrap: wrap;
`;
const $8806c699fe2cf862$export$393edc798c47379d = (0, $ku6eE.default).p`
  font-size: 1em;
  line-height: 24px;
  color: ${(0, $gbKg7.default)("color.text", (0, $5MUVm).N800)};

  @media (max-width: 640px) {
    text-align: center;
  }
`;
const $8806c699fe2cf862$export$5086488b1ac4411e = (0, $ku6eE.default).div`
  display: flex;
  justify-content: center;
  text-align: center;
  flex-wrap: wrap;
  width: 80%;
  flex-direction: column;
  align-items: center;

  @media (max-width: 640px) {
    max-width: 304px;
    width: 100%;
  }
`;

});



parcelRegister("7M9Ou", function(module, exports) {

$parcel$export(module.exports, "default", function () { return (parcelRequire("8zYsB")).default; });

var $8zYsB = parcelRequire("8zYsB");

});
parcelRegister("8zYsB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $394b3f5a7ddcaf6c$export$2e2bcd8739ae039; });
parcelRequire("jQGCp");
var $7PWYP = parcelRequire("7PWYP");

var $5g4S5 = parcelRequire("5g4S5");
var $394b3f5a7ddcaf6c$export$2e2bcd8739ae039 = (0, $7PWYP.default)()((0, $5g4S5.default));

});
parcelRegister("jQGCp", function(module, exports) {

$parcel$export(module.exports, "Provider", function () { return (parcelRequire("72LdD")).default; });
$parcel$export(module.exports, "connect", function () { return (parcelRequire("7PWYP")).default; });

var $72LdD = parcelRequire("72LdD");

var $hSeZM = parcelRequire("hSeZM");

var $c705f = parcelRequire("c705f");

var $7PWYP = parcelRequire("7PWYP");

});
parcelRegister("72LdD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $520d58fe971bff86$export$2e2bcd8739ae039; });

var $fGuus = parcelRequire("fGuus");

var $dAx5m = parcelRequire("dAx5m");

var $hyn2k = parcelRequire("hyn2k");

var $c705f = parcelRequire("c705f");
var $520d58fe971bff86$var$Provider = /*#__PURE__*/ function(_Component) {
    (0, $fGuus.default)(Provider, _Component);
    function Provider(props) {
        var _this;
        _this = _Component.call(this, props) || this;
        var store = props.store;
        _this.state = {
            storeState: store.getState(),
            store: store
        };
        return _this;
    }
    var _proto = Provider.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this._isMounted = true;
        this.subscribe();
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        if (this.unsubscribe) this.unsubscribe();
        this._isMounted = false;
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        if (this.props.store !== prevProps.store) {
            if (this.unsubscribe) this.unsubscribe();
            this.subscribe();
        }
    };
    _proto.subscribe = function subscribe() {
        var _this2 = this;
        var store = this.props.store;
        this.unsubscribe = store.subscribe(function() {
            var newStoreState = store.getState();
            if (!_this2._isMounted) return;
            _this2.setState(function(providerState) {
                // If the value is the same, skip the unnecessary state update.
                if (providerState.storeState === newStoreState) return null;
                return {
                    storeState: newStoreState
                };
            });
        }); // Actions might have been dispatched between render and mount - handle those
        var postMountStoreState = store.getState();
        if (postMountStoreState !== this.state.storeState) this.setState({
            storeState: postMountStoreState
        });
    };
    _proto.render = function render() {
        var Context = this.props.context || (0, $c705f.ReactReduxContext);
        return (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement(Context.Provider, {
            value: this.state
        }, this.props.children);
    };
    return Provider;
}((0, $dAx5m.Component));
$520d58fe971bff86$var$Provider.propTypes = {
    store: (0, (/*@__PURE__*/$parcel$interopDefault($hyn2k))).shape({
        subscribe: (0, (/*@__PURE__*/$parcel$interopDefault($hyn2k))).func.isRequired,
        dispatch: (0, (/*@__PURE__*/$parcel$interopDefault($hyn2k))).func.isRequired,
        getState: (0, (/*@__PURE__*/$parcel$interopDefault($hyn2k))).func.isRequired
    }),
    context: (0, (/*@__PURE__*/$parcel$interopDefault($hyn2k))).object,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($hyn2k))).any
};
var $520d58fe971bff86$export$2e2bcd8739ae039 = $520d58fe971bff86$var$Provider;

});
parcelRegister("fGuus", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b6b26dfd306e0e88$export$2e2bcd8739ae039; });

var $yGcYQ = parcelRequire("yGcYQ");
function $b6b26dfd306e0e88$export$2e2bcd8739ae039(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    (0, $yGcYQ.default)(subClass, superClass);
}

});
parcelRegister("yGcYQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0683eacab3648c29$export$2e2bcd8739ae039; });
function $0683eacab3648c29$export$2e2bcd8739ae039(o, p) {
    $0683eacab3648c29$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $0683eacab3648c29$export$2e2bcd8739ae039(o, p);
}

});


parcelRegister("c705f", function(module, exports) {

$parcel$export(module.exports, "ReactReduxContext", function () { return $8d1634198d0db56f$export$cc80c08dc91f1c00; });

var $dAx5m = parcelRequire("dAx5m");
var $8d1634198d0db56f$export$cc80c08dc91f1c00 = (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createContext(null);
var $8d1634198d0db56f$export$2e2bcd8739ae039 = $8d1634198d0db56f$export$cc80c08dc91f1c00;

});


parcelRegister("hSeZM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d0331c99fb0bfd82$export$2e2bcd8739ae039; });

var $jvip8 = parcelRequire("jvip8");

var $fGuus = parcelRequire("fGuus");

var $6Sryg = parcelRequire("6Sryg");

var $jKAjj = parcelRequire("jKAjj");

var $NP1E6 = parcelRequire("NP1E6");

var $leV3H = parcelRequire("leV3H");

var $dAx5m = parcelRequire("dAx5m");

var $cGNdg = parcelRequire("cGNdg");

var $c705f = parcelRequire("c705f");
var $d0331c99fb0bfd82$var$stringifyComponent = function stringifyComponent(Comp) {
    try {
        return JSON.stringify(Comp);
    } catch (err) {
        return String(Comp);
    }
};
function $d0331c99fb0bfd82$export$2e2bcd8739ae039(/*
  selectorFactory is a func that is responsible for returning the selector function used to
  compute new props from state, props, and dispatch. For example:
     export default connectAdvanced((dispatch, options) => (state, props) => ({
      thing: state.things[props.thingId],
      saveThing: fields => dispatch(actionCreators.saveThing(props.thingId, fields)),
    }))(YourComponent)
   Access to dispatch is provided to the factory so selectorFactories can bind actionCreators
  outside of their selector as an optimization. Options passed to connectAdvanced are passed to
  the selectorFactory, along with displayName and WrappedComponent, as the second argument.
   Note that selectorFactory is responsible for all caching/memoization of inbound and outbound
  props. Do not use connectAdvanced directly without memoizing results between calls to your
  selector, otherwise the Connect component will re-render on every state or props change.
*/ selectorFactory, _ref) {
    if (_ref === void 0) _ref = {};
    var _ref2 = _ref, _ref2$getDisplayName = _ref2.getDisplayName, getDisplayName = _ref2$getDisplayName === void 0 ? function(name) {
        return "ConnectAdvanced(" + name + ")";
    } : _ref2$getDisplayName, _ref2$methodName = _ref2.methodName, methodName = _ref2$methodName === void 0 ? "connectAdvanced" : _ref2$methodName, _ref2$renderCountProp = _ref2.renderCountProp, renderCountProp = _ref2$renderCountProp === void 0 ? undefined : _ref2$renderCountProp, _ref2$shouldHandleSta = _ref2.shouldHandleStateChanges, shouldHandleStateChanges = _ref2$shouldHandleSta === void 0 ? true : _ref2$shouldHandleSta, _ref2$storeKey = _ref2.storeKey, storeKey = _ref2$storeKey === void 0 ? "store" : _ref2$storeKey, _ref2$withRef = _ref2.withRef, withRef = _ref2$withRef === void 0 ? false : _ref2$withRef, _ref2$forwardRef = _ref2.forwardRef, forwardRef = _ref2$forwardRef === void 0 ? false : _ref2$forwardRef, _ref2$context = _ref2.context, context = _ref2$context === void 0 ? (0, $c705f.ReactReduxContext) : _ref2$context, connectOptions = (0, $jKAjj.default)(_ref2, [
        "getDisplayName",
        "methodName",
        "renderCountProp",
        "shouldHandleStateChanges",
        "storeKey",
        "withRef",
        "forwardRef",
        "context"
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($leV3H)))(renderCountProp === undefined, "renderCountProp is removed. render counting is built into the latest React dev tools profiling extension");
    (0, (/*@__PURE__*/$parcel$interopDefault($leV3H)))(!withRef, "withRef is removed. To access the wrapped instance, use a ref on the connected component");
    var customStoreWarningMessage = "To use a custom Redux store for specific components,  create a custom React context with React.createContext(), and pass the context object to React Redux's Provider and specific components like:  <Provider context={MyContext}><ConnectedComponent context={MyContext} /></Provider>. You may also pass a {context : MyContext} option to connect";
    (0, (/*@__PURE__*/$parcel$interopDefault($leV3H)))(storeKey === "store", "storeKey has been removed and does not do anything. " + customStoreWarningMessage);
    var Context = context;
    return function wrapWithConnect(WrappedComponent) {
        var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || "Component";
        var displayName = getDisplayName(wrappedComponentName);
        var selectorFactoryOptions = (0, $6Sryg.default)({}, connectOptions, {
            getDisplayName: getDisplayName,
            methodName: methodName,
            renderCountProp: renderCountProp,
            shouldHandleStateChanges: shouldHandleStateChanges,
            storeKey: storeKey,
            displayName: displayName,
            wrappedComponentName: wrappedComponentName,
            WrappedComponent: WrappedComponent
        });
        var pure = connectOptions.pure;
        var OuterBaseComponent = (0, $dAx5m.Component);
        if (pure) OuterBaseComponent = (0, $dAx5m.PureComponent);
        function makeDerivedPropsSelector() {
            var lastProps;
            var lastState;
            var lastDerivedProps;
            var lastStore;
            var lastSelectorFactoryOptions;
            var sourceSelector;
            return function selectDerivedProps(state, props, store, selectorFactoryOptions) {
                if (pure && lastProps === props && lastState === state) return lastDerivedProps;
                if (store !== lastStore || lastSelectorFactoryOptions !== selectorFactoryOptions) {
                    lastStore = store;
                    lastSelectorFactoryOptions = selectorFactoryOptions;
                    sourceSelector = selectorFactory(store.dispatch, selectorFactoryOptions);
                }
                lastProps = props;
                lastState = state;
                var nextProps = sourceSelector(state, props);
                lastDerivedProps = nextProps;
                return lastDerivedProps;
            };
        }
        function makeChildElementSelector() {
            var lastChildProps, lastForwardRef, lastChildElement, lastComponent;
            return function selectChildElement(WrappedComponent, childProps, forwardRef) {
                if (childProps !== lastChildProps || forwardRef !== lastForwardRef || lastComponent !== WrappedComponent) {
                    lastChildProps = childProps;
                    lastForwardRef = forwardRef;
                    lastComponent = WrappedComponent;
                    lastChildElement = (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement(WrappedComponent, (0, $6Sryg.default)({}, childProps, {
                        ref: forwardRef
                    }));
                }
                return lastChildElement;
            };
        }
        var Connect = /*#__PURE__*/ function(_OuterBaseComponent) {
            (0, $fGuus.default)(Connect, _OuterBaseComponent);
            function Connect(props) {
                var _this;
                _this = _OuterBaseComponent.call(this, props) || this;
                (0, (/*@__PURE__*/$parcel$interopDefault($leV3H)))(forwardRef ? !props.wrapperProps[storeKey] : !props[storeKey], "Passing redux store in props has been removed and does not do anything. " + customStoreWarningMessage);
                _this.selectDerivedProps = makeDerivedPropsSelector();
                _this.selectChildElement = makeChildElementSelector();
                _this.indirectRenderWrappedComponent = _this.indirectRenderWrappedComponent.bind((0, $jvip8.default)(_this));
                return _this;
            }
            var _proto = Connect.prototype;
            _proto.indirectRenderWrappedComponent = function indirectRenderWrappedComponent(value) {
                // calling renderWrappedComponent on prototype from indirectRenderWrappedComponent bound to `this`
                return this.renderWrappedComponent(value);
            };
            _proto.renderWrappedComponent = function renderWrappedComponent(value) {
                (0, (/*@__PURE__*/$parcel$interopDefault($leV3H)))(value, 'Could not find "store" in the context of ' + ('"' + displayName + '". Either wrap the root component in a <Provider>, ') + "or pass a custom React context provider to <Provider> and the corresponding " + ("React context consumer to " + displayName + " in connect options."));
                var storeState = value.storeState, store = value.store;
                var wrapperProps = this.props;
                var forwardedRef;
                if (forwardRef) {
                    wrapperProps = this.props.wrapperProps;
                    forwardedRef = this.props.forwardedRef;
                }
                var derivedProps = this.selectDerivedProps(storeState, wrapperProps, store, selectorFactoryOptions);
                return this.selectChildElement(WrappedComponent, derivedProps, forwardedRef);
            };
            _proto.render = function render() {
                var ContextToUse = this.props.context && this.props.context.Consumer && (0, $cGNdg.isContextConsumer)((0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement(this.props.context.Consumer, null)) ? this.props.context : Context;
                return (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement(ContextToUse.Consumer, null, this.indirectRenderWrappedComponent);
            };
            return Connect;
        }(OuterBaseComponent);
        Connect.WrappedComponent = WrappedComponent;
        Connect.displayName = displayName;
        if (forwardRef) {
            var forwarded = (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).forwardRef(function forwardConnectRef(props, ref) {
                return (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement(Connect, {
                    wrapperProps: props,
                    forwardedRef: ref
                });
            });
            forwarded.displayName = displayName;
            forwarded.WrappedComponent = WrappedComponent;
            return (0, (/*@__PURE__*/$parcel$interopDefault($NP1E6)))(forwarded, WrappedComponent);
        }
        return (0, (/*@__PURE__*/$parcel$interopDefault($NP1E6)))(Connect, WrappedComponent);
    };
}

});
parcelRegister("jvip8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e32f304e70fd833e$export$2e2bcd8739ae039; });
function $e32f304e70fd833e$export$2e2bcd8739ae039(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}

});

parcelRegister("6Sryg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $501d28660fd60db3$export$2e2bcd8739ae039; });
function $501d28660fd60db3$export$2e2bcd8739ae039() {
    $501d28660fd60db3$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $501d28660fd60db3$export$2e2bcd8739ae039.apply(this, arguments);
}

});

parcelRegister("jKAjj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e60e7ab5bb987a34$export$2e2bcd8739ae039; });
function $e60e7ab5bb987a34$export$2e2bcd8739ae039(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}

});

parcelRegister("leV3H", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */ var $f7672a705367502f$var$invariant = function(condition, format, a, b, c, d, e, f) {
    if (!condition) {
        var error;
        if (format === undefined) error = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
        else {
            var args = [
                a,
                b,
                c,
                d,
                e,
                f
            ];
            var argIndex = 0;
            error = new Error(format.replace(/%s/g, function() {
                return args[argIndex++];
            }));
            error.name = "Invariant Violation";
        }
        error.framesToPop = 1; // we don't care about invariant's own frame
        throw error;
    }
};
module.exports = $f7672a705367502f$var$invariant;

});


parcelRegister("7PWYP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5b4b0c0600bfd923$export$2e2bcd8739ae039; });

var $6Sryg = parcelRequire("6Sryg");

var $jKAjj = parcelRequire("jKAjj");

var $hSeZM = parcelRequire("hSeZM");

var $48sGL = parcelRequire("48sGL");

var $hTBXl = parcelRequire("hTBXl");

var $foufz = parcelRequire("foufz");

var $5aXBy = parcelRequire("5aXBy");

var $kaRml = parcelRequire("kaRml");
/*
  connect is a facade over connectAdvanced. It turns its args into a compatible
  selectorFactory, which has the signature:

    (dispatch, options) => (nextState, nextOwnProps) => nextFinalProps
  
  connect passes its args to connectAdvanced as options, which will in turn pass them to
  selectorFactory each time a Connect component instance is instantiated or hot reloaded.

  selectorFactory returns a final props selector from its mapStateToProps,
  mapStateToPropsFactories, mapDispatchToProps, mapDispatchToPropsFactories, mergeProps,
  mergePropsFactories, and pure args.

  The resulting final props selector is called by the Connect component instance whenever
  it receives new props or store state.
 */ function $5b4b0c0600bfd923$var$match(arg, factories, name) {
    for(var i = factories.length - 1; i >= 0; i--){
        var result = factories[i](arg);
        if (result) return result;
    }
    return function(dispatch, options) {
        throw new Error("Invalid value of type " + typeof arg + " for " + name + " argument when connecting component " + options.wrappedComponentName + ".");
    };
}
function $5b4b0c0600bfd923$var$strictEqual(a, b) {
    return a === b;
} // createConnect with default args builds the 'official' connect behavior. Calling it with
function $5b4b0c0600bfd923$export$9f9feb656dec1fc4(_temp) {
    var _ref = _temp === void 0 ? {} : _temp, _ref$connectHOC = _ref.connectHOC, connectHOC = _ref$connectHOC === void 0 ? (0, $hSeZM.default) : _ref$connectHOC, _ref$mapStateToPropsF = _ref.mapStateToPropsFactories, mapStateToPropsFactories = _ref$mapStateToPropsF === void 0 ? (0, $foufz.default) : _ref$mapStateToPropsF, _ref$mapDispatchToPro = _ref.mapDispatchToPropsFactories, mapDispatchToPropsFactories = _ref$mapDispatchToPro === void 0 ? (0, $hTBXl.default) : _ref$mapDispatchToPro, _ref$mergePropsFactor = _ref.mergePropsFactories, mergePropsFactories = _ref$mergePropsFactor === void 0 ? (0, $5aXBy.default) : _ref$mergePropsFactor, _ref$selectorFactory = _ref.selectorFactory, selectorFactory = _ref$selectorFactory === void 0 ? (0, $kaRml.default) : _ref$selectorFactory;
    return function connect(mapStateToProps, mapDispatchToProps, mergeProps, _ref2) {
        if (_ref2 === void 0) _ref2 = {};
        var _ref3 = _ref2, _ref3$pure = _ref3.pure, pure = _ref3$pure === void 0 ? true : _ref3$pure, _ref3$areStatesEqual = _ref3.areStatesEqual, areStatesEqual = _ref3$areStatesEqual === void 0 ? $5b4b0c0600bfd923$var$strictEqual : _ref3$areStatesEqual, _ref3$areOwnPropsEqua = _ref3.areOwnPropsEqual, areOwnPropsEqual = _ref3$areOwnPropsEqua === void 0 ? (0, $48sGL.default) : _ref3$areOwnPropsEqua, _ref3$areStatePropsEq = _ref3.areStatePropsEqual, areStatePropsEqual = _ref3$areStatePropsEq === void 0 ? (0, $48sGL.default) : _ref3$areStatePropsEq, _ref3$areMergedPropsE = _ref3.areMergedPropsEqual, areMergedPropsEqual = _ref3$areMergedPropsE === void 0 ? (0, $48sGL.default) : _ref3$areMergedPropsE, extraOptions = (0, $jKAjj.default)(_ref3, [
            "pure",
            "areStatesEqual",
            "areOwnPropsEqual",
            "areStatePropsEqual",
            "areMergedPropsEqual"
        ]);
        var initMapStateToProps = $5b4b0c0600bfd923$var$match(mapStateToProps, mapStateToPropsFactories, "mapStateToProps");
        var initMapDispatchToProps = $5b4b0c0600bfd923$var$match(mapDispatchToProps, mapDispatchToPropsFactories, "mapDispatchToProps");
        var initMergeProps = $5b4b0c0600bfd923$var$match(mergeProps, mergePropsFactories, "mergeProps");
        return connectHOC(selectorFactory, (0, $6Sryg.default)({
            // used in error messages
            methodName: "connect",
            // used to compute Connect's displayName from the wrapped component's displayName.
            getDisplayName: function getDisplayName(name) {
                return "Connect(" + name + ")";
            },
            // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
            shouldHandleStateChanges: Boolean(mapStateToProps),
            // passed through to selectorFactory
            initMapStateToProps: initMapStateToProps,
            initMapDispatchToProps: initMapDispatchToProps,
            initMergeProps: initMergeProps,
            pure: pure,
            areStatesEqual: areStatesEqual,
            areOwnPropsEqual: areOwnPropsEqual,
            areStatePropsEqual: areStatePropsEqual,
            areMergedPropsEqual: areMergedPropsEqual
        }, extraOptions));
    };
}
var $5b4b0c0600bfd923$export$2e2bcd8739ae039 = $5b4b0c0600bfd923$export$9f9feb656dec1fc4();

});
parcelRegister("48sGL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $302e29c5ec127651$export$2e2bcd8739ae039; });
var $302e29c5ec127651$var$hasOwn = Object.prototype.hasOwnProperty;
function $302e29c5ec127651$var$is(x, y) {
    if (x === y) return x !== 0 || y !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function $302e29c5ec127651$export$2e2bcd8739ae039(objA, objB) {
    if ($302e29c5ec127651$var$is(objA, objB)) return true;
    if (typeof objA !== "object" || objA === null || typeof objB !== "object" || objB === null) return false;
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    for(var i = 0; i < keysA.length; i++){
        if (!$302e29c5ec127651$var$hasOwn.call(objB, keysA[i]) || !$302e29c5ec127651$var$is(objA[keysA[i]], objB[keysA[i]])) return false;
    }
    return true;
}

});

parcelRegister("hTBXl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d0750402e37def6c$export$2e2bcd8739ae039; });

var $6plgC = parcelRequire("6plgC");

var $5Bmrs = parcelRequire("5Bmrs");
function $d0750402e37def6c$export$a9f27b4b187c1166(mapDispatchToProps) {
    return typeof mapDispatchToProps === "function" ? (0, $5Bmrs.wrapMapToPropsFunc)(mapDispatchToProps, "mapDispatchToProps") : undefined;
}
function $d0750402e37def6c$export$ba20d1a7aa0c4a90(mapDispatchToProps) {
    return !mapDispatchToProps ? (0, $5Bmrs.wrapMapToPropsConstant)(function(dispatch) {
        return {
            dispatch: dispatch
        };
    }) : undefined;
}
function $d0750402e37def6c$export$94a6e55709d4d961(mapDispatchToProps) {
    return mapDispatchToProps && typeof mapDispatchToProps === "object" ? (0, $5Bmrs.wrapMapToPropsConstant)(function(dispatch) {
        return (0, $6plgC.bindActionCreators)(mapDispatchToProps, dispatch);
    }) : undefined;
}
var $d0750402e37def6c$export$2e2bcd8739ae039 = [
    $d0750402e37def6c$export$a9f27b4b187c1166,
    $d0750402e37def6c$export$ba20d1a7aa0c4a90,
    $d0750402e37def6c$export$94a6e55709d4d961
];

});
parcelRegister("6plgC", function(module, exports) {

$parcel$export(module.exports, "createStore", function () { return $4aa593147952e3a9$export$f51a9068ac82ea43; });
$parcel$export(module.exports, "combineReducers", function () { return $4aa593147952e3a9$export$66e4520cdb265d18; });
$parcel$export(module.exports, "bindActionCreators", function () { return $4aa593147952e3a9$export$aea084d96e84da92; });
$parcel$export(module.exports, "compose", function () { return $4aa593147952e3a9$export$f672e0b6f7222cd7; });
$parcel$export(module.exports, "applyMiddleware", function () { return $4aa593147952e3a9$export$9ff26e0402cc7b7; });
// src/utils/formatProdErrorMessage.ts
function $4aa593147952e3a9$var$formatProdErrorMessage(code) {
    return `Minified Redux error #${code}; visit https://redux.js.org/Errors?code=${code} for the full message or use the non-minified dev environment for full errors. `;
}
// src/utils/symbol-observable.ts
var $4aa593147952e3a9$var$$$observable = /* @__PURE__ */ (()=>typeof Symbol === "function" && Symbol.observable || "@@observable")();
var $4aa593147952e3a9$var$symbol_observable_default = $4aa593147952e3a9$var$$$observable;
// src/utils/actionTypes.ts
var $4aa593147952e3a9$var$randomString = ()=>Math.random().toString(36).substring(7).split("").join(".");
var $4aa593147952e3a9$var$ActionTypes = {
    INIT: `@@redux/INIT${$4aa593147952e3a9$var$randomString()}`,
    REPLACE: `@@redux/REPLACE${$4aa593147952e3a9$var$randomString()}`,
    PROBE_UNKNOWN_ACTION: ()=>`@@redux/PROBE_UNKNOWN_ACTION${$4aa593147952e3a9$var$randomString()}`
};
var $4aa593147952e3a9$export$4219e499db7ca678 = $4aa593147952e3a9$var$ActionTypes;
// src/utils/isPlainObject.ts
function $4aa593147952e3a9$export$53b83ca8eaab0383(obj) {
    if (typeof obj !== "object" || obj === null) return false;
    let proto = obj;
    while(Object.getPrototypeOf(proto) !== null)proto = Object.getPrototypeOf(proto);
    return Object.getPrototypeOf(obj) === proto || Object.getPrototypeOf(obj) === null;
}
// src/utils/kindOf.ts
function $4aa593147952e3a9$var$miniKindOf(val) {
    if (val === void 0) return "undefined";
    if (val === null) return "null";
    const type = typeof val;
    switch(type){
        case "boolean":
        case "string":
        case "number":
        case "symbol":
        case "function":
            return type;
    }
    if (Array.isArray(val)) return "array";
    if ($4aa593147952e3a9$var$isDate(val)) return "date";
    if ($4aa593147952e3a9$var$isError(val)) return "error";
    const constructorName = $4aa593147952e3a9$var$ctorName(val);
    switch(constructorName){
        case "Symbol":
        case "Promise":
        case "WeakMap":
        case "WeakSet":
        case "Map":
        case "Set":
            return constructorName;
    }
    return Object.prototype.toString.call(val).slice(8, -1).toLowerCase().replace(/\s/g, "");
}
function $4aa593147952e3a9$var$ctorName(val) {
    return typeof val.constructor === "function" ? val.constructor.name : null;
}
function $4aa593147952e3a9$var$isError(val) {
    return val instanceof Error || typeof val.message === "string" && val.constructor && typeof val.constructor.stackTraceLimit === "number";
}
function $4aa593147952e3a9$var$isDate(val) {
    if (val instanceof Date) return true;
    return typeof val.toDateString === "function" && typeof val.getDate === "function" && typeof val.setDate === "function";
}
function $4aa593147952e3a9$var$kindOf(val) {
    let typeOfVal = typeof val;
    return typeOfVal;
}
// src/createStore.ts
function $4aa593147952e3a9$export$f51a9068ac82ea43(reducer, preloadedState, enhancer) {
    if (typeof reducer !== "function") throw new Error($4aa593147952e3a9$var$formatProdErrorMessage(2));
    if (typeof preloadedState === "function" && typeof enhancer === "function" || typeof enhancer === "function" && typeof arguments[3] === "function") throw new Error($4aa593147952e3a9$var$formatProdErrorMessage(0));
    if (typeof preloadedState === "function" && typeof enhancer === "undefined") {
        enhancer = preloadedState;
        preloadedState = void 0;
    }
    if (typeof enhancer !== "undefined") {
        if (typeof enhancer !== "function") throw new Error($4aa593147952e3a9$var$formatProdErrorMessage(1));
        return enhancer($4aa593147952e3a9$export$f51a9068ac82ea43)(reducer, preloadedState);
    }
    let currentReducer = reducer;
    let currentState = preloadedState;
    let currentListeners = /* @__PURE__ */ new Map();
    let nextListeners = currentListeners;
    let listenerIdCounter = 0;
    let isDispatching = false;
    function ensureCanMutateNextListeners() {
        if (nextListeners === currentListeners) {
            nextListeners = /* @__PURE__ */ new Map();
            currentListeners.forEach((listener, key)=>{
                nextListeners.set(key, listener);
            });
        }
    }
    function getState() {
        if (isDispatching) throw new Error($4aa593147952e3a9$var$formatProdErrorMessage(3));
        return currentState;
    }
    function subscribe(listener) {
        if (typeof listener !== "function") throw new Error($4aa593147952e3a9$var$formatProdErrorMessage(4));
        if (isDispatching) throw new Error($4aa593147952e3a9$var$formatProdErrorMessage(5));
        let isSubscribed = true;
        ensureCanMutateNextListeners();
        const listenerId = listenerIdCounter++;
        nextListeners.set(listenerId, listener);
        return function unsubscribe() {
            if (!isSubscribed) return;
            if (isDispatching) throw new Error($4aa593147952e3a9$var$formatProdErrorMessage(6));
            isSubscribed = false;
            ensureCanMutateNextListeners();
            nextListeners.delete(listenerId);
            currentListeners = null;
        };
    }
    function dispatch(action) {
        if (!$4aa593147952e3a9$export$53b83ca8eaab0383(action)) throw new Error($4aa593147952e3a9$var$formatProdErrorMessage(7));
        if (typeof action.type === "undefined") throw new Error($4aa593147952e3a9$var$formatProdErrorMessage(8));
        if (typeof action.type !== "string") throw new Error($4aa593147952e3a9$var$formatProdErrorMessage(17));
        if (isDispatching) throw new Error($4aa593147952e3a9$var$formatProdErrorMessage(9));
        try {
            isDispatching = true;
            currentState = currentReducer(currentState, action);
        } finally{
            isDispatching = false;
        }
        const listeners = currentListeners = nextListeners;
        listeners.forEach((listener)=>{
            listener();
        });
        return action;
    }
    function replaceReducer(nextReducer) {
        if (typeof nextReducer !== "function") throw new Error($4aa593147952e3a9$var$formatProdErrorMessage(10));
        currentReducer = nextReducer;
        dispatch({
            type: $4aa593147952e3a9$export$4219e499db7ca678.REPLACE
        });
    }
    function observable() {
        const outerSubscribe = subscribe;
        return {
            /**
       * The minimal observable subscription method.
       * @param observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */ subscribe (observer) {
                if (typeof observer !== "object" || observer === null) throw new Error($4aa593147952e3a9$var$formatProdErrorMessage(11));
                function observeState() {
                    const observerAsObserver = observer;
                    if (observerAsObserver.next) observerAsObserver.next(getState());
                }
                observeState();
                const unsubscribe = outerSubscribe(observeState);
                return {
                    unsubscribe: unsubscribe
                };
            },
            [$4aa593147952e3a9$var$symbol_observable_default] () {
                return this;
            }
        };
    }
    dispatch({
        type: $4aa593147952e3a9$export$4219e499db7ca678.INIT
    });
    const store = {
        dispatch: dispatch,
        subscribe: subscribe,
        getState: getState,
        replaceReducer: replaceReducer,
        [$4aa593147952e3a9$var$symbol_observable_default]: observable
    };
    return store;
}
function $4aa593147952e3a9$export$8928921ea2d3b126(reducer, preloadedState, enhancer) {
    return $4aa593147952e3a9$export$f51a9068ac82ea43(reducer, preloadedState, enhancer);
}
// src/utils/warning.ts
function $4aa593147952e3a9$var$warning(message) {
    if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
    try {
        throw new Error(message);
    } catch (e) {}
}
// src/combineReducers.ts
function $4aa593147952e3a9$var$getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
    const reducerKeys = Object.keys(reducers);
    const argumentName = action && action.type === $4aa593147952e3a9$export$4219e499db7ca678.INIT ? "preloadedState argument passed to createStore" : "previous state received by the reducer";
    if (reducerKeys.length === 0) return "Store does not have a valid reducer. Make sure the argument passed to combineReducers is an object whose values are reducers.";
    if (!$4aa593147952e3a9$export$53b83ca8eaab0383(inputState)) return `The ${argumentName} has unexpected type of "${$4aa593147952e3a9$var$kindOf(inputState)}". Expected argument to be an object with the following keys: "${reducerKeys.join('", "')}"`;
    const unexpectedKeys = Object.keys(inputState).filter((key)=>!reducers.hasOwnProperty(key) && !unexpectedKeyCache[key]);
    unexpectedKeys.forEach((key)=>{
        unexpectedKeyCache[key] = true;
    });
    if (action && action.type === $4aa593147952e3a9$export$4219e499db7ca678.REPLACE) return;
    if (unexpectedKeys.length > 0) return `Unexpected ${unexpectedKeys.length > 1 ? "keys" : "key"} "${unexpectedKeys.join('", "')}" found in ${argumentName}. Expected to find one of the known reducer keys instead: "${reducerKeys.join('", "')}". Unexpected keys will be ignored.`;
}
function $4aa593147952e3a9$var$assertReducerShape(reducers) {
    Object.keys(reducers).forEach((key)=>{
        const reducer = reducers[key];
        const initialState = reducer(void 0, {
            type: $4aa593147952e3a9$export$4219e499db7ca678.INIT
        });
        if (typeof initialState === "undefined") throw new Error($4aa593147952e3a9$var$formatProdErrorMessage(12));
        if (typeof reducer(void 0, {
            type: $4aa593147952e3a9$export$4219e499db7ca678.PROBE_UNKNOWN_ACTION()
        }) === "undefined") throw new Error($4aa593147952e3a9$var$formatProdErrorMessage(13));
    });
}
function $4aa593147952e3a9$export$66e4520cdb265d18(reducers) {
    const reducerKeys = Object.keys(reducers);
    const finalReducers = {};
    for(let i = 0; i < reducerKeys.length; i++){
        const key = reducerKeys[i];
        if (typeof reducers[key] === "function") finalReducers[key] = reducers[key];
    }
    const finalReducerKeys = Object.keys(finalReducers);
    let unexpectedKeyCache;
    let shapeAssertionError;
    try {
        $4aa593147952e3a9$var$assertReducerShape(finalReducers);
    } catch (e) {
        shapeAssertionError = e;
    }
    return function combination(state = {}, action) {
        if (shapeAssertionError) throw shapeAssertionError;
        let hasChanged = false;
        const nextState = {};
        for(let i = 0; i < finalReducerKeys.length; i++){
            const key = finalReducerKeys[i];
            const reducer = finalReducers[key];
            const previousStateForKey = state[key];
            const nextStateForKey = reducer(previousStateForKey, action);
            if (typeof nextStateForKey === "undefined") {
                const actionType = action && action.type;
                throw new Error($4aa593147952e3a9$var$formatProdErrorMessage(14));
            }
            nextState[key] = nextStateForKey;
            hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
        }
        hasChanged = hasChanged || finalReducerKeys.length !== Object.keys(state).length;
        return hasChanged ? nextState : state;
    };
}
// src/bindActionCreators.ts
function $4aa593147952e3a9$var$bindActionCreator(actionCreator, dispatch) {
    return function(...args) {
        return dispatch(actionCreator.apply(this, args));
    };
}
function $4aa593147952e3a9$export$aea084d96e84da92(actionCreators, dispatch) {
    if (typeof actionCreators === "function") return $4aa593147952e3a9$var$bindActionCreator(actionCreators, dispatch);
    if (typeof actionCreators !== "object" || actionCreators === null) throw new Error($4aa593147952e3a9$var$formatProdErrorMessage(16));
    const boundActionCreators = {};
    for(const key in actionCreators){
        const actionCreator = actionCreators[key];
        if (typeof actionCreator === "function") boundActionCreators[key] = $4aa593147952e3a9$var$bindActionCreator(actionCreator, dispatch);
    }
    return boundActionCreators;
}
// src/compose.ts
function $4aa593147952e3a9$export$f672e0b6f7222cd7(...funcs) {
    if (funcs.length === 0) return (arg)=>arg;
    if (funcs.length === 1) return funcs[0];
    return funcs.reduce((a, b)=>(...args)=>a(b(...args)));
}
// src/applyMiddleware.ts
function $4aa593147952e3a9$export$9ff26e0402cc7b7(...middlewares) {
    return (createStore2)=>(reducer, preloadedState)=>{
            const store = createStore2(reducer, preloadedState);
            let dispatch = ()=>{
                throw new Error($4aa593147952e3a9$var$formatProdErrorMessage(15));
            };
            const middlewareAPI = {
                getState: store.getState,
                dispatch: (action, ...args)=>dispatch(action, ...args)
            };
            const chain = middlewares.map((middleware)=>middleware(middlewareAPI));
            dispatch = $4aa593147952e3a9$export$f672e0b6f7222cd7(...chain)(store.dispatch);
            return {
                ...store,
                dispatch: dispatch
            };
        };
}
// src/utils/isAction.ts
function $4aa593147952e3a9$export$b956e38827fca970(action) {
    return $4aa593147952e3a9$export$53b83ca8eaab0383(action) && "type" in action && typeof action.type === "string";
}

});

parcelRegister("5Bmrs", function(module, exports) {

$parcel$export(module.exports, "wrapMapToPropsConstant", function () { return $4141d0ee857f1fa3$export$710f7c60f68acd3e; });
$parcel$export(module.exports, "wrapMapToPropsFunc", function () { return $4141d0ee857f1fa3$export$8d46c7f53c8c602f; });
parcelRequire("4biOK");
function $4141d0ee857f1fa3$export$710f7c60f68acd3e(getConstant) {
    return function initConstantSelector(dispatch, options) {
        var constant = getConstant(dispatch, options);
        function constantSelector() {
            return constant;
        }
        constantSelector.dependsOnOwnProps = false;
        return constantSelector;
    };
} // dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
function $4141d0ee857f1fa3$export$e561b938df936d57(mapToProps) {
    return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== undefined ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
} // Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
function $4141d0ee857f1fa3$export$8d46c7f53c8c602f(mapToProps, methodName) {
    return function initProxySelector(dispatch, _ref) {
        var displayName = _ref.displayName;
        var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
            return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch);
        }; // allow detectFactoryAndVerify to get ownProps
        proxy.dependsOnOwnProps = true;
        proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
            proxy.mapToProps = mapToProps;
            proxy.dependsOnOwnProps = $4141d0ee857f1fa3$export$e561b938df936d57(mapToProps);
            var props = proxy(stateOrDispatch, ownProps);
            if (typeof props === "function") {
                proxy.mapToProps = props;
                proxy.dependsOnOwnProps = $4141d0ee857f1fa3$export$e561b938df936d57(props);
                props = proxy(stateOrDispatch, ownProps);
            }
            return props;
        };
        return proxy;
    };
}

});
parcelRegister("4biOK", function(module, exports) {

var $efLHN = parcelRequire("efLHN");

var $4yst9 = parcelRequire("4yst9");
function $30b6c93f8bceb245$export$2e2bcd8739ae039(value, displayName, methodName) {
    if (!(0, $efLHN.default)(value)) (0, $4yst9.default)(methodName + "() in " + displayName + " must return a plain object. Instead received " + value + ".");
}

});
parcelRegister("efLHN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a60778b5ebd2b51b$export$2e2bcd8739ae039; });
/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */ function $a60778b5ebd2b51b$export$2e2bcd8739ae039(obj) {
    if (typeof obj !== "object" || obj === null) return false;
    var proto = Object.getPrototypeOf(obj);
    if (proto === null) return true;
    var baseProto = proto;
    while(Object.getPrototypeOf(baseProto) !== null)baseProto = Object.getPrototypeOf(baseProto);
    return proto === baseProto;
}

});

parcelRegister("4yst9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $35106bc861bfb3ae$export$2e2bcd8739ae039; });
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */ function $35106bc861bfb3ae$export$2e2bcd8739ae039(message) {
    /* eslint-disable no-console */ if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
    /* eslint-enable no-console */ try {
        // This error was thrown as a convenience so that if you enable
        // "break on all exceptions" in your console,
        // it would pause the execution at this line.
        throw new Error(message);
    /* eslint-disable no-empty */ } catch (e) {}
/* eslint-enable no-empty */ }

});




parcelRegister("foufz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b3508ff0281c19e6$export$2e2bcd8739ae039; });

var $5Bmrs = parcelRequire("5Bmrs");
function $b3508ff0281c19e6$export$23fc470827b14aa(mapStateToProps) {
    return typeof mapStateToProps === "function" ? (0, $5Bmrs.wrapMapToPropsFunc)(mapStateToProps, "mapStateToProps") : undefined;
}
function $b3508ff0281c19e6$export$514bc8c1a53c1d66(mapStateToProps) {
    return !mapStateToProps ? (0, $5Bmrs.wrapMapToPropsConstant)(function() {
        return {};
    }) : undefined;
}
var $b3508ff0281c19e6$export$2e2bcd8739ae039 = [
    $b3508ff0281c19e6$export$23fc470827b14aa,
    $b3508ff0281c19e6$export$514bc8c1a53c1d66
];

});

parcelRegister("5aXBy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3c4c1f2fb72330f8$export$2e2bcd8739ae039; });

var $6Sryg = parcelRequire("6Sryg");
parcelRequire("4biOK");
function $3c4c1f2fb72330f8$export$691c327fc30bc857(stateProps, dispatchProps, ownProps) {
    return (0, $6Sryg.default)({}, ownProps, stateProps, dispatchProps);
}
function $3c4c1f2fb72330f8$export$5b105939c84b5234(mergeProps) {
    return function initMergePropsProxy(dispatch, _ref) {
        var displayName = _ref.displayName, pure = _ref.pure, areMergedPropsEqual = _ref.areMergedPropsEqual;
        var hasRunOnce = false;
        var mergedProps;
        return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
            var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);
            if (hasRunOnce) {
                if (!pure || !areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
            } else {
                hasRunOnce = true;
                mergedProps = nextMergedProps;
            }
            return mergedProps;
        };
    };
}
function $3c4c1f2fb72330f8$export$d61b680184bc3f00(mergeProps) {
    return typeof mergeProps === "function" ? $3c4c1f2fb72330f8$export$5b105939c84b5234(mergeProps) : undefined;
}
function $3c4c1f2fb72330f8$export$a13ba70ef50dda6d(mergeProps) {
    return !mergeProps ? function() {
        return $3c4c1f2fb72330f8$export$691c327fc30bc857;
    } : undefined;
}
var $3c4c1f2fb72330f8$export$2e2bcd8739ae039 = [
    $3c4c1f2fb72330f8$export$d61b680184bc3f00,
    $3c4c1f2fb72330f8$export$a13ba70ef50dda6d
];

});

parcelRegister("kaRml", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $eafe21e30552fbe8$export$2e2bcd8739ae039; });

var $jKAjj = parcelRequire("jKAjj");
parcelRequire("jnbiZ");
function $eafe21e30552fbe8$export$68c2c73bda6aa4b0(mapStateToProps, mapDispatchToProps, mergeProps, dispatch) {
    return function impureFinalPropsSelector(state, ownProps) {
        return mergeProps(mapStateToProps(state, ownProps), mapDispatchToProps(dispatch, ownProps), ownProps);
    };
}
function $eafe21e30552fbe8$export$d20c0c2ca6eb2b6f(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, _ref) {
    var areStatesEqual = _ref.areStatesEqual, areOwnPropsEqual = _ref.areOwnPropsEqual, areStatePropsEqual = _ref.areStatePropsEqual;
    var hasRunAtLeastOnce = false;
    var state;
    var ownProps;
    var stateProps;
    var dispatchProps;
    var mergedProps;
    function handleFirstCall(firstState, firstOwnProps) {
        state = firstState;
        ownProps = firstOwnProps;
        stateProps = mapStateToProps(state, ownProps);
        dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        hasRunAtLeastOnce = true;
        return mergedProps;
    }
    function handleNewPropsAndNewState() {
        stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewProps() {
        if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewState() {
        var nextStateProps = mapStateToProps(state, ownProps);
        var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
        stateProps = nextStateProps;
        if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleSubsequentCalls(nextState, nextOwnProps) {
        var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
        var stateChanged = !areStatesEqual(nextState, state);
        state = nextState;
        ownProps = nextOwnProps;
        if (propsChanged && stateChanged) return handleNewPropsAndNewState();
        if (propsChanged) return handleNewProps();
        if (stateChanged) return handleNewState();
        return mergedProps;
    }
    return function pureFinalPropsSelector(nextState, nextOwnProps) {
        return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
    };
} // TODO: Add more comments
function $eafe21e30552fbe8$export$2e2bcd8739ae039(dispatch, _ref2) {
    var initMapStateToProps = _ref2.initMapStateToProps, initMapDispatchToProps = _ref2.initMapDispatchToProps, initMergeProps = _ref2.initMergeProps, options = (0, $jKAjj.default)(_ref2, [
        "initMapStateToProps",
        "initMapDispatchToProps",
        "initMergeProps"
    ]);
    var mapStateToProps = initMapStateToProps(dispatch, options);
    var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
    var mergeProps = initMergeProps(dispatch, options);
    var selectorFactory = options.pure ? $eafe21e30552fbe8$export$d20c0c2ca6eb2b6f : $eafe21e30552fbe8$export$68c2c73bda6aa4b0;
    return selectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}

});
parcelRegister("jnbiZ", function(module, exports) {

var $4yst9 = parcelRequire("4yst9");
function $e1a8ef470e1ec2d2$var$verify(selector, methodName, displayName) {
    if (!selector) throw new Error("Unexpected value for " + methodName + " in " + displayName + ".");
    else if (methodName === "mapStateToProps" || methodName === "mapDispatchToProps") {
        if (!selector.hasOwnProperty("dependsOnOwnProps")) (0, $4yst9.default)("The selector for " + methodName + " of " + displayName + " did not specify a value for dependsOnOwnProps.");
    }
}
function $e1a8ef470e1ec2d2$export$2e2bcd8739ae039(mapStateToProps, mapDispatchToProps, mergeProps, displayName) {
    $e1a8ef470e1ec2d2$var$verify(mapStateToProps, "mapStateToProps", displayName);
    $e1a8ef470e1ec2d2$var$verify(mapDispatchToProps, "mapDispatchToProps", displayName);
    $e1a8ef470e1ec2d2$var$verify(mergeProps, "mergeProps", displayName);
}

});




parcelRegister("5g4S5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d593af9b7abb58fa$export$2e2bcd8739ae039; });

var $bibO8 = parcelRequire("bibO8");

var $dAx5m = parcelRequire("dAx5m");
parcelRequire("5Zreo");
var $lairn = parcelRequire("lairn");

var $55TWT = parcelRequire("55TWT");
var $dZHnD = parcelRequire("dZHnD");

var $cUsaH = parcelRequire("cUsaH");

var $6qH56 = parcelRequire("6qH56");

var $7H29x = parcelRequire("7H29x");

var $cRCIP = parcelRequire("cRCIP");
parcelRequire("adUiG");
var $fjOHq = parcelRequire("fjOHq");
var $58n8k = parcelRequire("58n8k");
parcelRequire("ddU3E");
var $k9wkW = parcelRequire("k9wkW");
var $8nZKD = parcelRequire("8nZKD");

var $dnae4 = parcelRequire("dnae4");

var $9LtBD = parcelRequire("9LtBD");
parcelRequire("lLL9n");
var $5jCKl = parcelRequire("5jCKl");
var $84bHK = parcelRequire("84bHK");
var $8jUEk = parcelRequire("8jUEk");
var $5gNz2 = parcelRequire("5gNz2");

const $d593af9b7abb58fa$var$LoadableProfileAvatarPicker = (0, (/*@__PURE__*/$parcel$interopDefault($cUsaH)))({
    loader: ()=>(parcelRequire("7mUVx")),
    loading: ()=>null
});

const $d593af9b7abb58fa$var$LoadableInitialsEditorDialog = (0, (/*@__PURE__*/$parcel$interopDefault($cUsaH)))({
    loader: ()=>(parcelRequire("2E2Uy")),
    loading: ()=>null
});
const $d593af9b7abb58fa$var$EDIT_AVATAR_HASH = "#edit-avatar"; // https://product-fabric.atlassian.net/browse/PTC-1342
const $d593af9b7abb58fa$export$3778be82376b06d7 = ({ addFlag: addFlag, analytics: analytics, size: size = (0, $dnae4.AvatarSize).xxlarge, userId: userId })=>{
    const navigate = (0, $lairn.useNavigate)();
    const { mutateAsync: onAvatarPicked, isLoading: isAvatarUploading } = (0, $5gNz2.useUpdateUserAvatarMutation)(userId);
    const { mutateAsync: deleteAvatar, isLoading: isAvatarDeleting } = (0, $5jCKl.useDeleteUserAvatarMutation)(userId);
    const isLoading = isAvatarUploading || isAvatarDeleting;
    const { formatMessage: formatMessage } = (0, $dZHnD.default)();
    const { profileAvatar: profileAvatar, isLoading: isProfileAvatarLoading, isError: isProfileAvatarError } = (0, $8jUEk.useProfileAvatarQuery)(userId);
    const { myAvatar: myAvatar, isLoading: myAvatarIsLoading, isError: myAvatarIsError } = (0, $84bHK.useMyAvatar)(userId);
    const [isPickerOpen, setIsPickerOpen] = (0, $dAx5m.useState)(false);
    const [isInitialsEditorOpen, setIsInitialsEditorOpen] = (0, $dAx5m.useState)(false);
    const { avatarUrl: avatarUrl = "", fullName: fullName = "" } = profileAvatar || {};
    const { uploaded: uploaded = false } = myAvatar || {};
    (0, $dAx5m.useEffect)(()=>{
        $d593af9b7abb58fa$var$LoadableProfileAvatarPicker.preload();
        $d593af9b7abb58fa$var$LoadableInitialsEditorDialog.preload();
    }, []);
    const closeAvatarPicker = (0, $dAx5m.useCallback)(()=>{
        if (isPickerOpen) analytics.pushTrackEvent({
            source: (0, $fjOHq.AnalyticsEventSource).CLIENT_METRICS,
            actionSubject: "avatarPicker",
            action: (0, $fjOHq.AnalyticsEventActions).CLOSED
        });
        setIsPickerOpen(false);
    }, [
        analytics,
        isPickerOpen
    ]);
    const openAvatarPicker = (0, $dAx5m.useCallback)(()=>{
        analytics.pushUIEvent({
            source: (0, $fjOHq.AnalyticsEventSource).MANAGE_ACCOUNT_PROFILE_AND_VISIBILITY_TAB,
            actionSubject: (0, $fjOHq.AnalyticsEventSubjects).BUTTON,
            action: (0, $fjOHq.AnalyticsEventActions).CLICKED,
            actionSubjectId: "changeProfilePhoto"
        });
        setIsPickerOpen(true);
        analytics.pushTrackEvent({
            source: (0, $fjOHq.AnalyticsEventSource).MANAGE_ACCOUNT_PROFILE_AND_VISIBILITY_TAB,
            actionSubject: (0, $fjOHq.AnalyticsEventSubjects).AVATAR_PICKER,
            action: (0, $fjOHq.AnalyticsEventActions).OPENED
        });
    }, [
        analytics
    ]);
    (0, $dAx5m.useEffect)(()=>{
        if ((0, (/*@__PURE__*/$parcel$interopDefault($6qH56))).location.hash === $d593af9b7abb58fa$var$EDIT_AVATAR_HASH) openAvatarPicker();
    }, [
        openAvatarPicker
    ]);
    (0, $dAx5m.useEffect)(()=>{
        if (!isPickerOpen) {
            if ((0, (/*@__PURE__*/$parcel$interopDefault($6qH56))).location.hash === $d593af9b7abb58fa$var$EDIT_AVATAR_HASH) navigate((0, (/*@__PURE__*/$parcel$interopDefault($6qH56))).location.pathname, {
                replace: true
            });
        }
        if (isPickerOpen) navigate(`${(0, (/*@__PURE__*/$parcel$interopDefault($6qH56))).location.pathname}${$d593af9b7abb58fa$var$EDIT_AVATAR_HASH}`, {
            replace: true
        });
    }, [
        isPickerOpen,
        navigate
    ]);
    const handleDeleteAvatarError = (0, $dAx5m.useCallback)(()=>{
        analytics.pushTrackEvent({
            source: (0, $fjOHq.AnalyticsEventSource).MANAGE_ACCOUNT_PROFILE_AND_VISIBILITY_TAB,
            actionSubject: "deleteAvatar",
            action: (0, $fjOHq.AnalyticsEventActions).FAILED
        });
        addFlag({
            id: "profile.avatar.delete.error",
            title: formatMessage({
                id: "pf-home.profile.avatar.delete.failure.title",
                defaultMessage: "Failed to remove profile photo",
                description: "The title of a slide-in error notification card informing the user that the attempt to remove their profile photo has failed"
            }),
            type: "error"
        });
    }, [
        addFlag,
        analytics,
        formatMessage
    ]);
    const handleUpdateAvatarError = (0, $dAx5m.useCallback)((error, errorSource)=>{
        analytics.pushTrackEvent({
            source: (0, $fjOHq.AnalyticsEventSource).MANAGE_ACCOUNT_PROFILE_AND_VISIBILITY_TAB,
            actionSubject: errorSource,
            action: (0, $fjOHq.AnalyticsEventActions).FAILED
        });
        if (error) addFlag({
            id: "profile.avatar.upload.error",
            title: formatMessage({
                id: "pf-home.profile.avatar.upload.failure.title",
                defaultMessage: "Failed to change profile photo",
                description: "The title of a slide-in error notification card informing the user that the attempt to change their profile photo has failed"
            }),
            type: "error"
        });
    }, [
        addFlag,
        analytics,
        formatMessage
    ]);
    const openInitialsPicker = (0, $dAx5m.useCallback)(()=>{
        analytics.pushUIEvent({
            source: (0, $fjOHq.AnalyticsEventSource).MANAGE_ACCOUNT_PROFILE_AND_VISIBILITY_TAB,
            actionSubject: (0, $fjOHq.AnalyticsEventSubjects).BUTTON,
            action: (0, $fjOHq.AnalyticsEventActions).CLICKED,
            actionSubjectId: "createInitialsAvatar"
        });
        setIsInitialsEditorOpen(true);
        analytics.pushTrackEvent({
            source: (0, $fjOHq.AnalyticsEventSource).MANAGE_ACCOUNT_PROFILE_AND_VISIBILITY_TAB,
            actionSubject: "avatarInitialsPicker",
            action: (0, $fjOHq.AnalyticsEventActions).OPENED
        });
    }, [
        analytics
    ]);
    const closeInitialsPicker = (0, $dAx5m.useCallback)(()=>{
        setIsInitialsEditorOpen(false);
        analytics.pushTrackEvent({
            source: (0, $fjOHq.AnalyticsEventSource).MANAGE_ACCOUNT_PROFILE_AND_VISIBILITY_TAB,
            actionSubject: "avatarInitialsPicker",
            action: (0, $fjOHq.AnalyticsEventActions).CLOSED
        });
    }, [
        analytics
    ]);
    const handleAvatarPicked = (0, $dAx5m.useCallback)(async (dataURI)=>{
        try {
            await onAvatarPicked(dataURI);
            closeAvatarPicker();
            analytics.pushTrackEvent({
                source: (0, $fjOHq.AnalyticsEventSource).MANAGE_ACCOUNT_PROFILE_AND_VISIBILITY_TAB,
                actionSubject: "uploadAvatar",
                action: (0, $fjOHq.AnalyticsEventActions).SUCCEEDED
            });
            addFlag({
                id: "profile.avatar.upload.success",
                title: formatMessage({
                    id: "pf-home.profile.avatar.upload.success.title",
                    defaultMessage: "Avatar added",
                    description: "The title of a slide-in notification card informing the user that the attempt to change their profile photo has succeeded"
                }),
                description: formatMessage({
                    id: "pf-home.profile.avatar.upload.success.description",
                    defaultMessage: "We've uploaded your new avatar. It may take a few minutes to display everywhere.",
                    description: "The text of a slide-in notification card informing the user that the attempt to change their profile photo has succeeded"
                }),
                type: "success"
            });
        } catch (error) {
            handleUpdateAvatarError(error, "uploadAvatar");
        }
    }, [
        addFlag,
        analytics,
        closeAvatarPicker,
        formatMessage,
        handleUpdateAvatarError,
        onAvatarPicked
    ]);
    const handleCustomInitialsPicked = (0, $dAx5m.useCallback)(async (dataURI, _avatarType, _text, color)=>{
        try {
            closeInitialsPicker();
            await onAvatarPicked(dataURI);
            analytics.pushTrackEvent({
                source: (0, $fjOHq.AnalyticsEventSource).MANAGE_ACCOUNT_PROFILE_AND_VISIBILITY_TAB,
                actionSubject: "updateAvatarInitials",
                action: (0, $fjOHq.AnalyticsEventActions).SUCCEEDED,
                attributes: {
                    color: color
                }
            });
            addFlag({
                id: "profile.avatar.upload.success",
                title: formatMessage({
                    id: "pf-home.profile.avatar.upload.success.title",
                    defaultMessage: "Avatar added",
                    description: "The title of a slide-in notification card informing the user that the attempt to change their profile photo has succeeded"
                }),
                description: formatMessage({
                    id: "pf-home.profile.avatar.upload.success.description",
                    defaultMessage: "We've uploaded your new avatar. It may take a few minutes to display everywhere.",
                    description: "The text of a slide-in notification card informing the user that the attempt to change their profile photo has succeeded"
                }),
                type: "success"
            });
        } catch (error) {
            handleUpdateAvatarError(error, "updateAvatarInitials");
        }
    }, [
        addFlag,
        analytics,
        closeInitialsPicker,
        formatMessage,
        handleUpdateAvatarError,
        onAvatarPicked
    ]);
    const handleDeleteAvatar = (0, $dAx5m.useCallback)(async ()=>{
        analytics.pushUIEvent({
            source: (0, $fjOHq.AnalyticsEventSource).MANAGE_ACCOUNT_PROFILE_AND_VISIBILITY_TAB,
            actionSubject: (0, $fjOHq.AnalyticsEventSubjects).BUTTON,
            action: (0, $fjOHq.AnalyticsEventActions).CLICKED,
            actionSubjectId: "removeAvatar"
        });
        try {
            await deleteAvatar();
            analytics.pushTrackEvent({
                source: (0, $fjOHq.AnalyticsEventSource).MANAGE_ACCOUNT_PROFILE_AND_VISIBILITY_TAB,
                actionSubject: "deleteAvatar",
                action: (0, $fjOHq.AnalyticsEventActions).SUCCEEDED
            });
            addFlag({
                id: "profile.avatar.delete.success",
                title: formatMessage({
                    id: "pf-home.profile.avatar.delete.success.title",
                    defaultMessage: "Avatar removed",
                    description: `The title of a slide-in notification card informing the user that the
            attempt to delete their profile photo has succeeded`
                }),
                description: formatMessage({
                    id: "pf-home.profile.avatar.delete.success.description",
                    defaultMessage: "We've deleted your Atlassian avatar. If you have one, your Gravatar will display instead.",
                    description: "The text of a slide-in notification card informing the user that the attempt to delete their profile photo has succeeded"
                }),
                type: "success"
            });
        } catch (error) {
            handleDeleteAvatarError();
        }
    }, [
        addFlag,
        analytics,
        deleteAvatar,
        formatMessage,
        handleDeleteAvatarError
    ]);
    const renderAvatarMenu = ()=>{
        const iconSize = [
            (0, $dnae4.AvatarSize).xxlarge,
            (0, $dnae4.AvatarSize).xlarge
        ].includes(size) ? (0, $8nZKD.ProfileAvatarDropdownMenuIconSize).medium : (0, $8nZKD.ProfileAvatarDropdownMenuIconSize).small;
        if (uploaded) return /*#__PURE__*/ (0, $bibO8.jsxs)((0, $k9wkW.default), {
            iconSize: iconSize,
            children: [
                /*#__PURE__*/ (0, $bibO8.jsx)((0, $cRCIP.default), {
                    onClick: openAvatarPicker,
                    "data-testid": "change-avatar",
                    children: /*#__PURE__*/ (0, $bibO8.jsx)((0, $55TWT.default), {
                        id: "pf-home.profile-avatar.change-profile-photo.text",
                        defaultMessage: "Change profile photo",
                        description: "Used as text for a button for beginning the workflow of changing your own profile picture"
                    })
                }),
                /*#__PURE__*/ (0, $bibO8.jsx)((0, $cRCIP.default), {
                    onClick: openInitialsPicker,
                    "data-testid": "create-custom-initial-button",
                    children: /*#__PURE__*/ (0, $bibO8.jsx)((0, $55TWT.default), {
                        id: "pf-home.profile-avatar.create-custom-avatar.text",
                        defaultMessage: "Create initials avatar",
                        description: "Used as text for a button for beginning the workflow of creating a new profile picture showing their initials"
                    })
                }),
                /*#__PURE__*/ (0, $bibO8.jsx)((0, $cRCIP.default), {
                    onClick: handleDeleteAvatar,
                    "data-testid": "remove-avatar",
                    children: /*#__PURE__*/ (0, $bibO8.jsx)((0, $55TWT.default), {
                        id: "pf-home.profile-avatar.remove-profile-photo.text",
                        defaultMessage: "Remove",
                        description: "Used as text for a button for deleting your Atlassian profile picture"
                    })
                })
            ]
        });
        return /*#__PURE__*/ (0, $bibO8.jsxs)((0, $k9wkW.default), {
            iconSize: iconSize,
            children: [
                /*#__PURE__*/ (0, $bibO8.jsx)((0, $cRCIP.default), {
                    onClick: openAvatarPicker,
                    children: /*#__PURE__*/ (0, $bibO8.jsx)((0, $55TWT.default), {
                        id: "pf-home.profile-avatar.add-profile-photo.dropdown.text",
                        defaultMessage: "Add profile photo",
                        description: "Used as text for a button for beginning the workflow of adding your own profile picture when the user has never uploaded an avatar yet"
                    })
                }),
                /*#__PURE__*/ (0, $bibO8.jsx)((0, $cRCIP.default), {
                    onClick: openInitialsPicker,
                    "data-testid": "create-custom-initial-button",
                    children: /*#__PURE__*/ (0, $bibO8.jsx)((0, $55TWT.default), {
                        id: "pf-home.profile-avatar.create-custom-avatar.text",
                        defaultMessage: "Create initials avatar",
                        description: "Used as text for a button for beginning the workflow of creating a new profile picture showing their initials"
                    })
                })
            ]
        });
    };
    if (isProfileAvatarLoading || isProfileAvatarError || myAvatarIsError || myAvatarIsLoading) return null;
    return /*#__PURE__*/ (0, $bibO8.jsxs)($9LtBD.AvatarWrapper, {
        "data-test-selector": "profile-avatar",
        "data-testid": "avatar-wrapper",
        children: [
            /*#__PURE__*/ (0, $bibO8.jsx)((0, $7H29x.default), {
                testId: "avatar",
                name: fullName,
                src: avatarUrl,
                size: size
            }, avatarUrl),
            /*#__PURE__*/ (0, $bibO8.jsx)($9LtBD.AvatarHoverInfo, {
                size: size,
                "data-test-selector": "profile-hover-info",
                "data-has-uploaded-avatar": `${uploaded}`,
                children: renderAvatarMenu()
            }),
            isPickerOpen && /*#__PURE__*/ (0, $bibO8.jsx)($d593af9b7abb58fa$var$LoadableProfileAvatarPicker, {
                onCancel: closeAvatarPicker,
                onAvatarPicked: handleAvatarPicked,
                isLoading: isLoading,
                hasUploadedAvatar: uploaded && avatarUrl
            }),
            isInitialsEditorOpen && /*#__PURE__*/ (0, $bibO8.jsx)($d593af9b7abb58fa$var$LoadableInitialsEditorDialog, {
                fullName: fullName || "",
                onSubmit: handleCustomInitialsPicked,
                onCancel: closeInitialsPicker
            })
        ]
    });
};
var $d593af9b7abb58fa$export$2e2bcd8739ae039 = (0, $58n8k.default)($d593af9b7abb58fa$export$3778be82376b06d7);

});
parcelRegister("cUsaH", function(module, exports) {
"use strict";
var $96609144e0b1546f$var$_typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
    return typeof obj;
} : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
function $96609144e0b1546f$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $96609144e0b1546f$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $96609144e0b1546f$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var $dAx5m = parcelRequire("dAx5m");

var $hyn2k = parcelRequire("hyn2k");
var $96609144e0b1546f$var$ALL_INITIALIZERS = [];
var $96609144e0b1546f$var$READY_INITIALIZERS = [];
function $96609144e0b1546f$var$isWebpackReady(getModuleIds) {
    if ((typeof __webpack_modules__ === "undefined" ? "undefined" : $96609144e0b1546f$var$_typeof(__webpack_modules__)) !== "object") return false;
    return getModuleIds().every(function(moduleId) {
        return typeof moduleId !== "undefined" && typeof __webpack_modules__[moduleId] !== "undefined";
    });
}
function $96609144e0b1546f$var$load(loader) {
    var promise = loader();
    var state = {
        loading: true,
        loaded: null,
        error: null
    };
    state.promise = promise.then(function(loaded) {
        state.loading = false;
        state.loaded = loaded;
        return loaded;
    }).catch(function(err) {
        state.loading = false;
        state.error = err;
        throw err;
    });
    return state;
}
function $96609144e0b1546f$var$loadMap(obj) {
    var state = {
        loading: false,
        loaded: {},
        error: null
    };
    var promises = [];
    try {
        Object.keys(obj).forEach(function(key) {
            var result = $96609144e0b1546f$var$load(obj[key]);
            if (!result.loading) {
                state.loaded[key] = result.loaded;
                state.error = result.error;
            } else state.loading = true;
            promises.push(result.promise);
            result.promise.then(function(res) {
                state.loaded[key] = res;
            }).catch(function(err) {
                state.error = err;
            });
        });
    } catch (err) {
        state.error = err;
    }
    state.promise = Promise.all(promises).then(function(res) {
        state.loading = false;
        return res;
    }).catch(function(err) {
        state.loading = false;
        throw err;
    });
    return state;
}
function $96609144e0b1546f$var$resolve(obj) {
    return obj && obj.__esModule ? obj.default : obj;
}
function $96609144e0b1546f$var$render(loaded, props) {
    return $dAx5m.createElement($96609144e0b1546f$var$resolve(loaded), props);
}
function $96609144e0b1546f$var$createLoadableComponent(loadFn, options) {
    var _class, _temp;
    if (!options.loading) throw new Error("react-loadable requires a `loading` component");
    var opts = Object.assign({
        loader: null,
        loading: null,
        delay: 200,
        timeout: null,
        render: $96609144e0b1546f$var$render,
        webpack: null,
        modules: null
    }, options);
    var res = null;
    function init() {
        if (!res) res = loadFn(opts.loader);
        return res.promise;
    }
    $96609144e0b1546f$var$ALL_INITIALIZERS.push(init);
    if (typeof opts.webpack === "function") $96609144e0b1546f$var$READY_INITIALIZERS.push(function() {
        if ($96609144e0b1546f$var$isWebpackReady(opts.webpack)) return init();
    });
    return _temp = _class = function(_React$Component) {
        $96609144e0b1546f$var$_inherits(LoadableComponent, _React$Component);
        function LoadableComponent(props) {
            $96609144e0b1546f$var$_classCallCheck(this, LoadableComponent);
            var _this = $96609144e0b1546f$var$_possibleConstructorReturn(this, _React$Component.call(this, props));
            _this.retry = function() {
                _this.setState({
                    error: null,
                    loading: true,
                    timedOut: false
                });
                res = loadFn(opts.loader);
                _this._loadModule();
            };
            init();
            _this.state = {
                error: res.error,
                pastDelay: false,
                timedOut: false,
                loading: res.loading,
                loaded: res.loaded
            };
            return _this;
        }
        LoadableComponent.preload = function preload() {
            return init();
        };
        LoadableComponent.prototype.componentWillMount = function componentWillMount() {
            this._mounted = true;
            this._loadModule();
        };
        LoadableComponent.prototype._loadModule = function _loadModule() {
            var _this2 = this;
            if (this.context.loadable && Array.isArray(opts.modules)) opts.modules.forEach(function(moduleName) {
                _this2.context.loadable.report(moduleName);
            });
            if (!res.loading) return;
            if (typeof opts.delay === "number") {
                if (opts.delay === 0) this.setState({
                    pastDelay: true
                });
                else this._delay = setTimeout(function() {
                    _this2.setState({
                        pastDelay: true
                    });
                }, opts.delay);
            }
            if (typeof opts.timeout === "number") this._timeout = setTimeout(function() {
                _this2.setState({
                    timedOut: true
                });
            }, opts.timeout);
            var update = function update() {
                if (!_this2._mounted) return;
                _this2.setState({
                    error: res.error,
                    loaded: res.loaded,
                    loading: res.loading
                });
                _this2._clearTimeouts();
            };
            res.promise.then(function() {
                update();
            }).catch(function(err) {
                update();
            });
        };
        LoadableComponent.prototype.componentWillUnmount = function componentWillUnmount() {
            this._mounted = false;
            this._clearTimeouts();
        };
        LoadableComponent.prototype._clearTimeouts = function _clearTimeouts() {
            clearTimeout(this._delay);
            clearTimeout(this._timeout);
        };
        LoadableComponent.prototype.render = function render() {
            if (this.state.loading || this.state.error) return $dAx5m.createElement(opts.loading, {
                isLoading: this.state.loading,
                pastDelay: this.state.pastDelay,
                timedOut: this.state.timedOut,
                error: this.state.error,
                retry: this.retry
            });
            else if (this.state.loaded) return opts.render(this.state.loaded, this.props);
            else return null;
        };
        return LoadableComponent;
    }($dAx5m.Component), _class.contextTypes = {
        loadable: $hyn2k.shape({
            report: $hyn2k.func.isRequired
        })
    }, _temp;
}
function $96609144e0b1546f$var$Loadable(opts) {
    return $96609144e0b1546f$var$createLoadableComponent($96609144e0b1546f$var$load, opts);
}
function $96609144e0b1546f$var$LoadableMap(opts) {
    if (typeof opts.render !== "function") throw new Error("LoadableMap requires a `render(loaded, props)` function");
    return $96609144e0b1546f$var$createLoadableComponent($96609144e0b1546f$var$loadMap, opts);
}
$96609144e0b1546f$var$Loadable.Map = $96609144e0b1546f$var$LoadableMap;
var $96609144e0b1546f$var$Capture = function(_React$Component2) {
    $96609144e0b1546f$var$_inherits(Capture, _React$Component2);
    function Capture() {
        $96609144e0b1546f$var$_classCallCheck(this, Capture);
        return $96609144e0b1546f$var$_possibleConstructorReturn(this, _React$Component2.apply(this, arguments));
    }
    Capture.prototype.getChildContext = function getChildContext() {
        return {
            loadable: {
                report: this.props.report
            }
        };
    };
    Capture.prototype.render = function render() {
        return $dAx5m.Children.only(this.props.children);
    };
    return Capture;
}($dAx5m.Component);
$96609144e0b1546f$var$Capture.propTypes = {
    report: $hyn2k.func.isRequired
};
$96609144e0b1546f$var$Capture.childContextTypes = {
    loadable: $hyn2k.shape({
        report: $hyn2k.func.isRequired
    }).isRequired
};
$96609144e0b1546f$var$Loadable.Capture = $96609144e0b1546f$var$Capture;
function $96609144e0b1546f$var$flushInitializers(initializers) {
    var promises = [];
    while(initializers.length){
        var init = initializers.pop();
        promises.push(init());
    }
    return Promise.all(promises).then(function() {
        if (initializers.length) return $96609144e0b1546f$var$flushInitializers(initializers);
    });
}
$96609144e0b1546f$var$Loadable.preloadAll = function() {
    return new Promise(function(resolve, reject) {
        $96609144e0b1546f$var$flushInitializers($96609144e0b1546f$var$ALL_INITIALIZERS).then(resolve, reject);
    });
};
$96609144e0b1546f$var$Loadable.preloadReady = function() {
    return new Promise(function(resolve, reject) {
        // We always will resolve, errors should be handled within loading UIs.
        $96609144e0b1546f$var$flushInitializers($96609144e0b1546f$var$READY_INITIALIZERS).then(resolve, resolve);
    });
};
module.exports = $96609144e0b1546f$var$Loadable;

});

parcelRegister("7H29x", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $599e380e29a6a8cb$export$2e2bcd8739ae039; });

var $7SVKm = parcelRequire("7SVKm");

var $7hhP0 = parcelRequire("7hhP0");

var $dAx5m = parcelRequire("dAx5m");

var $jVTBW = parcelRequire("jVTBW");

var $D9YLo = parcelRequire("D9YLo");

var $6xDaL = parcelRequire("6xDaL");

var $5MUVm = parcelRequire("5MUVm");

var $cUDwB = parcelRequire("cUDwB");

var $6NpRk = parcelRequire("6NpRk");

var $a7SH5 = parcelRequire("a7SH5");

var $2QMjz = parcelRequire("2QMjz");

var $cfnBx = parcelRequire("cfnBx");
var $599e380e29a6a8cb$var$_templateObject;
function $599e380e29a6a8cb$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $599e380e29a6a8cb$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $599e380e29a6a8cb$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($7SVKm)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $599e380e29a6a8cb$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $599e380e29a6a8cb$var$packageName = "@atlaskit/avatar";
var $599e380e29a6a8cb$var$packageVersion = "21.4.4";
// eslint-disable-next-line @repo/internal/react/consistent-types-definitions
var $599e380e29a6a8cb$var$getStyles = function getStyles(css, _ref) {
    var size = _ref.size, radius = _ref.radius, appearance = _ref.appearance, _ref$borderColor = _ref.borderColor, borderColor = _ref$borderColor === void 0 ? "var(--ds-surface-overlay, ".concat((0, $5MUVm.N0), ")") : _ref$borderColor, stackIndex = _ref.stackIndex, isInteractive = _ref.isInteractive, isDisabled = _ref.isDisabled;
    return css($599e380e29a6a8cb$var$_templateObject || ($599e380e29a6a8cb$var$_templateObject = (0, (/*@__PURE__*/$parcel$interopDefault($7hhP0)))([
        "\n    height: ",
        "px;\n    width: ",
        "px;\n    align-items: stretch;\n    background-color: ",
        ";\n    border-radius: ",
        ";\n    box-sizing: content-box;\n    cursor: inherit;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    outline: none;\n    overflow: hidden;\n    position: static;\n    transform: translateZ(0);\n    transition: transform 200ms, opacity 200ms;\n    box-shadow: 0 0 0 ",
        "px ",
        ";\n    border: none;\n    margin: ",
        ";\n    padding: ",
        ";\n\n    /* Added font-size and font-family styles to fix alignment issue in firefox for interactive button avatar */\n    font-size: inherit;\n    font-family: inherit;\n\n    &::-moz-focus-inner {\n      border: 0;\n      margin: ",
        ";\n      padding: ",
        ";\n    }\n\n    &::after {\n      background-color: transparent;\n      inset: 0px;\n\n      /* Added border-radius style to fix hover issue in safari */\n      border-radius: ",
        ";\n      content: ' ';\n      opacity: 0;\n      pointer-events: none;\n      position: absolute;\n      transition: opacity 200ms;\n      width: 100%;\n    }\n\n    ",
        "\n\n    ",
        "\n\n    ",
        "\n  "
    ])), size, size, borderColor, appearance === "circle" ? "50%" : "".concat(radius, "px"), (0, $6NpRk.BORDER_WIDTH), borderColor, "var(--ds-space-025, 2px)", "var(--ds-space-0, 0px)", "var(--ds-space-0, 0px)", "var(--ds-space-0, 0px)", appearance === "circle" ? "50%" : "".concat(radius, "px"), stackIndex && "position: relative;", isInteractive && "\n      cursor: pointer;\n\n      :focus {\n        outline: none;\n        box-shadow: 0 0 0 ".concat((0, $6NpRk.BORDER_WIDTH), "px ", "var(--ds-border-focused, ".concat((0, $5MUVm.B300), ")"), "\n      }\n\n      :hover {\n        &::after {\n          background-color: ", "var(--ds-interaction-hovered, ".concat((0, $5MUVm.N70A), ")"), ";\n          opacity: 1;\n        }\n      }\n\n      :active {\n        &::after {\n          background-color: ", "var(--ds-interaction-pressed, ".concat((0, $5MUVm.N70A), ")"), ";\n          opacity: 1;\n        }\n      }\n\n      :active {\n        transform: scale(").concat((0, $6NpRk.ACTIVE_SCALE_FACTOR), ");\n      }\n\n      @media screen and (forced-colors: active) {\n        &:focus-visible {\n          outline: 1px solid\n        }\n      }\n    "), isDisabled && "\n        cursor: not-allowed;\n\n        &::after {\n          opacity: ".concat("var(--ds-opacity-disabled, 0.7)", ";\n          pointer-events: none;\n          background-color: ", "var(--ds-surface, ".concat((0, $5MUVm.N0), ")"), ";\n        }\n      "));
};
/**
 * __Avatar__
 *
 * An avatar is a visual representation of a user or entity.
 *
 * - [Examples](https://atlassian.design/components/avatar/examples)
 * - [Code](https://atlassian.design/components/avatar/code)
 * - [Usage](https://atlassian.design/components/avatar/usage)
 */ var $599e380e29a6a8cb$var$Avatar = /*#__PURE__*/ (0, $dAx5m.forwardRef)(function(_ref2, ref) {
    var analyticsContext = _ref2.analyticsContext, _ref2$appearance = _ref2.appearance, appearance = _ref2$appearance === void 0 ? "circle" : _ref2$appearance, label = _ref2.label, borderColor = _ref2.borderColor, children = _ref2.children, href = _ref2.href, isDisabled = _ref2.isDisabled, name = _ref2.name, onClick = _ref2.onClick, presence = _ref2.presence, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? "medium" : _ref2$size, src = _ref2.src, stackIndex = _ref2.stackIndex, status = _ref2.status, target = _ref2.target, testId = _ref2.testId, _ref2$as = _ref2.as, AvatarContainer = _ref2$as === void 0 ? "div" : _ref2$as;
    var _useAnalyticsEvents = (0, $6xDaL.useAnalyticsEvents)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    var customPresenceNode = /*#__PURE__*/ (0, $dAx5m.isValidElement)(presence) ? presence : null;
    var customStatusNode = /*#__PURE__*/ (0, $dAx5m.isValidElement)(status) ? status : null;
    var isValidIconSize = size !== "xxlarge" && size !== "xsmall";
    var lastAnalytics = (0, $dAx5m.useRef)(analyticsContext);
    var uuid = (0, $D9YLo.useUIDSeed)()("avatar");
    (0, $dAx5m.useEffect)(function() {
        lastAnalytics.current = analyticsContext;
    }, [
        analyticsContext
    ]);
    var onClickHandler = (0, $dAx5m.useCallback)(function(event) {
        if (isDisabled || typeof onClick !== "function") return;
        var analyticsEvent = createAnalyticsEvent({
            action: "clicked",
            actionSubject: "avatar",
            attributes: {
                componentName: "avatar",
                packageName: $599e380e29a6a8cb$var$packageName,
                packageVersion: $599e380e29a6a8cb$var$packageVersion
            }
        });
        /**
     * To avoid wrapping this component in AnalyticsContext we manually
     * push the parent context's meta data into the context.
     */ var context = $599e380e29a6a8cb$var$_objectSpread({
            componentName: "avatar",
            packageName: $599e380e29a6a8cb$var$packageName,
            packageVersion: $599e380e29a6a8cb$var$packageVersion
        }, lastAnalytics.current);
        analyticsEvent.context.push(context);
        /**
     * Replicating the logic in the `withAnalyticsEvents` HOC
     */ var clone = analyticsEvent.clone();
        if (clone) clone.fire("atlaskit");
        onClick(event, analyticsEvent);
    }, [
        createAnalyticsEvent,
        isDisabled,
        onClick
    ]);
    var getTestId = function getTestId(testId, children) {
        return !children ? {
            "data-testid": "".concat(testId, "--inner")
        } : {
            testId: "".concat(testId, "--inner")
        };
    };
    var componentProps = function componentProps() {
        if (isDisabled) return {
            disabled: true
        };
        // return only relevant props for either anchor or button elements
        return $599e380e29a6a8cb$var$_objectSpread($599e380e29a6a8cb$var$_objectSpread({}, href && (0, $cfnBx.getLinkProps)(href, target)), onClick && !href ? (0, $cfnBx.getButtonProps)(onClickHandler) : {
            onClick: onClick
        });
    };
    var isPresence = isValidIconSize && presence && !status;
    var isStatus = isValidIconSize && status;
    // add presence or status to the label by default if presence and status are passed as a string
    // if status or presence are nodes this is not added to the label by default
    var defaultLabel = [
        name,
        isStatus && !customStatusNode && "(".concat(status, ")"),
        isPresence && !customPresenceNode && "(".concat(presence, ")")
    ].filter(Boolean).join(" ");
    var isInteractive = onClick || href || isDisabled;
    return (0, $jVTBW.jsx)(AvatarContainer, {
        "data-testid": testId,
        role: isInteractive || !defaultLabel ? undefined : "img",
        "aria-labelledby": isInteractive || !defaultLabel ? undefined : "".concat(uuid, "-label"),
        style: {
            display: "inline-block",
            position: "relative",
            outline: 0,
            zIndex: stackIndex
        }
    }, (0, $jVTBW.jsx)((0, $jVTBW.ClassNames), null, function(_ref3) {
        var css = _ref3.css;
        var props = $599e380e29a6a8cb$var$_objectSpread($599e380e29a6a8cb$var$_objectSpread($599e380e29a6a8cb$var$_objectSpread($599e380e29a6a8cb$var$_objectSpread({
            className: $599e380e29a6a8cb$var$getStyles(css, {
                size: (0, $6NpRk.AVATAR_SIZES)[size],
                radius: (0, $6NpRk.AVATAR_RADIUS)[size],
                appearance: appearance,
                borderColor: borderColor,
                stackIndex: stackIndex,
                isInteractive: Boolean(href || onClick) && !isDisabled,
                isDisabled: isDisabled
            })
        }, componentProps()), testId && getTestId(testId, children)), (isInteractive || children) && {
            "aria-label": label || defaultLabel
        }), {}, {
            children: (0, $jVTBW.jsx)((0, $cUDwB.default), {
                alt: src ? name : undefined,
                appearance: appearance,
                size: size,
                src: src,
                testId: testId
            }),
            ref: ref
        });
        return children ? children(props) : /*#__PURE__*/ (0, $dAx5m.createElement)((0, $cfnBx.getCustomElement)(isDisabled, href, onClick), props);
    }), isPresence && (0, $jVTBW.jsx)((0, $a7SH5.PresenceWrapper), {
        appearance: appearance,
        size: size,
        presence: typeof presence === "string" ? presence : undefined,
        testId: testId
    }, customPresenceNode), isStatus && (0, $jVTBW.jsx)((0, $2QMjz.StatusWrapper), {
        appearance: appearance,
        size: size,
        borderColor: borderColor,
        status: typeof status === "string" ? status : undefined,
        testId: testId
    }, customStatusNode), !isInteractive && defaultLabel ? (0, $jVTBW.jsx)("span", {
        id: "".concat(uuid, "-label"),
        hidden: true
    }, defaultLabel) : undefined);
});
$599e380e29a6a8cb$var$Avatar.displayName = "Avatar";
var $599e380e29a6a8cb$export$2e2bcd8739ae039 = $599e380e29a6a8cb$var$Avatar;

});
parcelRegister("7SVKm", function(module, exports) {

var $4k6ut = parcelRequire("4k6ut");
function $5bda5ed55016a768$var$_defineProperty(e, r, t) {
    return (r = $4k6ut(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
module.exports = $5bda5ed55016a768$var$_defineProperty, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("4k6ut", function(module, exports) {

var $jp1GW = parcelRequire("jp1GW");
var $325e1094dcbc6958$var$_typeof = $jp1GW.default;

var $kSrW8 = parcelRequire("kSrW8");
function $325e1094dcbc6958$var$toPropertyKey(t) {
    var i = $kSrW8(t, "string");
    return "symbol" == $325e1094dcbc6958$var$_typeof(i) ? i : i + "";
}
module.exports = $325e1094dcbc6958$var$toPropertyKey, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("jp1GW", function(module, exports) {
function $e201aa09640ccafd$var$_typeof(o) {
    "@babel/helpers - typeof";
    return module.exports = $e201aa09640ccafd$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $e201aa09640ccafd$var$_typeof(o);
}
module.exports = $e201aa09640ccafd$var$_typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("kSrW8", function(module, exports) {

var $jp1GW = parcelRequire("jp1GW");
var $f32e857255633669$var$_typeof = $jp1GW.default;
function $f32e857255633669$var$toPrimitive(t, r) {
    if ("object" != $f32e857255633669$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $f32e857255633669$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
module.exports = $f32e857255633669$var$toPrimitive, module.exports.__esModule = true, module.exports["default"] = module.exports;

});



parcelRegister("7hhP0", function(module, exports) {
function $54c7f1f3fc3fe137$var$_taggedTemplateLiteral(e, t) {
    return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, {
        raw: {
            value: Object.freeze(t)
        }
    }));
}
module.exports = $54c7f1f3fc3fe137$var$_taggedTemplateLiteral, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("6xDaL", function(module, exports) {

$parcel$export(module.exports, "useAnalyticsEvents", function () { return $4c3435fe1cc5afb1$export$5bf35293e545f20c; });

var $tWuif = parcelRequire("tWuif");

var $j0RQF = parcelRequire("j0RQF");

var $bXyzO = parcelRequire("bXyzO");
function $4c3435fe1cc5afb1$export$5bf35293e545f20c() {
    var analyticsContext = (0, $bXyzO.useAnalyticsContext)();
    var createAnalyticsEvent = (0, $tWuif.useCallbackOne)(function(payload) {
        return new (0, $j0RQF.default)({
            context: analyticsContext.getAtlaskitAnalyticsContext(),
            handlers: analyticsContext.getAtlaskitAnalyticsEventHandlers(),
            payload: payload
        });
    }, [
        analyticsContext
    ]);
    return {
        createAnalyticsEvent: createAnalyticsEvent
    };
}

});
parcelRegister("j0RQF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dd77c994106ccdd6$export$2e2bcd8739ae039; });

var $e6ZRb = parcelRequire("e6ZRb");

var $lfZoe = parcelRequire("lfZoe");

var $5XY5L = parcelRequire("5XY5L");

var $kiwMz = parcelRequire("kiwMz");

var $3aqaY = parcelRequire("3aqaY");

var $dL20p = parcelRequire("dL20p");

var $bLzyD = parcelRequire("bLzyD");

var $3R66t = parcelRequire("3R66t");

var $2VFrg = parcelRequire("2VFrg");

var $e4Kx4 = parcelRequire("e4Kx4");
function $dd77c994106ccdd6$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $dd77c994106ccdd6$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, (/*@__PURE__*/$parcel$interopDefault($3R66t)))(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, (/*@__PURE__*/$parcel$interopDefault($3R66t)))(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, (/*@__PURE__*/$parcel$interopDefault($bLzyD)))(this, result);
    };
}
function $dd77c994106ccdd6$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($dd77c994106ccdd6$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $dd77c994106ccdd6$export$35f8383928ba8d7 = function isUIAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $dd77c994106ccdd6$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isUIAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === "UIAnalyticsEvent";
};
var $dd77c994106ccdd6$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_AnalyticsEvent) {
    (0, (/*@__PURE__*/$parcel$interopDefault($dL20p)))(UIAnalyticsEvent, _AnalyticsEvent);
    var _super = $dd77c994106ccdd6$var$_createSuper(UIAnalyticsEvent);
    function UIAnalyticsEvent(props) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($lfZoe)))(this, UIAnalyticsEvent);
        _this = _super.call(this, props);
        (0, (/*@__PURE__*/$parcel$interopDefault($2VFrg)))((0, (/*@__PURE__*/$parcel$interopDefault($kiwMz)))(_this), "_isUIAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($2VFrg)))((0, (/*@__PURE__*/$parcel$interopDefault($kiwMz)))(_this), "clone", function() {
            if (_this.hasFired) return null;
            var context = (0, (/*@__PURE__*/$parcel$interopDefault($e6ZRb)))(_this.context);
            var handlers = (0, (/*@__PURE__*/$parcel$interopDefault($e6ZRb)))(_this.handlers);
            /**
       * A hacky "deep clone" of the object. This is limited in that it wont
       * support functions, regexs, Maps, Sets, etc, but none of those need to
       * be represented in our payload.
       */ var payload = JSON.parse(JSON.stringify(_this.payload));
            return new UIAnalyticsEvent({
                context: context,
                handlers: handlers,
                payload: payload
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($2VFrg)))((0, (/*@__PURE__*/$parcel$interopDefault($kiwMz)))(_this), "fire", function(channel) {
            if (_this.hasFired) return;
            _this.handlers.forEach(function(handler) {
                return handler((0, (/*@__PURE__*/$parcel$interopDefault($kiwMz)))(_this), channel);
            });
            _this.hasFired = true;
        });
        _this.context = props.context || [];
        _this.handlers = props.handlers || [];
        _this.hasFired = false;
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($5XY5L)))(UIAnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (this.hasFired) return this;
                return (0, (/*@__PURE__*/$parcel$interopDefault($3aqaY)))((0, (/*@__PURE__*/$parcel$interopDefault($3R66t)))(UIAnalyticsEvent.prototype), "update", this).call(this, updater);
            }
        }
    ]);
    return UIAnalyticsEvent;
}((0, $e4Kx4.default));

});
parcelRegister("e6ZRb", function(module, exports) {

var $lAZ50 = parcelRequire("lAZ50");

var $2pIT8 = parcelRequire("2pIT8");

var $kiRHD = parcelRequire("kiRHD");

var $kyaNR = parcelRequire("kyaNR");
function $a4619bb66c5af614$var$_toConsumableArray(r) {
    return $lAZ50(r) || $2pIT8(r) || $kiRHD(r) || $kyaNR();
}
module.exports = $a4619bb66c5af614$var$_toConsumableArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("lAZ50", function(module, exports) {

var $dcc1J = parcelRequire("dcc1J");
function $fb8c56f3a1ac2eb9$var$_arrayWithoutHoles(r) {
    if (Array.isArray(r)) return $dcc1J(r);
}
module.exports = $fb8c56f3a1ac2eb9$var$_arrayWithoutHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("dcc1J", function(module, exports) {
function $99b5b9aba268531e$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
module.exports = $99b5b9aba268531e$var$_arrayLikeToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("2pIT8", function(module, exports) {
function $1c20bc73512e0010$var$_iterableToArray(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
module.exports = $1c20bc73512e0010$var$_iterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("kiRHD", function(module, exports) {

var $dcc1J = parcelRequire("dcc1J");
function $ec7f255ddb44ef67$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $dcc1J(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $dcc1J(r, a) : void 0;
    }
}
module.exports = $ec7f255ddb44ef67$var$_unsupportedIterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("kyaNR", function(module, exports) {
function $ef5f5ceddaded049$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
module.exports = $ef5f5ceddaded049$var$_nonIterableSpread, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("lfZoe", function(module, exports) {
function $f79a9e6bf11f9ee1$var$_classCallCheck(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
module.exports = $f79a9e6bf11f9ee1$var$_classCallCheck, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("5XY5L", function(module, exports) {

var $f5rL9 = parcelRequire("f5rL9");
function $45811374a450de43$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, $f5rL9(o.key), o);
    }
}
function $45811374a450de43$var$_createClass(e, r, t) {
    return r && $45811374a450de43$var$_defineProperties(e.prototype, r), t && $45811374a450de43$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}
module.exports = $45811374a450de43$var$_createClass, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("f5rL9", function(module, exports) {

var $eO1fC = parcelRequire("eO1fC");
var $afbcdb1c6fc7ec2d$var$_typeof = $eO1fC.default;

var $7LSnL = parcelRequire("7LSnL");
function $afbcdb1c6fc7ec2d$var$toPropertyKey(t) {
    var i = $7LSnL(t, "string");
    return "symbol" == $afbcdb1c6fc7ec2d$var$_typeof(i) ? i : i + "";
}
module.exports = $afbcdb1c6fc7ec2d$var$toPropertyKey, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("eO1fC", function(module, exports) {
function $ac76b498fc846b3d$var$_typeof(o) {
    "@babel/helpers - typeof";
    return module.exports = $ac76b498fc846b3d$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $ac76b498fc846b3d$var$_typeof(o);
}
module.exports = $ac76b498fc846b3d$var$_typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("7LSnL", function(module, exports) {

var $eO1fC = parcelRequire("eO1fC");
var $5a871b64c061ef1e$var$_typeof = $eO1fC.default;
function $5a871b64c061ef1e$var$toPrimitive(t, r) {
    if ("object" != $5a871b64c061ef1e$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $5a871b64c061ef1e$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
module.exports = $5a871b64c061ef1e$var$toPrimitive, module.exports.__esModule = true, module.exports["default"] = module.exports;

});



parcelRegister("kiwMz", function(module, exports) {
function $ec6eeafe38b8070c$var$_assertThisInitialized(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}
module.exports = $ec6eeafe38b8070c$var$_assertThisInitialized, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("3aqaY", function(module, exports) {

var $krbKB = parcelRequire("krbKB");
function $24e69c430a154488$var$_get() {
    return module.exports = $24e69c430a154488$var$_get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function(e, t, r) {
        var p = $krbKB(e, t);
        if (p) {
            var n = Object.getOwnPropertyDescriptor(p, t);
            return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value;
        }
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $24e69c430a154488$var$_get.apply(null, arguments);
}
module.exports = $24e69c430a154488$var$_get, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("krbKB", function(module, exports) {

var $3R66t = parcelRequire("3R66t");
function $ee0f71b778c52061$var$_superPropBase(t, o) {
    for(; !({}).hasOwnProperty.call(t, o) && null !== (t = $3R66t(t)););
    return t;
}
module.exports = $ee0f71b778c52061$var$_superPropBase, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("3R66t", function(module, exports) {
function $2ceb0e5804b9823d$var$_getPrototypeOf(t) {
    return module.exports = $2ceb0e5804b9823d$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $2ceb0e5804b9823d$var$_getPrototypeOf(t);
}
module.exports = $2ceb0e5804b9823d$var$_getPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

});



parcelRegister("dL20p", function(module, exports) {

var $5trdv = parcelRequire("5trdv");
function $a041386ec87a8973$var$_inherits(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && $5trdv(t, e);
}
module.exports = $a041386ec87a8973$var$_inherits, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("5trdv", function(module, exports) {
function $3fc4c5e5f9a39b7b$var$_setPrototypeOf(t, e) {
    return module.exports = $3fc4c5e5f9a39b7b$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $3fc4c5e5f9a39b7b$var$_setPrototypeOf(t, e);
}
module.exports = $3fc4c5e5f9a39b7b$var$_setPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("bLzyD", function(module, exports) {

var $eO1fC = parcelRequire("eO1fC");
var $890faa7f3f7ffbf9$var$_typeof = $eO1fC.default;

var $kiwMz = parcelRequire("kiwMz");
function $890faa7f3f7ffbf9$var$_possibleConstructorReturn(t, e) {
    if (e && ("object" == $890faa7f3f7ffbf9$var$_typeof(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return $kiwMz(t);
}
module.exports = $890faa7f3f7ffbf9$var$_possibleConstructorReturn, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("2VFrg", function(module, exports) {

var $f5rL9 = parcelRequire("f5rL9");
function $22210c7f7f072b91$var$_defineProperty(e, r, t) {
    return (r = $f5rL9(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
module.exports = $22210c7f7f072b91$var$_defineProperty, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("e4Kx4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a3f588c136d88636$export$2e2bcd8739ae039; });

var $eO1fC = parcelRequire("eO1fC");

var $lfZoe = parcelRequire("lfZoe");

var $5XY5L = parcelRequire("5XY5L");

var $2VFrg = parcelRequire("2VFrg");
function $a3f588c136d88636$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $a3f588c136d88636$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $a3f588c136d88636$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($2VFrg)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $a3f588c136d88636$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $a3f588c136d88636$export$ad4be5c2ec28cecf = function isAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $a3f588c136d88636$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === "AnalyticsEvent";
};
var $a3f588c136d88636$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function AnalyticsEvent(props) {
        var _this = this;
        (0, (/*@__PURE__*/$parcel$interopDefault($lfZoe)))(this, AnalyticsEvent);
        (0, (/*@__PURE__*/$parcel$interopDefault($2VFrg)))(this, "_isAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($2VFrg)))(this, "clone", function() {
            // just a shallow clone, don't change sub refs unless you want to
            // affect the original's too
            var payload = $a3f588c136d88636$var$_objectSpread({}, _this.payload);
            return new AnalyticsEvent({
                payload: payload
            });
        });
        this.payload = props.payload;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($5XY5L)))(AnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (typeof updater === "function") this.payload = updater(this.payload);
                if ((0, (/*@__PURE__*/$parcel$interopDefault($eO1fC)))(updater) === "object") this.payload = $a3f588c136d88636$var$_objectSpread($a3f588c136d88636$var$_objectSpread({}, this.payload), updater);
                return this;
            }
        }
    ]);
    return AnalyticsEvent;
}();

});


parcelRegister("bXyzO", function(module, exports) {

$parcel$export(module.exports, "useAnalyticsContext", function () { return $8b50069ccf8733d3$export$d1f587f82ad51c4; });

var $dAx5m = parcelRequire("dAx5m");

var $h0bf1 = parcelRequire("h0bf1");
var $8b50069ccf8733d3$export$d1f587f82ad51c4 = function useAnalyticsContext() {
    return (0, $dAx5m.useContext)((0, $h0bf1.default));
};

});


parcelRegister("cUDwB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $96695fca9a40c6e5$export$2e2bcd8739ae039; });

var $7SVKm = parcelRequire("7SVKm");

var $guLLE = parcelRequire("guLLE");

var $dAx5m = parcelRequire("dAx5m");

var $jVTBW = parcelRequire("jVTBW");

var $60l6m = parcelRequire("60l6m");

var $cqYCf = parcelRequire("cqYCf");

var $5MUVm = parcelRequire("5MUVm");

var $6NpRk = parcelRequire("6NpRk");
function $96695fca9a40c6e5$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $96695fca9a40c6e5$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $96695fca9a40c6e5$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($7SVKm)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $96695fca9a40c6e5$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $96695fca9a40c6e5$export$ebe0b8fe8b6acbfd = "var(--ds-icon-inverse, ".concat((0, $5MUVm.N0), ")");
var $96695fca9a40c6e5$export$72502e51aebdd94e = "var(--ds-icon-subtle, ".concat((0, $5MUVm.N90), ")");
var $96695fca9a40c6e5$var$avatarDefaultIconStyles = (0, $jVTBW.css)({
    display: "block",
    width: "100%",
    height: "100%",
    backgroundColor: $96695fca9a40c6e5$export$72502e51aebdd94e
});
var $96695fca9a40c6e5$var$nestedAvatarStyles = Object.entries((0, $6NpRk.AVATAR_SIZES)).reduce(function(styles, _ref) {
    var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($guLLE)))(_ref, 2), key = _ref2[0], size = _ref2[1];
    return $96695fca9a40c6e5$var$_objectSpread($96695fca9a40c6e5$var$_objectSpread({}, styles), {}, (0, (/*@__PURE__*/$parcel$interopDefault($7SVKm)))({}, key, (0, $jVTBW.css)({
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
        "& svg": {
            width: "".concat(size, "px"),
            height: "".concat(size, "px")
        }
    })));
}, {});
var $96695fca9a40c6e5$var$avatarImageStyles = (0, $jVTBW.css)({
    display: "flex",
    width: "100%",
    height: "100%",
    flex: "1 1 100%"
});
/**
 * __Avatar image__
 *
 * An avatar image is an internal component used to control the rendering phases of an image.
 */ var $96695fca9a40c6e5$var$AvatarImage = function AvatarImage(_ref3) {
    var _ref3$alt = _ref3.alt, alt = _ref3$alt === void 0 ? "" : _ref3$alt, src = _ref3.src, appearance = _ref3.appearance, size = _ref3.size, testId = _ref3.testId;
    var _useState = (0, $dAx5m.useState)(false), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($guLLE)))(_useState, 2), hasImageErrored = _useState2[0], setHasImageErrored = _useState2[1];
    var borderRadius = appearance === "circle" ? "50%" : "".concat((0, $6NpRk.AVATAR_RADIUS)[size], "px");
    // If src changes, reset state
    (0, $dAx5m.useEffect)(function() {
        setHasImageErrored(false);
    }, [
        src
    ]);
    if (!src || hasImageErrored) return (0, $jVTBW.jsx)("span", {
        css: [
            $96695fca9a40c6e5$var$avatarDefaultIconStyles,
            $96695fca9a40c6e5$var$nestedAvatarStyles[size]
        ]
    }, appearance === "circle" ? (0, $jVTBW.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($60l6m))), {
        label: alt,
        primaryColor: $96695fca9a40c6e5$export$ebe0b8fe8b6acbfd,
        secondaryColor: $96695fca9a40c6e5$export$72502e51aebdd94e,
        testId: testId && "".concat(testId, "--person")
    }) : (0, $jVTBW.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cqYCf))), {
        label: alt,
        primaryColor: $96695fca9a40c6e5$export$ebe0b8fe8b6acbfd,
        secondaryColor: $96695fca9a40c6e5$export$72502e51aebdd94e,
        testId: testId && "".concat(testId, "--ship")
    }));
    return (0, $jVTBW.jsx)("img", {
        src: src,
        alt: alt,
        "data-testid": testId && "".concat(testId, "--image"),
        css: $96695fca9a40c6e5$var$avatarImageStyles,
        style: {
            borderRadius: borderRadius
        },
        onError: function onError() {
            return setHasImageErrored(true);
        }
    });
};
var $96695fca9a40c6e5$export$2e2bcd8739ae039 = $96695fca9a40c6e5$var$AvatarImage;

});
parcelRegister("guLLE", function(module, exports) {

var $j0WTx = parcelRequire("j0WTx");

var $dMeHw = parcelRequire("dMeHw");

var $5Ck4g = parcelRequire("5Ck4g");

var $7Df6Q = parcelRequire("7Df6Q");
function $c0248059e0993425$var$_slicedToArray(r, e) {
    return $j0WTx(r) || $dMeHw(r, e) || $5Ck4g(r, e) || $7Df6Q();
}
module.exports = $c0248059e0993425$var$_slicedToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("j0WTx", function(module, exports) {
function $dd7bb3b13f521082$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
module.exports = $dd7bb3b13f521082$var$_arrayWithHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("dMeHw", function(module, exports) {
function $a07b295c2522136b$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
module.exports = $a07b295c2522136b$var$_iterableToArrayLimit, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("5Ck4g", function(module, exports) {

var $8ela9 = parcelRequire("8ela9");
function $417011623cf2cc5e$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $8ela9(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $8ela9(r, a) : void 0;
    }
}
module.exports = $417011623cf2cc5e$var$_unsupportedIterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("8ela9", function(module, exports) {
function $5fe00c09c431bcc8$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
module.exports = $5fe00c09c431bcc8$var$_arrayLikeToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("7Df6Q", function(module, exports) {
function $58e7e555c0b3eeba$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
module.exports = $58e7e555c0b3eeba$var$_nonIterableRest, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("60l6m", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $45f31c7f09cc4d98$var$_react = $45f31c7f09cc4d98$var$_interopRequireDefault((parcelRequire("dAx5m")));

var $9eGJl = parcelRequire("9eGJl");
function $45f31c7f09cc4d98$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $45f31c7f09cc4d98$var$PersonIcon = (props)=>/*#__PURE__*/ $45f31c7f09cc4d98$var$_react.default.createElement($9eGJl.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentColor" fill-rule="evenodd"><path d="M6 14c0-1.105.902-2 2.009-2h7.982c1.11 0 2.009.894 2.009 2.006v4.44c0 3.405-12 3.405-12 0V14z"/><circle cx="12" cy="7" r="4"/></g></svg>`
    }, props));
$45f31c7f09cc4d98$var$PersonIcon.displayName = "PersonIcon";
var $45f31c7f09cc4d98$var$_default = $45f31c7f09cc4d98$var$PersonIcon;
module.exports.default = $45f31c7f09cc4d98$var$_default;

});

parcelRegister("cqYCf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $90d6eecbe5f9350b$var$_react = $90d6eecbe5f9350b$var$_interopRequireDefault((parcelRequire("dAx5m")));

var $9eGJl = parcelRequire("9eGJl");
function $90d6eecbe5f9350b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $90d6eecbe5f9350b$var$ShipIcon = (props)=>/*#__PURE__*/ $90d6eecbe5f9350b$var$_react.default.createElement($9eGJl.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentColor" fill-rule="evenodd"><path d="M6 12h8v-2H6v2zM4 8.99C4 8.445 4.456 8 5.002 8h9.996C15.55 8 16 8.451 16 8.99V14H4V8.99z" fill-rule="nonzero"/><path d="M6 7.005C6 5.898 6.898 5 7.998 5h2.004C11.106 5 12 5.894 12 7.005V10H6V7.005zm4 0V7H7.999c.005 0 .002.003.002.005V8h2v-.995z"/><path d="M4.5 17h13.994l1.002-3H4.14l.36 3zm-2.495-4.012A.862.862 0 012.883 12h18.393c.55 0 .857.417.681.944l-1.707 5.112c-.174.521-.758.944-1.315.944H3.725a1.149 1.149 0 01-1.118-.988l-.602-5.024z" fill-rule="nonzero"/></g></svg>`
    }, props));
$90d6eecbe5f9350b$var$ShipIcon.displayName = "ShipIcon";
var $90d6eecbe5f9350b$var$_default = $90d6eecbe5f9350b$var$ShipIcon;
module.exports.default = $90d6eecbe5f9350b$var$_default;

});

parcelRegister("6NpRk", function(module, exports) {

$parcel$export(module.exports, "AVATAR_SIZES", function () { return $4f2b60bee06b3e7c$export$9a270941bcff7e77; });
$parcel$export(module.exports, "AVATAR_RADIUS", function () { return $4f2b60bee06b3e7c$export$e6da6efe4d1a5c9b; });
$parcel$export(module.exports, "BORDER_WIDTH", function () { return $4f2b60bee06b3e7c$export$e2bd4c1faded7921; });
$parcel$export(module.exports, "ACTIVE_SCALE_FACTOR", function () { return $4f2b60bee06b3e7c$export$89a980dfdf90df51; });
$parcel$export(module.exports, "ICON_SIZES", function () { return $4f2b60bee06b3e7c$export$fdc820179f1f9be4; });
$parcel$export(module.exports, "ICON_OFFSET", function () { return $4f2b60bee06b3e7c$export$382610e783aa2ae8; });
// eslint-disable-next-line @repo/internal/fs/filename-pattern-match, @atlaskit/design-system/no-deprecated-imports

var $6W4m7 = parcelRequire("6W4m7");
var $4f2b60bee06b3e7c$export$9a270941bcff7e77 = {
    xsmall: (0, $6W4m7.gridSize)() * 2,
    small: (0, $6W4m7.gridSize)() * 3,
    medium: (0, $6W4m7.gridSize)() * 4,
    large: (0, $6W4m7.gridSize)() * 5,
    xlarge: (0, $6W4m7.gridSize)() * 12,
    xxlarge: (0, $6W4m7.gridSize)() * 16
};
var $4f2b60bee06b3e7c$export$e6da6efe4d1a5c9b = {
    xsmall: 2,
    small: 2,
    medium: 3,
    large: 3,
    xlarge: 6,
    xxlarge: 12
};
var $4f2b60bee06b3e7c$export$e2bd4c1faded7921 = 2;
var $4f2b60bee06b3e7c$export$89a980dfdf90df51 = 0.9;
var $4f2b60bee06b3e7c$export$3c061e31594ebabe = "--avatar-background-color";
var $4f2b60bee06b3e7c$export$fdc820179f1f9be4 = {
    small: 12,
    medium: 14,
    large: 15,
    xlarge: 18
};
var $4f2b60bee06b3e7c$export$382610e783aa2ae8 = {
    small: 0,
    medium: 0,
    large: 1,
    xlarge: 7
};

});


parcelRegister("a7SH5", function(module, exports) {

$parcel$export(module.exports, "PresenceWrapper", function () { return $75f4fbe463264bb4$export$972c5e90200fa0ef; });
// eslint-disable-next-line @repo/internal/fs/filename-pattern-match

var $dAx5m = parcelRequire("dAx5m");

var $5MUVm = parcelRequire("5MUVm");

var $6NpRk = parcelRequire("6NpRk");

var $4eTjy = parcelRequire("4eTjy");
var $75f4fbe463264bb4$var$BusyIndicator = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $dAx5m.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement("circle", {
    fill: "var(--ds-icon-danger, ".concat((0, $5MUVm.R300), ")"),
    cx: "4",
    cy: "4",
    r: "4"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement("path", {
    fill: "var(--ds-surface-overlay, ".concat((0, $5MUVm.N0), ")"),
    d: "M3.3,1.9l2.8,2.8c0.2,0.2,0.2,0.5,0,0.7L5.4,6.1c-0.2,0.2-0.5,0.2-0.7,0L1.9,3.3c-0.2-0.2-0.2-0.5,0-0.7l0.7-0.7C2.8,1.7,3.1,1.7,3.3,1.9z"
}));
var $75f4fbe463264bb4$var$FocusIndicator = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $dAx5m.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement("path", {
    fill: "var(--ds-icon-discovery, ".concat((0, $5MUVm.P300), ")"),
    d: "M4,8 C1.790861,8 0,6.209139 0,4 C0,1.790861 1.790861,0 4,0 C6.209139,0 8,1.790861 8,4 C8,6.209139 6.209139,8 4,8 Z M4,6.66666667 C5.47275933,6.66666667 6.66666667,5.47275933 6.66666667,4 C6.66666667,2.52724067 5.47275933,1.33333333 4,1.33333333 C2.52724067,1.33333333 1.33333333,2.52724067 1.33333333,4 C1.33333333,5.47275933 2.52724067,6.66666667 4,6.66666667 Z M4,5.33333333 C3.26362033,5.33333333 2.66666667,4.73637967 2.66666667,4 C2.66666667,3.26362033 3.26362033,2.66666667 4,2.66666667 C4.73637967,2.66666667 5.33333333,3.26362033 5.33333333,4 C5.33333333,4.73637967 4.73637967,5.33333333 4,5.33333333 Z"
}));
var $75f4fbe463264bb4$var$OfflineIndicator = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $dAx5m.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement("path", {
    fill: "var(--ds-text-subtlest, ".concat((0, $5MUVm.N200), ")"),
    d: "M4,8 C6.209139,8 8,6.209139 8,4 C8,1.790861 6.209139,0 4,0 C1.790861,0 0,1.790861 0,4 C0,6.209139 1.790861,8 4,8 Z M4,6 C5.1045695,6 6,5.1045695 6,4 C6,2.8954305 5.1045695,2 4,2 C2.8954305,2 2,2.8954305 2,4 C2,5.1045695 2.8954305,6 4,6 Z"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement("path", {
    fill: "var(--ds-surface-overlay, ".concat((0, $5MUVm.N40), ")"),
    d: "M4,6 C5.1045695,6 6,5.1045695 6,4 C6,2.8954305 5.1045695,2 4,2 C2.8954305,2 2,2.8954305 2,4 C2,5.1045695 2.8954305,6 4,6 Z"
}));
var $75f4fbe463264bb4$var$OnlineIndicator = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement("circle", {
    fill: "var(--ds-icon-success, ".concat((0, $5MUVm.G300), ")"),
    cx: "4",
    cy: "4",
    r: "4"
});
function $75f4fbe463264bb4$var$getPresence(presence) {
    switch(presence){
        case "busy":
            return $75f4fbe463264bb4$var$BusyIndicator;
        case "focus":
            return $75f4fbe463264bb4$var$FocusIndicator;
        case "offline":
            return $75f4fbe463264bb4$var$OfflineIndicator;
        case "online":
            return $75f4fbe463264bb4$var$OnlineIndicator;
    }
}
/**
 * __Avatar presence__
 *
 * A presence shows an avatar’s availability.
 *
 * - [Examples](https://atlassian.design/components/avatar/avatar-presence/examples)
 * - [Code](https://atlassian.design/components/avatar/avatar-presence/code)
 * - [Usage](https://atlassian.design/components/avatar/avatar-presence/usage)
 */ var $75f4fbe463264bb4$var$AvatarPresence = function AvatarPresence(_ref) {
    var borderColor = _ref.borderColor, children = _ref.children, presence = _ref.presence;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $4eTjy.default), {
        bgColor: borderColor
    }, presence ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement("svg", {
        height: "100%",
        version: "1.1",
        viewBox: "0 0 8 8",
        width: "100%",
        xmlns: "http://www.w3.org/2000/svg"
    }, $75f4fbe463264bb4$var$getPresence(presence)) : children);
};
var $75f4fbe463264bb4$export$2e2bcd8739ae039 = $75f4fbe463264bb4$var$AvatarPresence;
var $75f4fbe463264bb4$export$972c5e90200fa0ef = function PresenceWrapper(_ref2) {
    var size = _ref2.size, appearance = _ref2.appearance, children = _ref2.children, borderColor = _ref2.borderColor, presence = _ref2.presence, testId = _ref2.testId;
    var position = appearance === "square" ? -4 : (0, $6NpRk.ICON_OFFSET)[size];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement("span", {
        "data-testid": testId && "".concat(testId, "--presence"),
        style: {
            pointerEvents: "none",
            position: "absolute",
            bottom: "".concat(position, "px"),
            height: "".concat((0, $6NpRk.ICON_SIZES)[size], "px"),
            right: "".concat(position, "px"),
            width: "".concat((0, $6NpRk.ICON_SIZES)[size], "px")
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement($75f4fbe463264bb4$var$AvatarPresence, {
        borderColor: borderColor,
        presence: !children ? presence : undefined
    }, children));
};

});
parcelRegister("4eTjy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3163608a1921b587$export$2e2bcd8739ae039; });
/** @jsx jsx */ // eslint-disable-next-line @repo/internal/fs/filename-pattern-match

var $jVTBW = parcelRequire("jVTBW");

var $5MUVm = parcelRequire("5MUVm");

var $6NpRk = parcelRequire("6NpRk");
var $3163608a1921b587$var$iconWrapperStyles = (0, $jVTBW.css)({
    display: "flex",
    boxSizing: "border-box",
    width: "100%",
    height: "100%",
    alignItems: "center",
    alignContent: "center",
    borderRadius: "var(--ds-border-radius-circle, 50%)",
    overflow: "hidden"
});
/**
 * __Icon wrapper__
 *
 * An icon wrapper is used internally only.
 */ var $3163608a1921b587$var$IconWrapper = function IconWrapper(_ref) {
    var _ref$bgColor = _ref.bgColor, bgColor = _ref$bgColor === void 0 ? "var(--ds-surface-overlay, ".concat((0, $5MUVm.N0), ")") : _ref$bgColor, children = _ref.children;
    return (0, $jVTBW.jsx)("span", {
        css: $3163608a1921b587$var$iconWrapperStyles,
        role: "presentation",
        style: {
            border: "".concat((0, $6NpRk.BORDER_WIDTH), "px solid ").concat(bgColor),
            backgroundColor: bgColor
        }
    }, children);
};
var $3163608a1921b587$export$2e2bcd8739ae039 = $3163608a1921b587$var$IconWrapper;

});


parcelRegister("2QMjz", function(module, exports) {

$parcel$export(module.exports, "StatusWrapper", function () { return $2135ea66de9c4bce$export$8045894f255f9726; });
// eslint-disable-next-line @repo/internal/fs/filename-pattern-match

var $dAx5m = parcelRequire("dAx5m");

var $5MUVm = parcelRequire("5MUVm");

var $6NpRk = parcelRequire("6NpRk");

var $4eTjy = parcelRequire("4eTjy");
var $2135ea66de9c4bce$var$ApprovedIndicator = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $dAx5m.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement("circle", {
    fill: "var(--ds-icon-success, ".concat((0, $5MUVm.G400), ")"),
    cx: "4",
    cy: "4",
    r: "4"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement("path", {
    fill: "var(--ds-surface-overlay, ".concat((0, $5MUVm.N0), ")"),
    d: "M2.47140452,3.52859548 C2.21105499,3.26824595 1.78894501,3.26824595 1.52859548,3.52859548 C1.26824595,3.78894501 1.26824595,4.21105499 1.52859548,4.47140452 L2.86192881,5.80473785 C3.12227834,6.06508738 3.54438833,6.06508738 3.80473785,5.80473785 L6.47140452,3.13807119 C6.73175405,2.87772166 6.73175405,2.45561167 6.47140452,2.19526215 C6.21105499,1.93491262 5.78894501,1.93491262 5.52859548,2.19526215 L3.33333333,4.39052429 L2.47140452,3.52859548 Z"
}));
var $2135ea66de9c4bce$var$DeclinedIndicator = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $dAx5m.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement("circle", {
    fill: "var(--ds-icon-danger, ".concat((0, $5MUVm.R400), ")"),
    cx: "4",
    cy: "4",
    r: "4"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement("path", {
    fill: "var(--ds-surface-overlay, ".concat((0, $5MUVm.N0), ")"),
    d: "M4.890661,4.0088336 L5.81806461,3.07802178 C6.06167933,2.83351177 6.06048933,2.43826992 5.81540668,2.19522442 C5.57032402,1.95217891 5.17415651,1.95336612 4.93054179,2.19787613 L4.00765946,3.12415007 L3.06906871,2.18377143 C2.82523777,1.93947602 2.42906937,1.93863765 2.18420182,2.18189887 C1.93933427,2.42516008 1.93849394,2.82040282 2.18232488,3.06469822 L3.12544091,4.00961077 L2.20275024,4.93569234 C1.95913552,5.18020236 1.96032551,5.5754442 2.20540817,5.81848971 C2.45049083,6.06153521 2.84665833,6.060348 3.09027306,5.81583799 L4.00844245,4.89429431 L4.9092123,5.79678001 C5.15304324,6.04107541 5.54921164,6.04191379 5.79407919,5.79865257 C6.03894674,5.55539135 6.03978708,5.16014862 5.79595614,4.91585321 L4.890661,4.0088336 Z"
}));
var $2135ea66de9c4bce$var$LockedIndicator = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $dAx5m.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement("circle", {
    fill: "var(--ds-text-subtlest, ".concat((0, $5MUVm.N40), ")"),
    cx: "4",
    cy: "4",
    r: "4"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement("path", {
    fill: "var(--ds-surface-overlay, ".concat((0, $5MUVm.N500), ")"),
    d: "M4.13074827,1.21766493 L4.10368158,1.21766493 C3.36340745,1.21766493 2.76388015,1.80793503 2.76388015,2.5367787 L2.76388015,3.21632216 L3.44054754,3.21632216 L3.44054754,2.54344089 C3.44054754,2.17901906 3.74031119,1.88388401 4.11044825,1.88388401 L4.1239816,1.88388401 C4.49411866,1.88388401 4.79388232,2.17901906 4.79388232,2.54344089 L4.79388232,3.21632216 L5.47054971,3.21632216 L5.47054971,2.5367787 C5.47054971,1.80793503 4.8710224,1.21766493 4.13074827,1.21766493 M2.76388015,3.21632216 L3.44054754,3.21632216 L3.44054754,3.88254123 L2.76388015,3.88254123 L2.76388015,3.21632216 Z M4.79388232,3.21632216 L5.47054971,3.21632216 L5.47054971,3.88254123 L4.79388232,3.88254123 L4.79388232,3.21632216 Z M4.79401765,3.88254123 L3.44068287,3.88254123 L2.76401548,3.88254123 C2.39049508,3.88254123 2.08734809,4.18100738 2.08734809,4.54876031 L2.08734809,5.54808892 C2.08734809,6.10000287 2.53735205,6.54741753 3.09094491,6.54741753 L5.14375561,6.54741753 C5.69802683,6.54741753 6.14735243,6.10385072 6.14735243,5.54808892 L6.14735243,4.54876031 C6.14735243,4.18100738 5.84420544,3.88254123 5.47068504,3.88254123 L4.79401765,3.88254123 Z"
}));
function $2135ea66de9c4bce$var$getStatus(status) {
    switch(status){
        case "approved":
            return $2135ea66de9c4bce$var$ApprovedIndicator;
        case "declined":
            return $2135ea66de9c4bce$var$DeclinedIndicator;
        case "locked":
            return $2135ea66de9c4bce$var$LockedIndicator;
    }
}
/**
 * __Avatar status__
 *
 * An avatar status shows contextual information, such as if someone approves or declines something.
 *
 * - [Examples](https://atlassian.design/components/avatar/avatar-status/examples)
 * - [Code](https://atlassian.design/components/avatar/avatar-status/code)
 */ var $2135ea66de9c4bce$var$AvatarStatus = function AvatarStatus(_ref) {
    var borderColor = _ref.borderColor, children = _ref.children, status = _ref.status;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $4eTjy.default), {
        bgColor: borderColor
    }, status ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement("svg", {
        height: "100%",
        version: "1.1",
        viewBox: "0 0 8 8",
        width: "100%",
        xmlns: "http://www.w3.org/2000/svg"
    }, $2135ea66de9c4bce$var$getStatus(status)) : children);
};
var $2135ea66de9c4bce$export$2e2bcd8739ae039 = $2135ea66de9c4bce$var$AvatarStatus;
var $2135ea66de9c4bce$export$8045894f255f9726 = function StatusWrapper(_ref2) {
    var size = _ref2.size, status = _ref2.status, appearance = _ref2.appearance, borderColor = _ref2.borderColor, children = _ref2.children, testId = _ref2.testId;
    var position = appearance === "square" ? 0 : (0, $6NpRk.ICON_OFFSET)[size];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement("span", {
        "data-testid": testId && "".concat(testId, "--status"),
        style: {
            position: "absolute",
            height: "".concat((0, $6NpRk.ICON_SIZES)[size], "px"),
            right: "".concat(position, "px"),
            top: "".concat(position, "px"),
            width: "".concat((0, $6NpRk.ICON_SIZES)[size], "px")
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement($2135ea66de9c4bce$var$AvatarStatus, {
        borderColor: borderColor,
        status: !children ? status : undefined
    }, children));
};

});

parcelRegister("cfnBx", function(module, exports) {

$parcel$export(module.exports, "getLinkProps", function () { return $8ea93216a76d79af$export$60113ebe1cf0ecf; });
$parcel$export(module.exports, "getButtonProps", function () { return $8ea93216a76d79af$export$cca6f1bef43616d3; });
$parcel$export(module.exports, "getCustomElement", function () { return $8ea93216a76d79af$export$83ee468102cdf04c; });
// eslint-disable-next-line @repo/internal/fs/filename-pattern-match
var $8ea93216a76d79af$export$60113ebe1cf0ecf = function getLinkProps(href, target) {
    return {
        href: href,
        rel: target === "_blank" ? "noopener noreferrer" : null,
        target: target
    };
};
var $8ea93216a76d79af$export$cca6f1bef43616d3 = function getButtonProps(onClick) {
    return {
        type: "button",
        onClick: onClick
    };
};
var $8ea93216a76d79af$export$83ee468102cdf04c = function getCustomElement(isDisabled, href, onClick) {
    if (href && !isDisabled) return "a";
    if (onClick || isDisabled) return "button";
    return "span";
};

});


parcelRegister("cRCIP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $95d878a782e530a4$export$2e2bcd8739ae039; });

var $ikNYA = parcelRequire("ikNYA");

var $gd5aU = parcelRequire("gd5aU");

var $dAx5m = parcelRequire("dAx5m");

var $2Dg3J = parcelRequire("2Dg3J");

var $hSAXR = parcelRequire("hSAXR");

var $5Xjg2 = parcelRequire("5Xjg2");

var $g061O = parcelRequire("g061O");

var $6XugO = parcelRequire("6XugO");
var $95d878a782e530a4$var$_excluded = [
    "children",
    "component",
    "description",
    "elemAfter",
    "elemBefore",
    "href",
    "isDisabled",
    "isSelected",
    "onClick",
    "rel",
    "shouldDescriptionWrap",
    "shouldTitleWrap",
    "target",
    "testId"
];
/**
 * __Dropdown menu item__
 *
 * A dropdown item populates the dropdown menu with items. Every item should be inside a dropdown item group.
 *
 * - [Examples](https://atlassian.design/components/dropdown-item/examples)
 * - [Code](https://atlassian.design/components/dropdown-item/code)
 * - [Usage](https://atlassian.design/components/dropdown-item/usage)
 */ var $95d878a782e530a4$var$DropdownMenuItem = /*#__PURE__*/ (0, $dAx5m.forwardRef)(function(_ref, ref) {
    var children = _ref.children, component = _ref.component, description = _ref.description, elemAfter = _ref.elemAfter, elemBefore = _ref.elemBefore, href = _ref.href, isDisabled = _ref.isDisabled, isSelected = _ref.isSelected, onClick = _ref.onClick, rel = _ref.rel, _ref$shouldDescriptio = _ref.shouldDescriptionWrap, shouldDescriptionWrap = _ref$shouldDescriptio === void 0 ? true : _ref$shouldDescriptio, _ref$shouldTitleWrap = _ref.shouldTitleWrap, shouldTitleWrap = _ref$shouldTitleWrap === void 0 ? true : _ref$shouldTitleWrap, target = _ref.target, testId = _ref.testId, rest = (0, (/*@__PURE__*/$parcel$interopDefault($gd5aU)))(_ref, $95d878a782e530a4$var$_excluded);
    var itemRef = (0, $6XugO.default)();
    if (component) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $5Xjg2.default), (0, (/*@__PURE__*/$parcel$interopDefault($ikNYA)))({
        component: component,
        description: description,
        iconAfter: elemAfter,
        iconBefore: elemBefore,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: onClick,
        ref: (0, $2Dg3J.default)([
            ref,
            itemRef
        ]),
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        testId: testId,
        href: href,
        target: target,
        rel: rel
    }, rest), children);
    else if (href) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $g061O.default), (0, (/*@__PURE__*/$parcel$interopDefault($ikNYA)))({
        description: description,
        href: href,
        iconAfter: elemAfter,
        iconBefore: elemBefore,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: onClick,
        ref: (0, $2Dg3J.default)([
            ref,
            itemRef
        ]),
        rel: rel,
        role: "menuitem",
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        target: target,
        testId: testId
    }, rest), children);
    else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $hSAXR.default), (0, (/*@__PURE__*/$parcel$interopDefault($ikNYA)))({
        description: description,
        iconAfter: elemAfter,
        iconBefore: elemBefore,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: onClick,
        ref: (0, $2Dg3J.default)([
            ref,
            itemRef
        ]),
        role: "menuitem",
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        testId: testId,
        target: target,
        rel: rel
    }, rest), children);
});
var $95d878a782e530a4$export$2e2bcd8739ae039 = $95d878a782e530a4$var$DropdownMenuItem;

});
parcelRegister("ikNYA", function(module, exports) {
function $d590dc758a3a2271$var$_extends() {
    return module.exports = $d590dc758a3a2271$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $d590dc758a3a2271$var$_extends.apply(null, arguments);
}
module.exports = $d590dc758a3a2271$var$_extends, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("gd5aU", function(module, exports) {

var $5ikQ6 = parcelRequire("5ikQ6");
function $bcd1dfe6c0d80566$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $5ikQ6(e, t);
    if (Object.getOwnPropertySymbols) {
        var s = Object.getOwnPropertySymbols(e);
        for(r = 0; r < s.length; r++)o = s[r], t.includes(o) || ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
module.exports = $bcd1dfe6c0d80566$var$_objectWithoutProperties, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("5ikQ6", function(module, exports) {
function $3daecc7374bd6228$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.includes(n)) continue;
        t[n] = r[n];
    }
    return t;
}
module.exports = $3daecc7374bd6228$var$_objectWithoutPropertiesLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("hSAXR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d04427357a65129e$export$2e2bcd8739ae039; });

var $4VswB = parcelRequire("4VswB");

var $dtPp3 = parcelRequire("dtPp3");

var $dAx5m = parcelRequire("dAx5m");

var $jVTBW = parcelRequire("jVTBW");

var $e2xkU = parcelRequire("e2xkU");

var $Bb0he = parcelRequire("Bb0he");

var $xcnsi = parcelRequire("xcnsi");

var $f5Q5r = parcelRequire("f5Q5r");
var $d04427357a65129e$var$_excluded = [
    "children",
    "cssFn",
    "description",
    "iconAfter",
    "iconBefore",
    "isDisabled",
    "isSelected",
    "onClick",
    "testId",
    "overrides",
    "onMouseDown",
    "shouldTitleWrap",
    "shouldDescriptionWrap",
    "className"
];
/**
 * __Button item__
 *
 * A button item is used to populate a menu with items that are buttons.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/button-item)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ var $d04427357a65129e$var$ButtonItem = /*#__PURE__*/ (0, $dAx5m.memo)(/*#__PURE__*/ (0, $dAx5m.forwardRef)(// Type needed on props to extract types with extract react types.
function(props, ref) {
    var children = props.children, _props$cssFn = props.cssFn, cssFn = _props$cssFn === void 0 ? (0, $Bb0he.default) : _props$cssFn, description = props.description, iconAfter = props.iconAfter, iconBefore = props.iconBefore, _props$isDisabled = props.isDisabled, isDisabled = _props$isDisabled === void 0 ? false : _props$isDisabled, _props$isSelected = props.isSelected, isSelected = _props$isSelected === void 0 ? false : _props$isSelected, onClick = props.onClick, testId = props.testId, overrides = props.overrides, onMouseDown = props.onMouseDown, shouldTitleWrap = props.shouldTitleWrap, shouldDescriptionWrap = props.shouldDescriptionWrap, UNSAFE_className = props.className, rest = (0, (/*@__PURE__*/$parcel$interopDefault($dtPp3)))(props, $d04427357a65129e$var$_excluded);
    var onMouseDownHandler = onMouseDown;
    if (!children) return null;
    (0, $e2xkU.propDeprecationWarning)("@atlaskit/menu", "cssFn", cssFn !== (0, $Bb0he.default), "" // TODO: Create DAC post when primitives/xcss are available as alternatives
    );
    return (0, $jVTBW.jsx)((0, $f5Q5r.default), (0, (/*@__PURE__*/$parcel$interopDefault($4VswB)))({
        className: (0, $xcnsi.getBooleanFF)("platform.design-system-team.unsafe-overrides-killswitch_c8j9m") ? undefined : UNSAFE_className
    }, rest, {
        // eslint-disable-next-line @repo/internal/react/no-unsafe-overrides
        overrides: overrides,
        iconBefore: iconBefore,
        iconAfter: iconAfter,
        isDisabled: isDisabled,
        isSelected: isSelected,
        description: description,
        title: children,
        shouldTitleWrap: shouldTitleWrap,
        shouldDescriptionWrap: shouldDescriptionWrap,
        css: // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        cssFn({
            isSelected: isSelected,
            isDisabled: isDisabled
        }),
        testId: testId && "".concat(testId, "--primitive")
    }), function(_ref) {
        var children = _ref.children, className = _ref.className;
        return (0, $jVTBW.jsx)("button", (0, (/*@__PURE__*/$parcel$interopDefault($4VswB)))({
            "data-testid": testId
        }, rest, {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            ref: ref,
            disabled: isDisabled,
            onClick: onClick,
            onMouseDown: onMouseDownHandler,
            type: "button"
        }), children);
    });
}));
var $d04427357a65129e$export$2e2bcd8739ae039 = $d04427357a65129e$var$ButtonItem;

});
parcelRegister("4VswB", function(module, exports) {
function $39629cb7d4b484f8$var$_extends() {
    return module.exports = $39629cb7d4b484f8$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $39629cb7d4b484f8$var$_extends.apply(null, arguments);
}
module.exports = $39629cb7d4b484f8$var$_extends, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("dtPp3", function(module, exports) {

var $6ypJ9 = parcelRequire("6ypJ9");
function $9d05db66ae0023e0$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $6ypJ9(e, t);
    if (Object.getOwnPropertySymbols) {
        var s = Object.getOwnPropertySymbols(e);
        for(r = 0; r < s.length; r++)o = s[r], t.includes(o) || ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
module.exports = $9d05db66ae0023e0$var$_objectWithoutProperties, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("6ypJ9", function(module, exports) {
function $4c59dfefcf74b112$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.includes(n)) continue;
        t[n] = r[n];
    }
    return t;
}
module.exports = $4c59dfefcf74b112$var$_objectWithoutPropertiesLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("xcnsi", function(module, exports) {

$parcel$export(module.exports, "getBooleanFF", function () { return $063caf0f03c34fa7$export$470e5c2be1411c89; });

var $7IEQj = parcelRequire("7IEQj");
function $063caf0f03c34fa7$export$ba05d765b8392e5e(flagResolver) {
    (0, $7IEQj.setBooleanResolver)(flagResolver);
}
function $063caf0f03c34fa7$export$470e5c2be1411c89(name) {
    return (0, $7IEQj.resolveBooleanFlag)(name);
}
function $063caf0f03c34fa7$export$b40ec24ac8275656(name) {
    return (0, $7IEQj.resolveBooleanFlag)(name);
}

});
parcelRegister("7IEQj", function(module, exports) {

$parcel$export(module.exports, "setBooleanResolver", function () { return $59ec52f9a52ec191$export$f2b591175b3e424c; });
$parcel$export(module.exports, "resolveBooleanFlag", function () { return $59ec52f9a52ec191$export$6333b6aff9fc6275; });

var $dYaPc = parcelRequire("dYaPc");

var $ahJoN = parcelRequire("ahJoN");
var $59ec52f9a52ec191$var$pkgName = "@atlaskit/platform-feature-flags";
var $59ec52f9a52ec191$export$7e41b1b2bdee3f98 = "__PLATFORM_FEATURE_FLAGS__";
var $59ec52f9a52ec191$var$hasProcessEnv = typeof $ahJoN !== "undefined" && typeof $ahJoN.env !== "undefined";
// FF global overrides can be configured by test runners or Storybook
var $59ec52f9a52ec191$var$ENV_ENABLE_PLATFORM_FF = $59ec52f9a52ec191$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
// STORYBOOK_ENABLE_PLATFORM_FF is included as storybook only allows env vars prefixed with STORYBOOK
// https://github.com/storybookjs/storybook/issues/12270
var $59ec52f9a52ec191$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF = $59ec52f9a52ec191$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
var $59ec52f9a52ec191$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE = $59ec52f9a52ec191$var$ENV_ENABLE_PLATFORM_FF || $59ec52f9a52ec191$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF;
var $59ec52f9a52ec191$var$DEFAULT_PFF_GLOBAL = {
    // In development mode we want to capture any feature flag checks that happen using the default resolver and log this result when the resolver is replaced.
    // This is because evaluating feature flags when the resolver/FF client is loaded asynchronously could cause unexpected issues.
    earlyResolvedFlags: new Map(),
    booleanResolver: function booleanResolver(flagKey) {
        var unresolvedFlagCount;
        return false;
    }
};
var $59ec52f9a52ec191$var$globalVar = typeof window !== "undefined" ? window : globalThis;
$59ec52f9a52ec191$var$globalVar[$59ec52f9a52ec191$export$7e41b1b2bdee3f98] = $59ec52f9a52ec191$var$globalVar[$59ec52f9a52ec191$export$7e41b1b2bdee3f98] || $59ec52f9a52ec191$var$DEFAULT_PFF_GLOBAL;
function $59ec52f9a52ec191$export$f2b591175b3e424c(resolver) {
    $59ec52f9a52ec191$var$globalVar[$59ec52f9a52ec191$export$7e41b1b2bdee3f98].booleanResolver = resolver;
    var _globalVar$PFF_GLOBAL;
}
function $59ec52f9a52ec191$export$6333b6aff9fc6275(flagKey) {
    if ($59ec52f9a52ec191$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE) {
        (0, $dYaPc.debug)('[%s]: The feature flags were enabled while running tests. The flag "%s" will be always enabled.', $59ec52f9a52ec191$var$pkgName, flagKey);
        return true;
    }
    try {
        var _globalVar$PFF_GLOBAL2;
        var result = (_globalVar$PFF_GLOBAL2 = $59ec52f9a52ec191$var$globalVar[$59ec52f9a52ec191$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL2 === void 0 ? void 0 : _globalVar$PFF_GLOBAL2.booleanResolver(flagKey);
        if (typeof result !== "boolean") {
            // eslint-disable-next-line no-console
            console.warn("".concat(flagKey, " resolved to a non-boolean value, returning false for safety"));
            return false;
        }
        return result;
    } catch (e) {
        return false;
    }
}

});
parcelRegister("dYaPc", function(module, exports) {

$parcel$export(module.exports, "debug", function () { return $a2b946847a3879ae$export$1c9f709888824e05; });
var $a2b946847a3879ae$var$_ref, $a2b946847a3879ae$var$_process, $a2b946847a3879ae$var$_process2;
// We can't rely on NODE_ENV === 'test' if its value is already configured by the consumer to some other value, so better to use JEST_WORKER_ID
// https://jestjs.io/docs/environment-variables#jest_worker_id
var $a2b946847a3879ae$var$TESTS_MODE = ($a2b946847a3879ae$var$_ref = (globalThis === null || globalThis === void 0 || ($a2b946847a3879ae$var$_process = globalThis.process) === null || $a2b946847a3879ae$var$_process === void 0 || ($a2b946847a3879ae$var$_process = $a2b946847a3879ae$var$_process.env) === null || $a2b946847a3879ae$var$_process === void 0 ? void 0 : $a2b946847a3879ae$var$_process.JEST_WORKER_ID) !== undefined, $a2b946847a3879ae$var$_ref !== void 0) ? $a2b946847a3879ae$var$_ref : false;
var $a2b946847a3879ae$var$DEBUG_MODE = !$a2b946847a3879ae$var$TESTS_MODE && (globalThis === null || globalThis === void 0 || ($a2b946847a3879ae$var$_process2 = globalThis.process) === null || $a2b946847a3879ae$var$_process2 === void 0 || ($a2b946847a3879ae$var$_process2 = $a2b946847a3879ae$var$_process2.env) === null || $a2b946847a3879ae$var$_process2 === void 0 ? void 0 : $a2b946847a3879ae$var$_process2.NODE_ENV) !== "production";
var $a2b946847a3879ae$export$1c9f709888824e05 = function debug() {
    var _console;
    if (!$a2b946847a3879ae$var$DEBUG_MODE) return;
    // eslint-disable-next-line no-console
    (_console = console).debug.apply(_console, arguments);
};

});



parcelRegister("f5Q5r", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $afcfb9f92b072c50$export$2e2bcd8739ae039; });
/** @jsx jsx */ 
var $dAx5m = parcelRequire("dAx5m");

var $jVTBW = parcelRequire("jVTBW");

var $e2xkU = parcelRequire("e2xkU");

var $iAyBE = parcelRequire("iAyBE");

var $xcnsi = parcelRequire("xcnsi");

var $fXJx8 = parcelRequire("fXJx8");
var $cCgQd = parcelRequire("cCgQd");
var $bH6cj = parcelRequire("bH6cj");

var $9lCOE = parcelRequire("9lCOE");

var $kdvLB = parcelRequire("kdvLB");
var $afcfb9f92b072c50$var$defaultRender = function defaultRender(Component, props) {
    return(// eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    (0, $jVTBW.jsx)(Component, props));
};
var $afcfb9f92b072c50$var$beforeAfterElementStyles = (0, $jVTBW.css)({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0
});
var $afcfb9f92b072c50$var$contentStyles = (0, $bH6cj.xcss)({
    outline: "none",
    overflow: "hidden",
    textAlign: "left"
});
var $afcfb9f92b072c50$var$baseContentStyles = (0, $bH6cj.xcss)({
    lineHeight: "var(--ds-font-lineHeight-100, 16px)"
});
var $afcfb9f92b072c50$var$truncateStyles = (0, $jVTBW.css)({
    display: "block",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap"
});
var $afcfb9f92b072c50$var$titleStyles = (0, $jVTBW.css)({
    font: 'var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)'
});
var $afcfb9f92b072c50$var$wordBreakStyles = (0, $jVTBW.css)({
    wordBreak: "break-word"
});
var $afcfb9f92b072c50$var$descriptionStyles = (0, $jVTBW.css)({
    color: "var(--ds-text-subtlest, ".concat((0, $9lCOE.N200), ")")
});
var $afcfb9f92b072c50$var$baseDescriptionStyles = (0, $jVTBW.css)({
    fontSize: "var(--ds-font-size-075, 12px)",
    marginBlockStart: "var(--ds-space-050, 4px)"
});
var $afcfb9f92b072c50$var$tokenizedDescriptionStyles = (0, $jVTBW.css)({
    font: 'var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)'
});
var $afcfb9f92b072c50$var$disabledDescriptionStyles = (0, $jVTBW.css)({
    color: "var(--ds-text-disabled, ".concat((0, $9lCOE.N200), ")")
});
var $afcfb9f92b072c50$var$positionRelativeStyles = (0, $jVTBW.css)({
    position: "relative"
});
var $afcfb9f92b072c50$var$primitiveStyles = (0, $jVTBW.css)({
    display: "flex",
    boxSizing: "border-box",
    width: "100%",
    minHeight: 40,
    margin: "var(--ds-space-0, 0px)",
    alignItems: "center",
    border: 0,
    outline: 0,
    textDecoration: "none",
    userSelect: "none",
    "::-moz-focus-inner": {
        border: 0
    },
    ":hover": {
        textDecoration: "none"
    }
});
var $afcfb9f92b072c50$var$primitiveBaseStyles = (0, $jVTBW.css)({
    fontSize: "var(--ds-font-size-100, 14px)"
});
var $afcfb9f92b072c50$var$spacingMapStyles = {
    cozy: (0, $jVTBW.css)({
        // 8 * 2 (16) + icon (24) === 40
        paddingBlock: "var(--ds-space-100, 8px)",
        paddingInline: "var(--ds-space-200, 16px)"
    }),
    compact: (0, $jVTBW.css)({
        minHeight: 32,
        // 4 * 2 (8) + icon (24) === 32
        paddingBlock: "var(--ds-space-050, 4px)",
        paddingInline: "var(--ds-space-150, 12px)"
    })
};
var $afcfb9f92b072c50$var$interactiveStyles = (0, $jVTBW.css)({
    cursor: "pointer"
});
var $afcfb9f92b072c50$var$unselectedStyles = (0, $jVTBW.css)({
    backgroundColor: "var(--ds-background-neutral-subtle, transparent)",
    color: "currentColor",
    ":visited": {
        color: "currentColor"
    },
    ":hover": {
        backgroundColor: "var(--ds-background-neutral-subtle-hovered, ".concat((0, $9lCOE.N20), ")"),
        color: "currentColor"
    },
    ":active": {
        backgroundColor: "var(--ds-background-neutral-subtle-pressed, ".concat((0, $9lCOE.N30), ")"),
        boxShadow: "none",
        color: "currentColor"
    }
});
var $afcfb9f92b072c50$var$disabledStyles = (0, $jVTBW.css)({
    cursor: "not-allowed",
    "&, :hover, :active": {
        backgroundColor: "var(--ds-background-neutral-subtle, transparent)",
        color: "var(--ds-text-disabled, ".concat((0, $9lCOE.N200), ")")
    }
});
var $afcfb9f92b072c50$var$selectedBorderStyles = (0, $jVTBW.css)({
    "&::before": {
        width: 2,
        position: "absolute",
        background: "var(--ds-border-selected, transparent)",
        content: '""',
        insetBlockEnd: 0,
        insetBlockStart: 0,
        insetInlineStart: 0
    }
});
var $afcfb9f92b072c50$var$selectedNotchStyles = (0, $jVTBW.css)({
    "&::before": {
        width: 4,
        position: "absolute",
        background: "var(--ds-border-selected, transparent)",
        borderRadius: "0 ".concat("var(--ds-border-radius, 4px)", " ", "var(--ds-border-radius, 4px)", " 0"),
        content: '""',
        insetBlockEnd: "var(--ds-space-150, 12px)",
        insetBlockStart: "var(--ds-space-150, 12px)",
        insetInlineStart: 0
    }
});
var $afcfb9f92b072c50$var$selectedStyles = (0, $jVTBW.css)({
    backgroundColor: "var(--ds-background-selected, ".concat((0, $9lCOE.N20), ")"),
    // Fallback set as babel plugin inserts one otherwise
    color: "var(--ds-text-selected, currentColor)",
    ":visited": {
        color: "var(--ds-text-selected, currentColor)"
    },
    ":hover": {
        backgroundColor: "var(--ds-background-selected-hovered, ".concat((0, $9lCOE.N20), ")"),
        color: "var(--ds-text-selected, currentColor)"
    },
    ":active": {
        backgroundColor: "var(--ds-background-selected-pressed, ".concat((0, $9lCOE.N30), ")"),
        color: "var(--ds-text-selected, currentColor)"
    }
});
var $afcfb9f92b072c50$var$gapMap = {
    compact: "space.100",
    cozy: "space.150"
};
/**
 * __Menu item primitive__
 *
 * Menu item primitive contains all the styles for menu items,
 * including support for selected, disabled, and interaction states.
 *
 * Using children as function prop you wire up this to your own host element.
 *
 * ```jsx
 * <MenuItemPrimitive>
 *   {({ children, ...props }) => <button {...props}>{children}</button>}
 * </MenuItemPrimitive>
 * ```
 */ var $afcfb9f92b072c50$var$MenuItemPrimitive = function MenuItemPrimitive(_ref) {
    var children = _ref.children, title = _ref.title, description = _ref.description, iconAfter = _ref.iconAfter, iconBefore = _ref.iconBefore, overrides = _ref.overrides, UNSAFE_externalClassName = _ref.className, _ref$shouldTitleWrap = _ref.shouldTitleWrap, shouldTitleWrap = _ref$shouldTitleWrap === void 0 ? false : _ref$shouldTitleWrap, _ref$shouldDescriptio = _ref.shouldDescriptionWrap, shouldDescriptionWrap = _ref$shouldDescriptio === void 0 ? false : _ref$shouldDescriptio, _ref$isDisabled = _ref.isDisabled, isDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled, _ref$isSelected = _ref.isSelected, isSelected = _ref$isSelected === void 0 ? false : _ref$isSelected, testId = _ref.testId;
    (0, $e2xkU.propDeprecationWarning)("@atlaskit/menu", "overrides", overrides !== undefined, "" // TODO: Create DAC post when primitives/xcss are available as alternatives
    );
    var spacing = (0, $dAx5m.useContext)((0, $kdvLB.SpacingContext));
    var selectionStyle = (0, $dAx5m.useContext)((0, $kdvLB.SELECTION_STYLE_CONTEXT_DO_NOT_USE));
    var renderTitle = overrides && overrides.Title && overrides.Title.render || $afcfb9f92b072c50$var$defaultRender;
    var UNSAFE_className = (0, $xcnsi.getBooleanFF)("platform.design-system-team.unsafe-overrides-killswitch_c8j9m") ? undefined : UNSAFE_externalClassName;
    return (0, $jVTBW.jsx)((0, $jVTBW.ClassNames), null, function(_ref2) {
        var cn = _ref2.css, cx = _ref2.cx;
        return (0, $jVTBW.jsx)((0, $iAyBE.default), {
            isInset: true
        }, children({
            className: cx([
                cn([
                    $afcfb9f92b072c50$var$positionRelativeStyles,
                    $afcfb9f92b072c50$var$primitiveStyles,
                    (0, $xcnsi.getBooleanFF)("platform.design-system-team.menu-tokenised-typography-styles") ? undefined : $afcfb9f92b072c50$var$primitiveBaseStyles,
                    $afcfb9f92b072c50$var$spacingMapStyles[spacing],
                    !isDisabled && !isSelected && $afcfb9f92b072c50$var$unselectedStyles,
                    !isDisabled && isSelected && [
                        $afcfb9f92b072c50$var$selectedStyles,
                        [
                            selectionStyle === "border" && $afcfb9f92b072c50$var$selectedBorderStyles,
                            selectionStyle === "notch" && $afcfb9f92b072c50$var$selectedNotchStyles
                        ]
                    ],
                    isDisabled ? $afcfb9f92b072c50$var$disabledStyles : $afcfb9f92b072c50$var$interactiveStyles
                ]),
                UNSAFE_className
            ]),
            children: (0, $jVTBW.jsx)((0, $fXJx8.default), {
                as: "span",
                spread: "space-between",
                alignBlock: "center",
                space: $afcfb9f92b072c50$var$gapMap[spacing],
                grow: "fill",
                testId: testId && "".concat(testId, "--container")
            }, iconBefore && (0, $jVTBW.jsx)("span", {
                "data-item-elem-before": true,
                css: $afcfb9f92b072c50$var$beforeAfterElementStyles,
                "data-testid": testId && "".concat(testId, "--icon-before")
            }, iconBefore), title && (0, $jVTBW.jsx)((0, $cCgQd.default), {
                alignBlock: "center",
                grow: "fill",
                xcss: (0, $xcnsi.getBooleanFF)("platform.design-system-team.menu-tokenised-typography-styles") ? $afcfb9f92b072c50$var$contentStyles : [
                    $afcfb9f92b072c50$var$contentStyles,
                    $afcfb9f92b072c50$var$baseContentStyles
                ]
            }, renderTitle("span", {
                children: title,
                className: cn((0, $xcnsi.getBooleanFF)("platform.design-system-team.menu-tokenised-typography-styles") ? $afcfb9f92b072c50$var$titleStyles : undefined, shouldTitleWrap ? $afcfb9f92b072c50$var$wordBreakStyles : $afcfb9f92b072c50$var$truncateStyles),
                "data-item-title": true
            }), description && (0, $jVTBW.jsx)("span", {
                "data-item-description": true,
                css: [
                    $afcfb9f92b072c50$var$descriptionStyles,
                    (0, $xcnsi.getBooleanFF)("platform.design-system-team.menu-tokenised-typography-styles") ? $afcfb9f92b072c50$var$tokenizedDescriptionStyles : $afcfb9f92b072c50$var$baseDescriptionStyles,
                    isDisabled && $afcfb9f92b072c50$var$disabledDescriptionStyles,
                    shouldDescriptionWrap ? $afcfb9f92b072c50$var$wordBreakStyles : $afcfb9f92b072c50$var$truncateStyles
                ]
            }, description)), iconAfter && (0, $jVTBW.jsx)("span", {
                "data-item-elem-after": true,
                css: $afcfb9f92b072c50$var$beforeAfterElementStyles,
                "data-testid": testId && "".concat(testId, "--icon-after")
            }, iconAfter))
        }));
    });
};
var $afcfb9f92b072c50$export$2e2bcd8739ae039 = $afcfb9f92b072c50$var$MenuItemPrimitive;

});
parcelRegister("fXJx8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $02ffbca3feee0f95$export$2e2bcd8739ae039; });

var $bgA8z = parcelRequire("bgA8z");

var $dAx5m = parcelRequire("dAx5m");

var $jVTBW = parcelRequire("jVTBW");

var $bH6cj = parcelRequire("bH6cj");

var $1TEBh = parcelRequire("1TEBh");
var $02ffbca3feee0f95$var$flexGrowMap = {
    hug: (0, $bH6cj.xcss)({
        flexGrow: 0
    }),
    fill: (0, $bH6cj.xcss)({
        width: "100%",
        flexGrow: 1
    })
};
var $02ffbca3feee0f95$var$separatorStyles = (0, $jVTBW.css)({
    color: "var(--ds-text-subtle, #42526E)",
    marginBlock: "var(--ds-space-0, 0px)",
    marginInline: "var(--ds-space-negative-025, -2px)",
    pointerEvents: "none",
    userSelect: "none"
});
var $02ffbca3feee0f95$var$Separator = function Separator(_ref) {
    var children = _ref.children;
    return (0, $jVTBW.jsx)("span", {
        css: $02ffbca3feee0f95$var$separatorStyles
    }, children);
};
/**
 * __Inline__
 *
 * Inline is a primitive component based on CSS Flexbox that manages the horizontal layout of direct children.
 *
 * @example
 * ```tsx
 *  <Inline>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *  </Inline>
 * ```
 *
 */ var $02ffbca3feee0f95$var$Inline = /*#__PURE__*/ (0, $dAx5m.memo)(/*#__PURE__*/ (0, $dAx5m.forwardRef)(function(_ref2, ref) {
    var as = _ref2.as, alignInline = _ref2.alignInline, _ref2$alignBlock = _ref2.alignBlock, alignItems = _ref2$alignBlock === void 0 ? "start" : _ref2$alignBlock, _ref2$shouldWrap = _ref2.shouldWrap, shouldWrap = _ref2$shouldWrap === void 0 ? false : _ref2$shouldWrap, spread = _ref2.spread, grow = _ref2.grow, space = _ref2.space, rowSpace = _ref2.rowSpace, separator = _ref2.separator, xcss = _ref2.xcss, testId = _ref2.testId, role = _ref2.role, rawChildren = _ref2.children;
    var separatorComponent = typeof separator === "string" ? (0, $jVTBW.jsx)($02ffbca3feee0f95$var$Separator, null, separator) : separator;
    var children = separatorComponent ? (0, $dAx5m.Children).toArray(rawChildren).filter(Boolean).map(function(child, index) {
        return (0, $jVTBW.jsx)((0, $dAx5m.Fragment), {
            key: index
        }, separator && index > 0 ? separatorComponent : null, child);
    }) : rawChildren;
    var justifyContent = spread || alignInline;
    // We're type coercing this as Compiled styles in an array isn't supported by the types
    // But the runtime accepts it none-the-wiser. We can remove this entire block and replace
    // it with cx(defaultStyles, focusRingStyles, xcssStyles) when we've moved away from Emotion.
    var styles = grow ? [
        $02ffbca3feee0f95$var$flexGrowMap[grow]
    ].concat((0, (/*@__PURE__*/$parcel$interopDefault($bgA8z)))(Array.isArray(xcss) ? xcss : [
        xcss
    ])) : xcss;
    return (0, $jVTBW.jsx)((0, $1TEBh.default), {
        as: as,
        role: role,
        alignItems: alignItems,
        justifyContent: justifyContent,
        direction: "row",
        gap: space,
        rowGap: rowSpace,
        wrap: shouldWrap ? "wrap" : undefined,
        xcss: styles,
        testId: testId,
        ref: ref
    }, children);
}));
$02ffbca3feee0f95$var$Inline.displayName = "Inline";
var $02ffbca3feee0f95$export$2e2bcd8739ae039 = $02ffbca3feee0f95$var$Inline;

});
parcelRegister("bgA8z", function(module, exports) {

var $3HsmW = parcelRequire("3HsmW");

var $eCeJm = parcelRequire("eCeJm");

var $037ja = parcelRequire("037ja");

var $1Riug = parcelRequire("1Riug");
function $833d386ae5df857a$var$_toConsumableArray(r) {
    return $3HsmW(r) || $eCeJm(r) || $037ja(r) || $1Riug();
}
module.exports = $833d386ae5df857a$var$_toConsumableArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("3HsmW", function(module, exports) {

var $3lEhJ = parcelRequire("3lEhJ");
function $2b1b64bb794e4e43$var$_arrayWithoutHoles(r) {
    if (Array.isArray(r)) return $3lEhJ(r);
}
module.exports = $2b1b64bb794e4e43$var$_arrayWithoutHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("3lEhJ", function(module, exports) {
function $27029505b6dc4f50$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
module.exports = $27029505b6dc4f50$var$_arrayLikeToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("eCeJm", function(module, exports) {
function $aa400a812a362642$var$_iterableToArray(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
module.exports = $aa400a812a362642$var$_iterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("037ja", function(module, exports) {

var $3lEhJ = parcelRequire("3lEhJ");
function $0095f328b66f32c0$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $3lEhJ(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $3lEhJ(r, a) : void 0;
    }
}
module.exports = $0095f328b66f32c0$var$_unsupportedIterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("1Riug", function(module, exports) {
function $15a914d9768c2424$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
module.exports = $15a914d9768c2424$var$_nonIterableSpread, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("bH6cj", function(module, exports) {

$parcel$export(module.exports, "parseXcss", function () { return $883884948a00540c$export$a9c84988c8f81f2d; });
$parcel$export(module.exports, "xcss", function () { return $883884948a00540c$export$f6c783d06584602c; });

var $bgA8z = parcelRequire("bgA8z");

var $fzkYl = parcelRequire("fzkYl");

var $6eeGl = parcelRequire("6eeGl");

var $2EG9w = parcelRequire("2EG9w");

var $jVTBW = parcelRequire("jVTBW");

var $fZx25 = parcelRequire("fZx25");

var $ahJoN = parcelRequire("ahJoN");
function $883884948a00540c$var$_createForOfIteratorHelper(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (!it) {
        if (Array.isArray(o) || (it = $883884948a00540c$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
            if (it) o = it;
            var i = 0;
            var F = function F() {};
            return {
                s: F,
                n: function n() {
                    if (i >= o.length) return {
                        done: true
                    };
                    return {
                        done: false,
                        value: o[i++]
                    };
                },
                e: function e(_e) {
                    throw _e;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var normalCompletion = true, didErr = false, err;
    return {
        s: function s() {
            it = it.call(o);
        },
        n: function n() {
            var step = it.next();
            normalCompletion = step.done;
            return step;
        },
        e: function e(_e2) {
            didErr = true;
            err = _e2;
        },
        f: function f() {
            try {
                if (!normalCompletion && it.return != null) it.return();
            } finally{
                if (didErr) throw err;
            }
        }
    };
}
function $883884948a00540c$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $883884948a00540c$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $883884948a00540c$var$_arrayLikeToArray(o, minLen);
}
function $883884948a00540c$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $883884948a00540c$export$9a199fbafee0014e = {
    backgroundColor: (0, $fZx25.backgroundColorMap),
    blockSize: (0, $fZx25.dimensionMap),
    borderBlockColor: (0, $fZx25.borderColorMap),
    borderBlockEndColor: (0, $fZx25.borderColorMap),
    borderBlockEndWidth: (0, $fZx25.borderWidthMap),
    borderBlockStartColor: (0, $fZx25.borderColorMap),
    borderBlockStartWidth: (0, $fZx25.borderWidthMap),
    borderBlockWidth: (0, $fZx25.borderWidthMap),
    borderBottomColor: (0, $fZx25.borderColorMap),
    borderBottomLeftRadius: (0, $fZx25.borderRadiusMap),
    borderBottomRightRadius: (0, $fZx25.borderRadiusMap),
    borderBottomWidth: (0, $fZx25.borderWidthMap),
    borderColor: (0, $fZx25.borderColorMap),
    borderEndEndRadius: (0, $fZx25.borderRadiusMap),
    borderEndStartRadius: (0, $fZx25.borderRadiusMap),
    borderInlineColor: (0, $fZx25.borderColorMap),
    borderInlineEndColor: (0, $fZx25.borderColorMap),
    borderInlineEndWidth: (0, $fZx25.borderWidthMap),
    borderInlineStartColor: (0, $fZx25.borderColorMap),
    borderInlineStartWidth: (0, $fZx25.borderWidthMap),
    borderInlineWidth: (0, $fZx25.borderWidthMap),
    borderLeftColor: (0, $fZx25.borderColorMap),
    borderLeftWidth: (0, $fZx25.borderWidthMap),
    borderRadius: (0, $fZx25.borderRadiusMap),
    borderRightColor: (0, $fZx25.borderColorMap),
    borderRightWidth: (0, $fZx25.borderWidthMap),
    borderStartEndRadius: (0, $fZx25.borderRadiusMap),
    borderStartStartRadius: (0, $fZx25.borderRadiusMap),
    borderTopColor: (0, $fZx25.borderColorMap),
    borderTopLeftRadius: (0, $fZx25.borderRadiusMap),
    borderTopRightRadius: (0, $fZx25.borderRadiusMap),
    borderTopWidth: (0, $fZx25.borderWidthMap),
    borderWidth: (0, $fZx25.borderWidthMap),
    bottom: (0, $fZx25.allSpaceMap),
    boxShadow: (0, $fZx25.shadowMap),
    color: (0, $fZx25.textColorMap),
    columnGap: (0, $fZx25.positiveSpaceMap),
    gap: (0, $fZx25.positiveSpaceMap),
    height: (0, $fZx25.dimensionMap),
    inlineSize: (0, $fZx25.dimensionMap),
    inset: (0, $fZx25.allSpaceMap),
    insetBlock: (0, $fZx25.allSpaceMap),
    insetBlockEnd: (0, $fZx25.allSpaceMap),
    insetBlockStart: (0, $fZx25.allSpaceMap),
    insetInline: (0, $fZx25.allSpaceMap),
    insetInlineEnd: (0, $fZx25.allSpaceMap),
    insetInlineStart: (0, $fZx25.allSpaceMap),
    left: (0, $fZx25.allSpaceMap),
    margin: (0, $fZx25.allSpaceMap),
    marginBlock: (0, $fZx25.allSpaceMap),
    marginBlockEnd: (0, $fZx25.allSpaceMap),
    marginBlockStart: (0, $fZx25.allSpaceMap),
    marginBottom: (0, $fZx25.allSpaceMap),
    marginInline: (0, $fZx25.allSpaceMap),
    marginInlineEnd: (0, $fZx25.allSpaceMap),
    marginInlineStart: (0, $fZx25.allSpaceMap),
    marginLeft: (0, $fZx25.allSpaceMap),
    marginRight: (0, $fZx25.allSpaceMap),
    marginTop: (0, $fZx25.allSpaceMap),
    maxBlockSize: (0, $fZx25.dimensionMap),
    maxHeight: (0, $fZx25.dimensionMap),
    maxInlineSize: (0, $fZx25.dimensionMap),
    maxWidth: (0, $fZx25.dimensionMap),
    minBlockSize: (0, $fZx25.dimensionMap),
    minHeight: (0, $fZx25.dimensionMap),
    minInlineSize: (0, $fZx25.dimensionMap),
    minWidth: (0, $fZx25.dimensionMap),
    opacity: (0, $fZx25.opacityMap),
    outlineColor: (0, $fZx25.borderColorMap),
    outlineOffset: (0, $fZx25.positiveSpaceMap),
    outlineWidth: (0, $fZx25.borderWidthMap),
    padding: (0, $fZx25.positiveSpaceMap),
    paddingBlock: (0, $fZx25.positiveSpaceMap),
    paddingBlockEnd: (0, $fZx25.positiveSpaceMap),
    paddingBlockStart: (0, $fZx25.positiveSpaceMap),
    paddingBottom: (0, $fZx25.positiveSpaceMap),
    paddingInline: (0, $fZx25.positiveSpaceMap),
    paddingInlineEnd: (0, $fZx25.positiveSpaceMap),
    paddingInlineStart: (0, $fZx25.positiveSpaceMap),
    paddingLeft: (0, $fZx25.positiveSpaceMap),
    paddingRight: (0, $fZx25.positiveSpaceMap),
    paddingTop: (0, $fZx25.positiveSpaceMap),
    right: (0, $fZx25.allSpaceMap),
    rowGap: (0, $fZx25.positiveSpaceMap),
    top: (0, $fZx25.allSpaceMap),
    width: (0, $fZx25.dimensionMap),
    zIndex: (0, $fZx25.layerMap)
};
var $883884948a00540c$var$uniqueSymbol = Symbol("UNSAFE_INTERNAL_styles");
var $883884948a00540c$var$isSafeEnvToThrow = function isSafeEnvToThrow() {
    return (typeof $ahJoN === "undefined" ? "undefined" : (0, (/*@__PURE__*/$parcel$interopDefault($2EG9w)))($ahJoN)) === "object" && (0, (/*@__PURE__*/$parcel$interopDefault($2EG9w)))($ahJoN.env) === "object" && false;
};
var $883884948a00540c$var$reNestedSelectors = /(\.|\s|&+|\*\>|#|\[.*\])/;
var $883884948a00540c$var$safeSelectors = /^@media .*$|^::?.*$|^@supports .*$/;
var $883884948a00540c$var$transformStyles = function transformStyles(styleObj) {
    if (!styleObj || (0, (/*@__PURE__*/$parcel$interopDefault($2EG9w)))(styleObj) !== "object") return styleObj;
    // If styles are defined as a CSSObject[], recursively call on each element until we reach CSSObject
    if (Array.isArray(styleObj)) return styleObj.map(transformStyles);
    // Modifies styleObj in place. Be careful.
    Object.entries(styleObj).forEach(function(_ref) {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($6eeGl)))(_ref, 2), key = _ref2[0], value = _ref2[1];
        // If key is a pseudo class or a pseudo element, then value should be an object.
        // So, call transformStyles on the value
        if ((0, (/*@__PURE__*/$parcel$interopDefault($2EG9w)))(value) === "object" && $883884948a00540c$var$safeSelectors.test(key)) {
            styleObj[key] = transformStyles(value);
            return;
        }
        if ($883884948a00540c$var$isSafeEnvToThrow()) {
            // We don't support `.class`, `[data-testid]`, `> *`, `#some-id`
            if ($883884948a00540c$var$reNestedSelectors.test(key)) throw new Error("Styles not supported for key '".concat(key, "'."));
        }
        // We have now dealt with all the special cases, so,
        // check whether what remains is a style property
        // that can be transformed.
        if (!(key in $883884948a00540c$export$9a199fbafee0014e)) return;
        var tokenValue = $883884948a00540c$export$9a199fbafee0014e[key][value];
        styleObj[key] = tokenValue !== null && tokenValue !== void 0 ? tokenValue : value;
    });
    return styleObj;
};
var $883884948a00540c$var$baseXcss = function baseXcss(style) {
    var transformedStyles = $883884948a00540c$var$transformStyles(style);
    return (0, (/*@__PURE__*/$parcel$interopDefault($fzkYl)))({}, $883884948a00540c$var$uniqueSymbol, (0, $jVTBW.css)(transformedStyles));
};
var $883884948a00540c$export$a9c84988c8f81f2d = function parseXcss(args) {
    if (Array.isArray(args)) {
        var emotion = [];
        var staticArr = [];
        var _iterator = $883884948a00540c$var$_createForOfIteratorHelper(args), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var arg = _step.value;
                var result = parseXcss(arg);
                if (result.emotion) emotion.push.apply(emotion, (0, (/*@__PURE__*/$parcel$interopDefault($bgA8z)))(result.emotion));
                if (result.static) staticArr.push(result.static);
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        return {
            emotion: emotion,
            static: staticArr.join(" ")
        };
    }
    var objArgs = args;
    var _ref4 = objArgs || {}, styles = _ref4[$883884948a00540c$var$uniqueSymbol];
    if (styles) return {
        emotion: [
            styles
        ]
    };
    if (args) {
        // We use string interpolation here instead of .toString() just
        // in case the resulting object doesn't have the method available.
        var stringifiedArgs = "".concat(args);
        if (stringifiedArgs) return {
            static: stringifiedArgs
        };
    }
    return {};
};
function $883884948a00540c$export$f6c783d06584602c(style) {
    return $883884948a00540c$var$baseXcss(style);
}

});
parcelRegister("fzkYl", function(module, exports) {

var $dYQeu = parcelRequire("dYQeu");
function $b55a64937687a86b$var$_defineProperty(e, r, t) {
    return (r = $dYQeu(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
module.exports = $b55a64937687a86b$var$_defineProperty, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("dYQeu", function(module, exports) {

var $2EG9w = parcelRequire("2EG9w");
var $a2d965448147f755$var$_typeof = $2EG9w.default;

var $hjQpg = parcelRequire("hjQpg");
function $a2d965448147f755$var$toPropertyKey(t) {
    var i = $hjQpg(t, "string");
    return "symbol" == $a2d965448147f755$var$_typeof(i) ? i : i + "";
}
module.exports = $a2d965448147f755$var$toPropertyKey, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("2EG9w", function(module, exports) {
function $1ef003d7ad205d90$var$_typeof(o) {
    "@babel/helpers - typeof";
    return module.exports = $1ef003d7ad205d90$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $1ef003d7ad205d90$var$_typeof(o);
}
module.exports = $1ef003d7ad205d90$var$_typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("hjQpg", function(module, exports) {

var $2EG9w = parcelRequire("2EG9w");
var $c9bcdcd60f94115a$var$_typeof = $2EG9w.default;
function $c9bcdcd60f94115a$var$toPrimitive(t, r) {
    if ("object" != $c9bcdcd60f94115a$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $c9bcdcd60f94115a$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
module.exports = $c9bcdcd60f94115a$var$toPrimitive, module.exports.__esModule = true, module.exports["default"] = module.exports;

});



parcelRegister("6eeGl", function(module, exports) {

var $5mG13 = parcelRequire("5mG13");

var $eK5gd = parcelRequire("eK5gd");

var $037ja = parcelRequire("037ja");

var $hKzKK = parcelRequire("hKzKK");
function $488f706a602e0a2b$var$_slicedToArray(r, e) {
    return $5mG13(r) || $eK5gd(r, e) || $037ja(r, e) || $hKzKK();
}
module.exports = $488f706a602e0a2b$var$_slicedToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("5mG13", function(module, exports) {
function $3e7f99525a723e7a$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
module.exports = $3e7f99525a723e7a$var$_arrayWithHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("eK5gd", function(module, exports) {
function $abb9713315a0459c$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
module.exports = $abb9713315a0459c$var$_iterableToArrayLimit, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("hKzKK", function(module, exports) {
function $cec2775528c2d4f9$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
module.exports = $cec2775528c2d4f9$var$_nonIterableRest, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("fZx25", function(module, exports) {

$parcel$export(module.exports, "dimensionMap", function () { return $ba462d1c6ac90de4$export$6ccdbebca2ee545f; });
$parcel$export(module.exports, "positiveSpaceMap", function () { return $ba462d1c6ac90de4$export$958d0ae7f2977ae4; });
$parcel$export(module.exports, "allSpaceMap", function () { return $ba462d1c6ac90de4$export$632685d741f3dbbf; });
$parcel$export(module.exports, "opacityMap", function () { return $ba462d1c6ac90de4$export$daf94a976c798b4f; });
$parcel$export(module.exports, "shadowMap", function () { return $ba462d1c6ac90de4$export$7aff6e7ba39bb774; });
$parcel$export(module.exports, "borderColorMap", function () { return $ba462d1c6ac90de4$export$1531ad5bb3fbedac; });
$parcel$export(module.exports, "backgroundColorMap", function () { return $ba462d1c6ac90de4$export$d1d79bf68ac056bd; });
$parcel$export(module.exports, "textColorMap", function () { return $ba462d1c6ac90de4$export$8473307aa00d6ea1; });
$parcel$export(module.exports, "layerMap", function () { return $ba462d1c6ac90de4$export$b5f31a7e431d2eab; });
$parcel$export(module.exports, "borderWidthMap", function () { return $ba462d1c6ac90de4$export$e1b83c5210c471b8; });
$parcel$export(module.exports, "borderRadiusMap", function () { return $ba462d1c6ac90de4$export$3c0a6c3e64bb180d; });
$parcel$export(module.exports, "spaceStylesMap", function () { return $ba462d1c6ac90de4$export$bf46c3f9eeafc71f; });

var $fzkYl = parcelRequire("fzkYl");

var $jVTBW = parcelRequire("jVTBW");

var $6PR8P = parcelRequire("6PR8P");
function $ba462d1c6ac90de4$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $ba462d1c6ac90de4$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $ba462d1c6ac90de4$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($fzkYl)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $ba462d1c6ac90de4$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $ba462d1c6ac90de4$export$6ccdbebca2ee545f = {
    "100%": "100%",
    "size.100": "1rem",
    "size.200": "1.5rem",
    "size.300": "2rem",
    "size.400": "2.5rem",
    "size.500": "3rem",
    "size.600": "6rem",
    "size.1000": "12rem"
};
var $ba462d1c6ac90de4$export$958d0ae7f2977ae4 = {
    "space.0": "var(--ds-space-0, 0px)",
    "space.025": "var(--ds-space-025, 2px)",
    "space.050": "var(--ds-space-050, 4px)",
    "space.075": "var(--ds-space-075, 6px)",
    "space.100": "var(--ds-space-100, 8px)",
    "space.150": "var(--ds-space-150, 12px)",
    "space.200": "var(--ds-space-200, 16px)",
    "space.250": "var(--ds-space-250, 20px)",
    "space.300": "var(--ds-space-300, 24px)",
    "space.400": "var(--ds-space-400, 32px)",
    "space.500": "var(--ds-space-500, 40px)",
    "space.600": "var(--ds-space-600, 48px)",
    "space.800": "var(--ds-space-800, 64px)",
    "space.1000": "var(--ds-space-1000, 80px)"
};
var $ba462d1c6ac90de4$export$d2dc61f58390201c = {
    "space.negative.025": "var(--ds-space-negative-025, -2px)",
    "space.negative.050": "var(--ds-space-negative-050, -4px)",
    "space.negative.075": "var(--ds-space-negative-075, -6px)",
    "space.negative.100": "var(--ds-space-negative-100, -8px)",
    "space.negative.150": "var(--ds-space-negative-150, -12px)",
    "space.negative.200": "var(--ds-space-negative-200, -16px)",
    "space.negative.250": "var(--ds-space-negative-250, -20px)",
    "space.negative.300": "var(--ds-space-negative-300, -24px)",
    "space.negative.400": "var(--ds-space-negative-400, -32px)"
};
var $ba462d1c6ac90de4$export$632685d741f3dbbf = $ba462d1c6ac90de4$var$_objectSpread($ba462d1c6ac90de4$var$_objectSpread({}, $ba462d1c6ac90de4$export$958d0ae7f2977ae4), $ba462d1c6ac90de4$export$d2dc61f58390201c);
var $ba462d1c6ac90de4$export$2185ce37f9bdd963 = {
    "color.background.neutral.bold": "color.text.inverse",
    "color.background.neutral.bold.hovered": "color.text.inverse",
    "color.background.neutral.bold.pressed": "color.text.inverse",
    "color.background.selected.bold": "color.text.inverse",
    "color.background.selected.bold.hovered": "color.text.inverse",
    "color.background.selected.bold.pressed": "color.text.inverse",
    "color.background.brand.bold": "color.text.inverse",
    "color.background.brand.bold.hovered": "color.text.inverse",
    "color.background.brand.bold.pressed": "color.text.inverse",
    "color.background.brand.boldest": "color.text.inverse",
    "color.background.brand.boldest.hovered": "color.text.inverse",
    "color.background.brand.boldest.pressed": "color.text.inverse",
    "color.background.danger.bold": "color.text.inverse",
    "color.background.danger.bold.hovered": "color.text.inverse",
    "color.background.danger.bold.pressed": "color.text.inverse",
    "color.background.warning.bold": "color.text.warning.inverse",
    "color.background.warning.bold.hovered": "color.text.warning.inverse",
    "color.background.warning.bold.pressed": "color.text.warning.inverse",
    "color.background.success.bold": "color.text.inverse",
    "color.background.success.bold.hovered": "color.text.inverse",
    "color.background.success.bold.pressed": "color.text.inverse",
    "color.background.discovery.bold": "color.text.inverse",
    "color.background.discovery.bold.hovered": "color.text.inverse",
    "color.background.discovery.bold.pressed": "color.text.inverse",
    "color.background.information.bold": "color.text.inverse",
    "color.background.information.bold.hovered": "color.text.inverse",
    "color.background.information.bold.pressed": "color.text.inverse"
};
var $ba462d1c6ac90de4$export$daf94a976c798b4f = {
    "opacity.disabled": "var(--ds-opacity-disabled, 0.4)",
    "opacity.loading": "var(--ds-opacity-loading, 0.2)"
};
var $ba462d1c6ac90de4$export$7aff6e7ba39bb774 = {
    "elevation.shadow.overflow": "var(--ds-shadow-overflow, 0px 0px 8px #091e423f, 0px 0px 1px #091e424f)",
    "elevation.shadow.overflow.perimeter": "var(--ds-shadow-overflow-perimeter, #091e421f)",
    "elevation.shadow.overflow.spread": "var(--ds-shadow-overflow-spread, #091e4229)",
    "elevation.shadow.overlay": "var(--ds-shadow-overlay, 0px 8px 12px #091e423f, 0px 0px 1px #091e424f)",
    "elevation.shadow.raised": "var(--ds-shadow-raised, 0px 1px 1px #091e423f, 0px 0px 1px #091e4221)"
};
var $ba462d1c6ac90de4$export$41a358c9c2356760 = {
    "elevation.surface": "var(--ds-surface, #FFFFFF)",
    "elevation.surface.hovered": "var(--ds-surface-hovered, #FAFBFC)",
    "elevation.surface.pressed": "var(--ds-surface-pressed, #F4F5F7)",
    "elevation.surface.overlay": "var(--ds-surface-overlay, #FFFFFF)",
    "elevation.surface.overlay.hovered": "var(--ds-surface-overlay-hovered, #FAFBFC)",
    "elevation.surface.overlay.pressed": "var(--ds-surface-overlay-pressed, #F4F5F7)",
    "elevation.surface.raised": "var(--ds-surface-raised, #FFFFFF)",
    "elevation.surface.raised.hovered": "var(--ds-surface-raised-hovered, #FAFBFC)",
    "elevation.surface.raised.pressed": "var(--ds-surface-raised-pressed, #F4F5F7)",
    "elevation.surface.sunken": "var(--ds-surface-sunken, #F4F5F7)"
};
var $ba462d1c6ac90de4$export$1531ad5bb3fbedac = {
    "color.border": "var(--ds-border, #091e4221)",
    "color.border.accent.lime": "var(--ds-border-accent-lime, #6A9A23)",
    "color.border.accent.red": "var(--ds-border-accent-red, #FF5630)",
    "color.border.accent.orange": "var(--ds-border-accent-orange, #D94008)",
    "color.border.accent.yellow": "var(--ds-border-accent-yellow, #FFAB00)",
    "color.border.accent.green": "var(--ds-border-accent-green, #36B37E)",
    "color.border.accent.teal": "var(--ds-border-accent-teal, #00B8D9)",
    "color.border.accent.blue": "var(--ds-border-accent-blue, #0065FF)",
    "color.border.accent.purple": "var(--ds-border-accent-purple, #6554C0)",
    "color.border.accent.magenta": "var(--ds-border-accent-magenta, #CD519D)",
    "color.border.accent.gray": "var(--ds-border-accent-gray, #5E6C84)",
    "color.border.disabled": "var(--ds-border-disabled, #FAFBFC)",
    "color.border.focused": "var(--ds-border-focused, #2684FF)",
    "color.border.input": "var(--ds-border-input, #FAFBFC)",
    "color.border.inverse": "var(--ds-border-inverse, #FFFFFF)",
    "color.border.selected": "var(--ds-border-selected, #0052CC)",
    "color.border.brand": "var(--ds-border-brand, #0052CC)",
    "color.border.danger": "var(--ds-border-danger, #FF5630)",
    "color.border.warning": "var(--ds-border-warning, #FFC400)",
    "color.border.success": "var(--ds-border-success, #00875A)",
    "color.border.discovery": "var(--ds-border-discovery, #998DD9)",
    "color.border.information": "var(--ds-border-information, #0065FF)",
    "color.border.bold": "var(--ds-border-bold, #344563)"
};
var $ba462d1c6ac90de4$export$d1d79bf68ac056bd = {
    "color.background.accent.lime.subtlest": "var(--ds-background-accent-lime-subtlest, #EEFBDA)",
    "color.background.accent.lime.subtlest.hovered": "var(--ds-background-accent-lime-subtlest-hovered, #D3F1A7)",
    "color.background.accent.lime.subtlest.pressed": "var(--ds-background-accent-lime-subtlest-pressed, #B3DF72)",
    "color.background.accent.lime.subtler": "var(--ds-background-accent-lime-subtler, #D3F1A7)",
    "color.background.accent.lime.subtler.hovered": "var(--ds-background-accent-lime-subtler-hovered, #B3DF72)",
    "color.background.accent.lime.subtler.pressed": "var(--ds-background-accent-lime-subtler-pressed, #94C748)",
    "color.background.accent.lime.subtle": "var(--ds-background-accent-lime-subtle, #94C748)",
    "color.background.accent.lime.subtle.hovered": "var(--ds-background-accent-lime-subtle-hovered, #B3DF72)",
    "color.background.accent.lime.subtle.pressed": "var(--ds-background-accent-lime-subtle-pressed, #D3F1A7)",
    "color.background.accent.lime.bolder": "var(--ds-background-accent-lime-bolder, #5B7F24)",
    "color.background.accent.lime.bolder.hovered": "var(--ds-background-accent-lime-bolder-hovered, #37471F)",
    "color.background.accent.lime.bolder.pressed": "var(--ds-background-accent-lime-bolder-pressed, #37471F)",
    "color.background.accent.red.subtlest": "var(--ds-background-accent-red-subtlest, #FF8F73)",
    "color.background.accent.red.subtlest.hovered": "var(--ds-background-accent-red-subtlest-hovered, #FF7452)",
    "color.background.accent.red.subtlest.pressed": "var(--ds-background-accent-red-subtlest-pressed, #FF5630)",
    "color.background.accent.red.subtler": "var(--ds-background-accent-red-subtler, #FF7452)",
    "color.background.accent.red.subtler.hovered": "var(--ds-background-accent-red-subtler-hovered, #FF5630)",
    "color.background.accent.red.subtler.pressed": "var(--ds-background-accent-red-subtler-pressed, #DE350B)",
    "color.background.accent.red.subtle": "var(--ds-background-accent-red-subtle, #DE350B)",
    "color.background.accent.red.subtle.hovered": "var(--ds-background-accent-red-subtle-hovered, #FF5630)",
    "color.background.accent.red.subtle.pressed": "var(--ds-background-accent-red-subtle-pressed, #FF7452)",
    "color.background.accent.red.bolder": "var(--ds-background-accent-red-bolder, #DE350B)",
    "color.background.accent.red.bolder.hovered": "var(--ds-background-accent-red-bolder-hovered, #FF5630)",
    "color.background.accent.red.bolder.pressed": "var(--ds-background-accent-red-bolder-pressed, #FF7452)",
    "color.background.accent.orange.subtlest": "var(--ds-background-accent-orange-subtlest, #F18D13)",
    "color.background.accent.orange.subtlest.hovered": "var(--ds-background-accent-orange-subtlest-hovered, #FEC57B)",
    "color.background.accent.orange.subtlest.pressed": "var(--ds-background-accent-orange-subtlest-pressed, #FFE2BD)",
    "color.background.accent.orange.subtler": "var(--ds-background-accent-orange-subtler, #B65C02)",
    "color.background.accent.orange.subtler.hovered": "var(--ds-background-accent-orange-subtler-hovered, #F18D13)",
    "color.background.accent.orange.subtler.pressed": "var(--ds-background-accent-orange-subtler-pressed, #FEC57B)",
    "color.background.accent.orange.subtle": "var(--ds-background-accent-orange-subtle, #5F3811)",
    "color.background.accent.orange.subtle.hovered": "var(--ds-background-accent-orange-subtle-hovered, #974F0C)",
    "color.background.accent.orange.subtle.pressed": "var(--ds-background-accent-orange-subtle-pressed, #B65C02)",
    "color.background.accent.orange.bolder": "var(--ds-background-accent-orange-bolder, #43290F)",
    "color.background.accent.orange.bolder.hovered": "var(--ds-background-accent-orange-bolder-hovered, #5F3811)",
    "color.background.accent.orange.bolder.pressed": "var(--ds-background-accent-orange-bolder-pressed, #974F0C)",
    "color.background.accent.yellow.subtlest": "var(--ds-background-accent-yellow-subtlest, #FFE380)",
    "color.background.accent.yellow.subtlest.hovered": "var(--ds-background-accent-yellow-subtlest-hovered, #FFC400)",
    "color.background.accent.yellow.subtlest.pressed": "var(--ds-background-accent-yellow-subtlest-pressed, #FFAB00)",
    "color.background.accent.yellow.subtler": "var(--ds-background-accent-yellow-subtler, #FFC400)",
    "color.background.accent.yellow.subtler.hovered": "var(--ds-background-accent-yellow-subtler-hovered, #FFAB00)",
    "color.background.accent.yellow.subtler.pressed": "var(--ds-background-accent-yellow-subtler-pressed, #FF991F)",
    "color.background.accent.yellow.subtle": "var(--ds-background-accent-yellow-subtle, #FF991F)",
    "color.background.accent.yellow.subtle.hovered": "var(--ds-background-accent-yellow-subtle-hovered, #FFAB00)",
    "color.background.accent.yellow.subtle.pressed": "var(--ds-background-accent-yellow-subtle-pressed, #FFC400)",
    "color.background.accent.yellow.bolder": "var(--ds-background-accent-yellow-bolder, #FF991F)",
    "color.background.accent.yellow.bolder.hovered": "var(--ds-background-accent-yellow-bolder-hovered, #FFAB00)",
    "color.background.accent.yellow.bolder.pressed": "var(--ds-background-accent-yellow-bolder-pressed, #FFC400)",
    "color.background.accent.green.subtlest": "var(--ds-background-accent-green-subtlest, #79F2C0)",
    "color.background.accent.green.subtlest.hovered": "var(--ds-background-accent-green-subtlest-hovered, #57D9A3)",
    "color.background.accent.green.subtlest.pressed": "var(--ds-background-accent-green-subtlest-pressed, #36B37E)",
    "color.background.accent.green.subtler": "var(--ds-background-accent-green-subtler, #57D9A3)",
    "color.background.accent.green.subtler.hovered": "var(--ds-background-accent-green-subtler-hovered, #36B37E)",
    "color.background.accent.green.subtler.pressed": "var(--ds-background-accent-green-subtler-pressed, #00875A)",
    "color.background.accent.green.subtle": "var(--ds-background-accent-green-subtle, #00875A)",
    "color.background.accent.green.subtle.hovered": "var(--ds-background-accent-green-subtle-hovered, #36B37E)",
    "color.background.accent.green.subtle.pressed": "var(--ds-background-accent-green-subtle-pressed, #57D9A3)",
    "color.background.accent.green.bolder": "var(--ds-background-accent-green-bolder, #00875A)",
    "color.background.accent.green.bolder.hovered": "var(--ds-background-accent-green-bolder-hovered, #36B37E)",
    "color.background.accent.green.bolder.pressed": "var(--ds-background-accent-green-bolder-pressed, #57D9A3)",
    "color.background.accent.teal.subtlest": "var(--ds-background-accent-teal-subtlest, #79E2F2)",
    "color.background.accent.teal.subtlest.hovered": "var(--ds-background-accent-teal-subtlest-hovered, #00C7E6)",
    "color.background.accent.teal.subtlest.pressed": "var(--ds-background-accent-teal-subtlest-pressed, #00B8D9)",
    "color.background.accent.teal.subtler": "var(--ds-background-accent-teal-subtler, #00C7E6)",
    "color.background.accent.teal.subtler.hovered": "var(--ds-background-accent-teal-subtler-hovered, #00B8D9)",
    "color.background.accent.teal.subtler.pressed": "var(--ds-background-accent-teal-subtler-pressed, #00A3BF)",
    "color.background.accent.teal.subtle": "var(--ds-background-accent-teal-subtle, #00A3BF)",
    "color.background.accent.teal.subtle.hovered": "var(--ds-background-accent-teal-subtle-hovered, #00B8D9)",
    "color.background.accent.teal.subtle.pressed": "var(--ds-background-accent-teal-subtle-pressed, #00C7E6)",
    "color.background.accent.teal.bolder": "var(--ds-background-accent-teal-bolder, #00A3BF)",
    "color.background.accent.teal.bolder.hovered": "var(--ds-background-accent-teal-bolder-hovered, #00B8D9)",
    "color.background.accent.teal.bolder.pressed": "var(--ds-background-accent-teal-bolder-pressed, #00C7E6)",
    "color.background.accent.blue.subtlest": "var(--ds-background-accent-blue-subtlest, #4C9AFF)",
    "color.background.accent.blue.subtlest.hovered": "var(--ds-background-accent-blue-subtlest-hovered, #2684FF)",
    "color.background.accent.blue.subtlest.pressed": "var(--ds-background-accent-blue-subtlest-pressed, #0065FF)",
    "color.background.accent.blue.subtler": "var(--ds-background-accent-blue-subtler, #2684FF)",
    "color.background.accent.blue.subtler.hovered": "var(--ds-background-accent-blue-subtler-hovered, #0065FF)",
    "color.background.accent.blue.subtler.pressed": "var(--ds-background-accent-blue-subtler-pressed, #0052CC)",
    "color.background.accent.blue.subtle": "var(--ds-background-accent-blue-subtle, #0052CC)",
    "color.background.accent.blue.subtle.hovered": "var(--ds-background-accent-blue-subtle-hovered, #0065FF)",
    "color.background.accent.blue.subtle.pressed": "var(--ds-background-accent-blue-subtle-pressed, #2684FF)",
    "color.background.accent.blue.bolder": "var(--ds-background-accent-blue-bolder, #0052CC)",
    "color.background.accent.blue.bolder.hovered": "var(--ds-background-accent-blue-bolder-hovered, #0065FF)",
    "color.background.accent.blue.bolder.pressed": "var(--ds-background-accent-blue-bolder-pressed, #2684FF)",
    "color.background.accent.purple.subtlest": "var(--ds-background-accent-purple-subtlest, #998DD9)",
    "color.background.accent.purple.subtlest.hovered": "var(--ds-background-accent-purple-subtlest-hovered, #8777D9)",
    "color.background.accent.purple.subtlest.pressed": "var(--ds-background-accent-purple-subtlest-pressed, #6554C0)",
    "color.background.accent.purple.subtler": "var(--ds-background-accent-purple-subtler, #8777D9)",
    "color.background.accent.purple.subtler.hovered": "var(--ds-background-accent-purple-subtler-hovered, #6554C0)",
    "color.background.accent.purple.subtler.pressed": "var(--ds-background-accent-purple-subtler-pressed, #5243AA)",
    "color.background.accent.purple.subtle": "var(--ds-background-accent-purple-subtle, #5243AA)",
    "color.background.accent.purple.subtle.hovered": "var(--ds-background-accent-purple-subtle-hovered, #6554C0)",
    "color.background.accent.purple.subtle.pressed": "var(--ds-background-accent-purple-subtle-pressed, #8777D9)",
    "color.background.accent.purple.bolder": "var(--ds-background-accent-purple-bolder, #5243AA)",
    "color.background.accent.purple.bolder.hovered": "var(--ds-background-accent-purple-bolder-hovered, #6554C0)",
    "color.background.accent.purple.bolder.pressed": "var(--ds-background-accent-purple-bolder-pressed, #8777D9)",
    "color.background.accent.magenta.subtlest": "var(--ds-background-accent-magenta-subtlest, #FFECF8)",
    "color.background.accent.magenta.subtlest.hovered": "var(--ds-background-accent-magenta-subtlest-hovered, #FDD0EC)",
    "color.background.accent.magenta.subtlest.pressed": "var(--ds-background-accent-magenta-subtlest-pressed, #F797D2)",
    "color.background.accent.magenta.subtler": "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
    "color.background.accent.magenta.subtler.hovered": "var(--ds-background-accent-magenta-subtler-hovered, #F797D2)",
    "color.background.accent.magenta.subtler.pressed": "var(--ds-background-accent-magenta-subtler-pressed, #E774BB)",
    "color.background.accent.magenta.subtle": "var(--ds-background-accent-magenta-subtle, #E774BB)",
    "color.background.accent.magenta.subtle.hovered": "var(--ds-background-accent-magenta-subtle-hovered, #F797D2)",
    "color.background.accent.magenta.subtle.pressed": "var(--ds-background-accent-magenta-subtle-pressed, #FDD0EC)",
    "color.background.accent.magenta.bolder": "var(--ds-background-accent-magenta-bolder, #AE4787)",
    "color.background.accent.magenta.bolder.hovered": "var(--ds-background-accent-magenta-bolder-hovered, #943D73)",
    "color.background.accent.magenta.bolder.pressed": "var(--ds-background-accent-magenta-bolder-pressed, #50253F)",
    "color.background.accent.gray.subtlest": "var(--ds-background-accent-gray-subtlest, #6B778C)",
    "color.background.accent.gray.subtlest.hovered": "var(--ds-background-accent-gray-subtlest-hovered, #5E6C84)",
    "color.background.accent.gray.subtlest.pressed": "var(--ds-background-accent-gray-subtlest-pressed, #505F79)",
    "color.background.accent.gray.subtler": "var(--ds-background-accent-gray-subtler, #5E6C84)",
    "color.background.accent.gray.subtler.hovered": "var(--ds-background-accent-gray-subtler-hovered, #505F79)",
    "color.background.accent.gray.subtler.pressed": "var(--ds-background-accent-gray-subtler-pressed, #42526E)",
    "color.background.accent.gray.subtle": "var(--ds-background-accent-gray-subtle, #505F79)",
    "color.background.accent.gray.subtle.hovered": "var(--ds-background-accent-gray-subtle-hovered, #5E6C84)",
    "color.background.accent.gray.subtle.pressed": "var(--ds-background-accent-gray-subtle-pressed, #6B778C)",
    "color.background.accent.gray.bolder": "var(--ds-background-accent-gray-bolder, #42526E)",
    "color.background.accent.gray.bolder.hovered": "var(--ds-background-accent-gray-bolder-hovered, #344563)",
    "color.background.accent.gray.bolder.pressed": "var(--ds-background-accent-gray-bolder-pressed, #253858)",
    "color.background.disabled": "var(--ds-background-disabled, #091e4289)",
    "color.background.input": "var(--ds-background-input, #FAFBFC)",
    "color.background.input.hovered": "var(--ds-background-input-hovered, #EBECF0)",
    "color.background.input.pressed": "var(--ds-background-input-pressed, #FFFFFF)",
    "color.background.inverse.subtle": "var(--ds-background-inverse-subtle, #00000029)",
    "color.background.inverse.subtle.hovered": "var(--ds-background-inverse-subtle-hovered, #0000003D)",
    "color.background.inverse.subtle.pressed": "var(--ds-background-inverse-subtle-pressed, #00000052)",
    "color.background.neutral": "var(--ds-background-neutral, #DFE1E6)",
    "color.background.neutral.hovered": "var(--ds-background-neutral-hovered, #091e4214)",
    "color.background.neutral.pressed": "var(--ds-background-neutral-pressed, #B3D4FF)",
    "color.background.neutral.subtle": "var(--ds-background-neutral-subtle, transparent)",
    "color.background.neutral.subtle.hovered": "var(--ds-background-neutral-subtle-hovered, #091e4214)",
    "color.background.neutral.subtle.pressed": "var(--ds-background-neutral-subtle-pressed, #B3D4FF)",
    "color.background.neutral.bold": "var(--ds-background-neutral-bold, #42526E)",
    "color.background.neutral.bold.hovered": "var(--ds-background-neutral-bold-hovered, #505F79)",
    "color.background.neutral.bold.pressed": "var(--ds-background-neutral-bold-pressed, #344563)",
    "color.background.selected": "var(--ds-background-selected, #DEEBFF)",
    "color.background.selected.hovered": "var(--ds-background-selected-hovered, #B3D4FF)",
    "color.background.selected.pressed": "var(--ds-background-selected-pressed, #4C9AFF)",
    "color.background.selected.bold": "var(--ds-background-selected-bold, #0052CC)",
    "color.background.selected.bold.hovered": "var(--ds-background-selected-bold-hovered, #2684FF)",
    "color.background.selected.bold.pressed": "var(--ds-background-selected-bold-pressed, #0052CC)",
    "color.background.brand.subtlest": "var(--ds-background-brand-subtlest, #B3D4FF)",
    "color.background.brand.subtlest.hovered": "var(--ds-background-brand-subtlest-hovered, #DEEBFF)",
    "color.background.brand.subtlest.pressed": "var(--ds-background-brand-subtlest-pressed, #4C9AFF)",
    "color.background.brand.bold": "var(--ds-background-brand-bold, #0052CC)",
    "color.background.brand.bold.hovered": "var(--ds-background-brand-bold-hovered, #0065FF)",
    "color.background.brand.bold.pressed": "var(--ds-background-brand-bold-pressed, #0747A6)",
    "color.background.brand.boldest": "var(--ds-background-brand-boldest, #0747A6)",
    "color.background.brand.boldest.hovered": "var(--ds-background-brand-boldest-hovered, #0052CC)",
    "color.background.brand.boldest.pressed": "var(--ds-background-brand-boldest-pressed, #0747A6)",
    "color.background.danger": "var(--ds-background-danger, #FFEBE6)",
    "color.background.danger.hovered": "var(--ds-background-danger-hovered, #FFBDAD)",
    "color.background.danger.pressed": "var(--ds-background-danger-pressed, #FF8F73)",
    "color.background.danger.bold": "var(--ds-background-danger-bold, #DE350B)",
    "color.background.danger.bold.hovered": "var(--ds-background-danger-bold-hovered, #FF5630)",
    "color.background.danger.bold.pressed": "var(--ds-background-danger-bold-pressed, #BF2600)",
    "color.background.warning": "var(--ds-background-warning, #FFFAE6)",
    "color.background.warning.hovered": "var(--ds-background-warning-hovered, #FFF0B3)",
    "color.background.warning.pressed": "var(--ds-background-warning-pressed, #FFE380)",
    "color.background.warning.bold": "var(--ds-background-warning-bold, #FFAB00)",
    "color.background.warning.bold.hovered": "var(--ds-background-warning-bold-hovered, #FFC400)",
    "color.background.warning.bold.pressed": "var(--ds-background-warning-bold-pressed, #FF991F)",
    "color.background.success": "var(--ds-background-success, #E3FCEF)",
    "color.background.success.hovered": "var(--ds-background-success-hovered, #ABF5D1)",
    "color.background.success.pressed": "var(--ds-background-success-pressed, #79F2C0)",
    "color.background.success.bold": "var(--ds-background-success-bold, #00875A)",
    "color.background.success.bold.hovered": "var(--ds-background-success-bold-hovered, #57D9A3)",
    "color.background.success.bold.pressed": "var(--ds-background-success-bold-pressed, #00875A)",
    "color.background.discovery": "var(--ds-background-discovery, #EAE6FF)",
    "color.background.discovery.hovered": "var(--ds-background-discovery-hovered, #C0B6F2)",
    "color.background.discovery.pressed": "var(--ds-background-discovery-pressed, #998DD9)",
    "color.background.discovery.bold": "var(--ds-background-discovery-bold, #5243AA)",
    "color.background.discovery.bold.hovered": "var(--ds-background-discovery-bold-hovered, #8777D9)",
    "color.background.discovery.bold.pressed": "var(--ds-background-discovery-bold-pressed, #5243AA)",
    "color.background.information": "var(--ds-background-information, #DEEBFF)",
    "color.background.information.hovered": "var(--ds-background-information-hovered, #B3D4FF)",
    "color.background.information.pressed": "var(--ds-background-information-pressed, #4C9AFF)",
    "color.background.information.bold": "var(--ds-background-information-bold, #0052CC)",
    "color.background.information.bold.hovered": "var(--ds-background-information-bold-hovered, #2684FF)",
    "color.background.information.bold.pressed": "var(--ds-background-information-bold-pressed, #0052CC)",
    "color.blanket": "var(--ds-blanket, #091e4289)",
    "color.blanket.selected": "var(--ds-blanket-selected, #388BFF14)",
    "color.blanket.danger": "var(--ds-blanket-danger, #EF5C4814)",
    "elevation.surface": "var(--ds-surface, #FFFFFF)",
    "elevation.surface.hovered": "var(--ds-surface-hovered, #FAFBFC)",
    "elevation.surface.pressed": "var(--ds-surface-pressed, #F4F5F7)",
    "elevation.surface.overlay": "var(--ds-surface-overlay, #FFFFFF)",
    "elevation.surface.overlay.hovered": "var(--ds-surface-overlay-hovered, #FAFBFC)",
    "elevation.surface.overlay.pressed": "var(--ds-surface-overlay-pressed, #F4F5F7)",
    "elevation.surface.raised": "var(--ds-surface-raised, #FFFFFF)",
    "elevation.surface.raised.hovered": "var(--ds-surface-raised-hovered, #FAFBFC)",
    "elevation.surface.raised.pressed": "var(--ds-surface-raised-pressed, #F4F5F7)",
    "elevation.surface.sunken": "var(--ds-surface-sunken, #F4F5F7)",
    "utility.elevation.surface.current": "var(--ds-elevation-surface-current, #FFFFFF)"
};
var $ba462d1c6ac90de4$export$8473307aa00d6ea1 = {
    "color.text": "var(--ds-text, #172B4D)",
    "color.text.accent.lime": "var(--ds-text-accent-lime, #4C6B1F)",
    "color.text.accent.lime.bolder": "var(--ds-text-accent-lime-bolder, #37471F)",
    "color.text.accent.red": "var(--ds-text-accent-red, #DE350B)",
    "color.text.accent.red.bolder": "var(--ds-text-accent-red-bolder, #BF2600)",
    "color.text.accent.orange": "var(--ds-text-accent-orange, #F18D13)",
    "color.text.accent.orange.bolder": "var(--ds-text-accent-orange-bolder, #B65C02)",
    "color.text.accent.yellow": "var(--ds-text-accent-yellow, #FF991F)",
    "color.text.accent.yellow.bolder": "var(--ds-text-accent-yellow-bolder, #FF8B00)",
    "color.text.accent.green": "var(--ds-text-accent-green, #00875A)",
    "color.text.accent.green.bolder": "var(--ds-text-accent-green-bolder, #006644)",
    "color.text.accent.teal": "var(--ds-text-accent-teal, #00A3BF)",
    "color.text.accent.teal.bolder": "var(--ds-text-accent-teal-bolder, #008DA6)",
    "color.text.accent.blue": "var(--ds-text-accent-blue, #0052CC)",
    "color.text.accent.blue.bolder": "var(--ds-text-accent-blue-bolder, #0747A6)",
    "color.text.accent.purple": "var(--ds-text-accent-purple, #5243AA)",
    "color.text.accent.purple.bolder": "var(--ds-text-accent-purple-bolder, #403294)",
    "color.text.accent.magenta": "var(--ds-text-accent-magenta, #E774BB)",
    "color.text.accent.magenta.bolder": "var(--ds-text-accent-magenta-bolder, #DA62AC)",
    "color.text.accent.gray": "var(--ds-text-accent-gray, #505F79)",
    "color.text.accent.gray.bolder": "var(--ds-text-accent-gray-bolder, #172B4D)",
    "color.text.disabled": "var(--ds-text-disabled, #A5ADBA)",
    "color.text.inverse": "var(--ds-text-inverse, #FFFFFF)",
    "color.text.selected": "var(--ds-text-selected, #0052CC)",
    "color.text.brand": "var(--ds-text-brand, #0065FF)",
    "color.text.danger": "var(--ds-text-danger, #DE350B)",
    "color.text.warning": "var(--ds-text-warning, #974F0C)",
    "color.text.warning.inverse": "var(--ds-text-warning-inverse, #172B4D)",
    "color.text.success": "var(--ds-text-success, #006644)",
    "color.text.discovery": "var(--ds-text-discovery, #403294)",
    "color.text.information": "var(--ds-text-information, #0052CC)",
    "color.text.subtlest": "var(--ds-text-subtlest, #7A869A)",
    "color.text.subtle": "var(--ds-text-subtle, #42526E)",
    "color.link": "var(--ds-link, #0052CC)",
    "color.link.pressed": "var(--ds-link-pressed, #0747A6)",
    "color.link.visited": "var(--ds-link-visited, #403294)",
    "color.link.visited.pressed": "var(--ds-link-visited-pressed, #403294)"
};
var $ba462d1c6ac90de4$export$498780f74be9af68 = {
    "color.icon": "var(--ds-icon, #505F79)",
    "color.icon.accent.lime": "var(--ds-icon-accent-lime, #6A9A23)",
    "color.icon.accent.red": "var(--ds-icon-accent-red, #FF5630)",
    "color.icon.accent.orange": "var(--ds-icon-accent-orange, #D94008)",
    "color.icon.accent.yellow": "var(--ds-icon-accent-yellow, #FFAB00)",
    "color.icon.accent.green": "var(--ds-icon-accent-green, #36B37E)",
    "color.icon.accent.teal": "var(--ds-icon-accent-teal, #00B8D9)",
    "color.icon.accent.blue": "var(--ds-icon-accent-blue, #0065FF)",
    "color.icon.accent.purple": "var(--ds-icon-accent-purple, #6554C0)",
    "color.icon.accent.magenta": "var(--ds-icon-accent-magenta, #CD519D)",
    "color.icon.accent.gray": "var(--ds-icon-accent-gray, #5E6C84)",
    "color.icon.disabled": "var(--ds-icon-disabled, #8993A4)",
    "color.icon.inverse": "var(--ds-icon-inverse, #FFFFFF)",
    "color.icon.selected": "var(--ds-icon-selected, #0052CC)",
    "color.icon.brand": "var(--ds-icon-brand, #0065FF)",
    "color.icon.danger": "var(--ds-icon-danger, #DE350B)",
    "color.icon.warning": "var(--ds-icon-warning, #FFC400)",
    "color.icon.warning.inverse": "var(--ds-icon-warning-inverse, #253858)",
    "color.icon.success": "var(--ds-icon-success, #00875A)",
    "color.icon.discovery": "var(--ds-icon-discovery, #8777D9)",
    "color.icon.information": "var(--ds-icon-information, #0747A6)",
    "color.icon.subtle": "var(--ds-icon-subtle, #6B778C)"
};
var $ba462d1c6ac90de4$export$b5f31a7e431d2eab = {
    card: 100,
    navigation: 200,
    dialog: 300,
    layer: 400,
    blanket: 500,
    modal: 510,
    flag: 600,
    spotlight: 700,
    tooltip: 800
};
var $ba462d1c6ac90de4$export$e1b83c5210c471b8 = {
    "border.width": "var(--ds-border-width, 1px)",
    "border.width.0": "var(--ds-border-width-0, 0px)",
    "border.width.indicator": "var(--ds-border-width-indicator, 3px)",
    "border.width.outline": "var(--ds-border-width-outline, 2px)"
};
var $ba462d1c6ac90de4$export$3c0a6c3e64bb180d = {
    "border.radius.050": "var(--ds-border-radius-050, 2px)",
    "border.radius": "var(--ds-border-radius, 3px)",
    "border.radius.100": "var(--ds-border-radius-100, 3px)",
    "border.radius.200": "var(--ds-border-radius-200, 8px)",
    "border.radius.300": "var(--ds-border-radius-300, 12px)",
    "border.radius.400": "var(--ds-border-radius-400, 16px)",
    "border.radius.circle": "var(--ds-border-radius-circle, 32032px)"
};
var $ba462d1c6ac90de4$export$6cc560b4dedf3816 = {
    medium: 'var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    UNSAFE_small: 'var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    large: 'var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    small: 'var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)'
};
var $ba462d1c6ac90de4$export$303e322c6b1ed114 = {
    bold: "var(--ds-font-weight-bold, 700)",
    medium: "var(--ds-font-weight-medium, 500)",
    regular: "var(--ds-font-weight-regular, 400)",
    semibold: "var(--ds-font-weight-semibold, 600)"
};
var $ba462d1c6ac90de4$export$3c7e9587132614b4 = {
    "font.family.body": 'var(--ds-font-family-body, ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.family.brand.body": 'var(--ds-font-family-brand-body, "Charlie Text", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.family.brand.heading": 'var(--ds-font-family-brand-heading, "Charlie Display", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.family.code": 'var(--ds-font-family-code, ui-monospace, Menlo, "Segoe UI Mono", "Ubuntu Mono", monospace)',
    "font.family.heading": 'var(--ds-font-family-heading, ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)'
};
/**
 * @codegenEnd
 */ // Generate maps for Box props. backgroundColor, padding, etc
var $ba462d1c6ac90de4$var$spacingProperties = [
    // Used by Box
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    // Used by Inline and Stack
    "gap",
    "rowGap",
    "columnGap"
];
var $ba462d1c6ac90de4$var$getSerializedStylesMap = function getSerializedStylesMap(cssProperty, tokenMap) {
    return Object.keys(tokenMap).reduce(function(emotionSpacingMap, token) {
        emotionSpacingMap[token] = (0, $jVTBW.css)((0, (/*@__PURE__*/$parcel$interopDefault($fzkYl)))({}, cssProperty, tokenMap[token]));
        return emotionSpacingMap;
    }, {});
};
var $ba462d1c6ac90de4$export$e615f061ca585a6c = $ba462d1c6ac90de4$var$spacingProperties.reduce(function(styleMap, spacingProperty) {
    styleMap[spacingProperty] = $ba462d1c6ac90de4$var$getSerializedStylesMap(spacingProperty, $ba462d1c6ac90de4$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
var $ba462d1c6ac90de4$export$bf46c3f9eeafc71f = $ba462d1c6ac90de4$var$spacingProperties.reduce(function(styleMap, spacingProperty) {
    styleMap[spacingProperty] = $ba462d1c6ac90de4$var$getSerializedStylesMap(spacingProperty, $ba462d1c6ac90de4$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
var $ba462d1c6ac90de4$export$e7af83bafe7f9e63 = $ba462d1c6ac90de4$var$getSerializedStylesMap("backgroundColor", $ba462d1c6ac90de4$export$d1d79bf68ac056bd);
var $ba462d1c6ac90de4$export$3a1bcba60b23d7f0 = $ba462d1c6ac90de4$var$getSerializedStylesMap("color", $ba462d1c6ac90de4$export$8473307aa00d6ea1);
var $ba462d1c6ac90de4$export$45f3f4fe16f9f7d5 = $ba462d1c6ac90de4$var$getSerializedStylesMap("fontWeight", $ba462d1c6ac90de4$export$303e322c6b1ed114);
var $ba462d1c6ac90de4$export$68cc305da27dbaa4 = $ba462d1c6ac90de4$var$getSerializedStylesMap("fontFamily", $ba462d1c6ac90de4$export$3c7e9587132614b4);
var $ba462d1c6ac90de4$export$128f10c238242f83 = $ba462d1c6ac90de4$var$getSerializedStylesMap("font", $ba462d1c6ac90de4$export$6cc560b4dedf3816);
var $ba462d1c6ac90de4$export$ff257d957d48c421 = $ba462d1c6ac90de4$var$getSerializedStylesMap((0, $6PR8P.CURRENT_SURFACE_CSS_VAR), $ba462d1c6ac90de4$export$41a358c9c2356760);
var $ba462d1c6ac90de4$export$5e65a44e5b6ecadb = function isSurfaceColorToken(color) {
    return $ba462d1c6ac90de4$export$41a358c9c2356760[color] !== undefined;
};

});
parcelRegister("6PR8P", function(module, exports) {

$parcel$export(module.exports, "CURRENT_SURFACE_CSS_VAR", function () { return $4fa0ba438de92f2d$export$9d7b58831ae93caa; });
var $4fa0ba438de92f2d$export$4ef52930e33717cd = "data-theme";
var $4fa0ba438de92f2d$export$a00eac3f8684bcd0 = "data-color-mode";
var $4fa0ba438de92f2d$export$2112803007239c61 = "data-contrast-mode";
var $4fa0ba438de92f2d$export$352e418ed5b6193a = "data-custom-theme";
var $4fa0ba438de92f2d$export$2faeed762aac6741 = "light";
var $4fa0ba438de92f2d$export$6f0c6fb8c80fcc92 = "ds";
var $4fa0ba438de92f2d$export$4d0c7bbf80185957 = [
    "opacity",
    "font",
    "space",
    "border"
];
var $4fa0ba438de92f2d$export$dddac1532e822863 = "--".concat($4fa0ba438de92f2d$export$6f0c6fb8c80fcc92, "-token-not-found");
var $4fa0ba438de92f2d$export$9d7b58831ae93caa = "--".concat($4fa0ba438de92f2d$export$6f0c6fb8c80fcc92, "-elevation-surface-current");

});



parcelRegister("1TEBh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $161a6bdf21223a51$export$2e2bcd8739ae039; });
/** @jsx jsx */ 
var $dAx5m = parcelRequire("dAx5m");

var $jVTBW = parcelRequire("jVTBW");

var $fZx25 = parcelRequire("fZx25");

var $bH6cj = parcelRequire("bH6cj");
var $161a6bdf21223a51$var$justifyContentMap = {
    start: (0, $jVTBW.css)({
        justifyContent: "start"
    }),
    center: (0, $jVTBW.css)({
        justifyContent: "center"
    }),
    end: (0, $jVTBW.css)({
        justifyContent: "end"
    }),
    "space-between": (0, $jVTBW.css)({
        justifyContent: "space-between"
    }),
    "space-around": (0, $jVTBW.css)({
        justifyContent: "space-around"
    }),
    "space-evenly": (0, $jVTBW.css)({
        justifyContent: "space-evenly"
    }),
    stretch: (0, $jVTBW.css)({
        justifyContent: "stretch"
    })
};
var $161a6bdf21223a51$var$flexDirectionMap = {
    column: (0, $jVTBW.css)({
        flexDirection: "column"
    }),
    row: (0, $jVTBW.css)({
        flexDirection: "row"
    })
};
var $161a6bdf21223a51$var$flexWrapMap = {
    wrap: (0, $jVTBW.css)({
        flexWrap: "wrap"
    }),
    nowrap: (0, $jVTBW.css)({
        flexWrap: "nowrap"
    })
};
var $161a6bdf21223a51$var$alignItemsMap = {
    start: (0, $jVTBW.css)({
        alignItems: "start"
    }),
    center: (0, $jVTBW.css)({
        alignItems: "center"
    }),
    baseline: (0, $jVTBW.css)({
        alignItems: "baseline"
    }),
    end: (0, $jVTBW.css)({
        alignItems: "end"
    }),
    stretch: (0, $jVTBW.css)({
        alignItems: "stretch"
    })
};
var $161a6bdf21223a51$var$baseStyles = (0, $jVTBW.css)({
    display: "flex",
    boxSizing: "border-box"
});
/**
 * __Flex__
 *
 * `Flex` is a primitive component that implements the CSS Flexbox API.
 *
 * - [Examples](https://atlassian.design/components/primitives/flex/examples)
 * - [Code](https://atlassian.design/components/primitives/flex/code)
 *
 * @example
 * ```tsx
 * import { Flex, Box } from '@atlaskit/primitives'
 *
 * const Component = () => (
 *   <Flex direction="column">
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *   </Flex>
 * )
 * ```
 */ var $161a6bdf21223a51$var$Flex = /*#__PURE__*/ (0, $dAx5m.memo)(/*#__PURE__*/ (0, $dAx5m.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? "div" : _ref$as, role = _ref.role, alignItems = _ref.alignItems, justifyContent = _ref.justifyContent, gap = _ref.gap, columnGap = _ref.columnGap, rowGap = _ref.rowGap, children = _ref.children, testId = _ref.testId, direction = _ref.direction, wrap = _ref.wrap, xcss = _ref.xcss;
    var resolvedStyles = (0, $bH6cj.parseXcss)(xcss);
    return (0, $jVTBW.jsx)(Component, {
        role: role,
        className: resolvedStyles.static,
        css: [
            $161a6bdf21223a51$var$baseStyles,
            gap && (0, $fZx25.spaceStylesMap).gap[gap],
            columnGap && (0, $fZx25.spaceStylesMap).columnGap[columnGap],
            rowGap && (0, $fZx25.spaceStylesMap).rowGap[rowGap],
            alignItems && $161a6bdf21223a51$var$alignItemsMap[alignItems],
            direction && $161a6bdf21223a51$var$flexDirectionMap[direction],
            justifyContent && $161a6bdf21223a51$var$justifyContentMap[justifyContent],
            wrap && $161a6bdf21223a51$var$flexWrapMap[wrap],
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
            resolvedStyles.emotion
        ],
        "data-testid": testId,
        ref: ref
    }, children);
}));
$161a6bdf21223a51$var$Flex.displayName = "Flex";
var $161a6bdf21223a51$export$2e2bcd8739ae039 = $161a6bdf21223a51$var$Flex;

});


parcelRegister("cCgQd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $92f618f33002f698$export$2e2bcd8739ae039; });

var $bgA8z = parcelRequire("bgA8z");

var $dAx5m = parcelRequire("dAx5m");

var $jVTBW = parcelRequire("jVTBW");

var $bH6cj = parcelRequire("bH6cj");

var $1TEBh = parcelRequire("1TEBh");
var $92f618f33002f698$var$flexGrowMap = {
    hug: (0, $bH6cj.xcss)({
        flexGrow: 0
    }),
    fill: (0, $bH6cj.xcss)({
        width: "100%",
        flexGrow: 1
    })
};
/**
 * __Stack__
 *
 * Stack is a primitive component based on flexbox that manages the block layout of direct children.
 *
 * @example
 * ```tsx
 *  <Stack>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *  </Stack>
 * ```
 *
 */ var $92f618f33002f698$var$Stack = /*#__PURE__*/ (0, $dAx5m.memo)(/*#__PURE__*/ (0, $dAx5m.forwardRef)(function(_ref, ref) {
    var as = _ref.as, alignItems = _ref.alignInline, _ref$alignBlock = _ref.alignBlock, alignBlock = _ref$alignBlock === void 0 ? "stretch" : _ref$alignBlock, spread = _ref.spread, grow = _ref.grow, space = _ref.space, children = _ref.children, testId = _ref.testId, xcss = _ref.xcss, role = _ref.role;
    var justifyContent = spread || alignBlock;
    // We're type coercing this as Compiled styles in an array isn't supported by the types
    // But the runtime accepts it none-the-wiser. We can remove this entire block and replace
    // it with cx(defaultStyles, focusRingStyles, xcssStyles) when we've moved away from Emotion.
    var styles = grow ? [
        $92f618f33002f698$var$flexGrowMap[grow]
    ].concat((0, (/*@__PURE__*/$parcel$interopDefault($bgA8z)))(Array.isArray(xcss) ? xcss : [
        xcss
    ])) : xcss;
    return (0, $jVTBW.jsx)((0, $1TEBh.default), {
        as: as,
        role: role,
        gap: space,
        direction: "column",
        alignItems: alignItems,
        justifyContent: justifyContent,
        xcss: styles,
        testId: testId,
        ref: ref
    }, children);
}));
$92f618f33002f698$var$Stack.displayName = "Stack";
var $92f618f33002f698$export$2e2bcd8739ae039 = $92f618f33002f698$var$Stack;

});

parcelRegister("9lCOE", function(module, exports) {

$parcel$export(module.exports, "B200", function () { return $6ce42f439e1233a7$export$215b7063051591f1; });
$parcel$export(module.exports, "N20", function () { return $6ce42f439e1233a7$export$9fdfb749e33cdf97; });
$parcel$export(module.exports, "N30", function () { return $6ce42f439e1233a7$export$3e51e8f1440314ba; });
$parcel$export(module.exports, "N200", function () { return $6ce42f439e1233a7$export$f563ee71e9ee74cd; });
$parcel$export(module.exports, "N300", function () { return $6ce42f439e1233a7$export$e2ef2124cf4024b1; });
$parcel$export(module.exports, "N30A", function () { return $6ce42f439e1233a7$export$920c0d5c49070351; });
$parcel$export(module.exports, "heading", function () { return $6ce42f439e1233a7$export$46e4a324ac90507f; });
$parcel$export(module.exports, "subtleHeading", function () { return $6ce42f439e1233a7$export$79f3f2b82beb0d36; });
$parcel$export(module.exports, "skeleton", function () { return $6ce42f439e1233a7$export$2a0674ff2eb10214; });
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ 
var $ezyGe = parcelRequire("ezyGe");
var $6ce42f439e1233a7$export$4b84fd0e2c617bd = "#FFEBE6";
var $6ce42f439e1233a7$export$b34b069eff244586 = "#FFBDAD";
var $6ce42f439e1233a7$export$be802dd0d8b57f35 = "#FF8F73";
var $6ce42f439e1233a7$export$60847d42f9da92a6 = "#FF7452";
var $6ce42f439e1233a7$export$4a7404f376229999 = "#FF5630";
var $6ce42f439e1233a7$export$2010d0fb4295b346 = "#DE350B";
var $6ce42f439e1233a7$export$2837b5a1a71d5c02 = "#BF2600";
var $6ce42f439e1233a7$export$8d9596b529bbb9cf = "#FFFAE6";
var $6ce42f439e1233a7$export$41060a744ab0b7ae = "#FFF0B3";
var $6ce42f439e1233a7$export$1cc05bbbf340e559 = "#FFE380";
var $6ce42f439e1233a7$export$5aae31392d72caaa = "#FFC400";
var $6ce42f439e1233a7$export$c6930421db9fa514 = "#FFAB00";
var $6ce42f439e1233a7$export$59619663aa6500fb = "#FF991F";
var $6ce42f439e1233a7$export$874739ea9e379ab6 = "#FF8B00";
var $6ce42f439e1233a7$export$8a6341c32b6a3ee6 = "#E3FCEF";
var $6ce42f439e1233a7$export$69a3bf21b9686c2b = "#ABF5D1";
var $6ce42f439e1233a7$export$afbce1382ec95f73 = "#79F2C0";
var $6ce42f439e1233a7$export$747d86715d4175de = "#57D9A3";
var $6ce42f439e1233a7$export$940e1f69e873f202 = "#36B37E";
var $6ce42f439e1233a7$export$a49394138f7b8e85 = "#00875A";
var $6ce42f439e1233a7$export$6fa04827ac68a4fb = "#006644";
var $6ce42f439e1233a7$export$226de0355ed012f8 = "#DEEBFF";
var $6ce42f439e1233a7$export$8c13c2ee36917869 = "#B3D4FF";
var $6ce42f439e1233a7$export$ecfc1dff386a3e7a = "#4C9AFF";
var $6ce42f439e1233a7$export$215b7063051591f1 = "#2684FF";
var $6ce42f439e1233a7$export$e62e8919cca44969 = "#0065FF";
var $6ce42f439e1233a7$export$b3de0ae08da2ce64 = "#0052CC";
var $6ce42f439e1233a7$export$a6ee3d71bc067634 = "#0747A6";
var $6ce42f439e1233a7$export$363e4475840015bb = "#EAE6FF";
var $6ce42f439e1233a7$export$4b0a4417ed59760f = "#C0B6F2";
var $6ce42f439e1233a7$export$6011520a64d9a187 = "#998DD9";
var $6ce42f439e1233a7$export$a7175d4e9206bc80 = "#8777D9";
var $6ce42f439e1233a7$export$b48405b95304b5a1 = "#6554C0";
var $6ce42f439e1233a7$export$c71e4279dd54a18d = "#5243AA";
var $6ce42f439e1233a7$export$147899de772240ec = "#403294";
var $6ce42f439e1233a7$export$2cf711fe14c66f06 = "#E6FCFF";
var $6ce42f439e1233a7$export$7a8f4d33f6f9772c = "#B3F5FF";
var $6ce42f439e1233a7$export$776c9c497ef08533 = "#79E2F2";
var $6ce42f439e1233a7$export$69cb3ca10c1e330e = "#00C7E6";
var $6ce42f439e1233a7$export$9dc1ef0f3f48059b = "#00B8D9";
var $6ce42f439e1233a7$export$7c835c78b6fcdef8 = "#00A3BF";
var $6ce42f439e1233a7$export$6036577f95c3877e = "#008DA6";
var $6ce42f439e1233a7$export$29a4f05edc054374 = "#FFFFFF";
var $6ce42f439e1233a7$export$e655ef011c4aa1a2 = "#FAFBFC";
var $6ce42f439e1233a7$export$9fdfb749e33cdf97 = "#F4F5F7";
var $6ce42f439e1233a7$export$3e51e8f1440314ba = "#EBECF0";
var $6ce42f439e1233a7$export$1ce2d1575d444ceb = "#DFE1E6";
var $6ce42f439e1233a7$export$8754fc7e6d8b3000 = "#C1C7D0";
var $6ce42f439e1233a7$export$c2e91cbeada39b8b = "#B3BAC5";
var $6ce42f439e1233a7$export$5f71e19f3a7ad9de = "#A5ADBA";
var $6ce42f439e1233a7$export$eaa8c8a70ac22806 = "#97A0AF";
var $6ce42f439e1233a7$export$7c87d337fb91a97d = "#8993A4";
var $6ce42f439e1233a7$export$d6447c357493214f = "#7A869A";
var $6ce42f439e1233a7$export$f563ee71e9ee74cd = "#6B778C";
var $6ce42f439e1233a7$export$e2ef2124cf4024b1 = "#5E6C84";
var $6ce42f439e1233a7$export$eece5f492e429f08 = "#505F79";
var $6ce42f439e1233a7$export$c39c0fe0f26207ae = "#42526E";
var $6ce42f439e1233a7$export$7090862dc3038a9f = "#344563";
var $6ce42f439e1233a7$export$ad0bacf983b7ddaa = "#253858";
var $6ce42f439e1233a7$export$7d61b15e0da132af = "#172B4D";
var $6ce42f439e1233a7$export$fbda843f0a27fe96 = "#091E42";
var $6ce42f439e1233a7$export$791e57b27ca738ef = "rgba(9, 30, 66, 0.02)";
var $6ce42f439e1233a7$export$8d43898f60b96a82 = "rgba(9, 30, 66, 0.04)";
var $6ce42f439e1233a7$export$920c0d5c49070351 = "rgba(9, 30, 66, 0.08)";
var $6ce42f439e1233a7$export$46987b49aab6d1a8 = "rgba(9, 30, 66, 0.13)";
var $6ce42f439e1233a7$export$7d3359664e8bb0e5 = "rgba(9, 30, 66, 0.25)";
var $6ce42f439e1233a7$export$d2d3bedfb276cac0 = "rgba(9, 30, 66, 0.31)";
var $6ce42f439e1233a7$export$6e5e7499ff054f6d = "rgba(9, 30, 66, 0.36)";
var $6ce42f439e1233a7$export$59264b346c877fa7 = "rgba(9, 30, 66, 0.42)";
var $6ce42f439e1233a7$export$d092757d7c64925c = "rgba(9, 30, 66, 0.48)";
var $6ce42f439e1233a7$export$486ab785e4bac3c6 = "rgba(9, 30, 66, 0.54)";
var $6ce42f439e1233a7$export$fba592bbc6419fea = "rgba(9, 30, 66, 0.60)";
var $6ce42f439e1233a7$export$13609db0e6812ab8 = "rgba(9, 30, 66, 0.66)";
var $6ce42f439e1233a7$export$fbae4efaa892d883 = "rgba(9, 30, 66, 0.71)";
var $6ce42f439e1233a7$export$f13946d26f440ce6 = "rgba(9, 30, 66, 0.77)";
var $6ce42f439e1233a7$export$19f58225ac52a306 = "rgba(9, 30, 66, 0.82)";
var $6ce42f439e1233a7$export$6384f09da70e7b62 = "rgba(9, 30, 66, 0.89)";
var $6ce42f439e1233a7$export$d0dccc730683edc2 = "rgba(9, 30, 66, 0.95)";
var $6ce42f439e1233a7$export$2f6319cf7d736c2a = "#E6EDFA";
var $6ce42f439e1233a7$export$95126bc8884d6634 = "#DCE5F5";
var $6ce42f439e1233a7$export$8338d8c35d44ff1 = "#CED9EB";
var $6ce42f439e1233a7$export$5368d76ae4fbbda7 = "#B8C7E0";
var $6ce42f439e1233a7$export$9f0a771d16ec8d36 = "#ABBBD6";
var $6ce42f439e1233a7$export$abcf8c38338b4aa5 = "#9FB0CC";
var $6ce42f439e1233a7$export$97e81faa16a182c7 = "#8C9CB8";
var $6ce42f439e1233a7$export$bfe21c59123ecf33 = "#7988A3";
var $6ce42f439e1233a7$export$ee82aa2ea6a1558 = "#67758F";
var $6ce42f439e1233a7$export$682927c6ed76be02 = "#56637A";
var $6ce42f439e1233a7$export$91fd9994c5be9757 = "#455166";
var $6ce42f439e1233a7$export$d281fbfe3cff2df6 = "#3B475C";
var $6ce42f439e1233a7$export$3902c91d8b98a753 = "#313D52";
var $6ce42f439e1233a7$export$8e8133c1ba5845b5 = "#283447";
var $6ce42f439e1233a7$export$33ff357f6620b39 = "#202B3D";
var $6ce42f439e1233a7$export$633847cf062b69e0 = "#1B2638";
var $6ce42f439e1233a7$export$9776a6e503bdbf76 = "#121A29";
var $6ce42f439e1233a7$export$6c813d5160dff5db = "#0E1624";
var $6ce42f439e1233a7$export$3d4f271a500072a = "#0D1424";
var $6ce42f439e1233a7$export$fe151285c22759ec = "rgba(13, 20, 36, 0.06)";
var $6ce42f439e1233a7$export$a101c6190d0da34 = "rgba(13, 20, 36, 0.14)";
var $6ce42f439e1233a7$export$4b16f52932fda51 = "rgba(13, 20, 36, 0.18)";
var $6ce42f439e1233a7$export$a74bcd7b9845b0d8 = "rgba(13, 20, 36, 0.29)";
var $6ce42f439e1233a7$export$9209c179316d1751 = "rgba(13, 20, 36, 0.36)";
var $6ce42f439e1233a7$export$88f55133f636c8dd = "rgba(13, 20, 36, 0.40)";
var $6ce42f439e1233a7$export$51126f85d1009512 = "rgba(13, 20, 36, 0.47)";
var $6ce42f439e1233a7$export$a069b547bd23af78 = "rgba(13, 20, 36, 0.53)";
var $6ce42f439e1233a7$export$40cce05af3b2600a = "rgba(13, 20, 36, 0.63)";
var $6ce42f439e1233a7$export$b78942185925a0d = "rgba(13, 20, 36, 0.73)";
var $6ce42f439e1233a7$export$e058fb44b8eaafca = "rgba(13, 20, 36, 0.78)";
var $6ce42f439e1233a7$export$92b0b8de26920c18 = "rgba(13, 20, 36, 0.81)";
var $6ce42f439e1233a7$export$67564f7459d3fc9e = "rgba(13, 20, 36, 0.85)";
var $6ce42f439e1233a7$export$77868e1ca884ffa3 = "rgba(13, 20, 36, 0.89)";
var $6ce42f439e1233a7$export$2afd71d7d3ea2cd5 = "rgba(13, 20, 36, 0.92)";
var $6ce42f439e1233a7$export$f2a0acaab9972c70 = "rgba(13, 20, 36, 0.95)";
var $6ce42f439e1233a7$export$9ab70e67d6475361 = "rgba(13, 20, 36, 0.97)";
var $6ce42f439e1233a7$export$8ce1fd94bee2f412 = (0, $ezyGe.default)({
    light: "var(--ds-surface, ".concat($6ce42f439e1233a7$export$29a4f05edc054374, ")"),
    dark: "var(--ds-surface, ".concat($6ce42f439e1233a7$export$633847cf062b69e0, ")")
});
var $6ce42f439e1233a7$export$b861914ea877b580 = (0, $ezyGe.default)({
    light: "var(--ds-background-selected, ".concat($6ce42f439e1233a7$export$226de0355ed012f8, ")"),
    dark: "var(--ds-background-selected, ".concat($6ce42f439e1233a7$export$8c13c2ee36917869, ")")
});
var $6ce42f439e1233a7$export$3f1b020df94387af = (0, $ezyGe.default)({
    light: "var(--ds-background-neutral-hovered, ".concat($6ce42f439e1233a7$export$3e51e8f1440314ba, ")"),
    dark: "var(--ds-background-neutral-hovered, ".concat($6ce42f439e1233a7$export$d281fbfe3cff2df6, ")")
});
var $6ce42f439e1233a7$export$c0183dbab98ca63e = (0, $ezyGe.default)({
    light: "var(--ds-surface-overlay, ".concat($6ce42f439e1233a7$export$29a4f05edc054374, ")"),
    dark: "var(--ds-surface-overlay, ".concat($6ce42f439e1233a7$export$8e8133c1ba5845b5, ")")
});
var $6ce42f439e1233a7$export$6f093cfa640b7166 = (0, $ezyGe.default)({
    light: "var(--ds-text, ".concat($6ce42f439e1233a7$export$fbda843f0a27fe96, ")"),
    dark: "var(--ds-text, ".concat($6ce42f439e1233a7$export$5368d76ae4fbbda7, ")")
});
var $6ce42f439e1233a7$export$42f8e9c698766e7a = (0, $ezyGe.default)({
    light: "var(--ds-text, ".concat($6ce42f439e1233a7$export$7d61b15e0da132af, ")"),
    dark: "var(--ds-text, ".concat($6ce42f439e1233a7$export$5368d76ae4fbbda7, ")")
});
var $6ce42f439e1233a7$export$c2d157ca1c34b6e3 = (0, $ezyGe.default)({
    light: "var(--ds-text-selected, ".concat($6ce42f439e1233a7$export$b3de0ae08da2ce64, ")"),
    dark: "var(--ds-text-selected, ".concat($6ce42f439e1233a7$export$b3de0ae08da2ce64, ")")
});
var $6ce42f439e1233a7$export$1905ba28d7cf066f = (0, $ezyGe.default)({
    light: "var(--ds-text-subtlest, ".concat($6ce42f439e1233a7$export$f563ee71e9ee74cd, ")"),
    dark: "var(--ds-text-subtlest, ".concat($6ce42f439e1233a7$export$97e81faa16a182c7, ")")
});
var $6ce42f439e1233a7$export$bd9002130d306d39 = (0, $ezyGe.default)({
    light: "var(--ds-text-subtlest, ".concat($6ce42f439e1233a7$export$f563ee71e9ee74cd, ")"),
    dark: "var(--ds-text-subtlest, ".concat($6ce42f439e1233a7$export$bfe21c59123ecf33, ")")
});
var $6ce42f439e1233a7$export$46e4a324ac90507f = (0, $ezyGe.default)({
    light: "var(--ds-text, ".concat($6ce42f439e1233a7$export$7d61b15e0da132af, ")"),
    dark: "var(--ds-text, ".concat($6ce42f439e1233a7$export$5368d76ae4fbbda7, ")")
});
var $6ce42f439e1233a7$export$79f3f2b82beb0d36 = (0, $ezyGe.default)({
    light: "var(--ds-text-subtlest, ".concat($6ce42f439e1233a7$export$f563ee71e9ee74cd, ")"),
    dark: "var(--ds-text-subtlest, ".concat($6ce42f439e1233a7$export$97e81faa16a182c7, ")")
});
var $6ce42f439e1233a7$export$7bb0d5c671655cc4 = (0, $ezyGe.default)({
    light: $6ce42f439e1233a7$export$9fdfb749e33cdf97,
    dark: $6ce42f439e1233a7$export$8e8133c1ba5845b5
});
var $6ce42f439e1233a7$export$9c30223ca0a664fb = (0, $ezyGe.default)({
    light: "var(--ds-link, ".concat($6ce42f439e1233a7$export$b3de0ae08da2ce64, ")"),
    dark: "var(--ds-link, ".concat($6ce42f439e1233a7$export$ecfc1dff386a3e7a, ")")
});
var $6ce42f439e1233a7$export$7ed258b0728b004b = (0, $ezyGe.default)({
    light: "var(--ds-link-pressed, ".concat($6ce42f439e1233a7$export$e62e8919cca44969, ")"),
    dark: "var(--ds-link-pressed, ".concat($6ce42f439e1233a7$export$215b7063051591f1, ")")
});
var $6ce42f439e1233a7$export$dfa920d8decc8a59 = (0, $ezyGe.default)({
    light: "var(--ds-link-pressed, ".concat($6ce42f439e1233a7$export$a6ee3d71bc067634, ")"),
    dark: "var(--ds-link-pressed, ".concat($6ce42f439e1233a7$export$ecfc1dff386a3e7a, ")")
});
var $6ce42f439e1233a7$export$6069e6ad5c78f632 = (0, $ezyGe.default)({
    light: "var(--ds-border-focused, ".concat($6ce42f439e1233a7$export$215b7063051591f1, ")"),
    dark: "var(--ds-border-focused, ".concat($6ce42f439e1233a7$export$215b7063051591f1, ")")
});
var $6ce42f439e1233a7$export$9ad721cf3b3debe0 = (0, $ezyGe.default)({
    light: "var(--ds-background-brand-bold, ".concat($6ce42f439e1233a7$export$b3de0ae08da2ce64, ")"),
    dark: "var(--ds-background-brand-bold, ".concat($6ce42f439e1233a7$export$ecfc1dff386a3e7a, ")")
});
var $6ce42f439e1233a7$export$2aa0182783e7e9de = (0, $ezyGe.default)({
    light: $6ce42f439e1233a7$export$b3de0ae08da2ce64,
    dark: $6ce42f439e1233a7$export$ecfc1dff386a3e7a
});
var $6ce42f439e1233a7$export$8bf7dff220b82b4a = (0, $ezyGe.default)({
    light: $6ce42f439e1233a7$export$9dc1ef0f3f48059b,
    dark: $6ce42f439e1233a7$export$69cb3ca10c1e330e
});
var $6ce42f439e1233a7$export$e13cce2a2d16a9d4 = (0, $ezyGe.default)({
    light: $6ce42f439e1233a7$export$b48405b95304b5a1,
    dark: $6ce42f439e1233a7$export$6011520a64d9a187
});
var $6ce42f439e1233a7$export$a90204d1394caf30 = (0, $ezyGe.default)({
    light: $6ce42f439e1233a7$export$4a7404f376229999,
    dark: $6ce42f439e1233a7$export$4a7404f376229999
});
var $6ce42f439e1233a7$export$594c5a8758200c32 = (0, $ezyGe.default)({
    light: $6ce42f439e1233a7$export$c6930421db9fa514,
    dark: $6ce42f439e1233a7$export$c6930421db9fa514
});
var $6ce42f439e1233a7$export$955a2ebd2fb142ae = (0, $ezyGe.default)({
    light: $6ce42f439e1233a7$export$940e1f69e873f202,
    dark: $6ce42f439e1233a7$export$940e1f69e873f202
});
var $6ce42f439e1233a7$export$2a0674ff2eb10214 = function skeleton() {
    return "var(--ds-skeleton, ".concat($6ce42f439e1233a7$export$8d43898f60b96a82, ")");
};

});
parcelRegister("ezyGe", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a9bf3c53ee61d790$export$2e2bcd8739ae039; });
/* eslint-disable prefer-rest-params */ 
var $65cOE = parcelRequire("65cOE");
// Unpack custom variants, and get correct value for the current theme
function $a9bf3c53ee61d790$var$themedVariants(variantProp, variants) {
    return function(props) {
        var theme = (0, $65cOE.default)(props);
        if (props && props[variantProp] && variants) {
            var modes = variants[props[variantProp]];
            if (modes && modes[theme.mode]) {
                var value = modes[theme.mode];
                if (value) return value;
                 // TS believes value can be undefined
            }
        }
        return "";
    };
}
function $a9bf3c53ee61d790$export$2e2bcd8739ae039(modesOrVariant, variantModes) {
    if (typeof modesOrVariant === "string") return $a9bf3c53ee61d790$var$themedVariants(modesOrVariant, variantModes);
    var modes = modesOrVariant;
    return function(props) {
        // Get theme from the user's props
        var theme = (0, $65cOE.default)(props);
        // User isn't required to provide both light and dark values
        if (theme.mode in modes) {
            var value = modes[theme.mode]; // TS believes value can be undefined
            if (value) return value;
        }
        return "";
    };
}

});
parcelRegister("65cOE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $46dd26b5fce3e9b5$export$2e2bcd8739ae039; });

var $koyev = parcelRequire("koyev");
function $46dd26b5fce3e9b5$export$2e2bcd8739ae039(props) {
    if (props && props.theme) {
        // Theme is the global Atlaskit theme
        if ((0, $koyev.CHANNEL) in props.theme) return props.theme[0, $koyev.CHANNEL];
        else if ("mode" in props.theme && (0, $koyev.THEME_MODES).includes(props.theme.mode)) return props.theme;
    }
    // If format not supported (or no theme provided), return standard theme
    return {
        mode: (0, $koyev.DEFAULT_THEME_MODE)
    };
}

});
parcelRegister("koyev", function(module, exports) {

$parcel$export(module.exports, "CHANNEL", function () { return $ed909a8423281729$export$44ffba16bd48dac6; });
$parcel$export(module.exports, "DEFAULT_THEME_MODE", function () { return $ed909a8423281729$export$c93026a968943f95; });
$parcel$export(module.exports, "THEME_MODES", function () { return $ed909a8423281729$export$6ba72c8346b4c57e; });
$parcel$export(module.exports, "gridSize", function () { return $ed909a8423281729$export$6d8204c2cb2e06b8; });

var $e2xkU = parcelRequire("e2xkU");

var $9lCOE = parcelRequire("9lCOE");
var $ed909a8423281729$export$44ffba16bd48dac6 = "__ATLASKIT_THEME__";
var $ed909a8423281729$export$c93026a968943f95 = "light";
var $ed909a8423281729$export$6ba72c8346b4c57e = [
    "light",
    "dark"
];
var $ed909a8423281729$export$7a57f79000377ca2 = function borderRadius() {
    return 3;
};
var $ed909a8423281729$export$6d8204c2cb2e06b8 = function gridSize() {
    return 8;
};
var $ed909a8423281729$export$85e3c3ca0c6fb93 = function fontSize() {
    return 14;
};
var $ed909a8423281729$export$6746fe0d9c9fab54 = function fontSizeSmall() {
    return 11;
};
var $ed909a8423281729$export$a5975749f0374264 = function fontFamily() {
    return "-apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif";
};
var $ed909a8423281729$export$356129969ee49c55 = function codeFontFamily() {
    return "'SFMono-Medium', 'SF Mono', 'Segoe UI Mono', 'Roboto Mono', 'Ubuntu Mono', Menlo, Consolas, Courier, monospace";
};
var $ed909a8423281729$export$8e24544ddba725ee = function focusRing() {
    var color = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "var(--ds-border-focused, ".concat((0, $9lCOE.B200), ")");
    var outlineWidth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $ed909a8423281729$export$6d8204c2cb2e06b8() / 4;
    (0, $e2xkU.default)("@atlaskit/theme", "focus ring mixin", "Please use `@atlaskit/focus-ring` instead.");
    return "\n  &:focus {\n    outline: none;\n    box-shadow: 0px 0px 0px ".concat(outlineWidth, "px ").concat(color, ";\n  }\n");
};
var $ed909a8423281729$export$c0dd343266bc3261 = function noFocusRing() {
    return "\n  box-shadow: none;\n";
};
var $ed909a8423281729$export$7be255094ccdc533 = {
    card: function card() {
        return 100;
    },
    navigation: function navigation() {
        return 200;
    },
    dialog: function dialog() {
        return 300;
    },
    layer: function layer() {
        return 400;
    },
    blanket: function blanket() {
        return 500;
    },
    modal: function modal() {
        return 510;
    },
    flag: function flag() {
        return 600;
    },
    spotlight: function spotlight() {
        return 700;
    },
    tooltip: function tooltip() {
        return 9999;
    }
};
var $ed909a8423281729$export$a1b3edb637fb4f35 = function visuallyHidden() {
    (0, $e2xkU.default)("@atlaskit/theme", "visually hidden mixin", "Please use `@atlaskit/visually-hidden` instead.");
    return {
        border: "0 !important",
        clip: "rect(1px, 1px, 1px, 1px) !important",
        height: "1px !important",
        overflow: "hidden !important",
        padding: "0 !important",
        position: "absolute !important",
        width: "1px !important",
        whiteSpace: "nowrap !important"
    };
};
var $ed909a8423281729$export$ba1d834b86d72a09 = $ed909a8423281729$export$a1b3edb637fb4f35;
var $ed909a8423281729$export$e497e856b4f89fcd = function skeletonShimmer() {
    return {
        css: {
            backgroundColor: "var(--ds-skeleton, ".concat((0, $9lCOE.skeleton)(), ")"),
            animationDuration: "1.5s",
            animationIterationCount: "infinite",
            animationTimingFunction: "linear",
            animationDirection: "alternate"
        },
        keyframes: {
            from: {
                backgroundColor: "var(--ds-skeleton, ".concat((0, $9lCOE.skeleton)(), ")")
            },
            to: {
                backgroundColor: "var(--ds-skeleton-subtle, ".concat((0, $9lCOE.N30A), ")")
            }
        }
    };
};

});




parcelRegister("kdvLB", function(module, exports) {

$parcel$export(module.exports, "SpacingContext", function () { return $eb7da9c47e792ad0$export$443076ec7ebce042; });
$parcel$export(module.exports, "SELECTION_STYLE_CONTEXT_DO_NOT_USE", function () { return $eb7da9c47e792ad0$export$9ca534b70725964d; });

var $dAx5m = parcelRequire("dAx5m");
var $eb7da9c47e792ad0$export$443076ec7ebce042 = /*#__PURE__*/ (0, $dAx5m.createContext)("cozy");
var $eb7da9c47e792ad0$export$9ca534b70725964d = /*#__PURE__*/ (0, $dAx5m.createContext)("border");

});



parcelRegister("5Xjg2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $45616696beaebd3e$export$2e2bcd8739ae039; });

var $4VswB = parcelRequire("4VswB");

var $dtPp3 = parcelRequire("dtPp3");

var $dAx5m = parcelRequire("dAx5m");

var $jVTBW = parcelRequire("jVTBW");

var $e2xkU = parcelRequire("e2xkU");

var $Bb0he = parcelRequire("Bb0he");

var $xcnsi = parcelRequire("xcnsi");

var $f5Q5r = parcelRequire("f5Q5r");
var $45616696beaebd3e$var$_excluded = [
    "component",
    "cssFn",
    "isDisabled",
    "isSelected",
    "onClick",
    "testId",
    "children",
    "description",
    "iconAfter",
    "iconBefore",
    "overrides",
    "onMouseDown",
    "shouldTitleWrap",
    "shouldDescriptionWrap",
    "className"
];
var $45616696beaebd3e$var$preventEvent = function preventEvent(e) {
    e.preventDefault();
};
// Dirty hack to get generics working with forward ref [1/2]
/**
 * __Custom item__
 *
 * A custom item is used to populate a menu with items that can be any element.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/custom-item)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ var $45616696beaebd3e$var$CustomItem = /*#__PURE__*/ (0, $dAx5m.memo)(/*#__PURE__*/ (0, $dAx5m.forwardRef)(function(_ref, ref) {
    var Component = _ref.component, _ref$cssFn = _ref.cssFn, cssFn = _ref$cssFn === void 0 ? (0, $Bb0he.default) : _ref$cssFn, _ref$isDisabled = _ref.isDisabled, isDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled, _ref$isSelected = _ref.isSelected, isSelected = _ref$isSelected === void 0 ? false : _ref$isSelected, onClick = _ref.onClick, testId = _ref.testId, children = _ref.children, description = _ref.description, iconAfter = _ref.iconAfter, iconBefore = _ref.iconBefore, overrides = _ref.overrides, onMouseDown = _ref.onMouseDown, shouldTitleWrap = _ref.shouldTitleWrap, shouldDescriptionWrap = _ref.shouldDescriptionWrap, UNSAFE_className = _ref.className, rest = (0, (/*@__PURE__*/$parcel$interopDefault($dtPp3)))(_ref, $45616696beaebd3e$var$_excluded);
    var onMouseDownHandler = onMouseDown;
    if (!Component) return null;
    (0, $e2xkU.propDeprecationWarning)("@atlaskit/menu", "cssFn", cssFn !== (0, $Bb0he.default), "" // TODO: Create DAC post when primitives/xcss are available as alternatives
    );
    return (0, $jVTBW.jsx)((0, $f5Q5r.default), (0, (/*@__PURE__*/$parcel$interopDefault($4VswB)))({
        className: (0, $xcnsi.getBooleanFF)("platform.design-system-team.unsafe-overrides-killswitch_c8j9m") ? undefined : UNSAFE_className
    }, rest, {
        // eslint-disable-next-line @repo/internal/react/no-unsafe-overrides
        overrides: overrides,
        description: description,
        iconAfter: iconAfter,
        title: children,
        iconBefore: iconBefore,
        isSelected: isSelected,
        isDisabled: isDisabled,
        shouldTitleWrap: shouldTitleWrap,
        shouldDescriptionWrap: shouldDescriptionWrap,
        css: (0, $jVTBW.css)(cssFn({
            isDisabled: isDisabled,
            isSelected: isSelected
        })),
        testId: testId && "".concat(testId, "--primitive")
    }), function(_ref2) {
        var children = _ref2.children, className = _ref2.className;
        return (0, $jVTBW.jsx)(Component, (0, (/*@__PURE__*/$parcel$interopDefault($4VswB)))({
            "data-testid": testId
        }, rest, {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            ref: ref,
            draggable: false,
            onDragStart: $45616696beaebd3e$var$preventEvent,
            onMouseDown: isDisabled ? $45616696beaebd3e$var$preventEvent : onMouseDownHandler,
            onClick: isDisabled ? $45616696beaebd3e$var$preventEvent : onClick,
            tabIndex: isDisabled ? -1 : undefined,
            "aria-disabled": isDisabled
        }), children);
    });
}));
var $45616696beaebd3e$export$2e2bcd8739ae039 = $45616696beaebd3e$var$CustomItem;

});

parcelRegister("g061O", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ba615283658ffe46$export$2e2bcd8739ae039; });

var $4VswB = parcelRequire("4VswB");

var $dtPp3 = parcelRequire("dtPp3");

var $dAx5m = parcelRequire("dAx5m");

var $jVTBW = parcelRequire("jVTBW");

var $e2xkU = parcelRequire("e2xkU");

var $Bb0he = parcelRequire("Bb0he");

var $xcnsi = parcelRequire("xcnsi");

var $f5Q5r = parcelRequire("f5Q5r");
var $ba615283658ffe46$var$_excluded = [
    "children",
    "href",
    "cssFn",
    "description",
    "iconAfter",
    "iconBefore",
    "isDisabled",
    "isSelected",
    "onClick",
    "testId",
    "overrides",
    "onMouseDown",
    "shouldTitleWrap",
    "shouldDescriptionWrap",
    "className"
];
var $ba615283658ffe46$var$preventEvent = function preventEvent(e) {
    e.preventDefault();
};
/**
 * __Link item__
 *
 * A link item is used to populate a menu with items that are links.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/link-item)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ var $ba615283658ffe46$var$LinkItem = /*#__PURE__*/ (0, $dAx5m.memo)(/*#__PURE__*/ (0, $dAx5m.forwardRef)(// Type needed on props to extract types with extract react types.
function(props, ref) {
    var children = props.children, href = props.href, _props$cssFn = props.cssFn, cssFn = _props$cssFn === void 0 ? (0, $Bb0he.default) : _props$cssFn, description = props.description, iconAfter = props.iconAfter, iconBefore = props.iconBefore, _props$isDisabled = props.isDisabled, isDisabled = _props$isDisabled === void 0 ? false : _props$isDisabled, _props$isSelected = props.isSelected, isSelected = _props$isSelected === void 0 ? false : _props$isSelected, onClick = props.onClick, testId = props.testId, overrides = props.overrides, onMouseDown = props.onMouseDown, shouldTitleWrap = props.shouldTitleWrap, shouldDescriptionWrap = props.shouldDescriptionWrap, UNSAFE_className = props.className, rest = (0, (/*@__PURE__*/$parcel$interopDefault($dtPp3)))(props, $ba615283658ffe46$var$_excluded);
    var onMouseDownHandler = onMouseDown;
    if (!children) return null;
    (0, $e2xkU.propDeprecationWarning)("@atlaskit/menu", "cssFn", cssFn !== (0, $Bb0he.default), "" // TODO: Create DAC post when primitives/xcss are available as alternatives
    );
    return (0, $jVTBW.jsx)((0, $f5Q5r.default), (0, (/*@__PURE__*/$parcel$interopDefault($4VswB)))({}, rest, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $xcnsi.getBooleanFF)("platform.design-system-team.unsafe-overrides-killswitch_c8j9m") ? undefined : UNSAFE_className,
        overrides: overrides,
        iconBefore: iconBefore,
        iconAfter: iconAfter,
        isSelected: isSelected,
        isDisabled: isDisabled,
        description: description,
        shouldTitleWrap: shouldTitleWrap,
        shouldDescriptionWrap: shouldDescriptionWrap,
        css: // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        cssFn({
            isSelected: isSelected,
            isDisabled: isDisabled
        }),
        title: children,
        testId: testId && "".concat(testId, "--primitive")
    }), function(_ref) {
        var children = _ref.children, className = _ref.className;
        return (0, $jVTBW.jsx)("a", (0, (/*@__PURE__*/$parcel$interopDefault($4VswB)))({
            "data-testid": testId
        }, rest, {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            href: isDisabled ? undefined : href,
            draggable: false,
            onDragStart: $ba615283658ffe46$var$preventEvent,
            onMouseDown: isDisabled ? $ba615283658ffe46$var$preventEvent : onMouseDownHandler,
            onClick: isDisabled ? $ba615283658ffe46$var$preventEvent : onClick,
            "aria-current": isSelected ? "page" : undefined,
            "aria-disabled": isDisabled,
            ref: ref
        }), children);
    });
}));
var $ba615283658ffe46$export$2e2bcd8739ae039 = $ba615283658ffe46$var$LinkItem;

});

parcelRegister("6XugO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $510fbbcd5acb42dc$export$2e2bcd8739ae039; });

var $dAx5m = parcelRequire("dAx5m");

var $9iPyH = parcelRequire("9iPyH");
// This function is called whenever a MenuItem mounts.
// The refs stored in the context are used to programatically
// control focus on a user navigates using the keyboard.
function $510fbbcd5acb42dc$var$useRegisterItemWithFocusManager() {
    var _useContext = (0, $dAx5m.useContext)((0, $9iPyH.FocusManagerContext)), registerRef = _useContext.registerRef;
    var itemRef = (0, $dAx5m.useRef)(null);
    (0, $dAx5m.useEffect)(function() {
        if (itemRef.current !== null) registerRef(itemRef.current);
    }, [
        registerRef
    ]);
    return itemRef;
}
var $510fbbcd5acb42dc$export$2e2bcd8739ae039 = $510fbbcd5acb42dc$var$useRegisterItemWithFocusManager;

});
parcelRegister("9iPyH", function(module, exports) {

$parcel$export(module.exports, "FocusManagerContext", function () { return $6c5dc9f57d488db2$export$f18c1d4fc7326096; });
$parcel$export(module.exports, "default", function () { return $6c5dc9f57d488db2$export$2e2bcd8739ae039; });

var $dAx5m = parcelRequire("dAx5m");

var $fJMKz = parcelRequire("fJMKz");

var $Bb0he = parcelRequire("Bb0he");

var $hQ2BY = parcelRequire("hQ2BY");

var $aVPfM = parcelRequire("aVPfM");
var $6c5dc9f57d488db2$export$f18c1d4fc7326096 = /*#__PURE__*/ (0, $dAx5m.createContext)({
    menuItemRefs: [],
    registerRef: (0, $Bb0he.default)
});
/**
 * Focus manager logic.
 */ var $6c5dc9f57d488db2$var$FocusManager = function FocusManager(_ref) {
    var children = _ref.children, onClose = _ref.onClose;
    var menuItemRefs = (0, $dAx5m.useRef)([]);
    var registerRef = (0, $dAx5m.useCallback)(function(ref) {
        if (ref && !menuItemRefs.current.includes(ref)) menuItemRefs.current.push(ref);
    }, []);
    var _UNSAFE_useLayering = (0, $hQ2BY.UNSAFE_useLayering)(), isLayerDisabled = _UNSAFE_useLayering.isLayerDisabled;
    // Intentionally rebinding on each render
    (0, $dAx5m.useEffect)(function() {
        return (0, $fJMKz.bind)(window, {
            type: "keydown",
            listener: (0, $aVPfM.default)(menuItemRefs.current, isLayerDisabled, onClose)
        });
    });
    var contextValue = {
        menuItemRefs: menuItemRefs.current,
        registerRef: registerRef
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement($6c5dc9f57d488db2$export$f18c1d4fc7326096.Provider, {
        value: contextValue
    }, children);
};
var $6c5dc9f57d488db2$export$2e2bcd8739ae039 = $6c5dc9f57d488db2$var$FocusManager;

});
parcelRegister("fJMKz", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.bindAll = module.exports.bind = void 0;

var $dZSBu = parcelRequire("dZSBu");
Object.defineProperty(module.exports, "bind", {
    enumerable: true,
    get: function() {
        return $dZSBu.bind;
    }
});

var $gH9q6 = parcelRequire("gH9q6");
Object.defineProperty(module.exports, "bindAll", {
    enumerable: true,
    get: function() {
        return $gH9q6.bindAll;
    }
});

});
parcelRegister("dZSBu", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.bind = void 0;
function $a30b5400d88f238a$var$bind(target, _a) {
    var type = _a.type, listener = _a.listener, options = _a.options;
    target.addEventListener(type, listener, options);
    return function unbind() {
        target.removeEventListener(type, listener, options);
    };
}
module.exports.bind = $a30b5400d88f238a$var$bind;

});

parcelRegister("gH9q6", function(module, exports) {
"use strict";
var $c277f817c526306d$var$__assign = module.exports && module.exports.__assign || function() {
    $c277f817c526306d$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $c277f817c526306d$var$__assign.apply(this, arguments);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.bindAll = void 0;

var $dZSBu = parcelRequire("dZSBu");
function $c277f817c526306d$var$toOptions(value) {
    if (typeof value === "undefined") return undefined;
    if (typeof value === "boolean") return {
        capture: value
    };
    return value;
}
function $c277f817c526306d$var$getBinding(original, sharedOptions) {
    if (sharedOptions == null) return original;
    var binding = $c277f817c526306d$var$__assign($c277f817c526306d$var$__assign({}, original), {
        options: $c277f817c526306d$var$__assign($c277f817c526306d$var$__assign({}, $c277f817c526306d$var$toOptions(sharedOptions)), $c277f817c526306d$var$toOptions(original.options))
    });
    return binding;
}
function $c277f817c526306d$var$bindAll(target, bindings, sharedOptions) {
    var unbinds = bindings.map(function(original) {
        var binding = $c277f817c526306d$var$getBinding(original, sharedOptions);
        return (0, $dZSBu.bind)(target, binding);
    });
    return function unbindAll() {
        unbinds.forEach(function(unbind) {
            return unbind();
        });
    };
}
module.exports.bindAll = $c277f817c526306d$var$bindAll;

});


parcelRegister("hQ2BY", function(module, exports) {

$parcel$export(module.exports, "UNSAFE_useLayering", function () { return $cfc9519549afcd5d$export$cec37b93989366d4; });

var $dAx5m = parcelRequire("dAx5m");

var $d7J5w = parcelRequire("d7J5w");

var $jEgcs = parcelRequire("jEgcs");
var $cfc9519549afcd5d$var$ESCAPE = "Escape";
function $cfc9519549afcd5d$export$4a4bf067ea9e7886(_ref) {
    var onClose = _ref.onClose, isDisabled = _ref.isDisabled;
    var escapePressed = (0, $dAx5m.useRef)(false);
    var _UNSAFE_useLayering = $cfc9519549afcd5d$export$cec37b93989366d4(), isLayerDisabled = _UNSAFE_useLayering.isLayerDisabled;
    var onKeyDown = (0, $dAx5m.useCallback)(function(e) {
        var isDisabledLayer = isLayerDisabled();
        if (isDisabled || escapePressed.current || e.key !== $cfc9519549afcd5d$var$ESCAPE || isDisabledLayer) // We're either already handling the key down event or it's not escape or disabled.
        // Bail early!
        return;
        escapePressed.current = true;
        onClose(e);
    }, [
        onClose,
        isDisabled,
        isLayerDisabled
    ]);
    var onKeyUp = (0, $dAx5m.useCallback)(function() {
        escapePressed.current = false;
    }, []);
    (0, $dAx5m.useEffect)(function() {
        return (0, $d7J5w.bindAll)(document, [
            {
                type: "keydown",
                listener: onKeyDown
            },
            {
                type: "keyup",
                listener: onKeyUp
            }
        ], {
            capture: false
        });
    }, [
        onKeyDown,
        onKeyUp
    ]);
}
function $cfc9519549afcd5d$export$cec37b93989366d4() {
    var currentLevel = (0, $dAx5m.useContext)((0, $jEgcs.LevelContext));
    var _useContext = (0, $dAx5m.useContext)((0, $jEgcs.TopLevelContext)), topLevelRef = _useContext.topLevelRef;
    var isLayerDisabled = (0, $dAx5m.useCallback)(function() {
        return !!topLevelRef.current && currentLevel !== topLevelRef.current;
    }, [
        currentLevel,
        topLevelRef
    ]);
    return {
        currentLevel: currentLevel,
        topLevelRef: topLevelRef,
        isLayerDisabled: isLayerDisabled
    };
}

});
parcelRegister("d7J5w", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.bindAll = module.exports.bind = void 0;

var $cuBbr = parcelRequire("cuBbr");
Object.defineProperty(module.exports, "bind", {
    enumerable: true,
    get: function() {
        return $cuBbr.bind;
    }
});

var $fQEIz = parcelRequire("fQEIz");
Object.defineProperty(module.exports, "bindAll", {
    enumerable: true,
    get: function() {
        return $fQEIz.bindAll;
    }
});

});
parcelRegister("cuBbr", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.bind = void 0;
function $9185214353df5726$var$bind(target, _a) {
    var type = _a.type, listener = _a.listener, options = _a.options;
    target.addEventListener(type, listener, options);
    return function unbind() {
        target.removeEventListener(type, listener, options);
    };
}
module.exports.bind = $9185214353df5726$var$bind;

});

parcelRegister("fQEIz", function(module, exports) {
"use strict";
var $b89b4c0c3333d9f2$var$__assign = module.exports && module.exports.__assign || function() {
    $b89b4c0c3333d9f2$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $b89b4c0c3333d9f2$var$__assign.apply(this, arguments);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.bindAll = void 0;

var $cuBbr = parcelRequire("cuBbr");
function $b89b4c0c3333d9f2$var$toOptions(value) {
    if (typeof value === "undefined") return undefined;
    if (typeof value === "boolean") return {
        capture: value
    };
    return value;
}
function $b89b4c0c3333d9f2$var$getBinding(original, sharedOptions) {
    if (sharedOptions == null) return original;
    var binding = $b89b4c0c3333d9f2$var$__assign($b89b4c0c3333d9f2$var$__assign({}, original), {
        options: $b89b4c0c3333d9f2$var$__assign($b89b4c0c3333d9f2$var$__assign({}, $b89b4c0c3333d9f2$var$toOptions(sharedOptions)), $b89b4c0c3333d9f2$var$toOptions(original.options))
    });
    return binding;
}
function $b89b4c0c3333d9f2$var$bindAll(target, bindings, sharedOptions) {
    var unbinds = bindings.map(function(original) {
        var binding = $b89b4c0c3333d9f2$var$getBinding(original, sharedOptions);
        return (0, $cuBbr.bind)(target, binding);
    });
    return function unbindAll() {
        unbinds.forEach(function(unbind) {
            return unbind();
        });
    };
}
module.exports.bindAll = $b89b4c0c3333d9f2$var$bindAll;

});


parcelRegister("jEgcs", function(module, exports) {

$parcel$export(module.exports, "LevelContext", function () { return $e4de51b1f87445ac$export$650d12d3c2ddb8fc; });
$parcel$export(module.exports, "TopLevelContext", function () { return $e4de51b1f87445ac$export$48b383b280e20440; });

var $dAx5m = parcelRequire("dAx5m");

var $Bb0he = parcelRequire("Bb0he");
var $e4de51b1f87445ac$export$650d12d3c2ddb8fc = /*#__PURE__*/ (0, $dAx5m.createContext)(0);
var $e4de51b1f87445ac$export$48b383b280e20440 = /*#__PURE__*/ (0, $dAx5m.createContext)({
    topLevelRef: {
        current: null
    },
    setTopLevel: (0, $Bb0he.default)
});
/**
 *
 *  @internal
 * Context Provider Component which provider the current level of nested layers
 * It handles level management when it mounts and unmounts
 *
 */ var $e4de51b1f87445ac$var$LevelProvider = function LevelProvider(_ref) {
    var children = _ref.children, currentLevel = _ref.currentLevel;
    var _useContext = (0, $dAx5m.useContext)($e4de51b1f87445ac$export$48b383b280e20440), setTopLevel = _useContext.setTopLevel;
    setTopLevel(currentLevel);
    (0, $dAx5m.useEffect)(function() {
        // avoid immediate cleanup using setTimeout when component unmount
        // this will make sure non-top layer components can get the correct top level value
        // when multiple layers trigger onClose in sequence.
        // From React 17, the useEffect cleanup functions are delayed till the commit phase is completed. In other words, the useEffect cleanup functions run asynchronously - for example, if the component is unmounting, the cleanup runs after the screen has been updated.
        // TODO revisit after we migrate to react 18. https://product-fabric.atlassian.net/browse/DSP-13139
        return function() {
            setTimeout(function() {
                setTopLevel(currentLevel - 1);
            }, 0);
        };
    }, [
        setTopLevel,
        currentLevel
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement($e4de51b1f87445ac$export$650d12d3c2ddb8fc.Provider, {
        value: currentLevel
    }, children);
};
/**
 *
 *  @internal
 * Context Provider Component which provides the top level of all nested layers
 * It provides initial top level ref value as 0 and set top level method
 *
 */ var $e4de51b1f87445ac$var$LayeringProvider = function LayeringProvider(_ref2) {
    var children = _ref2.children;
    var topLevelRef = (0, $dAx5m.useRef)(0);
    var value = (0, $dAx5m.useMemo)(function() {
        return {
            topLevelRef: topLevelRef,
            setTopLevel: function setTopLevel(level) {
                topLevelRef.current = level;
            }
        };
    }, [
        topLevelRef
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement($e4de51b1f87445ac$export$48b383b280e20440.Provider, {
        value: value
    }, children);
};
var $e4de51b1f87445ac$export$a183686c3f6f4ea8 = function UNSAFE_LAYERING(_ref3) {
    var children = _ref3.children, _ref3$isDisabled = _ref3.isDisabled, isDisabled = _ref3$isDisabled === void 0 ? true : _ref3$isDisabled;
    var currentLevel = (0, $dAx5m.useContext)($e4de51b1f87445ac$export$650d12d3c2ddb8fc);
    if (isDisabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).Fragment, null, children);
    var isNested = currentLevel > 0;
    var content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement($e4de51b1f87445ac$var$LevelProvider, {
        currentLevel: currentLevel + 1
    }, children);
    return isNested ? content : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement($e4de51b1f87445ac$var$LayeringProvider, null, content);
};

});


parcelRegister("aVPfM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7f56fc1d752cf6e6$export$2e2bcd8739ae039; });

var $iriaf = parcelRequire("iriaf");

var $76DDk = parcelRequire("76DDk");
var $7f56fc1d752cf6e6$var$_actionMap;
var $7f56fc1d752cf6e6$var$actionMap = ($7f56fc1d752cf6e6$var$_actionMap = {}, (0, (/*@__PURE__*/$parcel$interopDefault($iriaf)))($7f56fc1d752cf6e6$var$_actionMap, (0, $76DDk.KEY_DOWN), "next"), (0, (/*@__PURE__*/$parcel$interopDefault($iriaf)))($7f56fc1d752cf6e6$var$_actionMap, (0, $76DDk.KEY_UP), "prev"), (0, (/*@__PURE__*/$parcel$interopDefault($iriaf)))($7f56fc1d752cf6e6$var$_actionMap, (0, $76DDk.KEY_HOME), "first"), (0, (/*@__PURE__*/$parcel$interopDefault($iriaf)))($7f56fc1d752cf6e6$var$_actionMap, (0, $76DDk.KEY_END), "last"), $7f56fc1d752cf6e6$var$_actionMap);
/**
 * `currentFocusedIdx + 1` will not work if the next focusable element
 * is disabled. So, we need to iterate through the following menu items
 * to find one that isn't disabled. If all following elements are disabled,
 * return undefined.
 */ var $7f56fc1d752cf6e6$var$getNextFocusableElement = function getNextFocusableElement(refs, currentFocusedIdx) {
    while(currentFocusedIdx + 1 < refs.length){
        var isDisabled = refs[currentFocusedIdx + 1].hasAttribute("disabled");
        if (!isDisabled) return refs[currentFocusedIdx + 1];
        currentFocusedIdx++;
    }
};
/**
 * `currentFocusedIdx - 1` will not work if the prev focusable element
 * is disabled. So, we need to iterate through the previous menu items
 * to find one that isn't disabled. If all previous elements are disabled,
 * return undefined.
 */ var $7f56fc1d752cf6e6$var$getPrevFocusableElement = function getPrevFocusableElement(refs, currentFocusedIdx) {
    while(currentFocusedIdx > 0){
        var isDisabled = refs[currentFocusedIdx - 1].hasAttribute("disabled");
        if (!isDisabled) return refs[currentFocusedIdx - 1];
        currentFocusedIdx--;
    }
};
function $7f56fc1d752cf6e6$export$2e2bcd8739ae039(refs, isLayerDisabled, onClose) {
    return function(e) {
        var currentFocusedIdx = refs.findIndex(function(el) {
            var _document$activeEleme;
            return (_document$activeEleme = document.activeElement) === null || _document$activeEleme === void 0 ? void 0 : _document$activeEleme.isSameNode(el);
        });
        if (isLayerDisabled()) {
            // if nested dropdown isOpen we need to close on Tab key press
            if (e.key === (0, $76DDk.KEY_TAB) && !e.shiftKey) onClose(e);
            // if it is a nested dropdown and the level of the given dropdown is not the current level,
            // we don't need to have focus on it
            return;
        }
        var action = $7f56fc1d752cf6e6$var$actionMap[e.key];
        switch(action){
            case "next":
                // Always cancelling the event to prevent scrolling
                e.preventDefault();
                if (currentFocusedIdx < refs.length - 1) {
                    var _nextFocusableElement = $7f56fc1d752cf6e6$var$getNextFocusableElement(refs, currentFocusedIdx);
                    _nextFocusableElement === null || _nextFocusableElement === void 0 || _nextFocusableElement.focus();
                } else {
                    var firstFocusableElement = $7f56fc1d752cf6e6$var$getNextFocusableElement(refs, -1);
                    firstFocusableElement === null || firstFocusableElement === void 0 || firstFocusableElement.focus();
                }
                break;
            case "prev":
                // Always cancelling the event to prevent scrolling
                e.preventDefault();
                if (currentFocusedIdx > 0) {
                    var _prevFocusableElement = $7f56fc1d752cf6e6$var$getPrevFocusableElement(refs, currentFocusedIdx);
                    _prevFocusableElement === null || _prevFocusableElement === void 0 || _prevFocusableElement.focus();
                } else {
                    var lastFocusableElement = $7f56fc1d752cf6e6$var$getPrevFocusableElement(refs, refs.length);
                    lastFocusableElement === null || lastFocusableElement === void 0 || lastFocusableElement.focus();
                }
                break;
            case "first":
                e.preventDefault();
                // Search for first non-disabled element if first element is disabled
                var nextFocusableElement = $7f56fc1d752cf6e6$var$getNextFocusableElement(refs, -1);
                nextFocusableElement === null || nextFocusableElement === void 0 || nextFocusableElement.focus();
                break;
            case "last":
                e.preventDefault();
                // Search for last non-disabled element if last element is disabled
                var prevFocusableElement = $7f56fc1d752cf6e6$var$getPrevFocusableElement(refs, refs.length);
                prevFocusableElement === null || prevFocusableElement === void 0 || prevFocusableElement.focus();
                break;
            default:
                return;
        }
    };
}

});
parcelRegister("iriaf", function(module, exports) {

var $42egV = parcelRequire("42egV");
function $d6c8d6a90866f403$var$_defineProperty(e, r, t) {
    return (r = $42egV(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
module.exports = $d6c8d6a90866f403$var$_defineProperty, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("42egV", function(module, exports) {

var $8P8X8 = parcelRequire("8P8X8");
var $2f026b6d2f40bb03$var$_typeof = $8P8X8.default;

var $607qw = parcelRequire("607qw");
function $2f026b6d2f40bb03$var$toPropertyKey(t) {
    var i = $607qw(t, "string");
    return "symbol" == $2f026b6d2f40bb03$var$_typeof(i) ? i : i + "";
}
module.exports = $2f026b6d2f40bb03$var$toPropertyKey, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("8P8X8", function(module, exports) {
function $66ca07fe90610f4d$var$_typeof(o) {
    "@babel/helpers - typeof";
    return module.exports = $66ca07fe90610f4d$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $66ca07fe90610f4d$var$_typeof(o);
}
module.exports = $66ca07fe90610f4d$var$_typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("607qw", function(module, exports) {

var $8P8X8 = parcelRequire("8P8X8");
var $45e880fdbe07f4a7$var$_typeof = $8P8X8.default;
function $45e880fdbe07f4a7$var$toPrimitive(t, r) {
    if ("object" != $45e880fdbe07f4a7$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $45e880fdbe07f4a7$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
module.exports = $45e880fdbe07f4a7$var$toPrimitive, module.exports.__esModule = true, module.exports["default"] = module.exports;

});







parcelRegister("ddU3E", function(module, exports) {
$parcel$export(module.exports, "ProfileAvatarDropdownMenuIconSize", function () { return (parcelRequire("8nZKD")).ProfileAvatarDropdownMenuIconSize; });

$parcel$export(module.exports, "default", function () { return (parcelRequire("k9wkW")).default; });

var $k9wkW = parcelRequire("k9wkW");
parcelRequire("8nZKD");

});
parcelRegister("k9wkW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $aa730290c7aa4e58$export$2e2bcd8739ae039; });

var $bibO8 = parcelRequire("bibO8");

var $dAx5m = parcelRequire("dAx5m");

var $757qr = parcelRequire("757qr");

var $azm7k = parcelRequire("azm7k");

var $5MUVm = parcelRequire("5MUVm");

var $gbKg7 = parcelRequire("gbKg7");

var $8nZKD = parcelRequire("8nZKD");

var $f8uxT = parcelRequire("f8uxT");

var $fhHY5 = parcelRequire("fhHY5");
const $aa730290c7aa4e58$var$IconSizesThatNeedFullSizedTrigger = [
    (0, $8nZKD.ProfileAvatarDropdownMenuIconSize).xlarge,
    (0, $8nZKD.ProfileAvatarDropdownMenuIconSize).large,
    (0, $8nZKD.ProfileAvatarDropdownMenuIconSize).medium
];
const $aa730290c7aa4e58$var$ProfileAvatarDropdownMenu = ({ children: children, iconSize: iconSize })=>{
    const [isMenuOpen, setIsMenuOpen] = (0, $dAx5m.useState)(false);
    const openAvatarMenu = ()=>setIsMenuOpen(true);
    const closeAvatarMenu = ()=>setIsMenuOpen(false);
    const onAvatarMenuOpenChange = ({ isOpen: isOpen })=>setIsMenuOpen(isOpen);
    const triggerButtonSpacing = (0, $dAx5m.useMemo)(()=>{
        if ($aa730290c7aa4e58$var$IconSizesThatNeedFullSizedTrigger.includes(iconSize)) return "default";
        return "none";
    }, [
        iconSize
    ]);
    return /*#__PURE__*/ (0, $bibO8.jsxs)($f8uxT.DropdownWrapper, {
        children: [
            /*#__PURE__*/ (0, $bibO8.jsx)((0, $757qr.default), {
                placement: "bottom",
                isOpen: isMenuOpen,
                onOpenChange: onAvatarMenuOpenChange,
                trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ (0, $bibO8.jsx)((0, $fhHY5.default), {
                        ...props,
                        ref: triggerRef,
                        testId: "profile-avatar-dropdown-trigger",
                        appearance: "subtle",
                        spacing: triggerButtonSpacing,
                        iconBefore: /*#__PURE__*/ (0, $bibO8.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($azm7k))), {
                            size: iconSize,
                            label: "",
                            primaryColor: (0, $gbKg7.default)("color.icon.subtle", (0, $5MUVm).N20)
                        }),
                        onClick: openAvatarMenu
                    }),
                children: children
            }),
            // leaves the menu and avatar
            isMenuOpen && /*#__PURE__*/ (0, $bibO8.jsx)($f8uxT.MenuBlanket, {
                "data-testid": "profile-dropdown-blanket",
                onWheel: closeAvatarMenu
            })
        ]
    });
};
var $aa730290c7aa4e58$export$2e2bcd8739ae039 = $aa730290c7aa4e58$var$ProfileAvatarDropdownMenu;

});
parcelRegister("757qr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $527ec29848b89c77$export$2e2bcd8739ae039; });

var $ikNYA = parcelRequire("ikNYA");

var $iriaf = parcelRequire("iriaf");

var $gd5aU = parcelRequire("gd5aU");

var $3hVkQ = parcelRequire("3hVkQ");

var $dAx5m = parcelRequire("dAx5m");

var $fJMKz = parcelRequire("fJMKz");

var $6lUCm = parcelRequire("6lUCm");

var $76DDk = parcelRequire("76DDk");

var $2Dg3J = parcelRequire("2Dg3J");

var $Bb0he = parcelRequire("Bb0he");

var $4Xq7n = parcelRequire("4Xq7n");

var $kzmLI = parcelRequire("kzmLI");

var $8JoMy = parcelRequire("8JoMy");

var $7vqkt = parcelRequire("7vqkt");

var $7yUTl = parcelRequire("7yUTl");

var $9iPyH = parcelRequire("9iPyH");

var $kSmzo = parcelRequire("kSmzo");

var $eCFGt = parcelRequire("eCFGt");

var $6XugO = parcelRequire("6XugO");

var $7vxAI = parcelRequire("7vxAI");
var $527ec29848b89c77$var$_excluded = [
    "ref",
    "aria-controls",
    "aria-expanded",
    "aria-haspopup"
];
function $527ec29848b89c77$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $527ec29848b89c77$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $527ec29848b89c77$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($iriaf)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $527ec29848b89c77$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $527ec29848b89c77$var$gridSize = (0, $7yUTl.gridSize)();
var $527ec29848b89c77$var$MAX_HEIGHT = "calc(100vh - ".concat($527ec29848b89c77$var$gridSize * 2, "px)");
var $527ec29848b89c77$var$opposites = {
    top: "bottom",
    bottom: "top",
    left: "right",
    right: "left",
    start: "end",
    auto: "auto",
    end: "start"
};
var $527ec29848b89c77$var$getFallbackPlacements = function getFallbackPlacements(placement) {
    var placementPieces = placement.split("-");
    var mainAxis = placementPieces[0];
    // Left, right and auto placements can rely on standard popper sliding behaviour
    if (![
        "top",
        "bottom"
    ].includes(mainAxis)) return undefined;
    else if (placementPieces.length === 2 && [
        "start",
        "end"
    ].includes(placementPieces[1])) {
        var crossAxis = placementPieces[1];
        return [
            "".concat(mainAxis),
            "".concat(mainAxis, "-").concat($527ec29848b89c77$var$opposites[crossAxis]),
            "".concat($527ec29848b89c77$var$opposites[mainAxis], "-").concat(crossAxis),
            "".concat($527ec29848b89c77$var$opposites[mainAxis]),
            "".concat($527ec29848b89c77$var$opposites[mainAxis], "-").concat($527ec29848b89c77$var$opposites[crossAxis]),
            "auto"
        ];
    } else return [
        "".concat(mainAxis, "-start"),
        "".concat(mainAxis, "-end"),
        "".concat($527ec29848b89c77$var$opposites[mainAxis]),
        "".concat($527ec29848b89c77$var$opposites[mainAxis], "-start"),
        "".concat($527ec29848b89c77$var$opposites[mainAxis], "-end"),
        "auto"
    ];
};
/**
 * __Dropdown menu__
 *
 * A dropdown menu displays a list of actions or options to a user.
 *
 * - [Examples](https://atlassian.design/components/dropdown-menu/examples)
 * - [Code](https://atlassian.design/components/dropdown-menu/code)
 * - [Usage](https://atlassian.design/components/dropdown-menu/usage)
 */ var $527ec29848b89c77$var$DropdownMenu = function DropdownMenu(_ref) {
    var _ref$autoFocus = _ref.autoFocus, autoFocus = _ref$autoFocus === void 0 ? false : _ref$autoFocus, children = _ref.children, _ref$defaultOpen = _ref.defaultOpen, defaultOpen = _ref$defaultOpen === void 0 ? false : _ref$defaultOpen, _ref$isLoading = _ref.isLoading, isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading, isOpen = _ref.isOpen, _ref$onOpenChange = _ref.onOpenChange, onOpenChange = _ref$onOpenChange === void 0 ? (0, $Bb0he.default) : _ref$onOpenChange, _ref$placement = _ref.placement, placement = _ref$placement === void 0 ? "bottom-start" : _ref$placement, _ref$shouldFlip = _ref.shouldFlip, shouldFlip = _ref$shouldFlip === void 0 ? true : _ref$shouldFlip, _ref$shouldRenderToPa = _ref.shouldRenderToParent, shouldRenderToParent = _ref$shouldRenderToPa === void 0 ? false : _ref$shouldRenderToPa, spacing = _ref.spacing, statusLabel = _ref.statusLabel, testId = _ref.testId, _trigger = _ref.trigger, _ref$zIndex = _ref.zIndex, zIndex = _ref$zIndex === void 0 ? (0, $7yUTl.layers).modal() : _ref$zIndex, label = _ref.label;
    var _useControlledState = (0, $4Xq7n.default)(isOpen, function() {
        return defaultOpen;
    }), _useControlledState2 = (0, (/*@__PURE__*/$parcel$interopDefault($3hVkQ)))(_useControlledState, 2), isLocalOpen = _useControlledState2[0], setLocalIsOpen = _useControlledState2[1];
    var _useState = (0, $dAx5m.useState)(false), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($3hVkQ)))(_useState, 2), isTriggeredUsingKeyboard = _useState2[0], setTriggeredUsingKeyboard = _useState2[1];
    var id = (0, $7vxAI.default)();
    var itemRef = (0, $6XugO.default)();
    var fallbackPlacements = (0, $dAx5m.useMemo)(function() {
        return $527ec29848b89c77$var$getFallbackPlacements(placement);
    }, [
        placement
    ]);
    var handleTriggerClicked = (0, $dAx5m.useCallback)(// TODO: event is an `any` and is being cast incorrectly
    // This means that the public type for `onOpenChange` is incorrect
    // current: (event: React.MouseEvent | React.KeyboardEvent) => void;
    // correct: (event: React.MouseEvent | KeyboardEvent) => void;
    // https://product-fabric.atlassian.net/browse/DSP-4692
    function(event) {
        var newValue = !isLocalOpen;
        var clientX = event.clientX, clientY = event.clientY, type = event.type, detail = event.detail;
        if (type === "keydown") setTriggeredUsingKeyboard(true);
        else if (clientX === 0 || clientY === 0) // Hitting enter/space is registered as a click
        // with both clientX and clientY === 0
        setTriggeredUsingKeyboard(true);
        else if (detail === 0) // Fix for Safari. clientX and clientY !== 0 in Safari
        setTriggeredUsingKeyboard(true);
        else {
            var _itemRef$current;
            // The trigger element must be focused to avoid problems with an incorrectly focused element after closing DropdownMenu
            itemRef === null || itemRef === void 0 || (_itemRef$current = itemRef.current) === null || _itemRef$current === void 0 || _itemRef$current.focus();
            setTriggeredUsingKeyboard(false);
        }
        setLocalIsOpen(newValue);
        onOpenChange({
            isOpen: newValue,
            event: event
        });
    }, [
        itemRef,
        onOpenChange,
        isLocalOpen,
        setLocalIsOpen
    ]);
    var handleOnClose = (0, $dAx5m.useCallback)(function(event) {
        if (event.key !== "Escape" && event.key !== "Tab" && event.target.closest("[id^=".concat((0, $7vxAI.PREFIX), "] [aria-haspopup]"))) // Check if it is within dropdown and it is a trigger button
        // if it is a nested dropdown, clicking trigger won't close the dropdown
        // Dropdown can be closed by pressing Escape, Tab or Shift + Tab
        return;
        if (event.key === "Tab" && event.shiftKey || event.key === "Escape") requestAnimationFrame(function() {
            var _itemRef$current2;
            (_itemRef$current2 = itemRef.current) === null || _itemRef$current2 === void 0 || _itemRef$current2.focus();
        });
        var newValue = false;
        setLocalIsOpen(newValue);
        onOpenChange({
            isOpen: newValue,
            event: event
        });
    }, [
        onOpenChange,
        setLocalIsOpen,
        itemRef
    ]);
    var _useFocus = (0, $kzmLI.default)(), isFocused = _useFocus.isFocused, bindFocus = _useFocus.bindFocus;
    // When a trigger is focused, we want to open the dropdown if
    // the user presses the DownArrow
    (0, $dAx5m.useEffect)(function() {
        // Only need to listen for keydown when focused
        if (!isFocused) return 0, $Bb0he.default;
        // Being safe: we don't want to open the dropdown if it is already open
        // Note: This shouldn't happen as the trigger should not be able to get focus
        if (isLocalOpen) return 0, $Bb0he.default;
        return (0, $fJMKz.bind)(window, {
            type: "keydown",
            listener: function openOnKeyDown(e) {
                var isNestedTriggerButton;
                if (e.target instanceof HTMLElement) isNestedTriggerButton = e.target.closest("[id^=".concat((0, $7vxAI.PREFIX), "] [aria-haspopup]"));
                if (e.key === (0, $76DDk.KEY_DOWN) && !isNestedTriggerButton) {
                    // prevent page scroll
                    e.preventDefault();
                    handleTriggerClicked(e);
                } else if ((e.code === (0, $76DDk.KEY_SPACE) || e.key === (0, $76DDk.KEY_ENTER)) && e.detail === 0) // This allows us to focus on the first element if the dropdown was triggered by a custom trigger with a custom onClick
                setTriggeredUsingKeyboard(true);
                else if (e.key === (0, $76DDk.KEY_TAB) && isNestedTriggerButton) // This closes dropdown if it is a nested dropdown
                handleOnClose(e);
            }
        });
    }, [
        isFocused,
        isLocalOpen,
        handleTriggerClicked,
        handleOnClose
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $eCFGt.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $7vqkt.default), {
        id: isLocalOpen ? id : undefined,
        shouldFlip: shouldFlip,
        isOpen: isLocalOpen,
        onClose: handleOnClose,
        zIndex: zIndex,
        placement: placement,
        fallbackPlacements: fallbackPlacements,
        testId: testId && "".concat(testId, "--content"),
        shouldUseCaptureOnOutsideClick: true,
        shouldRenderToParent: shouldRenderToParent,
        shouldDisableFocusLock: true,
        trigger: function trigger(_ref2) {
            var ref = _ref2.ref, ariaControls = _ref2["aria-controls"], ariaExpanded = _ref2["aria-expanded"], ariaHasPopup = _ref2["aria-haspopup"], rest = (0, (/*@__PURE__*/$parcel$interopDefault($gd5aU)))(_ref2, $527ec29848b89c77$var$_excluded);
            if (typeof _trigger === "function") return _trigger($527ec29848b89c77$var$_objectSpread($527ec29848b89c77$var$_objectSpread($527ec29848b89c77$var$_objectSpread({
                "aria-controls": ariaControls,
                "aria-expanded": ariaExpanded,
                "aria-haspopup": ariaHasPopup
            }, rest), bindFocus), {}, {
                triggerRef: (0, $2Dg3J.default)([
                    ref,
                    itemRef
                ]),
                isSelected: isLocalOpen,
                onClick: handleTriggerClicked,
                testId: testId && "".concat(testId, "--trigger")
            }));
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $6lUCm.default), (0, (/*@__PURE__*/$parcel$interopDefault($ikNYA)))({}, bindFocus, {
                ref: (0, $2Dg3J.default)([
                    ref,
                    itemRef
                ]),
                "aria-controls": ariaControls,
                "aria-expanded": ariaExpanded,
                "aria-haspopup": ariaHasPopup,
                isSelected: isLocalOpen,
                iconAfter: (0, (/*@__PURE__*/$parcel$interopDefault($8JoMy))),
                onClick: handleTriggerClicked,
                testId: testId && "".concat(testId, "--trigger"),
                "aria-label": label
            }), _trigger);
        },
        content: function content(_ref3) {
            var setInitialFocusRef = _ref3.setInitialFocusRef, update = _ref3.update;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $9iPyH.default), {
                onClose: handleOnClose
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $kSmzo.default), {
                spacing: spacing,
                maxHeight: $527ec29848b89c77$var$MAX_HEIGHT,
                maxWidth: 800,
                onClose: handleOnClose,
                onUpdate: update,
                isLoading: isLoading,
                statusLabel: statusLabel,
                setInitialFocusRef: isTriggeredUsingKeyboard || autoFocus ? setInitialFocusRef : undefined,
                shouldRenderToParent: shouldRenderToParent,
                isTriggeredUsingKeyboard: isTriggeredUsingKeyboard,
                autoFocus: autoFocus,
                testId: testId && "".concat(testId, "--menu-wrapper")
            }, children));
        }
    }));
};
var $527ec29848b89c77$export$2e2bcd8739ae039 = $527ec29848b89c77$var$DropdownMenu;

});
parcelRegister("3hVkQ", function(module, exports) {

var $eO9bO = parcelRequire("eO9bO");

var $6EI7o = parcelRequire("6EI7o");

var $lFJSY = parcelRequire("lFJSY");

var $cxTga = parcelRequire("cxTga");
function $264f6f333084a74d$var$_slicedToArray(r, e) {
    return $eO9bO(r) || $6EI7o(r, e) || $lFJSY(r, e) || $cxTga();
}
module.exports = $264f6f333084a74d$var$_slicedToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("eO9bO", function(module, exports) {
function $ac7cdd093454a443$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
module.exports = $ac7cdd093454a443$var$_arrayWithHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("6EI7o", function(module, exports) {
function $4d88b3718c28aba4$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
module.exports = $4d88b3718c28aba4$var$_iterableToArrayLimit, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("lFJSY", function(module, exports) {

var $gWhnX = parcelRequire("gWhnX");
function $fc7105430528a85d$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $gWhnX(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $gWhnX(r, a) : void 0;
    }
}
module.exports = $fc7105430528a85d$var$_unsupportedIterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("gWhnX", function(module, exports) {
function $c54f8c7f221761a4$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
module.exports = $c54f8c7f221761a4$var$_arrayLikeToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("cxTga", function(module, exports) {
function $92236e8d52884ddb$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
module.exports = $92236e8d52884ddb$var$_nonIterableRest, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("6lUCm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4a009f5ad4e5a5b2$export$2e2bcd8739ae039; });

var $ikNYA = parcelRequire("ikNYA");

var $gd5aU = parcelRequire("gd5aU");

var $dAx5m = parcelRequire("dAx5m");

var $29ou0 = parcelRequire("29ou0");

var $8FAPf = parcelRequire("8FAPf");

var $lQQIZ = parcelRequire("lQQIZ");
var $4a009f5ad4e5a5b2$var$_excluded = [
    "analyticsContext",
    "appearance",
    "aria-label",
    "aria-labelledby",
    "autoFocus",
    "children",
    "iconAfter",
    "iconBefore",
    "interactionName",
    "isDisabled",
    "isLoading",
    "isSelected",
    "onClick",
    "onClickCapture",
    "onKeyDownCapture",
    "onKeyUpCapture",
    "onMouseDownCapture",
    "onMouseUpCapture",
    "onPointerDownCapture",
    "onPointerUpCapture",
    "onTouchEndCapture",
    "onTouchStartCapture",
    "overlay",
    "shouldFitContainer",
    "spacing",
    "testId",
    "type",
    "UNSAFE_iconAfter_size",
    "UNSAFE_iconBefore_size"
], $4a009f5ad4e5a5b2$var$_excluded2 = [
    "className",
    "css",
    "as",
    "style"
];
/**
 * __Button__
 *
 * A button triggers an event or action.
 *
 * - [Examples](https://atlassian.design/components/button/examples)
 * - [Code](https://atlassian.design/components/button/code)
 * - [Usage](https://atlassian.design/components/button/usage)
 */ var $4a009f5ad4e5a5b2$var$Button = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).forwardRef(function Button(_ref, ref) {
    var analyticsContext = _ref.analyticsContext, appearance = _ref.appearance, ariaLabel = _ref["aria-label"], ariaLabelledBy = _ref["aria-labelledby"], autoFocus = _ref.autoFocus, children = _ref.children, iconAfter = _ref.iconAfter, iconBefore = _ref.iconBefore, interactionName = _ref.interactionName, isDisabled = _ref.isDisabled, isLoading = _ref.isLoading, isSelected = _ref.isSelected, onClick = _ref.onClick, onClickCapture = _ref.onClickCapture, onKeyDownCapture = _ref.onKeyDownCapture, onKeyUpCapture = _ref.onKeyUpCapture, onMouseDownCapture = _ref.onMouseDownCapture, onMouseUpCapture = _ref.onMouseUpCapture, onPointerDownCapture = _ref.onPointerDownCapture, onPointerUpCapture = _ref.onPointerUpCapture, onTouchEndCapture = _ref.onTouchEndCapture, onTouchStartCapture = _ref.onTouchStartCapture, overlay = _ref.overlay, shouldFitContainer = _ref.shouldFitContainer, spacing = _ref.spacing, testId = _ref.testId, _ref$type = _ref.type, type = _ref$type === void 0 ? "button" : _ref$type, UNSAFE_iconAfter_size = _ref.UNSAFE_iconAfter_size, UNSAFE_iconBefore_size = _ref.UNSAFE_iconBefore_size, unsafeRest = (0, (/*@__PURE__*/$parcel$interopDefault($gd5aU)))(_ref, $4a009f5ad4e5a5b2$var$_excluded);
    // @ts-expect-error
    var _className = unsafeRest.className, _css = unsafeRest.css, _as = unsafeRest.as, _style = unsafeRest.style, saferRest = (0, (/*@__PURE__*/$parcel$interopDefault($gd5aU)))(unsafeRest, $4a009f5ad4e5a5b2$var$_excluded2);
    var rest = (0, $29ou0.getBooleanFF)("platform.design-system-team.remove-unsafe-spread-from-new-button_a2xhw") ? saferRest : unsafeRest;
    var baseProps = (0, $lQQIZ.default)({
        ariaLabel: ariaLabel,
        ariaLabelledBy: ariaLabelledBy,
        analyticsContext: analyticsContext,
        appearance: appearance,
        autoFocus: autoFocus,
        buttonType: "button",
        children: children,
        iconAfter: iconAfter,
        iconBefore: iconBefore,
        interactionName: interactionName,
        isDisabled: isDisabled,
        isLoading: isLoading,
        isSelected: isSelected,
        onClick: onClick,
        onClickCapture: onClickCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onTouchEndCapture: onTouchEndCapture,
        onTouchStartCapture: onTouchStartCapture,
        overlay: overlay,
        ref: ref,
        shouldFitContainer: shouldFitContainer,
        spacing: spacing,
        testId: testId,
        UNSAFE_iconAfter_size: UNSAFE_iconAfter_size,
        UNSAFE_iconBefore_size: UNSAFE_iconBefore_size
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $8FAPf.default), (0, (/*@__PURE__*/$parcel$interopDefault($ikNYA)))({}, rest, {
        "aria-label": baseProps["aria-label"],
        "aria-labelledby": baseProps["aria-labelledby"],
        ref: baseProps.ref,
        xcss: baseProps.xcss,
        isDisabled: baseProps.isDisabled,
        onClick: baseProps.onClick,
        onMouseDownCapture: baseProps.onMouseDownCapture,
        onMouseUpCapture: baseProps.onMouseUpCapture,
        onKeyDownCapture: baseProps.onKeyDownCapture,
        onKeyUpCapture: baseProps.onKeyUpCapture,
        onTouchStartCapture: baseProps.onTouchStartCapture,
        onTouchEndCapture: baseProps.onTouchEndCapture,
        onPointerDownCapture: baseProps.onPointerDownCapture,
        onPointerUpCapture: baseProps.onPointerUpCapture,
        onClickCapture: baseProps.onClickCapture,
        type: type,
        testId: testId,
        analyticsContext: analyticsContext,
        interactionName: interactionName,
        componentName: "Button"
    }), baseProps.children);
}));
$4a009f5ad4e5a5b2$var$Button.displayName = "Button";
var $4a009f5ad4e5a5b2$export$2e2bcd8739ae039 = $4a009f5ad4e5a5b2$var$Button;

});
parcelRegister("29ou0", function(module, exports) {

$parcel$export(module.exports, "getBooleanFF", function () { return $190f69dd35a9a725$export$470e5c2be1411c89; });

var $hYN41 = parcelRequire("hYN41");
function $190f69dd35a9a725$export$ba05d765b8392e5e(flagResolver) {
    (0, $hYN41.setBooleanResolver)(flagResolver);
}
function $190f69dd35a9a725$export$470e5c2be1411c89(name) {
    return (0, $hYN41.resolveBooleanFlag)(name);
}

});
parcelRegister("hYN41", function(module, exports) {

$parcel$export(module.exports, "setBooleanResolver", function () { return $d16e194ec7d7dc14$export$f2b591175b3e424c; });
$parcel$export(module.exports, "resolveBooleanFlag", function () { return $d16e194ec7d7dc14$export$6333b6aff9fc6275; });

var $gcjAp = parcelRequire("gcjAp");

var $ahJoN = parcelRequire("ahJoN");
var $d16e194ec7d7dc14$var$pkgName = "@atlaskit/platform-feature-flags";
var $d16e194ec7d7dc14$export$7e41b1b2bdee3f98 = "__PLATFORM_FEATURE_FLAGS__";
var $d16e194ec7d7dc14$var$hasProcessEnv = typeof $ahJoN !== "undefined" && typeof $ahJoN.env !== "undefined";
// FF global overrides can be configured by test runners or Storybook
var $d16e194ec7d7dc14$var$ENV_ENABLE_PLATFORM_FF = $d16e194ec7d7dc14$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
// STORYBOOK_ENABLE_PLATFORM_FF is included as storybook only allows env vars prefixed with STORYBOOK
// https://github.com/storybookjs/storybook/issues/12270
var $d16e194ec7d7dc14$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF = $d16e194ec7d7dc14$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
var $d16e194ec7d7dc14$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE = $d16e194ec7d7dc14$var$ENV_ENABLE_PLATFORM_FF || $d16e194ec7d7dc14$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF;
var $d16e194ec7d7dc14$var$DEFAULT_PFF_GLOBAL = {
    // In development mode we want to capture any feature flag checks that happen using the default resolver and log this result when the resolver is replaced.
    // This is because evaluating feature flags when the resolver/FF client is loaded asynchronously could cause unexpected issues.
    earlyResolvedFlags: new Map(),
    booleanResolver: function booleanResolver(flagKey) {
        var unresolvedFlagCount;
        return false;
    }
};
var $d16e194ec7d7dc14$var$globalVar = typeof window !== "undefined" ? window : globalThis;
$d16e194ec7d7dc14$var$globalVar[$d16e194ec7d7dc14$export$7e41b1b2bdee3f98] = $d16e194ec7d7dc14$var$globalVar[$d16e194ec7d7dc14$export$7e41b1b2bdee3f98] || $d16e194ec7d7dc14$var$DEFAULT_PFF_GLOBAL;
function $d16e194ec7d7dc14$export$f2b591175b3e424c(resolver) {
    $d16e194ec7d7dc14$var$globalVar[$d16e194ec7d7dc14$export$7e41b1b2bdee3f98].booleanResolver = resolver;
    var _globalVar$PFF_GLOBAL;
}
function $d16e194ec7d7dc14$export$6333b6aff9fc6275(flagKey) {
    if ($d16e194ec7d7dc14$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE) {
        (0, $gcjAp.debug)('[%s]: The feature flags were enabled while running tests. The flag "%s" will be always enabled.', $d16e194ec7d7dc14$var$pkgName, flagKey);
        return true;
    }
    try {
        var _globalVar$PFF_GLOBAL2;
        var result = (_globalVar$PFF_GLOBAL2 = $d16e194ec7d7dc14$var$globalVar[$d16e194ec7d7dc14$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL2 === void 0 ? void 0 : _globalVar$PFF_GLOBAL2.booleanResolver(flagKey);
        if (typeof result !== "boolean") {
            // eslint-disable-next-line no-console
            console.warn("".concat(flagKey, " resolved to a non-boolean value, returning false for safety"));
            return false;
        }
        return result;
    } catch (e) {
        return false;
    }
}

});
parcelRegister("gcjAp", function(module, exports) {

$parcel$export(module.exports, "debug", function () { return $bcacf5c1c6528ba2$export$1c9f709888824e05; });
var $bcacf5c1c6528ba2$var$_ref, $bcacf5c1c6528ba2$var$_process, $bcacf5c1c6528ba2$var$_process2;
// We can't rely on NODE_ENV === 'test' if its value is already configured by the consumer to some other value, so better to use JEST_WORKER_ID
// https://jestjs.io/docs/environment-variables#jest_worker_id
var $bcacf5c1c6528ba2$var$TESTS_MODE = ($bcacf5c1c6528ba2$var$_ref = (globalThis === null || globalThis === void 0 || ($bcacf5c1c6528ba2$var$_process = globalThis.process) === null || $bcacf5c1c6528ba2$var$_process === void 0 || ($bcacf5c1c6528ba2$var$_process = $bcacf5c1c6528ba2$var$_process.env) === null || $bcacf5c1c6528ba2$var$_process === void 0 ? void 0 : $bcacf5c1c6528ba2$var$_process.JEST_WORKER_ID) !== undefined, $bcacf5c1c6528ba2$var$_ref !== void 0) ? $bcacf5c1c6528ba2$var$_ref : false;
var $bcacf5c1c6528ba2$var$DEBUG_MODE = !$bcacf5c1c6528ba2$var$TESTS_MODE && (globalThis === null || globalThis === void 0 || ($bcacf5c1c6528ba2$var$_process2 = globalThis.process) === null || $bcacf5c1c6528ba2$var$_process2 === void 0 || ($bcacf5c1c6528ba2$var$_process2 = $bcacf5c1c6528ba2$var$_process2.env) === null || $bcacf5c1c6528ba2$var$_process2 === void 0 ? void 0 : $bcacf5c1c6528ba2$var$_process2.NODE_ENV) !== "production";
var $bcacf5c1c6528ba2$export$1c9f709888824e05 = function debug() {
    var _console;
    if (!$bcacf5c1c6528ba2$var$DEBUG_MODE) return;
    // eslint-disable-next-line no-console
    (_console = console).debug.apply(_console, arguments);
};

});



parcelRegister("8FAPf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $64feb7dd7ccf1f9b$export$2e2bcd8739ae039; });

var $ikNYA = parcelRequire("ikNYA");

var $gd5aU = parcelRequire("gd5aU");

var $dAx5m = parcelRequire("dAx5m");

var $jVTBW = parcelRequire("jVTBW");

var $dOsJ0 = parcelRequire("dOsJ0");

var $Bb0he = parcelRequire("Bb0he");

var $kqsmh = parcelRequire("kqsmh");

var $1BNrX = parcelRequire("1BNrX");

var $aSd6p = parcelRequire("aSd6p");

var $bPrsJ = parcelRequire("bPrsJ");
var $64feb7dd7ccf1f9b$var$_excluded = [
    "children",
    "backgroundColor",
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    "isDisabled",
    "type",
    "onClick",
    "interactionName",
    "componentName",
    "analyticsContext",
    "style",
    "testId",
    "xcss"
], $64feb7dd7ccf1f9b$var$_excluded2 = [
    "className"
];
// This duplicates FocusRing styles from `@atlaskit/focus-ring`.
var $64feb7dd7ccf1f9b$var$focusRingStyles = (0, $jVTBW.css)({
    "&:focus, &:focus-visible": {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        outlineColor: (0, $1BNrX.borderColorMap)["color.border.focused"],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        outlineOffset: (0, $1BNrX.positiveSpaceMap)["space.025"],
        outlineStyle: "solid",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        outlineWidth: (0, $1BNrX.borderWidthMap)["border.width.outline"]
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    "&:focus:not(:focus-visible)": {
        outline: "none"
    },
    "@media screen and (forced-colors: active), screen and (-ms-high-contrast: active)": {
        "&:focus-visible": {
            outline: "1px solid"
        }
    }
});
var $64feb7dd7ccf1f9b$var$baseStyles = (0, $jVTBW.css)({
    boxSizing: "border-box",
    appearance: "none",
    border: "none"
});
var $64feb7dd7ccf1f9b$var$enabledStyles = (0, $jVTBW.css)({
    cursor: "pointer"
});
var $64feb7dd7ccf1f9b$var$disabledStyles = (0, $jVTBW.css)({
    cursor: "not-allowed"
});
/**
 * __Pressable__
 *
 * A primitive for building custom buttons.
 *
 * - [Examples](https://atlassian.design/components/primitives/pressable/examples)
 * - [Code](https://atlassian.design/components/primitives/pressable/code)
 * - [Usage](https://atlassian.design/components/primitives/pressable/usage)
 */ var $64feb7dd7ccf1f9b$var$Pressable = /*#__PURE__*/ (0, $dAx5m.forwardRef)(function(_ref, ref) {
    var children = _ref.children, backgroundColor = _ref.backgroundColor, padding = _ref.padding, paddingBlock = _ref.paddingBlock, paddingBlockStart = _ref.paddingBlockStart, paddingBlockEnd = _ref.paddingBlockEnd, paddingInline = _ref.paddingInline, paddingInlineStart = _ref.paddingInlineStart, paddingInlineEnd = _ref.paddingInlineEnd, isDisabled = _ref.isDisabled, _ref$type = _ref.type, type = _ref$type === void 0 ? "button" : _ref$type, _ref$onClick = _ref.onClick, providedOnClick = _ref$onClick === void 0 ? (0, $Bb0he.default) : _ref$onClick, interactionName = _ref.interactionName, componentName = _ref.componentName, analyticsContext = _ref.analyticsContext, style = _ref.style, testId = _ref.testId, xcss = _ref.xcss, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($gd5aU)))(_ref, $64feb7dd7ccf1f9b$var$_excluded);
    var interactionContext = (0, $dAx5m.useContext)((0, $kqsmh.default));
    var handleClick = (0, $dAx5m.useCallback)(function(e, analyticsEvent) {
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    var onClick = (0, $dOsJ0.usePlatformLeafEventHandler)({
        fn: handleClick,
        action: "clicked",
        componentName: componentName || "Pressable",
        packageName: "@atlaskit/primitives",
        packageVersion: "8.2.1",
        analyticsData: analyticsContext,
        actionSubject: "button"
    });
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($gd5aU)))(htmlAttributes, $64feb7dd7ccf1f9b$var$_excluded2);
    var resolvedStyles = (0, $aSd6p.parseXcss)(xcss);
    var node = // eslint-disable-next-line @atlaskit/design-system/no-html-button
    (0, $jVTBW.jsx)("button", (0, (/*@__PURE__*/$parcel$interopDefault($ikNYA)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        ref: ref,
        className: resolvedStyles.static
    }, safeHtmlAttributes, {
        // eslint-disable-next-line react/button-has-type
        type: type,
        onClick: onClick,
        disabled: isDisabled,
        css: [
            $64feb7dd7ccf1f9b$var$baseStyles,
            $64feb7dd7ccf1f9b$var$focusRingStyles,
            isDisabled ? $64feb7dd7ccf1f9b$var$disabledStyles : $64feb7dd7ccf1f9b$var$enabledStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            backgroundColor && (0, $1BNrX.backgroundColorStylesMap)[backgroundColor],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $1BNrX.isSurfaceColorToken)(backgroundColor) && (0, $1BNrX.surfaceColorStylesMap)[backgroundColor],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            padding && (0, $1BNrX.paddingStylesMap).padding[padding],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlock && (0, $1BNrX.paddingStylesMap).paddingBlock[paddingBlock],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockStart && (0, $1BNrX.paddingStylesMap).paddingBlockStart[paddingBlockStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockEnd && (0, $1BNrX.paddingStylesMap).paddingBlockEnd[paddingBlockEnd],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInline && (0, $1BNrX.paddingStylesMap).paddingInline[paddingInline],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineStart && (0, $1BNrX.paddingStylesMap).paddingInlineStart[paddingInlineStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineEnd && (0, $1BNrX.paddingStylesMap).paddingInlineEnd[paddingInlineEnd],
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            resolvedStyles.emotion
        ],
        "data-testid": testId
    }), children);
    return backgroundColor ? (0, $jVTBW.jsx)((0, $bPrsJ.SurfaceContext).Provider, {
        value: backgroundColor
    }, node) : node;
});
var $64feb7dd7ccf1f9b$export$2e2bcd8739ae039 = $64feb7dd7ccf1f9b$var$Pressable;

});
parcelRegister("dOsJ0", function(module, exports) {

$parcel$export(module.exports, "usePlatformLeafEventHandler", function () { return $a0e63a04b8bf5494$export$a4687b0234b40e28; });

var $iriaf = parcelRequire("iriaf");

var $dAx5m = parcelRequire("dAx5m");

var $kTlAj = parcelRequire("kTlAj");

var $6vpiG = parcelRequire("6vpiG");
function $a0e63a04b8bf5494$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $a0e63a04b8bf5494$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $a0e63a04b8bf5494$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($iriaf)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $a0e63a04b8bf5494$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $a0e63a04b8bf5494$export$a4687b0234b40e28(_ref) {
    var fn = _ref.fn, action = _ref.action, componentName = _ref.componentName, actionSubject = _ref.actionSubject, packageName = _ref.packageName, packageVersion = _ref.packageVersion, analyticsData = _ref.analyticsData;
    var _useAnalyticsEvents = (0, $kTlAj.useAnalyticsEvents)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    // We put analyticsData and fn in a ref so that we don't need to break
    // memoization.
    // Generally these could be defined by consumers inline
    // and so we do this to avoid breaking memoization of useCallback
    var dataRef = (0, $6vpiG.useTrackedRef)(analyticsData);
    var fnRef = (0, $6vpiG.useTrackedRef)(fn);
    var handler = (0, $dAx5m.useCallback)(function(value) {
        var analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: actionSubject || componentName,
            attributes: {
                componentName: componentName,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
        // To avoid wrapping this component in AnalyticsContext we manually
        // push the parent context's meta data into the context.
        // Note: this new 'context'
        var context = $a0e63a04b8bf5494$var$_objectSpread({
            componentName: componentName,
            packageName: packageName,
            packageVersion: packageVersion
        }, dataRef.current);
        analyticsEvent.context.push(context);
        // fire an event on the atlaskit channel
        var clone = analyticsEvent.clone();
        if (clone) clone.fire("atlaskit");
        fnRef.current(value, analyticsEvent);
    }, [
        // These are strings and won't change
        action,
        componentName,
        actionSubject,
        packageName,
        packageVersion,
        // This function is memoized in the context
        createAnalyticsEvent,
        // these are a stable ref because of the useTrackedRef hook
        dataRef,
        fnRef
    ]);
    return handler;
}

});
parcelRegister("kTlAj", function(module, exports) {

$parcel$export(module.exports, "useAnalyticsEvents", function () { return $f359affcad1c6262$export$5bf35293e545f20c; });

var $tWuif = parcelRequire("tWuif");

var $hYMHY = parcelRequire("hYMHY");

var $hxm7R = parcelRequire("hxm7R");
function $f359affcad1c6262$export$5bf35293e545f20c() {
    var analyticsContext = (0, $hxm7R.useAnalyticsContext)();
    var createAnalyticsEvent = (0, $tWuif.useCallbackOne)(function(payload) {
        return new (0, $hYMHY.default)({
            context: analyticsContext.getAtlaskitAnalyticsContext(),
            handlers: analyticsContext.getAtlaskitAnalyticsEventHandlers(),
            payload: payload
        });
    }, [
        analyticsContext
    ]);
    return {
        createAnalyticsEvent: createAnalyticsEvent
    };
}

});
parcelRegister("hYMHY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d16dd2b3b68dff4f$export$2e2bcd8739ae039; });

var $hwFBe = parcelRequire("hwFBe");

var $2Su57 = parcelRequire("2Su57");

var $l6xlx = parcelRequire("l6xlx");

var $ixgxw = parcelRequire("ixgxw");

var $kWzN6 = parcelRequire("kWzN6");

var $bZODV = parcelRequire("bZODV");

var $h4REW = parcelRequire("h4REW");

var $71O4d = parcelRequire("71O4d");

var $iriaf = parcelRequire("iriaf");

var $96rnt = parcelRequire("96rnt");
function $d16dd2b3b68dff4f$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $d16dd2b3b68dff4f$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, (/*@__PURE__*/$parcel$interopDefault($71O4d)))(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, (/*@__PURE__*/$parcel$interopDefault($71O4d)))(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, (/*@__PURE__*/$parcel$interopDefault($h4REW)))(this, result);
    };
}
function $d16dd2b3b68dff4f$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($d16dd2b3b68dff4f$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $d16dd2b3b68dff4f$export$35f8383928ba8d7 = function isUIAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $d16dd2b3b68dff4f$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isUIAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === "UIAnalyticsEvent";
};
var $d16dd2b3b68dff4f$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_AnalyticsEvent) {
    (0, (/*@__PURE__*/$parcel$interopDefault($bZODV)))(UIAnalyticsEvent, _AnalyticsEvent);
    var _super = $d16dd2b3b68dff4f$var$_createSuper(UIAnalyticsEvent);
    function UIAnalyticsEvent(props) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($2Su57)))(this, UIAnalyticsEvent);
        _this = _super.call(this, props);
        (0, (/*@__PURE__*/$parcel$interopDefault($iriaf)))((0, (/*@__PURE__*/$parcel$interopDefault($ixgxw)))(_this), "_isUIAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($iriaf)))((0, (/*@__PURE__*/$parcel$interopDefault($ixgxw)))(_this), "clone", function() {
            if (_this.hasFired) return null;
            var context = (0, (/*@__PURE__*/$parcel$interopDefault($hwFBe)))(_this.context);
            var handlers = (0, (/*@__PURE__*/$parcel$interopDefault($hwFBe)))(_this.handlers);
            /**
       * A hacky "deep clone" of the object. This is limited in that it wont
       * support functions, regexs, Maps, Sets, etc, but none of those need to
       * be represented in our payload.
       */ var payload = JSON.parse(JSON.stringify(_this.payload));
            return new UIAnalyticsEvent({
                context: context,
                handlers: handlers,
                payload: payload
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($iriaf)))((0, (/*@__PURE__*/$parcel$interopDefault($ixgxw)))(_this), "fire", function(channel) {
            if (_this.hasFired) return;
            _this.handlers.forEach(function(handler) {
                return handler((0, (/*@__PURE__*/$parcel$interopDefault($ixgxw)))(_this), channel);
            });
            _this.hasFired = true;
        });
        _this.context = props.context || [];
        _this.handlers = props.handlers || [];
        _this.hasFired = false;
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($l6xlx)))(UIAnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (this.hasFired) return this;
                return (0, (/*@__PURE__*/$parcel$interopDefault($kWzN6)))((0, (/*@__PURE__*/$parcel$interopDefault($71O4d)))(UIAnalyticsEvent.prototype), "update", this).call(this, updater);
            }
        }
    ]);
    return UIAnalyticsEvent;
}((0, $96rnt.default));

});
parcelRegister("hwFBe", function(module, exports) {

var $kgYZQ = parcelRequire("kgYZQ");

var $d2FvT = parcelRequire("d2FvT");

var $lFJSY = parcelRequire("lFJSY");

var $1QROU = parcelRequire("1QROU");
function $cc25b1a147d9d357$var$_toConsumableArray(r) {
    return $kgYZQ(r) || $d2FvT(r) || $lFJSY(r) || $1QROU();
}
module.exports = $cc25b1a147d9d357$var$_toConsumableArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("kgYZQ", function(module, exports) {

var $gWhnX = parcelRequire("gWhnX");
function $ec249de4122a0dea$var$_arrayWithoutHoles(r) {
    if (Array.isArray(r)) return $gWhnX(r);
}
module.exports = $ec249de4122a0dea$var$_arrayWithoutHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("d2FvT", function(module, exports) {
function $97eba9f9995ff5a8$var$_iterableToArray(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
module.exports = $97eba9f9995ff5a8$var$_iterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("1QROU", function(module, exports) {
function $1594655279621f89$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
module.exports = $1594655279621f89$var$_nonIterableSpread, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("2Su57", function(module, exports) {
function $2187f581029d80ab$var$_classCallCheck(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
module.exports = $2187f581029d80ab$var$_classCallCheck, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("l6xlx", function(module, exports) {

var $42egV = parcelRequire("42egV");
function $f5d4066c21d4c116$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, $42egV(o.key), o);
    }
}
function $f5d4066c21d4c116$var$_createClass(e, r, t) {
    return r && $f5d4066c21d4c116$var$_defineProperties(e.prototype, r), t && $f5d4066c21d4c116$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}
module.exports = $f5d4066c21d4c116$var$_createClass, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("ixgxw", function(module, exports) {
function $d7e823853aab9d1b$var$_assertThisInitialized(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}
module.exports = $d7e823853aab9d1b$var$_assertThisInitialized, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("kWzN6", function(module, exports) {

var $cJ3Dv = parcelRequire("cJ3Dv");
function $f3f4fcca922af59e$var$_get() {
    return module.exports = $f3f4fcca922af59e$var$_get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function(e, t, r) {
        var p = $cJ3Dv(e, t);
        if (p) {
            var n = Object.getOwnPropertyDescriptor(p, t);
            return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value;
        }
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $f3f4fcca922af59e$var$_get.apply(null, arguments);
}
module.exports = $f3f4fcca922af59e$var$_get, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("cJ3Dv", function(module, exports) {

var $71O4d = parcelRequire("71O4d");
function $943c82149b7b399a$var$_superPropBase(t, o) {
    for(; !({}).hasOwnProperty.call(t, o) && null !== (t = $71O4d(t)););
    return t;
}
module.exports = $943c82149b7b399a$var$_superPropBase, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("71O4d", function(module, exports) {
function $51df76a87d92985b$var$_getPrototypeOf(t) {
    return module.exports = $51df76a87d92985b$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $51df76a87d92985b$var$_getPrototypeOf(t);
}
module.exports = $51df76a87d92985b$var$_getPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

});



parcelRegister("bZODV", function(module, exports) {

var $jwV9S = parcelRequire("jwV9S");
function $8bbcacde17a30580$var$_inherits(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && $jwV9S(t, e);
}
module.exports = $8bbcacde17a30580$var$_inherits, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("jwV9S", function(module, exports) {
function $e37d57e7a6406681$var$_setPrototypeOf(t, e) {
    return module.exports = $e37d57e7a6406681$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $e37d57e7a6406681$var$_setPrototypeOf(t, e);
}
module.exports = $e37d57e7a6406681$var$_setPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("h4REW", function(module, exports) {

var $8P8X8 = parcelRequire("8P8X8");
var $c6ec6f0882a00cfa$var$_typeof = $8P8X8.default;

var $ixgxw = parcelRequire("ixgxw");
function $c6ec6f0882a00cfa$var$_possibleConstructorReturn(t, e) {
    if (e && ("object" == $c6ec6f0882a00cfa$var$_typeof(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return $ixgxw(t);
}
module.exports = $c6ec6f0882a00cfa$var$_possibleConstructorReturn, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("96rnt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6a09e9356f83c47d$export$2e2bcd8739ae039; });

var $8P8X8 = parcelRequire("8P8X8");

var $2Su57 = parcelRequire("2Su57");

var $l6xlx = parcelRequire("l6xlx");

var $iriaf = parcelRequire("iriaf");
function $6a09e9356f83c47d$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $6a09e9356f83c47d$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $6a09e9356f83c47d$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($iriaf)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $6a09e9356f83c47d$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $6a09e9356f83c47d$export$ad4be5c2ec28cecf = function isAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $6a09e9356f83c47d$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === "AnalyticsEvent";
};
var $6a09e9356f83c47d$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function AnalyticsEvent(props) {
        var _this = this;
        (0, (/*@__PURE__*/$parcel$interopDefault($2Su57)))(this, AnalyticsEvent);
        (0, (/*@__PURE__*/$parcel$interopDefault($iriaf)))(this, "_isAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($iriaf)))(this, "clone", function() {
            // just a shallow clone, don't change sub refs unless you want to
            // affect the original's too
            var payload = $6a09e9356f83c47d$var$_objectSpread({}, _this.payload);
            return new AnalyticsEvent({
                payload: payload
            });
        });
        this.payload = props.payload;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($l6xlx)))(AnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (typeof updater === "function") this.payload = updater(this.payload);
                if ((0, (/*@__PURE__*/$parcel$interopDefault($8P8X8)))(updater) === "object") this.payload = $6a09e9356f83c47d$var$_objectSpread($6a09e9356f83c47d$var$_objectSpread({}, this.payload), updater);
                return this;
            }
        }
    ]);
    return AnalyticsEvent;
}();

});


parcelRegister("hxm7R", function(module, exports) {

$parcel$export(module.exports, "useAnalyticsContext", function () { return $cc46ae75c4e13695$export$d1f587f82ad51c4; });

var $dAx5m = parcelRequire("dAx5m");

var $h0bf1 = parcelRequire("h0bf1");
var $cc46ae75c4e13695$export$d1f587f82ad51c4 = function useAnalyticsContext() {
    return (0, $dAx5m.useContext)((0, $h0bf1.default));
};

});


parcelRegister("6vpiG", function(module, exports) {

$parcel$export(module.exports, "useTrackedRef", function () { return $4bc9436ec9985c36$export$1d27a74659855e44; });

var $dAx5m = parcelRequire("dAx5m");
var $4bc9436ec9985c36$export$1d27a74659855e44 = function useTrackedRef(value) {
    var ref = (0, $dAx5m.useRef)(value);
    ref.current = value;
    return ref;
};

});


parcelRegister("1BNrX", function(module, exports) {

$parcel$export(module.exports, "dimensionMap", function () { return $12bf9ae4bf94b2e7$export$6ccdbebca2ee545f; });
$parcel$export(module.exports, "positiveSpaceMap", function () { return $12bf9ae4bf94b2e7$export$958d0ae7f2977ae4; });
$parcel$export(module.exports, "allSpaceMap", function () { return $12bf9ae4bf94b2e7$export$632685d741f3dbbf; });
$parcel$export(module.exports, "opacityMap", function () { return $12bf9ae4bf94b2e7$export$daf94a976c798b4f; });
$parcel$export(module.exports, "shadowMap", function () { return $12bf9ae4bf94b2e7$export$7aff6e7ba39bb774; });
$parcel$export(module.exports, "borderColorMap", function () { return $12bf9ae4bf94b2e7$export$1531ad5bb3fbedac; });
$parcel$export(module.exports, "backgroundColorMap", function () { return $12bf9ae4bf94b2e7$export$d1d79bf68ac056bd; });
$parcel$export(module.exports, "textColorMap", function () { return $12bf9ae4bf94b2e7$export$8473307aa00d6ea1; });
$parcel$export(module.exports, "layerMap", function () { return $12bf9ae4bf94b2e7$export$b5f31a7e431d2eab; });
$parcel$export(module.exports, "borderWidthMap", function () { return $12bf9ae4bf94b2e7$export$e1b83c5210c471b8; });
$parcel$export(module.exports, "borderRadiusMap", function () { return $12bf9ae4bf94b2e7$export$3c0a6c3e64bb180d; });
$parcel$export(module.exports, "paddingStylesMap", function () { return $12bf9ae4bf94b2e7$export$e615f061ca585a6c; });
$parcel$export(module.exports, "backgroundColorStylesMap", function () { return $12bf9ae4bf94b2e7$export$e7af83bafe7f9e63; });
$parcel$export(module.exports, "surfaceColorStylesMap", function () { return $12bf9ae4bf94b2e7$export$ff257d957d48c421; });
$parcel$export(module.exports, "isSurfaceColorToken", function () { return $12bf9ae4bf94b2e7$export$5e65a44e5b6ecadb; });

var $iriaf = parcelRequire("iriaf");

var $jVTBW = parcelRequire("jVTBW");

var $aQjOC = parcelRequire("aQjOC");
function $12bf9ae4bf94b2e7$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $12bf9ae4bf94b2e7$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $12bf9ae4bf94b2e7$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($iriaf)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $12bf9ae4bf94b2e7$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $12bf9ae4bf94b2e7$export$6ccdbebca2ee545f = {
    "100%": "100%",
    "size.100": "1rem",
    "size.200": "1.5rem",
    "size.300": "2rem",
    "size.400": "2.5rem",
    "size.500": "3rem",
    "size.600": "6rem",
    "size.1000": "12rem"
};
var $12bf9ae4bf94b2e7$export$958d0ae7f2977ae4 = {
    "space.0": "var(--ds-space-0, 0px)",
    "space.025": "var(--ds-space-025, 2px)",
    "space.050": "var(--ds-space-050, 4px)",
    "space.075": "var(--ds-space-075, 6px)",
    "space.100": "var(--ds-space-100, 8px)",
    "space.150": "var(--ds-space-150, 12px)",
    "space.200": "var(--ds-space-200, 16px)",
    "space.250": "var(--ds-space-250, 20px)",
    "space.300": "var(--ds-space-300, 24px)",
    "space.400": "var(--ds-space-400, 32px)",
    "space.500": "var(--ds-space-500, 40px)",
    "space.600": "var(--ds-space-600, 48px)",
    "space.800": "var(--ds-space-800, 64px)",
    "space.1000": "var(--ds-space-1000, 80px)"
};
var $12bf9ae4bf94b2e7$export$d2dc61f58390201c = {
    "space.negative.025": "var(--ds-space-negative-025, -2px)",
    "space.negative.050": "var(--ds-space-negative-050, -4px)",
    "space.negative.075": "var(--ds-space-negative-075, -6px)",
    "space.negative.100": "var(--ds-space-negative-100, -8px)",
    "space.negative.150": "var(--ds-space-negative-150, -12px)",
    "space.negative.200": "var(--ds-space-negative-200, -16px)",
    "space.negative.250": "var(--ds-space-negative-250, -20px)",
    "space.negative.300": "var(--ds-space-negative-300, -24px)",
    "space.negative.400": "var(--ds-space-negative-400, -32px)"
};
var $12bf9ae4bf94b2e7$export$632685d741f3dbbf = $12bf9ae4bf94b2e7$var$_objectSpread($12bf9ae4bf94b2e7$var$_objectSpread({}, $12bf9ae4bf94b2e7$export$958d0ae7f2977ae4), $12bf9ae4bf94b2e7$export$d2dc61f58390201c);
var $12bf9ae4bf94b2e7$export$2185ce37f9bdd963 = {
    "color.background.neutral.bold": "color.text.inverse",
    "color.background.neutral.bold.hovered": "color.text.inverse",
    "color.background.neutral.bold.pressed": "color.text.inverse",
    "color.background.selected.bold": "color.text.inverse",
    "color.background.selected.bold.hovered": "color.text.inverse",
    "color.background.selected.bold.pressed": "color.text.inverse",
    "color.background.brand.bold": "color.text.inverse",
    "color.background.brand.bold.hovered": "color.text.inverse",
    "color.background.brand.bold.pressed": "color.text.inverse",
    "color.background.brand.boldest": "color.text.inverse",
    "color.background.brand.boldest.hovered": "color.text.inverse",
    "color.background.brand.boldest.pressed": "color.text.inverse",
    "color.background.danger.bold": "color.text.inverse",
    "color.background.danger.bold.hovered": "color.text.inverse",
    "color.background.danger.bold.pressed": "color.text.inverse",
    "color.background.warning.bold": "color.text.warning.inverse",
    "color.background.warning.bold.hovered": "color.text.warning.inverse",
    "color.background.warning.bold.pressed": "color.text.warning.inverse",
    "color.background.success.bold": "color.text.inverse",
    "color.background.success.bold.hovered": "color.text.inverse",
    "color.background.success.bold.pressed": "color.text.inverse",
    "color.background.discovery.bold": "color.text.inverse",
    "color.background.discovery.bold.hovered": "color.text.inverse",
    "color.background.discovery.bold.pressed": "color.text.inverse",
    "color.background.information.bold": "color.text.inverse",
    "color.background.information.bold.hovered": "color.text.inverse",
    "color.background.information.bold.pressed": "color.text.inverse"
};
var $12bf9ae4bf94b2e7$export$daf94a976c798b4f = {
    "opacity.disabled": "var(--ds-opacity-disabled, 0.4)",
    "opacity.loading": "var(--ds-opacity-loading, 0.2)"
};
var $12bf9ae4bf94b2e7$export$7aff6e7ba39bb774 = {
    "elevation.shadow.overflow": "var(--ds-shadow-overflow, 0px 0px 8px #091e423f, 0px 0px 1px #091e424f)",
    "elevation.shadow.overflow.perimeter": "var(--ds-shadow-overflow-perimeter, #091e421f)",
    "elevation.shadow.overflow.spread": "var(--ds-shadow-overflow-spread, #091e4229)",
    "elevation.shadow.overlay": "var(--ds-shadow-overlay, 0px 8px 12px #091e423f, 0px 0px 1px #091e424f)",
    "elevation.shadow.raised": "var(--ds-shadow-raised, 0px 1px 1px #091e423f, 0px 0px 1px #091e4221)"
};
var $12bf9ae4bf94b2e7$export$41a358c9c2356760 = {
    "elevation.surface": "var(--ds-surface, #FFFFFF)",
    "elevation.surface.hovered": "var(--ds-surface-hovered, #FAFBFC)",
    "elevation.surface.pressed": "var(--ds-surface-pressed, #F4F5F7)",
    "elevation.surface.overlay": "var(--ds-surface-overlay, #FFFFFF)",
    "elevation.surface.overlay.hovered": "var(--ds-surface-overlay-hovered, #FAFBFC)",
    "elevation.surface.overlay.pressed": "var(--ds-surface-overlay-pressed, #F4F5F7)",
    "elevation.surface.raised": "var(--ds-surface-raised, #FFFFFF)",
    "elevation.surface.raised.hovered": "var(--ds-surface-raised-hovered, #FAFBFC)",
    "elevation.surface.raised.pressed": "var(--ds-surface-raised-pressed, #F4F5F7)",
    "elevation.surface.sunken": "var(--ds-surface-sunken, #F4F5F7)"
};
var $12bf9ae4bf94b2e7$export$1531ad5bb3fbedac = {
    "color.border": "var(--ds-border, #091e4221)",
    "color.border.accent.lime": "var(--ds-border-accent-lime, #6A9A23)",
    "color.border.accent.red": "var(--ds-border-accent-red, #FF5630)",
    "color.border.accent.orange": "var(--ds-border-accent-orange, #D94008)",
    "color.border.accent.yellow": "var(--ds-border-accent-yellow, #FFAB00)",
    "color.border.accent.green": "var(--ds-border-accent-green, #36B37E)",
    "color.border.accent.teal": "var(--ds-border-accent-teal, #00B8D9)",
    "color.border.accent.blue": "var(--ds-border-accent-blue, #0065FF)",
    "color.border.accent.purple": "var(--ds-border-accent-purple, #6554C0)",
    "color.border.accent.magenta": "var(--ds-border-accent-magenta, #CD519D)",
    "color.border.accent.gray": "var(--ds-border-accent-gray, #5E6C84)",
    "color.border.disabled": "var(--ds-border-disabled, #FAFBFC)",
    "color.border.focused": "var(--ds-border-focused, #2684FF)",
    "color.border.input": "var(--ds-border-input, #FAFBFC)",
    "color.border.inverse": "var(--ds-border-inverse, #FFFFFF)",
    "color.border.selected": "var(--ds-border-selected, #0052CC)",
    "color.border.brand": "var(--ds-border-brand, #0052CC)",
    "color.border.danger": "var(--ds-border-danger, #FF5630)",
    "color.border.warning": "var(--ds-border-warning, #FFC400)",
    "color.border.success": "var(--ds-border-success, #00875A)",
    "color.border.discovery": "var(--ds-border-discovery, #998DD9)",
    "color.border.information": "var(--ds-border-information, #0065FF)",
    "color.border.bold": "var(--ds-border-bold, #344563)"
};
var $12bf9ae4bf94b2e7$export$d1d79bf68ac056bd = {
    "color.background.accent.lime.subtlest": "var(--ds-background-accent-lime-subtlest, #EEFBDA)",
    "color.background.accent.lime.subtlest.hovered": "var(--ds-background-accent-lime-subtlest-hovered, #D3F1A7)",
    "color.background.accent.lime.subtlest.pressed": "var(--ds-background-accent-lime-subtlest-pressed, #B3DF72)",
    "color.background.accent.lime.subtler": "var(--ds-background-accent-lime-subtler, #D3F1A7)",
    "color.background.accent.lime.subtler.hovered": "var(--ds-background-accent-lime-subtler-hovered, #B3DF72)",
    "color.background.accent.lime.subtler.pressed": "var(--ds-background-accent-lime-subtler-pressed, #94C748)",
    "color.background.accent.lime.subtle": "var(--ds-background-accent-lime-subtle, #94C748)",
    "color.background.accent.lime.subtle.hovered": "var(--ds-background-accent-lime-subtle-hovered, #B3DF72)",
    "color.background.accent.lime.subtle.pressed": "var(--ds-background-accent-lime-subtle-pressed, #D3F1A7)",
    "color.background.accent.lime.bolder": "var(--ds-background-accent-lime-bolder, #5B7F24)",
    "color.background.accent.lime.bolder.hovered": "var(--ds-background-accent-lime-bolder-hovered, #37471F)",
    "color.background.accent.lime.bolder.pressed": "var(--ds-background-accent-lime-bolder-pressed, #37471F)",
    "color.background.accent.red.subtlest": "var(--ds-background-accent-red-subtlest, #FF8F73)",
    "color.background.accent.red.subtlest.hovered": "var(--ds-background-accent-red-subtlest-hovered, #FF7452)",
    "color.background.accent.red.subtlest.pressed": "var(--ds-background-accent-red-subtlest-pressed, #FF5630)",
    "color.background.accent.red.subtler": "var(--ds-background-accent-red-subtler, #FF7452)",
    "color.background.accent.red.subtler.hovered": "var(--ds-background-accent-red-subtler-hovered, #FF5630)",
    "color.background.accent.red.subtler.pressed": "var(--ds-background-accent-red-subtler-pressed, #DE350B)",
    "color.background.accent.red.subtle": "var(--ds-background-accent-red-subtle, #DE350B)",
    "color.background.accent.red.subtle.hovered": "var(--ds-background-accent-red-subtle-hovered, #FF5630)",
    "color.background.accent.red.subtle.pressed": "var(--ds-background-accent-red-subtle-pressed, #FF7452)",
    "color.background.accent.red.bolder": "var(--ds-background-accent-red-bolder, #DE350B)",
    "color.background.accent.red.bolder.hovered": "var(--ds-background-accent-red-bolder-hovered, #FF5630)",
    "color.background.accent.red.bolder.pressed": "var(--ds-background-accent-red-bolder-pressed, #FF7452)",
    "color.background.accent.orange.subtlest": "var(--ds-background-accent-orange-subtlest, #F18D13)",
    "color.background.accent.orange.subtlest.hovered": "var(--ds-background-accent-orange-subtlest-hovered, #FEC57B)",
    "color.background.accent.orange.subtlest.pressed": "var(--ds-background-accent-orange-subtlest-pressed, #FFE2BD)",
    "color.background.accent.orange.subtler": "var(--ds-background-accent-orange-subtler, #B65C02)",
    "color.background.accent.orange.subtler.hovered": "var(--ds-background-accent-orange-subtler-hovered, #F18D13)",
    "color.background.accent.orange.subtler.pressed": "var(--ds-background-accent-orange-subtler-pressed, #FEC57B)",
    "color.background.accent.orange.subtle": "var(--ds-background-accent-orange-subtle, #5F3811)",
    "color.background.accent.orange.subtle.hovered": "var(--ds-background-accent-orange-subtle-hovered, #974F0C)",
    "color.background.accent.orange.subtle.pressed": "var(--ds-background-accent-orange-subtle-pressed, #B65C02)",
    "color.background.accent.orange.bolder": "var(--ds-background-accent-orange-bolder, #43290F)",
    "color.background.accent.orange.bolder.hovered": "var(--ds-background-accent-orange-bolder-hovered, #5F3811)",
    "color.background.accent.orange.bolder.pressed": "var(--ds-background-accent-orange-bolder-pressed, #974F0C)",
    "color.background.accent.yellow.subtlest": "var(--ds-background-accent-yellow-subtlest, #FFE380)",
    "color.background.accent.yellow.subtlest.hovered": "var(--ds-background-accent-yellow-subtlest-hovered, #FFC400)",
    "color.background.accent.yellow.subtlest.pressed": "var(--ds-background-accent-yellow-subtlest-pressed, #FFAB00)",
    "color.background.accent.yellow.subtler": "var(--ds-background-accent-yellow-subtler, #FFC400)",
    "color.background.accent.yellow.subtler.hovered": "var(--ds-background-accent-yellow-subtler-hovered, #FFAB00)",
    "color.background.accent.yellow.subtler.pressed": "var(--ds-background-accent-yellow-subtler-pressed, #FF991F)",
    "color.background.accent.yellow.subtle": "var(--ds-background-accent-yellow-subtle, #FF991F)",
    "color.background.accent.yellow.subtle.hovered": "var(--ds-background-accent-yellow-subtle-hovered, #FFAB00)",
    "color.background.accent.yellow.subtle.pressed": "var(--ds-background-accent-yellow-subtle-pressed, #FFC400)",
    "color.background.accent.yellow.bolder": "var(--ds-background-accent-yellow-bolder, #FF991F)",
    "color.background.accent.yellow.bolder.hovered": "var(--ds-background-accent-yellow-bolder-hovered, #FFAB00)",
    "color.background.accent.yellow.bolder.pressed": "var(--ds-background-accent-yellow-bolder-pressed, #FFC400)",
    "color.background.accent.green.subtlest": "var(--ds-background-accent-green-subtlest, #79F2C0)",
    "color.background.accent.green.subtlest.hovered": "var(--ds-background-accent-green-subtlest-hovered, #57D9A3)",
    "color.background.accent.green.subtlest.pressed": "var(--ds-background-accent-green-subtlest-pressed, #36B37E)",
    "color.background.accent.green.subtler": "var(--ds-background-accent-green-subtler, #57D9A3)",
    "color.background.accent.green.subtler.hovered": "var(--ds-background-accent-green-subtler-hovered, #36B37E)",
    "color.background.accent.green.subtler.pressed": "var(--ds-background-accent-green-subtler-pressed, #00875A)",
    "color.background.accent.green.subtle": "var(--ds-background-accent-green-subtle, #00875A)",
    "color.background.accent.green.subtle.hovered": "var(--ds-background-accent-green-subtle-hovered, #36B37E)",
    "color.background.accent.green.subtle.pressed": "var(--ds-background-accent-green-subtle-pressed, #57D9A3)",
    "color.background.accent.green.bolder": "var(--ds-background-accent-green-bolder, #00875A)",
    "color.background.accent.green.bolder.hovered": "var(--ds-background-accent-green-bolder-hovered, #36B37E)",
    "color.background.accent.green.bolder.pressed": "var(--ds-background-accent-green-bolder-pressed, #57D9A3)",
    "color.background.accent.teal.subtlest": "var(--ds-background-accent-teal-subtlest, #79E2F2)",
    "color.background.accent.teal.subtlest.hovered": "var(--ds-background-accent-teal-subtlest-hovered, #00C7E6)",
    "color.background.accent.teal.subtlest.pressed": "var(--ds-background-accent-teal-subtlest-pressed, #00B8D9)",
    "color.background.accent.teal.subtler": "var(--ds-background-accent-teal-subtler, #00C7E6)",
    "color.background.accent.teal.subtler.hovered": "var(--ds-background-accent-teal-subtler-hovered, #00B8D9)",
    "color.background.accent.teal.subtler.pressed": "var(--ds-background-accent-teal-subtler-pressed, #00A3BF)",
    "color.background.accent.teal.subtle": "var(--ds-background-accent-teal-subtle, #00A3BF)",
    "color.background.accent.teal.subtle.hovered": "var(--ds-background-accent-teal-subtle-hovered, #00B8D9)",
    "color.background.accent.teal.subtle.pressed": "var(--ds-background-accent-teal-subtle-pressed, #00C7E6)",
    "color.background.accent.teal.bolder": "var(--ds-background-accent-teal-bolder, #00A3BF)",
    "color.background.accent.teal.bolder.hovered": "var(--ds-background-accent-teal-bolder-hovered, #00B8D9)",
    "color.background.accent.teal.bolder.pressed": "var(--ds-background-accent-teal-bolder-pressed, #00C7E6)",
    "color.background.accent.blue.subtlest": "var(--ds-background-accent-blue-subtlest, #4C9AFF)",
    "color.background.accent.blue.subtlest.hovered": "var(--ds-background-accent-blue-subtlest-hovered, #2684FF)",
    "color.background.accent.blue.subtlest.pressed": "var(--ds-background-accent-blue-subtlest-pressed, #0065FF)",
    "color.background.accent.blue.subtler": "var(--ds-background-accent-blue-subtler, #2684FF)",
    "color.background.accent.blue.subtler.hovered": "var(--ds-background-accent-blue-subtler-hovered, #0065FF)",
    "color.background.accent.blue.subtler.pressed": "var(--ds-background-accent-blue-subtler-pressed, #0052CC)",
    "color.background.accent.blue.subtle": "var(--ds-background-accent-blue-subtle, #0052CC)",
    "color.background.accent.blue.subtle.hovered": "var(--ds-background-accent-blue-subtle-hovered, #0065FF)",
    "color.background.accent.blue.subtle.pressed": "var(--ds-background-accent-blue-subtle-pressed, #2684FF)",
    "color.background.accent.blue.bolder": "var(--ds-background-accent-blue-bolder, #0052CC)",
    "color.background.accent.blue.bolder.hovered": "var(--ds-background-accent-blue-bolder-hovered, #0065FF)",
    "color.background.accent.blue.bolder.pressed": "var(--ds-background-accent-blue-bolder-pressed, #2684FF)",
    "color.background.accent.purple.subtlest": "var(--ds-background-accent-purple-subtlest, #998DD9)",
    "color.background.accent.purple.subtlest.hovered": "var(--ds-background-accent-purple-subtlest-hovered, #8777D9)",
    "color.background.accent.purple.subtlest.pressed": "var(--ds-background-accent-purple-subtlest-pressed, #6554C0)",
    "color.background.accent.purple.subtler": "var(--ds-background-accent-purple-subtler, #8777D9)",
    "color.background.accent.purple.subtler.hovered": "var(--ds-background-accent-purple-subtler-hovered, #6554C0)",
    "color.background.accent.purple.subtler.pressed": "var(--ds-background-accent-purple-subtler-pressed, #5243AA)",
    "color.background.accent.purple.subtle": "var(--ds-background-accent-purple-subtle, #5243AA)",
    "color.background.accent.purple.subtle.hovered": "var(--ds-background-accent-purple-subtle-hovered, #6554C0)",
    "color.background.accent.purple.subtle.pressed": "var(--ds-background-accent-purple-subtle-pressed, #8777D9)",
    "color.background.accent.purple.bolder": "var(--ds-background-accent-purple-bolder, #5243AA)",
    "color.background.accent.purple.bolder.hovered": "var(--ds-background-accent-purple-bolder-hovered, #6554C0)",
    "color.background.accent.purple.bolder.pressed": "var(--ds-background-accent-purple-bolder-pressed, #8777D9)",
    "color.background.accent.magenta.subtlest": "var(--ds-background-accent-magenta-subtlest, #FFECF8)",
    "color.background.accent.magenta.subtlest.hovered": "var(--ds-background-accent-magenta-subtlest-hovered, #FDD0EC)",
    "color.background.accent.magenta.subtlest.pressed": "var(--ds-background-accent-magenta-subtlest-pressed, #F797D2)",
    "color.background.accent.magenta.subtler": "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
    "color.background.accent.magenta.subtler.hovered": "var(--ds-background-accent-magenta-subtler-hovered, #F797D2)",
    "color.background.accent.magenta.subtler.pressed": "var(--ds-background-accent-magenta-subtler-pressed, #E774BB)",
    "color.background.accent.magenta.subtle": "var(--ds-background-accent-magenta-subtle, #E774BB)",
    "color.background.accent.magenta.subtle.hovered": "var(--ds-background-accent-magenta-subtle-hovered, #F797D2)",
    "color.background.accent.magenta.subtle.pressed": "var(--ds-background-accent-magenta-subtle-pressed, #FDD0EC)",
    "color.background.accent.magenta.bolder": "var(--ds-background-accent-magenta-bolder, #AE4787)",
    "color.background.accent.magenta.bolder.hovered": "var(--ds-background-accent-magenta-bolder-hovered, #943D73)",
    "color.background.accent.magenta.bolder.pressed": "var(--ds-background-accent-magenta-bolder-pressed, #50253F)",
    "color.background.accent.gray.subtlest": "var(--ds-background-accent-gray-subtlest, #6B778C)",
    "color.background.accent.gray.subtlest.hovered": "var(--ds-background-accent-gray-subtlest-hovered, #5E6C84)",
    "color.background.accent.gray.subtlest.pressed": "var(--ds-background-accent-gray-subtlest-pressed, #505F79)",
    "color.background.accent.gray.subtler": "var(--ds-background-accent-gray-subtler, #5E6C84)",
    "color.background.accent.gray.subtler.hovered": "var(--ds-background-accent-gray-subtler-hovered, #505F79)",
    "color.background.accent.gray.subtler.pressed": "var(--ds-background-accent-gray-subtler-pressed, #42526E)",
    "color.background.accent.gray.subtle": "var(--ds-background-accent-gray-subtle, #505F79)",
    "color.background.accent.gray.subtle.hovered": "var(--ds-background-accent-gray-subtle-hovered, #5E6C84)",
    "color.background.accent.gray.subtle.pressed": "var(--ds-background-accent-gray-subtle-pressed, #6B778C)",
    "color.background.accent.gray.bolder": "var(--ds-background-accent-gray-bolder, #42526E)",
    "color.background.accent.gray.bolder.hovered": "var(--ds-background-accent-gray-bolder-hovered, #344563)",
    "color.background.accent.gray.bolder.pressed": "var(--ds-background-accent-gray-bolder-pressed, #253858)",
    "color.background.disabled": "var(--ds-background-disabled, #091e4289)",
    "color.background.input": "var(--ds-background-input, #FAFBFC)",
    "color.background.input.hovered": "var(--ds-background-input-hovered, #EBECF0)",
    "color.background.input.pressed": "var(--ds-background-input-pressed, #FFFFFF)",
    "color.background.inverse.subtle": "var(--ds-background-inverse-subtle, #00000029)",
    "color.background.inverse.subtle.hovered": "var(--ds-background-inverse-subtle-hovered, #0000003D)",
    "color.background.inverse.subtle.pressed": "var(--ds-background-inverse-subtle-pressed, #00000052)",
    "color.background.neutral": "var(--ds-background-neutral, #DFE1E6)",
    "color.background.neutral.hovered": "var(--ds-background-neutral-hovered, #091e4214)",
    "color.background.neutral.pressed": "var(--ds-background-neutral-pressed, #B3D4FF)",
    "color.background.neutral.subtle": "var(--ds-background-neutral-subtle, transparent)",
    "color.background.neutral.subtle.hovered": "var(--ds-background-neutral-subtle-hovered, #091e4214)",
    "color.background.neutral.subtle.pressed": "var(--ds-background-neutral-subtle-pressed, #B3D4FF)",
    "color.background.neutral.bold": "var(--ds-background-neutral-bold, #42526E)",
    "color.background.neutral.bold.hovered": "var(--ds-background-neutral-bold-hovered, #505F79)",
    "color.background.neutral.bold.pressed": "var(--ds-background-neutral-bold-pressed, #344563)",
    "color.background.selected": "var(--ds-background-selected, #DEEBFF)",
    "color.background.selected.hovered": "var(--ds-background-selected-hovered, #B3D4FF)",
    "color.background.selected.pressed": "var(--ds-background-selected-pressed, #4C9AFF)",
    "color.background.selected.bold": "var(--ds-background-selected-bold, #0052CC)",
    "color.background.selected.bold.hovered": "var(--ds-background-selected-bold-hovered, #2684FF)",
    "color.background.selected.bold.pressed": "var(--ds-background-selected-bold-pressed, #0052CC)",
    "color.background.brand.subtlest": "var(--ds-background-brand-subtlest, #B3D4FF)",
    "color.background.brand.subtlest.hovered": "var(--ds-background-brand-subtlest-hovered, #DEEBFF)",
    "color.background.brand.subtlest.pressed": "var(--ds-background-brand-subtlest-pressed, #4C9AFF)",
    "color.background.brand.bold": "var(--ds-background-brand-bold, #0052CC)",
    "color.background.brand.bold.hovered": "var(--ds-background-brand-bold-hovered, #0065FF)",
    "color.background.brand.bold.pressed": "var(--ds-background-brand-bold-pressed, #0747A6)",
    "color.background.brand.boldest": "var(--ds-background-brand-boldest, #0747A6)",
    "color.background.brand.boldest.hovered": "var(--ds-background-brand-boldest-hovered, #0052CC)",
    "color.background.brand.boldest.pressed": "var(--ds-background-brand-boldest-pressed, #0747A6)",
    "color.background.danger": "var(--ds-background-danger, #FFEBE6)",
    "color.background.danger.hovered": "var(--ds-background-danger-hovered, #FFBDAD)",
    "color.background.danger.pressed": "var(--ds-background-danger-pressed, #FF8F73)",
    "color.background.danger.bold": "var(--ds-background-danger-bold, #DE350B)",
    "color.background.danger.bold.hovered": "var(--ds-background-danger-bold-hovered, #FF5630)",
    "color.background.danger.bold.pressed": "var(--ds-background-danger-bold-pressed, #BF2600)",
    "color.background.warning": "var(--ds-background-warning, #FFFAE6)",
    "color.background.warning.hovered": "var(--ds-background-warning-hovered, #FFF0B3)",
    "color.background.warning.pressed": "var(--ds-background-warning-pressed, #FFE380)",
    "color.background.warning.bold": "var(--ds-background-warning-bold, #FFAB00)",
    "color.background.warning.bold.hovered": "var(--ds-background-warning-bold-hovered, #FFC400)",
    "color.background.warning.bold.pressed": "var(--ds-background-warning-bold-pressed, #FF991F)",
    "color.background.success": "var(--ds-background-success, #E3FCEF)",
    "color.background.success.hovered": "var(--ds-background-success-hovered, #ABF5D1)",
    "color.background.success.pressed": "var(--ds-background-success-pressed, #79F2C0)",
    "color.background.success.bold": "var(--ds-background-success-bold, #00875A)",
    "color.background.success.bold.hovered": "var(--ds-background-success-bold-hovered, #57D9A3)",
    "color.background.success.bold.pressed": "var(--ds-background-success-bold-pressed, #00875A)",
    "color.background.discovery": "var(--ds-background-discovery, #EAE6FF)",
    "color.background.discovery.hovered": "var(--ds-background-discovery-hovered, #C0B6F2)",
    "color.background.discovery.pressed": "var(--ds-background-discovery-pressed, #998DD9)",
    "color.background.discovery.bold": "var(--ds-background-discovery-bold, #5243AA)",
    "color.background.discovery.bold.hovered": "var(--ds-background-discovery-bold-hovered, #8777D9)",
    "color.background.discovery.bold.pressed": "var(--ds-background-discovery-bold-pressed, #5243AA)",
    "color.background.information": "var(--ds-background-information, #DEEBFF)",
    "color.background.information.hovered": "var(--ds-background-information-hovered, #B3D4FF)",
    "color.background.information.pressed": "var(--ds-background-information-pressed, #4C9AFF)",
    "color.background.information.bold": "var(--ds-background-information-bold, #0052CC)",
    "color.background.information.bold.hovered": "var(--ds-background-information-bold-hovered, #2684FF)",
    "color.background.information.bold.pressed": "var(--ds-background-information-bold-pressed, #0052CC)",
    "color.blanket": "var(--ds-blanket, #091e4289)",
    "color.blanket.selected": "var(--ds-blanket-selected, #388BFF14)",
    "color.blanket.danger": "var(--ds-blanket-danger, #EF5C4814)",
    "color.skeleton": "var(--ds-skeleton, #F4F5F7)",
    "color.skeleton.subtle": "var(--ds-skeleton-subtle, #091e420a)",
    "elevation.surface": "var(--ds-surface, #FFFFFF)",
    "elevation.surface.hovered": "var(--ds-surface-hovered, #FAFBFC)",
    "elevation.surface.pressed": "var(--ds-surface-pressed, #F4F5F7)",
    "elevation.surface.overlay": "var(--ds-surface-overlay, #FFFFFF)",
    "elevation.surface.overlay.hovered": "var(--ds-surface-overlay-hovered, #FAFBFC)",
    "elevation.surface.overlay.pressed": "var(--ds-surface-overlay-pressed, #F4F5F7)",
    "elevation.surface.raised": "var(--ds-surface-raised, #FFFFFF)",
    "elevation.surface.raised.hovered": "var(--ds-surface-raised-hovered, #FAFBFC)",
    "elevation.surface.raised.pressed": "var(--ds-surface-raised-pressed, #F4F5F7)",
    "elevation.surface.sunken": "var(--ds-surface-sunken, #F4F5F7)",
    "utility.elevation.surface.current": "var(--ds-elevation-surface-current, #FFFFFF)"
};
var $12bf9ae4bf94b2e7$export$8473307aa00d6ea1 = {
    "color.text": "var(--ds-text, #172B4D)",
    "color.text.accent.lime": "var(--ds-text-accent-lime, #4C6B1F)",
    "color.text.accent.lime.bolder": "var(--ds-text-accent-lime-bolder, #37471F)",
    "color.text.accent.red": "var(--ds-text-accent-red, #DE350B)",
    "color.text.accent.red.bolder": "var(--ds-text-accent-red-bolder, #BF2600)",
    "color.text.accent.orange": "var(--ds-text-accent-orange, #F18D13)",
    "color.text.accent.orange.bolder": "var(--ds-text-accent-orange-bolder, #B65C02)",
    "color.text.accent.yellow": "var(--ds-text-accent-yellow, #FF991F)",
    "color.text.accent.yellow.bolder": "var(--ds-text-accent-yellow-bolder, #FF8B00)",
    "color.text.accent.green": "var(--ds-text-accent-green, #00875A)",
    "color.text.accent.green.bolder": "var(--ds-text-accent-green-bolder, #006644)",
    "color.text.accent.teal": "var(--ds-text-accent-teal, #00A3BF)",
    "color.text.accent.teal.bolder": "var(--ds-text-accent-teal-bolder, #008DA6)",
    "color.text.accent.blue": "var(--ds-text-accent-blue, #0052CC)",
    "color.text.accent.blue.bolder": "var(--ds-text-accent-blue-bolder, #0747A6)",
    "color.text.accent.purple": "var(--ds-text-accent-purple, #5243AA)",
    "color.text.accent.purple.bolder": "var(--ds-text-accent-purple-bolder, #403294)",
    "color.text.accent.magenta": "var(--ds-text-accent-magenta, #E774BB)",
    "color.text.accent.magenta.bolder": "var(--ds-text-accent-magenta-bolder, #DA62AC)",
    "color.text.accent.gray": "var(--ds-text-accent-gray, #505F79)",
    "color.text.accent.gray.bolder": "var(--ds-text-accent-gray-bolder, #172B4D)",
    "color.text.disabled": "var(--ds-text-disabled, #A5ADBA)",
    "color.text.inverse": "var(--ds-text-inverse, #FFFFFF)",
    "color.text.selected": "var(--ds-text-selected, #0052CC)",
    "color.text.brand": "var(--ds-text-brand, #0065FF)",
    "color.text.danger": "var(--ds-text-danger, #DE350B)",
    "color.text.warning": "var(--ds-text-warning, #974F0C)",
    "color.text.warning.inverse": "var(--ds-text-warning-inverse, #172B4D)",
    "color.text.success": "var(--ds-text-success, #006644)",
    "color.text.discovery": "var(--ds-text-discovery, #403294)",
    "color.text.information": "var(--ds-text-information, #0052CC)",
    "color.text.subtlest": "var(--ds-text-subtlest, #7A869A)",
    "color.text.subtle": "var(--ds-text-subtle, #42526E)",
    "color.link": "var(--ds-link, #0052CC)",
    "color.link.pressed": "var(--ds-link-pressed, #0747A6)",
    "color.link.visited": "var(--ds-link-visited, #403294)",
    "color.link.visited.pressed": "var(--ds-link-visited-pressed, #403294)"
};
var $12bf9ae4bf94b2e7$export$498780f74be9af68 = {
    "color.icon": "var(--ds-icon, #505F79)",
    "color.icon.accent.lime": "var(--ds-icon-accent-lime, #6A9A23)",
    "color.icon.accent.red": "var(--ds-icon-accent-red, #FF5630)",
    "color.icon.accent.orange": "var(--ds-icon-accent-orange, #D94008)",
    "color.icon.accent.yellow": "var(--ds-icon-accent-yellow, #FFAB00)",
    "color.icon.accent.green": "var(--ds-icon-accent-green, #36B37E)",
    "color.icon.accent.teal": "var(--ds-icon-accent-teal, #00B8D9)",
    "color.icon.accent.blue": "var(--ds-icon-accent-blue, #0065FF)",
    "color.icon.accent.purple": "var(--ds-icon-accent-purple, #6554C0)",
    "color.icon.accent.magenta": "var(--ds-icon-accent-magenta, #CD519D)",
    "color.icon.accent.gray": "var(--ds-icon-accent-gray, #5E6C84)",
    "color.icon.disabled": "var(--ds-icon-disabled, #8993A4)",
    "color.icon.inverse": "var(--ds-icon-inverse, #FFFFFF)",
    "color.icon.selected": "var(--ds-icon-selected, #0052CC)",
    "color.icon.brand": "var(--ds-icon-brand, #0065FF)",
    "color.icon.danger": "var(--ds-icon-danger, #DE350B)",
    "color.icon.warning": "var(--ds-icon-warning, #FFC400)",
    "color.icon.warning.inverse": "var(--ds-icon-warning-inverse, #253858)",
    "color.icon.success": "var(--ds-icon-success, #00875A)",
    "color.icon.discovery": "var(--ds-icon-discovery, #8777D9)",
    "color.icon.information": "var(--ds-icon-information, #0747A6)",
    "color.icon.subtle": "var(--ds-icon-subtle, #6B778C)"
};
var $12bf9ae4bf94b2e7$export$b5f31a7e431d2eab = {
    card: 100,
    navigation: 200,
    dialog: 300,
    layer: 400,
    blanket: 500,
    modal: 510,
    flag: 600,
    spotlight: 700,
    tooltip: 800
};
var $12bf9ae4bf94b2e7$export$e1b83c5210c471b8 = {
    "border.width": "var(--ds-border-width, 1px)",
    "border.width.0": "var(--ds-border-width-0, 0px)",
    "border.width.indicator": "var(--ds-border-width-indicator, 3px)",
    "border.width.outline": "var(--ds-border-width-outline, 2px)"
};
var $12bf9ae4bf94b2e7$export$3c0a6c3e64bb180d = {
    "border.radius.050": "var(--ds-border-radius-050, 2px)",
    "border.radius": "var(--ds-border-radius, 3px)",
    "border.radius.100": "var(--ds-border-radius-100, 3px)",
    "border.radius.200": "var(--ds-border-radius-200, 8px)",
    "border.radius.300": "var(--ds-border-radius-300, 12px)",
    "border.radius.400": "var(--ds-border-radius-400, 16px)",
    "border.radius.circle": "var(--ds-border-radius-circle, 32032px)"
};
var $12bf9ae4bf94b2e7$export$6cc560b4dedf3816 = {
    medium: 'var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    UNSAFE_small: 'var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    large: 'var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    small: 'var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)'
};
var $12bf9ae4bf94b2e7$export$303e322c6b1ed114 = {
    bold: "var(--ds-font-weight-bold, 700)",
    medium: "var(--ds-font-weight-medium, 500)",
    regular: "var(--ds-font-weight-regular, 400)",
    semibold: "var(--ds-font-weight-semibold, 600)"
};
var $12bf9ae4bf94b2e7$export$3c7e9587132614b4 = {
    "font.family.body": 'var(--ds-font-family-body, ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.family.brand.body": 'var(--ds-font-family-brand-body, "Charlie Text", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.family.brand.heading": 'var(--ds-font-family-brand-heading, "Charlie Display", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.family.code": 'var(--ds-font-family-code, ui-monospace, Menlo, "Segoe UI Mono", "Ubuntu Mono", monospace)',
    "font.family.heading": 'var(--ds-font-family-heading, ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)'
};
/**
 * @codegenEnd
 */ // Generate maps for Box props. backgroundColor, padding, etc
var $12bf9ae4bf94b2e7$var$spacingProperties = [
    // Used by Box
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    // Used by Inline and Stack
    "gap",
    "rowGap",
    "columnGap"
];
var $12bf9ae4bf94b2e7$var$getSerializedStylesMap = function getSerializedStylesMap(cssProperty, tokenMap) {
    return Object.keys(tokenMap).reduce(function(emotionSpacingMap, token) {
        emotionSpacingMap[token] = (0, $jVTBW.css)((0, (/*@__PURE__*/$parcel$interopDefault($iriaf)))({}, cssProperty, tokenMap[token]));
        return emotionSpacingMap;
    }, {});
};
var $12bf9ae4bf94b2e7$export$e615f061ca585a6c = $12bf9ae4bf94b2e7$var$spacingProperties.reduce(function(styleMap, spacingProperty) {
    styleMap[spacingProperty] = $12bf9ae4bf94b2e7$var$getSerializedStylesMap(spacingProperty, $12bf9ae4bf94b2e7$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
var $12bf9ae4bf94b2e7$export$bf46c3f9eeafc71f = $12bf9ae4bf94b2e7$var$spacingProperties.reduce(function(styleMap, spacingProperty) {
    styleMap[spacingProperty] = $12bf9ae4bf94b2e7$var$getSerializedStylesMap(spacingProperty, $12bf9ae4bf94b2e7$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
var $12bf9ae4bf94b2e7$export$e7af83bafe7f9e63 = $12bf9ae4bf94b2e7$var$getSerializedStylesMap("backgroundColor", $12bf9ae4bf94b2e7$export$d1d79bf68ac056bd);
var $12bf9ae4bf94b2e7$export$3a1bcba60b23d7f0 = $12bf9ae4bf94b2e7$var$getSerializedStylesMap("color", $12bf9ae4bf94b2e7$export$8473307aa00d6ea1);
var $12bf9ae4bf94b2e7$export$45f3f4fe16f9f7d5 = $12bf9ae4bf94b2e7$var$getSerializedStylesMap("fontWeight", $12bf9ae4bf94b2e7$export$303e322c6b1ed114);
var $12bf9ae4bf94b2e7$export$68cc305da27dbaa4 = $12bf9ae4bf94b2e7$var$getSerializedStylesMap("fontFamily", $12bf9ae4bf94b2e7$export$3c7e9587132614b4);
var $12bf9ae4bf94b2e7$export$128f10c238242f83 = $12bf9ae4bf94b2e7$var$getSerializedStylesMap("font", $12bf9ae4bf94b2e7$export$6cc560b4dedf3816);
var $12bf9ae4bf94b2e7$export$ff257d957d48c421 = $12bf9ae4bf94b2e7$var$getSerializedStylesMap((0, $aQjOC.CURRENT_SURFACE_CSS_VAR), $12bf9ae4bf94b2e7$export$41a358c9c2356760);
var $12bf9ae4bf94b2e7$export$5e65a44e5b6ecadb = function isSurfaceColorToken(color) {
    return $12bf9ae4bf94b2e7$export$41a358c9c2356760[color] !== undefined;
};

});
parcelRegister("aQjOC", function(module, exports) {

$parcel$export(module.exports, "CURRENT_SURFACE_CSS_VAR", function () { return $7e4e219f37cbad6b$export$9d7b58831ae93caa; });
var $7e4e219f37cbad6b$export$4ef52930e33717cd = "data-theme";
var $7e4e219f37cbad6b$export$a00eac3f8684bcd0 = "data-color-mode";
var $7e4e219f37cbad6b$export$2112803007239c61 = "data-contrast-mode";
var $7e4e219f37cbad6b$export$352e418ed5b6193a = "data-custom-theme";
var $7e4e219f37cbad6b$export$2faeed762aac6741 = "light";
var $7e4e219f37cbad6b$export$6f0c6fb8c80fcc92 = "ds";
var $7e4e219f37cbad6b$export$4d0c7bbf80185957 = [
    "opacity",
    "font",
    "space",
    "border"
];
var $7e4e219f37cbad6b$export$dddac1532e822863 = "--".concat($7e4e219f37cbad6b$export$6f0c6fb8c80fcc92, "-token-not-found");
var $7e4e219f37cbad6b$export$9d7b58831ae93caa = "--".concat($7e4e219f37cbad6b$export$6f0c6fb8c80fcc92, "-elevation-surface-current");

});


parcelRegister("aSd6p", function(module, exports) {

$parcel$export(module.exports, "parseXcss", function () { return $7ea91c64c45ced77$export$a9c84988c8f81f2d; });
$parcel$export(module.exports, "xcss", function () { return $7ea91c64c45ced77$export$f6c783d06584602c; });

var $hwFBe = parcelRequire("hwFBe");

var $iriaf = parcelRequire("iriaf");

var $3hVkQ = parcelRequire("3hVkQ");

var $8P8X8 = parcelRequire("8P8X8");

var $jVTBW = parcelRequire("jVTBW");

var $1BNrX = parcelRequire("1BNrX");

var $ahJoN = parcelRequire("ahJoN");
function $7ea91c64c45ced77$var$_createForOfIteratorHelper(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (!it) {
        if (Array.isArray(o) || (it = $7ea91c64c45ced77$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
            if (it) o = it;
            var i = 0;
            var F = function F() {};
            return {
                s: F,
                n: function n() {
                    if (i >= o.length) return {
                        done: true
                    };
                    return {
                        done: false,
                        value: o[i++]
                    };
                },
                e: function e(_e) {
                    throw _e;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var normalCompletion = true, didErr = false, err;
    return {
        s: function s() {
            it = it.call(o);
        },
        n: function n() {
            var step = it.next();
            normalCompletion = step.done;
            return step;
        },
        e: function e(_e2) {
            didErr = true;
            err = _e2;
        },
        f: function f() {
            try {
                if (!normalCompletion && it.return != null) it.return();
            } finally{
                if (didErr) throw err;
            }
        }
    };
}
function $7ea91c64c45ced77$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $7ea91c64c45ced77$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $7ea91c64c45ced77$var$_arrayLikeToArray(o, minLen);
}
function $7ea91c64c45ced77$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $7ea91c64c45ced77$export$9a199fbafee0014e = {
    backgroundColor: (0, $1BNrX.backgroundColorMap),
    blockSize: (0, $1BNrX.dimensionMap),
    borderBlockColor: (0, $1BNrX.borderColorMap),
    borderBlockEndColor: (0, $1BNrX.borderColorMap),
    borderBlockEndWidth: (0, $1BNrX.borderWidthMap),
    borderBlockStartColor: (0, $1BNrX.borderColorMap),
    borderBlockStartWidth: (0, $1BNrX.borderWidthMap),
    borderBlockWidth: (0, $1BNrX.borderWidthMap),
    borderBottomColor: (0, $1BNrX.borderColorMap),
    borderBottomLeftRadius: (0, $1BNrX.borderRadiusMap),
    borderBottomRightRadius: (0, $1BNrX.borderRadiusMap),
    borderBottomWidth: (0, $1BNrX.borderWidthMap),
    borderColor: (0, $1BNrX.borderColorMap),
    borderEndEndRadius: (0, $1BNrX.borderRadiusMap),
    borderEndStartRadius: (0, $1BNrX.borderRadiusMap),
    borderInlineColor: (0, $1BNrX.borderColorMap),
    borderInlineEndColor: (0, $1BNrX.borderColorMap),
    borderInlineEndWidth: (0, $1BNrX.borderWidthMap),
    borderInlineStartColor: (0, $1BNrX.borderColorMap),
    borderInlineStartWidth: (0, $1BNrX.borderWidthMap),
    borderInlineWidth: (0, $1BNrX.borderWidthMap),
    borderLeftColor: (0, $1BNrX.borderColorMap),
    borderLeftWidth: (0, $1BNrX.borderWidthMap),
    borderRadius: (0, $1BNrX.borderRadiusMap),
    borderRightColor: (0, $1BNrX.borderColorMap),
    borderRightWidth: (0, $1BNrX.borderWidthMap),
    borderStartEndRadius: (0, $1BNrX.borderRadiusMap),
    borderStartStartRadius: (0, $1BNrX.borderRadiusMap),
    borderTopColor: (0, $1BNrX.borderColorMap),
    borderTopLeftRadius: (0, $1BNrX.borderRadiusMap),
    borderTopRightRadius: (0, $1BNrX.borderRadiusMap),
    borderTopWidth: (0, $1BNrX.borderWidthMap),
    borderWidth: (0, $1BNrX.borderWidthMap),
    bottom: (0, $1BNrX.allSpaceMap),
    boxShadow: (0, $1BNrX.shadowMap),
    color: (0, $1BNrX.textColorMap),
    columnGap: (0, $1BNrX.positiveSpaceMap),
    gap: (0, $1BNrX.positiveSpaceMap),
    height: (0, $1BNrX.dimensionMap),
    inlineSize: (0, $1BNrX.dimensionMap),
    inset: (0, $1BNrX.allSpaceMap),
    insetBlock: (0, $1BNrX.allSpaceMap),
    insetBlockEnd: (0, $1BNrX.allSpaceMap),
    insetBlockStart: (0, $1BNrX.allSpaceMap),
    insetInline: (0, $1BNrX.allSpaceMap),
    insetInlineEnd: (0, $1BNrX.allSpaceMap),
    insetInlineStart: (0, $1BNrX.allSpaceMap),
    left: (0, $1BNrX.allSpaceMap),
    margin: (0, $1BNrX.allSpaceMap),
    marginBlock: (0, $1BNrX.allSpaceMap),
    marginBlockEnd: (0, $1BNrX.allSpaceMap),
    marginBlockStart: (0, $1BNrX.allSpaceMap),
    marginBottom: (0, $1BNrX.allSpaceMap),
    marginInline: (0, $1BNrX.allSpaceMap),
    marginInlineEnd: (0, $1BNrX.allSpaceMap),
    marginInlineStart: (0, $1BNrX.allSpaceMap),
    marginLeft: (0, $1BNrX.allSpaceMap),
    marginRight: (0, $1BNrX.allSpaceMap),
    marginTop: (0, $1BNrX.allSpaceMap),
    maxBlockSize: (0, $1BNrX.dimensionMap),
    maxHeight: (0, $1BNrX.dimensionMap),
    maxInlineSize: (0, $1BNrX.dimensionMap),
    maxWidth: (0, $1BNrX.dimensionMap),
    minBlockSize: (0, $1BNrX.dimensionMap),
    minHeight: (0, $1BNrX.dimensionMap),
    minInlineSize: (0, $1BNrX.dimensionMap),
    minWidth: (0, $1BNrX.dimensionMap),
    opacity: (0, $1BNrX.opacityMap),
    outlineColor: (0, $1BNrX.borderColorMap),
    outlineOffset: (0, $1BNrX.positiveSpaceMap),
    outlineWidth: (0, $1BNrX.borderWidthMap),
    padding: (0, $1BNrX.positiveSpaceMap),
    paddingBlock: (0, $1BNrX.positiveSpaceMap),
    paddingBlockEnd: (0, $1BNrX.positiveSpaceMap),
    paddingBlockStart: (0, $1BNrX.positiveSpaceMap),
    paddingBottom: (0, $1BNrX.positiveSpaceMap),
    paddingInline: (0, $1BNrX.positiveSpaceMap),
    paddingInlineEnd: (0, $1BNrX.positiveSpaceMap),
    paddingInlineStart: (0, $1BNrX.positiveSpaceMap),
    paddingLeft: (0, $1BNrX.positiveSpaceMap),
    paddingRight: (0, $1BNrX.positiveSpaceMap),
    paddingTop: (0, $1BNrX.positiveSpaceMap),
    right: (0, $1BNrX.allSpaceMap),
    rowGap: (0, $1BNrX.positiveSpaceMap),
    top: (0, $1BNrX.allSpaceMap),
    width: (0, $1BNrX.dimensionMap),
    zIndex: (0, $1BNrX.layerMap)
};
var $7ea91c64c45ced77$var$uniqueSymbol = Symbol("UNSAFE_INTERNAL_styles");
var $7ea91c64c45ced77$var$isSafeEnvToThrow = function isSafeEnvToThrow() {
    return (typeof $ahJoN === "undefined" ? "undefined" : (0, (/*@__PURE__*/$parcel$interopDefault($8P8X8)))($ahJoN)) === "object" && (0, (/*@__PURE__*/$parcel$interopDefault($8P8X8)))($ahJoN.env) === "object" && false;
};
var $7ea91c64c45ced77$var$reNestedSelectors = /(\.|\s|&+|\*\>|#|\[.*\])/;
var $7ea91c64c45ced77$var$safeSelectors = /^@media .*$|^::?.*$|^@supports .*$/;
var $7ea91c64c45ced77$var$transformStyles = function transformStyles(styleObj) {
    if (!styleObj || (0, (/*@__PURE__*/$parcel$interopDefault($8P8X8)))(styleObj) !== "object") return styleObj;
    // If styles are defined as a CSSObject[], recursively call on each element until we reach CSSObject
    if (Array.isArray(styleObj)) return styleObj.map(transformStyles);
    // Modifies styleObj in place. Be careful.
    Object.entries(styleObj).forEach(function(_ref) {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($3hVkQ)))(_ref, 2), key = _ref2[0], value = _ref2[1];
        // If key is a pseudo class or a pseudo element, then value should be an object.
        // So, call transformStyles on the value
        if ((0, (/*@__PURE__*/$parcel$interopDefault($8P8X8)))(value) === "object" && $7ea91c64c45ced77$var$safeSelectors.test(key)) {
            styleObj[key] = transformStyles(value);
            return;
        }
        if ($7ea91c64c45ced77$var$isSafeEnvToThrow()) {
            // We don't support `.class`, `[data-testid]`, `> *`, `#some-id`
            if ($7ea91c64c45ced77$var$reNestedSelectors.test(key)) throw new Error("Styles not supported for key '".concat(key, "'."));
        }
        // We have now dealt with all the special cases, so,
        // check whether what remains is a style property
        // that can be transformed.
        if (!(key in $7ea91c64c45ced77$export$9a199fbafee0014e)) return;
        var tokenValue = $7ea91c64c45ced77$export$9a199fbafee0014e[key][value];
        styleObj[key] = tokenValue !== null && tokenValue !== void 0 ? tokenValue : value;
    });
    return styleObj;
};
var $7ea91c64c45ced77$var$baseXcss = function baseXcss(style) {
    var transformedStyles = $7ea91c64c45ced77$var$transformStyles(style);
    return (0, (/*@__PURE__*/$parcel$interopDefault($iriaf)))({}, $7ea91c64c45ced77$var$uniqueSymbol, (0, $jVTBW.css)(transformedStyles));
};
var $7ea91c64c45ced77$export$a9c84988c8f81f2d = function parseXcss(args) {
    if (Array.isArray(args)) {
        var emotion = [];
        var staticArr = [];
        var _iterator = $7ea91c64c45ced77$var$_createForOfIteratorHelper(args), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var arg = _step.value;
                var result = parseXcss(arg);
                if (result.emotion) emotion.push.apply(emotion, (0, (/*@__PURE__*/$parcel$interopDefault($hwFBe)))(result.emotion));
                if (result.static) staticArr.push(result.static);
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        return {
            emotion: emotion,
            static: staticArr.join(" ")
        };
    }
    var objArgs = args;
    var _ref4 = objArgs || {}, styles = _ref4[$7ea91c64c45ced77$var$uniqueSymbol];
    if (styles) return {
        emotion: [
            styles
        ]
    };
    if (args) {
        // We use string interpolation here instead of .toString() just
        // in case the resulting object doesn't have the method available.
        var stringifiedArgs = "".concat(args);
        if (stringifiedArgs) return {
            static: stringifiedArgs
        };
    }
    return {};
};
function $7ea91c64c45ced77$export$f6c783d06584602c(style) {
    return $7ea91c64c45ced77$var$baseXcss(style);
}

});

parcelRegister("bPrsJ", function(module, exports) {

$parcel$export(module.exports, "SurfaceContext", function () { return $89c9c296c0e5a3fa$export$1ca2a26fecb070ae; });

var $dAx5m = parcelRequire("dAx5m");
var $89c9c296c0e5a3fa$export$1ca2a26fecb070ae = /*#__PURE__*/ (0, $dAx5m.createContext)("elevation.surface");
var $89c9c296c0e5a3fa$export$1aeb4f6b93c4540d = function useSurface() {
    return (0, $dAx5m.useContext)($89c9c296c0e5a3fa$export$1ca2a26fecb070ae);
};
$89c9c296c0e5a3fa$export$1ca2a26fecb070ae.displayName = "SurfaceProvider";

});


parcelRegister("lQQIZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fe875a50db48cf7a$export$2e2bcd8739ae039; });

var $dAx5m = parcelRequire("dAx5m");

var $1SMy6 = parcelRequire("1SMy6");

var $amSyR = parcelRequire("amSyR");

var $dxA7k = parcelRequire("dxA7k");

var $gTEio = parcelRequire("gTEio");
/**
 * __Use default button base__
 *
 * A React hook that accepts a set of default Button props,
 * and processes them to return consistent base props for usage
 * across Button and LinkButton variants.
 *
 * @private
 */ var $fe875a50db48cf7a$var$useDefaultButton = function useDefaultButton(_ref) {
    var analyticsContext = _ref.analyticsContext, appearance = _ref.appearance, ariaLabel = _ref.ariaLabel, ariaLabelledBy = _ref.ariaLabelledBy, autoFocus = _ref.autoFocus, buttonType = _ref.buttonType, children = _ref.children, iconAfter = _ref.iconAfter, iconBefore = _ref.iconBefore, interactionName = _ref.interactionName, isDisabled = _ref.isDisabled, _ref$isLoading = _ref.isLoading, isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading, isSelected = _ref.isSelected, onClick = _ref.onClick, onClickCapture = _ref.onClickCapture, onKeyDownCapture = _ref.onKeyDownCapture, onKeyUpCapture = _ref.onKeyUpCapture, onMouseDownCapture = _ref.onMouseDownCapture, onMouseUpCapture = _ref.onMouseUpCapture, onPointerDownCapture = _ref.onPointerDownCapture, onPointerUpCapture = _ref.onPointerUpCapture, onTouchEndCapture = _ref.onTouchEndCapture, onTouchStartCapture = _ref.onTouchStartCapture, overlay = _ref.overlay, ref = _ref.ref, shouldFitContainer = _ref.shouldFitContainer, spacing = _ref.spacing, testId = _ref.testId, UNSAFE_iconAfter_size = _ref.UNSAFE_iconAfter_size, UNSAFE_iconBefore_size = _ref.UNSAFE_iconBefore_size;
    var hasOverlay = Boolean(overlay || isLoading);
    var baseProps = (0, $gTEio.default)({
        analyticsContext: analyticsContext,
        appearance: appearance,
        autoFocus: autoFocus,
        ariaLabel: ariaLabel,
        ariaLabelledBy: ariaLabelledBy,
        buttonType: buttonType,
        children: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $dAx5m.Fragment), null, iconBefore && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $1SMy6.default), {
            type: "icon",
            position: "before",
            hasOverlay: hasOverlay
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $amSyR.default), {
            icon: iconBefore,
            size: UNSAFE_iconBefore_size
        })), children && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $1SMy6.default), {
            hasOverlay: hasOverlay
        }, children), iconAfter && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $1SMy6.default), {
            type: "icon",
            position: "after",
            hasOverlay: hasOverlay
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $amSyR.default), {
            icon: iconAfter,
            size: UNSAFE_iconAfter_size
        }))),
        interactionName: interactionName,
        isDisabled: isDisabled,
        isLoading: isLoading,
        isSelected: isSelected,
        onClick: onClick,
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onTouchStartCapture: onTouchStartCapture,
        onTouchEndCapture: onTouchEndCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onClickCapture: onClickCapture,
        overlay: isLoading ? (0, $dxA7k.default)({
            spacing: spacing,
            appearance: appearance,
            isDisabled: isDisabled,
            isSelected: isSelected,
            testId: testId
        }) : overlay,
        ref: ref,
        shouldFitContainer: shouldFitContainer,
        spacing: spacing,
        hasIconBefore: Boolean(iconBefore),
        hasIconAfter: Boolean(iconAfter)
    });
    return baseProps;
};
var $fe875a50db48cf7a$export$2e2bcd8739ae039 = $fe875a50db48cf7a$var$useDefaultButton;

});
parcelRegister("1SMy6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $15f07e6a640898ef$export$2e2bcd8739ae039; });

var $hwFBe = parcelRequire("hwFBe");

var $dAx5m = parcelRequire("dAx5m");

var $cihAo = parcelRequire("cihAo");
var $aSd6p = parcelRequire("aSd6p");
var $15f07e6a640898ef$var$textStyles = (0, $aSd6p.xcss)({
    // content can grow and shrink
    flexGrow: 1,
    flexShrink: 1,
    // ellipsis for overflow text
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap"
});
var $15f07e6a640898ef$var$iconStyles = (0, $aSd6p.xcss)({
    display: "flex",
    // icon size cannot grow and shrink
    flexGrow: 0,
    flexShrink: 0,
    alignSelf: "center",
    fontSize: 0,
    lineHeight: 0,
    userSelect: "none"
});
var $15f07e6a640898ef$var$commonStyles = (0, $aSd6p.xcss)({
    transition: "opacity 0.3s"
});
var $15f07e6a640898ef$var$fadeStyles = (0, $aSd6p.xcss)({
    opacity: 0
});
/**
 * These CSS variables consumed by the new icons, to allow them to have appropriate
 * padding inside Button while also maintaining spacing for the existing icons.
 *
 * These styles can be removed once the new icons are fully rolled out, feature flag
 * platform.design-system-team.enable-new-icons is cleaned up,
 * and we bump Button to set padding based on the new icons.
 */ var $15f07e6a640898ef$var$beforeIconStyles = (0, $aSd6p.xcss)({
    // @ts-ignore
    "--ds--button--new-icon-padding-start": "var(--ds-space-050, 4px)",
    // @ts-ignore
    "--ds--button--new-icon-padding-end": "var(--ds-space-025, 2px)"
});
var $15f07e6a640898ef$var$afterIconStyles = (0, $aSd6p.xcss)({
    // @ts-ignore
    "--ds--button--new-icon-padding-start": "var(--ds-space-025, 2px)",
    // @ts-ignore
    "--ds--button--new-icon-padding-end": "var(--ds-space-050, 4px)"
});
/**
 * __Content__
 *
 * Used for slots within a Button, including icons and text content.
 */ var $15f07e6a640898ef$var$Content = function Content(_ref) {
    var children = _ref.children, _ref$type = _ref.type, type = _ref$type === void 0 ? "text" : _ref$type, hasOverlay = _ref.hasOverlay, position = _ref.position;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $cihAo.default), {
        as: "span",
        xcss: [
            $15f07e6a640898ef$var$commonStyles
        ].concat((0, (/*@__PURE__*/$parcel$interopDefault($hwFBe)))(type === "text" ? [
            $15f07e6a640898ef$var$textStyles
        ] : [
            $15f07e6a640898ef$var$iconStyles
        ]), (0, (/*@__PURE__*/$parcel$interopDefault($hwFBe)))(hasOverlay ? [
            $15f07e6a640898ef$var$fadeStyles
        ] : []), (0, (/*@__PURE__*/$parcel$interopDefault($hwFBe)))(position === "before" ? [
            $15f07e6a640898ef$var$beforeIconStyles
        ] : []), (0, (/*@__PURE__*/$parcel$interopDefault($hwFBe)))(position === "after" ? [
            $15f07e6a640898ef$var$afterIconStyles
        ] : []))
    }, children);
};
var $15f07e6a640898ef$export$2e2bcd8739ae039 = $15f07e6a640898ef$var$Content;

});
parcelRegister("cihAo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8f34ceb2fbcd1189$export$2e2bcd8739ae039; });

var $ikNYA = parcelRequire("ikNYA");

var $gd5aU = parcelRequire("gd5aU");

var $dAx5m = parcelRequire("dAx5m");

var $jVTBW = parcelRequire("jVTBW");

var $1BNrX = parcelRequire("1BNrX");

var $aSd6p = parcelRequire("aSd6p");

var $bPrsJ = parcelRequire("bPrsJ");
var $8f34ceb2fbcd1189$var$_excluded = [
    "as",
    "children",
    "backgroundColor",
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    "style",
    "testId",
    "xcss"
], $8f34ceb2fbcd1189$var$_excluded2 = [
    "className"
];
var $8f34ceb2fbcd1189$export$e71c4d32a2263218 = /*#__PURE__*/ (0, $dAx5m.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? "div" : _ref$as, children = _ref.children, backgroundColor = _ref.backgroundColor, padding = _ref.padding, paddingBlock = _ref.paddingBlock, paddingBlockStart = _ref.paddingBlockStart, paddingBlockEnd = _ref.paddingBlockEnd, paddingInline = _ref.paddingInline, paddingInlineStart = _ref.paddingInlineStart, paddingInlineEnd = _ref.paddingInlineEnd, style = _ref.style, testId = _ref.testId, xcss = _ref.xcss, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($gd5aU)))(_ref, $8f34ceb2fbcd1189$var$_excluded);
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($gd5aU)))(htmlAttributes, $8f34ceb2fbcd1189$var$_excluded2);
    var resolvedStyles = (0, $aSd6p.parseXcss)(xcss);
    var node = // @ts-expect-error Expression produces a union type that is too complex to represent. I think this is unavoidable
    (0, $jVTBW.jsx)(Component, (0, (/*@__PURE__*/$parcel$interopDefault($ikNYA)))({
        style: style,
        ref: ref,
        className: resolvedStyles.static
    }, safeHtmlAttributes, {
        css: [
            $8f34ceb2fbcd1189$var$baseStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            backgroundColor && (0, $1BNrX.backgroundColorStylesMap)[backgroundColor],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $1BNrX.isSurfaceColorToken)(backgroundColor) && (0, $1BNrX.surfaceColorStylesMap)[backgroundColor],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            padding && (0, $1BNrX.paddingStylesMap).padding[padding],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlock && (0, $1BNrX.paddingStylesMap).paddingBlock[paddingBlock],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockStart && (0, $1BNrX.paddingStylesMap).paddingBlockStart[paddingBlockStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockEnd && (0, $1BNrX.paddingStylesMap).paddingBlockEnd[paddingBlockEnd],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInline && (0, $1BNrX.paddingStylesMap).paddingInline[paddingInline],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineStart && (0, $1BNrX.paddingStylesMap).paddingInlineStart[paddingInlineStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineEnd && (0, $1BNrX.paddingStylesMap).paddingInlineEnd[paddingInlineEnd],
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            resolvedStyles.emotion
        ],
        "data-testid": testId
    }), children);
    return backgroundColor ? (0, $jVTBW.jsx)((0, $bPrsJ.SurfaceContext).Provider, {
        value: backgroundColor
    }, node) : node;
});
var $8f34ceb2fbcd1189$export$2e2bcd8739ae039 = $8f34ceb2fbcd1189$export$e71c4d32a2263218;
var $8f34ceb2fbcd1189$var$baseStyles = (0, $jVTBW.css)({
    boxSizing: "border-box",
    appearance: "none",
    border: "none"
});

});


parcelRegister("amSyR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $78c64833a8dd4e57$export$2e2bcd8739ae039; });

var $dAx5m = parcelRequire("dAx5m");

var $29ou0 = parcelRequire("29ou0");
function $78c64833a8dd4e57$var$isIconRenderProp(func) {
    return !func.displayName && // most function components and class components have a displayName, negate them
    !func.render && // forwardRef doesn't require a display name, however it does include a render function, negate them
    typeof func === "function" // at the very least we need to be a function
    ;
}
/**
 * __Icon renderer__
 *
 * Used to support render props with icons.
 *
 */ var $78c64833a8dd4e57$var$IconRenderer = function IconRenderer(_ref) {
    var Icon = _ref.icon, size = _ref.size;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).Fragment, null, (0, $29ou0.getBooleanFF)("platform.design-system-team.button-render-prop-fix_lyo55") && $78c64833a8dd4e57$var$isIconRenderProp(Icon) ? Icon({
        label: "",
        size: size,
        color: "currentColor"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement(Icon, {
        label: "",
        size: size,
        color: "currentColor"
    }));
};
var $78c64833a8dd4e57$export$2e2bcd8739ae039 = $78c64833a8dd4e57$var$IconRenderer;

});

parcelRegister("dxA7k", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $028b439b054731ef$export$2e2bcd8739ae039; });

var $dAx5m = parcelRequire("dAx5m");

var $6ppfX = parcelRequire("6ppfX");
function $028b439b054731ef$var$getIconSpacing(spacing) {
    switch(spacing){
        case "compact":
            return "small";
        case "none":
            return "xsmall";
        default:
            return "medium";
    }
}
function $028b439b054731ef$var$getSpinnerAppearance(_ref) {
    var appearance = _ref.appearance, isDisabled = _ref.isDisabled, isSelected = _ref.isSelected;
    if (isDisabled || isSelected) return "inherit";
    if (appearance === "primary" || appearance === "danger" || appearance === "discovery") return "invert";
    return "inherit";
}
function $028b439b054731ef$export$2e2bcd8739ae039(_ref2) {
    var appearance = _ref2.appearance, spacing = _ref2.spacing, isDisabled = _ref2.isDisabled, isSelected = _ref2.isSelected, testId = _ref2.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $6ppfX.default), {
        size: $028b439b054731ef$var$getIconSpacing(spacing),
        appearance: $028b439b054731ef$var$getSpinnerAppearance({
            appearance: appearance,
            isDisabled: isDisabled,
            isSelected: isSelected
        }),
        testId: testId ? "".concat(testId, "--loading-spinner") : undefined
    });
}

});
parcelRegister("6ppfX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4aa8ab436eab27af$export$2e2bcd8739ae039; });
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $dAx5m = parcelRequire("dAx5m");

var $jVTBW = parcelRequire("jVTBW");

var $kqsmh = parcelRequire("kqsmh");

var $6I4kX = parcelRequire("6I4kX");

var $7yVn2 = parcelRequire("7yVn2");
/**
 * Returns the appropriate circle stroke color.
 */ function $4aa8ab436eab27af$var$getStrokeColor(appearance) {
    return appearance === "inherit" ? "var(--ds-icon-subtle, ".concat((0, $6I4kX.N500), ")") : "var(--ds-icon-inverse, ".concat((0, $6I4kX.N0), ")");
}
var $4aa8ab436eab27af$var$rotate = (0, $jVTBW.keyframes)({
    to: {
        transform: "rotate(360deg)"
    }
});
var $4aa8ab436eab27af$var$rotateStyles = (0, $jVTBW.css)({
    animation: "".concat($4aa8ab436eab27af$var$rotate, " 0.86s infinite"),
    animationTimingFunction: "cubic-bezier(0.4, 0.15, 0.6, 0.85)",
    transformOrigin: "center"
});
/**
 * There are three parts to the load in animation:
 * 1. Fade in
 * 2. Accelerated spin
 * 3. Stretch the spinner line
 */ var $4aa8ab436eab27af$var$loadIn = (0, $jVTBW.keyframes)({
    from: {
        transform: "rotate(50deg)",
        opacity: 0,
        strokeDashoffset: 60
    },
    to: {
        transform: "rotate(230deg)",
        opacity: 1,
        strokeDashoffset: 50
    }
});
var $4aa8ab436eab27af$var$loadInStyles = (0, $jVTBW.css)({
    animation: "".concat($4aa8ab436eab27af$var$loadIn, " 1s ease-in-out"),
    /**
   * When the animation completes, stay at the last frame of the animation.
   */ animationFillMode: "forwards",
    /**
   * We are going to animate this in.
   */ opacity: 0
});
var $4aa8ab436eab27af$var$wrapperStyles = (0, $jVTBW.css)({
    display: "inline-flex",
    /**
   * Align better inline with text.
   */ verticalAlign: "middle"
});
var $4aa8ab436eab27af$var$circleStyles = (0, $jVTBW.css)({
    fill: "none",
    strokeDasharray: 60,
    strokeDashoffset: "inherit",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    "@media screen and (forced-colors: active)": {
        filter: "grayscale(100%)",
        stroke: "CanvasText"
    }
});
/**
 * `useLayoutEffect` is being used in SSR safe form. On the server, this work doesn’t need to run.
 * `useEffect` is used in-place, because `useEffect` is not run on the server and it matches types
 * which makes things simpler than doing an `isServer` check or a `null` check.
 *
 * @see https://hello.atlassian.net/wiki/spaces/DST/pages/2081696628/DSTDACI-010+-+Interaction+Tracing+hooks+in+DS+components
 */ var $4aa8ab436eab27af$var$useLayoutEffect = typeof window === "undefined" ? (0, $dAx5m.useEffect) : (0, $dAx5m.useLayoutEffect);
/**
 * __Spinner__
 *
 * A spinner is an animated spinning icon that lets users know content is being loaded.
 *
 * - [Examples](https://atlassian.design/components/spinner/examples)
 * - [Code](https://atlassian.design/components/spinner/code)
 * - [Usage](https://atlassian.design/components/spinner/usage)
 */ var $4aa8ab436eab27af$var$Spinner = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).forwardRef(function Spinner(_ref, ref) {
    var _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "inherit" : _ref$appearance, _ref$delay = _ref.delay, delay = _ref$delay === void 0 ? 0 : _ref$delay, interactionName = _ref.interactionName, label = _ref.label, _ref$size = _ref.size, providedSize = _ref$size === void 0 ? "medium" : _ref$size, testId = _ref.testId;
    var size = typeof providedSize === "number" ? providedSize : (0, $7yVn2.presetSizes)[providedSize];
    var animationDelay = "".concat(delay, "ms");
    var stroke = $4aa8ab436eab27af$var$getStrokeColor(appearance);
    var context = (0, $dAx5m.useContext)((0, $kqsmh.default));
    $4aa8ab436eab27af$var$useLayoutEffect(function() {
        if (context != null) return context.hold(interactionName);
    }, [
        context,
        interactionName
    ]);
    /**
   * The Spinner animation uses a combination of two
   * css animations on two separate elements.
   */ return (0, $jVTBW.jsx)("span", {
        /**
     * This span exists to off-load animations from the circle element,
     * which were causing performance issues (style recalculations)
     * on Safari and older versions of Chrome.
     *
     * This can be removed and styles placed back on the circle element once
     * Safari fixes this bug and off-loads rendering to the GPU from the CPU.
     */ css: [
            $4aa8ab436eab27af$var$wrapperStyles,
            $4aa8ab436eab27af$var$rotateStyles
        ],
        "data-testid": testId && "".concat(testId, "-wrapper"),
        style: {
            animationDelay: animationDelay,
            width: size,
            height: size
        }
    }, (0, $jVTBW.jsx)("svg", {
        height: size,
        width: size,
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        "data-testid": testId,
        ref: ref,
        "aria-label": label || undefined,
        css: $4aa8ab436eab27af$var$loadInStyles,
        style: {
            animationDelay: animationDelay
        },
        role: label ? "img" : "none"
    }, (0, $jVTBW.jsx)("circle", {
        cx: "8",
        cy: "8",
        r: "7",
        css: $4aa8ab436eab27af$var$circleStyles,
        style: {
            stroke: stroke
        }
    })));
}));
var $4aa8ab436eab27af$export$2e2bcd8739ae039 = $4aa8ab436eab27af$var$Spinner;

});
parcelRegister("6I4kX", function(module, exports) {

$parcel$export(module.exports, "N0", function () { return $4e2a37626057562a$export$29a4f05edc054374; });
$parcel$export(module.exports, "N500", function () { return $4e2a37626057562a$export$c39c0fe0f26207ae; });
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // Reds
var $4e2a37626057562a$export$4b84fd0e2c617bd = "#FFEBE6";
var $4e2a37626057562a$export$b34b069eff244586 = "#FFBDAD";
var $4e2a37626057562a$export$be802dd0d8b57f35 = "#FF8F73";
var $4e2a37626057562a$export$60847d42f9da92a6 = "#FF7452";
var $4e2a37626057562a$export$4a7404f376229999 = "#FF5630";
var $4e2a37626057562a$export$2010d0fb4295b346 = "#DE350B";
var $4e2a37626057562a$export$2837b5a1a71d5c02 = "#BF2600";
var $4e2a37626057562a$export$8d9596b529bbb9cf = "#FFFAE6";
var $4e2a37626057562a$export$41060a744ab0b7ae = "#FFF0B3";
var $4e2a37626057562a$export$1cc05bbbf340e559 = "#FFE380";
var $4e2a37626057562a$export$5aae31392d72caaa = "#FFC400";
var $4e2a37626057562a$export$c6930421db9fa514 = "#FFAB00";
var $4e2a37626057562a$export$59619663aa6500fb = "#FF991F";
var $4e2a37626057562a$export$874739ea9e379ab6 = "#FF8B00";
var $4e2a37626057562a$export$8a6341c32b6a3ee6 = "#E3FCEF";
var $4e2a37626057562a$export$69a3bf21b9686c2b = "#ABF5D1";
var $4e2a37626057562a$export$afbce1382ec95f73 = "#79F2C0";
var $4e2a37626057562a$export$747d86715d4175de = "#57D9A3";
var $4e2a37626057562a$export$940e1f69e873f202 = "#36B37E";
var $4e2a37626057562a$export$a49394138f7b8e85 = "#00875A";
var $4e2a37626057562a$export$6fa04827ac68a4fb = "#006644";
var $4e2a37626057562a$export$226de0355ed012f8 = "#DEEBFF";
var $4e2a37626057562a$export$8c13c2ee36917869 = "#B3D4FF";
var $4e2a37626057562a$export$ecfc1dff386a3e7a = "#4C9AFF";
var $4e2a37626057562a$export$215b7063051591f1 = "#2684FF";
var $4e2a37626057562a$export$e62e8919cca44969 = "#0065FF";
var $4e2a37626057562a$export$b3de0ae08da2ce64 = "#0052CC";
var $4e2a37626057562a$export$a6ee3d71bc067634 = "#0747A6";
var $4e2a37626057562a$export$363e4475840015bb = "#EAE6FF";
var $4e2a37626057562a$export$4b0a4417ed59760f = "#C0B6F2";
var $4e2a37626057562a$export$6011520a64d9a187 = "#998DD9";
var $4e2a37626057562a$export$a7175d4e9206bc80 = "#8777D9";
var $4e2a37626057562a$export$b48405b95304b5a1 = "#6554C0";
var $4e2a37626057562a$export$c71e4279dd54a18d = "#5243AA";
var $4e2a37626057562a$export$147899de772240ec = "#403294";
var $4e2a37626057562a$export$2cf711fe14c66f06 = "#E6FCFF";
var $4e2a37626057562a$export$7a8f4d33f6f9772c = "#B3F5FF";
var $4e2a37626057562a$export$776c9c497ef08533 = "#79E2F2";
var $4e2a37626057562a$export$69cb3ca10c1e330e = "#00C7E6";
var $4e2a37626057562a$export$9dc1ef0f3f48059b = "#00B8D9";
var $4e2a37626057562a$export$7c835c78b6fcdef8 = "#00A3BF";
var $4e2a37626057562a$export$6036577f95c3877e = "#008DA6";
var $4e2a37626057562a$export$29a4f05edc054374 = "#FFFFFF";
var $4e2a37626057562a$export$e655ef011c4aa1a2 = "#FAFBFC";
var $4e2a37626057562a$export$9fdfb749e33cdf97 = "#F4F5F7";
var $4e2a37626057562a$export$3e51e8f1440314ba = "#EBECF0";
var $4e2a37626057562a$export$1ce2d1575d444ceb = "#DFE1E6";
var $4e2a37626057562a$export$8754fc7e6d8b3000 = "#C1C7D0";
var $4e2a37626057562a$export$c2e91cbeada39b8b = "#B3BAC5";
var $4e2a37626057562a$export$5f71e19f3a7ad9de = "#A5ADBA";
var $4e2a37626057562a$export$eaa8c8a70ac22806 = "#97A0AF";
var $4e2a37626057562a$export$7c87d337fb91a97d = "#8993A4";
var $4e2a37626057562a$export$d6447c357493214f = "#7A869A";
var $4e2a37626057562a$export$f563ee71e9ee74cd = "#6B778C";
var $4e2a37626057562a$export$e2ef2124cf4024b1 = "#5E6C84";
var $4e2a37626057562a$export$eece5f492e429f08 = "#505F79";
var $4e2a37626057562a$export$c39c0fe0f26207ae = "#42526E";
var $4e2a37626057562a$export$7090862dc3038a9f = "#344563";
var $4e2a37626057562a$export$ad0bacf983b7ddaa = "#253858";
var $4e2a37626057562a$export$7d61b15e0da132af = "#172B4D";
var $4e2a37626057562a$export$fbda843f0a27fe96 = "#091E42";
var $4e2a37626057562a$export$791e57b27ca738ef = "rgba(9, 30, 66, 0.02)";
var $4e2a37626057562a$export$8d43898f60b96a82 = "rgba(9, 30, 66, 0.04)";
var $4e2a37626057562a$export$920c0d5c49070351 = "rgba(9, 30, 66, 0.08)";
var $4e2a37626057562a$export$46987b49aab6d1a8 = "rgba(9, 30, 66, 0.13)";
var $4e2a37626057562a$export$7d3359664e8bb0e5 = "rgba(9, 30, 66, 0.25)";
var $4e2a37626057562a$export$d2d3bedfb276cac0 = "rgba(9, 30, 66, 0.31)";
var $4e2a37626057562a$export$6e5e7499ff054f6d = "rgba(9, 30, 66, 0.36)";
var $4e2a37626057562a$export$59264b346c877fa7 = "rgba(9, 30, 66, 0.42)";
var $4e2a37626057562a$export$d092757d7c64925c = "rgba(9, 30, 66, 0.48)";
var $4e2a37626057562a$export$486ab785e4bac3c6 = "rgba(9, 30, 66, 0.54)";
var $4e2a37626057562a$export$fba592bbc6419fea = "rgba(9, 30, 66, 0.60)";
var $4e2a37626057562a$export$13609db0e6812ab8 = "rgba(9, 30, 66, 0.66)";
var $4e2a37626057562a$export$fbae4efaa892d883 = "rgba(9, 30, 66, 0.71)";
var $4e2a37626057562a$export$f13946d26f440ce6 = "rgba(9, 30, 66, 0.77)";
var $4e2a37626057562a$export$19f58225ac52a306 = "rgba(9, 30, 66, 0.82)";
var $4e2a37626057562a$export$6384f09da70e7b62 = "rgba(9, 30, 66, 0.89)";
var $4e2a37626057562a$export$d0dccc730683edc2 = "rgba(9, 30, 66, 0.95)";
var $4e2a37626057562a$export$2f6319cf7d736c2a = "#E6EDFA";
var $4e2a37626057562a$export$95126bc8884d6634 = "#DCE5F5";
var $4e2a37626057562a$export$8338d8c35d44ff1 = "#CED9EB";
var $4e2a37626057562a$export$5368d76ae4fbbda7 = "#B8C7E0";
var $4e2a37626057562a$export$9f0a771d16ec8d36 = "#ABBBD6";
var $4e2a37626057562a$export$abcf8c38338b4aa5 = "#9FB0CC";
var $4e2a37626057562a$export$97e81faa16a182c7 = "#8C9CB8";
var $4e2a37626057562a$export$bfe21c59123ecf33 = "#7988A3";
var $4e2a37626057562a$export$ee82aa2ea6a1558 = "#67758F";
var $4e2a37626057562a$export$682927c6ed76be02 = "#56637A";
var $4e2a37626057562a$export$91fd9994c5be9757 = "#455166";
var $4e2a37626057562a$export$d281fbfe3cff2df6 = "#3B475C";
var $4e2a37626057562a$export$3902c91d8b98a753 = "#313D52";
var $4e2a37626057562a$export$8e8133c1ba5845b5 = "#283447";
var $4e2a37626057562a$export$33ff357f6620b39 = "#202B3D";
var $4e2a37626057562a$export$633847cf062b69e0 = "#1B2638";
var $4e2a37626057562a$export$9776a6e503bdbf76 = "#121A29";
var $4e2a37626057562a$export$6c813d5160dff5db = "#0E1624";
var $4e2a37626057562a$export$3d4f271a500072a = "#0D1424";
var $4e2a37626057562a$export$fe151285c22759ec = "rgba(13, 20, 36, 0.06)";
var $4e2a37626057562a$export$a101c6190d0da34 = "rgba(13, 20, 36, 0.14)";
var $4e2a37626057562a$export$4b16f52932fda51 = "rgba(13, 20, 36, 0.18)";
var $4e2a37626057562a$export$a74bcd7b9845b0d8 = "rgba(13, 20, 36, 0.29)";
var $4e2a37626057562a$export$9209c179316d1751 = "rgba(13, 20, 36, 0.36)";
var $4e2a37626057562a$export$88f55133f636c8dd = "rgba(13, 20, 36, 0.40)";
var $4e2a37626057562a$export$51126f85d1009512 = "rgba(13, 20, 36, 0.47)";
var $4e2a37626057562a$export$a069b547bd23af78 = "rgba(13, 20, 36, 0.53)";
var $4e2a37626057562a$export$40cce05af3b2600a = "rgba(13, 20, 36, 0.63)";
var $4e2a37626057562a$export$b78942185925a0d = "rgba(13, 20, 36, 0.73)";
var $4e2a37626057562a$export$e058fb44b8eaafca = "rgba(13, 20, 36, 0.78)";
var $4e2a37626057562a$export$92b0b8de26920c18 = "rgba(13, 20, 36, 0.81)";
var $4e2a37626057562a$export$67564f7459d3fc9e = "rgba(13, 20, 36, 0.85)";
var $4e2a37626057562a$export$77868e1ca884ffa3 = "rgba(13, 20, 36, 0.89)";
var $4e2a37626057562a$export$2afd71d7d3ea2cd5 = "rgba(13, 20, 36, 0.92)";
var $4e2a37626057562a$export$f2a0acaab9972c70 = "rgba(13, 20, 36, 0.95)";
var $4e2a37626057562a$export$9ab70e67d6475361 = "rgba(13, 20, 36, 0.97)";

});

parcelRegister("7yVn2", function(module, exports) {

$parcel$export(module.exports, "presetSizes", function () { return $581835f93438745e$export$4e9f1640bbe7a1a8; });
var $581835f93438745e$export$4e9f1640bbe7a1a8 = {
    xsmall: 8,
    small: 16,
    medium: 24,
    large: 48,
    xlarge: 96
};

});



parcelRegister("gTEio", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c4d10a4bbd1b1688$export$2e2bcd8739ae039; });

var $iriaf = parcelRequire("iriaf");

var $dAx5m = parcelRequire("dAx5m");

var $h0JxK = parcelRequire("h0JxK");

var $2Dg3J = parcelRequire("2Dg3J");

var $gMIYi = parcelRequire("gMIYi");

var $29ou0 = parcelRequire("29ou0");

var $cihAo = parcelRequire("cihAo");
var $aSd6p = parcelRequire("aSd6p");

var $d0MiN = parcelRequire("d0MiN");

var $ez4n6 = parcelRequire("ez4n6");

var $lmtlU = parcelRequire("lmtlU");

var $bmXnN = parcelRequire("bmXnN");

var $jTObE = parcelRequire("jTObE");
function $c4d10a4bbd1b1688$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $c4d10a4bbd1b1688$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $c4d10a4bbd1b1688$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($iriaf)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $c4d10a4bbd1b1688$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $c4d10a4bbd1b1688$var$buttonStyles = (0, $aSd6p.xcss)({
    display: "inline-flex",
    boxSizing: "border-box",
    width: "auto",
    maxWidth: "100%",
    position: "relative",
    alignItems: "baseline",
    justifyContent: "center",
    columnGap: "space.050",
    borderRadius: "border.radius.100",
    borderWidth: "border.width.0",
    flexShrink: 0,
    height: "".concat(32 / 14, "em"),
    paddingInlineEnd: "space.150",
    paddingInlineStart: "space.150",
    textAlign: "center",
    transition: "background 0.1s ease-out",
    verticalAlign: "middle",
    "::after": {
        borderRadius: "inherit",
        inset: "space.0",
        borderStyle: "solid",
        borderWidth: "var(--ds-border-width, 1px)",
        pointerEvents: "none",
        position: "absolute"
    }
});
var $c4d10a4bbd1b1688$var$hardCodedButtonStyles = (0, $aSd6p.xcss)({
    fontFamily: "inherit",
    fontSize: "inherit",
    fontStyle: "normal",
    fontWeight: 500,
    lineHeight: "".concat(32 / 14, "em"),
    paddingBlock: "space.0"
});
var $c4d10a4bbd1b1688$var$tokenizedButtonStyles = (0, $aSd6p.xcss)({
    font: 'var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    fontWeight: "var(--ds-font-weight-medium, 500)",
    paddingBlock: "space.075"
});
var $c4d10a4bbd1b1688$var$defaultInteractiveStyles = (0, $aSd6p.xcss)({
    ":hover": {
        background: "var(--ds-background-neutral-hovered, #091e4214)",
        // @ts-expect-error
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        color: "var(--ds-text, ".concat($d0MiN.N500, ")")
    },
    ":active": {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        background: "var(--ds-background-neutral-pressed, ".concat($d0MiN.B75, ")"),
        // @ts-expect-error
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        color: "var(--ds-text, ".concat($d0MiN.B400, ")")
    }
});
var $c4d10a4bbd1b1688$var$defaultInteractiveRefreshedStyles = (0, $aSd6p.xcss)({
    ":hover": {
        background: "var(--ds-background-neutral-subtle-hovered, #091E420F)",
        color: "color.text.subtle"
    },
    ":active": {
        background: "var(--ds-background-neutral-subtle-pressed, #091E4224)",
        color: "color.text.subtle"
    }
});
var $c4d10a4bbd1b1688$var$defaultStyles = (0, $aSd6p.xcss)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
    background: "var(--ds-background-neutral, ".concat($d0MiN.N20A, ")"),
    // @ts-expect-error — using tokens for explicit fallback usage.
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values --  -- Ignored via go/DSP-18766
    color: "var(--ds-text, ".concat($d0MiN.N500, ")"),
    ":visited": {
        // @ts-expect-error
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        color: "var(--ds-text, ".concat($d0MiN.N500, ")")
    }
});
var $c4d10a4bbd1b1688$var$defaultRefreshedStyles = (0, $aSd6p.xcss)({
    background: "var(--ds-background-neutral-subtle, #00000000)",
    color: "color.text.subtle",
    "::after": {
        content: '""',
        borderColor: "color.border"
    },
    ":visited": {
        color: "color.text.subtle"
    }
});
var $c4d10a4bbd1b1688$var$primaryStyles = (0, $aSd6p.xcss)({
    background: "var(--ds-background-brand-bold, #0052CC)",
    // @ts-expect-error
    color: "var(--ds-text-inverse, #FFFFFF)",
    ":visited": {
        // @ts-expect-error
        color: "var(--ds-text-inverse, #FFFFFF)"
    }
});
var $c4d10a4bbd1b1688$var$primaryInteractiveStyles = (0, $aSd6p.xcss)({
    ":hover": {
        // @ts-expect-error
        color: "var(--ds-text-inverse, #FFFFFF)",
        background: "var(--ds-background-brand-bold-hovered, #0065FF)"
    },
    ":active": {
        // @ts-expect-error
        color: "var(--ds-text-inverse, #FFFFFF)",
        background: "var(--ds-background-brand-bold-pressed, #0747A6)"
    }
});
var $c4d10a4bbd1b1688$var$warningStyles = (0, $aSd6p.xcss)({
    background: "var(--ds-background-warning-bold, #FFAB00)",
    // @ts-expect-error
    color: "var(--ds-text-warning-inverse, #172B4D)",
    ":visited": {
        // @ts-expect-error
        color: "var(--ds-text-warning-inverse, #172B4D)"
    }
});
var $c4d10a4bbd1b1688$var$warningInteractiveStyles = (0, $aSd6p.xcss)({
    ":hover": {
        // @ts-expect-error
        color: "var(--ds-text-warning-inverse, #172B4D)",
        background: "var(--ds-background-warning-bold-hovered, #FFC400)"
    },
    ":active": {
        // @ts-expect-error
        color: "var(--ds-text-warning-inverse, #172B4D)",
        background: "var(--ds-background-warning-bold-pressed, #FF991F)"
    }
});
var $c4d10a4bbd1b1688$var$dangerStyles = (0, $aSd6p.xcss)({
    background: "var(--ds-background-danger-bold, #DE350B)",
    color: "color.text.inverse",
    ":visited": {
        color: "color.text.inverse"
    }
});
var $c4d10a4bbd1b1688$var$dangerInteractiveStyles = (0, $aSd6p.xcss)({
    ":hover": {
        color: "color.text.inverse",
        background: "var(--ds-background-danger-bold-hovered, #FF5630)"
    },
    ":active": {
        color: "color.text.inverse",
        background: "var(--ds-background-danger-bold-pressed, #BF2600)"
    }
});
var $c4d10a4bbd1b1688$var$discoveryStyles = (0, $aSd6p.xcss)({
    background: "var(--ds-background-discovery-bold, #5243AA)",
    color: "color.text.inverse",
    ":visited": {
        color: "color.text.inverse"
    }
});
var $c4d10a4bbd1b1688$var$discoveryInteractiveStyles = (0, $aSd6p.xcss)({
    ":hover": {
        color: "color.text.inverse",
        background: "var(--ds-background-discovery-bold-hovered, #8777D9)"
    },
    ":active": {
        color: "color.text.inverse",
        background: "var(--ds-background-discovery-bold-pressed, #5243AA)"
    }
});
var $c4d10a4bbd1b1688$var$subtleStyles = (0, $aSd6p.xcss)({
    background: "var(--ds-background-neutral-subtle, transparent)",
    // @ts-expect-error
    color: "var(--ds-text, #42526E)",
    ":visited": {
        // @ts-expect-error
        color: "var(--ds-text, #42526E)"
    }
});
var $c4d10a4bbd1b1688$var$subtleRefreshedStyles = (0, $aSd6p.xcss)({
    background: "var(--ds-background-neutral-subtle, transparent)",
    color: "color.text.subtle",
    ":visited": {
        color: "color.text.subtle"
    }
});
var $c4d10a4bbd1b1688$var$subtleInteractiveStyles = (0, $aSd6p.xcss)({
    ":hover": {
        background: "var(--ds-background-neutral-subtle-hovered, #091e4214)",
        // @ts-expect-error
        color: "var(--ds-text, #42526E)"
    },
    ":active": {
        background: "var(--ds-background-neutral-subtle-pressed, #B3D4FF)",
        // @ts-expect-error
        color: "var(--ds-text, #42526E)"
    }
});
var $c4d10a4bbd1b1688$var$subtleInteractiveRefreshedStyles = (0, $aSd6p.xcss)({
    ":hover": {
        background: "var(--ds-background-neutral-subtle-hovered, #091e4214)",
        color: "color.text.subtle"
    },
    ":active": {
        background: "var(--ds-background-neutral-subtle-pressed, #B3D4FF)",
        color: "color.text.subtle"
    }
});
var $c4d10a4bbd1b1688$var$linkStyles = (0, $aSd6p.xcss)({
    // @ts-expect-error
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    color: "var(--ds-link, ".concat($d0MiN.B400, ")"),
    background: "var(--ds-background-neutral-subtle, transparent)",
    textDecoration: "none",
    ":hover": {
        // @ts-expect-error
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        color: "var(--ds-link, ".concat($d0MiN.B300, ")"),
        background: "var(--ds-background-neutral-subtle, transparent)"
    },
    ":active": {
        // @ts-expect-error
        color: "var(--ds-link-pressed, #0055CC)",
        background: "var(--ds-background-neutral-subtle, transparent)"
    },
    ":visited": {
        // @ts-expect-error
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        color: "var(--ds-link, ".concat($d0MiN.B400, ")")
    }
});
var $c4d10a4bbd1b1688$var$subtleLinkStyles = (0, $aSd6p.xcss)({
    // @ts-expect-error
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    color: "var(--ds-text-subtle, ".concat($d0MiN.N200, ")"),
    background: "var(--ds-background-neutral-subtle, transparent)",
    textDecoration: "none",
    ":hover": {
        // @ts-expect-error
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        color: "var(--ds-text-subtle, ".concat($d0MiN.N90, ")"),
        background: "var(--ds-background-neutral-subtle, transparent)"
    },
    ":active": {
        // @ts-expect-error
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        color: "var(--ds-text, ".concat($d0MiN.N400, ")"),
        background: "var(--ds-background-neutral-subtle, transparent)"
    },
    ":visited": {
        // @ts-expect-error
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        color: "var(--ds-text-subtle, ".concat($d0MiN.N200, ")")
    }
});
// Required due to Jira's AUI CSS reset: https://product-fabric.atlassian.net/browse/DSP-15687
var $c4d10a4bbd1b1688$var$linkDecorationUnsetStyles = (0, $aSd6p.xcss)({
    textDecoration: "none",
    ":hover": {
        textDecoration: "none"
    },
    ":active": {
        textDecoration: "none"
    },
    ":focus": {
        textDecoration: "none"
    }
});
var $c4d10a4bbd1b1688$var$linkDecorationStyles = (0, $aSd6p.xcss)({
    ":hover": {
        textDecoration: "underline"
    },
    ":focus": {
        textDecoration: "underline"
    }
});
var $c4d10a4bbd1b1688$var$disabledStyles = (0, $aSd6p.xcss)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    background: "var(--ds-background-disabled, ".concat($d0MiN.N20A, ")"),
    // @ts-expect-error
    color: "var(--ds-text-disabled, #091E424F)",
    ":hover": {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        background: "var(--ds-background-disabled, ".concat($d0MiN.N20A, ")"),
        // @ts-expect-error
        color: "var(--ds-text-disabled, #091E424F)"
    },
    ":active": {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        background: "var(--ds-background-disabled, ".concat($d0MiN.N20A, ")"),
        // @ts-expect-error
        color: "var(--ds-text-disabled, #091E424F)"
    },
    "::after": {
        content: "none"
    }
});
var $c4d10a4bbd1b1688$var$selectedStyles = (0, $aSd6p.xcss)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    background: "var(--ds-background-selected, ".concat($d0MiN.N700, ")"),
    // @ts-expect-error
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    color: "var(--ds-text-selected, ".concat($d0MiN.N20, ")"),
    ":visited": {
        // @ts-expect-error
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        color: "var(--ds-text-selected, ".concat($d0MiN.N20, ")")
    }
});
var $c4d10a4bbd1b1688$var$selectedRefreshedStyles = (0, $aSd6p.xcss)({
    background: "var(--ds-background-selected, #E9F2FF)",
    color: "color.text.selected",
    "::after": {
        content: '""',
        borderColor: "color.border.selected"
    },
    ":visited": {
        color: "color.text.selected"
    }
});
var $c4d10a4bbd1b1688$var$selectedInteractiveStyles = (0, $aSd6p.xcss)({
    ":hover": {
        // @ts-expect-error
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        color: "var(--ds-text-selected, ".concat($d0MiN.N20, ")"),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        background: "var(--ds-background-selected-hovered, ".concat($d0MiN.N700, ")")
    },
    ":active": {
        // @ts-expect-error
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        color: "var(--ds-text-selected, ".concat($d0MiN.N20, ")"),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        background: "var(--ds-background-selected-pressed, ".concat($d0MiN.N700, ")")
    }
});
// TODO: Remove me once we kill color fallbacks
var $c4d10a4bbd1b1688$var$selectedWarningStyles = (0, $aSd6p.xcss)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    background: "var(--ds-background-selected, ".concat($d0MiN.Y400, ")"),
    // @ts-expect-error
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    color: "var(--ds-text-selected, ".concat($d0MiN.N800, ")"),
    ":hover": {
        // @ts-expect-error
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        color: "var(--ds-text-selected, ".concat($d0MiN.N20, ")"),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        background: "var(--ds-background-selected, ".concat($d0MiN.Y400, ")")
    },
    ":active": {
        // @ts-expect-error
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        color: "var(--ds-text-selected, ".concat($d0MiN.N20, ")"),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        background: "var(--ds-background-selected, ".concat($d0MiN.Y400, ")")
    }
});
// TODO: Remove me once we kill color fallbacks
var $c4d10a4bbd1b1688$var$selectedDangerStyles = (0, $aSd6p.xcss)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    background: "var(--ds-background-selected, ".concat($d0MiN.R500, ")"),
    // @ts-expect-error
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    color: "var(--ds-text-selected, ".concat($d0MiN.N20, ")"),
    ":hover": {
        // @ts-expect-error
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        color: "var(--ds-text-selected, ".concat($d0MiN.N20, ")"),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        background: "var(--ds-background-selected, ".concat($d0MiN.R500, ")")
    },
    ":active": {
        // @ts-expect-error
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        color: "var(--ds-text-selected, ".concat($d0MiN.N20, ")"),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        background: "var(--ds-background-selected, ".concat($d0MiN.R500, ")")
    }
});
// TODO: Remove me once we kill color fallbacks
var $c4d10a4bbd1b1688$var$selectedDiscoveryStyles = (0, $aSd6p.xcss)({
    background: "var(--ds-background-selected, #403294)",
    // @ts-expect-error
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    color: "var(--ds-text-selected, ".concat($d0MiN.N20, ")"),
    ":hover": {
        // @ts-expect-error
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        color: "var(--ds-text-selected, ".concat($d0MiN.N20, ")"),
        background: "var(--ds-background-selected, #403294)"
    },
    ":active": {
        // @ts-expect-error
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        color: "var(--ds-text-selected, ".concat($d0MiN.N20, ")"),
        background: "var(--ds-background-selected, #403294)"
    }
});
var $c4d10a4bbd1b1688$var$spacingCompactStyles = (0, $aSd6p.xcss)({
    columnGap: "space.050",
    height: "".concat(24 / 14, "em"),
    paddingInlineEnd: "space.150",
    paddingInlineStart: "space.150",
    verticalAlign: "middle"
});
var $c4d10a4bbd1b1688$var$baseSpacingCompactStyles = (0, $aSd6p.xcss)({
    lineHeight: "".concat(24 / 14, "em")
});
var $c4d10a4bbd1b1688$var$tokenizedSpacingCompactStyles = (0, $aSd6p.xcss)({
    paddingBlock: "space.025"
});
var $c4d10a4bbd1b1688$var$spacingNoneStyles = (0, $aSd6p.xcss)({
    columnGap: "space.0",
    height: "auto",
    lineHeight: "inherit",
    paddingInlineEnd: "space.0",
    paddingInlineStart: "space.0",
    verticalAlign: "baseline"
});
var $c4d10a4bbd1b1688$var$tokenizedSpacingNoneStyles = (0, $aSd6p.xcss)({
    paddingBlock: "space.0"
});
var $c4d10a4bbd1b1688$var$circleStyles = (0, $aSd6p.xcss)({
    borderRadius: "border.radius.circle"
});
var $c4d10a4bbd1b1688$var$fullWidthStyles = (0, $aSd6p.xcss)({
    width: "100%"
});
var $c4d10a4bbd1b1688$var$loadingOverlayStyles = (0, $aSd6p.xcss)({
    cursor: "progress"
});
var $c4d10a4bbd1b1688$var$nonInteractiveStyles = (0, $aSd6p.xcss)({
    cursor: "not-allowed"
});
var $c4d10a4bbd1b1688$var$iconButtonStyles = (0, $aSd6p.xcss)({
    height: "".concat(32 / 14, "em"),
    width: "".concat(32 / 14, "em"),
    paddingInlineEnd: "space.0",
    paddingInlineStart: "space.0"
});
var $c4d10a4bbd1b1688$var$iconButtonCompactStyles = (0, $aSd6p.xcss)({
    width: "".concat(24 / 14, "em"),
    height: "".concat(24 / 14, "em")
});
var $c4d10a4bbd1b1688$var$buttonIconBeforeStyles = (0, $aSd6p.xcss)({
    paddingInlineStart: "space.100"
});
var $c4d10a4bbd1b1688$var$buttonIconAfterStyles = (0, $aSd6p.xcss)({
    paddingInlineEnd: "space.100"
});
var $c4d10a4bbd1b1688$var$splitButtonStyles = (0, $aSd6p.xcss)({
    ":focus-visible": {
        zIndex: "card"
    }
});
var $c4d10a4bbd1b1688$var$navigationSplitButtonStyles = (0, $aSd6p.xcss)({
    width: "24px",
    backgroundColor: "color.background.neutral.subtle",
    paddingInlineEnd: "space.075",
    paddingInlineStart: "space.075"
});
var $c4d10a4bbd1b1688$var$overlayStyles = (0, $aSd6p.xcss)({
    display: "flex",
    position: "absolute",
    alignItems: "center",
    justifyContent: "center",
    insetBlockEnd: "space.0",
    insetBlockStart: "space.0",
    insetInlineEnd: "space.0",
    insetInlineStart: "space.0"
});
/**
 * __Use button base__
 *
 * A React hook that accepts a set of common Button props,
 * and processes them to return consistent base props for usage
 * across various Button components.
 *
 * It also:
 * - Implements auto focus when enabled.
 * - Appends the `onClick` event with UFO analytics tracking.
 *
 * @private
 */ var $c4d10a4bbd1b1688$var$useButtonBase = function useButtonBase(_ref) {
    var _ref$appearance = _ref.appearance, propAppearance = _ref$appearance === void 0 ? "default" : _ref$appearance, _ref$autoFocus = _ref.autoFocus, autoFocus = _ref$autoFocus === void 0 ? false : _ref$autoFocus, _ref$isDisabled = _ref.isDisabled, propIsDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled, _ref$isLoading = _ref.isLoading, isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading, _ref$isSelected = _ref.isSelected, propIsSelected = _ref$isSelected === void 0 ? false : _ref$isSelected, _ref$isIconButton = _ref.isIconButton, isIconButton = _ref$isIconButton === void 0 ? false : _ref$isIconButton, _ref$isCircle = _ref.isCircle, isCircle = _ref$isCircle === void 0 ? false : _ref$isCircle, _ref$hasIconBefore = _ref.hasIconBefore, hasIconBefore = _ref$hasIconBefore === void 0 ? false : _ref$hasIconBefore, _ref$hasIconAfter = _ref.hasIconAfter, hasIconAfter = _ref$hasIconAfter === void 0 ? false : _ref$hasIconAfter, children = _ref.children, onClick = _ref.onClick, onMouseDownCapture = _ref.onMouseDownCapture, onMouseUpCapture = _ref.onMouseUpCapture, onKeyDownCapture = _ref.onKeyDownCapture, onKeyUpCapture = _ref.onKeyUpCapture, onTouchStartCapture = _ref.onTouchStartCapture, onTouchEndCapture = _ref.onTouchEndCapture, onPointerDownCapture = _ref.onPointerDownCapture, onPointerUpCapture = _ref.onPointerUpCapture, onClickCapture = _ref.onClickCapture, overlay = _ref.overlay, ref = _ref.ref, _ref$shouldFitContain = _ref.shouldFitContainer, shouldFitContainer = _ref$shouldFitContain === void 0 ? false : _ref$shouldFitContain, _ref$spacing = _ref.spacing, propSpacing = _ref$spacing === void 0 ? "default" : _ref$spacing, ariaLabel = _ref.ariaLabel, ariaLabelledBy = _ref.ariaLabelledBy;
    var localRef = (0, $dAx5m.useRef)(null);
    var splitButtonContext = (0, $lmtlU.useSplitButtonContext)();
    // TODO: Use React 18's useId() hook when we update.
    // eslint-disable-next-line @repo/internal/react/disallow-unstable-values
    var loadingLabelId = (0, $h0JxK.uid)({
        ariaLabelledBy: ariaLabelledBy
    });
    var isSplitButton = Boolean(splitButtonContext);
    var isNavigationSplitButton = (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.isNavigationSplitButton) || false;
    var isDefaultAppearanceSplitButton = (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.appearance) === "default";
    var appearance = (0, $29ou0.getBooleanFF)("platform.design-system-team.component-visual-refresh_t8zbo") && isDefaultAppearanceSplitButton ? "subtle" : (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.appearance) || propAppearance;
    var spacing = (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.spacing) || propSpacing;
    var isDisabled = (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.isDisabled) || propIsDisabled;
    var hasOverlay = Boolean(overlay);
    var isInteractive = !isDisabled && !isLoading && !hasOverlay;
    var isEffectivelyDisabled = isDisabled || Boolean(overlay);
    var isSelected = propIsSelected && !isDisabled;
    (0, $gMIYi.default)(localRef, autoFocus);
    return $c4d10a4bbd1b1688$var$_objectSpread({
        ref: (0, $2Dg3J.default)([
            localRef,
            ref
        ]),
        xcss: [
            (0, $29ou0.getBooleanFF)("platform.design-system-team.button-tokenised-typography-styles") ? $c4d10a4bbd1b1688$var$tokenizedButtonStyles : $c4d10a4bbd1b1688$var$hardCodedButtonStyles,
            $c4d10a4bbd1b1688$var$buttonStyles,
            appearance === "default" && ((0, $29ou0.getBooleanFF)("platform.design-system-team.component-visual-refresh_t8zbo") ? $c4d10a4bbd1b1688$var$defaultRefreshedStyles : $c4d10a4bbd1b1688$var$defaultStyles),
            appearance === "default" && isInteractive && ((0, $29ou0.getBooleanFF)("platform.design-system-team.component-visual-refresh_t8zbo") ? $c4d10a4bbd1b1688$var$defaultInteractiveRefreshedStyles : $c4d10a4bbd1b1688$var$defaultInteractiveStyles),
            appearance === "primary" && $c4d10a4bbd1b1688$var$primaryStyles,
            appearance === "primary" && isInteractive && $c4d10a4bbd1b1688$var$primaryInteractiveStyles,
            appearance === "warning" && $c4d10a4bbd1b1688$var$warningStyles,
            appearance === "warning" && isInteractive && $c4d10a4bbd1b1688$var$warningInteractiveStyles,
            appearance === "danger" && $c4d10a4bbd1b1688$var$dangerStyles,
            appearance === "danger" && isInteractive && $c4d10a4bbd1b1688$var$dangerInteractiveStyles,
            appearance === "discovery" && $c4d10a4bbd1b1688$var$discoveryStyles,
            appearance === "discovery" && isInteractive && $c4d10a4bbd1b1688$var$discoveryInteractiveStyles,
            appearance === "subtle" && ((0, $29ou0.getBooleanFF)("platform.design-system-team.component-visual-refresh_t8zbo") ? $c4d10a4bbd1b1688$var$subtleRefreshedStyles : $c4d10a4bbd1b1688$var$subtleStyles),
            appearance === "subtle" && isInteractive && ((0, $29ou0.getBooleanFF)("platform.design-system-team.component-visual-refresh_t8zbo") ? $c4d10a4bbd1b1688$var$subtleInteractiveRefreshedStyles : $c4d10a4bbd1b1688$var$subtleInteractiveStyles),
            appearance === "link" && $c4d10a4bbd1b1688$var$linkStyles,
            appearance === "subtle-link" && $c4d10a4bbd1b1688$var$subtleLinkStyles,
            !isSelected && (appearance === "link" || appearance === "subtle-link") ? $c4d10a4bbd1b1688$var$linkDecorationStyles : $c4d10a4bbd1b1688$var$linkDecorationUnsetStyles,
            isSelected && ((0, $29ou0.getBooleanFF)("platform.design-system-team.component-visual-refresh_t8zbo") ? $c4d10a4bbd1b1688$var$selectedRefreshedStyles : $c4d10a4bbd1b1688$var$selectedStyles),
            isSelected && isInteractive && $c4d10a4bbd1b1688$var$selectedInteractiveStyles,
            // TODO: remove me once we kill color fallbacks
            isSelected && appearance === "danger" && $c4d10a4bbd1b1688$var$selectedDangerStyles,
            // TODO: remove me once we kill color fallbacks
            isSelected && appearance === "warning" && $c4d10a4bbd1b1688$var$selectedWarningStyles,
            // TODO: remove me once we kill color fallbacks
            isSelected && appearance === "discovery" && $c4d10a4bbd1b1688$var$selectedDiscoveryStyles,
            isDisabled && $c4d10a4bbd1b1688$var$disabledStyles,
            isCircle && !isSplitButton && $c4d10a4bbd1b1688$var$circleStyles,
            spacing === "compact" && $c4d10a4bbd1b1688$var$spacingCompactStyles,
            spacing === "compact" && ((0, $29ou0.getBooleanFF)("platform.design-system-team.button-tokenised-typography-styles") ? $c4d10a4bbd1b1688$var$tokenizedSpacingCompactStyles : $c4d10a4bbd1b1688$var$baseSpacingCompactStyles),
            spacing === "none" && $c4d10a4bbd1b1688$var$spacingNoneStyles,
            spacing === "none" && (0, $29ou0.getBooleanFF)("platform.design-system-team.button-tokenised-typography-styles") && $c4d10a4bbd1b1688$var$tokenizedSpacingNoneStyles,
            spacing !== "none" && hasIconBefore && $c4d10a4bbd1b1688$var$buttonIconBeforeStyles,
            spacing !== "none" && hasIconAfter && $c4d10a4bbd1b1688$var$buttonIconAfterStyles,
            isIconButton && $c4d10a4bbd1b1688$var$iconButtonStyles,
            isIconButton && spacing === "compact" && $c4d10a4bbd1b1688$var$iconButtonCompactStyles,
            shouldFitContainer && $c4d10a4bbd1b1688$var$fullWidthStyles,
            isLoading && $c4d10a4bbd1b1688$var$loadingOverlayStyles,
            (isDisabled || hasOverlay && !isLoading) && $c4d10a4bbd1b1688$var$nonInteractiveStyles,
            isSplitButton && $c4d10a4bbd1b1688$var$splitButtonStyles,
            isNavigationSplitButton && $c4d10a4bbd1b1688$var$navigationSplitButtonStyles
        ],
        // Consider overlay buttons to be effectively disabled
        isDisabled: isEffectivelyDisabled,
        children: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $dAx5m.Fragment), null, children, overlay ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $cihAo.default), {
            as: "span",
            xcss: $c4d10a4bbd1b1688$var$overlayStyles
        }, overlay) : null, isLoading && (children && !ariaLabel && !ariaLabelledBy || ariaLabelledBy) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $ez4n6.default), {
            id: loadingLabelId
        }, ", Loading")),
        "aria-label": isLoading && ariaLabel && !ariaLabelledBy ? "".concat(ariaLabel, " ").concat((0, $jTObE.LOADING_LABEL)) : ariaLabel,
        "aria-labelledby": isLoading && ariaLabelledBy ? "".concat(ariaLabelledBy, " ").concat(loadingLabelId) : ariaLabelledBy
    }, (0, $bmXnN.default)(isEffectivelyDisabled, {
        onClick: onClick,
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onTouchStartCapture: onTouchStartCapture,
        onTouchEndCapture: onTouchEndCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onClickCapture: onClickCapture
    }));
};
var $c4d10a4bbd1b1688$export$2e2bcd8739ae039 = $c4d10a4bbd1b1688$var$useButtonBase;

});
parcelRegister("d0MiN", function(module, exports) {

$parcel$export(module.exports, "R500", function () { return $9790be4453d154f9$export$2837b5a1a71d5c02; });
$parcel$export(module.exports, "Y400", function () { return $9790be4453d154f9$export$59619663aa6500fb; });
$parcel$export(module.exports, "B75", function () { return $9790be4453d154f9$export$8c13c2ee36917869; });
$parcel$export(module.exports, "B200", function () { return $9790be4453d154f9$export$215b7063051591f1; });
$parcel$export(module.exports, "B300", function () { return $9790be4453d154f9$export$e62e8919cca44969; });
$parcel$export(module.exports, "B400", function () { return $9790be4453d154f9$export$b3de0ae08da2ce64; });
$parcel$export(module.exports, "N10", function () { return $9790be4453d154f9$export$e655ef011c4aa1a2; });
$parcel$export(module.exports, "N20", function () { return $9790be4453d154f9$export$9fdfb749e33cdf97; });
$parcel$export(module.exports, "N40", function () { return $9790be4453d154f9$export$1ce2d1575d444ceb; });
$parcel$export(module.exports, "N90", function () { return $9790be4453d154f9$export$7c87d337fb91a97d; });
$parcel$export(module.exports, "N100", function () { return $9790be4453d154f9$export$d6447c357493214f; });
$parcel$export(module.exports, "N200", function () { return $9790be4453d154f9$export$f563ee71e9ee74cd; });
$parcel$export(module.exports, "N400", function () { return $9790be4453d154f9$export$eece5f492e429f08; });
$parcel$export(module.exports, "N500", function () { return $9790be4453d154f9$export$c39c0fe0f26207ae; });
$parcel$export(module.exports, "N700", function () { return $9790be4453d154f9$export$ad0bacf983b7ddaa; });
$parcel$export(module.exports, "N800", function () { return $9790be4453d154f9$export$7d61b15e0da132af; });
$parcel$export(module.exports, "N20A", function () { return $9790be4453d154f9$export$8d43898f60b96a82; });
$parcel$export(module.exports, "N30A", function () { return $9790be4453d154f9$export$920c0d5c49070351; });
$parcel$export(module.exports, "skeleton", function () { return $9790be4453d154f9$export$2a0674ff2eb10214; });
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ 
var $8ccV9 = parcelRequire("8ccV9");
var $9790be4453d154f9$export$4b84fd0e2c617bd = "#FFEBE6";
var $9790be4453d154f9$export$b34b069eff244586 = "#FFBDAD";
var $9790be4453d154f9$export$be802dd0d8b57f35 = "#FF8F73";
var $9790be4453d154f9$export$60847d42f9da92a6 = "#FF7452";
var $9790be4453d154f9$export$4a7404f376229999 = "#FF5630";
var $9790be4453d154f9$export$2010d0fb4295b346 = "#DE350B";
var $9790be4453d154f9$export$2837b5a1a71d5c02 = "#BF2600";
var $9790be4453d154f9$export$8d9596b529bbb9cf = "#FFFAE6";
var $9790be4453d154f9$export$41060a744ab0b7ae = "#FFF0B3";
var $9790be4453d154f9$export$1cc05bbbf340e559 = "#FFE380";
var $9790be4453d154f9$export$5aae31392d72caaa = "#FFC400";
var $9790be4453d154f9$export$c6930421db9fa514 = "#FFAB00";
var $9790be4453d154f9$export$59619663aa6500fb = "#FF991F";
var $9790be4453d154f9$export$874739ea9e379ab6 = "#FF8B00";
var $9790be4453d154f9$export$8a6341c32b6a3ee6 = "#E3FCEF";
var $9790be4453d154f9$export$69a3bf21b9686c2b = "#ABF5D1";
var $9790be4453d154f9$export$afbce1382ec95f73 = "#79F2C0";
var $9790be4453d154f9$export$747d86715d4175de = "#57D9A3";
var $9790be4453d154f9$export$940e1f69e873f202 = "#36B37E";
var $9790be4453d154f9$export$a49394138f7b8e85 = "#00875A";
var $9790be4453d154f9$export$6fa04827ac68a4fb = "#006644";
var $9790be4453d154f9$export$226de0355ed012f8 = "#DEEBFF";
var $9790be4453d154f9$export$8c13c2ee36917869 = "#B3D4FF";
var $9790be4453d154f9$export$ecfc1dff386a3e7a = "#4C9AFF";
var $9790be4453d154f9$export$215b7063051591f1 = "#2684FF";
var $9790be4453d154f9$export$e62e8919cca44969 = "#0065FF";
var $9790be4453d154f9$export$b3de0ae08da2ce64 = "#0052CC";
var $9790be4453d154f9$export$a6ee3d71bc067634 = "#0747A6";
var $9790be4453d154f9$export$363e4475840015bb = "#EAE6FF";
var $9790be4453d154f9$export$4b0a4417ed59760f = "#C0B6F2";
var $9790be4453d154f9$export$6011520a64d9a187 = "#998DD9";
var $9790be4453d154f9$export$a7175d4e9206bc80 = "#8777D9";
var $9790be4453d154f9$export$b48405b95304b5a1 = "#6554C0";
var $9790be4453d154f9$export$c71e4279dd54a18d = "#5243AA";
var $9790be4453d154f9$export$147899de772240ec = "#403294";
var $9790be4453d154f9$export$2cf711fe14c66f06 = "#E6FCFF";
var $9790be4453d154f9$export$7a8f4d33f6f9772c = "#B3F5FF";
var $9790be4453d154f9$export$776c9c497ef08533 = "#79E2F2";
var $9790be4453d154f9$export$69cb3ca10c1e330e = "#00C7E6";
var $9790be4453d154f9$export$9dc1ef0f3f48059b = "#00B8D9";
var $9790be4453d154f9$export$7c835c78b6fcdef8 = "#00A3BF";
var $9790be4453d154f9$export$6036577f95c3877e = "#008DA6";
var $9790be4453d154f9$export$29a4f05edc054374 = "#FFFFFF";
var $9790be4453d154f9$export$e655ef011c4aa1a2 = "#FAFBFC";
var $9790be4453d154f9$export$9fdfb749e33cdf97 = "#F4F5F7";
var $9790be4453d154f9$export$3e51e8f1440314ba = "#EBECF0";
var $9790be4453d154f9$export$1ce2d1575d444ceb = "#DFE1E6";
var $9790be4453d154f9$export$8754fc7e6d8b3000 = "#C1C7D0";
var $9790be4453d154f9$export$c2e91cbeada39b8b = "#B3BAC5";
var $9790be4453d154f9$export$5f71e19f3a7ad9de = "#A5ADBA";
var $9790be4453d154f9$export$eaa8c8a70ac22806 = "#97A0AF";
var $9790be4453d154f9$export$7c87d337fb91a97d = "#8993A4";
var $9790be4453d154f9$export$d6447c357493214f = "#7A869A";
var $9790be4453d154f9$export$f563ee71e9ee74cd = "#6B778C";
var $9790be4453d154f9$export$e2ef2124cf4024b1 = "#5E6C84";
var $9790be4453d154f9$export$eece5f492e429f08 = "#505F79";
var $9790be4453d154f9$export$c39c0fe0f26207ae = "#42526E";
var $9790be4453d154f9$export$7090862dc3038a9f = "#344563";
var $9790be4453d154f9$export$ad0bacf983b7ddaa = "#253858";
var $9790be4453d154f9$export$7d61b15e0da132af = "#172B4D";
var $9790be4453d154f9$export$fbda843f0a27fe96 = "#091E42";
var $9790be4453d154f9$export$791e57b27ca738ef = "rgba(9, 30, 66, 0.02)";
var $9790be4453d154f9$export$8d43898f60b96a82 = "rgba(9, 30, 66, 0.04)";
var $9790be4453d154f9$export$920c0d5c49070351 = "rgba(9, 30, 66, 0.08)";
var $9790be4453d154f9$export$46987b49aab6d1a8 = "rgba(9, 30, 66, 0.13)";
var $9790be4453d154f9$export$7d3359664e8bb0e5 = "rgba(9, 30, 66, 0.25)";
var $9790be4453d154f9$export$d2d3bedfb276cac0 = "rgba(9, 30, 66, 0.31)";
var $9790be4453d154f9$export$6e5e7499ff054f6d = "rgba(9, 30, 66, 0.36)";
var $9790be4453d154f9$export$59264b346c877fa7 = "rgba(9, 30, 66, 0.42)";
var $9790be4453d154f9$export$d092757d7c64925c = "rgba(9, 30, 66, 0.48)";
var $9790be4453d154f9$export$486ab785e4bac3c6 = "rgba(9, 30, 66, 0.54)";
var $9790be4453d154f9$export$fba592bbc6419fea = "rgba(9, 30, 66, 0.60)";
var $9790be4453d154f9$export$13609db0e6812ab8 = "rgba(9, 30, 66, 0.66)";
var $9790be4453d154f9$export$fbae4efaa892d883 = "rgba(9, 30, 66, 0.71)";
var $9790be4453d154f9$export$f13946d26f440ce6 = "rgba(9, 30, 66, 0.77)";
var $9790be4453d154f9$export$19f58225ac52a306 = "rgba(9, 30, 66, 0.82)";
var $9790be4453d154f9$export$6384f09da70e7b62 = "rgba(9, 30, 66, 0.89)";
var $9790be4453d154f9$export$d0dccc730683edc2 = "rgba(9, 30, 66, 0.95)";
var $9790be4453d154f9$export$2f6319cf7d736c2a = "#E6EDFA";
var $9790be4453d154f9$export$95126bc8884d6634 = "#DCE5F5";
var $9790be4453d154f9$export$8338d8c35d44ff1 = "#CED9EB";
var $9790be4453d154f9$export$5368d76ae4fbbda7 = "#B8C7E0";
var $9790be4453d154f9$export$9f0a771d16ec8d36 = "#ABBBD6";
var $9790be4453d154f9$export$abcf8c38338b4aa5 = "#9FB0CC";
var $9790be4453d154f9$export$97e81faa16a182c7 = "#8C9CB8";
var $9790be4453d154f9$export$bfe21c59123ecf33 = "#7988A3";
var $9790be4453d154f9$export$ee82aa2ea6a1558 = "#67758F";
var $9790be4453d154f9$export$682927c6ed76be02 = "#56637A";
var $9790be4453d154f9$export$91fd9994c5be9757 = "#455166";
var $9790be4453d154f9$export$d281fbfe3cff2df6 = "#3B475C";
var $9790be4453d154f9$export$3902c91d8b98a753 = "#313D52";
var $9790be4453d154f9$export$8e8133c1ba5845b5 = "#283447";
var $9790be4453d154f9$export$33ff357f6620b39 = "#202B3D";
var $9790be4453d154f9$export$633847cf062b69e0 = "#1B2638";
var $9790be4453d154f9$export$9776a6e503bdbf76 = "#121A29";
var $9790be4453d154f9$export$6c813d5160dff5db = "#0E1624";
var $9790be4453d154f9$export$3d4f271a500072a = "#0D1424";
var $9790be4453d154f9$export$fe151285c22759ec = "rgba(13, 20, 36, 0.06)";
var $9790be4453d154f9$export$a101c6190d0da34 = "rgba(13, 20, 36, 0.14)";
var $9790be4453d154f9$export$4b16f52932fda51 = "rgba(13, 20, 36, 0.18)";
var $9790be4453d154f9$export$a74bcd7b9845b0d8 = "rgba(13, 20, 36, 0.29)";
var $9790be4453d154f9$export$9209c179316d1751 = "rgba(13, 20, 36, 0.36)";
var $9790be4453d154f9$export$88f55133f636c8dd = "rgba(13, 20, 36, 0.40)";
var $9790be4453d154f9$export$51126f85d1009512 = "rgba(13, 20, 36, 0.47)";
var $9790be4453d154f9$export$a069b547bd23af78 = "rgba(13, 20, 36, 0.53)";
var $9790be4453d154f9$export$40cce05af3b2600a = "rgba(13, 20, 36, 0.63)";
var $9790be4453d154f9$export$b78942185925a0d = "rgba(13, 20, 36, 0.73)";
var $9790be4453d154f9$export$e058fb44b8eaafca = "rgba(13, 20, 36, 0.78)";
var $9790be4453d154f9$export$92b0b8de26920c18 = "rgba(13, 20, 36, 0.81)";
var $9790be4453d154f9$export$67564f7459d3fc9e = "rgba(13, 20, 36, 0.85)";
var $9790be4453d154f9$export$77868e1ca884ffa3 = "rgba(13, 20, 36, 0.89)";
var $9790be4453d154f9$export$2afd71d7d3ea2cd5 = "rgba(13, 20, 36, 0.92)";
var $9790be4453d154f9$export$f2a0acaab9972c70 = "rgba(13, 20, 36, 0.95)";
var $9790be4453d154f9$export$9ab70e67d6475361 = "rgba(13, 20, 36, 0.97)";
var $9790be4453d154f9$export$8ce1fd94bee2f412 = (0, $8ccV9.default)({
    light: "var(--ds-surface, ".concat($9790be4453d154f9$export$29a4f05edc054374, ")"),
    dark: "var(--ds-surface, ".concat($9790be4453d154f9$export$633847cf062b69e0, ")")
});
var $9790be4453d154f9$export$b861914ea877b580 = (0, $8ccV9.default)({
    light: "var(--ds-background-selected, ".concat($9790be4453d154f9$export$226de0355ed012f8, ")"),
    dark: "var(--ds-background-selected, ".concat($9790be4453d154f9$export$8c13c2ee36917869, ")")
});
var $9790be4453d154f9$export$3f1b020df94387af = (0, $8ccV9.default)({
    light: "var(--ds-background-neutral-hovered, ".concat($9790be4453d154f9$export$3e51e8f1440314ba, ")"),
    dark: "var(--ds-background-neutral-hovered, ".concat($9790be4453d154f9$export$d281fbfe3cff2df6, ")")
});
var $9790be4453d154f9$export$c0183dbab98ca63e = (0, $8ccV9.default)({
    light: "var(--ds-surface-overlay, ".concat($9790be4453d154f9$export$29a4f05edc054374, ")"),
    dark: "var(--ds-surface-overlay, ".concat($9790be4453d154f9$export$8e8133c1ba5845b5, ")")
});
var $9790be4453d154f9$export$6f093cfa640b7166 = (0, $8ccV9.default)({
    light: "var(--ds-text, ".concat($9790be4453d154f9$export$fbda843f0a27fe96, ")"),
    dark: "var(--ds-text, ".concat($9790be4453d154f9$export$5368d76ae4fbbda7, ")")
});
var $9790be4453d154f9$export$42f8e9c698766e7a = (0, $8ccV9.default)({
    light: "var(--ds-text, ".concat($9790be4453d154f9$export$7d61b15e0da132af, ")"),
    dark: "var(--ds-text, ".concat($9790be4453d154f9$export$5368d76ae4fbbda7, ")")
});
var $9790be4453d154f9$export$c2d157ca1c34b6e3 = (0, $8ccV9.default)({
    light: "var(--ds-text-selected, ".concat($9790be4453d154f9$export$b3de0ae08da2ce64, ")"),
    dark: "var(--ds-text-selected, ".concat($9790be4453d154f9$export$b3de0ae08da2ce64, ")")
});
var $9790be4453d154f9$export$1905ba28d7cf066f = (0, $8ccV9.default)({
    light: "var(--ds-text-subtlest, ".concat($9790be4453d154f9$export$f563ee71e9ee74cd, ")"),
    dark: "var(--ds-text-subtlest, ".concat($9790be4453d154f9$export$97e81faa16a182c7, ")")
});
var $9790be4453d154f9$export$bd9002130d306d39 = (0, $8ccV9.default)({
    light: "var(--ds-text-subtlest, ".concat($9790be4453d154f9$export$f563ee71e9ee74cd, ")"),
    dark: "var(--ds-text-subtlest, ".concat($9790be4453d154f9$export$bfe21c59123ecf33, ")")
});
var $9790be4453d154f9$export$46e4a324ac90507f = (0, $8ccV9.default)({
    light: "var(--ds-text, ".concat($9790be4453d154f9$export$7d61b15e0da132af, ")"),
    dark: "var(--ds-text, ".concat($9790be4453d154f9$export$5368d76ae4fbbda7, ")")
});
var $9790be4453d154f9$export$79f3f2b82beb0d36 = (0, $8ccV9.default)({
    light: "var(--ds-text-subtlest, ".concat($9790be4453d154f9$export$f563ee71e9ee74cd, ")"),
    dark: "var(--ds-text-subtlest, ".concat($9790be4453d154f9$export$97e81faa16a182c7, ")")
});
var $9790be4453d154f9$export$7bb0d5c671655cc4 = (0, $8ccV9.default)({
    light: $9790be4453d154f9$export$9fdfb749e33cdf97,
    dark: $9790be4453d154f9$export$8e8133c1ba5845b5
});
var $9790be4453d154f9$export$9c30223ca0a664fb = (0, $8ccV9.default)({
    light: "var(--ds-link, ".concat($9790be4453d154f9$export$b3de0ae08da2ce64, ")"),
    dark: "var(--ds-link, ".concat($9790be4453d154f9$export$ecfc1dff386a3e7a, ")")
});
var $9790be4453d154f9$export$7ed258b0728b004b = (0, $8ccV9.default)({
    light: "var(--ds-link-pressed, ".concat($9790be4453d154f9$export$e62e8919cca44969, ")"),
    dark: "var(--ds-link-pressed, ".concat($9790be4453d154f9$export$215b7063051591f1, ")")
});
var $9790be4453d154f9$export$dfa920d8decc8a59 = (0, $8ccV9.default)({
    light: "var(--ds-link-pressed, ".concat($9790be4453d154f9$export$a6ee3d71bc067634, ")"),
    dark: "var(--ds-link-pressed, ".concat($9790be4453d154f9$export$ecfc1dff386a3e7a, ")")
});
var $9790be4453d154f9$export$6069e6ad5c78f632 = (0, $8ccV9.default)({
    light: "var(--ds-border-focused, ".concat($9790be4453d154f9$export$215b7063051591f1, ")"),
    dark: "var(--ds-border-focused, ".concat($9790be4453d154f9$export$215b7063051591f1, ")")
});
var $9790be4453d154f9$export$9ad721cf3b3debe0 = (0, $8ccV9.default)({
    light: "var(--ds-background-brand-bold, ".concat($9790be4453d154f9$export$b3de0ae08da2ce64, ")"),
    dark: "var(--ds-background-brand-bold, ".concat($9790be4453d154f9$export$ecfc1dff386a3e7a, ")")
});
var $9790be4453d154f9$export$2aa0182783e7e9de = (0, $8ccV9.default)({
    light: $9790be4453d154f9$export$b3de0ae08da2ce64,
    dark: $9790be4453d154f9$export$ecfc1dff386a3e7a
});
var $9790be4453d154f9$export$8bf7dff220b82b4a = (0, $8ccV9.default)({
    light: $9790be4453d154f9$export$9dc1ef0f3f48059b,
    dark: $9790be4453d154f9$export$69cb3ca10c1e330e
});
var $9790be4453d154f9$export$e13cce2a2d16a9d4 = (0, $8ccV9.default)({
    light: $9790be4453d154f9$export$b48405b95304b5a1,
    dark: $9790be4453d154f9$export$6011520a64d9a187
});
var $9790be4453d154f9$export$a90204d1394caf30 = (0, $8ccV9.default)({
    light: $9790be4453d154f9$export$4a7404f376229999,
    dark: $9790be4453d154f9$export$4a7404f376229999
});
var $9790be4453d154f9$export$594c5a8758200c32 = (0, $8ccV9.default)({
    light: $9790be4453d154f9$export$c6930421db9fa514,
    dark: $9790be4453d154f9$export$c6930421db9fa514
});
var $9790be4453d154f9$export$955a2ebd2fb142ae = (0, $8ccV9.default)({
    light: $9790be4453d154f9$export$940e1f69e873f202,
    dark: $9790be4453d154f9$export$940e1f69e873f202
});
var $9790be4453d154f9$export$2a0674ff2eb10214 = function skeleton() {
    return "var(--ds-skeleton, ".concat($9790be4453d154f9$export$8d43898f60b96a82, ")");
};

});
parcelRegister("8ccV9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5f797784685bb57b$export$2e2bcd8739ae039; });
/* eslint-disable prefer-rest-params */ 
var $e2JSk = parcelRequire("e2JSk");
// Unpack custom variants, and get correct value for the current theme
function $5f797784685bb57b$var$themedVariants(variantProp, variants) {
    return function(props) {
        var theme = (0, $e2JSk.default)(props);
        if (props && props[variantProp] && variants) {
            var modes = variants[props[variantProp]];
            if (modes && modes[theme.mode]) {
                var value = modes[theme.mode];
                if (value) return value;
                 // TS believes value can be undefined
            }
        }
        return "";
    };
}
function $5f797784685bb57b$export$2e2bcd8739ae039(modesOrVariant, variantModes) {
    if (typeof modesOrVariant === "string") return $5f797784685bb57b$var$themedVariants(modesOrVariant, variantModes);
    var modes = modesOrVariant;
    return function(props) {
        // Get theme from the user's props
        var theme = (0, $e2JSk.default)(props);
        // User isn't required to provide both light and dark values
        if (theme.mode in modes) {
            var value = modes[theme.mode]; // TS believes value can be undefined
            if (value) return value;
        }
        return "";
    };
}

});
parcelRegister("e2JSk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a394d67c4633d747$export$2e2bcd8739ae039; });

var $7yUTl = parcelRequire("7yUTl");
function $a394d67c4633d747$export$2e2bcd8739ae039(props) {
    if (props && props.theme) {
        // Theme is the global Atlaskit theme
        if ((0, $7yUTl.CHANNEL) in props.theme) return props.theme[0, $7yUTl.CHANNEL];
        else if ("mode" in props.theme && (0, $7yUTl.THEME_MODES).includes(props.theme.mode)) return props.theme;
    }
    // If format not supported (or no theme provided), return standard theme
    return {
        mode: (0, $7yUTl.DEFAULT_THEME_MODE)
    };
}

});
parcelRegister("7yUTl", function(module, exports) {

$parcel$export(module.exports, "CHANNEL", function () { return $5817d6e272b36eac$export$44ffba16bd48dac6; });
$parcel$export(module.exports, "DEFAULT_THEME_MODE", function () { return $5817d6e272b36eac$export$c93026a968943f95; });
$parcel$export(module.exports, "THEME_MODES", function () { return $5817d6e272b36eac$export$6ba72c8346b4c57e; });
$parcel$export(module.exports, "gridSize", function () { return $5817d6e272b36eac$export$6d8204c2cb2e06b8; });
$parcel$export(module.exports, "layers", function () { return $5817d6e272b36eac$export$7be255094ccdc533; });

var $e2xkU = parcelRequire("e2xkU");

var $d0MiN = parcelRequire("d0MiN");
var $5817d6e272b36eac$export$44ffba16bd48dac6 = "__ATLASKIT_THEME__";
var $5817d6e272b36eac$export$c93026a968943f95 = "light";
var $5817d6e272b36eac$export$6ba72c8346b4c57e = [
    "light",
    "dark"
];
var $5817d6e272b36eac$export$7a57f79000377ca2 = function borderRadius() {
    return 3;
};
var $5817d6e272b36eac$export$6d8204c2cb2e06b8 = function gridSize() {
    return 8;
};
var $5817d6e272b36eac$export$85e3c3ca0c6fb93 = function fontSize() {
    return 14;
};
var $5817d6e272b36eac$export$6746fe0d9c9fab54 = function fontSizeSmall() {
    return 11;
};
var $5817d6e272b36eac$export$a5975749f0374264 = function fontFamily() {
    return "-apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif";
};
var $5817d6e272b36eac$export$356129969ee49c55 = function codeFontFamily() {
    return "'SFMono-Medium', 'SF Mono', 'Segoe UI Mono', 'Roboto Mono', 'Ubuntu Mono', Menlo, Consolas, Courier, monospace";
};
var $5817d6e272b36eac$export$8e24544ddba725ee = function focusRing() {
    var color = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "var(--ds-border-focused, ".concat((0, $d0MiN.B200), ")");
    var outlineWidth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $5817d6e272b36eac$export$6d8204c2cb2e06b8() / 4;
    (0, $e2xkU.default)("@atlaskit/theme", "focus ring mixin", "Please use `@atlaskit/focus-ring` instead.");
    return "\n  &:focus {\n    outline: none;\n    box-shadow: 0px 0px 0px ".concat(outlineWidth, "px ").concat(color, ";\n  }\n");
};
var $5817d6e272b36eac$export$c0dd343266bc3261 = function noFocusRing() {
    return "\n  box-shadow: none;\n";
};
var $5817d6e272b36eac$export$7be255094ccdc533 = {
    card: function card() {
        return 100;
    },
    navigation: function navigation() {
        return 200;
    },
    dialog: function dialog() {
        return 300;
    },
    layer: function layer() {
        return 400;
    },
    blanket: function blanket() {
        return 500;
    },
    modal: function modal() {
        return 510;
    },
    flag: function flag() {
        return 600;
    },
    spotlight: function spotlight() {
        return 700;
    },
    tooltip: function tooltip() {
        return 9999;
    }
};
var $5817d6e272b36eac$export$a1b3edb637fb4f35 = function visuallyHidden() {
    (0, $e2xkU.default)("@atlaskit/theme", "visually hidden mixin", "Please use `@atlaskit/visually-hidden` instead.");
    return {
        border: "0 !important",
        clip: "rect(1px, 1px, 1px, 1px) !important",
        height: "1px !important",
        overflow: "hidden !important",
        padding: "0 !important",
        position: "absolute !important",
        width: "1px !important",
        whiteSpace: "nowrap !important"
    };
};
var $5817d6e272b36eac$export$ba1d834b86d72a09 = $5817d6e272b36eac$export$a1b3edb637fb4f35;
var $5817d6e272b36eac$export$e497e856b4f89fcd = function skeletonShimmer() {
    return {
        css: {
            backgroundColor: "var(--ds-skeleton, ".concat((0, $d0MiN.skeleton)(), ")"),
            animationDuration: "1.5s",
            animationIterationCount: "infinite",
            animationTimingFunction: "linear",
            animationDirection: "alternate"
        },
        keyframes: {
            from: {
                backgroundColor: "var(--ds-skeleton, ".concat((0, $d0MiN.skeleton)(), ")")
            },
            to: {
                backgroundColor: "var(--ds-skeleton-subtle, ".concat((0, $d0MiN.N30A), ")")
            }
        }
    };
};

});




parcelRegister("lmtlU", function(module, exports) {

$parcel$export(module.exports, "useSplitButtonContext", function () { return $f8d26bd543069eb7$export$47e2c6fdb142d947; });

var $dAx5m = parcelRequire("dAx5m");
var $f8d26bd543069eb7$export$4b86304b2c0d7e71 = /*#__PURE__*/ (0, $dAx5m.createContext)(undefined);
var $f8d26bd543069eb7$export$47e2c6fdb142d947 = function useSplitButtonContext() {
    var context = (0, $dAx5m.useContext)($f8d26bd543069eb7$export$4b86304b2c0d7e71);
    if (!context) return undefined;
    if (context.appearance === "navigation") {
        var newContext = {
            spacing: "default",
            appearance: "subtle",
            isDisabled: false,
            isActiveOverSelected: false,
            isNavigationSplitButton: true,
            isHighlighted: context.isHighlighted
        };
        return newContext;
    }
    var splitButtonContext = {
        spacing: context.spacing,
        appearance: context.appearance,
        isDisabled: context.isDisabled,
        isActiveOverSelected: true,
        isNavigationSplitButton: false,
        isHighlighted: false
    };
    return splitButtonContext;
};

});

parcelRegister("bmXnN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $846fcff96dec3426$export$2e2bcd8739ae039; });
function $846fcff96dec3426$var$abort(event) {
    event.preventDefault();
    event.stopPropagation();
}
var $846fcff96dec3426$var$tabKeyCode = 9;
function $846fcff96dec3426$var$onKey(event) {
    // Allowing tab so that a user can move focus away
    if (event.keyCode === $846fcff96dec3426$var$tabKeyCode) return;
    $846fcff96dec3426$var$abort(event);
}
function $846fcff96dec3426$export$2e2bcd8739ae039(shouldBlockEvents, events) {
    return shouldBlockEvents ? {
        onMouseDownCapture: $846fcff96dec3426$var$abort,
        onMouseUpCapture: $846fcff96dec3426$var$abort,
        onKeyDownCapture: $846fcff96dec3426$var$onKey,
        onKeyUpCapture: $846fcff96dec3426$var$onKey,
        onTouchStartCapture: $846fcff96dec3426$var$abort,
        onTouchEndCapture: $846fcff96dec3426$var$abort,
        onPointerDownCapture: $846fcff96dec3426$var$abort,
        onPointerUpCapture: $846fcff96dec3426$var$abort,
        onClickCapture: $846fcff96dec3426$var$abort,
        // Just smashing the existing onClick for good measure
        onClick: $846fcff96dec3426$var$abort
    } : events;
}

});

parcelRegister("jTObE", function(module, exports) {

$parcel$export(module.exports, "LOADING_LABEL", function () { return $e7ca156e1d730b1d$export$d4c5499dc806c969; });
var $e7ca156e1d730b1d$export$d4c5499dc806c969 = ", Loading";

});




parcelRegister("4Xq7n", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $39c0ee971a4a96ad$export$2e2bcd8739ae039; });

var $gsBGP = parcelRequire("gsBGP");

var $dAx5m = parcelRequire("dAx5m");
function $39c0ee971a4a96ad$export$2e2bcd8739ae039(propValue) {
    var getDefaultPropValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function() {
        return propValue;
    };
    var isControlled = propValue !== undefined;
    var _useState = (0, $dAx5m.useState)(getDefaultPropValue), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($gsBGP)))(_useState, 2), valueState = _useState2[0], setValue = _useState2[1];
    var isControlledRef = (0, $dAx5m.useRef)(isControlled);
    (0, $dAx5m.useEffect)(function() {
        isControlledRef.current = isControlled;
    }, [
        isControlled
    ]);
    var value = isControlled ? propValue : valueState;
    var setValueIfUncontrolled = (0, $dAx5m.useCallback)(function(newValue) {
        if (!isControlledRef.current) setValue(newValue);
    }, []);
    return [
        value,
        setValueIfUncontrolled
    ];
}

});
parcelRegister("gsBGP", function(module, exports) {

var $fmFlC = parcelRequire("fmFlC");

var $6EoUV = parcelRequire("6EoUV");

var $hWg31 = parcelRequire("hWg31");

var $gSIOI = parcelRequire("gSIOI");
function $bfbc7f4682b62ea7$var$_slicedToArray(r, e) {
    return $fmFlC(r) || $6EoUV(r, e) || $hWg31(r, e) || $gSIOI();
}
module.exports = $bfbc7f4682b62ea7$var$_slicedToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("fmFlC", function(module, exports) {
function $b2f8fbe601a1cb67$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
module.exports = $b2f8fbe601a1cb67$var$_arrayWithHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("6EoUV", function(module, exports) {
function $4d79ce86f68cc806$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
module.exports = $4d79ce86f68cc806$var$_iterableToArrayLimit, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("hWg31", function(module, exports) {

var $jgHmy = parcelRequire("jgHmy");
function $d0f44d3387029e40$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $jgHmy(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $jgHmy(r, a) : void 0;
    }
}
module.exports = $d0f44d3387029e40$var$_unsupportedIterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("jgHmy", function(module, exports) {
function $e07125e3c320700d$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
module.exports = $e07125e3c320700d$var$_arrayLikeToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("gSIOI", function(module, exports) {
function $c4a4743a263f7a7f$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
module.exports = $c4a4743a263f7a7f$var$_nonIterableRest, module.exports.__esModule = true, module.exports["default"] = module.exports;

});



parcelRegister("kzmLI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ef98bce0dbf645af$export$2e2bcd8739ae039; });

var $gsBGP = parcelRequire("gsBGP");

var $dAx5m = parcelRequire("dAx5m");
function $ef98bce0dbf645af$export$2e2bcd8739ae039() {
    var _useState = (0, $dAx5m.useState)(false), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($gsBGP)))(_useState, 2), isFocused = _useState2[0], setIsFocused = _useState2[1];
    // ensure bindFocus has a stable ref
    var bindFocus = (0, $dAx5m.useRef)({
        onFocus: function onFocus() {
            return setIsFocused(true);
        },
        onBlur: function onBlur() {
            return setIsFocused(false);
        }
    });
    (0, $dAx5m.useEffect)(function() {
        // handle the case where a component might
        // unmount while being focused.
        return function() {
            return setIsFocused(false);
        };
    }, []);
    return {
        isFocused: isFocused,
        bindFocus: bindFocus.current
    };
}

});

parcelRegister("8JoMy", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $65b5bfea8acbb079$var$_react = $65b5bfea8acbb079$var$_interopRequireDefault((parcelRequire("dAx5m")));

var $buWzi = parcelRequire("buWzi");

var $65b5bfea8acbb079$var$_chevronDown = $65b5bfea8acbb079$var$_interopRequireDefault((parcelRequire("d1cEx")));
function $65b5bfea8acbb079$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $65b5bfea8acbb079$var$ChevronDownIcon = (props)=>/*#__PURE__*/ $65b5bfea8acbb079$var$_react.default.createElement($buWzi.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M8.292 10.293a1.01 1.01 0 0 0 0 1.419l2.939 2.965c.218.215.5.322.779.322s.556-.107.769-.322l2.93-2.955a1.01 1.01 0 0 0 0-1.419.987.987 0 0 0-1.406 0l-2.298 2.317-2.307-2.327a.99.99 0 0 0-1.406 0"/></svg>`
    }, props, {
        newIcon: $65b5bfea8acbb079$var$_chevronDown.default,
        iconType: "utility"
    }));
$65b5bfea8acbb079$var$ChevronDownIcon.displayName = "ChevronDownIcon";
var $65b5bfea8acbb079$var$_default = module.exports.default = $65b5bfea8acbb079$var$ChevronDownIcon;

});
parcelRegister("buWzi", function(module, exports) {

$parcel$export(module.exports, "IconFacade", function () { return $85efed7c82cccead$export$3cfb73f70dfca966; });

var $ikNYA = parcelRequire("ikNYA");

var $gd5aU = parcelRequire("gd5aU");

var $dAx5m = parcelRequire("dAx5m");

var $apoiF = parcelRequire("apoiF");

var $kSkEF = parcelRequire("kSkEF");
var $85efed7c82cccead$var$_excluded = [
    "dangerouslySetGlyph"
];
var $85efed7c82cccead$var$sizesEligibleForNewIcons = [
    "small",
    "medium"
];
var $85efed7c82cccead$export$3cfb73f70dfca966 = /*#__PURE__*/ (0, $dAx5m.memo)(function IconFacade(_ref) {
    var _props$size;
    var dangerouslySetGlyph = _ref.dangerouslySetGlyph, props = (0, (/*@__PURE__*/$parcel$interopDefault($gd5aU)))(_ref, $85efed7c82cccead$var$_excluded);
    var NewIcon = props.newIcon;
    // By default, the icon size will be medium and spacing will be none for small icons
    var size = (_props$size = props.size) !== null && _props$size !== void 0 ? _props$size : "medium";
    var spacing = size === "small" ? "none" : "spacious";
    var useNewIcon = !props.isFacadeDisabled && // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
    (0, $apoiF.fg)("platform-visual-refresh-icons-legacy-facade") && $85efed7c82cccead$var$sizesEligibleForNewIcons.includes(size);
    if (useNewIcon && NewIcon) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement(NewIcon, (0, (/*@__PURE__*/$parcel$interopDefault($ikNYA)))({}, props, {
        spacing: spacing,
        color: props.primaryColor || "currentColor",
        type: props.iconType
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $kSkEF.default), (0, (/*@__PURE__*/$parcel$interopDefault($ikNYA)))({
        dangerouslySetGlyph: dangerouslySetGlyph
    }, props));
});
var $85efed7c82cccead$export$2e2bcd8739ae039 = $85efed7c82cccead$export$3cfb73f70dfca966;

});
parcelRegister("apoiF", function(module, exports) {

$parcel$export(module.exports, "fg", function () { return $793f16ae5361f038$export$b40ec24ac8275656; });

var $1mthm = parcelRequire("1mthm");
function $793f16ae5361f038$export$ba05d765b8392e5e(flagResolver) {
    (0, $1mthm.setBooleanResolver)(flagResolver);
}
function $793f16ae5361f038$export$470e5c2be1411c89(name) {
    return (0, $1mthm.resolveBooleanFlag)(name);
}
function $793f16ae5361f038$export$b40ec24ac8275656(name) {
    return (0, $1mthm.resolveBooleanFlag)(name);
}

});
parcelRegister("1mthm", function(module, exports) {

$parcel$export(module.exports, "setBooleanResolver", function () { return $0fde8eb7ee3f3685$export$f2b591175b3e424c; });
$parcel$export(module.exports, "resolveBooleanFlag", function () { return $0fde8eb7ee3f3685$export$6333b6aff9fc6275; });

var $iFYQ9 = parcelRequire("iFYQ9");

var $ahJoN = parcelRequire("ahJoN");
var $0fde8eb7ee3f3685$var$pkgName = "@atlaskit/platform-feature-flags";
var $0fde8eb7ee3f3685$export$7e41b1b2bdee3f98 = "__PLATFORM_FEATURE_FLAGS__";
var $0fde8eb7ee3f3685$var$hasProcessEnv = typeof $ahJoN !== "undefined" && typeof $ahJoN.env !== "undefined";
// FF global overrides can be configured by test runners or Storybook
var $0fde8eb7ee3f3685$var$ENV_ENABLE_PLATFORM_FF = $0fde8eb7ee3f3685$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
// STORYBOOK_ENABLE_PLATFORM_FF is included as storybook only allows env vars prefixed with STORYBOOK
// https://github.com/storybookjs/storybook/issues/12270
var $0fde8eb7ee3f3685$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF = $0fde8eb7ee3f3685$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
var $0fde8eb7ee3f3685$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE = $0fde8eb7ee3f3685$var$ENV_ENABLE_PLATFORM_FF || $0fde8eb7ee3f3685$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF;
var $0fde8eb7ee3f3685$var$DEFAULT_PFF_GLOBAL = {
    // In development mode we want to capture any feature flag checks that happen using the default resolver and log this result when the resolver is replaced.
    // This is because evaluating feature flags when the resolver/FF client is loaded asynchronously could cause unexpected issues.
    earlyResolvedFlags: new Map(),
    booleanResolver: function booleanResolver(flagKey) {
        var unresolvedFlagCount;
        return false;
    }
};
var $0fde8eb7ee3f3685$var$globalVar = typeof window !== "undefined" ? window : globalThis;
$0fde8eb7ee3f3685$var$globalVar[$0fde8eb7ee3f3685$export$7e41b1b2bdee3f98] = $0fde8eb7ee3f3685$var$globalVar[$0fde8eb7ee3f3685$export$7e41b1b2bdee3f98] || $0fde8eb7ee3f3685$var$DEFAULT_PFF_GLOBAL;
function $0fde8eb7ee3f3685$export$f2b591175b3e424c(resolver) {
    $0fde8eb7ee3f3685$var$globalVar[$0fde8eb7ee3f3685$export$7e41b1b2bdee3f98].booleanResolver = resolver;
    var _globalVar$PFF_GLOBAL;
}
function $0fde8eb7ee3f3685$export$6333b6aff9fc6275(flagKey) {
    if ($0fde8eb7ee3f3685$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE) {
        (0, $iFYQ9.debug)('[%s]: The feature flags were enabled while running tests. The flag "%s" will be always enabled.', $0fde8eb7ee3f3685$var$pkgName, flagKey);
        return true;
    }
    try {
        var _globalVar$PFF_GLOBAL2;
        var result = (_globalVar$PFF_GLOBAL2 = $0fde8eb7ee3f3685$var$globalVar[$0fde8eb7ee3f3685$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL2 === void 0 ? void 0 : _globalVar$PFF_GLOBAL2.booleanResolver(flagKey);
        if (typeof result !== "boolean") {
            // eslint-disable-next-line no-console
            console.warn("".concat(flagKey, " resolved to a non-boolean value, returning false for safety"));
            return false;
        }
        return result;
    } catch (e) {
        return false;
    }
}

});
parcelRegister("iFYQ9", function(module, exports) {

$parcel$export(module.exports, "debug", function () { return $d98b3fe592b7b703$export$1c9f709888824e05; });
var $d98b3fe592b7b703$var$_ref, $d98b3fe592b7b703$var$_process, $d98b3fe592b7b703$var$_process2;
// We can't rely on NODE_ENV === 'test' if its value is already configured by the consumer to some other value, so better to use JEST_WORKER_ID
// https://jestjs.io/docs/environment-variables#jest_worker_id
var $d98b3fe592b7b703$var$TESTS_MODE = ($d98b3fe592b7b703$var$_ref = (globalThis === null || globalThis === void 0 || ($d98b3fe592b7b703$var$_process = globalThis.process) === null || $d98b3fe592b7b703$var$_process === void 0 || ($d98b3fe592b7b703$var$_process = $d98b3fe592b7b703$var$_process.env) === null || $d98b3fe592b7b703$var$_process === void 0 ? void 0 : $d98b3fe592b7b703$var$_process.JEST_WORKER_ID) !== undefined, $d98b3fe592b7b703$var$_ref !== void 0) ? $d98b3fe592b7b703$var$_ref : false;
var $d98b3fe592b7b703$var$DEBUG_MODE = !$d98b3fe592b7b703$var$TESTS_MODE && (globalThis === null || globalThis === void 0 || ($d98b3fe592b7b703$var$_process2 = globalThis.process) === null || $d98b3fe592b7b703$var$_process2 === void 0 || ($d98b3fe592b7b703$var$_process2 = $d98b3fe592b7b703$var$_process2.env) === null || $d98b3fe592b7b703$var$_process2 === void 0 ? void 0 : $d98b3fe592b7b703$var$_process2.NODE_ENV) !== "production";
var $d98b3fe592b7b703$export$1c9f709888824e05 = function debug() {
    var _console;
    if (!$d98b3fe592b7b703$var$DEBUG_MODE) return;
    // eslint-disable-next-line no-console
    (_console = console).debug.apply(_console, arguments);
};

});



parcelRegister("kSkEF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f328df713ba47a12$export$2e2bcd8739ae039; });

var $ikNYA = parcelRequire("ikNYA");

var $iriaf = parcelRequire("iriaf");

var $dAx5m = parcelRequire("dAx5m");

var $jVTBW = parcelRequire("jVTBW");

var $7popc = parcelRequire("7popc");

var $3YsxU = parcelRequire("3YsxU");
function $f328df713ba47a12$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $f328df713ba47a12$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $f328df713ba47a12$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($iriaf)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $f328df713ba47a12$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
/**
 * We are hiding these props from consumers as they're used to
 * hack around icon sizing specifically for icon-file-type.
 */ var $f328df713ba47a12$var$iconStyles = (0, $jVTBW.css)({
    display: "inline-block",
    flexShrink: 0,
    lineHeight: 1,
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    "> svg": $f328df713ba47a12$var$_objectSpread($f328df713ba47a12$var$_objectSpread({}, (0, $7popc.commonSVGStyles)), {}, {
        maxWidth: "100%",
        maxHeight: "100%",
        color: "var(--icon-primary-color)",
        fill: "var(--icon-secondary-color)",
        verticalAlign: "bottom"
    })
});
/**
 * For windows high contrast mode
 */ var $f328df713ba47a12$var$baseHcmStyles = (0, $jVTBW.css)({
    "@media screen and (forced-colors: active)": {
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        "> svg": {
            filter: "grayscale(1)",
            "--icon-primary-color": "CanvasText",
            // foreground
            "--icon-secondary-color": "Canvas" // background
        }
    }
});
var $f328df713ba47a12$var$primaryEqualsSecondaryHcmStyles = (0, $jVTBW.css)({
    "@media screen and (forced-colors: active)": {
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        "> svg": {
            // if the primaryColor is the same as the secondaryColor we
            // set the --icon-primary-color to Canvas
            // this is usually to convey state i.e. Checkbox checked -> not checked
            "--icon-primary-color": "Canvas" // foreground
        }
    }
});
var $f328df713ba47a12$var$secondaryTransparentHcmStyles = (0, $jVTBW.css)({
    "@media screen and (forced-colors: active)": {
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        "> svg": {
            "--icon-secondary-color": "transparent" // background
        }
    }
});
var $f328df713ba47a12$export$f04a61298a47a40f = /*#__PURE__*/ (0, $dAx5m.memo)(function Icon(props) {
    var _ref = props, Glyph = _ref.glyph, dangerouslySetGlyph = _ref.dangerouslySetGlyph, _ref$primaryColor = _ref.primaryColor, primaryColor = _ref$primaryColor === void 0 ? "currentColor" : _ref$primaryColor, secondaryColor = _ref.secondaryColor, size = _ref.size, testId = _ref.testId, label = _ref.label, width = _ref.width, height = _ref.height, UNSAFE_margin = _ref.UNSAFE_margin;
    var glyphProps = dangerouslySetGlyph ? {
        dangerouslySetInnerHTML: {
            __html: dangerouslySetGlyph
        }
    } : {
        children: Glyph ? (0, $jVTBW.jsx)(Glyph, {
            role: "presentation"
        }) : null
    };
    var dimensions = (0, $7popc.getIconSize)({
        width: width,
        height: height,
        size: size
    });
    return (0, $jVTBW.jsx)("span", (0, (/*@__PURE__*/$parcel$interopDefault($ikNYA)))({
        "data-testid": testId,
        "data-vc": "icon-".concat(testId),
        role: label ? "img" : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: $f328df713ba47a12$var$_objectSpread({
            "--icon-primary-color": primaryColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            "--icon-secondary-color": secondaryColor || (0, $3YsxU.getBackground)()
        }, UNSAFE_margin ? {
            margin: UNSAFE_margin
        } : {})
    }, glyphProps, {
        css: [
            $f328df713ba47a12$var$iconStyles,
            $f328df713ba47a12$var$baseHcmStyles,
            primaryColor === secondaryColor && $f328df713ba47a12$var$primaryEqualsSecondaryHcmStyles,
            secondaryColor === "transparent" && $f328df713ba47a12$var$secondaryTransparentHcmStyles,
            // NB: This can be resolved if this component, composes base SVG / and/or skeleton
            // We could then simplify how common styles are dealt with simply by encapsulating them
            // at their appropriate level and/or having a singular approach to css variables in the package
            dimensions && // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $jVTBW.css)({
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                width: dimensions.width,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                height: dimensions.height,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                "> svg": dimensions
            })
        ]
    }));
});
var $f328df713ba47a12$export$2e2bcd8739ae039 = $f328df713ba47a12$export$f04a61298a47a40f;

});
parcelRegister("7popc", function(module, exports) {

$parcel$export(module.exports, "commonSVGStyles", function () { return $564dcc9c602be379$export$16374db1c3e6dfba; });
$parcel$export(module.exports, "sizeStyleMap", function () { return $564dcc9c602be379$export$ef0ad74202575b64; });
$parcel$export(module.exports, "getIconSize", function () { return $564dcc9c602be379$export$3eb7d6130acfda37; });

var $h6Ov0 = parcelRequire("h6Ov0");

var $jVTBW = parcelRequire("jVTBW");
var $564dcc9c602be379$export$16374db1c3e6dfba = {
    overflow: "hidden",
    pointerEvents: "none",
    /**
   * Stop-color doesn't properly apply in chrome when the inherited/current color changes.
   * We have to initially set stop-color to inherit (either via DOM attribute or an initial CSS
   * rule) and then override it with currentColor for the color changes to be picked up.
   */ stop: {
        stopColor: "currentColor"
    }
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
var $564dcc9c602be379$var$smallStyles = (0, $jVTBW.css)((0, $h6Ov0.dimensions).small);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
var $564dcc9c602be379$var$mediumStyles = (0, $jVTBW.css)((0, $h6Ov0.dimensions).medium);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
var $564dcc9c602be379$var$largeStyles = (0, $jVTBW.css)((0, $h6Ov0.dimensions).large);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
var $564dcc9c602be379$var$xlargeStyles = (0, $jVTBW.css)((0, $h6Ov0.dimensions).xlarge);
var $564dcc9c602be379$export$ef0ad74202575b64 = {
    small: $564dcc9c602be379$var$smallStyles,
    medium: $564dcc9c602be379$var$mediumStyles,
    large: $564dcc9c602be379$var$largeStyles,
    xlarge: $564dcc9c602be379$var$xlargeStyles
};
var $564dcc9c602be379$export$3eb7d6130acfda37 = function getIconSize(_ref) {
    var width = _ref.width, height = _ref.height, size = _ref.size;
    if (width && height) return {
        width: width,
        height: height
    };
    if (size) return (0, $h6Ov0.dimensions)[size];
    return undefined;
};

});
parcelRegister("h6Ov0", function(module, exports) {

$parcel$export(module.exports, "dimensions", function () { return $c74a2b43a9def8a2$export$62ad7b0c781000e9; });
var $c74a2b43a9def8a2$export$c647cb0ee6e282fe = {
    small: "16px",
    medium: "24px",
    large: "32px",
    xlarge: "48px"
};
var $c74a2b43a9def8a2$export$7bd66fc94c81bf84 = {
    small: "small",
    medium: "medium",
    large: "large",
    xlarge: "xlarge"
};
var $c74a2b43a9def8a2$export$62ad7b0c781000e9 = {
    small: {
        width: $c74a2b43a9def8a2$export$c647cb0ee6e282fe.small,
        height: $c74a2b43a9def8a2$export$c647cb0ee6e282fe.small
    },
    medium: {
        width: $c74a2b43a9def8a2$export$c647cb0ee6e282fe.medium,
        height: $c74a2b43a9def8a2$export$c647cb0ee6e282fe.medium
    },
    large: {
        width: $c74a2b43a9def8a2$export$c647cb0ee6e282fe.large,
        height: $c74a2b43a9def8a2$export$c647cb0ee6e282fe.large
    },
    xlarge: {
        width: $c74a2b43a9def8a2$export$c647cb0ee6e282fe.xlarge,
        height: $c74a2b43a9def8a2$export$c647cb0ee6e282fe.xlarge
    }
};

});


parcelRegister("3YsxU", function(module, exports) {

$parcel$export(module.exports, "getBackground", function () { return $2e4d1e5771aa8256$export$18cb9425622d4e06; });
var $2e4d1e5771aa8256$export$18cb9425622d4e06 = function getBackground() {
    return "var(--ds-surface, #FFFFFF)";
};

});



parcelRegister("d1cEx", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3eb2993a427b2667a5277a7a906fec96>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $97a52ef79308e2db$var$_react = $97a52ef79308e2db$var$_interopRequireDefault((parcelRequire("dAx5m")));

var $97a52ef79308e2db$var$_UNSAFE_baseNew = $97a52ef79308e2db$var$_interopRequireDefault((parcelRequire("9zOGI")));
function $97a52ef79308e2db$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "ChevronDown".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for dropdown menus, selects, accordions, and expands.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $97a52ef79308e2db$var$ChevronDownIcon = (props)=>/*#__PURE__*/ $97a52ef79308e2db$var$_react.default.createElement($97a52ef79308e2db$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M10.5 4.5 8.25 6.75 6 9 3.75 6.75 1.5 4.5"/>`,
        type: "utility"
    }, props));
$97a52ef79308e2db$var$ChevronDownIcon.displayName = "ChevronDownIcon";
var $97a52ef79308e2db$var$_default = module.exports.default = $97a52ef79308e2db$var$ChevronDownIcon;

});
parcelRegister("9zOGI", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("bQQg6")).default; });
$parcel$export(module.exports, "Icon", function () { return (parcelRequire("bQQg6")).Icon; });

var $bQQg6 = parcelRequire("bQQg6");

});
parcelRegister("bQQg6", function(module, exports) {

$parcel$export(module.exports, "Icon", function () { return $8a0d168b3e6ce82a$export$f04a61298a47a40f; });
$parcel$export(module.exports, "default", function () { return $8a0d168b3e6ce82a$export$2e2bcd8739ae039; });
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $dAx5m = parcelRequire("dAx5m");

var $jVTBW = parcelRequire("jVTBW");

var $apoiF = parcelRequire("apoiF");
/**
 * We are hiding this props from consumers as it's reserved
 * for use by Icon Tile.
 */ var $8a0d168b3e6ce82a$var$commonSVGStyles = (0, $jVTBW.css)({
    overflow: "hidden",
    pointerEvents: "none",
    /**
   * Stop-color doesn't properly apply in chrome when the inherited/current color changes.
   * We have to initially set stop-color to inherit (either via DOM attribute or an initial CSS
   * rule) and then override it with currentColor for the color changes to be picked up.
   */ // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    stop: {
        stopColor: "currentColor"
    }
});
var $8a0d168b3e6ce82a$var$svgStyles = (0, $jVTBW.css)({
    color: "currentColor",
    verticalAlign: "bottom"
});
var $8a0d168b3e6ce82a$var$iconStyles = (0, $jVTBW.css)({
    display: "inline-block",
    boxSizing: "border-box",
    flexShrink: 0,
    lineHeight: 1,
    paddingInlineEnd: "var(--ds--button--new-icon-padding-end, 0)",
    paddingInlineStart: "var(--ds--button--new-icon-padding-start, 0)"
});
var $8a0d168b3e6ce82a$var$utilityIconStyles = (0, $jVTBW.css)({
    lineHeight: "var(--ds-space-150, 12px)"
});
var $8a0d168b3e6ce82a$var$scaleStyles = (0, $jVTBW.css)({
    width: "inherit",
    height: "inherit"
});
/**
 * For windows high contrast mode
 */ var $8a0d168b3e6ce82a$var$baseHcmStyles = (0, $jVTBW.css)({
    "@media screen and (forced-colors: active)": {
        color: "CanvasText",
        filter: "grayscale(1)"
    }
});
var $8a0d168b3e6ce82a$var$sizeMap = {
    scale: (0, $jVTBW.css)({
        width: "inherit",
        height: "inherit"
    }),
    utility: (0, $jVTBW.css)({
        width: "var(--ds-space-150, 12px)",
        height: "var(--ds-space-150, 12px)"
    }),
    none: (0, $jVTBW.css)({
        width: "var(--ds-space-200, 16px)",
        height: "var(--ds-space-200, 16px)"
    }),
    spacious: (0, $jVTBW.css)({
        width: "var(--ds-space-300, 24px)",
        height: "var(--ds-space-300, 24px)"
    })
};
var $8a0d168b3e6ce82a$var$baseSizeMap = {
    global: 16,
    utility: 12
};
var $8a0d168b3e6ce82a$export$f04a61298a47a40f = /*#__PURE__*/ (0, $dAx5m.memo)(function Icon(props) {
    var _ref = props, providedColor = _ref.color, _ref$spacing = _ref.spacing, providedSpacing = _ref$spacing === void 0 ? "none" : _ref$spacing, testId = _ref.testId, label = _ref.label, LEGACY_primaryColor = _ref.LEGACY_primaryColor, LEGACY_secondaryColor = _ref.LEGACY_secondaryColor, LEGACY_size = _ref.LEGACY_size, FallbackIcon = _ref.LEGACY_fallbackIcon, _ref$type = _ref.type, type = _ref$type === void 0 ? "global" : _ref$type, dangerouslySetGlyph = _ref.dangerouslySetGlyph, shouldScale = _ref.shouldScale, LEGACY_margin = _ref.LEGACY_margin;
    var fallbackColor = "var(--ds-icon, #44546F)";
    if ((0, $apoiF.fg)("platform-design-system-new-icon-default-color") || (0, $apoiF.fg)("platform-design-system-new-icon-default-color-2")) fallbackColor = "currentColor";
    var color = providedColor !== null && providedColor !== void 0 ? providedColor : fallbackColor;
    var dangerouslySetInnerHTML = dangerouslySetGlyph ? {
        __html: dangerouslySetGlyph
    } : undefined;
    // Fall back to old icon
    if (FallbackIcon && !(0, $apoiF.fg)("platform.design-system-team.enable-new-icons")) // parse out unnecessary props
    return (0, $jVTBW.jsx)(FallbackIcon, {
        primaryColor: LEGACY_primaryColor !== null && LEGACY_primaryColor !== void 0 ? LEGACY_primaryColor : color,
        secondaryColor: LEGACY_secondaryColor,
        size: LEGACY_size,
        label: label,
        testId: testId,
        UNSAFE_margin: LEGACY_margin
    });
    // Utility icons don't have 'spacing' as a type, but in case it's provided, we default to 'none'
    var spacing = type === "utility" ? "none" : providedSpacing;
    var baseSize = $8a0d168b3e6ce82a$var$baseSizeMap[type];
    var size = type === "utility" ? "utility" : shouldScale ? "scale" : spacing;
    var viewBoxPadding = spacing === "spacious" ? 4 : 0;
    var viewBoxSize = baseSize + 2 * viewBoxPadding;
    // Workaround for the transparency in our disabled icon token.
    // Because we have multiple strokes in icons, opacities overlap
    // This filter has an impact on render performance, but this is
    // acceptable as icons aren't commonly disabled en-masse
    var iconColor = color;
    if (dangerouslySetInnerHTML && color === "var(--ds-icon-disabled, #091E424F)") {
        dangerouslySetInnerHTML.__html = '\n<filter id="ds-newIconOpacityFilter">\n  <feFlood flood-color="var(--ds-icon-disabled)" />\n  <feComposite in2="SourceGraphic" operator="in" />\n</filter>\n<g filter="url(#ds-newIconOpacityFilter)">\n  '.concat(dangerouslySetInnerHTML.__html, "\n</g>");
        iconColor = "var(--ds-icon, #44546F)";
    }
    return (0, $jVTBW.jsx)("span", {
        "data-testid": testId,
        role: label ? "img" : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: {
            color: iconColor
        },
        css: [
            $8a0d168b3e6ce82a$var$iconStyles,
            $8a0d168b3e6ce82a$var$baseHcmStyles,
            shouldScale && $8a0d168b3e6ce82a$var$scaleStyles,
            type === "utility" && $8a0d168b3e6ce82a$var$utilityIconStyles
        ]
    }, (0, $jVTBW.jsx)("svg", {
        fill: "none",
        viewBox: "".concat(0 - viewBoxPadding, " ").concat(0 - viewBoxPadding, " ").concat(viewBoxSize, " ").concat(viewBoxSize),
        role: "presentation",
        css: [
            $8a0d168b3e6ce82a$var$commonSVGStyles,
            $8a0d168b3e6ce82a$var$svgStyles,
            $8a0d168b3e6ce82a$var$sizeMap[size]
        ],
        dangerouslySetInnerHTML: dangerouslySetInnerHTML
    }));
});
var $8a0d168b3e6ce82a$export$2e2bcd8739ae039 = $8a0d168b3e6ce82a$export$f04a61298a47a40f;

});




parcelRegister("7vqkt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $576fda107672772b$export$2e2bcd8739ae039; });

var $4026V = parcelRequire("4026V");
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$576fda107672772b$export$2e2bcd8739ae039 = (0, $4026V.Popup);

});
parcelRegister("4026V", function(module, exports) {

$parcel$export(module.exports, "Popup", function () { return $2e98ccad32c3ff75$export$129a32eedafa97c5; });

var $lA3Et = parcelRequire("lA3Et");

var $dAx5m = parcelRequire("dAx5m");

var $jVTBW = parcelRequire("jVTBW");

var $dHPoE = parcelRequire("dHPoE");

var $aIutD = parcelRequire("aIutD");

var $expeE = parcelRequire("expeE");
var $4Yjoy = parcelRequire("4Yjoy");

var $k4dMs = parcelRequire("k4dMs");

var $6W4m7 = parcelRequire("6W4m7");

var $7dAqT = parcelRequire("7dAqT");
var $2e98ccad32c3ff75$var$defaultLayer = (0, $6W4m7.layers).layer();
var $2e98ccad32c3ff75$export$129a32eedafa97c5 = /*#__PURE__*/ (0, $dAx5m.memo)(function(_ref) {
    var isOpen = _ref.isOpen, id = _ref.id, offset = _ref.offset, testId = _ref.testId, trigger = _ref.trigger, content = _ref.content, onClose = _ref.onClose, boundary = _ref.boundary, _ref$rootBoundary = _ref.rootBoundary, rootBoundary = _ref$rootBoundary === void 0 ? "viewport" : _ref$rootBoundary, _ref$shouldFlip = _ref.shouldFlip, shouldFlip = _ref$shouldFlip === void 0 ? true : _ref$shouldFlip, _ref$placement = _ref.placement, placement = _ref$placement === void 0 ? "auto" : _ref$placement, fallbackPlacements = _ref.fallbackPlacements, PopupContainer = _ref.popupComponent, _ref$autoFocus = _ref.autoFocus, autoFocus = _ref$autoFocus === void 0 ? true : _ref$autoFocus, _ref$zIndex = _ref.zIndex, zIndex = _ref$zIndex === void 0 ? $2e98ccad32c3ff75$var$defaultLayer : _ref$zIndex, _ref$shouldUseCapture = _ref.shouldUseCaptureOnOutsideClick, shouldUseCaptureOnOutsideClick = _ref$shouldUseCapture === void 0 ? false : _ref$shouldUseCapture, _ref$shouldRenderToPa = _ref.shouldRenderToParent, shouldRenderToParent = _ref$shouldRenderToPa === void 0 ? false : _ref$shouldRenderToPa, _ref$shouldDisableFoc = _ref.shouldDisableFocusLock, shouldDisableFocusLock = _ref$shouldDisableFoc === void 0 ? false : _ref$shouldDisableFoc, strategy = _ref.strategy;
    var _useState = (0, $dAx5m.useState)(null), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($lA3Et)))(_useState, 2), triggerRef = _useState2[0], setTriggerRef = _useState2[1];
    /*
   * Get a memoized functional ref for use within this Popup's Trigger.
   * This is still very volatile to change as `prop.isOpen` will regularly change, but it's better than nothing.
   * This is memoized within our component as to not be shared across all Popup instances, just this one.
   *
   * This is complex because the inputs are split across three different scopes:
   *  - `props.isOpen`
   *  - `useState.setTriggerRef`
   *  - `renderProps.ref`
   */ var _useState3 = (0, $dAx5m.useState)(function() {
        return (0, $dHPoE.default)(function(ref, setTriggerRef, isOpen) {
            return function(node) {
                if (node && isOpen) {
                    if (typeof ref === "function") ref(node);
                    else if (ref) ref.current = node;
                    setTriggerRef(node);
                }
            };
        });
    }), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($lA3Et)))(_useState3, 1), getMergedTriggerRef = _useState4[0];
    var renderPopperWrapper = (0, $jVTBW.jsx)((0, $aIutD.UNSAFE_LAYERING), {
        isDisabled: false
    }, (0, $jVTBW.jsx)((0, $7dAqT.default), {
        content: content,
        isOpen: isOpen,
        placement: placement,
        fallbackPlacements: fallbackPlacements,
        boundary: boundary,
        rootBoundary: rootBoundary,
        shouldFlip: shouldFlip,
        offset: offset,
        popupComponent: PopupContainer,
        id: id,
        testId: testId,
        onClose: onClose,
        autoFocus: autoFocus,
        shouldUseCaptureOnOutsideClick: shouldUseCaptureOnOutsideClick,
        shouldRenderToParent: shouldRenderToParent,
        shouldDisableFocusLock: shouldDisableFocusLock,
        triggerRef: triggerRef,
        strategy: strategy
    }));
    return (0, $jVTBW.jsx)((0, $expeE.Manager), null, (0, $jVTBW.jsx)((0, $4Yjoy.Reference), null, function(_ref2) {
        var ref = _ref2.ref;
        return trigger({
            ref: getMergedTriggerRef(ref, setTriggerRef, isOpen),
            "aria-controls": id,
            "aria-expanded": isOpen,
            "aria-haspopup": true
        });
    }), isOpen && (shouldRenderToParent ? renderPopperWrapper : (0, $jVTBW.jsx)((0, $k4dMs.default), {
        zIndex: zIndex
    }, renderPopperWrapper)));
});
var $2e98ccad32c3ff75$export$2e2bcd8739ae039 = $2e98ccad32c3ff75$export$129a32eedafa97c5;

});
parcelRegister("lA3Et", function(module, exports) {

var $cUSTu = parcelRequire("cUSTu");

var $5YKA1 = parcelRequire("5YKA1");

var $cFzF8 = parcelRequire("cFzF8");

var $2Ov9n = parcelRequire("2Ov9n");
function $fb5fcaecea3eec5c$var$_slicedToArray(r, e) {
    return $cUSTu(r) || $5YKA1(r, e) || $cFzF8(r, e) || $2Ov9n();
}
module.exports = $fb5fcaecea3eec5c$var$_slicedToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("cUSTu", function(module, exports) {
function $96754bd1cbf54d68$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
module.exports = $96754bd1cbf54d68$var$_arrayWithHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("5YKA1", function(module, exports) {
function $45a6b02a5cae2a7c$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
module.exports = $45a6b02a5cae2a7c$var$_iterableToArrayLimit, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("cFzF8", function(module, exports) {

var $ktKLa = parcelRequire("ktKLa");
function $9394fa2c0c11761c$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $ktKLa(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $ktKLa(r, a) : void 0;
    }
}
module.exports = $9394fa2c0c11761c$var$_unsupportedIterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("ktKLa", function(module, exports) {
function $ee8ac992ac659d5e$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
module.exports = $ee8ac992ac659d5e$var$_arrayLikeToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("2Ov9n", function(module, exports) {
function $20c86a0ce65a59d9$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
module.exports = $20c86a0ce65a59d9$var$_nonIterableRest, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("aIutD", function(module, exports) {

$parcel$export(module.exports, "LevelContext", function () { return $7cd5a7849776b1ff$export$650d12d3c2ddb8fc; });
$parcel$export(module.exports, "TopLevelContext", function () { return $7cd5a7849776b1ff$export$48b383b280e20440; });
$parcel$export(module.exports, "UNSAFE_LAYERING", function () { return $7cd5a7849776b1ff$export$a183686c3f6f4ea8; });

var $dAx5m = parcelRequire("dAx5m");

var $Bb0he = parcelRequire("Bb0he");
var $7cd5a7849776b1ff$export$650d12d3c2ddb8fc = /*#__PURE__*/ (0, $dAx5m.createContext)(0);
var $7cd5a7849776b1ff$export$48b383b280e20440 = /*#__PURE__*/ (0, $dAx5m.createContext)({
    topLevelRef: {
        current: null
    },
    setTopLevel: (0, $Bb0he.default)
});
/**
 *
 *  @internal
 * Context Provider Component which provider the current level of nested layers
 * It handles level management when it mounts and unmounts
 *
 */ var $7cd5a7849776b1ff$var$LevelProvider = function LevelProvider(_ref) {
    var children = _ref.children, currentLevel = _ref.currentLevel;
    var _useContext = (0, $dAx5m.useContext)($7cd5a7849776b1ff$export$48b383b280e20440), setTopLevel = _useContext.setTopLevel;
    setTopLevel(currentLevel);
    (0, $dAx5m.useEffect)(function() {
        // avoid immediate cleanup using setTimeout when component unmount
        // this will make sure non-top layer components can get the correct top level value
        // when multiple layers trigger onClose in sequence.
        // From React 17, the useEffect cleanup functions are delayed till the commit phase is completed. In other words, the useEffect cleanup functions run asynchronously - for example, if the component is unmounting, the cleanup runs after the screen has been updated.
        // TODO revisit after we migrate to react 18. https://product-fabric.atlassian.net/browse/DSP-13139
        return function() {
            setTimeout(function() {
                setTopLevel(currentLevel - 1);
            }, 0);
        };
    }, [
        setTopLevel,
        currentLevel
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement($7cd5a7849776b1ff$export$650d12d3c2ddb8fc.Provider, {
        value: currentLevel
    }, children);
};
/**
 *
 *  @internal
 * Context Provider Component which provides the top level of all nested layers
 * It provides initial top level ref value as 0 and set top level method
 *
 */ var $7cd5a7849776b1ff$var$LayeringProvider = function LayeringProvider(_ref2) {
    var children = _ref2.children;
    var topLevelRef = (0, $dAx5m.useRef)(0);
    var value = (0, $dAx5m.useMemo)(function() {
        return {
            topLevelRef: topLevelRef,
            setTopLevel: function setTopLevel(level) {
                topLevelRef.current = level;
            }
        };
    }, [
        topLevelRef
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement($7cd5a7849776b1ff$export$48b383b280e20440.Provider, {
        value: value
    }, children);
};
var $7cd5a7849776b1ff$export$a183686c3f6f4ea8 = function UNSAFE_LAYERING(_ref3) {
    var children = _ref3.children, _ref3$isDisabled = _ref3.isDisabled, isDisabled = _ref3$isDisabled === void 0 ? true : _ref3$isDisabled;
    var currentLevel = (0, $dAx5m.useContext)($7cd5a7849776b1ff$export$650d12d3c2ddb8fc);
    if (isDisabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).Fragment, null, children);
    var isNested = currentLevel > 0;
    var content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement($7cd5a7849776b1ff$var$LevelProvider, {
        currentLevel: currentLevel + 1
    }, children);
    return isNested ? content : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement($7cd5a7849776b1ff$var$LayeringProvider, null, content);
};

});

parcelRegister("7dAqT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $541602181fbf5807$export$2e2bcd8739ae039; });

var $lA3Et = parcelRequire("lA3Et");

var $6H9z0 = parcelRequire("6H9z0");

var $btCt0 = parcelRequire("btCt0");

var $7f2u6 = parcelRequire("7f2u6");

var $dAx5m = parcelRequire("dAx5m");

var $jVTBW = parcelRequire("jVTBW");

var $bvMGd = parcelRequire("bvMGd");

var $kD1z3 = parcelRequire("kD1z3");

var $bkzE4 = parcelRequire("bkzE4");

var $5MUVm = parcelRequire("5MUVm");

var $6W4m7 = parcelRequire("6W4m7");

var $91bv7 = parcelRequire("91bv7");

var $cTYUO = parcelRequire("cTYUO");

var $45cJf = parcelRequire("45cJf");

var $l43rK = parcelRequire("l43rK");
var $541602181fbf5807$var$_excluded = [
    "shouldRenderToParent",
    "children"
];
var $541602181fbf5807$var$_css;
var $541602181fbf5807$var$popupStyles = (0, $jVTBW.css)(($541602181fbf5807$var$_css = {
    display: "block",
    boxSizing: "border-box",
    zIndex: (0, $6W4m7.layers).layer(),
    flex: "1 1 auto",
    backgroundColor: "var(--ds-surface-overlay, ".concat((0, $5MUVm.N0), ")"),
    borderRadius: "var(--ds-border-radius, 3px)",
    boxShadow: "var(--ds-shadow-overlay, ".concat("0 4px 8px -2px ".concat((0, $5MUVm.N50A), ", 0 0 1px ").concat((0, $5MUVm.N60A)), ")")
}, (0, (/*@__PURE__*/$parcel$interopDefault($7f2u6)))($541602181fbf5807$var$_css, (0, $91bv7.CURRENT_SURFACE_CSS_VAR), "var(--ds-surface-overlay, ".concat((0, $5MUVm.N0), ")")), (0, (/*@__PURE__*/$parcel$interopDefault($7f2u6)))($541602181fbf5807$var$_css, ":focus", {
    outline: "none"
}), $541602181fbf5807$var$_css));
var $541602181fbf5807$var$popupOverflowStyles = (0, $jVTBW.css)({
    overflow: "auto"
});
// disables iframe pointer events while popup is open, except if iframe is nested inside popup
// solves an issue of popup not being closed on iframe click
var $541602181fbf5807$var$blockPointerEventsOnExternalIframeStyles = (0, $jVTBW.css)({
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
    "iframe:not([data-ds--level] iframe)": {
        pointerEvents: "none"
    }
});
var $541602181fbf5807$var$DefaultPopupComponent = /*#__PURE__*/ (0, $dAx5m.forwardRef)(function(props, ref) {
    var shouldRenderToParent = props.shouldRenderToParent, children = props.children, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($btCt0)))(props, $541602181fbf5807$var$_excluded);
    return (0, $jVTBW.jsx)("div", (0, (/*@__PURE__*/$parcel$interopDefault($6H9z0)))({
        css: [
            $541602181fbf5807$var$popupStyles,
            !shouldRenderToParent && $541602181fbf5807$var$popupOverflowStyles
        ]
    }, htmlAttributes, {
        ref: ref
    }), children);
});
function $541602181fbf5807$var$PopperWrapper(_ref) {
    var isOpen = _ref.isOpen, id = _ref.id, offset = _ref.offset, testId = _ref.testId, content = _ref.content, fallbackPlacements = _ref.fallbackPlacements, onClose = _ref.onClose, boundary = _ref.boundary, rootBoundary = _ref.rootBoundary, shouldFlip = _ref.shouldFlip, _ref$placement = _ref.placement, placement = _ref$placement === void 0 ? "auto" : _ref$placement, _ref$popupComponent = _ref.popupComponent, PopupContainer = _ref$popupComponent === void 0 ? $541602181fbf5807$var$DefaultPopupComponent : _ref$popupComponent, _ref$autoFocus = _ref.autoFocus, autoFocus = _ref$autoFocus === void 0 ? true : _ref$autoFocus, triggerRef = _ref.triggerRef, shouldUseCaptureOnOutsideClick = _ref.shouldUseCaptureOnOutsideClick, shouldRenderToParent = _ref.shouldRenderToParent, shouldDisableFocusLock = _ref.shouldDisableFocusLock, strategy = _ref.strategy;
    var _useState = (0, $dAx5m.useState)(null), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($lA3Et)))(_useState, 2), popupRef = _useState2[0], setPopupRef = _useState2[1];
    var _useState3 = (0, $dAx5m.useState)(null), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($lA3Et)))(_useState3, 2), initialFocusRef = _useState4[0], setInitialFocusRef = _useState4[1];
    // We have cases when we need to prohibit focus locking
    // e.g. in DropdownMenu
    var shouldCloseOnTab = shouldRenderToParent && shouldDisableFocusLock;
    (0, $l43rK.useFocusManager)({
        initialFocusRef: initialFocusRef,
        popupRef: popupRef,
        shouldCloseOnTab: shouldCloseOnTab
    });
    (0, $45cJf.useCloseManager)({
        isOpen: isOpen,
        onClose: onClose,
        popupRef: popupRef,
        triggerRef: triggerRef,
        shouldUseCaptureOnOutsideClick: shouldUseCaptureOnOutsideClick,
        shouldCloseOnTab: shouldCloseOnTab
    });
    var _UNSAFE_useLayering = (0, $bvMGd.UNSAFE_useLayering)(), currentLevel = _UNSAFE_useLayering.currentLevel;
    var modifiers = (0, $dAx5m.useMemo)(function() {
        return [
            {
                name: "flip",
                enabled: shouldFlip,
                options: {
                    rootBoundary: rootBoundary,
                    boundary: boundary,
                    fallbackPlacements: fallbackPlacements
                }
            }
        ];
    }, [
        shouldFlip,
        rootBoundary,
        boundary,
        fallbackPlacements
    ]);
    return (0, $jVTBW.jsx)((0, $bkzE4.Popper), {
        placement: placement,
        offset: offset,
        modifiers: modifiers,
        strategy: strategy
    }, function(_ref2) {
        var _ref3 = _ref2.ref, style = _ref2.style, placement = _ref2.placement, update = _ref2.update;
        return (0, $jVTBW.jsx)(PopupContainer, {
            id: id,
            "data-ds--level": currentLevel,
            "data-placement": placement,
            "data-testid": testId,
            ref: function ref(node) {
                if (node) {
                    if (typeof _ref3 === "function") _ref3(node);
                    else _ref3.current = node;
                    setPopupRef(node);
                }
            },
            style: style,
            tabIndex: autoFocus ? 0 : undefined,
            shouldRenderToParent: shouldRenderToParent
        }, (0, $kD1z3.getBooleanFF)("platform.design-system-team.iframe_gojiv") && (0, $jVTBW.jsx)((0, $jVTBW.Global), {
            styles: $541602181fbf5807$var$blockPointerEventsOnExternalIframeStyles
        }), (0, $jVTBW.jsx)((0, $cTYUO.RepositionOnUpdate), {
            update: update
        }, content({
            update: update,
            isOpen: isOpen,
            onClose: onClose,
            setInitialFocusRef: setInitialFocusRef
        })));
    });
}
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$541602181fbf5807$export$2e2bcd8739ae039 = $541602181fbf5807$var$PopperWrapper;

});
parcelRegister("6H9z0", function(module, exports) {
function $4dfe2d58305a1d5f$var$_extends() {
    return module.exports = $4dfe2d58305a1d5f$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $4dfe2d58305a1d5f$var$_extends.apply(null, arguments);
}
module.exports = $4dfe2d58305a1d5f$var$_extends, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("btCt0", function(module, exports) {

var $hP4uq = parcelRequire("hP4uq");
function $85b03de054d29596$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $hP4uq(e, t);
    if (Object.getOwnPropertySymbols) {
        var s = Object.getOwnPropertySymbols(e);
        for(r = 0; r < s.length; r++)o = s[r], t.includes(o) || ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
module.exports = $85b03de054d29596$var$_objectWithoutProperties, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("hP4uq", function(module, exports) {
function $cf9aaeac9bdddb33$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.includes(n)) continue;
        t[n] = r[n];
    }
    return t;
}
module.exports = $cf9aaeac9bdddb33$var$_objectWithoutPropertiesLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("7f2u6", function(module, exports) {

var $9dMBq = parcelRequire("9dMBq");
function $545bdc81ff373216$var$_defineProperty(e, r, t) {
    return (r = $9dMBq(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
module.exports = $545bdc81ff373216$var$_defineProperty, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("9dMBq", function(module, exports) {

var $k2EfB = parcelRequire("k2EfB");
var $6b6b076b550bbe4b$var$_typeof = $k2EfB.default;

var $kXYjs = parcelRequire("kXYjs");
function $6b6b076b550bbe4b$var$toPropertyKey(t) {
    var i = $kXYjs(t, "string");
    return "symbol" == $6b6b076b550bbe4b$var$_typeof(i) ? i : i + "";
}
module.exports = $6b6b076b550bbe4b$var$toPropertyKey, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("k2EfB", function(module, exports) {
function $e973377a11a3352e$var$_typeof(o) {
    "@babel/helpers - typeof";
    return module.exports = $e973377a11a3352e$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $e973377a11a3352e$var$_typeof(o);
}
module.exports = $e973377a11a3352e$var$_typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("kXYjs", function(module, exports) {

var $k2EfB = parcelRequire("k2EfB");
var $f4381a2fbcf3f49a$var$_typeof = $k2EfB.default;
function $f4381a2fbcf3f49a$var$toPrimitive(t, r) {
    if ("object" != $f4381a2fbcf3f49a$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $f4381a2fbcf3f49a$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
module.exports = $f4381a2fbcf3f49a$var$toPrimitive, module.exports.__esModule = true, module.exports["default"] = module.exports;

});



parcelRegister("bvMGd", function(module, exports) {

$parcel$export(module.exports, "UNSAFE_useLayering", function () { return $861859c553cbbd89$export$cec37b93989366d4; });

var $dAx5m = parcelRequire("dAx5m");

var $gJocn = parcelRequire("gJocn");

var $aIutD = parcelRequire("aIutD");
var $861859c553cbbd89$var$ESCAPE = "Escape";
function $861859c553cbbd89$export$4a4bf067ea9e7886(_ref) {
    var onClose = _ref.onClose, isDisabled = _ref.isDisabled;
    var escapePressed = (0, $dAx5m.useRef)(false);
    var _UNSAFE_useLayering = $861859c553cbbd89$export$cec37b93989366d4(), isLayerDisabled = _UNSAFE_useLayering.isLayerDisabled;
    var onKeyDown = (0, $dAx5m.useCallback)(function(e) {
        var isDisabledLayer = isLayerDisabled();
        if (isDisabled || escapePressed.current || e.key !== $861859c553cbbd89$var$ESCAPE || isDisabledLayer) // We're either already handling the key down event or it's not escape or disabled.
        // Bail early!
        return;
        escapePressed.current = true;
        onClose(e);
    }, [
        onClose,
        isDisabled,
        isLayerDisabled
    ]);
    var onKeyUp = (0, $dAx5m.useCallback)(function() {
        escapePressed.current = false;
    }, []);
    (0, $dAx5m.useEffect)(function() {
        return (0, $gJocn.bindAll)(document, [
            {
                type: "keydown",
                listener: onKeyDown
            },
            {
                type: "keyup",
                listener: onKeyUp
            }
        ], {
            capture: false
        });
    }, [
        onKeyDown,
        onKeyUp
    ]);
}
function $861859c553cbbd89$export$cec37b93989366d4() {
    var currentLevel = (0, $dAx5m.useContext)((0, $aIutD.LevelContext));
    var _useContext = (0, $dAx5m.useContext)((0, $aIutD.TopLevelContext)), topLevelRef = _useContext.topLevelRef;
    var isLayerDisabled = (0, $dAx5m.useCallback)(function() {
        return !!topLevelRef.current && currentLevel !== topLevelRef.current;
    }, [
        currentLevel,
        topLevelRef
    ]);
    return {
        currentLevel: currentLevel,
        topLevelRef: topLevelRef,
        isLayerDisabled: isLayerDisabled
    };
}

});
parcelRegister("gJocn", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.bindAll = module.exports.bind = void 0;

var $77fMF = parcelRequire("77fMF");
Object.defineProperty(module.exports, "bind", {
    enumerable: true,
    get: function() {
        return $77fMF.bind;
    }
});

var $gOkR8 = parcelRequire("gOkR8");
Object.defineProperty(module.exports, "bindAll", {
    enumerable: true,
    get: function() {
        return $gOkR8.bindAll;
    }
});

});
parcelRegister("77fMF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.bind = void 0;
function $52e56e345802d657$var$bind(target, _a) {
    var type = _a.type, listener = _a.listener, options = _a.options;
    target.addEventListener(type, listener, options);
    return function unbind() {
        target.removeEventListener(type, listener, options);
    };
}
module.exports.bind = $52e56e345802d657$var$bind;

});

parcelRegister("gOkR8", function(module, exports) {
"use strict";
var $c3d17e6c76a7d108$var$__assign = module.exports && module.exports.__assign || function() {
    $c3d17e6c76a7d108$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $c3d17e6c76a7d108$var$__assign.apply(this, arguments);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.bindAll = void 0;

var $77fMF = parcelRequire("77fMF");
function $c3d17e6c76a7d108$var$toOptions(value) {
    if (typeof value === "undefined") return undefined;
    if (typeof value === "boolean") return {
        capture: value
    };
    return value;
}
function $c3d17e6c76a7d108$var$getBinding(original, sharedOptions) {
    if (sharedOptions == null) return original;
    var binding = $c3d17e6c76a7d108$var$__assign($c3d17e6c76a7d108$var$__assign({}, original), {
        options: $c3d17e6c76a7d108$var$__assign($c3d17e6c76a7d108$var$__assign({}, $c3d17e6c76a7d108$var$toOptions(sharedOptions)), $c3d17e6c76a7d108$var$toOptions(original.options))
    });
    return binding;
}
function $c3d17e6c76a7d108$var$bindAll(target, bindings, sharedOptions) {
    var unbinds = bindings.map(function(original) {
        var binding = $c3d17e6c76a7d108$var$getBinding(original, sharedOptions);
        return (0, $77fMF.bind)(target, binding);
    });
    return function unbindAll() {
        unbinds.forEach(function(unbind) {
            return unbind();
        });
    };
}
module.exports.bindAll = $c3d17e6c76a7d108$var$bindAll;

});



parcelRegister("kD1z3", function(module, exports) {

$parcel$export(module.exports, "getBooleanFF", function () { return $f048a9cd1fa806da$export$470e5c2be1411c89; });

var $6n07R = parcelRequire("6n07R");
function $f048a9cd1fa806da$export$ba05d765b8392e5e(flagResolver) {
    (0, $6n07R.setBooleanResolver)(flagResolver);
}
function $f048a9cd1fa806da$export$470e5c2be1411c89(name) {
    return (0, $6n07R.resolveBooleanFlag)(name);
}
function $f048a9cd1fa806da$export$b40ec24ac8275656(name) {
    return (0, $6n07R.resolveBooleanFlag)(name);
}

});
parcelRegister("6n07R", function(module, exports) {

$parcel$export(module.exports, "setBooleanResolver", function () { return $4a34fd033ad17738$export$f2b591175b3e424c; });
$parcel$export(module.exports, "resolveBooleanFlag", function () { return $4a34fd033ad17738$export$6333b6aff9fc6275; });

var $9cGWp = parcelRequire("9cGWp");

var $ahJoN = parcelRequire("ahJoN");
var $4a34fd033ad17738$var$pkgName = "@atlaskit/platform-feature-flags";
var $4a34fd033ad17738$export$7e41b1b2bdee3f98 = "__PLATFORM_FEATURE_FLAGS__";
var $4a34fd033ad17738$var$hasProcessEnv = typeof $ahJoN !== "undefined" && typeof $ahJoN.env !== "undefined";
// FF global overrides can be configured by test runners or Storybook
var $4a34fd033ad17738$var$ENV_ENABLE_PLATFORM_FF = $4a34fd033ad17738$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
// STORYBOOK_ENABLE_PLATFORM_FF is included as storybook only allows env vars prefixed with STORYBOOK
// https://github.com/storybookjs/storybook/issues/12270
var $4a34fd033ad17738$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF = $4a34fd033ad17738$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
var $4a34fd033ad17738$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE = $4a34fd033ad17738$var$ENV_ENABLE_PLATFORM_FF || $4a34fd033ad17738$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF;
var $4a34fd033ad17738$var$DEFAULT_PFF_GLOBAL = {
    // In development mode we want to capture any feature flag checks that happen using the default resolver and log this result when the resolver is replaced.
    // This is because evaluating feature flags when the resolver/FF client is loaded asynchronously could cause unexpected issues.
    earlyResolvedFlags: new Map(),
    booleanResolver: function booleanResolver(flagKey) {
        var unresolvedFlagCount;
        return false;
    }
};
var $4a34fd033ad17738$var$globalVar = typeof window !== "undefined" ? window : globalThis;
$4a34fd033ad17738$var$globalVar[$4a34fd033ad17738$export$7e41b1b2bdee3f98] = $4a34fd033ad17738$var$globalVar[$4a34fd033ad17738$export$7e41b1b2bdee3f98] || $4a34fd033ad17738$var$DEFAULT_PFF_GLOBAL;
function $4a34fd033ad17738$export$f2b591175b3e424c(resolver) {
    $4a34fd033ad17738$var$globalVar[$4a34fd033ad17738$export$7e41b1b2bdee3f98].booleanResolver = resolver;
    var _globalVar$PFF_GLOBAL;
}
function $4a34fd033ad17738$export$6333b6aff9fc6275(flagKey) {
    if ($4a34fd033ad17738$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE) {
        (0, $9cGWp.debug)('[%s]: The feature flags were enabled while running tests. The flag "%s" will be always enabled.', $4a34fd033ad17738$var$pkgName, flagKey);
        return true;
    }
    try {
        var _globalVar$PFF_GLOBAL2;
        var result = (_globalVar$PFF_GLOBAL2 = $4a34fd033ad17738$var$globalVar[$4a34fd033ad17738$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL2 === void 0 ? void 0 : _globalVar$PFF_GLOBAL2.booleanResolver(flagKey);
        if (typeof result !== "boolean") {
            // eslint-disable-next-line no-console
            console.warn("".concat(flagKey, " resolved to a non-boolean value, returning false for safety"));
            return false;
        }
        return result;
    } catch (e) {
        return false;
    }
}

});
parcelRegister("9cGWp", function(module, exports) {

$parcel$export(module.exports, "debug", function () { return $6b368b421c42b9e9$export$1c9f709888824e05; });
var $6b368b421c42b9e9$var$_ref, $6b368b421c42b9e9$var$_process, $6b368b421c42b9e9$var$_process2;
// We can't rely on NODE_ENV === 'test' if its value is already configured by the consumer to some other value, so better to use JEST_WORKER_ID
// https://jestjs.io/docs/environment-variables#jest_worker_id
var $6b368b421c42b9e9$var$TESTS_MODE = ($6b368b421c42b9e9$var$_ref = (globalThis === null || globalThis === void 0 || ($6b368b421c42b9e9$var$_process = globalThis.process) === null || $6b368b421c42b9e9$var$_process === void 0 || ($6b368b421c42b9e9$var$_process = $6b368b421c42b9e9$var$_process.env) === null || $6b368b421c42b9e9$var$_process === void 0 ? void 0 : $6b368b421c42b9e9$var$_process.JEST_WORKER_ID) !== undefined, $6b368b421c42b9e9$var$_ref !== void 0) ? $6b368b421c42b9e9$var$_ref : false;
var $6b368b421c42b9e9$var$DEBUG_MODE = !$6b368b421c42b9e9$var$TESTS_MODE && (globalThis === null || globalThis === void 0 || ($6b368b421c42b9e9$var$_process2 = globalThis.process) === null || $6b368b421c42b9e9$var$_process2 === void 0 || ($6b368b421c42b9e9$var$_process2 = $6b368b421c42b9e9$var$_process2.env) === null || $6b368b421c42b9e9$var$_process2 === void 0 ? void 0 : $6b368b421c42b9e9$var$_process2.NODE_ENV) !== "production";
var $6b368b421c42b9e9$export$1c9f709888824e05 = function debug() {
    var _console;
    if (!$6b368b421c42b9e9$var$DEBUG_MODE) return;
    // eslint-disable-next-line no-console
    (_console = console).debug.apply(_console, arguments);
};

});



parcelRegister("bkzE4", function(module, exports) {

$parcel$export(module.exports, "Popper", function () { return $83fd365db7be29e6$export$badac9ada3a0bdf9; });

var $jsrCL = parcelRequire("jsrCL");

var $lA3Et = parcelRequire("lA3Et");

var $dAx5m = parcelRequire("dAx5m");

var $2BQLr = parcelRequire("2BQLr");

// Export types from PopperJS / React Popper
var $83fd365db7be29e6$var$constantModifiers = [
    {
        name: "flip",
        options: {
            flipVariations: false,
            padding: 5,
            boundary: "clippingParents",
            rootBoundary: "viewport"
        }
    },
    {
        name: "preventOverflow",
        options: {
            padding: 5,
            rootBoundary: "document"
        }
    }
];
function $83fd365db7be29e6$var$defaultChildrenFn() {
    return null;
}
var $83fd365db7be29e6$var$defaultOffset = [
    0,
    8
];
function $83fd365db7be29e6$export$badac9ada3a0bdf9(_ref) {
    var _ref$children = _ref.children, children = _ref$children === void 0 ? $83fd365db7be29e6$var$defaultChildrenFn : _ref$children, _ref$offset = _ref.offset, offset = _ref$offset === void 0 ? $83fd365db7be29e6$var$defaultOffset : _ref$offset, _ref$placement = _ref.placement, placement = _ref$placement === void 0 ? "bottom-start" : _ref$placement, _ref$referenceElement = _ref.referenceElement, referenceElement = _ref$referenceElement === void 0 ? undefined : _ref$referenceElement, modifiers = _ref.modifiers, _ref$strategy = _ref.strategy, strategy = _ref$strategy === void 0 ? "fixed" : _ref$strategy;
    var _offset = (0, (/*@__PURE__*/$parcel$interopDefault($lA3Et)))(offset, 2), offsetX = _offset[0], offsetY = _offset[1];
    // Merge a new offset modifier only if new offset values passed in
    var internalModifiers = (0, $dAx5m.useMemo)(function() {
        var offsetModifier = {
            name: "offset",
            options: {
                offset: [
                    offsetX,
                    offsetY
                ]
            }
        };
        return [].concat($83fd365db7be29e6$var$constantModifiers, [
            offsetModifier
        ]);
    }, [
        offsetX,
        offsetY
    ]);
    // Merge custom props and memoize
    var mergedModifiers = (0, $dAx5m.useMemo)(function() {
        if (modifiers == null) return internalModifiers;
        return [].concat((0, (/*@__PURE__*/$parcel$interopDefault($jsrCL)))(internalModifiers), (0, (/*@__PURE__*/$parcel$interopDefault($jsrCL)))(modifiers));
    }, [
        internalModifiers,
        modifiers
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $2BQLr.Popper), {
        modifiers: mergedModifiers,
        placement: placement,
        strategy: strategy,
        referenceElement: referenceElement
    }, children);
}

});
parcelRegister("jsrCL", function(module, exports) {

var $lH5T6 = parcelRequire("lH5T6");

var $1fCIW = parcelRequire("1fCIW");

var $cFzF8 = parcelRequire("cFzF8");

var $02dr6 = parcelRequire("02dr6");
function $e2a60f72f91f12d1$var$_toConsumableArray(r) {
    return $lH5T6(r) || $1fCIW(r) || $cFzF8(r) || $02dr6();
}
module.exports = $e2a60f72f91f12d1$var$_toConsumableArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("lH5T6", function(module, exports) {

var $ktKLa = parcelRequire("ktKLa");
function $fcb22e54e755b4ef$var$_arrayWithoutHoles(r) {
    if (Array.isArray(r)) return $ktKLa(r);
}
module.exports = $fcb22e54e755b4ef$var$_arrayWithoutHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("1fCIW", function(module, exports) {
function $0e953ae8b268618a$var$_iterableToArray(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
module.exports = $0e953ae8b268618a$var$_iterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("02dr6", function(module, exports) {
function $006a9c2e2e7b77d1$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
module.exports = $006a9c2e2e7b77d1$var$_nonIterableSpread, module.exports.__esModule = true, module.exports["default"] = module.exports;

});



parcelRegister("91bv7", function(module, exports) {

$parcel$export(module.exports, "CURRENT_SURFACE_CSS_VAR", function () { return $690d20eb8744d35b$export$9d7b58831ae93caa; });
var $690d20eb8744d35b$export$4ef52930e33717cd = "data-theme";
var $690d20eb8744d35b$export$a00eac3f8684bcd0 = "data-color-mode";
var $690d20eb8744d35b$export$2112803007239c61 = "data-contrast-mode";
var $690d20eb8744d35b$export$352e418ed5b6193a = "data-custom-theme";
var $690d20eb8744d35b$export$2faeed762aac6741 = "light";
var $690d20eb8744d35b$export$6f0c6fb8c80fcc92 = "ds";
var $690d20eb8744d35b$export$4d0c7bbf80185957 = [
    "opacity",
    "font",
    "space",
    "border"
];
var $690d20eb8744d35b$export$dddac1532e822863 = "--".concat($690d20eb8744d35b$export$6f0c6fb8c80fcc92, "-token-not-found");
var $690d20eb8744d35b$export$9d7b58831ae93caa = "--".concat($690d20eb8744d35b$export$6f0c6fb8c80fcc92, "-elevation-surface-current");

});

parcelRegister("cTYUO", function(module, exports) {

$parcel$export(module.exports, "RepositionOnUpdate", function () { return $9649df9d9d4ffe60$export$51eddd7655ca235a; });

var $dAx5m = parcelRequire("dAx5m");
var $9649df9d9d4ffe60$export$51eddd7655ca235a = function RepositionOnUpdate(_ref) {
    var children = _ref.children, update = _ref.update;
    // Ref used here to skip update on first render (when refs haven't been set)
    var isFirstRenderRef = (0, $dAx5m.useRef)(true);
    (0, $dAx5m.useLayoutEffect)(function() {
        if (isFirstRenderRef.current) {
            isFirstRenderRef.current = false;
            return;
        }
        // callback function from popper that repositions pop-up on content Update
        update();
    }, [
        update
    ]);
    // wrapping in fragment to make TS happy (known issue with FC returning children)
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $dAx5m.Fragment), null, children);
};

});

parcelRegister("45cJf", function(module, exports) {

$parcel$export(module.exports, "useCloseManager", function () { return $2f9180b4550f5357$export$92dae2778ae88f9d; });

var $dAx5m = parcelRequire("dAx5m");

var $4ULHc = parcelRequire("4ULHc");

var $Bb0he = parcelRequire("Bb0he");

var $bvMGd = parcelRequire("bvMGd");
var $2f9180b4550f5357$export$92dae2778ae88f9d = function useCloseManager(_ref) {
    var isOpen = _ref.isOpen, onClose = _ref.onClose, popupRef = _ref.popupRef, triggerRef = _ref.triggerRef, capture = _ref.shouldUseCaptureOnOutsideClick, shouldCloseOnTab = _ref.shouldCloseOnTab;
    var _UNSAFE_useLayering = (0, $bvMGd.UNSAFE_useLayering)(), isLayerDisabled = _UNSAFE_useLayering.isLayerDisabled;
    (0, $dAx5m.useEffect)(function() {
        if (!isOpen || !popupRef) return 0, $Bb0he.default;
        var closePopup = function closePopup(event) {
            if (onClose) onClose(event);
        };
        // This check is required for cases where components like
        // Select or DDM are placed inside a Popup. A click
        // on a MenuItem or Option would close the Popup, without registering
        // a click on DDM/Select.
        // Users would have to call `onClose` manually to close the Popup in these cases.
        // You can see the bug in action here:
        // https://codesandbox.io/s/atlaskitpopup-default-forked-2eb87?file=/example.tsx:0-1788
        var onClick = function onClick(event) {
            var target = event.target;
            var doesDomNodeExist = document.body.contains(target);
            if (!doesDomNodeExist) return;
            var isClickOnPopup = popupRef && popupRef.contains(target);
            var isClickOnTrigger = triggerRef && triggerRef.contains(target);
            if (!isClickOnPopup && !isClickOnTrigger) closePopup(event);
        };
        var onKeyDown = function onKeyDown(event) {
            if (isLayerDisabled()) return;
            var key = event.key;
            if (key === "Escape" || key === "Esc" || shouldCloseOnTab && key === "Tab") closePopup(event);
        };
        var unbind = (0, $4ULHc.bindAll)(window, [
            {
                type: "click",
                listener: onClick,
                options: {
                    capture: capture
                }
            },
            {
                type: "keydown",
                listener: onKeyDown
            }
        ]);
        return unbind;
    }, [
        isOpen,
        onClose,
        popupRef,
        triggerRef,
        capture,
        isLayerDisabled,
        shouldCloseOnTab
    ]);
};

});
parcelRegister("4ULHc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.bindAll = module.exports.bind = void 0;

var $f8Jeh = parcelRequire("f8Jeh");
Object.defineProperty(module.exports, "bind", {
    enumerable: true,
    get: function() {
        return $f8Jeh.bind;
    }
});

var $ebKGE = parcelRequire("ebKGE");
Object.defineProperty(module.exports, "bindAll", {
    enumerable: true,
    get: function() {
        return $ebKGE.bindAll;
    }
});

});
parcelRegister("f8Jeh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.bind = void 0;
function $b05aaff880752451$var$bind(target, _a) {
    var type = _a.type, listener = _a.listener, options = _a.options;
    target.addEventListener(type, listener, options);
    return function unbind() {
        target.removeEventListener(type, listener, options);
    };
}
module.exports.bind = $b05aaff880752451$var$bind;

});

parcelRegister("ebKGE", function(module, exports) {
"use strict";
var $a5464ecb5fcd46e9$var$__assign = module.exports && module.exports.__assign || function() {
    $a5464ecb5fcd46e9$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $a5464ecb5fcd46e9$var$__assign.apply(this, arguments);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.bindAll = void 0;

var $f8Jeh = parcelRequire("f8Jeh");
function $a5464ecb5fcd46e9$var$toOptions(value) {
    if (typeof value === "undefined") return undefined;
    if (typeof value === "boolean") return {
        capture: value
    };
    return value;
}
function $a5464ecb5fcd46e9$var$getBinding(original, sharedOptions) {
    if (sharedOptions == null) return original;
    var binding = $a5464ecb5fcd46e9$var$__assign($a5464ecb5fcd46e9$var$__assign({}, original), {
        options: $a5464ecb5fcd46e9$var$__assign($a5464ecb5fcd46e9$var$__assign({}, $a5464ecb5fcd46e9$var$toOptions(sharedOptions)), $a5464ecb5fcd46e9$var$toOptions(original.options))
    });
    return binding;
}
function $a5464ecb5fcd46e9$var$bindAll(target, bindings, sharedOptions) {
    var unbinds = bindings.map(function(original) {
        var binding = $a5464ecb5fcd46e9$var$getBinding(original, sharedOptions);
        return (0, $f8Jeh.bind)(target, binding);
    });
    return function unbindAll() {
        unbinds.forEach(function(unbind) {
            return unbind();
        });
    };
}
module.exports.bindAll = $a5464ecb5fcd46e9$var$bindAll;

});



parcelRegister("l43rK", function(module, exports) {

$parcel$export(module.exports, "useFocusManager", function () { return $f55ca51c4cab18da$export$10c5169755ce7bd7; });

var $dAx5m = parcelRequire("dAx5m");

var $3bwCn = parcelRequire("3bwCn");

var $Bb0he = parcelRequire("Bb0he");
var $f55ca51c4cab18da$export$10c5169755ce7bd7 = function useFocusManager(_ref) {
    var initialFocusRef = _ref.initialFocusRef, popupRef = _ref.popupRef, shouldCloseOnTab = _ref.shouldCloseOnTab;
    (0, $dAx5m.useEffect)(function() {
        if (!popupRef || shouldCloseOnTab) return 0, $Bb0he.default;
        var trapConfig = {
            clickOutsideDeactivates: true,
            escapeDeactivates: true,
            initialFocus: initialFocusRef || popupRef,
            fallbackFocus: popupRef,
            returnFocusOnDeactivate: true
        };
        var focusTrap = (0, (/*@__PURE__*/$parcel$interopDefault($3bwCn)))(popupRef, trapConfig);
        var frameId = null;
        // wait for the popup to reposition itself before we focus
        frameId = requestAnimationFrame(function() {
            frameId = null;
            focusTrap.activate();
        });
        return function() {
            if (frameId != null) {
                cancelAnimationFrame(frameId);
                frameId = null;
            }
            focusTrap.deactivate();
        };
    }, [
        popupRef,
        initialFocusRef,
        shouldCloseOnTab
    ]);
};

});
parcelRegister("3bwCn", function(module, exports) {

var $gUYRy = parcelRequire("gUYRy");
var $251bb36db8277e04$var$listeningFocusTrap = null;
function $251bb36db8277e04$var$focusTrap(element, userOptions) {
    var tabbableNodes = [];
    var firstTabbableNode = null;
    var lastTabbableNode = null;
    var nodeFocusedBeforeActivation = null;
    var active = false;
    var paused = false;
    var tabEvent = null;
    var container = typeof element === "string" ? document.querySelector(element) : element;
    var config = userOptions || {};
    config.returnFocusOnDeactivate = userOptions && userOptions.returnFocusOnDeactivate !== undefined ? userOptions.returnFocusOnDeactivate : true;
    config.escapeDeactivates = userOptions && userOptions.escapeDeactivates !== undefined ? userOptions.escapeDeactivates : true;
    var trap = {
        activate: activate,
        deactivate: deactivate,
        pause: pause,
        unpause: unpause
    };
    return trap;
    function activate(activateOptions) {
        if (active) return;
        var defaultedActivateOptions = {
            onActivate: activateOptions && activateOptions.onActivate !== undefined ? activateOptions.onActivate : config.onActivate
        };
        active = true;
        paused = false;
        nodeFocusedBeforeActivation = document.activeElement;
        if (defaultedActivateOptions.onActivate) defaultedActivateOptions.onActivate();
        addListeners();
        return trap;
    }
    function deactivate(deactivateOptions) {
        if (!active) return;
        var defaultedDeactivateOptions = {
            returnFocus: deactivateOptions && deactivateOptions.returnFocus !== undefined ? deactivateOptions.returnFocus : config.returnFocusOnDeactivate,
            onDeactivate: deactivateOptions && deactivateOptions.onDeactivate !== undefined ? deactivateOptions.onDeactivate : config.onDeactivate
        };
        removeListeners();
        if (defaultedDeactivateOptions.onDeactivate) defaultedDeactivateOptions.onDeactivate();
        if (defaultedDeactivateOptions.returnFocus) setTimeout(function() {
            $251bb36db8277e04$var$tryFocus(nodeFocusedBeforeActivation);
        }, 0);
        active = false;
        paused = false;
        return this;
    }
    function pause() {
        if (paused || !active) return;
        paused = true;
        removeListeners();
    }
    function unpause() {
        if (!paused || !active) return;
        paused = false;
        addListeners();
    }
    function addListeners() {
        if (!active) return;
        // There can be only one listening focus trap at a time
        if ($251bb36db8277e04$var$listeningFocusTrap) $251bb36db8277e04$var$listeningFocusTrap.pause();
        $251bb36db8277e04$var$listeningFocusTrap = trap;
        updateTabbableNodes();
        // Ensure that the focused element doesn't capture the event that caused the focus trap activation
        setTimeout(function() {
            $251bb36db8277e04$var$tryFocus(firstFocusNode());
        }, 0);
        document.addEventListener("focus", checkFocus, true);
        document.addEventListener("click", checkClick, true);
        document.addEventListener("mousedown", checkPointerDown, true);
        document.addEventListener("touchstart", checkPointerDown, true);
        document.addEventListener("keydown", checkKey, true);
        return trap;
    }
    function removeListeners() {
        if (!active || $251bb36db8277e04$var$listeningFocusTrap !== trap) return;
        document.removeEventListener("focus", checkFocus, true);
        document.removeEventListener("click", checkClick, true);
        document.removeEventListener("mousedown", checkPointerDown, true);
        document.removeEventListener("touchstart", checkPointerDown, true);
        document.removeEventListener("keydown", checkKey, true);
        $251bb36db8277e04$var$listeningFocusTrap = null;
        return trap;
    }
    function getNodeForOption(optionName) {
        var optionValue = config[optionName];
        var node = optionValue;
        if (!optionValue) return null;
        if (typeof optionValue === "string") {
            node = document.querySelector(optionValue);
            if (!node) throw new Error("`" + optionName + "` refers to no known node");
        }
        if (typeof optionValue === "function") {
            node = optionValue();
            if (!node) throw new Error("`" + optionName + "` did not return a node");
        }
        return node;
    }
    function firstFocusNode() {
        var node;
        if (getNodeForOption("initialFocus") !== null) node = getNodeForOption("initialFocus");
        else if (container.contains(document.activeElement)) node = document.activeElement;
        else node = tabbableNodes[0] || getNodeForOption("fallbackFocus");
        if (!node) throw new Error("You can't have a focus-trap without at least one focusable element");
        return node;
    }
    // This needs to be done on mousedown and touchstart instead of click
    // so that it precedes the focus event
    function checkPointerDown(e) {
        if (config.clickOutsideDeactivates && !container.contains(e.target)) deactivate({
            returnFocus: false
        });
    }
    function checkClick(e) {
        if (config.clickOutsideDeactivates) return;
        if (container.contains(e.target)) return;
        e.preventDefault();
        e.stopImmediatePropagation();
    }
    function checkFocus(e) {
        if (container.contains(e.target)) return;
        e.preventDefault();
        e.stopImmediatePropagation();
        // Checking for a blur method here resolves a Firefox issue (#15)
        if (typeof e.target.blur === "function") e.target.blur();
        if (tabEvent) readjustFocus(tabEvent);
    }
    function checkKey(e) {
        if (e.key === "Tab" || e.keyCode === 9) handleTab(e);
        if (config.escapeDeactivates !== false && $251bb36db8277e04$var$isEscapeEvent(e)) deactivate();
    }
    function handleTab(e) {
        updateTabbableNodes();
        if (e.target.hasAttribute("tabindex") && Number(e.target.getAttribute("tabindex")) < 0) return tabEvent = e;
        e.preventDefault();
        var currentFocusIndex = tabbableNodes.indexOf(e.target);
        if (e.shiftKey) {
            if (e.target === firstTabbableNode || tabbableNodes.indexOf(e.target) === -1) return $251bb36db8277e04$var$tryFocus(lastTabbableNode);
            return $251bb36db8277e04$var$tryFocus(tabbableNodes[currentFocusIndex - 1]);
        }
        if (e.target === lastTabbableNode) return $251bb36db8277e04$var$tryFocus(firstTabbableNode);
        $251bb36db8277e04$var$tryFocus(tabbableNodes[currentFocusIndex + 1]);
    }
    function updateTabbableNodes() {
        tabbableNodes = $gUYRy(container);
        firstTabbableNode = tabbableNodes[0];
        lastTabbableNode = tabbableNodes[tabbableNodes.length - 1];
    }
    function readjustFocus(e) {
        if (e.shiftKey) return $251bb36db8277e04$var$tryFocus(lastTabbableNode);
        $251bb36db8277e04$var$tryFocus(firstTabbableNode);
    }
}
function $251bb36db8277e04$var$isEscapeEvent(e) {
    return e.key === "Escape" || e.key === "Esc" || e.keyCode === 27;
}
function $251bb36db8277e04$var$tryFocus(node) {
    if (!node || !node.focus) return;
    if (node === document.activeElement) return;
    node.focus();
    if (node.tagName.toLowerCase() === "input") node.select();
}
module.exports = $251bb36db8277e04$var$focusTrap;

});
parcelRegister("gUYRy", function(module, exports) {
module.exports = function(el, options) {
    options = options || {};
    var elementDocument = el.ownerDocument || el;
    var basicTabbables = [];
    var orderedTabbables = [];
    // A node is "available" if
    // - it's computed style
    var isUnavailable = $c5111662b693b50f$var$createIsUnavailable(elementDocument);
    var candidateSelectors = [
        "input",
        "select",
        "a[href]",
        "textarea",
        "button",
        "[tabindex]"
    ];
    var candidates = el.querySelectorAll(candidateSelectors.join(","));
    if (options.includeContainer) {
        var matches = Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
        if (candidateSelectors.some(function(candidateSelector) {
            return matches.call(el, candidateSelector);
        })) {
            candidates = Array.prototype.slice.apply(candidates);
            candidates.unshift(el);
        }
    }
    var candidate, candidateIndexAttr, candidateIndex;
    for(var i = 0, l = candidates.length; i < l; i++){
        candidate = candidates[i];
        candidateIndexAttr = parseInt(candidate.getAttribute("tabindex"), 10);
        candidateIndex = isNaN(candidateIndexAttr) ? candidate.tabIndex : candidateIndexAttr;
        if (candidateIndex < 0 || candidate.tagName === "INPUT" && candidate.type === "hidden" || candidate.disabled || isUnavailable(candidate, elementDocument)) continue;
        if (candidateIndex === 0) basicTabbables.push(candidate);
        else orderedTabbables.push({
            index: i,
            tabIndex: candidateIndex,
            node: candidate
        });
    }
    var tabbableNodes = orderedTabbables.sort(function(a, b) {
        return a.tabIndex === b.tabIndex ? a.index - b.index : a.tabIndex - b.tabIndex;
    }).map(function(a) {
        return a.node;
    });
    Array.prototype.push.apply(tabbableNodes, basicTabbables);
    return tabbableNodes;
};
function $c5111662b693b50f$var$createIsUnavailable(elementDocument) {
    // Node cache must be refreshed on every check, in case
    // the content of the element has changed
    var isOffCache = [];
    // "off" means `display: none;`, as opposed to "hidden",
    // which means `visibility: hidden;`. getComputedStyle
    // accurately reflects visiblity in context but not
    // "off" state, so we need to recursively check parents.
    function isOff(node, nodeComputedStyle) {
        if (node === elementDocument.documentElement) return false;
        // Find the cached node (Array.prototype.find not available in IE9)
        for(var i = 0, length = isOffCache.length; i < length; i++){
            if (isOffCache[i][0] === node) return isOffCache[i][1];
        }
        nodeComputedStyle = nodeComputedStyle || elementDocument.defaultView.getComputedStyle(node);
        var result = false;
        if (nodeComputedStyle.display === "none") result = true;
        else if (node.parentNode) result = isOff(node.parentNode);
        isOffCache.push([
            node,
            result
        ]);
        return result;
    }
    return function isUnavailable(node) {
        if (node === elementDocument.documentElement) return false;
        var computedStyle = elementDocument.defaultView.getComputedStyle(node);
        if (isOff(node, computedStyle)) return true;
        return computedStyle.visibility === "hidden";
    };
}

});






parcelRegister("kSmzo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f32a5bb2f20683b2$export$2e2bcd8739ae039; });
/** @jsx jsx */ 
var $dAx5m = parcelRequire("dAx5m");

var $jVTBW = parcelRequire("jVTBW");

var $10AFn = parcelRequire("10AFn");

var $jFTJS = parcelRequire("jFTJS");
var $bwXEN = parcelRequire("bwXEN");

var $fL9T3 = parcelRequire("fL9T3");

var $9iPyH = parcelRequire("9iPyH");

var $cNZuY = parcelRequire("cNZuY");

var $4mxXK = parcelRequire("4mxXK");
var $f32a5bb2f20683b2$var$spinnerContainerStyles = (0, $bwXEN.xcss)({
    display: "flex",
    minWidth: "160px",
    padding: "space.250",
    justifyContent: "center"
});
var $f32a5bb2f20683b2$var$LoadingIndicator = function LoadingIndicator(_ref) {
    var _ref$statusLabel = _ref.statusLabel, statusLabel = _ref$statusLabel === void 0 ? "Loading" : _ref$statusLabel, testId = _ref.testId;
    return (0, $jVTBW.jsx)((0, $jFTJS.default), {
        xcss: $f32a5bb2f20683b2$var$spinnerContainerStyles
    }, (0, $jVTBW.jsx)((0, $fL9T3.default), {
        size: "small",
        label: statusLabel,
        testId: testId
    }));
};
/**
 *
 * MenuWrapper wraps all the menu items.
 * It handles the logic to close the menu when a MenuItem is clicked, but leaves it open
 * if a CheckboxItem or RadioItem is clicked.
 * It also sets focus to the first menu item when opened.
 */ var $f32a5bb2f20683b2$var$MenuWrapper = function MenuWrapper(_ref2) {
    var children = _ref2.children, isLoading = _ref2.isLoading, maxHeight = _ref2.maxHeight, maxWidth = _ref2.maxWidth, onClose = _ref2.onClose, onUpdate = _ref2.onUpdate, statusLabel = _ref2.statusLabel, setInitialFocusRef = _ref2.setInitialFocusRef, shouldRenderToParent = _ref2.shouldRenderToParent, spacing = _ref2.spacing, testId = _ref2.testId, isTriggeredUsingKeyboard = _ref2.isTriggeredUsingKeyboard, autoFocus = _ref2.autoFocus;
    var _useContext = (0, $dAx5m.useContext)((0, $9iPyH.FocusManagerContext)), menuItemRefs = _useContext.menuItemRefs;
    var closeOnMenuItemClick = function closeOnMenuItemClick(e) {
        var isTargetMenuItemOrDecendant = menuItemRefs.some(function(menuItem) {
            var isCheckboxOrRadio = (0, $cNZuY.default)(menuItem) || (0, $4mxXK.default)(menuItem);
            return menuItem.contains(e.target) && !isCheckboxOrRadio;
        });
        // Close menu if the click is triggered from a MenuItem or
        // its descendant. Don't close the menu if the click is triggered
        // from a MenuItemRadio or MenuItemCheckbox so that the user can
        // select multiple items.
        if (isTargetMenuItemOrDecendant && onClose) onClose(e);
    };
    // Using useEffect here causes a flicker.
    // useLayoutEffect ensures that the update and render happen in the same
    // rAF tick.
    (0, $dAx5m.useLayoutEffect)(function() {
        onUpdate();
    }, [
        isLoading,
        onUpdate
    ]);
    (0, $dAx5m.useEffect)(function() {
        var _menuItemRefs$find;
        var firstFocusableRef = (_menuItemRefs$find = menuItemRefs.find(function(ref) {
            return !ref.hasAttribute("disabled");
        })) !== null && _menuItemRefs$find !== void 0 ? _menuItemRefs$find : null;
        if (shouldRenderToParent && (isTriggeredUsingKeyboard || autoFocus)) firstFocusableRef === null || firstFocusableRef === void 0 || firstFocusableRef.focus();
        setInitialFocusRef === null || setInitialFocusRef === void 0 || setInitialFocusRef(firstFocusableRef);
    }, [
        menuItemRefs,
        setInitialFocusRef,
        autoFocus,
        shouldRenderToParent,
        isTriggeredUsingKeyboard
    ]);
    return (0, $jVTBW.jsx)((0, $10AFn.default), {
        isLoading: isLoading,
        maxHeight: maxHeight,
        maxWidth: maxWidth,
        onClick: closeOnMenuItemClick,
        role: "menu",
        spacing: spacing,
        testId: testId && "".concat(testId, "--menu-group")
    }, isLoading ? (0, $jVTBW.jsx)($f32a5bb2f20683b2$var$LoadingIndicator, {
        statusLabel: statusLabel,
        testId: testId && "".concat(testId, "--loading-indicator")
    }) : children);
};
var $f32a5bb2f20683b2$export$2e2bcd8739ae039 = $f32a5bb2f20683b2$var$MenuWrapper;

});
parcelRegister("10AFn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0bc23bb44d458d2b$export$2e2bcd8739ae039; });

var $4VswB = parcelRequire("4VswB");

var $dtPp3 = parcelRequire("dtPp3");

var $jVTBW = parcelRequire("jVTBW");

var $xcnsi = parcelRequire("xcnsi");

var $kdvLB = parcelRequire("kdvLB");
var $0bc23bb44d458d2b$var$_excluded = [
    "isLoading",
    "maxWidth",
    "minWidth",
    "minHeight",
    "maxHeight",
    "testId",
    "role",
    "spacing",
    "className"
];
var $0bc23bb44d458d2b$var$baseStyles = (0, $jVTBW.css)({
    display: "flex",
    position: "static",
    flexDirection: "column",
    overflow: "auto"
});
/**
 * __Menu group__
 *
 * A menu group includes all the actions or items in a menu.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/menu-group)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ var $0bc23bb44d458d2b$var$MenuGroup = function MenuGroup(_ref) {
    var isLoading = _ref.isLoading, maxWidth = _ref.maxWidth, minWidth = _ref.minWidth, minHeight = _ref.minHeight, maxHeight = _ref.maxHeight, testId = _ref.testId, role = _ref.role, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? "cozy" : _ref$spacing, UNSAFE_className = _ref.className, rest = (0, (/*@__PURE__*/$parcel$interopDefault($dtPp3)))(_ref, $0bc23bb44d458d2b$var$_excluded);
    return (0, $jVTBW.jsx)((0, $kdvLB.SpacingContext).Provider, {
        value: spacing
    }, (0, $jVTBW.jsx)((0, $kdvLB.SELECTION_STYLE_CONTEXT_DO_NOT_USE).Provider, {
        value: "border"
    }, (0, $jVTBW.jsx)("div", (0, (/*@__PURE__*/$parcel$interopDefault($4VswB)))({
        "aria-busy": isLoading,
        style: {
            minWidth: minWidth,
            maxWidth: maxWidth,
            minHeight: minHeight,
            maxHeight: maxHeight
        },
        css: $0bc23bb44d458d2b$var$baseStyles,
        "data-testid": testId,
        role: role,
        className: (0, $xcnsi.getBooleanFF)("platform.design-system-team.unsafe-overrides-killswitch_c8j9m") ? undefined : UNSAFE_className
    }, rest))));
};
var $0bc23bb44d458d2b$export$2e2bcd8739ae039 = $0bc23bb44d458d2b$var$MenuGroup;

});

parcelRegister("jFTJS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e52d1542b8dc419b$export$2e2bcd8739ae039; });

var $ikNYA = parcelRequire("ikNYA");

var $gd5aU = parcelRequire("gd5aU");

var $dAx5m = parcelRequire("dAx5m");

var $jVTBW = parcelRequire("jVTBW");

var $dRJak = parcelRequire("dRJak");

var $bwXEN = parcelRequire("bwXEN");

var $gU8SP = parcelRequire("gU8SP");
var $e52d1542b8dc419b$var$_excluded = [
    "as",
    "children",
    "backgroundColor",
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    "style",
    "testId",
    "xcss"
], $e52d1542b8dc419b$var$_excluded2 = [
    "className"
];
var $e52d1542b8dc419b$export$e71c4d32a2263218 = /*#__PURE__*/ (0, $dAx5m.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? "div" : _ref$as, children = _ref.children, backgroundColor = _ref.backgroundColor, padding = _ref.padding, paddingBlock = _ref.paddingBlock, paddingBlockStart = _ref.paddingBlockStart, paddingBlockEnd = _ref.paddingBlockEnd, paddingInline = _ref.paddingInline, paddingInlineStart = _ref.paddingInlineStart, paddingInlineEnd = _ref.paddingInlineEnd, style = _ref.style, testId = _ref.testId, xcss = _ref.xcss, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($gd5aU)))(_ref, $e52d1542b8dc419b$var$_excluded);
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($gd5aU)))(htmlAttributes, $e52d1542b8dc419b$var$_excluded2);
    var resolvedStyles = (0, $bwXEN.parseXcss)(xcss);
    var node = // @ts-expect-error Expression produces a union type that is too complex to represent. I think this is unavoidable
    (0, $jVTBW.jsx)(Component, (0, (/*@__PURE__*/$parcel$interopDefault($ikNYA)))({
        style: style,
        ref: ref,
        className: resolvedStyles.static
    }, safeHtmlAttributes, {
        css: [
            $e52d1542b8dc419b$var$baseStyles,
            backgroundColor && (0, $dRJak.backgroundColorStylesMap)[backgroundColor],
            (0, $dRJak.isSurfaceColorToken)(backgroundColor) && (0, $dRJak.surfaceColorStylesMap)[backgroundColor],
            padding && (0, $dRJak.paddingStylesMap).padding[padding],
            paddingBlock && (0, $dRJak.paddingStylesMap).paddingBlock[paddingBlock],
            paddingBlockStart && (0, $dRJak.paddingStylesMap).paddingBlockStart[paddingBlockStart],
            paddingBlockEnd && (0, $dRJak.paddingStylesMap).paddingBlockEnd[paddingBlockEnd],
            paddingInline && (0, $dRJak.paddingStylesMap).paddingInline[paddingInline],
            paddingInlineStart && (0, $dRJak.paddingStylesMap).paddingInlineStart[paddingInlineStart],
            paddingInlineEnd && (0, $dRJak.paddingStylesMap).paddingInlineEnd[paddingInlineEnd],
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
            resolvedStyles.emotion
        ],
        "data-testid": testId
    }), children);
    return backgroundColor ? (0, $jVTBW.jsx)((0, $gU8SP.SurfaceContext).Provider, {
        value: backgroundColor
    }, node) : node;
});
var $e52d1542b8dc419b$export$2e2bcd8739ae039 = $e52d1542b8dc419b$export$e71c4d32a2263218;
var $e52d1542b8dc419b$var$baseStyles = (0, $jVTBW.css)({
    boxSizing: "border-box",
    appearance: "none",
    border: "none"
});

});
parcelRegister("dRJak", function(module, exports) {

$parcel$export(module.exports, "dimensionMap", function () { return $a183429165e70b47$export$6ccdbebca2ee545f; });
$parcel$export(module.exports, "positiveSpaceMap", function () { return $a183429165e70b47$export$958d0ae7f2977ae4; });
$parcel$export(module.exports, "allSpaceMap", function () { return $a183429165e70b47$export$632685d741f3dbbf; });
$parcel$export(module.exports, "opacityMap", function () { return $a183429165e70b47$export$daf94a976c798b4f; });
$parcel$export(module.exports, "shadowMap", function () { return $a183429165e70b47$export$7aff6e7ba39bb774; });
$parcel$export(module.exports, "borderColorMap", function () { return $a183429165e70b47$export$1531ad5bb3fbedac; });
$parcel$export(module.exports, "backgroundColorMap", function () { return $a183429165e70b47$export$d1d79bf68ac056bd; });
$parcel$export(module.exports, "textColorMap", function () { return $a183429165e70b47$export$8473307aa00d6ea1; });
$parcel$export(module.exports, "layerMap", function () { return $a183429165e70b47$export$b5f31a7e431d2eab; });
$parcel$export(module.exports, "borderWidthMap", function () { return $a183429165e70b47$export$e1b83c5210c471b8; });
$parcel$export(module.exports, "borderRadiusMap", function () { return $a183429165e70b47$export$3c0a6c3e64bb180d; });
$parcel$export(module.exports, "paddingStylesMap", function () { return $a183429165e70b47$export$e615f061ca585a6c; });
$parcel$export(module.exports, "backgroundColorStylesMap", function () { return $a183429165e70b47$export$e7af83bafe7f9e63; });
$parcel$export(module.exports, "surfaceColorStylesMap", function () { return $a183429165e70b47$export$ff257d957d48c421; });
$parcel$export(module.exports, "isSurfaceColorToken", function () { return $a183429165e70b47$export$5e65a44e5b6ecadb; });

var $iriaf = parcelRequire("iriaf");

var $jVTBW = parcelRequire("jVTBW");

var $aQjOC = parcelRequire("aQjOC");
function $a183429165e70b47$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $a183429165e70b47$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $a183429165e70b47$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($iriaf)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $a183429165e70b47$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $a183429165e70b47$export$6ccdbebca2ee545f = {
    "100%": "100%",
    "size.100": "1rem",
    "size.200": "1.5rem",
    "size.300": "2rem",
    "size.400": "2.5rem",
    "size.500": "3rem",
    "size.600": "6rem",
    "size.1000": "12rem"
};
var $a183429165e70b47$export$958d0ae7f2977ae4 = {
    "space.0": "var(--ds-space-0, 0px)",
    "space.025": "var(--ds-space-025, 2px)",
    "space.050": "var(--ds-space-050, 4px)",
    "space.075": "var(--ds-space-075, 6px)",
    "space.100": "var(--ds-space-100, 8px)",
    "space.150": "var(--ds-space-150, 12px)",
    "space.200": "var(--ds-space-200, 16px)",
    "space.250": "var(--ds-space-250, 20px)",
    "space.300": "var(--ds-space-300, 24px)",
    "space.400": "var(--ds-space-400, 32px)",
    "space.500": "var(--ds-space-500, 40px)",
    "space.600": "var(--ds-space-600, 48px)",
    "space.800": "var(--ds-space-800, 64px)",
    "space.1000": "var(--ds-space-1000, 80px)"
};
var $a183429165e70b47$export$d2dc61f58390201c = {
    "space.negative.025": "var(--ds-space-negative-025, -2px)",
    "space.negative.050": "var(--ds-space-negative-050, -4px)",
    "space.negative.075": "var(--ds-space-negative-075, -6px)",
    "space.negative.100": "var(--ds-space-negative-100, -8px)",
    "space.negative.150": "var(--ds-space-negative-150, -12px)",
    "space.negative.200": "var(--ds-space-negative-200, -16px)",
    "space.negative.250": "var(--ds-space-negative-250, -20px)",
    "space.negative.300": "var(--ds-space-negative-300, -24px)",
    "space.negative.400": "var(--ds-space-negative-400, -32px)"
};
var $a183429165e70b47$export$632685d741f3dbbf = $a183429165e70b47$var$_objectSpread($a183429165e70b47$var$_objectSpread({}, $a183429165e70b47$export$958d0ae7f2977ae4), $a183429165e70b47$export$d2dc61f58390201c);
var $a183429165e70b47$export$2185ce37f9bdd963 = {
    "color.background.neutral.bold": "color.text.inverse",
    "color.background.neutral.bold.hovered": "color.text.inverse",
    "color.background.neutral.bold.pressed": "color.text.inverse",
    "color.background.selected.bold": "color.text.inverse",
    "color.background.selected.bold.hovered": "color.text.inverse",
    "color.background.selected.bold.pressed": "color.text.inverse",
    "color.background.brand.bold": "color.text.inverse",
    "color.background.brand.bold.hovered": "color.text.inverse",
    "color.background.brand.bold.pressed": "color.text.inverse",
    "color.background.brand.boldest": "color.text.inverse",
    "color.background.brand.boldest.hovered": "color.text.inverse",
    "color.background.brand.boldest.pressed": "color.text.inverse",
    "color.background.danger.bold": "color.text.inverse",
    "color.background.danger.bold.hovered": "color.text.inverse",
    "color.background.danger.bold.pressed": "color.text.inverse",
    "color.background.warning.bold": "color.text.warning.inverse",
    "color.background.warning.bold.hovered": "color.text.warning.inverse",
    "color.background.warning.bold.pressed": "color.text.warning.inverse",
    "color.background.success.bold": "color.text.inverse",
    "color.background.success.bold.hovered": "color.text.inverse",
    "color.background.success.bold.pressed": "color.text.inverse",
    "color.background.discovery.bold": "color.text.inverse",
    "color.background.discovery.bold.hovered": "color.text.inverse",
    "color.background.discovery.bold.pressed": "color.text.inverse",
    "color.background.information.bold": "color.text.inverse",
    "color.background.information.bold.hovered": "color.text.inverse",
    "color.background.information.bold.pressed": "color.text.inverse"
};
var $a183429165e70b47$export$daf94a976c798b4f = {
    "opacity.disabled": "var(--ds-opacity-disabled, 0.4)",
    "opacity.loading": "var(--ds-opacity-loading, 0.2)"
};
var $a183429165e70b47$export$7aff6e7ba39bb774 = {
    "elevation.shadow.overflow": "var(--ds-shadow-overflow, 0px 0px 8px #091e423f, 0px 0px 1px #091e424f)",
    "elevation.shadow.overflow.perimeter": "var(--ds-shadow-overflow-perimeter, #091e421f)",
    "elevation.shadow.overflow.spread": "var(--ds-shadow-overflow-spread, #091e4229)",
    "elevation.shadow.overlay": "var(--ds-shadow-overlay, 0px 8px 12px #091e423f, 0px 0px 1px #091e424f)",
    "elevation.shadow.raised": "var(--ds-shadow-raised, 0px 1px 1px #091e423f, 0px 0px 1px #091e4221)"
};
var $a183429165e70b47$export$41a358c9c2356760 = {
    "elevation.surface": "var(--ds-surface, #FFFFFF)",
    "elevation.surface.hovered": "var(--ds-surface-hovered, #FAFBFC)",
    "elevation.surface.pressed": "var(--ds-surface-pressed, #F4F5F7)",
    "elevation.surface.overlay": "var(--ds-surface-overlay, #FFFFFF)",
    "elevation.surface.overlay.hovered": "var(--ds-surface-overlay-hovered, #FAFBFC)",
    "elevation.surface.overlay.pressed": "var(--ds-surface-overlay-pressed, #F4F5F7)",
    "elevation.surface.raised": "var(--ds-surface-raised, #FFFFFF)",
    "elevation.surface.raised.hovered": "var(--ds-surface-raised-hovered, #FAFBFC)",
    "elevation.surface.raised.pressed": "var(--ds-surface-raised-pressed, #F4F5F7)",
    "elevation.surface.sunken": "var(--ds-surface-sunken, #F4F5F7)"
};
var $a183429165e70b47$export$1531ad5bb3fbedac = {
    "color.border": "var(--ds-border, #091e4221)",
    "color.border.accent.lime": "var(--ds-border-accent-lime, #6A9A23)",
    "color.border.accent.red": "var(--ds-border-accent-red, #FF5630)",
    "color.border.accent.orange": "var(--ds-border-accent-orange, #D94008)",
    "color.border.accent.yellow": "var(--ds-border-accent-yellow, #FFAB00)",
    "color.border.accent.green": "var(--ds-border-accent-green, #36B37E)",
    "color.border.accent.teal": "var(--ds-border-accent-teal, #00B8D9)",
    "color.border.accent.blue": "var(--ds-border-accent-blue, #0065FF)",
    "color.border.accent.purple": "var(--ds-border-accent-purple, #6554C0)",
    "color.border.accent.magenta": "var(--ds-border-accent-magenta, #CD519D)",
    "color.border.accent.gray": "var(--ds-border-accent-gray, #5E6C84)",
    "color.border.disabled": "var(--ds-border-disabled, #FAFBFC)",
    "color.border.focused": "var(--ds-border-focused, #2684FF)",
    "color.border.input": "var(--ds-border-input, #FAFBFC)",
    "color.border.inverse": "var(--ds-border-inverse, #FFFFFF)",
    "color.border.selected": "var(--ds-border-selected, #0052CC)",
    "color.border.brand": "var(--ds-border-brand, #0052CC)",
    "color.border.danger": "var(--ds-border-danger, #FF5630)",
    "color.border.warning": "var(--ds-border-warning, #FFC400)",
    "color.border.success": "var(--ds-border-success, #00875A)",
    "color.border.discovery": "var(--ds-border-discovery, #998DD9)",
    "color.border.information": "var(--ds-border-information, #0065FF)",
    "color.border.bold": "var(--ds-border-bold, #344563)"
};
var $a183429165e70b47$export$d1d79bf68ac056bd = {
    "color.background.accent.lime.subtlest": "var(--ds-background-accent-lime-subtlest, #EEFBDA)",
    "color.background.accent.lime.subtlest.hovered": "var(--ds-background-accent-lime-subtlest-hovered, #D3F1A7)",
    "color.background.accent.lime.subtlest.pressed": "var(--ds-background-accent-lime-subtlest-pressed, #B3DF72)",
    "color.background.accent.lime.subtler": "var(--ds-background-accent-lime-subtler, #D3F1A7)",
    "color.background.accent.lime.subtler.hovered": "var(--ds-background-accent-lime-subtler-hovered, #B3DF72)",
    "color.background.accent.lime.subtler.pressed": "var(--ds-background-accent-lime-subtler-pressed, #94C748)",
    "color.background.accent.lime.subtle": "var(--ds-background-accent-lime-subtle, #94C748)",
    "color.background.accent.lime.subtle.hovered": "var(--ds-background-accent-lime-subtle-hovered, #B3DF72)",
    "color.background.accent.lime.subtle.pressed": "var(--ds-background-accent-lime-subtle-pressed, #D3F1A7)",
    "color.background.accent.lime.bolder": "var(--ds-background-accent-lime-bolder, #5B7F24)",
    "color.background.accent.lime.bolder.hovered": "var(--ds-background-accent-lime-bolder-hovered, #37471F)",
    "color.background.accent.lime.bolder.pressed": "var(--ds-background-accent-lime-bolder-pressed, #37471F)",
    "color.background.accent.red.subtlest": "var(--ds-background-accent-red-subtlest, #FF8F73)",
    "color.background.accent.red.subtlest.hovered": "var(--ds-background-accent-red-subtlest-hovered, #FF7452)",
    "color.background.accent.red.subtlest.pressed": "var(--ds-background-accent-red-subtlest-pressed, #FF5630)",
    "color.background.accent.red.subtler": "var(--ds-background-accent-red-subtler, #FF7452)",
    "color.background.accent.red.subtler.hovered": "var(--ds-background-accent-red-subtler-hovered, #FF5630)",
    "color.background.accent.red.subtler.pressed": "var(--ds-background-accent-red-subtler-pressed, #DE350B)",
    "color.background.accent.red.subtle": "var(--ds-background-accent-red-subtle, #DE350B)",
    "color.background.accent.red.subtle.hovered": "var(--ds-background-accent-red-subtle-hovered, #FF5630)",
    "color.background.accent.red.subtle.pressed": "var(--ds-background-accent-red-subtle-pressed, #FF7452)",
    "color.background.accent.red.bolder": "var(--ds-background-accent-red-bolder, #DE350B)",
    "color.background.accent.red.bolder.hovered": "var(--ds-background-accent-red-bolder-hovered, #FF5630)",
    "color.background.accent.red.bolder.pressed": "var(--ds-background-accent-red-bolder-pressed, #FF7452)",
    "color.background.accent.orange.subtlest": "var(--ds-background-accent-orange-subtlest, #F18D13)",
    "color.background.accent.orange.subtlest.hovered": "var(--ds-background-accent-orange-subtlest-hovered, #FEC57B)",
    "color.background.accent.orange.subtlest.pressed": "var(--ds-background-accent-orange-subtlest-pressed, #FFE2BD)",
    "color.background.accent.orange.subtler": "var(--ds-background-accent-orange-subtler, #B65C02)",
    "color.background.accent.orange.subtler.hovered": "var(--ds-background-accent-orange-subtler-hovered, #F18D13)",
    "color.background.accent.orange.subtler.pressed": "var(--ds-background-accent-orange-subtler-pressed, #FEC57B)",
    "color.background.accent.orange.subtle": "var(--ds-background-accent-orange-subtle, #5F3811)",
    "color.background.accent.orange.subtle.hovered": "var(--ds-background-accent-orange-subtle-hovered, #974F0C)",
    "color.background.accent.orange.subtle.pressed": "var(--ds-background-accent-orange-subtle-pressed, #B65C02)",
    "color.background.accent.orange.bolder": "var(--ds-background-accent-orange-bolder, #43290F)",
    "color.background.accent.orange.bolder.hovered": "var(--ds-background-accent-orange-bolder-hovered, #5F3811)",
    "color.background.accent.orange.bolder.pressed": "var(--ds-background-accent-orange-bolder-pressed, #974F0C)",
    "color.background.accent.yellow.subtlest": "var(--ds-background-accent-yellow-subtlest, #FFE380)",
    "color.background.accent.yellow.subtlest.hovered": "var(--ds-background-accent-yellow-subtlest-hovered, #FFC400)",
    "color.background.accent.yellow.subtlest.pressed": "var(--ds-background-accent-yellow-subtlest-pressed, #FFAB00)",
    "color.background.accent.yellow.subtler": "var(--ds-background-accent-yellow-subtler, #FFC400)",
    "color.background.accent.yellow.subtler.hovered": "var(--ds-background-accent-yellow-subtler-hovered, #FFAB00)",
    "color.background.accent.yellow.subtler.pressed": "var(--ds-background-accent-yellow-subtler-pressed, #FF991F)",
    "color.background.accent.yellow.subtle": "var(--ds-background-accent-yellow-subtle, #FF991F)",
    "color.background.accent.yellow.subtle.hovered": "var(--ds-background-accent-yellow-subtle-hovered, #FFAB00)",
    "color.background.accent.yellow.subtle.pressed": "var(--ds-background-accent-yellow-subtle-pressed, #FFC400)",
    "color.background.accent.yellow.bolder": "var(--ds-background-accent-yellow-bolder, #FF991F)",
    "color.background.accent.yellow.bolder.hovered": "var(--ds-background-accent-yellow-bolder-hovered, #FFAB00)",
    "color.background.accent.yellow.bolder.pressed": "var(--ds-background-accent-yellow-bolder-pressed, #FFC400)",
    "color.background.accent.green.subtlest": "var(--ds-background-accent-green-subtlest, #79F2C0)",
    "color.background.accent.green.subtlest.hovered": "var(--ds-background-accent-green-subtlest-hovered, #57D9A3)",
    "color.background.accent.green.subtlest.pressed": "var(--ds-background-accent-green-subtlest-pressed, #36B37E)",
    "color.background.accent.green.subtler": "var(--ds-background-accent-green-subtler, #57D9A3)",
    "color.background.accent.green.subtler.hovered": "var(--ds-background-accent-green-subtler-hovered, #36B37E)",
    "color.background.accent.green.subtler.pressed": "var(--ds-background-accent-green-subtler-pressed, #00875A)",
    "color.background.accent.green.subtle": "var(--ds-background-accent-green-subtle, #00875A)",
    "color.background.accent.green.subtle.hovered": "var(--ds-background-accent-green-subtle-hovered, #36B37E)",
    "color.background.accent.green.subtle.pressed": "var(--ds-background-accent-green-subtle-pressed, #57D9A3)",
    "color.background.accent.green.bolder": "var(--ds-background-accent-green-bolder, #00875A)",
    "color.background.accent.green.bolder.hovered": "var(--ds-background-accent-green-bolder-hovered, #36B37E)",
    "color.background.accent.green.bolder.pressed": "var(--ds-background-accent-green-bolder-pressed, #57D9A3)",
    "color.background.accent.teal.subtlest": "var(--ds-background-accent-teal-subtlest, #79E2F2)",
    "color.background.accent.teal.subtlest.hovered": "var(--ds-background-accent-teal-subtlest-hovered, #00C7E6)",
    "color.background.accent.teal.subtlest.pressed": "var(--ds-background-accent-teal-subtlest-pressed, #00B8D9)",
    "color.background.accent.teal.subtler": "var(--ds-background-accent-teal-subtler, #00C7E6)",
    "color.background.accent.teal.subtler.hovered": "var(--ds-background-accent-teal-subtler-hovered, #00B8D9)",
    "color.background.accent.teal.subtler.pressed": "var(--ds-background-accent-teal-subtler-pressed, #00A3BF)",
    "color.background.accent.teal.subtle": "var(--ds-background-accent-teal-subtle, #00A3BF)",
    "color.background.accent.teal.subtle.hovered": "var(--ds-background-accent-teal-subtle-hovered, #00B8D9)",
    "color.background.accent.teal.subtle.pressed": "var(--ds-background-accent-teal-subtle-pressed, #00C7E6)",
    "color.background.accent.teal.bolder": "var(--ds-background-accent-teal-bolder, #00A3BF)",
    "color.background.accent.teal.bolder.hovered": "var(--ds-background-accent-teal-bolder-hovered, #00B8D9)",
    "color.background.accent.teal.bolder.pressed": "var(--ds-background-accent-teal-bolder-pressed, #00C7E6)",
    "color.background.accent.blue.subtlest": "var(--ds-background-accent-blue-subtlest, #4C9AFF)",
    "color.background.accent.blue.subtlest.hovered": "var(--ds-background-accent-blue-subtlest-hovered, #2684FF)",
    "color.background.accent.blue.subtlest.pressed": "var(--ds-background-accent-blue-subtlest-pressed, #0065FF)",
    "color.background.accent.blue.subtler": "var(--ds-background-accent-blue-subtler, #2684FF)",
    "color.background.accent.blue.subtler.hovered": "var(--ds-background-accent-blue-subtler-hovered, #0065FF)",
    "color.background.accent.blue.subtler.pressed": "var(--ds-background-accent-blue-subtler-pressed, #0052CC)",
    "color.background.accent.blue.subtle": "var(--ds-background-accent-blue-subtle, #0052CC)",
    "color.background.accent.blue.subtle.hovered": "var(--ds-background-accent-blue-subtle-hovered, #0065FF)",
    "color.background.accent.blue.subtle.pressed": "var(--ds-background-accent-blue-subtle-pressed, #2684FF)",
    "color.background.accent.blue.bolder": "var(--ds-background-accent-blue-bolder, #0052CC)",
    "color.background.accent.blue.bolder.hovered": "var(--ds-background-accent-blue-bolder-hovered, #0065FF)",
    "color.background.accent.blue.bolder.pressed": "var(--ds-background-accent-blue-bolder-pressed, #2684FF)",
    "color.background.accent.purple.subtlest": "var(--ds-background-accent-purple-subtlest, #998DD9)",
    "color.background.accent.purple.subtlest.hovered": "var(--ds-background-accent-purple-subtlest-hovered, #8777D9)",
    "color.background.accent.purple.subtlest.pressed": "var(--ds-background-accent-purple-subtlest-pressed, #6554C0)",
    "color.background.accent.purple.subtler": "var(--ds-background-accent-purple-subtler, #8777D9)",
    "color.background.accent.purple.subtler.hovered": "var(--ds-background-accent-purple-subtler-hovered, #6554C0)",
    "color.background.accent.purple.subtler.pressed": "var(--ds-background-accent-purple-subtler-pressed, #5243AA)",
    "color.background.accent.purple.subtle": "var(--ds-background-accent-purple-subtle, #5243AA)",
    "color.background.accent.purple.subtle.hovered": "var(--ds-background-accent-purple-subtle-hovered, #6554C0)",
    "color.background.accent.purple.subtle.pressed": "var(--ds-background-accent-purple-subtle-pressed, #8777D9)",
    "color.background.accent.purple.bolder": "var(--ds-background-accent-purple-bolder, #5243AA)",
    "color.background.accent.purple.bolder.hovered": "var(--ds-background-accent-purple-bolder-hovered, #6554C0)",
    "color.background.accent.purple.bolder.pressed": "var(--ds-background-accent-purple-bolder-pressed, #8777D9)",
    "color.background.accent.magenta.subtlest": "var(--ds-background-accent-magenta-subtlest, #FFECF8)",
    "color.background.accent.magenta.subtlest.hovered": "var(--ds-background-accent-magenta-subtlest-hovered, #FDD0EC)",
    "color.background.accent.magenta.subtlest.pressed": "var(--ds-background-accent-magenta-subtlest-pressed, #F797D2)",
    "color.background.accent.magenta.subtler": "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
    "color.background.accent.magenta.subtler.hovered": "var(--ds-background-accent-magenta-subtler-hovered, #F797D2)",
    "color.background.accent.magenta.subtler.pressed": "var(--ds-background-accent-magenta-subtler-pressed, #E774BB)",
    "color.background.accent.magenta.subtle": "var(--ds-background-accent-magenta-subtle, #E774BB)",
    "color.background.accent.magenta.subtle.hovered": "var(--ds-background-accent-magenta-subtle-hovered, #F797D2)",
    "color.background.accent.magenta.subtle.pressed": "var(--ds-background-accent-magenta-subtle-pressed, #FDD0EC)",
    "color.background.accent.magenta.bolder": "var(--ds-background-accent-magenta-bolder, #AE4787)",
    "color.background.accent.magenta.bolder.hovered": "var(--ds-background-accent-magenta-bolder-hovered, #943D73)",
    "color.background.accent.magenta.bolder.pressed": "var(--ds-background-accent-magenta-bolder-pressed, #50253F)",
    "color.background.accent.gray.subtlest": "var(--ds-background-accent-gray-subtlest, #6B778C)",
    "color.background.accent.gray.subtlest.hovered": "var(--ds-background-accent-gray-subtlest-hovered, #5E6C84)",
    "color.background.accent.gray.subtlest.pressed": "var(--ds-background-accent-gray-subtlest-pressed, #505F79)",
    "color.background.accent.gray.subtler": "var(--ds-background-accent-gray-subtler, #5E6C84)",
    "color.background.accent.gray.subtler.hovered": "var(--ds-background-accent-gray-subtler-hovered, #505F79)",
    "color.background.accent.gray.subtler.pressed": "var(--ds-background-accent-gray-subtler-pressed, #42526E)",
    "color.background.accent.gray.subtle": "var(--ds-background-accent-gray-subtle, #505F79)",
    "color.background.accent.gray.subtle.hovered": "var(--ds-background-accent-gray-subtle-hovered, #5E6C84)",
    "color.background.accent.gray.subtle.pressed": "var(--ds-background-accent-gray-subtle-pressed, #6B778C)",
    "color.background.accent.gray.bolder": "var(--ds-background-accent-gray-bolder, #42526E)",
    "color.background.accent.gray.bolder.hovered": "var(--ds-background-accent-gray-bolder-hovered, #344563)",
    "color.background.accent.gray.bolder.pressed": "var(--ds-background-accent-gray-bolder-pressed, #253858)",
    "color.background.disabled": "var(--ds-background-disabled, #091e4289)",
    "color.background.input": "var(--ds-background-input, #FAFBFC)",
    "color.background.input.hovered": "var(--ds-background-input-hovered, #EBECF0)",
    "color.background.input.pressed": "var(--ds-background-input-pressed, #FFFFFF)",
    "color.background.inverse.subtle": "var(--ds-background-inverse-subtle, #00000029)",
    "color.background.inverse.subtle.hovered": "var(--ds-background-inverse-subtle-hovered, #0000003D)",
    "color.background.inverse.subtle.pressed": "var(--ds-background-inverse-subtle-pressed, #00000052)",
    "color.background.neutral": "var(--ds-background-neutral, #DFE1E6)",
    "color.background.neutral.hovered": "var(--ds-background-neutral-hovered, #091e4214)",
    "color.background.neutral.pressed": "var(--ds-background-neutral-pressed, #B3D4FF)",
    "color.background.neutral.subtle": "var(--ds-background-neutral-subtle, transparent)",
    "color.background.neutral.subtle.hovered": "var(--ds-background-neutral-subtle-hovered, #091e4214)",
    "color.background.neutral.subtle.pressed": "var(--ds-background-neutral-subtle-pressed, #B3D4FF)",
    "color.background.neutral.bold": "var(--ds-background-neutral-bold, #42526E)",
    "color.background.neutral.bold.hovered": "var(--ds-background-neutral-bold-hovered, #505F79)",
    "color.background.neutral.bold.pressed": "var(--ds-background-neutral-bold-pressed, #344563)",
    "color.background.selected": "var(--ds-background-selected, #DEEBFF)",
    "color.background.selected.hovered": "var(--ds-background-selected-hovered, #B3D4FF)",
    "color.background.selected.pressed": "var(--ds-background-selected-pressed, #4C9AFF)",
    "color.background.selected.bold": "var(--ds-background-selected-bold, #0052CC)",
    "color.background.selected.bold.hovered": "var(--ds-background-selected-bold-hovered, #2684FF)",
    "color.background.selected.bold.pressed": "var(--ds-background-selected-bold-pressed, #0052CC)",
    "color.background.brand.subtlest": "var(--ds-background-brand-subtlest, #B3D4FF)",
    "color.background.brand.subtlest.hovered": "var(--ds-background-brand-subtlest-hovered, #DEEBFF)",
    "color.background.brand.subtlest.pressed": "var(--ds-background-brand-subtlest-pressed, #4C9AFF)",
    "color.background.brand.bold": "var(--ds-background-brand-bold, #0052CC)",
    "color.background.brand.bold.hovered": "var(--ds-background-brand-bold-hovered, #0065FF)",
    "color.background.brand.bold.pressed": "var(--ds-background-brand-bold-pressed, #0747A6)",
    "color.background.brand.boldest": "var(--ds-background-brand-boldest, #0747A6)",
    "color.background.brand.boldest.hovered": "var(--ds-background-brand-boldest-hovered, #0052CC)",
    "color.background.brand.boldest.pressed": "var(--ds-background-brand-boldest-pressed, #0747A6)",
    "color.background.danger": "var(--ds-background-danger, #FFEBE6)",
    "color.background.danger.hovered": "var(--ds-background-danger-hovered, #FFBDAD)",
    "color.background.danger.pressed": "var(--ds-background-danger-pressed, #FF8F73)",
    "color.background.danger.bold": "var(--ds-background-danger-bold, #DE350B)",
    "color.background.danger.bold.hovered": "var(--ds-background-danger-bold-hovered, #FF5630)",
    "color.background.danger.bold.pressed": "var(--ds-background-danger-bold-pressed, #BF2600)",
    "color.background.warning": "var(--ds-background-warning, #FFFAE6)",
    "color.background.warning.hovered": "var(--ds-background-warning-hovered, #FFF0B3)",
    "color.background.warning.pressed": "var(--ds-background-warning-pressed, #FFE380)",
    "color.background.warning.bold": "var(--ds-background-warning-bold, #FFAB00)",
    "color.background.warning.bold.hovered": "var(--ds-background-warning-bold-hovered, #FFC400)",
    "color.background.warning.bold.pressed": "var(--ds-background-warning-bold-pressed, #FF991F)",
    "color.background.success": "var(--ds-background-success, #E3FCEF)",
    "color.background.success.hovered": "var(--ds-background-success-hovered, #ABF5D1)",
    "color.background.success.pressed": "var(--ds-background-success-pressed, #79F2C0)",
    "color.background.success.bold": "var(--ds-background-success-bold, #00875A)",
    "color.background.success.bold.hovered": "var(--ds-background-success-bold-hovered, #57D9A3)",
    "color.background.success.bold.pressed": "var(--ds-background-success-bold-pressed, #00875A)",
    "color.background.discovery": "var(--ds-background-discovery, #EAE6FF)",
    "color.background.discovery.hovered": "var(--ds-background-discovery-hovered, #C0B6F2)",
    "color.background.discovery.pressed": "var(--ds-background-discovery-pressed, #998DD9)",
    "color.background.discovery.bold": "var(--ds-background-discovery-bold, #5243AA)",
    "color.background.discovery.bold.hovered": "var(--ds-background-discovery-bold-hovered, #8777D9)",
    "color.background.discovery.bold.pressed": "var(--ds-background-discovery-bold-pressed, #5243AA)",
    "color.background.information": "var(--ds-background-information, #DEEBFF)",
    "color.background.information.hovered": "var(--ds-background-information-hovered, #B3D4FF)",
    "color.background.information.pressed": "var(--ds-background-information-pressed, #4C9AFF)",
    "color.background.information.bold": "var(--ds-background-information-bold, #0052CC)",
    "color.background.information.bold.hovered": "var(--ds-background-information-bold-hovered, #2684FF)",
    "color.background.information.bold.pressed": "var(--ds-background-information-bold-pressed, #0052CC)",
    "color.blanket": "var(--ds-blanket, #091e4289)",
    "color.blanket.selected": "var(--ds-blanket-selected, #388BFF14)",
    "color.blanket.danger": "var(--ds-blanket-danger, #EF5C4814)",
    "elevation.surface": "var(--ds-surface, #FFFFFF)",
    "elevation.surface.hovered": "var(--ds-surface-hovered, #FAFBFC)",
    "elevation.surface.pressed": "var(--ds-surface-pressed, #F4F5F7)",
    "elevation.surface.overlay": "var(--ds-surface-overlay, #FFFFFF)",
    "elevation.surface.overlay.hovered": "var(--ds-surface-overlay-hovered, #FAFBFC)",
    "elevation.surface.overlay.pressed": "var(--ds-surface-overlay-pressed, #F4F5F7)",
    "elevation.surface.raised": "var(--ds-surface-raised, #FFFFFF)",
    "elevation.surface.raised.hovered": "var(--ds-surface-raised-hovered, #FAFBFC)",
    "elevation.surface.raised.pressed": "var(--ds-surface-raised-pressed, #F4F5F7)",
    "elevation.surface.sunken": "var(--ds-surface-sunken, #F4F5F7)",
    "utility.elevation.surface.current": "var(--ds-elevation-surface-current, #FFFFFF)"
};
var $a183429165e70b47$export$8473307aa00d6ea1 = {
    "color.text": "var(--ds-text, #172B4D)",
    "color.text.accent.lime": "var(--ds-text-accent-lime, #4C6B1F)",
    "color.text.accent.lime.bolder": "var(--ds-text-accent-lime-bolder, #37471F)",
    "color.text.accent.red": "var(--ds-text-accent-red, #DE350B)",
    "color.text.accent.red.bolder": "var(--ds-text-accent-red-bolder, #BF2600)",
    "color.text.accent.orange": "var(--ds-text-accent-orange, #F18D13)",
    "color.text.accent.orange.bolder": "var(--ds-text-accent-orange-bolder, #B65C02)",
    "color.text.accent.yellow": "var(--ds-text-accent-yellow, #FF991F)",
    "color.text.accent.yellow.bolder": "var(--ds-text-accent-yellow-bolder, #FF8B00)",
    "color.text.accent.green": "var(--ds-text-accent-green, #00875A)",
    "color.text.accent.green.bolder": "var(--ds-text-accent-green-bolder, #006644)",
    "color.text.accent.teal": "var(--ds-text-accent-teal, #00A3BF)",
    "color.text.accent.teal.bolder": "var(--ds-text-accent-teal-bolder, #008DA6)",
    "color.text.accent.blue": "var(--ds-text-accent-blue, #0052CC)",
    "color.text.accent.blue.bolder": "var(--ds-text-accent-blue-bolder, #0747A6)",
    "color.text.accent.purple": "var(--ds-text-accent-purple, #5243AA)",
    "color.text.accent.purple.bolder": "var(--ds-text-accent-purple-bolder, #403294)",
    "color.text.accent.magenta": "var(--ds-text-accent-magenta, #E774BB)",
    "color.text.accent.magenta.bolder": "var(--ds-text-accent-magenta-bolder, #DA62AC)",
    "color.text.accent.gray": "var(--ds-text-accent-gray, #505F79)",
    "color.text.accent.gray.bolder": "var(--ds-text-accent-gray-bolder, #172B4D)",
    "color.text.disabled": "var(--ds-text-disabled, #A5ADBA)",
    "color.text.inverse": "var(--ds-text-inverse, #FFFFFF)",
    "color.text.selected": "var(--ds-text-selected, #0052CC)",
    "color.text.brand": "var(--ds-text-brand, #0065FF)",
    "color.text.danger": "var(--ds-text-danger, #DE350B)",
    "color.text.warning": "var(--ds-text-warning, #974F0C)",
    "color.text.warning.inverse": "var(--ds-text-warning-inverse, #172B4D)",
    "color.text.success": "var(--ds-text-success, #006644)",
    "color.text.discovery": "var(--ds-text-discovery, #403294)",
    "color.text.information": "var(--ds-text-information, #0052CC)",
    "color.text.subtlest": "var(--ds-text-subtlest, #7A869A)",
    "color.text.subtle": "var(--ds-text-subtle, #42526E)",
    "color.link": "var(--ds-link, #0052CC)",
    "color.link.pressed": "var(--ds-link-pressed, #0747A6)",
    "color.link.visited": "var(--ds-link-visited, #403294)",
    "color.link.visited.pressed": "var(--ds-link-visited-pressed, #403294)"
};
var $a183429165e70b47$export$498780f74be9af68 = {
    "color.icon": "var(--ds-icon, #505F79)",
    "color.icon.accent.lime": "var(--ds-icon-accent-lime, #6A9A23)",
    "color.icon.accent.red": "var(--ds-icon-accent-red, #FF5630)",
    "color.icon.accent.orange": "var(--ds-icon-accent-orange, #D94008)",
    "color.icon.accent.yellow": "var(--ds-icon-accent-yellow, #FFAB00)",
    "color.icon.accent.green": "var(--ds-icon-accent-green, #36B37E)",
    "color.icon.accent.teal": "var(--ds-icon-accent-teal, #00B8D9)",
    "color.icon.accent.blue": "var(--ds-icon-accent-blue, #0065FF)",
    "color.icon.accent.purple": "var(--ds-icon-accent-purple, #6554C0)",
    "color.icon.accent.magenta": "var(--ds-icon-accent-magenta, #CD519D)",
    "color.icon.accent.gray": "var(--ds-icon-accent-gray, #5E6C84)",
    "color.icon.disabled": "var(--ds-icon-disabled, #8993A4)",
    "color.icon.inverse": "var(--ds-icon-inverse, #FFFFFF)",
    "color.icon.selected": "var(--ds-icon-selected, #0052CC)",
    "color.icon.brand": "var(--ds-icon-brand, #0065FF)",
    "color.icon.danger": "var(--ds-icon-danger, #DE350B)",
    "color.icon.warning": "var(--ds-icon-warning, #FFC400)",
    "color.icon.warning.inverse": "var(--ds-icon-warning-inverse, #253858)",
    "color.icon.success": "var(--ds-icon-success, #00875A)",
    "color.icon.discovery": "var(--ds-icon-discovery, #8777D9)",
    "color.icon.information": "var(--ds-icon-information, #0747A6)",
    "color.icon.subtle": "var(--ds-icon-subtle, #6B778C)"
};
var $a183429165e70b47$export$b5f31a7e431d2eab = {
    card: 100,
    navigation: 200,
    dialog: 300,
    layer: 400,
    blanket: 500,
    modal: 510,
    flag: 600,
    spotlight: 700,
    tooltip: 800
};
var $a183429165e70b47$export$e1b83c5210c471b8 = {
    "border.width": "var(--ds-border-width, 1px)",
    "border.width.0": "var(--ds-border-width-0, 0px)",
    "border.width.indicator": "var(--ds-border-width-indicator, 3px)",
    "border.width.outline": "var(--ds-border-width-outline, 2px)"
};
var $a183429165e70b47$export$3c0a6c3e64bb180d = {
    "border.radius.050": "var(--ds-border-radius-050, 2px)",
    "border.radius": "var(--ds-border-radius, 3px)",
    "border.radius.100": "var(--ds-border-radius-100, 3px)",
    "border.radius.200": "var(--ds-border-radius-200, 8px)",
    "border.radius.300": "var(--ds-border-radius-300, 12px)",
    "border.radius.400": "var(--ds-border-radius-400, 16px)",
    "border.radius.circle": "var(--ds-border-radius-circle, 32032px)"
};
var $a183429165e70b47$export$6cc560b4dedf3816 = {
    medium: 'var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    UNSAFE_small: 'var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    large: 'var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    small: 'var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)'
};
var $a183429165e70b47$export$303e322c6b1ed114 = {
    bold: "var(--ds-font-weight-bold, 700)",
    medium: "var(--ds-font-weight-medium, 500)",
    regular: "var(--ds-font-weight-regular, 400)",
    semibold: "var(--ds-font-weight-semibold, 600)"
};
var $a183429165e70b47$export$3c7e9587132614b4 = {
    "font.family.brand.body": 'var(--ds-font-family-brand-body, "Charlie Text", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.family.brand.heading": 'var(--ds-font-family-brand-heading, "Charlie Display", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)'
};
/**
 * @codegenEnd
 */ // Generate maps for Box props. backgroundColor, padding, etc
var $a183429165e70b47$var$spacingProperties = [
    // Used by Box
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    // Used by Inline and Stack
    "gap",
    "rowGap",
    "columnGap"
];
var $a183429165e70b47$var$getSerializedStylesMap = function getSerializedStylesMap(cssProperty, tokenMap) {
    return Object.keys(tokenMap).reduce(function(emotionSpacingMap, token) {
        emotionSpacingMap[token] = (0, $jVTBW.css)((0, (/*@__PURE__*/$parcel$interopDefault($iriaf)))({}, cssProperty, tokenMap[token]));
        return emotionSpacingMap;
    }, {});
};
var $a183429165e70b47$export$e615f061ca585a6c = $a183429165e70b47$var$spacingProperties.reduce(function(styleMap, spacingProperty) {
    styleMap[spacingProperty] = $a183429165e70b47$var$getSerializedStylesMap(spacingProperty, $a183429165e70b47$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
var $a183429165e70b47$export$bf46c3f9eeafc71f = $a183429165e70b47$var$spacingProperties.reduce(function(styleMap, spacingProperty) {
    styleMap[spacingProperty] = $a183429165e70b47$var$getSerializedStylesMap(spacingProperty, $a183429165e70b47$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
var $a183429165e70b47$export$e7af83bafe7f9e63 = $a183429165e70b47$var$getSerializedStylesMap("backgroundColor", $a183429165e70b47$export$d1d79bf68ac056bd);
var $a183429165e70b47$export$3a1bcba60b23d7f0 = $a183429165e70b47$var$getSerializedStylesMap("color", $a183429165e70b47$export$8473307aa00d6ea1);
var $a183429165e70b47$export$45f3f4fe16f9f7d5 = $a183429165e70b47$var$getSerializedStylesMap("fontWeight", $a183429165e70b47$export$303e322c6b1ed114);
var $a183429165e70b47$export$68cc305da27dbaa4 = $a183429165e70b47$var$getSerializedStylesMap("fontFamily", $a183429165e70b47$export$3c7e9587132614b4);
var $a183429165e70b47$export$128f10c238242f83 = $a183429165e70b47$var$getSerializedStylesMap("font", $a183429165e70b47$export$6cc560b4dedf3816);
var $a183429165e70b47$export$ff257d957d48c421 = $a183429165e70b47$var$getSerializedStylesMap((0, $aQjOC.CURRENT_SURFACE_CSS_VAR), $a183429165e70b47$export$41a358c9c2356760);
var $a183429165e70b47$export$5e65a44e5b6ecadb = function isSurfaceColorToken(color) {
    return $a183429165e70b47$export$41a358c9c2356760[color] !== undefined;
};

});

parcelRegister("bwXEN", function(module, exports) {

$parcel$export(module.exports, "parseXcss", function () { return $8650f57ee105370c$export$a9c84988c8f81f2d; });
$parcel$export(module.exports, "xcss", function () { return $8650f57ee105370c$export$f6c783d06584602c; });

var $hwFBe = parcelRequire("hwFBe");

var $iriaf = parcelRequire("iriaf");

var $3hVkQ = parcelRequire("3hVkQ");

var $8P8X8 = parcelRequire("8P8X8");

var $jVTBW = parcelRequire("jVTBW");

var $dRJak = parcelRequire("dRJak");

var $ahJoN = parcelRequire("ahJoN");
function $8650f57ee105370c$var$_createForOfIteratorHelper(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (!it) {
        if (Array.isArray(o) || (it = $8650f57ee105370c$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
            if (it) o = it;
            var i = 0;
            var F = function F() {};
            return {
                s: F,
                n: function n() {
                    if (i >= o.length) return {
                        done: true
                    };
                    return {
                        done: false,
                        value: o[i++]
                    };
                },
                e: function e(_e) {
                    throw _e;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var normalCompletion = true, didErr = false, err;
    return {
        s: function s() {
            it = it.call(o);
        },
        n: function n() {
            var step = it.next();
            normalCompletion = step.done;
            return step;
        },
        e: function e(_e2) {
            didErr = true;
            err = _e2;
        },
        f: function f() {
            try {
                if (!normalCompletion && it.return != null) it.return();
            } finally{
                if (didErr) throw err;
            }
        }
    };
}
function $8650f57ee105370c$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $8650f57ee105370c$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $8650f57ee105370c$var$_arrayLikeToArray(o, minLen);
}
function $8650f57ee105370c$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $8650f57ee105370c$export$9a199fbafee0014e = {
    backgroundColor: (0, $dRJak.backgroundColorMap),
    blockSize: (0, $dRJak.dimensionMap),
    borderBlockColor: (0, $dRJak.borderColorMap),
    borderBlockEndColor: (0, $dRJak.borderColorMap),
    borderBlockEndWidth: (0, $dRJak.borderWidthMap),
    borderBlockStartColor: (0, $dRJak.borderColorMap),
    borderBlockStartWidth: (0, $dRJak.borderWidthMap),
    borderBlockWidth: (0, $dRJak.borderWidthMap),
    borderBottomColor: (0, $dRJak.borderColorMap),
    borderBottomLeftRadius: (0, $dRJak.borderRadiusMap),
    borderBottomRightRadius: (0, $dRJak.borderRadiusMap),
    borderBottomWidth: (0, $dRJak.borderWidthMap),
    borderColor: (0, $dRJak.borderColorMap),
    borderEndEndRadius: (0, $dRJak.borderRadiusMap),
    borderEndStartRadius: (0, $dRJak.borderRadiusMap),
    borderInlineColor: (0, $dRJak.borderColorMap),
    borderInlineEndColor: (0, $dRJak.borderColorMap),
    borderInlineEndWidth: (0, $dRJak.borderWidthMap),
    borderInlineStartColor: (0, $dRJak.borderColorMap),
    borderInlineStartWidth: (0, $dRJak.borderWidthMap),
    borderInlineWidth: (0, $dRJak.borderWidthMap),
    borderLeftColor: (0, $dRJak.borderColorMap),
    borderLeftWidth: (0, $dRJak.borderWidthMap),
    borderRadius: (0, $dRJak.borderRadiusMap),
    borderRightColor: (0, $dRJak.borderColorMap),
    borderRightWidth: (0, $dRJak.borderWidthMap),
    borderStartEndRadius: (0, $dRJak.borderRadiusMap),
    borderStartStartRadius: (0, $dRJak.borderRadiusMap),
    borderTopColor: (0, $dRJak.borderColorMap),
    borderTopLeftRadius: (0, $dRJak.borderRadiusMap),
    borderTopRightRadius: (0, $dRJak.borderRadiusMap),
    borderTopWidth: (0, $dRJak.borderWidthMap),
    borderWidth: (0, $dRJak.borderWidthMap),
    bottom: (0, $dRJak.allSpaceMap),
    boxShadow: (0, $dRJak.shadowMap),
    color: (0, $dRJak.textColorMap),
    columnGap: (0, $dRJak.positiveSpaceMap),
    gap: (0, $dRJak.positiveSpaceMap),
    height: (0, $dRJak.dimensionMap),
    inlineSize: (0, $dRJak.dimensionMap),
    inset: (0, $dRJak.allSpaceMap),
    insetBlock: (0, $dRJak.allSpaceMap),
    insetBlockEnd: (0, $dRJak.allSpaceMap),
    insetBlockStart: (0, $dRJak.allSpaceMap),
    insetInline: (0, $dRJak.allSpaceMap),
    insetInlineEnd: (0, $dRJak.allSpaceMap),
    insetInlineStart: (0, $dRJak.allSpaceMap),
    left: (0, $dRJak.allSpaceMap),
    margin: (0, $dRJak.allSpaceMap),
    marginBlock: (0, $dRJak.allSpaceMap),
    marginBlockEnd: (0, $dRJak.allSpaceMap),
    marginBlockStart: (0, $dRJak.allSpaceMap),
    marginBottom: (0, $dRJak.allSpaceMap),
    marginInline: (0, $dRJak.allSpaceMap),
    marginInlineEnd: (0, $dRJak.allSpaceMap),
    marginInlineStart: (0, $dRJak.allSpaceMap),
    marginLeft: (0, $dRJak.allSpaceMap),
    marginRight: (0, $dRJak.allSpaceMap),
    marginTop: (0, $dRJak.allSpaceMap),
    maxBlockSize: (0, $dRJak.dimensionMap),
    maxHeight: (0, $dRJak.dimensionMap),
    maxInlineSize: (0, $dRJak.dimensionMap),
    maxWidth: (0, $dRJak.dimensionMap),
    minBlockSize: (0, $dRJak.dimensionMap),
    minHeight: (0, $dRJak.dimensionMap),
    minInlineSize: (0, $dRJak.dimensionMap),
    minWidth: (0, $dRJak.dimensionMap),
    opacity: (0, $dRJak.opacityMap),
    outlineColor: (0, $dRJak.borderColorMap),
    outlineOffset: (0, $dRJak.positiveSpaceMap),
    outlineWidth: (0, $dRJak.borderWidthMap),
    padding: (0, $dRJak.positiveSpaceMap),
    paddingBlock: (0, $dRJak.positiveSpaceMap),
    paddingBlockEnd: (0, $dRJak.positiveSpaceMap),
    paddingBlockStart: (0, $dRJak.positiveSpaceMap),
    paddingBottom: (0, $dRJak.positiveSpaceMap),
    paddingInline: (0, $dRJak.positiveSpaceMap),
    paddingInlineEnd: (0, $dRJak.positiveSpaceMap),
    paddingInlineStart: (0, $dRJak.positiveSpaceMap),
    paddingLeft: (0, $dRJak.positiveSpaceMap),
    paddingRight: (0, $dRJak.positiveSpaceMap),
    paddingTop: (0, $dRJak.positiveSpaceMap),
    right: (0, $dRJak.allSpaceMap),
    rowGap: (0, $dRJak.positiveSpaceMap),
    top: (0, $dRJak.allSpaceMap),
    width: (0, $dRJak.dimensionMap),
    zIndex: (0, $dRJak.layerMap)
};
var $8650f57ee105370c$var$uniqueSymbol = Symbol("UNSAFE_INTERNAL_styles");
var $8650f57ee105370c$var$isSafeEnvToThrow = function isSafeEnvToThrow() {
    return (typeof $ahJoN === "undefined" ? "undefined" : (0, (/*@__PURE__*/$parcel$interopDefault($8P8X8)))($ahJoN)) === "object" && (0, (/*@__PURE__*/$parcel$interopDefault($8P8X8)))($ahJoN.env) === "object" && false;
};
var $8650f57ee105370c$var$reNestedSelectors = /(\.|\s|&+|\*\>|#|\[.*\])/;
var $8650f57ee105370c$var$safeSelectors = /^@media .*$|^::?.*$|^@supports .*$/;
var $8650f57ee105370c$var$transformStyles = function transformStyles(styleObj) {
    if (!styleObj || (0, (/*@__PURE__*/$parcel$interopDefault($8P8X8)))(styleObj) !== "object") return styleObj;
    // If styles are defined as a CSSObject[], recursively call on each element until we reach CSSObject
    if (Array.isArray(styleObj)) return styleObj.map(transformStyles);
    // Modifies styleObj in place. Be careful.
    Object.entries(styleObj).forEach(function(_ref) {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($3hVkQ)))(_ref, 2), key = _ref2[0], value = _ref2[1];
        // If key is a pseudo class or a pseudo element, then value should be an object.
        // So, call transformStyles on the value
        if ((0, (/*@__PURE__*/$parcel$interopDefault($8P8X8)))(value) === "object" && $8650f57ee105370c$var$safeSelectors.test(key)) {
            styleObj[key] = transformStyles(value);
            return;
        }
        if ($8650f57ee105370c$var$isSafeEnvToThrow()) {
            // We don't support `.class`, `[data-testid]`, `> *`, `#some-id`
            if ($8650f57ee105370c$var$reNestedSelectors.test(key)) throw new Error("Styles not supported for key '".concat(key, "'."));
        }
        // We have now dealt with all the special cases, so,
        // check whether what remains is a style property
        // that can be transformed.
        if (!(key in $8650f57ee105370c$export$9a199fbafee0014e)) return;
        var tokenValue = $8650f57ee105370c$export$9a199fbafee0014e[key][value];
        styleObj[key] = tokenValue !== null && tokenValue !== void 0 ? tokenValue : value;
    });
    return styleObj;
};
var $8650f57ee105370c$var$baseXcss = function baseXcss(style) {
    var transformedStyles = $8650f57ee105370c$var$transformStyles(style);
    return (0, (/*@__PURE__*/$parcel$interopDefault($iriaf)))({}, $8650f57ee105370c$var$uniqueSymbol, (0, $jVTBW.css)(transformedStyles));
};
var $8650f57ee105370c$export$a9c84988c8f81f2d = function parseXcss(args) {
    if (Array.isArray(args)) {
        var emotion = [];
        var staticArr = [];
        var _iterator = $8650f57ee105370c$var$_createForOfIteratorHelper(args), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var arg = _step.value;
                var result = parseXcss(arg);
                if (result.emotion) emotion.push.apply(emotion, (0, (/*@__PURE__*/$parcel$interopDefault($hwFBe)))(result.emotion));
                if (result.static) staticArr.push(result.static);
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        return {
            emotion: emotion,
            static: staticArr.join(" ")
        };
    }
    var objArgs = args;
    var _ref4 = objArgs || {}, styles = _ref4[$8650f57ee105370c$var$uniqueSymbol];
    if (styles) return {
        emotion: [
            styles
        ]
    };
    if (args) {
        // We use string interpolation here instead of .toString() just
        // in case the resulting object doesn't have the method available.
        var stringifiedArgs = "".concat(args);
        if (stringifiedArgs) return {
            static: stringifiedArgs
        };
    }
    return {};
};
function $8650f57ee105370c$export$f6c783d06584602c(style) {
    return $8650f57ee105370c$var$baseXcss(style);
}

});

parcelRegister("gU8SP", function(module, exports) {

$parcel$export(module.exports, "SurfaceContext", function () { return $c4e8c45cb695b6f3$export$1ca2a26fecb070ae; });

var $dAx5m = parcelRequire("dAx5m");
var $c4e8c45cb695b6f3$export$1ca2a26fecb070ae = /*#__PURE__*/ (0, $dAx5m.createContext)("elevation.surface");
var $c4e8c45cb695b6f3$export$1aeb4f6b93c4540d = function useSurface() {
    return (0, $dAx5m.useContext)($c4e8c45cb695b6f3$export$1ca2a26fecb070ae);
};
$c4e8c45cb695b6f3$export$1ca2a26fecb070ae.displayName = "SurfaceProvider";

});


parcelRegister("cNZuY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9529c3f30cfe3013$export$2e2bcd8739ae039; });
function $9529c3f30cfe3013$export$2e2bcd8739ae039(element) {
    var role = element.getAttribute("role");
    return role === "checkbox" || role === "menuitemcheckbox";
}

});

parcelRegister("4mxXK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $32d38fcb803d1cc1$export$2e2bcd8739ae039; });
function $32d38fcb803d1cc1$export$2e2bcd8739ae039(element) {
    var role = element.getAttribute("role");
    return role === "radio" || role === "menuitemradio";
}

});


parcelRegister("eCFGt", function(module, exports) {

$parcel$export(module.exports, "SelectionStoreContext", function () { return $aa54f2df8ebf2345$export$756f795847463ebd; });
$parcel$export(module.exports, "default", function () { return $aa54f2df8ebf2345$export$2e2bcd8739ae039; });

var $dAx5m = parcelRequire("dAx5m");

var $Bb0he = parcelRequire("Bb0he");
var $aa54f2df8ebf2345$export$756f795847463ebd = /*#__PURE__*/ (0, $dAx5m.createContext)({
    setItemState: (0, $Bb0he.default),
    getItemState: function getItemState() {
        return undefined;
    },
    setGroupState: (0, $Bb0he.default),
    getGroupState: function getGroupState() {
        return {};
    }
});
/**
 * Selection store will persist data as long as it remains mounted.
 * It handles the uncontrolled story for dropdown menu when the menu
 * items can be mounted/unmounted depending if the menu is open or closed.
 */ var $aa54f2df8ebf2345$var$SelectionStore = function SelectionStore(props) {
    var children = props.children;
    var store = (0, $dAx5m.useRef)({});
    var context = (0, $dAx5m.useMemo)(function() {
        return {
            setItemState: function setItemState(group, id, value) {
                if (!store.current[group]) store.current[group] = {};
                store.current[group][id] = value;
            },
            getItemState: function getItemState(group, id) {
                if (!store.current[group]) return undefined;
                return store.current[group][id];
            },
            setGroupState: function setGroupState(group, value) {
                store.current[group] = value;
            },
            getGroupState: function getGroupState(group) {
                return store.current[group] || {};
            }
        };
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement($aa54f2df8ebf2345$export$756f795847463ebd.Provider, {
        value: context
    }, children);
};
var $aa54f2df8ebf2345$export$2e2bcd8739ae039 = $aa54f2df8ebf2345$var$SelectionStore;

});

parcelRegister("7vxAI", function(module, exports) {

$parcel$export(module.exports, "PREFIX", function () { return $57757c27de4a6cd1$export$8a682ae47622dbb9; });
$parcel$export(module.exports, "default", function () { return $57757c27de4a6cd1$export$2e2bcd8739ae039; });

var $dAx5m = parcelRequire("dAx5m");
var $57757c27de4a6cd1$export$8a682ae47622dbb9 = "ds--dropdown--";
var $57757c27de4a6cd1$var$generateRandomString = function generateRandomString() {
    return(// Therefore, so there is no risk of mismatch
    // between server and client generated markup.
    // eslint-disable-next-line @repo/internal/react/disallow-unstable-values
    "".concat($57757c27de4a6cd1$export$8a682ae47622dbb9).concat(Math.random().toString(16).substr(2, 8)));
};
function $57757c27de4a6cd1$export$2e2bcd8739ae039() {
    var cachedId = (0, $dAx5m.useRef)($57757c27de4a6cd1$var$generateRandomString());
    return cachedId.current;
}

});


parcelRegister("azm7k", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7b1e54426beb75e0$var$_react = $7b1e54426beb75e0$var$_interopRequireDefault((parcelRequire("dAx5m")));

var $9eGJl = parcelRequire("9eGJl");
function $7b1e54426beb75e0$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $7b1e54426beb75e0$var$CameraFilledIcon = (props)=>/*#__PURE__*/ $7b1e54426beb75e0$var$_react.default.createElement($9eGJl.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentColor" fill-rule="evenodd"><path d="M2 6.994C2 5.893 2.898 5 3.99 5h16.02C21.108 5 22 5.895 22 6.994v12.012A1.997 1.997 0 0120.01 21H3.99A1.994 1.994 0 012 19.006V6.994zM12 17a4 4 0 100-8 4 4 0 000 8zm5-8c0 .556.448 1 1 1 .556 0 1-.448 1-1 0-.556-.448-1-1-1-.556 0-1 .448-1 1zM8 4c0-.552.453-1 .997-1h6.006c.55 0 .997.444.997 1v1H8V4z"/><circle cx="12" cy="13" r="2"/></g></svg>`
    }, props));
$7b1e54426beb75e0$var$CameraFilledIcon.displayName = "CameraFilledIcon";
var $7b1e54426beb75e0$var$_default = $7b1e54426beb75e0$var$CameraFilledIcon;
module.exports.default = $7b1e54426beb75e0$var$_default;

});

parcelRegister("8nZKD", function(module, exports) {

$parcel$export(module.exports, "ProfileAvatarDropdownMenuIconSize", function () { return $3e7b20b022889d96$export$5811e1cb8e891918; });
var $3e7b20b022889d96$export$5811e1cb8e891918;
(function(ProfileAvatarDropdownMenuIconSize) {
    ProfileAvatarDropdownMenuIconSize["small"] = "small";
    ProfileAvatarDropdownMenuIconSize["medium"] = "medium";
    ProfileAvatarDropdownMenuIconSize["large"] = "large";
    ProfileAvatarDropdownMenuIconSize["xlarge"] = "xlarge";
})($3e7b20b022889d96$export$5811e1cb8e891918 || ($3e7b20b022889d96$export$5811e1cb8e891918 = {}));

});

parcelRegister("f8uxT", function(module, exports) {

$parcel$export(module.exports, "MenuBlanket", function () { return $7376ad18927c5086$export$886a73d17c6e7797; });
$parcel$export(module.exports, "DropdownWrapper", function () { return $7376ad18927c5086$export$5f7211d21bfdae05; });

var $ku6eE = parcelRequire("ku6eE");
const $7376ad18927c5086$export$886a73d17c6e7797 = (0, $ku6eE.default).div`
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
`;
const $7376ad18927c5086$export$5f7211d21bfdae05 = (0, $ku6eE.default).div`
  cursor: pointer;
`;

});



parcelRegister("dnae4", function(module, exports) {

$parcel$export(module.exports, "AvatarSize", function () { return $7d19b8121e4a7a76$export$567ccb944525eaba; });
var $7d19b8121e4a7a76$export$567ccb944525eaba;
(function(AvatarSize) {
    AvatarSize["xsmall"] = "xsmall";
    AvatarSize["small"] = "small";
    AvatarSize["medium"] = "medium";
    AvatarSize["large"] = "large";
    AvatarSize["xlarge"] = "xlarge";
    AvatarSize["xxlarge"] = "xxlarge";
})($7d19b8121e4a7a76$export$567ccb944525eaba || ($7d19b8121e4a7a76$export$567ccb944525eaba = {}));

});

parcelRegister("9LtBD", function(module, exports) {

$parcel$export(module.exports, "AvatarWrapper", function () { return $eae9944447e1af79$export$f7513421c53ce141; });
$parcel$export(module.exports, "AvatarHoverInfo", function () { return $eae9944447e1af79$export$90539ab8066d5f87; });

var $ku6eE = parcelRequire("ku6eE");

var $5MUVm = parcelRequire("5MUVm");

var $gbKg7 = parcelRequire("gbKg7");
const $eae9944447e1af79$var$avatarSizeTimes = (multiplier)=>multiplier * 8; // 8px is the design system base unit
const $eae9944447e1af79$export$9a270941bcff7e77 = {
    xsmall: $eae9944447e1af79$var$avatarSizeTimes(2),
    small: $eae9944447e1af79$var$avatarSizeTimes(3),
    medium: $eae9944447e1af79$var$avatarSizeTimes(4),
    large: $eae9944447e1af79$var$avatarSizeTimes(5),
    xlarge: $eae9944447e1af79$var$avatarSizeTimes(12),
    xxlarge: $eae9944447e1af79$var$avatarSizeTimes(16)
};
const $eae9944447e1af79$var$avatarBorder = 2;
const $eae9944447e1af79$export$f7513421c53ce141 = (0, $ku6eE.default).div`
  position: relative;
  display: block;

  && * {
    box-sizing: content-box;
  }

  &:hover,
  &:focus {
    outline: none;
  }
`;
const $eae9944447e1af79$export$90539ab8066d5f87 = (0, $ku6eE.default).div`
  opacity: 0;
  transition: all 0.25s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  position: absolute;
  top: 0;
  left: 0;
  width: ${({ size: size })=>$eae9944447e1af79$export$9a270941bcff7e77[size]}px;
  height: ${({ size: size })=>$eae9944447e1af79$export$9a270941bcff7e77[size]}px;
  border-radius: 50%;
  margin: ${$eae9944447e1af79$var$avatarBorder}px;

  & > * {
    display: none;
  }

  /* In order to simulate hover event in Cypress */
  &.hover,
  &:hover,
  &:focus {
    opacity: 1;
    transition: opacity 0.25s ease;
    color: ${(0, $gbKg7.default)("color.text.inverse", (0, $5MUVm).N0)};
    background: ${(0, $gbKg7.default)("color.background.neutral.hovered", (0, $5MUVm).N70A)};
    & > * {
      display: block;
    }
  }
`;
const $eae9944447e1af79$export$1e7f2b4fbeabac01 = (0, $ku6eE.default).div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: ${(0, $gbKg7.default)("space.050", "4px")};
`;

});

parcelRegister("lLL9n", function(module, exports) {
$parcel$export(module.exports, "useDeleteUserAvatarMutation", function () { return (parcelRequire("5jCKl")).useDeleteUserAvatarMutation; });
$parcel$export(module.exports, "useMyAvatar", function () { return (parcelRequire("84bHK")).useMyAvatar; });
$parcel$export(module.exports, "useProfileAvatarQuery", function () { return (parcelRequire("8jUEk")).useProfileAvatarQuery; });
$parcel$export(module.exports, "useUpdateUserAvatarMutation", function () { return (parcelRequire("5gNz2")).useUpdateUserAvatarMutation; });
parcelRequire("5jCKl");
parcelRequire("84bHK");
parcelRequire("8jUEk");
parcelRequire("5gNz2");

});
parcelRegister("5jCKl", function(module, exports) {

$parcel$export(module.exports, "useDeleteUserAvatarMutation", function () { return $c1a7115416b022b8$export$8a4180b8368ac4f8; });

var $atFkq = parcelRequire("atFkq");
var $132jP = parcelRequire("132jP");

var $5ehI7 = parcelRequire("5ehI7");

var $1Bj4T = parcelRequire("1Bj4T");

var $8jUEk = parcelRequire("8jUEk");

var $84bHK = parcelRequire("84bHK");
parcelRequire("bXDKf");
var $9MaY0 = parcelRequire("9MaY0");

var $77YRX = parcelRequire("77YRX");
const $c1a7115416b022b8$var$deleteUserAvatarMutationFn = async (userId)=>{
    const { stargateRoot: stargateRoot } = (0, $1Bj4T.getConfig)();
    const url = `${stargateRoot}/users/${userId}/manage/avatar`;
    await fetch(url, {
        method: "DELETE",
        credentials: "include"
    });
    return true;
};
const $c1a7115416b022b8$export$8a4180b8368ac4f8 = (userId)=>{
    const queryClient = (0, $132jP.useQueryClient)();
    const { isError: isError, isLoading: isLoading, mutateAsync: mutateAsync } = (0, $atFkq.useMutation)({
        onSuccess: ()=>{
            queryClient.setQueryData([
                (0, $8jUEk.profileAvatarQueryKey),
                userId
            ], (old)=>old && (0, (/*@__PURE__*/$parcel$interopDefault($5ehI7)))({}, old, {
                    avatarUrl: ""
                }));
            queryClient.setQueryData([
                (0, $84bHK.MyAvatarQueryKey),
                userId
            ], (old)=>old && (0, (/*@__PURE__*/$parcel$interopDefault($5ehI7)))({}, old, {
                    uploaded: false,
                    url: ""
                }));
            queryClient.setQueryData([
                (0, $9MaY0.avatarByAccountIdQueryKey),
                userId
            ], (old)=>old && (0, (/*@__PURE__*/$parcel$interopDefault($5ehI7)))({}, old, {
                    avatarUrl: ""
                }));
        },
        onError: (error)=>{
            (0, $77YRX.logException)(error, "Could not delete avatar");
        },
        mutationFn: async ()=>$c1a7115416b022b8$var$deleteUserAvatarMutationFn(userId)
    });
    return {
        isError: isError,
        isLoading: isLoading,
        mutateAsync: mutateAsync
    };
};

});
parcelRegister("atFkq", function(module, exports) {

$parcel$export(module.exports, "useMutation", function () { return $7a0cabce5ac3b0d6$export$609860bf8b0084c; });

var $dAx5m = parcelRequire("dAx5m");

var $1PXAR = parcelRequire("1PXAR");
var $QaI8V = parcelRequire("QaI8V");
var $iqz0v = parcelRequire("iqz0v");

var $akDF7 = parcelRequire("akDF7");

var $132jP = parcelRequire("132jP");

var $aahK4 = parcelRequire("aahK4");
"use client";
function $7a0cabce5ac3b0d6$export$609860bf8b0084c(arg1, arg2, arg3) {
    const options = (0, $iqz0v.parseMutationArgs)(arg1, arg2, arg3);
    const queryClient = (0, $132jP.useQueryClient)({
        context: options.context
    });
    const [observer] = $dAx5m.useState(()=>new (0, $1PXAR.MutationObserver)(queryClient, options));
    $dAx5m.useEffect(()=>{
        observer.setOptions(options);
    }, [
        observer,
        options
    ]);
    const result = (0, $akDF7.useSyncExternalStore)($dAx5m.useCallback((onStoreChange)=>observer.subscribe((0, $QaI8V.notifyManager).batchCalls(onStoreChange)), [
        observer
    ]), ()=>observer.getCurrentResult(), ()=>observer.getCurrentResult());
    const mutate = $dAx5m.useCallback((variables, mutateOptions)=>{
        observer.mutate(variables, mutateOptions).catch($7a0cabce5ac3b0d6$var$noop);
    }, [
        observer
    ]);
    if (result.error && (0, $aahK4.shouldThrowError)(observer.options.useErrorBoundary, [
        result.error
    ])) throw result.error;
    return {
        ...result,
        mutate: mutate,
        mutateAsync: result.mutate
    };
} // eslint-disable-next-line @typescript-eslint/no-empty-function
function $7a0cabce5ac3b0d6$var$noop() {}

});
parcelRegister("1PXAR", function(module, exports) {

$parcel$export(module.exports, "MutationObserver", function () { return $1568c7dfe150d6bc$export$d3c1860ee66f291a; });

var $a3KTB = parcelRequire("a3KTB");

var $QaI8V = parcelRequire("QaI8V");

var $1RjI5 = parcelRequire("1RjI5");

var $iqz0v = parcelRequire("iqz0v");
// CLASS
class $1568c7dfe150d6bc$export$d3c1860ee66f291a extends (0, $1RjI5.Subscribable) {
    constructor(client, options){
        super();
        this.client = client;
        this.setOptions(options);
        this.bindMethods();
        this.updateResult();
    }
    bindMethods() {
        this.mutate = this.mutate.bind(this);
        this.reset = this.reset.bind(this);
    }
    setOptions(options) {
        var _this$currentMutation;
        const prevOptions = this.options;
        this.options = this.client.defaultMutationOptions(options);
        if (!(0, $iqz0v.shallowEqualObjects)(prevOptions, this.options)) this.client.getMutationCache().notify({
            type: "observerOptionsUpdated",
            mutation: this.currentMutation,
            observer: this
        });
        (_this$currentMutation = this.currentMutation) == null || _this$currentMutation.setOptions(this.options);
    }
    onUnsubscribe() {
        if (!this.hasListeners()) {
            var _this$currentMutation2;
            (_this$currentMutation2 = this.currentMutation) == null || _this$currentMutation2.removeObserver(this);
        }
    }
    onMutationUpdate(action) {
        this.updateResult(); // Determine which callbacks to trigger
        const notifyOptions = {
            listeners: true
        };
        if (action.type === "success") notifyOptions.onSuccess = true;
        else if (action.type === "error") notifyOptions.onError = true;
        this.notify(notifyOptions);
    }
    getCurrentResult() {
        return this.currentResult;
    }
    reset() {
        this.currentMutation = undefined;
        this.updateResult();
        this.notify({
            listeners: true
        });
    }
    mutate(variables, options) {
        this.mutateOptions = options;
        if (this.currentMutation) this.currentMutation.removeObserver(this);
        this.currentMutation = this.client.getMutationCache().build(this.client, {
            ...this.options,
            variables: typeof variables !== "undefined" ? variables : this.options.variables
        });
        this.currentMutation.addObserver(this);
        return this.currentMutation.execute();
    }
    updateResult() {
        const state = this.currentMutation ? this.currentMutation.state : (0, $a3KTB.getDefaultState)();
        const result = {
            ...state,
            isLoading: state.status === "loading",
            isSuccess: state.status === "success",
            isError: state.status === "error",
            isIdle: state.status === "idle",
            mutate: this.mutate,
            reset: this.reset
        };
        this.currentResult = result;
    }
    notify(options) {
        (0, $QaI8V.notifyManager).batch(()=>{
            // First trigger the mutate callbacks
            if (this.mutateOptions && this.hasListeners()) {
                if (options.onSuccess) {
                    var _this$mutateOptions$o, _this$mutateOptions, _this$mutateOptions$o2, _this$mutateOptions2;
                    (_this$mutateOptions$o = (_this$mutateOptions = this.mutateOptions).onSuccess) == null || _this$mutateOptions$o.call(_this$mutateOptions, this.currentResult.data, this.currentResult.variables, this.currentResult.context);
                    (_this$mutateOptions$o2 = (_this$mutateOptions2 = this.mutateOptions).onSettled) == null || _this$mutateOptions$o2.call(_this$mutateOptions2, this.currentResult.data, null, this.currentResult.variables, this.currentResult.context);
                } else if (options.onError) {
                    var _this$mutateOptions$o3, _this$mutateOptions3, _this$mutateOptions$o4, _this$mutateOptions4;
                    (_this$mutateOptions$o3 = (_this$mutateOptions3 = this.mutateOptions).onError) == null || _this$mutateOptions$o3.call(_this$mutateOptions3, this.currentResult.error, this.currentResult.variables, this.currentResult.context);
                    (_this$mutateOptions$o4 = (_this$mutateOptions4 = this.mutateOptions).onSettled) == null || _this$mutateOptions$o4.call(_this$mutateOptions4, undefined, this.currentResult.error, this.currentResult.variables, this.currentResult.context);
                }
            } // Then trigger the listeners
            if (options.listeners) this.listeners.forEach(({ listener: listener })=>{
                listener(this.currentResult);
            });
        });
    }
}

});
parcelRegister("a3KTB", function(module, exports) {

$parcel$export(module.exports, "Mutation", function () { return $752e8fb697e5d345$export$17b8b19c814bcf56; });
$parcel$export(module.exports, "getDefaultState", function () { return $752e8fb697e5d345$export$a1659b54bac3252a; });

var $bgWTi = parcelRequire("bgWTi");

var $QaI8V = parcelRequire("QaI8V");

var $ejGTl = parcelRequire("ejGTl");

var $gbAXU = parcelRequire("gbAXU");
// CLASS
class $752e8fb697e5d345$export$17b8b19c814bcf56 extends (0, $ejGTl.Removable) {
    constructor(config){
        super();
        this.defaultOptions = config.defaultOptions;
        this.mutationId = config.mutationId;
        this.mutationCache = config.mutationCache;
        this.logger = config.logger || (0, $bgWTi.defaultLogger);
        this.observers = [];
        this.state = config.state || $752e8fb697e5d345$export$a1659b54bac3252a();
        this.setOptions(config.options);
        this.scheduleGc();
    }
    setOptions(options) {
        this.options = {
            ...this.defaultOptions,
            ...options
        };
        this.updateCacheTime(this.options.cacheTime);
    }
    get meta() {
        return this.options.meta;
    }
    setState(state) {
        this.dispatch({
            type: "setState",
            state: state
        });
    }
    addObserver(observer) {
        if (!this.observers.includes(observer)) {
            this.observers.push(observer); // Stop the mutation from being garbage collected
            this.clearGcTimeout();
            this.mutationCache.notify({
                type: "observerAdded",
                mutation: this,
                observer: observer
            });
        }
    }
    removeObserver(observer) {
        this.observers = this.observers.filter((x)=>x !== observer);
        this.scheduleGc();
        this.mutationCache.notify({
            type: "observerRemoved",
            mutation: this,
            observer: observer
        });
    }
    optionalRemove() {
        if (!this.observers.length) {
            if (this.state.status === "loading") this.scheduleGc();
            else this.mutationCache.remove(this);
        }
    }
    continue() {
        var _this$retryer$continu, _this$retryer;
        return (_this$retryer$continu = (_this$retryer = this.retryer) == null ? void 0 : _this$retryer.continue()) != null ? _this$retryer$continu : this.execute();
    }
    async execute() {
        const executeMutation = ()=>{
            var _this$options$retry;
            this.retryer = (0, $gbAXU.createRetryer)({
                fn: ()=>{
                    if (!this.options.mutationFn) return Promise.reject("No mutationFn found");
                    return this.options.mutationFn(this.state.variables);
                },
                onFail: (failureCount, error)=>{
                    this.dispatch({
                        type: "failed",
                        failureCount: failureCount,
                        error: error
                    });
                },
                onPause: ()=>{
                    this.dispatch({
                        type: "pause"
                    });
                },
                onContinue: ()=>{
                    this.dispatch({
                        type: "continue"
                    });
                },
                retry: (_this$options$retry = this.options.retry) != null ? _this$options$retry : 0,
                retryDelay: this.options.retryDelay,
                networkMode: this.options.networkMode
            });
            return this.retryer.promise;
        };
        const restored = this.state.status === "loading";
        try {
            var _this$mutationCache$c3, _this$mutationCache$c4, _this$options$onSucce, _this$options2, _this$mutationCache$c5, _this$mutationCache$c6, _this$options$onSettl, _this$options3;
            if (!restored) {
                var _this$mutationCache$c, _this$mutationCache$c2, _this$options$onMutat, _this$options;
                this.dispatch({
                    type: "loading",
                    variables: this.options.variables
                }); // Notify cache callback
                await ((_this$mutationCache$c = (_this$mutationCache$c2 = this.mutationCache.config).onMutate) == null ? void 0 : _this$mutationCache$c.call(_this$mutationCache$c2, this.state.variables, this));
                const context = await ((_this$options$onMutat = (_this$options = this.options).onMutate) == null ? void 0 : _this$options$onMutat.call(_this$options, this.state.variables));
                if (context !== this.state.context) this.dispatch({
                    type: "loading",
                    context: context,
                    variables: this.state.variables
                });
            }
            const data = await executeMutation(); // Notify cache callback
            await ((_this$mutationCache$c3 = (_this$mutationCache$c4 = this.mutationCache.config).onSuccess) == null ? void 0 : _this$mutationCache$c3.call(_this$mutationCache$c4, data, this.state.variables, this.state.context, this));
            await ((_this$options$onSucce = (_this$options2 = this.options).onSuccess) == null ? void 0 : _this$options$onSucce.call(_this$options2, data, this.state.variables, this.state.context)); // Notify cache callback
            await ((_this$mutationCache$c5 = (_this$mutationCache$c6 = this.mutationCache.config).onSettled) == null ? void 0 : _this$mutationCache$c5.call(_this$mutationCache$c6, data, null, this.state.variables, this.state.context, this));
            await ((_this$options$onSettl = (_this$options3 = this.options).onSettled) == null ? void 0 : _this$options$onSettl.call(_this$options3, data, null, this.state.variables, this.state.context));
            this.dispatch({
                type: "success",
                data: data
            });
            return data;
        } catch (error) {
            try {
                var _this$mutationCache$c7, _this$mutationCache$c8, _this$options$onError, _this$options4, _this$mutationCache$c9, _this$mutationCache$c10, _this$options$onSettl2, _this$options5;
                // Notify cache callback
                await ((_this$mutationCache$c7 = (_this$mutationCache$c8 = this.mutationCache.config).onError) == null ? void 0 : _this$mutationCache$c7.call(_this$mutationCache$c8, error, this.state.variables, this.state.context, this));
                await ((_this$options$onError = (_this$options4 = this.options).onError) == null ? void 0 : _this$options$onError.call(_this$options4, error, this.state.variables, this.state.context)); // Notify cache callback
                await ((_this$mutationCache$c9 = (_this$mutationCache$c10 = this.mutationCache.config).onSettled) == null ? void 0 : _this$mutationCache$c9.call(_this$mutationCache$c10, undefined, error, this.state.variables, this.state.context, this));
                await ((_this$options$onSettl2 = (_this$options5 = this.options).onSettled) == null ? void 0 : _this$options$onSettl2.call(_this$options5, undefined, error, this.state.variables, this.state.context));
                throw error;
            } finally{
                this.dispatch({
                    type: "error",
                    error: error
                });
            }
        }
    }
    dispatch(action) {
        const reducer = (state)=>{
            switch(action.type){
                case "failed":
                    return {
                        ...state,
                        failureCount: action.failureCount,
                        failureReason: action.error
                    };
                case "pause":
                    return {
                        ...state,
                        isPaused: true
                    };
                case "continue":
                    return {
                        ...state,
                        isPaused: false
                    };
                case "loading":
                    return {
                        ...state,
                        context: action.context,
                        data: undefined,
                        failureCount: 0,
                        failureReason: null,
                        error: null,
                        isPaused: !(0, $gbAXU.canFetch)(this.options.networkMode),
                        status: "loading",
                        variables: action.variables
                    };
                case "success":
                    return {
                        ...state,
                        data: action.data,
                        failureCount: 0,
                        failureReason: null,
                        error: null,
                        status: "success",
                        isPaused: false
                    };
                case "error":
                    return {
                        ...state,
                        data: undefined,
                        error: action.error,
                        failureCount: state.failureCount + 1,
                        failureReason: action.error,
                        isPaused: false,
                        status: "error"
                    };
                case "setState":
                    return {
                        ...state,
                        ...action.state
                    };
            }
        };
        this.state = reducer(this.state);
        (0, $QaI8V.notifyManager).batch(()=>{
            this.observers.forEach((observer)=>{
                observer.onMutationUpdate(action);
            });
            this.mutationCache.notify({
                mutation: this,
                type: "updated",
                action: action
            });
        });
    }
}
function $752e8fb697e5d345$export$a1659b54bac3252a() {
    return {
        context: undefined,
        data: undefined,
        error: null,
        failureCount: 0,
        failureReason: null,
        isPaused: false,
        status: "idle",
        variables: undefined
    };
}

});
parcelRegister("bgWTi", function(module, exports) {

$parcel$export(module.exports, "defaultLogger", function () { return $834eded17515ccaa$export$1cf3d545f2d4635c; });
const $834eded17515ccaa$export$1cf3d545f2d4635c = console;

});

parcelRegister("QaI8V", function(module, exports) {

$parcel$export(module.exports, "notifyManager", function () { return $09cd2a6bf4888ee8$export$520687f44db6e1ab; });

var $iqz0v = parcelRequire("iqz0v");
function $09cd2a6bf4888ee8$export$316a8efd03cd1458() {
    let queue = [];
    let transactions = 0;
    let notifyFn = (callback)=>{
        callback();
    };
    let batchNotifyFn = (callback)=>{
        callback();
    };
    const batch = (callback)=>{
        let result;
        transactions++;
        try {
            result = callback();
        } finally{
            transactions--;
            if (!transactions) flush();
        }
        return result;
    };
    const schedule = (callback)=>{
        if (transactions) queue.push(callback);
        else (0, $iqz0v.scheduleMicrotask)(()=>{
            notifyFn(callback);
        });
    };
    /**
   * All calls to the wrapped function will be batched.
   */ const batchCalls = (callback)=>{
        return (...args)=>{
            schedule(()=>{
                callback(...args);
            });
        };
    };
    const flush = ()=>{
        const originalQueue = queue;
        queue = [];
        if (originalQueue.length) (0, $iqz0v.scheduleMicrotask)(()=>{
            batchNotifyFn(()=>{
                originalQueue.forEach((callback)=>{
                    notifyFn(callback);
                });
            });
        });
    };
    /**
   * Use this method to set a custom notify function.
   * This can be used to for example wrap notifications with `React.act` while running tests.
   */ const setNotifyFunction = (fn)=>{
        notifyFn = fn;
    };
    /**
   * Use this method to set a custom function to batch notifications together into a single tick.
   * By default React Query will use the batch function provided by ReactDOM or React Native.
   */ const setBatchNotifyFunction = (fn)=>{
        batchNotifyFn = fn;
    };
    return {
        batch: batch,
        batchCalls: batchCalls,
        schedule: schedule,
        setNotifyFunction: setNotifyFunction,
        setBatchNotifyFunction: setBatchNotifyFunction
    };
} // SINGLETON
const $09cd2a6bf4888ee8$export$520687f44db6e1ab = $09cd2a6bf4888ee8$export$316a8efd03cd1458();

});
parcelRegister("iqz0v", function(module, exports) {

$parcel$export(module.exports, "isServer", function () { return $d6a5cf5f861faff3$export$6acf61af03e62db; });
$parcel$export(module.exports, "noop", function () { return $d6a5cf5f861faff3$export$8793edee2d425525; });
$parcel$export(module.exports, "functionalUpdate", function () { return $d6a5cf5f861faff3$export$7f095f455ad5af3f; });
$parcel$export(module.exports, "isValidTimeout", function () { return $d6a5cf5f861faff3$export$e539f754e934e270; });
$parcel$export(module.exports, "difference", function () { return $d6a5cf5f861faff3$export$acaf96a27438246b; });
$parcel$export(module.exports, "replaceAt", function () { return $d6a5cf5f861faff3$export$224e3b7078227b8a; });
$parcel$export(module.exports, "timeUntilStale", function () { return $d6a5cf5f861faff3$export$811b83d62bcf47f0; });
$parcel$export(module.exports, "parseQueryArgs", function () { return $d6a5cf5f861faff3$export$8a11fbc2c8ea08fd; });
$parcel$export(module.exports, "parseMutationArgs", function () { return $d6a5cf5f861faff3$export$b646c531ea475334; });
$parcel$export(module.exports, "parseFilterArgs", function () { return $d6a5cf5f861faff3$export$18e8f4b987e6c111; });
$parcel$export(module.exports, "matchQuery", function () { return $d6a5cf5f861faff3$export$c5d1efe363797780; });
$parcel$export(module.exports, "hashQueryKeyByOptions", function () { return $d6a5cf5f861faff3$export$cc90ca97bc0d73fd; });
$parcel$export(module.exports, "partialMatchKey", function () { return $d6a5cf5f861faff3$export$2f07189bb9fa26a7; });
$parcel$export(module.exports, "matchMutation", function () { return $d6a5cf5f861faff3$export$a1ea5fb559f63ae3; });
$parcel$export(module.exports, "hashQueryKey", function () { return $d6a5cf5f861faff3$export$5fcb678681417b54; });
$parcel$export(module.exports, "shallowEqualObjects", function () { return $d6a5cf5f861faff3$export$3e67810a3f0e9f1c; });
$parcel$export(module.exports, "sleep", function () { return $d6a5cf5f861faff3$export$e772c8ff12451969; });
$parcel$export(module.exports, "scheduleMicrotask", function () { return $d6a5cf5f861faff3$export$4304cb76768ca134; });
$parcel$export(module.exports, "getAbortController", function () { return $d6a5cf5f861faff3$export$382ca5d13a8f252c; });
$parcel$export(module.exports, "replaceData", function () { return $d6a5cf5f861faff3$export$17619bac5b909b23; });
// TYPES
// UTILS
const $d6a5cf5f861faff3$export$6acf61af03e62db = typeof window === "undefined" || "Deno" in window;
function $d6a5cf5f861faff3$export$8793edee2d425525() {
    return undefined;
}
function $d6a5cf5f861faff3$export$7f095f455ad5af3f(updater, input) {
    return typeof updater === "function" ? updater(input) : updater;
}
function $d6a5cf5f861faff3$export$e539f754e934e270(value) {
    return typeof value === "number" && value >= 0 && value !== Infinity;
}
function $d6a5cf5f861faff3$export$acaf96a27438246b(array1, array2) {
    return array1.filter((x)=>!array2.includes(x));
}
function $d6a5cf5f861faff3$export$224e3b7078227b8a(array, index, value) {
    const copy = array.slice(0);
    copy[index] = value;
    return copy;
}
function $d6a5cf5f861faff3$export$811b83d62bcf47f0(updatedAt, staleTime) {
    return Math.max(updatedAt + (staleTime || 0) - Date.now(), 0);
}
function $d6a5cf5f861faff3$export$8a11fbc2c8ea08fd(arg1, arg2, arg3) {
    if (!$d6a5cf5f861faff3$export$aaae5295ec3351c9(arg1)) return arg1;
    if (typeof arg2 === "function") return {
        ...arg3,
        queryKey: arg1,
        queryFn: arg2
    };
    return {
        ...arg2,
        queryKey: arg1
    };
}
function $d6a5cf5f861faff3$export$b646c531ea475334(arg1, arg2, arg3) {
    if ($d6a5cf5f861faff3$export$aaae5295ec3351c9(arg1)) {
        if (typeof arg2 === "function") return {
            ...arg3,
            mutationKey: arg1,
            mutationFn: arg2
        };
        return {
            ...arg2,
            mutationKey: arg1
        };
    }
    if (typeof arg1 === "function") return {
        ...arg2,
        mutationFn: arg1
    };
    return {
        ...arg1
    };
}
function $d6a5cf5f861faff3$export$18e8f4b987e6c111(arg1, arg2, arg3) {
    return $d6a5cf5f861faff3$export$aaae5295ec3351c9(arg1) ? [
        {
            ...arg2,
            queryKey: arg1
        },
        arg3
    ] : [
        arg1 || {},
        arg2
    ];
}
function $d6a5cf5f861faff3$export$42387eeaac09cf54(arg1, arg2, arg3) {
    return $d6a5cf5f861faff3$export$aaae5295ec3351c9(arg1) ? [
        {
            ...arg2,
            mutationKey: arg1
        },
        arg3
    ] : [
        arg1 || {},
        arg2
    ];
}
function $d6a5cf5f861faff3$export$c5d1efe363797780(filters, query) {
    const { type: type = "all", exact: exact, fetchStatus: fetchStatus, predicate: predicate, queryKey: queryKey, stale: stale } = filters;
    if ($d6a5cf5f861faff3$export$aaae5295ec3351c9(queryKey)) {
        if (exact) {
            if (query.queryHash !== $d6a5cf5f861faff3$export$cc90ca97bc0d73fd(queryKey, query.options)) return false;
        } else if (!$d6a5cf5f861faff3$export$2f07189bb9fa26a7(query.queryKey, queryKey)) return false;
    }
    if (type !== "all") {
        const isActive = query.isActive();
        if (type === "active" && !isActive) return false;
        if (type === "inactive" && isActive) return false;
    }
    if (typeof stale === "boolean" && query.isStale() !== stale) return false;
    if (typeof fetchStatus !== "undefined" && fetchStatus !== query.state.fetchStatus) return false;
    if (predicate && !predicate(query)) return false;
    return true;
}
function $d6a5cf5f861faff3$export$a1ea5fb559f63ae3(filters, mutation) {
    const { exact: exact, fetching: fetching, predicate: predicate, mutationKey: mutationKey } = filters;
    if ($d6a5cf5f861faff3$export$aaae5295ec3351c9(mutationKey)) {
        if (!mutation.options.mutationKey) return false;
        if (exact) {
            if ($d6a5cf5f861faff3$export$5fcb678681417b54(mutation.options.mutationKey) !== $d6a5cf5f861faff3$export$5fcb678681417b54(mutationKey)) return false;
        } else if (!$d6a5cf5f861faff3$export$2f07189bb9fa26a7(mutation.options.mutationKey, mutationKey)) return false;
    }
    if (typeof fetching === "boolean" && mutation.state.status === "loading" !== fetching) return false;
    if (predicate && !predicate(mutation)) return false;
    return true;
}
function $d6a5cf5f861faff3$export$cc90ca97bc0d73fd(queryKey, options) {
    const hashFn = (options == null ? void 0 : options.queryKeyHashFn) || $d6a5cf5f861faff3$export$5fcb678681417b54;
    return hashFn(queryKey);
}
/**
 * Default query keys hash function.
 * Hashes the value into a stable hash.
 */ function $d6a5cf5f861faff3$export$5fcb678681417b54(queryKey) {
    return JSON.stringify(queryKey, (_, val)=>$d6a5cf5f861faff3$export$53b83ca8eaab0383(val) ? Object.keys(val).sort().reduce((result, key)=>{
            result[key] = val[key];
            return result;
        }, {}) : val);
}
/**
 * Checks if key `b` partially matches with key `a`.
 */ function $d6a5cf5f861faff3$export$2f07189bb9fa26a7(a, b) {
    return $d6a5cf5f861faff3$export$3bc9138b70293839(a, b);
}
/**
 * Checks if `b` partially matches with `a`.
 */ function $d6a5cf5f861faff3$export$3bc9138b70293839(a, b) {
    if (a === b) return true;
    if (typeof a !== typeof b) return false;
    if (a && b && typeof a === "object" && typeof b === "object") return !Object.keys(b).some((key)=>!$d6a5cf5f861faff3$export$3bc9138b70293839(a[key], b[key]));
    return false;
}
/**
 * This function returns `a` if `b` is deeply equal.
 * If not, it will replace any deeply equal children of `b` with those of `a`.
 * This can be used for structural sharing between JSON values for example.
 */ function $d6a5cf5f861faff3$export$77a71fc411098696(a, b) {
    if (a === b) return a;
    const array = $d6a5cf5f861faff3$export$7a8558113332b71e(a) && $d6a5cf5f861faff3$export$7a8558113332b71e(b);
    if (array || $d6a5cf5f861faff3$export$53b83ca8eaab0383(a) && $d6a5cf5f861faff3$export$53b83ca8eaab0383(b)) {
        const aSize = array ? a.length : Object.keys(a).length;
        const bItems = array ? b : Object.keys(b);
        const bSize = bItems.length;
        const copy = array ? [] : {};
        let equalItems = 0;
        for(let i = 0; i < bSize; i++){
            const key = array ? i : bItems[i];
            copy[key] = $d6a5cf5f861faff3$export$77a71fc411098696(a[key], b[key]);
            if (copy[key] === a[key]) equalItems++;
        }
        return aSize === bSize && equalItems === aSize ? a : copy;
    }
    return b;
}
/**
 * Shallow compare objects. Only works with objects that always have the same properties.
 */ function $d6a5cf5f861faff3$export$3e67810a3f0e9f1c(a, b) {
    if (a && !b || b && !a) return false;
    for(const key in a){
        if (a[key] !== b[key]) return false;
    }
    return true;
}
function $d6a5cf5f861faff3$export$7a8558113332b71e(value) {
    return Array.isArray(value) && value.length === Object.keys(value).length;
} // Copied from: https://github.com/jonschlinkert/is-plain-object
function $d6a5cf5f861faff3$export$53b83ca8eaab0383(o) {
    if (!$d6a5cf5f861faff3$var$hasObjectPrototype(o)) return false;
     // If has modified constructor
    const ctor = o.constructor;
    if (typeof ctor === "undefined") return true;
     // If has modified prototype
    const prot = ctor.prototype;
    if (!$d6a5cf5f861faff3$var$hasObjectPrototype(prot)) return false;
     // If constructor does not have an Object-specific method
    if (!prot.hasOwnProperty("isPrototypeOf")) return false;
     // Most likely a plain Object
    return true;
}
function $d6a5cf5f861faff3$var$hasObjectPrototype(o) {
    return Object.prototype.toString.call(o) === "[object Object]";
}
function $d6a5cf5f861faff3$export$aaae5295ec3351c9(value) {
    return Array.isArray(value);
}
function $d6a5cf5f861faff3$export$e6127cc7fe7395c3(value) {
    return value instanceof Error;
}
function $d6a5cf5f861faff3$export$e772c8ff12451969(timeout) {
    return new Promise((resolve)=>{
        setTimeout(resolve, timeout);
    });
}
/**
 * Schedules a microtask.
 * This can be useful to schedule state updates after rendering.
 */ function $d6a5cf5f861faff3$export$4304cb76768ca134(callback) {
    $d6a5cf5f861faff3$export$e772c8ff12451969(0).then(callback);
}
function $d6a5cf5f861faff3$export$382ca5d13a8f252c() {
    if (typeof AbortController === "function") return new AbortController();
    return;
}
function $d6a5cf5f861faff3$export$17619bac5b909b23(prevData, data, options) {
    // Use prev data if an isDataEqual function is defined and returns `true`
    if (options.isDataEqual != null && options.isDataEqual(prevData, data)) return prevData;
    else if (typeof options.structuralSharing === "function") return options.structuralSharing(prevData, data);
    else if (options.structuralSharing !== false) // Structurally share data between prev and new data if needed
    return $d6a5cf5f861faff3$export$77a71fc411098696(prevData, data);
    return data;
}

});


parcelRegister("ejGTl", function(module, exports) {

$parcel$export(module.exports, "Removable", function () { return $a6c41c671d3da24e$export$e09608847fcc8c59; });

var $iqz0v = parcelRequire("iqz0v");
class $a6c41c671d3da24e$export$e09608847fcc8c59 {
    destroy() {
        this.clearGcTimeout();
    }
    scheduleGc() {
        this.clearGcTimeout();
        if ((0, $iqz0v.isValidTimeout)(this.cacheTime)) this.gcTimeout = setTimeout(()=>{
            this.optionalRemove();
        }, this.cacheTime);
    }
    updateCacheTime(newCacheTime) {
        // Default to 5 minutes (Infinity for server-side) if no cache time is set
        this.cacheTime = Math.max(this.cacheTime || 0, newCacheTime != null ? newCacheTime : (0, $iqz0v.isServer) ? Infinity : 300000);
    }
    clearGcTimeout() {
        if (this.gcTimeout) {
            clearTimeout(this.gcTimeout);
            this.gcTimeout = undefined;
        }
    }
}

});

parcelRegister("gbAXU", function(module, exports) {

$parcel$export(module.exports, "canFetch", function () { return $bc8a58f265573b6d$export$61b92f63f30245cf; });
$parcel$export(module.exports, "isCancelledError", function () { return $bc8a58f265573b6d$export$986cc6445c1d323; });
$parcel$export(module.exports, "createRetryer", function () { return $bc8a58f265573b6d$export$2cbd00fe8a2c8d85; });

var $bzUDw = parcelRequire("bzUDw");

var $2YnrV = parcelRequire("2YnrV");

var $iqz0v = parcelRequire("iqz0v");
function $bc8a58f265573b6d$var$defaultRetryDelay(failureCount) {
    return Math.min(1000 * 2 ** failureCount, 30000);
}
function $bc8a58f265573b6d$export$61b92f63f30245cf(networkMode) {
    return (networkMode != null ? networkMode : "online") === "online" ? (0, $2YnrV.onlineManager).isOnline() : true;
}
class $bc8a58f265573b6d$export$a8430ed4188f35a9 {
    constructor(options){
        this.revert = options == null ? void 0 : options.revert;
        this.silent = options == null ? void 0 : options.silent;
    }
}
function $bc8a58f265573b6d$export$986cc6445c1d323(value) {
    return value instanceof $bc8a58f265573b6d$export$a8430ed4188f35a9;
}
function $bc8a58f265573b6d$export$2cbd00fe8a2c8d85(config) {
    let isRetryCancelled = false;
    let failureCount = 0;
    let isResolved = false;
    let continueFn;
    let promiseResolve;
    let promiseReject;
    const promise = new Promise((outerResolve, outerReject)=>{
        promiseResolve = outerResolve;
        promiseReject = outerReject;
    });
    const cancel = (cancelOptions)=>{
        if (!isResolved) {
            reject(new $bc8a58f265573b6d$export$a8430ed4188f35a9(cancelOptions));
            config.abort == null || config.abort();
        }
    };
    const cancelRetry = ()=>{
        isRetryCancelled = true;
    };
    const continueRetry = ()=>{
        isRetryCancelled = false;
    };
    const shouldPause = ()=>!(0, $bzUDw.focusManager).isFocused() || config.networkMode !== "always" && !(0, $2YnrV.onlineManager).isOnline();
    const resolve = (value)=>{
        if (!isResolved) {
            isResolved = true;
            config.onSuccess == null || config.onSuccess(value);
            continueFn == null || continueFn();
            promiseResolve(value);
        }
    };
    const reject = (value)=>{
        if (!isResolved) {
            isResolved = true;
            config.onError == null || config.onError(value);
            continueFn == null || continueFn();
            promiseReject(value);
        }
    };
    const pause = ()=>{
        return new Promise((continueResolve)=>{
            continueFn = (value)=>{
                const canContinue = isResolved || !shouldPause();
                if (canContinue) continueResolve(value);
                return canContinue;
            };
            config.onPause == null || config.onPause();
        }).then(()=>{
            continueFn = undefined;
            if (!isResolved) config.onContinue == null || config.onContinue();
        });
    }; // Create loop function
    const run = ()=>{
        // Do nothing if already resolved
        if (isResolved) return;
        let promiseOrValue; // Execute query
        try {
            promiseOrValue = config.fn();
        } catch (error) {
            promiseOrValue = Promise.reject(error);
        }
        Promise.resolve(promiseOrValue).then(resolve).catch((error)=>{
            var _config$retry, _config$retryDelay;
            // Stop if the fetch is already resolved
            if (isResolved) return;
             // Do we need to retry the request?
            const retry = (_config$retry = config.retry) != null ? _config$retry : 3;
            const retryDelay = (_config$retryDelay = config.retryDelay) != null ? _config$retryDelay : $bc8a58f265573b6d$var$defaultRetryDelay;
            const delay = typeof retryDelay === "function" ? retryDelay(failureCount, error) : retryDelay;
            const shouldRetry = retry === true || typeof retry === "number" && failureCount < retry || typeof retry === "function" && retry(failureCount, error);
            if (isRetryCancelled || !shouldRetry) {
                // We are done if the query does not need to be retried
                reject(error);
                return;
            }
            failureCount++; // Notify on fail
            config.onFail == null || config.onFail(failureCount, error); // Delay
            (0, $iqz0v.sleep)(delay) // Pause if the document is not visible or when the device is offline
            .then(()=>{
                if (shouldPause()) return pause();
                return;
            }).then(()=>{
                if (isRetryCancelled) reject(error);
                else run();
            });
        });
    }; // Start loop
    if ($bc8a58f265573b6d$export$61b92f63f30245cf(config.networkMode)) run();
    else pause().then(run);
    return {
        promise: promise,
        cancel: cancel,
        continue: ()=>{
            const didContinue = continueFn == null ? void 0 : continueFn();
            return didContinue ? promise : Promise.resolve();
        },
        cancelRetry: cancelRetry,
        continueRetry: continueRetry
    };
}

});
parcelRegister("bzUDw", function(module, exports) {

$parcel$export(module.exports, "focusManager", function () { return $86dee5642fc496f7$export$6bf54661be5b02cf; });

var $1RjI5 = parcelRequire("1RjI5");

var $iqz0v = parcelRequire("iqz0v");
class $86dee5642fc496f7$export$86f1af424b2ca4de extends (0, $1RjI5.Subscribable) {
    constructor(){
        super();
        this.setup = (onFocus)=>{
            // addEventListener does not exist in React Native, but window does
            // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
            if (!(0, $iqz0v.isServer) && window.addEventListener) {
                const listener = ()=>onFocus(); // Listen to visibillitychange and focus
                window.addEventListener("visibilitychange", listener, false);
                window.addEventListener("focus", listener, false);
                return ()=>{
                    // Be sure to unsubscribe if a new handler is set
                    window.removeEventListener("visibilitychange", listener);
                    window.removeEventListener("focus", listener);
                };
            }
            return;
        };
    }
    onSubscribe() {
        if (!this.cleanup) this.setEventListener(this.setup);
    }
    onUnsubscribe() {
        if (!this.hasListeners()) {
            var _this$cleanup;
            (_this$cleanup = this.cleanup) == null || _this$cleanup.call(this);
            this.cleanup = undefined;
        }
    }
    setEventListener(setup) {
        var _this$cleanup2;
        this.setup = setup;
        (_this$cleanup2 = this.cleanup) == null || _this$cleanup2.call(this);
        this.cleanup = setup((focused)=>{
            if (typeof focused === "boolean") this.setFocused(focused);
            else this.onFocus();
        });
    }
    setFocused(focused) {
        const changed = this.focused !== focused;
        if (changed) {
            this.focused = focused;
            this.onFocus();
        }
    }
    onFocus() {
        this.listeners.forEach(({ listener: listener })=>{
            listener();
        });
    }
    isFocused() {
        if (typeof this.focused === "boolean") return this.focused;
         // document global can be unavailable in react native
        if (typeof document === "undefined") return true;
        return [
            undefined,
            "visible",
            "prerender"
        ].includes(document.visibilityState);
    }
}
const $86dee5642fc496f7$export$6bf54661be5b02cf = new $86dee5642fc496f7$export$86f1af424b2ca4de();

});
parcelRegister("1RjI5", function(module, exports) {

$parcel$export(module.exports, "Subscribable", function () { return $15aa07ae3d10a292$export$d26086b469ecdbcc; });
class $15aa07ae3d10a292$export$d26086b469ecdbcc {
    constructor(){
        this.listeners = new Set();
        this.subscribe = this.subscribe.bind(this);
    }
    subscribe(listener) {
        const identity = {
            listener: listener
        };
        this.listeners.add(identity);
        this.onSubscribe();
        return ()=>{
            this.listeners.delete(identity);
            this.onUnsubscribe();
        };
    }
    hasListeners() {
        return this.listeners.size > 0;
    }
    onSubscribe() {}
    onUnsubscribe() {}
}

});


parcelRegister("2YnrV", function(module, exports) {

$parcel$export(module.exports, "onlineManager", function () { return $22a35feb4bbd94ea$export$b113e788b2dd3fdc; });

var $1RjI5 = parcelRequire("1RjI5");

var $iqz0v = parcelRequire("iqz0v");
const $22a35feb4bbd94ea$var$onlineEvents = [
    "online",
    "offline"
];
class $22a35feb4bbd94ea$export$58774fb55d5ff7fc extends (0, $1RjI5.Subscribable) {
    constructor(){
        super();
        this.setup = (onOnline)=>{
            // addEventListener does not exist in React Native, but window does
            // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
            if (!(0, $iqz0v.isServer) && window.addEventListener) {
                const listener = ()=>onOnline(); // Listen to online
                $22a35feb4bbd94ea$var$onlineEvents.forEach((event)=>{
                    window.addEventListener(event, listener, false);
                });
                return ()=>{
                    // Be sure to unsubscribe if a new handler is set
                    $22a35feb4bbd94ea$var$onlineEvents.forEach((event)=>{
                        window.removeEventListener(event, listener);
                    });
                };
            }
            return;
        };
    }
    onSubscribe() {
        if (!this.cleanup) this.setEventListener(this.setup);
    }
    onUnsubscribe() {
        if (!this.hasListeners()) {
            var _this$cleanup;
            (_this$cleanup = this.cleanup) == null || _this$cleanup.call(this);
            this.cleanup = undefined;
        }
    }
    setEventListener(setup) {
        var _this$cleanup2;
        this.setup = setup;
        (_this$cleanup2 = this.cleanup) == null || _this$cleanup2.call(this);
        this.cleanup = setup((online)=>{
            if (typeof online === "boolean") this.setOnline(online);
            else this.onOnline();
        });
    }
    setOnline(online) {
        const changed = this.online !== online;
        if (changed) {
            this.online = online;
            this.onOnline();
        }
    }
    onOnline() {
        this.listeners.forEach(({ listener: listener })=>{
            listener();
        });
    }
    isOnline() {
        if (typeof this.online === "boolean") return this.online;
        if (typeof navigator === "undefined" || typeof navigator.onLine === "undefined") return true;
        return navigator.onLine;
    }
}
const $22a35feb4bbd94ea$export$b113e788b2dd3fdc = new $22a35feb4bbd94ea$export$58774fb55d5ff7fc();

});




parcelRegister("akDF7", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStore", function () { return $785a89b3f7b2671c$export$306c0aa65ff9ec16; });

var $dmOGj = parcelRequire("dmOGj");
"use client";
const $785a89b3f7b2671c$export$306c0aa65ff9ec16 = (0, $dmOGj.useSyncExternalStore);

});
parcelRegister("dmOGj", function(module, exports) {
"use strict";

module.exports = (parcelRequire("8eIrC"));

});
parcelRegister("8eIrC", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStore", function () { return $5ff21b419186f24f$export$306c0aa65ff9ec16; }, function (v) { return $5ff21b419186f24f$export$306c0aa65ff9ec16 = v; });
/**
 * @license React
 * use-sync-external-store-shim.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $5ff21b419186f24f$export$306c0aa65ff9ec16;
"use strict";

var $dAx5m = parcelRequire("dAx5m");
function $5ff21b419186f24f$var$h(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $5ff21b419186f24f$var$k = "function" === typeof Object.is ? Object.is : $5ff21b419186f24f$var$h, $5ff21b419186f24f$var$l = $dAx5m.useState, $5ff21b419186f24f$var$m = $dAx5m.useEffect, $5ff21b419186f24f$var$n = $dAx5m.useLayoutEffect, $5ff21b419186f24f$var$p = $dAx5m.useDebugValue;
function $5ff21b419186f24f$var$q(a, b) {
    var d = b(), f = $5ff21b419186f24f$var$l({
        inst: {
            value: d,
            getSnapshot: b
        }
    }), c = f[0].inst, g = f[1];
    $5ff21b419186f24f$var$n(function() {
        c.value = d;
        c.getSnapshot = b;
        $5ff21b419186f24f$var$r(c) && g({
            inst: c
        });
    }, [
        a,
        d,
        b
    ]);
    $5ff21b419186f24f$var$m(function() {
        $5ff21b419186f24f$var$r(c) && g({
            inst: c
        });
        return a(function() {
            $5ff21b419186f24f$var$r(c) && g({
                inst: c
            });
        });
    }, [
        a
    ]);
    $5ff21b419186f24f$var$p(d);
    return d;
}
function $5ff21b419186f24f$var$r(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var d = b();
        return !$5ff21b419186f24f$var$k(a, d);
    } catch (f) {
        return !0;
    }
}
function $5ff21b419186f24f$var$t(a, b) {
    return b();
}
var $5ff21b419186f24f$var$u = "undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement ? $5ff21b419186f24f$var$t : $5ff21b419186f24f$var$q;
$5ff21b419186f24f$export$306c0aa65ff9ec16 = void 0 !== $dAx5m.useSyncExternalStore ? $dAx5m.useSyncExternalStore : $5ff21b419186f24f$var$u;

});



parcelRegister("132jP", function(module, exports) {

$parcel$export(module.exports, "useQueryClient", function () { return $0c37debff743dca0$export$22e77b9572c4fded; });
$parcel$export(module.exports, "QueryClientProvider", function () { return $0c37debff743dca0$export$45604f0cc8ae667b; });

var $dAx5m = parcelRequire("dAx5m");
"use client";
const $0c37debff743dca0$export$2fba198b5b2e37fa = /*#__PURE__*/ $dAx5m.createContext(undefined);
const $0c37debff743dca0$var$QueryClientSharingContext = /*#__PURE__*/ $dAx5m.createContext(false); // If we are given a context, we will use it.
// Otherwise, if contextSharing is on, we share the first and at least one
// instance of the context across the window
// to ensure that if React Query is used across
// different bundles or microfrontends they will
// all use the same **instance** of context, regardless
// of module scoping.
function $0c37debff743dca0$var$getQueryClientContext(context, contextSharing) {
    if (context) return context;
    if (contextSharing && typeof window !== "undefined") {
        if (!window.ReactQueryClientContext) window.ReactQueryClientContext = $0c37debff743dca0$export$2fba198b5b2e37fa;
        return window.ReactQueryClientContext;
    }
    return $0c37debff743dca0$export$2fba198b5b2e37fa;
}
const $0c37debff743dca0$export$22e77b9572c4fded = ({ context: context } = {})=>{
    const queryClient = $dAx5m.useContext($0c37debff743dca0$var$getQueryClientContext(context, $dAx5m.useContext($0c37debff743dca0$var$QueryClientSharingContext)));
    if (!queryClient) throw new Error("No QueryClient set, use QueryClientProvider to set one");
    return queryClient;
};
const $0c37debff743dca0$export$45604f0cc8ae667b = ({ client: client, children: children, context: context, contextSharing: contextSharing = false })=>{
    $dAx5m.useEffect(()=>{
        client.mount();
        return ()=>{
            client.unmount();
        };
    }, [
        client
    ]);
    const Context = $0c37debff743dca0$var$getQueryClientContext(context, contextSharing);
    return /*#__PURE__*/ $dAx5m.createElement($0c37debff743dca0$var$QueryClientSharingContext.Provider, {
        value: !context && contextSharing
    }, /*#__PURE__*/ $dAx5m.createElement(Context.Provider, {
        value: client
    }, children));
};

});

parcelRegister("aahK4", function(module, exports) {

$parcel$export(module.exports, "shouldThrowError", function () { return $766899c7275db33f$export$2072f68e6c3507cf; });
function $766899c7275db33f$export$2072f68e6c3507cf(_useErrorBoundary, params) {
    // Allow useErrorBoundary function to override throwing behavior on a per-error basis
    if (typeof _useErrorBoundary === "function") return _useErrorBoundary(...params);
    return !!_useErrorBoundary;
}

});


parcelRegister("5ehI7", function(module, exports) {

var $hecco = parcelRequire("hecco");

var $kI6GP = parcelRequire("kI6GP");
/**
 * This method is like `_.assign` except that it recursively merges own and
 * inherited enumerable string keyed properties of source objects into the
 * destination object. Source properties that resolve to `undefined` are
 * skipped if a destination value exists. Array and plain object properties
 * are merged recursively. Other objects and value types are overridden by
 * assignment. Source objects are applied from left to right. Subsequent
 * sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 0.5.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = {
 *   'a': [{ 'b': 2 }, { 'd': 4 }]
 * };
 *
 * var other = {
 *   'a': [{ 'c': 3 }, { 'e': 5 }]
 * };
 *
 * _.merge(object, other);
 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
 */ var $3cebff86496f573a$var$merge = $kI6GP(function(object, source, srcIndex) {
    $hecco(object, source, srcIndex);
});
module.exports = $3cebff86496f573a$var$merge;

});
parcelRegister("hecco", function(module, exports) {

var $SQcVa = parcelRequire("SQcVa");

var $bNQhs = parcelRequire("bNQhs");

var $g4p8W = parcelRequire("g4p8W");

var $4OC0g = parcelRequire("4OC0g");

var $2fw24 = parcelRequire("2fw24");

var $1nwvb = parcelRequire("1nwvb");

var $ekfxm = parcelRequire("ekfxm");
/**
 * The base implementation of `_.merge` without support for multiple sources.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} [customizer] The function to customize merged values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */ function $c8ad34e5b1a942c6$var$baseMerge(object, source, srcIndex, customizer, stack) {
    if (object === source) return;
    $g4p8W(source, function(srcValue, key) {
        stack || (stack = new $SQcVa);
        if ($2fw24(srcValue)) $4OC0g(object, source, key, srcIndex, $c8ad34e5b1a942c6$var$baseMerge, customizer, stack);
        else {
            var newValue = customizer ? customizer($ekfxm(object, key), srcValue, key + "", object, source, stack) : undefined;
            if (newValue === undefined) newValue = srcValue;
            $bNQhs(object, key, newValue);
        }
    }, $1nwvb);
}
module.exports = $c8ad34e5b1a942c6$var$baseMerge;

});
parcelRegister("SQcVa", function(module, exports) {

var $bE9pp = parcelRequire("bE9pp");

var $ioOHM = parcelRequire("ioOHM");

var $9qiPn = parcelRequire("9qiPn");

var $joEcZ = parcelRequire("joEcZ");

var $7ZGpY = parcelRequire("7ZGpY");

var $2wfFz = parcelRequire("2wfFz");
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $0a4d8a904107caf5$var$Stack(entries) {
    var data = this.__data__ = new $bE9pp(entries);
    this.size = data.size;
}
// Add methods to `Stack`.
$0a4d8a904107caf5$var$Stack.prototype.clear = $ioOHM;
$0a4d8a904107caf5$var$Stack.prototype["delete"] = $9qiPn;
$0a4d8a904107caf5$var$Stack.prototype.get = $joEcZ;
$0a4d8a904107caf5$var$Stack.prototype.has = $7ZGpY;
$0a4d8a904107caf5$var$Stack.prototype.set = $2wfFz;
module.exports = $0a4d8a904107caf5$var$Stack;

});
parcelRegister("ioOHM", function(module, exports) {

var $bE9pp = parcelRequire("bE9pp");
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function $d651cce03ab9daac$var$stackClear() {
    this.__data__ = new $bE9pp;
    this.size = 0;
}
module.exports = $d651cce03ab9daac$var$stackClear;

});

parcelRegister("9qiPn", function(module, exports) {
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $6dc5259001352c72$var$stackDelete(key) {
    var data = this.__data__, result = data["delete"](key);
    this.size = data.size;
    return result;
}
module.exports = $6dc5259001352c72$var$stackDelete;

});

parcelRegister("joEcZ", function(module, exports) {
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $e1ef72c30c298350$var$stackGet(key) {
    return this.__data__.get(key);
}
module.exports = $e1ef72c30c298350$var$stackGet;

});

parcelRegister("7ZGpY", function(module, exports) {
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $5d1f223521256eec$var$stackHas(key) {
    return this.__data__.has(key);
}
module.exports = $5d1f223521256eec$var$stackHas;

});

parcelRegister("2wfFz", function(module, exports) {

var $bE9pp = parcelRequire("bE9pp");

var $a1lZD = parcelRequire("a1lZD");

var $ejB1j = parcelRequire("ejB1j");
/** Used as the size to enable large array optimizations. */ var $1d5ab98c9b9011b4$var$LARGE_ARRAY_SIZE = 200;
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function $1d5ab98c9b9011b4$var$stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof $bE9pp) {
        var pairs = data.__data__;
        if (!$a1lZD || pairs.length < $1d5ab98c9b9011b4$var$LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new $ejB1j(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
module.exports = $1d5ab98c9b9011b4$var$stackSet;

});


parcelRegister("bNQhs", function(module, exports) {

var $frkSI = parcelRequire("frkSI");

var $b82f6 = parcelRequire("b82f6");
/**
 * This function is like `assignValue` except that it doesn't assign
 * `undefined` values.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $897cd3282b9dd6f6$var$assignMergeValue(object, key, value) {
    if (value !== undefined && !$b82f6(object[key], value) || value === undefined && !(key in object)) $frkSI(object, key, value);
}
module.exports = $897cd3282b9dd6f6$var$assignMergeValue;

});

parcelRegister("g4p8W", function(module, exports) {

var $lIJ4n = parcelRequire("lIJ4n");
/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */ var $bb3086016dd4b24c$var$baseFor = $lIJ4n();
module.exports = $bb3086016dd4b24c$var$baseFor;

});
parcelRegister("lIJ4n", function(module, exports) {
/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function $fd00aae94fedc159$var$createBaseFor(fromRight) {
    return function(object, iteratee, keysFunc) {
        var index = -1, iterable = Object(object), props = keysFunc(object), length = props.length;
        while(length--){
            var key = props[fromRight ? length : ++index];
            if (iteratee(iterable[key], key, iterable) === false) break;
        }
        return object;
    };
}
module.exports = $fd00aae94fedc159$var$createBaseFor;

});


parcelRegister("4OC0g", function(module, exports) {

var $bNQhs = parcelRequire("bNQhs");

var $iKAc4 = parcelRequire("iKAc4");

var $bs4yL = parcelRequire("bs4yL");

var $3oJBu = parcelRequire("3oJBu");

var $6oaQt = parcelRequire("6oaQt");

var $hSVT1 = parcelRequire("hSVT1");

var $jyoU0 = parcelRequire("jyoU0");

var $15J8V = parcelRequire("15J8V");

var $1Rk6s = parcelRequire("1Rk6s");

var $1qW2I = parcelRequire("1qW2I");

var $2fw24 = parcelRequire("2fw24");

var $jKEjo = parcelRequire("jKEjo");

var $ao33p = parcelRequire("ao33p");

var $ekfxm = parcelRequire("ekfxm");

var $7Q0yl = parcelRequire("7Q0yl");
/**
 * A specialized version of `baseMerge` for arrays and objects which performs
 * deep merges and tracks traversed objects enabling objects with circular
 * references to be merged.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {string} key The key of the value to merge.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} mergeFunc The function to merge values.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */ function $38194f93d2596993$var$baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
    var objValue = $ekfxm(object, key), srcValue = $ekfxm(source, key), stacked = stack.get(srcValue);
    if (stacked) {
        $bNQhs(object, key, stacked);
        return;
    }
    var newValue = customizer ? customizer(objValue, srcValue, key + "", object, source, stack) : undefined;
    var isCommon = newValue === undefined;
    if (isCommon) {
        var isArr = $jyoU0(srcValue), isBuff = !isArr && $1Rk6s(srcValue), isTyped = !isArr && !isBuff && $ao33p(srcValue);
        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
            if ($jyoU0(objValue)) newValue = objValue;
            else if ($15J8V(objValue)) newValue = $3oJBu(objValue);
            else if (isBuff) {
                isCommon = false;
                newValue = $iKAc4(srcValue, true);
            } else if (isTyped) {
                isCommon = false;
                newValue = $bs4yL(srcValue, true);
            } else newValue = [];
        } else if ($jKEjo(srcValue) || $hSVT1(srcValue)) {
            newValue = objValue;
            if ($hSVT1(objValue)) newValue = $7Q0yl(objValue);
            else if (!$2fw24(objValue) || $1qW2I(objValue)) newValue = $6oaQt(srcValue);
        } else isCommon = false;
    }
    if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack["delete"](srcValue);
    }
    $bNQhs(object, key, newValue);
}
module.exports = $38194f93d2596993$var$baseMergeDeep;

});
parcelRegister("iKAc4", function(module, exports) {

var $dLxmN = parcelRequire("dLxmN");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? $dLxmN.Buffer : undefined, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;
/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */ function cloneBuffer(buffer, isDeep) {
    if (isDeep) return buffer.slice();
    var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
    buffer.copy(result);
    return result;
}
module.exports = cloneBuffer;

});

parcelRegister("bs4yL", function(module, exports) {

var $bqDPp = parcelRequire("bqDPp");
/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */ function $8565d8ac7af618c7$var$cloneTypedArray(typedArray, isDeep) {
    var buffer = isDeep ? $bqDPp(typedArray.buffer) : typedArray.buffer;
    return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}
module.exports = $8565d8ac7af618c7$var$cloneTypedArray;

});
parcelRegister("bqDPp", function(module, exports) {

var $1tpEG = parcelRequire("1tpEG");
/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */ function $8521047b283891db$var$cloneArrayBuffer(arrayBuffer) {
    var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
    new $1tpEG(result).set(new $1tpEG(arrayBuffer));
    return result;
}
module.exports = $8521047b283891db$var$cloneArrayBuffer;

});
parcelRegister("1tpEG", function(module, exports) {

var $dLxmN = parcelRequire("dLxmN");
/** Built-in value references. */ var $112c667a0238424f$var$Uint8Array = $dLxmN.Uint8Array;
module.exports = $112c667a0238424f$var$Uint8Array;

});



parcelRegister("3oJBu", function(module, exports) {
/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */ function $2796fcef12d2bc62$var$copyArray(source, array) {
    var index = -1, length = source.length;
    array || (array = Array(length));
    while(++index < length)array[index] = source[index];
    return array;
}
module.exports = $2796fcef12d2bc62$var$copyArray;

});

parcelRegister("6oaQt", function(module, exports) {

var $gg1lx = parcelRequire("gg1lx");

var $bNjG2 = parcelRequire("bNjG2");

var $jdcNi = parcelRequire("jdcNi");
/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */ function $4a6d65a5b590dec8$var$initCloneObject(object) {
    return typeof object.constructor == "function" && !$jdcNi(object) ? $gg1lx($bNjG2(object)) : {};
}
module.exports = $4a6d65a5b590dec8$var$initCloneObject;

});
parcelRegister("gg1lx", function(module, exports) {

var $2fw24 = parcelRequire("2fw24");
/** Built-in value references. */ var $bd5f2f575d1cb78c$var$objectCreate = Object.create;
/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */ var $bd5f2f575d1cb78c$var$baseCreate = function() {
    function object() {}
    return function(proto) {
        if (!$2fw24(proto)) return {};
        if ($bd5f2f575d1cb78c$var$objectCreate) return $bd5f2f575d1cb78c$var$objectCreate(proto);
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
    };
}();
module.exports = $bd5f2f575d1cb78c$var$baseCreate;

});

parcelRegister("bNjG2", function(module, exports) {

var $2Yv8v = parcelRequire("2Yv8v");
/** Built-in value references. */ var $896388be532f0dda$var$getPrototype = $2Yv8v(Object.getPrototypeOf, Object);
module.exports = $896388be532f0dda$var$getPrototype;

});
parcelRegister("2Yv8v", function(module, exports) {
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function $22a95658ee594460$var$overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
module.exports = $22a95658ee594460$var$overArg;

});


parcelRegister("jdcNi", function(module, exports) {
/** Used for built-in method references. */ var $dfc927d9edfdc14c$var$objectProto = Object.prototype;
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function $dfc927d9edfdc14c$var$isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || $dfc927d9edfdc14c$var$objectProto;
    return value === proto;
}
module.exports = $dfc927d9edfdc14c$var$isPrototype;

});


parcelRegister("hSVT1", function(module, exports) {

var $jee2E = parcelRequire("jee2E");

var $bROf4 = parcelRequire("bROf4");
/** Used for built-in method references. */ var $d05461ddbf9838c0$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $d05461ddbf9838c0$var$hasOwnProperty = $d05461ddbf9838c0$var$objectProto.hasOwnProperty;
/** Built-in value references. */ var $d05461ddbf9838c0$var$propertyIsEnumerable = $d05461ddbf9838c0$var$objectProto.propertyIsEnumerable;
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var $d05461ddbf9838c0$var$isArguments = $jee2E(function() {
    return arguments;
}()) ? $jee2E : function(value) {
    return $bROf4(value) && $d05461ddbf9838c0$var$hasOwnProperty.call(value, "callee") && !$d05461ddbf9838c0$var$propertyIsEnumerable.call(value, "callee");
};
module.exports = $d05461ddbf9838c0$var$isArguments;

});
parcelRegister("jee2E", function(module, exports) {

var $lIXED = parcelRequire("lIXED");

var $bROf4 = parcelRequire("bROf4");
/** `Object#toString` result references. */ var $dffa37889ad7240d$var$argsTag = "[object Arguments]";
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function $dffa37889ad7240d$var$baseIsArguments(value) {
    return $bROf4(value) && $lIXED(value) == $dffa37889ad7240d$var$argsTag;
}
module.exports = $dffa37889ad7240d$var$baseIsArguments;

});


parcelRegister("15J8V", function(module, exports) {

var $a8M8t = parcelRequire("a8M8t");

var $bROf4 = parcelRequire("bROf4");
/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */ function $0cb94680a303c78a$var$isArrayLikeObject(value) {
    return $bROf4(value) && $a8M8t(value);
}
module.exports = $0cb94680a303c78a$var$isArrayLikeObject;

});
parcelRegister("a8M8t", function(module, exports) {

var $1qW2I = parcelRequire("1qW2I");

var $3Y2Uj = parcelRequire("3Y2Uj");
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function $761ffd7baaf751b3$var$isArrayLike(value) {
    return value != null && $3Y2Uj(value.length) && !$1qW2I(value);
}
module.exports = $761ffd7baaf751b3$var$isArrayLike;

});
parcelRegister("3Y2Uj", function(module, exports) {
/** Used as references for various `Number` constants. */ var $2e393afdb9c3f667$var$MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function $2e393afdb9c3f667$var$isLength(value) {
    return typeof value == "number" && value > -1 && value % 1 == 0 && value <= $2e393afdb9c3f667$var$MAX_SAFE_INTEGER;
}
module.exports = $2e393afdb9c3f667$var$isLength;

});



parcelRegister("1Rk6s", function(module, exports) {

var $dLxmN = parcelRequire("dLxmN");

var $g7pi6 = parcelRequire("g7pi6");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? $dLxmN.Buffer : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || $g7pi6;
module.exports = isBuffer;

});
parcelRegister("g7pi6", function(module, exports) {
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function $bbc0eb07d9815429$var$stubFalse() {
    return false;
}
module.exports = $bbc0eb07d9815429$var$stubFalse;

});


parcelRegister("jKEjo", function(module, exports) {

var $lIXED = parcelRequire("lIXED");

var $bNjG2 = parcelRequire("bNjG2");

var $bROf4 = parcelRequire("bROf4");
/** `Object#toString` result references. */ var $e611954202bd3e7f$var$objectTag = "[object Object]";
/** Used for built-in method references. */ var $e611954202bd3e7f$var$funcProto = Function.prototype, $e611954202bd3e7f$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $e611954202bd3e7f$var$funcToString = $e611954202bd3e7f$var$funcProto.toString;
/** Used to check objects for own properties. */ var $e611954202bd3e7f$var$hasOwnProperty = $e611954202bd3e7f$var$objectProto.hasOwnProperty;
/** Used to infer the `Object` constructor. */ var $e611954202bd3e7f$var$objectCtorString = $e611954202bd3e7f$var$funcToString.call(Object);
/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */ function $e611954202bd3e7f$var$isPlainObject(value) {
    if (!$bROf4(value) || $lIXED(value) != $e611954202bd3e7f$var$objectTag) return false;
    var proto = $bNjG2(value);
    if (proto === null) return true;
    var Ctor = $e611954202bd3e7f$var$hasOwnProperty.call(proto, "constructor") && proto.constructor;
    return typeof Ctor == "function" && Ctor instanceof Ctor && $e611954202bd3e7f$var$funcToString.call(Ctor) == $e611954202bd3e7f$var$objectCtorString;
}
module.exports = $e611954202bd3e7f$var$isPlainObject;

});

parcelRegister("ao33p", function(module, exports) {

var $3zTxP = parcelRequire("3zTxP");

var $6AVe5 = parcelRequire("6AVe5");

var $b06Np = parcelRequire("b06Np");
/* Node.js helper references. */ var $78fe83c040d01cf9$var$nodeIsTypedArray = $b06Np && $b06Np.isTypedArray;
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var $78fe83c040d01cf9$var$isTypedArray = $78fe83c040d01cf9$var$nodeIsTypedArray ? $6AVe5($78fe83c040d01cf9$var$nodeIsTypedArray) : $3zTxP;
module.exports = $78fe83c040d01cf9$var$isTypedArray;

});
parcelRegister("3zTxP", function(module, exports) {

var $lIXED = parcelRequire("lIXED");

var $3Y2Uj = parcelRequire("3Y2Uj");

var $bROf4 = parcelRequire("bROf4");
/** `Object#toString` result references. */ var $29afb9fbc80b92c2$var$argsTag = "[object Arguments]", $29afb9fbc80b92c2$var$arrayTag = "[object Array]", $29afb9fbc80b92c2$var$boolTag = "[object Boolean]", $29afb9fbc80b92c2$var$dateTag = "[object Date]", $29afb9fbc80b92c2$var$errorTag = "[object Error]", $29afb9fbc80b92c2$var$funcTag = "[object Function]", $29afb9fbc80b92c2$var$mapTag = "[object Map]", $29afb9fbc80b92c2$var$numberTag = "[object Number]", $29afb9fbc80b92c2$var$objectTag = "[object Object]", $29afb9fbc80b92c2$var$regexpTag = "[object RegExp]", $29afb9fbc80b92c2$var$setTag = "[object Set]", $29afb9fbc80b92c2$var$stringTag = "[object String]", $29afb9fbc80b92c2$var$weakMapTag = "[object WeakMap]";
var $29afb9fbc80b92c2$var$arrayBufferTag = "[object ArrayBuffer]", $29afb9fbc80b92c2$var$dataViewTag = "[object DataView]", $29afb9fbc80b92c2$var$float32Tag = "[object Float32Array]", $29afb9fbc80b92c2$var$float64Tag = "[object Float64Array]", $29afb9fbc80b92c2$var$int8Tag = "[object Int8Array]", $29afb9fbc80b92c2$var$int16Tag = "[object Int16Array]", $29afb9fbc80b92c2$var$int32Tag = "[object Int32Array]", $29afb9fbc80b92c2$var$uint8Tag = "[object Uint8Array]", $29afb9fbc80b92c2$var$uint8ClampedTag = "[object Uint8ClampedArray]", $29afb9fbc80b92c2$var$uint16Tag = "[object Uint16Array]", $29afb9fbc80b92c2$var$uint32Tag = "[object Uint32Array]";
/** Used to identify `toStringTag` values of typed arrays. */ var $29afb9fbc80b92c2$var$typedArrayTags = {};
$29afb9fbc80b92c2$var$typedArrayTags[$29afb9fbc80b92c2$var$float32Tag] = $29afb9fbc80b92c2$var$typedArrayTags[$29afb9fbc80b92c2$var$float64Tag] = $29afb9fbc80b92c2$var$typedArrayTags[$29afb9fbc80b92c2$var$int8Tag] = $29afb9fbc80b92c2$var$typedArrayTags[$29afb9fbc80b92c2$var$int16Tag] = $29afb9fbc80b92c2$var$typedArrayTags[$29afb9fbc80b92c2$var$int32Tag] = $29afb9fbc80b92c2$var$typedArrayTags[$29afb9fbc80b92c2$var$uint8Tag] = $29afb9fbc80b92c2$var$typedArrayTags[$29afb9fbc80b92c2$var$uint8ClampedTag] = $29afb9fbc80b92c2$var$typedArrayTags[$29afb9fbc80b92c2$var$uint16Tag] = $29afb9fbc80b92c2$var$typedArrayTags[$29afb9fbc80b92c2$var$uint32Tag] = true;
$29afb9fbc80b92c2$var$typedArrayTags[$29afb9fbc80b92c2$var$argsTag] = $29afb9fbc80b92c2$var$typedArrayTags[$29afb9fbc80b92c2$var$arrayTag] = $29afb9fbc80b92c2$var$typedArrayTags[$29afb9fbc80b92c2$var$arrayBufferTag] = $29afb9fbc80b92c2$var$typedArrayTags[$29afb9fbc80b92c2$var$boolTag] = $29afb9fbc80b92c2$var$typedArrayTags[$29afb9fbc80b92c2$var$dataViewTag] = $29afb9fbc80b92c2$var$typedArrayTags[$29afb9fbc80b92c2$var$dateTag] = $29afb9fbc80b92c2$var$typedArrayTags[$29afb9fbc80b92c2$var$errorTag] = $29afb9fbc80b92c2$var$typedArrayTags[$29afb9fbc80b92c2$var$funcTag] = $29afb9fbc80b92c2$var$typedArrayTags[$29afb9fbc80b92c2$var$mapTag] = $29afb9fbc80b92c2$var$typedArrayTags[$29afb9fbc80b92c2$var$numberTag] = $29afb9fbc80b92c2$var$typedArrayTags[$29afb9fbc80b92c2$var$objectTag] = $29afb9fbc80b92c2$var$typedArrayTags[$29afb9fbc80b92c2$var$regexpTag] = $29afb9fbc80b92c2$var$typedArrayTags[$29afb9fbc80b92c2$var$setTag] = $29afb9fbc80b92c2$var$typedArrayTags[$29afb9fbc80b92c2$var$stringTag] = $29afb9fbc80b92c2$var$typedArrayTags[$29afb9fbc80b92c2$var$weakMapTag] = false;
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function $29afb9fbc80b92c2$var$baseIsTypedArray(value) {
    return $bROf4(value) && $3Y2Uj(value.length) && !!$29afb9fbc80b92c2$var$typedArrayTags[$lIXED(value)];
}
module.exports = $29afb9fbc80b92c2$var$baseIsTypedArray;

});

parcelRegister("6AVe5", function(module, exports) {
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function $4cd27ec9a8cd5274$var$baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
module.exports = $4cd27ec9a8cd5274$var$baseUnary;

});

parcelRegister("b06Np", function(module, exports) {

var $kGCkG = parcelRequire("kGCkG");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && $kGCkG.process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        // Use `util.types` for Node.js 10+.
        var types = freeModule && freeModule.require && freeModule.require("util").types;
        if (types) return types;
        // Legacy `process.binding('util')` for Node.js < 10.
        return freeProcess && freeProcess.binding && freeProcess.binding("util");
    } catch (e) {}
}();
module.exports = nodeUtil;

});


parcelRegister("ekfxm", function(module, exports) {
/**
 * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $a6defc481d612326$var$safeGet(object, key) {
    if (key === "constructor" && typeof object[key] === "function") return;
    if (key == "__proto__") return;
    return object[key];
}
module.exports = $a6defc481d612326$var$safeGet;

});

parcelRegister("7Q0yl", function(module, exports) {

var $27PUz = parcelRequire("27PUz");

var $1nwvb = parcelRequire("1nwvb");
/**
 * Converts `value` to a plain object flattening inherited enumerable string
 * keyed properties of `value` to own properties of the plain object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Object} Returns the converted plain object.
 * @example
 *
 * function Foo() {
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.assign({ 'a': 1 }, new Foo);
 * // => { 'a': 1, 'b': 2 }
 *
 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
 * // => { 'a': 1, 'b': 2, 'c': 3 }
 */ function $5b4dd188cfd9d95e$var$toPlainObject(value) {
    return $27PUz(value, $1nwvb(value));
}
module.exports = $5b4dd188cfd9d95e$var$toPlainObject;

});
parcelRegister("27PUz", function(module, exports) {

var $1E0vf = parcelRequire("1E0vf");

var $frkSI = parcelRequire("frkSI");
/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */ function $18c480c4ab4f9b6b$var$copyObject(source, props, object, customizer) {
    var isNew = !object;
    object || (object = {});
    var index = -1, length = props.length;
    while(++index < length){
        var key = props[index];
        var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
        if (newValue === undefined) newValue = source[key];
        if (isNew) $frkSI(object, key, newValue);
        else $1E0vf(object, key, newValue);
    }
    return object;
}
module.exports = $18c480c4ab4f9b6b$var$copyObject;

});

parcelRegister("1nwvb", function(module, exports) {

var $3mbzH = parcelRequire("3mbzH");

var $j3HNf = parcelRequire("j3HNf");

var $a8M8t = parcelRequire("a8M8t");
/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */ function $101126a5a0c72e06$var$keysIn(object) {
    return $a8M8t(object) ? $3mbzH(object, true) : $j3HNf(object);
}
module.exports = $101126a5a0c72e06$var$keysIn;

});
parcelRegister("3mbzH", function(module, exports) {

var $bCwNY = parcelRequire("bCwNY");

var $hSVT1 = parcelRequire("hSVT1");

var $jyoU0 = parcelRequire("jyoU0");

var $1Rk6s = parcelRequire("1Rk6s");

var $cJfGN = parcelRequire("cJfGN");

var $ao33p = parcelRequire("ao33p");
/** Used for built-in method references. */ var $271c67b0ba0c385b$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $271c67b0ba0c385b$var$hasOwnProperty = $271c67b0ba0c385b$var$objectProto.hasOwnProperty;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function $271c67b0ba0c385b$var$arrayLikeKeys(value, inherited) {
    var isArr = $jyoU0(value), isArg = !isArr && $hSVT1(value), isBuff = !isArr && !isArg && $1Rk6s(value), isType = !isArr && !isArg && !isBuff && $ao33p(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? $bCwNY(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || $271c67b0ba0c385b$var$hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
    $cJfGN(key, length)))) result.push(key);
    return result;
}
module.exports = $271c67b0ba0c385b$var$arrayLikeKeys;

});
parcelRegister("bCwNY", function(module, exports) {
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function $875cb0b7f02fb011$var$baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
module.exports = $875cb0b7f02fb011$var$baseTimes;

});


parcelRegister("j3HNf", function(module, exports) {

var $2fw24 = parcelRequire("2fw24");

var $jdcNi = parcelRequire("jdcNi");

var $1m8in = parcelRequire("1m8in");
/** Used for built-in method references. */ var $de004492754d5964$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $de004492754d5964$var$hasOwnProperty = $de004492754d5964$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $de004492754d5964$var$baseKeysIn(object) {
    if (!$2fw24(object)) return $1m8in(object);
    var isProto = $jdcNi(object), result = [];
    for(var key in object)if (!(key == "constructor" && (isProto || !$de004492754d5964$var$hasOwnProperty.call(object, key)))) result.push(key);
    return result;
}
module.exports = $de004492754d5964$var$baseKeysIn;

});
parcelRegister("1m8in", function(module, exports) {
/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $0fce47cb93dd14fe$var$nativeKeysIn(object) {
    var result = [];
    if (object != null) for(var key in Object(object))result.push(key);
    return result;
}
module.exports = $0fce47cb93dd14fe$var$nativeKeysIn;

});






parcelRegister("kI6GP", function(module, exports) {

var $4Jy5Y = parcelRequire("4Jy5Y");

var $jlqeX = parcelRequire("jlqeX");
/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */ function $f13d1b28bb252469$var$createAssigner(assigner) {
    return $4Jy5Y(function(object, sources) {
        var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined, guard = length > 2 ? sources[2] : undefined;
        customizer = assigner.length > 3 && typeof customizer == "function" ? (length--, customizer) : undefined;
        if (guard && $jlqeX(sources[0], sources[1], guard)) {
            customizer = length < 3 ? undefined : customizer;
            length = 1;
        }
        object = Object(object);
        while(++index < length){
            var source = sources[index];
            if (source) assigner(object, source, index, customizer);
        }
        return object;
    });
}
module.exports = $f13d1b28bb252469$var$createAssigner;

});
parcelRegister("4Jy5Y", function(module, exports) {

var $hByKG = parcelRequire("hByKG");

var $mNnbb = parcelRequire("mNnbb");

var $ab2TD = parcelRequire("ab2TD");
/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */ function $3725cffedb9900b8$var$baseRest(func, start) {
    return $ab2TD($mNnbb(func, start, $hByKG), func + "");
}
module.exports = $3725cffedb9900b8$var$baseRest;

});
parcelRegister("hByKG", function(module, exports) {
/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */ function $cd10d9659f81cce6$var$identity(value) {
    return value;
}
module.exports = $cd10d9659f81cce6$var$identity;

});

parcelRegister("mNnbb", function(module, exports) {

var $ggDan = parcelRequire("ggDan");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $04485a9c4ba5e6dd$var$nativeMax = Math.max;
/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */ function $04485a9c4ba5e6dd$var$overRest(func, start, transform) {
    start = $04485a9c4ba5e6dd$var$nativeMax(start === undefined ? func.length - 1 : start, 0);
    return function() {
        var args = arguments, index = -1, length = $04485a9c4ba5e6dd$var$nativeMax(args.length - start, 0), array = Array(length);
        while(++index < length)array[index] = args[start + index];
        index = -1;
        var otherArgs = Array(start + 1);
        while(++index < start)otherArgs[index] = args[index];
        otherArgs[start] = transform(array);
        return $ggDan(func, this, otherArgs);
    };
}
module.exports = $04485a9c4ba5e6dd$var$overRest;

});
parcelRegister("ggDan", function(module, exports) {
/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */ function $bd7c859ac4b77dab$var$apply(func, thisArg, args) {
    switch(args.length){
        case 0:
            return func.call(thisArg);
        case 1:
            return func.call(thisArg, args[0]);
        case 2:
            return func.call(thisArg, args[0], args[1]);
        case 3:
            return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
}
module.exports = $bd7c859ac4b77dab$var$apply;

});


parcelRegister("ab2TD", function(module, exports) {

var $93ZRs = parcelRequire("93ZRs");

var $7zSkM = parcelRequire("7zSkM");
/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var $768d2d9ba48255c0$var$setToString = $7zSkM($93ZRs);
module.exports = $768d2d9ba48255c0$var$setToString;

});
parcelRegister("93ZRs", function(module, exports) {

var $ftmYD = parcelRequire("ftmYD");

var $jC19Y = parcelRequire("jC19Y");

var $hByKG = parcelRequire("hByKG");
/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var $6994613ae1aaf7c5$var$baseSetToString = !$jC19Y ? $hByKG : function(func, string) {
    return $jC19Y(func, "toString", {
        "configurable": true,
        "enumerable": false,
        "value": $ftmYD(string),
        "writable": true
    });
};
module.exports = $6994613ae1aaf7c5$var$baseSetToString;

});
parcelRegister("ftmYD", function(module, exports) {
/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */ function $b43b6336fd49d1d2$var$constant(value) {
    return function() {
        return value;
    };
}
module.exports = $b43b6336fd49d1d2$var$constant;

});


parcelRegister("7zSkM", function(module, exports) {
/** Used to detect hot functions by number of calls within a span of milliseconds. */ var $5845f2e70003ed2d$var$HOT_COUNT = 800, $5845f2e70003ed2d$var$HOT_SPAN = 16;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $5845f2e70003ed2d$var$nativeNow = Date.now;
/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */ function $5845f2e70003ed2d$var$shortOut(func) {
    var count = 0, lastCalled = 0;
    return function() {
        var stamp = $5845f2e70003ed2d$var$nativeNow(), remaining = $5845f2e70003ed2d$var$HOT_SPAN - (stamp - lastCalled);
        lastCalled = stamp;
        if (remaining > 0) {
            if (++count >= $5845f2e70003ed2d$var$HOT_COUNT) return arguments[0];
        } else count = 0;
        return func.apply(undefined, arguments);
    };
}
module.exports = $5845f2e70003ed2d$var$shortOut;

});



parcelRegister("jlqeX", function(module, exports) {

var $b82f6 = parcelRequire("b82f6");

var $a8M8t = parcelRequire("a8M8t");

var $cJfGN = parcelRequire("cJfGN");

var $2fw24 = parcelRequire("2fw24");
/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */ function $e15455462658bf4d$var$isIterateeCall(value, index, object) {
    if (!$2fw24(object)) return false;
    var type = typeof index;
    if (type == "number" ? $a8M8t(object) && $cJfGN(index, object.length) : type == "string" && index in object) return $b82f6(object[index], value);
    return false;
}
module.exports = $e15455462658bf4d$var$isIterateeCall;

});



parcelRegister("8jUEk", function(module, exports) {

$parcel$export(module.exports, "profileAvatarQueryKey", function () { return $f71156939f7b6edc$export$2ec31fd48bb2c4e4; });
$parcel$export(module.exports, "useProfileAvatarQuery", function () { return $f71156939f7b6edc$export$4c2edab07a56d55f; });

var $4MHck = parcelRequire("4MHck");

var $1Bj4T = parcelRequire("1Bj4T");

var $eUuk8 = parcelRequire("eUuk8");
const $f71156939f7b6edc$export$2ec31fd48bb2c4e4 = "useProfileAvatarQueryKey";
const $f71156939f7b6edc$var$profileAvatarQueryQueryFn = async (userId)=>{
    const { stargateRoot: stargateRoot } = (0, $1Bj4T.getConfig)();
    const aggUrl = `${stargateRoot}/graphql?q=ProfileAvatar`;
    const { name: fullName, picture: avatarUrl, accountStatus: status } = await (0, $eUuk8.default)({
        userId: userId,
        url: aggUrl
    });
    return {
        status: status,
        avatarUrl: avatarUrl,
        fullName: fullName
    };
};
const $f71156939f7b6edc$export$4c2edab07a56d55f = (userId)=>{
    const { data: data, isLoading: isLoading, isError: isError } = (0, $4MHck.useQuery)({
        queryKey: [
            $f71156939f7b6edc$export$2ec31fd48bb2c4e4,
            userId
        ],
        queryFn: ()=>$f71156939f7b6edc$var$profileAvatarQueryQueryFn(userId)
    });
    return {
        profileAvatar: data,
        isLoading: isLoading,
        isError: isError
    };
};

});
parcelRegister("4MHck", function(module, exports) {

$parcel$export(module.exports, "useQuery", function () { return $37bd274c97865e2c$export$dd0a697e1782aedd; });

var $iqz0v = parcelRequire("iqz0v");
var $lDfMW = parcelRequire("lDfMW");

var $iMTE3 = parcelRequire("iMTE3");
"use client";
function $37bd274c97865e2c$export$dd0a697e1782aedd(arg1, arg2, arg3) {
    const parsedOptions = (0, $iqz0v.parseQueryArgs)(arg1, arg2, arg3);
    return (0, $iMTE3.useBaseQuery)(parsedOptions, (0, $lDfMW.QueryObserver));
}

});
parcelRegister("lDfMW", function(module, exports) {

$parcel$export(module.exports, "QueryObserver", function () { return $fbf97cbb993c3df3$export$a06cf8c0066f0d4c; });

var $iqz0v = parcelRequire("iqz0v");

var $QaI8V = parcelRequire("QaI8V");

var $bzUDw = parcelRequire("bzUDw");

var $1RjI5 = parcelRequire("1RjI5");

var $gbAXU = parcelRequire("gbAXU");
class $fbf97cbb993c3df3$export$a06cf8c0066f0d4c extends (0, $1RjI5.Subscribable) {
    constructor(client, options){
        super();
        this.client = client;
        this.options = options;
        this.trackedProps = new Set();
        this.selectError = null;
        this.bindMethods();
        this.setOptions(options);
    }
    bindMethods() {
        this.remove = this.remove.bind(this);
        this.refetch = this.refetch.bind(this);
    }
    onSubscribe() {
        if (this.listeners.size === 1) {
            this.currentQuery.addObserver(this);
            if ($fbf97cbb993c3df3$var$shouldFetchOnMount(this.currentQuery, this.options)) this.executeFetch();
            this.updateTimers();
        }
    }
    onUnsubscribe() {
        if (!this.hasListeners()) this.destroy();
    }
    shouldFetchOnReconnect() {
        return $fbf97cbb993c3df3$var$shouldFetchOn(this.currentQuery, this.options, this.options.refetchOnReconnect);
    }
    shouldFetchOnWindowFocus() {
        return $fbf97cbb993c3df3$var$shouldFetchOn(this.currentQuery, this.options, this.options.refetchOnWindowFocus);
    }
    destroy() {
        this.listeners = new Set();
        this.clearStaleTimeout();
        this.clearRefetchInterval();
        this.currentQuery.removeObserver(this);
    }
    setOptions(options, notifyOptions) {
        const prevOptions = this.options;
        const prevQuery = this.currentQuery;
        this.options = this.client.defaultQueryOptions(options);
        if (!(0, $iqz0v.shallowEqualObjects)(prevOptions, this.options)) this.client.getQueryCache().notify({
            type: "observerOptionsUpdated",
            query: this.currentQuery,
            observer: this
        });
        if (typeof this.options.enabled !== "undefined" && typeof this.options.enabled !== "boolean") throw new Error("Expected enabled to be a boolean");
         // Keep previous query key if the user does not supply one
        if (!this.options.queryKey) this.options.queryKey = prevOptions.queryKey;
        this.updateQuery();
        const mounted = this.hasListeners(); // Fetch if there are subscribers
        if (mounted && $fbf97cbb993c3df3$var$shouldFetchOptionally(this.currentQuery, prevQuery, this.options, prevOptions)) this.executeFetch();
         // Update result
        this.updateResult(notifyOptions); // Update stale interval if needed
        if (mounted && (this.currentQuery !== prevQuery || this.options.enabled !== prevOptions.enabled || this.options.staleTime !== prevOptions.staleTime)) this.updateStaleTimeout();
        const nextRefetchInterval = this.computeRefetchInterval(); // Update refetch interval if needed
        if (mounted && (this.currentQuery !== prevQuery || this.options.enabled !== prevOptions.enabled || nextRefetchInterval !== this.currentRefetchInterval)) this.updateRefetchInterval(nextRefetchInterval);
    }
    getOptimisticResult(options) {
        const query = this.client.getQueryCache().build(this.client, options);
        const result = this.createResult(query, options);
        if ($fbf97cbb993c3df3$var$shouldAssignObserverCurrentProperties(this, result, options)) {
            // this assigns the optimistic result to the current Observer
            // because if the query function changes, useQuery will be performing
            // an effect where it would fetch again.
            // When the fetch finishes, we perform a deep data cloning in order
            // to reuse objects references. This deep data clone is performed against
            // the `observer.currentResult.data` property
            // When QueryKey changes, we refresh the query and get new `optimistic`
            // result, while we leave the `observer.currentResult`, so when new data
            // arrives, it finds the old `observer.currentResult` which is related
            // to the old QueryKey. Which means that currentResult and selectData are
            // out of sync already.
            // To solve this, we move the cursor of the currentResult everytime
            // an observer reads an optimistic value.
            // When keeping the previous data, the result doesn't change until new
            // data arrives.
            this.currentResult = result;
            this.currentResultOptions = this.options;
            this.currentResultState = this.currentQuery.state;
        }
        return result;
    }
    getCurrentResult() {
        return this.currentResult;
    }
    trackResult(result) {
        const trackedResult = {};
        Object.keys(result).forEach((key)=>{
            Object.defineProperty(trackedResult, key, {
                configurable: false,
                enumerable: true,
                get: ()=>{
                    this.trackedProps.add(key);
                    return result[key];
                }
            });
        });
        return trackedResult;
    }
    getCurrentQuery() {
        return this.currentQuery;
    }
    remove() {
        this.client.getQueryCache().remove(this.currentQuery);
    }
    refetch({ refetchPage: refetchPage, ...options } = {}) {
        return this.fetch({
            ...options,
            meta: {
                refetchPage: refetchPage
            }
        });
    }
    fetchOptimistic(options) {
        const defaultedOptions = this.client.defaultQueryOptions(options);
        const query = this.client.getQueryCache().build(this.client, defaultedOptions);
        query.isFetchingOptimistic = true;
        return query.fetch().then(()=>this.createResult(query, defaultedOptions));
    }
    fetch(fetchOptions) {
        var _fetchOptions$cancelR;
        return this.executeFetch({
            ...fetchOptions,
            cancelRefetch: (_fetchOptions$cancelR = fetchOptions.cancelRefetch) != null ? _fetchOptions$cancelR : true
        }).then(()=>{
            this.updateResult();
            return this.currentResult;
        });
    }
    executeFetch(fetchOptions) {
        // Make sure we reference the latest query as the current one might have been removed
        this.updateQuery(); // Fetch
        let promise = this.currentQuery.fetch(this.options, fetchOptions);
        if (!(fetchOptions != null && fetchOptions.throwOnError)) promise = promise.catch((0, $iqz0v.noop));
        return promise;
    }
    updateStaleTimeout() {
        this.clearStaleTimeout();
        if ((0, $iqz0v.isServer) || this.currentResult.isStale || !(0, $iqz0v.isValidTimeout)(this.options.staleTime)) return;
        const time = (0, $iqz0v.timeUntilStale)(this.currentResult.dataUpdatedAt, this.options.staleTime); // The timeout is sometimes triggered 1 ms before the stale time expiration.
        // To mitigate this issue we always add 1 ms to the timeout.
        const timeout = time + 1;
        this.staleTimeoutId = setTimeout(()=>{
            if (!this.currentResult.isStale) this.updateResult();
        }, timeout);
    }
    computeRefetchInterval() {
        var _this$options$refetch;
        return typeof this.options.refetchInterval === "function" ? this.options.refetchInterval(this.currentResult.data, this.currentQuery) : (_this$options$refetch = this.options.refetchInterval) != null ? _this$options$refetch : false;
    }
    updateRefetchInterval(nextInterval) {
        this.clearRefetchInterval();
        this.currentRefetchInterval = nextInterval;
        if ((0, $iqz0v.isServer) || this.options.enabled === false || !(0, $iqz0v.isValidTimeout)(this.currentRefetchInterval) || this.currentRefetchInterval === 0) return;
        this.refetchIntervalId = setInterval(()=>{
            if (this.options.refetchIntervalInBackground || (0, $bzUDw.focusManager).isFocused()) this.executeFetch();
        }, this.currentRefetchInterval);
    }
    updateTimers() {
        this.updateStaleTimeout();
        this.updateRefetchInterval(this.computeRefetchInterval());
    }
    clearStaleTimeout() {
        if (this.staleTimeoutId) {
            clearTimeout(this.staleTimeoutId);
            this.staleTimeoutId = undefined;
        }
    }
    clearRefetchInterval() {
        if (this.refetchIntervalId) {
            clearInterval(this.refetchIntervalId);
            this.refetchIntervalId = undefined;
        }
    }
    createResult(query, options) {
        const prevQuery = this.currentQuery;
        const prevOptions = this.options;
        const prevResult = this.currentResult;
        const prevResultState = this.currentResultState;
        const prevResultOptions = this.currentResultOptions;
        const queryChange = query !== prevQuery;
        const queryInitialState = queryChange ? query.state : this.currentQueryInitialState;
        const prevQueryResult = queryChange ? this.currentResult : this.previousQueryResult;
        const { state: state } = query;
        let { dataUpdatedAt: dataUpdatedAt, error: error, errorUpdatedAt: errorUpdatedAt, fetchStatus: fetchStatus, status: status } = state;
        let isPreviousData = false;
        let isPlaceholderData = false;
        let data; // Optimistically set result in fetching state if needed
        if (options._optimisticResults) {
            const mounted = this.hasListeners();
            const fetchOnMount = !mounted && $fbf97cbb993c3df3$var$shouldFetchOnMount(query, options);
            const fetchOptionally = mounted && $fbf97cbb993c3df3$var$shouldFetchOptionally(query, prevQuery, options, prevOptions);
            if (fetchOnMount || fetchOptionally) {
                fetchStatus = (0, $gbAXU.canFetch)(query.options.networkMode) ? "fetching" : "paused";
                if (!dataUpdatedAt) status = "loading";
            }
            if (options._optimisticResults === "isRestoring") fetchStatus = "idle";
        } // Keep previous data if needed
        if (options.keepPreviousData && !state.dataUpdatedAt && prevQueryResult != null && prevQueryResult.isSuccess && status !== "error") {
            data = prevQueryResult.data;
            dataUpdatedAt = prevQueryResult.dataUpdatedAt;
            status = prevQueryResult.status;
            isPreviousData = true;
        } else if (options.select && typeof state.data !== "undefined") {
            // Memoize select result
            if (prevResult && state.data === (prevResultState == null ? void 0 : prevResultState.data) && options.select === this.selectFn) data = this.selectResult;
            else try {
                this.selectFn = options.select;
                data = options.select(state.data);
                data = (0, $iqz0v.replaceData)(prevResult == null ? void 0 : prevResult.data, data, options);
                this.selectResult = data;
                this.selectError = null;
            } catch (selectError) {
                this.selectError = selectError;
            }
        } else data = state.data;
         // Show placeholder data if needed
        if (typeof options.placeholderData !== "undefined" && typeof data === "undefined" && status === "loading") {
            let placeholderData; // Memoize placeholder data
            if (prevResult != null && prevResult.isPlaceholderData && options.placeholderData === (prevResultOptions == null ? void 0 : prevResultOptions.placeholderData)) placeholderData = prevResult.data;
            else {
                placeholderData = typeof options.placeholderData === "function" ? options.placeholderData() : options.placeholderData;
                if (options.select && typeof placeholderData !== "undefined") try {
                    placeholderData = options.select(placeholderData);
                    this.selectError = null;
                } catch (selectError) {
                    this.selectError = selectError;
                }
            }
            if (typeof placeholderData !== "undefined") {
                status = "success";
                data = (0, $iqz0v.replaceData)(prevResult == null ? void 0 : prevResult.data, placeholderData, options);
                isPlaceholderData = true;
            }
        }
        if (this.selectError) {
            error = this.selectError;
            data = this.selectResult;
            errorUpdatedAt = Date.now();
            status = "error";
        }
        const isFetching = fetchStatus === "fetching";
        const isLoading = status === "loading";
        const isError = status === "error";
        const result = {
            status: status,
            fetchStatus: fetchStatus,
            isLoading: isLoading,
            isSuccess: status === "success",
            isError: isError,
            isInitialLoading: isLoading && isFetching,
            data: data,
            dataUpdatedAt: dataUpdatedAt,
            error: error,
            errorUpdatedAt: errorUpdatedAt,
            failureCount: state.fetchFailureCount,
            failureReason: state.fetchFailureReason,
            errorUpdateCount: state.errorUpdateCount,
            isFetched: state.dataUpdateCount > 0 || state.errorUpdateCount > 0,
            isFetchedAfterMount: state.dataUpdateCount > queryInitialState.dataUpdateCount || state.errorUpdateCount > queryInitialState.errorUpdateCount,
            isFetching: isFetching,
            isRefetching: isFetching && !isLoading,
            isLoadingError: isError && state.dataUpdatedAt === 0,
            isPaused: fetchStatus === "paused",
            isPlaceholderData: isPlaceholderData,
            isPreviousData: isPreviousData,
            isRefetchError: isError && state.dataUpdatedAt !== 0,
            isStale: $fbf97cbb993c3df3$var$isStale(query, options),
            refetch: this.refetch,
            remove: this.remove
        };
        return result;
    }
    updateResult(notifyOptions) {
        const prevResult = this.currentResult;
        const nextResult = this.createResult(this.currentQuery, this.options);
        this.currentResultState = this.currentQuery.state;
        this.currentResultOptions = this.options; // Only notify and update result if something has changed
        if ((0, $iqz0v.shallowEqualObjects)(nextResult, prevResult)) return;
        this.currentResult = nextResult; // Determine which callbacks to trigger
        const defaultNotifyOptions = {
            cache: true
        };
        const shouldNotifyListeners = ()=>{
            if (!prevResult) return true;
            const { notifyOnChangeProps: notifyOnChangeProps } = this.options;
            const notifyOnChangePropsValue = typeof notifyOnChangeProps === "function" ? notifyOnChangeProps() : notifyOnChangeProps;
            if (notifyOnChangePropsValue === "all" || !notifyOnChangePropsValue && !this.trackedProps.size) return true;
            const includedProps = new Set(notifyOnChangePropsValue != null ? notifyOnChangePropsValue : this.trackedProps);
            if (this.options.useErrorBoundary) includedProps.add("error");
            return Object.keys(this.currentResult).some((key)=>{
                const typedKey = key;
                const changed = this.currentResult[typedKey] !== prevResult[typedKey];
                return changed && includedProps.has(typedKey);
            });
        };
        if ((notifyOptions == null ? void 0 : notifyOptions.listeners) !== false && shouldNotifyListeners()) defaultNotifyOptions.listeners = true;
        this.notify({
            ...defaultNotifyOptions,
            ...notifyOptions
        });
    }
    updateQuery() {
        const query = this.client.getQueryCache().build(this.client, this.options);
        if (query === this.currentQuery) return;
        const prevQuery = this.currentQuery;
        this.currentQuery = query;
        this.currentQueryInitialState = query.state;
        this.previousQueryResult = this.currentResult;
        if (this.hasListeners()) {
            prevQuery == null || prevQuery.removeObserver(this);
            query.addObserver(this);
        }
    }
    onQueryUpdate(action) {
        const notifyOptions = {};
        if (action.type === "success") notifyOptions.onSuccess = !action.manual;
        else if (action.type === "error" && !(0, $gbAXU.isCancelledError)(action.error)) notifyOptions.onError = true;
        this.updateResult(notifyOptions);
        if (this.hasListeners()) this.updateTimers();
    }
    notify(notifyOptions) {
        (0, $QaI8V.notifyManager).batch(()=>{
            // First trigger the configuration callbacks
            if (notifyOptions.onSuccess) {
                var _this$options$onSucce, _this$options, _this$options$onSettl, _this$options2;
                (_this$options$onSucce = (_this$options = this.options).onSuccess) == null || _this$options$onSucce.call(_this$options, this.currentResult.data);
                (_this$options$onSettl = (_this$options2 = this.options).onSettled) == null || _this$options$onSettl.call(_this$options2, this.currentResult.data, null);
            } else if (notifyOptions.onError) {
                var _this$options$onError, _this$options3, _this$options$onSettl2, _this$options4;
                (_this$options$onError = (_this$options3 = this.options).onError) == null || _this$options$onError.call(_this$options3, this.currentResult.error);
                (_this$options$onSettl2 = (_this$options4 = this.options).onSettled) == null || _this$options$onSettl2.call(_this$options4, undefined, this.currentResult.error);
            } // Then trigger the listeners
            if (notifyOptions.listeners) this.listeners.forEach(({ listener: listener })=>{
                listener(this.currentResult);
            });
             // Then the cache listeners
            if (notifyOptions.cache) this.client.getQueryCache().notify({
                query: this.currentQuery,
                type: "observerResultsUpdated"
            });
        });
    }
}
function $fbf97cbb993c3df3$var$shouldLoadOnMount(query, options) {
    return options.enabled !== false && !query.state.dataUpdatedAt && !(query.state.status === "error" && options.retryOnMount === false);
}
function $fbf97cbb993c3df3$var$shouldFetchOnMount(query, options) {
    return $fbf97cbb993c3df3$var$shouldLoadOnMount(query, options) || query.state.dataUpdatedAt > 0 && $fbf97cbb993c3df3$var$shouldFetchOn(query, options, options.refetchOnMount);
}
function $fbf97cbb993c3df3$var$shouldFetchOn(query, options, field) {
    if (options.enabled !== false) {
        const value = typeof field === "function" ? field(query) : field;
        return value === "always" || value !== false && $fbf97cbb993c3df3$var$isStale(query, options);
    }
    return false;
}
function $fbf97cbb993c3df3$var$shouldFetchOptionally(query, prevQuery, options, prevOptions) {
    return options.enabled !== false && (query !== prevQuery || prevOptions.enabled === false) && (!options.suspense || query.state.status !== "error") && $fbf97cbb993c3df3$var$isStale(query, options);
}
function $fbf97cbb993c3df3$var$isStale(query, options) {
    return query.isStaleByTime(options.staleTime);
} // this function would decide if we will update the observer's 'current'
// properties after an optimistic reading via getOptimisticResult
function $fbf97cbb993c3df3$var$shouldAssignObserverCurrentProperties(observer, optimisticResult, options) {
    // it is important to keep this condition like this for three reasons:
    // 1. It will get removed in the v5
    // 2. it reads: don't update the properties if we want to keep the previous
    // data.
    // 3. The opposite condition (!options.keepPreviousData) would fallthrough
    // and will result in a bad decision
    if (options.keepPreviousData) return false;
     // this means we want to put some placeholder data when pending and queryKey
    // changed.
    if (options.placeholderData !== undefined) // re-assign properties only if current data is placeholder data
    // which means that data did not arrive yet, so, if there is some cached data
    // we need to "prepare" to receive it
    return optimisticResult.isPlaceholderData;
     // if the newly created result isn't what the observer is holding as current,
    // then we'll need to update the properties as well
    if (!(0, $iqz0v.shallowEqualObjects)(observer.getCurrentResult(), optimisticResult)) return true;
     // basically, just keep previous properties if nothing changed
    return false;
}

});

parcelRegister("iMTE3", function(module, exports) {

$parcel$export(module.exports, "useBaseQuery", function () { return $dad7dfa67d39eab7$export$fff0865807e996c5; });

var $dAx5m = parcelRequire("dAx5m");

var $QaI8V = parcelRequire("QaI8V");

var $akDF7 = parcelRequire("akDF7");

var $cmdGx = parcelRequire("cmdGx");

var $132jP = parcelRequire("132jP");

var $jdhGv = parcelRequire("jdhGv");

var $aIvef = parcelRequire("aIvef");

var $dICGc = parcelRequire("dICGc");
"use client";
function $dad7dfa67d39eab7$export$fff0865807e996c5(options, Observer) {
    const queryClient = (0, $132jP.useQueryClient)({
        context: options.context
    });
    const isRestoring = (0, $jdhGv.useIsRestoring)();
    const errorResetBoundary = (0, $cmdGx.useQueryErrorResetBoundary)();
    const defaultedOptions = queryClient.defaultQueryOptions(options); // Make sure results are optimistically set in fetching state before subscribing or updating options
    defaultedOptions._optimisticResults = isRestoring ? "isRestoring" : "optimistic"; // Include callbacks in batch renders
    if (defaultedOptions.onError) defaultedOptions.onError = (0, $QaI8V.notifyManager).batchCalls(defaultedOptions.onError);
    if (defaultedOptions.onSuccess) defaultedOptions.onSuccess = (0, $QaI8V.notifyManager).batchCalls(defaultedOptions.onSuccess);
    if (defaultedOptions.onSettled) defaultedOptions.onSettled = (0, $QaI8V.notifyManager).batchCalls(defaultedOptions.onSettled);
    (0, $dICGc.ensureStaleTime)(defaultedOptions);
    (0, $aIvef.ensurePreventErrorBoundaryRetry)(defaultedOptions, errorResetBoundary);
    (0, $aIvef.useClearResetErrorBoundary)(errorResetBoundary);
    const [observer] = $dAx5m.useState(()=>new Observer(queryClient, defaultedOptions));
    const result = observer.getOptimisticResult(defaultedOptions);
    (0, $akDF7.useSyncExternalStore)($dAx5m.useCallback((onStoreChange)=>{
        const unsubscribe = isRestoring ? ()=>undefined : observer.subscribe((0, $QaI8V.notifyManager).batchCalls(onStoreChange)); // Update result to make sure we did not miss any query updates
        // between creating the observer and subscribing to it.
        observer.updateResult();
        return unsubscribe;
    }, [
        observer,
        isRestoring
    ]), ()=>observer.getCurrentResult(), ()=>observer.getCurrentResult());
    $dAx5m.useEffect(()=>{
        // Do not notify on updates because of changes in the options because
        // these changes should already be reflected in the optimistic result.
        observer.setOptions(defaultedOptions, {
            listeners: false
        });
    }, [
        defaultedOptions,
        observer
    ]); // Handle suspense
    if ((0, $dICGc.shouldSuspend)(defaultedOptions, result, isRestoring)) throw (0, $dICGc.fetchOptimistic)(defaultedOptions, observer, errorResetBoundary);
     // Handle error boundary
    if ((0, $aIvef.getHasError)({
        result: result,
        errorResetBoundary: errorResetBoundary,
        useErrorBoundary: defaultedOptions.useErrorBoundary,
        query: observer.getCurrentQuery()
    })) throw result.error;
     // Handle result property usage tracking
    return !defaultedOptions.notifyOnChangeProps ? observer.trackResult(result) : result;
}

});
parcelRegister("cmdGx", function(module, exports) {

$parcel$export(module.exports, "useQueryErrorResetBoundary", function () { return $8ff227b1eb733ef4$export$50dfac555130cafd; });

var $dAx5m = parcelRequire("dAx5m");
"use client";
function $8ff227b1eb733ef4$var$createValue() {
    let isReset = false;
    return {
        clearReset: ()=>{
            isReset = false;
        },
        reset: ()=>{
            isReset = true;
        },
        isReset: ()=>{
            return isReset;
        }
    };
}
const $8ff227b1eb733ef4$var$QueryErrorResetBoundaryContext = /*#__PURE__*/ $dAx5m.createContext($8ff227b1eb733ef4$var$createValue()); // HOOK
const $8ff227b1eb733ef4$export$50dfac555130cafd = ()=>$dAx5m.useContext($8ff227b1eb733ef4$var$QueryErrorResetBoundaryContext); // COMPONENT
const $8ff227b1eb733ef4$export$ddb9962d870f2330 = ({ children: children })=>{
    const [value] = $dAx5m.useState(()=>$8ff227b1eb733ef4$var$createValue());
    return /*#__PURE__*/ $dAx5m.createElement($8ff227b1eb733ef4$var$QueryErrorResetBoundaryContext.Provider, {
        value: value
    }, typeof children === "function" ? children(value) : children);
};

});

parcelRegister("jdhGv", function(module, exports) {

$parcel$export(module.exports, "useIsRestoring", function () { return $dfccf3003f3746fc$export$4da0178d6b5f553; });

var $dAx5m = parcelRequire("dAx5m");
"use client";
const $dfccf3003f3746fc$var$IsRestoringContext = /*#__PURE__*/ $dAx5m.createContext(false);
const $dfccf3003f3746fc$export$4da0178d6b5f553 = ()=>$dAx5m.useContext($dfccf3003f3746fc$var$IsRestoringContext);
const $dfccf3003f3746fc$export$593807d4e94f9621 = $dfccf3003f3746fc$var$IsRestoringContext.Provider;

});

parcelRegister("aIvef", function(module, exports) {

$parcel$export(module.exports, "ensurePreventErrorBoundaryRetry", function () { return $7cd63cd015bbce78$export$ae8adb3de3d77633; });
$parcel$export(module.exports, "useClearResetErrorBoundary", function () { return $7cd63cd015bbce78$export$b2b17ca3a1fb0229; });
$parcel$export(module.exports, "getHasError", function () { return $7cd63cd015bbce78$export$1fbcf724762d607; });

var $dAx5m = parcelRequire("dAx5m");

var $aahK4 = parcelRequire("aahK4");
"use client";
const $7cd63cd015bbce78$export$ae8adb3de3d77633 = (options, errorResetBoundary)=>{
    if (options.suspense || options.useErrorBoundary) // Prevent retrying failed query if the error boundary has not been reset yet
    {
        if (!errorResetBoundary.isReset()) options.retryOnMount = false;
    }
};
const $7cd63cd015bbce78$export$b2b17ca3a1fb0229 = (errorResetBoundary)=>{
    $dAx5m.useEffect(()=>{
        errorResetBoundary.clearReset();
    }, [
        errorResetBoundary
    ]);
};
const $7cd63cd015bbce78$export$1fbcf724762d607 = ({ result: result, errorResetBoundary: errorResetBoundary, useErrorBoundary: useErrorBoundary, query: query })=>{
    return result.isError && !errorResetBoundary.isReset() && !result.isFetching && (0, $aahK4.shouldThrowError)(useErrorBoundary, [
        result.error,
        query
    ]);
};

});

parcelRegister("dICGc", function(module, exports) {

$parcel$export(module.exports, "ensureStaleTime", function () { return $9fcd6368551714aa$export$2c40a591ad2dafb1; });
$parcel$export(module.exports, "willFetch", function () { return $9fcd6368551714aa$export$e0a3f29513afe430; });
$parcel$export(module.exports, "shouldSuspend", function () { return $9fcd6368551714aa$export$88d3586dfed64df9; });
$parcel$export(module.exports, "fetchOptimistic", function () { return $9fcd6368551714aa$export$defdc11a9c9acfcf; });
const $9fcd6368551714aa$export$2c40a591ad2dafb1 = (defaultedOptions)=>{
    if (defaultedOptions.suspense) // Always set stale time when using suspense to prevent
    // fetching again when directly mounting after suspending
    {
        if (typeof defaultedOptions.staleTime !== "number") defaultedOptions.staleTime = 1000;
    }
};
const $9fcd6368551714aa$export$e0a3f29513afe430 = (result, isRestoring)=>result.isLoading && result.isFetching && !isRestoring;
const $9fcd6368551714aa$export$88d3586dfed64df9 = (defaultedOptions, result, isRestoring)=>(defaultedOptions == null ? void 0 : defaultedOptions.suspense) && $9fcd6368551714aa$export$e0a3f29513afe430(result, isRestoring);
const $9fcd6368551714aa$export$defdc11a9c9acfcf = (defaultedOptions, observer, errorResetBoundary)=>observer.fetchOptimistic(defaultedOptions).then(({ data: data })=>{
        defaultedOptions.onSuccess == null || defaultedOptions.onSuccess(data);
        defaultedOptions.onSettled == null || defaultedOptions.onSettled(data, null);
    }).catch((error)=>{
        errorResetBoundary.clearReset();
        defaultedOptions.onError == null || defaultedOptions.onError(error);
        defaultedOptions.onSettled == null || defaultedOptions.onSettled(undefined, error);
    });

});



parcelRegister("eUuk8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3cb5a930455f136a$export$2e2bcd8739ae039; });

var $9NjwA = parcelRequire("9NjwA");
const $3cb5a930455f136a$export$da2f563366e05f1 = (0, $9NjwA.gql)`
  query User($userId: ID!) {
    user(accountId: $userId) {
      id
      name
      picture
      accountStatus
      ... on AtlassianAccountUser {
        email
      }
    }
  }
`;
const $3cb5a930455f136a$var$queryUserFromAGG = async ({ userId: userId, url: url })=>{
    const response = await fetch(url, {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        credentials: "include",
        body: JSON.stringify({
            query: $3cb5a930455f136a$export$da2f563366e05f1,
            variables: {
                userId: userId
            }
        })
    });
    const { data: { user: user } } = await response.json();
    // The AGG User query returns an id in the format "ari:cloud:identity::user/712020:123456-1234-440e-a377-8c7657b123456".
    // Given the potential instability of the prefix format and the requirement to use only the last part of the id,
    // it's safer to directly use `userId` as the `id` to ensure consistency and reliability.
    return {
        ...user,
        id: userId
    };
};
var $3cb5a930455f136a$export$2e2bcd8739ae039 = $3cb5a930455f136a$var$queryUserFromAGG;

});
parcelRegister("9NjwA", function(module, exports) {
"use strict";
var $01d718180fe24c47$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $01d718180fe24c47$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $01d718180fe24c47$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $01d718180fe24c47$var$__createBinding(result, mod, k);
    }
    $01d718180fe24c47$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.request = module.exports.rawRequest = module.exports.GraphQLClient = module.exports.ClientError = module.exports.batchRequests = module.exports.resolveRequestDocument = module.exports.GraphQLWebSocketClient = module.exports.gql = void 0;

var $rkTHe = parcelRequire("rkTHe");

var $1igkh = parcelRequire("1igkh");

var $2bb5N = parcelRequire("2bb5N");

var $gUyD7 = parcelRequire("gUyD7");

var $wEq4m = parcelRequire("wEq4m");
Object.defineProperty(module.exports, "ClientError", {
    enumerable: true,
    get: function() {
        return $wEq4m.ClientError;
    }
});

const $01d718180fe24c47$var$cross_fetch_1 = $01d718180fe24c47$var$__importStar((parcelRequire("fJW6e"))), $01d718180fe24c47$var$CrossFetch = $01d718180fe24c47$var$cross_fetch_1;
/**
 * Convert the given headers configuration into a plain object.
 */ const $01d718180fe24c47$var$resolveHeaders = (headers)=>{
    let oHeaders = {};
    if (headers) {
        if (typeof Headers !== `undefined` && headers instanceof Headers || $01d718180fe24c47$var$CrossFetch && $01d718180fe24c47$var$CrossFetch.Headers && headers instanceof $01d718180fe24c47$var$CrossFetch.Headers) oHeaders = (0, $1igkh.HeadersInstanceToPlainObject)(headers);
        else if (Array.isArray(headers)) headers.forEach(([name, value])=>{
            if (name && value !== undefined) oHeaders[name] = value;
        });
        else oHeaders = headers;
    }
    return oHeaders;
};
/**
 * Clean a GraphQL document to send it via a GET query
 */ const $01d718180fe24c47$var$cleanQuery = (str)=>str.replace(/([\s,]|#[^\n\r]+)+/g, ` `).trim();
/**
 * Create query string for GraphQL request
 */ const $01d718180fe24c47$var$buildRequestConfig = (params)=>{
    if (!Array.isArray(params.query)) {
        const params_ = params;
        const search = [
            `query=${encodeURIComponent($01d718180fe24c47$var$cleanQuery(params_.query))}`
        ];
        if (params.variables) search.push(`variables=${encodeURIComponent(params_.jsonSerializer.stringify(params_.variables))}`);
        if (params_.operationName) search.push(`operationName=${encodeURIComponent(params_.operationName)}`);
        return search.join(`&`);
    }
    if (typeof params.variables !== `undefined` && !Array.isArray(params.variables)) throw new Error(`Cannot create query with given variable type, array expected`);
    // Batch support
    const params_ = params;
    const payload = params.query.reduce((acc, currentQuery, index)=>{
        acc.push({
            query: $01d718180fe24c47$var$cleanQuery(currentQuery),
            variables: params_.variables ? params_.jsonSerializer.stringify(params_.variables[index]) : undefined
        });
        return acc;
    }, []);
    return `query=${encodeURIComponent(params_.jsonSerializer.stringify(payload))}`;
};
const $01d718180fe24c47$var$createHttpMethodFetcher = (method)=>async (params)=>{
        const { url: url, query: query, variables: variables, operationName: operationName, fetch: fetch, fetchOptions: fetchOptions, middleware: middleware } = params;
        const headers = {
            ...params.headers
        };
        let queryParams = ``;
        let body = undefined;
        if (method === `POST`) {
            body = $01d718180fe24c47$var$createRequestBody(query, variables, operationName, fetchOptions.jsonSerializer);
            if (typeof body === `string`) // @ts-expect-error todo
            headers[`Content-Type`] = `application/json`;
        } else // @ts-expect-error todo needs ADT for TS to understand the different states
        queryParams = $01d718180fe24c47$var$buildRequestConfig({
            query: query,
            variables: variables,
            operationName: operationName,
            jsonSerializer: fetchOptions.jsonSerializer ?? $rkTHe.defaultJsonSerializer
        });
        const init = {
            method: method,
            headers: headers,
            body: body,
            ...fetchOptions
        };
        let urlResolved = url;
        let initResolved = init;
        if (middleware) {
            const result = await Promise.resolve(middleware({
                ...init,
                url: url,
                operationName: operationName,
                variables: variables
            }));
            const { url: urlNew, ...initNew } = result;
            urlResolved = urlNew;
            initResolved = initNew;
        }
        if (queryParams) urlResolved = `${urlResolved}?${queryParams}`;
        return await fetch(urlResolved, initResolved);
    };
/**
 * GraphQL Client.
 */ class $01d718180fe24c47$var$GraphQLClient {
    constructor(url, requestConfig = {}){
        this.url = url;
        this.requestConfig = requestConfig;
        /**
         * Send a GraphQL query to the server.
         */ this.rawRequest = async (...args)=>{
            const [queryOrOptions, variables, requestHeaders] = args;
            const rawRequestOptions = (0, $2bb5N.parseRawRequestArgs)(queryOrOptions, variables, requestHeaders);
            const { headers: headers, fetch: fetch = $01d718180fe24c47$var$cross_fetch_1.default, method: method = `POST`, requestMiddleware: requestMiddleware, responseMiddleware: responseMiddleware, ...fetchOptions } = this.requestConfig;
            const { url: url } = this;
            if (rawRequestOptions.signal !== undefined) fetchOptions.signal = rawRequestOptions.signal;
            const { operationName: operationName } = (0, $gUyD7.resolveRequestDocument)(rawRequestOptions.query);
            return $01d718180fe24c47$var$makeRequest({
                url: url,
                query: rawRequestOptions.query,
                variables: rawRequestOptions.variables,
                headers: {
                    ...$01d718180fe24c47$var$resolveHeaders($01d718180fe24c47$var$callOrIdentity(headers)),
                    ...$01d718180fe24c47$var$resolveHeaders(rawRequestOptions.requestHeaders)
                },
                operationName: operationName,
                fetch: fetch,
                method: method,
                fetchOptions: fetchOptions,
                middleware: requestMiddleware
            }).then((response)=>{
                if (responseMiddleware) responseMiddleware(response);
                return response;
            }).catch((error)=>{
                if (responseMiddleware) responseMiddleware(error);
                throw error;
            });
        };
    }
    async request(documentOrOptions, ...variablesAndRequestHeaders) {
        const [variables, requestHeaders] = variablesAndRequestHeaders;
        const requestOptions = (0, $2bb5N.parseRequestArgs)(documentOrOptions, variables, requestHeaders);
        const { headers: headers, fetch: fetch = $01d718180fe24c47$var$cross_fetch_1.default, method: method = `POST`, requestMiddleware: requestMiddleware, responseMiddleware: responseMiddleware, ...fetchOptions } = this.requestConfig;
        const { url: url } = this;
        if (requestOptions.signal !== undefined) fetchOptions.signal = requestOptions.signal;
        const { query: query, operationName: operationName } = (0, $gUyD7.resolveRequestDocument)(requestOptions.document);
        return $01d718180fe24c47$var$makeRequest({
            url: url,
            query: query,
            variables: requestOptions.variables,
            headers: {
                ...$01d718180fe24c47$var$resolveHeaders($01d718180fe24c47$var$callOrIdentity(headers)),
                ...$01d718180fe24c47$var$resolveHeaders(requestOptions.requestHeaders)
            },
            operationName: operationName,
            fetch: fetch,
            method: method,
            fetchOptions: fetchOptions,
            middleware: requestMiddleware
        }).then((response)=>{
            if (responseMiddleware) responseMiddleware(response);
            return response.data;
        }).catch((error)=>{
            if (responseMiddleware) responseMiddleware(error);
            throw error;
        });
    }
    // prettier-ignore
    batchRequests(documentsOrOptions, requestHeaders) {
        const batchRequestOptions = (0, $2bb5N.parseBatchRequestArgs)(documentsOrOptions, requestHeaders);
        const { headers: headers, ...fetchOptions } = this.requestConfig;
        if (batchRequestOptions.signal !== undefined) fetchOptions.signal = batchRequestOptions.signal;
        const queries = batchRequestOptions.documents.map(({ document: document })=>(0, $gUyD7.resolveRequestDocument)(document).query);
        const variables = batchRequestOptions.documents.map(({ variables: variables })=>variables);
        return $01d718180fe24c47$var$makeRequest({
            url: this.url,
            query: queries,
            variables: // @ts-expect-error TODO reconcile batch variables into system.
            variables,
            headers: {
                ...$01d718180fe24c47$var$resolveHeaders($01d718180fe24c47$var$callOrIdentity(headers)),
                ...$01d718180fe24c47$var$resolveHeaders(batchRequestOptions.requestHeaders)
            },
            operationName: undefined,
            fetch: this.requestConfig.fetch ?? $01d718180fe24c47$var$cross_fetch_1.default,
            method: this.requestConfig.method || `POST`,
            fetchOptions: fetchOptions,
            middleware: this.requestConfig.requestMiddleware
        }).then((response)=>{
            if (this.requestConfig.responseMiddleware) this.requestConfig.responseMiddleware(response);
            return response.data;
        }).catch((error)=>{
            if (this.requestConfig.responseMiddleware) this.requestConfig.responseMiddleware(error);
            throw error;
        });
    }
    setHeaders(headers) {
        this.requestConfig.headers = headers;
        return this;
    }
    /**
     * Attach a header to the client. All subsequent requests will have this header.
     */ setHeader(key, value) {
        const { headers: headers } = this.requestConfig;
        if (headers) // todo what if headers is in nested array form... ?
        //@ts-expect-error todo
        headers[key] = value;
        else this.requestConfig.headers = {
            [key]: value
        };
        return this;
    }
    /**
     * Change the client endpoint. All subsequent requests will send to this endpoint.
     */ setEndpoint(value) {
        this.url = value;
        return this;
    }
}
module.exports.GraphQLClient = $01d718180fe24c47$var$GraphQLClient;
const $01d718180fe24c47$var$makeRequest = async (params)=>{
    const { query: query, variables: variables, fetchOptions: fetchOptions } = params;
    const fetcher = $01d718180fe24c47$var$createHttpMethodFetcher((0, $1igkh.uppercase)(params.method ?? `post`));
    const isBatchingQuery = Array.isArray(params.query);
    const response = await fetcher(params);
    const result = await $01d718180fe24c47$var$getResult(response, fetchOptions.jsonSerializer ?? $rkTHe.defaultJsonSerializer);
    const successfullyReceivedData = Array.isArray(result) ? !result.some(({ data: data })=>!data) : Boolean(result.data);
    const successfullyPassedErrorPolicy = Array.isArray(result) || !result.errors || Array.isArray(result.errors) && !result.errors.length || fetchOptions.errorPolicy === `all` || fetchOptions.errorPolicy === `ignore`;
    if (response.ok && successfullyPassedErrorPolicy && successfullyReceivedData) {
        // @ts-expect-error TODO fixme
        const { errors: _, ...rest } = Array.isArray(result) ? result : result;
        const data = fetchOptions.errorPolicy === `ignore` ? rest : result;
        const dataEnvelope = isBatchingQuery ? {
            data: data
        } : data;
        // @ts-expect-error TODO
        return {
            ...dataEnvelope,
            headers: response.headers,
            status: response.status
        };
    } else {
        const errorResult = typeof result === `string` ? {
            error: result
        } : result;
        throw new $wEq4m.ClientError(// @ts-expect-error TODO
        {
            ...errorResult,
            status: response.status,
            headers: response.headers
        }, {
            query: query,
            variables: variables
        });
    }
};
/**
 * Send a GraphQL Query to the GraphQL server for execution.
 */ const $01d718180fe24c47$var$rawRequest = async (...args)=>{
    const [urlOrOptions, query, ...variablesAndRequestHeaders] = args;
    const requestOptions = (0, $2bb5N.parseRawRequestExtendedArgs)(urlOrOptions, query, ...variablesAndRequestHeaders);
    const client = new $01d718180fe24c47$var$GraphQLClient(requestOptions.url);
    return client.rawRequest({
        ...requestOptions
    });
};
module.exports.rawRequest = $01d718180fe24c47$var$rawRequest;
// prettier-ignore
// eslint-disable-next-line
async function $01d718180fe24c47$var$request(urlOrOptions, document, ...variablesAndRequestHeaders) {
    const requestOptions = (0, $2bb5N.parseRequestExtendedArgs)(urlOrOptions, document, ...variablesAndRequestHeaders);
    const client = new $01d718180fe24c47$var$GraphQLClient(requestOptions.url);
    return client.request({
        ...requestOptions
    });
}
module.exports.request = $01d718180fe24c47$var$request;
/**
 * Send a batch of GraphQL Document to the GraphQL server for execution.
 *
 * @example
 *
 * ```ts
 * // You can pass a raw string
 *
 * await batchRequests('https://foo.bar/graphql', [
 * {
 *  query: `
 *   {
 *     query {
 *       users
 *     }
 *   }`
 * },
 * {
 *   query: `
 *   {
 *     query {
 *       users
 *     }
 *   }`
 * }])
 *
 * // You can also pass a GraphQL DocumentNode as query. Convenient if you
 * // are using graphql-tag package.
 *
 * import gql from 'graphql-tag'
 *
 * await batchRequests('https://foo.bar/graphql', [{ query: gql`...` }])
 * ```
 */ const $01d718180fe24c47$var$batchRequests = async (...args)=>{
    const params = $01d718180fe24c47$var$parseBatchRequestsArgsExtended(args);
    const client = new $01d718180fe24c47$var$GraphQLClient(params.url);
    return client.batchRequests(params);
};
module.exports.batchRequests = $01d718180fe24c47$var$batchRequests;
const $01d718180fe24c47$var$parseBatchRequestsArgsExtended = (args)=>{
    if (args.length === 1) return args[0];
    else return {
        url: args[0],
        documents: args[1],
        requestHeaders: args[2],
        signal: undefined
    };
};
const $01d718180fe24c47$var$createRequestBody = (query, variables, operationName, jsonSerializer)=>{
    const jsonSerializer_ = jsonSerializer ?? $rkTHe.defaultJsonSerializer;
    if (!Array.isArray(query)) return jsonSerializer_.stringify({
        query: query,
        variables: variables,
        operationName: operationName
    });
    if (typeof variables !== `undefined` && !Array.isArray(variables)) throw new Error(`Cannot create request body with given variable type, array expected`);
    // Batch support
    const payload = query.reduce((acc, currentQuery, index)=>{
        acc.push({
            query: currentQuery,
            variables: variables ? variables[index] : undefined
        });
        return acc;
    }, []);
    return jsonSerializer_.stringify(payload);
};
const $01d718180fe24c47$var$getResult = async (response, jsonSerializer)=>{
    let contentType;
    response.headers.forEach((value, key)=>{
        if (key.toLowerCase() === `content-type`) contentType = value;
    });
    if (contentType && (contentType.toLowerCase().startsWith(`application/json`) || contentType.toLowerCase().startsWith(`application/graphql+json`) || contentType.toLowerCase().startsWith(`application/graphql-response+json`))) return jsonSerializer.parse(await response.text());
    else return response.text();
};
const $01d718180fe24c47$var$callOrIdentity = (value)=>{
    return typeof value === `function` ? value() : value;
};
/**
 * Convenience passthrough template tag to get the benefits of tooling for the gql template tag. This does not actually parse the input into a GraphQL DocumentNode like graphql-tag package does. It just returns the string with any variables given interpolated. Can save you a bit of performance and having to install another package.
 *
 * @example
 * ```
 * import { gql } from 'graphql-request'
 *
 * await request('https://foo.bar/graphql', gql`...`)
 * ```
 *
 * @remarks
 *
 * Several tools in the Node GraphQL ecosystem are hardcoded to specially treat any template tag named "gql". For example see this prettier issue: https://github.com/prettier/prettier/issues/4360. Using this template tag has no runtime effect beyond variable interpolation.
 */ const $01d718180fe24c47$var$gql = (chunks, ...variables)=>{
    return chunks.reduce((acc, chunk, index)=>`${acc}${chunk}${index in variables ? String(variables[index]) : ``}`, ``);
};
module.exports.gql = $01d718180fe24c47$var$gql;

var $64v0p = parcelRequire("64v0p");
Object.defineProperty(module.exports, "GraphQLWebSocketClient", {
    enumerable: true,
    get: function() {
        return $64v0p.GraphQLWebSocketClient;
    }
});

var $gUyD7 = parcelRequire("gUyD7");
Object.defineProperty(module.exports, "resolveRequestDocument", {
    enumerable: true,
    get: function() {
        return $gUyD7.resolveRequestDocument;
    }
});
module.exports.default = $01d718180fe24c47$var$request;

});
parcelRegister("rkTHe", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.defaultJsonSerializer = void 0;
module.exports.defaultJsonSerializer = JSON;

});

parcelRegister("1igkh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.HeadersInstanceToPlainObject = module.exports.uppercase = void 0;
const $0f1422ea7a0d5b3c$var$uppercase = (str)=>str.toUpperCase();
module.exports.uppercase = $0f1422ea7a0d5b3c$var$uppercase;
/**
 * Convert Headers instance into regular object
 */ const $0f1422ea7a0d5b3c$var$HeadersInstanceToPlainObject = (headers)=>{
    const o = {};
    headers.forEach((v, k)=>{
        o[k] = v;
    });
    return o;
};
module.exports.HeadersInstanceToPlainObject = $0f1422ea7a0d5b3c$var$HeadersInstanceToPlainObject;

});

parcelRegister("2bb5N", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.parseRawRequestExtendedArgs = module.exports.parseRequestExtendedArgs = module.exports.parseBatchRequestArgs = module.exports.parseRawRequestArgs = module.exports.parseRequestArgs = void 0;
const $19653692b5df639a$var$parseRequestArgs = (documentOrOptions, variables, requestHeaders)=>{
    return documentOrOptions.document ? documentOrOptions : {
        document: documentOrOptions,
        variables: variables,
        requestHeaders: requestHeaders,
        signal: undefined
    };
};
module.exports.parseRequestArgs = $19653692b5df639a$var$parseRequestArgs;
const $19653692b5df639a$var$parseRawRequestArgs = (queryOrOptions, variables, requestHeaders)=>{
    return queryOrOptions.query ? queryOrOptions : {
        query: queryOrOptions,
        variables: variables,
        requestHeaders: requestHeaders,
        signal: undefined
    };
};
module.exports.parseRawRequestArgs = $19653692b5df639a$var$parseRawRequestArgs;
const $19653692b5df639a$var$parseBatchRequestArgs = (documentsOrOptions, requestHeaders)=>{
    return documentsOrOptions.documents ? documentsOrOptions : {
        documents: documentsOrOptions,
        requestHeaders: requestHeaders,
        signal: undefined
    };
};
module.exports.parseBatchRequestArgs = $19653692b5df639a$var$parseBatchRequestArgs;
const $19653692b5df639a$var$parseRequestExtendedArgs = (urlOrOptions, document, ...variablesAndRequestHeaders)=>{
    const [variables, requestHeaders] = variablesAndRequestHeaders;
    return urlOrOptions.document ? urlOrOptions : {
        url: urlOrOptions,
        document: document,
        variables: variables,
        requestHeaders: requestHeaders,
        signal: undefined
    };
};
module.exports.parseRequestExtendedArgs = $19653692b5df639a$var$parseRequestExtendedArgs;
const $19653692b5df639a$var$parseRawRequestExtendedArgs = (urlOrOptions, query, ...variablesAndRequestHeaders)=>{
    const [variables, requestHeaders] = variablesAndRequestHeaders;
    return urlOrOptions.query ? urlOrOptions : {
        url: urlOrOptions,
        query: query,
        variables: variables,
        requestHeaders: requestHeaders,
        signal: undefined
    };
};
module.exports.parseRawRequestExtendedArgs = $19653692b5df639a$var$parseRawRequestExtendedArgs;

});

parcelRegister("gUyD7", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.resolveRequestDocument = void 0;

var $61AhH = parcelRequire("61AhH");
var $iHmIK = parcelRequire("iHmIK");
/**
 * helpers
 */ const $c4fcbd16f09c1599$var$extractOperationName = (document)=>{
    let operationName = undefined;
    const operationDefinitions = document.definitions.filter((definition)=>definition.kind === `OperationDefinition`);
    if (operationDefinitions.length === 1) operationName = operationDefinitions[0]?.name?.value;
    return operationName;
};
const $c4fcbd16f09c1599$var$resolveRequestDocument = (document)=>{
    if (typeof document === `string`) {
        let operationName = undefined;
        try {
            const parsedDocument = (0, $61AhH.parse)(document);
            operationName = $c4fcbd16f09c1599$var$extractOperationName(parsedDocument);
        } catch (err) {
        // Failed parsing the document, the operationName will be undefined
        }
        return {
            query: document,
            operationName: operationName
        };
    }
    const operationName = $c4fcbd16f09c1599$var$extractOperationName(document);
    return {
        query: (0, $iHmIK.print)(document),
        operationName: operationName
    };
};
module.exports.resolveRequestDocument = $c4fcbd16f09c1599$var$resolveRequestDocument;

});
parcelRegister("61AhH", function(module, exports) {

$parcel$export(module.exports, "parse", function () { return $e70460d084dddc5c$export$98e6a39c04603d36; });

var $6hqcz = parcelRequire("6hqcz");

var $efBUw = parcelRequire("efBUw");

var $bm0nk = parcelRequire("bm0nk");

var $7lYaM = parcelRequire("7lYaM");

var $gXaMM = parcelRequire("gXaMM");

var $6PCvk = parcelRequire("6PCvk");

var $dlqjC = parcelRequire("dlqjC");

var $4bOBX = parcelRequire("4bOBX");

var $eUHO5 = parcelRequire("eUHO5");
function $e70460d084dddc5c$export$98e6a39c04603d36(source, options) {
    var parser = new $e70460d084dddc5c$var$Parser(source, options);
    return parser.parseDocument();
}
function $e70460d084dddc5c$export$5303528d1070ff6f(source, options) {
    var parser = new $e70460d084dddc5c$var$Parser(source, options);
    parser.expectToken((0, $eUHO5.TokenKind).SOF);
    var value = parser.parseValueLiteral(false);
    parser.expectToken((0, $eUHO5.TokenKind).EOF);
    return value;
}
function $e70460d084dddc5c$export$28b8f402ccc88182(source, options) {
    var parser = new $e70460d084dddc5c$var$Parser(source, options);
    parser.expectToken((0, $eUHO5.TokenKind).SOF);
    var type = parser.parseTypeReference();
    parser.expectToken((0, $eUHO5.TokenKind).EOF);
    return type;
}
var $e70460d084dddc5c$var$Parser = /*#__PURE__*/ function() {
    function Parser(source, options) {
        var sourceObj = typeof source === "string" ? new (0, $6PCvk.Source)(source) : source;
        sourceObj instanceof (0, $6PCvk.Source) || (0, $efBUw.default)(0, "Must provide Source. Received: ".concat((0, $6hqcz.default)(sourceObj)));
        this._lexer = (0, $dlqjC.createLexer)(sourceObj);
        this._options = options || {};
    }
    /**
   * Converts a name lex token into a name parse node.
   */ var _proto = Parser.prototype;
    _proto.parseName = function parseName() {
        var token = this.expectToken((0, $eUHO5.TokenKind).NAME);
        return {
            kind: (0, $gXaMM.Kind).NAME,
            value: token.value,
            loc: this.loc(token)
        };
    } // Implements the parsing rules in the Document section.
     /**
   * Document : Definition+
   */ ;
    _proto.parseDocument = function parseDocument() {
        var start = this._lexer.token;
        return {
            kind: (0, $gXaMM.Kind).DOCUMENT,
            definitions: this.many((0, $eUHO5.TokenKind).SOF, this.parseDefinition, (0, $eUHO5.TokenKind).EOF),
            loc: this.loc(start)
        };
    } /**
   * Definition :
   *   - ExecutableDefinition
   *   - TypeSystemDefinition
   *   - TypeSystemExtension
   *
   * ExecutableDefinition :
   *   - OperationDefinition
   *   - FragmentDefinition
   */ ;
    _proto.parseDefinition = function parseDefinition() {
        if (this.peek((0, $eUHO5.TokenKind).NAME)) switch(this._lexer.token.value){
            case "query":
            case "mutation":
            case "subscription":
                return this.parseOperationDefinition();
            case "fragment":
                return this.parseFragmentDefinition();
            case "schema":
            case "scalar":
            case "type":
            case "interface":
            case "union":
            case "enum":
            case "input":
            case "directive":
                return this.parseTypeSystemDefinition();
            case "extend":
                return this.parseTypeSystemExtension();
        }
        else if (this.peek((0, $eUHO5.TokenKind).BRACE_L)) return this.parseOperationDefinition();
        else if (this.peekDescription()) return this.parseTypeSystemDefinition();
        throw this.unexpected();
    } // Implements the parsing rules in the Operations section.
     /**
   * OperationDefinition :
   *  - SelectionSet
   *  - OperationType Name? VariableDefinitions? Directives? SelectionSet
   */ ;
    _proto.parseOperationDefinition = function parseOperationDefinition() {
        var start = this._lexer.token;
        if (this.peek((0, $eUHO5.TokenKind).BRACE_L)) return {
            kind: (0, $gXaMM.Kind).OPERATION_DEFINITION,
            operation: "query",
            name: undefined,
            variableDefinitions: [],
            directives: [],
            selectionSet: this.parseSelectionSet(),
            loc: this.loc(start)
        };
        var operation = this.parseOperationType();
        var name;
        if (this.peek((0, $eUHO5.TokenKind).NAME)) name = this.parseName();
        return {
            kind: (0, $gXaMM.Kind).OPERATION_DEFINITION,
            operation: operation,
            name: name,
            variableDefinitions: this.parseVariableDefinitions(),
            directives: this.parseDirectives(false),
            selectionSet: this.parseSelectionSet(),
            loc: this.loc(start)
        };
    } /**
   * OperationType : one of query mutation subscription
   */ ;
    _proto.parseOperationType = function parseOperationType() {
        var operationToken = this.expectToken((0, $eUHO5.TokenKind).NAME);
        switch(operationToken.value){
            case "query":
                return "query";
            case "mutation":
                return "mutation";
            case "subscription":
                return "subscription";
        }
        throw this.unexpected(operationToken);
    } /**
   * VariableDefinitions : ( VariableDefinition+ )
   */ ;
    _proto.parseVariableDefinitions = function parseVariableDefinitions() {
        return this.optionalMany((0, $eUHO5.TokenKind).PAREN_L, this.parseVariableDefinition, (0, $eUHO5.TokenKind).PAREN_R);
    } /**
   * VariableDefinition : Variable : Type DefaultValue? Directives[Const]?
   */ ;
    _proto.parseVariableDefinition = function parseVariableDefinition() {
        var start = this._lexer.token;
        return {
            kind: (0, $gXaMM.Kind).VARIABLE_DEFINITION,
            variable: this.parseVariable(),
            type: (this.expectToken((0, $eUHO5.TokenKind).COLON), this.parseTypeReference()),
            defaultValue: this.expectOptionalToken((0, $eUHO5.TokenKind).EQUALS) ? this.parseValueLiteral(true) : undefined,
            directives: this.parseDirectives(true),
            loc: this.loc(start)
        };
    } /**
   * Variable : $ Name
   */ ;
    _proto.parseVariable = function parseVariable() {
        var start = this._lexer.token;
        this.expectToken((0, $eUHO5.TokenKind).DOLLAR);
        return {
            kind: (0, $gXaMM.Kind).VARIABLE,
            name: this.parseName(),
            loc: this.loc(start)
        };
    } /**
   * SelectionSet : { Selection+ }
   */ ;
    _proto.parseSelectionSet = function parseSelectionSet() {
        var start = this._lexer.token;
        return {
            kind: (0, $gXaMM.Kind).SELECTION_SET,
            selections: this.many((0, $eUHO5.TokenKind).BRACE_L, this.parseSelection, (0, $eUHO5.TokenKind).BRACE_R),
            loc: this.loc(start)
        };
    } /**
   * Selection :
   *   - Field
   *   - FragmentSpread
   *   - InlineFragment
   */ ;
    _proto.parseSelection = function parseSelection() {
        return this.peek((0, $eUHO5.TokenKind).SPREAD) ? this.parseFragment() : this.parseField();
    } /**
   * Field : Alias? Name Arguments? Directives? SelectionSet?
   *
   * Alias : Name :
   */ ;
    _proto.parseField = function parseField() {
        var start = this._lexer.token;
        var nameOrAlias = this.parseName();
        var alias;
        var name;
        if (this.expectOptionalToken((0, $eUHO5.TokenKind).COLON)) {
            alias = nameOrAlias;
            name = this.parseName();
        } else name = nameOrAlias;
        return {
            kind: (0, $gXaMM.Kind).FIELD,
            alias: alias,
            name: name,
            arguments: this.parseArguments(false),
            directives: this.parseDirectives(false),
            selectionSet: this.peek((0, $eUHO5.TokenKind).BRACE_L) ? this.parseSelectionSet() : undefined,
            loc: this.loc(start)
        };
    } /**
   * Arguments[Const] : ( Argument[?Const]+ )
   */ ;
    _proto.parseArguments = function parseArguments(isConst) {
        var item = isConst ? this.parseConstArgument : this.parseArgument;
        return this.optionalMany((0, $eUHO5.TokenKind).PAREN_L, item, (0, $eUHO5.TokenKind).PAREN_R);
    } /**
   * Argument[Const] : Name : Value[?Const]
   */ ;
    _proto.parseArgument = function parseArgument() {
        var start = this._lexer.token;
        var name = this.parseName();
        this.expectToken((0, $eUHO5.TokenKind).COLON);
        return {
            kind: (0, $gXaMM.Kind).ARGUMENT,
            name: name,
            value: this.parseValueLiteral(false),
            loc: this.loc(start)
        };
    };
    _proto.parseConstArgument = function parseConstArgument() {
        var start = this._lexer.token;
        return {
            kind: (0, $gXaMM.Kind).ARGUMENT,
            name: this.parseName(),
            value: (this.expectToken((0, $eUHO5.TokenKind).COLON), this.parseValueLiteral(true)),
            loc: this.loc(start)
        };
    } // Implements the parsing rules in the Fragments section.
     /**
   * Corresponds to both FragmentSpread and InlineFragment in the spec.
   *
   * FragmentSpread : ... FragmentName Directives?
   *
   * InlineFragment : ... TypeCondition? Directives? SelectionSet
   */ ;
    _proto.parseFragment = function parseFragment() {
        var start = this._lexer.token;
        this.expectToken((0, $eUHO5.TokenKind).SPREAD);
        var hasTypeCondition = this.expectOptionalKeyword("on");
        if (!hasTypeCondition && this.peek((0, $eUHO5.TokenKind).NAME)) return {
            kind: (0, $gXaMM.Kind).FRAGMENT_SPREAD,
            name: this.parseFragmentName(),
            directives: this.parseDirectives(false),
            loc: this.loc(start)
        };
        return {
            kind: (0, $gXaMM.Kind).INLINE_FRAGMENT,
            typeCondition: hasTypeCondition ? this.parseNamedType() : undefined,
            directives: this.parseDirectives(false),
            selectionSet: this.parseSelectionSet(),
            loc: this.loc(start)
        };
    } /**
   * FragmentDefinition :
   *   - fragment FragmentName on TypeCondition Directives? SelectionSet
   *
   * TypeCondition : NamedType
   */ ;
    _proto.parseFragmentDefinition = function parseFragmentDefinition() {
        var start = this._lexer.token;
        this.expectKeyword("fragment"); // Experimental support for defining variables within fragments changes
        // the grammar of FragmentDefinition:
        //   - fragment FragmentName VariableDefinitions? on TypeCondition Directives? SelectionSet
        if (this._options.experimentalFragmentVariables) return {
            kind: (0, $gXaMM.Kind).FRAGMENT_DEFINITION,
            name: this.parseFragmentName(),
            variableDefinitions: this.parseVariableDefinitions(),
            typeCondition: (this.expectKeyword("on"), this.parseNamedType()),
            directives: this.parseDirectives(false),
            selectionSet: this.parseSelectionSet(),
            loc: this.loc(start)
        };
        return {
            kind: (0, $gXaMM.Kind).FRAGMENT_DEFINITION,
            name: this.parseFragmentName(),
            typeCondition: (this.expectKeyword("on"), this.parseNamedType()),
            directives: this.parseDirectives(false),
            selectionSet: this.parseSelectionSet(),
            loc: this.loc(start)
        };
    } /**
   * FragmentName : Name but not `on`
   */ ;
    _proto.parseFragmentName = function parseFragmentName() {
        if (this._lexer.token.value === "on") throw this.unexpected();
        return this.parseName();
    } // Implements the parsing rules in the Values section.
     /**
   * Value[Const] :
   *   - [~Const] Variable
   *   - IntValue
   *   - FloatValue
   *   - StringValue
   *   - BooleanValue
   *   - NullValue
   *   - EnumValue
   *   - ListValue[?Const]
   *   - ObjectValue[?Const]
   *
   * BooleanValue : one of `true` `false`
   *
   * NullValue : `null`
   *
   * EnumValue : Name but not `true`, `false` or `null`
   */ ;
    _proto.parseValueLiteral = function parseValueLiteral(isConst) {
        var token = this._lexer.token;
        switch(token.kind){
            case (0, $eUHO5.TokenKind).BRACKET_L:
                return this.parseList(isConst);
            case (0, $eUHO5.TokenKind).BRACE_L:
                return this.parseObject(isConst);
            case (0, $eUHO5.TokenKind).INT:
                this._lexer.advance();
                return {
                    kind: (0, $gXaMM.Kind).INT,
                    value: token.value,
                    loc: this.loc(token)
                };
            case (0, $eUHO5.TokenKind).FLOAT:
                this._lexer.advance();
                return {
                    kind: (0, $gXaMM.Kind).FLOAT,
                    value: token.value,
                    loc: this.loc(token)
                };
            case (0, $eUHO5.TokenKind).STRING:
            case (0, $eUHO5.TokenKind).BLOCK_STRING:
                return this.parseStringLiteral();
            case (0, $eUHO5.TokenKind).NAME:
                if (token.value === "true" || token.value === "false") {
                    this._lexer.advance();
                    return {
                        kind: (0, $gXaMM.Kind).BOOLEAN,
                        value: token.value === "true",
                        loc: this.loc(token)
                    };
                } else if (token.value === "null") {
                    this._lexer.advance();
                    return {
                        kind: (0, $gXaMM.Kind).NULL,
                        loc: this.loc(token)
                    };
                }
                this._lexer.advance();
                return {
                    kind: (0, $gXaMM.Kind).ENUM,
                    value: token.value,
                    loc: this.loc(token)
                };
            case (0, $eUHO5.TokenKind).DOLLAR:
                if (!isConst) return this.parseVariable();
                break;
        }
        throw this.unexpected();
    };
    _proto.parseStringLiteral = function parseStringLiteral() {
        var token = this._lexer.token;
        this._lexer.advance();
        return {
            kind: (0, $gXaMM.Kind).STRING,
            value: token.value,
            block: token.kind === (0, $eUHO5.TokenKind).BLOCK_STRING,
            loc: this.loc(token)
        };
    } /**
   * ListValue[Const] :
   *   - [ ]
   *   - [ Value[?Const]+ ]
   */ ;
    _proto.parseList = function parseList(isConst) {
        var _this = this;
        var start = this._lexer.token;
        var item = function item() {
            return _this.parseValueLiteral(isConst);
        };
        return {
            kind: (0, $gXaMM.Kind).LIST,
            values: this.any((0, $eUHO5.TokenKind).BRACKET_L, item, (0, $eUHO5.TokenKind).BRACKET_R),
            loc: this.loc(start)
        };
    } /**
   * ObjectValue[Const] :
   *   - { }
   *   - { ObjectField[?Const]+ }
   */ ;
    _proto.parseObject = function parseObject(isConst) {
        var _this2 = this;
        var start = this._lexer.token;
        var item = function item() {
            return _this2.parseObjectField(isConst);
        };
        return {
            kind: (0, $gXaMM.Kind).OBJECT,
            fields: this.any((0, $eUHO5.TokenKind).BRACE_L, item, (0, $eUHO5.TokenKind).BRACE_R),
            loc: this.loc(start)
        };
    } /**
   * ObjectField[Const] : Name : Value[?Const]
   */ ;
    _proto.parseObjectField = function parseObjectField(isConst) {
        var start = this._lexer.token;
        var name = this.parseName();
        this.expectToken((0, $eUHO5.TokenKind).COLON);
        return {
            kind: (0, $gXaMM.Kind).OBJECT_FIELD,
            name: name,
            value: this.parseValueLiteral(isConst),
            loc: this.loc(start)
        };
    } // Implements the parsing rules in the Directives section.
     /**
   * Directives[Const] : Directive[?Const]+
   */ ;
    _proto.parseDirectives = function parseDirectives(isConst) {
        var directives = [];
        while(this.peek((0, $eUHO5.TokenKind).AT))directives.push(this.parseDirective(isConst));
        return directives;
    } /**
   * Directive[Const] : @ Name Arguments[?Const]?
   */ ;
    _proto.parseDirective = function parseDirective(isConst) {
        var start = this._lexer.token;
        this.expectToken((0, $eUHO5.TokenKind).AT);
        return {
            kind: (0, $gXaMM.Kind).DIRECTIVE,
            name: this.parseName(),
            arguments: this.parseArguments(isConst),
            loc: this.loc(start)
        };
    } // Implements the parsing rules in the Types section.
     /**
   * Type :
   *   - NamedType
   *   - ListType
   *   - NonNullType
   */ ;
    _proto.parseTypeReference = function parseTypeReference() {
        var start = this._lexer.token;
        var type;
        if (this.expectOptionalToken((0, $eUHO5.TokenKind).BRACKET_L)) {
            type = this.parseTypeReference();
            this.expectToken((0, $eUHO5.TokenKind).BRACKET_R);
            type = {
                kind: (0, $gXaMM.Kind).LIST_TYPE,
                type: type,
                loc: this.loc(start)
            };
        } else type = this.parseNamedType();
        if (this.expectOptionalToken((0, $eUHO5.TokenKind).BANG)) return {
            kind: (0, $gXaMM.Kind).NON_NULL_TYPE,
            type: type,
            loc: this.loc(start)
        };
        return type;
    } /**
   * NamedType : Name
   */ ;
    _proto.parseNamedType = function parseNamedType() {
        var start = this._lexer.token;
        return {
            kind: (0, $gXaMM.Kind).NAMED_TYPE,
            name: this.parseName(),
            loc: this.loc(start)
        };
    } // Implements the parsing rules in the Type Definition section.
     /**
   * TypeSystemDefinition :
   *   - SchemaDefinition
   *   - TypeDefinition
   *   - DirectiveDefinition
   *
   * TypeDefinition :
   *   - ScalarTypeDefinition
   *   - ObjectTypeDefinition
   *   - InterfaceTypeDefinition
   *   - UnionTypeDefinition
   *   - EnumTypeDefinition
   *   - InputObjectTypeDefinition
   */ ;
    _proto.parseTypeSystemDefinition = function parseTypeSystemDefinition() {
        // Many definitions begin with a description and require a lookahead.
        var keywordToken = this.peekDescription() ? this._lexer.lookahead() : this._lexer.token;
        if (keywordToken.kind === (0, $eUHO5.TokenKind).NAME) switch(keywordToken.value){
            case "schema":
                return this.parseSchemaDefinition();
            case "scalar":
                return this.parseScalarTypeDefinition();
            case "type":
                return this.parseObjectTypeDefinition();
            case "interface":
                return this.parseInterfaceTypeDefinition();
            case "union":
                return this.parseUnionTypeDefinition();
            case "enum":
                return this.parseEnumTypeDefinition();
            case "input":
                return this.parseInputObjectTypeDefinition();
            case "directive":
                return this.parseDirectiveDefinition();
        }
        throw this.unexpected(keywordToken);
    };
    _proto.peekDescription = function peekDescription() {
        return this.peek((0, $eUHO5.TokenKind).STRING) || this.peek((0, $eUHO5.TokenKind).BLOCK_STRING);
    } /**
   * Description : StringValue
   */ ;
    _proto.parseDescription = function parseDescription() {
        if (this.peekDescription()) return this.parseStringLiteral();
    } /**
   * SchemaDefinition : schema Directives[Const]? { OperationTypeDefinition+ }
   */ ;
    _proto.parseSchemaDefinition = function parseSchemaDefinition() {
        var start = this._lexer.token;
        this.expectKeyword("schema");
        var directives = this.parseDirectives(true);
        var operationTypes = this.many((0, $eUHO5.TokenKind).BRACE_L, this.parseOperationTypeDefinition, (0, $eUHO5.TokenKind).BRACE_R);
        return {
            kind: (0, $gXaMM.Kind).SCHEMA_DEFINITION,
            directives: directives,
            operationTypes: operationTypes,
            loc: this.loc(start)
        };
    } /**
   * OperationTypeDefinition : OperationType : NamedType
   */ ;
    _proto.parseOperationTypeDefinition = function parseOperationTypeDefinition() {
        var start = this._lexer.token;
        var operation = this.parseOperationType();
        this.expectToken((0, $eUHO5.TokenKind).COLON);
        var type = this.parseNamedType();
        return {
            kind: (0, $gXaMM.Kind).OPERATION_TYPE_DEFINITION,
            operation: operation,
            type: type,
            loc: this.loc(start)
        };
    } /**
   * ScalarTypeDefinition : Description? scalar Name Directives[Const]?
   */ ;
    _proto.parseScalarTypeDefinition = function parseScalarTypeDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword("scalar");
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        return {
            kind: (0, $gXaMM.Kind).SCALAR_TYPE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            loc: this.loc(start)
        };
    } /**
   * ObjectTypeDefinition :
   *   Description?
   *   type Name ImplementsInterfaces? Directives[Const]? FieldsDefinition?
   */ ;
    _proto.parseObjectTypeDefinition = function parseObjectTypeDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword("type");
        var name = this.parseName();
        var interfaces = this.parseImplementsInterfaces();
        var directives = this.parseDirectives(true);
        var fields = this.parseFieldsDefinition();
        return {
            kind: (0, $gXaMM.Kind).OBJECT_TYPE_DEFINITION,
            description: description,
            name: name,
            interfaces: interfaces,
            directives: directives,
            fields: fields,
            loc: this.loc(start)
        };
    } /**
   * ImplementsInterfaces :
   *   - implements `&`? NamedType
   *   - ImplementsInterfaces & NamedType
   */ ;
    _proto.parseImplementsInterfaces = function parseImplementsInterfaces() {
        var types = [];
        if (this.expectOptionalKeyword("implements")) {
            // Optional leading ampersand
            this.expectOptionalToken((0, $eUHO5.TokenKind).AMP);
            do types.push(this.parseNamedType());
            while (this.expectOptionalToken((0, $eUHO5.TokenKind).AMP) || // Legacy support for the SDL?
            this._options.allowLegacySDLImplementsInterfaces && this.peek((0, $eUHO5.TokenKind).NAME));
        }
        return types;
    } /**
   * FieldsDefinition : { FieldDefinition+ }
   */ ;
    _proto.parseFieldsDefinition = function parseFieldsDefinition() {
        // Legacy support for the SDL?
        if (this._options.allowLegacySDLEmptyFields && this.peek((0, $eUHO5.TokenKind).BRACE_L) && this._lexer.lookahead().kind === (0, $eUHO5.TokenKind).BRACE_R) {
            this._lexer.advance();
            this._lexer.advance();
            return [];
        }
        return this.optionalMany((0, $eUHO5.TokenKind).BRACE_L, this.parseFieldDefinition, (0, $eUHO5.TokenKind).BRACE_R);
    } /**
   * FieldDefinition :
   *   - Description? Name ArgumentsDefinition? : Type Directives[Const]?
   */ ;
    _proto.parseFieldDefinition = function parseFieldDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        var name = this.parseName();
        var args = this.parseArgumentDefs();
        this.expectToken((0, $eUHO5.TokenKind).COLON);
        var type = this.parseTypeReference();
        var directives = this.parseDirectives(true);
        return {
            kind: (0, $gXaMM.Kind).FIELD_DEFINITION,
            description: description,
            name: name,
            arguments: args,
            type: type,
            directives: directives,
            loc: this.loc(start)
        };
    } /**
   * ArgumentsDefinition : ( InputValueDefinition+ )
   */ ;
    _proto.parseArgumentDefs = function parseArgumentDefs() {
        return this.optionalMany((0, $eUHO5.TokenKind).PAREN_L, this.parseInputValueDef, (0, $eUHO5.TokenKind).PAREN_R);
    } /**
   * InputValueDefinition :
   *   - Description? Name : Type DefaultValue? Directives[Const]?
   */ ;
    _proto.parseInputValueDef = function parseInputValueDef() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        var name = this.parseName();
        this.expectToken((0, $eUHO5.TokenKind).COLON);
        var type = this.parseTypeReference();
        var defaultValue;
        if (this.expectOptionalToken((0, $eUHO5.TokenKind).EQUALS)) defaultValue = this.parseValueLiteral(true);
        var directives = this.parseDirectives(true);
        return {
            kind: (0, $gXaMM.Kind).INPUT_VALUE_DEFINITION,
            description: description,
            name: name,
            type: type,
            defaultValue: defaultValue,
            directives: directives,
            loc: this.loc(start)
        };
    } /**
   * InterfaceTypeDefinition :
   *   - Description? interface Name Directives[Const]? FieldsDefinition?
   */ ;
    _proto.parseInterfaceTypeDefinition = function parseInterfaceTypeDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword("interface");
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        var fields = this.parseFieldsDefinition();
        return {
            kind: (0, $gXaMM.Kind).INTERFACE_TYPE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            fields: fields,
            loc: this.loc(start)
        };
    } /**
   * UnionTypeDefinition :
   *   - Description? union Name Directives[Const]? UnionMemberTypes?
   */ ;
    _proto.parseUnionTypeDefinition = function parseUnionTypeDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword("union");
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        var types = this.parseUnionMemberTypes();
        return {
            kind: (0, $gXaMM.Kind).UNION_TYPE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            types: types,
            loc: this.loc(start)
        };
    } /**
   * UnionMemberTypes :
   *   - = `|`? NamedType
   *   - UnionMemberTypes | NamedType
   */ ;
    _proto.parseUnionMemberTypes = function parseUnionMemberTypes() {
        var types = [];
        if (this.expectOptionalToken((0, $eUHO5.TokenKind).EQUALS)) {
            // Optional leading pipe
            this.expectOptionalToken((0, $eUHO5.TokenKind).PIPE);
            do types.push(this.parseNamedType());
            while (this.expectOptionalToken((0, $eUHO5.TokenKind).PIPE));
        }
        return types;
    } /**
   * EnumTypeDefinition :
   *   - Description? enum Name Directives[Const]? EnumValuesDefinition?
   */ ;
    _proto.parseEnumTypeDefinition = function parseEnumTypeDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword("enum");
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        var values = this.parseEnumValuesDefinition();
        return {
            kind: (0, $gXaMM.Kind).ENUM_TYPE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            values: values,
            loc: this.loc(start)
        };
    } /**
   * EnumValuesDefinition : { EnumValueDefinition+ }
   */ ;
    _proto.parseEnumValuesDefinition = function parseEnumValuesDefinition() {
        return this.optionalMany((0, $eUHO5.TokenKind).BRACE_L, this.parseEnumValueDefinition, (0, $eUHO5.TokenKind).BRACE_R);
    } /**
   * EnumValueDefinition : Description? EnumValue Directives[Const]?
   *
   * EnumValue : Name
   */ ;
    _proto.parseEnumValueDefinition = function parseEnumValueDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        return {
            kind: (0, $gXaMM.Kind).ENUM_VALUE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            loc: this.loc(start)
        };
    } /**
   * InputObjectTypeDefinition :
   *   - Description? input Name Directives[Const]? InputFieldsDefinition?
   */ ;
    _proto.parseInputObjectTypeDefinition = function parseInputObjectTypeDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword("input");
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        var fields = this.parseInputFieldsDefinition();
        return {
            kind: (0, $gXaMM.Kind).INPUT_OBJECT_TYPE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            fields: fields,
            loc: this.loc(start)
        };
    } /**
   * InputFieldsDefinition : { InputValueDefinition+ }
   */ ;
    _proto.parseInputFieldsDefinition = function parseInputFieldsDefinition() {
        return this.optionalMany((0, $eUHO5.TokenKind).BRACE_L, this.parseInputValueDef, (0, $eUHO5.TokenKind).BRACE_R);
    } /**
   * TypeSystemExtension :
   *   - SchemaExtension
   *   - TypeExtension
   *
   * TypeExtension :
   *   - ScalarTypeExtension
   *   - ObjectTypeExtension
   *   - InterfaceTypeExtension
   *   - UnionTypeExtension
   *   - EnumTypeExtension
   *   - InputObjectTypeDefinition
   */ ;
    _proto.parseTypeSystemExtension = function parseTypeSystemExtension() {
        var keywordToken = this._lexer.lookahead();
        if (keywordToken.kind === (0, $eUHO5.TokenKind).NAME) switch(keywordToken.value){
            case "schema":
                return this.parseSchemaExtension();
            case "scalar":
                return this.parseScalarTypeExtension();
            case "type":
                return this.parseObjectTypeExtension();
            case "interface":
                return this.parseInterfaceTypeExtension();
            case "union":
                return this.parseUnionTypeExtension();
            case "enum":
                return this.parseEnumTypeExtension();
            case "input":
                return this.parseInputObjectTypeExtension();
        }
        throw this.unexpected(keywordToken);
    } /**
   * SchemaExtension :
   *  - extend schema Directives[Const]? { OperationTypeDefinition+ }
   *  - extend schema Directives[Const]
   */ ;
    _proto.parseSchemaExtension = function parseSchemaExtension() {
        var start = this._lexer.token;
        this.expectKeyword("extend");
        this.expectKeyword("schema");
        var directives = this.parseDirectives(true);
        var operationTypes = this.optionalMany((0, $eUHO5.TokenKind).BRACE_L, this.parseOperationTypeDefinition, (0, $eUHO5.TokenKind).BRACE_R);
        if (directives.length === 0 && operationTypes.length === 0) throw this.unexpected();
        return {
            kind: (0, $gXaMM.Kind).SCHEMA_EXTENSION,
            directives: directives,
            operationTypes: operationTypes,
            loc: this.loc(start)
        };
    } /**
   * ScalarTypeExtension :
   *   - extend scalar Name Directives[Const]
   */ ;
    _proto.parseScalarTypeExtension = function parseScalarTypeExtension() {
        var start = this._lexer.token;
        this.expectKeyword("extend");
        this.expectKeyword("scalar");
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        if (directives.length === 0) throw this.unexpected();
        return {
            kind: (0, $gXaMM.Kind).SCALAR_TYPE_EXTENSION,
            name: name,
            directives: directives,
            loc: this.loc(start)
        };
    } /**
   * ObjectTypeExtension :
   *  - extend type Name ImplementsInterfaces? Directives[Const]? FieldsDefinition
   *  - extend type Name ImplementsInterfaces? Directives[Const]
   *  - extend type Name ImplementsInterfaces
   */ ;
    _proto.parseObjectTypeExtension = function parseObjectTypeExtension() {
        var start = this._lexer.token;
        this.expectKeyword("extend");
        this.expectKeyword("type");
        var name = this.parseName();
        var interfaces = this.parseImplementsInterfaces();
        var directives = this.parseDirectives(true);
        var fields = this.parseFieldsDefinition();
        if (interfaces.length === 0 && directives.length === 0 && fields.length === 0) throw this.unexpected();
        return {
            kind: (0, $gXaMM.Kind).OBJECT_TYPE_EXTENSION,
            name: name,
            interfaces: interfaces,
            directives: directives,
            fields: fields,
            loc: this.loc(start)
        };
    } /**
   * InterfaceTypeExtension :
   *   - extend interface Name Directives[Const]? FieldsDefinition
   *   - extend interface Name Directives[Const]
   */ ;
    _proto.parseInterfaceTypeExtension = function parseInterfaceTypeExtension() {
        var start = this._lexer.token;
        this.expectKeyword("extend");
        this.expectKeyword("interface");
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        var fields = this.parseFieldsDefinition();
        if (directives.length === 0 && fields.length === 0) throw this.unexpected();
        return {
            kind: (0, $gXaMM.Kind).INTERFACE_TYPE_EXTENSION,
            name: name,
            directives: directives,
            fields: fields,
            loc: this.loc(start)
        };
    } /**
   * UnionTypeExtension :
   *   - extend union Name Directives[Const]? UnionMemberTypes
   *   - extend union Name Directives[Const]
   */ ;
    _proto.parseUnionTypeExtension = function parseUnionTypeExtension() {
        var start = this._lexer.token;
        this.expectKeyword("extend");
        this.expectKeyword("union");
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        var types = this.parseUnionMemberTypes();
        if (directives.length === 0 && types.length === 0) throw this.unexpected();
        return {
            kind: (0, $gXaMM.Kind).UNION_TYPE_EXTENSION,
            name: name,
            directives: directives,
            types: types,
            loc: this.loc(start)
        };
    } /**
   * EnumTypeExtension :
   *   - extend enum Name Directives[Const]? EnumValuesDefinition
   *   - extend enum Name Directives[Const]
   */ ;
    _proto.parseEnumTypeExtension = function parseEnumTypeExtension() {
        var start = this._lexer.token;
        this.expectKeyword("extend");
        this.expectKeyword("enum");
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        var values = this.parseEnumValuesDefinition();
        if (directives.length === 0 && values.length === 0) throw this.unexpected();
        return {
            kind: (0, $gXaMM.Kind).ENUM_TYPE_EXTENSION,
            name: name,
            directives: directives,
            values: values,
            loc: this.loc(start)
        };
    } /**
   * InputObjectTypeExtension :
   *   - extend input Name Directives[Const]? InputFieldsDefinition
   *   - extend input Name Directives[Const]
   */ ;
    _proto.parseInputObjectTypeExtension = function parseInputObjectTypeExtension() {
        var start = this._lexer.token;
        this.expectKeyword("extend");
        this.expectKeyword("input");
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        var fields = this.parseInputFieldsDefinition();
        if (directives.length === 0 && fields.length === 0) throw this.unexpected();
        return {
            kind: (0, $gXaMM.Kind).INPUT_OBJECT_TYPE_EXTENSION,
            name: name,
            directives: directives,
            fields: fields,
            loc: this.loc(start)
        };
    } /**
   * DirectiveDefinition :
   *   - Description? directive @ Name ArgumentsDefinition? `repeatable`? on DirectiveLocations
   */ ;
    _proto.parseDirectiveDefinition = function parseDirectiveDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword("directive");
        this.expectToken((0, $eUHO5.TokenKind).AT);
        var name = this.parseName();
        var args = this.parseArgumentDefs();
        var repeatable = this.expectOptionalKeyword("repeatable");
        this.expectKeyword("on");
        var locations = this.parseDirectiveLocations();
        return {
            kind: (0, $gXaMM.Kind).DIRECTIVE_DEFINITION,
            description: description,
            name: name,
            arguments: args,
            repeatable: repeatable,
            locations: locations,
            loc: this.loc(start)
        };
    } /**
   * DirectiveLocations :
   *   - `|`? DirectiveLocation
   *   - DirectiveLocations | DirectiveLocation
   */ ;
    _proto.parseDirectiveLocations = function parseDirectiveLocations() {
        // Optional leading pipe
        this.expectOptionalToken((0, $eUHO5.TokenKind).PIPE);
        var locations = [];
        do locations.push(this.parseDirectiveLocation());
        while (this.expectOptionalToken((0, $eUHO5.TokenKind).PIPE));
        return locations;
    } /*
   * DirectiveLocation :
   *   - ExecutableDirectiveLocation
   *   - TypeSystemDirectiveLocation
   *
   * ExecutableDirectiveLocation : one of
   *   `QUERY`
   *   `MUTATION`
   *   `SUBSCRIPTION`
   *   `FIELD`
   *   `FRAGMENT_DEFINITION`
   *   `FRAGMENT_SPREAD`
   *   `INLINE_FRAGMENT`
   *
   * TypeSystemDirectiveLocation : one of
   *   `SCHEMA`
   *   `SCALAR`
   *   `OBJECT`
   *   `FIELD_DEFINITION`
   *   `ARGUMENT_DEFINITION`
   *   `INTERFACE`
   *   `UNION`
   *   `ENUM`
   *   `ENUM_VALUE`
   *   `INPUT_OBJECT`
   *   `INPUT_FIELD_DEFINITION`
   */ ;
    _proto.parseDirectiveLocation = function parseDirectiveLocation() {
        var start = this._lexer.token;
        var name = this.parseName();
        if ((0, $4bOBX.DirectiveLocation)[name.value] !== undefined) return name;
        throw this.unexpected(start);
    } // Core parsing utility functions
     /**
   * Returns a location object, used to identify the place in
   * the source that created a given parsed object.
   */ ;
    _proto.loc = function loc(startToken) {
        if (!this._options.noLocation) return new $e70460d084dddc5c$var$Loc(startToken, this._lexer.lastToken, this._lexer.source);
    } /**
   * Determines if the next token is of a given kind
   */ ;
    _proto.peek = function peek(kind) {
        return this._lexer.token.kind === kind;
    } /**
   * If the next token is of the given kind, return that token after advancing
   * the lexer. Otherwise, do not change the parser state and throw an error.
   */ ;
    _proto.expectToken = function expectToken(kind) {
        var token = this._lexer.token;
        if (token.kind === kind) {
            this._lexer.advance();
            return token;
        }
        throw (0, $7lYaM.syntaxError)(this._lexer.source, token.start, "Expected ".concat(kind, ", found ").concat($e70460d084dddc5c$var$getTokenDesc(token)));
    } /**
   * If the next token is of the given kind, return that token after advancing
   * the lexer. Otherwise, do not change the parser state and return undefined.
   */ ;
    _proto.expectOptionalToken = function expectOptionalToken(kind) {
        var token = this._lexer.token;
        if (token.kind === kind) {
            this._lexer.advance();
            return token;
        }
        return undefined;
    } /**
   * If the next token is a given keyword, advance the lexer.
   * Otherwise, do not change the parser state and throw an error.
   */ ;
    _proto.expectKeyword = function expectKeyword(value) {
        var token = this._lexer.token;
        if (token.kind === (0, $eUHO5.TokenKind).NAME && token.value === value) this._lexer.advance();
        else throw (0, $7lYaM.syntaxError)(this._lexer.source, token.start, 'Expected "'.concat(value, '", found ').concat($e70460d084dddc5c$var$getTokenDesc(token)));
    } /**
   * If the next token is a given keyword, return "true" after advancing
   * the lexer. Otherwise, do not change the parser state and return "false".
   */ ;
    _proto.expectOptionalKeyword = function expectOptionalKeyword(value) {
        var token = this._lexer.token;
        if (token.kind === (0, $eUHO5.TokenKind).NAME && token.value === value) {
            this._lexer.advance();
            return true;
        }
        return false;
    } /**
   * Helper function for creating an error when an unexpected lexed token
   * is encountered.
   */ ;
    _proto.unexpected = function unexpected(atToken) {
        var token = atToken || this._lexer.token;
        return (0, $7lYaM.syntaxError)(this._lexer.source, token.start, "Unexpected ".concat($e70460d084dddc5c$var$getTokenDesc(token)));
    } /**
   * Returns a possibly empty list of parse nodes, determined by
   * the parseFn. This list begins with a lex token of openKind
   * and ends with a lex token of closeKind. Advances the parser
   * to the next lex token after the closing token.
   */ ;
    _proto.any = function any(openKind, parseFn, closeKind) {
        this.expectToken(openKind);
        var nodes = [];
        while(!this.expectOptionalToken(closeKind))nodes.push(parseFn.call(this));
        return nodes;
    } /**
   * Returns a list of parse nodes, determined by the parseFn.
   * It can be empty only if open token is missing otherwise it will always
   * return non-empty list that begins with a lex token of openKind and ends
   * with a lex token of closeKind. Advances the parser to the next lex token
   * after the closing token.
   */ ;
    _proto.optionalMany = function optionalMany(openKind, parseFn, closeKind) {
        if (this.expectOptionalToken(openKind)) {
            var nodes = [];
            do nodes.push(parseFn.call(this));
            while (!this.expectOptionalToken(closeKind));
            return nodes;
        }
        return [];
    } /**
   * Returns a non-empty list of parse nodes, determined by
   * the parseFn. This list begins with a lex token of openKind
   * and ends with a lex token of closeKind. Advances the parser
   * to the next lex token after the closing token.
   */ ;
    _proto.many = function many(openKind, parseFn, closeKind) {
        this.expectToken(openKind);
        var nodes = [];
        do nodes.push(parseFn.call(this));
        while (!this.expectOptionalToken(closeKind));
        return nodes;
    };
    return Parser;
}();
function $e70460d084dddc5c$var$Loc(startToken, endToken, source) {
    this.start = startToken.start;
    this.end = endToken.end;
    this.startToken = startToken;
    this.endToken = endToken;
    this.source = source;
} // Print a simplified form when appearing in JSON/util.inspect.
(0, $bm0nk.default)($e70460d084dddc5c$var$Loc, function() {
    return {
        start: this.start,
        end: this.end
    };
});
/**
 * A helper function to describe a token as a string for debugging
 */ function $e70460d084dddc5c$var$getTokenDesc(token) {
    var value = token.value;
    return value ? "".concat(token.kind, ' "').concat(value, '"') : token.kind;
}

});
parcelRegister("6hqcz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f5fa47e2ac22b953$export$2e2bcd8739ae039; });

var $8t7l2 = parcelRequire("8t7l2");
function $f5fa47e2ac22b953$var$_typeof(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $f5fa47e2ac22b953$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $f5fa47e2ac22b953$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $f5fa47e2ac22b953$var$_typeof(obj);
}
var $f5fa47e2ac22b953$var$MAX_ARRAY_LENGTH = 10;
var $f5fa47e2ac22b953$var$MAX_RECURSIVE_DEPTH = 2;
function $f5fa47e2ac22b953$export$2e2bcd8739ae039(value) {
    return $f5fa47e2ac22b953$var$formatValue(value, []);
}
function $f5fa47e2ac22b953$var$formatValue(value, seenValues) {
    switch($f5fa47e2ac22b953$var$_typeof(value)){
        case "string":
            return JSON.stringify(value);
        case "function":
            return value.name ? "[function ".concat(value.name, "]") : "[function]";
        case "object":
            if (value === null) return "null";
            return $f5fa47e2ac22b953$var$formatObjectValue(value, seenValues);
        default:
            return String(value);
    }
}
function $f5fa47e2ac22b953$var$formatObjectValue(value, previouslySeenValues) {
    if (previouslySeenValues.indexOf(value) !== -1) return "[Circular]";
    var seenValues = [].concat(previouslySeenValues, [
        value
    ]);
    var customInspectFn = $f5fa47e2ac22b953$var$getCustomFn(value);
    if (customInspectFn !== undefined) {
        // $FlowFixMe(>=0.90.0)
        var customValue = customInspectFn.call(value); // check for infinite recursion
        if (customValue !== value) return typeof customValue === "string" ? customValue : $f5fa47e2ac22b953$var$formatValue(customValue, seenValues);
    } else if (Array.isArray(value)) return $f5fa47e2ac22b953$var$formatArray(value, seenValues);
    return $f5fa47e2ac22b953$var$formatObject(value, seenValues);
}
function $f5fa47e2ac22b953$var$formatObject(object, seenValues) {
    var keys = Object.keys(object);
    if (keys.length === 0) return "{}";
    if (seenValues.length > $f5fa47e2ac22b953$var$MAX_RECURSIVE_DEPTH) return "[" + $f5fa47e2ac22b953$var$getObjectTag(object) + "]";
    var properties = keys.map(function(key) {
        var value = $f5fa47e2ac22b953$var$formatValue(object[key], seenValues);
        return key + ": " + value;
    });
    return "{ " + properties.join(", ") + " }";
}
function $f5fa47e2ac22b953$var$formatArray(array, seenValues) {
    if (array.length === 0) return "[]";
    if (seenValues.length > $f5fa47e2ac22b953$var$MAX_RECURSIVE_DEPTH) return "[Array]";
    var len = Math.min($f5fa47e2ac22b953$var$MAX_ARRAY_LENGTH, array.length);
    var remaining = array.length - len;
    var items = [];
    for(var i = 0; i < len; ++i)items.push($f5fa47e2ac22b953$var$formatValue(array[i], seenValues));
    if (remaining === 1) items.push("... 1 more item");
    else if (remaining > 1) items.push("... ".concat(remaining, " more items"));
    return "[" + items.join(", ") + "]";
}
function $f5fa47e2ac22b953$var$getCustomFn(object) {
    var customInspectFn = object[String((0, $8t7l2.default))];
    if (typeof customInspectFn === "function") return customInspectFn;
    if (typeof object.inspect === "function") return object.inspect;
}
function $f5fa47e2ac22b953$var$getObjectTag(object) {
    var tag = Object.prototype.toString.call(object).replace(/^\[object /, "").replace(/]$/, "");
    if (tag === "Object" && typeof object.constructor === "function") {
        var name = object.constructor.name;
        if (typeof name === "string" && name !== "") return name;
    }
    return tag;
}

});
parcelRegister("8t7l2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $eb0bec545f89471d$export$2e2bcd8739ae039; });
var $eb0bec545f89471d$var$nodejsCustomInspectSymbol = typeof Symbol === "function" && typeof Symbol.for === "function" ? Symbol.for("nodejs.util.inspect.custom") : undefined;
var $eb0bec545f89471d$export$2e2bcd8739ae039 = $eb0bec545f89471d$var$nodejsCustomInspectSymbol;

});


parcelRegister("efBUw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6678dd71c433c6ad$export$2e2bcd8739ae039; });
function $6678dd71c433c6ad$export$2e2bcd8739ae039(condition, message) {
    var booleanCondition = Boolean(condition);
    if (!booleanCondition) throw new Error(message);
}

});

parcelRegister("bm0nk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e1f10a9c4ac77762$export$2e2bcd8739ae039; });

var $8t7l2 = parcelRequire("8t7l2");
function $e1f10a9c4ac77762$export$2e2bcd8739ae039(classObject) {
    var fn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : classObject.prototype.toString;
    classObject.prototype.toJSON = fn;
    classObject.prototype.inspect = fn;
    if (0, $8t7l2.default) classObject.prototype[0, $8t7l2.default] = fn;
}

});

parcelRegister("7lYaM", function(module, exports) {

$parcel$export(module.exports, "syntaxError", function () { return $32bed64c5e7f7c44$export$bbee0c6176c019d4; });

var $a023q = parcelRequire("a023q");
function $32bed64c5e7f7c44$export$bbee0c6176c019d4(source, position, description) {
    return new (0, $a023q.GraphQLError)("Syntax Error: ".concat(description), undefined, source, [
        position
    ]);
}

});
parcelRegister("a023q", function(module, exports) {

$parcel$export(module.exports, "GraphQLError", function () { return $238574a015e30759$export$92d6ed0888e7cb7f; });

var $j0Yl9 = parcelRequire("j0Yl9");

var $lxHMu = parcelRequire("lxHMu");

var $dn0M7 = parcelRequire("dn0M7");
function $238574a015e30759$export$92d6ed0888e7cb7f(message, nodes, source, positions, path, originalError, extensions) {
    // Compute list of blame nodes.
    var _nodes = Array.isArray(nodes) ? nodes.length !== 0 ? nodes : undefined : nodes ? [
        nodes
    ] : undefined; // Compute locations in the source for the given nodes/positions.
    var _source = source;
    if (!_source && _nodes) {
        var node = _nodes[0];
        _source = node && node.loc && node.loc.source;
    }
    var _positions = positions;
    if (!_positions && _nodes) _positions = _nodes.reduce(function(list, node) {
        if (node.loc) list.push(node.loc.start);
        return list;
    }, []);
    if (_positions && _positions.length === 0) _positions = undefined;
    var _locations;
    if (positions && source) _locations = positions.map(function(pos) {
        return (0, $lxHMu.getLocation)(source, pos);
    });
    else if (_nodes) _locations = _nodes.reduce(function(list, node) {
        if (node.loc) list.push((0, $lxHMu.getLocation)(node.loc.source, node.loc.start));
        return list;
    }, []);
    var _extensions = extensions;
    if (_extensions == null && originalError != null) {
        var originalExtensions = originalError.extensions;
        if ((0, $j0Yl9.default)(originalExtensions)) _extensions = originalExtensions;
    }
    Object.defineProperties(this, {
        message: {
            value: message,
            // By being enumerable, JSON.stringify will include `message` in the
            // resulting output. This ensures that the simplest possible GraphQL
            // service adheres to the spec.
            enumerable: true,
            writable: true
        },
        locations: {
            // Coercing falsey values to undefined ensures they will not be included
            // in JSON.stringify() when not provided.
            value: _locations || undefined,
            // By being enumerable, JSON.stringify will include `locations` in the
            // resulting output. This ensures that the simplest possible GraphQL
            // service adheres to the spec.
            enumerable: Boolean(_locations)
        },
        path: {
            // Coercing falsey values to undefined ensures they will not be included
            // in JSON.stringify() when not provided.
            value: path || undefined,
            // By being enumerable, JSON.stringify will include `path` in the
            // resulting output. This ensures that the simplest possible GraphQL
            // service adheres to the spec.
            enumerable: Boolean(path)
        },
        nodes: {
            value: _nodes || undefined
        },
        source: {
            value: _source || undefined
        },
        positions: {
            value: _positions || undefined
        },
        originalError: {
            value: originalError
        },
        extensions: {
            // Coercing falsey values to undefined ensures they will not be included
            // in JSON.stringify() when not provided.
            value: _extensions || undefined,
            // By being enumerable, JSON.stringify will include `path` in the
            // resulting output. This ensures that the simplest possible GraphQL
            // service adheres to the spec.
            enumerable: Boolean(_extensions)
        }
    }); // Include (non-enumerable) stack trace.
    if (originalError && originalError.stack) Object.defineProperty(this, "stack", {
        value: originalError.stack,
        writable: true,
        configurable: true
    });
    else if (Error.captureStackTrace) Error.captureStackTrace(this, $238574a015e30759$export$92d6ed0888e7cb7f);
    else Object.defineProperty(this, "stack", {
        value: Error().stack,
        writable: true,
        configurable: true
    });
}
$238574a015e30759$export$92d6ed0888e7cb7f.prototype = Object.create(Error.prototype, {
    constructor: {
        value: $238574a015e30759$export$92d6ed0888e7cb7f
    },
    name: {
        value: "GraphQLError"
    },
    toString: {
        value: function toString() {
            return $238574a015e30759$export$55ee1551a3f962e6(this);
        }
    }
});
function $238574a015e30759$export$55ee1551a3f962e6(error) {
    var output = error.message;
    if (error.nodes) for(var _i2 = 0, _error$nodes2 = error.nodes; _i2 < _error$nodes2.length; _i2++){
        var node = _error$nodes2[_i2];
        if (node.loc) output += "\n\n" + (0, $dn0M7.printLocation)(node.loc);
    }
    else if (error.source && error.locations) for(var _i4 = 0, _error$locations2 = error.locations; _i4 < _error$locations2.length; _i4++){
        var location = _error$locations2[_i4];
        output += "\n\n" + (0, $dn0M7.printSourceLocation)(error.source, location);
    }
    return output;
}

});
parcelRegister("j0Yl9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0c07e8d71be64950$export$2e2bcd8739ae039; });
function $0c07e8d71be64950$var$_typeof(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $0c07e8d71be64950$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $0c07e8d71be64950$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $0c07e8d71be64950$var$_typeof(obj);
}
function $0c07e8d71be64950$export$2e2bcd8739ae039(value) {
    return $0c07e8d71be64950$var$_typeof(value) == "object" && value !== null;
}

});

parcelRegister("lxHMu", function(module, exports) {

$parcel$export(module.exports, "getLocation", function () { return $1a227f1ce36f6acb$export$e7fd20fad3cf4b5f; });
/**
 * Represents a location in a Source.
 */ /**
 * Takes a Source and a UTF-8 character offset, and returns the corresponding
 * line and column as a SourceLocation.
 */ function $1a227f1ce36f6acb$export$e7fd20fad3cf4b5f(source, position) {
    var lineRegexp = /\r\n|[\n\r]/g;
    var line = 1;
    var column = position + 1;
    var match;
    while((match = lineRegexp.exec(source.body)) && match.index < position){
        line += 1;
        column = position + 1 - (match.index + match[0].length);
    }
    return {
        line: line,
        column: column
    };
}

});

parcelRegister("dn0M7", function(module, exports) {

$parcel$export(module.exports, "printLocation", function () { return $9a61d3f926c6ebf4$export$96a9681e539deed; });
$parcel$export(module.exports, "printSourceLocation", function () { return $9a61d3f926c6ebf4$export$867940333fd9f869; });

var $lxHMu = parcelRequire("lxHMu");
function $9a61d3f926c6ebf4$export$96a9681e539deed(location) {
    return $9a61d3f926c6ebf4$export$867940333fd9f869(location.source, (0, $lxHMu.getLocation)(location.source, location.start));
}
function $9a61d3f926c6ebf4$export$867940333fd9f869(source, sourceLocation) {
    var firstLineColumnOffset = source.locationOffset.column - 1;
    var body = $9a61d3f926c6ebf4$var$whitespace(firstLineColumnOffset) + source.body;
    var lineIndex = sourceLocation.line - 1;
    var lineOffset = source.locationOffset.line - 1;
    var lineNum = sourceLocation.line + lineOffset;
    var columnOffset = sourceLocation.line === 1 ? firstLineColumnOffset : 0;
    var columnNum = sourceLocation.column + columnOffset;
    var locationStr = "".concat(source.name, ":").concat(lineNum, ":").concat(columnNum, "\n");
    var lines = body.split(/\r\n|[\n\r]/g);
    var locationLine = lines[lineIndex]; // Special case for minified documents
    if (locationLine.length > 120) {
        var sublineIndex = Math.floor(columnNum / 80);
        var sublineColumnNum = columnNum % 80;
        var sublines = [];
        for(var i = 0; i < locationLine.length; i += 80)sublines.push(locationLine.slice(i, i + 80));
        return locationStr + $9a61d3f926c6ebf4$var$printPrefixedLines([
            [
                "".concat(lineNum),
                sublines[0]
            ]
        ].concat(sublines.slice(1, sublineIndex + 1).map(function(subline) {
            return [
                "",
                subline
            ];
        }), [
            [
                " ",
                $9a61d3f926c6ebf4$var$whitespace(sublineColumnNum - 1) + "^"
            ],
            [
                "",
                sublines[sublineIndex + 1]
            ]
        ]));
    }
    return locationStr + $9a61d3f926c6ebf4$var$printPrefixedLines([
        [
            "".concat(lineNum - 1),
            lines[lineIndex - 1]
        ],
        [
            "".concat(lineNum),
            locationLine
        ],
        [
            "",
            $9a61d3f926c6ebf4$var$whitespace(columnNum - 1) + "^"
        ],
        [
            "".concat(lineNum + 1),
            lines[lineIndex + 1]
        ]
    ]);
}
function $9a61d3f926c6ebf4$var$printPrefixedLines(lines) {
    var existingLines = lines.filter(function(_ref) {
        var _ = _ref[0], line = _ref[1];
        return line !== undefined;
    });
    var padLen = Math.max.apply(Math, existingLines.map(function(_ref2) {
        var prefix = _ref2[0];
        return prefix.length;
    }));
    return existingLines.map(function(_ref3) {
        var prefix = _ref3[0], line = _ref3[1];
        return $9a61d3f926c6ebf4$var$lpad(padLen, prefix) + (line ? " | " + line : " |");
    }).join("\n");
}
function $9a61d3f926c6ebf4$var$whitespace(len) {
    return Array(len + 1).join(" ");
}
function $9a61d3f926c6ebf4$var$lpad(len, str) {
    return $9a61d3f926c6ebf4$var$whitespace(len - str.length) + str;
}

});



parcelRegister("gXaMM", function(module, exports) {

$parcel$export(module.exports, "Kind", function () { return $09d038bfa524ab4a$export$a84bdc57c5122798; });
/**
 * The set of allowed kind values for AST nodes.
 */ var $09d038bfa524ab4a$export$a84bdc57c5122798 = Object.freeze({
    // Name
    NAME: "Name",
    // Document
    DOCUMENT: "Document",
    OPERATION_DEFINITION: "OperationDefinition",
    VARIABLE_DEFINITION: "VariableDefinition",
    SELECTION_SET: "SelectionSet",
    FIELD: "Field",
    ARGUMENT: "Argument",
    // Fragments
    FRAGMENT_SPREAD: "FragmentSpread",
    INLINE_FRAGMENT: "InlineFragment",
    FRAGMENT_DEFINITION: "FragmentDefinition",
    // Values
    VARIABLE: "Variable",
    INT: "IntValue",
    FLOAT: "FloatValue",
    STRING: "StringValue",
    BOOLEAN: "BooleanValue",
    NULL: "NullValue",
    ENUM: "EnumValue",
    LIST: "ListValue",
    OBJECT: "ObjectValue",
    OBJECT_FIELD: "ObjectField",
    // Directives
    DIRECTIVE: "Directive",
    // Types
    NAMED_TYPE: "NamedType",
    LIST_TYPE: "ListType",
    NON_NULL_TYPE: "NonNullType",
    // Type System Definitions
    SCHEMA_DEFINITION: "SchemaDefinition",
    OPERATION_TYPE_DEFINITION: "OperationTypeDefinition",
    // Type Definitions
    SCALAR_TYPE_DEFINITION: "ScalarTypeDefinition",
    OBJECT_TYPE_DEFINITION: "ObjectTypeDefinition",
    FIELD_DEFINITION: "FieldDefinition",
    INPUT_VALUE_DEFINITION: "InputValueDefinition",
    INTERFACE_TYPE_DEFINITION: "InterfaceTypeDefinition",
    UNION_TYPE_DEFINITION: "UnionTypeDefinition",
    ENUM_TYPE_DEFINITION: "EnumTypeDefinition",
    ENUM_VALUE_DEFINITION: "EnumValueDefinition",
    INPUT_OBJECT_TYPE_DEFINITION: "InputObjectTypeDefinition",
    // Directive Definitions
    DIRECTIVE_DEFINITION: "DirectiveDefinition",
    // Type System Extensions
    SCHEMA_EXTENSION: "SchemaExtension",
    // Type Extensions
    SCALAR_TYPE_EXTENSION: "ScalarTypeExtension",
    OBJECT_TYPE_EXTENSION: "ObjectTypeExtension",
    INTERFACE_TYPE_EXTENSION: "InterfaceTypeExtension",
    UNION_TYPE_EXTENSION: "UnionTypeExtension",
    ENUM_TYPE_EXTENSION: "EnumTypeExtension",
    INPUT_OBJECT_TYPE_EXTENSION: "InputObjectTypeExtension"
}); /**
 * The enum type representing the possible kind values of AST nodes.
 */ 

});

parcelRegister("6PCvk", function(module, exports) {

$parcel$export(module.exports, "Source", function () { return $8605d3cf8b23ffdf$export$1d2df86270c81ecb; });

var $efBUw = parcelRequire("efBUw");

var $5Qs0O = parcelRequire("5Qs0O");
var $8605d3cf8b23ffdf$export$1d2df86270c81ecb = function Source(body, name, locationOffset) {
    this.body = body;
    this.name = name || "GraphQL request";
    this.locationOffset = locationOffset || {
        line: 1,
        column: 1
    };
    this.locationOffset.line > 0 || (0, $efBUw.default)(0, "line in locationOffset is 1-indexed and must be positive");
    this.locationOffset.column > 0 || (0, $efBUw.default)(0, "column in locationOffset is 1-indexed and must be positive");
}; // Conditionally apply `[Symbol.toStringTag]` if `Symbol`s are supported
(0, $5Qs0O.default)($8605d3cf8b23ffdf$export$1d2df86270c81ecb);

});
parcelRegister("5Qs0O", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c29dcb244740816f$export$2e2bcd8739ae039; });
/**
 * The `defineToStringTag()` function checks first to see if the runtime
 * supports the `Symbol` class and then if the `Symbol.toStringTag` constant
 * is defined as a `Symbol` instance. If both conditions are met, the
 * Symbol.toStringTag property is defined as a getter that returns the
 * supplied class constructor's name.
 *
 * @method defineToStringTag
 *
 * @param {Class<any>} classObject a class such as Object, String, Number but
 * typically one of your own creation through the class keyword; `class A {}`,
 * for example.
 */ function $c29dcb244740816f$export$2e2bcd8739ae039(classObject) {
    if (typeof Symbol === "function" && Symbol.toStringTag) Object.defineProperty(classObject.prototype, Symbol.toStringTag, {
        get: function get() {
            return this.constructor.name;
        }
    });
}

});


parcelRegister("dlqjC", function(module, exports) {

$parcel$export(module.exports, "createLexer", function () { return $2a7f402c56f5ca90$export$542413421c3f8a82; });

var $bm0nk = parcelRequire("bm0nk");

var $7lYaM = parcelRequire("7lYaM");

var $70nja = parcelRequire("70nja");

var $eUHO5 = parcelRequire("eUHO5");
function $2a7f402c56f5ca90$export$542413421c3f8a82(source, options) {
    var startOfFileToken = new $2a7f402c56f5ca90$var$Tok((0, $eUHO5.TokenKind).SOF, 0, 0, 0, 0, null);
    var lexer = {
        source: source,
        options: options,
        lastToken: startOfFileToken,
        token: startOfFileToken,
        line: 1,
        lineStart: 0,
        advance: $2a7f402c56f5ca90$var$advanceLexer,
        lookahead: $2a7f402c56f5ca90$var$lookahead
    };
    return lexer;
}
function $2a7f402c56f5ca90$var$advanceLexer() {
    this.lastToken = this.token;
    var token = this.token = this.lookahead();
    return token;
}
function $2a7f402c56f5ca90$var$lookahead() {
    var token = this.token;
    if (token.kind !== (0, $eUHO5.TokenKind).EOF) do // Note: next is only mutable during parsing, so we cast to allow this.
    token = token.next || (token.next = $2a7f402c56f5ca90$var$readToken(this, token));
    while (token.kind === (0, $eUHO5.TokenKind).COMMENT);
    return token;
}
function $2a7f402c56f5ca90$export$aebcc098ae68f143(token) {
    var kind = token.kind;
    return kind === (0, $eUHO5.TokenKind).BANG || kind === (0, $eUHO5.TokenKind).DOLLAR || kind === (0, $eUHO5.TokenKind).AMP || kind === (0, $eUHO5.TokenKind).PAREN_L || kind === (0, $eUHO5.TokenKind).PAREN_R || kind === (0, $eUHO5.TokenKind).SPREAD || kind === (0, $eUHO5.TokenKind).COLON || kind === (0, $eUHO5.TokenKind).EQUALS || kind === (0, $eUHO5.TokenKind).AT || kind === (0, $eUHO5.TokenKind).BRACKET_L || kind === (0, $eUHO5.TokenKind).BRACKET_R || kind === (0, $eUHO5.TokenKind).BRACE_L || kind === (0, $eUHO5.TokenKind).PIPE || kind === (0, $eUHO5.TokenKind).BRACE_R;
}
/**
 * Helper function for constructing the Token object.
 */ function $2a7f402c56f5ca90$var$Tok(kind, start, end, line, column, prev, value) {
    this.kind = kind;
    this.start = start;
    this.end = end;
    this.line = line;
    this.column = column;
    this.value = value;
    this.prev = prev;
    this.next = null;
} // Print a simplified form when appearing in JSON/util.inspect.
(0, $bm0nk.default)($2a7f402c56f5ca90$var$Tok, function() {
    return {
        kind: this.kind,
        value: this.value,
        line: this.line,
        column: this.column
    };
});
function $2a7f402c56f5ca90$var$printCharCode(code) {
    return isNaN(code) ? (0, $eUHO5.TokenKind).EOF : code < 0x007f ? JSON.stringify(String.fromCharCode(code)) : '"\\u'.concat(("00" + code.toString(16).toUpperCase()).slice(-4), '"');
}
/**
 * Gets the next token from the source starting at the given position.
 *
 * This skips over whitespace until it finds the next lexable token, then lexes
 * punctuators immediately or calls the appropriate helper function for more
 * complicated tokens.
 */ function $2a7f402c56f5ca90$var$readToken(lexer, prev) {
    var source = lexer.source;
    var body = source.body;
    var bodyLength = body.length;
    var pos = $2a7f402c56f5ca90$var$positionAfterWhitespace(body, prev.end, lexer);
    var line = lexer.line;
    var col = 1 + pos - lexer.lineStart;
    if (pos >= bodyLength) return new $2a7f402c56f5ca90$var$Tok((0, $eUHO5.TokenKind).EOF, bodyLength, bodyLength, line, col, prev);
    var code = body.charCodeAt(pos); // SourceCharacter
    switch(code){
        // !
        case 33:
            return new $2a7f402c56f5ca90$var$Tok((0, $eUHO5.TokenKind).BANG, pos, pos + 1, line, col, prev);
        // #
        case 35:
            return $2a7f402c56f5ca90$var$readComment(source, pos, line, col, prev);
        // $
        case 36:
            return new $2a7f402c56f5ca90$var$Tok((0, $eUHO5.TokenKind).DOLLAR, pos, pos + 1, line, col, prev);
        // &
        case 38:
            return new $2a7f402c56f5ca90$var$Tok((0, $eUHO5.TokenKind).AMP, pos, pos + 1, line, col, prev);
        // (
        case 40:
            return new $2a7f402c56f5ca90$var$Tok((0, $eUHO5.TokenKind).PAREN_L, pos, pos + 1, line, col, prev);
        // )
        case 41:
            return new $2a7f402c56f5ca90$var$Tok((0, $eUHO5.TokenKind).PAREN_R, pos, pos + 1, line, col, prev);
        // .
        case 46:
            if (body.charCodeAt(pos + 1) === 46 && body.charCodeAt(pos + 2) === 46) return new $2a7f402c56f5ca90$var$Tok((0, $eUHO5.TokenKind).SPREAD, pos, pos + 3, line, col, prev);
            break;
        // :
        case 58:
            return new $2a7f402c56f5ca90$var$Tok((0, $eUHO5.TokenKind).COLON, pos, pos + 1, line, col, prev);
        // =
        case 61:
            return new $2a7f402c56f5ca90$var$Tok((0, $eUHO5.TokenKind).EQUALS, pos, pos + 1, line, col, prev);
        // @
        case 64:
            return new $2a7f402c56f5ca90$var$Tok((0, $eUHO5.TokenKind).AT, pos, pos + 1, line, col, prev);
        // [
        case 91:
            return new $2a7f402c56f5ca90$var$Tok((0, $eUHO5.TokenKind).BRACKET_L, pos, pos + 1, line, col, prev);
        // ]
        case 93:
            return new $2a7f402c56f5ca90$var$Tok((0, $eUHO5.TokenKind).BRACKET_R, pos, pos + 1, line, col, prev);
        // {
        case 123:
            return new $2a7f402c56f5ca90$var$Tok((0, $eUHO5.TokenKind).BRACE_L, pos, pos + 1, line, col, prev);
        // |
        case 124:
            return new $2a7f402c56f5ca90$var$Tok((0, $eUHO5.TokenKind).PIPE, pos, pos + 1, line, col, prev);
        // }
        case 125:
            return new $2a7f402c56f5ca90$var$Tok((0, $eUHO5.TokenKind).BRACE_R, pos, pos + 1, line, col, prev);
        // A-Z _ a-z
        case 65:
        case 66:
        case 67:
        case 68:
        case 69:
        case 70:
        case 71:
        case 72:
        case 73:
        case 74:
        case 75:
        case 76:
        case 77:
        case 78:
        case 79:
        case 80:
        case 81:
        case 82:
        case 83:
        case 84:
        case 85:
        case 86:
        case 87:
        case 88:
        case 89:
        case 90:
        case 95:
        case 97:
        case 98:
        case 99:
        case 100:
        case 101:
        case 102:
        case 103:
        case 104:
        case 105:
        case 106:
        case 107:
        case 108:
        case 109:
        case 110:
        case 111:
        case 112:
        case 113:
        case 114:
        case 115:
        case 116:
        case 117:
        case 118:
        case 119:
        case 120:
        case 121:
        case 122:
            return $2a7f402c56f5ca90$var$readName(source, pos, line, col, prev);
        // - 0-9
        case 45:
        case 48:
        case 49:
        case 50:
        case 51:
        case 52:
        case 53:
        case 54:
        case 55:
        case 56:
        case 57:
            return $2a7f402c56f5ca90$var$readNumber(source, pos, code, line, col, prev);
        // "
        case 34:
            if (body.charCodeAt(pos + 1) === 34 && body.charCodeAt(pos + 2) === 34) return $2a7f402c56f5ca90$var$readBlockString(source, pos, line, col, prev, lexer);
            return $2a7f402c56f5ca90$var$readString(source, pos, line, col, prev);
    }
    throw (0, $7lYaM.syntaxError)(source, pos, $2a7f402c56f5ca90$var$unexpectedCharacterMessage(code));
}
/**
 * Report a message that an unexpected character was encountered.
 */ function $2a7f402c56f5ca90$var$unexpectedCharacterMessage(code) {
    if (code < 0x0020 && code !== 0x0009 && code !== 0x000a && code !== 0x000d) return "Cannot contain the invalid character ".concat($2a7f402c56f5ca90$var$printCharCode(code), ".");
    if (code === 39) // '
    return "Unexpected single quote character ('), did you mean to use a double quote (\")?";
    return "Cannot parse the unexpected character ".concat($2a7f402c56f5ca90$var$printCharCode(code), ".");
}
/**
 * Reads from body starting at startPosition until it finds a non-whitespace
 * character, then returns the position of that character for lexing.
 */ function $2a7f402c56f5ca90$var$positionAfterWhitespace(body, startPosition, lexer) {
    var bodyLength = body.length;
    var position = startPosition;
    while(position < bodyLength){
        var code = body.charCodeAt(position); // tab | space | comma | BOM
        if (code === 9 || code === 32 || code === 44 || code === 0xfeff) ++position;
        else if (code === 10) {
            // new line
            ++position;
            ++lexer.line;
            lexer.lineStart = position;
        } else if (code === 13) {
            // carriage return
            if (body.charCodeAt(position + 1) === 10) position += 2;
            else ++position;
            ++lexer.line;
            lexer.lineStart = position;
        } else break;
    }
    return position;
}
/**
 * Reads a comment token from the source file.
 *
 * #[\u0009\u0020-\uFFFF]*
 */ function $2a7f402c56f5ca90$var$readComment(source, start, line, col, prev) {
    var body = source.body;
    var code;
    var position = start;
    do code = body.charCodeAt(++position);
    while (!isNaN(code) && (code > 0x001f || code === 0x0009));
    return new $2a7f402c56f5ca90$var$Tok((0, $eUHO5.TokenKind).COMMENT, start, position, line, col, prev, body.slice(start + 1, position));
}
/**
 * Reads a number token from the source file, either a float
 * or an int depending on whether a decimal point appears.
 *
 * Int:   -?(0|[1-9][0-9]*)
 * Float: -?(0|[1-9][0-9]*)(\.[0-9]+)?((E|e)(+|-)?[0-9]+)?
 */ function $2a7f402c56f5ca90$var$readNumber(source, start, firstCode, line, col, prev) {
    var body = source.body;
    var code = firstCode;
    var position = start;
    var isFloat = false;
    if (code === 45) // -
    code = body.charCodeAt(++position);
    if (code === 48) {
        // 0
        code = body.charCodeAt(++position);
        if (code >= 48 && code <= 57) throw (0, $7lYaM.syntaxError)(source, position, "Invalid number, unexpected digit after 0: ".concat($2a7f402c56f5ca90$var$printCharCode(code), "."));
    } else {
        position = $2a7f402c56f5ca90$var$readDigits(source, position, code);
        code = body.charCodeAt(position);
    }
    if (code === 46) {
        // .
        isFloat = true;
        code = body.charCodeAt(++position);
        position = $2a7f402c56f5ca90$var$readDigits(source, position, code);
        code = body.charCodeAt(position);
    }
    if (code === 69 || code === 101) {
        // E e
        isFloat = true;
        code = body.charCodeAt(++position);
        if (code === 43 || code === 45) // + -
        code = body.charCodeAt(++position);
        position = $2a7f402c56f5ca90$var$readDigits(source, position, code);
        code = body.charCodeAt(position);
    } // Numbers cannot be followed by . or e
    if (code === 46 || code === 69 || code === 101) throw (0, $7lYaM.syntaxError)(source, position, "Invalid number, expected digit but got: ".concat($2a7f402c56f5ca90$var$printCharCode(code), "."));
    return new $2a7f402c56f5ca90$var$Tok(isFloat ? (0, $eUHO5.TokenKind).FLOAT : (0, $eUHO5.TokenKind).INT, start, position, line, col, prev, body.slice(start, position));
}
/**
 * Returns the new position in the source after reading digits.
 */ function $2a7f402c56f5ca90$var$readDigits(source, start, firstCode) {
    var body = source.body;
    var position = start;
    var code = firstCode;
    if (code >= 48 && code <= 57) {
        // 0 - 9
        do code = body.charCodeAt(++position);
        while (code >= 48 && code <= 57); // 0 - 9
        return position;
    }
    throw (0, $7lYaM.syntaxError)(source, position, "Invalid number, expected digit but got: ".concat($2a7f402c56f5ca90$var$printCharCode(code), "."));
}
/**
 * Reads a string token from the source file.
 *
 * "([^"\\\u000A\u000D]|(\\(u[0-9a-fA-F]{4}|["\\/bfnrt])))*"
 */ function $2a7f402c56f5ca90$var$readString(source, start, line, col, prev) {
    var body = source.body;
    var position = start + 1;
    var chunkStart = position;
    var code = 0;
    var value = "";
    while(position < body.length && !isNaN(code = body.charCodeAt(position)) && // not LineTerminator
    code !== 0x000a && code !== 0x000d){
        // Closing Quote (")
        if (code === 34) {
            value += body.slice(chunkStart, position);
            return new $2a7f402c56f5ca90$var$Tok((0, $eUHO5.TokenKind).STRING, start, position + 1, line, col, prev, value);
        } // SourceCharacter
        if (code < 0x0020 && code !== 0x0009) throw (0, $7lYaM.syntaxError)(source, position, "Invalid character within String: ".concat($2a7f402c56f5ca90$var$printCharCode(code), "."));
        ++position;
        if (code === 92) {
            // \
            value += body.slice(chunkStart, position - 1);
            code = body.charCodeAt(position);
            switch(code){
                case 34:
                    value += '"';
                    break;
                case 47:
                    value += "/";
                    break;
                case 92:
                    value += "\\";
                    break;
                case 98:
                    value += "\b";
                    break;
                case 102:
                    value += "\f";
                    break;
                case 110:
                    value += "\n";
                    break;
                case 114:
                    value += "\r";
                    break;
                case 116:
                    value += "	";
                    break;
                case 117:
                    // uXXXX
                    var charCode = $2a7f402c56f5ca90$var$uniCharCode(body.charCodeAt(position + 1), body.charCodeAt(position + 2), body.charCodeAt(position + 3), body.charCodeAt(position + 4));
                    if (charCode < 0) {
                        var invalidSequence = body.slice(position + 1, position + 5);
                        throw (0, $7lYaM.syntaxError)(source, position, "Invalid character escape sequence: \\u".concat(invalidSequence, "."));
                    }
                    value += String.fromCharCode(charCode);
                    position += 4;
                    break;
                default:
                    throw (0, $7lYaM.syntaxError)(source, position, "Invalid character escape sequence: \\".concat(String.fromCharCode(code), "."));
            }
            ++position;
            chunkStart = position;
        }
    }
    throw (0, $7lYaM.syntaxError)(source, position, "Unterminated string.");
}
/**
 * Reads a block string token from the source file.
 *
 * """("?"?(\\"""|\\(?!=""")|[^"\\]))*"""
 */ function $2a7f402c56f5ca90$var$readBlockString(source, start, line, col, prev, lexer) {
    var body = source.body;
    var position = start + 3;
    var chunkStart = position;
    var code = 0;
    var rawValue = "";
    while(position < body.length && !isNaN(code = body.charCodeAt(position))){
        // Closing Triple-Quote (""")
        if (code === 34 && body.charCodeAt(position + 1) === 34 && body.charCodeAt(position + 2) === 34) {
            rawValue += body.slice(chunkStart, position);
            return new $2a7f402c56f5ca90$var$Tok((0, $eUHO5.TokenKind).BLOCK_STRING, start, position + 3, line, col, prev, (0, $70nja.dedentBlockStringValue)(rawValue));
        } // SourceCharacter
        if (code < 0x0020 && code !== 0x0009 && code !== 0x000a && code !== 0x000d) throw (0, $7lYaM.syntaxError)(source, position, "Invalid character within String: ".concat($2a7f402c56f5ca90$var$printCharCode(code), "."));
        if (code === 10) {
            // new line
            ++position;
            ++lexer.line;
            lexer.lineStart = position;
        } else if (code === 13) {
            // carriage return
            if (body.charCodeAt(position + 1) === 10) position += 2;
            else ++position;
            ++lexer.line;
            lexer.lineStart = position;
        } else if (code === 92 && body.charCodeAt(position + 1) === 34 && body.charCodeAt(position + 2) === 34 && body.charCodeAt(position + 3) === 34) {
            rawValue += body.slice(chunkStart, position) + '"""';
            position += 4;
            chunkStart = position;
        } else ++position;
    }
    throw (0, $7lYaM.syntaxError)(source, position, "Unterminated string.");
}
/**
 * Converts four hexadecimal chars to the integer that the
 * string represents. For example, uniCharCode('0','0','0','f')
 * will return 15, and uniCharCode('0','0','f','f') returns 255.
 *
 * Returns a negative number on error, if a char was invalid.
 *
 * This is implemented by noting that char2hex() returns -1 on error,
 * which means the result of ORing the char2hex() will also be negative.
 */ function $2a7f402c56f5ca90$var$uniCharCode(a, b, c, d) {
    return $2a7f402c56f5ca90$var$char2hex(a) << 12 | $2a7f402c56f5ca90$var$char2hex(b) << 8 | $2a7f402c56f5ca90$var$char2hex(c) << 4 | $2a7f402c56f5ca90$var$char2hex(d);
}
/**
 * Converts a hex character to its integer value.
 * '0' becomes 0, '9' becomes 9
 * 'A' becomes 10, 'F' becomes 15
 * 'a' becomes 10, 'f' becomes 15
 *
 * Returns -1 on error.
 */ function $2a7f402c56f5ca90$var$char2hex(a) {
    return a >= 48 && a <= 57 ? a - 48 // 0-9
     : a >= 65 && a <= 70 ? a - 55 // A-F
     : a >= 97 && a <= 102 ? a - 87 // a-f
     : -1;
}
/**
 * Reads an alphanumeric + underscore name from the source.
 *
 * [_A-Za-z][_0-9A-Za-z]*
 */ function $2a7f402c56f5ca90$var$readName(source, start, line, col, prev) {
    var body = source.body;
    var bodyLength = body.length;
    var position = start + 1;
    var code = 0;
    while(position !== bodyLength && !isNaN(code = body.charCodeAt(position)) && (code === 95 || // _
    code >= 48 && code <= 57 || // 0-9
    code >= 65 && code <= 90 || // A-Z
    code >= 97 && code <= 122 // a-z
    ))++position;
    return new $2a7f402c56f5ca90$var$Tok((0, $eUHO5.TokenKind).NAME, start, position, line, col, prev, body.slice(start, position));
}

});
parcelRegister("70nja", function(module, exports) {

$parcel$export(module.exports, "dedentBlockStringValue", function () { return $e11fa41a1d31c265$export$fd88c0b652c46ccc; });
$parcel$export(module.exports, "printBlockString", function () { return $e11fa41a1d31c265$export$adb6ca997eeb1f45; });
/**
 * Produces the value of a block string from its parsed raw value, similar to
 * CoffeeScript's block string, Python's docstring trim or Ruby's strip_heredoc.
 *
 * This implements the GraphQL spec's BlockStringValue() static algorithm.
 */ function $e11fa41a1d31c265$export$fd88c0b652c46ccc(rawString) {
    // Expand a block string's raw value into independent lines.
    var lines = rawString.split(/\r\n|[\n\r]/g); // Remove common indentation from all lines but first.
    var commonIndent = $e11fa41a1d31c265$export$3c95bfdc680af0c(lines);
    if (commonIndent !== 0) for(var i = 1; i < lines.length; i++)lines[i] = lines[i].slice(commonIndent);
     // Remove leading and trailing blank lines.
    while(lines.length > 0 && $e11fa41a1d31c265$var$isBlank(lines[0]))lines.shift();
    while(lines.length > 0 && $e11fa41a1d31c265$var$isBlank(lines[lines.length - 1]))lines.pop();
     // Return a string of the lines joined with U+000A.
    return lines.join("\n");
} // @internal
function $e11fa41a1d31c265$export$3c95bfdc680af0c(lines) {
    var commonIndent = null;
    for(var i = 1; i < lines.length; i++){
        var line = lines[i];
        var indent = $e11fa41a1d31c265$var$leadingWhitespace(line);
        if (indent === line.length) continue; // skip empty lines
        if (commonIndent === null || indent < commonIndent) {
            commonIndent = indent;
            if (commonIndent === 0) break;
        }
    }
    return commonIndent === null ? 0 : commonIndent;
}
function $e11fa41a1d31c265$var$leadingWhitespace(str) {
    var i = 0;
    while(i < str.length && (str[i] === " " || str[i] === "	"))i++;
    return i;
}
function $e11fa41a1d31c265$var$isBlank(str) {
    return $e11fa41a1d31c265$var$leadingWhitespace(str) === str.length;
}
function $e11fa41a1d31c265$export$adb6ca997eeb1f45(value) {
    var indentation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
    var preferMultipleLines = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var isSingleLine = value.indexOf("\n") === -1;
    var hasLeadingSpace = value[0] === " " || value[0] === "	";
    var hasTrailingQuote = value[value.length - 1] === '"';
    var printAsMultipleLines = !isSingleLine || hasTrailingQuote || preferMultipleLines;
    var result = ""; // Format a multi-line block quote to account for leading space.
    if (printAsMultipleLines && !(isSingleLine && hasLeadingSpace)) result += "\n" + indentation;
    result += indentation ? value.replace(/\n/g, "\n" + indentation) : value;
    if (printAsMultipleLines) result += "\n";
    return '"""' + result.replace(/"""/g, '\\"""') + '"""';
}

});

parcelRegister("eUHO5", function(module, exports) {

$parcel$export(module.exports, "TokenKind", function () { return $16760077a198c821$export$8b9d26ab11394711; });
/**
 * An exported enum describing the different kinds of tokens that the
 * lexer emits.
 */ var $16760077a198c821$export$8b9d26ab11394711 = Object.freeze({
    SOF: "<SOF>",
    EOF: "<EOF>",
    BANG: "!",
    DOLLAR: "$",
    AMP: "&",
    PAREN_L: "(",
    PAREN_R: ")",
    SPREAD: "...",
    COLON: ":",
    EQUALS: "=",
    AT: "@",
    BRACKET_L: "[",
    BRACKET_R: "]",
    BRACE_L: "{",
    PIPE: "|",
    BRACE_R: "}",
    NAME: "Name",
    INT: "Int",
    FLOAT: "Float",
    STRING: "String",
    BLOCK_STRING: "BlockString",
    COMMENT: "Comment"
}); /**
 * The enum type representing the token kinds values.
 */ 

});


parcelRegister("4bOBX", function(module, exports) {

$parcel$export(module.exports, "DirectiveLocation", function () { return $ad3b72124b96bb92$export$b45ffd2948484c41; });
/**
 * The set of allowed directive location values.
 */ var $ad3b72124b96bb92$export$b45ffd2948484c41 = Object.freeze({
    // Request Definitions
    QUERY: "QUERY",
    MUTATION: "MUTATION",
    SUBSCRIPTION: "SUBSCRIPTION",
    FIELD: "FIELD",
    FRAGMENT_DEFINITION: "FRAGMENT_DEFINITION",
    FRAGMENT_SPREAD: "FRAGMENT_SPREAD",
    INLINE_FRAGMENT: "INLINE_FRAGMENT",
    VARIABLE_DEFINITION: "VARIABLE_DEFINITION",
    // Type System Definitions
    SCHEMA: "SCHEMA",
    SCALAR: "SCALAR",
    OBJECT: "OBJECT",
    FIELD_DEFINITION: "FIELD_DEFINITION",
    ARGUMENT_DEFINITION: "ARGUMENT_DEFINITION",
    INTERFACE: "INTERFACE",
    UNION: "UNION",
    ENUM: "ENUM",
    ENUM_VALUE: "ENUM_VALUE",
    INPUT_OBJECT: "INPUT_OBJECT",
    INPUT_FIELD_DEFINITION: "INPUT_FIELD_DEFINITION"
}); /**
 * The enum type representing the directive location values.
 */ 

});


parcelRegister("iHmIK", function(module, exports) {

$parcel$export(module.exports, "print", function () { return $a5a97bac4dc7f904$export$c2d084dc44961371; });

var $2KF5B = parcelRequire("2KF5B");

var $70nja = parcelRequire("70nja");
function $a5a97bac4dc7f904$export$c2d084dc44961371(ast) {
    return (0, $2KF5B.visit)(ast, {
        leave: $a5a97bac4dc7f904$var$printDocASTReducer
    });
} // TODO: provide better type coverage in future
var $a5a97bac4dc7f904$var$printDocASTReducer = {
    Name: function Name(node) {
        return node.value;
    },
    Variable: function Variable(node) {
        return "$" + node.name;
    },
    // Document
    Document: function Document(node) {
        return $a5a97bac4dc7f904$var$join(node.definitions, "\n\n") + "\n";
    },
    OperationDefinition: function OperationDefinition(node) {
        var op = node.operation;
        var name = node.name;
        var varDefs = $a5a97bac4dc7f904$var$wrap("(", $a5a97bac4dc7f904$var$join(node.variableDefinitions, ", "), ")");
        var directives = $a5a97bac4dc7f904$var$join(node.directives, " ");
        var selectionSet = node.selectionSet; // Anonymous queries with no directives or variable definitions can use
        // the query short form.
        return !name && !directives && !varDefs && op === "query" ? selectionSet : $a5a97bac4dc7f904$var$join([
            op,
            $a5a97bac4dc7f904$var$join([
                name,
                varDefs
            ]),
            directives,
            selectionSet
        ], " ");
    },
    VariableDefinition: function VariableDefinition(_ref) {
        var variable = _ref.variable, type = _ref.type, defaultValue = _ref.defaultValue, directives = _ref.directives;
        return variable + ": " + type + $a5a97bac4dc7f904$var$wrap(" = ", defaultValue) + $a5a97bac4dc7f904$var$wrap(" ", $a5a97bac4dc7f904$var$join(directives, " "));
    },
    SelectionSet: function SelectionSet(_ref2) {
        var selections = _ref2.selections;
        return $a5a97bac4dc7f904$var$block(selections);
    },
    Field: function Field(_ref3) {
        var alias = _ref3.alias, name = _ref3.name, args = _ref3.arguments, directives = _ref3.directives, selectionSet = _ref3.selectionSet;
        return $a5a97bac4dc7f904$var$join([
            $a5a97bac4dc7f904$var$wrap("", alias, ": ") + name + $a5a97bac4dc7f904$var$wrap("(", $a5a97bac4dc7f904$var$join(args, ", "), ")"),
            $a5a97bac4dc7f904$var$join(directives, " "),
            selectionSet
        ], " ");
    },
    Argument: function Argument(_ref4) {
        var name = _ref4.name, value = _ref4.value;
        return name + ": " + value;
    },
    // Fragments
    FragmentSpread: function FragmentSpread(_ref5) {
        var name = _ref5.name, directives = _ref5.directives;
        return "..." + name + $a5a97bac4dc7f904$var$wrap(" ", $a5a97bac4dc7f904$var$join(directives, " "));
    },
    InlineFragment: function InlineFragment(_ref6) {
        var typeCondition = _ref6.typeCondition, directives = _ref6.directives, selectionSet = _ref6.selectionSet;
        return $a5a97bac4dc7f904$var$join([
            "...",
            $a5a97bac4dc7f904$var$wrap("on ", typeCondition),
            $a5a97bac4dc7f904$var$join(directives, " "),
            selectionSet
        ], " ");
    },
    FragmentDefinition: function FragmentDefinition(_ref7) {
        var name = _ref7.name, typeCondition = _ref7.typeCondition, variableDefinitions = _ref7.variableDefinitions, directives = _ref7.directives, selectionSet = _ref7.selectionSet;
        return(// or removed in the future.
        "fragment ".concat(name).concat($a5a97bac4dc7f904$var$wrap("(", $a5a97bac4dc7f904$var$join(variableDefinitions, ", "), ")"), " ") + "on ".concat(typeCondition, " ").concat($a5a97bac4dc7f904$var$wrap("", $a5a97bac4dc7f904$var$join(directives, " "), " ")) + selectionSet);
    },
    // Value
    IntValue: function IntValue(_ref8) {
        var value = _ref8.value;
        return value;
    },
    FloatValue: function FloatValue(_ref9) {
        var value = _ref9.value;
        return value;
    },
    StringValue: function StringValue(_ref10, key) {
        var value = _ref10.value, isBlockString = _ref10.block;
        return isBlockString ? (0, $70nja.printBlockString)(value, key === "description" ? "" : "  ") : JSON.stringify(value);
    },
    BooleanValue: function BooleanValue(_ref11) {
        var value = _ref11.value;
        return value ? "true" : "false";
    },
    NullValue: function NullValue() {
        return "null";
    },
    EnumValue: function EnumValue(_ref12) {
        var value = _ref12.value;
        return value;
    },
    ListValue: function ListValue(_ref13) {
        var values = _ref13.values;
        return "[" + $a5a97bac4dc7f904$var$join(values, ", ") + "]";
    },
    ObjectValue: function ObjectValue(_ref14) {
        var fields = _ref14.fields;
        return "{" + $a5a97bac4dc7f904$var$join(fields, ", ") + "}";
    },
    ObjectField: function ObjectField(_ref15) {
        var name = _ref15.name, value = _ref15.value;
        return name + ": " + value;
    },
    // Directive
    Directive: function Directive(_ref16) {
        var name = _ref16.name, args = _ref16.arguments;
        return "@" + name + $a5a97bac4dc7f904$var$wrap("(", $a5a97bac4dc7f904$var$join(args, ", "), ")");
    },
    // Type
    NamedType: function NamedType(_ref17) {
        var name = _ref17.name;
        return name;
    },
    ListType: function ListType(_ref18) {
        var type = _ref18.type;
        return "[" + type + "]";
    },
    NonNullType: function NonNullType(_ref19) {
        var type = _ref19.type;
        return type + "!";
    },
    // Type System Definitions
    SchemaDefinition: function SchemaDefinition(_ref20) {
        var directives = _ref20.directives, operationTypes = _ref20.operationTypes;
        return $a5a97bac4dc7f904$var$join([
            "schema",
            $a5a97bac4dc7f904$var$join(directives, " "),
            $a5a97bac4dc7f904$var$block(operationTypes)
        ], " ");
    },
    OperationTypeDefinition: function OperationTypeDefinition(_ref21) {
        var operation = _ref21.operation, type = _ref21.type;
        return operation + ": " + type;
    },
    ScalarTypeDefinition: $a5a97bac4dc7f904$var$addDescription(function(_ref22) {
        var name = _ref22.name, directives = _ref22.directives;
        return $a5a97bac4dc7f904$var$join([
            "scalar",
            name,
            $a5a97bac4dc7f904$var$join(directives, " ")
        ], " ");
    }),
    ObjectTypeDefinition: $a5a97bac4dc7f904$var$addDescription(function(_ref23) {
        var name = _ref23.name, interfaces = _ref23.interfaces, directives = _ref23.directives, fields = _ref23.fields;
        return $a5a97bac4dc7f904$var$join([
            "type",
            name,
            $a5a97bac4dc7f904$var$wrap("implements ", $a5a97bac4dc7f904$var$join(interfaces, " & ")),
            $a5a97bac4dc7f904$var$join(directives, " "),
            $a5a97bac4dc7f904$var$block(fields)
        ], " ");
    }),
    FieldDefinition: $a5a97bac4dc7f904$var$addDescription(function(_ref24) {
        var name = _ref24.name, args = _ref24.arguments, type = _ref24.type, directives = _ref24.directives;
        return name + ($a5a97bac4dc7f904$var$hasMultilineItems(args) ? $a5a97bac4dc7f904$var$wrap("(\n", $a5a97bac4dc7f904$var$indent($a5a97bac4dc7f904$var$join(args, "\n")), "\n)") : $a5a97bac4dc7f904$var$wrap("(", $a5a97bac4dc7f904$var$join(args, ", "), ")")) + ": " + type + $a5a97bac4dc7f904$var$wrap(" ", $a5a97bac4dc7f904$var$join(directives, " "));
    }),
    InputValueDefinition: $a5a97bac4dc7f904$var$addDescription(function(_ref25) {
        var name = _ref25.name, type = _ref25.type, defaultValue = _ref25.defaultValue, directives = _ref25.directives;
        return $a5a97bac4dc7f904$var$join([
            name + ": " + type,
            $a5a97bac4dc7f904$var$wrap("= ", defaultValue),
            $a5a97bac4dc7f904$var$join(directives, " ")
        ], " ");
    }),
    InterfaceTypeDefinition: $a5a97bac4dc7f904$var$addDescription(function(_ref26) {
        var name = _ref26.name, directives = _ref26.directives, fields = _ref26.fields;
        return $a5a97bac4dc7f904$var$join([
            "interface",
            name,
            $a5a97bac4dc7f904$var$join(directives, " "),
            $a5a97bac4dc7f904$var$block(fields)
        ], " ");
    }),
    UnionTypeDefinition: $a5a97bac4dc7f904$var$addDescription(function(_ref27) {
        var name = _ref27.name, directives = _ref27.directives, types = _ref27.types;
        return $a5a97bac4dc7f904$var$join([
            "union",
            name,
            $a5a97bac4dc7f904$var$join(directives, " "),
            types && types.length !== 0 ? "= " + $a5a97bac4dc7f904$var$join(types, " | ") : ""
        ], " ");
    }),
    EnumTypeDefinition: $a5a97bac4dc7f904$var$addDescription(function(_ref28) {
        var name = _ref28.name, directives = _ref28.directives, values = _ref28.values;
        return $a5a97bac4dc7f904$var$join([
            "enum",
            name,
            $a5a97bac4dc7f904$var$join(directives, " "),
            $a5a97bac4dc7f904$var$block(values)
        ], " ");
    }),
    EnumValueDefinition: $a5a97bac4dc7f904$var$addDescription(function(_ref29) {
        var name = _ref29.name, directives = _ref29.directives;
        return $a5a97bac4dc7f904$var$join([
            name,
            $a5a97bac4dc7f904$var$join(directives, " ")
        ], " ");
    }),
    InputObjectTypeDefinition: $a5a97bac4dc7f904$var$addDescription(function(_ref30) {
        var name = _ref30.name, directives = _ref30.directives, fields = _ref30.fields;
        return $a5a97bac4dc7f904$var$join([
            "input",
            name,
            $a5a97bac4dc7f904$var$join(directives, " "),
            $a5a97bac4dc7f904$var$block(fields)
        ], " ");
    }),
    DirectiveDefinition: $a5a97bac4dc7f904$var$addDescription(function(_ref31) {
        var name = _ref31.name, args = _ref31.arguments, repeatable = _ref31.repeatable, locations = _ref31.locations;
        return "directive @" + name + ($a5a97bac4dc7f904$var$hasMultilineItems(args) ? $a5a97bac4dc7f904$var$wrap("(\n", $a5a97bac4dc7f904$var$indent($a5a97bac4dc7f904$var$join(args, "\n")), "\n)") : $a5a97bac4dc7f904$var$wrap("(", $a5a97bac4dc7f904$var$join(args, ", "), ")")) + (repeatable ? " repeatable" : "") + " on " + $a5a97bac4dc7f904$var$join(locations, " | ");
    }),
    SchemaExtension: function SchemaExtension(_ref32) {
        var directives = _ref32.directives, operationTypes = _ref32.operationTypes;
        return $a5a97bac4dc7f904$var$join([
            "extend schema",
            $a5a97bac4dc7f904$var$join(directives, " "),
            $a5a97bac4dc7f904$var$block(operationTypes)
        ], " ");
    },
    ScalarTypeExtension: function ScalarTypeExtension(_ref33) {
        var name = _ref33.name, directives = _ref33.directives;
        return $a5a97bac4dc7f904$var$join([
            "extend scalar",
            name,
            $a5a97bac4dc7f904$var$join(directives, " ")
        ], " ");
    },
    ObjectTypeExtension: function ObjectTypeExtension(_ref34) {
        var name = _ref34.name, interfaces = _ref34.interfaces, directives = _ref34.directives, fields = _ref34.fields;
        return $a5a97bac4dc7f904$var$join([
            "extend type",
            name,
            $a5a97bac4dc7f904$var$wrap("implements ", $a5a97bac4dc7f904$var$join(interfaces, " & ")),
            $a5a97bac4dc7f904$var$join(directives, " "),
            $a5a97bac4dc7f904$var$block(fields)
        ], " ");
    },
    InterfaceTypeExtension: function InterfaceTypeExtension(_ref35) {
        var name = _ref35.name, directives = _ref35.directives, fields = _ref35.fields;
        return $a5a97bac4dc7f904$var$join([
            "extend interface",
            name,
            $a5a97bac4dc7f904$var$join(directives, " "),
            $a5a97bac4dc7f904$var$block(fields)
        ], " ");
    },
    UnionTypeExtension: function UnionTypeExtension(_ref36) {
        var name = _ref36.name, directives = _ref36.directives, types = _ref36.types;
        return $a5a97bac4dc7f904$var$join([
            "extend union",
            name,
            $a5a97bac4dc7f904$var$join(directives, " "),
            types && types.length !== 0 ? "= " + $a5a97bac4dc7f904$var$join(types, " | ") : ""
        ], " ");
    },
    EnumTypeExtension: function EnumTypeExtension(_ref37) {
        var name = _ref37.name, directives = _ref37.directives, values = _ref37.values;
        return $a5a97bac4dc7f904$var$join([
            "extend enum",
            name,
            $a5a97bac4dc7f904$var$join(directives, " "),
            $a5a97bac4dc7f904$var$block(values)
        ], " ");
    },
    InputObjectTypeExtension: function InputObjectTypeExtension(_ref38) {
        var name = _ref38.name, directives = _ref38.directives, fields = _ref38.fields;
        return $a5a97bac4dc7f904$var$join([
            "extend input",
            name,
            $a5a97bac4dc7f904$var$join(directives, " "),
            $a5a97bac4dc7f904$var$block(fields)
        ], " ");
    }
};
function $a5a97bac4dc7f904$var$addDescription(cb) {
    return function(node) {
        return $a5a97bac4dc7f904$var$join([
            node.description,
            cb(node)
        ], "\n");
    };
}
/**
 * Given maybeArray, print an empty string if it is null or empty, otherwise
 * print all items together separated by separator if provided
 */ function $a5a97bac4dc7f904$var$join(maybeArray, separator) {
    return maybeArray ? maybeArray.filter(function(x) {
        return x;
    }).join(separator || "") : "";
}
/**
 * Given array, print each item on its own line, wrapped in an
 * indented "{ }" block.
 */ function $a5a97bac4dc7f904$var$block(array) {
    return array && array.length !== 0 ? "{\n" + $a5a97bac4dc7f904$var$indent($a5a97bac4dc7f904$var$join(array, "\n")) + "\n}" : "";
}
/**
 * If maybeString is not null or empty, then wrap with start and end, otherwise
 * print an empty string.
 */ function $a5a97bac4dc7f904$var$wrap(start, maybeString, end) {
    return maybeString ? start + maybeString + (end || "") : "";
}
function $a5a97bac4dc7f904$var$indent(maybeString) {
    return maybeString && "  " + maybeString.replace(/\n/g, "\n  ");
}
function $a5a97bac4dc7f904$var$isMultiline(string) {
    return string.indexOf("\n") !== -1;
}
function $a5a97bac4dc7f904$var$hasMultilineItems(maybeArray) {
    return maybeArray && maybeArray.some($a5a97bac4dc7f904$var$isMultiline);
}

});
parcelRegister("2KF5B", function(module, exports) {

$parcel$export(module.exports, "visit", function () { return $81e64b4ccc10b65b$export$bf638b60ea8b89b7; });

var $6hqcz = parcelRequire("6hqcz");
var $81e64b4ccc10b65b$export$4fcd777a40ccf407 = {
    Name: [],
    Document: [
        "definitions"
    ],
    OperationDefinition: [
        "name",
        "variableDefinitions",
        "directives",
        "selectionSet"
    ],
    VariableDefinition: [
        "variable",
        "type",
        "defaultValue",
        "directives"
    ],
    Variable: [
        "name"
    ],
    SelectionSet: [
        "selections"
    ],
    Field: [
        "alias",
        "name",
        "arguments",
        "directives",
        "selectionSet"
    ],
    Argument: [
        "name",
        "value"
    ],
    FragmentSpread: [
        "name",
        "directives"
    ],
    InlineFragment: [
        "typeCondition",
        "directives",
        "selectionSet"
    ],
    FragmentDefinition: [
        "name",
        // or removed in the future.
        "variableDefinitions",
        "typeCondition",
        "directives",
        "selectionSet"
    ],
    IntValue: [],
    FloatValue: [],
    StringValue: [],
    BooleanValue: [],
    NullValue: [],
    EnumValue: [],
    ListValue: [
        "values"
    ],
    ObjectValue: [
        "fields"
    ],
    ObjectField: [
        "name",
        "value"
    ],
    Directive: [
        "name",
        "arguments"
    ],
    NamedType: [
        "name"
    ],
    ListType: [
        "type"
    ],
    NonNullType: [
        "type"
    ],
    SchemaDefinition: [
        "directives",
        "operationTypes"
    ],
    OperationTypeDefinition: [
        "type"
    ],
    ScalarTypeDefinition: [
        "description",
        "name",
        "directives"
    ],
    ObjectTypeDefinition: [
        "description",
        "name",
        "interfaces",
        "directives",
        "fields"
    ],
    FieldDefinition: [
        "description",
        "name",
        "arguments",
        "type",
        "directives"
    ],
    InputValueDefinition: [
        "description",
        "name",
        "type",
        "defaultValue",
        "directives"
    ],
    InterfaceTypeDefinition: [
        "description",
        "name",
        "directives",
        "fields"
    ],
    UnionTypeDefinition: [
        "description",
        "name",
        "directives",
        "types"
    ],
    EnumTypeDefinition: [
        "description",
        "name",
        "directives",
        "values"
    ],
    EnumValueDefinition: [
        "description",
        "name",
        "directives"
    ],
    InputObjectTypeDefinition: [
        "description",
        "name",
        "directives",
        "fields"
    ],
    DirectiveDefinition: [
        "description",
        "name",
        "arguments",
        "locations"
    ],
    SchemaExtension: [
        "directives",
        "operationTypes"
    ],
    ScalarTypeExtension: [
        "name",
        "directives"
    ],
    ObjectTypeExtension: [
        "name",
        "interfaces",
        "directives",
        "fields"
    ],
    InterfaceTypeExtension: [
        "name",
        "directives",
        "fields"
    ],
    UnionTypeExtension: [
        "name",
        "directives",
        "types"
    ],
    EnumTypeExtension: [
        "name",
        "directives",
        "values"
    ],
    InputObjectTypeExtension: [
        "name",
        "directives",
        "fields"
    ]
};
var $81e64b4ccc10b65b$export$a89c95c098ac2a58 = Object.freeze({});
function $81e64b4ccc10b65b$export$bf638b60ea8b89b7(root, visitor) {
    var visitorKeys = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : $81e64b4ccc10b65b$export$4fcd777a40ccf407;
    /* eslint-disable no-undef-init */ var stack = undefined;
    var inArray = Array.isArray(root);
    var keys = [
        root
    ];
    var index = -1;
    var edits = [];
    var node = undefined;
    var key = undefined;
    var parent = undefined;
    var path = [];
    var ancestors = [];
    var newRoot = root;
    /* eslint-enable no-undef-init */ do {
        index++;
        var isLeaving = index === keys.length;
        var isEdited = isLeaving && edits.length !== 0;
        if (isLeaving) {
            key = ancestors.length === 0 ? undefined : path[path.length - 1];
            node = parent;
            parent = ancestors.pop();
            if (isEdited) {
                if (inArray) node = node.slice();
                else {
                    var clone = {};
                    for(var _i2 = 0, _Object$keys2 = Object.keys(node); _i2 < _Object$keys2.length; _i2++){
                        var k = _Object$keys2[_i2];
                        clone[k] = node[k];
                    }
                    node = clone;
                }
                var editOffset = 0;
                for(var ii = 0; ii < edits.length; ii++){
                    var editKey = edits[ii][0];
                    var editValue = edits[ii][1];
                    if (inArray) editKey -= editOffset;
                    if (inArray && editValue === null) {
                        node.splice(editKey, 1);
                        editOffset++;
                    } else node[editKey] = editValue;
                }
            }
            index = stack.index;
            keys = stack.keys;
            edits = stack.edits;
            inArray = stack.inArray;
            stack = stack.prev;
        } else {
            key = parent ? inArray ? index : keys[index] : undefined;
            node = parent ? parent[key] : newRoot;
            if (node === null || node === undefined) continue;
            if (parent) path.push(key);
        }
        var result = void 0;
        if (!Array.isArray(node)) {
            if (!$81e64b4ccc10b65b$var$isNode(node)) throw new Error("Invalid AST Node: " + (0, $6hqcz.default)(node));
            var visitFn = $81e64b4ccc10b65b$export$c9c25cca74db6e70(visitor, node.kind, isLeaving);
            if (visitFn) {
                result = visitFn.call(visitor, node, key, parent, path, ancestors);
                if (result === $81e64b4ccc10b65b$export$a89c95c098ac2a58) break;
                if (result === false) {
                    if (!isLeaving) {
                        path.pop();
                        continue;
                    }
                } else if (result !== undefined) {
                    edits.push([
                        key,
                        result
                    ]);
                    if (!isLeaving) {
                        if ($81e64b4ccc10b65b$var$isNode(result)) node = result;
                        else {
                            path.pop();
                            continue;
                        }
                    }
                }
            }
        }
        if (result === undefined && isEdited) edits.push([
            key,
            node
        ]);
        if (isLeaving) path.pop();
        else {
            stack = {
                inArray: inArray,
                index: index,
                keys: keys,
                edits: edits,
                prev: stack
            };
            inArray = Array.isArray(node);
            keys = inArray ? node : visitorKeys[node.kind] || [];
            index = -1;
            edits = [];
            if (parent) ancestors.push(parent);
            parent = node;
        }
    }while (stack !== undefined);
    if (edits.length !== 0) newRoot = edits[edits.length - 1][1];
    return newRoot;
}
function $81e64b4ccc10b65b$var$isNode(maybeNode) {
    return Boolean(maybeNode && typeof maybeNode.kind === "string");
}
function $81e64b4ccc10b65b$export$728beebeea393478(visitors) {
    var skipping = new Array(visitors.length);
    return {
        enter: function enter(node) {
            for(var i = 0; i < visitors.length; i++)if (!skipping[i]) {
                var fn = $81e64b4ccc10b65b$export$c9c25cca74db6e70(visitors[i], node.kind, /* isLeaving */ false);
                if (fn) {
                    var result = fn.apply(visitors[i], arguments);
                    if (result === false) skipping[i] = node;
                    else if (result === $81e64b4ccc10b65b$export$a89c95c098ac2a58) skipping[i] = $81e64b4ccc10b65b$export$a89c95c098ac2a58;
                    else if (result !== undefined) return result;
                }
            }
        },
        leave: function leave(node) {
            for(var i = 0; i < visitors.length; i++){
                if (!skipping[i]) {
                    var fn = $81e64b4ccc10b65b$export$c9c25cca74db6e70(visitors[i], node.kind, /* isLeaving */ true);
                    if (fn) {
                        var result = fn.apply(visitors[i], arguments);
                        if (result === $81e64b4ccc10b65b$export$a89c95c098ac2a58) skipping[i] = $81e64b4ccc10b65b$export$a89c95c098ac2a58;
                        else if (result !== undefined && result !== false) return result;
                    }
                } else if (skipping[i] === node) skipping[i] = null;
            }
        }
    };
}
function $81e64b4ccc10b65b$export$18ca434620348336(typeInfo, visitor) {
    return {
        enter: function enter(node) {
            typeInfo.enter(node);
            var fn = $81e64b4ccc10b65b$export$c9c25cca74db6e70(visitor, node.kind, /* isLeaving */ false);
            if (fn) {
                var result = fn.apply(visitor, arguments);
                if (result !== undefined) {
                    typeInfo.leave(node);
                    if ($81e64b4ccc10b65b$var$isNode(result)) typeInfo.enter(result);
                }
                return result;
            }
        },
        leave: function leave(node) {
            var fn = $81e64b4ccc10b65b$export$c9c25cca74db6e70(visitor, node.kind, /* isLeaving */ true);
            var result;
            if (fn) result = fn.apply(visitor, arguments);
            typeInfo.leave(node);
            return result;
        }
    };
}
function $81e64b4ccc10b65b$export$c9c25cca74db6e70(visitor, kind, isLeaving) {
    var kindVisitor = visitor[kind];
    if (kindVisitor) {
        if (!isLeaving && typeof kindVisitor === "function") // { Kind() {} }
        return kindVisitor;
        var kindSpecificVisitor = isLeaving ? kindVisitor.leave : kindVisitor.enter;
        if (typeof kindSpecificVisitor === "function") // { Kind: { enter() {}, leave() {} } }
        return kindSpecificVisitor;
    } else {
        var specificVisitor = isLeaving ? visitor.leave : visitor.enter;
        if (specificVisitor) {
            if (typeof specificVisitor === "function") // { enter() {}, leave() {} }
            return specificVisitor;
            var specificKindVisitor = specificVisitor[kind];
            if (typeof specificKindVisitor === "function") // { enter: { Kind() {} }, leave: { Kind() {} } }
            return specificKindVisitor;
        }
    }
}

});



parcelRegister("wEq4m", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ClientError = void 0;
class $062257bd3dffee93$var$ClientError extends Error {
    constructor(response, request){
        const message = `${$062257bd3dffee93$var$ClientError.extractMessage(response)}: ${JSON.stringify({
            response: response,
            request: request
        })}`;
        super(message);
        Object.setPrototypeOf(this, $062257bd3dffee93$var$ClientError.prototype);
        this.response = response;
        this.request = request;
        // this is needed as Safari doesn't support .captureStackTrace
        if (typeof Error.captureStackTrace === `function`) Error.captureStackTrace(this, $062257bd3dffee93$var$ClientError);
    }
    static extractMessage(response) {
        return response.errors?.[0]?.message ?? `GraphQL Error (Code: ${response.status})`;
    }
}
module.exports.ClientError = $062257bd3dffee93$var$ClientError;

});

parcelRegister("fJW6e", function(module, exports) {
var global = typeof self !== "undefined" ? self : this;
var __self__ = function() {
    function F() {
        this.fetch = false;
        this.DOMException = global.DOMException;
    }
    F.prototype = global;
    return new F();
}();
(function(self1) {
    var irrelevant = function(exports1) {
        var support = {
            searchParams: "URLSearchParams" in self1,
            iterable: "Symbol" in self1 && "iterator" in Symbol,
            blob: "FileReader" in self1 && "Blob" in self1 && function() {
                try {
                    new Blob();
                    return true;
                } catch (e) {
                    return false;
                }
            }(),
            formData: "FormData" in self1,
            arrayBuffer: "ArrayBuffer" in self1
        };
        function isDataView(obj) {
            return obj && DataView.prototype.isPrototypeOf(obj);
        }
        if (support.arrayBuffer) {
            var viewClasses = [
                "[object Int8Array]",
                "[object Uint8Array]",
                "[object Uint8ClampedArray]",
                "[object Int16Array]",
                "[object Uint16Array]",
                "[object Int32Array]",
                "[object Uint32Array]",
                "[object Float32Array]",
                "[object Float64Array]"
            ];
            var isArrayBufferView = ArrayBuffer.isView || function(obj) {
                return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1;
            };
        }
        function normalizeName(name) {
            if (typeof name !== "string") name = String(name);
            if (/[^a-z0-9\-#$%&'*+.^_`|~]/i.test(name)) throw new TypeError("Invalid character in header field name");
            return name.toLowerCase();
        }
        function normalizeValue(value) {
            if (typeof value !== "string") value = String(value);
            return value;
        }
        // Build a destructive iterator for the value list
        function iteratorFor(items) {
            var iterator = {
                next: function() {
                    var value = items.shift();
                    return {
                        done: value === undefined,
                        value: value
                    };
                }
            };
            if (support.iterable) iterator[Symbol.iterator] = function() {
                return iterator;
            };
            return iterator;
        }
        function Headers(headers) {
            this.map = {};
            if (headers instanceof Headers) headers.forEach(function(value, name) {
                this.append(name, value);
            }, this);
            else if (Array.isArray(headers)) headers.forEach(function(header) {
                this.append(header[0], header[1]);
            }, this);
            else if (headers) Object.getOwnPropertyNames(headers).forEach(function(name) {
                this.append(name, headers[name]);
            }, this);
        }
        Headers.prototype.append = function(name, value) {
            name = normalizeName(name);
            value = normalizeValue(value);
            var oldValue = this.map[name];
            this.map[name] = oldValue ? oldValue + ", " + value : value;
        };
        Headers.prototype["delete"] = function(name) {
            delete this.map[normalizeName(name)];
        };
        Headers.prototype.get = function(name) {
            name = normalizeName(name);
            return this.has(name) ? this.map[name] : null;
        };
        Headers.prototype.has = function(name) {
            return this.map.hasOwnProperty(normalizeName(name));
        };
        Headers.prototype.set = function(name, value) {
            this.map[normalizeName(name)] = normalizeValue(value);
        };
        Headers.prototype.forEach = function(callback, thisArg) {
            for(var name in this.map)if (this.map.hasOwnProperty(name)) callback.call(thisArg, this.map[name], name, this);
        };
        Headers.prototype.keys = function() {
            var items = [];
            this.forEach(function(value, name) {
                items.push(name);
            });
            return iteratorFor(items);
        };
        Headers.prototype.values = function() {
            var items = [];
            this.forEach(function(value) {
                items.push(value);
            });
            return iteratorFor(items);
        };
        Headers.prototype.entries = function() {
            var items = [];
            this.forEach(function(value, name) {
                items.push([
                    name,
                    value
                ]);
            });
            return iteratorFor(items);
        };
        if (support.iterable) Headers.prototype[Symbol.iterator] = Headers.prototype.entries;
        function consumed(body) {
            if (body.bodyUsed) return Promise.reject(new TypeError("Already read"));
            body.bodyUsed = true;
        }
        function fileReaderReady(reader) {
            return new Promise(function(resolve, reject) {
                reader.onload = function() {
                    resolve(reader.result);
                };
                reader.onerror = function() {
                    reject(reader.error);
                };
            });
        }
        function readBlobAsArrayBuffer(blob) {
            var reader = new FileReader();
            var promise = fileReaderReady(reader);
            reader.readAsArrayBuffer(blob);
            return promise;
        }
        function readBlobAsText(blob) {
            var reader = new FileReader();
            var promise = fileReaderReady(reader);
            reader.readAsText(blob);
            return promise;
        }
        function readArrayBufferAsText(buf) {
            var view = new Uint8Array(buf);
            var chars = new Array(view.length);
            for(var i = 0; i < view.length; i++)chars[i] = String.fromCharCode(view[i]);
            return chars.join("");
        }
        function bufferClone(buf) {
            if (buf.slice) return buf.slice(0);
            else {
                var view = new Uint8Array(buf.byteLength);
                view.set(new Uint8Array(buf));
                return view.buffer;
            }
        }
        function Body() {
            this.bodyUsed = false;
            this._initBody = function(body) {
                this._bodyInit = body;
                if (!body) this._bodyText = "";
                else if (typeof body === "string") this._bodyText = body;
                else if (support.blob && Blob.prototype.isPrototypeOf(body)) this._bodyBlob = body;
                else if (support.formData && FormData.prototype.isPrototypeOf(body)) this._bodyFormData = body;
                else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) this._bodyText = body.toString();
                else if (support.arrayBuffer && support.blob && isDataView(body)) {
                    this._bodyArrayBuffer = bufferClone(body.buffer);
                    // IE 10-11 can't handle a DataView body.
                    this._bodyInit = new Blob([
                        this._bodyArrayBuffer
                    ]);
                } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) this._bodyArrayBuffer = bufferClone(body);
                else this._bodyText = body = Object.prototype.toString.call(body);
                if (!this.headers.get("content-type")) {
                    if (typeof body === "string") this.headers.set("content-type", "text/plain;charset=UTF-8");
                    else if (this._bodyBlob && this._bodyBlob.type) this.headers.set("content-type", this._bodyBlob.type);
                    else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) this.headers.set("content-type", "application/x-www-form-urlencoded;charset=UTF-8");
                }
            };
            if (support.blob) {
                this.blob = function() {
                    var rejected = consumed(this);
                    if (rejected) return rejected;
                    if (this._bodyBlob) return Promise.resolve(this._bodyBlob);
                    else if (this._bodyArrayBuffer) return Promise.resolve(new Blob([
                        this._bodyArrayBuffer
                    ]));
                    else if (this._bodyFormData) throw new Error("could not read FormData body as blob");
                    else return Promise.resolve(new Blob([
                        this._bodyText
                    ]));
                };
                this.arrayBuffer = function() {
                    if (this._bodyArrayBuffer) return consumed(this) || Promise.resolve(this._bodyArrayBuffer);
                    else return this.blob().then(readBlobAsArrayBuffer);
                };
            }
            this.text = function() {
                var rejected = consumed(this);
                if (rejected) return rejected;
                if (this._bodyBlob) return readBlobAsText(this._bodyBlob);
                else if (this._bodyArrayBuffer) return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer));
                else if (this._bodyFormData) throw new Error("could not read FormData body as text");
                else return Promise.resolve(this._bodyText);
            };
            if (support.formData) this.formData = function() {
                return this.text().then(decode);
            };
            this.json = function() {
                return this.text().then(JSON.parse);
            };
            return this;
        }
        // HTTP methods whose capitalization should be normalized
        var methods = [
            "DELETE",
            "GET",
            "HEAD",
            "OPTIONS",
            "POST",
            "PUT"
        ];
        function normalizeMethod(method) {
            var upcased = method.toUpperCase();
            return methods.indexOf(upcased) > -1 ? upcased : method;
        }
        function Request(input, options) {
            options = options || {};
            var body = options.body;
            if (input instanceof Request) {
                if (input.bodyUsed) throw new TypeError("Already read");
                this.url = input.url;
                this.credentials = input.credentials;
                if (!options.headers) this.headers = new Headers(input.headers);
                this.method = input.method;
                this.mode = input.mode;
                this.signal = input.signal;
                if (!body && input._bodyInit != null) {
                    body = input._bodyInit;
                    input.bodyUsed = true;
                }
            } else this.url = String(input);
            this.credentials = options.credentials || this.credentials || "same-origin";
            if (options.headers || !this.headers) this.headers = new Headers(options.headers);
            this.method = normalizeMethod(options.method || this.method || "GET");
            this.mode = options.mode || this.mode || null;
            this.signal = options.signal || this.signal;
            this.referrer = null;
            if ((this.method === "GET" || this.method === "HEAD") && body) throw new TypeError("Body not allowed for GET or HEAD requests");
            this._initBody(body);
        }
        Request.prototype.clone = function() {
            return new Request(this, {
                body: this._bodyInit
            });
        };
        function decode(body) {
            var form = new FormData();
            body.trim().split("&").forEach(function(bytes) {
                if (bytes) {
                    var split = bytes.split("=");
                    var name = split.shift().replace(/\+/g, " ");
                    var value = split.join("=").replace(/\+/g, " ");
                    form.append(decodeURIComponent(name), decodeURIComponent(value));
                }
            });
            return form;
        }
        function parseHeaders(rawHeaders) {
            var headers = new Headers();
            // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
            // https://tools.ietf.org/html/rfc7230#section-3.2
            var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, " ");
            preProcessedHeaders.split(/\r?\n/).forEach(function(line) {
                var parts = line.split(":");
                var key = parts.shift().trim();
                if (key) {
                    var value = parts.join(":").trim();
                    headers.append(key, value);
                }
            });
            return headers;
        }
        Body.call(Request.prototype);
        function Response(bodyInit, options) {
            if (!options) options = {};
            this.type = "default";
            this.status = options.status === undefined ? 200 : options.status;
            this.ok = this.status >= 200 && this.status < 300;
            this.statusText = "statusText" in options ? options.statusText : "OK";
            this.headers = new Headers(options.headers);
            this.url = options.url || "";
            this._initBody(bodyInit);
        }
        Body.call(Response.prototype);
        Response.prototype.clone = function() {
            return new Response(this._bodyInit, {
                status: this.status,
                statusText: this.statusText,
                headers: new Headers(this.headers),
                url: this.url
            });
        };
        Response.error = function() {
            var response = new Response(null, {
                status: 0,
                statusText: ""
            });
            response.type = "error";
            return response;
        };
        var redirectStatuses = [
            301,
            302,
            303,
            307,
            308
        ];
        Response.redirect = function(url, status) {
            if (redirectStatuses.indexOf(status) === -1) throw new RangeError("Invalid status code");
            return new Response(null, {
                status: status,
                headers: {
                    location: url
                }
            });
        };
        exports1.DOMException = self1.DOMException;
        try {
            new exports1.DOMException();
        } catch (err) {
            exports1.DOMException = function(message, name) {
                this.message = message;
                this.name = name;
                var error = Error(message);
                this.stack = error.stack;
            };
            exports1.DOMException.prototype = Object.create(Error.prototype);
            exports1.DOMException.prototype.constructor = exports1.DOMException;
        }
        function fetch(input, init) {
            return new Promise(function(resolve, reject) {
                var request = new Request(input, init);
                if (request.signal && request.signal.aborted) return reject(new exports1.DOMException("Aborted", "AbortError"));
                var xhr = new XMLHttpRequest();
                function abortXhr() {
                    xhr.abort();
                }
                xhr.onload = function() {
                    var options = {
                        status: xhr.status,
                        statusText: xhr.statusText,
                        headers: parseHeaders(xhr.getAllResponseHeaders() || "")
                    };
                    options.url = "responseURL" in xhr ? xhr.responseURL : options.headers.get("X-Request-URL");
                    var body = "response" in xhr ? xhr.response : xhr.responseText;
                    resolve(new Response(body, options));
                };
                xhr.onerror = function() {
                    reject(new TypeError("Network request failed"));
                };
                xhr.ontimeout = function() {
                    reject(new TypeError("Network request failed"));
                };
                xhr.onabort = function() {
                    reject(new exports1.DOMException("Aborted", "AbortError"));
                };
                xhr.open(request.method, request.url, true);
                if (request.credentials === "include") xhr.withCredentials = true;
                else if (request.credentials === "omit") xhr.withCredentials = false;
                if ("responseType" in xhr && support.blob) xhr.responseType = "blob";
                request.headers.forEach(function(value, name) {
                    xhr.setRequestHeader(name, value);
                });
                if (request.signal) {
                    request.signal.addEventListener("abort", abortXhr);
                    xhr.onreadystatechange = function() {
                        // DONE (success or failure)
                        if (xhr.readyState === 4) request.signal.removeEventListener("abort", abortXhr);
                    };
                }
                xhr.send(typeof request._bodyInit === "undefined" ? null : request._bodyInit);
            });
        }
        fetch.polyfill = true;
        if (!self1.fetch) {
            self1.fetch = fetch;
            self1.Headers = Headers;
            self1.Request = Request;
            self1.Response = Response;
        }
        exports1.Headers = Headers;
        exports1.Request = Request;
        exports1.Response = Response;
        exports1.fetch = fetch;
        Object.defineProperty(exports1, "__esModule", {
            value: true
        });
        return exports1;
    }({});
})(__self__);
__self__.fetch.ponyfill = true;
// Remove "polyfill" property added by whatwg-fetch
delete __self__.fetch.polyfill;
// Choose between native implementation (global) or custom implementation (__self__)
// var ctx = global.fetch ? global : __self__;
var ctx = __self__; // this line disable service worker support temporarily
exports = ctx.fetch // To enable: import fetch from 'cross-fetch'
;
exports.default = ctx.fetch // For TypeScript consumers without esModuleInterop.
;
exports.fetch = ctx.fetch // To enable: import {fetch} from 'cross-fetch'
;
exports.Headers = ctx.Headers;
exports.Request = ctx.Request;
exports.Response = ctx.Response;
module.exports = exports;

});

parcelRegister("64v0p", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.GraphQLWebSocketClient = void 0;

var $gUyD7 = parcelRequire("gUyD7");

var $wEq4m = parcelRequire("wEq4m");
// import type WebSocket from 'ws'
const $46bb2adada976348$var$CONNECTION_INIT = `connection_init`;
const $46bb2adada976348$var$CONNECTION_ACK = `connection_ack`;
const $46bb2adada976348$var$PING = `ping`;
const $46bb2adada976348$var$PONG = `pong`;
const $46bb2adada976348$var$SUBSCRIBE = `subscribe`;
const $46bb2adada976348$var$NEXT = `next`;
const $46bb2adada976348$var$ERROR = `error`;
const $46bb2adada976348$var$COMPLETE = `complete`;
class $46bb2adada976348$var$GraphQLWebSocketMessage {
    get type() {
        return this._type;
    }
    get id() {
        return this._id;
    }
    get payload() {
        return this._payload;
    }
    constructor(type, payload, id){
        this._type = type;
        this._payload = payload;
        this._id = id;
    }
    get text() {
        const result = {
            type: this.type
        };
        if (this.id != null && this.id != undefined) result.id = this.id;
        if (this.payload != null && this.payload != undefined) result.payload = this.payload;
        return JSON.stringify(result);
    }
    static parse(data, f) {
        const { type: type, payload: payload, id: id } = JSON.parse(data);
        return new $46bb2adada976348$var$GraphQLWebSocketMessage(type, f(payload), id);
    }
}
class $46bb2adada976348$var$GraphQLWebSocketClient {
    constructor(socket, { onInit: onInit, onAcknowledged: onAcknowledged, onPing: onPing, onPong: onPong }){
        this.socketState = {
            acknowledged: false,
            lastRequestId: 0,
            subscriptions: {}
        };
        this.socket = socket;
        socket.addEventListener(`open`, async (e)=>{
            this.socketState.acknowledged = false;
            this.socketState.subscriptions = {};
            socket.send($46bb2adada976348$var$ConnectionInit(onInit ? await onInit() : null).text);
        });
        socket.addEventListener(`close`, (e)=>{
            this.socketState.acknowledged = false;
            this.socketState.subscriptions = {};
        });
        socket.addEventListener(`error`, (e)=>{
            console.error(e);
        });
        socket.addEventListener(`message`, (e)=>{
            try {
                const message = $46bb2adada976348$var$parseMessage(e.data);
                switch(message.type){
                    case $46bb2adada976348$var$CONNECTION_ACK:
                        if (this.socketState.acknowledged) console.warn(`Duplicate CONNECTION_ACK message ignored`);
                        else {
                            this.socketState.acknowledged = true;
                            if (onAcknowledged) onAcknowledged(message.payload);
                        }
                        return;
                    case $46bb2adada976348$var$PING:
                        if (onPing) onPing(message.payload).then((r)=>socket.send($46bb2adada976348$var$Pong(r).text));
                        else socket.send($46bb2adada976348$var$Pong(null).text);
                        return;
                    case $46bb2adada976348$var$PONG:
                        if (onPong) onPong(message.payload);
                        return;
                }
                if (!this.socketState.acknowledged) // Web-socket connection not acknowledged
                return;
                if (message.id === undefined || message.id === null || !this.socketState.subscriptions[message.id]) // No subscription identifer or subscription indentifier is not found
                return;
                const { query: query, variables: variables, subscriber: subscriber } = this.socketState.subscriptions[message.id];
                switch(message.type){
                    case $46bb2adada976348$var$NEXT:
                        if (!message.payload.errors && message.payload.data) subscriber.next && subscriber.next(message.payload.data);
                        if (message.payload.errors) subscriber.error && subscriber.error(new $wEq4m.ClientError({
                            ...message.payload,
                            status: 200
                        }, {
                            query: query,
                            variables: variables
                        }));
                        return;
                    case $46bb2adada976348$var$ERROR:
                        subscriber.error && subscriber.error(new $wEq4m.ClientError({
                            errors: message.payload,
                            status: 200
                        }, {
                            query: query,
                            variables: variables
                        }));
                        return;
                    case $46bb2adada976348$var$COMPLETE:
                        subscriber.complete && subscriber.complete();
                        delete this.socketState.subscriptions[message.id];
                        return;
                }
            } catch (e) {
                // Unexpected errors while handling graphql-ws message
                console.error(e);
                socket.close(1006);
            }
            socket.close(4400, `Unknown graphql-ws message.`);
        });
    }
    makeSubscribe(query, operationName, subscriber, variables) {
        const subscriptionId = (this.socketState.lastRequestId++).toString();
        this.socketState.subscriptions[subscriptionId] = {
            query: query,
            variables: variables,
            subscriber: subscriber
        };
        this.socket.send($46bb2adada976348$var$Subscribe(subscriptionId, {
            query: query,
            operationName: operationName,
            variables: variables
        }).text);
        return ()=>{
            this.socket.send($46bb2adada976348$var$Complete(subscriptionId).text);
            delete this.socketState.subscriptions[subscriptionId];
        };
    }
    rawRequest(query, variables) {
        return new Promise((resolve, reject)=>{
            let result;
            this.rawSubscribe(query, {
                next: (data, extensions)=>result = {
                        data: data,
                        extensions: extensions
                    },
                error: reject,
                complete: ()=>resolve(result)
            }, variables);
        });
    }
    request(document, variables) {
        return new Promise((resolve, reject)=>{
            let result;
            this.subscribe(document, {
                next: (data)=>result = data,
                error: reject,
                complete: ()=>resolve(result)
            }, variables);
        });
    }
    subscribe(document, subscriber, variables) {
        const { query: query, operationName: operationName } = (0, $gUyD7.resolveRequestDocument)(document);
        return this.makeSubscribe(query, operationName, subscriber, variables);
    }
    rawSubscribe(query, subscriber, variables) {
        return this.makeSubscribe(query, undefined, subscriber, variables);
    }
    ping(payload) {
        this.socket.send($46bb2adada976348$var$Ping(payload).text);
    }
    close() {
        this.socket.close(1000);
    }
}
$46bb2adada976348$var$GraphQLWebSocketClient.PROTOCOL = `graphql-transport-ws`;
module.exports.GraphQLWebSocketClient = $46bb2adada976348$var$GraphQLWebSocketClient;
// Helper functions
function $46bb2adada976348$var$parseMessage(data, f = (a)=>a) {
    const m = $46bb2adada976348$var$GraphQLWebSocketMessage.parse(data, f);
    return m;
}
function $46bb2adada976348$var$ConnectionInit(payload) {
    return new $46bb2adada976348$var$GraphQLWebSocketMessage($46bb2adada976348$var$CONNECTION_INIT, payload);
}
function $46bb2adada976348$var$Ping(payload) {
    return new $46bb2adada976348$var$GraphQLWebSocketMessage($46bb2adada976348$var$PING, payload, undefined);
}
function $46bb2adada976348$var$Pong(payload) {
    return new $46bb2adada976348$var$GraphQLWebSocketMessage($46bb2adada976348$var$PONG, payload, undefined);
}
function $46bb2adada976348$var$Subscribe(id, payload) {
    return new $46bb2adada976348$var$GraphQLWebSocketMessage($46bb2adada976348$var$SUBSCRIBE, payload, id);
}
function $46bb2adada976348$var$Complete(id) {
    return new $46bb2adada976348$var$GraphQLWebSocketMessage($46bb2adada976348$var$COMPLETE, undefined, id);
}

});




parcelRegister("84bHK", function(module, exports) {

$parcel$export(module.exports, "MyAvatarQueryKey", function () { return $b9ab5585153664aa$export$8a17a6a26a751e9e; });
$parcel$export(module.exports, "useMyAvatar", function () { return $b9ab5585153664aa$export$7d0fb16b579eac66; });

var $4MHck = parcelRequire("4MHck");

var $iDL5l = parcelRequire("iDL5l");

var $1Bj4T = parcelRequire("1Bj4T");
const $b9ab5585153664aa$export$8a17a6a26a751e9e = "MyAvatarQuerykey";
const $b9ab5585153664aa$var$myAvatarQueryFn = async (userId)=>{
    const { stargateRoot: stargateRoot } = (0, $1Bj4T.getConfig)();
    const url = `${stargateRoot}/users/${userId}/manage/avatar`;
    const response = await (0, $iDL5l.fetchApi)(url);
    const data = await response.json();
    return data;
};
const $b9ab5585153664aa$export$7d0fb16b579eac66 = (userId)=>{
    const { data: data, isLoading: isLoading, isError: isError } = (0, $4MHck.useQuery)({
        queryKey: [
            $b9ab5585153664aa$export$8a17a6a26a751e9e,
            userId
        ],
        queryFn: ()=>$b9ab5585153664aa$var$myAvatarQueryFn(userId)
    });
    return {
        myAvatar: data,
        isLoading: isLoading,
        isError: isError
    };
};

});
parcelRegister("iDL5l", function(module, exports) {

$parcel$export(module.exports, "fetchApi", function () { return $0d086018c884b89d$export$adb4bb4243526aef; });

var $77YRX = parcelRequire("77YRX");
const $0d086018c884b89d$var$removeEmptyHeaders = (headers)=>{
    const result = {
        ...headers
    };
    Object.entries(result).forEach(([key, val])=>{
        if (val === undefined || val === null) delete result[key];
    });
    return result;
};
const $0d086018c884b89d$export$adb4bb4243526aef = async (url, init = {})=>{
    const response = await fetch(url, {
        credentials: "include",
        ...init,
        headers: $0d086018c884b89d$var$removeEmptyHeaders({
            "Content-Type": "application/json",
            ...init.headers
        })
    });
    if (!response.ok) {
        const message = `Failed to fetch ${url} [${response.status} status]`;
        const data = await response.json();
        const error = new Error(message);
        (0, $77YRX.logException)(error, message, data);
        throw error;
    }
    return response;
};

});


parcelRegister("bXDKf", function(module, exports) {
$parcel$export(module.exports, "avatarByAccountIdQueryKey", function () { return (parcelRequire("9MaY0")).avatarByAccountIdQueryKey; });
$parcel$export(module.exports, "useAvatarByAccountIdQuery", function () { return (parcelRequire("9MaY0")).useAvatarByAccountIdQuery; });
parcelRequire("9MaY0");

});
parcelRegister("9MaY0", function(module, exports) {

$parcel$export(module.exports, "avatarByAccountIdQueryKey", function () { return $a4085eb77cfdedf7$export$dc1ed81bd48aa5e2; });
$parcel$export(module.exports, "useAvatarByAccountIdQuery", function () { return $a4085eb77cfdedf7$export$47644ea6f236cf15; });

var $4MHck = parcelRequire("4MHck");

var $1Bj4T = parcelRequire("1Bj4T");

var $eUuk8 = parcelRequire("eUuk8");
const $a4085eb77cfdedf7$export$dc1ed81bd48aa5e2 = "avatarByAccountIdQueryKey";
const $a4085eb77cfdedf7$var$getAvatarAndFullNameByAccountIdQueryFn = async (userId, size)=>{
    const { stargateRoot: stargateRoot } = (0, $1Bj4T.getConfig)();
    if (!userId) return {
        id: "",
        fullName: "",
        avatarUrl: ""
    };
    const aggUrl = `${stargateRoot}/graphql?q=AvatarByAccountIdQuery`;
    const { id: id, name: fullName, picture: avatarUrl } = await (0, $eUuk8.default)({
        userId: userId,
        url: aggUrl
    });
    return {
        id: id,
        fullName: fullName,
        avatarUrl: avatarUrl
    };
};
const $a4085eb77cfdedf7$export$47644ea6f236cf15 = (userId, size)=>{
    const { data: data, isLoading: isLoading, isError: isError } = (0, $4MHck.useQuery)({
        queryKey: [
            $a4085eb77cfdedf7$export$dc1ed81bd48aa5e2,
            userId
        ],
        queryFn: ()=>$a4085eb77cfdedf7$var$getAvatarAndFullNameByAccountIdQueryFn(userId, size)
    });
    return {
        avatarByAccountIdData: data,
        isLoading: isLoading,
        isError: isError
    };
};

});



parcelRegister("5gNz2", function(module, exports) {

$parcel$export(module.exports, "useUpdateUserAvatarMutation", function () { return $785592a78df8248e$export$842efd75e6fdec2e; });

var $atFkq = parcelRequire("atFkq");
var $132jP = parcelRequire("132jP");

var $5ehI7 = parcelRequire("5ehI7");

var $1Bj4T = parcelRequire("1Bj4T");

var $8jUEk = parcelRequire("8jUEk");

var $iMYRj = parcelRequire("iMYRj");

var $84bHK = parcelRequire("84bHK");
parcelRequire("bXDKf");
var $9MaY0 = parcelRequire("9MaY0");

var $77YRX = parcelRequire("77YRX");
const $785592a78df8248e$var$updateUserAvatarMutationFn = async (userId, dataURI)=>{
    const { stargateRoot: stargateRoot } = (0, $1Bj4T.getConfig)();
    const url = `${stargateRoot}/users/${userId}/manage/avatar`;
    const fileObject = (0, $iMYRj.dataURItoFile)(dataURI);
    const formData = new FormData();
    formData.append("file", fileObject);
    const response = await fetch(url, {
        method: "PUT",
        credentials: "include",
        body: formData
    });
    const data = await response.json();
    return data;
};
const $785592a78df8248e$export$842efd75e6fdec2e = (userId)=>{
    const queryClient = (0, $132jP.useQueryClient)();
    const { isError: isError, isLoading: isLoading, mutateAsync: mutateAsync, error: error } = (0, $atFkq.useMutation)({
        onSuccess: (data)=>{
            const newAvatarUrl = data.url;
            queryClient.setQueryData([
                (0, $8jUEk.profileAvatarQueryKey),
                userId
            ], (old)=>old && (0, (/*@__PURE__*/$parcel$interopDefault($5ehI7)))({}, old, {
                    avatarUrl: newAvatarUrl
                }));
            queryClient.setQueryData([
                (0, $84bHK.MyAvatarQueryKey),
                userId
            ], (old)=>old && (0, (/*@__PURE__*/$parcel$interopDefault($5ehI7)))({}, old, {
                    uploaded: true,
                    url: newAvatarUrl
                }));
            queryClient.setQueryData([
                (0, $9MaY0.avatarByAccountIdQueryKey),
                userId
            ], (old)=>old && (0, (/*@__PURE__*/$parcel$interopDefault($5ehI7)))({}, old, {
                    avatarUrl: newAvatarUrl
                }));
        },
        onError: (error)=>{
            (0, $77YRX.logException)(error, "Could not update avatar");
        },
        mutationFn: async (dataURI)=>$785592a78df8248e$var$updateUserAvatarMutationFn(userId, dataURI)
    });
    return {
        isError: isError,
        error: error,
        isLoading: isLoading,
        mutateAsync: mutateAsync
    };
};

});
parcelRegister("iMYRj", function(module, exports) {

$parcel$export(module.exports, "dataURItoFile", function () { return $ded335cb788127e1$export$80d19edb7b1ae293; });
function $ded335cb788127e1$export$80d19edb7b1ae293(dataURI, filename = "untitled") {
    if (dataURI.length === 0) throw new Error("dataURI not found");
    // convert base64/URLEncoded data component to raw binary data held in a string
    const byteString = dataURI.split(",")[0].includes("base64") ? atob(dataURI.split(",")[1]) : decodeURIComponent(dataURI.split(",")[1]);
    // separate out the mime component
    let mimeString;
    try {
        mimeString = dataURI.split(",")[0].split(":")[1].split(";")[0];
    } catch (e) {
        mimeString = "unknown";
    }
    // write the bytes of the string to a typed array
    const intArray = new Uint8Array(byteString.length);
    for(let i = 0; i < byteString.length; i++)intArray[i] = byteString.charCodeAt(i);
    const blob = new Blob([
        intArray
    ], {
        type: mimeString
    });
    try {
        return new File([
            blob
        ], filename, {
            type: mimeString
        });
    } catch (e) {
        // IE11 and Safari does not support the File constructor.
        return blob;
    }
}

});



parcelRegister("7mUVx", function(module, exports) {

var $6aCUT = parcelRequire("6aCUT");
module.exports = $6aCUT("1TA39").then(()=>parcelRequire("hCB7C"));

});

parcelRegister("2E2Uy", function(module, exports) {

var $6aCUT = parcelRequire("6aCUT");
module.exports = Promise.all([
    $6aCUT("935eB"),
    $6aCUT("2fcNx"),
    $6aCUT("04gC2")
]).then(()=>parcelRequire("lqtku"));

});




parcelRegister("i4h1u", function(module, exports) {

$parcel$export(module.exports, "default", function () { return (parcelRequire("2MTID")).default; });

var $2MTID = parcelRequire("2MTID");

});
parcelRegister("2MTID", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c0940839b158e6a0$export$2e2bcd8739ae039; });

var $bibO8 = parcelRequire("bibO8");
parcelRequire("dAx5m");

var $lejQH = parcelRequire("lejQH");

var $dViVv = parcelRequire("dViVv");

var $jBIjf = parcelRequire("jBIjf");
// Make icon non-interactive
const $c0940839b158e6a0$var$focusedTaskOverrides = {
    Sidebar: {
        cssFn: (defaultStyles)=>({
                ...defaultStyles,
                "& > button": {
                    pointerEvents: "none"
                }
            })
    }
};
const $c0940839b158e6a0$var$FocusedTask = ({ onClose: onClose, isOpen: isOpen, children: children })=>/*#__PURE__*/ (0, $bibO8.jsx)((0, $lejQH.default), {
        onClose: onClose,
        isOpen: isOpen,
        icon: (0, $dViVv.AtlassianIcon),
        width: "full",
        overrides: $c0940839b158e6a0$var$focusedTaskOverrides,
        children: /*#__PURE__*/ (0, $bibO8.jsx)($jBIjf.FocusedTaskContent, {
            children: children
        })
    });
var $c0940839b158e6a0$export$2e2bcd8739ae039 = $c0940839b158e6a0$var$FocusedTask;

});
parcelRegister("lejQH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f74a4d669d563c15$export$2e2bcd8739ae039; });
/* eslint-disable @repo/internal/dom-events/no-unsafe-event-listeners */ 
var $dAx5m = parcelRequire("dAx5m");

var $5Fvus = parcelRequire("5Fvus");

var $gVLVb = parcelRequire("gVLVb");

var $jl49R = parcelRequire("jl49R");
var $gN6LC = parcelRequire("gN6LC");

var $iWhPr = parcelRequire("iWhPr");

var $hpTSI = parcelRequire("hpTSI");

var $ia0xI = parcelRequire("ia0xI");
// escape close manager for layering
var $f74a4d669d563c15$var$EscapeCloseManager = function EscapeCloseManager(_ref) {
    var onClose = _ref.onClose;
    // wrap so that we can cast the event to a React.KeyboardEvent
    var handleClose = (0, $dAx5m.useCallback)(function(evt) {
        onClose && onClose(evt);
    }, [
        onClose
    ]);
    (0, $gN6LC.useCloseOnEscapePress)({
        onClose: handleClose
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement("span", null);
};
/**
 * __Drawer__
 *
 * A drawer is a panel that slides in from the left side of the screen.
 *
 * - [Examples](https://atlassian.design/components/drawer/examples)
 * - [Code](https://atlassian.design/components/drawer/code)
 * - [Usage](https://atlassian.design/components/drawer/usage)
 */ var $f74a4d669d563c15$var$Drawer = function Drawer(_ref2) {
    var _ref2$width = _ref2.width, width = _ref2$width === void 0 ? "narrow" : _ref2$width, isOpen = _ref2.isOpen, _ref2$isFocusLockEnab = _ref2.isFocusLockEnabled, isFocusLockEnabled = _ref2$isFocusLockEnab === void 0 ? true : _ref2$isFocusLockEnab, _ref2$shouldReturnFoc = _ref2.shouldReturnFocus, shouldReturnFocus = _ref2$shouldReturnFoc === void 0 ? true : _ref2$shouldReturnFoc, _ref2$autoFocusFirstE = _ref2.autoFocusFirstElem, autoFocusFirstElem = _ref2$autoFocusFirstE === void 0 ? true : _ref2$autoFocusFirstE, onKeyDown = _ref2.onKeyDown, onClose = _ref2.onClose, testId = _ref2.testId, children = _ref2.children, icon = _ref2.icon, closeLabel = _ref2.closeLabel, scrollContentLabel = _ref2.scrollContentLabel, onCloseComplete = _ref2.onCloseComplete, onOpenComplete = _ref2.onOpenComplete, overrides = _ref2.overrides, _ref2$zIndex = _ref2.zIndex, zIndex = _ref2$zIndex === void 0 ? "unset" : _ref2$zIndex, label = _ref2.label, titleId = _ref2.titleId, enterFrom = _ref2.enterFrom;
    var body = (0, $5Fvus.canUseDOM) ? document.querySelector("body") : undefined;
    var handleClose = (0, $gVLVb.usePlatformLeafEventHandler)({
        fn: function fn(evt, analyticsEvent) {
            return onClose && onClose(evt, analyticsEvent);
        },
        action: "dismissed",
        componentName: "drawer",
        packageName: "@atlaskit/drawer",
        packageVersion: "10.0.3",
        analyticsData: {
            trigger: "escKey"
        }
    });
    var handleKeyDown = (0, $dAx5m.useCallback)(function(evt) {
        onKeyDown && onKeyDown(evt);
    }, [
        onKeyDown
    ]);
    (0, $dAx5m.useEffect)(function() {
        if (isOpen) window.addEventListener("keydown", handleKeyDown);
        return function() {
            window.removeEventListener("keydown", handleKeyDown);
        };
    }, [
        handleKeyDown,
        isOpen
    ]);
    var handleBlanketClick = (0, $gVLVb.usePlatformLeafEventHandler)({
        fn: function fn(evt, analyticsEvent) {
            return onClose && onClose(evt, analyticsEvent);
        },
        action: "dismissed",
        componentName: "drawer",
        packageName: "@atlaskit/drawer",
        packageVersion: "10.0.3",
        analyticsData: {
            trigger: "blanket"
        }
    });
    var handleBackButtonClick = (0, $gVLVb.usePlatformLeafEventHandler)({
        fn: function fn(evt, analyticsEvent) {
            return onClose && onClose(evt, analyticsEvent);
        },
        action: "dismissed",
        componentName: "drawer",
        packageName: "@atlaskit/drawer",
        packageVersion: "10.0.3",
        analyticsData: {
            trigger: "backButton"
        }
    });
    if (!body) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $iWhPr.default), {
        zIndex: zIndex
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $hpTSI.default), {
        isOpen: isOpen,
        onBlanketClicked: handleBlanketClick,
        testId: testId && "".concat(testId, "--blanket")
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $ia0xI.default), {
        testId: testId,
        icon: icon,
        closeLabel: closeLabel,
        in: isOpen,
        onClose: handleBackButtonClick,
        onCloseComplete: onCloseComplete,
        onOpenComplete: onOpenComplete,
        width: width,
        enterFrom: enterFrom,
        label: label,
        titleId: titleId,
        overrides: overrides,
        autoFocusFirstElem: autoFocusFirstElem,
        isFocusLockEnabled: isFocusLockEnabled,
        shouldReturnFocus: shouldReturnFocus,
        scrollContentLabel: scrollContentLabel
    }, isOpen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $jl49R.Layering), {
        isDisabled: false
    }, children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement($f74a4d669d563c15$var$EscapeCloseManager, {
        onClose: handleClose
    })) : children));
};
var $f74a4d669d563c15$export$2e2bcd8739ae039 = $f74a4d669d563c15$var$Drawer;

});
parcelRegister("5Fvus", function(module, exports) {
/*!
  Copyright (c) 2015 Jed Watson.
  Based on code that is Copyright 2013-2015, Facebook, Inc.
  All rights reserved.
*/ /* global define */ (function() {
    "use strict";
    var canUseDOM = !!(typeof window !== "undefined" && window.document && window.document.createElement);
    var ExecutionEnvironment = {
        canUseDOM: canUseDOM,
        canUseWorkers: typeof Worker !== "undefined",
        canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),
        canUseViewport: canUseDOM && !!window.screen
    };
    if (typeof define === "function" && typeof define.amd === "object" && define.amd) define(function() {
        return ExecutionEnvironment;
    });
    else if (0, module.exports) module.exports = ExecutionEnvironment;
    else window.ExecutionEnvironment = ExecutionEnvironment;
})();

});

parcelRegister("gVLVb", function(module, exports) {

$parcel$export(module.exports, "usePlatformLeafEventHandler", function () { return $c537245d8f89959e$export$a4687b0234b40e28; });

var $c6l2j = parcelRequire("c6l2j");

var $dAx5m = parcelRequire("dAx5m");

var $468YR = parcelRequire("468YR");

var $jEB3A = parcelRequire("jEB3A");
function $c537245d8f89959e$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $c537245d8f89959e$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $c537245d8f89959e$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($c6l2j)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $c537245d8f89959e$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $c537245d8f89959e$export$a4687b0234b40e28(_ref) {
    var fn = _ref.fn, action = _ref.action, componentName = _ref.componentName, actionSubject = _ref.actionSubject, packageName = _ref.packageName, packageVersion = _ref.packageVersion, analyticsData = _ref.analyticsData;
    var _useAnalyticsEvents = (0, $468YR.useAnalyticsEvents)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    // We put analyticsData and fn in a ref so that we don't need to break
    // memoization.
    // Generally these could be defined by consumers inline
    // and so we do this to avoid breaking memoization of useCallback
    var dataRef = (0, $jEB3A.useTrackedRef)(analyticsData);
    var fnRef = (0, $jEB3A.useTrackedRef)(fn);
    var handler = (0, $dAx5m.useCallback)(function(value) {
        var analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: actionSubject || componentName,
            attributes: {
                componentName: componentName,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
        // To avoid wrapping this component in AnalyticsContext we manually
        // push the parent context's meta data into the context.
        // Note: this new 'context'
        var context = $c537245d8f89959e$var$_objectSpread({
            componentName: componentName,
            packageName: packageName,
            packageVersion: packageVersion
        }, dataRef.current);
        analyticsEvent.context.push(context);
        // fire an event on the atlaskit channel
        var clone = analyticsEvent.clone();
        if (clone) clone.fire("atlaskit");
        fnRef.current(value, analyticsEvent);
    }, [
        // These are strings and won't change
        action,
        componentName,
        actionSubject,
        packageName,
        packageVersion,
        // This function is memoized in the context
        createAnalyticsEvent,
        // these are a stable ref because of the useTrackedRef hook
        dataRef,
        fnRef
    ]);
    return handler;
}

});
parcelRegister("c6l2j", function(module, exports) {

var $2ezgC = parcelRequire("2ezgC");
function $8cf65cf2ad439566$var$_defineProperty(e, r, t) {
    return (r = $2ezgC(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
module.exports = $8cf65cf2ad439566$var$_defineProperty, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("2ezgC", function(module, exports) {

var $b5I6c = parcelRequire("b5I6c");
var $1a083ede189847e2$var$_typeof = $b5I6c.default;

var $bhpiv = parcelRequire("bhpiv");
function $1a083ede189847e2$var$toPropertyKey(t) {
    var i = $bhpiv(t, "string");
    return "symbol" == $1a083ede189847e2$var$_typeof(i) ? i : i + "";
}
module.exports = $1a083ede189847e2$var$toPropertyKey, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("b5I6c", function(module, exports) {
function $81325e7abca53ece$var$_typeof(o) {
    "@babel/helpers - typeof";
    return module.exports = $81325e7abca53ece$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $81325e7abca53ece$var$_typeof(o);
}
module.exports = $81325e7abca53ece$var$_typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("bhpiv", function(module, exports) {

var $b5I6c = parcelRequire("b5I6c");
var $8364e7caadd243e2$var$_typeof = $b5I6c.default;
function $8364e7caadd243e2$var$toPrimitive(t, r) {
    if ("object" != $8364e7caadd243e2$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $8364e7caadd243e2$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
module.exports = $8364e7caadd243e2$var$toPrimitive, module.exports.__esModule = true, module.exports["default"] = module.exports;

});



parcelRegister("468YR", function(module, exports) {

$parcel$export(module.exports, "useAnalyticsEvents", function () { return $2fbeb052823c6ba5$export$5bf35293e545f20c; });

var $tWuif = parcelRequire("tWuif");

var $jXjwH = parcelRequire("jXjwH");

var $hpNPc = parcelRequire("hpNPc");
function $2fbeb052823c6ba5$export$5bf35293e545f20c() {
    var analyticsContext = (0, $hpNPc.useAnalyticsContext)();
    var createAnalyticsEvent = (0, $tWuif.useCallbackOne)(function(payload) {
        return new (0, $jXjwH.default)({
            context: analyticsContext.getAtlaskitAnalyticsContext(),
            handlers: analyticsContext.getAtlaskitAnalyticsEventHandlers(),
            payload: payload
        });
    }, [
        analyticsContext
    ]);
    return {
        createAnalyticsEvent: createAnalyticsEvent
    };
}

});
parcelRegister("jXjwH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e872ac8beea73d9a$export$2e2bcd8739ae039; });

var $9OmEa = parcelRequire("9OmEa");

var $f1n9f = parcelRequire("f1n9f");

var $xz46t = parcelRequire("xz46t");

var $ek7jo = parcelRequire("ek7jo");

var $4T9ga = parcelRequire("4T9ga");

var $lLNif = parcelRequire("lLNif");

var $2OMMC = parcelRequire("2OMMC");

var $c6l2j = parcelRequire("c6l2j");

var $dDV0S = parcelRequire("dDV0S");
function $e872ac8beea73d9a$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($4T9ga)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($ek7jo)))(t, $e872ac8beea73d9a$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($4T9ga)))(t).constructor) : o.apply(t, e));
}
function $e872ac8beea73d9a$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($e872ac8beea73d9a$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $e872ac8beea73d9a$var$_superPropGet(t, o, e, r) {
    var p = (0, (/*@__PURE__*/$parcel$interopDefault($lLNif)))((0, (/*@__PURE__*/$parcel$interopDefault($4T9ga)))(1 & r ? t.prototype : t), o, e);
    return 2 & r && "function" == typeof p ? function(t) {
        return p.apply(e, t);
    } : p;
}
var $e872ac8beea73d9a$export$35f8383928ba8d7 = function isUIAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $e872ac8beea73d9a$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isUIAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === "UIAnalyticsEvent";
};
var $e872ac8beea73d9a$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_AnalyticsEvent) {
    function UIAnalyticsEvent(props) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($f1n9f)))(this, UIAnalyticsEvent);
        _this = $e872ac8beea73d9a$var$_callSuper(this, UIAnalyticsEvent, [
            props
        ]);
        (0, (/*@__PURE__*/$parcel$interopDefault($c6l2j)))(_this, "_isUIAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($c6l2j)))(_this, "clone", function() {
            if (_this.hasFired) return null;
            var context = (0, (/*@__PURE__*/$parcel$interopDefault($9OmEa)))(_this.context);
            var handlers = (0, (/*@__PURE__*/$parcel$interopDefault($9OmEa)))(_this.handlers);
            /**
       * A hacky "deep clone" of the object. This is limited in that it wont
       * support functions, regexs, Maps, Sets, etc, but none of those need to
       * be represented in our payload.
       */ var payload = JSON.parse(JSON.stringify(_this.payload));
            return new UIAnalyticsEvent({
                context: context,
                handlers: handlers,
                payload: payload
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($c6l2j)))(_this, "fire", function(channel) {
            if (_this.hasFired) return;
            _this.handlers.forEach(function(handler) {
                return handler(_this, channel);
            });
            _this.hasFired = true;
        });
        _this.context = props.context || [];
        _this.handlers = props.handlers || [];
        _this.hasFired = false;
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($2OMMC)))(UIAnalyticsEvent, _AnalyticsEvent);
    return (0, (/*@__PURE__*/$parcel$interopDefault($xz46t)))(UIAnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (this.hasFired) return this;
                return $e872ac8beea73d9a$var$_superPropGet(UIAnalyticsEvent, "update", this, 3)([
                    updater
                ]);
            }
        }
    ]);
}((0, $dDV0S.default));

});
parcelRegister("9OmEa", function(module, exports) {

var $9wB9l = parcelRequire("9wB9l");

var $45WKD = parcelRequire("45WKD");

var $lM5y5 = parcelRequire("lM5y5");

var $4Wdtz = parcelRequire("4Wdtz");
function $724a59bfea8fc9c3$var$_toConsumableArray(r) {
    return $9wB9l(r) || $45WKD(r) || $lM5y5(r) || $4Wdtz();
}
module.exports = $724a59bfea8fc9c3$var$_toConsumableArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("9wB9l", function(module, exports) {

var $9JRrN = parcelRequire("9JRrN");
function $6ef3eb5a761ddb4e$var$_arrayWithoutHoles(r) {
    if (Array.isArray(r)) return $9JRrN(r);
}
module.exports = $6ef3eb5a761ddb4e$var$_arrayWithoutHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("9JRrN", function(module, exports) {
function $7171c68ca81a80f3$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
module.exports = $7171c68ca81a80f3$var$_arrayLikeToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("45WKD", function(module, exports) {
function $2fb533d033d4e6c1$var$_iterableToArray(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
module.exports = $2fb533d033d4e6c1$var$_iterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("lM5y5", function(module, exports) {

var $9JRrN = parcelRequire("9JRrN");
function $fda26289461ff23d$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $9JRrN(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $9JRrN(r, a) : void 0;
    }
}
module.exports = $fda26289461ff23d$var$_unsupportedIterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("4Wdtz", function(module, exports) {
function $398708434bf4d654$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
module.exports = $398708434bf4d654$var$_nonIterableSpread, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("f1n9f", function(module, exports) {
function $aef8e7c0ae0ac2b8$var$_classCallCheck(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
module.exports = $aef8e7c0ae0ac2b8$var$_classCallCheck, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("xz46t", function(module, exports) {

var $2ezgC = parcelRequire("2ezgC");
function $064e4865b81b813d$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, $2ezgC(o.key), o);
    }
}
function $064e4865b81b813d$var$_createClass(e, r, t) {
    return r && $064e4865b81b813d$var$_defineProperties(e.prototype, r), t && $064e4865b81b813d$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}
module.exports = $064e4865b81b813d$var$_createClass, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("ek7jo", function(module, exports) {

var $b5I6c = parcelRequire("b5I6c");
var $a6d89aed9193732d$var$_typeof = $b5I6c.default;

var $hRmGl = parcelRequire("hRmGl");
function $a6d89aed9193732d$var$_possibleConstructorReturn(t, e) {
    if (e && ("object" == $a6d89aed9193732d$var$_typeof(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return $hRmGl(t);
}
module.exports = $a6d89aed9193732d$var$_possibleConstructorReturn, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("hRmGl", function(module, exports) {
function $d008fb1828b147e8$var$_assertThisInitialized(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}
module.exports = $d008fb1828b147e8$var$_assertThisInitialized, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("4T9ga", function(module, exports) {
function $38f37b4b1d4ff014$var$_getPrototypeOf(t) {
    return module.exports = $38f37b4b1d4ff014$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $38f37b4b1d4ff014$var$_getPrototypeOf(t);
}
module.exports = $38f37b4b1d4ff014$var$_getPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("lLNif", function(module, exports) {

var $7pvUf = parcelRequire("7pvUf");
function $fd94395cf4b78bdf$var$_get() {
    return module.exports = $fd94395cf4b78bdf$var$_get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function(e, t, r) {
        var p = $7pvUf(e, t);
        if (p) {
            var n = Object.getOwnPropertyDescriptor(p, t);
            return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value;
        }
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $fd94395cf4b78bdf$var$_get.apply(null, arguments);
}
module.exports = $fd94395cf4b78bdf$var$_get, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("7pvUf", function(module, exports) {

var $4T9ga = parcelRequire("4T9ga");
function $56539e1750c3d5cb$var$_superPropBase(t, o) {
    for(; !({}).hasOwnProperty.call(t, o) && null !== (t = $4T9ga(t)););
    return t;
}
module.exports = $56539e1750c3d5cb$var$_superPropBase, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("2OMMC", function(module, exports) {

var $9iv68 = parcelRequire("9iv68");
function $20d6179743f855e7$var$_inherits(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && $9iv68(t, e);
}
module.exports = $20d6179743f855e7$var$_inherits, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("9iv68", function(module, exports) {
function $6c4deae37b70ac33$var$_setPrototypeOf(t, e) {
    return module.exports = $6c4deae37b70ac33$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $6c4deae37b70ac33$var$_setPrototypeOf(t, e);
}
module.exports = $6c4deae37b70ac33$var$_setPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("dDV0S", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9eeb24851dc6b3e6$export$2e2bcd8739ae039; });

var $b5I6c = parcelRequire("b5I6c");

var $f1n9f = parcelRequire("f1n9f");

var $xz46t = parcelRequire("xz46t");

var $c6l2j = parcelRequire("c6l2j");
function $9eeb24851dc6b3e6$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $9eeb24851dc6b3e6$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $9eeb24851dc6b3e6$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($c6l2j)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $9eeb24851dc6b3e6$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $9eeb24851dc6b3e6$export$ad4be5c2ec28cecf = function isAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $9eeb24851dc6b3e6$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === "AnalyticsEvent";
};
var $9eeb24851dc6b3e6$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function AnalyticsEvent(props) {
        var _this = this;
        (0, (/*@__PURE__*/$parcel$interopDefault($f1n9f)))(this, AnalyticsEvent);
        (0, (/*@__PURE__*/$parcel$interopDefault($c6l2j)))(this, "_isAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($c6l2j)))(this, "clone", function() {
            // just a shallow clone, don't change sub refs unless you want to
            // affect the original's too
            var payload = $9eeb24851dc6b3e6$var$_objectSpread({}, _this.payload);
            return new AnalyticsEvent({
                payload: payload
            });
        });
        this.payload = props.payload;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($xz46t)))(AnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (typeof updater === "function") this.payload = updater(this.payload);
                if ((0, (/*@__PURE__*/$parcel$interopDefault($b5I6c)))(updater) === "object") this.payload = $9eeb24851dc6b3e6$var$_objectSpread($9eeb24851dc6b3e6$var$_objectSpread({}, this.payload), updater);
                return this;
            }
        }
    ]);
}();

});


parcelRegister("hpNPc", function(module, exports) {

$parcel$export(module.exports, "useAnalyticsContext", function () { return $cadb6b9d75287b02$export$d1f587f82ad51c4; });

var $dAx5m = parcelRequire("dAx5m");

var $h0bf1 = parcelRequire("h0bf1");
var $cadb6b9d75287b02$export$d1f587f82ad51c4 = function useAnalyticsContext() {
    return (0, $dAx5m.useContext)((0, $h0bf1.default));
};

});


parcelRegister("jEB3A", function(module, exports) {

$parcel$export(module.exports, "useTrackedRef", function () { return $e4ee7f7c520ef479$export$1d27a74659855e44; });

var $dAx5m = parcelRequire("dAx5m");
var $e4ee7f7c520ef479$export$1d27a74659855e44 = function useTrackedRef(value) {
    var ref = (0, $dAx5m.useRef)(value);
    ref.current = value;
    return ref;
};

});


parcelRegister("jl49R", function(module, exports) {

$parcel$export(module.exports, "LevelContext", function () { return $e143342b27246164$export$650d12d3c2ddb8fc; });
$parcel$export(module.exports, "TopLevelContext", function () { return $e143342b27246164$export$48b383b280e20440; });
$parcel$export(module.exports, "Layering", function () { return $e143342b27246164$export$7c885f891c940977; });

var $dAx5m = parcelRequire("dAx5m");

var $bJzW6 = parcelRequire("bJzW6");

var $18rB9 = parcelRequire("18rB9");
var $e143342b27246164$export$650d12d3c2ddb8fc = /*#__PURE__*/ (0, $dAx5m.createContext)(0);
var $e143342b27246164$export$48b383b280e20440 = /*#__PURE__*/ (0, $dAx5m.createContext)({
    topLevelRef: {
        current: null
    },
    setTopLevel: (0, $bJzW6.default)
});
/**
 *
 *  @internal
 * Context Provider Component which provider the current level of nested layers
 * It handles level management when it mounts and unmounts
 *
 */ var $e143342b27246164$var$LevelProvider = function LevelProvider(_ref) {
    var children = _ref.children, currentLevel = _ref.currentLevel;
    var _useContext = (0, $dAx5m.useContext)($e143342b27246164$export$48b383b280e20440), setTopLevel = _useContext.setTopLevel, topLevelRef = _useContext.topLevelRef;
    if (!(0, $18rB9.fg)("plan_timeline_layering_wrapper")) {
        if (topLevelRef.current === null || currentLevel > topLevelRef.current) setTopLevel(currentLevel);
    }
    (0, $dAx5m.useEffect)(function() {
        if ((0, $18rB9.fg)("plan_timeline_layering_wrapper")) {
            if (topLevelRef.current === null || currentLevel > topLevelRef.current) setTopLevel(currentLevel);
        }
        return function() {
            if ((0, $18rB9.fg)("plan_timeline_layering_wrapper")) setTopLevel(currentLevel - 1);
            else // avoid immediate cleanup using setTimeout when component unmount
            // this will make sure non-top layer components can get the correct top level value
            // when multiple layers trigger onClose in sequence
            setTimeout(function() {
                setTopLevel(currentLevel - 1);
            }, 0);
        };
    }, [
        setTopLevel,
        currentLevel,
        topLevelRef
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement($e143342b27246164$export$650d12d3c2ddb8fc.Provider, {
        value: currentLevel
    }, children);
};
/**
 *
 *  @internal
 * Context Provider Component which provides the top level of all nested layers
 * It provides initial top level ref value as 0 and set top level method
 *
 */ var $e143342b27246164$var$LayeringProvider = function LayeringProvider(_ref2) {
    var children = _ref2.children;
    var topLevelRef = (0, $dAx5m.useRef)(0);
    var value = (0, $dAx5m.useMemo)(function() {
        return {
            topLevelRef: topLevelRef,
            setTopLevel: function setTopLevel(level) {
                topLevelRef.current = level;
            }
        };
    }, [
        topLevelRef
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement($e143342b27246164$export$48b383b280e20440.Provider, {
        value: value
    }, children);
};
var $e143342b27246164$export$7c885f891c940977 = function Layering(_ref3) {
    var children = _ref3.children, _ref3$isDisabled = _ref3.isDisabled, isDisabled = _ref3$isDisabled === void 0 ? true : _ref3$isDisabled;
    var currentLevel = (0, $dAx5m.useContext)($e143342b27246164$export$650d12d3c2ddb8fc);
    if (isDisabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).Fragment, null, children);
    var isNested = currentLevel > 0;
    var content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement($e143342b27246164$var$LevelProvider, {
        currentLevel: currentLevel + 1
    }, children);
    return isNested ? content : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement($e143342b27246164$var$LayeringProvider, null, content);
};

});
parcelRegister("bJzW6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $88afc5d89d828ff3$export$2e2bcd8739ae039; });
/**
 * An empty function which does nothing.
 */ // eslint-disable-next-line @repo/internal/react/use-noop
function $88afc5d89d828ff3$export$2e2bcd8739ae039() {}

});

parcelRegister("18rB9", function(module, exports) {

$parcel$export(module.exports, "fg", function () { return $0d3bf23b3efcb875$export$b40ec24ac8275656; });

var $8XitB = parcelRequire("8XitB");
function $0d3bf23b3efcb875$export$ba05d765b8392e5e(flagResolver) {
    (0, $8XitB.setBooleanResolver)(flagResolver);
}
function $0d3bf23b3efcb875$export$470e5c2be1411c89(name) {
    return (0, $8XitB.resolveBooleanFlag)(name);
}
function $0d3bf23b3efcb875$export$b40ec24ac8275656(name) {
    return (0, $8XitB.resolveBooleanFlag)(name);
}

});
parcelRegister("8XitB", function(module, exports) {

$parcel$export(module.exports, "setBooleanResolver", function () { return $68522a7992e8e2b3$export$f2b591175b3e424c; });
$parcel$export(module.exports, "resolveBooleanFlag", function () { return $68522a7992e8e2b3$export$6333b6aff9fc6275; });

var $4ydi2 = parcelRequire("4ydi2");

var $eA7oY = parcelRequire("eA7oY");

var $ahJoN = parcelRequire("ahJoN");
var $68522a7992e8e2b3$var$pkgName = "@atlaskit/platform-feature-flags";
var $68522a7992e8e2b3$export$7e41b1b2bdee3f98 = "__PLATFORM_FEATURE_FLAGS__";
var $68522a7992e8e2b3$var$hasProcessEnv = typeof $ahJoN !== "undefined" && typeof $ahJoN.env !== "undefined";
// FF global overrides can be configured by test runners or Storybook
var $68522a7992e8e2b3$var$ENV_ENABLE_PLATFORM_FF = $68522a7992e8e2b3$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
// STORYBOOK_ENABLE_PLATFORM_FF is included as storybook only allows env vars prefixed with STORYBOOK
// https://github.com/storybookjs/storybook/issues/12270
var $68522a7992e8e2b3$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF = $68522a7992e8e2b3$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
var $68522a7992e8e2b3$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE = $68522a7992e8e2b3$var$ENV_ENABLE_PLATFORM_FF || $68522a7992e8e2b3$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF;
var $68522a7992e8e2b3$var$DEFAULT_PFF_GLOBAL = {
    booleanResolver: undefined
};
var $68522a7992e8e2b3$var$globalVar = typeof window !== "undefined" ? window : globalThis;
$68522a7992e8e2b3$var$globalVar[$68522a7992e8e2b3$export$7e41b1b2bdee3f98] = $68522a7992e8e2b3$var$globalVar[$68522a7992e8e2b3$export$7e41b1b2bdee3f98] || $68522a7992e8e2b3$var$DEFAULT_PFF_GLOBAL;
function $68522a7992e8e2b3$export$f2b591175b3e424c(resolver) {
    $68522a7992e8e2b3$var$globalVar[$68522a7992e8e2b3$export$7e41b1b2bdee3f98].booleanResolver = resolver;
}
function $68522a7992e8e2b3$export$6333b6aff9fc6275(flagKey) {
    if ($68522a7992e8e2b3$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE) {
        (0, $eA7oY.debug)('[%s]: The feature flags were enabled while running tests. The flag "%s" will be always enabled.', $68522a7992e8e2b3$var$pkgName, flagKey);
        return true;
    }
    try {
        var _globalVar$PFF_GLOBAL, _globalVar$PFF_GLOBAL2, _globalVar$PFF_GLOBAL3;
        // booleanResolver will be empty for products like Trello, Elevate, Recruit etc.
        // Currently only Confluence, Jira and Bitbucket has set it.
        if (((_globalVar$PFF_GLOBAL = $68522a7992e8e2b3$var$globalVar[$68522a7992e8e2b3$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL === void 0 ? void 0 : _globalVar$PFF_GLOBAL.booleanResolver) === undefined || ((_globalVar$PFF_GLOBAL2 = $68522a7992e8e2b3$var$globalVar[$68522a7992e8e2b3$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL2 === void 0 ? void 0 : _globalVar$PFF_GLOBAL2.booleanResolver) === null) // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
        return (0, $4ydi2.default).checkGate(flagKey);
        var result = (_globalVar$PFF_GLOBAL3 = $68522a7992e8e2b3$var$globalVar[$68522a7992e8e2b3$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL3 === void 0 ? void 0 : _globalVar$PFF_GLOBAL3.booleanResolver(flagKey);
        if (typeof result !== "boolean") {
            // eslint-disable-next-line no-console
            console.warn("".concat(flagKey, " resolved to a non-boolean value, returning false for safety"));
            return false;
        }
        return result;
    } catch (e) {
        return false;
    }
}

});
parcelRegister("4ydi2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3504a58007a99d18$export$2e2bcd8739ae039; });

var $htuO4 = parcelRequire("htuO4");

var $2Bhkc = parcelRequire("2Bhkc");

var $cIF9u = parcelRequire("cIF9u");

var $dyvQM = parcelRequire("dyvQM");

var $fetJQ = parcelRequire("fetJQ");



var $3504a58007a99d18$var$_FeatureGates;
/**
 * Access the FeatureGates object via the default export.
 * ```ts
 * import FeatureGates from '@atlaskit/feature-gate-js-client';
 * ```
 */ var $3504a58007a99d18$var$FeatureGates = /*#__PURE__*/ function() {
    function FeatureGates() {
        (0, (/*@__PURE__*/$parcel$interopDefault($htuO4)))(this, FeatureGates);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($2Bhkc)))(FeatureGates, null, [
        {
            key: "isGateExists",
            value: function isGateExists(gateName) {
                return this.client.isGateExist(gateName);
            }
        },
        {
            key: "isExperimentExists",
            value: function isExperimentExists(experimentName) {
                return this.client.isExperimentExist(experimentName);
            }
        }
    ]);
}();
$3504a58007a99d18$var$_FeatureGates = $3504a58007a99d18$var$FeatureGates;
(0, (/*@__PURE__*/$parcel$interopDefault($cIF9u)))($3504a58007a99d18$var$FeatureGates, "client", new (0, $dyvQM.Client)());
(0, (/*@__PURE__*/$parcel$interopDefault($cIF9u)))($3504a58007a99d18$var$FeatureGates, "hasCheckGateErrorOccurred", false);
(0, (/*@__PURE__*/$parcel$interopDefault($cIF9u)))($3504a58007a99d18$var$FeatureGates, "hasGetExperimentValueErrorOccurred", false);
(0, (/*@__PURE__*/$parcel$interopDefault($cIF9u)))($3504a58007a99d18$var$FeatureGates, "checkGate", function(gateName, options) {
    try {
        // Check if the CRITERION override mechanism is available
        if (window && window.__CRITERION__ && typeof window.__CRITERION__.getFeatureFlagOverride === "function") {
            // Attempt to retrieve an override value for the feature gate
            var overrideValue = window.__CRITERION__.getFeatureFlagOverride(gateName);
            // If an override value is found, return it immediately
            if (overrideValue !== undefined) return overrideValue;
        }
    } catch (error) {
        // Log the first occurrence of the error
        if (!$3504a58007a99d18$var$_FeatureGates.hasCheckGateErrorOccurred) {
            // eslint-disable-next-line no-console
            console.warn({
                msg: "An error has occurred checking the feature gate from criterion override. Only the first occurrence of this error is logged.",
                gateName: gateName,
                error: error
            });
            $3504a58007a99d18$var$_FeatureGates.hasCheckGateErrorOccurred = true;
        }
    }
    // Proceed with the main logic if no override is found
    return $3504a58007a99d18$var$_FeatureGates.client.checkGate(gateName, options);
});
(0, (/*@__PURE__*/$parcel$interopDefault($cIF9u)))($3504a58007a99d18$var$FeatureGates, "getExperimentValue", function(experimentName, parameterName, defaultValue, options) {
    try {
        // Check if the CRITERION override mechanism is available
        if (typeof window !== "undefined" && window.__CRITERION__ && typeof window.__CRITERION__.getExperimentValueOverride === "function") {
            var overrideValue = window.__CRITERION__.getExperimentValueOverride(experimentName, parameterName);
            if (overrideValue !== undefined && overrideValue !== null) return overrideValue;
        }
    } catch (error) {
        // Log the first occurrence of the error
        if (!$3504a58007a99d18$var$_FeatureGates.hasGetExperimentValueErrorOccurred) {
            // eslint-disable-next-line no-console
            console.warn({
                msg: "An error has occurred getting the experiment value from criterion override. Only the first occurrence of this error is logged.",
                experimentName: experimentName,
                defaultValue: defaultValue,
                options: options,
                error: error
            });
            $3504a58007a99d18$var$_FeatureGates.hasGetExperimentValueErrorOccurred = true;
        }
        return defaultValue;
    }
    // Proceed with the main logic if no override is found
    return $3504a58007a99d18$var$_FeatureGates.client.getExperimentValue(experimentName, parameterName, defaultValue, options);
});
(0, (/*@__PURE__*/$parcel$interopDefault($cIF9u)))($3504a58007a99d18$var$FeatureGates, "initializeCalled", $3504a58007a99d18$var$_FeatureGates.client.initializeCalled.bind($3504a58007a99d18$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($cIF9u)))($3504a58007a99d18$var$FeatureGates, "initializeCompleted", $3504a58007a99d18$var$_FeatureGates.client.initializeCompleted.bind($3504a58007a99d18$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($cIF9u)))($3504a58007a99d18$var$FeatureGates, "initialize", $3504a58007a99d18$var$_FeatureGates.client.initialize.bind($3504a58007a99d18$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($cIF9u)))($3504a58007a99d18$var$FeatureGates, "initializeWithProvider", $3504a58007a99d18$var$_FeatureGates.client.initializeWithProvider.bind($3504a58007a99d18$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($cIF9u)))($3504a58007a99d18$var$FeatureGates, "initializeFromValues", $3504a58007a99d18$var$_FeatureGates.client.initializeFromValues.bind($3504a58007a99d18$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($cIF9u)))($3504a58007a99d18$var$FeatureGates, "manuallyLogGateExposure", $3504a58007a99d18$var$_FeatureGates.client.manuallyLogGateExposure.bind($3504a58007a99d18$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($cIF9u)))($3504a58007a99d18$var$FeatureGates, "getExperiment", $3504a58007a99d18$var$_FeatureGates.client.getExperiment.bind($3504a58007a99d18$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($cIF9u)))($3504a58007a99d18$var$FeatureGates, "manuallyLogExperimentExposure", $3504a58007a99d18$var$_FeatureGates.client.manuallyLogExperimentExposure.bind($3504a58007a99d18$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($cIF9u)))($3504a58007a99d18$var$FeatureGates, "manuallyLogLayerExposure", $3504a58007a99d18$var$_FeatureGates.client.manuallyLogLayerExposure.bind($3504a58007a99d18$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($cIF9u)))($3504a58007a99d18$var$FeatureGates, "shutdownStatsig", $3504a58007a99d18$var$_FeatureGates.client.shutdownStatsig.bind($3504a58007a99d18$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($cIF9u)))($3504a58007a99d18$var$FeatureGates, "overrideGate", $3504a58007a99d18$var$_FeatureGates.client.overrideGate.bind($3504a58007a99d18$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($cIF9u)))($3504a58007a99d18$var$FeatureGates, "clearGateOverride", $3504a58007a99d18$var$_FeatureGates.client.clearGateOverride.bind($3504a58007a99d18$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($cIF9u)))($3504a58007a99d18$var$FeatureGates, "overrideConfig", $3504a58007a99d18$var$_FeatureGates.client.overrideConfig.bind($3504a58007a99d18$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($cIF9u)))($3504a58007a99d18$var$FeatureGates, "clearConfigOverride", $3504a58007a99d18$var$_FeatureGates.client.clearConfigOverride.bind($3504a58007a99d18$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($cIF9u)))($3504a58007a99d18$var$FeatureGates, "setOverrides", $3504a58007a99d18$var$_FeatureGates.client.setOverrides.bind($3504a58007a99d18$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($cIF9u)))($3504a58007a99d18$var$FeatureGates, "getOverrides", $3504a58007a99d18$var$_FeatureGates.client.getOverrides.bind($3504a58007a99d18$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($cIF9u)))($3504a58007a99d18$var$FeatureGates, "clearAllOverrides", $3504a58007a99d18$var$_FeatureGates.client.clearAllOverrides.bind($3504a58007a99d18$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($cIF9u)))($3504a58007a99d18$var$FeatureGates, "isCurrentUser", $3504a58007a99d18$var$_FeatureGates.client.isCurrentUser.bind($3504a58007a99d18$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($cIF9u)))($3504a58007a99d18$var$FeatureGates, "onGateUpdated", $3504a58007a99d18$var$_FeatureGates.client.onGateUpdated.bind($3504a58007a99d18$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($cIF9u)))($3504a58007a99d18$var$FeatureGates, "onExperimentValueUpdated", $3504a58007a99d18$var$_FeatureGates.client.onExperimentValueUpdated.bind($3504a58007a99d18$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($cIF9u)))($3504a58007a99d18$var$FeatureGates, "onAnyUpdated", $3504a58007a99d18$var$_FeatureGates.client.onAnyUpdated.bind($3504a58007a99d18$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($cIF9u)))($3504a58007a99d18$var$FeatureGates, "updateUser", $3504a58007a99d18$var$_FeatureGates.client.updateUser.bind($3504a58007a99d18$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($cIF9u)))($3504a58007a99d18$var$FeatureGates, "updateUserWithProvider", $3504a58007a99d18$var$_FeatureGates.client.updateUserWithProvider.bind($3504a58007a99d18$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($cIF9u)))($3504a58007a99d18$var$FeatureGates, "updateUserWithValues", $3504a58007a99d18$var$_FeatureGates.client.updateUserWithValues.bind($3504a58007a99d18$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($cIF9u)))($3504a58007a99d18$var$FeatureGates, "getPackageVersion", $3504a58007a99d18$var$_FeatureGates.client.getPackageVersion.bind($3504a58007a99d18$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($cIF9u)))($3504a58007a99d18$var$FeatureGates, "getLayer", $3504a58007a99d18$var$_FeatureGates.client.getLayer.bind($3504a58007a99d18$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($cIF9u)))($3504a58007a99d18$var$FeatureGates, "getLayerValue", $3504a58007a99d18$var$_FeatureGates.client.getLayerValue.bind($3504a58007a99d18$var$_FeatureGates.client));
var $3504a58007a99d18$var$boundFGJS = $3504a58007a99d18$var$FeatureGates;
// This makes it possible to get a reference to the FeatureGates client at runtime.
// This is important for overriding values in Cypress tests, as there needs to be a
// way to get the exact instance for a window in order to mock some of its methods.
if (typeof window !== "undefined") {
    if (window.__FEATUREGATES_JS__ === undefined) window.__FEATUREGATES_JS__ = $3504a58007a99d18$var$FeatureGates;
    else {
        var $3504a58007a99d18$var$_boundFGJS, $3504a58007a99d18$var$_boundFGJS$getPackage;
        $3504a58007a99d18$var$boundFGJS = window.__FEATUREGATES_JS__;
        var $3504a58007a99d18$var$boundVersion = (($3504a58007a99d18$var$_boundFGJS = $3504a58007a99d18$var$boundFGJS) === null || $3504a58007a99d18$var$_boundFGJS === void 0 || ($3504a58007a99d18$var$_boundFGJS$getPackage = $3504a58007a99d18$var$_boundFGJS.getPackageVersion) === null || $3504a58007a99d18$var$_boundFGJS$getPackage === void 0 ? void 0 : $3504a58007a99d18$var$_boundFGJS$getPackage.call($3504a58007a99d18$var$_boundFGJS)) || "4.10.0 or earlier";
        if ($3504a58007a99d18$var$boundVersion !== (0, $fetJQ.CLIENT_VERSION)) {
            var $3504a58007a99d18$var$message = "Multiple versions of FeatureGateClients found on the current page.\n      The currently bound version is ".concat($3504a58007a99d18$var$boundVersion, " when module version ").concat((0, $fetJQ.CLIENT_VERSION), " was loading.");
            // eslint-disable-next-line no-console
            console.warn($3504a58007a99d18$var$message);
        }
    }
}
var /**
 * @property {FeatureGates} FeatureGate default export
 */ $3504a58007a99d18$export$2e2bcd8739ae039 = $3504a58007a99d18$var$boundFGJS;

});
parcelRegister("htuO4", function(module, exports) {
function $cb8d0aa1f2d7fca9$var$_classCallCheck(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
module.exports = $cb8d0aa1f2d7fca9$var$_classCallCheck, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("2Bhkc", function(module, exports) {

var $jgwnC = parcelRequire("jgwnC");
function $1e4c79d0f87d43c8$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, $jgwnC(o.key), o);
    }
}
function $1e4c79d0f87d43c8$var$_createClass(e, r, t) {
    return r && $1e4c79d0f87d43c8$var$_defineProperties(e.prototype, r), t && $1e4c79d0f87d43c8$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}
module.exports = $1e4c79d0f87d43c8$var$_createClass, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("jgwnC", function(module, exports) {

var $4tNfC = parcelRequire("4tNfC");
var $e068a0f2e2ec2ac6$var$_typeof = $4tNfC.default;

var $37bgC = parcelRequire("37bgC");
function $e068a0f2e2ec2ac6$var$toPropertyKey(t) {
    var i = $37bgC(t, "string");
    return "symbol" == $e068a0f2e2ec2ac6$var$_typeof(i) ? i : i + "";
}
module.exports = $e068a0f2e2ec2ac6$var$toPropertyKey, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("4tNfC", function(module, exports) {
function $3430130baae28efa$var$_typeof(o) {
    "@babel/helpers - typeof";
    return module.exports = $3430130baae28efa$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $3430130baae28efa$var$_typeof(o);
}
module.exports = $3430130baae28efa$var$_typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("37bgC", function(module, exports) {

var $4tNfC = parcelRequire("4tNfC");
var $244ac3f339b024cb$var$_typeof = $4tNfC.default;
function $244ac3f339b024cb$var$toPrimitive(t, r) {
    if ("object" != $244ac3f339b024cb$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $244ac3f339b024cb$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
module.exports = $244ac3f339b024cb$var$toPrimitive, module.exports.__esModule = true, module.exports["default"] = module.exports;

});



parcelRegister("cIF9u", function(module, exports) {

var $jgwnC = parcelRequire("jgwnC");
function $9429840b808af067$var$_defineProperty(e, r, t) {
    return (r = $jgwnC(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
module.exports = $9429840b808af067$var$_defineProperty, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("dyvQM", function(module, exports) {

$parcel$export(module.exports, "Client", function () { return $9de7282662b8efcc$export$1f2bb630327ac4b6; });

var $1sfUu = parcelRequire("1sfUu");

var $ityw2 = parcelRequire("ityw2");

var $lR5PM = parcelRequire("lR5PM");

var $htuO4 = parcelRequire("htuO4");

var $2Bhkc = parcelRequire("2Bhkc");

var $cIF9u = parcelRequire("cIF9u");

var $4G35a = parcelRequire("4G35a");

var $e2ZOQ = parcelRequire("e2ZOQ");

var $lEz0s = parcelRequire("lEz0s");

var $d6BRT = parcelRequire("d6BRT");

var $2FkTo = parcelRequire("2FkTo");

var $i9yc8 = parcelRequire("i9yc8");

var $2GOQ3 = parcelRequire("2GOQ3");

var $ks3Iz = parcelRequire("ks3Iz");

var $i7s0Q = parcelRequire("i7s0Q");

var $145CT = parcelRequire("145CT");

var $65XfA = parcelRequire("65XfA");

var $fetJQ = parcelRequire("fetJQ");
var $9de7282662b8efcc$var$_excluded = [
    "sdkKey",
    "environment",
    "updateUserCompletionCallback",
    "perimeter"
];
function $9de7282662b8efcc$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $9de7282662b8efcc$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $9de7282662b8efcc$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($cIF9u)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $9de7282662b8efcc$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $9de7282662b8efcc$var$DEFAULT_CLIENT_KEY = "client-default-key";
// default event logging api is Atlassian proxy rather than Statsig's domain, to avoid ad blockers
var $9de7282662b8efcc$var$DEFAULT_EVENT_LOGGING_API = "https://xp.atlassian.com/v1/rgstr";
var $9de7282662b8efcc$export$1f2bb630327ac4b6 = /*#__PURE__*/ function() {
    function Client() {
        var _this = this;
        (0, (/*@__PURE__*/$parcel$interopDefault($htuO4)))(this, Client);
        (0, (/*@__PURE__*/$parcel$interopDefault($cIF9u)))(this, "initPromise", null);
        /** True if an initialize method was called and completed successfully. */ (0, (/*@__PURE__*/$parcel$interopDefault($cIF9u)))(this, "initCompleted", false);
        /**
     * True if an initialize method was called and completed, meaning the client is now usable.
     * However if there was an error during initialization it may have initialized with default
     * values. Use {@link initCompleted} to check for this.
     */ (0, (/*@__PURE__*/$parcel$interopDefault($cIF9u)))(this, "initWithDefaults", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($cIF9u)))(this, "hasCheckGateErrorOccurred", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($cIF9u)))(this, "hasGetExperimentErrorOccurred", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($cIF9u)))(this, "hasGetExperimentValueErrorOccurred", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($cIF9u)))(this, "hasGetLayerErrorOccurred", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($cIF9u)))(this, "hasGetLayerValueErrorOccurred", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($cIF9u)))(this, "subscriptions", new (0, $lEz0s.default)());
        (0, (/*@__PURE__*/$parcel$interopDefault($cIF9u)))(this, "dataAdapter", new (0, $ks3Iz.NoFetchDataAdapter)());
        (0, (/*@__PURE__*/$parcel$interopDefault($cIF9u)))(this, "overrideAdapter", new (0, $i7s0Q.PersistentOverrideAdapter)());
        /**
     * Call this if modifying the values being served by the Statsig library since it has its own
     * memoization cache which will not be updated if the values are changed outside of the library.
     */ (0, (/*@__PURE__*/$parcel$interopDefault($cIF9u)))(this, "statsigValuesUpdated", function() {
            if (_this.user) // Trigger a reset of the memoize cache
            _this.statsigClient.updateUserSync(_this.user, {
                disableBackgroundCacheRefresh: true
            });
            _this.subscriptions.anyUpdated();
        });
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($2Bhkc)))(Client, [
        {
            key: "initialize",
            value: /**
     * @description
     * This method initializes the client using a network call to fetch the bootstrap values.
     * If the client is inialized with an `analyticsWebClient`, it will send an operational event
     * to GASv3 with the following attributes:
     * - targetApp: the target app of the client
     * - clientVersion: the version of the client
     * - success: whether the initialization was successful
     * - startTime: the time when the initialization started
     * - totalTime: the total time it took to initialize the client
     * - apiKey: the api key used to initialize the client
     * @param clientOptions {ClientOptions}
     * @param identifiers {Identifiers}
     * @param customAttributes {CustomAttributes}
     * @returns {Promise<void>}
     */ function() {
                var _initialize = (0, (/*@__PURE__*/$parcel$interopDefault($lR5PM)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4G35a))).mark(function _callee(clientOptions, identifiers, customAttributes) {
                    var _this2 = this;
                    var clientOptionsWithDefaults, startTime;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($4G35a))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                clientOptionsWithDefaults = (0, $65XfA.getOptionsWithDefaults)(clientOptions);
                                if (!this.initPromise) {
                                    _context.next = 4;
                                    break;
                                }
                                if (!(0, $65XfA.shallowEquals)(clientOptionsWithDefaults, this.initOptions)) // eslint-disable-next-line no-console
                                console.warn("Feature Gates client already initialized with different options. New options were not applied.");
                                return _context.abrupt("return", this.initPromise);
                            case 4:
                                startTime = performance.now();
                                this.initOptions = clientOptionsWithDefaults;
                                this.initPromise = this.init(clientOptionsWithDefaults, identifiers, customAttributes).then(function() {
                                    _this2.initCompleted = true;
                                    _this2.initWithDefaults = true;
                                }).finally(function() {
                                    var endTime = performance.now();
                                    var totalTime = endTime - startTime;
                                    _this2.fireClientEvent(startTime, totalTime, "initialize", _this2.initCompleted, clientOptionsWithDefaults.apiKey);
                                });
                                return _context.abrupt("return", this.initPromise);
                            case 8:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this);
                }));
                function initialize(_x, _x2, _x3) {
                    return _initialize.apply(this, arguments);
                }
                return initialize;
            }()
        },
        {
            key: "initializeWithProvider",
            value: function() {
                var _initializeWithProvider = (0, (/*@__PURE__*/$parcel$interopDefault($lR5PM)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4G35a))).mark(function _callee2(clientOptions, provider, identifiers, customAttributes) {
                    var _this3 = this;
                    var clientOptionsWithDefaults, startTime;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($4G35a))).wrap(function _callee2$(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                clientOptionsWithDefaults = (0, $65XfA.getOptionsWithDefaults)(clientOptions);
                                if (!this.initPromise) {
                                    _context2.next = 4;
                                    break;
                                }
                                if (!(0, $65XfA.shallowEquals)(clientOptionsWithDefaults, this.initOptions)) // eslint-disable-next-line no-console
                                console.warn("Feature Gates client already initialized with different options. New options were not applied.");
                                return _context2.abrupt("return", this.initPromise);
                            case 4:
                                startTime = performance.now();
                                this.initOptions = clientOptionsWithDefaults;
                                this.provider = provider;
                                this.provider.setClientVersion((0, $fetJQ.CLIENT_VERSION));
                                if (this.provider.setApplyUpdateCallback) this.provider.setApplyUpdateCallback(this.applyUpdateCallback);
                                this.initPromise = this.initWithProvider(clientOptionsWithDefaults, provider, identifiers, customAttributes).then(function() {
                                    _this3.initCompleted = true;
                                    _this3.initWithDefaults = true;
                                }).finally(function() {
                                    var endTime = performance.now();
                                    var totalTime = endTime - startTime;
                                    _this3.fireClientEvent(startTime, totalTime, "initializeWithProvider", _this3.initCompleted, provider.getApiKey ? provider.getApiKey() : undefined);
                                });
                                return _context2.abrupt("return", this.initPromise);
                            case 11:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this);
                }));
                function initializeWithProvider(_x4, _x5, _x6, _x7) {
                    return _initializeWithProvider.apply(this, arguments);
                }
                return initializeWithProvider;
            }()
        },
        {
            key: "applyUpdateCallback",
            value: function applyUpdateCallback(experimentsResult) {
                try {
                    if (this.initCompleted || this.initWithDefaults) {
                        this.assertInitialized(this.statsigClient);
                        this.dataAdapter.setBootstrapData(experimentsResult.experimentValues);
                        this.dataAdapter.setData(JSON.stringify(experimentsResult.experimentValues));
                        this.statsigValuesUpdated();
                    }
                } catch (error) {
                    // eslint-disable-next-line no-console
                    console.warn("Error when attempting to apply update", error);
                }
            }
        },
        {
            key: "fireClientEvent",
            value: function fireClientEvent(startTime, totalTime, action, success) {
                var _analyticsWebClient, _this4 = this;
                var apiKey = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
                (_analyticsWebClient = this.initOptions.analyticsWebClient) === null || _analyticsWebClient === void 0 || _analyticsWebClient.then(function(analyticsWebClient) {
                    var attributes = $9de7282662b8efcc$var$_objectSpread({
                        targetApp: _this4.initOptions.targetApp,
                        clientVersion: (0, $fetJQ.CLIENT_VERSION),
                        success: success,
                        startTime: startTime,
                        totalTime: totalTime
                    }, apiKey && {
                        apiKey: apiKey
                    });
                    analyticsWebClient.sendOperationalEvent({
                        action: action,
                        actionSubject: "featureGatesClient",
                        attributes: attributes,
                        tags: [
                            "measurement"
                        ],
                        source: "@atlaskit/feature-gate-js-client"
                    });
                }).catch(function(err) {
                    if (_this4.initOptions.environment !== (0, $145CT.FeatureGateEnvironment).Production) // eslint-disable-next-line no-console
                    console.error("Analytics web client promise did not resolve", err);
                });
            }
        },
        {
            key: "initializeFromValues",
            value: function() {
                var _initializeFromValues = (0, (/*@__PURE__*/$parcel$interopDefault($lR5PM)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4G35a))).mark(function _callee3(clientOptions, identifiers, customAttributes) {
                    var _this5 = this;
                    var initializeValues, clientOptionsWithDefaults, startTime, _args3 = arguments;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($4G35a))).wrap(function _callee3$(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                initializeValues = _args3.length > 3 && _args3[3] !== undefined ? _args3[3] : {};
                                clientOptionsWithDefaults = (0, $65XfA.getOptionsWithDefaults)(clientOptions);
                                if (!this.initPromise) {
                                    _context3.next = 5;
                                    break;
                                }
                                if (!(0, $65XfA.shallowEquals)(clientOptionsWithDefaults, this.initOptions)) // eslint-disable-next-line no-console
                                console.warn("Feature Gates client already initialized with different options. New options were not applied.");
                                return _context3.abrupt("return", this.initPromise);
                            case 5:
                                // This makes sure the new Statsig client behaves like the old when bootstrap data is
                                // passed, and `has_updates` isn't specified (which happens a lot in product integration tests).
                                if (!Object.prototype.hasOwnProperty.call(initializeValues, "has_updates")) initializeValues["has_updates"] = true;
                                startTime = performance.now();
                                this.initOptions = clientOptionsWithDefaults;
                                this.initPromise = this.initFromValues(clientOptionsWithDefaults, identifiers, customAttributes, initializeValues).then(function() {
                                    _this5.initCompleted = true;
                                    _this5.initWithDefaults = true;
                                }).finally(function() {
                                    var endTime = performance.now();
                                    var totalTime = endTime - startTime;
                                    _this5.fireClientEvent(startTime, totalTime, "initializeFromValues", _this5.initCompleted);
                                });
                                return _context3.abrupt("return", this.initPromise);
                            case 10:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3, this);
                }));
                function initializeFromValues(_x8, _x9, _x10) {
                    return _initializeFromValues.apply(this, arguments);
                }
                return initializeFromValues;
            }()
        },
        {
            key: "assertInitialized",
            value: function assertInitialized(statsigClient) {
                if (!statsigClient) throw new Error("Client must be initialized before using this method");
            }
        },
        {
            key: "updateUser",
            value: function() {
                var _updateUser = (0, (/*@__PURE__*/$parcel$interopDefault($lR5PM)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4G35a))).mark(function _callee4(fetchOptions, identifiers, customAttributes) {
                    var fetchOptionsWithDefaults, initializeValuesProducer;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($4G35a))).wrap(function _callee4$(_context4) {
                        while(true)switch(_context4.prev = _context4.next){
                            case 0:
                                this.assertInitialized(this.statsigClient);
                                fetchOptionsWithDefaults = (0, $65XfA.getOptionsWithDefaults)(fetchOptions);
                                initializeValuesProducer = function initializeValuesProducer() {
                                    return (0, $2GOQ3.default).fetchExperimentValues(fetchOptionsWithDefaults, identifiers, customAttributes).then(function(_ref) {
                                        var experimentValues = _ref.experimentValues, customAttributes = _ref.customAttributes;
                                        return {
                                            experimentValues: experimentValues,
                                            customAttributesFromFetch: customAttributes
                                        };
                                    });
                                };
                                _context4.next = 5;
                                return this.updateUserUsingInitializeValuesProducer(initializeValuesProducer, identifiers, customAttributes);
                            case 5:
                            case "end":
                                return _context4.stop();
                        }
                    }, _callee4, this);
                }));
                function updateUser(_x11, _x12, _x13) {
                    return _updateUser.apply(this, arguments);
                }
                return updateUser;
            }()
        },
        {
            key: "updateUserWithProvider",
            value: function() {
                var _updateUserWithProvider = (0, (/*@__PURE__*/$parcel$interopDefault($lR5PM)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4G35a))).mark(function _callee5(identifiers, customAttributes) {
                    var _this6 = this;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($4G35a))).wrap(function _callee5$(_context5) {
                        while(true)switch(_context5.prev = _context5.next){
                            case 0:
                                this.assertInitialized(this.statsigClient);
                                if (this.provider) {
                                    _context5.next = 3;
                                    break;
                                }
                                throw new Error("Cannot update user using provider as the client was not initialised with a provider");
                            case 3:
                                _context5.next = 5;
                                return this.provider.setProfile(this.initOptions, identifiers, customAttributes);
                            case 5:
                                _context5.next = 7;
                                return this.updateUserUsingInitializeValuesProducer(function() {
                                    return _this6.provider.getExperimentValues();
                                }, identifiers, customAttributes);
                            case 7:
                            case "end":
                                return _context5.stop();
                        }
                    }, _callee5, this);
                }));
                function updateUserWithProvider(_x14, _x15) {
                    return _updateUserWithProvider.apply(this, arguments);
                }
                return updateUserWithProvider;
            }()
        },
        {
            key: "updateUserWithValues",
            value: function() {
                var _updateUserWithValues = (0, (/*@__PURE__*/$parcel$interopDefault($lR5PM)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4G35a))).mark(function _callee6(identifiers, customAttributes) {
                    var initializeValues, initializeValuesProducer, _args6 = arguments;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($4G35a))).wrap(function _callee6$(_context6) {
                        while(true)switch(_context6.prev = _context6.next){
                            case 0:
                                initializeValues = _args6.length > 2 && _args6[2] !== undefined ? _args6[2] : {};
                                this.assertInitialized(this.statsigClient);
                                initializeValuesProducer = function initializeValuesProducer() {
                                    return Promise.resolve({
                                        experimentValues: initializeValues,
                                        customAttributesFromFetch: customAttributes
                                    });
                                };
                                _context6.next = 5;
                                return this.updateUserUsingInitializeValuesProducer(initializeValuesProducer, identifiers, customAttributes);
                            case 5:
                            case "end":
                                return _context6.stop();
                        }
                    }, _callee6, this);
                }));
                function updateUserWithValues(_x16, _x17) {
                    return _updateUserWithValues.apply(this, arguments);
                }
                return updateUserWithValues;
            }()
        },
        {
            key: "initializeCalled",
            value: function initializeCalled() {
                return this.initPromise != null;
            }
        },
        {
            key: "initializeCompleted",
            value: function initializeCompleted() {
                return this.initCompleted;
            }
        },
        {
            key: "checkGate",
            value: function checkGate(gateName) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                try {
                    this.assertInitialized(this.statsigClient);
                    var _options$fireGateExpo = options.fireGateExposure, fireGateExposure = _options$fireGateExpo === void 0 ? true : _options$fireGateExpo;
                    return this.statsigClient.checkGate(gateName, {
                        disableExposureLog: !fireGateExposure
                    });
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasCheckGateErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: "An error has occurred checking the feature gate. Only the first occurrence of this error is logged.",
                            gateName: gateName,
                            error: error
                        });
                        this.hasCheckGateErrorOccurred = true;
                    }
                    return false;
                }
            }
        },
        {
            key: "isGateExist",
            value: function isGateExist(gateName) {
                try {
                    this.assertInitialized(this.statsigClient);
                    var gate = this.statsigClient.getFeatureGate(gateName, {
                        disableExposureLog: true
                    });
                    return !gate.details.reason.includes("Unrecognized");
                } catch (error) {
                    // eslint-disable-next-line no-console
                    console.error("Error occurred when trying to check FeatureGate: ".concat(error));
                    // in case of error report true to avoid false positives.
                    return true;
                }
            }
        },
        {
            key: "isExperimentExist",
            value: function isExperimentExist(experimentName) {
                try {
                    this.assertInitialized(this.statsigClient);
                    var config = this.statsigClient.getExperiment(experimentName, {
                        disableExposureLog: true
                    });
                    return !config.details.reason.includes("Unrecognized");
                } catch (error) {
                    // eslint-disable-next-line no-console
                    console.error("Error occurred when trying to check Experiment: ".concat(error));
                    // in case of error report true to avoid false positives.
                    return true;
                }
            }
        },
        {
            key: "manuallyLogGateExposure",
            value: function manuallyLogGateExposure(gateName) {
                this.assertInitialized(this.statsigClient);
                // This is the approach recommended in the docs
                // https://docs.statsig.com/client/javascript-sdk/#manual-exposures-
                this.statsigClient.checkGate(gateName);
            }
        },
        {
            key: "getExperiment",
            value: function getExperiment(experimentName) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                try {
                    this.assertInitialized(this.statsigClient);
                    var _options$fireExperime = options.fireExperimentExposure, fireExperimentExposure = _options$fireExperime === void 0 ? true : _options$fireExperime;
                    return (0, $d6BRT.DynamicConfig).fromExperiment(this.statsigClient.getExperiment(experimentName, {
                        disableExposureLog: !fireExperimentExposure
                    }));
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasGetExperimentErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: "An error has occurred getting the experiment. Only the first occurrence of this error is logged.",
                            experimentName: experimentName,
                            error: error
                        });
                        this.hasGetExperimentErrorOccurred = true;
                    }
                    // Return a default value
                    return new (0, $d6BRT.DynamicConfig)(experimentName, {}, "", {
                        time: Date.now(),
                        reason: (0, $i9yc8.EvaluationReason).Error
                    });
                }
            }
        },
        {
            key: "getExperimentValue",
            value: function getExperimentValue(experimentName, parameterName, defaultValue) {
                var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var experiment = this.getExperiment(experimentName, options);
                try {
                    var typeGuard = options.typeGuard;
                    return experiment.get(parameterName, defaultValue, typeGuard);
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasGetExperimentValueErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: "An error has occurred getting the experiment value. Only the first occurrence of this error is logged.",
                            experimentName: experimentName,
                            defaultValue: defaultValue,
                            options: options,
                            error: error
                        });
                        this.hasGetExperimentValueErrorOccurred = true;
                    }
                    return defaultValue;
                }
            }
        },
        {
            key: "manuallyLogExperimentExposure",
            value: function manuallyLogExperimentExposure(experimentName) {
                this.assertInitialized(this.statsigClient);
                // This is the approach recommended in the docs
                // https://docs.statsig.com/client/javascript-sdk/#manual-exposures-
                this.statsigClient.getExperiment(experimentName);
            }
        },
        {
            key: "manuallyLogLayerExposure",
            value: function manuallyLogLayerExposure(layerName, parameterName) {
                var _this$statsigClient$g;
                this.assertInitialized(this.statsigClient);
                // This is the approach recommended in the docs
                // https://docs.statsig.com/client/javascript-sdk/#manual-exposures-
                (_this$statsigClient$g = this.statsigClient.getLayer(layerName)) === null || _this$statsigClient$g === void 0 || _this$statsigClient$g.get(parameterName);
            }
        },
        {
            key: "shutdownStatsig",
            value: function shutdownStatsig() {
                this.assertInitialized(this.statsigClient);
                this.statsigClient.shutdown();
            }
        },
        {
            key: "overrideGate",
            value: function overrideGate(gateName, value) {
                this.assertInitialized(this.statsigClient);
                this.overrideAdapter.overrideGate(gateName, value);
                // Trigger a reset of the memoized gate value
                if (this.user) this.statsigClient.updateUserSync(this.user, {
                    disableBackgroundCacheRefresh: true
                });
                this.statsigValuesUpdated();
            }
        },
        {
            key: "clearGateOverride",
            value: function clearGateOverride(gateName) {
                this.assertInitialized(this.statsigClient);
                this.overrideAdapter.removeGateOverride(gateName);
                this.statsigValuesUpdated();
            }
        },
        {
            key: "overrideConfig",
            value: function overrideConfig(experimentName, values) {
                this.assertInitialized(this.statsigClient);
                this.overrideAdapter.overrideDynamicConfig(experimentName, values);
                this.statsigValuesUpdated();
            }
        },
        {
            key: "clearConfigOverride",
            value: function clearConfigOverride(experimentName) {
                this.assertInitialized(this.statsigClient);
                this.overrideAdapter.removeDynamicConfigOverride(experimentName);
                this.statsigValuesUpdated();
            }
        },
        {
            key: "setOverrides",
            value: function setOverrides(overrides) {
                this.assertInitialized(this.statsigClient);
                this.overrideAdapter.setOverrides(overrides);
                this.statsigValuesUpdated();
            }
        },
        {
            key: "getOverrides",
            value: function getOverrides() {
                this.assertInitialized(this.statsigClient);
                return this.overrideAdapter.getOverrides();
            }
        },
        {
            key: "clearAllOverrides",
            value: function clearAllOverrides() {
                this.assertInitialized(this.statsigClient);
                this.overrideAdapter.removeAllOverrides();
                this.statsigValuesUpdated();
            }
        },
        {
            key: "isCurrentUser",
            value: function isCurrentUser(identifiers, customAttributes) {
                return (0, $65XfA.shallowEquals)(this.currentIdentifiers, identifiers) && (0, $65XfA.shallowEquals)(this.currentAttributes, customAttributes);
            }
        },
        {
            key: "onGateUpdated",
            value: function onGateUpdated(gateName, callback) {
                var _this7 = this;
                var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var wrapCallback = function wrapCallback(value) {
                    var _options$fireGateExpo2 = options.fireGateExposure, fireGateExposure = _options$fireGateExpo2 === void 0 ? true : _options$fireGateExpo2;
                    if (fireGateExposure) _this7.manuallyLogGateExposure(gateName);
                    try {
                        callback(value);
                    } catch (error) {
                        // eslint-disable-next-line no-console
                        console.warn("Error calling callback for gate ".concat(gateName, " with value ").concat(value), error);
                    }
                };
                return this.subscriptions.onGateUpdated(gateName, wrapCallback, this.checkGate.bind(this), options);
            }
        },
        {
            key: "onExperimentValueUpdated",
            value: function onExperimentValueUpdated(experimentName, parameterName, defaultValue, callback) {
                var _this8 = this;
                var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
                var wrapCallback = function wrapCallback(value) {
                    var _options$fireExperime2 = options.fireExperimentExposure, fireExperimentExposure = _options$fireExperime2 === void 0 ? true : _options$fireExperime2;
                    if (fireExperimentExposure) _this8.manuallyLogExperimentExposure(experimentName);
                    try {
                        callback(value);
                    } catch (error) {
                        // eslint-disable-next-line no-console
                        console.warn("Error calling callback for experiment ".concat(experimentName, " with value ").concat(value), error);
                    }
                };
                return this.subscriptions.onExperimentValueUpdated(experimentName, parameterName, defaultValue, wrapCallback, this.getExperimentValue.bind(this), options);
            }
        },
        {
            key: "onAnyUpdated",
            value: function onAnyUpdated(callback) {
                return this.subscriptions.onAnyUpdated(callback);
            }
        },
        {
            key: "init",
            value: function() {
                var _init = (0, (/*@__PURE__*/$parcel$interopDefault($lR5PM)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4G35a))).mark(function _callee7(clientOptions, identifiers, customAttributes) {
                    var fromValuesClientOptions, experimentValues, customAttributesFromResult, clientSdkKeyPromise, experimentValuesPromise, _yield$Promise$all, _yield$Promise$all2, experimentValuesResult;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($4G35a))).wrap(function _callee7$(_context7) {
                        while(true)switch(_context7.prev = _context7.next){
                            case 0:
                                fromValuesClientOptions = $9de7282662b8efcc$var$_objectSpread({}, clientOptions);
                                _context7.prev = 1;
                                // If client sdk key fetch fails, an error would be thrown and handled instead of waiting for
                                // the experiment values request to be settled, and it will fall back to use default values.
                                clientSdkKeyPromise = (0, $2GOQ3.default).fetchClientSdk(clientOptions).then(function(value) {
                                    return fromValuesClientOptions.sdkKey = value.clientSdkKey;
                                });
                                experimentValuesPromise = (0, $2GOQ3.default).fetchExperimentValues(clientOptions, identifiers, customAttributes); // Only wait for the experiment values request to finish and try to initialise the client
                                // with experiment values if both requests are successful. Else an error would be thrown and
                                // handled by the catch
                                _context7.next = 6;
                                return Promise.all([
                                    clientSdkKeyPromise,
                                    experimentValuesPromise
                                ]);
                            case 6:
                                _yield$Promise$all = _context7.sent;
                                _yield$Promise$all2 = (0, (/*@__PURE__*/$parcel$interopDefault($ityw2)))(_yield$Promise$all, 2);
                                experimentValuesResult = _yield$Promise$all2[1];
                                experimentValues = experimentValuesResult.experimentValues;
                                customAttributesFromResult = experimentValuesResult.customAttributes;
                                _context7.next = 20;
                                break;
                            case 13:
                                _context7.prev = 13;
                                _context7.t0 = _context7["catch"](1);
                                if (_context7.t0 instanceof Error) // eslint-disable-next-line no-console
                                console.error("Error occurred when trying to fetch the Feature Gates client values, error: ".concat(_context7.t0 === null || _context7.t0 === void 0 ? void 0 : _context7.t0.message));
                                // eslint-disable-next-line no-console
                                console.warn("Initialising Statsig client without values");
                                _context7.next = 19;
                                return this.initFromValues(fromValuesClientOptions, identifiers, customAttributes);
                            case 19:
                                throw _context7.t0;
                            case 20:
                                return _context7.abrupt("return", this.initFromValues(fromValuesClientOptions, identifiers, customAttributesFromResult, experimentValues));
                            case 21:
                            case "end":
                                return _context7.stop();
                        }
                    }, _callee7, this, [
                        [
                            1,
                            13
                        ]
                    ]);
                }));
                function init(_x18, _x19, _x20) {
                    return _init.apply(this, arguments);
                }
                return init;
            }()
        },
        {
            key: "initWithProvider",
            value: function() {
                var _initWithProvider = (0, (/*@__PURE__*/$parcel$interopDefault($lR5PM)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4G35a))).mark(function _callee8(baseClientOptions, provider, identifiers, customAttributes) {
                    var fromValuesClientOptions, experimentValues, customAttributesFromResult, clientSdkKeyPromise, experimentValuesPromise, _yield$Promise$all3, _yield$Promise$all4, experimentValuesResult;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($4G35a))).wrap(function _callee8$(_context8) {
                        while(true)switch(_context8.prev = _context8.next){
                            case 0:
                                fromValuesClientOptions = $9de7282662b8efcc$var$_objectSpread($9de7282662b8efcc$var$_objectSpread({}, baseClientOptions), {}, {
                                    disableCurrentPageLogging: true
                                });
                                _context8.prev = 1;
                                _context8.next = 4;
                                return provider.setProfile(baseClientOptions, identifiers, customAttributes);
                            case 4:
                                // If client sdk key fetch fails, an error would be thrown and handled instead of waiting for
                                // the experiment values request to be settled, and it will fall back to use default values.
                                clientSdkKeyPromise = provider.getClientSdkKey().then(function(value) {
                                    return fromValuesClientOptions.sdkKey = value;
                                });
                                experimentValuesPromise = provider.getExperimentValues(); // Only wait for the experiment values request to finish and try to initialise the client
                                // with experiment values if both requests are successful. Else an error would be thrown and
                                // handled by the catch
                                _context8.next = 8;
                                return Promise.all([
                                    clientSdkKeyPromise,
                                    experimentValuesPromise
                                ]);
                            case 8:
                                _yield$Promise$all3 = _context8.sent;
                                _yield$Promise$all4 = (0, (/*@__PURE__*/$parcel$interopDefault($ityw2)))(_yield$Promise$all3, 2);
                                experimentValuesResult = _yield$Promise$all4[1];
                                experimentValues = experimentValuesResult.experimentValues;
                                customAttributesFromResult = experimentValuesResult.customAttributesFromFetch;
                                _context8.next = 22;
                                break;
                            case 15:
                                _context8.prev = 15;
                                _context8.t0 = _context8["catch"](1);
                                if (_context8.t0 instanceof Error) // eslint-disable-next-line no-console
                                console.error("Error occurred when trying to fetch the Feature Gates client values, error: ".concat(_context8.t0 === null || _context8.t0 === void 0 ? void 0 : _context8.t0.message));
                                // eslint-disable-next-line no-console
                                console.warn("Initialising Statsig client without values");
                                _context8.next = 21;
                                return this.initFromValues(fromValuesClientOptions, identifiers, customAttributes);
                            case 21:
                                throw _context8.t0;
                            case 22:
                                return _context8.abrupt("return", this.initFromValues(fromValuesClientOptions, identifiers, customAttributesFromResult, experimentValues));
                            case 23:
                            case "end":
                                return _context8.stop();
                        }
                    }, _callee8, this, [
                        [
                            1,
                            15
                        ]
                    ]);
                }));
                function initWithProvider(_x21, _x22, _x23, _x24) {
                    return _initWithProvider.apply(this, arguments);
                }
                return initWithProvider;
            }()
        },
        {
            key: "initFromValues",
            value: function() {
                var _initFromValues = (0, (/*@__PURE__*/$parcel$interopDefault($lR5PM)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4G35a))).mark(function _callee9(clientOptions, identifiers, customAttributes) {
                    var _newClientOptions$net;
                    var initializeValues, newClientOptions, sdkKey, environment, _updateUserCompletionCallback, _perimeter, restClientOptions, statsigOptions, _args9 = arguments;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($4G35a))).wrap(function _callee9$(_context9) {
                        while(true)switch(_context9.prev = _context9.next){
                            case 0:
                                initializeValues = _args9.length > 3 && _args9[3] !== undefined ? _args9[3] : {};
                                this.overrideAdapter.initFromStoredOverrides();
                                this.user = (0, $65XfA.toStatsigUser)(identifiers, customAttributes);
                                this.currentIdentifiers = identifiers;
                                this.currentAttributes = customAttributes;
                                newClientOptions = (0, $65XfA.migrateInitializationOptions)(clientOptions);
                                if (!newClientOptions.sdkKey) newClientOptions.sdkKey = $9de7282662b8efcc$var$DEFAULT_CLIENT_KEY;
                                if (!((_newClientOptions$net = newClientOptions.networkConfig) !== null && _newClientOptions$net !== void 0 && _newClientOptions$net.logEventUrl)) newClientOptions.networkConfig = $9de7282662b8efcc$var$_objectSpread($9de7282662b8efcc$var$_objectSpread({}, newClientOptions.networkConfig), {}, {
                                    logEventUrl: $9de7282662b8efcc$var$DEFAULT_EVENT_LOGGING_API
                                });
                                if (newClientOptions.perimeter === (0, $145CT.PerimeterType).FEDRAMP_MODERATE) // disable all logging in FedRAMP to prevent egress of sensitive data
                                newClientOptions.disableLogging = true;
                                sdkKey = newClientOptions.sdkKey, environment = newClientOptions.environment, _updateUserCompletionCallback = newClientOptions.updateUserCompletionCallback, _perimeter = newClientOptions.perimeter, restClientOptions = (0, (/*@__PURE__*/$parcel$interopDefault($1sfUu)))(newClientOptions, $9de7282662b8efcc$var$_excluded);
                                statsigOptions = $9de7282662b8efcc$var$_objectSpread($9de7282662b8efcc$var$_objectSpread({}, restClientOptions), {}, {
                                    environment: {
                                        tier: environment
                                    },
                                    includeCurrentPageUrlWithEvents: false,
                                    dataAdapter: this.dataAdapter,
                                    overrideAdapter: this.overrideAdapter
                                });
                                _context9.prev = 11;
                                this.statsigClient = new (0, $e2ZOQ.StatsigClient)(sdkKey, this.user, statsigOptions);
                                this.dataAdapter.setBootstrapData(initializeValues);
                                _context9.next = 16;
                                return this.statsigClient.initializeAsync();
                            case 16:
                                _context9.next = 28;
                                break;
                            case 18:
                                _context9.prev = 18;
                                _context9.t0 = _context9["catch"](11);
                                if (_context9.t0 instanceof Error) // eslint-disable-next-line no-console
                                console.error("Error occurred when trying to initialise the Statsig client, error: ".concat(_context9.t0 === null || _context9.t0 === void 0 ? void 0 : _context9.t0.message));
                                // eslint-disable-next-line no-console
                                console.warn("Initialising Statsig client with default sdk key and without values");
                                this.statsigClient = new (0, $e2ZOQ.StatsigClient)($9de7282662b8efcc$var$DEFAULT_CLIENT_KEY, this.user, statsigOptions);
                                this.dataAdapter.setBootstrapData();
                                _context9.next = 26;
                                return this.statsigClient.initializeAsync();
                            case 26:
                                this.initWithDefaults = true;
                                throw _context9.t0;
                            case 28:
                            case "end":
                                return _context9.stop();
                        }
                    }, _callee9, this, [
                        [
                            11,
                            18
                        ]
                    ]);
                }));
                function initFromValues(_x25, _x26, _x27) {
                    return _initFromValues.apply(this, arguments);
                }
                return initFromValues;
            }()
        },
        {
            key: "updateUserUsingInitializeValuesProducer",
            value: function() {
                var _updateUserUsingInitializeValuesProducer = (0, (/*@__PURE__*/$parcel$interopDefault($lR5PM)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4G35a))).mark(function _callee11(getInitializeValues, identifiers, customAttributes) {
                    var _this9 = this;
                    var originalInitPromise, initializeValuesPromise, updateUserPromise;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($4G35a))).wrap(function _callee11$(_context11) {
                        while(true)switch(_context11.prev = _context11.next){
                            case 0:
                                this.assertInitialized(this.statsigClient);
                                if (this.initPromise) {
                                    _context11.next = 3;
                                    break;
                                }
                                throw new Error("The client must be initialized before you can update the user.");
                            case 3:
                                if (!this.isCurrentUser(identifiers, customAttributes)) {
                                    _context11.next = 5;
                                    break;
                                }
                                return _context11.abrupt("return", this.initPromise);
                            case 5:
                                // Wait for the current initialize/update to finish
                                originalInitPromise = this.initPromise;
                                _context11.prev = 6;
                                _context11.next = 9;
                                return this.initPromise;
                            case 9:
                                _context11.next = 13;
                                break;
                            case 11:
                                _context11.prev = 11;
                                _context11.t0 = _context11["catch"](6);
                            case 13:
                                initializeValuesPromise = getInitializeValues();
                                updateUserPromise = this.updateStatsigClientUser(initializeValuesPromise, identifiers, customAttributes); // We replace the init promise here since we are essentially re-initializing the client at this
                                // point. Any subsequent calls to await client.initialize() or client.updateUser()
                                // will now also await this user update.
                                this.initPromise = updateUserPromise.catch(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lR5PM)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4G35a))).mark(function _callee10() {
                                    return (0, (/*@__PURE__*/$parcel$interopDefault($4G35a))).wrap(function _callee10$(_context10) {
                                        while(true)switch(_context10.prev = _context10.next){
                                            case 0:
                                                // If the update failed then it changed nothing, so revert back to the original promise.
                                                _this9.initPromise = originalInitPromise;
                                                // Set the user profile again to revert back to the current user
                                                if (!_this9.provider) {
                                                    _context10.next = 4;
                                                    break;
                                                }
                                                _context10.next = 4;
                                                return _this9.provider.setProfile(_this9.initOptions, _this9.currentIdentifiers, _this9.currentAttributes);
                                            case 4:
                                            case "end":
                                                return _context10.stop();
                                        }
                                    }, _callee10);
                                })));
                                return _context11.abrupt("return", updateUserPromise);
                            case 17:
                            case "end":
                                return _context11.stop();
                        }
                    }, _callee11, this, [
                        [
                            6,
                            11
                        ]
                    ]);
                }));
                function updateUserUsingInitializeValuesProducer(_x28, _x29, _x30) {
                    return _updateUserUsingInitializeValuesProducer.apply(this, arguments);
                }
                return updateUserUsingInitializeValuesProducer;
            }()
        },
        {
            key: "updateStatsigClientUser",
            value: function() {
                var _updateStatsigClientUser = (0, (/*@__PURE__*/$parcel$interopDefault($lR5PM)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4G35a))).mark(function _callee12(initializeValuesPromise, identifiers, customAttributes) {
                    var _this$initOptions, _this$initOptions$upd;
                    var initializeValues, user, _updateUserCompletion, _ref3, errMsg, success, errorMessage;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($4G35a))).wrap(function _callee12$(_context12) {
                        while(true)switch(_context12.prev = _context12.next){
                            case 0:
                                this.assertInitialized(this.statsigClient);
                                _context12.prev = 1;
                                _context12.next = 4;
                                return initializeValuesPromise;
                            case 4:
                                initializeValues = _context12.sent;
                                user = (0, $65XfA.toStatsigUser)(identifiers, initializeValues.customAttributesFromFetch);
                                _context12.next = 13;
                                break;
                            case 8:
                                _context12.prev = 8;
                                _context12.t0 = _context12["catch"](1);
                                // Make sure the updateUserCompletionCallback is called for any errors in our custom code.
                                // This is not necessary for the updateUserWithValues call, because the Statsig client will
                                // already invoke the callback itself.
                                errMsg = _context12.t0 instanceof Error ? _context12.t0.message : JSON.stringify(_context12.t0);
                                (_updateUserCompletion = (_ref3 = this.initOptions).updateUserCompletionCallback) === null || _updateUserCompletion === void 0 || _updateUserCompletion.call(_ref3, false, errMsg);
                                throw _context12.t0;
                            case 13:
                                success = true;
                                errorMessage = null;
                                _context12.prev = 15;
                                this.dataAdapter.setBootstrapData(initializeValues.experimentValues);
                                this.user = user;
                                _context12.next = 20;
                                return this.statsigClient.updateUserAsync(this.user);
                            case 20:
                                _context12.next = 26;
                                break;
                            case 22:
                                _context12.prev = 22;
                                _context12.t1 = _context12["catch"](15);
                                success = false;
                                errorMessage = String(_context12.t1);
                            case 26:
                                (_this$initOptions = this.initOptions) === null || _this$initOptions === void 0 || (_this$initOptions$upd = _this$initOptions.updateUserCompletionCallback) === null || _this$initOptions$upd === void 0 || _this$initOptions$upd.call(_this$initOptions, success, errorMessage);
                                if (!success) {
                                    _context12.next = 33;
                                    break;
                                }
                                this.currentIdentifiers = identifiers;
                                this.currentAttributes = customAttributes;
                                this.subscriptions.anyUpdated();
                                _context12.next = 34;
                                break;
                            case 33:
                                throw new Error("Failed to update user. An unexpected error occured.");
                            case 34:
                            case "end":
                                return _context12.stop();
                        }
                    }, _callee12, this, [
                        [
                            1,
                            8
                        ],
                        [
                            15,
                            22
                        ]
                    ]);
                }));
                function updateStatsigClientUser(_x31, _x32, _x33) {
                    return _updateStatsigClientUser.apply(this, arguments);
                }
                return updateStatsigClientUser;
            }()
        },
        {
            key: "getPackageVersion",
            value: /**
     * @returns string version of the current package in semver style.
     */ function getPackageVersion() {
                return 0, $fetJQ.CLIENT_VERSION;
            }
        },
        {
            key: "getLayer",
            value: function getLayer(/** The name of the layer */ layerName) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                try {
                    this.assertInitialized(this.statsigClient);
                    var _options$fireLayerExp = options.fireLayerExposure, fireLayerExposure = _options$fireLayerExp === void 0 ? true : _options$fireLayerExp;
                    return (0, $2FkTo.Layer).fromLayer(this.statsigClient.getLayer(layerName, {
                        disableExposureLog: !fireLayerExposure
                    }));
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasGetLayerErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: "An error has occurred getting the layer. Only the first occurrence of this error is logged.",
                            layerName: layerName,
                            error: error
                        });
                        this.hasGetLayerErrorOccurred = true;
                    }
                    // Return a default value
                    return (0, $2FkTo.Layer).fromLayer((0, $e2ZOQ._makeLayer)(layerName, {
                        reason: "Error"
                    }, null));
                }
            }
        },
        {
            key: "getLayerValue",
            value: function getLayerValue(layerName, parameterName, defaultValue) {
                var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var layer = this.getLayer(layerName, options);
                try {
                    var typeGuard = options.typeGuard;
                    return layer.get(parameterName, defaultValue, typeGuard);
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasGetLayerValueErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: "An error has occurred getting the layer value. Only the first occurrence of this error is logged.",
                            layerName: layerName,
                            defaultValue: defaultValue,
                            options: options,
                            error: error
                        });
                        this.hasGetLayerValueErrorOccurred = true;
                    }
                    return defaultValue;
                }
            }
        }
    ]);
}();

});
parcelRegister("1sfUu", function(module, exports) {

var $gDHAT = parcelRequire("gDHAT");
function $10f4bf5d69d0333b$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $gDHAT(e, t);
    if (Object.getOwnPropertySymbols) {
        var s = Object.getOwnPropertySymbols(e);
        for(r = 0; r < s.length; r++)o = s[r], t.includes(o) || ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
module.exports = $10f4bf5d69d0333b$var$_objectWithoutProperties, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("gDHAT", function(module, exports) {
function $c1d21ab5dd6c0319$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.includes(n)) continue;
        t[n] = r[n];
    }
    return t;
}
module.exports = $c1d21ab5dd6c0319$var$_objectWithoutPropertiesLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("ityw2", function(module, exports) {

var $fKixo = parcelRequire("fKixo");

var $l5T54 = parcelRequire("l5T54");

var $e2UEX = parcelRequire("e2UEX");

var $S6Nh8 = parcelRequire("S6Nh8");
function $03789bb3aed5f237$var$_slicedToArray(r, e) {
    return $fKixo(r) || $l5T54(r, e) || $e2UEX(r, e) || $S6Nh8();
}
module.exports = $03789bb3aed5f237$var$_slicedToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("fKixo", function(module, exports) {
function $b769880c419a8ef8$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
module.exports = $b769880c419a8ef8$var$_arrayWithHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("l5T54", function(module, exports) {
function $f5b4ca7f7fa799f0$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
module.exports = $f5b4ca7f7fa799f0$var$_iterableToArrayLimit, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("e2UEX", function(module, exports) {

var $j0VL0 = parcelRequire("j0VL0");
function $a39d34045bf499fc$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $j0VL0(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $j0VL0(r, a) : void 0;
    }
}
module.exports = $a39d34045bf499fc$var$_unsupportedIterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("j0VL0", function(module, exports) {
function $dd7ad1cc3525ebd5$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
module.exports = $dd7ad1cc3525ebd5$var$_arrayLikeToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("S6Nh8", function(module, exports) {
function $0a2a505c457196cc$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
module.exports = $0a2a505c457196cc$var$_nonIterableRest, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("lR5PM", function(module, exports) {
function $fe9312bbbca06d7e$var$asyncGeneratorStep(n, t, e, r, o, a, c) {
    try {
        var i = n[a](c), u = i.value;
    } catch (n) {
        return void e(n);
    }
    i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function $fe9312bbbca06d7e$var$_asyncToGenerator(n) {
    return function() {
        var t = this, e = arguments;
        return new Promise(function(r, o) {
            var a = n.apply(t, e);
            function _next(n) {
                $fe9312bbbca06d7e$var$asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
            }
            function _throw(n) {
                $fe9312bbbca06d7e$var$asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
            }
            _next(void 0);
        });
    };
}
module.exports = $fe9312bbbca06d7e$var$_asyncToGenerator, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("4G35a", function(module, exports) {
// TODO(Babel 8): Remove this file.

var $367d79c32e2cd4e0$var$runtime = (parcelRequire("7RD2r"))();
module.exports = $367d79c32e2cd4e0$var$runtime;
// Copied from https://github.com/facebook/regenerator/blob/main/packages/runtime/runtime.js#L736=
try {
    regeneratorRuntime = $367d79c32e2cd4e0$var$runtime;
} catch (accidentalStrictMode) {
    if (typeof globalThis === "object") globalThis.regeneratorRuntime = $367d79c32e2cd4e0$var$runtime;
    else Function("r", "regeneratorRuntime = r")($367d79c32e2cd4e0$var$runtime);
}

});
parcelRegister("7RD2r", function(module, exports) {

var $4tNfC = parcelRequire("4tNfC");
var $5b9bc3dbb4da1a61$var$_typeof = $4tNfC.default;
function $5b9bc3dbb4da1a61$var$_regeneratorRuntime() {
    "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ 
    module.exports = $5b9bc3dbb4da1a61$var$_regeneratorRuntime = function _regeneratorRuntime() {
        return e;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports;
    var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function(t, e, r) {
        t[e] = r.value;
    }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag";
    function define(t, e, r) {
        return Object.defineProperty(t, e, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }), t[e];
    }
    try {
        define({}, "");
    } catch (t) {
        define = function define(t, e, r) {
            return t[e] = r;
        };
    }
    function wrap(t, e, r, n) {
        var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []);
        return o(a, "_invoke", {
            value: makeInvokeMethod(t, r, c)
        }), a;
    }
    function tryCatch(t, e, r) {
        try {
            return {
                type: "normal",
                arg: t.call(e, r)
            };
        } catch (t) {
            return {
                type: "throw",
                arg: t
            };
        }
    }
    e.wrap = wrap;
    var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {};
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    var p = {};
    define(p, a, function() {
        return this;
    });
    var d = Object.getPrototypeOf, v = d && d(d(values([])));
    v && v !== r && n.call(v, a) && (p = v);
    var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
    function defineIteratorMethods(t) {
        [
            "next",
            "throw",
            "return"
        ].forEach(function(e) {
            define(t, e, function(t) {
                return this._invoke(e, t);
            });
        });
    }
    function AsyncIterator(t, e) {
        function invoke(r, o, i, a) {
            var c = tryCatch(t[r], t, o);
            if ("throw" !== c.type) {
                var u = c.arg, h = u.value;
                return h && "object" == $5b9bc3dbb4da1a61$var$_typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function(t) {
                    invoke("next", t, i, a);
                }, function(t) {
                    invoke("throw", t, i, a);
                }) : e.resolve(h).then(function(t) {
                    u.value = t, i(u);
                }, function(t) {
                    return invoke("throw", t, i, a);
                });
            }
            a(c.arg);
        }
        var r;
        o(this, "_invoke", {
            value: function value(t, n) {
                function callInvokeWithMethodAndArg() {
                    return new e(function(e, r) {
                        invoke(t, n, e, r);
                    });
                }
                return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
            }
        });
    }
    function makeInvokeMethod(e, r, n) {
        var o = h;
        return function(i, a) {
            if (o === f) throw Error("Generator is already running");
            if (o === s) {
                if ("throw" === i) throw a;
                return {
                    value: t,
                    done: !0
                };
            }
            for(n.method = i, n.arg = a;;){
                var c = n.delegate;
                if (c) {
                    var u = maybeInvokeDelegate(c, n);
                    if (u) {
                        if (u === y) continue;
                        return u;
                    }
                }
                if ("next" === n.method) n.sent = n._sent = n.arg;
                else if ("throw" === n.method) {
                    if (o === h) throw o = s, n.arg;
                    n.dispatchException(n.arg);
                } else "return" === n.method && n.abrupt("return", n.arg);
                o = f;
                var p = tryCatch(e, r, n);
                if ("normal" === p.type) {
                    if (o = n.done ? s : l, p.arg === y) continue;
                    return {
                        value: p.arg,
                        done: n.done
                    };
                }
                "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
            }
        };
    }
    function maybeInvokeDelegate(e, r) {
        var n = r.method, o = e.iterator[n];
        if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
        var i = tryCatch(o, e.iterator, r.arg);
        if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
        var a = i.arg;
        return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
    }
    function pushTryEntry(t) {
        var e = {
            tryLoc: t[0]
        };
        1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
    }
    function resetTryEntry(t) {
        var e = t.completion || {};
        e.type = "normal", delete e.arg, t.completion = e;
    }
    function Context(t) {
        this.tryEntries = [
            {
                tryLoc: "root"
            }
        ], t.forEach(pushTryEntry, this), this.reset(!0);
    }
    function values(e) {
        if (e || "" === e) {
            var r = e[a];
            if (r) return r.call(e);
            if ("function" == typeof e.next) return e;
            if (!isNaN(e.length)) {
                var o = -1, i = function next() {
                    for(; ++o < e.length;)if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
                    return next.value = t, next.done = !0, next;
                };
                return i.next = i;
            }
        }
        throw new TypeError($5b9bc3dbb4da1a61$var$_typeof(e) + " is not iterable");
    }
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
        value: GeneratorFunctionPrototype,
        configurable: !0
    }), o(GeneratorFunctionPrototype, "constructor", {
        value: GeneratorFunction,
        configurable: !0
    }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function(t) {
        var e = "function" == typeof t && t.constructor;
        return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
    }, e.mark = function(t) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
    }, e.awrap = function(t) {
        return {
            __await: t
        };
    }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function() {
        return this;
    }), e.AsyncIterator = AsyncIterator, e.async = function(t, r, n, o, i) {
        void 0 === i && (i = Promise);
        var a = new AsyncIterator(wrap(t, r, n, o), i);
        return e.isGeneratorFunction(r) ? a : a.next().then(function(t) {
            return t.done ? t.value : a.next();
        });
    }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function() {
        return this;
    }), define(g, "toString", function() {
        return "[object Generator]";
    }), e.keys = function(t) {
        var e = Object(t), r = [];
        for(var n in e)r.push(n);
        return r.reverse(), function next() {
            for(; r.length;){
                var t = r.pop();
                if (t in e) return next.value = t, next.done = !1, next;
            }
            return next.done = !0, next;
        };
    }, e.values = values, Context.prototype = {
        constructor: Context,
        reset: function reset(e) {
            if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for(var r in this)"t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
        },
        stop: function stop() {
            this.done = !0;
            var t = this.tryEntries[0].completion;
            if ("throw" === t.type) throw t.arg;
            return this.rval;
        },
        dispatchException: function dispatchException(e) {
            if (this.done) throw e;
            var r = this;
            function handle(n, o) {
                return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
            }
            for(var o = this.tryEntries.length - 1; o >= 0; --o){
                var i = this.tryEntries[o], a = i.completion;
                if ("root" === i.tryLoc) return handle("end");
                if (i.tryLoc <= this.prev) {
                    var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc");
                    if (c && u) {
                        if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                        if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
                    } else if (c) {
                        if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                    } else {
                        if (!u) throw Error("try statement without catch or finally");
                        if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
                    }
                }
            }
        },
        abrupt: function abrupt(t, e) {
            for(var r = this.tryEntries.length - 1; r >= 0; --r){
                var o = this.tryEntries[r];
                if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
                    var i = o;
                    break;
                }
            }
            i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
            var a = i ? i.completion : {};
            return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
        },
        complete: function complete(t, e) {
            if ("throw" === t.type) throw t.arg;
            return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
        },
        finish: function finish(t) {
            for(var e = this.tryEntries.length - 1; e >= 0; --e){
                var r = this.tryEntries[e];
                if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
            }
        },
        "catch": function _catch(t) {
            for(var e = this.tryEntries.length - 1; e >= 0; --e){
                var r = this.tryEntries[e];
                if (r.tryLoc === t) {
                    var n = r.completion;
                    if ("throw" === n.type) {
                        var o = n.arg;
                        resetTryEntry(r);
                    }
                    return o;
                }
            }
            throw Error("illegal catch attempt");
        },
        delegateYield: function delegateYield(e, r, n) {
            return this.delegate = {
                iterator: values(e),
                resultName: r,
                nextLoc: n
            }, "next" === this.method && (this.arg = t), y;
        }
    }, e;
}
module.exports = $5b9bc3dbb4da1a61$var$_regeneratorRuntime, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("e2ZOQ", function(module, exports) {
"use strict";
var $a3a1348dbcf4b41b$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $a3a1348dbcf4b41b$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $a3a1348dbcf4b41b$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StatsigClient = void 0;

var $i0w6t = parcelRequire("i0w6t");
module.exports.StatsigClient = $i0w6t.default;

$a3a1348dbcf4b41b$var$__exportStar((parcelRequire("aALut")), module.exports);
__STATSIG__ = Object.assign(Object.assign({}, __STATSIG__ !== null && __STATSIG__ !== void 0 ? __STATSIG__ : {}), {
    StatsigClient: $i0w6t.default
});
module.exports.default = __STATSIG__;

});
parcelRegister("i0w6t", function(module, exports) {
"use strict";
var $d1c12128c2508e27$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $aALut = parcelRequire("aALut");

var $16TR8 = parcelRequire("16TR8");

var $iXmRJ = parcelRequire("iXmRJ");

var $cN42m = parcelRequire("cN42m");

var $fpmnb = parcelRequire("fpmnb");
class $d1c12128c2508e27$var$StatsigClient extends $aALut.StatsigClientBase {
    /**
     * Retrieves an instance of the StatsigClient based on the provided SDK key.
     *  If no SDK key is provided, the method returns the most recently created instance of the StatsigClient.
     *  The method ensures that each unique SDK key corresponds to a single instance of StatsigClient, effectively implementing a singleton pattern for each key.
     *
     * @param {string} [sdkKey] - Optional. The SDK key used to identify a specific instance of the StatsigClient. If omitted, the method returns the last created instance.
     * @returns {StatsigClient|undefined} Returns the StatsigClient instance associated with the given SDK key, or undefined if no instance is associated with the key or if no key is provided and no instances exist.
     */ static instance(sdkKey) {
        const instance = (0, $aALut._getStatsigGlobal)().instance(sdkKey);
        if (instance instanceof $d1c12128c2508e27$var$StatsigClient) return instance;
        $aALut.Log.warn((0, $aALut._isServerEnv)() ? "StatsigClient.instance is not supported in server environments" : "Unable to find StatsigClient instance");
        return new $d1c12128c2508e27$var$StatsigClient(sdkKey !== null && sdkKey !== void 0 ? sdkKey : "", {});
    }
    /**
     * StatsigClient constructor
     *
     * @param {string} sdkKey A Statsig client SDK key. eg "client-xyz123..."
     * @param {StatsigUser} user StatsigUser object containing various attributes related to a user.
     * @param {StatsigOptions | null} options StatsigOptions, used to customize the behavior of the SDK.
     */ constructor(sdkKey, user, options = null){
        var _a, _b;
        $aALut.SDKType._setClientType(sdkKey, "javascript-client");
        const network = new $iXmRJ.default(options, (e)=>{
            this.$emt(e);
        });
        super(sdkKey, (_a = options === null || options === void 0 ? void 0 : options.dataAdapter) !== null && _a !== void 0 ? _a : new $fpmnb.StatsigEvaluationsDataAdapter(), network, options);
        /**
         * Retrieves the value of a feature gate for the current user, represented as a {@link FeatureGate} object.
         *
         * @param {string} name - The name of the feature gate to retrieve.
         * @param {FeatureGateEvaluationOptions} [options] - Optional. Additional options to customize the method call.
         * @returns {FeatureGate} - The {@link FeatureGate} object representing the gate's current evaluation results for the user.
         */ this.getFeatureGate = this._memoize($aALut.MemoPrefix._gate, this._getFeatureGateImpl.bind(this));
        /**
         * Retrieves the value of a dynamic config for the current user.
         *
         * @param {string} name The name of the dynamic config to get.
         * @param {DynamicConfigEvaluationOptions} [options] - Optional. Additional options to customize the method call.
         * @returns {DynamicConfig} - The {@link DynamicConfig} object representing the dynamic configs's current evaluation results for the user.
         */ this.getDynamicConfig = this._memoize($aALut.MemoPrefix._dynamicConfig, this._getDynamicConfigImpl.bind(this));
        /**
         * Retrieves the value of a experiment for the current user.
         *
         * @param {string} name The name of the experiment to get.
         * @param {ExperimentEvaluationOptions} [options] - Optional. Additional options to customize the method call.
         * @returns {Experiment} - The {@link Experiment} object representing the experiments's current evaluation results for the user.
         */ this.getExperiment = this._memoize($aALut.MemoPrefix._experiment, this._getExperimentImpl.bind(this));
        /**
         * Retrieves the value of a layer for the current user.
         *
         * @param {string} name The name of the layer to get.
         * @param {LayerEvaluationOptions} [options] - Optional. Additional options to customize the method call.
         * @returns {Layer} - The {@link Layer} object representing the layers's current evaluation results for the user.
         */ this.getLayer = this._memoize($aALut.MemoPrefix._layer, this._getLayerImpl.bind(this));
        /**
         * Retrieves the value of a parameter store for the current user.
         *
         * @param {string} name The name of the parameter store to get.
         * @param {ParameterStoreEvaluationOptions} [options] - Optional. Additional options to customize the method call.
         * @returns {ParameterStore} - The {@link ParameterStore} object representing the parameter store's current mappings for the user.
         */ this.getParameterStore = this._memoize($aALut.MemoPrefix._paramStore, this._getParameterStoreImpl.bind(this));
        this._store = new $16TR8.default(sdkKey);
        this._network = network;
        this._user = this._configureUser(user, options);
        const plugins = (_b = options === null || options === void 0 ? void 0 : options.plugins) !== null && _b !== void 0 ? _b : [];
        for (const plugin of plugins)plugin.bind(this);
    }
    /**
     * Initializes the StatsigClient using cached values. This method sets up the client synchronously by utilizing previously cached values.
     * After initialization, cache values are updated in the background for future use, either in subsequent sessions or when `updateUser` is called.
     * This is useful for quickly starting with the last-known-good configurations while refreshing data to keep settings up-to-date.
     *
     * @see {@link initializeAsync} for the asynchronous version of this method.
     */ initializeSync(options) {
        var _a;
        if (this.loadingStatus !== "Uninitialized") return (0, $aALut.createUpdateDetails)(true, this._store.getSource(), -1, null, null, [
            "MultipleInitializations",
            ...(_a = this._store.getWarnings()) !== null && _a !== void 0 ? _a : []
        ]);
        this._logger.start();
        return this.updateUserSync(this._user, options);
    }
    /**
     * Initializes the StatsigClient asynchronously by first using cached values and then updating to the latest values from the network.
     * Once the network values are fetched, they replace the existing cached values. If this method's promise is not awaited,
     * there might be a transition from cached to network values during the session, which can affect consistency.
     * This method is useful when it's acceptable to begin with potentially stale data and switch to the latest configuration as it becomes available.
     *
     * @param {AsyncUpdateOptions} [options] - Optional. Additional options to customize the method call.
     * @returns {Promise<void>} A promise that resolves once the client is fully initialized with the latest values from the network or a timeout (if set) is hit.
     * @see {@link initializeSync} for the synchronous version of this method.
     */ initializeAsync(options) {
        return $d1c12128c2508e27$var$__awaiter(this, void 0, void 0, function*() {
            if (this._initializePromise) return this._initializePromise;
            this._initializePromise = this._initializeAsyncImpl(options);
            return this._initializePromise;
        });
    }
    /**
     * Synchronously updates the user in the Statsig client and switches the internal state to use cached values for the newly specified user.
     * After the initial switch to cached values, this method updates these values in the background, preparing them for future sessions or subsequent calls to updateUser.
     * This method ensures the client is quickly ready with available data.
     *
     * @param {StatsigUser} user - The new StatsigUser for which the client should update its internal state.
     * @see {@link updateUserAsync} for the asynchronous version of this method.
     */ updateUserSync(user, options) {
        var _a;
        const startTime = performance.now();
        const warnings = [
            ...(_a = this._store.getWarnings()) !== null && _a !== void 0 ? _a : []
        ];
        this._resetForUser(user);
        const result = this.dataAdapter.getDataSync(this._user);
        if (result == null) warnings.push("NoCachedValues");
        this._store.setValues(result, this._user);
        this._finalizeUpdate(result);
        const disable = options === null || options === void 0 ? void 0 : options.disableBackgroundCacheRefresh;
        if (disable === true || disable == null && (result === null || result === void 0 ? void 0 : result.source) === "Bootstrap") return (0, $aALut.createUpdateDetails)(true, this._store.getSource(), performance.now() - startTime, this._errorBoundary.getLastSeenErrorAndReset(), this._network.getLastUsedInitUrlAndReset(), warnings);
        this._runPostUpdate(result !== null && result !== void 0 ? result : null, this._user);
        return (0, $aALut.createUpdateDetails)(true, this._store.getSource(), performance.now() - startTime, this._errorBoundary.getLastSeenErrorAndReset(), this._network.getLastUsedInitUrlAndReset(), warnings);
    }
    /**
     * Asynchronously updates the user in the Statsig client by initially using cached values and then fetching the latest values from the network.
     * When the latest values are fetched, they replace the cached values. If the promise returned by this method is not awaited,
     * the client's state may shift from cached to updated network values during the session, potentially affecting consistency.
     * This method is best used in scenarios where up-to-date configuration is critical and initial delays are acceptable.
     *
     * @param {StatsigUser} user - The new StatsigUser for which the client should update its internal state.
     * @param {AsyncUpdateOptions} [options] - Optional. Additional options to customize the method call.
     * @returns {Promise<void>} A promise that resolves once the client is fully updated with the latest values from the network or a timeout (if set) is hit.
     * @see {@link updateUserSync} for the synchronous version of this method.
     */ updateUserAsync(user, options) {
        return $d1c12128c2508e27$var$__awaiter(this, void 0, void 0, function*() {
            this._resetForUser(user);
            const initiator = this._user;
            $aALut.Diagnostics._markInitOverallStart(this._sdkKey);
            let result = this.dataAdapter.getDataSync(initiator);
            this._store.setValues(result, this._user);
            this._setStatus("Loading", result);
            result = yield this.dataAdapter.getDataAsync(result, initiator, options);
            // ensure the user hasn't changed while we were waiting
            if (initiator !== this._user) return (0, $aALut.createUpdateDetails)(false, this._store.getSource(), -1, new Error("User changed during update"), this._network.getLastUsedInitUrlAndReset());
            let isUsingNetworkValues = false;
            if (result != null) {
                $aALut.Diagnostics._markInitProcessStart(this._sdkKey);
                isUsingNetworkValues = this._store.setValues(result, this._user);
                $aALut.Diagnostics._markInitProcessEnd(this._sdkKey, {
                    success: isUsingNetworkValues
                });
            }
            this._finalizeUpdate(result);
            if (!isUsingNetworkValues) {
                this._errorBoundary.attachErrorIfNoneExists($aALut.UPDATE_DETAIL_ERROR_MESSAGES.NO_NETWORK_DATA);
                this.$emt({
                    name: "initialization_failure"
                });
            }
            $aALut.Diagnostics._markInitOverallEnd(this._sdkKey, isUsingNetworkValues, this._store.getCurrentSourceDetails());
            const initDuration = $aALut.Diagnostics._enqueueDiagnosticsEvent(this._user, this._logger, this._sdkKey, this._options);
            return (0, $aALut.createUpdateDetails)(isUsingNetworkValues, this._store.getSource(), initDuration, this._errorBoundary.getLastSeenErrorAndReset(), this._network.getLastUsedInitUrlAndReset(), this._store.getWarnings());
        });
    }
    /**
     * Retrieves a synchronous context containing data currently being used by the SDK. Represented as a {@link PrecomputedEvaluationsContext} object.
     *
     * @returns {PrecomputedEvaluationsContext} The current synchronous context for the this StatsigClient instance.
     */ getContext() {
        return {
            sdkKey: this._sdkKey,
            options: this._options,
            values: this._store.getValues(),
            user: JSON.parse(JSON.stringify(this._user)),
            errorBoundary: this._errorBoundary,
            session: $aALut.StatsigSession.get(this._sdkKey),
            stableID: $aALut.StableID.get(this._sdkKey)
        };
    }
    /**
     * Retrieves the value of a feature gate for the current user, represented as a simple boolean.
     *
     * @param {string} name - The name of the feature gate to retrieve.
     * @param {FeatureGateEvaluationOptions} [options] - Optional. Additional options to customize the method call.
     * @returns {boolean} - The boolean value representing the gate's current evaluation results for the user.
     */ checkGate(name, options) {
        return this.getFeatureGate(name, options).value;
    }
    /**
     * Logs an event to the internal logging system. This function allows logging by either passing a fully formed event object or by specifying the event name with optional value and metadata.
     *
     * @param {StatsigEvent|string} eventOrName - The event object conforming to the StatsigEvent interface, or the name of the event as a string.
     * @param {string|number} value - Optional. The value associated with the event, which can be a string or a number. This parameter is ignored if the first parameter is a StatsigEvent object.
     * @param {Record<string, string>} metadata - Optional. A key-value record containing metadata about the event. This is also ignored if the first parameter is an event object.
     */ logEvent(eventOrName, value, metadata) {
        const event = typeof eventOrName === "string" ? {
            eventName: eventOrName,
            value: value,
            metadata: metadata
        } : eventOrName;
        this._logger.enqueue(Object.assign(Object.assign({}, event), {
            user: this._user,
            time: Date.now()
        }));
    }
    _primeReadyRipcord() {
        this.$on("error", ()=>{
            this.loadingStatus === "Loading" && this._finalizeUpdate(null);
        });
    }
    _initializeAsyncImpl(options) {
        return $d1c12128c2508e27$var$__awaiter(this, void 0, void 0, function*() {
            if (!$aALut.Storage.isReady()) yield $aALut.Storage.isReadyResolver();
            this._logger.start();
            return this.updateUserAsync(this._user, options);
        });
    }
    _finalizeUpdate(values) {
        this._store.finalize();
        this._setStatus("Ready", values);
    }
    _runPostUpdate(current, user) {
        this.dataAdapter.getDataAsync(current, user, {
            priority: "low"
        }).catch((err)=>{
            $aALut.Log.error("An error occurred after update.", err);
        });
    }
    _resetForUser(user) {
        this._logger.reset();
        this._store.reset();
        this._user = this._configureUser(user, this._options);
    }
    _configureUser(originalUser, options) {
        var _a;
        const user = (0, $aALut._normalizeUser)(originalUser, options);
        const stableIdOverride = (_a = user.customIDs) === null || _a === void 0 ? void 0 : _a.stableID;
        if (stableIdOverride) $aALut.StableID.setOverride(stableIdOverride, this._sdkKey);
        return user;
    }
    _getFeatureGateImpl(name, options) {
        var _a, _b;
        const { result: evaluation, details: details } = this._store.getGate(name);
        const gate = (0, $aALut._makeFeatureGate)(name, details, evaluation);
        const overridden = (_b = (_a = this.overrideAdapter) === null || _a === void 0 ? void 0 : _a.getGateOverride) === null || _b === void 0 ? void 0 : _b.call(_a, gate, this._user, options);
        const result = overridden !== null && overridden !== void 0 ? overridden : gate;
        this._enqueueExposure(name, (0, $aALut._createGateExposure)(this._user, result, this._store.getExposureMapping()), options);
        this.$emt({
            name: "gate_evaluation",
            gate: result
        });
        return result;
    }
    _getDynamicConfigImpl(name, options) {
        var _a, _b;
        const { result: evaluation, details: details } = this._store.getConfig(name);
        const config = (0, $aALut._makeDynamicConfig)(name, details, evaluation);
        const overridden = (_b = (_a = this.overrideAdapter) === null || _a === void 0 ? void 0 : _a.getDynamicConfigOverride) === null || _b === void 0 ? void 0 : _b.call(_a, config, this._user, options);
        const result = overridden !== null && overridden !== void 0 ? overridden : config;
        this._enqueueExposure(name, (0, $aALut._createConfigExposure)(this._user, result, this._store.getExposureMapping()), options);
        this.$emt({
            name: "dynamic_config_evaluation",
            dynamicConfig: result
        });
        return result;
    }
    _getExperimentImpl(name, options) {
        var _a, _b, _c, _d;
        const { result: evaluation, details: details } = this._store.getConfig(name);
        const experiment = (0, $aALut._makeExperiment)(name, details, evaluation);
        if (experiment.__evaluation != null) experiment.__evaluation.secondary_exposures = (0, $aALut._mapExposures)((_b = (_a = experiment.__evaluation) === null || _a === void 0 ? void 0 : _a.secondary_exposures) !== null && _b !== void 0 ? _b : [], this._store.getExposureMapping());
        const overridden = (_d = (_c = this.overrideAdapter) === null || _c === void 0 ? void 0 : _c.getExperimentOverride) === null || _d === void 0 ? void 0 : _d.call(_c, experiment, this._user, options);
        const result = overridden !== null && overridden !== void 0 ? overridden : experiment;
        this._enqueueExposure(name, (0, $aALut._createConfigExposure)(this._user, result, this._store.getExposureMapping()), options);
        this.$emt({
            name: "experiment_evaluation",
            experiment: result
        });
        return result;
    }
    _getLayerImpl(name, options) {
        var _a, _b, _c;
        const { result: evaluation, details: details } = this._store.getLayer(name);
        const layer = (0, $aALut._makeLayer)(name, details, evaluation);
        const overridden = (_b = (_a = this.overrideAdapter) === null || _a === void 0 ? void 0 : _a.getLayerOverride) === null || _b === void 0 ? void 0 : _b.call(_a, layer, this._user, options);
        if (options === null || options === void 0 ? void 0 : options.disableExposureLog) this._logger.incrementNonExposureCount(name);
        const result = (0, $aALut._mergeOverride)(layer, overridden, (_c = overridden === null || overridden === void 0 ? void 0 : overridden.__value) !== null && _c !== void 0 ? _c : layer.__value, (param)=>{
            if (options === null || options === void 0 ? void 0 : options.disableExposureLog) return;
            this._enqueueExposure(name, (0, $aALut._createLayerParameterExposure)(this._user, result, param, this._store.getExposureMapping()), options);
        });
        this.$emt({
            name: "layer_evaluation",
            layer: result
        });
        return result;
    }
    _getParameterStoreImpl(name, options) {
        var _a, _b;
        const { result: configuration, details: details } = this._store.getParamStore(name);
        this._logger.incrementNonExposureCount(name);
        const paramStore = {
            name: name,
            details: details,
            __configuration: configuration,
            get: (0, $cN42m._makeParamStoreGetter)(this, configuration, options)
        };
        const overridden = (_b = (_a = this.overrideAdapter) === null || _a === void 0 ? void 0 : _a.getParamStoreOverride) === null || _b === void 0 ? void 0 : _b.call(_a, paramStore, options);
        if (overridden != null) {
            paramStore.__configuration = overridden.config;
            paramStore.details = overridden.details;
            paramStore.get = (0, $cN42m._makeParamStoreGetter)(this, overridden.config, options);
        }
        return paramStore;
    }
}
module.exports.default = $d1c12128c2508e27$var$StatsigClient;

});
parcelRegister("aALut", function(module, exports) {
"use strict";
var $7b621acf9abf3fd6$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $7b621acf9abf3fd6$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $7b621acf9abf3fd6$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Storage = module.exports.Log = module.exports.EventLogger = module.exports.Diagnostics = void 0;


Object.defineProperty(module.exports, "Diagnostics", {
    enumerable: true,
    get: function() {
        return (parcelRequire("bPiJc")).Diagnostics;
    }
});

var $hIjZl = parcelRequire("hIjZl");
Object.defineProperty(module.exports, "EventLogger", {
    enumerable: true,
    get: function() {
        return $hIjZl.EventLogger;
    }
});

Object.defineProperty(module.exports, "Log", {
    enumerable: true,
    get: function() {
        return (parcelRequire("6NMPc")).Log;
    }
});


Object.defineProperty(module.exports, "Storage", {
    enumerable: true,
    get: function() {
        return (parcelRequire("esT98")).Storage;
    }
});

$7b621acf9abf3fd6$var$__exportStar((parcelRequire("bx6oK")), module.exports);

$7b621acf9abf3fd6$var$__exportStar((parcelRequire("hJcO9")), module.exports);

$7b621acf9abf3fd6$var$__exportStar((parcelRequire("dZVNH")), module.exports);

$7b621acf9abf3fd6$var$__exportStar((parcelRequire("5z75Y")), module.exports);

$7b621acf9abf3fd6$var$__exportStar((parcelRequire("bPiJc")), module.exports);

$7b621acf9abf3fd6$var$__exportStar((parcelRequire("wyuU1")), module.exports);

$7b621acf9abf3fd6$var$__exportStar((parcelRequire("8a96B")), module.exports);

$7b621acf9abf3fd6$var$__exportStar((parcelRequire("hNR37")), module.exports);

$7b621acf9abf3fd6$var$__exportStar((parcelRequire("eMrEI")), module.exports);

$7b621acf9abf3fd6$var$__exportStar((parcelRequire("luQa5")), module.exports);

$7b621acf9abf3fd6$var$__exportStar((parcelRequire("1LfXe")), module.exports);

$7b621acf9abf3fd6$var$__exportStar((parcelRequire("6NMPc")), module.exports);

$7b621acf9abf3fd6$var$__exportStar((parcelRequire("7dy1y")), module.exports);

$7b621acf9abf3fd6$var$__exportStar((parcelRequire("9kbTT")), module.exports);

$7b621acf9abf3fd6$var$__exportStar((parcelRequire("eFZRd")), module.exports);

$7b621acf9abf3fd6$var$__exportStar((parcelRequire("kZaDF")), module.exports);

$7b621acf9abf3fd6$var$__exportStar((parcelRequire("9es69")), module.exports);

$7b621acf9abf3fd6$var$__exportStar((parcelRequire("dKF5C")), module.exports);

$7b621acf9abf3fd6$var$__exportStar((parcelRequire("bqfSv")), module.exports);

$7b621acf9abf3fd6$var$__exportStar((parcelRequire("jvmJD")), module.exports);

$7b621acf9abf3fd6$var$__exportStar((parcelRequire("eNs8z")), module.exports);

$7b621acf9abf3fd6$var$__exportStar((parcelRequire("e6vI6")), module.exports);

$7b621acf9abf3fd6$var$__exportStar((parcelRequire("4bHKt")), module.exports);

$7b621acf9abf3fd6$var$__exportStar((parcelRequire("8Vj6d")), module.exports);

$7b621acf9abf3fd6$var$__exportStar((parcelRequire("92BAd")), module.exports);

$7b621acf9abf3fd6$var$__exportStar((parcelRequire("jJ1d3")), module.exports);

$7b621acf9abf3fd6$var$__exportStar((parcelRequire("jFwIL")), module.exports);

$7b621acf9abf3fd6$var$__exportStar((parcelRequire("aJX92")), module.exports);

$7b621acf9abf3fd6$var$__exportStar((parcelRequire("6TtU4")), module.exports);

$7b621acf9abf3fd6$var$__exportStar((parcelRequire("9K3az")), module.exports);

$7b621acf9abf3fd6$var$__exportStar((parcelRequire("1O1gA")), module.exports);

$7b621acf9abf3fd6$var$__exportStar((parcelRequire("esT98")), module.exports);

$7b621acf9abf3fd6$var$__exportStar((parcelRequire("43uRY")), module.exports);

$7b621acf9abf3fd6$var$__exportStar((parcelRequire("9JIh7")), module.exports);

$7b621acf9abf3fd6$var$__exportStar((parcelRequire("92k5h")), module.exports);

$7b621acf9abf3fd6$var$__exportStar((parcelRequire("18vEo")), module.exports);

$7b621acf9abf3fd6$var$__exportStar((parcelRequire("i5JCF")), module.exports);

$7b621acf9abf3fd6$var$__exportStar((parcelRequire("kACZd")), module.exports);

$7b621acf9abf3fd6$var$__exportStar((parcelRequire("idhq5")), module.exports);
__STATSIG__ = Object.assign(Object.assign({}, __STATSIG__ !== null && __STATSIG__ !== void 0 ? __STATSIG__ : {}), {
    Log: (parcelRequire("6NMPc")).Log,
    SDK_VERSION: (parcelRequire("jJ1d3")).SDK_VERSION
});

});
parcelRegister("bx6oK", function(module, exports) {
"use strict";
/* eslint-disable @typescript-eslint/no-unsafe-assignment */ var $8657bd4b05c9d8ce$var$_a, $8657bd4b05c9d8ce$var$_b, $8657bd4b05c9d8ce$var$_c;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._getInstance = module.exports._getStatsigGlobalFlag = module.exports._getStatsigGlobal = void 0;

var $6NMPc = parcelRequire("6NMPc");
const $8657bd4b05c9d8ce$var$_getStatsigGlobal = ()=>{
    return __STATSIG__ ? __STATSIG__ : $8657bd4b05c9d8ce$var$statsigGlobal;
};
module.exports._getStatsigGlobal = $8657bd4b05c9d8ce$var$_getStatsigGlobal;
const $8657bd4b05c9d8ce$var$_getStatsigGlobalFlag = (flag)=>{
    return (0, module.exports._getStatsigGlobal)()[flag];
};
module.exports._getStatsigGlobalFlag = $8657bd4b05c9d8ce$var$_getStatsigGlobalFlag;
const $8657bd4b05c9d8ce$var$_getInstance = (sdkKey)=>{
    const gbl = (0, module.exports._getStatsigGlobal)();
    if (!sdkKey) {
        if (gbl.instances && Object.keys(gbl.instances).length > 1) $6NMPc.Log.warn("Call made to Statsig global instance without an SDK key but there is more than one client instance. If you are using mulitple clients, please specify the SDK key.");
        return gbl.firstInstance;
    }
    return gbl.instances && gbl.instances[sdkKey];
};
module.exports._getInstance = $8657bd4b05c9d8ce$var$_getInstance;
const $8657bd4b05c9d8ce$var$GLOBAL_KEY = "__STATSIG__";
const $8657bd4b05c9d8ce$var$_window = typeof window !== "undefined" ? window : {};
const $8657bd4b05c9d8ce$var$_global = typeof $parcel$global !== "undefined" ? $parcel$global : {};
const $8657bd4b05c9d8ce$var$_globalThis = typeof globalThis !== "undefined" ? globalThis : {};
const $8657bd4b05c9d8ce$var$statsigGlobal = ($8657bd4b05c9d8ce$var$_c = ($8657bd4b05c9d8ce$var$_b = ($8657bd4b05c9d8ce$var$_a = $8657bd4b05c9d8ce$var$_window[$8657bd4b05c9d8ce$var$GLOBAL_KEY]) !== null && $8657bd4b05c9d8ce$var$_a !== void 0 ? $8657bd4b05c9d8ce$var$_a : $8657bd4b05c9d8ce$var$_global[$8657bd4b05c9d8ce$var$GLOBAL_KEY]) !== null && $8657bd4b05c9d8ce$var$_b !== void 0 ? $8657bd4b05c9d8ce$var$_b : $8657bd4b05c9d8ce$var$_globalThis[$8657bd4b05c9d8ce$var$GLOBAL_KEY]) !== null && $8657bd4b05c9d8ce$var$_c !== void 0 ? $8657bd4b05c9d8ce$var$_c : {
    instance: module.exports._getInstance
};
$8657bd4b05c9d8ce$var$_window[$8657bd4b05c9d8ce$var$GLOBAL_KEY] = $8657bd4b05c9d8ce$var$statsigGlobal;
$8657bd4b05c9d8ce$var$_global[$8657bd4b05c9d8ce$var$GLOBAL_KEY] = $8657bd4b05c9d8ce$var$statsigGlobal;
$8657bd4b05c9d8ce$var$_globalThis[$8657bd4b05c9d8ce$var$GLOBAL_KEY] = $8657bd4b05c9d8ce$var$statsigGlobal;

});
parcelRegister("6NMPc", function(module, exports) {
"use strict";
/* eslint-disable no-console */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Log = module.exports.LogLevel = void 0;
// intentionally spaced for formatting
const $4f3d314827d89564$var$DEBUG = " DEBUG ";
const $4f3d314827d89564$var$_INFO = "  INFO ";
const $4f3d314827d89564$var$_WARN = "  WARN ";
const $4f3d314827d89564$var$ERROR = " ERROR ";
function $4f3d314827d89564$var$addTag(args) {
    args.unshift("[Statsig]");
    return args; // ['[Statsig]', ...args];
}
module.exports.LogLevel = {
    None: 0,
    Error: 1,
    Warn: 2,
    Info: 3,
    Debug: 4
};
class $4f3d314827d89564$var$Log {
    static info(...args) {
        if ($4f3d314827d89564$var$Log.level >= module.exports.LogLevel.Info) console.info($4f3d314827d89564$var$_INFO, ...$4f3d314827d89564$var$addTag(args));
    }
    static debug(...args) {
        if ($4f3d314827d89564$var$Log.level >= module.exports.LogLevel.Debug) console.debug($4f3d314827d89564$var$DEBUG, ...$4f3d314827d89564$var$addTag(args));
    }
    static warn(...args) {
        if ($4f3d314827d89564$var$Log.level >= module.exports.LogLevel.Warn) console.warn($4f3d314827d89564$var$_WARN, ...$4f3d314827d89564$var$addTag(args));
    }
    static error(...args) {
        if ($4f3d314827d89564$var$Log.level >= module.exports.LogLevel.Error) console.error($4f3d314827d89564$var$ERROR, ...$4f3d314827d89564$var$addTag(args));
    }
}
module.exports.Log = $4f3d314827d89564$var$Log;
$4f3d314827d89564$var$Log.level = module.exports.LogLevel.Warn;

});


parcelRegister("bPiJc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Diagnostics = void 0;
const $89c2fc1996120416$var$MARKER_MAP = new Map();
const $89c2fc1996120416$var$ACT_START = "start";
const $89c2fc1996120416$var$ACT_END = "end";
const $89c2fc1996120416$var$DIAGNOSTICS_EVENT = "statsig::diagnostics";
module.exports.Diagnostics = {
    _getMarkers: (sdkKey)=>{
        return $89c2fc1996120416$var$MARKER_MAP.get(sdkKey);
    },
    _markInitOverallStart: (sdkKey)=>{
        $89c2fc1996120416$var$_addMarker(sdkKey, $89c2fc1996120416$var$_createMarker({}, $89c2fc1996120416$var$ACT_START, "overall"));
    },
    _markInitOverallEnd: (sdkKey, success, evaluationDetails)=>{
        $89c2fc1996120416$var$_addMarker(sdkKey, $89c2fc1996120416$var$_createMarker({
            success: success,
            error: success ? undefined : {
                name: "InitializeError",
                message: "Failed to initialize"
            },
            evaluationDetails: evaluationDetails
        }, $89c2fc1996120416$var$ACT_END, "overall"));
    },
    _markInitNetworkReqStart: (sdkKey, data)=>{
        $89c2fc1996120416$var$_addMarker(sdkKey, $89c2fc1996120416$var$_createMarker(data, $89c2fc1996120416$var$ACT_START, "initialize", "network_request"));
    },
    _markInitNetworkReqEnd: (sdkKey, data)=>{
        $89c2fc1996120416$var$_addMarker(sdkKey, $89c2fc1996120416$var$_createMarker(data, $89c2fc1996120416$var$ACT_END, "initialize", "network_request"));
    },
    _markInitProcessStart: (sdkKey)=>{
        $89c2fc1996120416$var$_addMarker(sdkKey, $89c2fc1996120416$var$_createMarker({}, $89c2fc1996120416$var$ACT_START, "initialize", "process"));
    },
    _markInitProcessEnd: (sdkKey, data)=>{
        $89c2fc1996120416$var$_addMarker(sdkKey, $89c2fc1996120416$var$_createMarker(data, $89c2fc1996120416$var$ACT_END, "initialize", "process"));
    },
    _clearMarkers: (sdkKey)=>{
        $89c2fc1996120416$var$MARKER_MAP.delete(sdkKey);
    },
    _formatError (e) {
        if (!(e && typeof e === "object")) return;
        return {
            code: $89c2fc1996120416$var$_safeGetField(e, "code"),
            name: $89c2fc1996120416$var$_safeGetField(e, "name"),
            message: $89c2fc1996120416$var$_safeGetField(e, "message")
        };
    },
    _getDiagnosticsData (res, attempt, body, e) {
        var _a;
        return {
            success: (res === null || res === void 0 ? void 0 : res.ok) === true,
            statusCode: res === null || res === void 0 ? void 0 : res.status,
            sdkRegion: (_a = res === null || res === void 0 ? void 0 : res.headers) === null || _a === void 0 ? void 0 : _a.get("x-statsig-region"),
            isDelta: body.includes('"is_delta":true') === true ? true : undefined,
            attempt: attempt,
            error: module.exports.Diagnostics._formatError(e)
        };
    },
    _enqueueDiagnosticsEvent (user, logger, sdk, options) {
        const markers = module.exports.Diagnostics._getMarkers(sdk);
        if (markers == null || markers.length <= 0) return -1;
        const overallInitDuration = markers[markers.length - 1].timestamp - markers[0].timestamp;
        module.exports.Diagnostics._clearMarkers(sdk);
        const event = $89c2fc1996120416$var$_makeDiagnosticsEvent(user, {
            context: "initialize",
            markers: markers.slice(),
            statsigOptions: options
        });
        logger.enqueue(event);
        return overallInitDuration;
    }
};
function $89c2fc1996120416$var$_createMarker(data, action, key, step) {
    return Object.assign({
        key: key,
        action: action,
        step: step,
        timestamp: Date.now()
    }, data);
}
function $89c2fc1996120416$var$_makeDiagnosticsEvent(user, data) {
    const latencyEvent = {
        eventName: $89c2fc1996120416$var$DIAGNOSTICS_EVENT,
        user: user,
        value: null,
        metadata: data,
        time: Date.now()
    };
    return latencyEvent;
}
function $89c2fc1996120416$var$_addMarker(sdkKey, marker) {
    var _a;
    const markers = (_a = $89c2fc1996120416$var$MARKER_MAP.get(sdkKey)) !== null && _a !== void 0 ? _a : [];
    markers.push(marker);
    $89c2fc1996120416$var$MARKER_MAP.set(sdkKey, markers);
}
function $89c2fc1996120416$var$_safeGetField(data, field) {
    if (field in data) return data[field];
    return undefined;
}

});

parcelRegister("hIjZl", function(module, exports) {
"use strict";
var $ce560d0645225469$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.EventLogger = void 0;

var $hJcO9 = parcelRequire("hJcO9");

var $luQa5 = parcelRequire("luQa5");

var $6NMPc = parcelRequire("6NMPc");

var $9kbTT = parcelRequire("9kbTT");

var $dKF5C = parcelRequire("dKF5C");

var $92BAd = parcelRequire("92BAd");

var $esT98 = parcelRequire("esT98");

var $92k5h = parcelRequire("92k5h");

var $i5JCF = parcelRequire("i5JCF");
const $ce560d0645225469$var$DEFAULT_QUEUE_SIZE = 100;
const $ce560d0645225469$var$DEFAULT_FLUSH_INTERVAL_MS = 10000;
const $ce560d0645225469$var$MAX_DEDUPER_KEYS = 1000;
const $ce560d0645225469$var$DEDUPER_WINDOW_DURATION_MS = 600000;
const $ce560d0645225469$var$MAX_FAILED_LOGS = 500;
const $ce560d0645225469$var$QUICK_FLUSH_WINDOW_MS = 200;
const $ce560d0645225469$var$EVENT_LOGGER_MAP = {};
const $ce560d0645225469$var$RetryFailedLogsTrigger = {
    Startup: "startup",
    GainedFocus: "gained_focus"
};
class $ce560d0645225469$var$EventLogger {
    static _safeFlushAndForget(sdkKey) {
        var _a;
        (_a = $ce560d0645225469$var$EVENT_LOGGER_MAP[sdkKey]) === null || _a === void 0 || _a.flush().catch(()=>{
        // noop
        });
    }
    static _safeRetryFailedLogs(sdkKey) {
        var _a;
        (_a = $ce560d0645225469$var$EVENT_LOGGER_MAP[sdkKey]) === null || _a === void 0 || _a._retryFailedLogs($ce560d0645225469$var$RetryFailedLogsTrigger.GainedFocus);
    }
    constructor(_sdkKey, _emitter, _network, _options){
        var _a;
        this._sdkKey = _sdkKey;
        this._emitter = _emitter;
        this._network = _network;
        this._options = _options;
        this._queue = [];
        this._lastExposureTimeMap = {};
        this._nonExposedChecks = {};
        this._hasRunQuickFlush = false;
        this._creationTime = Date.now();
        this._isLoggingDisabled = (_options === null || _options === void 0 ? void 0 : _options.disableLogging) === true;
        this._maxQueueSize = (_a = _options === null || _options === void 0 ? void 0 : _options.loggingBufferMaxSize) !== null && _a !== void 0 ? _a : $ce560d0645225469$var$DEFAULT_QUEUE_SIZE;
        const config = _options === null || _options === void 0 ? void 0 : _options.networkConfig;
        this._logEventUrlConfig = new $92k5h.UrlConfiguration($9kbTT.Endpoint._rgstr, config === null || config === void 0 ? void 0 : config.logEventUrl, config === null || config === void 0 ? void 0 : config.api, config === null || config === void 0 ? void 0 : config.logEventFallbackUrls);
    }
    setLoggingDisabled(isDisabled) {
        this._isLoggingDisabled = isDisabled;
    }
    enqueue(event) {
        if (!this._shouldLogEvent(event)) return;
        this._normalizeAndAppendEvent(event);
        this._quickFlushIfNeeded();
        if (this._queue.length > this._maxQueueSize) $ce560d0645225469$var$EventLogger._safeFlushAndForget(this._sdkKey);
    }
    incrementNonExposureCount(name) {
        var _a;
        const current = (_a = this._nonExposedChecks[name]) !== null && _a !== void 0 ? _a : 0;
        this._nonExposedChecks[name] = current + 1;
    }
    reset() {
        this._lastExposureTimeMap = {};
    }
    start() {
        if ((0, $dKF5C._isServerEnv)()) return; // do not run in server environments
        $ce560d0645225469$var$EVENT_LOGGER_MAP[this._sdkKey] = this;
        (0, $i5JCF._subscribeToVisiblityChanged)((visibility)=>{
            if (visibility === "background") $ce560d0645225469$var$EventLogger._safeFlushAndForget(this._sdkKey);
            else if (visibility === "foreground") $ce560d0645225469$var$EventLogger._safeRetryFailedLogs(this._sdkKey);
        });
        this._retryFailedLogs($ce560d0645225469$var$RetryFailedLogsTrigger.Startup);
        this._startBackgroundFlushInterval();
    }
    stop() {
        return $ce560d0645225469$var$__awaiter(this, void 0, void 0, function*() {
            if (this._flushIntervalId) {
                clearInterval(this._flushIntervalId);
                this._flushIntervalId = null;
            }
            delete $ce560d0645225469$var$EVENT_LOGGER_MAP[this._sdkKey];
            yield this.flush();
        });
    }
    flush() {
        return $ce560d0645225469$var$__awaiter(this, void 0, void 0, function*() {
            this._appendAndResetNonExposedChecks();
            if (this._queue.length === 0) return;
            const events = this._queue;
            this._queue = [];
            yield this._sendEvents(events);
        });
    }
    /**
     * We 'Quick Flush' following the very first event enqueued
     * within the quick flush window
     */ _quickFlushIfNeeded() {
        if (this._hasRunQuickFlush) return;
        this._hasRunQuickFlush = true;
        if (Date.now() - this._creationTime > $ce560d0645225469$var$QUICK_FLUSH_WINDOW_MS) return;
        setTimeout(()=>$ce560d0645225469$var$EventLogger._safeFlushAndForget(this._sdkKey), $ce560d0645225469$var$QUICK_FLUSH_WINDOW_MS);
    }
    _shouldLogEvent(event) {
        if ((0, $dKF5C._isServerEnv)()) return false; // do not run in server environments
        if (!(0, $92BAd._isExposureEvent)(event)) return true;
        const user = event.user ? event.user : {
            statsigEnvironment: undefined
        };
        const userKey = (0, $hJcO9._getUserStorageKey)(this._sdkKey, user);
        const metadata = event.metadata ? event.metadata : {};
        const key = [
            event.eventName,
            userKey,
            metadata["gate"],
            metadata["config"],
            metadata["ruleID"],
            metadata["allocatedExperiment"],
            metadata["parameterName"],
            String(metadata["isExplicitParameter"]),
            metadata["reason"]
        ].join("|");
        const previous = this._lastExposureTimeMap[key];
        const now = Date.now();
        if (previous && now - previous < $ce560d0645225469$var$DEDUPER_WINDOW_DURATION_MS) return false;
        if (Object.keys(this._lastExposureTimeMap).length > $ce560d0645225469$var$MAX_DEDUPER_KEYS) this._lastExposureTimeMap = {};
        this._lastExposureTimeMap[key] = now;
        return true;
    }
    _sendEvents(events) {
        var _a, _b;
        return $ce560d0645225469$var$__awaiter(this, void 0, void 0, function*() {
            if (this._isLoggingDisabled) {
                this._saveFailedLogsToStorage(events);
                return false;
            }
            try {
                const isClosing = (0, $i5JCF._isUnloading)();
                const shouldUseBeacon = isClosing && this._network.isBeaconSupported() && ((_b = (_a = this._options) === null || _a === void 0 ? void 0 : _a.networkConfig) === null || _b === void 0 ? void 0 : _b.networkOverrideFunc) == null;
                this._emitter({
                    name: "pre_logs_flushed",
                    events: events
                });
                const response = shouldUseBeacon ? yield this._sendEventsViaBeacon(events) : yield this._sendEventsViaPost(events);
                if (response.success) {
                    this._emitter({
                        name: "logs_flushed",
                        events: events
                    });
                    return true;
                } else {
                    $6NMPc.Log.warn("Failed to flush events.");
                    this._saveFailedLogsToStorage(events);
                    return false;
                }
            } catch (_c) {
                $6NMPc.Log.warn("Failed to flush events.");
                return false;
            }
        });
    }
    _sendEventsViaPost(events) {
        var _a;
        return $ce560d0645225469$var$__awaiter(this, void 0, void 0, function*() {
            const result = yield this._network.post(this._getRequestData(events));
            const code = (_a = result === null || result === void 0 ? void 0 : result.code) !== null && _a !== void 0 ? _a : -1;
            return {
                success: code >= 200 && code < 300
            };
        });
    }
    _sendEventsViaBeacon(events) {
        return $ce560d0645225469$var$__awaiter(this, void 0, void 0, function*() {
            return {
                success: yield this._network.beacon(this._getRequestData(events))
            };
        });
    }
    _getRequestData(events) {
        return {
            sdkKey: this._sdkKey,
            data: {
                events: events
            },
            urlConfig: this._logEventUrlConfig,
            retries: 3,
            isCompressable: true,
            params: {
                [$9kbTT.NetworkParam.EventCount]: String(events.length)
            }
        };
    }
    _saveFailedLogsToStorage(events) {
        while(events.length > $ce560d0645225469$var$MAX_FAILED_LOGS)events.shift();
        const storageKey = this._getStorageKey();
        try {
            (0, $esT98._setObjectInStorage)(storageKey, events);
        } catch (_a) {
            $6NMPc.Log.warn("Unable to save failed logs to storage");
        }
    }
    _retryFailedLogs(trigger) {
        const storageKey = this._getStorageKey();
        (()=>$ce560d0645225469$var$__awaiter(this, void 0, void 0, function*() {
                if (!$esT98.Storage.isReady()) yield $esT98.Storage.isReadyResolver();
                const events = (0, $esT98._getObjectFromStorage)(storageKey);
                if (!events) return;
                if (trigger === $ce560d0645225469$var$RetryFailedLogsTrigger.Startup) $esT98.Storage.removeItem(storageKey);
                const isSuccess = yield this._sendEvents(events);
                if (isSuccess && trigger === $ce560d0645225469$var$RetryFailedLogsTrigger.GainedFocus) $esT98.Storage.removeItem(storageKey);
            }))().catch(()=>{
            $6NMPc.Log.warn("Failed to flush stored logs");
        });
    }
    _getStorageKey() {
        return `statsig.failed_logs.${(0, $luQa5._DJB2)(this._sdkKey)}`;
    }
    _normalizeAndAppendEvent(event) {
        if (event.user) {
            event.user = Object.assign({}, event.user);
            delete event.user.privateAttributes;
        }
        const extras = {};
        const currentPage = this._getCurrentPageUrl();
        if (currentPage) extras.statsigMetadata = {
            currentPage: currentPage
        };
        const final = Object.assign(Object.assign({}, event), extras);
        $6NMPc.Log.debug("Enqueued Event:", final);
        this._queue.push(final);
    }
    _appendAndResetNonExposedChecks() {
        if (Object.keys(this._nonExposedChecks).length === 0) return;
        this._normalizeAndAppendEvent({
            eventName: "statsig::non_exposed_checks",
            user: null,
            time: Date.now(),
            metadata: {
                checks: Object.assign({}, this._nonExposedChecks)
            }
        });
        this._nonExposedChecks = {};
    }
    _getCurrentPageUrl() {
        var _a;
        if (((_a = this._options) === null || _a === void 0 ? void 0 : _a.includeCurrentPageUrlWithEvents) === false) return;
        return (0, $dKF5C._getCurrentPageUrlSafe)();
    }
    _startBackgroundFlushInterval() {
        var _a, _b;
        const flushInterval = (_b = (_a = this._options) === null || _a === void 0 ? void 0 : _a.loggingIntervalMs) !== null && _b !== void 0 ? _b : $ce560d0645225469$var$DEFAULT_FLUSH_INTERVAL_MS;
        const intervalId = setInterval(()=>{
            const logger = $ce560d0645225469$var$EVENT_LOGGER_MAP[this._sdkKey];
            if (!logger || logger._flushIntervalId !== intervalId) clearInterval(intervalId);
            else $ce560d0645225469$var$EventLogger._safeFlushAndForget(this._sdkKey);
        }, flushInterval);
        this._flushIntervalId = intervalId;
    }
}
module.exports.EventLogger = $ce560d0645225469$var$EventLogger;

});
parcelRegister("hJcO9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._getStorageKey = module.exports._getUserStorageKey = void 0;

var $luQa5 = parcelRequire("luQa5");
function $ce80930ac695fd54$var$_getUserStorageKey(sdkKey, user, customKeyGenerator) {
    var _a;
    if (customKeyGenerator) return customKeyGenerator(sdkKey, user);
    const cids = user && user.customIDs ? user.customIDs : {};
    const parts = [
        `uid:${(_a = user === null || user === void 0 ? void 0 : user.userID) !== null && _a !== void 0 ? _a : ""}`,
        `cids:${Object.keys(cids).sort((leftKey, rightKey)=>leftKey.localeCompare(rightKey)).map((key)=>`${key}-${cids[key]}`).join(",")}`,
        `k:${sdkKey}`
    ];
    return (0, $luQa5._DJB2)(parts.join("|"));
}
module.exports._getUserStorageKey = $ce80930ac695fd54$var$_getUserStorageKey;
function $ce80930ac695fd54$var$_getStorageKey(sdkKey, user, customKeyGenerator) {
    if (user) return $ce80930ac695fd54$var$_getUserStorageKey(sdkKey, user, customKeyGenerator);
    return (0, $luQa5._DJB2)(`k:${sdkKey}`);
}
module.exports._getStorageKey = $ce80930ac695fd54$var$_getStorageKey;

});
parcelRegister("luQa5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._getSortedObject = module.exports._DJB2Object = module.exports._DJB2 = void 0;

var $9JIh7 = parcelRequire("9JIh7");
const $fa64dc87d44fb485$var$_DJB2 = (value)=>{
    let hash = 0;
    for(let i = 0; i < value.length; i++){
        const character = value.charCodeAt(i);
        hash = (hash << 5) - hash + character;
        hash = hash & hash; // Convert to 32bit integer
    }
    return String(hash >>> 0);
};
module.exports._DJB2 = $fa64dc87d44fb485$var$_DJB2;
const $fa64dc87d44fb485$var$_DJB2Object = (value, maxLevels)=>{
    return (0, module.exports._DJB2)(JSON.stringify((0, module.exports._getSortedObject)(value, maxLevels)));
};
module.exports._DJB2Object = $fa64dc87d44fb485$var$_DJB2Object;
const $fa64dc87d44fb485$var$_getSortedObject = (object, maxDepth)=>{
    if (object == null) return null;
    const keys = Object.keys(object).sort();
    const sortedObject = {};
    keys.forEach((key)=>{
        const value = object[key];
        if (maxDepth === 0 || (0, $9JIh7._typeOf)(value) !== "object") {
            sortedObject[key] = value;
            return;
        }
        sortedObject[key] = (0, module.exports._getSortedObject)(value, maxDepth != null ? maxDepth - 1 : maxDepth);
    });
    return sortedObject;
};
module.exports._getSortedObject = $fa64dc87d44fb485$var$_getSortedObject;

});
parcelRegister("9JIh7", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._isTypeMatch = module.exports._typeOf = void 0;
function $716aa920ca271ca8$var$_typeOf(input) {
    return Array.isArray(input) ? "array" : typeof input;
}
module.exports._typeOf = $716aa920ca271ca8$var$_typeOf;
function $716aa920ca271ca8$var$_isTypeMatch(a, b) {
    const typeOf = (x)=>Array.isArray(x) ? "array" : typeof x;
    return typeOf(a) === typeOf(b);
}
module.exports._isTypeMatch = $716aa920ca271ca8$var$_isTypeMatch;

});



parcelRegister("9kbTT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.NetworkParam = module.exports.NetworkDefault = module.exports.Endpoint = void 0;
module.exports.Endpoint = {
    _initialize: "initialize",
    _rgstr: "rgstr",
    _download_config_specs: "download_config_specs"
};
module.exports.NetworkDefault = {
    [module.exports.Endpoint._rgstr]: "https://prodregistryv2.org/v1",
    [module.exports.Endpoint._initialize]: "https://featureassets.org/v1",
    [module.exports.Endpoint._download_config_specs]: "https://api.statsigcdn.com/v1"
};
module.exports.NetworkParam = {
    EventCount: "ec",
    SdkKey: "k",
    SdkType: "st",
    SdkVersion: "sv",
    Time: "t",
    SessionID: "sid",
    StatsigEncoded: "se",
    IsGzipped: "gz"
};

});

parcelRegister("dKF5C", function(module, exports) {

var $ahJoN = parcelRequire("ahJoN");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._getCurrentPageUrlSafe = module.exports._addDocumentEventListenerSafe = module.exports._addWindowEventListenerSafe = module.exports._isServerEnv = module.exports._getDocumentSafe = module.exports._getWindowSafe = void 0;
const $a02f71c80e70e27c$var$_getWindowSafe = ()=>{
    return typeof window !== "undefined" ? window : null;
};
module.exports._getWindowSafe = $a02f71c80e70e27c$var$_getWindowSafe;
const $a02f71c80e70e27c$var$_getDocumentSafe = ()=>{
    var _a;
    const win = (0, module.exports._getWindowSafe)();
    return (_a = win === null || win === void 0 ? void 0 : win.document) !== null && _a !== void 0 ? _a : null;
};
module.exports._getDocumentSafe = $a02f71c80e70e27c$var$_getDocumentSafe;
const $a02f71c80e70e27c$var$_isServerEnv = ()=>{
    if ((0, module.exports._getDocumentSafe)() !== null) return false;
    const isNode = typeof $ahJoN !== "undefined" && $ahJoN.versions != null && $ahJoN.versions.node != null;
    const isVercel = typeof EdgeRuntime === "string";
    return isVercel || isNode;
};
module.exports._isServerEnv = $a02f71c80e70e27c$var$_isServerEnv;
const $a02f71c80e70e27c$var$_addWindowEventListenerSafe = (key, listener)=>{
    const win = (0, module.exports._getWindowSafe)();
    if (typeof (win === null || win === void 0 ? void 0 : win.addEventListener) === "function") win.addEventListener(key, listener);
};
module.exports._addWindowEventListenerSafe = $a02f71c80e70e27c$var$_addWindowEventListenerSafe;
const $a02f71c80e70e27c$var$_addDocumentEventListenerSafe = (key, listener)=>{
    const doc = (0, module.exports._getDocumentSafe)();
    if (typeof (doc === null || doc === void 0 ? void 0 : doc.addEventListener) === "function") doc.addEventListener(key, listener);
};
module.exports._addDocumentEventListenerSafe = $a02f71c80e70e27c$var$_addDocumentEventListenerSafe;
const $a02f71c80e70e27c$var$_getCurrentPageUrlSafe = ()=>{
    var _a;
    try {
        return (_a = (0, module.exports._getWindowSafe)()) === null || _a === void 0 ? void 0 : _a.location.href.split(/[?#]/)[0];
    } catch (_b) {
        return;
    }
};
module.exports._getCurrentPageUrlSafe = $a02f71c80e70e27c$var$_getCurrentPageUrlSafe;

});

parcelRegister("92BAd", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._createLayerParameterExposure = module.exports._createConfigExposure = module.exports._mapExposures = module.exports._createGateExposure = module.exports._isExposureEvent = void 0;
const $69517429a912c08c$var$CONFIG_EXPOSURE_NAME = "statsig::config_exposure";
const $69517429a912c08c$var$GATE_EXPOSURE_NAME = "statsig::gate_exposure";
const $69517429a912c08c$var$LAYER_EXPOSURE_NAME = "statsig::layer_exposure";
const $69517429a912c08c$var$_createExposure = (eventName, user, details, metadata, secondaryExposures)=>{
    if (details.bootstrapMetadata) metadata["bootstrapMetadata"] = details.bootstrapMetadata;
    return {
        eventName: eventName,
        user: user,
        value: null,
        metadata: $69517429a912c08c$var$_addEvaluationDetailsToMetadata(details, metadata),
        secondaryExposures: secondaryExposures,
        time: Date.now()
    };
};
const $69517429a912c08c$var$_isExposureEvent = ({ eventName: eventName })=>{
    return eventName === $69517429a912c08c$var$GATE_EXPOSURE_NAME || eventName === $69517429a912c08c$var$CONFIG_EXPOSURE_NAME || eventName === $69517429a912c08c$var$LAYER_EXPOSURE_NAME;
};
module.exports._isExposureEvent = $69517429a912c08c$var$_isExposureEvent;
const $69517429a912c08c$var$_createGateExposure = (user, gate, exposureMapping)=>{
    var _a, _b, _c;
    const metadata = {
        gate: gate.name,
        gateValue: String(gate.value),
        ruleID: gate.ruleID
    };
    if (((_a = gate.__evaluation) === null || _a === void 0 ? void 0 : _a.version) != null) metadata["configVersion"] = gate.__evaluation.version;
    return $69517429a912c08c$var$_createExposure($69517429a912c08c$var$GATE_EXPOSURE_NAME, user, gate.details, metadata, $69517429a912c08c$var$_mapExposures((_c = (_b = gate.__evaluation) === null || _b === void 0 ? void 0 : _b.secondary_exposures) !== null && _c !== void 0 ? _c : [], exposureMapping));
};
module.exports._createGateExposure = $69517429a912c08c$var$_createGateExposure;
function $69517429a912c08c$var$_mapExposures(exposures, exposureMapping) {
    return exposures.map((exposure)=>{
        if (typeof exposure === "string") return (exposureMapping !== null && exposureMapping !== void 0 ? exposureMapping : {})[exposure];
        return exposure;
    }).filter((exposure)=>exposure != null);
}
module.exports._mapExposures = $69517429a912c08c$var$_mapExposures;
const $69517429a912c08c$var$_createConfigExposure = (user, config, exposureMapping)=>{
    var _a, _b, _c, _d;
    const metadata = {
        config: config.name,
        ruleID: config.ruleID
    };
    if (((_a = config.__evaluation) === null || _a === void 0 ? void 0 : _a.version) != null) metadata["configVersion"] = config.__evaluation.version;
    if (((_b = config.__evaluation) === null || _b === void 0 ? void 0 : _b.passed) != null) metadata["rulePassed"] = String(config.__evaluation.passed);
    return $69517429a912c08c$var$_createExposure($69517429a912c08c$var$CONFIG_EXPOSURE_NAME, user, config.details, metadata, $69517429a912c08c$var$_mapExposures((_d = (_c = config.__evaluation) === null || _c === void 0 ? void 0 : _c.secondary_exposures) !== null && _d !== void 0 ? _d : [], exposureMapping));
};
module.exports._createConfigExposure = $69517429a912c08c$var$_createConfigExposure;
const $69517429a912c08c$var$_createLayerParameterExposure = (user, layer, parameterName, exposureMapping)=>{
    var _a, _b, _c, _d;
    const evaluation = layer.__evaluation;
    const isExplicit = ((_a = evaluation === null || evaluation === void 0 ? void 0 : evaluation.explicit_parameters) === null || _a === void 0 ? void 0 : _a.includes(parameterName)) === true;
    let allocatedExperiment = "";
    let secondaryExposures = (_b = evaluation === null || evaluation === void 0 ? void 0 : evaluation.undelegated_secondary_exposures) !== null && _b !== void 0 ? _b : [];
    if (isExplicit) {
        allocatedExperiment = (_c = evaluation.allocated_experiment_name) !== null && _c !== void 0 ? _c : "";
        secondaryExposures = evaluation.secondary_exposures;
    }
    const metadata = {
        config: layer.name,
        parameterName: parameterName,
        ruleID: layer.ruleID,
        allocatedExperiment: allocatedExperiment,
        isExplicitParameter: String(isExplicit)
    };
    if (((_d = layer.__evaluation) === null || _d === void 0 ? void 0 : _d.version) != null) metadata["configVersion"] = layer.__evaluation.version;
    return $69517429a912c08c$var$_createExposure($69517429a912c08c$var$LAYER_EXPOSURE_NAME, user, layer.details, metadata, $69517429a912c08c$var$_mapExposures(secondaryExposures, exposureMapping));
};
module.exports._createLayerParameterExposure = $69517429a912c08c$var$_createLayerParameterExposure;
const $69517429a912c08c$var$_addEvaluationDetailsToMetadata = (details, metadata)=>{
    metadata["reason"] = details.reason;
    if (details.lcut) metadata["lcut"] = String(details.lcut);
    if (details.receivedAt) metadata["receivedAt"] = String(details.receivedAt);
    return metadata;
};

});

parcelRegister("esT98", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._setObjectInStorage = module.exports._getObjectFromStorage = module.exports.Storage = void 0;

var $6NMPc = parcelRequire("6NMPc");

var $dKF5C = parcelRequire("dKF5C");
const $a87e751f37580e0e$var$inMemoryStore = {};
const $a87e751f37580e0e$var$_inMemoryProvider = {
    isReady: ()=>true,
    isReadyResolver: ()=>null,
    getProviderName: ()=>"InMemory",
    getItem: (key)=>$a87e751f37580e0e$var$inMemoryStore[key] ? $a87e751f37580e0e$var$inMemoryStore[key] : null,
    setItem: (key, value)=>{
        $a87e751f37580e0e$var$inMemoryStore[key] = value;
    },
    removeItem: (key)=>{
        delete $a87e751f37580e0e$var$inMemoryStore[key];
    },
    getAllKeys: ()=>Object.keys($a87e751f37580e0e$var$inMemoryStore)
};
let $a87e751f37580e0e$var$_localStorageProvider = null;
try {
    const win = (0, $dKF5C._getWindowSafe)();
    if (win && win.localStorage && typeof win.localStorage.getItem === "function") $a87e751f37580e0e$var$_localStorageProvider = {
        isReady: ()=>true,
        isReadyResolver: ()=>null,
        getProviderName: ()=>"LocalStorage",
        getItem: (key)=>win.localStorage.getItem(key),
        setItem: (key, value)=>win.localStorage.setItem(key, value),
        removeItem: (key)=>win.localStorage.removeItem(key),
        getAllKeys: ()=>Object.keys(win.localStorage)
    };
} catch (error) {
    $6NMPc.Log.warn("Failed to setup localStorageProvider.");
}
let $a87e751f37580e0e$var$_main = $a87e751f37580e0e$var$_localStorageProvider !== null && $a87e751f37580e0e$var$_localStorageProvider !== void 0 ? $a87e751f37580e0e$var$_localStorageProvider : $a87e751f37580e0e$var$_inMemoryProvider;
let $a87e751f37580e0e$var$_current = $a87e751f37580e0e$var$_main;
function $a87e751f37580e0e$var$_inMemoryBreaker(get) {
    try {
        return get();
    } catch (error) {
        if (error instanceof Error && error.name === "SecurityError") {
            module.exports.Storage._setProvider($a87e751f37580e0e$var$_inMemoryProvider);
            return null;
        }
        throw error;
    }
}
module.exports.Storage = {
    isReady: ()=>$a87e751f37580e0e$var$_current.isReady(),
    isReadyResolver: ()=>$a87e751f37580e0e$var$_current.isReadyResolver(),
    getProviderName: ()=>$a87e751f37580e0e$var$_current.getProviderName(),
    getItem: (key)=>$a87e751f37580e0e$var$_inMemoryBreaker(()=>$a87e751f37580e0e$var$_current.getItem(key)),
    setItem: (key, value)=>$a87e751f37580e0e$var$_current.setItem(key, value),
    removeItem: (key)=>$a87e751f37580e0e$var$_current.removeItem(key),
    getAllKeys: ()=>$a87e751f37580e0e$var$_current.getAllKeys(),
    // StorageProviderManagment
    _setProvider: (newProvider)=>{
        $a87e751f37580e0e$var$_main = newProvider;
        $a87e751f37580e0e$var$_current = newProvider;
    },
    _setDisabled: (isDisabled)=>{
        if (isDisabled) $a87e751f37580e0e$var$_current = $a87e751f37580e0e$var$_inMemoryProvider;
        else $a87e751f37580e0e$var$_current = $a87e751f37580e0e$var$_main;
    }
};
function $a87e751f37580e0e$var$_getObjectFromStorage(key) {
    const value = module.exports.Storage.getItem(key);
    return JSON.parse(value !== null && value !== void 0 ? value : "null");
}
module.exports._getObjectFromStorage = $a87e751f37580e0e$var$_getObjectFromStorage;
function $a87e751f37580e0e$var$_setObjectInStorage(key, obj) {
    module.exports.Storage.setItem(key, JSON.stringify(obj));
}
module.exports._setObjectInStorage = $a87e751f37580e0e$var$_setObjectInStorage;

});

parcelRegister("92k5h", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.UrlConfiguration = void 0;

var $9kbTT = parcelRequire("9kbTT");
const $6943e140207d7fd1$var$ENDPOINT_DNS_KEY_MAP = {
    [$9kbTT.Endpoint._initialize]: "i",
    [$9kbTT.Endpoint._rgstr]: "e",
    [$9kbTT.Endpoint._download_config_specs]: "d"
};
class $6943e140207d7fd1$var$UrlConfiguration {
    constructor(endpoint, customUrl, customApi, fallbackUrls){
        this.customUrl = null;
        this.fallbackUrls = null;
        this.endpoint = endpoint;
        this.endpointDnsKey = $6943e140207d7fd1$var$ENDPOINT_DNS_KEY_MAP[endpoint];
        if (customUrl) this.customUrl = customUrl;
        if (!customUrl && customApi) this.customUrl = customApi.endsWith("/") ? `${customApi}${endpoint}` : `${customApi}/${endpoint}`;
        if (fallbackUrls) this.fallbackUrls = fallbackUrls;
        const defaultApi = $9kbTT.NetworkDefault[endpoint];
        this.defaultUrl = `${defaultApi}/${endpoint}`;
    }
    getUrl() {
        var _a;
        return (_a = this.customUrl) !== null && _a !== void 0 ? _a : this.defaultUrl;
    }
}
module.exports.UrlConfiguration = $6943e140207d7fd1$var$UrlConfiguration;

});

parcelRegister("i5JCF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._notifyVisibilityChanged = module.exports._subscribeToVisiblityChanged = module.exports._isUnloading = module.exports._isCurrentlyVisible = void 0;

var $dKF5C = parcelRequire("dKF5C");
const $d2bc155050c101bc$var$FOREGROUND = "foreground";
const $d2bc155050c101bc$var$BACKGROUND = "background";
const $d2bc155050c101bc$var$LISTENERS = [];
let $d2bc155050c101bc$var$current = $d2bc155050c101bc$var$FOREGROUND;
let $d2bc155050c101bc$var$isUnloading = false;
const $d2bc155050c101bc$var$_isCurrentlyVisible = ()=>{
    return $d2bc155050c101bc$var$current === $d2bc155050c101bc$var$FOREGROUND;
};
module.exports._isCurrentlyVisible = $d2bc155050c101bc$var$_isCurrentlyVisible;
const $d2bc155050c101bc$var$_isUnloading = ()=>$d2bc155050c101bc$var$isUnloading;
module.exports._isUnloading = $d2bc155050c101bc$var$_isUnloading;
const $d2bc155050c101bc$var$_subscribeToVisiblityChanged = (listener)=>{
    $d2bc155050c101bc$var$LISTENERS.unshift(listener);
};
module.exports._subscribeToVisiblityChanged = $d2bc155050c101bc$var$_subscribeToVisiblityChanged;
const $d2bc155050c101bc$var$_notifyVisibilityChanged = (visibility)=>{
    if (visibility === $d2bc155050c101bc$var$current) return;
    $d2bc155050c101bc$var$current = visibility;
    $d2bc155050c101bc$var$LISTENERS.forEach((l)=>l(visibility));
};
module.exports._notifyVisibilityChanged = $d2bc155050c101bc$var$_notifyVisibilityChanged;
(0, $dKF5C._addWindowEventListenerSafe)("focus", ()=>{
    $d2bc155050c101bc$var$isUnloading = false;
    (0, module.exports._notifyVisibilityChanged)($d2bc155050c101bc$var$FOREGROUND);
});
(0, $dKF5C._addWindowEventListenerSafe)("blur", ()=>(0, module.exports._notifyVisibilityChanged)($d2bc155050c101bc$var$BACKGROUND));
(0, $dKF5C._addWindowEventListenerSafe)("beforeunload", ()=>{
    $d2bc155050c101bc$var$isUnloading = true;
    (0, module.exports._notifyVisibilityChanged)($d2bc155050c101bc$var$BACKGROUND);
});
(0, $dKF5C._addDocumentEventListenerSafe)("visibilitychange", ()=>{
    (0, module.exports._notifyVisibilityChanged)(document.visibilityState === "visible" ? $d2bc155050c101bc$var$FOREGROUND : $d2bc155050c101bc$var$BACKGROUND);
});

});


parcelRegister("jJ1d3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StatsigMetadataProvider = module.exports.SDK_VERSION = void 0;
module.exports.SDK_VERSION = "3.12.1";
let $e5c32880028d151b$var$metadata = {
    sdkVersion: module.exports.SDK_VERSION,
    sdkType: "js-mono"
};
module.exports.StatsigMetadataProvider = {
    get: ()=>$e5c32880028d151b$var$metadata,
    add: (additions)=>{
        $e5c32880028d151b$var$metadata = Object.assign(Object.assign({}, $e5c32880028d151b$var$metadata), additions);
    }
};

});

parcelRegister("dZVNH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("5z75Y", function(module, exports) {
"use strict";
var $40d5b9a5a4059c2e$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._makeDataAdapterResult = module.exports.DataAdapterCore = void 0;

var $6NMPc = parcelRequire("6NMPc");

var $eNs8z = parcelRequire("eNs8z");

var $1O1gA = parcelRequire("1O1gA");

var $esT98 = parcelRequire("esT98");

var $43uRY = parcelRequire("43uRY");
const $40d5b9a5a4059c2e$var$CACHE_LIMIT = 10;
class $40d5b9a5a4059c2e$var$DataAdapterCore {
    constructor(_adapterName, _cacheSuffix){
        this._adapterName = _adapterName;
        this._cacheSuffix = _cacheSuffix;
        this._options = null;
        this._sdkKey = null;
        this._lastModifiedStoreKey = `statsig.last_modified_time.${_cacheSuffix}`;
        this._inMemoryCache = new $40d5b9a5a4059c2e$var$InMemoryCache();
    }
    attach(sdkKey, options) {
        this._sdkKey = sdkKey;
        this._options = options;
    }
    getDataSync(user) {
        const normalized = user && (0, $1O1gA._normalizeUser)(user, this._options);
        const cacheKey = this._getCacheKey(normalized);
        const inMem = this._inMemoryCache.get(cacheKey, normalized);
        if (inMem) return inMem;
        const cache = this._loadFromCache(cacheKey);
        if (cache) {
            this._inMemoryCache.add(cacheKey, cache);
            return this._inMemoryCache.get(cacheKey, normalized);
        }
        return null;
    }
    setData(data, user) {
        const normalized = user && (0, $1O1gA._normalizeUser)(user, this._options);
        const cacheKey = this._getCacheKey(normalized);
        this._inMemoryCache.add(cacheKey, $40d5b9a5a4059c2e$var$_makeDataAdapterResult("Bootstrap", data, null, normalized));
    }
    _getDataAsyncImpl(current, user, options) {
        return $40d5b9a5a4059c2e$var$__awaiter(this, void 0, void 0, function*() {
            if (!$esT98.Storage.isReady()) yield $esT98.Storage.isReadyResolver();
            const cache = current !== null && current !== void 0 ? current : this.getDataSync(user);
            const ops = [
                this._fetchAndPrepFromNetwork(cache, user, options)
            ];
            if (options === null || options === void 0 ? void 0 : options.timeoutMs) ops.push(new Promise((r)=>setTimeout(r, options.timeoutMs)).then(()=>{
                $6NMPc.Log.debug("Fetching latest value timed out");
                return null;
            }));
            return yield Promise.race(ops);
        });
    }
    _prefetchDataImpl(user, options) {
        return $40d5b9a5a4059c2e$var$__awaiter(this, void 0, void 0, function*() {
            const normalized = user && (0, $1O1gA._normalizeUser)(user, this._options);
            const cacheKey = this._getCacheKey(normalized);
            const result = yield this._getDataAsyncImpl(null, normalized, options);
            if (result) this._inMemoryCache.add(cacheKey, Object.assign(Object.assign({}, result), {
                source: "Prefetch"
            }));
        });
    }
    _fetchAndPrepFromNetwork(cachedResult, user, options) {
        var _a;
        return $40d5b9a5a4059c2e$var$__awaiter(this, void 0, void 0, function*() {
            const cachedData = (_a = cachedResult === null || cachedResult === void 0 ? void 0 : cachedResult.data) !== null && _a !== void 0 ? _a : null;
            const isCacheValidFor204 = cachedResult != null && this._isCachedResultValidFor204(cachedResult, user);
            const latest = yield this._fetchFromNetwork(cachedData, user, options, isCacheValidFor204);
            if (!latest) {
                $6NMPc.Log.debug("No response returned for latest value");
                return null;
            }
            const response = (0, $43uRY._typedJsonParse)(latest, "has_updates", "Response");
            const sdkKey = this._getSdkKey();
            const stableID = $eNs8z.StableID.get(sdkKey);
            let result = null;
            if ((response === null || response === void 0 ? void 0 : response.has_updates) === true) result = $40d5b9a5a4059c2e$var$_makeDataAdapterResult("Network", latest, stableID, user);
            else if (cachedData && (response === null || response === void 0 ? void 0 : response.has_updates) === false) result = $40d5b9a5a4059c2e$var$_makeDataAdapterResult("NetworkNotModified", cachedData, stableID, user);
            else return null;
            const cacheKey = this._getCacheKey(user);
            this._inMemoryCache.add(cacheKey, result);
            this._writeToCache(cacheKey, result);
            return result;
        });
    }
    _getSdkKey() {
        if (this._sdkKey != null) return this._sdkKey;
        $6NMPc.Log.error(`${this._adapterName} is not attached to a Client`);
        return "";
    }
    _loadFromCache(cacheKey) {
        var _a;
        const cache = (_a = $esT98.Storage.getItem) === null || _a === void 0 ? void 0 : _a.call($esT98.Storage, cacheKey);
        if (cache == null) return null;
        const result = (0, $43uRY._typedJsonParse)(cache, "source", "Cached Result");
        return result ? Object.assign(Object.assign({}, result), {
            source: "Cache"
        }) : null;
    }
    _writeToCache(cacheKey, result) {
        $esT98.Storage.setItem(cacheKey, JSON.stringify(result));
        this._runLocalStorageCacheEviction(cacheKey);
    }
    _runLocalStorageCacheEviction(cacheKey) {
        var _a;
        const lastModifiedTimeMap = (_a = (0, $esT98._getObjectFromStorage)(this._lastModifiedStoreKey)) !== null && _a !== void 0 ? _a : {};
        lastModifiedTimeMap[cacheKey] = Date.now();
        const evictable = $40d5b9a5a4059c2e$var$_getEvictableKey(lastModifiedTimeMap, $40d5b9a5a4059c2e$var$CACHE_LIMIT);
        if (evictable) {
            delete lastModifiedTimeMap[evictable];
            $esT98.Storage.removeItem(evictable);
        }
        (0, $esT98._setObjectInStorage)(this._lastModifiedStoreKey, lastModifiedTimeMap);
    }
}
module.exports.DataAdapterCore = $40d5b9a5a4059c2e$var$DataAdapterCore;
function $40d5b9a5a4059c2e$var$_makeDataAdapterResult(source, data, stableID, user) {
    return {
        source: source,
        data: data,
        receivedAt: Date.now(),
        stableID: stableID,
        fullUserHash: (0, $1O1gA._getFullUserHash)(user)
    };
}
module.exports._makeDataAdapterResult = $40d5b9a5a4059c2e$var$_makeDataAdapterResult;
class $40d5b9a5a4059c2e$var$InMemoryCache {
    constructor(){
        this._data = {};
    }
    get(cacheKey, user) {
        var _a;
        const result = this._data[cacheKey];
        const cached = result === null || result === void 0 ? void 0 : result.stableID;
        const provided = (_a = user === null || user === void 0 ? void 0 : user.customIDs) === null || _a === void 0 ? void 0 : _a.stableID;
        if (provided && cached && provided !== cached) {
            $6NMPc.Log.warn("'StatsigUser.customIDs.stableID' mismatch");
            return null;
        }
        return result;
    }
    add(cacheKey, value) {
        const oldest = $40d5b9a5a4059c2e$var$_getEvictableKey(this._data, $40d5b9a5a4059c2e$var$CACHE_LIMIT - 1);
        if (oldest) delete this._data[oldest];
        this._data[cacheKey] = value;
    }
    merge(values) {
        this._data = Object.assign(Object.assign({}, this._data), values);
    }
}
function $40d5b9a5a4059c2e$var$_getEvictableKey(data, limit) {
    const keys = Object.keys(data);
    if (keys.length <= limit) return null;
    return keys.reduce((prevKey, currKey)=>{
        const prev = data[prevKey];
        const current = data[currKey];
        if (typeof prev === "object" && typeof current === "object") return current.receivedAt < prev.receivedAt ? currKey : prevKey;
        return current < prev ? currKey : prevKey;
    });
}

});
parcelRegister("eNs8z", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StableID = void 0;

var $hJcO9 = parcelRequire("hJcO9");

var $6NMPc = parcelRequire("6NMPc");

var $esT98 = parcelRequire("esT98");

var $18vEo = parcelRequire("18vEo");
const $ac5b77bc71884900$var$PROMISE_MAP = {};
module.exports.StableID = {
    get: (sdkKey)=>{
        if ($ac5b77bc71884900$var$PROMISE_MAP[sdkKey] == null) {
            let stableID = $ac5b77bc71884900$var$_loadFromStorage(sdkKey);
            if (stableID == null) {
                stableID = (0, $18vEo.getUUID)();
                $ac5b77bc71884900$var$_persistToStorage(stableID, sdkKey);
            }
            $ac5b77bc71884900$var$PROMISE_MAP[sdkKey] = stableID;
        }
        return $ac5b77bc71884900$var$PROMISE_MAP[sdkKey];
    },
    setOverride: (override, sdkKey)=>{
        $ac5b77bc71884900$var$PROMISE_MAP[sdkKey] = override;
        $ac5b77bc71884900$var$_persistToStorage(override, sdkKey);
    }
};
function $ac5b77bc71884900$var$_getStableIDStorageKey(sdkKey) {
    return `statsig.stable_id.${(0, $hJcO9._getStorageKey)(sdkKey)}`;
}
function $ac5b77bc71884900$var$_persistToStorage(stableID, sdkKey) {
    const storageKey = $ac5b77bc71884900$var$_getStableIDStorageKey(sdkKey);
    try {
        (0, $esT98._setObjectInStorage)(storageKey, stableID);
    } catch (e) {
        $6NMPc.Log.warn("Failed to save StableID");
    }
}
function $ac5b77bc71884900$var$_loadFromStorage(sdkKey) {
    const storageKey = $ac5b77bc71884900$var$_getStableIDStorageKey(sdkKey);
    return (0, $esT98._getObjectFromStorage)(storageKey);
}

});
parcelRegister("18vEo", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getUUID = void 0;
function $0d3f16ed82bce67e$var$getUUID() {
    if (typeof crypto !== "undefined" && typeof crypto.randomUUID === "function") return crypto.randomUUID();
    let d = new Date().getTime();
    let d2 = typeof performance !== "undefined" && performance.now && performance.now() * 1000 || 0;
    const y = "89ab"[Math.floor(Math.random() * 4)];
    return `xxxxxxxx-xxxx-4xxx-${y}xxx-xxxxxxxxxxxx`.replace(/[xy]/g, (c)=>{
        let r = Math.random() * 16;
        if (d > 0) {
            r = (d + r) % 16 | 0;
            d = Math.floor(d / 16);
        } else {
            r = (d2 + r) % 16 | 0;
            d2 = Math.floor(d2 / 16);
        }
        return (c === "x" ? r : r & 0x7 | 0x8).toString(16);
    });
}
module.exports.getUUID = $0d3f16ed82bce67e$var$getUUID;

});


parcelRegister("1O1gA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._getFullUserHash = module.exports._normalizeUser = void 0;

var $luQa5 = parcelRequire("luQa5");

var $6NMPc = parcelRequire("6NMPc");
function $150b7179d755086e$var$_normalizeUser(original, options, fallbackEnvironment) {
    try {
        const copy = JSON.parse(JSON.stringify(original));
        if (options != null && options.environment != null) copy.statsigEnvironment = options.environment;
        else if (fallbackEnvironment != null) copy.statsigEnvironment = {
            tier: fallbackEnvironment
        };
        return copy;
    } catch (error) {
        $6NMPc.Log.error("Failed to JSON.stringify user");
        return {
            statsigEnvironment: undefined
        };
    }
}
module.exports._normalizeUser = $150b7179d755086e$var$_normalizeUser;
function $150b7179d755086e$var$_getFullUserHash(user) {
    return user ? (0, $luQa5._DJB2Object)(user) : null;
}
module.exports._getFullUserHash = $150b7179d755086e$var$_getFullUserHash;

});

parcelRegister("43uRY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._typedJsonParse = void 0;

var $6NMPc = parcelRequire("6NMPc");
/**
 *
 * @param {string} data The values to parse into T
 * @param {string} guard A field that must exists on the parsed object for the parse to be valid
 * @param {string} error An error to print via Log.error() when parsing fails
 * @returns {T | null} The parse object T or null if it failed
 */ function $2f3f634cf86084e9$var$_typedJsonParse(data, guard, typeName) {
    try {
        const result = JSON.parse(data);
        if (result && typeof result === "object" && guard in result) return result;
    } catch (_a) {
    // noop
    }
    $6NMPc.Log.error(`Failed to parse ${typeName}`);
    return null;
}
module.exports._typedJsonParse = $2f3f634cf86084e9$var$_typedJsonParse;

});


parcelRegister("wyuU1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("8a96B", function(module, exports) {
"use strict";
var $5f1652164e74d76c$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ErrorBoundary = module.exports.EXCEPTION_ENDPOINT = void 0;

var $6NMPc = parcelRequire("6NMPc");

var $bqfSv = parcelRequire("bqfSv");

var $jJ1d3 = parcelRequire("jJ1d3");
module.exports.EXCEPTION_ENDPOINT = "https://statsigapi.net/v1/sdk_exception";
const $5f1652164e74d76c$var$UNKNOWN_ERROR = "[Statsig] UnknownError";
class $5f1652164e74d76c$var$ErrorBoundary {
    constructor(_sdkKey, _options, _emitter, _lastSeenError){
        this._sdkKey = _sdkKey;
        this._options = _options;
        this._emitter = _emitter;
        this._lastSeenError = _lastSeenError;
        this._seen = new Set();
    }
    wrap(instance) {
        try {
            const obj = instance;
            $5f1652164e74d76c$var$_getAllInstanceMethodNames(obj).forEach((name)=>{
                const original = obj[name];
                if ("$EB" in original) return;
                obj[name] = (...args)=>{
                    return this._capture(name, ()=>original.apply(instance, args));
                };
                obj[name].$EB = true;
            });
        } catch (err) {
            this._onError("eb:wrap", err);
        }
    }
    logError(tag, error) {
        this._onError(tag, error);
    }
    getLastSeenErrorAndReset() {
        const tempError = this._lastSeenError;
        this._lastSeenError = undefined;
        return tempError !== null && tempError !== void 0 ? tempError : null;
    }
    attachErrorIfNoneExists(error) {
        if (this._lastSeenError) return;
        this._lastSeenError = $5f1652164e74d76c$var$_resolveError(error);
    }
    _capture(tag, task) {
        try {
            const res = task();
            if (res && res instanceof Promise) return res.catch((err)=>this._onError(tag, err));
            return res;
        } catch (error) {
            this._onError(tag, error);
            return null;
        }
    }
    _onError(tag, error) {
        try {
            $6NMPc.Log.warn(`Caught error in ${tag}`, {
                error: error
            });
            const impl = ()=>$5f1652164e74d76c$var$__awaiter(this, void 0, void 0, function*() {
                    var _a, _b, _c, _d, _e, _f, _g;
                    const unwrapped = error ? error : Error($5f1652164e74d76c$var$UNKNOWN_ERROR);
                    const isError = unwrapped instanceof Error;
                    const name = isError ? unwrapped.name : "No Name";
                    const resolvedError = $5f1652164e74d76c$var$_resolveError(unwrapped);
                    this._lastSeenError = resolvedError;
                    if (this._seen.has(name)) return;
                    this._seen.add(name);
                    if ((_b = (_a = this._options) === null || _a === void 0 ? void 0 : _a.networkConfig) === null || _b === void 0 ? void 0 : _b.preventAllNetworkTraffic) {
                        (_c = this._emitter) === null || _c === void 0 || _c.call(this, {
                            name: "error",
                            error: error,
                            tag: tag
                        });
                        return;
                    }
                    const sdkType = $bqfSv.SDKType._get(this._sdkKey);
                    const statsigMetadata = $jJ1d3.StatsigMetadataProvider.get();
                    const info = isError ? unwrapped.stack : $5f1652164e74d76c$var$_getDescription(unwrapped);
                    const body = JSON.stringify(Object.assign({
                        tag: tag,
                        exception: name,
                        info: info
                    }, Object.assign(Object.assign({}, statsigMetadata), {
                        sdkType: sdkType
                    })));
                    const func = (_f = (_e = (_d = this._options) === null || _d === void 0 ? void 0 : _d.networkConfig) === null || _e === void 0 ? void 0 : _e.networkOverrideFunc) !== null && _f !== void 0 ? _f : fetch;
                    yield func(module.exports.EXCEPTION_ENDPOINT, {
                        method: "POST",
                        headers: {
                            "STATSIG-API-KEY": this._sdkKey,
                            "STATSIG-SDK-TYPE": String(sdkType),
                            "STATSIG-SDK-VERSION": String(statsigMetadata.sdkVersion),
                            "Content-Type": "application/json"
                        },
                        body: body
                    });
                    (_g = this._emitter) === null || _g === void 0 || _g.call(this, {
                        name: "error",
                        error: error,
                        tag: tag
                    });
                });
            impl().then(()=>{
            /* noop */ }).catch(()=>{
            /* noop */ });
        } catch (_error) {
        /* noop */ }
    }
}
module.exports.ErrorBoundary = $5f1652164e74d76c$var$ErrorBoundary;
function $5f1652164e74d76c$var$_resolveError(error) {
    if (error instanceof Error) return error;
    else if (typeof error === "string") return new Error(error);
    else return new Error("An unknown error occurred.");
}
function $5f1652164e74d76c$var$_getDescription(obj) {
    try {
        return JSON.stringify(obj);
    } catch (_a) {
        return $5f1652164e74d76c$var$UNKNOWN_ERROR;
    }
}
function $5f1652164e74d76c$var$_getAllInstanceMethodNames(instance) {
    const names = new Set();
    let proto = Object.getPrototypeOf(instance);
    while(proto && proto !== Object.prototype){
        Object.getOwnPropertyNames(proto).filter((prop)=>typeof (proto === null || proto === void 0 ? void 0 : proto[prop]) === "function").forEach((name)=>names.add(name));
        proto = Object.getPrototypeOf(proto);
    }
    return Array.from(names);
}

});
parcelRegister("bqfSv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SDKType = void 0;
const $850e70752854cbaf$var$SDK_CLIENT = {};
let $850e70752854cbaf$var$suffix;
module.exports.SDKType = {
    _get: (sdkKey)=>{
        var _a;
        return ((_a = $850e70752854cbaf$var$SDK_CLIENT[sdkKey]) !== null && _a !== void 0 ? _a : "js-mono") + ($850e70752854cbaf$var$suffix !== null && $850e70752854cbaf$var$suffix !== void 0 ? $850e70752854cbaf$var$suffix : "");
    },
    _setClientType (sdkKey, client) {
        $850e70752854cbaf$var$SDK_CLIENT[sdkKey] = client;
    },
    _setBindingType (binding) {
        if (!$850e70752854cbaf$var$suffix || $850e70752854cbaf$var$suffix === "-react") $850e70752854cbaf$var$suffix = "-" + binding;
    }
};

});


parcelRegister("hNR37", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("eMrEI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("1LfXe", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("7dy1y", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createMemoKey = module.exports.MemoPrefix = void 0;
module.exports.MemoPrefix = {
    _gate: "g",
    _dynamicConfig: "c",
    _experiment: "e",
    _layer: "l",
    _paramStore: "p"
};
const $541423c0f5957c5d$var$EXIST_KEYS = new Set([]);
const $541423c0f5957c5d$var$DO_NOT_MEMO_KEYS = new Set([
    // Add keys that if exist, should not be memoized
    "userPersistedValues"
]);
function $541423c0f5957c5d$var$createMemoKey(prefix, name, options) {
    let cacheKey = `${prefix}|${name}`;
    if (!options) return cacheKey;
    for (const key of Object.keys(options)){
        if ($541423c0f5957c5d$var$DO_NOT_MEMO_KEYS.has(key)) return undefined;
        if ($541423c0f5957c5d$var$EXIST_KEYS.has(key)) cacheKey += `|${key}=true`;
        else cacheKey += `|${key}=${options[key]}`;
    }
    return cacheKey;
}
module.exports.createMemoKey = $541423c0f5957c5d$var$createMemoKey;

});

parcelRegister("eFZRd", function(module, exports) {
"use strict";
var $aaf4e097904626df$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.NetworkCore = void 0;

var $bx6oK = parcelRequire("bx6oK");

var $bx6oK = parcelRequire("bx6oK");

var $bPiJc = parcelRequire("bPiJc");

var $6NMPc = parcelRequire("6NMPc");

var $9kbTT = parcelRequire("9kbTT");

var $8C0qz = parcelRequire("8C0qz");

var $idhq5 = parcelRequire("idhq5");

var $bqfSv = parcelRequire("bqfSv");

var $dKF5C = parcelRequire("dKF5C");

var $jvmJD = parcelRequire("jvmJD");

var $eNs8z = parcelRequire("eNs8z");

var $4bHKt = parcelRequire("4bHKt");

var $jJ1d3 = parcelRequire("jJ1d3");

var $i5JCF = parcelRequire("i5JCF");
const $aaf4e097904626df$var$DEFAULT_TIMEOUT_MS = 10000;
const $aaf4e097904626df$var$BACKOFF_BASE_MS = 500;
const $aaf4e097904626df$var$BACKOFF_MAX_MS = 30000;
const $aaf4e097904626df$var$RATE_LIMIT_WINDOW_MS = 1000;
const $aaf4e097904626df$var$RATE_LIMIT_MAX_REQ_COUNT = 50;
const $aaf4e097904626df$var$LEAK_RATE = $aaf4e097904626df$var$RATE_LIMIT_MAX_REQ_COUNT / $aaf4e097904626df$var$RATE_LIMIT_WINDOW_MS;
const $aaf4e097904626df$var$RETRYABLE_CODES = new Set([
    408,
    500,
    502,
    503,
    504,
    522,
    524,
    599
]);
class $aaf4e097904626df$var$NetworkCore {
    constructor(options, _emitter){
        this._emitter = _emitter;
        this._errorBoundary = null;
        this._timeout = $aaf4e097904626df$var$DEFAULT_TIMEOUT_MS;
        this._netConfig = {};
        this._options = {};
        this._leakyBucket = {};
        this._lastUsedInitUrl = null;
        if (options) this._options = options;
        if (this._options.networkConfig) this._netConfig = this._options.networkConfig;
        if (this._netConfig.networkTimeoutMs) this._timeout = this._netConfig.networkTimeoutMs;
        this._fallbackResolver = new $8C0qz.NetworkFallbackResolver(this._options);
    }
    setErrorBoundary(errorBoundary) {
        this._errorBoundary = errorBoundary;
        this._errorBoundary.wrap(this);
        this._errorBoundary.wrap(this._fallbackResolver);
        this._fallbackResolver.setErrorBoundary(errorBoundary);
    }
    isBeaconSupported() {
        return typeof navigator !== "undefined" && typeof navigator.sendBeacon === "function";
    }
    getLastUsedInitUrlAndReset() {
        const tempUrl = this._lastUsedInitUrl;
        this._lastUsedInitUrl = null;
        return tempUrl;
    }
    beacon(args) {
        return $aaf4e097904626df$var$__awaiter(this, void 0, void 0, function*() {
            if (!$aaf4e097904626df$var$_ensureValidSdkKey(args)) return false;
            const argsInternal = this._getInternalRequestArgs("POST", args);
            yield this._tryToCompressBody(argsInternal);
            const url = yield this._getPopulatedURL(argsInternal);
            const nav = navigator;
            return nav.sendBeacon.bind(nav)(url, argsInternal.body);
        });
    }
    post(args) {
        return $aaf4e097904626df$var$__awaiter(this, void 0, void 0, function*() {
            const argsInternal = this._getInternalRequestArgs("POST", args);
            this._tryEncodeBody(argsInternal);
            yield this._tryToCompressBody(argsInternal);
            return this._sendRequest(argsInternal);
        });
    }
    get(args) {
        const argsInternal = this._getInternalRequestArgs("GET", args);
        return this._sendRequest(argsInternal);
    }
    _sendRequest(args) {
        var _a, _b, _c, _d;
        return $aaf4e097904626df$var$__awaiter(this, void 0, void 0, function*() {
            if (!$aaf4e097904626df$var$_ensureValidSdkKey(args)) return null;
            if (this._netConfig.preventAllNetworkTraffic) return null;
            const { method: method, body: body, retries: retries, attempt: attempt } = args;
            const endpoint = args.urlConfig.endpoint;
            if (this._isRateLimited(endpoint)) {
                $6NMPc.Log.warn(`Request to ${endpoint} was blocked because you are making requests too frequently.`);
                return null;
            }
            const currentAttempt = attempt !== null && attempt !== void 0 ? attempt : 1;
            const abortController = typeof AbortController !== "undefined" ? new AbortController() : null;
            const timeoutHandle = setTimeout(()=>{
                abortController === null || abortController === void 0 || abortController.abort(`Timeout of ${this._timeout}ms expired.`);
            }, this._timeout);
            const populatedUrl = yield this._getPopulatedURL(args);
            let response = null;
            const keepalive = (0, $i5JCF._isUnloading)();
            try {
                const config = {
                    method: method,
                    body: body,
                    headers: Object.assign({}, args.headers),
                    signal: abortController === null || abortController === void 0 ? void 0 : abortController.signal,
                    priority: args.priority,
                    keepalive: keepalive
                };
                $aaf4e097904626df$var$_tryMarkInitStart(args, currentAttempt);
                const bucket = this._leakyBucket[endpoint];
                if (bucket) {
                    bucket.lastRequestTime = Date.now();
                    this._leakyBucket[endpoint] = bucket;
                }
                const func = (_a = this._netConfig.networkOverrideFunc) !== null && _a !== void 0 ? _a : fetch;
                response = yield func(populatedUrl, config);
                clearTimeout(timeoutHandle);
                if (!response.ok) {
                    const text = yield response.text().catch(()=>"No Text");
                    const err = new Error(`NetworkError: ${populatedUrl} ${text}`);
                    err.name = "NetworkError";
                    throw err;
                }
                const text = yield response.text();
                $aaf4e097904626df$var$_tryMarkInitEnd(args, response, currentAttempt, text);
                this._fallbackResolver.tryBumpExpiryTime(args.sdkKey, args.urlConfig);
                return {
                    body: text,
                    code: response.status
                };
            } catch (error) {
                const errorMessage = $aaf4e097904626df$var$_getErrorMessage(abortController, error);
                const timedOut = $aaf4e097904626df$var$_didTimeout(abortController);
                $aaf4e097904626df$var$_tryMarkInitEnd(args, response, currentAttempt, "", error);
                const fallbackUpdated = yield this._fallbackResolver.tryFetchUpdatedFallbackInfo(args.sdkKey, args.urlConfig, errorMessage, timedOut);
                if (fallbackUpdated) args.fallbackUrl = this._fallbackResolver.getActiveFallbackUrl(args.sdkKey, args.urlConfig);
                if (!retries || currentAttempt > retries || !$aaf4e097904626df$var$RETRYABLE_CODES.has((_b = response === null || response === void 0 ? void 0 : response.status) !== null && _b !== void 0 ? _b : 500)) {
                    (_c = this._emitter) === null || _c === void 0 || _c.call(this, {
                        name: "error",
                        error: error,
                        tag: $4bHKt.ErrorTag.NetworkError,
                        requestArgs: args
                    });
                    const formattedErrorMsg = `A networking error occurred during ${method} request to ${populatedUrl}.`;
                    $6NMPc.Log.error(formattedErrorMsg, errorMessage, error);
                    (_d = this._errorBoundary) === null || _d === void 0 || _d.attachErrorIfNoneExists(formattedErrorMsg);
                    return null;
                }
                yield $aaf4e097904626df$var$_exponentialBackoff(currentAttempt);
                return this._sendRequest(Object.assign(Object.assign({}, args), {
                    retries: retries,
                    attempt: currentAttempt + 1
                }));
            }
        });
    }
    _isRateLimited(endpoint) {
        var _a;
        const now = Date.now();
        const bucket = (_a = this._leakyBucket[endpoint]) !== null && _a !== void 0 ? _a : {
            count: 0,
            lastRequestTime: now
        };
        const elapsed = now - bucket.lastRequestTime;
        const leakedRequests = Math.floor(elapsed * $aaf4e097904626df$var$LEAK_RATE);
        bucket.count = Math.max(0, bucket.count - leakedRequests);
        if (bucket.count >= $aaf4e097904626df$var$RATE_LIMIT_MAX_REQ_COUNT) return true;
        bucket.count += 1;
        bucket.lastRequestTime = now;
        this._leakyBucket[endpoint] = bucket;
        return false;
    }
    _getPopulatedURL(args) {
        var _a;
        return $aaf4e097904626df$var$__awaiter(this, void 0, void 0, function*() {
            const url = (_a = args.fallbackUrl) !== null && _a !== void 0 ? _a : args.urlConfig.getUrl();
            if (args.urlConfig.endpoint === $9kbTT.Endpoint._initialize || args.urlConfig.endpoint === $9kbTT.Endpoint._download_config_specs) this._lastUsedInitUrl = url;
            const params = Object.assign({
                [$9kbTT.NetworkParam.SdkKey]: args.sdkKey,
                [$9kbTT.NetworkParam.SdkType]: $bqfSv.SDKType._get(args.sdkKey),
                [$9kbTT.NetworkParam.SdkVersion]: $jJ1d3.SDK_VERSION,
                [$9kbTT.NetworkParam.Time]: String(Date.now()),
                [$9kbTT.NetworkParam.SessionID]: $jvmJD.SessionID.get(args.sdkKey)
            }, args.params);
            const query = Object.keys(params).map((key)=>{
                return `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`;
            }).join("&");
            return `${url}${query ? `?${query}` : ""}`;
        });
    }
    _tryEncodeBody(args) {
        var _a;
        const win = (0, $dKF5C._getWindowSafe)();
        const body = args.body;
        if (!args.isStatsigEncodable || this._options.disableStatsigEncoding || typeof body !== "string" || (0, $bx6oK._getStatsigGlobalFlag)("no-encode") != null || !(win === null || win === void 0 ? void 0 : win.btoa)) return;
        try {
            args.body = win.btoa(body).split("").reverse().join("");
            args.params = Object.assign(Object.assign({}, (_a = args.params) !== null && _a !== void 0 ? _a : {}), {
                [$9kbTT.NetworkParam.StatsigEncoded]: "1"
            });
        } catch (e) {
            $6NMPc.Log.warn(`Request encoding failed for ${args.urlConfig.getUrl()}`, e);
        }
    }
    _tryToCompressBody(args) {
        var _a;
        return $aaf4e097904626df$var$__awaiter(this, void 0, void 0, function*() {
            const body = args.body;
            if (!args.isCompressable || this._options.disableCompression || typeof body !== "string" || $idhq5.SDKFlags.get(args.sdkKey, "enable_log_event_compression") !== true || (0, $bx6oK._getStatsigGlobalFlag)("no-compress") != null || typeof CompressionStream === "undefined" || typeof TextEncoder === "undefined") return;
            try {
                const bytes = new TextEncoder().encode(body);
                const stream = new CompressionStream("gzip");
                const writer = stream.writable.getWriter();
                writer.write(bytes).catch($6NMPc.Log.error);
                writer.close().catch($6NMPc.Log.error);
                const reader = stream.readable.getReader();
                const chunks = [];
                let result;
                // eslint-disable-next-line no-await-in-loop
                while(!(result = yield reader.read()).done)chunks.push(result.value);
                const totalLength = chunks.reduce((acc, chunk)=>acc + chunk.length, 0);
                const combined = new Uint8Array(totalLength);
                let offset = 0;
                for (const chunk of chunks){
                    combined.set(chunk, offset);
                    offset += chunk.length;
                }
                args.body = combined;
                args.params = Object.assign(Object.assign({}, (_a = args.params) !== null && _a !== void 0 ? _a : {}), {
                    [$9kbTT.NetworkParam.IsGzipped]: "1"
                });
            } catch (e) {
                $6NMPc.Log.warn(`Request compression failed for ${args.urlConfig.getUrl()}`, e);
            }
        });
    }
    _getInternalRequestArgs(method, args) {
        const fallbackUrl = this._fallbackResolver.getActiveFallbackUrl(args.sdkKey, args.urlConfig);
        const result = Object.assign(Object.assign({}, args), {
            method: method,
            fallbackUrl: fallbackUrl
        });
        if ("data" in args) $aaf4e097904626df$var$_populateRequestBody(result, args.data);
        return result;
    }
}
module.exports.NetworkCore = $aaf4e097904626df$var$NetworkCore;
const $aaf4e097904626df$var$_ensureValidSdkKey = (args)=>{
    if (!args.sdkKey) {
        $6NMPc.Log.warn("Unable to make request without an SDK key");
        return false;
    }
    return true;
};
const $aaf4e097904626df$var$_populateRequestBody = (args, data)=>{
    const { sdkKey: sdkKey, fallbackUrl: fallbackUrl } = args;
    const stableID = $eNs8z.StableID.get(sdkKey);
    const sessionID = $jvmJD.SessionID.get(sdkKey);
    const sdkType = $bqfSv.SDKType._get(sdkKey);
    args.body = JSON.stringify(Object.assign(Object.assign({}, data), {
        statsigMetadata: Object.assign(Object.assign({}, $jJ1d3.StatsigMetadataProvider.get()), {
            stableID: stableID,
            sessionID: sessionID,
            sdkType: sdkType,
            fallbackUrl: fallbackUrl
        })
    }));
};
function $aaf4e097904626df$var$_getErrorMessage(controller, error) {
    if ((controller === null || controller === void 0 ? void 0 : controller.signal.aborted) && typeof controller.signal.reason === "string") return controller.signal.reason;
    if (typeof error === "string") return error;
    if (error instanceof Error) return `${error.name}: ${error.message}`;
    return "Unknown Error";
}
function $aaf4e097904626df$var$_didTimeout(controller) {
    const timeout = (controller === null || controller === void 0 ? void 0 : controller.signal.aborted) && typeof controller.signal.reason === "string" && controller.signal.reason.includes("Timeout");
    return timeout || false;
}
function $aaf4e097904626df$var$_tryMarkInitStart(args, attempt) {
    if (args.urlConfig.endpoint !== $9kbTT.Endpoint._initialize) return;
    $bPiJc.Diagnostics._markInitNetworkReqStart(args.sdkKey, {
        attempt: attempt
    });
}
function $aaf4e097904626df$var$_tryMarkInitEnd(args, response, attempt, body, err) {
    if (args.urlConfig.endpoint !== $9kbTT.Endpoint._initialize) return;
    $bPiJc.Diagnostics._markInitNetworkReqEnd(args.sdkKey, $bPiJc.Diagnostics._getDiagnosticsData(response, attempt, body, err));
}
function $aaf4e097904626df$var$_exponentialBackoff(attempt) {
    return $aaf4e097904626df$var$__awaiter(this, void 0, void 0, function*() {
        // 1*1*1000 1s
        // 2*2*1000 4s
        // 3*3*1000 9s
        // 4*4*1000 16s
        // 5*5*1000 25s
        yield new Promise((r)=>setTimeout(r, Math.min($aaf4e097904626df$var$BACKOFF_BASE_MS * (attempt * attempt), $aaf4e097904626df$var$BACKOFF_MAX_MS)));
    });
}

});
parcelRegister("8C0qz", function(module, exports) {
"use strict";
var $64523444808de77d$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._isDomainFailure = module.exports.NetworkFallbackResolver = void 0;

var $3g4Ks = parcelRequire("3g4Ks");

var $luQa5 = parcelRequire("luQa5");

var $6NMPc = parcelRequire("6NMPc");

var $esT98 = parcelRequire("esT98");
const $64523444808de77d$var$DEFAULT_TTL_MS = 604800000; // 7 days
const $64523444808de77d$var$COOLDOWN_TIME_MS = 14400000; // 4 hours
class $64523444808de77d$var$NetworkFallbackResolver {
    constructor(options){
        var _a;
        this._fallbackInfo = null;
        this._errorBoundary = null;
        this._dnsQueryCooldowns = {};
        this._networkOverrideFunc = (_a = options.networkConfig) === null || _a === void 0 ? void 0 : _a.networkOverrideFunc;
    }
    setErrorBoundary(errorBoundary) {
        this._errorBoundary = errorBoundary;
    }
    tryBumpExpiryTime(sdkKey, urlConfig) {
        var _a;
        const info = (_a = this._fallbackInfo) === null || _a === void 0 ? void 0 : _a[urlConfig.endpoint];
        if (!info) return;
        info.expiryTime = Date.now() + $64523444808de77d$var$DEFAULT_TTL_MS;
        $64523444808de77d$var$_tryWriteFallbackInfoToCache(sdkKey, Object.assign(Object.assign({}, this._fallbackInfo), {
            [urlConfig.endpoint]: info
        }));
    }
    getActiveFallbackUrl(sdkKey, urlConfig) {
        var _a, _b;
        let info = this._fallbackInfo;
        if (info == null) {
            info = (_a = $64523444808de77d$var$_readFallbackInfoFromCache(sdkKey)) !== null && _a !== void 0 ? _a : {};
            this._fallbackInfo = info;
        }
        const entry = info[urlConfig.endpoint];
        if (!entry || Date.now() > ((_b = entry.expiryTime) !== null && _b !== void 0 ? _b : 0)) {
            delete info[urlConfig.endpoint];
            this._fallbackInfo = info;
            $64523444808de77d$var$_tryWriteFallbackInfoToCache(sdkKey, this._fallbackInfo);
            return null;
        }
        if (entry.url) return entry.url;
        return null;
    }
    getFallbackFromProvided(url) {
        const path = $64523444808de77d$var$_extractPathFromUrl(url);
        if (path) return url.replace(path, "");
        return null;
    }
    tryFetchUpdatedFallbackInfo(sdkKey, urlConfig, errorMessage, timedOut) {
        var _a, _b;
        return $64523444808de77d$var$__awaiter(this, void 0, void 0, function*() {
            try {
                if (!$64523444808de77d$var$_isDomainFailure(errorMessage, timedOut)) return false;
                const canUseNetworkFallbacks = urlConfig.customUrl == null && urlConfig.fallbackUrls == null;
                const urls = canUseNetworkFallbacks ? yield this._tryFetchFallbackUrlsFromNetwork(urlConfig) : urlConfig.fallbackUrls;
                const newUrl = this._pickNewFallbackUrl((_a = this._fallbackInfo) === null || _a === void 0 ? void 0 : _a[urlConfig.endpoint], urls);
                if (!newUrl) return false;
                this._updateFallbackInfoWithNewUrl(sdkKey, urlConfig.endpoint, newUrl);
                return true;
            } catch (error) {
                (_b = this._errorBoundary) === null || _b === void 0 || _b.logError("tryFetchUpdatedFallbackInfo", error);
                return false;
            }
        });
    }
    _updateFallbackInfoWithNewUrl(sdkKey, endpoint, newUrl) {
        var _a, _b, _c;
        const newFallbackInfo = {
            url: newUrl,
            expiryTime: Date.now() + $64523444808de77d$var$DEFAULT_TTL_MS,
            previous: []
        };
        const previousInfo = (_a = this._fallbackInfo) === null || _a === void 0 ? void 0 : _a[endpoint];
        if (previousInfo) newFallbackInfo.previous.push(...previousInfo.previous);
        if (newFallbackInfo.previous.length > 10) newFallbackInfo.previous = [];
        const previousUrl = (_c = (_b = this._fallbackInfo) === null || _b === void 0 ? void 0 : _b[endpoint]) === null || _c === void 0 ? void 0 : _c.url;
        if (previousUrl != null) newFallbackInfo.previous.push(previousUrl);
        this._fallbackInfo = Object.assign(Object.assign({}, this._fallbackInfo), {
            [endpoint]: newFallbackInfo
        });
        $64523444808de77d$var$_tryWriteFallbackInfoToCache(sdkKey, this._fallbackInfo);
    }
    _tryFetchFallbackUrlsFromNetwork(urlConfig) {
        var _a;
        return $64523444808de77d$var$__awaiter(this, void 0, void 0, function*() {
            const cooldown = this._dnsQueryCooldowns[urlConfig.endpoint];
            if (cooldown && Date.now() < cooldown) return null;
            this._dnsQueryCooldowns[urlConfig.endpoint] = Date.now() + $64523444808de77d$var$COOLDOWN_TIME_MS;
            const result = [];
            const records = yield (0, $3g4Ks._fetchTxtRecords)((_a = this._networkOverrideFunc) !== null && _a !== void 0 ? _a : fetch);
            const path = $64523444808de77d$var$_extractPathFromUrl(urlConfig.defaultUrl);
            for (const record of records){
                if (!record.startsWith(urlConfig.endpointDnsKey + "=")) continue;
                const parts = record.split("=");
                if (parts.length > 1) {
                    let baseUrl = parts[1];
                    if (baseUrl.endsWith("/")) baseUrl = baseUrl.slice(0, -1);
                    result.push(`https://${baseUrl}${path}`);
                }
            }
            return result;
        });
    }
    _pickNewFallbackUrl(currentFallbackInfo, urls) {
        var _a;
        if (urls == null) return null;
        const previouslyUsed = new Set((_a = currentFallbackInfo === null || currentFallbackInfo === void 0 ? void 0 : currentFallbackInfo.previous) !== null && _a !== void 0 ? _a : []);
        const currentFallbackUrl = currentFallbackInfo === null || currentFallbackInfo === void 0 ? void 0 : currentFallbackInfo.url;
        let found = null;
        for (const loopUrl of urls){
            const url = loopUrl.endsWith("/") ? loopUrl.slice(0, -1) : loopUrl;
            if (!previouslyUsed.has(loopUrl) && url !== currentFallbackUrl) {
                found = url;
                break;
            }
        }
        return found;
    }
}
module.exports.NetworkFallbackResolver = $64523444808de77d$var$NetworkFallbackResolver;
function $64523444808de77d$var$_isDomainFailure(errorMsg, timedOut) {
    var _a;
    const lowerErrorMsg = (_a = errorMsg === null || errorMsg === void 0 ? void 0 : errorMsg.toLowerCase()) !== null && _a !== void 0 ? _a : "";
    return timedOut || lowerErrorMsg.includes("uncaught exception") || lowerErrorMsg.includes("failed to fetch") || lowerErrorMsg.includes("networkerror when attempting to fetch resource");
}
module.exports._isDomainFailure = $64523444808de77d$var$_isDomainFailure;
function $64523444808de77d$var$_getFallbackInfoStorageKey(sdkKey) {
    return `statsig.network_fallback.${(0, $luQa5._DJB2)(sdkKey)}`;
}
function $64523444808de77d$var$_tryWriteFallbackInfoToCache(sdkKey, info) {
    const hashKey = $64523444808de77d$var$_getFallbackInfoStorageKey(sdkKey);
    if (!info || Object.keys(info).length === 0) {
        $esT98.Storage.removeItem(hashKey);
        return;
    }
    $esT98.Storage.setItem(hashKey, JSON.stringify(info));
}
function $64523444808de77d$var$_readFallbackInfoFromCache(sdkKey) {
    const hashKey = $64523444808de77d$var$_getFallbackInfoStorageKey(sdkKey);
    const data = $esT98.Storage.getItem(hashKey);
    if (!data) return null;
    try {
        return JSON.parse(data);
    } catch (_a) {
        $6NMPc.Log.error("Failed to parse FallbackInfo");
        return null;
    }
}
function $64523444808de77d$var$_extractPathFromUrl(urlString) {
    try {
        const url = new URL(urlString);
        return url.pathname;
    } catch (error) {
        return null;
    }
}

});
parcelRegister("3g4Ks", function(module, exports) {
"use strict";
var $25f68ca2ecb9668e$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._fetchTxtRecords = void 0;
// See example: https://github.com/statsig-io/private-js-client-monorepo/pull/340
const $25f68ca2ecb9668e$var$FEATURE_ASSETS_DNS_QUERY = new Uint8Array([
    0x00,
    0x00,
    0x01,
    0x00,
    0x00,
    0x01,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x0d,
    0x66,
    0x65,
    0x61,
    0x74,
    0x75,
    0x72,
    0x65,
    0x61,
    0x73,
    0x73,
    0x65,
    0x74,
    0x73,
    0x03,
    0x6f,
    0x72,
    0x67,
    0x00,
    0x00,
    0x10,
    0x00,
    0x01
]);
const $25f68ca2ecb9668e$var$DNS_QUERY_ENDPOINT = "https://cloudflare-dns.com/dns-query";
const $25f68ca2ecb9668e$var$DOMAIN_CHARS = [
    "i",
    "e",
    "d"
];
const $25f68ca2ecb9668e$var$MAX_START_LOOKUP = 200;
function $25f68ca2ecb9668e$var$_fetchTxtRecords(networkFunc) {
    return $25f68ca2ecb9668e$var$__awaiter(this, void 0, void 0, function*() {
        const response = yield networkFunc($25f68ca2ecb9668e$var$DNS_QUERY_ENDPOINT, {
            method: "POST",
            headers: {
                "Content-Type": "application/dns-message",
                Accept: "application/dns-message"
            },
            body: $25f68ca2ecb9668e$var$FEATURE_ASSETS_DNS_QUERY
        });
        if (!response.ok) {
            const err = new Error("Failed to fetch TXT records from DNS");
            err.name = "DnsTxtFetchError";
            throw err;
        }
        const data = yield response.arrayBuffer();
        const bytes = new Uint8Array(data);
        return $25f68ca2ecb9668e$var$_parseDnsResponse(bytes);
    });
}
module.exports._fetchTxtRecords = $25f68ca2ecb9668e$var$_fetchTxtRecords;
function $25f68ca2ecb9668e$var$_parseDnsResponse(input) {
    // loop until we find the first valid domain char. One of [i=, e=, d=]
    const start = input.findIndex((byte, index)=>index < $25f68ca2ecb9668e$var$MAX_START_LOOKUP && String.fromCharCode(byte) === "=" && $25f68ca2ecb9668e$var$DOMAIN_CHARS.includes(String.fromCharCode(input[index - 1])));
    if (start === -1) {
        const err = new Error("Failed to parse TXT records from DNS");
        err.name = "DnsTxtParseError";
        throw err;
    }
    // decode the remaining bytes as a string
    let result = "";
    for(let i = start - 1; i < input.length; i++)result += String.fromCharCode(input[i]);
    return result.split(",");
}

});


parcelRegister("idhq5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SDKFlags = void 0;
const $d426f414bbdf2692$var$FLAGMAP = {};
module.exports.SDKFlags = {
    setFlags: (sdkKey, flags)=>{
        $d426f414bbdf2692$var$FLAGMAP[sdkKey] = flags;
    },
    get: (sdkKey, flagKey)=>{
        var _a, _b;
        return (_b = (_a = $d426f414bbdf2692$var$FLAGMAP[sdkKey]) === null || _a === void 0 ? void 0 : _a[flagKey]) !== null && _b !== void 0 ? _b : false;
    }
};

});

parcelRegister("jvmJD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StatsigSession = module.exports.SessionID = void 0;

var $hJcO9 = parcelRequire("hJcO9");

var $6NMPc = parcelRequire("6NMPc");

var $esT98 = parcelRequire("esT98");

var $18vEo = parcelRequire("18vEo");
const $e3328c4dbede2b79$var$MAX_SESSION_IDLE_TIME = 1800000; // 30 minutes
const $e3328c4dbede2b79$var$MAX_SESSION_AGE = 14400000; // 4 hours
const $e3328c4dbede2b79$var$PROMISE_MAP = {};
module.exports.SessionID = {
    get: (sdkKey)=>{
        return module.exports.StatsigSession.get(sdkKey).data.sessionID;
    }
};
module.exports.StatsigSession = {
    get: (sdkKey)=>{
        if ($e3328c4dbede2b79$var$PROMISE_MAP[sdkKey] == null) $e3328c4dbede2b79$var$PROMISE_MAP[sdkKey] = $e3328c4dbede2b79$var$_loadSession(sdkKey);
        const session = $e3328c4dbede2b79$var$PROMISE_MAP[sdkKey];
        return $e3328c4dbede2b79$var$_bumpSession(session);
    },
    overrideInitialSessionID: (override, sdkKey)=>{
        $e3328c4dbede2b79$var$PROMISE_MAP[sdkKey] = $e3328c4dbede2b79$var$_overrideSessionId(override, sdkKey);
    }
};
function $e3328c4dbede2b79$var$_loadSession(sdkKey) {
    let data = $e3328c4dbede2b79$var$_loadFromStorage(sdkKey);
    const now = Date.now();
    if (!data) data = {
        sessionID: (0, $18vEo.getUUID)(),
        startTime: now,
        lastUpdate: now
    };
    return {
        data: data,
        sdkKey: sdkKey
    };
}
function $e3328c4dbede2b79$var$_overrideSessionId(override, sdkKey) {
    const now = Date.now();
    return {
        data: {
            sessionID: override,
            startTime: now,
            lastUpdate: now
        },
        sdkKey: sdkKey
    };
}
function $e3328c4dbede2b79$var$_bumpSession(session) {
    const now = Date.now();
    const data = session.data;
    if ($e3328c4dbede2b79$var$_isIdle(data) || $e3328c4dbede2b79$var$_hasRunTooLong(data)) {
        data.sessionID = (0, $18vEo.getUUID)();
        data.startTime = now;
    }
    data.lastUpdate = now;
    $e3328c4dbede2b79$var$_persistToStorage(data, session.sdkKey);
    clearTimeout(session.idleTimeoutID);
    clearTimeout(session.ageTimeoutID);
    const lifetime = now - data.startTime;
    const sdkKey = session.sdkKey;
    session.idleTimeoutID = $e3328c4dbede2b79$var$_createSessionTimeout(sdkKey, $e3328c4dbede2b79$var$MAX_SESSION_IDLE_TIME);
    session.ageTimeoutID = $e3328c4dbede2b79$var$_createSessionTimeout(sdkKey, $e3328c4dbede2b79$var$MAX_SESSION_AGE - lifetime);
    return session;
}
function $e3328c4dbede2b79$var$_createSessionTimeout(sdkKey, duration) {
    return setTimeout(()=>{
        const client = __STATSIG__ === null || __STATSIG__ === void 0 ? void 0 : __STATSIG__.instance(sdkKey);
        if (client) client.$emt({
            name: "session_expired"
        });
    }, duration);
}
function $e3328c4dbede2b79$var$_isIdle({ lastUpdate: lastUpdate }) {
    return Date.now() - lastUpdate > $e3328c4dbede2b79$var$MAX_SESSION_IDLE_TIME;
}
function $e3328c4dbede2b79$var$_hasRunTooLong({ startTime: startTime }) {
    return Date.now() - startTime > $e3328c4dbede2b79$var$MAX_SESSION_AGE;
}
function $e3328c4dbede2b79$var$_getSessionIDStorageKey(sdkKey) {
    return `statsig.session_id.${(0, $hJcO9._getStorageKey)(sdkKey)}`;
}
function $e3328c4dbede2b79$var$_persistToStorage(session, sdkKey) {
    const storageKey = $e3328c4dbede2b79$var$_getSessionIDStorageKey(sdkKey);
    try {
        (0, $esT98._setObjectInStorage)(storageKey, session);
    } catch (e) {
        $6NMPc.Log.warn("Failed to save SessionID");
    }
}
function $e3328c4dbede2b79$var$_loadFromStorage(sdkKey) {
    const storageKey = $e3328c4dbede2b79$var$_getSessionIDStorageKey(sdkKey);
    return (0, $esT98._getObjectFromStorage)(storageKey);
}

});

parcelRegister("4bHKt", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ErrorTag = void 0;
module.exports.ErrorTag = {
    NetworkError: "NetworkError"
};

});


parcelRegister("kZaDF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("9es69", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("e6vI6", function(module, exports) {
"use strict";
var $a44a393915c10a32$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StatsigClientBase = void 0;

var $bx6oK = parcelRequire("bx6oK");

var $bx6oK = parcelRequire("bx6oK");

var $8a96B = parcelRequire("8a96B");

var $hIjZl = parcelRequire("hIjZl");

var $6NMPc = parcelRequire("6NMPc");

var $7dy1y = parcelRequire("7dy1y");

var $dKF5C = parcelRequire("dKF5C");

var $jvmJD = parcelRequire("jvmJD");

var $esT98 = parcelRequire("esT98");
const $a44a393915c10a32$var$MAX_MEMO_CACHE_SIZE = 3000;
class $a44a393915c10a32$var$StatsigClientBase {
    constructor(sdkKey, adapter, network, options){
        var _a;
        this.loadingStatus = "Uninitialized";
        this._initializePromise = null;
        this._listeners = {};
        const emitter = this.$emt.bind(this);
        (options === null || options === void 0 ? void 0 : options.logLevel) != null && ($6NMPc.Log.level = options.logLevel);
        (options === null || options === void 0 ? void 0 : options.disableStorage) && $esT98.Storage._setDisabled(true);
        (options === null || options === void 0 ? void 0 : options.initialSessionID) && $jvmJD.StatsigSession.overrideInitialSessionID(options.initialSessionID, sdkKey);
        (options === null || options === void 0 ? void 0 : options.storageProvider) && $esT98.Storage._setProvider(options.storageProvider);
        this._sdkKey = sdkKey;
        this._options = options !== null && options !== void 0 ? options : {};
        this._memoCache = {};
        this.overrideAdapter = (_a = options === null || options === void 0 ? void 0 : options.overrideAdapter) !== null && _a !== void 0 ? _a : null;
        this._logger = new $hIjZl.EventLogger(sdkKey, emitter, network, options);
        this._errorBoundary = new $8a96B.ErrorBoundary(sdkKey, options, emitter);
        this._errorBoundary.wrap(this);
        this._errorBoundary.wrap(adapter);
        this._errorBoundary.wrap(this._logger);
        network.setErrorBoundary(this._errorBoundary);
        this.dataAdapter = adapter;
        this.dataAdapter.attach(sdkKey, options);
        this.storageProvider = $esT98.Storage;
        this._primeReadyRipcord();
        $a44a393915c10a32$var$_assignGlobalInstance(sdkKey, this);
    }
    /**
     * Updates runtime configuration options for the SDK, allowing toggling of certain behaviors such as logging and storage to comply with user preferences or regulations such as GDPR.
     *
     * @param {StatsigRuntimeMutableOptions} options - The configuration options that dictate the runtime behavior of the SDK.
     */ updateRuntimeOptions(options) {
        if (options.disableLogging != null) {
            this._options.disableLogging = options.disableLogging;
            this._logger.setLoggingDisabled(options.disableLogging);
        }
        if (options.disableStorage != null) {
            this._options.disableStorage = options.disableStorage;
            $esT98.Storage._setDisabled(options.disableStorage);
        }
    }
    /**
     * Flushes any currently queued events.
     */ flush() {
        return this._logger.flush();
    }
    /**
     * Gracefully shuts down the SDK, ensuring that all pending events are send before the SDK stops.
     * This function emits a 'pre_shutdown' event and then waits for the logger to complete its shutdown process.
     *
     * @returns {Promise<void>} A promise that resolves when all shutdown procedures, including logging shutdown, have been completed.
     */ shutdown() {
        return $a44a393915c10a32$var$__awaiter(this, void 0, void 0, function*() {
            this.$emt({
                name: "pre_shutdown"
            });
            this._setStatus("Uninitialized", null);
            this._initializePromise = null;
            yield this._logger.stop();
        });
    }
    /**
     * Subscribes a callback function to a specific {@link StatsigClientEvent} or all StatsigClientEvents if the wildcard '*' is used.
     * Once subscribed, the listener callback will be invoked whenever the specified event is emitted.
     *
     * @param {StatsigClientEventName} event - The name of the event to subscribe to, or '*' to subscribe to all events.
     * @param {StatsigClientEventCallback<T>} listener - The callback function to execute when the event occurs. The function receives event-specific data as its parameter.
     * @see {@link off} for unsubscribing from events.
     */ on(event, listener) {
        if (!this._listeners[event]) this._listeners[event] = [];
        this._listeners[event].push(listener);
    }
    /**
     * Unsubscribes a previously registered callback function from a specific {@link StatsigClientEvent} or all StatsigClientEvents if the wildcard '*' is used.
     *
     * @param {StatsigClientEventName} event - The name of the event from which to unsubscribe, or '*' to unsubscribe from all events.
     * @param {StatsigClientEventCallback<T>} listener - The callback function to remove from the event's notification list.
     * @see {@link on} for subscribing to events.
     */ off(event, listener) {
        if (this._listeners[event]) {
            const index = this._listeners[event].indexOf(listener);
            if (index !== -1) this._listeners[event].splice(index, 1);
        }
    }
    $on(event, listener) {
        listener.__isInternal = true;
        this.on(event, listener);
    }
    $emt(event) {
        var _a;
        const barrier = (listener)=>{
            try {
                listener(event);
            } catch (error) {
                if (listener.__isInternal === true) {
                    this._errorBoundary.logError(`__emit:${event.name}`, error);
                    return;
                }
                $6NMPc.Log.error(`An error occurred in a StatsigClientEvent listener. This is not an issue with Statsig.`, event);
            }
        };
        if (this._listeners[event.name]) this._listeners[event.name].forEach((l)=>barrier(l));
        (_a = this._listeners["*"]) === null || _a === void 0 || _a.forEach(barrier);
    }
    _setStatus(newStatus, values) {
        this.loadingStatus = newStatus;
        this._memoCache = {};
        this.$emt({
            name: "values_updated",
            status: newStatus,
            values: values
        });
    }
    _enqueueExposure(name, exposure, options) {
        if ((options === null || options === void 0 ? void 0 : options.disableExposureLog) === true) {
            this._logger.incrementNonExposureCount(name);
            return;
        }
        this._logger.enqueue(exposure);
    }
    _memoize(prefix, fn) {
        return (name, options)=>{
            if (this._options.disableEvaluationMemoization) return fn(name, options);
            const memoKey = (0, $7dy1y.createMemoKey)(prefix, name, options);
            if (!memoKey) return fn(name, options);
            if (!(memoKey in this._memoCache)) {
                if (Object.keys(this._memoCache).length >= $a44a393915c10a32$var$MAX_MEMO_CACHE_SIZE) this._memoCache = {};
                this._memoCache[memoKey] = fn(name, options);
            }
            return this._memoCache[memoKey];
        };
    }
}
module.exports.StatsigClientBase = $a44a393915c10a32$var$StatsigClientBase;
function $a44a393915c10a32$var$_assignGlobalInstance(sdkKey, client) {
    var _a;
    if ((0, $dKF5C._isServerEnv)()) return;
    const statsigGlobal = (0, $bx6oK._getStatsigGlobal)();
    const instances = (_a = statsigGlobal.instances) !== null && _a !== void 0 ? _a : {};
    const inst = client;
    if (instances[sdkKey] != null) $6NMPc.Log.warn("Creating multiple Statsig clients with the same SDK key can lead to unexpected behavior. Multi-instance support requires different SDK keys.");
    instances[sdkKey] = inst;
    if (!statsigGlobal.firstInstance) statsigGlobal.firstInstance = inst;
    statsigGlobal.instances = instances;
    __STATSIG__ = statsigGlobal;
}

});

parcelRegister("8Vj6d", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DataAdapterCachePrefix = void 0;
module.exports.DataAdapterCachePrefix = "statsig.cached";

});

parcelRegister("jFwIL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("aJX92", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("6TtU4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._makeTypedGet = module.exports._mergeOverride = module.exports._makeLayer = module.exports._makeExperiment = module.exports._makeDynamicConfig = module.exports._makeFeatureGate = void 0;

var $6NMPc = parcelRequire("6NMPc");

var $9JIh7 = parcelRequire("9JIh7");
const $504f1350df4d92cf$var$DEFAULT_RULE = "default";
function $504f1350df4d92cf$var$_makeEvaluation(name, details, evaluation, value) {
    var _a;
    return {
        name: name,
        details: details,
        ruleID: (_a = evaluation === null || evaluation === void 0 ? void 0 : evaluation.rule_id) !== null && _a !== void 0 ? _a : $504f1350df4d92cf$var$DEFAULT_RULE,
        __evaluation: evaluation,
        value: value
    };
}
function $504f1350df4d92cf$var$_makeFeatureGate(name, details, evaluation) {
    return $504f1350df4d92cf$var$_makeEvaluation(name, details, evaluation, (evaluation === null || evaluation === void 0 ? void 0 : evaluation.value) === true);
}
module.exports._makeFeatureGate = $504f1350df4d92cf$var$_makeFeatureGate;
function $504f1350df4d92cf$var$_makeDynamicConfig(name, details, evaluation) {
    var _a;
    const value = (_a = evaluation === null || evaluation === void 0 ? void 0 : evaluation.value) !== null && _a !== void 0 ? _a : {};
    return Object.assign(Object.assign({}, $504f1350df4d92cf$var$_makeEvaluation(name, details, evaluation, value)), {
        get: $504f1350df4d92cf$var$_makeTypedGet(name, evaluation === null || evaluation === void 0 ? void 0 : evaluation.value)
    });
}
module.exports._makeDynamicConfig = $504f1350df4d92cf$var$_makeDynamicConfig;
function $504f1350df4d92cf$var$_makeExperiment(name, details, evaluation) {
    var _a;
    const result = $504f1350df4d92cf$var$_makeDynamicConfig(name, details, evaluation);
    return Object.assign(Object.assign({}, result), {
        groupName: (_a = evaluation === null || evaluation === void 0 ? void 0 : evaluation.group_name) !== null && _a !== void 0 ? _a : null
    });
}
module.exports._makeExperiment = $504f1350df4d92cf$var$_makeExperiment;
function $504f1350df4d92cf$var$_makeLayer(name, details, evaluation, exposeFunc) {
    var _a, _b;
    return Object.assign(Object.assign({}, $504f1350df4d92cf$var$_makeEvaluation(name, details, evaluation, undefined)), {
        get: $504f1350df4d92cf$var$_makeTypedGet(name, evaluation === null || evaluation === void 0 ? void 0 : evaluation.value, exposeFunc),
        groupName: (_a = evaluation === null || evaluation === void 0 ? void 0 : evaluation.group_name) !== null && _a !== void 0 ? _a : null,
        __value: (_b = evaluation === null || evaluation === void 0 ? void 0 : evaluation.value) !== null && _b !== void 0 ? _b : {}
    });
}
module.exports._makeLayer = $504f1350df4d92cf$var$_makeLayer;
function $504f1350df4d92cf$var$_mergeOverride(original, overridden, value, exposeFunc) {
    return Object.assign(Object.assign(Object.assign({}, original), overridden), {
        get: $504f1350df4d92cf$var$_makeTypedGet(original.name, value, exposeFunc)
    });
}
module.exports._mergeOverride = $504f1350df4d92cf$var$_mergeOverride;
function $504f1350df4d92cf$var$_makeTypedGet(name, value, exposeFunc) {
    return (param, fallback)=>{
        var _a;
        const found = (_a = value === null || value === void 0 ? void 0 : value[param]) !== null && _a !== void 0 ? _a : null;
        if (found == null) return fallback !== null && fallback !== void 0 ? fallback : null;
        if (fallback != null && !(0, $9JIh7._isTypeMatch)(found, fallback)) {
            $6NMPc.Log.warn(`Parameter type mismatch. '${name}.${param}' was found to be type '${typeof found}' but fallback/return type is '${typeof fallback}'. See https://docs.statsig.com/client/javascript-sdk/#typed-getters`);
            return fallback !== null && fallback !== void 0 ? fallback : null;
        }
        exposeFunc === null || exposeFunc === void 0 || exposeFunc(param);
        return found;
    };
}
module.exports._makeTypedGet = $504f1350df4d92cf$var$_makeTypedGet;

});

parcelRegister("9K3az", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("kACZd", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.UPDATE_DETAIL_ERROR_MESSAGES = module.exports.createUpdateDetails = void 0;
const $efd5695028afa191$var$createUpdateDetails = (success, source, initDuration, error, sourceUrl, warnings)=>{
    return {
        duration: initDuration,
        source: source,
        success: success,
        error: error,
        sourceUrl: sourceUrl,
        warnings: warnings
    };
};
module.exports.createUpdateDetails = $efd5695028afa191$var$createUpdateDetails;
module.exports.UPDATE_DETAIL_ERROR_MESSAGES = {
    NO_NETWORK_DATA: "No data was returned from the network. This may be due to a network timeout if a timeout value was specified in the options or ad blocker error."
};

});


parcelRegister("16TR8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $aALut = parcelRequire("aALut");
class $0cf1adcf57578508$var$EvaluationStore {
    constructor(_sdkKey){
        this._sdkKey = _sdkKey;
        this._rawValues = null;
        this._values = null;
        this._source = "Uninitialized";
        this._lcut = 0;
        this._receivedAt = 0;
        this._bootstrapMetadata = null;
        this._warnings = new Set();
    }
    reset() {
        this._values = null;
        this._rawValues = null;
        this._source = "Loading";
        this._lcut = 0;
        this._receivedAt = 0;
        this._bootstrapMetadata = null;
    }
    finalize() {
        if (this._values) return;
        this._source = "NoValues";
    }
    getValues() {
        return this._rawValues ? (0, $aALut._typedJsonParse)(this._rawValues, "has_updates", "EvaluationStoreValues") : null;
    }
    setValues(result, user) {
        var _a;
        if (!result) return false;
        const values = (0, $aALut._typedJsonParse)(result.data, "has_updates", "EvaluationResponse");
        if (values == null) return false;
        this._source = result.source;
        if ((values === null || values === void 0 ? void 0 : values.has_updates) !== true) return true;
        this._rawValues = result.data;
        this._lcut = values.time;
        this._receivedAt = result.receivedAt;
        this._values = values;
        this._bootstrapMetadata = this._extractBootstrapMetadata(result.source, values);
        if (result.source && values.user) this._setWarningState(user, values);
        $aALut.SDKFlags.setFlags(this._sdkKey, (_a = values.sdk_flags) !== null && _a !== void 0 ? _a : {});
        return true;
    }
    getWarnings() {
        if (this._warnings.size === 0) return undefined;
        return Array.from(this._warnings);
    }
    getGate(name) {
        var _a;
        return this._getDetailedStoreResult((_a = this._values) === null || _a === void 0 ? void 0 : _a.feature_gates, name);
    }
    getConfig(name) {
        var _a;
        return this._getDetailedStoreResult((_a = this._values) === null || _a === void 0 ? void 0 : _a.dynamic_configs, name);
    }
    getLayer(name) {
        var _a;
        return this._getDetailedStoreResult((_a = this._values) === null || _a === void 0 ? void 0 : _a.layer_configs, name);
    }
    getParamStore(name) {
        var _a;
        return this._getDetailedStoreResult((_a = this._values) === null || _a === void 0 ? void 0 : _a.param_stores, name);
    }
    getSource() {
        return this._source;
    }
    getExposureMapping() {
        var _a;
        return (_a = this._values) === null || _a === void 0 ? void 0 : _a.exposures;
    }
    _extractBootstrapMetadata(source, values) {
        if (source !== "Bootstrap") return null;
        const bootstrapMetadata = {};
        if (values.user) bootstrapMetadata.user = values.user;
        if (values.sdkInfo) bootstrapMetadata.generatorSDKInfo = values.sdkInfo;
        bootstrapMetadata.lcut = values.time;
        return bootstrapMetadata;
    }
    _getDetailedStoreResult(lookup, name) {
        let result = null;
        if (lookup) result = lookup[name] ? lookup[name] : lookup[(0, $aALut._DJB2)(name)];
        return {
            result: result,
            details: this._getDetails(result == null)
        };
    }
    _setWarningState(user, values) {
        var _a;
        const stableID = $aALut.StableID.get(this._sdkKey);
        if (((_a = user.customIDs) === null || _a === void 0 ? void 0 : _a.stableID) !== stableID) {
            this._warnings.add("StableIDMismatch");
            return;
        }
        if ("user" in values) {
            const bootstrapUser = values["user"];
            if ((0, $aALut._getFullUserHash)(user) !== (0, $aALut._getFullUserHash)(bootstrapUser)) this._warnings.add("PartialUserMatch");
        }
    }
    getCurrentSourceDetails() {
        if (this._source === "Uninitialized" || this._source === "NoValues") return {
            reason: this._source
        };
        const sourceDetails = {
            reason: this._source,
            lcut: this._lcut,
            receivedAt: this._receivedAt
        };
        if (this._warnings.size > 0) sourceDetails.warnings = Array.from(this._warnings);
        return sourceDetails;
    }
    _getDetails(isUnrecognized) {
        var _a, _b;
        const sourceDetails = this.getCurrentSourceDetails();
        let reason = sourceDetails.reason;
        const warnings = (_a = sourceDetails.warnings) !== null && _a !== void 0 ? _a : [];
        if (this._source === "Bootstrap" && warnings.length > 0) reason = reason + warnings[0];
        if (reason !== "Uninitialized" && reason !== "NoValues") {
            const subreason = isUnrecognized ? "Unrecognized" : "Recognized";
            reason = `${reason}:${subreason}`;
        }
        const bootstrapMetadata = this._source === "Bootstrap" ? (_b = this._bootstrapMetadata) !== null && _b !== void 0 ? _b : undefined : undefined;
        if (bootstrapMetadata) sourceDetails.bootstrapMetadata = bootstrapMetadata;
        return Object.assign(Object.assign({}, sourceDetails), {
            reason: reason
        });
    }
}
module.exports.default = $0cf1adcf57578508$var$EvaluationStore;

});

parcelRegister("iXmRJ", function(module, exports) {
"use strict";
var $dccf795202ef1302$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $aALut = parcelRequire("aALut");

var $aYIQq = parcelRequire("aYIQq");
class $dccf795202ef1302$var$StatsigNetwork extends $aALut.NetworkCore {
    constructor(options, emitter){
        super(options, emitter);
        const config = options === null || options === void 0 ? void 0 : options.networkConfig;
        this._initializeUrlConfig = new $aALut.UrlConfiguration($aALut.Endpoint._initialize, config === null || config === void 0 ? void 0 : config.initializeUrl, config === null || config === void 0 ? void 0 : config.api, config === null || config === void 0 ? void 0 : config.initializeFallbackUrls);
    }
    fetchEvaluations(sdkKey, current, priority, user, isCacheValidFor204) {
        return $dccf795202ef1302$var$__awaiter(this, void 0, void 0, function*() {
            const cache = current ? (0, $aALut._typedJsonParse)(current, "has_updates", "InitializeResponse") : null;
            let data = {
                user: user,
                hash: "djb2",
                deltasResponseRequested: false,
                full_checksum: null
            };
            if (cache === null || cache === void 0 ? void 0 : cache.has_updates) data = Object.assign(Object.assign({}, data), {
                sinceTime: isCacheValidFor204 ? cache.time : 0,
                previousDerivedFields: "derived_fields" in cache && isCacheValidFor204 ? cache.derived_fields : {},
                deltasResponseRequested: true,
                full_checksum: cache.full_checksum
            });
            return this._fetchEvaluations(sdkKey, cache, data, priority);
        });
    }
    _fetchEvaluations(sdkKey, cache, data, priority) {
        var _a, _b;
        return $dccf795202ef1302$var$__awaiter(this, void 0, void 0, function*() {
            const response = yield this.post({
                sdkKey: sdkKey,
                urlConfig: this._initializeUrlConfig,
                data: data,
                retries: 2,
                isStatsigEncodable: true,
                priority: priority
            });
            if ((response === null || response === void 0 ? void 0 : response.code) === 204) return '{"has_updates": false}';
            if ((response === null || response === void 0 ? void 0 : response.code) !== 200) return (_a = response === null || response === void 0 ? void 0 : response.body) !== null && _a !== void 0 ? _a : null;
            if ((cache === null || cache === void 0 ? void 0 : cache.has_updates) !== true || ((_b = response.body) === null || _b === void 0 ? void 0 : _b.includes('"is_delta":true')) !== true || data.deltasResponseRequested !== true) return response.body;
            const result = (0, $aYIQq._resolveDeltasResponse)(cache, response.body);
            if (typeof result === "string") return result;
            // retry without deltas
            return this._fetchEvaluations(sdkKey, cache, Object.assign(Object.assign(Object.assign({}, data), result), {
                deltasResponseRequested: false
            }), priority);
        });
    }
}
module.exports.default = $dccf795202ef1302$var$StatsigNetwork;

});
parcelRegister("aYIQq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._resolveDeltasResponse = void 0;

var $aALut = parcelRequire("aALut");
const $7fe24b282d9e4ce6$var$MAX_DELTAS_SORT_DEPTH = 2;
function $7fe24b282d9e4ce6$var$_resolveDeltasResponse(cache, deltasString) {
    const deltas = (0, $aALut._typedJsonParse)(deltasString, "checksum", "DeltasEvaluationResponse");
    if (!deltas) return {
        hadBadDeltaChecksum: true
    };
    const merged = $7fe24b282d9e4ce6$var$_mergeDeltasIntoCache(cache, deltas);
    const resolved = $7fe24b282d9e4ce6$var$_handleDeletedEntries(merged);
    const actualChecksum = (0, $aALut._DJB2Object)({
        feature_gates: resolved.feature_gates,
        dynamic_configs: resolved.dynamic_configs,
        layer_configs: resolved.layer_configs
    }, $7fe24b282d9e4ce6$var$MAX_DELTAS_SORT_DEPTH);
    const isMatch = actualChecksum === deltas.checksumV2;
    if (!isMatch) return {
        hadBadDeltaChecksum: true,
        badChecksum: actualChecksum,
        badMergedConfigs: resolved,
        badFullResponse: deltas.deltas_full_response
    };
    return JSON.stringify(resolved);
}
module.exports._resolveDeltasResponse = $7fe24b282d9e4ce6$var$_resolveDeltasResponse;
function $7fe24b282d9e4ce6$var$_mergeDeltasIntoCache(cache, deltas) {
    return Object.assign(Object.assign(Object.assign({}, cache), deltas), {
        feature_gates: Object.assign(Object.assign({}, cache.feature_gates), deltas.feature_gates),
        layer_configs: Object.assign(Object.assign({}, cache.layer_configs), deltas.layer_configs),
        dynamic_configs: Object.assign(Object.assign({}, cache.dynamic_configs), deltas.dynamic_configs)
    });
}
function $7fe24b282d9e4ce6$var$_handleDeletedEntries(deltas) {
    const result = deltas;
    $7fe24b282d9e4ce6$var$_deleteEntriesInRecord(deltas.deleted_gates, result.feature_gates);
    delete result.deleted_gates;
    $7fe24b282d9e4ce6$var$_deleteEntriesInRecord(deltas.deleted_configs, result.dynamic_configs);
    delete result.deleted_configs;
    $7fe24b282d9e4ce6$var$_deleteEntriesInRecord(deltas.deleted_layers, result.layer_configs);
    delete result.deleted_layers;
    return result;
}
function $7fe24b282d9e4ce6$var$_deleteEntriesInRecord(keys, values) {
    keys === null || keys === void 0 || keys.forEach((key)=>{
        delete values[key];
    });
}

});


parcelRegister("cN42m", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._makeParamStoreGetter = void 0;

var $aALut = parcelRequire("aALut");
const $94fd315378109646$var$NO_EXPOSURE_OPT = {
    disableExposureLog: true
};
function $94fd315378109646$var$_shouldLogExposure(options) {
    return options == null || options.disableExposureLog === false;
}
function $94fd315378109646$var$_shouldReturnFallback(value, fallback) {
    return fallback != null && !(0, $aALut._isTypeMatch)(value, fallback);
}
function $94fd315378109646$var$_getMappedStaticValue(param, _options) {
    return param.value;
}
function $94fd315378109646$var$_getMappedGateValue(client, param, options) {
    const gate = client.getFeatureGate(param.gate_name, $94fd315378109646$var$_shouldLogExposure(options) ? undefined : $94fd315378109646$var$NO_EXPOSURE_OPT);
    if (gate.value) return param.pass_value;
    return param.fail_value;
}
function $94fd315378109646$var$_getMappedDynamicConfigValue(client, param, fallback, options) {
    const config = client.getDynamicConfig(param.config_name, $94fd315378109646$var$NO_EXPOSURE_OPT);
    const value = config.get(param.param_name);
    if ($94fd315378109646$var$_shouldReturnFallback(value, fallback)) return fallback;
    if ($94fd315378109646$var$_shouldLogExposure(options)) client.getDynamicConfig(param.config_name);
    return value;
}
function $94fd315378109646$var$_getMappedExperimentValue(client, param, fallback, options) {
    const experiment = client.getExperiment(param.experiment_name, $94fd315378109646$var$NO_EXPOSURE_OPT);
    const value = experiment.get(param.param_name);
    if ($94fd315378109646$var$_shouldReturnFallback(value, fallback)) return fallback;
    if ($94fd315378109646$var$_shouldLogExposure(options)) client.getExperiment(param.experiment_name);
    return value;
}
function $94fd315378109646$var$_getMappedLayerValue(client, param, fallback, options) {
    const layer = client.getLayer(param.layer_name, $94fd315378109646$var$NO_EXPOSURE_OPT);
    const value = layer.get(param.param_name);
    if ($94fd315378109646$var$_shouldReturnFallback(value, fallback)) return fallback;
    if ($94fd315378109646$var$_shouldLogExposure(options)) client.getLayer(param.layer_name).get(param.param_name);
    return value;
}
function $94fd315378109646$var$_makeParamStoreGetter(client, config, options) {
    return (paramName, fallback)=>{
        if (config == null) return fallback;
        const param = config[paramName];
        if (param == null || fallback != null && (0, $aALut._typeOf)(fallback) !== param.param_type) return fallback;
        switch(param.ref_type){
            case "static":
                return $94fd315378109646$var$_getMappedStaticValue(param, options);
            case "gate":
                return $94fd315378109646$var$_getMappedGateValue(client, param, options);
            case "dynamic_config":
                return $94fd315378109646$var$_getMappedDynamicConfigValue(client, param, fallback, options);
            case "experiment":
                return $94fd315378109646$var$_getMappedExperimentValue(client, param, fallback, options);
            case "layer":
                return $94fd315378109646$var$_getMappedLayerValue(client, param, fallback, options);
            default:
                return fallback;
        }
    };
}
module.exports._makeParamStoreGetter = $94fd315378109646$var$_makeParamStoreGetter;

});

parcelRegister("fpmnb", function(module, exports) {
"use strict";
var $b37a8b9d4cea93c4$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StatsigEvaluationsDataAdapter = void 0;

var $aALut = parcelRequire("aALut");

var $iXmRJ = parcelRequire("iXmRJ");
class $b37a8b9d4cea93c4$var$StatsigEvaluationsDataAdapter extends $aALut.DataAdapterCore {
    constructor(){
        super("EvaluationsDataAdapter", "evaluations");
        this._network = null;
        this._options = null;
    }
    attach(sdkKey, options) {
        super.attach(sdkKey, options);
        this._network = new $iXmRJ.default(options !== null && options !== void 0 ? options : {});
    }
    getDataAsync(current, user, options) {
        return this._getDataAsyncImpl(current, (0, $aALut._normalizeUser)(user, this._options), options);
    }
    prefetchData(user, options) {
        return this._prefetchDataImpl(user, options);
    }
    setData(data) {
        const values = (0, $aALut._typedJsonParse)(data, "has_updates", "data");
        if (values && "user" in values) super.setData(data, values.user);
        else $aALut.Log.error("StatsigUser not found. You may be using an older server SDK version. Please upgrade your SDK or use setDataLegacy.");
    }
    setDataLegacy(data, user) {
        super.setData(data, user);
    }
    _fetchFromNetwork(current, user, options, isCacheValidFor204) {
        var _a;
        return $b37a8b9d4cea93c4$var$__awaiter(this, void 0, void 0, function*() {
            const result = yield (_a = this._network) === null || _a === void 0 ? void 0 : _a.fetchEvaluations(this._getSdkKey(), current, options === null || options === void 0 ? void 0 : options.priority, user, isCacheValidFor204);
            return result !== null && result !== void 0 ? result : null;
        });
    }
    _getCacheKey(user) {
        var _a;
        const key = (0, $aALut._getStorageKey)(this._getSdkKey(), user, (_a = this._options) === null || _a === void 0 ? void 0 : _a.customUserCacheKeyFunc);
        return `${$aALut.DataAdapterCachePrefix}.${this._cacheSuffix}.${key}`;
    }
    _isCachedResultValidFor204(result, user) {
        return result.fullUserHash != null && result.fullUserHash === (0, $aALut._getFullUserHash)(user);
    }
}
module.exports.StatsigEvaluationsDataAdapter = $b37a8b9d4cea93c4$var$StatsigEvaluationsDataAdapter;

});



parcelRegister("lEz0s", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fc387cf4971451a4$export$2e2bcd8739ae039; });

var $htuO4 = parcelRequire("htuO4");

var $2Bhkc = parcelRequire("2Bhkc");

var $cIF9u = parcelRequire("cIF9u");

var $59E62 = parcelRequire("59E62");
function $fc387cf4971451a4$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $fc387cf4971451a4$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $fc387cf4971451a4$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($cIF9u)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $fc387cf4971451a4$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $fc387cf4971451a4$export$a66cbd9b2289cd78 = "@all-features";
var $fc387cf4971451a4$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function Subscriptions() {
        (0, (/*@__PURE__*/$parcel$interopDefault($htuO4)))(this, Subscriptions);
        (0, (/*@__PURE__*/$parcel$interopDefault($cIF9u)))(this, "eventToValue", new Map());
        this.emitter = new (0, $59E62.EventEmitter2)();
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($2Bhkc)))(Subscriptions, [
        {
            key: "onGateUpdated",
            value: function onGateUpdated(gateName, callback, checkGate, options) {
                var _this = this;
                var value = checkGate(gateName, $fc387cf4971451a4$var$_objectSpread($fc387cf4971451a4$var$_objectSpread({}, options), {}, {
                    fireGateExposure: false
                }));
                if (this.eventToValue.get(callback) === undefined) this.eventToValue.set(callback, value);
                var wrapCallback = function wrapCallback() {
                    var value = checkGate(gateName, $fc387cf4971451a4$var$_objectSpread($fc387cf4971451a4$var$_objectSpread({}, options), {}, {
                        fireGateExposure: false
                    }));
                    var existingValue = _this.eventToValue.get(callback);
                    if (existingValue !== value) {
                        _this.eventToValue.set(callback, value);
                        callback(value);
                    }
                };
                this.emitter.on(gateName, wrapCallback);
                return function() {
                    _this.emitter.off(gateName, wrapCallback);
                };
            }
        },
        {
            key: "onExperimentValueUpdated",
            value: function onExperimentValueUpdated(experimentName, parameterName, defaultValue, callback, getExperimentValue, options) {
                var _this2 = this;
                var experimentEventName = "".concat(experimentName, ".").concat(parameterName);
                var value = getExperimentValue(experimentName, parameterName, defaultValue, $fc387cf4971451a4$var$_objectSpread($fc387cf4971451a4$var$_objectSpread({}, options), {}, {
                    fireExperimentExposure: false
                }));
                if (this.eventToValue.get(callback) === undefined) this.eventToValue.set(callback, value);
                var wrapCallback = function wrapCallback() {
                    var value = getExperimentValue(experimentName, parameterName, defaultValue, $fc387cf4971451a4$var$_objectSpread($fc387cf4971451a4$var$_objectSpread({}, options), {}, {
                        fireExperimentExposure: false
                    }));
                    var existingValue = _this2.eventToValue.get(callback);
                    if (existingValue !== value) {
                        _this2.eventToValue.set(callback, value);
                        callback(value);
                    }
                };
                this.emitter.on(experimentEventName, wrapCallback);
                return function() {
                    _this2.emitter.off(experimentEventName, wrapCallback);
                };
            }
        },
        {
            key: "onAnyUpdated",
            value: function onAnyUpdated(callback) {
                var _this3 = this;
                this.emitter.on($fc387cf4971451a4$export$a66cbd9b2289cd78, callback);
                return function() {
                    _this3.emitter.off($fc387cf4971451a4$export$a66cbd9b2289cd78, callback);
                };
            }
        },
        {
            key: "anyUpdated",
            value: function anyUpdated() {
                var _this4 = this;
                this.emitter.emit($fc387cf4971451a4$export$a66cbd9b2289cd78);
                this.emitter.eventNames().filter(function(name) {
                    return name !== $fc387cf4971451a4$export$a66cbd9b2289cd78;
                }).forEach(function(event) {
                    _this4.emitter.emit(event);
                });
            }
        }
    ]);
}();

});
parcelRegister("59E62", function(module, exports) {

var $ahJoN = parcelRequire("ahJoN");
!function(undefined) {
    var isArray = Array.isArray ? Array.isArray : function _isArray(obj) {
        return Object.prototype.toString.call(obj) === "[object Array]";
    };
    var defaultMaxListeners = 10;
    function init() {
        this._events = {};
        if (this._conf) configure.call(this, this._conf);
    }
    function configure(conf) {
        if (conf) {
            this._conf = conf;
            conf.delimiter && (this.delimiter = conf.delimiter);
            this._maxListeners = conf.maxListeners !== undefined ? conf.maxListeners : defaultMaxListeners;
            conf.wildcard && (this.wildcard = conf.wildcard);
            conf.newListener && (this.newListener = conf.newListener);
            conf.verboseMemoryLeak && (this.verboseMemoryLeak = conf.verboseMemoryLeak);
            if (this.wildcard) this.listenerTree = {};
        } else this._maxListeners = defaultMaxListeners;
    }
    function logPossibleMemoryLeak(count, eventName) {
        var errorMsg = "(node) warning: possible EventEmitter memory leak detected. " + count + " listeners added. " + "Use emitter.setMaxListeners() to increase limit.";
        if (this.verboseMemoryLeak) errorMsg += " Event name: " + eventName + ".";
        if (typeof $ahJoN !== "undefined" && $ahJoN.emitWarning) {
            var e = new Error(errorMsg);
            e.name = "MaxListenersExceededWarning";
            e.emitter = this;
            e.count = count;
            $ahJoN.emitWarning(e);
        } else {
            console.error(errorMsg);
            if (console.trace) console.trace();
        }
    }
    function EventEmitter(conf) {
        this._events = {};
        this.newListener = false;
        this.verboseMemoryLeak = false;
        configure.call(this, conf);
    }
    EventEmitter.EventEmitter2 = EventEmitter; // backwards compatibility for exporting EventEmitter property
    //
    // Attention, function return type now is array, always !
    // It has zero elements if no any matches found and one or more
    // elements (leafs) if there are matches
    //
    function searchListenerTree(handlers, type, tree, i) {
        if (!tree) return [];
        var listeners = [], leaf, len, branch, xTree, xxTree, isolatedBranch, endReached, typeLength = type.length, currentType = type[i], nextType = type[i + 1];
        if (i === typeLength && tree._listeners) {
            //
            // If at the end of the event(s) list and the tree has listeners
            // invoke those listeners.
            //
            if (typeof tree._listeners === "function") {
                handlers && handlers.push(tree._listeners);
                return [
                    tree
                ];
            } else {
                for(leaf = 0, len = tree._listeners.length; leaf < len; leaf++)handlers && handlers.push(tree._listeners[leaf]);
                return [
                    tree
                ];
            }
        }
        if (currentType === "*" || currentType === "**" || tree[currentType]) {
            //
            // If the event emitted is '*' at this part
            // or there is a concrete match at this patch
            //
            if (currentType === "*") {
                for(branch in tree)if (branch !== "_listeners" && tree.hasOwnProperty(branch)) listeners = listeners.concat(searchListenerTree(handlers, type, tree[branch], i + 1));
                return listeners;
            } else if (currentType === "**") {
                endReached = i + 1 === typeLength || i + 2 === typeLength && nextType === "*";
                if (endReached && tree._listeners) // The next element has a _listeners, add it to the handlers.
                listeners = listeners.concat(searchListenerTree(handlers, type, tree, typeLength));
                for(branch in tree)if (branch !== "_listeners" && tree.hasOwnProperty(branch)) {
                    if (branch === "*" || branch === "**") {
                        if (tree[branch]._listeners && !endReached) listeners = listeners.concat(searchListenerTree(handlers, type, tree[branch], typeLength));
                        listeners = listeners.concat(searchListenerTree(handlers, type, tree[branch], i));
                    } else if (branch === nextType) listeners = listeners.concat(searchListenerTree(handlers, type, tree[branch], i + 2));
                    else // No match on this one, shift into the tree but not in the type array.
                    listeners = listeners.concat(searchListenerTree(handlers, type, tree[branch], i));
                }
                return listeners;
            }
            listeners = listeners.concat(searchListenerTree(handlers, type, tree[currentType], i + 1));
        }
        xTree = tree["*"];
        if (xTree) //
        // If the listener tree will allow any match for this part,
        // then recursively explore all branches of the tree
        //
        searchListenerTree(handlers, type, xTree, i + 1);
        xxTree = tree["**"];
        if (xxTree) {
            if (i < typeLength) {
                if (xxTree._listeners) // If we have a listener on a '**', it will catch all, so add its handler.
                searchListenerTree(handlers, type, xxTree, typeLength);
                // Build arrays of matching next branches and others.
                for(branch in xxTree)if (branch !== "_listeners" && xxTree.hasOwnProperty(branch)) {
                    if (branch === nextType) // We know the next element will match, so jump twice.
                    searchListenerTree(handlers, type, xxTree[branch], i + 2);
                    else if (branch === currentType) // Current node matches, move into the tree.
                    searchListenerTree(handlers, type, xxTree[branch], i + 1);
                    else {
                        isolatedBranch = {};
                        isolatedBranch[branch] = xxTree[branch];
                        searchListenerTree(handlers, type, {
                            "**": isolatedBranch
                        }, i + 1);
                    }
                }
            } else if (xxTree._listeners) // We have reached the end and still on a '**'
            searchListenerTree(handlers, type, xxTree, typeLength);
            else if (xxTree["*"] && xxTree["*"]._listeners) searchListenerTree(handlers, type, xxTree["*"], typeLength);
        }
        return listeners;
    }
    function growListenerTree(type, listener) {
        type = typeof type === "string" ? type.split(this.delimiter) : type.slice();
        //
        // Looks for two consecutive '**', if so, don't add the event at all.
        //
        for(var i = 0, len = type.length; i + 1 < len; i++){
            if (type[i] === "**" && type[i + 1] === "**") return;
        }
        var tree = this.listenerTree;
        var name = type.shift();
        while(name !== undefined){
            if (!tree[name]) tree[name] = {};
            tree = tree[name];
            if (type.length === 0) {
                if (!tree._listeners) tree._listeners = listener;
                else {
                    if (typeof tree._listeners === "function") tree._listeners = [
                        tree._listeners
                    ];
                    tree._listeners.push(listener);
                    if (!tree._listeners.warned && this._maxListeners > 0 && tree._listeners.length > this._maxListeners) {
                        tree._listeners.warned = true;
                        logPossibleMemoryLeak.call(this, tree._listeners.length, name);
                    }
                }
                return true;
            }
            name = type.shift();
        }
        return true;
    }
    // By default EventEmitters will print a warning if more than
    // 10 listeners are added to it. This is a useful default which
    // helps finding memory leaks.
    //
    // Obviously not all Emitters should be limited to 10. This function allows
    // that to be increased. Set to zero for unlimited.
    EventEmitter.prototype.delimiter = ".";
    EventEmitter.prototype.setMaxListeners = function(n) {
        if (n !== undefined) {
            this._maxListeners = n;
            if (!this._conf) this._conf = {};
            this._conf.maxListeners = n;
        }
    };
    EventEmitter.prototype.event = "";
    EventEmitter.prototype.once = function(event, fn) {
        return this._once(event, fn, false);
    };
    EventEmitter.prototype.prependOnceListener = function(event, fn) {
        return this._once(event, fn, true);
    };
    EventEmitter.prototype._once = function(event, fn, prepend) {
        this._many(event, 1, fn, prepend);
        return this;
    };
    EventEmitter.prototype.many = function(event, ttl, fn) {
        return this._many(event, ttl, fn, false);
    };
    EventEmitter.prototype.prependMany = function(event, ttl, fn) {
        return this._many(event, ttl, fn, true);
    };
    EventEmitter.prototype._many = function(event, ttl, fn, prepend) {
        var self = this;
        if (typeof fn !== "function") throw new Error("many only accepts instances of Function");
        function listener() {
            if (--ttl === 0) self.off(event, listener);
            return fn.apply(this, arguments);
        }
        listener._origin = fn;
        this._on(event, listener, prepend);
        return self;
    };
    EventEmitter.prototype.emit = function() {
        this._events || init.call(this);
        var type = arguments[0];
        if (type === "newListener" && !this.newListener) {
            if (!this._events.newListener) return false;
        }
        var al = arguments.length;
        var args, l, i, j;
        var handler;
        if (this._all && this._all.length) {
            handler = this._all.slice();
            if (al > 3) {
                args = new Array(al);
                for(j = 0; j < al; j++)args[j] = arguments[j];
            }
            for(i = 0, l = handler.length; i < l; i++){
                this.event = type;
                switch(al){
                    case 1:
                        handler[i].call(this, type);
                        break;
                    case 2:
                        handler[i].call(this, type, arguments[1]);
                        break;
                    case 3:
                        handler[i].call(this, type, arguments[1], arguments[2]);
                        break;
                    default:
                        handler[i].apply(this, args);
                }
            }
        }
        if (this.wildcard) {
            handler = [];
            var ns = typeof type === "string" ? type.split(this.delimiter) : type.slice();
            searchListenerTree.call(this, handler, ns, this.listenerTree, 0);
        } else {
            handler = this._events[type];
            if (typeof handler === "function") {
                this.event = type;
                switch(al){
                    case 1:
                        handler.call(this);
                        break;
                    case 2:
                        handler.call(this, arguments[1]);
                        break;
                    case 3:
                        handler.call(this, arguments[1], arguments[2]);
                        break;
                    default:
                        args = new Array(al - 1);
                        for(j = 1; j < al; j++)args[j - 1] = arguments[j];
                        handler.apply(this, args);
                }
                return true;
            } else if (handler) // need to make copy of handlers because list can change in the middle
            // of emit call
            handler = handler.slice();
        }
        if (handler && handler.length) {
            if (al > 3) {
                args = new Array(al - 1);
                for(j = 1; j < al; j++)args[j - 1] = arguments[j];
            }
            for(i = 0, l = handler.length; i < l; i++){
                this.event = type;
                switch(al){
                    case 1:
                        handler[i].call(this);
                        break;
                    case 2:
                        handler[i].call(this, arguments[1]);
                        break;
                    case 3:
                        handler[i].call(this, arguments[1], arguments[2]);
                        break;
                    default:
                        handler[i].apply(this, args);
                }
            }
            return true;
        } else if (!this._all && type === "error") {
            if (arguments[1] instanceof Error) throw arguments[1]; // Unhandled 'error' event
            else throw new Error("Uncaught, unspecified 'error' event.");
            return false;
        }
        return !!this._all;
    };
    EventEmitter.prototype.emitAsync = function() {
        this._events || init.call(this);
        var type = arguments[0];
        if (type === "newListener" && !this.newListener) {
            if (!this._events.newListener) return Promise.resolve([
                false
            ]);
        }
        var promises = [];
        var al = arguments.length;
        var args, l, i, j;
        var handler;
        if (this._all) {
            if (al > 3) {
                args = new Array(al);
                for(j = 1; j < al; j++)args[j] = arguments[j];
            }
            for(i = 0, l = this._all.length; i < l; i++){
                this.event = type;
                switch(al){
                    case 1:
                        promises.push(this._all[i].call(this, type));
                        break;
                    case 2:
                        promises.push(this._all[i].call(this, type, arguments[1]));
                        break;
                    case 3:
                        promises.push(this._all[i].call(this, type, arguments[1], arguments[2]));
                        break;
                    default:
                        promises.push(this._all[i].apply(this, args));
                }
            }
        }
        if (this.wildcard) {
            handler = [];
            var ns = typeof type === "string" ? type.split(this.delimiter) : type.slice();
            searchListenerTree.call(this, handler, ns, this.listenerTree, 0);
        } else handler = this._events[type];
        if (typeof handler === "function") {
            this.event = type;
            switch(al){
                case 1:
                    promises.push(handler.call(this));
                    break;
                case 2:
                    promises.push(handler.call(this, arguments[1]));
                    break;
                case 3:
                    promises.push(handler.call(this, arguments[1], arguments[2]));
                    break;
                default:
                    args = new Array(al - 1);
                    for(j = 1; j < al; j++)args[j - 1] = arguments[j];
                    promises.push(handler.apply(this, args));
            }
        } else if (handler && handler.length) {
            handler = handler.slice();
            if (al > 3) {
                args = new Array(al - 1);
                for(j = 1; j < al; j++)args[j - 1] = arguments[j];
            }
            for(i = 0, l = handler.length; i < l; i++){
                this.event = type;
                switch(al){
                    case 1:
                        promises.push(handler[i].call(this));
                        break;
                    case 2:
                        promises.push(handler[i].call(this, arguments[1]));
                        break;
                    case 3:
                        promises.push(handler[i].call(this, arguments[1], arguments[2]));
                        break;
                    default:
                        promises.push(handler[i].apply(this, args));
                }
            }
        } else if (!this._all && type === "error") {
            if (arguments[1] instanceof Error) return Promise.reject(arguments[1]); // Unhandled 'error' event
            else return Promise.reject("Uncaught, unspecified 'error' event.");
        }
        return Promise.all(promises);
    };
    EventEmitter.prototype.on = function(type, listener) {
        return this._on(type, listener, false);
    };
    EventEmitter.prototype.prependListener = function(type, listener) {
        return this._on(type, listener, true);
    };
    EventEmitter.prototype.onAny = function(fn) {
        return this._onAny(fn, false);
    };
    EventEmitter.prototype.prependAny = function(fn) {
        return this._onAny(fn, true);
    };
    EventEmitter.prototype.addListener = EventEmitter.prototype.on;
    EventEmitter.prototype._onAny = function(fn, prepend) {
        if (typeof fn !== "function") throw new Error("onAny only accepts instances of Function");
        if (!this._all) this._all = [];
        // Add the function to the event listener collection.
        if (prepend) this._all.unshift(fn);
        else this._all.push(fn);
        return this;
    };
    EventEmitter.prototype._on = function(type, listener, prepend) {
        if (typeof type === "function") {
            this._onAny(type, listener);
            return this;
        }
        if (typeof listener !== "function") throw new Error("on only accepts instances of Function");
        this._events || init.call(this);
        // To avoid recursion in the case that type == "newListeners"! Before
        // adding it to the listeners, first emit "newListeners".
        this.emit("newListener", type, listener);
        if (this.wildcard) {
            growListenerTree.call(this, type, listener);
            return this;
        }
        if (!this._events[type]) // Optimize the case of one listener. Don't need the extra array object.
        this._events[type] = listener;
        else {
            if (typeof this._events[type] === "function") // Change to array.
            this._events[type] = [
                this._events[type]
            ];
            // If we've already got an array, just add
            if (prepend) this._events[type].unshift(listener);
            else this._events[type].push(listener);
            // Check for listener leak
            if (!this._events[type].warned && this._maxListeners > 0 && this._events[type].length > this._maxListeners) {
                this._events[type].warned = true;
                logPossibleMemoryLeak.call(this, this._events[type].length, type);
            }
        }
        return this;
    };
    EventEmitter.prototype.off = function(type, listener) {
        if (typeof listener !== "function") throw new Error("removeListener only takes instances of Function");
        var handlers, leafs = [];
        if (this.wildcard) {
            var ns = typeof type === "string" ? type.split(this.delimiter) : type.slice();
            leafs = searchListenerTree.call(this, null, ns, this.listenerTree, 0);
        } else {
            // does not use listeners(), so no side effect of creating _events[type]
            if (!this._events[type]) return this;
            handlers = this._events[type];
            leafs.push({
                _listeners: handlers
            });
        }
        for(var iLeaf = 0; iLeaf < leafs.length; iLeaf++){
            var leaf = leafs[iLeaf];
            handlers = leaf._listeners;
            if (isArray(handlers)) {
                var position = -1;
                for(var i = 0, length = handlers.length; i < length; i++)if (handlers[i] === listener || handlers[i].listener && handlers[i].listener === listener || handlers[i]._origin && handlers[i]._origin === listener) {
                    position = i;
                    break;
                }
                if (position < 0) continue;
                if (this.wildcard) leaf._listeners.splice(position, 1);
                else this._events[type].splice(position, 1);
                if (handlers.length === 0) {
                    if (this.wildcard) delete leaf._listeners;
                    else delete this._events[type];
                }
                this.emit("removeListener", type, listener);
                return this;
            } else if (handlers === listener || handlers.listener && handlers.listener === listener || handlers._origin && handlers._origin === listener) {
                if (this.wildcard) delete leaf._listeners;
                else delete this._events[type];
                this.emit("removeListener", type, listener);
            }
        }
        function recursivelyGarbageCollect(root) {
            if (root === undefined) return;
            var keys = Object.keys(root);
            for(var i in keys){
                var key = keys[i];
                var obj = root[key];
                if (obj instanceof Function || typeof obj !== "object" || obj === null) continue;
                if (Object.keys(obj).length > 0) recursivelyGarbageCollect(root[key]);
                if (Object.keys(obj).length === 0) delete root[key];
            }
        }
        recursivelyGarbageCollect(this.listenerTree);
        return this;
    };
    EventEmitter.prototype.offAny = function(fn) {
        var i = 0, l = 0, fns;
        if (fn && this._all && this._all.length > 0) {
            fns = this._all;
            for(i = 0, l = fns.length; i < l; i++)if (fn === fns[i]) {
                fns.splice(i, 1);
                this.emit("removeListenerAny", fn);
                return this;
            }
        } else {
            fns = this._all;
            for(i = 0, l = fns.length; i < l; i++)this.emit("removeListenerAny", fns[i]);
            this._all = [];
        }
        return this;
    };
    EventEmitter.prototype.removeListener = EventEmitter.prototype.off;
    EventEmitter.prototype.removeAllListeners = function(type) {
        if (arguments.length === 0) {
            !this._events || init.call(this);
            return this;
        }
        if (this.wildcard) {
            var ns = typeof type === "string" ? type.split(this.delimiter) : type.slice();
            var leafs = searchListenerTree.call(this, null, ns, this.listenerTree, 0);
            for(var iLeaf = 0; iLeaf < leafs.length; iLeaf++){
                var leaf = leafs[iLeaf];
                leaf._listeners = null;
            }
        } else if (this._events) this._events[type] = null;
        return this;
    };
    EventEmitter.prototype.listeners = function(type) {
        if (this.wildcard) {
            var handlers = [];
            var ns = typeof type === "string" ? type.split(this.delimiter) : type.slice();
            searchListenerTree.call(this, handlers, ns, this.listenerTree, 0);
            return handlers;
        }
        this._events || init.call(this);
        if (!this._events[type]) this._events[type] = [];
        if (!isArray(this._events[type])) this._events[type] = [
            this._events[type]
        ];
        return this._events[type];
    };
    EventEmitter.prototype.eventNames = function() {
        return Object.keys(this._events);
    };
    EventEmitter.prototype.listenerCount = function(type) {
        return this.listeners(type).length;
    };
    EventEmitter.prototype.listenersAny = function() {
        if (this._all) return this._all;
        else return [];
    };
    if (typeof define === "function" && define.amd) // AMD. Register as an anonymous module.
    define(function() {
        return EventEmitter;
    });
    else // CommonJS
    module.exports = EventEmitter;
}();

});


parcelRegister("d6BRT", function(module, exports) {

$parcel$export(module.exports, "DynamicConfig", function () { return $98a935c0d0d3a509$export$6dc24881a3d96325; });

var $4tNfC = parcelRequire("4tNfC");

var $htuO4 = parcelRequire("htuO4");

var $2Bhkc = parcelRequire("2Bhkc");

var $65XfA = parcelRequire("65XfA");
var $98a935c0d0d3a509$export$6dc24881a3d96325 = /*#__PURE__*/ function() {
    function DynamicConfig(configName, configValue, ruleID, evaluationDetails) {
        var secondaryExposures = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
        var allocatedExperimentName = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : "";
        var onDefaultValueFallback = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : null;
        (0, (/*@__PURE__*/$parcel$interopDefault($htuO4)))(this, DynamicConfig);
        this.value = configValue;
        this._name = configName;
        this._ruleID = ruleID;
        this._secondaryExposures = secondaryExposures;
        this._allocatedExperimentName = allocatedExperimentName;
        this._evaluationDetails = evaluationDetails;
        this._onDefaultValueFallback = onDefaultValueFallback;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($2Bhkc)))(DynamicConfig, [
        {
            key: "get",
            value: function get(key, defaultValue, typeGuard) {
                var _this$_onDefaultValue2;
                var val = this.getValue(key, defaultValue);
                if (val == null) return defaultValue;
                var expectedType = Array.isArray(defaultValue) ? "array" : (0, (/*@__PURE__*/$parcel$interopDefault($4tNfC)))(defaultValue);
                var actualType = Array.isArray(val) ? "array" : (0, (/*@__PURE__*/$parcel$interopDefault($4tNfC)))(val);
                if (typeGuard) {
                    var _this$_onDefaultValue;
                    if (typeGuard(val)) {
                        this.fireExposure(key);
                        return val;
                    }
                    (_this$_onDefaultValue = this._onDefaultValueFallback) === null || _this$_onDefaultValue === void 0 || _this$_onDefaultValue.call(this, this, key, expectedType, actualType);
                    return defaultValue;
                }
                if (defaultValue == null || expectedType === actualType) {
                    this.fireExposure(key);
                    return val;
                }
                (_this$_onDefaultValue2 = this._onDefaultValueFallback) === null || _this$_onDefaultValue2 === void 0 || _this$_onDefaultValue2.call(this, this, key, expectedType, actualType);
                return defaultValue;
            }
        },
        {
            key: "getValue",
            value: function getValue(key, defaultValue) {
                if (key == null) return this.value;
                if (defaultValue == null) defaultValue = null;
                if (this.value[key] == null) return defaultValue;
                this.fireExposure(key);
                return this.value[key];
            }
        },
        {
            key: "fireExposure",
            value: function fireExposure(key) {
                // Call the wrapped experiment's get method to fire exposure
                if (this.experiment) this.experiment.get(key);
            }
        }
    ], [
        {
            key: "fromExperiment",
            value: function fromExperiment(experiment) {
                var _experiment$__evaluat, _experiment$groupName;
                var config = new DynamicConfig(experiment.name, experiment.value, experiment.ruleID, (0, $65XfA.migrateEvaluationDetails)(experiment.details), (_experiment$__evaluat = experiment.__evaluation) === null || _experiment$__evaluat === void 0 ? void 0 : _experiment$__evaluat.secondary_exposures, (_experiment$groupName = experiment.groupName) !== null && _experiment$groupName !== void 0 ? _experiment$groupName : undefined);
                config.experiment = experiment;
                return config;
            }
        }
    ]);
}();

});
parcelRegister("65XfA", function(module, exports) {

$parcel$export(module.exports, "getOptionsWithDefaults", function () { return $47012b999ccee216$export$d119b37e5f788b43; });
$parcel$export(module.exports, "shallowEquals", function () { return $47012b999ccee216$export$fa1c2bbf4100b8bc; });
$parcel$export(module.exports, "toStatsigUser", function () { return $47012b999ccee216$export$3dad1db244472f32; });
$parcel$export(module.exports, "migrateInitializationOptions", function () { return $47012b999ccee216$export$202946b690d26d22; });
$parcel$export(module.exports, "migrateEvaluationDetails", function () { return $47012b999ccee216$export$18ad168d3dbac899; });

var $1sfUu = parcelRequire("1sfUu");

var $ityw2 = parcelRequire("ityw2");

var $cIF9u = parcelRequire("cIF9u");

var $91P2H = parcelRequire("91P2H");

var $i9yc8 = parcelRequire("i9yc8");

var $145CT = parcelRequire("145CT");
var $47012b999ccee216$var$_excluded = [
    "api",
    "disableCurrentPageLogging",
    "loggingIntervalMillis",
    "loggingBufferMaxSize",
    "localMode",
    "eventLoggingApi",
    "eventLoggingApiForRetries",
    "disableLocalStorage",
    "ignoreWindowUndefined",
    "disableAllLogging",
    "initTimeoutMs",
    "disableNetworkKeepalive",
    "overrideStableID",
    "disableErrorLogging",
    "disableAutoMetricsLogging"
];
function $47012b999ccee216$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $47012b999ccee216$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $47012b999ccee216$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($cIF9u)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $47012b999ccee216$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $47012b999ccee216$export$d119b37e5f788b43 = function getOptionsWithDefaults(options) {
    return $47012b999ccee216$var$_objectSpread({
        /**
     * If more federal PerimeterTypes are added in the future, this should be updated so
     * that isFedRamp() === true always returns the strictest perimeter.
     */ perimeter: (0, $91P2H.isFedRamp)() ? (0, $145CT.PerimeterType).FEDRAMP_MODERATE : (0, $145CT.PerimeterType).COMMERCIAL
    }, options);
};
var $47012b999ccee216$export$fa1c2bbf4100b8bc = function shallowEquals(objectA, objectB) {
    if (!objectA && !objectB) return true;
    if (!objectA || !objectB) return false;
    var aEntries = Object.entries(objectA);
    var bEntries = Object.entries(objectB);
    if (aEntries.length !== bEntries.length) return false;
    var ascendingKeyOrder = function ascendingKeyOrder(_ref, _ref2) {
        var _ref3 = (0, (/*@__PURE__*/$parcel$interopDefault($ityw2)))(_ref, 1), key1 = _ref3[0];
        var _ref4 = (0, (/*@__PURE__*/$parcel$interopDefault($ityw2)))(_ref2, 1), key2 = _ref4[0];
        return key1.localeCompare(key2);
    };
    aEntries.sort(ascendingKeyOrder);
    bEntries.sort(ascendingKeyOrder);
    for(var i = 0; i < aEntries.length; i++){
        var _aEntries$i = (0, (/*@__PURE__*/$parcel$interopDefault($ityw2)))(aEntries[i], 2), aValue = _aEntries$i[1];
        var _bEntries$i = (0, (/*@__PURE__*/$parcel$interopDefault($ityw2)))(bEntries[i], 2), bValue = _bEntries$i[1];
        if (aValue !== bValue) return false;
    }
    return true;
};
var $47012b999ccee216$export$3dad1db244472f32 = function toStatsigUser(identifiers, customAttributes) {
    var user = {
        customIDs: identifiers,
        custom: customAttributes
    };
    if (identifiers.atlassianAccountId) user.userID = identifiers.atlassianAccountId;
    return user;
};
var $47012b999ccee216$export$202946b690d26d22 = function migrateInitializationOptions(options) {
    var api = options.api, disableCurrentPageLogging = options.disableCurrentPageLogging, loggingIntervalMillis = options.loggingIntervalMillis, loggingBufferMaxSize = options.loggingBufferMaxSize, localMode = options.localMode, eventLoggingApi = options.eventLoggingApi, eventLoggingApiForRetries = options.eventLoggingApiForRetries, disableLocalStorage = options.disableLocalStorage, ignoreWindowUndefined = options.ignoreWindowUndefined, disableAllLogging = options.disableAllLogging, _initTimeoutMs = options.initTimeoutMs, _disableNetworkKeepalive = options.disableNetworkKeepalive, _overrideStableID = options.overrideStableID, _disableErrorLogging = options.disableErrorLogging, _disableAutoMetricsLogging = options.disableAutoMetricsLogging, rest = (0, (/*@__PURE__*/$parcel$interopDefault($1sfUu)))(options, $47012b999ccee216$var$_excluded);
    return $47012b999ccee216$var$_objectSpread($47012b999ccee216$var$_objectSpread({}, rest), {}, {
        networkConfig: {
            api: api,
            logEventUrl: eventLoggingApi ? eventLoggingApi + "rgstr" : undefined,
            logEventFallbackUrls: eventLoggingApiForRetries ? [
                eventLoggingApiForRetries
            ] : undefined,
            preventAllNetworkTraffic: localMode || !ignoreWindowUndefined && typeof window === "undefined"
        },
        includeCurrentPageUrlWithEvents: !disableCurrentPageLogging,
        loggingIntervalMs: loggingIntervalMillis,
        loggingBufferMaxSize: loggingBufferMaxSize,
        disableStorage: disableLocalStorage,
        disableLogging: disableAllLogging
    });
};
var $47012b999ccee216$var$evaluationReasonMappings = Object.entries((0, $i9yc8.EvaluationReason)).map(function(_ref5) {
    var _ref6 = (0, (/*@__PURE__*/$parcel$interopDefault($ityw2)))(_ref5, 2), key = _ref6[0], value = _ref6[1];
    return [
        key.toLowerCase(),
        value
    ];
});
var $47012b999ccee216$export$18ad168d3dbac899 = function migrateEvaluationDetails(details) {
    var _evaluationReasonMapp, _evaluationReasonMapp2, _details$receivedAt;
    var reasonLower = details.reason.toLowerCase();
    return {
        reason: (_evaluationReasonMapp = (_evaluationReasonMapp2 = $47012b999ccee216$var$evaluationReasonMappings.find(function(_ref7) {
            var _ref8 = (0, (/*@__PURE__*/$parcel$interopDefault($ityw2)))(_ref7, 1), key = _ref8[0];
            return reasonLower.includes(key);
        })) === null || _evaluationReasonMapp2 === void 0 ? void 0 : _evaluationReasonMapp2[1]) !== null && _evaluationReasonMapp !== void 0 ? _evaluationReasonMapp : (0, $i9yc8.EvaluationReason).Unknown,
        time: (_details$receivedAt = details.receivedAt) !== null && _details$receivedAt !== void 0 ? _details$receivedAt : Date.now()
    };
};

});
parcelRegister("91P2H", function(module, exports) {

$parcel$export(module.exports, "isFedRamp", function () { return $692bcd0b0d020958$export$64d6499adf9b2e51; });

var $gFqms = parcelRequire("gFqms");
function $692bcd0b0d020958$export$64d6499adf9b2e51() {
    var _global$location;
    var global = globalThis;
    // MICROS_PERIMETER is already used by few products, so we need to keep it for backward compatibility
    var env = global.MICROS_PERIMETER || global.UNSAFE_ATL_CONTEXT_BOUNDARY;
    if (env) return env === (0, $gFqms.FEDRAMP_MODERATE);
    var matches = (_global$location = global.location) === null || _global$location === void 0 || (_global$location = _global$location.hostname) === null || _global$location === void 0 ? void 0 : _global$location.match(/atlassian-us-gov-mod\.(com|net)|atlassian-us-gov\.(com|net)|atlassian-fex\.(com|net)|atlassian-stg-fedm\.(com|net)/);
    return matches ? matches.length > 0 : false;
}

});
parcelRegister("gFqms", function(module, exports) {

$parcel$export(module.exports, "FEDRAMP_MODERATE", function () { return $c224ec73133d5151$export$ce553301d55c2fd8; });
var $c224ec73133d5151$export$ce553301d55c2fd8 = "fedramp-moderate";
var $c224ec73133d5151$export$f005e2e9f707cb5f = "commercial";
var $c224ec73133d5151$export$bd6b5a7802d76127 = "fedramp-fedex";
var $c224ec73133d5151$export$a739cd5aac835909 = "stg";
var $c224ec73133d5151$export$42dd0cdd351a4a9 = "prod";
var $c224ec73133d5151$export$404582bc18fe4d9e = "dev";

});


parcelRegister("i9yc8", function(module, exports) {

$parcel$export(module.exports, "EvaluationReason", function () { return $d37397a1083bb210$export$c62558b199e46828; });
// Reference: https://github.com/statsig-io/js-lite/blob/main/src/StatsigStore.ts
var $d37397a1083bb210$export$c62558b199e46828 = /*#__PURE__*/ function(EvaluationReason) {
    EvaluationReason["Error"] = "Error";
    EvaluationReason["LocalOverride"] = "LocalOverride";
    EvaluationReason["Unrecognized"] = "Unrecognized";
    EvaluationReason["Uninitialized"] = "Uninitialized";
    EvaluationReason["NetworkNotModified"] = "NetworkNotModified";
    EvaluationReason["Network"] = "Network";
    EvaluationReason["InvalidBootstrap"] = "InvalidBootstrap";
    EvaluationReason["Bootstrap"] = "Bootstrap";
    EvaluationReason["Cache"] = "Cache";
    EvaluationReason["Unknown"] = "Unknown";
    return EvaluationReason;
}({}); // Reference: https://github.com/statsig-io/js-lite/blob/main/src/StatsigSDKOptions.ts

});

parcelRegister("145CT", function(module, exports) {

$parcel$export(module.exports, "FeatureGateEnvironment", function () { return $0c6a876f7351d393$export$479e7351a733299; });
$parcel$export(module.exports, "PerimeterType", function () { return $0c6a876f7351d393$export$c42b7bbc5e7ba555; });
/**
 * The identifiers for the user. Options are restricted to the set that is currently supported.
 */ /**
 * Base client options. Does not include any options specific to providers
 * @interface BaseClientOptions
 * @property {FeatureGateEnvironment} environment - The environment for the client.
 * @property {string} targetApp - The target app for the client.
 * @property {AnalyticsWebClient} analyticsWebClient - The analytics web client.
 * @property {PerimeterType} perimeter - The perimeter for the client.
 */ /**
 * The options for the client.
 * @interface ClientOptions
 * @extends {BaseClientOptions}
 * @property {string} apiKey - The API key for the client.
 * @property {fetchTimeoutMs} fetchTimeoutMs - The timeout for the fetch request in milliseconds. Defaults to 5000.
 * @property {boolean} useGatewayURL - Whether to use the gateway URL. Defaults to false.
 */ /**
 * The custom attributes for the user.
 */ var $0c6a876f7351d393$export$479e7351a733299 = /*#__PURE__*/ function(FeatureGateEnvironment) {
    FeatureGateEnvironment["Development"] = "development";
    FeatureGateEnvironment["Staging"] = "staging";
    FeatureGateEnvironment["Production"] = "production";
    return FeatureGateEnvironment;
}({});
var $0c6a876f7351d393$export$c42b7bbc5e7ba555 = /*#__PURE__*/ function(PerimeterType) {
    PerimeterType["COMMERCIAL"] = "commercial";
    PerimeterType["FEDRAMP_MODERATE"] = "fedramp-moderate";
    return PerimeterType;
}({});
var $0c6a876f7351d393$export$42f4885608027d0c = "non_boolean"; // Type magic to get the JSDoc comments from the Client class methods to appear on the static
 // methods in FeatureGates where the property name and function type are identical

});



parcelRegister("2FkTo", function(module, exports) {

$parcel$export(module.exports, "Layer", function () { return $1f0f9de7eef95b8d$export$936d0764594b6eb3; });

var $4tNfC = parcelRequire("4tNfC");

var $htuO4 = parcelRequire("htuO4");

var $2Bhkc = parcelRequire("2Bhkc");

var $65XfA = parcelRequire("65XfA");
var $1f0f9de7eef95b8d$export$936d0764594b6eb3 = /*#__PURE__*/ function() {
    function Layer(name, layerValue, ruleID, evaluationDetails) {
        var logParameterFunction = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
        var secondaryExposures = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : [];
        var undelegatedSecondaryExposures = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : [];
        var allocatedExperimentName = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : "";
        var explicitParameters = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : [];
        (0, (/*@__PURE__*/$parcel$interopDefault($htuO4)))(this, Layer);
        this._logParameterFunction = logParameterFunction;
        this._name = name;
        this._value = JSON.parse(JSON.stringify(layerValue !== null && layerValue !== void 0 ? layerValue : {}));
        this._ruleID = ruleID !== null && ruleID !== void 0 ? ruleID : "";
        this._evaluationDetails = evaluationDetails;
        this._secondaryExposures = secondaryExposures;
        this._undelegatedSecondaryExposures = undelegatedSecondaryExposures;
        this._allocatedExperimentName = allocatedExperimentName;
        this._explicitParameters = explicitParameters;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($2Bhkc)))(Layer, [
        {
            key: "get",
            value: function get(key, defaultValue, typeGuard) {
                var _this = this;
                var val = this._value[key];
                if (val == null) return defaultValue;
                var logAndReturn = function logAndReturn() {
                    _this._logLayerParameterExposure(key);
                    return val;
                };
                if (typeGuard) return typeGuard(val) ? logAndReturn() : defaultValue;
                if (defaultValue == null) return logAndReturn();
                if ((0, (/*@__PURE__*/$parcel$interopDefault($4tNfC)))(val) === (0, (/*@__PURE__*/$parcel$interopDefault($4tNfC)))(defaultValue) && Array.isArray(defaultValue) === Array.isArray(val)) return logAndReturn();
                return defaultValue;
            }
        },
        {
            key: "getValue",
            value: function getValue(key, defaultValue) {
                // eslint-disable-next-line eqeqeq
                if (defaultValue == undefined) defaultValue = null;
                var val = this._value[key];
                if (val != null) this._logLayerParameterExposure(key);
                return val !== null && val !== void 0 ? val : defaultValue;
            }
        },
        {
            key: "_logLayerParameterExposure",
            value: function _logLayerParameterExposure(parameterName) {
                var _this$_logParameterFu;
                (_this$_logParameterFu = this._logParameterFunction) === null || _this$_logParameterFu === void 0 || _this$_logParameterFu.call(this, this, parameterName);
            }
        }
    ], [
        {
            key: "fromLayer",
            value: function fromLayer(layer) {
                var _layer$__evaluation, _layer$__evaluation2, _layer$__evaluation3, _layer$__evaluation4;
                var value = new Layer(layer.name, layer.__value, layer.ruleID, (0, $65XfA.migrateEvaluationDetails)(layer.details), function(_layer, parameterName) {
                    return layer.get(parameterName);
                }, (_layer$__evaluation = layer.__evaluation) === null || _layer$__evaluation === void 0 ? void 0 : _layer$__evaluation.secondary_exposures, (_layer$__evaluation2 = layer.__evaluation) === null || _layer$__evaluation2 === void 0 ? void 0 : _layer$__evaluation2.undelegated_secondary_exposures, (_layer$__evaluation3 = layer.__evaluation) === null || _layer$__evaluation3 === void 0 ? void 0 : _layer$__evaluation3.allocated_experiment_name, (_layer$__evaluation4 = layer.__evaluation) === null || _layer$__evaluation4 === void 0 ? void 0 : _layer$__evaluation4.explicit_parameters);
                return value;
            }
        }
    ]);
}();

});

parcelRegister("2GOQ3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1f56f07d92fe87e6$export$2e2bcd8739ae039; });

var $cIF9u = parcelRequire("cIF9u");

var $lR5PM = parcelRequire("lR5PM");

var $htuO4 = parcelRequire("htuO4");

var $2Bhkc = parcelRequire("2Bhkc");

var $4G35a = parcelRequire("4G35a");

var $145CT = parcelRequire("145CT");

var $fetJQ = parcelRequire("fetJQ");

var $kD2wT = parcelRequire("kD2wT");
function $1f56f07d92fe87e6$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $1f56f07d92fe87e6$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $1f56f07d92fe87e6$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($cIF9u)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $1f56f07d92fe87e6$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $1f56f07d92fe87e6$var$DEFAULT_REQUEST_TIMEOUT_MS = 5000;
var $1f56f07d92fe87e6$export$250a58ecde616daa = "https://api.atlassian.com/flags";
var $1f56f07d92fe87e6$export$942ba04389b0d5a2 = "https://api.stg.atlassian.com/flags";
var $1f56f07d92fe87e6$export$f058dbf75c3bc647 = "https://api.dev.atlassian.com/flags";
var $1f56f07d92fe87e6$export$1a401a0da8da3565 = "https://api.stg.atlassian-us-gov-mod.com/flags";
var $1f56f07d92fe87e6$export$18c93900db9358a4 = "https://api.atlassian-us-gov-mod.com/flags";
var $1f56f07d92fe87e6$export$450bd8fb2a6d7ace = "/gateway/api/flags";
var $1f56f07d92fe87e6$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function Fetcher() {
        (0, (/*@__PURE__*/$parcel$interopDefault($htuO4)))(this, Fetcher);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($2Bhkc)))(Fetcher, null, [
        {
            key: "fetchClientSdk",
            value: function() {
                var _fetchClientSdk = (0, (/*@__PURE__*/$parcel$interopDefault($lR5PM)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4G35a))).mark(function _callee(fetcherOptions) {
                    var targetApp, url;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($4G35a))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                targetApp = fetcherOptions.targetApp;
                                url = "/api/v2/frontend/clientSdkKey/".concat(targetApp);
                                _context.prev = 2;
                                _context.next = 5;
                                return this.fetchRequest(url, "GET", fetcherOptions);
                            case 5:
                                return _context.abrupt("return", _context.sent);
                            case 8:
                                _context.prev = 8;
                                _context.t0 = _context["catch"](2);
                                if (!(_context.t0 instanceof Error)) {
                                    _context.next = 12;
                                    break;
                                }
                                throw _context.t0;
                            case 12:
                                throw Error("Failed to retrieve client sdk key");
                            case 13:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this, [
                        [
                            2,
                            8
                        ]
                    ]);
                }));
                function fetchClientSdk(_x) {
                    return _fetchClientSdk.apply(this, arguments);
                }
                return fetchClientSdk;
            }()
        },
        {
            key: "fetchExperimentValues",
            value: function() {
                var _fetchExperimentValues = (0, (/*@__PURE__*/$parcel$interopDefault($lR5PM)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4G35a))).mark(function _callee2(fetcherOptions, identifiers, customAttributes) {
                    var requestBody;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($4G35a))).wrap(function _callee2$(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                requestBody = {
                                    identifiers: identifiers,
                                    customAttributes: customAttributes,
                                    targetApp: fetcherOptions.targetApp
                                };
                                _context2.prev = 1;
                                _context2.next = 4;
                                return this.fetchRequest("/api/v2/frontend/experimentValues", "POST", fetcherOptions, requestBody);
                            case 4:
                                return _context2.abrupt("return", _context2.sent);
                            case 7:
                                _context2.prev = 7;
                                _context2.t0 = _context2["catch"](1);
                                if (!(_context2.t0 instanceof Error)) {
                                    _context2.next = 11;
                                    break;
                                }
                                throw _context2.t0;
                            case 11:
                                throw Error("Failed to retrieve experiment values");
                            case 12:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this, [
                        [
                            1,
                            7
                        ]
                    ]);
                }));
                function fetchExperimentValues(_x2, _x3, _x4) {
                    return _fetchExperimentValues.apply(this, arguments);
                }
                return fetchExperimentValues;
            }()
        },
        {
            key: "handleResponseError",
            value: function() {
                var _handleResponseError = (0, (/*@__PURE__*/$parcel$interopDefault($lR5PM)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4G35a))).mark(function _callee3(response) {
                    var body;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($4G35a))).wrap(function _callee3$(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                if (response.ok) {
                                    _context3.next = 5;
                                    break;
                                }
                                _context3.next = 3;
                                return response.text();
                            case 3:
                                body = _context3.sent;
                                throw new (0, $kD2wT.ResponseError)("Non 2xx response status received, status: ".concat(response.status, ", body: ").concat(JSON.stringify(body)));
                            case 5:
                                if (!(response.status === 204)) {
                                    _context3.next = 7;
                                    break;
                                }
                                throw new (0, $kD2wT.ResponseError)("Unexpected 204 response");
                            case 7:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3);
                }));
                function handleResponseError(_x5) {
                    return _handleResponseError.apply(this, arguments);
                }
                return handleResponseError;
            }()
        },
        {
            key: "extractResponseBody",
            value: function() {
                var _extractResponseBody = (0, (/*@__PURE__*/$parcel$interopDefault($lR5PM)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4G35a))).mark(function _callee4(response) {
                    var value;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($4G35a))).wrap(function _callee4$(_context4) {
                        while(true)switch(_context4.prev = _context4.next){
                            case 0:
                                _context4.next = 2;
                                return response.text();
                            case 2:
                                value = _context4.sent;
                                return _context4.abrupt("return", JSON.parse(value));
                            case 4:
                            case "end":
                                return _context4.stop();
                        }
                    }, _callee4);
                }));
                function extractResponseBody(_x6) {
                    return _extractResponseBody.apply(this, arguments);
                }
                return extractResponseBody;
            }()
        },
        {
            key: "getBaseUrl",
            value: function getBaseUrl(serviceEnv) {
                var useGatewayUrl = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
                var perimeter = arguments.length > 2 ? arguments[2] : undefined;
                if (useGatewayUrl) return $1f56f07d92fe87e6$export$450bd8fb2a6d7ace;
                if (perimeter === (0, $145CT.PerimeterType).FEDRAMP_MODERATE) switch(serviceEnv){
                    case (0, $145CT.FeatureGateEnvironment).Production:
                        return $1f56f07d92fe87e6$export$18c93900db9358a4;
                    case (0, $145CT.FeatureGateEnvironment).Staging:
                        return $1f56f07d92fe87e6$export$1a401a0da8da3565;
                    default:
                        throw new Error('Invalid environment "'.concat(serviceEnv, '" for "').concat(perimeter, '" perimeter'));
                }
                else if (perimeter === (0, $145CT.PerimeterType).COMMERCIAL) switch(serviceEnv){
                    case (0, $145CT.FeatureGateEnvironment).Development:
                        return $1f56f07d92fe87e6$export$f058dbf75c3bc647;
                    case (0, $145CT.FeatureGateEnvironment).Staging:
                        return $1f56f07d92fe87e6$export$942ba04389b0d5a2;
                    default:
                        return $1f56f07d92fe87e6$export$250a58ecde616daa;
                }
                else throw new Error('Invalid perimeter "'.concat(perimeter, '"'));
            }
        },
        {
            key: "fetchRequest",
            value: function() {
                var _fetchRequest = (0, (/*@__PURE__*/$parcel$interopDefault($lR5PM)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4G35a))).mark(function _callee5(path, method, fetcherOptions, body) {
                    var baseUrl, fetchTimeout, abortSignal, abortController, response;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($4G35a))).wrap(function _callee5$(_context5) {
                        while(true)switch(_context5.prev = _context5.next){
                            case 0:
                                baseUrl = Fetcher.getBaseUrl(fetcherOptions.environment, fetcherOptions.useGatewayURL, fetcherOptions.perimeter);
                                fetchTimeout = fetcherOptions.fetchTimeoutMs || $1f56f07d92fe87e6$var$DEFAULT_REQUEST_TIMEOUT_MS;
                                if (AbortSignal.timeout) abortSignal = AbortSignal.timeout(fetchTimeout);
                                else if (AbortController) {
                                    abortController = new AbortController();
                                    abortSignal = abortController.signal;
                                    setTimeout(function() {
                                        return abortController.abort();
                                    }, fetchTimeout);
                                }
                                _context5.next = 5;
                                return fetch("".concat(baseUrl).concat(path), $1f56f07d92fe87e6$var$_objectSpread({
                                    method: method,
                                    headers: {
                                        "Content-Type": "application/json",
                                        "X-Client-Name": "feature-gate-js-client",
                                        "X-Client-Version": (0, $fetJQ.CLIENT_VERSION),
                                        "X-API-KEY": fetcherOptions.apiKey
                                    },
                                    signal: abortSignal
                                }, body && {
                                    body: JSON.stringify(body)
                                }));
                            case 5:
                                response = _context5.sent;
                                _context5.next = 8;
                                return this.handleResponseError(response);
                            case 8:
                                _context5.next = 10;
                                return this.extractResponseBody(response);
                            case 10:
                                return _context5.abrupt("return", _context5.sent);
                            case 11:
                            case "end":
                                return _context5.stop();
                        }
                    }, _callee5, this);
                }));
                function fetchRequest(_x7, _x8, _x9, _x10) {
                    return _fetchRequest.apply(this, arguments);
                }
                return fetchRequest;
            }()
        }
    ]);
}();

});
parcelRegister("fetJQ", function(module, exports) {

$parcel$export(module.exports, "CLIENT_VERSION", function () { return $b16f3b4478da24e2$export$a59f8d67326bd1cb; });
/// <reference types="node" />
var $b16f3b4478da24e2$export$a59f8d67326bd1cb = "4.25.0";

});

parcelRegister("kD2wT", function(module, exports) {

$parcel$export(module.exports, "ResponseError", function () { return $f049697992662052$export$286baf652d0b1206; });

var $2Bhkc = parcelRequire("2Bhkc");

var $htuO4 = parcelRequire("htuO4");

var $059ss = parcelRequire("059ss");

var $7qVJv = parcelRequire("7qVJv");

var $fRASa = parcelRequire("fRASa");

var $5yG9W = parcelRequire("5yG9W");
function $f049697992662052$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($7qVJv)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($059ss)))(t, $f049697992662052$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($7qVJv)))(t).constructor) : o.apply(t, e));
}
function $f049697992662052$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($f049697992662052$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $f049697992662052$export$286baf652d0b1206 = /*#__PURE__*/ function(_Error) {
    function ResponseError(message) {
        (0, (/*@__PURE__*/$parcel$interopDefault($htuO4)))(this, ResponseError);
        return $f049697992662052$var$_callSuper(this, ResponseError, [
            message
        ]);
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($fRASa)))(ResponseError, _Error);
    return (0, (/*@__PURE__*/$parcel$interopDefault($2Bhkc)))(ResponseError);
}(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5yG9W)))(Error));

});
parcelRegister("059ss", function(module, exports) {

var $4tNfC = parcelRequire("4tNfC");
var $00f7cdebf58f286b$var$_typeof = $4tNfC.default;

var $doTRp = parcelRequire("doTRp");
function $00f7cdebf58f286b$var$_possibleConstructorReturn(t, e) {
    if (e && ("object" == $00f7cdebf58f286b$var$_typeof(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return $doTRp(t);
}
module.exports = $00f7cdebf58f286b$var$_possibleConstructorReturn, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("doTRp", function(module, exports) {
function $9c18d8f62082a976$var$_assertThisInitialized(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}
module.exports = $9c18d8f62082a976$var$_assertThisInitialized, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("7qVJv", function(module, exports) {
function $5697beae31aeb15b$var$_getPrototypeOf(t) {
    return module.exports = $5697beae31aeb15b$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $5697beae31aeb15b$var$_getPrototypeOf(t);
}
module.exports = $5697beae31aeb15b$var$_getPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("fRASa", function(module, exports) {

var $fLb54 = parcelRequire("fLb54");
function $b8c8685ef3a3eb1e$var$_inherits(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && $fLb54(t, e);
}
module.exports = $b8c8685ef3a3eb1e$var$_inherits, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("fLb54", function(module, exports) {
function $b793d7389d79b1b8$var$_setPrototypeOf(t, e) {
    return module.exports = $b793d7389d79b1b8$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $b793d7389d79b1b8$var$_setPrototypeOf(t, e);
}
module.exports = $b793d7389d79b1b8$var$_setPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("5yG9W", function(module, exports) {

var $7qVJv = parcelRequire("7qVJv");

var $fLb54 = parcelRequire("fLb54");

var $gpxFB = parcelRequire("gpxFB");

var $fvpZv = parcelRequire("fvpZv");
function $40c0d4b487205efc$var$_wrapNativeSuper(t) {
    var r = "function" == typeof Map ? new Map() : void 0;
    return module.exports = $40c0d4b487205efc$var$_wrapNativeSuper = function _wrapNativeSuper(t) {
        if (null === t || !$gpxFB(t)) return t;
        if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function");
        if (void 0 !== r) {
            if (r.has(t)) return r.get(t);
            r.set(t, Wrapper);
        }
        function Wrapper() {
            return $fvpZv(t, arguments, $7qVJv(this).constructor);
        }
        return Wrapper.prototype = Object.create(t.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: !1,
                writable: !0,
                configurable: !0
            }
        }), $fLb54(Wrapper, t);
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $40c0d4b487205efc$var$_wrapNativeSuper(t);
}
module.exports = $40c0d4b487205efc$var$_wrapNativeSuper, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("gpxFB", function(module, exports) {
function $bf29194d87b70603$var$_isNativeFunction(t) {
    try {
        return -1 !== Function.toString.call(t).indexOf("[native code]");
    } catch (n) {
        return "function" == typeof t;
    }
}
module.exports = $bf29194d87b70603$var$_isNativeFunction, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("fvpZv", function(module, exports) {

var $2iKZP = parcelRequire("2iKZP");

var $fLb54 = parcelRequire("fLb54");
function $b49de988fa8846ee$var$_construct(t, e, r) {
    if ($2iKZP()) return Reflect.construct.apply(null, arguments);
    var o = [
        null
    ];
    o.push.apply(o, e);
    var p = new (t.bind.apply(t, o))();
    return r && $fLb54(p, r.prototype), p;
}
module.exports = $b49de988fa8846ee$var$_construct, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("2iKZP", function(module, exports) {
function $1ad1b7afebcacf53$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return (module.exports = $1ad1b7afebcacf53$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports)();
}
module.exports = $1ad1b7afebcacf53$var$_isNativeReflectConstruct, module.exports.__esModule = true, module.exports["default"] = module.exports;

});





parcelRegister("ks3Iz", function(module, exports) {

$parcel$export(module.exports, "NoFetchDataAdapter", function () { return $ee394e798e51d18b$export$55fffef3474104af; });

var $lR5PM = parcelRequire("lR5PM");

var $htuO4 = parcelRequire("htuO4");

var $2Bhkc = parcelRequire("2Bhkc");

var $059ss = parcelRequire("059ss");

var $7qVJv = parcelRequire("7qVJv");

var $az8H7 = parcelRequire("az8H7");

var $fRASa = parcelRequire("fRASa");

var $cIF9u = parcelRequire("cIF9u");

var $4G35a = parcelRequire("4G35a");

var $e2ZOQ = parcelRequire("e2ZOQ");
function $ee394e798e51d18b$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $ee394e798e51d18b$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $ee394e798e51d18b$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($cIF9u)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $ee394e798e51d18b$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $ee394e798e51d18b$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($7qVJv)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($059ss)))(t, $ee394e798e51d18b$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($7qVJv)))(t).constructor) : o.apply(t, e));
}
function $ee394e798e51d18b$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($ee394e798e51d18b$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $ee394e798e51d18b$var$_superPropGet(t, o, e, r) {
    var p = (0, (/*@__PURE__*/$parcel$interopDefault($az8H7)))((0, (/*@__PURE__*/$parcel$interopDefault($7qVJv)))(1 & r ? t.prototype : t), o, e);
    return 2 & r && "function" == typeof p ? function(t) {
        return p.apply(e, t);
    } : p;
}
var $ee394e798e51d18b$export$55fffef3474104af = /*#__PURE__*/ function(_DataAdapterCore) {
    function NoFetchDataAdapter() {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($htuO4)))(this, NoFetchDataAdapter);
        _this = $ee394e798e51d18b$var$_callSuper(this, NoFetchDataAdapter, [
            "NoFetchDataAdapter",
            "nofetch"
        ]);
        (0, (/*@__PURE__*/$parcel$interopDefault($cIF9u)))(_this, "bootstrapResult", null);
        return _this;
    }
    /**
   * Make sure to call this **before** calling `initializeAsync` or `updateUserAsync` but
   * after the Statsig client has been created!
   */ (0, (/*@__PURE__*/$parcel$interopDefault($fRASa)))(NoFetchDataAdapter, _DataAdapterCore);
    return (0, (/*@__PURE__*/$parcel$interopDefault($2Bhkc)))(NoFetchDataAdapter, [
        {
            key: "setBootstrapData",
            value: function setBootstrapData(data) {
                this.bootstrapResult = data ? {
                    source: "Bootstrap",
                    data: JSON.stringify(data),
                    receivedAt: Date.now(),
                    stableID: (0, $e2ZOQ.StableID).get(this._getSdkKey()),
                    fullUserHash: null
                } : null;
            }
        },
        {
            key: "prefetchData",
            value: function() {
                var _prefetchData = (0, (/*@__PURE__*/$parcel$interopDefault($lR5PM)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4G35a))).mark(function _callee(_user, _options) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($4G35a))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee);
                }));
                function prefetchData(_x, _x2) {
                    return _prefetchData.apply(this, arguments);
                }
                return prefetchData;
            }()
        },
        {
            key: "getDataAsync",
            value: function() {
                var _getDataAsync = (0, (/*@__PURE__*/$parcel$interopDefault($lR5PM)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4G35a))).mark(function _callee2(_current, user, _options) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($4G35a))).wrap(function _callee2$(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                return _context2.abrupt("return", this.bootstrapResult && $ee394e798e51d18b$var$_objectSpread($ee394e798e51d18b$var$_objectSpread({}, this.bootstrapResult), {}, {
                                    fullUserHash: (0, $e2ZOQ._getFullUserHash)(user)
                                }));
                            case 1:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this);
                }));
                function getDataAsync(_x3, _x4, _x5) {
                    return _getDataAsync.apply(this, arguments);
                }
                return getDataAsync;
            }()
        },
        {
            key: "getDataSync",
            value: function getDataSync(user) {
                return this.bootstrapResult && $ee394e798e51d18b$var$_objectSpread($ee394e798e51d18b$var$_objectSpread({}, this.bootstrapResult), {}, {
                    fullUserHash: (0, $e2ZOQ._getFullUserHash)(user)
                });
            }
        },
        {
            key: "_fetchFromNetwork",
            value: function() {
                var _fetchFromNetwork2 = (0, (/*@__PURE__*/$parcel$interopDefault($lR5PM)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4G35a))).mark(function _callee3(_current, _user, _options) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($4G35a))).wrap(function _callee3$(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                return _context3.abrupt("return", null);
                            case 1:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3);
                }));
                function _fetchFromNetwork(_x6, _x7, _x8) {
                    return _fetchFromNetwork2.apply(this, arguments);
                }
                return _fetchFromNetwork;
            }()
        },
        {
            key: "_getCacheKey",
            value: function _getCacheKey(user) {
                // Same logic as default data adapter
                // https://github.com/statsig-io/js-client-monorepo/blob/main/packages/js-client/src/StatsigEvaluationsDataAdapter.ts
                var key = (0, $e2ZOQ._getStorageKey)(this._getSdkKey(), user);
                return "".concat((0, $e2ZOQ.DataAdapterCachePrefix), ".").concat(this._cacheSuffix, ".").concat(key);
            }
        },
        {
            key: "_isCachedResultValidFor204",
            value: function _isCachedResultValidFor204(_result, _user) {
                return false;
            }
        },
        {
            key: "setDataLegacy",
            value: function setDataLegacy(data, user) {
                $ee394e798e51d18b$var$_superPropGet(NoFetchDataAdapter, "setData", this, 3)([
                    data,
                    user
                ]);
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                var result = $ee394e798e51d18b$var$_objectSpread({}, this);
                delete result._options;
                delete result._inMemoryCache;
                delete result.bootstrapResult;
                return result;
            }
        }
    ]);
}((0, $e2ZOQ.DataAdapterCore));

});
parcelRegister("az8H7", function(module, exports) {

var $ibukC = parcelRequire("ibukC");
function $7b13eaceb96cdfd0$var$_get() {
    return module.exports = $7b13eaceb96cdfd0$var$_get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function(e, t, r) {
        var p = $ibukC(e, t);
        if (p) {
            var n = Object.getOwnPropertyDescriptor(p, t);
            return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value;
        }
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $7b13eaceb96cdfd0$var$_get.apply(null, arguments);
}
module.exports = $7b13eaceb96cdfd0$var$_get, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("ibukC", function(module, exports) {

var $7qVJv = parcelRequire("7qVJv");
function $d3d0c85016ad5134$var$_superPropBase(t, o) {
    for(; !({}).hasOwnProperty.call(t, o) && null !== (t = $7qVJv(t)););
    return t;
}
module.exports = $d3d0c85016ad5134$var$_superPropBase, module.exports.__esModule = true, module.exports["default"] = module.exports;

});



parcelRegister("i7s0Q", function(module, exports) {

$parcel$export(module.exports, "PersistentOverrideAdapter", function () { return $d30e9c2608b5b891$export$bcb28fbac1def494; });

var $cIF9u = parcelRequire("cIF9u");

var $ityw2 = parcelRequire("ityw2");

var $htuO4 = parcelRequire("htuO4");

var $2Bhkc = parcelRequire("2Bhkc");

var $aALut = parcelRequire("aALut");
function $d30e9c2608b5b891$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $d30e9c2608b5b891$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $d30e9c2608b5b891$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($cIF9u)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $d30e9c2608b5b891$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $d30e9c2608b5b891$var$LOCAL_OVERRIDE_REASON = "LocalOverride:Recognized";
var $d30e9c2608b5b891$export$d8474cff104280f3 = "STATSIG_OVERRIDES";
var $d30e9c2608b5b891$var$LEGACY_LOCAL_STORAGE_KEY = "STATSIG_JS_LITE_LOCAL_OVERRIDES";
var $d30e9c2608b5b891$var$makeEmptyStore = function makeEmptyStore() {
    return {
        gates: {},
        configs: {},
        layers: {}
    };
};
var $d30e9c2608b5b891$export$bcb28fbac1def494 = /*#__PURE__*/ function() {
    function PersistentOverrideAdapter() {
        (0, (/*@__PURE__*/$parcel$interopDefault($htuO4)))(this, PersistentOverrideAdapter);
        this._overrides = $d30e9c2608b5b891$var$makeEmptyStore();
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($2Bhkc)))(PersistentOverrideAdapter, [
        {
            key: "parseStoredOverrides",
            value: function parseStoredOverrides(localStorageKey) {
                try {
                    var json = window.localStorage.getItem($d30e9c2608b5b891$export$d8474cff104280f3);
                    if (!json) return $d30e9c2608b5b891$var$makeEmptyStore();
                    return JSON.parse(json);
                } catch (_unused) {
                    return $d30e9c2608b5b891$var$makeEmptyStore();
                }
            }
        },
        {
            key: "mergeOverrides",
            value: function mergeOverrides() {
                var merged = $d30e9c2608b5b891$var$makeEmptyStore();
                for(var _len = arguments.length, allOverrides = new Array(_len), _key = 0; _key < _len; _key++)allOverrides[_key] = arguments[_key];
                for(var _i = 0, _allOverrides = allOverrides; _i < _allOverrides.length; _i++){
                    var overrides = _allOverrides[_i];
                    for(var _i2 = 0, _Object$entries = Object.entries(overrides.gates); _i2 < _Object$entries.length; _i2++){
                        var _Object$entries$_i = (0, (/*@__PURE__*/$parcel$interopDefault($ityw2)))(_Object$entries[_i2], 2), name = _Object$entries$_i[0], value = _Object$entries$_i[1];
                        merged.gates[name] = value;
                    }
                    for(var _i3 = 0, _Object$entries2 = Object.entries(overrides.configs); _i3 < _Object$entries2.length; _i3++){
                        var _Object$entries2$_i = (0, (/*@__PURE__*/$parcel$interopDefault($ityw2)))(_Object$entries2[_i3], 2), _name = _Object$entries2$_i[0], _value = _Object$entries2$_i[1];
                        merged.configs[_name] = _value;
                    }
                    for(var _i4 = 0, _Object$entries3 = Object.entries(overrides.layers); _i4 < _Object$entries3.length; _i4++){
                        var _Object$entries3$_i = (0, (/*@__PURE__*/$parcel$interopDefault($ityw2)))(_Object$entries3[_i4], 2), _name2 = _Object$entries3$_i[0], _value2 = _Object$entries3$_i[1];
                        merged.layers[_name2] = _value2;
                    }
                }
                return merged;
            }
        },
        {
            key: "initFromStoredOverrides",
            value: function initFromStoredOverrides() {
                this._overrides = this.mergeOverrides(this.parseStoredOverrides($d30e9c2608b5b891$var$LEGACY_LOCAL_STORAGE_KEY), this.parseStoredOverrides($d30e9c2608b5b891$export$d8474cff104280f3));
            }
        },
        {
            key: "saveOverrides",
            value: function saveOverrides() {
                window.localStorage.setItem($d30e9c2608b5b891$export$d8474cff104280f3, JSON.stringify(this._overrides));
            }
        },
        {
            key: "getOverrides",
            value: function getOverrides() {
                return Object.fromEntries(Object.entries(this._overrides).map(function(_ref) {
                    var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($ityw2)))(_ref, 2), key = _ref2[0], container = _ref2[1];
                    var record = {};
                    for(var _i5 = 0, _Object$entries4 = Object.entries(container); _i5 < _Object$entries4.length; _i5++){
                        var _Object$entries4$_i = (0, (/*@__PURE__*/$parcel$interopDefault($ityw2)))(_Object$entries4[_i5], 2), name = _Object$entries4$_i[0], value = _Object$entries4$_i[1];
                        if (Object.prototype.hasOwnProperty.call(container, (0, $aALut._DJB2)(name))) record[name] = value;
                    }
                    return [
                        key,
                        record
                    ];
                }));
            }
        },
        {
            key: "setOverrides",
            value: function setOverrides(overrides) {
                var newOverrides = $d30e9c2608b5b891$var$_objectSpread($d30e9c2608b5b891$var$_objectSpread({}, $d30e9c2608b5b891$var$makeEmptyStore()), overrides);
                for(var _i6 = 0, _Object$values = Object.values(newOverrides); _i6 < _Object$values.length; _i6++){
                    var container = _Object$values[_i6];
                    for(var _i7 = 0, _Object$entries5 = Object.entries(container); _i7 < _Object$entries5.length; _i7++){
                        var _Object$entries5$_i = (0, (/*@__PURE__*/$parcel$interopDefault($ityw2)))(_Object$entries5[_i7], 2), name = _Object$entries5$_i[0], value = _Object$entries5$_i[1];
                        var hash = (0, $aALut._DJB2)(name);
                        if (!Object.prototype.hasOwnProperty.call(container, hash)) container[hash] = value;
                    }
                }
                this._overrides = newOverrides;
                this.saveOverrides();
            }
        },
        {
            key: "overrideGate",
            value: function overrideGate(name, value) {
                this._overrides.gates[name] = value;
                this._overrides.gates[(0, $aALut._DJB2)(name)] = value;
                this.saveOverrides();
            }
        },
        {
            key: "removeGateOverride",
            value: function removeGateOverride(name) {
                delete this._overrides.gates[name];
                delete this._overrides.gates[(0, $aALut._DJB2)(name)];
                this.saveOverrides();
            }
        },
        {
            key: "getGateOverride",
            value: function getGateOverride(current, _user) {
                var _this$_overrides$gate;
                var overridden = (_this$_overrides$gate = this._overrides.gates[current.name]) !== null && _this$_overrides$gate !== void 0 ? _this$_overrides$gate : this._overrides.gates[(0, $aALut._DJB2)(current.name)];
                if (overridden == null) return null;
                return $d30e9c2608b5b891$var$_objectSpread($d30e9c2608b5b891$var$_objectSpread({}, current), {}, {
                    value: overridden,
                    details: $d30e9c2608b5b891$var$_objectSpread($d30e9c2608b5b891$var$_objectSpread({}, current.details), {}, {
                        reason: $d30e9c2608b5b891$var$LOCAL_OVERRIDE_REASON
                    })
                });
            }
        },
        {
            key: "overrideDynamicConfig",
            value: function overrideDynamicConfig(name, value) {
                this._overrides.configs[name] = value;
                this._overrides.configs[(0, $aALut._DJB2)(name)] = value;
                this.saveOverrides();
            }
        },
        {
            key: "removeDynamicConfigOverride",
            value: function removeDynamicConfigOverride(name) {
                delete this._overrides.configs[name];
                delete this._overrides.configs[(0, $aALut._DJB2)(name)];
                this.saveOverrides();
            }
        },
        {
            key: "getDynamicConfigOverride",
            value: function getDynamicConfigOverride(current, _user) {
                return this._getConfigOverride(current, this._overrides.configs);
            }
        },
        {
            key: "overrideExperiment",
            value: function overrideExperiment(name, value) {
                this._overrides.configs[name] = value;
                this._overrides.configs[(0, $aALut._DJB2)(name)] = value;
                this.saveOverrides();
            }
        },
        {
            key: "removeExperimentOverride",
            value: function removeExperimentOverride(name) {
                delete this._overrides.configs[name];
                delete this._overrides.configs[(0, $aALut._DJB2)(name)];
                this.saveOverrides();
            }
        },
        {
            key: "getExperimentOverride",
            value: function getExperimentOverride(current, _user) {
                return this._getConfigOverride(current, this._overrides.configs);
            }
        },
        {
            key: "overrideLayer",
            value: function overrideLayer(name, value) {
                this._overrides.layers[name] = value;
                this._overrides.layers[(0, $aALut._DJB2)(name)] = value;
                this.saveOverrides();
            }
        },
        {
            key: "removeLayerOverride",
            value: function removeLayerOverride(name) {
                delete this._overrides.layers[name];
                delete this._overrides.layers[(0, $aALut._DJB2)(name)];
                this.saveOverrides();
            }
        },
        {
            key: "removeAllOverrides",
            value: function removeAllOverrides() {
                this._overrides = $d30e9c2608b5b891$var$makeEmptyStore();
                window.localStorage.removeItem($d30e9c2608b5b891$export$d8474cff104280f3);
            }
        },
        {
            key: "getLayerOverride",
            value: function getLayerOverride(current, _user) {
                var _this$_overrides$laye;
                var overridden = (_this$_overrides$laye = this._overrides.layers[current.name]) !== null && _this$_overrides$laye !== void 0 ? _this$_overrides$laye : this._overrides.layers[(0, $aALut._DJB2)(current.name)];
                if (overridden == null) return null;
                return $d30e9c2608b5b891$var$_objectSpread($d30e9c2608b5b891$var$_objectSpread({}, current), {}, {
                    __value: overridden,
                    get: (0, $aALut._makeTypedGet)(current.name, overridden),
                    details: $d30e9c2608b5b891$var$_objectSpread($d30e9c2608b5b891$var$_objectSpread({}, current.details), {}, {
                        reason: $d30e9c2608b5b891$var$LOCAL_OVERRIDE_REASON
                    })
                });
            }
        },
        {
            key: "_getConfigOverride",
            value: function _getConfigOverride(current, lookup) {
                var _lookup$current$name;
                var overridden = (_lookup$current$name = lookup[current.name]) !== null && _lookup$current$name !== void 0 ? _lookup$current$name : lookup[(0, $aALut._DJB2)(current.name)];
                if (overridden == null) return null;
                return $d30e9c2608b5b891$var$_objectSpread($d30e9c2608b5b891$var$_objectSpread({}, current), {}, {
                    value: overridden,
                    get: (0, $aALut._makeTypedGet)(current.name, overridden),
                    details: $d30e9c2608b5b891$var$_objectSpread($d30e9c2608b5b891$var$_objectSpread({}, current.details), {}, {
                        reason: $d30e9c2608b5b891$var$LOCAL_OVERRIDE_REASON
                    })
                });
            }
        }
    ]);
}();

});



parcelRegister("eA7oY", function(module, exports) {

$parcel$export(module.exports, "debug", function () { return $a9da2b58be523614$export$1c9f709888824e05; });
var $a9da2b58be523614$var$_process, $a9da2b58be523614$var$_process2;
// We can't rely on NODE_ENV === 'test' if its value is already configured by the consumer to some other value, so better to use JEST_WORKER_ID
// https://jestjs.io/docs/environment-variables#jest_worker_id
var $a9da2b58be523614$var$TESTS_MODE = (globalThis === null || globalThis === void 0 || ($a9da2b58be523614$var$_process = globalThis.process) === null || $a9da2b58be523614$var$_process === void 0 || ($a9da2b58be523614$var$_process = $a9da2b58be523614$var$_process.env) === null || $a9da2b58be523614$var$_process === void 0 ? void 0 : $a9da2b58be523614$var$_process.JEST_WORKER_ID) !== undefined;
var $a9da2b58be523614$var$DEBUG_MODE = !$a9da2b58be523614$var$TESTS_MODE && (globalThis === null || globalThis === void 0 || ($a9da2b58be523614$var$_process2 = globalThis.process) === null || $a9da2b58be523614$var$_process2 === void 0 || ($a9da2b58be523614$var$_process2 = $a9da2b58be523614$var$_process2.env) === null || $a9da2b58be523614$var$_process2 === void 0 ? void 0 : $a9da2b58be523614$var$_process2.NODE_ENV) !== "production";
var $a9da2b58be523614$export$1c9f709888824e05 = function debug() {
    var _console;
    if (!$a9da2b58be523614$var$DEBUG_MODE) return;
    // eslint-disable-next-line no-console
    (_console = console).debug.apply(_console, arguments);
};

});




parcelRegister("gN6LC", function(module, exports) {

$parcel$export(module.exports, "useCloseOnEscapePress", function () { return $c39678b9357330c8$export$4a4bf067ea9e7886; });

var $dAx5m = parcelRequire("dAx5m");

var $dd4sf = parcelRequire("dd4sf");

var $jl49R = parcelRequire("jl49R");
var $c39678b9357330c8$var$ESCAPE = "Escape";
function $c39678b9357330c8$export$4a4bf067ea9e7886(_ref) {
    var onClose = _ref.onClose, isDisabled = _ref.isDisabled;
    var escapePressed = (0, $dAx5m.useRef)(false);
    var _useLayering = $c39678b9357330c8$export$c8b4d54e03dee6ed(), isLayerDisabled = _useLayering.isLayerDisabled;
    var onKeyDown = (0, $dAx5m.useCallback)(function(e) {
        var isDisabledLayer = isLayerDisabled();
        if (isDisabled || escapePressed.current || e.key !== $c39678b9357330c8$var$ESCAPE || isDisabledLayer) // We're either already handling the key down event or it's not escape or disabled.
        // Bail early!
        return;
        escapePressed.current = true;
        onClose(e);
    }, [
        onClose,
        isDisabled,
        isLayerDisabled
    ]);
    var onKeyUp = (0, $dAx5m.useCallback)(function() {
        escapePressed.current = false;
    }, []);
    (0, $dAx5m.useEffect)(function() {
        return (0, $dd4sf.bindAll)(window, [
            {
                type: "keydown",
                listener: onKeyDown
            },
            {
                type: "keyup",
                listener: onKeyUp
            }
        ], {
            capture: false
        });
    }, [
        onKeyDown,
        onKeyUp
    ]);
}
function $c39678b9357330c8$export$c8b4d54e03dee6ed() {
    var currentLevel = (0, $dAx5m.useContext)((0, $jl49R.LevelContext));
    var _useContext = (0, $dAx5m.useContext)((0, $jl49R.TopLevelContext)), topLevelRef = _useContext.topLevelRef;
    var isLayerDisabled = (0, $dAx5m.useCallback)(function() {
        return !!topLevelRef.current && currentLevel !== topLevelRef.current;
    }, [
        currentLevel,
        topLevelRef
    ]);
    return {
        currentLevel: currentLevel,
        topLevelRef: topLevelRef,
        isLayerDisabled: isLayerDisabled
    };
}

});

parcelRegister("iWhPr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dc9b79327c42f7ed$export$2e2bcd8739ae039; });

var $dAx5m = parcelRequire("dAx5m");

var $18rB9 = parcelRequire("18rB9");

var $bL3rT = parcelRequire("bL3rT");

var $14HMF = parcelRequire("14HMF");

var $44qD7 = parcelRequire("44qD7");

var $bm5Mx = parcelRequire("bm5Mx");
function $dc9b79327c42f7ed$export$2e2bcd8739ae039(_ref) {
    var _ref$zIndex = _ref.zIndex, zIndex = _ref$zIndex === void 0 ? 0 : _ref$zIndex, children = _ref.children, _ref$mountStrategy = _ref.mountStrategy, mountStrategy = _ref$mountStrategy === void 0 ? "effect" : _ref$mountStrategy;
    var isSubsequentRender = (0, $44qD7.default)(mountStrategy);
    (0, $bm5Mx.default)(zIndex);
    // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
    return !(0, $18rB9.fg)("platform_design_system_team_portal_logic_r18_fix") ? isSubsequentRender ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $bL3rT.default), {
        zIndex: zIndex
    }, children) : null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $14HMF.default), {
        zIndex: zIndex
    }, children);
}

});
parcelRegister("bL3rT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $02358743abaf1be4$export$2e2bcd8739ae039; });

var $dAx5m = parcelRequire("dAx5m");

var $1MpXQ = parcelRequire("1MpXQ");

var $jaMRM = parcelRequire("jaMRM");
function $02358743abaf1be4$export$2e2bcd8739ae039(props) {
    var zIndex = props.zIndex, children = props.children;
    var container = (0, $dAx5m.useMemo)(function() {
        return (0, $jaMRM.createContainer)(zIndex);
    }, [
        zIndex
    ]);
    // This is in the render method instead of useEffect so that
    // the portal will be added to the DOM before the children render.
    // For any further changes, ensure that the container does not have a
    // parent besides the portal parent.
    (0, $jaMRM.appendPortalContainerIfNotAppended)(container);
    (0, $dAx5m.useEffect)(function() {
        return function() {
            (0, $jaMRM.removePortalContainer)(container);
        };
    }, [
        container
    ]);
    return /*#__PURE__*/ (0, $1MpXQ.createPortal)(children, container);
}

});
parcelRegister("jaMRM", function(module, exports) {

$parcel$export(module.exports, "createContainer", function () { return $df54db561ca68475$export$26ae5ca175b4ec5a; });
$parcel$export(module.exports, "removePortalContainer", function () { return $df54db561ca68475$export$da99f98bf3fe55b3; });
$parcel$export(module.exports, "appendPortalContainerIfNotAppended", function () { return $df54db561ca68475$export$c582005add11e141; });
$parcel$export(module.exports, "createAtlaskitPortal", function () { return $df54db561ca68475$export$fef014d7cef9e543; });
$parcel$export(module.exports, "createPortalParent", function () { return $df54db561ca68475$export$95029ca7aca2989e; });

var $2DiSv = parcelRequire("2DiSv");
var $df54db561ca68475$export$26ae5ca175b4ec5a = function createContainer(zIndex) {
    var container = document.createElement("div");
    container.className = (0, $2DiSv.portalClassName);
    container.style.zIndex = "".concat(zIndex);
    return container;
};
/**
 * Returns document body element
 * @return {number} - The document body element
 */ var $df54db561ca68475$var$getBody = function getBody() {
    return document.body;
};
/**
 * Returns portal parent container. If no container exists already then it creates a new container with class name 'atlaskit-portal-container'
 * @return {Element} - The portal parent container div element
 */ var $df54db561ca68475$var$getPortalParent = function getPortalParent() {
    var parentElement = document.querySelector((0, $2DiSv.portalParentSelector));
    if (!parentElement) {
        var _getBody;
        var parent = document.createElement("div");
        parent.className = (0, $2DiSv.portalParentClassName);
        // we are setting display to flex because we want each portal to create a new stacking context
        // See https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Positioning/Understanding_z_index/The_stacking_context
        parent.style.display = "flex";
        (_getBody = $df54db561ca68475$var$getBody()) === null || _getBody === void 0 || _getBody.appendChild(parent);
        return parent;
    }
    return parentElement;
};
var $df54db561ca68475$export$da99f98bf3fe55b3 = function removePortalContainer(container) {
    $df54db561ca68475$var$getPortalParent().removeChild(container);
};
var $df54db561ca68475$export$c582005add11e141 = function appendPortalContainerIfNotAppended(container) {
    if (!container.parentElement) $df54db561ca68475$var$getPortalParent().appendChild(container);
};
var $df54db561ca68475$var$isDocumentDefined = function isDocumentDefined() {
    return document !== undefined;
};
var $df54db561ca68475$export$fef014d7cef9e543 = function createAtlaskitPortal(zIndex) {
    //atlaskit-portal div
    if ($df54db561ca68475$var$isDocumentDefined()) {
        var atlaskitportal = document.createElement("div");
        atlaskitportal.className = (0, $2DiSv.portalClassName);
        atlaskitportal.style.zIndex = "".concat(zIndex);
        return atlaskitportal;
    }
};
var $df54db561ca68475$export$95029ca7aca2989e = function createPortalParent() {
    //atlaskit-portal-container div
    if ($df54db561ca68475$var$isDocumentDefined()) {
        var parentElement = document.querySelector((0, $2DiSv.portalParentSelector));
        if (!parentElement) {
            var _getBody2;
            var parent = document.createElement("div");
            parent.className = (0, $2DiSv.portalParentClassName);
            parent.style.display = "flex";
            (_getBody2 = $df54db561ca68475$var$getBody()) === null || _getBody2 === void 0 || _getBody2.appendChild(parent);
            return parent;
        }
        return parentElement;
    }
};

});
parcelRegister("2DiSv", function(module, exports) {

$parcel$export(module.exports, "portalParentClassName", function () { return $1eadde16bfd75246$export$e4c79eb95c23a0da; });
$parcel$export(module.exports, "portalParentSelector", function () { return $1eadde16bfd75246$export$72f415121273627e; });
$parcel$export(module.exports, "portalClassName", function () { return $1eadde16bfd75246$export$13f57c02915787b3; });
var $1eadde16bfd75246$export$e4c79eb95c23a0da = "atlaskit-portal-container";
var $1eadde16bfd75246$export$72f415121273627e = "body > .atlaskit-portal-container";
var $1eadde16bfd75246$export$13f57c02915787b3 = "atlaskit-portal";

});



parcelRegister("14HMF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0c8820be6d879734$export$2e2bcd8739ae039; });

var $kC8H4 = parcelRequire("kC8H4");

var $dAx5m = parcelRequire("dAx5m");

var $1MpXQ = parcelRequire("1MpXQ");

var $1k2zg = parcelRequire("1k2zg");

var $jaMRM = parcelRequire("jaMRM");
function $0c8820be6d879734$export$2e2bcd8739ae039(props) {
    var zIndex = props.zIndex, children = props.children;
    var _useState = (0, $dAx5m.useState)(null), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($kC8H4)))(_useState, 2), atlaskitPortal = _useState2[0], setAtlaskitPortal = _useState2[1];
    (0, $1k2zg.useIsomorphicLayoutEffect)(function() {
        var tempPortalContainer = (0, $jaMRM.createAtlaskitPortal)(zIndex);
        setAtlaskitPortal(tempPortalContainer);
        var portalParent = (0, $jaMRM.createPortalParent)();
        if (!tempPortalContainer || !portalParent) return;
        portalParent.appendChild(tempPortalContainer);
        return function() {
            if (tempPortalContainer) portalParent.removeChild(tempPortalContainer);
            setAtlaskitPortal(null);
        };
    }, [
        zIndex
    ]);
    /**
   * We wrap portal children with a Suspense boundary because in React 18 concurrent,
   * if you suspend from _within_ a portal to a Suspense boundary _outside_ the portal,
   * our portal gets in an infinite loop of rendering.
   */ var suspendedChildren = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $dAx5m.Suspense), {
        fallback: null
    }, children);
    return atlaskitPortal ? /*#__PURE__*/ (0, $1MpXQ.createPortal)(suspendedChildren, atlaskitPortal) : null;
}

});
parcelRegister("kC8H4", function(module, exports) {

var $6RPPe = parcelRequire("6RPPe");

var $eVgp2 = parcelRequire("eVgp2");

var $lM5y5 = parcelRequire("lM5y5");

var $1Vt1c = parcelRequire("1Vt1c");
function $f01e19a4da85cf68$var$_slicedToArray(r, e) {
    return $6RPPe(r) || $eVgp2(r, e) || $lM5y5(r, e) || $1Vt1c();
}
module.exports = $f01e19a4da85cf68$var$_slicedToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("6RPPe", function(module, exports) {
function $4fffe4bccf0b7040$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
module.exports = $4fffe4bccf0b7040$var$_arrayWithHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("eVgp2", function(module, exports) {
function $add31cccd911cd59$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
module.exports = $add31cccd911cd59$var$_iterableToArrayLimit, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("1Vt1c", function(module, exports) {
function $16719fbbee1189fb$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
module.exports = $16719fbbee1189fb$var$_nonIterableRest, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("1k2zg", function(module, exports) {

$parcel$export(module.exports, "useIsomorphicLayoutEffect", function () { return $0f69a69de3de867f$export$700979bc83e7db82; });

var $dAx5m = parcelRequire("dAx5m");
var $0f69a69de3de867f$export$700979bc83e7db82 = typeof window !== "undefined" ? (0, $dAx5m.useLayoutEffect) : (0, $dAx5m.useEffect);

});


parcelRegister("44qD7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2f6c314a6e3d1632$export$2e2bcd8739ae039; });

var $kC8H4 = parcelRequire("kC8H4");

var $dAx5m = parcelRequire("dAx5m");

var $1k2zg = parcelRequire("1k2zg");
var $2f6c314a6e3d1632$var$useIsSubsequentRender = function useIsSubsequentRender(mountStrategy) {
    var _useState = (0, $dAx5m.useState)(false), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($kC8H4)))(_useState, 2), isSubsequentRender = _useState2[0], setIsSubsequentRender = _useState2[1];
    var _useState3 = (0, $dAx5m.useState)(function() {
        return mountStrategy === "layoutEffect" ? (0, $1k2zg.useIsomorphicLayoutEffect) : (0, $dAx5m.useEffect);
    }), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($kC8H4)))(_useState3, 1), useMountEffect = _useState4[0];
    useMountEffect(function() {
        setIsSubsequentRender(true);
    }, []);
    return isSubsequentRender;
};
var $2f6c314a6e3d1632$export$2e2bcd8739ae039 = $2f6c314a6e3d1632$var$useIsSubsequentRender;

});

parcelRegister("bm5Mx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $84463bf3a6cb2aac$export$2e2bcd8739ae039; });

var $dAx5m = parcelRequire("dAx5m");

var $51H40 = parcelRequire("51H40");

var $9A9EB = parcelRequire("9A9EB");
var $84463bf3a6cb2aac$var$useFirePortalEvent = function useFirePortalEvent(zIndex) {
    var zIndexNumber = Number(zIndex);
    (0, $dAx5m.useEffect)(function() {
        (0, $9A9EB.default)((0, $51H40.PORTAL_MOUNT_EVENT), zIndexNumber);
        return function() {
            (0, $9A9EB.default)((0, $51H40.PORTAL_UNMOUNT_EVENT), zIndexNumber);
        };
    }, [
        zIndexNumber
    ]);
};
var $84463bf3a6cb2aac$export$2e2bcd8739ae039 = $84463bf3a6cb2aac$var$useFirePortalEvent;

});
parcelRegister("51H40", function(module, exports) {

$parcel$export(module.exports, "PORTAL_MOUNT_EVENT", function () { return $3a8e734b183fe2a5$export$ed5835cc67e87f72; });
$parcel$export(module.exports, "PORTAL_UNMOUNT_EVENT", function () { return $3a8e734b183fe2a5$export$80816bd900e5bd00; });
var $3a8e734b183fe2a5$export$ed5835cc67e87f72 = "akPortalMount";
var $3a8e734b183fe2a5$export$80816bd900e5bd00 = "akPortalUnmount";

});

parcelRegister("9A9EB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6f9ef6ea1d522075$export$2e2bcd8739ae039; });
var $6f9ef6ea1d522075$var$zIndexToName = {
    100: "card",
    200: "navigation",
    300: "dialog",
    400: "layer",
    500: "blanket",
    510: "modal",
    600: "flag",
    700: "spotlight",
    9999: "tooltip"
};
/**
 * return layer name in Atlassian design system corresponding to given z-index
 * @param {number} zIndex - z-index value for which layer name is needed
 * @returns {LayerName | null} - The layer name for given z-index. If layer name is not found then null is returned
 */ var $6f9ef6ea1d522075$var$getLayerName = function getLayerName(zIndex) {
    return $6f9ef6ea1d522075$var$zIndexToName.hasOwnProperty(zIndex) ? $6f9ef6ea1d522075$var$zIndexToName[zIndex] : null;
};
/**
 * Creates a PortalEvent object with given eventName, given zIndex and corresponding layer
 * @param {string} eventName - either of Mount or Unmount event name
 * @param {number} zIndex - z-index value which will be included in the event to be dispatched
 * @returns {PortalEvent} - The newly created PortalEvent object
 */ var $6f9ef6ea1d522075$var$getEvent = function getEvent(eventName, zIndex) {
    var detail = {
        layer: $6f9ef6ea1d522075$var$getLayerName(Number(zIndex)),
        zIndex: zIndex
    };
    return new CustomEvent(eventName, {
        detail: detail
    });
};
function $6f9ef6ea1d522075$export$2e2bcd8739ae039(eventName, zIndex) {
    var event = $6f9ef6ea1d522075$var$getEvent(eventName, zIndex);
    window.dispatchEvent(event);
}

});



parcelRegister("hpTSI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cae01e5dbc779080$export$2e2bcd8739ae039; });
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ parcelRequire("dAx5m");

var $jVTBW = parcelRequire("jVTBW");

var $fVL0I = parcelRequire("fVL0I");

var $ggwTM = parcelRequire("ggwTM");
var $62E0k = parcelRequire("62E0k");
var $cae01e5dbc779080$var$blanketStyles = (0, $jVTBW.css)({
    position: "relative"
});
/**
 * A wrapper around `@atlaskit/blanket` that adds a fade in/out transition.
 */ var $cae01e5dbc779080$var$Blanket = function Blanket(_ref) {
    var isOpen = _ref.isOpen, onBlanketClicked = _ref.onBlanketClicked, testId = _ref.testId;
    return (0, $jVTBW.jsx)((0, $ggwTM.default), {
        appear: true
    }, isOpen && (0, $jVTBW.jsx)((0, $62E0k.default), {
        duration: "large",
        animationTimingFunction: "ease-out"
    }, function(_ref2) {
        var className = _ref2.className;
        return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        (0, $jVTBW.jsx)("div", {
            css: $cae01e5dbc779080$var$blanketStyles,
            className: className
        }, (0, $jVTBW.jsx)((0, $fVL0I.default), {
            isTinted: true,
            onBlanketClicked: onBlanketClicked,
            testId: testId && testId
        })));
    }));
};
var $cae01e5dbc779080$export$2e2bcd8739ae039 = $cae01e5dbc779080$var$Blanket;

});
parcelRegister("fVL0I", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b990a5306b94ae00$export$2e2bcd8739ae039; });
/* blanket.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $c6l2j = parcelRequire("c6l2j");

var $dAx5m = parcelRequire("dAx5m");

var $aF9LR = parcelRequire("aF9LR");
var $02hNl = parcelRequire("02hNl");

var $gVLVb = parcelRequire("gVLVb");

var $bJzW6 = parcelRequire("bJzW6");

var $1zU5H = parcelRequire("1zU5H");

function $b990a5306b94ae00$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $b990a5306b94ae00$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $b990a5306b94ae00$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($c6l2j)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $b990a5306b94ae00$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $b990a5306b94ae00$var$packageName = "@atlaskit/blanket";
var $b990a5306b94ae00$var$packageVersion = "15.0.1";
var $b990a5306b94ae00$var$analyticsAttributes = {
    componentName: "blanket",
    packageName: $b990a5306b94ae00$var$packageName,
    packageVersion: $b990a5306b94ae00$var$packageVersion
};
var $b990a5306b94ae00$var$baseStyles = null;
var $b990a5306b94ae00$var$shouldAllowClickThroughStyles = null;
var $b990a5306b94ae00$var$invisibleStyles = null;
/**
 * __Blanket__
 *
 * A Blanket provides the overlay layer for components such as a modal dialog or a tooltip
 *
 * - [Examples](https://atlaskit.atlassian.com/examples/design-system/blanket/basic-usage)
 */ var $b990a5306b94ae00$var$Blanket = /*#__PURE__*/ (0, $dAx5m.memo)(/*#__PURE__*/ (0, $dAx5m.forwardRef)(function Blanket(_ref, ref) {
    var _ref$shouldAllowClick = _ref.shouldAllowClickThrough, shouldAllowClickThrough = _ref$shouldAllowClick === void 0 ? false : _ref$shouldAllowClick, _ref$isTinted = _ref.isTinted, isTinted = _ref$isTinted === void 0 ? false : _ref$isTinted, _ref$onBlanketClicked = _ref.onBlanketClicked, onBlanketClicked = _ref$onBlanketClicked === void 0 ? (0, $bJzW6.default) : _ref$onBlanketClicked, testId = _ref.testId, children = _ref.children, analyticsContext = _ref.analyticsContext;
    var mouseDownTarget = (0, $dAx5m.useRef)(null);
    var onBlanketClickedWithAnalytics = (0, $gVLVb.usePlatformLeafEventHandler)($b990a5306b94ae00$var$_objectSpread({
        fn: onBlanketClicked,
        action: "clicked",
        analyticsData: analyticsContext
    }, $b990a5306b94ae00$var$analyticsAttributes));
    var blanketClickOutsideChildren = (0, $dAx5m.useCallback)(function(e) {
        return e.currentTarget === e.target && mouseDownTarget.current === e.target ? onBlanketClickedWithAnalytics(e) : undefined;
    }, [
        onBlanketClickedWithAnalytics
    ]);
    var onClick = shouldAllowClickThrough ? undefined : blanketClickOutsideChildren;
    var onMouseDown = (0, $dAx5m.useCallback)(function(e) {
        mouseDownTarget.current = e.target;
    }, []);
    return /*#__PURE__*/ $dAx5m.createElement("div", {
        role: "presentation",
        onClick: onClick,
        onMouseDown: onMouseDown,
        "data-testid": testId,
        ref: ref,
        className: (0, $aF9LR.default)([
            "_1r04idpf _kqsw1n9t _1pbybfng _bfhk705f _18m91wug _lcxv1wug",
            shouldAllowClickThrough && "_lcxvglyw",
            !isTinted && "_bfhk1j28"
        ]),
        style: {
            "--_10avjlk": (0, $02hNl.default)("var(--ds-blanket, ".concat((0, $1zU5H.N100A), ")"))
        }
    }, children);
}));
$b990a5306b94ae00$var$Blanket.displayName = "Blanket";
var $b990a5306b94ae00$export$2e2bcd8739ae039 = $b990a5306b94ae00$var$Blanket;

});
parcelRegister("aF9LR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7c355001c894b108$export$2e2bcd8739ae039; });
const $7c355001c894b108$var$UNDERSCORE_UNICODE = 95;
/**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $7c355001c894b108$var$ATOMIC_GROUP_LENGTH = 5;
function $7c355001c894b108$export$2e2bcd8739ae039(classNames) {
    if (classNames.length <= 1 && (!classNames[0] || classNames[0].indexOf(" ") === -1)) // short circuit if there's no custom class names.
    return classNames[0] || undefined;
    const atomicGroups = {};
    for(let i = 0; i < classNames.length; i++){
        const cls = classNames[i];
        if (!cls) continue;
        const groups = cls.split(" ");
        for(let x = 0; x < groups.length; x++){
            const atomic = groups[x];
            const atomicGroupName = atomic.slice(0, atomic.charCodeAt(0) === $7c355001c894b108$var$UNDERSCORE_UNICODE ? $7c355001c894b108$var$ATOMIC_GROUP_LENGTH : undefined);
            atomicGroups[atomicGroupName] = atomic;
        }
    }
    let str = "";
    for(const key in atomicGroups){
        const value = atomicGroups[key];
        str += value + " ";
    }
    return str.slice(0, -1);
}

});

parcelRegister("02hNl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $006dfdb569674a35$export$2e2bcd8739ae039; });
/**
 * Returns a CSS custom property value with an optional suffix & prefix.
 * Prefix will only be added if there is a suffix.
 * If the value is undefined a fallback value will be returned to prevent children inheriting parent values.
 *
 * @param value
 * @param suffix
 * @param prefix
 */ function $006dfdb569674a35$export$2e2bcd8739ae039(value, suffix, prefix) {
    if (value != undefined) {
        if (suffix) {
            if (prefix) return prefix + value + suffix;
            return value + suffix;
        }
        return value;
    }
    // Currently React trims these values so we can't use a space " " to block the value.
    // Instead we use a CSS variable that doesn't exist which falls back to " ".
    // Bug raised here: https://github.com/facebook/react/issues/20497
    return "var(--c-, )";
}

});

parcelRegister("1zU5H", function(module, exports) {

$parcel$export(module.exports, "R500", function () { return $126491cd9b6a06e1$export$2837b5a1a71d5c02; });
$parcel$export(module.exports, "Y400", function () { return $126491cd9b6a06e1$export$59619663aa6500fb; });
$parcel$export(module.exports, "B75", function () { return $126491cd9b6a06e1$export$8c13c2ee36917869; });
$parcel$export(module.exports, "B200", function () { return $126491cd9b6a06e1$export$215b7063051591f1; });
$parcel$export(module.exports, "B400", function () { return $126491cd9b6a06e1$export$b3de0ae08da2ce64; });
$parcel$export(module.exports, "N0", function () { return $126491cd9b6a06e1$export$29a4f05edc054374; });
$parcel$export(module.exports, "N20", function () { return $126491cd9b6a06e1$export$9fdfb749e33cdf97; });
$parcel$export(module.exports, "N500", function () { return $126491cd9b6a06e1$export$c39c0fe0f26207ae; });
$parcel$export(module.exports, "N700", function () { return $126491cd9b6a06e1$export$ad0bacf983b7ddaa; });
$parcel$export(module.exports, "N800", function () { return $126491cd9b6a06e1$export$7d61b15e0da132af; });
$parcel$export(module.exports, "N20A", function () { return $126491cd9b6a06e1$export$8d43898f60b96a82; });
$parcel$export(module.exports, "N30A", function () { return $126491cd9b6a06e1$export$920c0d5c49070351; });
$parcel$export(module.exports, "N100A", function () { return $126491cd9b6a06e1$export$486ab785e4bac3c6; });
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // Reds
var $126491cd9b6a06e1$export$4b84fd0e2c617bd = "#FFEBE6";
var $126491cd9b6a06e1$export$b34b069eff244586 = "#FFBDAD";
var $126491cd9b6a06e1$export$be802dd0d8b57f35 = "#FF8F73";
var $126491cd9b6a06e1$export$60847d42f9da92a6 = "#FF7452";
var $126491cd9b6a06e1$export$4a7404f376229999 = "#FF5630";
var $126491cd9b6a06e1$export$2010d0fb4295b346 = "#DE350B";
var $126491cd9b6a06e1$export$2837b5a1a71d5c02 = "#BF2600";
var $126491cd9b6a06e1$export$8d9596b529bbb9cf = "#FFFAE6";
var $126491cd9b6a06e1$export$41060a744ab0b7ae = "#FFF0B3";
var $126491cd9b6a06e1$export$1cc05bbbf340e559 = "#FFE380";
var $126491cd9b6a06e1$export$5aae31392d72caaa = "#FFC400";
var $126491cd9b6a06e1$export$c6930421db9fa514 = "#FFAB00";
var $126491cd9b6a06e1$export$59619663aa6500fb = "#FF991F";
var $126491cd9b6a06e1$export$874739ea9e379ab6 = "#FF8B00";
var $126491cd9b6a06e1$export$8a6341c32b6a3ee6 = "#E3FCEF";
var $126491cd9b6a06e1$export$69a3bf21b9686c2b = "#ABF5D1";
var $126491cd9b6a06e1$export$afbce1382ec95f73 = "#79F2C0";
var $126491cd9b6a06e1$export$747d86715d4175de = "#57D9A3";
var $126491cd9b6a06e1$export$940e1f69e873f202 = "#36B37E";
var $126491cd9b6a06e1$export$a49394138f7b8e85 = "#00875A";
var $126491cd9b6a06e1$export$6fa04827ac68a4fb = "#006644";
var $126491cd9b6a06e1$export$226de0355ed012f8 = "#DEEBFF";
var $126491cd9b6a06e1$export$8c13c2ee36917869 = "#B3D4FF";
var $126491cd9b6a06e1$export$ecfc1dff386a3e7a = "#4C9AFF";
var $126491cd9b6a06e1$export$215b7063051591f1 = "#2684FF";
var $126491cd9b6a06e1$export$e62e8919cca44969 = "#0065FF";
var $126491cd9b6a06e1$export$b3de0ae08da2ce64 = "#0052CC";
var $126491cd9b6a06e1$export$a6ee3d71bc067634 = "#0747A6";
var $126491cd9b6a06e1$export$67f15409e87642a1 = "#669DF1";
var $126491cd9b6a06e1$export$f0539dbc42dbb067 = "#8FB8F6";
var $126491cd9b6a06e1$export$363e4475840015bb = "#EAE6FF";
var $126491cd9b6a06e1$export$4b0a4417ed59760f = "#C0B6F2";
var $126491cd9b6a06e1$export$6011520a64d9a187 = "#998DD9";
var $126491cd9b6a06e1$export$a7175d4e9206bc80 = "#8777D9";
var $126491cd9b6a06e1$export$b48405b95304b5a1 = "#6554C0";
var $126491cd9b6a06e1$export$c71e4279dd54a18d = "#5243AA";
var $126491cd9b6a06e1$export$147899de772240ec = "#403294";
var $126491cd9b6a06e1$export$2cf711fe14c66f06 = "#E6FCFF";
var $126491cd9b6a06e1$export$7a8f4d33f6f9772c = "#B3F5FF";
var $126491cd9b6a06e1$export$776c9c497ef08533 = "#79E2F2";
var $126491cd9b6a06e1$export$69cb3ca10c1e330e = "#00C7E6";
var $126491cd9b6a06e1$export$9dc1ef0f3f48059b = "#00B8D9";
var $126491cd9b6a06e1$export$7c835c78b6fcdef8 = "#00A3BF";
var $126491cd9b6a06e1$export$6036577f95c3877e = "#008DA6";
var $126491cd9b6a06e1$export$29a4f05edc054374 = "#FFFFFF";
var $126491cd9b6a06e1$export$e655ef011c4aa1a2 = "#FAFBFC";
var $126491cd9b6a06e1$export$9fdfb749e33cdf97 = "#F4F5F7";
var $126491cd9b6a06e1$export$3e51e8f1440314ba = "#EBECF0";
var $126491cd9b6a06e1$export$1ce2d1575d444ceb = "#DFE1E6";
var $126491cd9b6a06e1$export$8754fc7e6d8b3000 = "#C1C7D0";
var $126491cd9b6a06e1$export$c2e91cbeada39b8b = "#B3BAC5";
var $126491cd9b6a06e1$export$5f71e19f3a7ad9de = "#A5ADBA";
var $126491cd9b6a06e1$export$eaa8c8a70ac22806 = "#97A0AF";
var $126491cd9b6a06e1$export$7c87d337fb91a97d = "#8993A4";
var $126491cd9b6a06e1$export$d6447c357493214f = "#7A869A";
var $126491cd9b6a06e1$export$f563ee71e9ee74cd = "#6B778C";
var $126491cd9b6a06e1$export$e2ef2124cf4024b1 = "#5E6C84";
var $126491cd9b6a06e1$export$eece5f492e429f08 = "#505F79";
var $126491cd9b6a06e1$export$c39c0fe0f26207ae = "#42526E";
var $126491cd9b6a06e1$export$7090862dc3038a9f = "#344563";
var $126491cd9b6a06e1$export$ad0bacf983b7ddaa = "#253858";
var $126491cd9b6a06e1$export$7d61b15e0da132af = "#172B4D";
var $126491cd9b6a06e1$export$fbda843f0a27fe96 = "#091E42";
var $126491cd9b6a06e1$export$791e57b27ca738ef = "rgba(9, 30, 66, 0.02)";
var $126491cd9b6a06e1$export$8d43898f60b96a82 = "rgba(9, 30, 66, 0.04)";
var $126491cd9b6a06e1$export$920c0d5c49070351 = "rgba(9, 30, 66, 0.08)";
var $126491cd9b6a06e1$export$46987b49aab6d1a8 = "rgba(9, 30, 66, 0.13)";
var $126491cd9b6a06e1$export$7d3359664e8bb0e5 = "rgba(9, 30, 66, 0.25)";
var $126491cd9b6a06e1$export$d2d3bedfb276cac0 = "rgba(9, 30, 66, 0.31)";
var $126491cd9b6a06e1$export$6e5e7499ff054f6d = "rgba(9, 30, 66, 0.36)";
var $126491cd9b6a06e1$export$59264b346c877fa7 = "rgba(9, 30, 66, 0.42)";
var $126491cd9b6a06e1$export$d092757d7c64925c = "rgba(9, 30, 66, 0.48)";
var $126491cd9b6a06e1$export$486ab785e4bac3c6 = "rgba(9, 30, 66, 0.54)";
var $126491cd9b6a06e1$export$fba592bbc6419fea = "rgba(9, 30, 66, 0.60)";
var $126491cd9b6a06e1$export$13609db0e6812ab8 = "rgba(9, 30, 66, 0.66)";
var $126491cd9b6a06e1$export$fbae4efaa892d883 = "rgba(9, 30, 66, 0.71)";
var $126491cd9b6a06e1$export$f13946d26f440ce6 = "rgba(9, 30, 66, 0.77)";
var $126491cd9b6a06e1$export$19f58225ac52a306 = "rgba(9, 30, 66, 0.82)";
var $126491cd9b6a06e1$export$6384f09da70e7b62 = "rgba(9, 30, 66, 0.89)";
var $126491cd9b6a06e1$export$d0dccc730683edc2 = "rgba(9, 30, 66, 0.95)";
var $126491cd9b6a06e1$export$2f6319cf7d736c2a = "#E6EDFA";
var $126491cd9b6a06e1$export$95126bc8884d6634 = "#DCE5F5";
var $126491cd9b6a06e1$export$8338d8c35d44ff1 = "#CED9EB";
var $126491cd9b6a06e1$export$5368d76ae4fbbda7 = "#B8C7E0";
var $126491cd9b6a06e1$export$9f0a771d16ec8d36 = "#ABBBD6";
var $126491cd9b6a06e1$export$abcf8c38338b4aa5 = "#9FB0CC";
var $126491cd9b6a06e1$export$97e81faa16a182c7 = "#8C9CB8";
var $126491cd9b6a06e1$export$bfe21c59123ecf33 = "#7988A3";
var $126491cd9b6a06e1$export$ee82aa2ea6a1558 = "#67758F";
var $126491cd9b6a06e1$export$682927c6ed76be02 = "#56637A";
var $126491cd9b6a06e1$export$91fd9994c5be9757 = "#455166";
var $126491cd9b6a06e1$export$d281fbfe3cff2df6 = "#3B475C";
var $126491cd9b6a06e1$export$3902c91d8b98a753 = "#313D52";
var $126491cd9b6a06e1$export$8e8133c1ba5845b5 = "#283447";
var $126491cd9b6a06e1$export$33ff357f6620b39 = "#202B3D";
var $126491cd9b6a06e1$export$633847cf062b69e0 = "#1B2638";
var $126491cd9b6a06e1$export$9776a6e503bdbf76 = "#121A29";
var $126491cd9b6a06e1$export$6c813d5160dff5db = "#0E1624";
var $126491cd9b6a06e1$export$3d4f271a500072a = "#0D1424";
var $126491cd9b6a06e1$export$fe151285c22759ec = "rgba(13, 20, 36, 0.06)";
var $126491cd9b6a06e1$export$a101c6190d0da34 = "rgba(13, 20, 36, 0.14)";
var $126491cd9b6a06e1$export$4b16f52932fda51 = "rgba(13, 20, 36, 0.18)";
var $126491cd9b6a06e1$export$a74bcd7b9845b0d8 = "rgba(13, 20, 36, 0.29)";
var $126491cd9b6a06e1$export$9209c179316d1751 = "rgba(13, 20, 36, 0.36)";
var $126491cd9b6a06e1$export$88f55133f636c8dd = "rgba(13, 20, 36, 0.40)";
var $126491cd9b6a06e1$export$51126f85d1009512 = "rgba(13, 20, 36, 0.47)";
var $126491cd9b6a06e1$export$a069b547bd23af78 = "rgba(13, 20, 36, 0.53)";
var $126491cd9b6a06e1$export$40cce05af3b2600a = "rgba(13, 20, 36, 0.63)";
var $126491cd9b6a06e1$export$b78942185925a0d = "rgba(13, 20, 36, 0.73)";
var $126491cd9b6a06e1$export$e058fb44b8eaafca = "rgba(13, 20, 36, 0.78)";
var $126491cd9b6a06e1$export$92b0b8de26920c18 = "rgba(13, 20, 36, 0.81)";
var $126491cd9b6a06e1$export$67564f7459d3fc9e = "rgba(13, 20, 36, 0.85)";
var $126491cd9b6a06e1$export$77868e1ca884ffa3 = "rgba(13, 20, 36, 0.89)";
var $126491cd9b6a06e1$export$2afd71d7d3ea2cd5 = "rgba(13, 20, 36, 0.92)";
var $126491cd9b6a06e1$export$f2a0acaab9972c70 = "rgba(13, 20, 36, 0.95)";
var $126491cd9b6a06e1$export$9ab70e67d6475361 = "rgba(13, 20, 36, 0.97)";
var $126491cd9b6a06e1$export$d2adc5dedf09fced = "#292A2E";
var $126491cd9b6a06e1$export$f51762073d2bb381 = "#94C748";
var $126491cd9b6a06e1$export$95e26d54def96891 = "#B3DF72";

});


parcelRegister("ggwTM", function(module, exports) {

$parcel$export(module.exports, "useExitingPersistence", function () { return $bd77a8f241eed2ea$export$3b6f38abbdcbd000; });
$parcel$export(module.exports, "default", function () { return $bd77a8f241eed2ea$export$2e2bcd8739ae039; });

var $kC8H4 = parcelRequire("kC8H4");

var $dAx5m = parcelRequire("dAx5m");

var $18rB9 = parcelRequire("18rB9");

var $jcIPJ = parcelRequire("jcIPJ");
/**
 * Internally we will be playing with an element that will always have a key defined.
 */ /**
 * Internal data passed to child motions.
 */ // We define empty context here so the object doesn't change.
var $bd77a8f241eed2ea$var$emptyContext = {
    // Motions will always appear if not inside a exiting persistence component.
    appear: true,
    isExiting: false
};
/**
 * __Exiting context__
 *
 * An exiting context.
 */ var $bd77a8f241eed2ea$var$ExitingContext = /*#__PURE__*/ (0, $dAx5m.createContext)($bd77a8f241eed2ea$var$emptyContext);
/**
 * This method will wrap any React element with a context provider. We're using context (instead of
 * cloneElement) so we can communicate between multiple elements without the need of prop drilling
 * (results in a better API for consumers).
 */ var $bd77a8f241eed2ea$var$wrapChildWithContextProvider = function wrapChildWithContextProvider(child) {
    var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $bd77a8f241eed2ea$var$emptyContext;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement($bd77a8f241eed2ea$var$ExitingContext.Provider, {
        key: "".concat(child.key, "-provider"),
        value: value
    }, child);
};
/**
 * This function will convert all children types to an array while also filtering out non-valid React elements.
 */ var $bd77a8f241eed2ea$var$childrenToArray = function childrenToArray(children) {
    var childrenAsArray = [];
    // We convert children to an array using this helper method as it will add keys to children that do not
    // have them, such as when we have hardcoded children that are conditionally rendered.
    (0, $dAx5m.Children).toArray(children).forEach(function(child) {
        // We ignore any boolean children to make our code a little more simple later on,
        // and also filter out any falsies (empty strings, nulls, and undefined).
        if (typeof child !== "boolean" && Boolean(child)) // Children WILL have a key after being forced into an array using the React.Children helper.
        childrenAsArray.push(child);
    });
    return childrenAsArray;
};
var $bd77a8f241eed2ea$var$spliceNewElementsIntoPrevious = function spliceNewElementsIntoPrevious(current, previous) {
    var splicedChildren = previous.concat([]);
    var previousMap = $bd77a8f241eed2ea$var$childrenToObj(previous);
    for(var i = 0; i < current.length; i++){
        var child = current[i];
        var childIsNew = !previousMap[child.key];
        if (childIsNew) // This will insert the new element after the previous element.
        splicedChildren.splice(i + 1, 0, child);
    }
    return splicedChildren;
};
var $bd77a8f241eed2ea$var$childrenToObj = function childrenToObj(children) {
    return children.reduce(function(acc, child) {
        acc[child.key] = child;
        return acc;
    }, {});
};
var $bd77a8f241eed2ea$var$getMissingKeys = function getMissingKeys(current, previous) {
    var currentMapKeys = new Set(current.map(function(child) {
        return child.key;
    }));
    var missing = new Set();
    for(var i = 0; i < previous.length; i++){
        var element = previous[i];
        var _key = element.key;
        if (!currentMapKeys.has(_key)) missing.add(_key);
    }
    return missing;
};
/**
 * How does this component work?
 *
 * It looks at changes in its children to see what is removed.
 *
 * If a child is removed it clones it and wraps it with context providing an `onFinish` callback.
 *
 * The cloned child will call the `onFinish` when it finishes its exit animation,
 * which lets `ExitingPersistence` know to stop rendering it.
 */ /**
 * __ExitingPersistence__
 *
 * Useful for enabling elements to persist and animate away when they are removed from the DOM.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motions)
 */ var $bd77a8f241eed2ea$var$ExitingPersistence = /*#__PURE__*/ (0, $dAx5m.memo)(function(_ref) {
    var _ref$appear = _ref.appear, appear = _ref$appear === void 0 ? false : _ref$appear, children = _ref.children, exitThenEnter = _ref.exitThenEnter;
    var _useState = (0, $dAx5m.useState)([
        null,
        children
    ]), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($kC8H4)))(_useState, 2), stateChildren = _useState2[0], setChildren = _useState2[1];
    var _useState3 = (0, $dAx5m.useState)([]), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($kC8H4)))(_useState3, 2), exitingChildren = _useState4[0], setExitingChildren = _useState4[1];
    var _useState5 = (0, $dAx5m.useState)(function() {
        return {
            appear: appear,
            isExiting: false
        };
    }), _useState6 = (0, (/*@__PURE__*/$parcel$interopDefault($kC8H4)))(_useState5, 2), defaultContext = _useState6[0], setDefaultContext = _useState6[1];
    (0, $dAx5m.useEffect)(function() {
        if (!defaultContext.appear) setDefaultContext({
            appear: true,
            isExiting: false
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    if ((0, $jcIPJ.isReducedMotion)() && !(0, $18rB9.fg)("platform_design_system_motion_on_finish_fix")) /**
     * We still want to use the `ExitingPersistence` with reduced motion,
     * otherwise the exiting `onFinish` is not called.
     */ return children;
    /**
   * NOTE: This is a workaround for the test case written in Jira where the stateChildren is a boolean value because
   * useState is mocked to return a boolean value.
   */ if (typeof stateChildren === "boolean") return children;
    var _stateChildren = (0, (/*@__PURE__*/$parcel$interopDefault($kC8H4)))(stateChildren, 2), previousChildren = _stateChildren[0], currentChildren = _stateChildren[1];
    var previous = $bd77a8f241eed2ea$var$childrenToArray(previousChildren);
    var current = $bd77a8f241eed2ea$var$childrenToArray(currentChildren);
    if (currentChildren !== children) setChildren([
        currentChildren,
        children
    ]);
    var missingKeys = $bd77a8f241eed2ea$var$getMissingKeys(current, previous);
    var isSomeChildRemoved = !!missingKeys.size;
    var visibleChildren = current;
    if (isSomeChildRemoved) visibleChildren = $bd77a8f241eed2ea$var$spliceNewElementsIntoPrevious(current, previous);
    if (exitThenEnter) {
        if (exitingChildren.length) visibleChildren = exitingChildren;
        else {
            var nextExitingChildren = visibleChildren.filter(function(child) {
                return missingKeys.has(child.key);
            });
            if (nextExitingChildren.length) setExitingChildren(nextExitingChildren);
        }
    }
    if (missingKeys.size) visibleChildren = visibleChildren.map(function(child) {
        var isExiting = missingKeys.has(child.key);
        return $bd77a8f241eed2ea$var$wrapChildWithContextProvider(child, {
            appear: true,
            isExiting: isExiting,
            onFinish: isExiting ? function() {
                missingKeys.delete(child.key);
                if (missingKeys.size === 0) {
                    setChildren([
                        null,
                        children
                    ]);
                    setExitingChildren([]);
                }
            } : undefined
        });
    });
    else visibleChildren = visibleChildren.map(function(child) {
        return $bd77a8f241eed2ea$var$wrapChildWithContextProvider(child, defaultContext);
    });
    return visibleChildren;
});
var $bd77a8f241eed2ea$export$3b6f38abbdcbd000 = function useExitingPersistence() {
    return (0, $dAx5m.useContext)($bd77a8f241eed2ea$var$ExitingContext);
};
$bd77a8f241eed2ea$var$ExitingPersistence.displayName = "ExitingPersistence";
var $bd77a8f241eed2ea$export$2e2bcd8739ae039 = $bd77a8f241eed2ea$var$ExitingPersistence;

});
parcelRegister("jcIPJ", function(module, exports) {

$parcel$export(module.exports, "isReducedMotion", function () { return $dfb1ea45fef04255$export$b7baf7667a68d87c; });

var $kC8H4 = parcelRequire("kC8H4");

var $dAx5m = parcelRequire("dAx5m");

var $dd4sf = parcelRequire("dd4sf");
var $dfb1ea45fef04255$var$isMatchMediaAvailable = function isMatchMediaAvailable() {
    return typeof window !== "undefined" && "matchMedia" in window;
};
var $dfb1ea45fef04255$export$b7baf7667a68d87c = function isReducedMotion() {
    if (!$dfb1ea45fef04255$var$isMatchMediaAvailable()) return false;
    var _window$matchMedia = window.matchMedia("(prefers-reduced-motion: reduce)"), matches = _window$matchMedia.matches;
    return matches;
};
var $dfb1ea45fef04255$export$c537e63161742ce3 = function useIsReducedMotion() {
    var _useState = (0, $dAx5m.useState)($dfb1ea45fef04255$export$b7baf7667a68d87c), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($kC8H4)))(_useState, 2), prefersReducedMotion = _useState2[0], setPrefersReducedMotion = _useState2[1];
    (0, $dAx5m.useEffect)(function() {
        if (!$dfb1ea45fef04255$var$isMatchMediaAvailable()) return;
        var mediaQueryList = window.matchMedia("(prefers-reduced-motion: reduce)");
        var onChange = function onChange(event) {
            return setPrefersReducedMotion(event.matches);
        };
        return (0, $dd4sf.bind)(mediaQueryList, {
            type: "change",
            listener: onChange
        });
    }, []);
    return prefersReducedMotion;
};
var $dfb1ea45fef04255$export$f0f789643ba5a83c = {
    "@media (prefers-reduced-motion: reduce)": {
        animation: "none",
        transition: "none"
    }
};
var $dfb1ea45fef04255$export$ff7706047246b98b = function prefersReducedMotion() {
    return $dfb1ea45fef04255$export$f0f789643ba5a83c;
};

});


parcelRegister("62E0k", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4661f6066506823c$export$2e2bcd8739ae039; });

var $dAx5m = parcelRequire("dAx5m");

var $1xZNb = parcelRequire("1xZNb");
var $4661f6066506823c$var$invertedDirection = {
    top: "bottom",
    bottom: "top",
    left: "right",
    right: "left"
};
/**
 * Props for controlling the behavior of the FadeIn animation
 */ /**
 * __FadeIn__
 *
 * Useful for fading in one or more elements.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motions)
 */ var $4661f6066506823c$var$FadeIn = function FadeIn(_ref) {
    var children = _ref.children, _ref$duration = _ref.duration, duration = _ref$duration === void 0 ? "large" : _ref$duration, entranceDirection = _ref.entranceDirection, exitDirection = _ref.exitDirection, _ref$distance = _ref.distance, distance = _ref$distance === void 0 ? "proportional" : _ref$distance, onFinish = _ref.onFinish, isPaused = _ref.isPaused;
    var invertedEntranceDirection = entranceDirection !== undefined ? $4661f6066506823c$var$invertedDirection[entranceDirection] : undefined;
    var isExitDirect = Boolean(exitDirection || invertedEntranceDirection) ? "fade-out-from-".concat(exitDirection || invertedEntranceDirection).concat(distance === "proportional" ? "" : "-constant") : "fade-out";
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $1xZNb.default), {
        duration: duration,
        enteringAnimation: entranceDirection ? "fade-in-from-".concat(entranceDirection).concat(distance === "proportional" ? "" : "-constant") : "fade-in",
        exitingAnimation: isExitDirect,
        animationTimingFunction: "ease-in-out",
        onFinish: onFinish,
        isPaused: isPaused
    }, children);
};
var $4661f6066506823c$export$2e2bcd8739ae039 = $4661f6066506823c$var$FadeIn;

});
parcelRegister("1xZNb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1208ce27757afc9c$export$2e2bcd8739ae039; });
/* keyframes-motion.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $kC8H4 = parcelRequire("kC8H4");

var $dAx5m = parcelRequire("dAx5m");

var $aF9LR = parcelRequire("aF9LR");

var $18rB9 = parcelRequire("18rB9");

var $jcIPJ = parcelRequire("jcIPJ");

var $cLHRz = parcelRequire("cLHRz");

var $gGW01 = parcelRequire("gGW01");

var $ggwTM = parcelRequire("ggwTM");

var $8Mwhb = parcelRequire("8Mwhb");
var $1208ce27757afc9c$var$zoomIn = null;
var $1208ce27757afc9c$var$zoomOut = null;
var $1208ce27757afc9c$var$fadeIn = null;
var $1208ce27757afc9c$var$fadeOut = null;
var $1208ce27757afc9c$var$fadeInFromTop = null;
var $1208ce27757afc9c$var$fadeOutFromTop = null;
var $1208ce27757afc9c$var$fadeInFromLeft = null;
var $1208ce27757afc9c$var$fadeOutFromLeft = null;
var $1208ce27757afc9c$var$fadeInFromBottom = null;
var $1208ce27757afc9c$var$fadeOutFromBottom = null;
var $1208ce27757afc9c$var$fadeInFromRight = null;
var $1208ce27757afc9c$var$fadeOutFromRight = null;
var $1208ce27757afc9c$var$fadeInFromTopConstant = null;
var $1208ce27757afc9c$var$fadeOutFromTopConstant = null;
var $1208ce27757afc9c$var$fadeInFromLeftConstant = null;
var $1208ce27757afc9c$var$fadeOutFromLeftConstant = null;
var $1208ce27757afc9c$var$fadeInFromBottomConstant = null;
var $1208ce27757afc9c$var$fadeOutFromBottomConstant = null;
var $1208ce27757afc9c$var$fadeInFromRightConstant = null;
var $1208ce27757afc9c$var$fadeOutFromRightConstant = null;
var $1208ce27757afc9c$var$slideInFromTop = null;
var $1208ce27757afc9c$var$slideOutFromTop = null;
var $1208ce27757afc9c$var$slideInFromRight = null;
var $1208ce27757afc9c$var$slideOutFromRight = null;
var $1208ce27757afc9c$var$slideInFromBottom = null;
var $1208ce27757afc9c$var$slideOutFromBottom = null;
var $1208ce27757afc9c$var$slideInFromLeft = null;
var $1208ce27757afc9c$var$slideOutFromLeft = null;
/**
 * These are props that motions should use as their external props for consumers.
 * See [FadeIn](packages/helpers/motion/src/entering/fade-in.tsx) for an example usage.
 */ /**
 * This is the base INTERNAL component used for all other entering motions.
 * This does not need Javascript to execute on the client so it will run immediately
 * for any SSR rendered React apps before the JS has executed.
 */ var $1208ce27757afc9c$var$EnteringMotion = function EnteringMotion(_ref) {
    var children = _ref.children, animationTimingFunction = _ref.animationTimingFunction, _ref$animationTimingF = _ref.animationTimingFunctionExiting, animationTimingFunctionExiting = _ref$animationTimingF === void 0 ? animationTimingFunction : _ref$animationTimingF, enteringAnimation = _ref.enteringAnimation, _ref$exitingAnimation = _ref.exitingAnimation, exitingAnimation = _ref$exitingAnimation === void 0 ? enteringAnimation : _ref$exitingAnimation, isPaused = _ref.isPaused, onFinishMotion = _ref.onFinish, _ref$duration = _ref.duration, duration = _ref$duration === void 0 ? "large" : _ref$duration;
    var staggered = (0, $8Mwhb.useStaggeredEntrance)();
    var _useExitingPersistenc = (0, $ggwTM.useExitingPersistence)(), isExiting = _useExitingPersistenc.isExiting, onExitFinished = _useExitingPersistenc.onFinish, appear = _useExitingPersistenc.appear;
    var setTimeout = (0, $gGW01.useSetTimeout)();
    var paused = isPaused || !staggered.isReady;
    var delay = isExiting ? 0 : staggered.delay;
    var state = isExiting ? "exiting" : "entering";
    var _useState = (0, $dAx5m.useState)(appear), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($kC8H4)))(_useState, 2), hasAnimationStyles = _useState2[0], setHasAnimationStyles = _useState2[1];
    (0, $dAx5m.useEffect)(function() {
        // Tracking this to prevent changing state on an unmounted component
        var isCancelled = false;
        if (paused) return;
        // On initial mount if elements aren't set to animate on appear, we return early and callback
        if (!appear) {
            onFinishMotion && onFinishMotion(state);
            return;
        }
        /**
     * Updates relevant state.
     * Called when the animation is finished, or immediately with reduced motion.
     */ var onAnimationEnd = function onAnimationEnd() {
            if (state === "exiting") // Updates the `ExitingPersistence` to remove this child
            onExitFinished === null || onExitFinished === void 0 || onExitFinished();
            if (!isCancelled) setHasAnimationStyles(false);
            onFinishMotion === null || onFinishMotion === void 0 || onFinishMotion(state);
        };
        if ((0, $jcIPJ.isReducedMotion)() && (0, $18rB9.fg)("platform_design_system_motion_on_finish_fix")) {
            // If there is reduced motion there is no exit animation, so call this immediately
            onAnimationEnd();
            return;
        }
        // Elements may need animation styles back after initial mount (they could animate out)
        setHasAnimationStyles(true);
        // Queue `onAnimationEnd` for after the animation has finished
        setTimeout(onAnimationEnd, isExiting ? (0, $cLHRz.exitingDurations)[duration] : (0, $cLHRz.durations)[duration] + delay);
        return function() {
            isCancelled = true;
        };
    // We ignore this for onFinishMotion as consumers could potentially inline the function
    // which would then trigger this effect every re-render.
    // We want to make it easier for consumers so we go down this path unfortunately.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        onExitFinished,
        state,
        isExiting,
        duration,
        delay,
        paused,
        setTimeout
    ]);
    return children({
        ref: staggered.ref,
        // @ts-expect-error: `ax` is not typed correctly
        className: hasAnimationStyles ? (0, $aF9LR.default)([
            (0, $aF9LR.default)([
                "_1o51eoah _1y0co91m _1bumglyw _sedtglyw"
            ]),
            paused && (0, $aF9LR.default)([
                "_1y0ctrqk"
            ]),
            duration === "small" && (0, $aF9LR.default)([
                "_5sag1yx9"
            ]),
            duration === "medium" && (0, $aF9LR.default)([
                "_5sag1ttt"
            ]),
            duration === "large" && (0, $aF9LR.default)([
                "_5sagpwmj"
            ]),
            isExiting && duration === "small" && (0, $aF9LR.default)([
                "_5sag14ed"
            ]),
            isExiting && duration === "medium" && (0, $aF9LR.default)([
                "_5sagluct"
            ]),
            isExiting && duration === "large" && (0, $aF9LR.default)([
                "_5sag1ttt"
            ]),
            isExiting && (0, $aF9LR.default)([
                "_ju255cps _1o51q7pw"
            ]),
            !isExiting && animationTimingFunction === "linear" && (0, $aF9LR.default)([
                "_1pglp3kn"
            ]),
            !isExiting && animationTimingFunction === "ease-out" && (0, $aF9LR.default)([
                "_1pgldkwg"
            ]),
            !isExiting && animationTimingFunction === "ease-in" && (0, $aF9LR.default)([
                "_1pgl1nzg"
            ]),
            !isExiting && animationTimingFunction === "ease-in-out" && (0, $aF9LR.default)([
                "_1pgl1fu8"
            ]),
            isExiting && animationTimingFunction === "linear" && (0, $aF9LR.default)([
                "_1pglp3kn"
            ]),
            isExiting && animationTimingFunctionExiting === "ease-out" && (0, $aF9LR.default)([
                "_1pgldkwg"
            ]),
            isExiting && animationTimingFunctionExiting === "ease-in" && (0, $aF9LR.default)([
                "_1pgl1nzg"
            ]),
            isExiting && animationTimingFunctionExiting === "ease-in-out" && (0, $aF9LR.default)([
                "_1pgl1fu8"
            ]),
            (!isExiting && enteringAnimation === "fade-in" || isExiting && exitingAnimation === "fade-in") && (0, $aF9LR.default)([
                "_j7hq1cgr"
            ]),
            (!isExiting && enteringAnimation === "fade-out" || isExiting && exitingAnimation === "fade-out") && (0, $aF9LR.default)([
                "_j7hq1lln"
            ]),
            (!isExiting && enteringAnimation === "zoom-in" || isExiting && exitingAnimation === "zoom-in") && (0, $aF9LR.default)([
                "_j7hqe8p0"
            ]),
            (!isExiting && enteringAnimation === "zoom-out" || isExiting && exitingAnimation === "zoom-out") && (0, $aF9LR.default)([
                "_j7hqy6ql"
            ]),
            (!isExiting && enteringAnimation === "slide-in-from-top" || isExiting && exitingAnimation === "slide-in-from-top") && (0, $aF9LR.default)([
                "_j7hqqshu"
            ]),
            (!isExiting && enteringAnimation === "slide-out-from-top" || isExiting && exitingAnimation === "slide-out-from-top") && (0, $aF9LR.default)([
                "_j7hq7ri4"
            ]),
            (!isExiting && enteringAnimation === "slide-in-from-right" || isExiting && exitingAnimation === "slide-in-from-right") && (0, $aF9LR.default)([
                "_j7hqdfjr"
            ]),
            (!isExiting && enteringAnimation === "slide-out-from-right" || isExiting && exitingAnimation === "slide-out-from-right") && (0, $aF9LR.default)([
                "_j7hqonfj"
            ]),
            (!isExiting && enteringAnimation === "slide-in-from-bottom" || isExiting && exitingAnimation === "slide-in-from-bottom") && (0, $aF9LR.default)([
                "_j7hq1liq"
            ]),
            (!isExiting && enteringAnimation === "slide-out-from-bottom" || isExiting && exitingAnimation === "slide-out-from-bottom") && (0, $aF9LR.default)([
                "_j7hqhnf1"
            ]),
            (!isExiting && enteringAnimation === "slide-in-from-left" || isExiting && exitingAnimation === "slide-in-from-left") && (0, $aF9LR.default)([
                "_j7hq1bh1"
            ]),
            (!isExiting && enteringAnimation === "slide-out-from-left" || isExiting && exitingAnimation === "slide-out-from-left") && (0, $aF9LR.default)([
                "_j7hqj08w"
            ]),
            (!isExiting && enteringAnimation === "fade-in-from-top" || isExiting && exitingAnimation === "fade-in-from-top") && (0, $aF9LR.default)([
                "_j7hq2iua"
            ]),
            (!isExiting && enteringAnimation === "fade-out-from-top" || isExiting && exitingAnimation === "fade-out-from-top") && (0, $aF9LR.default)([
                "_j7hq39va"
            ]),
            (!isExiting && enteringAnimation === "fade-in-from-left" || isExiting && exitingAnimation === "fade-in-from-left") && (0, $aF9LR.default)([
                "_j7hq15m2"
            ]),
            (!isExiting && enteringAnimation === "fade-out-from-left" || isExiting && exitingAnimation === "fade-out-from-left") && (0, $aF9LR.default)([
                "_j7hq1yiv"
            ]),
            (!isExiting && enteringAnimation === "fade-in-from-bottom" || isExiting && exitingAnimation === "fade-in-from-bottom") && (0, $aF9LR.default)([
                "_j7hq1w00"
            ]),
            (!isExiting && enteringAnimation === "fade-out-from-bottom" || isExiting && exitingAnimation === "fade-out-from-bottom") && (0, $aF9LR.default)([
                "_j7hqzy3z"
            ]),
            (!isExiting && enteringAnimation === "fade-in-from-right" || isExiting && exitingAnimation === "fade-in-from-right") && (0, $aF9LR.default)([
                "_j7hqpqak"
            ]),
            (!isExiting && enteringAnimation === "fade-out-from-right" || isExiting && exitingAnimation === "fade-out-from-right") && (0, $aF9LR.default)([
                "_j7hq1ebg"
            ]),
            (!isExiting && enteringAnimation === "fade-in-from-top-constant" || isExiting && exitingAnimation === "fade-in-from-top-constant") && (0, $aF9LR.default)([
                "_j7hqm2e2"
            ]),
            (!isExiting && enteringAnimation === "fade-out-from-top-constant" || isExiting && exitingAnimation === "fade-out-from-top-constant") && (0, $aF9LR.default)([
                "_j7hq97jn"
            ]),
            (!isExiting && enteringAnimation === "fade-in-from-left-constant" || isExiting && exitingAnimation === "fade-in-from-left-constant") && (0, $aF9LR.default)([
                "_j7hqovgq"
            ]),
            (!isExiting && enteringAnimation === "fade-out-from-left-constant" || isExiting && exitingAnimation === "fade-out-from-left-constant") && (0, $aF9LR.default)([
                "_j7hq15do"
            ]),
            (!isExiting && enteringAnimation === "fade-in-from-bottom-constant" || isExiting && exitingAnimation === "fade-in-from-bottom-constant") && (0, $aF9LR.default)([
                "_j7hq797a"
            ]),
            (!isExiting && enteringAnimation === "fade-out-from-bottom-constant" || isExiting && exitingAnimation === "fade-out-from-bottom-constant") && (0, $aF9LR.default)([
                "_j7hqwo7r"
            ]),
            (!isExiting && enteringAnimation === "fade-in-from-right-constant" || isExiting && exitingAnimation === "fade-in-from-right-constant") && (0, $aF9LR.default)([
                "_j7hqt8u5"
            ]),
            (!isExiting && enteringAnimation === "fade-out-from-right-constant" || isExiting && exitingAnimation === "fade-out-from-right-constant") && (0, $aF9LR.default)([
                "_j7hq1pgp"
            ])
        ]) : "",
        style: {
            animationDelay: "".concat(delay, "ms")
        }
    }, state);
};
var $1208ce27757afc9c$export$2e2bcd8739ae039 = $1208ce27757afc9c$var$EnteringMotion;

});
parcelRegister("cLHRz", function(module, exports) {

$parcel$export(module.exports, "durations", function () { return $94bbe616c047e368$export$38b928a7167ce124; });
$parcel$export(module.exports, "exitingDurations", function () { return $94bbe616c047e368$export$30fa1a2e62ae150c; });
/**
 * Think of this as the motion equivalent of the @atlaskit/theme `grid()`.
 */ var $94bbe616c047e368$export$368bacef0dacbe05 = 25;
var $94bbe616c047e368$export$38b928a7167ce124 = {
    none: 0,
    small: 100,
    medium: 350,
    large: 700
};
/**
 * Used to multiply the initial duration for exiting motions.
 */ var $94bbe616c047e368$var$EXITING_MOTION_MULTIPLIER = 0.5;
var $94bbe616c047e368$export$30fa1a2e62ae150c = {
    none: $94bbe616c047e368$export$38b928a7167ce124.none,
    small: $94bbe616c047e368$export$38b928a7167ce124.small * $94bbe616c047e368$var$EXITING_MOTION_MULTIPLIER,
    medium: $94bbe616c047e368$export$38b928a7167ce124.medium * $94bbe616c047e368$var$EXITING_MOTION_MULTIPLIER,
    large: $94bbe616c047e368$export$38b928a7167ce124.large * $94bbe616c047e368$var$EXITING_MOTION_MULTIPLIER
};

});

parcelRegister("gGW01", function(module, exports) {

$parcel$export(module.exports, "useSetTimeout", function () { return $c26d8f0ef23623be$export$4f34107a2b00f39c; });

var $dAx5m = parcelRequire("dAx5m");
var $c26d8f0ef23623be$var$getHookDeps = function getHookDeps(opts) {
    switch(opts.cleanup){
        case "next-effect":
            return undefined;
        case "unmount":
        default:
            return [];
    }
};
var $c26d8f0ef23623be$export$1775f27e7c8051ca = function useRequestAnimationFrame() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        cleanup: "unmount"
    };
    var frames = (0, $dAx5m.useRef)([]);
    (0, $dAx5m.useEffect)(function() {
        return function() {
            if (frames.current.length) {
                frames.current.forEach(function(id) {
                    return cancelAnimationFrame(id);
                });
                frames.current = [];
            }
        };
    // We dynamically set this so we either clean up on the next effect - or on unmount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, $c26d8f0ef23623be$var$getHookDeps(opts));
    return (0, $dAx5m.useCallback)(function(handler) {
        var id = requestAnimationFrame(function(time) {
            frames.current = frames.current.filter(function(frameId) {
                return frameId !== id;
            });
            handler(time);
        });
        frames.current.push(id);
    }, []);
};
var $c26d8f0ef23623be$export$4f34107a2b00f39c = function useSetTimeout() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        cleanup: "unmount"
    };
    var timeouts = (0, $dAx5m.useRef)([]);
    (0, $dAx5m.useEffect)(function() {
        return function() {
            if (timeouts.current.length) {
                timeouts.current.forEach(function(id) {
                    return clearTimeout(id);
                });
                timeouts.current = [];
            }
        };
    // We dynamically set this so we either clean up on the next effect - or on unmount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, $c26d8f0ef23623be$var$getHookDeps(opts));
    return (0, $dAx5m.useCallback)(function(handler, timeout) {
        for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
        var id = setTimeout.apply(void 0, [
            function() {
                timeouts.current = timeouts.current.filter(function(timeoutId) {
                    return timeoutId !== id;
                });
                handler();
            },
            timeout
        ].concat(args));
        timeouts.current.push(id);
    }, []);
};

});

parcelRegister("8Mwhb", function(module, exports) {

$parcel$export(module.exports, "useStaggeredEntrance", function () { return $664bd7c61d33bd13$export$25c7213fc07ec080; });

var $kC8H4 = parcelRequire("kC8H4");

var $dAx5m = parcelRequire("dAx5m");

var $bJzW6 = parcelRequire("bJzW6");

var $5Znnf = parcelRequire("5Znnf");

var $jQ1ft = parcelRequire("jQ1ft");
var $664bd7c61d33bd13$var$StaggeredEntranceContext = /*#__PURE__*/ (0, $dAx5m.createContext)(function() {
    return {
        isReady: true,
        delay: 0,
        ref: (0, $bJzW6.default)
    };
});
var $664bd7c61d33bd13$export$25c7213fc07ec080 = function useStaggeredEntrance() {
    var indentifier = (0, $jQ1ft.useUniqueId)();
    var context = (0, $dAx5m.useContext)($664bd7c61d33bd13$var$StaggeredEntranceContext);
    return context(indentifier);
};
/**
 * For a list of elements that need to animate in,
 * this should be used in conjunction with entering components.
 * This does not need Javascript to execute so it will run immediately for any SSR rendered React apps before the JS has executed.
 *
 * Will dynamically add delay to each child entering component.
 * Unfortunately all entering components _NEED_ to be a direct descendant.
 */ var $664bd7c61d33bd13$var$StaggeredEntrance = function StaggeredEntrance(_ref) {
    var children = _ref.children, column = _ref.column, _ref$columns = _ref.columns, columns = _ref$columns === void 0 ? "responsive" : _ref$columns, _ref$delayStep = _ref.delayStep, delayStep = _ref$delayStep === void 0 ? 50 : _ref$delayStep;
    var elementRefs = (0, $dAx5m.useRef)([]);
    var indexes = [];
    var _useState = (0, $dAx5m.useState)(function() {
        if (typeof columns === "number") // A hardcoded columns is set so bail out and set it to that!
        return columns;
        if (typeof column === "number") // A hardcoded column is set so we will set actualColumns to be 1.
        return 1;
        // We are in "responsive" mode.
        // So we will be calculating when the Javascript executes on the client how many columns there will be.
        return 0;
    }), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($kC8H4)))(_useState, 2), actualColumns = _useState2[0], setActualColumns = _useState2[1];
    (0, $5Znnf.useLayoutEffect)(function() {
        // We want to only run this code when we are in "responsive" mode.
        // It is assumed we are in responsive mode if `columns` is "responsive",
        // we have children element refs ready to be read (i.e. if there are no children this won't run as well)
        // and finally that `actualColumns` is `0` - this is because for the first render cycle `actualColumns` will be `0` (set above)
        // and then after this layout effect runs the value for `actualColumns` will then be calculated and set.
        if (columns === "responsive" && elementRefs.current.length && actualColumns === 0) {
            var currentTop = 0;
            var numberColumns = 0;
            if (elementRefs.current.length <= 1) {
                setActualColumns(1);
                return;
            }
            // We set the current top to the first elements.
            // We will be comparing this and incrementing the column count
            // until we hit an element that has a different offset top (or we run out of elements).
            currentTop = elementRefs.current[0] ? elementRefs.current[0].offsetTop : 0;
            for(var i = 0; i < elementRefs.current.length; i++){
                var child = elementRefs.current[i];
                if (!child) break;
                if (currentTop === child.offsetTop) {
                    numberColumns += 1;
                    if (elementRefs.current.length - 1 === i) setActualColumns(numberColumns);
                    continue;
                }
                setActualColumns(numberColumns);
                break;
            }
        }
    // We only want this effect to run once - on initial mount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement($664bd7c61d33bd13$var$StaggeredEntranceContext.Provider, {
        value: function value(id) {
            if (!indexes.includes(id)) indexes.push(id);
            var isReady = actualColumns > 0;
            var index = indexes.indexOf(id);
            var currentColumn = column || index % actualColumns;
            var currentRow = Math.floor(index / actualColumns);
            var distanceFromTopLeftElement = currentRow + currentColumn;
            // We don't want loads of elements to have the same staggered delay as it ends up looking slow for users.
            // To get around that we calculate the logarithm using `distanceFromTopLeftElement` which ends making
            // elements appear faster the further away from the top left element.
            var delay = Math.ceil(Math.log(distanceFromTopLeftElement + 1) * delayStep * 1.5) || 0;
            return {
                delay: delay,
                isReady: isReady,
                ref: function ref(element) {
                    return elementRefs.current[index] = element;
                }
            };
        }
    }, children);
};
var $664bd7c61d33bd13$export$2e2bcd8739ae039 = $664bd7c61d33bd13$var$StaggeredEntrance;

});
parcelRegister("5Znnf", function(module, exports) {

$parcel$export(module.exports, "useLayoutEffect", function () { return $45c4c7d9fff68a5f$export$e5c5a5f917a5871c; });

var $dAx5m = parcelRequire("dAx5m");
var $45c4c7d9fff68a5f$export$e5c5a5f917a5871c = typeof window === "undefined" ? (0, $dAx5m.useEffect) : (0, $dAx5m.useLayoutEffect);

});

parcelRegister("jQ1ft", function(module, exports) {

$parcel$export(module.exports, "useUniqueId", function () { return $e713d7935f3d6ba6$export$c485849f2e393253; });
/* eslint-disable @repo/internal/react/disallow-unstable-values */ 
var $dAx5m = parcelRequire("dAx5m");
function $e713d7935f3d6ba6$export$c485849f2e393253() {
    var identifier = (0, $dAx5m.useRef)("");
    if (!identifier.current) identifier.current = "_" + (Number(String(Math.random()).slice(2)) + Date.now() + Math.round(performance.now())).toString(36);
    return identifier.current;
}

});





parcelRegister("ia0xI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d38994fa29f668da$export$2e2bcd8739ae039; });

var $sN2rQ = parcelRequire("sN2rQ");

var $dTYVX = parcelRequire("dTYVX");

var $dAx5m = parcelRequire("dAx5m");

var $jVTBW = parcelRequire("jVTBW");

var $c1fUv = parcelRequire("c1fUv");

var $b9R5N = parcelRequire("b9R5N");

var $ggwTM = parcelRequire("ggwTM");
var $5cC3Q = parcelRequire("5cC3Q");

var $h5NR9 = parcelRequire("h5NR9");

var $9OhEN = parcelRequire("9OhEN");

var $bwfSA = parcelRequire("bwfSA");

var $ajA5X = parcelRequire("ajA5X");

var $4cwGG = parcelRequire("4cwGG");
var $d38994fa29f668da$var$_excluded = [
    "component"
], $d38994fa29f668da$var$_excluded2 = [
    "component"
];
// Misc.
// ------------------------------
var $d38994fa29f668da$var$defaults = {
    Sidebar: (0, $4cwGG.default),
    Content: (0, $9OhEN.default)
};
/**
 * This wrapper is used to specify separate durations for enter and exit.
 */ var $d38994fa29f668da$var$CustomSlideIn = function CustomSlideIn(_ref) {
    var children = _ref.children, onFinish = _ref.onFinish, enterFrom = _ref.enterFrom;
    return (0, $jVTBW.jsx)((0, $5cC3Q.default), {
        animationTimingFunction: "ease-out",
        duration: "small",
        enterFrom: enterFrom,
        exitTo: enterFrom,
        fade: "none",
        onFinish: onFinish
    }, children);
};
var $d38994fa29f668da$var$DrawerPrimitive = function DrawerPrimitive(_ref2) {
    var children = _ref2.children, Icon = _ref2.icon, _ref2$closeLabel = _ref2.closeLabel, closeLabel = _ref2$closeLabel === void 0 ? "Close drawer" : _ref2$closeLabel, scrollContentLabel = _ref2.scrollContentLabel, onClose = _ref2.onClose, onCloseComplete = _ref2.onCloseComplete, onOpenComplete = _ref2.onOpenComplete, overrides = _ref2.overrides, testId = _ref2.testId, isOpen = _ref2.in, shouldReturnFocus = _ref2.shouldReturnFocus, autoFocusFirstElem = _ref2.autoFocusFirstElem, isFocusLockEnabled = _ref2.isFocusLockEnabled, width = _ref2.width, label = _ref2.label, titleId = _ref2.titleId, _ref2$enterFrom = _ref2.enterFrom, enterFrom = _ref2$enterFrom === void 0 ? "left" : _ref2$enterFrom;
    var getOverrides = (0, $h5NR9.createExtender)($d38994fa29f668da$var$defaults, overrides);
    var _getOverrides = getOverrides("Sidebar"), Sidebar = _getOverrides.component, sideBarOverrides = (0, (/*@__PURE__*/$parcel$interopDefault($dTYVX)))(_getOverrides, $d38994fa29f668da$var$_excluded);
    var _getOverrides2 = getOverrides("Content"), Content = _getOverrides2.component, contentOverrides = (0, (/*@__PURE__*/$parcel$interopDefault($dTYVX)))(_getOverrides2, $d38994fa29f668da$var$_excluded2);
    /**
   * A ref to point to our wrapper, passed to `onCloseComplete` and `onOpenComplete` callbacks.
   */ var drawerRef = (0, $dAx5m.useRef)(null);
    var onFinish = (0, $dAx5m.useCallback)(function(state) {
        if (state === "entering") onOpenComplete === null || onOpenComplete === void 0 || onOpenComplete(drawerRef.current);
        else if (state === "exiting") onCloseComplete === null || onCloseComplete === void 0 || onCloseComplete(drawerRef.current);
    }, [
        onCloseComplete,
        onOpenComplete
    ]);
    return (0, $jVTBW.jsx)((0, $ggwTM.default), {
        appear: true
    }, isOpen && (0, $jVTBW.jsx)($d38994fa29f668da$var$CustomSlideIn, {
        onFinish: onFinish,
        enterFrom: enterFrom
    }, function(_ref3) {
        var className = _ref3.className;
        return (0, $jVTBW.jsx)((0, $ajA5X.default), {
            autoFocusFirstElem: autoFocusFirstElem,
            isFocusLockEnabled: isFocusLockEnabled,
            shouldReturnFocus: shouldReturnFocus
        }, (0, $jVTBW.jsx)((0, $bwfSA.default), {
            className: className,
            width: width,
            testId: testId,
            drawerRef: drawerRef,
            label: label,
            titleId: titleId
        }, (0, $jVTBW.jsx)(Sidebar, sideBarOverrides, (0, $jVTBW.jsx)((0, $c1fUv.default), {
            onClick: onClose,
            testId: testId && "DrawerPrimitiveSidebarCloseButton",
            icon: Icon ? function(iconProps) {
                return (0, $jVTBW.jsx)(Icon, (0, (/*@__PURE__*/$parcel$interopDefault($sN2rQ)))({}, iconProps, {
                    size: "large",
                    LEGACY_size: "large"
                }));
            } : (0, (/*@__PURE__*/$parcel$interopDefault($b9R5N))),
            label: closeLabel,
            shape: "circle",
            appearance: "subtle"
        })), (0, $jVTBW.jsx)(Content, (0, (/*@__PURE__*/$parcel$interopDefault($sN2rQ)))({
            scrollContentLabel: scrollContentLabel
        }, contentOverrides), children)));
    }));
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$d38994fa29f668da$export$2e2bcd8739ae039 = $d38994fa29f668da$var$DrawerPrimitive;

});
parcelRegister("sN2rQ", function(module, exports) {
function $0568a7a95f3e8dce$var$_extends() {
    return module.exports = $0568a7a95f3e8dce$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $0568a7a95f3e8dce$var$_extends.apply(null, arguments);
}
module.exports = $0568a7a95f3e8dce$var$_extends, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("dTYVX", function(module, exports) {

var $9WtRT = parcelRequire("9WtRT");
function $a1efad9e6c0ef9c0$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $9WtRT(e, t);
    if (Object.getOwnPropertySymbols) {
        var s = Object.getOwnPropertySymbols(e);
        for(r = 0; r < s.length; r++)o = s[r], t.includes(o) || ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
module.exports = $a1efad9e6c0ef9c0$var$_objectWithoutProperties, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("9WtRT", function(module, exports) {
function $73d0b3067ac26d41$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.includes(n)) continue;
        t[n] = r[n];
    }
    return t;
}
module.exports = $73d0b3067ac26d41$var$_objectWithoutPropertiesLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("c1fUv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8c01eb7a2bd25344$export$2e2bcd8739ae039; });

var $sN2rQ = parcelRequire("sN2rQ");

var $dTYVX = parcelRequire("dTYVX");

var $dAx5m = parcelRequire("dAx5m");

var $cJk9l = parcelRequire("cJk9l");

var $bfbOM = parcelRequire("bfbOM");

var $f2JTV = parcelRequire("f2JTV");
var $8c01eb7a2bd25344$var$_excluded = [
    "aria-label",
    "aria-labelledby",
    "analyticsContext",
    "appearance",
    "autoFocus",
    "icon",
    "interactionName",
    "isDisabled",
    "isLoading",
    "isSelected",
    "isTooltipDisabled",
    "label",
    "onClick",
    "onClickCapture",
    "onKeyDownCapture",
    "onKeyUpCapture",
    "onMouseDownCapture",
    "onMouseUpCapture",
    "onPointerDownCapture",
    "onPointerUpCapture",
    "onTouchEndCapture",
    "onTouchStartCapture",
    "shape",
    "spacing",
    "testId",
    "tooltip",
    "type"
], $8c01eb7a2bd25344$var$_excluded2 = [
    "className",
    "css",
    "as",
    "style"
];
/**
 * __Icon Button__
 *
 * Renders an icon-only button lets people take a common and recognizable action where space is limited.
 *
 * - [Examples](https://atlassian.design/components/button/icon-button/examples)
 * - [Code](https://atlassian.design/components/button/icon-button/code)
 * - [Usage](https://atlassian.design/components/button/icon-button/usage)
 */ var $8c01eb7a2bd25344$var$IconButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).forwardRef(function Button(_ref, ref) {
    var preventedAriaLabel = _ref["aria-label"], ariaLabelledBy = _ref["aria-labelledby"], analyticsContext = _ref.analyticsContext, appearance = _ref.appearance, autoFocus = _ref.autoFocus, icon = _ref.icon, interactionName = _ref.interactionName, isDisabled = _ref.isDisabled, isLoading = _ref.isLoading, isSelected = _ref.isSelected, _ref$isTooltipDisable = _ref.isTooltipDisabled, isTooltipDisabled = _ref$isTooltipDisable === void 0 ? true : _ref$isTooltipDisable, label = _ref.label, onClick = _ref.onClick, onClickCapture = _ref.onClickCapture, onKeyDownCapture = _ref.onKeyDownCapture, onKeyUpCapture = _ref.onKeyUpCapture, onMouseDownCapture = _ref.onMouseDownCapture, onMouseUpCapture = _ref.onMouseUpCapture, onPointerDownCapture = _ref.onPointerDownCapture, onPointerUpCapture = _ref.onPointerUpCapture, onTouchEndCapture = _ref.onTouchEndCapture, onTouchStartCapture = _ref.onTouchStartCapture, shape = _ref.shape, spacing = _ref.spacing, testId = _ref.testId, tooltip = _ref.tooltip, _ref$type = _ref.type, type = _ref$type === void 0 ? "button" : _ref$type, unsafeRest = (0, (/*@__PURE__*/$parcel$interopDefault($dTYVX)))(_ref, $8c01eb7a2bd25344$var$_excluded);
    // @ts-expect-error
    var _className = unsafeRest.className, _css = unsafeRest.css, _as = unsafeRest.as, _style = unsafeRest.style, saferRest = (0, (/*@__PURE__*/$parcel$interopDefault($dTYVX)))(unsafeRest, $8c01eb7a2bd25344$var$_excluded2);
    /**
   * TODO: At some stage I'll look into re-using more logic across 'default' and 'icon'
   * buttons. It's currently duplicated and mostly the same.
   */ var baseProps = (0, $f2JTV.default)({
        analyticsContext: analyticsContext,
        appearance: appearance,
        ariaLabelledBy: ariaLabelledBy,
        autoFocus: autoFocus,
        buttonType: "button",
        icon: icon,
        interactionName: interactionName,
        isDisabled: isDisabled,
        isLoading: isLoading,
        isSelected: isSelected,
        label: label,
        onClick: onClick,
        onClickCapture: onClickCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onTouchEndCapture: onTouchEndCapture,
        onTouchStartCapture: onTouchStartCapture,
        ref: ref,
        shape: shape,
        spacing: spacing,
        testId: testId
    });
    if (!isTooltipDisabled) {
        var _tooltip$content;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $bfbOM.default), {
            content: (_tooltip$content = tooltip === null || tooltip === void 0 ? void 0 : tooltip.content) !== null && _tooltip$content !== void 0 ? _tooltip$content : label,
            testId: tooltip === null || tooltip === void 0 ? void 0 : tooltip.testId,
            position: tooltip === null || tooltip === void 0 ? void 0 : tooltip.position,
            delay: tooltip === null || tooltip === void 0 ? void 0 : tooltip.delay,
            onShow: tooltip === null || tooltip === void 0 ? void 0 : tooltip.onShow,
            onHide: tooltip === null || tooltip === void 0 ? void 0 : tooltip.onHide,
            mousePosition: tooltip === null || tooltip === void 0 ? void 0 : tooltip.mousePosition,
            analyticsContext: tooltip === null || tooltip === void 0 ? void 0 : tooltip.analyticsContext,
            strategy: tooltip === null || tooltip === void 0 ? void 0 : tooltip.strategy,
            tag: tooltip === null || tooltip === void 0 ? void 0 : tooltip.tag,
            truncate: tooltip === null || tooltip === void 0 ? void 0 : tooltip.truncate,
            component: tooltip === null || tooltip === void 0 ? void 0 : tooltip.component,
            hideTooltipOnClick: tooltip === null || tooltip === void 0 ? void 0 : tooltip.hideTooltipOnClick,
            hideTooltipOnMouseDown: tooltip === null || tooltip === void 0 ? void 0 : tooltip.hideTooltipOnMouseDown,
            ignoreTooltipPointerEvents: tooltip === null || tooltip === void 0 ? void 0 : tooltip.ignoreTooltipPointerEvents
        }, function(triggerProps) {
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $cJk9l.default), (0, (/*@__PURE__*/$parcel$interopDefault($sN2rQ)))({}, saferRest, {
                // Top level props
                "aria-labelledby": baseProps["aria-labelledby"],
                type: type,
                testId: testId,
                componentName: "IconButton",
                analyticsContext: analyticsContext,
                interactionName: interactionName,
                onMouseOver: function onMouseOver(e) {
                    var _triggerProps$onMouse, _saferRest$onMouseOve;
                    (_triggerProps$onMouse = triggerProps.onMouseOver) === null || _triggerProps$onMouse === void 0 || _triggerProps$onMouse.call(triggerProps, e);
                    (_saferRest$onMouseOve = saferRest.onMouseOver) === null || _saferRest$onMouseOve === void 0 || _saferRest$onMouseOve.call(saferRest, e);
                },
                onMouseOut: function onMouseOut(e) {
                    var _triggerProps$onMouse2, _saferRest$onMouseOut;
                    (_triggerProps$onMouse2 = triggerProps.onMouseOut) === null || _triggerProps$onMouse2 === void 0 || _triggerProps$onMouse2.call(triggerProps, e);
                    (_saferRest$onMouseOut = saferRest.onMouseOut) === null || _saferRest$onMouseOut === void 0 || _saferRest$onMouseOut.call(saferRest, e);
                },
                onMouseMove: function onMouseMove(e) {
                    var _triggerProps$onMouse3, _saferRest$onMouseMov;
                    (_triggerProps$onMouse3 = triggerProps.onMouseMove) === null || _triggerProps$onMouse3 === void 0 || _triggerProps$onMouse3.call(triggerProps, e);
                    (_saferRest$onMouseMov = saferRest.onMouseMove) === null || _saferRest$onMouseMov === void 0 || _saferRest$onMouseMov.call(saferRest, e);
                },
                onMouseDown: function onMouseDown(e) {
                    var _triggerProps$onMouse4, _saferRest$onMouseDow;
                    (_triggerProps$onMouse4 = triggerProps.onMouseDown) === null || _triggerProps$onMouse4 === void 0 || _triggerProps$onMouse4.call(triggerProps, e);
                    (_saferRest$onMouseDow = saferRest.onMouseDown) === null || _saferRest$onMouseDow === void 0 || _saferRest$onMouseDow.call(saferRest, e);
                },
                onFocus: function onFocus(e) {
                    var _triggerProps$onFocus, _saferRest$onFocus;
                    (_triggerProps$onFocus = triggerProps.onFocus) === null || _triggerProps$onFocus === void 0 || _triggerProps$onFocus.call(triggerProps, e);
                    (_saferRest$onFocus = saferRest.onFocus) === null || _saferRest$onFocus === void 0 || _saferRest$onFocus.call(saferRest, e);
                },
                onBlur: function onBlur(e) {
                    var _triggerProps$onBlur, _saferRest$onBlur;
                    (_triggerProps$onBlur = triggerProps.onBlur) === null || _triggerProps$onBlur === void 0 || _triggerProps$onBlur.call(triggerProps, e);
                    (_saferRest$onBlur = saferRest.onBlur) === null || _saferRest$onBlur === void 0 || _saferRest$onBlur.call(saferRest, e);
                },
                onClick: function onClick(event, analyticsEvent) {
                    var _baseProps$onClick, _triggerProps$onClick;
                    baseProps === null || baseProps === void 0 || (_baseProps$onClick = baseProps.onClick) === null || _baseProps$onClick === void 0 || _baseProps$onClick.call(baseProps, event, analyticsEvent);
                    triggerProps === null || triggerProps === void 0 || (_triggerProps$onClick = triggerProps.onClick) === null || _triggerProps$onClick === void 0 || _triggerProps$onClick.call(triggerProps, event);
                },
                ref: function ref(_ref2) {
                    var _triggerProps$ref;
                    baseProps.ref(_ref2);
                    triggerProps === null || triggerProps === void 0 || (_triggerProps$ref = triggerProps.ref) === null || _triggerProps$ref === void 0 || _triggerProps$ref.call(triggerProps, _ref2);
                },
                xcss: baseProps.xcss,
                isDisabled: baseProps.isDisabled,
                onMouseDownCapture: baseProps.onMouseDownCapture,
                onMouseUpCapture: baseProps.onMouseUpCapture,
                onKeyDownCapture: baseProps.onKeyDownCapture,
                onKeyUpCapture: baseProps.onKeyUpCapture,
                onTouchStartCapture: baseProps.onTouchStartCapture,
                onTouchEndCapture: baseProps.onTouchEndCapture,
                onPointerDownCapture: baseProps.onPointerDownCapture,
                onPointerUpCapture: baseProps.onPointerUpCapture,
                onClickCapture: baseProps.onClickCapture
            }), baseProps.children);
        });
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $cJk9l.default), (0, (/*@__PURE__*/$parcel$interopDefault($sN2rQ)))({}, saferRest, {
        "aria-labelledby": baseProps["aria-labelledby"],
        ref: baseProps.ref,
        xcss: baseProps.xcss,
        isDisabled: baseProps.isDisabled,
        onClick: baseProps.onClick,
        onMouseDownCapture: baseProps.onMouseDownCapture,
        onMouseUpCapture: baseProps.onMouseUpCapture,
        onKeyDownCapture: baseProps.onKeyDownCapture,
        onKeyUpCapture: baseProps.onKeyUpCapture,
        onTouchStartCapture: baseProps.onTouchStartCapture,
        onTouchEndCapture: baseProps.onTouchEndCapture,
        onPointerDownCapture: baseProps.onPointerDownCapture,
        onPointerUpCapture: baseProps.onPointerUpCapture,
        onClickCapture: baseProps.onClickCapture,
        type: type,
        testId: testId,
        componentName: "IconButton",
        analyticsContext: analyticsContext,
        interactionName: interactionName
    }), baseProps.children);
}));
$8c01eb7a2bd25344$var$IconButton.displayName = "IconButton";
var $8c01eb7a2bd25344$export$2e2bcd8739ae039 = $8c01eb7a2bd25344$var$IconButton;

});
parcelRegister("cJk9l", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9449515587f44084$export$2e2bcd8739ae039; });

var $sN2rQ = parcelRequire("sN2rQ");

var $dTYVX = parcelRequire("dTYVX");

var $dAx5m = parcelRequire("dAx5m");

var $jVTBW = parcelRequire("jVTBW");

var $gVLVb = parcelRequire("gVLVb");

var $bJzW6 = parcelRequire("bJzW6");

var $cYAkF = parcelRequire("cYAkF");

var $8xoOY = parcelRequire("8xoOY");

var $aDEaV = parcelRequire("aDEaV");
var $9449515587f44084$var$_excluded = [
    "children",
    "backgroundColor",
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    "isDisabled",
    "type",
    "onClick",
    "interactionName",
    "componentName",
    "analyticsContext",
    "style",
    "testId",
    "xcss"
], $9449515587f44084$var$_excluded2 = [
    "className"
];
// This duplicates FocusRing styles from `@atlaskit/focus-ring`.
var $9449515587f44084$var$focusRingStyles = (0, $jVTBW.css)({
    "&:focus, &:focus-visible": {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        outlineColor: (0, $8xoOY.borderColorMap)["color.border.focused"],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        outlineOffset: (0, $8xoOY.positiveSpaceMap)["space.025"],
        outlineStyle: "solid",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        outlineWidth: (0, $8xoOY.borderWidthMap)["border.width.outline"]
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    "&:focus:not(:focus-visible)": {
        outline: "none"
    },
    "@media screen and (forced-colors: active), screen and (-ms-high-contrast: active)": {
        "&:focus-visible": {
            outline: "1px solid"
        }
    }
});
var $9449515587f44084$var$baseStyles = (0, $jVTBW.css)({
    boxSizing: "border-box",
    appearance: "none",
    border: "none"
});
var $9449515587f44084$var$enabledStyles = (0, $jVTBW.css)({
    cursor: "pointer"
});
var $9449515587f44084$var$disabledStyles = (0, $jVTBW.css)({
    cursor: "not-allowed"
});
/**
 * __Pressable__
 *
 * A primitive for building custom buttons.
 *
 * - [Examples](https://atlassian.design/components/primitives/pressable/examples)
 * - [Code](https://atlassian.design/components/primitives/pressable/code)
 * - [Usage](https://atlassian.design/components/primitives/pressable/usage)
 */ var $9449515587f44084$var$Pressable = /*#__PURE__*/ (0, $dAx5m.forwardRef)(function(_ref, ref) {
    var children = _ref.children, backgroundColor = _ref.backgroundColor, padding = _ref.padding, paddingBlock = _ref.paddingBlock, paddingBlockStart = _ref.paddingBlockStart, paddingBlockEnd = _ref.paddingBlockEnd, paddingInline = _ref.paddingInline, paddingInlineStart = _ref.paddingInlineStart, paddingInlineEnd = _ref.paddingInlineEnd, isDisabled = _ref.isDisabled, _ref$type = _ref.type, type = _ref$type === void 0 ? "button" : _ref$type, _ref$onClick = _ref.onClick, providedOnClick = _ref$onClick === void 0 ? (0, $bJzW6.default) : _ref$onClick, interactionName = _ref.interactionName, componentName = _ref.componentName, analyticsContext = _ref.analyticsContext, style = _ref.style, testId = _ref.testId, xcss = _ref.xcss, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($dTYVX)))(_ref, $9449515587f44084$var$_excluded);
    var interactionContext = (0, $dAx5m.useContext)((0, $cYAkF.default));
    var handleClick = (0, $dAx5m.useCallback)(function(e, analyticsEvent) {
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    var onClick = (0, $gVLVb.usePlatformLeafEventHandler)({
        fn: handleClick,
        action: "clicked",
        componentName: componentName || "Pressable",
        packageName: "@atlaskit/primitives",
        packageVersion: "14.1.0",
        analyticsData: analyticsContext,
        actionSubject: "button"
    });
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($dTYVX)))(htmlAttributes, $9449515587f44084$var$_excluded2);
    var resolvedStyles = (0, $aDEaV.parseXcss)(xcss);
    return(// eslint-disable-next-line @atlaskit/design-system/no-html-button
    (0, $jVTBW.jsx)("button", (0, (/*@__PURE__*/$parcel$interopDefault($sN2rQ)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        ref: ref,
        className: resolvedStyles.static
    }, safeHtmlAttributes, {
        // eslint-disable-next-line react/button-has-type
        type: type,
        onClick: onClick,
        disabled: isDisabled,
        css: [
            $9449515587f44084$var$baseStyles,
            $9449515587f44084$var$focusRingStyles,
            isDisabled ? $9449515587f44084$var$disabledStyles : $9449515587f44084$var$enabledStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            backgroundColor && (0, $8xoOY.backgroundColorStylesMap)[backgroundColor],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            padding && (0, $8xoOY.paddingStylesMap).padding[padding],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlock && (0, $8xoOY.paddingStylesMap).paddingBlock[paddingBlock],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockStart && (0, $8xoOY.paddingStylesMap).paddingBlockStart[paddingBlockStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockEnd && (0, $8xoOY.paddingStylesMap).paddingBlockEnd[paddingBlockEnd],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInline && (0, $8xoOY.paddingStylesMap).paddingInline[paddingInline],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineStart && (0, $8xoOY.paddingStylesMap).paddingInlineStart[paddingInlineStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineEnd && (0, $8xoOY.paddingStylesMap).paddingInlineEnd[paddingInlineEnd],
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            resolvedStyles.emotion
        ],
        "data-testid": testId
    }), children));
});
var $9449515587f44084$export$2e2bcd8739ae039 = $9449515587f44084$var$Pressable;

});
parcelRegister("cYAkF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $972745795f5dca8a$export$2e2bcd8739ae039; });

var $dAx5m = parcelRequire("dAx5m");
var $972745795f5dca8a$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $dAx5m.createContext)(null);

});

parcelRegister("8xoOY", function(module, exports) {

$parcel$export(module.exports, "dimensionMap", function () { return $6374a8c7bd915319$export$6ccdbebca2ee545f; });
$parcel$export(module.exports, "positiveSpaceMap", function () { return $6374a8c7bd915319$export$958d0ae7f2977ae4; });
$parcel$export(module.exports, "allSpaceMap", function () { return $6374a8c7bd915319$export$632685d741f3dbbf; });
$parcel$export(module.exports, "opacityMap", function () { return $6374a8c7bd915319$export$daf94a976c798b4f; });
$parcel$export(module.exports, "shadowMap", function () { return $6374a8c7bd915319$export$7aff6e7ba39bb774; });
$parcel$export(module.exports, "borderColorMap", function () { return $6374a8c7bd915319$export$1531ad5bb3fbedac; });
$parcel$export(module.exports, "backgroundColorMap", function () { return $6374a8c7bd915319$export$d1d79bf68ac056bd; });
$parcel$export(module.exports, "textColorMap", function () { return $6374a8c7bd915319$export$8473307aa00d6ea1; });
$parcel$export(module.exports, "layerMap", function () { return $6374a8c7bd915319$export$b5f31a7e431d2eab; });
$parcel$export(module.exports, "borderWidthMap", function () { return $6374a8c7bd915319$export$e1b83c5210c471b8; });
$parcel$export(module.exports, "borderRadiusMap", function () { return $6374a8c7bd915319$export$3c0a6c3e64bb180d; });
$parcel$export(module.exports, "fontMap", function () { return $6374a8c7bd915319$export$6ffa317d5e70375; });
$parcel$export(module.exports, "fontWeightMap", function () { return $6374a8c7bd915319$export$303e322c6b1ed114; });
$parcel$export(module.exports, "fontFamilyMap", function () { return $6374a8c7bd915319$export$3c7e9587132614b4; });
$parcel$export(module.exports, "paddingStylesMap", function () { return $6374a8c7bd915319$export$e615f061ca585a6c; });
$parcel$export(module.exports, "backgroundColorStylesMap", function () { return $6374a8c7bd915319$export$e7af83bafe7f9e63; });
$parcel$export(module.exports, "surfaceColorStylesMap", function () { return $6374a8c7bd915319$export$ff257d957d48c421; });
$parcel$export(module.exports, "isSurfaceColorToken", function () { return $6374a8c7bd915319$export$5e65a44e5b6ecadb; });

var $c6l2j = parcelRequire("c6l2j");

var $jVTBW = parcelRequire("jVTBW");

var $3BXIB = parcelRequire("3BXIB");
function $6374a8c7bd915319$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $6374a8c7bd915319$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $6374a8c7bd915319$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($c6l2j)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $6374a8c7bd915319$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $6374a8c7bd915319$export$6ccdbebca2ee545f = {
    "100%": "100%",
    "size.100": "1rem",
    "size.200": "1.5rem",
    "size.300": "2rem",
    "size.400": "2.5rem",
    "size.500": "3rem",
    "size.600": "6rem",
    "size.1000": "12rem"
};
var $6374a8c7bd915319$export$958d0ae7f2977ae4 = {
    "space.0": "var(--ds-space-0, 0px)",
    "space.025": "var(--ds-space-025, 2px)",
    "space.050": "var(--ds-space-050, 4px)",
    "space.075": "var(--ds-space-075, 6px)",
    "space.100": "var(--ds-space-100, 8px)",
    "space.150": "var(--ds-space-150, 12px)",
    "space.200": "var(--ds-space-200, 16px)",
    "space.250": "var(--ds-space-250, 20px)",
    "space.300": "var(--ds-space-300, 24px)",
    "space.400": "var(--ds-space-400, 32px)",
    "space.500": "var(--ds-space-500, 40px)",
    "space.600": "var(--ds-space-600, 48px)",
    "space.800": "var(--ds-space-800, 64px)",
    "space.1000": "var(--ds-space-1000, 80px)"
};
var $6374a8c7bd915319$export$d2dc61f58390201c = {
    "space.negative.025": "var(--ds-space-negative-025, -2px)",
    "space.negative.050": "var(--ds-space-negative-050, -4px)",
    "space.negative.075": "var(--ds-space-negative-075, -6px)",
    "space.negative.100": "var(--ds-space-negative-100, -8px)",
    "space.negative.150": "var(--ds-space-negative-150, -12px)",
    "space.negative.200": "var(--ds-space-negative-200, -16px)",
    "space.negative.250": "var(--ds-space-negative-250, -20px)",
    "space.negative.300": "var(--ds-space-negative-300, -24px)",
    "space.negative.400": "var(--ds-space-negative-400, -32px)"
};
var $6374a8c7bd915319$export$632685d741f3dbbf = $6374a8c7bd915319$var$_objectSpread($6374a8c7bd915319$var$_objectSpread({}, $6374a8c7bd915319$export$958d0ae7f2977ae4), $6374a8c7bd915319$export$d2dc61f58390201c);
var $6374a8c7bd915319$export$2185ce37f9bdd963 = {
    "color.background.neutral.bold": "color.text.inverse",
    "color.background.neutral.bold.hovered": "color.text.inverse",
    "color.background.neutral.bold.pressed": "color.text.inverse",
    "color.background.selected.bold": "color.text.inverse",
    "color.background.selected.bold.hovered": "color.text.inverse",
    "color.background.selected.bold.pressed": "color.text.inverse",
    "color.background.brand.bold": "color.text.inverse",
    "color.background.brand.bold.hovered": "color.text.inverse",
    "color.background.brand.bold.pressed": "color.text.inverse",
    "color.background.brand.boldest": "color.text.inverse",
    "color.background.brand.boldest.hovered": "color.text.inverse",
    "color.background.brand.boldest.pressed": "color.text.inverse",
    "color.background.danger.bold": "color.text.inverse",
    "color.background.danger.bold.hovered": "color.text.inverse",
    "color.background.danger.bold.pressed": "color.text.inverse",
    "color.background.warning.bold": "color.text.warning.inverse",
    "color.background.warning.bold.hovered": "color.text.warning.inverse",
    "color.background.warning.bold.pressed": "color.text.warning.inverse",
    "color.background.success.bold": "color.text.inverse",
    "color.background.success.bold.hovered": "color.text.inverse",
    "color.background.success.bold.pressed": "color.text.inverse",
    "color.background.discovery.bold": "color.text.inverse",
    "color.background.discovery.bold.hovered": "color.text.inverse",
    "color.background.discovery.bold.pressed": "color.text.inverse",
    "color.background.information.bold": "color.text.inverse",
    "color.background.information.bold.hovered": "color.text.inverse",
    "color.background.information.bold.pressed": "color.text.inverse"
};
var $6374a8c7bd915319$export$daf94a976c798b4f = {
    "opacity.disabled": "var(--ds-opacity-disabled, 0.4)",
    "opacity.loading": "var(--ds-opacity-loading, 0.2)"
};
var $6374a8c7bd915319$export$7aff6e7ba39bb774 = {
    "elevation.shadow.overflow": "var(--ds-shadow-overflow, 0px 0px 8px #091e423f, 0px 0px 1px #091e424f)",
    "elevation.shadow.overflow.perimeter": "var(--ds-shadow-overflow-perimeter, #091e421f)",
    "elevation.shadow.overflow.spread": "var(--ds-shadow-overflow-spread, #091e4229)",
    "elevation.shadow.overlay": "var(--ds-shadow-overlay, 0px 8px 12px #091e423f, 0px 0px 1px #091e424f)",
    "elevation.shadow.raised": "var(--ds-shadow-raised, 0px 1px 1px #091e423f, 0px 0px 1px #091e4221)"
};
var $6374a8c7bd915319$export$41a358c9c2356760 = {
    "elevation.surface": "var(--ds-surface, #FFFFFF)",
    "elevation.surface.hovered": "var(--ds-surface-hovered, #FAFBFC)",
    "elevation.surface.pressed": "var(--ds-surface-pressed, #F4F5F7)",
    "elevation.surface.overlay": "var(--ds-surface-overlay, #FFFFFF)",
    "elevation.surface.overlay.hovered": "var(--ds-surface-overlay-hovered, #FAFBFC)",
    "elevation.surface.overlay.pressed": "var(--ds-surface-overlay-pressed, #F4F5F7)",
    "elevation.surface.raised": "var(--ds-surface-raised, #FFFFFF)",
    "elevation.surface.raised.hovered": "var(--ds-surface-raised-hovered, #FAFBFC)",
    "elevation.surface.raised.pressed": "var(--ds-surface-raised-pressed, #F4F5F7)",
    "elevation.surface.sunken": "var(--ds-surface-sunken, #F4F5F7)"
};
var $6374a8c7bd915319$export$1531ad5bb3fbedac = {
    "color.border": "var(--ds-border, #091e4221)",
    "color.border.accent.lime": "var(--ds-border-accent-lime, #6A9A23)",
    "color.border.accent.red": "var(--ds-border-accent-red, #FF5630)",
    "color.border.accent.orange": "var(--ds-border-accent-orange, #D94008)",
    "color.border.accent.yellow": "var(--ds-border-accent-yellow, #FFAB00)",
    "color.border.accent.green": "var(--ds-border-accent-green, #36B37E)",
    "color.border.accent.teal": "var(--ds-border-accent-teal, #00B8D9)",
    "color.border.accent.blue": "var(--ds-border-accent-blue, #0065FF)",
    "color.border.accent.purple": "var(--ds-border-accent-purple, #6554C0)",
    "color.border.accent.magenta": "var(--ds-border-accent-magenta, #CD519D)",
    "color.border.accent.gray": "var(--ds-border-accent-gray, #5E6C84)",
    "color.border.disabled": "var(--ds-border-disabled, #FAFBFC)",
    "color.border.focused": "var(--ds-border-focused, #2684FF)",
    "color.border.input": "var(--ds-border-input, #FAFBFC)",
    "color.border.inverse": "var(--ds-border-inverse, #FFFFFF)",
    "color.border.selected": "var(--ds-border-selected, #0052CC)",
    "color.border.brand": "var(--ds-border-brand, #0052CC)",
    "color.border.danger": "var(--ds-border-danger, #FF5630)",
    "color.border.warning": "var(--ds-border-warning, #FFC400)",
    "color.border.success": "var(--ds-border-success, #00875A)",
    "color.border.discovery": "var(--ds-border-discovery, #998DD9)",
    "color.border.information": "var(--ds-border-information, #0065FF)",
    "color.border.bold": "var(--ds-border-bold, #344563)"
};
var $6374a8c7bd915319$export$d1d79bf68ac056bd = {
    "color.background.accent.lime.subtlest": "var(--ds-background-accent-lime-subtlest, #EEFBDA)",
    "color.background.accent.lime.subtlest.hovered": "var(--ds-background-accent-lime-subtlest-hovered, #D3F1A7)",
    "color.background.accent.lime.subtlest.pressed": "var(--ds-background-accent-lime-subtlest-pressed, #B3DF72)",
    "color.background.accent.lime.subtler": "var(--ds-background-accent-lime-subtler, #D3F1A7)",
    "color.background.accent.lime.subtler.hovered": "var(--ds-background-accent-lime-subtler-hovered, #B3DF72)",
    "color.background.accent.lime.subtler.pressed": "var(--ds-background-accent-lime-subtler-pressed, #94C748)",
    "color.background.accent.lime.subtle": "var(--ds-background-accent-lime-subtle, #94C748)",
    "color.background.accent.lime.subtle.hovered": "var(--ds-background-accent-lime-subtle-hovered, #B3DF72)",
    "color.background.accent.lime.subtle.pressed": "var(--ds-background-accent-lime-subtle-pressed, #D3F1A7)",
    "color.background.accent.lime.bolder": "var(--ds-background-accent-lime-bolder, #5B7F24)",
    "color.background.accent.lime.bolder.hovered": "var(--ds-background-accent-lime-bolder-hovered, #37471F)",
    "color.background.accent.lime.bolder.pressed": "var(--ds-background-accent-lime-bolder-pressed, #37471F)",
    "color.background.accent.red.subtlest": "var(--ds-background-accent-red-subtlest, #FF8F73)",
    "color.background.accent.red.subtlest.hovered": "var(--ds-background-accent-red-subtlest-hovered, #FF7452)",
    "color.background.accent.red.subtlest.pressed": "var(--ds-background-accent-red-subtlest-pressed, #FF5630)",
    "color.background.accent.red.subtler": "var(--ds-background-accent-red-subtler, #FF7452)",
    "color.background.accent.red.subtler.hovered": "var(--ds-background-accent-red-subtler-hovered, #FF5630)",
    "color.background.accent.red.subtler.pressed": "var(--ds-background-accent-red-subtler-pressed, #DE350B)",
    "color.background.accent.red.subtle": "var(--ds-background-accent-red-subtle, #DE350B)",
    "color.background.accent.red.subtle.hovered": "var(--ds-background-accent-red-subtle-hovered, #FF5630)",
    "color.background.accent.red.subtle.pressed": "var(--ds-background-accent-red-subtle-pressed, #FF7452)",
    "color.background.accent.red.bolder": "var(--ds-background-accent-red-bolder, #DE350B)",
    "color.background.accent.red.bolder.hovered": "var(--ds-background-accent-red-bolder-hovered, #FF5630)",
    "color.background.accent.red.bolder.pressed": "var(--ds-background-accent-red-bolder-pressed, #FF7452)",
    "color.background.accent.orange.subtlest": "var(--ds-background-accent-orange-subtlest, #F18D13)",
    "color.background.accent.orange.subtlest.hovered": "var(--ds-background-accent-orange-subtlest-hovered, #FEC57B)",
    "color.background.accent.orange.subtlest.pressed": "var(--ds-background-accent-orange-subtlest-pressed, #FFE2BD)",
    "color.background.accent.orange.subtler": "var(--ds-background-accent-orange-subtler, #B65C02)",
    "color.background.accent.orange.subtler.hovered": "var(--ds-background-accent-orange-subtler-hovered, #F18D13)",
    "color.background.accent.orange.subtler.pressed": "var(--ds-background-accent-orange-subtler-pressed, #FEC57B)",
    "color.background.accent.orange.subtle": "var(--ds-background-accent-orange-subtle, #5F3811)",
    "color.background.accent.orange.subtle.hovered": "var(--ds-background-accent-orange-subtle-hovered, #974F0C)",
    "color.background.accent.orange.subtle.pressed": "var(--ds-background-accent-orange-subtle-pressed, #B65C02)",
    "color.background.accent.orange.bolder": "var(--ds-background-accent-orange-bolder, #43290F)",
    "color.background.accent.orange.bolder.hovered": "var(--ds-background-accent-orange-bolder-hovered, #5F3811)",
    "color.background.accent.orange.bolder.pressed": "var(--ds-background-accent-orange-bolder-pressed, #974F0C)",
    "color.background.accent.yellow.subtlest": "var(--ds-background-accent-yellow-subtlest, #FFE380)",
    "color.background.accent.yellow.subtlest.hovered": "var(--ds-background-accent-yellow-subtlest-hovered, #FFC400)",
    "color.background.accent.yellow.subtlest.pressed": "var(--ds-background-accent-yellow-subtlest-pressed, #FFAB00)",
    "color.background.accent.yellow.subtler": "var(--ds-background-accent-yellow-subtler, #FFC400)",
    "color.background.accent.yellow.subtler.hovered": "var(--ds-background-accent-yellow-subtler-hovered, #FFAB00)",
    "color.background.accent.yellow.subtler.pressed": "var(--ds-background-accent-yellow-subtler-pressed, #FF991F)",
    "color.background.accent.yellow.subtle": "var(--ds-background-accent-yellow-subtle, #FF991F)",
    "color.background.accent.yellow.subtle.hovered": "var(--ds-background-accent-yellow-subtle-hovered, #FFAB00)",
    "color.background.accent.yellow.subtle.pressed": "var(--ds-background-accent-yellow-subtle-pressed, #FFC400)",
    "color.background.accent.yellow.bolder": "var(--ds-background-accent-yellow-bolder, #FF991F)",
    "color.background.accent.yellow.bolder.hovered": "var(--ds-background-accent-yellow-bolder-hovered, #FFAB00)",
    "color.background.accent.yellow.bolder.pressed": "var(--ds-background-accent-yellow-bolder-pressed, #FFC400)",
    "color.background.accent.green.subtlest": "var(--ds-background-accent-green-subtlest, #79F2C0)",
    "color.background.accent.green.subtlest.hovered": "var(--ds-background-accent-green-subtlest-hovered, #57D9A3)",
    "color.background.accent.green.subtlest.pressed": "var(--ds-background-accent-green-subtlest-pressed, #36B37E)",
    "color.background.accent.green.subtler": "var(--ds-background-accent-green-subtler, #57D9A3)",
    "color.background.accent.green.subtler.hovered": "var(--ds-background-accent-green-subtler-hovered, #36B37E)",
    "color.background.accent.green.subtler.pressed": "var(--ds-background-accent-green-subtler-pressed, #00875A)",
    "color.background.accent.green.subtle": "var(--ds-background-accent-green-subtle, #00875A)",
    "color.background.accent.green.subtle.hovered": "var(--ds-background-accent-green-subtle-hovered, #36B37E)",
    "color.background.accent.green.subtle.pressed": "var(--ds-background-accent-green-subtle-pressed, #57D9A3)",
    "color.background.accent.green.bolder": "var(--ds-background-accent-green-bolder, #00875A)",
    "color.background.accent.green.bolder.hovered": "var(--ds-background-accent-green-bolder-hovered, #36B37E)",
    "color.background.accent.green.bolder.pressed": "var(--ds-background-accent-green-bolder-pressed, #57D9A3)",
    "color.background.accent.teal.subtlest": "var(--ds-background-accent-teal-subtlest, #79E2F2)",
    "color.background.accent.teal.subtlest.hovered": "var(--ds-background-accent-teal-subtlest-hovered, #00C7E6)",
    "color.background.accent.teal.subtlest.pressed": "var(--ds-background-accent-teal-subtlest-pressed, #00B8D9)",
    "color.background.accent.teal.subtler": "var(--ds-background-accent-teal-subtler, #00C7E6)",
    "color.background.accent.teal.subtler.hovered": "var(--ds-background-accent-teal-subtler-hovered, #00B8D9)",
    "color.background.accent.teal.subtler.pressed": "var(--ds-background-accent-teal-subtler-pressed, #00A3BF)",
    "color.background.accent.teal.subtle": "var(--ds-background-accent-teal-subtle, #00A3BF)",
    "color.background.accent.teal.subtle.hovered": "var(--ds-background-accent-teal-subtle-hovered, #00B8D9)",
    "color.background.accent.teal.subtle.pressed": "var(--ds-background-accent-teal-subtle-pressed, #00C7E6)",
    "color.background.accent.teal.bolder": "var(--ds-background-accent-teal-bolder, #00A3BF)",
    "color.background.accent.teal.bolder.hovered": "var(--ds-background-accent-teal-bolder-hovered, #00B8D9)",
    "color.background.accent.teal.bolder.pressed": "var(--ds-background-accent-teal-bolder-pressed, #00C7E6)",
    "color.background.accent.blue.subtlest": "var(--ds-background-accent-blue-subtlest, #4C9AFF)",
    "color.background.accent.blue.subtlest.hovered": "var(--ds-background-accent-blue-subtlest-hovered, #2684FF)",
    "color.background.accent.blue.subtlest.pressed": "var(--ds-background-accent-blue-subtlest-pressed, #0065FF)",
    "color.background.accent.blue.subtler": "var(--ds-background-accent-blue-subtler, #2684FF)",
    "color.background.accent.blue.subtler.hovered": "var(--ds-background-accent-blue-subtler-hovered, #0065FF)",
    "color.background.accent.blue.subtler.pressed": "var(--ds-background-accent-blue-subtler-pressed, #0052CC)",
    "color.background.accent.blue.subtle": "var(--ds-background-accent-blue-subtle, #0052CC)",
    "color.background.accent.blue.subtle.hovered": "var(--ds-background-accent-blue-subtle-hovered, #0065FF)",
    "color.background.accent.blue.subtle.pressed": "var(--ds-background-accent-blue-subtle-pressed, #2684FF)",
    "color.background.accent.blue.bolder": "var(--ds-background-accent-blue-bolder, #0052CC)",
    "color.background.accent.blue.bolder.hovered": "var(--ds-background-accent-blue-bolder-hovered, #0065FF)",
    "color.background.accent.blue.bolder.pressed": "var(--ds-background-accent-blue-bolder-pressed, #2684FF)",
    "color.background.accent.purple.subtlest": "var(--ds-background-accent-purple-subtlest, #998DD9)",
    "color.background.accent.purple.subtlest.hovered": "var(--ds-background-accent-purple-subtlest-hovered, #8777D9)",
    "color.background.accent.purple.subtlest.pressed": "var(--ds-background-accent-purple-subtlest-pressed, #6554C0)",
    "color.background.accent.purple.subtler": "var(--ds-background-accent-purple-subtler, #8777D9)",
    "color.background.accent.purple.subtler.hovered": "var(--ds-background-accent-purple-subtler-hovered, #6554C0)",
    "color.background.accent.purple.subtler.pressed": "var(--ds-background-accent-purple-subtler-pressed, #5243AA)",
    "color.background.accent.purple.subtle": "var(--ds-background-accent-purple-subtle, #5243AA)",
    "color.background.accent.purple.subtle.hovered": "var(--ds-background-accent-purple-subtle-hovered, #6554C0)",
    "color.background.accent.purple.subtle.pressed": "var(--ds-background-accent-purple-subtle-pressed, #8777D9)",
    "color.background.accent.purple.bolder": "var(--ds-background-accent-purple-bolder, #5243AA)",
    "color.background.accent.purple.bolder.hovered": "var(--ds-background-accent-purple-bolder-hovered, #6554C0)",
    "color.background.accent.purple.bolder.pressed": "var(--ds-background-accent-purple-bolder-pressed, #8777D9)",
    "color.background.accent.magenta.subtlest": "var(--ds-background-accent-magenta-subtlest, #FFECF8)",
    "color.background.accent.magenta.subtlest.hovered": "var(--ds-background-accent-magenta-subtlest-hovered, #FDD0EC)",
    "color.background.accent.magenta.subtlest.pressed": "var(--ds-background-accent-magenta-subtlest-pressed, #F797D2)",
    "color.background.accent.magenta.subtler": "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
    "color.background.accent.magenta.subtler.hovered": "var(--ds-background-accent-magenta-subtler-hovered, #F797D2)",
    "color.background.accent.magenta.subtler.pressed": "var(--ds-background-accent-magenta-subtler-pressed, #E774BB)",
    "color.background.accent.magenta.subtle": "var(--ds-background-accent-magenta-subtle, #E774BB)",
    "color.background.accent.magenta.subtle.hovered": "var(--ds-background-accent-magenta-subtle-hovered, #F797D2)",
    "color.background.accent.magenta.subtle.pressed": "var(--ds-background-accent-magenta-subtle-pressed, #FDD0EC)",
    "color.background.accent.magenta.bolder": "var(--ds-background-accent-magenta-bolder, #AE4787)",
    "color.background.accent.magenta.bolder.hovered": "var(--ds-background-accent-magenta-bolder-hovered, #943D73)",
    "color.background.accent.magenta.bolder.pressed": "var(--ds-background-accent-magenta-bolder-pressed, #50253F)",
    "color.background.accent.gray.subtlest": "var(--ds-background-accent-gray-subtlest, #6B778C)",
    "color.background.accent.gray.subtlest.hovered": "var(--ds-background-accent-gray-subtlest-hovered, #5E6C84)",
    "color.background.accent.gray.subtlest.pressed": "var(--ds-background-accent-gray-subtlest-pressed, #505F79)",
    "color.background.accent.gray.subtler": "var(--ds-background-accent-gray-subtler, #5E6C84)",
    "color.background.accent.gray.subtler.hovered": "var(--ds-background-accent-gray-subtler-hovered, #505F79)",
    "color.background.accent.gray.subtler.pressed": "var(--ds-background-accent-gray-subtler-pressed, #42526E)",
    "color.background.accent.gray.subtle": "var(--ds-background-accent-gray-subtle, #505F79)",
    "color.background.accent.gray.subtle.hovered": "var(--ds-background-accent-gray-subtle-hovered, #5E6C84)",
    "color.background.accent.gray.subtle.pressed": "var(--ds-background-accent-gray-subtle-pressed, #6B778C)",
    "color.background.accent.gray.bolder": "var(--ds-background-accent-gray-bolder, #42526E)",
    "color.background.accent.gray.bolder.hovered": "var(--ds-background-accent-gray-bolder-hovered, #344563)",
    "color.background.accent.gray.bolder.pressed": "var(--ds-background-accent-gray-bolder-pressed, #253858)",
    "color.background.disabled": "var(--ds-background-disabled, #091e4289)",
    "color.background.input": "var(--ds-background-input, #FAFBFC)",
    "color.background.input.hovered": "var(--ds-background-input-hovered, #EBECF0)",
    "color.background.input.pressed": "var(--ds-background-input-pressed, #FFFFFF)",
    "color.background.inverse.subtle": "var(--ds-background-inverse-subtle, #00000029)",
    "color.background.inverse.subtle.hovered": "var(--ds-background-inverse-subtle-hovered, #0000003D)",
    "color.background.inverse.subtle.pressed": "var(--ds-background-inverse-subtle-pressed, #00000052)",
    "color.background.neutral": "var(--ds-background-neutral, #DFE1E6)",
    "color.background.neutral.hovered": "var(--ds-background-neutral-hovered, #091e4214)",
    "color.background.neutral.pressed": "var(--ds-background-neutral-pressed, #B3D4FF)",
    "color.background.neutral.subtle": "var(--ds-background-neutral-subtle, transparent)",
    "color.background.neutral.subtle.hovered": "var(--ds-background-neutral-subtle-hovered, #091e4214)",
    "color.background.neutral.subtle.pressed": "var(--ds-background-neutral-subtle-pressed, #B3D4FF)",
    "color.background.neutral.bold": "var(--ds-background-neutral-bold, #42526E)",
    "color.background.neutral.bold.hovered": "var(--ds-background-neutral-bold-hovered, #505F79)",
    "color.background.neutral.bold.pressed": "var(--ds-background-neutral-bold-pressed, #344563)",
    "color.background.selected": "var(--ds-background-selected, #DEEBFF)",
    "color.background.selected.hovered": "var(--ds-background-selected-hovered, #B3D4FF)",
    "color.background.selected.pressed": "var(--ds-background-selected-pressed, #4C9AFF)",
    "color.background.selected.bold": "var(--ds-background-selected-bold, #0052CC)",
    "color.background.selected.bold.hovered": "var(--ds-background-selected-bold-hovered, #2684FF)",
    "color.background.selected.bold.pressed": "var(--ds-background-selected-bold-pressed, #0052CC)",
    "color.background.brand.subtlest": "var(--ds-background-brand-subtlest, #B3D4FF)",
    "color.background.brand.subtlest.hovered": "var(--ds-background-brand-subtlest-hovered, #DEEBFF)",
    "color.background.brand.subtlest.pressed": "var(--ds-background-brand-subtlest-pressed, #4C9AFF)",
    "color.background.brand.bold": "var(--ds-background-brand-bold, #0052CC)",
    "color.background.brand.bold.hovered": "var(--ds-background-brand-bold-hovered, #0065FF)",
    "color.background.brand.bold.pressed": "var(--ds-background-brand-bold-pressed, #0747A6)",
    "color.background.brand.boldest": "var(--ds-background-brand-boldest, #0747A6)",
    "color.background.brand.boldest.hovered": "var(--ds-background-brand-boldest-hovered, #0052CC)",
    "color.background.brand.boldest.pressed": "var(--ds-background-brand-boldest-pressed, #0747A6)",
    "color.background.danger": "var(--ds-background-danger, #FFEBE6)",
    "color.background.danger.hovered": "var(--ds-background-danger-hovered, #FFBDAD)",
    "color.background.danger.pressed": "var(--ds-background-danger-pressed, #FF8F73)",
    "color.background.danger.bold": "var(--ds-background-danger-bold, #DE350B)",
    "color.background.danger.bold.hovered": "var(--ds-background-danger-bold-hovered, #FF5630)",
    "color.background.danger.bold.pressed": "var(--ds-background-danger-bold-pressed, #BF2600)",
    "color.background.warning": "var(--ds-background-warning, #FFFAE6)",
    "color.background.warning.hovered": "var(--ds-background-warning-hovered, #FFF0B3)",
    "color.background.warning.pressed": "var(--ds-background-warning-pressed, #FFE380)",
    "color.background.warning.bold": "var(--ds-background-warning-bold, #FFAB00)",
    "color.background.warning.bold.hovered": "var(--ds-background-warning-bold-hovered, #FFC400)",
    "color.background.warning.bold.pressed": "var(--ds-background-warning-bold-pressed, #FF991F)",
    "color.background.success": "var(--ds-background-success, #E3FCEF)",
    "color.background.success.hovered": "var(--ds-background-success-hovered, #ABF5D1)",
    "color.background.success.pressed": "var(--ds-background-success-pressed, #79F2C0)",
    "color.background.success.bold": "var(--ds-background-success-bold, #00875A)",
    "color.background.success.bold.hovered": "var(--ds-background-success-bold-hovered, #57D9A3)",
    "color.background.success.bold.pressed": "var(--ds-background-success-bold-pressed, #00875A)",
    "color.background.discovery": "var(--ds-background-discovery, #EAE6FF)",
    "color.background.discovery.hovered": "var(--ds-background-discovery-hovered, #C0B6F2)",
    "color.background.discovery.pressed": "var(--ds-background-discovery-pressed, #998DD9)",
    "color.background.discovery.bold": "var(--ds-background-discovery-bold, #5243AA)",
    "color.background.discovery.bold.hovered": "var(--ds-background-discovery-bold-hovered, #8777D9)",
    "color.background.discovery.bold.pressed": "var(--ds-background-discovery-bold-pressed, #5243AA)",
    "color.background.information": "var(--ds-background-information, #DEEBFF)",
    "color.background.information.hovered": "var(--ds-background-information-hovered, #B3D4FF)",
    "color.background.information.pressed": "var(--ds-background-information-pressed, #4C9AFF)",
    "color.background.information.bold": "var(--ds-background-information-bold, #0052CC)",
    "color.background.information.bold.hovered": "var(--ds-background-information-bold-hovered, #2684FF)",
    "color.background.information.bold.pressed": "var(--ds-background-information-bold-pressed, #0052CC)",
    "color.blanket": "var(--ds-blanket, #091e4289)",
    "color.blanket.selected": "var(--ds-blanket-selected, #388BFF14)",
    "color.blanket.danger": "var(--ds-blanket-danger, #EF5C4814)",
    "color.skeleton": "var(--ds-skeleton, #F4F5F7)",
    "color.skeleton.subtle": "var(--ds-skeleton-subtle, #091e420a)",
    "elevation.surface": "var(--ds-surface, #FFFFFF)",
    "elevation.surface.hovered": "var(--ds-surface-hovered, #FAFBFC)",
    "elevation.surface.pressed": "var(--ds-surface-pressed, #F4F5F7)",
    "elevation.surface.overlay": "var(--ds-surface-overlay, #FFFFFF)",
    "elevation.surface.overlay.hovered": "var(--ds-surface-overlay-hovered, #FAFBFC)",
    "elevation.surface.overlay.pressed": "var(--ds-surface-overlay-pressed, #F4F5F7)",
    "elevation.surface.raised": "var(--ds-surface-raised, #FFFFFF)",
    "elevation.surface.raised.hovered": "var(--ds-surface-raised-hovered, #FAFBFC)",
    "elevation.surface.raised.pressed": "var(--ds-surface-raised-pressed, #F4F5F7)",
    "elevation.surface.sunken": "var(--ds-surface-sunken, #F4F5F7)",
    "utility.elevation.surface.current": "var(--ds-elevation-surface-current, #FFFFFF)"
};
var $6374a8c7bd915319$export$8473307aa00d6ea1 = {
    "color.text": "var(--ds-text, #172B4D)",
    "color.text.accent.lime": "var(--ds-text-accent-lime, #4C6B1F)",
    "color.text.accent.lime.bolder": "var(--ds-text-accent-lime-bolder, #37471F)",
    "color.text.accent.red": "var(--ds-text-accent-red, #DE350B)",
    "color.text.accent.red.bolder": "var(--ds-text-accent-red-bolder, #BF2600)",
    "color.text.accent.orange": "var(--ds-text-accent-orange, #F18D13)",
    "color.text.accent.orange.bolder": "var(--ds-text-accent-orange-bolder, #B65C02)",
    "color.text.accent.yellow": "var(--ds-text-accent-yellow, #FF991F)",
    "color.text.accent.yellow.bolder": "var(--ds-text-accent-yellow-bolder, #FF8B00)",
    "color.text.accent.green": "var(--ds-text-accent-green, #00875A)",
    "color.text.accent.green.bolder": "var(--ds-text-accent-green-bolder, #006644)",
    "color.text.accent.teal": "var(--ds-text-accent-teal, #00A3BF)",
    "color.text.accent.teal.bolder": "var(--ds-text-accent-teal-bolder, #008DA6)",
    "color.text.accent.blue": "var(--ds-text-accent-blue, #0052CC)",
    "color.text.accent.blue.bolder": "var(--ds-text-accent-blue-bolder, #0747A6)",
    "color.text.accent.purple": "var(--ds-text-accent-purple, #5243AA)",
    "color.text.accent.purple.bolder": "var(--ds-text-accent-purple-bolder, #403294)",
    "color.text.accent.magenta": "var(--ds-text-accent-magenta, #E774BB)",
    "color.text.accent.magenta.bolder": "var(--ds-text-accent-magenta-bolder, #DA62AC)",
    "color.text.accent.gray": "var(--ds-text-accent-gray, #505F79)",
    "color.text.accent.gray.bolder": "var(--ds-text-accent-gray-bolder, #172B4D)",
    "color.text.disabled": "var(--ds-text-disabled, #A5ADBA)",
    "color.text.inverse": "var(--ds-text-inverse, #FFFFFF)",
    "color.text.selected": "var(--ds-text-selected, #0052CC)",
    "color.text.brand": "var(--ds-text-brand, #0065FF)",
    "color.text.danger": "var(--ds-text-danger, #DE350B)",
    "color.text.warning": "var(--ds-text-warning, #974F0C)",
    "color.text.warning.inverse": "var(--ds-text-warning-inverse, #172B4D)",
    "color.text.success": "var(--ds-text-success, #006644)",
    "color.text.discovery": "var(--ds-text-discovery, #403294)",
    "color.text.information": "var(--ds-text-information, #0052CC)",
    "color.text.subtlest": "var(--ds-text-subtlest, #7A869A)",
    "color.text.subtle": "var(--ds-text-subtle, #42526E)",
    "color.link": "var(--ds-link, #0052CC)",
    "color.link.pressed": "var(--ds-link-pressed, #0747A6)",
    "color.link.visited": "var(--ds-link-visited, #403294)",
    "color.link.visited.pressed": "var(--ds-link-visited-pressed, #403294)"
};
var $6374a8c7bd915319$export$498780f74be9af68 = {
    "color.icon": "var(--ds-icon, #505F79)",
    "color.icon.accent.lime": "var(--ds-icon-accent-lime, #6A9A23)",
    "color.icon.accent.red": "var(--ds-icon-accent-red, #FF5630)",
    "color.icon.accent.orange": "var(--ds-icon-accent-orange, #D94008)",
    "color.icon.accent.yellow": "var(--ds-icon-accent-yellow, #FFAB00)",
    "color.icon.accent.green": "var(--ds-icon-accent-green, #36B37E)",
    "color.icon.accent.teal": "var(--ds-icon-accent-teal, #00B8D9)",
    "color.icon.accent.blue": "var(--ds-icon-accent-blue, #0065FF)",
    "color.icon.accent.purple": "var(--ds-icon-accent-purple, #6554C0)",
    "color.icon.accent.magenta": "var(--ds-icon-accent-magenta, #CD519D)",
    "color.icon.accent.gray": "var(--ds-icon-accent-gray, #5E6C84)",
    "color.icon.disabled": "var(--ds-icon-disabled, #8993A4)",
    "color.icon.inverse": "var(--ds-icon-inverse, #FFFFFF)",
    "color.icon.selected": "var(--ds-icon-selected, #0052CC)",
    "color.icon.brand": "var(--ds-icon-brand, #0065FF)",
    "color.icon.danger": "var(--ds-icon-danger, #DE350B)",
    "color.icon.warning": "var(--ds-icon-warning, #FFC400)",
    "color.icon.warning.inverse": "var(--ds-icon-warning-inverse, #253858)",
    "color.icon.success": "var(--ds-icon-success, #00875A)",
    "color.icon.discovery": "var(--ds-icon-discovery, #8777D9)",
    "color.icon.information": "var(--ds-icon-information, #0747A6)",
    "color.icon.subtle": "var(--ds-icon-subtle, #6B778C)"
};
var $6374a8c7bd915319$export$b5f31a7e431d2eab = {
    "1": 1,
    card: 100,
    navigation: 200,
    dialog: 300,
    layer: 400,
    blanket: 500,
    modal: 510,
    flag: 600,
    spotlight: 700,
    tooltip: 800
};
var $6374a8c7bd915319$export$e1b83c5210c471b8 = {
    "border.width": "var(--ds-border-width, 1px)",
    "border.width.0": "var(--ds-border-width-0, 0px)",
    "border.width.indicator": "var(--ds-border-width-indicator, 3px)",
    "border.width.outline": "var(--ds-border-width-outline, 2px)"
};
var $6374a8c7bd915319$export$3c0a6c3e64bb180d = {
    "border.radius.050": "var(--ds-border-radius-050, 2px)",
    "border.radius": "var(--ds-border-radius, 3px)",
    "border.radius.100": "var(--ds-border-radius-100, 3px)",
    "border.radius.200": "var(--ds-border-radius-200, 8px)",
    "border.radius.300": "var(--ds-border-radius-300, 12px)",
    "border.radius.400": "var(--ds-border-radius-400, 16px)",
    "border.radius.circle": "var(--ds-border-radius-circle, 32032px)"
};
var $6374a8c7bd915319$export$6ffa317d5e70375 = {
    "font.body": 'var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.body.UNSAFE_small": 'var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.body.large": 'var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.body.small": 'var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.code": 'var(--ds-font-code, normal 400 0.875em/1 ui-monospace, Menlo, "Segoe UI Mono", "Ubuntu Mono", monospace)',
    "font.heading.large": 'var(--ds-font-heading-large, normal 500 24px/28px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.heading.medium": 'var(--ds-font-heading-medium, normal 500 20px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.heading.small": 'var(--ds-font-heading-small, normal 600 16px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.heading.xlarge": 'var(--ds-font-heading-xlarge, normal 600 29px/32px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.heading.xsmall": 'var(--ds-font-heading-xsmall, normal 600 14px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.heading.xxlarge": 'var(--ds-font-heading-xxlarge, normal 500 35px/40px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.heading.xxsmall": 'var(--ds-font-heading-xxsmall, normal 600 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)'
};
var $6374a8c7bd915319$export$303e322c6b1ed114 = {
    "font.weight.bold": "var(--ds-font-weight-bold, 700)",
    "font.weight.medium": "var(--ds-font-weight-medium, 500)",
    "font.weight.regular": "var(--ds-font-weight-regular, 400)",
    "font.weight.semibold": "var(--ds-font-weight-semibold, 600)"
};
var $6374a8c7bd915319$export$3c7e9587132614b4 = {
    "font.family.body": 'var(--ds-font-family-body, ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.family.brand.body": 'var(--ds-font-family-brand-body, "Charlie Text", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.family.brand.heading": 'var(--ds-font-family-brand-heading, "Charlie Display", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.family.code": 'var(--ds-font-family-code, ui-monospace, Menlo, "Segoe UI Mono", "Ubuntu Mono", monospace)',
    "font.family.heading": 'var(--ds-font-family-heading, ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)'
};
var $6374a8c7bd915319$export$236bfe3a33ef1292 = {
    medium: 'var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    UNSAFE_small: 'var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    large: 'var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    small: 'var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)'
};
var $6374a8c7bd915319$export$855cfd311192d666 = {
    bold: "var(--ds-font-weight-bold, 700)",
    medium: "var(--ds-font-weight-medium, 500)",
    regular: "var(--ds-font-weight-regular, 400)",
    semibold: "var(--ds-font-weight-semibold, 600)"
};
/**
 * @codegenEnd
 */ // Margin needs some bespoke types: https://atlassian.slack.com/archives/CKRHB23K8/p1712623192772909
// Generate maps for Box props. backgroundColor, padding, etc
var $6374a8c7bd915319$var$spacingProperties = [
    // Used by Box
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    // Used by Inline and Stack
    "gap",
    "rowGap",
    "columnGap"
];
var $6374a8c7bd915319$export$ca0f9c2de39ffed7 = function getSerializedStylesMap(cssProperty, tokenMap) {
    return Object.keys(tokenMap).reduce(function(emotionSpacingMap, token) {
        // eslint-disable-next-line @repo/internal/styles/no-exported-styles
        emotionSpacingMap[token] = (0, $jVTBW.css)((0, (/*@__PURE__*/$parcel$interopDefault($c6l2j)))({}, cssProperty, tokenMap[token]));
        return emotionSpacingMap;
    }, {});
};
var $6374a8c7bd915319$export$e615f061ca585a6c = $6374a8c7bd915319$var$spacingProperties.reduce(function(styleMap, spacingProperty) {
    styleMap[spacingProperty] = $6374a8c7bd915319$export$ca0f9c2de39ffed7(spacingProperty, $6374a8c7bd915319$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
var $6374a8c7bd915319$export$bf46c3f9eeafc71f = $6374a8c7bd915319$var$spacingProperties.reduce(function(styleMap, spacingProperty) {
    styleMap[spacingProperty] = $6374a8c7bd915319$export$ca0f9c2de39ffed7(spacingProperty, $6374a8c7bd915319$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
var $6374a8c7bd915319$export$e7af83bafe7f9e63 = $6374a8c7bd915319$export$ca0f9c2de39ffed7("backgroundColor", $6374a8c7bd915319$export$d1d79bf68ac056bd);
var $6374a8c7bd915319$export$3a1bcba60b23d7f0 = $6374a8c7bd915319$export$ca0f9c2de39ffed7("color", $6374a8c7bd915319$export$8473307aa00d6ea1);
var $6374a8c7bd915319$export$45f3f4fe16f9f7d5 = $6374a8c7bd915319$export$ca0f9c2de39ffed7("fontWeight", $6374a8c7bd915319$export$303e322c6b1ed114);
var $6374a8c7bd915319$export$68cc305da27dbaa4 = $6374a8c7bd915319$export$ca0f9c2de39ffed7("fontFamily", $6374a8c7bd915319$export$3c7e9587132614b4);
var $6374a8c7bd915319$export$128f10c238242f83 = $6374a8c7bd915319$export$ca0f9c2de39ffed7("font", $6374a8c7bd915319$export$6ffa317d5e70375);
var $6374a8c7bd915319$export$219d364c0da35ae4 = $6374a8c7bd915319$export$ca0f9c2de39ffed7("font", $6374a8c7bd915319$export$236bfe3a33ef1292);
var $6374a8c7bd915319$export$38845ca010b93505 = $6374a8c7bd915319$export$ca0f9c2de39ffed7("fontWeight", $6374a8c7bd915319$export$855cfd311192d666);
var $6374a8c7bd915319$export$ff257d957d48c421 = $6374a8c7bd915319$export$ca0f9c2de39ffed7((0, $3BXIB.CURRENT_SURFACE_CSS_VAR), $6374a8c7bd915319$export$41a358c9c2356760);
var $6374a8c7bd915319$export$5e65a44e5b6ecadb = function isSurfaceColorToken(color) {
    return $6374a8c7bd915319$export$41a358c9c2356760[color] !== undefined;
};

});
parcelRegister("3BXIB", function(module, exports) {

$parcel$export(module.exports, "CURRENT_SURFACE_CSS_VAR", function () { return $2a1326a1f8be5c1a$export$9d7b58831ae93caa; });
var $2a1326a1f8be5c1a$export$4ef52930e33717cd = "data-theme";
var $2a1326a1f8be5c1a$export$a00eac3f8684bcd0 = "data-color-mode";
var $2a1326a1f8be5c1a$export$2112803007239c61 = "data-contrast-mode";
var $2a1326a1f8be5c1a$export$352e418ed5b6193a = "data-custom-theme";
var $2a1326a1f8be5c1a$export$2faeed762aac6741 = "light";
var $2a1326a1f8be5c1a$export$6f0c6fb8c80fcc92 = "ds";
var $2a1326a1f8be5c1a$export$4d0c7bbf80185957 = [
    "opacity",
    "font",
    "space",
    "border"
];
var $2a1326a1f8be5c1a$export$dddac1532e822863 = "--".concat($2a1326a1f8be5c1a$export$6f0c6fb8c80fcc92, "-token-not-found");
var $2a1326a1f8be5c1a$export$9d7b58831ae93caa = "--".concat($2a1326a1f8be5c1a$export$6f0c6fb8c80fcc92, "-elevation-surface-current");

});


parcelRegister("aDEaV", function(module, exports) {

$parcel$export(module.exports, "parseXcss", function () { return $7becb5e0086519a2$export$a9c84988c8f81f2d; });
$parcel$export(module.exports, "xcss", function () { return $7becb5e0086519a2$export$f6c783d06584602c; });

var $9OmEa = parcelRequire("9OmEa");

var $c6l2j = parcelRequire("c6l2j");

var $kC8H4 = parcelRequire("kC8H4");

var $b5I6c = parcelRequire("b5I6c");

var $jVTBW = parcelRequire("jVTBW");

var $8xoOY = parcelRequire("8xoOY");

var $ahJoN = parcelRequire("ahJoN");
function $7becb5e0086519a2$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $7becb5e0086519a2$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $7becb5e0086519a2$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $7becb5e0086519a2$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $7becb5e0086519a2$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $7becb5e0086519a2$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
var $7becb5e0086519a2$export$9a199fbafee0014e = {
    backgroundColor: (0, $8xoOY.backgroundColorMap),
    blockSize: (0, $8xoOY.dimensionMap),
    borderBlockColor: (0, $8xoOY.borderColorMap),
    borderBlockEndColor: (0, $8xoOY.borderColorMap),
    borderBlockEndWidth: (0, $8xoOY.borderWidthMap),
    borderBlockStartColor: (0, $8xoOY.borderColorMap),
    borderBlockStartWidth: (0, $8xoOY.borderWidthMap),
    borderBlockWidth: (0, $8xoOY.borderWidthMap),
    borderBottomColor: (0, $8xoOY.borderColorMap),
    borderBottomLeftRadius: (0, $8xoOY.borderRadiusMap),
    borderBottomRightRadius: (0, $8xoOY.borderRadiusMap),
    borderBottomWidth: (0, $8xoOY.borderWidthMap),
    borderColor: (0, $8xoOY.borderColorMap),
    borderEndEndRadius: (0, $8xoOY.borderRadiusMap),
    borderEndStartRadius: (0, $8xoOY.borderRadiusMap),
    borderInlineColor: (0, $8xoOY.borderColorMap),
    borderInlineEndColor: (0, $8xoOY.borderColorMap),
    borderInlineEndWidth: (0, $8xoOY.borderWidthMap),
    borderInlineStartColor: (0, $8xoOY.borderColorMap),
    borderInlineStartWidth: (0, $8xoOY.borderWidthMap),
    borderInlineWidth: (0, $8xoOY.borderWidthMap),
    borderLeftColor: (0, $8xoOY.borderColorMap),
    borderLeftWidth: (0, $8xoOY.borderWidthMap),
    borderRadius: (0, $8xoOY.borderRadiusMap),
    borderRightColor: (0, $8xoOY.borderColorMap),
    borderRightWidth: (0, $8xoOY.borderWidthMap),
    borderStartEndRadius: (0, $8xoOY.borderRadiusMap),
    borderStartStartRadius: (0, $8xoOY.borderRadiusMap),
    borderTopColor: (0, $8xoOY.borderColorMap),
    borderTopLeftRadius: (0, $8xoOY.borderRadiusMap),
    borderTopRightRadius: (0, $8xoOY.borderRadiusMap),
    borderTopWidth: (0, $8xoOY.borderWidthMap),
    borderWidth: (0, $8xoOY.borderWidthMap),
    bottom: (0, $8xoOY.allSpaceMap),
    boxShadow: (0, $8xoOY.shadowMap),
    color: (0, $8xoOY.textColorMap),
    columnGap: (0, $8xoOY.positiveSpaceMap),
    font: (0, $8xoOY.fontMap),
    fontFamily: (0, $8xoOY.fontFamilyMap),
    fontWeight: (0, $8xoOY.fontWeightMap),
    gap: (0, $8xoOY.positiveSpaceMap),
    height: (0, $8xoOY.dimensionMap),
    inlineSize: (0, $8xoOY.dimensionMap),
    inset: (0, $8xoOY.allSpaceMap),
    insetBlock: (0, $8xoOY.allSpaceMap),
    insetBlockEnd: (0, $8xoOY.allSpaceMap),
    insetBlockStart: (0, $8xoOY.allSpaceMap),
    insetInline: (0, $8xoOY.allSpaceMap),
    insetInlineEnd: (0, $8xoOY.allSpaceMap),
    insetInlineStart: (0, $8xoOY.allSpaceMap),
    left: (0, $8xoOY.allSpaceMap),
    margin: (0, $8xoOY.allSpaceMap),
    marginBlock: (0, $8xoOY.allSpaceMap),
    marginBlockEnd: (0, $8xoOY.allSpaceMap),
    marginBlockStart: (0, $8xoOY.allSpaceMap),
    marginBottom: (0, $8xoOY.allSpaceMap),
    marginInline: (0, $8xoOY.allSpaceMap),
    marginInlineEnd: (0, $8xoOY.allSpaceMap),
    marginInlineStart: (0, $8xoOY.allSpaceMap),
    marginLeft: (0, $8xoOY.allSpaceMap),
    marginRight: (0, $8xoOY.allSpaceMap),
    marginTop: (0, $8xoOY.allSpaceMap),
    maxBlockSize: (0, $8xoOY.dimensionMap),
    maxHeight: (0, $8xoOY.dimensionMap),
    maxInlineSize: (0, $8xoOY.dimensionMap),
    maxWidth: (0, $8xoOY.dimensionMap),
    minBlockSize: (0, $8xoOY.dimensionMap),
    minHeight: (0, $8xoOY.dimensionMap),
    minInlineSize: (0, $8xoOY.dimensionMap),
    minWidth: (0, $8xoOY.dimensionMap),
    opacity: (0, $8xoOY.opacityMap),
    outlineColor: (0, $8xoOY.borderColorMap),
    outlineOffset: (0, $8xoOY.positiveSpaceMap),
    outlineWidth: (0, $8xoOY.borderWidthMap),
    padding: (0, $8xoOY.positiveSpaceMap),
    paddingBlock: (0, $8xoOY.positiveSpaceMap),
    paddingBlockEnd: (0, $8xoOY.positiveSpaceMap),
    paddingBlockStart: (0, $8xoOY.positiveSpaceMap),
    paddingBottom: (0, $8xoOY.positiveSpaceMap),
    paddingInline: (0, $8xoOY.positiveSpaceMap),
    paddingInlineEnd: (0, $8xoOY.positiveSpaceMap),
    paddingInlineStart: (0, $8xoOY.positiveSpaceMap),
    paddingLeft: (0, $8xoOY.positiveSpaceMap),
    paddingRight: (0, $8xoOY.positiveSpaceMap),
    paddingTop: (0, $8xoOY.positiveSpaceMap),
    right: (0, $8xoOY.allSpaceMap),
    rowGap: (0, $8xoOY.positiveSpaceMap),
    top: (0, $8xoOY.allSpaceMap),
    width: (0, $8xoOY.dimensionMap),
    zIndex: (0, $8xoOY.layerMap)
};
var $7becb5e0086519a2$var$uniqueSymbol = Symbol("UNSAFE_INTERNAL_styles");
var $7becb5e0086519a2$var$isSafeEnvToThrow = function isSafeEnvToThrow() {
    return (typeof $ahJoN === "undefined" ? "undefined" : (0, (/*@__PURE__*/$parcel$interopDefault($b5I6c)))($ahJoN)) === "object" && (0, (/*@__PURE__*/$parcel$interopDefault($b5I6c)))($ahJoN.env) === "object" && false;
};
var $7becb5e0086519a2$var$reNestedSelectors = /(\.|\s|&+|\*\>|#|\[.*\])/;
var $7becb5e0086519a2$var$safeSelectors = /^@media .*$|^::?.*$|^@supports .*$/;
var $7becb5e0086519a2$var$_transformStyles = function transformStyles(styleObj) {
    if (!styleObj || (0, (/*@__PURE__*/$parcel$interopDefault($b5I6c)))(styleObj) !== "object") return styleObj;
    // If styles are defined as a CSSObject[], recursively call on each element until we reach CSSObject
    if (Array.isArray(styleObj)) return styleObj.map($7becb5e0086519a2$var$_transformStyles);
    // Modifies styleObj in place. Be careful.
    Object.entries(styleObj).forEach(function(_ref) {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($kC8H4)))(_ref, 2), key = _ref2[0], value = _ref2[1];
        // If key is a pseudo class or a pseudo element, then value should be an object.
        // So, call transformStyles on the value
        if ((0, (/*@__PURE__*/$parcel$interopDefault($b5I6c)))(value) === "object" && $7becb5e0086519a2$var$safeSelectors.test(key)) {
            styleObj[key] = $7becb5e0086519a2$var$_transformStyles(value);
            return;
        }
        if ($7becb5e0086519a2$var$isSafeEnvToThrow()) {
            // We don't support `.class`, `[data-testid]`, `> *`, `#some-id`
            if ($7becb5e0086519a2$var$reNestedSelectors.test(key)) throw new Error("Styles not supported for key '".concat(key, "'."));
        }
        // We have now dealt with all the special cases, so,
        // check whether what remains is a style property
        // that can be transformed.
        if (!(key in $7becb5e0086519a2$export$9a199fbafee0014e)) return;
        var tokenValue = $7becb5e0086519a2$export$9a199fbafee0014e[key][value];
        styleObj[key] = tokenValue !== null && tokenValue !== void 0 ? tokenValue : value;
    });
    return styleObj;
};
var $7becb5e0086519a2$var$baseXcss = function baseXcss(style) {
    var transformedStyles = $7becb5e0086519a2$var$_transformStyles(style);
    return (0, (/*@__PURE__*/$parcel$interopDefault($c6l2j)))({}, $7becb5e0086519a2$var$uniqueSymbol, (0, $jVTBW.css)(transformedStyles));
};
/**
 * Picks out runtime XCSS objects and build-time XCSS strings. This is needed
 * to supported both Emotion and Compiled styles until we've fully migrated
 * to Compiled.
 *
 * @private
 * @deprecated
 */ var $7becb5e0086519a2$export$a9c84988c8f81f2d = function parseXcss(args) {
    if (Array.isArray(args)) {
        var emotion = [];
        var staticArr = [];
        var _iterator = $7becb5e0086519a2$var$_createForOfIteratorHelper(args), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var arg = _step.value;
                var result = $7becb5e0086519a2$export$a9c84988c8f81f2d(arg);
                if (result.emotion) emotion.push.apply(emotion, (0, (/*@__PURE__*/$parcel$interopDefault($9OmEa)))(result.emotion));
                if (result.static) staticArr.push(result.static);
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        return {
            emotion: emotion,
            static: staticArr.join(" ")
        };
    }
    var objArgs = args;
    var _ref4 = objArgs || {}, styles = _ref4[$7becb5e0086519a2$var$uniqueSymbol];
    if (styles) return {
        emotion: [
            styles
        ]
    };
    if (args) {
        // We use string interpolation here instead of .toString() just
        // in case the resulting object doesn't have the method available.
        var stringifiedArgs = "".concat(args);
        if (stringifiedArgs) return {
            static: stringifiedArgs
        };
    }
    return {};
};
function $7becb5e0086519a2$export$f6c783d06584602c(style) {
    return $7becb5e0086519a2$var$baseXcss(style);
}

});


parcelRegister("bfbOM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $82fa4338d59d27a8$export$2e2bcd8739ae039; });

var $sN2rQ = parcelRequire("sN2rQ");

var $kC8H4 = parcelRequire("kC8H4");

var $c6l2j = parcelRequire("c6l2j");

var $dAx5m = parcelRequire("dAx5m");

var $dd4sf = parcelRequire("dd4sf");

var $6X4go = parcelRequire("6X4go");

var $bJzW6 = parcelRequire("bJzW6");

var $djC9A = parcelRequire("djC9A");

var $gsEbz = parcelRequire("gsEbz");

var $29qVV = parcelRequire("29qVV");

var $ggwTM = parcelRequire("ggwTM");
var $62E0k = parcelRequire("62E0k");

var $7SQ8g = parcelRequire("7SQ8g");

var $iWhPr = parcelRequire("iWhPr");

var $jzVTV = parcelRequire("jzVTV");

var $ZzBpf = parcelRequire("ZzBpf");

var $91qPF = parcelRequire("91qPF");

var $BAnnF = parcelRequire("BAnnF");

var $7X0HR = parcelRequire("7X0HR");

var $jlH72 = parcelRequire("jlH72");
function $82fa4338d59d27a8$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $82fa4338d59d27a8$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $82fa4338d59d27a8$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($c6l2j)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $82fa4338d59d27a8$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $82fa4338d59d27a8$var$tooltipZIndex = (0, $jzVTV.layers).tooltip();
var $82fa4338d59d27a8$var$analyticsAttributes = {
    componentName: "tooltip",
    packageName: "@atlaskit/tooltip",
    packageVersion: "20.0.2"
};
// Inverts motion direction
var $82fa4338d59d27a8$var$invertedDirection = {
    top: "bottom",
    bottom: "top",
    left: "right",
    right: "left"
};
/**
 * Converts a Popper placement to it's general direction.
 *
 * @param placement - Popper Placement value, e.g. 'top-start'
 * @returns Popper Direction, e.g. 'top'
 */ var $82fa4338d59d27a8$var$getDirectionFromPlacement = function getDirectionFromPlacement(placement) {
    return placement.split("-")[0];
};
/**
 * __Tooltip__
 *
 * A tooltip is a floating, non-actionable label used to explain a user interface element or feature.
 */ function $82fa4338d59d27a8$var$Tooltip(_ref) {
    var children = _ref.children, _ref$position = _ref.position, position = _ref$position === void 0 ? "bottom" : _ref$position, _ref$mousePosition = _ref.mousePosition, mousePosition = _ref$mousePosition === void 0 ? "bottom" : _ref$mousePosition, content = _ref.content, _ref$truncate = _ref.truncate, truncate = _ref$truncate === void 0 ? false : _ref$truncate, _ref$component = _ref.component, Container = _ref$component === void 0 ? (0, $7X0HR.default) : _ref$component, _ref$tag = _ref.tag, TargetContainer = _ref$tag === void 0 ? "div" : _ref$tag, testId = _ref.testId, _ref$delay = _ref.delay, delay = _ref$delay === void 0 ? 300 : _ref$delay, _ref$onShow = _ref.onShow, onShow = _ref$onShow === void 0 ? (0, $bJzW6.default) : _ref$onShow, _ref$onHide = _ref.onHide, onHide = _ref$onHide === void 0 ? (0, $bJzW6.default) : _ref$onHide, canAppear = _ref.canAppear, _ref$hideTooltipOnCli = _ref.hideTooltipOnClick, hideTooltipOnClick = _ref$hideTooltipOnCli === void 0 ? false : _ref$hideTooltipOnCli, _ref$hideTooltipOnMou = _ref.hideTooltipOnMouseDown, hideTooltipOnMouseDown = _ref$hideTooltipOnMou === void 0 ? false : _ref$hideTooltipOnMou, analyticsContext = _ref.analyticsContext, _ref$strategy = _ref.strategy, strategy = _ref$strategy === void 0 ? "fixed" : _ref$strategy, _ref$ignoreTooltipPoi = _ref.ignoreTooltipPointerEvents, ignoreTooltipPointerEvents = _ref$ignoreTooltipPoi === void 0 ? false : _ref$ignoreTooltipPoi, _ref$isScreenReaderAn = _ref.isScreenReaderAnnouncementDisabled, isScreenReaderAnnouncementDisabled = _ref$isScreenReaderAn === void 0 ? false : _ref$isScreenReaderAn;
    var tooltipPosition = position === "mouse" ? mousePosition : position;
    var onShowHandler = (0, $6X4go.usePlatformLeafSyntheticEventHandler)($82fa4338d59d27a8$var$_objectSpread({
        fn: onShow,
        action: "displayed",
        analyticsData: analyticsContext
    }, $82fa4338d59d27a8$var$analyticsAttributes));
    var onHideHandler = (0, $6X4go.usePlatformLeafSyntheticEventHandler)($82fa4338d59d27a8$var$_objectSpread({
        fn: onHide,
        action: "hidden",
        analyticsData: analyticsContext
    }, $82fa4338d59d27a8$var$analyticsAttributes));
    var apiRef = (0, $dAx5m.useRef)(null);
    var _useState = (0, $dAx5m.useState)("hide"), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($kC8H4)))(_useState, 2), state = _useState2[0], setState = _useState2[1];
    var targetRef = (0, $dAx5m.useRef)(null);
    var containerRef = (0, $dAx5m.useRef)(null);
    // This function is deliberately _not_ memoized as it needs to re-run every render
    // to pick up any child ref changes. If you use render props you don't have this issue.
    var setImplicitRefFromChildren = function setImplicitRefFromChildren(node) {
        containerRef.current = node;
        targetRef.current = node ? node.firstElementChild : null;
    };
    // This is memoized and passed into the render props callback.
    var setDirectRef = (0, $dAx5m.useCallback)(function(node) {
        targetRef.current = node;
    }, []);
    // Putting a few things into refs so that we don't have to break memoization
    var stableState = (0, $gsEbz.default)(state);
    // These props are placed in separate refs instead of a single object to reduce memory usage.
    // Placing them in the same object previously caused an increase in the number of JavaScript event listeners
    // before garbage collection.
    var onShowHandlerStable = (0, $gsEbz.default)(onShowHandler);
    var onHideHandlerStable = (0, $gsEbz.default)(onHideHandler);
    var delayStable = (0, $gsEbz.default)(delay);
    var canAppearStable = (0, $gsEbz.default)(canAppear);
    var hasCalledShowHandler = (0, $dAx5m.useRef)(false);
    var start = (0, $dAx5m.useCallback)(function(api) {
        // @ts-ignore
        apiRef.current = api;
        hasCalledShowHandler.current = false;
    }, []);
    var done = (0, $dAx5m.useCallback)(function() {
        if (!apiRef.current) return;
        // Only call onHideHandler if we have called onShowHandler
        if (hasCalledShowHandler.current) onHideHandlerStable.current();
        // @ts-ignore
        apiRef.current = null;
        // @ts-ignore
        hasCalledShowHandler.current = false;
        // just in case
        setState("hide");
    }, [
        onHideHandlerStable
    ]);
    var abort = (0, $dAx5m.useCallback)(function() {
        if (!apiRef.current) return;
        apiRef.current.abort();
        // Only call onHideHandler if we have called onShowHandler
        if (hasCalledShowHandler.current) onHideHandlerStable.current();
        // @ts-ignore
        apiRef.current = null;
    }, [
        onHideHandlerStable
    ]);
    (0, $dAx5m.useEffect)(function mount() {
        return function unmount() {
            if (apiRef.current) abort();
        };
    }, [
        abort
    ]);
    var isDraggingRef = (0, $dAx5m.useRef)(false);
    (0, $dAx5m.useEffect)(function() {
        return (0, $ZzBpf.register)({
            onRegister: function onRegister(_ref2) {
                var isDragging = _ref2.isDragging;
                isDraggingRef.current = isDragging;
            },
            onDragStart: function onDragStart() {
                var _apiRef$current;
                /**
         * Hiding any visible tooltips when a drag starts because otherwise it
         * looks janky (disappears and reappears), and is not required.
         */ (_apiRef$current = apiRef.current) === null || _apiRef$current === void 0 || _apiRef$current.requestHide({
                    isImmediate: true
                });
                isDraggingRef.current = true;
            },
            onDragEnd: function onDragEnd() {
                isDraggingRef.current = false;
            }
        });
    }, []);
    var tryShowTooltip = (0, $dAx5m.useCallback)(function(source) {
        var _canAppearStable$curr;
        /**
     * Prevent tooltips from being shown during a drag. This can occur with
     * the native drag and drop API, where some pointer events can fire
     * when they should not and lead to jank with tooltips.
     */ if (isDraggingRef.current) return;
        // Another tooltip is has been active but we still have the old `api`
        // around. We need to finish up the last usage.
        // Note: just being safe - this should not happen
        if (apiRef.current && !apiRef.current.isActive()) abort();
        // This tooltip is already active, we can exit
        if (apiRef.current && apiRef.current.isActive()) {
            apiRef.current.keep();
            return;
        }
        /**
     * Check if tooltip is allowed to show.
     *
     * Once a tooltip has started, or has scheduled to start
     * we won't be checking `canAppear` again.
     *
     * - We don't want tooltips to disappear once they are shown
     * - For consistency, we start after a single positive `canAppear`.
     *   Otherwise the amount of times we ask consumers would depend on
     *   how many times we get a "mousemove", which _could_ lead to situations
     *   where moving the mouse could result in a different outcome to if
     *   the mouse was not moved.
     */ if (canAppearStable.current && !((_canAppearStable$curr = canAppearStable.current) !== null && _canAppearStable$curr !== void 0 && _canAppearStable$curr.call(canAppearStable))) return;
        var entry = {
            source: source,
            delay: delayStable.current,
            show: function show(_ref3) {
                var isImmediate = _ref3.isImmediate;
                // Call the onShow handler if it hasn't been called yet
                if (!hasCalledShowHandler.current) {
                    hasCalledShowHandler.current = true;
                    onShowHandlerStable.current();
                }
                setState(isImmediate ? "show-immediate" : "fade-in");
            },
            hide: function hide(_ref4) {
                var isImmediate = _ref4.isImmediate;
                if (isImmediate) setState("hide");
                else setState("before-fade-out");
            },
            done: done
        };
        var api = (0, $91qPF.show)(entry);
        start(api);
    }, [
        canAppearStable,
        delayStable,
        done,
        start,
        abort,
        onShowHandlerStable
    ]);
    var hideTooltipOnEsc = (0, $dAx5m.useCallback)(function() {
        var _apiRef$current2;
        (_apiRef$current2 = apiRef.current) === null || _apiRef$current2 === void 0 || _apiRef$current2.requestHide({
            isImmediate: true
        });
    }, [
        apiRef
    ]);
    (0, $djC9A.default)({
        onClose: hideTooltipOnEsc,
        isDisabled: state === "hide" || state === "fade-out"
    });
    (0, $dAx5m.useEffect)(function() {
        if (state === "hide") return 0, $bJzW6.default;
        if (state === "before-fade-out") setState("fade-out");
        var unbind = (0, $dd4sf.bind)(window, {
            type: "scroll",
            listener: function listener() {
                if (apiRef.current) apiRef.current.requestHide({
                    isImmediate: true
                });
            },
            options: {
                capture: true,
                passive: true,
                once: true
            }
        });
        return unbind;
    }, [
        state
    ]);
    var onMouseDown = (0, $dAx5m.useCallback)(function() {
        if (hideTooltipOnMouseDown && apiRef.current) apiRef.current.requestHide({
            isImmediate: true
        });
    }, [
        hideTooltipOnMouseDown
    ]);
    var onClick = (0, $dAx5m.useCallback)(function() {
        if (hideTooltipOnClick && apiRef.current) apiRef.current.requestHide({
            isImmediate: true
        });
    }, [
        hideTooltipOnClick
    ]);
    // Ideally we would be using onMouseEnter here, but
    // because we are binding the event to the target parent
    // we need to listen for the mouseover of all sub elements
    // This means when moving along a tooltip we are quickly toggling
    // between api.requestHide and api.keep. This it not ideal
    var onMouseOver = (0, $dAx5m.useCallback)(function(event) {
        // Ignoring events from the container ref
        if (containerRef.current && event.target === containerRef.current) return;
        // Using prevent default as a signal that parent tooltips
        if (event.defaultPrevented) return;
        event.preventDefault();
        var source = position === "mouse" ? {
            type: "mouse",
            // TODO: ideally not recalculating this object each time
            mouse: (0, $jlH72.getMousePosition)({
                left: event.clientX,
                top: event.clientY
            })
        } : {
            type: "keyboard"
        };
        tryShowTooltip(source);
    }, [
        position,
        tryShowTooltip
    ]);
    // Ideally we would be using onMouseEnter here, but
    // because we are binding the event to the target parent
    // we need to listen for the mouseout of all sub elements
    // This means when moving along a tooltip we are quickly toggling
    // between api.requestHide and api.keep. This it not ideal
    var onMouseOut = (0, $dAx5m.useCallback)(function(event) {
        // Ignoring events from the container ref
        if (containerRef.current && event.target === containerRef.current) return;
        // Using prevent default as a signal that parent tooltips
        if (event.defaultPrevented) return;
        event.preventDefault();
        if (apiRef.current) apiRef.current.requestHide({
            isImmediate: false
        });
    }, []);
    var onMouseMove = position === "mouse" ? function(event) {
        var _apiRef$current3;
        if ((_apiRef$current3 = apiRef.current) !== null && _apiRef$current3 !== void 0 && _apiRef$current3.isActive()) apiRef.current.mousePosition = (0, $jlH72.getMousePosition)({
            left: event.clientX,
            top: event.clientY
        });
    } : undefined;
    var onMouseOverTooltip = (0, $dAx5m.useCallback)(function() {
        if (apiRef.current && apiRef.current.isActive()) {
            apiRef.current.keep();
            return;
        }
    }, []);
    var onFocus = (0, $dAx5m.useCallback)(function() {
        // TODO: this does not play well with `hideTooltipOnMouseDown`
        // as "focus" will occur after the "mousedown".
        tryShowTooltip({
            type: "keyboard"
        });
    }, [
        tryShowTooltip
    ]);
    var onBlur = (0, $dAx5m.useCallback)(function() {
        if (apiRef.current) apiRef.current.requestHide({
            isImmediate: false
        });
    }, []);
    var onAnimationFinished = (0, $dAx5m.useCallback)(function(transition) {
        // Using lastState here because motion is not picking up the latest value
        if (transition === "exiting" && stableState.current === "fade-out" && apiRef.current) // @ts-ignore: refs are writeable
        apiRef.current.finishHideAnimation();
    }, [
        stableState
    ]);
    // Doing a cast because typescript is struggling to narrow the type
    var CastTargetContainer = TargetContainer;
    var shouldRenderTooltipPopup = state !== "hide" && Boolean(content);
    var shouldRenderHiddenContent = !isScreenReaderAnnouncementDisabled && shouldRenderTooltipPopup;
    var shouldRenderTooltipChildren = state !== "hide" && state !== "fade-out";
    (0, $29qVV.useNotifyOpenLayerObserver)({
        isOpen: shouldRenderTooltipPopup
    });
    var getReferenceElement = function getReferenceElement() {
        var _apiRef$current4;
        if (position === "mouse" && (_apiRef$current4 = apiRef.current) !== null && _apiRef$current4 !== void 0 && _apiRef$current4.mousePosition) {
            var _apiRef$current5;
            return (_apiRef$current5 = apiRef.current) === null || _apiRef$current5 === void 0 ? void 0 : _apiRef$current5.mousePosition;
        }
        return targetRef.current || undefined;
    };
    var tooltipIdForHiddenContent = (0, $BAnnF.default)("tooltip", shouldRenderHiddenContent);
    var tooltipTriggerProps = {
        onMouseOver: onMouseOver,
        onMouseOut: onMouseOut,
        onMouseMove: onMouseMove,
        onMouseDown: onMouseDown,
        onClick: onClick,
        onFocus: onFocus,
        onBlur: onBlur
    };
    // Don't set `data-testid` unless it's defined, as it's not in the interface.
    if (testId) // @ts-expect-error - Adding `data-testid` to the TriggerProps interface breaks Buttons.
    tooltipTriggerProps["data-testid"] = "".concat(testId, "--container");
    // This useEffect is purely for managing the aria attribute when using the
    // wrapped children approach.
    var isChildrenAFunction = typeof children === "function";
    (0, $dAx5m.useEffect)(function() {
        if (isChildrenAFunction) return;
        // If `children` is _not_ a function, we are stepping outside of the public
        // API to add a `aria-describedby` attribute.
        var target = targetRef.current;
        if (!target || !tooltipIdForHiddenContent) return;
        target.setAttribute("aria-describedby", tooltipIdForHiddenContent);
        return function() {
            return target.removeAttribute("aria-describedby");
        };
    }, [
        isChildrenAFunction,
        tooltipIdForHiddenContent
    ]);
    var hiddenContent = shouldRenderHiddenContent ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement("span", {
        "data-testid": testId ? "".concat(testId, "-hidden") : undefined,
        hidden: true,
        id: tooltipIdForHiddenContent
    }, typeof content === "function" ? content({}) : content) : null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).Fragment, null, typeof children === "function" ? /*#__PURE__*/ // once we deprecate the wrapped approach, we can put the aria
    // attribute back into the tooltipTriggerProps and make it required
    // instead of optional in `types`
    (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).Fragment, null, children($82fa4338d59d27a8$var$_objectSpread($82fa4338d59d27a8$var$_objectSpread({}, tooltipTriggerProps), {}, {
        "aria-describedby": tooltipIdForHiddenContent,
        ref: setDirectRef
    })), hiddenContent) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement(CastTargetContainer, (0, (/*@__PURE__*/$parcel$interopDefault($sN2rQ)))({}, tooltipTriggerProps, {
        ref: setImplicitRefFromChildren,
        role: "presentation"
    }), children, hiddenContent), shouldRenderTooltipPopup ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $iWhPr.default), {
        zIndex: $82fa4338d59d27a8$var$tooltipZIndex
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $7SQ8g.Popper), {
        placement: tooltipPosition,
        referenceElement: getReferenceElement(),
        strategy: strategy
    }, function(_ref5) {
        var ref = _ref5.ref, style = _ref5.style, update = _ref5.update, placement = _ref5.placement;
        // Invert the entrance and exit directions.
        // E.g. a tooltip's position is on the 'right', it should enter from and exit to the 'left'
        // This gives the effect the tooltip is appearing from the target
        var direction = position === "mouse" ? undefined : $82fa4338d59d27a8$var$invertedDirection[$82fa4338d59d27a8$var$getDirectionFromPlacement(placement)];
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $ggwTM.default), {
            appear: true
        }, shouldRenderTooltipChildren && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $62E0k.default), {
            distance: "constant",
            entranceDirection: direction,
            exitDirection: direction,
            onFinish: onAnimationFinished,
            duration: state !== "show-immediate" ? "medium" : "none"
        }, function(_ref6) {
            var className = _ref6.className;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement(Container, {
                ref: ref,
                className: "Tooltip ".concat(className),
                style: $82fa4338d59d27a8$var$_objectSpread($82fa4338d59d27a8$var$_objectSpread({}, style), ignoreTooltipPointerEvents && {
                    pointerEvents: "none"
                }),
                truncate: truncate,
                placement: tooltipPosition,
                testId: getReferenceElement() ? testId : testId && "".concat(testId, "--unresolved"),
                onMouseOut: onMouseOut,
                onMouseOver: onMouseOverTooltip
            }, typeof content === "function" ? content({
                update: update
            }) : content);
        }));
    })) : null);
}
$82fa4338d59d27a8$var$Tooltip.displayName = "Tooltip";
var $82fa4338d59d27a8$export$2e2bcd8739ae039 = $82fa4338d59d27a8$var$Tooltip;

});
parcelRegister("6X4go", function(module, exports) {

$parcel$export(module.exports, "usePlatformLeafSyntheticEventHandler", function () { return $50fb8f615c3d77fe$export$1a04351537078b55; });

var $c6l2j = parcelRequire("c6l2j");

var $dAx5m = parcelRequire("dAx5m");

var $468YR = parcelRequire("468YR");

var $jEB3A = parcelRequire("jEB3A");
function $50fb8f615c3d77fe$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $50fb8f615c3d77fe$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $50fb8f615c3d77fe$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($c6l2j)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $50fb8f615c3d77fe$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $50fb8f615c3d77fe$export$1a04351537078b55(_ref) {
    var fn = _ref.fn, action = _ref.action, componentName = _ref.componentName, packageName = _ref.packageName, packageVersion = _ref.packageVersion, analyticsData = _ref.analyticsData;
    var _useAnalyticsEvents = (0, $468YR.useAnalyticsEvents)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    // We put analyticsData and fn in a ref so that we don't need to break
    // memoization.
    // Generally these could be defined by consumers inline
    // and so we do this to avoid breaking memoization of useCallback
    var dataRef = (0, $jEB3A.useTrackedRef)(analyticsData);
    var fnRef = (0, $jEB3A.useTrackedRef)(fn);
    var handler = (0, $dAx5m.useCallback)(function() {
        var analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: componentName,
            attributes: {
                componentName: componentName,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
        // To avoid wrapping this component in AnalyticsContext we manually
        // push the parent context's meta data into the context.
        // Note: this new 'context'
        var context = $50fb8f615c3d77fe$var$_objectSpread({
            componentName: componentName,
            packageName: packageName,
            packageVersion: packageVersion
        }, dataRef.current);
        analyticsEvent.context.push(context);
        // fire an event on the atlaskit channel
        var clone = analyticsEvent.clone();
        if (clone) clone.fire("atlaskit");
        fnRef.current(analyticsEvent);
    }, [
        // These are strings and won't change
        action,
        componentName,
        packageName,
        packageVersion,
        // This function is memoized in the context
        createAnalyticsEvent,
        // these are a stable ref because of the useTrackedRef hook
        dataRef,
        fnRef
    ]);
    return handler;
}

});

parcelRegister("djC9A", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9b1aa53c9d5a2455$export$2e2bcd8739ae039; });

var $dAx5m = parcelRequire("dAx5m");

var $dd4sf = parcelRequire("dd4sf");

var $lIKXj = parcelRequire("lIKXj");
function $9b1aa53c9d5a2455$export$2e2bcd8739ae039(_ref) {
    var onClose = _ref.onClose, isDisabled = _ref.isDisabled;
    var escapePressed = (0, $dAx5m.useRef)(false);
    var onKeyDown = (0, $dAx5m.useCallback)(function(e) {
        if (isDisabled || escapePressed.current || e.key !== (0, $lIKXj.ESCAPE)) // We're either already handling the key down event or it's not escape.
        // Bail early!
        return;
        escapePressed.current = true;
        onClose(e);
    }, [
        onClose,
        isDisabled
    ]);
    var onKeyUp = (0, $dAx5m.useCallback)(function() {
        escapePressed.current = false;
    }, []);
    (0, $dAx5m.useEffect)(function() {
        return (0, $dd4sf.bindAll)(document, [
            {
                type: "keydown",
                listener: onKeyDown
            },
            {
                type: "keyup",
                listener: onKeyUp
            }
        ], {
            capture: false
        });
    }, [
        onKeyDown,
        onKeyUp
    ]);
}

});
parcelRegister("lIKXj", function(module, exports) {

$parcel$export(module.exports, "ESCAPE", function () { return $fd02216e33f19e13$export$2bb790b9008907b4; });
/**
 * Character key codes which can be used in keyboard events.
 */ var $fd02216e33f19e13$export$390330c10ff2b9a1 = "ArrowUp";
var $fd02216e33f19e13$export$a80636c6f41931fe = "ArrowDown";
var $fd02216e33f19e13$export$4af703091671bc = "Home";
var $fd02216e33f19e13$export$e2bc30913faa5db7 = "End";
var $fd02216e33f19e13$export$10f6869ed0a7d75b = "Tab";
var $fd02216e33f19e13$export$8152f929a25a0ff4 = "Enter";
var $fd02216e33f19e13$export$e51a3576c045c8d5 = "Space";
var $fd02216e33f19e13$export$2bb790b9008907b4 = "Escape";

});


parcelRegister("gsEbz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bfbe6eea4ce361f2$export$2e2bcd8739ae039; });

var $dAx5m = parcelRequire("dAx5m");
function $bfbe6eea4ce361f2$export$2e2bcd8739ae039(value) {
    var ref = (0, $dAx5m.useRef)(value);
    (0, $dAx5m.useEffect)(function() {
        ref.current = value;
    }, [
        value
    ]);
    return ref;
}

});

parcelRegister("29qVV", function(module, exports) {

$parcel$export(module.exports, "useNotifyOpenLayerObserver", function () { return $191150668755b2df$export$469bb693f11edc7f; });

var $dAx5m = parcelRequire("dAx5m");

var $ilxrF = parcelRequire("ilxrF");
function $191150668755b2df$export$469bb693f11edc7f() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref$isOpen = _ref.isOpen, isOpen = _ref$isOpen === void 0 ? true : _ref$isOpen;
    var context = (0, $dAx5m.useContext)((0, $ilxrF.OpenLayerObserverContext));
    (0, $dAx5m.useEffect)(function() {
        if (context === null) return;
        if (!isOpen) return;
        context.increment();
        return function() {
            context.decrement();
        };
    }, [
        context,
        isOpen
    ]);
}

});
parcelRegister("ilxrF", function(module, exports) {

$parcel$export(module.exports, "OpenLayerObserverContext", function () { return $d5b421b22afe6361$export$5fbf4d7fae6cdc00; });

var $dAx5m = parcelRequire("dAx5m");
var $d5b421b22afe6361$export$5fbf4d7fae6cdc00 = /*#__PURE__*/ (0, $dAx5m.createContext)(null);

});


parcelRegister("7SQ8g", function(module, exports) {

$parcel$export(module.exports, "Popper", function () { return $5bd603f5cf1636d2$export$badac9ada3a0bdf9; });

var $eOrTx = parcelRequire("eOrTx");

var $9GATj = parcelRequire("9GATj");

var $dAx5m = parcelRequire("dAx5m");

var $2BQLr = parcelRequire("2BQLr");

var $2bfVO = parcelRequire("2bfVO");

// Export types from PopperJS / React Popper
var $5bd603f5cf1636d2$var$viewportPadding = 5;
var $5bd603f5cf1636d2$var$constantModifiers = [
    {
        name: "flip",
        options: {
            flipVariations: false,
            padding: $5bd603f5cf1636d2$var$viewportPadding,
            boundary: "clippingParents",
            rootBoundary: "viewport"
        }
    }
];
function $5bd603f5cf1636d2$var$defaultChildrenFn() {
    return null;
}
var $5bd603f5cf1636d2$var$defaultOffset = [
    0,
    8
];
function $5bd603f5cf1636d2$export$badac9ada3a0bdf9(_ref) {
    var _ref$children = _ref.children, children = _ref$children === void 0 ? $5bd603f5cf1636d2$var$defaultChildrenFn : _ref$children, _ref$offset = _ref.offset, offset = _ref$offset === void 0 ? $5bd603f5cf1636d2$var$defaultOffset : _ref$offset, _ref$placement = _ref.placement, placement = _ref$placement === void 0 ? "bottom-start" : _ref$placement, _ref$referenceElement = _ref.referenceElement, referenceElement = _ref$referenceElement === void 0 ? undefined : _ref$referenceElement, modifiers = _ref.modifiers, _ref$strategy = _ref.strategy, strategy = _ref$strategy === void 0 ? "fixed" : _ref$strategy, _ref$shouldFitViewpor = _ref.shouldFitViewport, shouldFitViewport = _ref$shouldFitViewpor === void 0 ? false : _ref$shouldFitViewpor;
    var _offset = (0, (/*@__PURE__*/$parcel$interopDefault($9GATj)))(offset, 2), offsetX = _offset[0], offsetY = _offset[1];
    var internalModifiers = (0, $dAx5m.useMemo)(function() {
        var preventOverflowModifier = {
            name: "preventOverflow",
            options: {
                padding: $5bd603f5cf1636d2$var$viewportPadding,
                rootBoundary: shouldFitViewport ? "viewport" : "document"
            }
        };
        var offsetModifier = {
            name: "offset",
            options: {
                offset: [
                    offsetX,
                    offsetY
                ]
            }
        };
        var maxSizeModifiers = shouldFitViewport ? (0, $2bfVO.getMaxSizeModifiers)({
            viewportPadding: $5bd603f5cf1636d2$var$viewportPadding
        }) : [];
        // @ts-ignore Type errors from incompatible @popperjs/core versions between Jira and AFM Platform... we are using ts-ignore here because ts-expect-error will cause an "Unused '@ts-expect-error' directive." error
        return [].concat($5bd603f5cf1636d2$var$constantModifiers, [
            preventOverflowModifier,
            offsetModifier
        ], (0, (/*@__PURE__*/$parcel$interopDefault($eOrTx)))(maxSizeModifiers));
    }, [
        offsetX,
        offsetY,
        shouldFitViewport
    ]);
    // Merge custom props and memoize
    var mergedModifiers = (0, $dAx5m.useMemo)(function() {
        if (modifiers == null) return internalModifiers;
        return [].concat((0, (/*@__PURE__*/$parcel$interopDefault($eOrTx)))(internalModifiers), (0, (/*@__PURE__*/$parcel$interopDefault($eOrTx)))(modifiers));
    }, [
        internalModifiers,
        modifiers
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $2BQLr.Popper), {
        modifiers: mergedModifiers,
        placement: placement,
        strategy: strategy,
        referenceElement: referenceElement
    }, children);
}

});
parcelRegister("eOrTx", function(module, exports) {

var $4UtoG = parcelRequire("4UtoG");

var $bhVN4 = parcelRequire("bhVN4");

var $hE2jo = parcelRequire("hE2jo");

var $8x7Lw = parcelRequire("8x7Lw");
function $ac8b5f87d05fb4b8$var$_toConsumableArray(r) {
    return $4UtoG(r) || $bhVN4(r) || $hE2jo(r) || $8x7Lw();
}
module.exports = $ac8b5f87d05fb4b8$var$_toConsumableArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("4UtoG", function(module, exports) {

var $i1vfT = parcelRequire("i1vfT");
function $393332070fb0ee30$var$_arrayWithoutHoles(r) {
    if (Array.isArray(r)) return $i1vfT(r);
}
module.exports = $393332070fb0ee30$var$_arrayWithoutHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("i1vfT", function(module, exports) {
function $d1f090a1e6097f4d$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
module.exports = $d1f090a1e6097f4d$var$_arrayLikeToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("bhVN4", function(module, exports) {
function $837e1c3908149627$var$_iterableToArray(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
module.exports = $837e1c3908149627$var$_iterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("hE2jo", function(module, exports) {

var $i1vfT = parcelRequire("i1vfT");
function $cd87f72b0b52b26c$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $i1vfT(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $i1vfT(r, a) : void 0;
    }
}
module.exports = $cd87f72b0b52b26c$var$_unsupportedIterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("8x7Lw", function(module, exports) {
function $63676dd63f3ebd4d$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
module.exports = $63676dd63f3ebd4d$var$_nonIterableSpread, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("9GATj", function(module, exports) {

var $9ufWi = parcelRequire("9ufWi");

var $22yLA = parcelRequire("22yLA");

var $hE2jo = parcelRequire("hE2jo");

var $2vk25 = parcelRequire("2vk25");
function $70d4a71e0c7f192e$var$_slicedToArray(r, e) {
    return $9ufWi(r) || $22yLA(r, e) || $hE2jo(r, e) || $2vk25();
}
module.exports = $70d4a71e0c7f192e$var$_slicedToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("9ufWi", function(module, exports) {
function $6e83479c2fa862c5$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
module.exports = $6e83479c2fa862c5$var$_arrayWithHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("22yLA", function(module, exports) {
function $17c6bc92336f8f08$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
module.exports = $17c6bc92336f8f08$var$_iterableToArrayLimit, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("2vk25", function(module, exports) {
function $1d2e04105323b5cd$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
module.exports = $1d2e04105323b5cd$var$_nonIterableRest, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("2bfVO", function(module, exports) {

$parcel$export(module.exports, "getMaxSizeModifiers", function () { return $1968f77c80e86f4a$export$6d8c2b45c99d6e3f; });

var $9GATj = parcelRequire("9GATj");
function $1968f77c80e86f4a$export$6d8c2b45c99d6e3f(_ref) {
    var viewportPadding = _ref.viewportPadding;
    return [
        {
            /**
     * Performing DOM measurements in the 'read' phase,
     * which is the convention for popper modifiers
     */ name: "maxSizeData",
            enabled: true,
            phase: "read",
            fn: function fn(_ref2) {
                var state = _ref2.state, name = _ref2.name;
                if (!window.visualViewport) return;
                state.modifiersData[name] = {
                    viewport: {
                        width: window.visualViewport.width,
                        height: window.visualViewport.height
                    }
                };
            }
        },
        {
            /**
     * Applying max size CSS
     */ name: "maxSize",
            enabled: true,
            phase: "beforeWrite",
            requiresIfExists: [
                "offset",
                "preventOverflow",
                "flip"
            ],
            fn: function fn(_ref3) {
                var _data$viewport, _data$viewport2, _state$modifiersData$2, _state$modifiersData;
                var state = _ref3.state;
                var data = state.modifiersData.maxSizeData;
                if (typeof (data === null || data === void 0 || (_data$viewport = data.viewport) === null || _data$viewport === void 0 ? void 0 : _data$viewport.width) !== "number" || typeof (data === null || data === void 0 || (_data$viewport2 = data.viewport) === null || _data$viewport2 === void 0 ? void 0 : _data$viewport2.height) !== "number") // This shouldn't occur in a real browser but might in non-browser test environments
                return;
                var viewport = data.viewport;
                var _state$modifiersData$ = state.modifiersData.popperOffsets, popperOffsets = _state$modifiersData$ === void 0 ? {
                    x: 0,
                    y: 0
                } : _state$modifiersData$;
                var _state$placement$spli = state.placement.split("-"), _state$placement$spli2 = (0, (/*@__PURE__*/$parcel$interopDefault($9GATj)))(_state$placement$spli, 1), basePlacement = _state$placement$spli2[0];
                var placementOffset = (_state$modifiersData$2 = (_state$modifiersData = state.modifiersData) === null || _state$modifiersData === void 0 || (_state$modifiersData = _state$modifiersData.offset) === null || _state$modifiersData === void 0 ? void 0 : _state$modifiersData[state.placement]) !== null && _state$modifiersData$2 !== void 0 ? _state$modifiersData$2 : {
                    x: 0,
                    y: 0
                };
                // By default we set these to the entire viewport (minus padding)
                // Each placement direction will overwrite one of these
                var maxWidth = viewport.width - 2 * viewportPadding;
                var maxHeight = viewport.height - 2 * viewportPadding;
                if (basePlacement === "top") maxHeight = state.rects.reference.y + // Viewport-relative position of reference element
                placementOffset.y - // Space between popper and reference
                viewportPadding;
                if (basePlacement === "bottom") maxHeight = viewport.height - popperOffsets.y - // Viewport-relative position of popper
                viewportPadding;
                if (basePlacement === "left") maxWidth = state.rects.reference.x + // Viewport-relative position of reference element
                placementOffset.x - // Space between popper and reference
                viewportPadding;
                if (basePlacement === "right") maxWidth = viewport.width - popperOffsets.x - // Viewport-relative position of popper
                viewportPadding;
                state.styles.popper.maxWidth = "".concat(maxWidth, "px");
                state.styles.popper.maxHeight = "".concat(maxHeight, "px");
            }
        }
    ];
}

});


parcelRegister("jzVTV", function(module, exports) {

$parcel$export(module.exports, "layers", function () { return $e40e3326ad0d0dd2$export$7be255094ccdc533; });

var $4oDd5 = parcelRequire("4oDd5");

var $1zU5H = parcelRequire("1zU5H");
var $e40e3326ad0d0dd2$export$44ffba16bd48dac6 = "__ATLASKIT_THEME__";
var $e40e3326ad0d0dd2$export$c93026a968943f95 = "light";
var $e40e3326ad0d0dd2$export$6ba72c8346b4c57e = [
    "light",
    "dark"
];
var $e40e3326ad0d0dd2$export$7a57f79000377ca2 = function borderRadius() {
    return 3;
};
var $e40e3326ad0d0dd2$export$6d8204c2cb2e06b8 = function gridSize() {
    return 8;
};
var $e40e3326ad0d0dd2$export$8e24544ddba725ee = function focusRing() {
    var color = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "var(--ds-border-focused, ".concat((0, $1zU5H.B200), ")");
    var outlineWidth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $e40e3326ad0d0dd2$export$6d8204c2cb2e06b8() / 4;
    (0, $4oDd5.default)("@atlaskit/theme", "focus ring mixin", "Please use `@atlaskit/focus-ring` instead.");
    return "\n  &:focus {\n    outline: none;\n    box-shadow: 0px 0px 0px ".concat(outlineWidth, "px ").concat(color, ";\n  }\n");
};
var $e40e3326ad0d0dd2$export$c0dd343266bc3261 = function noFocusRing() {
    return "\n  box-shadow: none;\n";
};
var $e40e3326ad0d0dd2$export$7be255094ccdc533 = {
    card: function card() {
        return 100;
    },
    navigation: function navigation() {
        return 200;
    },
    dialog: function dialog() {
        return 300;
    },
    layer: function layer() {
        return 400;
    },
    blanket: function blanket() {
        return 500;
    },
    modal: function modal() {
        return 510;
    },
    flag: function flag() {
        return 600;
    },
    spotlight: function spotlight() {
        return 700;
    },
    tooltip: function tooltip() {
        return 9999;
    }
};
var $e40e3326ad0d0dd2$export$a1b3edb637fb4f35 = function visuallyHidden() {
    (0, $4oDd5.default)("@atlaskit/theme", "visually hidden mixin", "Please use `@atlaskit/visually-hidden` instead.");
    return {
        border: "0 !important",
        clip: "rect(1px, 1px, 1px, 1px) !important",
        height: "1px !important",
        overflow: "hidden !important",
        padding: "0 !important",
        position: "absolute !important",
        width: "1px !important",
        whiteSpace: "nowrap !important"
    };
};
var $e40e3326ad0d0dd2$export$ba1d834b86d72a09 = $e40e3326ad0d0dd2$export$a1b3edb637fb4f35;
var $e40e3326ad0d0dd2$export$e497e856b4f89fcd = function skeletonShimmer() {
    return {
        css: {
            backgroundColor: "var(--ds-skeleton, ".concat((0, $1zU5H.N20A), ")"),
            animationDuration: "1.5s",
            animationIterationCount: "infinite",
            animationTimingFunction: "linear",
            animationDirection: "alternate"
        },
        keyframes: {
            from: {
                backgroundColor: "var(--ds-skeleton, ".concat((0, $1zU5H.N20A), ")")
            },
            to: {
                backgroundColor: "var(--ds-skeleton-subtle, ".concat((0, $1zU5H.N30A), ")")
            }
        }
    };
};

});
parcelRegister("4oDd5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3337d1a2198c82d9$export$2e2bcd8739ae039; });

var $6tI5N = parcelRequire("6tI5N");

var $ahJoN = parcelRequire("ahJoN");
function $3337d1a2198c82d9$export$2e2bcd8739ae039(packageName, api, additionalMessage) {
    (0, $6tI5N.default)("[".concat(packageName, "]: The ").concat(api, " is deprecated.").concat(additionalMessage && " ".concat(additionalMessage)));
}
function $3337d1a2198c82d9$export$eb1decd851a5ae56(packageName, propName, predicate, deprecationAnnouncementOnDAC) {
    typeof $ahJoN;
}

});
parcelRegister("6tI5N", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4b77a76183013b0d$export$2e2bcd8739ae039; });
/* eslint-disable no-console */ var $4b77a76183013b0d$var$printed = {};
function $4b77a76183013b0d$export$2e2bcd8739ae039(message) {
    if ($4b77a76183013b0d$var$printed[message]) return;
    $4b77a76183013b0d$var$printed[message] = true;
    if (typeof window !== "undefined") console.warn(message);
}

});



parcelRegister("ZzBpf", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $0b9150800c096e52$export$6503ec6e8aabbaf; });
/* eslint-disable @atlaskit/design-system/no-direct-use-of-web-platform-drag-and-drop */ /**
 * We are listening directly to drag events instead of using a monitor from
 * `@atlaskit/pragmatic-drag-and-drop` to avoid the bundle size cost, as it
 * would affect almost every view in every product.
 *
 * We can reconsider this choice in the future.
 */ 
var $dd4sf = parcelRequire("dd4sf");
var $0b9150800c096e52$var$registrations = new Set();
var $0b9150800c096e52$var$cleanupEndEventListeners = null;
function $0b9150800c096e52$var$onDragStart() {
    if ($0b9150800c096e52$var$cleanupEndEventListeners) // If the cleanup function exists then we've already run this
    return;
    $0b9150800c096e52$var$cleanupEndEventListeners = (0, $dd4sf.bindAll)(window, [
        {
            type: "dragend",
            listener: $0b9150800c096e52$var$onDragEnd
        },
        {
            type: "pointerdown",
            listener: $0b9150800c096e52$var$onDragEnd
        },
        {
            type: "pointermove",
            listener: function() {
                var callCount = 0;
                return function listener() {
                    // Using 20 as it is far bigger than the most observed (3)
                    if (callCount < 20) {
                        callCount++;
                        return;
                    }
                    $0b9150800c096e52$var$onDragEnd();
                };
            }()
        }
    ]);
    var clone = Array.from($0b9150800c096e52$var$registrations);
    clone.forEach(function(subscriber) {
        subscriber.onDragStart();
    });
}
function $0b9150800c096e52$var$onDragEnd() {
    var _cleanupEndEventListe;
    (_cleanupEndEventListe = $0b9150800c096e52$var$cleanupEndEventListeners) === null || _cleanupEndEventListe === void 0 || _cleanupEndEventListe();
    $0b9150800c096e52$var$cleanupEndEventListeners = null;
    var clone = Array.from($0b9150800c096e52$var$registrations);
    clone.forEach(function(subscriber) {
        subscriber.onDragEnd();
    });
}
function $0b9150800c096e52$var$bindStartEvents() {
    return (0, $dd4sf.bindAll)(window, [
        {
            type: "dragstart",
            listener: $0b9150800c096e52$var$onDragStart
        },
        {
            type: "dragenter",
            listener: $0b9150800c096e52$var$onDragStart
        }
    ]);
}
var $0b9150800c096e52$var$cleanupStartEventListeners = null;
function $0b9150800c096e52$export$6503ec6e8aabbaf(registration) {
    // if first registration, bind event listeners
    if (!$0b9150800c096e52$var$cleanupStartEventListeners) // note: currently never unbinding these event listeners
    $0b9150800c096e52$var$cleanupStartEventListeners = $0b9150800c096e52$var$bindStartEvents();
    $0b9150800c096e52$var$registrations.add(registration);
    /**
   * The reasoning for this behavior is so that if a tooltip mounts during
   * a drag it can still be suppressed.
   *
   * We use a separate callback instead of onDragStart to avoid infinite loops.
   */ registration.onRegister({
        isDragging: $0b9150800c096e52$var$cleanupEndEventListeners !== null
    });
    return function unregister() {
        $0b9150800c096e52$var$registrations.delete(registration);
        if ($0b9150800c096e52$var$registrations.size === 0) {
            var _cleanupStartEventLis;
            (_cleanupStartEventLis = $0b9150800c096e52$var$cleanupStartEventListeners) === null || _cleanupStartEventLis === void 0 || _cleanupStartEventLis();
            $0b9150800c096e52$var$cleanupStartEventListeners = null;
        }
    };
}

});

parcelRegister("91qPF", function(module, exports) {

$parcel$export(module.exports, "show", function () { return $69190565859e039a$export$57bf213be019eeb0; });

var $ctXtv = parcelRequire("ctXtv");
// This file is a singleton for managing tooltips
var $69190565859e039a$var$active = null;
function $69190565859e039a$export$57bf213be019eeb0(entry) {
    var phase = "waiting-to-show";
    function isActive() {
        return Boolean($69190565859e039a$var$active && $69190565859e039a$var$active.entry === entry);
    }
    function cleanup() {
        if (isActive()) {
            (0, $ctXtv.clearScheduled)();
            $69190565859e039a$var$active = null;
        }
    }
    function done() {
        if (isActive()) entry.done();
        phase = "done";
        cleanup();
    }
    function immediatelyHideAndDone() {
        if (isActive()) entry.hide({
            isImmediate: true
        });
        done();
    }
    function keep() {
        if (!isActive()) return;
        // aborting a wait to hide
        if (phase === "waiting-to-hide") {
            phase = "shown";
            (0, $ctXtv.clearScheduled)();
            return;
        }
        // aborting hide animation
        if (phase === "hide-animating") {
            phase = "shown";
            (0, $ctXtv.clearScheduled)();
            entry.show({
                isImmediate: false
            });
            return;
        }
    }
    function requestHide(_ref) {
        var isImmediate = _ref.isImmediate;
        if (!isActive()) return;
        // If we were not showing yet anyway; finish straight away
        if (phase === "waiting-to-show") {
            immediatelyHideAndDone();
            return;
        }
        // already waiting to hide
        if (phase === "waiting-to-hide") return;
        if (isImmediate) {
            immediatelyHideAndDone();
            return;
        }
        phase = "waiting-to-hide";
        (0, $ctXtv.scheduleTimeout)(function() {
            phase = "hide-animating";
            entry.hide({
                isImmediate: false
            });
        }, entry.delay);
    }
    function finishHideAnimation() {
        if (isActive() && phase === "hide-animating") done();
    }
    function isVisible() {
        return phase === "shown" || phase === "waiting-to-hide" || phase === "hide-animating";
    }
    function getInitialMouse() {
        if (entry.source.type === "mouse") return entry.source.mouse;
        return null;
    }
    function start() {
        var showImmediately = Boolean($69190565859e039a$var$active && $69190565859e039a$var$active.isVisible());
        // If there was an active tooltip; we tell it to remove itself at once!
        if ($69190565859e039a$var$active) {
            (0, $ctXtv.clearScheduled)();
            $69190565859e039a$var$active.entry.hide({
                isImmediate: true
            });
            $69190565859e039a$var$active.entry.done();
            $69190565859e039a$var$active = null;
        }
        // this tooltip is now the active tooltip
        $69190565859e039a$var$active = {
            entry: entry,
            isVisible: isVisible
        };
        function show() {
            phase = "shown";
            entry.show({
                isImmediate: showImmediately
            });
        }
        if (showImmediately) {
            show();
            return;
        }
        phase = "waiting-to-show";
        (0, $ctXtv.scheduleTimeout)(show, entry.delay);
    }
    // let's get started!
    start();
    var result = {
        keep: keep,
        abort: cleanup,
        isActive: isActive,
        requestHide: requestHide,
        finishHideAnimation: finishHideAnimation,
        mousePosition: getInitialMouse()
    };
    return result;
}

});
parcelRegister("ctXtv", function(module, exports) {

$parcel$export(module.exports, "clearScheduled", function () { return $916653eeed961d7e$export$eaf678f6f93f5250; });
$parcel$export(module.exports, "scheduleTimeout", function () { return $916653eeed961d7e$export$5f4d6617421d489b; });
var $916653eeed961d7e$var$delayId = null;
function $916653eeed961d7e$export$eaf678f6f93f5250() {
    if ($916653eeed961d7e$var$delayId != null) {
        window.clearTimeout($916653eeed961d7e$var$delayId);
        $916653eeed961d7e$var$delayId = null;
    }
}
function $916653eeed961d7e$export$5f4d6617421d489b(fn, delay) {
    $916653eeed961d7e$export$eaf678f6f93f5250();
    $916653eeed961d7e$var$delayId = window.setTimeout(function() {
        $916653eeed961d7e$var$delayId = null;
        fn();
    }, delay);
}

});


parcelRegister("BAnnF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $070fac5a6798d3eb$export$2e2bcd8739ae039; });

var $ViONZ = parcelRequire("ViONZ");
function $070fac5a6798d3eb$export$2e2bcd8739ae039(prefix, shouldRenderId) {
    var seed = (0, $ViONZ.useIdSeed)();
    return shouldRenderId ? "".concat(seed(prefix)) : undefined;
}

});
parcelRegister("ViONZ", function(module, exports) {

$parcel$export(module.exports, "useId", function () { return $0ac3ebefaa493287$export$f680877a34711e37; });
$parcel$export(module.exports, "useIdSeed", function () { return $0ac3ebefaa493287$export$6ee17796e3d70de2; });

var $b5I6c = parcelRequire("b5I6c");

var $dAx5m = parcelRequire("dAx5m");

var $D9YLo = parcelRequire("D9YLo");

var $18rB9 = parcelRequire("18rB9");
var $0ac3ebefaa493287$var$_React$useId;
// Type copied from https://github.com/thearnica/react-uid/blob/0f507fbbdb1ab84acf477ec32698afe3d2191e49/src/hooks.ts#L12
// Copied rather than inferred to make the type transparent
// @ts-ignore - useId is not accessible in React 16
var $0ac3ebefaa493287$var$react18UseId = ($0ac3ebefaa493287$var$_React$useId = (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).useId) !== null && $0ac3ebefaa493287$var$_React$useId !== void 0 ? $0ac3ebefaa493287$var$_React$useId : undefined;
function $0ac3ebefaa493287$export$f680877a34711e37() {
    if ($0ac3ebefaa493287$var$react18UseId && (0, $18rB9.fg)("platform-dst-react-18-use-id")) // eslint-disable-next-line react-hooks/rules-of-hooks
    return $0ac3ebefaa493287$var$react18UseId();
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return "uid".concat((0, $D9YLo.useUID)());
}
var $0ac3ebefaa493287$export$6be90bcb437e928f = /*#__PURE__*/ (0, $dAx5m.forwardRef)(function(_ref, ref) {
    var children = _ref.children, _ref$postfix = _ref.postfix, postfix = _ref$postfix === void 0 ? "" : _ref$postfix, _ref$prefix = _ref.prefix, prefix = _ref$prefix === void 0 ? "" : _ref$prefix;
    var id = "".concat(prefix).concat($0ac3ebefaa493287$export$f680877a34711e37()).concat(postfix);
    (0, $dAx5m.useEffect)(function() {
        if (!ref) return;
        switch((0, (/*@__PURE__*/$parcel$interopDefault($b5I6c)))(ref)){
            case "function":
                ref(id);
                break;
            case "object":
                ref.current = id;
                break;
            default:
                throw new Error('Unreachable case for unsupported type of ref "'.concat((0, (/*@__PURE__*/$parcel$interopDefault($b5I6c)))(ref), '"'));
        }
    }, [
        id,
        ref
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).Fragment, null, typeof children === "function" ? children({
        id: id
    }) : children);
});
function $0ac3ebefaa493287$export$6ee17796e3d70de2() {
    if ($0ac3ebefaa493287$var$react18UseId && (0, $18rB9.fg)("platform-dst-react-18-use-id")) {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        var uid = $0ac3ebefaa493287$var$react18UseId();
        return function(id) {
            return "".concat(uid, "-").concat(id.toString());
        };
    }
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return (0, $D9YLo.useUIDSeed)();
}

});


parcelRegister("7X0HR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5c9e97640f6db483$export$2e2bcd8739ae039; });
/* tooltip-container.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $c6l2j = parcelRequire("c6l2j");

var $dAx5m = parcelRequire("dAx5m");

var $aF9LR = parcelRequire("aF9LR");
var $02hNl = parcelRequire("02hNl");

var $1zU5H = parcelRequire("1zU5H");

var $eCvAn = parcelRequire("eCvAn");
function $5c9e97640f6db483$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $5c9e97640f6db483$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $5c9e97640f6db483$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($c6l2j)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $5c9e97640f6db483$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $5c9e97640f6db483$var$baseStyles = null;
var $5c9e97640f6db483$var$truncateStyles = null;
/**
 * Used as the default tooltip container component for the exported `Tooltip` component.
 * Adds some styles to the tooltip primitive.
 */ var $5c9e97640f6db483$var$TooltipContainer = /*#__PURE__*/ (0, $dAx5m.forwardRef)(function TooltipContainer(_ref, ref) {
    var style = _ref.style, className = _ref.className, children = _ref.children, truncate = _ref.truncate, placement = _ref.placement, testId = _ref.testId, onMouseOut = _ref.onMouseOut, onMouseOver = _ref.onMouseOver, id = _ref.id;
    return /*#__PURE__*/ $dAx5m.createElement((0, $eCvAn.default), {
        ref: ref,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $aF9LR.default)([
            "_2rko1sit _11c8dcr7 _vchhusvi _p12fp3fh _bfhkpioe _syaz1i9p _152tze3t _1e02ze3t _1i4q1hna _85i5v77o _1q51v77o _y4ti12x7 _bozg12x7 _slp31hna",
            truncate && "_1reo15vq _18m915vq _p12f1pna _1bto1l2s _o5721q9c",
            className
        ]),
        placement: placement,
        testId: testId,
        id: id,
        onMouseOut: onMouseOut,
        onMouseOver: onMouseOver,
        style: $5c9e97640f6db483$var$_objectSpread($5c9e97640f6db483$var$_objectSpread({}, style), {}, {
            "--_yr7xfv": (0, $02hNl.default)("var(--ds-background-neutral-bold, ".concat((0, $1zU5H.N800), ")")),
            "--_ywovvi": (0, $02hNl.default)("var(--ds-text-inverse, ".concat((0, $1zU5H.N0), ")"))
        })
    }, children);
});
$5c9e97640f6db483$var$TooltipContainer.displayName = "TooltipContainer";
var $5c9e97640f6db483$export$2e2bcd8739ae039 = $5c9e97640f6db483$var$TooltipContainer;

});
parcelRegister("eCvAn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $aa4d1d92b915ed29$export$2e2bcd8739ae039; });

var $c6l2j = parcelRequire("c6l2j");

var $dAx5m = parcelRequire("dAx5m");

var $jVTBW = parcelRequire("jVTBW");

var $jzVTV = parcelRequire("jzVTV");
function $aa4d1d92b915ed29$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $aa4d1d92b915ed29$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $aa4d1d92b915ed29$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($c6l2j)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $aa4d1d92b915ed29$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $aa4d1d92b915ed29$var$VAR_PRIMITIVE_ZINDEX = "tooltipPrimitiveZindex";
var $aa4d1d92b915ed29$var$primitiveStyles = (0, $jVTBW.css)({
    zindex: "var(".concat($aa4d1d92b915ed29$var$VAR_PRIMITIVE_ZINDEX, ")"),
    cursor: "default"
});
/**
 * The lower level component for rendering a tooltip.
 */ var $aa4d1d92b915ed29$var$TooltipPrimitive = /*#__PURE__*/ (0, $dAx5m.forwardRef)(function TooltipPrimitive(_ref, ref) {
    var style = _ref.style, className = _ref.className, children = _ref.children, placement = _ref.placement, testId = _ref.testId, onMouseOut = _ref.onMouseOut, onMouseOver = _ref.onMouseOver, id = _ref.id;
    var styleWithZIndex = $aa4d1d92b915ed29$var$_objectSpread($aa4d1d92b915ed29$var$_objectSpread({}, style), {}, (0, (/*@__PURE__*/$parcel$interopDefault($c6l2j)))({}, $aa4d1d92b915ed29$var$VAR_PRIMITIVE_ZINDEX, (0, $jzVTV.layers).tooltip()));
    return (0, $jVTBW.jsx)("div", {
        ref: ref,
        style: styleWithZIndex,
        "data-testid": testId ? "".concat(testId, "--wrapper") : undefined
    }, (0, $jVTBW.jsx)("div", {
        role: "tooltip",
        className: className,
        onMouseOut: onMouseOut,
        onMouseOver: onMouseOver,
        css: $aa4d1d92b915ed29$var$primitiveStyles,
        "data-placement": placement,
        "data-testid": testId,
        id: id
    }, children));
});
$aa4d1d92b915ed29$var$TooltipPrimitive.displayName = "TooltipPrimitive";
var $aa4d1d92b915ed29$export$2e2bcd8739ae039 = $aa4d1d92b915ed29$var$TooltipPrimitive;

});


parcelRegister("jlH72", function(module, exports) {

$parcel$export(module.exports, "getMousePosition", function () { return $e1616bbdae3a1127$export$642213d516a9b928; });
function $e1616bbdae3a1127$export$642213d516a9b928(mouseCoordinates) {
    var safeMouse = mouseCoordinates || {
        top: 0,
        left: 0
    };
    var getBoundingClientRect = function getBoundingClientRect() {
        return {
            top: safeMouse.top,
            left: safeMouse.left,
            bottom: safeMouse.top,
            right: safeMouse.left,
            width: 0,
            height: 0
        };
    };
    return {
        getBoundingClientRect: getBoundingClientRect,
        clientWidth: 0,
        clientHeight: 0
    };
}

});


parcelRegister("f2JTV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $af3aa5e2269067d4$export$2e2bcd8739ae039; });

var $dAx5m = parcelRequire("dAx5m");

var $8zaFA = parcelRequire("8zaFA");

var $itFuA = parcelRequire("itFuA");

var $2CIEr = parcelRequire("2CIEr");

var $1aRSA = parcelRequire("1aRSA");
/**
 * __Use icon button__
 *
 * A React hook that accepts a set of icon Button props,
 * and processes them to return consistent base props for usage
 * across IconButton and LinkIconButton variants.
 *
 * @private
 */ var $af3aa5e2269067d4$var$useIconButton = function useIconButton(_ref) {
    var analyticsContext = _ref.analyticsContext, appearance = _ref.appearance, ariaLabel = _ref.ariaLabel, ariaLabelledBy = _ref.ariaLabelledBy, autoFocus = _ref.autoFocus, buttonType = _ref.buttonType, icon = _ref.icon, interactionName = _ref.interactionName, isDisabled = _ref.isDisabled, _ref$isLoading = _ref.isLoading, isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading, isSelected = _ref.isSelected, label = _ref.label, onClick = _ref.onClick, onClickCapture = _ref.onClickCapture, onKeyDownCapture = _ref.onKeyDownCapture, onKeyUpCapture = _ref.onKeyUpCapture, onMouseDownCapture = _ref.onMouseDownCapture, onMouseUpCapture = _ref.onMouseUpCapture, onPointerDownCapture = _ref.onPointerDownCapture, onPointerUpCapture = _ref.onPointerUpCapture, onTouchEndCapture = _ref.onTouchEndCapture, onTouchStartCapture = _ref.onTouchStartCapture, ref = _ref.ref, shape = _ref.shape, shouldFitContainer = _ref.shouldFitContainer, spacing = _ref.spacing, testId = _ref.testId;
    var isCircle = shape === "circle";
    var baseProps = (0, $1aRSA.default)({
        analyticsContext: analyticsContext,
        appearance: appearance,
        autoFocus: autoFocus,
        ariaLabel: ariaLabel,
        ariaLabelledBy: ariaLabelledBy,
        buttonType: buttonType,
        children: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $itFuA.default), {
            type: "icon",
            isLoading: isLoading
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $2CIEr.default), {
            icon: icon
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $8zaFA.default), null, label)),
        interactionName: interactionName,
        isDisabled: isDisabled,
        isLoading: isLoading,
        isSelected: isSelected,
        isIconButton: true,
        isCircle: isCircle,
        onClick: onClick,
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onTouchStartCapture: onTouchStartCapture,
        onTouchEndCapture: onTouchEndCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onClickCapture: onClickCapture,
        ref: ref,
        shouldFitContainer: shouldFitContainer,
        spacing: spacing,
        testId: testId
    });
    return baseProps;
};
var $af3aa5e2269067d4$export$2e2bcd8739ae039 = $af3aa5e2269067d4$var$useIconButton;

});
parcelRegister("8zaFA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $63c9de65d3e8b43d$export$2e2bcd8739ae039; });
/* visually-hidden.tsx generated by @compiled/babel-plugin v0.36.1 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
// eslint-disable-next-line @atlaskit/design-system/use-visually-hidden

var $dAx5m = parcelRequire("dAx5m");

var $aF9LR = parcelRequire("aF9LR");
var $63c9de65d3e8b43d$var$visuallyHiddenStyles = null;
/**
 * __Visually hidden__
 *
 * A composable element to apply a visually hidden effect to children.
 * Useful for accessibility compliance.
 *
 * @example
 * ```jsx
 * import VisuallyHidden from '@atlaskit/visually-hidden';
 *
 * export default () => (
 *   <div style={{ border: '1px solid black' }}>
 *      There is text hidden between the brackets [
 *      <VisuallyHidden>Can't see me!</VisuallyHidden>]
 *   </div>
 * );
 * ```
 */ var $63c9de65d3e8b43d$var$VisuallyHidden = function VisuallyHidden(_ref) {
    var children = _ref.children, testId = _ref.testId, role = _ref.role, id = _ref.id;
    return /*#__PURE__*/ $dAx5m.createElement("span", {
        id: id,
        "data-testid": testId,
        role: role,
        className: (0, $aF9LR.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itidpf _1reo15vq _18m915vq _1bsbt94y _4t3it94y _kqswstnw _ogto7mnp _o5721q9c"
        ])
    }, children);
};
var $63c9de65d3e8b43d$export$2e2bcd8739ae039 = $63c9de65d3e8b43d$var$VisuallyHidden;

});

parcelRegister("itFuA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d73b1eeb27abc8d8$export$2e2bcd8739ae039; });

var $9OmEa = parcelRequire("9OmEa");

var $dAx5m = parcelRequire("dAx5m");

var $k5fVw = parcelRequire("k5fVw");
var $aDEaV = parcelRequire("aDEaV");
var $d73b1eeb27abc8d8$var$textStyles = (0, $aDEaV.xcss)({
    // content can grow and shrink
    flexGrow: 1,
    flexShrink: 1,
    // ellipsis for overflow text
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap"
});
var $d73b1eeb27abc8d8$var$iconStyles = (0, $aDEaV.xcss)({
    display: "flex",
    // icon size cannot grow and shrink
    flexGrow: 0,
    flexShrink: 0,
    alignSelf: "center",
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    fontSize: 0,
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: 0,
    userSelect: "none"
});
var $d73b1eeb27abc8d8$var$commonStyles = (0, $aDEaV.xcss)({
    transition: "opacity 0.3s"
});
var $d73b1eeb27abc8d8$var$fadeStyles = (0, $aDEaV.xcss)({
    opacity: 0
});
/**
 * These CSS variables consumed by the new icons, to allow them to have appropriate
 * padding inside Button while also maintaining spacing for the existing icons.
 *
 * These styles can be removed once the new icons are fully rolled out, feature flag
 * platform-visual-refresh-icons is cleaned up,
 * and we bump Button to set padding based on the new icons.
 */ var $d73b1eeb27abc8d8$var$beforeIconStyles = (0, $aDEaV.xcss)({
    // @ts-ignore
    "--ds--button--new-icon-padding-start": "var(--ds-space-050, 4px)",
    // @ts-ignore
    "--ds--button--new-icon-padding-end": "var(--ds-space-025, 2px)"
});
var $d73b1eeb27abc8d8$var$afterIconStyles = (0, $aDEaV.xcss)({
    // @ts-ignore
    "--ds--button--new-icon-padding-start": "var(--ds-space-025, 2px)",
    // @ts-ignore
    "--ds--button--new-icon-padding-end": "var(--ds-space-050, 4px)"
});
/**
 * __Content__
 *
 * Used for slots within a Button, including icons and text content.
 */ var $d73b1eeb27abc8d8$var$Content = function Content(_ref) {
    var children = _ref.children, _ref$type = _ref.type, type = _ref$type === void 0 ? "text" : _ref$type, isLoading = _ref.isLoading, position = _ref.position;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $k5fVw.default), {
        as: "span",
        xcss: [
            $d73b1eeb27abc8d8$var$commonStyles
        ].concat((0, (/*@__PURE__*/$parcel$interopDefault($9OmEa)))(type === "text" ? [
            $d73b1eeb27abc8d8$var$textStyles
        ] : [
            $d73b1eeb27abc8d8$var$iconStyles
        ]), (0, (/*@__PURE__*/$parcel$interopDefault($9OmEa)))(isLoading ? [
            $d73b1eeb27abc8d8$var$fadeStyles
        ] : []), (0, (/*@__PURE__*/$parcel$interopDefault($9OmEa)))(position === "before" ? [
            $d73b1eeb27abc8d8$var$beforeIconStyles
        ] : []), (0, (/*@__PURE__*/$parcel$interopDefault($9OmEa)))(position === "after" ? [
            $d73b1eeb27abc8d8$var$afterIconStyles
        ] : []))
    }, children);
};
var $d73b1eeb27abc8d8$export$2e2bcd8739ae039 = $d73b1eeb27abc8d8$var$Content;

});
parcelRegister("k5fVw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e9f0a1041d4a8cc3$export$2e2bcd8739ae039; });

var $sN2rQ = parcelRequire("sN2rQ");

var $dTYVX = parcelRequire("dTYVX");

var $dAx5m = parcelRequire("dAx5m");

var $jVTBW = parcelRequire("jVTBW");

var $gBwI2 = parcelRequire("gBwI2");

var $8xoOY = parcelRequire("8xoOY");

var $aDEaV = parcelRequire("aDEaV");
var $e9f0a1041d4a8cc3$var$_excluded = [
    "as",
    "children",
    "backgroundColor",
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    "style",
    "testId",
    "xcss"
], $e9f0a1041d4a8cc3$var$_excluded2 = [
    "className"
];
var $e9f0a1041d4a8cc3$export$e71c4d32a2263218 = /*#__PURE__*/ (0, $dAx5m.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? "div" : _ref$as, children = _ref.children, backgroundColor = _ref.backgroundColor, padding = _ref.padding, paddingBlock = _ref.paddingBlock, paddingBlockStart = _ref.paddingBlockStart, paddingBlockEnd = _ref.paddingBlockEnd, paddingInline = _ref.paddingInline, paddingInlineStart = _ref.paddingInlineStart, paddingInlineEnd = _ref.paddingInlineEnd, style = _ref.style, testId = _ref.testId, xcss = _ref.xcss, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($dTYVX)))(_ref, $e9f0a1041d4a8cc3$var$_excluded);
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($dTYVX)))(htmlAttributes, $e9f0a1041d4a8cc3$var$_excluded2);
    var resolvedStyles = (0, $aDEaV.parseXcss)(xcss);
    var node = // @ts-expect-error Expression produces a union type that is too complex to represent. I think this is unavoidable
    (0, $jVTBW.jsx)(Component, (0, (/*@__PURE__*/$parcel$interopDefault($sN2rQ)))({
        style: style,
        ref: ref,
        className: resolvedStyles.static
    }, safeHtmlAttributes, {
        css: [
            $e9f0a1041d4a8cc3$var$baseStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            backgroundColor && (0, $8xoOY.backgroundColorStylesMap)[backgroundColor],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $8xoOY.isSurfaceColorToken)(backgroundColor) && (0, $8xoOY.surfaceColorStylesMap)[backgroundColor],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            padding && (0, $8xoOY.paddingStylesMap).padding[padding],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlock && (0, $8xoOY.paddingStylesMap).paddingBlock[paddingBlock],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockStart && (0, $8xoOY.paddingStylesMap).paddingBlockStart[paddingBlockStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockEnd && (0, $8xoOY.paddingStylesMap).paddingBlockEnd[paddingBlockEnd],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInline && (0, $8xoOY.paddingStylesMap).paddingInline[paddingInline],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineStart && (0, $8xoOY.paddingStylesMap).paddingInlineStart[paddingInlineStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineEnd && (0, $8xoOY.paddingStylesMap).paddingInlineEnd[paddingInlineEnd],
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            resolvedStyles.emotion
        ],
        "data-testid": testId
    }), children);
    return backgroundColor ? (0, $jVTBW.jsx)((0, $gBwI2.SurfaceContext).Provider, {
        value: backgroundColor
    }, node) : node;
});
var $e9f0a1041d4a8cc3$export$2e2bcd8739ae039 = $e9f0a1041d4a8cc3$export$e71c4d32a2263218;
var $e9f0a1041d4a8cc3$var$baseStyles = (0, $jVTBW.css)({
    boxSizing: "border-box",
    appearance: "none",
    border: "none"
});

});
parcelRegister("gBwI2", function(module, exports) {

$parcel$export(module.exports, "SurfaceContext", function () { return $c1697973a2f94030$export$1ca2a26fecb070ae; });

var $dAx5m = parcelRequire("dAx5m");
var $c1697973a2f94030$export$1ca2a26fecb070ae = /*#__PURE__*/ (0, $dAx5m.createContext)("elevation.surface");
var $c1697973a2f94030$export$1aeb4f6b93c4540d = function useSurface() {
    return (0, $dAx5m.useContext)($c1697973a2f94030$export$1ca2a26fecb070ae);
};
$c1697973a2f94030$export$1ca2a26fecb070ae.displayName = "SurfaceProvider";

});



parcelRegister("2CIEr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1e91c42c35687657$export$2e2bcd8739ae039; });

var $dAx5m = parcelRequire("dAx5m");
function $1e91c42c35687657$var$isIconRenderProp(func) {
    return !func.displayName && // most function components and class components have a displayName, negate them
    !func.render && // forwardRef doesn't require a display name, however it does include a render function, negate them
    typeof func === "function" // at the very least we need to be a function
    ;
}
/**
 * __Icon renderer__
 *
 * Used to support render props with icons.
 *
 */ var $1e91c42c35687657$var$IconRenderer = function IconRenderer(_ref) {
    var Icon = _ref.icon;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).Fragment, null, $1e91c42c35687657$var$isIconRenderProp(Icon) ? Icon({
        label: "",
        color: "currentColor"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement(Icon, {
        label: "",
        color: "currentColor"
    }));
};
var $1e91c42c35687657$export$2e2bcd8739ae039 = $1e91c42c35687657$var$IconRenderer;

});

parcelRegister("1aRSA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0db084ecfaaad2b9$export$2e2bcd8739ae039; });

var $c6l2j = parcelRequire("c6l2j");

var $dAx5m = parcelRequire("dAx5m");

var $fHF59 = parcelRequire("fHF59");

var $86K4q = parcelRequire("86K4q");

var $ViONZ = parcelRequire("ViONZ");

var $18rB9 = parcelRequire("18rB9");

var $k5fVw = parcelRequire("k5fVw");
var $aDEaV = parcelRequire("aDEaV");

var $1zU5H = parcelRequire("1zU5H");

var $8zaFA = parcelRequire("8zaFA");

var $6cXDH = parcelRequire("6cXDH");

var $bkvra = parcelRequire("bkvra");

var $4ohgH = parcelRequire("4ohgH");

var $g34D9 = parcelRequire("g34D9");
function $0db084ecfaaad2b9$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $0db084ecfaaad2b9$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $0db084ecfaaad2b9$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($c6l2j)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $0db084ecfaaad2b9$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $0db084ecfaaad2b9$var$buttonStyles = (0, $aDEaV.xcss)({
    display: "inline-flex",
    boxSizing: "border-box",
    width: "auto",
    maxWidth: "100%",
    position: "relative",
    alignItems: "baseline",
    justifyContent: "center",
    columnGap: "space.050",
    borderRadius: "border.radius.100",
    borderWidth: "border.width.0",
    flexShrink: 0,
    height: "2rem",
    font: "font.body",
    fontWeight: "font.weight.medium",
    paddingBlock: "space.075",
    paddingInlineEnd: "space.150",
    paddingInlineStart: "space.150",
    textAlign: "center",
    transition: "background 0.1s ease-out",
    verticalAlign: "middle",
    "::after": {
        borderRadius: "inherit",
        inset: "space.0",
        borderStyle: "solid",
        borderWidth: "var(--ds-border-width, 1px)",
        pointerEvents: "none",
        position: "absolute"
    }
});
var $0db084ecfaaad2b9$var$defaultInteractiveStyles = (0, $aDEaV.xcss)({
    ":hover": {
        background: "var(--ds-background-neutral-hovered, #091e4214)",
        // @ts-expect-error
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        color: "var(--ds-text, ".concat($1zU5H.N500, ")")
    },
    ":active": {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        background: "var(--ds-background-neutral-pressed, ".concat($1zU5H.B75, ")"),
        // @ts-expect-error
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        color: "var(--ds-text, ".concat($1zU5H.B400, ")")
    }
});
var $0db084ecfaaad2b9$var$defaultInteractiveRefreshedStyles = (0, $aDEaV.xcss)({
    ":hover": {
        background: "var(--ds-background-neutral-subtle-hovered, #091E420F)",
        color: "color.text.subtle"
    },
    ":active": {
        background: "var(--ds-background-neutral-subtle-pressed, #091E4224)",
        color: "color.text.subtle"
    }
});
var $0db084ecfaaad2b9$var$defaultStyles = (0, $aDEaV.xcss)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
    background: "var(--ds-background-neutral, ".concat($1zU5H.N20A, ")"),
    // @ts-expect-error — using tokens for explicit fallback usage.
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values --  -- Ignored via go/DSP-18766
    color: "var(--ds-text, ".concat($1zU5H.N500, ")"),
    ":visited": {
        // @ts-expect-error
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        color: "var(--ds-text, ".concat($1zU5H.N500, ")")
    },
    ":hover": {
        // @ts-expect-error — using tokens for explicit fallback usage.
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values --  -- Ignored via go/DSP-18766
        color: "var(--ds-text, ".concat($1zU5H.N500, ")")
    },
    ":active": {
        // @ts-expect-error — using tokens for explicit fallback usage.
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values --  -- Ignored via go/DSP-18766
        color: "var(--ds-text, ".concat($1zU5H.N500, ")")
    },
    ":focus": {
        // @ts-expect-error — using tokens for explicit fallback usage.
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values --  -- Ignored via go/DSP-18766
        color: "var(--ds-text, ".concat($1zU5H.N500, ")")
    }
});
var $0db084ecfaaad2b9$var$defaultRefreshedStyles = (0, $aDEaV.xcss)({
    background: "var(--ds-background-neutral-subtle, #00000000)",
    color: "color.text.subtle",
    "::after": {
        content: '""',
        borderColor: "color.border"
    },
    ":visited": {
        color: "color.text.subtle"
    },
    ":hover": {
        color: "color.text.subtle"
    },
    ":active": {
        color: "color.text.subtle"
    },
    ":focus": {
        color: "color.text.subtle"
    }
});
var $0db084ecfaaad2b9$var$primaryStyles = (0, $aDEaV.xcss)({
    background: "var(--ds-background-brand-bold, #0052CC)",
    color: "color.text.inverse",
    ":visited": {
        color: "color.text.inverse"
    },
    ":hover": {
        color: "color.text.inverse"
    },
    ":active": {
        color: "color.text.inverse"
    },
    ":focus": {
        color: "color.text.inverse"
    }
});
var $0db084ecfaaad2b9$var$primaryInteractiveStyles = (0, $aDEaV.xcss)({
    ":hover": {
        // @ts-expect-error
        color: "var(--ds-text-inverse, #FFFFFF)",
        background: "var(--ds-background-brand-bold-hovered, #0065FF)"
    },
    ":active": {
        // @ts-expect-error
        color: "var(--ds-text-inverse, #FFFFFF)",
        background: "var(--ds-background-brand-bold-pressed, #0747A6)"
    }
});
var $0db084ecfaaad2b9$var$warningStyles = (0, $aDEaV.xcss)({
    background: "var(--ds-background-warning-bold, #FFAB00)",
    // @ts-expect-error
    color: "var(--ds-text-warning-inverse, #172B4D)",
    ":visited": {
        // @ts-expect-error
        color: "var(--ds-text-warning-inverse, #172B4D)"
    },
    ":hover": {
        // @ts-expect-error
        color: "var(--ds-text-warning-inverse, #172B4D)"
    },
    ":active": {
        // @ts-expect-error
        color: "var(--ds-text-warning-inverse, #172B4D)"
    },
    ":focus": {
        // @ts-expect-error
        color: "var(--ds-text-warning-inverse, #172B4D)"
    }
});
var $0db084ecfaaad2b9$var$warningInteractiveStyles = (0, $aDEaV.xcss)({
    ":hover": {
        // @ts-expect-error
        color: "var(--ds-text-warning-inverse, #172B4D)",
        background: "var(--ds-background-warning-bold-hovered, #FFC400)"
    },
    ":active": {
        // @ts-expect-error
        color: "var(--ds-text-warning-inverse, #172B4D)",
        background: "var(--ds-background-warning-bold-pressed, #FF991F)"
    }
});
var $0db084ecfaaad2b9$var$dangerStyles = (0, $aDEaV.xcss)({
    background: "var(--ds-background-danger-bold, #DE350B)",
    color: "color.text.inverse",
    ":visited": {
        color: "color.text.inverse"
    },
    ":hover": {
        color: "color.text.inverse"
    },
    ":active": {
        color: "color.text.inverse"
    },
    ":focus": {
        color: "color.text.inverse"
    }
});
var $0db084ecfaaad2b9$var$dangerInteractiveStyles = (0, $aDEaV.xcss)({
    ":hover": {
        color: "color.text.inverse",
        background: "var(--ds-background-danger-bold-hovered, #FF5630)"
    },
    ":active": {
        color: "color.text.inverse",
        background: "var(--ds-background-danger-bold-pressed, #BF2600)"
    }
});
var $0db084ecfaaad2b9$var$discoveryStyles = (0, $aDEaV.xcss)({
    background: "var(--ds-background-discovery-bold, #5243AA)",
    color: "color.text.inverse",
    ":visited": {
        color: "color.text.inverse"
    },
    ":hover": {
        color: "color.text.inverse"
    },
    ":active": {
        color: "color.text.inverse"
    },
    ":focus": {
        color: "color.text.inverse"
    }
});
var $0db084ecfaaad2b9$var$discoveryInteractiveStyles = (0, $aDEaV.xcss)({
    ":hover": {
        color: "color.text.inverse",
        background: "var(--ds-background-discovery-bold-hovered, #8777D9)"
    },
    ":active": {
        color: "color.text.inverse",
        background: "var(--ds-background-discovery-bold-pressed, #5243AA)"
    }
});
var $0db084ecfaaad2b9$var$subtleStyles = (0, $aDEaV.xcss)({
    background: "var(--ds-background-neutral-subtle, transparent)",
    // @ts-expect-error
    color: "var(--ds-text, #42526E)",
    ":visited": {
        // @ts-expect-error
        color: "var(--ds-text, #42526E)"
    },
    ":hover": {
        // @ts-expect-error
        color: "var(--ds-text, #42526E)"
    },
    ":active": {
        // @ts-expect-error
        color: "var(--ds-text, #42526E)"
    },
    ":focus": {
        // @ts-expect-error
        color: "var(--ds-text, #42526E)"
    }
});
var $0db084ecfaaad2b9$var$subtleRefreshedStyles = (0, $aDEaV.xcss)({
    background: "var(--ds-background-neutral-subtle, transparent)",
    color: "color.text.subtle",
    ":visited": {
        color: "color.text.subtle"
    },
    ":hover": {
        color: "color.text.subtle"
    },
    ":active": {
        color: "color.text.subtle"
    },
    ":focus": {
        color: "color.text.subtle"
    }
});
var $0db084ecfaaad2b9$var$subtleInteractiveStyles = (0, $aDEaV.xcss)({
    ":hover": {
        background: "var(--ds-background-neutral-subtle-hovered, #091e4214)",
        // @ts-expect-error
        color: "var(--ds-text, #42526E)"
    },
    ":active": {
        background: "var(--ds-background-neutral-subtle-pressed, #B3D4FF)",
        // @ts-expect-error
        color: "var(--ds-text, #42526E)"
    }
});
var $0db084ecfaaad2b9$var$subtleInteractiveRefreshedStyles = (0, $aDEaV.xcss)({
    ":hover": {
        background: "var(--ds-background-neutral-subtle-hovered, #091e4214)",
        color: "color.text.subtle"
    },
    ":active": {
        background: "var(--ds-background-neutral-subtle-pressed, #B3D4FF)",
        color: "color.text.subtle"
    }
});
// Reinforce existing styles with higher specificity
// to defend against global anchor styles from products,
// preventing issues in Jira and Confluence.
var $0db084ecfaaad2b9$var$linkDefensiveStyles = (0, $aDEaV.xcss)({
    textDecoration: "none",
    ":hover": {
        textDecoration: "none"
    },
    ":active": {
        textDecoration: "none"
    },
    ":focus": {
        textDecoration: "none"
    },
    ":visited": {
        textDecoration: "none"
    }
});
var $0db084ecfaaad2b9$var$disabledStyles = (0, $aDEaV.xcss)({
    cursor: "not-allowed",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    background: "var(--ds-background-disabled, ".concat($1zU5H.N20A, ")"),
    color: "color.text.disabled",
    "::after": {
        content: "none"
    },
    ":visited": {
        color: "color.text.disabled"
    },
    ":hover": {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        background: "var(--ds-background-disabled, ".concat($1zU5H.N20A, ")"),
        color: "color.text.disabled"
    },
    ":active": {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        background: "var(--ds-background-disabled, ".concat($1zU5H.N20A, ")"),
        color: "color.text.disabled"
    },
    ":focus": {
        color: "color.text.disabled"
    }
});
var $0db084ecfaaad2b9$var$selectedStyles = (0, $aDEaV.xcss)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    background: "var(--ds-background-selected, ".concat($1zU5H.N700, ")"),
    // @ts-expect-error
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    color: "var(--ds-text-selected, ".concat($1zU5H.N20, ")"),
    ":visited": {
        // @ts-expect-error
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        color: "var(--ds-text-selected, ".concat($1zU5H.N20, ")")
    },
    ":hover": {
        // @ts-expect-error
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        color: "var(--ds-text-selected, ".concat($1zU5H.N20, ")")
    },
    ":active": {
        // @ts-expect-error
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        color: "var(--ds-text-selected, ".concat($1zU5H.N20, ")")
    },
    ":focus": {
        // @ts-expect-error
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        color: "var(--ds-text-selected, ".concat($1zU5H.N20, ")")
    }
});
var $0db084ecfaaad2b9$var$selectedRefreshedStyles = (0, $aDEaV.xcss)({
    background: "var(--ds-background-selected, #E9F2FF)",
    color: "color.text.selected",
    "::after": {
        content: '""',
        borderColor: "color.border.selected"
    },
    ":visited": {
        color: "color.text.selected"
    },
    ":hover": {
        color: "color.text.selected"
    },
    ":active": {
        color: "color.text.selected"
    },
    ":focus": {
        color: "color.text.selected"
    }
});
var $0db084ecfaaad2b9$var$selectedInsideSplitButtonStyles = (0, $aDEaV.xcss)({
    // This is 2 so it appears above the split button divider when selected.
    // See split-button.tsx.
    // @ts-expect-error — We need a local zindex just for button.
    zIndex: 2
});
var $0db084ecfaaad2b9$var$selectedInteractiveStyles = (0, $aDEaV.xcss)({
    ":hover": {
        // @ts-expect-error
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        color: "var(--ds-text-selected, ".concat($1zU5H.N20, ")"),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        background: "var(--ds-background-selected-hovered, ".concat($1zU5H.N700, ")")
    },
    ":active": {
        // @ts-expect-error
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        color: "var(--ds-text-selected, ".concat($1zU5H.N20, ")"),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        background: "var(--ds-background-selected-pressed, ".concat($1zU5H.N700, ")")
    }
});
// TODO: Remove me once we kill color fallbacks
var $0db084ecfaaad2b9$var$selectedWarningStyles = (0, $aDEaV.xcss)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    background: "var(--ds-background-selected, ".concat($1zU5H.Y400, ")"),
    // @ts-expect-error
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    color: "var(--ds-text-selected, ".concat($1zU5H.N800, ")"),
    ":hover": {
        // @ts-expect-error
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        color: "var(--ds-text-selected, ".concat($1zU5H.N20, ")"),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        background: "var(--ds-background-selected, ".concat($1zU5H.Y400, ")")
    },
    ":active": {
        // @ts-expect-error
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        color: "var(--ds-text-selected, ".concat($1zU5H.N20, ")"),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        background: "var(--ds-background-selected, ".concat($1zU5H.Y400, ")")
    }
});
// TODO: Remove me once we kill color fallbacks
var $0db084ecfaaad2b9$var$selectedDangerStyles = (0, $aDEaV.xcss)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    background: "var(--ds-background-selected, ".concat($1zU5H.R500, ")"),
    // @ts-expect-error
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    color: "var(--ds-text-selected, ".concat($1zU5H.N20, ")"),
    ":hover": {
        // @ts-expect-error
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        color: "var(--ds-text-selected, ".concat($1zU5H.N20, ")"),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        background: "var(--ds-background-selected, ".concat($1zU5H.R500, ")")
    },
    ":active": {
        // @ts-expect-error
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        color: "var(--ds-text-selected, ".concat($1zU5H.N20, ")"),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        background: "var(--ds-background-selected, ".concat($1zU5H.R500, ")")
    }
});
// TODO: Remove me once we kill color fallbacks
var $0db084ecfaaad2b9$var$selectedDiscoveryStyles = (0, $aDEaV.xcss)({
    background: "var(--ds-background-selected, #403294)",
    // @ts-expect-error
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    color: "var(--ds-text-selected, ".concat($1zU5H.N20, ")"),
    ":hover": {
        // @ts-expect-error
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        color: "var(--ds-text-selected, ".concat($1zU5H.N20, ")"),
        background: "var(--ds-background-selected, #403294)"
    },
    ":active": {
        // @ts-expect-error
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        color: "var(--ds-text-selected, ".concat($1zU5H.N20, ")"),
        background: "var(--ds-background-selected, #403294)"
    }
});
var $0db084ecfaaad2b9$var$spacingCompactStyles = (0, $aDEaV.xcss)({
    columnGap: "space.050",
    height: "1.5rem",
    paddingBlock: "space.025",
    paddingInlineEnd: "space.150",
    paddingInlineStart: "space.150",
    verticalAlign: "middle"
});
var $0db084ecfaaad2b9$var$circleStyles = (0, $aDEaV.xcss)({
    borderRadius: "border.radius.circle"
});
var $0db084ecfaaad2b9$var$fullWidthStyles = (0, $aDEaV.xcss)({
    width: "100%"
});
var $0db084ecfaaad2b9$var$loadingStyles = (0, $aDEaV.xcss)({
    cursor: "progress"
});
var $0db084ecfaaad2b9$var$iconButtonStyles = (0, $aDEaV.xcss)({
    height: "2rem",
    width: "2rem",
    paddingInlineEnd: "space.0",
    paddingInlineStart: "space.0"
});
var $0db084ecfaaad2b9$var$iconButtonCompactStyles = (0, $aDEaV.xcss)({
    width: "1.5rem",
    height: "1.5rem"
});
var $0db084ecfaaad2b9$var$buttonIconBeforeStyles = (0, $aDEaV.xcss)({
    paddingInlineStart: "space.100"
});
var $0db084ecfaaad2b9$var$buttonIconAfterStyles = (0, $aDEaV.xcss)({
    paddingInlineEnd: "space.100"
});
var $0db084ecfaaad2b9$var$splitButtonStyles = (0, $aDEaV.xcss)({
    ":focus-visible": {
        zIndex: "card"
    }
});
var $0db084ecfaaad2b9$var$navigationSplitButtonStyles = (0, $aDEaV.xcss)({
    width: "24px",
    backgroundColor: "color.background.neutral.subtle",
    paddingInlineEnd: "space.075",
    paddingInlineStart: "space.075"
});
var $0db084ecfaaad2b9$var$loadingOverlayStyles = (0, $aDEaV.xcss)({
    display: "flex",
    position: "absolute",
    alignItems: "center",
    justifyContent: "center",
    insetBlockEnd: "space.0",
    insetBlockStart: "space.0",
    insetInlineEnd: "space.0",
    insetInlineStart: "space.0"
});
/**
 * __Use button base__
 *
 * A React hook that accepts a set of common Button props,
 * and processes them to return consistent base props for usage
 * across various Button components.
 *
 * It also:
 * - Implements auto focus when enabled.
 * - Appends the `onClick` event with UFO analytics tracking.
 *
 * @private
 */ var $0db084ecfaaad2b9$var$useButtonBase = function useButtonBase(_ref) {
    var _ref$appearance = _ref.appearance, propAppearance = _ref$appearance === void 0 ? "default" : _ref$appearance, _ref$autoFocus = _ref.autoFocus, autoFocus = _ref$autoFocus === void 0 ? false : _ref$autoFocus, buttonType = _ref.buttonType, _ref$isDisabled = _ref.isDisabled, propIsDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled, _ref$isLoading = _ref.isLoading, isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading, _ref$isSelected = _ref.isSelected, propIsSelected = _ref$isSelected === void 0 ? false : _ref$isSelected, _ref$isIconButton = _ref.isIconButton, isIconButton = _ref$isIconButton === void 0 ? false : _ref$isIconButton, _ref$isCircle = _ref.isCircle, isCircle = _ref$isCircle === void 0 ? false : _ref$isCircle, _ref$hasIconBefore = _ref.hasIconBefore, hasIconBefore = _ref$hasIconBefore === void 0 ? false : _ref$hasIconBefore, _ref$hasIconAfter = _ref.hasIconAfter, hasIconAfter = _ref$hasIconAfter === void 0 ? false : _ref$hasIconAfter, children = _ref.children, onClick = _ref.onClick, onMouseDownCapture = _ref.onMouseDownCapture, onMouseUpCapture = _ref.onMouseUpCapture, onKeyDownCapture = _ref.onKeyDownCapture, onKeyUpCapture = _ref.onKeyUpCapture, onTouchStartCapture = _ref.onTouchStartCapture, onTouchEndCapture = _ref.onTouchEndCapture, onPointerDownCapture = _ref.onPointerDownCapture, onPointerUpCapture = _ref.onPointerUpCapture, onClickCapture = _ref.onClickCapture, ref = _ref.ref, _ref$shouldFitContain = _ref.shouldFitContainer, shouldFitContainer = _ref$shouldFitContain === void 0 ? false : _ref$shouldFitContain, _ref$spacing = _ref.spacing, propSpacing = _ref$spacing === void 0 ? "default" : _ref$spacing, testId = _ref.testId, ariaLabel = _ref.ariaLabel, ariaLabelledBy = _ref.ariaLabelledBy;
    var localRef = (0, $dAx5m.useRef)(null);
    var splitButtonContext = (0, $6cXDH.useSplitButtonContext)();
    var loadingLabelId = (0, $ViONZ.useId)();
    var isSplitButton = Boolean(splitButtonContext);
    var isNavigationSplitButton = (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.isNavigationSplitButton) || false;
    var isDefaultAppearanceSplitButton = (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.appearance) === "default";
    var appearance = isDefaultAppearanceSplitButton && (0, $18rB9.fg)("platform-component-visual-refresh") ? "subtle" : (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.appearance) || propAppearance;
    var spacing = (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.spacing) || propSpacing;
    var isDisabled = (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.isDisabled) || propIsDisabled;
    var isInteractive = !isDisabled && !isLoading;
    // Also treat loading buttons as disabled
    var isEffectivelyDisabled = isDisabled || isLoading;
    var isSelected = propIsSelected && !isDisabled;
    (0, $86K4q.default)(localRef, autoFocus);
    return $0db084ecfaaad2b9$var$_objectSpread({
        ref: (0, $fHF59.default)([
            localRef,
            ref
        ]),
        xcss: [
            $0db084ecfaaad2b9$var$buttonStyles,
            appearance === "default" && ((0, $18rB9.fg)("platform-component-visual-refresh") ? $0db084ecfaaad2b9$var$defaultRefreshedStyles : $0db084ecfaaad2b9$var$defaultStyles),
            appearance === "default" && isInteractive && ((0, $18rB9.fg)("platform-component-visual-refresh") ? $0db084ecfaaad2b9$var$defaultInteractiveRefreshedStyles : $0db084ecfaaad2b9$var$defaultInteractiveStyles),
            appearance === "primary" && $0db084ecfaaad2b9$var$primaryStyles,
            appearance === "primary" && isInteractive && $0db084ecfaaad2b9$var$primaryInteractiveStyles,
            appearance === "warning" && $0db084ecfaaad2b9$var$warningStyles,
            appearance === "warning" && isInteractive && $0db084ecfaaad2b9$var$warningInteractiveStyles,
            appearance === "danger" && $0db084ecfaaad2b9$var$dangerStyles,
            appearance === "danger" && isInteractive && $0db084ecfaaad2b9$var$dangerInteractiveStyles,
            appearance === "discovery" && $0db084ecfaaad2b9$var$discoveryStyles,
            appearance === "discovery" && isInteractive && $0db084ecfaaad2b9$var$discoveryInteractiveStyles,
            appearance === "subtle" && ((0, $18rB9.fg)("platform-component-visual-refresh") ? $0db084ecfaaad2b9$var$subtleRefreshedStyles : $0db084ecfaaad2b9$var$subtleStyles),
            appearance === "subtle" && isInteractive && ((0, $18rB9.fg)("platform-component-visual-refresh") ? $0db084ecfaaad2b9$var$subtleInteractiveRefreshedStyles : $0db084ecfaaad2b9$var$subtleInteractiveStyles),
            buttonType === "link" && $0db084ecfaaad2b9$var$linkDefensiveStyles,
            isSelected && ((0, $18rB9.fg)("platform-component-visual-refresh") ? $0db084ecfaaad2b9$var$selectedRefreshedStyles : $0db084ecfaaad2b9$var$selectedStyles),
            isSelected && isSplitButton && $0db084ecfaaad2b9$var$selectedInsideSplitButtonStyles,
            isSelected && isInteractive && $0db084ecfaaad2b9$var$selectedInteractiveStyles,
            // TODO: remove me once we kill color fallbacks
            isSelected && appearance === "danger" && $0db084ecfaaad2b9$var$selectedDangerStyles,
            // TODO: remove me once we kill color fallbacks
            isSelected && appearance === "warning" && $0db084ecfaaad2b9$var$selectedWarningStyles,
            // TODO: remove me once we kill color fallbacks
            isSelected && appearance === "discovery" && $0db084ecfaaad2b9$var$selectedDiscoveryStyles,
            isDisabled && $0db084ecfaaad2b9$var$disabledStyles,
            isCircle && !isSplitButton && $0db084ecfaaad2b9$var$circleStyles,
            spacing === "compact" && $0db084ecfaaad2b9$var$spacingCompactStyles,
            hasIconBefore && $0db084ecfaaad2b9$var$buttonIconBeforeStyles,
            hasIconAfter && $0db084ecfaaad2b9$var$buttonIconAfterStyles,
            isIconButton && $0db084ecfaaad2b9$var$iconButtonStyles,
            isIconButton && spacing === "compact" && $0db084ecfaaad2b9$var$iconButtonCompactStyles,
            shouldFitContainer && $0db084ecfaaad2b9$var$fullWidthStyles,
            isLoading && $0db084ecfaaad2b9$var$loadingStyles,
            isSplitButton && $0db084ecfaaad2b9$var$splitButtonStyles,
            isNavigationSplitButton && $0db084ecfaaad2b9$var$navigationSplitButtonStyles
        ],
        isDisabled: isEffectivelyDisabled,
        children: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $6cXDH.SplitButtonContext).Provider, {
            value: undefined
        }, children, isLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $k5fVw.default), {
            as: "span",
            xcss: $0db084ecfaaad2b9$var$loadingOverlayStyles
        }, (0, $g34D9.default)({
            spacing: spacing,
            appearance: appearance,
            isDisabled: isDisabled,
            isSelected: isSelected,
            testId: testId
        })) : null, isLoading && (children && !ariaLabel && !ariaLabelledBy || ariaLabelledBy) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $8zaFA.default), {
            id: loadingLabelId
        }, (0, $4ohgH.LOADING_LABEL))),
        "aria-label": isLoading && ariaLabel && !ariaLabelledBy ? "".concat(ariaLabel, " ").concat((0, $4ohgH.LOADING_LABEL)) : ariaLabel,
        "aria-labelledby": isLoading && ariaLabelledBy ? "".concat(ariaLabelledBy, " ").concat(loadingLabelId) : ariaLabelledBy
    }, (0, $bkvra.default)(isEffectivelyDisabled, {
        onClick: onClick,
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onTouchStartCapture: onTouchStartCapture,
        onTouchEndCapture: onTouchEndCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onClickCapture: onClickCapture
    }));
};
var $0db084ecfaaad2b9$export$2e2bcd8739ae039 = $0db084ecfaaad2b9$var$useButtonBase;

});
parcelRegister("fHF59", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b6eabd357f1dc646$export$2e2bcd8739ae039; });
/**
 * Assigns the node to all the refs passed in the argument.
 *
 * @param refs: An array of refs (as function or ref object)
 */ function $b6eabd357f1dc646$export$2e2bcd8739ae039(refs) {
    // TODO: could this be wrapped in `useCallback` so we get a stable function?
    return function(value) {
        refs.forEach(function(ref) {
            if (typeof ref === "function") ref(value);
            else if (ref !== null) ref.current = value;
        });
    };
}

});

parcelRegister("86K4q", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5e729ee32e6b83a9$export$2e2bcd8739ae039; });

var $dAx5m = parcelRequire("dAx5m");
function $5e729ee32e6b83a9$export$2e2bcd8739ae039(ref, autoFocus) {
    var initialMount = (0, $dAx5m.useRef)(true);
    (0, $dAx5m.useEffect)(function() {
        if (ref && initialMount.current && autoFocus && ref.current) ref.current.focus();
        initialMount.current = false;
    }, [
        autoFocus,
        ref
    ]);
}

});

parcelRegister("6cXDH", function(module, exports) {

$parcel$export(module.exports, "SplitButtonContext", function () { return $4852202aa8e046f3$export$4b86304b2c0d7e71; });
$parcel$export(module.exports, "useSplitButtonContext", function () { return $4852202aa8e046f3$export$47e2c6fdb142d947; });

var $dAx5m = parcelRequire("dAx5m");
var $4852202aa8e046f3$export$4b86304b2c0d7e71 = /*#__PURE__*/ (0, $dAx5m.createContext)(undefined);
var $4852202aa8e046f3$export$47e2c6fdb142d947 = function useSplitButtonContext() {
    var context = (0, $dAx5m.useContext)($4852202aa8e046f3$export$4b86304b2c0d7e71);
    if (!context) return undefined;
    if (context.appearance === "navigation") {
        var newContext = {
            spacing: "default",
            appearance: "subtle",
            isDisabled: false,
            isActiveOverSelected: false,
            isNavigationSplitButton: true,
            isHighlighted: context.isHighlighted
        };
        return newContext;
    }
    var splitButtonContext = {
        spacing: context.spacing,
        appearance: context.appearance,
        isDisabled: context.isDisabled,
        isActiveOverSelected: true,
        isNavigationSplitButton: false,
        isHighlighted: false
    };
    return splitButtonContext;
};

});

parcelRegister("bkvra", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $83f9f2bf8cc587e4$export$2e2bcd8739ae039; });
function $83f9f2bf8cc587e4$var$abort(event) {
    event.preventDefault();
    event.stopPropagation();
}
var $83f9f2bf8cc587e4$var$tabKeyCode = 9;
function $83f9f2bf8cc587e4$var$onKey(event) {
    // Allowing tab so that a user can move focus away
    if (event.keyCode === $83f9f2bf8cc587e4$var$tabKeyCode) return;
    $83f9f2bf8cc587e4$var$abort(event);
}
function $83f9f2bf8cc587e4$export$2e2bcd8739ae039(shouldBlockEvents, events) {
    return shouldBlockEvents ? {
        onMouseDownCapture: $83f9f2bf8cc587e4$var$abort,
        onMouseUpCapture: $83f9f2bf8cc587e4$var$abort,
        onKeyDownCapture: $83f9f2bf8cc587e4$var$onKey,
        onKeyUpCapture: $83f9f2bf8cc587e4$var$onKey,
        onTouchStartCapture: $83f9f2bf8cc587e4$var$abort,
        onTouchEndCapture: $83f9f2bf8cc587e4$var$abort,
        onPointerDownCapture: $83f9f2bf8cc587e4$var$abort,
        onPointerUpCapture: $83f9f2bf8cc587e4$var$abort,
        onClickCapture: $83f9f2bf8cc587e4$var$abort,
        // Just smashing the existing onClick for good measure
        onClick: $83f9f2bf8cc587e4$var$abort
    } : events;
}

});

parcelRegister("4ohgH", function(module, exports) {

$parcel$export(module.exports, "LOADING_LABEL", function () { return $3326cc71a3cd0b32$export$d4c5499dc806c969; });
var $3326cc71a3cd0b32$export$d4c5499dc806c969 = ", Loading";

});

parcelRegister("g34D9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $baf084a73f16b932$export$2e2bcd8739ae039; });

var $dAx5m = parcelRequire("dAx5m");

var $1c0XY = parcelRequire("1c0XY");
function $baf084a73f16b932$var$getIconSpacing(spacing) {
    switch(spacing){
        case "compact":
            return "small";
        default:
            return "medium";
    }
}
function $baf084a73f16b932$var$getSpinnerAppearance(_ref) {
    var appearance = _ref.appearance, isDisabled = _ref.isDisabled, isSelected = _ref.isSelected;
    if (isDisabled || isSelected) return "inherit";
    if (appearance === "primary" || appearance === "danger" || appearance === "discovery") return "invert";
    return "inherit";
}
function $baf084a73f16b932$export$2e2bcd8739ae039(_ref2) {
    var appearance = _ref2.appearance, spacing = _ref2.spacing, isDisabled = _ref2.isDisabled, isSelected = _ref2.isSelected, testId = _ref2.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $1c0XY.default), {
        size: $baf084a73f16b932$var$getIconSpacing(spacing),
        appearance: $baf084a73f16b932$var$getSpinnerAppearance({
            appearance: appearance,
            isDisabled: isDisabled,
            isSelected: isSelected
        }),
        testId: testId ? "".concat(testId, "--loading-spinner") : undefined
    });
}

});
parcelRegister("1c0XY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0de7a9512502561c$export$2e2bcd8739ae039; });
/* spinner.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $aF9LR = parcelRequire("aF9LR");

var $dAx5m = parcelRequire("dAx5m");

var $cYAkF = parcelRequire("cYAkF");

var $1zU5H = parcelRequire("1zU5H");

var $e79OG = parcelRequire("e79OG");
/**
 * Returns the appropriate circle stroke color.
 */ function $0de7a9512502561c$var$getStrokeColor(appearance) {
    return appearance === "inherit" ? "var(--ds-icon-subtle, ".concat((0, $1zU5H.N500), ")") : "var(--ds-icon-inverse, ".concat((0, $1zU5H.N0), ")");
}
var $0de7a9512502561c$var$rotate = null;
/**
 * There are three parts to the load in animation:
 * 1. Fade in
 * 2. Accelerated spin
 * 3. Stretch the spinner line
 */ var $0de7a9512502561c$var$loadIn = null;
var $0de7a9512502561c$var$styles = {
    rotateStyles: "_y44v1ozz _1pgl2qsq _8hrz1h6o",
    loadInStyles: "_y44v1a7z _1o51q7pw _tzy4idpf",
    wrapperStyles: "_1e0c116y _s7n4nkob",
    circleStyles: "_lswuglyw _7ljx1dhp _opj11kw7 _134c892t _1snbbs82 _jcxd7g3v _1tjm1onz"
};
/**
 * `useLayoutEffect` is being used in SSR safe form. On the server, this work doesn’t need to run.
 * `useEffect` is used in-place, because `useEffect` is not run on the server and it matches types
 * which makes things simpler than doing an `isServer` check or a `null` check.
 *
 * @see https://hello.atlassian.net/wiki/spaces/DST/pages/2081696628/DSTDACI-010+-+Interaction+Tracing+hooks+in+DS+components
 */ var $0de7a9512502561c$var$useLayoutEffect = typeof window === "undefined" ? (0, $dAx5m.useEffect) : (0, $dAx5m.useLayoutEffect);
/**
 * __Spinner__
 *
 * A spinner is an animated spinning icon that lets users know content is being loaded.
 *
 * - [Examples](https://atlassian.design/components/spinner/examples)
 * - [Code](https://atlassian.design/components/spinner/code)
 * - [Usage](https://atlassian.design/components/spinner/usage)
 */ var $0de7a9512502561c$var$Spinner = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).forwardRef(function Spinner(_ref, ref) {
    var _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "inherit" : _ref$appearance, _ref$delay = _ref.delay, delay = _ref$delay === void 0 ? 0 : _ref$delay, interactionName = _ref.interactionName, label = _ref.label, _ref$size = _ref.size, providedSize = _ref$size === void 0 ? "medium" : _ref$size, testId = _ref.testId;
    var size = typeof providedSize === "number" ? providedSize : (0, $e79OG.presetSizes)[providedSize];
    var animationDelay = "".concat(delay, "ms");
    var stroke = $0de7a9512502561c$var$getStrokeColor(appearance);
    var context = (0, $dAx5m.useContext)((0, $cYAkF.default));
    $0de7a9512502561c$var$useLayoutEffect(function() {
        if (context != null) return context.hold(interactionName);
    }, [
        context,
        interactionName
    ]);
    /**
   * The Spinner animation uses a combination of two
   * css animations on two separate elements.
   */ return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement("span", {
        "data-testid": testId ? "".concat(testId, "-wrapper") : "spinner-wrapper",
        style: {
            animationDelay: animationDelay,
            width: size,
            height: size
        },
        className: (0, $aF9LR.default)([
            $0de7a9512502561c$var$styles.wrapperStyles,
            $0de7a9512502561c$var$styles.rotateStyles
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement("svg", {
        height: size,
        width: size,
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        "data-testid": testId,
        ref: ref,
        "aria-label": label || undefined,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            animationDelay: animationDelay
        },
        role: label ? "img" : "none",
        className: (0, $aF9LR.default)([
            $0de7a9512502561c$var$styles.loadInStyles
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement("circle", {
        cx: "8",
        cy: "8",
        r: "7",
        style: {
            stroke: stroke
        },
        className: (0, $aF9LR.default)([
            $0de7a9512502561c$var$styles.circleStyles
        ])
    })));
}));
var $0de7a9512502561c$export$2e2bcd8739ae039 = $0de7a9512502561c$var$Spinner;

});
parcelRegister("e79OG", function(module, exports) {

$parcel$export(module.exports, "presetSizes", function () { return $a469557a1a866e15$export$4e9f1640bbe7a1a8; });
var $a469557a1a866e15$export$4e9f1640bbe7a1a8 = {
    xsmall: 8,
    small: 16,
    medium: 24,
    large: 48,
    xlarge: 96
};

});






parcelRegister("b9R5N", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::707984c4bf43fbcb724a560e605082a5>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $81f9b80bc1a57663$var$_react = $81f9b80bc1a57663$var$_interopRequireDefault((parcelRequire("dAx5m")));

var $81f9b80bc1a57663$var$_arrowLeft = $81f9b80bc1a57663$var$_interopRequireDefault((parcelRequire("ivBwc")));

var $81f9b80bc1a57663$var$_arrowLeft2 = $81f9b80bc1a57663$var$_interopRequireDefault((parcelRequire("eJNgi")));
function $81f9b80bc1a57663$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ArrowLeftIcon.
 * This component is ArrowLeftIcon, with `UNSAFE_fallbackIcon` set to "ArrowLeftIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: back to previous screen, previous slide.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $81f9b80bc1a57663$var$ArrowLeftIcon = (props)=>/*#__PURE__*/ $81f9b80bc1a57663$var$_react.default.createElement($81f9b80bc1a57663$var$_arrowLeft.default, Object.assign({
        LEGACY_fallbackIcon: $81f9b80bc1a57663$var$_arrowLeft2.default
    }, props));
$81f9b80bc1a57663$var$ArrowLeftIcon.Name = "ArrowLeftIconMigration";
var $81f9b80bc1a57663$var$_default = module.exports.default = $81f9b80bc1a57663$var$ArrowLeftIcon;

});
parcelRegister("ivBwc", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::efa63c6a59a6ee993a0458e40fc93a18>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d79839a0b4cb7858$var$_react = $d79839a0b4cb7858$var$_interopRequireDefault((parcelRequire("dAx5m")));

var $d79839a0b4cb7858$var$_baseNew = $d79839a0b4cb7858$var$_interopRequireDefault((parcelRequire("cJc6Q")));
function $d79839a0b4cb7858$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ArrowLeft".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: back to previous screen, previous slide.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d79839a0b4cb7858$var$ArrowLeftIcon = (props)=>/*#__PURE__*/ $d79839a0b4cb7858$var$_react.default.createElement($d79839a0b4cb7858$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m1.22 7.47 5-5 1.06 1.06-3.72 3.72H15v1.5H3.56l3.72 3.72-1.06 1.06-5-5a.75.75 0 0 1 0-1.06" clip-rule="evenodd"/>`
    }, props));
$d79839a0b4cb7858$var$ArrowLeftIcon.displayName = "ArrowLeftIcon";
var $d79839a0b4cb7858$var$_default = module.exports.default = $d79839a0b4cb7858$var$ArrowLeftIcon;

});
parcelRegister("cJc6Q", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("6I7lk")).default; });
$parcel$export(module.exports, "Icon", function () { return (parcelRequire("6I7lk")).Icon; });

var $6I7lk = parcelRequire("6I7lk");

});
parcelRegister("6I7lk", function(module, exports) {

$parcel$export(module.exports, "Icon", function () { return $4e2c8c4ba6b5b0ad$export$f04a61298a47a40f; });
$parcel$export(module.exports, "default", function () { return $4e2c8c4ba6b5b0ad$export$2e2bcd8739ae039; });
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $dAx5m = parcelRequire("dAx5m");

var $jVTBW = parcelRequire("jVTBW");

var $18rB9 = parcelRequire("18rB9");
/**
 * We are hiding this props from consumers as it's reserved
 * for use by Icon Tile.
 */ var $4e2c8c4ba6b5b0ad$var$commonSVGStyles = (0, $jVTBW.css)({
    overflow: "hidden",
    pointerEvents: "none",
    /**
   * Stop-color doesn't properly apply in chrome when the inherited/current color changes.
   * We have to initially set stop-color to inherit (either via DOM attribute or an initial CSS
   * rule) and then override it with currentColor for the color changes to be picked up.
   */ // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    stop: {
        stopColor: "currentColor"
    }
});
var $4e2c8c4ba6b5b0ad$var$svgStyles = (0, $jVTBW.css)({
    color: "currentColor",
    verticalAlign: "bottom"
});
var $4e2c8c4ba6b5b0ad$var$iconStyles = (0, $jVTBW.css)({
    display: "inline-block",
    boxSizing: "border-box",
    flexShrink: 0,
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: 1,
    paddingInlineEnd: "var(--ds--button--new-icon-padding-end, 0)",
    paddingInlineStart: "var(--ds--button--new-icon-padding-start, 0)"
});
var $4e2c8c4ba6b5b0ad$var$utilityIconStyles = (0, $jVTBW.css)({
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: "var(--ds-space-150, 12px)"
});
var $4e2c8c4ba6b5b0ad$var$scaleStyles = (0, $jVTBW.css)({
    width: "inherit",
    height: "inherit"
});
/**
 * For windows high contrast mode
 */ var $4e2c8c4ba6b5b0ad$var$baseHcmStyles = (0, $jVTBW.css)({
    "@media screen and (forced-colors: active)": {
        color: "CanvasText",
        filter: "grayscale(1)"
    }
});
var $4e2c8c4ba6b5b0ad$var$scaleSize = (0, $jVTBW.css)({
    width: "inherit",
    height: "inherit"
});
var $4e2c8c4ba6b5b0ad$var$sizeMap = {
    core: {
        none: (0, $jVTBW.css)({
            width: "var(--ds-space-200, 16px)",
            height: "var(--ds-space-200, 16px)"
        }),
        spacious: (0, $jVTBW.css)({
            width: "var(--ds-space-300, 24px)",
            height: "var(--ds-space-300, 24px)"
        })
    },
    utility: {
        none: (0, $jVTBW.css)({
            width: "var(--ds-space-150, 12px)",
            height: "var(--ds-space-150, 12px)"
        }),
        compact: (0, $jVTBW.css)({
            width: "var(--ds-space-200, 16px)",
            height: "var(--ds-space-200, 16px)"
        }),
        spacious: (0, $jVTBW.css)({
            width: "var(--ds-space-300, 24px)",
            height: "var(--ds-space-300, 24px)"
        })
    }
};
var $4e2c8c4ba6b5b0ad$var$baseSizeMap = {
    core: 16,
    utility: 12
};
var $4e2c8c4ba6b5b0ad$var$paddingMap = {
    core: {
        none: 0,
        spacious: 4
    },
    utility: {
        none: 0,
        compact: 2,
        spacious: 6
    }
};
var $4e2c8c4ba6b5b0ad$export$f04a61298a47a40f = /*#__PURE__*/ (0, $dAx5m.memo)(function Icon(props) {
    var _props$type, _props$spacing3, _props$spacing4;
    var _ref = props, _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, testId = _ref.testId, label = _ref.label, LEGACY_primaryColor = _ref.LEGACY_primaryColor, LEGACY_secondaryColor = _ref.LEGACY_secondaryColor, LEGACY_size = _ref.LEGACY_size, FallbackIcon = _ref.LEGACY_fallbackIcon, dangerouslySetGlyph = _ref.dangerouslySetGlyph, shouldScale = _ref.shouldScale, LEGACY_margin = _ref.LEGACY_margin;
    var dangerouslySetInnerHTML = dangerouslySetGlyph ? {
        __html: dangerouslySetGlyph
    } : undefined;
    // Fall back to old icon
    if (FallbackIcon && !(0, $18rB9.fg)("platform-visual-refresh-icons")) // parse out unnecessary props
    return (0, $jVTBW.jsx)(FallbackIcon, {
        primaryColor: LEGACY_primaryColor !== null && LEGACY_primaryColor !== void 0 ? LEGACY_primaryColor : color,
        secondaryColor: LEGACY_secondaryColor,
        size: LEGACY_size,
        label: label,
        testId: testId,
        UNSAFE_margin: LEGACY_margin
    });
    var baseSize = $4e2c8c4ba6b5b0ad$var$baseSizeMap[(_props$type = props.type) !== null && _props$type !== void 0 ? _props$type : "core"];
    var viewBoxPadding;
    if (props.type === "utility") {
        var _props$spacing;
        viewBoxPadding = $4e2c8c4ba6b5b0ad$var$paddingMap[props.type][(_props$spacing = props.spacing) !== null && _props$spacing !== void 0 ? _props$spacing : "none"];
    } else {
        var _props$spacing2;
        viewBoxPadding = $4e2c8c4ba6b5b0ad$var$paddingMap["core"][(_props$spacing2 = props.spacing) !== null && _props$spacing2 !== void 0 ? _props$spacing2 : "none"];
    }
    var viewBoxSize = baseSize + 2 * viewBoxPadding;
    // Workaround for the transparency in our disabled icon token.
    // Because we have multiple strokes in icons, opacities overlap
    // This filter has an impact on render performance, but this is
    // acceptable as icons aren't commonly disabled en-masse
    var iconColor = color;
    if (dangerouslySetInnerHTML && color === "var(--ds-icon-disabled, #091E424F)") {
        dangerouslySetInnerHTML.__html = '\n<filter id="ds-newIconOpacityFilter">\n  <feFlood flood-color="var(--ds-icon-disabled)" />\n  <feComposite in2="SourceGraphic" operator="in" />\n</filter>\n<g filter="url(#ds-newIconOpacityFilter)">\n  '.concat(dangerouslySetInnerHTML.__html, "\n</g>");
        iconColor = "var(--ds-icon, #44546F)";
    }
    return (0, $jVTBW.jsx)("span", {
        "data-testid": testId,
        role: label ? "img" : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: {
            color: iconColor
        },
        css: [
            $4e2c8c4ba6b5b0ad$var$iconStyles,
            $4e2c8c4ba6b5b0ad$var$baseHcmStyles,
            shouldScale && $4e2c8c4ba6b5b0ad$var$scaleStyles,
            props.type === "utility" && $4e2c8c4ba6b5b0ad$var$utilityIconStyles
        ]
    }, (0, $jVTBW.jsx)("svg", {
        fill: "none",
        viewBox: "".concat(0 - viewBoxPadding, " ").concat(0 - viewBoxPadding, " ").concat(viewBoxSize, " ").concat(viewBoxSize),
        role: "presentation",
        css: [
            $4e2c8c4ba6b5b0ad$var$commonSVGStyles,
            $4e2c8c4ba6b5b0ad$var$svgStyles,
            shouldScale ? $4e2c8c4ba6b5b0ad$var$scaleSize : props.type === "utility" ? $4e2c8c4ba6b5b0ad$var$sizeMap[props.type][(_props$spacing3 = props.spacing) !== null && _props$spacing3 !== void 0 ? _props$spacing3 : "none"] : $4e2c8c4ba6b5b0ad$var$sizeMap["core"][(_props$spacing4 = props.spacing) !== null && _props$spacing4 !== void 0 ? _props$spacing4 : "none"]
        ],
        dangerouslySetInnerHTML: dangerouslySetInnerHTML
    }));
});
var $4e2c8c4ba6b5b0ad$export$2e2bcd8739ae039 = $4e2c8c4ba6b5b0ad$export$f04a61298a47a40f;

});



parcelRegister("eJNgi", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $abab7b038334beb8$var$_react = $abab7b038334beb8$var$_interopRequireDefault((parcelRequire("dAx5m")));

var $ffO1H = parcelRequire("ffO1H");

var $abab7b038334beb8$var$_arrowLeft = $abab7b038334beb8$var$_interopRequireDefault((parcelRequire("ivBwc")));
function $abab7b038334beb8$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $abab7b038334beb8$var$ArrowLeftIcon = (props)=>/*#__PURE__*/ $abab7b038334beb8$var$_react.default.createElement($ffO1H.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M12.207 5.793a1 1 0 0 1 0 1.414L8.414 11H18a1 1 0 1 1 0 2H8.414l3.793 3.793a1 1 0 1 1-1.415 1.414l-5.499-5.5A1 1 0 0 1 5 12.028v-.057a1 1 0 0 1 .293-.678l5.499-5.5a1 1 0 0 1 1.415 0" clip-rule="evenodd"/></svg>`
    }, props, {
        newIcon: $abab7b038334beb8$var$_arrowLeft.default
    }));
$abab7b038334beb8$var$ArrowLeftIcon.displayName = "ArrowLeftIcon";
var $abab7b038334beb8$var$_default = module.exports.default = $abab7b038334beb8$var$ArrowLeftIcon;

});
parcelRegister("ffO1H", function(module, exports) {

$parcel$export(module.exports, "IconFacade", function () { return $b1af0fee275ea116$export$3cfb73f70dfca966; });

var $sN2rQ = parcelRequire("sN2rQ");

var $dTYVX = parcelRequire("dTYVX");

var $dAx5m = parcelRequire("dAx5m");

var $18rB9 = parcelRequire("18rB9");

var $7l4fF = parcelRequire("7l4fF");
var $b1af0fee275ea116$var$_excluded = [
    "dangerouslySetGlyph"
];
var $b1af0fee275ea116$var$sizeSpacingMap = {
    utility: {
        small: "compact",
        medium: "spacious"
    },
    core: {
        small: "none",
        medium: "spacious"
    }
};
var $b1af0fee275ea116$export$3cfb73f70dfca966 = /*#__PURE__*/ (0, $dAx5m.memo)(function IconFacade(_ref) {
    var _props$size;
    var dangerouslySetGlyph = _ref.dangerouslySetGlyph, props = (0, (/*@__PURE__*/$parcel$interopDefault($dTYVX)))(_ref, $b1af0fee275ea116$var$_excluded);
    var NewIcon = props.newIcon;
    // By default, the icon size will be medium for core icons and small for utility icons
    var size = (_props$size = props.size) !== null && _props$size !== void 0 ? _props$size : "medium";
    var useNewIcon = !props.isFacadeDisabled && // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
    (0, $18rB9.fg)("platform-visual-refresh-icons-legacy-facade");
    if (useNewIcon && NewIcon && (size === "small" || size === "medium")) {
        if (props.iconType === "utility") {
            var Icon = NewIcon;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement(Icon, (0, (/*@__PURE__*/$parcel$interopDefault($sN2rQ)))({}, props, {
                spacing: (0, $18rB9.fg)("platform-visual-refresh-icons-facade-button-fix") ? $b1af0fee275ea116$var$sizeSpacingMap["utility"][size] : "none",
                color: props.primaryColor || "currentColor",
                type: props.iconType
            }));
        } else {
            var _Icon = NewIcon;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement(_Icon, (0, (/*@__PURE__*/$parcel$interopDefault($sN2rQ)))({}, props, {
                spacing: $b1af0fee275ea116$var$sizeSpacingMap["core"][size],
                color: props.primaryColor || "currentColor",
                type: props.iconType
            }));
        }
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $7l4fF.Icon), (0, (/*@__PURE__*/$parcel$interopDefault($sN2rQ)))({
        dangerouslySetGlyph: dangerouslySetGlyph
    }, props));
});

});
parcelRegister("7l4fF", function(module, exports) {

$parcel$export(module.exports, "Icon", function () { return $557dcadd17406269$export$f04a61298a47a40f; });

var $sN2rQ = parcelRequire("sN2rQ");

var $c6l2j = parcelRequire("c6l2j");

var $dAx5m = parcelRequire("dAx5m");

var $jVTBW = parcelRequire("jVTBW");

var $evWch = parcelRequire("evWch");

var $Wty8q = parcelRequire("Wty8q");
function $557dcadd17406269$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $557dcadd17406269$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $557dcadd17406269$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($c6l2j)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $557dcadd17406269$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
/**
 * We are hiding these props from consumers as they're used to
 * hack around icon sizing specifically for icon-file-type.
 */ var $557dcadd17406269$var$iconStyles = (0, $jVTBW.css)({
    display: "inline-block",
    flexShrink: 0,
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: 1,
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    "> svg": $557dcadd17406269$var$_objectSpread($557dcadd17406269$var$_objectSpread({}, (0, $evWch.commonSVGStyles)), {}, {
        maxWidth: "100%",
        maxHeight: "100%",
        color: "var(--icon-primary-color)",
        fill: "var(--icon-secondary-color)",
        verticalAlign: "bottom"
    })
});
/**
 * For windows high contrast mode
 */ var $557dcadd17406269$var$baseHcmStyles = (0, $jVTBW.css)({
    "@media screen and (forced-colors: active)": {
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        "> svg": {
            filter: "grayscale(1)",
            "--icon-primary-color": "CanvasText",
            // foreground
            "--icon-secondary-color": "Canvas" // background
        }
    }
});
var $557dcadd17406269$var$primaryEqualsSecondaryHcmStyles = (0, $jVTBW.css)({
    "@media screen and (forced-colors: active)": {
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        "> svg": {
            // if the primaryColor is the same as the secondaryColor we
            // set the --icon-primary-color to Canvas
            // this is usually to convey state i.e. Checkbox checked -> not checked
            "--icon-primary-color": "Canvas" // foreground
        }
    }
});
var $557dcadd17406269$var$secondaryTransparentHcmStyles = (0, $jVTBW.css)({
    "@media screen and (forced-colors: active)": {
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        "> svg": {
            "--icon-secondary-color": "transparent" // background
        }
    }
});
var $557dcadd17406269$export$f04a61298a47a40f = /*#__PURE__*/ (0, $dAx5m.memo)(function Icon(props) {
    var _ref = props, Glyph = _ref.glyph, dangerouslySetGlyph = _ref.dangerouslySetGlyph, _ref$primaryColor = _ref.primaryColor, primaryColor = _ref$primaryColor === void 0 ? "currentColor" : _ref$primaryColor, secondaryColor = _ref.secondaryColor, size = _ref.size, testId = _ref.testId, label = _ref.label, width = _ref.width, height = _ref.height, UNSAFE_margin = _ref.UNSAFE_margin;
    var glyphProps = dangerouslySetGlyph ? {
        dangerouslySetInnerHTML: {
            __html: dangerouslySetGlyph
        }
    } : {
        children: Glyph ? (0, $jVTBW.jsx)(Glyph, {
            role: "presentation"
        }) : null
    };
    var dimensions = (0, $evWch.getIconSize)({
        width: width,
        height: height,
        size: size
    });
    return (0, $jVTBW.jsx)("span", (0, (/*@__PURE__*/$parcel$interopDefault($sN2rQ)))({
        "data-testid": testId,
        "data-vc": "icon-".concat(testId),
        role: label ? "img" : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: {
            "--icon-primary-color": primaryColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            "--icon-secondary-color": secondaryColor || (0, $Wty8q.getBackground)(),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            margin: UNSAFE_margin
        }
    }, glyphProps, {
        css: [
            $557dcadd17406269$var$iconStyles,
            $557dcadd17406269$var$baseHcmStyles,
            primaryColor === secondaryColor && $557dcadd17406269$var$primaryEqualsSecondaryHcmStyles,
            secondaryColor === "transparent" && $557dcadd17406269$var$secondaryTransparentHcmStyles,
            // NB: This can be resolved if this component, composes base SVG / and/or skeleton
            // We could then simplify how common styles are dealt with simply by encapsulating them
            // at their appropriate level and/or having a singular approach to css variables in the package
            dimensions && // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $jVTBW.css)({
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                width: dimensions.width,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                height: dimensions.height,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                "> svg": dimensions
            })
        ]
    }));
});
var $557dcadd17406269$export$2e2bcd8739ae039 = $557dcadd17406269$export$f04a61298a47a40f;

});
parcelRegister("evWch", function(module, exports) {

$parcel$export(module.exports, "commonSVGStyles", function () { return $a9111aa4ce0a70c0$export$16374db1c3e6dfba; });
$parcel$export(module.exports, "getIconSize", function () { return $a9111aa4ce0a70c0$export$3eb7d6130acfda37; });

var $ctSWm = parcelRequire("ctSWm");

var $jVTBW = parcelRequire("jVTBW");
var $a9111aa4ce0a70c0$export$16374db1c3e6dfba = {
    overflow: "hidden",
    pointerEvents: "none",
    /**
   * Stop-color doesn't properly apply in chrome when the inherited/current color changes.
   * We have to initially set stop-color to inherit (either via DOM attribute or an initial CSS
   * rule) and then override it with currentColor for the color changes to be picked up.
   */ stop: {
        stopColor: "currentColor"
    }
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
var $a9111aa4ce0a70c0$var$smallStyles = (0, $jVTBW.css)((0, $ctSWm.dimensions).small);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
var $a9111aa4ce0a70c0$var$mediumStyles = (0, $jVTBW.css)((0, $ctSWm.dimensions).medium);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
var $a9111aa4ce0a70c0$var$largeStyles = (0, $jVTBW.css)((0, $ctSWm.dimensions).large);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
var $a9111aa4ce0a70c0$var$xlargeStyles = (0, $jVTBW.css)((0, $ctSWm.dimensions).xlarge);
var $a9111aa4ce0a70c0$export$ef0ad74202575b64 = {
    small: $a9111aa4ce0a70c0$var$smallStyles,
    medium: $a9111aa4ce0a70c0$var$mediumStyles,
    large: $a9111aa4ce0a70c0$var$largeStyles,
    xlarge: $a9111aa4ce0a70c0$var$xlargeStyles
};
var $a9111aa4ce0a70c0$export$3eb7d6130acfda37 = function getIconSize(_ref) {
    var width = _ref.width, height = _ref.height, size = _ref.size;
    if (width && height) return {
        width: width,
        height: height
    };
    if (size) return (0, $ctSWm.dimensions)[size];
    return undefined;
};

});
parcelRegister("ctSWm", function(module, exports) {

$parcel$export(module.exports, "dimensions", function () { return $9162cf7bd937683a$export$62ad7b0c781000e9; });
var $9162cf7bd937683a$export$c647cb0ee6e282fe = {
    small: "16px",
    medium: "24px",
    large: "32px",
    xlarge: "48px"
};
var $9162cf7bd937683a$export$7bd66fc94c81bf84 = {
    small: "small",
    medium: "medium",
    large: "large",
    xlarge: "xlarge"
};
var $9162cf7bd937683a$export$62ad7b0c781000e9 = {
    small: {
        width: $9162cf7bd937683a$export$c647cb0ee6e282fe.small,
        height: $9162cf7bd937683a$export$c647cb0ee6e282fe.small
    },
    medium: {
        width: $9162cf7bd937683a$export$c647cb0ee6e282fe.medium,
        height: $9162cf7bd937683a$export$c647cb0ee6e282fe.medium
    },
    large: {
        width: $9162cf7bd937683a$export$c647cb0ee6e282fe.large,
        height: $9162cf7bd937683a$export$c647cb0ee6e282fe.large
    },
    xlarge: {
        width: $9162cf7bd937683a$export$c647cb0ee6e282fe.xlarge,
        height: $9162cf7bd937683a$export$c647cb0ee6e282fe.xlarge
    }
};

});


parcelRegister("Wty8q", function(module, exports) {

$parcel$export(module.exports, "getBackground", function () { return $0afc56d257da03ec$export$18cb9425622d4e06; });
var $0afc56d257da03ec$export$18cb9425622d4e06 = function getBackground() {
    return "var(--ds-surface, #FFFFFF)";
};

});





parcelRegister("5cC3Q", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3c9b98d987cc61fe$export$2e2bcd8739ae039; });

var $dAx5m = parcelRequire("dAx5m");

var $1xZNb = parcelRequire("1xZNb");
/**
 * __SlideIn__
 *
 * Will slide an element into position, generally used for things that appear from outside of the viewport into view.
 *
 * See [examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motions).
 */ var $3c9b98d987cc61fe$var$SlideIn = function SlideIn(_ref) {
    var children = _ref.children, enterFrom = _ref.enterFrom, exitTo = _ref.exitTo, _ref$fade = _ref.fade, fade = _ref$fade === void 0 ? "none" : _ref$fade, _ref$duration = _ref.duration, duration = _ref$duration === void 0 ? "medium" : _ref$duration, isPaused = _ref.isPaused, onFinish = _ref.onFinish, _ref$animationTimingF = _ref.animationTimingFunction, animationTimingFunction = _ref$animationTimingF === void 0 ? "ease-out" : _ref$animationTimingF, _ref$animationTimingF2 = _ref.animationTimingFunctionExiting, animationTimingFunctionExiting = _ref$animationTimingF2 === void 0 ? "ease-in" : _ref$animationTimingF2;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $1xZNb.default), {
        duration: duration,
        enteringAnimation: "slide-in-from-".concat(enterFrom),
        exitingAnimation: "slide-out-from-".concat(exitTo || enterFrom),
        animationTimingFunction: animationTimingFunction,
        animationTimingFunctionExiting: animationTimingFunctionExiting,
        isPaused: isPaused,
        onFinish: onFinish
    }, children);
};
var $3c9b98d987cc61fe$export$2e2bcd8739ae039 = $3c9b98d987cc61fe$var$SlideIn;

});

parcelRegister("h5NR9", function(module, exports) {

$parcel$export(module.exports, "createExtender", function () { return $c71993b9445e478d$export$3f052dbd10b2d4da; });
// eslint-disable-next-line @repo/internal/react/consistent-types-definitions
/**
 * @deprecated Please avoid using this function as we intend to remote it in a future release. See DSP-2673 for more information.
 */ var $c71993b9445e478d$export$3f052dbd10b2d4da = function createExtender(defaults) {
    var overrides = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Object.create(Object.prototype);
    if (!defaults) throw new Error("a default set of overrides *must* be passed in as the first argument");
    return function getOverrides(key) {
        var _defaults$key = defaults[key], defaultCssFn = _defaults$key.cssFn, defaultComponent = _defaults$key.component;
        if (!overrides[key]) return {
            cssFn: defaultCssFn,
            component: defaultComponent
        };
        var _overrides$key = overrides[key], customCssFn = _overrides$key.cssFn, customComponent = _overrides$key.component;
        var composedCssFn = function composedCssFn(state) {
            return customCssFn(defaultCssFn(state), state);
        };
        return {
            cssFn: customCssFn ? composedCssFn : defaultCssFn,
            component: customComponent || defaultComponent
        };
    };
};

});

parcelRegister("9OhEN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $72467ae5df240ccb$export$2e2bcd8739ae039; });

var $sN2rQ = parcelRequire("sN2rQ");

var $kC8H4 = parcelRequire("kC8H4");

var $dTYVX = parcelRequire("dTYVX");

var $dAx5m = parcelRequire("dAx5m");

var $jVTBW = parcelRequire("jVTBW");
var $72467ae5df240ccb$var$_excluded = [
    "cssFn",
    "scrollContentLabel"
];
var $72467ae5df240ccb$var$defaultStyles = {
    flex: 1,
    overflow: "auto",
    marginTop: "var(--ds-space-300, 24px)"
};
var $72467ae5df240ccb$var$contentCSS = function contentCSS() {
    return $72467ae5df240ccb$var$defaultStyles;
};
var $72467ae5df240ccb$var$Content = function Content(_ref) {
    var cssFn = _ref.cssFn, _ref$scrollContentLab = _ref.scrollContentLabel, scrollContentLabel = _ref$scrollContentLab === void 0 ? "Scrollable content" : _ref$scrollContentLab, props = (0, (/*@__PURE__*/$parcel$interopDefault($dTYVX)))(_ref, $72467ae5df240ccb$var$_excluded);
    var _useState = (0, $dAx5m.useState)(false), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($kC8H4)))(_useState, 2), showContentFocus = _useState2[0], setContentFocus = _useState2[1];
    var scrollableRef = (0, $dAx5m.useRef)(null);
    (0, $dAx5m.useEffect)(function() {
        var setLazyContentFocus = function setLazyContentFocus() {
            var target = scrollableRef.current;
            target && setContentFocus(target.scrollHeight > target.clientHeight);
        };
        setLazyContentFocus();
    }, []);
    /**
   * I noticed the implementation at @atlaskit/checkbox would send the props to cssFn rather
   * than the defaultStyles as the overrides guide suggests. I went with what the overrides
   * guide suggested as it made more sense as a transformer of the current styles rather than
   * a complete override with no chance of partially changing styles.
   */ return (0, $jVTBW.jsx)("div", (0, (/*@__PURE__*/$parcel$interopDefault($sN2rQ)))({
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        css: (0, $jVTBW.css)(cssFn($72467ae5df240ccb$var$defaultStyles)),
        ref: scrollableRef,
        tabIndex: showContentFocus ? 0 : undefined,
        role: showContentFocus ? "region" : undefined,
        "aria-label": showContentFocus ? scrollContentLabel : undefined,
        "data-testid": "drawer-contents"
    }, props));
};
var $72467ae5df240ccb$var$contentDefaults = {
    component: $72467ae5df240ccb$var$Content,
    cssFn: $72467ae5df240ccb$var$contentCSS
};
var $72467ae5df240ccb$export$2e2bcd8739ae039 = $72467ae5df240ccb$var$contentDefaults;

});

parcelRegister("bwfSA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $862f002e33682c05$export$2e2bcd8739ae039; });

var $c6l2j = parcelRequire("c6l2j");

var $dAx5m = parcelRequire("dAx5m");

var $jVTBW = parcelRequire("jVTBW");

var $8pNC4 = parcelRequire("8pNC4");

var $1zU5H = parcelRequire("1zU5H");

var $da8nl = parcelRequire("da8nl");

var $bcs6Z = parcelRequire("bcs6Z");
var $862f002e33682c05$export$f693ac40d0904cc2 = {
    full: {
        width: "100vw"
    },
    extended: {
        width: "95vw"
    },
    narrow: {
        width: 360
    },
    medium: {
        width: 480
    },
    wide: {
        width: 600
    }
};
var $862f002e33682c05$var$wrapperStyles = (0, $jVTBW.css)((0, (/*@__PURE__*/$parcel$interopDefault($c6l2j)))((0, (/*@__PURE__*/$parcel$interopDefault($c6l2j)))((0, (/*@__PURE__*/$parcel$interopDefault($c6l2j)))((0, (/*@__PURE__*/$parcel$interopDefault($c6l2j)))({
    display: "flex",
    height: "100vh",
    position: "fixed",
    zIndex: 500,
    backgroundColor: "var(--ds-surface-overlay, ".concat((0, $1zU5H.N0), ")")
}, (0, $da8nl.CURRENT_SURFACE_CSS_VAR), "var(--ds-surface-overlay, ".concat((0, $1zU5H.N0), ")")), "insetBlockStart", 0), "insetInlineStart", 0), "overflow", "hidden"));
/**
 * A wrapper that controls the styling of the drawer with a few hacks with refs to get our Touch±Scroll locks working.
 */ var $862f002e33682c05$var$DrawerWrapper = /*#__PURE__*/ (0, $dAx5m.forwardRef)(function(_ref, scrollRef) {
    var children = _ref.children, className = _ref.className, _ref$width = _ref.width, width = _ref$width === void 0 ? "narrow" : _ref$width, testId = _ref.testId, drawerRef = _ref.drawerRef, label = _ref.label, titleId = _ref.titleId;
    /**
   * We use a callback ref to assign the `<Content />` component to the forwarded `scrollRef`.
   * This ref comes from `react-scrolllock` to allow touch scrolling, eg.: `<ScrollLock><TouchScrollable>{children}</TouchScrollable><ScrollLock>`
   *
   * This is because we do not control the `<Content />` component in order to forward a ref to it (given it can be overriden via `DrawerPrimitiveProps['overrides']['Content']['component']`).
   * Additionally, we target the last child because with `props.overrides.Sidebar.component = () => null` you only have one child.
   * If both `Sidebar.component` and `Content.component` return null you will have no children and this will throw an error, but that doesn't seem valid.
   */ var assignSecondChildRef = (0, $dAx5m.useCallback)(function(node) {
        var _node$children;
        if (node !== null && node !== void 0 && (_node$children = node.children) !== null && _node$children !== void 0 && _node$children.length && typeof scrollRef === "function") scrollRef(node.children[node.children.length - 1]);
    }, [
        scrollRef
    ]);
    var ref = (0, $8pNC4.useMergeRefs)([
        drawerRef,
        assignSecondChildRef
    ]);
    (0, $bcs6Z.default)();
    return (0, $jVTBW.jsx)("div", {
        css: $862f002e33682c05$var$wrapperStyles,
        style: $862f002e33682c05$export$f693ac40d0904cc2[width],
        className: className,
        "data-testid": testId,
        ref: ref,
        "aria-modal": true,
        role: "dialog",
        "aria-label": label,
        "aria-labelledby": titleId
    }, children);
});
var $862f002e33682c05$export$2e2bcd8739ae039 = $862f002e33682c05$var$DrawerWrapper;

});
parcelRegister("8pNC4", function(module, exports) {

$parcel$export(module.exports, "useMergeRefs", function () { return $6207249f499e0d67$export$74665b213cb5c4cf; });

var $dAx5m = parcelRequire("dAx5m");

var $1Cl4T = parcelRequire("1Cl4T");

var $b2XIN = parcelRequire("b2XIN");
var $6207249f499e0d67$var$useIsomorphicLayoutEffect = typeof window !== "undefined" ? $dAx5m.useLayoutEffect : $dAx5m.useEffect;
var $6207249f499e0d67$var$currentValues = new WeakMap();
function $6207249f499e0d67$export$74665b213cb5c4cf(refs, defaultValue) {
    var callbackRef = (0, $b2XIN.useCallbackRef)(defaultValue || null, function(newValue) {
        return refs.forEach(function(ref) {
            return (0, $1Cl4T.assignRef)(ref, newValue);
        });
    });
    // handle refs changes - added or removed
    $6207249f499e0d67$var$useIsomorphicLayoutEffect(function() {
        var oldValue = $6207249f499e0d67$var$currentValues.get(callbackRef);
        if (oldValue) {
            var prevRefs_1 = new Set(oldValue);
            var nextRefs_1 = new Set(refs);
            var current_1 = callbackRef.current;
            prevRefs_1.forEach(function(ref) {
                if (!nextRefs_1.has(ref)) (0, $1Cl4T.assignRef)(ref, null);
            });
            nextRefs_1.forEach(function(ref) {
                if (!prevRefs_1.has(ref)) (0, $1Cl4T.assignRef)(ref, current_1);
            });
        }
        $6207249f499e0d67$var$currentValues.set(callbackRef, refs);
    }, [
        refs
    ]);
    return callbackRef;
}

});
parcelRegister("1Cl4T", function(module, exports) {

$parcel$export(module.exports, "assignRef", function () { return $12d9b0b2268cd2ea$export$d734136a7b018efe; });
/**
 * Assigns a value for a given ref, no matter of the ref format
 * @param {RefObject} ref - a callback function or ref object
 * @param value - a new value
 *
 * @see https://github.com/theKashey/use-callback-ref#assignref
 * @example
 * const refObject = useRef();
 * const refFn = (ref) => {....}
 *
 * assignRef(refObject, "refValue");
 * assignRef(refFn, "refValue");
 */ function $12d9b0b2268cd2ea$export$d734136a7b018efe(ref, value) {
    if (typeof ref === "function") ref(value);
    else if (ref) ref.current = value;
    return ref;
}

});

parcelRegister("b2XIN", function(module, exports) {

$parcel$export(module.exports, "useCallbackRef", function () { return $80ae3509adc64e2c$export$25bec8c6f54ee79a; });

var $dAx5m = parcelRequire("dAx5m");
function $80ae3509adc64e2c$export$25bec8c6f54ee79a(initialValue, callback) {
    var ref = (0, $dAx5m.useState)(function() {
        return {
            // value
            value: initialValue,
            // last callback
            callback: callback,
            // "memoized" public interface
            facade: {
                get current () {
                    return ref.value;
                },
                set current (value){
                    var last = ref.value;
                    if (last !== value) {
                        ref.value = value;
                        ref.callback(value, last);
                    }
                }
            }
        };
    })[0];
    // update callback
    ref.callback = callback;
    return ref.facade;
}

});


parcelRegister("bcs6Z", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $82769f1801c6a101$export$2e2bcd8739ae039; });

var $kC8H4 = parcelRequire("kC8H4");

var $dAx5m = parcelRequire("dAx5m");

var $dd4sf = parcelRequire("dd4sf");
/**
 * Returns how far the body is scrolled from the top of the viewport.
 *
 * ⚠️ This is copied from `packages/design-system/modal-dialog/src/internal/hooks/use-prevent-programmatic-scroll.tsx`
 *
 *   ____
 * ||____|| <-- overflow
 *  |    |  <-- viewport
 *  |____|
 *
 * Scroll distance is the height of overflow outside the viewport.
 */ function $82769f1801c6a101$var$getScrollDistance() {
    var _document$documentEle, _document$body;
    return window.pageYOffset || ((_document$documentEle = document.documentElement) === null || _document$documentEle === void 0 ? void 0 : _document$documentEle.scrollTop) || ((_document$body = document.body) === null || _document$body === void 0 ? void 0 : _document$body.scrollTop) || 0;
}
function $82769f1801c6a101$export$2e2bcd8739ae039() {
    var _useState = (0, $dAx5m.useState)(0), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($kC8H4)))(_useState, 2), scrollTopOffset = _useState2[0], setScrollTopOffset = _useState2[1];
    (0, $dAx5m.useLayoutEffect)(function() {
        setScrollTopOffset($82769f1801c6a101$var$getScrollDistance());
    }, []);
    var onWindowScroll = (0, $dAx5m.useCallback)(function() {
        if ($82769f1801c6a101$var$getScrollDistance() !== scrollTopOffset) window.scrollTo(window.pageXOffset, scrollTopOffset);
    }, [
        scrollTopOffset
    ]);
    (0, $dAx5m.useEffect)(function() {
        return (0, $dd4sf.bind)(window, {
            type: "scroll",
            listener: onWindowScroll
        });
    }, [
        onWindowScroll
    ]);
    return scrollTopOffset;
}

});


parcelRegister("ajA5X", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7827ad72160bc001$export$2e2bcd8739ae039; });

var $dAx5m = parcelRequire("dAx5m");

var $hKRkP = parcelRequire("hKRkP");

var $5SgSF = parcelRequire("5SgSF");


var $ahJoN = parcelRequire("ahJoN");
/**
 * __Focus lock__
 *
 * Thin wrapper over react-focus-lock. This wrapper only exists to ensure API compatibility.
 * This component should be deleted during https://ecosystem.atlassian.net/browse/AK-5658
 */ var $7827ad72160bc001$var$FocusLock = function FocusLock(_ref) {
    var _ref$isFocusLockEnabl = _ref.isFocusLockEnabled, isFocusLockEnabled = _ref$isFocusLockEnabl === void 0 ? true : _ref$isFocusLockEnabl, _ref$autoFocusFirstEl = _ref.autoFocusFirstElem, autoFocusFirstElem = _ref$autoFocusFirstEl === void 0 ? true : _ref$autoFocusFirstEl, _ref$shouldReturnFocu = _ref.shouldReturnFocus, shouldReturnFocus = _ref$shouldReturnFocu === void 0 ? true : _ref$shouldReturnFocu, children = _ref.children;
    (0, $dAx5m.useEffect)(function() {
        typeof $ahJoN;
        if (typeof autoFocusFirstElem === "function" && isFocusLockEnabled) {
            var elem = autoFocusFirstElem();
            if (elem && elem.focus) elem.focus();
        }
    }, [
        autoFocusFirstElem,
        isFocusLockEnabled
    ]);
    var getFocusTarget = function getFocusTarget() {
        if (typeof shouldReturnFocus === "boolean") return shouldReturnFocus;
        return false;
    };
    var onDeactivation = function onDeactivation() {
        if (typeof shouldReturnFocus !== "boolean") window.setTimeout(function() {
            var _shouldReturnFocus$cu;
            shouldReturnFocus === null || shouldReturnFocus === void 0 || (_shouldReturnFocus$cu = shouldReturnFocus.current) === null || _shouldReturnFocus$cu === void 0 || _shouldReturnFocus$cu.focus();
        }, 0);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $hKRkP.default), {
        disabled: !isFocusLockEnabled,
        autoFocus: !!autoFocusFirstElem,
        returnFocus: getFocusTarget(),
        onDeactivation: onDeactivation
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5SgSF))), null, children));
};
var $7827ad72160bc001$export$2e2bcd8739ae039 = $7827ad72160bc001$var$FocusLock;

});
parcelRegister("hKRkP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ced01ac30cc35cdb$export$2e2bcd8739ae039; });

var $fVWJU = parcelRequire("fVWJU");

var $ced01ac30cc35cdb$export$2e2bcd8739ae039 = (0, $fVWJU.default);

});
parcelRegister("fVWJU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b999be4c86f302dc$export$2e2bcd8739ae039; });

var $79c01 = parcelRequire("79c01");

var $a2TqH = parcelRequire("a2TqH");

var $dAx5m = parcelRequire("dAx5m");

var $5KwuN = parcelRequire("5KwuN");

var $fjEvb = parcelRequire("fjEvb");
var $b999be4c86f302dc$var$FocusLockCombination = /*#__PURE__*/ $dAx5m.forwardRef(function FocusLockUICombination(props, ref) {
    return /*#__PURE__*/ $dAx5m.createElement((0, $5KwuN.default), (0, $a2TqH.default)({
        sideCar: (0, $fjEvb.default),
        ref: ref
    }, props));
});
var $b999be4c86f302dc$var$_ref = (0, $5KwuN.default).propTypes || {}, $b999be4c86f302dc$var$sideCar = $b999be4c86f302dc$var$_ref.sideCar, $b999be4c86f302dc$var$propTypes = (0, $79c01.default)($b999be4c86f302dc$var$_ref, [
    "sideCar"
]);
$b999be4c86f302dc$var$FocusLockCombination.propTypes = {};
var $b999be4c86f302dc$export$2e2bcd8739ae039 = $b999be4c86f302dc$var$FocusLockCombination;

});
parcelRegister("79c01", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5342ae787f744b36$export$2e2bcd8739ae039; });
function $5342ae787f744b36$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.includes(n)) continue;
        t[n] = r[n];
    }
    return t;
}

});

parcelRegister("a2TqH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $75051674e52ea030$export$2e2bcd8739ae039; });
function $75051674e52ea030$export$2e2bcd8739ae039() {
    return $75051674e52ea030$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $75051674e52ea030$export$2e2bcd8739ae039.apply(null, arguments);
}

});

parcelRegister("5KwuN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $01148e448368b7bc$export$2e2bcd8739ae039; });

var $a2TqH = parcelRequire("a2TqH");

var $dAx5m = parcelRequire("dAx5m");


var $hMR7v = parcelRequire("hMR7v");

var $8pNC4 = parcelRequire("8pNC4");

var $5yVxg = parcelRequire("5yVxg");

var $8lenq = parcelRequire("8lenq");

var $li9HS = parcelRequire("li9HS");
var $01148e448368b7bc$var$emptyArray = [];
var $01148e448368b7bc$var$FocusLock = /*#__PURE__*/ $dAx5m.forwardRef(function FocusLockUI(props, parentRef) {
    var _extends2;
    var _React$useState = $dAx5m.useState(), realObserved = _React$useState[0], setObserved = _React$useState[1];
    var observed = $dAx5m.useRef();
    var isActive = $dAx5m.useRef(false);
    var originalFocusedElement = $dAx5m.useRef(null);
    var _React$useState2 = $dAx5m.useState({}), update = _React$useState2[1];
    var children = props.children, _props$disabled = props.disabled, disabled = _props$disabled === void 0 ? false : _props$disabled, _props$noFocusGuards = props.noFocusGuards, noFocusGuards = _props$noFocusGuards === void 0 ? false : _props$noFocusGuards, _props$persistentFocu = props.persistentFocus, persistentFocus = _props$persistentFocu === void 0 ? false : _props$persistentFocu, _props$crossFrame = props.crossFrame, crossFrame = _props$crossFrame === void 0 ? true : _props$crossFrame, _props$autoFocus = props.autoFocus, autoFocus = _props$autoFocus === void 0 ? true : _props$autoFocus, allowTextSelection = props.allowTextSelection, group = props.group, className = props.className, whiteList = props.whiteList, hasPositiveIndices = props.hasPositiveIndices, _props$shards = props.shards, shards = _props$shards === void 0 ? $01148e448368b7bc$var$emptyArray : _props$shards, _props$as = props.as, Container = _props$as === void 0 ? "div" : _props$as, _props$lockProps = props.lockProps, containerProps = _props$lockProps === void 0 ? {} : _props$lockProps, SideCar = props.sideCar, _props$returnFocus = props.returnFocus, shouldReturnFocus = _props$returnFocus === void 0 ? false : _props$returnFocus, focusOptions = props.focusOptions, onActivationCallback = props.onActivation, onDeactivationCallback = props.onDeactivation;
    var _React$useState3 = $dAx5m.useState({}), id = _React$useState3[0];
    var onActivation = $dAx5m.useCallback(function(_ref) {
        var captureFocusRestore = _ref.captureFocusRestore;
        if (!originalFocusedElement.current) {
            var _document;
            var activeElement = (_document = document) == null ? void 0 : _document.activeElement;
            originalFocusedElement.current = activeElement;
            if (activeElement !== document.body) originalFocusedElement.current = captureFocusRestore(activeElement);
        }
        if (observed.current && onActivationCallback) onActivationCallback(observed.current);
        isActive.current = true;
        update();
    }, [
        onActivationCallback
    ]);
    var onDeactivation = $dAx5m.useCallback(function() {
        isActive.current = false;
        if (onDeactivationCallback) onDeactivationCallback(observed.current);
        update();
    }, [
        onDeactivationCallback
    ]);
    var returnFocus = $dAx5m.useCallback(function(allowDefer) {
        var focusRestore = originalFocusedElement.current;
        if (focusRestore) {
            var returnFocusTo = (typeof focusRestore === "function" ? focusRestore() : focusRestore) || document.body;
            var howToReturnFocus = typeof shouldReturnFocus === "function" ? shouldReturnFocus(returnFocusTo) : shouldReturnFocus;
            if (howToReturnFocus) {
                var returnFocusOptions = typeof howToReturnFocus === "object" ? howToReturnFocus : undefined;
                originalFocusedElement.current = null;
                if (allowDefer) Promise.resolve().then(function() {
                    return returnFocusTo.focus(returnFocusOptions);
                });
                else returnFocusTo.focus(returnFocusOptions);
            }
        }
    }, [
        shouldReturnFocus
    ]);
    var onFocus = $dAx5m.useCallback(function(event) {
        if (isActive.current) (0, $8lenq.mediumFocus).useMedium(event);
    }, []);
    var onBlur = (0, $8lenq.mediumBlur).useMedium;
    var setObserveNode = $dAx5m.useCallback(function(newObserved) {
        if (observed.current !== newObserved) {
            observed.current = newObserved;
            setObserved(newObserved);
        }
    }, []);
    var lockProps = (0, $a2TqH.default)((_extends2 = {}, _extends2[$hMR7v.FOCUS_DISABLED] = disabled && "disabled", _extends2[$hMR7v.FOCUS_GROUP] = group, _extends2), containerProps);
    var hasLeadingGuards = noFocusGuards !== true;
    var hasTailingGuards = hasLeadingGuards && noFocusGuards !== "tail";
    var mergedRef = (0, $8pNC4.useMergeRefs)([
        parentRef,
        setObserveNode
    ]);
    var focusScopeValue = $dAx5m.useMemo(function() {
        return {
            observed: observed,
            shards: shards,
            enabled: !disabled,
            active: isActive.current
        };
    }, [
        disabled,
        isActive.current,
        shards,
        realObserved
    ]);
    return /*#__PURE__*/ $dAx5m.createElement($dAx5m.Fragment, null, hasLeadingGuards && [
        /*#__PURE__*/ $dAx5m.createElement("div", {
            key: "guard-first",
            "data-focus-guard": true,
            tabIndex: disabled ? -1 : 0,
            style: (0, $5yVxg.hiddenGuard)
        }),
        hasPositiveIndices ? /*#__PURE__*/ $dAx5m.createElement("div", {
            key: "guard-nearest",
            "data-focus-guard": true,
            tabIndex: disabled ? -1 : 1,
            style: (0, $5yVxg.hiddenGuard)
        }) : null
    ], !disabled && /*#__PURE__*/ $dAx5m.createElement(SideCar, {
        id: id,
        sideCar: (0, $8lenq.mediumSidecar),
        observed: realObserved,
        disabled: disabled,
        persistentFocus: persistentFocus,
        crossFrame: crossFrame,
        autoFocus: autoFocus,
        whiteList: whiteList,
        shards: shards,
        onActivation: onActivation,
        onDeactivation: onDeactivation,
        returnFocus: returnFocus,
        focusOptions: focusOptions,
        noFocusGuards: noFocusGuards
    }), /*#__PURE__*/ $dAx5m.createElement(Container, (0, $a2TqH.default)({
        ref: mergedRef
    }, lockProps, {
        className: className,
        onBlur: onBlur,
        onFocus: onFocus
    }), /*#__PURE__*/ $dAx5m.createElement((0, $li9HS.focusScope).Provider, {
        value: focusScopeValue
    }, children)), hasTailingGuards && /*#__PURE__*/ $dAx5m.createElement("div", {
        "data-focus-guard": true,
        tabIndex: disabled ? -1 : 0,
        style: (0, $5yVxg.hiddenGuard)
    }));
});
$01148e448368b7bc$var$FocusLock.propTypes = {};
var $01148e448368b7bc$export$2e2bcd8739ae039 = $01148e448368b7bc$var$FocusLock;

});
parcelRegister("hMR7v", function(module, exports) {

$parcel$export(module.exports, "FOCUS_GROUP", function () { return $cf301fe068915354$export$4f9a06cb7441a087; });
$parcel$export(module.exports, "FOCUS_DISABLED", function () { return $cf301fe068915354$export$aeda8252e54b50f7; });
$parcel$export(module.exports, "FOCUS_ALLOW", function () { return $cf301fe068915354$export$54ecf528c58f9ef6; });
$parcel$export(module.exports, "FOCUS_AUTO", function () { return $cf301fe068915354$export$70e9b4a1820af101; });
$parcel$export(module.exports, "FOCUS_NO_AUTOFOCUS", function () { return $cf301fe068915354$export$134ebef29fd94853; });
/**
 * defines a focus group
 */ var $cf301fe068915354$export$4f9a06cb7441a087 = "data-focus-lock";
var $cf301fe068915354$export$aeda8252e54b50f7 = "data-focus-lock-disabled";
var $cf301fe068915354$export$54ecf528c58f9ef6 = "data-no-focus-lock";
var $cf301fe068915354$export$70e9b4a1820af101 = "data-autofocus-inside";
var $cf301fe068915354$export$134ebef29fd94853 = "data-no-autofocus";

});

parcelRegister("5yVxg", function(module, exports) {

$parcel$export(module.exports, "hiddenGuard", function () { return $40ccc2181586ca02$export$b8c7b07253306600; });

var $dAx5m = parcelRequire("dAx5m");

var $40ccc2181586ca02$export$b8c7b07253306600 = {
    width: "1px",
    height: "0px",
    padding: 0,
    overflow: "hidden",
    position: "fixed",
    top: "1px",
    left: "1px"
};
var $40ccc2181586ca02$var$InFocusGuard = function InFocusGuard(_ref) {
    var _ref$children = _ref.children, children = _ref$children === void 0 ? null : _ref$children;
    return /*#__PURE__*/ $dAx5m.createElement($dAx5m.Fragment, null, /*#__PURE__*/ $dAx5m.createElement("div", {
        key: "guard-first",
        "data-focus-guard": true,
        "data-focus-auto-guard": true,
        style: $40ccc2181586ca02$export$b8c7b07253306600
    }), children, children && /*#__PURE__*/ $dAx5m.createElement("div", {
        key: "guard-last",
        "data-focus-guard": true,
        "data-focus-auto-guard": true,
        style: $40ccc2181586ca02$export$b8c7b07253306600
    }));
};
$40ccc2181586ca02$var$InFocusGuard.propTypes = {};
var $40ccc2181586ca02$export$2e2bcd8739ae039 = $40ccc2181586ca02$var$InFocusGuard;

});

parcelRegister("8lenq", function(module, exports) {

$parcel$export(module.exports, "mediumFocus", function () { return $612b6fd26605effc$export$5733e022b1d538cb; });
$parcel$export(module.exports, "mediumBlur", function () { return $612b6fd26605effc$export$b3e9a9312f73723c; });
$parcel$export(module.exports, "mediumEffect", function () { return $612b6fd26605effc$export$3a1d52767cbc07b8; });
$parcel$export(module.exports, "mediumSidecar", function () { return $612b6fd26605effc$export$892cbf28e5518020; });

var $ZRqkl = parcelRequire("ZRqkl");
var $612b6fd26605effc$export$5733e022b1d538cb = (0, $ZRqkl.createMedium)({}, function(_ref) {
    var target = _ref.target, currentTarget = _ref.currentTarget;
    return {
        target: target,
        currentTarget: currentTarget
    };
});
var $612b6fd26605effc$export$b3e9a9312f73723c = (0, $ZRqkl.createMedium)();
var $612b6fd26605effc$export$3a1d52767cbc07b8 = (0, $ZRqkl.createMedium)();
var $612b6fd26605effc$export$892cbf28e5518020 = (0, $ZRqkl.createSidecarMedium)({
    async: true,
    ssr: typeof document !== "undefined"
});

});
parcelRegister("ZRqkl", function(module, exports) {

$parcel$export(module.exports, "createMedium", function () { return $0b9f2370c1b4ffed$export$9ffbfcaf067b02c6; });
$parcel$export(module.exports, "createSidecarMedium", function () { return $0b9f2370c1b4ffed$export$e13ec7dd7a14088d; });

var $ed9wW = parcelRequire("ed9wW");
function $0b9f2370c1b4ffed$var$ItoI(a) {
    return a;
}
function $0b9f2370c1b4ffed$var$innerCreateMedium(defaults, middleware) {
    if (middleware === void 0) middleware = $0b9f2370c1b4ffed$var$ItoI;
    var buffer = [];
    var assigned = false;
    var medium = {
        read: function() {
            if (assigned) throw new Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
            if (buffer.length) return buffer[buffer.length - 1];
            return defaults;
        },
        useMedium: function(data) {
            var item = middleware(data, assigned);
            buffer.push(item);
            return function() {
                buffer = buffer.filter(function(x) {
                    return x !== item;
                });
            };
        },
        assignSyncMedium: function(cb) {
            assigned = true;
            while(buffer.length){
                var cbs = buffer;
                buffer = [];
                cbs.forEach(cb);
            }
            buffer = {
                push: function(x) {
                    return cb(x);
                },
                filter: function() {
                    return buffer;
                }
            };
        },
        assignMedium: function(cb) {
            assigned = true;
            var pendingQueue = [];
            if (buffer.length) {
                var cbs = buffer;
                buffer = [];
                cbs.forEach(cb);
                pendingQueue = buffer;
            }
            var executeQueue = function() {
                var cbs = pendingQueue;
                pendingQueue = [];
                cbs.forEach(cb);
            };
            var cycle = function() {
                return Promise.resolve().then(executeQueue);
            };
            cycle();
            buffer = {
                push: function(x) {
                    pendingQueue.push(x);
                    cycle();
                },
                filter: function(filter) {
                    pendingQueue = pendingQueue.filter(filter);
                    return buffer;
                }
            };
        }
    };
    return medium;
}
function $0b9f2370c1b4ffed$export$9ffbfcaf067b02c6(defaults, middleware) {
    if (middleware === void 0) middleware = $0b9f2370c1b4ffed$var$ItoI;
    return $0b9f2370c1b4ffed$var$innerCreateMedium(defaults, middleware);
}
function $0b9f2370c1b4ffed$export$e13ec7dd7a14088d(options) {
    if (options === void 0) options = {};
    var medium = $0b9f2370c1b4ffed$var$innerCreateMedium(null);
    medium.options = (0, $ed9wW.__assign)({
        async: true,
        ssr: false
    }, options);
    return medium;
}

});
parcelRegister("ed9wW", function(module, exports) {

$parcel$export(module.exports, "__assign", function () { return $a589ac1d8829653c$export$18ce0697a983be9b; });
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ var $a589ac1d8829653c$var$extendStatics = function(d, b) {
    $a589ac1d8829653c$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $a589ac1d8829653c$var$extendStatics(d, b);
};
function $a589ac1d8829653c$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $a589ac1d8829653c$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $a589ac1d8829653c$export$18ce0697a983be9b = function() {
    $a589ac1d8829653c$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $a589ac1d8829653c$export$18ce0697a983be9b.apply(this, arguments);
};
function $a589ac1d8829653c$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $a589ac1d8829653c$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $a589ac1d8829653c$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $a589ac1d8829653c$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $a589ac1d8829653c$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $a589ac1d8829653c$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $a589ac1d8829653c$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $a589ac1d8829653c$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $a589ac1d8829653c$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $a589ac1d8829653c$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $a589ac1d8829653c$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $a589ac1d8829653c$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $a589ac1d8829653c$export$45d3717a4c69092e(o, m, p);
}
function $a589ac1d8829653c$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $a589ac1d8829653c$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $a589ac1d8829653c$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($a589ac1d8829653c$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $a589ac1d8829653c$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $a589ac1d8829653c$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $a589ac1d8829653c$export$10c90e4f7922046c(v) {
    return this instanceof $a589ac1d8829653c$export$10c90e4f7922046c ? (this.v = v, this) : new $a589ac1d8829653c$export$10c90e4f7922046c(v);
}
function $a589ac1d8829653c$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $a589ac1d8829653c$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $a589ac1d8829653c$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $a589ac1d8829653c$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $a589ac1d8829653c$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $a589ac1d8829653c$export$19a8beecd37a4c45 === "function" ? $a589ac1d8829653c$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $a589ac1d8829653c$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $a589ac1d8829653c$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $a589ac1d8829653c$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $a589ac1d8829653c$export$45d3717a4c69092e(result, mod, k);
    }
    $a589ac1d8829653c$var$__setModuleDefault(result, mod);
    return result;
}
function $a589ac1d8829653c$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $a589ac1d8829653c$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $a589ac1d8829653c$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $a589ac1d8829653c$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $a589ac1d8829653c$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $a589ac1d8829653c$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $a589ac1d8829653c$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $a589ac1d8829653c$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    var r, s = 0;
    function next() {
        while(r = env.stack.pop())try {
            if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
            if (r.dispose) {
                var result = r.dispose.call(r.value);
                if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } else s |= 1;
        } catch (e) {
            fail(e);
        }
        if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
        if (env.hasError) throw env.error;
    }
    return next();
}
var $a589ac1d8829653c$export$2e2bcd8739ae039 = {
    __extends: $a589ac1d8829653c$export$a8ba968b8961cb8a,
    __assign: $a589ac1d8829653c$export$18ce0697a983be9b,
    __rest: $a589ac1d8829653c$export$3c9a16f847548506,
    __decorate: $a589ac1d8829653c$export$29e00dfd3077644b,
    __param: $a589ac1d8829653c$export$d5ad3fd78186038f,
    __metadata: $a589ac1d8829653c$export$f1db080c865becb9,
    __awaiter: $a589ac1d8829653c$export$1050f835b63b671e,
    __generator: $a589ac1d8829653c$export$67ebef60e6f28a6,
    __createBinding: $a589ac1d8829653c$export$45d3717a4c69092e,
    __exportStar: $a589ac1d8829653c$export$f33643c0debef087,
    __values: $a589ac1d8829653c$export$19a8beecd37a4c45,
    __read: $a589ac1d8829653c$export$8d051b38c9118094,
    __spread: $a589ac1d8829653c$export$afc72e2116322959,
    __spreadArrays: $a589ac1d8829653c$export$6388937ca91ccae8,
    __spreadArray: $a589ac1d8829653c$export$1216008129fb82ed,
    __await: $a589ac1d8829653c$export$10c90e4f7922046c,
    __asyncGenerator: $a589ac1d8829653c$export$e427f37a30a4de9b,
    __asyncDelegator: $a589ac1d8829653c$export$bbd80228419bb833,
    __asyncValues: $a589ac1d8829653c$export$e3b29a3d6162315f,
    __makeTemplateObject: $a589ac1d8829653c$export$4fb47efe1390b86f,
    __importStar: $a589ac1d8829653c$export$c21735bcef00d192,
    __importDefault: $a589ac1d8829653c$export$da59b14a69baef04,
    __classPrivateFieldGet: $a589ac1d8829653c$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $a589ac1d8829653c$export$d40a35129aaff81f,
    __classPrivateFieldIn: $a589ac1d8829653c$export$81fdc39f203e4e04,
    __addDisposableResource: $a589ac1d8829653c$export$88ac25d8e944e405,
    __disposeResources: $a589ac1d8829653c$export$8f076105dc360e92
};

});



parcelRegister("li9HS", function(module, exports) {

$parcel$export(module.exports, "focusScope", function () { return $f802cef0bd45d113$export$f5272e9b1168239c; });

var $dAx5m = parcelRequire("dAx5m");
var $f802cef0bd45d113$export$f5272e9b1168239c = /*#__PURE__*/ (0, $dAx5m.createContext)(undefined);

});


parcelRegister("fjEvb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b2680c38edc05ad2$export$2e2bcd8739ae039; });

var $dAx5m = parcelRequire("dAx5m");


var $54u7j = parcelRequire("54u7j");

var $t0fek = parcelRequire("t0fek");
var $e0lqW = parcelRequire("e0lqW");
var $I3drC = parcelRequire("I3drC");
var $fiuUs = parcelRequire("fiuUs");
var $6H6m5 = parcelRequire("6H6m5");
var $9I2Gm = parcelRequire("9I2Gm");parcelRequire("auPsB");
var $32Pmy = parcelRequire("32Pmy");

var $b4gub = parcelRequire("b4gub");

var $8lenq = parcelRequire("8lenq");
var $b2680c38edc05ad2$var$focusOnBody = function focusOnBody() {
    return document && document.activeElement === document.body;
};
var $b2680c38edc05ad2$var$isFreeFocus = function isFreeFocus() {
    return $b2680c38edc05ad2$var$focusOnBody() || (0, $6H6m5.focusIsHidden)();
};
var $b2680c38edc05ad2$var$lastActiveTrap = null;
var $b2680c38edc05ad2$var$lastActiveFocus = null;
var $b2680c38edc05ad2$var$tryRestoreFocus = function tryRestoreFocus() {
    return null;
};
var $b2680c38edc05ad2$var$lastPortaledElement = null;
var $b2680c38edc05ad2$var$focusWasOutsideWindow = false;
var $b2680c38edc05ad2$var$windowFocused = false;
var $b2680c38edc05ad2$var$defaultWhitelist = function defaultWhitelist() {
    return true;
};
var $b2680c38edc05ad2$var$focusWhitelisted = function focusWhitelisted(activeElement) {
    return ($b2680c38edc05ad2$var$lastActiveTrap.whiteList || $b2680c38edc05ad2$var$defaultWhitelist)(activeElement);
};
var $b2680c38edc05ad2$var$recordPortal = function recordPortal(observerNode, portaledElement) {
    $b2680c38edc05ad2$var$lastPortaledElement = {
        observerNode: observerNode,
        portaledElement: portaledElement
    };
};
var $b2680c38edc05ad2$var$focusIsPortaledPair = function focusIsPortaledPair(element) {
    return $b2680c38edc05ad2$var$lastPortaledElement && $b2680c38edc05ad2$var$lastPortaledElement.portaledElement === element;
};
function $b2680c38edc05ad2$var$autoGuard(startIndex, end, step, allNodes) {
    var lastGuard = null;
    var i = startIndex;
    do {
        var item = allNodes[i];
        if (item.guard) {
            if (item.node.dataset.focusAutoGuard) lastGuard = item;
        } else if (item.lockItem) {
            if (i !== startIndex) return;
            lastGuard = null;
        } else break;
    }while ((i += step) !== end);
    if (lastGuard) lastGuard.node.tabIndex = 0;
}
var $b2680c38edc05ad2$var$focusWasOutside = function focusWasOutside(crossFrameOption) {
    if (crossFrameOption) return Boolean($b2680c38edc05ad2$var$focusWasOutsideWindow);
    return $b2680c38edc05ad2$var$focusWasOutsideWindow === "meanwhile";
};
var $b2680c38edc05ad2$var$checkInHost = function checkInHost(check, el, boundary) {
    return el && (el.host === check && (!el.activeElement || boundary.contains(el.activeElement)) || el.parentNode && checkInHost(check, el.parentNode, boundary));
};
var $b2680c38edc05ad2$var$withinHost = function withinHost(activeElement, workingArea) {
    return workingArea.some(function(area) {
        return $b2680c38edc05ad2$var$checkInHost(activeElement, area, area);
    });
};
var $b2680c38edc05ad2$var$getNodeFocusables = function getNodeFocusables(nodes) {
    return (0, $9I2Gm.getFocusableNodes)(nodes, new Map());
};
var $b2680c38edc05ad2$var$isNotFocusable = function isNotFocusable(node) {
    return !$b2680c38edc05ad2$var$getNodeFocusables([
        node.parentNode
    ]).some(function(el) {
        return el.node === node;
    });
};
var $b2680c38edc05ad2$var$activateTrap = function activateTrap() {
    var result = false;
    if ($b2680c38edc05ad2$var$lastActiveTrap) {
        var _lastActiveTrap = $b2680c38edc05ad2$var$lastActiveTrap, observed = _lastActiveTrap.observed, persistentFocus = _lastActiveTrap.persistentFocus, autoFocus = _lastActiveTrap.autoFocus, shards = _lastActiveTrap.shards, crossFrame = _lastActiveTrap.crossFrame, focusOptions = _lastActiveTrap.focusOptions, noFocusGuards = _lastActiveTrap.noFocusGuards;
        var workingNode = observed || $b2680c38edc05ad2$var$lastPortaledElement && $b2680c38edc05ad2$var$lastPortaledElement.portaledElement;
        if ($b2680c38edc05ad2$var$focusOnBody() && $b2680c38edc05ad2$var$lastActiveFocus) {
            if (!document.body.contains($b2680c38edc05ad2$var$lastActiveFocus) || $b2680c38edc05ad2$var$isNotFocusable($b2680c38edc05ad2$var$lastActiveFocus)) {
                $b2680c38edc05ad2$var$lastActiveFocus = null;
                var newTarget = $b2680c38edc05ad2$var$tryRestoreFocus();
                if (newTarget) newTarget.focus();
            }
        }
        var activeElement = document && document.activeElement;
        if (workingNode) {
            var workingArea = [
                workingNode
            ].concat(shards.map((0, $b4gub.extractRef)).filter(Boolean));
            var shouldForceRestoreFocus = function shouldForceRestoreFocus() {
                if (!$b2680c38edc05ad2$var$focusWasOutside(crossFrame) || !noFocusGuards || !$b2680c38edc05ad2$var$lastActiveFocus || $b2680c38edc05ad2$var$windowFocused) return false;
                var nodes = $b2680c38edc05ad2$var$getNodeFocusables(workingArea);
                var lastIndex = nodes.findIndex(function(_ref) {
                    var node = _ref.node;
                    return node === $b2680c38edc05ad2$var$lastActiveFocus;
                });
                return lastIndex === 0 || lastIndex === nodes.length - 1;
            };
            if (!activeElement || $b2680c38edc05ad2$var$focusWhitelisted(activeElement)) {
                if (persistentFocus || shouldForceRestoreFocus() || !$b2680c38edc05ad2$var$isFreeFocus() || !$b2680c38edc05ad2$var$lastActiveFocus && autoFocus) {
                    if (workingNode && !((0, $fiuUs.focusInside)(workingArea) || activeElement && $b2680c38edc05ad2$var$withinHost(activeElement, workingArea) || $b2680c38edc05ad2$var$focusIsPortaledPair(activeElement, workingNode))) {
                        if (document && !$b2680c38edc05ad2$var$lastActiveFocus && activeElement && !autoFocus) {
                            if (activeElement.blur) activeElement.blur();
                            document.body.focus();
                        } else {
                            result = (0, $32Pmy.moveFocusInside)(workingArea, $b2680c38edc05ad2$var$lastActiveFocus, {
                                focusOptions: focusOptions
                            });
                            $b2680c38edc05ad2$var$lastPortaledElement = {};
                        }
                    }
                    $b2680c38edc05ad2$var$focusWasOutsideWindow = false;
                    $b2680c38edc05ad2$var$lastActiveFocus = document && document.activeElement;
                    $b2680c38edc05ad2$var$tryRestoreFocus = (0, $t0fek.captureFocusRestore)($b2680c38edc05ad2$var$lastActiveFocus);
                }
            }
            if (document && activeElement !== document.activeElement && document.querySelector("[data-focus-auto-guard]")) {
                var newActiveElement = document && document.activeElement;
                var allNodes = (0, $e0lqW.expandFocusableNodes)(workingArea);
                var focusedIndex = allNodes.map(function(_ref2) {
                    var node = _ref2.node;
                    return node;
                }).indexOf(newActiveElement);
                if (focusedIndex > -1) {
                    allNodes.filter(function(_ref3) {
                        var guard = _ref3.guard, node = _ref3.node;
                        return guard && node.dataset.focusAutoGuard;
                    }).forEach(function(_ref4) {
                        var node = _ref4.node;
                        return node.removeAttribute("tabIndex");
                    });
                    $b2680c38edc05ad2$var$autoGuard(focusedIndex, allNodes.length, 1, allNodes);
                    $b2680c38edc05ad2$var$autoGuard(focusedIndex, -1, -1, allNodes);
                }
            }
        }
    }
    return result;
};
var $b2680c38edc05ad2$var$onTrap = function onTrap(event) {
    if ($b2680c38edc05ad2$var$activateTrap() && event) {
        event.stopPropagation();
        event.preventDefault();
    }
};
var $b2680c38edc05ad2$var$onBlur = function onBlur() {
    return (0, $b4gub.deferAction)($b2680c38edc05ad2$var$activateTrap);
};
var $b2680c38edc05ad2$var$onFocus = function onFocus(event) {
    var source = event.target;
    var currentNode = event.currentTarget;
    if (!currentNode.contains(source)) $b2680c38edc05ad2$var$recordPortal(currentNode, source);
};
var $b2680c38edc05ad2$var$FocusWatcher = function FocusWatcher() {
    return null;
};
var $b2680c38edc05ad2$var$FocusTrap = function FocusTrap(_ref5) {
    var children = _ref5.children;
    return /*#__PURE__*/ $dAx5m.createElement("div", {
        onBlur: $b2680c38edc05ad2$var$onBlur,
        onFocus: $b2680c38edc05ad2$var$onFocus
    }, children);
};
$b2680c38edc05ad2$var$FocusTrap.propTypes = {};
var $b2680c38edc05ad2$var$onWindowFocus = function onWindowFocus() {
    $b2680c38edc05ad2$var$windowFocused = true;
};
var $b2680c38edc05ad2$var$onWindowBlur = function onWindowBlur() {
    $b2680c38edc05ad2$var$windowFocused = false;
    $b2680c38edc05ad2$var$focusWasOutsideWindow = "just";
    (0, $b4gub.deferAction)(function() {
        $b2680c38edc05ad2$var$focusWasOutsideWindow = "meanwhile";
    });
};
var $b2680c38edc05ad2$var$attachHandler = function attachHandler() {
    document.addEventListener("focusin", $b2680c38edc05ad2$var$onTrap);
    document.addEventListener("focusout", $b2680c38edc05ad2$var$onBlur);
    window.addEventListener("focus", $b2680c38edc05ad2$var$onWindowFocus);
    window.addEventListener("blur", $b2680c38edc05ad2$var$onWindowBlur);
};
var $b2680c38edc05ad2$var$detachHandler = function detachHandler() {
    document.removeEventListener("focusin", $b2680c38edc05ad2$var$onTrap);
    document.removeEventListener("focusout", $b2680c38edc05ad2$var$onBlur);
    window.removeEventListener("focus", $b2680c38edc05ad2$var$onWindowFocus);
    window.removeEventListener("blur", $b2680c38edc05ad2$var$onWindowBlur);
};
function $b2680c38edc05ad2$var$reducePropsToState(propsList) {
    return propsList.filter(function(_ref6) {
        var disabled = _ref6.disabled;
        return !disabled;
    });
}
var $b2680c38edc05ad2$var$focusLockAPI = {
    moveFocusInside: (0, $32Pmy.moveFocusInside),
    focusInside: (0, $fiuUs.focusInside),
    focusNextElement: (0, $I3drC.focusNextElement),
    focusPrevElement: (0, $I3drC.focusPrevElement),
    focusFirstElement: (0, $I3drC.focusFirstElement),
    focusLastElement: (0, $I3drC.focusLastElement),
    captureFocusRestore: (0, $t0fek.captureFocusRestore)
};
function $b2680c38edc05ad2$var$handleStateChangeOnClient(traps) {
    var trap = traps.slice(-1)[0];
    if (trap && !$b2680c38edc05ad2$var$lastActiveTrap) $b2680c38edc05ad2$var$attachHandler();
    var lastTrap = $b2680c38edc05ad2$var$lastActiveTrap;
    var sameTrap = lastTrap && trap && trap.id === lastTrap.id;
    $b2680c38edc05ad2$var$lastActiveTrap = trap;
    if (lastTrap && !sameTrap) {
        lastTrap.onDeactivation();
        if (!traps.filter(function(_ref7) {
            var id = _ref7.id;
            return id === lastTrap.id;
        }).length) lastTrap.returnFocus(!trap);
    }
    if (trap) {
        $b2680c38edc05ad2$var$lastActiveFocus = null;
        if (!sameTrap || lastTrap.observed !== trap.observed) trap.onActivation($b2680c38edc05ad2$var$focusLockAPI);
        $b2680c38edc05ad2$var$activateTrap(true);
        (0, $b4gub.deferAction)($b2680c38edc05ad2$var$activateTrap);
    } else {
        $b2680c38edc05ad2$var$detachHandler();
        $b2680c38edc05ad2$var$lastActiveFocus = null;
    }
}
(0, $8lenq.mediumFocus).assignSyncMedium($b2680c38edc05ad2$var$onFocus);
(0, $8lenq.mediumBlur).assignMedium($b2680c38edc05ad2$var$onBlur);
(0, $8lenq.mediumEffect).assignMedium(function(cb) {
    return cb($b2680c38edc05ad2$var$focusLockAPI);
});
var $b2680c38edc05ad2$export$2e2bcd8739ae039 = (0, $54u7j.default)($b2680c38edc05ad2$var$reducePropsToState, $b2680c38edc05ad2$var$handleStateChangeOnClient)($b2680c38edc05ad2$var$FocusWatcher);

});
parcelRegister("54u7j", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3b14b01094089dba$export$2e2bcd8739ae039; });

var $63FQV = parcelRequire("63FQV");

var $2Xgcc = parcelRequire("2Xgcc");

var $dAx5m = parcelRequire("dAx5m");
function $3b14b01094089dba$var$withSideEffect(reducePropsToState, handleStateChangeOnClient) {
    function getDisplayName(WrappedComponent) {
        return WrappedComponent.displayName || WrappedComponent.name || "Component";
    }
    return function wrap(WrappedComponent) {
        var mountedInstances = [];
        var state;
        function emitChange() {
            state = reducePropsToState(mountedInstances.map(function(instance) {
                return instance.props;
            }));
            handleStateChangeOnClient(state);
        }
        var SideEffect = /*#__PURE__*/ function(_PureComponent) {
            (0, $63FQV.default)(SideEffect, _PureComponent);
            function SideEffect() {
                return _PureComponent.apply(this, arguments) || this;
            }
            // Try to use displayName of wrapped component
            SideEffect.peek = function peek() {
                return state;
            };
            var _proto = SideEffect.prototype;
            _proto.componentDidMount = function componentDidMount() {
                mountedInstances.push(this);
                emitChange();
            };
            _proto.componentDidUpdate = function componentDidUpdate() {
                emitChange();
            };
            _proto.componentWillUnmount = function componentWillUnmount() {
                var index = mountedInstances.indexOf(this);
                mountedInstances.splice(index, 1);
                emitChange();
            };
            _proto.render = function render() {
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement(WrappedComponent, this.props);
            };
            return SideEffect;
        }((0, $dAx5m.PureComponent));
        (0, $2Xgcc.default)(SideEffect, "displayName", "SideEffect(" + getDisplayName(WrappedComponent) + ")");
        return SideEffect;
    };
}
var $3b14b01094089dba$export$2e2bcd8739ae039 = $3b14b01094089dba$var$withSideEffect;

});
parcelRegister("63FQV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $46937cf027247ce7$export$2e2bcd8739ae039; });

var $4E2kU = parcelRequire("4E2kU");
function $46937cf027247ce7$export$2e2bcd8739ae039(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, (0, $4E2kU.default)(t, o);
}

});
parcelRegister("4E2kU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $361cb5ce35d3d20d$export$2e2bcd8739ae039; });
function $361cb5ce35d3d20d$export$2e2bcd8739ae039(t, e) {
    return $361cb5ce35d3d20d$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $361cb5ce35d3d20d$export$2e2bcd8739ae039(t, e);
}

});


parcelRegister("2Xgcc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $226da79c7ef1648b$export$2e2bcd8739ae039; });

var $55OPb = parcelRequire("55OPb");
function $226da79c7ef1648b$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $55OPb.default)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}

});
parcelRegister("55OPb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3b54d817cfe3f3b0$export$2e2bcd8739ae039; });

var $8qXOU = parcelRequire("8qXOU");

var $fozI9 = parcelRequire("fozI9");
function $3b54d817cfe3f3b0$export$2e2bcd8739ae039(t) {
    var i = (0, $fozI9.default)(t, "string");
    return "symbol" == (0, $8qXOU.default)(i) ? i : i + "";
}

});
parcelRegister("8qXOU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $623f2770f6d1f75d$export$2e2bcd8739ae039; });
function $623f2770f6d1f75d$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $623f2770f6d1f75d$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $623f2770f6d1f75d$export$2e2bcd8739ae039(o);
}

});

parcelRegister("fozI9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b354cc5f3e1ef550$export$2e2bcd8739ae039; });

var $8qXOU = parcelRequire("8qXOU");
function $b354cc5f3e1ef550$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $8qXOU.default)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $8qXOU.default)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}

});




parcelRegister("t0fek", function(module, exports) {

$parcel$export(module.exports, "captureFocusRestore", function () { return $0572e62130d95bad$export$d357db6e554ff59a; });

var $9I2Gm = parcelRequire("9I2Gm");
function $0572e62130d95bad$var$weakRef(value) {
    if (!value) return null;
    // #68 Safari 14.1 dont have it yet
    // FIXME: remove in 2025
    if (typeof WeakRef === "undefined") return function() {
        return value || null;
    };
    var w = value ? new WeakRef(value) : null;
    return function() {
        return (w === null || w === void 0 ? void 0 : w.deref()) || null;
    };
}
var $0572e62130d95bad$export$5061a7725be48ff9 = function(element) {
    if (!element) return null;
    var stack = [];
    var currentElement = element;
    while(currentElement && currentElement !== document.body){
        stack.push({
            current: $0572e62130d95bad$var$weakRef(currentElement),
            parent: $0572e62130d95bad$var$weakRef(currentElement.parentElement),
            left: $0572e62130d95bad$var$weakRef(currentElement.previousElementSibling),
            right: $0572e62130d95bad$var$weakRef(currentElement.nextElementSibling)
        });
        currentElement = currentElement.parentElement;
    }
    return {
        element: $0572e62130d95bad$var$weakRef(element),
        stack: stack,
        ownerDocument: element.ownerDocument
    };
};
var $0572e62130d95bad$var$restoreFocusTo = function(location) {
    var _a, _b, _c, _d, _e;
    if (!location) return undefined;
    var stack = location.stack, ownerDocument = location.ownerDocument;
    var visibilityCache = new Map();
    for(var _i = 0, stack_1 = stack; _i < stack_1.length; _i++){
        var line = stack_1[_i];
        var parent_1 = (_a = line.parent) === null || _a === void 0 ? void 0 : _a.call(line);
        // is it still here?
        if (parent_1 && ownerDocument.contains(parent_1)) {
            var left = (_b = line.left) === null || _b === void 0 ? void 0 : _b.call(line);
            var savedCurrent = line.current();
            var current = parent_1.contains(savedCurrent) ? savedCurrent : undefined;
            var right = (_c = line.right) === null || _c === void 0 ? void 0 : _c.call(line);
            var focusables = (0, $9I2Gm.getTabbableNodes)([
                parent_1
            ], visibilityCache);
            var aim = // that is element itself
            (_e = (_d = current !== null && current !== void 0 ? current : // or something in it's place
            left === null || left === void 0 ? void 0 : left.nextElementSibling) !== null && _d !== void 0 ? _d : // or somebody to the right, still close enough
            right) !== null && _e !== void 0 ? _e : // or somebody to the left, something?
            left;
            while(aim){
                for(var _f = 0, focusables_1 = focusables; _f < focusables_1.length; _f++){
                    var focusable = focusables_1[_f];
                    if (aim === null || aim === void 0 ? void 0 : aim.contains(focusable.node)) return focusable.node;
                }
                aim = aim.nextElementSibling;
            }
            if (focusables.length) // if parent contains a focusable - move there
            return focusables[0].node;
        }
    }
    // nothing matched
    return undefined;
};
var $0572e62130d95bad$export$d357db6e554ff59a = function(targetElement) {
    var location = $0572e62130d95bad$export$5061a7725be48ff9(targetElement);
    return function() {
        return $0572e62130d95bad$var$restoreFocusTo(location);
    };
};

});
parcelRegister("9I2Gm", function(module, exports) {

$parcel$export(module.exports, "filterAutoFocusable", function () { return $711a4dc15d74555e$export$2f70373d403a5d2b; });
$parcel$export(module.exports, "getTabbableNodes", function () { return $711a4dc15d74555e$export$3738e313571e2ad2; });
$parcel$export(module.exports, "getFocusableNodes", function () { return $711a4dc15d74555e$export$493d05a3a8e6532d; });
$parcel$export(module.exports, "parentAutofocusables", function () { return $711a4dc15d74555e$export$dc26309a71d1ce47; });
$parcel$export(module.exports, "contains", function () { return $711a4dc15d74555e$export$2344b14b097df817; });

var $7jayT = parcelRequire("7jayT");

var $fY49N = parcelRequire("fY49N");

var $gN7TE = parcelRequire("gN7TE");

var $2wfff = parcelRequire("2wfff");
var $711a4dc15d74555e$export$6266a5cd5915dc33 = function(nodes, visibilityCache) {
    return (0, $7jayT.toArray)(nodes).filter(function(node) {
        return (0, $fY49N.isVisibleCached)(visibilityCache, node);
    }).filter(function(node) {
        return (0, $fY49N.notHiddenInput)(node);
    });
};
var $711a4dc15d74555e$export$2f70373d403a5d2b = function(nodes, cache) {
    if (cache === void 0) cache = new Map();
    return (0, $7jayT.toArray)(nodes).filter(function(node) {
        return (0, $fY49N.isAutoFocusAllowedCached)(cache, node);
    });
};
var $711a4dc15d74555e$export$3738e313571e2ad2 = function(topNodes, visibilityCache, withGuards) {
    return (0, $gN7TE.orderByTabIndex)($711a4dc15d74555e$export$6266a5cd5915dc33((0, $2wfff.getFocusables)(topNodes, withGuards), visibilityCache), true, withGuards);
};
var $711a4dc15d74555e$export$493d05a3a8e6532d = function(topNodes, visibilityCache) {
    return (0, $gN7TE.orderByTabIndex)($711a4dc15d74555e$export$6266a5cd5915dc33((0, $2wfff.getFocusables)(topNodes), visibilityCache), false);
};
var $711a4dc15d74555e$export$dc26309a71d1ce47 = function(topNode, visibilityCache) {
    return $711a4dc15d74555e$export$6266a5cd5915dc33((0, $2wfff.getParentAutofocusables)(topNode), visibilityCache);
};
var $711a4dc15d74555e$export$2344b14b097df817 = function(scope, element) {
    if (scope.shadowRoot) return $711a4dc15d74555e$export$2344b14b097df817(scope.shadowRoot, element);
    else {
        if (Object.getPrototypeOf(scope).contains !== undefined && Object.getPrototypeOf(scope).contains.call(scope, element)) return true;
        return (0, $7jayT.toArray)(scope.children).some(function(child) {
            var _a;
            if (child instanceof HTMLIFrameElement) {
                var iframeBody = (_a = child.contentDocument) === null || _a === void 0 ? void 0 : _a.body;
                if (iframeBody) return $711a4dc15d74555e$export$2344b14b097df817(iframeBody, element);
                return false;
            }
            return $711a4dc15d74555e$export$2344b14b097df817(child, element);
        });
    }
};

});
parcelRegister("7jayT", function(module, exports) {

$parcel$export(module.exports, "toArray", function () { return $5522801439e344b3$export$45b10814cc054894; });
$parcel$export(module.exports, "asArray", function () { return $5522801439e344b3$export$75093a47a9fa838d; });
$parcel$export(module.exports, "getFirst", function () { return $5522801439e344b3$export$bcd7afcd904dce14; });
/*
IE11 support
 */ var $5522801439e344b3$export$45b10814cc054894 = function(a) {
    var ret = Array(a.length);
    for(var i = 0; i < a.length; ++i)ret[i] = a[i];
    return ret;
};
var $5522801439e344b3$export$75093a47a9fa838d = function(a) {
    return Array.isArray(a) ? a : [
        a
    ];
};
var $5522801439e344b3$export$bcd7afcd904dce14 = function(a) {
    return Array.isArray(a) ? a[0] : a;
};

});

parcelRegister("fY49N", function(module, exports) {

$parcel$export(module.exports, "isVisibleCached", function () { return $b9ffaf167de5f752$export$3c9dc299685ad160; });
$parcel$export(module.exports, "isAutoFocusAllowedCached", function () { return $b9ffaf167de5f752$export$bcaa50628f6a736e; });
$parcel$export(module.exports, "getDataset", function () { return $b9ffaf167de5f752$export$698b339b0c8edae3; });
$parcel$export(module.exports, "isRadioElement", function () { return $b9ffaf167de5f752$export$9d74f6fbc6f469d0; });
$parcel$export(module.exports, "notHiddenInput", function () { return $b9ffaf167de5f752$export$8197b0ea56b3b055; });
$parcel$export(module.exports, "isGuard", function () { return $b9ffaf167de5f752$export$d94b8b58ec2f30eb; });
$parcel$export(module.exports, "isNotAGuard", function () { return $b9ffaf167de5f752$export$602e5a0d338d7750; });
$parcel$export(module.exports, "isDefined", function () { return $b9ffaf167de5f752$export$4e62c701997796c1; });

var $hMR7v = parcelRequire("hMR7v");
var $b9ffaf167de5f752$var$isElementHidden = function(node) {
    // we can measure only "elements"
    // consider others as "visible"
    if (node.nodeType !== Node.ELEMENT_NODE) return false;
    var computedStyle = window.getComputedStyle(node, null);
    if (!computedStyle || !computedStyle.getPropertyValue) return false;
    return computedStyle.getPropertyValue("display") === "none" || computedStyle.getPropertyValue("visibility") === "hidden";
};
var $b9ffaf167de5f752$var$getParentNode = function(node) {
    // DOCUMENT_FRAGMENT_NODE can also point on ShadowRoot. In this case .host will point on the next node
    return node.parentNode && node.parentNode.nodeType === Node.DOCUMENT_FRAGMENT_NODE ? node.parentNode.host : node.parentNode;
};
var $b9ffaf167de5f752$var$isTopNode = function(node) {
    // @ts-ignore
    return node === document || node && node.nodeType === Node.DOCUMENT_NODE;
};
var $b9ffaf167de5f752$var$isInert = function(node) {
    return node.hasAttribute("inert");
};
/**
 * @see https://github.com/testing-library/jest-dom/blob/main/src/to-be-visible.js
 */ var $b9ffaf167de5f752$var$isVisibleUncached = function(node, checkParent) {
    return !node || $b9ffaf167de5f752$var$isTopNode(node) || !$b9ffaf167de5f752$var$isElementHidden(node) && !$b9ffaf167de5f752$var$isInert(node) && checkParent($b9ffaf167de5f752$var$getParentNode(node));
};
var $b9ffaf167de5f752$export$3c9dc299685ad160 = function(visibilityCache, node) {
    var cached = visibilityCache.get(node);
    if (cached !== undefined) return cached;
    var result = $b9ffaf167de5f752$var$isVisibleUncached(node, $b9ffaf167de5f752$export$3c9dc299685ad160.bind(undefined, visibilityCache));
    visibilityCache.set(node, result);
    return result;
};
var $b9ffaf167de5f752$var$isAutoFocusAllowedUncached = function(node, checkParent) {
    return node && !$b9ffaf167de5f752$var$isTopNode(node) ? $b9ffaf167de5f752$export$b8550e27de209d85(node) ? checkParent($b9ffaf167de5f752$var$getParentNode(node)) : false : true;
};
var $b9ffaf167de5f752$export$bcaa50628f6a736e = function(cache, node) {
    var cached = cache.get(node);
    if (cached !== undefined) return cached;
    var result = $b9ffaf167de5f752$var$isAutoFocusAllowedUncached(node, $b9ffaf167de5f752$export$bcaa50628f6a736e.bind(undefined, cache));
    cache.set(node, result);
    return result;
};
var $b9ffaf167de5f752$export$698b339b0c8edae3 = function(node) {
    // @ts-ignore
    return node.dataset;
};
var $b9ffaf167de5f752$export$65aad1b6bc934b11 = function(node) {
    return node.tagName === "BUTTON";
};
var $b9ffaf167de5f752$export$88a6ceeed5737ba3 = function(node) {
    return node.tagName === "INPUT";
};
var $b9ffaf167de5f752$export$9d74f6fbc6f469d0 = function(node) {
    return $b9ffaf167de5f752$export$88a6ceeed5737ba3(node) && node.type === "radio";
};
var $b9ffaf167de5f752$export$8197b0ea56b3b055 = function(node) {
    return !(($b9ffaf167de5f752$export$88a6ceeed5737ba3(node) || $b9ffaf167de5f752$export$65aad1b6bc934b11(node)) && (node.type === "hidden" || node.disabled));
};
var $b9ffaf167de5f752$export$b8550e27de209d85 = function(node) {
    var attribute = node.getAttribute((0, $hMR7v.FOCUS_NO_AUTOFOCUS));
    return ![
        true,
        "true",
        ""
    ].includes(attribute);
};
var $b9ffaf167de5f752$export$d94b8b58ec2f30eb = function(node) {
    var _a;
    return Boolean(node && ((_a = $b9ffaf167de5f752$export$698b339b0c8edae3(node)) === null || _a === void 0 ? void 0 : _a.focusGuard));
};
var $b9ffaf167de5f752$export$602e5a0d338d7750 = function(node) {
    return !$b9ffaf167de5f752$export$d94b8b58ec2f30eb(node);
};
var $b9ffaf167de5f752$export$4e62c701997796c1 = function(x) {
    return Boolean(x);
};

});

parcelRegister("gN7TE", function(module, exports) {

$parcel$export(module.exports, "orderByTabIndex", function () { return $c397590a0347bb11$export$cb40ee071f0d5226; });

var $7jayT = parcelRequire("7jayT");
var $c397590a0347bb11$export$350ee6c095d98996 = function(a, b) {
    var aTab = Math.max(0, a.tabIndex);
    var bTab = Math.max(0, b.tabIndex);
    var tabDiff = aTab - bTab;
    var indexDiff = a.index - b.index;
    if (tabDiff) {
        if (!aTab) return 1;
        if (!bTab) return -1;
    }
    return tabDiff || indexDiff;
};
var $c397590a0347bb11$var$getTabIndex = function(node) {
    if (node.tabIndex < 0) {
        // all "focusable" elements are already preselected
        // but some might have implicit negative tabIndex
        // return 0 for <audio without tabIndex attribute - it is "tabbable"
        if (!node.hasAttribute("tabindex")) return 0;
    }
    return node.tabIndex;
};
var $c397590a0347bb11$export$cb40ee071f0d5226 = function(nodes, filterNegative, keepGuards) {
    return (0, $7jayT.toArray)(nodes).map(function(node, index) {
        var tabIndex = $c397590a0347bb11$var$getTabIndex(node);
        return {
            node: node,
            index: index,
            tabIndex: keepGuards && tabIndex === -1 ? (node.dataset || {}).focusGuard ? 0 : -1 : tabIndex
        };
    }).filter(function(data) {
        return !filterNegative || data.tabIndex >= 0;
    }).sort($c397590a0347bb11$export$350ee6c095d98996);
};

});

parcelRegister("2wfff", function(module, exports) {

$parcel$export(module.exports, "getFocusables", function () { return $1d5a6544c78a9432$export$f6768025e418420e; });
$parcel$export(module.exports, "getParentAutofocusables", function () { return $1d5a6544c78a9432$export$853fa94d922e78b9; });

var $hMR7v = parcelRequire("hMR7v");

var $7jayT = parcelRequire("7jayT");

var $aNwRg = parcelRequire("aNwRg");
var $1d5a6544c78a9432$var$queryTabbables = (0, $aNwRg.tabbables).join(",");
var $1d5a6544c78a9432$var$queryGuardTabbables = "".concat($1d5a6544c78a9432$var$queryTabbables, ", [data-focus-guard]");
var $1d5a6544c78a9432$var$getFocusablesWithShadowDom = function(parent, withGuards) {
    return (0, $7jayT.toArray)((parent.shadowRoot || parent).children).reduce(function(acc, child) {
        return acc.concat(child.matches(withGuards ? $1d5a6544c78a9432$var$queryGuardTabbables : $1d5a6544c78a9432$var$queryTabbables) ? [
            child
        ] : [], $1d5a6544c78a9432$var$getFocusablesWithShadowDom(child));
    }, []);
};
var $1d5a6544c78a9432$var$getFocusablesWithIFrame = function(parent, withGuards) {
    var _a;
    // contentDocument of iframe will be null if current origin cannot access it
    if (parent instanceof HTMLIFrameElement && ((_a = parent.contentDocument) === null || _a === void 0 ? void 0 : _a.body)) return $1d5a6544c78a9432$export$f6768025e418420e([
        parent.contentDocument.body
    ], withGuards);
    return [
        parent
    ];
};
var $1d5a6544c78a9432$export$f6768025e418420e = function(parents, withGuards) {
    return parents.reduce(function(acc, parent) {
        var _a;
        var focusableWithShadowDom = $1d5a6544c78a9432$var$getFocusablesWithShadowDom(parent, withGuards);
        var focusableWithIframes = (_a = []).concat.apply(_a, focusableWithShadowDom.map(function(node) {
            return $1d5a6544c78a9432$var$getFocusablesWithIFrame(node, withGuards);
        }));
        return acc.concat(// add all tabbables inside and within shadow DOMs in DOM order
        focusableWithIframes, // add if node is tabbable itself
        parent.parentNode ? (0, $7jayT.toArray)(parent.parentNode.querySelectorAll($1d5a6544c78a9432$var$queryTabbables)).filter(function(node) {
            return node === parent;
        }) : []);
    }, []);
};
var $1d5a6544c78a9432$export$853fa94d922e78b9 = function(parent) {
    var parentFocus = parent.querySelectorAll("[".concat((0, $hMR7v.FOCUS_AUTO), "]"));
    return (0, $7jayT.toArray)(parentFocus).map(function(node) {
        return $1d5a6544c78a9432$export$f6768025e418420e([
            node
        ]);
    }).reduce(function(acc, nodes) {
        return acc.concat(nodes);
    }, []);
};

});
parcelRegister("aNwRg", function(module, exports) {

$parcel$export(module.exports, "tabbables", function () { return $7dc7f7f00367262f$export$8555f4622e95784; });
/**
 * list of the object to be considered as focusable
 */ var $7dc7f7f00367262f$export$8555f4622e95784 = [
    "button:enabled",
    "select:enabled",
    "textarea:enabled",
    "input:enabled",
    // elements with explicit roles will also use explicit tabindex
    // '[role="button"]',
    "a[href]",
    "area[href]",
    "summary",
    "iframe",
    "object",
    "embed",
    "audio[controls]",
    "video[controls]",
    "[tabindex]",
    "[contenteditable]",
    "[autofocus]"
];

});




parcelRegister("e0lqW", function(module, exports) {

$parcel$export(module.exports, "expandFocusableNodes", function () { return $a321b109273bd37a$export$f89ac71e91767111; });

var $bkSiX = parcelRequire("bkSiX");

var $fY49N = parcelRequire("fY49N");

var $lXm2p = parcelRequire("lXm2p");

var $gN7TE = parcelRequire("gN7TE");

var $2wfff = parcelRequire("2wfff");
var $a321b109273bd37a$export$f89ac71e91767111 = function(topNode) {
    var entries = (0, $bkSiX.getAllAffectedNodes)(topNode).filter((0, $fY49N.isNotAGuard));
    var commonParent = (0, $lXm2p.getTopCommonParent)(topNode, topNode, entries);
    var outerNodes = (0, $gN7TE.orderByTabIndex)((0, $2wfff.getFocusables)([
        commonParent
    ], true), true, true);
    var innerElements = (0, $2wfff.getFocusables)(entries, false);
    return outerNodes.map(function(_a) {
        var node = _a.node, index = _a.index;
        return {
            node: node,
            index: index,
            lockItem: innerElements.indexOf(node) >= 0,
            guard: (0, $fY49N.isGuard)(node)
        };
    });
};

});
parcelRegister("bkSiX", function(module, exports) {

$parcel$export(module.exports, "getAllAffectedNodes", function () { return $840bafbe331c51e1$export$7e87c4720b9b279b; });

var $hMR7v = parcelRequire("hMR7v");

var $7jayT = parcelRequire("7jayT");
/**
 * in case of multiple nodes nested inside each other
 * keeps only top ones
 * this is O(nlogn)
 * @param nodes
 * @returns {*}
 */ var $840bafbe331c51e1$var$filterNested = function(nodes) {
    var contained = new Set();
    var l = nodes.length;
    for(var i = 0; i < l; i += 1)for(var j = i + 1; j < l; j += 1){
        var position = nodes[i].compareDocumentPosition(nodes[j]);
        /* eslint-disable no-bitwise */ if ((position & Node.DOCUMENT_POSITION_CONTAINED_BY) > 0) contained.add(j);
        if ((position & Node.DOCUMENT_POSITION_CONTAINS) > 0) contained.add(i);
    /* eslint-enable */ }
    return nodes.filter(function(_, index) {
        return !contained.has(index);
    });
};
/**
 * finds top most parent for a node
 * @param node
 * @returns {*}
 */ var $840bafbe331c51e1$var$getTopParent = function(node) {
    return node.parentNode ? $840bafbe331c51e1$var$getTopParent(node.parentNode) : node;
};
var $840bafbe331c51e1$export$7e87c4720b9b279b = function(node) {
    var nodes = (0, $7jayT.asArray)(node);
    return nodes.filter(Boolean).reduce(function(acc, currentNode) {
        var group = currentNode.getAttribute((0, $hMR7v.FOCUS_GROUP));
        acc.push.apply(acc, group ? $840bafbe331c51e1$var$filterNested((0, $7jayT.toArray)($840bafbe331c51e1$var$getTopParent(currentNode).querySelectorAll("[".concat((0, $hMR7v.FOCUS_GROUP), '="').concat(group, '"]:not([').concat((0, $hMR7v.FOCUS_DISABLED), '="disabled"])')))) : [
            currentNode
        ]);
        return acc;
    }, []);
};

});

parcelRegister("lXm2p", function(module, exports) {

$parcel$export(module.exports, "getTopCommonParent", function () { return $ffc033e9756b550e$export$a9a7252b5f2e280e; });
$parcel$export(module.exports, "allParentAutofocusables", function () { return $ffc033e9756b550e$export$8f99714c70a37db1; });

var $9I2Gm = parcelRequire("9I2Gm");

var $7jayT = parcelRequire("7jayT");
var $ffc033e9756b550e$var$getParents = function(node, parents) {
    if (parents === void 0) parents = [];
    parents.push(node);
    if (node.parentNode) $ffc033e9756b550e$var$getParents(node.parentNode.host || node.parentNode, parents);
    return parents;
};
var $ffc033e9756b550e$export$a08e5f53769bce53 = function(nodeA, nodeB) {
    var parentsA = $ffc033e9756b550e$var$getParents(nodeA);
    var parentsB = $ffc033e9756b550e$var$getParents(nodeB);
    // tslint:disable-next-line:prefer-for-of
    for(var i = 0; i < parentsA.length; i += 1){
        var currentParent = parentsA[i];
        if (parentsB.indexOf(currentParent) >= 0) return currentParent;
    }
    return false;
};
var $ffc033e9756b550e$export$a9a7252b5f2e280e = function(baseActiveElement, leftEntry, rightEntries) {
    var activeElements = (0, $7jayT.asArray)(baseActiveElement);
    var leftEntries = (0, $7jayT.asArray)(leftEntry);
    var activeElement = activeElements[0];
    var topCommon = false;
    leftEntries.filter(Boolean).forEach(function(entry) {
        topCommon = $ffc033e9756b550e$export$a08e5f53769bce53(topCommon || entry, entry) || topCommon;
        rightEntries.filter(Boolean).forEach(function(subEntry) {
            var common = $ffc033e9756b550e$export$a08e5f53769bce53(activeElement, subEntry);
            if (common) {
                if (!topCommon || (0, $9I2Gm.contains)(common, topCommon)) topCommon = common;
                else topCommon = $ffc033e9756b550e$export$a08e5f53769bce53(common, topCommon);
            }
        });
    });
    // TODO: add assert here?
    return topCommon;
};
var $ffc033e9756b550e$export$8f99714c70a37db1 = function(entries, visibilityCache) {
    return entries.reduce(function(acc, node) {
        return acc.concat((0, $9I2Gm.parentAutofocusables)(node, visibilityCache));
    }, []);
};

});


parcelRegister("I3drC", function(module, exports) {

$parcel$export(module.exports, "focusNextElement", function () { return $08469ac68e30b3d8$export$3b0237e8566c8d65; });
$parcel$export(module.exports, "focusPrevElement", function () { return $08469ac68e30b3d8$export$33b47db07a82b2fb; });
$parcel$export(module.exports, "focusFirstElement", function () { return $08469ac68e30b3d8$export$2a791d8097a66406; });
$parcel$export(module.exports, "focusLastElement", function () { return $08469ac68e30b3d8$export$6a79073ddabfd6c3; });

var $bWkVU = parcelRequire("bWkVU");

var $9I2Gm = parcelRequire("9I2Gm");

var $7jayT = parcelRequire("7jayT");
var $08469ac68e30b3d8$export$1b42c72592537703 = function(element, scope, useTabbables) {
    if (!element || !scope) {
        console.error("no element or scope given");
        return {};
    }
    var shards = (0, $7jayT.asArray)(scope);
    if (shards.every(function(shard) {
        return !(0, $9I2Gm.contains)(shard, element);
    })) {
        console.error("Active element is not contained in the scope");
        return {};
    }
    var focusables = useTabbables ? (0, $9I2Gm.getTabbableNodes)(shards, new Map()) : (0, $9I2Gm.getFocusableNodes)(shards, new Map());
    var current = focusables.findIndex(function(_a) {
        var node = _a.node;
        return node === element;
    });
    if (current === -1) // an edge case, when anchor element is not found
    return undefined;
    return {
        prev: focusables[current - 1],
        next: focusables[current + 1],
        first: focusables[0],
        last: focusables[focusables.length - 1]
    };
};
var $08469ac68e30b3d8$var$getBoundary = function(shards, useTabbables) {
    var set = useTabbables ? (0, $9I2Gm.getTabbableNodes)((0, $7jayT.asArray)(shards), new Map()) : (0, $9I2Gm.getFocusableNodes)((0, $7jayT.asArray)(shards), new Map());
    return {
        first: set[0],
        last: set[set.length - 1]
    };
};
var $08469ac68e30b3d8$var$defaultOptions = function(options) {
    return Object.assign({
        scope: document.body,
        cycle: true,
        onlyTabbable: true
    }, options);
};
var $08469ac68e30b3d8$var$moveFocus = function(fromElement, options, cb) {
    if (options === void 0) options = {};
    var newOptions = $08469ac68e30b3d8$var$defaultOptions(options);
    var solution = $08469ac68e30b3d8$export$1b42c72592537703(fromElement, newOptions.scope, newOptions.onlyTabbable);
    if (!solution) return;
    var target = cb(solution, newOptions.cycle);
    if (target) (0, $bWkVU.focusOn)(target.node, newOptions.focusOptions);
};
var $08469ac68e30b3d8$export$3b0237e8566c8d65 = function(fromElement, options) {
    if (options === void 0) options = {};
    $08469ac68e30b3d8$var$moveFocus(fromElement, options, function(_a, cycle) {
        var next = _a.next, first = _a.first;
        return next || cycle && first;
    });
};
var $08469ac68e30b3d8$export$33b47db07a82b2fb = function(fromElement, options) {
    if (options === void 0) options = {};
    $08469ac68e30b3d8$var$moveFocus(fromElement, options, function(_a, cycle) {
        var prev = _a.prev, last = _a.last;
        return prev || cycle && last;
    });
};
var $08469ac68e30b3d8$var$pickBoundary = function(scope, options, what) {
    var _a;
    var boundary = $08469ac68e30b3d8$var$getBoundary(scope, (_a = options.onlyTabbable) !== null && _a !== void 0 ? _a : true);
    var node = boundary[what];
    if (node) (0, $bWkVU.focusOn)(node.node, options.focusOptions);
};
var $08469ac68e30b3d8$export$2a791d8097a66406 = function(scope, options) {
    if (options === void 0) options = {};
    $08469ac68e30b3d8$var$pickBoundary(scope, options, "first");
};
var $08469ac68e30b3d8$export$6a79073ddabfd6c3 = function(scope, options) {
    if (options === void 0) options = {};
    $08469ac68e30b3d8$var$pickBoundary(scope, options, "last");
};

});
parcelRegister("bWkVU", function(module, exports) {

$parcel$export(module.exports, "focusOn", function () { return $8b15595c714fb02a$export$c12b3da842c43a8; });
var $8b15595c714fb02a$export$c12b3da842c43a8 = function(target, focusOptions) {
    if (!target) // not clear how, but is possible https://github.com/theKashey/focus-lock/issues/53
    return;
    if ("focus" in target) target.focus(focusOptions);
    if ("contentWindow" in target && target.contentWindow) target.contentWindow.focus();
};

});


parcelRegister("fiuUs", function(module, exports) {

$parcel$export(module.exports, "focusInside", function () { return $b2308377d1889a60$export$20115f8da7baa6fa; });

var $9I2Gm = parcelRequire("9I2Gm");

var $bkSiX = parcelRequire("bkSiX");

var $7jayT = parcelRequire("7jayT");

var $cmcLg = parcelRequire("cmcLg");
var $b2308377d1889a60$var$focusInFrame = function(frame, activeElement) {
    return frame === activeElement;
};
var $b2308377d1889a60$var$focusInsideIframe = function(topNode, activeElement) {
    return Boolean((0, $7jayT.toArray)(topNode.querySelectorAll("iframe")).some(function(node) {
        return $b2308377d1889a60$var$focusInFrame(node, activeElement);
    }));
};
var $b2308377d1889a60$export$20115f8da7baa6fa = function(topNode, activeElement) {
    // const activeElement = document && getActiveElement();
    if (activeElement === void 0) activeElement = (0, $cmcLg.getActiveElement)((0, $7jayT.getFirst)(topNode).ownerDocument);
    if (!activeElement || activeElement.dataset && activeElement.dataset.focusGuard) return false;
    return (0, $bkSiX.getAllAffectedNodes)(topNode).some(function(node) {
        return (0, $9I2Gm.contains)(node, activeElement) || $b2308377d1889a60$var$focusInsideIframe(node, activeElement);
    });
};

});
parcelRegister("cmcLg", function(module, exports) {

$parcel$export(module.exports, "getActiveElement", function () { return $8ff1703a2508a6d9$export$cd4e5573fbe2b576; });
/**
 * returns active element from document or from nested shadowdoms
 */ 
var $03Ebx = parcelRequire("03Ebx");
var $8ff1703a2508a6d9$export$cd4e5573fbe2b576 = function(inDocument) {
    if (inDocument === void 0) inDocument = document;
    if (!inDocument || !inDocument.activeElement) return undefined;
    var activeElement = inDocument.activeElement;
    return activeElement.shadowRoot ? $8ff1703a2508a6d9$export$cd4e5573fbe2b576(activeElement.shadowRoot) : activeElement instanceof HTMLIFrameElement && (0, $03Ebx.safeProbe)(function() {
        return activeElement.contentWindow.document;
    }) ? $8ff1703a2508a6d9$export$cd4e5573fbe2b576(activeElement.contentWindow.document) : activeElement;
};

});
parcelRegister("03Ebx", function(module, exports) {

$parcel$export(module.exports, "safeProbe", function () { return $00af73d9bffd365f$export$78d20aae35adef88; });
var $00af73d9bffd365f$export$78d20aae35adef88 = function(cb) {
    try {
        return cb();
    } catch (e) {
        return undefined;
    }
};

});



parcelRegister("6H6m5", function(module, exports) {

$parcel$export(module.exports, "focusIsHidden", function () { return $4dfbb03a9ea75ad8$export$be6b21806d3fd485; });

var $hMR7v = parcelRequire("hMR7v");

var $9I2Gm = parcelRequire("9I2Gm");

var $7jayT = parcelRequire("7jayT");

var $cmcLg = parcelRequire("cmcLg");
var $4dfbb03a9ea75ad8$export$be6b21806d3fd485 = function(inDocument) {
    if (inDocument === void 0) inDocument = document;
    var activeElement = (0, $cmcLg.getActiveElement)(inDocument);
    if (!activeElement) return false;
    // this does not support setting FOCUS_ALLOW within shadow dom
    return (0, $7jayT.toArray)(inDocument.querySelectorAll("[".concat((0, $hMR7v.FOCUS_ALLOW), "]"))).some(function(node) {
        return (0, $9I2Gm.contains)(node, activeElement);
    });
};

});

parcelRegister("auPsB", function(module, exports) {

$parcel$export(module.exports, "moveFocusInside", function () { return (parcelRequire("32Pmy")).moveFocusInside; });

var $hMR7v = parcelRequire("hMR7v");

var $fiuUs = parcelRequire("fiuUs");

var $6H6m5 = parcelRequire("6H6m5");


var $e0lqW = parcelRequire("e0lqW");

var $32Pmy = parcelRequire("32Pmy");

var $t0fek = parcelRequire("t0fek");

var $I3drC = parcelRequire("I3drC");

var $9I2Gm = parcelRequire("9I2Gm");
/**
 * magic symbols to control focus behavior from DOM
 * see description of every particular one
 */ var $7a449fa6952d687c$export$1a988e7317c65621 = $hMR7v;
/**
 * @deprecated - please use {@link moveFocusInside} named export
 */ var $7a449fa6952d687c$var$deprecated_default_moveFocusInside = (0, $32Pmy.moveFocusInside);
var $7a449fa6952d687c$export$2e2bcd8739ae039 //
 = $7a449fa6952d687c$var$deprecated_default_moveFocusInside;

});
parcelRegister("32Pmy", function(module, exports) {

$parcel$export(module.exports, "moveFocusInside", function () { return $237966992320f39c$export$cd599851e879a025; });

var $bWkVU = parcelRequire("bWkVU");

var $6UNAi = parcelRequire("6UNAi");
var $237966992320f39c$var$guardCount = 0;
var $237966992320f39c$var$lockDisabled = false;
var $237966992320f39c$export$cd599851e879a025 = function(topNode, lastNode, options) {
    if (options === void 0) options = {};
    var focusable = (0, $6UNAi.focusSolver)(topNode, lastNode);
    // global local side effect to countain recursive lock activation and resolve focus-fighting
    if ($237966992320f39c$var$lockDisabled) return;
    if (focusable) {
        /** +FOCUS-FIGHTING prevention **/ if ($237966992320f39c$var$guardCount > 2) {
            // we have recursive entered back the lock activation
            console.error("FocusLock: focus-fighting detected. Only one focus management system could be active. See https://github.com/theKashey/focus-lock/#focus-fighting");
            $237966992320f39c$var$lockDisabled = true;
            setTimeout(function() {
                $237966992320f39c$var$lockDisabled = false;
            }, 1);
            return;
        }
        $237966992320f39c$var$guardCount++;
        (0, $bWkVU.focusOn)(focusable.node, options.focusOptions);
        $237966992320f39c$var$guardCount--;
    }
};

});
parcelRegister("6UNAi", function(module, exports) {

$parcel$export(module.exports, "focusSolver", function () { return $508e6f731158d283$export$305758c744b57f6f; });

var $jaiPc = parcelRequire("jaiPc");

var $9I2Gm = parcelRequire("9I2Gm");

var $bkSiX = parcelRequire("bkSiX");

var $7jayT = parcelRequire("7jayT");

var $cynAR = parcelRequire("cynAR");

var $cmcLg = parcelRequire("cmcLg");

var $fY49N = parcelRequire("fY49N");

var $lXm2p = parcelRequire("lXm2p");
var $508e6f731158d283$var$reorderNodes = function(srcNodes, dstNodes) {
    var remap = new Map();
    // no Set(dstNodes) for IE11 :(
    dstNodes.forEach(function(entity) {
        return remap.set(entity.node, entity);
    });
    // remap to dstNodes
    return srcNodes.map(function(node) {
        return remap.get(node);
    }).filter((0, $fY49N.isDefined));
};
var $508e6f731158d283$export$305758c744b57f6f = function(topNode, lastNode) {
    var activeElement = (0, $cmcLg.getActiveElement)((0, $7jayT.asArray)(topNode).length > 0 ? document : (0, $7jayT.getFirst)(topNode).ownerDocument);
    var entries = (0, $bkSiX.getAllAffectedNodes)(topNode).filter((0, $fY49N.isNotAGuard));
    var commonParent = (0, $lXm2p.getTopCommonParent)(activeElement || topNode, topNode, entries);
    var visibilityCache = new Map();
    var anyFocusable = (0, $9I2Gm.getFocusableNodes)(entries, visibilityCache);
    var innerElements = anyFocusable.filter(function(_a) {
        var node = _a.node;
        return (0, $fY49N.isNotAGuard)(node);
    });
    if (!innerElements[0]) return undefined;
    var outerNodes = (0, $9I2Gm.getFocusableNodes)([
        commonParent
    ], visibilityCache).map(function(_a) {
        var node = _a.node;
        return node;
    });
    var orderedInnerElements = $508e6f731158d283$var$reorderNodes(outerNodes, innerElements);
    // collect inner focusable and separately tabbables
    var innerFocusables = orderedInnerElements.map(function(_a) {
        var node = _a.node;
        return node;
    });
    var innerTabbable = orderedInnerElements.filter(function(_a) {
        var tabIndex = _a.tabIndex;
        return tabIndex >= 0;
    }).map(function(_a) {
        var node = _a.node;
        return node;
    });
    var newId = (0, $jaiPc.newFocus)(innerFocusables, innerTabbable, outerNodes, activeElement, lastNode);
    if (newId === (0, $jaiPc.NEW_FOCUS)) {
        var focusNode = // first try only tabbable, and the fallback to all focusable, as long as at least one element should be picked for focus
        (0, $cynAR.pickAutofocus)(anyFocusable, innerTabbable, (0, $lXm2p.allParentAutofocusables)(entries, visibilityCache)) || (0, $cynAR.pickAutofocus)(anyFocusable, innerFocusables, (0, $lXm2p.allParentAutofocusables)(entries, visibilityCache));
        if (focusNode) return {
            node: focusNode
        };
        else {
            console.warn("focus-lock: cannot find any node to move focus into");
            return undefined;
        }
    }
    if (newId === undefined) return newId;
    return orderedInnerElements[newId];
};

});
parcelRegister("jaiPc", function(module, exports) {

$parcel$export(module.exports, "NEW_FOCUS", function () { return $df3d8db2a00c181a$export$85710b12cf912438; });
$parcel$export(module.exports, "newFocus", function () { return $df3d8db2a00c181a$export$65842178e9bb4205; });

var $9mHJq = parcelRequire("9mHJq");

var $kWz9a = parcelRequire("kWz9a");

var $fY49N = parcelRequire("fY49N");
var $df3d8db2a00c181a$export$85710b12cf912438 = "NEW_FOCUS";
var $df3d8db2a00c181a$export$65842178e9bb4205 = function(innerNodes, innerTabbables, outerNodes, activeElement, lastNode) {
    var cnt = innerNodes.length;
    var firstFocus = innerNodes[0];
    var lastFocus = innerNodes[cnt - 1];
    var isOnGuard = (0, $fY49N.isGuard)(activeElement);
    // focus is inside
    if (activeElement && innerNodes.indexOf(activeElement) >= 0) return undefined;
    var activeIndex = activeElement !== undefined ? outerNodes.indexOf(activeElement) : -1;
    var lastIndex = lastNode ? outerNodes.indexOf(lastNode) : activeIndex;
    var lastNodeInside = lastNode ? innerNodes.indexOf(lastNode) : -1;
    // no active focus (or focus is on the body)
    if (activeIndex === -1) {
        // known fallback
        if (lastNodeInside !== -1) return lastNodeInside;
        return $df3d8db2a00c181a$export$85710b12cf912438;
    }
    // new focus, nothing to calculate
    if (lastNodeInside === -1) return $df3d8db2a00c181a$export$85710b12cf912438;
    var indexDiff = activeIndex - lastIndex;
    var firstNodeIndex = outerNodes.indexOf(firstFocus);
    var lastNodeIndex = outerNodes.indexOf(lastFocus);
    var correctedNodes = (0, $9mHJq.correctNodes)(outerNodes);
    var correctedIndex = activeElement !== undefined ? correctedNodes.indexOf(activeElement) : -1;
    var correctedIndexDiff = correctedIndex - (lastNode ? correctedNodes.indexOf(lastNode) : activeIndex);
    // old focus
    if (!indexDiff && lastNodeInside >= 0) return lastNodeInside;
    // no tabbable elements, autofocus is not possible
    if (innerTabbables.length === 0) // an edge case with no tabbable elements
    // return the last focusable one
    // with some probability this will prevent focus from cycling across the lock, but there is no tabbale elements to cycle to
    return lastNodeInside;
    var returnFirstNode = (0, $kWz9a.pickFocusable)(innerNodes, innerTabbables[0]);
    var returnLastNode = (0, $kWz9a.pickFocusable)(innerNodes, innerTabbables[innerTabbables.length - 1]);
    // first element
    if (activeIndex <= firstNodeIndex && isOnGuard && Math.abs(indexDiff) > 1) return returnLastNode;
    // last element
    if (activeIndex >= lastNodeIndex && isOnGuard && Math.abs(indexDiff) > 1) return returnFirstNode;
    // jump out, but not on the guard
    if (indexDiff && Math.abs(correctedIndexDiff) > 1) return lastNodeInside;
    // focus above lock
    if (activeIndex <= firstNodeIndex) return returnLastNode;
    // focus below lock
    if (activeIndex > lastNodeIndex) return returnFirstNode;
    // index is inside tab order, but outside Lock
    if (indexDiff) {
        if (Math.abs(indexDiff) > 1) return lastNodeInside;
        return (cnt + lastNodeInside + indexDiff) % cnt;
    }
    // do nothing
    return undefined;
};

});
parcelRegister("9mHJq", function(module, exports) {

$parcel$export(module.exports, "correctNode", function () { return $6d18174f7f3e5959$export$5261662167ad7ced; });
$parcel$export(module.exports, "correctNodes", function () { return $6d18174f7f3e5959$export$4a5a72a7124e45f9; });

var $fY49N = parcelRequire("fY49N");
var $6d18174f7f3e5959$var$findSelectedRadio = function(node, nodes) {
    return nodes.filter((0, $fY49N.isRadioElement)).filter(function(el) {
        return el.name === node.name;
    }).filter(function(el) {
        return el.checked;
    })[0] || node;
};
var $6d18174f7f3e5959$export$5261662167ad7ced = function(node, nodes) {
    if ((0, $fY49N.isRadioElement)(node) && node.name) return $6d18174f7f3e5959$var$findSelectedRadio(node, nodes);
    return node;
};
var $6d18174f7f3e5959$export$4a5a72a7124e45f9 = function(nodes) {
    // IE11 has no Set(array) constructor
    var resultSet = new Set();
    nodes.forEach(function(node) {
        return resultSet.add($6d18174f7f3e5959$export$5261662167ad7ced(node, nodes));
    });
    // using filter to support IE11
    return nodes.filter(function(node) {
        return resultSet.has(node);
    });
};

});

parcelRegister("kWz9a", function(module, exports) {

$parcel$export(module.exports, "pickFirstFocus", function () { return $f3f47cdf71316b5b$export$f4e86cfa0679b9cc; });
$parcel$export(module.exports, "pickFocusable", function () { return $f3f47cdf71316b5b$export$e06728ee87c96122; });

var $9mHJq = parcelRequire("9mHJq");
var $f3f47cdf71316b5b$export$f4e86cfa0679b9cc = function(nodes) {
    if (nodes[0] && nodes.length > 1) return (0, $9mHJq.correctNode)(nodes[0], nodes);
    return nodes[0];
};
var $f3f47cdf71316b5b$export$e06728ee87c96122 = function(nodes, node) {
    return nodes.indexOf((0, $9mHJq.correctNode)(node, nodes));
};

});


parcelRegister("cynAR", function(module, exports) {

$parcel$export(module.exports, "pickAutofocus", function () { return $923af63446918881$export$cfb742983e257555; });

var $9I2Gm = parcelRequire("9I2Gm");

var $kWz9a = parcelRequire("kWz9a");

var $fY49N = parcelRequire("fY49N");
var $923af63446918881$var$findAutoFocused = function(autoFocusables) {
    return function(node) {
        var _a;
        var autofocus = (_a = (0, $fY49N.getDataset)(node)) === null || _a === void 0 ? void 0 : _a.autofocus;
        return(// @ts-expect-error
        node.autofocus || //
        autofocus !== undefined && autofocus !== "false" || //
        autoFocusables.indexOf(node) >= 0);
    };
};
var $923af63446918881$export$cfb742983e257555 = function(nodesIndexes, orderedNodes, groups) {
    var nodes = nodesIndexes.map(function(_a) {
        var node = _a.node;
        return node;
    });
    var autoFocusable = (0, $9I2Gm.filterAutoFocusable)(nodes.filter($923af63446918881$var$findAutoFocused(groups)));
    if (autoFocusable && autoFocusable.length) return (0, $kWz9a.pickFirstFocus)(autoFocusable);
    return (0, $kWz9a.pickFirstFocus)((0, $9I2Gm.filterAutoFocusable)(orderedNodes));
};

});




parcelRegister("b4gub", function(module, exports) {

$parcel$export(module.exports, "deferAction", function () { return $80ecdb31c399ef89$export$6523025722806278; });
$parcel$export(module.exports, "extractRef", function () { return $80ecdb31c399ef89$export$c613fed06e332533; });
function $80ecdb31c399ef89$export$6523025722806278(action) {
    setTimeout(action, 1);
}
var $80ecdb31c399ef89$export$db10c343af3f20fa = function inlineProp(name, value) {
    var obj = {};
    obj[name] = value;
    return obj;
};
var $80ecdb31c399ef89$export$c613fed06e332533 = function extractRef(ref) {
    return ref && "current" in ref ? ref.current : ref;
};

});




parcelRegister("5SgSF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $g8KI1 = parcelRequire("g8KI1");
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function get() {
        return $446f17088ff57561$var$_interopRequireDefault($g8KI1).default;
    }
});

var $3X0uc = parcelRequire("3X0uc");
Object.defineProperty(module.exports, "TouchScrollable", {
    enumerable: true,
    get: function get() {
        return $3X0uc.TouchScrollable;
    }
});
function $446f17088ff57561$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}

});
parcelRegister("g8KI1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $bc01a01cb932961a$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $dAx5m = parcelRequire("dAx5m");
var $bc01a01cb932961a$var$_react2 = $bc01a01cb932961a$var$_interopRequireDefault($dAx5m);

var $5Fvus = parcelRequire("5Fvus");

var $3X0uc = parcelRequire("3X0uc");

var $iykGP = parcelRequire("iykGP");
var $bc01a01cb932961a$var$_withLockSheet2 = $bc01a01cb932961a$var$_interopRequireDefault($iykGP);

var $gXupg = parcelRequire("gXupg");
var $bc01a01cb932961a$var$_withTouchListeners2 = $bc01a01cb932961a$var$_interopRequireDefault($gXupg);

var $bs5ms = parcelRequire("bs5ms");
function $bc01a01cb932961a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $bc01a01cb932961a$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $bc01a01cb932961a$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $bc01a01cb932961a$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $bc01a01cb932961a$var$ScrollLock = function(_PureComponent) {
    $bc01a01cb932961a$var$_inherits(ScrollLock, _PureComponent);
    function ScrollLock() {
        $bc01a01cb932961a$var$_classCallCheck(this, ScrollLock);
        return $bc01a01cb932961a$var$_possibleConstructorReturn(this, (ScrollLock.__proto__ || Object.getPrototypeOf(ScrollLock)).apply(this, arguments));
    }
    $bc01a01cb932961a$var$_createClass(ScrollLock, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                if (!$5Fvus.canUseDOM) return;
                this.initialHeight = window.innerHeight;
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                var offset = window.innerHeight - this.initialHeight;
                // adjust scroll if the window has been resized since the lock was engaged
                // e.g. mobile safari dynamic chrome heights
                if (offset) window.scrollTo(0, window.pageYOffset + offset);
                // reset the initial height in case this scroll lock is used again
                this.initialHeight = window.innerHeight;
            }
        },
        {
            key: "render",
            value: function render() {
                var children = this.props.children;
                return children ? $bc01a01cb932961a$var$_react2.default.createElement($3X0uc.TouchScrollable, null, children) : null;
            }
        }
    ]);
    return ScrollLock;
}($dAx5m.PureComponent);
// attach the stylesheet and inject styles on [un]mount
var $bc01a01cb932961a$var$compose = (0, $bs5ms.pipe)($bc01a01cb932961a$var$_withTouchListeners2.default, $bc01a01cb932961a$var$_withLockSheet2.default);
var $bc01a01cb932961a$var$SheetLock = $bc01a01cb932961a$var$compose($bc01a01cb932961a$var$ScrollLock);
// toggle the lock based on `isActive` prop
var $bc01a01cb932961a$var$LockToggle = function LockToggle(props) {
    return props.isActive ? $bc01a01cb932961a$var$_react2.default.createElement($bc01a01cb932961a$var$SheetLock, props) : props.children;
};
$bc01a01cb932961a$var$LockToggle.defaultProps = {
    accountForScrollbars: true,
    children: null,
    isActive: true
};
module.exports.default = $bc01a01cb932961a$var$LockToggle;

});
parcelRegister("3X0uc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TouchScrollable = undefined;
var $2e07424a873459f6$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $2e07424a873459f6$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $dAx5m = parcelRequire("dAx5m");

var $5Fvus = parcelRequire("5Fvus");

var $bs5ms = parcelRequire("bs5ms");
function $2e07424a873459f6$var$_objectWithoutProperties(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
}
function $2e07424a873459f6$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $2e07424a873459f6$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $2e07424a873459f6$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $2e07424a873459f6$var$TouchScrollable = module.exports.TouchScrollable = function(_PureComponent) {
    $2e07424a873459f6$var$_inherits(TouchScrollable, _PureComponent);
    function TouchScrollable() {
        var _ref;
        var _temp, _this, _ret;
        $2e07424a873459f6$var$_classCallCheck(this, TouchScrollable);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this = $2e07424a873459f6$var$_possibleConstructorReturn(this, (_ref = TouchScrollable.__proto__ || Object.getPrototypeOf(TouchScrollable)).call.apply(_ref, [
            this
        ].concat(args))), _this), _this.getScrollableArea = function(ref) {
            _this.scrollableArea = ref;
        }, _temp), $2e07424a873459f6$var$_possibleConstructorReturn(_this, _ret);
    }
    $2e07424a873459f6$var$_createClass(TouchScrollable, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                if (!$5Fvus.canUseEventListeners) return;
                this.scrollableArea.addEventListener("touchstart", $bs5ms.preventInertiaScroll, $bs5ms.listenerOptions);
                this.scrollableArea.addEventListener("touchmove", $bs5ms.allowTouchMove, $bs5ms.listenerOptions);
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                if (!$5Fvus.canUseEventListeners) return;
                this.scrollableArea.removeEventListener("touchstart", $bs5ms.preventInertiaScroll, $bs5ms.listenerOptions);
                this.scrollableArea.removeEventListener("touchmove", $bs5ms.allowTouchMove, $bs5ms.listenerOptions);
            }
        },
        {
            key: "render",
            value: function render() {
                var _props = this.props, children = _props.children, rest = $2e07424a873459f6$var$_objectWithoutProperties(_props, [
                    "children"
                ]);
                return typeof children === "function" ? children(this.getScrollableArea) : (0, $dAx5m.cloneElement)(children, $2e07424a873459f6$var$_extends({
                    ref: this.getScrollableArea
                }, rest));
            }
        }
    ]);
    return TouchScrollable;
}($dAx5m.PureComponent);

});
parcelRegister("bs5ms", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.pipe = module.exports.listenerOptions = undefined;
module.exports.preventTouchMove = $856677e20a69d471$var$preventTouchMove;
module.exports.allowTouchMove = $856677e20a69d471$var$allowTouchMove;
module.exports.preventInertiaScroll = $856677e20a69d471$var$preventInertiaScroll;
module.exports.isTouchDevice = $856677e20a69d471$var$isTouchDevice;
module.exports.camelToKebab = $856677e20a69d471$var$camelToKebab;
module.exports.parse = $856677e20a69d471$var$parse;
module.exports.getPadding = $856677e20a69d471$var$getPadding;
module.exports.getWindowHeight = $856677e20a69d471$var$getWindowHeight;
module.exports.getDocumentHeight = $856677e20a69d471$var$getDocumentHeight;
module.exports.makeStyleTag = $856677e20a69d471$var$makeStyleTag;
module.exports.injectStyles = $856677e20a69d471$var$injectStyles;
module.exports.insertStyleTag = $856677e20a69d471$var$insertStyleTag;

var $5Fvus = parcelRequire("5Fvus");
var $856677e20a69d471$var$listenerOptions = module.exports.listenerOptions = {
    capture: false,
    passive: false
};
// ==============================
// Touch Helpers
// ==============================
function $856677e20a69d471$var$preventTouchMove(e) {
    e.preventDefault();
    return false;
}
function $856677e20a69d471$var$allowTouchMove(e) {
    var target = e.currentTarget;
    if (target.scrollHeight > target.clientHeight) {
        e.stopPropagation();
        return true;
    }
    e.preventDefault();
    return false;
}
function $856677e20a69d471$var$preventInertiaScroll() {
    var top = this.scrollTop;
    var totalScroll = this.scrollHeight;
    var currentScroll = top + this.offsetHeight;
    if (top === 0) this.scrollTop = 1;
    else if (currentScroll === totalScroll) this.scrollTop = top - 1;
}
// `ontouchstart` check works on most browsers
// `maxTouchPoints` works on IE10/11 and Surface
function $856677e20a69d471$var$isTouchDevice() {
    if (!$5Fvus.canUseDOM) return false;
    return "ontouchstart" in window || navigator.maxTouchPoints;
}
// ==============================
// Misc.
// ==============================
function $856677e20a69d471$var$camelToKebab(str) {
    return str.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase();
}
function $856677e20a69d471$var$parse(val) {
    return isNaN(val) ? val : val + "px";
}
// Take a list of functions and return a function that applies the list of
// functions from left to right
var $856677e20a69d471$var$pipeFns = function pipeFns(a, b) {
    return function() {
        return b(a.apply(undefined, arguments));
    };
};
var $856677e20a69d471$var$pipe = module.exports.pipe = function pipe() {
    for(var _len = arguments.length, fns = Array(_len), _key = 0; _key < _len; _key++)fns[_key] = arguments[_key];
    return fns.reduce($856677e20a69d471$var$pipeFns);
};
// ==============================
// Document Helpers
// ==============================
function $856677e20a69d471$var$getPadding() {
    if (!$5Fvus.canUseDOM) return 0;
    var paddingRight = parseInt(window.getComputedStyle(document.body).paddingRight, 10);
    var scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
    return paddingRight + scrollbarWidth;
}
function $856677e20a69d471$var$getWindowHeight() {
    var multiplier = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
    if ($5Fvus.canUseDOM) return window.innerHeight * multiplier;
}
function $856677e20a69d471$var$getDocumentHeight() {
    if ($5Fvus.canUseDOM) return document.body.clientHeight;
}
// ==============================
// Style Sheets
// ==============================
function $856677e20a69d471$var$makeStyleTag() {
    if (!$5Fvus.canUseDOM) return;
    var tag = document.createElement("style");
    tag.type = "text/css";
    tag.setAttribute("data-react-scrolllock", "");
    return tag;
}
function $856677e20a69d471$var$injectStyles(tag, css) {
    if (!$5Fvus.canUseDOM) return;
    if (tag.styleSheet) tag.styleSheet.cssText = css;
    else tag.appendChild(document.createTextNode(css));
}
function $856677e20a69d471$var$insertStyleTag(tag) {
    if (!$5Fvus.canUseDOM) return;
    var head = document.head || document.getElementsByTagName("head")[0];
    head.appendChild(tag);
}

});


parcelRegister("iykGP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $d81b73895cc83f02$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
module.exports.default = $d81b73895cc83f02$var$withLockSheet;

var $dAx5m = parcelRequire("dAx5m");
var $d81b73895cc83f02$var$_react2 = $d81b73895cc83f02$var$_interopRequireDefault($dAx5m);

var $bs5ms = parcelRequire("bs5ms");
function $d81b73895cc83f02$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $d81b73895cc83f02$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $d81b73895cc83f02$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $d81b73895cc83f02$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
function $d81b73895cc83f02$var$withLockSheet(WrappedComponent) {
    return function(_PureComponent) {
        $d81b73895cc83f02$var$_inherits(SheetProvider, _PureComponent);
        function SheetProvider() {
            var _ref;
            var _temp, _this, _ret;
            $d81b73895cc83f02$var$_classCallCheck(this, SheetProvider);
            for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            return _ret = (_temp = (_this = $d81b73895cc83f02$var$_possibleConstructorReturn(this, (_ref = SheetProvider.__proto__ || Object.getPrototypeOf(SheetProvider)).call.apply(_ref, [
                this
            ].concat(args))), _this), _this.addSheet = function() {
                var styles = _this.getStyles();
                var sheet = (0, $bs5ms.makeStyleTag)();
                if (!sheet) return;
                (0, $bs5ms.injectStyles)(sheet, styles);
                (0, $bs5ms.insertStyleTag)(sheet);
                _this.sheet = sheet;
            }, _this.getStyles = function() {
                var accountForScrollbars = _this.props.accountForScrollbars;
                var height = (0, $bs5ms.getDocumentHeight)();
                var paddingRight = accountForScrollbars ? (0, $bs5ms.getPadding)() : null;
                var styles = "body {\n        box-sizing: border-box !important;\n        overflow: hidden !important;\n        position: relative !important;\n        " + (height ? "height: " + height + "px !important;" : "") + "\n        " + (paddingRight ? "padding-right: " + paddingRight + "px !important;" : "") + "\n      }";
                return styles;
            }, _temp), $d81b73895cc83f02$var$_possibleConstructorReturn(_this, _ret);
        }
        $d81b73895cc83f02$var$_createClass(SheetProvider, [
            {
                key: "componentDidMount",
                value: function componentDidMount() {
                    this.addSheet();
                }
            },
            {
                key: "removeSheet",
                value: function removeSheet() {
                    if (!this.sheet) return;
                    // $FlowFixMe
                    this.sheet.parentNode.removeChild(this.sheet);
                    this.sheet = null;
                }
            },
            {
                key: "componentWillUnmount",
                value: function componentWillUnmount() {
                    this.removeSheet();
                }
            },
            {
                key: "render",
                value: function render() {
                    return $d81b73895cc83f02$var$_react2.default.createElement(WrappedComponent, this.props);
                }
            }
        ]);
        return SheetProvider;
    }($dAx5m.PureComponent);
}

});

parcelRegister("gXupg", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $c589be1bd5999452$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
module.exports.default = $c589be1bd5999452$var$withTouchListeners;

var $dAx5m = parcelRequire("dAx5m");
var $c589be1bd5999452$var$_react2 = $c589be1bd5999452$var$_interopRequireDefault($dAx5m);

var $5Fvus = parcelRequire("5Fvus");

var $bs5ms = parcelRequire("bs5ms");
function $c589be1bd5999452$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $c589be1bd5999452$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $c589be1bd5999452$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $c589be1bd5999452$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
// Mobile Safari ignores { overflow: hidden } declaration on the body,
// so we have to prevent touchmove events via JS
function $c589be1bd5999452$var$withTouchListeners(WrappedComponent) {
    return function(_PureComponent) {
        $c589be1bd5999452$var$_inherits(TouchProvider, _PureComponent);
        function TouchProvider() {
            $c589be1bd5999452$var$_classCallCheck(this, TouchProvider);
            return $c589be1bd5999452$var$_possibleConstructorReturn(this, (TouchProvider.__proto__ || Object.getPrototypeOf(TouchProvider)).apply(this, arguments));
        }
        $c589be1bd5999452$var$_createClass(TouchProvider, [
            {
                key: "componentDidMount",
                value: function componentDidMount() {
                    if (!$5Fvus.canUseDOM || !(0, $bs5ms.isTouchDevice)()) return;
                    document.addEventListener("touchmove", $bs5ms.preventTouchMove, $bs5ms.listenerOptions);
                }
            },
            {
                key: "componentWillUnmount",
                value: function componentWillUnmount() {
                    if (!$5Fvus.canUseDOM || !(0, $bs5ms.isTouchDevice)()) return;
                    document.removeEventListener("touchmove", $bs5ms.preventTouchMove, $bs5ms.listenerOptions);
                }
            },
            {
                key: "render",
                value: function render() {
                    return $c589be1bd5999452$var$_react2.default.createElement(WrappedComponent, this.props);
                }
            }
        ]);
        return TouchProvider;
    }($dAx5m.PureComponent);
}

});




parcelRegister("4cwGG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $30f1a37473435daf$export$2e2bcd8739ae039; });

var $sN2rQ = parcelRequire("sN2rQ");

var $dTYVX = parcelRequire("dTYVX");

var $jVTBW = parcelRequire("jVTBW");

var $1zU5H = parcelRequire("1zU5H");
var $30f1a37473435daf$var$_excluded = [
    "cssFn"
];
var $30f1a37473435daf$var$defaultStyle = {
    alignItems: "center",
    boxSizing: "border-box",
    color: "var(--ds-text-subtle, ".concat((0, $1zU5H.N500), ")"),
    display: "flex",
    flexShrink: 0,
    flexDirection: "column",
    height: "100vh",
    paddingBottom: "var(--ds-space-200, 16px)",
    paddingTop: "var(--ds-space-300, 24px)",
    width: "var(--ds-space-800, 64px)"
};
var $30f1a37473435daf$var$sidebarCSS = function sidebarCSS() {
    return $30f1a37473435daf$var$defaultStyle;
};
var $30f1a37473435daf$var$Sidebar = function Sidebar(_ref) {
    var cssFn = _ref.cssFn, props = (0, (/*@__PURE__*/$parcel$interopDefault($dTYVX)))(_ref, $30f1a37473435daf$var$_excluded);
    // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @repo/internal/react/no-unsafe-spread-props, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    return (0, $jVTBW.jsx)("div", (0, (/*@__PURE__*/$parcel$interopDefault($sN2rQ)))({
        css: (0, $jVTBW.css)(cssFn($30f1a37473435daf$var$defaultStyle))
    }, props));
};
var $30f1a37473435daf$var$sidebarDefaults = {
    component: $30f1a37473435daf$var$Sidebar,
    cssFn: $30f1a37473435daf$var$sidebarCSS
};
var $30f1a37473435daf$export$2e2bcd8739ae039 = $30f1a37473435daf$var$sidebarDefaults;

});



parcelRegister("dViVv", function(module, exports) {

$parcel$export(module.exports, "AtlassianIcon", function () { return $a22f479f00dfeaf9$export$8a485e2e7ed91e8f; });
/* eslint-disable max-len */ 
var $dAx5m = parcelRequire("dAx5m");

var $h0JxK = parcelRequire("h0JxK");

var $2na4u = parcelRequire("2na4u");

var $8sWx6 = parcelRequire("8sWx6");

var $c546B = parcelRequire("c546B");
var $a22f479f00dfeaf9$var$svg = function svg(_ref) {
    var appearance = _ref.appearance, iconGradientStart = _ref.iconGradientStart, iconGradientStop = _ref.iconGradientStop, iconColor = _ref.iconColor;
    var colors = {
        iconGradientStart: iconGradientStart,
        iconGradientStop: iconGradientStop,
        iconColor: iconColor
    };
    // Will be fixed upon removal of deprecated iconGradientStart and
    // iconGradientStop props, or with React 18's useId() hook when we update.
    // eslint-disable-next-line @repo/internal/react/disallow-unstable-values
    var id = (0, $h0JxK.uid)({
        iconGradientStart: iconGradientStop
    });
    if (appearance) colors = (0, $8sWx6.getColorsFromAppearance)(appearance);
    return '\n  <svg viewBox="0 0 32 32" height="32" xmlns="http://www.w3.org/2000/svg" focusable="false" aria-hidden="true">\n    <defs>\n      <linearGradient id="'.concat(id, '" x1="14.8402" y1="15.8324" x2="8.6599" y2="26.5369" gradientUnits="userSpaceOnUse">\n        <stop stop-color="').concat(colors.iconGradientStart, '" ').concat(colors.iconGradientStart === "inherit" ? 'stop-opacity="0.4"' : "", ' offset="0%"></stop>\n        <stop stop-color="').concat(colors.iconGradientStop, '" offset="0.9228"></stop>\n      </linearGradient>\n    </defs>\n    <path fill="url(#').concat(id, ')" d="M11.6397 14.0398C11.2789 13.643 10.7378 13.679 10.4852 14.148L4.64091 25.8728C4.42446 26.3418 4.74912 26.8829 5.25419 26.8829H13.4074C13.6599 26.8829 13.9125 26.7386 14.0207 26.4861C15.7885 22.8424 14.7061 17.3227 11.6397 14.0398Z" />\n    <path fill="').concat(colors.iconColor, '" d="M15.9343 3.36124C12.6513 8.55622 12.8678 14.2923 15.0324 18.6215C17.1969 22.9506 18.8565 26.2336 18.9647 26.4861C19.0729 26.7386 19.3254 26.8829 19.578 26.8829H27.7312C28.2363 26.8829 28.597 26.3418 28.3445 25.8728C28.3445 25.8728 17.3774 3.93846 17.0887 3.39732C16.8723 2.89225 16.259 2.85618 15.9343 3.36124Z" />\n  </svg>');
};
var $a22f479f00dfeaf9$export$8a485e2e7ed91e8f = function AtlassianIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? "Atlassian" : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $2na4u.defaultLogoParams).size : _ref2$size, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $2na4u.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$iconGradientSta = _ref2.iconGradientStart, iconGradientStart = _ref2$iconGradientSta === void 0 ? (0, $2na4u.defaultLogoParams).iconGradientStart : _ref2$iconGradientSta, _ref2$iconGradientSto = _ref2.iconGradientStop, iconGradientStop = _ref2$iconGradientSto === void 0 ? (0, $2na4u.defaultLogoParams).iconGradientStop : _ref2$iconGradientSto, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $2na4u.defaultLogoParams).textColor : _ref2$textColor, testId = _ref2.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $c546B.default), {
        appearance: appearance,
        label: label,
        svg: $a22f479f00dfeaf9$var$svg({
            appearance: appearance,
            iconGradientStart: iconGradientStart,
            iconGradientStop: iconGradientStop,
            iconColor: iconColor
        }),
        iconColor: iconColor,
        iconGradientStart: iconGradientStart,
        iconGradientStop: iconGradientStop,
        textColor: textColor,
        size: size,
        testId: testId
    });
};

});

parcelRegister("jBIjf", function(module, exports) {

$parcel$export(module.exports, "FocusedTaskContent", function () { return $f6767beb62cfe0bb$export$162f6e571fdc0b26; });

var $ku6eE = parcelRequire("ku6eE");
const $f6767beb62cfe0bb$export$162f6e571fdc0b26 = (0, $ku6eE.default).div`
  width: 368px;
  margin: auto;
`;

});



parcelRegister("52IGI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $eeb5cf643da5fd2d$export$2e2bcd8739ae039; });

var $ktKLu = parcelRequire("ktKLu");
var $eeb5cf643da5fd2d$export$2e2bcd8739ae039 = (0, $ktKLu.default);

});
parcelRegister("ktKLu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $81f101d693eb61af$export$2e2bcd8739ae039; });

var $bibO8 = parcelRequire("bibO8");
parcelRequire("dAx5m");

var $lXo0o = parcelRequire("lXo0o");
const $81f101d693eb61af$var$GenericInlineDialogContent = ({ headline: headline, message: message })=>{
    return /*#__PURE__*/ (0, $bibO8.jsxs)((0, $bibO8.Fragment), {
        children: [
            headline ? /*#__PURE__*/ (0, $bibO8.jsx)($lXo0o.Headline, {
                children: headline
            }) : null,
            typeof message === "string" ? /*#__PURE__*/ (0, $bibO8.jsx)("p", {
                children: message
            }) : message
        ]
    });
};
var $81f101d693eb61af$export$2e2bcd8739ae039 = $81f101d693eb61af$var$GenericInlineDialogContent;

});
parcelRegister("lXo0o", function(module, exports) {

$parcel$export(module.exports, "Headline", function () { return $66e9127043f80474$export$e1faab0803786bcf; });

var $gbKg7 = parcelRequire("gbKg7");

var $ku6eE = parcelRequire("ku6eE");
const $66e9127043f80474$export$e1faab0803786bcf = (0, $ku6eE.default).h5`
  margin: 0 0 ${(0, $gbKg7.default)("space.150", "12px")} 0;
`;

});



parcelRegister("hKSu6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return (parcelRequire("l5OgO")).default; });

var $l5OgO = parcelRequire("l5OgO");

var $iNFKX = parcelRequire("iNFKX");

});
parcelRegister("l5OgO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b71e4930044b8e85$export$2e2bcd8739ae039; });

var $bibO8 = parcelRequire("bibO8");

var $dAx5m = parcelRequire("dAx5m");

var $6PkJI = parcelRequire("6PkJI");

var $77YRX = parcelRequire("77YRX");

var $iNFKX = parcelRequire("iNFKX");
/**
 * Sets up the react-intl IntlProvider for its children, blocking until translations are loaded
 */ const $b71e4930044b8e85$var$NO_MESSAGES = {};
const $b71e4930044b8e85$var$I18nProvider = ({ children: children, messagesConfig: messagesConfig, locale: predefinedLocale })=>{
    const [locale, setLocale] = (0, $dAx5m.useState)((0, $iNFKX.DEFAULT_LOCALE));
    const [messages, setMessages] = (0, $dAx5m.useState)();
    (0, $dAx5m.useEffect)(()=>{
        const loadData = async ()=>{
            const locale = await (0, $iNFKX.getEffectiveLocale)(predefinedLocale);
            if (locale === (0, $iNFKX.DEFAULT_LOCALE)) {
                // Everything is already loaded for English
                setLocale((0, $iNFKX.DEFAULT_LOCALE));
                setMessages($b71e4930044b8e85$var$NO_MESSAGES);
                return;
            }
            try {
                const messages = await (0, $iNFKX.loadIntlData)(messagesConfig, locale);
                setLocale(locale);
                setMessages(messages || $b71e4930044b8e85$var$NO_MESSAGES);
            } catch (error) {
                (0, $77YRX.logException)(error, "Error loading translations.", {
                    locale: locale
                });
                // show english on error
                setLocale((0, $iNFKX.DEFAULT_LOCALE));
                setMessages($b71e4930044b8e85$var$NO_MESSAGES);
            }
        };
        loadData();
    }, [
        messagesConfig,
        predefinedLocale
    ]);
    if (!messages) return null;
    return /*#__PURE__*/ (0, $bibO8.jsx)((0, $6PkJI.default), {
        locale: locale,
        messages: messages,
        children: children
    });
};
var $b71e4930044b8e85$export$2e2bcd8739ae039 = $b71e4930044b8e85$var$I18nProvider;

});
parcelRegister("6PkJI", function(module, exports) {

$parcel$export(module.exports, "createIntl", function () { return $4f87974ff8a57de0$export$7e4cbedfdd7b4c0d; });
$parcel$export(module.exports, "default", function () { return $4f87974ff8a57de0$export$2e2bcd8739ae039; });
/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */ 
var $evtaG = parcelRequire("evtaG");

var $dAx5m = parcelRequire("dAx5m");

var $ja4jS = parcelRequire("ja4jS");

var $hJU20 = parcelRequire("hJU20");

var $gUTyg = parcelRequire("gUTyg");
var $kIkDA = parcelRequire("kIkDA");
var $1HnRf = parcelRequire("1HnRf");

var $l1ayF = parcelRequire("l1ayF");
function $4f87974ff8a57de0$var$processIntlConfig(config) {
    return {
        locale: config.locale,
        timeZone: config.timeZone,
        fallbackOnEmptyString: config.fallbackOnEmptyString,
        formats: config.formats,
        textComponent: config.textComponent,
        messages: config.messages,
        defaultLocale: config.defaultLocale,
        defaultFormats: config.defaultFormats,
        onError: config.onError,
        onWarn: config.onWarn,
        wrapRichTextChunksInFragment: config.wrapRichTextChunksInFragment,
        defaultRichTextElements: config.defaultRichTextElements
    };
}
function $4f87974ff8a57de0$var$assignUniqueKeysToFormatXMLElementFnArgument(values) {
    if (!values) return values;
    return Object.keys(values).reduce(function(acc, k) {
        var v = values[k];
        acc[k] = (0, $l1ayF.isFormatXMLElementFn)(v) ? (0, $hJU20.assignUniqueKeysToParts)(v) : v;
        return acc;
    }, {});
}
var $4f87974ff8a57de0$var$formatMessage = function(config, formatters, descriptor, rawValues) {
    var rest = [];
    for(var _i = 4; _i < arguments.length; _i++)rest[_i - 4] = arguments[_i];
    var values = $4f87974ff8a57de0$var$assignUniqueKeysToFormatXMLElementFnArgument(rawValues);
    var chunks = (0, $1HnRf.formatMessage).apply(void 0, (0, $evtaG.__spreadArray)([
        config,
        formatters,
        descriptor,
        values
    ], rest, false));
    if (Array.isArray(chunks)) return $dAx5m.Children.toArray(chunks);
    return chunks;
};
var $4f87974ff8a57de0$export$7e4cbedfdd7b4c0d = function(_a, cache) {
    var rawDefaultRichTextElements = _a.defaultRichTextElements, config = (0, $evtaG.__rest)(_a, [
        "defaultRichTextElements"
    ]);
    var defaultRichTextElements = $4f87974ff8a57de0$var$assignUniqueKeysToFormatXMLElementFnArgument(rawDefaultRichTextElements);
    var coreIntl = (0, $gUTyg.createIntl)((0, $evtaG.__assign)((0, $evtaG.__assign)((0, $evtaG.__assign)({}, (0, $hJU20.DEFAULT_INTL_CONFIG)), config), {
        defaultRichTextElements: defaultRichTextElements
    }), cache);
    return (0, $evtaG.__assign)((0, $evtaG.__assign)({}, coreIntl), {
        formatMessage: $4f87974ff8a57de0$var$formatMessage.bind(null, {
            locale: coreIntl.locale,
            timeZone: coreIntl.timeZone,
            fallbackOnEmptyString: coreIntl.fallbackOnEmptyString,
            formats: coreIntl.formats,
            defaultLocale: coreIntl.defaultLocale,
            defaultFormats: coreIntl.defaultFormats,
            messages: coreIntl.messages,
            onError: coreIntl.onError,
            defaultRichTextElements: defaultRichTextElements
        }, coreIntl.formatters)
    });
};
var $4f87974ff8a57de0$var$IntlProvider = /** @class */ function(_super) {
    (0, $evtaG.__extends)(IntlProvider, _super);
    function IntlProvider() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.cache = (0, $kIkDA.createIntlCache)();
        _this.state = {
            cache: _this.cache,
            intl: $4f87974ff8a57de0$export$7e4cbedfdd7b4c0d($4f87974ff8a57de0$var$processIntlConfig(_this.props), _this.cache),
            prevConfig: $4f87974ff8a57de0$var$processIntlConfig(_this.props)
        };
        return _this;
    }
    IntlProvider.getDerivedStateFromProps = function(props, _a) {
        var prevConfig = _a.prevConfig, cache = _a.cache;
        var config = $4f87974ff8a57de0$var$processIntlConfig(props);
        if (!(0, $hJU20.shallowEqual)(prevConfig, config)) return {
            intl: $4f87974ff8a57de0$export$7e4cbedfdd7b4c0d(config, cache),
            prevConfig: config
        };
        return null;
    };
    IntlProvider.prototype.render = function() {
        (0, $hJU20.invariantIntlContext)(this.state.intl);
        return $dAx5m.createElement((0, $ja4jS.Provider), {
            value: this.state.intl
        }, this.props.children);
    };
    IntlProvider.displayName = "IntlProvider";
    IntlProvider.defaultProps = (0, $hJU20.DEFAULT_INTL_CONFIG);
    return IntlProvider;
}($dAx5m.PureComponent);
var $4f87974ff8a57de0$export$2e2bcd8739ae039 = $4f87974ff8a57de0$var$IntlProvider;

});
parcelRegister("gUTyg", function(module, exports) {

$parcel$export(module.exports, "createIntl", function () { return $c50cf7ae9d15a9ee$export$7e4cbedfdd7b4c0d; });

var $evtaG = parcelRequire("evtaG");

var $kIkDA = parcelRequire("kIkDA");

var $5Ygy2 = parcelRequire("5Ygy2");

var $dnDzz = parcelRequire("dnDzz");

var $6SPzU = parcelRequire("6SPzU");

var $RwXb3 = parcelRequire("RwXb3");

var $i1Ugr = parcelRequire("i1Ugr");

var $1HnRf = parcelRequire("1HnRf");

var $ggt6S = parcelRequire("ggt6S");

var $fv0ur = parcelRequire("fv0ur");
function $c50cf7ae9d15a9ee$var$messagesContainString(messages) {
    var firstMessage = messages ? messages[Object.keys(messages)[0]] : undefined;
    return typeof firstMessage === "string";
}
function $c50cf7ae9d15a9ee$var$verifyConfigMessages(config) {
    if (config.onWarn && config.defaultRichTextElements && $c50cf7ae9d15a9ee$var$messagesContainString(config.messages || {})) config.onWarn('[@formatjs/intl] "defaultRichTextElements" was specified but "message" was not pre-compiled. \nPlease consider using "@formatjs/cli" to pre-compile your messages for performance.\nFor more details see https://formatjs.io/docs/getting-started/message-distribution');
}
function $c50cf7ae9d15a9ee$export$7e4cbedfdd7b4c0d(config, cache) {
    var formatters = (0, $kIkDA.createFormatters)(cache);
    var resolvedConfig = (0, $evtaG.__assign)((0, $evtaG.__assign)({}, (0, $kIkDA.DEFAULT_INTL_CONFIG)), config);
    var locale = resolvedConfig.locale, defaultLocale = resolvedConfig.defaultLocale, onError = resolvedConfig.onError;
    if (!locale) {
        if (onError) onError(new (0, $5Ygy2.InvalidConfigError)('"locale" was not configured, using "'.concat(defaultLocale, '" as fallback. See https://formatjs.io/docs/react-intl/api#intlshape for more details')));
        // Since there's no registered locale data for `locale`, this will
        // fallback to the `defaultLocale` to make sure things can render.
        // The `messages` are overridden to the `defaultProps` empty object
        // to maintain referential equality across re-renders. It's assumed
        // each <FormattedMessage> contains a `defaultMessage` prop.
        resolvedConfig.locale = resolvedConfig.defaultLocale || "en";
    } else if (!Intl.NumberFormat.supportedLocalesOf(locale).length && onError) onError(new (0, $5Ygy2.MissingDataError)('Missing locale data for locale: "'.concat(locale, '" in Intl.NumberFormat. Using default locale: "').concat(defaultLocale, '" as fallback. See https://formatjs.io/docs/react-intl#runtime-requirements for more details')));
    else if (!Intl.DateTimeFormat.supportedLocalesOf(locale).length && onError) onError(new (0, $5Ygy2.MissingDataError)('Missing locale data for locale: "'.concat(locale, '" in Intl.DateTimeFormat. Using default locale: "').concat(defaultLocale, '" as fallback. See https://formatjs.io/docs/react-intl#runtime-requirements for more details')));
    $c50cf7ae9d15a9ee$var$verifyConfigMessages(resolvedConfig);
    return (0, $evtaG.__assign)((0, $evtaG.__assign)({}, resolvedConfig), {
        formatters: formatters,
        formatNumber: (0, $dnDzz.formatNumber).bind(null, resolvedConfig, formatters.getNumberFormat),
        formatNumberToParts: (0, $dnDzz.formatNumberToParts).bind(null, resolvedConfig, formatters.getNumberFormat),
        formatRelativeTime: (0, $6SPzU.formatRelativeTime).bind(null, resolvedConfig, formatters.getRelativeTimeFormat),
        formatDate: (0, $RwXb3.formatDate).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatDateToParts: (0, $RwXb3.formatDateToParts).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatTime: (0, $RwXb3.formatTime).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatDateTimeRange: (0, $RwXb3.formatDateTimeRange).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatTimeToParts: (0, $RwXb3.formatTimeToParts).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatPlural: (0, $i1Ugr.formatPlural).bind(null, resolvedConfig, formatters.getPluralRules),
        formatMessage: (0, $1HnRf.formatMessage).bind(null, resolvedConfig, formatters),
        $t: (0, $1HnRf.formatMessage).bind(null, resolvedConfig, formatters),
        formatList: (0, $ggt6S.formatList).bind(null, resolvedConfig, formatters.getListFormat),
        formatListToParts: (0, $ggt6S.formatListToParts).bind(null, resolvedConfig, formatters.getListFormat),
        formatDisplayName: (0, $fv0ur.formatDisplayName).bind(null, resolvedConfig, formatters.getDisplayNames)
    });
}

});
parcelRegister("dnDzz", function(module, exports) {

$parcel$export(module.exports, "formatNumber", function () { return $9bdc1ea709f0116b$export$f5dd818bff069720; });
$parcel$export(module.exports, "formatNumberToParts", function () { return $9bdc1ea709f0116b$export$6871080848f10b2f; });

var $kIkDA = parcelRequire("kIkDA");

var $5Ygy2 = parcelRequire("5Ygy2");
var $9bdc1ea709f0116b$var$NUMBER_FORMAT_OPTIONS = [
    "localeMatcher",
    "style",
    "currency",
    "currencyDisplay",
    "unit",
    "unitDisplay",
    "useGrouping",
    "minimumIntegerDigits",
    "minimumFractionDigits",
    "maximumFractionDigits",
    "minimumSignificantDigits",
    "maximumSignificantDigits",
    // ES2020 NumberFormat
    "compactDisplay",
    "currencyDisplay",
    "currencySign",
    "notation",
    "signDisplay",
    "unit",
    "unitDisplay",
    "numberingSystem"
];
function $9bdc1ea709f0116b$export$a7f9565e3c81cd54(_a, getNumberFormat, options) {
    var locale = _a.locale, formats = _a.formats, onError = _a.onError;
    if (options === void 0) options = {};
    var format = options.format;
    var defaults = format && (0, $kIkDA.getNamedFormat)(formats, "number", format, onError) || {};
    var filteredOptions = (0, $kIkDA.filterProps)(options, $9bdc1ea709f0116b$var$NUMBER_FORMAT_OPTIONS, defaults);
    return getNumberFormat(locale, filteredOptions);
}
function $9bdc1ea709f0116b$export$f5dd818bff069720(config, getNumberFormat, value, options) {
    if (options === void 0) options = {};
    try {
        return $9bdc1ea709f0116b$export$a7f9565e3c81cd54(config, getNumberFormat, options).format(value);
    } catch (e) {
        config.onError(new (0, $5Ygy2.IntlError)((0, $5Ygy2.IntlErrorCode).FORMAT_ERROR, "Error formatting number.", e));
    }
    return String(value);
}
function $9bdc1ea709f0116b$export$6871080848f10b2f(config, getNumberFormat, value, options) {
    if (options === void 0) options = {};
    try {
        return $9bdc1ea709f0116b$export$a7f9565e3c81cd54(config, getNumberFormat, options).formatToParts(value);
    } catch (e) {
        config.onError(new (0, $5Ygy2.IntlError)((0, $5Ygy2.IntlErrorCode).FORMAT_ERROR, "Error formatting number.", e));
    }
    return [];
}

});

parcelRegister("6SPzU", function(module, exports) {

$parcel$export(module.exports, "formatRelativeTime", function () { return $502fcb99c08f7982$export$b4ea3b48dcf921f6; });

var $kIkDA = parcelRequire("kIkDA");

var $71hur = parcelRequire("71hur");

var $5Ygy2 = parcelRequire("5Ygy2");
var $502fcb99c08f7982$var$RELATIVE_TIME_FORMAT_OPTIONS = [
    "numeric",
    "style"
];
function $502fcb99c08f7982$var$getFormatter(_a, getRelativeTimeFormat, options) {
    var locale = _a.locale, formats = _a.formats, onError = _a.onError;
    if (options === void 0) options = {};
    var format = options.format;
    var defaults = !!format && (0, $kIkDA.getNamedFormat)(formats, "relative", format, onError) || {};
    var filteredOptions = (0, $kIkDA.filterProps)(options, $502fcb99c08f7982$var$RELATIVE_TIME_FORMAT_OPTIONS, defaults);
    return getRelativeTimeFormat(locale, filteredOptions);
}
function $502fcb99c08f7982$export$b4ea3b48dcf921f6(config, getRelativeTimeFormat, value, unit, options) {
    if (options === void 0) options = {};
    if (!unit) unit = "second";
    var RelativeTimeFormat = Intl.RelativeTimeFormat;
    if (!RelativeTimeFormat) config.onError(new (0, $71hur.FormatError)('Intl.RelativeTimeFormat is not available in this environment.\nTry polyfilling it using "@formatjs/intl-relativetimeformat"\n', (0, $71hur.ErrorCode).MISSING_INTL_API));
    try {
        return $502fcb99c08f7982$var$getFormatter(config, getRelativeTimeFormat, options).format(value, unit);
    } catch (e) {
        config.onError(new (0, $5Ygy2.IntlFormatError)("Error formatting relative time.", config.locale, e));
    }
    return String(value);
}

});

parcelRegister("RwXb3", function(module, exports) {

$parcel$export(module.exports, "formatDate", function () { return $0a0e833994d0bd20$export$3ae94a2503e890a1; });
$parcel$export(module.exports, "formatTime", function () { return $0a0e833994d0bd20$export$3203edd9e5edd663; });
$parcel$export(module.exports, "formatDateTimeRange", function () { return $0a0e833994d0bd20$export$a7fc3a91cb2ec376; });
$parcel$export(module.exports, "formatDateToParts", function () { return $0a0e833994d0bd20$export$dc1f059bce486b1; });
$parcel$export(module.exports, "formatTimeToParts", function () { return $0a0e833994d0bd20$export$af6e5d7a5c73edeb; });

var $evtaG = parcelRequire("evtaG");

var $kIkDA = parcelRequire("kIkDA");

var $5Ygy2 = parcelRequire("5Ygy2");
var $0a0e833994d0bd20$var$DATE_TIME_FORMAT_OPTIONS = [
    "localeMatcher",
    "formatMatcher",
    "timeZone",
    "hour12",
    "weekday",
    "era",
    "year",
    "month",
    "day",
    "hour",
    "minute",
    "second",
    "timeZoneName",
    "hourCycle",
    "dateStyle",
    "timeStyle",
    "calendar",
    // 'dayPeriod',
    "numberingSystem"
];
function $0a0e833994d0bd20$export$a7f9565e3c81cd54(_a, type, getDateTimeFormat, options) {
    var locale = _a.locale, formats = _a.formats, onError = _a.onError, timeZone = _a.timeZone;
    if (options === void 0) options = {};
    var format = options.format;
    var defaults = (0, $evtaG.__assign)((0, $evtaG.__assign)({}, timeZone && {
        timeZone: timeZone
    }), format && (0, $kIkDA.getNamedFormat)(formats, type, format, onError));
    var filteredOptions = (0, $kIkDA.filterProps)(options, $0a0e833994d0bd20$var$DATE_TIME_FORMAT_OPTIONS, defaults);
    if (type === "time" && !filteredOptions.hour && !filteredOptions.minute && !filteredOptions.second && !filteredOptions.timeStyle && !filteredOptions.dateStyle) // Add default formatting options if hour, minute, or second isn't defined.
    filteredOptions = (0, $evtaG.__assign)((0, $evtaG.__assign)({}, filteredOptions), {
        hour: "numeric",
        minute: "numeric"
    });
    return getDateTimeFormat(locale, filteredOptions);
}
function $0a0e833994d0bd20$export$3ae94a2503e890a1(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === "string" ? new Date(value || 0) : value;
    try {
        return $0a0e833994d0bd20$export$a7f9565e3c81cd54(config, "date", getDateTimeFormat, options).format(date);
    } catch (e) {
        config.onError(new (0, $5Ygy2.IntlError)((0, $5Ygy2.IntlErrorCode).FORMAT_ERROR, "Error formatting date.", e));
    }
    return String(date);
}
function $0a0e833994d0bd20$export$3203edd9e5edd663(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === "string" ? new Date(value || 0) : value;
    try {
        return $0a0e833994d0bd20$export$a7f9565e3c81cd54(config, "time", getDateTimeFormat, options).format(date);
    } catch (e) {
        config.onError(new (0, $5Ygy2.IntlError)((0, $5Ygy2.IntlErrorCode).FORMAT_ERROR, "Error formatting time.", e));
    }
    return String(date);
}
function $0a0e833994d0bd20$export$a7fc3a91cb2ec376(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var from = _a[0], to = _a[1], _b = _a[2], options = _b === void 0 ? {} : _b;
    var timeZone = config.timeZone, locale = config.locale, onError = config.onError;
    var filteredOptions = (0, $kIkDA.filterProps)(options, $0a0e833994d0bd20$var$DATE_TIME_FORMAT_OPTIONS, timeZone ? {
        timeZone: timeZone
    } : {});
    try {
        return getDateTimeFormat(locale, filteredOptions).formatRange(from, to);
    } catch (e) {
        onError(new (0, $5Ygy2.IntlError)((0, $5Ygy2.IntlErrorCode).FORMAT_ERROR, "Error formatting date time range.", e));
    }
    return String(from);
}
function $0a0e833994d0bd20$export$dc1f059bce486b1(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === "string" ? new Date(value || 0) : value;
    try {
        return $0a0e833994d0bd20$export$a7f9565e3c81cd54(config, "date", getDateTimeFormat, options).formatToParts(date);
    } catch (e) {
        config.onError(new (0, $5Ygy2.IntlError)((0, $5Ygy2.IntlErrorCode).FORMAT_ERROR, "Error formatting date.", e));
    }
    return [];
}
function $0a0e833994d0bd20$export$af6e5d7a5c73edeb(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === "string" ? new Date(value || 0) : value;
    try {
        return $0a0e833994d0bd20$export$a7f9565e3c81cd54(config, "time", getDateTimeFormat, options).formatToParts(date);
    } catch (e) {
        config.onError(new (0, $5Ygy2.IntlError)((0, $5Ygy2.IntlErrorCode).FORMAT_ERROR, "Error formatting time.", e));
    }
    return [];
}

});

parcelRegister("i1Ugr", function(module, exports) {

$parcel$export(module.exports, "formatPlural", function () { return $d203f6e19ec82930$export$bbbd05c900f3568d; });

var $kIkDA = parcelRequire("kIkDA");

var $5Ygy2 = parcelRequire("5Ygy2");

var $71hur = parcelRequire("71hur");
var $d203f6e19ec82930$var$PLURAL_FORMAT_OPTIONS = [
    "localeMatcher",
    "type"
];
function $d203f6e19ec82930$export$bbbd05c900f3568d(_a, getPluralRules, value, options) {
    var locale = _a.locale, onError = _a.onError;
    if (options === void 0) options = {};
    if (!Intl.PluralRules) onError(new (0, $71hur.FormatError)('Intl.PluralRules is not available in this environment.\nTry polyfilling it using "@formatjs/intl-pluralrules"\n', (0, $71hur.ErrorCode).MISSING_INTL_API));
    var filteredOptions = (0, $kIkDA.filterProps)(options, $d203f6e19ec82930$var$PLURAL_FORMAT_OPTIONS);
    try {
        return getPluralRules(locale, filteredOptions).select(value);
    } catch (e) {
        onError(new (0, $5Ygy2.IntlFormatError)("Error formatting plural.", locale, e));
    }
    return "other";
}

});

parcelRegister("1HnRf", function(module, exports) {

$parcel$export(module.exports, "formatMessage", function () { return $13cc5041fe3e5239$export$25868d1e8e76735f; });

var $evtaG = parcelRequire("evtaG");

var $gDrm5 = parcelRequire("gDrm5");

var $hvf2d = parcelRequire("hvf2d");

var $5Ygy2 = parcelRequire("5Ygy2");
parcelRequire("fcnnD");
var $bOKth = parcelRequire("bOKth");
function $13cc5041fe3e5239$var$setTimeZoneInOptions(opts, timeZone) {
    return Object.keys(opts).reduce(function(all, k) {
        all[k] = (0, $evtaG.__assign)({
            timeZone: timeZone
        }, opts[k]);
        return all;
    }, {});
}
function $13cc5041fe3e5239$var$deepMergeOptions(opts1, opts2) {
    var keys = Object.keys((0, $evtaG.__assign)((0, $evtaG.__assign)({}, opts1), opts2));
    return keys.reduce(function(all, k) {
        all[k] = (0, $evtaG.__assign)((0, $evtaG.__assign)({}, opts1[k] || {}), opts2[k] || {});
        return all;
    }, {});
}
function $13cc5041fe3e5239$var$deepMergeFormatsAndSetTimeZone(f1, timeZone) {
    if (!timeZone) return f1;
    var mfFormats = (0, $hvf2d.IntlMessageFormat).formats;
    return (0, $evtaG.__assign)((0, $evtaG.__assign)((0, $evtaG.__assign)({}, mfFormats), f1), {
        date: $13cc5041fe3e5239$var$deepMergeOptions($13cc5041fe3e5239$var$setTimeZoneInOptions(mfFormats.date, timeZone), $13cc5041fe3e5239$var$setTimeZoneInOptions(f1.date || {}, timeZone)),
        time: $13cc5041fe3e5239$var$deepMergeOptions($13cc5041fe3e5239$var$setTimeZoneInOptions(mfFormats.time, timeZone), $13cc5041fe3e5239$var$setTimeZoneInOptions(f1.time || {}, timeZone))
    });
}
function $13cc5041fe3e5239$export$25868d1e8e76735f(_a, state, messageDescriptor, values, opts) {
    var locale = _a.locale, formats = _a.formats, messages = _a.messages, defaultLocale = _a.defaultLocale, defaultFormats = _a.defaultFormats, fallbackOnEmptyString = _a.fallbackOnEmptyString, onError = _a.onError, timeZone = _a.timeZone, defaultRichTextElements = _a.defaultRichTextElements;
    if (messageDescriptor === void 0) messageDescriptor = {
        id: ""
    };
    var msgId = messageDescriptor.id, defaultMessage = messageDescriptor.defaultMessage;
    // `id` is a required field of a Message Descriptor.
    (0, $gDrm5.invariant)(!!msgId, "[@formatjs/intl] An `id` must be provided to format a message. You can either:\n1. Configure your build toolchain with [babel-plugin-formatjs](https://formatjs.io/docs/tooling/babel-plugin)\nor [@formatjs/ts-transformer](https://formatjs.io/docs/tooling/ts-transformer) OR\n2. Configure your `eslint` config to include [eslint-plugin-formatjs](https://formatjs.io/docs/tooling/linter#enforce-id)\nto autofix this issue");
    var id = String(msgId);
    var message = // In case messages is Object.create(null)
    // e.g import('foo.json') from webpack)
    // See https://github.com/formatjs/formatjs/issues/1914
    messages && Object.prototype.hasOwnProperty.call(messages, id) && messages[id];
    // IMPORTANT: Hot path if `message` is AST with a single literal node
    if (Array.isArray(message) && message.length === 1 && message[0].type === (0, $bOKth.TYPE).literal) return message[0].value;
    // IMPORTANT: Hot path straight lookup for performance
    if (!values && message && typeof message === "string" && !defaultRichTextElements) return message.replace(/'\{(.*?)\}'/gi, "{$1}");
    values = (0, $evtaG.__assign)((0, $evtaG.__assign)({}, defaultRichTextElements), values || {});
    formats = $13cc5041fe3e5239$var$deepMergeFormatsAndSetTimeZone(formats, timeZone);
    defaultFormats = $13cc5041fe3e5239$var$deepMergeFormatsAndSetTimeZone(defaultFormats, timeZone);
    if (!message) {
        if (fallbackOnEmptyString === false && message === "") return message;
        if (!defaultMessage || locale && locale.toLowerCase() !== defaultLocale.toLowerCase()) // This prevents warnings from littering the console in development
        // when no `messages` are passed into the <IntlProvider> for the
        // default locale.
        onError(new (0, $5Ygy2.MissingTranslationError)(messageDescriptor, locale));
        if (defaultMessage) try {
            var formatter = state.getMessageFormat(defaultMessage, defaultLocale, defaultFormats, opts);
            return formatter.format(values);
        } catch (e) {
            onError(new (0, $5Ygy2.MessageFormatError)('Error formatting default message for: "'.concat(id, '", rendering default message verbatim'), locale, messageDescriptor, e));
            return typeof defaultMessage === "string" ? defaultMessage : id;
        }
        return id;
    }
    // We have the translated message
    try {
        var formatter = state.getMessageFormat(message, locale, formats, (0, $evtaG.__assign)({
            formatters: state
        }, opts || {}));
        return formatter.format(values);
    } catch (e) {
        onError(new (0, $5Ygy2.MessageFormatError)('Error formatting message: "'.concat(id, '", using ').concat(defaultMessage ? "default message" : "id", " as fallback."), locale, messageDescriptor, e));
    }
    if (defaultMessage) try {
        var formatter = state.getMessageFormat(defaultMessage, defaultLocale, defaultFormats, opts);
        return formatter.format(values);
    } catch (e) {
        onError(new (0, $5Ygy2.MessageFormatError)('Error formatting the default message for: "'.concat(id, '", rendering message verbatim'), locale, messageDescriptor, e));
    }
    if (typeof message === "string") return message;
    if (typeof defaultMessage === "string") return defaultMessage;
    return id;
}

});

parcelRegister("ggt6S", function(module, exports) {

$parcel$export(module.exports, "formatList", function () { return $bd74b890a6117748$export$e8b8be48b45905bb; });
$parcel$export(module.exports, "formatListToParts", function () { return $bd74b890a6117748$export$6f284aad1934db69; });

var $evtaG = parcelRequire("evtaG");

var $kIkDA = parcelRequire("kIkDA");

var $71hur = parcelRequire("71hur");

var $5Ygy2 = parcelRequire("5Ygy2");
var $bd74b890a6117748$var$LIST_FORMAT_OPTIONS = [
    "localeMatcher",
    "type",
    "style"
];
var $bd74b890a6117748$var$now = Date.now();
function $bd74b890a6117748$var$generateToken(i) {
    return "".concat($bd74b890a6117748$var$now, "_").concat(i, "_").concat($bd74b890a6117748$var$now);
}
function $bd74b890a6117748$export$e8b8be48b45905bb(opts, getListFormat, values, options) {
    if (options === void 0) options = {};
    var results = $bd74b890a6117748$export$6f284aad1934db69(opts, getListFormat, values, options).reduce(function(all, el) {
        var val = el.value;
        if (typeof val !== "string") all.push(val);
        else if (typeof all[all.length - 1] === "string") all[all.length - 1] += val;
        else all.push(val);
        return all;
    }, []);
    return results.length === 1 ? results[0] : results;
}
function $bd74b890a6117748$export$6f284aad1934db69(_a, getListFormat, values, options) {
    var locale = _a.locale, onError = _a.onError;
    if (options === void 0) options = {};
    var ListFormat = Intl.ListFormat;
    if (!ListFormat) onError(new (0, $71hur.FormatError)('Intl.ListFormat is not available in this environment.\nTry polyfilling it using "@formatjs/intl-listformat"\n', (0, $71hur.ErrorCode).MISSING_INTL_API));
    var filteredOptions = (0, $kIkDA.filterProps)(options, $bd74b890a6117748$var$LIST_FORMAT_OPTIONS);
    try {
        var richValues_1 = {};
        var serializedValues = values.map(function(v, i) {
            if (typeof v === "object") {
                var id = $bd74b890a6117748$var$generateToken(i);
                richValues_1[id] = v;
                return id;
            }
            return String(v);
        });
        return getListFormat(locale, filteredOptions).formatToParts(serializedValues).map(function(part) {
            return part.type === "literal" ? part : (0, $evtaG.__assign)((0, $evtaG.__assign)({}, part), {
                value: richValues_1[part.value] || part.value
            });
        });
    } catch (e) {
        onError(new (0, $5Ygy2.IntlError)((0, $5Ygy2.IntlErrorCode).FORMAT_ERROR, "Error formatting list.", e));
    }
    // @ts-ignore
    return values;
}

});

parcelRegister("fv0ur", function(module, exports) {

$parcel$export(module.exports, "formatDisplayName", function () { return $b48a2194b089b8cf$export$62fe1a4d9e891fa2; });

var $kIkDA = parcelRequire("kIkDA");

var $71hur = parcelRequire("71hur");

var $5Ygy2 = parcelRequire("5Ygy2");
var $b48a2194b089b8cf$var$DISPLAY_NAMES_OPTONS = [
    "localeMatcher",
    "style",
    "type",
    "fallback"
];
function $b48a2194b089b8cf$export$62fe1a4d9e891fa2(_a, getDisplayNames, value, options) {
    var locale = _a.locale, onError = _a.onError;
    var DisplayNames = Intl.DisplayNames;
    if (!DisplayNames) onError(new (0, $71hur.FormatError)('Intl.DisplayNames is not available in this environment.\nTry polyfilling it using "@formatjs/intl-displaynames"\n', (0, $71hur.ErrorCode).MISSING_INTL_API));
    var filteredOptions = (0, $kIkDA.filterProps)(options, $b48a2194b089b8cf$var$DISPLAY_NAMES_OPTONS);
    try {
        return getDisplayNames(locale, filteredOptions).of(value);
    } catch (e) {
        onError(new (0, $5Ygy2.IntlError)((0, $5Ygy2.IntlErrorCode).FORMAT_ERROR, "Error formatting display name.", e));
    }
}

});



parcelRegister("iNFKX", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_LOCALE", function () { return $8985ca3cbfc3b6f2$export$1af4c7e47ad72f44; });
$parcel$export(module.exports, "getEffectiveLocale", function () { return $8985ca3cbfc3b6f2$export$5211f28df9ef284a; });
$parcel$export(module.exports, "loadIntlData", function () { return $8985ca3cbfc3b6f2$export$d225990554fb28f7; });

var $6qH56 = parcelRequire("6qH56");

var $3N6J0 = parcelRequire("3N6J0");

var $fCHnn = parcelRequire("fCHnn");

var $2Lhwc = parcelRequire("2Lhwc");
const $8985ca3cbfc3b6f2$export$1af4c7e47ad72f44 = "en";
// Generated list of supported locales based on locales config
const $8985ca3cbfc3b6f2$var$SUPPORTED_LOCALES = (0, $2Lhwc.intlLocales);
// In URL, a tester can pass lang code or locale into URL, e.g `?locale=fr` or `?locale=cs-CZ`
const $8985ca3cbfc3b6f2$var$getLocaleFromUrl = ()=>{
    const locales = (0, (/*@__PURE__*/$parcel$interopDefault($3N6J0))).parse((0, (/*@__PURE__*/$parcel$interopDefault($6qH56))).location.search).locale;
    return Array.isArray(locales) ? locales[0] : locales;
};
function $8985ca3cbfc3b6f2$var$getSupportedLocale(locale) {
    if (typeof locale !== "string") return null;
    locale = locale.replace("_", "-");
    if ($8985ca3cbfc3b6f2$var$SUPPORTED_LOCALES.includes(locale)) return locale;
    // If we don't have the exact locale available, attempt to match just the language
    const languageCode = locale.substring(0, 2);
    if ($8985ca3cbfc3b6f2$var$SUPPORTED_LOCALES.includes(languageCode)) return languageCode;
}
const $8985ca3cbfc3b6f2$export$5211f28df9ef284a = async (predefinedLocale)=>{
    // locale that we can manually pass to intl provider
    const receivedLocale = $8985ca3cbfc3b6f2$var$getSupportedLocale(predefinedLocale);
    if (receivedLocale) return receivedLocale;
    // locale that we can pass to intl provider via `locale` GET param
    const localeInUrl = $8985ca3cbfc3b6f2$var$getSupportedLocale($8985ca3cbfc3b6f2$var$getLocaleFromUrl());
    if (localeInUrl) return localeInUrl;
    let userLocale = $8985ca3cbfc3b6f2$export$1af4c7e47ad72f44;
    try {
        userLocale = (await (0, $fCHnn.userInfoProvider).get()).locale;
    } catch (e) {
        userLocale = $8985ca3cbfc3b6f2$export$1af4c7e47ad72f44;
    }
    return $8985ca3cbfc3b6f2$var$getSupportedLocale(userLocale) || $8985ca3cbfc3b6f2$export$1af4c7e47ad72f44;
};
const $8985ca3cbfc3b6f2$export$d225990554fb28f7 = (localesConfig, locale)=>{
    return new Promise((resolve, reject)=>{
        const pickedConfig = localesConfig.find((config)=>config.locales.includes(locale));
        if (!pickedConfig || !pickedConfig.loader) {
            resolve(null);
            return;
        }
        // Fails if we haven't loaded/resolved after 30 seconds
        const rejectTimer = setTimeout(reject, 30000);
        pickedConfig.loader().then((res)=>{
            clearTimeout(rejectTimer);
            if (!res) {
                resolve(null);
                return;
            }
            // depending on a builder and config used in a project the result of dynamic imports could be behind `default`
            // this way we'll cover both cases:
            const response = res;
            resolve(response && "default" in response ? response.default : response);
        }).catch(reject);
    });
};

});
parcelRegister("fCHnn", function(module, exports) {

$parcel$export(module.exports, "userInfoProvider", function () { return $12c99dfe7d78d5db$export$30a852ca4cb27370; });

var $1Bj4T = parcelRequire("1Bj4T");
// Needs to be declared here to avoid blowing up this earlyInit bundle
class $12c99dfe7d78d5db$var$FetchError extends Error {
    constructor(response){
        super(`Request failed with status ${response.status}`);
        this.response = response;
        this.name = this.constructor.name;
    }
}
class $12c99dfe7d78d5db$export$dc10e400a1189789 {
    get(fetchOp = fetch) {
        if (this.promise) return this.promise;
        const getJson = (url)=>fetchOp(url, {
                method: "GET",
                mode: "cors",
                credentials: "include",
                headers: {
                    "Content-Type": "application/json"
                }
            }).then((response)=>{
                if (!response.ok) throw new $12c99dfe7d78d5db$var$FetchError(response);
                return response.json();
            });
        this.promise = getJson(`${(0, $1Bj4T.getConfig)().stargateRoot}/me`).then((me)=>{
            return getJson(`${(0, $1Bj4T.getConfig)().stargateRoot}/users/${me.account_id}/manage/profile`).then((profile)=>({
                    userId: profile.account.account_id,
                    fullName: profile.account.name,
                    email: profile.account.email,
                    isEmailVerified: profile.account.email_verified,
                    locale: profile.account.locale,
                    picture: profile.account.picture
                }));
        });
        return this.promise;
    }
}
const $12c99dfe7d78d5db$export$30a852ca4cb27370 = new $12c99dfe7d78d5db$export$dc10e400a1189789();

});

parcelRegister("2Lhwc", function(module, exports) {

$parcel$export(module.exports, "intlLocales", function () { return $36c70383cdff8a34$export$a6451ecfee2e1449; });
// TODO: PTC-2088 - simplify list of locales
const $36c70383cdff8a34$export$a6451ecfee2e1449 = [
    "cs",
    "cs-CZ",
    "da",
    "da-DK",
    "de",
    "de-DE",
    "es",
    "es-ES",
    "en-GB",
    "en-ZZ",
    "et",
    "et-EE",
    "fi",
    "fi-FI",
    "fr",
    "fr-FR",
    "hu",
    "hu-HU",
    "is",
    "is-IS",
    "it",
    "it-IT",
    "ja",
    "ja-JP",
    "ko",
    "ko-KR",
    "nl",
    "nl-NL",
    "nb",
    "nb-NO",
    "pl",
    "pl-PL",
    "pt",
    "pt-PT",
    "pt-BR",
    "ro",
    "ro-RO",
    "ru",
    "ru-RU",
    "sk",
    "sk-SK",
    "sv",
    "sv-SE",
    "zh",
    "zh-CN",
    "zh-Hans",
    "zh-TW",
    "zh-HK",
    "zh-Hant",
    "tr",
    "tr-TR",
    "th",
    "th-TH",
    "uk",
    "uk-UA",
    "vi",
    "vi-VN"
];

});




parcelRegister("hIpVk", function(module, exports) {

var $agSD9 = parcelRequire("agSD9");

});
parcelRegister("agSD9", function(module, exports) {

var $ku6eE = parcelRequire("ku6eE");
const $f2cc18f60ba8d97b$export$d4b7158914d60efa = (0, $ku6eE.default).div`
  && * {
    box-sizing: ${({ value: value })=>value};
  }
`;

});


parcelRegister("7rBBG", function(module, exports) {
/**
 * If the promise throws then a default value will be returned as well as a false marker.
 *
 * @param promise The promise to be wrapped.
 * @param defaultValue The value to be returned if an error is thrown.
 */ function $2ddc0bd0c41a9610$export$a970b469503acdc8(promise, defaultValue) {
    return promise.then((value)=>({
            value: value,
            success: true
        })).catch(()=>({
            value: defaultValue,
            success: false
        }));
}

});

parcelRegister("aTv5x", function(module, exports) {

var $77YRX = parcelRequire("77YRX");
const $b20c5635f4f6ebfd$var$PREFIX = "ptc-dir-ui.";
var // A facade for browser localstorage.
$b20c5635f4f6ebfd$export$2e2bcd8739ae039 = {
    setItem (key, value) {
        try {
            localStorage.setItem($b20c5635f4f6ebfd$var$PREFIX + key, value);
            return true;
        } catch (error) {
            // maybe we can use cookie as alternative storage
            (0, $77YRX.logException)(error, "Cannot write into localstorage");
        }
        return false;
    },
    // tslint:disable-next-line:no-any
    getItem (key) {
        try {
            return localStorage.getItem($b20c5635f4f6ebfd$var$PREFIX + key);
        } catch (error) {
            (0, $77YRX.logException)(error, "Cannot read into localstorage");
        }
        return null;
    }
};

});

parcelRegister("edxno", function(module, exports) {

$parcel$export(module.exports, "ellipsis", function () { return $912e3e8fab15efd9$export$a5b94313d6908893; });
$parcel$export(module.exports, "ellipsisInFlexChild", function () { return $912e3e8fab15efd9$export$58ca30256a534b20; });

var $jVTBW = parcelRequire("jVTBW");
const $912e3e8fab15efd9$export$a5b94313d6908893 = `
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
`;
const $912e3e8fab15efd9$export$58ca30256a534b20 = (0, $jVTBW.css)`
  min-width: 0;
  ${$912e3e8fab15efd9$export$a5b94313d6908893};
`;

});

parcelRegister("iyr2L", function(module, exports) {

$parcel$export(module.exports, "requestLoginCheckOrRedirect", function () { return $877c1def864bd3da$export$daa09d242b53608c; });

var $6qH56 = parcelRequire("6qH56");

var $1Bj4T = parcelRequire("1Bj4T");

var $hlc9t = parcelRequire("hlc9t");
const $877c1def864bd3da$var$redirect = (url)=>(0, (/*@__PURE__*/$parcel$interopDefault($6qH56))).location.assign(url);
const $877c1def864bd3da$var$HALTING_REDIRECT_THRESHOLD = 10;
function $877c1def864bd3da$var$redirectCentralLogin() {
    $877c1def864bd3da$var$redirect(`${(0, $1Bj4T.getConfig)().atlassianAccountUrl}/login?continue=${encodeURIComponent((0, (/*@__PURE__*/$parcel$interopDefault($6qH56))).location.href)}`);
}
const $877c1def864bd3da$var$redirectLimiter = {
    reset: ()=>{
        (0, $hlc9t.clearCookie)((0, $hlc9t.REDIRECT_COUNT));
    },
    try: (f)=>{
        const attemptCount = (0, $hlc9t.getCookieAsInteger)((0, $hlc9t.REDIRECT_COUNT));
        if (attemptCount < $877c1def864bd3da$var$HALTING_REDIRECT_THRESHOLD) {
            (0, $hlc9t.setCookie)((0, $hlc9t.REDIRECT_COUNT), attemptCount + 1);
            f();
        }
    }
};
function $877c1def864bd3da$var$createRequestLoginCheckOrRedirect(onUnauthorised) {
    return (request)=>request.then((result)=>{
            $877c1def864bd3da$var$redirectLimiter.reset();
            return result;
        }).catch((err)=>{
            if (err.response && err.response.status === 401) return {
                redirectToLogin: ()=>{
                    $877c1def864bd3da$var$redirectLimiter.try(onUnauthorised);
                }
            };
            throw err;
        });
}
const $877c1def864bd3da$export$daa09d242b53608c = $877c1def864bd3da$var$createRequestLoginCheckOrRedirect($877c1def864bd3da$var$redirectCentralLogin);

});
parcelRegister("hlc9t", function(module, exports) {

$parcel$export(module.exports, "REDIRECT_COUNT", function () { return $f34a7a0ade2e5dfd$export$f6101897f0230549; });
$parcel$export(module.exports, "IDENTITY_CSRF_TOKEN", function () { return $f34a7a0ade2e5dfd$export$5a7d8afb87170e45; });
$parcel$export(module.exports, "setCookie", function () { return $f34a7a0ade2e5dfd$export$110700823644f4a6; });
$parcel$export(module.exports, "getCookieAsInteger", function () { return $f34a7a0ade2e5dfd$export$6a289e5003f59269; });
$parcel$export(module.exports, "clearCookie", function () { return $f34a7a0ade2e5dfd$export$ad3506281d5a5e5d; });
const $f34a7a0ade2e5dfd$export$f6101897f0230549 = "redirectCount";
const $f34a7a0ade2e5dfd$export$5a7d8afb87170e45 = "avatar.csrf.token";
function $f34a7a0ade2e5dfd$export$110700823644f4a6(key, value) {
    document.cookie = `${key}=${value};path=/;max-age=30`;
}
function $f34a7a0ade2e5dfd$export$6a289e5003f59269(key, defaultValue = 0) {
    const regex = new RegExp(`${key}=(\\d+)`);
    const result = document.cookie.match(regex);
    return result ? parseInt(result[1], 10) : defaultValue;
}
function $f34a7a0ade2e5dfd$export$ad3506281d5a5e5d(key) {
    document.cookie = `${key}=doesntmatter;path=/;expires=Thu, 01 Jan 1970 00:00:01 GMT`;
}

});


parcelRegister("9S009", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8aadec4093a2939f$export$2e2bcd8739ae039; });

var $20U8t = parcelRequire("20U8t");

var $5lc1q = parcelRequire("5lc1q");

var $1Bj4T = parcelRequire("1Bj4T");
class $8aadec4093a2939f$var$IdentityAvailableProductsClient extends (0, $20U8t.default) {
    constructor(){
        super({
            serviceUrl: (0, $1Bj4T.getConfig)().stargateRoot
        });
        this.getAvailableProducts = async ()=>{
            const availableProducts = this.postResource("/accessible-products", {
                productIds: [
                    (0, $5lc1q.LongProductKey).CONFLUENCE,
                    (0, $5lc1q.LongProductKey).JIRA_CORE,
                    (0, $5lc1q.LongProductKey).JIRA_SOFTWARE,
                    (0, $5lc1q.LongProductKey).JIRA_SERVICE_DESK,
                    (0, $5lc1q.LongProductKey).TRELLO,
                    (0, $5lc1q.LongProductKey).BITBUCKET
                ],
                permissionIds: [
                    "write",
                    "write-portal",
                    "external-collaborator-write"
                ]
            });
            return availableProducts;
        };
        this.getAvailableSites = async ()=>{
            const otherSitesCheck = this.postResource("/available-sites", {
                products: [
                    (0, $5lc1q.LongProductKey).CONFLUENCE,
                    (0, $5lc1q.LongProductKey).JIRA_CORE,
                    (0, $5lc1q.LongProductKey).JIRA_SERVICE_DESK,
                    (0, $5lc1q.LongProductKey).JIRA_SOFTWARE
                ]
            });
            const bitbucketCheck = this.postResource("/permissions/permitted", {
                resourceId: "ari:cloud:bitbucket::site/bitbucket",
                permissionId: "write"
            });
            const trelloCheck = this.postResource("/permissions/permitted", {
                resourceId: "ari:cloud:trello::site/trello",
                permissionId: "write"
            });
            const [bitbucketResponse, trelloResponse, otherSitesResponse] = await Promise.all([
                bitbucketCheck,
                trelloCheck,
                otherSitesCheck
            ]);
            const bitbucketValue = {
                cloudId: null,
                url: "bitbucket.org"
            };
            const trelloValue = {
                cloudId: null,
                url: "trello.com"
            };
            return {
                sites: otherSitesResponse.sites.concat(bitbucketResponse.permitted === true && bitbucketValue).concat(trelloResponse.permitted === true && trelloValue).filter((x)=>x !== false).filter((x)=>x !== true)
            };
        };
    }
}
var $8aadec4093a2939f$export$2e2bcd8739ae039 = new $8aadec4093a2939f$var$IdentityAvailableProductsClient();

});
parcelRegister("20U8t", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0df1f1ce9509c829$export$2e2bcd8739ae039; });

var $58QKT = parcelRequire("58QKT");

var $883Vm = parcelRequire("883Vm");

var $5ehI7 = parcelRequire("5ehI7");

var $hlc9t = parcelRequire("hlc9t");

var $5eCIB = parcelRequire("5eCIB");

var $cdiBL = parcelRequire("cdiBL");
const $0df1f1ce9509c829$var$defaultFetchOptions = {
    credentials: "include",
    headers: {
        Accept: "application/json"
    },
    mode: "cors"
};
const $0df1f1ce9509c829$var$fetchWithExponentialBackoff = (0, $5eCIB.withDefaultExponentialBackoff)(fetch);
// tslint:disable-next-line no-any
function $0df1f1ce9509c829$var$parseResponse(response) {
    const responseStatusCode = response.status;
    if (responseStatusCode === 204 || responseStatusCode === 202) return null;
    const contentType = response.headers.get("content-type");
    if (!contentType || contentType.includes("text/html") || contentType.includes("text/plain")) return response.text();
    if (contentType.includes("application/json")) return response.json();
    return null;
}
// to dedupe sentry, scrub non-unique 'timestamp' field from the error body
function $0df1f1ce9509c829$var$scrubTimestampFromErrorBody(text) {
    let json;
    try {
        json = JSON.parse(text);
    } catch (err) {
        return text;
    }
    delete json.timestamp;
    return JSON.stringify(json);
}
let $0df1f1ce9509c829$var$incrementRedirectCount;
let $0df1f1ce9509c829$var$clearRedirectCount;
$0df1f1ce9509c829$export$7a0fc52d8c359feb();
function $0df1f1ce9509c829$export$7a0fc52d8c359feb() {
    $0df1f1ce9509c829$var$incrementRedirectCount = (0, (/*@__PURE__*/$parcel$interopDefault($58QKT)))(()=>(0, $hlc9t.setCookie)((0, $hlc9t.REDIRECT_COUNT), (0, $hlc9t.getCookieAsInteger)((0, $hlc9t.REDIRECT_COUNT)) + 1));
    $0df1f1ce9509c829$var$clearRedirectCount = (0, (/*@__PURE__*/$parcel$interopDefault($58QKT)))(()=>(0, $hlc9t.clearCookie)((0, $hlc9t.REDIRECT_COUNT)));
}
class $0df1f1ce9509c829$var$RestClient {
    constructor({ serviceUrl: serviceUrl = "" } = {}){
        /**
   * This function is necessary for if `statusCodeHandler` prescribes a login
   * redirect upon a 401 response.
   * While the default redirect behaviour may be overriden, this function has
   * been kept separate to ensure it cannot be overriden, lest a host
   * application supply embeddable-directory with a custom handler that suffers
   * the infinite redirect bug.
   */ this.preventInfiniteRedirectLoop = (response)=>{
            if (!response.ok) {
                const responseStatusCode = response.status;
                if (responseStatusCode === 401) $0df1f1ce9509c829$var$incrementRedirectCount();
            } else $0df1f1ce9509c829$var$clearRedirectCount();
        };
        this.serviceUrl = serviceUrl;
    }
    async getResource(path) {
        return this.makeRequest(path);
    }
    async postResource(path, data, fetchOptions = {}) {
        return this.postResourceRaw(path, JSON.stringify(data), fetchOptions);
    }
    async postResourceRaw(path, data, fetchOptions = {}) {
        fetchOptions = {
            method: "post",
            headers: {},
            ...fetchOptions
        };
        if (data) fetchOptions = {
            body: data,
            ...fetchOptions,
            headers: {
                "Content-Type": "application/json",
                ...fetchOptions.headers
            }
        };
        return this.makeRequest(path, fetchOptions);
    }
    async patchResource(path, data) {
        let fetchOptions = {
            /**
       * PATCH must be uppercase as per fetch spec only
       * DELETE, GET, HEAD, OPTIONS, POST, and PUT methods
       * are normalised to uppercase.
       *
       * https://github.com/github/fetch/issues/37
       * https://fetch.spec.whatwg.org/#methods
       */ method: "PATCH"
        };
        if (data) fetchOptions = {
            ...fetchOptions,
            body: JSON.stringify(data),
            headers: {
                "Content-Type": "application/json"
            }
        };
        return this.makeRequest(path, fetchOptions);
    }
    async putResource(path, data, additionalFetchOptions = {}) {
        let fetchOptions = {
            method: "put"
        };
        if (data) fetchOptions = (0, (/*@__PURE__*/$parcel$interopDefault($883Vm)))({}, fetchOptions, {
            body: JSON.stringify(data),
            headers: {
                "Content-Type": "application/json"
            }
        });
        return this.makeRequest(path, {
            ...fetchOptions,
            ...additionalFetchOptions
        });
    }
    async deleteResource(path, options = {}) {
        const fetchOptions = {
            ...options,
            method: "delete"
        };
        return this.makeRequest(path, fetchOptions);
    }
    async makeRequest(path, additionalFetchOptions = {}) {
        const url = this.serviceUrl + path;
        const options = (0, (/*@__PURE__*/$parcel$interopDefault($5ehI7)))({}, $0df1f1ce9509c829$var$defaultFetchOptions, additionalFetchOptions);
        const response = await $0df1f1ce9509c829$var$fetchWithExponentialBackoff(url, options);
        this.preventInfiniteRedirectLoop(response);
        const responseStatusCode = response.status;
        if (!response.ok) {
            if (responseStatusCode === 401) throw new (0, $cdiBL.SentryIgnoreError)({
                message: "Unauthorized Request - incrementing redirect count"
            });
            else {
                const text = $0df1f1ce9509c829$var$scrubTimestampFromErrorBody(await response.text());
                throw new (0, $cdiBL.HttpError)({
                    message: text,
                    status: responseStatusCode
                });
            }
        }
        return additionalFetchOptions.ignoreResponse ? null : $0df1f1ce9509c829$var$parseResponse(response);
    }
}
var $0df1f1ce9509c829$export$2e2bcd8739ae039 = $0df1f1ce9509c829$var$RestClient;

});
parcelRegister("58QKT", function(module, exports) {

var $kaUWf = parcelRequire("kaUWf");
/**
 * Creates a function that is restricted to invoking `func` once. Repeat calls
 * to the function return the value of the first invocation. The `func` is
 * invoked with the `this` binding and arguments of the created function.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new restricted function.
 * @example
 *
 * var initialize = _.once(createApplication);
 * initialize();
 * initialize();
 * // => `createApplication` is invoked once
 */ function $3be69f3a53c35aa9$var$once(func) {
    return $kaUWf(2, func);
}
module.exports = $3be69f3a53c35aa9$var$once;

});
parcelRegister("kaUWf", function(module, exports) {

var $1r38A = parcelRequire("1r38A");
/** Error message constants. */ var $eb00e898c85c8e8f$var$FUNC_ERROR_TEXT = "Expected a function";
/**
 * Creates a function that invokes `func`, with the `this` binding and arguments
 * of the created function, while it's called less than `n` times. Subsequent
 * calls to the created function return the result of the last `func` invocation.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Function
 * @param {number} n The number of calls at which `func` is no longer invoked.
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new restricted function.
 * @example
 *
 * jQuery(element).on('click', _.before(5, addContactToList));
 * // => Allows adding up to 4 contacts to the list.
 */ function $eb00e898c85c8e8f$var$before(n, func) {
    var result;
    if (typeof func != "function") throw new TypeError($eb00e898c85c8e8f$var$FUNC_ERROR_TEXT);
    n = $1r38A(n);
    return function() {
        if (--n > 0) result = func.apply(this, arguments);
        if (n <= 1) func = undefined;
        return result;
    };
}
module.exports = $eb00e898c85c8e8f$var$before;

});
parcelRegister("1r38A", function(module, exports) {

var $4fOZ8 = parcelRequire("4fOZ8");
/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */ function $10babf1557990e70$var$toInteger(value) {
    var result = $4fOZ8(value), remainder = result % 1;
    return result === result ? remainder ? result - remainder : result : 0;
}
module.exports = $10babf1557990e70$var$toInteger;

});
parcelRegister("4fOZ8", function(module, exports) {

var $fIIJN = parcelRequire("fIIJN");
/** Used as references for various `Number` constants. */ var $31901cb8a6804e9b$var$INFINITY = 1 / 0, $31901cb8a6804e9b$var$MAX_INTEGER = 1.7976931348623157e+308;
/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */ function $31901cb8a6804e9b$var$toFinite(value) {
    if (!value) return value === 0 ? value : 0;
    value = $fIIJN(value);
    if (value === $31901cb8a6804e9b$var$INFINITY || value === -$31901cb8a6804e9b$var$INFINITY) {
        var sign = value < 0 ? -1 : 1;
        return sign * $31901cb8a6804e9b$var$MAX_INTEGER;
    }
    return value === value ? value : 0;
}
module.exports = $31901cb8a6804e9b$var$toFinite;

});
parcelRegister("fIIJN", function(module, exports) {

var $1n4lz = parcelRequire("1n4lz");

var $2fw24 = parcelRequire("2fw24");

var $aKvy8 = parcelRequire("aKvy8");
/** Used as references for various `Number` constants. */ var $b71dab043ee3305d$var$NAN = 0 / 0;
/** Used to detect bad signed hexadecimal string values. */ var $b71dab043ee3305d$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var $b71dab043ee3305d$var$reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var $b71dab043ee3305d$var$reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var $b71dab043ee3305d$var$freeParseInt = parseInt;
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function $b71dab043ee3305d$var$toNumber(value) {
    if (typeof value == "number") return value;
    if ($aKvy8(value)) return $b71dab043ee3305d$var$NAN;
    if ($2fw24(value)) {
        var other = typeof value.valueOf == "function" ? value.valueOf() : value;
        value = $2fw24(other) ? other + "" : other;
    }
    if (typeof value != "string") return value === 0 ? value : +value;
    value = $1n4lz(value);
    var isBinary = $b71dab043ee3305d$var$reIsBinary.test(value);
    return isBinary || $b71dab043ee3305d$var$reIsOctal.test(value) ? $b71dab043ee3305d$var$freeParseInt(value.slice(2), isBinary ? 2 : 8) : $b71dab043ee3305d$var$reIsBadHex.test(value) ? $b71dab043ee3305d$var$NAN : +value;
}
module.exports = $b71dab043ee3305d$var$toNumber;

});
parcelRegister("1n4lz", function(module, exports) {

var $eCCJ6 = parcelRequire("eCCJ6");
/** Used to match leading whitespace. */ var $0ffb4fa873b7b9bb$var$reTrimStart = /^\s+/;
/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */ function $0ffb4fa873b7b9bb$var$baseTrim(string) {
    return string ? string.slice(0, $eCCJ6(string) + 1).replace($0ffb4fa873b7b9bb$var$reTrimStart, "") : string;
}
module.exports = $0ffb4fa873b7b9bb$var$baseTrim;

});
parcelRegister("eCCJ6", function(module, exports) {
/** Used to match a single whitespace character. */ var $aa52a79081417f71$var$reWhitespace = /\s/;
/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */ function $aa52a79081417f71$var$trimmedEndIndex(string) {
    var index = string.length;
    while(index-- && $aa52a79081417f71$var$reWhitespace.test(string.charAt(index)));
    return index;
}
module.exports = $aa52a79081417f71$var$trimmedEndIndex;

});







parcelRegister("883Vm", function(module, exports) {

var $1E0vf = parcelRequire("1E0vf");

var $27PUz = parcelRequire("27PUz");

var $kI6GP = parcelRequire("kI6GP");

var $a8M8t = parcelRequire("a8M8t");

var $jdcNi = parcelRequire("jdcNi");

var $4upTl = parcelRequire("4upTl");
/** Used for built-in method references. */ var $5eb21d57a9baaa1e$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $5eb21d57a9baaa1e$var$hasOwnProperty = $5eb21d57a9baaa1e$var$objectProto.hasOwnProperty;
/**
 * Assigns own enumerable string keyed properties of source objects to the
 * destination object. Source objects are applied from left to right.
 * Subsequent sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object` and is loosely based on
 * [`Object.assign`](https://mdn.io/Object/assign).
 *
 * @static
 * @memberOf _
 * @since 0.10.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @see _.assignIn
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * function Bar() {
 *   this.c = 3;
 * }
 *
 * Foo.prototype.b = 2;
 * Bar.prototype.d = 4;
 *
 * _.assign({ 'a': 0 }, new Foo, new Bar);
 * // => { 'a': 1, 'c': 3 }
 */ var $5eb21d57a9baaa1e$var$assign = $kI6GP(function(object, source) {
    if ($jdcNi(source) || $a8M8t(source)) {
        $27PUz(source, $4upTl(source), object);
        return;
    }
    for(var key in source)if ($5eb21d57a9baaa1e$var$hasOwnProperty.call(source, key)) $1E0vf(object, key, source[key]);
});
module.exports = $5eb21d57a9baaa1e$var$assign;

});
parcelRegister("4upTl", function(module, exports) {

var $3mbzH = parcelRequire("3mbzH");

var $fUguj = parcelRequire("fUguj");

var $a8M8t = parcelRequire("a8M8t");
/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function $344e0c53559229ac$var$keys(object) {
    return $a8M8t(object) ? $3mbzH(object) : $fUguj(object);
}
module.exports = $344e0c53559229ac$var$keys;

});
parcelRegister("fUguj", function(module, exports) {

var $jdcNi = parcelRequire("jdcNi");

var $ldkOg = parcelRequire("ldkOg");
/** Used for built-in method references. */ var $b948e026a4141ee8$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $b948e026a4141ee8$var$hasOwnProperty = $b948e026a4141ee8$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $b948e026a4141ee8$var$baseKeys(object) {
    if (!$jdcNi(object)) return $ldkOg(object);
    var result = [];
    for(var key in Object(object))if ($b948e026a4141ee8$var$hasOwnProperty.call(object, key) && key != "constructor") result.push(key);
    return result;
}
module.exports = $b948e026a4141ee8$var$baseKeys;

});
parcelRegister("ldkOg", function(module, exports) {

var $2Yv8v = parcelRequire("2Yv8v");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $f71af441705800e2$var$nativeKeys = $2Yv8v(Object.keys, Object);
module.exports = $f71af441705800e2$var$nativeKeys;

});




parcelRegister("5eCIB", function(module, exports) {

$parcel$export(module.exports, "EXPONENTIAL_BACKOFF_RETRY_POLICY", function () { return $3521bd09b742b06e$export$8f4286bf21155381; });
$parcel$export(module.exports, "is5xx", function () { return $3521bd09b742b06e$export$55b2fbd5d4a32495; });
$parcel$export(module.exports, "withExponentialBackoff", function () { return $3521bd09b742b06e$export$20eaa22f2295996f; });
$parcel$export(module.exports, "withDefaultExponentialBackoff", function () { return $3521bd09b742b06e$export$455df4c93665fa4a; });
const $3521bd09b742b06e$export$8f4286bf21155381 = {
    INITIAL_DELAY: 200,
    MAX_RETRIES: 5,
    JITTER: true
};
function $3521bd09b742b06e$export$55b2fbd5d4a32495(status) {
    return 500 <= status && status <= 599;
}
// tslint:disable-next-line no-any
const $3521bd09b742b06e$var$defaultRetryIfCallback = (a)=>!a;
const $3521bd09b742b06e$var$defaultOptions = {
    initial: 200,
    jitter: false,
    max: 5,
    retryIf: $3521bd09b742b06e$var$defaultRetryIfCallback
};
function $3521bd09b742b06e$export$20eaa22f2295996f(toTry, hofOptions = $3521bd09b742b06e$var$defaultOptions) {
    const { initial: initial, jitter: jitter, max: max, retryIf: retryIf } = hofOptions;
    // Initialize max retry decrementing counter (range of max...0)
    let attemptsRemaining = max;
    // Initialize delay. This will exponentially increase each retry (delay = intial * 2^n)
    let delay = initial;
    /**
   * This function calls itself recursively until `retryIf` evaluates false or the retry limit is reached.
   * The functioned-to-be-retried is called on each recursion.
   */ return async function tryWithExponentialBackoff(...args) {
        // "An attempt was made"
        const result = await toTry(...args);
        --attemptsRemaining;
        // If tried function was unsuccessful and there are still retries remaining, retry!
        if (retryIf && retryIf(result) && attemptsRemaining > 0) {
            // Wait for delay
            await new Promise((resolve)=>setTimeout(resolve, jitter ? Math.random() * delay : delay));
            // Exponentially increase delay
            delay *= 2;
            // Initiate retry
            return tryWithExponentialBackoff(...args);
        }
        // Return result of tried function if it is successful or if the retry limit
        // was reached regardless of success.
        return result;
    };
}
function $3521bd09b742b06e$export$455df4c93665fa4a(fetchOp) {
    return $3521bd09b742b06e$export$20eaa22f2295996f(fetchOp, {
        initial: $3521bd09b742b06e$export$8f4286bf21155381.INITIAL_DELAY,
        jitter: $3521bd09b742b06e$export$8f4286bf21155381.JITTER,
        max: $3521bd09b742b06e$export$8f4286bf21155381.MAX_RETRIES,
        retryIf: (response)=>$3521bd09b742b06e$export$55b2fbd5d4a32495(response.status)
    });
}

});

parcelRegister("cdiBL", function(module, exports) {

$parcel$export(module.exports, "DefaultError", function () { return $a18a9d99bbd2f9ab$export$c73ca302efeda3b4; });
$parcel$export(module.exports, "SentryIgnoreError", function () { return $a18a9d99bbd2f9ab$export$20de9a0e470e95aa; });
$parcel$export(module.exports, "HttpError", function () { return $a18a9d99bbd2f9ab$export$65bd6083489bd8bb; });
$parcel$export(module.exports, "GraphQLError", function () { return $a18a9d99bbd2f9ab$export$92d6ed0888e7cb7f; });
// Extending new custom Error types with `Object.setPrototypeOf`
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/setPrototypeOf
class $a18a9d99bbd2f9ab$var$CommonError extends Error {
    constructor(message){
        super(message);
        this.name = this.constructor.name;
        this.message = message;
        this.stack = new Error(message).stack || "";
    }
}
class $a18a9d99bbd2f9ab$export$c73ca302efeda3b4 extends $a18a9d99bbd2f9ab$var$CommonError {
    constructor({ message: message }){
        super(message || "UnknownError");
        Object.setPrototypeOf(this, $a18a9d99bbd2f9ab$export$c73ca302efeda3b4.prototype);
    }
}
class $a18a9d99bbd2f9ab$export$20de9a0e470e95aa extends $a18a9d99bbd2f9ab$var$CommonError {
    constructor({ message: message }){
        super(`SentryIgnore: ${message || "UnknownError"}`);
        Object.setPrototypeOf(this, $a18a9d99bbd2f9ab$export$20de9a0e470e95aa.prototype);
    }
}
class $a18a9d99bbd2f9ab$export$65bd6083489bd8bb extends $a18a9d99bbd2f9ab$var$CommonError {
    constructor({ message: message, status: status }){
        super(message);
        Object.setPrototypeOf(this, $a18a9d99bbd2f9ab$export$65bd6083489bd8bb.prototype);
        this.status = status;
    }
}
class $a18a9d99bbd2f9ab$export$92d6ed0888e7cb7f extends $a18a9d99bbd2f9ab$var$CommonError {
    constructor({ message: message, category: category = "default", fields: fields }){
        super(message);
        Object.setPrototypeOf(this, $a18a9d99bbd2f9ab$export$92d6ed0888e7cb7f.prototype);
        this.category = category;
        if (fields) this.fields = fields;
    }
    static #_ = this.from = (rawErrors)=>{
        const firstError = rawErrors[0];
        const errorData = {
            category: firstError.category,
            message: firstError.message
        };
        if (firstError.fields) errorData.fields = firstError.fields.reduce((obj, item)=>{
            obj[item.field] = item.message;
            return obj;
        }, {});
        return new $a18a9d99bbd2f9ab$export$92d6ed0888e7cb7f(errorData);
    };
}

});



parcelRegister("9FKx7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $feac223972bc37f4$export$2e2bcd8739ae039; });

var $20U8t = parcelRequire("20U8t");

var $1Bj4T = parcelRequire("1Bj4T");
class $feac223972bc37f4$var$IdentityUserClient extends (0, $20U8t.default) {
    constructor(){
        super({
            serviceUrl: `${(0, $1Bj4T.getConfig)().stargateRoot}/users`
        });
        this.deleteUser = (userId)=>{
            const resourcePath = `/${userId}`;
            return this.deleteResource(resourcePath);
        };
        this.checkCloseAccount = (userId)=>{
            return this.getResource(`/${userId}/can-close`);
        };
    }
}
var $feac223972bc37f4$export$2e2bcd8739ae039 = new $feac223972bc37f4$var$IdentityUserClient();

});

parcelRegister("h1RRU", function(module, exports) {

$parcel$export(module.exports, "ExternalUserManagers", function () { return $772cdb8e1a8e04fc$export$26493a6ff02c634a; });
$parcel$export(module.exports, "getCurrentUser", function () { return $772cdb8e1a8e04fc$export$e5432d4c8eb97ea7; });
$parcel$export(module.exports, "setTsvDisabled", function () { return $772cdb8e1a8e04fc$export$99dc0d755961a9c; });
$parcel$export(module.exports, "default", function () { return $772cdb8e1a8e04fc$export$2e2bcd8739ae039; });

var $kBVUb = parcelRequire("kBVUb");

var $fCHnn = parcelRequire("fCHnn");

var $4rjyH = parcelRequire("4rjyH");
var $772cdb8e1a8e04fc$export$26493a6ff02c634a;
(function(ExternalUserManagers) {
    ExternalUserManagers["GOOGLE"] = "google";
    ExternalUserManagers["SAML"] = "saml";
})($772cdb8e1a8e04fc$export$26493a6ff02c634a || ($772cdb8e1a8e04fc$export$26493a6ff02c634a = {}));
const $772cdb8e1a8e04fc$export$c5ea488fb9c82a2d = "GET_USER";
const $772cdb8e1a8e04fc$export$cce12ae071c13cba = "USER_CORE_READY";
const $772cdb8e1a8e04fc$export$b3f4c7c082b77f2e = "GET_IS_SITE_ADMIN";
const $772cdb8e1a8e04fc$export$95c2579ec81c5a3 = "SET_TSV_DISABLED";
function $772cdb8e1a8e04fc$export$e5432d4c8eb97ea7() {
    return async (dispatch)=>{
        const { userId: accountId, isEmailVerified: isEmailVerified, fullName: fullName, email: email, picture: picture } = await (0, $fCHnn.userInfoProvider).get();
        // dispatch this action so that we can have current user-id in Redux store as soon as possible
        // it will increase render performance of other components which needs current user-id
        dispatch({
            type: $772cdb8e1a8e04fc$export$cce12ae071c13cba,
            payload: {
                accountId: accountId,
                isEmailVerified: isEmailVerified,
                fullName: fullName,
                email: email,
                picture: picture
            }
        });
        const userInfoPromise = (0, $kBVUb.default).getUserInfo();
        dispatch({
            type: $772cdb8e1a8e04fc$export$c5ea488fb9c82a2d,
            payload: userInfoPromise
        });
    };
}
function $772cdb8e1a8e04fc$export$c6a793bed474dc53() {
    return async (dispatch)=>{
        dispatch({
            type: $772cdb8e1a8e04fc$export$b3f4c7c082b77f2e,
            payload: Promise.resolve(false)
        });
    };
}
function $772cdb8e1a8e04fc$export$99dc0d755961a9c() {
    return {
        type: $772cdb8e1a8e04fc$export$95c2579ec81c5a3
    };
}
const $772cdb8e1a8e04fc$export$d4c72bab9d6cc13a = {
    data: {
        isSiteAdmin: false,
        isSiteAdminLoading: null,
        accountId: null,
        fullName: null,
        email: null,
        isEmailVerified: null,
        pendingEmail: null,
        isManaged: null,
        managedBy: null,
        managedById: undefined,
        manageStartedTimestamp: undefined,
        managedByOrgName: undefined,
        tsvEnabled: null,
        picture: null,
        mfaEnforcedByAuthPolicy: null
    },
    isLoading: null,
    isError: false
};
const $772cdb8e1a8e04fc$var$getSafeIsManagedState = (data)=>data.userManagedStatus && data.userManagedStatus.managed || false;
const $772cdb8e1a8e04fc$var$getSafeManagedOwner = (data)=>{
    const ownerType = data.authProvider || data.userManagedStatus?.owner?.ownerType;
    return ownerType ? ownerType.toLowerCase() : null;
};
const $772cdb8e1a8e04fc$var$getSafeManagedOwnerId = (data)=>data.userManagedStatus?.owner?.ownerId;
const $772cdb8e1a8e04fc$var$getSafeManagedOwnerName = (data)=>data.userManagedStatus?.owner?.ownerName;
const $772cdb8e1a8e04fc$var$getSafeManageStartedTimestamp = (data)=>data.userManagedStatus?.owner?.timestamp;
const $772cdb8e1a8e04fc$var$isTsvEnabled = (data)=>{
    return data.useMfa || false;
};
const $772cdb8e1a8e04fc$var$isMfaEnforcedByAuthPolicy = (data)=>{
    return data.mfaEnforcedByAuthPolicy || false;
};
// Map REST payload to domain model
const $772cdb8e1a8e04fc$var$dataFromPayload = (payload)=>{
    // don't need `accountId` prop because `accountId` is already set by USER_CORE_READY action
    return {
        email: payload.email,
        fullName: payload.fullName,
        pendingEmail: payload.pendingEmail,
        isManaged: $772cdb8e1a8e04fc$var$getSafeIsManagedState(payload),
        managedBy: $772cdb8e1a8e04fc$var$getSafeManagedOwner(payload),
        managedById: $772cdb8e1a8e04fc$var$getSafeManagedOwnerId(payload),
        managedByOrgName: $772cdb8e1a8e04fc$var$getSafeManagedOwnerName(payload),
        manageStartedTimestamp: $772cdb8e1a8e04fc$var$getSafeManageStartedTimestamp(payload),
        tsvEnabled: $772cdb8e1a8e04fc$var$isTsvEnabled(payload),
        mfaEnforcedByAuthPolicy: $772cdb8e1a8e04fc$var$isMfaEnforcedByAuthPolicy(payload)
    };
};
function $772cdb8e1a8e04fc$export$2e2bcd8739ae039(state = $772cdb8e1a8e04fc$export$d4c72bab9d6cc13a, action) {
    switch(action.type){
        case `${$772cdb8e1a8e04fc$export$c5ea488fb9c82a2d}_PENDING`:
            return {
                ...state,
                isLoading: true
            };
        case `${$772cdb8e1a8e04fc$export$c5ea488fb9c82a2d}_FULFILLED`:
            return {
                ...state,
                data: {
                    ...state.data,
                    ...$772cdb8e1a8e04fc$var$dataFromPayload(action.payload)
                },
                isLoading: false,
                isError: false
            };
        case `${$772cdb8e1a8e04fc$export$c5ea488fb9c82a2d}_REJECTED`:
            return {
                ...state,
                isLoading: false,
                isError: true
            };
        case `${$772cdb8e1a8e04fc$export$b3f4c7c082b77f2e}_PENDING`:
            return {
                ...state,
                data: {
                    ...state.data,
                    isSiteAdminLoading: true
                }
            };
        case `${$772cdb8e1a8e04fc$export$b3f4c7c082b77f2e}_FULFILLED`:
            return {
                ...state,
                data: {
                    ...state.data,
                    isSiteAdmin: action.payload,
                    isSiteAdminLoading: false
                }
            };
        case `${$772cdb8e1a8e04fc$export$b3f4c7c082b77f2e}_REJECTED`:
            return {
                ...state,
                data: {
                    ...state.data,
                    isSiteAdminLoading: false
                }
            };
        case `${0, $4rjyH.UPDATE_USER_EMAIL}_FULFILLED`:
            return {
                ...state,
                data: {
                    ...state.data,
                    pendingEmail: action.payload.newEmail
                }
            };
        case `${0, $4rjyH.REVERT_USER_EMAIL}_FULFILLED`:
            return {
                ...state,
                data: {
                    ...state.data,
                    pendingEmail: null
                }
            };
        case `${$772cdb8e1a8e04fc$export$cce12ae071c13cba}`:
            return {
                ...state,
                isLoading: true,
                data: {
                    ...state.data,
                    ...action.payload
                }
            };
        case $772cdb8e1a8e04fc$export$95c2579ec81c5a3:
            return {
                ...state,
                data: {
                    ...state.data,
                    tsvEnabled: false
                }
            };
        default:
            return state;
    }
}

});
parcelRegister("kBVUb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2a60654ebf3bfeaf$export$2e2bcd8739ae039; });

var $20U8t = parcelRequire("20U8t");

var $1Bj4T = parcelRequire("1Bj4T");

var $hlc9t = parcelRequire("hlc9t");
const $2a60654ebf3bfeaf$export$ec82fc8dae20530e = "X-CSRF-TOKEN";
const $2a60654ebf3bfeaf$var$commonHeaders = {
    "Content-Type": "application/x-www-form-urlencoded; charset=utf-8",
    // we don't want server returning a non-english error message to front-end.
    "Accept-Language": "en-US,en;q=0.5"
};
const $2a60654ebf3bfeaf$var$createRandomString = (n = 20)=>{
    const charset = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    let result = "";
    for(let i = 0; i < n; i++)result += charset.charAt(Math.floor(Math.random() * charset.length));
    return result;
};
const $2a60654ebf3bfeaf$var$formUrlEncode = (data)=>Object.keys(data).reduce((a, b)=>{
        return `${b}=${encodeURIComponent(data[b])}&${a}`;
    }, "").slice(0, -1);
class $2a60654ebf3bfeaf$var$IdentityClient extends (0, $20U8t.default) {
    getUserInfo() {
        return this.getResource("/user");
    }
    changePassword(currentPassword, newPassword) {
        const token = $2a60654ebf3bfeaf$var$createRandomString();
        (0, $hlc9t.setCookie)((0, $hlc9t.IDENTITY_CSRF_TOKEN), token);
        const query = $2a60654ebf3bfeaf$var$formUrlEncode({
            currentPassword: currentPassword,
            newPassword: newPassword,
            confirmPassword: newPassword
        });
        const options = {
            headers: {
                ...$2a60654ebf3bfeaf$var$commonHeaders,
                [$2a60654ebf3bfeaf$export$ec82fc8dae20530e]: token,
                "X-REQUESTED-WITH": "XMLHttpRequest"
            }
        };
        return this.postResourceRaw("/password", query, options);
    }
    changeEmail(newEmail) {
        const token = $2a60654ebf3bfeaf$var$createRandomString();
        (0, $hlc9t.setCookie)((0, $hlc9t.IDENTITY_CSRF_TOKEN), token);
        const query = $2a60654ebf3bfeaf$var$formUrlEncode({
            newEmail: newEmail,
            csrfToken: token
        });
        return this.postResourceRaw("/change-email", query, {
            headers: $2a60654ebf3bfeaf$var$commonHeaders
        });
    }
    revertEmail() {
        const token = $2a60654ebf3bfeaf$var$createRandomString();
        (0, $hlc9t.setCookie)((0, $hlc9t.IDENTITY_CSRF_TOKEN), token);
        const query = $2a60654ebf3bfeaf$var$formUrlEncode({
            csrfToken: token
        });
        const fetchOptions = {
            body: query,
            ignoreResponse: true,
            headers: $2a60654ebf3bfeaf$var$commonHeaders
        };
        return this.deleteResource("/change-email", fetchOptions);
    }
}
var $2a60654ebf3bfeaf$export$2e2bcd8739ae039 = new $2a60654ebf3bfeaf$var$IdentityClient({
    serviceUrl: (0, $1Bj4T.getConfig)().identityProxyUrl
});

});

parcelRegister("4rjyH", function(module, exports) {

$parcel$export(module.exports, "UPDATE_USER_EMAIL", function () { return $e9fdf3ff1c11596b$export$2368c83195630e17; });
$parcel$export(module.exports, "REVERT_USER_EMAIL", function () { return $e9fdf3ff1c11596b$export$aed180ea3b2dbf60; });
$parcel$export(module.exports, "updateUserEmail", function () { return $e9fdf3ff1c11596b$export$794c747ace225d95; });
$parcel$export(module.exports, "revertUserEmail", function () { return $e9fdf3ff1c11596b$export$addd095ce2aaf7d; });
$parcel$export(module.exports, "default", function () { return $e9fdf3ff1c11596b$export$2e2bcd8739ae039; });

var $2YSZG = parcelRequire("2YSZG");

var $kBVUb = parcelRequire("kBVUb");

var $77YRX = parcelRequire("77YRX");
const $e9fdf3ff1c11596b$export$91c32f1b22d29b2d = (errorFromEndpoint)=>{
    try {
        const err = errorFromEndpoint ? errorFromEndpoint.message || errorFromEndpoint : undefined;
        const { formErrors: formErrors, fieldErrors: fieldErrors, error: error } = JSON.parse(err);
        if (formErrors?.[0]) return formErrors[0];
        else if (typeof error === "string") return error;
        if (fieldErrors?.newEmail?.[0]) return fieldErrors.newEmail[0];
    } catch (caughtError) {
        (0, $77YRX.logInfoMessage)("Failed to parse error message for updateUserEmail", {
            error: errorFromEndpoint,
            caughtError: caughtError
        });
    }
    return (0, $2YSZG.ChangeEmailErrorKeys).DEFAULT;
};
const $e9fdf3ff1c11596b$export$2368c83195630e17 = "UPDATE_USER_EMAIL";
const $e9fdf3ff1c11596b$export$aed180ea3b2dbf60 = "REVERT_USER_EMAIL";
const $e9fdf3ff1c11596b$export$794c747ace225d95 = (email)=>async (dispatch)=>{
        const updatePromise = (0, $kBVUb.default).changeEmail(email);
        dispatch({
            type: $e9fdf3ff1c11596b$export$2368c83195630e17,
            payload: updatePromise
        }).catch(()=>null);
        return updatePromise.catch((error)=>{
            throw $e9fdf3ff1c11596b$export$91c32f1b22d29b2d(error);
        });
    };
const $e9fdf3ff1c11596b$export$addd095ce2aaf7d = ()=>async (dispatch)=>{
        const revertPromise = (0, $kBVUb.default).revertEmail();
        dispatch({
            type: $e9fdf3ff1c11596b$export$aed180ea3b2dbf60,
            payload: revertPromise
        }).catch(()=>null);
        return revertPromise.catch((error)=>{
            throw $e9fdf3ff1c11596b$export$91c32f1b22d29b2d(error);
        });
    };
// ------------------------------------
// Reducer
// ------------------------------------
const $e9fdf3ff1c11596b$var$initialState = {
    isSaving: false
};
const $e9fdf3ff1c11596b$var$profileEmailReducer = (state = $e9fdf3ff1c11596b$var$initialState, action)=>{
    switch(action.type){
        case `${$e9fdf3ff1c11596b$export$2368c83195630e17}_PENDING`:
            return {
                ...state,
                isSaving: true
            };
        case `${$e9fdf3ff1c11596b$export$2368c83195630e17}_REJECTED`:
            return {
                ...state,
                isSaving: false
            };
        case `${$e9fdf3ff1c11596b$export$2368c83195630e17}_FULFILLED`:
            return {
                ...state,
                isSaving: false
            };
        case `${$e9fdf3ff1c11596b$export$aed180ea3b2dbf60}_PENDING`:
            return {
                ...state,
                isSaving: true
            };
        case `${$e9fdf3ff1c11596b$export$aed180ea3b2dbf60}_REJECTED`:
            return {
                ...state,
                isSaving: false
            };
        case `${$e9fdf3ff1c11596b$export$aed180ea3b2dbf60}_FULFILLED`:
            return {
                ...state,
                isSaving: false
            };
        default:
            return state;
    }
};
var $e9fdf3ff1c11596b$export$2e2bcd8739ae039 = $e9fdf3ff1c11596b$var$profileEmailReducer;

});
parcelRegister("2YSZG", function(module, exports) {

$parcel$export(module.exports, "ChangeEmailErrorKeys", function () { return $631f3fbeb73e54e7$export$cdfc7a9432036426; });
$parcel$export(module.exports, "default", function () { return $631f3fbeb73e54e7$export$2e2bcd8739ae039; });

var $lKhJJ = parcelRequire("lKhJJ");
var $631f3fbeb73e54e7$export$cdfc7a9432036426;
(function(ChangeEmailErrorKeys) {
    ChangeEmailErrorKeys["TOO_MANY_EMAIL_CHANGES"] = "com.atlassian.id.profile.too.many.email.changes";
    ChangeEmailErrorKeys["INVALID_EMAIL"] = "change-email.form.new.email.error.invalid";
    ChangeEmailErrorKeys["DEFAULT"] = "change-email.failure";
    ChangeEmailErrorKeys["NO_EMAIL"] = "change-email.form.new.email.error.no.email";
    ChangeEmailErrorKeys["NO_CHANGE"] = "change-email.form.new.email.error.no.change";
    ChangeEmailErrorKeys["RESTRICTED_DOMAIN"] = "change-email.form.new.email.error.restricted.domain";
    ChangeEmailErrorKeys["CURRENT_DOMAIN_RESTRICTED"] = "change-email.form.current.email.error.restricted.domain";
})($631f3fbeb73e54e7$export$cdfc7a9432036426 || ($631f3fbeb73e54e7$export$cdfc7a9432036426 = {}));
var $631f3fbeb73e54e7$export$2e2bcd8739ae039 = (0, $lKhJJ.defineMessages)({
    [`flagTitle_${"com.atlassian.id.profile.too.many.email.changes"}`]: {
        id: "pf-home.profile-settings.email.flag.error.update.limit.title",
        defaultMessage: "Daily limit reached",
        description: "The error title in the flag component when an daily limit error occured when the user tried to update their email address."
    },
    [`flagMessage_${"com.atlassian.id.profile.too.many.email.changes"}`]: {
        id: "pf-home.profile-settings.email.flag.error.update.limit.message",
        defaultMessage: "We limit email changes to help keep your account safe. You can try again in 24 hours.",
        description: "The error message in the flag component when an daily limit error occured when the user tried to update their email address."
    },
    [`flagTitle_${"change-email.form.new.email.error.invalid"}`]: {
        id: "pf-home.profile-settings.email.flag.error.update.invalid.title",
        defaultMessage: "Email invalid",
        description: "The error title in the flag component when the user tried to update their email address to an invalid email address."
    },
    [`flagMessage_${"change-email.form.new.email.error.invalid"}`]: {
        id: "pf-home.profile-settings.email.flag.error.update.invalid.message",
        defaultMessage: "The email you used is not a valid email address. Please try again.",
        description: "The error message in the flag component when the user tried to update their email address to an invalid email address."
    },
    [`flagTitle_${"change-email.failure"}`]: {
        id: "pf-home.profile-settings.email.flag.error.update.default.title",
        defaultMessage: "Oops, something went wrong",
        description: "The error title in the flag component when an error occured while the user tried to update their email address."
    },
    [`flagMessage_${"change-email.failure"}`]: {
        id: "pf-home.profile-settings.email.flag.error.update.default.message",
        defaultMessage: "We couldn\u2019t save your email change. Please try again.",
        description: "The error message in the flag component when an error occured while the user tried to update their email address."
    },
    [`flagTitle_${"change-email.form.new.email.error.no.email"}`]: {
        id: "pf-home.profile-settings.email.flag.error.no.email.title",
        defaultMessage: "Email address required",
        description: "The error title in the flag component when the user tried to update their email address to an empty email address."
    },
    [`flagMessage_${"change-email.form.new.email.error.no.email"}`]: {
        id: "pf-home.profile-settings.email.flag.error.no.email.message",
        defaultMessage: "Please enter your email address",
        description: "The error title in the flag component when the user tried to update their email address to an empty email address."
    },
    [`flagTitle_${"change-email.form.new.email.error.no.change"}`]: {
        id: "pf-home.profile-settings.email.flag.error.no.change.title",
        defaultMessage: "New email address required",
        description: "The error title in the flag component when the user tried to update their email address to the same email address."
    },
    [`flagMessage_${"change-email.form.new.email.error.no.change"}`]: {
        id: "pf-home.profile-settings.email.flag.error.no.change.message",
        defaultMessage: "Please enter an email address that is different to your current email address",
        description: "The error title in the flag component when the user tried to update their email address to the same email address."
    },
    [`flagTitle_${"change-email.form.new.email.error.restricted.domain"}`]: {
        id: "pf-home.profile-settings.email.flag.error.restricted.domain.title",
        defaultMessage: "Email invalid",
        description: "The error title in the flag component when the user tried to update their email address to an email address that is not allowed."
    },
    [`flagMessage_${"change-email.form.new.email.error.restricted.domain"}`]: {
        id: "pf-home.profile-settings.email.flag.error.restricted.domain.message",
        defaultMessage: "The provided email address is not allowed, please use a different one",
        description: "The error title in the flag component when the user tried to update their email address to an email address that is not allowed."
    },
    [`flagTitle_${"change-email.form.current.email.error.restricted.domain"}`]: {
        id: "pf-home.profile-settings.email.flag.error.current.domain.restricted.title",
        defaultMessage: "Not allowed",
        description: "The error title in the flag component when the user tried to update their email address but they are not allowed."
    },
    [`flagMessage_${"change-email.form.current.email.error.restricted.domain"}`]: {
        id: "pf-home.profile-settings.email.flag.error.current.domain.restricted.message",
        defaultMessage: "Changing from your current email address is not allowed.",
        description: "The error title in the flag component when the user tried to update their email address, but they are not allowed."
    }
});

});
parcelRegister("lKhJJ", function(module, exports) {

$parcel$export(module.exports, "defineMessages", function () { return $fd4ba6fd01b34ec0$export$1adfeb024f5185b; });
$parcel$export(module.exports, "defineMessage", function () { return $fd4ba6fd01b34ec0$export$747d244ee58120dd; });
$parcel$export(module.exports, "FormattedDate", function () { return $fd4ba6fd01b34ec0$export$40ae3194919d16b; });
$parcel$export(module.exports, "FormattedTime", function () { return $fd4ba6fd01b34ec0$export$5b390a54f8a846f7; });
$parcel$export(module.exports, "FormattedNumber", function () { return $fd4ba6fd01b34ec0$export$db80edc1e6b2f63d; });
$parcel$export(module.exports, "FormattedList", function () { return $fd4ba6fd01b34ec0$export$f52b44e459e6e71d; });
$parcel$export(module.exports, "FormattedDisplayName", function () { return $fd4ba6fd01b34ec0$export$c2336ea5aaab92fa; });
$parcel$export(module.exports, "FormattedDateParts", function () { return $fd4ba6fd01b34ec0$export$7fdc7d2c91ce149b; });
$parcel$export(module.exports, "FormattedTimeParts", function () { return $fd4ba6fd01b34ec0$export$ec35873761676c2a; });
$parcel$export(module.exports, "FormattedDateTimeRange", function () { return (parcelRequire("44eEQ")).default; });
$parcel$export(module.exports, "FormattedMessage", function () { return (parcelRequire("55TWT")).default; });
$parcel$export(module.exports, "FormattedPlural", function () { return (parcelRequire("dlzfr")).default; });
$parcel$export(module.exports, "FormattedRelativeTime", function () { return (parcelRequire("aUu17")).default; });
$parcel$export(module.exports, "IntlContext", function () { return (parcelRequire("ja4jS")).Context; });
$parcel$export(module.exports, "IntlProvider", function () { return (parcelRequire("6PkJI")).default; });
$parcel$export(module.exports, "RawIntlProvider", function () { return (parcelRequire("ja4jS")).Provider; });
$parcel$export(module.exports, "createIntl", function () { return (parcelRequire("6PkJI")).createIntl; });
$parcel$export(module.exports, "injectIntl", function () { return (parcelRequire("ja4jS")).default; });
$parcel$export(module.exports, "useIntl", function () { return (parcelRequire("dZHnD")).default; });
$parcel$export(module.exports, "createIntlCache", function () { return (parcelRequire("kIkDA")).createIntlCache; });
$parcel$export(module.exports, "UnsupportedFormatterError", function () { return (parcelRequire("5Ygy2")).UnsupportedFormatterError; });
$parcel$export(module.exports, "InvalidConfigError", function () { return (parcelRequire("5Ygy2")).InvalidConfigError; });
$parcel$export(module.exports, "MissingDataError", function () { return (parcelRequire("5Ygy2")).MissingDataError; });
$parcel$export(module.exports, "MessageFormatError", function () { return (parcelRequire("5Ygy2")).MessageFormatError; });
$parcel$export(module.exports, "MissingTranslationError", function () { return (parcelRequire("5Ygy2")).MissingTranslationError; });
$parcel$export(module.exports, "ReactIntlErrorCode", function () { return (parcelRequire("5Ygy2")).IntlErrorCode; });
$parcel$export(module.exports, "ReactIntlError", function () { return (parcelRequire("5Ygy2")).IntlError; });
$parcel$export(module.exports, "FormattedNumberParts", function () { return (parcelRequire("fm7Zf")).FormattedNumberParts; });
$parcel$export(module.exports, "FormattedListParts", function () { return (parcelRequire("fm7Zf")).FormattedListParts; });

var $fm7Zf = parcelRequire("fm7Zf");

var $ja4jS = parcelRequire("ja4jS");

var $dZHnD = parcelRequire("dZHnD");

var $6PkJI = parcelRequire("6PkJI");

var $aUu17 = parcelRequire("aUu17");

var $dlzfr = parcelRequire("dlzfr");

var $55TWT = parcelRequire("55TWT");

var $44eEQ = parcelRequire("44eEQ");

var $kIkDA = parcelRequire("kIkDA");
var $5Ygy2 = parcelRequire("5Ygy2");
function $fd4ba6fd01b34ec0$export$1adfeb024f5185b(msgs) {
    return msgs;
}
function $fd4ba6fd01b34ec0$export$747d244ee58120dd(msg) {
    return msg;
}
var $fd4ba6fd01b34ec0$export$40ae3194919d16b = (0, $fm7Zf.createFormattedComponent)("formatDate");
var $fd4ba6fd01b34ec0$export$5b390a54f8a846f7 = (0, $fm7Zf.createFormattedComponent)("formatTime");
var $fd4ba6fd01b34ec0$export$db80edc1e6b2f63d = (0, $fm7Zf.createFormattedComponent)("formatNumber");
var $fd4ba6fd01b34ec0$export$f52b44e459e6e71d = (0, $fm7Zf.createFormattedComponent)("formatList");
var $fd4ba6fd01b34ec0$export$c2336ea5aaab92fa = (0, $fm7Zf.createFormattedComponent)("formatDisplayName");
var $fd4ba6fd01b34ec0$export$7fdc7d2c91ce149b = (0, $fm7Zf.createFormattedDateTimePartsComponent)("formatDate");
var $fd4ba6fd01b34ec0$export$ec35873761676c2a = (0, $fm7Zf.createFormattedDateTimePartsComponent)("formatTime");

});
parcelRegister("fm7Zf", function(module, exports) {

$parcel$export(module.exports, "FormattedNumberParts", function () { return $b2df1b1ab8113166$export$54d4989ed3eea1ea; });
$parcel$export(module.exports, "FormattedListParts", function () { return $b2df1b1ab8113166$export$5ac259c7da6d2188; });
$parcel$export(module.exports, "createFormattedDateTimePartsComponent", function () { return $b2df1b1ab8113166$export$7448277f6036d2ab; });
$parcel$export(module.exports, "createFormattedComponent", function () { return $b2df1b1ab8113166$export$b37e14176d001dec; });

var $evtaG = parcelRequire("evtaG");

var $dAx5m = parcelRequire("dAx5m");

var $dZHnD = parcelRequire("dZHnD");
var $b2df1b1ab8113166$var$DisplayName;
(function(DisplayName) {
    DisplayName["formatDate"] = "FormattedDate";
    DisplayName["formatTime"] = "FormattedTime";
    DisplayName["formatNumber"] = "FormattedNumber";
    DisplayName["formatList"] = "FormattedList";
    // Note that this DisplayName is the locale display name, not to be confused with
    // the name of the enum, which is for React component display name in dev tools.
    DisplayName["formatDisplayName"] = "FormattedDisplayName";
})($b2df1b1ab8113166$var$DisplayName || ($b2df1b1ab8113166$var$DisplayName = {}));
var $b2df1b1ab8113166$var$DisplayNameParts;
(function(DisplayNameParts) {
    DisplayNameParts["formatDate"] = "FormattedDateParts";
    DisplayNameParts["formatTime"] = "FormattedTimeParts";
    DisplayNameParts["formatNumber"] = "FormattedNumberParts";
    DisplayNameParts["formatList"] = "FormattedListParts";
})($b2df1b1ab8113166$var$DisplayNameParts || ($b2df1b1ab8113166$var$DisplayNameParts = {}));
var $b2df1b1ab8113166$export$54d4989ed3eea1ea = function(props) {
    var intl = (0, $dZHnD.default)();
    var value = props.value, children = props.children, formatProps = (0, $evtaG.__rest)(props, [
        "value",
        "children"
    ]);
    return children(intl.formatNumberToParts(value, formatProps));
};
$b2df1b1ab8113166$export$54d4989ed3eea1ea.displayName = "FormattedNumberParts";
var $b2df1b1ab8113166$export$5ac259c7da6d2188 = function(props) {
    var intl = (0, $dZHnD.default)();
    var value = props.value, children = props.children, formatProps = (0, $evtaG.__rest)(props, [
        "value",
        "children"
    ]);
    return children(intl.formatListToParts(value, formatProps));
};
$b2df1b1ab8113166$export$54d4989ed3eea1ea.displayName = "FormattedNumberParts";
function $b2df1b1ab8113166$export$7448277f6036d2ab(name) {
    var ComponentParts = function(props) {
        var intl = (0, $dZHnD.default)();
        var value = props.value, children = props.children, formatProps = (0, $evtaG.__rest)(props, [
            "value",
            "children"
        ]);
        var date = typeof value === "string" ? new Date(value || 0) : value;
        var formattedParts = name === "formatDate" ? intl.formatDateToParts(date, formatProps) : intl.formatTimeToParts(date, formatProps);
        return children(formattedParts);
    };
    ComponentParts.displayName = $b2df1b1ab8113166$var$DisplayNameParts[name];
    return ComponentParts;
}
function $b2df1b1ab8113166$export$b37e14176d001dec(name) {
    var Component = function(props) {
        var intl = (0, $dZHnD.default)();
        var value = props.value, children = props.children, formatProps = (0, $evtaG.__rest)(props, [
            "value",
            "children"
        ]);
        // TODO: fix TS type definition for localeMatcher upstream
        var formattedValue = intl[name](value, formatProps);
        if (typeof children === "function") return children(formattedValue);
        var Text = intl.textComponent || $dAx5m.Fragment;
        return $dAx5m.createElement(Text, null, formattedValue);
    };
    Component.displayName = $b2df1b1ab8113166$var$DisplayName[name];
    return Component;
}

});

parcelRegister("aUu17", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7f166b15fc6cd334$export$2e2bcd8739ae039; });

var $evtaG = parcelRequire("evtaG");

var $dAx5m = parcelRequire("dAx5m");

var $gDrm5 = parcelRequire("gDrm5");

var $dZHnD = parcelRequire("dZHnD");
var $7f166b15fc6cd334$var$MINUTE = 60;
var $7f166b15fc6cd334$var$HOUR = 3600;
var $7f166b15fc6cd334$var$DAY = 86400;
function $7f166b15fc6cd334$var$selectUnit(seconds) {
    var absValue = Math.abs(seconds);
    if (absValue < $7f166b15fc6cd334$var$MINUTE) return "second";
    if (absValue < $7f166b15fc6cd334$var$HOUR) return "minute";
    if (absValue < $7f166b15fc6cd334$var$DAY) return "hour";
    return "day";
}
function $7f166b15fc6cd334$var$getDurationInSeconds(unit) {
    switch(unit){
        case "second":
            return 1;
        case "minute":
            return $7f166b15fc6cd334$var$MINUTE;
        case "hour":
            return $7f166b15fc6cd334$var$HOUR;
        default:
            return $7f166b15fc6cd334$var$DAY;
    }
}
function $7f166b15fc6cd334$var$valueToSeconds(value, unit) {
    if (!value) return 0;
    switch(unit){
        case "second":
            return value;
        case "minute":
            return value * $7f166b15fc6cd334$var$MINUTE;
        default:
            return value * $7f166b15fc6cd334$var$HOUR;
    }
}
var $7f166b15fc6cd334$var$INCREMENTABLE_UNITS = [
    "second",
    "minute",
    "hour"
];
function $7f166b15fc6cd334$var$canIncrement(unit) {
    if (unit === void 0) unit = "second";
    return $7f166b15fc6cd334$var$INCREMENTABLE_UNITS.indexOf(unit) > -1;
}
var $7f166b15fc6cd334$var$SimpleFormattedRelativeTime = function(props) {
    var _a = (0, $dZHnD.default)(), formatRelativeTime = _a.formatRelativeTime, Text = _a.textComponent;
    var children = props.children, value = props.value, unit = props.unit, otherProps = (0, $evtaG.__rest)(props, [
        "children",
        "value",
        "unit"
    ]);
    var formattedRelativeTime = formatRelativeTime(value || 0, unit, otherProps);
    if (typeof children === "function") return children(formattedRelativeTime);
    if (Text) return $dAx5m.createElement(Text, null, formattedRelativeTime);
    return $dAx5m.createElement($dAx5m.Fragment, null, formattedRelativeTime);
};
var $7f166b15fc6cd334$var$FormattedRelativeTime = function(_a) {
    var value = _a.value, unit = _a.unit, updateIntervalInSeconds = _a.updateIntervalInSeconds, otherProps = (0, $evtaG.__rest)(_a, [
        "value",
        "unit",
        "updateIntervalInSeconds"
    ]);
    (0, $gDrm5.invariant)(!updateIntervalInSeconds || !!(updateIntervalInSeconds && $7f166b15fc6cd334$var$canIncrement(unit)), "Cannot schedule update with unit longer than hour");
    var _b = $dAx5m.useState(), prevUnit = _b[0], setPrevUnit = _b[1];
    var _c = $dAx5m.useState(0), prevValue = _c[0], setPrevValue = _c[1];
    var _d = $dAx5m.useState(0), currentValueInSeconds = _d[0], setCurrentValueInSeconds = _d[1];
    var updateTimer;
    if (unit !== prevUnit || value !== prevValue) {
        setPrevValue(value || 0);
        setPrevUnit(unit);
        setCurrentValueInSeconds($7f166b15fc6cd334$var$canIncrement(unit) ? $7f166b15fc6cd334$var$valueToSeconds(value, unit) : 0);
    }
    $dAx5m.useEffect(function() {
        function clearUpdateTimer() {
            clearTimeout(updateTimer);
        }
        clearUpdateTimer();
        // If there's no interval and we cannot increment this unit, do nothing
        if (!updateIntervalInSeconds || !$7f166b15fc6cd334$var$canIncrement(unit)) return clearUpdateTimer;
        // Figure out the next interesting time
        var nextValueInSeconds = currentValueInSeconds - updateIntervalInSeconds;
        var nextUnit = $7f166b15fc6cd334$var$selectUnit(nextValueInSeconds);
        // We've reached the max auto incrementable unit, don't schedule another update
        if (nextUnit === "day") return clearUpdateTimer;
        var unitDuration = $7f166b15fc6cd334$var$getDurationInSeconds(nextUnit);
        var remainder = nextValueInSeconds % unitDuration;
        var prevInterestingValueInSeconds = nextValueInSeconds - remainder;
        var nextInterestingValueInSeconds = prevInterestingValueInSeconds >= currentValueInSeconds ? prevInterestingValueInSeconds - unitDuration : prevInterestingValueInSeconds;
        var delayInSeconds = Math.abs(nextInterestingValueInSeconds - currentValueInSeconds);
        if (currentValueInSeconds !== nextInterestingValueInSeconds) updateTimer = setTimeout(function() {
            return setCurrentValueInSeconds(nextInterestingValueInSeconds);
        }, delayInSeconds * 1e3);
        return clearUpdateTimer;
    }, [
        currentValueInSeconds,
        updateIntervalInSeconds,
        unit
    ]);
    var currentValue = value || 0;
    var currentUnit = unit;
    if ($7f166b15fc6cd334$var$canIncrement(unit) && typeof currentValueInSeconds === "number" && updateIntervalInSeconds) {
        currentUnit = $7f166b15fc6cd334$var$selectUnit(currentValueInSeconds);
        var unitDuration = $7f166b15fc6cd334$var$getDurationInSeconds(currentUnit);
        currentValue = Math.round(currentValueInSeconds / unitDuration);
    }
    return $dAx5m.createElement($7f166b15fc6cd334$var$SimpleFormattedRelativeTime, (0, $evtaG.__assign)({
        value: currentValue,
        unit: currentUnit
    }, otherProps));
};
$7f166b15fc6cd334$var$FormattedRelativeTime.displayName = "FormattedRelativeTime";
$7f166b15fc6cd334$var$FormattedRelativeTime.defaultProps = {
    value: 0,
    unit: "second"
};
var $7f166b15fc6cd334$export$2e2bcd8739ae039 = $7f166b15fc6cd334$var$FormattedRelativeTime;

});

parcelRegister("dlzfr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9b789411d87c6878$export$2e2bcd8739ae039; });
/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */ 
var $dAx5m = parcelRequire("dAx5m");

var $dZHnD = parcelRequire("dZHnD");
var $9b789411d87c6878$var$FormattedPlural = function(props) {
    var _a = (0, $dZHnD.default)(), formatPlural = _a.formatPlural, Text = _a.textComponent;
    var value = props.value, other = props.other, children = props.children;
    var pluralCategory = formatPlural(value, props);
    var formattedPlural = props[pluralCategory] || other;
    if (typeof children === "function") return children(formattedPlural);
    if (Text) return $dAx5m.createElement(Text, null, formattedPlural);
    // Work around @types/react where React.FC cannot return string
    return formattedPlural;
};
$9b789411d87c6878$var$FormattedPlural.defaultProps = {
    type: "cardinal"
};
$9b789411d87c6878$var$FormattedPlural.displayName = "FormattedPlural";
var $9b789411d87c6878$export$2e2bcd8739ae039 = $9b789411d87c6878$var$FormattedPlural;

});

parcelRegister("44eEQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2f62e7e0b3fd6d2b$export$2e2bcd8739ae039; });

var $evtaG = parcelRequire("evtaG");

var $dAx5m = parcelRequire("dAx5m");

var $dZHnD = parcelRequire("dZHnD");
var $2f62e7e0b3fd6d2b$var$FormattedDateTimeRange = function(props) {
    var intl = (0, $dZHnD.default)();
    var from = props.from, to = props.to, children = props.children, formatProps = (0, $evtaG.__rest)(props, [
        "from",
        "to",
        "children"
    ]);
    var formattedValue = intl.formatDateTimeRange(from, to, formatProps);
    if (typeof children === "function") return children(formattedValue);
    var Text = intl.textComponent || $dAx5m.Fragment;
    return $dAx5m.createElement(Text, null, formattedValue);
};
$2f62e7e0b3fd6d2b$var$FormattedDateTimeRange.displayName = "FormattedDateTimeRange";
var $2f62e7e0b3fd6d2b$export$2e2bcd8739ae039 = $2f62e7e0b3fd6d2b$var$FormattedDateTimeRange;

});





parcelRegister("3kXiv", function(module, exports) {

$parcel$export(module.exports, "addFlag", function () { return $b21d42e55c9e49ef$export$820a1da46c7a4303; });
$parcel$export(module.exports, "removeFlag", function () { return $b21d42e55c9e49ef$export$f2c4075a13a8b485; });
$parcel$export(module.exports, "default", function () { return $b21d42e55c9e49ef$export$2e2bcd8739ae039; });
// ------------------------------------
// Reducer
// ------------------------------------
const $b21d42e55c9e49ef$var$REMOVE_FLAG = "REMOVE_FLAG";
const $b21d42e55c9e49ef$export$8db129480af5aa95 = "ADD_FLAG";
const $b21d42e55c9e49ef$var$initialState = {
    flags: []
};
function $b21d42e55c9e49ef$export$820a1da46c7a4303(flag) {
    return {
        type: $b21d42e55c9e49ef$export$8db129480af5aa95,
        payload: flag
    };
}
function $b21d42e55c9e49ef$export$f2c4075a13a8b485(flagId) {
    return {
        type: $b21d42e55c9e49ef$var$REMOVE_FLAG,
        payload: {
            flagId: flagId
        }
    };
}
function $b21d42e55c9e49ef$export$2e2bcd8739ae039(state = $b21d42e55c9e49ef$var$initialState, action) {
    const { type: type, payload: payload } = action;
    switch(type){
        case $b21d42e55c9e49ef$var$REMOVE_FLAG:
            {
                const newFlags = state.flags.filter((flag)=>flag && flag.id !== payload.flagId);
                return {
                    ...state,
                    flags: newFlags
                };
            }
        case $b21d42e55c9e49ef$export$8db129480af5aa95:
            {
                let flagId = payload.id;
                const newFlag = {
                    ...payload,
                    id: flagId
                };
                return {
                    ...state,
                    flags: [
                        newFlag,
                        ...state.flags
                    ]
                };
            }
        default:
            return state;
    }
}

});

parcelRegister("9b2OC", function(module, exports) {

$parcel$export(module.exports, "UPDATE_PASSWORD", function () { return $3511c8b6f8a46550$export$d7089c9f5899d47c; });
$parcel$export(module.exports, "updatePassword", function () { return $3511c8b6f8a46550$export$e2853351e15b7895; });

var $kBVUb = parcelRequire("kBVUb");
const $3511c8b6f8a46550$export$d7089c9f5899d47c = "UPDATE_PASSWORD";
const $3511c8b6f8a46550$export$e2853351e15b7895 = (currentPassword, newPassword)=>{
    return (dispatch)=>{
        const changePasswordPromise = (0, $kBVUb.default).changePassword(currentPassword, newPassword).catch((error)=>{
            let errorJson = {};
            try {
                errorJson = JSON.parse(error.message);
            } catch (errorJsonParse) {
                throw error;
            }
            throw errorJson;
        });
        dispatch({
            type: $3511c8b6f8a46550$export$d7089c9f5899d47c,
            payload: changePasswordPromise
        })// Prevent uncaught exception in console.
        .catch(()=>null);
        return changePasswordPromise;
    };
};

});

parcelRegister("ekBOb", function(module, exports) {

$parcel$export(module.exports, "getConnectedApps", function () { return $23e641b8de7876f9$export$34bdddbdaa5e5de7; });
$parcel$export(module.exports, "removeAccessForApp", function () { return $23e641b8de7876f9$export$306334fadec0d1e0; });
$parcel$export(module.exports, "removeAccessToThirdParty", function () { return $23e641b8de7876f9$export$76cf523a85c7f812; });

var $crJIF = parcelRequire("crJIF");

var $6T77I = parcelRequire("6T77I");

var $2X6wq = parcelRequire("2X6wq");

var $eDBap = parcelRequire("eDBap");
const $23e641b8de7876f9$export$34bdddbdaa5e5de7 = (userId)=>{
    return (dispatch)=>{
        dispatch({
            type: (0, $eDBap.GET_CONNECTED_APPS),
            payload: Promise.all([
                (0, $6T77I.outboundAuthClient).getAccounts(userId),
                (0, $crJIF.atlassianGraphQLGatewayClient).queryAccountGrantConnectedApps()
            ])
        })// Prevent uncaught exception in console.
        .catch(()=>null);
    };
};
const $23e641b8de7876f9$export$306334fadec0d1e0 = (userId, oauthClientId)=>{
    return (dispatch)=>{
        // This removes the connected app from the user's account.
        const revokeAppAccessPromise = (0, $crJIF.atlassianGraphQLGatewayClient).removeConnectedApps(oauthClientId).then(()=>{
            // And then revokes the refresh token.
            return (0, $2X6wq.oAuthClient).revokeRefreshToken(oauthClientId);
        });
        dispatch({
            type: (0, $eDBap.REMOVE_CONNECTED_APP),
            payload: revokeAppAccessPromise,
            meta: {
                oauthClientId: oauthClientId
            }
        }).catch(()=>null);
        return revokeAppAccessPromise;
    };
};
const $23e641b8de7876f9$export$76cf523a85c7f812 = (userId, accountId, oauthClientId)=>{
    return (dispatch)=>{
        const removeOutboundAuthPromise = (0, $6T77I.outboundAuthClient).revokeAccess(userId, accountId);
        dispatch({
            type: (0, $eDBap.REMOVE_THIRD_PARTY_CONNECTION),
            payload: removeOutboundAuthPromise,
            meta: {
                accountId: accountId,
                oauthClientId: oauthClientId
            }
        }).catch(()=>null);
        return removeOutboundAuthPromise;
    };
};

});
parcelRegister("crJIF", function(module, exports) {

$parcel$export(module.exports, "atlassianGraphQLGatewayClient", function () { return $6e7bd0ad65b02a40$export$aa73d20cd85da393; });

var $9gLVV = parcelRequire("9gLVV");
const $6e7bd0ad65b02a40$var$buildAccountGrantConnectedAppsQuery = (parameters)=>({
        query: `query AccountGrants(
    $first: Int
    $after: String
  ){
    oauthClients {
      allAccountGrantsForUser(first: $first, after: $after) {
        nodes {
          accountId
          clientId
          scopeDetails {
            description
            key
          }
          appEnvironment {
            app {
              name
              id
              description
              vendorName
              termsOfService
              contactLink
            }
          }
        }
      }
    }
  }`,
        variables: {
            first: parameters?.first,
            after: parameters?.after
        }
    });
const $6e7bd0ad65b02a40$var$buildRemoveConnectedAppsMutation = (input)=>({
        query: `mutation RemoveConnectedApps($input: DeleteUserGrantInput!) {
    ecosystem {
      deleteUserGrant(input: $input) {
        success
        errors {
          message
          extensions {
            statusCode
            errorType
          }
        }
      }
    }
  }`,
        variables: {
            input: input
        }
    });
const $6e7bd0ad65b02a40$var$buildEcosystemMarketplaceAppScopesQuery = (ecosystemMarketplaceAppScopesQueryParams)=>({
        query: `query EcosystemMarketplaceAppScopes($cloudAppId: ID!, $version: String) {
    ecosystem {
      marketplaceData(cloudAppId: $cloudAppId) {
        versions(filter: {version: $version}) {
          edges {
            node {
              deployment {
                ... on EcosystemMarketplaceConnectAppDeployment {
                  connectAppScope:scopes {
                    description
                  }
                }
                ... on EcosystemMarketplaceCloudAppDeployment {
                  forgeAppScope:scopes {
                    description
                  }
                }
              }
            }
          }
        }
      }
    }
  }`,
        variables: {
            cloudAppId: ecosystemMarketplaceAppScopesQueryParams.cloudAppId,
            version: ecosystemMarketplaceAppScopesQueryParams.version
        }
    });
const $6e7bd0ad65b02a40$var$buildEcosystemMarketplaceAppQuery = (appKey)=>({
        query: `query EcosystemMarketplaceApp($appKey: ID!) {
    ecosystem {
      marketplaceData(appKey: $appKey) {
        appId
        slug
        summary
        partner {
          name
        }
        logo {
          original {
            uri
          }
        }
        privacyPolicyUrl
      }
    }
  }`,
        variables: {
            appKey: appKey
        }
    });
class $6e7bd0ad65b02a40$var$AtlassianGraphQLGatewayClient extends (0, $9gLVV.BaseGraphQlClient) {
    /**
   * Get connected apps for user with paging parameters
   * @param {Object} parameters - Paging parameters
   * @param {string} parameters.first - Returns the first n results
   * @param {string} parameters.last - Returns the last n results
   * @param {string} parameters.before - Returns results before a date
   * @param {string} parameters.after - Returns results after a date
   * @returns {Promise}
   */ queryAccountGrantConnectedApps(parameters) {
        const accountGrantConnectedAppsQuery = $6e7bd0ad65b02a40$var$buildAccountGrantConnectedAppsQuery(parameters);
        return this.makeGraphQLRequest(accountGrantConnectedAppsQuery, {
            operationName: "AccountGrants",
            errorPolicy: "all"
        });
    }
    /**
   * Remove access for a connected app with oauthClientId
   * @param {string} oauthClientId
   * @returns {Promise<string>}
   */ removeConnectedApps(oauthClientId) {
        const removeConnectedAppsquery = $6e7bd0ad65b02a40$var$buildRemoveConnectedAppsMutation({
            oauthClientId: oauthClientId
        });
        return this.makeGraphQLRequest(removeConnectedAppsquery, {
            operationName: "RemoveConnectedApps"
        });
    }
    /**
   * Get marketplace data for a specific app and version
   * @param {Object} marketplaceAppScopesQueryParams - Query parameters
   * @param {string} marketplaceAppScopesQueryParams.cloudAppId - The cloudAppId of the app
   * @param {string} marketplaceAppScopesQueryParams.version - The version of the app
   * @returns {Promise}
   */ queryEcosystemMarketplaceAppScopes(ecosystemMarketplaceAppScopesQueryParams) {
        const marketplaceAppScopesQuery = $6e7bd0ad65b02a40$var$buildEcosystemMarketplaceAppScopesQuery(ecosystemMarketplaceAppScopesQueryParams);
        return this.makeGraphQLRequest(marketplaceAppScopesQuery, {
            operationName: "EcosystemMarketplaceAppScopes",
            errorPolicy: "all"
        });
    }
    /**
   * Get marketplace data for an app
   * @param {string} appKey - The appKey of the app
   * @returns {Promise}
   */ queryEcosystemMarketplaceApp(appKey) {
        const marketplaceAppQuery = $6e7bd0ad65b02a40$var$buildEcosystemMarketplaceAppQuery(appKey);
        return this.makeGraphQLRequest(marketplaceAppQuery, {
            operationName: "EcosystemMarketplaceApp",
            errorPolicy: "all"
        });
    }
}
const $6e7bd0ad65b02a40$export$aa73d20cd85da393 = new $6e7bd0ad65b02a40$var$AtlassianGraphQLGatewayClient("/graphql");

});
parcelRegister("9gLVV", function(module, exports) {

$parcel$export(module.exports, "BaseGraphQlClient", function () { return $c67f22c6481dd83f$export$42f6d6baced34b2d; });
parcelRequire("9M337");
parcelRequire("itIMF");
var $3p1VH = parcelRequire("3p1VH");

var $1Bj4T = parcelRequire("1Bj4T");

var $5eCIB = parcelRequire("5eCIB");

var $cdiBL = parcelRequire("cdiBL");
class $c67f22c6481dd83f$export$42f6d6baced34b2d {
    constructor(servicePath){
        this.serviceUrl = `${(0, $1Bj4T.getConfig)().stargateRoot}${servicePath}`;
    }
    async makeGraphQLRequestWithoutRetries(body, options = {}) {
        const operationNameQuery = options.operationName ? `?q=${options.operationName}` : "";
        const errorPolicy = options.errorPolicy || "none";
        const url = this.serviceUrl + operationNameQuery;
        const request = (0, $3p1VH.default).post(url, !options.contentType || options.contentType === "application/json" ? JSON.stringify(body) : body, {
            responseType: "json",
            withCredentials: true,
            headers: {
                // 'Accept': 'application/json',
                "Content-Type": options.contentType || "application/json"
            },
            validateStatus: (status)=>{
                return status < 300 || status === 400;
            }
        });
        return request.then((response)=>{
            if (response.data.errors) {
                if (errorPolicy === "none") throw (0, $cdiBL.GraphQLError).from(response.data.errors);
                if (errorPolicy === "all") // Set timeout will postpone error throwing and de-touch it to another event loop,
                // so we can return data along with throwing error
                setTimeout(()=>{
                    throw (0, $cdiBL.GraphQLError).from(response.data.errors);
                }, 0);
            }
            return response.data.data;
        }, (error)=>{
            if (!(0, $3p1VH.default).isCancel(error)) {
                if (!error.response) {
                    if (error instanceof (0, $cdiBL.GraphQLError)) throw error;
                    throw new (0, $cdiBL.DefaultError)({
                        message: error.message
                    });
                }
                return error;
            }
        });
    }
    async makeGraphQLRequest(...args) {
        const makeGraphQLRequestWithRetries = (0, $5eCIB.withExponentialBackoff)(this.makeGraphQLRequestWithoutRetries.bind(this), {
            initial: (0, $5eCIB.EXPONENTIAL_BACKOFF_RETRY_POLICY).INITIAL_DELAY,
            jitter: (0, $5eCIB.EXPONENTIAL_BACKOFF_RETRY_POLICY).JITTER,
            max: (0, $5eCIB.EXPONENTIAL_BACKOFF_RETRY_POLICY).MAX_RETRIES,
            retryIf: (data)=>{
                return data && data.response && (0, $5eCIB.is5xx)(data.response.status);
            }
        });
        const result = await makeGraphQLRequestWithRetries(...args);
        const status = result && result.response && result.response.status;
        const statusText = result && result.response && result.response.statusText;
        if (status > 400 && status <= 599) throw new (0, $cdiBL.HttpError)({
            message: statusText,
            status: status
        });
        return result;
    }
}
var $c67f22c6481dd83f$export$2e2bcd8739ae039 = $c67f22c6481dd83f$export$42f6d6baced34b2d;

});
parcelRegister("9M337", function(module, exports) {
// This file can be required in Browserify and Node.js for automatic polyfill
// To use it:  require('es6-promise/auto');
"use strict";

module.exports = (parcelRequire("gOHOn")).polyfill();

});
parcelRegister("gOHOn", function(module, exports) {

var $ahJoN = parcelRequire("ahJoN");
/*!
 * @overview es6-promise - a tiny implementation of Promises/A+.
 * @copyright Copyright (c) 2014 Yehuda Katz, Tom Dale, Stefan Penner and contributors (Conversion to ES6 API by Jake Archibald)
 * @license   Licensed under MIT license
 *            See https://raw.githubusercontent.com/stefanpenner/es6-promise/master/LICENSE
 * @version   v4.2.6+9869a4bc
 */ (function(global1, factory) {
    module.exports = factory();
})(module.exports, function() {
    "use strict";
    function objectOrFunction(x) {
        var type = typeof x;
        return x !== null && (type === "object" || type === "function");
    }
    function isFunction(x) {
        return typeof x === "function";
    }
    var _isArray = void 0;
    if (Array.isArray) _isArray = Array.isArray;
    else _isArray = function(x) {
        return Object.prototype.toString.call(x) === "[object Array]";
    };
    var isArray = _isArray;
    var len = 0;
    var vertxNext = void 0;
    var customSchedulerFn = void 0;
    var asap = function asap(callback, arg) {
        queue[len] = callback;
        queue[len + 1] = arg;
        len += 2;
        if (len === 2) {
            // If len is 2, that means that we need to schedule an async flush.
            // If additional callbacks are queued before the queue is flushed, they
            // will be processed by this flush that we are scheduling.
            if (customSchedulerFn) customSchedulerFn(flush);
            else scheduleFlush();
        }
    };
    function setScheduler(scheduleFn) {
        customSchedulerFn = scheduleFn;
    }
    function setAsap(asapFn) {
        asap = asapFn;
    }
    var browserWindow = typeof window !== "undefined" ? window : undefined;
    var browserGlobal = browserWindow || {};
    var BrowserMutationObserver = browserGlobal.MutationObserver || browserGlobal.WebKitMutationObserver;
    var isNode = typeof self === "undefined" && typeof $ahJoN !== "undefined" && ({}).toString.call($ahJoN) === "[object process]";
    // test for web worker but not in IE10
    var isWorker = typeof Uint8ClampedArray !== "undefined" && typeof importScripts !== "undefined" && typeof MessageChannel !== "undefined";
    // node
    function useNextTick() {
        // node version 0.10.x displays a deprecation warning when nextTick is used recursively
        // see https://github.com/cujojs/when/issues/410 for details
        return function() {
            return $ahJoN.nextTick(flush);
        };
    }
    // vertx
    function useVertxTimer() {
        if (typeof vertxNext !== "undefined") return function() {
            vertxNext(flush);
        };
        return useSetTimeout();
    }
    function useMutationObserver() {
        var iterations = 0;
        var observer = new BrowserMutationObserver(flush);
        var node = document.createTextNode("");
        observer.observe(node, {
            characterData: true
        });
        return function() {
            node.data = iterations = ++iterations % 2;
        };
    }
    // web worker
    function useMessageChannel() {
        var channel = new MessageChannel();
        channel.port1.onmessage = flush;
        return function() {
            return channel.port2.postMessage(0);
        };
    }
    function useSetTimeout() {
        // Store setTimeout reference so es6-promise will be unaffected by
        // other code modifying setTimeout (like sinon.useFakeTimers())
        var globalSetTimeout = setTimeout;
        return function() {
            return globalSetTimeout(flush, 1);
        };
    }
    var queue = new Array(1000);
    function flush() {
        for(var i = 0; i < len; i += 2){
            var callback = queue[i];
            var arg = queue[i + 1];
            callback(arg);
            queue[i] = undefined;
            queue[i + 1] = undefined;
        }
        len = 0;
    }
    function attemptVertx() {
        try {
            var vertx = Function("return this")().require("vertx");
            vertxNext = vertx.runOnLoop || vertx.runOnContext;
            return useVertxTimer();
        } catch (e) {
            return useSetTimeout();
        }
    }
    var scheduleFlush = void 0;
    // Decide what async method to use to triggering processing of queued callbacks:
    if (isNode) scheduleFlush = useNextTick();
    else if (BrowserMutationObserver) scheduleFlush = useMutationObserver();
    else if (isWorker) scheduleFlush = useMessageChannel();
    else if (browserWindow === undefined && true) scheduleFlush = attemptVertx();
    else scheduleFlush = useSetTimeout();
    function then(onFulfillment, onRejection) {
        var parent = this;
        var child = new this.constructor(noop);
        if (child[PROMISE_ID] === undefined) makePromise(child);
        var _state = parent._state;
        if (_state) {
            var callback = arguments[_state - 1];
            asap(function() {
                return invokeCallback(_state, child, callback, parent._result);
            });
        } else subscribe(parent, child, onFulfillment, onRejection);
        return child;
    }
    /**
  `Promise.resolve` returns a promise that will become resolved with the
  passed `value`. It is shorthand for the following:

  ```javascript
  let promise = new Promise(function(resolve, reject){
    resolve(1);
  });

  promise.then(function(value){
    // value === 1
  });
  ```

  Instead of writing the above, your code now simply becomes the following:

  ```javascript
  let promise = Promise.resolve(1);

  promise.then(function(value){
    // value === 1
  });
  ```

  @method resolve
  @static
  @param {Any} value value that the returned promise will be resolved with
  Useful for tooling.
  @return {Promise} a promise that will become fulfilled with the given
  `value`
*/ function resolve$1(object) {
        /*jshint validthis:true */ var Constructor = this;
        if (object && typeof object === "object" && object.constructor === Constructor) return object;
        var promise = new Constructor(noop);
        resolve(promise, object);
        return promise;
    }
    var PROMISE_ID = Math.random().toString(36).substring(2);
    function noop() {}
    var PENDING = void 0;
    var FULFILLED = 1;
    var REJECTED = 2;
    var TRY_CATCH_ERROR = {
        error: null
    };
    function selfFulfillment() {
        return new TypeError("You cannot resolve a promise with itself");
    }
    function cannotReturnOwn() {
        return new TypeError("A promises callback cannot return that same promise.");
    }
    function getThen(promise) {
        try {
            return promise.then;
        } catch (error) {
            TRY_CATCH_ERROR.error = error;
            return TRY_CATCH_ERROR;
        }
    }
    function tryThen(then$$1, value, fulfillmentHandler, rejectionHandler) {
        try {
            then$$1.call(value, fulfillmentHandler, rejectionHandler);
        } catch (e) {
            return e;
        }
    }
    function handleForeignThenable(promise, thenable, then$$1) {
        asap(function(promise) {
            var sealed = false;
            var error = tryThen(then$$1, thenable, function(value) {
                if (sealed) return;
                sealed = true;
                if (thenable !== value) resolve(promise, value);
                else fulfill(promise, value);
            }, function(reason) {
                if (sealed) return;
                sealed = true;
                reject(promise, reason);
            }, "Settle: " + (promise._label || " unknown promise"));
            if (!sealed && error) {
                sealed = true;
                reject(promise, error);
            }
        }, promise);
    }
    function handleOwnThenable(promise, thenable) {
        if (thenable._state === FULFILLED) fulfill(promise, thenable._result);
        else if (thenable._state === REJECTED) reject(promise, thenable._result);
        else subscribe(thenable, undefined, function(value) {
            return resolve(promise, value);
        }, function(reason) {
            return reject(promise, reason);
        });
    }
    function handleMaybeThenable(promise, maybeThenable, then$$1) {
        if (maybeThenable.constructor === promise.constructor && then$$1 === then && maybeThenable.constructor.resolve === resolve$1) handleOwnThenable(promise, maybeThenable);
        else {
            if (then$$1 === TRY_CATCH_ERROR) {
                reject(promise, TRY_CATCH_ERROR.error);
                TRY_CATCH_ERROR.error = null;
            } else if (then$$1 === undefined) fulfill(promise, maybeThenable);
            else if (isFunction(then$$1)) handleForeignThenable(promise, maybeThenable, then$$1);
            else fulfill(promise, maybeThenable);
        }
    }
    function resolve(promise, value) {
        if (promise === value) reject(promise, selfFulfillment());
        else if (objectOrFunction(value)) handleMaybeThenable(promise, value, getThen(value));
        else fulfill(promise, value);
    }
    function publishRejection(promise) {
        if (promise._onerror) promise._onerror(promise._result);
        publish(promise);
    }
    function fulfill(promise, value) {
        if (promise._state !== PENDING) return;
        promise._result = value;
        promise._state = FULFILLED;
        if (promise._subscribers.length !== 0) asap(publish, promise);
    }
    function reject(promise, reason) {
        if (promise._state !== PENDING) return;
        promise._state = REJECTED;
        promise._result = reason;
        asap(publishRejection, promise);
    }
    function subscribe(parent, child, onFulfillment, onRejection) {
        var _subscribers = parent._subscribers;
        var length = _subscribers.length;
        parent._onerror = null;
        _subscribers[length] = child;
        _subscribers[length + FULFILLED] = onFulfillment;
        _subscribers[length + REJECTED] = onRejection;
        if (length === 0 && parent._state) asap(publish, parent);
    }
    function publish(promise) {
        var subscribers = promise._subscribers;
        var settled = promise._state;
        if (subscribers.length === 0) return;
        var child = void 0, callback = void 0, detail = promise._result;
        for(var i = 0; i < subscribers.length; i += 3){
            child = subscribers[i];
            callback = subscribers[i + settled];
            if (child) invokeCallback(settled, child, callback, detail);
            else callback(detail);
        }
        promise._subscribers.length = 0;
    }
    function tryCatch(callback, detail) {
        try {
            return callback(detail);
        } catch (e) {
            TRY_CATCH_ERROR.error = e;
            return TRY_CATCH_ERROR;
        }
    }
    function invokeCallback(settled, promise, callback, detail) {
        var hasCallback = isFunction(callback), value = void 0, error = void 0, succeeded = void 0, failed = void 0;
        if (hasCallback) {
            value = tryCatch(callback, detail);
            if (value === TRY_CATCH_ERROR) {
                failed = true;
                error = value.error;
                value.error = null;
            } else succeeded = true;
            if (promise === value) {
                reject(promise, cannotReturnOwn());
                return;
            }
        } else {
            value = detail;
            succeeded = true;
        }
        if (promise._state !== PENDING) ;
        else if (hasCallback && succeeded) resolve(promise, value);
        else if (failed) reject(promise, error);
        else if (settled === FULFILLED) fulfill(promise, value);
        else if (settled === REJECTED) reject(promise, value);
    }
    function initializePromise(promise, resolver) {
        try {
            resolver(function resolvePromise(value) {
                resolve(promise, value);
            }, function rejectPromise(reason) {
                reject(promise, reason);
            });
        } catch (e) {
            reject(promise, e);
        }
    }
    var id = 0;
    function nextId() {
        return id++;
    }
    function makePromise(promise) {
        promise[PROMISE_ID] = id++;
        promise._state = undefined;
        promise._result = undefined;
        promise._subscribers = [];
    }
    function validationError() {
        return new Error("Array Methods must be provided an Array");
    }
    var Enumerator = function() {
        function Enumerator(Constructor, input) {
            this._instanceConstructor = Constructor;
            this.promise = new Constructor(noop);
            if (!this.promise[PROMISE_ID]) makePromise(this.promise);
            if (isArray(input)) {
                this.length = input.length;
                this._remaining = input.length;
                this._result = new Array(this.length);
                if (this.length === 0) fulfill(this.promise, this._result);
                else {
                    this.length = this.length || 0;
                    this._enumerate(input);
                    if (this._remaining === 0) fulfill(this.promise, this._result);
                }
            } else reject(this.promise, validationError());
        }
        Enumerator.prototype._enumerate = function _enumerate(input) {
            for(var i = 0; this._state === PENDING && i < input.length; i++)this._eachEntry(input[i], i);
        };
        Enumerator.prototype._eachEntry = function _eachEntry(entry, i) {
            var c = this._instanceConstructor;
            var resolve$$1 = c.resolve;
            if (resolve$$1 === resolve$1) {
                var _then = getThen(entry);
                if (_then === then && entry._state !== PENDING) this._settledAt(entry._state, i, entry._result);
                else if (typeof _then !== "function") {
                    this._remaining--;
                    this._result[i] = entry;
                } else if (c === Promise$1) {
                    var promise = new c(noop);
                    handleMaybeThenable(promise, entry, _then);
                    this._willSettleAt(promise, i);
                } else this._willSettleAt(new c(function(resolve$$1) {
                    return resolve$$1(entry);
                }), i);
            } else this._willSettleAt(resolve$$1(entry), i);
        };
        Enumerator.prototype._settledAt = function _settledAt(state, i, value) {
            var promise = this.promise;
            if (promise._state === PENDING) {
                this._remaining--;
                if (state === REJECTED) reject(promise, value);
                else this._result[i] = value;
            }
            if (this._remaining === 0) fulfill(promise, this._result);
        };
        Enumerator.prototype._willSettleAt = function _willSettleAt(promise, i) {
            var enumerator = this;
            subscribe(promise, undefined, function(value) {
                return enumerator._settledAt(FULFILLED, i, value);
            }, function(reason) {
                return enumerator._settledAt(REJECTED, i, reason);
            });
        };
        return Enumerator;
    }();
    /**
  `Promise.all` accepts an array of promises, and returns a new promise which
  is fulfilled with an array of fulfillment values for the passed promises, or
  rejected with the reason of the first passed promise to be rejected. It casts all
  elements of the passed iterable to promises as it runs this algorithm.

  Example:

  ```javascript
  let promise1 = resolve(1);
  let promise2 = resolve(2);
  let promise3 = resolve(3);
  let promises = [ promise1, promise2, promise3 ];

  Promise.all(promises).then(function(array){
    // The array here would be [ 1, 2, 3 ];
  });
  ```

  If any of the `promises` given to `all` are rejected, the first promise
  that is rejected will be given as an argument to the returned promises's
  rejection handler. For example:

  Example:

  ```javascript
  let promise1 = resolve(1);
  let promise2 = reject(new Error("2"));
  let promise3 = reject(new Error("3"));
  let promises = [ promise1, promise2, promise3 ];

  Promise.all(promises).then(function(array){
    // Code here never runs because there are rejected promises!
  }, function(error) {
    // error.message === "2"
  });
  ```

  @method all
  @static
  @param {Array} entries array of promises
  @param {String} label optional string for labeling the promise.
  Useful for tooling.
  @return {Promise} promise that is fulfilled when all `promises` have been
  fulfilled, or rejected if any of them become rejected.
  @static
*/ function all(entries) {
        return new Enumerator(this, entries).promise;
    }
    /**
  `Promise.race` returns a new promise which is settled in the same way as the
  first passed promise to settle.

  Example:

  ```javascript
  let promise1 = new Promise(function(resolve, reject){
    setTimeout(function(){
      resolve('promise 1');
    }, 200);
  });

  let promise2 = new Promise(function(resolve, reject){
    setTimeout(function(){
      resolve('promise 2');
    }, 100);
  });

  Promise.race([promise1, promise2]).then(function(result){
    // result === 'promise 2' because it was resolved before promise1
    // was resolved.
  });
  ```

  `Promise.race` is deterministic in that only the state of the first
  settled promise matters. For example, even if other promises given to the
  `promises` array argument are resolved, but the first settled promise has
  become rejected before the other promises became fulfilled, the returned
  promise will become rejected:

  ```javascript
  let promise1 = new Promise(function(resolve, reject){
    setTimeout(function(){
      resolve('promise 1');
    }, 200);
  });

  let promise2 = new Promise(function(resolve, reject){
    setTimeout(function(){
      reject(new Error('promise 2'));
    }, 100);
  });

  Promise.race([promise1, promise2]).then(function(result){
    // Code here never runs
  }, function(reason){
    // reason.message === 'promise 2' because promise 2 became rejected before
    // promise 1 became fulfilled
  });
  ```

  An example real-world use case is implementing timeouts:

  ```javascript
  Promise.race([ajax('foo.json'), timeout(5000)])
  ```

  @method race
  @static
  @param {Array} promises array of promises to observe
  Useful for tooling.
  @return {Promise} a promise which settles in the same way as the first passed
  promise to settle.
*/ function race(entries) {
        /*jshint validthis:true */ var Constructor = this;
        if (!isArray(entries)) return new Constructor(function(_, reject) {
            return reject(new TypeError("You must pass an array to race."));
        });
        else return new Constructor(function(resolve, reject) {
            var length = entries.length;
            for(var i = 0; i < length; i++)Constructor.resolve(entries[i]).then(resolve, reject);
        });
    }
    /**
  `Promise.reject` returns a promise rejected with the passed `reason`.
  It is shorthand for the following:

  ```javascript
  let promise = new Promise(function(resolve, reject){
    reject(new Error('WHOOPS'));
  });

  promise.then(function(value){
    // Code here doesn't run because the promise is rejected!
  }, function(reason){
    // reason.message === 'WHOOPS'
  });
  ```

  Instead of writing the above, your code now simply becomes the following:

  ```javascript
  let promise = Promise.reject(new Error('WHOOPS'));

  promise.then(function(value){
    // Code here doesn't run because the promise is rejected!
  }, function(reason){
    // reason.message === 'WHOOPS'
  });
  ```

  @method reject
  @static
  @param {Any} reason value that the returned promise will be rejected with.
  Useful for tooling.
  @return {Promise} a promise rejected with the given `reason`.
*/ function reject$1(reason) {
        /*jshint validthis:true */ var Constructor = this;
        var promise = new Constructor(noop);
        reject(promise, reason);
        return promise;
    }
    function needsResolver() {
        throw new TypeError("You must pass a resolver function as the first argument to the promise constructor");
    }
    function needsNew() {
        throw new TypeError("Failed to construct 'Promise': Please use the 'new' operator, this object constructor cannot be called as a function.");
    }
    /**
  Promise objects represent the eventual result of an asynchronous operation. The
  primary way of interacting with a promise is through its `then` method, which
  registers callbacks to receive either a promise's eventual value or the reason
  why the promise cannot be fulfilled.

  Terminology
  -----------

  - `promise` is an object or function with a `then` method whose behavior conforms to this specification.
  - `thenable` is an object or function that defines a `then` method.
  - `value` is any legal JavaScript value (including undefined, a thenable, or a promise).
  - `exception` is a value that is thrown using the throw statement.
  - `reason` is a value that indicates why a promise was rejected.
  - `settled` the final resting state of a promise, fulfilled or rejected.

  A promise can be in one of three states: pending, fulfilled, or rejected.

  Promises that are fulfilled have a fulfillment value and are in the fulfilled
  state.  Promises that are rejected have a rejection reason and are in the
  rejected state.  A fulfillment value is never a thenable.

  Promises can also be said to *resolve* a value.  If this value is also a
  promise, then the original promise's settled state will match the value's
  settled state.  So a promise that *resolves* a promise that rejects will
  itself reject, and a promise that *resolves* a promise that fulfills will
  itself fulfill.


  Basic Usage:
  ------------

  ```js
  let promise = new Promise(function(resolve, reject) {
    // on success
    resolve(value);

    // on failure
    reject(reason);
  });

  promise.then(function(value) {
    // on fulfillment
  }, function(reason) {
    // on rejection
  });
  ```

  Advanced Usage:
  ---------------

  Promises shine when abstracting away asynchronous interactions such as
  `XMLHttpRequest`s.

  ```js
  function getJSON(url) {
    return new Promise(function(resolve, reject){
      let xhr = new XMLHttpRequest();

      xhr.open('GET', url);
      xhr.onreadystatechange = handler;
      xhr.responseType = 'json';
      xhr.setRequestHeader('Accept', 'application/json');
      xhr.send();

      function handler() {
        if (this.readyState === this.DONE) {
          if (this.status === 200) {
            resolve(this.response);
          } else {
            reject(new Error('getJSON: `' + url + '` failed with status: [' + this.status + ']'));
          }
        }
      };
    });
  }

  getJSON('/posts.json').then(function(json) {
    // on fulfillment
  }, function(reason) {
    // on rejection
  });
  ```

  Unlike callbacks, promises are great composable primitives.

  ```js
  Promise.all([
    getJSON('/posts'),
    getJSON('/comments')
  ]).then(function(values){
    values[0] // => postsJSON
    values[1] // => commentsJSON

    return values;
  });
  ```

  @class Promise
  @param {Function} resolver
  Useful for tooling.
  @constructor
*/ var Promise$1 = function() {
        function Promise(resolver) {
            this[PROMISE_ID] = nextId();
            this._result = this._state = undefined;
            this._subscribers = [];
            if (noop !== resolver) {
                typeof resolver !== "function" && needsResolver();
                this instanceof Promise ? initializePromise(this, resolver) : needsNew();
            }
        }
        /**
  The primary way of interacting with a promise is through its `then` method,
  which registers callbacks to receive either a promise's eventual value or the
  reason why the promise cannot be fulfilled.
   ```js
  findUser().then(function(user){
    // user is available
  }, function(reason){
    // user is unavailable, and you are given the reason why
  });
  ```
   Chaining
  --------
   The return value of `then` is itself a promise.  This second, 'downstream'
  promise is resolved with the return value of the first promise's fulfillment
  or rejection handler, or rejected if the handler throws an exception.
   ```js
  findUser().then(function (user) {
    return user.name;
  }, function (reason) {
    return 'default name';
  }).then(function (userName) {
    // If `findUser` fulfilled, `userName` will be the user's name, otherwise it
    // will be `'default name'`
  });
   findUser().then(function (user) {
    throw new Error('Found user, but still unhappy');
  }, function (reason) {
    throw new Error('`findUser` rejected and we're unhappy');
  }).then(function (value) {
    // never reached
  }, function (reason) {
    // if `findUser` fulfilled, `reason` will be 'Found user, but still unhappy'.
    // If `findUser` rejected, `reason` will be '`findUser` rejected and we're unhappy'.
  });
  ```
  If the downstream promise does not specify a rejection handler, rejection reasons will be propagated further downstream.
   ```js
  findUser().then(function (user) {
    throw new PedagogicalException('Upstream error');
  }).then(function (value) {
    // never reached
  }).then(function (value) {
    // never reached
  }, function (reason) {
    // The `PedgagocialException` is propagated all the way down to here
  });
  ```
   Assimilation
  ------------
   Sometimes the value you want to propagate to a downstream promise can only be
  retrieved asynchronously. This can be achieved by returning a promise in the
  fulfillment or rejection handler. The downstream promise will then be pending
  until the returned promise is settled. This is called *assimilation*.
   ```js
  findUser().then(function (user) {
    return findCommentsByAuthor(user);
  }).then(function (comments) {
    // The user's comments are now available
  });
  ```
   If the assimliated promise rejects, then the downstream promise will also reject.
   ```js
  findUser().then(function (user) {
    return findCommentsByAuthor(user);
  }).then(function (comments) {
    // If `findCommentsByAuthor` fulfills, we'll have the value here
  }, function (reason) {
    // If `findCommentsByAuthor` rejects, we'll have the reason here
  });
  ```
   Simple Example
  --------------
   Synchronous Example
   ```javascript
  let result;
   try {
    result = findResult();
    // success
  } catch(reason) {
    // failure
  }
  ```
   Errback Example
   ```js
  findResult(function(result, err){
    if (err) {
      // failure
    } else {
      // success
    }
  });
  ```
   Promise Example;
   ```javascript
  findResult().then(function(result){
    // success
  }, function(reason){
    // failure
  });
  ```
   Advanced Example
  --------------
   Synchronous Example
   ```javascript
  let author, books;
   try {
    author = findAuthor();
    books  = findBooksByAuthor(author);
    // success
  } catch(reason) {
    // failure
  }
  ```
   Errback Example
   ```js
   function foundBooks(books) {
   }
   function failure(reason) {
   }
   findAuthor(function(author, err){
    if (err) {
      failure(err);
      // failure
    } else {
      try {
        findBoooksByAuthor(author, function(books, err) {
          if (err) {
            failure(err);
          } else {
            try {
              foundBooks(books);
            } catch(reason) {
              failure(reason);
            }
          }
        });
      } catch(error) {
        failure(err);
      }
      // success
    }
  });
  ```
   Promise Example;
   ```javascript
  findAuthor().
    then(findBooksByAuthor).
    then(function(books){
      // found books
  }).catch(function(reason){
    // something went wrong
  });
  ```
   @method then
  @param {Function} onFulfilled
  @param {Function} onRejected
  Useful for tooling.
  @return {Promise}
  */ /**
  `catch` is simply sugar for `then(undefined, onRejection)` which makes it the same
  as the catch block of a try/catch statement.
  ```js
  function findAuthor(){
  throw new Error('couldn't find that author');
  }
  // synchronous
  try {
  findAuthor();
  } catch(reason) {
  // something went wrong
  }
  // async with promises
  findAuthor().catch(function(reason){
  // something went wrong
  });
  ```
  @method catch
  @param {Function} onRejection
  Useful for tooling.
  @return {Promise}
  */ Promise.prototype.catch = function _catch(onRejection) {
            return this.then(null, onRejection);
        };
        /**
    `finally` will be invoked regardless of the promise's fate just as native
    try/catch/finally behaves
  
    Synchronous example:
  
    ```js
    findAuthor() {
      if (Math.random() > 0.5) {
        throw new Error();
      }
      return new Author();
    }
  
    try {
      return findAuthor(); // succeed or fail
    } catch(error) {
      return findOtherAuther();
    } finally {
      // always runs
      // doesn't affect the return value
    }
    ```
  
    Asynchronous example:
  
    ```js
    findAuthor().catch(function(reason){
      return findOtherAuther();
    }).finally(function(){
      // author was either found, or not
    });
    ```
  
    @method finally
    @param {Function} callback
    @return {Promise}
  */ Promise.prototype.finally = function _finally(callback) {
            var promise = this;
            var constructor = promise.constructor;
            if (isFunction(callback)) return promise.then(function(value) {
                return constructor.resolve(callback()).then(function() {
                    return value;
                });
            }, function(reason) {
                return constructor.resolve(callback()).then(function() {
                    throw reason;
                });
            });
            return promise.then(callback, callback);
        };
        return Promise;
    }();
    Promise$1.prototype.then = then;
    Promise$1.all = all;
    Promise$1.race = race;
    Promise$1.resolve = resolve$1;
    Promise$1.reject = reject$1;
    Promise$1._setScheduler = setScheduler;
    Promise$1._setAsap = setAsap;
    Promise$1._asap = asap;
    /*global self*/ function polyfill() {
        var local = void 0;
        if (typeof $parcel$global !== "undefined") local = $parcel$global;
        else if (typeof self !== "undefined") local = self;
        else try {
            local = Function("return this")();
        } catch (e) {
            throw new Error("polyfill failed because global object is unavailable in this environment");
        }
        var P = local.Promise;
        if (P) {
            var promiseToString = null;
            try {
                promiseToString = Object.prototype.toString.call(P.resolve());
            } catch (e) {
            // silently ignored
            }
            if (promiseToString === "[object Promise]" && !P.cast) return;
        }
        local.Promise = Promise$1;
    }
    // Strange compat..
    Promise$1.polyfill = polyfill;
    Promise$1.Promise = Promise$1;
    return Promise$1;
});

});


parcelRegister("itIMF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return (parcelRequire("3p1VH")).default; });

var $3p1VH = parcelRequire("3p1VH");
// This module is intended to unwrap Axios default export as named.
// Keep top-level export same with static properties
// so that it can keep same with es module or cjs
const { Axios: $d73dac9315f62794$export$1c00760e9e5a4e95, AxiosError: $d73dac9315f62794$export$c1fbed17c2f6a328, CanceledError: $d73dac9315f62794$export$1ab0c6b20d94fa14, isCancel: $d73dac9315f62794$export$3b22524397b493c6, CancelToken: $d73dac9315f62794$export$fd08e3cb425f0d61, VERSION: $d73dac9315f62794$export$a4ad2735b021c132, all: $d73dac9315f62794$export$84bf76cd7afc7469, Cancel: $d73dac9315f62794$export$848c9b7ead0df967, isAxiosError: $d73dac9315f62794$export$fbafdbe06a5b5a9a, spread: $d73dac9315f62794$export$3ae0fd4797ed47c8, toFormData: $d73dac9315f62794$export$10ae0d317ea97f8b, AxiosHeaders: $d73dac9315f62794$export$4e7d6ff0f3e6520, HttpStatusCode: $d73dac9315f62794$export$a972f69c851492b3, formToJSON: $d73dac9315f62794$export$86d7c59254d6a2c9, getAdapter: $d73dac9315f62794$export$17ddc20a97d669e2, mergeConfig: $d73dac9315f62794$export$7ec1ebcfa9d8bd6a } = (0, $3p1VH.default);

});
parcelRegister("3p1VH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $27a53410dbe87706$export$2e2bcd8739ae039; });

var $hjVaC = parcelRequire("hjVaC");

var $3EgYN = parcelRequire("3EgYN");

var $4u335 = parcelRequire("4u335");

var $c3v5Q = parcelRequire("c3v5Q");

var $ia3kZ = parcelRequire("ia3kZ");

var $bPTby = parcelRequire("bPTby");

var $kk27X = parcelRequire("kk27X");

var $hWsWr = parcelRequire("hWsWr");

var $eAWn0 = parcelRequire("eAWn0");

var $7zwsx = parcelRequire("7zwsx");

var $4VTWW = parcelRequire("4VTWW");

var $7cviO = parcelRequire("7cviO");

var $48rwv = parcelRequire("48rwv");

var $3Fzaq = parcelRequire("3Fzaq");

var $aF1JP = parcelRequire("aF1JP");

var $5wGMX = parcelRequire("5wGMX");

var $hDBVh = parcelRequire("hDBVh");
"use strict";
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 *
 * @returns {Axios} A new instance of Axios
 */ function $27a53410dbe87706$var$createInstance(defaultConfig) {
    const context = new (0, $4u335.default)(defaultConfig);
    const instance = (0, $3EgYN.default)((0, $4u335.default).prototype.request, context);
    // Copy axios.prototype to instance
    (0, $hjVaC.default).extend(instance, (0, $4u335.default).prototype, context, {
        allOwnKeys: true
    });
    // Copy context to instance
    (0, $hjVaC.default).extend(instance, context, null, {
        allOwnKeys: true
    });
    // Factory for creating new instances
    instance.create = function create(instanceConfig) {
        return $27a53410dbe87706$var$createInstance((0, $c3v5Q.default)(defaultConfig, instanceConfig));
    };
    return instance;
}
// Create the default instance to be exported
const $27a53410dbe87706$var$axios = $27a53410dbe87706$var$createInstance((0, $ia3kZ.default));
// Expose Axios class to allow class inheritance
$27a53410dbe87706$var$axios.Axios = (0, $4u335.default);
// Expose Cancel & CancelToken
$27a53410dbe87706$var$axios.CanceledError = (0, $kk27X.default);
$27a53410dbe87706$var$axios.CancelToken = (0, $hWsWr.default);
$27a53410dbe87706$var$axios.isCancel = (0, $eAWn0.default);
$27a53410dbe87706$var$axios.VERSION = (0, $7zwsx.VERSION);
$27a53410dbe87706$var$axios.toFormData = (0, $4VTWW.default);
// Expose AxiosError class
$27a53410dbe87706$var$axios.AxiosError = (0, $7cviO.default);
// alias for CanceledError for backward compatibility
$27a53410dbe87706$var$axios.Cancel = $27a53410dbe87706$var$axios.CanceledError;
// Expose all/spread
$27a53410dbe87706$var$axios.all = function all(promises) {
    return Promise.all(promises);
};
$27a53410dbe87706$var$axios.spread = (0, $48rwv.default);
// Expose isAxiosError
$27a53410dbe87706$var$axios.isAxiosError = (0, $3Fzaq.default);
// Expose mergeConfig
$27a53410dbe87706$var$axios.mergeConfig = (0, $c3v5Q.default);
$27a53410dbe87706$var$axios.AxiosHeaders = (0, $aF1JP.default);
$27a53410dbe87706$var$axios.formToJSON = (thing)=>(0, $bPTby.default)((0, $hjVaC.default).isHTMLForm(thing) ? new FormData(thing) : thing);
$27a53410dbe87706$var$axios.getAdapter = (0, $5wGMX.default).getAdapter;
$27a53410dbe87706$var$axios.HttpStatusCode = (0, $hDBVh.default);
$27a53410dbe87706$var$axios.default = $27a53410dbe87706$var$axios;
var // this module should only have a default export
$27a53410dbe87706$export$2e2bcd8739ae039 = $27a53410dbe87706$var$axios;

});
parcelRegister("hjVaC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c9c08ed182d3c57a$export$2e2bcd8739ae039; });

var $3EgYN = parcelRequire("3EgYN");

var $ahJoN = parcelRequire("ahJoN");
"use strict";
// utils is a library of generic helper functions non-specific to axios
const { toString: $c9c08ed182d3c57a$var$toString } = Object.prototype;
const { getPrototypeOf: $c9c08ed182d3c57a$var$getPrototypeOf } = Object;
const $c9c08ed182d3c57a$var$kindOf = ((cache)=>(thing)=>{
        const str = $c9c08ed182d3c57a$var$toString.call(thing);
        return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
    })(Object.create(null));
const $c9c08ed182d3c57a$var$kindOfTest = (type)=>{
    type = type.toLowerCase();
    return (thing)=>$c9c08ed182d3c57a$var$kindOf(thing) === type;
};
const $c9c08ed182d3c57a$var$typeOfTest = (type)=>(thing)=>typeof thing === type;
/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 *
 * @returns {boolean} True if value is an Array, otherwise false
 */ const { isArray: $c9c08ed182d3c57a$var$isArray } = Array;
/**
 * Determine if a value is undefined
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if the value is undefined, otherwise false
 */ const $c9c08ed182d3c57a$var$isUndefined = $c9c08ed182d3c57a$var$typeOfTest("undefined");
/**
 * Determine if a value is a Buffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Buffer, otherwise false
 */ function $c9c08ed182d3c57a$var$isBuffer(val) {
    return val !== null && !$c9c08ed182d3c57a$var$isUndefined(val) && val.constructor !== null && !$c9c08ed182d3c57a$var$isUndefined(val.constructor) && $c9c08ed182d3c57a$var$isFunction(val.constructor.isBuffer) && val.constructor.isBuffer(val);
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */ const $c9c08ed182d3c57a$var$isArrayBuffer = $c9c08ed182d3c57a$var$kindOfTest("ArrayBuffer");
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */ function $c9c08ed182d3c57a$var$isArrayBufferView(val) {
    let result;
    if (typeof ArrayBuffer !== "undefined" && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
    else result = val && val.buffer && $c9c08ed182d3c57a$var$isArrayBuffer(val.buffer);
    return result;
}
/**
 * Determine if a value is a String
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a String, otherwise false
 */ const $c9c08ed182d3c57a$var$isString = $c9c08ed182d3c57a$var$typeOfTest("string");
/**
 * Determine if a value is a Function
 *
 * @param {*} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */ const $c9c08ed182d3c57a$var$isFunction = $c9c08ed182d3c57a$var$typeOfTest("function");
/**
 * Determine if a value is a Number
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Number, otherwise false
 */ const $c9c08ed182d3c57a$var$isNumber = $c9c08ed182d3c57a$var$typeOfTest("number");
/**
 * Determine if a value is an Object
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an Object, otherwise false
 */ const $c9c08ed182d3c57a$var$isObject = (thing)=>thing !== null && typeof thing === "object";
/**
 * Determine if a value is a Boolean
 *
 * @param {*} thing The value to test
 * @returns {boolean} True if value is a Boolean, otherwise false
 */ const $c9c08ed182d3c57a$var$isBoolean = (thing)=>thing === true || thing === false;
/**
 * Determine if a value is a plain Object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a plain Object, otherwise false
 */ const $c9c08ed182d3c57a$var$isPlainObject = (val)=>{
    if ($c9c08ed182d3c57a$var$kindOf(val) !== "object") return false;
    const prototype = $c9c08ed182d3c57a$var$getPrototypeOf(val);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in val) && !(Symbol.iterator in val);
};
/**
 * Determine if a value is a Date
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Date, otherwise false
 */ const $c9c08ed182d3c57a$var$isDate = $c9c08ed182d3c57a$var$kindOfTest("Date");
/**
 * Determine if a value is a File
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const $c9c08ed182d3c57a$var$isFile = $c9c08ed182d3c57a$var$kindOfTest("File");
/**
 * Determine if a value is a Blob
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Blob, otherwise false
 */ const $c9c08ed182d3c57a$var$isBlob = $c9c08ed182d3c57a$var$kindOfTest("Blob");
/**
 * Determine if a value is a FileList
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const $c9c08ed182d3c57a$var$isFileList = $c9c08ed182d3c57a$var$kindOfTest("FileList");
/**
 * Determine if a value is a Stream
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Stream, otherwise false
 */ const $c9c08ed182d3c57a$var$isStream = (val)=>$c9c08ed182d3c57a$var$isObject(val) && $c9c08ed182d3c57a$var$isFunction(val.pipe);
/**
 * Determine if a value is a FormData
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an FormData, otherwise false
 */ const $c9c08ed182d3c57a$var$isFormData = (thing)=>{
    let kind;
    return thing && (typeof FormData === "function" && thing instanceof FormData || $c9c08ed182d3c57a$var$isFunction(thing.append) && ((kind = $c9c08ed182d3c57a$var$kindOf(thing)) === "formdata" || // detect form-data instance
    kind === "object" && $c9c08ed182d3c57a$var$isFunction(thing.toString) && thing.toString() === "[object FormData]"));
};
/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */ const $c9c08ed182d3c57a$var$isURLSearchParams = $c9c08ed182d3c57a$var$kindOfTest("URLSearchParams");
const [$c9c08ed182d3c57a$var$isReadableStream, $c9c08ed182d3c57a$var$isRequest, $c9c08ed182d3c57a$var$isResponse, $c9c08ed182d3c57a$var$isHeaders] = [
    "ReadableStream",
    "Request",
    "Response",
    "Headers"
].map($c9c08ed182d3c57a$var$kindOfTest);
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 *
 * @returns {String} The String freed of excess whitespace
 */ const $c9c08ed182d3c57a$var$trim = (str)=>str.trim ? str.trim() : str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 *
 * @param {Boolean} [allOwnKeys = false]
 * @returns {any}
 */ function $c9c08ed182d3c57a$var$forEach(obj, fn, { allOwnKeys: allOwnKeys = false } = {}) {
    // Don't bother if no value provided
    if (obj === null || typeof obj === "undefined") return;
    let i;
    let l;
    // Force an array if not already something iterable
    if (typeof obj !== "object") /*eslint no-param-reassign:0*/ obj = [
        obj
    ];
    if ($c9c08ed182d3c57a$var$isArray(obj)) // Iterate over array values
    for(i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
    else {
        // Iterate over object keys
        const keys = allOwnKeys ? Object.getOwnPropertyNames(obj) : Object.keys(obj);
        const len = keys.length;
        let key;
        for(i = 0; i < len; i++){
            key = keys[i];
            fn.call(null, obj[key], key, obj);
        }
    }
}
function $c9c08ed182d3c57a$var$findKey(obj, key) {
    key = key.toLowerCase();
    const keys = Object.keys(obj);
    let i = keys.length;
    let _key;
    while(i-- > 0){
        _key = keys[i];
        if (key === _key.toLowerCase()) return _key;
    }
    return null;
}
const $c9c08ed182d3c57a$var$_global = (()=>{
    /*eslint no-undef:0*/ if (typeof globalThis !== "undefined") return globalThis;
    return typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : $parcel$global;
})();
const $c9c08ed182d3c57a$var$isContextDefined = (context)=>!$c9c08ed182d3c57a$var$isUndefined(context) && context !== $c9c08ed182d3c57a$var$_global;
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 *
 * @returns {Object} Result of all merge properties
 */ function $c9c08ed182d3c57a$var$merge() {
    const { caseless: caseless } = $c9c08ed182d3c57a$var$isContextDefined(this) && this || {};
    const result = {};
    const assignValue = (val, key)=>{
        const targetKey = caseless && $c9c08ed182d3c57a$var$findKey(result, key) || key;
        if ($c9c08ed182d3c57a$var$isPlainObject(result[targetKey]) && $c9c08ed182d3c57a$var$isPlainObject(val)) result[targetKey] = $c9c08ed182d3c57a$var$merge(result[targetKey], val);
        else if ($c9c08ed182d3c57a$var$isPlainObject(val)) result[targetKey] = $c9c08ed182d3c57a$var$merge({}, val);
        else if ($c9c08ed182d3c57a$var$isArray(val)) result[targetKey] = val.slice();
        else result[targetKey] = val;
    };
    for(let i = 0, l = arguments.length; i < l; i++)arguments[i] && $c9c08ed182d3c57a$var$forEach(arguments[i], assignValue);
    return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 *
 * @param {Boolean} [allOwnKeys]
 * @returns {Object} The resulting value of object a
 */ const $c9c08ed182d3c57a$var$extend = (a, b, thisArg, { allOwnKeys: allOwnKeys } = {})=>{
    $c9c08ed182d3c57a$var$forEach(b, (val, key)=>{
        if (thisArg && $c9c08ed182d3c57a$var$isFunction(val)) a[key] = (0, $3EgYN.default)(val, thisArg);
        else a[key] = val;
    }, {
        allOwnKeys: allOwnKeys
    });
    return a;
};
/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 *
 * @returns {string} content value without BOM
 */ const $c9c08ed182d3c57a$var$stripBOM = (content)=>{
    if (content.charCodeAt(0) === 0xFEFF) content = content.slice(1);
    return content;
};
/**
 * Inherit the prototype methods from one constructor into another
 * @param {function} constructor
 * @param {function} superConstructor
 * @param {object} [props]
 * @param {object} [descriptors]
 *
 * @returns {void}
 */ const $c9c08ed182d3c57a$var$inherits = (constructor, superConstructor, props, descriptors)=>{
    constructor.prototype = Object.create(superConstructor.prototype, descriptors);
    constructor.prototype.constructor = constructor;
    Object.defineProperty(constructor, "super", {
        value: superConstructor.prototype
    });
    props && Object.assign(constructor.prototype, props);
};
/**
 * Resolve object with deep prototype chain to a flat object
 * @param {Object} sourceObj source object
 * @param {Object} [destObj]
 * @param {Function|Boolean} [filter]
 * @param {Function} [propFilter]
 *
 * @returns {Object}
 */ const $c9c08ed182d3c57a$var$toFlatObject = (sourceObj, destObj, filter, propFilter)=>{
    let props;
    let i;
    let prop;
    const merged = {};
    destObj = destObj || {};
    // eslint-disable-next-line no-eq-null,eqeqeq
    if (sourceObj == null) return destObj;
    do {
        props = Object.getOwnPropertyNames(sourceObj);
        i = props.length;
        while(i-- > 0){
            prop = props[i];
            if ((!propFilter || propFilter(prop, sourceObj, destObj)) && !merged[prop]) {
                destObj[prop] = sourceObj[prop];
                merged[prop] = true;
            }
        }
        sourceObj = filter !== false && $c9c08ed182d3c57a$var$getPrototypeOf(sourceObj);
    }while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);
    return destObj;
};
/**
 * Determines whether a string ends with the characters of a specified string
 *
 * @param {String} str
 * @param {String} searchString
 * @param {Number} [position= 0]
 *
 * @returns {boolean}
 */ const $c9c08ed182d3c57a$var$endsWith = (str, searchString, position)=>{
    str = String(str);
    if (position === undefined || position > str.length) position = str.length;
    position -= searchString.length;
    const lastIndex = str.indexOf(searchString, position);
    return lastIndex !== -1 && lastIndex === position;
};
/**
 * Returns new array from array like object or null if failed
 *
 * @param {*} [thing]
 *
 * @returns {?Array}
 */ const $c9c08ed182d3c57a$var$toArray = (thing)=>{
    if (!thing) return null;
    if ($c9c08ed182d3c57a$var$isArray(thing)) return thing;
    let i = thing.length;
    if (!$c9c08ed182d3c57a$var$isNumber(i)) return null;
    const arr = new Array(i);
    while(i-- > 0)arr[i] = thing[i];
    return arr;
};
/**
 * Checking if the Uint8Array exists and if it does, it returns a function that checks if the
 * thing passed in is an instance of Uint8Array
 *
 * @param {TypedArray}
 *
 * @returns {Array}
 */ // eslint-disable-next-line func-names
const $c9c08ed182d3c57a$var$isTypedArray = ((TypedArray)=>{
    // eslint-disable-next-line func-names
    return (thing)=>{
        return TypedArray && thing instanceof TypedArray;
    };
})(typeof Uint8Array !== "undefined" && $c9c08ed182d3c57a$var$getPrototypeOf(Uint8Array));
/**
 * For each entry in the object, call the function with the key and value.
 *
 * @param {Object<any, any>} obj - The object to iterate over.
 * @param {Function} fn - The function to call for each entry.
 *
 * @returns {void}
 */ const $c9c08ed182d3c57a$var$forEachEntry = (obj, fn)=>{
    const generator = obj && obj[Symbol.iterator];
    const iterator = generator.call(obj);
    let result;
    while((result = iterator.next()) && !result.done){
        const pair = result.value;
        fn.call(obj, pair[0], pair[1]);
    }
};
/**
 * It takes a regular expression and a string, and returns an array of all the matches
 *
 * @param {string} regExp - The regular expression to match against.
 * @param {string} str - The string to search.
 *
 * @returns {Array<boolean>}
 */ const $c9c08ed182d3c57a$var$matchAll = (regExp, str)=>{
    let matches;
    const arr = [];
    while((matches = regExp.exec(str)) !== null)arr.push(matches);
    return arr;
};
/* Checking if the kindOfTest function returns true when passed an HTMLFormElement. */ const $c9c08ed182d3c57a$var$isHTMLForm = $c9c08ed182d3c57a$var$kindOfTest("HTMLFormElement");
const $c9c08ed182d3c57a$var$toCamelCase = (str)=>{
    return str.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g, function replacer(m, p1, p2) {
        return p1.toUpperCase() + p2;
    });
};
/* Creating a function that will check if an object has a property. */ const $c9c08ed182d3c57a$var$hasOwnProperty = (({ hasOwnProperty: hasOwnProperty })=>(obj, prop)=>hasOwnProperty.call(obj, prop))(Object.prototype);
/**
 * Determine if a value is a RegExp object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a RegExp object, otherwise false
 */ const $c9c08ed182d3c57a$var$isRegExp = $c9c08ed182d3c57a$var$kindOfTest("RegExp");
const $c9c08ed182d3c57a$var$reduceDescriptors = (obj, reducer)=>{
    const descriptors = Object.getOwnPropertyDescriptors(obj);
    const reducedDescriptors = {};
    $c9c08ed182d3c57a$var$forEach(descriptors, (descriptor, name)=>{
        let ret;
        if ((ret = reducer(descriptor, name, obj)) !== false) reducedDescriptors[name] = ret || descriptor;
    });
    Object.defineProperties(obj, reducedDescriptors);
};
/**
 * Makes all methods read-only
 * @param {Object} obj
 */ const $c9c08ed182d3c57a$var$freezeMethods = (obj)=>{
    $c9c08ed182d3c57a$var$reduceDescriptors(obj, (descriptor, name)=>{
        // skip restricted props in strict mode
        if ($c9c08ed182d3c57a$var$isFunction(obj) && [
            "arguments",
            "caller",
            "callee"
        ].indexOf(name) !== -1) return false;
        const value = obj[name];
        if (!$c9c08ed182d3c57a$var$isFunction(value)) return;
        descriptor.enumerable = false;
        if ("writable" in descriptor) {
            descriptor.writable = false;
            return;
        }
        if (!descriptor.set) descriptor.set = ()=>{
            throw Error("Can not rewrite read-only method '" + name + "'");
        };
    });
};
const $c9c08ed182d3c57a$var$toObjectSet = (arrayOrString, delimiter)=>{
    const obj = {};
    const define = (arr)=>{
        arr.forEach((value)=>{
            obj[value] = true;
        });
    };
    $c9c08ed182d3c57a$var$isArray(arrayOrString) ? define(arrayOrString) : define(String(arrayOrString).split(delimiter));
    return obj;
};
const $c9c08ed182d3c57a$var$noop = ()=>{};
const $c9c08ed182d3c57a$var$toFiniteNumber = (value, defaultValue)=>{
    return value != null && Number.isFinite(value = +value) ? value : defaultValue;
};
/**
 * If the thing is a FormData object, return true, otherwise return false.
 *
 * @param {unknown} thing - The thing to check.
 *
 * @returns {boolean}
 */ function $c9c08ed182d3c57a$var$isSpecCompliantForm(thing) {
    return !!(thing && $c9c08ed182d3c57a$var$isFunction(thing.append) && thing[Symbol.toStringTag] === "FormData" && thing[Symbol.iterator]);
}
const $c9c08ed182d3c57a$var$toJSONObject = (obj)=>{
    const stack = new Array(10);
    const visit = (source, i)=>{
        if ($c9c08ed182d3c57a$var$isObject(source)) {
            if (stack.indexOf(source) >= 0) return;
            if (!("toJSON" in source)) {
                stack[i] = source;
                const target = $c9c08ed182d3c57a$var$isArray(source) ? [] : {};
                $c9c08ed182d3c57a$var$forEach(source, (value, key)=>{
                    const reducedValue = visit(value, i + 1);
                    !$c9c08ed182d3c57a$var$isUndefined(reducedValue) && (target[key] = reducedValue);
                });
                stack[i] = undefined;
                return target;
            }
        }
        return source;
    };
    return visit(obj, 0);
};
const $c9c08ed182d3c57a$var$isAsyncFn = $c9c08ed182d3c57a$var$kindOfTest("AsyncFunction");
const $c9c08ed182d3c57a$var$isThenable = (thing)=>thing && ($c9c08ed182d3c57a$var$isObject(thing) || $c9c08ed182d3c57a$var$isFunction(thing)) && $c9c08ed182d3c57a$var$isFunction(thing.then) && $c9c08ed182d3c57a$var$isFunction(thing.catch);
// original code
// https://github.com/DigitalBrainJS/AxiosPromise/blob/16deab13710ec09779922131f3fa5954320f83ab/lib/utils.js#L11-L34
const $c9c08ed182d3c57a$var$_setImmediate = ((setImmediateSupported, postMessageSupported)=>{
    if (setImmediateSupported) return setImmediate;
    return postMessageSupported ? ((token, callbacks)=>{
        $c9c08ed182d3c57a$var$_global.addEventListener("message", ({ source: source, data: data })=>{
            if (source === $c9c08ed182d3c57a$var$_global && data === token) callbacks.length && callbacks.shift()();
        }, false);
        return (cb)=>{
            callbacks.push(cb);
            $c9c08ed182d3c57a$var$_global.postMessage(token, "*");
        };
    })(`axios@${Math.random()}`, []) : (cb)=>setTimeout(cb);
})(typeof setImmediate === "function", $c9c08ed182d3c57a$var$isFunction($c9c08ed182d3c57a$var$_global.postMessage));
const $c9c08ed182d3c57a$var$asap = typeof queueMicrotask !== "undefined" ? queueMicrotask.bind($c9c08ed182d3c57a$var$_global) : typeof $ahJoN !== "undefined" && $ahJoN.nextTick || $c9c08ed182d3c57a$var$_setImmediate;
var // *********************
$c9c08ed182d3c57a$export$2e2bcd8739ae039 = {
    isArray: $c9c08ed182d3c57a$var$isArray,
    isArrayBuffer: $c9c08ed182d3c57a$var$isArrayBuffer,
    isBuffer: $c9c08ed182d3c57a$var$isBuffer,
    isFormData: $c9c08ed182d3c57a$var$isFormData,
    isArrayBufferView: $c9c08ed182d3c57a$var$isArrayBufferView,
    isString: $c9c08ed182d3c57a$var$isString,
    isNumber: $c9c08ed182d3c57a$var$isNumber,
    isBoolean: $c9c08ed182d3c57a$var$isBoolean,
    isObject: $c9c08ed182d3c57a$var$isObject,
    isPlainObject: $c9c08ed182d3c57a$var$isPlainObject,
    isReadableStream: $c9c08ed182d3c57a$var$isReadableStream,
    isRequest: $c9c08ed182d3c57a$var$isRequest,
    isResponse: $c9c08ed182d3c57a$var$isResponse,
    isHeaders: $c9c08ed182d3c57a$var$isHeaders,
    isUndefined: $c9c08ed182d3c57a$var$isUndefined,
    isDate: $c9c08ed182d3c57a$var$isDate,
    isFile: $c9c08ed182d3c57a$var$isFile,
    isBlob: $c9c08ed182d3c57a$var$isBlob,
    isRegExp: $c9c08ed182d3c57a$var$isRegExp,
    isFunction: $c9c08ed182d3c57a$var$isFunction,
    isStream: $c9c08ed182d3c57a$var$isStream,
    isURLSearchParams: $c9c08ed182d3c57a$var$isURLSearchParams,
    isTypedArray: $c9c08ed182d3c57a$var$isTypedArray,
    isFileList: $c9c08ed182d3c57a$var$isFileList,
    forEach: $c9c08ed182d3c57a$var$forEach,
    merge: $c9c08ed182d3c57a$var$merge,
    extend: $c9c08ed182d3c57a$var$extend,
    trim: $c9c08ed182d3c57a$var$trim,
    stripBOM: $c9c08ed182d3c57a$var$stripBOM,
    inherits: $c9c08ed182d3c57a$var$inherits,
    toFlatObject: $c9c08ed182d3c57a$var$toFlatObject,
    kindOf: $c9c08ed182d3c57a$var$kindOf,
    kindOfTest: $c9c08ed182d3c57a$var$kindOfTest,
    endsWith: $c9c08ed182d3c57a$var$endsWith,
    toArray: $c9c08ed182d3c57a$var$toArray,
    forEachEntry: $c9c08ed182d3c57a$var$forEachEntry,
    matchAll: $c9c08ed182d3c57a$var$matchAll,
    isHTMLForm: $c9c08ed182d3c57a$var$isHTMLForm,
    hasOwnProperty: $c9c08ed182d3c57a$var$hasOwnProperty,
    hasOwnProp: $c9c08ed182d3c57a$var$hasOwnProperty,
    reduceDescriptors: $c9c08ed182d3c57a$var$reduceDescriptors,
    freezeMethods: $c9c08ed182d3c57a$var$freezeMethods,
    toObjectSet: $c9c08ed182d3c57a$var$toObjectSet,
    toCamelCase: $c9c08ed182d3c57a$var$toCamelCase,
    noop: $c9c08ed182d3c57a$var$noop,
    toFiniteNumber: $c9c08ed182d3c57a$var$toFiniteNumber,
    findKey: $c9c08ed182d3c57a$var$findKey,
    global: $c9c08ed182d3c57a$var$_global,
    isContextDefined: $c9c08ed182d3c57a$var$isContextDefined,
    isSpecCompliantForm: $c9c08ed182d3c57a$var$isSpecCompliantForm,
    toJSONObject: $c9c08ed182d3c57a$var$toJSONObject,
    isAsyncFn: $c9c08ed182d3c57a$var$isAsyncFn,
    isThenable: $c9c08ed182d3c57a$var$isThenable,
    setImmediate: $c9c08ed182d3c57a$var$_setImmediate,
    asap: $c9c08ed182d3c57a$var$asap
};

});
parcelRegister("3EgYN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2a824752f1cd6f14$export$2e2bcd8739ae039; });
"use strict";
function $2a824752f1cd6f14$export$2e2bcd8739ae039(fn, thisArg) {
    return function wrap() {
        return fn.apply(thisArg, arguments);
    };
}

});


parcelRegister("4u335", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $343c542de62ee413$export$2e2bcd8739ae039; });

var $hjVaC = parcelRequire("hjVaC");

var $hHwRb = parcelRequire("hHwRb");

var $2ByHk = parcelRequire("2ByHk");

var $jx59l = parcelRequire("jx59l");

var $c3v5Q = parcelRequire("c3v5Q");

var $9jhII = parcelRequire("9jhII");

var $alWME = parcelRequire("alWME");

var $aF1JP = parcelRequire("aF1JP");
"use strict";
const $343c542de62ee413$var$validators = (0, $alWME.default).validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 *
 * @return {Axios} A new instance of Axios
 */ class $343c542de62ee413$var$Axios {
    constructor(instanceConfig){
        this.defaults = instanceConfig;
        this.interceptors = {
            request: new (0, $2ByHk.default)(),
            response: new (0, $2ByHk.default)()
        };
    }
    /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */ async request(configOrUrl, config) {
        try {
            return await this._request(configOrUrl, config);
        } catch (err) {
            if (err instanceof Error) {
                let dummy = {};
                Error.captureStackTrace ? Error.captureStackTrace(dummy) : dummy = new Error();
                // slice off the Error: ... line
                const stack = dummy.stack ? dummy.stack.replace(/^.+\n/, "") : "";
                try {
                    if (!err.stack) err.stack = stack;
                    else if (stack && !String(err.stack).endsWith(stack.replace(/^.+\n.+\n/, ""))) err.stack += "\n" + stack;
                } catch (e) {
                // ignore the case where "stack" is an un-writable property
                }
            }
            throw err;
        }
    }
    _request(configOrUrl, config) {
        /*eslint no-param-reassign:0*/ // Allow for axios('example/url'[, config]) a la fetch API
        if (typeof configOrUrl === "string") {
            config = config || {};
            config.url = configOrUrl;
        } else config = configOrUrl || {};
        config = (0, $c3v5Q.default)(this.defaults, config);
        const { transitional: transitional, paramsSerializer: paramsSerializer, headers: headers } = config;
        if (transitional !== undefined) (0, $alWME.default).assertOptions(transitional, {
            silentJSONParsing: $343c542de62ee413$var$validators.transitional($343c542de62ee413$var$validators.boolean),
            forcedJSONParsing: $343c542de62ee413$var$validators.transitional($343c542de62ee413$var$validators.boolean),
            clarifyTimeoutError: $343c542de62ee413$var$validators.transitional($343c542de62ee413$var$validators.boolean)
        }, false);
        if (paramsSerializer != null) {
            if ((0, $hjVaC.default).isFunction(paramsSerializer)) config.paramsSerializer = {
                serialize: paramsSerializer
            };
            else (0, $alWME.default).assertOptions(paramsSerializer, {
                encode: $343c542de62ee413$var$validators.function,
                serialize: $343c542de62ee413$var$validators.function
            }, true);
        }
        // Set config.allowAbsoluteUrls
        if (config.allowAbsoluteUrls !== undefined) ;
        else if (this.defaults.allowAbsoluteUrls !== undefined) config.allowAbsoluteUrls = this.defaults.allowAbsoluteUrls;
        else config.allowAbsoluteUrls = true;
        (0, $alWME.default).assertOptions(config, {
            baseUrl: $343c542de62ee413$var$validators.spelling("baseURL"),
            withXsrfToken: $343c542de62ee413$var$validators.spelling("withXSRFToken")
        }, true);
        // Set config.method
        config.method = (config.method || this.defaults.method || "get").toLowerCase();
        // Flatten headers
        let contextHeaders = headers && (0, $hjVaC.default).merge(headers.common, headers[config.method]);
        headers && (0, $hjVaC.default).forEach([
            "delete",
            "get",
            "head",
            "post",
            "put",
            "patch",
            "common"
        ], (method)=>{
            delete headers[method];
        });
        config.headers = (0, $aF1JP.default).concat(contextHeaders, headers);
        // filter out skipped interceptors
        const requestInterceptorChain = [];
        let synchronousRequestInterceptors = true;
        this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
            if (typeof interceptor.runWhen === "function" && interceptor.runWhen(config) === false) return;
            synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
            requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
        });
        const responseInterceptorChain = [];
        this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
            responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
        });
        let promise;
        let i = 0;
        let len;
        if (!synchronousRequestInterceptors) {
            const chain = [
                (0, $jx59l.default).bind(this),
                undefined
            ];
            chain.unshift.apply(chain, requestInterceptorChain);
            chain.push.apply(chain, responseInterceptorChain);
            len = chain.length;
            promise = Promise.resolve(config);
            while(i < len)promise = promise.then(chain[i++], chain[i++]);
            return promise;
        }
        len = requestInterceptorChain.length;
        let newConfig = config;
        i = 0;
        while(i < len){
            const onFulfilled = requestInterceptorChain[i++];
            const onRejected = requestInterceptorChain[i++];
            try {
                newConfig = onFulfilled(newConfig);
            } catch (error) {
                onRejected.call(this, error);
                break;
            }
        }
        try {
            promise = (0, $jx59l.default).call(this, newConfig);
        } catch (error) {
            return Promise.reject(error);
        }
        i = 0;
        len = responseInterceptorChain.length;
        while(i < len)promise = promise.then(responseInterceptorChain[i++], responseInterceptorChain[i++]);
        return promise;
    }
    getUri(config) {
        config = (0, $c3v5Q.default)(this.defaults, config);
        const fullPath = (0, $9jhII.default)(config.baseURL, config.url, config.allowAbsoluteUrls);
        return (0, $hHwRb.default)(fullPath, config.params, config.paramsSerializer);
    }
}
// Provide aliases for supported request methods
(0, $hjVaC.default).forEach([
    "delete",
    "get",
    "head",
    "options"
], function forEachMethodNoData(method) {
    /*eslint func-names:0*/ $343c542de62ee413$var$Axios.prototype[method] = function(url, config) {
        return this.request((0, $c3v5Q.default)(config || {}, {
            method: method,
            url: url,
            data: (config || {}).data
        }));
    };
});
(0, $hjVaC.default).forEach([
    "post",
    "put",
    "patch"
], function forEachMethodWithData(method) {
    /*eslint func-names:0*/ function generateHTTPMethod(isForm) {
        return function httpMethod(url, data, config) {
            return this.request((0, $c3v5Q.default)(config || {}, {
                method: method,
                headers: isForm ? {
                    "Content-Type": "multipart/form-data"
                } : {},
                url: url,
                data: data
            }));
        };
    }
    $343c542de62ee413$var$Axios.prototype[method] = generateHTTPMethod();
    $343c542de62ee413$var$Axios.prototype[method + "Form"] = generateHTTPMethod(true);
});
var $343c542de62ee413$export$2e2bcd8739ae039 = $343c542de62ee413$var$Axios;

});
parcelRegister("hHwRb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ce2ff078c5ea3559$export$2e2bcd8739ae039; });

var $hjVaC = parcelRequire("hjVaC");

var $bwjaX = parcelRequire("bwjaX");
"use strict";
/**
 * It replaces all instances of the characters `:`, `$`, `,`, `+`, `[`, and `]` with their
 * URI encoded counterparts
 *
 * @param {string} val The value to be encoded.
 *
 * @returns {string} The encoded value.
 */ function $ce2ff078c5ea3559$var$encode(val) {
    return encodeURIComponent(val).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
function $ce2ff078c5ea3559$export$2e2bcd8739ae039(url, params, options) {
    /*eslint no-param-reassign:0*/ if (!params) return url;
    const _encode = options && options.encode || $ce2ff078c5ea3559$var$encode;
    if ((0, $hjVaC.default).isFunction(options)) options = {
        serialize: options
    };
    const serializeFn = options && options.serialize;
    let serializedParams;
    if (serializeFn) serializedParams = serializeFn(params, options);
    else serializedParams = (0, $hjVaC.default).isURLSearchParams(params) ? params.toString() : new (0, $bwjaX.default)(params, options).toString(_encode);
    if (serializedParams) {
        const hashmarkIndex = url.indexOf("#");
        if (hashmarkIndex !== -1) url = url.slice(0, hashmarkIndex);
        url += (url.indexOf("?") === -1 ? "?" : "&") + serializedParams;
    }
    return url;
}

});
parcelRegister("bwjaX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $86318ec6dee99b23$export$2e2bcd8739ae039; });

var $4VTWW = parcelRequire("4VTWW");
"use strict";
/**
 * It encodes a string by replacing all characters that are not in the unreserved set with
 * their percent-encoded equivalents
 *
 * @param {string} str - The string to encode.
 *
 * @returns {string} The encoded string.
 */ function $86318ec6dee99b23$var$encode(str) {
    const charMap = {
        "!": "%21",
        "'": "%27",
        "(": "%28",
        ")": "%29",
        "~": "%7E",
        "%20": "+",
        "%00": "\0"
    };
    return encodeURIComponent(str).replace(/[!'()~]|%20|%00/g, function replacer(match) {
        return charMap[match];
    });
}
/**
 * It takes a params object and converts it to a FormData object
 *
 * @param {Object<string, any>} params - The parameters to be converted to a FormData object.
 * @param {Object<string, any>} options - The options object passed to the Axios constructor.
 *
 * @returns {void}
 */ function $86318ec6dee99b23$var$AxiosURLSearchParams(params, options) {
    this._pairs = [];
    params && (0, $4VTWW.default)(params, this, options);
}
const $86318ec6dee99b23$var$prototype = $86318ec6dee99b23$var$AxiosURLSearchParams.prototype;
$86318ec6dee99b23$var$prototype.append = function append(name, value) {
    this._pairs.push([
        name,
        value
    ]);
};
$86318ec6dee99b23$var$prototype.toString = function toString(encoder) {
    const _encode = encoder ? function(value) {
        return encoder.call(this, value, $86318ec6dee99b23$var$encode);
    } : $86318ec6dee99b23$var$encode;
    return this._pairs.map(function each(pair) {
        return _encode(pair[0]) + "=" + _encode(pair[1]);
    }, "").join("&");
};
var $86318ec6dee99b23$export$2e2bcd8739ae039 = $86318ec6dee99b23$var$AxiosURLSearchParams;

});
parcelRegister("4VTWW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3977e2bcc9cc5715$export$2e2bcd8739ae039; });

var $hjVaC = parcelRequire("hjVaC");

var $7cviO = parcelRequire("7cviO");

var $5ExyV = parcelRequire("5ExyV");

var $fHYX8 = parcelRequire("fHYX8");
var $3977e2bcc9cc5715$require$Buffer = $fHYX8.Buffer;
"use strict";
/**
 * Determines if the given thing is a array or js object.
 *
 * @param {string} thing - The object or array to be visited.
 *
 * @returns {boolean}
 */ function $3977e2bcc9cc5715$var$isVisitable(thing) {
    return (0, $hjVaC.default).isPlainObject(thing) || (0, $hjVaC.default).isArray(thing);
}
/**
 * It removes the brackets from the end of a string
 *
 * @param {string} key - The key of the parameter.
 *
 * @returns {string} the key without the brackets.
 */ function $3977e2bcc9cc5715$var$removeBrackets(key) {
    return (0, $hjVaC.default).endsWith(key, "[]") ? key.slice(0, -2) : key;
}
/**
 * It takes a path, a key, and a boolean, and returns a string
 *
 * @param {string} path - The path to the current key.
 * @param {string} key - The key of the current object being iterated over.
 * @param {string} dots - If true, the key will be rendered with dots instead of brackets.
 *
 * @returns {string} The path to the current key.
 */ function $3977e2bcc9cc5715$var$renderKey(path, key, dots) {
    if (!path) return key;
    return path.concat(key).map(function each(token, i) {
        // eslint-disable-next-line no-param-reassign
        token = $3977e2bcc9cc5715$var$removeBrackets(token);
        return !dots && i ? "[" + token + "]" : token;
    }).join(dots ? "." : "");
}
/**
 * If the array is an array and none of its elements are visitable, then it's a flat array.
 *
 * @param {Array<any>} arr - The array to check
 *
 * @returns {boolean}
 */ function $3977e2bcc9cc5715$var$isFlatArray(arr) {
    return (0, $hjVaC.default).isArray(arr) && !arr.some($3977e2bcc9cc5715$var$isVisitable);
}
const $3977e2bcc9cc5715$var$predicates = (0, $hjVaC.default).toFlatObject((0, $hjVaC.default), {}, null, function filter(prop) {
    return /^is[A-Z]/.test(prop);
});
/**
 * Convert a data object to FormData
 *
 * @param {Object} obj
 * @param {?Object} [formData]
 * @param {?Object} [options]
 * @param {Function} [options.visitor]
 * @param {Boolean} [options.metaTokens = true]
 * @param {Boolean} [options.dots = false]
 * @param {?Boolean} [options.indexes = false]
 *
 * @returns {Object}
 **/ /**
 * It converts an object into a FormData object
 *
 * @param {Object<any, any>} obj - The object to convert to form data.
 * @param {string} formData - The FormData object to append to.
 * @param {Object<string, any>} options
 *
 * @returns
 */ function $3977e2bcc9cc5715$var$toFormData(obj, formData, options) {
    if (!(0, $hjVaC.default).isObject(obj)) throw new TypeError("target must be an object");
    // eslint-disable-next-line no-param-reassign
    formData = formData || new ((0, $5ExyV.default) || FormData)();
    // eslint-disable-next-line no-param-reassign
    options = (0, $hjVaC.default).toFlatObject(options, {
        metaTokens: true,
        dots: false,
        indexes: false
    }, false, function defined(option, source) {
        // eslint-disable-next-line no-eq-null,eqeqeq
        return !(0, $hjVaC.default).isUndefined(source[option]);
    });
    const metaTokens = options.metaTokens;
    // eslint-disable-next-line no-use-before-define
    const visitor = options.visitor || defaultVisitor;
    const dots = options.dots;
    const indexes = options.indexes;
    const _Blob = options.Blob || typeof Blob !== "undefined" && Blob;
    const useBlob = _Blob && (0, $hjVaC.default).isSpecCompliantForm(formData);
    if (!(0, $hjVaC.default).isFunction(visitor)) throw new TypeError("visitor must be a function");
    function convertValue(value) {
        if (value === null) return "";
        if ((0, $hjVaC.default).isDate(value)) return value.toISOString();
        if (!useBlob && (0, $hjVaC.default).isBlob(value)) throw new (0, $7cviO.default)("Blob is not supported. Use a Buffer instead.");
        if ((0, $hjVaC.default).isArrayBuffer(value) || (0, $hjVaC.default).isTypedArray(value)) return useBlob && typeof Blob === "function" ? new Blob([
            value
        ]) : $3977e2bcc9cc5715$require$Buffer.from(value);
        return value;
    }
    /**
   * Default visitor.
   *
   * @param {*} value
   * @param {String|Number} key
   * @param {Array<String|Number>} path
   * @this {FormData}
   *
   * @returns {boolean} return true to visit the each prop of the value recursively
   */ function defaultVisitor(value, key, path) {
        let arr = value;
        if (value && !path && typeof value === "object") {
            if ((0, $hjVaC.default).endsWith(key, "{}")) {
                // eslint-disable-next-line no-param-reassign
                key = metaTokens ? key : key.slice(0, -2);
                // eslint-disable-next-line no-param-reassign
                value = JSON.stringify(value);
            } else if ((0, $hjVaC.default).isArray(value) && $3977e2bcc9cc5715$var$isFlatArray(value) || ((0, $hjVaC.default).isFileList(value) || (0, $hjVaC.default).endsWith(key, "[]")) && (arr = (0, $hjVaC.default).toArray(value))) {
                // eslint-disable-next-line no-param-reassign
                key = $3977e2bcc9cc5715$var$removeBrackets(key);
                arr.forEach(function each(el, index) {
                    !((0, $hjVaC.default).isUndefined(el) || el === null) && formData.append(// eslint-disable-next-line no-nested-ternary
                    indexes === true ? $3977e2bcc9cc5715$var$renderKey([
                        key
                    ], index, dots) : indexes === null ? key : key + "[]", convertValue(el));
                });
                return false;
            }
        }
        if ($3977e2bcc9cc5715$var$isVisitable(value)) return true;
        formData.append($3977e2bcc9cc5715$var$renderKey(path, key, dots), convertValue(value));
        return false;
    }
    const stack = [];
    const exposedHelpers = Object.assign($3977e2bcc9cc5715$var$predicates, {
        defaultVisitor: defaultVisitor,
        convertValue: convertValue,
        isVisitable: $3977e2bcc9cc5715$var$isVisitable
    });
    function build(value, path) {
        if ((0, $hjVaC.default).isUndefined(value)) return;
        if (stack.indexOf(value) !== -1) throw Error("Circular reference detected in " + path.join("."));
        stack.push(value);
        (0, $hjVaC.default).forEach(value, function each(el, key) {
            const result = !((0, $hjVaC.default).isUndefined(el) || el === null) && visitor.call(formData, el, (0, $hjVaC.default).isString(key) ? key.trim() : key, path, exposedHelpers);
            if (result === true) build(el, path ? path.concat(key) : [
                key
            ]);
        });
        stack.pop();
    }
    if (!(0, $hjVaC.default).isObject(obj)) throw new TypeError("data must be an object");
    build(obj);
    return formData;
}
var $3977e2bcc9cc5715$export$2e2bcd8739ae039 = $3977e2bcc9cc5715$var$toFormData;

});
parcelRegister("7cviO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $53e1ef624d8b03a6$export$2e2bcd8739ae039; });

var $hjVaC = parcelRequire("hjVaC");
"use strict";
/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [config] The config.
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 *
 * @returns {Error} The created error.
 */ function $53e1ef624d8b03a6$var$AxiosError(message, code, config, request, response) {
    Error.call(this);
    if (Error.captureStackTrace) Error.captureStackTrace(this, this.constructor);
    else this.stack = new Error().stack;
    this.message = message;
    this.name = "AxiosError";
    code && (this.code = code);
    config && (this.config = config);
    request && (this.request = request);
    if (response) {
        this.response = response;
        this.status = response.status ? response.status : null;
    }
}
(0, $hjVaC.default).inherits($53e1ef624d8b03a6$var$AxiosError, Error, {
    toJSON: function toJSON() {
        return {
            // Standard
            message: this.message,
            name: this.name,
            // Microsoft
            description: this.description,
            number: this.number,
            // Mozilla
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            // Axios
            config: (0, $hjVaC.default).toJSONObject(this.config),
            code: this.code,
            status: this.status
        };
    }
});
const $53e1ef624d8b03a6$var$prototype = $53e1ef624d8b03a6$var$AxiosError.prototype;
const $53e1ef624d8b03a6$var$descriptors = {};
[
    "ERR_BAD_OPTION_VALUE",
    "ERR_BAD_OPTION",
    "ECONNABORTED",
    "ETIMEDOUT",
    "ERR_NETWORK",
    "ERR_FR_TOO_MANY_REDIRECTS",
    "ERR_DEPRECATED",
    "ERR_BAD_RESPONSE",
    "ERR_BAD_REQUEST",
    "ERR_CANCELED",
    "ERR_NOT_SUPPORT",
    "ERR_INVALID_URL"
].forEach((code)=>{
    $53e1ef624d8b03a6$var$descriptors[code] = {
        value: code
    };
});
Object.defineProperties($53e1ef624d8b03a6$var$AxiosError, $53e1ef624d8b03a6$var$descriptors);
Object.defineProperty($53e1ef624d8b03a6$var$prototype, "isAxiosError", {
    value: true
});
// eslint-disable-next-line func-names
$53e1ef624d8b03a6$var$AxiosError.from = (error, code, config, request, response, customProps)=>{
    const axiosError = Object.create($53e1ef624d8b03a6$var$prototype);
    (0, $hjVaC.default).toFlatObject(error, axiosError, function filter(obj) {
        return obj !== Error.prototype;
    }, (prop)=>{
        return prop !== "isAxiosError";
    });
    $53e1ef624d8b03a6$var$AxiosError.call(axiosError, error.message, code, config, request, response);
    axiosError.cause = error;
    axiosError.name = error.name;
    customProps && Object.assign(axiosError, customProps);
    return axiosError;
};
var $53e1ef624d8b03a6$export$2e2bcd8739ae039 = $53e1ef624d8b03a6$var$AxiosError;

});

parcelRegister("5ExyV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $41dab8efeaa8f6a2$export$2e2bcd8739ae039; });
// eslint-disable-next-line strict
var $41dab8efeaa8f6a2$export$2e2bcd8739ae039 = null;

});

parcelRegister("fHYX8", function(module, exports) {

$parcel$export(module.exports, "Buffer", function () { return $b6fa271c9e403fd9$export$a143d493d941bafc; }, function (v) { return $b6fa271c9e403fd9$export$a143d493d941bafc = v; });
$parcel$export(module.exports, "INSPECT_MAX_BYTES", function () { return $b6fa271c9e403fd9$export$f99ded8fe4b79145; }, function (v) { return $b6fa271c9e403fd9$export$f99ded8fe4b79145 = v; });
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $b6fa271c9e403fd9$export$a143d493d941bafc;
var $b6fa271c9e403fd9$export$e4cf37d7f6fb9e0a;
var $b6fa271c9e403fd9$export$f99ded8fe4b79145;
var $b6fa271c9e403fd9$export$599f31c3813fae4d;
"use strict";

var $5TOYE = parcelRequire("5TOYE");

var $5L225 = parcelRequire("5L225");
var $b6fa271c9e403fd9$var$customInspectSymbol = typeof Symbol === "function" && typeof Symbol["for"] === "function" // eslint-disable-line dot-notation
 ? Symbol["for"]("nodejs.util.inspect.custom") // eslint-disable-line dot-notation
 : null;
$b6fa271c9e403fd9$export$a143d493d941bafc = $b6fa271c9e403fd9$var$Buffer;
$b6fa271c9e403fd9$export$e4cf37d7f6fb9e0a = $b6fa271c9e403fd9$var$SlowBuffer;
$b6fa271c9e403fd9$export$f99ded8fe4b79145 = 50;
var $b6fa271c9e403fd9$var$K_MAX_LENGTH = 0x7fffffff;
$b6fa271c9e403fd9$export$599f31c3813fae4d = $b6fa271c9e403fd9$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $b6fa271c9e403fd9$var$Buffer.TYPED_ARRAY_SUPPORT = $b6fa271c9e403fd9$var$typedArraySupport();
if (!$b6fa271c9e403fd9$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== "undefined" && typeof console.error === "function") console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $b6fa271c9e403fd9$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        var arr = new Uint8Array(1);
        var proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($b6fa271c9e403fd9$var$Buffer.prototype, "parent", {
    enumerable: true,
    get: function() {
        if (!$b6fa271c9e403fd9$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($b6fa271c9e403fd9$var$Buffer.prototype, "offset", {
    enumerable: true,
    get: function() {
        if (!$b6fa271c9e403fd9$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $b6fa271c9e403fd9$var$createBuffer(length) {
    if (length > $b6fa271c9e403fd9$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    var buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $b6fa271c9e403fd9$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $b6fa271c9e403fd9$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === "number") {
        if (typeof encodingOrOffset === "string") throw new TypeError('The "string" argument must be of type string. Received type number');
        return $b6fa271c9e403fd9$var$allocUnsafe(arg);
    }
    return $b6fa271c9e403fd9$var$from(arg, encodingOrOffset, length);
}
$b6fa271c9e403fd9$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $b6fa271c9e403fd9$var$from(value, encodingOrOffset, length) {
    if (typeof value === "string") return $b6fa271c9e403fd9$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $b6fa271c9e403fd9$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($b6fa271c9e403fd9$var$isInstance(value, ArrayBuffer) || value && $b6fa271c9e403fd9$var$isInstance(value.buffer, ArrayBuffer)) return $b6fa271c9e403fd9$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== "undefined" && ($b6fa271c9e403fd9$var$isInstance(value, SharedArrayBuffer) || value && $b6fa271c9e403fd9$var$isInstance(value.buffer, SharedArrayBuffer))) return $b6fa271c9e403fd9$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === "number") throw new TypeError('The "value" argument must not be of type number. Received type number');
    var valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $b6fa271c9e403fd9$var$Buffer.from(valueOf, encodingOrOffset, length);
    var b = $b6fa271c9e403fd9$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== "undefined" && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === "function") return $b6fa271c9e403fd9$var$Buffer.from(value[Symbol.toPrimitive]("string"), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $b6fa271c9e403fd9$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $b6fa271c9e403fd9$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($b6fa271c9e403fd9$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($b6fa271c9e403fd9$var$Buffer, Uint8Array);
function $b6fa271c9e403fd9$var$assertSize(size) {
    if (typeof size !== "number") throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $b6fa271c9e403fd9$var$alloc(size, fill, encoding) {
    $b6fa271c9e403fd9$var$assertSize(size);
    if (size <= 0) return $b6fa271c9e403fd9$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === "string" ? $b6fa271c9e403fd9$var$createBuffer(size).fill(fill, encoding) : $b6fa271c9e403fd9$var$createBuffer(size).fill(fill);
    return $b6fa271c9e403fd9$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $b6fa271c9e403fd9$var$Buffer.alloc = function(size, fill, encoding) {
    return $b6fa271c9e403fd9$var$alloc(size, fill, encoding);
};
function $b6fa271c9e403fd9$var$allocUnsafe(size) {
    $b6fa271c9e403fd9$var$assertSize(size);
    return $b6fa271c9e403fd9$var$createBuffer(size < 0 ? 0 : $b6fa271c9e403fd9$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $b6fa271c9e403fd9$var$Buffer.allocUnsafe = function(size) {
    return $b6fa271c9e403fd9$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $b6fa271c9e403fd9$var$Buffer.allocUnsafeSlow = function(size) {
    return $b6fa271c9e403fd9$var$allocUnsafe(size);
};
function $b6fa271c9e403fd9$var$fromString(string, encoding) {
    if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
    if (!$b6fa271c9e403fd9$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
    var length = $b6fa271c9e403fd9$var$byteLength(string, encoding) | 0;
    var buf = $b6fa271c9e403fd9$var$createBuffer(length);
    var actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $b6fa271c9e403fd9$var$fromArrayLike(array) {
    var length = array.length < 0 ? 0 : $b6fa271c9e403fd9$var$checked(array.length) | 0;
    var buf = $b6fa271c9e403fd9$var$createBuffer(length);
    for(var i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $b6fa271c9e403fd9$var$fromArrayView(arrayView) {
    if ($b6fa271c9e403fd9$var$isInstance(arrayView, Uint8Array)) {
        var copy = new Uint8Array(arrayView);
        return $b6fa271c9e403fd9$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $b6fa271c9e403fd9$var$fromArrayLike(arrayView);
}
function $b6fa271c9e403fd9$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    var buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $b6fa271c9e403fd9$var$Buffer.prototype);
    return buf;
}
function $b6fa271c9e403fd9$var$fromObject(obj) {
    if ($b6fa271c9e403fd9$var$Buffer.isBuffer(obj)) {
        var len = $b6fa271c9e403fd9$var$checked(obj.length) | 0;
        var buf = $b6fa271c9e403fd9$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== "number" || $b6fa271c9e403fd9$var$numberIsNaN(obj.length)) return $b6fa271c9e403fd9$var$createBuffer(0);
        return $b6fa271c9e403fd9$var$fromArrayLike(obj);
    }
    if (obj.type === "Buffer" && Array.isArray(obj.data)) return $b6fa271c9e403fd9$var$fromArrayLike(obj.data);
}
function $b6fa271c9e403fd9$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $b6fa271c9e403fd9$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $b6fa271c9e403fd9$var$K_MAX_LENGTH.toString(16) + " bytes");
    return length | 0;
}
function $b6fa271c9e403fd9$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $b6fa271c9e403fd9$var$Buffer.alloc(+length);
}
$b6fa271c9e403fd9$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $b6fa271c9e403fd9$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$b6fa271c9e403fd9$var$Buffer.compare = function compare(a, b) {
    if ($b6fa271c9e403fd9$var$isInstance(a, Uint8Array)) a = $b6fa271c9e403fd9$var$Buffer.from(a, a.offset, a.byteLength);
    if ($b6fa271c9e403fd9$var$isInstance(b, Uint8Array)) b = $b6fa271c9e403fd9$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$b6fa271c9e403fd9$var$Buffer.isBuffer(a) || !$b6fa271c9e403fd9$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$b6fa271c9e403fd9$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return true;
        default:
            return false;
    }
};
$b6fa271c9e403fd9$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $b6fa271c9e403fd9$var$Buffer.alloc(0);
    var i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    var buffer = $b6fa271c9e403fd9$var$Buffer.allocUnsafe(length);
    var pos = 0;
    for(i = 0; i < list.length; ++i){
        var buf = list[i];
        if ($b6fa271c9e403fd9$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) $b6fa271c9e403fd9$var$Buffer.from(buf).copy(buffer, pos);
            else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$b6fa271c9e403fd9$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $b6fa271c9e403fd9$var$byteLength(string, encoding) {
    if ($b6fa271c9e403fd9$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $b6fa271c9e403fd9$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== "string") throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    var len = string.length;
    var mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    var loweredCase = false;
    for(;;)switch(encoding){
        case "ascii":
        case "latin1":
        case "binary":
            return len;
        case "utf8":
        case "utf-8":
            return $b6fa271c9e403fd9$var$utf8ToBytes(string).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return len * 2;
        case "hex":
            return len >>> 1;
        case "base64":
            return $b6fa271c9e403fd9$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $b6fa271c9e403fd9$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
}
$b6fa271c9e403fd9$var$Buffer.byteLength = $b6fa271c9e403fd9$var$byteLength;
function $b6fa271c9e403fd9$var$slowToString(encoding, start, end) {
    var loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return "";
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return "";
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return "";
    if (!encoding) encoding = "utf8";
    while(true)switch(encoding){
        case "hex":
            return $b6fa271c9e403fd9$var$hexSlice(this, start, end);
        case "utf8":
        case "utf-8":
            return $b6fa271c9e403fd9$var$utf8Slice(this, start, end);
        case "ascii":
            return $b6fa271c9e403fd9$var$asciiSlice(this, start, end);
        case "latin1":
        case "binary":
            return $b6fa271c9e403fd9$var$latin1Slice(this, start, end);
        case "base64":
            return $b6fa271c9e403fd9$var$base64Slice(this, start, end);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $b6fa271c9e403fd9$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = (encoding + "").toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$b6fa271c9e403fd9$var$Buffer.prototype._isBuffer = true;
function $b6fa271c9e403fd9$var$swap(b, n, m) {
    var i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$b6fa271c9e403fd9$var$Buffer.prototype.swap16 = function swap16() {
    var len = this.length;
    if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
    for(var i = 0; i < len; i += 2)$b6fa271c9e403fd9$var$swap(this, i, i + 1);
    return this;
};
$b6fa271c9e403fd9$var$Buffer.prototype.swap32 = function swap32() {
    var len = this.length;
    if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
    for(var i = 0; i < len; i += 4){
        $b6fa271c9e403fd9$var$swap(this, i, i + 3);
        $b6fa271c9e403fd9$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$b6fa271c9e403fd9$var$Buffer.prototype.swap64 = function swap64() {
    var len = this.length;
    if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
    for(var i = 0; i < len; i += 8){
        $b6fa271c9e403fd9$var$swap(this, i, i + 7);
        $b6fa271c9e403fd9$var$swap(this, i + 1, i + 6);
        $b6fa271c9e403fd9$var$swap(this, i + 2, i + 5);
        $b6fa271c9e403fd9$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$b6fa271c9e403fd9$var$Buffer.prototype.toString = function toString() {
    var length = this.length;
    if (length === 0) return "";
    if (arguments.length === 0) return $b6fa271c9e403fd9$var$utf8Slice(this, 0, length);
    return $b6fa271c9e403fd9$var$slowToString.apply(this, arguments);
};
$b6fa271c9e403fd9$var$Buffer.prototype.toLocaleString = $b6fa271c9e403fd9$var$Buffer.prototype.toString;
$b6fa271c9e403fd9$var$Buffer.prototype.equals = function equals(b) {
    if (!$b6fa271c9e403fd9$var$Buffer.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
    if (this === b) return true;
    return $b6fa271c9e403fd9$var$Buffer.compare(this, b) === 0;
};
$b6fa271c9e403fd9$var$Buffer.prototype.inspect = function inspect() {
    var str = "";
    var max = $b6fa271c9e403fd9$export$f99ded8fe4b79145;
    str = this.toString("hex", 0, max).replace(/(.{2})/g, "$1 ").trim();
    if (this.length > max) str += " ... ";
    return "<Buffer " + str + ">";
};
if ($b6fa271c9e403fd9$var$customInspectSymbol) $b6fa271c9e403fd9$var$Buffer.prototype[$b6fa271c9e403fd9$var$customInspectSymbol] = $b6fa271c9e403fd9$var$Buffer.prototype.inspect;
$b6fa271c9e403fd9$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($b6fa271c9e403fd9$var$isInstance(target, Uint8Array)) target = $b6fa271c9e403fd9$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$b6fa271c9e403fd9$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    var x = thisEnd - thisStart;
    var y = end - start;
    var len = Math.min(x, y);
    var thisCopy = this.slice(thisStart, thisEnd);
    var targetCopy = target.slice(start, end);
    for(var i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $b6fa271c9e403fd9$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === "string") {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($b6fa271c9e403fd9$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === "string") val = $b6fa271c9e403fd9$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($b6fa271c9e403fd9$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $b6fa271c9e403fd9$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === "number") {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === "function") {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $b6fa271c9e403fd9$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError("val must be string, number or Buffer");
}
function $b6fa271c9e403fd9$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    var indexSize = 1;
    var arrLength = arr.length;
    var valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    var i;
    if (dir) {
        var foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            var found = true;
            for(var j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$b6fa271c9e403fd9$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$b6fa271c9e403fd9$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $b6fa271c9e403fd9$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$b6fa271c9e403fd9$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $b6fa271c9e403fd9$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $b6fa271c9e403fd9$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    var remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    var strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    for(var i = 0; i < length; ++i){
        var parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($b6fa271c9e403fd9$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $b6fa271c9e403fd9$var$utf8Write(buf, string, offset, length) {
    return $b6fa271c9e403fd9$var$blitBuffer($b6fa271c9e403fd9$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $b6fa271c9e403fd9$var$asciiWrite(buf, string, offset, length) {
    return $b6fa271c9e403fd9$var$blitBuffer($b6fa271c9e403fd9$var$asciiToBytes(string), buf, offset, length);
}
function $b6fa271c9e403fd9$var$base64Write(buf, string, offset, length) {
    return $b6fa271c9e403fd9$var$blitBuffer($b6fa271c9e403fd9$var$base64ToBytes(string), buf, offset, length);
}
function $b6fa271c9e403fd9$var$ucs2Write(buf, string, offset, length) {
    return $b6fa271c9e403fd9$var$blitBuffer($b6fa271c9e403fd9$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$b6fa271c9e403fd9$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = "utf8";
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === "string") {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = "utf8";
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    var remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
    if (!encoding) encoding = "utf8";
    var loweredCase = false;
    for(;;)switch(encoding){
        case "hex":
            return $b6fa271c9e403fd9$var$hexWrite(this, string, offset, length);
        case "utf8":
        case "utf-8":
            return $b6fa271c9e403fd9$var$utf8Write(this, string, offset, length);
        case "ascii":
        case "latin1":
        case "binary":
            return $b6fa271c9e403fd9$var$asciiWrite(this, string, offset, length);
        case "base64":
            // Warning: maxLength not taken into account in base64Write
            return $b6fa271c9e403fd9$var$base64Write(this, string, offset, length);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $b6fa271c9e403fd9$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
};
$b6fa271c9e403fd9$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $b6fa271c9e403fd9$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $5TOYE.fromByteArray(buf);
    else return $5TOYE.fromByteArray(buf.slice(start, end));
}
function $b6fa271c9e403fd9$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    var res = [];
    var i = start;
    while(i < end){
        var firstByte = buf[i];
        var codePoint = null;
        var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            var secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $b6fa271c9e403fd9$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var $b6fa271c9e403fd9$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $b6fa271c9e403fd9$var$decodeCodePointsArray(codePoints) {
    var len = codePoints.length;
    if (len <= $b6fa271c9e403fd9$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    var res = "";
    var i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $b6fa271c9e403fd9$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $b6fa271c9e403fd9$var$asciiSlice(buf, start, end) {
    var ret = "";
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $b6fa271c9e403fd9$var$latin1Slice(buf, start, end) {
    var ret = "";
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $b6fa271c9e403fd9$var$hexSlice(buf, start, end) {
    var len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    var out = "";
    for(var i = start; i < end; ++i)out += $b6fa271c9e403fd9$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $b6fa271c9e403fd9$var$utf16leSlice(buf, start, end) {
    var bytes = buf.slice(start, end);
    var res = "";
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(var i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$b6fa271c9e403fd9$var$Buffer.prototype.slice = function slice(start, end) {
    var len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    var newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $b6fa271c9e403fd9$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $b6fa271c9e403fd9$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
    if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
}
$b6fa271c9e403fd9$var$Buffer.prototype.readUintLE = $b6fa271c9e403fd9$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $b6fa271c9e403fd9$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$b6fa271c9e403fd9$var$Buffer.prototype.readUintBE = $b6fa271c9e403fd9$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $b6fa271c9e403fd9$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset + --byteLength];
    var mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$b6fa271c9e403fd9$var$Buffer.prototype.readUint8 = $b6fa271c9e403fd9$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $b6fa271c9e403fd9$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$b6fa271c9e403fd9$var$Buffer.prototype.readUint16LE = $b6fa271c9e403fd9$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $b6fa271c9e403fd9$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$b6fa271c9e403fd9$var$Buffer.prototype.readUint16BE = $b6fa271c9e403fd9$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $b6fa271c9e403fd9$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$b6fa271c9e403fd9$var$Buffer.prototype.readUint32LE = $b6fa271c9e403fd9$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $b6fa271c9e403fd9$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$b6fa271c9e403fd9$var$Buffer.prototype.readUint32BE = $b6fa271c9e403fd9$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $b6fa271c9e403fd9$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$b6fa271c9e403fd9$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $b6fa271c9e403fd9$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$b6fa271c9e403fd9$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $b6fa271c9e403fd9$var$checkOffset(offset, byteLength, this.length);
    var i = byteLength;
    var mul = 1;
    var val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$b6fa271c9e403fd9$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $b6fa271c9e403fd9$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$b6fa271c9e403fd9$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $b6fa271c9e403fd9$var$checkOffset(offset, 2, this.length);
    var val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$b6fa271c9e403fd9$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $b6fa271c9e403fd9$var$checkOffset(offset, 2, this.length);
    var val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$b6fa271c9e403fd9$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $b6fa271c9e403fd9$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$b6fa271c9e403fd9$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $b6fa271c9e403fd9$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$b6fa271c9e403fd9$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $b6fa271c9e403fd9$var$checkOffset(offset, 4, this.length);
    return $5L225.read(this, offset, true, 23, 4);
};
$b6fa271c9e403fd9$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $b6fa271c9e403fd9$var$checkOffset(offset, 4, this.length);
    return $5L225.read(this, offset, false, 23, 4);
};
$b6fa271c9e403fd9$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $b6fa271c9e403fd9$var$checkOffset(offset, 8, this.length);
    return $5L225.read(this, offset, true, 52, 8);
};
$b6fa271c9e403fd9$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $b6fa271c9e403fd9$var$checkOffset(offset, 8, this.length);
    return $5L225.read(this, offset, false, 52, 8);
};
function $b6fa271c9e403fd9$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$b6fa271c9e403fd9$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
}
$b6fa271c9e403fd9$var$Buffer.prototype.writeUintLE = $b6fa271c9e403fd9$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $b6fa271c9e403fd9$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var mul = 1;
    var i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$b6fa271c9e403fd9$var$Buffer.prototype.writeUintBE = $b6fa271c9e403fd9$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $b6fa271c9e403fd9$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var i = byteLength - 1;
    var mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$b6fa271c9e403fd9$var$Buffer.prototype.writeUint8 = $b6fa271c9e403fd9$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $b6fa271c9e403fd9$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$b6fa271c9e403fd9$var$Buffer.prototype.writeUint16LE = $b6fa271c9e403fd9$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $b6fa271c9e403fd9$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$b6fa271c9e403fd9$var$Buffer.prototype.writeUint16BE = $b6fa271c9e403fd9$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $b6fa271c9e403fd9$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$b6fa271c9e403fd9$var$Buffer.prototype.writeUint32LE = $b6fa271c9e403fd9$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $b6fa271c9e403fd9$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$b6fa271c9e403fd9$var$Buffer.prototype.writeUint32BE = $b6fa271c9e403fd9$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $b6fa271c9e403fd9$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$b6fa271c9e403fd9$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $b6fa271c9e403fd9$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = 0;
    var mul = 1;
    var sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$b6fa271c9e403fd9$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $b6fa271c9e403fd9$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = byteLength - 1;
    var mul = 1;
    var sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$b6fa271c9e403fd9$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $b6fa271c9e403fd9$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$b6fa271c9e403fd9$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $b6fa271c9e403fd9$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$b6fa271c9e403fd9$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $b6fa271c9e403fd9$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$b6fa271c9e403fd9$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $b6fa271c9e403fd9$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$b6fa271c9e403fd9$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $b6fa271c9e403fd9$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $b6fa271c9e403fd9$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
    if (offset < 0) throw new RangeError("Index out of range");
}
function $b6fa271c9e403fd9$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $b6fa271c9e403fd9$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $5L225.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$b6fa271c9e403fd9$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $b6fa271c9e403fd9$var$writeFloat(this, value, offset, true, noAssert);
};
$b6fa271c9e403fd9$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $b6fa271c9e403fd9$var$writeFloat(this, value, offset, false, noAssert);
};
function $b6fa271c9e403fd9$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $b6fa271c9e403fd9$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $5L225.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$b6fa271c9e403fd9$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $b6fa271c9e403fd9$var$writeDouble(this, value, offset, true, noAssert);
};
$b6fa271c9e403fd9$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $b6fa271c9e403fd9$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$b6fa271c9e403fd9$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$b6fa271c9e403fd9$var$Buffer.isBuffer(target)) throw new TypeError("argument should be a Buffer");
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError("targetStart out of bounds");
    if (start < 0 || start >= this.length) throw new RangeError("Index out of range");
    if (end < 0) throw new RangeError("sourceEnd out of bounds");
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    var len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === "function") // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$b6fa271c9e403fd9$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === "string") {
        if (typeof start === "string") {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === "string") {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== "string") throw new TypeError("encoding must be a string");
        if (typeof encoding === "string" && !$b6fa271c9e403fd9$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
        if (val.length === 1) {
            var code = val.charCodeAt(0);
            if (encoding === "utf8" && code < 128 || encoding === "latin1") // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === "number") val = val & 255;
    else if (typeof val === "boolean") val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    var i;
    if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
    else {
        var bytes = $b6fa271c9e403fd9$var$Buffer.isBuffer(val) ? val : $b6fa271c9e403fd9$var$Buffer.from(val, encoding);
        var len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// HELPER FUNCTIONS
// ================
var $b6fa271c9e403fd9$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $b6fa271c9e403fd9$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split("=")[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($b6fa271c9e403fd9$var$INVALID_BASE64_RE, "");
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return "";
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + "=";
    return str;
}
function $b6fa271c9e403fd9$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    var codePoint;
    var length = string.length;
    var leadSurrogate = null;
    var bytes = [];
    for(var i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error("Invalid code point");
    }
    return bytes;
}
function $b6fa271c9e403fd9$var$asciiToBytes(str) {
    var byteArray = [];
    for(var i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $b6fa271c9e403fd9$var$utf16leToBytes(str, units) {
    var c, hi, lo;
    var byteArray = [];
    for(var i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $b6fa271c9e403fd9$var$base64ToBytes(str) {
    return $5TOYE.toByteArray($b6fa271c9e403fd9$var$base64clean(str));
}
function $b6fa271c9e403fd9$var$blitBuffer(src, dst, offset, length) {
    for(var i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $b6fa271c9e403fd9$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $b6fa271c9e403fd9$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
var $b6fa271c9e403fd9$var$hexSliceLookupTable = function() {
    var alphabet = "0123456789abcdef";
    var table = new Array(256);
    for(var i = 0; i < 16; ++i){
        var i16 = i * 16;
        for(var j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();

});
parcelRegister("5TOYE", function(module, exports) {

$parcel$export(module.exports, "toByteArray", function () { return $44b9a1cf7f998b29$export$d622b2ad8d90c771; }, function (v) { return $44b9a1cf7f998b29$export$d622b2ad8d90c771 = v; });
$parcel$export(module.exports, "fromByteArray", function () { return $44b9a1cf7f998b29$export$6100ba28696e12de; }, function (v) { return $44b9a1cf7f998b29$export$6100ba28696e12de = v; });
var $44b9a1cf7f998b29$export$a48f0734ac7c2329;
var $44b9a1cf7f998b29$export$d622b2ad8d90c771;
var $44b9a1cf7f998b29$export$6100ba28696e12de;
"use strict";
$44b9a1cf7f998b29$export$a48f0734ac7c2329 = $44b9a1cf7f998b29$var$byteLength;
$44b9a1cf7f998b29$export$d622b2ad8d90c771 = $44b9a1cf7f998b29$var$toByteArray;
$44b9a1cf7f998b29$export$6100ba28696e12de = $44b9a1cf7f998b29$var$fromByteArray;
var $44b9a1cf7f998b29$var$lookup = [];
var $44b9a1cf7f998b29$var$revLookup = [];
var $44b9a1cf7f998b29$var$Arr = typeof Uint8Array !== "undefined" ? Uint8Array : Array;
var $44b9a1cf7f998b29$var$code = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for(var $44b9a1cf7f998b29$var$i = 0, $44b9a1cf7f998b29$var$len = $44b9a1cf7f998b29$var$code.length; $44b9a1cf7f998b29$var$i < $44b9a1cf7f998b29$var$len; ++$44b9a1cf7f998b29$var$i){
    $44b9a1cf7f998b29$var$lookup[$44b9a1cf7f998b29$var$i] = $44b9a1cf7f998b29$var$code[$44b9a1cf7f998b29$var$i];
    $44b9a1cf7f998b29$var$revLookup[$44b9a1cf7f998b29$var$code.charCodeAt($44b9a1cf7f998b29$var$i)] = $44b9a1cf7f998b29$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$44b9a1cf7f998b29$var$revLookup["-".charCodeAt(0)] = 62;
$44b9a1cf7f998b29$var$revLookup["_".charCodeAt(0)] = 63;
function $44b9a1cf7f998b29$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf("=");
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $44b9a1cf7f998b29$var$byteLength(b64) {
    var lens = $44b9a1cf7f998b29$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $44b9a1cf7f998b29$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $44b9a1cf7f998b29$var$toByteArray(b64) {
    var tmp;
    var lens = $44b9a1cf7f998b29$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $44b9a1cf7f998b29$var$Arr($44b9a1cf7f998b29$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $44b9a1cf7f998b29$var$revLookup[b64.charCodeAt(i)] << 18 | $44b9a1cf7f998b29$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $44b9a1cf7f998b29$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $44b9a1cf7f998b29$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $44b9a1cf7f998b29$var$revLookup[b64.charCodeAt(i)] << 2 | $44b9a1cf7f998b29$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $44b9a1cf7f998b29$var$revLookup[b64.charCodeAt(i)] << 10 | $44b9a1cf7f998b29$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $44b9a1cf7f998b29$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $44b9a1cf7f998b29$var$tripletToBase64(num) {
    return $44b9a1cf7f998b29$var$lookup[num >> 18 & 0x3F] + $44b9a1cf7f998b29$var$lookup[num >> 12 & 0x3F] + $44b9a1cf7f998b29$var$lookup[num >> 6 & 0x3F] + $44b9a1cf7f998b29$var$lookup[num & 0x3F];
}
function $44b9a1cf7f998b29$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($44b9a1cf7f998b29$var$tripletToBase64(tmp));
    }
    return output.join("");
}
function $44b9a1cf7f998b29$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($44b9a1cf7f998b29$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($44b9a1cf7f998b29$var$lookup[tmp >> 2] + $44b9a1cf7f998b29$var$lookup[tmp << 4 & 0x3F] + "==");
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($44b9a1cf7f998b29$var$lookup[tmp >> 10] + $44b9a1cf7f998b29$var$lookup[tmp >> 4 & 0x3F] + $44b9a1cf7f998b29$var$lookup[tmp << 2 & 0x3F] + "=");
    }
    return parts.join("");
}

});

parcelRegister("5L225", function(module, exports) {

$parcel$export(module.exports, "read", function () { return $4312eb34400b2bbc$export$aafa59e2e03f2942; }, function (v) { return $4312eb34400b2bbc$export$aafa59e2e03f2942 = v; });
$parcel$export(module.exports, "write", function () { return $4312eb34400b2bbc$export$68d8715fc104d294; }, function (v) { return $4312eb34400b2bbc$export$68d8715fc104d294 = v; });
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $4312eb34400b2bbc$export$aafa59e2e03f2942;
var $4312eb34400b2bbc$export$68d8715fc104d294;
$4312eb34400b2bbc$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$4312eb34400b2bbc$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});





parcelRegister("2ByHk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1e59f3c0c8363186$export$2e2bcd8739ae039; });

var $hjVaC = parcelRequire("hjVaC");
"use strict";
class $1e59f3c0c8363186$var$InterceptorManager {
    constructor(){
        this.handlers = [];
    }
    /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */ use(fulfilled, rejected, options) {
        this.handlers.push({
            fulfilled: fulfilled,
            rejected: rejected,
            synchronous: options ? options.synchronous : false,
            runWhen: options ? options.runWhen : null
        });
        return this.handlers.length - 1;
    }
    /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */ eject(id) {
        if (this.handlers[id]) this.handlers[id] = null;
    }
    /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */ clear() {
        if (this.handlers) this.handlers = [];
    }
    /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */ forEach(fn) {
        (0, $hjVaC.default).forEach(this.handlers, function forEachHandler(h) {
            if (h !== null) fn(h);
        });
    }
}
var $1e59f3c0c8363186$export$2e2bcd8739ae039 = $1e59f3c0c8363186$var$InterceptorManager;

});

parcelRegister("jx59l", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e3851804877a6f84$export$2e2bcd8739ae039; });

var $4UoCm = parcelRequire("4UoCm");

var $eAWn0 = parcelRequire("eAWn0");

var $ia3kZ = parcelRequire("ia3kZ");

var $kk27X = parcelRequire("kk27X");

var $aF1JP = parcelRequire("aF1JP");

var $5wGMX = parcelRequire("5wGMX");
"use strict";
/**
 * Throws a `CanceledError` if cancellation has been requested.
 *
 * @param {Object} config The config that is to be used for the request
 *
 * @returns {void}
 */ function $e3851804877a6f84$var$throwIfCancellationRequested(config) {
    if (config.cancelToken) config.cancelToken.throwIfRequested();
    if (config.signal && config.signal.aborted) throw new (0, $kk27X.default)(null, config);
}
function $e3851804877a6f84$export$2e2bcd8739ae039(config) {
    $e3851804877a6f84$var$throwIfCancellationRequested(config);
    config.headers = (0, $aF1JP.default).from(config.headers);
    // Transform request data
    config.data = (0, $4UoCm.default).call(config, config.transformRequest);
    if ([
        "post",
        "put",
        "patch"
    ].indexOf(config.method) !== -1) config.headers.setContentType("application/x-www-form-urlencoded", false);
    const adapter = (0, $5wGMX.default).getAdapter(config.adapter || (0, $ia3kZ.default).adapter);
    return adapter(config).then(function onAdapterResolution(response) {
        $e3851804877a6f84$var$throwIfCancellationRequested(config);
        // Transform response data
        response.data = (0, $4UoCm.default).call(config, config.transformResponse, response);
        response.headers = (0, $aF1JP.default).from(response.headers);
        return response;
    }, function onAdapterRejection(reason) {
        if (!(0, $eAWn0.default)(reason)) {
            $e3851804877a6f84$var$throwIfCancellationRequested(config);
            // Transform response data
            if (reason && reason.response) {
                reason.response.data = (0, $4UoCm.default).call(config, config.transformResponse, reason.response);
                reason.response.headers = (0, $aF1JP.default).from(reason.response.headers);
            }
        }
        return Promise.reject(reason);
    });
}

});
parcelRegister("4UoCm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $392f7cfa58094df9$export$2e2bcd8739ae039; });

var $hjVaC = parcelRequire("hjVaC");

var $ia3kZ = parcelRequire("ia3kZ");

var $aF1JP = parcelRequire("aF1JP");
"use strict";
function $392f7cfa58094df9$export$2e2bcd8739ae039(fns, response) {
    const config = this || (0, $ia3kZ.default);
    const context = response || config;
    const headers = (0, $aF1JP.default).from(context.headers);
    let data = context.data;
    (0, $hjVaC.default).forEach(fns, function transform(fn) {
        data = fn.call(config, data, headers.normalize(), response ? response.status : undefined);
    });
    headers.normalize();
    return data;
}

});
parcelRegister("ia3kZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d38bbfe918ea8264$export$2e2bcd8739ae039; });

var $hjVaC = parcelRequire("hjVaC");

var $7cviO = parcelRequire("7cviO");

var $7TD1f = parcelRequire("7TD1f");

var $4VTWW = parcelRequire("4VTWW");

var $3vro6 = parcelRequire("3vro6");

var $8t7aE = parcelRequire("8t7aE");

var $bPTby = parcelRequire("bPTby");
"use strict";
/**
 * It takes a string, tries to parse it, and if it fails, it returns the stringified version
 * of the input
 *
 * @param {any} rawValue - The value to be stringified.
 * @param {Function} parser - A function that parses a string into a JavaScript object.
 * @param {Function} encoder - A function that takes a value and returns a string.
 *
 * @returns {string} A stringified version of the rawValue.
 */ function $d38bbfe918ea8264$var$stringifySafely(rawValue, parser, encoder) {
    if ((0, $hjVaC.default).isString(rawValue)) try {
        (parser || JSON.parse)(rawValue);
        return (0, $hjVaC.default).trim(rawValue);
    } catch (e) {
        if (e.name !== "SyntaxError") throw e;
    }
    return (encoder || JSON.stringify)(rawValue);
}
const $d38bbfe918ea8264$var$defaults = {
    transitional: (0, $7TD1f.default),
    adapter: [
        "xhr",
        "http",
        "fetch"
    ],
    transformRequest: [
        function transformRequest(data, headers) {
            const contentType = headers.getContentType() || "";
            const hasJSONContentType = contentType.indexOf("application/json") > -1;
            const isObjectPayload = (0, $hjVaC.default).isObject(data);
            if (isObjectPayload && (0, $hjVaC.default).isHTMLForm(data)) data = new FormData(data);
            const isFormData = (0, $hjVaC.default).isFormData(data);
            if (isFormData) return hasJSONContentType ? JSON.stringify((0, $bPTby.default)(data)) : data;
            if ((0, $hjVaC.default).isArrayBuffer(data) || (0, $hjVaC.default).isBuffer(data) || (0, $hjVaC.default).isStream(data) || (0, $hjVaC.default).isFile(data) || (0, $hjVaC.default).isBlob(data) || (0, $hjVaC.default).isReadableStream(data)) return data;
            if ((0, $hjVaC.default).isArrayBufferView(data)) return data.buffer;
            if ((0, $hjVaC.default).isURLSearchParams(data)) {
                headers.setContentType("application/x-www-form-urlencoded;charset=utf-8", false);
                return data.toString();
            }
            let isFileList;
            if (isObjectPayload) {
                if (contentType.indexOf("application/x-www-form-urlencoded") > -1) return (0, $3vro6.default)(data, this.formSerializer).toString();
                if ((isFileList = (0, $hjVaC.default).isFileList(data)) || contentType.indexOf("multipart/form-data") > -1) {
                    const _FormData = this.env && this.env.FormData;
                    return (0, $4VTWW.default)(isFileList ? {
                        "files[]": data
                    } : data, _FormData && new _FormData(), this.formSerializer);
                }
            }
            if (isObjectPayload || hasJSONContentType) {
                headers.setContentType("application/json", false);
                return $d38bbfe918ea8264$var$stringifySafely(data);
            }
            return data;
        }
    ],
    transformResponse: [
        function transformResponse(data) {
            const transitional = this.transitional || $d38bbfe918ea8264$var$defaults.transitional;
            const forcedJSONParsing = transitional && transitional.forcedJSONParsing;
            const JSONRequested = this.responseType === "json";
            if ((0, $hjVaC.default).isResponse(data) || (0, $hjVaC.default).isReadableStream(data)) return data;
            if (data && (0, $hjVaC.default).isString(data) && (forcedJSONParsing && !this.responseType || JSONRequested)) {
                const silentJSONParsing = transitional && transitional.silentJSONParsing;
                const strictJSONParsing = !silentJSONParsing && JSONRequested;
                try {
                    return JSON.parse(data);
                } catch (e) {
                    if (strictJSONParsing) {
                        if (e.name === "SyntaxError") throw (0, $7cviO.default).from(e, (0, $7cviO.default).ERR_BAD_RESPONSE, this, null, this.response);
                        throw e;
                    }
                }
            }
            return data;
        }
    ],
    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
    xsrfCookieName: "XSRF-TOKEN",
    xsrfHeaderName: "X-XSRF-TOKEN",
    maxContentLength: -1,
    maxBodyLength: -1,
    env: {
        FormData: (0, $8t7aE.default).classes.FormData,
        Blob: (0, $8t7aE.default).classes.Blob
    },
    validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
    },
    headers: {
        common: {
            "Accept": "application/json, text/plain, */*",
            "Content-Type": undefined
        }
    }
};
(0, $hjVaC.default).forEach([
    "delete",
    "get",
    "head",
    "post",
    "put",
    "patch"
], (method)=>{
    $d38bbfe918ea8264$var$defaults.headers[method] = {};
});
var $d38bbfe918ea8264$export$2e2bcd8739ae039 = $d38bbfe918ea8264$var$defaults;

});
parcelRegister("7TD1f", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5bfbefd59673c044$export$2e2bcd8739ae039; });
"use strict";
var $5bfbefd59673c044$export$2e2bcd8739ae039 = {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false
};

});

parcelRegister("3vro6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $28d982ff2f15eda2$export$2e2bcd8739ae039; });

var $hjVaC = parcelRequire("hjVaC");

var $4VTWW = parcelRequire("4VTWW");

var $8t7aE = parcelRequire("8t7aE");
"use strict";
function $28d982ff2f15eda2$export$2e2bcd8739ae039(data, options) {
    return (0, $4VTWW.default)(data, new (0, $8t7aE.default).classes.URLSearchParams(), Object.assign({
        visitor: function(value, key, path, helpers) {
            if ((0, $8t7aE.default).isNode && (0, $hjVaC.default).isBuffer(value)) {
                this.append(key, value.toString("base64"));
                return false;
            }
            return helpers.defaultVisitor.apply(this, arguments);
        }
    }, options));
}

});
parcelRegister("8t7aE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $62a69823bc749177$export$2e2bcd8739ae039; });

var $lBSXU = parcelRequire("lBSXU");

var $e9bsx = parcelRequire("e9bsx");
var $62a69823bc749177$export$2e2bcd8739ae039 = {
    ...$e9bsx,
    ...(0, $lBSXU.default)
};

});
parcelRegister("lBSXU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fbb7b09e417318cf$export$2e2bcd8739ae039; });

var $bG1Tl = parcelRequire("bG1Tl");

var $dH8wt = parcelRequire("dH8wt");

var $kU4BX = parcelRequire("kU4BX");
var $fbb7b09e417318cf$export$2e2bcd8739ae039 = {
    isBrowser: true,
    classes: {
        URLSearchParams: $bG1Tl.default,
        FormData: $dH8wt.default,
        Blob: $kU4BX.default
    },
    protocols: [
        "http",
        "https",
        "file",
        "blob",
        "url",
        "data"
    ]
};

});
parcelRegister("bG1Tl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8805159e9cec1e83$export$2e2bcd8739ae039; });

var $bwjaX = parcelRequire("bwjaX");
"use strict";
var $8805159e9cec1e83$export$2e2bcd8739ae039 = typeof URLSearchParams !== "undefined" ? URLSearchParams : (0, $bwjaX.default);

});

parcelRegister("dH8wt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9f85e6f07eabf1b5$export$2e2bcd8739ae039; });
"use strict";
var $9f85e6f07eabf1b5$export$2e2bcd8739ae039 = typeof FormData !== "undefined" ? FormData : null;

});

parcelRegister("kU4BX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f37c9d51645be16f$export$2e2bcd8739ae039; });
"use strict";
var $f37c9d51645be16f$export$2e2bcd8739ae039 = typeof Blob !== "undefined" ? Blob : null;

});


parcelRegister("e9bsx", function(module, exports) {

$parcel$export(module.exports, "hasBrowserEnv", function () { return $a4cacb8c6615c025$export$c4996c4b7b93b0bf; });
$parcel$export(module.exports, "navigator", function () { return $a4cacb8c6615c025$export$ec7c8efa7f5790ae; });
$parcel$export(module.exports, "hasStandardBrowserEnv", function () { return $a4cacb8c6615c025$export$c0bcc9250309d66; });
$parcel$export(module.exports, "hasStandardBrowserWebWorkerEnv", function () { return $a4cacb8c6615c025$export$c81692cf5af97dac; });
$parcel$export(module.exports, "origin", function () { return $a4cacb8c6615c025$export$f710a83a91838a36; });
const $a4cacb8c6615c025$export$c4996c4b7b93b0bf = typeof window !== "undefined" && typeof document !== "undefined";
const $a4cacb8c6615c025$export$ec7c8efa7f5790ae = typeof navigator === "object" && navigator || undefined;
/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 *
 * @returns {boolean}
 */ const $a4cacb8c6615c025$export$c0bcc9250309d66 = $a4cacb8c6615c025$export$c4996c4b7b93b0bf && (!$a4cacb8c6615c025$export$ec7c8efa7f5790ae || [
    "ReactNative",
    "NativeScript",
    "NS"
].indexOf($a4cacb8c6615c025$export$ec7c8efa7f5790ae.product) < 0);
/**
 * Determine if we're running in a standard browser webWorker environment
 *
 * Although the `isStandardBrowserEnv` method indicates that
 * `allows axios to run in a web worker`, the WebWorker will still be
 * filtered out due to its judgment standard
 * `typeof window !== 'undefined' && typeof document !== 'undefined'`.
 * This leads to a problem when axios post `FormData` in webWorker
 */ const $a4cacb8c6615c025$export$c81692cf5af97dac = (()=>{
    return typeof WorkerGlobalScope !== "undefined" && // eslint-disable-next-line no-undef
    self instanceof WorkerGlobalScope && typeof self.importScripts === "function";
})();
const $a4cacb8c6615c025$export$f710a83a91838a36 = $a4cacb8c6615c025$export$c4996c4b7b93b0bf && window.location.href || "http://localhost";

});



parcelRegister("bPTby", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $89df43cec7d4df5a$export$2e2bcd8739ae039; });

var $hjVaC = parcelRequire("hjVaC");
"use strict";
/**
 * It takes a string like `foo[x][y][z]` and returns an array like `['foo', 'x', 'y', 'z']
 *
 * @param {string} name - The name of the property to get.
 *
 * @returns An array of strings.
 */ function $89df43cec7d4df5a$var$parsePropPath(name) {
    // foo[x][y][z]
    // foo.x.y.z
    // foo-x-y-z
    // foo x y z
    return (0, $hjVaC.default).matchAll(/\w+|\[(\w*)]/g, name).map((match)=>{
        return match[0] === "[]" ? "" : match[1] || match[0];
    });
}
/**
 * Convert an array to an object.
 *
 * @param {Array<any>} arr - The array to convert to an object.
 *
 * @returns An object with the same keys and values as the array.
 */ function $89df43cec7d4df5a$var$arrayToObject(arr) {
    const obj = {};
    const keys = Object.keys(arr);
    let i;
    const len = keys.length;
    let key;
    for(i = 0; i < len; i++){
        key = keys[i];
        obj[key] = arr[key];
    }
    return obj;
}
/**
 * It takes a FormData object and returns a JavaScript object
 *
 * @param {string} formData The FormData object to convert to JSON.
 *
 * @returns {Object<string, any> | null} The converted object.
 */ function $89df43cec7d4df5a$var$formDataToJSON(formData) {
    function buildPath(path, value, target, index) {
        let name = path[index++];
        if (name === "__proto__") return true;
        const isNumericKey = Number.isFinite(+name);
        const isLast = index >= path.length;
        name = !name && (0, $hjVaC.default).isArray(target) ? target.length : name;
        if (isLast) {
            if ((0, $hjVaC.default).hasOwnProp(target, name)) target[name] = [
                target[name],
                value
            ];
            else target[name] = value;
            return !isNumericKey;
        }
        if (!target[name] || !(0, $hjVaC.default).isObject(target[name])) target[name] = [];
        const result = buildPath(path, value, target[name], index);
        if (result && (0, $hjVaC.default).isArray(target[name])) target[name] = $89df43cec7d4df5a$var$arrayToObject(target[name]);
        return !isNumericKey;
    }
    if ((0, $hjVaC.default).isFormData(formData) && (0, $hjVaC.default).isFunction(formData.entries)) {
        const obj = {};
        (0, $hjVaC.default).forEachEntry(formData, (name, value)=>{
            buildPath($89df43cec7d4df5a$var$parsePropPath(name), value, obj, 0);
        });
        return obj;
    }
    return null;
}
var $89df43cec7d4df5a$export$2e2bcd8739ae039 = $89df43cec7d4df5a$var$formDataToJSON;

});


parcelRegister("aF1JP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7c2f14e819334a34$export$2e2bcd8739ae039; });

var $hjVaC = parcelRequire("hjVaC");

var $i07gc = parcelRequire("i07gc");
"use strict";
const $7c2f14e819334a34$var$$internals = Symbol("internals");
function $7c2f14e819334a34$var$normalizeHeader(header) {
    return header && String(header).trim().toLowerCase();
}
function $7c2f14e819334a34$var$normalizeValue(value) {
    if (value === false || value == null) return value;
    return (0, $hjVaC.default).isArray(value) ? value.map($7c2f14e819334a34$var$normalizeValue) : String(value);
}
function $7c2f14e819334a34$var$parseTokens(str) {
    const tokens = Object.create(null);
    const tokensRE = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
    let match;
    while(match = tokensRE.exec(str))tokens[match[1]] = match[2];
    return tokens;
}
const $7c2f14e819334a34$var$isValidHeaderName = (str)=>/^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(str.trim());
function $7c2f14e819334a34$var$matchHeaderValue(context, value, header, filter, isHeaderNameFilter) {
    if ((0, $hjVaC.default).isFunction(filter)) return filter.call(this, value, header);
    if (isHeaderNameFilter) value = header;
    if (!(0, $hjVaC.default).isString(value)) return;
    if ((0, $hjVaC.default).isString(filter)) return value.indexOf(filter) !== -1;
    if ((0, $hjVaC.default).isRegExp(filter)) return filter.test(value);
}
function $7c2f14e819334a34$var$formatHeader(header) {
    return header.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (w, char, str)=>{
        return char.toUpperCase() + str;
    });
}
function $7c2f14e819334a34$var$buildAccessors(obj, header) {
    const accessorName = (0, $hjVaC.default).toCamelCase(" " + header);
    [
        "get",
        "set",
        "has"
    ].forEach((methodName)=>{
        Object.defineProperty(obj, methodName + accessorName, {
            value: function(arg1, arg2, arg3) {
                return this[methodName].call(this, header, arg1, arg2, arg3);
            },
            configurable: true
        });
    });
}
class $7c2f14e819334a34$var$AxiosHeaders {
    constructor(headers){
        headers && this.set(headers);
    }
    set(header, valueOrRewrite, rewrite) {
        const self = this;
        function setHeader(_value, _header, _rewrite) {
            const lHeader = $7c2f14e819334a34$var$normalizeHeader(_header);
            if (!lHeader) throw new Error("header name must be a non-empty string");
            const key = (0, $hjVaC.default).findKey(self, lHeader);
            if (!key || self[key] === undefined || _rewrite === true || _rewrite === undefined && self[key] !== false) self[key || _header] = $7c2f14e819334a34$var$normalizeValue(_value);
        }
        const setHeaders = (headers, _rewrite)=>(0, $hjVaC.default).forEach(headers, (_value, _header)=>setHeader(_value, _header, _rewrite));
        if ((0, $hjVaC.default).isPlainObject(header) || header instanceof this.constructor) setHeaders(header, valueOrRewrite);
        else if ((0, $hjVaC.default).isString(header) && (header = header.trim()) && !$7c2f14e819334a34$var$isValidHeaderName(header)) setHeaders((0, $i07gc.default)(header), valueOrRewrite);
        else if ((0, $hjVaC.default).isHeaders(header)) for (const [key, value] of header.entries())setHeader(value, key, rewrite);
        else header != null && setHeader(valueOrRewrite, header, rewrite);
        return this;
    }
    get(header, parser) {
        header = $7c2f14e819334a34$var$normalizeHeader(header);
        if (header) {
            const key = (0, $hjVaC.default).findKey(this, header);
            if (key) {
                const value = this[key];
                if (!parser) return value;
                if (parser === true) return $7c2f14e819334a34$var$parseTokens(value);
                if ((0, $hjVaC.default).isFunction(parser)) return parser.call(this, value, key);
                if ((0, $hjVaC.default).isRegExp(parser)) return parser.exec(value);
                throw new TypeError("parser must be boolean|regexp|function");
            }
        }
    }
    has(header, matcher) {
        header = $7c2f14e819334a34$var$normalizeHeader(header);
        if (header) {
            const key = (0, $hjVaC.default).findKey(this, header);
            return !!(key && this[key] !== undefined && (!matcher || $7c2f14e819334a34$var$matchHeaderValue(this, this[key], key, matcher)));
        }
        return false;
    }
    delete(header, matcher) {
        const self = this;
        let deleted = false;
        function deleteHeader(_header) {
            _header = $7c2f14e819334a34$var$normalizeHeader(_header);
            if (_header) {
                const key = (0, $hjVaC.default).findKey(self, _header);
                if (key && (!matcher || $7c2f14e819334a34$var$matchHeaderValue(self, self[key], key, matcher))) {
                    delete self[key];
                    deleted = true;
                }
            }
        }
        if ((0, $hjVaC.default).isArray(header)) header.forEach(deleteHeader);
        else deleteHeader(header);
        return deleted;
    }
    clear(matcher) {
        const keys = Object.keys(this);
        let i = keys.length;
        let deleted = false;
        while(i--){
            const key = keys[i];
            if (!matcher || $7c2f14e819334a34$var$matchHeaderValue(this, this[key], key, matcher, true)) {
                delete this[key];
                deleted = true;
            }
        }
        return deleted;
    }
    normalize(format) {
        const self = this;
        const headers = {};
        (0, $hjVaC.default).forEach(this, (value, header)=>{
            const key = (0, $hjVaC.default).findKey(headers, header);
            if (key) {
                self[key] = $7c2f14e819334a34$var$normalizeValue(value);
                delete self[header];
                return;
            }
            const normalized = format ? $7c2f14e819334a34$var$formatHeader(header) : String(header).trim();
            if (normalized !== header) delete self[header];
            self[normalized] = $7c2f14e819334a34$var$normalizeValue(value);
            headers[normalized] = true;
        });
        return this;
    }
    concat(...targets) {
        return this.constructor.concat(this, ...targets);
    }
    toJSON(asStrings) {
        const obj = Object.create(null);
        (0, $hjVaC.default).forEach(this, (value, header)=>{
            value != null && value !== false && (obj[header] = asStrings && (0, $hjVaC.default).isArray(value) ? value.join(", ") : value);
        });
        return obj;
    }
    [Symbol.iterator]() {
        return Object.entries(this.toJSON())[Symbol.iterator]();
    }
    toString() {
        return Object.entries(this.toJSON()).map(([header, value])=>header + ": " + value).join("\n");
    }
    get [Symbol.toStringTag]() {
        return "AxiosHeaders";
    }
    static from(thing) {
        return thing instanceof this ? thing : new this(thing);
    }
    static concat(first, ...targets) {
        const computed = new this(first);
        targets.forEach((target)=>computed.set(target));
        return computed;
    }
    static accessor(header) {
        const internals = this[$7c2f14e819334a34$var$$internals] = this[$7c2f14e819334a34$var$$internals] = {
            accessors: {}
        };
        const accessors = internals.accessors;
        const prototype = this.prototype;
        function defineAccessor(_header) {
            const lHeader = $7c2f14e819334a34$var$normalizeHeader(_header);
            if (!accessors[lHeader]) {
                $7c2f14e819334a34$var$buildAccessors(prototype, _header);
                accessors[lHeader] = true;
            }
        }
        (0, $hjVaC.default).isArray(header) ? header.forEach(defineAccessor) : defineAccessor(header);
        return this;
    }
}
$7c2f14e819334a34$var$AxiosHeaders.accessor([
    "Content-Type",
    "Content-Length",
    "Accept",
    "Accept-Encoding",
    "User-Agent",
    "Authorization"
]);
// reserved names hotfix
(0, $hjVaC.default).reduceDescriptors($7c2f14e819334a34$var$AxiosHeaders.prototype, ({ value: value }, key)=>{
    let mapped = key[0].toUpperCase() + key.slice(1); // map `set` => `Set`
    return {
        get: ()=>value,
        set (headerValue) {
            this[mapped] = headerValue;
        }
    };
});
(0, $hjVaC.default).freezeMethods($7c2f14e819334a34$var$AxiosHeaders);
var $7c2f14e819334a34$export$2e2bcd8739ae039 = $7c2f14e819334a34$var$AxiosHeaders;

});
parcelRegister("i07gc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d1addbd7f282a937$export$2e2bcd8739ae039; });

var $hjVaC = parcelRequire("hjVaC");
"use strict";
// RawAxiosHeaders whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
const $d1addbd7f282a937$var$ignoreDuplicateOf = (0, $hjVaC.default).toObjectSet([
    "age",
    "authorization",
    "content-length",
    "content-type",
    "etag",
    "expires",
    "from",
    "host",
    "if-modified-since",
    "if-unmodified-since",
    "last-modified",
    "location",
    "max-forwards",
    "proxy-authorization",
    "referer",
    "retry-after",
    "user-agent"
]);
var /**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} rawHeaders Headers needing to be parsed
 *
 * @returns {Object} Headers parsed into an object
 */ $d1addbd7f282a937$export$2e2bcd8739ae039 = (rawHeaders)=>{
    const parsed = {};
    let key;
    let val;
    let i;
    rawHeaders && rawHeaders.split("\n").forEach(function parser(line) {
        i = line.indexOf(":");
        key = line.substring(0, i).trim().toLowerCase();
        val = line.substring(i + 1).trim();
        if (!key || parsed[key] && $d1addbd7f282a937$var$ignoreDuplicateOf[key]) return;
        if (key === "set-cookie") {
            if (parsed[key]) parsed[key].push(val);
            else parsed[key] = [
                val
            ];
        } else parsed[key] = parsed[key] ? parsed[key] + ", " + val : val;
    });
    return parsed;
};

});



parcelRegister("eAWn0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $aa01b48ddf020889$export$2e2bcd8739ae039; });
"use strict";
function $aa01b48ddf020889$export$2e2bcd8739ae039(value) {
    return !!(value && value.__CANCEL__);
}

});

parcelRegister("kk27X", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ecb7535b0ca1cd4c$export$2e2bcd8739ae039; });

var $7cviO = parcelRequire("7cviO");

var $hjVaC = parcelRequire("hjVaC");
"use strict";
/**
 * A `CanceledError` is an object that is thrown when an operation is canceled.
 *
 * @param {string=} message The message.
 * @param {Object=} config The config.
 * @param {Object=} request The request.
 *
 * @returns {CanceledError} The created error.
 */ function $ecb7535b0ca1cd4c$var$CanceledError(message, config, request) {
    // eslint-disable-next-line no-eq-null,eqeqeq
    (0, $7cviO.default).call(this, message == null ? "canceled" : message, (0, $7cviO.default).ERR_CANCELED, config, request);
    this.name = "CanceledError";
}
(0, $hjVaC.default).inherits($ecb7535b0ca1cd4c$var$CanceledError, (0, $7cviO.default), {
    __CANCEL__: true
});
var $ecb7535b0ca1cd4c$export$2e2bcd8739ae039 = $ecb7535b0ca1cd4c$var$CanceledError;

});

parcelRegister("5wGMX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $406121dd6fa6c4a1$export$2e2bcd8739ae039; });

var $hjVaC = parcelRequire("hjVaC");

var $5ExyV = parcelRequire("5ExyV");

var $aF5U7 = parcelRequire("aF5U7");

var $ilhCo = parcelRequire("ilhCo");

var $7cviO = parcelRequire("7cviO");
const $406121dd6fa6c4a1$var$knownAdapters = {
    http: (0, $5ExyV.default),
    xhr: (0, $aF5U7.default),
    fetch: (0, $ilhCo.default)
};
(0, $hjVaC.default).forEach($406121dd6fa6c4a1$var$knownAdapters, (fn, value)=>{
    if (fn) {
        try {
            Object.defineProperty(fn, "name", {
                value: value
            });
        } catch (e) {
        // eslint-disable-next-line no-empty
        }
        Object.defineProperty(fn, "adapterName", {
            value: value
        });
    }
});
const $406121dd6fa6c4a1$var$renderReason = (reason)=>`- ${reason}`;
const $406121dd6fa6c4a1$var$isResolvedHandle = (adapter)=>(0, $hjVaC.default).isFunction(adapter) || adapter === null || adapter === false;
var $406121dd6fa6c4a1$export$2e2bcd8739ae039 = {
    getAdapter: (adapters)=>{
        adapters = (0, $hjVaC.default).isArray(adapters) ? adapters : [
            adapters
        ];
        const { length: length } = adapters;
        let nameOrAdapter;
        let adapter;
        const rejectedReasons = {};
        for(let i = 0; i < length; i++){
            nameOrAdapter = adapters[i];
            let id;
            adapter = nameOrAdapter;
            if (!$406121dd6fa6c4a1$var$isResolvedHandle(nameOrAdapter)) {
                adapter = $406121dd6fa6c4a1$var$knownAdapters[(id = String(nameOrAdapter)).toLowerCase()];
                if (adapter === undefined) throw new (0, $7cviO.default)(`Unknown adapter '${id}'`);
            }
            if (adapter) break;
            rejectedReasons[id || "#" + i] = adapter;
        }
        if (!adapter) {
            const reasons = Object.entries(rejectedReasons).map(([id, state])=>`adapter ${id} ` + (state === false ? "is not supported by the environment" : "is not available in the build"));
            let s = length ? reasons.length > 1 ? "since :\n" + reasons.map($406121dd6fa6c4a1$var$renderReason).join("\n") : " " + $406121dd6fa6c4a1$var$renderReason(reasons[0]) : "as no adapter specified";
            throw new (0, $7cviO.default)(`There is no suitable adapter to dispatch the request ` + s, "ERR_NOT_SUPPORT");
        }
        return adapter;
    },
    adapters: $406121dd6fa6c4a1$var$knownAdapters
};

});
parcelRegister("aF5U7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7c325029fcb69874$export$2e2bcd8739ae039; });

var $hjVaC = parcelRequire("hjVaC");

var $3fNGB = parcelRequire("3fNGB");

var $7TD1f = parcelRequire("7TD1f");

var $7cviO = parcelRequire("7cviO");

var $kk27X = parcelRequire("kk27X");

var $18rP4 = parcelRequire("18rP4");

var $8t7aE = parcelRequire("8t7aE");

var $aF1JP = parcelRequire("aF1JP");

var $cl3d9 = parcelRequire("cl3d9");

var $g8Sdh = parcelRequire("g8Sdh");
const $7c325029fcb69874$var$isXHRAdapterSupported = typeof XMLHttpRequest !== "undefined";
var $7c325029fcb69874$export$2e2bcd8739ae039 = $7c325029fcb69874$var$isXHRAdapterSupported && function(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
        const _config = (0, $g8Sdh.default)(config);
        let requestData = _config.data;
        const requestHeaders = (0, $aF1JP.default).from(_config.headers).normalize();
        let { responseType: responseType, onUploadProgress: onUploadProgress, onDownloadProgress: onDownloadProgress } = _config;
        let onCanceled;
        let uploadThrottled, downloadThrottled;
        let flushUpload, flushDownload;
        function done() {
            flushUpload && flushUpload(); // flush events
            flushDownload && flushDownload(); // flush events
            _config.cancelToken && _config.cancelToken.unsubscribe(onCanceled);
            _config.signal && _config.signal.removeEventListener("abort", onCanceled);
        }
        let request = new XMLHttpRequest();
        request.open(_config.method.toUpperCase(), _config.url, true);
        // Set the request timeout in MS
        request.timeout = _config.timeout;
        function onloadend() {
            if (!request) return;
            // Prepare the response
            const responseHeaders = (0, $aF1JP.default).from("getAllResponseHeaders" in request && request.getAllResponseHeaders());
            const responseData = !responseType || responseType === "text" || responseType === "json" ? request.responseText : request.response;
            const response = {
                data: responseData,
                status: request.status,
                statusText: request.statusText,
                headers: responseHeaders,
                config: config,
                request: request
            };
            (0, $3fNGB.default)(function _resolve(value) {
                resolve(value);
                done();
            }, function _reject(err) {
                reject(err);
                done();
            }, response);
            // Clean up request
            request = null;
        }
        if ("onloadend" in request) // Use onloadend if available
        request.onloadend = onloadend;
        else // Listen for ready state to emulate onloadend
        request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) return;
            // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request
            if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf("file:") === 0)) return;
            // readystate handler is calling before onerror or ontimeout handlers,
            // so we should call onloadend on the next 'tick'
            setTimeout(onloadend);
        };
        // Handle browser request cancellation (as opposed to a manual cancellation)
        request.onabort = function handleAbort() {
            if (!request) return;
            reject(new (0, $7cviO.default)("Request aborted", (0, $7cviO.default).ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Handle low level network errors
        request.onerror = function handleError() {
            // Real errors are hidden from us by the browser
            // onerror should only fire if it's a network error
            reject(new (0, $7cviO.default)("Network Error", (0, $7cviO.default).ERR_NETWORK, config, request));
            // Clean up request
            request = null;
        };
        // Handle timeout
        request.ontimeout = function handleTimeout() {
            let timeoutErrorMessage = _config.timeout ? "timeout of " + _config.timeout + "ms exceeded" : "timeout exceeded";
            const transitional = _config.transitional || (0, $7TD1f.default);
            if (_config.timeoutErrorMessage) timeoutErrorMessage = _config.timeoutErrorMessage;
            reject(new (0, $7cviO.default)(timeoutErrorMessage, transitional.clarifyTimeoutError ? (0, $7cviO.default).ETIMEDOUT : (0, $7cviO.default).ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Remove Content-Type if data is undefined
        requestData === undefined && requestHeaders.setContentType(null);
        // Add headers to the request
        if ("setRequestHeader" in request) (0, $hjVaC.default).forEach(requestHeaders.toJSON(), function setRequestHeader(val, key) {
            request.setRequestHeader(key, val);
        });
        // Add withCredentials to request if needed
        if (!(0, $hjVaC.default).isUndefined(_config.withCredentials)) request.withCredentials = !!_config.withCredentials;
        // Add responseType to request if needed
        if (responseType && responseType !== "json") request.responseType = _config.responseType;
        // Handle progress if needed
        if (onDownloadProgress) {
            [downloadThrottled, flushDownload] = (0, $cl3d9.progressEventReducer)(onDownloadProgress, true);
            request.addEventListener("progress", downloadThrottled);
        }
        // Not all browsers support upload events
        if (onUploadProgress && request.upload) {
            [uploadThrottled, flushUpload] = (0, $cl3d9.progressEventReducer)(onUploadProgress);
            request.upload.addEventListener("progress", uploadThrottled);
            request.upload.addEventListener("loadend", flushUpload);
        }
        if (_config.cancelToken || _config.signal) {
            // Handle cancellation
            // eslint-disable-next-line func-names
            onCanceled = (cancel)=>{
                if (!request) return;
                reject(!cancel || cancel.type ? new (0, $kk27X.default)(null, config, request) : cancel);
                request.abort();
                request = null;
            };
            _config.cancelToken && _config.cancelToken.subscribe(onCanceled);
            if (_config.signal) _config.signal.aborted ? onCanceled() : _config.signal.addEventListener("abort", onCanceled);
        }
        const protocol = (0, $18rP4.default)(_config.url);
        if (protocol && (0, $8t7aE.default).protocols.indexOf(protocol) === -1) {
            reject(new (0, $7cviO.default)("Unsupported protocol " + protocol + ":", (0, $7cviO.default).ERR_BAD_REQUEST, config));
            return;
        }
        // Send the request
        request.send(requestData || null);
    });
};

});
parcelRegister("3fNGB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $25e9506f060d2268$export$2e2bcd8739ae039; });

var $7cviO = parcelRequire("7cviO");
"use strict";
function $25e9506f060d2268$export$2e2bcd8739ae039(resolve, reject, response) {
    const validateStatus = response.config.validateStatus;
    if (!response.status || !validateStatus || validateStatus(response.status)) resolve(response);
    else reject(new (0, $7cviO.default)("Request failed with status code " + response.status, [
        (0, $7cviO.default).ERR_BAD_REQUEST,
        (0, $7cviO.default).ERR_BAD_RESPONSE
    ][Math.floor(response.status / 100) - 4], response.config, response.request, response));
}

});

parcelRegister("18rP4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0d3c1ecc340d2bbc$export$2e2bcd8739ae039; });
"use strict";
function $0d3c1ecc340d2bbc$export$2e2bcd8739ae039(url) {
    const match = /^([-+\w]{1,25})(:?\/\/|:)/.exec(url);
    return match && match[1] || "";
}

});

parcelRegister("cl3d9", function(module, exports) {

$parcel$export(module.exports, "progressEventReducer", function () { return $8fb9efdfe09d6fb9$export$c1b28109d46c3592; });
$parcel$export(module.exports, "progressEventDecorator", function () { return $8fb9efdfe09d6fb9$export$d9fadd12586c18d6; });
$parcel$export(module.exports, "asyncDecorator", function () { return $8fb9efdfe09d6fb9$export$5d35863c355a22a9; });

var $1fUmp = parcelRequire("1fUmp");

var $kQ440 = parcelRequire("kQ440");

var $hjVaC = parcelRequire("hjVaC");
const $8fb9efdfe09d6fb9$export$c1b28109d46c3592 = (listener, isDownloadStream, freq = 3)=>{
    let bytesNotified = 0;
    const _speedometer = (0, $1fUmp.default)(50, 250);
    return (0, $kQ440.default)((e)=>{
        const loaded = e.loaded;
        const total = e.lengthComputable ? e.total : undefined;
        const progressBytes = loaded - bytesNotified;
        const rate = _speedometer(progressBytes);
        const inRange = loaded <= total;
        bytesNotified = loaded;
        const data = {
            loaded: loaded,
            total: total,
            progress: total ? loaded / total : undefined,
            bytes: progressBytes,
            rate: rate ? rate : undefined,
            estimated: rate && total && inRange ? (total - loaded) / rate : undefined,
            event: e,
            lengthComputable: total != null,
            [isDownloadStream ? "download" : "upload"]: true
        };
        listener(data);
    }, freq);
};
const $8fb9efdfe09d6fb9$export$d9fadd12586c18d6 = (total, throttled)=>{
    const lengthComputable = total != null;
    return [
        (loaded)=>throttled[0]({
                lengthComputable: lengthComputable,
                total: total,
                loaded: loaded
            }),
        throttled[1]
    ];
};
const $8fb9efdfe09d6fb9$export$5d35863c355a22a9 = (fn)=>(...args)=>(0, $hjVaC.default).asap(()=>fn(...args));

});
parcelRegister("1fUmp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0ea2e930f7493ae5$export$2e2bcd8739ae039; });
"use strict";
/**
 * Calculate data maxRate
 * @param {Number} [samplesCount= 10]
 * @param {Number} [min= 1000]
 * @returns {Function}
 */ function $0ea2e930f7493ae5$var$speedometer(samplesCount, min) {
    samplesCount = samplesCount || 10;
    const bytes = new Array(samplesCount);
    const timestamps = new Array(samplesCount);
    let head = 0;
    let tail = 0;
    let firstSampleTS;
    min = min !== undefined ? min : 1000;
    return function push(chunkLength) {
        const now = Date.now();
        const startedAt = timestamps[tail];
        if (!firstSampleTS) firstSampleTS = now;
        bytes[head] = chunkLength;
        timestamps[head] = now;
        let i = tail;
        let bytesCount = 0;
        while(i !== head){
            bytesCount += bytes[i++];
            i = i % samplesCount;
        }
        head = (head + 1) % samplesCount;
        if (head === tail) tail = (tail + 1) % samplesCount;
        if (now - firstSampleTS < min) return;
        const passed = startedAt && now - startedAt;
        return passed ? Math.round(bytesCount * 1000 / passed) : undefined;
    };
}
var $0ea2e930f7493ae5$export$2e2bcd8739ae039 = $0ea2e930f7493ae5$var$speedometer;

});

parcelRegister("kQ440", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f2bbd0eef9a6f063$export$2e2bcd8739ae039; });
/**
 * Throttle decorator
 * @param {Function} fn
 * @param {Number} freq
 * @return {Function}
 */ function $f2bbd0eef9a6f063$var$throttle(fn, freq) {
    let timestamp = 0;
    let threshold = 1000 / freq;
    let lastArgs;
    let timer;
    const invoke = (args, now = Date.now())=>{
        timestamp = now;
        lastArgs = null;
        if (timer) {
            clearTimeout(timer);
            timer = null;
        }
        fn.apply(null, args);
    };
    const throttled = (...args)=>{
        const now = Date.now();
        const passed = now - timestamp;
        if (passed >= threshold) invoke(args, now);
        else {
            lastArgs = args;
            if (!timer) timer = setTimeout(()=>{
                timer = null;
                invoke(lastArgs);
            }, threshold - passed);
        }
    };
    const flush = ()=>lastArgs && invoke(lastArgs);
    return [
        throttled,
        flush
    ];
}
var $f2bbd0eef9a6f063$export$2e2bcd8739ae039 = $f2bbd0eef9a6f063$var$throttle;

});


parcelRegister("g8Sdh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bc077248f34dd777$export$2e2bcd8739ae039; });

var $8t7aE = parcelRequire("8t7aE");

var $hjVaC = parcelRequire("hjVaC");

var $6Ivjn = parcelRequire("6Ivjn");

var $dJGuR = parcelRequire("dJGuR");

var $9jhII = parcelRequire("9jhII");

var $c3v5Q = parcelRequire("c3v5Q");

var $aF1JP = parcelRequire("aF1JP");

var $hHwRb = parcelRequire("hHwRb");
var $bc077248f34dd777$export$2e2bcd8739ae039 = (config)=>{
    const newConfig = (0, $c3v5Q.default)({}, config);
    let { data: data, withXSRFToken: withXSRFToken, xsrfHeaderName: xsrfHeaderName, xsrfCookieName: xsrfCookieName, headers: headers, auth: auth } = newConfig;
    newConfig.headers = headers = (0, $aF1JP.default).from(headers);
    newConfig.url = (0, $hHwRb.default)((0, $9jhII.default)(newConfig.baseURL, newConfig.url, newConfig.allowAbsoluteUrls), config.params, config.paramsSerializer);
    // HTTP basic authentication
    if (auth) headers.set("Authorization", "Basic " + btoa((auth.username || "") + ":" + (auth.password ? unescape(encodeURIComponent(auth.password)) : "")));
    let contentType;
    if ((0, $hjVaC.default).isFormData(data)) {
        if ((0, $8t7aE.default).hasStandardBrowserEnv || (0, $8t7aE.default).hasStandardBrowserWebWorkerEnv) headers.setContentType(undefined); // Let the browser set it
        else if ((contentType = headers.getContentType()) !== false) {
            // fix semicolon duplication issue for ReactNative FormData implementation
            const [type, ...tokens] = contentType ? contentType.split(";").map((token)=>token.trim()).filter(Boolean) : [];
            headers.setContentType([
                type || "multipart/form-data",
                ...tokens
            ].join("; "));
        }
    }
    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if ((0, $8t7aE.default).hasStandardBrowserEnv) {
        withXSRFToken && (0, $hjVaC.default).isFunction(withXSRFToken) && (withXSRFToken = withXSRFToken(newConfig));
        if (withXSRFToken || withXSRFToken !== false && (0, $6Ivjn.default)(newConfig.url)) {
            // Add xsrf header
            const xsrfValue = xsrfHeaderName && xsrfCookieName && (0, $dJGuR.default).read(xsrfCookieName);
            if (xsrfValue) headers.set(xsrfHeaderName, xsrfValue);
        }
    }
    return newConfig;
};

});
parcelRegister("6Ivjn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4e3f23f93e9b03f5$export$2e2bcd8739ae039; });

var $8t7aE = parcelRequire("8t7aE");
var $4e3f23f93e9b03f5$export$2e2bcd8739ae039 = (0, $8t7aE.default).hasStandardBrowserEnv ? ((origin, isMSIE)=>(url)=>{
        url = new URL(url, (0, $8t7aE.default).origin);
        return origin.protocol === url.protocol && origin.host === url.host && (isMSIE || origin.port === url.port);
    })(new URL((0, $8t7aE.default).origin), (0, $8t7aE.default).navigator && /(msie|trident)/i.test((0, $8t7aE.default).navigator.userAgent)) : ()=>true;

});

parcelRegister("dJGuR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a000714f15927542$export$2e2bcd8739ae039; });

var $hjVaC = parcelRequire("hjVaC");

var $8t7aE = parcelRequire("8t7aE");
var $a000714f15927542$export$2e2bcd8739ae039 = (0, $8t7aE.default).hasStandardBrowserEnv ? // Standard browser envs support document.cookie
{
    write (name, value, expires, path, domain, secure) {
        const cookie = [
            name + "=" + encodeURIComponent(value)
        ];
        (0, $hjVaC.default).isNumber(expires) && cookie.push("expires=" + new Date(expires).toGMTString());
        (0, $hjVaC.default).isString(path) && cookie.push("path=" + path);
        (0, $hjVaC.default).isString(domain) && cookie.push("domain=" + domain);
        secure === true && cookie.push("secure");
        document.cookie = cookie.join("; ");
    },
    read (name) {
        const match = document.cookie.match(new RegExp("(^|;\\s*)(" + name + ")=([^;]*)"));
        return match ? decodeURIComponent(match[3]) : null;
    },
    remove (name) {
        this.write(name, "", Date.now() - 86400000);
    }
} : // Non-standard browser env (web workers, react-native) lack needed support.
{
    write () {},
    read () {
        return null;
    },
    remove () {}
};

});

parcelRegister("9jhII", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6c73a24521bd3a83$export$2e2bcd8739ae039; });

var $kfhDU = parcelRequire("kfhDU");

var $bpgAv = parcelRequire("bpgAv");
"use strict";
function $6c73a24521bd3a83$export$2e2bcd8739ae039(baseURL, requestedURL, allowAbsoluteUrls) {
    let isRelativeUrl = !(0, $kfhDU.default)(requestedURL);
    if (baseURL && (isRelativeUrl || allowAbsoluteUrls == false)) return (0, $bpgAv.default)(baseURL, requestedURL);
    return requestedURL;
}

});
parcelRegister("kfhDU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ebd2e4d631bac7b7$export$2e2bcd8739ae039; });
"use strict";
function $ebd2e4d631bac7b7$export$2e2bcd8739ae039(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
}

});

parcelRegister("bpgAv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $84dee57cd472f929$export$2e2bcd8739ae039; });
"use strict";
function $84dee57cd472f929$export$2e2bcd8739ae039(baseURL, relativeURL) {
    return relativeURL ? baseURL.replace(/\/?\/$/, "") + "/" + relativeURL.replace(/^\/+/, "") : baseURL;
}

});


parcelRegister("c3v5Q", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8c6de24c5f0d5b2b$export$2e2bcd8739ae039; });

var $hjVaC = parcelRequire("hjVaC");

var $aF1JP = parcelRequire("aF1JP");
"use strict";
const $8c6de24c5f0d5b2b$var$headersToObject = (thing)=>thing instanceof (0, $aF1JP.default) ? {
        ...thing
    } : thing;
function $8c6de24c5f0d5b2b$export$2e2bcd8739ae039(config1, config2) {
    // eslint-disable-next-line no-param-reassign
    config2 = config2 || {};
    const config = {};
    function getMergedValue(target, source, prop, caseless) {
        if ((0, $hjVaC.default).isPlainObject(target) && (0, $hjVaC.default).isPlainObject(source)) return (0, $hjVaC.default).merge.call({
            caseless: caseless
        }, target, source);
        else if ((0, $hjVaC.default).isPlainObject(source)) return (0, $hjVaC.default).merge({}, source);
        else if ((0, $hjVaC.default).isArray(source)) return source.slice();
        return source;
    }
    // eslint-disable-next-line consistent-return
    function mergeDeepProperties(a, b, prop, caseless) {
        if (!(0, $hjVaC.default).isUndefined(b)) return getMergedValue(a, b, prop, caseless);
        else if (!(0, $hjVaC.default).isUndefined(a)) return getMergedValue(undefined, a, prop, caseless);
    }
    // eslint-disable-next-line consistent-return
    function valueFromConfig2(a, b) {
        if (!(0, $hjVaC.default).isUndefined(b)) return getMergedValue(undefined, b);
    }
    // eslint-disable-next-line consistent-return
    function defaultToConfig2(a, b) {
        if (!(0, $hjVaC.default).isUndefined(b)) return getMergedValue(undefined, b);
        else if (!(0, $hjVaC.default).isUndefined(a)) return getMergedValue(undefined, a);
    }
    // eslint-disable-next-line consistent-return
    function mergeDirectKeys(a, b, prop) {
        if (prop in config2) return getMergedValue(a, b);
        else if (prop in config1) return getMergedValue(undefined, a);
    }
    const mergeMap = {
        url: valueFromConfig2,
        method: valueFromConfig2,
        data: valueFromConfig2,
        baseURL: defaultToConfig2,
        transformRequest: defaultToConfig2,
        transformResponse: defaultToConfig2,
        paramsSerializer: defaultToConfig2,
        timeout: defaultToConfig2,
        timeoutMessage: defaultToConfig2,
        withCredentials: defaultToConfig2,
        withXSRFToken: defaultToConfig2,
        adapter: defaultToConfig2,
        responseType: defaultToConfig2,
        xsrfCookieName: defaultToConfig2,
        xsrfHeaderName: defaultToConfig2,
        onUploadProgress: defaultToConfig2,
        onDownloadProgress: defaultToConfig2,
        decompress: defaultToConfig2,
        maxContentLength: defaultToConfig2,
        maxBodyLength: defaultToConfig2,
        beforeRedirect: defaultToConfig2,
        transport: defaultToConfig2,
        httpAgent: defaultToConfig2,
        httpsAgent: defaultToConfig2,
        cancelToken: defaultToConfig2,
        socketPath: defaultToConfig2,
        responseEncoding: defaultToConfig2,
        validateStatus: mergeDirectKeys,
        headers: (a, b, prop)=>mergeDeepProperties($8c6de24c5f0d5b2b$var$headersToObject(a), $8c6de24c5f0d5b2b$var$headersToObject(b), prop, true)
    };
    (0, $hjVaC.default).forEach(Object.keys(Object.assign({}, config1, config2)), function computeConfigValue(prop) {
        const merge = mergeMap[prop] || mergeDeepProperties;
        const configValue = merge(config1[prop], config2[prop], prop);
        (0, $hjVaC.default).isUndefined(configValue) && merge !== mergeDirectKeys || (config[prop] = configValue);
    });
    return config;
}

});



parcelRegister("ilhCo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d5a7dac728ba111d$export$2e2bcd8739ae039; });

var $8t7aE = parcelRequire("8t7aE");

var $hjVaC = parcelRequire("hjVaC");

var $7cviO = parcelRequire("7cviO");

var $h31lz = parcelRequire("h31lz");

var $8YnMa = parcelRequire("8YnMa");

var $aF1JP = parcelRequire("aF1JP");

var $cl3d9 = parcelRequire("cl3d9");

var $g8Sdh = parcelRequire("g8Sdh");

var $3fNGB = parcelRequire("3fNGB");
const $d5a7dac728ba111d$var$isFetchSupported = typeof fetch === "function" && typeof Request === "function" && typeof Response === "function";
const $d5a7dac728ba111d$var$isReadableStreamSupported = $d5a7dac728ba111d$var$isFetchSupported && typeof ReadableStream === "function";
// used only inside the fetch adapter
const $d5a7dac728ba111d$var$encodeText = $d5a7dac728ba111d$var$isFetchSupported && (typeof TextEncoder === "function" ? ((encoder)=>(str)=>encoder.encode(str))(new TextEncoder()) : async (str)=>new Uint8Array(await new Response(str).arrayBuffer()));
const $d5a7dac728ba111d$var$test = (fn, ...args)=>{
    try {
        return !!fn(...args);
    } catch (e) {
        return false;
    }
};
const $d5a7dac728ba111d$var$supportsRequestStream = $d5a7dac728ba111d$var$isReadableStreamSupported && $d5a7dac728ba111d$var$test(()=>{
    let duplexAccessed = false;
    const hasContentType = new Request((0, $8t7aE.default).origin, {
        body: new ReadableStream(),
        method: "POST",
        get duplex () {
            duplexAccessed = true;
            return "half";
        }
    }).headers.has("Content-Type");
    return duplexAccessed && !hasContentType;
});
const $d5a7dac728ba111d$var$DEFAULT_CHUNK_SIZE = 65536;
const $d5a7dac728ba111d$var$supportsResponseStream = $d5a7dac728ba111d$var$isReadableStreamSupported && $d5a7dac728ba111d$var$test(()=>(0, $hjVaC.default).isReadableStream(new Response("").body));
const $d5a7dac728ba111d$var$resolvers = {
    stream: $d5a7dac728ba111d$var$supportsResponseStream && ((res)=>res.body)
};
$d5a7dac728ba111d$var$isFetchSupported && ((res)=>{
    [
        "text",
        "arrayBuffer",
        "blob",
        "formData",
        "stream"
    ].forEach((type)=>{
        !$d5a7dac728ba111d$var$resolvers[type] && ($d5a7dac728ba111d$var$resolvers[type] = (0, $hjVaC.default).isFunction(res[type]) ? (res)=>res[type]() : (_, config)=>{
            throw new (0, $7cviO.default)(`Response type '${type}' is not supported`, (0, $7cviO.default).ERR_NOT_SUPPORT, config);
        });
    });
})(new Response);
const $d5a7dac728ba111d$var$getBodyLength = async (body)=>{
    if (body == null) return 0;
    if ((0, $hjVaC.default).isBlob(body)) return body.size;
    if ((0, $hjVaC.default).isSpecCompliantForm(body)) {
        const _request = new Request((0, $8t7aE.default).origin, {
            method: "POST",
            body: body
        });
        return (await _request.arrayBuffer()).byteLength;
    }
    if ((0, $hjVaC.default).isArrayBufferView(body) || (0, $hjVaC.default).isArrayBuffer(body)) return body.byteLength;
    if ((0, $hjVaC.default).isURLSearchParams(body)) body = body + "";
    if ((0, $hjVaC.default).isString(body)) return (await $d5a7dac728ba111d$var$encodeText(body)).byteLength;
};
const $d5a7dac728ba111d$var$resolveBodyLength = async (headers, body)=>{
    const length = (0, $hjVaC.default).toFiniteNumber(headers.getContentLength());
    return length == null ? $d5a7dac728ba111d$var$getBodyLength(body) : length;
};
var $d5a7dac728ba111d$export$2e2bcd8739ae039 = $d5a7dac728ba111d$var$isFetchSupported && (async (config)=>{
    let { url: url, method: method, data: data, signal: signal, cancelToken: cancelToken, timeout: timeout, onDownloadProgress: onDownloadProgress, onUploadProgress: onUploadProgress, responseType: responseType, headers: headers, withCredentials: withCredentials = "same-origin", fetchOptions: fetchOptions } = (0, $g8Sdh.default)(config);
    responseType = responseType ? (responseType + "").toLowerCase() : "text";
    let composedSignal = (0, $h31lz.default)([
        signal,
        cancelToken && cancelToken.toAbortSignal()
    ], timeout);
    let request;
    const unsubscribe = composedSignal && composedSignal.unsubscribe && (()=>{
        composedSignal.unsubscribe();
    });
    let requestContentLength;
    try {
        if (onUploadProgress && $d5a7dac728ba111d$var$supportsRequestStream && method !== "get" && method !== "head" && (requestContentLength = await $d5a7dac728ba111d$var$resolveBodyLength(headers, data)) !== 0) {
            let _request = new Request(url, {
                method: "POST",
                body: data,
                duplex: "half"
            });
            let contentTypeHeader;
            if ((0, $hjVaC.default).isFormData(data) && (contentTypeHeader = _request.headers.get("content-type"))) headers.setContentType(contentTypeHeader);
            if (_request.body) {
                const [onProgress, flush] = (0, $cl3d9.progressEventDecorator)(requestContentLength, (0, $cl3d9.progressEventReducer)((0, $cl3d9.asyncDecorator)(onUploadProgress)));
                data = (0, $8YnMa.trackStream)(_request.body, $d5a7dac728ba111d$var$DEFAULT_CHUNK_SIZE, onProgress, flush);
            }
        }
        if (!(0, $hjVaC.default).isString(withCredentials)) withCredentials = withCredentials ? "include" : "omit";
        // Cloudflare Workers throws when credentials are defined
        // see https://github.com/cloudflare/workerd/issues/902
        const isCredentialsSupported = "credentials" in Request.prototype;
        request = new Request(url, {
            ...fetchOptions,
            signal: composedSignal,
            method: method.toUpperCase(),
            headers: headers.normalize().toJSON(),
            body: data,
            duplex: "half",
            credentials: isCredentialsSupported ? withCredentials : undefined
        });
        let response = await fetch(request);
        const isStreamResponse = $d5a7dac728ba111d$var$supportsResponseStream && (responseType === "stream" || responseType === "response");
        if ($d5a7dac728ba111d$var$supportsResponseStream && (onDownloadProgress || isStreamResponse && unsubscribe)) {
            const options = {};
            [
                "status",
                "statusText",
                "headers"
            ].forEach((prop)=>{
                options[prop] = response[prop];
            });
            const responseContentLength = (0, $hjVaC.default).toFiniteNumber(response.headers.get("content-length"));
            const [onProgress, flush] = onDownloadProgress && (0, $cl3d9.progressEventDecorator)(responseContentLength, (0, $cl3d9.progressEventReducer)((0, $cl3d9.asyncDecorator)(onDownloadProgress), true)) || [];
            response = new Response((0, $8YnMa.trackStream)(response.body, $d5a7dac728ba111d$var$DEFAULT_CHUNK_SIZE, onProgress, ()=>{
                flush && flush();
                unsubscribe && unsubscribe();
            }), options);
        }
        responseType = responseType || "text";
        let responseData = await $d5a7dac728ba111d$var$resolvers[(0, $hjVaC.default).findKey($d5a7dac728ba111d$var$resolvers, responseType) || "text"](response, config);
        !isStreamResponse && unsubscribe && unsubscribe();
        return await new Promise((resolve, reject)=>{
            (0, $3fNGB.default)(resolve, reject, {
                data: responseData,
                headers: (0, $aF1JP.default).from(response.headers),
                status: response.status,
                statusText: response.statusText,
                config: config,
                request: request
            });
        });
    } catch (err) {
        unsubscribe && unsubscribe();
        if (err && err.name === "TypeError" && /fetch/i.test(err.message)) throw Object.assign(new (0, $7cviO.default)("Network Error", (0, $7cviO.default).ERR_NETWORK, config, request), {
            cause: err.cause || err
        });
        throw (0, $7cviO.default).from(err, err && err.code, config, request);
    }
});

});
parcelRegister("h31lz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c693c2f3a9adda30$export$2e2bcd8739ae039; });

var $kk27X = parcelRequire("kk27X");

var $7cviO = parcelRequire("7cviO");

var $hjVaC = parcelRequire("hjVaC");
const $c693c2f3a9adda30$var$composeSignals = (signals, timeout)=>{
    const { length: length } = signals = signals ? signals.filter(Boolean) : [];
    if (timeout || length) {
        let controller = new AbortController();
        let aborted;
        const onabort = function(reason) {
            if (!aborted) {
                aborted = true;
                unsubscribe();
                const err = reason instanceof Error ? reason : this.reason;
                controller.abort(err instanceof (0, $7cviO.default) ? err : new (0, $kk27X.default)(err instanceof Error ? err.message : err));
            }
        };
        let timer = timeout && setTimeout(()=>{
            timer = null;
            onabort(new (0, $7cviO.default)(`timeout ${timeout} of ms exceeded`, (0, $7cviO.default).ETIMEDOUT));
        }, timeout);
        const unsubscribe = ()=>{
            if (signals) {
                timer && clearTimeout(timer);
                timer = null;
                signals.forEach((signal)=>{
                    signal.unsubscribe ? signal.unsubscribe(onabort) : signal.removeEventListener("abort", onabort);
                });
                signals = null;
            }
        };
        signals.forEach((signal)=>signal.addEventListener("abort", onabort));
        const { signal: signal } = controller;
        signal.unsubscribe = ()=>(0, $hjVaC.default).asap(unsubscribe);
        return signal;
    }
};
var $c693c2f3a9adda30$export$2e2bcd8739ae039 = $c693c2f3a9adda30$var$composeSignals;

});

parcelRegister("8YnMa", function(module, exports) {

$parcel$export(module.exports, "trackStream", function () { return $68865ebbc006c986$export$b0119225647bd83; });
const $68865ebbc006c986$export$71b051935044bd5d = function*(chunk, chunkSize) {
    let len = chunk.byteLength;
    if (!chunkSize || len < chunkSize) {
        yield chunk;
        return;
    }
    let pos = 0;
    let end;
    while(pos < len){
        end = pos + chunkSize;
        yield chunk.slice(pos, end);
        pos = end;
    }
};
const $68865ebbc006c986$export$f9f241124ee3198e = async function*(iterable, chunkSize) {
    for await (const chunk of $68865ebbc006c986$var$readStream(iterable))yield* $68865ebbc006c986$export$71b051935044bd5d(chunk, chunkSize);
};
const $68865ebbc006c986$var$readStream = async function*(stream) {
    if (stream[Symbol.asyncIterator]) {
        yield* stream;
        return;
    }
    const reader = stream.getReader();
    try {
        for(;;){
            const { done: done, value: value } = await reader.read();
            if (done) break;
            yield value;
        }
    } finally{
        await reader.cancel();
    }
};
const $68865ebbc006c986$export$b0119225647bd83 = (stream, chunkSize, onProgress, onFinish)=>{
    const iterator = $68865ebbc006c986$export$f9f241124ee3198e(stream, chunkSize);
    let bytes = 0;
    let done;
    let _onFinish = (e)=>{
        if (!done) {
            done = true;
            onFinish && onFinish(e);
        }
    };
    return new ReadableStream({
        async pull (controller) {
            try {
                const { done: done, value: value } = await iterator.next();
                if (done) {
                    _onFinish();
                    controller.close();
                    return;
                }
                let len = value.byteLength;
                if (onProgress) {
                    let loadedBytes = bytes += len;
                    onProgress(loadedBytes);
                }
                controller.enqueue(new Uint8Array(value));
            } catch (err) {
                _onFinish(err);
                throw err;
            }
        },
        cancel (reason) {
            _onFinish(reason);
            return iterator.return();
        }
    }, {
        highWaterMark: 2
    });
};

});




parcelRegister("alWME", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $789976c5b4c90e5a$export$2e2bcd8739ae039; });

var $7zwsx = parcelRequire("7zwsx");

var $7cviO = parcelRequire("7cviO");
"use strict";
const $789976c5b4c90e5a$var$validators = {};
// eslint-disable-next-line func-names
[
    "object",
    "boolean",
    "number",
    "function",
    "string",
    "symbol"
].forEach((type, i)=>{
    $789976c5b4c90e5a$var$validators[type] = function validator(thing) {
        return typeof thing === type || "a" + (i < 1 ? "n " : " ") + type;
    };
});
const $789976c5b4c90e5a$var$deprecatedWarnings = {};
/**
 * Transitional option validator
 *
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 *
 * @returns {function}
 */ $789976c5b4c90e5a$var$validators.transitional = function transitional(validator, version, message) {
    function formatMessage(opt, desc) {
        return "[Axios v" + (0, $7zwsx.VERSION) + "] Transitional option '" + opt + "'" + desc + (message ? ". " + message : "");
    }
    // eslint-disable-next-line func-names
    return (value, opt, opts)=>{
        if (validator === false) throw new (0, $7cviO.default)(formatMessage(opt, " has been removed" + (version ? " in " + version : "")), (0, $7cviO.default).ERR_DEPRECATED);
        if (version && !$789976c5b4c90e5a$var$deprecatedWarnings[opt]) {
            $789976c5b4c90e5a$var$deprecatedWarnings[opt] = true;
            // eslint-disable-next-line no-console
            console.warn(formatMessage(opt, " has been deprecated since v" + version + " and will be removed in the near future"));
        }
        return validator ? validator(value, opt, opts) : true;
    };
};
$789976c5b4c90e5a$var$validators.spelling = function spelling(correctSpelling) {
    return (value, opt)=>{
        // eslint-disable-next-line no-console
        console.warn(`${opt} is likely a misspelling of ${correctSpelling}`);
        return true;
    };
};
/**
 * Assert object's properties type
 *
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 *
 * @returns {object}
 */ function $789976c5b4c90e5a$var$assertOptions(options, schema, allowUnknown) {
    if (typeof options !== "object") throw new (0, $7cviO.default)("options must be an object", (0, $7cviO.default).ERR_BAD_OPTION_VALUE);
    const keys = Object.keys(options);
    let i = keys.length;
    while(i-- > 0){
        const opt = keys[i];
        const validator = schema[opt];
        if (validator) {
            const value = options[opt];
            const result = value === undefined || validator(value, opt, options);
            if (result !== true) throw new (0, $7cviO.default)("option " + opt + " must be " + result, (0, $7cviO.default).ERR_BAD_OPTION_VALUE);
            continue;
        }
        if (allowUnknown !== true) throw new (0, $7cviO.default)("Unknown option " + opt, (0, $7cviO.default).ERR_BAD_OPTION);
    }
}
var $789976c5b4c90e5a$export$2e2bcd8739ae039 = {
    assertOptions: $789976c5b4c90e5a$var$assertOptions,
    validators: $789976c5b4c90e5a$var$validators
};

});
parcelRegister("7zwsx", function(module, exports) {

$parcel$export(module.exports, "VERSION", function () { return $5834fb095506a9d0$export$a4ad2735b021c132; });
const $5834fb095506a9d0$export$a4ad2735b021c132 = "1.8.4";

});



parcelRegister("hWsWr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d0fe4da6d116dd20$export$2e2bcd8739ae039; });

var $kk27X = parcelRequire("kk27X");
"use strict";
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @param {Function} executor The executor function.
 *
 * @returns {CancelToken}
 */ class $d0fe4da6d116dd20$var$CancelToken {
    constructor(executor){
        if (typeof executor !== "function") throw new TypeError("executor must be a function.");
        let resolvePromise;
        this.promise = new Promise(function promiseExecutor(resolve) {
            resolvePromise = resolve;
        });
        const token = this;
        // eslint-disable-next-line func-names
        this.promise.then((cancel)=>{
            if (!token._listeners) return;
            let i = token._listeners.length;
            while(i-- > 0)token._listeners[i](cancel);
            token._listeners = null;
        });
        // eslint-disable-next-line func-names
        this.promise.then = (onfulfilled)=>{
            let _resolve;
            // eslint-disable-next-line func-names
            const promise = new Promise((resolve)=>{
                token.subscribe(resolve);
                _resolve = resolve;
            }).then(onfulfilled);
            promise.cancel = function reject() {
                token.unsubscribe(_resolve);
            };
            return promise;
        };
        executor(function cancel(message, config, request) {
            if (token.reason) // Cancellation has already been requested
            return;
            token.reason = new (0, $kk27X.default)(message, config, request);
            resolvePromise(token.reason);
        });
    }
    /**
   * Throws a `CanceledError` if cancellation has been requested.
   */ throwIfRequested() {
        if (this.reason) throw this.reason;
    }
    /**
   * Subscribe to the cancel signal
   */ subscribe(listener) {
        if (this.reason) {
            listener(this.reason);
            return;
        }
        if (this._listeners) this._listeners.push(listener);
        else this._listeners = [
            listener
        ];
    }
    /**
   * Unsubscribe from the cancel signal
   */ unsubscribe(listener) {
        if (!this._listeners) return;
        const index = this._listeners.indexOf(listener);
        if (index !== -1) this._listeners.splice(index, 1);
    }
    toAbortSignal() {
        const controller = new AbortController();
        const abort = (err)=>{
            controller.abort(err);
        };
        this.subscribe(abort);
        controller.signal.unsubscribe = ()=>this.unsubscribe(abort);
        return controller.signal;
    }
    /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */ static source() {
        let cancel;
        const token = new $d0fe4da6d116dd20$var$CancelToken(function executor(c) {
            cancel = c;
        });
        return {
            token: token,
            cancel: cancel
        };
    }
}
var $d0fe4da6d116dd20$export$2e2bcd8739ae039 = $d0fe4da6d116dd20$var$CancelToken;

});

parcelRegister("48rwv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $302d4253679226e7$export$2e2bcd8739ae039; });
"use strict";
function $302d4253679226e7$export$2e2bcd8739ae039(callback) {
    return function wrap(arr) {
        return callback.apply(null, arr);
    };
}

});

parcelRegister("3Fzaq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2ac07aead25e8166$export$2e2bcd8739ae039; });

var $hjVaC = parcelRequire("hjVaC");
"use strict";
function $2ac07aead25e8166$export$2e2bcd8739ae039(payload) {
    return (0, $hjVaC.default).isObject(payload) && payload.isAxiosError === true;
}

});

parcelRegister("hDBVh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cd737ede3f6bb0f3$export$2e2bcd8739ae039; });
const $cd737ede3f6bb0f3$var$HttpStatusCode = {
    Continue: 100,
    SwitchingProtocols: 101,
    Processing: 102,
    EarlyHints: 103,
    Ok: 200,
    Created: 201,
    Accepted: 202,
    NonAuthoritativeInformation: 203,
    NoContent: 204,
    ResetContent: 205,
    PartialContent: 206,
    MultiStatus: 207,
    AlreadyReported: 208,
    ImUsed: 226,
    MultipleChoices: 300,
    MovedPermanently: 301,
    Found: 302,
    SeeOther: 303,
    NotModified: 304,
    UseProxy: 305,
    Unused: 306,
    TemporaryRedirect: 307,
    PermanentRedirect: 308,
    BadRequest: 400,
    Unauthorized: 401,
    PaymentRequired: 402,
    Forbidden: 403,
    NotFound: 404,
    MethodNotAllowed: 405,
    NotAcceptable: 406,
    ProxyAuthenticationRequired: 407,
    RequestTimeout: 408,
    Conflict: 409,
    Gone: 410,
    LengthRequired: 411,
    PreconditionFailed: 412,
    PayloadTooLarge: 413,
    UriTooLong: 414,
    UnsupportedMediaType: 415,
    RangeNotSatisfiable: 416,
    ExpectationFailed: 417,
    ImATeapot: 418,
    MisdirectedRequest: 421,
    UnprocessableEntity: 422,
    Locked: 423,
    FailedDependency: 424,
    TooEarly: 425,
    UpgradeRequired: 426,
    PreconditionRequired: 428,
    TooManyRequests: 429,
    RequestHeaderFieldsTooLarge: 431,
    UnavailableForLegalReasons: 451,
    InternalServerError: 500,
    NotImplemented: 501,
    BadGateway: 502,
    ServiceUnavailable: 503,
    GatewayTimeout: 504,
    HttpVersionNotSupported: 505,
    VariantAlsoNegotiates: 506,
    InsufficientStorage: 507,
    LoopDetected: 508,
    NotExtended: 510,
    NetworkAuthenticationRequired: 511
};
Object.entries($cd737ede3f6bb0f3$var$HttpStatusCode).forEach(([key, value])=>{
    $cd737ede3f6bb0f3$var$HttpStatusCode[value] = key;
});
var $cd737ede3f6bb0f3$export$2e2bcd8739ae039 = $cd737ede3f6bb0f3$var$HttpStatusCode;

});





parcelRegister("6T77I", function(module, exports) {

$parcel$export(module.exports, "outboundAuthClient", function () { return $46b59ef7bcba875f$export$f33e27e3c68b4e90; });

var $20U8t = parcelRequire("20U8t");

var $1Bj4T = parcelRequire("1Bj4T");
var $46b59ef7bcba875f$export$97427506c744357e;
(function(TokenStatus) {
    TokenStatus["Available"] = "available";
    TokenStatus["Expired"] = "expired";
    TokenStatus["RefreshNeeded"] = "refreshNeeded";
    TokenStatus["ServerError"] = "serverError";
})($46b59ef7bcba875f$export$97427506c744357e || ($46b59ef7bcba875f$export$97427506c744357e = {}));
var $46b59ef7bcba875f$export$bf337c9223e5c8b;
(function(ProviderTypes) {
    ProviderTypes["Google"] = "google";
    ProviderTypes["Dropbox"] = "dropbox";
    ProviderTypes["OAuth2"] = "oauth2";
})($46b59ef7bcba875f$export$bf337c9223e5c8b || ($46b59ef7bcba875f$export$bf337c9223e5c8b = {}));
class $46b59ef7bcba875f$var$OutboundAuthClient extends (0, $20U8t.default) {
    getAccounts(aaId) {
        return this.getResource(`/aaId/${aaId}`);
    }
    revokeAccess(aaId, externalAccountId) {
        return this.postResource(`/aaId/${aaId}/removeExternalAccount`, {
            externalAccountId: externalAccountId
        });
    }
}
const $46b59ef7bcba875f$export$f33e27e3c68b4e90 = new $46b59ef7bcba875f$var$OutboundAuthClient({
    serviceUrl: `${(0, $1Bj4T.getConfig)().stargateRoot}/outbound-auth`
});

});

parcelRegister("2X6wq", function(module, exports) {

$parcel$export(module.exports, "oAuthClient", function () { return $f09558f73804df99$export$63f88bbfcc413f5c; });

var $20U8t = parcelRequire("20U8t");

var $1Bj4T = parcelRequire("1Bj4T");
class $f09558f73804df99$var$OAuthClient extends (0, $20U8t.default) {
    revokeRefreshToken(oauthClientId) {
        return this.postResource(`/refreshTokens/user/${oauthClientId}/revoke`);
    }
}
const $f09558f73804df99$export$63f88bbfcc413f5c = new $f09558f73804df99$var$OAuthClient({
    serviceUrl: `${(0, $1Bj4T.getConfig)().stargateRoot}/oauth`
});

});

parcelRegister("eDBap", function(module, exports) {

$parcel$export(module.exports, "GET_CONNECTED_APPS", function () { return $33e78eed53946564$export$2be5cf26faf24cc0; });
$parcel$export(module.exports, "REMOVE_CONNECTED_APP", function () { return $33e78eed53946564$export$3c82012c18cdea48; });
$parcel$export(module.exports, "REMOVE_THIRD_PARTY_CONNECTION", function () { return $33e78eed53946564$export$c903f5d300378b6e; });
$parcel$export(module.exports, "default", function () { return $33e78eed53946564$export$2e2bcd8739ae039; });
const $33e78eed53946564$export$2be5cf26faf24cc0 = "GET_CONNECTED_APPS";
const $33e78eed53946564$export$3c82012c18cdea48 = "REMOVE_CONNECTED_APP";
const $33e78eed53946564$export$c903f5d300378b6e = "REMOVE_THIRD_PARTY_CONNECTION";
const $33e78eed53946564$export$edfa8c498c501378 = (scopeKey, scopeDetails)=>{
    const foundDetails = scopeDetails.find((scope)=>scope.key === scopeKey);
    // in case no description is available we return just the scope key
    // as we must not hide an app's scope from the user
    return foundDetails?.description ? foundDetails.description : scopeKey;
};
const $33e78eed53946564$export$fb2283f4a44fb53 = (ari)=>{
    // extracting resource ids (uuid) from app ari
    const matches = ari.match(/\/[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/);
    return !matches ? ari : matches[0].slice(1);
};
const $33e78eed53946564$export$e865edb83a9d0b57 = (connectedApps, scopeDetails)=>connectedApps.map((app)=>({
            ...app,
            scopes: !scopeDetails ? [] : app.scopes.map((scope)=>$33e78eed53946564$export$edfa8c498c501378(scope, scopeDetails))
        }));
const $33e78eed53946564$export$bc0ef501bb5f98d0 = (accountGrants, outboundAuthConnections)=>{
    let filteredConnections = outboundAuthConnections;
    const appDictionary = accountGrants.reduce((connectedApps, accountGrant)=>{
        if (connectedApps[accountGrant.clientId]) {
            const existingGrant = connectedApps[accountGrant.clientId];
            accountGrant.scopeDetails.map((scope)=>scope.description || scope.key).filter((scope)=>!existingGrant.scopes.find((existing)=>existing === scope)).forEach((scope)=>existingGrant.scopes.push(scope));
        } else {
            const app = accountGrant.appEnvironment?.app;
            if (!app) return connectedApps;
            const { id: id, name: name, description: description, vendorName: vendorName, contactLink: contactLink } = app;
            const appConnections = outboundAuthConnections.filter((connection)=>id && connection.containerId.includes(id));
            // Remove connections that belongs to the app from the list
            filteredConnections = filteredConnections.filter((connection)=>!id || !connection.containerId.includes(id));
            connectedApps[accountGrant.clientId] = {
                accountId: accountGrant.accountId,
                oauthClientId: accountGrant.clientId,
                appDetails: {
                    name: name,
                    description: description,
                    vendorName: vendorName,
                    contactLink: contactLink,
                    avatarUrl: ""
                },
                scopes: accountGrant.scopeDetails.map((scope)=>scope.description || scope.key),
                outboundAuthConnections: appConnections
            };
        }
        return connectedApps;
    }, {});
    return {
        apps: Object.values(appDictionary),
        filteredConnections: filteredConnections
    };
};
const $33e78eed53946564$export$f6449eb939a0311c = (response)=>response.containers.reduce((containerConns, containerWrapper)=>containerWrapper.services.reduce((serviceConns, serviceWrapper)=>serviceWrapper.accounts.reduce((connections, account)=>connections.concat([
                    {
                        accountId: account.id,
                        displayName: account.displayName,
                        containerId: containerWrapper.container.containerId,
                        containerName: containerWrapper.container.displayName,
                        serviceKey: serviceWrapper.service.serviceKey,
                        serviceName: serviceWrapper.service.displayName,
                        addedDate: account.connectedAt,
                        scopes: account.scopes,
                        contextAris: account.contextAris
                    }
                ]), serviceConns), containerConns), []);
const $33e78eed53946564$export$e7ec8a18f6f1d042 = (apps, accountId, oauthClientId)=>{
    return apps.map((app)=>{
        if (app.oauthClientId === oauthClientId) app.outboundAuthConnections = app.outboundAuthConnections?.filter((conn)=>conn.accountId !== accountId);
        return app;
    });
};
const $33e78eed53946564$export$7a5163dc8848f55f = {
    isLoading: true,
    hasLoaded: false,
    hasError: false,
    apps: [],
    outboundAuthConnections: []
};
var $33e78eed53946564$export$2e2bcd8739ae039 = (state = $33e78eed53946564$export$7a5163dc8848f55f, action)=>{
    switch(action.type){
        case `${$33e78eed53946564$export$2be5cf26faf24cc0}_PENDING`:
            return {
                ...state,
                isLoading: true,
                hasLoaded: false,
                hasError: false,
                apps: [],
                outboundAuthConnections: []
            };
        case `${$33e78eed53946564$export$2be5cf26faf24cc0}_FULFILLED`:
            {
                const [outboundAuthPayload, accountGrantsPayload] = action.payload;
                const outboundAuthConnectionsResponse = $33e78eed53946564$export$f6449eb939a0311c(outboundAuthPayload);
                const accountGrants = accountGrantsPayload.oauthClients?.allAccountGrantsForUser.nodes ?? [];
                const transformedResponse = $33e78eed53946564$export$bc0ef501bb5f98d0(accountGrants, outboundAuthConnectionsResponse);
                const apps = transformedResponse.apps;
                const outboundAuthConnections = transformedResponse.filteredConnections;
                return {
                    ...state,
                    isLoading: false,
                    hasLoaded: true,
                    hasError: false,
                    apps: apps,
                    outboundAuthConnections: outboundAuthConnections
                };
            }
        case `${$33e78eed53946564$export$2be5cf26faf24cc0}_REJECTED`:
            return {
                ...state,
                isLoading: false,
                hasLoaded: true,
                hasError: true,
                apps: []
            };
        case `${$33e78eed53946564$export$3c82012c18cdea48}_FULFILLED`:
            {
                const oauthClientId = action.meta.oauthClientId;
                return {
                    ...state,
                    apps: state.apps.filter((app)=>app.oauthClientId !== oauthClientId)
                };
            }
        case `${$33e78eed53946564$export$c903f5d300378b6e}_FULFILLED`:
            {
                const { accountId: accountId, oauthClientId: clientId } = action.meta;
                return {
                    ...state,
                    apps: clientId ? $33e78eed53946564$export$e7ec8a18f6f1d042(state.apps, accountId, clientId) : state.apps,
                    outboundAuthConnections: state.outboundAuthConnections.filter((conn)=>conn.accountId !== accountId)
                };
            }
        default:
            return state;
    }
};

});


parcelRegister("h1Uju", function(module, exports) {

$parcel$export(module.exports, "FieldType", function () { return $96676b550edec36d$export$ed12481c953b8653; });
// Profile details fields
var $96676b550edec36d$export$ed12481c953b8653;
(function(FieldType) {
    FieldType["FullName"] = "fullName";
    FieldType["Nickname"] = "nickname";
    FieldType["Title"] = "title";
    FieldType["Department"] = "department";
    FieldType["CompanyName"] = "companyName";
    FieldType["Location"] = "location";
    FieldType["Timezone"] = "timezone";
    FieldType["Email"] = "email";
    FieldType["PhoneNumber"] = "phoneNumber";
    FieldType["Avatar"] = "picture";
    FieldType["Language"] = "language";
    FieldType["LocalTime"] = "localTime";
})($96676b550edec36d$export$ed12481c953b8653 || ($96676b550edec36d$export$ed12481c953b8653 = {}));

});

parcelRegister("8Bxc9", function(module, exports) {

});


parcelRegister("3P18c", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2c8703232ca49e1d$export$2e2bcd8739ae039; });
var $2c8703232ca49e1d$var$isProduction = true;
var $2c8703232ca49e1d$var$prefix = "Invariant failed";
function $2c8703232ca49e1d$export$2e2bcd8739ae039(condition, message) {
    if (condition) return;
    if ($2c8703232ca49e1d$var$isProduction) throw new Error($2c8703232ca49e1d$var$prefix);
    var provided = typeof message === "function" ? message() : message;
    var value = provided ? "".concat($2c8703232ca49e1d$var$prefix, ": ").concat(provided) : $2c8703232ca49e1d$var$prefix;
    throw new Error(value);
}

});

parcelRegister("4ffTz", function(module, exports) {

$parcel$export(module.exports, "FeatureGate", function () { return $513644608f5a759b$export$d4ba9a3e7000cca8; });
$parcel$export(module.exports, "checkFeatureGate", function () { return $513644608f5a759b$export$bd360271f9be3afb; });

var $fWbo7 = parcelRequire("fWbo7");
var $513644608f5a759b$export$d4ba9a3e7000cca8;
(function(FeatureGate) {
    // https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/gates/enable_en_zz_i18n_locale
    FeatureGate["ENABLE_EN_ZZ_I18N_LOCALE"] = "enable_en_zz_i18n_locale";
    // https://switcheroo.atlassian.com/ui/gates/9ad261f3-f8e3-4588-9f16-44e18dff6f34/key/allow-users-to-remove-themselves-from-site-org
    FeatureGate["ALLOW_USERS_TO_REMOVE_THEMSELVES_FROM_SITES"] = "allow-users-to-remove-themselves-from-site-org";
    // https://switcheroo.atlassian.com/ui/gates/f6291d57-442e-4653-89c9-03f03a91a6fa/key/id-manage-profile-enable-just-in-time-acc-switcher
    FeatureGate["ENABLE_JUST_IN_TIME_ACCOUNT_SWITCHER"] = "id-manage-profile-enable-just-in-time-acc-switcher";
    // https://switcheroo.atlassian.com/ui/gates/654823cd-c467-403f-b46f-72ade138bd24/key/id-manage-profile-enable-in-product-acc-switcher
    FeatureGate["ENABLE_IN_PRODUCT_ACCOUNT_SWITCHER"] = "id-manage-profile-enable-in-product-acc-switcher";
    // https://switcheroo.atlassian.com/ui/gates/bba5bcc6-0480-4ff8-9136-cabc2f017f91/key/id-manage-profile-color-theme-menu-enabled
    FeatureGate["ENABLE_SETTINGS_MENU_AND_COLOR_THEMES"] = "id-manage-profile-color-theme-menu-enabled";
    // https://switcheroo.atlassian.com/ui/gates/324438ec-2fdc-4114-803f-b2233e57438d/key/manage-profile-ui_enable_api_token_expiry_ui
    FeatureGate["ENABLE_API_TOKEN_EXPIRY_DATES"] = "manage-profile-ui_enable_api_token_expiry_ui";
    // https://switcheroo.atlassian.com/ui/gates/8934ca55-20a0-4d76-94f7-2fec38b3526d/key/manage-profile-ui_show_coms_banner_apitoken_expiry_
    // When cleaning up this feature flag, the behaviour should match the flag being set to false.
    // The Comms banner should be removed and not shown after API token expiry feature is rolled out.
    FeatureGate["ENABLE_COMS_BANNER_APITOKEN_EXPIRY_CHANGES"] = "manage-profile-ui_show_coms_banner_apitoken_expiry_";
    // https://switcheroo.atlassian.com/ui/gates/e0968448-b798-46f8-94e5-b53d59593721/key/kirby-7867_scoped_token_creation
    FeatureGate["ENABLE_SCOPED_TOKEN_CREATION"] = "kirby-7867_scoped_token_creation";
    // https://switcheroo.atlassian.com/ui/gates/6bda4109-994c-49f1-8167-7188356d8d6d/key/manage-profiles-id-connected-apps-scopes-mosaic
    FeatureGate["MANAGE_PROFILES_ID_CONNECTED_APPS_SCOPES_MOSAIC"] = "manage-profiles-id-connected-apps-scopes-mosaic";
    // https://switcheroo.atlassian.com/ui/gates/a9c724da-57be-49f9-b685-d33d3c9a2228/key/id-connected-apps-ecosystem-marketplace-app-gql
    FeatureGate["USE_ECOSYSTEM_MARKETPLACE_GQL_IN_GET_APP_CONNECTED_APPS"] = "id-connected-apps-ecosystem-marketplace-app-gql";
})($513644608f5a759b$export$d4ba9a3e7000cca8 || ($513644608f5a759b$export$d4ba9a3e7000cca8 = {}));
const $513644608f5a759b$export$bd360271f9be3afb = (key)=>{
    return (0, $fWbo7.default).initializeCompleted() && (0, $fWbo7.default).checkGate(key);
};

});
parcelRegister("fWbo7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b9a51b3af307f77d$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "DynamicConfig", function () { return (parcelRequire("btpuG")).DynamicConfig; });
$parcel$export(module.exports, "EvaluationReason", function () { return (parcelRequire("btpuG")).EvaluationReason; });
$parcel$export(module.exports, "FeatureGateEnvironment", function () { return (parcelRequire("kvFVg")).FeatureGateEnvironment; });
$parcel$export(module.exports, "PerimeterType", function () { return (parcelRequire("kvFVg")).PerimeterType; });

var $jnkvP = parcelRequire("jnkvP");

var $fSzxJ = parcelRequire("fSzxJ");

var $a6c7b = parcelRequire("a6c7b");

var $bQusk = parcelRequire("bQusk");

var $3OGT6 = parcelRequire("3OGT6");

var $1NEEu = parcelRequire("1NEEu");

var $eLcXj = parcelRequire("eLcXj");

var $btpuG = parcelRequire("btpuG");

var $8nOOE = parcelRequire("8nOOE");

var $kvFVg = parcelRequire("kvFVg");

var $bdCfk = parcelRequire("bdCfk");
var $b9a51b3af307f77d$var$_excluded = [
    "sdkKey",
    "updateUserCompletionCallback",
    "perimeter"
];
function $b9a51b3af307f77d$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $b9a51b3af307f77d$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $b9a51b3af307f77d$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($1NEEu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $b9a51b3af307f77d$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $b9a51b3af307f77d$var$DEFAULT_CLIENT_KEY = "client-default-key";
// the default event logging api is the Atlassian proxy rather than Statsig's domain, to avoid ad blockers
var $b9a51b3af307f77d$var$DEFAULT_EVENT_LOGGING_API = "https://xp.atlassian.com/v1/";
/**
 * Access the FeatureGates object via the default export.
 * ```ts
 * import FeatureGates from '@atlaskit/feature-gate-js-client';
 * ```
 */ var $b9a51b3af307f77d$var$FeatureGates = /*#__PURE__*/ function() {
    function FeatureGates() {
        (0, (/*@__PURE__*/$parcel$interopDefault($bQusk)))(this, FeatureGates);
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($3OGT6)))(FeatureGates, null, [
        {
            key: "initialize",
            value: /**
     * @description
     * This method initializes the client using a network call to fetch the bootstrap values.
     * If the client is inialized with an `analyticsWebClient`, it will send an operational event
     * to GASv3 with the following attributes:
     * - targetApp: the target app of the client
     * - clientVersion: the version of the client
     * - success: whether the initialization was successful
     * - startTime: the time when the initialization started
     * - totalTime: the total time it took to initialize the client
     * - apiKey: the api key used to initialize the client
     * @param clientOptions {ClientOptions}
     * @param identifiers {Identifiers}
     * @param customAttributes {CustomAttributes}
     * @returns {Promise<void>}
     */ function() {
                var _initialize = (0, (/*@__PURE__*/$parcel$interopDefault($a6c7b)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eLcXj))).mark(function _callee(clientOptions, identifiers, customAttributes) {
                    var startTime;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($eLcXj))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                if (!FeatureGates.initPromise) {
                                    _context.next = 3;
                                    break;
                                }
                                if (!FeatureGates.shallowEquals(clientOptions, FeatureGates.initOptions)) // eslint-disable-next-line no-console
                                console.warn("Feature Gates client already initialized with different options. New options were not applied.");
                                return _context.abrupt("return", FeatureGates.initPromise);
                            case 3:
                                startTime = performance.now();
                                FeatureGates.initOptions = clientOptions;
                                FeatureGates.initPromise = FeatureGates.init(clientOptions, identifiers, customAttributes).then(function() {
                                    FeatureGates.initCompleted = true;
                                }).finally(function() {
                                    var endTime = performance.now();
                                    var totalTime = endTime - startTime;
                                    FeatureGates.fireClientEvent(startTime, totalTime, "initialize", FeatureGates.initCompleted, clientOptions.apiKey);
                                });
                                return _context.abrupt("return", FeatureGates.initPromise);
                            case 7:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee);
                }));
                function initialize(_x, _x2, _x3) {
                    return _initialize.apply(this, arguments);
                }
                return initialize;
            }()
        },
        {
            key: "fireClientEvent",
            value: function fireClientEvent(startTime, totalTime, action, success) {
                var _FeatureGates$initOpt;
                var apiKey = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
                (_FeatureGates$initOpt = FeatureGates.initOptions.analyticsWebClient) === null || _FeatureGates$initOpt === void 0 || _FeatureGates$initOpt.then(function(analyticsWebClient) {
                    var attributes = $b9a51b3af307f77d$var$_objectSpread({
                        targetApp: FeatureGates.initOptions.targetApp,
                        clientVersion: (0, $bdCfk.CLIENT_VERSION),
                        success: success,
                        startTime: startTime,
                        totalTime: totalTime
                    }, apiKey && {
                        apiKey: apiKey
                    });
                    analyticsWebClient.sendOperationalEvent({
                        action: action,
                        actionSubject: "featureGatesClient",
                        attributes: attributes,
                        tags: [
                            "measurement"
                        ],
                        source: "@atlaskit/feature-gate-js-client"
                    });
                }).catch(function(err) {
                    if (FeatureGates.initOptions.environment !== (0, $kvFVg.FeatureGateEnvironment).Production) // eslint-disable-next-line no-console
                    console.error("Analytics web client promise did not resolve", err);
                });
            }
        },
        {
            key: "initializeFromValues",
            value: function() {
                var _initializeFromValues = (0, (/*@__PURE__*/$parcel$interopDefault($a6c7b)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eLcXj))).mark(function _callee2(clientOptions, identifiers, customAttributes) {
                    var initializeValues, startTime, _args2 = arguments;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($eLcXj))).wrap(function _callee2$(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                initializeValues = _args2.length > 3 && _args2[3] !== undefined ? _args2[3] : {};
                                if (!FeatureGates.initPromise) {
                                    _context2.next = 4;
                                    break;
                                }
                                if (!FeatureGates.shallowEquals(clientOptions, FeatureGates.initOptions)) // eslint-disable-next-line no-console
                                console.warn("Feature Gates client already initialized with different options. New options were not applied.");
                                return _context2.abrupt("return", FeatureGates.initPromise);
                            case 4:
                                startTime = performance.now();
                                FeatureGates.initOptions = clientOptions;
                                FeatureGates.initPromise = FeatureGates.initFromValues(clientOptions, identifiers, customAttributes, initializeValues).then(function() {
                                    FeatureGates.initCompleted = true;
                                }).finally(function() {
                                    var endTime = performance.now();
                                    var totalTime = endTime - startTime;
                                    FeatureGates.fireClientEvent(startTime, totalTime, "initializeFromValues", FeatureGates.initCompleted);
                                });
                                return _context2.abrupt("return", FeatureGates.initPromise);
                            case 8:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2);
                }));
                function initializeFromValues(_x4, _x5, _x6) {
                    return _initializeFromValues.apply(this, arguments);
                }
                return initializeFromValues;
            }()
        },
        {
            key: "updateUser",
            value: function() {
                var _updateUser = (0, (/*@__PURE__*/$parcel$interopDefault($a6c7b)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eLcXj))).mark(function _callee3(fetchOptions, identifiers, customAttributes) {
                    var initializeValuesProducer;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($eLcXj))).wrap(function _callee3$(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                initializeValuesProducer = function initializeValuesProducer() {
                                    return (0, $8nOOE.default).fetchExperimentValues(fetchOptions, identifiers, customAttributes).then(function(_ref) {
                                        var experimentValues = _ref.experimentValues, customAttributes = _ref.customAttributes;
                                        return {
                                            experimentValues: experimentValues,
                                            customAttributesFromFetch: customAttributes
                                        };
                                    });
                                };
                                _context3.next = 3;
                                return FeatureGates.updateUserUsingInitializeValuesProducer(initializeValuesProducer, identifiers, customAttributes);
                            case 3:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3);
                }));
                function updateUser(_x7, _x8, _x9) {
                    return _updateUser.apply(this, arguments);
                }
                return updateUser;
            }()
        },
        {
            key: "updateUserWithValues",
            value: function() {
                var _updateUserWithValues = (0, (/*@__PURE__*/$parcel$interopDefault($a6c7b)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eLcXj))).mark(function _callee4(identifiers, customAttributes) {
                    var initializeValues, initializeValuesProducer, _args4 = arguments;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($eLcXj))).wrap(function _callee4$(_context4) {
                        while(true)switch(_context4.prev = _context4.next){
                            case 0:
                                initializeValues = _args4.length > 2 && _args4[2] !== undefined ? _args4[2] : {};
                                initializeValuesProducer = function initializeValuesProducer() {
                                    return Promise.resolve({
                                        experimentValues: initializeValues,
                                        customAttributesFromFetch: customAttributes
                                    });
                                };
                                _context4.next = 4;
                                return FeatureGates.updateUserUsingInitializeValuesProducer(initializeValuesProducer, identifiers, customAttributes);
                            case 4:
                            case "end":
                                return _context4.stop();
                        }
                    }, _callee4);
                }));
                function updateUserWithValues(_x10, _x11) {
                    return _updateUserWithValues.apply(this, arguments);
                }
                return updateUserWithValues;
            }()
        },
        {
            key: "initializeCalled",
            value: function initializeCalled() {
                return FeatureGates.initPromise != null;
            }
        },
        {
            key: "initializeCompleted",
            value: function initializeCompleted() {
                return FeatureGates.initCompleted;
            }
        },
        {
            key: "checkGate",
            value: function checkGate(gateName) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                try {
                    var _options$fireGateExpo = options.fireGateExposure, fireGateExposure = _options$fireGateExpo === void 0 ? true : _options$fireGateExpo;
                    var evalMethod = fireGateExposure ? (0, (/*@__PURE__*/$parcel$interopDefault($btpuG))).checkGate.bind((0, (/*@__PURE__*/$parcel$interopDefault($btpuG)))) : (0, (/*@__PURE__*/$parcel$interopDefault($btpuG))).checkGateWithExposureLoggingDisabled.bind((0, (/*@__PURE__*/$parcel$interopDefault($btpuG))));
                    return evalMethod(gateName);
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!FeatureGates.hasCheckGateErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: "An error has occurred checking the feature gate. Only the first occurrence of this error is logged.",
                            gateName: gateName,
                            error: error
                        });
                        FeatureGates.hasCheckGateErrorOccurred = true;
                    }
                    return false;
                }
            }
        },
        {
            key: "manuallyLogGateExposure",
            value: function manuallyLogGateExposure(gateName) {
                (0, (/*@__PURE__*/$parcel$interopDefault($btpuG))).manuallyLogGateExposure(gateName);
            }
        },
        {
            key: "getExperiment",
            value: function getExperiment(experimentName) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                try {
                    var _options$fireExperime = options.fireExperimentExposure, fireExperimentExposure = _options$fireExperime === void 0 ? true : _options$fireExperime;
                    var evalMethod = fireExperimentExposure ? (0, (/*@__PURE__*/$parcel$interopDefault($btpuG))).getExperiment.bind((0, (/*@__PURE__*/$parcel$interopDefault($btpuG)))) : (0, (/*@__PURE__*/$parcel$interopDefault($btpuG))).getExperimentWithExposureLoggingDisabled.bind((0, (/*@__PURE__*/$parcel$interopDefault($btpuG))));
                    return evalMethod(experimentName);
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!FeatureGates.hasGetExperimentErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: "An error has occurred getting the experiment. Only the first occurrence of this error is logged.",
                            experimentName: experimentName,
                            error: error
                        });
                        FeatureGates.hasGetExperimentErrorOccurred = true;
                    }
                    // Return a default value
                    return new (0, $btpuG.DynamicConfig)(experimentName, {}, "", {
                        time: Date.now(),
                        reason: (0, $btpuG.EvaluationReason).Error
                    });
                }
            }
        },
        {
            key: "getExperimentValue",
            value: function getExperimentValue(experimentName, parameterName, defaultValue) {
                var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var experiment = FeatureGates.getExperiment(experimentName, options);
                try {
                    var typeGuard = options.typeGuard;
                    return experiment.get(parameterName, defaultValue, typeGuard);
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!FeatureGates.hasGetExperimentValueErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: "An error has occurred getting the experiment value. Only the first occurrence of this error is logged.",
                            experimentName: experimentName,
                            defaultValue: defaultValue,
                            options: options,
                            error: error
                        });
                        FeatureGates.hasGetExperimentValueErrorOccurred = true;
                    }
                    return defaultValue;
                }
            }
        },
        {
            key: "manuallyLogExperimentExposure",
            value: function manuallyLogExperimentExposure(experimentName) {
                (0, (/*@__PURE__*/$parcel$interopDefault($btpuG))).manuallyLogExperimentExposure(experimentName);
            }
        },
        {
            key: "manuallyLogLayerExposure",
            value: function manuallyLogLayerExposure(layerName, parameterName) {
                (0, (/*@__PURE__*/$parcel$interopDefault($btpuG))).manuallyLogLayerParameterExposure(layerName, parameterName);
            }
        },
        {
            key: "shutdownStatsig",
            value: function shutdownStatsig() {
                (0, (/*@__PURE__*/$parcel$interopDefault($btpuG))).shutdown();
            }
        },
        {
            key: "overrideGate",
            value: function overrideGate(gateName, value) {
                (0, (/*@__PURE__*/$parcel$interopDefault($btpuG))).overrideGate(gateName, value);
            }
        },
        {
            key: "clearGateOverride",
            value: function clearGateOverride(gateName) {
                (0, (/*@__PURE__*/$parcel$interopDefault($btpuG))).overrideGate(gateName, null);
            }
        },
        {
            key: "overrideConfig",
            value: function overrideConfig(experimentName, values) {
                (0, (/*@__PURE__*/$parcel$interopDefault($btpuG))).overrideConfig(experimentName, values);
            }
        },
        {
            key: "clearConfigOverride",
            value: function clearConfigOverride(experimentName) {
                (0, (/*@__PURE__*/$parcel$interopDefault($btpuG))).overrideConfig(experimentName, null);
            }
        },
        {
            key: "setOverrides",
            value: function setOverrides(overrides) {
                (0, (/*@__PURE__*/$parcel$interopDefault($btpuG))).setOverrides($b9a51b3af307f77d$var$_objectSpread({
                    gates: {},
                    configs: {},
                    layers: {}
                }, overrides));
            }
        },
        {
            key: "getOverrides",
            value: function getOverrides() {
                return (0, (/*@__PURE__*/$parcel$interopDefault($btpuG))).getOverrides();
            }
        },
        {
            key: "clearAllOverrides",
            value: function clearAllOverrides() {
                (0, (/*@__PURE__*/$parcel$interopDefault($btpuG))).setOverrides(null);
            }
        },
        {
            key: "isCurrentUser",
            value: function isCurrentUser(identifiers, customAttributes) {
                return FeatureGates.shallowEquals(FeatureGates.currentIdentifiers, identifiers) && FeatureGates.shallowEquals(FeatureGates.currentAttributes, customAttributes);
            }
        },
        {
            key: "init",
            value: function() {
                var _init = (0, (/*@__PURE__*/$parcel$interopDefault($a6c7b)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eLcXj))).mark(function _callee5(clientOptions, identifiers, customAttributes) {
                    var fromValuesClientOptions, experimentValues, customAttributesFromResult, clientSdkKeyPromise, experimentValuesPromise, _yield$Promise$all, _yield$Promise$all2, experimentValuesResult;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($eLcXj))).wrap(function _callee5$(_context5) {
                        while(true)switch(_context5.prev = _context5.next){
                            case 0:
                                fromValuesClientOptions = $b9a51b3af307f77d$var$_objectSpread($b9a51b3af307f77d$var$_objectSpread({}, clientOptions), {}, {
                                    disableCurrentPageLogging: true
                                });
                                _context5.prev = 1;
                                // If client sdk key fetch fails, an error would be thrown and handled instead of waiting for the experiment
                                // values request to be settled, and it will fall back to use default values.
                                clientSdkKeyPromise = (0, $8nOOE.default).fetchClientSdk(clientOptions).then(function(value) {
                                    return fromValuesClientOptions.sdkKey = value.clientSdkKey;
                                });
                                experimentValuesPromise = (0, $8nOOE.default).fetchExperimentValues(clientOptions, identifiers, customAttributes); // Only wait for the experiment values request to finish and try to initialise the client with experiment
                                // values if both requests are successful. Else an error would be thrown and handled by the catch
                                _context5.next = 6;
                                return Promise.all([
                                    clientSdkKeyPromise,
                                    experimentValuesPromise
                                ]);
                            case 6:
                                _yield$Promise$all = _context5.sent;
                                _yield$Promise$all2 = (0, (/*@__PURE__*/$parcel$interopDefault($fSzxJ)))(_yield$Promise$all, 2);
                                experimentValuesResult = _yield$Promise$all2[1];
                                experimentValues = experimentValuesResult.experimentValues;
                                customAttributesFromResult = experimentValuesResult.customAttributes;
                                _context5.next = 20;
                                break;
                            case 13:
                                _context5.prev = 13;
                                _context5.t0 = _context5["catch"](1);
                                if (_context5.t0 instanceof Error) // eslint-disable-next-line no-console
                                console.error("Error occurred when trying to fetch the Feature Gates client values, error: ".concat(_context5.t0 === null || _context5.t0 === void 0 ? void 0 : _context5.t0.message));
                                // eslint-disable-next-line no-console
                                console.warn("Initialising Statsig client without values");
                                _context5.next = 19;
                                return FeatureGates.initFromValues(fromValuesClientOptions, identifiers, customAttributes);
                            case 19:
                                throw _context5.t0;
                            case 20:
                                _context5.next = 22;
                                return this.initFromValues(fromValuesClientOptions, identifiers, customAttributesFromResult, experimentValues);
                            case 22:
                            case "end":
                                return _context5.stop();
                        }
                    }, _callee5, this, [
                        [
                            1,
                            13
                        ]
                    ]);
                }));
                function init(_x12, _x13, _x14) {
                    return _init.apply(this, arguments);
                }
                return init;
            }()
        },
        {
            key: "initFromValues",
            value: function() {
                var _initFromValues = (0, (/*@__PURE__*/$parcel$interopDefault($a6c7b)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eLcXj))).mark(function _callee6(clientOptions, identifiers, customAttributes) {
                    var initializeValues, user, sdkKey, statsigOptions, _args6 = arguments;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($eLcXj))).wrap(function _callee6$(_context6) {
                        while(true)switch(_context6.prev = _context6.next){
                            case 0:
                                initializeValues = _args6.length > 3 && _args6[3] !== undefined ? _args6[3] : {};
                                user = this.toStatsigUser(identifiers, customAttributes);
                                FeatureGates.currentIdentifiers = identifiers;
                                FeatureGates.currentAttributes = customAttributes;
                                if (!clientOptions.sdkKey) clientOptions.sdkKey = $b9a51b3af307f77d$var$DEFAULT_CLIENT_KEY;
                                if (!clientOptions.eventLoggingApi) clientOptions.eventLoggingApi = $b9a51b3af307f77d$var$DEFAULT_EVENT_LOGGING_API;
                                if (clientOptions.perimeter === (0, $kvFVg.PerimeterType).FEDRAMP_MODERATE) // disable all logging in FedRAMP to prevent egress of sensitive data
                                clientOptions.disableAllLogging = true;
                                sdkKey = clientOptions.sdkKey;
                                statsigOptions = this.toStatsigOptions(clientOptions, initializeValues);
                                _context6.prev = 9;
                                _context6.next = 12;
                                return (0, (/*@__PURE__*/$parcel$interopDefault($btpuG))).initialize(sdkKey, user, statsigOptions);
                            case 12:
                                _context6.next = 21;
                                break;
                            case 14:
                                _context6.prev = 14;
                                _context6.t0 = _context6["catch"](9);
                                if (_context6.t0 instanceof Error) // eslint-disable-next-line no-console
                                console.error("Error occurred when trying to initialise the Statsig client, error: ".concat(_context6.t0 === null || _context6.t0 === void 0 ? void 0 : _context6.t0.message));
                                // eslint-disable-next-line no-console
                                console.warn("Initialising Statsig client with default sdk key and without values");
                                _context6.next = 20;
                                return (0, (/*@__PURE__*/$parcel$interopDefault($btpuG))).initialize($b9a51b3af307f77d$var$DEFAULT_CLIENT_KEY, user, $b9a51b3af307f77d$var$_objectSpread($b9a51b3af307f77d$var$_objectSpread({}, statsigOptions), {}, {
                                    initializeValues: {}
                                }));
                            case 20:
                                throw _context6.t0;
                            case 21:
                            case "end":
                                return _context6.stop();
                        }
                    }, _callee6, this, [
                        [
                            9,
                            14
                        ]
                    ]);
                }));
                function initFromValues(_x15, _x16, _x17) {
                    return _initFromValues.apply(this, arguments);
                }
                return initFromValues;
            }()
        },
        {
            key: "toStatsigUser",
            value: function toStatsigUser(identifiers, customAttributes) {
                var user = {
                    customIDs: identifiers,
                    custom: customAttributes
                };
                if (identifiers.atlassianAccountId) user.userID = identifiers.atlassianAccountId;
                return user;
            }
        },
        {
            key: "updateUserUsingInitializeValuesProducer",
            value: function() {
                var _updateUserUsingInitializeValuesProducer = (0, (/*@__PURE__*/$parcel$interopDefault($a6c7b)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eLcXj))).mark(function _callee7(getInitializeValues, identifiers, customAttributes) {
                    var originalInitPromise, initializeValuesPromise, updateUserPromise;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($eLcXj))).wrap(function _callee7$(_context7) {
                        while(true)switch(_context7.prev = _context7.next){
                            case 0:
                                if (FeatureGates.initPromise) {
                                    _context7.next = 2;
                                    break;
                                }
                                throw new Error("The FeatureGates client must be initialized before you can update the user.");
                            case 2:
                                if (!FeatureGates.isCurrentUser(identifiers, customAttributes)) {
                                    _context7.next = 4;
                                    break;
                                }
                                return _context7.abrupt("return", FeatureGates.initPromise);
                            case 4:
                                // Wait for the current initialize/update to finish
                                originalInitPromise = FeatureGates.initPromise;
                                _context7.prev = 5;
                                _context7.next = 8;
                                return FeatureGates.initPromise;
                            case 8:
                                _context7.next = 12;
                                break;
                            case 10:
                                _context7.prev = 10;
                                _context7.t0 = _context7["catch"](5);
                            case 12:
                                initializeValuesPromise = getInitializeValues();
                                updateUserPromise = FeatureGates.updateStatsigClientUser(initializeValuesPromise, identifiers, customAttributes); // We replace the init promise here since we are essentially re-initializing the client at this point.
                                // Any subsequent calls to await FeatureGates.initialize() or FeatureGates.updateUser() will now also await this user update.
                                FeatureGates.initPromise = updateUserPromise.catch(function() {
                                    // If the update failed then it changed nothing, so revert back to the original promise.
                                    FeatureGates.initPromise = originalInitPromise;
                                });
                                return _context7.abrupt("return", updateUserPromise);
                            case 16:
                            case "end":
                                return _context7.stop();
                        }
                    }, _callee7, null, [
                        [
                            5,
                            10
                        ]
                    ]);
                }));
                function updateUserUsingInitializeValuesProducer(_x18, _x19, _x20) {
                    return _updateUserUsingInitializeValuesProducer.apply(this, arguments);
                }
                return updateUserUsingInitializeValuesProducer;
            }()
        },
        {
            key: "updateStatsigClientUser",
            value: function() {
                var _updateStatsigClientUser = (0, (/*@__PURE__*/$parcel$interopDefault($a6c7b)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eLcXj))).mark(function _callee8(initializeValuesPromise, identifiers, customAttributes) {
                    var initializeValues, user, _FeatureGates$initOpt2, _FeatureGates$initOpt3, errMsg, success;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($eLcXj))).wrap(function _callee8$(_context8) {
                        while(true)switch(_context8.prev = _context8.next){
                            case 0:
                                _context8.prev = 0;
                                _context8.next = 3;
                                return initializeValuesPromise;
                            case 3:
                                initializeValues = _context8.sent;
                                user = FeatureGates.toStatsigUser(identifiers, initializeValues.customAttributesFromFetch);
                                _context8.next = 12;
                                break;
                            case 7:
                                _context8.prev = 7;
                                _context8.t0 = _context8["catch"](0);
                                // Make sure the updateUserCompletionCallback is called for any errors in our custom code.
                                // This is not necessary for the updateUserWithValues call, because the Statsig client will already invoke the callback itself.
                                errMsg = _context8.t0 instanceof Error ? _context8.t0.message : JSON.stringify(_context8.t0);
                                (_FeatureGates$initOpt2 = (_FeatureGates$initOpt3 = FeatureGates.initOptions).updateUserCompletionCallback) === null || _FeatureGates$initOpt2 === void 0 || _FeatureGates$initOpt2.call(_FeatureGates$initOpt3, false, errMsg);
                                throw _context8.t0;
                            case 12:
                                success = (0, (/*@__PURE__*/$parcel$interopDefault($btpuG))).updateUserWithValues(user, initializeValues.experimentValues);
                                if (!success) {
                                    _context8.next = 18;
                                    break;
                                }
                                FeatureGates.currentIdentifiers = identifiers;
                                FeatureGates.currentAttributes = customAttributes;
                                _context8.next = 19;
                                break;
                            case 18:
                                throw new Error("Failed to update user. An unexpected error occured.");
                            case 19:
                            case "end":
                                return _context8.stop();
                        }
                    }, _callee8, null, [
                        [
                            0,
                            7
                        ]
                    ]);
                }));
                function updateStatsigClientUser(_x21, _x22, _x23) {
                    return _updateStatsigClientUser.apply(this, arguments);
                }
                return updateStatsigClientUser;
            }()
        },
        {
            key: "toStatsigOptions",
            value: function toStatsigOptions(options, initializeValues) {
                var sdkKey = options.sdkKey, updateUserCompletionCallback = options.updateUserCompletionCallback, perimeter = options.perimeter, restClientOptions = (0, (/*@__PURE__*/$parcel$interopDefault($jnkvP)))(options, $b9a51b3af307f77d$var$_excluded);
                return $b9a51b3af307f77d$var$_objectSpread($b9a51b3af307f77d$var$_objectSpread({}, restClientOptions), {}, {
                    initializeValues: initializeValues,
                    environment: {
                        tier: options.environment
                    },
                    disableCurrentPageLogging: true
                }, options.updateUserCompletionCallback && {
                    updateUserCompletionCallback: FeatureGates.toStatsigUpdateUserCompletionCallback(options.updateUserCompletionCallback)
                });
            }
        },
        {
            key: "toStatsigUpdateUserCompletionCallback",
            value: function toStatsigUpdateUserCompletionCallback(callback) {
                /**
       * The duration passed to the callback indicates how long the update took, but it is deceptive since it only times the
       * Statsig code and doesn't account for all of the extra custom work we do to obtain the bootstrap values.
       * As a result, we just suppress this parameter in our own callback rather than trying to keep it accurate.
       */ return function(_duration, success, message) {
                    callback(success, message);
                };
            }
        },
        {
            key: "shallowEquals",
            value: function shallowEquals(objectA, objectB) {
                if (!objectA && !objectB) return true;
                if (!objectA || !objectB) return false;
                var aEntries = Object.entries(objectA);
                var bEntries = Object.entries(objectB);
                if (aEntries.length !== bEntries.length) return false;
                var ascendingKeyOrder = function ascendingKeyOrder(_ref2, _ref3) {
                    var _ref4 = (0, (/*@__PURE__*/$parcel$interopDefault($fSzxJ)))(_ref2, 1), key1 = _ref4[0];
                    var _ref5 = (0, (/*@__PURE__*/$parcel$interopDefault($fSzxJ)))(_ref3, 1), key2 = _ref5[0];
                    return key1.localeCompare(key2);
                };
                aEntries.sort(ascendingKeyOrder);
                bEntries.sort(ascendingKeyOrder);
                for(var i = 0; i < aEntries.length; i++){
                    var _aEntries$i = (0, (/*@__PURE__*/$parcel$interopDefault($fSzxJ)))(aEntries[i], 2), aValue = _aEntries$i[1];
                    var _bEntries$i = (0, (/*@__PURE__*/$parcel$interopDefault($fSzxJ)))(bEntries[i], 2), bValue = _bEntries$i[1];
                    if (aValue !== bValue) return false;
                }
                return true;
            }
        },
        {
            key: "getPackageVersion",
            value: function getPackageVersion() {
                return 0, $bdCfk.CLIENT_VERSION;
            }
        },
        {
            key: "getLayer",
            value: function getLayer(layerName) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                try {
                    var _options$fireLayerExp = options.fireLayerExposure, fireLayerExposure = _options$fireLayerExp === void 0 ? true : _options$fireLayerExp;
                    var evalMethod = fireLayerExposure ? (0, (/*@__PURE__*/$parcel$interopDefault($btpuG))).getLayer.bind((0, (/*@__PURE__*/$parcel$interopDefault($btpuG)))) : (0, (/*@__PURE__*/$parcel$interopDefault($btpuG))).getLayerWithExposureLoggingDisabled.bind((0, (/*@__PURE__*/$parcel$interopDefault($btpuG))));
                    return evalMethod(layerName);
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!FeatureGates.hasGetLayerErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: "An error has occurred getting the layer. Only the first occurrence of this error is logged.",
                            layerName: layerName,
                            error: error
                        });
                        FeatureGates.hasGetLayerErrorOccurred = true;
                    }
                    // Return a default value
                    return (0, $btpuG.Layer)._create(layerName, {}, "", {
                        time: Date.now(),
                        reason: (0, $btpuG.EvaluationReason).Error
                    });
                }
            }
        },
        {
            key: "getLayerValue",
            value: function getLayerValue(layerName, parameterName, defaultValue) {
                var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var layer = FeatureGates.getLayer(layerName, options);
                try {
                    var typeGuard = options.typeGuard;
                    return layer.get(parameterName, defaultValue, typeGuard);
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!FeatureGates.hasGetLayerValueErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: "An error has occurred getting the layer value. Only the first occurrence of this error is logged.",
                            layerName: layerName,
                            defaultValue: defaultValue,
                            options: options,
                            error: error
                        });
                        FeatureGates.hasGetLayerValueErrorOccurred = true;
                    }
                    return defaultValue;
                }
            }
        }
    ]);
    return FeatureGates;
}();
(0, (/*@__PURE__*/$parcel$interopDefault($1NEEu)))($b9a51b3af307f77d$var$FeatureGates, "initPromise", null);
(0, (/*@__PURE__*/$parcel$interopDefault($1NEEu)))($b9a51b3af307f77d$var$FeatureGates, "initCompleted", false);
(0, (/*@__PURE__*/$parcel$interopDefault($1NEEu)))($b9a51b3af307f77d$var$FeatureGates, "hasGetExperimentErrorOccurred", false);
(0, (/*@__PURE__*/$parcel$interopDefault($1NEEu)))($b9a51b3af307f77d$var$FeatureGates, "hasGetExperimentValueErrorOccurred", false);
(0, (/*@__PURE__*/$parcel$interopDefault($1NEEu)))($b9a51b3af307f77d$var$FeatureGates, "hasGetLayerErrorOccurred", false);
(0, (/*@__PURE__*/$parcel$interopDefault($1NEEu)))($b9a51b3af307f77d$var$FeatureGates, "hasGetLayerValueErrorOccurred", false);
(0, (/*@__PURE__*/$parcel$interopDefault($1NEEu)))($b9a51b3af307f77d$var$FeatureGates, "hasCheckGateErrorOccurred", false);
var $b9a51b3af307f77d$var$boundFGJS = $b9a51b3af307f77d$var$FeatureGates;
// This makes it possible to get a reference to the FeatureGates client at runtime.
// This is important for overriding values in Cyprus tests, as there needs to be a
// way to get the exact instance for a window in order to mock some of its methods.
if (typeof window !== "undefined") {
    if (window.__FEATUREGATES_JS__ === undefined) window.__FEATUREGATES_JS__ = $b9a51b3af307f77d$var$FeatureGates;
    else {
        var $b9a51b3af307f77d$var$_boundFGJS, $b9a51b3af307f77d$var$_boundFGJS$getPackage;
        $b9a51b3af307f77d$var$boundFGJS = window.__FEATUREGATES_JS__;
        var $b9a51b3af307f77d$var$boundVersion = (($b9a51b3af307f77d$var$_boundFGJS = $b9a51b3af307f77d$var$boundFGJS) === null || $b9a51b3af307f77d$var$_boundFGJS === void 0 || ($b9a51b3af307f77d$var$_boundFGJS$getPackage = $b9a51b3af307f77d$var$_boundFGJS.getPackageVersion) === null || $b9a51b3af307f77d$var$_boundFGJS$getPackage === void 0 ? void 0 : $b9a51b3af307f77d$var$_boundFGJS$getPackage.call($b9a51b3af307f77d$var$_boundFGJS)) || "4.10.0 or earlier";
        if ($b9a51b3af307f77d$var$boundVersion !== (0, $bdCfk.CLIENT_VERSION)) {
            var $b9a51b3af307f77d$var$message = "Multiple versions of FeatureGateClients found on the current page.\n      The currently bound version is ".concat($b9a51b3af307f77d$var$boundVersion, " when module version ").concat((0, $bdCfk.CLIENT_VERSION), " was loading.");
            // eslint-disable-next-line no-console
            console.warn($b9a51b3af307f77d$var$message);
        }
    }
}
var /**
 * @property {FeatureGates} FeatureGate default export
 */ $b9a51b3af307f77d$export$2e2bcd8739ae039 = $b9a51b3af307f77d$var$boundFGJS;

});
parcelRegister("jnkvP", function(module, exports) {

var $rfcKb = parcelRequire("rfcKb");
function $e1b013a23945f24c$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $rfcKb(e, t);
    if (Object.getOwnPropertySymbols) {
        var s = Object.getOwnPropertySymbols(e);
        for(r = 0; r < s.length; r++)o = s[r], t.includes(o) || ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
module.exports = $e1b013a23945f24c$var$_objectWithoutProperties, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("rfcKb", function(module, exports) {
function $051e5109a2a02f02$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.includes(n)) continue;
        t[n] = r[n];
    }
    return t;
}
module.exports = $051e5109a2a02f02$var$_objectWithoutPropertiesLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("fSzxJ", function(module, exports) {

var $jO4bQ = parcelRequire("jO4bQ");

var $dYc6I = parcelRequire("dYc6I");

var $1wF0H = parcelRequire("1wF0H");

var $gwQLA = parcelRequire("gwQLA");
function $b8f7784a64f22b7f$var$_slicedToArray(r, e) {
    return $jO4bQ(r) || $dYc6I(r, e) || $1wF0H(r, e) || $gwQLA();
}
module.exports = $b8f7784a64f22b7f$var$_slicedToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("jO4bQ", function(module, exports) {
function $e6b5efdcc987ccb0$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
module.exports = $e6b5efdcc987ccb0$var$_arrayWithHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("dYc6I", function(module, exports) {
function $a2ba45378510df20$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
module.exports = $a2ba45378510df20$var$_iterableToArrayLimit, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("1wF0H", function(module, exports) {

var $2I6QF = parcelRequire("2I6QF");
function $11c8975f788d9c4a$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $2I6QF(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $2I6QF(r, a) : void 0;
    }
}
module.exports = $11c8975f788d9c4a$var$_unsupportedIterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("2I6QF", function(module, exports) {
function $1f9500c82e734dd1$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
module.exports = $1f9500c82e734dd1$var$_arrayLikeToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("gwQLA", function(module, exports) {
function $c08890d493a39704$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
module.exports = $c08890d493a39704$var$_nonIterableRest, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("a6c7b", function(module, exports) {
function $75a3dca9dee4c884$var$asyncGeneratorStep(n, t, e, r, o, a, c) {
    try {
        var i = n[a](c), u = i.value;
    } catch (n) {
        return void e(n);
    }
    i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function $75a3dca9dee4c884$var$_asyncToGenerator(n) {
    return function() {
        var t = this, e = arguments;
        return new Promise(function(r, o) {
            var a = n.apply(t, e);
            function _next(n) {
                $75a3dca9dee4c884$var$asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
            }
            function _throw(n) {
                $75a3dca9dee4c884$var$asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
            }
            _next(void 0);
        });
    };
}
module.exports = $75a3dca9dee4c884$var$_asyncToGenerator, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("bQusk", function(module, exports) {
function $89fc2ced03ca1825$var$_classCallCheck(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
module.exports = $89fc2ced03ca1825$var$_classCallCheck, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("3OGT6", function(module, exports) {

var $bySzh = parcelRequire("bySzh");
function $2c774f3c4cfe4fd3$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, $bySzh(o.key), o);
    }
}
function $2c774f3c4cfe4fd3$var$_createClass(e, r, t) {
    return r && $2c774f3c4cfe4fd3$var$_defineProperties(e.prototype, r), t && $2c774f3c4cfe4fd3$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}
module.exports = $2c774f3c4cfe4fd3$var$_createClass, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("bySzh", function(module, exports) {

var $1ooHa = parcelRequire("1ooHa");
var $86ad32c6e38d09c3$var$_typeof = $1ooHa.default;

var $hQhU7 = parcelRequire("hQhU7");
function $86ad32c6e38d09c3$var$toPropertyKey(t) {
    var i = $hQhU7(t, "string");
    return "symbol" == $86ad32c6e38d09c3$var$_typeof(i) ? i : i + "";
}
module.exports = $86ad32c6e38d09c3$var$toPropertyKey, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("1ooHa", function(module, exports) {
function $103b304f09a64a3e$var$_typeof(o) {
    "@babel/helpers - typeof";
    return module.exports = $103b304f09a64a3e$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $103b304f09a64a3e$var$_typeof(o);
}
module.exports = $103b304f09a64a3e$var$_typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("hQhU7", function(module, exports) {

var $1ooHa = parcelRequire("1ooHa");
var $cfd52e67c5e77fdf$var$_typeof = $1ooHa.default;
function $cfd52e67c5e77fdf$var$toPrimitive(t, r) {
    if ("object" != $cfd52e67c5e77fdf$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $cfd52e67c5e77fdf$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
module.exports = $cfd52e67c5e77fdf$var$toPrimitive, module.exports.__esModule = true, module.exports["default"] = module.exports;

});



parcelRegister("1NEEu", function(module, exports) {

var $bySzh = parcelRequire("bySzh");
function $14f9e6b2f8e7d256$var$_defineProperty(e, r, t) {
    return (r = $bySzh(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
module.exports = $14f9e6b2f8e7d256$var$_defineProperty, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("eLcXj", function(module, exports) {
// TODO(Babel 8): Remove this file.

var $abef8132c5ea4fc1$var$runtime = (parcelRequire("61krd"))();
module.exports = $abef8132c5ea4fc1$var$runtime;
// Copied from https://github.com/facebook/regenerator/blob/main/packages/runtime/runtime.js#L736=
try {
    regeneratorRuntime = $abef8132c5ea4fc1$var$runtime;
} catch (accidentalStrictMode) {
    if (typeof globalThis === "object") globalThis.regeneratorRuntime = $abef8132c5ea4fc1$var$runtime;
    else Function("r", "regeneratorRuntime = r")($abef8132c5ea4fc1$var$runtime);
}

});
parcelRegister("61krd", function(module, exports) {

var $1ooHa = parcelRequire("1ooHa");
var $4622b0a244b7c141$var$_typeof = $1ooHa.default;
function $4622b0a244b7c141$var$_regeneratorRuntime() {
    "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ 
    module.exports = $4622b0a244b7c141$var$_regeneratorRuntime = function _regeneratorRuntime() {
        return e;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports;
    var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function(t, e, r) {
        t[e] = r.value;
    }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag";
    function define(t, e, r) {
        return Object.defineProperty(t, e, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }), t[e];
    }
    try {
        define({}, "");
    } catch (t) {
        define = function define(t, e, r) {
            return t[e] = r;
        };
    }
    function wrap(t, e, r, n) {
        var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []);
        return o(a, "_invoke", {
            value: makeInvokeMethod(t, r, c)
        }), a;
    }
    function tryCatch(t, e, r) {
        try {
            return {
                type: "normal",
                arg: t.call(e, r)
            };
        } catch (t) {
            return {
                type: "throw",
                arg: t
            };
        }
    }
    e.wrap = wrap;
    var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {};
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    var p = {};
    define(p, a, function() {
        return this;
    });
    var d = Object.getPrototypeOf, v = d && d(d(values([])));
    v && v !== r && n.call(v, a) && (p = v);
    var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
    function defineIteratorMethods(t) {
        [
            "next",
            "throw",
            "return"
        ].forEach(function(e) {
            define(t, e, function(t) {
                return this._invoke(e, t);
            });
        });
    }
    function AsyncIterator(t, e) {
        function invoke(r, o, i, a) {
            var c = tryCatch(t[r], t, o);
            if ("throw" !== c.type) {
                var u = c.arg, h = u.value;
                return h && "object" == $4622b0a244b7c141$var$_typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function(t) {
                    invoke("next", t, i, a);
                }, function(t) {
                    invoke("throw", t, i, a);
                }) : e.resolve(h).then(function(t) {
                    u.value = t, i(u);
                }, function(t) {
                    return invoke("throw", t, i, a);
                });
            }
            a(c.arg);
        }
        var r;
        o(this, "_invoke", {
            value: function value(t, n) {
                function callInvokeWithMethodAndArg() {
                    return new e(function(e, r) {
                        invoke(t, n, e, r);
                    });
                }
                return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
            }
        });
    }
    function makeInvokeMethod(e, r, n) {
        var o = h;
        return function(i, a) {
            if (o === f) throw Error("Generator is already running");
            if (o === s) {
                if ("throw" === i) throw a;
                return {
                    value: t,
                    done: !0
                };
            }
            for(n.method = i, n.arg = a;;){
                var c = n.delegate;
                if (c) {
                    var u = maybeInvokeDelegate(c, n);
                    if (u) {
                        if (u === y) continue;
                        return u;
                    }
                }
                if ("next" === n.method) n.sent = n._sent = n.arg;
                else if ("throw" === n.method) {
                    if (o === h) throw o = s, n.arg;
                    n.dispatchException(n.arg);
                } else "return" === n.method && n.abrupt("return", n.arg);
                o = f;
                var p = tryCatch(e, r, n);
                if ("normal" === p.type) {
                    if (o = n.done ? s : l, p.arg === y) continue;
                    return {
                        value: p.arg,
                        done: n.done
                    };
                }
                "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
            }
        };
    }
    function maybeInvokeDelegate(e, r) {
        var n = r.method, o = e.iterator[n];
        if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
        var i = tryCatch(o, e.iterator, r.arg);
        if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
        var a = i.arg;
        return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
    }
    function pushTryEntry(t) {
        var e = {
            tryLoc: t[0]
        };
        1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
    }
    function resetTryEntry(t) {
        var e = t.completion || {};
        e.type = "normal", delete e.arg, t.completion = e;
    }
    function Context(t) {
        this.tryEntries = [
            {
                tryLoc: "root"
            }
        ], t.forEach(pushTryEntry, this), this.reset(!0);
    }
    function values(e) {
        if (e || "" === e) {
            var r = e[a];
            if (r) return r.call(e);
            if ("function" == typeof e.next) return e;
            if (!isNaN(e.length)) {
                var o = -1, i = function next() {
                    for(; ++o < e.length;)if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
                    return next.value = t, next.done = !0, next;
                };
                return i.next = i;
            }
        }
        throw new TypeError($4622b0a244b7c141$var$_typeof(e) + " is not iterable");
    }
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
        value: GeneratorFunctionPrototype,
        configurable: !0
    }), o(GeneratorFunctionPrototype, "constructor", {
        value: GeneratorFunction,
        configurable: !0
    }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function(t) {
        var e = "function" == typeof t && t.constructor;
        return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
    }, e.mark = function(t) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
    }, e.awrap = function(t) {
        return {
            __await: t
        };
    }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function() {
        return this;
    }), e.AsyncIterator = AsyncIterator, e.async = function(t, r, n, o, i) {
        void 0 === i && (i = Promise);
        var a = new AsyncIterator(wrap(t, r, n, o), i);
        return e.isGeneratorFunction(r) ? a : a.next().then(function(t) {
            return t.done ? t.value : a.next();
        });
    }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function() {
        return this;
    }), define(g, "toString", function() {
        return "[object Generator]";
    }), e.keys = function(t) {
        var e = Object(t), r = [];
        for(var n in e)r.push(n);
        return r.reverse(), function next() {
            for(; r.length;){
                var t = r.pop();
                if (t in e) return next.value = t, next.done = !1, next;
            }
            return next.done = !0, next;
        };
    }, e.values = values, Context.prototype = {
        constructor: Context,
        reset: function reset(e) {
            if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for(var r in this)"t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
        },
        stop: function stop() {
            this.done = !0;
            var t = this.tryEntries[0].completion;
            if ("throw" === t.type) throw t.arg;
            return this.rval;
        },
        dispatchException: function dispatchException(e) {
            if (this.done) throw e;
            var r = this;
            function handle(n, o) {
                return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
            }
            for(var o = this.tryEntries.length - 1; o >= 0; --o){
                var i = this.tryEntries[o], a = i.completion;
                if ("root" === i.tryLoc) return handle("end");
                if (i.tryLoc <= this.prev) {
                    var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc");
                    if (c && u) {
                        if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                        if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
                    } else if (c) {
                        if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                    } else {
                        if (!u) throw Error("try statement without catch or finally");
                        if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
                    }
                }
            }
        },
        abrupt: function abrupt(t, e) {
            for(var r = this.tryEntries.length - 1; r >= 0; --r){
                var o = this.tryEntries[r];
                if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
                    var i = o;
                    break;
                }
            }
            i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
            var a = i ? i.completion : {};
            return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
        },
        complete: function complete(t, e) {
            if ("throw" === t.type) throw t.arg;
            return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
        },
        finish: function finish(t) {
            for(var e = this.tryEntries.length - 1; e >= 0; --e){
                var r = this.tryEntries[e];
                if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
            }
        },
        "catch": function _catch(t) {
            for(var e = this.tryEntries.length - 1; e >= 0; --e){
                var r = this.tryEntries[e];
                if (r.tryLoc === t) {
                    var n = r.completion;
                    if ("throw" === n.type) {
                        var o = n.arg;
                        resetTryEntry(r);
                    }
                    return o;
                }
            }
            throw Error("illegal catch attempt");
        },
        delegateYield: function delegateYield(e, r, n) {
            return this.delegate = {
                iterator: values(e),
                resultName: r,
                nextLoc: n
            }, "next" === this.method && (this.arg = t), y;
        }
    }, e;
}
module.exports = $4622b0a244b7c141$var$_regeneratorRuntime, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("btpuG", function(module, exports) {
"use strict";
var $85a62db6a2459dc5$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $85a62db6a2459dc5$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $85a62db6a2459dc5$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.EvaluationReason = module.exports.Layer = module.exports.DynamicConfig = void 0;

var $2FNDf = parcelRequire("2FNDf");

var $85a62db6a2459dc5$var$StatsigClient_1 = $85a62db6a2459dc5$var$__importDefault((parcelRequire("lMx9j")));

var $5QxP2 = parcelRequire("5QxP2");

var $2MIyU = parcelRequire("2MIyU");
Object.defineProperty(module.exports, "DynamicConfig", {
    enumerable: true,
    get: function() {
        return $85a62db6a2459dc5$var$__importDefault($2MIyU).default;
    }
});

var $9F78u = parcelRequire("9F78u");
Object.defineProperty(module.exports, "Layer", {
    enumerable: true,
    get: function() {
        return $85a62db6a2459dc5$var$__importDefault($9F78u).default;
    }
});

var $5QxP2 = parcelRequire("5QxP2");
Object.defineProperty(module.exports, "EvaluationReason", {
    enumerable: true,
    get: function() {
        return $5QxP2.EvaluationReason;
    }
});
var $85a62db6a2459dc5$var$Statsig = /** @class */ function() {
    function Statsig() {}
    Statsig.initialize = function(sdkKey, user, options) {
        var _a;
        return $85a62db6a2459dc5$var$__awaiter(this, void 0, void 0, function() {
            var inst;
            return $85a62db6a2459dc5$var$__generator(this, function(_b) {
                inst = (_a = Statsig.instance) !== null && _a !== void 0 ? _a : new $85a62db6a2459dc5$var$StatsigClient_1.default(sdkKey, user, options);
                if (!Statsig.instance) Statsig.instance = inst;
                return [
                    2 /*return*/ ,
                    inst.initializeAsync()
                ];
            });
        });
    };
    Statsig.setInitializeValues = function(initializeValues) {
        Statsig._getClientX().setInitializeValues(initializeValues);
    };
    // Gate
    Statsig.checkGate = function(gateName) {
        return Statsig._getClientX().checkGate(gateName);
    };
    Statsig.checkGateWithExposureLoggingDisabled = function(gateName) {
        return Statsig._getClientX().checkGateWithExposureLoggingDisabled(gateName);
    };
    Statsig.manuallyLogGateExposure = function(gateName) {
        Statsig._getClientX().logGateExposure(gateName);
    };
    // Config
    Statsig.getConfig = function(configName) {
        return Statsig._getClientX().getConfig(configName);
    };
    Statsig.getConfigWithExposureLoggingDisabled = function(configName) {
        return Statsig._getClientX().getConfigWithExposureLoggingDisabled(configName);
    };
    Statsig.manuallyLogConfigExposure = function(configName) {
        Statsig._getClientX().logConfigExposure(configName);
    };
    // Experiment
    Statsig.getExperiment = function(experimentName) {
        return Statsig._getClientX().getExperiment(experimentName);
    };
    Statsig.getExperimentWithExposureLoggingDisabled = function(experimentName) {
        return Statsig._getClientX().getExperimentWithExposureLoggingDisabled(experimentName);
    };
    Statsig.manuallyLogExperimentExposure = function(configName) {
        Statsig._getClientX().logExperimentExposure(configName);
    };
    // Layer
    Statsig.getLayer = function(layerName) {
        return Statsig._getClientX().getLayer(layerName);
    };
    Statsig.getLayerWithExposureLoggingDisabled = function(layerName) {
        return Statsig._getClientX().getLayerWithExposureLoggingDisabled(layerName);
    };
    Statsig.manuallyLogLayerParameterExposure = function(layerName, parameterName) {
        Statsig._getClientX().logLayerParameterExposure(layerName, parameterName);
    };
    Statsig.logEvent = function(eventName, value, metadata) {
        if (value === void 0) value = null;
        if (metadata === void 0) metadata = null;
        return Statsig._getClientX().logEvent(eventName, value, metadata);
    };
    Statsig.updateUser = function(user) {
        return Statsig._getClientX().updateUser(user);
    };
    Statsig.updateUserWithValues = function(user, values) {
        return Statsig._getClientX().updateUserWithValues(user, values);
    };
    Statsig.shutdown = function() {
        Statsig._getClientX().shutdown();
        Statsig.instance = null;
    };
    Statsig.overrideGate = function(gate, result) {
        Statsig._getClientX().overrideGate(gate, result);
    };
    Statsig.overrideConfig = function(config, result) {
        Statsig._getClientX().overrideConfig(config, result);
    };
    Statsig.overrideLayer = function(layer, result) {
        Statsig._getClientX().overrideLayer(layer, result);
    };
    Statsig.setOverrides = function(overrides) {
        Statsig._getClientX().setOverrides(overrides);
    };
    Statsig.getOverrides = function() {
        return Statsig._getClientX().getOverrides();
    };
    /**
     * @returns The Statsig stable ID used for device level experiments
     */ Statsig.getStableID = function() {
        return Statsig._getClientX().getStableID();
    };
    /**
     *
     * @returns The reason and time associated with the evaluation for the current set
     * of gates and configs
     */ Statsig.getEvaluationDetails = function() {
        var _a, _b;
        return (_b = (_a = Statsig.instance) === null || _a === void 0 ? void 0 : _a.getEvaluationDetails()) !== null && _b !== void 0 ? _b : {
            reason: $5QxP2.EvaluationReason.Uninitialized,
            time: 0
        };
    };
    /**
     *
     * @returns true if initialize has already been called, false otherwise
     */ Statsig.initializeCalled = function() {
        return Statsig.instance != null && Statsig.instance.initializeCalled();
    };
    Statsig._getClientX = function() {
        if (!Statsig.instance) throw new $2FNDf.StatsigUninitializedError();
        return Statsig.instance;
    };
    Statsig.instance = null;
    return Statsig;
}();
module.exports.default = $85a62db6a2459dc5$var$Statsig;

});
parcelRegister("2FNDf", function(module, exports) {
"use strict";
var $1f25e8fe72367052$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StatsigSDKKeyMismatchError = module.exports.StatsigInvalidArgumentError = module.exports.StatsigUninitializedError = module.exports.StatsigErrorMessage = void 0;
var $1f25e8fe72367052$var$StatsigErrorMessage;
(function(StatsigErrorMessage) {
    StatsigErrorMessage["REQUIRE_ASYNC_INITIALIZE"] = "Call initialize() first.";
    StatsigErrorMessage["REQUIRE_SYNC_INITIALIZE"] = "Call and wait for initialize() to finish first.";
    StatsigErrorMessage["REQUIRE_INITIALIZE_FOR_LOG_EVENT"] = "Must initialize() before logging events.";
})($1f25e8fe72367052$var$StatsigErrorMessage = module.exports.StatsigErrorMessage || (module.exports.StatsigErrorMessage = {}));
var $1f25e8fe72367052$var$StatsigUninitializedError = /** @class */ function(_super) {
    $1f25e8fe72367052$var$__extends(StatsigUninitializedError, _super);
    function StatsigUninitializedError(message) {
        var _this = _super.call(this, message !== null && message !== void 0 ? message : $1f25e8fe72367052$var$StatsigErrorMessage.REQUIRE_SYNC_INITIALIZE) || this;
        Object.setPrototypeOf(_this, StatsigUninitializedError.prototype);
        return _this;
    }
    return StatsigUninitializedError;
}(Error);
module.exports.StatsigUninitializedError = $1f25e8fe72367052$var$StatsigUninitializedError;
var $1f25e8fe72367052$var$StatsigInvalidArgumentError = /** @class */ function(_super) {
    $1f25e8fe72367052$var$__extends(StatsigInvalidArgumentError, _super);
    function StatsigInvalidArgumentError(message) {
        var _this = _super.call(this, message) || this;
        Object.setPrototypeOf(_this, StatsigInvalidArgumentError.prototype);
        return _this;
    }
    return StatsigInvalidArgumentError;
}(Error);
module.exports.StatsigInvalidArgumentError = $1f25e8fe72367052$var$StatsigInvalidArgumentError;
var $1f25e8fe72367052$var$StatsigSDKKeyMismatchError = /** @class */ function(_super) {
    $1f25e8fe72367052$var$__extends(StatsigSDKKeyMismatchError, _super);
    function StatsigSDKKeyMismatchError(message) {
        var _this = _super.call(this, message) || this;
        Object.setPrototypeOf(_this, StatsigSDKKeyMismatchError.prototype);
        return _this;
    }
    return StatsigSDKKeyMismatchError;
}(Error);
module.exports.StatsigSDKKeyMismatchError = $1f25e8fe72367052$var$StatsigSDKKeyMismatchError;

});

parcelRegister("lMx9j", function(module, exports) {
"use strict";
var $fdb7cb68f187b4dc$var$__assign = module.exports && module.exports.__assign || function() {
    $fdb7cb68f187b4dc$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $fdb7cb68f187b4dc$var$__assign.apply(this, arguments);
};
var $fdb7cb68f187b4dc$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $fdb7cb68f187b4dc$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $fdb7cb68f187b4dc$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $fdb7cb68f187b4dc$var$__createBinding(result, mod, k);
    }
    $fdb7cb68f187b4dc$var$__setModuleDefault(result, mod);
    return result;
};
var $fdb7cb68f187b4dc$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $fdb7cb68f187b4dc$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $fdb7cb68f187b4dc$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $fdb7cb68f187b4dc$var$DynamicConfig_1 = $fdb7cb68f187b4dc$var$__importDefault((parcelRequire("2MIyU")));

var $fdb7cb68f187b4dc$var$ErrorBoundary_1 = $fdb7cb68f187b4dc$var$__importDefault((parcelRequire("7kPzH")));

var $2FNDf = parcelRequire("2FNDf");

var $fdb7cb68f187b4dc$var$Layer_1 = $fdb7cb68f187b4dc$var$__importDefault((parcelRequire("9F78u")));

var $fdb7cb68f187b4dc$var$StatsigIdentity_1 = $fdb7cb68f187b4dc$var$__importDefault((parcelRequire("1BiLW")));

var $fdb7cb68f187b4dc$var$StatsigLogger_1 = $fdb7cb68f187b4dc$var$__importDefault((parcelRequire("f5b45")));

var $fdb7cb68f187b4dc$var$StatsigNetwork_1 = $fdb7cb68f187b4dc$var$__importDefault((parcelRequire("bISsA")));

var $fdb7cb68f187b4dc$var$StatsigSDKOptions_1 = $fdb7cb68f187b4dc$var$__importDefault((parcelRequire("OnTwj")));

var $fdb7cb68f187b4dc$var$StatsigStore_1 = $fdb7cb68f187b4dc$var$__importStar((parcelRequire("5QxP2")));

var $eSgoQ = parcelRequire("eSgoQ");

var $fdb7cb68f187b4dc$var$StatsigLocalStorage_1 = $fdb7cb68f187b4dc$var$__importDefault((parcelRequire("16w86")));

var $8RsHO = parcelRequire("8RsHO");

var $fdb7cb68f187b4dc$var$LogEvent_1 = $fdb7cb68f187b4dc$var$__importDefault((parcelRequire("hS11o")));

var $5Erfl = parcelRequire("5Erfl");
var $fdb7cb68f187b4dc$var$StatsigClient = /** @class */ function() {
    function StatsigClient(sdkKey, user, options) {
        var _this = this;
        this._initCalled = false;
        this._pendingInitPromise = null;
        this._sdkKey = null;
        this._logLayerParameterExposureForLayer = function(layer, parameterName, isManualExposure) {
            if (isManualExposure === void 0) isManualExposure = false;
            var allocatedExperiment = "";
            var exposures = layer._undelegatedSecondaryExposures;
            var isExplicit = layer._explicitParameters.includes(parameterName);
            if (isExplicit) {
                allocatedExperiment = layer._allocatedExperimentName;
                exposures = layer._secondaryExposures;
            }
            _this._logger.logLayerExposure(_this._identity._user, layer._name, layer._ruleID, exposures, allocatedExperiment, parameterName, isExplicit, layer._evaluationDetails, isManualExposure, _this._store.getBootstrapMetadata());
        };
        if ((options === null || options === void 0 ? void 0 : options.localMode) !== true && (typeof sdkKey !== "string" || !sdkKey.startsWith("client-"))) throw new $2FNDf.StatsigInvalidArgumentError("Invalid key provided.  You must use a Client SDK Key from the Statsig console to initialize the sdk");
        this._sdkKey = sdkKey;
        this._startTime = (0, $8RsHO.now)();
        this._options = new $fdb7cb68f187b4dc$var$StatsigSDKOptions_1.default(options);
        this._errorBoundary = new $fdb7cb68f187b4dc$var$ErrorBoundary_1.default(sdkKey, this._options);
        this._ready = false;
        $fdb7cb68f187b4dc$var$StatsigLocalStorage_1.default.disabled = this._options.disableLocalStorage;
        this._overrides = (0, $5Erfl.loadOverridesFromLocalStorage)();
        this._identity = new $fdb7cb68f187b4dc$var$StatsigIdentity_1.default(sdkKey, this._normalizeUser(user !== null && user !== void 0 ? user : null), this._options.overrideStableID);
        this._network = new $fdb7cb68f187b4dc$var$StatsigNetwork_1.default(this._options, this._identity, this._errorBoundary);
        this._logger = new $fdb7cb68f187b4dc$var$StatsigLogger_1.default(this._options, this._identity, this._network, this._errorBoundary);
        this._store = new $fdb7cb68f187b4dc$var$StatsigStore_1.default(this._identity, this._logger.logConfigDefaultValueFallback, this._options.initializeValues);
        this._errorBoundary._setStatsigMetadata(this._identity._statsigMetadata);
        if (this._options.initializeValues != null) {
            this._ready = true;
            this._initCalled = true;
            setTimeout(function() {
                return _this._delayedSetup();
            }, 20);
        }
    }
    StatsigClient.prototype.setInitializeValues = function(initializeValues) {
        var _this = this;
        this._errorBoundary._capture("setInitializeValues", function() {
            _this._store.bootstrap(initializeValues);
            if (!_this._ready) {
                // the sdk is usable and considered initialized when configured
                // with initializeValues
                _this._ready = true;
                _this._initCalled = true;
            }
            // we wont have access to window/document/localStorage if these run on the server
            // so try to run whenever this is called
            _this._logger.sendSavedRequests();
        }, function() {
            _this._ready = true;
            _this._initCalled = true;
        });
    };
    StatsigClient.prototype.initializeAsync = function() {
        return $fdb7cb68f187b4dc$var$__awaiter(this, void 0, void 0, function() {
            var _this = this;
            return $fdb7cb68f187b4dc$var$__generator(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this._errorBoundary._capture("initializeAsync", function() {
                        return $fdb7cb68f187b4dc$var$__awaiter(_this, void 0, void 0, function() {
                            var user;
                            var _this = this;
                            return $fdb7cb68f187b4dc$var$__generator(this, function(_a) {
                                if (this._pendingInitPromise != null) return [
                                    2 /*return*/ ,
                                    this._pendingInitPromise
                                ];
                                if (this._ready) return [
                                    2 /*return*/ ,
                                    Promise.resolve()
                                ];
                                this._initCalled = true;
                                if (this._options.localMode) return [
                                    2 /*return*/ ,
                                    Promise.resolve()
                                ];
                                user = this._identity._user;
                                this._pendingInitPromise = this._fetchAndSaveValues(user, this._options.initTimeoutMs).then(function() {
                                    return;
                                }).catch(function(e) {
                                    _this._errorBoundary._logError("initializeAsync:fetchAndSaveValues", e);
                                    return {
                                        success: false,
                                        message: e.message
                                    };
                                }).then(function() {
                                    return;
                                }).finally(function() {
                                    return $fdb7cb68f187b4dc$var$__awaiter(_this, void 0, void 0, function() {
                                        return $fdb7cb68f187b4dc$var$__generator(this, function(_a) {
                                            this._pendingInitPromise = null;
                                            this._ready = true;
                                            this._delayedSetup();
                                            return [
                                                2 /*return*/ 
                                            ];
                                        });
                                    });
                                });
                                return [
                                    2 /*return*/ ,
                                    this._pendingInitPromise
                                ];
                            });
                        });
                    }, function() {
                        _this._ready = true;
                        _this._initCalled = true;
                        return Promise.resolve();
                    })
                ];
            });
        });
    };
    StatsigClient.prototype.getEvaluationDetails = function() {
        var _this = this;
        return this._errorBoundary._capture("getEvaluationDetails", function() {
            return _this._store.getGlobalEvaluationDetails();
        }, function() {
            return {
                time: Date.now(),
                reason: $fdb7cb68f187b4dc$var$StatsigStore_1.EvaluationReason.Error
            };
        });
    };
    /**
     * Checks the value of a gate for the current user
     * @param {string} gateName - the name of the gate to check
     * @returns {boolean} - value of a gate for the user. Gates are "off" (return false) by default
     * @throws Error if initialize() is not called first, or gateName is not a string
     */ StatsigClient.prototype.checkGate = function(gateName) {
        return this._checkGateImpl(gateName, "checkGate");
    };
    StatsigClient.prototype.checkGateWithExposureLoggingDisabled = function(gateName) {
        return this._checkGateImpl(gateName, "checkGateWithExposureLoggingDisabled");
    };
    StatsigClient.prototype.logGateExposure = function(gateName) {
        var _this = this;
        this._errorBoundary._swallow("logGateExposure", function() {
            _this._logGateExposureImpl(gateName);
        });
    };
    /**
     * Checks the value of a config for the current user
     * @param {string} configName - the name of the config to get
     * @returns {DynamicConfig} - value of a config for the user
     * @throws Error if initialize() is not called first, or configName is not a string
     */ StatsigClient.prototype.getConfig = function(configName) {
        return this._getConfigImpl(configName, "getConfig");
    };
    StatsigClient.prototype.getConfigWithExposureLoggingDisabled = function(configName) {
        return this._getConfigImpl(configName, "getConfigWithExposureLoggingDisabled");
    };
    StatsigClient.prototype.logConfigExposure = function(configName) {
        var _this = this;
        this._errorBoundary._swallow("logConfigExposure", function() {
            _this._logConfigExposureImpl(configName);
        });
    };
    StatsigClient.prototype.getExperiment = function(experimentName) {
        return this.getConfig(experimentName);
    };
    StatsigClient.prototype.getExperimentWithExposureLoggingDisabled = function(experimentName) {
        return this.getConfigWithExposureLoggingDisabled(experimentName);
    };
    StatsigClient.prototype.logExperimentExposure = function(experimentName) {
        this.logConfigExposure(experimentName);
    };
    StatsigClient.prototype.getLayer = function(layerName) {
        return this._getLayerImpl(layerName, "getLayer");
    };
    StatsigClient.prototype.getLayerWithExposureLoggingDisabled = function(layerName) {
        return this._getLayerImpl(layerName, "getLayerWithExposureLoggingDisabled");
    };
    StatsigClient.prototype.logLayerParameterExposure = function(layerName, parameterName) {
        var _this = this;
        this._errorBoundary._swallow("logLayerParameterExposure", function() {
            var layer = _this._getLayerFromStore(null, layerName);
            _this._logLayerParameterExposureForLayer(layer, parameterName, true);
        });
    };
    StatsigClient.prototype.logEvent = function(eventName, value, metadata) {
        var _this = this;
        if (value === void 0) value = null;
        if (metadata === void 0) metadata = null;
        this._errorBoundary._swallow("logEvent", function() {
            if (!_this._logger || !_this._identity._sdkKey) throw new $2FNDf.StatsigUninitializedError($2FNDf.StatsigErrorMessage.REQUIRE_INITIALIZE_FOR_LOG_EVENT);
            if (typeof eventName !== "string" || eventName.length === 0) return;
            var event = (0, $fdb7cb68f187b4dc$var$LogEvent_1.default)(eventName, _this._identity._user, _this._identity._statsigMetadata, value, metadata);
            _this._logger.log(event);
        });
    };
    StatsigClient.prototype.updateUserWithValues = function(user, values) {
        var _this = this;
        var updateStartTime = Date.now();
        var fireCompletionCallback;
        return this._errorBoundary._capture("updateUserWithValues", function() {
            if (!_this.initializeCalled()) throw new $2FNDf.StatsigUninitializedError($2FNDf.StatsigErrorMessage.REQUIRE_ASYNC_INITIALIZE);
            fireCompletionCallback = function(success, error) {
                var cb = _this._options.updateUserCompletionCallback;
                cb === null || cb === void 0 || cb(Date.now() - updateStartTime, success, error);
            };
            _this._identity._user = _this._normalizeUser(user);
            _this._store.bootstrap(values);
            _this._logger.resetDedupeKeys();
            fireCompletionCallback(true, null);
            return true;
        }, function() {
            fireCompletionCallback === null || fireCompletionCallback === void 0 || fireCompletionCallback(false, "Failed to update user. An unexpected error occured.");
            return false;
        });
    };
    StatsigClient.prototype.updateUser = function(user) {
        return $fdb7cb68f187b4dc$var$__awaiter(this, void 0, void 0, function() {
            var updateStartTime, fireCompletionCallback;
            var _this = this;
            return $fdb7cb68f187b4dc$var$__generator(this, function(_a) {
                updateStartTime = Date.now();
                return [
                    2 /*return*/ ,
                    this._errorBoundary._capture("updateUser", function() {
                        return $fdb7cb68f187b4dc$var$__awaiter(_this, void 0, void 0, function() {
                            var currentUser;
                            var _this = this;
                            return $fdb7cb68f187b4dc$var$__generator(this, function(_a) {
                                switch(_a.label){
                                    case 0:
                                        if (!this.initializeCalled()) throw new $2FNDf.StatsigUninitializedError($2FNDf.StatsigErrorMessage.REQUIRE_ASYNC_INITIALIZE);
                                        fireCompletionCallback = function(success, error) {
                                            var cb = _this._options.updateUserCompletionCallback;
                                            cb === null || cb === void 0 || cb(Date.now() - updateStartTime, success, error);
                                        };
                                        this._identity._user = this._normalizeUser(user);
                                        this._store.updateUser();
                                        this._logger.resetDedupeKeys();
                                        if (!(this._pendingInitPromise != null)) return [
                                            3 /*break*/ ,
                                            2
                                        ];
                                        return [
                                            4 /*yield*/ ,
                                            this._pendingInitPromise
                                        ];
                                    case 1:
                                        _a.sent();
                                        _a.label = 2;
                                    case 2:
                                        if (this._options.localMode) {
                                            fireCompletionCallback(true, null);
                                            return [
                                                2 /*return*/ ,
                                                Promise.resolve(true)
                                            ];
                                        }
                                        currentUser = this._identity._user;
                                        this._pendingInitPromise = this._fetchAndSaveValues(currentUser).finally(function() {
                                            _this._pendingInitPromise = null;
                                        });
                                        return [
                                            2 /*return*/ ,
                                            this._pendingInitPromise.then(function() {
                                                fireCompletionCallback(true, null);
                                                return Promise.resolve(true);
                                            }).catch(function(error) {
                                                fireCompletionCallback(false, "Failed to update user: ".concat(error));
                                                return Promise.resolve(false);
                                            })
                                        ];
                                }
                            });
                        });
                    }, function() {
                        fireCompletionCallback(false, "Failed to update user. An unexpected error occured.");
                        return Promise.resolve(false);
                    })
                ];
            });
        });
    };
    /**
     * Informs the statsig SDK that the client is closing or shutting down
     * so the SDK can clean up internal state
     */ StatsigClient.prototype.shutdown = function() {
        var _this = this;
        this._errorBoundary._swallow("shutdown", function() {
            _this._logger.shutdown();
        });
    };
    /**
     * @returns The Statsig stable ID used for device level experiments
     */ StatsigClient.prototype.getStableID = function() {
        var _this = this;
        return this._errorBoundary._capture("getStableID", function() {
            return _this._identity._statsigMetadata.stableID;
        }, function() {
            return "";
        });
    };
    StatsigClient.prototype.initializeCalled = function() {
        return this._initCalled;
    };
    StatsigClient.prototype.overrideGate = function(gate, result) {
        this._setOverride("gates", gate, result);
    };
    StatsigClient.prototype.overrideConfig = function(config, result) {
        this._setOverride("configs", config, result);
    };
    StatsigClient.prototype.overrideLayer = function(layer, result) {
        this._setOverride("layers", layer, result);
    };
    StatsigClient.prototype.setOverrides = function(overrides) {
        var _this = this;
        this._errorBoundary._swallow("setOverrides", function() {
            _this._overrides = overrides !== null && overrides !== void 0 ? overrides : (0, $5Erfl.makeEmptyOverrides)();
            (0, $5Erfl.saveOverridesToLocalStorage)(_this._overrides);
        });
    };
    StatsigClient.prototype.getOverrides = function() {
        var _this = this;
        return this._errorBoundary._capture("getOverrides", function() {
            return _this._overrides;
        }, function() {
            return (0, $5Erfl.makeEmptyOverrides)();
        });
    };
    // Private
    StatsigClient.prototype._delayedSetup = function() {
        var _this = this;
        this._errorBoundary._swallow("delayedSetup", function() {
            _this._identity.saveStableID();
            _this._logger.sendSavedRequests().then(function() {
            /* noop */ });
        });
    };
    StatsigClient.prototype._normalizeUser = function(user) {
        var userCopy = {};
        try {
            userCopy = JSON.parse(JSON.stringify(user));
        } catch (error) {
            throw new $2FNDf.StatsigInvalidArgumentError("User object must be convertable to JSON string.");
        }
        if (this._options.environment != null) userCopy = $fdb7cb68f187b4dc$var$__assign($fdb7cb68f187b4dc$var$__assign({}, userCopy), {
            statsigEnvironment: this._options.environment
        });
        return userCopy;
    };
    StatsigClient.prototype._ensureStoreLoaded = function() {
        if (!this._store.isLoaded()) throw new $2FNDf.StatsigUninitializedError();
    };
    StatsigClient.prototype._getEvaluationDetailsForError = function() {
        return {
            time: Date.now(),
            reason: $fdb7cb68f187b4dc$var$StatsigStore_1.EvaluationReason.Error
        };
    };
    StatsigClient.prototype._fetchAndSaveValues = function(user, timeout) {
        if (timeout === void 0) timeout = this._options.initTimeoutMs;
        return $fdb7cb68f187b4dc$var$__awaiter(this, void 0, void 0, function() {
            var sinceTime, previousDerivedFields;
            var _this = this;
            return $fdb7cb68f187b4dc$var$__generator(this, function(_a) {
                sinceTime = null;
                sinceTime = this._store.getLastUpdateTime(user);
                previousDerivedFields = this._store.getPreviousDerivedFields(user);
                return [
                    2 /*return*/ ,
                    this._network.fetchValues(user, sinceTime, timeout, previousDerivedFields).eventually(function(json) {
                        var _a;
                        if (!(0, $eSgoQ.verifySDKKeyUsed)(json, (_a = _this._sdkKey) !== null && _a !== void 0 ? _a : "", _this._errorBoundary)) return;
                        if (json === null || json === void 0 ? void 0 : json.has_updates) _this._store.save(user, json, false);
                    }).then(function(json) {
                        return $fdb7cb68f187b4dc$var$__awaiter(_this, void 0, void 0, function() {
                            var _this = this;
                            return $fdb7cb68f187b4dc$var$__generator(this, function(_a) {
                                return [
                                    2 /*return*/ ,
                                    this._errorBoundary._swallow("fetchAndSaveValues", function() {
                                        return $fdb7cb68f187b4dc$var$__awaiter(_this, void 0, void 0, function() {
                                            var _a;
                                            return $fdb7cb68f187b4dc$var$__generator(this, function(_b) {
                                                switch(_b.label){
                                                    case 0:
                                                        if (!(0, $eSgoQ.verifySDKKeyUsed)(json, (_a = this._sdkKey) !== null && _a !== void 0 ? _a : "", this._errorBoundary)) return [
                                                            2 /*return*/ 
                                                        ];
                                                        if (!(json === null || json === void 0 ? void 0 : json.has_updates)) return [
                                                            3 /*break*/ ,
                                                            2
                                                        ];
                                                        return [
                                                            4 /*yield*/ ,
                                                            this._store.save(user, json)
                                                        ];
                                                    case 1:
                                                        _b.sent();
                                                        return [
                                                            3 /*break*/ ,
                                                            3
                                                        ];
                                                    case 2:
                                                        if (json === null || json === void 0 ? void 0 : json.is_no_content) this._store.setEvaluationReason($fdb7cb68f187b4dc$var$StatsigStore_1.EvaluationReason.NetworkNotModified);
                                                        _b.label = 3;
                                                    case 3:
                                                        return [
                                                            2 /*return*/ 
                                                        ];
                                                }
                                            });
                                        });
                                    })
                                ];
                            });
                        });
                    })
                ];
            });
        });
    };
    StatsigClient.prototype._checkGateImpl = function(gateName, callsite) {
        var _this = this;
        return this._errorBoundary._capture(callsite, function() {
            if (typeof _this._overrides.gates[gateName] === "boolean") return _this._overrides.gates[gateName];
            var result = _this._getGateFromStore(gateName);
            if (callsite === "checkGate") _this._logGateExposureImpl(gateName, result);
            return result.gate.value === true;
        }, function() {
            return false;
        });
    };
    StatsigClient.prototype._getGateFromStore = function(gateName) {
        this._ensureStoreLoaded();
        if (typeof gateName !== "string" || gateName.length === 0) throw new $2FNDf.StatsigInvalidArgumentError("Must pass a valid string as the gateName.");
        return this._store.checkGate(gateName);
    };
    StatsigClient.prototype._logGateExposureImpl = function(gateName, fetchResult) {
        var isManualExposure = !fetchResult;
        var result = fetchResult !== null && fetchResult !== void 0 ? fetchResult : this._getGateFromStore(gateName);
        var gate = result.gate;
        this._logger.logGateExposure(this._identity._user, gateName, gate.value, gate.rule_id, gate.secondary_exposures, result.evaluationDetails, isManualExposure, this._store.getBootstrapMetadata());
    };
    StatsigClient.prototype._getConfigImpl = function(configName, callsite) {
        var _this = this;
        return this._errorBoundary._capture(callsite, function() {
            if (_this._overrides.configs[configName]) return new $fdb7cb68f187b4dc$var$DynamicConfig_1.default(configName, _this._overrides.configs[configName], "local_override", {
                reason: $fdb7cb68f187b4dc$var$StatsigStore_1.EvaluationReason.LocalOverride,
                time: Date.now()
            });
            var result = _this._getConfigFromStore(configName);
            if (callsite === "getConfig") _this._logConfigExposureImpl(configName, result);
            return result;
        }, function() {
            return _this._getEmptyConfig(configName);
        });
    };
    StatsigClient.prototype._getConfigFromStore = function(configName) {
        this._ensureStoreLoaded();
        if (typeof configName !== "string" || configName.length === 0) throw new $2FNDf.StatsigInvalidArgumentError("Must pass a valid string as the configName.");
        return this._store.getConfig(configName);
    };
    StatsigClient.prototype._logConfigExposureImpl = function(configName, config) {
        var isManualExposure = !config;
        var localConfig = config !== null && config !== void 0 ? config : this._getConfigFromStore(configName);
        this._logger.logConfigExposure(this._identity._user, configName, localConfig._ruleID, localConfig._secondaryExposures, localConfig._evaluationDetails, isManualExposure, this._store.getBootstrapMetadata());
    };
    StatsigClient.prototype._getLayerImpl = function(layerName, callsite) {
        var _this = this;
        return this._errorBoundary._capture(callsite, function() {
            if (_this._overrides.layers[layerName]) return $fdb7cb68f187b4dc$var$Layer_1.default._create(layerName, _this._overrides.layers[layerName], "local_override", {
                reason: $fdb7cb68f187b4dc$var$StatsigStore_1.EvaluationReason.LocalOverride,
                time: Date.now()
            });
            var logFunc = callsite === "getLayer" ? _this._logLayerParameterExposureForLayer : null;
            return _this._getLayerFromStore(logFunc, layerName);
        }, function() {
            return $fdb7cb68f187b4dc$var$Layer_1.default._create(layerName, {}, "", _this._getEvaluationDetailsForError());
        });
    };
    StatsigClient.prototype._getLayerFromStore = function(logParameterFunction, layerName) {
        this._ensureStoreLoaded();
        if (typeof layerName !== "string" || layerName.length === 0) throw new $2FNDf.StatsigInvalidArgumentError("Must pass a valid string as the layerName.");
        return this._store.getLayer(logParameterFunction, layerName);
    };
    StatsigClient.prototype._getEmptyConfig = function(configName) {
        return new $fdb7cb68f187b4dc$var$DynamicConfig_1.default(configName, {}, "", this._getEvaluationDetailsForError());
    };
    StatsigClient.prototype._setOverride = function(type, key, result) {
        if (result == null) delete this._overrides[type][key];
        else this._overrides[type][key] = result;
        this.setOverrides(this._overrides);
    };
    return StatsigClient;
}();
module.exports.default = $fdb7cb68f187b4dc$var$StatsigClient;

});
parcelRegister("2MIyU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $2072a1930070f285$var$DynamicConfig = /** @class */ function() {
    function DynamicConfig(configName, configValue, ruleID, evaluationDetails, secondaryExposures, allocatedExperimentName, onDefaultValueFallback) {
        if (secondaryExposures === void 0) secondaryExposures = [];
        if (allocatedExperimentName === void 0) allocatedExperimentName = "";
        if (onDefaultValueFallback === void 0) onDefaultValueFallback = null;
        this._onDefaultValueFallback = null;
        this.value = JSON.parse(JSON.stringify(configValue !== null && configValue !== void 0 ? configValue : {}));
        this._name = configName;
        this._ruleID = ruleID !== null && ruleID !== void 0 ? ruleID : "";
        this._secondaryExposures = secondaryExposures;
        this._allocatedExperimentName = allocatedExperimentName;
        this._evaluationDetails = evaluationDetails;
        this._onDefaultValueFallback = onDefaultValueFallback;
    }
    DynamicConfig.prototype.get = function(key, defaultValue, typeGuard) {
        var _a, _b;
        var val = this.getValue(key, defaultValue);
        if (val == null) return defaultValue;
        var expectedType = Array.isArray(defaultValue) ? "array" : typeof defaultValue;
        var actualType = Array.isArray(val) ? "array" : typeof val;
        if (typeGuard) {
            if (typeGuard(val)) return val;
            (_a = this._onDefaultValueFallback) === null || _a === void 0 || _a.call(this, this, key, expectedType, actualType);
            return defaultValue;
        }
        if (defaultValue == null || expectedType === actualType) return val;
        (_b = this._onDefaultValueFallback) === null || _b === void 0 || _b.call(this, this, key, expectedType, actualType);
        return defaultValue;
    };
    DynamicConfig.prototype.getValue = function(key, defaultValue) {
        if (key == null) return this.value;
        if (defaultValue == null) defaultValue = null;
        if (this.value[key] == null) return defaultValue;
        return this.value[key];
    };
    return DynamicConfig;
}();
module.exports.default = $2072a1930070f285$var$DynamicConfig;

});

parcelRegister("7kPzH", function(module, exports) {
"use strict";
var $557268540b29282c$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $557268540b29282c$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ExceptionEndpoint = void 0;

var $2FNDf = parcelRequire("2FNDf");
module.exports.ExceptionEndpoint = "https://statsigapi.net/v1/sdk_exception";
var $557268540b29282c$var$ErrorBoundary = /** @class */ function() {
    function ErrorBoundary(sdkKey, options) {
        this._seen = new Set();
        this._sdkKey = sdkKey;
        this._options = options;
    }
    ErrorBoundary.prototype._setStatsigMetadata = function(statsigMetadata) {
        this._statsigMetadata = statsigMetadata;
    };
    ErrorBoundary.prototype._swallow = function(tag, task) {
        this._capture(tag, task, function() {
            return undefined;
        });
    };
    ErrorBoundary.prototype._capture = function(tag, task, recover, getExtraData) {
        var _this = this;
        try {
            var result = task();
            if (result instanceof Promise) return result.catch(function(e) {
                return _this._onCaught(tag, e, recover, getExtraData);
            });
            return result;
        } catch (error) {
            return this._onCaught(tag, error, recover, getExtraData);
        }
    };
    ErrorBoundary.prototype._logError = function(tag, error, getExtraData) {
        var _this = this;
        if (this._options.disableAllLogging) return;
        try {
            var impl = function() {
                return $557268540b29282c$var$__awaiter(_this, void 0, void 0, function() {
                    var extra, _a, unwrapped, isError, name, info, metadata, body;
                    var _b;
                    return $557268540b29282c$var$__generator(this, function(_c) {
                        switch(_c.label){
                            case 0:
                                if (!(typeof getExtraData === "function")) return [
                                    3 /*break*/ ,
                                    2
                                ];
                                return [
                                    4 /*yield*/ ,
                                    getExtraData()
                                ];
                            case 1:
                                _a = _c.sent();
                                return [
                                    3 /*break*/ ,
                                    3
                                ];
                            case 2:
                                _a = null;
                                _c.label = 3;
                            case 3:
                                extra = _a;
                                unwrapped = error !== null && error !== void 0 ? error : Error("[Statsig] Error was empty");
                                isError = unwrapped instanceof Error;
                                name = isError ? unwrapped.name : "No Name";
                                if (this._seen.has(name)) return [
                                    2 /*return*/ 
                                ];
                                this._seen.add(name);
                                info = isError ? unwrapped.stack : this._getDescription(unwrapped);
                                metadata = (_b = this._statsigMetadata) !== null && _b !== void 0 ? _b : {};
                                body = JSON.stringify({
                                    tag: tag,
                                    exception: name,
                                    info: info,
                                    statsigMetadata: metadata,
                                    extra: extra !== null && extra !== void 0 ? extra : {}
                                });
                                return [
                                    2 /*return*/ ,
                                    fetch(module.exports.ExceptionEndpoint, {
                                        method: "POST",
                                        headers: {
                                            "STATSIG-API-KEY": this._sdkKey,
                                            "STATSIG-SDK-TYPE": String(metadata["sdkType"]),
                                            "STATSIG-SDK-VERSION": String(metadata["sdkVersion"]),
                                            "Content-Type": "application/json",
                                            "Content-Length": "".concat(body.length)
                                        },
                                        body: body
                                    })
                                ];
                        }
                    });
                });
            };
            impl().then(function() {
            /* noop */ }).catch(function() {
            /* noop */ });
        } catch (_error) {
        /* noop */ }
    };
    ErrorBoundary.prototype._onCaught = function(tag, error, recover, getExtraData) {
        if (error instanceof $2FNDf.StatsigUninitializedError || error instanceof $2FNDf.StatsigInvalidArgumentError) throw error; // Don't catch these
        console.error("[Statsig] An unexpected exception occurred.", error);
        this._logError(tag, error, getExtraData);
        return recover();
    };
    ErrorBoundary.prototype._getDescription = function(obj) {
        try {
            return JSON.stringify(obj);
        } catch (_a) {
            return "[Statsig] Failed to get string for error.";
        }
    };
    return ErrorBoundary;
}();
module.exports.default = $557268540b29282c$var$ErrorBoundary;

});

parcelRegister("9F78u", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $708d7a75cd1b6311$var$Layer = /** @class */ function() {
    function Layer(name, layerValue, ruleID, evaluationDetails, logParameterFunction, secondaryExposures, undelegatedSecondaryExposures, allocatedExperimentName, explicitParameters) {
        if (logParameterFunction === void 0) logParameterFunction = null;
        if (secondaryExposures === void 0) secondaryExposures = [];
        if (undelegatedSecondaryExposures === void 0) undelegatedSecondaryExposures = [];
        if (allocatedExperimentName === void 0) allocatedExperimentName = "";
        if (explicitParameters === void 0) explicitParameters = [];
        this._logParameterFunction = logParameterFunction;
        this._name = name;
        this._value = JSON.parse(JSON.stringify(layerValue !== null && layerValue !== void 0 ? layerValue : {}));
        this._ruleID = ruleID !== null && ruleID !== void 0 ? ruleID : "";
        this._evaluationDetails = evaluationDetails;
        this._secondaryExposures = secondaryExposures;
        this._undelegatedSecondaryExposures = undelegatedSecondaryExposures;
        this._allocatedExperimentName = allocatedExperimentName;
        this._explicitParameters = explicitParameters;
    }
    Layer._create = function(name, value, ruleID, evaluationDetails, logParameterFunction, secondaryExposures, undelegatedSecondaryExposures, allocatedExperimentName, explicitParameters) {
        if (logParameterFunction === void 0) logParameterFunction = null;
        if (secondaryExposures === void 0) secondaryExposures = [];
        if (undelegatedSecondaryExposures === void 0) undelegatedSecondaryExposures = [];
        if (allocatedExperimentName === void 0) allocatedExperimentName = "";
        if (explicitParameters === void 0) explicitParameters = [];
        return new Layer(name, value, ruleID, evaluationDetails, logParameterFunction, secondaryExposures, undelegatedSecondaryExposures, allocatedExperimentName, explicitParameters);
    };
    Layer.prototype.get = function(key, defaultValue, typeGuard) {
        var _this = this;
        var val = this._value[key];
        if (val == null) return defaultValue;
        var logAndReturn = function() {
            _this._logLayerParameterExposure(key);
            return val;
        };
        if (typeGuard) return typeGuard(val) ? logAndReturn() : defaultValue;
        if (defaultValue == null) return logAndReturn();
        if (typeof val === typeof defaultValue && Array.isArray(defaultValue) === Array.isArray(val)) return logAndReturn();
        return defaultValue;
    };
    Layer.prototype.getValue = function(key, defaultValue) {
        if (defaultValue == undefined) defaultValue = null;
        var val = this._value[key];
        if (val != null) this._logLayerParameterExposure(key);
        return val !== null && val !== void 0 ? val : defaultValue;
    };
    Layer.prototype._logLayerParameterExposure = function(parameterName) {
        var _a;
        (_a = this._logParameterFunction) === null || _a === void 0 || _a.call(this, this, parameterName);
    };
    return Layer;
}();
module.exports.default = $708d7a75cd1b6311$var$Layer;

});

parcelRegister("1BiLW", function(module, exports) {
"use strict";
var $12a7cee8beac65a4$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $eJCf0 = parcelRequire("eJCf0");

var $c5V7T = parcelRequire("c5V7T");

var $12a7cee8beac65a4$var$StatsigLocalStorage_1 = $12a7cee8beac65a4$var$__importDefault((parcelRequire("16w86")));

var $8lYkT = parcelRequire("8lYkT");
var $12a7cee8beac65a4$var$Identity = /** @class */ function() {
    function Identity(sdkKey, user, overrideStableID) {
        var _a;
        this._sdkType = "js-lite";
        this._sdkKey = sdkKey;
        this._user = user;
        this._sdkVersion = $8lYkT.version;
        var stableID = overrideStableID;
        stableID = (_a = stableID !== null && stableID !== void 0 ? stableID : $12a7cee8beac65a4$var$StatsigLocalStorage_1.default.getItem($eJCf0.STATSIG_STABLE_ID_KEY)) !== null && _a !== void 0 ? _a : this._getUUID();
        this._statsigMetadata = {
            stableID: stableID,
            sdkType: this._sdkType,
            sdkVersion: this._sdkVersion
        };
    }
    Identity.prototype.saveStableID = function() {
        if (this._statsigMetadata.stableID != null) $12a7cee8beac65a4$var$StatsigLocalStorage_1.default.setItem($eJCf0.STATSIG_STABLE_ID_KEY, this._statsigMetadata.stableID);
    };
    Identity.prototype.getUserCacheKey = function() {
        return (0, $c5V7T.getUserCacheKey)(this._user);
    };
    Identity.prototype._getUUID = function() {
        var uuid = "";
        for(var i = 0; i < 32; i++){
            if (i === 8 || i === 12 || i === 16 || i === 20) uuid += "-";
            var randomDigit = Math.random() * 16 | 0;
            if (i === 12) uuid += "4";
            else if (i === 16) uuid += (randomDigit & 3 | 8).toString(16);
            else uuid += randomDigit.toString(16);
        }
        return uuid;
    };
    return Identity;
}();
module.exports.default = $12a7cee8beac65a4$var$Identity;

});
parcelRegister("eJCf0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LOCAL_STORAGE_KEYS = module.exports.STATSIG_LOCAL_STORAGE_LOGGING_REQUEST_KEY = module.exports.STATSIG_STABLE_ID_KEY = module.exports.INTERNAL_STORE_KEY = void 0;
module.exports.INTERNAL_STORE_KEY = "STATSIG_STORE";
module.exports.STATSIG_STABLE_ID_KEY = "STATSIG_STABLE_ID";
module.exports.STATSIG_LOCAL_STORAGE_LOGGING_REQUEST_KEY = "STATSIG_LOGS";
module.exports.LOCAL_STORAGE_KEYS = {
    INTERNAL_STORE_KEY: true,
    STATSIG_STABLE_ID_KEY: true,
    STATSIG_LOCAL_STORAGE_LOGGING_REQUEST_KEY: true
};

});

parcelRegister("c5V7T", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getUserCacheKey = module.exports.getSortedObject = module.exports.djb2HashForObject = module.exports.getHashValue = module.exports.SimpleHash = void 0;
function $8ce243c2b7222f2e$var$SimpleHash(value) {
    var hash = 0;
    for(var i = 0; i < value.length; i++){
        var character = value.charCodeAt(i);
        hash = (hash << 5) - hash + character;
        hash = hash & hash; // Convert to 32bit integer
    }
    return String(hash >>> 0);
}
module.exports.SimpleHash = $8ce243c2b7222f2e$var$SimpleHash;
function $8ce243c2b7222f2e$var$getHashValue(value, hash_used) {
    if (hash_used === "none") return value;
    return $8ce243c2b7222f2e$var$SimpleHash(value);
}
module.exports.getHashValue = $8ce243c2b7222f2e$var$getHashValue;
function $8ce243c2b7222f2e$var$djb2HashForObject(object) {
    return $8ce243c2b7222f2e$var$SimpleHash(JSON.stringify($8ce243c2b7222f2e$var$getSortedObject(object)));
}
module.exports.djb2HashForObject = $8ce243c2b7222f2e$var$djb2HashForObject;
function $8ce243c2b7222f2e$var$getSortedObject(object) {
    if (object == null) return null;
    var keys = Object.keys(object).sort();
    var sortedObject = {};
    keys.forEach(function(key) {
        var value = object[key];
        if (value instanceof Object) value = $8ce243c2b7222f2e$var$getSortedObject(value);
        sortedObject[key] = value;
    });
    return sortedObject;
}
module.exports.getSortedObject = $8ce243c2b7222f2e$var$getSortedObject;
function $8ce243c2b7222f2e$var$getUserCacheKey(user) {
    var _a;
    var key = "userID:".concat(String((_a = user === null || user === void 0 ? void 0 : user.userID) !== null && _a !== void 0 ? _a : ""));
    var customIDs = user === null || user === void 0 ? void 0 : user.customIDs;
    if (customIDs != null) for(var _i = 0, _b = Object.entries(customIDs); _i < _b.length; _i++){
        var _c = _b[_i], type = _c[0], value = _c[1];
        key += ";".concat(type, ":").concat(value);
    }
    return $8ce243c2b7222f2e$var$SimpleHash(key);
}
module.exports.getUserCacheKey = $8ce243c2b7222f2e$var$getUserCacheKey;

});

parcelRegister("16w86", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $0cdf464654b3d30c$var$StatsigLocalStorage = /** @class */ function() {
    function StatsigLocalStorage() {}
    StatsigLocalStorage.getItem = function(key) {
        var _a;
        try {
            if (this.isStorageAccessible()) return window.localStorage.getItem(key);
        } catch (e) {}
        return (_a = this.fallbackSessionCache[key]) !== null && _a !== void 0 ? _a : null;
    };
    StatsigLocalStorage.setItem = function(key, value) {
        try {
            if (this.isStorageAccessible()) {
                window.localStorage.setItem(key, value);
                return;
            }
        } catch (e) {}
        this.fallbackSessionCache[key] = value;
    };
    StatsigLocalStorage.removeItem = function(key) {
        try {
            if (this.isStorageAccessible()) {
                window.localStorage.removeItem(key);
                return;
            }
        } catch (e) {}
        delete this.fallbackSessionCache[key];
    };
    StatsigLocalStorage.isStorageAccessible = function(ignoreDisabledOption) {
        if (ignoreDisabledOption === void 0) ignoreDisabledOption = false;
        if (this.canAccessStorageAccessible == null) this.canAccessStorageAccessible = typeof Storage !== "undefined" && typeof window !== "undefined" && window != null && window.localStorage != null;
        var canAccess = this.canAccessStorageAccessible;
        if (ignoreDisabledOption) return canAccess;
        return !this.disabled && canAccess;
    };
    StatsigLocalStorage.disabled = false;
    StatsigLocalStorage.fallbackSessionCache = {};
    StatsigLocalStorage.canAccessStorageAccessible = null;
    return StatsigLocalStorage;
}();
module.exports.default = $0cdf464654b3d30c$var$StatsigLocalStorage;

});

parcelRegister("8lYkT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.version = void 0;
// Generated by genversion.
module.exports.version = "1.4.0";

});


parcelRegister("f5b45", function(module, exports) {
"use strict";
var $afafe7e508378bc5$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $afafe7e508378bc5$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $afafe7e508378bc5$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $afafe7e508378bc5$var$LogEvent_1 = $afafe7e508378bc5$var$__importDefault((parcelRequire("hS11o")));

var $bISsA = parcelRequire("bISsA");

var $eJCf0 = parcelRequire("eJCf0");

var $afafe7e508378bc5$var$StatsigLocalStorage_1 = $afafe7e508378bc5$var$__importDefault((parcelRequire("16w86")));
var $afafe7e508378bc5$var$INTERNAL_EVENT_PREFIX = "statsig::";
var $afafe7e508378bc5$var$CONFIG_EXPOSURE_EVENT = $afafe7e508378bc5$var$INTERNAL_EVENT_PREFIX + "config_exposure";
var $afafe7e508378bc5$var$LAYER_EXPOSURE_EVENT = $afafe7e508378bc5$var$INTERNAL_EVENT_PREFIX + "layer_exposure";
var $afafe7e508378bc5$var$GATE_EXPOSURE_EVENT = $afafe7e508378bc5$var$INTERNAL_EVENT_PREFIX + "gate_exposure";
var $afafe7e508378bc5$var$LOG_FAILURE_EVENT = $afafe7e508378bc5$var$INTERNAL_EVENT_PREFIX + "log_event_failed";
var $afafe7e508378bc5$var$DEFAULT_VALUE_WARNING = $afafe7e508378bc5$var$INTERNAL_EVENT_PREFIX + "default_value_type_mismatch";
var $afafe7e508378bc5$var$MS_RETRY_LOGS_CUTOFF = 432000000;
var $afafe7e508378bc5$var$MAX_BATCHES_TO_RETRY = 100;
var $afafe7e508378bc5$var$MAX_FAILED_EVENTS = 1000;
var $afafe7e508378bc5$var$MAX_LOCAL_STORAGE_SIZE = 1024 * $afafe7e508378bc5$var$MAX_FAILED_EVENTS;
var $afafe7e508378bc5$var$StatsigLogger = /** @class */ function() {
    function StatsigLogger(options, identity, network, errorBoundary) {
        var _this = this;
        this._failedLogEventCount = 0;
        this.logConfigDefaultValueFallback = function(user, message, metadata) {
            var defaultValueEvent = (0, $afafe7e508378bc5$var$LogEvent_1.default)($afafe7e508378bc5$var$DEFAULT_VALUE_WARNING, user, _this._identity._statsigMetadata, message, metadata);
            _this.log(defaultValueEvent);
            _this._loggedErrors.add(message);
        };
        this._options = options;
        this._identity = identity;
        this._network = network;
        this._errorBoundary = errorBoundary;
        this._queue = [];
        this._flushInterval = null;
        this._loggedErrors = new Set();
        this._failedLogEvents = [];
        this._exposureDedupeKeys = {};
        this._failedLogEventCount = 0;
        this._init();
    }
    StatsigLogger.prototype.log = function(event) {
        if (this._options.disableAllLogging) return;
        try {
            if (!this._options.disableCurrentPageLogging && typeof window !== "undefined" && window != null && typeof window.location === "object" && typeof window.location.href === "string") {
                // https://stackoverflow.com/questions/6257463/how-to-get-the-url-without-any-parameters-in-javascript
                var parts = window.location.href.split(/[?#]/);
                if ((parts === null || parts === void 0 ? void 0 : parts.length) > 0) event.statsigMetadata.currentPage = parts[0];
            }
        } catch (_e) {}
        this._queue.push(event);
        if (this._queue.length >= this._options.loggingBufferMaxSize) this.flush();
    };
    StatsigLogger.prototype.resetDedupeKeys = function() {
        this._exposureDedupeKeys = {};
    };
    StatsigLogger.prototype.logGateExposure = function(user, gateName, gateValue, ruleID, secondaryExposures, details, isManualExposure, bootstrapMetadata) {
        var dedupeKey = gateName + String(gateValue) + ruleID + details.reason;
        if (!this._shouldLogExposure(dedupeKey)) return;
        var metadata = {
            gate: gateName,
            gateValue: String(gateValue),
            ruleID: ruleID,
            reason: details.reason,
            time: details.time
        };
        if (isManualExposure) metadata["isManualExposure"] = "true";
        if (bootstrapMetadata != null) metadata["bootstrapMetadata"] = bootstrapMetadata;
        var gateExposure = (0, $afafe7e508378bc5$var$LogEvent_1.default)($afafe7e508378bc5$var$GATE_EXPOSURE_EVENT, user, this._identity._statsigMetadata, null, metadata, secondaryExposures);
        this.log(gateExposure);
    };
    StatsigLogger.prototype.logConfigExposure = function(user, configName, ruleID, secondaryExposures, details, isManualExposure, bootstrapMetadata) {
        var dedupeKey = configName + ruleID + details.reason;
        if (!this._shouldLogExposure(dedupeKey)) return;
        var metadata = {
            config: configName,
            ruleID: ruleID,
            reason: details.reason,
            time: details.time
        };
        if (isManualExposure) metadata["isManualExposure"] = "true";
        if (bootstrapMetadata != null) metadata["bootstrapMetadata"] = bootstrapMetadata;
        var configExposure = (0, $afafe7e508378bc5$var$LogEvent_1.default)($afafe7e508378bc5$var$CONFIG_EXPOSURE_EVENT, user, this._identity._statsigMetadata, null, metadata, secondaryExposures);
        this.log(configExposure);
    };
    StatsigLogger.prototype.logLayerExposure = function(user, configName, ruleID, secondaryExposures, allocatedExperiment, parameterName, isExplicitParameter, details, isManualExposure, bootstrapMetadata) {
        var dedupeKey = [
            configName,
            ruleID,
            allocatedExperiment,
            parameterName,
            String(isExplicitParameter),
            details.reason
        ].join("|");
        if (!this._shouldLogExposure(dedupeKey)) return;
        var metadata = {
            config: configName,
            ruleID: ruleID,
            allocatedExperiment: allocatedExperiment,
            parameterName: parameterName,
            isExplicitParameter: String(isExplicitParameter),
            reason: details.reason,
            time: details.time
        };
        if (isManualExposure) metadata["isManualExposure"] = "true";
        if (bootstrapMetadata != null) metadata["bootstrapMetadata"] = bootstrapMetadata;
        var configExposure = (0, $afafe7e508378bc5$var$LogEvent_1.default)($afafe7e508378bc5$var$LAYER_EXPOSURE_EVENT, user, this._identity._statsigMetadata, null, metadata, secondaryExposures);
        this.log(configExposure);
    };
    StatsigLogger.prototype.shutdown = function() {
        if (this._flushInterval) {
            clearInterval(this._flushInterval);
            this._flushInterval = null;
        }
        this.flush(true);
    };
    StatsigLogger.prototype.flush = function(isClosing) {
        var _this = this;
        if (isClosing === void 0) isClosing = false;
        if (this._queue.length === 0) return;
        var statsigMetadata = this._identity._statsigMetadata;
        var oldQueue = this._queue;
        this._queue = [];
        if (isClosing && !this._network.supportsKeepalive() && typeof navigator !== "undefined" && navigator != null && // @ts-ignore
        navigator.sendBeacon) {
            var beacon = this._network.sendLogBeacon({
                events: oldQueue,
                statsigMetadata: statsigMetadata
            });
            if (!beacon) {
                this._queue = oldQueue.concat(this._queue);
                if (this._queue.length > 0) {
                    this._addFailedRequest({
                        events: this._queue,
                        statsigMetadata: statsigMetadata,
                        time: Date.now()
                    });
                    this._queue = [];
                }
                this._saveFailedRequests();
            }
            return;
        }
        var processor = this;
        this._network.postToEndpoint($bISsA.StatsigEndpoint.Rgstr, {
            events: oldQueue,
            statsigMetadata: statsigMetadata
        }, 3 /* retries */ , 1000 /* backoff */ , isClosing /* useKeepalive */ ).then(function(response) {
            if (!response.ok) throw response;
        }).catch(function(error) {
            if (typeof error.text === "function") error.text().then(function(errorText) {
                _this._errorBoundary._logError($afafe7e508378bc5$var$LOG_FAILURE_EVENT, error, function() {
                    return $afafe7e508378bc5$var$__awaiter(_this, void 0, void 0, function() {
                        return $afafe7e508378bc5$var$__generator(this, function(_a) {
                            return [
                                2 /*return*/ ,
                                {
                                    eventCount: oldQueue.length,
                                    error: errorText
                                }
                            ];
                        });
                    });
                });
            });
            else _this._errorBoundary._logError($afafe7e508378bc5$var$LOG_FAILURE_EVENT, error, function() {
                return $afafe7e508378bc5$var$__awaiter(_this, void 0, void 0, function() {
                    return $afafe7e508378bc5$var$__generator(this, function(_a) {
                        return [
                            2 /*return*/ ,
                            {
                                eventCount: oldQueue.length,
                                error: error.message
                            }
                        ];
                    });
                });
            });
            processor._newFailedRequest($afafe7e508378bc5$var$LOG_FAILURE_EVENT, oldQueue);
        }).finally(function() {
            return $afafe7e508378bc5$var$__awaiter(_this, void 0, void 0, function() {
                return $afafe7e508378bc5$var$__generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            if (!isClosing) return [
                                3 /*break*/ ,
                                2
                            ];
                            if (this._queue.length > 0) {
                                this._addFailedRequest({
                                    events: this._queue,
                                    statsigMetadata: statsigMetadata,
                                    time: Date.now()
                                });
                                // on app background/window blur, save unsent events as a request and clean up the queue (in case app foregrounds)
                                this._queue = [];
                            }
                            return [
                                4 /*yield*/ ,
                                processor._saveFailedRequests()
                            ];
                        case 1:
                            _a.sent();
                            _a.label = 2;
                        case 2:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        });
    };
    StatsigLogger.prototype.sendSavedRequests = function() {
        return $afafe7e508378bc5$var$__awaiter(this, void 0, void 0, function() {
            var failedRequests, fireAndForget, requestBodies, _loop_1, this_1, _i, requestBodies_1, requestBody;
            var _this = this;
            return $afafe7e508378bc5$var$__generator(this, function(_a) {
                fireAndForget = false;
                failedRequests = $afafe7e508378bc5$var$StatsigLocalStorage_1.default.getItem($eJCf0.STATSIG_LOCAL_STORAGE_LOGGING_REQUEST_KEY);
                if (failedRequests == null) {
                    this._clearLocalStorageRequests();
                    return [
                        2 /*return*/ 
                    ];
                }
                if (failedRequests.length > $afafe7e508378bc5$var$MAX_LOCAL_STORAGE_SIZE) fireAndForget = true;
                requestBodies = [];
                try {
                    requestBodies = JSON.parse(failedRequests);
                    _loop_1 = function(requestBody) {
                        if (requestBody != null && requestBody.events && Array.isArray(requestBody.events)) this_1._network.postToEndpoint($bISsA.StatsigEndpoint.Rgstr, requestBody).then(function(response) {
                            if (!response.ok) throw Error(response.status + "");
                        }).catch(function(_e) {
                            if (fireAndForget) return;
                            _this._addFailedRequest(requestBody);
                        });
                    };
                    this_1 = this;
                    for(_i = 0, requestBodies_1 = requestBodies; _i < requestBodies_1.length; _i++){
                        requestBody = requestBodies_1[_i];
                        _loop_1(requestBody);
                    }
                } catch (_e) {} finally{
                    this._clearLocalStorageRequests();
                }
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    StatsigLogger.prototype._init = function() {
        var _this = this;
        if (typeof window !== "undefined" && typeof window.addEventListener === "function") {
            window.addEventListener("blur", function() {
                return _this.flush(true);
            });
            window.addEventListener("beforeunload", function() {
                return _this.flush(true);
            });
            window.addEventListener("load", function() {
                setTimeout(function() {
                    return _this.flush();
                }, 100);
                setTimeout(function() {
                    return _this.flush();
                }, 1000);
            });
        }
        if (typeof document !== "undefined" && typeof document.addEventListener === "function") document.addEventListener("visibilitychange", function() {
            _this.flush(document.visibilityState !== "visible");
        });
        if (!this._options.ignoreWindowUndefined && (typeof window === "undefined" || window == null)) // dont set the flush interval outside of client browser environments
        return;
        if (this._options.localMode) // unnecessary interval in local mode since logs dont flush anyway
        return;
        var me = this;
        this._flushInterval = setInterval(function() {
            me.flush();
        }, this._options.loggingIntervalMillis);
        // Quick flush
        setTimeout(function() {
            return _this.flush();
        }, 100);
        setTimeout(function() {
            return _this.flush();
        }, 1000);
    };
    StatsigLogger.prototype._shouldLogExposure = function(key) {
        var lastTime = this._exposureDedupeKeys[key];
        var now = Date.now();
        if (lastTime == null) {
            this._exposureDedupeKeys[key] = now;
            return true;
        }
        if (lastTime >= now - 600000) return false;
        this._exposureDedupeKeys[key] = now;
        return true;
    };
    StatsigLogger.prototype._saveFailedRequests = function() {
        return $afafe7e508378bc5$var$__awaiter(this, void 0, void 0, function() {
            var requestsCopy;
            return $afafe7e508378bc5$var$__generator(this, function(_a) {
                if (this._failedLogEvents.length > 0) {
                    requestsCopy = JSON.stringify(this._failedLogEvents);
                    if (requestsCopy.length > $afafe7e508378bc5$var$MAX_LOCAL_STORAGE_SIZE) {
                        this._clearLocalStorageRequests();
                        return [
                            2 /*return*/ 
                        ];
                    }
                    $afafe7e508378bc5$var$StatsigLocalStorage_1.default.setItem($eJCf0.STATSIG_LOCAL_STORAGE_LOGGING_REQUEST_KEY, requestsCopy);
                }
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    StatsigLogger.prototype._addFailedRequest = function(requestBody) {
        if (requestBody.time < Date.now() - $afafe7e508378bc5$var$MS_RETRY_LOGS_CUTOFF) return;
        if (this._failedLogEvents.length > $afafe7e508378bc5$var$MAX_BATCHES_TO_RETRY) return;
        var additionalEvents = requestBody.events.length;
        if (this._failedLogEventCount + additionalEvents > $afafe7e508378bc5$var$MAX_FAILED_EVENTS) return;
        this._failedLogEvents.push(requestBody);
        this._failedLogEventCount += additionalEvents;
    };
    StatsigLogger.prototype._clearLocalStorageRequests = function() {
        $afafe7e508378bc5$var$StatsigLocalStorage_1.default.removeItem($eJCf0.STATSIG_LOCAL_STORAGE_LOGGING_REQUEST_KEY);
    };
    StatsigLogger.prototype._newFailedRequest = function(name, queue) {
        if (this._loggedErrors.has(name)) return;
        this._loggedErrors.add(name);
        this._failedLogEvents.push({
            events: queue,
            statsigMetadata: this._identity._statsigMetadata,
            time: Date.now()
        });
        this._saveFailedRequests().then(function() {});
    };
    return StatsigLogger;
}();
module.exports.default = $afafe7e508378bc5$var$StatsigLogger;

});
parcelRegister("hS11o", function(module, exports) {
"use strict";
var $d02845aa53847add$var$__assign = module.exports && module.exports.__assign || function() {
    $d02845aa53847add$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $d02845aa53847add$var$__assign.apply(this, arguments);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
function $d02845aa53847add$var$makeLogEvent(eventName, user, statsigMetadata, value, metadata, secondaryExposures) {
    if (value === void 0) value = null;
    if (metadata === void 0) metadata = null;
    var logUser = user;
    if (logUser === null || logUser === void 0 ? void 0 : logUser.privateAttributes) {
        logUser = $d02845aa53847add$var$__assign({}, user);
        delete logUser.privateAttributes;
    }
    return {
        time: Date.now(),
        eventName: eventName,
        statsigMetadata: statsigMetadata,
        user: logUser,
        value: value,
        metadata: metadata,
        secondaryExposures: secondaryExposures
    };
}
module.exports.default = $d02845aa53847add$var$makeLogEvent;

});

parcelRegister("bISsA", function(module, exports) {
"use strict";
var $888e0c694a5c88f0$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $888e0c694a5c88f0$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StatsigEndpoint = void 0;
var $888e0c694a5c88f0$var$StatsigEndpoint;
(function(StatsigEndpoint) {
    StatsigEndpoint["Initialize"] = "initialize";
    StatsigEndpoint["Rgstr"] = "rgstr";
    StatsigEndpoint["LogEventBeacon"] = "log_event_beacon";
})($888e0c694a5c88f0$var$StatsigEndpoint = module.exports.StatsigEndpoint || (module.exports.StatsigEndpoint = {}));
var $888e0c694a5c88f0$var$NO_CONTENT = 204;
var $888e0c694a5c88f0$var$StatsigNetwork = /** @class */ function() {
    function StatsigNetwork(options, identity, errorBoundary) {
        this.retryCodes = {
            408: true,
            500: true,
            502: true,
            503: true,
            504: true,
            522: true,
            524: true,
            599: true
        };
        this.canUseKeepalive = false;
        this._options = options;
        this._identity = identity;
        this._errorBoundary = errorBoundary;
        this.leakyBucket = {};
        this._init();
    }
    StatsigNetwork.prototype.fetchValues = function(user, sinceTime, timeout, previousDerivedFields) {
        var input = {
            user: user,
            statsigMetadata: this._identity._statsigMetadata,
            sinceTime: sinceTime !== null && sinceTime !== void 0 ? sinceTime : undefined,
            hash: "djb2",
            previousDerivedFields: previousDerivedFields
        };
        return this._postWithTimeout($888e0c694a5c88f0$var$StatsigEndpoint.Initialize, input, timeout, 3);
    };
    StatsigNetwork.prototype.sendLogBeacon = function(payload) {
        if (this._options.localMode) return true;
        var url = new URL(this._options.eventLoggingApi + $888e0c694a5c88f0$var$StatsigEndpoint.LogEventBeacon);
        url.searchParams.append("k", this._identity._sdkKey);
        payload.clientTime = Date.now() + "";
        var stringPayload = null;
        try {
            stringPayload = JSON.stringify(payload);
        } catch (_e) {
            return false;
        }
        return navigator.sendBeacon(url.toString(), stringPayload);
    };
    StatsigNetwork.prototype.postToEndpoint = function(endpointName, body, retries, backoff, useKeepalive) {
        if (retries === void 0) retries = 0;
        if (backoff === void 0) backoff = 1000;
        if (useKeepalive === void 0) useKeepalive = false;
        return $888e0c694a5c88f0$var$__awaiter(this, void 0, void 0, function() {
            var api, url, counter, postBody, statsigMetadata, params;
            var _this = this;
            return $888e0c694a5c88f0$var$__generator(this, function(_a) {
                if (this._options.localMode) return [
                    2 /*return*/ ,
                    Promise.reject("no network requests in localMode")
                ];
                if (typeof fetch !== "function") // fetch is not defined in this environment, short circuit
                return [
                    2 /*return*/ ,
                    Promise.reject("fetch is not defined")
                ];
                if (typeof window === "undefined" && !this._options.ignoreWindowUndefined) // by default, dont issue requests from the server
                return [
                    2 /*return*/ ,
                    Promise.reject("window is not defined")
                ];
                api = [
                    $888e0c694a5c88f0$var$StatsigEndpoint.Initialize
                ].includes(endpointName) ? this._options.api : this._options.eventLoggingApi;
                url = api + endpointName;
                counter = this.leakyBucket[url];
                if (counter != null && counter >= 30) return [
                    2 /*return*/ ,
                    Promise.reject(new Error("Request failed because you are making the same request too frequently."))
                ];
                if (counter == null) this.leakyBucket[url] = 1;
                else this.leakyBucket[url] = counter + 1;
                postBody = JSON.stringify(body);
                statsigMetadata = this._identity._statsigMetadata;
                params = {
                    method: "POST",
                    body: postBody,
                    headers: {
                        "Content-type": "application/json; charset=UTF-8",
                        "STATSIG-API-KEY": this._identity._sdkKey,
                        "STATSIG-CLIENT-TIME": Date.now() + "",
                        "STATSIG-SDK-TYPE": statsigMetadata.sdkType,
                        "STATSIG-SDK-VERSION": statsigMetadata.sdkVersion
                    }
                };
                if (this.canUseKeepalive && useKeepalive) params.keepalive = true;
                return [
                    2 /*return*/ ,
                    fetch(url, params).then(function(res) {
                        return $888e0c694a5c88f0$var$__awaiter(_this, void 0, void 0, function() {
                            var networkResponse, text, errorText;
                            return $888e0c694a5c88f0$var$__generator(this, function(_a) {
                                switch(_a.label){
                                    case 0:
                                        if (!res.ok) return [
                                            3 /*break*/ ,
                                            4
                                        ];
                                        networkResponse = res;
                                        if (!(res.status === $888e0c694a5c88f0$var$NO_CONTENT)) return [
                                            3 /*break*/ ,
                                            1
                                        ];
                                        networkResponse.data = {
                                            has_updates: false,
                                            is_no_content: true
                                        };
                                        return [
                                            3 /*break*/ ,
                                            3
                                        ];
                                    case 1:
                                        return [
                                            4 /*yield*/ ,
                                            res.text()
                                        ];
                                    case 2:
                                        text = _a.sent();
                                        networkResponse.data = JSON.parse(text);
                                        _a.label = 3;
                                    case 3:
                                        return [
                                            2 /*return*/ ,
                                            Promise.resolve(networkResponse)
                                        ];
                                    case 4:
                                        if (!this.retryCodes[res.status]) retries = 0;
                                        return [
                                            4 /*yield*/ ,
                                            res.text()
                                        ];
                                    case 5:
                                        errorText = _a.sent();
                                        return [
                                            2 /*return*/ ,
                                            Promise.reject(new Error("".concat(res.status, ": ").concat(errorText)))
                                        ];
                                }
                            });
                        });
                    }).catch(function(e) {
                        if (retries > 0) return new Promise(function(resolve, reject) {
                            setTimeout(function() {
                                _this.leakyBucket[url] = Math.max(_this.leakyBucket[url] - 1, 0);
                                _this.postToEndpoint(endpointName, body, retries - 1, backoff * 2, useKeepalive).then(resolve).catch(reject);
                            }, backoff);
                        });
                        return Promise.reject(e);
                    }).finally(function() {
                        _this.leakyBucket[url] = Math.max(_this.leakyBucket[url] - 1, 0);
                    })
                ];
            });
        });
    };
    StatsigNetwork.prototype.supportsKeepalive = function() {
        return this.canUseKeepalive;
    };
    StatsigNetwork.prototype._init = function() {
        if (!this._options.disableNetworkKeepalive) try {
            this.canUseKeepalive = "keepalive" in new Request("");
        } catch (_e) {}
    };
    StatsigNetwork.prototype._postWithTimeout = function(endpointName, body, timeout, retries, backoff) {
        var _this = this;
        if (timeout === void 0) timeout = 0;
        if (retries === void 0) retries = 0;
        if (backoff === void 0) backoff = 1000;
        var hasTimedOut = false;
        var timer = null;
        var cachedReturnValue = null;
        var eventuals = [];
        var eventually = function(boundScope) {
            return function(fn) {
                if (hasTimedOut && cachedReturnValue) fn(cachedReturnValue);
                else eventuals.push(fn);
                return boundScope;
            };
        };
        if (timeout != 0) timer = new Promise(function(resolve, reject) {
            setTimeout(function() {
                hasTimedOut = true;
                reject(new Error("The initialization timeout of ".concat(timeout, "ms has been hit before the network request has completed.")));
            }, timeout);
        });
        var fetchPromise = this.postToEndpoint(endpointName, body, retries, backoff).then(function(res) {
            if (!res.ok) return Promise.reject(new Error("Request to ".concat(endpointName, " failed with status ").concat(res.status)));
            if (typeof res.data !== "object") {
                var error = new Error("Request to ".concat(endpointName, " received invalid response type. Expected 'object' but got '").concat(typeof res.data, "'"));
                _this._errorBoundary._logError("postWithTimeoutInvalidRes", error, function() {
                    return $888e0c694a5c88f0$var$__awaiter(_this, void 0, void 0, function() {
                        return $888e0c694a5c88f0$var$__generator(this, function(_a) {
                            return [
                                2 /*return*/ ,
                                this._getErrorData(endpointName, body, retries, backoff, res)
                            ];
                        });
                    });
                });
                return Promise.reject(error);
            }
            var json = res.data;
            return _this._errorBoundary._capture("postWithTimeout", function() {
                return $888e0c694a5c88f0$var$__awaiter(_this, void 0, void 0, function() {
                    return $888e0c694a5c88f0$var$__generator(this, function(_a) {
                        cachedReturnValue = json;
                        if (hasTimedOut) {
                            eventuals.forEach(function(fn) {
                                return fn(json);
                            });
                            eventuals = [];
                        }
                        return [
                            2 /*return*/ ,
                            Promise.resolve(json)
                        ];
                    });
                });
            }, function() {
                return Promise.resolve({});
            }, function() {
                return $888e0c694a5c88f0$var$__awaiter(_this, void 0, void 0, function() {
                    return $888e0c694a5c88f0$var$__generator(this, function(_a) {
                        return [
                            2 /*return*/ ,
                            this._getErrorData(endpointName, body, retries, backoff, res)
                        ];
                    });
                });
            });
        }).catch(function(e) {
            return Promise.reject(e);
        });
        var racingPromise = timer ? Promise.race([
            fetchPromise,
            timer
        ]) : fetchPromise;
        racingPromise.eventually = eventually(racingPromise);
        return racingPromise;
    };
    StatsigNetwork.prototype._getErrorData = function(endpointName, body, retries, backoff, res) {
        var _a;
        return $888e0c694a5c88f0$var$__awaiter(this, void 0, void 0, function() {
            var headers_1;
            return $888e0c694a5c88f0$var$__generator(this, function(_b) {
                try {
                    headers_1 = {};
                    ((_a = res.headers) !== null && _a !== void 0 ? _a : []).forEach(function(value, key) {
                        headers_1[key] = value;
                    });
                    return [
                        2 /*return*/ ,
                        {
                            responseInfo: {
                                headers: headers_1,
                                status: res.status,
                                statusText: res.statusText,
                                type: res.type,
                                url: res.url,
                                redirected: res.redirected,
                                bodySnippet: res.data ? JSON.stringify(res.data).slice(0, 500) : null
                            },
                            requestInfo: {
                                endpointName: endpointName,
                                bodySnippet: JSON.stringify(body).slice(0, 500),
                                retries: retries,
                                backoff: backoff
                            }
                        }
                    ];
                } catch (_e) {
                    return [
                        2 /*return*/ ,
                        {
                            statusText: "statsig::failed to extract extra data"
                        }
                    ];
                }
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    return StatsigNetwork;
}();
module.exports.default = $888e0c694a5c88f0$var$StatsigNetwork;

});


parcelRegister("OnTwj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.INIT_TIMEOUT_DEFAULT_MS = void 0;
var $09773492e1a92025$var$DEFAULT_FEATURE_GATE_API = "https://featuregates.org/v1/";
var $09773492e1a92025$var$DEFAULT_EVENT_LOGGING_API = "https://events.statsigapi.net/v1/";
module.exports.INIT_TIMEOUT_DEFAULT_MS = 3000;
var $09773492e1a92025$var$StatsigSDKOptions = /** @class */ function() {
    function StatsigSDKOptions(options) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q;
        if (options == null) options = {};
        var api = (_a = options.api) !== null && _a !== void 0 ? _a : $09773492e1a92025$var$DEFAULT_FEATURE_GATE_API;
        this.api = api.endsWith("/") ? api : api + "/";
        this.disableCurrentPageLogging = (_b = options.disableCurrentPageLogging) !== null && _b !== void 0 ? _b : false;
        this.environment = (_c = options.environment) !== null && _c !== void 0 ? _c : null;
        this.loggingIntervalMillis = this.normalizeNumberInput(options.loggingIntervalMillis, {
            default: 10000,
            min: 1000,
            max: 60000
        });
        this.loggingBufferMaxSize = this.normalizeNumberInput(options.loggingBufferMaxSize, {
            default: 100,
            min: 2,
            max: 500
        });
        this.disableNetworkKeepalive = (_d = options.disableNetworkKeepalive) !== null && _d !== void 0 ? _d : false;
        this.overrideStableID = (_e = options.overrideStableID) !== null && _e !== void 0 ? _e : null;
        this.localMode = (_f = options.localMode) !== null && _f !== void 0 ? _f : false;
        this.initTimeoutMs = options.initTimeoutMs && options.initTimeoutMs >= 0 ? options.initTimeoutMs : module.exports.INIT_TIMEOUT_DEFAULT_MS;
        this.disableErrorLogging = (_g = options.disableErrorLogging) !== null && _g !== void 0 ? _g : false;
        this.disableAutoMetricsLogging = (_h = options.disableAutoMetricsLogging) !== null && _h !== void 0 ? _h : false;
        this.initializeValues = (_j = options.initializeValues) !== null && _j !== void 0 ? _j : null;
        var eventLoggingApi = (_l = (_k = options.eventLoggingApi) !== null && _k !== void 0 ? _k : options.api) !== null && _l !== void 0 ? _l : $09773492e1a92025$var$DEFAULT_EVENT_LOGGING_API;
        this.eventLoggingApi = eventLoggingApi.endsWith("/") ? eventLoggingApi : eventLoggingApi + "/";
        this.disableLocalStorage = (_m = options.disableLocalStorage) !== null && _m !== void 0 ? _m : false;
        this.ignoreWindowUndefined = (_o = options === null || options === void 0 ? void 0 : options.ignoreWindowUndefined) !== null && _o !== void 0 ? _o : false;
        this.updateUserCompletionCallback = (_p = options === null || options === void 0 ? void 0 : options.updateUserCompletionCallback) !== null && _p !== void 0 ? _p : null;
        this.disableAllLogging = (_q = options === null || options === void 0 ? void 0 : options.disableAllLogging) !== null && _q !== void 0 ? _q : false;
    }
    StatsigSDKOptions.prototype.normalizeNumberInput = function(input, bounds) {
        if (input == null) return bounds.default;
        return Math.max(Math.min(input, bounds.max), bounds.min);
    };
    return StatsigSDKOptions;
}();
module.exports.default = $09773492e1a92025$var$StatsigSDKOptions;

});

parcelRegister("5QxP2", function(module, exports) {
"use strict";
var $441c0b7082129e71$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $441c0b7082129e71$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $441c0b7082129e71$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.EvaluationReason = void 0;

var $441c0b7082129e71$var$DynamicConfig_1 = $441c0b7082129e71$var$__importDefault((parcelRequire("2MIyU")));

var $441c0b7082129e71$var$Layer_1 = $441c0b7082129e71$var$__importDefault((parcelRequire("9F78u")));

var $441c0b7082129e71$var$BootstrapValidator_1 = $441c0b7082129e71$var$__importDefault((parcelRequire("f2NPH")));

var $eJCf0 = parcelRequire("eJCf0");

var $c5V7T = parcelRequire("c5V7T");

var $441c0b7082129e71$var$StatsigLocalStorage_1 = $441c0b7082129e71$var$__importDefault((parcelRequire("16w86")));
var $441c0b7082129e71$var$EvaluationReason;
(function(EvaluationReason) {
    EvaluationReason["Network"] = "Network";
    EvaluationReason["Bootstrap"] = "Bootstrap";
    EvaluationReason["InvalidBootstrap"] = "InvalidBootstrap";
    EvaluationReason["Cache"] = "Cache";
    EvaluationReason["Unrecognized"] = "Unrecognized";
    EvaluationReason["Uninitialized"] = "Uninitialized";
    EvaluationReason["Error"] = "Error";
    EvaluationReason["NetworkNotModified"] = "NetworkNotModified";
    EvaluationReason["LocalOverride"] = "LocalOverride";
})($441c0b7082129e71$var$EvaluationReason = module.exports.EvaluationReason || (module.exports.EvaluationReason = {}));
var $441c0b7082129e71$var$MAX_USER_VALUE_CACHED = 10;
var $441c0b7082129e71$var$StatsigStore = /** @class */ function() {
    function StatsigStore(identity, onDefaultValueFallback, initializeValues) {
        this._identity = identity;
        this._onDefaultValueFallback = onDefaultValueFallback;
        this._userCacheKey = this._identity.getUserCacheKey();
        this._values = {};
        this._userValues = this._getDefaultUserCacheValues();
        this._loaded = false;
        this._reason = $441c0b7082129e71$var$EvaluationReason.Uninitialized;
        if (initializeValues) this.bootstrap(initializeValues);
        else this._loadFromLocalStorage();
    }
    StatsigStore.prototype.updateUser = function() {
        this._userCacheKey = this._identity.getUserCacheKey();
        return this._setUserValueFromCache();
    };
    StatsigStore.prototype.bootstrap = function(initializeValues) {
        var _a, _b, _c, _d;
        var key = this._identity.getUserCacheKey();
        var user = this._identity._user;
        var reason = $441c0b7082129e71$var$BootstrapValidator_1.default.isValid(user, initializeValues) ? $441c0b7082129e71$var$EvaluationReason.Bootstrap : $441c0b7082129e71$var$EvaluationReason.InvalidBootstrap;
        // clients are going to assume that the SDK is bootstrapped after this method runs
        // if we fail to parse, we will fall back to defaults, but we dont want to throw
        // when clients try to check gates/configs/etc after this point
        this._loaded = true;
        try {
            this._userValues.feature_gates = (_a = initializeValues.feature_gates) !== null && _a !== void 0 ? _a : {};
            this._userValues.dynamic_configs = (_b = initializeValues.dynamic_configs) !== null && _b !== void 0 ? _b : {};
            this._userValues.layer_configs = (_c = initializeValues.layer_configs) !== null && _c !== void 0 ? _c : {};
            this._userValues.evaluation_time = Date.now();
            this._userValues.time = (_d = initializeValues.time) !== null && _d !== void 0 ? _d : Date.now();
            this._values[key] = this._userValues;
            this._reason = reason;
            var generatorSDKInfo = initializeValues.sdkInfo;
            this._userValues.bootstrapMetadata = {};
            if (generatorSDKInfo != null) this._userValues.bootstrapMetadata.generatorSDKInfo = generatorSDKInfo;
            if (initializeValues.user != null) this._userValues.bootstrapMetadata.user = initializeValues.user;
            if (initializeValues.time != null) this._userValues.bootstrapMetadata.lcut = initializeValues.time;
        } catch (_e) {
            return;
        }
    };
    StatsigStore.prototype.getBootstrapMetadata = function() {
        var _a;
        return (_a = this._userValues.bootstrapMetadata) !== null && _a !== void 0 ? _a : null;
    };
    StatsigStore.prototype.isLoaded = function() {
        return this._loaded;
    };
    StatsigStore.prototype.getLastUpdateTime = function(user) {
        var userHash = (0, $c5V7T.djb2HashForObject)(user);
        if (this._userValues.user_hash == userHash) return this._userValues.time;
        return null;
    };
    StatsigStore.prototype.getPreviousDerivedFields = function(user) {
        var userHash = (0, $c5V7T.djb2HashForObject)(user);
        if (this._userValues.user_hash == userHash) return this._userValues.derived_fields;
        return undefined;
    };
    StatsigStore.prototype.setEvaluationReason = function(evalReason) {
        this._reason = evalReason;
    };
    StatsigStore.prototype.save = function(user, jsonConfigs, updateState) {
        if (updateState === void 0) updateState = true;
        return $441c0b7082129e71$var$__awaiter(this, void 0, void 0, function() {
            var requestedUserCacheKey, initResponse, userValues, _a;
            return $441c0b7082129e71$var$__generator(this, function(_b) {
                switch(_b.label){
                    case 0:
                        requestedUserCacheKey = (0, $c5V7T.getUserCacheKey)(user);
                        initResponse = jsonConfigs;
                        this._mergeInitializeResponseIntoUserMap(initResponse, this._values, requestedUserCacheKey, user, function(userValues) {
                            return userValues;
                        });
                        if (updateState) {
                            userValues = this._values[requestedUserCacheKey];
                            if (userValues && requestedUserCacheKey && requestedUserCacheKey == this._userCacheKey) {
                                this._userValues = userValues;
                                this._reason = $441c0b7082129e71$var$EvaluationReason.Network;
                            }
                        }
                        _a = this;
                        return [
                            4 /*yield*/ ,
                            this._writeValuesToStorage(this._values)
                        ];
                    case 1:
                        _a._values = _b.sent();
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    StatsigStore.prototype.checkGate = function(gateName) {
        var _a;
        var gateNameHash = (0, $c5V7T.getHashValue)(gateName, this._userValues.hash_used);
        var gateValue = {
            name: gateName,
            value: false,
            rule_id: "",
            secondary_exposures: []
        };
        var details;
        var value = (_a = this._userValues) === null || _a === void 0 ? void 0 : _a.feature_gates[gateNameHash];
        if (value) gateValue = value;
        details = this._getEvaluationDetails(value != null);
        return {
            evaluationDetails: details,
            gate: gateValue
        };
    };
    StatsigStore.prototype.getConfig = function(configName) {
        var _a, _b;
        var configNameHash = (0, $c5V7T.getHashValue)(configName, this._userValues.hash_used);
        var configValue;
        var details;
        if (((_a = this._userValues) === null || _a === void 0 ? void 0 : _a.dynamic_configs[configNameHash]) != null) {
            var rawConfigValue = (_b = this._userValues) === null || _b === void 0 ? void 0 : _b.dynamic_configs[configNameHash];
            details = this._getEvaluationDetails(true);
            configValue = this._createDynamicConfig(configName, rawConfigValue, details);
        } else {
            details = this._getEvaluationDetails(false);
            configValue = new $441c0b7082129e71$var$DynamicConfig_1.default(configName, {}, "", details);
        }
        return configValue;
    };
    StatsigStore.prototype.getLayer = function(logParameterFunction, layerName) {
        var _a, _b, _c;
        var latestValue = this._getLatestValue(layerName, "layer_configs");
        var details = this._getEvaluationDetails(latestValue != null);
        return $441c0b7082129e71$var$Layer_1.default._create(layerName, (_a = latestValue === null || latestValue === void 0 ? void 0 : latestValue.value) !== null && _a !== void 0 ? _a : {}, (_b = latestValue === null || latestValue === void 0 ? void 0 : latestValue.rule_id) !== null && _b !== void 0 ? _b : "", details, logParameterFunction, latestValue === null || latestValue === void 0 ? void 0 : latestValue.secondary_exposures, latestValue === null || latestValue === void 0 ? void 0 : latestValue.undelegated_secondary_exposures, (_c = latestValue === null || latestValue === void 0 ? void 0 : latestValue.allocated_experiment_name) !== null && _c !== void 0 ? _c : "", latestValue === null || latestValue === void 0 ? void 0 : latestValue.explicit_parameters);
    };
    StatsigStore.prototype.getGlobalEvaluationDetails = function() {
        var _a, _b;
        return {
            reason: (_a = this._reason) !== null && _a !== void 0 ? _a : $441c0b7082129e71$var$EvaluationReason.Uninitialized,
            time: (_b = this._userValues.evaluation_time) !== null && _b !== void 0 ? _b : 0
        };
    };
    StatsigStore.prototype._loadFromLocalStorage = function() {
        this._parseCachedValues($441c0b7082129e71$var$StatsigLocalStorage_1.default.getItem($eJCf0.INTERNAL_STORE_KEY));
        this._loaded = true;
    };
    StatsigStore.prototype._parseCachedValues = function(allValues) {
        try {
            this._values = allValues ? JSON.parse(allValues) : this._values;
            this._setUserValueFromCache();
        } catch (e) {
            // Cached value corrupted, remove cache
            this._removeFromStorage($eJCf0.INTERNAL_STORE_KEY);
        }
    };
    StatsigStore.prototype._setUserValueFromCache = function() {
        var _a;
        var cachedValues = this._values[this._userCacheKey];
        if (cachedValues == null) {
            this._resetUserValues();
            this._reason = $441c0b7082129e71$var$EvaluationReason.Uninitialized;
            return null;
        }
        this._userValues = cachedValues;
        this._reason = $441c0b7082129e71$var$EvaluationReason.Cache;
        return (_a = cachedValues.evaluation_time) !== null && _a !== void 0 ? _a : 0;
    };
    StatsigStore.prototype._removeFromStorage = function(key) {
        $441c0b7082129e71$var$StatsigLocalStorage_1.default.removeItem(key);
    };
    /**
     * Merges the provided init configs into the provided config map, according to the provided merge function
     */ StatsigStore.prototype._mergeInitializeResponseIntoUserMap = function(data, configMap, requestedUserCacheKey, user, mergeFn) {
        if (requestedUserCacheKey) {
            var requestedUserValues = this._convertAPIDataToCacheValues(data, requestedUserCacheKey);
            if (data.has_updates && data.time) {
                var userHash = (0, $c5V7T.djb2HashForObject)(user);
                requestedUserValues.user_hash = userHash;
            }
            configMap[requestedUserCacheKey] = mergeFn(requestedUserValues, requestedUserCacheKey);
        }
    };
    StatsigStore.prototype._getDefaultUserCacheValues = function() {
        return {
            feature_gates: {},
            layer_configs: {},
            dynamic_configs: {},
            time: 0,
            evaluation_time: 0,
            has_updates: false
        };
    };
    /**
     * Writes the provided values to storage, truncating down to
     * MAX_USER_VALUE_CACHED number entries.
     * @returns The truncated entry list
     */ StatsigStore.prototype._writeValuesToStorage = function(valuesToWrite) {
        return $441c0b7082129e71$var$__awaiter(this, void 0, void 0, function() {
            var filteredValues;
            return $441c0b7082129e71$var$__generator(this, function(_a) {
                filteredValues = Object.entries(valuesToWrite).sort(function(_a, _b) {
                    var _c, _d;
                    var a = _a[1];
                    var b = _b[1];
                    if (a == null) return 1;
                    if (b == null) return -1;
                    return ((_c = b === null || b === void 0 ? void 0 : b.evaluation_time) !== null && _c !== void 0 ? _c : b === null || b === void 0 ? void 0 : b.time) - ((_d = a === null || a === void 0 ? void 0 : a.evaluation_time) !== null && _d !== void 0 ? _d : a === null || a === void 0 ? void 0 : a.time);
                }).slice(0, $441c0b7082129e71$var$MAX_USER_VALUE_CACHED);
                valuesToWrite = Object.fromEntries(filteredValues);
                $441c0b7082129e71$var$StatsigLocalStorage_1.default.setItem($eJCf0.INTERNAL_STORE_KEY, JSON.stringify(valuesToWrite));
                return [
                    2 /*return*/ ,
                    valuesToWrite
                ];
            });
        });
    };
    StatsigStore.prototype._getLatestValue = function(name, topLevelKey) {
        var _a, _b, _c, _d, _f;
        var hash = (0, $c5V7T.getHashValue)(name, this._userValues.hash_used);
        return (_c = (_b = (_a = this._userValues) === null || _a === void 0 ? void 0 : _a[topLevelKey]) === null || _b === void 0 ? void 0 : _b[hash]) !== null && _c !== void 0 ? _c : (_f = (_d = this._userValues) === null || _d === void 0 ? void 0 : _d[topLevelKey]) === null || _f === void 0 ? void 0 : _f[name];
    };
    StatsigStore.prototype._createDynamicConfig = function(name, apiConfig, details) {
        var _a, _b, _c;
        return new $441c0b7082129e71$var$DynamicConfig_1.default(name, (_a = apiConfig === null || apiConfig === void 0 ? void 0 : apiConfig.value) !== null && _a !== void 0 ? _a : {}, (_b = apiConfig === null || apiConfig === void 0 ? void 0 : apiConfig.rule_id) !== null && _b !== void 0 ? _b : "", details, apiConfig === null || apiConfig === void 0 ? void 0 : apiConfig.secondary_exposures, (_c = apiConfig === null || apiConfig === void 0 ? void 0 : apiConfig.allocated_experiment_name) !== null && _c !== void 0 ? _c : "", this._makeOnConfigDefaultValueFallback(this._identity._user));
    };
    StatsigStore.prototype._getEvaluationDetails = function(valueExists, reasonOverride) {
        var _a;
        if (valueExists) return {
            reason: this._reason,
            time: (_a = this._userValues.evaluation_time) !== null && _a !== void 0 ? _a : Date.now()
        };
        else return {
            reason: reasonOverride !== null && reasonOverride !== void 0 ? reasonOverride : this._reason == $441c0b7082129e71$var$EvaluationReason.Uninitialized ? $441c0b7082129e71$var$EvaluationReason.Uninitialized : $441c0b7082129e71$var$EvaluationReason.Unrecognized,
            time: Date.now()
        };
    };
    StatsigStore.prototype._resetUserValues = function() {
        this._userValues = this._getDefaultUserCacheValues();
    };
    StatsigStore.prototype._convertAPIDataToCacheValues = function(data, cacheKey) {
        // Specifically pulling keys from data here to avoid pulling in unwanted keys
        return {
            feature_gates: data.feature_gates,
            layer_configs: data.layer_configs,
            dynamic_configs: data.dynamic_configs,
            time: data.time == null || isNaN(data.time) ? 0 : data.time,
            evaluation_time: Date.now(),
            derived_fields: data.derived_fields,
            hash_used: data.hash_used
        };
    };
    StatsigStore.prototype._makeOnConfigDefaultValueFallback = function(user) {
        var _this = this;
        return function(config, parameter, defaultValueType, valueType) {
            if (!_this.isLoaded()) return;
            _this._onDefaultValueFallback(user, "Parameter ".concat(parameter, " is a value of type ").concat(valueType, ".\n          Returning requested defaultValue type ").concat(defaultValueType), {
                name: config._name,
                ruleID: config._ruleID,
                parameter: parameter,
                defaultValueType: defaultValueType,
                valueType: valueType
            });
        };
    };
    return StatsigStore;
}();
module.exports.default = $441c0b7082129e71$var$StatsigStore;

});
parcelRegister("f2NPH", function(module, exports) {
"use strict";
var $af3db2b089ca5d0c$var$__assign = module.exports && module.exports.__assign || function() {
    $af3db2b089ca5d0c$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $af3db2b089ca5d0c$var$__assign.apply(this, arguments);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $af3db2b089ca5d0c$var$BootstrapValidator = /** @class */ function() {
    function BootstrapValidator() {}
    BootstrapValidator.isValid = function(user, values) {
        try {
            var evaluatedKeys = values["evaluated_keys"];
            if (!evaluatedKeys || typeof evaluatedKeys !== "object") return true;
            var evaluatedKeysRecord = this.copyObject(evaluatedKeys);
            var userToCompare = user == null ? null : this.copyObject(user);
            return BootstrapValidator.validate(evaluatedKeysRecord, userToCompare) && BootstrapValidator.validate(userToCompare, evaluatedKeysRecord);
        } catch (error) {
        // This is best-effort. If we fail, return true.
        }
        return true;
    };
    BootstrapValidator.validate = function(one, two) {
        if (one == null) return two == null;
        else if (two == null) return false;
        for(var _i = 0, _a = Object.entries(one); _i < _a.length; _i++){
            var _b = _a[_i], key = _b[0], value = _b[1];
            if (key === "stableID") continue;
            if (typeof value !== typeof two[key]) return false;
            if (typeof value === "string") {
                if (value !== two[key]) return false;
            } else if (typeof value === "object") return this.validate(value, two[key]);
            else // unexpected
            return false;
        }
        return true;
    };
    BootstrapValidator.copyObject = function(obj) {
        if (obj == null) return null;
        var copy = {};
        if (obj === null || obj === void 0 ? void 0 : obj.userID) copy["userID"] = obj === null || obj === void 0 ? void 0 : obj.userID;
        if (obj === null || obj === void 0 ? void 0 : obj.customIDs) {
            var customIDs = $af3db2b089ca5d0c$var$__assign({}, obj.customIDs);
            delete customIDs["stableID"];
            if (Object.keys(customIDs).length !== 0) copy["customIDs"] = customIDs;
        }
        return copy;
    };
    return BootstrapValidator;
}();
module.exports.default = $af3db2b089ca5d0c$var$BootstrapValidator;

});


parcelRegister("eSgoQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.verifySDKKeyUsed = void 0;

var $2FNDf = parcelRequire("2FNDf");

var $c5V7T = parcelRequire("c5V7T");
function $ad42d47f68f12e18$var$verifySDKKeyUsed(json, sdkKey, errorBoundary) {
    var hashedSDKKeyUsed = json === null || json === void 0 ? void 0 : json.hashed_sdk_key_used;
    if (hashedSDKKeyUsed != null && hashedSDKKeyUsed !== (0, $c5V7T.SimpleHash)(sdkKey !== null && sdkKey !== void 0 ? sdkKey : "")) {
        errorBoundary._logError("fetchAndSaveValues", new $2FNDf.StatsigSDKKeyMismatchError("The SDK key provided does not match the one used to generate values."));
        return false;
    }
    return true;
}
module.exports.verifySDKKeyUsed = $ad42d47f68f12e18$var$verifySDKKeyUsed;

});

parcelRegister("8RsHO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.difference = module.exports.now = void 0;
function $67398a50a5b183a7$var$now() {
    if (typeof performance === "undefined" || !performance) return Date.now();
    return performance.now() | 0;
}
module.exports.now = $67398a50a5b183a7$var$now;
function $67398a50a5b183a7$var$difference(time) {
    return $67398a50a5b183a7$var$now() - time;
}
module.exports.difference = $67398a50a5b183a7$var$difference;

});

parcelRegister("5Erfl", function(module, exports) {
"use strict";
var $41d5d2bcdbb5e104$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.saveOverridesToLocalStorage = module.exports.loadOverridesFromLocalStorage = module.exports.makeEmptyOverrides = module.exports.STORAGE_KEY = void 0;

var $41d5d2bcdbb5e104$var$StatsigLocalStorage_1 = $41d5d2bcdbb5e104$var$__importDefault((parcelRequire("16w86")));
module.exports.STORAGE_KEY = "STATSIG_JS_LITE_LOCAL_OVERRIDES";
function $41d5d2bcdbb5e104$var$makeEmptyOverrides() {
    return {
        gates: {},
        configs: {},
        layers: {}
    };
}
module.exports.makeEmptyOverrides = $41d5d2bcdbb5e104$var$makeEmptyOverrides;
function $41d5d2bcdbb5e104$var$loadOverridesFromLocalStorage() {
    var raw = $41d5d2bcdbb5e104$var$StatsigLocalStorage_1.default.getItem(module.exports.STORAGE_KEY);
    if (raw) try {
        return JSON.parse(raw);
    } catch (error) {
    // noop
    }
    return $41d5d2bcdbb5e104$var$makeEmptyOverrides();
}
module.exports.loadOverridesFromLocalStorage = $41d5d2bcdbb5e104$var$loadOverridesFromLocalStorage;
function $41d5d2bcdbb5e104$var$saveOverridesToLocalStorage(overrides) {
    $41d5d2bcdbb5e104$var$StatsigLocalStorage_1.default.setItem(module.exports.STORAGE_KEY, JSON.stringify(overrides));
}
module.exports.saveOverridesToLocalStorage = $41d5d2bcdbb5e104$var$saveOverridesToLocalStorage;

});



parcelRegister("8nOOE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $61a7e3b4be26e5b6$export$2e2bcd8739ae039; });

var $1NEEu = parcelRequire("1NEEu");

var $a6c7b = parcelRequire("a6c7b");

var $bQusk = parcelRequire("bQusk");

var $3OGT6 = parcelRequire("3OGT6");

var $eLcXj = parcelRequire("eLcXj");

var $kvFVg = parcelRequire("kvFVg");

var $bdCfk = parcelRequire("bdCfk");

var $cvDmS = parcelRequire("cvDmS");
function $61a7e3b4be26e5b6$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $61a7e3b4be26e5b6$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $61a7e3b4be26e5b6$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($1NEEu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $61a7e3b4be26e5b6$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $61a7e3b4be26e5b6$var$DEFAULT_REQUEST_TIMEOUT_MS = 5000;
var $61a7e3b4be26e5b6$var$PROD_BASE_URL = "https://api.atlassian.com/flags";
var $61a7e3b4be26e5b6$var$STAGING_BASE_URL = "https://api.stg.atlassian.com/flags";
var $61a7e3b4be26e5b6$export$f058dbf75c3bc647 = "https://api.dev.atlassian.com/flags";
var $61a7e3b4be26e5b6$export$1a401a0da8da3565 = "https://api.stg.atlassian-us-gov-mod.com/flags";
var $61a7e3b4be26e5b6$export$18c93900db9358a4 = "https://api.atlassian-us-gov-mod.com/flags";
var $61a7e3b4be26e5b6$export$450bd8fb2a6d7ace = "/gateway/api/flags";
var $61a7e3b4be26e5b6$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function Fetcher() {
        (0, (/*@__PURE__*/$parcel$interopDefault($bQusk)))(this, Fetcher);
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($3OGT6)))(Fetcher, null, [
        {
            key: "fetchClientSdk",
            value: function() {
                var _fetchClientSdk = (0, (/*@__PURE__*/$parcel$interopDefault($a6c7b)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eLcXj))).mark(function _callee(fetcherOptions) {
                    var targetApp, url;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($eLcXj))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                targetApp = fetcherOptions.targetApp;
                                url = "/api/v2/frontend/clientSdkKey/".concat(targetApp);
                                _context.prev = 2;
                                _context.next = 5;
                                return this.fetchRequest(url, "GET", fetcherOptions);
                            case 5:
                                return _context.abrupt("return", _context.sent);
                            case 8:
                                _context.prev = 8;
                                _context.t0 = _context["catch"](2);
                                if (!(_context.t0 instanceof Error)) {
                                    _context.next = 12;
                                    break;
                                }
                                throw _context.t0;
                            case 12:
                                throw Error("Failed to retrieve client sdk key");
                            case 13:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this, [
                        [
                            2,
                            8
                        ]
                    ]);
                }));
                function fetchClientSdk(_x) {
                    return _fetchClientSdk.apply(this, arguments);
                }
                return fetchClientSdk;
            }()
        },
        {
            key: "fetchExperimentValues",
            value: function() {
                var _fetchExperimentValues = (0, (/*@__PURE__*/$parcel$interopDefault($a6c7b)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eLcXj))).mark(function _callee2(fetcherOptions, identifiers, customAttributes) {
                    var requestBody;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($eLcXj))).wrap(function _callee2$(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                requestBody = {
                                    identifiers: identifiers,
                                    customAttributes: customAttributes,
                                    targetApp: fetcherOptions.targetApp
                                };
                                _context2.prev = 1;
                                _context2.next = 4;
                                return this.fetchRequest("/api/v2/frontend/experimentValues", "POST", fetcherOptions, requestBody);
                            case 4:
                                return _context2.abrupt("return", _context2.sent);
                            case 7:
                                _context2.prev = 7;
                                _context2.t0 = _context2["catch"](1);
                                if (!(_context2.t0 instanceof Error)) {
                                    _context2.next = 11;
                                    break;
                                }
                                throw _context2.t0;
                            case 11:
                                throw Error("Failed to retrieve experiment values");
                            case 12:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this, [
                        [
                            1,
                            7
                        ]
                    ]);
                }));
                function fetchExperimentValues(_x2, _x3, _x4) {
                    return _fetchExperimentValues.apply(this, arguments);
                }
                return fetchExperimentValues;
            }()
        },
        {
            key: "handleResponseError",
            value: function() {
                var _handleResponseError = (0, (/*@__PURE__*/$parcel$interopDefault($a6c7b)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eLcXj))).mark(function _callee3(response) {
                    var body;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($eLcXj))).wrap(function _callee3$(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                if (response.ok) {
                                    _context3.next = 5;
                                    break;
                                }
                                _context3.next = 3;
                                return response.text();
                            case 3:
                                body = _context3.sent;
                                throw new (0, $cvDmS.ResponseError)("Non 2xx response status received, status: ".concat(response.status, ", body: ").concat(JSON.stringify(body)));
                            case 5:
                                if (!(response.status === 204)) {
                                    _context3.next = 7;
                                    break;
                                }
                                throw new (0, $cvDmS.ResponseError)("Unexpected 204 response");
                            case 7:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3);
                }));
                function handleResponseError(_x5) {
                    return _handleResponseError.apply(this, arguments);
                }
                return handleResponseError;
            }()
        },
        {
            key: "extractResponseBody",
            value: function() {
                var _extractResponseBody = (0, (/*@__PURE__*/$parcel$interopDefault($a6c7b)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eLcXj))).mark(function _callee4(response) {
                    var value;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($eLcXj))).wrap(function _callee4$(_context4) {
                        while(true)switch(_context4.prev = _context4.next){
                            case 0:
                                _context4.next = 2;
                                return response.text();
                            case 2:
                                value = _context4.sent;
                                return _context4.abrupt("return", JSON.parse(value));
                            case 4:
                            case "end":
                                return _context4.stop();
                        }
                    }, _callee4);
                }));
                function extractResponseBody(_x6) {
                    return _extractResponseBody.apply(this, arguments);
                }
                return extractResponseBody;
            }()
        },
        {
            key: "getBaseUrl",
            value: function getBaseUrl(serviceEnv) {
                var useGatewayUrl = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
                var perimeter = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : (0, $kvFVg.PerimeterType).COMMERCIAL;
                if (useGatewayUrl) return $61a7e3b4be26e5b6$export$450bd8fb2a6d7ace;
                if (perimeter === (0, $kvFVg.PerimeterType).FEDRAMP_MODERATE) switch(serviceEnv){
                    case (0, $kvFVg.FeatureGateEnvironment).Production:
                        return $61a7e3b4be26e5b6$export$18c93900db9358a4;
                    case (0, $kvFVg.FeatureGateEnvironment).Staging:
                        return $61a7e3b4be26e5b6$export$1a401a0da8da3565;
                    default:
                        throw new Error('Invalid environment "'.concat(serviceEnv, '" for "').concat(perimeter, '" perimeter'));
                }
                else if (perimeter === (0, $kvFVg.PerimeterType).COMMERCIAL) switch(serviceEnv){
                    case (0, $kvFVg.FeatureGateEnvironment).Development:
                        return $61a7e3b4be26e5b6$export$f058dbf75c3bc647;
                    case (0, $kvFVg.FeatureGateEnvironment).Staging:
                        return $61a7e3b4be26e5b6$var$STAGING_BASE_URL;
                    default:
                        return $61a7e3b4be26e5b6$var$PROD_BASE_URL;
                }
                else throw new Error('Invalid perimeter "'.concat(perimeter, '"'));
            }
        },
        {
            key: "fetchRequest",
            value: function() {
                var _fetchRequest = (0, (/*@__PURE__*/$parcel$interopDefault($a6c7b)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eLcXj))).mark(function _callee5(path, method, fetcherOptions, body) {
                    var baseUrl, fetchTimeout, abortSignal, abortController, response;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($eLcXj))).wrap(function _callee5$(_context5) {
                        while(true)switch(_context5.prev = _context5.next){
                            case 0:
                                baseUrl = Fetcher.getBaseUrl(fetcherOptions.environment, fetcherOptions.useGatewayURL, fetcherOptions.perimeter);
                                fetchTimeout = fetcherOptions.fetchTimeoutMs || $61a7e3b4be26e5b6$var$DEFAULT_REQUEST_TIMEOUT_MS;
                                if (AbortSignal.timeout) abortSignal = AbortSignal.timeout(fetchTimeout);
                                else if (AbortController) {
                                    abortController = new AbortController();
                                    abortSignal = abortController.signal;
                                    setTimeout(function() {
                                        return abortController.abort();
                                    }, fetchTimeout);
                                }
                                _context5.next = 5;
                                return fetch("".concat(baseUrl).concat(path), $61a7e3b4be26e5b6$var$_objectSpread({
                                    method: method,
                                    headers: {
                                        "Content-Type": "application/json",
                                        "X-Client-Name": "feature-gate-js-client",
                                        "X-Client-Version": (0, $bdCfk.CLIENT_VERSION),
                                        "X-API-KEY": fetcherOptions.apiKey
                                    },
                                    signal: abortSignal
                                }, body && {
                                    body: JSON.stringify(body)
                                }));
                            case 5:
                                response = _context5.sent;
                                _context5.next = 8;
                                return this.handleResponseError(response);
                            case 8:
                                _context5.next = 10;
                                return this.extractResponseBody(response);
                            case 10:
                                return _context5.abrupt("return", _context5.sent);
                            case 11:
                            case "end":
                                return _context5.stop();
                        }
                    }, _callee5, this);
                }));
                function fetchRequest(_x7, _x8, _x9, _x10) {
                    return _fetchRequest.apply(this, arguments);
                }
                return fetchRequest;
            }()
        }
    ]);
    return Fetcher;
}();

});
parcelRegister("kvFVg", function(module, exports) {

$parcel$export(module.exports, "FeatureGateEnvironment", function () { return $eee738db08514d4c$export$479e7351a733299; });
$parcel$export(module.exports, "PerimeterType", function () { return $eee738db08514d4c$export$c42b7bbc5e7ba555; });
/**
 * The identifiers for the user. Options are restricted to the set that is currently supported.
 */ /**
 * Base client options.
 * @interface BaseClientOptions
 * @property {FeatureGateEnvironment} environment - The environment for the client.
 * @property {string} targetApp - The target app for the client.
 * @property {AnalyticsWebClient} analyticsWebClient - The analytics web client.
 * @property {PerimeterType} perimeter - The perimeter for the client.
 */ /**
 * The options for the client.
 * @interface ClientOptions
 * @extends {BaseClientOptions}
 * @property {string} apiKey - The API key for the client.
 * @property {fetchTimeoutMs} fetchTimeoutMs - The timeout for the fetch request in milliseconds. Defaults to 5000.
 * @property {boolean} useGatewayURL - Whether to use the gateway URL. Defaults to false.
 */ /**
 * The custom attributes for the user.
 */ var $eee738db08514d4c$export$479e7351a733299 = /*#__PURE__*/ function(FeatureGateEnvironment) {
    FeatureGateEnvironment["Development"] = "development";
    FeatureGateEnvironment["Staging"] = "staging";
    FeatureGateEnvironment["Production"] = "production";
    return FeatureGateEnvironment;
}({});
var $eee738db08514d4c$export$c42b7bbc5e7ba555 = /*#__PURE__*/ function(PerimeterType) {
    PerimeterType["COMMERCIAL"] = "commercial";
    PerimeterType["FEDRAMP_MODERATE"] = "fedramp-moderate";
    return PerimeterType;
}({});

});

parcelRegister("bdCfk", function(module, exports) {

$parcel$export(module.exports, "CLIENT_VERSION", function () { return $82ae938629d3399f$export$a59f8d67326bd1cb; });
var $82ae938629d3399f$export$a59f8d67326bd1cb = "4.18.0";

});

parcelRegister("cvDmS", function(module, exports) {

$parcel$export(module.exports, "ResponseError", function () { return $91b6eaecca2611d8$export$286baf652d0b1206; });

var $3OGT6 = parcelRequire("3OGT6");

var $bQusk = parcelRequire("bQusk");

var $54SYg = parcelRequire("54SYg");

var $1tOon = parcelRequire("1tOon");

var $9OJue = parcelRequire("9OJue");

var $73NgV = parcelRequire("73NgV");
function $91b6eaecca2611d8$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $91b6eaecca2611d8$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, (/*@__PURE__*/$parcel$interopDefault($9OJue)))(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, (/*@__PURE__*/$parcel$interopDefault($9OJue)))(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, (/*@__PURE__*/$parcel$interopDefault($1tOon)))(this, result);
    };
}
function $91b6eaecca2611d8$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($91b6eaecca2611d8$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $91b6eaecca2611d8$export$286baf652d0b1206 = /*#__PURE__*/ function(_Error) {
    (0, (/*@__PURE__*/$parcel$interopDefault($54SYg)))(ResponseError, _Error);
    var _super = $91b6eaecca2611d8$var$_createSuper(ResponseError);
    function ResponseError(message) {
        (0, (/*@__PURE__*/$parcel$interopDefault($bQusk)))(this, ResponseError);
        return _super.call(this, message);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($3OGT6)))(ResponseError);
}(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($73NgV)))(Error));

});
parcelRegister("54SYg", function(module, exports) {

var $fJDAw = parcelRequire("fJDAw");
function $3b27f792825096eb$var$_inherits(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && $fJDAw(t, e);
}
module.exports = $3b27f792825096eb$var$_inherits, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("fJDAw", function(module, exports) {
function $b749c455f4762915$var$_setPrototypeOf(t, e) {
    return module.exports = $b749c455f4762915$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $b749c455f4762915$var$_setPrototypeOf(t, e);
}
module.exports = $b749c455f4762915$var$_setPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("1tOon", function(module, exports) {

var $1ooHa = parcelRequire("1ooHa");
var $113f96b1b3712f4d$var$_typeof = $1ooHa.default;

var $kQ8c7 = parcelRequire("kQ8c7");
function $113f96b1b3712f4d$var$_possibleConstructorReturn(t, e) {
    if (e && ("object" == $113f96b1b3712f4d$var$_typeof(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return $kQ8c7(t);
}
module.exports = $113f96b1b3712f4d$var$_possibleConstructorReturn, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("kQ8c7", function(module, exports) {
function $f2bf053fefb7257f$var$_assertThisInitialized(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}
module.exports = $f2bf053fefb7257f$var$_assertThisInitialized, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("9OJue", function(module, exports) {
function $725c1148bfce8895$var$_getPrototypeOf(t) {
    return module.exports = $725c1148bfce8895$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $725c1148bfce8895$var$_getPrototypeOf(t);
}
module.exports = $725c1148bfce8895$var$_getPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("73NgV", function(module, exports) {

var $9OJue = parcelRequire("9OJue");

var $fJDAw = parcelRequire("fJDAw");

var $bi1Mx = parcelRequire("bi1Mx");

var $bQJw4 = parcelRequire("bQJw4");
function $523f089f3a4113ee$var$_wrapNativeSuper(t) {
    var r = "function" == typeof Map ? new Map() : void 0;
    return module.exports = $523f089f3a4113ee$var$_wrapNativeSuper = function _wrapNativeSuper(t) {
        if (null === t || !$bi1Mx(t)) return t;
        if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function");
        if (void 0 !== r) {
            if (r.has(t)) return r.get(t);
            r.set(t, Wrapper);
        }
        function Wrapper() {
            return $bQJw4(t, arguments, $9OJue(this).constructor);
        }
        return Wrapper.prototype = Object.create(t.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: !1,
                writable: !0,
                configurable: !0
            }
        }), $fJDAw(Wrapper, t);
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $523f089f3a4113ee$var$_wrapNativeSuper(t);
}
module.exports = $523f089f3a4113ee$var$_wrapNativeSuper, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("bi1Mx", function(module, exports) {
function $8382c1f918db7824$var$_isNativeFunction(t) {
    try {
        return -1 !== Function.toString.call(t).indexOf("[native code]");
    } catch (n) {
        return "function" == typeof t;
    }
}
module.exports = $8382c1f918db7824$var$_isNativeFunction, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("bQJw4", function(module, exports) {

var $iqNfc = parcelRequire("iqNfc");

var $fJDAw = parcelRequire("fJDAw");
function $8a07dba390250d6a$var$_construct(t, e, r) {
    if ($iqNfc()) return Reflect.construct.apply(null, arguments);
    var o = [
        null
    ];
    o.push.apply(o, e);
    var p = new (t.bind.apply(t, o))();
    return r && $fJDAw(p, r.prototype), p;
}
module.exports = $8a07dba390250d6a$var$_construct, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("iqNfc", function(module, exports) {
function $d6b0da8c94e4e93f$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return (module.exports = $d6b0da8c94e4e93f$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports)();
}
module.exports = $d6b0da8c94e4e93f$var$_isNativeReflectConstruct, module.exports.__esModule = true, module.exports["default"] = module.exports;

});







parcelRegister("h6uNY", function(module, exports) {

var $3RQ7P = parcelRequire("3RQ7P");
var $c73ae4760ade978b$var$_typeof = $3RQ7P.default;
function $c73ae4760ade978b$var$_regeneratorRuntime() {
    "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ 
    module.exports = $c73ae4760ade978b$var$_regeneratorRuntime = function _regeneratorRuntime() {
        return e;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports;
    var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function(t, e, r) {
        t[e] = r.value;
    }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag";
    function define(t, e, r) {
        return Object.defineProperty(t, e, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }), t[e];
    }
    try {
        define({}, "");
    } catch (t) {
        define = function define(t, e, r) {
            return t[e] = r;
        };
    }
    function wrap(t, e, r, n) {
        var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []);
        return o(a, "_invoke", {
            value: makeInvokeMethod(t, r, c)
        }), a;
    }
    function tryCatch(t, e, r) {
        try {
            return {
                type: "normal",
                arg: t.call(e, r)
            };
        } catch (t) {
            return {
                type: "throw",
                arg: t
            };
        }
    }
    e.wrap = wrap;
    var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {};
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    var p = {};
    define(p, a, function() {
        return this;
    });
    var d = Object.getPrototypeOf, v = d && d(d(values([])));
    v && v !== r && n.call(v, a) && (p = v);
    var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
    function defineIteratorMethods(t) {
        [
            "next",
            "throw",
            "return"
        ].forEach(function(e) {
            define(t, e, function(t) {
                return this._invoke(e, t);
            });
        });
    }
    function AsyncIterator(t, e) {
        function invoke(r, o, i, a) {
            var c = tryCatch(t[r], t, o);
            if ("throw" !== c.type) {
                var u = c.arg, h = u.value;
                return h && "object" == $c73ae4760ade978b$var$_typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function(t) {
                    invoke("next", t, i, a);
                }, function(t) {
                    invoke("throw", t, i, a);
                }) : e.resolve(h).then(function(t) {
                    u.value = t, i(u);
                }, function(t) {
                    return invoke("throw", t, i, a);
                });
            }
            a(c.arg);
        }
        var r;
        o(this, "_invoke", {
            value: function value(t, n) {
                function callInvokeWithMethodAndArg() {
                    return new e(function(e, r) {
                        invoke(t, n, e, r);
                    });
                }
                return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
            }
        });
    }
    function makeInvokeMethod(e, r, n) {
        var o = h;
        return function(i, a) {
            if (o === f) throw Error("Generator is already running");
            if (o === s) {
                if ("throw" === i) throw a;
                return {
                    value: t,
                    done: !0
                };
            }
            for(n.method = i, n.arg = a;;){
                var c = n.delegate;
                if (c) {
                    var u = maybeInvokeDelegate(c, n);
                    if (u) {
                        if (u === y) continue;
                        return u;
                    }
                }
                if ("next" === n.method) n.sent = n._sent = n.arg;
                else if ("throw" === n.method) {
                    if (o === h) throw o = s, n.arg;
                    n.dispatchException(n.arg);
                } else "return" === n.method && n.abrupt("return", n.arg);
                o = f;
                var p = tryCatch(e, r, n);
                if ("normal" === p.type) {
                    if (o = n.done ? s : l, p.arg === y) continue;
                    return {
                        value: p.arg,
                        done: n.done
                    };
                }
                "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
            }
        };
    }
    function maybeInvokeDelegate(e, r) {
        var n = r.method, o = e.iterator[n];
        if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
        var i = tryCatch(o, e.iterator, r.arg);
        if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
        var a = i.arg;
        return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
    }
    function pushTryEntry(t) {
        var e = {
            tryLoc: t[0]
        };
        1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
    }
    function resetTryEntry(t) {
        var e = t.completion || {};
        e.type = "normal", delete e.arg, t.completion = e;
    }
    function Context(t) {
        this.tryEntries = [
            {
                tryLoc: "root"
            }
        ], t.forEach(pushTryEntry, this), this.reset(!0);
    }
    function values(e) {
        if (e || "" === e) {
            var r = e[a];
            if (r) return r.call(e);
            if ("function" == typeof e.next) return e;
            if (!isNaN(e.length)) {
                var o = -1, i = function next() {
                    for(; ++o < e.length;)if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
                    return next.value = t, next.done = !0, next;
                };
                return i.next = i;
            }
        }
        throw new TypeError($c73ae4760ade978b$var$_typeof(e) + " is not iterable");
    }
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
        value: GeneratorFunctionPrototype,
        configurable: !0
    }), o(GeneratorFunctionPrototype, "constructor", {
        value: GeneratorFunction,
        configurable: !0
    }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function(t) {
        var e = "function" == typeof t && t.constructor;
        return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
    }, e.mark = function(t) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
    }, e.awrap = function(t) {
        return {
            __await: t
        };
    }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function() {
        return this;
    }), e.AsyncIterator = AsyncIterator, e.async = function(t, r, n, o, i) {
        void 0 === i && (i = Promise);
        var a = new AsyncIterator(wrap(t, r, n, o), i);
        return e.isGeneratorFunction(r) ? a : a.next().then(function(t) {
            return t.done ? t.value : a.next();
        });
    }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function() {
        return this;
    }), define(g, "toString", function() {
        return "[object Generator]";
    }), e.keys = function(t) {
        var e = Object(t), r = [];
        for(var n in e)r.push(n);
        return r.reverse(), function next() {
            for(; r.length;){
                var t = r.pop();
                if (t in e) return next.value = t, next.done = !1, next;
            }
            return next.done = !0, next;
        };
    }, e.values = values, Context.prototype = {
        constructor: Context,
        reset: function reset(e) {
            if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for(var r in this)"t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
        },
        stop: function stop() {
            this.done = !0;
            var t = this.tryEntries[0].completion;
            if ("throw" === t.type) throw t.arg;
            return this.rval;
        },
        dispatchException: function dispatchException(e) {
            if (this.done) throw e;
            var r = this;
            function handle(n, o) {
                return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
            }
            for(var o = this.tryEntries.length - 1; o >= 0; --o){
                var i = this.tryEntries[o], a = i.completion;
                if ("root" === i.tryLoc) return handle("end");
                if (i.tryLoc <= this.prev) {
                    var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc");
                    if (c && u) {
                        if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                        if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
                    } else if (c) {
                        if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                    } else {
                        if (!u) throw Error("try statement without catch or finally");
                        if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
                    }
                }
            }
        },
        abrupt: function abrupt(t, e) {
            for(var r = this.tryEntries.length - 1; r >= 0; --r){
                var o = this.tryEntries[r];
                if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
                    var i = o;
                    break;
                }
            }
            i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
            var a = i ? i.completion : {};
            return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
        },
        complete: function complete(t, e) {
            if ("throw" === t.type) throw t.arg;
            return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
        },
        finish: function finish(t) {
            for(var e = this.tryEntries.length - 1; e >= 0; --e){
                var r = this.tryEntries[e];
                if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
            }
        },
        "catch": function _catch(t) {
            for(var e = this.tryEntries.length - 1; e >= 0; --e){
                var r = this.tryEntries[e];
                if (r.tryLoc === t) {
                    var n = r.completion;
                    if ("throw" === n.type) {
                        var o = n.arg;
                        resetTryEntry(r);
                    }
                    return o;
                }
            }
            throw Error("illegal catch attempt");
        },
        delegateYield: function delegateYield(e, r, n) {
            return this.delegate = {
                iterator: values(e),
                resultName: r,
                nextLoc: n
            }, "next" === this.method && (this.arg = t), y;
        }
    }, e;
}
module.exports = $c73ae4760ade978b$var$_regeneratorRuntime, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("3RQ7P", function(module, exports) {
function $2d0ec15959f9814e$var$_typeof(o) {
    "@babel/helpers - typeof";
    return module.exports = $2d0ec15959f9814e$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $2d0ec15959f9814e$var$_typeof(o);
}
module.exports = $2d0ec15959f9814e$var$_typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("hSHEC", function(module, exports) {

$parcel$export(module.exports, "themeIds", function () { return $d049579b04287509$export$7d43e72a58e3283f; });
$parcel$export(module.exports, "themeStateDefaults", function () { return $d049579b04287509$export$9aedcfa7336a207; });
$parcel$export(module.exports, "default", function () { return $d049579b04287509$export$2e2bcd8739ae039; });

var $18rB9 = parcelRequire("18rB9");
var $d049579b04287509$export$83993de8eb66733 = [
    "light",
    "dark",
    "auto"
];
var $d049579b04287509$export$8ce7e340c74e86c5 = [
    "more",
    "no-preference",
    "auto"
];
var $d049579b04287509$export$7d43e72a58e3283f = [
    "light-increased-contrast",
    "light",
    "light-future",
    "light-brand-refresh",
    "dark",
    "dark-future",
    "dark-increased-contrast",
    "dark-brand-refresh",
    "legacy-light",
    "legacy-dark",
    "spacing",
    "shape",
    "typography-adg3",
    "typography-modernized",
    "typography-refreshed"
];
var $d049579b04287509$export$ba8a43b83ecc69f8 = [];
var $d049579b04287509$export$92ba366331403db2 = [].concat($d049579b04287509$export$7d43e72a58e3283f, $d049579b04287509$export$ba8a43b83ecc69f8);
/**
 * Theme to use a base. This will create the theme as
 * an extension with all token values marked as optional
 * to allow tokens to be overridden as required.
 */ /**
 * Palettes: The set of base tokens a given theme may be populated with.
 * For example: legacy light & dark themes use the "legacyPalette" containing colors from our
 * previous color set.
 */ /**
 * ThemeConfig: the source of truth for all theme meta-data.
 * This object should be used whenever interfacing with themes.
 */ var $d049579b04287509$var$themeConfig = {
    "atlassian-light": {
        id: "light",
        displayName: "Light Theme",
        palette: "defaultPalette",
        attributes: {
            type: "color",
            mode: "light"
        }
    },
    "atlassian-light-future": {
        id: "light-future",
        displayName: "Future Light Theme",
        palette: "defaultPalette",
        attributes: {
            type: "color",
            mode: "light"
        },
        override: "light"
    },
    "atlassian-light-increased-contrast": {
        id: "light-increased-contrast",
        displayName: "Light Theme (increased contrast)",
        palette: "defaultPalette",
        attributes: {
            type: "color",
            mode: "light"
        },
        extends: "light",
        increasesContrastFor: "light"
    },
    "atlassian-dark": {
        id: "dark",
        displayName: "Dark Theme",
        palette: "defaultPalette",
        attributes: {
            type: "color",
            mode: "dark"
        }
    },
    "atlassian-dark-future": {
        id: "dark-future",
        displayName: "Future Dark Theme",
        palette: "defaultPalette",
        attributes: {
            type: "color",
            mode: "dark"
        },
        override: "light"
    },
    "atlassian-dark-increased-contrast": {
        id: "dark-increased-contrast",
        displayName: "Dark Theme (increased contrast)",
        palette: "defaultPalette",
        attributes: {
            type: "color",
            mode: "dark"
        },
        extends: "dark",
        increasesContrastFor: "dark"
    },
    "atlassian-legacy-light": {
        id: "legacy-light",
        displayName: "Light Theme (legacy)",
        palette: "legacyPalette",
        attributes: {
            type: "color",
            mode: "light"
        }
    },
    "atlassian-legacy-dark": {
        id: "legacy-dark",
        displayName: "Dark Theme (legacy)",
        palette: "legacyPalette",
        attributes: {
            type: "color",
            mode: "dark"
        }
    },
    "atlassian-spacing": {
        id: "spacing",
        displayName: "Atlassian Spacing",
        palette: "spacingScale",
        attributes: {
            type: "spacing"
        }
    },
    "atlassian-typography-adg3": {
        id: "typography-adg3",
        displayName: "ADG3 Typography",
        palette: "typographyPalette",
        attributes: {
            type: "typography"
        }
    },
    "atlassian-shape": {
        id: "shape",
        displayName: "Atlassian Shape",
        palette: "shapePalette",
        attributes: {
            type: "shape"
        }
    },
    "atlassian-typography-modernized": {
        id: "typography-modernized",
        displayName: "Atlassian Typography (Modernized)",
        palette: "typographyPalette",
        attributes: {
            type: "typography"
        }
    },
    "atlassian-typography-refreshed": {
        id: "typography-refreshed",
        displayName: "Atlassian Typography (Refreshed)",
        palette: "typographyPalette",
        attributes: {
            type: "typography"
        }
    },
    "atlassian-light-brand-refresh": {
        id: "light-brand-refresh",
        displayName: "Light theme (Brand refresh)",
        palette: "brandRefreshPalette",
        attributes: {
            type: "color",
            mode: "light"
        }
    },
    "atlassian-dark-brand-refresh": {
        id: "dark-brand-refresh",
        displayName: "Dark theme (Brand refresh)",
        palette: "brandRefreshPalette",
        attributes: {
            type: "color",
            mode: "dark"
        }
    }
};
var $d049579b04287509$export$9aedcfa7336a207 = {
    colorMode: "auto",
    contrastMode: "auto",
    dark: "dark",
    light: "light",
    shape: undefined,
    spacing: "spacing",
    typography: function typography() {
        if ((0, $18rB9.fg)("platform-default-typography-modernized")) return "typography-modernized";
        return undefined;
    },
    UNSAFE_themeOptions: undefined
};
var /**
 * Represents theme state once mounted to the page
 * (the page doesn't have an "auto" color mode, it's either light or dark)
 */ $d049579b04287509$export$2e2bcd8739ae039 = $d049579b04287509$var$themeConfig;

});

parcelRegister("bCORa", function(module, exports) {

$parcel$export(module.exports, "isValidBrandHex", function () { return $876ab15efb41a2aa$export$53031ac1ecb71f44; });
$parcel$export(module.exports, "rgbToHex", function () { return $876ab15efb41a2aa$export$34d09c4a771c46ef; });
$parcel$export(module.exports, "hexToRgbA", function () { return $876ab15efb41a2aa$export$b36dbdb4f463f05c; });
$parcel$export(module.exports, "hexToRgb", function () { return $876ab15efb41a2aa$export$5a544e13ad4e1fa5; });
$parcel$export(module.exports, "hexToHSL", function () { return $876ab15efb41a2aa$export$47ea145a83f50dc0; });
$parcel$export(module.exports, "HSLToRGB", function () { return $876ab15efb41a2aa$export$1ff93e992dd58bec; });
$parcel$export(module.exports, "relativeLuminanceW3C", function () { return $876ab15efb41a2aa$export$e770b01b744f3745; });
$parcel$export(module.exports, "getContrastRatio", function () { return $876ab15efb41a2aa$export$d061e26956a60b0a; });
$parcel$export(module.exports, "deltaE", function () { return $876ab15efb41a2aa$export$e8ddad763b4bebf9; });
// valid hex color with 6 digits
var $876ab15efb41a2aa$export$53031ac1ecb71f44 = function isValidBrandHex(hex) {
    return /^#[0-9A-F]{6}$/i.test(hex);
};
// valid hex color with 4, 6 or 8 digits
var $876ab15efb41a2aa$var$isValidHex = function isValidHex(hex) {
    return /^#([A-Fa-f0-9]{3,4}){1,2}$/.test(hex);
};
function $876ab15efb41a2aa$export$34d09c4a771c46ef(r, g, b) {
    return "#" + (16777216 + (r << 16) + (g << 8) + b).toString(16).slice(1);
}
function $876ab15efb41a2aa$export$1212645cf40ebf71(hex) {
    if (hex.length === 9) {
        var int = parseInt(hex.slice(7, 9), 16) / 255;
        return Number(parseFloat(int.toString()).toFixed(2));
    }
    return 1;
}
function $876ab15efb41a2aa$export$b36dbdb4f463f05c(hex) {
    if (!$876ab15efb41a2aa$var$isValidHex(hex)) throw new Error("Invalid HEX");
    var c;
    c = hex.substring(1).split("");
    if (c.length === 3) c = [
        c[0],
        c[0],
        c[1],
        c[1],
        c[2],
        c[2]
    ];
    c = "0x" + c.join("");
    return [
        c >> 16 & 255,
        c >> 8 & 255,
        c & 255,
        $876ab15efb41a2aa$export$1212645cf40ebf71(hex)
    ];
}
function $876ab15efb41a2aa$export$5a544e13ad4e1fa5(hex) {
    if (!$876ab15efb41a2aa$var$isValidHex(hex)) throw new Error("Invalid HEX");
    var c;
    c = hex.substring(1).split("");
    if (c.length === 3) c = [
        c[0],
        c[0],
        c[1],
        c[1],
        c[2],
        c[2]
    ];
    c = "0x" + c.join("");
    return [
        c >> 16 & 255,
        c >> 8 & 255,
        c & 255
    ];
}
function $876ab15efb41a2aa$export$47ea145a83f50dc0(hex) {
    if (!$876ab15efb41a2aa$var$isValidHex(hex)) throw new Error("Invalid HEX");
    var r = 0, g = 0, b = 0;
    if (hex.length === 4) {
        r = "0x" + hex[1] + hex[1];
        g = "0x" + hex[2] + hex[2];
        b = "0x" + hex[3] + hex[3];
    } else if (hex.length === 7) {
        r = "0x" + hex[1] + hex[2];
        g = "0x" + hex[3] + hex[4];
        b = "0x" + hex[5] + hex[6];
    }
    // Then to HSL
    r /= 255;
    g /= 255;
    b /= 255;
    var cmin = Math.min(r, g, b), cmax = Math.max(r, g, b), delta = cmax - cmin, h = 0, s = 0, l = 0;
    if (delta === 0) h = 0;
    else if (cmax === r) h = (g - b) / delta % 6;
    else if (cmax === g) h = (b - r) / delta + 2;
    else h = (r - g) / delta + 4;
    h = Math.round(h * 60);
    if (h < 0) h += 360;
    l = (cmax + cmin) / 2;
    s = delta === 0 ? 0 : delta / (1 - Math.abs(2 * l - 1));
    s = +(s * 100).toFixed(1);
    l = +(l * 100).toFixed(1);
    return [
        h,
        s,
        l
    ];
}
function $876ab15efb41a2aa$export$1ff93e992dd58bec(h, s, l) {
    s /= 100;
    l /= 100;
    var k = function k(n) {
        return (n + h / 30) % 12;
    };
    var a = s * Math.min(l, 1 - l);
    var f = function f(n) {
        return l - a * Math.max(-1, Math.min(k(n) - 3, Math.min(9 - k(n), 1)));
    };
    return [
        255 * f(0),
        255 * f(8),
        255 * f(4)
    ];
}
function $876ab15efb41a2aa$export$e770b01b744f3745(r, g, b) {
    var RsRGB = r / 255;
    var GsRGB = g / 255;
    var BsRGB = b / 255;
    var R = RsRGB <= 0.03928 ? RsRGB / 12.92 : Math.pow((RsRGB + 0.055) / 1.055, 2.4);
    var G = GsRGB <= 0.03928 ? GsRGB / 12.92 : Math.pow((GsRGB + 0.055) / 1.055, 2.4);
    var B = BsRGB <= 0.03928 ? BsRGB / 12.92 : Math.pow((BsRGB + 0.055) / 1.055, 2.4);
    // For the sRGB colorspace, the relative luminance of a color is defined as:
    var L = 0.2126 * R + 0.7152 * G + 0.0722 * B;
    return L;
}
function $876ab15efb41a2aa$export$d061e26956a60b0a(foreground, background) {
    if (!$876ab15efb41a2aa$var$isValidHex(foreground) || !$876ab15efb41a2aa$var$isValidHex(background)) throw new Error("Invalid HEX");
    var foregroundRgb = $876ab15efb41a2aa$export$5a544e13ad4e1fa5(foreground);
    var backgroundRgb = $876ab15efb41a2aa$export$5a544e13ad4e1fa5(background);
    var foregroundLuminance = $876ab15efb41a2aa$export$e770b01b744f3745(foregroundRgb[0], foregroundRgb[1], foregroundRgb[2]);
    var backgroundLuminance = $876ab15efb41a2aa$export$e770b01b744f3745(backgroundRgb[0], backgroundRgb[1], backgroundRgb[2]);
    // calculate the color contrast ratio
    var brightest = Math.max(foregroundLuminance, backgroundLuminance);
    var darkest = Math.min(foregroundLuminance, backgroundLuminance);
    return (brightest + 0.05) / (darkest + 0.05);
}
function $876ab15efb41a2aa$export$e8ddad763b4bebf9(rgbA, rgbB) {
    var labA = $876ab15efb41a2aa$var$rgbToLab(rgbA);
    var labB = $876ab15efb41a2aa$var$rgbToLab(rgbB);
    var deltaL = labA[0] - labB[0];
    var deltaA = labA[1] - labB[1];
    var deltaB = labA[2] - labB[2];
    var c1 = Math.sqrt(labA[1] * labA[1] + labA[2] * labA[2]);
    var c2 = Math.sqrt(labB[1] * labB[1] + labB[2] * labB[2]);
    var deltaC = c1 - c2;
    var deltaH = deltaA * deltaA + deltaB * deltaB - deltaC * deltaC;
    deltaH = deltaH < 0 ? 0 : Math.sqrt(deltaH);
    var sc = 1.0 + 0.045 * c1;
    var sh = 1.0 + 0.015 * c1;
    var deltaLKlsl = deltaL / 1.0;
    var deltaCkcsc = deltaC / sc;
    var deltaHkhsh = deltaH / sh;
    var i = deltaLKlsl * deltaLKlsl + deltaCkcsc * deltaCkcsc + deltaHkhsh * deltaHkhsh;
    return i < 0 ? 0 : Math.sqrt(i);
}
function $876ab15efb41a2aa$var$rgbToLab(rgb) {
    var r = rgb[0] / 255, g = rgb[1] / 255, b = rgb[2] / 255, x, y, z;
    r = r > 0.04045 ? Math.pow((r + 0.055) / 1.055, 2.4) : r / 12.92;
    g = g > 0.04045 ? Math.pow((g + 0.055) / 1.055, 2.4) : g / 12.92;
    b = b > 0.04045 ? Math.pow((b + 0.055) / 1.055, 2.4) : b / 12.92;
    x = (r * 0.4124 + g * 0.3576 + b * 0.1805) / 0.95047;
    y = (r * 0.2126 + g * 0.7152 + b * 0.0722) / 1.0;
    z = (r * 0.0193 + g * 0.1192 + b * 0.9505) / 1.08883;
    x = x > 0.008856 ? Math.pow(x, 1 / 3) : 7.787 * x + 16 / 116;
    y = y > 0.008856 ? Math.pow(y, 1 / 3) : 7.787 * y + 16 / 116;
    z = z > 0.008856 ? Math.pow(z, 1 / 3) : 7.787 * z + 16 / 116;
    return [
        116 * y - 16,
        500 * (x - y),
        200 * (y - z)
    ];
}

});

parcelRegister("64Sai", function(module, exports) {

var $dWztq = parcelRequire("dWztq");

var $9MrPZ = parcelRequire("9MrPZ");

var $5jcGl = parcelRequire("5jcGl");

var $eTNhF = parcelRequire("eTNhF");
function $46cd21d6b555b8a5$var$_slicedToArray(r, e) {
    return $dWztq(r) || $9MrPZ(r, e) || $5jcGl(r, e) || $eTNhF();
}
module.exports = $46cd21d6b555b8a5$var$_slicedToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("dWztq", function(module, exports) {
function $a26c3575a68f0611$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
module.exports = $a26c3575a68f0611$var$_arrayWithHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("9MrPZ", function(module, exports) {
function $71ee30af94707b7b$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
module.exports = $71ee30af94707b7b$var$_iterableToArrayLimit, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("5jcGl", function(module, exports) {

var $iycwI = parcelRequire("iycwI");
function $3dd8907c5c6ec7b9$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $iycwI(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $iycwI(r, a) : void 0;
    }
}
module.exports = $3dd8907c5c6ec7b9$var$_unsupportedIterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("iycwI", function(module, exports) {
function $d8151e83120ddecd$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
module.exports = $d8151e83120ddecd$var$_arrayLikeToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("eTNhF", function(module, exports) {
function $ad8c6e7d794d715d$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
module.exports = $ad8c6e7d794d715d$var$_nonIterableRest, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("b0tKs", function(module, exports) {

var $55nAY = parcelRequire("55nAY");
function $8036c52bb5a7d077$var$_defineProperty(e, r, t) {
    return (r = $55nAY(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
module.exports = $8036c52bb5a7d077$var$_defineProperty, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("55nAY", function(module, exports) {

var $3RQ7P = parcelRequire("3RQ7P");
var $3b3fb8f1b74963b2$var$_typeof = $3RQ7P.default;

var $k2vFs = parcelRequire("k2vFs");
function $3b3fb8f1b74963b2$var$toPropertyKey(t) {
    var i = $k2vFs(t, "string");
    return "symbol" == $3b3fb8f1b74963b2$var$_typeof(i) ? i : i + "";
}
module.exports = $3b3fb8f1b74963b2$var$toPropertyKey, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("k2vFs", function(module, exports) {

var $3RQ7P = parcelRequire("3RQ7P");
var $e96c8f15cda90e1d$var$_typeof = $3RQ7P.default;
function $e96c8f15cda90e1d$var$toPrimitive(t, r) {
    if ("object" != $e96c8f15cda90e1d$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $e96c8f15cda90e1d$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
module.exports = $e96c8f15cda90e1d$var$toPrimitive, module.exports.__esModule = true, module.exports["default"] = module.exports;

});



parcelRegister("dBfsM", function(module, exports) {

$parcel$export(module.exports, "hash", function () { return $9e6ab9c1b4af4066$export$d6af199866bfb566; });
var $9e6ab9c1b4af4066$export$d6af199866bfb566 = function hash(str) {
    var hash = 0;
    for(var i = 0; i < str.length; i++){
        var char = str.charCodeAt(i);
        hash = (hash << 5) - hash + char;
        hash &= hash; // Convert to 32bit integer
    }
    return new Uint32Array([
        hash
    ])[0].toString(36);
};

});

parcelRegister("kreZW", function(module, exports) {
function $ee11f6968c4357ee$var$_classCallCheck(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
module.exports = $ee11f6968c4357ee$var$_classCallCheck, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("9kHty", function(module, exports) {

var $55nAY = parcelRequire("55nAY");
function $6cb7b4b053faf191$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, $55nAY(o.key), o);
    }
}
function $6cb7b4b053faf191$var$_createClass(e, r, t) {
    return r && $6cb7b4b053faf191$var$_defineProperties(e.prototype, r), t && $6cb7b4b053faf191$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}
module.exports = $6cb7b4b053faf191$var$_createClass, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("jKM4s", function(module, exports) {

var $6aCUT = parcelRequire("6aCUT");
module.exports = $6aCUT("eLVUz").then(()=>parcelRequire("9rCXE"));

});

parcelRegister("66m9D", function(module, exports) {

var $6aCUT = parcelRequire("6aCUT");
module.exports = $6aCUT("1z8DM").then(()=>parcelRequire("bRPlF"));

});

parcelRegister("lzHUs", function(module, exports) {

var $6aCUT = parcelRequire("6aCUT");
module.exports = $6aCUT("9HbDi").then(()=>parcelRequire("5ckE0"));

});

parcelRegister("afCjQ", function(module, exports) {

var $6aCUT = parcelRequire("6aCUT");
module.exports = $6aCUT("ip1Wa").then(()=>parcelRequire("6aWfy"));

});

parcelRegister("ezHh3", function(module, exports) {

var $6aCUT = parcelRequire("6aCUT");
module.exports = $6aCUT("gl1SR").then(()=>parcelRequire("7lHC5"));

});

parcelRegister("aFtYc", function(module, exports) {

var $6aCUT = parcelRequire("6aCUT");
module.exports = $6aCUT("efwKr").then(()=>parcelRequire("2Vrdq"));

});

parcelRegister("2pYof", function(module, exports) {

var $6aCUT = parcelRequire("6aCUT");
module.exports = $6aCUT("3R7Ic").then(()=>parcelRequire("f7Ltr"));

});

parcelRegister("70xpV", function(module, exports) {

var $6aCUT = parcelRequire("6aCUT");
module.exports = $6aCUT("9IMP7").then(()=>parcelRequire("k8hzx"));

});

parcelRegister("lgJq4", function(module, exports) {

var $6aCUT = parcelRequire("6aCUT");
module.exports = $6aCUT("hKemU").then(()=>parcelRequire("2aEJc"));

});

parcelRegister("iGNVw", function(module, exports) {

var $6aCUT = parcelRequire("6aCUT");
module.exports = $6aCUT("jY2TF").then(()=>parcelRequire("2XbNr"));

});

parcelRegister("8ocrC", function(module, exports) {

var $6aCUT = parcelRequire("6aCUT");
module.exports = $6aCUT("lP1gD").then(()=>parcelRequire("3ucuW"));

});

parcelRegister("a7Jto", function(module, exports) {

var $6aCUT = parcelRequire("6aCUT");
module.exports = $6aCUT("eAdtx").then(()=>parcelRequire("5gPYk"));

});

parcelRegister("eXBd8", function(module, exports) {

var $6aCUT = parcelRequire("6aCUT");
module.exports = $6aCUT("bLDrj").then(()=>parcelRequire("4S9uX"));

});

parcelRegister("6Bdbd", function(module, exports) {

var $6aCUT = parcelRequire("6aCUT");
module.exports = $6aCUT("6jhBU").then(()=>parcelRequire("6BYzL"));

});

parcelRegister("8VokN", function(module, exports) {

var $6aCUT = parcelRequire("6aCUT");
module.exports = $6aCUT("9ApWa").then(()=>parcelRequire("aQDSo"));

});

parcelRegister("84EaV", function(module, exports) {

$parcel$export(module.exports, "findMissingCustomStyleElements", function () { return $01845a43c312d07d$export$bd1ac9300b0e885a; });
$parcel$export(module.exports, "limitSizeOfCustomStyleElements", function () { return $01845a43c312d07d$export$e7ae172320e03461; });
$parcel$export(module.exports, "reduceTokenMap", function () { return $01845a43c312d07d$export$e673f367da2ff23e; });

var $64Sai = parcelRequire("64Sai");

var $cgqdi = parcelRequire("cgqdi");

var $8iKWE = parcelRequire("8iKWE");

var $da8nl = parcelRequire("da8nl");

var $dBfsM = parcelRequire("dBfsM");
function $01845a43c312d07d$export$bd1ac9300b0e885a(UNSAFE_themeOptions, mode) {
    var optionString = JSON.stringify(UNSAFE_themeOptions);
    var uniqueId = (0, $dBfsM.hash)(optionString);
    var attrOfMissingCustomStyles = [];
    (mode === "auto" ? [
        "light",
        "dark"
    ] : [
        mode
    ]).forEach(function(themeId) {
        var element = document.head.querySelector("style[".concat((0, $da8nl.CUSTOM_THEME_ATTRIBUTE), '="').concat(uniqueId, '"][').concat((0, $da8nl.THEME_DATA_ATTRIBUTE), '="').concat(themeId, '"]'));
        if (element) // Append the existing custom styles to take precedence over others
        document.head.appendChild(element);
        else attrOfMissingCustomStyles.push(themeId);
    });
    return attrOfMissingCustomStyles;
}
function $01845a43c312d07d$export$e7ae172320e03461(sizeThreshold) {
    var styleTags = (0, (/*@__PURE__*/$parcel$interopDefault($cgqdi)))(Array.from(document.head.querySelectorAll("style[".concat((0, $da8nl.CUSTOM_THEME_ATTRIBUTE), "][").concat((0, $da8nl.THEME_DATA_ATTRIBUTE), "]"))));
    if (styleTags.length < sizeThreshold) return;
    styleTags.slice(0, styleTags.length - (sizeThreshold - 1)).forEach(function(element) {
        return element.remove();
    });
}
function $01845a43c312d07d$export$e673f367da2ff23e(tokenMap, themeRamp) {
    return Object.entries(tokenMap).reduce(function(acc, _ref) {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($64Sai)))(_ref, 2), key = _ref2[0], value = _ref2[1];
        var cssVar = (0, $8iKWE.default)[key];
        return cssVar ? "".concat(acc, "\n  ").concat(cssVar, ": ").concat(typeof value === "string" ? value : themeRamp[value], ";") : acc;
    }, "");
}

});
parcelRegister("cgqdi", function(module, exports) {

var $h4EPX = parcelRequire("h4EPX");

var $laXNR = parcelRequire("laXNR");

var $5jcGl = parcelRequire("5jcGl");

var $4vAiV = parcelRequire("4vAiV");
function $8edb501662d64f0b$var$_toConsumableArray(r) {
    return $h4EPX(r) || $laXNR(r) || $5jcGl(r) || $4vAiV();
}
module.exports = $8edb501662d64f0b$var$_toConsumableArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("h4EPX", function(module, exports) {

var $iycwI = parcelRequire("iycwI");
function $c6e27cc2576f9b1e$var$_arrayWithoutHoles(r) {
    if (Array.isArray(r)) return $iycwI(r);
}
module.exports = $c6e27cc2576f9b1e$var$_arrayWithoutHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("laXNR", function(module, exports) {
function $f6a8ebd40beb3505$var$_iterableToArray(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
module.exports = $f6a8ebd40beb3505$var$_iterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("4vAiV", function(module, exports) {
function $348637f5c942a4f3$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
module.exports = $348637f5c942a4f3$var$_nonIterableSpread, module.exports.__esModule = true, module.exports["default"] = module.exports;

});



parcelRegister("eckKF", function(module, exports) {

var $6aCUT = parcelRequire("6aCUT");
module.exports = $6aCUT("iM9sC").then(()=>parcelRequire("ixC6r"));

});

parcelRegister("fYdPZ", function(module, exports) {
$parcel$export(module.exports, "DeviceContextConsumer", function () { return (parcelRequire("cZlBJ")).DeviceContextConsumer; });
$parcel$export(module.exports, "DeviceContextProvider", function () { return (parcelRequire("cZlBJ")).DeviceContextProvider; });
$parcel$export(module.exports, "useDeviceContext", function () { return (parcelRequire("cZlBJ")).useDeviceContext; });
parcelRequire("cZlBJ");

});
parcelRegister("cZlBJ", function(module, exports) {

$parcel$export(module.exports, "useDeviceContext", function () { return $36944969527ee69e$export$614b08d9820abf14; });
$parcel$export(module.exports, "DeviceContextConsumer", function () { return $36944969527ee69e$export$69f7fdb0942f94c1; });
$parcel$export(module.exports, "DeviceContextProvider", function () { return $36944969527ee69e$export$53fe53eec7086f9d; });

var $bibO8 = parcelRequire("bibO8");

var $dAx5m = parcelRequire("dAx5m");

var $4hCyL = parcelRequire("4hCyL");
const $36944969527ee69e$export$65939b2133dcf615 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createContext({
    isMobile: null
});
const $36944969527ee69e$export$614b08d9820abf14 = ()=>(0, $dAx5m.useContext)($36944969527ee69e$export$65939b2133dcf615);
const $36944969527ee69e$export$69f7fdb0942f94c1 = ({ children: children })=>children($36944969527ee69e$export$614b08d9820abf14());
const $36944969527ee69e$export$53fe53eec7086f9d = ({ children: children, mobileWidthThreshold: mobileWidthThreshold = 980 })=>/*#__PURE__*/ (0, $bibO8.jsx)((0, $4hCyL.default), {
        children: (width)=>/*#__PURE__*/ (0, $bibO8.jsx)($36944969527ee69e$export$65939b2133dcf615.Provider, {
                value: {
                    isMobile: width ? width < mobileWidthThreshold : null
                },
                children: children
            })
    });

});
parcelRegister("4hCyL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $31e6a91edf6421a5$export$2e2bcd8739ae039; });

var $jNkpH = parcelRequire("jNkpH");

var $3l8cq = parcelRequire("3l8cq");

var $2tfQO = parcelRequire("2tfQO");

var $afFpd = parcelRequire("afFpd");

var $i9lwu = parcelRequire("i9lwu");

var $cvspi = parcelRequire("cvspi");

var $gaX01 = parcelRequire("gaX01");

var $6X6yi = parcelRequire("6X6yi");

var $bpFdu = parcelRequire("bpFdu");

var $dAx5m = parcelRequire("dAx5m");

var $dehtN = parcelRequire("dehtN");
var $31e6a91edf6421a5$var$_excluded = [
    "containerStyle",
    "onResize",
    "children"
];
function $31e6a91edf6421a5$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $31e6a91edf6421a5$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $31e6a91edf6421a5$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($bpFdu)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $31e6a91edf6421a5$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $31e6a91edf6421a5$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $31e6a91edf6421a5$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, (/*@__PURE__*/$parcel$interopDefault($6X6yi)))(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, (/*@__PURE__*/$parcel$interopDefault($6X6yi)))(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, (/*@__PURE__*/$parcel$interopDefault($gaX01)))(this, result);
    };
}
function $31e6a91edf6421a5$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var $31e6a91edf6421a5$var$containerDivStyle = {
    width: "100%",
    position: "relative"
};
// Not using styled-components here for performance
// and framework-agnostic reasons.
var $31e6a91edf6421a5$var$sizerStyle = {
    display: "block",
    position: "absolute",
    top: 0,
    left: 0,
    height: 0,
    width: "100%",
    opacity: 0,
    overflow: "hidden",
    pointerEvents: "none",
    zIndex: -1
};
// add a definition for a data field to the resize object
// since HTMLElements do not have this.
/**
 * @deprecated use WidthObserver instead
 *
 * This component uses iframes for rendering and is currently
 * not performant. It will be DEPRECATED in the future.
 * It is recommended that you instead use WidthObserver from @atlaskit/width-detector
 */ var $31e6a91edf6421a5$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_React$Component) {
    (0, (/*@__PURE__*/$parcel$interopDefault($cvspi)))(WidthDetector, _React$Component);
    var _super = $31e6a91edf6421a5$var$_createSuper(WidthDetector);
    function WidthDetector(props) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($2tfQO)))(this, WidthDetector);
        _this = _super.call(this, props);
        // eslint-disable-next-line no-console
        (0, (/*@__PURE__*/$parcel$interopDefault($bpFdu)))((0, (/*@__PURE__*/$parcel$interopDefault($i9lwu)))(_this), "state", {});
        (0, (/*@__PURE__*/$parcel$interopDefault($bpFdu)))((0, (/*@__PURE__*/$parcel$interopDefault($i9lwu)))(_this), "handleResize", (0, $dehtN.default)(function() {
            var _assertThisInitialize = (0, (/*@__PURE__*/$parcel$interopDefault($i9lwu)))(_this), container = _assertThisInitialize.container;
            if (!container) return;
            var width = container.offsetWidth;
            _this.setState({
                width: width
            });
            if (_this.props.onResize) _this.props.onResize(width);
        }));
        (0, (/*@__PURE__*/$parcel$interopDefault($bpFdu)))((0, (/*@__PURE__*/$parcel$interopDefault($i9lwu)))(_this), "handleContainerRef", function(ref) {
            if (!ref) return;
            _this.container = ref;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($bpFdu)))((0, (/*@__PURE__*/$parcel$interopDefault($i9lwu)))(_this), "handleObjectRef", function(ref) {
            if (!ref) return;
            _this.resizeObject = ref;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($bpFdu)))((0, (/*@__PURE__*/$parcel$interopDefault($i9lwu)))(_this), "handleObjectLoad", function() {
            if (!_this.resizeObject) return;
            _this.resizeObjectDocument = _this.resizeObject.contentDocument.defaultView;
            _this.resizeObjectDocument.addEventListener("resize", _this.handleResize);
            _this.handleResize();
        });
        console.warn("WidthDetector will be deprecated, please use WidthObserver from @atlaskit/width-detector instead.");
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($afFpd)))(WidthDetector, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                if (this.resizeObject) this.resizeObject.data = "about:blank";
                // Calculate width first time, after object has loaded.
                // Prevents it from getting in a weird state where width is always 0.
                this.handleResize();
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.handleResize.cancel();
                if (this.resizeObjectDocument) this.resizeObjectDocument.removeEventListener("resize", this.handleResize);
            }
        },
        {
            key: "render",
            value: function render() {
                // @TODO: Add alternative method using IntersectionObserver or ResizeObserver
                var sizerEl = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement("object", {
                    type: "text/html",
                    style: $31e6a91edf6421a5$var$sizerStyle,
                    ref: this.handleObjectRef,
                    onLoad: this.handleObjectLoad,
                    "aria-hidden": true,
                    tabIndex: -1
                }));
                // pluck non-DOM props off the props so we can safely spread remaining items
                var _this$props = this.props, containerStyle = _this$props.containerStyle, onResize = _this$props.onResize, children = _this$props.children, props = (0, (/*@__PURE__*/$parcel$interopDefault($3l8cq)))(_this$props, $31e6a91edf6421a5$var$_excluded);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($jNkpH)))({}, props, {
                    style: $31e6a91edf6421a5$var$_objectSpread($31e6a91edf6421a5$var$_objectSpread({}, $31e6a91edf6421a5$var$containerDivStyle), containerStyle),
                    ref: this.handleContainerRef
                }), children(this.state.width), sizerEl);
            }
        }
    ]);
    return WidthDetector;
}((0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).Component);
(0, (/*@__PURE__*/$parcel$interopDefault($bpFdu)))($31e6a91edf6421a5$export$2e2bcd8739ae039, "defaultProps", {
    containerStyle: {}
});

});
parcelRegister("jNkpH", function(module, exports) {
function $e6926da557275274$var$_extends() {
    return module.exports = $e6926da557275274$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $e6926da557275274$var$_extends.apply(null, arguments);
}
module.exports = $e6926da557275274$var$_extends, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("3l8cq", function(module, exports) {

var $3RKu9 = parcelRequire("3RKu9");
function $26e9b17a92371ef7$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $3RKu9(e, t);
    if (Object.getOwnPropertySymbols) {
        var s = Object.getOwnPropertySymbols(e);
        for(r = 0; r < s.length; r++)o = s[r], t.includes(o) || ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
module.exports = $26e9b17a92371ef7$var$_objectWithoutProperties, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("3RKu9", function(module, exports) {
function $2d0a615aed6c7743$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.includes(n)) continue;
        t[n] = r[n];
    }
    return t;
}
module.exports = $2d0a615aed6c7743$var$_objectWithoutPropertiesLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("2tfQO", function(module, exports) {
function $1cca95d8664b4d9f$var$_classCallCheck(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
module.exports = $1cca95d8664b4d9f$var$_classCallCheck, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("afFpd", function(module, exports) {

var $j1lMv = parcelRequire("j1lMv");
function $776b6c6cc594dea4$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, $j1lMv(o.key), o);
    }
}
function $776b6c6cc594dea4$var$_createClass(e, r, t) {
    return r && $776b6c6cc594dea4$var$_defineProperties(e.prototype, r), t && $776b6c6cc594dea4$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}
module.exports = $776b6c6cc594dea4$var$_createClass, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("j1lMv", function(module, exports) {

var $eu1Gm = parcelRequire("eu1Gm");
var $dd8f01a9e8c80595$var$_typeof = $eu1Gm.default;

var $6JiU3 = parcelRequire("6JiU3");
function $dd8f01a9e8c80595$var$toPropertyKey(t) {
    var i = $6JiU3(t, "string");
    return "symbol" == $dd8f01a9e8c80595$var$_typeof(i) ? i : i + "";
}
module.exports = $dd8f01a9e8c80595$var$toPropertyKey, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("eu1Gm", function(module, exports) {
function $a8b52c19086e2171$var$_typeof(o) {
    "@babel/helpers - typeof";
    return module.exports = $a8b52c19086e2171$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $a8b52c19086e2171$var$_typeof(o);
}
module.exports = $a8b52c19086e2171$var$_typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("6JiU3", function(module, exports) {

var $eu1Gm = parcelRequire("eu1Gm");
var $4e659bd1a47f55a6$var$_typeof = $eu1Gm.default;
function $4e659bd1a47f55a6$var$toPrimitive(t, r) {
    if ("object" != $4e659bd1a47f55a6$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $4e659bd1a47f55a6$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
module.exports = $4e659bd1a47f55a6$var$toPrimitive, module.exports.__esModule = true, module.exports["default"] = module.exports;

});



parcelRegister("i9lwu", function(module, exports) {
function $d369c3481e362691$var$_assertThisInitialized(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}
module.exports = $d369c3481e362691$var$_assertThisInitialized, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("cvspi", function(module, exports) {

var $ehKXC = parcelRequire("ehKXC");
function $91ae6a53c06b4c33$var$_inherits(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && $ehKXC(t, e);
}
module.exports = $91ae6a53c06b4c33$var$_inherits, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("ehKXC", function(module, exports) {
function $a66714a3015cca28$var$_setPrototypeOf(t, e) {
    return module.exports = $a66714a3015cca28$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $a66714a3015cca28$var$_setPrototypeOf(t, e);
}
module.exports = $a66714a3015cca28$var$_setPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("gaX01", function(module, exports) {

var $eu1Gm = parcelRequire("eu1Gm");
var $bc6b589428cf8b5d$var$_typeof = $eu1Gm.default;

var $i9lwu = parcelRequire("i9lwu");
function $bc6b589428cf8b5d$var$_possibleConstructorReturn(t, e) {
    if (e && ("object" == $bc6b589428cf8b5d$var$_typeof(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return $i9lwu(t);
}
module.exports = $bc6b589428cf8b5d$var$_possibleConstructorReturn, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("6X6yi", function(module, exports) {
function $50fd55e24ee89e5c$var$_getPrototypeOf(t) {
    return module.exports = $50fd55e24ee89e5c$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $50fd55e24ee89e5c$var$_getPrototypeOf(t);
}
module.exports = $50fd55e24ee89e5c$var$_getPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("bpFdu", function(module, exports) {

var $j1lMv = parcelRequire("j1lMv");
function $84f2004223557a17$var$_defineProperty(e, r, t) {
    return (r = $j1lMv(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
module.exports = $84f2004223557a17$var$_defineProperty, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("dehtN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9a1a2445ae22439e$export$2e2bcd8739ae039; });
var $9a1a2445ae22439e$var$rafSchd = function rafSchd(fn) {
    var lastArgs = [];
    var frameId = null;
    var wrapperFn = function wrapperFn() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        lastArgs = args;
        if (frameId) return;
        frameId = requestAnimationFrame(function() {
            frameId = null;
            fn.apply(void 0, lastArgs);
        });
    };
    wrapperFn.cancel = function() {
        if (!frameId) return;
        cancelAnimationFrame(frameId);
        frameId = null;
    };
    return wrapperFn;
};
var $9a1a2445ae22439e$export$2e2bcd8739ae039 = $9a1a2445ae22439e$var$rafSchd;

});




parcelRegister("fxo4p", function(module, exports) {
//
module.exports = function shallowEqual(objA, objB, compare, compareContext) {
    var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
    if (ret !== void 0) return !!ret;
    if (objA === objB) return true;
    if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) return false;
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
    // Test for A's keys different from B.
    for(var idx = 0; idx < keysA.length; idx++){
        var key = keysA[idx];
        if (!bHasOwnProperty(key)) return false;
        var valueA = objA[key];
        var valueB = objB[key];
        ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
        if (ret === false || ret === void 0 && valueA !== valueB) return false;
    }
    return true;
};

});

parcelRegister("gKpEp", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3eb2993a427b2667a5277a7a906fec96>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c314d6e8790147f3$var$_react = $c314d6e8790147f3$var$_interopRequireDefault((parcelRequire("dAx5m")));

var $c314d6e8790147f3$var$_UNSAFE_baseNew = $c314d6e8790147f3$var$_interopRequireDefault((parcelRequire("iSHhU")));
function $c314d6e8790147f3$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "ChevronDown".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for dropdown menus, selects, accordions, and expands.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c314d6e8790147f3$var$ChevronDownIcon = (props)=>/*#__PURE__*/ $c314d6e8790147f3$var$_react.default.createElement($c314d6e8790147f3$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M10.5 4.5 8.25 6.75 6 9 3.75 6.75 1.5 4.5"/>`,
        type: "utility"
    }, props));
$c314d6e8790147f3$var$ChevronDownIcon.displayName = "ChevronDownIcon";
var $c314d6e8790147f3$var$_default = module.exports.default = $c314d6e8790147f3$var$ChevronDownIcon;

});
parcelRegister("iSHhU", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("8io2O")).default; });
$parcel$export(module.exports, "Icon", function () { return (parcelRequire("8io2O")).Icon; });

var $8io2O = parcelRequire("8io2O");

});
parcelRegister("8io2O", function(module, exports) {

$parcel$export(module.exports, "Icon", function () { return $60a2a7dbe1f6895f$export$f04a61298a47a40f; });
$parcel$export(module.exports, "default", function () { return $60a2a7dbe1f6895f$export$2e2bcd8739ae039; });
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $dAx5m = parcelRequire("dAx5m");

var $jVTBW = parcelRequire("jVTBW");

var $hlM0a = parcelRequire("hlM0a");
/**
 * We are hiding this props from consumers as it's reserved
 * for use by Icon Tile.
 */ var $60a2a7dbe1f6895f$var$commonSVGStyles = (0, $jVTBW.css)({
    overflow: "hidden",
    pointerEvents: "none",
    /**
   * Stop-color doesn't properly apply in chrome when the inherited/current color changes.
   * We have to initially set stop-color to inherit (either via DOM attribute or an initial CSS
   * rule) and then override it with currentColor for the color changes to be picked up.
   */ // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    stop: {
        stopColor: "currentColor"
    }
});
var $60a2a7dbe1f6895f$var$svgStyles = (0, $jVTBW.css)({
    color: "currentColor",
    verticalAlign: "bottom"
});
var $60a2a7dbe1f6895f$var$iconStyles = (0, $jVTBW.css)({
    display: "inline-block",
    boxSizing: "border-box",
    flexShrink: 0,
    lineHeight: 1,
    paddingInlineEnd: "var(--ds--button--new-icon-padding-end, 0)",
    paddingInlineStart: "var(--ds--button--new-icon-padding-start, 0)"
});
var $60a2a7dbe1f6895f$var$utilityIconStyles = (0, $jVTBW.css)({
    lineHeight: "var(--ds-space-150, 12px)"
});
var $60a2a7dbe1f6895f$var$scaleStyles = (0, $jVTBW.css)({
    width: "inherit",
    height: "inherit"
});
/**
 * For windows high contrast mode
 */ var $60a2a7dbe1f6895f$var$baseHcmStyles = (0, $jVTBW.css)({
    "@media screen and (forced-colors: active)": {
        color: "CanvasText",
        filter: "grayscale(1)"
    }
});
var $60a2a7dbe1f6895f$var$sizeMap = {
    scale: (0, $jVTBW.css)({
        width: "inherit",
        height: "inherit"
    }),
    utility: (0, $jVTBW.css)({
        width: "var(--ds-space-150, 12px)",
        height: "var(--ds-space-150, 12px)"
    }),
    none: (0, $jVTBW.css)({
        width: "var(--ds-space-200, 16px)",
        height: "var(--ds-space-200, 16px)"
    }),
    spacious: (0, $jVTBW.css)({
        width: "var(--ds-space-300, 24px)",
        height: "var(--ds-space-300, 24px)"
    })
};
var $60a2a7dbe1f6895f$var$baseSizeMap = {
    global: 16,
    utility: 12
};
var $60a2a7dbe1f6895f$export$f04a61298a47a40f = /*#__PURE__*/ (0, $dAx5m.memo)(function Icon(props) {
    var _ref = props, providedColor = _ref.color, _ref$spacing = _ref.spacing, providedSpacing = _ref$spacing === void 0 ? "none" : _ref$spacing, testId = _ref.testId, label = _ref.label, LEGACY_primaryColor = _ref.LEGACY_primaryColor, LEGACY_secondaryColor = _ref.LEGACY_secondaryColor, LEGACY_size = _ref.LEGACY_size, FallbackIcon = _ref.LEGACY_fallbackIcon, _ref$type = _ref.type, type = _ref$type === void 0 ? "global" : _ref$type, dangerouslySetGlyph = _ref.dangerouslySetGlyph, shouldScale = _ref.shouldScale, LEGACY_margin = _ref.LEGACY_margin;
    var fallbackColor = "var(--ds-icon, #44546F)";
    if ((0, $hlM0a.fg)("platform-design-system-new-icon-default-color") || (0, $hlM0a.fg)("platform-design-system-new-icon-default-color-2")) fallbackColor = "currentColor";
    var color = providedColor !== null && providedColor !== void 0 ? providedColor : fallbackColor;
    var dangerouslySetInnerHTML = dangerouslySetGlyph ? {
        __html: dangerouslySetGlyph
    } : undefined;
    // Fall back to old icon
    if (FallbackIcon && !(0, $hlM0a.fg)("platform.design-system-team.enable-new-icons")) // parse out unnecessary props
    return (0, $jVTBW.jsx)(FallbackIcon, {
        primaryColor: LEGACY_primaryColor !== null && LEGACY_primaryColor !== void 0 ? LEGACY_primaryColor : color,
        secondaryColor: LEGACY_secondaryColor,
        size: LEGACY_size,
        label: label,
        testId: testId,
        UNSAFE_margin: LEGACY_margin
    });
    // Utility icons don't have 'spacing' as a type, but in case it's provided, we default to 'none'
    var spacing = type === "utility" ? "none" : providedSpacing;
    var baseSize = $60a2a7dbe1f6895f$var$baseSizeMap[type];
    var size = type === "utility" ? "utility" : shouldScale ? "scale" : spacing;
    var viewBoxPadding = spacing === "spacious" ? 4 : 0;
    var viewBoxSize = baseSize + 2 * viewBoxPadding;
    // Workaround for the transparency in our disabled icon token.
    // Because we have multiple strokes in icons, opacities overlap
    // This filter has an impact on render performance, but this is
    // acceptable as icons aren't commonly disabled en-masse
    var iconColor = color;
    if (dangerouslySetInnerHTML && color === "var(--ds-icon-disabled, #091E424F)") {
        dangerouslySetInnerHTML.__html = '\n<filter id="ds-newIconOpacityFilter">\n  <feFlood flood-color="var(--ds-icon-disabled)" />\n  <feComposite in2="SourceGraphic" operator="in" />\n</filter>\n<g filter="url(#ds-newIconOpacityFilter)">\n  '.concat(dangerouslySetInnerHTML.__html, "\n</g>");
        iconColor = "var(--ds-icon, #44546F)";
    }
    return (0, $jVTBW.jsx)("span", {
        "data-testid": testId,
        role: label ? "img" : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: {
            color: iconColor
        },
        css: [
            $60a2a7dbe1f6895f$var$iconStyles,
            $60a2a7dbe1f6895f$var$baseHcmStyles,
            shouldScale && $60a2a7dbe1f6895f$var$scaleStyles,
            type === "utility" && $60a2a7dbe1f6895f$var$utilityIconStyles
        ]
    }, (0, $jVTBW.jsx)("svg", {
        fill: "none",
        viewBox: "".concat(0 - viewBoxPadding, " ").concat(0 - viewBoxPadding, " ").concat(viewBoxSize, " ").concat(viewBoxSize),
        role: "presentation",
        css: [
            $60a2a7dbe1f6895f$var$commonSVGStyles,
            $60a2a7dbe1f6895f$var$svgStyles,
            $60a2a7dbe1f6895f$var$sizeMap[size]
        ],
        dangerouslySetInnerHTML: dangerouslySetInnerHTML
    }));
});
var $60a2a7dbe1f6895f$export$2e2bcd8739ae039 = $60a2a7dbe1f6895f$export$f04a61298a47a40f;

});
parcelRegister("hlM0a", function(module, exports) {

$parcel$export(module.exports, "fg", function () { return $ca19a1ff00f8dbfe$export$b40ec24ac8275656; });

var $8tToB = parcelRequire("8tToB");
function $ca19a1ff00f8dbfe$export$ba05d765b8392e5e(flagResolver) {
    (0, $8tToB.setBooleanResolver)(flagResolver);
}
function $ca19a1ff00f8dbfe$export$470e5c2be1411c89(name) {
    return (0, $8tToB.resolveBooleanFlag)(name);
}
function $ca19a1ff00f8dbfe$export$b40ec24ac8275656(name) {
    return (0, $8tToB.resolveBooleanFlag)(name);
}

});
parcelRegister("8tToB", function(module, exports) {

$parcel$export(module.exports, "setBooleanResolver", function () { return $62cc009f08041bfa$export$f2b591175b3e424c; });
$parcel$export(module.exports, "resolveBooleanFlag", function () { return $62cc009f08041bfa$export$6333b6aff9fc6275; });

var $dVpOh = parcelRequire("dVpOh");

var $ahJoN = parcelRequire("ahJoN");
var $62cc009f08041bfa$var$pkgName = "@atlaskit/platform-feature-flags";
var $62cc009f08041bfa$export$7e41b1b2bdee3f98 = "__PLATFORM_FEATURE_FLAGS__";
var $62cc009f08041bfa$var$hasProcessEnv = typeof $ahJoN !== "undefined" && typeof $ahJoN.env !== "undefined";
// FF global overrides can be configured by test runners or Storybook
var $62cc009f08041bfa$var$ENV_ENABLE_PLATFORM_FF = $62cc009f08041bfa$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
// STORYBOOK_ENABLE_PLATFORM_FF is included as storybook only allows env vars prefixed with STORYBOOK
// https://github.com/storybookjs/storybook/issues/12270
var $62cc009f08041bfa$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF = $62cc009f08041bfa$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
var $62cc009f08041bfa$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE = $62cc009f08041bfa$var$ENV_ENABLE_PLATFORM_FF || $62cc009f08041bfa$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF;
var $62cc009f08041bfa$var$DEFAULT_PFF_GLOBAL = {
    // In development mode we want to capture any feature flag checks that happen using the default resolver and log this result when the resolver is replaced.
    // This is because evaluating feature flags when the resolver/FF client is loaded asynchronously could cause unexpected issues.
    earlyResolvedFlags: new Map(),
    booleanResolver: function booleanResolver(flagKey) {
        var unresolvedFlagCount;
        return false;
    }
};
var $62cc009f08041bfa$var$globalVar = typeof window !== "undefined" ? window : globalThis;
$62cc009f08041bfa$var$globalVar[$62cc009f08041bfa$export$7e41b1b2bdee3f98] = $62cc009f08041bfa$var$globalVar[$62cc009f08041bfa$export$7e41b1b2bdee3f98] || $62cc009f08041bfa$var$DEFAULT_PFF_GLOBAL;
function $62cc009f08041bfa$export$f2b591175b3e424c(resolver) {
    $62cc009f08041bfa$var$globalVar[$62cc009f08041bfa$export$7e41b1b2bdee3f98].booleanResolver = resolver;
    var _globalVar$PFF_GLOBAL;
}
function $62cc009f08041bfa$export$6333b6aff9fc6275(flagKey) {
    if ($62cc009f08041bfa$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE) {
        (0, $dVpOh.debug)('[%s]: The feature flags were enabled while running tests. The flag "%s" will be always enabled.', $62cc009f08041bfa$var$pkgName, flagKey);
        return true;
    }
    try {
        var _globalVar$PFF_GLOBAL2;
        var result = (_globalVar$PFF_GLOBAL2 = $62cc009f08041bfa$var$globalVar[$62cc009f08041bfa$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL2 === void 0 ? void 0 : _globalVar$PFF_GLOBAL2.booleanResolver(flagKey);
        if (typeof result !== "boolean") {
            // eslint-disable-next-line no-console
            console.warn("".concat(flagKey, " resolved to a non-boolean value, returning false for safety"));
            return false;
        }
        return result;
    } catch (e) {
        return false;
    }
}

});
parcelRegister("dVpOh", function(module, exports) {

$parcel$export(module.exports, "debug", function () { return $a2349e898065de35$export$1c9f709888824e05; });
var $a2349e898065de35$var$_ref, $a2349e898065de35$var$_process, $a2349e898065de35$var$_process2;
// We can't rely on NODE_ENV === 'test' if its value is already configured by the consumer to some other value, so better to use JEST_WORKER_ID
// https://jestjs.io/docs/environment-variables#jest_worker_id
var $a2349e898065de35$var$TESTS_MODE = ($a2349e898065de35$var$_ref = (globalThis === null || globalThis === void 0 || ($a2349e898065de35$var$_process = globalThis.process) === null || $a2349e898065de35$var$_process === void 0 || ($a2349e898065de35$var$_process = $a2349e898065de35$var$_process.env) === null || $a2349e898065de35$var$_process === void 0 ? void 0 : $a2349e898065de35$var$_process.JEST_WORKER_ID) !== undefined, $a2349e898065de35$var$_ref !== void 0) ? $a2349e898065de35$var$_ref : false;
var $a2349e898065de35$var$DEBUG_MODE = !$a2349e898065de35$var$TESTS_MODE && (globalThis === null || globalThis === void 0 || ($a2349e898065de35$var$_process2 = globalThis.process) === null || $a2349e898065de35$var$_process2 === void 0 || ($a2349e898065de35$var$_process2 = $a2349e898065de35$var$_process2.env) === null || $a2349e898065de35$var$_process2 === void 0 ? void 0 : $a2349e898065de35$var$_process2.NODE_ENV) !== "production";
var $a2349e898065de35$export$1c9f709888824e05 = function debug() {
    var _console;
    if (!$a2349e898065de35$var$DEBUG_MODE) return;
    // eslint-disable-next-line no-console
    (_console = console).debug.apply(_console, arguments);
};

});






parcelRegister("fIjLq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b70a4bc52286b772$export$2e2bcd8739ae039; });

var $jIMDT = parcelRequire("jIMDT");

var $91np6 = parcelRequire("91np6");

var $b6jao = parcelRequire("b6jao");

var $aZB6k = parcelRequire("aZB6k");

var $dAx5m = parcelRequire("dAx5m");

var $iGzks = parcelRequire("iGzks");

var $92Uwu = parcelRequire("92Uwu");

var $3qE8l = parcelRequire("3qE8l");

var $bFCyL = parcelRequire("bFCyL");

var $85GSA = parcelRequire("85GSA");
var $b70a4bc52286b772$var$_excluded = [
    "appearance",
    "autoFocus",
    "isDisabled",
    "isSelected",
    "shouldFitContainer",
    "spacing",
    "isLoading",
    "onMouseEnter",
    "onMouseLeave",
    "onMouseDown",
    "onMouseUp",
    "onFocus",
    "onBlur",
    "theme"
];
function $b70a4bc52286b772$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $b70a4bc52286b772$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $b70a4bc52286b772$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($b6jao)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $b70a4bc52286b772$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $b70a4bc52286b772$var$getInteractionState(_ref) {
    var _ref$isDisabled = _ref.isDisabled, isDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled, _ref$isActive = _ref.isActive, isActive = _ref$isActive === void 0 ? false : _ref$isActive, _ref$isFocus = _ref.isFocus, isFocus = _ref$isFocus === void 0 ? false : _ref$isFocus, _ref$isHover = _ref.isHover, isHover = _ref$isHover === void 0 ? false : _ref$isHover, _ref$isSelected = _ref.isSelected, isSelected = _ref$isSelected === void 0 ? false : _ref$isSelected, _ref$isLoading = _ref.isLoading, isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading;
    if (isDisabled) return "disabled";
    if (isSelected && isFocus) return "focusSelected";
    if (isSelected) return "selected";
    // not allowing active or focus style changes while loading
    if (!isLoading && isActive) return "active";
    if (!isLoading && isHover) return "hover";
    if (isFocus) return "focus";
    return "default";
}
var $b70a4bc52286b772$var$initial = {
    isHover: false,
    isActive: false,
    isFocus: false
};
/**
 * __Custom theme button__
 *
 * A custom theme button. Avoid using this component. It exists for those already using custom theming, which is hard to use and has performance issues.
 *
 * - [Examples](https://atlassian.design/components/button/examples#custom-theme-button)
 */ var $b70a4bc52286b772$var$CustomThemeButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).forwardRef(function CustomThemeButton(_ref2, ref) {
    var _ref2$appearance = _ref2.appearance, appearance = _ref2$appearance === void 0 ? "default" : _ref2$appearance, _ref2$autoFocus = _ref2.autoFocus, autoFocus = _ref2$autoFocus === void 0 ? false : _ref2$autoFocus, _ref2$isDisabled = _ref2.isDisabled, isDisabled = _ref2$isDisabled === void 0 ? false : _ref2$isDisabled, _ref2$isSelected = _ref2.isSelected, isSelected = _ref2$isSelected === void 0 ? false : _ref2$isSelected, _ref2$shouldFitContai = _ref2.shouldFitContainer, shouldFitContainer = _ref2$shouldFitContai === void 0 ? false : _ref2$shouldFitContai, _ref2$spacing = _ref2.spacing, spacing = _ref2$spacing === void 0 ? "default" : _ref2$spacing, _ref2$isLoading = _ref2.isLoading, isLoading = _ref2$isLoading === void 0 ? false : _ref2$isLoading, providedOnMouseEnter = _ref2.onMouseEnter, providedOnMouseLeave = _ref2.onMouseLeave, providedOnMouseDown = _ref2.onMouseDown, providedOnMouseUp = _ref2.onMouseUp, providedOnFocus = _ref2.onFocus, providedOnBlur = _ref2.onBlur, _ref2$theme = _ref2.theme, theme = _ref2$theme === void 0 ? (0, $85GSA.defaultThemeFn) : _ref2$theme, rest = (0, (/*@__PURE__*/$parcel$interopDefault($aZB6k)))(_ref2, $b70a4bc52286b772$var$_excluded);
    // TODO is there a nicer way to do this?
    // Add default props back into object for spreading
    var restProps = $b70a4bc52286b772$var$_objectSpread({
        appearance: appearance,
        autoFocus: autoFocus,
        isDisabled: isDisabled,
        isSelected: isSelected,
        shouldFitContainer: shouldFitContainer,
        spacing: spacing
    }, rest);
    var _useState = (0, $dAx5m.useState)($b70a4bc52286b772$var$initial), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($91np6)))(_useState, 2), state = _useState2[0], setState = _useState2[1];
    var onMouseEnter = (0, $dAx5m.useCallback)(function(event) {
        setState(function(current) {
            return $b70a4bc52286b772$var$_objectSpread($b70a4bc52286b772$var$_objectSpread({}, current), {}, {
                isHover: true
            });
        });
        if (providedOnMouseEnter) providedOnMouseEnter(event);
    }, [
        providedOnMouseEnter
    ]);
    var onMouseLeave = (0, $dAx5m.useCallback)(function(event) {
        setState(function(current) {
            return $b70a4bc52286b772$var$_objectSpread($b70a4bc52286b772$var$_objectSpread({}, current), {}, {
                isHover: false,
                isActive: false
            });
        });
        if (providedOnMouseLeave) providedOnMouseLeave(event);
    }, [
        providedOnMouseLeave
    ]);
    var onMouseDown = (0, $dAx5m.useCallback)(function(event) {
        setState(function(current) {
            return $b70a4bc52286b772$var$_objectSpread($b70a4bc52286b772$var$_objectSpread({}, current), {}, {
                isActive: true
            });
        });
        if (providedOnMouseDown) providedOnMouseDown(event);
    }, [
        providedOnMouseDown
    ]);
    var onMouseUp = (0, $dAx5m.useCallback)(function(event) {
        setState(function(current) {
            return $b70a4bc52286b772$var$_objectSpread($b70a4bc52286b772$var$_objectSpread({}, current), {}, {
                isActive: false
            });
        });
        if (providedOnMouseUp) providedOnMouseUp(event);
    }, [
        providedOnMouseUp
    ]);
    var onFocus = (0, $dAx5m.useCallback)(function(event) {
        setState(function(current) {
            return $b70a4bc52286b772$var$_objectSpread($b70a4bc52286b772$var$_objectSpread({}, current), {}, {
                isFocus: true
            });
        });
        if (providedOnFocus) providedOnFocus(event);
    }, [
        providedOnFocus
    ]);
    var onBlur = (0, $dAx5m.useCallback)(function(event) {
        setState(function(current) {
            return $b70a4bc52286b772$var$_objectSpread($b70a4bc52286b772$var$_objectSpread({}, current), {}, {
                isFocus: false
            });
        });
        if (providedOnBlur) providedOnBlur(event);
    }, [
        providedOnBlur
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $85GSA.default).Provider, {
        value: theme
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $iGzks.default).Consumer, null, function(_ref3) {
        var mode = _ref3.mode;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $85GSA.default).Consumer, (0, (/*@__PURE__*/$parcel$interopDefault($jIMDT)))({
            mode: mode,
            state: $b70a4bc52286b772$var$getInteractionState($b70a4bc52286b772$var$_objectSpread($b70a4bc52286b772$var$_objectSpread({}, state), {}, {
                isLoading: isLoading,
                isSelected: restProps.isSelected,
                isDisabled: restProps.isDisabled
            })),
            iconIsOnlyChild: (0, $3qE8l.default)(restProps),
            isLoading: isLoading
        }, restProps), function(_ref4) {
            var buttonStyles = _ref4.buttonStyles;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $92Uwu.default), (0, (/*@__PURE__*/$parcel$interopDefault($jIMDT)))({}, restProps, {
                ref: ref,
                overlay: isLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $bFCyL.default), restProps) : null,
                "aria-disabled": isLoading || restProps["aria-disabled"],
                onMouseEnter: onMouseEnter,
                onMouseLeave: onMouseLeave,
                onMouseDown: onMouseDown,
                onMouseUp: onMouseUp,
                onFocus: onFocus,
                onBlur: onBlur,
                buttonCss: (0, $85GSA.getSpecifiers)(buttonStyles)
            }));
        });
    }));
}));
// Tools including enzyme rely on components having a display name
$b70a4bc52286b772$var$CustomThemeButton.displayName = "CustomThemeButton";
var $b70a4bc52286b772$export$2e2bcd8739ae039 = $b70a4bc52286b772$var$CustomThemeButton;

});
parcelRegister("bFCyL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $87f16f2e41aa1f8f$export$2e2bcd8739ae039; });

var $dAx5m = parcelRequire("dAx5m");

var $fL9T3 = parcelRequire("fL9T3");
function $87f16f2e41aa1f8f$var$getSpinnerAppearance(_ref) {
    var appearance = _ref.appearance, isDisabled = _ref.isDisabled, isSelected = _ref.isSelected;
    if (isDisabled) return "inherit";
    if (isSelected) return "invert";
    if (appearance === "primary" || appearance === "danger") return "invert";
    return "inherit";
}
function $87f16f2e41aa1f8f$export$2e2bcd8739ae039(_ref2) {
    var appearance = _ref2.appearance, isDisabled = _ref2.isDisabled, isSelected = _ref2.isSelected, _ref2$spacing = _ref2.spacing, spacing = _ref2$spacing === void 0 ? "default" : _ref2$spacing;
    var size = spacing === "default" ? "medium" : "small";
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $fL9T3.default), {
        size: size,
        label: ", Loading",
        appearance: $87f16f2e41aa1f8f$var$getSpinnerAppearance({
            appearance: appearance,
            isDisabled: isDisabled,
            isSelected: isSelected
        })
    });
}

});

parcelRegister("85GSA", function(module, exports) {

$parcel$export(module.exports, "getSpecifiers", function () { return $5e400d4f9f320460$export$643db0b8d8778e; });
$parcel$export(module.exports, "defaultThemeFn", function () { return $5e400d4f9f320460$export$437a7f77d13d7916; });
$parcel$export(module.exports, "default", function () { return $5e400d4f9f320460$export$2e2bcd8739ae039; });

var $b6jao = parcelRequire("b6jao");

var $cAxNV = parcelRequire("cAxNV");

var $gje9J = parcelRequire("gje9J");
function $5e400d4f9f320460$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $5e400d4f9f320460$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $5e400d4f9f320460$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($b6jao)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $5e400d4f9f320460$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $5e400d4f9f320460$var$stateToSelectorMap = {
    focus: "&:focus",
    focusSelected: "&:focus",
    hover: "&:hover",
    active: "&:active",
    disabled: "&[disabled]"
};
function $5e400d4f9f320460$export$31512de7fa606fa4(_ref) {
    var _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "default" : _ref$appearance, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? "default" : _ref$spacing, _ref$mode = _ref.mode, mode = _ref$mode === void 0 ? "light" : _ref$mode, _ref$isSelected = _ref.isSelected, isSelected = _ref$isSelected === void 0 ? false : _ref$isSelected, _ref$shouldFitContain = _ref.shouldFitContainer, shouldFitContainer = _ref$shouldFitContain === void 0 ? false : _ref$shouldFitContain, _ref$iconIsOnlyChild = _ref.iconIsOnlyChild, iconIsOnlyChild = _ref$iconIsOnlyChild === void 0 ? false : _ref$iconIsOnlyChild, _ref$isLoading = _ref.isLoading, isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading, state = _ref.state;
    var result = (0, $gje9J.getCss)({
        appearance: appearance,
        spacing: spacing,
        mode: mode,
        isSelected: isSelected,
        shouldFitContainer: shouldFitContainer,
        isOnlySingleIcon: iconIsOnlyChild
    });
    // we need to disable the default browser focus styles always
    // this is because we are not expressing that we can have two pseudo states at a time
    result.outline = "none";
    // Pulling relevant styles up to the top level
    var selector = $5e400d4f9f320460$var$stateToSelectorMap[state];
    if (selector) result = $5e400d4f9f320460$var$_objectSpread($5e400d4f9f320460$var$_objectSpread({}, result), result[selector]);
    if (isLoading) result = $5e400d4f9f320460$var$_objectSpread($5e400d4f9f320460$var$_objectSpread({}, result), result['&[data-has-overlay="true"]']);
    // Delete all selectors and just keep root styles
    Object.keys(result).forEach(function(key) {
        // want to keep this one
        if (key === "&::-moz-focus-inner") return;
        // Not using .startsWith for ie11
        if (key.indexOf("&") === 0) delete result[key];
    });
    return result;
}
function $5e400d4f9f320460$export$643db0b8d8778e(styles) {
    return {
        "&, &:hover, &:active, &:focus, &:focus-visible, &:visited, &:disabled, &[disabled]": styles
    };
}
function $5e400d4f9f320460$export$437a7f77d13d7916(current, values) {
    return current(values);
}
var $5e400d4f9f320460$var$Theme = (0, $cAxNV.createTheme)(function(themeProps) {
    return {
        buttonStyles: $5e400d4f9f320460$export$31512de7fa606fa4(themeProps),
        // No styles being applied directly to spinner by default
        // Keeping this for legacy compat. We could remove it, but given
        // that we are changing theme soon there is no point
        spinnerStyles: {}
    };
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$5e400d4f9f320460$export$2e2bcd8739ae039 = $5e400d4f9f320460$var$Theme;

});


parcelRegister("lyB4O", function(module, exports) {

$parcel$export(module.exports, "useId", function () { return $fb19889bebcd588d$export$f680877a34711e37; });
$parcel$export(module.exports, "useIdSeed", function () { return $fb19889bebcd588d$export$6ee17796e3d70de2; });

var $dAx5m = parcelRequire("dAx5m");

var $D9YLo = parcelRequire("D9YLo");

var $14H8l = parcelRequire("14H8l");
var $fb19889bebcd588d$var$_React$useId;
// Type copied from https://github.com/thearnica/react-uid/blob/0f507fbbdb1ab84acf477ec32698afe3d2191e49/src/hooks.ts#L12
// Copied rather than inferred to make the type transparent
// @ts-ignore - useId is not accessible in React 16
var $fb19889bebcd588d$var$react18UseId = ($fb19889bebcd588d$var$_React$useId = (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).useId) !== null && $fb19889bebcd588d$var$_React$useId !== void 0 ? $fb19889bebcd588d$var$_React$useId : undefined;
function $fb19889bebcd588d$export$f680877a34711e37() {
    if ($fb19889bebcd588d$var$react18UseId && (0, $14H8l.fg)("platform.design-system-team.react-18-use-id_mn8q4")) // eslint-disable-next-line react-hooks/rules-of-hooks
    return $fb19889bebcd588d$var$react18UseId();
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return (0, $D9YLo.useUID)();
}
function $fb19889bebcd588d$export$6ee17796e3d70de2() {
    if ($fb19889bebcd588d$var$react18UseId && (0, $14H8l.fg)("platform.design-system-team.react-18-use-id_mn8q4")) {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        var uid = $fb19889bebcd588d$var$react18UseId();
        return function(id) {
            return "".concat(uid, "-").concat(id.toString());
        };
    }
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return (0, $D9YLo.useUIDSeed)();
}

});
parcelRegister("14H8l", function(module, exports) {

$parcel$export(module.exports, "fg", function () { return $0c879f937f9544a2$export$b40ec24ac8275656; });

var $lxO79 = parcelRequire("lxO79");
function $0c879f937f9544a2$export$ba05d765b8392e5e(flagResolver) {
    (0, $lxO79.setBooleanResolver)(flagResolver);
}
function $0c879f937f9544a2$export$470e5c2be1411c89(name) {
    return (0, $lxO79.resolveBooleanFlag)(name);
}
function $0c879f937f9544a2$export$b40ec24ac8275656(name) {
    return (0, $lxO79.resolveBooleanFlag)(name);
}

});
parcelRegister("lxO79", function(module, exports) {

$parcel$export(module.exports, "setBooleanResolver", function () { return $faf38daeebc40644$export$f2b591175b3e424c; });
$parcel$export(module.exports, "resolveBooleanFlag", function () { return $faf38daeebc40644$export$6333b6aff9fc6275; });

var $dlecJ = parcelRequire("dlecJ");

var $ahJoN = parcelRequire("ahJoN");
var $faf38daeebc40644$var$pkgName = "@atlaskit/platform-feature-flags";
var $faf38daeebc40644$export$7e41b1b2bdee3f98 = "__PLATFORM_FEATURE_FLAGS__";
var $faf38daeebc40644$var$hasProcessEnv = typeof $ahJoN !== "undefined" && typeof $ahJoN.env !== "undefined";
// FF global overrides can be configured by test runners or Storybook
var $faf38daeebc40644$var$ENV_ENABLE_PLATFORM_FF = $faf38daeebc40644$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
// STORYBOOK_ENABLE_PLATFORM_FF is included as storybook only allows env vars prefixed with STORYBOOK
// https://github.com/storybookjs/storybook/issues/12270
var $faf38daeebc40644$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF = $faf38daeebc40644$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
var $faf38daeebc40644$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE = $faf38daeebc40644$var$ENV_ENABLE_PLATFORM_FF || $faf38daeebc40644$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF;
var $faf38daeebc40644$var$DEFAULT_PFF_GLOBAL = {
    // In development mode we want to capture any feature flag checks that happen using the default resolver and log this result when the resolver is replaced.
    // This is because evaluating feature flags when the resolver/FF client is loaded asynchronously could cause unexpected issues.
    earlyResolvedFlags: new Map(),
    booleanResolver: function booleanResolver(flagKey) {
        var unresolvedFlagCount;
        return false;
    }
};
var $faf38daeebc40644$var$globalVar = typeof window !== "undefined" ? window : globalThis;
$faf38daeebc40644$var$globalVar[$faf38daeebc40644$export$7e41b1b2bdee3f98] = $faf38daeebc40644$var$globalVar[$faf38daeebc40644$export$7e41b1b2bdee3f98] || $faf38daeebc40644$var$DEFAULT_PFF_GLOBAL;
function $faf38daeebc40644$export$f2b591175b3e424c(resolver) {
    $faf38daeebc40644$var$globalVar[$faf38daeebc40644$export$7e41b1b2bdee3f98].booleanResolver = resolver;
    var _globalVar$PFF_GLOBAL;
}
function $faf38daeebc40644$export$6333b6aff9fc6275(flagKey) {
    if ($faf38daeebc40644$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE) {
        (0, $dlecJ.debug)('[%s]: The feature flags were enabled while running tests. The flag "%s" will be always enabled.', $faf38daeebc40644$var$pkgName, flagKey);
        return true;
    }
    try {
        var _globalVar$PFF_GLOBAL2;
        var result = (_globalVar$PFF_GLOBAL2 = $faf38daeebc40644$var$globalVar[$faf38daeebc40644$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL2 === void 0 ? void 0 : _globalVar$PFF_GLOBAL2.booleanResolver(flagKey);
        if (typeof result !== "boolean") {
            // eslint-disable-next-line no-console
            console.warn("".concat(flagKey, " resolved to a non-boolean value, returning false for safety"));
            return false;
        }
        return result;
    } catch (e) {
        return false;
    }
}

});
parcelRegister("dlecJ", function(module, exports) {

$parcel$export(module.exports, "debug", function () { return $9b68413dc9e72c51$export$1c9f709888824e05; });
var $9b68413dc9e72c51$var$_ref, $9b68413dc9e72c51$var$_process, $9b68413dc9e72c51$var$_process2;
// We can't rely on NODE_ENV === 'test' if its value is already configured by the consumer to some other value, so better to use JEST_WORKER_ID
// https://jestjs.io/docs/environment-variables#jest_worker_id
var $9b68413dc9e72c51$var$TESTS_MODE = ($9b68413dc9e72c51$var$_ref = (globalThis === null || globalThis === void 0 || ($9b68413dc9e72c51$var$_process = globalThis.process) === null || $9b68413dc9e72c51$var$_process === void 0 || ($9b68413dc9e72c51$var$_process = $9b68413dc9e72c51$var$_process.env) === null || $9b68413dc9e72c51$var$_process === void 0 ? void 0 : $9b68413dc9e72c51$var$_process.JEST_WORKER_ID) !== undefined, $9b68413dc9e72c51$var$_ref !== void 0) ? $9b68413dc9e72c51$var$_ref : false;
var $9b68413dc9e72c51$var$DEBUG_MODE = !$9b68413dc9e72c51$var$TESTS_MODE && (globalThis === null || globalThis === void 0 || ($9b68413dc9e72c51$var$_process2 = globalThis.process) === null || $9b68413dc9e72c51$var$_process2 === void 0 || ($9b68413dc9e72c51$var$_process2 = $9b68413dc9e72c51$var$_process2.env) === null || $9b68413dc9e72c51$var$_process2 === void 0 ? void 0 : $9b68413dc9e72c51$var$_process2.NODE_ENV) !== "production";
var $9b68413dc9e72c51$export$1c9f709888824e05 = function debug() {
    var _console;
    if (!$9b68413dc9e72c51$var$DEBUG_MODE) return;
    // eslint-disable-next-line no-console
    (_console = console).debug.apply(_console, arguments);
};

});




parcelRegister("1abnK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return (parcelRequire("f9232")).default; });
$parcel$export(module.exports, "FlagHashes", function () { return (parcelRequire("9fcOo")).FlagHashes; });

var $f9232 = parcelRequire("f9232");

var $9fcOo = parcelRequire("9fcOo");

});
parcelRegister("f9232", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $21818899a050c0dc$export$2e2bcd8739ae039; });
parcelRequire("8p3sV");

var $dAx5m = parcelRequire("dAx5m");
parcelRequire("5Zreo");
var $lairn = parcelRequire("lairn");

var $lKhJJ = parcelRequire("lKhJJ");
var $dZHnD = parcelRequire("dZHnD");
parcelRequire("jShba");
var $3kXiv = parcelRequire("3kXiv");

var $9fcOo = parcelRequire("9fcOo");
parcelRequire("jQGCp");
var $7PWYP = parcelRequire("7PWYP");
const $21818899a050c0dc$export$af20f1185a10d9e2 = ({ dispatchAddFlag: dispatchAddFlag })=>{
    const navigate = (0, $lairn.useNavigate)();
    const { formatMessage: formatMessage } = (0, $dZHnD.default)();
    const location = (0, $lairn.useLocation)();
    (0, $dAx5m.useEffect)(()=>{
        const { pathname: pathname, search: search, hash: hash = "" } = location;
        const clearHash = ()=>{
            navigate(`${pathname}${search}`, {
                replace: true
            });
        };
        const showFlagsIfHave = ()=>{
            const message = $21818899a050c0dc$var$HASH_TO_FLAG_MESSAGE[hash];
            if (message) {
                const { title: title, description: description } = message;
                dispatchAddFlag({
                    ...message,
                    title: title && formatMessage(title),
                    description: description && formatMessage(description)
                });
                clearHash();
            }
        };
        showFlagsIfHave();
    }, [
        dispatchAddFlag,
        formatMessage,
        location,
        navigate
    ]);
    return null;
};
const $21818899a050c0dc$export$defe85febe8b728c = (0, $lKhJJ.defineMessages)({
    flagAccountRecoverTitle: {
        id: "manage.profile.flag.account.recover.title",
        defaultMessage: "Account recovery request cancelled",
        description: "Title of a success flag to let a user know that they have cancelled their request to recover their account because they have lost their MFA device"
    },
    flagAccountRecoverMsg: {
        id: "manage.profile.flag.account.recover.message",
        defaultMessage: "We've cancelled your account recovery request.",
        description: "Message of a success flag to let a user know that they have cancelled their request to recover their account because they have lost their MFA device"
    },
    flagVerifiedAccountTitle: {
        id: "manage.profile.flag.verified.account.title",
        defaultMessage: "Welcome to your Atlassian account",
        description: "Title of a success flag to tell a user they have successfully verified their email address"
    },
    flagVerifiedAccountMsg: {
        id: "manage.profile.flag.verified.account.message",
        defaultMessage: "We've verified your email address.",
        description: "Message of a success flag to tell a user they have successfully verified their email address"
    },
    // TODO: Get updated copy
    flagRegenerateRecoveryCodeSuccessTitle: {
        id: "manage.profile.flag.regenerate-recovery-code.success.title",
        defaultMessage: "You created a new recovery key",
        description: "Title of flag shown after the user regenerates their TSV recovery code"
    },
    flagRegenerateRecoveryCodeSuccessMsg: {
        id: "manage.profile.flag.regenerate-recovery-code.success.message",
        defaultMessage: "Your old recovery key no longer works.",
        description: "Message of flag shown after the user regenerates their TSV recovery code"
    },
    flagRegenerateRecoveryCodeUnauthorizedTitle: {
        id: "manage.profile.flag.regenerate-recovery-code.unauthorized.title",
        defaultMessage: "We've locked your two-step verification settings.",
        description: "Title of flag shown after the user fails to regenerate their TSV recovery code because they weren't authorized"
    },
    flagTsvEnrollmentSuccessTitle: {
        id: "manage.profile.flag.flag.tsv.enrollment.successful.title",
        defaultMessage: "You're all set!",
        description: "Title of the flag shown after user successfully finishes two step verification enrollment flow"
    },
    flagTsvEnrollmentSuccessMessage: {
        id: "manage.profile.flag.flag.tsv.enrollment.successful.message",
        defaultMessage: "The next time you log in, you'll need to enter a 6-digit verification code.",
        description: "Description of the flag shown after user successfully finishes two step verification enrollment flow"
    },
    flagChangePasswordSuccessFlagMessage: {
        id: "manage.profile.flag.flag.change.password.successful.message",
        defaultMessage: "Your password was successfully changed",
        description: "Message body of flag informing the user that their password change was successful."
    },
    flagChangePasswordSuccessFlagTitle: {
        id: "manage.profile.flag.flag.change.password.successful.title",
        defaultMessage: "Success",
        description: "Title of flag informing the user that their password change was successful."
    }
});
const $21818899a050c0dc$var$HASH_TO_FLAG_MESSAGE = {
    [(0, $9fcOo.FlagHashes).TSV_RECOVERY_CANCELED]: {
        type: "success",
        title: $21818899a050c0dc$export$defe85febe8b728c.flagAccountRecoverTitle,
        description: $21818899a050c0dc$export$defe85febe8b728c.flagAccountRecoverMsg,
        id: "manage.profile.flag.account.recover"
    },
    [(0, $9fcOo.FlagHashes).VERIFIED]: {
        type: "success",
        title: $21818899a050c0dc$export$defe85febe8b728c.flagVerifiedAccountTitle,
        description: $21818899a050c0dc$export$defe85febe8b728c.flagVerifiedAccountMsg,
        id: "manage.profile.flag.verified.account"
    },
    [(0, $9fcOo.FlagHashes).TSV_REGENERATE_RECOVERY_CODE_SUCCESS]: {
        type: "success",
        title: $21818899a050c0dc$export$defe85febe8b728c.flagRegenerateRecoveryCodeSuccessTitle,
        description: $21818899a050c0dc$export$defe85febe8b728c.flagRegenerateRecoveryCodeSuccessMsg,
        id: "manage.profile.flag.regenerate-recover-code.success"
    },
    [(0, $9fcOo.FlagHashes).TSV_REGENERATE_RECOVERY_CODE_UNAUTHORIZED]: {
        type: "error",
        title: $21818899a050c0dc$export$defe85febe8b728c.flagRegenerateRecoveryCodeUnauthorizedTitle,
        id: "manage.profile.flag.regenerate-recover-code.unauthorized"
    },
    [(0, $9fcOo.FlagHashes).TSV_ENROLLMENT_SUCCESS]: {
        type: "success",
        title: $21818899a050c0dc$export$defe85febe8b728c.flagTsvEnrollmentSuccessTitle,
        description: $21818899a050c0dc$export$defe85febe8b728c.flagTsvEnrollmentSuccessMessage,
        id: "manage.profile.flag.tsv.enrollment.success"
    },
    [(0, $9fcOo.FlagHashes).CHANGE_PASSWORD_SUCCESS]: {
        type: "success",
        title: $21818899a050c0dc$export$defe85febe8b728c.flagChangePasswordSuccessFlagTitle,
        description: $21818899a050c0dc$export$defe85febe8b728c.flagChangePasswordSuccessFlagMessage,
        id: "manage.profile.flag.change.password.success"
    }
};
const $21818899a050c0dc$var$mapDispatchToProps = {
    dispatchAddFlag: (0, $3kXiv.addFlag)
};
var $21818899a050c0dc$export$2e2bcd8739ae039 = (0, $7PWYP.default)(undefined, $21818899a050c0dc$var$mapDispatchToProps)($21818899a050c0dc$export$af20f1185a10d9e2);

});
parcelRegister("8p3sV", function(module, exports) {

var $fhMbr = parcelRequire("fhMbr");

var $5MUVm = parcelRequire("5MUVm");
var $6W4m7 = parcelRequire("6W4m7");

var $gbKg7 = parcelRequire("gbKg7");
// eslint-disable-next-line no-unused-expressions
(0, $fhMbr.injectGlobal)`
  html {
    box-sizing: border-box;
  }

  html,
  body {
    margin: 0;
    padding: 0;
    height: 100%;
  }

  body {
    font-family: ${(0, $6W4m7.fontFamily)()};
    font-size: 14px;
    line-height: 1.42857143;
    color: ${(0, $gbKg7.default)("color.text", (0, $5MUVm).N800)};
  }

  a {
    text-decoration: none;

    &:hover {
      text-decoration: none;
    }
  }

  *,
  *:before,
  *:after {
    box-sizing: inherit;
  }

  b, strong {
    font-weight: 600;
  }
`;

});
parcelRegister("fhMbr", function(module, exports) {

$parcel$export(module.exports, "injectGlobal", function () { return $b20dd1c660f12352$export$efb9f5caaa2ca0c7; });

var $iyIcA = parcelRequire("iyIcA");
parcelRequire("3Wdxg");
parcelRequire("2EoW8");
parcelRequire("3Ao1t");
var $b20dd1c660f12352$var$_createEmotion = (0, $iyIcA.default)({
    key: "css"
}), $b20dd1c660f12352$export$4909b86c8034bf73 = $b20dd1c660f12352$var$_createEmotion.flush, $b20dd1c660f12352$export$fa8d919ba61d84db = $b20dd1c660f12352$var$_createEmotion.hydrate, $b20dd1c660f12352$export$a274e22fb40f762e = $b20dd1c660f12352$var$_createEmotion.cx, $b20dd1c660f12352$export$4950aa0f605343fb = $b20dd1c660f12352$var$_createEmotion.merge, $b20dd1c660f12352$export$95d99596f328fd52 = $b20dd1c660f12352$var$_createEmotion.getRegisteredStyles, $b20dd1c660f12352$export$efb9f5caaa2ca0c7 = $b20dd1c660f12352$var$_createEmotion.injectGlobal, $b20dd1c660f12352$export$d25ddfdf17c3ad3e = $b20dd1c660f12352$var$_createEmotion.keyframes, $b20dd1c660f12352$export$dbf350e5966cf602 = $b20dd1c660f12352$var$_createEmotion.css, $b20dd1c660f12352$export$995990c5c04c46f0 = $b20dd1c660f12352$var$_createEmotion.sheet, $b20dd1c660f12352$export$69a3209f1a06c04d = $b20dd1c660f12352$var$_createEmotion.cache;

});
parcelRegister("iyIcA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d82db08bf675d805$export$2e2bcd8739ae039; });

var $3Wdxg = parcelRequire("3Wdxg");

var $2EoW8 = parcelRequire("2EoW8");

var $3Ao1t = parcelRequire("3Ao1t");
function $d82db08bf675d805$var$insertWithoutScoping(cache, serialized) {
    if (cache.inserted[serialized.name] === undefined) return cache.insert("", serialized, cache.sheet, true);
}
function $d82db08bf675d805$var$merge(registered, css, className) {
    var registeredStyles = [];
    var rawClassName = (0, $3Ao1t.getRegisteredStyles)(registered, registeredStyles, className);
    if (registeredStyles.length < 2) return className;
    return rawClassName + css(registeredStyles);
}
var $d82db08bf675d805$export$2e2bcd8739ae039 = function createEmotion(options) {
    var cache = (0, $3Wdxg.default)(options);
    cache.sheet.speedy = function(value) {
        this.isSpeedy = value;
    };
    cache.compat = true;
    var css = function css() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var serialized = (0, $2EoW8.serializeStyles)(args, cache.registered, undefined);
        (0, $3Ao1t.insertStyles)(cache, serialized, false);
        return cache.key + "-" + serialized.name;
    };
    var keyframes = function keyframes() {
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        var serialized = (0, $2EoW8.serializeStyles)(args, cache.registered);
        var animation = "animation-" + serialized.name;
        $d82db08bf675d805$var$insertWithoutScoping(cache, {
            name: serialized.name,
            styles: "@keyframes " + animation + "{" + serialized.styles + "}"
        });
        return animation;
    };
    var injectGlobal = function injectGlobal() {
        for(var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)args[_key3] = arguments[_key3];
        var serialized = (0, $2EoW8.serializeStyles)(args, cache.registered);
        $d82db08bf675d805$var$insertWithoutScoping(cache, serialized);
    };
    var cx = function cx() {
        for(var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)args[_key4] = arguments[_key4];
        return $d82db08bf675d805$var$merge(cache.registered, css, $d82db08bf675d805$var$classnames(args));
    };
    return {
        css: css,
        cx: cx,
        injectGlobal: injectGlobal,
        keyframes: keyframes,
        hydrate: function hydrate(ids) {
            ids.forEach(function(key) {
                cache.inserted[key] = true;
            });
        },
        flush: function flush() {
            cache.registered = {};
            cache.inserted = {};
            cache.sheet.flush();
        },
        sheet: cache.sheet,
        cache: cache,
        getRegisteredStyles: (0, $3Ao1t.getRegisteredStyles).bind(null, cache.registered),
        merge: $d82db08bf675d805$var$merge.bind(null, cache.registered, css)
    };
};
var $d82db08bf675d805$var$classnames = function classnames(args) {
    var cls = "";
    for(var i = 0; i < args.length; i++){
        var arg = args[i];
        if (arg == null) continue;
        var toAdd = void 0;
        switch(typeof arg){
            case "boolean":
                break;
            case "object":
                if (Array.isArray(arg)) toAdd = classnames(arg);
                else {
                    toAdd = "";
                    for(var k in arg)if (arg[k] && k) {
                        toAdd && (toAdd += " ");
                        toAdd += k;
                    }
                }
                break;
            default:
                toAdd = arg;
        }
        if (toAdd) {
            cls && (cls += " ");
            cls += toAdd;
        }
    }
    return cls;
};

});



parcelRegister("9fcOo", function(module, exports) {

$parcel$export(module.exports, "FlagHashes", function () { return $9efb37264c0957ea$export$7e727ddc41bdfc88; });
var $9efb37264c0957ea$export$7e727ddc41bdfc88;
(function(FlagHashes) {
    FlagHashes["VERIFIED"] = "#verified";
    FlagHashes["TSV_RECOVERY_CANCELED"] = "#tsvRecoveryCancelled";
    FlagHashes["TSV_REGENERATE_RECOVERY_CODE_SUCCESS"] = "#tsvRegenerateRecoveryCodeSuccess";
    FlagHashes["TSV_REGENERATE_RECOVERY_CODE_UNAUTHORIZED"] = "#tsvRegenerateRecoveryCodeUnauthorized";
    FlagHashes["TSV_ENROLLMENT_SUCCESS"] = "#tsvEnrollmentSuccess";
    FlagHashes["CHANGE_PASSWORD_SUCCESS"] = "#changePasswordSuccess";
})($9efb37264c0957ea$export$7e727ddc41bdfc88 || ($9efb37264c0957ea$export$7e727ddc41bdfc88 = {}));

});



parcelRegister("3B7Hp", function(module, exports) {

$parcel$export(module.exports, "getManageProfileAppRootPath", function () { return $0aaba3377c8248f8$export$da59f2572a591db8; });
$parcel$export(module.exports, "getWACLinks", function () { return $0aaba3377c8248f8$export$d49b6067c2a88089; });
function $0aaba3377c8248f8$export$da59f2572a591db8() {
    return "/manage-profile";
}
function $0aaba3377c8248f8$export$d49b6067c2a88089() {
    const wacHomePage = "https://www.atlassian.com";
    return {
        homePage: wacHomePage,
        products: `${wacHomePage}/software`,
        privacyPolicy: `${wacHomePage}/legal/privacy-policy`,
        userAgreement: `${wacHomePage}/end-user-agreement`,
        userNotice: `${wacHomePage}/legal/user-notice`,
        cloudTermsOfService: `${wacHomePage}/legal/cloud-terms-of-service`
    };
}

});

parcelRegister("3FJlW", function(module, exports) {

$parcel$export(module.exports, "UI_EVENT_TYPE", function () { return $2ac86194b4c279b9$export$a1562d08625f5d7e; });
$parcel$export(module.exports, "SCREEN_EVENT_TYPE", function () { return $2ac86194b4c279b9$export$f1d537d508d2945a; });
$parcel$export(module.exports, "OPERATIONAL_EVENT_TYPE", function () { return $2ac86194b4c279b9$export$12346a674644c156; });
// same types defined in analytics-web-client but avoid creating dependency with that
var $2ac86194b4c279b9$export$a1562d08625f5d7e = "ui";
var $2ac86194b4c279b9$export$947dac6c72b26f81 = "track";
var $2ac86194b4c279b9$export$f1d537d508d2945a = "screen";
var $2ac86194b4c279b9$export$12346a674644c156 = "operational";
var $2ac86194b4c279b9$export$b055de0e665cb20c = "unknown";

});

parcelRegister("1kknn", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3eb2993a427b2667a5277a7a906fec96>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0f7776fad9785a99$var$_react = $0f7776fad9785a99$var$_interopRequireDefault((parcelRequire("dAx5m")));

var $0f7776fad9785a99$var$_UNSAFE_baseNew = $0f7776fad9785a99$var$_interopRequireDefault((parcelRequire("iIloM")));
function $0f7776fad9785a99$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "ChevronDown".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for dropdown menus, selects, accordions, and expands.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0f7776fad9785a99$var$ChevronDownIcon = (props)=>/*#__PURE__*/ $0f7776fad9785a99$var$_react.default.createElement($0f7776fad9785a99$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M10.5 4.5 8.25 6.75 6 9 3.75 6.75 1.5 4.5"/>`,
        type: "utility"
    }, props));
$0f7776fad9785a99$var$ChevronDownIcon.displayName = "ChevronDownIcon";
var $0f7776fad9785a99$var$_default = module.exports.default = $0f7776fad9785a99$var$ChevronDownIcon;

});
parcelRegister("iIloM", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("4k43O")).default; });
$parcel$export(module.exports, "Icon", function () { return (parcelRequire("4k43O")).Icon; });

var $4k43O = parcelRequire("4k43O");

});
parcelRegister("4k43O", function(module, exports) {

$parcel$export(module.exports, "Icon", function () { return $325c2e04adc135d9$export$f04a61298a47a40f; });
$parcel$export(module.exports, "default", function () { return $325c2e04adc135d9$export$2e2bcd8739ae039; });
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $dAx5m = parcelRequire("dAx5m");

var $jVTBW = parcelRequire("jVTBW");

var $jAmv0 = parcelRequire("jAmv0");
/**
 * We are hiding this props from consumers as it's reserved
 * for use by Icon Tile.
 */ var $325c2e04adc135d9$var$commonSVGStyles = (0, $jVTBW.css)({
    overflow: "hidden",
    pointerEvents: "none",
    /**
   * Stop-color doesn't properly apply in chrome when the inherited/current color changes.
   * We have to initially set stop-color to inherit (either via DOM attribute or an initial CSS
   * rule) and then override it with currentColor for the color changes to be picked up.
   */ // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    stop: {
        stopColor: "currentColor"
    }
});
var $325c2e04adc135d9$var$svgStyles = (0, $jVTBW.css)({
    color: "currentColor",
    verticalAlign: "bottom"
});
var $325c2e04adc135d9$var$iconStyles = (0, $jVTBW.css)({
    display: "inline-block",
    boxSizing: "border-box",
    flexShrink: 0,
    lineHeight: 1,
    paddingInlineEnd: "var(--ds--button--new-icon-padding-end, 0)",
    paddingInlineStart: "var(--ds--button--new-icon-padding-start, 0)"
});
var $325c2e04adc135d9$var$utilityIconStyles = (0, $jVTBW.css)({
    lineHeight: "var(--ds-space-150, 12px)"
});
var $325c2e04adc135d9$var$scaleStyles = (0, $jVTBW.css)({
    width: "inherit",
    height: "inherit"
});
/**
 * For windows high contrast mode
 */ var $325c2e04adc135d9$var$baseHcmStyles = (0, $jVTBW.css)({
    "@media screen and (forced-colors: active)": {
        color: "CanvasText",
        filter: "grayscale(1)"
    }
});
var $325c2e04adc135d9$var$sizeMap = {
    scale: (0, $jVTBW.css)({
        width: "inherit",
        height: "inherit"
    }),
    utility: (0, $jVTBW.css)({
        width: "var(--ds-space-150, 12px)",
        height: "var(--ds-space-150, 12px)"
    }),
    none: (0, $jVTBW.css)({
        width: "var(--ds-space-200, 16px)",
        height: "var(--ds-space-200, 16px)"
    }),
    spacious: (0, $jVTBW.css)({
        width: "var(--ds-space-300, 24px)",
        height: "var(--ds-space-300, 24px)"
    })
};
var $325c2e04adc135d9$var$baseSizeMap = {
    global: 16,
    utility: 12
};
var $325c2e04adc135d9$export$f04a61298a47a40f = /*#__PURE__*/ (0, $dAx5m.memo)(function Icon(props) {
    var _ref = props, providedColor = _ref.color, _ref$spacing = _ref.spacing, providedSpacing = _ref$spacing === void 0 ? "none" : _ref$spacing, testId = _ref.testId, label = _ref.label, LEGACY_primaryColor = _ref.LEGACY_primaryColor, LEGACY_secondaryColor = _ref.LEGACY_secondaryColor, LEGACY_size = _ref.LEGACY_size, FallbackIcon = _ref.LEGACY_fallbackIcon, _ref$type = _ref.type, type = _ref$type === void 0 ? "global" : _ref$type, dangerouslySetGlyph = _ref.dangerouslySetGlyph, shouldScale = _ref.shouldScale, LEGACY_margin = _ref.LEGACY_margin;
    var fallbackColor = "var(--ds-icon, #44546F)";
    if ((0, $jAmv0.fg)("platform-design-system-new-icon-default-color") || (0, $jAmv0.fg)("platform-design-system-new-icon-default-color-2")) fallbackColor = "currentColor";
    var color = providedColor !== null && providedColor !== void 0 ? providedColor : fallbackColor;
    var dangerouslySetInnerHTML = dangerouslySetGlyph ? {
        __html: dangerouslySetGlyph
    } : undefined;
    // Fall back to old icon
    if (FallbackIcon && !(0, $jAmv0.fg)("platform.design-system-team.enable-new-icons")) // parse out unnecessary props
    return (0, $jVTBW.jsx)(FallbackIcon, {
        primaryColor: LEGACY_primaryColor !== null && LEGACY_primaryColor !== void 0 ? LEGACY_primaryColor : color,
        secondaryColor: LEGACY_secondaryColor,
        size: LEGACY_size,
        label: label,
        testId: testId,
        UNSAFE_margin: LEGACY_margin
    });
    // Utility icons don't have 'spacing' as a type, but in case it's provided, we default to 'none'
    var spacing = type === "utility" ? "none" : providedSpacing;
    var baseSize = $325c2e04adc135d9$var$baseSizeMap[type];
    var size = type === "utility" ? "utility" : shouldScale ? "scale" : spacing;
    var viewBoxPadding = spacing === "spacious" ? 4 : 0;
    var viewBoxSize = baseSize + 2 * viewBoxPadding;
    // Workaround for the transparency in our disabled icon token.
    // Because we have multiple strokes in icons, opacities overlap
    // This filter has an impact on render performance, but this is
    // acceptable as icons aren't commonly disabled en-masse
    var iconColor = color;
    if (dangerouslySetInnerHTML && color === "var(--ds-icon-disabled, #091E424F)") {
        dangerouslySetInnerHTML.__html = '\n<filter id="ds-newIconOpacityFilter">\n  <feFlood flood-color="var(--ds-icon-disabled)" />\n  <feComposite in2="SourceGraphic" operator="in" />\n</filter>\n<g filter="url(#ds-newIconOpacityFilter)">\n  '.concat(dangerouslySetInnerHTML.__html, "\n</g>");
        iconColor = "var(--ds-icon, #44546F)";
    }
    return (0, $jVTBW.jsx)("span", {
        "data-testid": testId,
        role: label ? "img" : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: {
            color: iconColor
        },
        css: [
            $325c2e04adc135d9$var$iconStyles,
            $325c2e04adc135d9$var$baseHcmStyles,
            shouldScale && $325c2e04adc135d9$var$scaleStyles,
            type === "utility" && $325c2e04adc135d9$var$utilityIconStyles
        ]
    }, (0, $jVTBW.jsx)("svg", {
        fill: "none",
        viewBox: "".concat(0 - viewBoxPadding, " ").concat(0 - viewBoxPadding, " ").concat(viewBoxSize, " ").concat(viewBoxSize),
        role: "presentation",
        css: [
            $325c2e04adc135d9$var$commonSVGStyles,
            $325c2e04adc135d9$var$svgStyles,
            $325c2e04adc135d9$var$sizeMap[size]
        ],
        dangerouslySetInnerHTML: dangerouslySetInnerHTML
    }));
});
var $325c2e04adc135d9$export$2e2bcd8739ae039 = $325c2e04adc135d9$export$f04a61298a47a40f;

});
parcelRegister("jAmv0", function(module, exports) {

$parcel$export(module.exports, "getBooleanFF", function () { return $e422d4f16e55818c$export$470e5c2be1411c89; });
$parcel$export(module.exports, "fg", function () { return $e422d4f16e55818c$export$b40ec24ac8275656; });

var $7Zhny = parcelRequire("7Zhny");
function $e422d4f16e55818c$export$ba05d765b8392e5e(flagResolver) {
    (0, $7Zhny.setBooleanResolver)(flagResolver);
}
function $e422d4f16e55818c$export$470e5c2be1411c89(name) {
    return (0, $7Zhny.resolveBooleanFlag)(name);
}
function $e422d4f16e55818c$export$b40ec24ac8275656(name) {
    return (0, $7Zhny.resolveBooleanFlag)(name);
}

});
parcelRegister("7Zhny", function(module, exports) {

$parcel$export(module.exports, "setBooleanResolver", function () { return $5d0bb60290ff3597$export$f2b591175b3e424c; });
$parcel$export(module.exports, "resolveBooleanFlag", function () { return $5d0bb60290ff3597$export$6333b6aff9fc6275; });

var $876WF = parcelRequire("876WF");

var $ahJoN = parcelRequire("ahJoN");
var $5d0bb60290ff3597$var$pkgName = "@atlaskit/platform-feature-flags";
var $5d0bb60290ff3597$export$7e41b1b2bdee3f98 = "__PLATFORM_FEATURE_FLAGS__";
var $5d0bb60290ff3597$var$hasProcessEnv = typeof $ahJoN !== "undefined" && typeof $ahJoN.env !== "undefined";
// FF global overrides can be configured by test runners or Storybook
var $5d0bb60290ff3597$var$ENV_ENABLE_PLATFORM_FF = $5d0bb60290ff3597$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
// STORYBOOK_ENABLE_PLATFORM_FF is included as storybook only allows env vars prefixed with STORYBOOK
// https://github.com/storybookjs/storybook/issues/12270
var $5d0bb60290ff3597$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF = $5d0bb60290ff3597$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
var $5d0bb60290ff3597$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE = $5d0bb60290ff3597$var$ENV_ENABLE_PLATFORM_FF || $5d0bb60290ff3597$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF;
var $5d0bb60290ff3597$var$DEFAULT_PFF_GLOBAL = {
    // In development mode we want to capture any feature flag checks that happen using the default resolver and log this result when the resolver is replaced.
    // This is because evaluating feature flags when the resolver/FF client is loaded asynchronously could cause unexpected issues.
    earlyResolvedFlags: new Map(),
    booleanResolver: function booleanResolver(flagKey) {
        var unresolvedFlagCount;
        return false;
    }
};
var $5d0bb60290ff3597$var$globalVar = typeof window !== "undefined" ? window : globalThis;
$5d0bb60290ff3597$var$globalVar[$5d0bb60290ff3597$export$7e41b1b2bdee3f98] = $5d0bb60290ff3597$var$globalVar[$5d0bb60290ff3597$export$7e41b1b2bdee3f98] || $5d0bb60290ff3597$var$DEFAULT_PFF_GLOBAL;
function $5d0bb60290ff3597$export$f2b591175b3e424c(resolver) {
    $5d0bb60290ff3597$var$globalVar[$5d0bb60290ff3597$export$7e41b1b2bdee3f98].booleanResolver = resolver;
    var _globalVar$PFF_GLOBAL;
}
function $5d0bb60290ff3597$export$6333b6aff9fc6275(flagKey) {
    if ($5d0bb60290ff3597$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE) {
        (0, $876WF.debug)('[%s]: The feature flags were enabled while running tests. The flag "%s" will be always enabled.', $5d0bb60290ff3597$var$pkgName, flagKey);
        return true;
    }
    try {
        var _globalVar$PFF_GLOBAL2;
        var result = (_globalVar$PFF_GLOBAL2 = $5d0bb60290ff3597$var$globalVar[$5d0bb60290ff3597$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL2 === void 0 ? void 0 : _globalVar$PFF_GLOBAL2.booleanResolver(flagKey);
        if (typeof result !== "boolean") {
            // eslint-disable-next-line no-console
            console.warn("".concat(flagKey, " resolved to a non-boolean value, returning false for safety"));
            return false;
        }
        return result;
    } catch (e) {
        return false;
    }
}

});
parcelRegister("876WF", function(module, exports) {

$parcel$export(module.exports, "debug", function () { return $5e845d59892c99c0$export$1c9f709888824e05; });
var $5e845d59892c99c0$var$_ref, $5e845d59892c99c0$var$_process, $5e845d59892c99c0$var$_process2;
// We can't rely on NODE_ENV === 'test' if its value is already configured by the consumer to some other value, so better to use JEST_WORKER_ID
// https://jestjs.io/docs/environment-variables#jest_worker_id
var $5e845d59892c99c0$var$TESTS_MODE = ($5e845d59892c99c0$var$_ref = (globalThis === null || globalThis === void 0 || ($5e845d59892c99c0$var$_process = globalThis.process) === null || $5e845d59892c99c0$var$_process === void 0 || ($5e845d59892c99c0$var$_process = $5e845d59892c99c0$var$_process.env) === null || $5e845d59892c99c0$var$_process === void 0 ? void 0 : $5e845d59892c99c0$var$_process.JEST_WORKER_ID) !== undefined, $5e845d59892c99c0$var$_ref !== void 0) ? $5e845d59892c99c0$var$_ref : false;
var $5e845d59892c99c0$var$DEBUG_MODE = !$5e845d59892c99c0$var$TESTS_MODE && (globalThis === null || globalThis === void 0 || ($5e845d59892c99c0$var$_process2 = globalThis.process) === null || $5e845d59892c99c0$var$_process2 === void 0 || ($5e845d59892c99c0$var$_process2 = $5e845d59892c99c0$var$_process2.env) === null || $5e845d59892c99c0$var$_process2 === void 0 ? void 0 : $5e845d59892c99c0$var$_process2.NODE_ENV) !== "production";
var $5e845d59892c99c0$export$1c9f709888824e05 = function debug() {
    var _console;
    if (!$5e845d59892c99c0$var$DEBUG_MODE) return;
    // eslint-disable-next-line no-console
    (_console = console).debug.apply(_console, arguments);
};

});






parcelRegister("hpAWv", function(module, exports) {

var $6J7ZY = parcelRequire("6J7ZY");
var $cad16d87668994fa$var$_typeof = $6J7ZY.default;
function $cad16d87668994fa$var$_regeneratorRuntime() {
    "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ 
    module.exports = $cad16d87668994fa$var$_regeneratorRuntime = function _regeneratorRuntime() {
        return e;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports;
    var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function(t, e, r) {
        t[e] = r.value;
    }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag";
    function define(t, e, r) {
        return Object.defineProperty(t, e, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }), t[e];
    }
    try {
        define({}, "");
    } catch (t) {
        define = function define(t, e, r) {
            return t[e] = r;
        };
    }
    function wrap(t, e, r, n) {
        var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []);
        return o(a, "_invoke", {
            value: makeInvokeMethod(t, r, c)
        }), a;
    }
    function tryCatch(t, e, r) {
        try {
            return {
                type: "normal",
                arg: t.call(e, r)
            };
        } catch (t) {
            return {
                type: "throw",
                arg: t
            };
        }
    }
    e.wrap = wrap;
    var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {};
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    var p = {};
    define(p, a, function() {
        return this;
    });
    var d = Object.getPrototypeOf, v = d && d(d(values([])));
    v && v !== r && n.call(v, a) && (p = v);
    var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
    function defineIteratorMethods(t) {
        [
            "next",
            "throw",
            "return"
        ].forEach(function(e) {
            define(t, e, function(t) {
                return this._invoke(e, t);
            });
        });
    }
    function AsyncIterator(t, e) {
        function invoke(r, o, i, a) {
            var c = tryCatch(t[r], t, o);
            if ("throw" !== c.type) {
                var u = c.arg, h = u.value;
                return h && "object" == $cad16d87668994fa$var$_typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function(t) {
                    invoke("next", t, i, a);
                }, function(t) {
                    invoke("throw", t, i, a);
                }) : e.resolve(h).then(function(t) {
                    u.value = t, i(u);
                }, function(t) {
                    return invoke("throw", t, i, a);
                });
            }
            a(c.arg);
        }
        var r;
        o(this, "_invoke", {
            value: function value(t, n) {
                function callInvokeWithMethodAndArg() {
                    return new e(function(e, r) {
                        invoke(t, n, e, r);
                    });
                }
                return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
            }
        });
    }
    function makeInvokeMethod(e, r, n) {
        var o = h;
        return function(i, a) {
            if (o === f) throw Error("Generator is already running");
            if (o === s) {
                if ("throw" === i) throw a;
                return {
                    value: t,
                    done: !0
                };
            }
            for(n.method = i, n.arg = a;;){
                var c = n.delegate;
                if (c) {
                    var u = maybeInvokeDelegate(c, n);
                    if (u) {
                        if (u === y) continue;
                        return u;
                    }
                }
                if ("next" === n.method) n.sent = n._sent = n.arg;
                else if ("throw" === n.method) {
                    if (o === h) throw o = s, n.arg;
                    n.dispatchException(n.arg);
                } else "return" === n.method && n.abrupt("return", n.arg);
                o = f;
                var p = tryCatch(e, r, n);
                if ("normal" === p.type) {
                    if (o = n.done ? s : l, p.arg === y) continue;
                    return {
                        value: p.arg,
                        done: n.done
                    };
                }
                "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
            }
        };
    }
    function maybeInvokeDelegate(e, r) {
        var n = r.method, o = e.iterator[n];
        if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
        var i = tryCatch(o, e.iterator, r.arg);
        if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
        var a = i.arg;
        return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
    }
    function pushTryEntry(t) {
        var e = {
            tryLoc: t[0]
        };
        1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
    }
    function resetTryEntry(t) {
        var e = t.completion || {};
        e.type = "normal", delete e.arg, t.completion = e;
    }
    function Context(t) {
        this.tryEntries = [
            {
                tryLoc: "root"
            }
        ], t.forEach(pushTryEntry, this), this.reset(!0);
    }
    function values(e) {
        if (e || "" === e) {
            var r = e[a];
            if (r) return r.call(e);
            if ("function" == typeof e.next) return e;
            if (!isNaN(e.length)) {
                var o = -1, i = function next() {
                    for(; ++o < e.length;)if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
                    return next.value = t, next.done = !0, next;
                };
                return i.next = i;
            }
        }
        throw new TypeError($cad16d87668994fa$var$_typeof(e) + " is not iterable");
    }
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
        value: GeneratorFunctionPrototype,
        configurable: !0
    }), o(GeneratorFunctionPrototype, "constructor", {
        value: GeneratorFunction,
        configurable: !0
    }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function(t) {
        var e = "function" == typeof t && t.constructor;
        return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
    }, e.mark = function(t) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
    }, e.awrap = function(t) {
        return {
            __await: t
        };
    }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function() {
        return this;
    }), e.AsyncIterator = AsyncIterator, e.async = function(t, r, n, o, i) {
        void 0 === i && (i = Promise);
        var a = new AsyncIterator(wrap(t, r, n, o), i);
        return e.isGeneratorFunction(r) ? a : a.next().then(function(t) {
            return t.done ? t.value : a.next();
        });
    }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function() {
        return this;
    }), define(g, "toString", function() {
        return "[object Generator]";
    }), e.keys = function(t) {
        var e = Object(t), r = [];
        for(var n in e)r.push(n);
        return r.reverse(), function next() {
            for(; r.length;){
                var t = r.pop();
                if (t in e) return next.value = t, next.done = !1, next;
            }
            return next.done = !0, next;
        };
    }, e.values = values, Context.prototype = {
        constructor: Context,
        reset: function reset(e) {
            if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for(var r in this)"t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
        },
        stop: function stop() {
            this.done = !0;
            var t = this.tryEntries[0].completion;
            if ("throw" === t.type) throw t.arg;
            return this.rval;
        },
        dispatchException: function dispatchException(e) {
            if (this.done) throw e;
            var r = this;
            function handle(n, o) {
                return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
            }
            for(var o = this.tryEntries.length - 1; o >= 0; --o){
                var i = this.tryEntries[o], a = i.completion;
                if ("root" === i.tryLoc) return handle("end");
                if (i.tryLoc <= this.prev) {
                    var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc");
                    if (c && u) {
                        if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                        if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
                    } else if (c) {
                        if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                    } else {
                        if (!u) throw Error("try statement without catch or finally");
                        if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
                    }
                }
            }
        },
        abrupt: function abrupt(t, e) {
            for(var r = this.tryEntries.length - 1; r >= 0; --r){
                var o = this.tryEntries[r];
                if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
                    var i = o;
                    break;
                }
            }
            i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
            var a = i ? i.completion : {};
            return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
        },
        complete: function complete(t, e) {
            if ("throw" === t.type) throw t.arg;
            return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
        },
        finish: function finish(t) {
            for(var e = this.tryEntries.length - 1; e >= 0; --e){
                var r = this.tryEntries[e];
                if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
            }
        },
        "catch": function _catch(t) {
            for(var e = this.tryEntries.length - 1; e >= 0; --e){
                var r = this.tryEntries[e];
                if (r.tryLoc === t) {
                    var n = r.completion;
                    if ("throw" === n.type) {
                        var o = n.arg;
                        resetTryEntry(r);
                    }
                    return o;
                }
            }
            throw Error("illegal catch attempt");
        },
        delegateYield: function delegateYield(e, r, n) {
            return this.delegate = {
                iterator: values(e),
                resultName: r,
                nextLoc: n
            }, "next" === this.method && (this.arg = t), y;
        }
    }, e;
}
module.exports = $cad16d87668994fa$var$_regeneratorRuntime, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("6J7ZY", function(module, exports) {
function $4e5d266899a410d6$var$_typeof(o) {
    "@babel/helpers - typeof";
    return module.exports = $4e5d266899a410d6$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $4e5d266899a410d6$var$_typeof(o);
}
module.exports = $4e5d266899a410d6$var$_typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("8u31q", function(module, exports) {

var $6aCUT = parcelRequire("6aCUT");
module.exports = $6aCUT("teKRo").then(()=>parcelRequire("7x24I"));

});

parcelRegister("lMEsk", function(module, exports) {

var $6aCUT = parcelRequire("6aCUT");
module.exports = $6aCUT("himkY").then(()=>parcelRequire("fpak5"));

});

parcelRegister("8h2kf", function(module, exports) {

var $6aCUT = parcelRequire("6aCUT");
module.exports = $6aCUT("3zKCj").then(()=>parcelRequire("kSXIq"));

});

parcelRegister("aBFrD", function(module, exports) {

var $6aCUT = parcelRequire("6aCUT");
module.exports = $6aCUT("4cmF1").then(()=>parcelRequire("1vQJk"));

});

parcelRegister("hEJhY", function(module, exports) {

var $6aCUT = parcelRequire("6aCUT");
module.exports = $6aCUT("2SaKZ").then(()=>parcelRequire("2y0Xr"));

});

parcelRegister("kOMMf", function(module, exports) {

var $6aCUT = parcelRequire("6aCUT");
module.exports = $6aCUT("bT05h").then(()=>parcelRequire("9OvzW"));

});

parcelRegister("6twDR", function(module, exports) {

var $6aCUT = parcelRequire("6aCUT");
module.exports = $6aCUT("57t5G").then(()=>parcelRequire("2egoF"));

});

parcelRegister("9EScH", function(module, exports) {

var $6aCUT = parcelRequire("6aCUT");
module.exports = $6aCUT("fRZqT").then(()=>parcelRequire("jEPTe"));

});

parcelRegister("B0V72", function(module, exports) {

var $6aCUT = parcelRequire("6aCUT");
module.exports = $6aCUT("3NtZz").then(()=>parcelRequire("hRZXx"));

});

parcelRegister("58rxg", function(module, exports) {

var $6aCUT = parcelRequire("6aCUT");
module.exports = $6aCUT("bGHX3").then(()=>parcelRequire("el9UR"));

});

parcelRegister("bt008", function(module, exports) {

var $6aCUT = parcelRequire("6aCUT");
module.exports = $6aCUT("ba6Zq").then(()=>parcelRequire("1J8aF"));

});

parcelRegister("4JghM", function(module, exports) {

var $6aCUT = parcelRequire("6aCUT");
module.exports = $6aCUT("8cK3C").then(()=>parcelRequire("1QV1A"));

});

parcelRegister("cYfKv", function(module, exports) {

var $6aCUT = parcelRequire("6aCUT");
module.exports = $6aCUT("2QB13").then(()=>parcelRequire("h2qJ5"));

});

parcelRegister("8J6nR", function(module, exports) {

var $6aCUT = parcelRequire("6aCUT");
module.exports = $6aCUT("bj69z").then(()=>parcelRequire("1UBXU"));

});

parcelRegister("4RDQH", function(module, exports) {

var $6aCUT = parcelRequire("6aCUT");
module.exports = $6aCUT("39HdJ").then(()=>parcelRequire("6kAxS"));

});

parcelRegister("lihf4", function(module, exports) {

var $6aCUT = parcelRequire("6aCUT");
module.exports = $6aCUT("a1g83").then(()=>parcelRequire("3K1pw"));

});

parcelRegister("afAPz", function(module, exports) {

var $6aCUT = parcelRequire("6aCUT");
module.exports = $6aCUT("cGyrT").then(()=>parcelRequire("9Z2Pl"));

});

parcelRegister("2BGl2", function(module, exports) {

var $6aCUT = parcelRequire("6aCUT");
module.exports = $6aCUT("dtcKq").then(()=>parcelRequire("dmzcM"));

});

parcelRegister("byplY", function(module, exports) {

var $6aCUT = parcelRequire("6aCUT");
module.exports = $6aCUT("9XYrv").then(()=>parcelRequire("cOSZR"));

});

parcelRegister("9JFVt", function(module, exports) {

var $6aCUT = parcelRequire("6aCUT");
module.exports = $6aCUT("8hFUj").then(()=>parcelRequire("By5Hs"));

});

parcelRegister("khJ4d", function(module, exports) {

var $6aCUT = parcelRequire("6aCUT");
module.exports = $6aCUT("goDBf").then(()=>parcelRequire("eZ4ER"));

});

parcelRegister("hs2Qn", function(module, exports) {

var $6aCUT = parcelRequire("6aCUT");
module.exports = $6aCUT("a6cHz").then(()=>parcelRequire("6o9Qh"));

});

parcelRegister("7p1Dq", function(module, exports) {

var $6aCUT = parcelRequire("6aCUT");
module.exports = $6aCUT("eIjF7").then(()=>parcelRequire("axKUd"));

});

parcelRegister("bRM5R", function(module, exports) {

var $6aCUT = parcelRequire("6aCUT");
module.exports = $6aCUT("dbjG1").then(()=>parcelRequire("aop52"));

});

parcelRegister("dOF23", function(module, exports) {

var $6aCUT = parcelRequire("6aCUT");
module.exports = $6aCUT("5OoDv").then(()=>parcelRequire("aqiGJ"));

});

parcelRegister("js7SL", function(module, exports) {

var $6aCUT = parcelRequire("6aCUT");
module.exports = $6aCUT("5Rt4z").then(()=>parcelRequire("lC1CO"));

});

parcelRegister("lunyD", function(module, exports) {

var $6aCUT = parcelRequire("6aCUT");
module.exports = $6aCUT("hMrRQ").then(()=>parcelRequire("9lWyc"));

});

parcelRegister("71avd", function(module, exports) {

var $6aCUT = parcelRequire("6aCUT");
module.exports = $6aCUT("fWPHE").then(()=>parcelRequire("bPBGc"));

});

parcelRegister("gfBBl", function(module, exports) {

var $6aCUT = parcelRequire("6aCUT");
module.exports = $6aCUT("4pQsL").then(()=>parcelRequire("kmIAR"));

});

parcelRegister("9QL9F", function(module, exports) {

var $6aCUT = parcelRequire("6aCUT");
module.exports = $6aCUT("6EJjG").then(()=>parcelRequire("bRoQG"));

});

parcelRegister("ixHD9", function(module, exports) {

var $6aCUT = parcelRequire("6aCUT");
module.exports = $6aCUT("9QhBO").then(()=>parcelRequire("hmCGL"));

});

parcelRegister("6y6dX", function(module, exports) {

var $6aCUT = parcelRequire("6aCUT");
module.exports = $6aCUT("cZGHO").then(()=>parcelRequire("isjQv"));

});

parcelRegister("cEcSp", function(module, exports) {

var $6aCUT = parcelRequire("6aCUT");
module.exports = $6aCUT("bp6jW").then(()=>parcelRequire("77oNg"));

});

parcelRegister("90epT", function(module, exports) {

var $6aCUT = parcelRequire("6aCUT");
module.exports = $6aCUT("2YViw").then(()=>parcelRequire("02srw"));

});

parcelRegister("deegU", function(module, exports) {

var $6aCUT = parcelRequire("6aCUT");
module.exports = $6aCUT("i91ub").then(()=>parcelRequire("hFom2"));

});

parcelRegister("5Sz54", function(module, exports) {

var $6aCUT = parcelRequire("6aCUT");
module.exports = $6aCUT("hCsfc").then(()=>parcelRequire("168We"));

});

parcelRegister("9lnnk", function(module, exports) {

var $6aCUT = parcelRequire("6aCUT");
module.exports = $6aCUT("b7les").then(()=>parcelRequire("lnIHz"));

});

parcelRegister("b0v1B", function(module, exports) {

var $6aCUT = parcelRequire("6aCUT");
module.exports = $6aCUT("fSGBx").then(()=>parcelRequire("dqPo8"));

});

parcelRegister("2chS9", function(module, exports) {

var $6aCUT = parcelRequire("6aCUT");
module.exports = $6aCUT("MHjmt").then(()=>parcelRequire("05576"));

});

parcelRegister("69bNn", function(module, exports) {

var $6aCUT = parcelRequire("6aCUT");
module.exports = $6aCUT("hJvsn").then(()=>parcelRequire("38L5o"));

});

parcelRegister("3pg1P", function(module, exports) {

var $6aCUT = parcelRequire("6aCUT");
module.exports = $6aCUT("3njHl").then(()=>parcelRequire("4q0GE"));

});

parcelRegister("7e3IE", function(module, exports) {

var $6aCUT = parcelRequire("6aCUT");
module.exports = $6aCUT("lpj2I").then(()=>parcelRequire("aFPQO"));

});

parcelRegister("bKBIG", function(module, exports) {

var $6aCUT = parcelRequire("6aCUT");
module.exports = $6aCUT("630Fh").then(()=>parcelRequire("cZ1ur"));

});

parcelRegister("8fyf0", function(module, exports) {

$parcel$export(module.exports, "GENERIC_ERROR_FLAG_ID", function () { return $8de3f619ff10c75a$export$2bf4c569057627f9; });
// All the common constants
const $8de3f619ff10c75a$export$2bf4c569057627f9 = "genericError";

});

parcelRegister("kDlRl", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::44f68a28e7579c1e69613bedc98a8120>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f05867f9bac6acf2$var$_react = $f05867f9bac6acf2$var$_interopRequireDefault((parcelRequire("dAx5m")));

var $f05867f9bac6acf2$var$_UNSAFE_baseNew = $f05867f9bac6acf2$var$_interopRequireDefault((parcelRequire("iSHhU")));
function $f05867f9bac6acf2$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "QuestionCircle".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: help, tip.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f05867f9bac6acf2$var$QuestionCircleIcon = (props)=>/*#__PURE__*/ $f05867f9bac6acf2$var$_react.default.createElement($f05867f9bac6acf2$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M6.25 6C6.25 5 7 4.25 8 4.25S9.75 5 9.75 6C9.75 7.5 8 7.5 8 8.75v.75M15.25 8A7.25 7.25 0 1 1 .75 8a7.25 7.25 0 0 1 14.5 0Z"/><path fill="currentcolor" d="M9 11.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0"/>`
    }, props));
$f05867f9bac6acf2$var$QuestionCircleIcon.displayName = "QuestionCircleIcon";
var $f05867f9bac6acf2$var$_default = module.exports.default = $f05867f9bac6acf2$var$QuestionCircleIcon;

});

parcelRegister("1xtOA", function(module, exports) {
function $11f0002838a29ceb$var$_classCallCheck(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
module.exports = $11f0002838a29ceb$var$_classCallCheck, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("kVYWy", function(module, exports) {

var $f21MR = parcelRequire("f21MR");
function $f3d867a041c361fe$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, $f21MR(o.key), o);
    }
}
function $f3d867a041c361fe$var$_createClass(e, r, t) {
    return r && $f3d867a041c361fe$var$_defineProperties(e.prototype, r), t && $f3d867a041c361fe$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}
module.exports = $f3d867a041c361fe$var$_createClass, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("f21MR", function(module, exports) {

var $5RAei = parcelRequire("5RAei");
var $af186dc9bf80408f$var$_typeof = $5RAei.default;

var $f2ugL = parcelRequire("f2ugL");
function $af186dc9bf80408f$var$toPropertyKey(t) {
    var i = $f2ugL(t, "string");
    return "symbol" == $af186dc9bf80408f$var$_typeof(i) ? i : i + "";
}
module.exports = $af186dc9bf80408f$var$toPropertyKey, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("5RAei", function(module, exports) {
function $444e016f66292535$var$_typeof(o) {
    "@babel/helpers - typeof";
    return module.exports = $444e016f66292535$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $444e016f66292535$var$_typeof(o);
}
module.exports = $444e016f66292535$var$_typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("f2ugL", function(module, exports) {

var $5RAei = parcelRequire("5RAei");
var $af2e85cb2a5e8458$var$_typeof = $5RAei.default;
function $af2e85cb2a5e8458$var$toPrimitive(t, r) {
    if ("object" != $af2e85cb2a5e8458$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $af2e85cb2a5e8458$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
module.exports = $af2e85cb2a5e8458$var$toPrimitive, module.exports.__esModule = true, module.exports["default"] = module.exports;

});



parcelRegister("c2AoJ", function(module, exports) {

var $5RAei = parcelRequire("5RAei");
var $8c41e7d1d3ffafdc$var$_typeof = $5RAei.default;

var $i1dk5 = parcelRequire("i1dk5");
function $8c41e7d1d3ffafdc$var$_possibleConstructorReturn(t, e) {
    if (e && ("object" == $8c41e7d1d3ffafdc$var$_typeof(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return $i1dk5(t);
}
module.exports = $8c41e7d1d3ffafdc$var$_possibleConstructorReturn, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("i1dk5", function(module, exports) {
function $03629f9b77b51149$var$_assertThisInitialized(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}
module.exports = $03629f9b77b51149$var$_assertThisInitialized, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("e3Gk1", function(module, exports) {
function $a3c22cbef5fd495e$var$_getPrototypeOf(t) {
    return module.exports = $a3c22cbef5fd495e$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $a3c22cbef5fd495e$var$_getPrototypeOf(t);
}
module.exports = $a3c22cbef5fd495e$var$_getPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("4huf8", function(module, exports) {

var $9jjbT = parcelRequire("9jjbT");
function $31e03599e12f16af$var$_inherits(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && $9jjbT(t, e);
}
module.exports = $31e03599e12f16af$var$_inherits, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("9jjbT", function(module, exports) {
function $6c74c647438d9130$var$_setPrototypeOf(t, e) {
    return module.exports = $6c74c647438d9130$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $6c74c647438d9130$var$_setPrototypeOf(t, e);
}
module.exports = $6c74c647438d9130$var$_setPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("9HWAT", function(module, exports) {

var $f21MR = parcelRequire("f21MR");
function $711594c47a5d015d$var$_defineProperty(e, r, t) {
    return (r = $f21MR(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
module.exports = $711594c47a5d015d$var$_defineProperty, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("2nkDG", function(module, exports) {

$parcel$export(module.exports, "UserPermissionProvider", function () { return $1badbd41715bb92c$export$ea5ef74fdb7fc4f8; });
$parcel$export(module.exports, "prefetchAll", function () { return $1badbd41715bb92c$export$aba5d6cf034db22e; });

var $kHOjI = parcelRequire("kHOjI");

var $t5UCS = parcelRequire("t5UCS");

var $jXZjr = parcelRequire("jXZjr");

var $gNMXn = parcelRequire("gNMXn");

var $9sDtc = parcelRequire("9sDtc");

var $bBsJG = parcelRequire("bBsJG");
// Permissions api
var $1badbd41715bb92c$var$fetchPermission = (0, $gNMXn.withCached)(function(_ref) {
    var cloudId = _ref.cloudId, permissionId = _ref.permissionId;
    return (0, $kHOjI.postJson)("/gateway/api/permissions/permitted", {
        permissionId: permissionId,
        resourceId: "ari:cloud:platform::site/".concat(cloudId)
    }).then(function(permission) {
        return permission.permitted;
    });
});
var $1badbd41715bb92c$export$ea5ef74fdb7fc4f8 = (0, $9sDtc.default)((0, $t5UCS.default)("permission", (0, $bBsJG.ExperienceMark).API_PERMISSIONS, $1badbd41715bb92c$var$fetchPermission, $1badbd41715bb92c$var$fetchPermission.cached), false);
var $1badbd41715bb92c$export$aba5d6cf034db22e = function prefetchAll(_ref2) {
    var cloudId = _ref2.cloudId;
    $1badbd41715bb92c$var$fetchPermission({
        cloudId: cloudId,
        permissionId: (0, $jXZjr.Permissions).MANAGE
    });
};
var $1badbd41715bb92c$export$ffe8c06b7e356699 = function resetAll() {
    $1badbd41715bb92c$var$fetchPermission.reset();
};

});
parcelRegister("kHOjI", function(module, exports) {

$parcel$export(module.exports, "fetchJson", function () { return $f12edab77295b29e$export$6d71b655afe1638d; });
$parcel$export(module.exports, "fetchJsonWithNetworkRetries", function () { return $f12edab77295b29e$export$16566b750080153d; });
$parcel$export(module.exports, "postJson", function () { return $f12edab77295b29e$export$c776284ef4b1209a; });

var $9HWAT = parcelRequire("9HWAT");

var $4nJ2c = parcelRequire("4nJ2c");

var $lUUgm = parcelRequire("lUUgm");

var $22ND8 = parcelRequire("22ND8");
function $f12edab77295b29e$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $f12edab77295b29e$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $f12edab77295b29e$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($9HWAT)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $f12edab77295b29e$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $f12edab77295b29e$var$extraJsonFromResponse = function extraJsonFromResponse(response) {
    if (response.ok) return response.json();
    throw new (0, $4nJ2c.FetchError)("Unable to fetch ".concat(response.url, " ").concat(response.status, " ").concat(response.statusText), response.status);
};
var $f12edab77295b29e$export$6d71b655afe1638d = function fetchJson(url, init) {
    return fetch(url, $f12edab77295b29e$var$_objectSpread($f12edab77295b29e$var$_objectSpread({
        credentials: "include"
    }, init), {}, {
        headers: $f12edab77295b29e$var$_objectSpread({
            "Atl-App-Switcher-Version": (0, $22ND8.default).packageVersion
        }, init === null || init === void 0 ? void 0 : init.headers)
    })).then($f12edab77295b29e$var$extraJsonFromResponse);
};
var $f12edab77295b29e$export$16566b750080153d = function fetchJsonWithNetworkRetries(url, retryConfig, init) {
    return (0, $lUUgm.retryOnException)(function() {
        return fetch(url, $f12edab77295b29e$var$_objectSpread($f12edab77295b29e$var$_objectSpread({
            credentials: "include"
        }, init), {}, {
            headers: $f12edab77295b29e$var$_objectSpread({
                "Atl-App-Switcher-Version": (0, $22ND8.default).packageVersion
            }, init === null || init === void 0 ? void 0 : init.headers)
        }));
    }, retryConfig).then($f12edab77295b29e$var$extraJsonFromResponse);
};
var $f12edab77295b29e$export$c776284ef4b1209a = function postJson(url, data) {
    return $f12edab77295b29e$export$6d71b655afe1638d(url, {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify(data)
    });
};

});
parcelRegister("4nJ2c", function(module, exports) {

$parcel$export(module.exports, "FETCH_ERROR_NAME", function () { return $330c3e52eaa20272$export$83179404a61b001a; });
$parcel$export(module.exports, "FetchError", function () { return $330c3e52eaa20272$export$26e841bcf1aeb894; });

var $1xtOA = parcelRequire("1xtOA");

var $kVYWy = parcelRequire("kVYWy");

var $c2AoJ = parcelRequire("c2AoJ");

var $e3Gk1 = parcelRequire("e3Gk1");

var $4huf8 = parcelRequire("4huf8");

var $kNSsc = parcelRequire("kNSsc");

var $9HWAT = parcelRequire("9HWAT");
function $330c3e52eaa20272$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($e3Gk1)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($c2AoJ)))(t, $330c3e52eaa20272$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($e3Gk1)))(t).constructor) : o.apply(t, e));
}
function $330c3e52eaa20272$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($330c3e52eaa20272$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $330c3e52eaa20272$export$83179404a61b001a = "FetchError";
var $330c3e52eaa20272$export$26e841bcf1aeb894 = /*#__PURE__*/ function(_Error) {
    function FetchError(message, status) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($1xtOA)))(this, FetchError);
        _this = $330c3e52eaa20272$var$_callSuper(this, FetchError, [
            message
        ]);
        (0, (/*@__PURE__*/$parcel$interopDefault($9HWAT)))(_this, "name", $330c3e52eaa20272$export$83179404a61b001a);
        _this.status = status;
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($4huf8)))(FetchError, _Error);
    return (0, (/*@__PURE__*/$parcel$interopDefault($kVYWy)))(FetchError, null, [
        {
            key: "isFetchError",
            value: function isFetchError(value) {
                return value instanceof FetchError;
            }
        }
    ]);
}(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($kNSsc)))(Error));

});
parcelRegister("kNSsc", function(module, exports) {

var $e3Gk1 = parcelRequire("e3Gk1");

var $9jjbT = parcelRequire("9jjbT");

var $hAbGK = parcelRequire("hAbGK");

var $1TRj2 = parcelRequire("1TRj2");
function $f2529fa80c591566$var$_wrapNativeSuper(t) {
    var r = "function" == typeof Map ? new Map() : void 0;
    return module.exports = $f2529fa80c591566$var$_wrapNativeSuper = function _wrapNativeSuper(t) {
        if (null === t || !$hAbGK(t)) return t;
        if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function");
        if (void 0 !== r) {
            if (r.has(t)) return r.get(t);
            r.set(t, Wrapper);
        }
        function Wrapper() {
            return $1TRj2(t, arguments, $e3Gk1(this).constructor);
        }
        return Wrapper.prototype = Object.create(t.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: !1,
                writable: !0,
                configurable: !0
            }
        }), $9jjbT(Wrapper, t);
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $f2529fa80c591566$var$_wrapNativeSuper(t);
}
module.exports = $f2529fa80c591566$var$_wrapNativeSuper, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("hAbGK", function(module, exports) {
function $cccedd8720bdfd27$var$_isNativeFunction(t) {
    try {
        return -1 !== Function.toString.call(t).indexOf("[native code]");
    } catch (n) {
        return "function" == typeof t;
    }
}
module.exports = $cccedd8720bdfd27$var$_isNativeFunction, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("1TRj2", function(module, exports) {

var $4pb2S = parcelRequire("4pb2S");

var $9jjbT = parcelRequire("9jjbT");
function $162446f88fd2628c$var$_construct(t, e, r) {
    if ($4pb2S()) return Reflect.construct.apply(null, arguments);
    var o = [
        null
    ];
    o.push.apply(o, e);
    var p = new (t.bind.apply(t, o))();
    return r && $9jjbT(p, r.prototype), p;
}
module.exports = $162446f88fd2628c$var$_construct, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("4pb2S", function(module, exports) {
function $335210988ac20b6a$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return (module.exports = $335210988ac20b6a$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports)();
}
module.exports = $335210988ac20b6a$var$_isNativeReflectConstruct, module.exports.__esModule = true, module.exports["default"] = module.exports;

});




parcelRegister("lUUgm", function(module, exports) {

$parcel$export(module.exports, "retryOnException", function () { return $ff4a78981f569d3a$export$1d94629c94e7a17f; });

var $6XUwN = parcelRequire("6XUwN");

var $cwdap = parcelRequire("cwdap");
var $ff4a78981f569d3a$export$5c069c93d2b7493f = function wait(ms) {
    return new Promise(function(resolve) {
        setTimeout(resolve, ms);
    });
};
var $ff4a78981f569d3a$export$1d94629c94e7a17f = /*#__PURE__*/ function() {
    var _ref = (0, (/*@__PURE__*/$parcel$interopDefault($6XUwN)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cwdap))).mark(function _callee(invokeOperation, config) {
        var nextMSInterval, error, retries;
        return (0, (/*@__PURE__*/$parcel$interopDefault($cwdap))).wrap(function _callee$(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    nextMSInterval = 0;
                    error = new Error("No calls made");
                    retries = config.intervalsMS.length;
                case 3:
                    if (!(nextMSInterval !== undefined)) {
                        _context.next = 22;
                        break;
                    }
                    _context.prev = 4;
                    if (!(nextMSInterval > 0)) {
                        _context.next = 9;
                        break;
                    }
                    _context.next = 8;
                    return $ff4a78981f569d3a$export$5c069c93d2b7493f(nextMSInterval);
                case 8:
                    if (config.onRetry) config.onRetry(error, retries - config.intervalsMS.length);
                case 9:
                    _context.next = 11;
                    return invokeOperation();
                case 11:
                    return _context.abrupt("return", _context.sent);
                case 14:
                    _context.prev = 14;
                    _context.t0 = _context["catch"](4);
                    error = _context.t0;
                    if (!(config.shouldRetryOnException && !config.shouldRetryOnException(error))) {
                        _context.next = 19;
                        break;
                    }
                    throw error;
                case 19:
                    nextMSInterval = config.intervalsMS.shift();
                case 20:
                    _context.next = 3;
                    break;
                case 22:
                    throw error;
                case 23:
                case "end":
                    return _context.stop();
            }
        }, _callee, null, [
            [
                4,
                14
            ]
        ]);
    }));
    return function retryOnException(_x, _x2) {
        return _ref.apply(this, arguments);
    };
}();

});
parcelRegister("6XUwN", function(module, exports) {
function $51241a069c9f8d28$var$asyncGeneratorStep(n, t, e, r, o, a, c) {
    try {
        var i = n[a](c), u = i.value;
    } catch (n) {
        return void e(n);
    }
    i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function $51241a069c9f8d28$var$_asyncToGenerator(n) {
    return function() {
        var t = this, e = arguments;
        return new Promise(function(r, o) {
            var a = n.apply(t, e);
            function _next(n) {
                $51241a069c9f8d28$var$asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
            }
            function _throw(n) {
                $51241a069c9f8d28$var$asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
            }
            _next(void 0);
        });
    };
}
module.exports = $51241a069c9f8d28$var$_asyncToGenerator, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("cwdap", function(module, exports) {
// TODO(Babel 8): Remove this file.

var $91d2afdc2e5ca952$var$runtime = (parcelRequire("eFn1h"))();
module.exports = $91d2afdc2e5ca952$var$runtime;
// Copied from https://github.com/facebook/regenerator/blob/main/packages/runtime/runtime.js#L736=
try {
    regeneratorRuntime = $91d2afdc2e5ca952$var$runtime;
} catch (accidentalStrictMode) {
    if (typeof globalThis === "object") globalThis.regeneratorRuntime = $91d2afdc2e5ca952$var$runtime;
    else Function("r", "regeneratorRuntime = r")($91d2afdc2e5ca952$var$runtime);
}

});
parcelRegister("eFn1h", function(module, exports) {

var $5RAei = parcelRequire("5RAei");
var $aad6c0404a60a938$var$_typeof = $5RAei.default;
function $aad6c0404a60a938$var$_regeneratorRuntime() {
    "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ 
    module.exports = $aad6c0404a60a938$var$_regeneratorRuntime = function _regeneratorRuntime() {
        return e;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports;
    var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function(t, e, r) {
        t[e] = r.value;
    }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag";
    function define(t, e, r) {
        return Object.defineProperty(t, e, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }), t[e];
    }
    try {
        define({}, "");
    } catch (t) {
        define = function define(t, e, r) {
            return t[e] = r;
        };
    }
    function wrap(t, e, r, n) {
        var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []);
        return o(a, "_invoke", {
            value: makeInvokeMethod(t, r, c)
        }), a;
    }
    function tryCatch(t, e, r) {
        try {
            return {
                type: "normal",
                arg: t.call(e, r)
            };
        } catch (t) {
            return {
                type: "throw",
                arg: t
            };
        }
    }
    e.wrap = wrap;
    var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {};
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    var p = {};
    define(p, a, function() {
        return this;
    });
    var d = Object.getPrototypeOf, v = d && d(d(values([])));
    v && v !== r && n.call(v, a) && (p = v);
    var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
    function defineIteratorMethods(t) {
        [
            "next",
            "throw",
            "return"
        ].forEach(function(e) {
            define(t, e, function(t) {
                return this._invoke(e, t);
            });
        });
    }
    function AsyncIterator(t, e) {
        function invoke(r, o, i, a) {
            var c = tryCatch(t[r], t, o);
            if ("throw" !== c.type) {
                var u = c.arg, h = u.value;
                return h && "object" == $aad6c0404a60a938$var$_typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function(t) {
                    invoke("next", t, i, a);
                }, function(t) {
                    invoke("throw", t, i, a);
                }) : e.resolve(h).then(function(t) {
                    u.value = t, i(u);
                }, function(t) {
                    return invoke("throw", t, i, a);
                });
            }
            a(c.arg);
        }
        var r;
        o(this, "_invoke", {
            value: function value(t, n) {
                function callInvokeWithMethodAndArg() {
                    return new e(function(e, r) {
                        invoke(t, n, e, r);
                    });
                }
                return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
            }
        });
    }
    function makeInvokeMethod(e, r, n) {
        var o = h;
        return function(i, a) {
            if (o === f) throw Error("Generator is already running");
            if (o === s) {
                if ("throw" === i) throw a;
                return {
                    value: t,
                    done: !0
                };
            }
            for(n.method = i, n.arg = a;;){
                var c = n.delegate;
                if (c) {
                    var u = maybeInvokeDelegate(c, n);
                    if (u) {
                        if (u === y) continue;
                        return u;
                    }
                }
                if ("next" === n.method) n.sent = n._sent = n.arg;
                else if ("throw" === n.method) {
                    if (o === h) throw o = s, n.arg;
                    n.dispatchException(n.arg);
                } else "return" === n.method && n.abrupt("return", n.arg);
                o = f;
                var p = tryCatch(e, r, n);
                if ("normal" === p.type) {
                    if (o = n.done ? s : l, p.arg === y) continue;
                    return {
                        value: p.arg,
                        done: n.done
                    };
                }
                "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
            }
        };
    }
    function maybeInvokeDelegate(e, r) {
        var n = r.method, o = e.iterator[n];
        if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
        var i = tryCatch(o, e.iterator, r.arg);
        if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
        var a = i.arg;
        return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
    }
    function pushTryEntry(t) {
        var e = {
            tryLoc: t[0]
        };
        1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
    }
    function resetTryEntry(t) {
        var e = t.completion || {};
        e.type = "normal", delete e.arg, t.completion = e;
    }
    function Context(t) {
        this.tryEntries = [
            {
                tryLoc: "root"
            }
        ], t.forEach(pushTryEntry, this), this.reset(!0);
    }
    function values(e) {
        if (e || "" === e) {
            var r = e[a];
            if (r) return r.call(e);
            if ("function" == typeof e.next) return e;
            if (!isNaN(e.length)) {
                var o = -1, i = function next() {
                    for(; ++o < e.length;)if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
                    return next.value = t, next.done = !0, next;
                };
                return i.next = i;
            }
        }
        throw new TypeError($aad6c0404a60a938$var$_typeof(e) + " is not iterable");
    }
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
        value: GeneratorFunctionPrototype,
        configurable: !0
    }), o(GeneratorFunctionPrototype, "constructor", {
        value: GeneratorFunction,
        configurable: !0
    }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function(t) {
        var e = "function" == typeof t && t.constructor;
        return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
    }, e.mark = function(t) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
    }, e.awrap = function(t) {
        return {
            __await: t
        };
    }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function() {
        return this;
    }), e.AsyncIterator = AsyncIterator, e.async = function(t, r, n, o, i) {
        void 0 === i && (i = Promise);
        var a = new AsyncIterator(wrap(t, r, n, o), i);
        return e.isGeneratorFunction(r) ? a : a.next().then(function(t) {
            return t.done ? t.value : a.next();
        });
    }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function() {
        return this;
    }), define(g, "toString", function() {
        return "[object Generator]";
    }), e.keys = function(t) {
        var e = Object(t), r = [];
        for(var n in e)r.push(n);
        return r.reverse(), function next() {
            for(; r.length;){
                var t = r.pop();
                if (t in e) return next.value = t, next.done = !1, next;
            }
            return next.done = !0, next;
        };
    }, e.values = values, Context.prototype = {
        constructor: Context,
        reset: function reset(e) {
            if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for(var r in this)"t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
        },
        stop: function stop() {
            this.done = !0;
            var t = this.tryEntries[0].completion;
            if ("throw" === t.type) throw t.arg;
            return this.rval;
        },
        dispatchException: function dispatchException(e) {
            if (this.done) throw e;
            var r = this;
            function handle(n, o) {
                return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
            }
            for(var o = this.tryEntries.length - 1; o >= 0; --o){
                var i = this.tryEntries[o], a = i.completion;
                if ("root" === i.tryLoc) return handle("end");
                if (i.tryLoc <= this.prev) {
                    var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc");
                    if (c && u) {
                        if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                        if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
                    } else if (c) {
                        if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                    } else {
                        if (!u) throw Error("try statement without catch or finally");
                        if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
                    }
                }
            }
        },
        abrupt: function abrupt(t, e) {
            for(var r = this.tryEntries.length - 1; r >= 0; --r){
                var o = this.tryEntries[r];
                if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
                    var i = o;
                    break;
                }
            }
            i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
            var a = i ? i.completion : {};
            return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
        },
        complete: function complete(t, e) {
            if ("throw" === t.type) throw t.arg;
            return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
        },
        finish: function finish(t) {
            for(var e = this.tryEntries.length - 1; e >= 0; --e){
                var r = this.tryEntries[e];
                if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
            }
        },
        "catch": function _catch(t) {
            for(var e = this.tryEntries.length - 1; e >= 0; --e){
                var r = this.tryEntries[e];
                if (r.tryLoc === t) {
                    var n = r.completion;
                    if ("throw" === n.type) {
                        var o = n.arg;
                        resetTryEntry(r);
                    }
                    return o;
                }
            }
            throw Error("illegal catch attempt");
        },
        delegateYield: function delegateYield(e, r, n) {
            return this.delegate = {
                iterator: values(e),
                resultName: r,
                nextLoc: n
            }, "next" === this.method && (this.arg = t), y;
        }
    }, e;
}
module.exports = $aad6c0404a60a938$var$_regeneratorRuntime, module.exports.__esModule = true, module.exports["default"] = module.exports;

});



parcelRegister("22ND8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $17d2443925cdb0cf$export$2e2bcd8739ae039; });
var $17d2443925cdb0cf$var$packageName = "@atlassian/switcher";
var $17d2443925cdb0cf$var$packageVersion = "35.22.4";
var $17d2443925cdb0cf$export$2e2bcd8739ae039 = {
    packageName: $17d2443925cdb0cf$var$packageName,
    packageVersion: $17d2443925cdb0cf$var$packageVersion
};

});


parcelRegister("t5UCS", function(module, exports) {

$parcel$export(module.exports, "Status", function () { return $05774b9ccaf621cd$export$96e9906d6d93a972; });
$parcel$export(module.exports, "isComplete", function () { return $05774b9ccaf621cd$export$9569565a7ac14e8e; });
$parcel$export(module.exports, "isError", function () { return $05774b9ccaf621cd$export$e6127cc7fe7395c3; });
$parcel$export(module.exports, "hasLoaded", function () { return $05774b9ccaf621cd$export$5fce62f50756dbf; });
$parcel$export(module.exports, "default", function () { return $05774b9ccaf621cd$export$2e2bcd8739ae039; });

var $ikhrG = parcelRequire("ikhrG");

var $1xtOA = parcelRequire("1xtOA");

var $kVYWy = parcelRequire("kVYWy");

var $c2AoJ = parcelRequire("c2AoJ");

var $e3Gk1 = parcelRequire("e3Gk1");

var $4huf8 = parcelRequire("4huf8");

var $9HWAT = parcelRequire("9HWAT");

var $dAx5m = parcelRequire("dAx5m");

var $5QmqT = parcelRequire("5QmqT");
var $3FJlW = parcelRequire("3FJlW");

var $kyTiB = parcelRequire("kyTiB");

var $eKOS7 = parcelRequire("eKOS7");

var $lUUgm = parcelRequire("lUUgm");

var $ijEo3 = parcelRequire("ijEo3");
var $05774b9ccaf621cd$var$_excluded = [
    "children"
];
function $05774b9ccaf621cd$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $05774b9ccaf621cd$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $05774b9ccaf621cd$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($9HWAT)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $05774b9ccaf621cd$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $05774b9ccaf621cd$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($e3Gk1)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($c2AoJ)))(t, $05774b9ccaf621cd$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($e3Gk1)))(t).constructor) : o.apply(t, e));
}
function $05774b9ccaf621cd$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($05774b9ccaf621cd$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $05774b9ccaf621cd$var$DATA_PROVIDER_SUBJECT = "atlassianSwitcherDataProvider";
var $05774b9ccaf621cd$export$96e9906d6d93a972 = /*#__PURE__*/ function(Status) {
    Status["LOADING"] = "loading";
    Status["COMPLETE"] = "complete";
    Status["ERROR"] = "error";
    return Status;
}({});
var $05774b9ccaf621cd$export$947ceca65da0e7a6 = function createResultComplete(data) {
    return {
        status: $05774b9ccaf621cd$export$96e9906d6d93a972.COMPLETE,
        data: data
    };
};
var $05774b9ccaf621cd$export$9569565a7ac14e8e = function isComplete(result) {
    return result.status === $05774b9ccaf621cd$export$96e9906d6d93a972.COMPLETE;
};
var $05774b9ccaf621cd$export$e6127cc7fe7395c3 = function isError(result) {
    return result.status === $05774b9ccaf621cd$export$96e9906d6d93a972.ERROR;
};
var $05774b9ccaf621cd$export$20bb0d907fbbe433 = function isLoading(result) {
    return result.status === $05774b9ccaf621cd$export$96e9906d6d93a972.LOADING;
};
var $05774b9ccaf621cd$export$5fce62f50756dbf = function hasLoaded(result) {
    return result.status !== $05774b9ccaf621cd$export$96e9906d6d93a972.LOADING;
};
function $05774b9ccaf621cd$export$2e2bcd8739ae039(name, experienceMark, mapPropsToPromise, mapPropsToInitialValue, retryConfig, shouldUpdate) {
    var getInitialState = function getInitialState(props) {
        if (mapPropsToInitialValue) {
            var initialValue = mapPropsToInitialValue(props);
            if (initialValue !== undefined) return {
                status: $05774b9ccaf621cd$export$96e9906d6d93a972.COMPLETE,
                data: initialValue
            };
        }
        return {
            status: $05774b9ccaf621cd$export$96e9906d6d93a972.LOADING,
            data: null
        };
    };
    var DataProvider = /*#__PURE__*/ function(_React$Component) {
        function DataProvider() {
            var _this;
            (0, (/*@__PURE__*/$parcel$interopDefault($1xtOA)))(this, DataProvider);
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            _this = $05774b9ccaf621cd$var$_callSuper(this, DataProvider, [].concat(args));
            (0, (/*@__PURE__*/$parcel$interopDefault($9HWAT)))(_this, "acceptResults", true);
            (0, (/*@__PURE__*/$parcel$interopDefault($9HWAT)))(_this, "state", getInitialState(_this.props.params));
            (0, (/*@__PURE__*/$parcel$interopDefault($9HWAT)))(_this, "fireOperationalEvent", function(payload) {
                if (_this.props.createAnalyticsEvent) _this.props.createAnalyticsEvent($05774b9ccaf621cd$var$_objectSpread($05774b9ccaf621cd$var$_objectSpread({
                    eventType: (0, $3FJlW.OPERATIONAL_EVENT_TYPE),
                    actionSubject: $05774b9ccaf621cd$var$DATA_PROVIDER_SUBJECT
                }, payload), {}, {
                    attributes: $05774b9ccaf621cd$var$_objectSpread($05774b9ccaf621cd$var$_objectSpread({}, payload.attributes), {}, {
                        outdated: !_this.acceptResults
                    })
                })).fire((0, $5QmqT.NAVIGATION_CHANNEL));
            });
            return _this;
        }
        (0, (/*@__PURE__*/$parcel$interopDefault($4huf8)))(DataProvider, _React$Component);
        return (0, (/*@__PURE__*/$parcel$interopDefault($kVYWy)))(DataProvider, [
            {
                key: "componentWillUnmount",
                value: function componentWillUnmount() {
                    /**
         * Promise resolved after component is unmounted to be ignored
         */ this.acceptResults = false;
                }
            },
            {
                key: "componentDidMount",
                value: function componentDidMount() {
                    this.props.experienceTracker.markStart(experienceMark);
                    this.fetchData();
                }
            },
            {
                key: "componentDidUpdate",
                value: function componentDidUpdate(prevProps) {
                    if (shouldUpdate !== null && shouldUpdate !== void 0 && shouldUpdate(prevProps.params, this.props.params)) this.fetchData();
                }
            },
            {
                key: "fetchData",
                value: function fetchData() {
                    var _this2 = this;
                    (0, $lUUgm.retryOnException)(function() {
                        return mapPropsToPromise(_this2.props.params);
                    }, {
                        intervalsMS: (retryConfig === null || retryConfig === void 0 ? void 0 : retryConfig.intervalsMS) || [],
                        shouldRetryOnException: retryConfig === null || retryConfig === void 0 ? void 0 : retryConfig.shouldRetryOnException,
                        onRetry: function onRetry(previousException, retryCount) {
                            _this2.onRetry(previousException, retryCount);
                        }
                    }).then(function(result) {
                        _this2.onResult(result);
                    }).catch(function(error) {
                        _this2.onError(error);
                    });
                }
            },
            {
                key: "onResult",
                value: function onResult(value) {
                    if (this.acceptResults) this.setState({
                        data: value,
                        status: $05774b9ccaf621cd$export$96e9906d6d93a972.COMPLETE
                    });
                    this.props.experienceTracker.markEnd(experienceMark);
                    this.fireOperationalEvent({
                        action: "receivedResult",
                        actionSubjectId: name,
                        attributes: {
                            provider: name
                        }
                    });
                }
            },
            {
                key: "onRetry",
                value: function onRetry(error, retryCount) {
                    this.fireOperationalEvent({
                        action: "retried",
                        actionSubjectId: name,
                        attributes: {
                            provider: name,
                            reason: retryConfig !== null && retryConfig !== void 0 && retryConfig.customErrorToReason ? retryConfig.customErrorToReason(error) : (0, $eKOS7.errorToReason)(error),
                            retryCount: retryCount
                        }
                    });
                }
            },
            {
                key: "onError",
                value: function onError(error) {
                    /**
         * Do not transition from "complete" state to "error"
         */ if (this.acceptResults && !$05774b9ccaf621cd$export$9569565a7ac14e8e(this.state)) this.setState({
                        error: error,
                        status: $05774b9ccaf621cd$export$96e9906d6d93a972.ERROR,
                        data: null
                    });
                    this.fireOperationalEvent({
                        action: "failed",
                        actionSubjectId: name,
                        attributes: {
                            provider: name,
                            reason: (0, $eKOS7.errorToReason)(error)
                        }
                    });
                }
            },
            {
                key: "render",
                value: function render() {
                    return this.props.children(this.state);
                }
            }
        ]);
    }((0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).Component); // In prefetch, we start with empty args {}, but when getting data from the cache in the data provider, extra args are injected by HOC withAnalyticsEvents and withExperienceTracker
    // This results in a cache miss due to a key mismatch.
    // The workaround here is to use a wrapper (OuterComponent) that passes the original props as a separate prop(params) to the underlying component(InnerComponent).
    // For more info: https://product-fabric.atlassian.net/browse/CXP-2697
    (0, (/*@__PURE__*/$parcel$interopDefault($9HWAT)))(DataProvider, "displayName", "DataProvider(".concat(name, ")"));
    var InnerComponent = (0, $kyTiB.default)()((0, $ijEo3.withExperienceTracker)(DataProvider));
    var OuterComponent = function OuterComponent(_ref) {
        var children = _ref.children, params = (0, (/*@__PURE__*/$parcel$interopDefault($ikhrG)))(_ref, $05774b9ccaf621cd$var$_excluded);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement(InnerComponent, {
            params: params
        }, children);
    };
    return OuterComponent;
}

});
parcelRegister("ikhrG", function(module, exports) {

var $dMXOD = parcelRequire("dMXOD");
function $d577a091fe70afe5$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $dMXOD(e, t);
    if (Object.getOwnPropertySymbols) {
        var s = Object.getOwnPropertySymbols(e);
        for(r = 0; r < s.length; r++)o = s[r], t.includes(o) || ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
module.exports = $d577a091fe70afe5$var$_objectWithoutProperties, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("dMXOD", function(module, exports) {
function $a09e283124ce68cc$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.includes(n)) continue;
        t[n] = r[n];
    }
    return t;
}
module.exports = $a09e283124ce68cc$var$_objectWithoutPropertiesLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("5QmqT", function(module, exports) {

$parcel$export(module.exports, "NAVIGATION_CHANNEL", function () { return $441335c4962a2a0d$export$515664faa1398f37; });
$parcel$export(module.exports, "SWITCHER_SUBJECT", function () { return $441335c4962a2a0d$export$17ff9c46e41eb585; });
$parcel$export(module.exports, "SWITCHER_ITEM_SUBJECT", function () { return $441335c4962a2a0d$export$7598b001981cfda5; });
$parcel$export(module.exports, "SWITCHER_ITEM_LOZENGES_SUBJECT", function () { return $441335c4962a2a0d$export$c3c93e13b09d3ad9; });
$parcel$export(module.exports, "SWITCHER_CHILD_ITEM_SUBJECT", function () { return $441335c4962a2a0d$export$7d4d527df0e3789c; });
$parcel$export(module.exports, "SWITCHER_ITEM_EXPAND_SUBJECT", function () { return $441335c4962a2a0d$export$16cf10618135eb24; });
$parcel$export(module.exports, "SWITCHER_COMPONENT", function () { return $441335c4962a2a0d$export$2b570fc112cbca; });
$parcel$export(module.exports, "SWITCHER_SOURCE", function () { return $441335c4962a2a0d$export$5ed36c4d23de5568; });
$parcel$export(module.exports, "TRIGGER_COMPONENT", function () { return $441335c4962a2a0d$export$8d2f933bbd9e4f09; });
$parcel$export(module.exports, "TRIGGER_SUBJECT", function () { return $441335c4962a2a0d$export$d7029a5dc66b0736; });
$parcel$export(module.exports, "SWITCHER_PARTIAL_RESULTS", function () { return $441335c4962a2a0d$export$4649adbfda1b6a66; });
$parcel$export(module.exports, "SWITCHER_ORG_ITEM", function () { return $441335c4962a2a0d$export$6dd696c9ad636a67; });
$parcel$export(module.exports, "SWITCHER_ORG_NAME_EXPAND_PANEL", function () { return $441335c4962a2a0d$export$53f2256589c0fa08; });
$parcel$export(module.exports, "SWITCHER_CURRENT_ORG", function () { return $441335c4962a2a0d$export$44c7ac3fdc1d62b8; });
$parcel$export(module.exports, "SWITCHER_ORG_LIST", function () { return $441335c4962a2a0d$export$d9d2f872f3b91169; });
$parcel$export(module.exports, "SWITCHER_JOINABLE_SITES", function () { return $441335c4962a2a0d$export$5724539c9b1a3a5d; });
$parcel$export(module.exports, "SWITCHER_AVAILABLE_PRODUCTS", function () { return $441335c4962a2a0d$export$22f5f827d9934254; });
$parcel$export(module.exports, "createAndFireNavigationEvent", function () { return $441335c4962a2a0d$export$884b1a4c7ac9dd14; });
$parcel$export(module.exports, "analyticsAttributes", function () { return $441335c4962a2a0d$export$a305f130b289b818; });
$parcel$export(module.exports, "withAnalyticsContextData", function () { return $441335c4962a2a0d$export$97ebdd8e7274f18a; });
$parcel$export(module.exports, "RenderTracker", function () { return $441335c4962a2a0d$export$e09ad93c2b74b853; });
$parcel$export(module.exports, "NotRenderedTracker", function () { return $441335c4962a2a0d$export$95b1f1a72cad0dcb; });
$parcel$export(module.exports, "ViewedTracker", function () { return $441335c4962a2a0d$export$b3fd6624b6a6d057; });
$parcel$export(module.exports, "getJoinableSitesRenderTracker", function () { return $441335c4962a2a0d$export$e823e937102b322b; });
$parcel$export(module.exports, "getCustomLinksRenderTracker", function () { return $441335c4962a2a0d$export$d75a4f56d85f67ea; });
$parcel$export(module.exports, "getItemAnalyticsContext", function () { return $441335c4962a2a0d$export$6489efba2ca85102; });
$parcel$export(module.exports, "withAnalyticsEvents", function () { return (parcelRequire("kyTiB")).default; });
$parcel$export(module.exports, "NavigationAnalyticsContext", function () { return (parcelRequire("i8FXL")).NavigationAnalyticsContext; });
$parcel$export(module.exports, "OPERATIONAL_EVENT_TYPE", function () { return (parcelRequire("3FJlW")).OPERATIONAL_EVENT_TYPE; });
$parcel$export(module.exports, "UI_EVENT_TYPE", function () { return (parcelRequire("3FJlW")).UI_EVENT_TYPE; });

var $1xtOA = parcelRequire("1xtOA");

var $kVYWy = parcelRequire("kVYWy");

var $c2AoJ = parcelRequire("c2AoJ");

var $e3Gk1 = parcelRequire("e3Gk1");

var $4huf8 = parcelRequire("4huf8");

var $9HWAT = parcelRequire("9HWAT");

var $dAx5m = parcelRequire("dAx5m");
parcelRequire("b7QJY");
var $i8FXL = parcelRequire("i8FXL");

var $lTPlV = parcelRequire("lTPlV");
var $kyTiB = parcelRequire("kyTiB");

var $3FJlW = parcelRequire("3FJlW");

var $t5UCS = parcelRequire("t5UCS");

var $kUnkQ = parcelRequire("kUnkQ");

var $clxoZ = parcelRequire("clxoZ");
function $441335c4962a2a0d$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($e3Gk1)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($c2AoJ)))(t, $441335c4962a2a0d$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($e3Gk1)))(t).constructor) : o.apply(t, e));
}
function $441335c4962a2a0d$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($441335c4962a2a0d$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $441335c4962a2a0d$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $441335c4962a2a0d$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $441335c4962a2a0d$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($9HWAT)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $441335c4962a2a0d$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $441335c4962a2a0d$export$515664faa1398f37 = "navigation";
var $441335c4962a2a0d$export$17ff9c46e41eb585 = "atlassianSwitcher";
var $441335c4962a2a0d$export$7598b001981cfda5 = "atlassianSwitcherItem";
var $441335c4962a2a0d$export$c3c93e13b09d3ad9 = "atlassianSwitcherItemLozenges";
var $441335c4962a2a0d$export$7d4d527df0e3789c = "atlassianSwitcherChildItem";
var $441335c4962a2a0d$export$16cf10618135eb24 = "atlassianSwitcherItemExpand";
var $441335c4962a2a0d$export$2b570fc112cbca = "atlassianSwitcher";
var $441335c4962a2a0d$export$5ed36c4d23de5568 = "atlassianSwitcher";
var $441335c4962a2a0d$export$8d2f933bbd9e4f09 = "atlassianSwitcherPrefetch";
var $441335c4962a2a0d$export$d7029a5dc66b0736 = "atlassianSwitcherPrefetch";
var $441335c4962a2a0d$export$4649adbfda1b6a66 = "atlassianSwitcherPartialResultError";
var $441335c4962a2a0d$export$6dd696c9ad636a67 = "atlassianSwitcherOrgItem";
var $441335c4962a2a0d$export$53f2256589c0fa08 = "atlassianSwitcherOrgNameExpandPanel";
var $441335c4962a2a0d$export$44c7ac3fdc1d62b8 = "atlassianSwitcherCurrentOrg";
var $441335c4962a2a0d$export$d9d2f872f3b91169 = "atlassianSwitcherOrganisationsList";
var $441335c4962a2a0d$export$5724539c9b1a3a5d = "atlassianSwitcherJoinableSites";
var $441335c4962a2a0d$export$22f5f827d9934254 = "atlassianSwitcherAvailableProducts";
var $441335c4962a2a0d$var$SWITCHER_CUSTOM_LINKS = "atlassianSwitcherCustomLinks";
var $441335c4962a2a0d$var$RENDERED_ACTION = "rendered";
var $441335c4962a2a0d$var$NOT_RENDERED_ACTION = "not_rendered";
var $441335c4962a2a0d$var$VIEWED_ACTION = "viewed";
var $441335c4962a2a0d$export$884b1a4c7ac9dd14 = (0, $lTPlV.default)($441335c4962a2a0d$export$515664faa1398f37);
var $441335c4962a2a0d$export$a305f130b289b818 = function analyticsAttributes(attributes) {
    return {
        attributes: attributes
    };
};
var $441335c4962a2a0d$export$97ebdd8e7274f18a = function withAnalyticsContextData(mapPropsToContext) {
    return function(WrappedComponent) {
        return function(props) {
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $i8FXL.NavigationAnalyticsContext), {
                data: mapPropsToContext(props)
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement(WrappedComponent, props));
        };
    };
};
var $441335c4962a2a0d$var$isValidDuration = function isValidDuration(duration) {
    return duration !== null && duration !== undefined && duration >= 0;
};
var $441335c4962a2a0d$export$e09ad93c2b74b853 = (0, $kyTiB.default)({
    onRender: function onRender(createAnalyticsEvent, props) {
        var _props$data;
        var duration = (_props$data = props.data) === null || _props$data === void 0 ? void 0 : _props$data.duration;
        return createAnalyticsEvent({
            eventType: (0, $3FJlW.OPERATIONAL_EVENT_TYPE),
            action: $441335c4962a2a0d$var$RENDERED_ACTION,
            actionSubject: props.subject,
            attributes: $441335c4962a2a0d$var$_objectSpread($441335c4962a2a0d$var$_objectSpread({}, props.data), $441335c4962a2a0d$var$isValidDuration(duration) && {
                bucket: (0, $clxoZ.getMetricBucket)(duration, (0, $clxoZ.RenderTrackerBuckets))
            })
        }).fire($441335c4962a2a0d$export$515664faa1398f37);
    }
})(/*#__PURE__*/ function(_React$Component) {
    function _class() {
        (0, (/*@__PURE__*/$parcel$interopDefault($1xtOA)))(this, _class);
        return $441335c4962a2a0d$var$_callSuper(this, _class, arguments);
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($4huf8)))(_class, _React$Component);
    return (0, (/*@__PURE__*/$parcel$interopDefault($kVYWy)))(_class, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.props.onRender();
            }
        },
        {
            key: "render",
            value: function render() {
                return null;
            }
        }
    ]);
}((0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).Component));
var $441335c4962a2a0d$export$95b1f1a72cad0dcb = (0, $kyTiB.default)({
    onRender: function onRender(createAnalyticsEvent, props) {
        return createAnalyticsEvent({
            eventType: (0, $3FJlW.OPERATIONAL_EVENT_TYPE),
            action: $441335c4962a2a0d$var$NOT_RENDERED_ACTION,
            actionSubject: props.subject,
            attributes: props.data
        }).fire($441335c4962a2a0d$export$515664faa1398f37);
    }
})(/*#__PURE__*/ function(_React$Component2) {
    function _class2() {
        (0, (/*@__PURE__*/$parcel$interopDefault($1xtOA)))(this, _class2);
        return $441335c4962a2a0d$var$_callSuper(this, _class2, arguments);
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($4huf8)))(_class2, _React$Component2);
    return (0, (/*@__PURE__*/$parcel$interopDefault($kVYWy)))(_class2, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.props.onRender();
            }
        },
        {
            key: "render",
            value: function render() {
                return null;
            }
        }
    ]);
}((0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).Component));
var $441335c4962a2a0d$export$b3fd6624b6a6d057 = (0, $kyTiB.default)({
    onRender: function onRender(createAnalyticsEvent, props) {
        return createAnalyticsEvent({
            eventType: (0, $3FJlW.UI_EVENT_TYPE),
            action: $441335c4962a2a0d$var$VIEWED_ACTION,
            actionSubject: props.subject,
            attributes: props.data
        }).fire($441335c4962a2a0d$export$515664faa1398f37);
    }
})(/*#__PURE__*/ function(_React$Component3) {
    function _class3() {
        (0, (/*@__PURE__*/$parcel$interopDefault($1xtOA)))(this, _class3);
        return $441335c4962a2a0d$var$_callSuper(this, _class3, arguments);
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($4huf8)))(_class3, _React$Component3);
    return (0, (/*@__PURE__*/$parcel$interopDefault($kVYWy)))(_class3, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.props.onRender();
            }
        },
        {
            key: "render",
            value: function render() {
                return null;
            }
        }
    ]);
}((0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).Component));
var $441335c4962a2a0d$var$renderTrackerWithReason = function renderTrackerWithReason(_ref) {
    var subject = _ref.subject, notRenderedReason = _ref.notRenderedReason, emptyRenderExpected = _ref.emptyRenderExpected, data = _ref.data;
    if (notRenderedReason) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement($441335c4962a2a0d$export$95b1f1a72cad0dcb, {
        subject: subject,
        data: $441335c4962a2a0d$var$_objectSpread($441335c4962a2a0d$var$_objectSpread({}, data), {}, {
            notRenderedReason: notRenderedReason
        })
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement($441335c4962a2a0d$export$e09ad93c2b74b853, {
        subject: subject,
        data: $441335c4962a2a0d$var$_objectSpread($441335c4962a2a0d$var$_objectSpread({}, data), {}, {
            emptyRender: emptyRenderExpected
        })
    });
};
var $441335c4962a2a0d$var$renderTracker = function renderTracker(_ref2) {
    var subject = _ref2.subject, providerFailed = _ref2.providerFailed, emptyRenderExpected = _ref2.emptyRenderExpected, linksRendered = _ref2.linksRendered, data = _ref2.data;
    if (providerFailed || linksRendered.length === 0 && !emptyRenderExpected) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement($441335c4962a2a0d$export$95b1f1a72cad0dcb, {
        subject: subject,
        data: $441335c4962a2a0d$var$_objectSpread($441335c4962a2a0d$var$_objectSpread({}, data), {}, {
            providerFailed: providerFailed
        })
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement($441335c4962a2a0d$export$e09ad93c2b74b853, {
        subject: subject,
        data: $441335c4962a2a0d$var$_objectSpread($441335c4962a2a0d$var$_objectSpread({}, data), {}, {
            emptyRender: emptyRenderExpected
        })
    });
};
var $441335c4962a2a0d$export$e823e937102b322b = function getJoinableSitesRenderTracker(providerResult, joinableSiteLinks, data) {
    if (!(0, $t5UCS.hasLoaded)(providerResult)) return null;
    if (providerResult.data && !providerResult.data.sites) return null;
    // The render is considered failed when either the provider failed, or the provider returned a non-empty result but nothing was rendered
    var emptyRenderExpected = Boolean(providerResult.data && providerResult.data.sites && providerResult.data.sites.length === 0);
    return $441335c4962a2a0d$var$renderTracker({
        subject: $441335c4962a2a0d$export$5724539c9b1a3a5d,
        providerFailed: providerResult.data === null,
        emptyRenderExpected: emptyRenderExpected,
        linksRendered: joinableSiteLinks,
        data: data
    });
};
var $441335c4962a2a0d$export$d75a4f56d85f67ea = function getCustomLinksRenderTracker(customLinksProviderResult, userSiteDataProviderResult, customLinks, data) {
    // The render is only considered failed when one of the providers failed, and empty render is a valid case
    if (!customLinksProviderResult) return;
    var emptyRenderExpected = customLinks.length === 0;
    function getNotRenderedReason() {
        if ((customLinksProviderResult === null || customLinksProviderResult === void 0 ? void 0 : customLinksProviderResult.status) === (0, $t5UCS.Status).ERROR) return "custom_links_api_error";
        var error = userSiteDataProviderResult.error;
        if (!error) return null;
        if (error instanceof (0, $kUnkQ.UserSiteDataError)) return error.reason;
        else return "usd_unknown";
    }
    var notRenderedReason = getNotRenderedReason();
    return $441335c4962a2a0d$var$renderTrackerWithReason({
        subject: $441335c4962a2a0d$var$SWITCHER_CUSTOM_LINKS,
        notRenderedReason: notRenderedReason,
        emptyRenderExpected: emptyRenderExpected,
        data: data
    });
};
var $441335c4962a2a0d$export$6489efba2ca85102 = function getItemAnalyticsContext(groupIndex, id, type, productType, extraAttributes) {
    return $441335c4962a2a0d$var$_objectSpread({}, $441335c4962a2a0d$export$a305f130b289b818($441335c4962a2a0d$var$_objectSpread({
        groupIndex: groupIndex,
        itemId: id,
        itemType: type,
        productType: productType
    }, extraAttributes)));
};

});
parcelRegister("b7QJY", function(module, exports) {

$parcel$export(module.exports, "NavigationAnalyticsContext", function () { return (parcelRequire("i8FXL")).NavigationAnalyticsContext; });

var $7g5Xl = parcelRequire("7g5Xl");

var $i8FXL = parcelRequire("i8FXL");

var $fuhsD = parcelRequire("fuhsD");

var $dYpxz = parcelRequire("dYpxz");

var $47bQk = parcelRequire("47bQk");

var $4YqRW = parcelRequire("4YqRW");

var $6ox3q = parcelRequire("6ox3q");

var $kxwGl = parcelRequire("kxwGl");

var $lgdDb = parcelRequire("lgdDb");

var $3i7ec = parcelRequire("3i7ec");

var $81qE4 = parcelRequire("81qE4");

var $eAv2c = parcelRequire("eAv2c");

var $eGGB9 = parcelRequire("eGGB9");

});
parcelRegister("7g5Xl", function(module, exports) {

var $loSda = parcelRequire("loSda");
var $548ea5ced59fdc38$export$80450e0a84a5ede9 = "fabricElementsCtx";
var $548ea5ced59fdc38$export$3fe25500478a635c = (0, $loSda.default)($548ea5ced59fdc38$export$80450e0a84a5ede9, "FabricElementsAnalyticsContext");

});
parcelRegister("loSda", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f945e41981955945$export$2e2bcd8739ae039; });

var $9HWAT = parcelRequire("9HWAT");

var $dAx5m = parcelRequire("dAx5m");

var $3oWGr = parcelRequire("3oWGr");
var $f945e41981955945$var$createNamespaceContext = function createNamespaceContext(namespace) {
    var displayName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "NamespacedContext";
    var Component = function Component(props) {
        var newData = (0, (/*@__PURE__*/$parcel$interopDefault($9HWAT)))({}, namespace, props.data);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $3oWGr.default), {
            data: newData
        }, (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).Children.only(props.children));
    };
    Component.displayName = displayName;
    return Component;
};
var $f945e41981955945$export$2e2bcd8739ae039 = $f945e41981955945$var$createNamespaceContext;

});
parcelRegister("3oWGr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $27a12250cc343550$export$2e2bcd8739ae039; });

var $dAx5m = parcelRequire("dAx5m");

var $18rB9 = parcelRequire("18rB9");

var $83Mdo = parcelRequire("83Mdo");

var $ll5IL = parcelRequire("ll5IL");

var $huLfc = parcelRequire("huLfc");
var $27a12250cc343550$var$ExportedAnalyticsContext = function ExportedAnalyticsContext(props) {
    var isModernContext = (0, $83Mdo.default) || (0, $18rB9.fg)("analytics-next-use-modern-context_jira");
    return isModernContext ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $huLfc.default), props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $ll5IL.default), props);
};
var $27a12250cc343550$export$2e2bcd8739ae039 = $27a12250cc343550$var$ExportedAnalyticsContext;

});
parcelRegister("83Mdo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5de4010f738e7cea$export$2e2bcd8739ae039; });

var $ahJoN = parcelRequire("ahJoN");
var $5de4010f738e7cea$var$_process$env;
var /// <reference types="node" />
$5de4010f738e7cea$export$2e2bcd8739ae039 = typeof $ahJoN !== "undefined" && $ahJoN !== null && (($5de4010f738e7cea$var$_process$env = {}, $5de4010f738e7cea$var$_process$env === void 0) ? void 0 : $5de4010f738e7cea$var$_process$env["ANALYTICS_NEXT_MODERN_CONTEXT"]);

});

parcelRegister("ll5IL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f88fff32203d7bc3$export$2e2bcd8739ae039; });

var $bd3Va = parcelRequire("bd3Va");

var $1xtOA = parcelRequire("1xtOA");

var $kVYWy = parcelRequire("kVYWy");

var $c2AoJ = parcelRequire("c2AoJ");

var $e3Gk1 = parcelRequire("e3Gk1");

var $4huf8 = parcelRequire("4huf8");

var $9HWAT = parcelRequire("9HWAT");

var $dAx5m = parcelRequire("dAx5m");

var $hyn2k = parcelRequire("hyn2k");

var $h0bf1 = parcelRequire("h0bf1");
function $f88fff32203d7bc3$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($e3Gk1)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($c2AoJ)))(t, $f88fff32203d7bc3$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($e3Gk1)))(t).constructor) : o.apply(t, e));
}
function $f88fff32203d7bc3$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($f88fff32203d7bc3$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $f88fff32203d7bc3$var$ContextTypes = {
    getAtlaskitAnalyticsContext: (0, (/*@__PURE__*/$parcel$interopDefault($hyn2k))).func,
    getAtlaskitAnalyticsEventHandlers: (0, (/*@__PURE__*/$parcel$interopDefault($hyn2k))).func
};
var $f88fff32203d7bc3$var$noop = function noop() {
    return [];
};
// eslint-disable-next-line @repo/internal/react/no-class-components
var $f88fff32203d7bc3$var$AnalyticsContext = /*#__PURE__*/ function(_Component) {
    function AnalyticsContext(props) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($1xtOA)))(this, AnalyticsContext);
        _this = $f88fff32203d7bc3$var$_callSuper(this, AnalyticsContext, [
            props
        ]);
        (0, (/*@__PURE__*/$parcel$interopDefault($9HWAT)))(_this, "getChildContext", function() {
            return {
                getAtlaskitAnalyticsContext: _this.getAnalyticsContext
            };
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($9HWAT)))(_this, "getAnalyticsContext", function() {
            var data = _this.props.data;
            var _this$context$getAtla = _this.context.getAtlaskitAnalyticsContext, getAtlaskitAnalyticsContext = _this$context$getAtla === void 0 ? $f88fff32203d7bc3$var$noop : _this$context$getAtla;
            return [].concat((0, (/*@__PURE__*/$parcel$interopDefault($bd3Va)))(getAtlaskitAnalyticsContext()), [
                data
            ]);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($9HWAT)))(_this, "getAnalyticsEventHandlers", function() {
            var _this$context$getAtla2 = _this.context.getAtlaskitAnalyticsEventHandlers, getAtlaskitAnalyticsEventHandlers = _this$context$getAtla2 === void 0 ? $f88fff32203d7bc3$var$noop : _this$context$getAtla2;
            return getAtlaskitAnalyticsEventHandlers();
        });
        _this.contextValue = {
            getAtlaskitAnalyticsContext: _this.getAnalyticsContext,
            getAtlaskitAnalyticsEventHandlers: _this.getAnalyticsEventHandlers
        };
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($4huf8)))(AnalyticsContext, _Component);
    return (0, (/*@__PURE__*/$parcel$interopDefault($kVYWy)))(AnalyticsContext, [
        {
            key: "render",
            value: function render() {
                var children = this.props.children;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $h0bf1.default).Provider, {
                    value: this.contextValue
                }, children);
            }
        }
    ]);
}((0, $dAx5m.Component));
(0, (/*@__PURE__*/$parcel$interopDefault($9HWAT)))($f88fff32203d7bc3$var$AnalyticsContext, "contextTypes", $f88fff32203d7bc3$var$ContextTypes);
(0, (/*@__PURE__*/$parcel$interopDefault($9HWAT)))($f88fff32203d7bc3$var$AnalyticsContext, "childContextTypes", $f88fff32203d7bc3$var$ContextTypes);
var $f88fff32203d7bc3$export$2e2bcd8739ae039 = $f88fff32203d7bc3$var$AnalyticsContext;

});
parcelRegister("bd3Va", function(module, exports) {

var $7kw6c = parcelRequire("7kw6c");

var $fTcUl = parcelRequire("fTcUl");

var $57wOj = parcelRequire("57wOj");

var $cfMrn = parcelRequire("cfMrn");
function $8293f34323175c79$var$_toConsumableArray(r) {
    return $7kw6c(r) || $fTcUl(r) || $57wOj(r) || $cfMrn();
}
module.exports = $8293f34323175c79$var$_toConsumableArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("7kw6c", function(module, exports) {

var $4Hw3L = parcelRequire("4Hw3L");
function $55634cdc19695b45$var$_arrayWithoutHoles(r) {
    if (Array.isArray(r)) return $4Hw3L(r);
}
module.exports = $55634cdc19695b45$var$_arrayWithoutHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("4Hw3L", function(module, exports) {
function $36c40bfe1af26e47$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
module.exports = $36c40bfe1af26e47$var$_arrayLikeToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("fTcUl", function(module, exports) {
function $b9160149bbcd31cd$var$_iterableToArray(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
module.exports = $b9160149bbcd31cd$var$_iterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("57wOj", function(module, exports) {

var $4Hw3L = parcelRequire("4Hw3L");
function $3ba70eb167c41b63$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $4Hw3L(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $4Hw3L(r, a) : void 0;
    }
}
module.exports = $3ba70eb167c41b63$var$_unsupportedIterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("cfMrn", function(module, exports) {
function $8ebc760d3e35e7d4$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
module.exports = $8ebc760d3e35e7d4$var$_nonIterableSpread, module.exports.__esModule = true, module.exports["default"] = module.exports;

});



parcelRegister("huLfc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cbc9e2bcd530ade9$export$2e2bcd8739ae039; });

var $bd3Va = parcelRequire("bd3Va");

var $dAx5m = parcelRequire("dAx5m");

var $h0bf1 = parcelRequire("h0bf1");

var $ev6z5 = parcelRequire("ev6z5");

var $kLAwr = parcelRequire("kLAwr");
var $cbc9e2bcd530ade9$var$AnalyticsContext = function AnalyticsContext(_ref) {
    var data = _ref.data, children = _ref.children;
    var dataRef = (0, $kLAwr.useTrackedRef)(data);
    var _useAnalyticsContext = (0, $ev6z5.useAnalyticsContext)(), getAtlaskitAnalyticsEventHandlers = _useAnalyticsContext.getAtlaskitAnalyticsEventHandlers, getOriginalAnalyticsContext = _useAnalyticsContext.getAtlaskitAnalyticsContext;
    var getAtlaskitAnalyticsContext = (0, $dAx5m.useCallback)(function() {
        return [].concat((0, (/*@__PURE__*/$parcel$interopDefault($bd3Va)))(getOriginalAnalyticsContext()), [
            dataRef.current
        ]);
    }, [
        getOriginalAnalyticsContext,
        dataRef
    ]);
    var value = (0, $dAx5m.useMemo)(function() {
        return {
            getAtlaskitAnalyticsContext: getAtlaskitAnalyticsContext,
            getAtlaskitAnalyticsEventHandlers: getAtlaskitAnalyticsEventHandlers
        };
    }, [
        getAtlaskitAnalyticsContext,
        getAtlaskitAnalyticsEventHandlers
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $h0bf1.default).Provider, {
        value: value
    }, children);
};
var $cbc9e2bcd530ade9$export$2e2bcd8739ae039 = $cbc9e2bcd530ade9$var$AnalyticsContext;

});
parcelRegister("ev6z5", function(module, exports) {

$parcel$export(module.exports, "useAnalyticsContext", function () { return $a8e90d9de2cee241$export$d1f587f82ad51c4; });

var $dAx5m = parcelRequire("dAx5m");

var $h0bf1 = parcelRequire("h0bf1");
var $a8e90d9de2cee241$export$d1f587f82ad51c4 = function useAnalyticsContext() {
    return (0, $dAx5m.useContext)((0, $h0bf1.default));
};

});

parcelRegister("kLAwr", function(module, exports) {

$parcel$export(module.exports, "useTrackedRef", function () { return $f1e486f73e2e75d7$export$1d27a74659855e44; });

var $dAx5m = parcelRequire("dAx5m");
var $f1e486f73e2e75d7$export$1d27a74659855e44 = function useTrackedRef(value) {
    var ref = (0, $dAx5m.useRef)(value);
    ref.current = value;
    return ref;
};

});





parcelRegister("i8FXL", function(module, exports) {

$parcel$export(module.exports, "NavigationAnalyticsContext", function () { return $d349864edad02171$export$d0a82da1a0b94929; });

var $loSda = parcelRequire("loSda");
var $d349864edad02171$export$1fd3aad76a7c6788 = "navigationCtx";
var $d349864edad02171$export$d0a82da1a0b94929 = (0, $loSda.default)($d349864edad02171$export$1fd3aad76a7c6788, "NavigationAnalyticsContext");

});

parcelRegister("fuhsD", function(module, exports) {

var $loSda = parcelRequire("loSda");
var $b46733b67b28b811$export$8c8f6d8f1fa796f0 = "fabricEditorCtx";
var $b46733b67b28b811$export$9eb2b47430ed3f7c = /*#__PURE__*/ function(EDITOR_APPEARANCE_CONTEXT) {
    EDITOR_APPEARANCE_CONTEXT["FIXED_WIDTH"] = "fixedWidth";
    EDITOR_APPEARANCE_CONTEXT["FULL_WIDTH"] = "fullWidth";
    EDITOR_APPEARANCE_CONTEXT["COMMENT"] = "comment";
    EDITOR_APPEARANCE_CONTEXT["CHROMELESS"] = "chromeless";
    EDITOR_APPEARANCE_CONTEXT["MOBILE"] = "mobile";
    return EDITOR_APPEARANCE_CONTEXT;
}({});
var $b46733b67b28b811$export$629cada6c5e621e1 = (0, $loSda.default)($b46733b67b28b811$export$8c8f6d8f1fa796f0, "FabricEditorAnalyticsContext");

});

parcelRegister("dYpxz", function(module, exports) {
// Media uses a namespaced analytics context under the following key MEDIA_CONTEXT.
var $a2c4b0bf19c9dabe$export$70df29c238ba7306 = "mediaCtx"; // However we don't export any JSX component to create that namespaced analytics context.
 // In media components, analytics context is being created by this component:
 // @see packages/media/media-common/src/analytics/withMediaAnalyticsContext.tsx

});

parcelRegister("47bQk", function(module, exports) {

var $loSda = parcelRequire("loSda");
var $2ff100ab36d92ee4$export$b326383bee6cb993 = "peopleTeamsCtx";
var $2ff100ab36d92ee4$export$4119ddb38ccbfb87 = (0, $loSda.default)($2ff100ab36d92ee4$export$b326383bee6cb993, "PeopleTeamsAnalyticsContext");

});

parcelRegister("4YqRW", function(module, exports) {

var $loSda = parcelRequire("loSda");
var $39f19ba72af50371$export$da1befb791e93c7e = "NotificationsCtx";
var $39f19ba72af50371$export$6f8e7ff1e3feafd7 = (0, $loSda.default)($39f19ba72af50371$export$da1befb791e93c7e, "NotificationsAnalyticsContext");

});

parcelRegister("6ox3q", function(module, exports) {

var $loSda = parcelRequire("loSda");
var $4a7e9fe030ad74dd$export$fc7a65795610cb71 = "RecentWorkCtx";
var $4a7e9fe030ad74dd$export$745926731087ebe2 = (0, $loSda.default)($4a7e9fe030ad74dd$export$fc7a65795610cb71, "RecentWorkAnalyticsContext");

});

parcelRegister("kxwGl", function(module, exports) {

var $loSda = parcelRequire("loSda");
var $ef403daaf2509b8e$export$4906017439f33fc0 = "atlasCtx";
var $ef403daaf2509b8e$export$43ebbe41370d4543 = (0, $loSda.default)($ef403daaf2509b8e$export$4906017439f33fc0, "AtlasAnalyticsContext");

});

parcelRegister("lgdDb", function(module, exports) {

var $loSda = parcelRequire("loSda");
var $f7a5aa6f6a3c3c7f$export$3240443bf2b83834 = "linkingPlatformCtx";
var $f7a5aa6f6a3c3c7f$export$6d568da622ce0a08 = (0, $loSda.default)($f7a5aa6f6a3c3c7f$export$3240443bf2b83834, "LinkingPlatformAnalyticsContext");

});

parcelRegister("3i7ec", function(module, exports) {

var $loSda = parcelRequire("loSda");
var $2658a8e1d2098b86$export$ef0c05448f0f8f9 = "postOfficeCtx";
var $2658a8e1d2098b86$export$dcd232f3be312f94 = (0, $loSda.default)($2658a8e1d2098b86$export$ef0c05448f0f8f9, "PostOfficeAnalyticsContext");

});

parcelRegister("81qE4", function(module, exports) {

var $loSda = parcelRequire("loSda");
var $5d7315e9d646da83$export$5c3a6fd8b96e8b66 = "aiMateCtx";
var $5d7315e9d646da83$export$de3826c30468da26 = (0, $loSda.default)($5d7315e9d646da83$export$5c3a6fd8b96e8b66, "AIMateAnalyticsContext");

});

parcelRegister("eAv2c", function(module, exports) {

var $loSda = parcelRequire("loSda");
var $a9ec8046f8666a67$export$c2a811a4e42f4af5 = "avpCtx";
var $a9ec8046f8666a67$export$da383e8879a25b03 = (0, $loSda.default)($a9ec8046f8666a67$export$c2a811a4e42f4af5, "AVPAnalyticsContext");

});

parcelRegister("eGGB9", function(module, exports) {

var $loSda = parcelRequire("loSda");
var $ab16080f2c0f15e9$export$82023f2f4bfb06c1 = "editionAwarenessCtx";
var $ab16080f2c0f15e9$export$84980182680018f = (0, $loSda.default)($ab16080f2c0f15e9$export$82023f2f4bfb06c1, "GrowthAnalyticsContext");

});


parcelRegister("lTPlV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ff16919bfc39e03d$export$2e2bcd8739ae039; });
var $ff16919bfc39e03d$export$2e2bcd8739ae039 = function(channel) {
    return function(payload) {
        return function(createAnalyticsEvent) {
            var consumerEvent = createAnalyticsEvent(payload);
            var clonedEvent = consumerEvent.clone();
            if (clonedEvent) clonedEvent.fire(channel);
            return consumerEvent;
        };
    };
};

});

parcelRegister("kyTiB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ef81e0db236b515b$export$2e2bcd8739ae039; });

var $lDu5G = parcelRequire("lDu5G");

var $dAx5m = parcelRequire("dAx5m");

var $cMzgg = parcelRequire("cMzgg");

var $4e1Ln = parcelRequire("4e1Ln");
var $ef81e0db236b515b$var$withAnalyticsEvents = function withAnalyticsEvents() {
    var createEventMap = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return function(WrappedComponent) {
        var WithAnalyticsEvents = /*#__PURE__*/ (0, $dAx5m.forwardRef)(function(props, ref) {
            var _usePatchedProps = (0, $4e1Ln.usePatchedProps)(createEventMap, props), patchedEventProps = _usePatchedProps.patchedEventProps;
            var _useAnalyticsEvents = (0, $cMzgg.useAnalyticsEvents)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement(WrappedComponent, (0, (/*@__PURE__*/$parcel$interopDefault($lDu5G)))({}, props, patchedEventProps, {
                createAnalyticsEvent: createAnalyticsEvent,
                ref: ref
            }));
        });
        WithAnalyticsEvents.displayName = "WithAnalyticsEvents(".concat(WrappedComponent.displayName || WrappedComponent.name, ")");
        return WithAnalyticsEvents;
    };
};
var $ef81e0db236b515b$export$2e2bcd8739ae039 = $ef81e0db236b515b$var$withAnalyticsEvents;

});
parcelRegister("lDu5G", function(module, exports) {
function $fc0494dc2dda696d$var$_extends() {
    return module.exports = $fc0494dc2dda696d$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $fc0494dc2dda696d$var$_extends.apply(null, arguments);
}
module.exports = $fc0494dc2dda696d$var$_extends, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("cMzgg", function(module, exports) {

$parcel$export(module.exports, "useAnalyticsEvents", function () { return $94e551de6f514be8$export$5bf35293e545f20c; });

var $tWuif = parcelRequire("tWuif");

var $9zSOH = parcelRequire("9zSOH");

var $ev6z5 = parcelRequire("ev6z5");
function $94e551de6f514be8$export$5bf35293e545f20c() {
    var analyticsContext = (0, $ev6z5.useAnalyticsContext)();
    var createAnalyticsEvent = (0, $tWuif.useCallbackOne)(function(payload) {
        return new (0, $9zSOH.default)({
            context: analyticsContext.getAtlaskitAnalyticsContext(),
            handlers: analyticsContext.getAtlaskitAnalyticsEventHandlers(),
            payload: payload
        });
    }, [
        analyticsContext
    ]);
    return {
        createAnalyticsEvent: createAnalyticsEvent
    };
}

});
parcelRegister("9zSOH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6f91e7693abf9f25$export$2e2bcd8739ae039; });

var $bd3Va = parcelRequire("bd3Va");

var $1xtOA = parcelRequire("1xtOA");

var $kVYWy = parcelRequire("kVYWy");

var $c2AoJ = parcelRequire("c2AoJ");

var $e3Gk1 = parcelRequire("e3Gk1");

var $bDWhs = parcelRequire("bDWhs");

var $4huf8 = parcelRequire("4huf8");

var $9HWAT = parcelRequire("9HWAT");

var $aEYHl = parcelRequire("aEYHl");
function $6f91e7693abf9f25$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($e3Gk1)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($c2AoJ)))(t, $6f91e7693abf9f25$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($e3Gk1)))(t).constructor) : o.apply(t, e));
}
function $6f91e7693abf9f25$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($6f91e7693abf9f25$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $6f91e7693abf9f25$var$_superPropGet(t, o, e, r) {
    var p = (0, (/*@__PURE__*/$parcel$interopDefault($bDWhs)))((0, (/*@__PURE__*/$parcel$interopDefault($e3Gk1)))(1 & r ? t.prototype : t), o, e);
    return 2 & r && "function" == typeof p ? function(t) {
        return p.apply(e, t);
    } : p;
}
var $6f91e7693abf9f25$export$35f8383928ba8d7 = function isUIAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $6f91e7693abf9f25$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isUIAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === "UIAnalyticsEvent";
};
var $6f91e7693abf9f25$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_AnalyticsEvent) {
    function UIAnalyticsEvent(props) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($1xtOA)))(this, UIAnalyticsEvent);
        _this = $6f91e7693abf9f25$var$_callSuper(this, UIAnalyticsEvent, [
            props
        ]);
        (0, (/*@__PURE__*/$parcel$interopDefault($9HWAT)))(_this, "_isUIAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($9HWAT)))(_this, "clone", function() {
            if (_this.hasFired) return null;
            var context = (0, (/*@__PURE__*/$parcel$interopDefault($bd3Va)))(_this.context);
            var handlers = (0, (/*@__PURE__*/$parcel$interopDefault($bd3Va)))(_this.handlers);
            /**
       * A hacky "deep clone" of the object. This is limited in that it wont
       * support functions, regexs, Maps, Sets, etc, but none of those need to
       * be represented in our payload.
       */ var payload = JSON.parse(JSON.stringify(_this.payload));
            return new UIAnalyticsEvent({
                context: context,
                handlers: handlers,
                payload: payload
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($9HWAT)))(_this, "fire", function(channel) {
            if (_this.hasFired) return;
            _this.handlers.forEach(function(handler) {
                return handler(_this, channel);
            });
            _this.hasFired = true;
        });
        _this.context = props.context || [];
        _this.handlers = props.handlers || [];
        _this.hasFired = false;
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($4huf8)))(UIAnalyticsEvent, _AnalyticsEvent);
    return (0, (/*@__PURE__*/$parcel$interopDefault($kVYWy)))(UIAnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (this.hasFired) return this;
                return $6f91e7693abf9f25$var$_superPropGet(UIAnalyticsEvent, "update", this, 3)([
                    updater
                ]);
            }
        }
    ]);
}((0, $aEYHl.default));

});
parcelRegister("bDWhs", function(module, exports) {

var $aEJBJ = parcelRequire("aEJBJ");
function $87a08b86f2fc8c2d$var$_get() {
    return module.exports = $87a08b86f2fc8c2d$var$_get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function(e, t, r) {
        var p = $aEJBJ(e, t);
        if (p) {
            var n = Object.getOwnPropertyDescriptor(p, t);
            return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value;
        }
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $87a08b86f2fc8c2d$var$_get.apply(null, arguments);
}
module.exports = $87a08b86f2fc8c2d$var$_get, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("aEJBJ", function(module, exports) {

var $e3Gk1 = parcelRequire("e3Gk1");
function $7c210482f24fd6ed$var$_superPropBase(t, o) {
    for(; !({}).hasOwnProperty.call(t, o) && null !== (t = $e3Gk1(t)););
    return t;
}
module.exports = $7c210482f24fd6ed$var$_superPropBase, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("aEYHl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7c2cb92dda2ef5fd$export$2e2bcd8739ae039; });

var $5RAei = parcelRequire("5RAei");

var $1xtOA = parcelRequire("1xtOA");

var $kVYWy = parcelRequire("kVYWy");

var $9HWAT = parcelRequire("9HWAT");
function $7c2cb92dda2ef5fd$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $7c2cb92dda2ef5fd$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $7c2cb92dda2ef5fd$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($9HWAT)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $7c2cb92dda2ef5fd$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $7c2cb92dda2ef5fd$export$ad4be5c2ec28cecf = function isAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $7c2cb92dda2ef5fd$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === "AnalyticsEvent";
};
var $7c2cb92dda2ef5fd$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function AnalyticsEvent(props) {
        var _this = this;
        (0, (/*@__PURE__*/$parcel$interopDefault($1xtOA)))(this, AnalyticsEvent);
        (0, (/*@__PURE__*/$parcel$interopDefault($9HWAT)))(this, "_isAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($9HWAT)))(this, "clone", function() {
            // just a shallow clone, don't change sub refs unless you want to
            // affect the original's too
            var payload = $7c2cb92dda2ef5fd$var$_objectSpread({}, _this.payload);
            return new AnalyticsEvent({
                payload: payload
            });
        });
        this.payload = props.payload;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($kVYWy)))(AnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (typeof updater === "function") this.payload = updater(this.payload);
                if ((0, (/*@__PURE__*/$parcel$interopDefault($5RAei)))(updater) === "object") this.payload = $7c2cb92dda2ef5fd$var$_objectSpread($7c2cb92dda2ef5fd$var$_objectSpread({}, this.payload), updater);
                return this;
            }
        }
    ]);
}();

});



parcelRegister("4e1Ln", function(module, exports) {

$parcel$export(module.exports, "usePatchedProps", function () { return $3139d65aa48519d6$export$9ebb5a84d17e5d18; });

var $9HWAT = parcelRequire("9HWAT");

var $5RAei = parcelRequire("5RAei");

var $dAx5m = parcelRequire("dAx5m");

var $cMzgg = parcelRequire("cMzgg");
function $3139d65aa48519d6$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $3139d65aa48519d6$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $3139d65aa48519d6$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($9HWAT)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $3139d65aa48519d6$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $3139d65aa48519d6$export$9ebb5a84d17e5d18() {
    var createEventMap = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var wrappedComponentProps = arguments.length > 1 ? arguments[1] : undefined;
    var _useAnalyticsEvents = (0, $cMzgg.useAnalyticsEvents)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    var handlerCache = (0, $dAx5m.useRef)({});
    var patchedProps = (0, $dAx5m.useMemo)(function() {
        var cache = handlerCache.current;
        // Clean up no longer used handlers in cache
        Object.keys(cache).filter(function(key) {
            return !(key in createEventMap);
        }).forEach(function(key) {
            return delete cache[key];
        });
        return Object.keys(createEventMap).reduce(function(p, k) {
            var eventCreator = createEventMap[k];
            if (![
                "object",
                "function"
            ].includes((0, (/*@__PURE__*/$parcel$interopDefault($5RAei)))(eventCreator))) return p;
            var propValue = wrappedComponentProps[k];
            if (k in cache && cache[k].eventCreator === eventCreator && cache[k].propValue === propValue) return $3139d65aa48519d6$var$_objectSpread($3139d65aa48519d6$var$_objectSpread({}, p), {}, (0, (/*@__PURE__*/$parcel$interopDefault($9HWAT)))({}, k, cache[k].wrappedCallback));
            var wrappedCallback = function wrappedCallback() {
                var analyticsEvent = typeof eventCreator === "function" ? eventCreator(createAnalyticsEvent, wrappedComponentProps) : createAnalyticsEvent(eventCreator);
                if (propValue && typeof propValue === "function") {
                    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                    propValue.apply(void 0, args.concat([
                        analyticsEvent
                    ]));
                }
            };
            cache[k] = {
                eventCreator: eventCreator,
                wrappedCallback: wrappedCallback,
                propValue: propValue
            };
            return $3139d65aa48519d6$var$_objectSpread($3139d65aa48519d6$var$_objectSpread({}, p), {}, (0, (/*@__PURE__*/$parcel$interopDefault($9HWAT)))({}, k, wrappedCallback));
        }, {});
    }, [
        createEventMap,
        wrappedComponentProps,
        createAnalyticsEvent,
        handlerCache
    ]);
    return {
        patchedEventProps: patchedProps
    };
}

});


parcelRegister("kUnkQ", function(module, exports) {

$parcel$export(module.exports, "UserSiteDataErrorReason", function () { return $f38b2378c66450fc$export$b08600051ba52198; });
$parcel$export(module.exports, "UserSiteDataError", function () { return $f38b2378c66450fc$export$c460344055e97b1; });

var $kVYWy = parcelRequire("kVYWy");

var $1xtOA = parcelRequire("1xtOA");

var $c2AoJ = parcelRequire("c2AoJ");

var $e3Gk1 = parcelRequire("e3Gk1");

var $4huf8 = parcelRequire("4huf8");

var $kNSsc = parcelRequire("kNSsc");
function $f38b2378c66450fc$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($e3Gk1)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($c2AoJ)))(t, $f38b2378c66450fc$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($e3Gk1)))(t).constructor) : o.apply(t, e));
}
function $f38b2378c66450fc$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($f38b2378c66450fc$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $f38b2378c66450fc$export$b08600051ba52198 = /*#__PURE__*/ function(UserSiteDataErrorReason) {
    UserSiteDataErrorReason["APS_NO_SITE_MATCH"] = "aps_no_site_match";
    UserSiteDataErrorReason["APS_EMPTY_RESULT"] = "aps_empty_result";
    UserSiteDataErrorReason["APS_PARTIAL_EMPTY_RESULT"] = "aps_partial_response_empty_result";
    return UserSiteDataErrorReason;
}({});
var $f38b2378c66450fc$export$c460344055e97b1 = /*#__PURE__*/ function(_Error) {
    function UserSiteDataError(reason, message) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($1xtOA)))(this, UserSiteDataError);
        _this = $f38b2378c66450fc$var$_callSuper(this, UserSiteDataError, [
            message
        ]);
        _this.name = "UserSiteDataError";
        _this.reason = reason;
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($4huf8)))(UserSiteDataError, _Error);
    return (0, (/*@__PURE__*/$parcel$interopDefault($kVYWy)))(UserSiteDataError);
}(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($kNSsc)))(Error));

});

parcelRegister("clxoZ", function(module, exports) {

$parcel$export(module.exports, "RenderTrackerBuckets", function () { return $8fd15b2b7caf6227$export$e59c24bc0768d568; });
$parcel$export(module.exports, "getMetricBucket", function () { return $8fd15b2b7caf6227$export$b59492d26971ae92; });
var $8fd15b2b7caf6227$var$INFINITY = "+Inf";
var $8fd15b2b7caf6227$export$e59c24bc0768d568 = [
    1000,
    900,
    800,
    700,
    600,
    500
];
var $8fd15b2b7caf6227$export$b59492d26971ae92 = function getMetricBucket(metricValue, buckets) {
    return metricValue >= 0 ? buckets.reduce(function(lowestBucket, currentBucket) {
        return metricValue <= currentBucket ? currentBucket.toString() : lowestBucket.toString();
    }, $8fd15b2b7caf6227$var$INFINITY) : null;
};

});


parcelRegister("eKOS7", function(module, exports) {

$parcel$export(module.exports, "errorToReason", function () { return $abdcd2a40704d83a$export$a3e288208721751b; });
function $abdcd2a40704d83a$export$a3e288208721751b(error) {
    var _ref = error || {}, _ref$name = _ref.name, name = _ref$name === void 0 ? "Unknown" : _ref$name, _ref$status = _ref.status, status = _ref$status === void 0 ? undefined : _ref$status;
    return {
        name: name,
        status: status
    };
}

});

parcelRegister("ijEo3", function(module, exports) {

$parcel$export(module.exports, "SwitcherExperienceTrackerContext", function () { return $d559545a6fcaeb83$export$3f3eebb4b8116461; });
$parcel$export(module.exports, "useExperienceTracker", function () { return $d559545a6fcaeb83$export$cdefb2a8b53f879f; });
$parcel$export(module.exports, "withExperienceTracker", function () { return $d559545a6fcaeb83$export$f88dde183f4d31cb; });

var $lDu5G = parcelRequire("lDu5G");

var $dAx5m = parcelRequire("dAx5m");
var $d559545a6fcaeb83$var$noop = function noop() {};
var $d559545a6fcaeb83$export$3f3eebb4b8116461 = /*#__PURE__*/ (0, $dAx5m.createContext)({
    start: $d559545a6fcaeb83$var$noop,
    success: $d559545a6fcaeb83$var$noop,
    failure: $d559545a6fcaeb83$var$noop,
    failureAll: $d559545a6fcaeb83$var$noop,
    abort: $d559545a6fcaeb83$var$noop,
    abortAll: $d559545a6fcaeb83$var$noop,
    markStart: $d559545a6fcaeb83$var$noop,
    markEnd: $d559545a6fcaeb83$var$noop
});
var $d559545a6fcaeb83$export$cdefb2a8b53f879f = function useExperienceTracker() {
    return (0, $dAx5m.useContext)($d559545a6fcaeb83$export$3f3eebb4b8116461);
};
var $d559545a6fcaeb83$export$f88dde183f4d31cb = function withExperienceTracker(Component) {
    var WithExperienceTracker = function WithExperienceTracker(props) {
        var experienceTracker = $d559545a6fcaeb83$export$cdefb2a8b53f879f();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement(Component, (0, (/*@__PURE__*/$parcel$interopDefault($lDu5G)))({}, props, {
            experienceTracker: experienceTracker
        }));
    };
    WithExperienceTracker.displayName = "WithExperienceTracker(".concat(Component.displayName, ")");
    return WithExperienceTracker;
};

});


parcelRegister("jXZjr", function(module, exports) {

$parcel$export(module.exports, "Permissions", function () { return $e8931667f6ac4180$export$2d41982586bbb6be; });
$parcel$export(module.exports, "Product", function () { return $e8931667f6ac4180$export$264ad599d7cef668; });
$parcel$export(module.exports, "Feature", function () { return $e8931667f6ac4180$export$6e91cf7616333d5; });
$parcel$export(module.exports, "AnalyticsItemType", function () { return $e8931667f6ac4180$export$77f267162e8983fb; });
$parcel$export(module.exports, "ProductKey", function () { return $e8931667f6ac4180$export$f3a53bd43617a593; });
var $e8931667f6ac4180$export$2d41982586bbb6be = /*#__PURE__*/ function(Permissions) {
    Permissions["MANAGE"] = "manage";
    Permissions["CAN_INVITE_USERS"] = "invite-users";
    return Permissions;
}({});
var $e8931667f6ac4180$export$264ad599d7cef668 = /*#__PURE__*/ function(Product) {
    Product["BITBUCKET"] = "bitbucket";
    Product["CONFLUENCE"] = "confluence";
    Product["HOME"] = "home";
    Product["JIRA"] = "jira";
    Product["SITE_ADMIN"] = "site-admin";
    Product["TRELLO"] = "trello";
    Product["START"] = "start";
    return Product;
}({});
var $e8931667f6ac4180$export$6e91cf7616333d5 = /*#__PURE__*/ function(Feature) {
    Feature["isUFOEnabled"] = "isUFOEnabled";
    return Feature;
}({});
var $e8931667f6ac4180$export$77f267162e8983fb = /*#__PURE__*/ function(AnalyticsItemType) {
    AnalyticsItemType["PRODUCT"] = "product";
    AnalyticsItemType["ADMIN"] = "admin";
    AnalyticsItemType["TRY"] = "try";
    AnalyticsItemType["JOIN"] = "join";
    AnalyticsItemType["CUSTOM_LINK"] = "customLink";
    AnalyticsItemType["EMPTY_STATE_EXPLORE_PRODUCTS"] = "empty-state-explore-products";
    return AnalyticsItemType;
}({});
var $e8931667f6ac4180$export$f3a53bd43617a593 = /*#__PURE__*/ function(ProductKey) {
    ProductKey["CONFLUENCE"] = "confluence.ondemand";
    ProductKey["JIRA_CORE"] = "jira-core.ondemand";
    ProductKey["JIRA_SOFTWARE"] = "jira-software.ondemand";
    ProductKey["JIRA_SERVICE_DESK"] = "jira-servicedesk.ondemand";
    ProductKey["BITBUCKET"] = "bitbucket";
    ProductKey["OPSGENIE"] = "opsgenie";
    ProductKey["STATUSPAGE"] = "statuspage";
    ProductKey["TRELLO"] = "trello";
    ProductKey["COMPASS"] = "compass";
    ProductKey["TEAM_CENTRAL"] = "townsquare";
    ProductKey["JIRA_PRODUCT_DISCOVERY"] = "jira-product-discovery";
    return ProductKey;
}({}); //

});

parcelRegister("gNMXn", function(module, exports) {

$parcel$export(module.exports, "withCached", function () { return $c3b732b388a9e727$export$7f51828d6b6af163; });
var $c3b732b388a9e727$export$d4d4b402ab64e2f4 = 5000;
var $c3b732b388a9e727$var$isPromise = function isPromise(p) {
    return typeof p.then === "function" && typeof p.catch === "function";
};
var $c3b732b388a9e727$export$7f51828d6b6af163 = function withCached(fn) {
    var resultCache = new Map();
    var promiseCache = new Map();
    function getCacheKey() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return JSON.stringify(args);
    }
    var cached = function cached() {
        var cacheKey = getCacheKey.apply(void 0, arguments);
        return resultCache.get(cacheKey);
    };
    var reset = function reset() {
        resultCache.clear();
        promiseCache.clear();
    };
    var execute = function execute() {
        var cacheKey = getCacheKey.apply(void 0, arguments);
        var cachedPromise = promiseCache.get(cacheKey);
        if (cachedPromise !== undefined) return cachedPromise;
        var maybePromise = fn.apply(void 0, arguments);
        promiseCache.set(cacheKey, maybePromise);
        if ($c3b732b388a9e727$var$isPromise(maybePromise)) maybePromise.then(function(result) {
            resultCache.set(cacheKey, result);
            setTimeout(function() {
                return promiseCache.delete(cacheKey);
            }, $c3b732b388a9e727$export$d4d4b402ab64e2f4);
        }).catch(function() {
            promiseCache.delete(cacheKey);
        });
        return maybePromise;
    };
    return Object.assign(execute, fn, {
        cached: cached,
        reset: reset
    });
};

});

parcelRegister("9sDtc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6e35587979a1439f$export$2e2bcd8739ae039; });

var $dAx5m = parcelRequire("dAx5m");

var $t5UCS = parcelRequire("t5UCS");
/**
 * Inject the ability to handle cases when cloudID is missing into the provided component.
 *
 * When cloud ID is available, this HOC will wrap {children} with the given provided component.
 * Otherwise, {children} is executed with the provided fallback result.
 *
 * @param ProviderComponent component to wrap
 * @param fallbackProviderResult result used to execute children if cloud id is missing
 *
 * @type P component props
 * @type U provider result type
 */ function $6e35587979a1439f$var$withHandleOptionalCloudId(ProviderComponent, fallbackProviderResult) {
    return function(props) {
        var cloudId = props.cloudId, children = props.children;
        if (cloudId) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement(ProviderComponent, props, children);
        else {
            var resultComplete = {
                status: (0, $t5UCS.Status).COMPLETE,
                data: fallbackProviderResult
            };
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).Fragment, null, children(resultComplete));
        }
    };
}
var $6e35587979a1439f$export$2e2bcd8739ae039 = $6e35587979a1439f$var$withHandleOptionalCloudId;

});

parcelRegister("bBsJG", function(module, exports) {

$parcel$export(module.exports, "Experience", function () { return $872970bde1926d2a$export$c90b54e658fc4d7c; });
$parcel$export(module.exports, "EXPERIENCE_CONFIGS", function () { return $872970bde1926d2a$export$d54d7a2744fdf647; });
$parcel$export(module.exports, "ExperienceMark", function () { return $872970bde1926d2a$export$cbf1e672c3e37474; });
$parcel$export(module.exports, "EXPERIENCES_TO_MARKS", function () { return $872970bde1926d2a$export$755e75afbd377bc4; });
$parcel$export(module.exports, "MARKS_TO_EXPERIENCES", function () { return $872970bde1926d2a$export$805ed806e0769ee4; });
$parcel$export(module.exports, "ExperienceMarkPhase", function () { return $872970bde1926d2a$export$ec8391a70bbdbe59; });
$parcel$export(module.exports, "AbortReason", function () { return $872970bde1926d2a$export$279d6315a97b520d; });
$parcel$export(module.exports, "SWITCHER_RENDER_START_PERFORMANCE_MARK", function () { return $872970bde1926d2a$export$86919b84f9a64054; });

var $9HWAT = parcelRequire("9HWAT");

var $eSGx5 = parcelRequire("eSGx5");

var $fS8V9 = parcelRequire("fS8V9");
var $872970bde1926d2a$export$c90b54e658fc4d7c = /*#__PURE__*/ function(Experience) {
    Experience["RENDER_CUSTOM_LINKS_SECTION"] = "render-custom-links-section";
    Experience["RENDER_JOIN_SECTION"] = "render-join-section";
    Experience["RENDER_SWITCH_TO_SECTION"] = "render-switch-to-section";
    Experience["RENDER_SWITCHER_EMPTY_STATE"] = "render-switcher-empty-state";
    return Experience;
}({});
var $872970bde1926d2a$export$d54d7a2744fdf647 = (0, (/*@__PURE__*/$parcel$interopDefault($9HWAT)))((0, (/*@__PURE__*/$parcel$interopDefault($9HWAT)))((0, (/*@__PURE__*/$parcel$interopDefault($9HWAT)))((0, (/*@__PURE__*/$parcel$interopDefault($9HWAT)))({}, $872970bde1926d2a$export$c90b54e658fc4d7c.RENDER_CUSTOM_LINKS_SECTION, {
    type: (0, $eSGx5.ExperienceTypes).Load,
    performanceType: (0, $eSGx5.ExperiencePerformanceTypes).PageSegmentLoad
}), $872970bde1926d2a$export$c90b54e658fc4d7c.RENDER_JOIN_SECTION, {
    type: (0, $eSGx5.ExperienceTypes).Load,
    performanceType: (0, $eSGx5.ExperiencePerformanceTypes).PageSegmentLoad
}), $872970bde1926d2a$export$c90b54e658fc4d7c.RENDER_SWITCH_TO_SECTION, {
    type: (0, $eSGx5.ExperienceTypes).Load,
    performanceType: (0, $eSGx5.ExperiencePerformanceTypes).PageSegmentLoad
}), $872970bde1926d2a$export$c90b54e658fc4d7c.RENDER_SWITCHER_EMPTY_STATE, {
    type: (0, $eSGx5.ExperienceTypes).Load,
    performanceType: (0, $eSGx5.ExperiencePerformanceTypes).PageSegmentLoad
});
var $872970bde1926d2a$export$cbf1e672c3e37474 = /*#__PURE__*/ function(ExperienceMark) {
    ExperienceMark["API_APP_SWITCHER_BFF_AVAILABLE_PRODUCTS"] = "api-app-switcher-bff-available-products";
    ExperienceMark["API_CONFLUENCE_CUSTOM_LINKS"] = "api-confluence-custom-links";
    ExperienceMark["API_FLIGHT_DECK"] = "api-flight-deck";
    ExperienceMark["API_JIRA_CUSTOM_LINKS"] = "api-jira-custom-links";
    ExperienceMark["API_JOINABLE_SITES"] = "api-joinable-sites";
    ExperienceMark["API_PERMISSIONS"] = "api-permissions";
    ExperienceMark["SWITCHER_INITIAL_MOUNT"] = "switcher-initial-mount";
    ExperienceMark["SWITCHER_SKELETON_MOUNT"] = "switcher-skeleton-mount";
    // Mock for tests
    ExperienceMark["TEST_MARK"] = "test-mark";
    return ExperienceMark;
}({});
var $872970bde1926d2a$var$allNonTestExperienceMarks = Object.values($872970bde1926d2a$export$cbf1e672c3e37474).filter(function(mark) {
    return mark !== $872970bde1926d2a$export$cbf1e672c3e37474.TEST_MARK;
});
var $872970bde1926d2a$export$755e75afbd377bc4 = (0, (/*@__PURE__*/$parcel$interopDefault($9HWAT)))((0, (/*@__PURE__*/$parcel$interopDefault($9HWAT)))((0, (/*@__PURE__*/$parcel$interopDefault($9HWAT)))((0, (/*@__PURE__*/$parcel$interopDefault($9HWAT)))({}, $872970bde1926d2a$export$c90b54e658fc4d7c.RENDER_CUSTOM_LINKS_SECTION, $872970bde1926d2a$var$allNonTestExperienceMarks), $872970bde1926d2a$export$c90b54e658fc4d7c.RENDER_JOIN_SECTION, $872970bde1926d2a$var$allNonTestExperienceMarks), $872970bde1926d2a$export$c90b54e658fc4d7c.RENDER_SWITCH_TO_SECTION, $872970bde1926d2a$var$allNonTestExperienceMarks), $872970bde1926d2a$export$c90b54e658fc4d7c.RENDER_SWITCHER_EMPTY_STATE, $872970bde1926d2a$var$allNonTestExperienceMarks);
var $872970bde1926d2a$export$805ed806e0769ee4 = (0, $fS8V9.invertRecordOfArrays)($872970bde1926d2a$export$755e75afbd377bc4);
var $872970bde1926d2a$export$ec8391a70bbdbe59 = /*#__PURE__*/ function(ExperienceMarkPhase) {
    ExperienceMarkPhase["START"] = "start";
    ExperienceMarkPhase["END"] = "end";
    return ExperienceMarkPhase;
}({});
var $872970bde1926d2a$export$279d6315a97b520d = /*#__PURE__*/ function(AbortReason) {
    AbortReason["COMPONENT_UNMOUNTED"] = "component-unmounted";
    AbortReason["WINDOW_UNLOADING"] = "window-unloading";
    return AbortReason;
}({});
var $872970bde1926d2a$export$86919b84f9a64054 = "atlassianSwitcher.render.start";

});
parcelRegister("eSGx5", function(module, exports) {

$parcel$export(module.exports, "ExperienceTypes", function () { return $ad5719ec9e0a06b4$export$994164cf3ae1cc9a; });
$parcel$export(module.exports, "ExperiencePerformanceTypes", function () { return $ad5719ec9e0a06b4$export$cc26007c03242fff; });
var $ad5719ec9e0a06b4$export$994164cf3ae1cc9a = /*#__PURE__*/ function(ExperienceTypes) {
    ExperienceTypes["Load"] = "load";
    ExperienceTypes["Experience"] = "experience";
    ExperienceTypes["Operation"] = "operation";
    return ExperienceTypes;
}({});
var $ad5719ec9e0a06b4$export$cc26007c03242fff = /*#__PURE__*/ function(ExperiencePerformanceTypes) {
    ExperiencePerformanceTypes["PageLoad"] = "page-load";
    ExperiencePerformanceTypes["PageSegmentLoad"] = "page-segment-load";
    ExperiencePerformanceTypes["InlineResult"] = "inline-result";
    ExperiencePerformanceTypes["Custom"] = "custom";
    return ExperiencePerformanceTypes;
}({});

});

parcelRegister("fS8V9", function(module, exports) {

$parcel$export(module.exports, "invertRecordOfArrays", function () { return $b8e2d1a04e069e13$export$c371a74fe5222b3; });

var $1m89o = parcelRequire("1m89o");
function $b8e2d1a04e069e13$export$c371a74fe5222b3(record) {
    var invertedRecord = {};
    Object.entries(record).forEach(function(_ref) {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($1m89o)))(_ref, 2), key = _ref2[0], values = _ref2[1];
        values.forEach(function(value) {
            if (!invertedRecord[value]) invertedRecord[value] = [];
            invertedRecord[value].push(key);
        });
    });
    return invertedRecord;
}

});
parcelRegister("1m89o", function(module, exports) {

var $6QBY6 = parcelRequire("6QBY6");

var $3levi = parcelRequire("3levi");

var $57wOj = parcelRequire("57wOj");

var $iqDRO = parcelRequire("iqDRO");
function $0fce2b091f5c295f$var$_slicedToArray(r, e) {
    return $6QBY6(r) || $3levi(r, e) || $57wOj(r, e) || $iqDRO();
}
module.exports = $0fce2b091f5c295f$var$_slicedToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("6QBY6", function(module, exports) {
function $4fc50d265280e53d$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
module.exports = $4fc50d265280e53d$var$_arrayWithHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("3levi", function(module, exports) {
function $26ee9564128173cb$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
module.exports = $26ee9564128173cb$var$_iterableToArrayLimit, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("iqDRO", function(module, exports) {
function $d6a99478ae91f50f$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
module.exports = $d6a99478ae91f50f$var$_nonIterableRest, module.exports.__esModule = true, module.exports["default"] = module.exports;

});





parcelRegister("8KgLq", function(module, exports) {

$parcel$export(module.exports, "AvailableProductsProvider", function () { return $65df9f9158be5d1c$export$4c169257ef988618; });
$parcel$export(module.exports, "prefetchAvailableProducts", function () { return $65df9f9158be5d1c$export$1c5684a3ba697d80; });

var $dAx5m = parcelRequire("dAx5m");

var $78xg5 = parcelRequire("78xg5");
var $65df9f9158be5d1c$var$_ref = (0, $78xg5.createAppSwitcherBffAvailableProductsProvider)(), $65df9f9158be5d1c$var$fetchAppSwitcherBffAvailableProducts = $65df9f9158be5d1c$var$_ref.fetchMethod, $65df9f9158be5d1c$var$DefaultBffDataProviderComponent = $65df9f9158be5d1c$var$_ref.ProviderComponent;
var $65df9f9158be5d1c$export$4c169257ef988618 = function AvailableProductsProvider(_ref2) {
    var cloudId = _ref2.cloudId, product = _ref2.product, children = _ref2.children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement($65df9f9158be5d1c$var$DefaultBffDataProviderComponent, {
        cloudId: cloudId,
        product: product
    }, children);
};
var $65df9f9158be5d1c$export$1c5684a3ba697d80 = $65df9f9158be5d1c$var$fetchAppSwitcherBffAvailableProducts;
var $65df9f9158be5d1c$export$cd9fc41c59711bdd = function resetAvailableProducts() {
    return $65df9f9158be5d1c$var$fetchAppSwitcherBffAvailableProducts.reset();
};

});
parcelRegister("78xg5", function(module, exports) {

$parcel$export(module.exports, "createAppSwitcherBffAvailableProductsProvider", function () { return $53231431a771ba79$export$7fd9c7ae7afb494c; });

var $6XUwN = parcelRequire("6XUwN");

var $cwdap = parcelRequire("cwdap");

var $cX8GM = parcelRequire("cX8GM");

var $kHOjI = parcelRequire("kHOjI");

var $bBsJG = parcelRequire("bBsJG");

var $1Sdo1 = parcelRequire("1Sdo1");
var $53231431a771ba79$export$f36bb44a614923a8 = "/gateway/api/app-switcher/api/available-products";
// TODO: remove this once Asset app becomes standalone app
var $53231431a771ba79$var$transformAppSwitcherBffResponse = function transformAppSwitcherBffResponse(response) {
    if (response.switcherTeam25ExperimentCohort === "test" && response.assetsAsAnAppEnabled) response.sites.forEach(function(site) {
        if (site.availableProducts.some(function(product) {
            return product.productType === "JIRA_SERVICE_DESK" && product.isJsmPremium;
        })) site.availableProducts.push({
            productType: (0, $1Sdo1.ASSETS_APP_KEY)
        });
    });
    return response;
};
var $53231431a771ba79$export$1096efb00c5f8afc = /*#__PURE__*/ function() {
    var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($6XUwN)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cwdap))).mark(function _callee(_ref) {
        var cloudId, product, params, response;
        return (0, (/*@__PURE__*/$parcel$interopDefault($cwdap))).wrap(function _callee$(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    cloudId = _ref.cloudId, product = _ref.product;
                    params = new URLSearchParams({
                        source: "app-switcher-fe"
                    });
                    if (cloudId) params.append("tenantid", encodeURIComponent(cloudId));
                    if (product) params.append("product", encodeURIComponent(product));
                    _context.next = 6;
                    return (0, $kHOjI.fetchJsonWithNetworkRetries)("".concat($53231431a771ba79$export$f36bb44a614923a8, "?").concat(params.toString()), {
                        intervalsMS: [
                            50,
                            200,
                            1000
                        ]
                    }, {
                        headers: {
                            "Atl-App-Switcher-Private-API": "true"
                        }
                    });
                case 6:
                    response = _context.sent;
                    return _context.abrupt("return", $53231431a771ba79$var$transformAppSwitcherBffResponse(response));
                case 8:
                case "end":
                    return _context.stop();
            }
        }, _callee);
    }));
    return function appSwitcherBffAvailableProductsFetch(_x) {
        return _ref2.apply(this, arguments);
    };
}();
var $53231431a771ba79$export$7fd9c7ae7afb494c = function createAppSwitcherBffAvailableProductsProvider() {
    return (0, $cX8GM.createProviderWithCustomFetchData)("appSwitcherBffAvailableProducts", (0, $bBsJG.ExperienceMark).API_APP_SWITCHER_BFF_AVAILABLE_PRODUCTS, $53231431a771ba79$export$1096efb00c5f8afc);
};

});
parcelRegister("cX8GM", function(module, exports) {

$parcel$export(module.exports, "createProviderWithCustomFetchData", function () { return $96e1bc2f0db5528d$export$310e48be95687c2f; });

var $t5UCS = parcelRequire("t5UCS");

var $kHOjI = parcelRequire("kHOjI");

var $gNMXn = parcelRequire("gNMXn");
var $96e1bc2f0db5528d$export$500fbc0cd14cdbaa = function createProvider(name, experienceMark, url) {
    var fetchMethod = (0, $gNMXn.withCached)(function(param) {
        return (0, $kHOjI.fetchJson)(url);
    });
    return {
        fetchMethod: fetchMethod,
        ProviderComponent: (0, $t5UCS.default)(name, experienceMark, fetchMethod, fetchMethod.cached, // fetch will only throw on a network exception,
        // so we can safely retry on all exceptions
        {
            shouldRetryOnException: function shouldRetryOnException() {
                return true;
            },
            intervalsMS: [
                50,
                200,
                1000
            ]
        })
    };
};
var $96e1bc2f0db5528d$export$310e48be95687c2f = function createProviderWithCustomFetchData(name, experienceMark, fetchData, retryConfig) {
    var fetchMethod = (0, $gNMXn.withCached)(function(param) {
        return fetchData(param);
    });
    return {
        fetchMethod: fetchMethod,
        ProviderComponent: (0, $t5UCS.default)(name, experienceMark, fetchMethod, fetchMethod.cached, retryConfig)
    };
};

});

parcelRegister("1Sdo1", function(module, exports) {

$parcel$export(module.exports, "COLLAPSED_ORG_SELECTOR_WIDTH", function () { return $15d537df67a92484$export$2f90b4ad2fe04542; });
$parcel$export(module.exports, "DEFAULT_ORG_SELECTOR_EXPANDED_WIDTH", function () { return $15d537df67a92484$export$4103378b1e498da3; });
$parcel$export(module.exports, "MIN_ORG_SELECTOR_EXPAND_WIDTH", function () { return $15d537df67a92484$export$85408825f773203f; });
$parcel$export(module.exports, "MAX_ORG_SELECTOR_EXPANDED_WIDTH", function () { return $15d537df67a92484$export$d1ad8b9b8feac8dc; });
$parcel$export(module.exports, "ORG_SELECTOR_WIDTH_LS_KEY", function () { return $15d537df67a92484$export$22193936843a6dda; });
$parcel$export(module.exports, "ASSETS_APP_KEY", function () { return $15d537df67a92484$export$45e63649edff1e2a; });
var $15d537df67a92484$export$2f90b4ad2fe04542 = 56;
var $15d537df67a92484$export$4103378b1e498da3 = 200;
var $15d537df67a92484$export$85408825f773203f = $15d537df67a92484$export$2f90b4ad2fe04542 + ($15d537df67a92484$export$4103378b1e498da3 - $15d537df67a92484$export$2f90b4ad2fe04542) / 2;
var $15d537df67a92484$export$d1ad8b9b8feac8dc = 400;
var $15d537df67a92484$export$22193936843a6dda = "AS_ORG_SELECTOR_WIDTH";
var $15d537df67a92484$export$45e63649edff1e2a = "ASSETS";

});



parcelRegister("bCfF5", function(module, exports) {

$parcel$export(module.exports, "JoinableSitesProvider", function () { return $874f646a33807ff6$export$70da68d3b04f82d0; });
$parcel$export(module.exports, "prefetchJoinableSites", function () { return $874f646a33807ff6$export$2aed3ef1595b4d9; });

var $dAx5m = parcelRequire("dAx5m");

var $8TI0R = parcelRequire("8TI0R");
var $874f646a33807ff6$var$_ref = (0, $8TI0R.createJoinableSitesProvider)(), $874f646a33807ff6$var$fetchJoinableSites = $874f646a33807ff6$var$_ref.fetchMethod, $874f646a33807ff6$var$DefaultDataProviderComponent = $874f646a33807ff6$var$_ref.ProviderComponent;
var $874f646a33807ff6$export$70da68d3b04f82d0 = function JoinableSitesProvider(_ref2) {
    var children = _ref2.children, joinableSitesDataProvider = _ref2.joinableSitesDataProvider, cloudId = _ref2.cloudId;
    var CustomDataProviderComponent = joinableSitesDataProvider && joinableSitesDataProvider.ProviderComponent;
    var DataProviderComponent = CustomDataProviderComponent || $874f646a33807ff6$var$DefaultDataProviderComponent;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement(DataProviderComponent, {
        cloudId: cloudId
    }, children);
};
var $874f646a33807ff6$export$2aed3ef1595b4d9 = function prefetchJoinableSites(customProvider) {
    if (customProvider) {
        customProvider.fetchMethod({});
        return;
    }
    $874f646a33807ff6$var$fetchJoinableSites({});
};
var $874f646a33807ff6$export$4ba2a997caa6db74 = function resetJoinableSites(customProvider) {
    if (customProvider) {
        customProvider.fetchMethod.reset();
        return;
    }
    $874f646a33807ff6$var$fetchJoinableSites.reset();
};

});
parcelRegister("8TI0R", function(module, exports) {

$parcel$export(module.exports, "createJoinableSitesProvider", function () { return $67a599d78f99ced0$export$c3b6af53f1ca17d8; });

var $cX8GM = parcelRequire("cX8GM");

var $bBsJG = parcelRequire("bBsJG");
var $67a599d78f99ced0$export$62986affcccd56a5 = function fetchEmptyData() {
    return Promise.resolve({
        sites: undefined
    });
};
var $67a599d78f99ced0$export$c3b6af53f1ca17d8 = function createJoinableSitesProvider() {
    var fetchData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : $67a599d78f99ced0$export$62986affcccd56a5;
    var retryConfig = arguments.length > 1 ? arguments[1] : undefined;
    return (0, $cX8GM.createProviderWithCustomFetchData)("joinableSites", (0, $bBsJG.ExperienceMark).API_JOINABLE_SITES, fetchData, retryConfig);
};

});


parcelRegister("3R0Tv", function(module, exports) {

$parcel$export(module.exports, "loadAtlassianSwitcher", function () { return $2ce703ece3e956ae$export$6c6894dd831bfacb; });
$parcel$export(module.exports, "loadJiraSwitcher", function () { return $2ce703ece3e956ae$export$52c59c5b477673fb; });
$parcel$export(module.exports, "loadConfluenceSwitcher", function () { return $2ce703ece3e956ae$export$2d2945898d9ee55f; });
$parcel$export(module.exports, "loadGenericSwitcher", function () { return $2ce703ece3e956ae$export$64191a36345a6b2b; });
$parcel$export(module.exports, "AtlassianSwitcherLoader", function () { return $2ce703ece3e956ae$export$25f16f9fee84a840; });
$parcel$export(module.exports, "JiraSwitcherLoader", function () { return $2ce703ece3e956ae$export$10767845f9f42bd; });
$parcel$export(module.exports, "ConfluenceSwitcherLoader", function () { return $2ce703ece3e956ae$export$71f961c620294b68; });
$parcel$export(module.exports, "GenericSwitcherLoader", function () { return $2ce703ece3e956ae$export$8c21d1a0c59fc17e; });

var $cUsaH = parcelRequire("cUsaH");

var $dAx5m = parcelRequire("dAx5m");

var $6SD2e = parcelRequire("6SD2e");

var $2ce703ece3e956ae$export$6c6894dd831bfacb = function loadAtlassianSwitcher() {
    return (parcelRequire("hMpCI")).then(function(module) {
        return module.default;
    });
};

var $2ce703ece3e956ae$export$52c59c5b477673fb = function loadJiraSwitcher() {
    return (parcelRequire("8oiqH")).then(function(module) {
        return module.default;
    });
};

var $2ce703ece3e956ae$export$2d2945898d9ee55f = function loadConfluenceSwitcher() {
    return (parcelRequire("bt95C")).then(function(module) {
        return module.default;
    });
};

var $2ce703ece3e956ae$export$64191a36345a6b2b = function loadGenericSwitcher() {
    return (parcelRequire("90zU2")).then(function(module) {
        return module.default;
    });
};
var $2ce703ece3e956ae$export$25f16f9fee84a840 = (0, (/*@__PURE__*/$parcel$interopDefault($cUsaH)))({
    loader: $2ce703ece3e956ae$export$6c6894dd831bfacb,
    loading: function loading() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $6SD2e.default), null);
    }
});
var $2ce703ece3e956ae$export$10767845f9f42bd = (0, (/*@__PURE__*/$parcel$interopDefault($cUsaH)))({
    loader: $2ce703ece3e956ae$export$52c59c5b477673fb,
    loading: function loading() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $6SD2e.default), null);
    }
});
var $2ce703ece3e956ae$export$71f961c620294b68 = (0, (/*@__PURE__*/$parcel$interopDefault($cUsaH)))({
    loader: $2ce703ece3e956ae$export$2d2945898d9ee55f,
    loading: function loading() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $6SD2e.default), null);
    }
});
var $2ce703ece3e956ae$export$8c21d1a0c59fc17e = (0, (/*@__PURE__*/$parcel$interopDefault($cUsaH)))({
    loader: $2ce703ece3e956ae$export$64191a36345a6b2b,
    loading: function loading() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $6SD2e.default), null);
    }
});

});
parcelRegister("6SD2e", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $502610bc6a8ec97a$export$2e2bcd8739ae039; });
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $jVTBW = parcelRequire("jVTBW");

var $2I3Lh = parcelRequire("2I3Lh");

var $jyfI2 = parcelRequire("jyfI2");

var $9yySa = parcelRequire("9yySa");

var $bBsJG = parcelRequire("bBsJG");
var $4q22m = parcelRequire("4q22m");

var $dZHnD = parcelRequire("dZHnD");

var $d1Wgq = parcelRequire("d1Wgq");
var $502610bc6a8ec97a$var$iconSkeletonStyles = (0, $jVTBW.css)({
    display: "inline-block",
    width: 32,
    height: 32,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    backgroundColor: "var(--ds-skeleton, ".concat($2I3Lh.N20, ")"),
    borderRadius: "var(--ds-border-radius-200, 8px)"
});
var $502610bc6a8ec97a$var$lineSkeletonStyles = (0, $jVTBW.css)({
    display: "inline-block",
    width: 98,
    height: 10,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    backgroundColor: "var(--ds-skeleton, ".concat($2I3Lh.N20, ")"),
    borderRadius: "var(--ds-border-radius, 3px)"
});
var $502610bc6a8ec97a$var$iconSkeleton = (0, $jVTBW.jsx)("div", {
    css: $502610bc6a8ec97a$var$iconSkeletonStyles
});
var $502610bc6a8ec97a$var$lineSkeleton = (0, $jVTBW.jsx)("div", {
    css: $502610bc6a8ec97a$var$lineSkeletonStyles
});
var $502610bc6a8ec97a$export$2e2bcd8739ae039 = function() {
    (0, $4q22m.useExperienceRenderAndMountMark)((0, $bBsJG.ExperienceMark).SWITCHER_SKELETON_MOUNT);
    var _useIntl = (0, $dZHnD.default)(), formatMessage = _useIntl.formatMessage;
    return (0, $jVTBW.jsx)((0, $jyfI2.SectionContainer), {
        sectionId: "skeleton",
        title: $502610bc6a8ec97a$var$lineSkeleton,
        sectionRole: "alert",
        "aria-label": formatMessage((0, $d1Wgq.default).skeletonLoaderAriaLabel)
    }, (0, $jVTBW.jsx)((0, $9yySa.default), {
        tag: "li",
        icon: $502610bc6a8ec97a$var$iconSkeleton,
        isDisabled: true,
        "aria-hidden": "true"
    }, $502610bc6a8ec97a$var$lineSkeleton), (0, $jVTBW.jsx)((0, $9yySa.default), {
        tag: "li",
        icon: $502610bc6a8ec97a$var$iconSkeleton,
        isDisabled: true,
        "aria-hidden": "true"
    }, $502610bc6a8ec97a$var$lineSkeleton), (0, $jVTBW.jsx)((0, $9yySa.default), {
        tag: "li",
        icon: $502610bc6a8ec97a$var$iconSkeleton,
        isDisabled: true,
        "aria-hidden": "true"
    }, $502610bc6a8ec97a$var$lineSkeleton));
};

});
parcelRegister("2I3Lh", function(module, exports) {

$parcel$export(module.exports, "R300", function () { return $1f929bc90274ebd9$export$4a7404f376229999; });
$parcel$export(module.exports, "R400", function () { return $1f929bc90274ebd9$export$2010d0fb4295b346; });
$parcel$export(module.exports, "R500", function () { return $1f929bc90274ebd9$export$2837b5a1a71d5c02; });
$parcel$export(module.exports, "Y200", function () { return $1f929bc90274ebd9$export$5aae31392d72caaa; });
$parcel$export(module.exports, "Y300", function () { return $1f929bc90274ebd9$export$c6930421db9fa514; });
$parcel$export(module.exports, "Y400", function () { return $1f929bc90274ebd9$export$59619663aa6500fb; });
$parcel$export(module.exports, "G300", function () { return $1f929bc90274ebd9$export$940e1f69e873f202; });
$parcel$export(module.exports, "B50", function () { return $1f929bc90274ebd9$export$226de0355ed012f8; });
$parcel$export(module.exports, "B75", function () { return $1f929bc90274ebd9$export$8c13c2ee36917869; });
$parcel$export(module.exports, "B100", function () { return $1f929bc90274ebd9$export$ecfc1dff386a3e7a; });
$parcel$export(module.exports, "B200", function () { return $1f929bc90274ebd9$export$215b7063051591f1; });
$parcel$export(module.exports, "B300", function () { return $1f929bc90274ebd9$export$e62e8919cca44969; });
$parcel$export(module.exports, "B400", function () { return $1f929bc90274ebd9$export$b3de0ae08da2ce64; });
$parcel$export(module.exports, "B500", function () { return $1f929bc90274ebd9$export$a6ee3d71bc067634; });
$parcel$export(module.exports, "N0", function () { return $1f929bc90274ebd9$export$29a4f05edc054374; });
$parcel$export(module.exports, "N20", function () { return $1f929bc90274ebd9$export$9fdfb749e33cdf97; });
$parcel$export(module.exports, "N30", function () { return $1f929bc90274ebd9$export$3e51e8f1440314ba; });
$parcel$export(module.exports, "N40", function () { return $1f929bc90274ebd9$export$1ce2d1575d444ceb; });
$parcel$export(module.exports, "N70", function () { return $1f929bc90274ebd9$export$5f71e19f3a7ad9de; });
$parcel$export(module.exports, "N90", function () { return $1f929bc90274ebd9$export$7c87d337fb91a97d; });
$parcel$export(module.exports, "N100", function () { return $1f929bc90274ebd9$export$d6447c357493214f; });
$parcel$export(module.exports, "N200", function () { return $1f929bc90274ebd9$export$f563ee71e9ee74cd; });
$parcel$export(module.exports, "N400", function () { return $1f929bc90274ebd9$export$eece5f492e429f08; });
$parcel$export(module.exports, "N500", function () { return $1f929bc90274ebd9$export$c39c0fe0f26207ae; });
$parcel$export(module.exports, "N600", function () { return $1f929bc90274ebd9$export$7090862dc3038a9f; });
$parcel$export(module.exports, "N700", function () { return $1f929bc90274ebd9$export$ad0bacf983b7ddaa; });
$parcel$export(module.exports, "N800", function () { return $1f929bc90274ebd9$export$7d61b15e0da132af; });
$parcel$export(module.exports, "N900", function () { return $1f929bc90274ebd9$export$fbda843f0a27fe96; });
$parcel$export(module.exports, "N20A", function () { return $1f929bc90274ebd9$export$8d43898f60b96a82; });
$parcel$export(module.exports, "N30A", function () { return $1f929bc90274ebd9$export$920c0d5c49070351; });
$parcel$export(module.exports, "DN400", function () { return $1f929bc90274ebd9$export$abcf8c38338b4aa5; });
$parcel$export(module.exports, "DN300", function () { return $1f929bc90274ebd9$export$97e81faa16a182c7; });
$parcel$export(module.exports, "DN100", function () { return $1f929bc90274ebd9$export$ee82aa2ea6a1558; });
$parcel$export(module.exports, "DN70", function () { return $1f929bc90274ebd9$export$d281fbfe3cff2df6; });
$parcel$export(module.exports, "DN60", function () { return $1f929bc90274ebd9$export$3902c91d8b98a753; });
$parcel$export(module.exports, "DN30", function () { return $1f929bc90274ebd9$export$633847cf062b69e0; });
$parcel$export(module.exports, "DN0", function () { return $1f929bc90274ebd9$export$3d4f271a500072a; });
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // Reds
var $1f929bc90274ebd9$export$4b84fd0e2c617bd = "#FFEBE6";
var $1f929bc90274ebd9$export$b34b069eff244586 = "#FFBDAD";
var $1f929bc90274ebd9$export$be802dd0d8b57f35 = "#FF8F73";
var $1f929bc90274ebd9$export$60847d42f9da92a6 = "#FF7452";
var $1f929bc90274ebd9$export$4a7404f376229999 = "#FF5630";
var $1f929bc90274ebd9$export$2010d0fb4295b346 = "#DE350B";
var $1f929bc90274ebd9$export$2837b5a1a71d5c02 = "#BF2600";
var $1f929bc90274ebd9$export$8d9596b529bbb9cf = "#FFFAE6";
var $1f929bc90274ebd9$export$41060a744ab0b7ae = "#FFF0B3";
var $1f929bc90274ebd9$export$1cc05bbbf340e559 = "#FFE380";
var $1f929bc90274ebd9$export$5aae31392d72caaa = "#FFC400";
var $1f929bc90274ebd9$export$c6930421db9fa514 = "#FFAB00";
var $1f929bc90274ebd9$export$59619663aa6500fb = "#FF991F";
var $1f929bc90274ebd9$export$874739ea9e379ab6 = "#FF8B00";
var $1f929bc90274ebd9$export$8a6341c32b6a3ee6 = "#E3FCEF";
var $1f929bc90274ebd9$export$69a3bf21b9686c2b = "#ABF5D1";
var $1f929bc90274ebd9$export$afbce1382ec95f73 = "#79F2C0";
var $1f929bc90274ebd9$export$747d86715d4175de = "#57D9A3";
var $1f929bc90274ebd9$export$940e1f69e873f202 = "#36B37E";
var $1f929bc90274ebd9$export$a49394138f7b8e85 = "#00875A";
var $1f929bc90274ebd9$export$6fa04827ac68a4fb = "#006644";
var $1f929bc90274ebd9$export$226de0355ed012f8 = "#DEEBFF";
var $1f929bc90274ebd9$export$8c13c2ee36917869 = "#B3D4FF";
var $1f929bc90274ebd9$export$ecfc1dff386a3e7a = "#4C9AFF";
var $1f929bc90274ebd9$export$215b7063051591f1 = "#2684FF";
var $1f929bc90274ebd9$export$e62e8919cca44969 = "#0065FF";
var $1f929bc90274ebd9$export$b3de0ae08da2ce64 = "#0052CC";
var $1f929bc90274ebd9$export$a6ee3d71bc067634 = "#0747A6";
var $1f929bc90274ebd9$export$67f15409e87642a1 = "#669DF1";
var $1f929bc90274ebd9$export$f0539dbc42dbb067 = "#8FB8F6";
var $1f929bc90274ebd9$export$363e4475840015bb = "#EAE6FF";
var $1f929bc90274ebd9$export$4b0a4417ed59760f = "#C0B6F2";
var $1f929bc90274ebd9$export$6011520a64d9a187 = "#998DD9";
var $1f929bc90274ebd9$export$a7175d4e9206bc80 = "#8777D9";
var $1f929bc90274ebd9$export$b48405b95304b5a1 = "#6554C0";
var $1f929bc90274ebd9$export$c71e4279dd54a18d = "#5243AA";
var $1f929bc90274ebd9$export$147899de772240ec = "#403294";
var $1f929bc90274ebd9$export$2cf711fe14c66f06 = "#E6FCFF";
var $1f929bc90274ebd9$export$7a8f4d33f6f9772c = "#B3F5FF";
var $1f929bc90274ebd9$export$776c9c497ef08533 = "#79E2F2";
var $1f929bc90274ebd9$export$69cb3ca10c1e330e = "#00C7E6";
var $1f929bc90274ebd9$export$9dc1ef0f3f48059b = "#00B8D9";
var $1f929bc90274ebd9$export$7c835c78b6fcdef8 = "#00A3BF";
var $1f929bc90274ebd9$export$6036577f95c3877e = "#008DA6";
var $1f929bc90274ebd9$export$29a4f05edc054374 = "#FFFFFF";
var $1f929bc90274ebd9$export$e655ef011c4aa1a2 = "#FAFBFC";
var $1f929bc90274ebd9$export$9fdfb749e33cdf97 = "#F4F5F7";
var $1f929bc90274ebd9$export$3e51e8f1440314ba = "#EBECF0";
var $1f929bc90274ebd9$export$1ce2d1575d444ceb = "#DFE1E6";
var $1f929bc90274ebd9$export$8754fc7e6d8b3000 = "#C1C7D0";
var $1f929bc90274ebd9$export$c2e91cbeada39b8b = "#B3BAC5";
var $1f929bc90274ebd9$export$5f71e19f3a7ad9de = "#A5ADBA";
var $1f929bc90274ebd9$export$eaa8c8a70ac22806 = "#97A0AF";
var $1f929bc90274ebd9$export$7c87d337fb91a97d = "#8993A4";
var $1f929bc90274ebd9$export$d6447c357493214f = "#7A869A";
var $1f929bc90274ebd9$export$f563ee71e9ee74cd = "#6B778C";
var $1f929bc90274ebd9$export$e2ef2124cf4024b1 = "#5E6C84";
var $1f929bc90274ebd9$export$eece5f492e429f08 = "#505F79";
var $1f929bc90274ebd9$export$c39c0fe0f26207ae = "#42526E";
var $1f929bc90274ebd9$export$7090862dc3038a9f = "#344563";
var $1f929bc90274ebd9$export$ad0bacf983b7ddaa = "#253858";
var $1f929bc90274ebd9$export$7d61b15e0da132af = "#172B4D";
var $1f929bc90274ebd9$export$fbda843f0a27fe96 = "#091E42";
var $1f929bc90274ebd9$export$791e57b27ca738ef = "rgba(9, 30, 66, 0.02)";
var $1f929bc90274ebd9$export$8d43898f60b96a82 = "rgba(9, 30, 66, 0.04)";
var $1f929bc90274ebd9$export$920c0d5c49070351 = "rgba(9, 30, 66, 0.08)";
var $1f929bc90274ebd9$export$46987b49aab6d1a8 = "rgba(9, 30, 66, 0.13)";
var $1f929bc90274ebd9$export$7d3359664e8bb0e5 = "rgba(9, 30, 66, 0.25)";
var $1f929bc90274ebd9$export$d2d3bedfb276cac0 = "rgba(9, 30, 66, 0.31)";
var $1f929bc90274ebd9$export$6e5e7499ff054f6d = "rgba(9, 30, 66, 0.36)";
var $1f929bc90274ebd9$export$59264b346c877fa7 = "rgba(9, 30, 66, 0.42)";
var $1f929bc90274ebd9$export$d092757d7c64925c = "rgba(9, 30, 66, 0.48)";
var $1f929bc90274ebd9$export$486ab785e4bac3c6 = "rgba(9, 30, 66, 0.54)";
var $1f929bc90274ebd9$export$fba592bbc6419fea = "rgba(9, 30, 66, 0.60)";
var $1f929bc90274ebd9$export$13609db0e6812ab8 = "rgba(9, 30, 66, 0.66)";
var $1f929bc90274ebd9$export$fbae4efaa892d883 = "rgba(9, 30, 66, 0.71)";
var $1f929bc90274ebd9$export$f13946d26f440ce6 = "rgba(9, 30, 66, 0.77)";
var $1f929bc90274ebd9$export$19f58225ac52a306 = "rgba(9, 30, 66, 0.82)";
var $1f929bc90274ebd9$export$6384f09da70e7b62 = "rgba(9, 30, 66, 0.89)";
var $1f929bc90274ebd9$export$d0dccc730683edc2 = "rgba(9, 30, 66, 0.95)";
var $1f929bc90274ebd9$export$2f6319cf7d736c2a = "#E6EDFA";
var $1f929bc90274ebd9$export$95126bc8884d6634 = "#DCE5F5";
var $1f929bc90274ebd9$export$8338d8c35d44ff1 = "#CED9EB";
var $1f929bc90274ebd9$export$5368d76ae4fbbda7 = "#B8C7E0";
var $1f929bc90274ebd9$export$9f0a771d16ec8d36 = "#ABBBD6";
var $1f929bc90274ebd9$export$abcf8c38338b4aa5 = "#9FB0CC";
var $1f929bc90274ebd9$export$97e81faa16a182c7 = "#8C9CB8";
var $1f929bc90274ebd9$export$bfe21c59123ecf33 = "#7988A3";
var $1f929bc90274ebd9$export$ee82aa2ea6a1558 = "#67758F";
var $1f929bc90274ebd9$export$682927c6ed76be02 = "#56637A";
var $1f929bc90274ebd9$export$91fd9994c5be9757 = "#455166";
var $1f929bc90274ebd9$export$d281fbfe3cff2df6 = "#3B475C";
var $1f929bc90274ebd9$export$3902c91d8b98a753 = "#313D52";
var $1f929bc90274ebd9$export$8e8133c1ba5845b5 = "#283447";
var $1f929bc90274ebd9$export$33ff357f6620b39 = "#202B3D";
var $1f929bc90274ebd9$export$633847cf062b69e0 = "#1B2638";
var $1f929bc90274ebd9$export$9776a6e503bdbf76 = "#121A29";
var $1f929bc90274ebd9$export$6c813d5160dff5db = "#0E1624";
var $1f929bc90274ebd9$export$3d4f271a500072a = "#0D1424";
var $1f929bc90274ebd9$export$fe151285c22759ec = "rgba(13, 20, 36, 0.06)";
var $1f929bc90274ebd9$export$a101c6190d0da34 = "rgba(13, 20, 36, 0.14)";
var $1f929bc90274ebd9$export$4b16f52932fda51 = "rgba(13, 20, 36, 0.18)";
var $1f929bc90274ebd9$export$a74bcd7b9845b0d8 = "rgba(13, 20, 36, 0.29)";
var $1f929bc90274ebd9$export$9209c179316d1751 = "rgba(13, 20, 36, 0.36)";
var $1f929bc90274ebd9$export$88f55133f636c8dd = "rgba(13, 20, 36, 0.40)";
var $1f929bc90274ebd9$export$51126f85d1009512 = "rgba(13, 20, 36, 0.47)";
var $1f929bc90274ebd9$export$a069b547bd23af78 = "rgba(13, 20, 36, 0.53)";
var $1f929bc90274ebd9$export$40cce05af3b2600a = "rgba(13, 20, 36, 0.63)";
var $1f929bc90274ebd9$export$b78942185925a0d = "rgba(13, 20, 36, 0.73)";
var $1f929bc90274ebd9$export$e058fb44b8eaafca = "rgba(13, 20, 36, 0.78)";
var $1f929bc90274ebd9$export$92b0b8de26920c18 = "rgba(13, 20, 36, 0.81)";
var $1f929bc90274ebd9$export$67564f7459d3fc9e = "rgba(13, 20, 36, 0.85)";
var $1f929bc90274ebd9$export$77868e1ca884ffa3 = "rgba(13, 20, 36, 0.89)";
var $1f929bc90274ebd9$export$2afd71d7d3ea2cd5 = "rgba(13, 20, 36, 0.92)";
var $1f929bc90274ebd9$export$f2a0acaab9972c70 = "rgba(13, 20, 36, 0.95)";
var $1f929bc90274ebd9$export$9ab70e67d6475361 = "rgba(13, 20, 36, 0.97)";
var $1f929bc90274ebd9$export$d2adc5dedf09fced = "#292A2E";
var $1f929bc90274ebd9$export$f51762073d2bb381 = "#94C748";
var $1f929bc90274ebd9$export$95e26d54def96891 = "#B3DF72";

});

parcelRegister("jyfI2", function(module, exports) {

$parcel$export(module.exports, "SectionContainer", function () { return $e3bd60d5e805f45b$export$be4c8679ebfd988; });
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ /* eslint-disable */ 
var $dAx5m = parcelRequire("dAx5m");

var $12GLU = parcelRequire("12GLU");
var $fDIOj = parcelRequire("fDIOj");

var $885QU = parcelRequire("885QU");

var $jVTBW = parcelRequire("jVTBW");

var $5QmqT = parcelRequire("5QmqT");
var $i8FXL = parcelRequire("i8FXL");

var $2JSZB = parcelRequire("2JSZB");

var $enfj2 = parcelRequire("enfj2");

var $jXZjr = parcelRequire("jXZjr");

var $3xWrW = parcelRequire("3xWrW");

var $3QXCS = parcelRequire("3QXCS");
var $e3bd60d5e805f45b$var$baseSectionContainerStyles = (0, $jVTBW.css)({
    padding: "var(--ds-space-075, 6px)".concat(" 0")
});
var $e3bd60d5e805f45b$var$visualRefreshStyles = (0, $jVTBW.css)({
    paddingTop: "var(--ds-space-100, 8px)",
    overflow: "hidden",
    marginTop: "-1px",
    borderTop: "1px solid ".concat("var(--ds-border, #091E4224)")
});
var $e3bd60d5e805f45b$var$boxStyles = (0, $fDIOj.xcss)({
    marginLeft: "space.100",
    marginRight: "space.100",
    marginTop: "0",
    marginBottom: "space.100"
});
var $e3bd60d5e805f45b$var$secondarySectionTitleBaseStyles = (0, $fDIOj.xcss)({
    overflow: "hidden",
    textOverflow: "ellipsis",
    textTransform: "uppercase",
    whiteSpace: "nowrap",
    marginTop: "space.200",
    marginLeft: "space.100",
    color: "color.text.subtle",
    font: "font.body.small",
    fontWeight: "font.weight.bold",
    marginBottom: "space.050"
});
var $e3bd60d5e805f45b$var$refreshedSecondarySectionTitleBaseStyles = (0, $fDIOj.xcss)({
    marginTop: "space.075",
    marginLeft: "space.100",
    marginBottom: "space.075",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    color: "color.text.subtlest",
    fontWeight: "font.weight.medium"
});
var $e3bd60d5e805f45b$var$sectionChildrenWrapperStyles = (0, $jVTBW.css)({
    listStyleType: "none",
    padding: 0,
    margin: 0
});
var $e3bd60d5e805f45b$export$7bb82566a1f2a4f5 = function SectionContainerTitle(_ref) {
    var title = _ref.title;
    var isVisualRefreshEnabled = (0, $3QXCS.useIsSwitcherTeam25TestCohort)();
    return (0, $jVTBW.jsx)((0, $3xWrW.default), {
        as: "h3",
        size: "xxsmall"
    }, (0, $jVTBW.jsx)((0, $12GLU.default), {
        xcss: isVisualRefreshEnabled ? $e3bd60d5e805f45b$var$refreshedSecondarySectionTitleBaseStyles : $e3bd60d5e805f45b$var$secondarySectionTitleBaseStyles
    }, title));
};
var $e3bd60d5e805f45b$var$SectionContainerComponent = function SectionContainerComponent(_ref2) {
    var title = _ref2.title, titleLink = _ref2.titleLink, children = _ref2.children, actionSubject = _ref2.actionSubject, sectionId = _ref2.sectionId, sectionRole = _ref2.sectionRole, ariaLabel = _ref2.ariaLabel;
    var isVisualRefreshEnabled = (0, $3QXCS.useIsSwitcherTeam25TestCohort)();
    return (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).Children.toArray(children).some(Boolean) ? (0, $jVTBW.jsx)("section", {
        css: isVisualRefreshEnabled ? $e3bd60d5e805f45b$var$visualRefreshStyles : $e3bd60d5e805f45b$var$baseSectionContainerStyles,
        "data-testid": "".concat(sectionId, "__section"),
        role: sectionRole,
        "aria-label": ariaLabel
    }, (0, $jVTBW.jsx)((0, $12GLU.default), {
        xcss: isVisualRefreshEnabled ? $e3bd60d5e805f45b$var$boxStyles : undefined
    }, (0, $jVTBW.jsx)((0, $2JSZB.FadeIn), null, title && (0, $jVTBW.jsx)($e3bd60d5e805f45b$export$7bb82566a1f2a4f5, {
        title: title
    }), titleLink && (0, $jVTBW.jsx)($e3bd60d5e805f45b$var$TitleLink, {
        titleLink: titleLink,
        actionSubject: actionSubject
    })), (0, $jVTBW.jsx)("ul", {
        css: $e3bd60d5e805f45b$var$sectionChildrenWrapperStyles
    }, children))) : null;
};
var $e3bd60d5e805f45b$var$TitleLink = function TitleLink(_ref3) {
    var titleLink = _ref3.titleLink, actionSubject = _ref3.actionSubject;
    return (0, $jVTBW.jsx)((0, $i8FXL.NavigationAnalyticsContext), {
        key: titleLink.key,
        data: (0, $5QmqT.getItemAnalyticsContext)(0, titleLink.key, (0, $jXZjr.AnalyticsItemType).PRODUCT, titleLink.productType)
    }, (0, $jVTBW.jsx)((0, $enfj2.default), {
        href: titleLink.href,
        iconAfter: (0, $jVTBW.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($885QU))), {
            LEGACY_size: "small",
            color: "currentColor",
            label: ""
        }),
        label: titleLink.label,
        testId: "section-title__link",
        actionSubject: actionSubject,
        ariaLabel: titleLink.ariaLabel
    }));
};
var $e3bd60d5e805f45b$export$be4c8679ebfd988 = (0, $5QmqT.withAnalyticsContextData)(function(props) {
    return (0, $5QmqT.analyticsAttributes)({
        group: props.sectionId,
        groupItemsCount: (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).Children.toArray(props.children).filter(function(child) {
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).isValidElement(child);
        }).length
    });
})($e3bd60d5e805f45b$var$SectionContainerComponent); /* eslint-enable */ 

});
parcelRegister("12GLU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0c2727e9cc95cb8c$export$2e2bcd8739ae039; });

var $lDu5G = parcelRequire("lDu5G");

var $ikhrG = parcelRequire("ikhrG");

var $dAx5m = parcelRequire("dAx5m");

var $jVTBW = parcelRequire("jVTBW");

var $8NxUT = parcelRequire("8NxUT");

var $dG34F = parcelRequire("dG34F");

var $fDIOj = parcelRequire("fDIOj");
var $0c2727e9cc95cb8c$var$_excluded = [
    "as",
    "children",
    "backgroundColor",
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    "style",
    "testId",
    "xcss"
], $0c2727e9cc95cb8c$var$_excluded2 = [
    "className"
];
var $0c2727e9cc95cb8c$export$e71c4d32a2263218 = /*#__PURE__*/ (0, $dAx5m.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? "div" : _ref$as, children = _ref.children, backgroundColor = _ref.backgroundColor, padding = _ref.padding, paddingBlock = _ref.paddingBlock, paddingBlockStart = _ref.paddingBlockStart, paddingBlockEnd = _ref.paddingBlockEnd, paddingInline = _ref.paddingInline, paddingInlineStart = _ref.paddingInlineStart, paddingInlineEnd = _ref.paddingInlineEnd, style = _ref.style, testId = _ref.testId, xcss = _ref.xcss, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($ikhrG)))(_ref, $0c2727e9cc95cb8c$var$_excluded);
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($ikhrG)))(htmlAttributes, $0c2727e9cc95cb8c$var$_excluded2);
    var resolvedStyles = (0, $fDIOj.parseXcss)(xcss);
    var node = // @ts-expect-error Expression produces a union type that is too complex to represent. I think this is unavoidable
    (0, $jVTBW.jsx)(Component, (0, (/*@__PURE__*/$parcel$interopDefault($lDu5G)))({
        style: style,
        ref: ref,
        className: resolvedStyles.static
    }, safeHtmlAttributes, {
        css: [
            $0c2727e9cc95cb8c$var$baseStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            backgroundColor && (0, $dG34F.backgroundColorStylesMap)[backgroundColor],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $dG34F.isSurfaceColorToken)(backgroundColor) && (0, $dG34F.surfaceColorStylesMap)[backgroundColor],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            padding && (0, $dG34F.paddingStylesMap).padding[padding],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlock && (0, $dG34F.paddingStylesMap).paddingBlock[paddingBlock],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockStart && (0, $dG34F.paddingStylesMap).paddingBlockStart[paddingBlockStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockEnd && (0, $dG34F.paddingStylesMap).paddingBlockEnd[paddingBlockEnd],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInline && (0, $dG34F.paddingStylesMap).paddingInline[paddingInline],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineStart && (0, $dG34F.paddingStylesMap).paddingInlineStart[paddingInlineStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineEnd && (0, $dG34F.paddingStylesMap).paddingInlineEnd[paddingInlineEnd],
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            resolvedStyles.emotion
        ],
        "data-testid": testId
    }), children);
    return backgroundColor ? (0, $jVTBW.jsx)((0, $8NxUT.SurfaceContext).Provider, {
        value: backgroundColor
    }, node) : node;
});
var $0c2727e9cc95cb8c$export$2e2bcd8739ae039 = $0c2727e9cc95cb8c$export$e71c4d32a2263218;
var $0c2727e9cc95cb8c$var$baseStyles = (0, $jVTBW.css)({
    boxSizing: "border-box",
    appearance: "none",
    border: "none"
});

});
parcelRegister("8NxUT", function(module, exports) {

$parcel$export(module.exports, "SurfaceContext", function () { return $667d3575cccafcd0$export$1ca2a26fecb070ae; });
$parcel$export(module.exports, "useSurface", function () { return $667d3575cccafcd0$export$1aeb4f6b93c4540d; });

var $dAx5m = parcelRequire("dAx5m");
var $667d3575cccafcd0$export$1ca2a26fecb070ae = /*#__PURE__*/ (0, $dAx5m.createContext)("elevation.surface");
var $667d3575cccafcd0$export$1aeb4f6b93c4540d = function useSurface() {
    return (0, $dAx5m.useContext)($667d3575cccafcd0$export$1ca2a26fecb070ae);
};
$667d3575cccafcd0$export$1ca2a26fecb070ae.displayName = "SurfaceProvider";

});

parcelRegister("dG34F", function(module, exports) {

$parcel$export(module.exports, "dimensionMap", function () { return $9f51951cdbbc6069$export$6ccdbebca2ee545f; });
$parcel$export(module.exports, "positiveSpaceMap", function () { return $9f51951cdbbc6069$export$958d0ae7f2977ae4; });
$parcel$export(module.exports, "allSpaceMap", function () { return $9f51951cdbbc6069$export$632685d741f3dbbf; });
$parcel$export(module.exports, "inverseColorMap", function () { return $9f51951cdbbc6069$export$2185ce37f9bdd963; });
$parcel$export(module.exports, "opacityMap", function () { return $9f51951cdbbc6069$export$daf94a976c798b4f; });
$parcel$export(module.exports, "shadowMap", function () { return $9f51951cdbbc6069$export$7aff6e7ba39bb774; });
$parcel$export(module.exports, "borderColorMap", function () { return $9f51951cdbbc6069$export$1531ad5bb3fbedac; });
$parcel$export(module.exports, "backgroundColorMap", function () { return $9f51951cdbbc6069$export$d1d79bf68ac056bd; });
$parcel$export(module.exports, "textColorMap", function () { return $9f51951cdbbc6069$export$8473307aa00d6ea1; });
$parcel$export(module.exports, "layerMap", function () { return $9f51951cdbbc6069$export$b5f31a7e431d2eab; });
$parcel$export(module.exports, "borderWidthMap", function () { return $9f51951cdbbc6069$export$e1b83c5210c471b8; });
$parcel$export(module.exports, "borderRadiusMap", function () { return $9f51951cdbbc6069$export$3c0a6c3e64bb180d; });
$parcel$export(module.exports, "fontMap", function () { return $9f51951cdbbc6069$export$6ffa317d5e70375; });
$parcel$export(module.exports, "fontWeightMap", function () { return $9f51951cdbbc6069$export$303e322c6b1ed114; });
$parcel$export(module.exports, "fontFamilyMap", function () { return $9f51951cdbbc6069$export$3c7e9587132614b4; });
$parcel$export(module.exports, "paddingStylesMap", function () { return $9f51951cdbbc6069$export$e615f061ca585a6c; });
$parcel$export(module.exports, "spaceStylesMap", function () { return $9f51951cdbbc6069$export$bf46c3f9eeafc71f; });
$parcel$export(module.exports, "backgroundColorStylesMap", function () { return $9f51951cdbbc6069$export$e7af83bafe7f9e63; });
$parcel$export(module.exports, "textColorStylesMap", function () { return $9f51951cdbbc6069$export$3a1bcba60b23d7f0; });
$parcel$export(module.exports, "textSizeStylesMap", function () { return $9f51951cdbbc6069$export$219d364c0da35ae4; });
$parcel$export(module.exports, "textWeightStylesMap", function () { return $9f51951cdbbc6069$export$38845ca010b93505; });
$parcel$export(module.exports, "surfaceColorStylesMap", function () { return $9f51951cdbbc6069$export$ff257d957d48c421; });
$parcel$export(module.exports, "isSurfaceColorToken", function () { return $9f51951cdbbc6069$export$5e65a44e5b6ecadb; });

var $9HWAT = parcelRequire("9HWAT");

var $jVTBW = parcelRequire("jVTBW");

var $ePLY9 = parcelRequire("ePLY9");
function $9f51951cdbbc6069$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $9f51951cdbbc6069$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $9f51951cdbbc6069$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($9HWAT)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $9f51951cdbbc6069$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $9f51951cdbbc6069$export$6ccdbebca2ee545f = {
    "100%": "100%",
    "size.100": "1rem",
    "size.200": "1.5rem",
    "size.300": "2rem",
    "size.400": "2.5rem",
    "size.500": "3rem",
    "size.600": "6rem",
    "size.1000": "12rem"
};
var $9f51951cdbbc6069$export$958d0ae7f2977ae4 = {
    "space.0": "var(--ds-space-0, 0px)",
    "space.025": "var(--ds-space-025, 2px)",
    "space.050": "var(--ds-space-050, 4px)",
    "space.075": "var(--ds-space-075, 6px)",
    "space.100": "var(--ds-space-100, 8px)",
    "space.150": "var(--ds-space-150, 12px)",
    "space.200": "var(--ds-space-200, 16px)",
    "space.250": "var(--ds-space-250, 20px)",
    "space.300": "var(--ds-space-300, 24px)",
    "space.400": "var(--ds-space-400, 32px)",
    "space.500": "var(--ds-space-500, 40px)",
    "space.600": "var(--ds-space-600, 48px)",
    "space.800": "var(--ds-space-800, 64px)",
    "space.1000": "var(--ds-space-1000, 80px)"
};
var $9f51951cdbbc6069$export$d2dc61f58390201c = {
    "space.negative.025": "var(--ds-space-negative-025, -2px)",
    "space.negative.050": "var(--ds-space-negative-050, -4px)",
    "space.negative.075": "var(--ds-space-negative-075, -6px)",
    "space.negative.100": "var(--ds-space-negative-100, -8px)",
    "space.negative.150": "var(--ds-space-negative-150, -12px)",
    "space.negative.200": "var(--ds-space-negative-200, -16px)",
    "space.negative.250": "var(--ds-space-negative-250, -20px)",
    "space.negative.300": "var(--ds-space-negative-300, -24px)",
    "space.negative.400": "var(--ds-space-negative-400, -32px)"
};
var $9f51951cdbbc6069$export$632685d741f3dbbf = $9f51951cdbbc6069$var$_objectSpread($9f51951cdbbc6069$var$_objectSpread({}, $9f51951cdbbc6069$export$958d0ae7f2977ae4), $9f51951cdbbc6069$export$d2dc61f58390201c);
var $9f51951cdbbc6069$export$2185ce37f9bdd963 = {
    "color.background.neutral.bold": "color.text.inverse",
    "color.background.neutral.bold.hovered": "color.text.inverse",
    "color.background.neutral.bold.pressed": "color.text.inverse",
    "color.background.selected.bold": "color.text.inverse",
    "color.background.selected.bold.hovered": "color.text.inverse",
    "color.background.selected.bold.pressed": "color.text.inverse",
    "color.background.brand.bold": "color.text.inverse",
    "color.background.brand.bold.hovered": "color.text.inverse",
    "color.background.brand.bold.pressed": "color.text.inverse",
    "color.background.brand.boldest": "color.text.inverse",
    "color.background.brand.boldest.hovered": "color.text.inverse",
    "color.background.brand.boldest.pressed": "color.text.inverse",
    "color.background.danger.bold": "color.text.inverse",
    "color.background.danger.bold.hovered": "color.text.inverse",
    "color.background.danger.bold.pressed": "color.text.inverse",
    "color.background.warning.bold": "color.text.warning.inverse",
    "color.background.warning.bold.hovered": "color.text.warning.inverse",
    "color.background.warning.bold.pressed": "color.text.warning.inverse",
    "color.background.success.bold": "color.text.inverse",
    "color.background.success.bold.hovered": "color.text.inverse",
    "color.background.success.bold.pressed": "color.text.inverse",
    "color.background.discovery.bold": "color.text.inverse",
    "color.background.discovery.bold.hovered": "color.text.inverse",
    "color.background.discovery.bold.pressed": "color.text.inverse",
    "color.background.information.bold": "color.text.inverse",
    "color.background.information.bold.hovered": "color.text.inverse",
    "color.background.information.bold.pressed": "color.text.inverse"
};
var $9f51951cdbbc6069$export$daf94a976c798b4f = {
    "opacity.disabled": "var(--ds-opacity-disabled, 0.4)",
    "opacity.loading": "var(--ds-opacity-loading, 0.2)"
};
var $9f51951cdbbc6069$export$7aff6e7ba39bb774 = {
    "elevation.shadow.overflow": "var(--ds-shadow-overflow, 0px 0px 8px #091e423f, 0px 0px 1px #091e424f)",
    "elevation.shadow.overflow.perimeter": "var(--ds-shadow-overflow-perimeter, #091e421f)",
    "elevation.shadow.overflow.spread": "var(--ds-shadow-overflow-spread, #091e4229)",
    "elevation.shadow.overlay": "var(--ds-shadow-overlay, 0px 8px 12px #091e423f, 0px 0px 1px #091e424f)",
    "elevation.shadow.raised": "var(--ds-shadow-raised, 0px 1px 1px #091e423f, 0px 0px 1px #091e4221)"
};
var $9f51951cdbbc6069$export$41a358c9c2356760 = {
    "elevation.surface": "var(--ds-surface, #FFFFFF)",
    "elevation.surface.hovered": "var(--ds-surface-hovered, #FAFBFC)",
    "elevation.surface.pressed": "var(--ds-surface-pressed, #F4F5F7)",
    "elevation.surface.overlay": "var(--ds-surface-overlay, #FFFFFF)",
    "elevation.surface.overlay.hovered": "var(--ds-surface-overlay-hovered, #FAFBFC)",
    "elevation.surface.overlay.pressed": "var(--ds-surface-overlay-pressed, #F4F5F7)",
    "elevation.surface.raised": "var(--ds-surface-raised, #FFFFFF)",
    "elevation.surface.raised.hovered": "var(--ds-surface-raised-hovered, #FAFBFC)",
    "elevation.surface.raised.pressed": "var(--ds-surface-raised-pressed, #F4F5F7)",
    "elevation.surface.sunken": "var(--ds-surface-sunken, #F4F5F7)"
};
var $9f51951cdbbc6069$export$1531ad5bb3fbedac = {
    "color.border": "var(--ds-border, #091e4221)",
    "color.border.accent.lime": "var(--ds-border-accent-lime, #6A9A23)",
    "color.border.accent.red": "var(--ds-border-accent-red, #FF5630)",
    "color.border.accent.orange": "var(--ds-border-accent-orange, #D94008)",
    "color.border.accent.yellow": "var(--ds-border-accent-yellow, #FFAB00)",
    "color.border.accent.green": "var(--ds-border-accent-green, #36B37E)",
    "color.border.accent.teal": "var(--ds-border-accent-teal, #00B8D9)",
    "color.border.accent.blue": "var(--ds-border-accent-blue, #0065FF)",
    "color.border.accent.purple": "var(--ds-border-accent-purple, #6554C0)",
    "color.border.accent.magenta": "var(--ds-border-accent-magenta, #CD519D)",
    "color.border.accent.gray": "var(--ds-border-accent-gray, #5E6C84)",
    "color.border.disabled": "var(--ds-border-disabled, #FAFBFC)",
    "color.border.focused": "var(--ds-border-focused, #2684FF)",
    "color.border.input": "var(--ds-border-input, #FAFBFC)",
    "color.border.inverse": "var(--ds-border-inverse, #FFFFFF)",
    "color.border.selected": "var(--ds-border-selected, #0052CC)",
    "color.border.brand": "var(--ds-border-brand, #0052CC)",
    "color.border.danger": "var(--ds-border-danger, #FF5630)",
    "color.border.warning": "var(--ds-border-warning, #FFC400)",
    "color.border.success": "var(--ds-border-success, #00875A)",
    "color.border.discovery": "var(--ds-border-discovery, #998DD9)",
    "color.border.information": "var(--ds-border-information, #0065FF)",
    "color.border.bold": "var(--ds-border-bold, #344563)"
};
var $9f51951cdbbc6069$export$d1d79bf68ac056bd = {
    "color.background.accent.lime.subtlest": "var(--ds-background-accent-lime-subtlest, #EEFBDA)",
    "color.background.accent.lime.subtlest.hovered": "var(--ds-background-accent-lime-subtlest-hovered, #D3F1A7)",
    "color.background.accent.lime.subtlest.pressed": "var(--ds-background-accent-lime-subtlest-pressed, #B3DF72)",
    "color.background.accent.lime.subtler": "var(--ds-background-accent-lime-subtler, #D3F1A7)",
    "color.background.accent.lime.subtler.hovered": "var(--ds-background-accent-lime-subtler-hovered, #B3DF72)",
    "color.background.accent.lime.subtler.pressed": "var(--ds-background-accent-lime-subtler-pressed, #94C748)",
    "color.background.accent.lime.subtle": "var(--ds-background-accent-lime-subtle, #94C748)",
    "color.background.accent.lime.subtle.hovered": "var(--ds-background-accent-lime-subtle-hovered, #B3DF72)",
    "color.background.accent.lime.subtle.pressed": "var(--ds-background-accent-lime-subtle-pressed, #D3F1A7)",
    "color.background.accent.lime.bolder": "var(--ds-background-accent-lime-bolder, #5B7F24)",
    "color.background.accent.lime.bolder.hovered": "var(--ds-background-accent-lime-bolder-hovered, #37471F)",
    "color.background.accent.lime.bolder.pressed": "var(--ds-background-accent-lime-bolder-pressed, #37471F)",
    "color.background.accent.red.subtlest": "var(--ds-background-accent-red-subtlest, #FF8F73)",
    "color.background.accent.red.subtlest.hovered": "var(--ds-background-accent-red-subtlest-hovered, #FF7452)",
    "color.background.accent.red.subtlest.pressed": "var(--ds-background-accent-red-subtlest-pressed, #FF5630)",
    "color.background.accent.red.subtler": "var(--ds-background-accent-red-subtler, #FF7452)",
    "color.background.accent.red.subtler.hovered": "var(--ds-background-accent-red-subtler-hovered, #FF5630)",
    "color.background.accent.red.subtler.pressed": "var(--ds-background-accent-red-subtler-pressed, #DE350B)",
    "color.background.accent.red.subtle": "var(--ds-background-accent-red-subtle, #DE350B)",
    "color.background.accent.red.subtle.hovered": "var(--ds-background-accent-red-subtle-hovered, #FF5630)",
    "color.background.accent.red.subtle.pressed": "var(--ds-background-accent-red-subtle-pressed, #FF7452)",
    "color.background.accent.red.bolder": "var(--ds-background-accent-red-bolder, #DE350B)",
    "color.background.accent.red.bolder.hovered": "var(--ds-background-accent-red-bolder-hovered, #FF5630)",
    "color.background.accent.red.bolder.pressed": "var(--ds-background-accent-red-bolder-pressed, #FF7452)",
    "color.background.accent.orange.subtlest": "var(--ds-background-accent-orange-subtlest, #F18D13)",
    "color.background.accent.orange.subtlest.hovered": "var(--ds-background-accent-orange-subtlest-hovered, #FEC57B)",
    "color.background.accent.orange.subtlest.pressed": "var(--ds-background-accent-orange-subtlest-pressed, #FFE2BD)",
    "color.background.accent.orange.subtler": "var(--ds-background-accent-orange-subtler, #B65C02)",
    "color.background.accent.orange.subtler.hovered": "var(--ds-background-accent-orange-subtler-hovered, #F18D13)",
    "color.background.accent.orange.subtler.pressed": "var(--ds-background-accent-orange-subtler-pressed, #FEC57B)",
    "color.background.accent.orange.subtle": "var(--ds-background-accent-orange-subtle, #5F3811)",
    "color.background.accent.orange.subtle.hovered": "var(--ds-background-accent-orange-subtle-hovered, #974F0C)",
    "color.background.accent.orange.subtle.pressed": "var(--ds-background-accent-orange-subtle-pressed, #B65C02)",
    "color.background.accent.orange.bolder": "var(--ds-background-accent-orange-bolder, #43290F)",
    "color.background.accent.orange.bolder.hovered": "var(--ds-background-accent-orange-bolder-hovered, #5F3811)",
    "color.background.accent.orange.bolder.pressed": "var(--ds-background-accent-orange-bolder-pressed, #974F0C)",
    "color.background.accent.yellow.subtlest": "var(--ds-background-accent-yellow-subtlest, #FFE380)",
    "color.background.accent.yellow.subtlest.hovered": "var(--ds-background-accent-yellow-subtlest-hovered, #FFC400)",
    "color.background.accent.yellow.subtlest.pressed": "var(--ds-background-accent-yellow-subtlest-pressed, #FFAB00)",
    "color.background.accent.yellow.subtler": "var(--ds-background-accent-yellow-subtler, #FFC400)",
    "color.background.accent.yellow.subtler.hovered": "var(--ds-background-accent-yellow-subtler-hovered, #FFAB00)",
    "color.background.accent.yellow.subtler.pressed": "var(--ds-background-accent-yellow-subtler-pressed, #FF991F)",
    "color.background.accent.yellow.subtle": "var(--ds-background-accent-yellow-subtle, #FF991F)",
    "color.background.accent.yellow.subtle.hovered": "var(--ds-background-accent-yellow-subtle-hovered, #FFAB00)",
    "color.background.accent.yellow.subtle.pressed": "var(--ds-background-accent-yellow-subtle-pressed, #FFC400)",
    "color.background.accent.yellow.bolder": "var(--ds-background-accent-yellow-bolder, #FF991F)",
    "color.background.accent.yellow.bolder.hovered": "var(--ds-background-accent-yellow-bolder-hovered, #FFAB00)",
    "color.background.accent.yellow.bolder.pressed": "var(--ds-background-accent-yellow-bolder-pressed, #FFC400)",
    "color.background.accent.green.subtlest": "var(--ds-background-accent-green-subtlest, #79F2C0)",
    "color.background.accent.green.subtlest.hovered": "var(--ds-background-accent-green-subtlest-hovered, #57D9A3)",
    "color.background.accent.green.subtlest.pressed": "var(--ds-background-accent-green-subtlest-pressed, #36B37E)",
    "color.background.accent.green.subtler": "var(--ds-background-accent-green-subtler, #57D9A3)",
    "color.background.accent.green.subtler.hovered": "var(--ds-background-accent-green-subtler-hovered, #36B37E)",
    "color.background.accent.green.subtler.pressed": "var(--ds-background-accent-green-subtler-pressed, #00875A)",
    "color.background.accent.green.subtle": "var(--ds-background-accent-green-subtle, #00875A)",
    "color.background.accent.green.subtle.hovered": "var(--ds-background-accent-green-subtle-hovered, #36B37E)",
    "color.background.accent.green.subtle.pressed": "var(--ds-background-accent-green-subtle-pressed, #57D9A3)",
    "color.background.accent.green.bolder": "var(--ds-background-accent-green-bolder, #00875A)",
    "color.background.accent.green.bolder.hovered": "var(--ds-background-accent-green-bolder-hovered, #36B37E)",
    "color.background.accent.green.bolder.pressed": "var(--ds-background-accent-green-bolder-pressed, #57D9A3)",
    "color.background.accent.teal.subtlest": "var(--ds-background-accent-teal-subtlest, #79E2F2)",
    "color.background.accent.teal.subtlest.hovered": "var(--ds-background-accent-teal-subtlest-hovered, #00C7E6)",
    "color.background.accent.teal.subtlest.pressed": "var(--ds-background-accent-teal-subtlest-pressed, #00B8D9)",
    "color.background.accent.teal.subtler": "var(--ds-background-accent-teal-subtler, #00C7E6)",
    "color.background.accent.teal.subtler.hovered": "var(--ds-background-accent-teal-subtler-hovered, #00B8D9)",
    "color.background.accent.teal.subtler.pressed": "var(--ds-background-accent-teal-subtler-pressed, #00A3BF)",
    "color.background.accent.teal.subtle": "var(--ds-background-accent-teal-subtle, #00A3BF)",
    "color.background.accent.teal.subtle.hovered": "var(--ds-background-accent-teal-subtle-hovered, #00B8D9)",
    "color.background.accent.teal.subtle.pressed": "var(--ds-background-accent-teal-subtle-pressed, #00C7E6)",
    "color.background.accent.teal.bolder": "var(--ds-background-accent-teal-bolder, #00A3BF)",
    "color.background.accent.teal.bolder.hovered": "var(--ds-background-accent-teal-bolder-hovered, #00B8D9)",
    "color.background.accent.teal.bolder.pressed": "var(--ds-background-accent-teal-bolder-pressed, #00C7E6)",
    "color.background.accent.blue.subtlest": "var(--ds-background-accent-blue-subtlest, #4C9AFF)",
    "color.background.accent.blue.subtlest.hovered": "var(--ds-background-accent-blue-subtlest-hovered, #2684FF)",
    "color.background.accent.blue.subtlest.pressed": "var(--ds-background-accent-blue-subtlest-pressed, #0065FF)",
    "color.background.accent.blue.subtler": "var(--ds-background-accent-blue-subtler, #2684FF)",
    "color.background.accent.blue.subtler.hovered": "var(--ds-background-accent-blue-subtler-hovered, #0065FF)",
    "color.background.accent.blue.subtler.pressed": "var(--ds-background-accent-blue-subtler-pressed, #0052CC)",
    "color.background.accent.blue.subtle": "var(--ds-background-accent-blue-subtle, #0052CC)",
    "color.background.accent.blue.subtle.hovered": "var(--ds-background-accent-blue-subtle-hovered, #0065FF)",
    "color.background.accent.blue.subtle.pressed": "var(--ds-background-accent-blue-subtle-pressed, #2684FF)",
    "color.background.accent.blue.bolder": "var(--ds-background-accent-blue-bolder, #0052CC)",
    "color.background.accent.blue.bolder.hovered": "var(--ds-background-accent-blue-bolder-hovered, #0065FF)",
    "color.background.accent.blue.bolder.pressed": "var(--ds-background-accent-blue-bolder-pressed, #2684FF)",
    "color.background.accent.purple.subtlest": "var(--ds-background-accent-purple-subtlest, #998DD9)",
    "color.background.accent.purple.subtlest.hovered": "var(--ds-background-accent-purple-subtlest-hovered, #8777D9)",
    "color.background.accent.purple.subtlest.pressed": "var(--ds-background-accent-purple-subtlest-pressed, #6554C0)",
    "color.background.accent.purple.subtler": "var(--ds-background-accent-purple-subtler, #8777D9)",
    "color.background.accent.purple.subtler.hovered": "var(--ds-background-accent-purple-subtler-hovered, #6554C0)",
    "color.background.accent.purple.subtler.pressed": "var(--ds-background-accent-purple-subtler-pressed, #5243AA)",
    "color.background.accent.purple.subtle": "var(--ds-background-accent-purple-subtle, #5243AA)",
    "color.background.accent.purple.subtle.hovered": "var(--ds-background-accent-purple-subtle-hovered, #6554C0)",
    "color.background.accent.purple.subtle.pressed": "var(--ds-background-accent-purple-subtle-pressed, #8777D9)",
    "color.background.accent.purple.bolder": "var(--ds-background-accent-purple-bolder, #5243AA)",
    "color.background.accent.purple.bolder.hovered": "var(--ds-background-accent-purple-bolder-hovered, #6554C0)",
    "color.background.accent.purple.bolder.pressed": "var(--ds-background-accent-purple-bolder-pressed, #8777D9)",
    "color.background.accent.magenta.subtlest": "var(--ds-background-accent-magenta-subtlest, #FFECF8)",
    "color.background.accent.magenta.subtlest.hovered": "var(--ds-background-accent-magenta-subtlest-hovered, #FDD0EC)",
    "color.background.accent.magenta.subtlest.pressed": "var(--ds-background-accent-magenta-subtlest-pressed, #F797D2)",
    "color.background.accent.magenta.subtler": "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
    "color.background.accent.magenta.subtler.hovered": "var(--ds-background-accent-magenta-subtler-hovered, #F797D2)",
    "color.background.accent.magenta.subtler.pressed": "var(--ds-background-accent-magenta-subtler-pressed, #E774BB)",
    "color.background.accent.magenta.subtle": "var(--ds-background-accent-magenta-subtle, #E774BB)",
    "color.background.accent.magenta.subtle.hovered": "var(--ds-background-accent-magenta-subtle-hovered, #F797D2)",
    "color.background.accent.magenta.subtle.pressed": "var(--ds-background-accent-magenta-subtle-pressed, #FDD0EC)",
    "color.background.accent.magenta.bolder": "var(--ds-background-accent-magenta-bolder, #AE4787)",
    "color.background.accent.magenta.bolder.hovered": "var(--ds-background-accent-magenta-bolder-hovered, #943D73)",
    "color.background.accent.magenta.bolder.pressed": "var(--ds-background-accent-magenta-bolder-pressed, #50253F)",
    "color.background.accent.gray.subtlest": "var(--ds-background-accent-gray-subtlest, #6B778C)",
    "color.background.accent.gray.subtlest.hovered": "var(--ds-background-accent-gray-subtlest-hovered, #5E6C84)",
    "color.background.accent.gray.subtlest.pressed": "var(--ds-background-accent-gray-subtlest-pressed, #505F79)",
    "color.background.accent.gray.subtler": "var(--ds-background-accent-gray-subtler, #5E6C84)",
    "color.background.accent.gray.subtler.hovered": "var(--ds-background-accent-gray-subtler-hovered, #505F79)",
    "color.background.accent.gray.subtler.pressed": "var(--ds-background-accent-gray-subtler-pressed, #42526E)",
    "color.background.accent.gray.subtle": "var(--ds-background-accent-gray-subtle, #505F79)",
    "color.background.accent.gray.subtle.hovered": "var(--ds-background-accent-gray-subtle-hovered, #5E6C84)",
    "color.background.accent.gray.subtle.pressed": "var(--ds-background-accent-gray-subtle-pressed, #6B778C)",
    "color.background.accent.gray.bolder": "var(--ds-background-accent-gray-bolder, #42526E)",
    "color.background.accent.gray.bolder.hovered": "var(--ds-background-accent-gray-bolder-hovered, #344563)",
    "color.background.accent.gray.bolder.pressed": "var(--ds-background-accent-gray-bolder-pressed, #253858)",
    "color.background.disabled": "var(--ds-background-disabled, #091e4289)",
    "color.background.input": "var(--ds-background-input, #FAFBFC)",
    "color.background.input.hovered": "var(--ds-background-input-hovered, #EBECF0)",
    "color.background.input.pressed": "var(--ds-background-input-pressed, #FFFFFF)",
    "color.background.inverse.subtle": "var(--ds-background-inverse-subtle, #00000029)",
    "color.background.inverse.subtle.hovered": "var(--ds-background-inverse-subtle-hovered, #0000003D)",
    "color.background.inverse.subtle.pressed": "var(--ds-background-inverse-subtle-pressed, #00000052)",
    "color.background.neutral": "var(--ds-background-neutral, #DFE1E6)",
    "color.background.neutral.hovered": "var(--ds-background-neutral-hovered, #091e4214)",
    "color.background.neutral.pressed": "var(--ds-background-neutral-pressed, #B3D4FF)",
    "color.background.neutral.subtle": "var(--ds-background-neutral-subtle, transparent)",
    "color.background.neutral.subtle.hovered": "var(--ds-background-neutral-subtle-hovered, #091e4214)",
    "color.background.neutral.subtle.pressed": "var(--ds-background-neutral-subtle-pressed, #B3D4FF)",
    "color.background.neutral.bold": "var(--ds-background-neutral-bold, #42526E)",
    "color.background.neutral.bold.hovered": "var(--ds-background-neutral-bold-hovered, #505F79)",
    "color.background.neutral.bold.pressed": "var(--ds-background-neutral-bold-pressed, #344563)",
    "color.background.selected": "var(--ds-background-selected, #DEEBFF)",
    "color.background.selected.hovered": "var(--ds-background-selected-hovered, #B3D4FF)",
    "color.background.selected.pressed": "var(--ds-background-selected-pressed, #4C9AFF)",
    "color.background.selected.bold": "var(--ds-background-selected-bold, #0052CC)",
    "color.background.selected.bold.hovered": "var(--ds-background-selected-bold-hovered, #2684FF)",
    "color.background.selected.bold.pressed": "var(--ds-background-selected-bold-pressed, #0052CC)",
    "color.background.brand.subtlest": "var(--ds-background-brand-subtlest, #B3D4FF)",
    "color.background.brand.subtlest.hovered": "var(--ds-background-brand-subtlest-hovered, #DEEBFF)",
    "color.background.brand.subtlest.pressed": "var(--ds-background-brand-subtlest-pressed, #4C9AFF)",
    "color.background.brand.bold": "var(--ds-background-brand-bold, #0052CC)",
    "color.background.brand.bold.hovered": "var(--ds-background-brand-bold-hovered, #0065FF)",
    "color.background.brand.bold.pressed": "var(--ds-background-brand-bold-pressed, #0747A6)",
    "color.background.brand.boldest": "var(--ds-background-brand-boldest, #0747A6)",
    "color.background.brand.boldest.hovered": "var(--ds-background-brand-boldest-hovered, #0052CC)",
    "color.background.brand.boldest.pressed": "var(--ds-background-brand-boldest-pressed, #0747A6)",
    "color.background.danger": "var(--ds-background-danger, #FFEBE6)",
    "color.background.danger.hovered": "var(--ds-background-danger-hovered, #FFBDAD)",
    "color.background.danger.pressed": "var(--ds-background-danger-pressed, #FF8F73)",
    "color.background.danger.bold": "var(--ds-background-danger-bold, #DE350B)",
    "color.background.danger.bold.hovered": "var(--ds-background-danger-bold-hovered, #FF5630)",
    "color.background.danger.bold.pressed": "var(--ds-background-danger-bold-pressed, #BF2600)",
    "color.background.warning": "var(--ds-background-warning, #FFFAE6)",
    "color.background.warning.hovered": "var(--ds-background-warning-hovered, #FFF0B3)",
    "color.background.warning.pressed": "var(--ds-background-warning-pressed, #FFE380)",
    "color.background.warning.bold": "var(--ds-background-warning-bold, #FFAB00)",
    "color.background.warning.bold.hovered": "var(--ds-background-warning-bold-hovered, #FFC400)",
    "color.background.warning.bold.pressed": "var(--ds-background-warning-bold-pressed, #FF991F)",
    "color.background.success": "var(--ds-background-success, #E3FCEF)",
    "color.background.success.hovered": "var(--ds-background-success-hovered, #ABF5D1)",
    "color.background.success.pressed": "var(--ds-background-success-pressed, #79F2C0)",
    "color.background.success.bold": "var(--ds-background-success-bold, #00875A)",
    "color.background.success.bold.hovered": "var(--ds-background-success-bold-hovered, #57D9A3)",
    "color.background.success.bold.pressed": "var(--ds-background-success-bold-pressed, #00875A)",
    "color.background.discovery": "var(--ds-background-discovery, #EAE6FF)",
    "color.background.discovery.hovered": "var(--ds-background-discovery-hovered, #C0B6F2)",
    "color.background.discovery.pressed": "var(--ds-background-discovery-pressed, #998DD9)",
    "color.background.discovery.bold": "var(--ds-background-discovery-bold, #5243AA)",
    "color.background.discovery.bold.hovered": "var(--ds-background-discovery-bold-hovered, #8777D9)",
    "color.background.discovery.bold.pressed": "var(--ds-background-discovery-bold-pressed, #5243AA)",
    "color.background.information": "var(--ds-background-information, #DEEBFF)",
    "color.background.information.hovered": "var(--ds-background-information-hovered, #B3D4FF)",
    "color.background.information.pressed": "var(--ds-background-information-pressed, #4C9AFF)",
    "color.background.information.bold": "var(--ds-background-information-bold, #0052CC)",
    "color.background.information.bold.hovered": "var(--ds-background-information-bold-hovered, #2684FF)",
    "color.background.information.bold.pressed": "var(--ds-background-information-bold-pressed, #0052CC)",
    "color.blanket": "var(--ds-blanket, #091e4289)",
    "color.blanket.selected": "var(--ds-blanket-selected, #388BFF14)",
    "color.blanket.danger": "var(--ds-blanket-danger, #EF5C4814)",
    "color.skeleton": "var(--ds-skeleton, #F4F5F7)",
    "color.skeleton.subtle": "var(--ds-skeleton-subtle, #091e420a)",
    "elevation.surface": "var(--ds-surface, #FFFFFF)",
    "elevation.surface.hovered": "var(--ds-surface-hovered, #FAFBFC)",
    "elevation.surface.pressed": "var(--ds-surface-pressed, #F4F5F7)",
    "elevation.surface.overlay": "var(--ds-surface-overlay, #FFFFFF)",
    "elevation.surface.overlay.hovered": "var(--ds-surface-overlay-hovered, #FAFBFC)",
    "elevation.surface.overlay.pressed": "var(--ds-surface-overlay-pressed, #F4F5F7)",
    "elevation.surface.raised": "var(--ds-surface-raised, #FFFFFF)",
    "elevation.surface.raised.hovered": "var(--ds-surface-raised-hovered, #FAFBFC)",
    "elevation.surface.raised.pressed": "var(--ds-surface-raised-pressed, #F4F5F7)",
    "elevation.surface.sunken": "var(--ds-surface-sunken, #F4F5F7)",
    "utility.elevation.surface.current": "var(--ds-elevation-surface-current, #FFFFFF)"
};
var $9f51951cdbbc6069$export$8473307aa00d6ea1 = {
    "color.text": "var(--ds-text, #172B4D)",
    "color.text.accent.lime": "var(--ds-text-accent-lime, #4C6B1F)",
    "color.text.accent.lime.bolder": "var(--ds-text-accent-lime-bolder, #37471F)",
    "color.text.accent.red": "var(--ds-text-accent-red, #DE350B)",
    "color.text.accent.red.bolder": "var(--ds-text-accent-red-bolder, #BF2600)",
    "color.text.accent.orange": "var(--ds-text-accent-orange, #F18D13)",
    "color.text.accent.orange.bolder": "var(--ds-text-accent-orange-bolder, #B65C02)",
    "color.text.accent.yellow": "var(--ds-text-accent-yellow, #FF991F)",
    "color.text.accent.yellow.bolder": "var(--ds-text-accent-yellow-bolder, #FF8B00)",
    "color.text.accent.green": "var(--ds-text-accent-green, #00875A)",
    "color.text.accent.green.bolder": "var(--ds-text-accent-green-bolder, #006644)",
    "color.text.accent.teal": "var(--ds-text-accent-teal, #00A3BF)",
    "color.text.accent.teal.bolder": "var(--ds-text-accent-teal-bolder, #008DA6)",
    "color.text.accent.blue": "var(--ds-text-accent-blue, #0052CC)",
    "color.text.accent.blue.bolder": "var(--ds-text-accent-blue-bolder, #0747A6)",
    "color.text.accent.purple": "var(--ds-text-accent-purple, #5243AA)",
    "color.text.accent.purple.bolder": "var(--ds-text-accent-purple-bolder, #403294)",
    "color.text.accent.magenta": "var(--ds-text-accent-magenta, #E774BB)",
    "color.text.accent.magenta.bolder": "var(--ds-text-accent-magenta-bolder, #DA62AC)",
    "color.text.accent.gray": "var(--ds-text-accent-gray, #505F79)",
    "color.text.accent.gray.bolder": "var(--ds-text-accent-gray-bolder, #172B4D)",
    "color.text.disabled": "var(--ds-text-disabled, #A5ADBA)",
    "color.text.inverse": "var(--ds-text-inverse, #FFFFFF)",
    "color.text.selected": "var(--ds-text-selected, #0052CC)",
    "color.text.brand": "var(--ds-text-brand, #0065FF)",
    "color.text.danger": "var(--ds-text-danger, #DE350B)",
    "color.text.warning": "var(--ds-text-warning, #974F0C)",
    "color.text.warning.inverse": "var(--ds-text-warning-inverse, #172B4D)",
    "color.text.success": "var(--ds-text-success, #006644)",
    "color.text.discovery": "var(--ds-text-discovery, #403294)",
    "color.text.information": "var(--ds-text-information, #0052CC)",
    "color.text.subtlest": "var(--ds-text-subtlest, #7A869A)",
    "color.text.subtle": "var(--ds-text-subtle, #42526E)",
    "color.link": "var(--ds-link, #0052CC)",
    "color.link.pressed": "var(--ds-link-pressed, #0747A6)",
    "color.link.visited": "var(--ds-link-visited, #403294)",
    "color.link.visited.pressed": "var(--ds-link-visited-pressed, #403294)"
};
var $9f51951cdbbc6069$export$498780f74be9af68 = {
    "color.icon": "var(--ds-icon, #505F79)",
    "color.icon.accent.lime": "var(--ds-icon-accent-lime, #6A9A23)",
    "color.icon.accent.red": "var(--ds-icon-accent-red, #FF5630)",
    "color.icon.accent.orange": "var(--ds-icon-accent-orange, #D94008)",
    "color.icon.accent.yellow": "var(--ds-icon-accent-yellow, #FFAB00)",
    "color.icon.accent.green": "var(--ds-icon-accent-green, #36B37E)",
    "color.icon.accent.teal": "var(--ds-icon-accent-teal, #00B8D9)",
    "color.icon.accent.blue": "var(--ds-icon-accent-blue, #0065FF)",
    "color.icon.accent.purple": "var(--ds-icon-accent-purple, #6554C0)",
    "color.icon.accent.magenta": "var(--ds-icon-accent-magenta, #CD519D)",
    "color.icon.accent.gray": "var(--ds-icon-accent-gray, #5E6C84)",
    "color.icon.disabled": "var(--ds-icon-disabled, #8993A4)",
    "color.icon.inverse": "var(--ds-icon-inverse, #FFFFFF)",
    "color.icon.selected": "var(--ds-icon-selected, #0052CC)",
    "color.icon.brand": "var(--ds-icon-brand, #0065FF)",
    "color.icon.danger": "var(--ds-icon-danger, #DE350B)",
    "color.icon.warning": "var(--ds-icon-warning, #FFC400)",
    "color.icon.warning.inverse": "var(--ds-icon-warning-inverse, #253858)",
    "color.icon.success": "var(--ds-icon-success, #00875A)",
    "color.icon.discovery": "var(--ds-icon-discovery, #8777D9)",
    "color.icon.information": "var(--ds-icon-information, #0747A6)",
    "color.icon.subtlest": "var(--ds-icon-subtlest, #6B778C)",
    "color.icon.subtle": "var(--ds-icon-subtle, #6B778C)"
};
var $9f51951cdbbc6069$export$b5f31a7e431d2eab = {
    "1": 1,
    card: 100,
    navigation: 200,
    dialog: 300,
    layer: 400,
    blanket: 500,
    modal: 510,
    flag: 600,
    spotlight: 700,
    tooltip: 800
};
var $9f51951cdbbc6069$export$e1b83c5210c471b8 = {
    "border.width": "var(--ds-border-width, 1px)",
    "border.width.0": "var(--ds-border-width-0, 0px)",
    "border.width.indicator": "var(--ds-border-width-indicator, 3px)",
    "border.width.outline": "var(--ds-border-width-outline, 2px)"
};
var $9f51951cdbbc6069$export$3c0a6c3e64bb180d = {
    "border.radius.050": "var(--ds-border-radius-050, 2px)",
    "border.radius": "var(--ds-border-radius, 3px)",
    "border.radius.100": "var(--ds-border-radius-100, 3px)",
    "border.radius.200": "var(--ds-border-radius-200, 8px)",
    "border.radius.300": "var(--ds-border-radius-300, 12px)",
    "border.radius.400": "var(--ds-border-radius-400, 16px)",
    "border.radius.circle": "var(--ds-border-radius-circle, 32032px)"
};
var $9f51951cdbbc6069$export$6ffa317d5e70375 = {
    "font.body": 'var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    "font.body.UNSAFE_small": 'var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    "font.body.large": 'var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    "font.body.small": 'var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    "font.code": 'var(--ds-font-code, normal 400 0.875em/1 ui-monospace, Menlo, "Segoe UI Mono", "Ubuntu Mono", monospace)',
    "font.heading.large": 'var(--ds-font-heading-large, normal 500 24px/28px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    "font.heading.medium": 'var(--ds-font-heading-medium, normal 500 20px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    "font.heading.small": 'var(--ds-font-heading-small, normal 600 16px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    "font.heading.xlarge": 'var(--ds-font-heading-xlarge, normal 600 29px/32px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    "font.heading.xsmall": 'var(--ds-font-heading-xsmall, normal 600 14px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    "font.heading.xxlarge": 'var(--ds-font-heading-xxlarge, normal 500 35px/40px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    "font.heading.xxsmall": 'var(--ds-font-heading-xxsmall, normal 600 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)'
};
var $9f51951cdbbc6069$export$303e322c6b1ed114 = {
    "font.weight.bold": "var(--ds-font-weight-bold, 700)",
    "font.weight.medium": "var(--ds-font-weight-medium, 500)",
    "font.weight.regular": "var(--ds-font-weight-regular, 400)",
    "font.weight.semibold": "var(--ds-font-weight-semibold, 600)"
};
var $9f51951cdbbc6069$export$3c7e9587132614b4 = {
    "font.family.body": 'var(--ds-font-family-body, ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    "font.family.brand.body": 'var(--ds-font-family-brand-body, "Charlie Text", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    "font.family.brand.heading": 'var(--ds-font-family-brand-heading, "Charlie Display", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    "font.family.code": 'var(--ds-font-family-code, ui-monospace, Menlo, "Segoe UI Mono", "Ubuntu Mono", monospace)',
    "font.family.heading": 'var(--ds-font-family-heading, ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)'
};
var $9f51951cdbbc6069$export$236bfe3a33ef1292 = {
    medium: 'var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    UNSAFE_small: 'var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    large: 'var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    small: 'var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)'
};
var $9f51951cdbbc6069$export$855cfd311192d666 = {
    bold: "var(--ds-font-weight-bold, 700)",
    medium: "var(--ds-font-weight-medium, 500)",
    regular: "var(--ds-font-weight-regular, 400)",
    semibold: "var(--ds-font-weight-semibold, 600)"
};
/**
 * @codegenEnd
 */ // Margin needs some bespoke types: https://atlassian.slack.com/archives/CKRHB23K8/p1712623192772909
// Generate maps for Box props. backgroundColor, padding, etc
var $9f51951cdbbc6069$var$spacingProperties = [
    // Used by Box
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    // Used by Inline and Stack
    "gap",
    "rowGap",
    "columnGap"
];
var $9f51951cdbbc6069$export$ca0f9c2de39ffed7 = function getSerializedStylesMap(cssProperty, tokenMap) {
    return Object.keys(tokenMap).reduce(function(emotionSpacingMap, token) {
        // eslint-disable-next-line @repo/internal/styles/no-exported-styles
        emotionSpacingMap[token] = (0, $jVTBW.css)((0, (/*@__PURE__*/$parcel$interopDefault($9HWAT)))({}, cssProperty, tokenMap[token]));
        return emotionSpacingMap;
    }, {});
};
var $9f51951cdbbc6069$export$e615f061ca585a6c = $9f51951cdbbc6069$var$spacingProperties.reduce(function(styleMap, spacingProperty) {
    styleMap[spacingProperty] = $9f51951cdbbc6069$export$ca0f9c2de39ffed7(spacingProperty, $9f51951cdbbc6069$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
var $9f51951cdbbc6069$export$bf46c3f9eeafc71f = $9f51951cdbbc6069$var$spacingProperties.reduce(function(styleMap, spacingProperty) {
    styleMap[spacingProperty] = $9f51951cdbbc6069$export$ca0f9c2de39ffed7(spacingProperty, $9f51951cdbbc6069$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
var $9f51951cdbbc6069$export$e7af83bafe7f9e63 = $9f51951cdbbc6069$export$ca0f9c2de39ffed7("backgroundColor", $9f51951cdbbc6069$export$d1d79bf68ac056bd);
var $9f51951cdbbc6069$export$3a1bcba60b23d7f0 = $9f51951cdbbc6069$export$ca0f9c2de39ffed7("color", $9f51951cdbbc6069$export$8473307aa00d6ea1);
var $9f51951cdbbc6069$export$45f3f4fe16f9f7d5 = $9f51951cdbbc6069$export$ca0f9c2de39ffed7("fontWeight", $9f51951cdbbc6069$export$303e322c6b1ed114);
var $9f51951cdbbc6069$export$68cc305da27dbaa4 = $9f51951cdbbc6069$export$ca0f9c2de39ffed7("fontFamily", $9f51951cdbbc6069$export$3c7e9587132614b4);
var $9f51951cdbbc6069$export$128f10c238242f83 = $9f51951cdbbc6069$export$ca0f9c2de39ffed7("font", $9f51951cdbbc6069$export$6ffa317d5e70375);
var $9f51951cdbbc6069$export$219d364c0da35ae4 = $9f51951cdbbc6069$export$ca0f9c2de39ffed7("font", $9f51951cdbbc6069$export$236bfe3a33ef1292);
var $9f51951cdbbc6069$export$38845ca010b93505 = $9f51951cdbbc6069$export$ca0f9c2de39ffed7("fontWeight", $9f51951cdbbc6069$export$855cfd311192d666);
var $9f51951cdbbc6069$export$ff257d957d48c421 = $9f51951cdbbc6069$export$ca0f9c2de39ffed7((0, $ePLY9.CURRENT_SURFACE_CSS_VAR), $9f51951cdbbc6069$export$41a358c9c2356760);
var $9f51951cdbbc6069$export$5e65a44e5b6ecadb = function isSurfaceColorToken(color) {
    return $9f51951cdbbc6069$export$41a358c9c2356760[color] !== undefined;
};

});
parcelRegister("ePLY9", function(module, exports) {

$parcel$export(module.exports, "THEME_DATA_ATTRIBUTE", function () { return $accb09ccc1eb11db$export$4ef52930e33717cd; });
$parcel$export(module.exports, "COLOR_MODE_ATTRIBUTE", function () { return $accb09ccc1eb11db$export$a00eac3f8684bcd0; });
$parcel$export(module.exports, "CURRENT_SURFACE_CSS_VAR", function () { return $accb09ccc1eb11db$export$9d7b58831ae93caa; });
var $accb09ccc1eb11db$export$4ef52930e33717cd = "data-theme";
var $accb09ccc1eb11db$export$a00eac3f8684bcd0 = "data-color-mode";
var $accb09ccc1eb11db$export$2112803007239c61 = "data-contrast-mode";
var $accb09ccc1eb11db$export$352e418ed5b6193a = "data-custom-theme";
var $accb09ccc1eb11db$export$6f0c6fb8c80fcc92 = "ds";
var $accb09ccc1eb11db$export$4d0c7bbf80185957 = [
    "opacity",
    "font",
    "space",
    "border"
];
var $accb09ccc1eb11db$export$dddac1532e822863 = "--".concat($accb09ccc1eb11db$export$6f0c6fb8c80fcc92, "-token-not-found");
var $accb09ccc1eb11db$export$9d7b58831ae93caa = "--".concat($accb09ccc1eb11db$export$6f0c6fb8c80fcc92, "-elevation-surface-current");

});


parcelRegister("fDIOj", function(module, exports) {

$parcel$export(module.exports, "parseXcss", function () { return $b62d41fcbd2d0f41$export$a9c84988c8f81f2d; });
$parcel$export(module.exports, "xcss", function () { return $b62d41fcbd2d0f41$export$f6c783d06584602c; });

var $bd3Va = parcelRequire("bd3Va");

var $9HWAT = parcelRequire("9HWAT");

var $1m89o = parcelRequire("1m89o");

var $5RAei = parcelRequire("5RAei");

var $jVTBW = parcelRequire("jVTBW");

var $dG34F = parcelRequire("dG34F");

var $ahJoN = parcelRequire("ahJoN");
function $b62d41fcbd2d0f41$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $b62d41fcbd2d0f41$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $b62d41fcbd2d0f41$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $b62d41fcbd2d0f41$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $b62d41fcbd2d0f41$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $b62d41fcbd2d0f41$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
var $b62d41fcbd2d0f41$export$9a199fbafee0014e = {
    backgroundColor: (0, $dG34F.backgroundColorMap),
    blockSize: (0, $dG34F.dimensionMap),
    borderBlockColor: (0, $dG34F.borderColorMap),
    borderBlockEndColor: (0, $dG34F.borderColorMap),
    borderBlockEndWidth: (0, $dG34F.borderWidthMap),
    borderBlockStartColor: (0, $dG34F.borderColorMap),
    borderBlockStartWidth: (0, $dG34F.borderWidthMap),
    borderBlockWidth: (0, $dG34F.borderWidthMap),
    borderBottomColor: (0, $dG34F.borderColorMap),
    borderBottomLeftRadius: (0, $dG34F.borderRadiusMap),
    borderBottomRightRadius: (0, $dG34F.borderRadiusMap),
    borderBottomWidth: (0, $dG34F.borderWidthMap),
    borderColor: (0, $dG34F.borderColorMap),
    borderEndEndRadius: (0, $dG34F.borderRadiusMap),
    borderEndStartRadius: (0, $dG34F.borderRadiusMap),
    borderInlineColor: (0, $dG34F.borderColorMap),
    borderInlineEndColor: (0, $dG34F.borderColorMap),
    borderInlineEndWidth: (0, $dG34F.borderWidthMap),
    borderInlineStartColor: (0, $dG34F.borderColorMap),
    borderInlineStartWidth: (0, $dG34F.borderWidthMap),
    borderInlineWidth: (0, $dG34F.borderWidthMap),
    borderLeftColor: (0, $dG34F.borderColorMap),
    borderLeftWidth: (0, $dG34F.borderWidthMap),
    borderRadius: (0, $dG34F.borderRadiusMap),
    borderRightColor: (0, $dG34F.borderColorMap),
    borderRightWidth: (0, $dG34F.borderWidthMap),
    borderStartEndRadius: (0, $dG34F.borderRadiusMap),
    borderStartStartRadius: (0, $dG34F.borderRadiusMap),
    borderTopColor: (0, $dG34F.borderColorMap),
    borderTopLeftRadius: (0, $dG34F.borderRadiusMap),
    borderTopRightRadius: (0, $dG34F.borderRadiusMap),
    borderTopWidth: (0, $dG34F.borderWidthMap),
    borderWidth: (0, $dG34F.borderWidthMap),
    bottom: (0, $dG34F.allSpaceMap),
    boxShadow: (0, $dG34F.shadowMap),
    color: (0, $dG34F.textColorMap),
    columnGap: (0, $dG34F.positiveSpaceMap),
    font: (0, $dG34F.fontMap),
    fontFamily: (0, $dG34F.fontFamilyMap),
    fontWeight: (0, $dG34F.fontWeightMap),
    gap: (0, $dG34F.positiveSpaceMap),
    height: (0, $dG34F.dimensionMap),
    inlineSize: (0, $dG34F.dimensionMap),
    inset: (0, $dG34F.allSpaceMap),
    insetBlock: (0, $dG34F.allSpaceMap),
    insetBlockEnd: (0, $dG34F.allSpaceMap),
    insetBlockStart: (0, $dG34F.allSpaceMap),
    insetInline: (0, $dG34F.allSpaceMap),
    insetInlineEnd: (0, $dG34F.allSpaceMap),
    insetInlineStart: (0, $dG34F.allSpaceMap),
    left: (0, $dG34F.allSpaceMap),
    margin: (0, $dG34F.allSpaceMap),
    marginBlock: (0, $dG34F.allSpaceMap),
    marginBlockEnd: (0, $dG34F.allSpaceMap),
    marginBlockStart: (0, $dG34F.allSpaceMap),
    marginBottom: (0, $dG34F.allSpaceMap),
    marginInline: (0, $dG34F.allSpaceMap),
    marginInlineEnd: (0, $dG34F.allSpaceMap),
    marginInlineStart: (0, $dG34F.allSpaceMap),
    marginLeft: (0, $dG34F.allSpaceMap),
    marginRight: (0, $dG34F.allSpaceMap),
    marginTop: (0, $dG34F.allSpaceMap),
    maxBlockSize: (0, $dG34F.dimensionMap),
    maxHeight: (0, $dG34F.dimensionMap),
    maxInlineSize: (0, $dG34F.dimensionMap),
    maxWidth: (0, $dG34F.dimensionMap),
    minBlockSize: (0, $dG34F.dimensionMap),
    minHeight: (0, $dG34F.dimensionMap),
    minInlineSize: (0, $dG34F.dimensionMap),
    minWidth: (0, $dG34F.dimensionMap),
    opacity: (0, $dG34F.opacityMap),
    outlineColor: (0, $dG34F.borderColorMap),
    outlineOffset: (0, $dG34F.allSpaceMap),
    outlineWidth: (0, $dG34F.borderWidthMap),
    padding: (0, $dG34F.positiveSpaceMap),
    paddingBlock: (0, $dG34F.positiveSpaceMap),
    paddingBlockEnd: (0, $dG34F.positiveSpaceMap),
    paddingBlockStart: (0, $dG34F.positiveSpaceMap),
    paddingBottom: (0, $dG34F.positiveSpaceMap),
    paddingInline: (0, $dG34F.positiveSpaceMap),
    paddingInlineEnd: (0, $dG34F.positiveSpaceMap),
    paddingInlineStart: (0, $dG34F.positiveSpaceMap),
    paddingLeft: (0, $dG34F.positiveSpaceMap),
    paddingRight: (0, $dG34F.positiveSpaceMap),
    paddingTop: (0, $dG34F.positiveSpaceMap),
    right: (0, $dG34F.allSpaceMap),
    rowGap: (0, $dG34F.positiveSpaceMap),
    top: (0, $dG34F.allSpaceMap),
    width: (0, $dG34F.dimensionMap),
    zIndex: (0, $dG34F.layerMap)
};
var $b62d41fcbd2d0f41$var$uniqueSymbol = Symbol("UNSAFE_INTERNAL_styles");
var $b62d41fcbd2d0f41$var$isSafeEnvToThrow = function isSafeEnvToThrow() {
    return (typeof $ahJoN === "undefined" ? "undefined" : (0, (/*@__PURE__*/$parcel$interopDefault($5RAei)))($ahJoN)) === "object" && (0, (/*@__PURE__*/$parcel$interopDefault($5RAei)))($ahJoN.env) === "object" && false;
};
var $b62d41fcbd2d0f41$var$reNestedSelectors = /(\.|\s|&+|\*\>|#|\[.*\])/;
var $b62d41fcbd2d0f41$var$safeSelectors = /^@media .*$|^::?.*$|^@supports .*$/;
var $b62d41fcbd2d0f41$var$_transformStyles = function transformStyles(styleObj) {
    if (!styleObj || (0, (/*@__PURE__*/$parcel$interopDefault($5RAei)))(styleObj) !== "object") return styleObj;
    // If styles are defined as a CSSObject[], recursively call on each element until we reach CSSObject
    if (Array.isArray(styleObj)) return styleObj.map($b62d41fcbd2d0f41$var$_transformStyles);
    // Modifies styleObj in place. Be careful.
    Object.entries(styleObj).forEach(function(_ref) {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($1m89o)))(_ref, 2), key = _ref2[0], value = _ref2[1];
        // If key is a pseudo class or a pseudo element, then value should be an object.
        // So, call transformStyles on the value
        if ((0, (/*@__PURE__*/$parcel$interopDefault($5RAei)))(value) === "object" && $b62d41fcbd2d0f41$var$safeSelectors.test(key)) {
            styleObj[key] = $b62d41fcbd2d0f41$var$_transformStyles(value);
            return;
        }
        if ($b62d41fcbd2d0f41$var$isSafeEnvToThrow()) {
            // We don't support `.class`, `[data-testid]`, `> *`, `#some-id`
            if ($b62d41fcbd2d0f41$var$reNestedSelectors.test(key)) throw new Error("Styles not supported for key '".concat(key, "'."));
        }
        // We have now dealt with all the special cases, so,
        // check whether what remains is a style property
        // that can be transformed.
        if (!(key in $b62d41fcbd2d0f41$export$9a199fbafee0014e)) return;
        var tokenValue = $b62d41fcbd2d0f41$export$9a199fbafee0014e[key][value];
        styleObj[key] = tokenValue !== null && tokenValue !== void 0 ? tokenValue : value;
    });
    return styleObj;
};
var $b62d41fcbd2d0f41$var$baseXcss = function baseXcss(style) {
    var transformedStyles = $b62d41fcbd2d0f41$var$_transformStyles(style);
    return (0, (/*@__PURE__*/$parcel$interopDefault($9HWAT)))({}, $b62d41fcbd2d0f41$var$uniqueSymbol, (0, $jVTBW.css)(transformedStyles));
};
/**
 * Picks out runtime XCSS objects and build-time XCSS strings. This is needed
 * to supported both Emotion and Compiled styles until we've fully migrated
 * to Compiled.
 *
 * @private
 * @deprecated
 */ var $b62d41fcbd2d0f41$export$a9c84988c8f81f2d = function parseXcss(args) {
    if (Array.isArray(args)) {
        var emotion = [];
        var staticArr = [];
        var _iterator = $b62d41fcbd2d0f41$var$_createForOfIteratorHelper(args), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var arg = _step.value;
                var result = $b62d41fcbd2d0f41$export$a9c84988c8f81f2d(arg);
                if (result.emotion) emotion.push.apply(emotion, (0, (/*@__PURE__*/$parcel$interopDefault($bd3Va)))(result.emotion));
                if (result.static) staticArr.push(result.static);
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        return {
            emotion: emotion,
            static: staticArr.join(" ")
        };
    }
    var objArgs = args;
    var _ref4 = objArgs || {}, styles = _ref4[$b62d41fcbd2d0f41$var$uniqueSymbol];
    if (styles) return {
        emotion: [
            styles
        ]
    };
    if (args) {
        // We use string interpolation here instead of .toString() just
        // in case the resulting object doesn't have the method available.
        var stringifiedArgs = "".concat(args);
        if (stringifiedArgs) return {
            static: stringifiedArgs
        };
    }
    return {};
};
function $b62d41fcbd2d0f41$export$f6c783d06584602c(style) {
    return $b62d41fcbd2d0f41$var$baseXcss(style);
}

});


parcelRegister("885QU", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::bc9ca86dc3d7916919414cea3f7ddc7f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5eb39c3dfebebb3a$var$_react = $5eb39c3dfebebb3a$var$_interopRequireDefault((parcelRequire("dAx5m")));

var $5eb39c3dfebebb3a$var$_linkExternal = $5eb39c3dfebebb3a$var$_interopRequireDefault((parcelRequire("KFNrI")));

var $5eb39c3dfebebb3a$var$_shortcut = $5eb39c3dfebebb3a$var$_interopRequireDefault((parcelRequire("eYHgo")));
function $5eb39c3dfebebb3a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for LinkExternalIcon.
 * This component is LinkExternalIcon, with `UNSAFE_fallbackIcon` set to "ShortcutIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for links that open up a new tab.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $5eb39c3dfebebb3a$var$LinkExternalIcon = (props)=>/*#__PURE__*/ $5eb39c3dfebebb3a$var$_react.default.createElement($5eb39c3dfebebb3a$var$_linkExternal.default, Object.assign({
        LEGACY_fallbackIcon: $5eb39c3dfebebb3a$var$_shortcut.default
    }, props));
$5eb39c3dfebebb3a$var$LinkExternalIcon.Name = "LinkExternalIconMigration";
var $5eb39c3dfebebb3a$var$_default = module.exports.default = $5eb39c3dfebebb3a$var$LinkExternalIcon;

});
parcelRegister("KFNrI", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3602017c9c0db571ac57dae4d1f426bd>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $08c4b7e90ebdd7cf$var$_react = $08c4b7e90ebdd7cf$var$_interopRequireDefault((parcelRequire("dAx5m")));

var $08c4b7e90ebdd7cf$var$_baseNew = $08c4b7e90ebdd7cf$var$_interopRequireDefault((parcelRequire("3Ywmk")));
function $08c4b7e90ebdd7cf$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "LinkExternal".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for links that open up a new tab.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $08c4b7e90ebdd7cf$var$LinkExternalIcon = (props)=>/*#__PURE__*/ $08c4b7e90ebdd7cf$var$_react.default.createElement($08c4b7e90ebdd7cf$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M3 2.5a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5v-3H15v3a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h3v1.5zM10 1h4.25a.75.75 0 0 1 .75.75V6h-1.5V3.56L7.53 9.53 6.47 8.47l5.97-5.97H10z" clip-rule="evenodd"/>`
    }, props));
$08c4b7e90ebdd7cf$var$LinkExternalIcon.displayName = "LinkExternalIcon";
var $08c4b7e90ebdd7cf$var$_default = module.exports.default = $08c4b7e90ebdd7cf$var$LinkExternalIcon;

});
parcelRegister("3Ywmk", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("3K1PX")).default; });
$parcel$export(module.exports, "Icon", function () { return (parcelRequire("3K1PX")).Icon; });

var $3K1PX = parcelRequire("3K1PX");

});
parcelRegister("3K1PX", function(module, exports) {

$parcel$export(module.exports, "Icon", function () { return $2b9717c66cf6bf36$export$f04a61298a47a40f; });
$parcel$export(module.exports, "default", function () { return $2b9717c66cf6bf36$export$2e2bcd8739ae039; });
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $dAx5m = parcelRequire("dAx5m");

var $jVTBW = parcelRequire("jVTBW");

var $18rB9 = parcelRequire("18rB9");
/**
 * We are hiding this props from consumers as it's reserved
 * for use by Icon Tile.
 */ var $2b9717c66cf6bf36$var$commonSVGStyles = (0, $jVTBW.css)({
    overflow: "hidden",
    pointerEvents: "none",
    /**
   * Stop-color doesn't properly apply in chrome when the inherited/current color changes.
   * We have to initially set stop-color to inherit (either via DOM attribute or an initial CSS
   * rule) and then override it with currentColor for the color changes to be picked up.
   */ // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    stop: {
        stopColor: "currentColor"
    }
});
var $2b9717c66cf6bf36$var$svgStyles = (0, $jVTBW.css)({
    color: "currentColor",
    verticalAlign: "bottom"
});
var $2b9717c66cf6bf36$var$iconStyles = (0, $jVTBW.css)({
    display: "inline-block",
    boxSizing: "border-box",
    flexShrink: 0,
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: 1,
    paddingInlineEnd: "var(--ds--button--new-icon-padding-end, 0)",
    paddingInlineStart: "var(--ds--button--new-icon-padding-start, 0)"
});
var $2b9717c66cf6bf36$var$utilityIconStyles = (0, $jVTBW.css)({
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: "var(--ds-space-150, 12px)"
});
var $2b9717c66cf6bf36$var$scaleStyles = (0, $jVTBW.css)({
    width: "inherit",
    height: "inherit"
});
/**
 * For windows high contrast mode
 */ var $2b9717c66cf6bf36$var$baseHcmStyles = (0, $jVTBW.css)({
    "@media screen and (forced-colors: active)": {
        color: "CanvasText",
        filter: "grayscale(1)"
    }
});
var $2b9717c66cf6bf36$var$scaleSize = (0, $jVTBW.css)({
    width: "inherit",
    height: "inherit"
});
var $2b9717c66cf6bf36$var$sizeMap = {
    core: {
        none: (0, $jVTBW.css)({
            width: "var(--ds-space-200, 16px)",
            height: "var(--ds-space-200, 16px)"
        }),
        spacious: (0, $jVTBW.css)({
            width: "var(--ds-space-300, 24px)",
            height: "var(--ds-space-300, 24px)"
        })
    },
    utility: {
        none: (0, $jVTBW.css)({
            width: "var(--ds-space-150, 12px)",
            height: "var(--ds-space-150, 12px)"
        }),
        compact: (0, $jVTBW.css)({
            width: "var(--ds-space-200, 16px)",
            height: "var(--ds-space-200, 16px)"
        }),
        spacious: (0, $jVTBW.css)({
            width: "var(--ds-space-300, 24px)",
            height: "var(--ds-space-300, 24px)"
        })
    }
};
var $2b9717c66cf6bf36$var$baseSizeMap = {
    core: 16,
    utility: 12
};
var $2b9717c66cf6bf36$var$paddingMap = {
    core: {
        none: 0,
        spacious: 4
    },
    utility: {
        none: 0,
        compact: 2,
        spacious: 6
    }
};
var $2b9717c66cf6bf36$export$f04a61298a47a40f = /*#__PURE__*/ (0, $dAx5m.memo)(function Icon(props) {
    var _props$type, _props$spacing3, _props$spacing4;
    var _ref = props, _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, testId = _ref.testId, label = _ref.label, LEGACY_primaryColor = _ref.LEGACY_primaryColor, LEGACY_secondaryColor = _ref.LEGACY_secondaryColor, LEGACY_size = _ref.LEGACY_size, FallbackIcon = _ref.LEGACY_fallbackIcon, dangerouslySetGlyph = _ref.dangerouslySetGlyph, shouldScale = _ref.shouldScale, LEGACY_margin = _ref.LEGACY_margin;
    var dangerouslySetInnerHTML = dangerouslySetGlyph ? {
        __html: dangerouslySetGlyph
    } : undefined;
    // Fall back to old icon
    if (FallbackIcon && !(0, $18rB9.fg)("platform-visual-refresh-icons")) // parse out unnecessary props
    return (0, $jVTBW.jsx)(FallbackIcon, {
        primaryColor: LEGACY_primaryColor !== null && LEGACY_primaryColor !== void 0 ? LEGACY_primaryColor : color,
        secondaryColor: LEGACY_secondaryColor,
        size: LEGACY_size,
        label: label,
        testId: testId,
        UNSAFE_margin: LEGACY_margin
    });
    var baseSize = $2b9717c66cf6bf36$var$baseSizeMap[(_props$type = props.type) !== null && _props$type !== void 0 ? _props$type : "core"];
    var viewBoxPadding;
    if (props.type === "utility") {
        var _props$spacing;
        viewBoxPadding = $2b9717c66cf6bf36$var$paddingMap[props.type][(_props$spacing = props.spacing) !== null && _props$spacing !== void 0 ? _props$spacing : "none"];
    } else {
        var _props$spacing2;
        viewBoxPadding = $2b9717c66cf6bf36$var$paddingMap["core"][(_props$spacing2 = props.spacing) !== null && _props$spacing2 !== void 0 ? _props$spacing2 : "none"];
    }
    var viewBoxSize = baseSize + 2 * viewBoxPadding;
    return (0, $jVTBW.jsx)("span", {
        "data-testid": testId,
        role: label ? "img" : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: {
            color: color
        },
        css: [
            $2b9717c66cf6bf36$var$iconStyles,
            $2b9717c66cf6bf36$var$baseHcmStyles,
            shouldScale && $2b9717c66cf6bf36$var$scaleStyles,
            props.type === "utility" && $2b9717c66cf6bf36$var$utilityIconStyles
        ]
    }, (0, $jVTBW.jsx)("svg", {
        fill: "none",
        viewBox: "".concat(0 - viewBoxPadding, " ").concat(0 - viewBoxPadding, " ").concat(viewBoxSize, " ").concat(viewBoxSize),
        role: "presentation",
        css: [
            $2b9717c66cf6bf36$var$commonSVGStyles,
            $2b9717c66cf6bf36$var$svgStyles,
            shouldScale ? $2b9717c66cf6bf36$var$scaleSize : props.type === "utility" ? $2b9717c66cf6bf36$var$sizeMap[props.type][(_props$spacing3 = props.spacing) !== null && _props$spacing3 !== void 0 ? _props$spacing3 : "none"] : $2b9717c66cf6bf36$var$sizeMap["core"][(_props$spacing4 = props.spacing) !== null && _props$spacing4 !== void 0 ? _props$spacing4 : "none"]
        ],
        dangerouslySetInnerHTML: dangerouslySetInnerHTML
    }));
});
var $2b9717c66cf6bf36$export$2e2bcd8739ae039 = $2b9717c66cf6bf36$export$f04a61298a47a40f;

});



parcelRegister("eYHgo", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ae783a7b3ef720b6$var$_react = $ae783a7b3ef720b6$var$_interopRequireDefault((parcelRequire("dAx5m")));

var $aB12u = parcelRequire("aB12u");

var $ae783a7b3ef720b6$var$_linkExternal = $ae783a7b3ef720b6$var$_interopRequireDefault((parcelRequire("KFNrI")));
function $ae783a7b3ef720b6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $ae783a7b3ef720b6$var$ShortcutIcon = (props)=>/*#__PURE__*/ $ae783a7b3ef720b6$var$_react.default.createElement($aB12u.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor"><path d="M5 19.01V19zM5 4.99V5zM19 19v-6h2v6a2 2 0 0 1-1.99 2H5a2 2 0 0 1-2-1.99V4.99C3 3.89 3.9 3 5 3h6v2H5v14zM5 4.99V5zM11 5H5v14h14v-6h2v6a2 2 0 0 1-1.99 2H5a2 2 0 0 1-2-1.99V4.99C3 3.89 3.9 3 5 3h6zm8 0v3a1 1 0 0 0 2 0V4a1 1 0 0 0-1-1h-4a1 1 0 0 0 0 2z"/><path d="m12.707 12.707 8-8a1 1 0 1 0-1.414-1.414l-8 8a1 1 0 0 0 1.414 1.414"/></g></svg>`
    }, props, {
        newIcon: $ae783a7b3ef720b6$var$_linkExternal.default
    }));
$ae783a7b3ef720b6$var$ShortcutIcon.displayName = "ShortcutIcon";
var $ae783a7b3ef720b6$var$_default = module.exports.default = $ae783a7b3ef720b6$var$ShortcutIcon;

});
parcelRegister("aB12u", function(module, exports) {

$parcel$export(module.exports, "IconFacade", function () { return $7b6e2a6d129fe5b3$export$3cfb73f70dfca966; });

var $lDu5G = parcelRequire("lDu5G");

var $ikhrG = parcelRequire("ikhrG");

var $dAx5m = parcelRequire("dAx5m");

var $18rB9 = parcelRequire("18rB9");

var $iqvNZ = parcelRequire("iqvNZ");
var $7b6e2a6d129fe5b3$var$_excluded = [
    "dangerouslySetGlyph"
];
var $7b6e2a6d129fe5b3$var$sizeSpacingMap = {
    utility: {
        small: "compact",
        medium: "spacious"
    },
    core: {
        small: "none",
        medium: "spacious"
    }
};
var $7b6e2a6d129fe5b3$export$3cfb73f70dfca966 = /*#__PURE__*/ (0, $dAx5m.memo)(function IconFacade(_ref) {
    var _props$size;
    var dangerouslySetGlyph = _ref.dangerouslySetGlyph, props = (0, (/*@__PURE__*/$parcel$interopDefault($ikhrG)))(_ref, $7b6e2a6d129fe5b3$var$_excluded);
    var NewIcon = props.newIcon;
    // By default, the icon size will be medium for core icons and small for utility icons
    var size = (_props$size = props.size) !== null && _props$size !== void 0 ? _props$size : "medium";
    var useNewIcon = !props.isFacadeDisabled && // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
    (0, $18rB9.fg)("platform-visual-refresh-icons-legacy-facade");
    if (useNewIcon && NewIcon && (size === "small" || size === "medium")) {
        if (props.iconType === "utility") {
            var Icon = NewIcon;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement(Icon, (0, (/*@__PURE__*/$parcel$interopDefault($lDu5G)))({}, props, {
                spacing: (0, $18rB9.fg)("platform-visual-refresh-icons-facade-button-fix") ? $7b6e2a6d129fe5b3$var$sizeSpacingMap["utility"][size] : "none",
                color: props.primaryColor || "currentColor",
                type: props.iconType
            }));
        } else {
            var _Icon = NewIcon;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement(_Icon, (0, (/*@__PURE__*/$parcel$interopDefault($lDu5G)))({}, props, {
                spacing: $7b6e2a6d129fe5b3$var$sizeSpacingMap["core"][size],
                color: props.primaryColor || "currentColor",
                type: props.iconType
            }));
        }
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $iqvNZ.Icon), (0, (/*@__PURE__*/$parcel$interopDefault($lDu5G)))({
        dangerouslySetGlyph: dangerouslySetGlyph
    }, props));
});

});
parcelRegister("iqvNZ", function(module, exports) {

$parcel$export(module.exports, "Icon", function () { return $d6a35396f3c0f554$export$f04a61298a47a40f; });

var $lDu5G = parcelRequire("lDu5G");

var $9HWAT = parcelRequire("9HWAT");

var $dAx5m = parcelRequire("dAx5m");

var $jVTBW = parcelRequire("jVTBW");

var $klfZl = parcelRequire("klfZl");

var $4oudP = parcelRequire("4oudP");
function $d6a35396f3c0f554$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $d6a35396f3c0f554$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $d6a35396f3c0f554$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($9HWAT)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $d6a35396f3c0f554$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
/**
 * We are hiding these props from consumers as they're used to
 * hack around icon sizing specifically for icon-file-type.
 */ var $d6a35396f3c0f554$var$iconStyles = (0, $jVTBW.css)({
    display: "inline-block",
    flexShrink: 0,
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: 1,
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    "> svg": $d6a35396f3c0f554$var$_objectSpread($d6a35396f3c0f554$var$_objectSpread({}, (0, $klfZl.commonSVGStyles)), {}, {
        maxWidth: "100%",
        maxHeight: "100%",
        color: "var(--icon-primary-color)",
        fill: "var(--icon-secondary-color)",
        verticalAlign: "bottom"
    })
});
/**
 * For windows high contrast mode
 */ var $d6a35396f3c0f554$var$baseHcmStyles = (0, $jVTBW.css)({
    "@media screen and (forced-colors: active)": {
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        "> svg": {
            filter: "grayscale(1)",
            "--icon-primary-color": "CanvasText",
            // foreground
            "--icon-secondary-color": "Canvas" // background
        }
    }
});
var $d6a35396f3c0f554$var$primaryEqualsSecondaryHcmStyles = (0, $jVTBW.css)({
    "@media screen and (forced-colors: active)": {
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        "> svg": {
            // if the primaryColor is the same as the secondaryColor we
            // set the --icon-primary-color to Canvas
            // this is usually to convey state i.e. Checkbox checked -> not checked
            "--icon-primary-color": "Canvas" // foreground
        }
    }
});
var $d6a35396f3c0f554$var$secondaryTransparentHcmStyles = (0, $jVTBW.css)({
    "@media screen and (forced-colors: active)": {
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        "> svg": {
            "--icon-secondary-color": "transparent" // background
        }
    }
});
var $d6a35396f3c0f554$export$f04a61298a47a40f = /*#__PURE__*/ (0, $dAx5m.memo)(function Icon(props) {
    var _ref = props, Glyph = _ref.glyph, dangerouslySetGlyph = _ref.dangerouslySetGlyph, _ref$primaryColor = _ref.primaryColor, primaryColor = _ref$primaryColor === void 0 ? "currentColor" : _ref$primaryColor, secondaryColor = _ref.secondaryColor, size = _ref.size, testId = _ref.testId, label = _ref.label, width = _ref.width, height = _ref.height, UNSAFE_margin = _ref.UNSAFE_margin;
    var glyphProps = dangerouslySetGlyph ? {
        dangerouslySetInnerHTML: {
            __html: dangerouslySetGlyph
        }
    } : {
        children: Glyph ? (0, $jVTBW.jsx)(Glyph, {
            role: "presentation"
        }) : null
    };
    var dimensions = (0, $klfZl.getIconSize)({
        width: width,
        height: height,
        size: size
    });
    return (0, $jVTBW.jsx)("span", (0, (/*@__PURE__*/$parcel$interopDefault($lDu5G)))({
        "data-testid": testId,
        "data-vc": "icon-".concat(testId),
        role: label ? "img" : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: {
            "--icon-primary-color": primaryColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            "--icon-secondary-color": secondaryColor || (0, $4oudP.getBackground)(),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            margin: UNSAFE_margin
        }
    }, glyphProps, {
        css: [
            $d6a35396f3c0f554$var$iconStyles,
            $d6a35396f3c0f554$var$baseHcmStyles,
            primaryColor === secondaryColor && $d6a35396f3c0f554$var$primaryEqualsSecondaryHcmStyles,
            secondaryColor === "transparent" && $d6a35396f3c0f554$var$secondaryTransparentHcmStyles,
            // NB: This can be resolved if this component, composes base SVG / and/or skeleton
            // We could then simplify how common styles are dealt with simply by encapsulating them
            // at their appropriate level and/or having a singular approach to css variables in the package
            dimensions && // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $jVTBW.css)({
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                width: dimensions.width,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                height: dimensions.height,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                "> svg": dimensions
            })
        ]
    }));
});
var $d6a35396f3c0f554$export$2e2bcd8739ae039 = $d6a35396f3c0f554$export$f04a61298a47a40f;

});
parcelRegister("klfZl", function(module, exports) {

$parcel$export(module.exports, "commonSVGStyles", function () { return $ecf22bc8ca657efd$export$16374db1c3e6dfba; });
$parcel$export(module.exports, "getIconSize", function () { return $ecf22bc8ca657efd$export$3eb7d6130acfda37; });

var $3nSao = parcelRequire("3nSao");

var $jVTBW = parcelRequire("jVTBW");
var $ecf22bc8ca657efd$export$16374db1c3e6dfba = {
    overflow: "hidden",
    pointerEvents: "none",
    /**
   * Stop-color doesn't properly apply in chrome when the inherited/current color changes.
   * We have to initially set stop-color to inherit (either via DOM attribute or an initial CSS
   * rule) and then override it with currentColor for the color changes to be picked up.
   */ stop: {
        stopColor: "currentColor"
    }
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
var $ecf22bc8ca657efd$var$smallStyles = (0, $jVTBW.css)((0, $3nSao.dimensions).small);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
var $ecf22bc8ca657efd$var$mediumStyles = (0, $jVTBW.css)((0, $3nSao.dimensions).medium);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
var $ecf22bc8ca657efd$var$largeStyles = (0, $jVTBW.css)((0, $3nSao.dimensions).large);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
var $ecf22bc8ca657efd$var$xlargeStyles = (0, $jVTBW.css)((0, $3nSao.dimensions).xlarge);
var $ecf22bc8ca657efd$export$ef0ad74202575b64 = {
    small: $ecf22bc8ca657efd$var$smallStyles,
    medium: $ecf22bc8ca657efd$var$mediumStyles,
    large: $ecf22bc8ca657efd$var$largeStyles,
    xlarge: $ecf22bc8ca657efd$var$xlargeStyles
};
var $ecf22bc8ca657efd$export$3eb7d6130acfda37 = function getIconSize(_ref) {
    var width = _ref.width, height = _ref.height, size = _ref.size;
    if (width && height) return {
        width: width,
        height: height
    };
    if (size) return (0, $3nSao.dimensions)[size];
    return undefined;
};

});
parcelRegister("3nSao", function(module, exports) {

$parcel$export(module.exports, "dimensions", function () { return $276d896f4f2458df$export$62ad7b0c781000e9; });
var $276d896f4f2458df$export$c647cb0ee6e282fe = {
    small: "16px",
    medium: "24px",
    large: "32px",
    xlarge: "48px"
};
var $276d896f4f2458df$export$7bd66fc94c81bf84 = {
    small: "small",
    medium: "medium",
    large: "large",
    xlarge: "xlarge"
};
var $276d896f4f2458df$export$62ad7b0c781000e9 = {
    small: {
        width: $276d896f4f2458df$export$c647cb0ee6e282fe.small,
        height: $276d896f4f2458df$export$c647cb0ee6e282fe.small
    },
    medium: {
        width: $276d896f4f2458df$export$c647cb0ee6e282fe.medium,
        height: $276d896f4f2458df$export$c647cb0ee6e282fe.medium
    },
    large: {
        width: $276d896f4f2458df$export$c647cb0ee6e282fe.large,
        height: $276d896f4f2458df$export$c647cb0ee6e282fe.large
    },
    xlarge: {
        width: $276d896f4f2458df$export$c647cb0ee6e282fe.xlarge,
        height: $276d896f4f2458df$export$c647cb0ee6e282fe.xlarge
    }
};

});


parcelRegister("4oudP", function(module, exports) {

$parcel$export(module.exports, "getBackground", function () { return $3330d8c34734f14a$export$18cb9425622d4e06; });
var $3330d8c34734f14a$export$18cb9425622d4e06 = function getBackground() {
    return "var(--ds-surface, #FFFFFF)";
};

});





parcelRegister("2JSZB", function(module, exports) {

$parcel$export(module.exports, "FadeIn", function () { return $1fea711bde2a5200$export$bd7370ffb2917ab7; });
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ parcelRequire("dAx5m");

var $jVTBW = parcelRequire("jVTBW");

var $2I3Lh = parcelRequire("2I3Lh");
var $1fea711bde2a5200$var$fadeIn = (0, $jVTBW.keyframes)({
    to: {
        opacity: 1
    }
});
var $1fea711bde2a5200$var$fadeInStyles = (0, $jVTBW.css)({
    animation: "".concat($1fea711bde2a5200$var$fadeIn, " 500ms ease forwards"),
    opacity: 0,
    margin: 0,
    padding: 0,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    color: "var(--ds-text, ".concat($2I3Lh.N800, ")")
});
var $1fea711bde2a5200$export$bd7370ffb2917ab7 = function FadeIn(_ref) {
    var children = _ref.children, className = _ref.className, _ref$tag = _ref.tag, Tag = _ref$tag === void 0 ? "div" : _ref$tag;
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    (0, $jVTBW.jsx)(Tag, {
        css: $1fea711bde2a5200$var$fadeInStyles,
        className: className
    }, children));
};

});

parcelRegister("enfj2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a76f162337ea9394$export$2e2bcd8739ae039; });

var $lDu5G = parcelRequire("lDu5G");

var $dAx5m = parcelRequire("dAx5m");

var $7s5UC = parcelRequire("7s5UC");

var $885QU = parcelRequire("885QU");

var $kyTiB = parcelRequire("kyTiB");

var $3FJlW = parcelRequire("3FJlW");

var $5QmqT = parcelRequire("5QmqT");

var $55TWT = parcelRequire("55TWT");
var $a76f162337ea9394$var$ItemLink = function ItemLink(_ref) {
    var label = _ref.label, href = _ref.href, testId = _ref.testId, onClick = _ref.onClick, ariaLabel = _ref.ariaLabel;
    var buttonProps = {
        appearance: "link",
        href: href,
        className: "section-link",
        target: "_blank",
        rel: "noopener noreferrer",
        iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($885QU))), {
            LEGACY_size: "small",
            color: "currentColor",
            label: ""
        }),
        onClick: onClick ? function(e, a) {
            return onClick(e, a);
        } : undefined,
        testId: testId
    };
    if (ariaLabel) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $55TWT.default), ariaLabel, function(placeholder) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $7s5UC.default), (0, (/*@__PURE__*/$parcel$interopDefault($lDu5G)))({}, buttonProps, {
            "aria-label": String(placeholder)
        }), label);
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $7s5UC.default), buttonProps, label);
};
var $a76f162337ea9394$export$2e2bcd8739ae039 = (0, $kyTiB.default)({
    onClick: (0, $5QmqT.createAndFireNavigationEvent)({
        eventType: (0, $3FJlW.UI_EVENT_TYPE),
        action: "clicked",
        actionSubject: (0, $5QmqT.SWITCHER_ITEM_SUBJECT)
    })
})($a76f162337ea9394$var$ItemLink);

});
parcelRegister("7s5UC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $56cfbbf8e3945140$export$2e2bcd8739ae039; });

var $lDu5G = parcelRequire("lDu5G");

var $1m89o = parcelRequire("1m89o");

var $ikhrG = parcelRequire("ikhrG");

var $dAx5m = parcelRequire("dAx5m");

var $2NfKg = parcelRequire("2NfKg");

var $12rpF = parcelRequire("12rpF");

var $h3bya = parcelRequire("h3bya");

var $9MM3y = parcelRequire("9MM3y");

var $6JrVv = parcelRequire("6JrVv");
var $56cfbbf8e3945140$var$_excluded = [
    "appearance",
    "children",
    "iconBefore",
    "iconAfter",
    "isSelected",
    "onMouseDown",
    "onMouseUp",
    "shouldFitContainer",
    "spacing"
];
var $56cfbbf8e3945140$var$isFirefox = typeof navigator !== "undefined" && navigator.userAgent.toLowerCase().indexOf("firefox") > -1;
/**
 * __Button__
 *
 * @deprecated Legacy buttons are deprecated and will be removed from `atlaskit/button` in an upcoming major release. Please use the new Button components from `@atlaskit/button/new`
 *
 * Please refer to the [migration guide](https://atlassian.design/components/button/button-legacy/migration-guide) for further details.
 *
 * A button triggers an event or action. They let users know what will happen next.
 *
 * - [Examples](https://atlassian.design/components/button/button-legacy/examples)
 * - [Code](https://atlassian.design/components/button/button-legacy/code)
 * - [Usage](https://atlassian.design/components/button/button-legacy/usage)
 */ var $56cfbbf8e3945140$var$Button = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).forwardRef(function Button(_ref, ref) {
    var _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "default" : _ref$appearance, children = _ref.children, iconBefore = _ref.iconBefore, iconAfter = _ref.iconAfter, _ref$isSelected = _ref.isSelected, isSelected = _ref$isSelected === void 0 ? false : _ref$isSelected, _ref$onMouseDown = _ref.onMouseDown, providedOnMouseDown = _ref$onMouseDown === void 0 ? (0, $2NfKg.default) : _ref$onMouseDown, _ref$onMouseUp = _ref.onMouseUp, providedOnMouseUp = _ref$onMouseUp === void 0 ? (0, $2NfKg.default) : _ref$onMouseUp, _ref$shouldFitContain = _ref.shouldFitContainer, shouldFitContainer = _ref$shouldFitContain === void 0 ? false : _ref$shouldFitContain, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? "default" : _ref$spacing, rest = (0, (/*@__PURE__*/$parcel$interopDefault($ikhrG)))(_ref, $56cfbbf8e3945140$var$_excluded);
    var _useGlobalTheme = (0, $12rpF.useGlobalTheme)(), mode = _useGlobalTheme.mode;
    var isOnlySingleIcon = (0, $6JrVv.default)({
        children: children,
        iconBefore: iconBefore,
        iconAfter: iconAfter
    });
    var _useState = (0, $dAx5m.useState)(false), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($1m89o)))(_useState, 2), isActive = _useState2[0], setIsActive = _useState2[1];
    // Wrap onMouseDown / onMouseUp to manually trigger active state
    //  in Firefox
    var onMouseDown = (0, $dAx5m.useCallback)(function(event) {
        providedOnMouseDown(event);
        if ($56cfbbf8e3945140$var$isFirefox) setIsActive(true);
    }, [
        providedOnMouseDown,
        setIsActive
    ]);
    var onMouseUp = (0, $dAx5m.useCallback)(function(event) {
        providedOnMouseUp(event);
        if ($56cfbbf8e3945140$var$isFirefox) setIsActive(false);
    }, [
        providedOnMouseUp,
        setIsActive
    ]);
    var buttonCss = (0, $dAx5m.useMemo)(function() {
        return (0, $9MM3y.getCss)({
            appearance: appearance,
            spacing: spacing,
            mode: mode,
            isSelected: isSelected,
            shouldFitContainer: shouldFitContainer,
            isOnlySingleIcon: isOnlySingleIcon
        });
    }, [
        appearance,
        spacing,
        mode,
        isSelected,
        shouldFitContainer,
        isOnlySingleIcon
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $h3bya.default), (0, (/*@__PURE__*/$parcel$interopDefault($lDu5G)))({}, rest, {
        ref: ref,
        appearance: appearance,
        buttonCss: buttonCss,
        children: children,
        "data-firefox-is-active": isActive ? true : undefined,
        iconAfter: iconAfter,
        iconBefore: iconBefore,
        isSelected: isSelected,
        onMouseDown: onMouseDown,
        onMouseUp: onMouseUp,
        spacing: spacing
    }));
}));
// Tools including enzyme rely on components having a display name
$56cfbbf8e3945140$var$Button.displayName = "Button";
var $56cfbbf8e3945140$export$2e2bcd8739ae039 = $56cfbbf8e3945140$var$Button;

});
parcelRegister("2NfKg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $208c5f05c8d19533$export$2e2bcd8739ae039; });
/**
 * An empty function which does nothing.
 */ // eslint-disable-next-line @repo/internal/react/use-noop
function $208c5f05c8d19533$export$2e2bcd8739ae039() {}

});

parcelRegister("12rpF", function(module, exports) {

$parcel$export(module.exports, "useGlobalTheme", function () { return $0c1b3dfda52adad9$export$7692396083754928; });
$parcel$export(module.exports, "default", function () { return $0c1b3dfda52adad9$export$2e2bcd8739ae039; });

var $9g1l0 = parcelRequire("9g1l0");
// Create default global light theme
var $0c1b3dfda52adad9$var$_createTheme = (0, $9g1l0.createTheme)(function() {
    return {
        mode: "light"
    };
}), $0c1b3dfda52adad9$var$Provider = $0c1b3dfda52adad9$var$_createTheme.Provider, $0c1b3dfda52adad9$var$Consumer = $0c1b3dfda52adad9$var$_createTheme.Consumer, $0c1b3dfda52adad9$export$7692396083754928 = $0c1b3dfda52adad9$var$_createTheme.useTheme;
var $0c1b3dfda52adad9$var$Theme = {
    Provider: $0c1b3dfda52adad9$var$Provider,
    Consumer: $0c1b3dfda52adad9$var$Consumer
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$0c1b3dfda52adad9$export$2e2bcd8739ae039 = $0c1b3dfda52adad9$var$Theme;

});
parcelRegister("9g1l0", function(module, exports) {

$parcel$export(module.exports, "createTheme", function () { return $6bd6a555f2cffe6e$export$25d302a5b900a763; });

var $ikhrG = parcelRequire("ikhrG");

var $dAx5m = parcelRequire("dAx5m");
var $6bd6a555f2cffe6e$var$_excluded = [
    "children"
];
function $6bd6a555f2cffe6e$export$25d302a5b900a763(defaultGetTokens) {
    var emptyThemeFn = function emptyThemeFn(getTokens, props) {
        return getTokens(props);
    };
    /**
   * Internally, Theme uses React Context, with internal providers and consumers.
   * The React Context passes only a function that gets props, and turns them into tokens. This
   * function gets mixed as more Providers with their own themes are added. This mixed function
   * is ultimately picked up by Consumers, which implement a context consumer internally to fetch
   * the theme.
   */ var ThemeContext = /*#__PURE__*/ (0, $dAx5m.createContext)(defaultGetTokens);
    function useTheme(themeProps) {
        var theme = (0, $dAx5m.useContext)(ThemeContext);
        var themeFn = theme || emptyThemeFn;
        var tokens = themeFn(themeProps);
        return tokens;
    }
    // The Theme Consumer takes a function as its child - this function takes tokens, and the
    // return value is generally a set of nodes with the tokens applied appropriately.
    function Consumer(props) {
        var children = props.children, themeProps = (0, (/*@__PURE__*/$parcel$interopDefault($ikhrG)))(props, $6bd6a555f2cffe6e$var$_excluded);
        // @ts-ignore See issue for more info: https://github.com/Microsoft/TypeScript/issues/10727
        // Argument of type 'Pick<ThemeProps & { children: (tokens: ThemeTokens) => ReactNode; }, Exclude<keyof ThemeProps, "children">>' is not assignable to parameter of type 'ThemeProps'.ts(2345)
        var tokens = useTheme(themeProps);
        // We add a fragment to ensure we don't break people upgrading.
        // Previously they may have been able to pass in undefined without things blowing up.
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).Fragment, null, children(tokens));
    }
    /**
   * The Theme Provider takes regular nodes as its children, but also takes a *theme function*
   * - The theme function takes a set of props, as well as a function (getTokens) that can turn props into tokens.
   * - The getTokens function isn't called immediately - instead the props are passed
   *    through a mix of parent theming functions
   * Children of this provider will receive this mixed theme
   */ function Provider(props) {
        var themeFn = (0, $dAx5m.useContext)(ThemeContext);
        var valueFn = props.value || emptyThemeFn;
        var mixedFn = (0, $dAx5m.useCallback)(function(themeProps) {
            return valueFn(themeFn, themeProps);
        }, [
            themeFn,
            valueFn
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement(ThemeContext.Provider, {
            value: mixedFn
        }, props.children);
    }
    return {
        Consumer: Consumer,
        Provider: Provider,
        useTheme: useTheme
    };
}

});


parcelRegister("h3bya", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c69bad101f9ee4ce$export$2e2bcd8739ae039; });

var $lDu5G = parcelRequire("lDu5G");

var $ikhrG = parcelRequire("ikhrG");

var $dAx5m = parcelRequire("dAx5m");

var $jVTBW = parcelRequire("jVTBW");

var $aadHU = parcelRequire("aadHU");

var $2NfKg = parcelRequire("2NfKg");

var $aINwx = parcelRequire("aINwx");

var $8qML2 = parcelRequire("8qML2");

var $4mhQ1 = parcelRequire("4mhQ1");

var $2I3Lh = parcelRequire("2I3Lh");

var $kgzSn = parcelRequire("kgzSn");

var $9MM3y = parcelRequire("9MM3y");

var $dUYqG = parcelRequire("dUYqG");
var $c69bad101f9ee4ce$var$_excluded = [
    "analyticsContext",
    "appearance",
    "autoFocus",
    "buttonCss",
    "children",
    "className",
    "href",
    "component",
    "iconAfter",
    "iconBefore",
    "interactionName",
    "isDisabled",
    "isSelected",
    "onBlur",
    "onClick",
    "onFocus",
    "onMouseDown",
    "overlay",
    "shouldFitContainer",
    "spacing",
    "tabIndex",
    "type",
    "testId"
];
// Disabled buttons will still publish events for nested elements in webkit.
// We are disabling pointer events on child elements so that
// the button will always be the target of events
// Note: firefox does not have this behaviour for child elements
var $c69bad101f9ee4ce$var$noPointerEventsOnChildrenCss = {
    "> *": {
        pointerEvents: "none"
    }
};
/**
 * These CSS variables consumed by the new icons, to allow them to have appropriate
 * padding inside Button while also maintaining spacing for the existing icons.
 *
 * These styles can be removed once the new icons are fully rolled out, feature flag
 * platform-visual-refresh-icons is cleaned up,
 * and we bump Button to set padding based on the new icons.
 */ var $c69bad101f9ee4ce$var$iconBeforeSpacingFixStyle = (0, $jVTBW.css)({
    "--ds--button--new-icon-padding-end": "var(--ds-space-025, 2px)",
    "--ds--button--new-icon-padding-start": "var(--ds-space-050, 4px)",
    marginInlineStart: "var(--ds-space-negative-025, -2px)"
});
var $c69bad101f9ee4ce$var$iconAfterSpacingFixStyle = (0, $jVTBW.css)({
    "--ds--button--new-icon-padding-end": "var(--ds-space-050, 4px)",
    "--ds--button--new-icon-padding-start": "var(--ds-space-025, 2px)",
    marginInlineEnd: "var(--ds-space-negative-025, -2px)"
});
var $c69bad101f9ee4ce$var$getSpacingFix = function getSpacingFix(children, spacingStyles) {
    if (!children || (0, $dUYqG.getIfVisuallyHiddenChildren)(children)) return null;
    return spacingStyles;
};
var $c69bad101f9ee4ce$var$getChildren = function getChildren(children, childrenStyles) {
    if ((0, $dUYqG.getIfVisuallyHiddenChildren)(children)) return children;
    return children ? (0, $jVTBW.jsx)("span", {
        css: childrenStyles
    }, children) : null;
};
var $c69bad101f9ee4ce$var$ButtonBase = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).forwardRef(function ButtonBase(props, ref) {
    var analyticsContext = props.analyticsContext, _props$appearance = props.appearance, appearance = _props$appearance === void 0 ? "default" : _props$appearance, _props$autoFocus = props.autoFocus, autoFocus = _props$autoFocus === void 0 ? false : _props$autoFocus, buttonCss = props.buttonCss, children = props.children, className = props.className, href = props.href, _props$component = props.component, Component = _props$component === void 0 ? href ? "a" : "button" : _props$component, iconAfter = props.iconAfter, iconBefore = props.iconBefore, interactionName = props.interactionName, _props$isDisabled = props.isDisabled, isDisabled = _props$isDisabled === void 0 ? false : _props$isDisabled, _props$isSelected = props.isSelected, isSelected = _props$isSelected === void 0 ? false : _props$isSelected, onBlur = props.onBlur, _props$onClick = props.onClick, providedOnClick = _props$onClick === void 0 ? (0, $2NfKg.default) : _props$onClick, onFocus = props.onFocus, _props$onMouseDown = props.onMouseDown, providedOnMouseDown = _props$onMouseDown === void 0 ? (0, $2NfKg.default) : _props$onMouseDown, overlay = props.overlay, shouldFitContainer = props.shouldFitContainer, _props$spacing = props.spacing, spacing = _props$spacing === void 0 ? "default" : _props$spacing, _props$tabIndex = props.tabIndex, tabIndex = _props$tabIndex === void 0 ? 0 : _props$tabIndex, _props$type = props.type, type = _props$type === void 0 ? !href ? "button" : undefined : _props$type, testId = props.testId, rest = (0, (/*@__PURE__*/$parcel$interopDefault($ikhrG)))(props, $c69bad101f9ee4ce$var$_excluded);
    var ourRef = (0, $dAx5m.useRef)();
    var setRef = (0, $dAx5m.useCallback)(function(node) {
        ourRef.current = node;
        if (ref == null) return;
        if (typeof ref === "function") {
            ref(node);
            return;
        }
        // We can write to ref's `current` property, but Typescript does not like it.
        // @ts-ignore
        ref.current = node;
    }, [
        ourRef,
        ref
    ]);
    // Cross browser auto focusing is pretty broken, so we are doing it ourselves
    (0, $aINwx.default)(ourRef, autoFocus);
    var interactionContext = (0, $dAx5m.useContext)((0, $4mhQ1.default));
    var handleClick = (0, $dAx5m.useCallback)(function(e, analyticsEvent) {
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    var onClick = (0, $aadHU.usePlatformLeafEventHandler)({
        fn: handleClick,
        action: "clicked",
        componentName: "button",
        packageName: "@atlaskit/button",
        packageVersion: "23.0.3",
        analyticsData: analyticsContext
    });
    // Button currently calls preventDefault, which is not standard button behaviour
    var onMouseDown = (0, $dAx5m.useCallback)(function(event) {
        event.preventDefault();
        providedOnMouseDown(event);
    }, [
        providedOnMouseDown
    ]);
    // Lose focus when becoming disabled (standard button behaviour)
    (0, $dAx5m.useEffect)(function() {
        var el = ourRef.current;
        if (isDisabled && el && el === document.activeElement) el.blur();
    }, [
        isDisabled
    ]);
    // we are 'disabling' input with a button when there is an overlay
    var hasOverlay = Boolean(overlay);
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    var fadeStyles = (0, $jVTBW.css)((0, $9MM3y.getFadingCss)({
        hasOverlay: hasOverlay
    }));
    var isInteractive = !isDisabled && !hasOverlay;
    /**
   * HACK: Spinner needs to have different colours in the "new" tokens design compared to the old design.
   * For now, while we support both, these styles reach into Spinner when a theme is set, applies the right color.
   * Ticket to remove: https://product-fabric.atlassian.net/browse/DSP-2067.
   */ var spinnerHackCss = {};
    if (isSelected || isDisabled || appearance === "warning") spinnerHackCss = {
        "[data-theme] & circle": {
            stroke: "".concat(isSelected || isDisabled ? "var(--ds-icon-subtle, ".concat((0, $2I3Lh.N500), ")") : "var(--ds-icon-warning-inverse, ".concat((0, $2I3Lh.N500), ")"), " !important")
        }
    };
    return (0, $jVTBW.jsx)((0, $8qML2.default), null, (0, $jVTBW.jsx)(Component, (0, (/*@__PURE__*/$parcel$interopDefault($lDu5G)))({}, rest, {
        ref: setRef,
        className: className,
        css: [
            buttonCss,
            isInteractive ? null : $c69bad101f9ee4ce$var$noPointerEventsOnChildrenCss
        ],
        "data-has-overlay": hasOverlay ? true : undefined,
        "data-testid": testId,
        disabled: isDisabled,
        href: isInteractive ? href : undefined,
        onBlur: onBlur,
        onClick: onClick,
        onFocus: onFocus,
        onMouseDown: onMouseDown,
        tabIndex: isDisabled ? -1 : tabIndex,
        type: type
    }, (0, $kgzSn.default)({
        isInteractive: isInteractive
    })), iconBefore ? (0, $jVTBW.jsx)("span", {
        css: [
            fadeStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $9MM3y.getIconStyle)({
                spacing: spacing
            }),
            $c69bad101f9ee4ce$var$getSpacingFix(children, $c69bad101f9ee4ce$var$iconBeforeSpacingFixStyle)
        ]
    }, iconBefore) : null, $c69bad101f9ee4ce$var$getChildren(children, [
        fadeStyles,
        (0, $9MM3y.getContentStyle)({
            spacing: spacing
        })
    ]), iconAfter ? (0, $jVTBW.jsx)("span", {
        css: [
            fadeStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $9MM3y.getIconStyle)({
                spacing: spacing
            }),
            $c69bad101f9ee4ce$var$getSpacingFix(children, $c69bad101f9ee4ce$var$iconAfterSpacingFixStyle)
        ]
    }, iconAfter) : null, overlay ? (0, $jVTBW.jsx)("span", {
        css: [
            (0, $9MM3y.overlayCss),
            spinnerHackCss
        ]
    }, overlay) : null));
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$c69bad101f9ee4ce$export$2e2bcd8739ae039 = $c69bad101f9ee4ce$var$ButtonBase;

});
parcelRegister("aadHU", function(module, exports) {

$parcel$export(module.exports, "usePlatformLeafEventHandler", function () { return $76657886a36dfa6e$export$a4687b0234b40e28; });

var $9HWAT = parcelRequire("9HWAT");

var $dAx5m = parcelRequire("dAx5m");

var $cMzgg = parcelRequire("cMzgg");

var $kLAwr = parcelRequire("kLAwr");
function $76657886a36dfa6e$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $76657886a36dfa6e$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $76657886a36dfa6e$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($9HWAT)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $76657886a36dfa6e$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $76657886a36dfa6e$export$a4687b0234b40e28(_ref) {
    var fn = _ref.fn, action = _ref.action, componentName = _ref.componentName, actionSubject = _ref.actionSubject, packageName = _ref.packageName, packageVersion = _ref.packageVersion, analyticsData = _ref.analyticsData;
    var _useAnalyticsEvents = (0, $cMzgg.useAnalyticsEvents)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    // We put analyticsData and fn in a ref so that we don't need to break
    // memoization.
    // Generally these could be defined by consumers inline
    // and so we do this to avoid breaking memoization of useCallback
    var dataRef = (0, $kLAwr.useTrackedRef)(analyticsData);
    var fnRef = (0, $kLAwr.useTrackedRef)(fn);
    var handler = (0, $dAx5m.useCallback)(function(value) {
        var analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: actionSubject || componentName,
            attributes: {
                componentName: componentName,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
        // To avoid wrapping this component in AnalyticsContext we manually
        // push the parent context's meta data into the context.
        // Note: this new 'context'
        var context = $76657886a36dfa6e$var$_objectSpread({
            componentName: componentName,
            packageName: packageName,
            packageVersion: packageVersion
        }, dataRef.current);
        analyticsEvent.context.push(context);
        // fire an event on the atlaskit channel
        var clone = analyticsEvent.clone();
        if (clone) clone.fire("atlaskit");
        fnRef.current(value, analyticsEvent);
    }, [
        // These are strings and won't change
        action,
        componentName,
        actionSubject,
        packageName,
        packageVersion,
        // This function is memoized in the context
        createAnalyticsEvent,
        // these are a stable ref because of the useTrackedRef hook
        dataRef,
        fnRef
    ]);
    return handler;
}

});

parcelRegister("aINwx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7ce46dddbdde725a$export$2e2bcd8739ae039; });

var $dAx5m = parcelRequire("dAx5m");
function $7ce46dddbdde725a$export$2e2bcd8739ae039(ref, autoFocus) {
    var initialMount = (0, $dAx5m.useRef)(true);
    (0, $dAx5m.useEffect)(function() {
        if (ref && initialMount.current && autoFocus && ref.current) ref.current.focus();
        initialMount.current = false;
    }, [
        autoFocus,
        ref
    ]);
}

});

parcelRegister("8qML2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $623692ada4dd6cc1$export$2e2bcd8739ae039; });
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $dAx5m = parcelRequire("dAx5m");

var $jVTBW = parcelRequire("jVTBW");
var $623692ada4dd6cc1$var$BORDER_WIDTH = 2;
var $623692ada4dd6cc1$var$baseFocusOutsideStyles = (0, $jVTBW.css)({
    outline: "".concat($623692ada4dd6cc1$var$BORDER_WIDTH, "px solid ", "var(--ds-border-focused, #2684FF)"),
    outlineOffset: $623692ada4dd6cc1$var$BORDER_WIDTH
});
var $623692ada4dd6cc1$var$baseInsetStyles = (0, $jVTBW.css)({
    outlineColor: "var(--ds-border-focused, #2684FF)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    outlineOffset: -$623692ada4dd6cc1$var$BORDER_WIDTH,
    outlineStyle: "solid",
    outlineWidth: "var(--ds-border-width-outline, 2px)"
});
var $623692ada4dd6cc1$var$focusRingStyles = (0, $jVTBW.css)({
    // Focus styles used when :focus-visible isn't supported
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    "&:focus": $623692ada4dd6cc1$var$baseFocusOutsideStyles,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    "&:focus-visible": $623692ada4dd6cc1$var$baseFocusOutsideStyles,
    // Remove default focus styles for mouse interactions if :focus-visible is supported
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    "&:focus:not(:focus-visible)": {
        outline: "none"
    },
    "@media screen and (forced-colors: active), screen and (-ms-high-contrast: active)": {
        "&:focus-visible": {
            outline: "1px solid"
        }
    }
});
var $623692ada4dd6cc1$var$insetFocusRingStyles = (0, $jVTBW.css)({
    // Focus styles used when :focus-visible isn't supported
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    "&:focus": $623692ada4dd6cc1$var$baseInsetStyles,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    "&:focus-visible": $623692ada4dd6cc1$var$baseInsetStyles,
    // Remove default focus styles for mouse interactions if :focus-visible is supported
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    "&:focus:not(:focus-visible)": {
        outline: "none"
    },
    "@media screen and (forced-colors: active), screen and (-ms-high-contrast: active)": {
        "&:focus-visible": {
            outline: "1px solid",
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
            outlineOffset: "-1px"
        }
    }
});
/**
 * __Focus ring__
 *
 * A focus ring visually indicates the currently focused item.
 *
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/focus-ring)
 *
 * @example
 * ```jsx
 * import FocusRing from '@atlaskit/focus-ring';
 *
 * const InteractiveComponent = () => (
 *   <FocusRing>
 *     <button type="button">Hello</button>
 *   </FocusRing>
 * )
 * ```
 */ var $623692ada4dd6cc1$var$FocusRing = /*#__PURE__*/ (0, $dAx5m.memo)(function(_ref) {
    var children = _ref.children, isInset = _ref.isInset, focus = _ref.focus;
    var controlledStyles = isInset ? $623692ada4dd6cc1$var$baseInsetStyles : $623692ada4dd6cc1$var$baseFocusOutsideStyles;
    var uncontrolledStyles = isInset ? $623692ada4dd6cc1$var$insetFocusRingStyles : $623692ada4dd6cc1$var$focusRingStyles;
    var focusCls = typeof focus === "undefined" ? uncontrolledStyles : focus === "on" && controlledStyles;
    return (0, $jVTBW.jsx)((0, $jVTBW.ClassNames), null, function(_ref2) {
        var css = _ref2.css, cx = _ref2.cx;
        return (0, $dAx5m.Children).only(// This may look unwieldy but means we skip applying styles / cloning if no className is applicable
        focusCls ? /*#__PURE__*/ // eslint-disable-next-line @repo/internal/react/no-clone-element
        (0, $dAx5m.cloneElement)(children, {
            className: cx([
                css(focusCls),
                children.props.className
            ])
        }) : children);
    });
});
$623692ada4dd6cc1$var$FocusRing.displayName = "FocusRing";
var $623692ada4dd6cc1$export$2e2bcd8739ae039 = $623692ada4dd6cc1$var$FocusRing;

});

parcelRegister("4mhQ1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $32c70dc7a9c8e99a$export$2e2bcd8739ae039; });

var $dAx5m = parcelRequire("dAx5m");
var $32c70dc7a9c8e99a$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $dAx5m.createContext)(null);

});

parcelRegister("kgzSn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ec1121863789c36e$export$2e2bcd8739ae039; });
function $ec1121863789c36e$var$abort(event) {
    event.preventDefault();
    event.stopPropagation();
}
var $ec1121863789c36e$var$tabKeyCode = 9;
function $ec1121863789c36e$var$onKey(event) {
    // Allowing tab so that a user can move focus away
    if (event.keyCode === $ec1121863789c36e$var$tabKeyCode) return;
    $ec1121863789c36e$var$abort(event);
}
var $ec1121863789c36e$var$block = {
    onMouseDownCapture: $ec1121863789c36e$var$abort,
    onMouseUpCapture: $ec1121863789c36e$var$abort,
    // because we have tabIndex = -1 when disabled,
    // keyboard events can only occur when there is an overlay
    onKeyDownCapture: $ec1121863789c36e$var$onKey,
    onKeyUpCapture: $ec1121863789c36e$var$onKey,
    onTouchStartCapture: $ec1121863789c36e$var$abort,
    onTouchEndCapture: $ec1121863789c36e$var$abort,
    onPointerDownCapture: $ec1121863789c36e$var$abort,
    onPointerUpCapture: $ec1121863789c36e$var$abort,
    onClickCapture: $ec1121863789c36e$var$abort,
    // Just smashing the existing onClick for good measure
    onClick: $ec1121863789c36e$var$abort
};
var $ec1121863789c36e$var$doNotBlock = {};
function $ec1121863789c36e$export$2e2bcd8739ae039(_ref) {
    var isInteractive = _ref.isInteractive;
    return isInteractive ? $ec1121863789c36e$var$doNotBlock : $ec1121863789c36e$var$block;
}

});

parcelRegister("9MM3y", function(module, exports) {

$parcel$export(module.exports, "getCss", function () { return $71fddfb62ff54ce9$export$955358618f994a11; });
$parcel$export(module.exports, "getIconStyle", function () { return $71fddfb62ff54ce9$export$864eea3f4ec3368f; });
$parcel$export(module.exports, "getContentStyle", function () { return $71fddfb62ff54ce9$export$7ad0316cc0dd65a; });
$parcel$export(module.exports, "getFadingCss", function () { return $71fddfb62ff54ce9$export$1b5827d324e945b1; });
$parcel$export(module.exports, "overlayCss", function () { return $71fddfb62ff54ce9$export$1a9fe1b84c876bb5; });

var $9HWAT = parcelRequire("9HWAT");

var $jVTBW = parcelRequire("jVTBW");

var $18rB9 = parcelRequire("18rB9");

var $c7v9o = parcelRequire("c7v9o");

var $7SBjN = parcelRequire("7SBjN");
function $71fddfb62ff54ce9$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $71fddfb62ff54ce9$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $71fddfb62ff54ce9$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($9HWAT)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $71fddfb62ff54ce9$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $71fddfb62ff54ce9$var$gridSize = (0, $c7v9o.gridSize)();
var $71fddfb62ff54ce9$var$HAS_DISABLED_BACKGROUND = [
    "default",
    "primary",
    "danger",
    "warning"
];
// ## Button layout
//
// /------------------------------------------------------------------------------------------------------------------\
// |       →  |  ←      |          |      →  |  ←      |           |      →  |  ←      |         |      →  |  ←       |
// |  10px →  |  ← 2px  |   icon   |  2px →  |  ← 2px  |           |  2px →  |  ← 2px  |  icon   |  2px →  |  ← 10px  |
// |  padding |  margin |  before  |  margin |  margin |  content  |  margin |  margin |  after  |  margin |  padding |
// |    (12px total)    |          |    (4px total)    |           |    (4px total)    |         |    (12px total)    |
// |       →  |  ←      |          |      →  |  ←      |           |      →  |  ←      |         |      →  |  ←       |
// \------------------------------------------------------------------------------------------------------------------/
//                                           ↑                               ↑
//                                        Margins don't collapse with inline-flex
//
var $71fddfb62ff54ce9$var$heights = {
    default: "".concat(32 / 14, "em"),
    // 32px
    compact: "".concat(24 / 14, "em"),
    none: "auto"
};
var $71fddfb62ff54ce9$var$lineHeights = {
    default: $71fddfb62ff54ce9$var$heights.default,
    compact: $71fddfb62ff54ce9$var$heights.compact,
    none: "inherit"
};
var $71fddfb62ff54ce9$var$padding = {
    // 10px gutter
    default: "0 ".concat($71fddfb62ff54ce9$var$gridSize + $71fddfb62ff54ce9$var$gridSize / 4, "px"),
    compact: "0 ".concat($71fddfb62ff54ce9$var$gridSize + $71fddfb62ff54ce9$var$gridSize / 4, "px"),
    none: "0"
};
var $71fddfb62ff54ce9$var$singleIconPadding = {
    // 2px gutter
    compact: "0 ".concat($71fddfb62ff54ce9$var$gridSize / 4, "px"),
    default: "0 ".concat($71fddfb62ff54ce9$var$gridSize / 4, "px"),
    none: "0"
};
var $71fddfb62ff54ce9$var$verticalAlign = {
    default: "middle",
    compact: "middle",
    none: "baseline"
};
var $71fddfb62ff54ce9$var$innerMargin = {
    content: "0 ".concat($71fddfb62ff54ce9$var$gridSize / 4, "px"),
    icon: "0 ".concat($71fddfb62ff54ce9$var$gridSize / 4, "px")
};
var $71fddfb62ff54ce9$var$defaultAfterStyles = {
    borderRadius: "inherit",
    inset: "var(--ds-space-0, 0px)",
    borderStyle: "solid",
    borderWidth: "var(--ds-border-width, 1px)",
    pointerEvents: "none",
    position: "absolute"
};
var $71fddfb62ff54ce9$var$defaultStyles = {
    background: "var(--ds-background-neutral-subtle, #00000000)",
    color: "var(--ds-text, #172B4D)",
    "&:not([disabled])::after": $71fddfb62ff54ce9$var$_objectSpread($71fddfb62ff54ce9$var$_objectSpread({}, $71fddfb62ff54ce9$var$defaultAfterStyles), {}, {
        content: '""',
        borderColor: "var(--ds-border, #091E4224)"
    }),
    "&:hover": {
        background: "var(--ds-background-neutral-hovered, #091E4224)"
    },
    "&:active": {
        background: "var(--ds-background-neutral-pressed, #091E424F)"
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: "var(--ds-background-neutral-subtle, #00000000)"
    }
};
var $71fddfb62ff54ce9$var$primaryStyles = {
    background: "var(--ds-background-brand-bold, #0C66E4)",
    color: "var(--ds-text-inverse, #FFFFFF)",
    "&:hover": {
        background: "var(--ds-background-brand-bold-hovered, #0055CC)"
    },
    "&:active": {
        background: "var(--ds-background-brand-bold-pressed, #09326C)"
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: "var(--ds-background-brand-bold, #0C66E4)"
    }
};
var $71fddfb62ff54ce9$var$linkStyles = {
    background: "transparent",
    color: "var(--ds-link, #0C66E4)",
    "&:hover": {
        color: "var(--ds-link, #0C66E4)",
        textDecoration: "underline"
    },
    "&:active": {
        color: "var(--ds-link-pressed, #0055CC)",
        textDecoration: "underline"
    }
};
var $71fddfb62ff54ce9$var$subtleStyles = {
    background: "transparent",
    color: "var(--ds-text-subtle, #44546F)",
    "&:hover": {
        background: "var(--ds-background-neutral-subtle-hovered, #091E420F)"
    },
    "&:active": {
        background: "var(--ds-background-neutral-subtle-pressed, #091E4224)"
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: "transparent"
    }
};
var $71fddfb62ff54ce9$var$subtleLinkStyles = {
    background: "transparent",
    color: "var(--ds-text-subtle, #44546F)",
    "&:hover": {
        background: "transparent",
        color: "var(--ds-text-subtle, #44546F)",
        textDecoration: "underline"
    },
    "&:active": {
        background: "transparent",
        color: "var(--ds-text, #172B4D)",
        textDecoration: "underline"
    }
};
var $71fddfb62ff54ce9$var$warningStyles = {
    background: "var(--ds-background-warning-bold, #F5CD47)",
    color: "var(--ds-text-warning-inverse, #172B4D)",
    "&:hover": {
        background: "var(--ds-background-warning-bold-hovered, #E2B203)"
    },
    "&:active": {
        background: "var(--ds-background-warning-bold-pressed, #CF9F02)"
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: "var(--ds-background-warning-bold, #F5CD47)"
    }
};
var $71fddfb62ff54ce9$var$dangerStyles = {
    background: "var(--ds-background-danger-bold, #C9372C)",
    color: "var(--ds-text-inverse, #FFFFFF)",
    "&:hover": {
        background: "var(--ds-background-danger-bold-hovered, #AE2E24)"
    },
    "&:active": {
        background: "var(--ds-background-danger-bold-pressed, #5D1F1A)"
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: "var(--ds-background-danger-bold, #C9372C)"
    }
};
var $71fddfb62ff54ce9$var$selectedStyles = {
    background: "var(--ds-background-selected, #E9F2FF)",
    color: "var(--ds-text-selected, #0C66E4)",
    "&:not([disabled])::after": $71fddfb62ff54ce9$var$_objectSpread($71fddfb62ff54ce9$var$_objectSpread({}, $71fddfb62ff54ce9$var$defaultAfterStyles), {}, {
        content: '""',
        borderColor: "var(--ds-border-selected, #0C66E4)"
    })
};
var $71fddfb62ff54ce9$var$hasOverlayStyles = {
    '&[data-has-overlay="true"]': {
        cursor: "default",
        textDecoration: "none"
    }
};
function $71fddfb62ff54ce9$var$getColor(_ref) {
    var group = _ref.group, key = _ref.key, mode = _ref.mode;
    var rule = group[key] || group.default;
    return rule[mode];
}
function $71fddfb62ff54ce9$var$getColors(_ref2) {
    var appearance = _ref2.appearance, key = _ref2.key, mode = _ref2.mode;
    return {
        background: $71fddfb62ff54ce9$var$getColor({
            group: (0, $7SBjN.default).background[appearance],
            key: key,
            mode: mode
        }),
        // Needing to add !important to overcome specificity issue caused by deprecated AtlaskitThemeProvider
        color: "".concat($71fddfb62ff54ce9$var$getColor({
            group: (0, $7SBjN.default).color[appearance],
            key: key,
            mode: mode
        }), " !important")
    };
}
function $71fddfb62ff54ce9$export$955358618f994a11(_ref3) {
    var appearance = _ref3.appearance, spacing = _ref3.spacing, mode = _ref3.mode, isSelected = _ref3.isSelected, shouldFitContainer = _ref3.shouldFitContainer, isOnlySingleIcon = _ref3.isOnlySingleIcon;
    var baseColors = $71fddfb62ff54ce9$var$getColors({
        appearance: appearance,
        key: isSelected ? "selected" : "default",
        mode: mode
    });
    return $71fddfb62ff54ce9$var$_objectSpread($71fddfb62ff54ce9$var$_objectSpread($71fddfb62ff54ce9$var$_objectSpread($71fddfb62ff54ce9$var$_objectSpread({
        // 0px margin added to css-reset
        alignItems: "baseline",
        borderWidth: 0,
        borderRadius: "var(--ds-border-radius, 3px)",
        boxSizing: "border-box",
        display: "inline-flex",
        fontSize: "inherit",
        fontStyle: "normal",
        // Chrome recently changed button so that they use 'arial' as the font family
        fontFamily: "inherit",
        fontWeight: "var(--ds-font-weight-medium, 500)",
        // margin for button has been applied to css reset
        maxWidth: "100%",
        // Needed to position overlay
        position: "relative",
        textAlign: "center",
        textDecoration: "none",
        transition: "background 0.1s ease-out, box-shadow 0.15s cubic-bezier(0.47, 0.03, 0.49, 1.38)",
        whiteSpace: "nowrap"
    }, !(0, $18rB9.fg)("platform-component-visual-refresh") && baseColors), {}, {
        cursor: "pointer",
        height: $71fddfb62ff54ce9$var$heights[spacing],
        lineHeight: $71fddfb62ff54ce9$var$lineHeights[spacing],
        padding: isOnlySingleIcon ? $71fddfb62ff54ce9$var$singleIconPadding[spacing] : $71fddfb62ff54ce9$var$padding[spacing],
        verticalAlign: $71fddfb62ff54ce9$var$verticalAlign[spacing],
        width: shouldFitContainer ? "100%" : "auto",
        // justifyContent required for shouldFitContainer buttons with an icon inside
        justifyContent: "center"
    }, !(0, $18rB9.fg)("platform-component-visual-refresh") && $71fddfb62ff54ce9$var$_objectSpread($71fddfb62ff54ce9$var$_objectSpread({
        // Disabling visited styles (just using the base colors)
        "&:visited": $71fddfb62ff54ce9$var$_objectSpread({}, baseColors),
        "&:hover": $71fddfb62ff54ce9$var$_objectSpread($71fddfb62ff54ce9$var$_objectSpread({}, $71fddfb62ff54ce9$var$getColors({
            appearance: appearance,
            key: isSelected ? "selected" : "hover",
            mode: mode
        })), {}, {
            textDecoration: !isSelected && (appearance === "link" || appearance === "subtle-link") ? "underline" : "inherit",
            // background, box-shadow
            transitionDuration: "0s, 0.15s"
        }),
        // giving active styles preference by listing them after focus
        "&:active": $71fddfb62ff54ce9$var$_objectSpread($71fddfb62ff54ce9$var$_objectSpread({}, $71fddfb62ff54ce9$var$getColors({
            appearance: appearance,
            key: isSelected ? "selected" : "active",
            mode: mode
        })), {}, {
            // background, box-shadow
            transitionDuration: "0s, 0s"
        }),
        // preventDefault prevents regular active styles from applying in Firefox
        '&[data-firefox-is-active="true"]': $71fddfb62ff54ce9$var$_objectSpread($71fddfb62ff54ce9$var$_objectSpread({}, $71fddfb62ff54ce9$var$getColors({
            appearance: appearance,
            key: isSelected ? "selected" : "active",
            mode: mode
        })), {}, {
            // background, box-shadow
            transitionDuration: "0s, 0s"
        }),
        // Giving disabled styles preference over active by listing them after.
        // Not using '&:disabled' because :disabled is not a valid state for all element types
        // so we are targeting the attribute
        // Attributes have the same specificity a pseudo classes so we are overriding :disabled here
        "&[disabled]": $71fddfb62ff54ce9$var$_objectSpread($71fddfb62ff54ce9$var$_objectSpread({}, $71fddfb62ff54ce9$var$getColors({
            appearance: appearance,
            key: "disabled",
            mode: mode
        })), {}, {
            cursor: "not-allowed",
            textDecoration: "none"
        })
    }, $71fddfb62ff54ce9$var$hasOverlayStyles), {}, {
        // disabling hover and active color changes when there is an overlay, but the button is not disabled
        '&[data-has-overlay="true"]:not([disabled]):hover, &[data-has-overlay="true"]:not([disabled]):active': $71fddfb62ff54ce9$var$_objectSpread({}, $71fddfb62ff54ce9$var$getColors({
            appearance: appearance,
            key: isSelected ? "selected" : "default",
            mode: mode
        }))
    })), (0, $18rB9.fg)("platform-component-visual-refresh") && (isSelected ? $71fddfb62ff54ce9$var$selectedStyles : $71fddfb62ff54ce9$var$_objectSpread($71fddfb62ff54ce9$var$_objectSpread($71fddfb62ff54ce9$var$_objectSpread($71fddfb62ff54ce9$var$_objectSpread($71fddfb62ff54ce9$var$_objectSpread($71fddfb62ff54ce9$var$_objectSpread($71fddfb62ff54ce9$var$_objectSpread($71fddfb62ff54ce9$var$_objectSpread({}, appearance === "default" && $71fddfb62ff54ce9$var$defaultStyles), appearance === "primary" && $71fddfb62ff54ce9$var$primaryStyles), appearance === "link" && $71fddfb62ff54ce9$var$linkStyles), appearance === "subtle" && $71fddfb62ff54ce9$var$subtleStyles), appearance === "subtle-link" && $71fddfb62ff54ce9$var$subtleLinkStyles), appearance === "warning" && $71fddfb62ff54ce9$var$warningStyles), appearance === "danger" && $71fddfb62ff54ce9$var$dangerStyles), {}, {
        "&[disabled]": {
            color: "var(--ds-text-disabled, #091E424F)",
            backgroundColor: $71fddfb62ff54ce9$var$HAS_DISABLED_BACKGROUND.includes(appearance) ? "var(--ds-background-disabled, #091E4208)" : "transparent",
            cursor: "not-allowed",
            textDecoration: "none",
            "&:hovered": {
                backgroundColor: $71fddfb62ff54ce9$var$HAS_DISABLED_BACKGROUND.includes(appearance) ? "var(--ds-background-disabled, #091E4208)" : "transparent"
            },
            "&:active": {
                backgroundColor: $71fddfb62ff54ce9$var$HAS_DISABLED_BACKGROUND.includes(appearance) ? "var(--ds-background-disabled, #091E4208)" : "transparent"
            }
        }
    }, $71fddfb62ff54ce9$var$hasOverlayStyles))), {}, {
        "&::-moz-focus-inner": {
            border: 0,
            margin: 0,
            padding: 0
        }
    });
}
function $71fddfb62ff54ce9$export$864eea3f4ec3368f(_ref4) {
    var spacing = _ref4.spacing;
    return (0, $jVTBW.css)({
        display: "flex",
        // icon size cannot grow and shrink
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        margin: spacing === "none" ? 0 : $71fddfb62ff54ce9$var$innerMargin.icon,
        flexGrow: 0,
        flexShrink: 0,
        alignSelf: "center",
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: 0,
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: 0,
        userSelect: "none"
    });
}
function $71fddfb62ff54ce9$export$7ad0316cc0dd65a(_ref5) {
    var spacing = _ref5.spacing;
    return (0, $jVTBW.css)({
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        margin: spacing === "none" ? 0 : $71fddfb62ff54ce9$var$innerMargin.content,
        // content can grow and shrink
        flexGrow: 1,
        flexShrink: 1,
        // ellipsis for overflow text
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap"
    });
}
function $71fddfb62ff54ce9$export$1b5827d324e945b1(_ref6) {
    var hasOverlay = _ref6.hasOverlay;
    return (0, $jVTBW.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        opacity: hasOverlay ? 0 : 1,
        transition: "opacity 0.3s"
    });
}
var $71fddfb62ff54ce9$export$1a9fe1b84c876bb5 = {
    // stretching to full width / height of button
    // this is important as we need it to still block
    // event if clicking in the button's own padding
    position: "absolute",
    left: 0,
    top: 0,
    right: 0,
    bottom: 0,
    // Putting all children in the center
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
};

});
parcelRegister("c7v9o", function(module, exports) {

$parcel$export(module.exports, "gridSize", function () { return $8d2e4d4d2c30f95d$export$6d8204c2cb2e06b8; });
$parcel$export(module.exports, "layers", function () { return $8d2e4d4d2c30f95d$export$7be255094ccdc533; });

var $1khUv = parcelRequire("1khUv");

var $2I3Lh = parcelRequire("2I3Lh");
var $8d2e4d4d2c30f95d$export$44ffba16bd48dac6 = "__ATLASKIT_THEME__";
var $8d2e4d4d2c30f95d$export$c93026a968943f95 = "light";
var $8d2e4d4d2c30f95d$export$6ba72c8346b4c57e = [
    "light",
    "dark"
];
var $8d2e4d4d2c30f95d$export$7a57f79000377ca2 = function borderRadius() {
    return 3;
};
var $8d2e4d4d2c30f95d$export$6d8204c2cb2e06b8 = function gridSize() {
    return 8;
};
var $8d2e4d4d2c30f95d$export$8e24544ddba725ee = function focusRing() {
    var color = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "var(--ds-border-focused, ".concat((0, $2I3Lh.B200), ")");
    var outlineWidth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $8d2e4d4d2c30f95d$export$6d8204c2cb2e06b8() / 4;
    (0, $1khUv.default)("@atlaskit/theme", "focus ring mixin", "Please use `@atlaskit/focus-ring` instead.");
    return "\n  &:focus {\n    outline: none;\n    box-shadow: 0px 0px 0px ".concat(outlineWidth, "px ").concat(color, ";\n  }\n");
};
var $8d2e4d4d2c30f95d$export$c0dd343266bc3261 = function noFocusRing() {
    return "\n  box-shadow: none;\n";
};
var $8d2e4d4d2c30f95d$export$7be255094ccdc533 = {
    card: function card() {
        return 100;
    },
    navigation: function navigation() {
        return 200;
    },
    dialog: function dialog() {
        return 300;
    },
    layer: function layer() {
        return 400;
    },
    blanket: function blanket() {
        return 500;
    },
    modal: function modal() {
        return 510;
    },
    flag: function flag() {
        return 600;
    },
    spotlight: function spotlight() {
        return 700;
    },
    tooltip: function tooltip() {
        return 9999;
    }
};
var $8d2e4d4d2c30f95d$export$a1b3edb637fb4f35 = function visuallyHidden() {
    (0, $1khUv.default)("@atlaskit/theme", "visually hidden mixin", "Please use `@atlaskit/visually-hidden` instead.");
    return {
        border: "0 !important",
        clip: "rect(1px, 1px, 1px, 1px) !important",
        height: "1px !important",
        overflow: "hidden !important",
        padding: "0 !important",
        position: "absolute !important",
        width: "1px !important",
        whiteSpace: "nowrap !important"
    };
};
var $8d2e4d4d2c30f95d$export$ba1d834b86d72a09 = $8d2e4d4d2c30f95d$export$a1b3edb637fb4f35;
var $8d2e4d4d2c30f95d$export$e497e856b4f89fcd = function skeletonShimmer() {
    return {
        css: {
            backgroundColor: "var(--ds-skeleton, ".concat((0, $2I3Lh.N20A), ")"),
            animationDuration: "1.5s",
            animationIterationCount: "infinite",
            animationTimingFunction: "linear",
            animationDirection: "alternate"
        },
        keyframes: {
            from: {
                backgroundColor: "var(--ds-skeleton, ".concat((0, $2I3Lh.N20A), ")")
            },
            to: {
                backgroundColor: "var(--ds-skeleton-subtle, ".concat((0, $2I3Lh.N30A), ")")
            }
        }
    };
};

});
parcelRegister("1khUv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0f758d50ef77ca28$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "propDeprecationWarning", function () { return $0f758d50ef77ca28$export$eb1decd851a5ae56; });

var $kPB4R = parcelRequire("kPB4R");

var $ahJoN = parcelRequire("ahJoN");
function $0f758d50ef77ca28$export$2e2bcd8739ae039(packageName, api, additionalMessage) {
    (0, $kPB4R.default)("[".concat(packageName, "]: The ").concat(api, " is deprecated.").concat(additionalMessage && " ".concat(additionalMessage)));
}
function $0f758d50ef77ca28$export$eb1decd851a5ae56(packageName, propName, predicate, deprecationAnnouncementOnDAC) {
    typeof $ahJoN;
}

});
parcelRegister("kPB4R", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f2a554e433b7503b$export$2e2bcd8739ae039; });
/* eslint-disable no-console */ var $f2a554e433b7503b$var$printed = {};
function $f2a554e433b7503b$export$2e2bcd8739ae039(message) {
    if ($f2a554e433b7503b$var$printed[message]) return;
    $f2a554e433b7503b$var$printed[message] = true;
    if (typeof window !== "undefined") console.warn(message);
}

});



parcelRegister("7SBjN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5bca86327d1fb274$export$2e2bcd8739ae039; });

var $2I3Lh = parcelRequire("2I3Lh");
// Hard coding the active rgba color value rather than using a helper to convert it
// With helper it would be: hex2rgba(colors.B75, 0.6)
var $5bca86327d1fb274$var$fadedB75 = "rgba(179, 212, 255, 0.6)";
var $5bca86327d1fb274$var$values = {
    // Default appearance
    background: {
        default: {
            default: {
                light: "var(--ds-background-neutral, ".concat($2I3Lh.N20A, ")"),
                dark: "var(--ds-background-neutral, ".concat($2I3Lh.DN70, ")")
            },
            hover: {
                light: "var(--ds-background-neutral-hovered, ".concat($2I3Lh.N30A, ")"),
                dark: "var(--ds-background-neutral-hovered, ".concat($2I3Lh.DN60, ")")
            },
            active: {
                light: "var(--ds-background-neutral-pressed, ".concat($5bca86327d1fb274$var$fadedB75, ")"),
                dark: "var(--ds-background-neutral-pressed, ".concat($2I3Lh.B75, ")")
            },
            disabled: {
                light: "var(--ds-background-disabled, ".concat($2I3Lh.N20A, ")"),
                dark: "var(--ds-background-disabled, ".concat($2I3Lh.DN70, ")")
            },
            selected: {
                light: "var(--ds-background-selected, ".concat($2I3Lh.N700, ")"),
                dark: "var(--ds-background-selected, ".concat($2I3Lh.DN0, ")")
            },
            focusSelected: {
                light: "var(--ds-background-selected, ".concat($2I3Lh.N700, ")"),
                dark: "var(--ds-background-selected, ".concat($2I3Lh.DN0, ")")
            }
        },
        primary: {
            default: {
                light: "var(--ds-background-brand-bold, ".concat($2I3Lh.B400, ")"),
                dark: "var(--ds-background-brand-bold, ".concat($2I3Lh.B100, ")")
            },
            hover: {
                light: "var(--ds-background-brand-bold-hovered, ".concat($2I3Lh.B300, ")"),
                dark: "var(--ds-background-brand-bold-hovered, ".concat($2I3Lh.B75, ")")
            },
            active: {
                light: "var(--ds-background-brand-bold-pressed, ".concat($2I3Lh.B500, ")"),
                dark: "var(--ds-background-brand-bold-pressed, ".concat($2I3Lh.B200, ")")
            },
            disabled: {
                light: "var(--ds-background-disabled, ".concat($2I3Lh.N20A, ")"),
                dark: "var(--ds-background-disabled, ".concat($2I3Lh.DN70, ")")
            },
            selected: {
                light: "var(--ds-background-selected, ".concat($2I3Lh.N700, ")"),
                dark: "var(--ds-background-selected, ".concat($2I3Lh.DN0, ")")
            },
            focusSelected: {
                light: "var(--ds-background-selected, ".concat($2I3Lh.N700, ")"),
                dark: "var(--ds-background-selected, ".concat($2I3Lh.DN0, ")")
            }
        },
        warning: {
            default: {
                light: "var(--ds-background-warning-bold, ".concat($2I3Lh.Y300, ")"),
                dark: "var(--ds-background-warning-bold, ".concat($2I3Lh.Y300, ")")
            },
            hover: {
                light: "var(--ds-background-warning-bold-hovered, ".concat($2I3Lh.Y200, ")"),
                dark: "var(--ds-background-warning-bold-hovered, ".concat($2I3Lh.Y200, ")")
            },
            active: {
                light: "var(--ds-background-warning-bold-pressed, ".concat($2I3Lh.Y400, ")"),
                dark: "var(--ds-background-warning-bold-pressed, ".concat($2I3Lh.Y400, ")")
            },
            disabled: {
                light: "var(--ds-background-disabled, ".concat($2I3Lh.N20A, ")"),
                dark: "var(--ds-background-disabled, ".concat($2I3Lh.DN70, ")")
            },
            selected: {
                light: "var(--ds-background-selected, ".concat($2I3Lh.Y400, ")"),
                dark: "var(--ds-background-selected, ".concat($2I3Lh.Y400, ")")
            },
            focusSelected: {
                light: "var(--ds-background-selected, ".concat($2I3Lh.Y400, ")"),
                dark: "var(--ds-background-selected, ".concat($2I3Lh.Y400, ")")
            }
        },
        danger: {
            default: {
                light: "var(--ds-background-danger-bold, ".concat($2I3Lh.R400, ")"),
                dark: "var(--ds-background-danger-bold, ".concat($2I3Lh.R400, ")")
            },
            hover: {
                light: "var(--ds-background-danger-bold-hovered, ".concat($2I3Lh.R300, ")"),
                dark: "var(--ds-background-danger-bold-hovered, ".concat($2I3Lh.R300, ")")
            },
            active: {
                light: "var(--ds-background-danger-bold-pressed, ".concat($2I3Lh.R500, ")"),
                dark: "var(--ds-background-danger-bold-pressed, ".concat($2I3Lh.R500, ")")
            },
            disabled: {
                light: "var(--ds-background-disabled, ".concat($2I3Lh.N20A, ")"),
                dark: "var(--ds-background-disabled, ".concat($2I3Lh.DN70, ")")
            },
            selected: {
                light: "var(--ds-background-selected, ".concat($2I3Lh.R500, ")"),
                dark: "var(--ds-background-selected, ".concat($2I3Lh.R500, ")")
            },
            focusSelected: {
                light: "var(--ds-background-selected, ".concat($2I3Lh.R500, ")"),
                dark: "var(--ds-background-selected, ".concat($2I3Lh.R500, ")")
            }
        },
        link: {
            default: {
                light: "var(--ds-background-neutral-subtle, none)",
                dark: "var(--ds-background-neutral-subtle, none)"
            },
            selected: {
                light: "var(--ds-background-selected, ".concat($2I3Lh.N700, ")"),
                dark: "var(--ds-background-selected, ".concat($2I3Lh.N20, ")")
            },
            focusSelected: {
                light: "var(--ds-background-selected, ".concat($2I3Lh.N700, ")"),
                dark: "var(--ds-background-selected, ".concat($2I3Lh.N20, ")")
            }
        },
        subtle: {
            default: {
                light: "var(--ds-background-neutral-subtle, none)",
                dark: "var(--ds-background-neutral-subtle, none)"
            },
            hover: {
                light: "var(--ds-background-neutral-subtle-hovered, ".concat($2I3Lh.N30A, ")"),
                dark: "var(--ds-background-neutral-subtle-hovered, ".concat($2I3Lh.DN60, ")")
            },
            active: {
                light: "var(--ds-background-neutral-subtle-pressed, ".concat($5bca86327d1fb274$var$fadedB75, ")"),
                dark: "var(--ds-background-neutral-subtle-pressed, ".concat($2I3Lh.B75, ")")
            },
            disabled: {
                light: "var(--ds-background-neutral-subtle, none)",
                dark: "var(--ds-background-neutral-subtle, none)"
            },
            selected: {
                light: "var(--ds-background-selected, ".concat($2I3Lh.N700, ")"),
                dark: "var(--ds-background-selected, ".concat($2I3Lh.DN0, ")")
            },
            focusSelected: {
                light: "var(--ds-background-selected, ".concat($2I3Lh.N700, ")"),
                dark: "var(--ds-background-selected, ".concat($2I3Lh.DN0, ")")
            }
        },
        "subtle-link": {
            default: {
                light: "var(--ds-background-neutral-subtle, none)",
                dark: "var(--ds-background-neutral-subtle, none)"
            },
            selected: {
                light: "var(--ds-background-selected, ".concat($2I3Lh.N700, ")"),
                dark: "var(--ds-background-selected, ".concat($2I3Lh.N20, ")")
            },
            focusSelected: {
                light: "var(--ds-background-selected, ".concat($2I3Lh.N700, ")"),
                dark: "var(--ds-background-selected, ".concat($2I3Lh.N20, ")")
            }
        }
    },
    color: {
        default: {
            default: {
                light: "var(--ds-text, ".concat($2I3Lh.N500, ")"),
                dark: "var(--ds-text, ".concat($2I3Lh.DN400, ")")
            },
            active: {
                light: "var(--ds-text, ".concat($2I3Lh.B400, ")"),
                dark: "var(--ds-text, ".concat($2I3Lh.B400, ")")
            },
            disabled: {
                light: "var(--ds-text-disabled, ".concat($2I3Lh.N70, ")"),
                dark: "var(--ds-text-disabled, ".concat($2I3Lh.DN30, ")")
            },
            selected: {
                light: "var(--ds-text-selected, ".concat($2I3Lh.N20, ")"),
                dark: "var(--ds-text-selected, ".concat($2I3Lh.DN400, ")")
            },
            focusSelected: {
                light: "var(--ds-text-selected, ".concat($2I3Lh.N20, ")"),
                dark: "var(--ds-text-selected, ".concat($2I3Lh.DN400, ")")
            }
        },
        primary: {
            default: {
                light: "var(--ds-text-inverse, ".concat($2I3Lh.N0, ")"),
                dark: "var(--ds-text-inverse, ".concat($2I3Lh.DN30, ")")
            },
            disabled: {
                light: "var(--ds-text-disabled, ".concat($2I3Lh.N70, ")"),
                dark: "var(--ds-text-disabled, ".concat($2I3Lh.DN30, ")")
            },
            selected: {
                light: "var(--ds-text-selected, ".concat($2I3Lh.N20, ")"),
                dark: "var(--ds-text-selected, ".concat($2I3Lh.DN400, ")")
            },
            focusSelected: {
                light: "var(--ds-text-selected, ".concat($2I3Lh.N20, ")"),
                dark: "var(--ds-text-selected, ".concat($2I3Lh.DN400, ")")
            }
        },
        warning: {
            default: {
                light: "var(--ds-text-warning-inverse, ".concat($2I3Lh.N800, ")"),
                dark: "var(--ds-text-warning-inverse, ".concat($2I3Lh.N800, ")")
            },
            disabled: {
                light: "var(--ds-text-disabled, ".concat($2I3Lh.N70, ")"),
                dark: "var(--ds-text-disabled, ".concat($2I3Lh.DN30, ")")
            },
            selected: {
                light: "var(--ds-text-selected, ".concat($2I3Lh.N800, ")"),
                dark: "var(--ds-text-selected, ".concat($2I3Lh.N800, ")")
            },
            focusSelected: {
                light: "var(--ds-text-selected, ".concat($2I3Lh.N800, ")"),
                dark: "var(--ds-text-selected, ".concat($2I3Lh.N800, ")")
            }
        },
        danger: {
            default: {
                light: "var(--ds-text-inverse, ".concat($2I3Lh.N0, ")"),
                dark: "var(--ds-text-inverse, ".concat($2I3Lh.N0, ")")
            },
            disabled: {
                light: "var(--ds-text-disabled, ".concat($2I3Lh.N70, ")"),
                dark: "var(--ds-text-disabled, ".concat($2I3Lh.DN30, ")")
            },
            selected: {
                light: "var(--ds-text-selected, ".concat($2I3Lh.N0, ")"),
                dark: "var(--ds-text-selected, ".concat($2I3Lh.N0, ")")
            },
            focusSelected: {
                light: "var(--ds-text-selected, ".concat($2I3Lh.N0, ")"),
                dark: "var(--ds-text-selected, ".concat($2I3Lh.N0, ")")
            }
        },
        link: {
            default: {
                light: "var(--ds-link, ".concat($2I3Lh.B400, ")"),
                dark: "var(--ds-link, ".concat($2I3Lh.B100, ")")
            },
            hover: {
                light: "var(--ds-link, ".concat($2I3Lh.B300, ")"),
                dark: "var(--ds-link, ".concat($2I3Lh.B75, ")")
            },
            active: {
                light: "var(--ds-link-pressed, ".concat($2I3Lh.B500, ")"),
                dark: "var(--ds-link-pressed, ".concat($2I3Lh.B200, ")")
            },
            disabled: {
                light: "var(--ds-text-disabled, ".concat($2I3Lh.N70, ")"),
                dark: "var(--ds-text-disabled, ".concat($2I3Lh.DN100, ")")
            },
            selected: {
                light: "var(--ds-text-selected, ".concat($2I3Lh.N20, ")"),
                dark: "var(--ds-text-selected, ".concat($2I3Lh.N700, ")")
            },
            focusSelected: {
                light: "var(--ds-text-selected, ".concat($2I3Lh.N20, ")"),
                dark: "var(--ds-text-selected, ".concat($2I3Lh.N700, ")")
            }
        },
        subtle: {
            default: {
                light: "var(--ds-text, ".concat($2I3Lh.N500, ")"),
                dark: "var(--ds-text, ".concat($2I3Lh.DN400, ")")
            },
            active: {
                light: "var(--ds-text, ".concat($2I3Lh.B400, ")"),
                dark: "var(--ds-text, ".concat($2I3Lh.B400, ")")
            },
            disabled: {
                light: "var(--ds-text-disabled, ".concat($2I3Lh.N70, ")"),
                dark: "var(--ds-text-disabled, ".concat($2I3Lh.DN100, ")")
            },
            selected: {
                light: "var(--ds-text-selected, ".concat($2I3Lh.N20, ")"),
                dark: "var(--ds-text-selected, ".concat($2I3Lh.DN400, ")")
            },
            focusSelected: {
                light: "var(--ds-text-selected, ".concat($2I3Lh.N20, ")"),
                dark: "var(--ds-text-selected, ".concat($2I3Lh.DN400, ")")
            }
        },
        "subtle-link": {
            default: {
                light: "var(--ds-text-subtle, ".concat($2I3Lh.N200, ")"),
                dark: "var(--ds-text-subtle, ".concat($2I3Lh.DN400, ")")
            },
            hover: {
                light: "var(--ds-text-subtle, ".concat($2I3Lh.N90, ")"),
                dark: "var(--ds-text-subtle, ".concat($2I3Lh.B50, ")")
            },
            active: {
                light: "var(--ds-text, ".concat($2I3Lh.N400, ")"),
                dark: "var(--ds-text, ".concat($2I3Lh.DN300, ")")
            },
            disabled: {
                light: "var(--ds-text-disabled, ".concat($2I3Lh.N70, ")"),
                dark: "var(--ds-text-disabled, ".concat($2I3Lh.DN100, ")")
            },
            selected: {
                light: "var(--ds-text-selected, ".concat($2I3Lh.N20, ")"),
                dark: "var(--ds-text-selected, ".concat($2I3Lh.DN400, ")")
            },
            focusSelected: {
                light: "var(--ds-text-selected, ".concat($2I3Lh.N20, ")"),
                dark: "var(--ds-text-selected, ".concat($2I3Lh.DN400, ")")
            }
        }
    }
};
var $5bca86327d1fb274$export$2e2bcd8739ae039 = $5bca86327d1fb274$var$values;

});


parcelRegister("dUYqG", function(module, exports) {

$parcel$export(module.exports, "getIfVisuallyHiddenChildren", function () { return $a21f61595cb10363$export$20bbd2efb0d734c4; });

var $dAx5m = parcelRequire("dAx5m");

var $dfmtY = parcelRequire("dfmtY");
var $a21f61595cb10363$export$20bbd2efb0d734c4 = function getIfVisuallyHiddenChildren(children) {
    return children && /*#__PURE__*/ (0, $dAx5m.isValidElement)(children) && children.type === (0, $dfmtY.default);
};

});
parcelRegister("dfmtY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9a4e1da567883d6a$export$2e2bcd8739ae039; });
/* visually-hidden.tsx generated by @compiled/babel-plugin v0.36.1 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
// eslint-disable-next-line @atlaskit/design-system/use-visually-hidden

var $dAx5m = parcelRequire("dAx5m");

var $fo4ms = parcelRequire("fo4ms");
var $9a4e1da567883d6a$var$visuallyHiddenStyles = null;
/**
 * __Visually hidden__
 *
 * A composable element to apply a visually hidden effect to children.
 * Useful for accessibility compliance.
 *
 * @example
 * ```jsx
 * import VisuallyHidden from '@atlaskit/visually-hidden';
 *
 * export default () => (
 *   <div style={{ border: '1px solid black' }}>
 *      There is text hidden between the brackets [
 *      <VisuallyHidden>Can't see me!</VisuallyHidden>]
 *   </div>
 * );
 * ```
 */ var $9a4e1da567883d6a$var$VisuallyHidden = function VisuallyHidden(_ref) {
    var children = _ref.children, testId = _ref.testId, role = _ref.role, id = _ref.id;
    return /*#__PURE__*/ $dAx5m.createElement("span", {
        id: id,
        "data-testid": testId,
        role: role,
        className: (0, $fo4ms.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itidpf _1reo15vq _18m915vq _1bsbt94y _4t3it94y _kqswstnw _ogto7mnp _o5721q9c"
        ])
    }, children);
};
var $9a4e1da567883d6a$export$2e2bcd8739ae039 = $9a4e1da567883d6a$var$VisuallyHidden;

});
parcelRegister("fo4ms", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b33c7aee19eee464$export$2e2bcd8739ae039; });
const $b33c7aee19eee464$var$UNDERSCORE_UNICODE = 95;
/**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $b33c7aee19eee464$var$ATOMIC_GROUP_LENGTH = 5;
function $b33c7aee19eee464$export$2e2bcd8739ae039(classNames) {
    if (classNames.length <= 1 && (!classNames[0] || classNames[0].indexOf(" ") === -1)) // short circuit if there's no custom class names.
    return classNames[0] || undefined;
    const atomicGroups = {};
    for(let i = 0; i < classNames.length; i++){
        const cls = classNames[i];
        if (!cls) continue;
        const groups = cls.split(" ");
        for(let x = 0; x < groups.length; x++){
            const atomic = groups[x];
            const atomicGroupName = atomic.slice(0, atomic.charCodeAt(0) === $b33c7aee19eee464$var$UNDERSCORE_UNICODE ? $b33c7aee19eee464$var$ATOMIC_GROUP_LENGTH : undefined);
            atomicGroups[atomicGroupName] = atomic;
        }
    }
    let str = "";
    for(const key in atomicGroups){
        const value = atomicGroups[key];
        str += value + " ";
    }
    return str.slice(0, -1);
}

});




parcelRegister("6JrVv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4e6c9bae038248bd$export$2e2bcd8739ae039; });

var $dUYqG = parcelRequire("dUYqG");
function $4e6c9bae038248bd$export$2e2bcd8739ae039(_ref) {
    var children = _ref.children, iconBefore = _ref.iconBefore, iconAfter = _ref.iconAfter;
    if ((0, $dUYqG.getIfVisuallyHiddenChildren)(children)) return true;
    if (children) return false;
    if (iconBefore && !iconAfter) return true;
    if (!iconBefore && iconAfter) return true;
    return false;
}

});



parcelRegister("3xWrW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2951cb0d47d505bb$export$2e2bcd8739ae039; });
/* heading.partial.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $1m89o = parcelRequire("1m89o");

var $dAx5m = parcelRequire("dAx5m");

var $5FDU9 = parcelRequire("5FDU9");

var $dG34F = parcelRequire("dG34F");

var $8NxUT = parcelRequire("8NxUT");

var $fjKSK = parcelRequire("fjKSK");

var $ahJoN = parcelRequire("ahJoN");
var $2951cb0d47d505bb$var$sizeTagMap = {
    xxlarge: "h1",
    xlarge: "h1",
    large: "h2",
    medium: "h3",
    small: "h4",
    xsmall: "h5",
    xxsmall: "h6"
};
var $2951cb0d47d505bb$var$styles = {
    reset: "_1mouidpf _1dyz4jg8 _1p1dglyw"
};
var $2951cb0d47d505bb$var$headingColorStylesMap = {
    "color.text": "_syaz1fxt",
    "color.text.inverse": "_syaz15cr",
    "color.text.warning.inverse": "_syazal3n"
};
/**
 * THIS SECTION WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c47bed69b7a147a63fdb8c394e98514a>>
 * @codegenId typography
 * @codegenCommand yarn workspace @atlaskit/heading codegen
 */ var $2951cb0d47d505bb$var$headingSizeStylesMap = {
    xxlarge: "_11c84xcc",
    xlarge: "_11c81c04",
    large: "_11c8nf1z",
    medium: "_11c8lodh",
    small: "_11c8nbxd",
    xsmall: "_11c8140y",
    xxsmall: "_11c81vhk"
};
/**
 * @codegenEnd
 */ var $2951cb0d47d505bb$var$useColor = function useColor(colorProp) {
    var surface = (0, $8NxUT.useSurface)();
    if (colorProp) return colorProp;
    if ((0, $dG34F.inverseColorMap).hasOwnProperty(surface)) return (0, $dG34F.inverseColorMap)[surface];
    return "color.text";
};
/**
 * __Heading__
 *
 * Heading is a typography component used to display text in defined sizes and styles.
 *
 * @example
 *
 * ```jsx
 * <Heading size="xxlarge">Page title</Heading>
 * ```
 */ var $2951cb0d47d505bb$var$Heading = /*#__PURE__*/ (0, $dAx5m.forwardRef)(function(props, ref) {
    var children = props.children, size = props.size, id = props.id, testId = props.testId, as = props.as, colorProp = props.color;
    typeof $ahJoN;
    var _useHeading = (0, $fjKSK.useHeading)($2951cb0d47d505bb$var$sizeTagMap[size]), _useHeading2 = (0, (/*@__PURE__*/$parcel$interopDefault($1m89o)))(_useHeading, 2), hLevel = _useHeading2[0], inferredElement = _useHeading2[1];
    var Component = as || inferredElement;
    var needsAriaRole = Component === "div" && hLevel;
    var color = $2951cb0d47d505bb$var$useColor(colorProp);
    return /*#__PURE__*/ $dAx5m.createElement(Component, {
        id: id,
        ref: ref,
        "data-testid": testId,
        role: needsAriaRole ? "heading" : undefined,
        "aria-level": needsAriaRole ? hLevel : undefined,
        className: (0, $5FDU9.default)([
            $2951cb0d47d505bb$var$styles.reset,
            size && $2951cb0d47d505bb$var$headingSizeStylesMap[size],
            $2951cb0d47d505bb$var$headingColorStylesMap[color]
        ])
    }, children);
});
var $2951cb0d47d505bb$export$2e2bcd8739ae039 = $2951cb0d47d505bb$var$Heading;

});
parcelRegister("5FDU9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $420fbc576682071f$export$2e2bcd8739ae039; });
const $420fbc576682071f$var$UNDERSCORE_UNICODE = 95;
/**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $420fbc576682071f$var$ATOMIC_GROUP_LENGTH = 5;
function $420fbc576682071f$export$2e2bcd8739ae039(classNames) {
    if (classNames.length <= 1 && (!classNames[0] || classNames[0].indexOf(" ") === -1)) // short circuit if there's no custom class names.
    return classNames[0] || undefined;
    const atomicGroups = {};
    for(let i = 0; i < classNames.length; i++){
        const cls = classNames[i];
        if (!cls) continue;
        const groups = cls.split(" ");
        for(let x = 0; x < groups.length; x++){
            const atomic = groups[x];
            const atomicGroupName = atomic.slice(0, atomic.charCodeAt(0) === $420fbc576682071f$var$UNDERSCORE_UNICODE ? $420fbc576682071f$var$ATOMIC_GROUP_LENGTH : undefined);
            atomicGroups[atomicGroupName] = atomic;
        }
    }
    let str = "";
    for(const key in atomicGroups){
        const value = atomicGroups[key];
        str += value + " ";
    }
    return str.slice(0, -1);
}

});

parcelRegister("fjKSK", function(module, exports) {

$parcel$export(module.exports, "useHeading", function () { return $b26cff295cd4dc82$export$97a37b1befbbf9b1; });

var $dAx5m = parcelRequire("dAx5m");
// Allows support for heading levels 1-9 via aria-level
var $b26cff295cd4dc82$var$HeadingLevelContext = /*#__PURE__*/ (0, $dAx5m.createContext)(0);
/**
 * @internal
 * @returns The current heading level context.
 */ var $b26cff295cd4dc82$var$useHeadingLevel = function useHeadingLevel() {
    return (0, $dAx5m.useContext)($b26cff295cd4dc82$var$HeadingLevelContext);
};
var $b26cff295cd4dc82$export$97a37b1befbbf9b1 = function useHeading(fallback) {
    var hLevel = $b26cff295cd4dc82$var$useHeadingLevel();
    /**
   * Order here is important, we for now apply
   * 1. inferred a11y level (this only applies if context is present)
   * 2. default final fallback
   */ return [
        hLevel,
        hLevel && (hLevel > 6 ? "div" : "h".concat(hLevel)) || fallback
    ];
};
/**
 * __Heading level provider__
 *
 * The Heading level provider injects the heading level to all `Heading` components below it in the component tree.
 *
 * @example
 * ```tsx
 * // Will correctly infer the heading level
 * <HeadingContext value={1}>
 *  <Heading>H1</Heading>
 *  <HeadingContext>
 *    <Heading>H2</Heading>
 *  </HeadingContext>
 * </HeadingContext>
 * ```
 */ var $b26cff295cd4dc82$var$HeadingLevelContextProvider = function HeadingLevelContextProvider(_ref) {
    var children = _ref.children, value = _ref.value;
    var parentHeadingLevel = $b26cff295cd4dc82$var$useHeadingLevel();
    var headingLevel = parentHeadingLevel + 1;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement($b26cff295cd4dc82$var$HeadingLevelContext.Provider, {
        value: value || headingLevel
    }, children);
};
var $b26cff295cd4dc82$export$2e2bcd8739ae039 = $b26cff295cd4dc82$var$HeadingLevelContextProvider;

});


parcelRegister("3QXCS", function(module, exports) {

$parcel$export(module.exports, "SwitcherExperimentProvider", function () { return $2ce47ae7b422e3ae$export$cd11e4cf103a20cf; });
$parcel$export(module.exports, "useSwitcherTeam25Experiment", function () { return $2ce47ae7b422e3ae$export$f0a8b7930250858a; });
$parcel$export(module.exports, "useIsSwitcherTeam25TestCohort", function () { return $2ce47ae7b422e3ae$export$3b522177296bf82b; });

var $1m89o = parcelRequire("1m89o");

var $dAx5m = parcelRequire("dAx5m");
// Temporary fix to enable the Growth team’s app recommendation section to access our experiment.
// TODO: https://hello.jira.atlassian.cloud/browse/NAVX-350
var $2ce47ae7b422e3ae$var$storageKey = "@atlassian/switcher-team-25-experiment-cohort";
var $2ce47ae7b422e3ae$export$fcdf652c4fd8e4c7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createContext(undefined);
var $2ce47ae7b422e3ae$export$cd11e4cf103a20cf = function SwitcherExperimentProvider(_ref) {
    var children = _ref.children;
    var _useState = (0, $dAx5m.useState)(), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($1m89o)))(_useState, 2), switcherTeam25ExperimentCohort = _useState2[0], setSwitcherTeam25ExperimentCohort = _useState2[1];
    var contextValue = (0, $dAx5m.useMemo)(function() {
        return {
            switcherTeam25ExperimentCohort: switcherTeam25ExperimentCohort,
            setSwitcherTeam25ExperimentCohort: setSwitcherTeam25ExperimentCohort
        };
    }, [
        switcherTeam25ExperimentCohort,
        setSwitcherTeam25ExperimentCohort
    ]);
    (0, $dAx5m.useEffect)(function() {
        var _window;
        if ((_window = window) !== null && _window !== void 0 && _window.sessionStorage && switcherTeam25ExperimentCohort) window.sessionStorage.setItem($2ce47ae7b422e3ae$var$storageKey, switcherTeam25ExperimentCohort);
    }, [
        switcherTeam25ExperimentCohort
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement($2ce47ae7b422e3ae$export$fcdf652c4fd8e4c7.Provider, {
        value: contextValue
    }, children);
};
var $2ce47ae7b422e3ae$export$3135e38521020087 = function useExperimentProvider() {
    return (0, $dAx5m.useContext)($2ce47ae7b422e3ae$export$fcdf652c4fd8e4c7);
};
var $2ce47ae7b422e3ae$export$f0a8b7930250858a = function useSwitcherTeam25Experiment() {
    var experimentContext = $2ce47ae7b422e3ae$export$3135e38521020087();
    return {
        cohort: experimentContext === null || experimentContext === void 0 ? void 0 : experimentContext.switcherTeam25ExperimentCohort,
        setCohort: experimentContext ? experimentContext.setSwitcherTeam25ExperimentCohort : function() {}
    };
};
var $2ce47ae7b422e3ae$export$3b522177296bf82b = function useIsSwitcherTeam25TestCohort() {
    var _window2;
    var _useSwitcherTeam25Exp = $2ce47ae7b422e3ae$export$f0a8b7930250858a(), cohort = _useSwitcherTeam25Exp.cohort;
    if (cohort) return cohort === "test";
    // fallback to session storage
    return ((_window2 = window) === null || _window2 === void 0 || (_window2 = _window2.sessionStorage) === null || _window2 === void 0 ? void 0 : _window2.getItem($2ce47ae7b422e3ae$var$storageKey)) === "test";
};

});


parcelRegister("9yySa", function(module, exports) {

$parcel$export(module.exports, "LozengeType", function () { return $6f525700488f2d16$export$b95b532653e2b7f6; });
$parcel$export(module.exports, "default", function () { return $6f525700488f2d16$export$2e2bcd8739ae039; });

var $lDu5G = parcelRequire("lDu5G");

var $ikhrG = parcelRequire("ikhrG");

var $9HWAT = parcelRequire("9HWAT");

var $dAx5m = parcelRequire("dAx5m");

var $2VF5z = parcelRequire("2VF5z");

var $5QmqT = parcelRequire("5QmqT");

var $2JSZB = parcelRequire("2JSZB");

var $jVTBW = parcelRequire("jVTBW");

var $5M6lo = parcelRequire("5M6lo");

var $55TWT = parcelRequire("55TWT");

var $d1Wgq = parcelRequire("d1Wgq");

var $ix0ZR = parcelRequire("ix0ZR");

var $3QXCS = parcelRequire("3QXCS");
var $6f525700488f2d16$var$_excluded = [
    "icon",
    "description",
    "elemAfter",
    "shouldAllowMultiline",
    "onClick",
    "children",
    "lozenges",
    "product",
    "createAnalyticsEvent",
    "tag",
    "href"
];
var $6f525700488f2d16$export$b95b532653e2b7f6 = /*#__PURE__*/ function(LozengeType) {
    LozengeType["New"] = "new";
    LozengeType["Try"] = "try";
    return LozengeType;
}({});
var $6f525700488f2d16$var$lozengeData = (0, (/*@__PURE__*/$parcel$interopDefault($9HWAT)))((0, (/*@__PURE__*/$parcel$interopDefault($9HWAT)))({}, $6f525700488f2d16$export$b95b532653e2b7f6.New, {
    label: (0, $d1Wgq.default).newLozenge,
    componentProps: {
        appearance: "new"
    }
}), $6f525700488f2d16$export$b95b532653e2b7f6.Try, {
    label: (0, $d1Wgq.default).tryLozenge,
    componentProps: {
        appearance: "new"
    }
});
var $6f525700488f2d16$var$fadeInStyles = (0, $jVTBW.css)({
    width: "100%"
});
// this marginTop -4px is to avoid the bottom of description text get cut off
var $6f525700488f2d16$var$itemDescriptionStyles = (0, $jVTBW.css)({
    marginTop: "var(--ds-space-negative-050, -4px)",
    display: "block"
});
var $6f525700488f2d16$var$refreshedItemDescriptionStyles = (0, $jVTBW.css)({
    display: "block",
    marginRight: "var(--ds-space-400, 32px)",
    overflow: "hidden",
    textOverflow: "ellipsis"
});
var $6f525700488f2d16$var$refreshTitleWrapper = (0, $jVTBW.css)({
    display: "block"
});
var $6f525700488f2d16$var$refreshHasDescriptionStyles = (0, $jVTBW.css)({
    marginTop: "var(--ds-space-negative-025, -2px)"
});
var $6f525700488f2d16$var$SwitcherItem = function SwitcherItem(_ref) {
    var icon = _ref.icon, description = _ref.description, elemAfter = _ref.elemAfter, shouldAllowMultiline = _ref.shouldAllowMultiline, _onClick = _ref.onClick, children = _ref.children, lozenges = _ref.lozenges, product = _ref.product, createAnalyticsEvent = _ref.createAnalyticsEvent, tag = _ref.tag, href = _ref.href, rest = (0, (/*@__PURE__*/$parcel$interopDefault($ikhrG)))(_ref, $6f525700488f2d16$var$_excluded);
    var isVisualRefreshEnabled = (0, $3QXCS.useIsSwitcherTeam25TestCohort)();
    var itemDescription = (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).useMemo(function() {
        if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).isValidElement(description) || typeof description === "string") return (0, $jVTBW.jsx)("span", {
            css: isVisualRefreshEnabled ? $6f525700488f2d16$var$refreshedItemDescriptionStyles : $6f525700488f2d16$var$itemDescriptionStyles
        }, description);
        return undefined;
    }, [
        description,
        isVisualRefreshEnabled
    ]);
    var renderLozenges = (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).useMemo(function() {
        if (!(lozenges !== null && lozenges !== void 0 && lozenges.length)) return null;
        return (0, $jVTBW.jsx)((0, $ix0ZR.default), {
            product: product,
            triggerSubject: "switcherItemLozengeErrorBoundary",
            hideFallbackUI: true
        }, (0, $jVTBW.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).Fragment, null, lozenges.map(function(lozenge, index) {
            var _lozengeData$lozenge = $6f525700488f2d16$var$lozengeData[lozenge], componentProps = _lozengeData$lozenge.componentProps, label = _lozengeData$lozenge.label;
            return (0, $jVTBW.jsx)("span", {
                key: index,
                style: {
                    marginLeft: "var(--ds-space-100, 8px)"
                }
            }, (0, $jVTBW.jsx)((0, $5M6lo.default), (0, (/*@__PURE__*/$parcel$interopDefault($lDu5G)))({}, componentProps, {
                testId: "switcher-item-lozenge"
            }), (0, $jVTBW.jsx)((0, $55TWT.default), label)));
        }), (0, $jVTBW.jsx)((0, $5QmqT.RenderTracker), {
            subject: (0, $5QmqT.SWITCHER_ITEM_LOZENGES_SUBJECT),
            data: {
                product: product,
                lozenges: lozenges,
                children: children,
                description: description
            }
        })));
    }, [
        lozenges,
        product,
        children,
        description
    ]);
    return (0, $jVTBW.jsx)((0, $2JSZB.FadeIn), {
        css: $6f525700488f2d16$var$fadeInStyles,
        tag: tag
    }, (0, $jVTBW.jsx)((0, $2VF5z.default), (0, (/*@__PURE__*/$parcel$interopDefault($lDu5G)))({
        testId: "switcher-base-item",
        description: itemDescription,
        iconBefore: icon,
        shouldTitleWrap: false,
        shouldDescriptionWrap: false,
        iconAfter: elemAfter,
        target: "_blank",
        href: href !== null && href !== void 0 ? href : "#",
        onClick: function onClick(event) {
            // To prevent the page from reloading when using a fallback '#' in href, make sure to use preventDefault.
            if (!href) event.preventDefault();
            if (_onClick) _onClick(event);
        }
    }, rest), (0, $jVTBW.jsx)("span", {
        css: isVisualRefreshEnabled ? [
            $6f525700488f2d16$var$refreshTitleWrapper,
            itemDescription && $6f525700488f2d16$var$refreshHasDescriptionStyles
        ] : undefined
    }, children, renderLozenges)));
};
var $6f525700488f2d16$export$2e2bcd8739ae039 = $6f525700488f2d16$var$SwitcherItem;

});
parcelRegister("2VF5z", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2220c7054626f202$export$2e2bcd8739ae039; });

var $lDu5G = parcelRequire("lDu5G");

var $ikhrG = parcelRequire("ikhrG");

var $dAx5m = parcelRequire("dAx5m");

var $jVTBW = parcelRequire("jVTBW");

var $l4A7i = parcelRequire("l4A7i");

var $1khUv = parcelRequire("1khUv");

var $2NfKg = parcelRequire("2NfKg");

var $4mhQ1 = parcelRequire("4mhQ1");

var $18rB9 = parcelRequire("18rB9");

var $klYhI = parcelRequire("klYhI");
var $2220c7054626f202$var$_excluded = [
    "children",
    "href",
    "cssFn",
    "description",
    "iconAfter",
    "iconBefore",
    "isDisabled",
    "isSelected",
    "onClick",
    "testId",
    "overrides",
    "onMouseDown",
    "shouldTitleWrap",
    "shouldDescriptionWrap",
    "className",
    "UNSAFE_shouldDisableRouterLink",
    "UNSAFE_isDraggable",
    "interactionName"
];
var $2220c7054626f202$var$IS_EXTERNAL_LINK_REGEX = /^(?:(http|https):\/\/)/;
var $2220c7054626f202$var$IS_NON_HTTP_BASED = /^(((mailto|tel|sms):)|(#))/;
var $2220c7054626f202$var$preventEvent = function preventEvent(e) {
    e.preventDefault();
};
/**
 * __Link item__
 *
 * A link item is used to populate a menu with items that are links.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/link-item)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ var $2220c7054626f202$var$LinkItem = /*#__PURE__*/ (0, $dAx5m.memo)(/*#__PURE__*/ (0, $dAx5m.forwardRef)(// Type needed on props to extract types with extract react types.
function(props, ref) {
    var children = props.children, href = props.href, _props$cssFn = props.cssFn, cssFn = _props$cssFn === void 0 ? (0, $2NfKg.default) : _props$cssFn, description = props.description, iconAfter = props.iconAfter, iconBefore = props.iconBefore, _props$isDisabled = props.isDisabled, isDisabled = _props$isDisabled === void 0 ? false : _props$isDisabled, _props$isSelected = props.isSelected, isSelected = _props$isSelected === void 0 ? false : _props$isSelected, onClick = props.onClick, testId = props.testId, overrides = props.overrides, onMouseDown = props.onMouseDown, shouldTitleWrap = props.shouldTitleWrap, shouldDescriptionWrap = props.shouldDescriptionWrap, UNSAFE_className = props.className, UNSAFE_shouldDisableRouterLink = props.UNSAFE_shouldDisableRouterLink, UNSAFE_isDraggable = props.UNSAFE_isDraggable, interactionName = props.interactionName, rest = (0, (/*@__PURE__*/$parcel$interopDefault($ikhrG)))(props, $2220c7054626f202$var$_excluded);
    var onMouseDownHandler = onMouseDown;
    var RouterLink = (0, $l4A7i.default)();
    var interactionContext = (0, $dAx5m.useContext)((0, $4mhQ1.default));
    var handleClick = (0, $dAx5m.useCallback)(function(e) {
        interactionContext === null || interactionContext === void 0 || interactionContext.tracePress(interactionName, e.timeStamp);
        onClick === null || onClick === void 0 || onClick(e);
    }, [
        onClick,
        interactionContext,
        interactionName
    ]);
    if (!children) return null;
    var isExternal = typeof href === "string" && $2220c7054626f202$var$IS_EXTERNAL_LINK_REGEX.test(href);
    var isNonHttpBased = typeof href === "string" && $2220c7054626f202$var$IS_NON_HTTP_BASED.test(href);
    var isEmptyHref = href == null || href === "";
    /**
   * Renders a router link if:
   *
   * - a link component is set in the app provider
   * - it's not an external link (starting with `http://` or `https://`)
   * - it's not a non-HTTP-based link (e.g. emails, phone numbers, hash links etc.)
   * - it doesn't have an empty href (e.g. href="" or href={undefined})
   */ var isRouterLink = !UNSAFE_shouldDisableRouterLink && RouterLink && !isExternal && !isNonHttpBased && !isEmptyHref;
    var Component = isRouterLink ? RouterLink : "a";
    (0, $1khUv.propDeprecationWarning)("@atlaskit/menu", "cssFn", cssFn !== (0, $2NfKg.default), "" // TODO: Create DAC post when primitives/xcss are available as alternatives
    );
    return (0, $jVTBW.jsx)((0, $klYhI.default), (0, (/*@__PURE__*/$parcel$interopDefault($lDu5G)))({}, rest, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: UNSAFE_className,
        overrides: overrides,
        iconBefore: iconBefore,
        iconAfter: iconAfter,
        isSelected: isSelected,
        isDisabled: isDisabled,
        description: description,
        shouldTitleWrap: shouldTitleWrap,
        shouldDescriptionWrap: shouldDescriptionWrap,
        css: // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        cssFn({
            isSelected: isSelected,
            isDisabled: isDisabled
        }),
        title: children,
        testId: testId && "".concat(testId, "--primitive")
    }), function(_ref) {
        var children = _ref.children, className = _ref.className;
        return (0, $jVTBW.jsx)(Component, (0, (/*@__PURE__*/$parcel$interopDefault($lDu5G)))({
            "data-testid": testId,
            "data-is-router-link": testId ? isRouterLink ? "true" : "false" : undefined,
            "data-vc": "link-item"
        }, rest, {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            href: isDisabled ? undefined : href
        }, UNSAFE_isDraggable ? {} : {
            draggable: false,
            onDragStart: $2220c7054626f202$var$preventEvent
        }, {
            onMouseDown: isDisabled ? $2220c7054626f202$var$preventEvent : onMouseDownHandler,
            onClick: isDisabled ? $2220c7054626f202$var$preventEvent : (0, $18rB9.fg)("platform_button_item-add-ufo-metrics") ? handleClick : onClick,
            "aria-current": isSelected ? "page" : undefined,
            "aria-disabled": isDisabled,
            ref: ref
        }), children);
    });
}));
var $2220c7054626f202$export$2e2bcd8739ae039 = $2220c7054626f202$var$LinkItem;

});
parcelRegister("l4A7i", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f575fcba2a426a98$export$2e2bcd8739ae039; });

var $dAx5m = parcelRequire("dAx5m");

var $diK9Y = parcelRequire("diK9Y");
/**
 * __useRouterLink()__
 *
 * Hook: Returns app-configured router link component.
 *
 * A generic can be passed to define advanced link configuration:
 * ```
 * type MyRouterLinkConfig = {
 *  to: string;
 *  replace?: boolean;
 * }
 *
 * const RouterLink = useRouterLink<MyRouterLinkConfig>();
 * ```
 */ var $f575fcba2a426a98$var$useRouterLink = function useRouterLink() {
    var _useContext = (0, $dAx5m.useContext)((0, $diK9Y.RouterLinkProviderContext)), routerLinkComponent = _useContext.routerLinkComponent;
    if (routerLinkComponent) return routerLinkComponent;
};
var $f575fcba2a426a98$export$2e2bcd8739ae039 = $f575fcba2a426a98$var$useRouterLink;

});
parcelRegister("diK9Y", function(module, exports) {

$parcel$export(module.exports, "RouterLinkProviderContext", function () { return $9af0c32f8186ede1$export$2931e0ee690eee88; });

var $dAx5m = parcelRequire("dAx5m");
var $9af0c32f8186ede1$export$2931e0ee690eee88 = /*#__PURE__*/ (0, $dAx5m.createContext)({});
/**
 * __RouterLinkProvider__
 *
 * Provides a configured router link component for use
 * within Design System components.
 */ var $9af0c32f8186ede1$var$RouterLinkProvider = function RouterLinkProvider(_ref) {
    var routerLinkComponent = _ref.routerLinkComponent, children = _ref.children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement($9af0c32f8186ede1$export$2931e0ee690eee88.Provider, {
        value: {
            routerLinkComponent: routerLinkComponent
        }
    }, children);
};
var $9af0c32f8186ede1$export$2e2bcd8739ae039 = $9af0c32f8186ede1$var$RouterLinkProvider;

});


parcelRegister("klYhI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ed148816fdb90787$export$2e2bcd8739ae039; });
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $dAx5m = parcelRequire("dAx5m");

var $jVTBW = parcelRequire("jVTBW");

var $1khUv = parcelRequire("1khUv");

var $8qML2 = parcelRequire("8qML2");

var $18rB9 = parcelRequire("18rB9");

var $ha63T = parcelRequire("ha63T");
var $5vzr2 = parcelRequire("5vzr2");
var $fDIOj = parcelRequire("fDIOj");

var $2I3Lh = parcelRequire("2I3Lh");

var $ancMD = parcelRequire("ancMD");
var $ed148816fdb90787$var$defaultRender = function defaultRender(Component, props) {
    return(// eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    (0, $jVTBW.jsx)(Component, props));
};
var $ed148816fdb90787$var$beforeAfterElementStylesOld = (0, $jVTBW.css)({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0
});
var $ed148816fdb90787$var$beforeAfterElementStyles = (0, $jVTBW.css)({
    display: "flex",
    minWidth: 24,
    minHeight: 24,
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0
});
var $ed148816fdb90787$var$contentStyles = (0, $fDIOj.xcss)({
    outline: "none",
    overflow: "hidden",
    textAlign: "left"
});
var $ed148816fdb90787$var$truncateStyles = (0, $jVTBW.css)({
    display: "block",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap"
});
var $ed148816fdb90787$var$titleStyles = (0, $jVTBW.css)({
    font: 'var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)'
});
var $ed148816fdb90787$var$wordBreakStyles = (0, $jVTBW.css)({
    wordBreak: "break-word"
});
var $ed148816fdb90787$var$descriptionStyles = (0, $jVTBW.css)({
    color: "var(--ds-text-subtlest, ".concat((0, $2I3Lh.N200), ")"),
    font: 'var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)'
});
var $ed148816fdb90787$var$disabledDescriptionStyles = (0, $jVTBW.css)({
    color: "var(--ds-text-disabled, ".concat((0, $2I3Lh.N200), ")")
});
var $ed148816fdb90787$var$positionRelativeStyles = (0, $jVTBW.css)({
    position: "relative"
});
var $ed148816fdb90787$var$primitiveStyles = (0, $jVTBW.css)({
    display: "flex",
    boxSizing: "border-box",
    width: "100%",
    minHeight: 40,
    margin: "var(--ds-space-0, 0px)",
    alignItems: "center",
    border: 0,
    outline: 0,
    textDecoration: "none",
    userSelect: "none",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    "&::-moz-focus-inner": {
        border: 0
    },
    "&:hover": {
        textDecoration: "none"
    }
});
var $ed148816fdb90787$var$spacingMapStyles = {
    cozy: (0, $jVTBW.css)({
        // 8 * 2 (16) + icon (24) === 40
        paddingBlock: "var(--ds-space-100, 8px)",
        paddingInline: "var(--ds-space-200, 16px)"
    }),
    compact: (0, $jVTBW.css)({
        minHeight: 32,
        // 4 * 2 (8) + icon (24) === 32
        paddingBlock: "var(--ds-space-050, 4px)",
        paddingInline: "var(--ds-space-150, 12px)"
    })
};
var $ed148816fdb90787$var$interactiveStyles = (0, $jVTBW.css)({
    cursor: "pointer"
});
var $ed148816fdb90787$var$unselectedStyles = (0, $jVTBW.css)({
    backgroundColor: "var(--ds-background-neutral-subtle, transparent)",
    color: "currentColor",
    "&:visited": {
        color: "currentColor"
    },
    "&:hover": {
        backgroundColor: "var(--ds-background-neutral-subtle-hovered, ".concat((0, $2I3Lh.N20), ")"),
        color: "currentColor"
    },
    "&:active": {
        backgroundColor: "var(--ds-background-neutral-subtle-pressed, ".concat((0, $2I3Lh.N30), ")"),
        boxShadow: "none",
        color: "currentColor"
    }
});
var $ed148816fdb90787$var$disabledStyles = (0, $jVTBW.css)({
    cursor: "not-allowed",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    "&, :hover, :active": {
        backgroundColor: "var(--ds-background-neutral-subtle, transparent)",
        color: "var(--ds-text-disabled, ".concat((0, $2I3Lh.N200), ")")
    }
});
var $ed148816fdb90787$var$selectedBorderStyles = (0, $jVTBW.css)({
    "&::before": {
        width: 2,
        position: "absolute",
        background: "var(--ds-border-selected, transparent)",
        content: '""',
        insetBlockEnd: 0,
        insetBlockStart: 0,
        insetInlineStart: 0
    }
});
var $ed148816fdb90787$var$selectedNotchStyles = (0, $jVTBW.css)({
    "&::before": {
        width: 4,
        position: "absolute",
        background: "var(--ds-border-selected, transparent)",
        borderRadius: "0 ".concat("var(--ds-border-radius, 4px)", " ", "var(--ds-border-radius, 4px)", " 0"),
        content: '""',
        insetBlockEnd: "var(--ds-space-150, 12px)",
        insetBlockStart: "var(--ds-space-150, 12px)",
        insetInlineStart: 0
    }
});
var $ed148816fdb90787$var$selectedStyles = (0, $jVTBW.css)({
    backgroundColor: "var(--ds-background-selected, ".concat((0, $2I3Lh.N20), ")"),
    // Fallback set as babel plugin inserts one otherwise
    color: "var(--ds-text-selected, currentColor)",
    "&:visited": {
        color: "var(--ds-text-selected, currentColor)"
    },
    "&:hover": {
        backgroundColor: "var(--ds-background-selected-hovered, ".concat((0, $2I3Lh.N20), ")"),
        color: "var(--ds-text-selected, currentColor)"
    },
    "&:active": {
        backgroundColor: "var(--ds-background-selected-pressed, ".concat((0, $2I3Lh.N30), ")"),
        color: "var(--ds-text-selected, currentColor)"
    }
});
var $ed148816fdb90787$var$gapMap = {
    compact: "space.100",
    cozy: "space.150"
};
/**
 * __Menu item primitive__
 *
 * Menu item primitive contains all the styles for menu items,
 * including support for selected, disabled, and interaction states.
 *
 * Using children as function prop you wire up this to your own host element.
 *
 * ```jsx
 * <MenuItemPrimitive>
 *   {({ children, ...props }) => <button {...props}>{children}</button>}
 * </MenuItemPrimitive>
 * ```
 */ var $ed148816fdb90787$var$MenuItemPrimitive = function MenuItemPrimitive(_ref) {
    var children = _ref.children, title = _ref.title, description = _ref.description, iconAfter = _ref.iconAfter, iconBefore = _ref.iconBefore, overrides = _ref.overrides, UNSAFE_externalClassName = _ref.className, _ref$shouldTitleWrap = _ref.shouldTitleWrap, shouldTitleWrap = _ref$shouldTitleWrap === void 0 ? false : _ref$shouldTitleWrap, _ref$shouldDescriptio = _ref.shouldDescriptionWrap, shouldDescriptionWrap = _ref$shouldDescriptio === void 0 ? false : _ref$shouldDescriptio, _ref$isDisabled = _ref.isDisabled, isDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled, _ref$isSelected = _ref.isSelected, isSelected = _ref$isSelected === void 0 ? false : _ref$isSelected, testId = _ref.testId;
    (0, $1khUv.propDeprecationWarning)("@atlaskit/menu", "overrides", overrides !== undefined, "" // TODO: Create DAC post when primitives/xcss are available as alternatives
    );
    var spacing = (0, $dAx5m.useContext)((0, $ancMD.SpacingContext));
    var selectionStyle = (0, $dAx5m.useContext)((0, $ancMD.SELECTION_STYLE_CONTEXT_DO_NOT_USE));
    var renderTitle = overrides && overrides.Title && overrides.Title.render || $ed148816fdb90787$var$defaultRender;
    var UNSAFE_className = UNSAFE_externalClassName;
    return (0, $jVTBW.jsx)((0, $jVTBW.ClassNames), null, function(_ref2) {
        var cn = _ref2.css, cx = _ref2.cx;
        return (0, $jVTBW.jsx)((0, $8qML2.default), {
            isInset: true
        }, children({
            className: cx([
                cn([
                    $ed148816fdb90787$var$positionRelativeStyles,
                    $ed148816fdb90787$var$primitiveStyles,
                    $ed148816fdb90787$var$spacingMapStyles[spacing],
                    !isDisabled && !isSelected && $ed148816fdb90787$var$unselectedStyles,
                    !isDisabled && isSelected && [
                        $ed148816fdb90787$var$selectedStyles,
                        [
                            selectionStyle === "border" && $ed148816fdb90787$var$selectedBorderStyles,
                            selectionStyle === "notch" && $ed148816fdb90787$var$selectedNotchStyles
                        ]
                    ],
                    isDisabled ? $ed148816fdb90787$var$disabledStyles : $ed148816fdb90787$var$interactiveStyles
                ]),
                UNSAFE_className
            ]),
            children: (0, $jVTBW.jsx)((0, $ha63T.default), {
                as: "span",
                spread: "space-between",
                alignBlock: "center",
                space: $ed148816fdb90787$var$gapMap[spacing],
                grow: "fill",
                testId: testId && "".concat(testId, "--container")
            }, iconBefore && (0, $jVTBW.jsx)("span", {
                "data-item-elem-before": true,
                css: (0, $18rB9.fg)("platform_ads_component_no_icon_spacing_support") ? $ed148816fdb90787$var$beforeAfterElementStyles : $ed148816fdb90787$var$beforeAfterElementStylesOld,
                "data-testid": testId && "".concat(testId, "--icon-before")
            }, iconBefore), title && (0, $jVTBW.jsx)((0, $5vzr2.default), {
                alignBlock: "center",
                grow: "fill",
                xcss: $ed148816fdb90787$var$contentStyles
            }, renderTitle("span", {
                children: title,
                className: cn($ed148816fdb90787$var$titleStyles, shouldTitleWrap ? $ed148816fdb90787$var$wordBreakStyles : $ed148816fdb90787$var$truncateStyles),
                "data-item-title": true
            }), description && (0, $jVTBW.jsx)("span", {
                "data-item-description": true,
                css: [
                    $ed148816fdb90787$var$descriptionStyles,
                    isDisabled && $ed148816fdb90787$var$disabledDescriptionStyles,
                    shouldDescriptionWrap ? $ed148816fdb90787$var$wordBreakStyles : $ed148816fdb90787$var$truncateStyles
                ]
            }, description)), iconAfter && (0, $jVTBW.jsx)("span", {
                "data-item-elem-after": true,
                css: (0, $18rB9.fg)("platform_ads_component_no_icon_spacing_support") ? $ed148816fdb90787$var$beforeAfterElementStyles : $ed148816fdb90787$var$beforeAfterElementStylesOld,
                "data-testid": testId && "".concat(testId, "--icon-after")
            }, iconAfter))
        }));
    });
};
var $ed148816fdb90787$export$2e2bcd8739ae039 = $ed148816fdb90787$var$MenuItemPrimitive;

});
parcelRegister("ha63T", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c7e812967d9fe3a8$export$2e2bcd8739ae039; });

var $bd3Va = parcelRequire("bd3Va");

var $dAx5m = parcelRequire("dAx5m");

var $jVTBW = parcelRequire("jVTBW");

var $fDIOj = parcelRequire("fDIOj");

var $elgcn = parcelRequire("elgcn");
var $c7e812967d9fe3a8$var$flexGrowMap = {
    hug: (0, $fDIOj.xcss)({
        flexGrow: 0
    }),
    fill: (0, $fDIOj.xcss)({
        width: "100%",
        flexGrow: 1
    })
};
var $c7e812967d9fe3a8$var$separatorStyles = (0, $jVTBW.css)({
    color: "var(--ds-text-subtle, #42526E)",
    marginBlock: "var(--ds-space-0, 0px)",
    marginInline: "var(--ds-space-negative-025, -2px)",
    pointerEvents: "none",
    userSelect: "none"
});
var $c7e812967d9fe3a8$var$Separator = function Separator(_ref) {
    var children = _ref.children;
    return (0, $jVTBW.jsx)("span", {
        css: $c7e812967d9fe3a8$var$separatorStyles
    }, children);
};
/**
 * __Inline__
 *
 * Inline is a primitive component based on CSS Flexbox that manages the horizontal layout of direct children.
 *
 * @example
 * ```tsx
 *  <Inline>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *  </Inline>
 * ```
 *
 */ var $c7e812967d9fe3a8$var$Inline = /*#__PURE__*/ (0, $dAx5m.memo)(/*#__PURE__*/ (0, $dAx5m.forwardRef)(function(_ref2, ref) {
    var as = _ref2.as, alignInline = _ref2.alignInline, _ref2$alignBlock = _ref2.alignBlock, alignItems = _ref2$alignBlock === void 0 ? "start" : _ref2$alignBlock, _ref2$shouldWrap = _ref2.shouldWrap, shouldWrap = _ref2$shouldWrap === void 0 ? false : _ref2$shouldWrap, spread = _ref2.spread, grow = _ref2.grow, space = _ref2.space, rowSpace = _ref2.rowSpace, separator = _ref2.separator, xcss = _ref2.xcss, testId = _ref2.testId, role = _ref2.role, rawChildren = _ref2.children;
    var separatorComponent = typeof separator === "string" ? (0, $jVTBW.jsx)($c7e812967d9fe3a8$var$Separator, null, separator) : separator;
    var children = separatorComponent ? (0, $dAx5m.Children).toArray(rawChildren).filter(Boolean).map(function(child, index) {
        return (0, $jVTBW.jsx)((0, $dAx5m.Fragment), {
            key: index
        }, separator && index > 0 ? separatorComponent : null, child);
    }) : rawChildren;
    var justifyContent = spread || alignInline;
    // We're type coercing this as Compiled styles in an array isn't supported by the types
    // But the runtime accepts it none-the-wiser. We can remove this entire block and replace
    // it with cx(defaultStyles, focusRingStyles, xcssStyles) when we've moved away from Emotion.
    var styles = grow ? [
        $c7e812967d9fe3a8$var$flexGrowMap[grow]
    ].concat((0, (/*@__PURE__*/$parcel$interopDefault($bd3Va)))(Array.isArray(xcss) ? xcss : [
        xcss
    ])) : xcss;
    return (0, $jVTBW.jsx)((0, $elgcn.default), {
        as: as,
        role: role,
        alignItems: alignItems,
        justifyContent: justifyContent,
        direction: "row",
        gap: space,
        rowGap: rowSpace,
        wrap: shouldWrap ? "wrap" : undefined,
        xcss: styles,
        testId: testId,
        ref: ref
    }, children);
}));
$c7e812967d9fe3a8$var$Inline.displayName = "Inline";
var $c7e812967d9fe3a8$export$2e2bcd8739ae039 = $c7e812967d9fe3a8$var$Inline;

});
parcelRegister("elgcn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a70f978ba80e1f24$export$2e2bcd8739ae039; });
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $dAx5m = parcelRequire("dAx5m");

var $jVTBW = parcelRequire("jVTBW");

var $dG34F = parcelRequire("dG34F");

var $fDIOj = parcelRequire("fDIOj");
var $a70f978ba80e1f24$var$justifyContentMap = {
    start: (0, $jVTBW.css)({
        justifyContent: "start"
    }),
    center: (0, $jVTBW.css)({
        justifyContent: "center"
    }),
    end: (0, $jVTBW.css)({
        justifyContent: "end"
    }),
    "space-between": (0, $jVTBW.css)({
        justifyContent: "space-between"
    }),
    "space-around": (0, $jVTBW.css)({
        justifyContent: "space-around"
    }),
    "space-evenly": (0, $jVTBW.css)({
        justifyContent: "space-evenly"
    }),
    stretch: (0, $jVTBW.css)({
        justifyContent: "stretch"
    })
};
var $a70f978ba80e1f24$var$flexDirectionMap = {
    column: (0, $jVTBW.css)({
        flexDirection: "column"
    }),
    row: (0, $jVTBW.css)({
        flexDirection: "row"
    })
};
var $a70f978ba80e1f24$var$flexWrapMap = {
    wrap: (0, $jVTBW.css)({
        flexWrap: "wrap"
    }),
    nowrap: (0, $jVTBW.css)({
        flexWrap: "nowrap"
    })
};
var $a70f978ba80e1f24$var$alignItemsMap = {
    start: (0, $jVTBW.css)({
        alignItems: "start"
    }),
    center: (0, $jVTBW.css)({
        alignItems: "center"
    }),
    baseline: (0, $jVTBW.css)({
        alignItems: "baseline"
    }),
    end: (0, $jVTBW.css)({
        alignItems: "end"
    }),
    stretch: (0, $jVTBW.css)({
        alignItems: "stretch"
    })
};
var $a70f978ba80e1f24$var$baseStyles = (0, $jVTBW.css)({
    display: "flex",
    boxSizing: "border-box"
});
/**
 * __Flex__
 *
 * `Flex` is a primitive component that implements the CSS Flexbox API.
 *
 * - [Examples](https://atlassian.design/components/primitives/flex/examples)
 * - [Code](https://atlassian.design/components/primitives/flex/code)
 *
 * @example
 * ```tsx
 * import { Flex, Box } from '@atlaskit/primitives'
 *
 * const Component = () => (
 *   <Flex direction="column">
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *   </Flex>
 * )
 * ```
 */ var $a70f978ba80e1f24$var$Flex = /*#__PURE__*/ (0, $dAx5m.memo)(/*#__PURE__*/ (0, $dAx5m.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? "div" : _ref$as, role = _ref.role, alignItems = _ref.alignItems, justifyContent = _ref.justifyContent, gap = _ref.gap, columnGap = _ref.columnGap, rowGap = _ref.rowGap, children = _ref.children, testId = _ref.testId, direction = _ref.direction, wrap = _ref.wrap, xcss = _ref.xcss;
    var resolvedStyles = (0, $fDIOj.parseXcss)(xcss);
    return (0, $jVTBW.jsx)(Component, {
        role: role,
        className: resolvedStyles.static,
        css: [
            $a70f978ba80e1f24$var$baseStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            gap && (0, $dG34F.spaceStylesMap).gap[gap],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            columnGap && (0, $dG34F.spaceStylesMap).columnGap[columnGap],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            rowGap && (0, $dG34F.spaceStylesMap).rowGap[rowGap],
            alignItems && $a70f978ba80e1f24$var$alignItemsMap[alignItems],
            direction && $a70f978ba80e1f24$var$flexDirectionMap[direction],
            justifyContent && $a70f978ba80e1f24$var$justifyContentMap[justifyContent],
            wrap && $a70f978ba80e1f24$var$flexWrapMap[wrap],
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
            resolvedStyles.emotion
        ],
        "data-testid": testId,
        ref: ref
    }, children);
}));
$a70f978ba80e1f24$var$Flex.displayName = "Flex";
var $a70f978ba80e1f24$export$2e2bcd8739ae039 = $a70f978ba80e1f24$var$Flex;

});


parcelRegister("5vzr2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $402b55aa5af2655a$export$2e2bcd8739ae039; });

var $bd3Va = parcelRequire("bd3Va");

var $dAx5m = parcelRequire("dAx5m");

var $jVTBW = parcelRequire("jVTBW");

var $fDIOj = parcelRequire("fDIOj");

var $elgcn = parcelRequire("elgcn");
var $402b55aa5af2655a$var$flexGrowMap = {
    hug: (0, $fDIOj.xcss)({
        flexGrow: 0
    }),
    fill: (0, $fDIOj.xcss)({
        width: "100%",
        flexGrow: 1
    })
};
/**
 * __Stack__
 *
 * Stack is a primitive component based on flexbox that manages the block layout of direct children.
 *
 * @example
 * ```tsx
 *  <Stack>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *  </Stack>
 * ```
 *
 */ var $402b55aa5af2655a$var$Stack = /*#__PURE__*/ (0, $dAx5m.memo)(/*#__PURE__*/ (0, $dAx5m.forwardRef)(function(_ref, ref) {
    var as = _ref.as, alignItems = _ref.alignInline, _ref$alignBlock = _ref.alignBlock, alignBlock = _ref$alignBlock === void 0 ? "stretch" : _ref$alignBlock, spread = _ref.spread, grow = _ref.grow, space = _ref.space, children = _ref.children, testId = _ref.testId, xcss = _ref.xcss, role = _ref.role;
    var justifyContent = spread || alignBlock;
    // We're type coercing this as Compiled styles in an array isn't supported by the types
    // But the runtime accepts it none-the-wiser. We can remove this entire block and replace
    // it with cx(defaultStyles, focusRingStyles, xcssStyles) when we've moved away from Emotion.
    var styles = grow ? [
        $402b55aa5af2655a$var$flexGrowMap[grow]
    ].concat((0, (/*@__PURE__*/$parcel$interopDefault($bd3Va)))(Array.isArray(xcss) ? xcss : [
        xcss
    ])) : xcss;
    return (0, $jVTBW.jsx)((0, $elgcn.default), {
        as: as,
        role: role,
        gap: space,
        direction: "column",
        alignItems: alignItems,
        justifyContent: justifyContent,
        xcss: styles,
        testId: testId,
        ref: ref
    }, children);
}));
$402b55aa5af2655a$var$Stack.displayName = "Stack";
var $402b55aa5af2655a$export$2e2bcd8739ae039 = $402b55aa5af2655a$var$Stack;

});

parcelRegister("ancMD", function(module, exports) {

$parcel$export(module.exports, "SpacingContext", function () { return $78d5f7dd1d139a21$export$443076ec7ebce042; });
$parcel$export(module.exports, "SELECTION_STYLE_CONTEXT_DO_NOT_USE", function () { return $78d5f7dd1d139a21$export$9ca534b70725964d; });

var $dAx5m = parcelRequire("dAx5m");
var $78d5f7dd1d139a21$export$443076ec7ebce042 = /*#__PURE__*/ (0, $dAx5m.createContext)("cozy");
var $78d5f7dd1d139a21$export$9ca534b70725964d = /*#__PURE__*/ (0, $dAx5m.createContext)("border");

});



parcelRegister("5M6lo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $43465b3e2ee6831e$export$2e2bcd8739ae039; });

var $dAx5m = parcelRequire("dAx5m");

var $18rB9 = parcelRequire("18rB9");

var $llIFh = parcelRequire("llIFh");

var $7a44Y = parcelRequire("7a44Y");
/**
 * __Lozenge__
 *
 * A lozenge is a visual indicator used to highlight an item's status for quick recognition.
 *
 * - [Examples](https://atlassian.design/components/lozenge/examples)
 * - [Code](https://atlassian.design/components/lozenge/code)
 * - [Usage](https://atlassian.design/components/lozenge/usage)
 */ var $43465b3e2ee6831e$var$Lozenge = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).memo(function(props) {
    return(// eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    (0, $18rB9.fg)("platform_dst_lozenge_fg") ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $llIFh.default), props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $7a44Y.default), props));
});
// NOTE: Remove this and just directly `export { default } from '…';` when tidying `platform_dst_lozenge_fg`
$43465b3e2ee6831e$var$Lozenge.displayName = "Lozenge";
var $43465b3e2ee6831e$export$2e2bcd8739ae039 = $43465b3e2ee6831e$var$Lozenge;

});
parcelRegister("llIFh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f8ae34a0ba9d9ca1$export$2e2bcd8739ae039; });
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $dAx5m = parcelRequire("dAx5m");

var $1xVU6 = parcelRequire("1xVU6");

var $18rB9 = parcelRequire("18rB9");

var $jiOFg = parcelRequire("jiOFg");
var $f8ae34a0ba9d9ca1$var$stylesOld = {
    container: "_2rkoglpi _1reo15vq _18m915vq _18zr1b66 _1e0c116y _1kz6184x _kqswpfqs _vchhusvi",
    "text.bold.default": "_syaz15cr",
    "text.bold.inprogress": "_syaz15cr",
    "text.bold.moved": "_syazal3n",
    "text.bold.new": "_syaz15cr",
    "text.bold.removed": "_syaz15cr",
    "text.bold.success": "_syaz15cr",
    "text.subtle.default": "_syazjjyb",
    "text.subtle.inprogress": "_syaz1lpn",
    "text.subtle.moved": "_syaz1tm6",
    "text.subtle.new": "_syaz1mvf",
    "text.subtle.removed": "_syaz1ick",
    "text.subtle.success": "_syaz17fi"
};
// NOTE: This is isolated to avoid breaking the bounded `stylesOld` interface as they do not fall within the Design System.
var $f8ae34a0ba9d9ca1$var$stylesOldUnbounded = {
    text: "_1reo15vq _18m915vq _ect41gqc _1wyb1skh _zg8l4jg8 _k48pmoej _vwz47vkz _1bto1l2s _1p1dangw _o5721q9c",
    customLetterspacing: "_1dyz9vsi"
};
var $f8ae34a0ba9d9ca1$var$backgroundColorsOld = {
    bold: {
        default: "color.background.neutral.bold",
        inprogress: "color.background.information.bold",
        moved: "color.background.warning.bold",
        new: "color.background.discovery.bold",
        removed: "color.background.danger.bold",
        success: "color.background.success.bold"
    },
    subtle: {
        default: "color.background.neutral",
        inprogress: "color.background.information",
        moved: "color.background.warning",
        new: "color.background.discovery",
        removed: "color.background.danger",
        success: "color.background.success"
    }
};
/**
 * TODO: We should be using our bounded `cssMap` here, but most of
 * these styles from the visual refresh are not in the Design System.
 */ var $f8ae34a0ba9d9ca1$var$stylesNew = {
    container: "_2rko1l7b _1reo15vq _18m915vq _1e0c116y _vchhusvi _kqswpfqs _1kz6184x _bozg1b66 _y4ti1b66",
    containerSubtle: "_1cwg1n1a",
    text: "_1reo15vq _18m915vq _ect41gqc _1wyb1skh _zg8l4jg8 _k48pmoej _vwz47vkz _1bto1l2s _1p1dangw _o5721q9c",
    customLetterspacing: "_1dyz9vsi",
    "bg.bold.default": "_bfhk1fkg",
    "bg.bold.inprogress": "_bfhk1ymo",
    "bg.bold.moved": "_bfhkxmjf",
    "bg.bold.new": "_bfhkshej",
    "bg.bold.removed": "_bfhk1366",
    "bg.bold.success": "_bfhk3uhp",
    "bg.subtle.default": "_bfhksm61",
    "bg.subtle.inprogress": "_bfhksm61",
    "bg.subtle.moved": "_bfhksm61",
    "bg.subtle.new": "_bfhksm61",
    "bg.subtle.removed": "_bfhksm61",
    "bg.subtle.success": "_bfhksm61",
    "border.subtle.default": "_19it14mp",
    "border.subtle.inprogress": "_19it1cy7",
    "border.subtle.moved": "_19itzi1n",
    "border.subtle.new": "_19it1apr",
    "border.subtle.removed": "_19itoa5t",
    "border.subtle.success": "_19it1am1",
    "outline.subtle.default": "_12ji14je _1qu2nqa1 _12y3t94y",
    "outline.subtle.inprogress": "_12jiuisw _1qu2nqa1 _12y3t94y",
    "outline.subtle.moved": "_12jih727 _1qu2nqa1 _12y3t94y",
    "outline.subtle.new": "_12ji157s _1qu2nqa1 _12y3t94y",
    "outline.subtle.removed": "_12jia2c0 _1qu2nqa1 _12y3t94y",
    "outline.subtle.success": "_12jin0nx _1qu2nqa1 _12y3t94y",
    "text.subtle": "_syaz1fxt",
    "text.bold": "_syazwwip"
};
var $f8ae34a0ba9d9ca1$var$appearanceTypes = [
    "default",
    "inprogress",
    "moved",
    "new",
    "removed",
    "success"
];
/**
 * __Lozenge__
 *
 * A lozenge is a visual indicator used to highlight an item's status for quick recognition.
 *
 * - [Examples](https://atlassian.design/components/lozenge/examples)
 * - [Code](https://atlassian.design/components/lozenge/code)
 * - [Usage](https://atlassian.design/components/lozenge/usage)
 */ var $f8ae34a0ba9d9ca1$var$Lozenge = /*#__PURE__*/ (0, $dAx5m.memo)(function(_ref) {
    var children = _ref.children, testId = _ref.testId, _ref$isBold = _ref.isBold, isBold = _ref$isBold === void 0 ? false : _ref$isBold, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "default" : _ref$appearance, _ref$maxWidth = _ref.maxWidth, maxWidth = _ref$maxWidth === void 0 ? 200 : _ref$maxWidth, style = _ref.style;
    var appearanceStyle = isBold ? "bold" : "subtle";
    var appearanceType = (0, $dAx5m.useMemo)(function() {
        return $f8ae34a0ba9d9ca1$var$appearanceTypes.includes(appearance) ? appearance : "default";
    }, [
        appearance
    ]);
    var maxWidthValue = typeof maxWidth === "string" ? maxWidth : "".concat(maxWidth, "px");
    var maxWidthIsPc = typeof maxWidth === "string" && /%$/.test(maxWidth);
    if ((0, $18rB9.fg)("platform-component-visual-refresh")) return /*#__PURE__*/ $dAx5m.createElement("span", {
        style: {
            backgroundColor: style === null || style === void 0 ? void 0 : style.backgroundColor,
            maxWidth: maxWidthIsPc ? maxWidth : "100%"
        },
        "data-testid": testId,
        className: (0, $1xVU6.default)([
            $f8ae34a0ba9d9ca1$var$stylesNew.container,
            $f8ae34a0ba9d9ca1$var$stylesNew["bg.".concat(appearanceStyle, ".").concat(appearanceType)],
            appearanceStyle === "subtle" && !(0, $18rB9.fg)("visual-refresh_drop_5") && $f8ae34a0ba9d9ca1$var$stylesNew["border.subtle.".concat(appearanceType)],
            appearanceStyle === "subtle" && (0, $18rB9.fg)("visual-refresh_drop_5") && $f8ae34a0ba9d9ca1$var$stylesNew["outline.subtle.".concat(appearanceType)],
            appearanceStyle === "subtle" && (0, $18rB9.fg)("visual-refresh_drop_5") && $f8ae34a0ba9d9ca1$var$stylesNew.containerSubtle
        ])
    }, /*#__PURE__*/ $dAx5m.createElement("span", {
        style: {
            color: style === null || style === void 0 ? void 0 : style.color,
            // to negate paddingInline specified on Box above
            maxWidth: maxWidthIsPc ? "100%" : "calc(".concat(maxWidthValue, " - ", "var(--ds-space-100, 8px)", ")")
        },
        "data-testid": testId && "".concat(testId, "--text"),
        className: (0, $1xVU6.default)([
            $f8ae34a0ba9d9ca1$var$stylesNew.text,
            (0, $18rB9.fg)("platform-lozenge-custom-letterspacing") && $f8ae34a0ba9d9ca1$var$stylesNew.customLetterspacing,
            $f8ae34a0ba9d9ca1$var$stylesNew["text.".concat(appearanceStyle)]
        ])
    }, children));
    return /*#__PURE__*/ $dAx5m.createElement((0, $jiOFg.default), {
        as: "span",
        backgroundColor: $f8ae34a0ba9d9ca1$var$backgroundColorsOld[appearanceStyle][appearanceType],
        style: {
            backgroundColor: style === null || style === void 0 ? void 0 : style.backgroundColor,
            maxWidth: maxWidthIsPc ? maxWidth : "100%"
        },
        paddingInline: "space.050",
        xcss: $f8ae34a0ba9d9ca1$var$stylesOld.container,
        testId: testId
    }, /*#__PURE__*/ $dAx5m.createElement("span", {
        style: {
            color: style === null || style === void 0 ? void 0 : style.color,
            // to negate paddingInline specified on Box above
            maxWidth: maxWidthIsPc ? "100%" : "calc(".concat(maxWidthValue, " - ", "var(--ds-space-100, 8px)", ")")
        },
        "data-testid": testId && "".concat(testId, "--text"),
        className: (0, $1xVU6.default)([
            $f8ae34a0ba9d9ca1$var$stylesOldUnbounded.text,
            (0, $18rB9.fg)("platform-lozenge-custom-letterspacing") && $f8ae34a0ba9d9ca1$var$stylesOldUnbounded.customLetterspacing,
            $f8ae34a0ba9d9ca1$var$stylesOld["text.".concat(appearanceStyle, ".").concat(appearanceType)]
        ])
    }, children));
});
$f8ae34a0ba9d9ca1$var$Lozenge.displayName = "Lozenge";
var $f8ae34a0ba9d9ca1$export$2e2bcd8739ae039 = $f8ae34a0ba9d9ca1$var$Lozenge;

});
parcelRegister("1xVU6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1205ca02efed0ea5$export$2e2bcd8739ae039; });
const $1205ca02efed0ea5$var$UNDERSCORE_UNICODE = 95;
/**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $1205ca02efed0ea5$var$ATOMIC_GROUP_LENGTH = 5;
function $1205ca02efed0ea5$export$2e2bcd8739ae039(classNames) {
    if (classNames.length <= 1 && (!classNames[0] || classNames[0].indexOf(" ") === -1)) // short circuit if there's no custom class names.
    return classNames[0] || undefined;
    const atomicGroups = {};
    for(let i = 0; i < classNames.length; i++){
        const cls = classNames[i];
        if (!cls) continue;
        const groups = cls.split(" ");
        for(let x = 0; x < groups.length; x++){
            const atomic = groups[x];
            const atomicGroupName = atomic.slice(0, atomic.charCodeAt(0) === $1205ca02efed0ea5$var$UNDERSCORE_UNICODE ? $1205ca02efed0ea5$var$ATOMIC_GROUP_LENGTH : undefined);
            atomicGroups[atomicGroupName] = atomic;
        }
    }
    let str = "";
    for(const key in atomicGroups){
        const value = atomicGroups[key];
        str += value + " ";
    }
    return str.slice(0, -1);
}

});

parcelRegister("jiOFg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e0d6ffae88f45c37$export$2e2bcd8739ae039; });
/* box.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $lDu5G = parcelRequire("lDu5G");

var $ikhrG = parcelRequire("ikhrG");

var $dAx5m = parcelRequire("dAx5m");

var $iBCmT = parcelRequire("iBCmT");

var $8NxUT = parcelRequire("8NxUT");
var $e0d6ffae88f45c37$var$_excluded = [
    "as",
    "children",
    "backgroundColor",
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    "style",
    "testId",
    "xcss"
], $e0d6ffae88f45c37$var$_excluded2 = [
    "className"
];
// Can either Exclude or Extract - here we're excluding all SVG-related elements, <button> elements (handled by Pressable), and <a> elements (handled by Anchor)
// Basically just ElementType but without ComponentType, it makes sense to keep the "Type" suffix
// eslint-disable-next-line @repo/internal/react/consistent-types-definitions
var $e0d6ffae88f45c37$var$baseStyles = null;
var $e0d6ffae88f45c37$var$backgroundColorMap = {
    "color.background.accent.lime.subtlest": "_bfhkm890",
    "color.background.accent.lime.subtlest.hovered": "_bfhkd4y8",
    "color.background.accent.lime.subtlest.pressed": "_bfhk1fno",
    "color.background.accent.lime.subtler": "_bfhkz2ec",
    "color.background.accent.lime.subtler.hovered": "_bfhk1eds",
    "color.background.accent.lime.subtler.pressed": "_bfhk1hgz",
    "color.background.accent.lime.subtle": "_bfhkbq5w",
    "color.background.accent.lime.subtle.hovered": "_bfhkfoww",
    "color.background.accent.lime.subtle.pressed": "_bfhkhgj8",
    "color.background.accent.lime.bolder": "_bfhktde4",
    "color.background.accent.lime.bolder.hovered": "_bfhknzpa",
    "color.background.accent.lime.bolder.pressed": "_bfhk1b17",
    "color.background.accent.red.subtlest": "_bfhk1vk5",
    "color.background.accent.red.subtlest.hovered": "_bfhk1i6i",
    "color.background.accent.red.subtlest.pressed": "_bfhk1pbw",
    "color.background.accent.red.subtler": "_bfhk1rtt",
    "color.background.accent.red.subtler.hovered": "_bfhkrw5d",
    "color.background.accent.red.subtler.pressed": "_bfhk69rw",
    "color.background.accent.red.subtle": "_bfhkkrt9",
    "color.background.accent.red.subtle.hovered": "_bfhk1sou",
    "color.background.accent.red.subtle.pressed": "_bfhk1tf4",
    "color.background.accent.red.bolder": "_bfhkuibq",
    "color.background.accent.red.bolder.hovered": "_bfhk100f",
    "color.background.accent.red.bolder.pressed": "_bfhkprmn",
    "color.background.accent.orange.subtlest": "_bfhk1g3m",
    "color.background.accent.orange.subtlest.hovered": "_bfhkg4tm",
    "color.background.accent.orange.subtlest.pressed": "_bfhk1ya0",
    "color.background.accent.orange.subtler": "_bfhkf2vu",
    "color.background.accent.orange.subtler.hovered": "_bfhk1lml",
    "color.background.accent.orange.subtler.pressed": "_bfhkuxsx",
    "color.background.accent.orange.subtle": "_bfhk1g6e",
    "color.background.accent.orange.subtle.hovered": "_bfhk1oew",
    "color.background.accent.orange.subtle.pressed": "_bfhk1phk",
    "color.background.accent.orange.bolder": "_bfhkjgng",
    "color.background.accent.orange.bolder.hovered": "_bfhkhi52",
    "color.background.accent.orange.bolder.pressed": "_bfhkf767",
    "color.background.accent.yellow.subtlest": "_bfhk1ozg",
    "color.background.accent.yellow.subtlest.hovered": "_bfhk19g9",
    "color.background.accent.yellow.subtlest.pressed": "_bfhk31d1",
    "color.background.accent.yellow.subtler": "_bfhk3fv2",
    "color.background.accent.yellow.subtler.hovered": "_bfhklg04",
    "color.background.accent.yellow.subtler.pressed": "_bfhk1d44",
    "color.background.accent.yellow.subtle": "_bfhkry5t",
    "color.background.accent.yellow.subtle.hovered": "_bfhk17e6",
    "color.background.accent.yellow.subtle.pressed": "_bfhko0y5",
    "color.background.accent.yellow.bolder": "_bfhk1vop",
    "color.background.accent.yellow.bolder.hovered": "_bfhkkjqf",
    "color.background.accent.yellow.bolder.pressed": "_bfhk32kj",
    "color.background.accent.green.subtlest": "_bfhkn729",
    "color.background.accent.green.subtlest.hovered": "_bfhk3utz",
    "color.background.accent.green.subtlest.pressed": "_bfhkv5yf",
    "color.background.accent.green.subtler": "_bfhk1wnw",
    "color.background.accent.green.subtler.hovered": "_bfhkung8",
    "color.background.accent.green.subtler.pressed": "_bfhk1p19",
    "color.background.accent.green.subtle": "_bfhk1rsu",
    "color.background.accent.green.subtle.hovered": "_bfhk12e3",
    "color.background.accent.green.subtle.pressed": "_bfhk8h4p",
    "color.background.accent.green.bolder": "_bfhk1e5c",
    "color.background.accent.green.bolder.hovered": "_bfhka5yi",
    "color.background.accent.green.bolder.pressed": "_bfhk1azz",
    "color.background.accent.teal.subtlest": "_bfhk7xuz",
    "color.background.accent.teal.subtlest.hovered": "_bfhk108c",
    "color.background.accent.teal.subtlest.pressed": "_bfhk1j2h",
    "color.background.accent.teal.subtler": "_bfhk1a17",
    "color.background.accent.teal.subtler.hovered": "_bfhkg5py",
    "color.background.accent.teal.subtler.pressed": "_bfhkq7li",
    "color.background.accent.teal.subtle": "_bfhktdv8",
    "color.background.accent.teal.subtle.hovered": "_bfhkzh8h",
    "color.background.accent.teal.subtle.pressed": "_bfhk10ai",
    "color.background.accent.teal.bolder": "_bfhk2c8p",
    "color.background.accent.teal.bolder.hovered": "_bfhkl3ve",
    "color.background.accent.teal.bolder.pressed": "_bfhkse6l",
    "color.background.accent.blue.subtlest": "_bfhkavxe",
    "color.background.accent.blue.subtlest.hovered": "_bfhkay3p",
    "color.background.accent.blue.subtlest.pressed": "_bfhk1xmr",
    "color.background.accent.blue.subtler": "_bfhk4v9p",
    "color.background.accent.blue.subtler.hovered": "_bfhk16e6",
    "color.background.accent.blue.subtler.pressed": "_bfhk1uh7",
    "color.background.accent.blue.subtle": "_bfhk1j89",
    "color.background.accent.blue.subtle.hovered": "_bfhk1f4s",
    "color.background.accent.blue.subtle.pressed": "_bfhkqctv",
    "color.background.accent.blue.bolder": "_bfhkc8cv",
    "color.background.accent.blue.bolder.hovered": "_bfhk1cwi",
    "color.background.accent.blue.bolder.pressed": "_bfhkhcrq",
    "color.background.accent.purple.subtlest": "_bfhkp7j4",
    "color.background.accent.purple.subtlest.hovered": "_bfhkm0d5",
    "color.background.accent.purple.subtlest.pressed": "_bfhkgslw",
    "color.background.accent.purple.subtler": "_bfhk1jkz",
    "color.background.accent.purple.subtler.hovered": "_bfhk1wyu",
    "color.background.accent.purple.subtler.pressed": "_bfhk5fkp",
    "color.background.accent.purple.subtle": "_bfhkdh45",
    "color.background.accent.purple.subtle.hovered": "_bfhk1wob",
    "color.background.accent.purple.subtle.pressed": "_bfhkwz05",
    "color.background.accent.purple.bolder": "_bfhkygwo",
    "color.background.accent.purple.bolder.hovered": "_bfhkadgs",
    "color.background.accent.purple.bolder.pressed": "_bfhk1uro",
    "color.background.accent.magenta.subtlest": "_bfhk8tvm",
    "color.background.accent.magenta.subtlest.hovered": "_bfhkr3zd",
    "color.background.accent.magenta.subtlest.pressed": "_bfhk1een",
    "color.background.accent.magenta.subtler": "_bfhkv9ra",
    "color.background.accent.magenta.subtler.hovered": "_bfhk1r0p",
    "color.background.accent.magenta.subtler.pressed": "_bfhkxuzc",
    "color.background.accent.magenta.subtle": "_bfhk1mi6",
    "color.background.accent.magenta.subtle.hovered": "_bfhkrwyz",
    "color.background.accent.magenta.subtle.pressed": "_bfhk1ovh",
    "color.background.accent.magenta.bolder": "_bfhkc3uk",
    "color.background.accent.magenta.bolder.hovered": "_bfhk1ok8",
    "color.background.accent.magenta.bolder.pressed": "_bfhkwaw3",
    "color.background.accent.gray.subtlest": "_bfhk11bn",
    "color.background.accent.gray.subtlest.hovered": "_bfhk12j4",
    "color.background.accent.gray.subtlest.pressed": "_bfhk1lb4",
    "color.background.accent.gray.subtler": "_bfhk1v33",
    "color.background.accent.gray.subtler.hovered": "_bfhk1f7l",
    "color.background.accent.gray.subtler.pressed": "_bfhkd8a2",
    "color.background.accent.gray.subtle": "_bfhk1t05",
    "color.background.accent.gray.subtle.hovered": "_bfhk1a2l",
    "color.background.accent.gray.subtle.pressed": "_bfhk1z0s",
    "color.background.accent.gray.bolder": "_bfhk1t1b",
    "color.background.accent.gray.bolder.hovered": "_bfhke4nv",
    "color.background.accent.gray.bolder.pressed": "_bfhk82ra",
    "color.background.disabled": "_bfhksyzs",
    "color.background.input": "_bfhk1j9a",
    "color.background.input.hovered": "_bfhk1d5g",
    "color.background.input.pressed": "_bfhkr01l",
    "color.background.inverse.subtle": "_bfhk1vck",
    "color.background.inverse.subtle.hovered": "_bfhkmpja",
    "color.background.inverse.subtle.pressed": "_bfhk1gii",
    "color.background.neutral": "_bfhkm7j4",
    "color.background.neutral.hovered": "_bfhk15ej",
    "color.background.neutral.pressed": "_bfhkip91",
    "color.background.neutral.subtle": "_bfhksm61",
    "color.background.neutral.subtle.hovered": "_bfhk166n",
    "color.background.neutral.subtle.pressed": "_bfhk1dty",
    "color.background.neutral.bold": "_bfhkcdhy",
    "color.background.neutral.bold.hovered": "_bfhk1bsc",
    "color.background.neutral.bold.pressed": "_bfhk1b6k",
    "color.background.selected": "_bfhkfg4m",
    "color.background.selected.hovered": "_bfhki1yw",
    "color.background.selected.pressed": "_bfhk19ru",
    "color.background.selected.bold": "_bfhk1fvw",
    "color.background.selected.bold.hovered": "_bfhk18hz",
    "color.background.selected.bold.pressed": "_bfhkgr1v",
    "color.background.brand.subtlest": "_bfhk3wxy",
    "color.background.brand.subtlest.hovered": "_bfhkezq1",
    "color.background.brand.subtlest.pressed": "_bfhk2ggb",
    "color.background.brand.bold": "_bfhkb29m",
    "color.background.brand.bold.hovered": "_bfhku1se",
    "color.background.brand.bold.pressed": "_bfhkqkzo",
    "color.background.brand.boldest": "_bfhk15mt",
    "color.background.brand.boldest.hovered": "_bfhk1uwk",
    "color.background.brand.boldest.pressed": "_bfhk17jr",
    "color.background.danger": "_bfhk1gly",
    "color.background.danger.hovered": "_bfhk1yvi",
    "color.background.danger.pressed": "_bfhk1io2",
    "color.background.danger.bold": "_bfhkybec",
    "color.background.danger.bold.hovered": "_bfhks9hg",
    "color.background.danger.bold.pressed": "_bfhk9pqq",
    "color.background.warning": "_bfhk1tzq",
    "color.background.warning.hovered": "_bfhk1rd4",
    "color.background.warning.pressed": "_bfhk11dh",
    "color.background.warning.bold": "_bfhk190i",
    "color.background.warning.bold.hovered": "_bfhk1i4c",
    "color.background.warning.bold.pressed": "_bfhkrj9s",
    "color.background.success": "_bfhkmv6i",
    "color.background.success.hovered": "_bfhk1jgi",
    "color.background.success.pressed": "_bfhky4f1",
    "color.background.success.bold": "_bfhk8emd",
    "color.background.success.bold.hovered": "_bfhk1q4l",
    "color.background.success.bold.pressed": "_bfhkcrcn",
    "color.background.discovery": "_bfhk1nvp",
    "color.background.discovery.hovered": "_bfhk1xp7",
    "color.background.discovery.pressed": "_bfhkdlkp",
    "color.background.discovery.bold": "_bfhk1lri",
    "color.background.discovery.bold.hovered": "_bfhk1w72",
    "color.background.discovery.bold.pressed": "_bfhkrb53",
    "color.background.information": "_bfhk33gi",
    "color.background.information.hovered": "_bfhk1vps",
    "color.background.information.pressed": "_bfhk1s0z",
    "color.background.information.bold": "_bfhk14wj",
    "color.background.information.bold.hovered": "_bfhk1amz",
    "color.background.information.bold.pressed": "_bfhk5bth",
    "color.blanket": "_bfhk10xm",
    "color.blanket.selected": "_bfhk7wq0",
    "color.blanket.danger": "_bfhkrprw",
    "color.skeleton": "_bfhkn82g",
    "color.skeleton.subtle": "_bfhkh3tw",
    "elevation.surface": "_bfhkvuon",
    "elevation.surface.hovered": "_bfhk108i",
    "elevation.surface.pressed": "_bfhk1ji5",
    "elevation.surface.overlay": "_bfhk1bhr",
    "elevation.surface.overlay.hovered": "_bfhk16qz",
    "elevation.surface.overlay.pressed": "_bfhkvq0a",
    "elevation.surface.raised": "_bfhkhp5a",
    "elevation.surface.raised.hovered": "_bfhk1a0f",
    "elevation.surface.raised.pressed": "_bfhkf7u5",
    "elevation.surface.sunken": "_bfhkqbzx",
    "utility.elevation.surface.current": "_bfhkchd4"
};
var $e0d6ffae88f45c37$var$CURRENT_SURFACE_CSS_VAR = "--ds-elevation-surface-current";
var $e0d6ffae88f45c37$var$setSurfaceTokenMap = {
    "elevation.surface": "_1q1lvuon",
    "elevation.surface.hovered": "_1q1l108i",
    "elevation.surface.pressed": "_1q1l1ji5",
    "elevation.surface.overlay": "_1q1l1bhr",
    "elevation.surface.overlay.hovered": "_1q1l16qz",
    "elevation.surface.overlay.pressed": "_1q1lvq0a",
    "elevation.surface.raised": "_1q1lhp5a",
    "elevation.surface.raised.hovered": "_1q1l1a0f",
    "elevation.surface.raised.pressed": "_1q1lf7u5",
    "elevation.surface.sunken": "_1q1lqbzx"
};
var $e0d6ffae88f45c37$var$paddingBlockStartMap = {
    "space.0": "_1q51ze3t",
    "space.025": "_1q51v77o",
    "space.050": "_1q511b66",
    "space.075": "_1q5112x7",
    "space.100": "_1q51u2gc",
    "space.150": "_1q51utpp",
    "space.200": "_1q51pxbi",
    "space.250": "_1q51v47k",
    "space.300": "_1q511ejb",
    "space.400": "_1q51xy5q",
    "space.500": "_1q511jfw",
    "space.600": "_1q51oahv",
    "space.800": "_1q51xncg",
    "space.1000": "_1q511epz"
};
var $e0d6ffae88f45c37$var$paddingBlockEndMap = {
    "space.0": "_85i5ze3t",
    "space.025": "_85i5v77o",
    "space.050": "_85i51b66",
    "space.075": "_85i512x7",
    "space.100": "_85i5u2gc",
    "space.150": "_85i5utpp",
    "space.200": "_85i5pxbi",
    "space.250": "_85i5v47k",
    "space.300": "_85i51ejb",
    "space.400": "_85i5xy5q",
    "space.500": "_85i51jfw",
    "space.600": "_85i5oahv",
    "space.800": "_85i5xncg",
    "space.1000": "_85i51epz"
};
var $e0d6ffae88f45c37$var$paddingInlineStartMap = {
    "space.0": "_bozgze3t",
    "space.025": "_bozgv77o",
    "space.050": "_bozg1b66",
    "space.075": "_bozg12x7",
    "space.100": "_bozgu2gc",
    "space.150": "_bozgutpp",
    "space.200": "_bozgpxbi",
    "space.250": "_bozgv47k",
    "space.300": "_bozg1ejb",
    "space.400": "_bozgxy5q",
    "space.500": "_bozg1jfw",
    "space.600": "_bozgoahv",
    "space.800": "_bozgxncg",
    "space.1000": "_bozg1epz"
};
var $e0d6ffae88f45c37$var$paddingInlineEndMap = {
    "space.0": "_y4tize3t",
    "space.025": "_y4tiv77o",
    "space.050": "_y4ti1b66",
    "space.075": "_y4ti12x7",
    "space.100": "_y4tiu2gc",
    "space.150": "_y4tiutpp",
    "space.200": "_y4tipxbi",
    "space.250": "_y4tiv47k",
    "space.300": "_y4ti1ejb",
    "space.400": "_y4tixy5q",
    "space.500": "_y4ti1jfw",
    "space.600": "_y4tioahv",
    "space.800": "_y4tixncg",
    "space.1000": "_y4ti1epz"
};
/**
 * __Box__
 *
 * A Box is a primitive component that has the design decisions of the Atlassian Design System baked in.
 * Renders a `div` by default.
 *
 * - [Examples](https://atlassian.design/components/primitives/box/examples)
 * - [Code](https://atlassian.design/components/primitives/box/code)
 * - [Usage](https://atlassian.design/components/primitives/box/usage)
 */ var $e0d6ffae88f45c37$var$Box = /*#__PURE__*/ (0, $dAx5m.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? "div" : _ref$as, children = _ref.children, backgroundColor = _ref.backgroundColor, padding = _ref.padding, _ref$paddingBlock = _ref.paddingBlock, paddingBlock = _ref$paddingBlock === void 0 ? padding : _ref$paddingBlock, _ref$paddingBlockStar = _ref.paddingBlockStart, paddingBlockStart = _ref$paddingBlockStar === void 0 ? paddingBlock : _ref$paddingBlockStar, _ref$paddingBlockEnd = _ref.paddingBlockEnd, paddingBlockEnd = _ref$paddingBlockEnd === void 0 ? paddingBlock : _ref$paddingBlockEnd, _ref$paddingInline = _ref.paddingInline, paddingInline = _ref$paddingInline === void 0 ? padding : _ref$paddingInline, _ref$paddingInlineSta = _ref.paddingInlineStart, paddingInlineStart = _ref$paddingInlineSta === void 0 ? paddingInline : _ref$paddingInlineSta, _ref$paddingInlineEnd = _ref.paddingInlineEnd, paddingInlineEnd = _ref$paddingInlineEnd === void 0 ? paddingInline : _ref$paddingInlineEnd, style = _ref.style, testId = _ref.testId, xcss = _ref.xcss, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($ikhrG)))(_ref, $e0d6ffae88f45c37$var$_excluded);
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error -- className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($ikhrG)))(htmlAttributes, $e0d6ffae88f45c37$var$_excluded2);
    var node = /*#__PURE__*/ $dAx5m.createElement(Component, (0, (/*@__PURE__*/$parcel$interopDefault($lDu5G)))({
        style: style,
        ref: ref,
        className: (0, $iBCmT.default)([
            "_19itglyw _vchhusvi _r06hglyw",
            backgroundColor && $e0d6ffae88f45c37$var$backgroundColorMap[backgroundColor],
            backgroundColor && $e0d6ffae88f45c37$var$isSurfaceToken(backgroundColor) && $e0d6ffae88f45c37$var$setSurfaceTokenMap[backgroundColor],
            paddingBlockStart && $e0d6ffae88f45c37$var$paddingBlockStartMap[paddingBlockStart],
            paddingBlockEnd && $e0d6ffae88f45c37$var$paddingBlockEndMap[paddingBlockEnd],
            paddingInlineStart && $e0d6ffae88f45c37$var$paddingInlineStartMap[paddingInlineStart],
            paddingInlineEnd && $e0d6ffae88f45c37$var$paddingInlineEndMap[paddingInlineEnd],
            xcss
        ])
    }, safeHtmlAttributes, {
        "data-testid": testId
    }), children);
    if (backgroundColor) return /*#__PURE__*/ $dAx5m.createElement((0, $8NxUT.SurfaceContext).Provider, {
        value: backgroundColor
    }, node);
    return node;
});
var $e0d6ffae88f45c37$export$2e2bcd8739ae039 = $e0d6ffae88f45c37$var$Box;
function $e0d6ffae88f45c37$var$isSurfaceToken(backgroundColor) {
    return backgroundColor in $e0d6ffae88f45c37$var$setSurfaceTokenMap;
}

});
parcelRegister("iBCmT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d8b971d1d2a81495$export$2e2bcd8739ae039; });
const $d8b971d1d2a81495$var$UNDERSCORE_UNICODE = 95;
/**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $d8b971d1d2a81495$var$ATOMIC_GROUP_LENGTH = 5;
function $d8b971d1d2a81495$export$2e2bcd8739ae039(classNames) {
    if (classNames.length <= 1 && (!classNames[0] || classNames[0].indexOf(" ") === -1)) // short circuit if there's no custom class names.
    return classNames[0] || undefined;
    const atomicGroups = {};
    for(let i = 0; i < classNames.length; i++){
        const cls = classNames[i];
        if (!cls) continue;
        const groups = cls.split(" ");
        for(let x = 0; x < groups.length; x++){
            const atomic = groups[x];
            const atomicGroupName = atomic.slice(0, atomic.charCodeAt(0) === $d8b971d1d2a81495$var$UNDERSCORE_UNICODE ? $d8b971d1d2a81495$var$ATOMIC_GROUP_LENGTH : undefined);
            atomicGroups[atomicGroupName] = atomic;
        }
    }
    let str = "";
    for(const key in atomicGroups){
        const value = atomicGroups[key];
        str += value + " ";
    }
    return str.slice(0, -1);
}

});



parcelRegister("7a44Y", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $536ca19c1f806ba0$export$2e2bcd8739ae039; });
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $dAx5m = parcelRequire("dAx5m");

var $jVTBW = parcelRequire("jVTBW");

var $18rB9 = parcelRequire("18rB9");

var $12GLU = parcelRequire("12GLU");
var $fDIOj = parcelRequire("fDIOj");
var $536ca19c1f806ba0$var$baseStylesOld = (0, $fDIOj.xcss)({
    display: "inline-flex",
    borderRadius: "border.radius",
    blockSize: "min-content",
    position: "static",
    overflow: "hidden"
});
var $536ca19c1f806ba0$var$styles = {
    container: (0, $jVTBW.css)({
        display: "inline-flex",
        boxSizing: "border-box",
        position: "static",
        blockSize: "min-content",
        borderRadius: "3px",
        overflow: "hidden",
        paddingInline: "var(--ds-space-050, 4px)"
    }),
    containerSubtle: (0, $jVTBW.css)({
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
        outlineOffset: -1
    }),
    background: {
        bold: {
            default: (0, $jVTBW.css)({
                backgroundColor: "#DDDEE1"
            }),
            inprogress: (0, $jVTBW.css)({
                backgroundColor: "#8FB8F6"
            }),
            moved: (0, $jVTBW.css)({
                backgroundColor: "#F9C84E"
            }),
            new: (0, $jVTBW.css)({
                backgroundColor: "#D8A0F7"
            }),
            removed: (0, $jVTBW.css)({
                backgroundColor: "#FD9891"
            }),
            success: (0, $jVTBW.css)({
                backgroundColor: "#B3DF72"
            })
        },
        subtle: {
            default: (0, $jVTBW.css)({
                backgroundColor: "var(--ds-background-neutral-subtle, #00000000)"
            }),
            inprogress: (0, $jVTBW.css)({
                backgroundColor: "var(--ds-background-neutral-subtle, #00000000)"
            }),
            moved: (0, $jVTBW.css)({
                backgroundColor: "var(--ds-background-neutral-subtle, #00000000)"
            }),
            new: (0, $jVTBW.css)({
                backgroundColor: "var(--ds-background-neutral-subtle, #00000000)"
            }),
            removed: (0, $jVTBW.css)({
                backgroundColor: "var(--ds-background-neutral-subtle, #00000000)"
            }),
            success: (0, $jVTBW.css)({
                backgroundColor: "var(--ds-background-neutral-subtle, #00000000)"
            })
        }
    },
    border: {
        subtle: {
            default: (0, $jVTBW.css)({
                border: "1px solid #B7B9BE"
            }),
            inprogress: (0, $jVTBW.css)({
                border: "1px solid #669DF1"
            }),
            moved: (0, $jVTBW.css)({
                border: "1px solid #FCA700"
            }),
            new: (0, $jVTBW.css)({
                border: "1px solid #C97CF4"
            }),
            removed: (0, $jVTBW.css)({
                border: "1px solid #F87168"
            }),
            success: (0, $jVTBW.css)({
                border: "1px solid #94C748"
            })
        }
    },
    outline: {
        subtle: {
            default: (0, $jVTBW.css)({
                outline: "1px solid #B7B9BE"
            }),
            inprogress: (0, $jVTBW.css)({
                outline: "1px solid #669DF1"
            }),
            moved: (0, $jVTBW.css)({
                outline: "1px solid #FCA700"
            }),
            new: (0, $jVTBW.css)({
                outline: "1px solid #C97CF4"
            }),
            removed: (0, $jVTBW.css)({
                outline: "1px solid #F87168"
            }),
            success: (0, $jVTBW.css)({
                outline: "1px solid #94C748"
            })
        }
    },
    text: {
        subtle: (0, $jVTBW.css)({
            color: "var(--ds-text, #172B4D)"
        }),
        bold: (0, $jVTBW.css)({
            color: "#292A2E"
        })
    }
};
var $536ca19c1f806ba0$var$textStyles = (0, $jVTBW.css)({
    fontFamily: 'var(--ds-font-family-body, ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    fontSize: "11px",
    fontStyle: "normal",
    fontWeight: "var(--ds-font-weight-bold, 700)",
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: "16px",
    overflow: "hidden",
    textOverflow: "ellipsis",
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    textTransform: "uppercase",
    whiteSpace: "nowrap"
});
var $536ca19c1f806ba0$var$customLetterspacingStyles = (0, $jVTBW.css)({
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    letterSpacing: 0.165
});
/**
 * __Lozenge__
 *
 * A lozenge is a visual indicator used to highlight an item's status for quick recognition.
 *
 * - [Examples](https://atlassian.design/components/lozenge/examples)
 * - [Code](https://atlassian.design/components/lozenge/code)
 * - [Usage](https://atlassian.design/components/lozenge/usage)
 */ var $536ca19c1f806ba0$var$Lozenge = /*#__PURE__*/ (0, $dAx5m.memo)(function(_ref) {
    var children = _ref.children, testId = _ref.testId, _ref$isBold = _ref.isBold, isBold = _ref$isBold === void 0 ? false : _ref$isBold, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "default" : _ref$appearance, _ref$maxWidth = _ref.maxWidth, maxWidth = _ref$maxWidth === void 0 ? 200 : _ref$maxWidth, style = _ref.style;
    var appearanceStyle = isBold ? "bold" : "subtle";
    var appearanceType = appearance in $536ca19c1f806ba0$var$styles.background[appearanceStyle] ? appearance : "default";
    var maxWidthValue = typeof maxWidth === "string" ? maxWidth : "".concat(maxWidth, "px");
    var maxWidthIsPc = typeof maxWidth === "string" && /%$/.test(maxWidth);
    if ((0, $18rB9.fg)("platform-component-visual-refresh")) return (0, $jVTBW.jsx)("span", {
        style: {
            backgroundColor: style === null || style === void 0 ? void 0 : style.backgroundColor,
            maxWidth: maxWidthIsPc ? maxWidth : "100%"
        },
        css: [
            $536ca19c1f806ba0$var$styles.container,
            $536ca19c1f806ba0$var$styles.background[appearanceStyle][appearanceType],
            appearanceStyle === "subtle" && !(0, $18rB9.fg)("visual-refresh_drop_5") && $536ca19c1f806ba0$var$styles.border.subtle[appearanceType],
            appearanceStyle === "subtle" && (0, $18rB9.fg)("visual-refresh_drop_5") && $536ca19c1f806ba0$var$styles.outline.subtle[appearanceType],
            appearanceStyle === "subtle" && (0, $18rB9.fg)("visual-refresh_drop_5") && $536ca19c1f806ba0$var$styles.containerSubtle
        ],
        "data-testid": testId
    }, (0, $jVTBW.jsx)("span", {
        css: [
            $536ca19c1f806ba0$var$textStyles,
            (0, $18rB9.fg)("platform-lozenge-custom-letterspacing") && $536ca19c1f806ba0$var$customLetterspacingStyles,
            $536ca19c1f806ba0$var$styles.text[appearanceStyle]
        ],
        style: {
            color: style === null || style === void 0 ? void 0 : style.color,
            // to negate paddingInline specified on Box above
            maxWidth: maxWidthIsPc ? "100%" : "calc(".concat(maxWidthValue, " - ", "var(--ds-space-100, 8px)", ")")
        },
        "data-testid": testId && "".concat(testId, "--text")
    }, children));
    var appearanceTypeOld = appearance in $536ca19c1f806ba0$var$backgroundColorsOld[appearanceStyle] ? appearance : "default";
    return (0, $jVTBW.jsx)((0, $12GLU.default), {
        as: "span",
        backgroundColor: $536ca19c1f806ba0$var$backgroundColorsOld[appearanceStyle][appearanceTypeOld],
        style: {
            backgroundColor: style === null || style === void 0 ? void 0 : style.backgroundColor,
            maxWidth: maxWidthIsPc ? maxWidth : "100%"
        },
        paddingInline: "space.050",
        xcss: $536ca19c1f806ba0$var$baseStylesOld,
        testId: testId
    }, (0, $jVTBW.jsx)("span", {
        css: [
            $536ca19c1f806ba0$var$textStyles,
            (0, $18rB9.fg)("platform-lozenge-custom-letterspacing") && $536ca19c1f806ba0$var$customLetterspacingStyles,
            $536ca19c1f806ba0$var$textColorsOld[appearanceStyle][appearanceType]
        ],
        style: {
            color: style === null || style === void 0 ? void 0 : style.color,
            // to negate paddingInline specified on Box above
            maxWidth: maxWidthIsPc ? "100%" : "calc(".concat(maxWidthValue, " - ", "var(--ds-space-100, 8px)", ")")
        },
        "data-testid": testId && "".concat(testId, "--text")
    }, children));
});
$536ca19c1f806ba0$var$Lozenge.displayName = "Lozenge";
var $536ca19c1f806ba0$export$2e2bcd8739ae039 = $536ca19c1f806ba0$var$Lozenge;
var $536ca19c1f806ba0$var$backgroundColorsOld = {
    bold: {
        default: "color.background.neutral.bold",
        inprogress: "color.background.information.bold",
        moved: "color.background.warning.bold",
        new: "color.background.discovery.bold",
        removed: "color.background.danger.bold",
        success: "color.background.success.bold"
    },
    subtle: {
        default: "color.background.neutral",
        inprogress: "color.background.information",
        moved: "color.background.warning",
        new: "color.background.discovery",
        removed: "color.background.danger",
        success: "color.background.success"
    }
};
var $536ca19c1f806ba0$var$textColorsOld = {
    bold: {
        default: (0, $jVTBW.css)({
            color: "var(--ds-text-inverse, #FFFFFF)"
        }),
        inprogress: (0, $jVTBW.css)({
            color: "var(--ds-text-inverse, #FFFFFF)"
        }),
        moved: (0, $jVTBW.css)({
            color: "var(--ds-text-warning-inverse, #172B4D)"
        }),
        new: (0, $jVTBW.css)({
            color: "var(--ds-text-inverse, #FFFFFF)"
        }),
        removed: (0, $jVTBW.css)({
            color: "var(--ds-text-inverse, #FFFFFF)"
        }),
        success: (0, $jVTBW.css)({
            color: "var(--ds-text-inverse, #FFFFFF)"
        })
    },
    subtle: {
        default: (0, $jVTBW.css)({
            color: "var(--ds-text-subtle, #42526E)"
        }),
        inprogress: (0, $jVTBW.css)({
            color: "var(--ds-text-information, #0052CC)"
        }),
        moved: (0, $jVTBW.css)({
            color: "var(--ds-text-warning, #974F0C)"
        }),
        new: (0, $jVTBW.css)({
            color: "var(--ds-text-discovery, #403294)"
        }),
        removed: (0, $jVTBW.css)({
            color: "var(--ds-text-danger, #DE350B)"
        }),
        success: (0, $jVTBW.css)({
            color: "var(--ds-text-success, #006644)"
        })
    }
};

});


parcelRegister("d1Wgq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $97c8905cfdb92683$export$2e2bcd8739ae039; });

var $lKhJJ = parcelRequire("lKhJJ");
var $97c8905cfdb92683$var$messages = (0, $lKhJJ.defineMessages)({
    newLozenge: {
        id: "fabric.atlassianSwitcher.newLozenge",
        defaultMessage: "New",
        description: "The lozenge text for a lozenge indicating a new switcher item"
    },
    tryLozenge: {
        id: "fabric.atlassianSwitcher.tryLozenge",
        defaultMessage: "Try",
        description: "Alternative lozenge text for a lozenge indicating a new switcher item"
    },
    sites: {
        id: "fabric.atlassianSwitcher.sites",
        defaultMessage: "{productName} {numSites, plural, one {site} other {sites}}",
        description: "The text of a toggle showing or hiding more site options"
    },
    skeletonLoaderAriaLabel: {
        id: "fabric.atlassianSwitcher.skeletonLoaderAriaLabel",
        defaultMessage: "The App Switcher is loading",
        description: "The aria-label for the app switcher skeleton loader primative"
    }
});
var $97c8905cfdb92683$export$2e2bcd8739ae039 = $97c8905cfdb92683$var$messages;

});

parcelRegister("ix0ZR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d7dc14fa1f95363e$export$2e2bcd8739ae039; });

var $lDu5G = parcelRequire("lDu5G");

var $1m89o = parcelRequire("1m89o");

var $1xtOA = parcelRequire("1xtOA");

var $kVYWy = parcelRequire("kVYWy");

var $c2AoJ = parcelRequire("c2AoJ");

var $e3Gk1 = parcelRequire("e3Gk1");

var $4huf8 = parcelRequire("4huf8");

var $9HWAT = parcelRequire("9HWAT");

var $12GLU = parcelRequire("12GLU");
var $eDMLb = parcelRequire("eDMLb");
var $fDIOj = parcelRequire("fDIOj");

var $3xWrW = parcelRequire("3xWrW");

var $h1fPX = parcelRequire("h1fPX");
var $jezSP = parcelRequire("jezSP");

var $dAx5m = parcelRequire("dAx5m");

var $55TWT = parcelRequire("55TWT");
var $ja4jS = parcelRequire("ja4jS");

var $jVTBW = parcelRequire("jVTBW");

var $jAH5d = parcelRequire("jAH5d");

var $2cxIB = parcelRequire("2cxIB");

var $5QmqT = parcelRequire("5QmqT");
var $3FJlW = parcelRequire("3FJlW");
var $kyTiB = parcelRequire("kyTiB");

var $5qE33 = parcelRequire("5qE33");

var $eKOS7 = parcelRequire("eKOS7");

var $e73p3 = parcelRequire("e73p3");

var $jXZjr = parcelRequire("jXZjr");

var $jnTm7 = parcelRequire("jnTm7");

var $4nJ2c = parcelRequire("4nJ2c");
function $d7dc14fa1f95363e$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $d7dc14fa1f95363e$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $d7dc14fa1f95363e$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($9HWAT)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $d7dc14fa1f95363e$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $d7dc14fa1f95363e$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($e3Gk1)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($c2AoJ)))(t, $d7dc14fa1f95363e$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($e3Gk1)))(t).constructor) : o.apply(t, e));
}
function $d7dc14fa1f95363e$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($d7dc14fa1f95363e$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $d7dc14fa1f95363e$var$TRIGGER_SUBJECT = "errorBoundary";
var $d7dc14fa1f95363e$var$ACTION_SUBJECT = "rendered";
// This image is also used as the generic error message in Notifications
var $d7dc14fa1f95363e$var$robotsImgStyles = (0, $jVTBW.css)({
    height: 200
});
var $d7dc14fa1f95363e$var$trelloErrorImgStyles = (0, $jVTBW.css)({
    width: 140,
    height: 88
});
var $d7dc14fa1f95363e$var$unverifiedUserImageStyles = (0, $jVTBW.css)({
    height: 150
});
var $d7dc14fa1f95363e$var$errorContentStyles = (0, $jVTBW.css)({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column"
});
var $d7dc14fa1f95363e$var$errorHeadingStyles = (0, $fDIOj.xcss)({
    maxWidth: "240",
    marginTop: "space.400"
});
var $d7dc14fa1f95363e$var$errorMessageStyles = (0, $fDIOj.xcss)({
    maxWidth: "240",
    marginTop: "space.300"
});
var $d7dc14fa1f95363e$var$errorBoundaryBoxStyles = (0, $jVTBW.css)({
    display: "flex",
    justifyContent: "center",
    flexDirection: "column",
    textAlign: "center",
    margin: "var(--ds-space-600, 48px)".concat(" 0")
});
var $d7dc14fa1f95363e$var$loginButtonStyles = (0, $fDIOj.xcss)({
    marginTop: "space.300",
    justifyContent: "center",
    alignSelf: "stretch"
});
var $d7dc14fa1f95363e$var$ErrorMessage = function ErrorMessage(props) {
    return (0, $jVTBW.jsx)((0, $12GLU.default), {
        xcss: $d7dc14fa1f95363e$var$errorMessageStyles
    }, (0, $jVTBW.jsx)((0, $eDMLb.default), {
        as: "p"
    }, props.children));
};
var $d7dc14fa1f95363e$var$ErrorBoundary = /*#__PURE__*/ function(_React$Component) {
    function ErrorBoundary() {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($1xtOA)))(this, ErrorBoundary);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = $d7dc14fa1f95363e$var$_callSuper(this, ErrorBoundary, [].concat(args));
        (0, (/*@__PURE__*/$parcel$interopDefault($9HWAT)))(_this, "state", {
            hasError: false
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($9HWAT)))(_this, "fireOperationalEvent", function(payload) {
            if (_this.props.createAnalyticsEvent) _this.props.createAnalyticsEvent($d7dc14fa1f95363e$var$_objectSpread({
                eventType: (0, $3FJlW.OPERATIONAL_EVENT_TYPE),
                actionSubject: _this.props.triggerSubject || $d7dc14fa1f95363e$var$TRIGGER_SUBJECT
            }, payload)).fire((0, $5QmqT.NAVIGATION_CHANNEL));
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($9HWAT)))(_this, "handleLogin", function(_, analyticsEvent) {
            analyticsEvent.update({
                eventType: (0, $3FJlW.UI_EVENT_TYPE),
                actionSubjectId: "login"
            }).fire((0, $5QmqT.NAVIGATION_CHANNEL));
            if (_this.props.product !== (0, $jXZjr.Product).TRELLO) window.location.reload();
        });
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($4huf8)))(ErrorBoundary, _React$Component);
    return (0, (/*@__PURE__*/$parcel$interopDefault($kVYWy)))(ErrorBoundary, [
        {
            key: "componentDidCatch",
            value: function componentDidCatch(error) {
                var _this2 = this, _this$props$onErrorCa, _this$props;
                var reason = error instanceof (0, $jnTm7.SwitcherLoadError) ? error.reason() : (0, $eKOS7.errorToReason)(error);
                this.setState({
                    hasError: true,
                    reason: reason
                }, function() {
                    _this2.fireOperationalEvent({
                        action: $d7dc14fa1f95363e$var$ACTION_SUBJECT,
                        attributes: $d7dc14fa1f95363e$var$_objectSpread($d7dc14fa1f95363e$var$_objectSpread({}, reason), _this2.props.extraAnalyticProps)
                    });
                });
                (_this$props$onErrorCa = (_this$props = this.props).onErrorCallback) === null || _this$props$onErrorCa === void 0 || _this$props$onErrorCa.call(_this$props, error);
            }
        },
        {
            key: "renderErrorBody",
            value: function renderErrorBody() {
                var reason = this.state.reason;
                if (!reason) return;
                if (reason.name === (0, $4nJ2c.FETCH_ERROR_NAME)) {
                    var isTrello = this.props.product === (0, $jXZjr.Product).TRELLO;
                    if (reason.status === 401) // Not authorised http error
                    return (0, $jVTBW.jsx)((0, $dAx5m.Fragment), null, (0, $jVTBW.jsx)($d7dc14fa1f95363e$var$ErrorMessage, null, (0, $jVTBW.jsx)((0, $55TWT.default), (0, $e73p3.default).errorTextLoggedOut)), isTrello ? (0, $jVTBW.jsx)((0, $12GLU.default), {
                        xcss: $d7dc14fa1f95363e$var$loginButtonStyles
                    }, (0, $jVTBW.jsx)((0, $jezSP.default), {
                        href: (0, $5qE33.getLoginUrl)((0, $jXZjr.Product).TRELLO),
                        onClick: this.handleLogin
                    }, (0, $jVTBW.jsx)((0, $55TWT.default), (0, $e73p3.default).login))) : (0, $jVTBW.jsx)((0, $12GLU.default), {
                        xcss: $d7dc14fa1f95363e$var$loginButtonStyles
                    }, (0, $jVTBW.jsx)((0, $h1fPX.default), {
                        onClick: this.handleLogin
                    }, (0, $jVTBW.jsx)((0, $55TWT.default), (0, $e73p3.default).login))));
                    if (reason.status === 403) return (0, $jVTBW.jsx)($d7dc14fa1f95363e$var$ErrorMessage, null, (0, $jVTBW.jsx)((0, $55TWT.default), (0, $e73p3.default).errorTextUnverified));
                    return (0, $jVTBW.jsx)($d7dc14fa1f95363e$var$ErrorMessage, null, (0, $jVTBW.jsx)((0, $55TWT.default), (0, $e73p3.default).errorTextNetwork));
                }
                // Default error message
                return (0, $jVTBW.jsx)($d7dc14fa1f95363e$var$ErrorMessage, null, (0, $jVTBW.jsx)((0, $55TWT.default), (0, $e73p3.default).errorText));
            }
        },
        {
            key: "renderErrorHeading",
            value: function renderErrorHeading() {
                var reason = this.state.reason;
                if (!reason) return;
                if (reason.name === (0, $4nJ2c.FETCH_ERROR_NAME) && reason.status === 401) return (0, $jVTBW.jsx)((0, $55TWT.default), (0, $e73p3.default).errorHeadingLoggedOut);
                if (reason.name === (0, $4nJ2c.FETCH_ERROR_NAME) && reason.status === 403) return (0, $jVTBW.jsx)((0, $55TWT.default), (0, $e73p3.default).errorHeadingUnverified);
                return (0, $jVTBW.jsx)((0, $55TWT.default), (0, $e73p3.default).errorHeading);
            }
        },
        {
            key: "renderErrorImage",
            value: function renderErrorImage() {
                var _this$props2 = this.props, intl = _this$props2.intl, product = _this$props2.product;
                var reason = this.state.reason;
                if (product === (0, $jXZjr.Product).TRELLO) return (0, $jVTBW.jsx)("img", {
                    css: $d7dc14fa1f95363e$var$trelloErrorImgStyles,
                    src: (0, $jAH5d.default),
                    alt: intl.formatMessage((0, $e73p3.default).errorImageAltText)
                });
                if (reason.status === 403) return (0, $jVTBW.jsx)("img", {
                    css: $d7dc14fa1f95363e$var$unverifiedUserImageStyles,
                    src: (0, $2cxIB.default),
                    alt: intl.formatMessage((0, $e73p3.default).errorImageAltText)
                });
                return (0, $jVTBW.jsx)($d7dc14fa1f95363e$var$RobotImage, {
                    css: $d7dc14fa1f95363e$var$robotsImgStyles,
                    alt: intl.formatMessage((0, $e73p3.default).errorImageAltText)
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var hideFallbackUI = this.props.hideFallbackUI;
                var hasError = this.state.hasError;
                if (hasError && hideFallbackUI) return (0, $jVTBW.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).Fragment, null);
                if (hasError) return (0, $jVTBW.jsx)("div", {
                    css: $d7dc14fa1f95363e$var$errorBoundaryBoxStyles,
                    "data-testid": "error-boundary"
                }, (0, $jVTBW.jsx)("div", {
                    css: $d7dc14fa1f95363e$var$errorContentStyles
                }, this.renderErrorImage(), (0, $jVTBW.jsx)((0, $12GLU.default), {
                    xcss: $d7dc14fa1f95363e$var$errorHeadingStyles
                }, (0, $jVTBW.jsx)((0, $3xWrW.default), {
                    size: "medium"
                }, this.renderErrorHeading())), this.renderErrorBody()));
                return this.props.children;
            }
        }
    ]);
}((0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).Component);

var $d7dc14fa1f95363e$var$RobotImage = function RobotImage(props) {
    var _useState = (0, $dAx5m.useState)(), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($1m89o)))(_useState, 2), imgSrc = _useState2[0], setImgSrc = _useState2[1];
    (0, $dAx5m.useEffect)(function() {
        (parcelRequire("52cMQ")).then(function(src) {
            return setImgSrc(src.default);
        });
    }, []);
    // eslint-disable-next-line jsx-a11y/alt-text
    return (0, $jVTBW.jsx)("img", (0, (/*@__PURE__*/$parcel$interopDefault($lDu5G)))({}, props, {
        src: imgSrc
    }));
};
var $d7dc14fa1f95363e$export$2e2bcd8739ae039 = (0, $kyTiB.default)()((0, $ja4jS.default)($d7dc14fa1f95363e$var$ErrorBoundary));

});
parcelRegister("eDMLb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $aa8a87f00cdaf462$export$2e2bcd8739ae039; });
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $dAx5m = parcelRequire("dAx5m");

var $jVTBW = parcelRequire("jVTBW");

var $3P18c = parcelRequire("3P18c");

var $krqDm = parcelRequire("krqDm");

var $8NxUT = parcelRequire("8NxUT");

var $dG34F = parcelRequire("dG34F");
var $aa8a87f00cdaf462$var$asAllowlist = [
    "span",
    "p",
    "strong",
    "em"
];
// We're doing this because our CSS reset can add top margins to elements such as `p` which is totally insane.
// Long term we should remove those instances from the reset - it should be a reset to 0.
// For now, at least we know <Text> will be unaffected by this.
var $aa8a87f00cdaf462$var$resetStyles = (0, $jVTBW.css)({
    margin: 0,
    overflowWrap: "anywhere"
});
var $aa8a87f00cdaf462$var$strongStyles = (0, $jVTBW.css)({
    fontWeight: "var(--ds-font-weight-bold, 700)"
});
var $aa8a87f00cdaf462$var$emStyles = (0, $jVTBW.css)({
    fontStyle: "italic"
});
var $aa8a87f00cdaf462$var$textAlignMap = {
    center: (0, $jVTBW.css)({
        textAlign: "center"
    }),
    end: (0, $jVTBW.css)({
        textAlign: "end"
    }),
    start: (0, $jVTBW.css)({
        textAlign: "start"
    })
};
var $aa8a87f00cdaf462$var$truncationStyles = (0, $jVTBW.css)({
    display: "-webkit-box",
    overflow: "hidden",
    WebkitBoxOrient: "vertical"
});
var $aa8a87f00cdaf462$var$wordBreakMap = {
    breakAll: (0, $jVTBW.css)({
        wordBreak: "break-all"
    })
};
/**
 * Custom hook designed to abstract the parsing of the color props and make it clearer in the future how color is reconciled between themes and tokens.
 */ var $aa8a87f00cdaf462$var$useColor = function useColor(colorProp, hasTextAncestor) {
    var surface = (0, $8NxUT.useSurface)();
    if (colorProp === "inherit") return undefined;
    if (colorProp) return colorProp;
    if (hasTextAncestor) return undefined;
    if ((0, $dG34F.inverseColorMap).hasOwnProperty(surface)) return (0, $dG34F.inverseColorMap)[surface];
    return "color.text";
};
/**
 * __Text__
 *
 * Text is a primitive component that has the Atlassian Design System's design guidelines baked in.
 * This includes considerations for text attributes such as color, font size, font weight, and line height.
 * It renders a `span` by default.
 *
 * @internal
 */ var $aa8a87f00cdaf462$var$Text = /*#__PURE__*/ (0, $dAx5m.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? "span" : _ref$as, colorProp = _ref.color, align = _ref.align, testId = _ref.testId, id = _ref.id, size = _ref.size, weight = _ref.weight, maxLines = _ref.maxLines, children = _ref.children;
    (0, $3P18c.default)($aa8a87f00cdaf462$var$asAllowlist.includes(Component), '@atlaskit/primitives: Text received an invalid "as" value of "'.concat(Component, '"'));
    var hasTextAncestor = (0, $krqDm.useHasTextAncestor)();
    var color = $aa8a87f00cdaf462$var$useColor(colorProp, hasTextAncestor);
    if (!size && !hasTextAncestor) size = "medium";
    var component = (0, $jVTBW.jsx)(Component, {
        ref: ref,
        css: [
            $aa8a87f00cdaf462$var$resetStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            size && (0, $dG34F.textSizeStylesMap)[size],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            color && (0, $dG34F.textColorStylesMap)[color],
            maxLines && $aa8a87f00cdaf462$var$truncationStyles,
            maxLines === 1 && $aa8a87f00cdaf462$var$wordBreakMap.breakAll,
            align && $aa8a87f00cdaf462$var$textAlignMap[align],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            weight && (0, $dG34F.textWeightStylesMap)[weight],
            Component === "em" && $aa8a87f00cdaf462$var$emStyles,
            Component === "strong" && $aa8a87f00cdaf462$var$strongStyles
        ],
        style: {
            WebkitLineClamp: maxLines
        },
        "data-testid": testId,
        id: id
    }, children);
    return hasTextAncestor ? // no need to re-apply context if the text is already wrapped
    component : (0, $jVTBW.jsx)((0, $krqDm.HasTextAncestorProvider), {
        value: true
    }, component);
});
var $aa8a87f00cdaf462$export$2e2bcd8739ae039 = $aa8a87f00cdaf462$var$Text;

});
parcelRegister("krqDm", function(module, exports) {

$parcel$export(module.exports, "useHasTextAncestor", function () { return $ee1afd30329e87c5$export$9322276ec105d055; });
$parcel$export(module.exports, "HasTextAncestorProvider", function () { return $ee1afd30329e87c5$export$ae933c6cbe5643ad; });

var $dAx5m = parcelRequire("dAx5m");
var $ee1afd30329e87c5$var$HasTextAncestorContext = /*#__PURE__*/ (0, $dAx5m.createContext)(false);
var $ee1afd30329e87c5$export$9322276ec105d055 = function useHasTextAncestor() {
    return (0, $dAx5m.useContext)($ee1afd30329e87c5$var$HasTextAncestorContext);
};
var $ee1afd30329e87c5$export$ae933c6cbe5643ad = $ee1afd30329e87c5$var$HasTextAncestorContext.Provider;

});


parcelRegister("h1fPX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c63ed0910f6cab3b$export$2e2bcd8739ae039; });

var $lDu5G = parcelRequire("lDu5G");

var $ikhrG = parcelRequire("ikhrG");

var $dAx5m = parcelRequire("dAx5m");

var $5mHml = parcelRequire("5mHml");

var $faTCN = parcelRequire("faTCN");

var $2MQ4R = parcelRequire("2MQ4R");
var $c63ed0910f6cab3b$var$_excluded = [
    "analyticsContext",
    "appearance",
    "aria-label",
    "aria-labelledby",
    "autoFocus",
    "children",
    "iconAfter",
    "iconBefore",
    "interactionName",
    "isDisabled",
    "isLoading",
    "isSelected",
    "onClick",
    "onClickCapture",
    "onKeyDownCapture",
    "onKeyUpCapture",
    "onMouseDownCapture",
    "onMouseUpCapture",
    "onPointerDownCapture",
    "onPointerUpCapture",
    "onTouchEndCapture",
    "onTouchStartCapture",
    "shouldFitContainer",
    "spacing",
    "testId",
    "type"
], $c63ed0910f6cab3b$var$_excluded2 = [
    "className",
    "css",
    "as",
    "style"
];
/**
 * __Button__
 *
 * A button triggers an event or action.
 *
 * - [Examples](https://atlassian.design/components/button/examples)
 * - [Code](https://atlassian.design/components/button/code)
 * - [Usage](https://atlassian.design/components/button/usage)
 */ var $c63ed0910f6cab3b$var$Button = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).forwardRef(function Button(_ref, ref) {
    var analyticsContext = _ref.analyticsContext, appearance = _ref.appearance, ariaLabel = _ref["aria-label"], ariaLabelledBy = _ref["aria-labelledby"], autoFocus = _ref.autoFocus, children = _ref.children, iconAfter = _ref.iconAfter, iconBefore = _ref.iconBefore, interactionName = _ref.interactionName, isDisabled = _ref.isDisabled, _ref$isLoading = _ref.isLoading, isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading, isSelected = _ref.isSelected, onClick = _ref.onClick, onClickCapture = _ref.onClickCapture, onKeyDownCapture = _ref.onKeyDownCapture, onKeyUpCapture = _ref.onKeyUpCapture, onMouseDownCapture = _ref.onMouseDownCapture, onMouseUpCapture = _ref.onMouseUpCapture, onPointerDownCapture = _ref.onPointerDownCapture, onPointerUpCapture = _ref.onPointerUpCapture, onTouchEndCapture = _ref.onTouchEndCapture, onTouchStartCapture = _ref.onTouchStartCapture, shouldFitContainer = _ref.shouldFitContainer, spacing = _ref.spacing, testId = _ref.testId, _ref$type = _ref.type, type = _ref$type === void 0 ? "button" : _ref$type, unsafeRest = (0, (/*@__PURE__*/$parcel$interopDefault($ikhrG)))(_ref, $c63ed0910f6cab3b$var$_excluded);
    // @ts-expect-error
    var _className = unsafeRest.className, _css = unsafeRest.css, _as = unsafeRest.as, _style = unsafeRest.style, saferRest = (0, (/*@__PURE__*/$parcel$interopDefault($ikhrG)))(unsafeRest, $c63ed0910f6cab3b$var$_excluded2);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $5mHml.default), (0, (/*@__PURE__*/$parcel$interopDefault($lDu5G)))({
        analyticsContext: analyticsContext,
        ref: ref,
        appearance: appearance,
        autoFocus: autoFocus,
        isDisabled: isDisabled,
        isLoading: isLoading,
        isSelected: isSelected,
        hasIconBefore: Boolean(iconBefore),
        hasIconAfter: Boolean(iconAfter),
        shouldFitContainer: shouldFitContainer,
        spacing: spacing,
        ariaLabel: ariaLabel,
        ariaLabelledBy: ariaLabelledBy,
        onClick: onClick,
        onClickCapture: onClickCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onTouchStartCapture: onTouchStartCapture,
        onTouchEndCapture: onTouchEndCapture,
        testId: testId,
        componentName: "Button",
        type: type,
        interactionName: interactionName
    }, saferRest), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $dAx5m.Fragment), null, iconBefore && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $faTCN.default), {
        type: "icon",
        position: "before",
        isLoading: isLoading
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $2MQ4R.default), {
        icon: iconBefore
    })), children && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $faTCN.default), {
        isLoading: isLoading
    }, children), iconAfter && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $faTCN.default), {
        type: "icon",
        position: "after",
        isLoading: isLoading
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $2MQ4R.default), {
        icon: iconAfter
    }))));
}));
$c63ed0910f6cab3b$var$Button.displayName = "Button";
var $c63ed0910f6cab3b$export$2e2bcd8739ae039 = $c63ed0910f6cab3b$var$Button;

});
parcelRegister("5mHml", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3e80a41b86ca7aa2$export$2e2bcd8739ae039; });
/* button-base.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $lDu5G = parcelRequire("lDu5G");

var $ikhrG = parcelRequire("ikhrG");

var $9UAdG = parcelRequire("9UAdG");

var $dAx5m = parcelRequire("dAx5m");

var $fTztV = parcelRequire("fTztV");

var $jPkgn = parcelRequire("jPkgn");

var $aINwx = parcelRequire("aINwx");

var $bEvp9 = parcelRequire("bEvp9");

var $18rB9 = parcelRequire("18rB9");

var $7fSbo = parcelRequire("7fSbo");

var $dfmtY = parcelRequire("dfmtY");

var $8Ttyh = parcelRequire("8Ttyh");

var $gjLaE = parcelRequire("gjLaE");

var $jOZTc = parcelRequire("jOZTc");
var $3e80a41b86ca7aa2$var$_excluded = [
    "appearance",
    "autoFocus",
    "isDisabled",
    "isLoading",
    "isSelected",
    "isIconButton",
    "isCircle",
    "hasIconBefore",
    "hasIconAfter",
    "shouldFitContainer",
    "spacing",
    "ariaLabel",
    "ariaLabelledBy",
    "children",
    "interactionName",
    "onClick",
    "onMouseDown",
    "onMouseDownCapture",
    "onMouseUp",
    "onMouseUpCapture",
    "onKeyDown",
    "onKeyDownCapture",
    "onKeyUp",
    "onKeyUpCapture",
    "onTouchStart",
    "onTouchStartCapture",
    "onTouchEnd",
    "onTouchEndCapture",
    "onPointerDown",
    "onPointerDownCapture",
    "onPointerUp",
    "onPointerUpCapture",
    "onClickCapture",
    "testId",
    "analyticsContext",
    "componentName",
    "role",
    "onMouseOver",
    "onMouseOut",
    "onFocus",
    "onBlur",
    "onMouseMove",
    "type"
], $3e80a41b86ca7aa2$var$_excluded2 = [
    "className",
    "css",
    "as",
    "style"
];
var $3e80a41b86ca7aa2$var$LOADING_LABEL = ", Loading";
var $3e80a41b86ca7aa2$var$styles = {
    base: "_2rkosqtm _11c82smr _v5649dqc _189eidpf _1rjc12x7 _1e0c116y _vchhusvi _1bsb1wug _p12f1osq _kqswh2mm _4cvr1q9y _1bah1h6o _gy1p1b66 _1o9zidpf _4t3iviql _k48p1wq8 _y4tiutpp _bozgutpp _y3gn1h6o _s7n4nkob _14mj1kw7 _9v7aze3t _1tv3nqa1 _39yqe4h9 _11fnglyw _18postnw",
    linkDecorationUnset: "_4bfu1r31 _1hmsglyw _ajmmnqa1 _1a3b1r31 _4fprglyw _5goinqa1 _9oik1r31 _1bnxglyw _jf4cnqa1 _1nrm1r31 _c2waglyw _1iohnqa1",
    disabled: "_80om13gf _bfhk1fvb _syaz1lh4 _aetrglyw _irr31fvb _30l31lh4 _1di61fvb _9h8h1lh4",
    spacingCompact: "_1rjcv77o _gy1p1b66 _4t3i1k8s _y4tiutpp _bozgutpp _s7n4nkob",
    circle: "_2rko14q2",
    fullWidth: "_1bsb1osq",
    loading: "_80om15jw",
    iconButton: "_4t3iviql _1bsbviql _y4tize3t _bozgze3t",
    iconButtonCompact: "_4t3i1k8s _1bsb1k8s",
    buttonIconBefore: "_bozgu2gc",
    buttonIconAfter: "_y4tiu2gc",
    splitButton: "_g0pbb4wl",
    loadingOverlay: "_1e0c1txw _kqswstnw _4cvr1h6o _1bah1h6o _u7coze3t _152tze3t _rjxpze3t _1e02ze3t",
    navigationSplitButton: "_1bsb1tcg _bfhksm61 _y4ti12x7 _bozg12x7"
};
var $3e80a41b86ca7aa2$var$defaultStyles = {
    root: "_bfhk1j54 _syaz10s3 _105310s3 _f8pj10s3 _30l310s3 _9h8h10s3",
    rootRefreshed: "_bfhksm61 _syaz1gjq _8l3mmuej _aetrb3bt _10531gjq _f8pj1gjq _30l31gjq _9h8h1gjq",
    interactive: "_irr3yw9d _30l310s3 _1di6ih13 _9h8h10s3",
    interactiveRefreshed: "_irr3166n _30l31gjq _1di61dty _9h8h1gjq"
};
var $3e80a41b86ca7aa2$var$primaryStyles = {
    root: "_bfhkomb0 _syaz15cr _105315cr _f8pj15cr _30l315cr _9h8h15cr",
    interactive: "_30l315cr _irr31wqm _9h8h15cr _1di617hq"
};
var $3e80a41b86ca7aa2$var$warningStyles = {
    root: "_bfhk1ikc _syazal3n _1053al3n _f8pjal3n _30l3al3n _9h8hal3n",
    interactive: "_30l3al3n _irr31j43 _9h8hal3n _1di6h4op"
};
var $3e80a41b86ca7aa2$var$dangerStyles = {
    root: "_bfhk1v7l _syaz15cr _105315cr _f8pj15cr _30l315cr _9h8h15cr",
    interactive: "_30l315cr _irr31rwk _9h8h15cr _1di6yycf"
};
var $3e80a41b86ca7aa2$var$discoveryStyles = {
    root: "_bfhk1vbi _syaz15cr _105315cr _f8pj15cr _30l315cr _9h8h15cr",
    interactive: "_30l315cr _irr37gr8 _9h8h15cr _1di61wu2"
};
var $3e80a41b86ca7aa2$var$subtleStyles = {
    root: "_bfhkqtfy _syaz10s3 _105310s3 _f8pj10s3 _30l310s3 _9h8h10s3",
    rootRefreshed: "_bfhkqtfy _syaz1gjq _10531gjq _f8pj1gjq _30l31gjq _9h8h1gjq",
    interactive: "_irr34mfv _30l310s3 _1di619qy _9h8h10s3",
    interactiveRefreshed: "_irr34mfv _30l31gjq _1di619qy _9h8h1gjq"
};
var $3e80a41b86ca7aa2$var$selectedStyles = {
    root: "_bfhk7btw _syaz1pke _10531pke _f8pj1pke _30l31pke _9h8h1pke",
    rootRefreshed: "_bfhkfg4m _syaz1ldt _8l3mcoux _aetrb3bt _10531ldt _f8pj1ldt _30l31ldt _9h8h1ldt",
    insideSplitButton: "_1pbycs5v",
    interactive: "_irr3t71w _30l31pke _1di6yssv _9h8h1pke",
    warning: "_bfhkvdtc _syaz16q2 _30l31pke _irr3vdtc _9h8h1pke _1di6vdtc",
    danger: "_bfhkbeib _syaz1pke _30l31pke _irr3beib _9h8h1pke _1di6beib",
    discovery: "_bfhk1g49 _syaz1pke _30l31pke _irr31g49 _9h8h1pke _1di61g49"
};
/**
 * __button base__
 *
 * - Implements auto focus when enabled.
 * - Appends the `onClick` event with UFO analytics tracking.
 *
 * @private
 */ var $3e80a41b86ca7aa2$var$ButtonBase = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).forwardRef(function(_ref, ref) {
    var propAppearance = _ref.appearance, _ref$autoFocus = _ref.autoFocus, autoFocus = _ref$autoFocus === void 0 ? false : _ref$autoFocus, _ref$isDisabled = _ref.isDisabled, propIsDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled, _ref$isLoading = _ref.isLoading, isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading, _ref$isSelected = _ref.isSelected, propIsSelected = _ref$isSelected === void 0 ? false : _ref$isSelected, _ref$isIconButton = _ref.isIconButton, isIconButton = _ref$isIconButton === void 0 ? false : _ref$isIconButton, _ref$isCircle = _ref.isCircle, isCircle = _ref$isCircle === void 0 ? false : _ref$isCircle, _ref$hasIconBefore = _ref.hasIconBefore, hasIconBefore = _ref$hasIconBefore === void 0 ? false : _ref$hasIconBefore, _ref$hasIconAfter = _ref.hasIconAfter, hasIconAfter = _ref$hasIconAfter === void 0 ? false : _ref$hasIconAfter, _ref$shouldFitContain = _ref.shouldFitContainer, shouldFitContainer = _ref$shouldFitContain === void 0 ? false : _ref$shouldFitContain, _ref$spacing = _ref.spacing, propSpacing = _ref$spacing === void 0 ? "default" : _ref$spacing, ariaLabel = _ref.ariaLabel, ariaLabelledBy = _ref.ariaLabelledBy, children = _ref.children, interactionName = _ref.interactionName, onClick = _ref.onClick, onMouseDown = _ref.onMouseDown, onMouseDownCapture = _ref.onMouseDownCapture, onMouseUp = _ref.onMouseUp, onMouseUpCapture = _ref.onMouseUpCapture, onKeyDown = _ref.onKeyDown, onKeyDownCapture = _ref.onKeyDownCapture, onKeyUp = _ref.onKeyUp, onKeyUpCapture = _ref.onKeyUpCapture, onTouchStart = _ref.onTouchStart, onTouchStartCapture = _ref.onTouchStartCapture, onTouchEnd = _ref.onTouchEnd, onTouchEndCapture = _ref.onTouchEndCapture, onPointerDown = _ref.onPointerDown, onPointerDownCapture = _ref.onPointerDownCapture, onPointerUp = _ref.onPointerUp, onPointerUpCapture = _ref.onPointerUpCapture, onClickCapture = _ref.onClickCapture, testId = _ref.testId, analyticsContext = _ref.analyticsContext, componentName = _ref.componentName, role = _ref.role, onMouseOver = _ref.onMouseOver, onMouseOut = _ref.onMouseOut, onFocus = _ref.onFocus, onBlur = _ref.onBlur, onMouseMove = _ref.onMouseMove, type = _ref.type, unsafeRest = (0, (/*@__PURE__*/$parcel$interopDefault($ikhrG)))(_ref, $3e80a41b86ca7aa2$var$_excluded);
    var localRef = (0, $dAx5m.useRef)(null);
    var splitButtonContext = (0, $8Ttyh.useSplitButtonContext)();
    var loadingLabelId = (0, $bEvp9.useId)();
    var isSplitButton = Boolean(splitButtonContext);
    var isNavigationSplitButton = (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.isNavigationSplitButton) || false;
    var isDefaultAppearanceSplitButton = (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.appearance) === "default";
    var appearance = isDefaultAppearanceSplitButton && (0, $18rB9.fg)("platform-component-visual-refresh") ? "subtle" : propAppearance || (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.appearance) || "default";
    var spacing = (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.spacing) || propSpacing;
    var isDisabled = (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.isDisabled) || propIsDisabled;
    var isInteractive = !isDisabled && !isLoading;
    // Also treat loading buttons as disabled
    var isEffectivelyDisabled = isDisabled || isLoading;
    var isSelected = propIsSelected && !isDisabled;
    (0, $aINwx.default)(localRef, autoFocus);
    // @ts-expect-error
    var _className = unsafeRest.className, _css = unsafeRest.css, _as = unsafeRest.as, _style = unsafeRest.style, saferRest = (0, (/*@__PURE__*/$parcel$interopDefault($ikhrG)))(unsafeRest, $3e80a41b86ca7aa2$var$_excluded2);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $7fSbo.default), (0, (/*@__PURE__*/$parcel$interopDefault($lDu5G)))({}, saferRest, {
        componentName: componentName || "button",
        analyticsContext: analyticsContext,
        role: role,
        ref: (0, $jPkgn.default)([
            localRef,
            ref
        ]),
        xcss: (0, $fTztV.cx)($3e80a41b86ca7aa2$var$styles.base, appearance === "default" && ((0, $18rB9.fg)("platform-component-visual-refresh") ? $3e80a41b86ca7aa2$var$defaultStyles.rootRefreshed : $3e80a41b86ca7aa2$var$defaultStyles.root), appearance === "default" && isInteractive && ((0, $18rB9.fg)("platform-component-visual-refresh") ? $3e80a41b86ca7aa2$var$defaultStyles.interactiveRefreshed : $3e80a41b86ca7aa2$var$defaultStyles.interactive), appearance === "primary" && $3e80a41b86ca7aa2$var$primaryStyles.root, appearance === "primary" && isInteractive && $3e80a41b86ca7aa2$var$primaryStyles.interactive, appearance === "warning" && $3e80a41b86ca7aa2$var$warningStyles.root, appearance === "warning" && isInteractive && $3e80a41b86ca7aa2$var$warningStyles.interactive, appearance === "danger" && $3e80a41b86ca7aa2$var$dangerStyles.root, appearance === "danger" && isInteractive && $3e80a41b86ca7aa2$var$dangerStyles.interactive, appearance === "discovery" && $3e80a41b86ca7aa2$var$discoveryStyles.root, appearance === "discovery" && isInteractive && $3e80a41b86ca7aa2$var$discoveryStyles.interactive, appearance === "subtle" && ((0, $18rB9.fg)("platform-component-visual-refresh") ? $3e80a41b86ca7aa2$var$subtleStyles.rootRefreshed : $3e80a41b86ca7aa2$var$subtleStyles.root), appearance === "subtle" && isInteractive && ((0, $18rB9.fg)("platform-component-visual-refresh") ? $3e80a41b86ca7aa2$var$subtleStyles.interactiveRefreshed : $3e80a41b86ca7aa2$var$subtleStyles.interactive), $3e80a41b86ca7aa2$var$styles.linkDecorationUnset, isSelected && ((0, $18rB9.fg)("platform-component-visual-refresh") ? $3e80a41b86ca7aa2$var$selectedStyles.rootRefreshed : $3e80a41b86ca7aa2$var$selectedStyles.root), isSelected && isSplitButton && $3e80a41b86ca7aa2$var$selectedStyles.insideSplitButton, isSelected && isInteractive && $3e80a41b86ca7aa2$var$selectedStyles.interactive, // TODO: remove me once we kill color fallbacks
        isSelected && appearance === "danger" && $3e80a41b86ca7aa2$var$selectedStyles.danger, // TODO: remove me once we kill color fallbacks
        isSelected && appearance === "warning" && $3e80a41b86ca7aa2$var$selectedStyles.warning, // TODO: remove me once we kill color fallbacks
        isSelected && appearance === "discovery" && $3e80a41b86ca7aa2$var$selectedStyles.discovery, isDisabled && $3e80a41b86ca7aa2$var$styles.disabled, isCircle && !isSplitButton && $3e80a41b86ca7aa2$var$styles.circle, spacing === "compact" && $3e80a41b86ca7aa2$var$styles.spacingCompact, hasIconBefore && $3e80a41b86ca7aa2$var$styles.buttonIconBefore, shouldFitContainer && $3e80a41b86ca7aa2$var$styles.fullWidth, hasIconAfter && $3e80a41b86ca7aa2$var$styles.buttonIconAfter, isIconButton && $3e80a41b86ca7aa2$var$styles.iconButton, isIconButton && spacing === "compact" && $3e80a41b86ca7aa2$var$styles.iconButtonCompact, isLoading && $3e80a41b86ca7aa2$var$styles.loading, isSplitButton && $3e80a41b86ca7aa2$var$styles.splitButton, isNavigationSplitButton && $3e80a41b86ca7aa2$var$styles.navigationSplitButton),
        isDisabled: isEffectivelyDisabled,
        "aria-label": isLoading && ariaLabel && !ariaLabelledBy ? "".concat(ariaLabel, " ").concat($3e80a41b86ca7aa2$var$LOADING_LABEL) : ariaLabel,
        "aria-labelledby": isLoading && ariaLabelledBy ? "".concat(ariaLabelledBy, " ").concat(loadingLabelId) : ariaLabelledBy,
        onClick: onClick
    }, (0, $gjLaE.default)(isEffectivelyDisabled, {
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onTouchStartCapture: onTouchStartCapture,
        onTouchEndCapture: onTouchEndCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onClickCapture: onClickCapture
    }), {
        testId: testId,
        onMouseOver: onMouseOver,
        onFocus: onFocus,
        onMouseMove: onMouseMove,
        onBlur: onBlur,
        type: type,
        interactionName: interactionName,
        onMouseDown: onMouseDown,
        onMouseUp: onMouseUp,
        onKeyDown: onKeyDown,
        onMouseOut: onMouseOut,
        onKeyUp: onKeyUp,
        onTouchStart: onTouchStart,
        onTouchEnd: onTouchEnd,
        onPointerDown: onPointerDown,
        onPointerUp: onPointerUp
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $8Ttyh.SplitButtonContext).Provider, {
        value: undefined
    }, children, isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement("span", {
        className: (0, $9UAdG.default)([
            $3e80a41b86ca7aa2$var$styles.loadingOverlay
        ])
    }, (0, $jOZTc.default)({
        spacing: spacing,
        appearance: appearance,
        isDisabled: isDisabled,
        isSelected: isSelected,
        testId: testId
    })), isLoading && (ariaLabelledBy || !ariaLabel) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $dfmtY.default), {
        id: loadingLabelId
    }, $3e80a41b86ca7aa2$var$LOADING_LABEL)));
});
var $3e80a41b86ca7aa2$export$2e2bcd8739ae039 = $3e80a41b86ca7aa2$var$ButtonBase;

});
parcelRegister("9UAdG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $73757079b6ea0702$export$2e2bcd8739ae039; });
const $73757079b6ea0702$var$UNDERSCORE_UNICODE = 95;
/**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $73757079b6ea0702$var$ATOMIC_GROUP_LENGTH = 5;
function $73757079b6ea0702$export$2e2bcd8739ae039(classNames) {
    if (classNames.length <= 1 && (!classNames[0] || classNames[0].indexOf(" ") === -1)) // short circuit if there's no custom class names.
    return classNames[0] || undefined;
    const atomicGroups = {};
    for(let i = 0; i < classNames.length; i++){
        const cls = classNames[i];
        if (!cls) continue;
        const groups = cls.split(" ");
        for(let x = 0; x < groups.length; x++){
            const atomic = groups[x];
            const atomicGroupName = atomic.slice(0, atomic.charCodeAt(0) === $73757079b6ea0702$var$UNDERSCORE_UNICODE ? $73757079b6ea0702$var$ATOMIC_GROUP_LENGTH : undefined);
            atomicGroups[atomicGroupName] = atomic;
        }
    }
    let str = "";
    for(const key in atomicGroups){
        const value = atomicGroups[key];
        str += value + " ";
    }
    return str.slice(0, -1);
}

});

parcelRegister("fTztV", function(module, exports) {

$parcel$export(module.exports, "cx", function () { return $b92783f793c7c962$export$a274e22fb40f762e; });
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ parcelRequire("dAx5m");


var $7zPRS = parcelRequire("7zPRS");
var $b92783f793c7c962$var$_createStrictAPI = (0, $7zPRS.createStrictAPI)(), $b92783f793c7c962$var$XCSSProp = $b92783f793c7c962$var$_createStrictAPI.XCSSProp, $b92783f793c7c962$export$dbf350e5966cf602 = $b92783f793c7c962$var$_createStrictAPI.css, $b92783f793c7c962$export$eb1ecd84a24ee424 = $b92783f793c7c962$var$_createStrictAPI.cssMap, $b92783f793c7c962$export$a274e22fb40f762e = $b92783f793c7c962$var$_createStrictAPI.cx;
 // This is to mitigate local TS error TS2315: Type 'StrictXCSSProp' is not generic.
 // Currently for some reason tsc is generating malformed .d.ts in local dev environment, below change fixes it
 /**
 * ## StrictXCSSProp
 *
 * Declare styles your component takes with all other styles marked as violations
 * by the TypeScript compiler. There are two primary use cases for xcss prop:
 *
 * - safe style overrides
 * - inverting style declarations
 *
 * Interverting style declarations is interesting for platform teams as
 * it means products only pay for styles they use as they're now the ones who declare
 * the styles!
 *
 * The {@link StrictXCSSProp} type has generics two of which must be defined — use to explicitly
 * set what you want to maintain as API. Use {@link XCSSAllProperties} and {@link XCSSAllPseudos}
 * to enable all properties and pseudos.
 *
 * The third generic is used to declare what properties and pseudos should be required.
 *
 * ```tsx
 * interface MyComponentProps {
 *   // Color is accepted, all other properties / pseudos are considered violations.
 *   xcss?: StrictXCSSProp<'color', never>;
 *
 *   // Only background color and hover pseudo are accepted.
 *   xcss?: StrictXCSSProp<'backgroundColor', '&:hover'>;
 *
 *   // All properties are accepted, all pseudos are considered violations.
 *   xcss?: StrictXCSSProp<XCSSAllProperties, never>;
 *
 *   // All properties are accepted, only the hover pseudo is accepted.
 *   xcss?: StrictXCSSProp<XCSSAllProperties, '&:hover'>;
 *
 *   // The xcss prop is required as well as the color property. No pseudos are required.
 *   xcss: StrictXCSSProp<
 *     XCSSAllProperties,
 *     '&:hover',
 *     { requiredProperties: 'color', requiredPseudos: never }
 *   >;
 * }
 *
 * function MyComponent({ xcss }: MyComponentProps) {
 *   return <div css={{ color: 'var(--ds-text-danger)' }} className={xcss} />
 * }
 * ```
 *
 * The xcss prop works with static inline objects and the [cssMap](https://compiledcssinjs.com/docs/api-cssmap) API.
 *
 * ```jsx
 * // Declared as an inline object
 * <Component xcss={{ color: 'var(--ds-text)' }} />
 *
 * // Declared with the cssMap API
 * const styles = cssMap({ text: { color: 'var(--ds-text)' } });
 * <Component xcss={styles.text} />
 * ```
 *
 * To concatenate and conditonally apply styles use the {@link cssMap} and {@link cx} functions.
 */ 
});
parcelRegister("7zPRS", function(module, exports) {

$parcel$export(module.exports, "createStrictAPI", function () { return $5844092b8c6884ac$export$39716b4af53f4ad; });

var $l3vAw = parcelRequire("l3vAw");

var $hB4g5 = parcelRequire("hB4g5");
function $5844092b8c6884ac$export$39716b4af53f4ad() {
    return {
        css () {
            throw (0, $l3vAw.createStrictSetupError)();
        },
        cssMap () {
            throw (0, $l3vAw.createStrictSetupError)();
        },
        cx: $hB4g5.cx,
        XCSSProp () {
            throw (0, $l3vAw.createStrictSetupError)();
        }
    };
}

});
parcelRegister("l3vAw", function(module, exports) {

$parcel$export(module.exports, "createStrictSetupError", function () { return $f54261868e38e445$export$c4df1cb0c2b4d77c; });
const $f54261868e38e445$export$6c9a87045746941d = ()=>{
    return new Error(`
 \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2557}   \u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2557}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}\u{255A}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{255D}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551} \u{255A}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}
 \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}

  @compiled/react

  Code was executed when it shouldn't have. This could have happened because:

  1. You haven't configured a transformer yet. Visit https://compiledcssinjs.com/docs/installation and follow the instructions.
  2. You have duplicate versions of React and hooks are blowing up. You need to de-duplicate your dependencies.

  Good luck!
`);
};
const $f54261868e38e445$export$c4df1cb0c2b4d77c = ()=>{
    return new Error(`
 \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2557}   \u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2557}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}\u{255A}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{255D}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551} \u{255A}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}
 \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}

  @compiled/react

  Code was executed when it shouldn't have. To resolve make sure to:

  1. Set up Compiled.
  2. Configure importSources in your Compiled config to point to the module that exports the output of createStrictAPI().

  For more information visit https://compiledcssinjs.com/docs/installation and follow the instructions.
`);
};

});

parcelRegister("hB4g5", function(module, exports) {

$parcel$export(module.exports, "cx", function () { return $ccf93207cce6776a$export$a274e22fb40f762e; });

var $jxjwT = parcelRequire("jxjwT");
const $ccf93207cce6776a$export$a274e22fb40f762e = (...styles)=>{
    // At runtime TStyles is resolved down to strings, but not at compile time.
    // We circumvent the type system here because of that.
    const actualStyles = styles;
    // The output should be a union type of passed in styles. This ensures the call
    // site of xcss prop can raise violations when disallowed styles have been passed.
    return (0, $jxjwT.default)(actualStyles);
};

});
parcelRegister("jxjwT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e3903f90446b1723$export$2e2bcd8739ae039; });
const $e3903f90446b1723$var$UNDERSCORE_UNICODE = 95;
/**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $e3903f90446b1723$var$ATOMIC_GROUP_LENGTH = 5;
function $e3903f90446b1723$export$2e2bcd8739ae039(classNames) {
    if (classNames.length <= 1 && (!classNames[0] || classNames[0].indexOf(" ") === -1)) // short circuit if there's no custom class names.
    return classNames[0] || undefined;
    const atomicGroups = {};
    for(let i = 0; i < classNames.length; i++){
        const cls = classNames[i];
        if (!cls) continue;
        const groups = cls.split(" ");
        for(let x = 0; x < groups.length; x++){
            const atomic = groups[x];
            const atomicGroupName = atomic.slice(0, atomic.charCodeAt(0) === $e3903f90446b1723$var$UNDERSCORE_UNICODE ? $e3903f90446b1723$var$ATOMIC_GROUP_LENGTH : undefined);
            atomicGroups[atomicGroupName] = atomic;
        }
    }
    let str = "";
    for(const key in atomicGroups){
        const value = atomicGroups[key];
        str += value + " ";
    }
    return str.slice(0, -1);
}

});




parcelRegister("jPkgn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e6f27f924e351c74$export$2e2bcd8739ae039; });
/**
 * Assigns the node to all the refs passed in the argument.
 *
 * @param refs: An array of refs (as function or ref object)
 */ function $e6f27f924e351c74$export$2e2bcd8739ae039(refs) {
    // TODO: could this be wrapped in `useCallback` so we get a stable function?
    return function(value) {
        refs.forEach(function(ref) {
            if (typeof ref === "function") ref(value);
            else if (ref !== null) ref.current = value;
        });
    };
}

});

parcelRegister("bEvp9", function(module, exports) {

$parcel$export(module.exports, "useId", function () { return $87bbca71bd712966$export$f680877a34711e37; });
$parcel$export(module.exports, "useIdSeed", function () { return $87bbca71bd712966$export$6ee17796e3d70de2; });

var $5RAei = parcelRequire("5RAei");

var $dAx5m = parcelRequire("dAx5m");

var $D9YLo = parcelRequire("D9YLo");

var $18rB9 = parcelRequire("18rB9");
var $87bbca71bd712966$var$_React$useId;
// Type copied from https://github.com/thearnica/react-uid/blob/0f507fbbdb1ab84acf477ec32698afe3d2191e49/src/hooks.ts#L12
// Copied rather than inferred to make the type transparent
// @ts-ignore - useId is not accessible in React 16
var $87bbca71bd712966$var$react18UseId = ($87bbca71bd712966$var$_React$useId = (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).useId) !== null && $87bbca71bd712966$var$_React$useId !== void 0 ? $87bbca71bd712966$var$_React$useId : undefined;
function $87bbca71bd712966$export$f680877a34711e37() {
    if ($87bbca71bd712966$var$react18UseId && (0, $18rB9.fg)("platform-dst-react-18-use-id")) // eslint-disable-next-line react-hooks/rules-of-hooks
    return $87bbca71bd712966$var$react18UseId();
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return "uid".concat((0, $D9YLo.useUID)());
}
var $87bbca71bd712966$export$6be90bcb437e928f = /*#__PURE__*/ (0, $dAx5m.forwardRef)(function(_ref, ref) {
    var children = _ref.children, _ref$postfix = _ref.postfix, postfix = _ref$postfix === void 0 ? "" : _ref$postfix, _ref$prefix = _ref.prefix, prefix = _ref$prefix === void 0 ? "" : _ref$prefix;
    var id = "".concat(prefix).concat($87bbca71bd712966$export$f680877a34711e37()).concat(postfix);
    (0, $dAx5m.useEffect)(function() {
        if (!ref) return;
        switch((0, (/*@__PURE__*/$parcel$interopDefault($5RAei)))(ref)){
            case "function":
                ref(id);
                break;
            case "object":
                ref.current = id;
                break;
            default:
                throw new Error('Unreachable case for unsupported type of ref "'.concat((0, (/*@__PURE__*/$parcel$interopDefault($5RAei)))(ref), '"'));
        }
    }, [
        id,
        ref
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).Fragment, null, typeof children === "function" ? children({
        id: id
    }) : children);
});
function $87bbca71bd712966$export$6ee17796e3d70de2() {
    if ($87bbca71bd712966$var$react18UseId && (0, $18rB9.fg)("platform-dst-react-18-use-id")) {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        var uid = $87bbca71bd712966$var$react18UseId();
        return function(id) {
            return "".concat(uid, "-").concat(id.toString());
        };
    }
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return (0, $D9YLo.useUIDSeed)();
}

});

parcelRegister("7fSbo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5483f6ac039c4040$export$2e2bcd8739ae039; });
/* pressable.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $lDu5G = parcelRequire("lDu5G");

var $ikhrG = parcelRequire("ikhrG");

var $dAx5m = parcelRequire("dAx5m");


var $fJHBw = parcelRequire("fJHBw");

var $aadHU = parcelRequire("aadHU");

var $2NfKg = parcelRequire("2NfKg");

var $4mhQ1 = parcelRequire("4mhQ1");

var $kyNNs = parcelRequire("kyNNs");
var $5483f6ac039c4040$var$_excluded = [
    "children",
    "isDisabled",
    "type",
    "onClick",
    "interactionName",
    "componentName",
    "analyticsContext",
    "style",
    "testId",
    "xcss"
], $5483f6ac039c4040$var$_excluded2 = [
    "className"
];
var $5483f6ac039c4040$var$styles = {
    root: "_19itglyw _vchhusvi _r06hglyw _80omtlke",
    disabled: "_80om13gf"
};
/**
 * __Pressable__
 *
 * A primitive for building custom buttons.
 *
 * - [Examples](https://atlassian.design/components/primitives/pressable/examples)
 * - [Code](https://atlassian.design/components/primitives/pressable/code)
 * - [Usage](https://atlassian.design/components/primitives/pressable/usage)
 */ var $5483f6ac039c4040$var$Pressable = /*#__PURE__*/ (0, $dAx5m.forwardRef)(function(_ref, ref) {
    var children = _ref.children, isDisabled = _ref.isDisabled, _ref$type = _ref.type, type = _ref$type === void 0 ? "button" : _ref$type, _ref$onClick = _ref.onClick, providedOnClick = _ref$onClick === void 0 ? (0, $2NfKg.default) : _ref$onClick, interactionName = _ref.interactionName, componentName = _ref.componentName, analyticsContext = _ref.analyticsContext, style = _ref.style, testId = _ref.testId, xcss = _ref.xcss, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($ikhrG)))(_ref, $5483f6ac039c4040$var$_excluded);
    var interactionContext = (0, $dAx5m.useContext)((0, $4mhQ1.default));
    var handleClick = (0, $dAx5m.useCallback)(function(e, analyticsEvent) {
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    var onClick = (0, $aadHU.usePlatformLeafEventHandler)({
        fn: handleClick,
        action: "clicked",
        componentName: componentName || "Pressable",
        packageName: "@atlaskit/primitives",
        packageVersion: "14.4.0",
        analyticsData: analyticsContext,
        actionSubject: "button"
    });
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($ikhrG)))(htmlAttributes, $5483f6ac039c4040$var$_excluded2);
    return /*#__PURE__*/ $dAx5m.createElement((0, $kyNNs.default), (0, (/*@__PURE__*/$parcel$interopDefault($lDu5G)))({
        as: "button",
        style: style
    }, safeHtmlAttributes, {
        // eslint-disable-next-line react/button-has-type
        type: type,
        onClick: onClick,
        disabled: isDisabled,
        xcss: (0, $fJHBw.cx)($5483f6ac039c4040$var$styles.root, isDisabled && $5483f6ac039c4040$var$styles.disabled, xcss),
        testId: testId,
        ref: ref
    }), children);
});
var $5483f6ac039c4040$export$2e2bcd8739ae039 = $5483f6ac039c4040$var$Pressable;

});
parcelRegister("fJHBw", function(module, exports) {

$parcel$export(module.exports, "cx", function () { return $b74ce1e1fb68572f$export$a274e22fb40f762e; });

var $iBCmT = parcelRequire("iBCmT");
const $b74ce1e1fb68572f$export$a274e22fb40f762e = (...styles)=>{
    // At runtime TStyles is resolved down to strings, but not at compile time.
    // We circumvent the type system here because of that.
    const actualStyles = styles;
    // The output should be a union type of passed in styles. This ensures the call
    // site of xcss prop can raise violations when disallowed styles have been passed.
    return (0, $iBCmT.default)(actualStyles);
};

});

parcelRegister("kyNNs", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ef7d9c308e0a7bdd$export$2e2bcd8739ae039; });
/* focusable.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $lDu5G = parcelRequire("lDu5G");

var $9HWAT = parcelRequire("9HWAT");

var $ikhrG = parcelRequire("ikhrG");

var $dAx5m = parcelRequire("dAx5m");

var $iBCmT = parcelRequire("iBCmT");
var $dskpG = parcelRequire("dskpG");
var $ef7d9c308e0a7bdd$var$_excluded = [
    "as",
    "children",
    "isInset",
    "testId",
    "style",
    "xcss"
], $ef7d9c308e0a7bdd$var$_excluded2 = [
    "className"
];
function $ef7d9c308e0a7bdd$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $ef7d9c308e0a7bdd$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $ef7d9c308e0a7bdd$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($9HWAT)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $ef7d9c308e0a7bdd$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $ef7d9c308e0a7bdd$var$focusRingStyles = null;
var $ef7d9c308e0a7bdd$var$insetFocusRingStyles = null;
/**
 * __Focus ring__
 *
 * A focus ring visually indicates the currently focused item.
 *
 */ var $ef7d9c308e0a7bdd$var$Focusable = /*#__PURE__*/ (0, $dAx5m.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? "button" : _ref$as, children = _ref.children, isInset = _ref.isInset, testId = _ref.testId, style = _ref.style, xcss = _ref.xcss, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($ikhrG)))(_ref, $ef7d9c308e0a7bdd$var$_excluded);
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($ikhrG)))(htmlAttributes, $ef7d9c308e0a7bdd$var$_excluded2);
    return /*#__PURE__*/ $dAx5m.createElement(Component, (0, (/*@__PURE__*/$parcel$interopDefault($lDu5G)))({}, safeHtmlAttributes, {
        // @ts-ignore Expression produces a union type that is too complex to represent. We may be able to narrow the type here but unsure.
        ref: ref,
        className: (0, $iBCmT.default)([
            "_mizu194a _1ah31bk5 _ra3xnqa1 _128m1bk5 _1cvmnqa1 _4davt94y",
            isInset && "_1ah3115h _2mwq115h",
            xcss
        ]),
        "data-testid": testId,
        style: $ef7d9c308e0a7bdd$var$_objectSpread($ef7d9c308e0a7bdd$var$_objectSpread({}, style), {}, {
            "--_1203r2w": (0, $dskpG.default)("calc(0px - ".concat("var(--ds-border-width-outline, 2px)", ")"))
        })
    }), children);
});
var $ef7d9c308e0a7bdd$export$2e2bcd8739ae039 = $ef7d9c308e0a7bdd$var$Focusable;

});
parcelRegister("dskpG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9cbdb98247f4f22a$export$2e2bcd8739ae039; });
/**
 * Returns a CSS custom property value with an optional suffix & prefix.
 * Prefix will only be added if there is a suffix.
 * If the value is undefined a fallback value will be returned to prevent children inheriting parent values.
 *
 * @param value
 * @param suffix
 * @param prefix
 */ function $9cbdb98247f4f22a$export$2e2bcd8739ae039(value, suffix, prefix) {
    if (value != undefined) {
        if (suffix) {
            if (prefix) return prefix + value + suffix;
            return value + suffix;
        }
        return value;
    }
    // Currently React trims these values so we can't use a space " " to block the value.
    // Instead we use a CSS variable that doesn't exist which falls back to " ".
    // Bug raised here: https://github.com/facebook/react/issues/20497
    return "var(--c-, )";
}

});



parcelRegister("8Ttyh", function(module, exports) {

$parcel$export(module.exports, "SplitButtonContext", function () { return $679a62305b4e358f$export$4b86304b2c0d7e71; });
$parcel$export(module.exports, "useSplitButtonContext", function () { return $679a62305b4e358f$export$47e2c6fdb142d947; });

var $dAx5m = parcelRequire("dAx5m");
var $679a62305b4e358f$export$4b86304b2c0d7e71 = /*#__PURE__*/ (0, $dAx5m.createContext)(undefined);
var $679a62305b4e358f$export$47e2c6fdb142d947 = function useSplitButtonContext() {
    var context = (0, $dAx5m.useContext)($679a62305b4e358f$export$4b86304b2c0d7e71);
    if (!context) return undefined;
    if (context.appearance === "navigation") {
        var newContext = {
            spacing: "default",
            appearance: "subtle",
            isDisabled: false,
            isActiveOverSelected: false,
            isNavigationSplitButton: true,
            isHighlighted: context.isHighlighted
        };
        return newContext;
    }
    var splitButtonContext = {
        spacing: context.spacing,
        appearance: context.appearance,
        isDisabled: context.isDisabled,
        isActiveOverSelected: true,
        isNavigationSplitButton: false,
        isHighlighted: false
    };
    return splitButtonContext;
};

});

parcelRegister("gjLaE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $be1302d0649a3582$export$2e2bcd8739ae039; });
function $be1302d0649a3582$var$abort(event) {
    event.preventDefault();
    event.stopPropagation();
}
var $be1302d0649a3582$var$tabKeyCode = 9;
function $be1302d0649a3582$var$onKey(event) {
    // Allowing tab so that a user can move focus away
    if (event.keyCode === $be1302d0649a3582$var$tabKeyCode) return;
    $be1302d0649a3582$var$abort(event);
}
function $be1302d0649a3582$export$2e2bcd8739ae039(shouldBlockEvents, events) {
    return shouldBlockEvents ? {
        onMouseDownCapture: $be1302d0649a3582$var$abort,
        onMouseUpCapture: $be1302d0649a3582$var$abort,
        onKeyDownCapture: $be1302d0649a3582$var$onKey,
        onKeyUpCapture: $be1302d0649a3582$var$onKey,
        onTouchStartCapture: $be1302d0649a3582$var$abort,
        onTouchEndCapture: $be1302d0649a3582$var$abort,
        onPointerDownCapture: $be1302d0649a3582$var$abort,
        onPointerUpCapture: $be1302d0649a3582$var$abort,
        onClickCapture: $be1302d0649a3582$var$abort,
        // Just smashing the existing onClick for good measure
        onClick: $be1302d0649a3582$var$abort
    } : events;
}

});

parcelRegister("jOZTc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e6e2b1bd3deb4216$export$2e2bcd8739ae039; });

var $dAx5m = parcelRequire("dAx5m");

var $ec8zO = parcelRequire("ec8zO");
function $e6e2b1bd3deb4216$var$getIconSpacing(spacing) {
    switch(spacing){
        case "compact":
            return "small";
        default:
            return "medium";
    }
}
function $e6e2b1bd3deb4216$var$getSpinnerAppearance(_ref) {
    var appearance = _ref.appearance, isDisabled = _ref.isDisabled, isSelected = _ref.isSelected;
    if (isDisabled || isSelected) return "inherit";
    if (appearance === "primary" || appearance === "danger" || appearance === "discovery") return "invert";
    return "inherit";
}
function $e6e2b1bd3deb4216$export$2e2bcd8739ae039(_ref2) {
    var appearance = _ref2.appearance, spacing = _ref2.spacing, isDisabled = _ref2.isDisabled, isSelected = _ref2.isSelected, testId = _ref2.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $ec8zO.default), {
        size: $e6e2b1bd3deb4216$var$getIconSpacing(spacing),
        appearance: $e6e2b1bd3deb4216$var$getSpinnerAppearance({
            appearance: appearance,
            isDisabled: isDisabled,
            isSelected: isSelected
        }),
        testId: testId ? "".concat(testId, "--loading-spinner") : undefined
    });
}

});
parcelRegister("ec8zO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a558d6d25f68411e$export$2e2bcd8739ae039; });
/* spinner.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $fo4ms = parcelRequire("fo4ms");

var $dAx5m = parcelRequire("dAx5m");

var $4mhQ1 = parcelRequire("4mhQ1");

var $2I3Lh = parcelRequire("2I3Lh");

var $dsYtH = parcelRequire("dsYtH");
/**
 * Returns the appropriate circle stroke color.
 */ function $a558d6d25f68411e$var$getStrokeColor(appearance) {
    return appearance === "inherit" ? "var(--ds-icon-subtle, ".concat((0, $2I3Lh.N500), ")") : "var(--ds-icon-inverse, ".concat((0, $2I3Lh.N0), ")");
}
var $a558d6d25f68411e$var$rotate = null;
/**
 * There are three parts to the load in animation:
 * 1. Fade in
 * 2. Accelerated spin
 * 3. Stretch the spinner line
 */ var $a558d6d25f68411e$var$loadIn = null;
var $a558d6d25f68411e$var$styles = {
    rotateStyles: "_y44v1ozz _1pgl2qsq _8hrz1h6o",
    loadInStyles: "_y44v1a7z _1o51q7pw _tzy4idpf",
    wrapperStyles: "_1e0c116y _s7n4nkob",
    circleStyles: "_lswuglyw _7ljx1dhp _opj11kw7 _134c892t _1snbbs82 _jcxd7g3v _1tjm1onz"
};
/**
 * `useLayoutEffect` is being used in SSR safe form. On the server, this work doesn’t need to run.
 * `useEffect` is used in-place, because `useEffect` is not run on the server and it matches types
 * which makes things simpler than doing an `isServer` check or a `null` check.
 *
 * @see https://hello.atlassian.net/wiki/spaces/DST/pages/2081696628/DSTDACI-010+-+Interaction+Tracing+hooks+in+DS+components
 */ var $a558d6d25f68411e$var$useLayoutEffect = typeof window === "undefined" ? (0, $dAx5m.useEffect) : (0, $dAx5m.useLayoutEffect);
/**
 * __Spinner__
 *
 * A spinner is an animated spinning icon that lets users know content is being loaded.
 *
 * - [Examples](https://atlassian.design/components/spinner/examples)
 * - [Code](https://atlassian.design/components/spinner/code)
 * - [Usage](https://atlassian.design/components/spinner/usage)
 */ var $a558d6d25f68411e$var$Spinner = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).forwardRef(function Spinner(_ref, ref) {
    var _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "inherit" : _ref$appearance, _ref$delay = _ref.delay, delay = _ref$delay === void 0 ? 0 : _ref$delay, interactionName = _ref.interactionName, label = _ref.label, _ref$size = _ref.size, providedSize = _ref$size === void 0 ? "medium" : _ref$size, testId = _ref.testId;
    var size = typeof providedSize === "number" ? providedSize : (0, $dsYtH.presetSizes)[providedSize];
    var animationDelay = "".concat(delay, "ms");
    var stroke = $a558d6d25f68411e$var$getStrokeColor(appearance);
    var context = (0, $dAx5m.useContext)((0, $4mhQ1.default));
    $a558d6d25f68411e$var$useLayoutEffect(function() {
        if (context != null) return context.hold(interactionName);
    }, [
        context,
        interactionName
    ]);
    /**
   * The Spinner animation uses a combination of two
   * css animations on two separate elements.
   */ return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement("span", {
        "data-testid": testId ? "".concat(testId, "-wrapper") : "spinner-wrapper",
        style: {
            animationDelay: animationDelay,
            width: size,
            height: size
        },
        className: (0, $fo4ms.default)([
            $a558d6d25f68411e$var$styles.wrapperStyles,
            $a558d6d25f68411e$var$styles.rotateStyles
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement("svg", {
        height: size,
        width: size,
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        "data-testid": testId,
        ref: ref,
        "aria-label": label || undefined,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            animationDelay: animationDelay
        },
        role: label ? "img" : "none",
        className: (0, $fo4ms.default)([
            $a558d6d25f68411e$var$styles.loadInStyles
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement("circle", {
        cx: "8",
        cy: "8",
        r: "7",
        style: {
            stroke: stroke
        },
        className: (0, $fo4ms.default)([
            $a558d6d25f68411e$var$styles.circleStyles
        ])
    })));
}));
var $a558d6d25f68411e$export$2e2bcd8739ae039 = $a558d6d25f68411e$var$Spinner;

});
parcelRegister("dsYtH", function(module, exports) {

$parcel$export(module.exports, "presetSizes", function () { return $9cdccd953019544b$export$4e9f1640bbe7a1a8; });
var $9cdccd953019544b$export$4e9f1640bbe7a1a8 = {
    xsmall: 8,
    small: 16,
    medium: 24,
    large: 48,
    xlarge: 96
};

});




parcelRegister("faTCN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b0c2f01dab45b603$export$2e2bcd8739ae039; });
/* content.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $9UAdG = parcelRequire("9UAdG");

var $dAx5m = parcelRequire("dAx5m");
var $b0c2f01dab45b603$var$styles = {
    text: "_1reo15vq _18m915vq _16jlkb7n _1o9zkb7n _1bto1l2s _o5721q9c",
    icon: "_1e0c1txw _16jlidpf _1o9zidpf _1wpz1h6o _1wybidpf _vwz4idpf _uiztglyw",
    beforeIcon: "_1he91b66 _w795v77o",
    afterIcon: "_1he9v77o _w7951b66",
    common: "_v564g17y",
    fade: "_tzy4idpf"
};
/**
 * __Content__
 *
 * Used for slots within a Button, including icons and text content.
 */ var $b0c2f01dab45b603$var$Content = function Content(_ref) {
    var children = _ref.children, _ref$type = _ref.type, type = _ref$type === void 0 ? "text" : _ref$type, isLoading = _ref.isLoading, position = _ref.position;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement("span", {
        className: (0, $9UAdG.default)([
            $b0c2f01dab45b603$var$styles.common,
            type === "text" && $b0c2f01dab45b603$var$styles.text,
            type === "icon" && $b0c2f01dab45b603$var$styles.icon,
            isLoading && $b0c2f01dab45b603$var$styles.fade,
            position === "before" && $b0c2f01dab45b603$var$styles.beforeIcon,
            position === "after" && $b0c2f01dab45b603$var$styles.afterIcon
        ])
    }, children);
};
var $b0c2f01dab45b603$export$2e2bcd8739ae039 = $b0c2f01dab45b603$var$Content;

});

parcelRegister("2MQ4R", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $207875f8e1bb9c3a$export$2e2bcd8739ae039; });

var $dAx5m = parcelRequire("dAx5m");
function $207875f8e1bb9c3a$var$isIconRenderProp(func) {
    return !func.displayName && // most function components and class components have a displayName, negate them
    !func.render && // forwardRef doesn't require a display name, however it does include a render function, negate them
    typeof func === "function" // at the very least we need to be a function
    ;
}
/**
 * __Icon renderer__
 *
 * Used to support render props with icons.
 *
 */ var $207875f8e1bb9c3a$var$IconRenderer = function IconRenderer(_ref) {
    var Icon = _ref.icon;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).Fragment, null, $207875f8e1bb9c3a$var$isIconRenderProp(Icon) ? Icon({
        label: "",
        color: "currentColor"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement(Icon, {
        label: "",
        color: "currentColor"
    }));
};
var $207875f8e1bb9c3a$export$2e2bcd8739ae039 = $207875f8e1bb9c3a$var$IconRenderer;

});


parcelRegister("jezSP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e00b28d149aa4f91$export$2e2bcd8739ae039; });
/* link.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $lDu5G = parcelRequire("lDu5G");

var $ikhrG = parcelRequire("ikhrG");

var $dAx5m = parcelRequire("dAx5m");


var $fTztV = parcelRequire("fTztV");

var $jPkgn = parcelRequire("jPkgn");

var $aINwx = parcelRequire("aINwx");

var $18rB9 = parcelRequire("18rB9");

var $bzvfB = parcelRequire("bzvfB");

var $faTCN = parcelRequire("faTCN");

var $2MQ4R = parcelRequire("2MQ4R");
var $e00b28d149aa4f91$var$_excluded = [
    "analyticsContext",
    "appearance",
    "aria-label",
    "aria-labelledby",
    "autoFocus",
    "children",
    "href",
    "iconAfter",
    "iconBefore",
    "interactionName",
    "isDisabled",
    "isSelected",
    "onClick",
    "onClickCapture",
    "onKeyDownCapture",
    "onKeyUpCapture",
    "onMouseDownCapture",
    "onMouseUpCapture",
    "onPointerDownCapture",
    "onPointerUpCapture",
    "onTouchEndCapture",
    "onTouchStartCapture",
    "spacing",
    "testId"
], $e00b28d149aa4f91$var$_excluded2 = [
    "className",
    "css",
    "as",
    "style"
];
var $e00b28d149aa4f91$var$styles = {
    base: "_2rkosqtm _11c82smr _v5649dqc _189eidpf _1rjc12x7 _1e0c116y _vchhusvi _1bsb1wug _p12f1osq _kqswh2mm _4cvr1q9y _1bah1h6o _gy1p1b66 _1o9zidpf _4t3iviql _k48p1wq8 _y4tiutpp _bozgutpp _y3gn1h6o _s7n4nkob _14mj1kw7 _9v7aze3t _1tv3nqa1 _39yqe4h9 _11fnglyw _18postnw",
    linkDecorationUnset: "_4bfu1snc _1hmsagmp _ajmmvv82 _1a3b1r31 _4fprglyw _5goinqa1 _9oik1r31 _1bnxglyw _jf4cnqa1 _1nrm1r31 _c2waglyw _1iohnqa1",
    disabled: "_80om13gf _bfhksyzs _syaz1lh4 _aetrglyw _irr3syzs _30l31lh4 _1di6syzs _9h8h1lh4",
    spacingCompact: "_1rjcv77o _gy1p1b66 _4t3i1k8s _y4tiutpp _bozgutpp _s7n4nkob",
    buttonIconBefore: "_bozgu2gc",
    buttonIconAfter: "_y4tiu2gc"
};
var $e00b28d149aa4f91$var$defaultStyles = {
    root: "_bfhk1j54 _syaz10s3 _105310s3 _f8pj10s3 _irr3yw9d _30l310s3 _1di6ip91 _9h8h10s3",
    rootRefreshed: "_bfhksm61 _syaz1gjq _8l3mmuej _aetrb3bt _10531gjq _f8pj1gjq _irr3166n _30l31gjq _1di61dty _9h8h1gjq"
};
var $e00b28d149aa4f91$var$primaryStyles = {
    root: "_bfhkomb0 _syaz15cr _105315cr _f8pj15cr _30l315cr _irr31wqm _9h8h15cr _1di617hq"
};
var $e00b28d149aa4f91$var$warningStyles = {
    root: "_bfhk1ikc _syazal3n _1053al3n _f8pjal3n _30l3al3n _irr31j43 _9h8hal3n _1di6h4op"
};
var $e00b28d149aa4f91$var$dangerStyles = {
    root: "_bfhk1v7l _syaz15cr _105315cr _f8pj15cr _30l315cr _irr31rwk _9h8h15cr _1di6yycf"
};
var $e00b28d149aa4f91$var$discoveryStyles = {
    root: "_bfhk1vbi _syaz15cr _105315cr _f8pj15cr _30l315cr _irr37gr8 _9h8h15cr _1di61wu2"
};
var $e00b28d149aa4f91$var$subtleStyles = {
    root: "_bfhkqtfy _syaz10s3 _105310s3 _f8pj10s3 _irr34mfv _30l310s3 _1di619qy _9h8h10s3",
    rootRefreshed: "_bfhkqtfy _syaz1gjq _10531gjq _f8pj1mjl _irr34mfv _30l31gjq _1di619qy _9h8h1gjq"
};
var $e00b28d149aa4f91$var$selectedStyles = {
    root: "_bfhk7btw _syaz1pke _10531pke _f8pj1pke _irr3i1yw _30l31pke _1di619ru _9h8h1pke",
    rootRefreshed: "_bfhkfg4m _syaz1ldt _8l3mcoux _aetrb3bt _10531ldt _f8pj1ldt _30l31ldt _9h8h1ldt",
    warning: "_bfhkvdtc _syaz16q2 _30l31pke _irr3vdtc _9h8h1pke _1di6vdtc",
    danger: "_bfhkbeib _syaz1pke _30l31pke _irr3beib _9h8h1pke _1di6beib",
    discovery: "_bfhk1g49 _syaz1pke _30l31pke _irr31g49 _9h8h1pke _1di61g49"
};
/**
 * __Link Button__
 *
 * Renders a link in the style of a button.
 *
 * - [Examples](https://atlassian.design/components/link-button/examples)
 * - [Code](https://atlassian.design/components/link-button/code)
 * - [Usage](https://atlassian.design/components/link-button/usage)
 */ var $e00b28d149aa4f91$var$LinkButtonBase = function LinkButtonBase(_ref, ref) {
    var analyticsContext = _ref.analyticsContext, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "default" : _ref$appearance, ariaLabel = _ref["aria-label"], ariaLabelledBy = _ref["aria-labelledby"], _ref$autoFocus = _ref.autoFocus, autoFocus = _ref$autoFocus === void 0 ? false : _ref$autoFocus, children = _ref.children, href = _ref.href, iconAfter = _ref.iconAfter, iconBefore = _ref.iconBefore, interactionName = _ref.interactionName, isDisabled = _ref.isDisabled, isSelected = _ref.isSelected, onClick = _ref.onClick, onClickCapture = _ref.onClickCapture, onKeyDownCapture = _ref.onKeyDownCapture, onKeyUpCapture = _ref.onKeyUpCapture, onMouseDownCapture = _ref.onMouseDownCapture, onMouseUpCapture = _ref.onMouseUpCapture, onPointerDownCapture = _ref.onPointerDownCapture, onPointerUpCapture = _ref.onPointerUpCapture, onTouchEndCapture = _ref.onTouchEndCapture, onTouchStartCapture = _ref.onTouchStartCapture, spacing = _ref.spacing, testId = _ref.testId, unsafeRest = (0, (/*@__PURE__*/$parcel$interopDefault($ikhrG)))(_ref, $e00b28d149aa4f91$var$_excluded);
    // @ts-expect-error
    var _className = unsafeRest.className, _css = unsafeRest.css, _as = unsafeRest.as, _style = unsafeRest.style, saferRest = (0, (/*@__PURE__*/$parcel$interopDefault($ikhrG)))(unsafeRest, $e00b28d149aa4f91$var$_excluded2);
    var hasIconAfter = Boolean(iconAfter);
    var hasIconBefore = Boolean(iconBefore);
    var localRef = (0, $dAx5m.useRef)(null);
    (0, $aINwx.default)(localRef, autoFocus);
    var combinedRef = (0, $jPkgn.default)([
        localRef,
        ref
    ]);
    return /*#__PURE__*/ $dAx5m.createElement((0, $bzvfB.default), (0, (/*@__PURE__*/$parcel$interopDefault($lDu5G)))({
        analyticsContext: analyticsContext,
        ref: combinedRef,
        href: isDisabled ? undefined : href,
        role: isDisabled ? "link" : undefined,
        "aria-disabled": isDisabled === true ? true : undefined,
        "aria-label": ariaLabel,
        "aria-labelledby": ariaLabelledBy,
        onClick: onClick,
        onClickCapture: onClickCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onTouchEndCapture: onTouchEndCapture,
        onTouchStartCapture: onTouchStartCapture,
        testId: testId,
        componentName: "LinkButton",
        interactionName: interactionName
    }, saferRest, {
        xcss: (0, $fTztV.cx)($e00b28d149aa4f91$var$styles.base, appearance === "default" && ((0, $18rB9.fg)("platform-component-visual-refresh") ? $e00b28d149aa4f91$var$defaultStyles.rootRefreshed : $e00b28d149aa4f91$var$defaultStyles.root), appearance === "primary" && $e00b28d149aa4f91$var$primaryStyles.root, appearance === "warning" && $e00b28d149aa4f91$var$warningStyles.root, appearance === "danger" && $e00b28d149aa4f91$var$dangerStyles.root, appearance === "discovery" && $e00b28d149aa4f91$var$discoveryStyles.root, appearance === "subtle" && ((0, $18rB9.fg)("platform-component-visual-refresh") ? $e00b28d149aa4f91$var$subtleStyles.rootRefreshed : $e00b28d149aa4f91$var$subtleStyles.root), $e00b28d149aa4f91$var$styles.linkDecorationUnset, isSelected && ((0, $18rB9.fg)("platform-component-visual-refresh") ? $e00b28d149aa4f91$var$selectedStyles.rootRefreshed : $e00b28d149aa4f91$var$selectedStyles.root), // TODO: remove me once we kill color fallbacks
        isSelected && appearance === "danger" && $e00b28d149aa4f91$var$selectedStyles.danger, // TODO: remove me once we kill color fallbacks
        isSelected && appearance === "warning" && $e00b28d149aa4f91$var$selectedStyles.warning, // TODO: remove me once we kill color fallbacks
        isSelected && appearance === "discovery" && $e00b28d149aa4f91$var$selectedStyles.discovery, isDisabled && $e00b28d149aa4f91$var$styles.disabled, spacing === "compact" && $e00b28d149aa4f91$var$styles.spacingCompact, hasIconBefore && $e00b28d149aa4f91$var$styles.buttonIconBefore, hasIconAfter && $e00b28d149aa4f91$var$styles.buttonIconAfter)
    }), iconBefore && /*#__PURE__*/ $dAx5m.createElement((0, $faTCN.default), {
        type: "icon",
        position: "before",
        isLoading: false
    }, /*#__PURE__*/ $dAx5m.createElement((0, $2MQ4R.default), {
        icon: iconBefore
    })), children && /*#__PURE__*/ $dAx5m.createElement((0, $faTCN.default), {
        isLoading: false
    }, children), iconAfter && /*#__PURE__*/ $dAx5m.createElement((0, $faTCN.default), {
        type: "icon",
        position: "after",
        isLoading: false
    }, /*#__PURE__*/ $dAx5m.createElement((0, $2MQ4R.default), {
        icon: iconAfter
    })));
};
// Workarounds to support generic types with forwardRef
/**
 * __Link Button__
 *
 * Renders a link in the style of a button.
 *
 * - [Examples](https://atlassian.design/components/link-button/examples)
 * - [Code](https://atlassian.design/components/link-button/code)
 * - [Usage](https://atlassian.design/components/link-button/usage)
 */ var $e00b28d149aa4f91$var$LinkButton = /*#__PURE__*/ (0, $dAx5m.forwardRef)($e00b28d149aa4f91$var$LinkButtonBase);
$e00b28d149aa4f91$var$LinkButton.displayName = "LinkButton";
var $e00b28d149aa4f91$export$2e2bcd8739ae039 = $e00b28d149aa4f91$var$LinkButton;

});
parcelRegister("bzvfB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $86cb344d3ad04670$export$2e2bcd8739ae039; });
/* anchor.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $lDu5G = parcelRequire("lDu5G");

var $5RAei = parcelRequire("5RAei");

var $ikhrG = parcelRequire("ikhrG");

var $dAx5m = parcelRequire("dAx5m");


var $fJHBw = parcelRequire("fJHBw");

var $3P18c = parcelRequire("3P18c");

var $aadHU = parcelRequire("aadHU");

var $NwIp5 = parcelRequire("NwIp5");

var $2NfKg = parcelRequire("2NfKg");

var $bEvp9 = parcelRequire("bEvp9");

var $4mhQ1 = parcelRequire("4mhQ1");

var $dfmtY = parcelRequire("dfmtY");

var $kyNNs = parcelRequire("kyNNs");
var $86cb344d3ad04670$var$_excluded = [
    "href",
    "children",
    "onClick",
    "interactionName",
    "componentName",
    "analyticsContext",
    "aria-label",
    "aria-labelledby",
    "style",
    "target",
    "testId",
    "xcss",
    "newWindowLabel"
], $86cb344d3ad04670$var$_excluded2 = [
    "className"
];
var $86cb344d3ad04670$var$styles = {
    root: "_4bfu1r31 _1hms8stv _ajmmnqa1 _vchhusvi"
};
var $86cb344d3ad04670$var$IS_EXTERNAL_LINK_REGEX = /^(?:(http|https):\/\/)/;
var $86cb344d3ad04670$var$IS_NON_HTTP_BASED = /^(((mailto|tel|sms|blob):)|(#))/;
/**
 * __Anchor__
 *
 * A primitive for building custom anchor links.
 *
 * - [Examples](https://atlassian.design/components/primitives/anchor/examples)
 * - [Code](https://atlassian.design/components/primitives/anchor/code)
 * - [Usage](https://atlassian.design/components/primitives/anchor/usage)
 */ var $86cb344d3ad04670$var$AnchorNoRef = function AnchorNoRef(_ref, ref) {
    var href = _ref.href, children = _ref.children, _ref$onClick = _ref.onClick, providedOnClick = _ref$onClick === void 0 ? (0, $2NfKg.default) : _ref$onClick, interactionName = _ref.interactionName, componentName = _ref.componentName, analyticsContext = _ref.analyticsContext, ariaLabel = _ref["aria-label"], ariaLabelledBy = _ref["aria-labelledby"], style = _ref.style, target = _ref.target, testId = _ref.testId, xcss = _ref.xcss, _ref$newWindowLabel = _ref.newWindowLabel, newWindowLabel = _ref$newWindowLabel === void 0 ? "(opens new window)" : _ref$newWindowLabel, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($ikhrG)))(_ref, $86cb344d3ad04670$var$_excluded);
    var interactionContext = (0, $dAx5m.useContext)((0, $4mhQ1.default));
    var handleClick = (0, $dAx5m.useCallback)(function(e, analyticsEvent) {
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    var opensNewWindowLabelId = (0, $bEvp9.useId)();
    var onClick = (0, $aadHU.usePlatformLeafEventHandler)({
        fn: handleClick,
        action: "clicked",
        componentName: componentName || "Anchor",
        packageName: "@atlaskit/primitives",
        packageVersion: "14.4.0",
        analyticsData: analyticsContext,
        actionSubject: "link"
    });
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($ikhrG)))(htmlAttributes, $86cb344d3ad04670$var$_excluded2);
    var RouterLink = (0, $NwIp5.default)();
    var isExternal = typeof href === "string" && $86cb344d3ad04670$var$IS_EXTERNAL_LINK_REGEX.test(href);
    var isNonHttpBased = typeof href === "string" && $86cb344d3ad04670$var$IS_NON_HTTP_BASED.test(href);
    /**
   * Renders a router link if:
   *
   * - a link component is set in the app provider
   * - it's not an external link (starting with `http://` or `https://`)
   * - it's not a non-HTTP-based link (e.g. emails, phone numbers, hash links etc.).
   */ var isRouterLink = RouterLink && !isExternal && !isNonHttpBased;
    var hrefObjectUsedWithoutRouterLink = RouterLink === undefined && (0, (/*@__PURE__*/$parcel$interopDefault($5RAei)))(href) === "object";
    (0, $3P18c.default)(!hrefObjectUsedWithoutRouterLink, "@atlaskit/primitives: Anchor primitive cannot pass an object to 'href' unless a router link is configured in the AppProvider");
    var Component = isRouterLink ? RouterLink : "a";
    return /*#__PURE__*/ $dAx5m.createElement((0, $kyNNs.default), (0, (/*@__PURE__*/$parcel$interopDefault($lDu5G)))({
        as: Component,
        className: xcss,
        style: style,
        ref: ref
    }, safeHtmlAttributes, {
        href: !isRouterLink && typeof href !== "string" ? undefined : href,
        target: target,
        onClick: onClick,
        "aria-label": ariaLabel && target === "_blank" && !ariaLabelledBy ? "".concat(ariaLabel, " , ").concat(newWindowLabel) : ariaLabel,
        "aria-labelledby": ariaLabelledBy && target === "_blank" ? "".concat(ariaLabelledBy, " ").concat(opensNewWindowLabelId) : ariaLabelledBy,
        xcss: (0, $fJHBw.cx)($86cb344d3ad04670$var$styles.root, xcss),
        testId: testId,
        "data-is-router-link": testId ? isRouterLink ? "true" : "false" : undefined
    }), children, target === "_blank" && (children && !ariaLabel && !ariaLabelledBy || ariaLabelledBy) && /*#__PURE__*/ $dAx5m.createElement((0, $dfmtY.default), {
        id: opensNewWindowLabelId
    }, ", ".concat(newWindowLabel)));
};
// Workarounds to support generic types with forwardRef
/**
 * __Anchor__
 *
 * Anchor is a primitive for building custom anchor links. It's a wrapper around the HTML `<a>` element that provides a consistent API for handling client-side routing and Atlassian Design System styling.
 *
 * - [Examples](https://atlassian.design/components/primitives/anchor/examples)
 * - [Code](https://atlassian.design/components/primitives/anchor/code)
 * - [Usage](https://atlassian.design/components/primitives/anchor/usage)
 */ var $86cb344d3ad04670$var$Anchor = /*#__PURE__*/ (0, $dAx5m.forwardRef)($86cb344d3ad04670$var$AnchorNoRef);
var $86cb344d3ad04670$export$2e2bcd8739ae039 = $86cb344d3ad04670$var$Anchor;

});
parcelRegister("NwIp5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $094df445e637c095$export$2e2bcd8739ae039; });

var $dAx5m = parcelRequire("dAx5m");

var $4FizR = parcelRequire("4FizR");
/**
 * __useRouterLink()__
 *
 * Hook: Returns app-configured router link component.
 *
 * A generic can be passed to define advanced link configuration:
 * ```
 * type MyRouterLinkConfig = {
 *  to: string;
 *  replace?: boolean;
 * }
 *
 * const RouterLink = useRouterLink<MyRouterLinkConfig>();
 * ```
 */ var $094df445e637c095$var$useRouterLink = function useRouterLink() {
    var _useContext = (0, $dAx5m.useContext)((0, $4FizR.RouterLinkProviderContext)), routerLinkComponent = _useContext.routerLinkComponent;
    if (routerLinkComponent) return routerLinkComponent;
};
var $094df445e637c095$export$2e2bcd8739ae039 = $094df445e637c095$var$useRouterLink;

});
parcelRegister("4FizR", function(module, exports) {

$parcel$export(module.exports, "RouterLinkProviderContext", function () { return $365966d1d471e1b2$export$2931e0ee690eee88; });

var $dAx5m = parcelRequire("dAx5m");
var $365966d1d471e1b2$export$2931e0ee690eee88 = /*#__PURE__*/ (0, $dAx5m.createContext)({});
/**
 * __RouterLinkProvider__
 *
 * Provides a configured router link component for use
 * within Design System components.
 */ var $365966d1d471e1b2$var$RouterLinkProvider = function RouterLinkProvider(_ref) {
    var routerLinkComponent = _ref.routerLinkComponent, children = _ref.children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement($365966d1d471e1b2$export$2931e0ee690eee88.Provider, {
        value: {
            routerLinkComponent: routerLinkComponent
        }
    }, children);
};
var $365966d1d471e1b2$export$2e2bcd8739ae039 = $365966d1d471e1b2$var$RouterLinkProvider;

});




parcelRegister("jAH5d", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e432cc890566b186$export$2e2bcd8739ae039; });
var $e432cc890566b186$export$2e2bcd8739ae039 = "data:image/svg+xml;base64,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";

});

parcelRegister("2cxIB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $19a6db8d75406820$export$2e2bcd8739ae039; });
var $19a6db8d75406820$export$2e2bcd8739ae039 = "data:image/svg+xml;base64,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";

});

parcelRegister("5qE33", function(module, exports) {

$parcel$export(module.exports, "getLoginUrl", function () { return $3f3e7233120678d1$export$8abe2e83e8d74da2; });

var $jXZjr = parcelRequire("jXZjr");
var $3f3e7233120678d1$export$7dc6752a22ab011a = /*#__PURE__*/ function(Environment) {
    Environment["Staging"] = "stg";
    Environment["Production"] = "prod";
    return Environment;
}({});
var $3f3e7233120678d1$export$186d9db1ec46a9ca = function getEnvName() {
    var _window;
    var origin = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (_window = window) === null || _window === void 0 || (_window = _window.location) === null || _window === void 0 ? void 0 : _window.origin;
    return [
        "https://trello.com"
    ].includes(origin) ? $3f3e7233120678d1$export$7dc6752a22ab011a.Production : $3f3e7233120678d1$export$7dc6752a22ab011a.Staging;
};
var $3f3e7233120678d1$var$getProduct = function getProduct(product) {
    if (product) {
        var lowerJira = (0, $jXZjr.Product).JIRA.toLowerCase();
        var lowerProduct = product.toLowerCase();
        if (lowerProduct.includes(lowerJira)) return lowerJira;
        return lowerProduct;
    }
};
var $3f3e7233120678d1$export$8abe2e83e8d74da2 = function getLoginUrl(productType) {
    var env = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $3f3e7233120678d1$export$186d9db1ec46a9ca();
    var continueUrl = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : String(window.location);
    var loginHint = arguments.length > 3 ? arguments[3] : undefined;
    var baseUrl = env === $3f3e7233120678d1$export$7dc6752a22ab011a.Production ? "https://id.atlassian.com/login" : "https://id.stg.internal.atlassian.com/login";
    var product = $3f3e7233120678d1$var$getProduct(productType);
    return "".concat(baseUrl, "?continue=").concat(encodeURIComponent(continueUrl)).concat(product ? "&application=".concat(encodeURIComponent(product)) : "", "\n  ").concat(loginHint ? "&login_hint=".concat(encodeURIComponent(loginHint)) : "");
};

});

parcelRegister("e73p3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a4645bf003a5d843$export$2e2bcd8739ae039; });

var $lKhJJ = parcelRequire("lKhJJ");
var $a4645bf003a5d843$var$messages = (0, $lKhJJ.defineMessages)({
    emptyStateExploreProductsTitle: {
        id: "fabric.atlassianSwitcher.emptyState.exploreProducts.title",
        defaultMessage: "Get started with cloud",
        description: "The title text for the empty state explore products content, which prompts users to try new products."
    },
    emptyStateExploreProductsBody: {
        id: "fabric.atlassianSwitcher.emptyState.exploreProducts.body",
        defaultMessage: "Try a product to start collaborating with your team.",
        description: "The body text for the empty state explore products content, which prompts users to try new products."
    },
    emptyStateExploreProductsLink: {
        id: "fabric.atlassianSwitcher.emptyState.exploreProducts.link",
        defaultMessage: "Explore products",
        description: "The text for the empty state explore products link, which prompts users to try new products."
    },
    home: {
        id: "fabric.atlassianSwitcher.atlassianHome",
        defaultMessage: "Home",
        description: "The text of a link redirecting the user to the Home site"
    },
    atlassianHome: {
        id: "fabric.atlassianSwitcher.home",
        defaultMessage: "Atlassian Home",
        description: "The text of a link redirecting the user to the Home site"
    },
    atlassianStart: {
        id: "fabric.atlassianSwitcher.start",
        defaultMessage: "Atlassian Start",
        description: "The text of a link redirecting the user to the Start site"
    },
    assets: {
        id: "fabric.atlassianSwitcher.assets",
        defaultMessage: "Assets",
        description: "The text of a link redirecting the user to the Assets"
    },
    analytics: {
        id: "fabric.atlassianSwitcher.analytics",
        defaultMessage: "Analytics",
        description: "The text of a link redirecting the user to the Analytics"
    },
    companyHub: {
        id: "fabric.atlassianSwitcher.companyHub",
        defaultMessage: "Company Hub",
        description: "The text of a link redirecting the user to the Company Hub"
    },
    goals: {
        id: "fabric.atlassianSwitcher.goals",
        defaultMessage: "Goals",
        description: "The text of a link redirecting the user to the Goals"
    },
    teams: {
        id: "fabric.atlassianSwitcher.teams",
        defaultMessage: "Teams",
        description: "The text of a link redirecting the user to the Teams"
    },
    search: {
        id: "fabric.atlassianSwitcher.search",
        defaultMessage: "Search",
        description: "The text of a link redirecting the user to the Search"
    },
    chat: {
        id: "fabric.atlassianSwitcher.chat",
        defaultMessage: "Chat",
        description: "The text of a link redirecting the user to the Chat"
    },
    studio: {
        id: "fabric.atlassianSwitcher.studio",
        defaultMessage: "Studio",
        description: "The text of a link redirecting the user to the Studio"
    },
    more: {
        id: "fabric.atlassianSwitcher.more",
        defaultMessage: "More",
        description: "In a context in which users are able to view predefined custom links, this text is the title of the section displaying all existing custom links."
    },
    manageList: {
        id: "fabric.atlassianSwitcher.manageList",
        defaultMessage: "Manage list",
        description: "This text is for the action for a user to manage the values present in an editable list of links."
    },
    jiraProject: {
        id: "fabric.atlassianSwitcher.jiraProject",
        defaultMessage: "Jira project",
        description: "In a context in which several items are listed , this text describes that the specific type of a given item is a Jira project"
    },
    confluenceSpace: {
        id: "fabric.atlassianSwitcher.confluenceSpace",
        defaultMessage: "Confluence space",
        description: "In a context in which several items are listed , this text describes that the specific type of a given item is a Confluence space"
    },
    errorEmptyPartialResults: {
        id: "fabric.atlassianSwitcher.errorEmptyPartialResults",
        defaultMessage: "We can't display your apps right now.",
        description: "Heading of the error message when available apps returns a partial result and no sites"
    },
    errorHeading: {
        id: "fabric.atlassianSwitcher.errorHeading",
        defaultMessage: "Something\u2019s gone wrong",
        description: "Heading of the error screen which is shown when an unknown error happens in the Atlassian Switcher. Usually due to failed network requests."
    },
    errorText: {
        id: "fabric.atlassianSwitcher.errorText",
        defaultMessage: "We keep track of these errors, but feel free to contact us if refreshing doesn\u2019t fix things",
        description: "Text that is displayed when an unknown error happens in the Atlassian Switcher."
    },
    errorImageAltText: {
        id: "fabric.atlassianSwitcher.errorImageAltText",
        defaultMessage: "A broken robot and a number of people busy fixing it.",
        description: "Text displayed as alt text when an error occurs in the Atlassian Switcher"
    },
    errorTextNetwork: {
        id: "fabric.atlassianSwitcher.errorTextNetwork",
        defaultMessage: "We couldn\u2019t load this list. Please reload the page and try again.",
        description: "Text that is displayed when we detect a network issue."
    },
    errorHeadingLoggedOut: {
        id: "fabric.atlassianSwitcher.errorHeadingLoggedOut",
        defaultMessage: "Your Atlassian account is logged out",
        description: "Heading of the error screen which is shown when an unknown error happens in the Atlassian Switcher. Usually due to failed network requests."
    },
    errorTextLoggedOut: {
        id: "fabric.atlassianSwitcher.errorTextLoggedOut",
        defaultMessage: "Log in again to use the Atlassian\xa0switcher.",
        description: "Text that is displayed when we detect user is logged out."
    },
    errorHeadingUnverified: {
        id: "fabric.atlassianSwitcher.errorHeadingUnverified",
        defaultMessage: "Your account is unverified",
        description: "Heading that is displayed when we detect user account is unverified."
    },
    errorPartialResults: {
        id: "fabric.atlassianSwitcher.errorPartialResults",
        defaultMessage: "We can't display some of your apps right now.",
        description: "Heading of the error message when available apps returns a partial result and 1 or more sites"
    },
    errorPartialResultsRefresh: {
        id: "fabric.atlassianSwitcher.errorPartialResultsRefresh",
        defaultMessage: "Refresh the page, or try again later.",
        description: "Subtitle of the error message when available products returns a partial result"
    },
    errorTextUnverified: {
        id: "fabric.atlassianSwitcher.errorTextUnverified",
        defaultMessage: "Please confirm your email address to view a list of available products.",
        description: "Text that is displayed when we detect user account is unverified."
    },
    login: {
        id: "fabric.atlassianSwitcher.login",
        defaultMessage: "Log in",
        description: "Text in log in button."
    },
    productDescriptionConfluence: {
        id: "fabric.atlassianSwitcher.product.description.confluence",
        defaultMessage: "Document collaboration",
        description: "Text displayed under the Confluence product recommendation."
    },
    productDescriptionJiraServiceManagement: {
        id: "fabric.atlassianSwitcher.product.description.jsm",
        defaultMessage: "Collaborative IT service management",
        description: "Text displayed under the Jira Service Management product recommendation."
    },
    productDescriptionJiraSoftware: {
        id: "fabric.atlassianSwitcher.product.description.jsw",
        defaultMessage: "Project and issue tracking",
        description: "Text displayed under the Jira Software product recommendation."
    },
    productDescriptionOpsgenie: {
        id: "fabric.atlassianSwitcher.product.description.opsgenie",
        defaultMessage: "Modern incident management",
        description: "Text displayed under the Opsgenie product recommendation."
    },
    productDescriptionCompass: {
        id: "fabric.atlassianSwitcher.product.description.compass",
        defaultMessage: "Component manager",
        description: "Text displayed under the Compass product recommendation."
    },
    join: {
        id: "fabric.atlassianSwitcher.join",
        defaultMessage: "Join",
        description: "Section Header in Atlassian Switcher. To set the expectation of what items would be shown in following section. Shown when an user has at least one joinable site via Domain Enabled Sign up with common collaborators."
    }
});
var $a4645bf003a5d843$export$2e2bcd8739ae039 = $a4645bf003a5d843$var$messages;

});

parcelRegister("jnTm7", function(module, exports) {

$parcel$export(module.exports, "SwitcherLoadErrorReason", function () { return $e1cb1acff1be5351$export$2c6136f6e27d3fdd; });
$parcel$export(module.exports, "SwitcherLoadError", function () { return $e1cb1acff1be5351$export$ff0950b3c2e7f03e; });

var $9HWAT = parcelRequire("9HWAT");

var $1xtOA = parcelRequire("1xtOA");

var $kVYWy = parcelRequire("kVYWy");

var $c2AoJ = parcelRequire("c2AoJ");

var $e3Gk1 = parcelRequire("e3Gk1");

var $4huf8 = parcelRequire("4huf8");

var $kNSsc = parcelRequire("kNSsc");

var $eKOS7 = parcelRequire("eKOS7");
function $e1cb1acff1be5351$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $e1cb1acff1be5351$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $e1cb1acff1be5351$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($9HWAT)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $e1cb1acff1be5351$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $e1cb1acff1be5351$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($e3Gk1)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($c2AoJ)))(t, $e1cb1acff1be5351$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($e3Gk1)))(t).constructor) : o.apply(t, e));
}
function $e1cb1acff1be5351$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($e1cb1acff1be5351$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $e1cb1acff1be5351$export$2c6136f6e27d3fdd = /*#__PURE__*/ function(SwitcherLoadErrorReason) {
    SwitcherLoadErrorReason["AVAILABLE_PRODUCTS"] = "availableProducts";
    SwitcherLoadErrorReason["PRODUCT_CONFIGURATION"] = "productConfiguration";
    return SwitcherLoadErrorReason;
}({});
var $e1cb1acff1be5351$export$ff0950b3c2e7f03e = /*#__PURE__*/ function(_Error) {
    function SwitcherLoadError(errorReason, resultError) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($1xtOA)))(this, SwitcherLoadError);
        _this = $e1cb1acff1be5351$var$_callSuper(this, SwitcherLoadError);
        _this.errorReason = errorReason;
        _this.resultError = resultError;
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($4huf8)))(SwitcherLoadError, _Error);
    return (0, (/*@__PURE__*/$parcel$interopDefault($kVYWy)))(SwitcherLoadError, [
        {
            key: "reason",
            value: function reason() {
                var potentialResultError = this.resultError;
                return $e1cb1acff1be5351$var$_objectSpread($e1cb1acff1be5351$var$_objectSpread({}, (0, $eKOS7.errorToReason)(potentialResultError.error ? potentialResultError.error : this.resultError)), {}, {
                    source: this.errorReason
                });
            }
        }
    ]);
}(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($kNSsc)))(Error));

});

parcelRegister("52cMQ", function(module, exports) {

var $6aCUT = parcelRequire("6aCUT");
module.exports = $6aCUT("jdTYQ").then(()=>parcelRequire("cSshD"));

});



parcelRegister("4q22m", function(module, exports) {

$parcel$export(module.exports, "useExperienceSuccess", function () { return $337b2baa8ec09342$export$e94f0da4fc0603c6; });
$parcel$export(module.exports, "useExperienceRenderAndMountMark", function () { return $337b2baa8ec09342$export$fb30551804b67d63; });
/* eslint-disable no-console */ 
var $ijEo3 = parcelRequire("ijEo3");

var $dAx5m = parcelRequire("dAx5m");

var $4qUV0 = parcelRequire("4qUV0");
function $337b2baa8ec09342$export$675e0d25df38d426(experienceName, customStartTime) {
    var experienceTracker = (0, $ijEo3.useExperienceTracker)();
    (0, $4qUV0.useOnceImmediately)(function() {
        return experienceTracker.start(experienceName, customStartTime);
    });
}
function $337b2baa8ec09342$export$e94f0da4fc0603c6(experience, attributes) {
    var experienceTracker = (0, $ijEo3.useExperienceTracker)();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    (0, $dAx5m.useLayoutEffect)(function() {
        return experienceTracker.success(experience, attributes);
    }, []);
}
function $337b2baa8ec09342$export$fb30551804b67d63(mark) {
    var experienceTracker = (0, $ijEo3.useExperienceTracker)();
    (0, $4qUV0.useOnceImmediately)(function() {
        return experienceTracker.markStart(mark);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    (0, $dAx5m.useLayoutEffect)(function() {
        return experienceTracker.markEnd(mark);
    }, []);
}

});
parcelRegister("4qUV0", function(module, exports) {

$parcel$export(module.exports, "useSingleton", function () { return $33a5bdef155c880b$export$abf4268d2dd55708; });
$parcel$export(module.exports, "useOnceImmediately", function () { return $33a5bdef155c880b$export$ad4f8d0eee7a0e24; });

var $dAx5m = parcelRequire("dAx5m");
function $33a5bdef155c880b$export$abf4268d2dd55708(builder) {
    var ref = (0, $dAx5m.useRef)();
    if (!ref.current) ref.current = builder();
    return ref.current;
}
function $33a5bdef155c880b$export$ad4f8d0eee7a0e24(callback) {
    var wasCalledRef = (0, $dAx5m.useRef)(false);
    var result = (0, $dAx5m.useRef)();
    if (!wasCalledRef.current) {
        wasCalledRef.current = true;
        result.current = callback();
    }
    return result.current;
}

});



parcelRegister("hMpCI", function(module, exports) {

var $6aCUT = parcelRequire("6aCUT");
module.exports = $6aCUT("5K599").then(()=>parcelRequire("6pTMc"));

});

parcelRegister("8oiqH", function(module, exports) {

var $6aCUT = parcelRequire("6aCUT");
module.exports = Promise.all([
    $6aCUT("6uhRb"),
    $6aCUT("12X0X"),
    $6aCUT("5UXyf")
]).then(()=>parcelRequire("XDDh0"));

});

parcelRegister("bt95C", function(module, exports) {

var $6aCUT = parcelRequire("6aCUT");
module.exports = Promise.all([
    $6aCUT("6uhRb"),
    $6aCUT("12X0X"),
    $6aCUT("6oc1e")
]).then(()=>parcelRequire("dHUgH"));

});

parcelRegister("90zU2", function(module, exports) {

var $6aCUT = parcelRequire("6aCUT");
module.exports = Promise.all([
    $6aCUT("6uhRb"),
    $6aCUT("12X0X"),
    $6aCUT("d4D9N")
]).then(()=>parcelRequire("ffUQJ"));

});


parcelRegister("4vSc6", function(module, exports) {

$parcel$export(module.exports, "performanceNow", function () { return $3494187e424c81c8$export$fb4230f160368c88; });
var $3494187e424c81c8$export$fb4230f160368c88 = typeof window !== "undefined" && window.performance && window.performance.now.bind(performance) || Date.now;

});

parcelRegister("3VCTs", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b06e3bb71d50b255425a97591cf27724>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2dc4dd6820748cb3$var$_react = $2dc4dd6820748cb3$var$_interopRequireDefault((parcelRequire("dAx5m")));

var $2dc4dd6820748cb3$var$_UNSAFE_baseNew = $2dc4dd6820748cb3$var$_interopRequireDefault((parcelRequire("iSHhU")));
function $2dc4dd6820748cb3$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "AppSwitcher".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for app switcher in global product navigation.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $2dc4dd6820748cb3$var$AppSwitcherIcon = (props)=>/*#__PURE__*/ $2dc4dd6820748cb3$var$_react.default.createElement($2dc4dd6820748cb3$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M1.75 3c0-.69.56-1.25 1.25-1.25h2c.69 0 1.25.56 1.25 1.25v2c0 .69-.56 1.25-1.25 1.25H3c-.69 0-1.25-.56-1.25-1.25zm8 0c0-.69.56-1.25 1.25-1.25h2c.69 0 1.25.56 1.25 1.25v2c0 .69-.56 1.25-1.25 1.25h-2c-.69 0-1.25-.56-1.25-1.25zm-8 8c0-.69.56-1.25 1.25-1.25h2c.69 0 1.25.56 1.25 1.25v2c0 .69-.56 1.25-1.25 1.25H3c-.69 0-1.25-.56-1.25-1.25zm8 0c0-.69.56-1.25 1.25-1.25h2c.69 0 1.25.56 1.25 1.25v2c0 .69-.56 1.25-1.25 1.25h-2c-.69 0-1.25-.56-1.25-1.25z"/>`
    }, props));
$2dc4dd6820748cb3$var$AppSwitcherIcon.displayName = "AppSwitcherIcon";
var $2dc4dd6820748cb3$var$_default = module.exports.default = $2dc4dd6820748cb3$var$AppSwitcherIcon;

});

parcelRegister("agI6a", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("h8RhW")).default; });
$parcel$export(module.exports, "FeatureGateEnvironment", function () { return (parcelRequire("3E94U")).FeatureGateEnvironment; });
$parcel$export(module.exports, "PerimeterType", function () { return (parcelRequire("3E94U")).PerimeterType; });
$parcel$export(module.exports, "CLIENT_VERSION", function () { return (parcelRequire("fuICm")).CLIENT_VERSION; });
$parcel$export(module.exports, "DynamicConfig", function () { return (parcelRequire("b1e3j")).DynamicConfig; });
$parcel$export(module.exports, "EvaluationReason", function () { return (parcelRequire("b1e3j")).EvaluationReason; });
parcelRequire("h8RhW");
var $fuICm = parcelRequire("fuICm");
var $h8RhW = parcelRequire("h8RhW");
var $b1e3j = parcelRequire("b1e3j");
var $3E94U = parcelRequire("3E94U");

});
parcelRegister("h8RhW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c7ac8501770c1f13$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "CLIENT_VERSION", function () { return (parcelRequire("fuICm")).CLIENT_VERSION; });

var $9nAUV = parcelRequire("9nAUV");

var $2c9To = parcelRequire("2c9To");

var $7hJEL = parcelRequire("7hJEL");

var $9Ul0s = parcelRequire("9Ul0s");

var $fuICm = parcelRequire("fuICm");

var $b1e3j = parcelRequire("b1e3j");

var $3E94U = parcelRequire("3E94U");
var $c7ac8501770c1f13$var$_FeatureGates;
/**
 * Access the FeatureGates object via the default export.
 * ```ts
 * import FeatureGates from '@atlaskit/feature-gate-js-client';
 * ```
 */ var $c7ac8501770c1f13$var$FeatureGates = /*#__PURE__*/ function() {
    function FeatureGates() {
        (0, (/*@__PURE__*/$parcel$interopDefault($9nAUV)))(this, FeatureGates);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($2c9To)))(FeatureGates, null, [
        {
            key: "isGateExists",
            value: function isGateExists(gateName) {
                return this.client.isGateExist(gateName);
            }
        },
        {
            key: "isExperimentExists",
            value: function isExperimentExists(experimentName) {
                return this.client.isExperimentExist(experimentName);
            }
        }
    ]);
}();
$c7ac8501770c1f13$var$_FeatureGates = $c7ac8501770c1f13$var$FeatureGates;
(0, (/*@__PURE__*/$parcel$interopDefault($7hJEL)))($c7ac8501770c1f13$var$FeatureGates, "client", new (0, $9Ul0s.Client)());
(0, (/*@__PURE__*/$parcel$interopDefault($7hJEL)))($c7ac8501770c1f13$var$FeatureGates, "hasCheckGateErrorOccurred", false);
(0, (/*@__PURE__*/$parcel$interopDefault($7hJEL)))($c7ac8501770c1f13$var$FeatureGates, "hasGetExperimentValueErrorOccurred", false);
(0, (/*@__PURE__*/$parcel$interopDefault($7hJEL)))($c7ac8501770c1f13$var$FeatureGates, "checkGate", function(gateName, options) {
    try {
        // Check if the CRITERION override mechanism is available
        if (window && window.__CRITERION__ && typeof window.__CRITERION__.getFeatureFlagOverride === "function") {
            // Attempt to retrieve an override value for the feature gate
            var overrideValue = window.__CRITERION__.getFeatureFlagOverride(gateName);
            // If an override value is found, return it immediately
            if (overrideValue !== undefined) return overrideValue;
        }
    } catch (error) {
        // Log the first occurrence of the error
        if (!$c7ac8501770c1f13$var$_FeatureGates.hasCheckGateErrorOccurred) {
            // eslint-disable-next-line no-console
            console.warn({
                msg: "An error has occurred checking the feature gate from criterion override. Only the first occurrence of this error is logged.",
                gateName: gateName,
                error: error
            });
            $c7ac8501770c1f13$var$_FeatureGates.hasCheckGateErrorOccurred = true;
        }
    }
    // Proceed with the main logic if no override is found
    return $c7ac8501770c1f13$var$_FeatureGates.client.checkGate(gateName, options);
});
(0, (/*@__PURE__*/$parcel$interopDefault($7hJEL)))($c7ac8501770c1f13$var$FeatureGates, "getExperimentValue", function(experimentName, parameterName, defaultValue, options) {
    try {
        // Check if the CRITERION override mechanism is available
        if (typeof window !== "undefined" && window.__CRITERION__ && typeof window.__CRITERION__.getExperimentValueOverride === "function") {
            var overrideValue = window.__CRITERION__.getExperimentValueOverride(experimentName, parameterName);
            if (overrideValue !== undefined && overrideValue !== null) return overrideValue;
        }
    } catch (error) {
        // Log the first occurrence of the error
        if (!$c7ac8501770c1f13$var$_FeatureGates.hasCheckGateErrorOccurred) {
            // Log the first occurrence of the error
            if (!$c7ac8501770c1f13$var$_FeatureGates.hasGetExperimentValueErrorOccurred) {
                // eslint-disable-next-line no-console
                console.warn({
                    msg: "An error has occurred getting the experiment value from criterion override. Only the first occurrence of this error is logged.",
                    experimentName: experimentName,
                    defaultValue: defaultValue,
                    options: options,
                    error: error
                });
                $c7ac8501770c1f13$var$_FeatureGates.hasGetExperimentValueErrorOccurred = true;
            }
            return defaultValue;
        }
    }
    // Proceed with the main logic if no override is found
    return $c7ac8501770c1f13$var$_FeatureGates.client.getExperimentValue(experimentName, parameterName, defaultValue, options);
});
(0, (/*@__PURE__*/$parcel$interopDefault($7hJEL)))($c7ac8501770c1f13$var$FeatureGates, "initializeCalled", $c7ac8501770c1f13$var$_FeatureGates.client.initializeCalled.bind($c7ac8501770c1f13$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($7hJEL)))($c7ac8501770c1f13$var$FeatureGates, "initializeCompleted", $c7ac8501770c1f13$var$_FeatureGates.client.initializeCompleted.bind($c7ac8501770c1f13$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($7hJEL)))($c7ac8501770c1f13$var$FeatureGates, "initialize", $c7ac8501770c1f13$var$_FeatureGates.client.initialize.bind($c7ac8501770c1f13$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($7hJEL)))($c7ac8501770c1f13$var$FeatureGates, "initializeWithProvider", $c7ac8501770c1f13$var$_FeatureGates.client.initializeWithProvider.bind($c7ac8501770c1f13$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($7hJEL)))($c7ac8501770c1f13$var$FeatureGates, "initializeFromValues", $c7ac8501770c1f13$var$_FeatureGates.client.initializeFromValues.bind($c7ac8501770c1f13$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($7hJEL)))($c7ac8501770c1f13$var$FeatureGates, "manuallyLogGateExposure", $c7ac8501770c1f13$var$_FeatureGates.client.manuallyLogGateExposure.bind($c7ac8501770c1f13$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($7hJEL)))($c7ac8501770c1f13$var$FeatureGates, "getExperiment", $c7ac8501770c1f13$var$_FeatureGates.client.getExperiment.bind($c7ac8501770c1f13$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($7hJEL)))($c7ac8501770c1f13$var$FeatureGates, "manuallyLogExperimentExposure", $c7ac8501770c1f13$var$_FeatureGates.client.manuallyLogExperimentExposure.bind($c7ac8501770c1f13$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($7hJEL)))($c7ac8501770c1f13$var$FeatureGates, "manuallyLogLayerExposure", $c7ac8501770c1f13$var$_FeatureGates.client.manuallyLogLayerExposure.bind($c7ac8501770c1f13$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($7hJEL)))($c7ac8501770c1f13$var$FeatureGates, "shutdownStatsig", $c7ac8501770c1f13$var$_FeatureGates.client.shutdownStatsig.bind($c7ac8501770c1f13$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($7hJEL)))($c7ac8501770c1f13$var$FeatureGates, "overrideGate", $c7ac8501770c1f13$var$_FeatureGates.client.overrideGate.bind($c7ac8501770c1f13$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($7hJEL)))($c7ac8501770c1f13$var$FeatureGates, "clearGateOverride", $c7ac8501770c1f13$var$_FeatureGates.client.clearGateOverride.bind($c7ac8501770c1f13$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($7hJEL)))($c7ac8501770c1f13$var$FeatureGates, "overrideConfig", $c7ac8501770c1f13$var$_FeatureGates.client.overrideConfig.bind($c7ac8501770c1f13$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($7hJEL)))($c7ac8501770c1f13$var$FeatureGates, "clearConfigOverride", $c7ac8501770c1f13$var$_FeatureGates.client.clearConfigOverride.bind($c7ac8501770c1f13$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($7hJEL)))($c7ac8501770c1f13$var$FeatureGates, "setOverrides", $c7ac8501770c1f13$var$_FeatureGates.client.setOverrides.bind($c7ac8501770c1f13$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($7hJEL)))($c7ac8501770c1f13$var$FeatureGates, "getOverrides", $c7ac8501770c1f13$var$_FeatureGates.client.getOverrides.bind($c7ac8501770c1f13$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($7hJEL)))($c7ac8501770c1f13$var$FeatureGates, "clearAllOverrides", $c7ac8501770c1f13$var$_FeatureGates.client.clearAllOverrides.bind($c7ac8501770c1f13$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($7hJEL)))($c7ac8501770c1f13$var$FeatureGates, "isCurrentUser", $c7ac8501770c1f13$var$_FeatureGates.client.isCurrentUser.bind($c7ac8501770c1f13$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($7hJEL)))($c7ac8501770c1f13$var$FeatureGates, "onGateUpdated", $c7ac8501770c1f13$var$_FeatureGates.client.onGateUpdated.bind($c7ac8501770c1f13$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($7hJEL)))($c7ac8501770c1f13$var$FeatureGates, "onExperimentValueUpdated", $c7ac8501770c1f13$var$_FeatureGates.client.onExperimentValueUpdated.bind($c7ac8501770c1f13$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($7hJEL)))($c7ac8501770c1f13$var$FeatureGates, "onAnyUpdated", $c7ac8501770c1f13$var$_FeatureGates.client.onAnyUpdated.bind($c7ac8501770c1f13$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($7hJEL)))($c7ac8501770c1f13$var$FeatureGates, "updateUser", $c7ac8501770c1f13$var$_FeatureGates.client.updateUser.bind($c7ac8501770c1f13$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($7hJEL)))($c7ac8501770c1f13$var$FeatureGates, "updateUserWithProvider", $c7ac8501770c1f13$var$_FeatureGates.client.updateUserWithProvider.bind($c7ac8501770c1f13$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($7hJEL)))($c7ac8501770c1f13$var$FeatureGates, "updateUserWithValues", $c7ac8501770c1f13$var$_FeatureGates.client.updateUserWithValues.bind($c7ac8501770c1f13$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($7hJEL)))($c7ac8501770c1f13$var$FeatureGates, "getPackageVersion", $c7ac8501770c1f13$var$_FeatureGates.client.getPackageVersion.bind($c7ac8501770c1f13$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($7hJEL)))($c7ac8501770c1f13$var$FeatureGates, "getLayer", $c7ac8501770c1f13$var$_FeatureGates.client.getLayer.bind($c7ac8501770c1f13$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($7hJEL)))($c7ac8501770c1f13$var$FeatureGates, "getLayerValue", $c7ac8501770c1f13$var$_FeatureGates.client.getLayerValue.bind($c7ac8501770c1f13$var$_FeatureGates.client));
var $c7ac8501770c1f13$var$boundFGJS = $c7ac8501770c1f13$var$FeatureGates;
// This makes it possible to get a reference to the FeatureGates client at runtime.
// This is important for overriding values in Cypress tests, as there needs to be a
// way to get the exact instance for a window in order to mock some of its methods.
if (typeof window !== "undefined") {
    if (window.__FEATUREGATES_JS__ === undefined) window.__FEATUREGATES_JS__ = $c7ac8501770c1f13$var$FeatureGates;
    else {
        var $c7ac8501770c1f13$var$_boundFGJS, $c7ac8501770c1f13$var$_boundFGJS$getPackage;
        $c7ac8501770c1f13$var$boundFGJS = window.__FEATUREGATES_JS__;
        var $c7ac8501770c1f13$var$boundVersion = (($c7ac8501770c1f13$var$_boundFGJS = $c7ac8501770c1f13$var$boundFGJS) === null || $c7ac8501770c1f13$var$_boundFGJS === void 0 || ($c7ac8501770c1f13$var$_boundFGJS$getPackage = $c7ac8501770c1f13$var$_boundFGJS.getPackageVersion) === null || $c7ac8501770c1f13$var$_boundFGJS$getPackage === void 0 ? void 0 : $c7ac8501770c1f13$var$_boundFGJS$getPackage.call($c7ac8501770c1f13$var$_boundFGJS)) || "4.10.0 or earlier";
        if ($c7ac8501770c1f13$var$boundVersion !== (0, $fuICm.CLIENT_VERSION)) {
            var $c7ac8501770c1f13$var$message = "Multiple versions of FeatureGateClients found on the current page.\n      The currently bound version is ".concat($c7ac8501770c1f13$var$boundVersion, " when module version ").concat((0, $fuICm.CLIENT_VERSION), " was loading.");
            // eslint-disable-next-line no-console
            console.warn($c7ac8501770c1f13$var$message);
        }
    }
}
var /**
 * @property {FeatureGates} FeatureGate default export
 */ $c7ac8501770c1f13$export$2e2bcd8739ae039 = $c7ac8501770c1f13$var$boundFGJS;

});
parcelRegister("9nAUV", function(module, exports) {
function $6d42e609e0061cb2$var$_classCallCheck(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
module.exports = $6d42e609e0061cb2$var$_classCallCheck, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("2c9To", function(module, exports) {

var $AbFKP = parcelRequire("AbFKP");
function $19946032a707df77$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, $AbFKP(o.key), o);
    }
}
function $19946032a707df77$var$_createClass(e, r, t) {
    return r && $19946032a707df77$var$_defineProperties(e.prototype, r), t && $19946032a707df77$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}
module.exports = $19946032a707df77$var$_createClass, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("AbFKP", function(module, exports) {

var $gLgUI = parcelRequire("gLgUI");
var $06cc6ad05ca783ef$var$_typeof = $gLgUI.default;

var $izQKj = parcelRequire("izQKj");
function $06cc6ad05ca783ef$var$toPropertyKey(t) {
    var i = $izQKj(t, "string");
    return "symbol" == $06cc6ad05ca783ef$var$_typeof(i) ? i : i + "";
}
module.exports = $06cc6ad05ca783ef$var$toPropertyKey, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("gLgUI", function(module, exports) {
function $032629eef0ea9a42$var$_typeof(o) {
    "@babel/helpers - typeof";
    return module.exports = $032629eef0ea9a42$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $032629eef0ea9a42$var$_typeof(o);
}
module.exports = $032629eef0ea9a42$var$_typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("izQKj", function(module, exports) {

var $gLgUI = parcelRequire("gLgUI");
var $d8646927bd6a667c$var$_typeof = $gLgUI.default;
function $d8646927bd6a667c$var$toPrimitive(t, r) {
    if ("object" != $d8646927bd6a667c$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $d8646927bd6a667c$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
module.exports = $d8646927bd6a667c$var$toPrimitive, module.exports.__esModule = true, module.exports["default"] = module.exports;

});



parcelRegister("7hJEL", function(module, exports) {

var $AbFKP = parcelRequire("AbFKP");
function $54dd896248d1dddb$var$_defineProperty(e, r, t) {
    return (r = $AbFKP(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
module.exports = $54dd896248d1dddb$var$_defineProperty, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("9Ul0s", function(module, exports) {

$parcel$export(module.exports, "Client", function () { return $7369a36c6f76a89e$export$1f2bb630327ac4b6; });

var $907WG = parcelRequire("907WG");

var $5mLfW = parcelRequire("5mLfW");

var $9nAUV = parcelRequire("9nAUV");

var $2c9To = parcelRequire("2c9To");

var $7hJEL = parcelRequire("7hJEL");

var $3rY0i = parcelRequire("3rY0i");

var $b1e3j = parcelRequire("b1e3j");

var $gWA6f = parcelRequire("gWA6f");

var $bMTrr = parcelRequire("bMTrr");

var $3E94U = parcelRequire("3E94U");

var $g8lao = parcelRequire("g8lao");

var $fuICm = parcelRequire("fuICm");
function $7369a36c6f76a89e$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $7369a36c6f76a89e$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $7369a36c6f76a89e$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($7hJEL)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $7369a36c6f76a89e$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $7369a36c6f76a89e$var$DEFAULT_CLIENT_KEY = "client-default-key";
// default event logging api is Atlassian proxy rather than Statsig's domain, to avoid ad blockers
var $7369a36c6f76a89e$var$DEFAULT_EVENT_LOGGING_API = "https://xp.atlassian.com/v1/";
var $7369a36c6f76a89e$export$1f2bb630327ac4b6 = /*#__PURE__*/ function() {
    function Client() {
        (0, (/*@__PURE__*/$parcel$interopDefault($9nAUV)))(this, Client);
        (0, (/*@__PURE__*/$parcel$interopDefault($7hJEL)))(this, "initPromise", null);
        /** True if an initialize method was called and completed successfully. */ (0, (/*@__PURE__*/$parcel$interopDefault($7hJEL)))(this, "initCompleted", false);
        /**
     * True if an initialize method was called and completed, meaning the client is now usable.
     * However if there was an error during initialization it may have initialized with default
     * values. Use {@link initCompleted} to check for this.
     */ (0, (/*@__PURE__*/$parcel$interopDefault($7hJEL)))(this, "initWithDefaults", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($7hJEL)))(this, "hasCheckGateErrorOccurred", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($7hJEL)))(this, "hasGetExperimentErrorOccurred", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($7hJEL)))(this, "hasGetExperimentValueErrorOccurred", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($7hJEL)))(this, "hasGetLayerErrorOccurred", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($7hJEL)))(this, "hasGetLayerValueErrorOccurred", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($7hJEL)))(this, "subscriptions", new (0, $gWA6f.default)());
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($2c9To)))(Client, [
        {
            key: "initialize",
            value: /**
     * @description
     * This method initializes the client using a network call to fetch the bootstrap values.
     * If the client is inialized with an `analyticsWebClient`, it will send an operational event
     * to GASv3 with the following attributes:
     * - targetApp: the target app of the client
     * - clientVersion: the version of the client
     * - success: whether the initialization was successful
     * - startTime: the time when the initialization started
     * - totalTime: the total time it took to initialize the client
     * - apiKey: the api key used to initialize the client
     * @param clientOptions {ClientOptions}
     * @param identifiers {Identifiers}
     * @param customAttributes {CustomAttributes}
     * @returns {Promise<void>}
     */ function() {
                var _initialize = (0, (/*@__PURE__*/$parcel$interopDefault($5mLfW)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3rY0i))).mark(function _callee(clientOptions, identifiers, customAttributes) {
                    var _this = this;
                    var clientOptionsWithDefaults, startTime;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($3rY0i))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                clientOptionsWithDefaults = (0, $g8lao.getOptionsWithDefaults)(clientOptions);
                                if (!this.initPromise) {
                                    _context.next = 4;
                                    break;
                                }
                                if (!(0, $g8lao.shallowEquals)(clientOptionsWithDefaults, this.initOptions)) // eslint-disable-next-line no-console
                                console.warn("Feature Gates client already initialized with different options. New options were not applied.");
                                return _context.abrupt("return", this.initPromise);
                            case 4:
                                startTime = performance.now();
                                this.initOptions = clientOptionsWithDefaults;
                                this.initPromise = this.init(clientOptionsWithDefaults, identifiers, customAttributes).then(function() {
                                    _this.initCompleted = true;
                                    _this.initWithDefaults = true;
                                }).finally(function() {
                                    var endTime = performance.now();
                                    var totalTime = endTime - startTime;
                                    _this.fireClientEvent(startTime, totalTime, "initialize", _this.initCompleted, clientOptionsWithDefaults.apiKey);
                                });
                                return _context.abrupt("return", this.initPromise);
                            case 8:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this);
                }));
                function initialize(_x, _x2, _x3) {
                    return _initialize.apply(this, arguments);
                }
                return initialize;
            }()
        },
        {
            key: "initializeWithProvider",
            value: function() {
                var _initializeWithProvider = (0, (/*@__PURE__*/$parcel$interopDefault($5mLfW)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3rY0i))).mark(function _callee2(clientOptions, provider, identifiers, customAttributes) {
                    var _this2 = this;
                    var clientOptionsWithDefaults, startTime;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($3rY0i))).wrap(function _callee2$(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                clientOptionsWithDefaults = (0, $g8lao.getOptionsWithDefaults)(clientOptions);
                                if (!this.initPromise) {
                                    _context2.next = 4;
                                    break;
                                }
                                if (!(0, $g8lao.shallowEquals)(clientOptionsWithDefaults, this.initOptions)) // eslint-disable-next-line no-console
                                console.warn("Feature Gates client already initialized with different options. New options were not applied.");
                                return _context2.abrupt("return", this.initPromise);
                            case 4:
                                startTime = performance.now();
                                this.initOptions = clientOptionsWithDefaults;
                                this.provider = provider;
                                this.provider.setClientVersion((0, $fuICm.CLIENT_VERSION));
                                if (this.provider.setApplyUpdateCallback) this.provider.setApplyUpdateCallback(this.applyUpdateCallback);
                                this.initPromise = this.initWithProvider(clientOptionsWithDefaults, provider, identifiers, customAttributes).then(function() {
                                    _this2.initCompleted = true;
                                    _this2.initWithDefaults = true;
                                }).finally(function() {
                                    var endTime = performance.now();
                                    var totalTime = endTime - startTime;
                                    _this2.fireClientEvent(startTime, totalTime, "initializeWithProvider", _this2.initCompleted, provider.getApiKey ? provider.getApiKey() : undefined);
                                });
                                return _context2.abrupt("return", this.initPromise);
                            case 11:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this);
                }));
                function initializeWithProvider(_x4, _x5, _x6, _x7) {
                    return _initializeWithProvider.apply(this, arguments);
                }
                return initializeWithProvider;
            }()
        },
        {
            key: "applyUpdateCallback",
            value: function applyUpdateCallback(experimentsResult) {
                try {
                    if (this.initCompleted || this.initWithDefaults) {
                        (0, (/*@__PURE__*/$parcel$interopDefault($b1e3j))).setInitializeValues(experimentsResult.experimentValues);
                        this.subscriptions.anyUpdated();
                    }
                } catch (error) {
                    // eslint-disable-next-line no-console
                    console.warn("Error when attempting to apply update", error);
                }
            }
        },
        {
            key: "fireClientEvent",
            value: function fireClientEvent(startTime, totalTime, action, success) {
                var _analyticsWebClient, _this3 = this;
                var apiKey = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
                (_analyticsWebClient = this.initOptions.analyticsWebClient) === null || _analyticsWebClient === void 0 || _analyticsWebClient.then(function(analyticsWebClient) {
                    var attributes = $7369a36c6f76a89e$var$_objectSpread({
                        targetApp: _this3.initOptions.targetApp,
                        clientVersion: (0, $fuICm.CLIENT_VERSION),
                        success: success,
                        startTime: startTime,
                        totalTime: totalTime
                    }, apiKey && {
                        apiKey: apiKey
                    });
                    analyticsWebClient.sendOperationalEvent({
                        action: action,
                        actionSubject: "featureGatesClient",
                        attributes: attributes,
                        tags: [
                            "measurement"
                        ],
                        source: "@atlaskit/feature-gate-js-client"
                    });
                }).catch(function(err) {
                    if (_this3.initOptions.environment !== (0, $3E94U.FeatureGateEnvironment).Production) // eslint-disable-next-line no-console
                    console.error("Analytics web client promise did not resolve", err);
                });
            }
        },
        {
            key: "initializeFromValues",
            value: function() {
                var _initializeFromValues = (0, (/*@__PURE__*/$parcel$interopDefault($5mLfW)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3rY0i))).mark(function _callee3(clientOptions, identifiers, customAttributes) {
                    var _this4 = this;
                    var initializeValues, clientOptionsWithDefaults, startTime, _args3 = arguments;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($3rY0i))).wrap(function _callee3$(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                initializeValues = _args3.length > 3 && _args3[3] !== undefined ? _args3[3] : {};
                                clientOptionsWithDefaults = (0, $g8lao.getOptionsWithDefaults)(clientOptions);
                                if (!this.initPromise) {
                                    _context3.next = 5;
                                    break;
                                }
                                if (!(0, $g8lao.shallowEquals)(clientOptionsWithDefaults, this.initOptions)) // eslint-disable-next-line no-console
                                console.warn("Feature Gates client already initialized with different options. New options were not applied.");
                                return _context3.abrupt("return", this.initPromise);
                            case 5:
                                startTime = performance.now();
                                this.initOptions = clientOptionsWithDefaults;
                                this.initPromise = this.initFromValues(clientOptionsWithDefaults, identifiers, customAttributes, initializeValues).then(function() {
                                    _this4.initCompleted = true;
                                    _this4.initWithDefaults = true;
                                }).finally(function() {
                                    var endTime = performance.now();
                                    var totalTime = endTime - startTime;
                                    _this4.fireClientEvent(startTime, totalTime, "initializeFromValues", _this4.initCompleted);
                                });
                                return _context3.abrupt("return", this.initPromise);
                            case 9:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3, this);
                }));
                function initializeFromValues(_x8, _x9, _x10) {
                    return _initializeFromValues.apply(this, arguments);
                }
                return initializeFromValues;
            }()
        },
        {
            key: "updateUser",
            value: function() {
                var _updateUser = (0, (/*@__PURE__*/$parcel$interopDefault($5mLfW)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3rY0i))).mark(function _callee4(fetchOptions, identifiers, customAttributes) {
                    var fetchOptionsWithDefaults, initializeValuesProducer;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($3rY0i))).wrap(function _callee4$(_context4) {
                        while(true)switch(_context4.prev = _context4.next){
                            case 0:
                                fetchOptionsWithDefaults = (0, $g8lao.getOptionsWithDefaults)(fetchOptions);
                                initializeValuesProducer = function initializeValuesProducer() {
                                    return (0, $bMTrr.default).fetchExperimentValues(fetchOptionsWithDefaults, identifiers, customAttributes).then(function(_ref) {
                                        var experimentValues = _ref.experimentValues, customAttributes = _ref.customAttributes;
                                        return {
                                            experimentValues: experimentValues,
                                            customAttributesFromFetch: customAttributes
                                        };
                                    });
                                };
                                _context4.next = 4;
                                return this.updateUserUsingInitializeValuesProducer(initializeValuesProducer, identifiers, customAttributes);
                            case 4:
                            case "end":
                                return _context4.stop();
                        }
                    }, _callee4, this);
                }));
                function updateUser(_x11, _x12, _x13) {
                    return _updateUser.apply(this, arguments);
                }
                return updateUser;
            }()
        },
        {
            key: "updateUserWithProvider",
            value: function() {
                var _updateUserWithProvider = (0, (/*@__PURE__*/$parcel$interopDefault($5mLfW)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3rY0i))).mark(function _callee5(identifiers, customAttributes) {
                    var _this5 = this;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($3rY0i))).wrap(function _callee5$(_context5) {
                        while(true)switch(_context5.prev = _context5.next){
                            case 0:
                                if (this.provider) {
                                    _context5.next = 2;
                                    break;
                                }
                                throw new Error("Cannot update user using provider as the client was not initialised with a provider");
                            case 2:
                                _context5.next = 4;
                                return this.provider.setProfile(this.initOptions, identifiers, customAttributes);
                            case 4:
                                _context5.next = 6;
                                return this.updateUserUsingInitializeValuesProducer(function() {
                                    return _this5.provider.getExperimentValues();
                                }, identifiers, customAttributes);
                            case 6:
                            case "end":
                                return _context5.stop();
                        }
                    }, _callee5, this);
                }));
                function updateUserWithProvider(_x14, _x15) {
                    return _updateUserWithProvider.apply(this, arguments);
                }
                return updateUserWithProvider;
            }()
        },
        {
            key: "updateUserWithValues",
            value: function() {
                var _updateUserWithValues = (0, (/*@__PURE__*/$parcel$interopDefault($5mLfW)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3rY0i))).mark(function _callee6(identifiers, customAttributes) {
                    var initializeValues, initializeValuesProducer, _args6 = arguments;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($3rY0i))).wrap(function _callee6$(_context6) {
                        while(true)switch(_context6.prev = _context6.next){
                            case 0:
                                initializeValues = _args6.length > 2 && _args6[2] !== undefined ? _args6[2] : {};
                                initializeValuesProducer = function initializeValuesProducer() {
                                    return Promise.resolve({
                                        experimentValues: initializeValues,
                                        customAttributesFromFetch: customAttributes
                                    });
                                };
                                _context6.next = 4;
                                return this.updateUserUsingInitializeValuesProducer(initializeValuesProducer, identifiers, customAttributes);
                            case 4:
                            case "end":
                                return _context6.stop();
                        }
                    }, _callee6, this);
                }));
                function updateUserWithValues(_x16, _x17) {
                    return _updateUserWithValues.apply(this, arguments);
                }
                return updateUserWithValues;
            }()
        },
        {
            key: "initializeCalled",
            value: function initializeCalled() {
                return this.initPromise != null;
            }
        },
        {
            key: "initializeCompleted",
            value: function initializeCompleted() {
                return this.initCompleted;
            }
        },
        {
            key: "checkGate",
            value: function checkGate(gateName) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                try {
                    var _options$fireGateExpo = options.fireGateExposure, fireGateExposure = _options$fireGateExpo === void 0 ? true : _options$fireGateExpo;
                    var evalMethod = fireGateExposure ? (0, (/*@__PURE__*/$parcel$interopDefault($b1e3j))).checkGate.bind((0, (/*@__PURE__*/$parcel$interopDefault($b1e3j)))) : (0, (/*@__PURE__*/$parcel$interopDefault($b1e3j))).checkGateWithExposureLoggingDisabled.bind((0, (/*@__PURE__*/$parcel$interopDefault($b1e3j))));
                    return evalMethod(gateName);
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasCheckGateErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: "An error has occurred checking the feature gate. Only the first occurrence of this error is logged.",
                            gateName: gateName,
                            error: error
                        });
                        this.hasCheckGateErrorOccurred = true;
                    }
                    return false;
                }
            }
        },
        {
            key: "isGateExist",
            value: function isGateExist(gateName) {
                try {
                    // @ts-expect-error TS2341: Property _getClientX is private and only accessible within class Statsi
                    var gate = (0, (/*@__PURE__*/$parcel$interopDefault($b1e3j)))._getClientX()._getGateFromStore(gateName);
                    return gate.evaluationDetails.reason !== (0, $b1e3j.EvaluationReason).Unrecognized;
                } catch (error) {
                    // eslint-disable-next-line no-console
                    console.error("Error occurred when trying to check FeatureGate: ".concat(error));
                    // in case of error report true to avoid false positives.
                    return true;
                }
            }
        },
        {
            key: "isExperimentExist",
            value: function isExperimentExist(experimentName) {
                try {
                    var config = (0, (/*@__PURE__*/$parcel$interopDefault($b1e3j))).getExperimentWithExposureLoggingDisabled(experimentName);
                    return config._evaluationDetails.reason !== (0, $b1e3j.EvaluationReason).Unrecognized;
                } catch (error) {
                    // eslint-disable-next-line no-console
                    console.error("Error occurred when trying to check Experiment: ".concat(error));
                    // in case of error report true to avoid false positives.
                    return true;
                }
            }
        },
        {
            key: "manuallyLogGateExposure",
            value: function manuallyLogGateExposure(gateName) {
                (0, (/*@__PURE__*/$parcel$interopDefault($b1e3j))).manuallyLogGateExposure(gateName);
            }
        },
        {
            key: "getExperiment",
            value: function getExperiment(experimentName) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                try {
                    var _options$fireExperime = options.fireExperimentExposure, fireExperimentExposure = _options$fireExperime === void 0 ? true : _options$fireExperime;
                    var evalMethod = fireExperimentExposure ? (0, (/*@__PURE__*/$parcel$interopDefault($b1e3j))).getExperiment.bind((0, (/*@__PURE__*/$parcel$interopDefault($b1e3j)))) : (0, (/*@__PURE__*/$parcel$interopDefault($b1e3j))).getExperimentWithExposureLoggingDisabled.bind((0, (/*@__PURE__*/$parcel$interopDefault($b1e3j))));
                    return evalMethod(experimentName);
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasGetExperimentErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: "An error has occurred getting the experiment. Only the first occurrence of this error is logged.",
                            experimentName: experimentName,
                            error: error
                        });
                        this.hasGetExperimentErrorOccurred = true;
                    }
                    // Return a default value
                    return new (0, $b1e3j.DynamicConfig)(experimentName, {}, "", {
                        time: Date.now(),
                        reason: (0, $b1e3j.EvaluationReason).Error
                    });
                }
            }
        },
        {
            key: "getExperimentValue",
            value: function getExperimentValue(experimentName, parameterName, defaultValue) {
                var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var experiment = this.getExperiment(experimentName, options);
                try {
                    var typeGuard = options.typeGuard;
                    return experiment.get(parameterName, defaultValue, typeGuard);
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasGetExperimentValueErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: "An error has occurred getting the experiment value. Only the first occurrence of this error is logged.",
                            experimentName: experimentName,
                            defaultValue: defaultValue,
                            options: options,
                            error: error
                        });
                        this.hasGetExperimentValueErrorOccurred = true;
                    }
                    return defaultValue;
                }
            }
        },
        {
            key: "manuallyLogExperimentExposure",
            value: function manuallyLogExperimentExposure(experimentName) {
                (0, (/*@__PURE__*/$parcel$interopDefault($b1e3j))).manuallyLogExperimentExposure(experimentName);
            }
        },
        {
            key: "manuallyLogLayerExposure",
            value: function manuallyLogLayerExposure(layerName, parameterName) {
                (0, (/*@__PURE__*/$parcel$interopDefault($b1e3j))).manuallyLogLayerParameterExposure(layerName, parameterName);
            }
        },
        {
            key: "shutdownStatsig",
            value: function shutdownStatsig() {
                (0, (/*@__PURE__*/$parcel$interopDefault($b1e3j))).shutdown();
            }
        },
        {
            key: "overrideGate",
            value: function overrideGate(gateName, value) {
                (0, (/*@__PURE__*/$parcel$interopDefault($b1e3j))).overrideGate(gateName, value);
                this.subscriptions.anyUpdated();
            }
        },
        {
            key: "clearGateOverride",
            value: function clearGateOverride(gateName) {
                (0, (/*@__PURE__*/$parcel$interopDefault($b1e3j))).overrideGate(gateName, null);
                this.subscriptions.anyUpdated();
            }
        },
        {
            key: "overrideConfig",
            value: function overrideConfig(experimentName, values) {
                (0, (/*@__PURE__*/$parcel$interopDefault($b1e3j))).overrideConfig(experimentName, values);
                this.subscriptions.anyUpdated();
            }
        },
        {
            key: "clearConfigOverride",
            value: function clearConfigOverride(experimentName) {
                (0, (/*@__PURE__*/$parcel$interopDefault($b1e3j))).overrideConfig(experimentName, null);
                this.subscriptions.anyUpdated();
            }
        },
        {
            key: "setOverrides",
            value: function setOverrides(overrides) {
                (0, (/*@__PURE__*/$parcel$interopDefault($b1e3j))).setOverrides($7369a36c6f76a89e$var$_objectSpread({
                    gates: {},
                    configs: {},
                    layers: {}
                }, overrides));
                this.subscriptions.anyUpdated();
            }
        },
        {
            key: "getOverrides",
            value: function getOverrides() {
                return (0, (/*@__PURE__*/$parcel$interopDefault($b1e3j))).getOverrides();
            }
        },
        {
            key: "clearAllOverrides",
            value: function clearAllOverrides() {
                (0, (/*@__PURE__*/$parcel$interopDefault($b1e3j))).setOverrides(null);
                this.subscriptions.anyUpdated();
            }
        },
        {
            key: "isCurrentUser",
            value: function isCurrentUser(identifiers, customAttributes) {
                return (0, $g8lao.shallowEquals)(this.currentIdentifiers, identifiers) && (0, $g8lao.shallowEquals)(this.currentAttributes, customAttributes);
            }
        },
        {
            key: "onGateUpdated",
            value: function onGateUpdated(gateName, callback) {
                var _this6 = this;
                var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var wrapCallback = function wrapCallback(value) {
                    var _options$fireGateExpo2 = options.fireGateExposure, fireGateExposure = _options$fireGateExpo2 === void 0 ? true : _options$fireGateExpo2;
                    if (fireGateExposure) _this6.manuallyLogGateExposure(gateName);
                    try {
                        callback(value);
                    } catch (error) {
                        // eslint-disable-next-line no-console
                        console.warn("Error calling callback for gate ".concat(gateName, " with value ").concat(value), error);
                    }
                };
                return this.subscriptions.onGateUpdated(gateName, wrapCallback, this.checkGate.bind(this), options);
            }
        },
        {
            key: "onExperimentValueUpdated",
            value: function onExperimentValueUpdated(experimentName, parameterName, defaultValue, callback) {
                var _this7 = this;
                var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
                var wrapCallback = function wrapCallback(value) {
                    var _options$fireExperime2 = options.fireExperimentExposure, fireExperimentExposure = _options$fireExperime2 === void 0 ? true : _options$fireExperime2;
                    if (fireExperimentExposure) _this7.manuallyLogExperimentExposure(experimentName);
                    try {
                        callback(value);
                    } catch (error) {
                        // eslint-disable-next-line no-console
                        console.warn("Error calling callback for experiment ".concat(experimentName, " with value ").concat(value), error);
                    }
                };
                return this.subscriptions.onExperimentValueUpdated(experimentName, parameterName, defaultValue, wrapCallback, this.getExperimentValue, options);
            }
        },
        {
            key: "onAnyUpdated",
            value: function onAnyUpdated(callback) {
                return this.subscriptions.onAnyUpdated(callback);
            }
        },
        {
            key: "init",
            value: function() {
                var _init = (0, (/*@__PURE__*/$parcel$interopDefault($5mLfW)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3rY0i))).mark(function _callee7(clientOptions, identifiers, customAttributes) {
                    var fromValuesClientOptions, experimentValues, customAttributesFromResult, clientSdkKeyPromise, experimentValuesPromise, _yield$Promise$all, _yield$Promise$all2, experimentValuesResult;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($3rY0i))).wrap(function _callee7$(_context7) {
                        while(true)switch(_context7.prev = _context7.next){
                            case 0:
                                fromValuesClientOptions = $7369a36c6f76a89e$var$_objectSpread({}, clientOptions);
                                _context7.prev = 1;
                                // If client sdk key fetch fails, an error would be thrown and handled instead of waiting for
                                // the experiment values request to be settled, and it will fall back to use default values.
                                clientSdkKeyPromise = (0, $bMTrr.default).fetchClientSdk(clientOptions).then(function(value) {
                                    return fromValuesClientOptions.sdkKey = value.clientSdkKey;
                                });
                                experimentValuesPromise = (0, $bMTrr.default).fetchExperimentValues(clientOptions, identifiers, customAttributes); // Only wait for the experiment values request to finish and try to initialise the client
                                // with experiment values if both requests are successful. Else an error would be thrown and
                                // handled by the catch
                                _context7.next = 6;
                                return Promise.all([
                                    clientSdkKeyPromise,
                                    experimentValuesPromise
                                ]);
                            case 6:
                                _yield$Promise$all = _context7.sent;
                                _yield$Promise$all2 = (0, (/*@__PURE__*/$parcel$interopDefault($907WG)))(_yield$Promise$all, 2);
                                experimentValuesResult = _yield$Promise$all2[1];
                                experimentValues = experimentValuesResult.experimentValues;
                                customAttributesFromResult = experimentValuesResult.customAttributes;
                                _context7.next = 20;
                                break;
                            case 13:
                                _context7.prev = 13;
                                _context7.t0 = _context7["catch"](1);
                                if (_context7.t0 instanceof Error) // eslint-disable-next-line no-console
                                console.error("Error occurred when trying to fetch the Feature Gates client values, error: ".concat(_context7.t0 === null || _context7.t0 === void 0 ? void 0 : _context7.t0.message));
                                // eslint-disable-next-line no-console
                                console.warn("Initialising Statsig client without values");
                                _context7.next = 19;
                                return this.initFromValues(fromValuesClientOptions, identifiers, customAttributes);
                            case 19:
                                throw _context7.t0;
                            case 20:
                                return _context7.abrupt("return", this.initFromValues(fromValuesClientOptions, identifiers, customAttributesFromResult, experimentValues));
                            case 21:
                            case "end":
                                return _context7.stop();
                        }
                    }, _callee7, this, [
                        [
                            1,
                            13
                        ]
                    ]);
                }));
                function init(_x18, _x19, _x20) {
                    return _init.apply(this, arguments);
                }
                return init;
            }()
        },
        {
            key: "initWithProvider",
            value: function() {
                var _initWithProvider = (0, (/*@__PURE__*/$parcel$interopDefault($5mLfW)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3rY0i))).mark(function _callee8(baseClientOptions, provider, identifiers, customAttributes) {
                    var fromValuesClientOptions, experimentValues, customAttributesFromResult, clientSdkKeyPromise, experimentValuesPromise, _yield$Promise$all3, _yield$Promise$all4, experimentValuesResult;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($3rY0i))).wrap(function _callee8$(_context8) {
                        while(true)switch(_context8.prev = _context8.next){
                            case 0:
                                fromValuesClientOptions = $7369a36c6f76a89e$var$_objectSpread($7369a36c6f76a89e$var$_objectSpread({}, baseClientOptions), {}, {
                                    disableCurrentPageLogging: true
                                });
                                _context8.prev = 1;
                                _context8.next = 4;
                                return provider.setProfile(baseClientOptions, identifiers, customAttributes);
                            case 4:
                                // If client sdk key fetch fails, an error would be thrown and handled instead of waiting for
                                // the experiment values request to be settled, and it will fall back to use default values.
                                clientSdkKeyPromise = provider.getClientSdkKey().then(function(value) {
                                    return fromValuesClientOptions.sdkKey = value;
                                });
                                experimentValuesPromise = provider.getExperimentValues(); // Only wait for the experiment values request to finish and try to initialise the client
                                // with experiment values if both requests are successful. Else an error would be thrown and
                                // handled by the catch
                                _context8.next = 8;
                                return Promise.all([
                                    clientSdkKeyPromise,
                                    experimentValuesPromise
                                ]);
                            case 8:
                                _yield$Promise$all3 = _context8.sent;
                                _yield$Promise$all4 = (0, (/*@__PURE__*/$parcel$interopDefault($907WG)))(_yield$Promise$all3, 2);
                                experimentValuesResult = _yield$Promise$all4[1];
                                experimentValues = experimentValuesResult.experimentValues;
                                customAttributesFromResult = experimentValuesResult.customAttributesFromFetch;
                                _context8.next = 22;
                                break;
                            case 15:
                                _context8.prev = 15;
                                _context8.t0 = _context8["catch"](1);
                                if (_context8.t0 instanceof Error) // eslint-disable-next-line no-console
                                console.error("Error occurred when trying to fetch the Feature Gates client values, error: ".concat(_context8.t0 === null || _context8.t0 === void 0 ? void 0 : _context8.t0.message));
                                // eslint-disable-next-line no-console
                                console.warn("Initialising Statsig client without values");
                                _context8.next = 21;
                                return this.initFromValues(fromValuesClientOptions, identifiers, customAttributes);
                            case 21:
                                throw _context8.t0;
                            case 22:
                                return _context8.abrupt("return", this.initFromValues(fromValuesClientOptions, identifiers, customAttributesFromResult, experimentValues));
                            case 23:
                            case "end":
                                return _context8.stop();
                        }
                    }, _callee8, this, [
                        [
                            1,
                            15
                        ]
                    ]);
                }));
                function initWithProvider(_x21, _x22, _x23, _x24) {
                    return _initWithProvider.apply(this, arguments);
                }
                return initWithProvider;
            }()
        },
        {
            key: "initFromValues",
            value: function() {
                var _initFromValues = (0, (/*@__PURE__*/$parcel$interopDefault($5mLfW)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3rY0i))).mark(function _callee9(clientOptions, identifiers, customAttributes) {
                    var initializeValues, user, sdkKey, statsigOptions, _args9 = arguments;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($3rY0i))).wrap(function _callee9$(_context9) {
                        while(true)switch(_context9.prev = _context9.next){
                            case 0:
                                initializeValues = _args9.length > 3 && _args9[3] !== undefined ? _args9[3] : {};
                                user = (0, $g8lao.toStatsigUser)(identifiers, customAttributes);
                                this.currentIdentifiers = identifiers;
                                this.currentAttributes = customAttributes;
                                if (!clientOptions.sdkKey) clientOptions.sdkKey = $7369a36c6f76a89e$var$DEFAULT_CLIENT_KEY;
                                if (!clientOptions.eventLoggingApi) clientOptions.eventLoggingApi = $7369a36c6f76a89e$var$DEFAULT_EVENT_LOGGING_API;
                                if (clientOptions.perimeter === (0, $3E94U.PerimeterType).FEDRAMP_MODERATE) // disable all logging in FedRAMP to prevent egress of sensitive data
                                clientOptions.disableAllLogging = true;
                                sdkKey = clientOptions.sdkKey;
                                statsigOptions = (0, $g8lao.toStatsigOptions)(clientOptions, initializeValues);
                                _context9.prev = 9;
                                _context9.next = 12;
                                return (0, (/*@__PURE__*/$parcel$interopDefault($b1e3j))).initialize(sdkKey, user, statsigOptions);
                            case 12:
                                _context9.next = 22;
                                break;
                            case 14:
                                _context9.prev = 14;
                                _context9.t0 = _context9["catch"](9);
                                if (_context9.t0 instanceof Error) // eslint-disable-next-line no-console
                                console.error("Error occurred when trying to initialise the Statsig client, error: ".concat(_context9.t0 === null || _context9.t0 === void 0 ? void 0 : _context9.t0.message));
                                // eslint-disable-next-line no-console
                                console.warn("Initialising Statsig client with default sdk key and without values");
                                _context9.next = 20;
                                return (0, (/*@__PURE__*/$parcel$interopDefault($b1e3j))).initialize($7369a36c6f76a89e$var$DEFAULT_CLIENT_KEY, user, $7369a36c6f76a89e$var$_objectSpread($7369a36c6f76a89e$var$_objectSpread({}, statsigOptions), {}, {
                                    initializeValues: {}
                                }));
                            case 20:
                                this.initWithDefaults = true;
                                throw _context9.t0;
                            case 22:
                            case "end":
                                return _context9.stop();
                        }
                    }, _callee9, this, [
                        [
                            9,
                            14
                        ]
                    ]);
                }));
                function initFromValues(_x25, _x26, _x27) {
                    return _initFromValues.apply(this, arguments);
                }
                return initFromValues;
            }()
        },
        {
            key: "updateUserUsingInitializeValuesProducer",
            value: function() {
                var _updateUserUsingInitializeValuesProducer = (0, (/*@__PURE__*/$parcel$interopDefault($5mLfW)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3rY0i))).mark(function _callee11(getInitializeValues, identifiers, customAttributes) {
                    var _this8 = this;
                    var originalInitPromise, initializeValuesPromise, updateUserPromise;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($3rY0i))).wrap(function _callee11$(_context11) {
                        while(true)switch(_context11.prev = _context11.next){
                            case 0:
                                if (this.initPromise) {
                                    _context11.next = 2;
                                    break;
                                }
                                throw new Error("The client must be initialized before you can update the user.");
                            case 2:
                                if (!this.isCurrentUser(identifiers, customAttributes)) {
                                    _context11.next = 4;
                                    break;
                                }
                                return _context11.abrupt("return", this.initPromise);
                            case 4:
                                // Wait for the current initialize/update to finish
                                originalInitPromise = this.initPromise;
                                _context11.prev = 5;
                                _context11.next = 8;
                                return this.initPromise;
                            case 8:
                                _context11.next = 12;
                                break;
                            case 10:
                                _context11.prev = 10;
                                _context11.t0 = _context11["catch"](5);
                            case 12:
                                initializeValuesPromise = getInitializeValues();
                                updateUserPromise = this.updateStatsigClientUser(initializeValuesPromise, identifiers, customAttributes); // We replace the init promise here since we are essentially re-initializing the client at this
                                // point. Any subsequent calls to await client.initialize() or client.updateUser()
                                // will now also await this user update.
                                this.initPromise = updateUserPromise.catch(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5mLfW)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3rY0i))).mark(function _callee10() {
                                    return (0, (/*@__PURE__*/$parcel$interopDefault($3rY0i))).wrap(function _callee10$(_context10) {
                                        while(true)switch(_context10.prev = _context10.next){
                                            case 0:
                                                // If the update failed then it changed nothing, so revert back to the original promise.
                                                _this8.initPromise = originalInitPromise;
                                                // Set the user profile again to revert back to the current user
                                                if (!_this8.provider) {
                                                    _context10.next = 4;
                                                    break;
                                                }
                                                _context10.next = 4;
                                                return _this8.provider.setProfile(_this8.initOptions, _this8.currentIdentifiers, _this8.currentAttributes);
                                            case 4:
                                            case "end":
                                                return _context10.stop();
                                        }
                                    }, _callee10);
                                })));
                                return _context11.abrupt("return", updateUserPromise);
                            case 16:
                            case "end":
                                return _context11.stop();
                        }
                    }, _callee11, this, [
                        [
                            5,
                            10
                        ]
                    ]);
                }));
                function updateUserUsingInitializeValuesProducer(_x28, _x29, _x30) {
                    return _updateUserUsingInitializeValuesProducer.apply(this, arguments);
                }
                return updateUserUsingInitializeValuesProducer;
            }()
        },
        {
            key: "updateStatsigClientUser",
            value: function() {
                var _updateStatsigClientUser = (0, (/*@__PURE__*/$parcel$interopDefault($5mLfW)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3rY0i))).mark(function _callee12(initializeValuesPromise, identifiers, customAttributes) {
                    var initializeValues, user, _updateUserCompletion, _ref3, errMsg, success;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($3rY0i))).wrap(function _callee12$(_context12) {
                        while(true)switch(_context12.prev = _context12.next){
                            case 0:
                                _context12.prev = 0;
                                _context12.next = 3;
                                return initializeValuesPromise;
                            case 3:
                                initializeValues = _context12.sent;
                                user = (0, $g8lao.toStatsigUser)(identifiers, initializeValues.customAttributesFromFetch);
                                _context12.next = 12;
                                break;
                            case 7:
                                _context12.prev = 7;
                                _context12.t0 = _context12["catch"](0);
                                // Make sure the updateUserCompletionCallback is called for any errors in our custom code.
                                // This is not necessary for the updateUserWithValues call, because the Statsig client will
                                // already invoke the callback itself.
                                errMsg = _context12.t0 instanceof Error ? _context12.t0.message : JSON.stringify(_context12.t0);
                                (_updateUserCompletion = (_ref3 = this.initOptions).updateUserCompletionCallback) === null || _updateUserCompletion === void 0 || _updateUserCompletion.call(_ref3, false, errMsg);
                                throw _context12.t0;
                            case 12:
                                success = (0, (/*@__PURE__*/$parcel$interopDefault($b1e3j))).updateUserWithValues(user, initializeValues.experimentValues);
                                if (!success) {
                                    _context12.next = 19;
                                    break;
                                }
                                this.currentIdentifiers = identifiers;
                                this.currentAttributes = customAttributes;
                                this.subscriptions.anyUpdated();
                                _context12.next = 20;
                                break;
                            case 19:
                                throw new Error("Failed to update user. An unexpected error occured.");
                            case 20:
                            case "end":
                                return _context12.stop();
                        }
                    }, _callee12, this, [
                        [
                            0,
                            7
                        ]
                    ]);
                }));
                function updateStatsigClientUser(_x31, _x32, _x33) {
                    return _updateStatsigClientUser.apply(this, arguments);
                }
                return updateStatsigClientUser;
            }()
        },
        {
            key: "getPackageVersion",
            value: function getPackageVersion() {
                return 0, $fuICm.CLIENT_VERSION;
            }
        },
        {
            key: "getLayer",
            value: function getLayer(/** The name of the layer */ layerName) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                try {
                    var _options$fireLayerExp = options.fireLayerExposure, fireLayerExposure = _options$fireLayerExp === void 0 ? true : _options$fireLayerExp;
                    var evalMethod = fireLayerExposure ? (0, (/*@__PURE__*/$parcel$interopDefault($b1e3j))).getLayer.bind((0, (/*@__PURE__*/$parcel$interopDefault($b1e3j)))) : (0, (/*@__PURE__*/$parcel$interopDefault($b1e3j))).getLayerWithExposureLoggingDisabled.bind((0, (/*@__PURE__*/$parcel$interopDefault($b1e3j))));
                    return evalMethod(layerName);
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasGetLayerErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: "An error has occurred getting the layer. Only the first occurrence of this error is logged.",
                            layerName: layerName,
                            error: error
                        });
                        this.hasGetLayerErrorOccurred = true;
                    }
                    // Return a default value
                    return (0, $b1e3j.Layer)._create(layerName, {}, "", {
                        time: Date.now(),
                        reason: (0, $b1e3j.EvaluationReason).Error
                    });
                }
            }
        },
        {
            key: "getLayerValue",
            value: function getLayerValue(layerName, parameterName, defaultValue) {
                var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var layer = this.getLayer(layerName, options);
                try {
                    var typeGuard = options.typeGuard;
                    return layer.get(parameterName, defaultValue, typeGuard);
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasGetLayerValueErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: "An error has occurred getting the layer value. Only the first occurrence of this error is logged.",
                            layerName: layerName,
                            defaultValue: defaultValue,
                            options: options,
                            error: error
                        });
                        this.hasGetLayerValueErrorOccurred = true;
                    }
                    return defaultValue;
                }
            }
        }
    ]);
}();

});
parcelRegister("907WG", function(module, exports) {

var $6kKxD = parcelRequire("6kKxD");

var $d4K9F = parcelRequire("d4K9F");

var $4TVTA = parcelRequire("4TVTA");

var $3syA8 = parcelRequire("3syA8");
function $68da46f70af77dd8$var$_slicedToArray(r, e) {
    return $6kKxD(r) || $d4K9F(r, e) || $4TVTA(r, e) || $3syA8();
}
module.exports = $68da46f70af77dd8$var$_slicedToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("6kKxD", function(module, exports) {
function $49c8b684a950d11f$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
module.exports = $49c8b684a950d11f$var$_arrayWithHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("d4K9F", function(module, exports) {
function $984f73809aae92a6$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
module.exports = $984f73809aae92a6$var$_iterableToArrayLimit, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("4TVTA", function(module, exports) {

var $8qimH = parcelRequire("8qimH");
function $3919355408be28af$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $8qimH(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $8qimH(r, a) : void 0;
    }
}
module.exports = $3919355408be28af$var$_unsupportedIterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("8qimH", function(module, exports) {
function $621eff61af43bd9d$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
module.exports = $621eff61af43bd9d$var$_arrayLikeToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("3syA8", function(module, exports) {
function $284ecfd5ce069dc2$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
module.exports = $284ecfd5ce069dc2$var$_nonIterableRest, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("5mLfW", function(module, exports) {
function $3e83a9e76b36eaf7$var$asyncGeneratorStep(n, t, e, r, o, a, c) {
    try {
        var i = n[a](c), u = i.value;
    } catch (n) {
        return void e(n);
    }
    i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function $3e83a9e76b36eaf7$var$_asyncToGenerator(n) {
    return function() {
        var t = this, e = arguments;
        return new Promise(function(r, o) {
            var a = n.apply(t, e);
            function _next(n) {
                $3e83a9e76b36eaf7$var$asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
            }
            function _throw(n) {
                $3e83a9e76b36eaf7$var$asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
            }
            _next(void 0);
        });
    };
}
module.exports = $3e83a9e76b36eaf7$var$_asyncToGenerator, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("3rY0i", function(module, exports) {
// TODO(Babel 8): Remove this file.

var $2832703058d1301c$var$runtime = (parcelRequire("9BLBo"))();
module.exports = $2832703058d1301c$var$runtime;
// Copied from https://github.com/facebook/regenerator/blob/main/packages/runtime/runtime.js#L736=
try {
    regeneratorRuntime = $2832703058d1301c$var$runtime;
} catch (accidentalStrictMode) {
    if (typeof globalThis === "object") globalThis.regeneratorRuntime = $2832703058d1301c$var$runtime;
    else Function("r", "regeneratorRuntime = r")($2832703058d1301c$var$runtime);
}

});
parcelRegister("9BLBo", function(module, exports) {

var $gLgUI = parcelRequire("gLgUI");
var $6fec7e8d45f7c658$var$_typeof = $gLgUI.default;
function $6fec7e8d45f7c658$var$_regeneratorRuntime() {
    "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ 
    module.exports = $6fec7e8d45f7c658$var$_regeneratorRuntime = function _regeneratorRuntime() {
        return e;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports;
    var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function(t, e, r) {
        t[e] = r.value;
    }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag";
    function define(t, e, r) {
        return Object.defineProperty(t, e, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }), t[e];
    }
    try {
        define({}, "");
    } catch (t) {
        define = function define(t, e, r) {
            return t[e] = r;
        };
    }
    function wrap(t, e, r, n) {
        var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []);
        return o(a, "_invoke", {
            value: makeInvokeMethod(t, r, c)
        }), a;
    }
    function tryCatch(t, e, r) {
        try {
            return {
                type: "normal",
                arg: t.call(e, r)
            };
        } catch (t) {
            return {
                type: "throw",
                arg: t
            };
        }
    }
    e.wrap = wrap;
    var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {};
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    var p = {};
    define(p, a, function() {
        return this;
    });
    var d = Object.getPrototypeOf, v = d && d(d(values([])));
    v && v !== r && n.call(v, a) && (p = v);
    var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
    function defineIteratorMethods(t) {
        [
            "next",
            "throw",
            "return"
        ].forEach(function(e) {
            define(t, e, function(t) {
                return this._invoke(e, t);
            });
        });
    }
    function AsyncIterator(t, e) {
        function invoke(r, o, i, a) {
            var c = tryCatch(t[r], t, o);
            if ("throw" !== c.type) {
                var u = c.arg, h = u.value;
                return h && "object" == $6fec7e8d45f7c658$var$_typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function(t) {
                    invoke("next", t, i, a);
                }, function(t) {
                    invoke("throw", t, i, a);
                }) : e.resolve(h).then(function(t) {
                    u.value = t, i(u);
                }, function(t) {
                    return invoke("throw", t, i, a);
                });
            }
            a(c.arg);
        }
        var r;
        o(this, "_invoke", {
            value: function value(t, n) {
                function callInvokeWithMethodAndArg() {
                    return new e(function(e, r) {
                        invoke(t, n, e, r);
                    });
                }
                return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
            }
        });
    }
    function makeInvokeMethod(e, r, n) {
        var o = h;
        return function(i, a) {
            if (o === f) throw Error("Generator is already running");
            if (o === s) {
                if ("throw" === i) throw a;
                return {
                    value: t,
                    done: !0
                };
            }
            for(n.method = i, n.arg = a;;){
                var c = n.delegate;
                if (c) {
                    var u = maybeInvokeDelegate(c, n);
                    if (u) {
                        if (u === y) continue;
                        return u;
                    }
                }
                if ("next" === n.method) n.sent = n._sent = n.arg;
                else if ("throw" === n.method) {
                    if (o === h) throw o = s, n.arg;
                    n.dispatchException(n.arg);
                } else "return" === n.method && n.abrupt("return", n.arg);
                o = f;
                var p = tryCatch(e, r, n);
                if ("normal" === p.type) {
                    if (o = n.done ? s : l, p.arg === y) continue;
                    return {
                        value: p.arg,
                        done: n.done
                    };
                }
                "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
            }
        };
    }
    function maybeInvokeDelegate(e, r) {
        var n = r.method, o = e.iterator[n];
        if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
        var i = tryCatch(o, e.iterator, r.arg);
        if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
        var a = i.arg;
        return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
    }
    function pushTryEntry(t) {
        var e = {
            tryLoc: t[0]
        };
        1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
    }
    function resetTryEntry(t) {
        var e = t.completion || {};
        e.type = "normal", delete e.arg, t.completion = e;
    }
    function Context(t) {
        this.tryEntries = [
            {
                tryLoc: "root"
            }
        ], t.forEach(pushTryEntry, this), this.reset(!0);
    }
    function values(e) {
        if (e || "" === e) {
            var r = e[a];
            if (r) return r.call(e);
            if ("function" == typeof e.next) return e;
            if (!isNaN(e.length)) {
                var o = -1, i = function next() {
                    for(; ++o < e.length;)if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
                    return next.value = t, next.done = !0, next;
                };
                return i.next = i;
            }
        }
        throw new TypeError($6fec7e8d45f7c658$var$_typeof(e) + " is not iterable");
    }
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
        value: GeneratorFunctionPrototype,
        configurable: !0
    }), o(GeneratorFunctionPrototype, "constructor", {
        value: GeneratorFunction,
        configurable: !0
    }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function(t) {
        var e = "function" == typeof t && t.constructor;
        return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
    }, e.mark = function(t) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
    }, e.awrap = function(t) {
        return {
            __await: t
        };
    }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function() {
        return this;
    }), e.AsyncIterator = AsyncIterator, e.async = function(t, r, n, o, i) {
        void 0 === i && (i = Promise);
        var a = new AsyncIterator(wrap(t, r, n, o), i);
        return e.isGeneratorFunction(r) ? a : a.next().then(function(t) {
            return t.done ? t.value : a.next();
        });
    }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function() {
        return this;
    }), define(g, "toString", function() {
        return "[object Generator]";
    }), e.keys = function(t) {
        var e = Object(t), r = [];
        for(var n in e)r.push(n);
        return r.reverse(), function next() {
            for(; r.length;){
                var t = r.pop();
                if (t in e) return next.value = t, next.done = !1, next;
            }
            return next.done = !0, next;
        };
    }, e.values = values, Context.prototype = {
        constructor: Context,
        reset: function reset(e) {
            if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for(var r in this)"t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
        },
        stop: function stop() {
            this.done = !0;
            var t = this.tryEntries[0].completion;
            if ("throw" === t.type) throw t.arg;
            return this.rval;
        },
        dispatchException: function dispatchException(e) {
            if (this.done) throw e;
            var r = this;
            function handle(n, o) {
                return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
            }
            for(var o = this.tryEntries.length - 1; o >= 0; --o){
                var i = this.tryEntries[o], a = i.completion;
                if ("root" === i.tryLoc) return handle("end");
                if (i.tryLoc <= this.prev) {
                    var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc");
                    if (c && u) {
                        if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                        if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
                    } else if (c) {
                        if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                    } else {
                        if (!u) throw Error("try statement without catch or finally");
                        if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
                    }
                }
            }
        },
        abrupt: function abrupt(t, e) {
            for(var r = this.tryEntries.length - 1; r >= 0; --r){
                var o = this.tryEntries[r];
                if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
                    var i = o;
                    break;
                }
            }
            i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
            var a = i ? i.completion : {};
            return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
        },
        complete: function complete(t, e) {
            if ("throw" === t.type) throw t.arg;
            return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
        },
        finish: function finish(t) {
            for(var e = this.tryEntries.length - 1; e >= 0; --e){
                var r = this.tryEntries[e];
                if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
            }
        },
        "catch": function _catch(t) {
            for(var e = this.tryEntries.length - 1; e >= 0; --e){
                var r = this.tryEntries[e];
                if (r.tryLoc === t) {
                    var n = r.completion;
                    if ("throw" === n.type) {
                        var o = n.arg;
                        resetTryEntry(r);
                    }
                    return o;
                }
            }
            throw Error("illegal catch attempt");
        },
        delegateYield: function delegateYield(e, r, n) {
            return this.delegate = {
                iterator: values(e),
                resultName: r,
                nextLoc: n
            }, "next" === this.method && (this.arg = t), y;
        }
    }, e;
}
module.exports = $6fec7e8d45f7c658$var$_regeneratorRuntime, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("b1e3j", function(module, exports) {
"use strict";
var $805ab0368f2b7425$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $805ab0368f2b7425$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $805ab0368f2b7425$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.EvaluationReason = module.exports.Layer = module.exports.DynamicConfig = void 0;

var $67pep = parcelRequire("67pep");

var $805ab0368f2b7425$var$StatsigClient_1 = $805ab0368f2b7425$var$__importDefault((parcelRequire("cL0q8")));

var $d3Tbn = parcelRequire("d3Tbn");

var $6EuWr = parcelRequire("6EuWr");
Object.defineProperty(module.exports, "DynamicConfig", {
    enumerable: true,
    get: function() {
        return $805ab0368f2b7425$var$__importDefault($6EuWr).default;
    }
});

var $7tvtH = parcelRequire("7tvtH");
Object.defineProperty(module.exports, "Layer", {
    enumerable: true,
    get: function() {
        return $805ab0368f2b7425$var$__importDefault($7tvtH).default;
    }
});

var $d3Tbn = parcelRequire("d3Tbn");
Object.defineProperty(module.exports, "EvaluationReason", {
    enumerable: true,
    get: function() {
        return $d3Tbn.EvaluationReason;
    }
});
var $805ab0368f2b7425$var$Statsig = /** @class */ function() {
    function Statsig() {}
    Statsig.initialize = function(sdkKey, user, options) {
        var _a;
        return $805ab0368f2b7425$var$__awaiter(this, void 0, void 0, function() {
            var inst;
            return $805ab0368f2b7425$var$__generator(this, function(_b) {
                inst = (_a = Statsig.instance) !== null && _a !== void 0 ? _a : new $805ab0368f2b7425$var$StatsigClient_1.default(sdkKey, user, options);
                if (!Statsig.instance) Statsig.instance = inst;
                return [
                    2 /*return*/ ,
                    inst.initializeAsync()
                ];
            });
        });
    };
    Statsig.setInitializeValues = function(initializeValues) {
        Statsig._getClientX().setInitializeValues(initializeValues);
    };
    // Gate
    Statsig.checkGate = function(gateName) {
        return Statsig._getClientX().checkGate(gateName);
    };
    Statsig.checkGateWithExposureLoggingDisabled = function(gateName) {
        return Statsig._getClientX().checkGateWithExposureLoggingDisabled(gateName);
    };
    Statsig.manuallyLogGateExposure = function(gateName) {
        Statsig._getClientX().logGateExposure(gateName);
    };
    // Config
    Statsig.getConfig = function(configName) {
        return Statsig._getClientX().getConfig(configName);
    };
    Statsig.getConfigWithExposureLoggingDisabled = function(configName) {
        return Statsig._getClientX().getConfigWithExposureLoggingDisabled(configName);
    };
    Statsig.manuallyLogConfigExposure = function(configName) {
        Statsig._getClientX().logConfigExposure(configName);
    };
    // Experiment
    Statsig.getExperiment = function(experimentName) {
        return Statsig._getClientX().getExperiment(experimentName);
    };
    Statsig.getExperimentWithExposureLoggingDisabled = function(experimentName) {
        return Statsig._getClientX().getExperimentWithExposureLoggingDisabled(experimentName);
    };
    Statsig.manuallyLogExperimentExposure = function(configName) {
        Statsig._getClientX().logExperimentExposure(configName);
    };
    // Layer
    Statsig.getLayer = function(layerName) {
        return Statsig._getClientX().getLayer(layerName);
    };
    Statsig.getLayerWithExposureLoggingDisabled = function(layerName) {
        return Statsig._getClientX().getLayerWithExposureLoggingDisabled(layerName);
    };
    Statsig.manuallyLogLayerParameterExposure = function(layerName, parameterName) {
        Statsig._getClientX().logLayerParameterExposure(layerName, parameterName);
    };
    Statsig.logEvent = function(eventName, value, metadata) {
        if (value === void 0) value = null;
        if (metadata === void 0) metadata = null;
        return Statsig._getClientX().logEvent(eventName, value, metadata);
    };
    Statsig.updateUser = function(user) {
        return Statsig._getClientX().updateUser(user);
    };
    Statsig.updateUserWithValues = function(user, values) {
        return Statsig._getClientX().updateUserWithValues(user, values);
    };
    Statsig.shutdown = function() {
        Statsig._getClientX().shutdown();
        Statsig.instance = null;
    };
    Statsig.overrideGate = function(gate, result) {
        Statsig._getClientX().overrideGate(gate, result);
    };
    Statsig.overrideConfig = function(config, result) {
        Statsig._getClientX().overrideConfig(config, result);
    };
    Statsig.overrideLayer = function(layer, result) {
        Statsig._getClientX().overrideLayer(layer, result);
    };
    Statsig.setOverrides = function(overrides) {
        Statsig._getClientX().setOverrides(overrides);
    };
    Statsig.getOverrides = function() {
        return Statsig._getClientX().getOverrides();
    };
    /**
     * @returns The Statsig stable ID used for device level experiments
     */ Statsig.getStableID = function() {
        return Statsig._getClientX().getStableID();
    };
    /**
     *
     * @returns The reason and time associated with the evaluation for the current set
     * of gates and configs
     */ Statsig.getEvaluationDetails = function() {
        var _a, _b;
        return (_b = (_a = Statsig.instance) === null || _a === void 0 ? void 0 : _a.getEvaluationDetails()) !== null && _b !== void 0 ? _b : {
            reason: $d3Tbn.EvaluationReason.Uninitialized,
            time: 0
        };
    };
    /**
     *
     * @returns true if initialize has already been called, false otherwise
     */ Statsig.initializeCalled = function() {
        return Statsig.instance != null && Statsig.instance.initializeCalled();
    };
    Statsig._getClientX = function() {
        if (!Statsig.instance) throw new $67pep.StatsigUninitializedError();
        return Statsig.instance;
    };
    Statsig.instance = null;
    return Statsig;
}();
module.exports.default = $805ab0368f2b7425$var$Statsig;

});
parcelRegister("67pep", function(module, exports) {
"use strict";
var $4746f7f0f708b496$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StatsigSDKKeyMismatchError = module.exports.StatsigInvalidArgumentError = module.exports.StatsigUninitializedError = module.exports.StatsigErrorMessage = void 0;
var $4746f7f0f708b496$var$StatsigErrorMessage;
(function(StatsigErrorMessage) {
    StatsigErrorMessage["REQUIRE_ASYNC_INITIALIZE"] = "Call initialize() first.";
    StatsigErrorMessage["REQUIRE_SYNC_INITIALIZE"] = "Call and wait for initialize() to finish first.";
    StatsigErrorMessage["REQUIRE_INITIALIZE_FOR_LOG_EVENT"] = "Must initialize() before logging events.";
})($4746f7f0f708b496$var$StatsigErrorMessage = module.exports.StatsigErrorMessage || (module.exports.StatsigErrorMessage = {}));
var $4746f7f0f708b496$var$StatsigUninitializedError = /** @class */ function(_super) {
    $4746f7f0f708b496$var$__extends(StatsigUninitializedError, _super);
    function StatsigUninitializedError(message) {
        var _this = _super.call(this, message !== null && message !== void 0 ? message : $4746f7f0f708b496$var$StatsigErrorMessage.REQUIRE_SYNC_INITIALIZE) || this;
        Object.setPrototypeOf(_this, StatsigUninitializedError.prototype);
        return _this;
    }
    return StatsigUninitializedError;
}(Error);
module.exports.StatsigUninitializedError = $4746f7f0f708b496$var$StatsigUninitializedError;
var $4746f7f0f708b496$var$StatsigInvalidArgumentError = /** @class */ function(_super) {
    $4746f7f0f708b496$var$__extends(StatsigInvalidArgumentError, _super);
    function StatsigInvalidArgumentError(message) {
        var _this = _super.call(this, message) || this;
        Object.setPrototypeOf(_this, StatsigInvalidArgumentError.prototype);
        return _this;
    }
    return StatsigInvalidArgumentError;
}(Error);
module.exports.StatsigInvalidArgumentError = $4746f7f0f708b496$var$StatsigInvalidArgumentError;
var $4746f7f0f708b496$var$StatsigSDKKeyMismatchError = /** @class */ function(_super) {
    $4746f7f0f708b496$var$__extends(StatsigSDKKeyMismatchError, _super);
    function StatsigSDKKeyMismatchError(message) {
        var _this = _super.call(this, message) || this;
        Object.setPrototypeOf(_this, StatsigSDKKeyMismatchError.prototype);
        return _this;
    }
    return StatsigSDKKeyMismatchError;
}(Error);
module.exports.StatsigSDKKeyMismatchError = $4746f7f0f708b496$var$StatsigSDKKeyMismatchError;

});

parcelRegister("cL0q8", function(module, exports) {
"use strict";
var $949a334ed1b58fe5$var$__assign = module.exports && module.exports.__assign || function() {
    $949a334ed1b58fe5$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $949a334ed1b58fe5$var$__assign.apply(this, arguments);
};
var $949a334ed1b58fe5$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $949a334ed1b58fe5$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $949a334ed1b58fe5$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $949a334ed1b58fe5$var$__createBinding(result, mod, k);
    }
    $949a334ed1b58fe5$var$__setModuleDefault(result, mod);
    return result;
};
var $949a334ed1b58fe5$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $949a334ed1b58fe5$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $949a334ed1b58fe5$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $949a334ed1b58fe5$var$DynamicConfig_1 = $949a334ed1b58fe5$var$__importDefault((parcelRequire("6EuWr")));

var $949a334ed1b58fe5$var$ErrorBoundary_1 = $949a334ed1b58fe5$var$__importDefault((parcelRequire("aYhoF")));

var $67pep = parcelRequire("67pep");

var $949a334ed1b58fe5$var$Layer_1 = $949a334ed1b58fe5$var$__importDefault((parcelRequire("7tvtH")));

var $949a334ed1b58fe5$var$StatsigIdentity_1 = $949a334ed1b58fe5$var$__importDefault((parcelRequire("kU88b")));

var $949a334ed1b58fe5$var$StatsigLogger_1 = $949a334ed1b58fe5$var$__importDefault((parcelRequire("3AB9J")));

var $949a334ed1b58fe5$var$StatsigNetwork_1 = $949a334ed1b58fe5$var$__importDefault((parcelRequire("bTkP2")));

var $949a334ed1b58fe5$var$StatsigSDKOptions_1 = $949a334ed1b58fe5$var$__importDefault((parcelRequire("7LDvt")));

var $949a334ed1b58fe5$var$StatsigStore_1 = $949a334ed1b58fe5$var$__importStar((parcelRequire("d3Tbn")));

var $4l64D = parcelRequire("4l64D");

var $949a334ed1b58fe5$var$StatsigLocalStorage_1 = $949a334ed1b58fe5$var$__importDefault((parcelRequire("2klGt")));

var $zQ9jk = parcelRequire("zQ9jk");

var $949a334ed1b58fe5$var$LogEvent_1 = $949a334ed1b58fe5$var$__importDefault((parcelRequire("22SUv")));

var $lFzGg = parcelRequire("lFzGg");
var $949a334ed1b58fe5$var$StatsigClient = /** @class */ function() {
    function StatsigClient(sdkKey, user, options) {
        var _this = this;
        this._initCalled = false;
        this._pendingInitPromise = null;
        this._sdkKey = null;
        this._logLayerParameterExposureForLayer = function(layer, parameterName, isManualExposure) {
            if (isManualExposure === void 0) isManualExposure = false;
            var allocatedExperiment = "";
            var exposures = layer._undelegatedSecondaryExposures;
            var isExplicit = layer._explicitParameters.includes(parameterName);
            if (isExplicit) {
                allocatedExperiment = layer._allocatedExperimentName;
                exposures = layer._secondaryExposures;
            }
            _this._logger.logLayerExposure(_this._identity._user, layer._name, layer._ruleID, exposures, allocatedExperiment, parameterName, isExplicit, layer._evaluationDetails, isManualExposure, _this._store.getBootstrapMetadata());
        };
        if ((options === null || options === void 0 ? void 0 : options.localMode) !== true && (typeof sdkKey !== "string" || !sdkKey.startsWith("client-"))) throw new $67pep.StatsigInvalidArgumentError("Invalid key provided.  You must use a Client SDK Key from the Statsig console to initialize the sdk");
        this._sdkKey = sdkKey;
        this._startTime = (0, $zQ9jk.now)();
        this._options = new $949a334ed1b58fe5$var$StatsigSDKOptions_1.default(options);
        this._errorBoundary = new $949a334ed1b58fe5$var$ErrorBoundary_1.default(sdkKey, this._options);
        this._ready = false;
        $949a334ed1b58fe5$var$StatsigLocalStorage_1.default.disabled = this._options.disableLocalStorage;
        this._overrides = (0, $lFzGg.loadOverridesFromLocalStorage)();
        this._identity = new $949a334ed1b58fe5$var$StatsigIdentity_1.default(sdkKey, this._normalizeUser(user !== null && user !== void 0 ? user : null), this._options.overrideStableID);
        this._network = new $949a334ed1b58fe5$var$StatsigNetwork_1.default(this._options, this._identity, this._errorBoundary);
        this._logger = new $949a334ed1b58fe5$var$StatsigLogger_1.default(this._options, this._identity, this._network, this._errorBoundary);
        this._store = new $949a334ed1b58fe5$var$StatsigStore_1.default(this._identity, this._logger.logConfigDefaultValueFallback, this._options.initializeValues);
        this._errorBoundary._setStatsigMetadata(this._identity._statsigMetadata);
        if (this._options.initializeValues != null) {
            this._ready = true;
            this._initCalled = true;
            setTimeout(function() {
                return _this._delayedSetup();
            }, 20);
        }
    }
    StatsigClient.prototype.setInitializeValues = function(initializeValues) {
        var _this = this;
        this._errorBoundary._capture("setInitializeValues", function() {
            _this._store.bootstrap(initializeValues);
            if (!_this._ready) {
                // the sdk is usable and considered initialized when configured
                // with initializeValues
                _this._ready = true;
                _this._initCalled = true;
            }
            // we wont have access to window/document/localStorage if these run on the server
            // so try to run whenever this is called
            _this._logger.sendSavedRequests();
        }, function() {
            _this._ready = true;
            _this._initCalled = true;
        });
    };
    StatsigClient.prototype.initializeAsync = function() {
        return $949a334ed1b58fe5$var$__awaiter(this, void 0, void 0, function() {
            var _this = this;
            return $949a334ed1b58fe5$var$__generator(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this._errorBoundary._capture("initializeAsync", function() {
                        return $949a334ed1b58fe5$var$__awaiter(_this, void 0, void 0, function() {
                            var user;
                            var _this = this;
                            return $949a334ed1b58fe5$var$__generator(this, function(_a) {
                                if (this._pendingInitPromise != null) return [
                                    2 /*return*/ ,
                                    this._pendingInitPromise
                                ];
                                if (this._ready) return [
                                    2 /*return*/ ,
                                    Promise.resolve()
                                ];
                                this._initCalled = true;
                                if (this._options.localMode) return [
                                    2 /*return*/ ,
                                    Promise.resolve()
                                ];
                                user = this._identity._user;
                                this._pendingInitPromise = this._fetchAndSaveValues(user, this._options.initTimeoutMs).then(function() {
                                    return;
                                }).catch(function(e) {
                                    _this._errorBoundary._logError("initializeAsync:fetchAndSaveValues", e);
                                    return {
                                        success: false,
                                        message: e.message
                                    };
                                }).then(function() {
                                    return;
                                }).finally(function() {
                                    return $949a334ed1b58fe5$var$__awaiter(_this, void 0, void 0, function() {
                                        return $949a334ed1b58fe5$var$__generator(this, function(_a) {
                                            this._pendingInitPromise = null;
                                            this._ready = true;
                                            this._delayedSetup();
                                            return [
                                                2 /*return*/ 
                                            ];
                                        });
                                    });
                                });
                                return [
                                    2 /*return*/ ,
                                    this._pendingInitPromise
                                ];
                            });
                        });
                    }, function() {
                        _this._ready = true;
                        _this._initCalled = true;
                        return Promise.resolve();
                    })
                ];
            });
        });
    };
    StatsigClient.prototype.getEvaluationDetails = function() {
        var _this = this;
        return this._errorBoundary._capture("getEvaluationDetails", function() {
            return _this._store.getGlobalEvaluationDetails();
        }, function() {
            return {
                time: Date.now(),
                reason: $949a334ed1b58fe5$var$StatsigStore_1.EvaluationReason.Error
            };
        });
    };
    /**
     * Checks the value of a gate for the current user
     * @param {string} gateName - the name of the gate to check
     * @returns {boolean} - value of a gate for the user. Gates are "off" (return false) by default
     * @throws Error if initialize() is not called first, or gateName is not a string
     */ StatsigClient.prototype.checkGate = function(gateName) {
        return this._checkGateImpl(gateName, "checkGate");
    };
    StatsigClient.prototype.checkGateWithExposureLoggingDisabled = function(gateName) {
        return this._checkGateImpl(gateName, "checkGateWithExposureLoggingDisabled");
    };
    StatsigClient.prototype.logGateExposure = function(gateName) {
        var _this = this;
        this._errorBoundary._swallow("logGateExposure", function() {
            _this._logGateExposureImpl(gateName);
        });
    };
    /**
     * Checks the value of a config for the current user
     * @param {string} configName - the name of the config to get
     * @returns {DynamicConfig} - value of a config for the user
     * @throws Error if initialize() is not called first, or configName is not a string
     */ StatsigClient.prototype.getConfig = function(configName) {
        return this._getConfigImpl(configName, "getConfig");
    };
    StatsigClient.prototype.getConfigWithExposureLoggingDisabled = function(configName) {
        return this._getConfigImpl(configName, "getConfigWithExposureLoggingDisabled");
    };
    StatsigClient.prototype.logConfigExposure = function(configName) {
        var _this = this;
        this._errorBoundary._swallow("logConfigExposure", function() {
            _this._logConfigExposureImpl(configName);
        });
    };
    StatsigClient.prototype.getExperiment = function(experimentName) {
        return this.getConfig(experimentName);
    };
    StatsigClient.prototype.getExperimentWithExposureLoggingDisabled = function(experimentName) {
        return this.getConfigWithExposureLoggingDisabled(experimentName);
    };
    StatsigClient.prototype.logExperimentExposure = function(experimentName) {
        this.logConfigExposure(experimentName);
    };
    StatsigClient.prototype.getLayer = function(layerName) {
        return this._getLayerImpl(layerName, "getLayer");
    };
    StatsigClient.prototype.getLayerWithExposureLoggingDisabled = function(layerName) {
        return this._getLayerImpl(layerName, "getLayerWithExposureLoggingDisabled");
    };
    StatsigClient.prototype.logLayerParameterExposure = function(layerName, parameterName) {
        var _this = this;
        this._errorBoundary._swallow("logLayerParameterExposure", function() {
            var layer = _this._getLayerFromStore(null, layerName);
            _this._logLayerParameterExposureForLayer(layer, parameterName, true);
        });
    };
    StatsigClient.prototype.logEvent = function(eventName, value, metadata) {
        var _this = this;
        if (value === void 0) value = null;
        if (metadata === void 0) metadata = null;
        this._errorBoundary._swallow("logEvent", function() {
            if (!_this._logger || !_this._identity._sdkKey) throw new $67pep.StatsigUninitializedError($67pep.StatsigErrorMessage.REQUIRE_INITIALIZE_FOR_LOG_EVENT);
            if (typeof eventName !== "string" || eventName.length === 0) return;
            var event = (0, $949a334ed1b58fe5$var$LogEvent_1.default)(eventName, _this._identity._user, _this._identity._statsigMetadata, value, metadata);
            _this._logger.log(event);
        });
    };
    StatsigClient.prototype.updateUserWithValues = function(user, values) {
        var _this = this;
        var updateStartTime = Date.now();
        var fireCompletionCallback;
        return this._errorBoundary._capture("updateUserWithValues", function() {
            if (!_this.initializeCalled()) throw new $67pep.StatsigUninitializedError($67pep.StatsigErrorMessage.REQUIRE_ASYNC_INITIALIZE);
            fireCompletionCallback = function(success, error) {
                var cb = _this._options.updateUserCompletionCallback;
                cb === null || cb === void 0 || cb(Date.now() - updateStartTime, success, error);
            };
            _this._identity._user = _this._normalizeUser(user);
            _this._store.bootstrap(values);
            _this._logger.resetDedupeKeys();
            fireCompletionCallback(true, null);
            return true;
        }, function() {
            fireCompletionCallback === null || fireCompletionCallback === void 0 || fireCompletionCallback(false, "Failed to update user. An unexpected error occured.");
            return false;
        });
    };
    StatsigClient.prototype.updateUser = function(user) {
        return $949a334ed1b58fe5$var$__awaiter(this, void 0, void 0, function() {
            var updateStartTime, fireCompletionCallback;
            var _this = this;
            return $949a334ed1b58fe5$var$__generator(this, function(_a) {
                updateStartTime = Date.now();
                return [
                    2 /*return*/ ,
                    this._errorBoundary._capture("updateUser", function() {
                        return $949a334ed1b58fe5$var$__awaiter(_this, void 0, void 0, function() {
                            var currentUser;
                            var _this = this;
                            return $949a334ed1b58fe5$var$__generator(this, function(_a) {
                                switch(_a.label){
                                    case 0:
                                        if (!this.initializeCalled()) throw new $67pep.StatsigUninitializedError($67pep.StatsigErrorMessage.REQUIRE_ASYNC_INITIALIZE);
                                        fireCompletionCallback = function(success, error) {
                                            var cb = _this._options.updateUserCompletionCallback;
                                            cb === null || cb === void 0 || cb(Date.now() - updateStartTime, success, error);
                                        };
                                        this._identity._user = this._normalizeUser(user);
                                        this._store.updateUser();
                                        this._logger.resetDedupeKeys();
                                        if (!(this._pendingInitPromise != null)) return [
                                            3 /*break*/ ,
                                            2
                                        ];
                                        return [
                                            4 /*yield*/ ,
                                            this._pendingInitPromise
                                        ];
                                    case 1:
                                        _a.sent();
                                        _a.label = 2;
                                    case 2:
                                        if (this._options.localMode) {
                                            fireCompletionCallback(true, null);
                                            return [
                                                2 /*return*/ ,
                                                Promise.resolve(true)
                                            ];
                                        }
                                        currentUser = this._identity._user;
                                        this._pendingInitPromise = this._fetchAndSaveValues(currentUser).finally(function() {
                                            _this._pendingInitPromise = null;
                                        });
                                        return [
                                            2 /*return*/ ,
                                            this._pendingInitPromise.then(function() {
                                                fireCompletionCallback(true, null);
                                                return Promise.resolve(true);
                                            }).catch(function(error) {
                                                fireCompletionCallback(false, "Failed to update user: ".concat(error));
                                                return Promise.resolve(false);
                                            })
                                        ];
                                }
                            });
                        });
                    }, function() {
                        fireCompletionCallback(false, "Failed to update user. An unexpected error occured.");
                        return Promise.resolve(false);
                    })
                ];
            });
        });
    };
    /**
     * Informs the statsig SDK that the client is closing or shutting down
     * so the SDK can clean up internal state
     */ StatsigClient.prototype.shutdown = function() {
        var _this = this;
        this._errorBoundary._swallow("shutdown", function() {
            _this._logger.shutdown();
        });
    };
    /**
     * @returns The Statsig stable ID used for device level experiments
     */ StatsigClient.prototype.getStableID = function() {
        var _this = this;
        return this._errorBoundary._capture("getStableID", function() {
            return _this._identity._statsigMetadata.stableID;
        }, function() {
            return "";
        });
    };
    StatsigClient.prototype.initializeCalled = function() {
        return this._initCalled;
    };
    StatsigClient.prototype.overrideGate = function(gate, result) {
        this._setOverride("gates", gate, result);
    };
    StatsigClient.prototype.overrideConfig = function(config, result) {
        this._setOverride("configs", config, result);
    };
    StatsigClient.prototype.overrideLayer = function(layer, result) {
        this._setOverride("layers", layer, result);
    };
    StatsigClient.prototype.setOverrides = function(overrides) {
        var _this = this;
        this._errorBoundary._swallow("setOverrides", function() {
            _this._overrides = overrides !== null && overrides !== void 0 ? overrides : (0, $lFzGg.makeEmptyOverrides)();
            (0, $lFzGg.saveOverridesToLocalStorage)(_this._overrides);
        });
    };
    StatsigClient.prototype.getOverrides = function() {
        var _this = this;
        return this._errorBoundary._capture("getOverrides", function() {
            return _this._overrides;
        }, function() {
            return (0, $lFzGg.makeEmptyOverrides)();
        });
    };
    // Private
    StatsigClient.prototype._delayedSetup = function() {
        var _this = this;
        this._errorBoundary._swallow("delayedSetup", function() {
            _this._identity.saveStableID();
            _this._logger.sendSavedRequests().then(function() {
            /* noop */ });
        });
    };
    StatsigClient.prototype._normalizeUser = function(user) {
        var userCopy = {};
        try {
            userCopy = JSON.parse(JSON.stringify(user));
        } catch (error) {
            throw new $67pep.StatsigInvalidArgumentError("User object must be convertable to JSON string.");
        }
        if (this._options.environment != null) userCopy = $949a334ed1b58fe5$var$__assign($949a334ed1b58fe5$var$__assign({}, userCopy), {
            statsigEnvironment: this._options.environment
        });
        return userCopy;
    };
    StatsigClient.prototype._ensureStoreLoaded = function() {
        if (!this._store.isLoaded()) throw new $67pep.StatsigUninitializedError();
    };
    StatsigClient.prototype._getEvaluationDetailsForError = function() {
        return {
            time: Date.now(),
            reason: $949a334ed1b58fe5$var$StatsigStore_1.EvaluationReason.Error
        };
    };
    StatsigClient.prototype._fetchAndSaveValues = function(user, timeout) {
        if (timeout === void 0) timeout = this._options.initTimeoutMs;
        return $949a334ed1b58fe5$var$__awaiter(this, void 0, void 0, function() {
            var sinceTime, previousDerivedFields;
            var _this = this;
            return $949a334ed1b58fe5$var$__generator(this, function(_a) {
                sinceTime = null;
                sinceTime = this._store.getLastUpdateTime(user);
                previousDerivedFields = this._store.getPreviousDerivedFields(user);
                return [
                    2 /*return*/ ,
                    this._network.fetchValues(user, sinceTime, timeout, previousDerivedFields).eventually(function(json) {
                        var _a;
                        if (!(0, $4l64D.verifySDKKeyUsed)(json, (_a = _this._sdkKey) !== null && _a !== void 0 ? _a : "", _this._errorBoundary)) return;
                        if (json === null || json === void 0 ? void 0 : json.has_updates) _this._store.save(user, json, false);
                    }).then(function(json) {
                        return $949a334ed1b58fe5$var$__awaiter(_this, void 0, void 0, function() {
                            var _this = this;
                            return $949a334ed1b58fe5$var$__generator(this, function(_a) {
                                return [
                                    2 /*return*/ ,
                                    this._errorBoundary._swallow("fetchAndSaveValues", function() {
                                        return $949a334ed1b58fe5$var$__awaiter(_this, void 0, void 0, function() {
                                            var _a;
                                            return $949a334ed1b58fe5$var$__generator(this, function(_b) {
                                                switch(_b.label){
                                                    case 0:
                                                        if (!(0, $4l64D.verifySDKKeyUsed)(json, (_a = this._sdkKey) !== null && _a !== void 0 ? _a : "", this._errorBoundary)) return [
                                                            2 /*return*/ 
                                                        ];
                                                        if (!(json === null || json === void 0 ? void 0 : json.has_updates)) return [
                                                            3 /*break*/ ,
                                                            2
                                                        ];
                                                        return [
                                                            4 /*yield*/ ,
                                                            this._store.save(user, json)
                                                        ];
                                                    case 1:
                                                        _b.sent();
                                                        return [
                                                            3 /*break*/ ,
                                                            3
                                                        ];
                                                    case 2:
                                                        if (json === null || json === void 0 ? void 0 : json.is_no_content) this._store.setEvaluationReason($949a334ed1b58fe5$var$StatsigStore_1.EvaluationReason.NetworkNotModified);
                                                        _b.label = 3;
                                                    case 3:
                                                        return [
                                                            2 /*return*/ 
                                                        ];
                                                }
                                            });
                                        });
                                    })
                                ];
                            });
                        });
                    })
                ];
            });
        });
    };
    StatsigClient.prototype._checkGateImpl = function(gateName, callsite) {
        var _this = this;
        return this._errorBoundary._capture(callsite, function() {
            if (typeof _this._overrides.gates[gateName] === "boolean") return _this._overrides.gates[gateName];
            var result = _this._getGateFromStore(gateName);
            if (callsite === "checkGate") _this._logGateExposureImpl(gateName, result);
            return result.gate.value === true;
        }, function() {
            return false;
        });
    };
    StatsigClient.prototype._getGateFromStore = function(gateName) {
        this._ensureStoreLoaded();
        if (typeof gateName !== "string" || gateName.length === 0) throw new $67pep.StatsigInvalidArgumentError("Must pass a valid string as the gateName.");
        return this._store.checkGate(gateName);
    };
    StatsigClient.prototype._logGateExposureImpl = function(gateName, fetchResult) {
        var _a;
        var isManualExposure = !fetchResult;
        var result = fetchResult !== null && fetchResult !== void 0 ? fetchResult : this._getGateFromStore(gateName);
        var gate = result.gate;
        this._logger.logGateExposure(this._identity._user, gateName, gate.value, gate.rule_id, this._store.mapExposures((_a = gate.secondary_exposures) !== null && _a !== void 0 ? _a : []), result.evaluationDetails, isManualExposure, this._store.getBootstrapMetadata());
    };
    StatsigClient.prototype._getConfigImpl = function(configName, callsite) {
        var _this = this;
        return this._errorBoundary._capture(callsite, function() {
            if (_this._overrides.configs[configName]) return new $949a334ed1b58fe5$var$DynamicConfig_1.default(configName, _this._overrides.configs[configName], "local_override", {
                reason: $949a334ed1b58fe5$var$StatsigStore_1.EvaluationReason.LocalOverride,
                time: Date.now()
            });
            var result = _this._getConfigFromStore(configName);
            if (callsite === "getConfig") _this._logConfigExposureImpl(configName, result);
            return result;
        }, function() {
            return _this._getEmptyConfig(configName);
        });
    };
    StatsigClient.prototype._getConfigFromStore = function(configName) {
        this._ensureStoreLoaded();
        if (typeof configName !== "string" || configName.length === 0) throw new $67pep.StatsigInvalidArgumentError("Must pass a valid string as the configName.");
        return this._store.getConfig(configName);
    };
    StatsigClient.prototype._logConfigExposureImpl = function(configName, config) {
        var isManualExposure = !config;
        var localConfig = config !== null && config !== void 0 ? config : this._getConfigFromStore(configName);
        this._logger.logConfigExposure(this._identity._user, configName, localConfig._ruleID, localConfig._secondaryExposures, localConfig._evaluationDetails, isManualExposure, this._store.getBootstrapMetadata());
    };
    StatsigClient.prototype._getLayerImpl = function(layerName, callsite) {
        var _this = this;
        return this._errorBoundary._capture(callsite, function() {
            if (_this._overrides.layers[layerName]) return $949a334ed1b58fe5$var$Layer_1.default._create(layerName, _this._overrides.layers[layerName], "local_override", {
                reason: $949a334ed1b58fe5$var$StatsigStore_1.EvaluationReason.LocalOverride,
                time: Date.now()
            });
            var logFunc = callsite === "getLayer" ? _this._logLayerParameterExposureForLayer : null;
            return _this._getLayerFromStore(logFunc, layerName);
        }, function() {
            return $949a334ed1b58fe5$var$Layer_1.default._create(layerName, {}, "", _this._getEvaluationDetailsForError());
        });
    };
    StatsigClient.prototype._getLayerFromStore = function(logParameterFunction, layerName) {
        this._ensureStoreLoaded();
        if (typeof layerName !== "string" || layerName.length === 0) throw new $67pep.StatsigInvalidArgumentError("Must pass a valid string as the layerName.");
        return this._store.getLayer(logParameterFunction, layerName);
    };
    StatsigClient.prototype._getEmptyConfig = function(configName) {
        return new $949a334ed1b58fe5$var$DynamicConfig_1.default(configName, {}, "", this._getEvaluationDetailsForError());
    };
    StatsigClient.prototype._setOverride = function(type, key, result) {
        if (result == null) delete this._overrides[type][key];
        else this._overrides[type][key] = result;
        this.setOverrides(this._overrides);
    };
    return StatsigClient;
}();
module.exports.default = $949a334ed1b58fe5$var$StatsigClient;

});
parcelRegister("6EuWr", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $4d7e7adfab2c0b32$var$DynamicConfig = /** @class */ function() {
    function DynamicConfig(configName, configValue, ruleID, evaluationDetails, secondaryExposures, allocatedExperimentName, onDefaultValueFallback) {
        if (secondaryExposures === void 0) secondaryExposures = [];
        if (allocatedExperimentName === void 0) allocatedExperimentName = "";
        if (onDefaultValueFallback === void 0) onDefaultValueFallback = null;
        this._onDefaultValueFallback = null;
        this.value = JSON.parse(JSON.stringify(configValue !== null && configValue !== void 0 ? configValue : {}));
        this._name = configName;
        this._ruleID = ruleID !== null && ruleID !== void 0 ? ruleID : "";
        this._secondaryExposures = secondaryExposures;
        this._allocatedExperimentName = allocatedExperimentName;
        this._evaluationDetails = evaluationDetails;
        this._onDefaultValueFallback = onDefaultValueFallback;
    }
    DynamicConfig.prototype.get = function(key, defaultValue, typeGuard) {
        var _a, _b;
        var val = this.getValue(key, defaultValue);
        if (val == null) return defaultValue;
        var expectedType = Array.isArray(defaultValue) ? "array" : typeof defaultValue;
        var actualType = Array.isArray(val) ? "array" : typeof val;
        if (typeGuard) {
            if (typeGuard(val)) return val;
            (_a = this._onDefaultValueFallback) === null || _a === void 0 || _a.call(this, this, key, expectedType, actualType);
            return defaultValue;
        }
        if (defaultValue == null || expectedType === actualType) return val;
        (_b = this._onDefaultValueFallback) === null || _b === void 0 || _b.call(this, this, key, expectedType, actualType);
        return defaultValue;
    };
    DynamicConfig.prototype.getValue = function(key, defaultValue) {
        if (key == null) return this.value;
        if (defaultValue == null) defaultValue = null;
        if (this.value[key] == null) return defaultValue;
        return this.value[key];
    };
    return DynamicConfig;
}();
module.exports.default = $4d7e7adfab2c0b32$var$DynamicConfig;

});

parcelRegister("aYhoF", function(module, exports) {
"use strict";
var $7fcd00a6d9f81868$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $7fcd00a6d9f81868$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ExceptionEndpoint = void 0;

var $67pep = parcelRequire("67pep");
module.exports.ExceptionEndpoint = "https://statsigapi.net/v1/sdk_exception";
var $7fcd00a6d9f81868$var$ErrorBoundary = /** @class */ function() {
    function ErrorBoundary(sdkKey, options) {
        this._seen = new Set();
        this._sdkKey = sdkKey;
        this._options = options;
    }
    ErrorBoundary.prototype._setStatsigMetadata = function(statsigMetadata) {
        this._statsigMetadata = statsigMetadata;
    };
    ErrorBoundary.prototype._swallow = function(tag, task) {
        this._capture(tag, task, function() {
            return undefined;
        });
    };
    ErrorBoundary.prototype._capture = function(tag, task, recover, getExtraData) {
        var _this = this;
        try {
            var result = task();
            if (result instanceof Promise) return result.catch(function(e) {
                return _this._onCaught(tag, e, recover, getExtraData);
            });
            return result;
        } catch (error) {
            return this._onCaught(tag, error, recover, getExtraData);
        }
    };
    ErrorBoundary.prototype._logError = function(tag, error, getExtraData) {
        var _this = this;
        if (this._options.disableAllLogging) return;
        try {
            var impl = function() {
                return $7fcd00a6d9f81868$var$__awaiter(_this, void 0, void 0, function() {
                    var extra, _a, unwrapped, isError, name, info, metadata, body;
                    var _b;
                    return $7fcd00a6d9f81868$var$__generator(this, function(_c) {
                        switch(_c.label){
                            case 0:
                                if (!(typeof getExtraData === "function")) return [
                                    3 /*break*/ ,
                                    2
                                ];
                                return [
                                    4 /*yield*/ ,
                                    getExtraData()
                                ];
                            case 1:
                                _a = _c.sent();
                                return [
                                    3 /*break*/ ,
                                    3
                                ];
                            case 2:
                                _a = null;
                                _c.label = 3;
                            case 3:
                                extra = _a;
                                unwrapped = error !== null && error !== void 0 ? error : Error("[Statsig] Error was empty");
                                isError = unwrapped instanceof Error;
                                name = isError ? unwrapped.name : "No Name";
                                if (this._seen.has(name)) return [
                                    2 /*return*/ 
                                ];
                                this._seen.add(name);
                                info = isError ? unwrapped.stack : this._getDescription(unwrapped);
                                metadata = (_b = this._statsigMetadata) !== null && _b !== void 0 ? _b : {};
                                body = JSON.stringify({
                                    tag: tag,
                                    exception: name,
                                    info: info,
                                    statsigMetadata: metadata,
                                    extra: extra !== null && extra !== void 0 ? extra : {}
                                });
                                return [
                                    2 /*return*/ ,
                                    fetch(module.exports.ExceptionEndpoint, {
                                        method: "POST",
                                        headers: {
                                            "STATSIG-API-KEY": this._sdkKey,
                                            "STATSIG-SDK-TYPE": String(metadata["sdkType"]),
                                            "STATSIG-SDK-VERSION": String(metadata["sdkVersion"]),
                                            "Content-Type": "application/json",
                                            "Content-Length": "".concat(body.length)
                                        },
                                        body: body
                                    })
                                ];
                        }
                    });
                });
            };
            impl().then(function() {
            /* noop */ }).catch(function() {
            /* noop */ });
        } catch (_error) {
        /* noop */ }
    };
    ErrorBoundary.prototype._onCaught = function(tag, error, recover, getExtraData) {
        if (error instanceof $67pep.StatsigUninitializedError || error instanceof $67pep.StatsigInvalidArgumentError) throw error; // Don't catch these
        console.error("[Statsig] An unexpected exception occurred.", error);
        this._logError(tag, error, getExtraData);
        return recover();
    };
    ErrorBoundary.prototype._getDescription = function(obj) {
        try {
            return JSON.stringify(obj);
        } catch (_a) {
            return "[Statsig] Failed to get string for error.";
        }
    };
    return ErrorBoundary;
}();
module.exports.default = $7fcd00a6d9f81868$var$ErrorBoundary;

});

parcelRegister("7tvtH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $5713a8b37b1f0067$var$Layer = /** @class */ function() {
    function Layer(name, layerValue, ruleID, evaluationDetails, logParameterFunction, secondaryExposures, undelegatedSecondaryExposures, allocatedExperimentName, explicitParameters) {
        if (logParameterFunction === void 0) logParameterFunction = null;
        if (secondaryExposures === void 0) secondaryExposures = [];
        if (undelegatedSecondaryExposures === void 0) undelegatedSecondaryExposures = [];
        if (allocatedExperimentName === void 0) allocatedExperimentName = "";
        if (explicitParameters === void 0) explicitParameters = [];
        this._logParameterFunction = logParameterFunction;
        this._name = name;
        this._value = JSON.parse(JSON.stringify(layerValue !== null && layerValue !== void 0 ? layerValue : {}));
        this._ruleID = ruleID !== null && ruleID !== void 0 ? ruleID : "";
        this._evaluationDetails = evaluationDetails;
        this._secondaryExposures = secondaryExposures;
        this._undelegatedSecondaryExposures = undelegatedSecondaryExposures;
        this._allocatedExperimentName = allocatedExperimentName;
        this._explicitParameters = explicitParameters;
    }
    Layer._create = function(name, value, ruleID, evaluationDetails, logParameterFunction, secondaryExposures, undelegatedSecondaryExposures, allocatedExperimentName, explicitParameters) {
        if (logParameterFunction === void 0) logParameterFunction = null;
        if (secondaryExposures === void 0) secondaryExposures = [];
        if (undelegatedSecondaryExposures === void 0) undelegatedSecondaryExposures = [];
        if (allocatedExperimentName === void 0) allocatedExperimentName = "";
        if (explicitParameters === void 0) explicitParameters = [];
        return new Layer(name, value, ruleID, evaluationDetails, logParameterFunction, secondaryExposures, undelegatedSecondaryExposures, allocatedExperimentName, explicitParameters);
    };
    Layer.prototype.get = function(key, defaultValue, typeGuard) {
        var _this = this;
        var val = this._value[key];
        if (val == null) return defaultValue;
        var logAndReturn = function() {
            _this._logLayerParameterExposure(key);
            return val;
        };
        if (typeGuard) return typeGuard(val) ? logAndReturn() : defaultValue;
        if (defaultValue == null) return logAndReturn();
        if (typeof val === typeof defaultValue && Array.isArray(defaultValue) === Array.isArray(val)) return logAndReturn();
        return defaultValue;
    };
    Layer.prototype.getValue = function(key, defaultValue) {
        if (defaultValue == undefined) defaultValue = null;
        var val = this._value[key];
        if (val != null) this._logLayerParameterExposure(key);
        return val !== null && val !== void 0 ? val : defaultValue;
    };
    Layer.prototype._logLayerParameterExposure = function(parameterName) {
        var _a;
        (_a = this._logParameterFunction) === null || _a === void 0 || _a.call(this, this, parameterName);
    };
    return Layer;
}();
module.exports.default = $5713a8b37b1f0067$var$Layer;

});

parcelRegister("kU88b", function(module, exports) {
"use strict";
var $f37f583ec62c845b$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $eH4EZ = parcelRequire("eH4EZ");

var $jDn9b = parcelRequire("jDn9b");

var $f37f583ec62c845b$var$StatsigLocalStorage_1 = $f37f583ec62c845b$var$__importDefault((parcelRequire("2klGt")));

var $dOtZb = parcelRequire("dOtZb");
var $f37f583ec62c845b$var$Identity = /** @class */ function() {
    function Identity(sdkKey, user, overrideStableID) {
        var _a;
        this._sdkType = "js-lite";
        this._sdkKey = sdkKey;
        this._user = user;
        this._sdkVersion = $dOtZb.version;
        var stableID = overrideStableID;
        stableID = (_a = stableID !== null && stableID !== void 0 ? stableID : $f37f583ec62c845b$var$StatsigLocalStorage_1.default.getItem($eH4EZ.STATSIG_STABLE_ID_KEY)) !== null && _a !== void 0 ? _a : this._getUUID();
        this._statsigMetadata = {
            stableID: stableID,
            sdkType: this._sdkType,
            sdkVersion: this._sdkVersion
        };
    }
    Identity.prototype.saveStableID = function() {
        if (this._statsigMetadata.stableID != null) $f37f583ec62c845b$var$StatsigLocalStorage_1.default.setItem($eH4EZ.STATSIG_STABLE_ID_KEY, this._statsigMetadata.stableID);
    };
    Identity.prototype.getUserCacheKey = function() {
        return (0, $jDn9b.getUserCacheKey)(this._user);
    };
    Identity.prototype._getUUID = function() {
        var uuid = "";
        for(var i = 0; i < 32; i++){
            if (i === 8 || i === 12 || i === 16 || i === 20) uuid += "-";
            var randomDigit = Math.random() * 16 | 0;
            if (i === 12) uuid += "4";
            else if (i === 16) uuid += (randomDigit & 3 | 8).toString(16);
            else uuid += randomDigit.toString(16);
        }
        return uuid;
    };
    return Identity;
}();
module.exports.default = $f37f583ec62c845b$var$Identity;

});
parcelRegister("eH4EZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LOCAL_STORAGE_KEYS = module.exports.STATSIG_LOCAL_STORAGE_LOGGING_REQUEST_KEY = module.exports.STATSIG_STABLE_ID_KEY = module.exports.INTERNAL_STORE_KEY = void 0;
module.exports.INTERNAL_STORE_KEY = "STATSIG_STORE";
module.exports.STATSIG_STABLE_ID_KEY = "STATSIG_STABLE_ID";
module.exports.STATSIG_LOCAL_STORAGE_LOGGING_REQUEST_KEY = "STATSIG_LOGS";
module.exports.LOCAL_STORAGE_KEYS = {
    INTERNAL_STORE_KEY: true,
    STATSIG_STABLE_ID_KEY: true,
    STATSIG_LOCAL_STORAGE_LOGGING_REQUEST_KEY: true
};

});

parcelRegister("jDn9b", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getUserCacheKey = module.exports.getSortedObject = module.exports.djb2HashForObject = module.exports.getHashValue = module.exports.SimpleHash = void 0;
function $e4b39d639f9fb0a3$var$SimpleHash(value) {
    var hash = 0;
    for(var i = 0; i < value.length; i++){
        var character = value.charCodeAt(i);
        hash = (hash << 5) - hash + character;
        hash = hash & hash; // Convert to 32bit integer
    }
    return String(hash >>> 0);
}
module.exports.SimpleHash = $e4b39d639f9fb0a3$var$SimpleHash;
function $e4b39d639f9fb0a3$var$getHashValue(value, hash_used) {
    if (hash_used === "none") return value;
    return $e4b39d639f9fb0a3$var$SimpleHash(value);
}
module.exports.getHashValue = $e4b39d639f9fb0a3$var$getHashValue;
function $e4b39d639f9fb0a3$var$djb2HashForObject(object) {
    return $e4b39d639f9fb0a3$var$SimpleHash(JSON.stringify($e4b39d639f9fb0a3$var$getSortedObject(object)));
}
module.exports.djb2HashForObject = $e4b39d639f9fb0a3$var$djb2HashForObject;
function $e4b39d639f9fb0a3$var$getSortedObject(object) {
    if (object == null) return null;
    var keys = Object.keys(object).sort();
    var sortedObject = {};
    keys.forEach(function(key) {
        var value = object[key];
        if (value instanceof Object) value = $e4b39d639f9fb0a3$var$getSortedObject(value);
        sortedObject[key] = value;
    });
    return sortedObject;
}
module.exports.getSortedObject = $e4b39d639f9fb0a3$var$getSortedObject;
function $e4b39d639f9fb0a3$var$getUserCacheKey(user) {
    var _a;
    var key = "userID:".concat(String((_a = user === null || user === void 0 ? void 0 : user.userID) !== null && _a !== void 0 ? _a : ""));
    var customIDs = user === null || user === void 0 ? void 0 : user.customIDs;
    if (customIDs != null) for(var _i = 0, _b = Object.entries(customIDs); _i < _b.length; _i++){
        var _c = _b[_i], type = _c[0], value = _c[1];
        key += ";".concat(type, ":").concat(value);
    }
    return $e4b39d639f9fb0a3$var$SimpleHash(key);
}
module.exports.getUserCacheKey = $e4b39d639f9fb0a3$var$getUserCacheKey;

});

parcelRegister("2klGt", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $1b1e4508bab18d85$var$StatsigLocalStorage = /** @class */ function() {
    function StatsigLocalStorage() {}
    StatsigLocalStorage.getItem = function(key) {
        var _a;
        try {
            if (this.isStorageAccessible()) return window.localStorage.getItem(key);
        } catch (e) {}
        return (_a = this.fallbackSessionCache[key]) !== null && _a !== void 0 ? _a : null;
    };
    StatsigLocalStorage.setItem = function(key, value) {
        try {
            if (this.isStorageAccessible()) {
                window.localStorage.setItem(key, value);
                return;
            }
        } catch (e) {}
        this.fallbackSessionCache[key] = value;
    };
    StatsigLocalStorage.removeItem = function(key) {
        try {
            if (this.isStorageAccessible()) {
                window.localStorage.removeItem(key);
                return;
            }
        } catch (e) {}
        delete this.fallbackSessionCache[key];
    };
    StatsigLocalStorage.isStorageAccessible = function(ignoreDisabledOption) {
        if (ignoreDisabledOption === void 0) ignoreDisabledOption = false;
        if (this.canAccessStorageAccessible == null) this.canAccessStorageAccessible = typeof Storage !== "undefined" && typeof window !== "undefined" && window != null && window.localStorage != null;
        var canAccess = this.canAccessStorageAccessible;
        if (ignoreDisabledOption) return canAccess;
        return !this.disabled && canAccess;
    };
    StatsigLocalStorage.disabled = false;
    StatsigLocalStorage.fallbackSessionCache = {};
    StatsigLocalStorage.canAccessStorageAccessible = null;
    return StatsigLocalStorage;
}();
module.exports.default = $1b1e4508bab18d85$var$StatsigLocalStorage;

});

parcelRegister("dOtZb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.version = void 0;
// Generated by genversion.
module.exports.version = "1.6.0";

});


parcelRegister("3AB9J", function(module, exports) {
"use strict";
var $29d18e4a5c0c0006$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $29d18e4a5c0c0006$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $29d18e4a5c0c0006$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $29d18e4a5c0c0006$var$LogEvent_1 = $29d18e4a5c0c0006$var$__importDefault((parcelRequire("22SUv")));

var $bTkP2 = parcelRequire("bTkP2");

var $eH4EZ = parcelRequire("eH4EZ");

var $29d18e4a5c0c0006$var$StatsigLocalStorage_1 = $29d18e4a5c0c0006$var$__importDefault((parcelRequire("2klGt")));
var $29d18e4a5c0c0006$var$INTERNAL_EVENT_PREFIX = "statsig::";
var $29d18e4a5c0c0006$var$CONFIG_EXPOSURE_EVENT = $29d18e4a5c0c0006$var$INTERNAL_EVENT_PREFIX + "config_exposure";
var $29d18e4a5c0c0006$var$LAYER_EXPOSURE_EVENT = $29d18e4a5c0c0006$var$INTERNAL_EVENT_PREFIX + "layer_exposure";
var $29d18e4a5c0c0006$var$GATE_EXPOSURE_EVENT = $29d18e4a5c0c0006$var$INTERNAL_EVENT_PREFIX + "gate_exposure";
var $29d18e4a5c0c0006$var$LOG_FAILURE_EVENT = $29d18e4a5c0c0006$var$INTERNAL_EVENT_PREFIX + "log_event_failed";
var $29d18e4a5c0c0006$var$DEFAULT_VALUE_WARNING = $29d18e4a5c0c0006$var$INTERNAL_EVENT_PREFIX + "default_value_type_mismatch";
var $29d18e4a5c0c0006$var$MS_RETRY_LOGS_CUTOFF = 432000000;
var $29d18e4a5c0c0006$var$MAX_BATCHES_TO_RETRY = 100;
var $29d18e4a5c0c0006$var$MAX_FAILED_EVENTS = 1000;
var $29d18e4a5c0c0006$var$MAX_LOCAL_STORAGE_SIZE = 1024 * $29d18e4a5c0c0006$var$MAX_FAILED_EVENTS;
var $29d18e4a5c0c0006$var$StatsigLogger = /** @class */ function() {
    function StatsigLogger(options, identity, network, errorBoundary) {
        var _this = this;
        this._failedLogEventCount = 0;
        this.logConfigDefaultValueFallback = function(user, message, metadata) {
            var defaultValueEvent = (0, $29d18e4a5c0c0006$var$LogEvent_1.default)($29d18e4a5c0c0006$var$DEFAULT_VALUE_WARNING, user, _this._identity._statsigMetadata, message, metadata);
            _this.log(defaultValueEvent);
            _this._loggedErrors.add(message);
        };
        this._options = options;
        this._identity = identity;
        this._network = network;
        this._errorBoundary = errorBoundary;
        this._queue = [];
        this._flushInterval = null;
        this._loggedErrors = new Set();
        this._failedLogEvents = [];
        this._exposureDedupeKeys = {};
        this._failedLogEventCount = 0;
        this._init();
    }
    StatsigLogger.prototype.log = function(event) {
        if (this._options.disableAllLogging) return;
        try {
            if (!this._options.disableCurrentPageLogging && typeof window !== "undefined" && window != null && typeof window.location === "object" && typeof window.location.href === "string") {
                // https://stackoverflow.com/questions/6257463/how-to-get-the-url-without-any-parameters-in-javascript
                var parts = window.location.href.split(/[?#]/);
                if ((parts === null || parts === void 0 ? void 0 : parts.length) > 0) event.statsigMetadata.currentPage = parts[0];
            }
        } catch (_e) {}
        this._queue.push(event);
        if (this._queue.length >= this._options.loggingBufferMaxSize) this.flush();
    };
    StatsigLogger.prototype.resetDedupeKeys = function() {
        this._exposureDedupeKeys = {};
    };
    StatsigLogger.prototype.logGateExposure = function(user, gateName, gateValue, ruleID, secondaryExposures, details, isManualExposure, bootstrapMetadata) {
        var dedupeKey = gateName + String(gateValue) + ruleID + details.reason;
        if (!this._shouldLogExposure(dedupeKey)) return;
        var metadata = {
            gate: gateName,
            gateValue: String(gateValue),
            ruleID: ruleID,
            reason: details.reason,
            time: details.time
        };
        if (isManualExposure) metadata["isManualExposure"] = "true";
        if (bootstrapMetadata != null) metadata["bootstrapMetadata"] = bootstrapMetadata;
        var gateExposure = (0, $29d18e4a5c0c0006$var$LogEvent_1.default)($29d18e4a5c0c0006$var$GATE_EXPOSURE_EVENT, user, this._identity._statsigMetadata, null, metadata, secondaryExposures);
        this.log(gateExposure);
    };
    StatsigLogger.prototype.logConfigExposure = function(user, configName, ruleID, secondaryExposures, details, isManualExposure, bootstrapMetadata) {
        var dedupeKey = configName + ruleID + details.reason;
        if (!this._shouldLogExposure(dedupeKey)) return;
        var metadata = {
            config: configName,
            ruleID: ruleID,
            reason: details.reason,
            time: details.time
        };
        if (isManualExposure) metadata["isManualExposure"] = "true";
        if (bootstrapMetadata != null) metadata["bootstrapMetadata"] = bootstrapMetadata;
        var configExposure = (0, $29d18e4a5c0c0006$var$LogEvent_1.default)($29d18e4a5c0c0006$var$CONFIG_EXPOSURE_EVENT, user, this._identity._statsigMetadata, null, metadata, secondaryExposures);
        this.log(configExposure);
    };
    StatsigLogger.prototype.logLayerExposure = function(user, configName, ruleID, secondaryExposures, allocatedExperiment, parameterName, isExplicitParameter, details, isManualExposure, bootstrapMetadata) {
        var dedupeKey = [
            configName,
            ruleID,
            allocatedExperiment,
            parameterName,
            String(isExplicitParameter),
            details.reason
        ].join("|");
        if (!this._shouldLogExposure(dedupeKey)) return;
        var metadata = {
            config: configName,
            ruleID: ruleID,
            allocatedExperiment: allocatedExperiment,
            parameterName: parameterName,
            isExplicitParameter: String(isExplicitParameter),
            reason: details.reason,
            time: details.time
        };
        if (isManualExposure) metadata["isManualExposure"] = "true";
        if (bootstrapMetadata != null) metadata["bootstrapMetadata"] = bootstrapMetadata;
        var configExposure = (0, $29d18e4a5c0c0006$var$LogEvent_1.default)($29d18e4a5c0c0006$var$LAYER_EXPOSURE_EVENT, user, this._identity._statsigMetadata, null, metadata, secondaryExposures);
        this.log(configExposure);
    };
    StatsigLogger.prototype.shutdown = function() {
        if (this._flushInterval) {
            clearInterval(this._flushInterval);
            this._flushInterval = null;
        }
        this.flush(true);
    };
    StatsigLogger.prototype.flush = function(isClosing) {
        var _this = this;
        if (isClosing === void 0) isClosing = false;
        if (this._queue.length === 0) return;
        var statsigMetadata = this._identity._statsigMetadata;
        var oldQueue = this._queue;
        this._queue = [];
        if (isClosing && !this._network.supportsKeepalive() && typeof navigator !== "undefined" && navigator != null && // @ts-ignore
        navigator.sendBeacon) {
            var beacon = this._network.sendLogBeacon({
                events: oldQueue,
                statsigMetadata: statsigMetadata
            });
            if (!beacon) {
                this._queue = oldQueue.concat(this._queue);
                if (this._queue.length > 0) {
                    this._addFailedRequest({
                        events: this._queue,
                        statsigMetadata: statsigMetadata,
                        time: Date.now()
                    });
                    this._queue = [];
                }
                this._saveFailedRequests();
            }
            return;
        }
        var processor = this;
        this._network.postToEndpoint($bTkP2.StatsigEndpoint.Rgstr, {
            events: oldQueue,
            statsigMetadata: statsigMetadata
        }, 3 /* retries */ , 1000 /* backoff */ , 0 /* retry attempt */ , isClosing /* useKeepalive */ ).then(function(response) {
            if (!response.ok) throw response;
        }).catch(function(error) {
            if (typeof error.text === "function") error.text().then(function(errorText) {
                _this._errorBoundary._logError($29d18e4a5c0c0006$var$LOG_FAILURE_EVENT, error, function() {
                    return $29d18e4a5c0c0006$var$__awaiter(_this, void 0, void 0, function() {
                        return $29d18e4a5c0c0006$var$__generator(this, function(_a) {
                            return [
                                2 /*return*/ ,
                                {
                                    eventCount: oldQueue.length,
                                    error: errorText
                                }
                            ];
                        });
                    });
                });
            });
            else _this._errorBoundary._logError($29d18e4a5c0c0006$var$LOG_FAILURE_EVENT, error, function() {
                return $29d18e4a5c0c0006$var$__awaiter(_this, void 0, void 0, function() {
                    return $29d18e4a5c0c0006$var$__generator(this, function(_a) {
                        return [
                            2 /*return*/ ,
                            {
                                eventCount: oldQueue.length,
                                error: error.message
                            }
                        ];
                    });
                });
            });
            processor._newFailedRequest($29d18e4a5c0c0006$var$LOG_FAILURE_EVENT, oldQueue);
        }).finally(function() {
            return $29d18e4a5c0c0006$var$__awaiter(_this, void 0, void 0, function() {
                return $29d18e4a5c0c0006$var$__generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            if (!isClosing) return [
                                3 /*break*/ ,
                                2
                            ];
                            if (this._queue.length > 0) {
                                this._addFailedRequest({
                                    events: this._queue,
                                    statsigMetadata: statsigMetadata,
                                    time: Date.now()
                                });
                                // on app background/window blur, save unsent events as a request and clean up the queue (in case app foregrounds)
                                this._queue = [];
                            }
                            return [
                                4 /*yield*/ ,
                                processor._saveFailedRequests()
                            ];
                        case 1:
                            _a.sent();
                            _a.label = 2;
                        case 2:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        });
    };
    StatsigLogger.prototype.sendSavedRequests = function() {
        return $29d18e4a5c0c0006$var$__awaiter(this, void 0, void 0, function() {
            var failedRequests, fireAndForget, requestBodies, _loop_1, this_1, _i, requestBodies_1, requestBody;
            var _this = this;
            return $29d18e4a5c0c0006$var$__generator(this, function(_a) {
                fireAndForget = false;
                failedRequests = $29d18e4a5c0c0006$var$StatsigLocalStorage_1.default.getItem($eH4EZ.STATSIG_LOCAL_STORAGE_LOGGING_REQUEST_KEY);
                if (failedRequests == null) {
                    this._clearLocalStorageRequests();
                    return [
                        2 /*return*/ 
                    ];
                }
                if (failedRequests.length > $29d18e4a5c0c0006$var$MAX_LOCAL_STORAGE_SIZE) fireAndForget = true;
                requestBodies = [];
                try {
                    requestBodies = JSON.parse(failedRequests);
                    _loop_1 = function(requestBody) {
                        if (requestBody != null && requestBody.events && Array.isArray(requestBody.events)) this_1._network.postToEndpoint($bTkP2.StatsigEndpoint.Rgstr, requestBody).then(function(response) {
                            if (!response.ok) throw Error(response.status + "");
                        }).catch(function(_e) {
                            if (fireAndForget) return;
                            _this._addFailedRequest(requestBody);
                        });
                    };
                    this_1 = this;
                    for(_i = 0, requestBodies_1 = requestBodies; _i < requestBodies_1.length; _i++){
                        requestBody = requestBodies_1[_i];
                        _loop_1(requestBody);
                    }
                } catch (_e) {} finally{
                    this._clearLocalStorageRequests();
                }
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    StatsigLogger.prototype._init = function() {
        var _this = this;
        if (typeof window !== "undefined" && typeof window.addEventListener === "function") {
            window.addEventListener("blur", function() {
                return _this.flush(true);
            });
            window.addEventListener("beforeunload", function() {
                return _this.flush(true);
            });
            window.addEventListener("load", function() {
                setTimeout(function() {
                    return _this.flush();
                }, 100);
                setTimeout(function() {
                    return _this.flush();
                }, 1000);
            });
        }
        if (typeof document !== "undefined" && typeof document.addEventListener === "function") document.addEventListener("visibilitychange", function() {
            _this.flush(document.visibilityState !== "visible");
        });
        if (!this._options.ignoreWindowUndefined && (typeof window === "undefined" || window == null)) // dont set the flush interval outside of client browser environments
        return;
        if (this._options.localMode) // unnecessary interval in local mode since logs dont flush anyway
        return;
        var me = this;
        this._flushInterval = setInterval(function() {
            me.flush();
        }, this._options.loggingIntervalMillis);
        // Quick flush
        setTimeout(function() {
            return _this.flush();
        }, 100);
        setTimeout(function() {
            return _this.flush();
        }, 1000);
    };
    StatsigLogger.prototype._shouldLogExposure = function(key) {
        var lastTime = this._exposureDedupeKeys[key];
        var now = Date.now();
        if (lastTime == null) {
            this._exposureDedupeKeys[key] = now;
            return true;
        }
        if (lastTime >= now - 600000) return false;
        this._exposureDedupeKeys[key] = now;
        return true;
    };
    StatsigLogger.prototype._saveFailedRequests = function() {
        return $29d18e4a5c0c0006$var$__awaiter(this, void 0, void 0, function() {
            var requestsCopy;
            return $29d18e4a5c0c0006$var$__generator(this, function(_a) {
                if (this._failedLogEvents.length > 0) {
                    requestsCopy = JSON.stringify(this._failedLogEvents);
                    if (requestsCopy.length > $29d18e4a5c0c0006$var$MAX_LOCAL_STORAGE_SIZE) {
                        this._clearLocalStorageRequests();
                        return [
                            2 /*return*/ 
                        ];
                    }
                    $29d18e4a5c0c0006$var$StatsigLocalStorage_1.default.setItem($eH4EZ.STATSIG_LOCAL_STORAGE_LOGGING_REQUEST_KEY, requestsCopy);
                }
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    StatsigLogger.prototype._addFailedRequest = function(requestBody) {
        if (requestBody.time < Date.now() - $29d18e4a5c0c0006$var$MS_RETRY_LOGS_CUTOFF) return;
        if (this._failedLogEvents.length > $29d18e4a5c0c0006$var$MAX_BATCHES_TO_RETRY) return;
        var additionalEvents = requestBody.events.length;
        if (this._failedLogEventCount + additionalEvents > $29d18e4a5c0c0006$var$MAX_FAILED_EVENTS) return;
        this._failedLogEvents.push(requestBody);
        this._failedLogEventCount += additionalEvents;
    };
    StatsigLogger.prototype._clearLocalStorageRequests = function() {
        $29d18e4a5c0c0006$var$StatsigLocalStorage_1.default.removeItem($eH4EZ.STATSIG_LOCAL_STORAGE_LOGGING_REQUEST_KEY);
    };
    StatsigLogger.prototype._newFailedRequest = function(name, queue) {
        if (this._loggedErrors.has(name)) return;
        this._loggedErrors.add(name);
        this._failedLogEvents.push({
            events: queue,
            statsigMetadata: this._identity._statsigMetadata,
            time: Date.now()
        });
        this._saveFailedRequests().then(function() {});
    };
    return StatsigLogger;
}();
module.exports.default = $29d18e4a5c0c0006$var$StatsigLogger;

});
parcelRegister("22SUv", function(module, exports) {
"use strict";
var $17d65cb9738bca62$var$__assign = module.exports && module.exports.__assign || function() {
    $17d65cb9738bca62$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $17d65cb9738bca62$var$__assign.apply(this, arguments);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
function $17d65cb9738bca62$var$makeLogEvent(eventName, user, statsigMetadata, value, metadata, secondaryExposures) {
    if (value === void 0) value = null;
    if (metadata === void 0) metadata = null;
    var logUser = user;
    if (logUser === null || logUser === void 0 ? void 0 : logUser.privateAttributes) {
        logUser = $17d65cb9738bca62$var$__assign({}, user);
        delete logUser.privateAttributes;
    }
    return {
        time: Date.now(),
        eventName: eventName,
        statsigMetadata: statsigMetadata,
        user: logUser,
        value: value,
        metadata: metadata,
        secondaryExposures: secondaryExposures
    };
}
module.exports.default = $17d65cb9738bca62$var$makeLogEvent;

});

parcelRegister("bTkP2", function(module, exports) {
"use strict";
var $8a84fb9e1d6950b6$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $8a84fb9e1d6950b6$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StatsigEndpoint = void 0;
var $8a84fb9e1d6950b6$var$StatsigEndpoint;
(function(StatsigEndpoint) {
    StatsigEndpoint["Initialize"] = "initialize";
    StatsigEndpoint["Rgstr"] = "rgstr";
    StatsigEndpoint["LogEventBeacon"] = "log_event_beacon";
})($8a84fb9e1d6950b6$var$StatsigEndpoint = module.exports.StatsigEndpoint || (module.exports.StatsigEndpoint = {}));
var $8a84fb9e1d6950b6$var$NO_CONTENT = 204;
var $8a84fb9e1d6950b6$var$StatsigNetwork = /** @class */ function() {
    function StatsigNetwork(options, identity, errorBoundary) {
        this.retryCodes = {
            408: true,
            500: true,
            502: true,
            503: true,
            504: true,
            522: true,
            524: true,
            599: true
        };
        this.canUseKeepalive = false;
        this._options = options;
        this._identity = identity;
        this._errorBoundary = errorBoundary;
        this.leakyBucket = {};
        this._init();
    }
    StatsigNetwork.prototype.fetchValues = function(user, sinceTime, timeout, previousDerivedFields) {
        var input = {
            user: user,
            statsigMetadata: this._identity._statsigMetadata,
            sinceTime: sinceTime !== null && sinceTime !== void 0 ? sinceTime : undefined,
            hash: "djb2",
            previousDerivedFields: previousDerivedFields
        };
        return this._postWithTimeout($8a84fb9e1d6950b6$var$StatsigEndpoint.Initialize, input, timeout, 3);
    };
    StatsigNetwork.prototype.sendLogBeacon = function(payload) {
        if (this._options.localMode) return true;
        var url = new URL(this._options.eventLoggingApi + $8a84fb9e1d6950b6$var$StatsigEndpoint.LogEventBeacon);
        url.searchParams.append("k", this._identity._sdkKey);
        payload.clientTime = Date.now() + "";
        var stringPayload = null;
        try {
            stringPayload = JSON.stringify(payload);
        } catch (_e) {
            return false;
        }
        return navigator.sendBeacon(url.toString(), stringPayload);
    };
    StatsigNetwork.prototype.postToEndpoint = function(endpointName, body, retries, backoff, retryAttempt, useKeepalive) {
        if (retries === void 0) retries = 0;
        if (backoff === void 0) backoff = 1000;
        if (retryAttempt === void 0) retryAttempt = 0;
        if (useKeepalive === void 0) useKeepalive = false;
        return $8a84fb9e1d6950b6$var$__awaiter(this, void 0, void 0, function() {
            var api, url, counter, postBody, statsigMetadata, params;
            var _this = this;
            return $8a84fb9e1d6950b6$var$__generator(this, function(_a) {
                if (this._options.localMode) return [
                    2 /*return*/ ,
                    Promise.reject("no network requests in localMode")
                ];
                if (typeof fetch !== "function") // fetch is not defined in this environment, short circuit
                return [
                    2 /*return*/ ,
                    Promise.reject("fetch is not defined")
                ];
                if (typeof window === "undefined" && !this._options.ignoreWindowUndefined) // by default, dont issue requests from the server
                return [
                    2 /*return*/ ,
                    Promise.reject("window is not defined")
                ];
                api = [
                    $8a84fb9e1d6950b6$var$StatsigEndpoint.Initialize
                ].includes(endpointName) ? this._options.api : retryAttempt > 0 ? this._options.eventLoggingApiForRetries : this._options.eventLoggingApi;
                url = api + endpointName;
                counter = this.leakyBucket[url];
                if (counter != null && counter >= 30) return [
                    2 /*return*/ ,
                    Promise.reject(new Error("Request failed because you are making the same request too frequently."))
                ];
                if (counter == null) this.leakyBucket[url] = 1;
                else this.leakyBucket[url] = counter + 1;
                postBody = JSON.stringify(body);
                statsigMetadata = this._identity._statsigMetadata;
                params = {
                    method: "POST",
                    body: postBody,
                    headers: {
                        "Content-type": "application/json; charset=UTF-8",
                        "STATSIG-API-KEY": this._identity._sdkKey,
                        "STATSIG-CLIENT-TIME": Date.now() + "",
                        "STATSIG-SDK-TYPE": statsigMetadata.sdkType,
                        "STATSIG-SDK-VERSION": statsigMetadata.sdkVersion
                    }
                };
                if (this.canUseKeepalive && useKeepalive) params.keepalive = true;
                return [
                    2 /*return*/ ,
                    fetch(url, params).then(function(res) {
                        return $8a84fb9e1d6950b6$var$__awaiter(_this, void 0, void 0, function() {
                            var networkResponse, text, errorText;
                            return $8a84fb9e1d6950b6$var$__generator(this, function(_a) {
                                switch(_a.label){
                                    case 0:
                                        if (!res.ok) return [
                                            3 /*break*/ ,
                                            4
                                        ];
                                        networkResponse = res;
                                        if (!(res.status === $8a84fb9e1d6950b6$var$NO_CONTENT)) return [
                                            3 /*break*/ ,
                                            1
                                        ];
                                        networkResponse.data = {
                                            has_updates: false,
                                            is_no_content: true
                                        };
                                        return [
                                            3 /*break*/ ,
                                            3
                                        ];
                                    case 1:
                                        return [
                                            4 /*yield*/ ,
                                            res.text()
                                        ];
                                    case 2:
                                        text = _a.sent();
                                        networkResponse.data = JSON.parse(text);
                                        _a.label = 3;
                                    case 3:
                                        return [
                                            2 /*return*/ ,
                                            Promise.resolve(networkResponse)
                                        ];
                                    case 4:
                                        if (!this.retryCodes[res.status]) retries = 0;
                                        return [
                                            4 /*yield*/ ,
                                            res.text()
                                        ];
                                    case 5:
                                        errorText = _a.sent();
                                        return [
                                            2 /*return*/ ,
                                            Promise.reject(new Error("".concat(res.status, ": ").concat(errorText)))
                                        ];
                                }
                            });
                        });
                    }).catch(function(e) {
                        if (retries > 0) return new Promise(function(resolve, reject) {
                            setTimeout(function() {
                                _this.leakyBucket[url] = Math.max(_this.leakyBucket[url] - 1, 0);
                                _this.postToEndpoint(endpointName, body, retries - 1, backoff * 2, retryAttempt + 1, useKeepalive).then(resolve).catch(reject);
                            }, backoff);
                        });
                        return Promise.reject(e);
                    }).finally(function() {
                        _this.leakyBucket[url] = Math.max(_this.leakyBucket[url] - 1, 0);
                    })
                ];
            });
        });
    };
    StatsigNetwork.prototype.supportsKeepalive = function() {
        return this.canUseKeepalive;
    };
    StatsigNetwork.prototype._init = function() {
        if (!this._options.disableNetworkKeepalive) try {
            this.canUseKeepalive = "keepalive" in new Request("");
        } catch (_e) {}
    };
    StatsigNetwork.prototype._postWithTimeout = function(endpointName, body, timeout, retries, backoff) {
        var _this = this;
        if (timeout === void 0) timeout = 0;
        if (retries === void 0) retries = 0;
        if (backoff === void 0) backoff = 1000;
        var hasTimedOut = false;
        var timer = null;
        var cachedReturnValue = null;
        var eventuals = [];
        var eventually = function(boundScope) {
            return function(fn) {
                if (hasTimedOut && cachedReturnValue) fn(cachedReturnValue);
                else eventuals.push(fn);
                return boundScope;
            };
        };
        if (timeout != 0) timer = new Promise(function(resolve, reject) {
            setTimeout(function() {
                hasTimedOut = true;
                reject(new Error("The initialization timeout of ".concat(timeout, "ms has been hit before the network request has completed.")));
            }, timeout);
        });
        var fetchPromise = this.postToEndpoint(endpointName, body, retries, backoff).then(function(res) {
            if (!res.ok) return Promise.reject(new Error("Request to ".concat(endpointName, " failed with status ").concat(res.status)));
            if (typeof res.data !== "object") {
                var error = new Error("Request to ".concat(endpointName, " received invalid response type. Expected 'object' but got '").concat(typeof res.data, "'"));
                _this._errorBoundary._logError("postWithTimeoutInvalidRes", error, function() {
                    return $8a84fb9e1d6950b6$var$__awaiter(_this, void 0, void 0, function() {
                        return $8a84fb9e1d6950b6$var$__generator(this, function(_a) {
                            return [
                                2 /*return*/ ,
                                this._getErrorData(endpointName, body, retries, backoff, res)
                            ];
                        });
                    });
                });
                return Promise.reject(error);
            }
            var json = res.data;
            return _this._errorBoundary._capture("postWithTimeout", function() {
                return $8a84fb9e1d6950b6$var$__awaiter(_this, void 0, void 0, function() {
                    return $8a84fb9e1d6950b6$var$__generator(this, function(_a) {
                        cachedReturnValue = json;
                        if (hasTimedOut) {
                            eventuals.forEach(function(fn) {
                                return fn(json);
                            });
                            eventuals = [];
                        }
                        return [
                            2 /*return*/ ,
                            Promise.resolve(json)
                        ];
                    });
                });
            }, function() {
                return Promise.resolve({});
            }, function() {
                return $8a84fb9e1d6950b6$var$__awaiter(_this, void 0, void 0, function() {
                    return $8a84fb9e1d6950b6$var$__generator(this, function(_a) {
                        return [
                            2 /*return*/ ,
                            this._getErrorData(endpointName, body, retries, backoff, res)
                        ];
                    });
                });
            });
        }).catch(function(e) {
            return Promise.reject(e);
        });
        var racingPromise = timer ? Promise.race([
            fetchPromise,
            timer
        ]) : fetchPromise;
        racingPromise.eventually = eventually(racingPromise);
        return racingPromise;
    };
    StatsigNetwork.prototype._getErrorData = function(endpointName, body, retries, backoff, res) {
        var _a;
        return $8a84fb9e1d6950b6$var$__awaiter(this, void 0, void 0, function() {
            var headers_1;
            return $8a84fb9e1d6950b6$var$__generator(this, function(_b) {
                try {
                    headers_1 = {};
                    ((_a = res.headers) !== null && _a !== void 0 ? _a : []).forEach(function(value, key) {
                        headers_1[key] = value;
                    });
                    return [
                        2 /*return*/ ,
                        {
                            responseInfo: {
                                headers: headers_1,
                                status: res.status,
                                statusText: res.statusText,
                                type: res.type,
                                url: res.url,
                                redirected: res.redirected,
                                bodySnippet: res.data ? JSON.stringify(res.data).slice(0, 500) : null
                            },
                            requestInfo: {
                                endpointName: endpointName,
                                bodySnippet: JSON.stringify(body).slice(0, 500),
                                retries: retries,
                                backoff: backoff
                            }
                        }
                    ];
                } catch (_e) {
                    return [
                        2 /*return*/ ,
                        {
                            statusText: "statsig::failed to extract extra data"
                        }
                    ];
                }
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    return StatsigNetwork;
}();
module.exports.default = $8a84fb9e1d6950b6$var$StatsigNetwork;

});


parcelRegister("7LDvt", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.INIT_TIMEOUT_DEFAULT_MS = void 0;
var $5a7b91634cf17e43$var$DEFAULT_FEATURE_GATE_API = "https://featuregates.org/v1/";
var $5a7b91634cf17e43$var$DEFAULT_EVENT_LOGGING_API = "https://events.statsigapi.net/v1/";
module.exports.INIT_TIMEOUT_DEFAULT_MS = 3000;
var $5a7b91634cf17e43$var$StatsigSDKOptions = /** @class */ function() {
    function StatsigSDKOptions(options) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r;
        if (options == null) options = {};
        var api = (_a = options.api) !== null && _a !== void 0 ? _a : $5a7b91634cf17e43$var$DEFAULT_FEATURE_GATE_API;
        this.api = api.endsWith("/") ? api : api + "/";
        this.disableCurrentPageLogging = (_b = options.disableCurrentPageLogging) !== null && _b !== void 0 ? _b : false;
        this.environment = (_c = options.environment) !== null && _c !== void 0 ? _c : null;
        this.loggingIntervalMillis = this.normalizeNumberInput(options.loggingIntervalMillis, {
            default: 10000,
            min: 1000,
            max: 60000
        });
        this.loggingBufferMaxSize = this.normalizeNumberInput(options.loggingBufferMaxSize, {
            default: 100,
            min: 2,
            max: 500
        });
        this.disableNetworkKeepalive = (_d = options.disableNetworkKeepalive) !== null && _d !== void 0 ? _d : false;
        this.overrideStableID = (_e = options.overrideStableID) !== null && _e !== void 0 ? _e : null;
        this.localMode = (_f = options.localMode) !== null && _f !== void 0 ? _f : false;
        this.initTimeoutMs = options.initTimeoutMs && options.initTimeoutMs >= 0 ? options.initTimeoutMs : module.exports.INIT_TIMEOUT_DEFAULT_MS;
        this.disableErrorLogging = (_g = options.disableErrorLogging) !== null && _g !== void 0 ? _g : false;
        this.disableAutoMetricsLogging = (_h = options.disableAutoMetricsLogging) !== null && _h !== void 0 ? _h : false;
        this.initializeValues = (_j = options.initializeValues) !== null && _j !== void 0 ? _j : null;
        var eventLoggingApi = (_l = (_k = options.eventLoggingApi) !== null && _k !== void 0 ? _k : options.api) !== null && _l !== void 0 ? _l : $5a7b91634cf17e43$var$DEFAULT_EVENT_LOGGING_API;
        this.eventLoggingApi = eventLoggingApi.endsWith("/") ? eventLoggingApi : eventLoggingApi + "/";
        var eventLoggingApiForRetries = (_m = options.eventLoggingApiForRetries) !== null && _m !== void 0 ? _m : eventLoggingApi;
        this.eventLoggingApiForRetries = eventLoggingApiForRetries.endsWith("/") ? eventLoggingApiForRetries : eventLoggingApiForRetries + "/";
        this.disableLocalStorage = (_o = options.disableLocalStorage) !== null && _o !== void 0 ? _o : false;
        this.ignoreWindowUndefined = (_p = options === null || options === void 0 ? void 0 : options.ignoreWindowUndefined) !== null && _p !== void 0 ? _p : false;
        this.updateUserCompletionCallback = (_q = options === null || options === void 0 ? void 0 : options.updateUserCompletionCallback) !== null && _q !== void 0 ? _q : null;
        this.disableAllLogging = (_r = options === null || options === void 0 ? void 0 : options.disableAllLogging) !== null && _r !== void 0 ? _r : false;
    }
    StatsigSDKOptions.prototype.normalizeNumberInput = function(input, bounds) {
        if (input == null) return bounds.default;
        return Math.max(Math.min(input, bounds.max), bounds.min);
    };
    return StatsigSDKOptions;
}();
module.exports.default = $5a7b91634cf17e43$var$StatsigSDKOptions;

});

parcelRegister("d3Tbn", function(module, exports) {
"use strict";
var $98265c44655259c5$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $98265c44655259c5$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $98265c44655259c5$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.EvaluationReason = void 0;

var $98265c44655259c5$var$DynamicConfig_1 = $98265c44655259c5$var$__importDefault((parcelRequire("6EuWr")));

var $98265c44655259c5$var$Layer_1 = $98265c44655259c5$var$__importDefault((parcelRequire("7tvtH")));

var $98265c44655259c5$var$BootstrapValidator_1 = $98265c44655259c5$var$__importDefault((parcelRequire("7Rwvg")));

var $eH4EZ = parcelRequire("eH4EZ");

var $jDn9b = parcelRequire("jDn9b");

var $98265c44655259c5$var$StatsigLocalStorage_1 = $98265c44655259c5$var$__importDefault((parcelRequire("2klGt")));
var $98265c44655259c5$var$EvaluationReason;
(function(EvaluationReason) {
    EvaluationReason["Network"] = "Network";
    EvaluationReason["Bootstrap"] = "Bootstrap";
    EvaluationReason["InvalidBootstrap"] = "InvalidBootstrap";
    EvaluationReason["Cache"] = "Cache";
    EvaluationReason["Unrecognized"] = "Unrecognized";
    EvaluationReason["Uninitialized"] = "Uninitialized";
    EvaluationReason["Error"] = "Error";
    EvaluationReason["NetworkNotModified"] = "NetworkNotModified";
    EvaluationReason["LocalOverride"] = "LocalOverride";
})($98265c44655259c5$var$EvaluationReason = module.exports.EvaluationReason || (module.exports.EvaluationReason = {}));
var $98265c44655259c5$var$MAX_USER_VALUE_CACHED = 10;
var $98265c44655259c5$var$StatsigStore = /** @class */ function() {
    function StatsigStore(identity, onDefaultValueFallback, initializeValues) {
        this._identity = identity;
        this._onDefaultValueFallback = onDefaultValueFallback;
        this._userCacheKey = this._identity.getUserCacheKey();
        this._values = {};
        this._userValues = this._getDefaultUserCacheValues();
        this._loaded = false;
        this._reason = $98265c44655259c5$var$EvaluationReason.Uninitialized;
        if (initializeValues) this.bootstrap(initializeValues);
        else this._loadFromLocalStorage();
    }
    StatsigStore.prototype.updateUser = function() {
        this._userCacheKey = this._identity.getUserCacheKey();
        return this._setUserValueFromCache();
    };
    StatsigStore.prototype.bootstrap = function(initializeValues) {
        var _a, _b, _c, _d, _f, _g, _h;
        var key = this._identity.getUserCacheKey();
        var user = this._identity._user;
        var reason = $98265c44655259c5$var$BootstrapValidator_1.default.isValid(user, initializeValues) ? $98265c44655259c5$var$EvaluationReason.Bootstrap : $98265c44655259c5$var$EvaluationReason.InvalidBootstrap;
        // clients are going to assume that the SDK is bootstrapped after this method runs
        // if we fail to parse, we will fall back to defaults, but we dont want to throw
        // when clients try to check gates/configs/etc after this point
        this._loaded = true;
        try {
            this._userValues.feature_gates = (_a = initializeValues.feature_gates) !== null && _a !== void 0 ? _a : {};
            this._userValues.dynamic_configs = (_b = initializeValues.dynamic_configs) !== null && _b !== void 0 ? _b : {};
            this._userValues.layer_configs = (_c = initializeValues.layer_configs) !== null && _c !== void 0 ? _c : {};
            this._userValues.evaluation_time = Date.now();
            this._userValues.time = (_d = initializeValues.time) !== null && _d !== void 0 ? _d : Date.now();
            this._userValues.exposures = (_f = initializeValues.exposures) !== null && _f !== void 0 ? _f : [];
            this._userValues.hash_used = (_g = initializeValues.hash_used) !== null && _g !== void 0 ? _g : "djb2";
            this._values[key] = this._userValues;
            this._reason = reason;
            var generatorSDKInfo = (_h = initializeValues.sdkInfo) !== null && _h !== void 0 ? _h : initializeValues.sdk_info;
            this._userValues.bootstrapMetadata = {};
            if (generatorSDKInfo != null) this._userValues.bootstrapMetadata.generatorSDKInfo = generatorSDKInfo;
            if (initializeValues.user != null) this._userValues.bootstrapMetadata.user = initializeValues.user;
            if (initializeValues.time != null) this._userValues.bootstrapMetadata.lcut = initializeValues.time;
        } catch (_e) {
            return;
        }
    };
    StatsigStore.prototype.getBootstrapMetadata = function() {
        var _a;
        return (_a = this._userValues.bootstrapMetadata) !== null && _a !== void 0 ? _a : null;
    };
    StatsigStore.prototype.isLoaded = function() {
        return this._loaded;
    };
    StatsigStore.prototype.getLastUpdateTime = function(user) {
        var userHash = (0, $jDn9b.djb2HashForObject)(user);
        if (this._userValues.user_hash == userHash) return this._userValues.time;
        return null;
    };
    StatsigStore.prototype.getPreviousDerivedFields = function(user) {
        var userHash = (0, $jDn9b.djb2HashForObject)(user);
        if (this._userValues.user_hash == userHash) return this._userValues.derived_fields;
        return undefined;
    };
    StatsigStore.prototype.setEvaluationReason = function(evalReason) {
        this._reason = evalReason;
    };
    StatsigStore.prototype.save = function(user, jsonConfigs, updateState) {
        if (updateState === void 0) updateState = true;
        return $98265c44655259c5$var$__awaiter(this, void 0, void 0, function() {
            var requestedUserCacheKey, initResponse, userValues, _a;
            return $98265c44655259c5$var$__generator(this, function(_b) {
                switch(_b.label){
                    case 0:
                        requestedUserCacheKey = (0, $jDn9b.getUserCacheKey)(user);
                        initResponse = jsonConfigs;
                        this._mergeInitializeResponseIntoUserMap(initResponse, this._values, requestedUserCacheKey, user, function(userValues) {
                            return userValues;
                        });
                        if (updateState) {
                            userValues = this._values[requestedUserCacheKey];
                            if (userValues && requestedUserCacheKey && requestedUserCacheKey == this._userCacheKey) {
                                this._userValues = userValues;
                                this._reason = $98265c44655259c5$var$EvaluationReason.Network;
                            }
                        }
                        _a = this;
                        return [
                            4 /*yield*/ ,
                            this._writeValuesToStorage(this._values)
                        ];
                    case 1:
                        _a._values = _b.sent();
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    StatsigStore.prototype.checkGate = function(gateName) {
        var _a, _b;
        var gateNameHash = (0, $jDn9b.getHashValue)(gateName, this._userValues.hash_used);
        var gateValue = {
            name: gateName,
            value: false,
            rule_id: "",
            secondary_exposures: []
        };
        var details;
        var value = (_a = this._userValues) === null || _a === void 0 ? void 0 : _a.feature_gates[gateNameHash];
        if (value) gateValue = value;
        gateValue.secondary_exposures = this.mapExposures((_b = gateValue.secondary_exposures) !== null && _b !== void 0 ? _b : []);
        details = this._getEvaluationDetails(value != null);
        return {
            evaluationDetails: details,
            gate: gateValue
        };
    };
    StatsigStore.prototype.mapExposures = function(exposures) {
        var _this = this;
        return exposures.map(function(exposure) {
            var _a;
            if (typeof exposure === "string") return ((_a = _this._userValues.exposures) !== null && _a !== void 0 ? _a : {})[exposure];
            return exposure;
        });
    };
    StatsigStore.prototype.getConfig = function(configName) {
        var _a, _b;
        var configNameHash = (0, $jDn9b.getHashValue)(configName, this._userValues.hash_used);
        var configValue;
        var details;
        if (((_a = this._userValues) === null || _a === void 0 ? void 0 : _a.dynamic_configs[configNameHash]) != null) {
            var rawConfigValue = (_b = this._userValues) === null || _b === void 0 ? void 0 : _b.dynamic_configs[configNameHash];
            details = this._getEvaluationDetails(true);
            configValue = this._createDynamicConfig(configName, rawConfigValue, details);
        } else {
            details = this._getEvaluationDetails(false);
            configValue = new $98265c44655259c5$var$DynamicConfig_1.default(configName, {}, "", details);
        }
        return configValue;
    };
    StatsigStore.prototype.getLayer = function(logParameterFunction, layerName) {
        var _a, _b, _c, _d, _f;
        var latestValue = this._getLatestValue(layerName, "layer_configs");
        var details = this._getEvaluationDetails(latestValue != null);
        return $98265c44655259c5$var$Layer_1.default._create(layerName, (_a = latestValue === null || latestValue === void 0 ? void 0 : latestValue.value) !== null && _a !== void 0 ? _a : {}, (_b = latestValue === null || latestValue === void 0 ? void 0 : latestValue.rule_id) !== null && _b !== void 0 ? _b : "", details, logParameterFunction, this.mapExposures((_c = latestValue === null || latestValue === void 0 ? void 0 : latestValue.secondary_exposures) !== null && _c !== void 0 ? _c : []), this.mapExposures((_d = latestValue === null || latestValue === void 0 ? void 0 : latestValue.undelegated_secondary_exposures) !== null && _d !== void 0 ? _d : []), (_f = latestValue === null || latestValue === void 0 ? void 0 : latestValue.allocated_experiment_name) !== null && _f !== void 0 ? _f : "", latestValue === null || latestValue === void 0 ? void 0 : latestValue.explicit_parameters);
    };
    StatsigStore.prototype.getGlobalEvaluationDetails = function() {
        var _a, _b;
        return {
            reason: (_a = this._reason) !== null && _a !== void 0 ? _a : $98265c44655259c5$var$EvaluationReason.Uninitialized,
            time: (_b = this._userValues.evaluation_time) !== null && _b !== void 0 ? _b : 0
        };
    };
    StatsigStore.prototype._loadFromLocalStorage = function() {
        this._parseCachedValues($98265c44655259c5$var$StatsigLocalStorage_1.default.getItem($eH4EZ.INTERNAL_STORE_KEY));
        this._loaded = true;
    };
    StatsigStore.prototype._parseCachedValues = function(allValues) {
        try {
            this._values = allValues ? JSON.parse(allValues) : this._values;
            this._setUserValueFromCache();
        } catch (e) {
            // Cached value corrupted, remove cache
            this._removeFromStorage($eH4EZ.INTERNAL_STORE_KEY);
        }
    };
    StatsigStore.prototype._setUserValueFromCache = function() {
        var _a;
        var cachedValues = this._values[this._userCacheKey];
        if (cachedValues == null) {
            this._resetUserValues();
            this._reason = $98265c44655259c5$var$EvaluationReason.Uninitialized;
            return null;
        }
        this._userValues = cachedValues;
        this._reason = $98265c44655259c5$var$EvaluationReason.Cache;
        return (_a = cachedValues.evaluation_time) !== null && _a !== void 0 ? _a : 0;
    };
    StatsigStore.prototype._removeFromStorage = function(key) {
        $98265c44655259c5$var$StatsigLocalStorage_1.default.removeItem(key);
    };
    /**
     * Merges the provided init configs into the provided config map, according to the provided merge function
     */ StatsigStore.prototype._mergeInitializeResponseIntoUserMap = function(data, configMap, requestedUserCacheKey, user, mergeFn) {
        if (requestedUserCacheKey) {
            var requestedUserValues = this._convertAPIDataToCacheValues(data, requestedUserCacheKey);
            if (data.has_updates && data.time) {
                var userHash = (0, $jDn9b.djb2HashForObject)(user);
                requestedUserValues.user_hash = userHash;
            }
            configMap[requestedUserCacheKey] = mergeFn(requestedUserValues, requestedUserCacheKey);
        }
    };
    StatsigStore.prototype._getDefaultUserCacheValues = function() {
        return {
            feature_gates: {},
            layer_configs: {},
            dynamic_configs: {},
            time: 0,
            evaluation_time: 0,
            has_updates: false
        };
    };
    /**
     * Writes the provided values to storage, truncating down to
     * MAX_USER_VALUE_CACHED number entries.
     * @returns The truncated entry list
     */ StatsigStore.prototype._writeValuesToStorage = function(valuesToWrite) {
        return $98265c44655259c5$var$__awaiter(this, void 0, void 0, function() {
            var filteredValues;
            return $98265c44655259c5$var$__generator(this, function(_a) {
                filteredValues = Object.entries(valuesToWrite).sort(function(_a, _b) {
                    var _c, _d;
                    var a = _a[1];
                    var b = _b[1];
                    if (a == null) return 1;
                    if (b == null) return -1;
                    return ((_c = b === null || b === void 0 ? void 0 : b.evaluation_time) !== null && _c !== void 0 ? _c : b === null || b === void 0 ? void 0 : b.time) - ((_d = a === null || a === void 0 ? void 0 : a.evaluation_time) !== null && _d !== void 0 ? _d : a === null || a === void 0 ? void 0 : a.time);
                }).slice(0, $98265c44655259c5$var$MAX_USER_VALUE_CACHED);
                valuesToWrite = Object.fromEntries(filteredValues);
                $98265c44655259c5$var$StatsigLocalStorage_1.default.setItem($eH4EZ.INTERNAL_STORE_KEY, JSON.stringify(valuesToWrite));
                return [
                    2 /*return*/ ,
                    valuesToWrite
                ];
            });
        });
    };
    StatsigStore.prototype._getLatestValue = function(name, topLevelKey) {
        var _a, _b, _c, _d, _f;
        var hash = (0, $jDn9b.getHashValue)(name, this._userValues.hash_used);
        return (_c = (_b = (_a = this._userValues) === null || _a === void 0 ? void 0 : _a[topLevelKey]) === null || _b === void 0 ? void 0 : _b[hash]) !== null && _c !== void 0 ? _c : (_f = (_d = this._userValues) === null || _d === void 0 ? void 0 : _d[topLevelKey]) === null || _f === void 0 ? void 0 : _f[name];
    };
    StatsigStore.prototype._createDynamicConfig = function(name, apiConfig, details) {
        var _a, _b, _c, _d;
        return new $98265c44655259c5$var$DynamicConfig_1.default(name, (_a = apiConfig === null || apiConfig === void 0 ? void 0 : apiConfig.value) !== null && _a !== void 0 ? _a : {}, (_b = apiConfig === null || apiConfig === void 0 ? void 0 : apiConfig.rule_id) !== null && _b !== void 0 ? _b : "", details, this.mapExposures((_c = apiConfig === null || apiConfig === void 0 ? void 0 : apiConfig.secondary_exposures) !== null && _c !== void 0 ? _c : []), (_d = apiConfig === null || apiConfig === void 0 ? void 0 : apiConfig.allocated_experiment_name) !== null && _d !== void 0 ? _d : "", this._makeOnConfigDefaultValueFallback(this._identity._user));
    };
    StatsigStore.prototype._getEvaluationDetails = function(valueExists, reasonOverride) {
        var _a;
        if (valueExists) return {
            reason: this._reason,
            time: (_a = this._userValues.evaluation_time) !== null && _a !== void 0 ? _a : Date.now()
        };
        else return {
            reason: reasonOverride !== null && reasonOverride !== void 0 ? reasonOverride : this._reason == $98265c44655259c5$var$EvaluationReason.Uninitialized ? $98265c44655259c5$var$EvaluationReason.Uninitialized : $98265c44655259c5$var$EvaluationReason.Unrecognized,
            time: Date.now()
        };
    };
    StatsigStore.prototype._resetUserValues = function() {
        this._userValues = this._getDefaultUserCacheValues();
    };
    StatsigStore.prototype._convertAPIDataToCacheValues = function(data, cacheKey) {
        // Specifically pulling keys from data here to avoid pulling in unwanted keys
        return {
            feature_gates: data.feature_gates,
            layer_configs: data.layer_configs,
            dynamic_configs: data.dynamic_configs,
            time: data.time == null || isNaN(data.time) ? 0 : data.time,
            evaluation_time: Date.now(),
            derived_fields: data.derived_fields,
            hash_used: data.hash_used
        };
    };
    StatsigStore.prototype._makeOnConfigDefaultValueFallback = function(user) {
        var _this = this;
        return function(config, parameter, defaultValueType, valueType) {
            if (!_this.isLoaded()) return;
            _this._onDefaultValueFallback(user, "Parameter ".concat(parameter, " is a value of type ").concat(valueType, ".\n          Returning requested defaultValue type ").concat(defaultValueType), {
                name: config._name,
                ruleID: config._ruleID,
                parameter: parameter,
                defaultValueType: defaultValueType,
                valueType: valueType
            });
        };
    };
    return StatsigStore;
}();
module.exports.default = $98265c44655259c5$var$StatsigStore;

});
parcelRegister("7Rwvg", function(module, exports) {
"use strict";
var $5b96b2202950aeb6$var$__assign = module.exports && module.exports.__assign || function() {
    $5b96b2202950aeb6$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $5b96b2202950aeb6$var$__assign.apply(this, arguments);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $5b96b2202950aeb6$var$BootstrapValidator = /** @class */ function() {
    function BootstrapValidator() {}
    BootstrapValidator.isValid = function(user, values) {
        try {
            var evaluatedKeys = values["evaluated_keys"];
            if (!evaluatedKeys) {
                var user_1 = values["user"];
                if (user_1) {
                    evaluatedKeys = {};
                    evaluatedKeys["userID"] = user_1["userID"];
                    if (user_1["customIDs"]) evaluatedKeys["customIDs"] = user_1["customIDs"];
                }
            }
            if (!evaluatedKeys || typeof evaluatedKeys !== "object") return true;
            var evaluatedKeysRecord = this.copyObject(evaluatedKeys);
            var userToCompare = user == null ? null : this.copyObject(user);
            return BootstrapValidator.validate(evaluatedKeysRecord, userToCompare) && BootstrapValidator.validate(userToCompare, evaluatedKeysRecord);
        } catch (error) {
        // This is best-effort. If we fail, return true.
        }
        return true;
    };
    BootstrapValidator.validate = function(one, two) {
        if (one == null) return two == null;
        else if (two == null) return false;
        for(var _i = 0, _a = Object.entries(one); _i < _a.length; _i++){
            var _b = _a[_i], key = _b[0], value = _b[1];
            if (key === "stableID") continue;
            if (typeof value !== typeof two[key]) return false;
            if (typeof value === "string") {
                if (value !== two[key]) return false;
            } else if (typeof value === "object") return this.validate(value, two[key]);
            else // unexpected
            return false;
        }
        return true;
    };
    BootstrapValidator.copyObject = function(obj) {
        if (obj == null) return null;
        var copy = {};
        if (obj === null || obj === void 0 ? void 0 : obj.userID) copy["userID"] = obj === null || obj === void 0 ? void 0 : obj.userID;
        if (obj === null || obj === void 0 ? void 0 : obj.customIDs) {
            var customIDs = $5b96b2202950aeb6$var$__assign({}, obj.customIDs);
            delete customIDs["stableID"];
            if (Object.keys(customIDs).length !== 0) copy["customIDs"] = customIDs;
        }
        return copy;
    };
    return BootstrapValidator;
}();
module.exports.default = $5b96b2202950aeb6$var$BootstrapValidator;

});


parcelRegister("4l64D", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.verifySDKKeyUsed = void 0;

var $67pep = parcelRequire("67pep");

var $jDn9b = parcelRequire("jDn9b");
function $328dd5b7ffe65303$var$verifySDKKeyUsed(json, sdkKey, errorBoundary) {
    var hashedSDKKeyUsed = json === null || json === void 0 ? void 0 : json.hashed_sdk_key_used;
    if (hashedSDKKeyUsed != null && hashedSDKKeyUsed !== (0, $jDn9b.SimpleHash)(sdkKey !== null && sdkKey !== void 0 ? sdkKey : "")) {
        errorBoundary._logError("fetchAndSaveValues", new $67pep.StatsigSDKKeyMismatchError("The SDK key provided does not match the one used to generate values."));
        return false;
    }
    return true;
}
module.exports.verifySDKKeyUsed = $328dd5b7ffe65303$var$verifySDKKeyUsed;

});

parcelRegister("zQ9jk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.difference = module.exports.now = void 0;
function $06bbb8bd2d0b98bd$var$now() {
    if (typeof performance === "undefined" || !performance) return Date.now();
    return performance.now() | 0;
}
module.exports.now = $06bbb8bd2d0b98bd$var$now;
function $06bbb8bd2d0b98bd$var$difference(time) {
    return $06bbb8bd2d0b98bd$var$now() - time;
}
module.exports.difference = $06bbb8bd2d0b98bd$var$difference;

});

parcelRegister("lFzGg", function(module, exports) {
"use strict";
var $fc691ac5f9105c16$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.saveOverridesToLocalStorage = module.exports.loadOverridesFromLocalStorage = module.exports.makeEmptyOverrides = module.exports.STORAGE_KEY = void 0;

var $fc691ac5f9105c16$var$StatsigLocalStorage_1 = $fc691ac5f9105c16$var$__importDefault((parcelRequire("2klGt")));
module.exports.STORAGE_KEY = "STATSIG_JS_LITE_LOCAL_OVERRIDES";
function $fc691ac5f9105c16$var$makeEmptyOverrides() {
    return {
        gates: {},
        configs: {},
        layers: {}
    };
}
module.exports.makeEmptyOverrides = $fc691ac5f9105c16$var$makeEmptyOverrides;
function $fc691ac5f9105c16$var$loadOverridesFromLocalStorage() {
    var raw = $fc691ac5f9105c16$var$StatsigLocalStorage_1.default.getItem(module.exports.STORAGE_KEY);
    if (raw) try {
        return JSON.parse(raw);
    } catch (error) {
    // noop
    }
    return $fc691ac5f9105c16$var$makeEmptyOverrides();
}
module.exports.loadOverridesFromLocalStorage = $fc691ac5f9105c16$var$loadOverridesFromLocalStorage;
function $fc691ac5f9105c16$var$saveOverridesToLocalStorage(overrides) {
    $fc691ac5f9105c16$var$StatsigLocalStorage_1.default.setItem(module.exports.STORAGE_KEY, JSON.stringify(overrides));
}
module.exports.saveOverridesToLocalStorage = $fc691ac5f9105c16$var$saveOverridesToLocalStorage;

});



parcelRegister("gWA6f", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c55e10c7ed56edcf$export$2e2bcd8739ae039; });

var $9nAUV = parcelRequire("9nAUV");

var $2c9To = parcelRequire("2c9To");

var $7hJEL = parcelRequire("7hJEL");

var $59E62 = parcelRequire("59E62");
function $c55e10c7ed56edcf$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $c55e10c7ed56edcf$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $c55e10c7ed56edcf$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($7hJEL)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $c55e10c7ed56edcf$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $c55e10c7ed56edcf$export$a66cbd9b2289cd78 = "@all-features";
var $c55e10c7ed56edcf$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function Subscriptions() {
        (0, (/*@__PURE__*/$parcel$interopDefault($9nAUV)))(this, Subscriptions);
        (0, (/*@__PURE__*/$parcel$interopDefault($7hJEL)))(this, "eventToValue", new Map());
        this.emitter = new (0, $59E62.EventEmitter2)();
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($2c9To)))(Subscriptions, [
        {
            key: "onGateUpdated",
            value: function onGateUpdated(gateName, callback, checkGate, options) {
                var _this = this;
                var value = checkGate(gateName, $c55e10c7ed56edcf$var$_objectSpread($c55e10c7ed56edcf$var$_objectSpread({}, options), {}, {
                    fireGateExposure: false
                }));
                if (this.eventToValue.get(callback) === undefined) this.eventToValue.set(callback, value);
                var wrapCallback = function wrapCallback() {
                    var value = checkGate(gateName, $c55e10c7ed56edcf$var$_objectSpread($c55e10c7ed56edcf$var$_objectSpread({}, options), {}, {
                        fireGateExposure: false
                    }));
                    var existingValue = _this.eventToValue.get(callback);
                    if (existingValue !== value) {
                        _this.eventToValue.set(callback, value);
                        callback(value);
                    }
                };
                this.emitter.on(gateName, wrapCallback);
                return function() {
                    _this.emitter.off(gateName, wrapCallback);
                };
            }
        },
        {
            key: "onExperimentValueUpdated",
            value: function onExperimentValueUpdated(experimentName, parameterName, defaultValue, callback, getExperimentValue, options) {
                var _this2 = this;
                var experimentEventName = "".concat(experimentName, ".").concat(parameterName);
                var value = getExperimentValue(experimentName, parameterName, defaultValue, $c55e10c7ed56edcf$var$_objectSpread($c55e10c7ed56edcf$var$_objectSpread({}, options), {}, {
                    fireExperimentExposure: false
                }));
                if (this.eventToValue.get(callback) === undefined) this.eventToValue.set(callback, value);
                var wrapCallback = function wrapCallback() {
                    var value = getExperimentValue(experimentName, parameterName, defaultValue, $c55e10c7ed56edcf$var$_objectSpread($c55e10c7ed56edcf$var$_objectSpread({}, options), {}, {
                        fireExperimentExposure: false
                    }));
                    var existingValue = _this2.eventToValue.get(callback);
                    if (existingValue !== value) {
                        _this2.eventToValue.set(callback, value);
                        callback(value);
                    }
                };
                this.emitter.on(experimentEventName, wrapCallback);
                return function() {
                    _this2.emitter.off(experimentEventName, wrapCallback);
                };
            }
        },
        {
            key: "onAnyUpdated",
            value: function onAnyUpdated(callback) {
                var _this3 = this;
                this.emitter.on($c55e10c7ed56edcf$export$a66cbd9b2289cd78, callback);
                return function() {
                    _this3.emitter.off($c55e10c7ed56edcf$export$a66cbd9b2289cd78, callback);
                };
            }
        },
        {
            key: "anyUpdated",
            value: function anyUpdated() {
                var _this4 = this;
                this.emitter.emit($c55e10c7ed56edcf$export$a66cbd9b2289cd78);
                this.emitter.eventNames().filter(function(name) {
                    return name !== $c55e10c7ed56edcf$export$a66cbd9b2289cd78;
                }).forEach(function(event) {
                    _this4.emitter.emit(event);
                });
            }
        }
    ]);
}();

});

parcelRegister("bMTrr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0236f45ebae598f1$export$2e2bcd8739ae039; });

var $7hJEL = parcelRequire("7hJEL");

var $5mLfW = parcelRequire("5mLfW");

var $9nAUV = parcelRequire("9nAUV");

var $2c9To = parcelRequire("2c9To");

var $3rY0i = parcelRequire("3rY0i");

var $3E94U = parcelRequire("3E94U");

var $fuICm = parcelRequire("fuICm");

var $TP5cR = parcelRequire("TP5cR");
function $0236f45ebae598f1$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $0236f45ebae598f1$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $0236f45ebae598f1$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($7hJEL)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $0236f45ebae598f1$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $0236f45ebae598f1$var$DEFAULT_REQUEST_TIMEOUT_MS = 5000;
var $0236f45ebae598f1$export$250a58ecde616daa = "https://api.atlassian.com/flags";
var $0236f45ebae598f1$export$942ba04389b0d5a2 = "https://api.stg.atlassian.com/flags";
var $0236f45ebae598f1$export$f058dbf75c3bc647 = "https://api.dev.atlassian.com/flags";
var $0236f45ebae598f1$export$1a401a0da8da3565 = "https://api.stg.atlassian-us-gov-mod.com/flags";
var $0236f45ebae598f1$export$18c93900db9358a4 = "https://api.atlassian-us-gov-mod.com/flags";
var $0236f45ebae598f1$export$450bd8fb2a6d7ace = "/gateway/api/flags";
var $0236f45ebae598f1$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function Fetcher() {
        (0, (/*@__PURE__*/$parcel$interopDefault($9nAUV)))(this, Fetcher);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($2c9To)))(Fetcher, null, [
        {
            key: "fetchClientSdk",
            value: function() {
                var _fetchClientSdk = (0, (/*@__PURE__*/$parcel$interopDefault($5mLfW)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3rY0i))).mark(function _callee(fetcherOptions) {
                    var targetApp, url;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($3rY0i))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                targetApp = fetcherOptions.targetApp;
                                url = "/api/v2/frontend/clientSdkKey/".concat(targetApp);
                                _context.prev = 2;
                                _context.next = 5;
                                return this.fetchRequest(url, "GET", fetcherOptions);
                            case 5:
                                return _context.abrupt("return", _context.sent);
                            case 8:
                                _context.prev = 8;
                                _context.t0 = _context["catch"](2);
                                if (!(_context.t0 instanceof Error)) {
                                    _context.next = 12;
                                    break;
                                }
                                throw _context.t0;
                            case 12:
                                throw Error("Failed to retrieve client sdk key");
                            case 13:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this, [
                        [
                            2,
                            8
                        ]
                    ]);
                }));
                function fetchClientSdk(_x) {
                    return _fetchClientSdk.apply(this, arguments);
                }
                return fetchClientSdk;
            }()
        },
        {
            key: "fetchExperimentValues",
            value: function() {
                var _fetchExperimentValues = (0, (/*@__PURE__*/$parcel$interopDefault($5mLfW)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3rY0i))).mark(function _callee2(fetcherOptions, identifiers, customAttributes) {
                    var requestBody;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($3rY0i))).wrap(function _callee2$(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                requestBody = {
                                    identifiers: identifiers,
                                    customAttributes: customAttributes,
                                    targetApp: fetcherOptions.targetApp
                                };
                                _context2.prev = 1;
                                _context2.next = 4;
                                return this.fetchRequest("/api/v2/frontend/experimentValues", "POST", fetcherOptions, requestBody);
                            case 4:
                                return _context2.abrupt("return", _context2.sent);
                            case 7:
                                _context2.prev = 7;
                                _context2.t0 = _context2["catch"](1);
                                if (!(_context2.t0 instanceof Error)) {
                                    _context2.next = 11;
                                    break;
                                }
                                throw _context2.t0;
                            case 11:
                                throw Error("Failed to retrieve experiment values");
                            case 12:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this, [
                        [
                            1,
                            7
                        ]
                    ]);
                }));
                function fetchExperimentValues(_x2, _x3, _x4) {
                    return _fetchExperimentValues.apply(this, arguments);
                }
                return fetchExperimentValues;
            }()
        },
        {
            key: "handleResponseError",
            value: function() {
                var _handleResponseError = (0, (/*@__PURE__*/$parcel$interopDefault($5mLfW)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3rY0i))).mark(function _callee3(response) {
                    var body;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($3rY0i))).wrap(function _callee3$(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                if (response.ok) {
                                    _context3.next = 5;
                                    break;
                                }
                                _context3.next = 3;
                                return response.text();
                            case 3:
                                body = _context3.sent;
                                throw new (0, $TP5cR.ResponseError)("Non 2xx response status received, status: ".concat(response.status, ", body: ").concat(JSON.stringify(body)));
                            case 5:
                                if (!(response.status === 204)) {
                                    _context3.next = 7;
                                    break;
                                }
                                throw new (0, $TP5cR.ResponseError)("Unexpected 204 response");
                            case 7:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3);
                }));
                function handleResponseError(_x5) {
                    return _handleResponseError.apply(this, arguments);
                }
                return handleResponseError;
            }()
        },
        {
            key: "extractResponseBody",
            value: function() {
                var _extractResponseBody = (0, (/*@__PURE__*/$parcel$interopDefault($5mLfW)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3rY0i))).mark(function _callee4(response) {
                    var value;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($3rY0i))).wrap(function _callee4$(_context4) {
                        while(true)switch(_context4.prev = _context4.next){
                            case 0:
                                _context4.next = 2;
                                return response.text();
                            case 2:
                                value = _context4.sent;
                                return _context4.abrupt("return", JSON.parse(value));
                            case 4:
                            case "end":
                                return _context4.stop();
                        }
                    }, _callee4);
                }));
                function extractResponseBody(_x6) {
                    return _extractResponseBody.apply(this, arguments);
                }
                return extractResponseBody;
            }()
        },
        {
            key: "getBaseUrl",
            value: function getBaseUrl(serviceEnv) {
                var useGatewayUrl = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
                var perimeter = arguments.length > 2 ? arguments[2] : undefined;
                if (useGatewayUrl) return $0236f45ebae598f1$export$450bd8fb2a6d7ace;
                if (perimeter === (0, $3E94U.PerimeterType).FEDRAMP_MODERATE) switch(serviceEnv){
                    case (0, $3E94U.FeatureGateEnvironment).Production:
                        return $0236f45ebae598f1$export$18c93900db9358a4;
                    case (0, $3E94U.FeatureGateEnvironment).Staging:
                        return $0236f45ebae598f1$export$1a401a0da8da3565;
                    default:
                        throw new Error('Invalid environment "'.concat(serviceEnv, '" for "').concat(perimeter, '" perimeter'));
                }
                else if (perimeter === (0, $3E94U.PerimeterType).COMMERCIAL) switch(serviceEnv){
                    case (0, $3E94U.FeatureGateEnvironment).Development:
                        return $0236f45ebae598f1$export$f058dbf75c3bc647;
                    case (0, $3E94U.FeatureGateEnvironment).Staging:
                        return $0236f45ebae598f1$export$942ba04389b0d5a2;
                    default:
                        return $0236f45ebae598f1$export$250a58ecde616daa;
                }
                else throw new Error('Invalid perimeter "'.concat(perimeter, '"'));
            }
        },
        {
            key: "fetchRequest",
            value: function() {
                var _fetchRequest = (0, (/*@__PURE__*/$parcel$interopDefault($5mLfW)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3rY0i))).mark(function _callee5(path, method, fetcherOptions, body) {
                    var baseUrl, fetchTimeout, abortSignal, abortController, response;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($3rY0i))).wrap(function _callee5$(_context5) {
                        while(true)switch(_context5.prev = _context5.next){
                            case 0:
                                baseUrl = Fetcher.getBaseUrl(fetcherOptions.environment, fetcherOptions.useGatewayURL, fetcherOptions.perimeter);
                                fetchTimeout = fetcherOptions.fetchTimeoutMs || $0236f45ebae598f1$var$DEFAULT_REQUEST_TIMEOUT_MS;
                                if (AbortSignal.timeout) abortSignal = AbortSignal.timeout(fetchTimeout);
                                else if (AbortController) {
                                    abortController = new AbortController();
                                    abortSignal = abortController.signal;
                                    setTimeout(function() {
                                        return abortController.abort();
                                    }, fetchTimeout);
                                }
                                _context5.next = 5;
                                return fetch("".concat(baseUrl).concat(path), $0236f45ebae598f1$var$_objectSpread({
                                    method: method,
                                    headers: {
                                        "Content-Type": "application/json",
                                        "X-Client-Name": "feature-gate-js-client",
                                        "X-Client-Version": (0, $fuICm.CLIENT_VERSION),
                                        "X-API-KEY": fetcherOptions.apiKey
                                    },
                                    signal: abortSignal
                                }, body && {
                                    body: JSON.stringify(body)
                                }));
                            case 5:
                                response = _context5.sent;
                                _context5.next = 8;
                                return this.handleResponseError(response);
                            case 8:
                                _context5.next = 10;
                                return this.extractResponseBody(response);
                            case 10:
                                return _context5.abrupt("return", _context5.sent);
                            case 11:
                            case "end":
                                return _context5.stop();
                        }
                    }, _callee5, this);
                }));
                function fetchRequest(_x7, _x8, _x9, _x10) {
                    return _fetchRequest.apply(this, arguments);
                }
                return fetchRequest;
            }()
        }
    ]);
}();

});
parcelRegister("3E94U", function(module, exports) {

$parcel$export(module.exports, "FeatureGateEnvironment", function () { return $2a7c263ca63428d0$export$479e7351a733299; });
$parcel$export(module.exports, "PerimeterType", function () { return $2a7c263ca63428d0$export$c42b7bbc5e7ba555; });
/**
 * The identifiers for the user. Options are restricted to the set that is currently supported.
 */ /**
 * Base client options. Does not include any options specific to providers
 * @interface BaseClientOptions
 * @property {FeatureGateEnvironment} environment - The environment for the client.
 * @property {string} targetApp - The target app for the client.
 * @property {AnalyticsWebClient} analyticsWebClient - The analytics web client.
 * @property {PerimeterType} perimeter - The perimeter for the client.
 */ /**
 * The options for the client.
 * @interface ClientOptions
 * @extends {BaseClientOptions}
 * @property {string} apiKey - The API key for the client.
 * @property {fetchTimeoutMs} fetchTimeoutMs - The timeout for the fetch request in milliseconds. Defaults to 5000.
 * @property {boolean} useGatewayURL - Whether to use the gateway URL. Defaults to false.
 */ /**
 * The custom attributes for the user.
 */ var $2a7c263ca63428d0$export$479e7351a733299 = /*#__PURE__*/ function(FeatureGateEnvironment) {
    FeatureGateEnvironment["Development"] = "development";
    FeatureGateEnvironment["Staging"] = "staging";
    FeatureGateEnvironment["Production"] = "production";
    return FeatureGateEnvironment;
}({});
var $2a7c263ca63428d0$export$c42b7bbc5e7ba555 = /*#__PURE__*/ function(PerimeterType) {
    PerimeterType["COMMERCIAL"] = "commercial";
    PerimeterType["FEDRAMP_MODERATE"] = "fedramp-moderate";
    return PerimeterType;
}({});
var $2a7c263ca63428d0$export$42f4885608027d0c = "non_boolean"; // Type magic to get the JSDoc comments from the Client class methods to appear on the static
 // methods in FeatureGates where the property name and function type are identical

});

parcelRegister("fuICm", function(module, exports) {

$parcel$export(module.exports, "CLIENT_VERSION", function () { return $b47c447b3d6abdf8$export$a59f8d67326bd1cb; });
/// <reference types="node" />
var $b47c447b3d6abdf8$export$a59f8d67326bd1cb = "4.23.4";

});

parcelRegister("TP5cR", function(module, exports) {

$parcel$export(module.exports, "ResponseError", function () { return $0a7cc32eeb85b2e0$export$286baf652d0b1206; });

var $2c9To = parcelRequire("2c9To");

var $9nAUV = parcelRequire("9nAUV");

var $4hWn5 = parcelRequire("4hWn5");

var $bSTwW = parcelRequire("bSTwW");

var $keLsu = parcelRequire("keLsu");

var $51bxH = parcelRequire("51bxH");
function $0a7cc32eeb85b2e0$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($bSTwW)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($4hWn5)))(t, $0a7cc32eeb85b2e0$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($bSTwW)))(t).constructor) : o.apply(t, e));
}
function $0a7cc32eeb85b2e0$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($0a7cc32eeb85b2e0$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $0a7cc32eeb85b2e0$export$286baf652d0b1206 = /*#__PURE__*/ function(_Error) {
    function ResponseError(message) {
        (0, (/*@__PURE__*/$parcel$interopDefault($9nAUV)))(this, ResponseError);
        return $0a7cc32eeb85b2e0$var$_callSuper(this, ResponseError, [
            message
        ]);
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($keLsu)))(ResponseError, _Error);
    return (0, (/*@__PURE__*/$parcel$interopDefault($2c9To)))(ResponseError);
}(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($51bxH)))(Error));

});
parcelRegister("4hWn5", function(module, exports) {

var $gLgUI = parcelRequire("gLgUI");
var $31f6074a488d863b$var$_typeof = $gLgUI.default;

var $ah43u = parcelRequire("ah43u");
function $31f6074a488d863b$var$_possibleConstructorReturn(t, e) {
    if (e && ("object" == $31f6074a488d863b$var$_typeof(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return $ah43u(t);
}
module.exports = $31f6074a488d863b$var$_possibleConstructorReturn, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("ah43u", function(module, exports) {
function $77aea331717ceaec$var$_assertThisInitialized(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}
module.exports = $77aea331717ceaec$var$_assertThisInitialized, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("bSTwW", function(module, exports) {
function $8a6fd000c9912cb2$var$_getPrototypeOf(t) {
    return module.exports = $8a6fd000c9912cb2$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $8a6fd000c9912cb2$var$_getPrototypeOf(t);
}
module.exports = $8a6fd000c9912cb2$var$_getPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("keLsu", function(module, exports) {

var $8ngnK = parcelRequire("8ngnK");
function $ebb9edba46f3c8b5$var$_inherits(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && $8ngnK(t, e);
}
module.exports = $ebb9edba46f3c8b5$var$_inherits, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("8ngnK", function(module, exports) {
function $618d2dd41396b543$var$_setPrototypeOf(t, e) {
    return module.exports = $618d2dd41396b543$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $618d2dd41396b543$var$_setPrototypeOf(t, e);
}
module.exports = $618d2dd41396b543$var$_setPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("51bxH", function(module, exports) {

var $bSTwW = parcelRequire("bSTwW");

var $8ngnK = parcelRequire("8ngnK");

var $f5HpN = parcelRequire("f5HpN");

var $lOgQ6 = parcelRequire("lOgQ6");
function $3a75ffe10bae3ea6$var$_wrapNativeSuper(t) {
    var r = "function" == typeof Map ? new Map() : void 0;
    return module.exports = $3a75ffe10bae3ea6$var$_wrapNativeSuper = function _wrapNativeSuper(t) {
        if (null === t || !$f5HpN(t)) return t;
        if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function");
        if (void 0 !== r) {
            if (r.has(t)) return r.get(t);
            r.set(t, Wrapper);
        }
        function Wrapper() {
            return $lOgQ6(t, arguments, $bSTwW(this).constructor);
        }
        return Wrapper.prototype = Object.create(t.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: !1,
                writable: !0,
                configurable: !0
            }
        }), $8ngnK(Wrapper, t);
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $3a75ffe10bae3ea6$var$_wrapNativeSuper(t);
}
module.exports = $3a75ffe10bae3ea6$var$_wrapNativeSuper, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("f5HpN", function(module, exports) {
function $afc8fff7c70e8620$var$_isNativeFunction(t) {
    try {
        return -1 !== Function.toString.call(t).indexOf("[native code]");
    } catch (n) {
        return "function" == typeof t;
    }
}
module.exports = $afc8fff7c70e8620$var$_isNativeFunction, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("lOgQ6", function(module, exports) {

var $4tAwy = parcelRequire("4tAwy");

var $8ngnK = parcelRequire("8ngnK");
function $fe0b546d05fef6b2$var$_construct(t, e, r) {
    if ($4tAwy()) return Reflect.construct.apply(null, arguments);
    var o = [
        null
    ];
    o.push.apply(o, e);
    var p = new (t.bind.apply(t, o))();
    return r && $8ngnK(p, r.prototype), p;
}
module.exports = $fe0b546d05fef6b2$var$_construct, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("4tAwy", function(module, exports) {
function $342633c45d6cbf64$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return (module.exports = $342633c45d6cbf64$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports)();
}
module.exports = $342633c45d6cbf64$var$_isNativeReflectConstruct, module.exports.__esModule = true, module.exports["default"] = module.exports;

});





parcelRegister("g8lao", function(module, exports) {

$parcel$export(module.exports, "getOptionsWithDefaults", function () { return $bbedcff33b71894d$export$d119b37e5f788b43; });
$parcel$export(module.exports, "shallowEquals", function () { return $bbedcff33b71894d$export$fa1c2bbf4100b8bc; });
$parcel$export(module.exports, "toStatsigUser", function () { return $bbedcff33b71894d$export$3dad1db244472f32; });
$parcel$export(module.exports, "toStatsigOptions", function () { return $bbedcff33b71894d$export$9cc5c9067f37d95c; });

var $ldcUZ = parcelRequire("ldcUZ");

var $907WG = parcelRequire("907WG");

var $7hJEL = parcelRequire("7hJEL");

var $91P2H = parcelRequire("91P2H");

var $3E94U = parcelRequire("3E94U");
var $bbedcff33b71894d$var$_excluded = [
    "sdkKey",
    "updateUserCompletionCallback",
    "perimeter"
];
function $bbedcff33b71894d$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $bbedcff33b71894d$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $bbedcff33b71894d$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($7hJEL)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $bbedcff33b71894d$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $bbedcff33b71894d$export$d119b37e5f788b43 = function getOptionsWithDefaults(options) {
    return $bbedcff33b71894d$var$_objectSpread({
        /**
     * If more federal PerimeterTypes are added in the future, this should be updated so
     * that isFedRamp() === true always returns the strictest perimeter.
     */ perimeter: (0, $91P2H.isFedRamp)() ? (0, $3E94U.PerimeterType).FEDRAMP_MODERATE : (0, $3E94U.PerimeterType).COMMERCIAL
    }, options);
};
var $bbedcff33b71894d$export$fa1c2bbf4100b8bc = function shallowEquals(objectA, objectB) {
    if (!objectA && !objectB) return true;
    if (!objectA || !objectB) return false;
    var aEntries = Object.entries(objectA);
    var bEntries = Object.entries(objectB);
    if (aEntries.length !== bEntries.length) return false;
    var ascendingKeyOrder = function ascendingKeyOrder(_ref, _ref2) {
        var _ref3 = (0, (/*@__PURE__*/$parcel$interopDefault($907WG)))(_ref, 1), key1 = _ref3[0];
        var _ref4 = (0, (/*@__PURE__*/$parcel$interopDefault($907WG)))(_ref2, 1), key2 = _ref4[0];
        return key1.localeCompare(key2);
    };
    aEntries.sort(ascendingKeyOrder);
    bEntries.sort(ascendingKeyOrder);
    for(var i = 0; i < aEntries.length; i++){
        var _aEntries$i = (0, (/*@__PURE__*/$parcel$interopDefault($907WG)))(aEntries[i], 2), aValue = _aEntries$i[1];
        var _bEntries$i = (0, (/*@__PURE__*/$parcel$interopDefault($907WG)))(bEntries[i], 2), bValue = _bEntries$i[1];
        if (aValue !== bValue) return false;
    }
    return true;
};
var $bbedcff33b71894d$export$3dad1db244472f32 = function toStatsigUser(identifiers, customAttributes) {
    var user = {
        customIDs: identifiers,
        custom: customAttributes
    };
    if (identifiers.atlassianAccountId) user.userID = identifiers.atlassianAccountId;
    return user;
};
var $bbedcff33b71894d$export$9cc5c9067f37d95c = function toStatsigOptions(options, initializeValues) {
    var sdkKey = options.sdkKey, updateUserCompletionCallback = options.updateUserCompletionCallback, perimeter = options.perimeter, restClientOptions = (0, (/*@__PURE__*/$parcel$interopDefault($ldcUZ)))(options, $bbedcff33b71894d$var$_excluded);
    return $bbedcff33b71894d$var$_objectSpread($bbedcff33b71894d$var$_objectSpread({}, restClientOptions), {}, {
        initializeValues: initializeValues,
        environment: {
            tier: options.environment
        },
        disableCurrentPageLogging: true
    }, options.updateUserCompletionCallback && {
        updateUserCompletionCallback: $bbedcff33b71894d$export$61433c0cacff7901(options.updateUserCompletionCallback)
    });
};
var $bbedcff33b71894d$export$61433c0cacff7901 = function toStatsigUpdateUserCompletionCallback(callback) {
    /**
   * The duration passed to the callback indicates how long the update took, but it is deceptive
   * since it only times the Statsig code and doesn't account for all of the extra custom work we
   * do to obtain the bootstrap values. As a result, we just suppress this parameter in our own
   * callback rather than trying to keep it accurate.
   */ return function(_duration, success, message) {
        callback(success, message);
    };
};

});
parcelRegister("ldcUZ", function(module, exports) {

var $1PpLF = parcelRequire("1PpLF");
function $f714d52dd9a543fc$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $1PpLF(e, t);
    if (Object.getOwnPropertySymbols) {
        var s = Object.getOwnPropertySymbols(e);
        for(r = 0; r < s.length; r++)o = s[r], t.includes(o) || ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
module.exports = $f714d52dd9a543fc$var$_objectWithoutProperties, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("1PpLF", function(module, exports) {
function $154e8ad0df026df5$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.includes(n)) continue;
        t[n] = r[n];
    }
    return t;
}
module.exports = $154e8ad0df026df5$var$_objectWithoutPropertiesLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

});






parcelRegister("bBele", function(module, exports) {

var $6aCUT = parcelRequire("6aCUT");
module.exports = Promise.all([
    $6aCUT("6YynV"),
    $6aCUT("cNijL"),
    $6aCUT("6si2L")
]).then(()=>parcelRequire("e1zIz"));

});

parcelRegister("d5C4u", function(module, exports) {

var $6aCUT = parcelRequire("6aCUT");
module.exports = Promise.all([
    $6aCUT("cNijL"),
    $6aCUT("cEf9M")
]).then(()=>parcelRequire("eQS7t"));

});

parcelRegister("8DKk6", function(module, exports) {

var $6aCUT = parcelRequire("6aCUT");
module.exports = Promise.all([
    $6aCUT("gQCmS"),
    $6aCUT("6gv1G"),
    $6aCUT("ckeVw"),
    $6aCUT("cNijL"),
    $6aCUT("935eB"),
    $6aCUT("2fcNx"),
    $6aCUT("9RwSd")
]).then(()=>parcelRequire("1VC5o"));

});

parcelRegister("iJPyN", function(module, exports) {

var $6aCUT = parcelRequire("6aCUT");
module.exports = Promise.all([
    $6aCUT("gQCmS"),
    $6aCUT("6gv1G"),
    $6aCUT("6YynV"),
    $6aCUT("cNijL"),
    $6aCUT("6uhRb"),
    $6aCUT("935eB"),
    $6aCUT("2fcNx"),
    $6aCUT("heo3b")
]).then(()=>parcelRequire("gQjGc"));

});

parcelRegister("hPirZ", function(module, exports) {

var $6aCUT = parcelRequire("6aCUT");
module.exports = Promise.all([
    $6aCUT("gQCmS"),
    $6aCUT("6gv1G"),
    $6aCUT("ckeVw"),
    $6aCUT("935eB"),
    $6aCUT("2fcNx"),
    $6aCUT("8rQox")
]).then(()=>parcelRequire("v55GA"));

});

parcelRegister("jXhle", function(module, exports) {

var $6aCUT = parcelRequire("6aCUT");
module.exports = $6aCUT("3orYu").then(()=>parcelRequire("fwTIo"));

});

parcelRegister("6bOZI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $481b539a965459e2$export$2e2bcd8739ae039; });
// TODO: Remove this eslint-disable when prop names have been renamed.
// This rule is here as prop name changes are a major as they are used
// by our consumers. This can be done in the next lite-mode conversion.
/* eslint-disable @repo/internal/react/boolean-prop-naming-convention */ 
var $dAx5m = parcelRequire("dAx5m");

var $dQigW = parcelRequire("dQigW");
/**
 * __Page header__
 *
 * A page header defines the top of a page. It contains a title and can be optionally combined with
 * breadcrumbs buttons, search, and filters.
 *
 * - [Examples](https://atlassian.design/components/page-header/examples)
 * - [Code](https://atlassian.design/components/page-header/code)
 * - [Usage](https://atlassian.design/components/page-header/usage)
 */ var $481b539a965459e2$var$PageHeader = function PageHeader(_ref) {
    var innerRef = _ref.innerRef, breadcrumbs = _ref.breadcrumbs, actions = _ref.actions, bottomBar = _ref.bottomBar, children = _ref.children, id = _ref.id, _ref$disableTitleStyl = _ref.disableTitleStyles, disableTitleStyles = _ref$disableTitleStyl === void 0 ? false : _ref$disableTitleStyl, _ref$truncateTitle = _ref.truncateTitle, truncateTitle = _ref$truncateTitle === void 0 ? false : _ref$truncateTitle;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $dQigW.OuterWrapper), null, breadcrumbs, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $dQigW.TitleWrapper), {
        truncateTitle: truncateTitle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $dQigW.TitleContainer), {
        truncateTitle: truncateTitle
    }, disableTitleStyles ? children : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $dQigW.StyledTitleWrapper), {
        ref: innerRef,
        truncateTitle: truncateTitle,
        id: id
    }, children)), actions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $dQigW.ActionsWrapper), null, actions)), bottomBar && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $dQigW.BottomBarWrapper), null, " ", bottomBar, " "));
};
var $481b539a965459e2$export$2e2bcd8739ae039 = $481b539a965459e2$var$PageHeader;

});
parcelRegister("dQigW", function(module, exports) {

$parcel$export(module.exports, "OuterWrapper", function () { return $a13e4e2e61e4db05$export$edaaad985a878983; });
$parcel$export(module.exports, "StyledTitleWrapper", function () { return $a13e4e2e61e4db05$export$284be1ee64a3465c; });
$parcel$export(module.exports, "TitleWrapper", function () { return $a13e4e2e61e4db05$export$585a3b23e887288b; });
$parcel$export(module.exports, "TitleContainer", function () { return $a13e4e2e61e4db05$export$35e09ba17cc51c69; });
$parcel$export(module.exports, "ActionsWrapper", function () { return $a13e4e2e61e4db05$export$c8223871eecc8f3a; });
$parcel$export(module.exports, "BottomBarWrapper", function () { return $a13e4e2e61e4db05$export$6330225854c30dc; });

var $hcOR8 = parcelRequire("hcOR8");

var $dAx5m = parcelRequire("dAx5m");

var $jVTBW = parcelRequire("jVTBW");

var $8vFVh = parcelRequire("8vFVh");

var $7e197 = parcelRequire("7e197");
var $cLRZO = parcelRequire("cLRZO");

var $9Pfox = parcelRequire("9Pfox");
var $a13e4e2e61e4db05$var$truncateStyles = (0, $jVTBW.css)({
    overflowX: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap"
});
var $a13e4e2e61e4db05$var$outerStyles = (0, $jVTBW.css)({
    margin: "var(--ds-space-300, 24px)".concat(" 0 ", "var(--ds-space-200, 16px)", " 0")
});
var $a13e4e2e61e4db05$var$titleStyles = (0, $jVTBW.css)({
    color: "var(--ds-text, #172B4D)",
    font: 'var(--ds-font-heading-large, normal 500 24px/28px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    letterSpacing: "normal",
    marginBlockStart: 0,
    outline: "none"
});
var $a13e4e2e61e4db05$var$styledTitleStyles = (0, $jVTBW.css)({
    lineHeight: "var(--ds-font-lineHeight-500, 32px)",
    marginBlockStart: 0,
    outline: "none"
});
var $a13e4e2e61e4db05$var$titleWrapperStyles = (0, $jVTBW.css)({
    display: "flex",
    alignItems: "flex-start",
    flexWrap: "wrap"
});
var $a13e4e2e61e4db05$var$titleWrapperTruncateStyles = (0, $jVTBW.css)({
    flexWrap: "nowrap"
});
var $a13e4e2e61e4db05$var$titleContainerStyles = (0, $jVTBW.css)({
    minWidth: 0,
    maxWidth: "100%",
    flex: "1 0 auto",
    flexShrink: undefined,
    marginBlockEnd: "var(--ds-space-100, 8px)"
});
var $a13e4e2e61e4db05$var$actionStyles = (0, $jVTBW.css)({
    maxWidth: "100%",
    flex: "0 0 auto",
    marginBlockEnd: "var(--ds-space-100, 8px)",
    marginInlineStart: "auto",
    paddingInlineStart: "var(--ds-space-400, 32px)",
    whiteSpace: "nowrap",
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
    ">": {
        textAlign: "right"
    }
});
var $a13e4e2e61e4db05$var$titleContainerTruncateStyles = (0, $jVTBW.css)({
    flexShrink: 1
});
var $a13e4e2e61e4db05$var$bottomBarStyles = (0, $cLRZO.xcss)({
    marginBlockStart: "space.200"
});
var $a13e4e2e61e4db05$export$edaaad985a878983 = function OuterWrapper(_ref) {
    var children = _ref.children;
    return (0, $jVTBW.jsx)("div", {
        css: $a13e4e2e61e4db05$var$outerStyles
    }, children);
};
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
var $a13e4e2e61e4db05$var$h700Styles = (0, $jVTBW.css)((0, $9Pfox.h700)());
var $a13e4e2e61e4db05$export$284be1ee64a3465c = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).forwardRef(function(_ref2, ref) {
    var children = _ref2.children, id = _ref2.id, truncateTitle = _ref2.truncateTitle;
    return (0, $jVTBW.jsx)("h1", {
        css: [].concat((0, (/*@__PURE__*/$parcel$interopDefault($hcOR8)))((0, $8vFVh.getBooleanFF)("platform.design-system-team.page-header-tokenised-typography-styles_lj1ix") ? [
            $a13e4e2e61e4db05$var$titleStyles
        ] : [
            $a13e4e2e61e4db05$var$h700Styles,
            $a13e4e2e61e4db05$var$styledTitleStyles
        ]), [
            truncateTitle && $a13e4e2e61e4db05$var$truncateStyles
        ]),
        ref: ref,
        tabIndex: -1,
        id: id
    }, children);
});
var $a13e4e2e61e4db05$export$585a3b23e887288b = function TitleWrapper(_ref3) {
    var children = _ref3.children, truncateTitle = _ref3.truncateTitle;
    return (0, $jVTBW.jsx)("div", {
        css: [
            $a13e4e2e61e4db05$var$titleWrapperStyles,
            truncateTitle && $a13e4e2e61e4db05$var$titleWrapperTruncateStyles
        ]
    }, children);
};
var $a13e4e2e61e4db05$export$35e09ba17cc51c69 = function TitleContainer(_ref4) {
    var children = _ref4.children, truncateTitle = _ref4.truncateTitle;
    return (0, $jVTBW.jsx)("div", {
        css: [
            $a13e4e2e61e4db05$var$titleContainerStyles,
            truncateTitle && $a13e4e2e61e4db05$var$titleContainerTruncateStyles
        ]
    }, children);
};
var $a13e4e2e61e4db05$export$c8223871eecc8f3a = function ActionsWrapper(_ref5) {
    var children = _ref5.children;
    return (0, $jVTBW.jsx)("div", {
        css: $a13e4e2e61e4db05$var$actionStyles
    }, children);
};
var $a13e4e2e61e4db05$export$6330225854c30dc = function BottomBarWrapper(_ref6) {
    var children = _ref6.children;
    return (0, $jVTBW.jsx)((0, $7e197.default), {
        xcss: $a13e4e2e61e4db05$var$bottomBarStyles
    }, children);
};

});
parcelRegister("hcOR8", function(module, exports) {

var $ljb3W = parcelRequire("ljb3W");

var $1jGw7 = parcelRequire("1jGw7");

var $jQtma = parcelRequire("jQtma");

var $3tKZI = parcelRequire("3tKZI");
function $c86b0196e1d634de$var$_toConsumableArray(r) {
    return $ljb3W(r) || $1jGw7(r) || $jQtma(r) || $3tKZI();
}
module.exports = $c86b0196e1d634de$var$_toConsumableArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("ljb3W", function(module, exports) {

var $1XZlV = parcelRequire("1XZlV");
function $f833f4209f3b8350$var$_arrayWithoutHoles(r) {
    if (Array.isArray(r)) return $1XZlV(r);
}
module.exports = $f833f4209f3b8350$var$_arrayWithoutHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("1XZlV", function(module, exports) {
function $16eae47a2206eaef$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
module.exports = $16eae47a2206eaef$var$_arrayLikeToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("1jGw7", function(module, exports) {
function $0f588bd16edb39b6$var$_iterableToArray(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
module.exports = $0f588bd16edb39b6$var$_iterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("jQtma", function(module, exports) {

var $1XZlV = parcelRequire("1XZlV");
function $e729a53cdb9a56cc$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $1XZlV(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $1XZlV(r, a) : void 0;
    }
}
module.exports = $e729a53cdb9a56cc$var$_unsupportedIterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("3tKZI", function(module, exports) {
function $288888a309d7a241$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
module.exports = $288888a309d7a241$var$_nonIterableSpread, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("8vFVh", function(module, exports) {

$parcel$export(module.exports, "getBooleanFF", function () { return $6321bcfb268b4820$export$470e5c2be1411c89; });

var $eHaak = parcelRequire("eHaak");
function $6321bcfb268b4820$export$ba05d765b8392e5e(flagResolver) {
    (0, $eHaak.setBooleanResolver)(flagResolver);
}
function $6321bcfb268b4820$export$470e5c2be1411c89(name) {
    return (0, $eHaak.resolveBooleanFlag)(name);
}

});
parcelRegister("eHaak", function(module, exports) {

$parcel$export(module.exports, "setBooleanResolver", function () { return $ab2cf7808e3debb7$export$f2b591175b3e424c; });
$parcel$export(module.exports, "resolveBooleanFlag", function () { return $ab2cf7808e3debb7$export$6333b6aff9fc6275; });

var $3wT3f = parcelRequire("3wT3f");

var $ahJoN = parcelRequire("ahJoN");
var $ab2cf7808e3debb7$var$pkgName = "@atlaskit/platform-feature-flags";
var $ab2cf7808e3debb7$export$7e41b1b2bdee3f98 = "__PLATFORM_FEATURE_FLAGS__";
var $ab2cf7808e3debb7$var$hasProcessEnv = typeof $ahJoN !== "undefined" && typeof $ahJoN.env !== "undefined";
// FF global overrides can be configured by test runners or Storybook
var $ab2cf7808e3debb7$var$ENV_ENABLE_PLATFORM_FF = $ab2cf7808e3debb7$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
// STORYBOOK_ENABLE_PLATFORM_FF is included as storybook only allows env vars prefixed with STORYBOOK
// https://github.com/storybookjs/storybook/issues/12270
var $ab2cf7808e3debb7$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF = $ab2cf7808e3debb7$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
var $ab2cf7808e3debb7$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE = $ab2cf7808e3debb7$var$ENV_ENABLE_PLATFORM_FF || $ab2cf7808e3debb7$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF;
var $ab2cf7808e3debb7$var$DEFAULT_PFF_GLOBAL = {
    // In development mode we want to capture any feature flag checks that happen using the default resolver and log this result when the resolver is replaced.
    // This is because evaluating feature flags when the resolver/FF client is loaded asynchronously could cause unexpected issues.
    earlyResolvedFlags: new Map(),
    booleanResolver: function booleanResolver(flagKey) {
        var unresolvedFlagCount;
        return false;
    }
};
var $ab2cf7808e3debb7$var$globalVar = typeof window !== "undefined" ? window : globalThis;
$ab2cf7808e3debb7$var$globalVar[$ab2cf7808e3debb7$export$7e41b1b2bdee3f98] = $ab2cf7808e3debb7$var$globalVar[$ab2cf7808e3debb7$export$7e41b1b2bdee3f98] || $ab2cf7808e3debb7$var$DEFAULT_PFF_GLOBAL;
function $ab2cf7808e3debb7$export$f2b591175b3e424c(resolver) {
    $ab2cf7808e3debb7$var$globalVar[$ab2cf7808e3debb7$export$7e41b1b2bdee3f98].booleanResolver = resolver;
    var _globalVar$PFF_GLOBAL;
}
function $ab2cf7808e3debb7$export$6333b6aff9fc6275(flagKey) {
    if ($ab2cf7808e3debb7$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE) {
        (0, $3wT3f.debug)('[%s]: The feature flags were enabled while running tests. The flag "%s" will be always enabled.', $ab2cf7808e3debb7$var$pkgName, flagKey);
        return true;
    }
    try {
        var _globalVar$PFF_GLOBAL2;
        var result = (_globalVar$PFF_GLOBAL2 = $ab2cf7808e3debb7$var$globalVar[$ab2cf7808e3debb7$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL2 === void 0 ? void 0 : _globalVar$PFF_GLOBAL2.booleanResolver(flagKey);
        if (typeof result !== "boolean") {
            // eslint-disable-next-line no-console
            console.warn("".concat(flagKey, " resolved to a non-boolean value, returning false for safety"));
            return false;
        }
        return result;
    } catch (e) {
        return false;
    }
}

});
parcelRegister("3wT3f", function(module, exports) {

$parcel$export(module.exports, "debug", function () { return $291f1053db88e274$export$1c9f709888824e05; });
var $291f1053db88e274$var$_ref, $291f1053db88e274$var$_process, $291f1053db88e274$var$_process2;
// We can't rely on NODE_ENV === 'test' if its value is already configured by the consumer to some other value, so better to use JEST_WORKER_ID
// https://jestjs.io/docs/environment-variables#jest_worker_id
var $291f1053db88e274$var$TESTS_MODE = ($291f1053db88e274$var$_ref = (globalThis === null || globalThis === void 0 || ($291f1053db88e274$var$_process = globalThis.process) === null || $291f1053db88e274$var$_process === void 0 || ($291f1053db88e274$var$_process = $291f1053db88e274$var$_process.env) === null || $291f1053db88e274$var$_process === void 0 ? void 0 : $291f1053db88e274$var$_process.JEST_WORKER_ID) !== undefined, $291f1053db88e274$var$_ref !== void 0) ? $291f1053db88e274$var$_ref : false;
var $291f1053db88e274$var$DEBUG_MODE = !$291f1053db88e274$var$TESTS_MODE && (globalThis === null || globalThis === void 0 || ($291f1053db88e274$var$_process2 = globalThis.process) === null || $291f1053db88e274$var$_process2 === void 0 || ($291f1053db88e274$var$_process2 = $291f1053db88e274$var$_process2.env) === null || $291f1053db88e274$var$_process2 === void 0 ? void 0 : $291f1053db88e274$var$_process2.NODE_ENV) !== "production";
var $291f1053db88e274$export$1c9f709888824e05 = function debug() {
    var _console;
    if (!$291f1053db88e274$var$DEBUG_MODE) return;
    // eslint-disable-next-line no-console
    (_console = console).debug.apply(_console, arguments);
};

});



parcelRegister("7e197", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $542abac5cf7bb30f$export$2e2bcd8739ae039; });

var $Olyfu = parcelRequire("Olyfu");

var $cmsWk = parcelRequire("cmsWk");

var $dAx5m = parcelRequire("dAx5m");

var $jVTBW = parcelRequire("jVTBW");

var $JaTZ8 = parcelRequire("JaTZ8");

var $cLRZO = parcelRequire("cLRZO");

var $8lTJk = parcelRequire("8lTJk");
var $542abac5cf7bb30f$var$_excluded = [
    "as",
    "children",
    "backgroundColor",
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    "style",
    "testId",
    "xcss"
], $542abac5cf7bb30f$var$_excluded2 = [
    "className"
];
var $542abac5cf7bb30f$export$e71c4d32a2263218 = /*#__PURE__*/ (0, $dAx5m.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? "div" : _ref$as, children = _ref.children, backgroundColor = _ref.backgroundColor, padding = _ref.padding, paddingBlock = _ref.paddingBlock, paddingBlockStart = _ref.paddingBlockStart, paddingBlockEnd = _ref.paddingBlockEnd, paddingInline = _ref.paddingInline, paddingInlineStart = _ref.paddingInlineStart, paddingInlineEnd = _ref.paddingInlineEnd, style = _ref.style, testId = _ref.testId, xcss = _ref.xcss, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($cmsWk)))(_ref, $542abac5cf7bb30f$var$_excluded);
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($cmsWk)))(htmlAttributes, $542abac5cf7bb30f$var$_excluded2);
    var resolvedStyles = (0, $cLRZO.parseXcss)(xcss);
    var node = // @ts-expect-error Expression produces a union type that is too complex to represent. I think this is unavoidable
    (0, $jVTBW.jsx)(Component, (0, (/*@__PURE__*/$parcel$interopDefault($Olyfu)))({
        style: style,
        ref: ref,
        className: resolvedStyles.static
    }, safeHtmlAttributes, {
        css: [
            $542abac5cf7bb30f$var$baseStyles,
            backgroundColor && (0, $JaTZ8.backgroundColorStylesMap)[backgroundColor],
            (0, $JaTZ8.isSurfaceColorToken)(backgroundColor) && (0, $JaTZ8.surfaceColorStylesMap)[backgroundColor],
            padding && (0, $JaTZ8.paddingStylesMap).padding[padding],
            paddingBlock && (0, $JaTZ8.paddingStylesMap).paddingBlock[paddingBlock],
            paddingBlockStart && (0, $JaTZ8.paddingStylesMap).paddingBlockStart[paddingBlockStart],
            paddingBlockEnd && (0, $JaTZ8.paddingStylesMap).paddingBlockEnd[paddingBlockEnd],
            paddingInline && (0, $JaTZ8.paddingStylesMap).paddingInline[paddingInline],
            paddingInlineStart && (0, $JaTZ8.paddingStylesMap).paddingInlineStart[paddingInlineStart],
            paddingInlineEnd && (0, $JaTZ8.paddingStylesMap).paddingInlineEnd[paddingInlineEnd],
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
            resolvedStyles.emotion
        ],
        "data-testid": testId
    }), children);
    return backgroundColor ? (0, $jVTBW.jsx)((0, $8lTJk.SurfaceContext).Provider, {
        value: backgroundColor
    }, node) : node;
});
var $542abac5cf7bb30f$export$2e2bcd8739ae039 = $542abac5cf7bb30f$export$e71c4d32a2263218;
var $542abac5cf7bb30f$var$baseStyles = (0, $jVTBW.css)({
    boxSizing: "border-box",
    appearance: "none",
    border: "none"
});

});
parcelRegister("Olyfu", function(module, exports) {
function $09756349298b346f$var$_extends() {
    return module.exports = $09756349298b346f$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $09756349298b346f$var$_extends.apply(null, arguments);
}
module.exports = $09756349298b346f$var$_extends, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("cmsWk", function(module, exports) {

var $kinSJ = parcelRequire("kinSJ");
function $8ffdfcf3c4d2f469$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $kinSJ(e, t);
    if (Object.getOwnPropertySymbols) {
        var s = Object.getOwnPropertySymbols(e);
        for(r = 0; r < s.length; r++)o = s[r], t.includes(o) || ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
module.exports = $8ffdfcf3c4d2f469$var$_objectWithoutProperties, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("kinSJ", function(module, exports) {
function $ec68037f03033a2b$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.includes(n)) continue;
        t[n] = r[n];
    }
    return t;
}
module.exports = $ec68037f03033a2b$var$_objectWithoutPropertiesLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("JaTZ8", function(module, exports) {

$parcel$export(module.exports, "dimensionMap", function () { return $087ca8fdae1b787c$export$6ccdbebca2ee545f; });
$parcel$export(module.exports, "positiveSpaceMap", function () { return $087ca8fdae1b787c$export$958d0ae7f2977ae4; });
$parcel$export(module.exports, "allSpaceMap", function () { return $087ca8fdae1b787c$export$632685d741f3dbbf; });
$parcel$export(module.exports, "opacityMap", function () { return $087ca8fdae1b787c$export$daf94a976c798b4f; });
$parcel$export(module.exports, "shadowMap", function () { return $087ca8fdae1b787c$export$7aff6e7ba39bb774; });
$parcel$export(module.exports, "borderColorMap", function () { return $087ca8fdae1b787c$export$1531ad5bb3fbedac; });
$parcel$export(module.exports, "backgroundColorMap", function () { return $087ca8fdae1b787c$export$d1d79bf68ac056bd; });
$parcel$export(module.exports, "textColorMap", function () { return $087ca8fdae1b787c$export$8473307aa00d6ea1; });
$parcel$export(module.exports, "layerMap", function () { return $087ca8fdae1b787c$export$b5f31a7e431d2eab; });
$parcel$export(module.exports, "borderWidthMap", function () { return $087ca8fdae1b787c$export$e1b83c5210c471b8; });
$parcel$export(module.exports, "borderRadiusMap", function () { return $087ca8fdae1b787c$export$3c0a6c3e64bb180d; });
$parcel$export(module.exports, "paddingStylesMap", function () { return $087ca8fdae1b787c$export$e615f061ca585a6c; });
$parcel$export(module.exports, "backgroundColorStylesMap", function () { return $087ca8fdae1b787c$export$e7af83bafe7f9e63; });
$parcel$export(module.exports, "surfaceColorStylesMap", function () { return $087ca8fdae1b787c$export$ff257d957d48c421; });
$parcel$export(module.exports, "isSurfaceColorToken", function () { return $087ca8fdae1b787c$export$5e65a44e5b6ecadb; });

var $67paE = parcelRequire("67paE");

var $jVTBW = parcelRequire("jVTBW");

var $7W4iZ = parcelRequire("7W4iZ");
function $087ca8fdae1b787c$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $087ca8fdae1b787c$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $087ca8fdae1b787c$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($67paE)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $087ca8fdae1b787c$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $087ca8fdae1b787c$export$6ccdbebca2ee545f = {
    "100%": "100%",
    "size.100": "1rem",
    "size.200": "1.5rem",
    "size.300": "2rem",
    "size.400": "2.5rem",
    "size.500": "3rem",
    "size.600": "6rem",
    "size.1000": "12rem"
};
var $087ca8fdae1b787c$export$958d0ae7f2977ae4 = {
    "space.0": "var(--ds-space-0, 0px)",
    "space.025": "var(--ds-space-025, 2px)",
    "space.050": "var(--ds-space-050, 4px)",
    "space.075": "var(--ds-space-075, 6px)",
    "space.100": "var(--ds-space-100, 8px)",
    "space.150": "var(--ds-space-150, 12px)",
    "space.200": "var(--ds-space-200, 16px)",
    "space.250": "var(--ds-space-250, 20px)",
    "space.300": "var(--ds-space-300, 24px)",
    "space.400": "var(--ds-space-400, 32px)",
    "space.500": "var(--ds-space-500, 40px)",
    "space.600": "var(--ds-space-600, 48px)",
    "space.800": "var(--ds-space-800, 64px)",
    "space.1000": "var(--ds-space-1000, 80px)"
};
var $087ca8fdae1b787c$export$d2dc61f58390201c = {
    "space.negative.025": "var(--ds-space-negative-025, -2px)",
    "space.negative.050": "var(--ds-space-negative-050, -4px)",
    "space.negative.075": "var(--ds-space-negative-075, -6px)",
    "space.negative.100": "var(--ds-space-negative-100, -8px)",
    "space.negative.150": "var(--ds-space-negative-150, -12px)",
    "space.negative.200": "var(--ds-space-negative-200, -16px)",
    "space.negative.250": "var(--ds-space-negative-250, -20px)",
    "space.negative.300": "var(--ds-space-negative-300, -24px)",
    "space.negative.400": "var(--ds-space-negative-400, -32px)"
};
var $087ca8fdae1b787c$export$632685d741f3dbbf = $087ca8fdae1b787c$var$_objectSpread($087ca8fdae1b787c$var$_objectSpread({}, $087ca8fdae1b787c$export$958d0ae7f2977ae4), $087ca8fdae1b787c$export$d2dc61f58390201c);
var $087ca8fdae1b787c$export$2185ce37f9bdd963 = {
    "color.background.neutral.bold": "color.text.inverse",
    "color.background.neutral.bold.hovered": "color.text.inverse",
    "color.background.neutral.bold.pressed": "color.text.inverse",
    "color.background.selected.bold": "color.text.inverse",
    "color.background.selected.bold.hovered": "color.text.inverse",
    "color.background.selected.bold.pressed": "color.text.inverse",
    "color.background.brand.bold": "color.text.inverse",
    "color.background.brand.bold.hovered": "color.text.inverse",
    "color.background.brand.bold.pressed": "color.text.inverse",
    "color.background.brand.boldest": "color.text.inverse",
    "color.background.brand.boldest.hovered": "color.text.inverse",
    "color.background.brand.boldest.pressed": "color.text.inverse",
    "color.background.danger.bold": "color.text.inverse",
    "color.background.danger.bold.hovered": "color.text.inverse",
    "color.background.danger.bold.pressed": "color.text.inverse",
    "color.background.warning.bold": "color.text.warning.inverse",
    "color.background.warning.bold.hovered": "color.text.warning.inverse",
    "color.background.warning.bold.pressed": "color.text.warning.inverse",
    "color.background.success.bold": "color.text.inverse",
    "color.background.success.bold.hovered": "color.text.inverse",
    "color.background.success.bold.pressed": "color.text.inverse",
    "color.background.discovery.bold": "color.text.inverse",
    "color.background.discovery.bold.hovered": "color.text.inverse",
    "color.background.discovery.bold.pressed": "color.text.inverse",
    "color.background.information.bold": "color.text.inverse",
    "color.background.information.bold.hovered": "color.text.inverse",
    "color.background.information.bold.pressed": "color.text.inverse"
};
var $087ca8fdae1b787c$export$daf94a976c798b4f = {
    "opacity.disabled": "var(--ds-opacity-disabled, 0.4)",
    "opacity.loading": "var(--ds-opacity-loading, 0.2)"
};
var $087ca8fdae1b787c$export$7aff6e7ba39bb774 = {
    "elevation.shadow.overflow": "var(--ds-shadow-overflow, 0px 0px 8px #091e423f, 0px 0px 1px #091e424f)",
    "elevation.shadow.overflow.perimeter": "var(--ds-shadow-overflow-perimeter, #091e421f)",
    "elevation.shadow.overflow.spread": "var(--ds-shadow-overflow-spread, #091e4229)",
    "elevation.shadow.overlay": "var(--ds-shadow-overlay, 0px 8px 12px #091e423f, 0px 0px 1px #091e424f)",
    "elevation.shadow.raised": "var(--ds-shadow-raised, 0px 1px 1px #091e423f, 0px 0px 1px #091e4221)"
};
var $087ca8fdae1b787c$export$41a358c9c2356760 = {
    "elevation.surface": "var(--ds-surface, #FFFFFF)",
    "elevation.surface.hovered": "var(--ds-surface-hovered, #FAFBFC)",
    "elevation.surface.pressed": "var(--ds-surface-pressed, #F4F5F7)",
    "elevation.surface.overlay": "var(--ds-surface-overlay, #FFFFFF)",
    "elevation.surface.overlay.hovered": "var(--ds-surface-overlay-hovered, #FAFBFC)",
    "elevation.surface.overlay.pressed": "var(--ds-surface-overlay-pressed, #F4F5F7)",
    "elevation.surface.raised": "var(--ds-surface-raised, #FFFFFF)",
    "elevation.surface.raised.hovered": "var(--ds-surface-raised-hovered, #FAFBFC)",
    "elevation.surface.raised.pressed": "var(--ds-surface-raised-pressed, #F4F5F7)",
    "elevation.surface.sunken": "var(--ds-surface-sunken, #F4F5F7)"
};
var $087ca8fdae1b787c$export$1531ad5bb3fbedac = {
    "color.border": "var(--ds-border, #091e4221)",
    "color.border.accent.lime": "var(--ds-border-accent-lime, #6A9A23)",
    "color.border.accent.red": "var(--ds-border-accent-red, #FF5630)",
    "color.border.accent.orange": "var(--ds-border-accent-orange, #D94008)",
    "color.border.accent.yellow": "var(--ds-border-accent-yellow, #FFAB00)",
    "color.border.accent.green": "var(--ds-border-accent-green, #36B37E)",
    "color.border.accent.teal": "var(--ds-border-accent-teal, #00B8D9)",
    "color.border.accent.blue": "var(--ds-border-accent-blue, #0065FF)",
    "color.border.accent.purple": "var(--ds-border-accent-purple, #6554C0)",
    "color.border.accent.magenta": "var(--ds-border-accent-magenta, #CD519D)",
    "color.border.accent.gray": "var(--ds-border-accent-gray, #5E6C84)",
    "color.border.disabled": "var(--ds-border-disabled, #FAFBFC)",
    "color.border.focused": "var(--ds-border-focused, #2684FF)",
    "color.border.input": "var(--ds-border-input, #FAFBFC)",
    "color.border.inverse": "var(--ds-border-inverse, #FFFFFF)",
    "color.border.selected": "var(--ds-border-selected, #0052CC)",
    "color.border.brand": "var(--ds-border-brand, #0052CC)",
    "color.border.danger": "var(--ds-border-danger, #FF5630)",
    "color.border.warning": "var(--ds-border-warning, #FFC400)",
    "color.border.success": "var(--ds-border-success, #00875A)",
    "color.border.discovery": "var(--ds-border-discovery, #998DD9)",
    "color.border.information": "var(--ds-border-information, #0065FF)",
    "color.border.bold": "var(--ds-border-bold, #344563)"
};
var $087ca8fdae1b787c$export$d1d79bf68ac056bd = {
    "color.background.accent.lime.subtlest": "var(--ds-background-accent-lime-subtlest, #EEFBDA)",
    "color.background.accent.lime.subtlest.hovered": "var(--ds-background-accent-lime-subtlest-hovered, #D3F1A7)",
    "color.background.accent.lime.subtlest.pressed": "var(--ds-background-accent-lime-subtlest-pressed, #B3DF72)",
    "color.background.accent.lime.subtler": "var(--ds-background-accent-lime-subtler, #D3F1A7)",
    "color.background.accent.lime.subtler.hovered": "var(--ds-background-accent-lime-subtler-hovered, #B3DF72)",
    "color.background.accent.lime.subtler.pressed": "var(--ds-background-accent-lime-subtler-pressed, #94C748)",
    "color.background.accent.lime.subtle": "var(--ds-background-accent-lime-subtle, #94C748)",
    "color.background.accent.lime.subtle.hovered": "var(--ds-background-accent-lime-subtle-hovered, #B3DF72)",
    "color.background.accent.lime.subtle.pressed": "var(--ds-background-accent-lime-subtle-pressed, #D3F1A7)",
    "color.background.accent.lime.bolder": "var(--ds-background-accent-lime-bolder, #5B7F24)",
    "color.background.accent.lime.bolder.hovered": "var(--ds-background-accent-lime-bolder-hovered, #37471F)",
    "color.background.accent.lime.bolder.pressed": "var(--ds-background-accent-lime-bolder-pressed, #37471F)",
    "color.background.accent.red.subtlest": "var(--ds-background-accent-red-subtlest, #FF8F73)",
    "color.background.accent.red.subtlest.hovered": "var(--ds-background-accent-red-subtlest-hovered, #FF7452)",
    "color.background.accent.red.subtlest.pressed": "var(--ds-background-accent-red-subtlest-pressed, #FF5630)",
    "color.background.accent.red.subtler": "var(--ds-background-accent-red-subtler, #FF7452)",
    "color.background.accent.red.subtler.hovered": "var(--ds-background-accent-red-subtler-hovered, #FF5630)",
    "color.background.accent.red.subtler.pressed": "var(--ds-background-accent-red-subtler-pressed, #DE350B)",
    "color.background.accent.red.subtle": "var(--ds-background-accent-red-subtle, #DE350B)",
    "color.background.accent.red.subtle.hovered": "var(--ds-background-accent-red-subtle-hovered, #FF5630)",
    "color.background.accent.red.subtle.pressed": "var(--ds-background-accent-red-subtle-pressed, #FF7452)",
    "color.background.accent.red.bolder": "var(--ds-background-accent-red-bolder, #DE350B)",
    "color.background.accent.red.bolder.hovered": "var(--ds-background-accent-red-bolder-hovered, #FF5630)",
    "color.background.accent.red.bolder.pressed": "var(--ds-background-accent-red-bolder-pressed, #FF7452)",
    "color.background.accent.orange.subtlest": "var(--ds-background-accent-orange-subtlest, #F18D13)",
    "color.background.accent.orange.subtlest.hovered": "var(--ds-background-accent-orange-subtlest-hovered, #FEC57B)",
    "color.background.accent.orange.subtlest.pressed": "var(--ds-background-accent-orange-subtlest-pressed, #FFE2BD)",
    "color.background.accent.orange.subtler": "var(--ds-background-accent-orange-subtler, #B65C02)",
    "color.background.accent.orange.subtler.hovered": "var(--ds-background-accent-orange-subtler-hovered, #F18D13)",
    "color.background.accent.orange.subtler.pressed": "var(--ds-background-accent-orange-subtler-pressed, #FEC57B)",
    "color.background.accent.orange.subtle": "var(--ds-background-accent-orange-subtle, #5F3811)",
    "color.background.accent.orange.subtle.hovered": "var(--ds-background-accent-orange-subtle-hovered, #974F0C)",
    "color.background.accent.orange.subtle.pressed": "var(--ds-background-accent-orange-subtle-pressed, #B65C02)",
    "color.background.accent.orange.bolder": "var(--ds-background-accent-orange-bolder, #43290F)",
    "color.background.accent.orange.bolder.hovered": "var(--ds-background-accent-orange-bolder-hovered, #5F3811)",
    "color.background.accent.orange.bolder.pressed": "var(--ds-background-accent-orange-bolder-pressed, #974F0C)",
    "color.background.accent.yellow.subtlest": "var(--ds-background-accent-yellow-subtlest, #FFE380)",
    "color.background.accent.yellow.subtlest.hovered": "var(--ds-background-accent-yellow-subtlest-hovered, #FFC400)",
    "color.background.accent.yellow.subtlest.pressed": "var(--ds-background-accent-yellow-subtlest-pressed, #FFAB00)",
    "color.background.accent.yellow.subtler": "var(--ds-background-accent-yellow-subtler, #FFC400)",
    "color.background.accent.yellow.subtler.hovered": "var(--ds-background-accent-yellow-subtler-hovered, #FFAB00)",
    "color.background.accent.yellow.subtler.pressed": "var(--ds-background-accent-yellow-subtler-pressed, #FF991F)",
    "color.background.accent.yellow.subtle": "var(--ds-background-accent-yellow-subtle, #FF991F)",
    "color.background.accent.yellow.subtle.hovered": "var(--ds-background-accent-yellow-subtle-hovered, #FFAB00)",
    "color.background.accent.yellow.subtle.pressed": "var(--ds-background-accent-yellow-subtle-pressed, #FFC400)",
    "color.background.accent.yellow.bolder": "var(--ds-background-accent-yellow-bolder, #FF991F)",
    "color.background.accent.yellow.bolder.hovered": "var(--ds-background-accent-yellow-bolder-hovered, #FFAB00)",
    "color.background.accent.yellow.bolder.pressed": "var(--ds-background-accent-yellow-bolder-pressed, #FFC400)",
    "color.background.accent.green.subtlest": "var(--ds-background-accent-green-subtlest, #79F2C0)",
    "color.background.accent.green.subtlest.hovered": "var(--ds-background-accent-green-subtlest-hovered, #57D9A3)",
    "color.background.accent.green.subtlest.pressed": "var(--ds-background-accent-green-subtlest-pressed, #36B37E)",
    "color.background.accent.green.subtler": "var(--ds-background-accent-green-subtler, #57D9A3)",
    "color.background.accent.green.subtler.hovered": "var(--ds-background-accent-green-subtler-hovered, #36B37E)",
    "color.background.accent.green.subtler.pressed": "var(--ds-background-accent-green-subtler-pressed, #00875A)",
    "color.background.accent.green.subtle": "var(--ds-background-accent-green-subtle, #00875A)",
    "color.background.accent.green.subtle.hovered": "var(--ds-background-accent-green-subtle-hovered, #36B37E)",
    "color.background.accent.green.subtle.pressed": "var(--ds-background-accent-green-subtle-pressed, #57D9A3)",
    "color.background.accent.green.bolder": "var(--ds-background-accent-green-bolder, #00875A)",
    "color.background.accent.green.bolder.hovered": "var(--ds-background-accent-green-bolder-hovered, #36B37E)",
    "color.background.accent.green.bolder.pressed": "var(--ds-background-accent-green-bolder-pressed, #57D9A3)",
    "color.background.accent.teal.subtlest": "var(--ds-background-accent-teal-subtlest, #79E2F2)",
    "color.background.accent.teal.subtlest.hovered": "var(--ds-background-accent-teal-subtlest-hovered, #00C7E6)",
    "color.background.accent.teal.subtlest.pressed": "var(--ds-background-accent-teal-subtlest-pressed, #00B8D9)",
    "color.background.accent.teal.subtler": "var(--ds-background-accent-teal-subtler, #00C7E6)",
    "color.background.accent.teal.subtler.hovered": "var(--ds-background-accent-teal-subtler-hovered, #00B8D9)",
    "color.background.accent.teal.subtler.pressed": "var(--ds-background-accent-teal-subtler-pressed, #00A3BF)",
    "color.background.accent.teal.subtle": "var(--ds-background-accent-teal-subtle, #00A3BF)",
    "color.background.accent.teal.subtle.hovered": "var(--ds-background-accent-teal-subtle-hovered, #00B8D9)",
    "color.background.accent.teal.subtle.pressed": "var(--ds-background-accent-teal-subtle-pressed, #00C7E6)",
    "color.background.accent.teal.bolder": "var(--ds-background-accent-teal-bolder, #00A3BF)",
    "color.background.accent.teal.bolder.hovered": "var(--ds-background-accent-teal-bolder-hovered, #00B8D9)",
    "color.background.accent.teal.bolder.pressed": "var(--ds-background-accent-teal-bolder-pressed, #00C7E6)",
    "color.background.accent.blue.subtlest": "var(--ds-background-accent-blue-subtlest, #4C9AFF)",
    "color.background.accent.blue.subtlest.hovered": "var(--ds-background-accent-blue-subtlest-hovered, #2684FF)",
    "color.background.accent.blue.subtlest.pressed": "var(--ds-background-accent-blue-subtlest-pressed, #0065FF)",
    "color.background.accent.blue.subtler": "var(--ds-background-accent-blue-subtler, #2684FF)",
    "color.background.accent.blue.subtler.hovered": "var(--ds-background-accent-blue-subtler-hovered, #0065FF)",
    "color.background.accent.blue.subtler.pressed": "var(--ds-background-accent-blue-subtler-pressed, #0052CC)",
    "color.background.accent.blue.subtle": "var(--ds-background-accent-blue-subtle, #0052CC)",
    "color.background.accent.blue.subtle.hovered": "var(--ds-background-accent-blue-subtle-hovered, #0065FF)",
    "color.background.accent.blue.subtle.pressed": "var(--ds-background-accent-blue-subtle-pressed, #2684FF)",
    "color.background.accent.blue.bolder": "var(--ds-background-accent-blue-bolder, #0052CC)",
    "color.background.accent.blue.bolder.hovered": "var(--ds-background-accent-blue-bolder-hovered, #0065FF)",
    "color.background.accent.blue.bolder.pressed": "var(--ds-background-accent-blue-bolder-pressed, #2684FF)",
    "color.background.accent.purple.subtlest": "var(--ds-background-accent-purple-subtlest, #998DD9)",
    "color.background.accent.purple.subtlest.hovered": "var(--ds-background-accent-purple-subtlest-hovered, #8777D9)",
    "color.background.accent.purple.subtlest.pressed": "var(--ds-background-accent-purple-subtlest-pressed, #6554C0)",
    "color.background.accent.purple.subtler": "var(--ds-background-accent-purple-subtler, #8777D9)",
    "color.background.accent.purple.subtler.hovered": "var(--ds-background-accent-purple-subtler-hovered, #6554C0)",
    "color.background.accent.purple.subtler.pressed": "var(--ds-background-accent-purple-subtler-pressed, #5243AA)",
    "color.background.accent.purple.subtle": "var(--ds-background-accent-purple-subtle, #5243AA)",
    "color.background.accent.purple.subtle.hovered": "var(--ds-background-accent-purple-subtle-hovered, #6554C0)",
    "color.background.accent.purple.subtle.pressed": "var(--ds-background-accent-purple-subtle-pressed, #8777D9)",
    "color.background.accent.purple.bolder": "var(--ds-background-accent-purple-bolder, #5243AA)",
    "color.background.accent.purple.bolder.hovered": "var(--ds-background-accent-purple-bolder-hovered, #6554C0)",
    "color.background.accent.purple.bolder.pressed": "var(--ds-background-accent-purple-bolder-pressed, #8777D9)",
    "color.background.accent.magenta.subtlest": "var(--ds-background-accent-magenta-subtlest, #FFECF8)",
    "color.background.accent.magenta.subtlest.hovered": "var(--ds-background-accent-magenta-subtlest-hovered, #FDD0EC)",
    "color.background.accent.magenta.subtlest.pressed": "var(--ds-background-accent-magenta-subtlest-pressed, #F797D2)",
    "color.background.accent.magenta.subtler": "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
    "color.background.accent.magenta.subtler.hovered": "var(--ds-background-accent-magenta-subtler-hovered, #F797D2)",
    "color.background.accent.magenta.subtler.pressed": "var(--ds-background-accent-magenta-subtler-pressed, #E774BB)",
    "color.background.accent.magenta.subtle": "var(--ds-background-accent-magenta-subtle, #E774BB)",
    "color.background.accent.magenta.subtle.hovered": "var(--ds-background-accent-magenta-subtle-hovered, #F797D2)",
    "color.background.accent.magenta.subtle.pressed": "var(--ds-background-accent-magenta-subtle-pressed, #FDD0EC)",
    "color.background.accent.magenta.bolder": "var(--ds-background-accent-magenta-bolder, #AE4787)",
    "color.background.accent.magenta.bolder.hovered": "var(--ds-background-accent-magenta-bolder-hovered, #943D73)",
    "color.background.accent.magenta.bolder.pressed": "var(--ds-background-accent-magenta-bolder-pressed, #50253F)",
    "color.background.accent.gray.subtlest": "var(--ds-background-accent-gray-subtlest, #6B778C)",
    "color.background.accent.gray.subtlest.hovered": "var(--ds-background-accent-gray-subtlest-hovered, #5E6C84)",
    "color.background.accent.gray.subtlest.pressed": "var(--ds-background-accent-gray-subtlest-pressed, #505F79)",
    "color.background.accent.gray.subtler": "var(--ds-background-accent-gray-subtler, #5E6C84)",
    "color.background.accent.gray.subtler.hovered": "var(--ds-background-accent-gray-subtler-hovered, #505F79)",
    "color.background.accent.gray.subtler.pressed": "var(--ds-background-accent-gray-subtler-pressed, #42526E)",
    "color.background.accent.gray.subtle": "var(--ds-background-accent-gray-subtle, #505F79)",
    "color.background.accent.gray.subtle.hovered": "var(--ds-background-accent-gray-subtle-hovered, #5E6C84)",
    "color.background.accent.gray.subtle.pressed": "var(--ds-background-accent-gray-subtle-pressed, #6B778C)",
    "color.background.accent.gray.bolder": "var(--ds-background-accent-gray-bolder, #42526E)",
    "color.background.accent.gray.bolder.hovered": "var(--ds-background-accent-gray-bolder-hovered, #344563)",
    "color.background.accent.gray.bolder.pressed": "var(--ds-background-accent-gray-bolder-pressed, #253858)",
    "color.background.disabled": "var(--ds-background-disabled, #091e4289)",
    "color.background.input": "var(--ds-background-input, #FAFBFC)",
    "color.background.input.hovered": "var(--ds-background-input-hovered, #EBECF0)",
    "color.background.input.pressed": "var(--ds-background-input-pressed, #FFFFFF)",
    "color.background.inverse.subtle": "var(--ds-background-inverse-subtle, #00000029)",
    "color.background.inverse.subtle.hovered": "var(--ds-background-inverse-subtle-hovered, #0000003D)",
    "color.background.inverse.subtle.pressed": "var(--ds-background-inverse-subtle-pressed, #00000052)",
    "color.background.neutral": "var(--ds-background-neutral, #DFE1E6)",
    "color.background.neutral.hovered": "var(--ds-background-neutral-hovered, #091e4214)",
    "color.background.neutral.pressed": "var(--ds-background-neutral-pressed, #B3D4FF)",
    "color.background.neutral.subtle": "var(--ds-background-neutral-subtle, transparent)",
    "color.background.neutral.subtle.hovered": "var(--ds-background-neutral-subtle-hovered, #091e4214)",
    "color.background.neutral.subtle.pressed": "var(--ds-background-neutral-subtle-pressed, #B3D4FF)",
    "color.background.neutral.bold": "var(--ds-background-neutral-bold, #42526E)",
    "color.background.neutral.bold.hovered": "var(--ds-background-neutral-bold-hovered, #505F79)",
    "color.background.neutral.bold.pressed": "var(--ds-background-neutral-bold-pressed, #344563)",
    "color.background.selected": "var(--ds-background-selected, #DEEBFF)",
    "color.background.selected.hovered": "var(--ds-background-selected-hovered, #B3D4FF)",
    "color.background.selected.pressed": "var(--ds-background-selected-pressed, #4C9AFF)",
    "color.background.selected.bold": "var(--ds-background-selected-bold, #0052CC)",
    "color.background.selected.bold.hovered": "var(--ds-background-selected-bold-hovered, #2684FF)",
    "color.background.selected.bold.pressed": "var(--ds-background-selected-bold-pressed, #0052CC)",
    "color.background.brand.subtlest": "var(--ds-background-brand-subtlest, #B3D4FF)",
    "color.background.brand.subtlest.hovered": "var(--ds-background-brand-subtlest-hovered, #DEEBFF)",
    "color.background.brand.subtlest.pressed": "var(--ds-background-brand-subtlest-pressed, #4C9AFF)",
    "color.background.brand.bold": "var(--ds-background-brand-bold, #0052CC)",
    "color.background.brand.bold.hovered": "var(--ds-background-brand-bold-hovered, #0065FF)",
    "color.background.brand.bold.pressed": "var(--ds-background-brand-bold-pressed, #0747A6)",
    "color.background.brand.boldest": "var(--ds-background-brand-boldest, #0747A6)",
    "color.background.brand.boldest.hovered": "var(--ds-background-brand-boldest-hovered, #0052CC)",
    "color.background.brand.boldest.pressed": "var(--ds-background-brand-boldest-pressed, #0747A6)",
    "color.background.danger": "var(--ds-background-danger, #FFEBE6)",
    "color.background.danger.hovered": "var(--ds-background-danger-hovered, #FFBDAD)",
    "color.background.danger.pressed": "var(--ds-background-danger-pressed, #FF8F73)",
    "color.background.danger.bold": "var(--ds-background-danger-bold, #DE350B)",
    "color.background.danger.bold.hovered": "var(--ds-background-danger-bold-hovered, #FF5630)",
    "color.background.danger.bold.pressed": "var(--ds-background-danger-bold-pressed, #BF2600)",
    "color.background.warning": "var(--ds-background-warning, #FFFAE6)",
    "color.background.warning.hovered": "var(--ds-background-warning-hovered, #FFF0B3)",
    "color.background.warning.pressed": "var(--ds-background-warning-pressed, #FFE380)",
    "color.background.warning.bold": "var(--ds-background-warning-bold, #FFAB00)",
    "color.background.warning.bold.hovered": "var(--ds-background-warning-bold-hovered, #FFC400)",
    "color.background.warning.bold.pressed": "var(--ds-background-warning-bold-pressed, #FF991F)",
    "color.background.success": "var(--ds-background-success, #E3FCEF)",
    "color.background.success.hovered": "var(--ds-background-success-hovered, #ABF5D1)",
    "color.background.success.pressed": "var(--ds-background-success-pressed, #79F2C0)",
    "color.background.success.bold": "var(--ds-background-success-bold, #00875A)",
    "color.background.success.bold.hovered": "var(--ds-background-success-bold-hovered, #57D9A3)",
    "color.background.success.bold.pressed": "var(--ds-background-success-bold-pressed, #00875A)",
    "color.background.discovery": "var(--ds-background-discovery, #EAE6FF)",
    "color.background.discovery.hovered": "var(--ds-background-discovery-hovered, #C0B6F2)",
    "color.background.discovery.pressed": "var(--ds-background-discovery-pressed, #998DD9)",
    "color.background.discovery.bold": "var(--ds-background-discovery-bold, #5243AA)",
    "color.background.discovery.bold.hovered": "var(--ds-background-discovery-bold-hovered, #8777D9)",
    "color.background.discovery.bold.pressed": "var(--ds-background-discovery-bold-pressed, #5243AA)",
    "color.background.information": "var(--ds-background-information, #DEEBFF)",
    "color.background.information.hovered": "var(--ds-background-information-hovered, #B3D4FF)",
    "color.background.information.pressed": "var(--ds-background-information-pressed, #4C9AFF)",
    "color.background.information.bold": "var(--ds-background-information-bold, #0052CC)",
    "color.background.information.bold.hovered": "var(--ds-background-information-bold-hovered, #2684FF)",
    "color.background.information.bold.pressed": "var(--ds-background-information-bold-pressed, #0052CC)",
    "color.blanket": "var(--ds-blanket, #091e4289)",
    "color.blanket.selected": "var(--ds-blanket-selected, #388BFF14)",
    "color.blanket.danger": "var(--ds-blanket-danger, #EF5C4814)",
    "elevation.surface": "var(--ds-surface, #FFFFFF)",
    "elevation.surface.hovered": "var(--ds-surface-hovered, #FAFBFC)",
    "elevation.surface.pressed": "var(--ds-surface-pressed, #F4F5F7)",
    "elevation.surface.overlay": "var(--ds-surface-overlay, #FFFFFF)",
    "elevation.surface.overlay.hovered": "var(--ds-surface-overlay-hovered, #FAFBFC)",
    "elevation.surface.overlay.pressed": "var(--ds-surface-overlay-pressed, #F4F5F7)",
    "elevation.surface.raised": "var(--ds-surface-raised, #FFFFFF)",
    "elevation.surface.raised.hovered": "var(--ds-surface-raised-hovered, #FAFBFC)",
    "elevation.surface.raised.pressed": "var(--ds-surface-raised-pressed, #F4F5F7)",
    "elevation.surface.sunken": "var(--ds-surface-sunken, #F4F5F7)",
    "utility.elevation.surface.current": "var(--ds-elevation-surface-current, #FFFFFF)"
};
var $087ca8fdae1b787c$export$8473307aa00d6ea1 = {
    "color.text": "var(--ds-text, #172B4D)",
    "color.text.accent.lime": "var(--ds-text-accent-lime, #4C6B1F)",
    "color.text.accent.lime.bolder": "var(--ds-text-accent-lime-bolder, #37471F)",
    "color.text.accent.red": "var(--ds-text-accent-red, #DE350B)",
    "color.text.accent.red.bolder": "var(--ds-text-accent-red-bolder, #BF2600)",
    "color.text.accent.orange": "var(--ds-text-accent-orange, #F18D13)",
    "color.text.accent.orange.bolder": "var(--ds-text-accent-orange-bolder, #B65C02)",
    "color.text.accent.yellow": "var(--ds-text-accent-yellow, #FF991F)",
    "color.text.accent.yellow.bolder": "var(--ds-text-accent-yellow-bolder, #FF8B00)",
    "color.text.accent.green": "var(--ds-text-accent-green, #00875A)",
    "color.text.accent.green.bolder": "var(--ds-text-accent-green-bolder, #006644)",
    "color.text.accent.teal": "var(--ds-text-accent-teal, #00A3BF)",
    "color.text.accent.teal.bolder": "var(--ds-text-accent-teal-bolder, #008DA6)",
    "color.text.accent.blue": "var(--ds-text-accent-blue, #0052CC)",
    "color.text.accent.blue.bolder": "var(--ds-text-accent-blue-bolder, #0747A6)",
    "color.text.accent.purple": "var(--ds-text-accent-purple, #5243AA)",
    "color.text.accent.purple.bolder": "var(--ds-text-accent-purple-bolder, #403294)",
    "color.text.accent.magenta": "var(--ds-text-accent-magenta, #E774BB)",
    "color.text.accent.magenta.bolder": "var(--ds-text-accent-magenta-bolder, #DA62AC)",
    "color.text.accent.gray": "var(--ds-text-accent-gray, #505F79)",
    "color.text.accent.gray.bolder": "var(--ds-text-accent-gray-bolder, #172B4D)",
    "color.text.disabled": "var(--ds-text-disabled, #A5ADBA)",
    "color.text.inverse": "var(--ds-text-inverse, #FFFFFF)",
    "color.text.selected": "var(--ds-text-selected, #0052CC)",
    "color.text.brand": "var(--ds-text-brand, #0065FF)",
    "color.text.danger": "var(--ds-text-danger, #DE350B)",
    "color.text.warning": "var(--ds-text-warning, #974F0C)",
    "color.text.warning.inverse": "var(--ds-text-warning-inverse, #172B4D)",
    "color.text.success": "var(--ds-text-success, #006644)",
    "color.text.discovery": "var(--ds-text-discovery, #403294)",
    "color.text.information": "var(--ds-text-information, #0052CC)",
    "color.text.subtlest": "var(--ds-text-subtlest, #7A869A)",
    "color.text.subtle": "var(--ds-text-subtle, #42526E)",
    "color.link": "var(--ds-link, #0052CC)",
    "color.link.pressed": "var(--ds-link-pressed, #0747A6)",
    "color.link.visited": "var(--ds-link-visited, #403294)",
    "color.link.visited.pressed": "var(--ds-link-visited-pressed, #403294)"
};
var $087ca8fdae1b787c$export$498780f74be9af68 = {
    "color.icon": "var(--ds-icon, #505F79)",
    "color.icon.accent.lime": "var(--ds-icon-accent-lime, #6A9A23)",
    "color.icon.accent.red": "var(--ds-icon-accent-red, #FF5630)",
    "color.icon.accent.orange": "var(--ds-icon-accent-orange, #D94008)",
    "color.icon.accent.yellow": "var(--ds-icon-accent-yellow, #FFAB00)",
    "color.icon.accent.green": "var(--ds-icon-accent-green, #36B37E)",
    "color.icon.accent.teal": "var(--ds-icon-accent-teal, #00B8D9)",
    "color.icon.accent.blue": "var(--ds-icon-accent-blue, #0065FF)",
    "color.icon.accent.purple": "var(--ds-icon-accent-purple, #6554C0)",
    "color.icon.accent.magenta": "var(--ds-icon-accent-magenta, #CD519D)",
    "color.icon.accent.gray": "var(--ds-icon-accent-gray, #5E6C84)",
    "color.icon.disabled": "var(--ds-icon-disabled, #8993A4)",
    "color.icon.inverse": "var(--ds-icon-inverse, #FFFFFF)",
    "color.icon.selected": "var(--ds-icon-selected, #0052CC)",
    "color.icon.brand": "var(--ds-icon-brand, #0065FF)",
    "color.icon.danger": "var(--ds-icon-danger, #DE350B)",
    "color.icon.warning": "var(--ds-icon-warning, #FFC400)",
    "color.icon.warning.inverse": "var(--ds-icon-warning-inverse, #253858)",
    "color.icon.success": "var(--ds-icon-success, #00875A)",
    "color.icon.discovery": "var(--ds-icon-discovery, #8777D9)",
    "color.icon.information": "var(--ds-icon-information, #0747A6)",
    "color.icon.subtle": "var(--ds-icon-subtle, #6B778C)"
};
var $087ca8fdae1b787c$export$b5f31a7e431d2eab = {
    card: 100,
    navigation: 200,
    dialog: 300,
    layer: 400,
    blanket: 500,
    modal: 510,
    flag: 600,
    spotlight: 700,
    tooltip: 800
};
var $087ca8fdae1b787c$export$e1b83c5210c471b8 = {
    "border.width": "var(--ds-border-width, 1px)",
    "border.width.0": "var(--ds-border-width-0, 0px)",
    "border.width.indicator": "var(--ds-border-width-indicator, 3px)",
    "border.width.outline": "var(--ds-border-width-outline, 2px)"
};
var $087ca8fdae1b787c$export$3c0a6c3e64bb180d = {
    "border.radius.050": "var(--ds-border-radius-050, 2px)",
    "border.radius": "var(--ds-border-radius, 3px)",
    "border.radius.100": "var(--ds-border-radius-100, 3px)",
    "border.radius.200": "var(--ds-border-radius-200, 8px)",
    "border.radius.300": "var(--ds-border-radius-300, 12px)",
    "border.radius.400": "var(--ds-border-radius-400, 16px)",
    "border.radius.circle": "var(--ds-border-radius-circle, 32032px)"
};
var $087ca8fdae1b787c$export$6cc560b4dedf3816 = {
    medium: 'var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    UNSAFE_small: 'var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    large: 'var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    small: 'var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)'
};
var $087ca8fdae1b787c$export$303e322c6b1ed114 = {
    bold: "var(--ds-font-weight-bold, 700)",
    medium: "var(--ds-font-weight-medium, 500)",
    regular: "var(--ds-font-weight-regular, 400)",
    semibold: "var(--ds-font-weight-semibold, 600)"
};
var $087ca8fdae1b787c$export$3c7e9587132614b4 = {
    "font.family.body": 'var(--ds-font-family-body, ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.family.brand.body": 'var(--ds-font-family-brand-body, "Charlie Text", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.family.brand.heading": 'var(--ds-font-family-brand-heading, "Charlie Display", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.family.code": 'var(--ds-font-family-code, ui-monospace, Menlo, "Segoe UI Mono", "Ubuntu Mono", monospace)',
    "font.family.heading": 'var(--ds-font-family-heading, ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)'
};
/**
 * @codegenEnd
 */ // Generate maps for Box props. backgroundColor, padding, etc
var $087ca8fdae1b787c$var$spacingProperties = [
    // Used by Box
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    // Used by Inline and Stack
    "gap",
    "rowGap",
    "columnGap"
];
var $087ca8fdae1b787c$var$getSerializedStylesMap = function getSerializedStylesMap(cssProperty, tokenMap) {
    return Object.keys(tokenMap).reduce(function(emotionSpacingMap, token) {
        emotionSpacingMap[token] = (0, $jVTBW.css)((0, (/*@__PURE__*/$parcel$interopDefault($67paE)))({}, cssProperty, tokenMap[token]));
        return emotionSpacingMap;
    }, {});
};
var $087ca8fdae1b787c$export$e615f061ca585a6c = $087ca8fdae1b787c$var$spacingProperties.reduce(function(styleMap, spacingProperty) {
    styleMap[spacingProperty] = $087ca8fdae1b787c$var$getSerializedStylesMap(spacingProperty, $087ca8fdae1b787c$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
var $087ca8fdae1b787c$export$bf46c3f9eeafc71f = $087ca8fdae1b787c$var$spacingProperties.reduce(function(styleMap, spacingProperty) {
    styleMap[spacingProperty] = $087ca8fdae1b787c$var$getSerializedStylesMap(spacingProperty, $087ca8fdae1b787c$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
var $087ca8fdae1b787c$export$e7af83bafe7f9e63 = $087ca8fdae1b787c$var$getSerializedStylesMap("backgroundColor", $087ca8fdae1b787c$export$d1d79bf68ac056bd);
var $087ca8fdae1b787c$export$3a1bcba60b23d7f0 = $087ca8fdae1b787c$var$getSerializedStylesMap("color", $087ca8fdae1b787c$export$8473307aa00d6ea1);
var $087ca8fdae1b787c$export$45f3f4fe16f9f7d5 = $087ca8fdae1b787c$var$getSerializedStylesMap("fontWeight", $087ca8fdae1b787c$export$303e322c6b1ed114);
var $087ca8fdae1b787c$export$68cc305da27dbaa4 = $087ca8fdae1b787c$var$getSerializedStylesMap("fontFamily", $087ca8fdae1b787c$export$3c7e9587132614b4);
var $087ca8fdae1b787c$export$128f10c238242f83 = $087ca8fdae1b787c$var$getSerializedStylesMap("font", $087ca8fdae1b787c$export$6cc560b4dedf3816);
var $087ca8fdae1b787c$export$ff257d957d48c421 = $087ca8fdae1b787c$var$getSerializedStylesMap((0, $7W4iZ.CURRENT_SURFACE_CSS_VAR), $087ca8fdae1b787c$export$41a358c9c2356760);
var $087ca8fdae1b787c$export$5e65a44e5b6ecadb = function isSurfaceColorToken(color) {
    return $087ca8fdae1b787c$export$41a358c9c2356760[color] !== undefined;
};

});
parcelRegister("67paE", function(module, exports) {

var $jLmBr = parcelRequire("jLmBr");
function $4746ebe7955eb017$var$_defineProperty(e, r, t) {
    return (r = $jLmBr(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
module.exports = $4746ebe7955eb017$var$_defineProperty, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("jLmBr", function(module, exports) {

var $5RP18 = parcelRequire("5RP18");
var $e633f092c30537cb$var$_typeof = $5RP18.default;

var $9bwOp = parcelRequire("9bwOp");
function $e633f092c30537cb$var$toPropertyKey(t) {
    var i = $9bwOp(t, "string");
    return "symbol" == $e633f092c30537cb$var$_typeof(i) ? i : i + "";
}
module.exports = $e633f092c30537cb$var$toPropertyKey, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("5RP18", function(module, exports) {
function $445979fa85febfff$var$_typeof(o) {
    "@babel/helpers - typeof";
    return module.exports = $445979fa85febfff$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $445979fa85febfff$var$_typeof(o);
}
module.exports = $445979fa85febfff$var$_typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("9bwOp", function(module, exports) {

var $5RP18 = parcelRequire("5RP18");
var $6afe97f061bb555c$var$_typeof = $5RP18.default;
function $6afe97f061bb555c$var$toPrimitive(t, r) {
    if ("object" != $6afe97f061bb555c$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $6afe97f061bb555c$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
module.exports = $6afe97f061bb555c$var$toPrimitive, module.exports.__esModule = true, module.exports["default"] = module.exports;

});



parcelRegister("7W4iZ", function(module, exports) {

$parcel$export(module.exports, "CURRENT_SURFACE_CSS_VAR", function () { return $5c714a240beab570$export$9d7b58831ae93caa; });
var $5c714a240beab570$export$4ef52930e33717cd = "data-theme";
var $5c714a240beab570$export$a00eac3f8684bcd0 = "data-color-mode";
var $5c714a240beab570$export$2112803007239c61 = "data-contrast-mode";
var $5c714a240beab570$export$352e418ed5b6193a = "data-custom-theme";
var $5c714a240beab570$export$2faeed762aac6741 = "light";
var $5c714a240beab570$export$6f0c6fb8c80fcc92 = "ds";
var $5c714a240beab570$export$4d0c7bbf80185957 = [
    "opacity",
    "font",
    "space",
    "border"
];
var $5c714a240beab570$export$dddac1532e822863 = "--".concat($5c714a240beab570$export$6f0c6fb8c80fcc92, "-token-not-found");
var $5c714a240beab570$export$9d7b58831ae93caa = "--".concat($5c714a240beab570$export$6f0c6fb8c80fcc92, "-elevation-surface-current");

});


parcelRegister("cLRZO", function(module, exports) {

$parcel$export(module.exports, "parseXcss", function () { return $94c3c24f00452a3e$export$a9c84988c8f81f2d; });
$parcel$export(module.exports, "xcss", function () { return $94c3c24f00452a3e$export$f6c783d06584602c; });

var $hcOR8 = parcelRequire("hcOR8");

var $67paE = parcelRequire("67paE");

var $6cz07 = parcelRequire("6cz07");

var $5RP18 = parcelRequire("5RP18");

var $jVTBW = parcelRequire("jVTBW");

var $JaTZ8 = parcelRequire("JaTZ8");

var $ahJoN = parcelRequire("ahJoN");
function $94c3c24f00452a3e$var$_createForOfIteratorHelper(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (!it) {
        if (Array.isArray(o) || (it = $94c3c24f00452a3e$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
            if (it) o = it;
            var i = 0;
            var F = function F() {};
            return {
                s: F,
                n: function n() {
                    if (i >= o.length) return {
                        done: true
                    };
                    return {
                        done: false,
                        value: o[i++]
                    };
                },
                e: function e(_e) {
                    throw _e;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var normalCompletion = true, didErr = false, err;
    return {
        s: function s() {
            it = it.call(o);
        },
        n: function n() {
            var step = it.next();
            normalCompletion = step.done;
            return step;
        },
        e: function e(_e2) {
            didErr = true;
            err = _e2;
        },
        f: function f() {
            try {
                if (!normalCompletion && it.return != null) it.return();
            } finally{
                if (didErr) throw err;
            }
        }
    };
}
function $94c3c24f00452a3e$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $94c3c24f00452a3e$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $94c3c24f00452a3e$var$_arrayLikeToArray(o, minLen);
}
function $94c3c24f00452a3e$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $94c3c24f00452a3e$export$9a199fbafee0014e = {
    backgroundColor: (0, $JaTZ8.backgroundColorMap),
    blockSize: (0, $JaTZ8.dimensionMap),
    borderBlockColor: (0, $JaTZ8.borderColorMap),
    borderBlockEndColor: (0, $JaTZ8.borderColorMap),
    borderBlockEndWidth: (0, $JaTZ8.borderWidthMap),
    borderBlockStartColor: (0, $JaTZ8.borderColorMap),
    borderBlockStartWidth: (0, $JaTZ8.borderWidthMap),
    borderBlockWidth: (0, $JaTZ8.borderWidthMap),
    borderBottomColor: (0, $JaTZ8.borderColorMap),
    borderBottomLeftRadius: (0, $JaTZ8.borderRadiusMap),
    borderBottomRightRadius: (0, $JaTZ8.borderRadiusMap),
    borderBottomWidth: (0, $JaTZ8.borderWidthMap),
    borderColor: (0, $JaTZ8.borderColorMap),
    borderEndEndRadius: (0, $JaTZ8.borderRadiusMap),
    borderEndStartRadius: (0, $JaTZ8.borderRadiusMap),
    borderInlineColor: (0, $JaTZ8.borderColorMap),
    borderInlineEndColor: (0, $JaTZ8.borderColorMap),
    borderInlineEndWidth: (0, $JaTZ8.borderWidthMap),
    borderInlineStartColor: (0, $JaTZ8.borderColorMap),
    borderInlineStartWidth: (0, $JaTZ8.borderWidthMap),
    borderInlineWidth: (0, $JaTZ8.borderWidthMap),
    borderLeftColor: (0, $JaTZ8.borderColorMap),
    borderLeftWidth: (0, $JaTZ8.borderWidthMap),
    borderRadius: (0, $JaTZ8.borderRadiusMap),
    borderRightColor: (0, $JaTZ8.borderColorMap),
    borderRightWidth: (0, $JaTZ8.borderWidthMap),
    borderStartEndRadius: (0, $JaTZ8.borderRadiusMap),
    borderStartStartRadius: (0, $JaTZ8.borderRadiusMap),
    borderTopColor: (0, $JaTZ8.borderColorMap),
    borderTopLeftRadius: (0, $JaTZ8.borderRadiusMap),
    borderTopRightRadius: (0, $JaTZ8.borderRadiusMap),
    borderTopWidth: (0, $JaTZ8.borderWidthMap),
    borderWidth: (0, $JaTZ8.borderWidthMap),
    bottom: (0, $JaTZ8.allSpaceMap),
    boxShadow: (0, $JaTZ8.shadowMap),
    color: (0, $JaTZ8.textColorMap),
    columnGap: (0, $JaTZ8.positiveSpaceMap),
    gap: (0, $JaTZ8.positiveSpaceMap),
    height: (0, $JaTZ8.dimensionMap),
    inlineSize: (0, $JaTZ8.dimensionMap),
    inset: (0, $JaTZ8.allSpaceMap),
    insetBlock: (0, $JaTZ8.allSpaceMap),
    insetBlockEnd: (0, $JaTZ8.allSpaceMap),
    insetBlockStart: (0, $JaTZ8.allSpaceMap),
    insetInline: (0, $JaTZ8.allSpaceMap),
    insetInlineEnd: (0, $JaTZ8.allSpaceMap),
    insetInlineStart: (0, $JaTZ8.allSpaceMap),
    left: (0, $JaTZ8.allSpaceMap),
    margin: (0, $JaTZ8.allSpaceMap),
    marginBlock: (0, $JaTZ8.allSpaceMap),
    marginBlockEnd: (0, $JaTZ8.allSpaceMap),
    marginBlockStart: (0, $JaTZ8.allSpaceMap),
    marginBottom: (0, $JaTZ8.allSpaceMap),
    marginInline: (0, $JaTZ8.allSpaceMap),
    marginInlineEnd: (0, $JaTZ8.allSpaceMap),
    marginInlineStart: (0, $JaTZ8.allSpaceMap),
    marginLeft: (0, $JaTZ8.allSpaceMap),
    marginRight: (0, $JaTZ8.allSpaceMap),
    marginTop: (0, $JaTZ8.allSpaceMap),
    maxBlockSize: (0, $JaTZ8.dimensionMap),
    maxHeight: (0, $JaTZ8.dimensionMap),
    maxInlineSize: (0, $JaTZ8.dimensionMap),
    maxWidth: (0, $JaTZ8.dimensionMap),
    minBlockSize: (0, $JaTZ8.dimensionMap),
    minHeight: (0, $JaTZ8.dimensionMap),
    minInlineSize: (0, $JaTZ8.dimensionMap),
    minWidth: (0, $JaTZ8.dimensionMap),
    opacity: (0, $JaTZ8.opacityMap),
    outlineColor: (0, $JaTZ8.borderColorMap),
    outlineOffset: (0, $JaTZ8.positiveSpaceMap),
    outlineWidth: (0, $JaTZ8.borderWidthMap),
    padding: (0, $JaTZ8.positiveSpaceMap),
    paddingBlock: (0, $JaTZ8.positiveSpaceMap),
    paddingBlockEnd: (0, $JaTZ8.positiveSpaceMap),
    paddingBlockStart: (0, $JaTZ8.positiveSpaceMap),
    paddingBottom: (0, $JaTZ8.positiveSpaceMap),
    paddingInline: (0, $JaTZ8.positiveSpaceMap),
    paddingInlineEnd: (0, $JaTZ8.positiveSpaceMap),
    paddingInlineStart: (0, $JaTZ8.positiveSpaceMap),
    paddingLeft: (0, $JaTZ8.positiveSpaceMap),
    paddingRight: (0, $JaTZ8.positiveSpaceMap),
    paddingTop: (0, $JaTZ8.positiveSpaceMap),
    right: (0, $JaTZ8.allSpaceMap),
    rowGap: (0, $JaTZ8.positiveSpaceMap),
    top: (0, $JaTZ8.allSpaceMap),
    width: (0, $JaTZ8.dimensionMap),
    zIndex: (0, $JaTZ8.layerMap)
};
var $94c3c24f00452a3e$var$uniqueSymbol = Symbol("UNSAFE_INTERNAL_styles");
var $94c3c24f00452a3e$var$isSafeEnvToThrow = function isSafeEnvToThrow() {
    return (typeof $ahJoN === "undefined" ? "undefined" : (0, (/*@__PURE__*/$parcel$interopDefault($5RP18)))($ahJoN)) === "object" && (0, (/*@__PURE__*/$parcel$interopDefault($5RP18)))($ahJoN.env) === "object" && false;
};
var $94c3c24f00452a3e$var$reNestedSelectors = /(\.|\s|&+|\*\>|#|\[.*\])/;
var $94c3c24f00452a3e$var$safeSelectors = /^@media .*$|^::?.*$|^@supports .*$/;
var $94c3c24f00452a3e$var$transformStyles = function transformStyles(styleObj) {
    if (!styleObj || (0, (/*@__PURE__*/$parcel$interopDefault($5RP18)))(styleObj) !== "object") return styleObj;
    // If styles are defined as a CSSObject[], recursively call on each element until we reach CSSObject
    if (Array.isArray(styleObj)) return styleObj.map(transformStyles);
    // Modifies styleObj in place. Be careful.
    Object.entries(styleObj).forEach(function(_ref) {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($6cz07)))(_ref, 2), key = _ref2[0], value = _ref2[1];
        // If key is a pseudo class or a pseudo element, then value should be an object.
        // So, call transformStyles on the value
        if ((0, (/*@__PURE__*/$parcel$interopDefault($5RP18)))(value) === "object" && $94c3c24f00452a3e$var$safeSelectors.test(key)) {
            styleObj[key] = transformStyles(value);
            return;
        }
        if ($94c3c24f00452a3e$var$isSafeEnvToThrow()) {
            // We don't support `.class`, `[data-testid]`, `> *`, `#some-id`
            if ($94c3c24f00452a3e$var$reNestedSelectors.test(key)) throw new Error("Styles not supported for key '".concat(key, "'."));
        }
        // We have now dealt with all the special cases, so,
        // check whether what remains is a style property
        // that can be transformed.
        if (!(key in $94c3c24f00452a3e$export$9a199fbafee0014e)) return;
        var tokenValue = $94c3c24f00452a3e$export$9a199fbafee0014e[key][value];
        styleObj[key] = tokenValue !== null && tokenValue !== void 0 ? tokenValue : value;
    });
    return styleObj;
};
var $94c3c24f00452a3e$var$baseXcss = function baseXcss(style) {
    var transformedStyles = $94c3c24f00452a3e$var$transformStyles(style);
    return (0, (/*@__PURE__*/$parcel$interopDefault($67paE)))({}, $94c3c24f00452a3e$var$uniqueSymbol, (0, $jVTBW.css)(transformedStyles));
};
var $94c3c24f00452a3e$export$a9c84988c8f81f2d = function parseXcss(args) {
    if (Array.isArray(args)) {
        var emotion = [];
        var staticArr = [];
        var _iterator = $94c3c24f00452a3e$var$_createForOfIteratorHelper(args), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var arg = _step.value;
                var result = parseXcss(arg);
                if (result.emotion) emotion.push.apply(emotion, (0, (/*@__PURE__*/$parcel$interopDefault($hcOR8)))(result.emotion));
                if (result.static) staticArr.push(result.static);
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        return {
            emotion: emotion,
            static: staticArr.join(" ")
        };
    }
    var objArgs = args;
    var _ref4 = objArgs || {}, styles = _ref4[$94c3c24f00452a3e$var$uniqueSymbol];
    if (styles) return {
        emotion: [
            styles
        ]
    };
    if (args) {
        // We use string interpolation here instead of .toString() just
        // in case the resulting object doesn't have the method available.
        var stringifiedArgs = "".concat(args);
        if (stringifiedArgs) return {
            static: stringifiedArgs
        };
    }
    return {};
};
function $94c3c24f00452a3e$export$f6c783d06584602c(style) {
    return $94c3c24f00452a3e$var$baseXcss(style);
}

});
parcelRegister("6cz07", function(module, exports) {

var $kCnBX = parcelRequire("kCnBX");

var $e9CLp = parcelRequire("e9CLp");

var $jQtma = parcelRequire("jQtma");

var $5ydiu = parcelRequire("5ydiu");
function $483f038690ac42ef$var$_slicedToArray(r, e) {
    return $kCnBX(r) || $e9CLp(r, e) || $jQtma(r, e) || $5ydiu();
}
module.exports = $483f038690ac42ef$var$_slicedToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("kCnBX", function(module, exports) {
function $f029abee2b48e9ae$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
module.exports = $f029abee2b48e9ae$var$_arrayWithHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("e9CLp", function(module, exports) {
function $a4dff99d676858fe$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
module.exports = $a4dff99d676858fe$var$_iterableToArrayLimit, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("5ydiu", function(module, exports) {
function $40aa7141a8af4a05$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
module.exports = $40aa7141a8af4a05$var$_nonIterableRest, module.exports.__esModule = true, module.exports["default"] = module.exports;

});



parcelRegister("8lTJk", function(module, exports) {

$parcel$export(module.exports, "SurfaceContext", function () { return $614b83ba46be97b0$export$1ca2a26fecb070ae; });

var $dAx5m = parcelRequire("dAx5m");
var $614b83ba46be97b0$export$1ca2a26fecb070ae = /*#__PURE__*/ (0, $dAx5m.createContext)("elevation.surface");
var $614b83ba46be97b0$export$1aeb4f6b93c4540d = function useSurface() {
    return (0, $dAx5m.useContext)($614b83ba46be97b0$export$1ca2a26fecb070ae);
};
$614b83ba46be97b0$export$1ca2a26fecb070ae.displayName = "SurfaceProvider";

});


parcelRegister("9Pfox", function(module, exports) {

$parcel$export(module.exports, "h700", function () { return $7274d18f21de9579$export$e4f993a313607daa; });

var $67paE = parcelRequire("67paE");

var $hPTIV = parcelRequire("hPTIV");

var $cgVu3 = parcelRequire("cgVu3");
function $7274d18f21de9579$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $7274d18f21de9579$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $7274d18f21de9579$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($67paE)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $7274d18f21de9579$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $7274d18f21de9579$export$2a99220fb32ec798 = {
    heading: {
        xxlarge: 'normal 500 35px/40px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
        xlarge: 'normal 600 29px/32px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
        large: 'normal 500 24px/28px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
        medium: 'normal 500 20px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
        small: 'normal 600 16px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
        xsmall: 'normal 600 14px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
        xxsmall: 'normal 600 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif'
    },
    body: {
        large: 'normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
        medium: 'normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
        UNSAFE_small: 'normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
        small: 'normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif'
    }
};
var $7274d18f21de9579$var$baseHeading = function baseHeading(size, lineHeight) {
    return {
        fontSize: "".concat(size / 14, "em"),
        fontStyle: "inherit",
        lineHeight: lineHeight / size
    };
};
var $7274d18f21de9579$export$bc02e067df412c3b = {
    h900: {
        size: 35,
        lineHeight: 40
    },
    h800: {
        size: 29,
        lineHeight: 32
    },
    h700: {
        size: 24,
        lineHeight: 28
    },
    h600: {
        size: 20,
        lineHeight: 24
    },
    h500: {
        size: 16,
        lineHeight: 20
    },
    h400: {
        size: 14,
        lineHeight: 16
    },
    h300: {
        size: 12,
        lineHeight: 16
    },
    h200: {
        size: 12,
        lineHeight: 16
    },
    h100: {
        size: 11,
        lineHeight: 16
    }
};
var $7274d18f21de9579$export$bdb8f897727a9c67 = function h900() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return $7274d18f21de9579$var$_objectSpread($7274d18f21de9579$var$_objectSpread({}, $7274d18f21de9579$var$baseHeading($7274d18f21de9579$export$bc02e067df412c3b.h900.size, $7274d18f21de9579$export$bc02e067df412c3b.h900.lineHeight)), {}, {
        color: "var(--ds-text, ".concat((0, $hPTIV.heading)(props), ")"),
        fontWeight: "var(--ds-font-weight-medium, 500)",
        letterSpacing: "-0.01em",
        marginTop: "".concat((0, $cgVu3.gridSize)() * 6.5, "px")
    });
};
var $7274d18f21de9579$export$3953fb6fbd158d23 = function h800() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return $7274d18f21de9579$var$_objectSpread($7274d18f21de9579$var$_objectSpread({}, $7274d18f21de9579$var$baseHeading($7274d18f21de9579$export$bc02e067df412c3b.h800.size, $7274d18f21de9579$export$bc02e067df412c3b.h800.lineHeight)), {}, {
        color: "var(--ds-text, ".concat((0, $hPTIV.heading)(props), ")"),
        fontWeight: "var(--ds-font-weight-semibold, 600)",
        letterSpacing: "-0.01em",
        marginTop: "".concat((0, $cgVu3.gridSize)() * 5, "px")
    });
};
var $7274d18f21de9579$export$e4f993a313607daa = function h700() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return $7274d18f21de9579$var$_objectSpread($7274d18f21de9579$var$_objectSpread({}, $7274d18f21de9579$var$baseHeading($7274d18f21de9579$export$bc02e067df412c3b.h700.size, $7274d18f21de9579$export$bc02e067df412c3b.h700.lineHeight)), {}, {
        color: "var(--ds-text, ".concat((0, $hPTIV.heading)(props), ")"),
        fontWeight: "var(--ds-font-weight-medium, 500)",
        letterSpacing: "-0.01em",
        marginTop: "".concat((0, $cgVu3.gridSize)() * 5, "px")
    });
};
var $7274d18f21de9579$export$1e8b2acea3fb3119 = function h600() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return $7274d18f21de9579$var$_objectSpread($7274d18f21de9579$var$_objectSpread({}, $7274d18f21de9579$var$baseHeading($7274d18f21de9579$export$bc02e067df412c3b.h600.size, $7274d18f21de9579$export$bc02e067df412c3b.h600.lineHeight)), {}, {
        color: "var(--ds-text, ".concat((0, $hPTIV.heading)(props), ")"),
        fontWeight: "var(--ds-font-weight-medium, 500)",
        letterSpacing: "-0.008em",
        marginTop: "".concat((0, $cgVu3.gridSize)() * 3.5, "px")
    });
};
var $7274d18f21de9579$export$85aa43a9b9f06707 = function h500() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return $7274d18f21de9579$var$_objectSpread($7274d18f21de9579$var$_objectSpread({}, $7274d18f21de9579$var$baseHeading($7274d18f21de9579$export$bc02e067df412c3b.h500.size, $7274d18f21de9579$export$bc02e067df412c3b.h500.lineHeight)), {}, {
        color: "var(--ds-text, ".concat((0, $hPTIV.heading)(props), ")"),
        fontWeight: "var(--ds-font-weight-semibold, 600)",
        letterSpacing: "-0.006em",
        marginTop: "".concat((0, $cgVu3.gridSize)() * 3, "px")
    });
};
var $7274d18f21de9579$export$fcb7764b80bd908f = function h400() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return $7274d18f21de9579$var$_objectSpread($7274d18f21de9579$var$_objectSpread({}, $7274d18f21de9579$var$baseHeading($7274d18f21de9579$export$bc02e067df412c3b.h400.size, $7274d18f21de9579$export$bc02e067df412c3b.h400.lineHeight)), {}, {
        color: "var(--ds-text, ".concat((0, $hPTIV.heading)(props), ")"),
        fontWeight: "var(--ds-font-weight-semibold, 600)",
        letterSpacing: "-0.003em",
        marginTop: "".concat((0, $cgVu3.gridSize)() * 2, "px")
    });
};
var $7274d18f21de9579$export$a0e59c3bbc05e815 = function h300() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return $7274d18f21de9579$var$_objectSpread($7274d18f21de9579$var$_objectSpread({}, $7274d18f21de9579$var$baseHeading($7274d18f21de9579$export$bc02e067df412c3b.h300.size, $7274d18f21de9579$export$bc02e067df412c3b.h300.lineHeight)), {}, {
        color: "var(--ds-text, ".concat((0, $hPTIV.heading)(props), ")"),
        fontWeight: "var(--ds-font-weight-semibold, 600)",
        marginTop: "".concat((0, $cgVu3.gridSize)() * 2.5, "px"),
        textTransform: "uppercase"
    });
};
var $7274d18f21de9579$export$7ccf32eb2150ac7e = function h200() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return $7274d18f21de9579$var$_objectSpread($7274d18f21de9579$var$_objectSpread({}, $7274d18f21de9579$var$baseHeading($7274d18f21de9579$export$bc02e067df412c3b.h200.size, $7274d18f21de9579$export$bc02e067df412c3b.h200.lineHeight)), {}, {
        color: "var(--ds-text-subtlest, ".concat((0, $hPTIV.subtleHeading)(props), ")"),
        fontWeight: "var(--ds-font-weight-semibold, 600)",
        marginTop: "".concat((0, $cgVu3.gridSize)() * 2, "px")
    });
};
var $7274d18f21de9579$export$dfc0e69214efdc3c = function h100() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return $7274d18f21de9579$var$_objectSpread($7274d18f21de9579$var$_objectSpread({}, $7274d18f21de9579$var$baseHeading($7274d18f21de9579$export$bc02e067df412c3b.h100.size, $7274d18f21de9579$export$bc02e067df412c3b.h100.lineHeight)), {}, {
        color: "var(--ds-text-subtlest, ".concat((0, $hPTIV.subtleHeading)(props), ")"),
        fontWeight: "var(--ds-font-weight-bold, 700)",
        marginTop: "".concat((0, $cgVu3.gridSize)() * 2, "px")
    });
};

});
parcelRegister("hPTIV", function(module, exports) {

$parcel$export(module.exports, "B200", function () { return $cfc26c9c85b14063$export$215b7063051591f1; });
$parcel$export(module.exports, "N30A", function () { return $cfc26c9c85b14063$export$920c0d5c49070351; });
$parcel$export(module.exports, "heading", function () { return $cfc26c9c85b14063$export$46e4a324ac90507f; });
$parcel$export(module.exports, "subtleHeading", function () { return $cfc26c9c85b14063$export$79f3f2b82beb0d36; });
$parcel$export(module.exports, "skeleton", function () { return $cfc26c9c85b14063$export$2a0674ff2eb10214; });
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ 
var $f6pGf = parcelRequire("f6pGf");
var $cfc26c9c85b14063$export$4b84fd0e2c617bd = "#FFEBE6";
var $cfc26c9c85b14063$export$b34b069eff244586 = "#FFBDAD";
var $cfc26c9c85b14063$export$be802dd0d8b57f35 = "#FF8F73";
var $cfc26c9c85b14063$export$60847d42f9da92a6 = "#FF7452";
var $cfc26c9c85b14063$export$4a7404f376229999 = "#FF5630";
var $cfc26c9c85b14063$export$2010d0fb4295b346 = "#DE350B";
var $cfc26c9c85b14063$export$2837b5a1a71d5c02 = "#BF2600";
var $cfc26c9c85b14063$export$8d9596b529bbb9cf = "#FFFAE6";
var $cfc26c9c85b14063$export$41060a744ab0b7ae = "#FFF0B3";
var $cfc26c9c85b14063$export$1cc05bbbf340e559 = "#FFE380";
var $cfc26c9c85b14063$export$5aae31392d72caaa = "#FFC400";
var $cfc26c9c85b14063$export$c6930421db9fa514 = "#FFAB00";
var $cfc26c9c85b14063$export$59619663aa6500fb = "#FF991F";
var $cfc26c9c85b14063$export$874739ea9e379ab6 = "#FF8B00";
var $cfc26c9c85b14063$export$8a6341c32b6a3ee6 = "#E3FCEF";
var $cfc26c9c85b14063$export$69a3bf21b9686c2b = "#ABF5D1";
var $cfc26c9c85b14063$export$afbce1382ec95f73 = "#79F2C0";
var $cfc26c9c85b14063$export$747d86715d4175de = "#57D9A3";
var $cfc26c9c85b14063$export$940e1f69e873f202 = "#36B37E";
var $cfc26c9c85b14063$export$a49394138f7b8e85 = "#00875A";
var $cfc26c9c85b14063$export$6fa04827ac68a4fb = "#006644";
var $cfc26c9c85b14063$export$226de0355ed012f8 = "#DEEBFF";
var $cfc26c9c85b14063$export$8c13c2ee36917869 = "#B3D4FF";
var $cfc26c9c85b14063$export$ecfc1dff386a3e7a = "#4C9AFF";
var $cfc26c9c85b14063$export$215b7063051591f1 = "#2684FF";
var $cfc26c9c85b14063$export$e62e8919cca44969 = "#0065FF";
var $cfc26c9c85b14063$export$b3de0ae08da2ce64 = "#0052CC";
var $cfc26c9c85b14063$export$a6ee3d71bc067634 = "#0747A6";
var $cfc26c9c85b14063$export$363e4475840015bb = "#EAE6FF";
var $cfc26c9c85b14063$export$4b0a4417ed59760f = "#C0B6F2";
var $cfc26c9c85b14063$export$6011520a64d9a187 = "#998DD9";
var $cfc26c9c85b14063$export$a7175d4e9206bc80 = "#8777D9";
var $cfc26c9c85b14063$export$b48405b95304b5a1 = "#6554C0";
var $cfc26c9c85b14063$export$c71e4279dd54a18d = "#5243AA";
var $cfc26c9c85b14063$export$147899de772240ec = "#403294";
var $cfc26c9c85b14063$export$2cf711fe14c66f06 = "#E6FCFF";
var $cfc26c9c85b14063$export$7a8f4d33f6f9772c = "#B3F5FF";
var $cfc26c9c85b14063$export$776c9c497ef08533 = "#79E2F2";
var $cfc26c9c85b14063$export$69cb3ca10c1e330e = "#00C7E6";
var $cfc26c9c85b14063$export$9dc1ef0f3f48059b = "#00B8D9";
var $cfc26c9c85b14063$export$7c835c78b6fcdef8 = "#00A3BF";
var $cfc26c9c85b14063$export$6036577f95c3877e = "#008DA6";
var $cfc26c9c85b14063$export$29a4f05edc054374 = "#FFFFFF";
var $cfc26c9c85b14063$export$e655ef011c4aa1a2 = "#FAFBFC";
var $cfc26c9c85b14063$export$9fdfb749e33cdf97 = "#F4F5F7";
var $cfc26c9c85b14063$export$3e51e8f1440314ba = "#EBECF0";
var $cfc26c9c85b14063$export$1ce2d1575d444ceb = "#DFE1E6";
var $cfc26c9c85b14063$export$8754fc7e6d8b3000 = "#C1C7D0";
var $cfc26c9c85b14063$export$c2e91cbeada39b8b = "#B3BAC5";
var $cfc26c9c85b14063$export$5f71e19f3a7ad9de = "#A5ADBA";
var $cfc26c9c85b14063$export$eaa8c8a70ac22806 = "#97A0AF";
var $cfc26c9c85b14063$export$7c87d337fb91a97d = "#8993A4";
var $cfc26c9c85b14063$export$d6447c357493214f = "#7A869A";
var $cfc26c9c85b14063$export$f563ee71e9ee74cd = "#6B778C";
var $cfc26c9c85b14063$export$e2ef2124cf4024b1 = "#5E6C84";
var $cfc26c9c85b14063$export$eece5f492e429f08 = "#505F79";
var $cfc26c9c85b14063$export$c39c0fe0f26207ae = "#42526E";
var $cfc26c9c85b14063$export$7090862dc3038a9f = "#344563";
var $cfc26c9c85b14063$export$ad0bacf983b7ddaa = "#253858";
var $cfc26c9c85b14063$export$7d61b15e0da132af = "#172B4D";
var $cfc26c9c85b14063$export$fbda843f0a27fe96 = "#091E42";
var $cfc26c9c85b14063$export$791e57b27ca738ef = "rgba(9, 30, 66, 0.02)";
var $cfc26c9c85b14063$export$8d43898f60b96a82 = "rgba(9, 30, 66, 0.04)";
var $cfc26c9c85b14063$export$920c0d5c49070351 = "rgba(9, 30, 66, 0.08)";
var $cfc26c9c85b14063$export$46987b49aab6d1a8 = "rgba(9, 30, 66, 0.13)";
var $cfc26c9c85b14063$export$7d3359664e8bb0e5 = "rgba(9, 30, 66, 0.25)";
var $cfc26c9c85b14063$export$d2d3bedfb276cac0 = "rgba(9, 30, 66, 0.31)";
var $cfc26c9c85b14063$export$6e5e7499ff054f6d = "rgba(9, 30, 66, 0.36)";
var $cfc26c9c85b14063$export$59264b346c877fa7 = "rgba(9, 30, 66, 0.42)";
var $cfc26c9c85b14063$export$d092757d7c64925c = "rgba(9, 30, 66, 0.48)";
var $cfc26c9c85b14063$export$486ab785e4bac3c6 = "rgba(9, 30, 66, 0.54)";
var $cfc26c9c85b14063$export$fba592bbc6419fea = "rgba(9, 30, 66, 0.60)";
var $cfc26c9c85b14063$export$13609db0e6812ab8 = "rgba(9, 30, 66, 0.66)";
var $cfc26c9c85b14063$export$fbae4efaa892d883 = "rgba(9, 30, 66, 0.71)";
var $cfc26c9c85b14063$export$f13946d26f440ce6 = "rgba(9, 30, 66, 0.77)";
var $cfc26c9c85b14063$export$19f58225ac52a306 = "rgba(9, 30, 66, 0.82)";
var $cfc26c9c85b14063$export$6384f09da70e7b62 = "rgba(9, 30, 66, 0.89)";
var $cfc26c9c85b14063$export$d0dccc730683edc2 = "rgba(9, 30, 66, 0.95)";
var $cfc26c9c85b14063$export$2f6319cf7d736c2a = "#E6EDFA";
var $cfc26c9c85b14063$export$95126bc8884d6634 = "#DCE5F5";
var $cfc26c9c85b14063$export$8338d8c35d44ff1 = "#CED9EB";
var $cfc26c9c85b14063$export$5368d76ae4fbbda7 = "#B8C7E0";
var $cfc26c9c85b14063$export$9f0a771d16ec8d36 = "#ABBBD6";
var $cfc26c9c85b14063$export$abcf8c38338b4aa5 = "#9FB0CC";
var $cfc26c9c85b14063$export$97e81faa16a182c7 = "#8C9CB8";
var $cfc26c9c85b14063$export$bfe21c59123ecf33 = "#7988A3";
var $cfc26c9c85b14063$export$ee82aa2ea6a1558 = "#67758F";
var $cfc26c9c85b14063$export$682927c6ed76be02 = "#56637A";
var $cfc26c9c85b14063$export$91fd9994c5be9757 = "#455166";
var $cfc26c9c85b14063$export$d281fbfe3cff2df6 = "#3B475C";
var $cfc26c9c85b14063$export$3902c91d8b98a753 = "#313D52";
var $cfc26c9c85b14063$export$8e8133c1ba5845b5 = "#283447";
var $cfc26c9c85b14063$export$33ff357f6620b39 = "#202B3D";
var $cfc26c9c85b14063$export$633847cf062b69e0 = "#1B2638";
var $cfc26c9c85b14063$export$9776a6e503bdbf76 = "#121A29";
var $cfc26c9c85b14063$export$6c813d5160dff5db = "#0E1624";
var $cfc26c9c85b14063$export$3d4f271a500072a = "#0D1424";
var $cfc26c9c85b14063$export$fe151285c22759ec = "rgba(13, 20, 36, 0.06)";
var $cfc26c9c85b14063$export$a101c6190d0da34 = "rgba(13, 20, 36, 0.14)";
var $cfc26c9c85b14063$export$4b16f52932fda51 = "rgba(13, 20, 36, 0.18)";
var $cfc26c9c85b14063$export$a74bcd7b9845b0d8 = "rgba(13, 20, 36, 0.29)";
var $cfc26c9c85b14063$export$9209c179316d1751 = "rgba(13, 20, 36, 0.36)";
var $cfc26c9c85b14063$export$88f55133f636c8dd = "rgba(13, 20, 36, 0.40)";
var $cfc26c9c85b14063$export$51126f85d1009512 = "rgba(13, 20, 36, 0.47)";
var $cfc26c9c85b14063$export$a069b547bd23af78 = "rgba(13, 20, 36, 0.53)";
var $cfc26c9c85b14063$export$40cce05af3b2600a = "rgba(13, 20, 36, 0.63)";
var $cfc26c9c85b14063$export$b78942185925a0d = "rgba(13, 20, 36, 0.73)";
var $cfc26c9c85b14063$export$e058fb44b8eaafca = "rgba(13, 20, 36, 0.78)";
var $cfc26c9c85b14063$export$92b0b8de26920c18 = "rgba(13, 20, 36, 0.81)";
var $cfc26c9c85b14063$export$67564f7459d3fc9e = "rgba(13, 20, 36, 0.85)";
var $cfc26c9c85b14063$export$77868e1ca884ffa3 = "rgba(13, 20, 36, 0.89)";
var $cfc26c9c85b14063$export$2afd71d7d3ea2cd5 = "rgba(13, 20, 36, 0.92)";
var $cfc26c9c85b14063$export$f2a0acaab9972c70 = "rgba(13, 20, 36, 0.95)";
var $cfc26c9c85b14063$export$9ab70e67d6475361 = "rgba(13, 20, 36, 0.97)";
var $cfc26c9c85b14063$export$8ce1fd94bee2f412 = (0, $f6pGf.default)({
    light: "var(--ds-surface, ".concat($cfc26c9c85b14063$export$29a4f05edc054374, ")"),
    dark: "var(--ds-surface, ".concat($cfc26c9c85b14063$export$633847cf062b69e0, ")")
});
var $cfc26c9c85b14063$export$b861914ea877b580 = (0, $f6pGf.default)({
    light: "var(--ds-background-selected, ".concat($cfc26c9c85b14063$export$226de0355ed012f8, ")"),
    dark: "var(--ds-background-selected, ".concat($cfc26c9c85b14063$export$8c13c2ee36917869, ")")
});
var $cfc26c9c85b14063$export$3f1b020df94387af = (0, $f6pGf.default)({
    light: "var(--ds-background-neutral-hovered, ".concat($cfc26c9c85b14063$export$3e51e8f1440314ba, ")"),
    dark: "var(--ds-background-neutral-hovered, ".concat($cfc26c9c85b14063$export$d281fbfe3cff2df6, ")")
});
var $cfc26c9c85b14063$export$c0183dbab98ca63e = (0, $f6pGf.default)({
    light: "var(--ds-surface-overlay, ".concat($cfc26c9c85b14063$export$29a4f05edc054374, ")"),
    dark: "var(--ds-surface-overlay, ".concat($cfc26c9c85b14063$export$8e8133c1ba5845b5, ")")
});
var $cfc26c9c85b14063$export$6f093cfa640b7166 = (0, $f6pGf.default)({
    light: "var(--ds-text, ".concat($cfc26c9c85b14063$export$fbda843f0a27fe96, ")"),
    dark: "var(--ds-text, ".concat($cfc26c9c85b14063$export$5368d76ae4fbbda7, ")")
});
var $cfc26c9c85b14063$export$42f8e9c698766e7a = (0, $f6pGf.default)({
    light: "var(--ds-text, ".concat($cfc26c9c85b14063$export$7d61b15e0da132af, ")"),
    dark: "var(--ds-text, ".concat($cfc26c9c85b14063$export$5368d76ae4fbbda7, ")")
});
var $cfc26c9c85b14063$export$c2d157ca1c34b6e3 = (0, $f6pGf.default)({
    light: "var(--ds-text-selected, ".concat($cfc26c9c85b14063$export$b3de0ae08da2ce64, ")"),
    dark: "var(--ds-text-selected, ".concat($cfc26c9c85b14063$export$b3de0ae08da2ce64, ")")
});
var $cfc26c9c85b14063$export$1905ba28d7cf066f = (0, $f6pGf.default)({
    light: "var(--ds-text-subtlest, ".concat($cfc26c9c85b14063$export$f563ee71e9ee74cd, ")"),
    dark: "var(--ds-text-subtlest, ".concat($cfc26c9c85b14063$export$97e81faa16a182c7, ")")
});
var $cfc26c9c85b14063$export$bd9002130d306d39 = (0, $f6pGf.default)({
    light: "var(--ds-text-subtlest, ".concat($cfc26c9c85b14063$export$f563ee71e9ee74cd, ")"),
    dark: "var(--ds-text-subtlest, ".concat($cfc26c9c85b14063$export$bfe21c59123ecf33, ")")
});
var $cfc26c9c85b14063$export$46e4a324ac90507f = (0, $f6pGf.default)({
    light: "var(--ds-text, ".concat($cfc26c9c85b14063$export$7d61b15e0da132af, ")"),
    dark: "var(--ds-text, ".concat($cfc26c9c85b14063$export$5368d76ae4fbbda7, ")")
});
var $cfc26c9c85b14063$export$79f3f2b82beb0d36 = (0, $f6pGf.default)({
    light: "var(--ds-text-subtlest, ".concat($cfc26c9c85b14063$export$f563ee71e9ee74cd, ")"),
    dark: "var(--ds-text-subtlest, ".concat($cfc26c9c85b14063$export$97e81faa16a182c7, ")")
});
var $cfc26c9c85b14063$export$7bb0d5c671655cc4 = (0, $f6pGf.default)({
    light: $cfc26c9c85b14063$export$9fdfb749e33cdf97,
    dark: $cfc26c9c85b14063$export$8e8133c1ba5845b5
});
var $cfc26c9c85b14063$export$9c30223ca0a664fb = (0, $f6pGf.default)({
    light: "var(--ds-link, ".concat($cfc26c9c85b14063$export$b3de0ae08da2ce64, ")"),
    dark: "var(--ds-link, ".concat($cfc26c9c85b14063$export$ecfc1dff386a3e7a, ")")
});
var $cfc26c9c85b14063$export$7ed258b0728b004b = (0, $f6pGf.default)({
    light: "var(--ds-link-pressed, ".concat($cfc26c9c85b14063$export$e62e8919cca44969, ")"),
    dark: "var(--ds-link-pressed, ".concat($cfc26c9c85b14063$export$215b7063051591f1, ")")
});
var $cfc26c9c85b14063$export$dfa920d8decc8a59 = (0, $f6pGf.default)({
    light: "var(--ds-link-pressed, ".concat($cfc26c9c85b14063$export$a6ee3d71bc067634, ")"),
    dark: "var(--ds-link-pressed, ".concat($cfc26c9c85b14063$export$ecfc1dff386a3e7a, ")")
});
var $cfc26c9c85b14063$export$6069e6ad5c78f632 = (0, $f6pGf.default)({
    light: "var(--ds-border-focused, ".concat($cfc26c9c85b14063$export$215b7063051591f1, ")"),
    dark: "var(--ds-border-focused, ".concat($cfc26c9c85b14063$export$215b7063051591f1, ")")
});
var $cfc26c9c85b14063$export$9ad721cf3b3debe0 = (0, $f6pGf.default)({
    light: "var(--ds-background-brand-bold, ".concat($cfc26c9c85b14063$export$b3de0ae08da2ce64, ")"),
    dark: "var(--ds-background-brand-bold, ".concat($cfc26c9c85b14063$export$ecfc1dff386a3e7a, ")")
});
var $cfc26c9c85b14063$export$2aa0182783e7e9de = (0, $f6pGf.default)({
    light: $cfc26c9c85b14063$export$b3de0ae08da2ce64,
    dark: $cfc26c9c85b14063$export$ecfc1dff386a3e7a
});
var $cfc26c9c85b14063$export$8bf7dff220b82b4a = (0, $f6pGf.default)({
    light: $cfc26c9c85b14063$export$9dc1ef0f3f48059b,
    dark: $cfc26c9c85b14063$export$69cb3ca10c1e330e
});
var $cfc26c9c85b14063$export$e13cce2a2d16a9d4 = (0, $f6pGf.default)({
    light: $cfc26c9c85b14063$export$b48405b95304b5a1,
    dark: $cfc26c9c85b14063$export$6011520a64d9a187
});
var $cfc26c9c85b14063$export$a90204d1394caf30 = (0, $f6pGf.default)({
    light: $cfc26c9c85b14063$export$4a7404f376229999,
    dark: $cfc26c9c85b14063$export$4a7404f376229999
});
var $cfc26c9c85b14063$export$594c5a8758200c32 = (0, $f6pGf.default)({
    light: $cfc26c9c85b14063$export$c6930421db9fa514,
    dark: $cfc26c9c85b14063$export$c6930421db9fa514
});
var $cfc26c9c85b14063$export$955a2ebd2fb142ae = (0, $f6pGf.default)({
    light: $cfc26c9c85b14063$export$940e1f69e873f202,
    dark: $cfc26c9c85b14063$export$940e1f69e873f202
});
var $cfc26c9c85b14063$export$2a0674ff2eb10214 = function skeleton() {
    return "var(--ds-skeleton, ".concat($cfc26c9c85b14063$export$8d43898f60b96a82, ")");
};

});
parcelRegister("f6pGf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $afeb562a4c7fe2f7$export$2e2bcd8739ae039; });
/* eslint-disable prefer-rest-params */ 
var $bfP3d = parcelRequire("bfP3d");
// Unpack custom variants, and get correct value for the current theme
function $afeb562a4c7fe2f7$var$themedVariants(variantProp, variants) {
    return function(props) {
        var theme = (0, $bfP3d.default)(props);
        if (props && props[variantProp] && variants) {
            var modes = variants[props[variantProp]];
            if (modes && modes[theme.mode]) {
                var value = modes[theme.mode];
                if (value) return value;
                 // TS believes value can be undefined
            }
        }
        return "";
    };
}
function $afeb562a4c7fe2f7$export$2e2bcd8739ae039(modesOrVariant, variantModes) {
    if (typeof modesOrVariant === "string") return $afeb562a4c7fe2f7$var$themedVariants(modesOrVariant, variantModes);
    var modes = modesOrVariant;
    return function(props) {
        // Get theme from the user's props
        var theme = (0, $bfP3d.default)(props);
        // User isn't required to provide both light and dark values
        if (theme.mode in modes) {
            var value = modes[theme.mode]; // TS believes value can be undefined
            if (value) return value;
        }
        return "";
    };
}

});
parcelRegister("bfP3d", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8318b20bf18f5b87$export$2e2bcd8739ae039; });

var $cgVu3 = parcelRequire("cgVu3");
function $8318b20bf18f5b87$export$2e2bcd8739ae039(props) {
    if (props && props.theme) {
        // Theme is the global Atlaskit theme
        if ((0, $cgVu3.CHANNEL) in props.theme) return props.theme[0, $cgVu3.CHANNEL];
        else if ("mode" in props.theme && (0, $cgVu3.THEME_MODES).includes(props.theme.mode)) return props.theme;
    }
    // If format not supported (or no theme provided), return standard theme
    return {
        mode: (0, $cgVu3.DEFAULT_THEME_MODE)
    };
}

});
parcelRegister("cgVu3", function(module, exports) {

$parcel$export(module.exports, "CHANNEL", function () { return $8ef391b681ac140e$export$44ffba16bd48dac6; });
$parcel$export(module.exports, "DEFAULT_THEME_MODE", function () { return $8ef391b681ac140e$export$c93026a968943f95; });
$parcel$export(module.exports, "THEME_MODES", function () { return $8ef391b681ac140e$export$6ba72c8346b4c57e; });
$parcel$export(module.exports, "gridSize", function () { return $8ef391b681ac140e$export$6d8204c2cb2e06b8; });

var $e2xkU = parcelRequire("e2xkU");

var $hPTIV = parcelRequire("hPTIV");
var $8ef391b681ac140e$export$44ffba16bd48dac6 = "__ATLASKIT_THEME__";
var $8ef391b681ac140e$export$c93026a968943f95 = "light";
var $8ef391b681ac140e$export$6ba72c8346b4c57e = [
    "light",
    "dark"
];
var $8ef391b681ac140e$export$7a57f79000377ca2 = function borderRadius() {
    return 3;
};
var $8ef391b681ac140e$export$6d8204c2cb2e06b8 = function gridSize() {
    return 8;
};
var $8ef391b681ac140e$export$85e3c3ca0c6fb93 = function fontSize() {
    return 14;
};
var $8ef391b681ac140e$export$6746fe0d9c9fab54 = function fontSizeSmall() {
    return 11;
};
var $8ef391b681ac140e$export$a5975749f0374264 = function fontFamily() {
    return "-apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif";
};
var $8ef391b681ac140e$export$356129969ee49c55 = function codeFontFamily() {
    return "'SFMono-Medium', 'SF Mono', 'Segoe UI Mono', 'Roboto Mono', 'Ubuntu Mono', Menlo, Consolas, Courier, monospace";
};
var $8ef391b681ac140e$export$8e24544ddba725ee = function focusRing() {
    var color = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "var(--ds-border-focused, ".concat((0, $hPTIV.B200), ")");
    var outlineWidth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $8ef391b681ac140e$export$6d8204c2cb2e06b8() / 4;
    (0, $e2xkU.default)("@atlaskit/theme", "focus ring mixin", "Please use `@atlaskit/focus-ring` instead.");
    return "\n  &:focus {\n    outline: none;\n    box-shadow: 0px 0px 0px ".concat(outlineWidth, "px ").concat(color, ";\n  }\n");
};
var $8ef391b681ac140e$export$c0dd343266bc3261 = function noFocusRing() {
    return "\n  box-shadow: none;\n";
};
var $8ef391b681ac140e$export$7be255094ccdc533 = {
    card: function card() {
        return 100;
    },
    navigation: function navigation() {
        return 200;
    },
    dialog: function dialog() {
        return 300;
    },
    layer: function layer() {
        return 400;
    },
    blanket: function blanket() {
        return 500;
    },
    modal: function modal() {
        return 510;
    },
    flag: function flag() {
        return 600;
    },
    spotlight: function spotlight() {
        return 700;
    },
    tooltip: function tooltip() {
        return 9999;
    }
};
var $8ef391b681ac140e$export$a1b3edb637fb4f35 = function visuallyHidden() {
    (0, $e2xkU.default)("@atlaskit/theme", "visually hidden mixin", "Please use `@atlaskit/visually-hidden` instead.");
    return {
        border: "0 !important",
        clip: "rect(1px, 1px, 1px, 1px) !important",
        height: "1px !important",
        overflow: "hidden !important",
        padding: "0 !important",
        position: "absolute !important",
        width: "1px !important",
        whiteSpace: "nowrap !important"
    };
};
var $8ef391b681ac140e$export$ba1d834b86d72a09 = $8ef391b681ac140e$export$a1b3edb637fb4f35;
var $8ef391b681ac140e$export$e497e856b4f89fcd = function skeletonShimmer() {
    return {
        css: {
            backgroundColor: "var(--ds-skeleton, ".concat((0, $hPTIV.skeleton)(), ")"),
            animationDuration: "1.5s",
            animationIterationCount: "infinite",
            animationTimingFunction: "linear",
            animationDirection: "alternate"
        },
        keyframes: {
            from: {
                backgroundColor: "var(--ds-skeleton, ".concat((0, $hPTIV.skeleton)(), ")")
            },
            to: {
                backgroundColor: "var(--ds-skeleton-subtle, ".concat((0, $hPTIV.N30A), ")")
            }
        }
    };
};

});







parcelRegister("hxi5h", function(module, exports) {

$parcel$export(module.exports, "SettingsDescription", function () { return $b789902ae08b8587$export$79fae77cf5247d65; });
$parcel$export(module.exports, "LoadingState", function () { return $b789902ae08b8587$export$62aa48085237e36f; });
$parcel$export(module.exports, "SettingsSection", function () { return $b789902ae08b8587$export$d239b03507a9e5cc; });
$parcel$export(module.exports, "SectionMessageWrapper", function () { return $b789902ae08b8587$export$c5e20d5e200edfe2; });

var $ku6eE = parcelRequire("ku6eE");

var $9HXRO = parcelRequire("9HXRO");
const $b789902ae08b8587$export$79fae77cf5247d65 = (0, $ku6eE.default).div`
  h3 {
    ${(0, $9HXRO).h500};
  }

  p {
    margin: 12px 0;
  }
`;
const $b789902ae08b8587$export$62aa48085237e36f = (0, $ku6eE.default).div`
  width: 100%;
  height: 256px;
  display: flex;
  align-items: center;
  justify-content: center;
`;
const $b789902ae08b8587$export$d239b03507a9e5cc = (0, $ku6eE.default).div`
  position: relative;

  &:not(:last-child) {
    margin-bottom: 24px;
  }
`;
const $b789902ae08b8587$export$c5e20d5e200edfe2 = (0, $ku6eE.default).div`
  margin: 1em 0;
`;

});
parcelRegister("9HXRO", function(module, exports) {

$parcel$export(module.exports, "fontFallback", function () { return $71169183d35ed802$export$2a99220fb32ec798; });
$parcel$export(module.exports, "headingSizes", function () { return $71169183d35ed802$export$bc02e067df412c3b; });
$parcel$export(module.exports, "h900", function () { return $71169183d35ed802$export$bdb8f897727a9c67; });
$parcel$export(module.exports, "h800", function () { return $71169183d35ed802$export$3953fb6fbd158d23; });
$parcel$export(module.exports, "h700", function () { return $71169183d35ed802$export$e4f993a313607daa; });
$parcel$export(module.exports, "h600", function () { return $71169183d35ed802$export$1e8b2acea3fb3119; });
$parcel$export(module.exports, "h500", function () { return $71169183d35ed802$export$85aa43a9b9f06707; });
$parcel$export(module.exports, "h400", function () { return $71169183d35ed802$export$fcb7764b80bd908f; });
$parcel$export(module.exports, "h300", function () { return $71169183d35ed802$export$a0e59c3bbc05e815; });
$parcel$export(module.exports, "h200", function () { return $71169183d35ed802$export$7ccf32eb2150ac7e; });
$parcel$export(module.exports, "h100", function () { return $71169183d35ed802$export$dfc0e69214efdc3c; });

var $acf0f = parcelRequire("acf0f");

var $5MUVm = parcelRequire("5MUVm");

var $6W4m7 = parcelRequire("6W4m7");
function $71169183d35ed802$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $71169183d35ed802$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $71169183d35ed802$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($acf0f)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $71169183d35ed802$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $71169183d35ed802$export$2a99220fb32ec798 = {
    heading: {
        xxlarge: 'normal 500 35px/40px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
        xlarge: 'normal 600 29px/32px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
        large: 'normal 500 24px/28px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
        medium: 'normal 500 20px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
        small: 'normal 600 16px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
        xsmall: 'normal 600 14px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
        xxsmall: 'normal 600 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif'
    },
    body: {
        large: 'normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
        medium: 'normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
        UNSAFE_small: 'normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
        small: 'normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif'
    }
};
var $71169183d35ed802$var$baseHeading = function baseHeading(size, lineHeight) {
    return {
        fontSize: "".concat(size / (0, $6W4m7.fontSize)(), "em"),
        fontStyle: "inherit",
        lineHeight: lineHeight / size
    };
};
var $71169183d35ed802$export$bc02e067df412c3b = {
    h900: {
        size: 35,
        lineHeight: 40
    },
    h800: {
        size: 29,
        lineHeight: 32
    },
    h700: {
        size: 24,
        lineHeight: 28
    },
    h600: {
        size: 20,
        lineHeight: 24
    },
    h500: {
        size: 16,
        lineHeight: 20
    },
    h400: {
        size: 14,
        lineHeight: 16
    },
    h300: {
        size: 12,
        lineHeight: 16
    },
    h200: {
        size: 12,
        lineHeight: 16
    },
    h100: {
        size: 11,
        lineHeight: 16
    }
};
var $71169183d35ed802$export$bdb8f897727a9c67 = function h900() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return $71169183d35ed802$var$_objectSpread($71169183d35ed802$var$_objectSpread({}, $71169183d35ed802$var$baseHeading($71169183d35ed802$export$bc02e067df412c3b.h900.size, $71169183d35ed802$export$bc02e067df412c3b.h900.lineHeight)), {}, {
        color: "var(--ds-text, ".concat((0, $5MUVm.heading)(props), ")"),
        fontWeight: "var(--ds-font-weight-medium, 500)",
        letterSpacing: "-0.01em",
        marginTop: "".concat((0, $6W4m7.gridSize)() * 6.5, "px")
    });
};
var $71169183d35ed802$export$3953fb6fbd158d23 = function h800() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return $71169183d35ed802$var$_objectSpread($71169183d35ed802$var$_objectSpread({}, $71169183d35ed802$var$baseHeading($71169183d35ed802$export$bc02e067df412c3b.h800.size, $71169183d35ed802$export$bc02e067df412c3b.h800.lineHeight)), {}, {
        color: "var(--ds-text, ".concat((0, $5MUVm.heading)(props), ")"),
        fontWeight: "var(--ds-font-weight-semibold, 600)",
        letterSpacing: "-0.01em",
        marginTop: "".concat((0, $6W4m7.gridSize)() * 5, "px")
    });
};
var $71169183d35ed802$export$e4f993a313607daa = function h700() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return $71169183d35ed802$var$_objectSpread($71169183d35ed802$var$_objectSpread({}, $71169183d35ed802$var$baseHeading($71169183d35ed802$export$bc02e067df412c3b.h700.size, $71169183d35ed802$export$bc02e067df412c3b.h700.lineHeight)), {}, {
        color: "var(--ds-text, ".concat((0, $5MUVm.heading)(props), ")"),
        fontWeight: "var(--ds-font-weight-medium, 500)",
        letterSpacing: "-0.01em",
        marginTop: "".concat((0, $6W4m7.gridSize)() * 5, "px")
    });
};
var $71169183d35ed802$export$1e8b2acea3fb3119 = function h600() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return $71169183d35ed802$var$_objectSpread($71169183d35ed802$var$_objectSpread({}, $71169183d35ed802$var$baseHeading($71169183d35ed802$export$bc02e067df412c3b.h600.size, $71169183d35ed802$export$bc02e067df412c3b.h600.lineHeight)), {}, {
        color: "var(--ds-text, ".concat((0, $5MUVm.heading)(props), ")"),
        fontWeight: "var(--ds-font-weight-medium, 500)",
        letterSpacing: "-0.008em",
        marginTop: "".concat((0, $6W4m7.gridSize)() * 3.5, "px")
    });
};
var $71169183d35ed802$export$85aa43a9b9f06707 = function h500() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return $71169183d35ed802$var$_objectSpread($71169183d35ed802$var$_objectSpread({}, $71169183d35ed802$var$baseHeading($71169183d35ed802$export$bc02e067df412c3b.h500.size, $71169183d35ed802$export$bc02e067df412c3b.h500.lineHeight)), {}, {
        color: "var(--ds-text, ".concat((0, $5MUVm.heading)(props), ")"),
        fontWeight: "var(--ds-font-weight-semibold, 600)",
        letterSpacing: "-0.006em",
        marginTop: "".concat((0, $6W4m7.gridSize)() * 3, "px")
    });
};
var $71169183d35ed802$export$fcb7764b80bd908f = function h400() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return $71169183d35ed802$var$_objectSpread($71169183d35ed802$var$_objectSpread({}, $71169183d35ed802$var$baseHeading($71169183d35ed802$export$bc02e067df412c3b.h400.size, $71169183d35ed802$export$bc02e067df412c3b.h400.lineHeight)), {}, {
        color: "var(--ds-text, ".concat((0, $5MUVm.heading)(props), ")"),
        fontWeight: "var(--ds-font-weight-semibold, 600)",
        letterSpacing: "-0.003em",
        marginTop: "".concat((0, $6W4m7.gridSize)() * 2, "px")
    });
};
var $71169183d35ed802$export$a0e59c3bbc05e815 = function h300() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return $71169183d35ed802$var$_objectSpread($71169183d35ed802$var$_objectSpread({}, $71169183d35ed802$var$baseHeading($71169183d35ed802$export$bc02e067df412c3b.h300.size, $71169183d35ed802$export$bc02e067df412c3b.h300.lineHeight)), {}, {
        color: "var(--ds-text, ".concat((0, $5MUVm.heading)(props), ")"),
        fontWeight: "var(--ds-font-weight-semibold, 600)",
        marginTop: "".concat((0, $6W4m7.gridSize)() * 2.5, "px"),
        textTransform: "uppercase"
    });
};
var $71169183d35ed802$export$7ccf32eb2150ac7e = function h200() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return $71169183d35ed802$var$_objectSpread($71169183d35ed802$var$_objectSpread({}, $71169183d35ed802$var$baseHeading($71169183d35ed802$export$bc02e067df412c3b.h200.size, $71169183d35ed802$export$bc02e067df412c3b.h200.lineHeight)), {}, {
        color: "var(--ds-text-subtlest, ".concat((0, $5MUVm.subtleHeading)(props), ")"),
        fontWeight: "var(--ds-font-weight-semibold, 600)",
        marginTop: "".concat((0, $6W4m7.gridSize)() * 2, "px")
    });
};
var $71169183d35ed802$export$dfc0e69214efdc3c = function h100() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return $71169183d35ed802$var$_objectSpread($71169183d35ed802$var$_objectSpread({}, $71169183d35ed802$var$baseHeading($71169183d35ed802$export$bc02e067df412c3b.h100.size, $71169183d35ed802$export$bc02e067df412c3b.h100.lineHeight)), {}, {
        color: "var(--ds-text-subtlest, ".concat((0, $5MUVm.subtleHeading)(props), ")"),
        fontWeight: "var(--ds-font-weight-bold, 700)",
        marginTop: "".concat((0, $6W4m7.gridSize)() * 2, "px")
    });
};

});
parcelRegister("acf0f", function(module, exports) {

var $eyGv6 = parcelRequire("eyGv6");
function $76c6a9a6cf29842d$var$_defineProperty(e, r, t) {
    return (r = $eyGv6(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
module.exports = $76c6a9a6cf29842d$var$_defineProperty, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("eyGv6", function(module, exports) {

var $gkdRW = parcelRequire("gkdRW");
var $a995356df2f29541$var$_typeof = $gkdRW.default;

var $lVFV8 = parcelRequire("lVFV8");
function $a995356df2f29541$var$toPropertyKey(t) {
    var i = $lVFV8(t, "string");
    return "symbol" == $a995356df2f29541$var$_typeof(i) ? i : i + "";
}
module.exports = $a995356df2f29541$var$toPropertyKey, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("gkdRW", function(module, exports) {
function $be2945ace6a3f40f$var$_typeof(o) {
    "@babel/helpers - typeof";
    return module.exports = $be2945ace6a3f40f$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $be2945ace6a3f40f$var$_typeof(o);
}
module.exports = $be2945ace6a3f40f$var$_typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("lVFV8", function(module, exports) {

var $gkdRW = parcelRequire("gkdRW");
var $ff6f7069a33f7878$var$_typeof = $gkdRW.default;
function $ff6f7069a33f7878$var$toPrimitive(t, r) {
    if ("object" != $ff6f7069a33f7878$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $ff6f7069a33f7878$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
module.exports = $ff6f7069a33f7878$var$toPrimitive, module.exports.__esModule = true, module.exports["default"] = module.exports;

});





parcelRegister("2QbFH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $21197dd05921a40b$export$2e2bcd8739ae039; });

var $edawc = parcelRequire("edawc");

var $ae7Ah = parcelRequire("ae7Ah");
var $1yqRj = parcelRequire("1yqRj");
var $8n0Fr = parcelRequire("8n0Fr");

var $2hDPH = parcelRequire("2hDPH");
var $21197dd05921a40b$var$packageName = "@atlaskit/select";
var $21197dd05921a40b$var$packageVersion = "17.10.3";
var $21197dd05921a40b$export$d1de3b251ccaa8a3 = (0, $2hDPH.default)((0, $edawc.default));
var $21197dd05921a40b$var$createAndFireEventOnAtlaskit = (0, $ae7Ah.default)("atlaskit");
var $21197dd05921a40b$var$Select = (0, $1yqRj.default)({
    componentName: "select",
    packageName: $21197dd05921a40b$var$packageName,
    packageVersion: $21197dd05921a40b$var$packageVersion
})((0, $8n0Fr.default)({
    onChange: $21197dd05921a40b$var$createAndFireEventOnAtlaskit({
        action: "changed",
        actionSubject: "option",
        attributes: {
            componentName: "select",
            packageName: $21197dd05921a40b$var$packageName,
            packageVersion: $21197dd05921a40b$var$packageVersion
        }
    })
})($21197dd05921a40b$export$d1de3b251ccaa8a3));
var $21197dd05921a40b$export$2e2bcd8739ae039 = $21197dd05921a40b$var$Select;

});
parcelRegister("edawc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a58a704e4abfc935$export$2e2bcd8739ae039; });

var $4qK4E = parcelRequire("4qK4E");

var $i6L24 = parcelRequire("i6L24");

var $dAx5m = parcelRequire("dAx5m");

var $6wOet = parcelRequire("6wOet");

var $2wjNk = parcelRequire("2wjNk");

var $3Wdxg = parcelRequire("3Wdxg");

var $fc2pq = parcelRequire("fc2pq");
parcelRequire("9Zr3u");
parcelRequire("cK17F");
parcelRequire("7RQoD");
parcelRequire("9B1JN");
parcelRequire("fHWei");
parcelRequire("gRE01");
parcelRequire("4Szvh");
parcelRequire("iLhwL");

parcelRequire("kTnsx");
parcelRequire("agZsZ");
parcelRequire("hkD8d");
parcelRequire("1MpXQ");

parcelRequire("3k7Ry");
var $a58a704e4abfc935$var$StateManagedSelect = /*#__PURE__*/ (0, $dAx5m.forwardRef)(function(props, ref) {
    var baseSelectProps = (0, $4qK4E.u)(props);
    return /*#__PURE__*/ $dAx5m.createElement((0, $6wOet.S), (0, $i6L24.default)({
        ref: ref
    }, baseSelectProps));
});
var $a58a704e4abfc935$export$2e2bcd8739ae039 = $a58a704e4abfc935$var$StateManagedSelect;
var $a58a704e4abfc935$export$a7deb1594c5ce10e = function(_ref) {
    var nonce = _ref.nonce, children = _ref.children, cacheKey = _ref.cacheKey;
    var emotionCache = (0, $dAx5m.useMemo)(function() {
        return (0, $3Wdxg.default)({
            key: cacheKey,
            nonce: nonce
        });
    }, [
        cacheKey,
        nonce
    ]);
    return /*#__PURE__*/ $dAx5m.createElement((0, $2wjNk.C), {
        value: emotionCache
    }, children);
};

});
parcelRegister("4qK4E", function(module, exports) {

$parcel$export(module.exports, "u", function () { return $339d5479d9bcd46d$export$3b14a55fb2447963; });

var $lWmb7 = parcelRequire("lWmb7");

var $8Y5h3 = parcelRequire("8Y5h3");

var $3ci4f = parcelRequire("3ci4f");

var $dAx5m = parcelRequire("dAx5m");
var $339d5479d9bcd46d$var$_excluded = [
    "defaultInputValue",
    "defaultMenuIsOpen",
    "defaultValue",
    "inputValue",
    "menuIsOpen",
    "onChange",
    "onInputChange",
    "onMenuClose",
    "onMenuOpen",
    "value"
];
function $339d5479d9bcd46d$export$3b14a55fb2447963(_ref) {
    var _ref$defaultInputValu = _ref.defaultInputValue, defaultInputValue = _ref$defaultInputValu === void 0 ? "" : _ref$defaultInputValu, _ref$defaultMenuIsOpe = _ref.defaultMenuIsOpen, defaultMenuIsOpen = _ref$defaultMenuIsOpe === void 0 ? false : _ref$defaultMenuIsOpe, _ref$defaultValue = _ref.defaultValue, defaultValue = _ref$defaultValue === void 0 ? null : _ref$defaultValue, propsInputValue = _ref.inputValue, propsMenuIsOpen = _ref.menuIsOpen, propsOnChange = _ref.onChange, propsOnInputChange = _ref.onInputChange, propsOnMenuClose = _ref.onMenuClose, propsOnMenuOpen = _ref.onMenuOpen, propsValue = _ref.value, restSelectProps = (0, $3ci4f.default)(_ref, $339d5479d9bcd46d$var$_excluded);
    var _useState = (0, $dAx5m.useState)(propsInputValue !== undefined ? propsInputValue : defaultInputValue), _useState2 = (0, $8Y5h3.default)(_useState, 2), stateInputValue = _useState2[0], setStateInputValue = _useState2[1];
    var _useState3 = (0, $dAx5m.useState)(propsMenuIsOpen !== undefined ? propsMenuIsOpen : defaultMenuIsOpen), _useState4 = (0, $8Y5h3.default)(_useState3, 2), stateMenuIsOpen = _useState4[0], setStateMenuIsOpen = _useState4[1];
    var _useState5 = (0, $dAx5m.useState)(propsValue !== undefined ? propsValue : defaultValue), _useState6 = (0, $8Y5h3.default)(_useState5, 2), stateValue = _useState6[0], setStateValue = _useState6[1];
    var onChange = (0, $dAx5m.useCallback)(function(value, actionMeta) {
        if (typeof propsOnChange === "function") propsOnChange(value, actionMeta);
        setStateValue(value);
    }, [
        propsOnChange
    ]);
    var onInputChange = (0, $dAx5m.useCallback)(function(value, actionMeta) {
        var newValue;
        if (typeof propsOnInputChange === "function") newValue = propsOnInputChange(value, actionMeta);
        setStateInputValue(newValue !== undefined ? newValue : value);
    }, [
        propsOnInputChange
    ]);
    var onMenuOpen = (0, $dAx5m.useCallback)(function() {
        if (typeof propsOnMenuOpen === "function") propsOnMenuOpen();
        setStateMenuIsOpen(true);
    }, [
        propsOnMenuOpen
    ]);
    var onMenuClose = (0, $dAx5m.useCallback)(function() {
        if (typeof propsOnMenuClose === "function") propsOnMenuClose();
        setStateMenuIsOpen(false);
    }, [
        propsOnMenuClose
    ]);
    var inputValue = propsInputValue !== undefined ? propsInputValue : stateInputValue;
    var menuIsOpen = propsMenuIsOpen !== undefined ? propsMenuIsOpen : stateMenuIsOpen;
    var value = propsValue !== undefined ? propsValue : stateValue;
    return (0, $lWmb7.default)((0, $lWmb7.default)({}, restSelectProps), {}, {
        inputValue: inputValue,
        menuIsOpen: menuIsOpen,
        onChange: onChange,
        onInputChange: onInputChange,
        onMenuClose: onMenuClose,
        onMenuOpen: onMenuOpen,
        value: value
    });
}

});
parcelRegister("lWmb7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ff9037e41f5decb2$export$2e2bcd8739ae039; });

var $fZJbz = parcelRequire("fZJbz");
function $ff9037e41f5decb2$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $ff9037e41f5decb2$export$2e2bcd8739ae039(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $ff9037e41f5decb2$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $fZJbz.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $ff9037e41f5decb2$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}

});
parcelRegister("fZJbz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ba4f9a76bd59516d$export$2e2bcd8739ae039; });

var $3ZtVs = parcelRequire("3ZtVs");
function $ba4f9a76bd59516d$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $3ZtVs.default)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}

});
parcelRegister("3ZtVs", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2e7e483e9e02c8b5$export$2e2bcd8739ae039; });

var $9f2pJ = parcelRequire("9f2pJ");

var $3lGtX = parcelRequire("3lGtX");
function $2e7e483e9e02c8b5$export$2e2bcd8739ae039(t) {
    var i = (0, $3lGtX.default)(t, "string");
    return "symbol" == (0, $9f2pJ.default)(i) ? i : i + "";
}

});
parcelRegister("9f2pJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6ba763227f98d27a$export$2e2bcd8739ae039; });
function $6ba763227f98d27a$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $6ba763227f98d27a$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $6ba763227f98d27a$export$2e2bcd8739ae039(o);
}

});

parcelRegister("3lGtX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2704495d224bdeae$export$2e2bcd8739ae039; });

var $9f2pJ = parcelRequire("9f2pJ");
function $2704495d224bdeae$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $9f2pJ.default)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $9f2pJ.default)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}

});




parcelRegister("8Y5h3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $687804a69f4a305b$export$2e2bcd8739ae039; });

var $avNl2 = parcelRequire("avNl2");

var $4JVEW = parcelRequire("4JVEW");

var $bxBqk = parcelRequire("bxBqk");

var $2TCea = parcelRequire("2TCea");
function $687804a69f4a305b$export$2e2bcd8739ae039(r, e) {
    return (0, $avNl2.default)(r) || (0, $4JVEW.default)(r, e) || (0, $bxBqk.default)(r, e) || (0, $2TCea.default)();
}

});
parcelRegister("avNl2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7a73123902b8d049$export$2e2bcd8739ae039; });
function $7a73123902b8d049$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return r;
}

});

parcelRegister("4JVEW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $37381759732a2c15$export$2e2bcd8739ae039; });
function $37381759732a2c15$export$2e2bcd8739ae039(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}

});

parcelRegister("bxBqk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $866fce58692abe03$export$2e2bcd8739ae039; });

var $iK4tD = parcelRequire("iK4tD");
function $866fce58692abe03$export$2e2bcd8739ae039(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, $iK4tD.default)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, $iK4tD.default)(r, a) : void 0;
    }
}

});
parcelRegister("iK4tD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $da4ffee6c26e8556$export$2e2bcd8739ae039; });
function $da4ffee6c26e8556$export$2e2bcd8739ae039(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}

});


parcelRegister("2TCea", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $21be5f003761943e$export$2e2bcd8739ae039; });
function $21be5f003761943e$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("3ci4f", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $254081e932a2d415$export$2e2bcd8739ae039; });

var $5WzaO = parcelRequire("5WzaO");
function $254081e932a2d415$export$2e2bcd8739ae039(e, t) {
    if (null == e) return {};
    var o, r, i = (0, $5WzaO.default)(e, t);
    if (Object.getOwnPropertySymbols) {
        var s = Object.getOwnPropertySymbols(e);
        for(r = 0; r < s.length; r++)o = s[r], t.includes(o) || ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}

});
parcelRegister("5WzaO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $453da741bebe4418$export$2e2bcd8739ae039; });
function $453da741bebe4418$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.includes(n)) continue;
        t[n] = r[n];
    }
    return t;
}

});



parcelRegister("i6L24", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d2ed4532a0b50570$export$2e2bcd8739ae039; });
function $d2ed4532a0b50570$export$2e2bcd8739ae039() {
    return $d2ed4532a0b50570$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $d2ed4532a0b50570$export$2e2bcd8739ae039.apply(null, arguments);
}

});

parcelRegister("6wOet", function(module, exports) {

$parcel$export(module.exports, "m", function () { return $4c0cb255ecf8b430$export$953cecd6e717a553; });
$parcel$export(module.exports, "S", function () { return $4c0cb255ecf8b430$export$25ce5a424b770e84; });

var $i6L24 = parcelRequire("i6L24");

var $lWmb7 = parcelRequire("lWmb7");

var $3Ez4j = parcelRequire("3Ez4j");

var $5JW2y = parcelRequire("5JW2y");

var $bTgpJ = parcelRequire("bTgpJ");

var $KsTfi = parcelRequire("KsTfi");

var $jPOzM = parcelRequire("jPOzM");

var $dAx5m = parcelRequire("dAx5m");

var $fc2pq = parcelRequire("fc2pq");

var $jVTBW = parcelRequire("jVTBW");

var $dHPoE = parcelRequire("dHPoE");

var $3ci4f = parcelRequire("3ci4f");
function $4c0cb255ecf8b430$var$_EMOTION_STRINGIFIED_CSS_ERROR__$2() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// Assistive text to describe visual elements. Hidden for sighted users.
var $4c0cb255ecf8b430$var$_ref = {
    name: "7pg0cj-a11yText",
    styles: "label:a11yText;z-index:9999;border:0;clip:rect(1px, 1px, 1px, 1px);height:1px;width:1px;position:absolute;overflow:hidden;padding:0;white-space:nowrap"
};
var $4c0cb255ecf8b430$var$A11yText = function A11yText(props) {
    return (0, $jVTBW.jsx)("span", (0, $i6L24.default)({
        css: $4c0cb255ecf8b430$var$_ref
    }, props));
};
var $4c0cb255ecf8b430$var$A11yText$1 = $4c0cb255ecf8b430$var$A11yText;
var $4c0cb255ecf8b430$var$defaultAriaLiveMessages = {
    guidance: function guidance(props) {
        var isSearchable = props.isSearchable, isMulti = props.isMulti, tabSelectsValue = props.tabSelectsValue, context = props.context, isInitialFocus = props.isInitialFocus;
        switch(context){
            case "menu":
                return "Use Up and Down to choose options, press Enter to select the currently focused option, press Escape to exit the menu".concat(tabSelectsValue ? ", press Tab to select the option and exit the menu" : "", ".");
            case "input":
                return isInitialFocus ? "".concat(props["aria-label"] || "Select", " is focused ").concat(isSearchable ? ",type to refine list" : "", ", press Down to open the menu, ").concat(isMulti ? " press left to focus selected values" : "") : "";
            case "value":
                return "Use left and right to toggle between focused values, press Backspace to remove the currently focused value";
            default:
                return "";
        }
    },
    onChange: function onChange(props) {
        var action = props.action, _props$label = props.label, label = _props$label === void 0 ? "" : _props$label, labels = props.labels, isDisabled = props.isDisabled;
        switch(action){
            case "deselect-option":
            case "pop-value":
            case "remove-value":
                return "option ".concat(label, ", deselected.");
            case "clear":
                return "All selected options have been cleared.";
            case "initial-input-focus":
                return "option".concat(labels.length > 1 ? "s" : "", " ").concat(labels.join(","), ", selected.");
            case "select-option":
                return isDisabled ? "option ".concat(label, " is disabled. Select another option.") : "option ".concat(label, ", selected.");
            default:
                return "";
        }
    },
    onFocus: function onFocus(props) {
        var context = props.context, focused = props.focused, options = props.options, _props$label2 = props.label, label = _props$label2 === void 0 ? "" : _props$label2, selectValue = props.selectValue, isDisabled = props.isDisabled, isSelected = props.isSelected, isAppleDevice = props.isAppleDevice;
        var getArrayIndex = function getArrayIndex(arr, item) {
            return arr && arr.length ? "".concat(arr.indexOf(item) + 1, " of ").concat(arr.length) : "";
        };
        if (context === "value" && selectValue) return "value ".concat(label, " focused, ").concat(getArrayIndex(selectValue, focused), ".");
        if (context === "menu" && isAppleDevice) {
            var disabled = isDisabled ? " disabled" : "";
            var status = "".concat(isSelected ? " selected" : "").concat(disabled);
            return "".concat(label).concat(status, ", ").concat(getArrayIndex(options, focused), ".");
        }
        return "";
    },
    onFilter: function onFilter(props) {
        var inputValue = props.inputValue, resultsMessage = props.resultsMessage;
        return "".concat(resultsMessage).concat(inputValue ? " for search term " + inputValue : "", ".");
    }
};
var $4c0cb255ecf8b430$var$LiveRegion = function LiveRegion(props) {
    var ariaSelection = props.ariaSelection, focusedOption = props.focusedOption, focusedValue = props.focusedValue, focusableOptions = props.focusableOptions, isFocused = props.isFocused, selectValue = props.selectValue, selectProps = props.selectProps, id = props.id, isAppleDevice = props.isAppleDevice;
    var ariaLiveMessages = selectProps.ariaLiveMessages, getOptionLabel = selectProps.getOptionLabel, inputValue = selectProps.inputValue, isMulti = selectProps.isMulti, isOptionDisabled = selectProps.isOptionDisabled, isSearchable = selectProps.isSearchable, menuIsOpen = selectProps.menuIsOpen, options = selectProps.options, screenReaderStatus = selectProps.screenReaderStatus, tabSelectsValue = selectProps.tabSelectsValue, isLoading = selectProps.isLoading;
    var ariaLabel = selectProps["aria-label"];
    var ariaLive = selectProps["aria-live"];
    // Update aria live message configuration when prop changes
    var messages = (0, $dAx5m.useMemo)(function() {
        return (0, $lWmb7.default)((0, $lWmb7.default)({}, $4c0cb255ecf8b430$var$defaultAriaLiveMessages), ariaLiveMessages || {});
    }, [
        ariaLiveMessages
    ]);
    // Update aria live selected option when prop changes
    var ariaSelected = (0, $dAx5m.useMemo)(function() {
        var message = "";
        if (ariaSelection && messages.onChange) {
            var option = ariaSelection.option, selectedOptions = ariaSelection.options, removedValue = ariaSelection.removedValue, removedValues = ariaSelection.removedValues, value = ariaSelection.value;
            // select-option when !isMulti does not return option so we assume selected option is value
            var asOption = function asOption(val) {
                return !Array.isArray(val) ? val : null;
            };
            // If there is just one item from the action then get its label
            var selected = removedValue || option || asOption(value);
            var label = selected ? getOptionLabel(selected) : "";
            // If there are multiple items from the action then return an array of labels
            var multiSelected = selectedOptions || removedValues || undefined;
            var labels = multiSelected ? multiSelected.map(getOptionLabel) : [];
            var onChangeProps = (0, $lWmb7.default)({
                // multiSelected items are usually items that have already been selected
                // or set by the user as a default value so we assume they are not disabled
                isDisabled: selected && isOptionDisabled(selected, selectValue),
                label: label,
                labels: labels
            }, ariaSelection);
            message = messages.onChange(onChangeProps);
        }
        return message;
    }, [
        ariaSelection,
        messages,
        isOptionDisabled,
        selectValue,
        getOptionLabel
    ]);
    var ariaFocused = (0, $dAx5m.useMemo)(function() {
        var focusMsg = "";
        var focused = focusedOption || focusedValue;
        var isSelected = !!(focusedOption && selectValue && selectValue.includes(focusedOption));
        if (focused && messages.onFocus) {
            var onFocusProps = {
                focused: focused,
                label: getOptionLabel(focused),
                isDisabled: isOptionDisabled(focused, selectValue),
                isSelected: isSelected,
                options: focusableOptions,
                context: focused === focusedOption ? "menu" : "value",
                selectValue: selectValue,
                isAppleDevice: isAppleDevice
            };
            focusMsg = messages.onFocus(onFocusProps);
        }
        return focusMsg;
    }, [
        focusedOption,
        focusedValue,
        getOptionLabel,
        isOptionDisabled,
        messages,
        focusableOptions,
        selectValue,
        isAppleDevice
    ]);
    var ariaResults = (0, $dAx5m.useMemo)(function() {
        var resultsMsg = "";
        if (menuIsOpen && options.length && !isLoading && messages.onFilter) {
            var resultsMessage = screenReaderStatus({
                count: focusableOptions.length
            });
            resultsMsg = messages.onFilter({
                inputValue: inputValue,
                resultsMessage: resultsMessage
            });
        }
        return resultsMsg;
    }, [
        focusableOptions,
        inputValue,
        menuIsOpen,
        messages,
        options,
        screenReaderStatus,
        isLoading
    ]);
    var isInitialFocus = (ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === "initial-input-focus";
    var ariaGuidance = (0, $dAx5m.useMemo)(function() {
        var guidanceMsg = "";
        if (messages.guidance) {
            var context = focusedValue ? "value" : menuIsOpen ? "menu" : "input";
            guidanceMsg = messages.guidance({
                "aria-label": ariaLabel,
                context: context,
                isDisabled: focusedOption && isOptionDisabled(focusedOption, selectValue),
                isMulti: isMulti,
                isSearchable: isSearchable,
                tabSelectsValue: tabSelectsValue,
                isInitialFocus: isInitialFocus
            });
        }
        return guidanceMsg;
    }, [
        ariaLabel,
        focusedOption,
        focusedValue,
        isMulti,
        isOptionDisabled,
        isSearchable,
        menuIsOpen,
        messages,
        selectValue,
        tabSelectsValue,
        isInitialFocus
    ]);
    var ScreenReaderText = (0, $jVTBW.jsx)((0, $dAx5m.Fragment), null, (0, $jVTBW.jsx)("span", {
        id: "aria-selection"
    }, ariaSelected), (0, $jVTBW.jsx)("span", {
        id: "aria-focused"
    }, ariaFocused), (0, $jVTBW.jsx)("span", {
        id: "aria-results"
    }, ariaResults), (0, $jVTBW.jsx)("span", {
        id: "aria-guidance"
    }, ariaGuidance));
    return (0, $jVTBW.jsx)((0, $dAx5m.Fragment), null, (0, $jVTBW.jsx)($4c0cb255ecf8b430$var$A11yText$1, {
        id: id
    }, isInitialFocus && ScreenReaderText), (0, $jVTBW.jsx)($4c0cb255ecf8b430$var$A11yText$1, {
        "aria-live": ariaLive,
        "aria-atomic": "false",
        "aria-relevant": "additions text",
        role: "log"
    }, isFocused && !isInitialFocus && ScreenReaderText));
};
var $4c0cb255ecf8b430$var$LiveRegion$1 = $4c0cb255ecf8b430$var$LiveRegion;
var $4c0cb255ecf8b430$var$diacritics = [
    {
        base: "A",
        letters: "A\u24B6\uFF21\xc0\xc1\xc2\u1EA6\u1EA4\u1EAA\u1EA8\xc3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\xc4\u01DE\u1EA2\xc5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F"
    },
    {
        base: "AA",
        letters: "\uA732"
    },
    {
        base: "AE",
        letters: "\xc6\u01FC\u01E2"
    },
    {
        base: "AO",
        letters: "\uA734"
    },
    {
        base: "AU",
        letters: "\uA736"
    },
    {
        base: "AV",
        letters: "\uA738\uA73A"
    },
    {
        base: "AY",
        letters: "\uA73C"
    },
    {
        base: "B",
        letters: "B\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181"
    },
    {
        base: "C",
        letters: "C\u24B8\uFF23\u0106\u0108\u010A\u010C\xc7\u1E08\u0187\u023B\uA73E"
    },
    {
        base: "D",
        letters: "D\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779"
    },
    {
        base: "DZ",
        letters: "\u01F1\u01C4"
    },
    {
        base: "Dz",
        letters: "\u01F2\u01C5"
    },
    {
        base: "E",
        letters: "E\u24BA\uFF25\xc8\xc9\xca\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\xcb\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E"
    },
    {
        base: "F",
        letters: "F\u24BB\uFF26\u1E1E\u0191\uA77B"
    },
    {
        base: "G",
        letters: "G\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E"
    },
    {
        base: "H",
        letters: "H\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D"
    },
    {
        base: "I",
        letters: "I\u24BE\uFF29\xcc\xcd\xce\u0128\u012A\u012C\u0130\xcf\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197"
    },
    {
        base: "J",
        letters: "J\u24BF\uFF2A\u0134\u0248"
    },
    {
        base: "K",
        letters: "K\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2"
    },
    {
        base: "L",
        letters: "L\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780"
    },
    {
        base: "LJ",
        letters: "\u01C7"
    },
    {
        base: "Lj",
        letters: "\u01C8"
    },
    {
        base: "M",
        letters: "M\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C"
    },
    {
        base: "N",
        letters: "N\u24C3\uFF2E\u01F8\u0143\xd1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4"
    },
    {
        base: "NJ",
        letters: "\u01CA"
    },
    {
        base: "Nj",
        letters: "\u01CB"
    },
    {
        base: "O",
        letters: "O\u24C4\uFF2F\xd2\xd3\xd4\u1ED2\u1ED0\u1ED6\u1ED4\xd5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\xd6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\xd8\u01FE\u0186\u019F\uA74A\uA74C"
    },
    {
        base: "OI",
        letters: "\u01A2"
    },
    {
        base: "OO",
        letters: "\uA74E"
    },
    {
        base: "OU",
        letters: "\u0222"
    },
    {
        base: "P",
        letters: "P\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754"
    },
    {
        base: "Q",
        letters: "Q\u24C6\uFF31\uA756\uA758\u024A"
    },
    {
        base: "R",
        letters: "R\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782"
    },
    {
        base: "S",
        letters: "S\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784"
    },
    {
        base: "T",
        letters: "T\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786"
    },
    {
        base: "TZ",
        letters: "\uA728"
    },
    {
        base: "U",
        letters: "U\u24CA\uFF35\xd9\xda\xdb\u0168\u1E78\u016A\u1E7A\u016C\xdc\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244"
    },
    {
        base: "V",
        letters: "V\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245"
    },
    {
        base: "VY",
        letters: "\uA760"
    },
    {
        base: "W",
        letters: "W\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72"
    },
    {
        base: "X",
        letters: "X\u24CD\uFF38\u1E8A\u1E8C"
    },
    {
        base: "Y",
        letters: "Y\u24CE\uFF39\u1EF2\xdd\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE"
    },
    {
        base: "Z",
        letters: "Z\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762"
    },
    {
        base: "a",
        letters: "a\u24D0\uFF41\u1E9A\xe0\xe1\xe2\u1EA7\u1EA5\u1EAB\u1EA9\xe3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\xe4\u01DF\u1EA3\xe5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250"
    },
    {
        base: "aa",
        letters: "\uA733"
    },
    {
        base: "ae",
        letters: "\xe6\u01FD\u01E3"
    },
    {
        base: "ao",
        letters: "\uA735"
    },
    {
        base: "au",
        letters: "\uA737"
    },
    {
        base: "av",
        letters: "\uA739\uA73B"
    },
    {
        base: "ay",
        letters: "\uA73D"
    },
    {
        base: "b",
        letters: "b\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253"
    },
    {
        base: "c",
        letters: "c\u24D2\uFF43\u0107\u0109\u010B\u010D\xe7\u1E09\u0188\u023C\uA73F\u2184"
    },
    {
        base: "d",
        letters: "d\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A"
    },
    {
        base: "dz",
        letters: "\u01F3\u01C6"
    },
    {
        base: "e",
        letters: "e\u24D4\uFF45\xe8\xe9\xea\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\xeb\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD"
    },
    {
        base: "f",
        letters: "f\u24D5\uFF46\u1E1F\u0192\uA77C"
    },
    {
        base: "g",
        letters: "g\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F"
    },
    {
        base: "h",
        letters: "h\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265"
    },
    {
        base: "hv",
        letters: "\u0195"
    },
    {
        base: "i",
        letters: "i\u24D8\uFF49\xec\xed\xee\u0129\u012B\u012D\xef\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131"
    },
    {
        base: "j",
        letters: "j\u24D9\uFF4A\u0135\u01F0\u0249"
    },
    {
        base: "k",
        letters: "k\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3"
    },
    {
        base: "l",
        letters: "l\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747"
    },
    {
        base: "lj",
        letters: "\u01C9"
    },
    {
        base: "m",
        letters: "m\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F"
    },
    {
        base: "n",
        letters: "n\u24DD\uFF4E\u01F9\u0144\xf1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5"
    },
    {
        base: "nj",
        letters: "\u01CC"
    },
    {
        base: "o",
        letters: "o\u24DE\uFF4F\xf2\xf3\xf4\u1ED3\u1ED1\u1ED7\u1ED5\xf5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\xf6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\xf8\u01FF\u0254\uA74B\uA74D\u0275"
    },
    {
        base: "oi",
        letters: "\u01A3"
    },
    {
        base: "ou",
        letters: "\u0223"
    },
    {
        base: "oo",
        letters: "\uA74F"
    },
    {
        base: "p",
        letters: "p\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755"
    },
    {
        base: "q",
        letters: "q\u24E0\uFF51\u024B\uA757\uA759"
    },
    {
        base: "r",
        letters: "r\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783"
    },
    {
        base: "s",
        letters: "s\u24E2\uFF53\xdf\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B"
    },
    {
        base: "t",
        letters: "t\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787"
    },
    {
        base: "tz",
        letters: "\uA729"
    },
    {
        base: "u",
        letters: "u\u24E4\uFF55\xf9\xfa\xfb\u0169\u1E79\u016B\u1E7B\u016D\xfc\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289"
    },
    {
        base: "v",
        letters: "v\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C"
    },
    {
        base: "vy",
        letters: "\uA761"
    },
    {
        base: "w",
        letters: "w\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73"
    },
    {
        base: "x",
        letters: "x\u24E7\uFF58\u1E8B\u1E8D"
    },
    {
        base: "y",
        letters: "y\u24E8\uFF59\u1EF3\xfd\u0177\u1EF9\u0233\u1E8F\xff\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF"
    },
    {
        base: "z",
        letters: "z\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763"
    }
];
var $4c0cb255ecf8b430$var$anyDiacritic = new RegExp("[" + $4c0cb255ecf8b430$var$diacritics.map(function(d) {
    return d.letters;
}).join("") + "]", "g");
var $4c0cb255ecf8b430$var$diacriticToBase = {};
for(var $4c0cb255ecf8b430$var$i = 0; $4c0cb255ecf8b430$var$i < $4c0cb255ecf8b430$var$diacritics.length; $4c0cb255ecf8b430$var$i++){
    var $4c0cb255ecf8b430$var$diacritic = $4c0cb255ecf8b430$var$diacritics[$4c0cb255ecf8b430$var$i];
    for(var $4c0cb255ecf8b430$var$j = 0; $4c0cb255ecf8b430$var$j < $4c0cb255ecf8b430$var$diacritic.letters.length; $4c0cb255ecf8b430$var$j++)$4c0cb255ecf8b430$var$diacriticToBase[$4c0cb255ecf8b430$var$diacritic.letters[$4c0cb255ecf8b430$var$j]] = $4c0cb255ecf8b430$var$diacritic.base;
}
var $4c0cb255ecf8b430$var$stripDiacritics = function stripDiacritics(str) {
    return str.replace($4c0cb255ecf8b430$var$anyDiacritic, function(match) {
        return $4c0cb255ecf8b430$var$diacriticToBase[match];
    });
};
var $4c0cb255ecf8b430$var$memoizedStripDiacriticsForInput = (0, $dHPoE.default)($4c0cb255ecf8b430$var$stripDiacritics);
var $4c0cb255ecf8b430$var$trimString = function trimString(str) {
    return str.replace(/^\s+|\s+$/g, "");
};
var $4c0cb255ecf8b430$var$defaultStringify = function defaultStringify(option) {
    return "".concat(option.label, " ").concat(option.value);
};
var $4c0cb255ecf8b430$export$db3b6bfb95261072 = function createFilter(config) {
    return function(option, rawInput) {
        // eslint-disable-next-line no-underscore-dangle
        if (option.data.__isNew__) return true;
        var _ignoreCase$ignoreAcc = (0, $lWmb7.default)({
            ignoreCase: true,
            ignoreAccents: true,
            stringify: $4c0cb255ecf8b430$var$defaultStringify,
            trim: true,
            matchFrom: "any"
        }, config), ignoreCase = _ignoreCase$ignoreAcc.ignoreCase, ignoreAccents = _ignoreCase$ignoreAcc.ignoreAccents, stringify = _ignoreCase$ignoreAcc.stringify, trim = _ignoreCase$ignoreAcc.trim, matchFrom = _ignoreCase$ignoreAcc.matchFrom;
        var input = trim ? $4c0cb255ecf8b430$var$trimString(rawInput) : rawInput;
        var candidate = trim ? $4c0cb255ecf8b430$var$trimString(stringify(option)) : stringify(option);
        if (ignoreCase) {
            input = input.toLowerCase();
            candidate = candidate.toLowerCase();
        }
        if (ignoreAccents) {
            input = $4c0cb255ecf8b430$var$memoizedStripDiacriticsForInput(input);
            candidate = $4c0cb255ecf8b430$var$stripDiacritics(candidate);
        }
        return matchFrom === "start" ? candidate.substr(0, input.length) === input : candidate.indexOf(input) > -1;
    };
};
var $4c0cb255ecf8b430$var$_excluded = [
    "innerRef"
];
function $4c0cb255ecf8b430$var$DummyInput(_ref) {
    var innerRef = _ref.innerRef, props = (0, $3ci4f.default)(_ref, $4c0cb255ecf8b430$var$_excluded);
    // Remove animation props not meant for HTML elements
    var filteredProps = (0, $fc2pq.r)(props, "onExited", "in", "enter", "exit", "appear");
    return (0, $jVTBW.jsx)("input", (0, $i6L24.default)({
        ref: innerRef
    }, filteredProps, {
        css: /*#__PURE__*/ (0, $jVTBW.css)({
            label: "dummyInput",
            // get rid of any default styles
            background: 0,
            border: 0,
            // important! this hides the flashing cursor
            caretColor: "transparent",
            fontSize: "inherit",
            gridArea: "1 / 1 / 2 / 3",
            outline: 0,
            padding: 0,
            // important! without `width` browsers won't allow focus
            width: 1,
            // remove cursor on desktop
            color: "transparent",
            // remove cursor on mobile whilst maintaining "scroll into view" behaviour
            left: -100,
            opacity: 0,
            position: "relative",
            transform: "scale(.01)"
        }, "", "")
    }));
}
var $4c0cb255ecf8b430$var$cancelScroll = function cancelScroll(event) {
    if (event.cancelable) event.preventDefault();
    event.stopPropagation();
};
function $4c0cb255ecf8b430$var$useScrollCapture(_ref) {
    var isEnabled = _ref.isEnabled, onBottomArrive = _ref.onBottomArrive, onBottomLeave = _ref.onBottomLeave, onTopArrive = _ref.onTopArrive, onTopLeave = _ref.onTopLeave;
    var isBottom = (0, $dAx5m.useRef)(false);
    var isTop = (0, $dAx5m.useRef)(false);
    var touchStart = (0, $dAx5m.useRef)(0);
    var scrollTarget = (0, $dAx5m.useRef)(null);
    var handleEventDelta = (0, $dAx5m.useCallback)(function(event, delta) {
        if (scrollTarget.current === null) return;
        var _scrollTarget$current = scrollTarget.current, scrollTop = _scrollTarget$current.scrollTop, scrollHeight = _scrollTarget$current.scrollHeight, clientHeight = _scrollTarget$current.clientHeight;
        var target = scrollTarget.current;
        var isDeltaPositive = delta > 0;
        var availableScroll = scrollHeight - clientHeight - scrollTop;
        var shouldCancelScroll = false;
        // reset bottom/top flags
        if (availableScroll > delta && isBottom.current) {
            if (onBottomLeave) onBottomLeave(event);
            isBottom.current = false;
        }
        if (isDeltaPositive && isTop.current) {
            if (onTopLeave) onTopLeave(event);
            isTop.current = false;
        }
        // bottom limit
        if (isDeltaPositive && delta > availableScroll) {
            if (onBottomArrive && !isBottom.current) onBottomArrive(event);
            target.scrollTop = scrollHeight;
            shouldCancelScroll = true;
            isBottom.current = true;
        // top limit
        } else if (!isDeltaPositive && -delta > scrollTop) {
            if (onTopArrive && !isTop.current) onTopArrive(event);
            target.scrollTop = 0;
            shouldCancelScroll = true;
            isTop.current = true;
        }
        // cancel scroll
        if (shouldCancelScroll) $4c0cb255ecf8b430$var$cancelScroll(event);
    }, [
        onBottomArrive,
        onBottomLeave,
        onTopArrive,
        onTopLeave
    ]);
    var onWheel = (0, $dAx5m.useCallback)(function(event) {
        handleEventDelta(event, event.deltaY);
    }, [
        handleEventDelta
    ]);
    var onTouchStart = (0, $dAx5m.useCallback)(function(event) {
        // set touch start so we can calculate touchmove delta
        touchStart.current = event.changedTouches[0].clientY;
    }, []);
    var onTouchMove = (0, $dAx5m.useCallback)(function(event) {
        var deltaY = touchStart.current - event.changedTouches[0].clientY;
        handleEventDelta(event, deltaY);
    }, [
        handleEventDelta
    ]);
    var startListening = (0, $dAx5m.useCallback)(function(el) {
        // bail early if no element is available to attach to
        if (!el) return;
        var notPassive = (0, $fc2pq.s) ? {
            passive: false
        } : false;
        el.addEventListener("wheel", onWheel, notPassive);
        el.addEventListener("touchstart", onTouchStart, notPassive);
        el.addEventListener("touchmove", onTouchMove, notPassive);
    }, [
        onTouchMove,
        onTouchStart,
        onWheel
    ]);
    var stopListening = (0, $dAx5m.useCallback)(function(el) {
        // bail early if no element is available to detach from
        if (!el) return;
        el.removeEventListener("wheel", onWheel, false);
        el.removeEventListener("touchstart", onTouchStart, false);
        el.removeEventListener("touchmove", onTouchMove, false);
    }, [
        onTouchMove,
        onTouchStart,
        onWheel
    ]);
    (0, $dAx5m.useEffect)(function() {
        if (!isEnabled) return;
        var element = scrollTarget.current;
        startListening(element);
        return function() {
            stopListening(element);
        };
    }, [
        isEnabled,
        startListening,
        stopListening
    ]);
    return function(element) {
        scrollTarget.current = element;
    };
}
var $4c0cb255ecf8b430$var$STYLE_KEYS = [
    "boxSizing",
    "height",
    "overflow",
    "paddingRight",
    "position"
];
var $4c0cb255ecf8b430$var$LOCK_STYLES = {
    boxSizing: "border-box",
    // account for possible declaration `width: 100%;` on body
    overflow: "hidden",
    position: "relative",
    height: "100%"
};
function $4c0cb255ecf8b430$var$preventTouchMove(e) {
    e.preventDefault();
}
function $4c0cb255ecf8b430$var$allowTouchMove(e) {
    e.stopPropagation();
}
function $4c0cb255ecf8b430$var$preventInertiaScroll() {
    var top = this.scrollTop;
    var totalScroll = this.scrollHeight;
    var currentScroll = top + this.offsetHeight;
    if (top === 0) this.scrollTop = 1;
    else if (currentScroll === totalScroll) this.scrollTop = top - 1;
}
// `ontouchstart` check works on most browsers
// `maxTouchPoints` works on IE10/11 and Surface
function $4c0cb255ecf8b430$var$isTouchDevice() {
    return "ontouchstart" in window || navigator.maxTouchPoints;
}
var $4c0cb255ecf8b430$var$canUseDOM = !!(typeof window !== "undefined" && window.document && window.document.createElement);
var $4c0cb255ecf8b430$var$activeScrollLocks = 0;
var $4c0cb255ecf8b430$var$listenerOptions = {
    capture: false,
    passive: false
};
function $4c0cb255ecf8b430$var$useScrollLock(_ref) {
    var isEnabled = _ref.isEnabled, _ref$accountForScroll = _ref.accountForScrollbars, accountForScrollbars = _ref$accountForScroll === void 0 ? true : _ref$accountForScroll;
    var originalStyles = (0, $dAx5m.useRef)({});
    var scrollTarget = (0, $dAx5m.useRef)(null);
    var addScrollLock = (0, $dAx5m.useCallback)(function(touchScrollTarget) {
        if (!$4c0cb255ecf8b430$var$canUseDOM) return;
        var target = document.body;
        var targetStyle = target && target.style;
        if (accountForScrollbars) // store any styles already applied to the body
        $4c0cb255ecf8b430$var$STYLE_KEYS.forEach(function(key) {
            var val = targetStyle && targetStyle[key];
            originalStyles.current[key] = val;
        });
        // apply the lock styles and padding if this is the first scroll lock
        if (accountForScrollbars && $4c0cb255ecf8b430$var$activeScrollLocks < 1) {
            var currentPadding = parseInt(originalStyles.current.paddingRight, 10) || 0;
            var clientWidth = document.body ? document.body.clientWidth : 0;
            var adjustedPadding = window.innerWidth - clientWidth + currentPadding || 0;
            Object.keys($4c0cb255ecf8b430$var$LOCK_STYLES).forEach(function(key) {
                var val = $4c0cb255ecf8b430$var$LOCK_STYLES[key];
                if (targetStyle) targetStyle[key] = val;
            });
            if (targetStyle) targetStyle.paddingRight = "".concat(adjustedPadding, "px");
        }
        // account for touch devices
        if (target && $4c0cb255ecf8b430$var$isTouchDevice()) {
            // Mobile Safari ignores { overflow: hidden } declaration on the body.
            target.addEventListener("touchmove", $4c0cb255ecf8b430$var$preventTouchMove, $4c0cb255ecf8b430$var$listenerOptions);
            // Allow scroll on provided target
            if (touchScrollTarget) {
                touchScrollTarget.addEventListener("touchstart", $4c0cb255ecf8b430$var$preventInertiaScroll, $4c0cb255ecf8b430$var$listenerOptions);
                touchScrollTarget.addEventListener("touchmove", $4c0cb255ecf8b430$var$allowTouchMove, $4c0cb255ecf8b430$var$listenerOptions);
            }
        }
        // increment active scroll locks
        $4c0cb255ecf8b430$var$activeScrollLocks += 1;
    }, [
        accountForScrollbars
    ]);
    var removeScrollLock = (0, $dAx5m.useCallback)(function(touchScrollTarget) {
        if (!$4c0cb255ecf8b430$var$canUseDOM) return;
        var target = document.body;
        var targetStyle = target && target.style;
        // safely decrement active scroll locks
        $4c0cb255ecf8b430$var$activeScrollLocks = Math.max($4c0cb255ecf8b430$var$activeScrollLocks - 1, 0);
        // reapply original body styles, if any
        if (accountForScrollbars && $4c0cb255ecf8b430$var$activeScrollLocks < 1) $4c0cb255ecf8b430$var$STYLE_KEYS.forEach(function(key) {
            var val = originalStyles.current[key];
            if (targetStyle) targetStyle[key] = val;
        });
        // remove touch listeners
        if (target && $4c0cb255ecf8b430$var$isTouchDevice()) {
            target.removeEventListener("touchmove", $4c0cb255ecf8b430$var$preventTouchMove, $4c0cb255ecf8b430$var$listenerOptions);
            if (touchScrollTarget) {
                touchScrollTarget.removeEventListener("touchstart", $4c0cb255ecf8b430$var$preventInertiaScroll, $4c0cb255ecf8b430$var$listenerOptions);
                touchScrollTarget.removeEventListener("touchmove", $4c0cb255ecf8b430$var$allowTouchMove, $4c0cb255ecf8b430$var$listenerOptions);
            }
        }
    }, [
        accountForScrollbars
    ]);
    (0, $dAx5m.useEffect)(function() {
        if (!isEnabled) return;
        var element = scrollTarget.current;
        addScrollLock(element);
        return function() {
            removeScrollLock(element);
        };
    }, [
        isEnabled,
        addScrollLock,
        removeScrollLock
    ]);
    return function(element) {
        scrollTarget.current = element;
    };
}
function $4c0cb255ecf8b430$var$_EMOTION_STRINGIFIED_CSS_ERROR__$1() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $4c0cb255ecf8b430$var$blurSelectInput = function blurSelectInput(event) {
    var element = event.target;
    return element.ownerDocument.activeElement && element.ownerDocument.activeElement.blur();
};
var $4c0cb255ecf8b430$var$_ref2$1 = {
    name: "1kfdb0e",
    styles: "position:fixed;left:0;bottom:0;right:0;top:0"
};
function $4c0cb255ecf8b430$var$ScrollManager(_ref) {
    var children = _ref.children, lockEnabled = _ref.lockEnabled, _ref$captureEnabled = _ref.captureEnabled, captureEnabled = _ref$captureEnabled === void 0 ? true : _ref$captureEnabled, onBottomArrive = _ref.onBottomArrive, onBottomLeave = _ref.onBottomLeave, onTopArrive = _ref.onTopArrive, onTopLeave = _ref.onTopLeave;
    var setScrollCaptureTarget = $4c0cb255ecf8b430$var$useScrollCapture({
        isEnabled: captureEnabled,
        onBottomArrive: onBottomArrive,
        onBottomLeave: onBottomLeave,
        onTopArrive: onTopArrive,
        onTopLeave: onTopLeave
    });
    var setScrollLockTarget = $4c0cb255ecf8b430$var$useScrollLock({
        isEnabled: lockEnabled
    });
    var targetRef = function targetRef(element) {
        setScrollCaptureTarget(element);
        setScrollLockTarget(element);
    };
    return (0, $jVTBW.jsx)((0, $dAx5m.Fragment), null, lockEnabled && (0, $jVTBW.jsx)("div", {
        onClick: $4c0cb255ecf8b430$var$blurSelectInput,
        css: $4c0cb255ecf8b430$var$_ref2$1
    }), children(targetRef));
}
function $4c0cb255ecf8b430$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $4c0cb255ecf8b430$var$_ref2 = {
    name: "1a0ro4n-requiredInput",
    styles: "label:requiredInput;opacity:0;pointer-events:none;position:absolute;bottom:0;left:0;right:0;width:100%"
};
var $4c0cb255ecf8b430$var$RequiredInput = function RequiredInput(_ref) {
    var name = _ref.name, onFocus = _ref.onFocus;
    return (0, $jVTBW.jsx)("input", {
        required: true,
        name: name,
        tabIndex: -1,
        "aria-hidden": "true",
        onFocus: onFocus,
        css: $4c0cb255ecf8b430$var$_ref2,
        value: "",
        onChange: function onChange() {}
    });
};
var $4c0cb255ecf8b430$var$RequiredInput$1 = $4c0cb255ecf8b430$var$RequiredInput;
/// <reference types="user-agent-data-types" />
function $4c0cb255ecf8b430$var$testPlatform(re) {
    var _window$navigator$use;
    return typeof window !== "undefined" && window.navigator != null ? re.test(((_window$navigator$use = window.navigator["userAgentData"]) === null || _window$navigator$use === void 0 ? void 0 : _window$navigator$use.platform) || window.navigator.platform) : false;
}
function $4c0cb255ecf8b430$var$isIPhone() {
    return $4c0cb255ecf8b430$var$testPlatform(/^iPhone/i);
}
function $4c0cb255ecf8b430$var$isMac() {
    return $4c0cb255ecf8b430$var$testPlatform(/^Mac/i);
}
function $4c0cb255ecf8b430$var$isIPad() {
    return $4c0cb255ecf8b430$var$testPlatform(/^iPad/i) || // iPadOS 13 lies and says it's a Mac, but we can distinguish by detecting touch support.
    $4c0cb255ecf8b430$var$isMac() && navigator.maxTouchPoints > 1;
}
function $4c0cb255ecf8b430$var$isIOS() {
    return $4c0cb255ecf8b430$var$isIPhone() || $4c0cb255ecf8b430$var$isIPad();
}
function $4c0cb255ecf8b430$var$isAppleDevice() {
    return $4c0cb255ecf8b430$var$isMac() || $4c0cb255ecf8b430$var$isIOS();
}
var $4c0cb255ecf8b430$var$formatGroupLabel = function formatGroupLabel(group) {
    return group.label;
};
var $4c0cb255ecf8b430$export$8b22cf2602fb60ce = function getOptionLabel(option) {
    return option.label;
};
var $4c0cb255ecf8b430$export$39b482c5e57630a8 = function getOptionValue(option) {
    return option.value;
};
var $4c0cb255ecf8b430$var$isOptionDisabled = function isOptionDisabled(option) {
    return !!option.isDisabled;
};
var $4c0cb255ecf8b430$var$defaultStyles = {
    clearIndicator: (0, $fc2pq.a),
    container: (0, $fc2pq.b),
    control: (0, $fc2pq.d),
    dropdownIndicator: (0, $fc2pq.e),
    group: (0, $fc2pq.g),
    groupHeading: (0, $fc2pq.f),
    indicatorsContainer: (0, $fc2pq.i),
    indicatorSeparator: (0, $fc2pq.h),
    input: (0, $fc2pq.j),
    loadingIndicator: (0, $fc2pq.l),
    loadingMessage: (0, $fc2pq.k),
    menu: (0, $fc2pq.m),
    menuList: (0, $fc2pq.n),
    menuPortal: (0, $fc2pq.o),
    multiValue: (0, $fc2pq.p),
    multiValueLabel: (0, $fc2pq.q),
    multiValueRemove: (0, $fc2pq.t),
    noOptionsMessage: (0, $fc2pq.u),
    option: (0, $fc2pq.v),
    placeholder: (0, $fc2pq.w),
    singleValue: (0, $fc2pq.x),
    valueContainer: (0, $fc2pq.y)
};
// Merge Utility
// Allows consumers to extend a base Select with additional styles
function $4c0cb255ecf8b430$export$953cecd6e717a553(source) {
    var target = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    // initialize with source styles
    var styles = (0, $lWmb7.default)({}, source);
    // massage in target styles
    Object.keys(target).forEach(function(keyAsString) {
        var key = keyAsString;
        if (source[key]) styles[key] = function(rsCss, props) {
            return target[key](source[key](rsCss, props), props);
        };
        else styles[key] = target[key];
    });
    return styles;
}
var $4c0cb255ecf8b430$var$colors = {
    primary: "#2684FF",
    primary75: "#4C9AFF",
    primary50: "#B2D4FF",
    primary25: "#DEEBFF",
    danger: "#DE350B",
    dangerLight: "#FFBDAD",
    neutral0: "hsl(0, 0%, 100%)",
    neutral5: "hsl(0, 0%, 95%)",
    neutral10: "hsl(0, 0%, 90%)",
    neutral20: "hsl(0, 0%, 80%)",
    neutral30: "hsl(0, 0%, 70%)",
    neutral40: "hsl(0, 0%, 60%)",
    neutral50: "hsl(0, 0%, 50%)",
    neutral60: "hsl(0, 0%, 40%)",
    neutral70: "hsl(0, 0%, 30%)",
    neutral80: "hsl(0, 0%, 20%)",
    neutral90: "hsl(0, 0%, 10%)"
};
var $4c0cb255ecf8b430$var$borderRadius = 4;
// Used to calculate consistent margin/padding on elements
var $4c0cb255ecf8b430$var$baseUnit = 4;
// The minimum height of the control
var $4c0cb255ecf8b430$var$controlHeight = 38;
// The amount of space between the control and menu */
var $4c0cb255ecf8b430$var$menuGutter = $4c0cb255ecf8b430$var$baseUnit * 2;
var $4c0cb255ecf8b430$var$spacing = {
    baseUnit: $4c0cb255ecf8b430$var$baseUnit,
    controlHeight: $4c0cb255ecf8b430$var$controlHeight,
    menuGutter: $4c0cb255ecf8b430$var$menuGutter
};
var $4c0cb255ecf8b430$export$4368d992c4eafac0 = {
    borderRadius: $4c0cb255ecf8b430$var$borderRadius,
    colors: $4c0cb255ecf8b430$var$colors,
    spacing: $4c0cb255ecf8b430$var$spacing
};
var $4c0cb255ecf8b430$export$407448d2b89b1813 = {
    "aria-live": "polite",
    backspaceRemovesValue: true,
    blurInputOnSelect: (0, $fc2pq.z)(),
    captureMenuScroll: !(0, $fc2pq.z)(),
    classNames: {},
    closeMenuOnSelect: true,
    closeMenuOnScroll: false,
    components: {},
    controlShouldRenderValue: true,
    escapeClearsValue: false,
    filterOption: $4c0cb255ecf8b430$export$db3b6bfb95261072(),
    formatGroupLabel: $4c0cb255ecf8b430$var$formatGroupLabel,
    getOptionLabel: $4c0cb255ecf8b430$export$8b22cf2602fb60ce,
    getOptionValue: $4c0cb255ecf8b430$export$39b482c5e57630a8,
    isDisabled: false,
    isLoading: false,
    isMulti: false,
    isRtl: false,
    isSearchable: true,
    isOptionDisabled: $4c0cb255ecf8b430$var$isOptionDisabled,
    loadingMessage: function loadingMessage() {
        return "Loading...";
    },
    maxMenuHeight: 300,
    minMenuHeight: 140,
    menuIsOpen: false,
    menuPlacement: "bottom",
    menuPosition: "absolute",
    menuShouldBlockScroll: false,
    menuShouldScrollIntoView: !(0, $fc2pq.A)(),
    noOptionsMessage: function noOptionsMessage() {
        return "No options";
    },
    openMenuOnFocus: false,
    openMenuOnClick: true,
    options: [],
    pageSize: 5,
    placeholder: "Select...",
    screenReaderStatus: function screenReaderStatus(_ref) {
        var count = _ref.count;
        return "".concat(count, " result").concat(count !== 1 ? "s" : "", " available");
    },
    styles: {},
    tabIndex: 0,
    tabSelectsValue: true,
    unstyled: false
};
function $4c0cb255ecf8b430$var$toCategorizedOption(props, option, selectValue, index) {
    var isDisabled = $4c0cb255ecf8b430$var$_isOptionDisabled(props, option, selectValue);
    var isSelected = $4c0cb255ecf8b430$var$_isOptionSelected(props, option, selectValue);
    var label = $4c0cb255ecf8b430$var$getOptionLabel(props, option);
    var value = $4c0cb255ecf8b430$var$getOptionValue(props, option);
    return {
        type: "option",
        data: option,
        isDisabled: isDisabled,
        isSelected: isSelected,
        label: label,
        value: value,
        index: index
    };
}
function $4c0cb255ecf8b430$var$buildCategorizedOptions(props, selectValue) {
    return props.options.map(function(groupOrOption, groupOrOptionIndex) {
        if ("options" in groupOrOption) {
            var categorizedOptions = groupOrOption.options.map(function(option, optionIndex) {
                return $4c0cb255ecf8b430$var$toCategorizedOption(props, option, selectValue, optionIndex);
            }).filter(function(categorizedOption) {
                return $4c0cb255ecf8b430$var$isFocusable(props, categorizedOption);
            });
            return categorizedOptions.length > 0 ? {
                type: "group",
                data: groupOrOption,
                options: categorizedOptions,
                index: groupOrOptionIndex
            } : undefined;
        }
        var categorizedOption = $4c0cb255ecf8b430$var$toCategorizedOption(props, groupOrOption, selectValue, groupOrOptionIndex);
        return $4c0cb255ecf8b430$var$isFocusable(props, categorizedOption) ? categorizedOption : undefined;
    }).filter((0, $fc2pq.K));
}
function $4c0cb255ecf8b430$var$buildFocusableOptionsFromCategorizedOptions(categorizedOptions) {
    return categorizedOptions.reduce(function(optionsAccumulator, categorizedOption) {
        if (categorizedOption.type === "group") optionsAccumulator.push.apply(optionsAccumulator, (0, $jPOzM.default)(categorizedOption.options.map(function(option) {
            return option.data;
        })));
        else optionsAccumulator.push(categorizedOption.data);
        return optionsAccumulator;
    }, []);
}
function $4c0cb255ecf8b430$var$buildFocusableOptionsWithIds(categorizedOptions, optionId) {
    return categorizedOptions.reduce(function(optionsAccumulator, categorizedOption) {
        if (categorizedOption.type === "group") optionsAccumulator.push.apply(optionsAccumulator, (0, $jPOzM.default)(categorizedOption.options.map(function(option) {
            return {
                data: option.data,
                id: "".concat(optionId, "-").concat(categorizedOption.index, "-").concat(option.index)
            };
        })));
        else optionsAccumulator.push({
            data: categorizedOption.data,
            id: "".concat(optionId, "-").concat(categorizedOption.index)
        });
        return optionsAccumulator;
    }, []);
}
function $4c0cb255ecf8b430$var$buildFocusableOptions(props, selectValue) {
    return $4c0cb255ecf8b430$var$buildFocusableOptionsFromCategorizedOptions($4c0cb255ecf8b430$var$buildCategorizedOptions(props, selectValue));
}
function $4c0cb255ecf8b430$var$isFocusable(props, categorizedOption) {
    var _props$inputValue = props.inputValue, inputValue = _props$inputValue === void 0 ? "" : _props$inputValue;
    var data = categorizedOption.data, isSelected = categorizedOption.isSelected, label = categorizedOption.label, value = categorizedOption.value;
    return (!$4c0cb255ecf8b430$var$shouldHideSelectedOptions(props) || !isSelected) && $4c0cb255ecf8b430$var$_filterOption(props, {
        label: label,
        value: value,
        data: data
    }, inputValue);
}
function $4c0cb255ecf8b430$var$getNextFocusedValue(state, nextSelectValue) {
    var focusedValue = state.focusedValue, lastSelectValue = state.selectValue;
    var lastFocusedIndex = lastSelectValue.indexOf(focusedValue);
    if (lastFocusedIndex > -1) {
        var nextFocusedIndex = nextSelectValue.indexOf(focusedValue);
        if (nextFocusedIndex > -1) // the focused value is still in the selectValue, return it
        return focusedValue;
        else if (lastFocusedIndex < nextSelectValue.length) // the focusedValue is not present in the next selectValue array by
        // reference, so return the new value at the same index
        return nextSelectValue[lastFocusedIndex];
    }
    return null;
}
function $4c0cb255ecf8b430$var$getNextFocusedOption(state, options) {
    var lastFocusedOption = state.focusedOption;
    return lastFocusedOption && options.indexOf(lastFocusedOption) > -1 ? lastFocusedOption : options[0];
}
var $4c0cb255ecf8b430$var$getFocusedOptionId = function getFocusedOptionId(focusableOptionsWithIds, focusedOption) {
    var _focusableOptionsWith;
    var focusedOptionId = (_focusableOptionsWith = focusableOptionsWithIds.find(function(option) {
        return option.data === focusedOption;
    })) === null || _focusableOptionsWith === void 0 ? void 0 : _focusableOptionsWith.id;
    return focusedOptionId || null;
};
var $4c0cb255ecf8b430$var$getOptionLabel = function getOptionLabel(props, data) {
    return props.getOptionLabel(data);
};
var $4c0cb255ecf8b430$var$getOptionValue = function getOptionValue(props, data) {
    return props.getOptionValue(data);
};
function $4c0cb255ecf8b430$var$_isOptionDisabled(props, option, selectValue) {
    return typeof props.isOptionDisabled === "function" ? props.isOptionDisabled(option, selectValue) : false;
}
function $4c0cb255ecf8b430$var$_isOptionSelected(props, option, selectValue) {
    if (selectValue.indexOf(option) > -1) return true;
    if (typeof props.isOptionSelected === "function") return props.isOptionSelected(option, selectValue);
    var candidate = $4c0cb255ecf8b430$var$getOptionValue(props, option);
    return selectValue.some(function(i) {
        return $4c0cb255ecf8b430$var$getOptionValue(props, i) === candidate;
    });
}
function $4c0cb255ecf8b430$var$_filterOption(props, option, inputValue) {
    return props.filterOption ? props.filterOption(option, inputValue) : true;
}
var $4c0cb255ecf8b430$var$shouldHideSelectedOptions = function shouldHideSelectedOptions(props) {
    var hideSelectedOptions = props.hideSelectedOptions, isMulti = props.isMulti;
    if (hideSelectedOptions === undefined) return isMulti;
    return hideSelectedOptions;
};
var $4c0cb255ecf8b430$var$instanceId = 1;
var $4c0cb255ecf8b430$export$25ce5a424b770e84 = /*#__PURE__*/ function(_Component) {
    (0, $bTgpJ.default)(Select, _Component);
    var _super = (0, $KsTfi.default)(Select);
    // Misc. Instance Properties
    // ------------------------------
    // TODO
    // Refs
    // ------------------------------
    // Lifecycle
    // ------------------------------
    function Select(_props) {
        var _this;
        (0, $3Ez4j.default)(this, Select);
        _this = _super.call(this, _props);
        _this.state = {
            ariaSelection: null,
            focusedOption: null,
            focusedOptionId: null,
            focusableOptionsWithIds: [],
            focusedValue: null,
            inputIsHidden: false,
            isFocused: false,
            selectValue: [],
            clearFocusValueOnUpdate: false,
            prevWasFocused: false,
            inputIsHiddenAfterUpdate: undefined,
            prevProps: undefined,
            instancePrefix: ""
        };
        _this.blockOptionHover = false;
        _this.isComposing = false;
        _this.commonProps = void 0;
        _this.initialTouchX = 0;
        _this.initialTouchY = 0;
        _this.openAfterFocus = false;
        _this.scrollToFocusedOptionOnUpdate = false;
        _this.userIsDragging = void 0;
        _this.isAppleDevice = $4c0cb255ecf8b430$var$isAppleDevice();
        _this.controlRef = null;
        _this.getControlRef = function(ref) {
            _this.controlRef = ref;
        };
        _this.focusedOptionRef = null;
        _this.getFocusedOptionRef = function(ref) {
            _this.focusedOptionRef = ref;
        };
        _this.menuListRef = null;
        _this.getMenuListRef = function(ref) {
            _this.menuListRef = ref;
        };
        _this.inputRef = null;
        _this.getInputRef = function(ref) {
            _this.inputRef = ref;
        };
        _this.focus = _this.focusInput;
        _this.blur = _this.blurInput;
        _this.onChange = function(newValue, actionMeta) {
            var _this$props = _this.props, onChange = _this$props.onChange, name = _this$props.name;
            actionMeta.name = name;
            _this.ariaOnChange(newValue, actionMeta);
            onChange(newValue, actionMeta);
        };
        _this.setValue = function(newValue, action, option) {
            var _this$props2 = _this.props, closeMenuOnSelect = _this$props2.closeMenuOnSelect, isMulti = _this$props2.isMulti, inputValue = _this$props2.inputValue;
            _this.onInputChange("", {
                action: "set-value",
                prevInputValue: inputValue
            });
            if (closeMenuOnSelect) {
                _this.setState({
                    inputIsHiddenAfterUpdate: !isMulti
                });
                _this.onMenuClose();
            }
            // when the select value should change, we should reset focusedValue
            _this.setState({
                clearFocusValueOnUpdate: true
            });
            _this.onChange(newValue, {
                action: action,
                option: option
            });
        };
        _this.selectOption = function(newValue) {
            var _this$props3 = _this.props, blurInputOnSelect = _this$props3.blurInputOnSelect, isMulti = _this$props3.isMulti, name = _this$props3.name;
            var selectValue = _this.state.selectValue;
            var deselected = isMulti && _this.isOptionSelected(newValue, selectValue);
            var isDisabled = _this.isOptionDisabled(newValue, selectValue);
            if (deselected) {
                var candidate = _this.getOptionValue(newValue);
                _this.setValue((0, $fc2pq.B)(selectValue.filter(function(i) {
                    return _this.getOptionValue(i) !== candidate;
                })), "deselect-option", newValue);
            } else if (!isDisabled) {
                // Select option if option is not disabled
                if (isMulti) _this.setValue((0, $fc2pq.B)([].concat((0, $jPOzM.default)(selectValue), [
                    newValue
                ])), "select-option", newValue);
                else _this.setValue((0, $fc2pq.C)(newValue), "select-option");
            } else {
                _this.ariaOnChange((0, $fc2pq.C)(newValue), {
                    action: "select-option",
                    option: newValue,
                    name: name
                });
                return;
            }
            if (blurInputOnSelect) _this.blurInput();
        };
        _this.removeValue = function(removedValue) {
            var isMulti = _this.props.isMulti;
            var selectValue = _this.state.selectValue;
            var candidate = _this.getOptionValue(removedValue);
            var newValueArray = selectValue.filter(function(i) {
                return _this.getOptionValue(i) !== candidate;
            });
            var newValue = (0, $fc2pq.D)(isMulti, newValueArray, newValueArray[0] || null);
            _this.onChange(newValue, {
                action: "remove-value",
                removedValue: removedValue
            });
            _this.focusInput();
        };
        _this.clearValue = function() {
            var selectValue = _this.state.selectValue;
            _this.onChange((0, $fc2pq.D)(_this.props.isMulti, [], null), {
                action: "clear",
                removedValues: selectValue
            });
        };
        _this.popValue = function() {
            var isMulti = _this.props.isMulti;
            var selectValue = _this.state.selectValue;
            var lastSelectedValue = selectValue[selectValue.length - 1];
            var newValueArray = selectValue.slice(0, selectValue.length - 1);
            var newValue = (0, $fc2pq.D)(isMulti, newValueArray, newValueArray[0] || null);
            _this.onChange(newValue, {
                action: "pop-value",
                removedValue: lastSelectedValue
            });
        };
        _this.getFocusedOptionId = function(focusedOption) {
            return $4c0cb255ecf8b430$var$getFocusedOptionId(_this.state.focusableOptionsWithIds, focusedOption);
        };
        _this.getFocusableOptionsWithIds = function() {
            return $4c0cb255ecf8b430$var$buildFocusableOptionsWithIds($4c0cb255ecf8b430$var$buildCategorizedOptions(_this.props, _this.state.selectValue), _this.getElementId("option"));
        };
        _this.getValue = function() {
            return _this.state.selectValue;
        };
        _this.cx = function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            return (0, $fc2pq.E).apply(void 0, [
                _this.props.classNamePrefix
            ].concat(args));
        };
        _this.getOptionLabel = function(data) {
            return $4c0cb255ecf8b430$var$getOptionLabel(_this.props, data);
        };
        _this.getOptionValue = function(data) {
            return $4c0cb255ecf8b430$var$getOptionValue(_this.props, data);
        };
        _this.getStyles = function(key, props) {
            var unstyled = _this.props.unstyled;
            var base = $4c0cb255ecf8b430$var$defaultStyles[key](props, unstyled);
            base.boxSizing = "border-box";
            var custom = _this.props.styles[key];
            return custom ? custom(base, props) : base;
        };
        _this.getClassNames = function(key, props) {
            var _this$props$className, _this$props$className2;
            return (_this$props$className = (_this$props$className2 = _this.props.classNames)[key]) === null || _this$props$className === void 0 ? void 0 : _this$props$className.call(_this$props$className2, props);
        };
        _this.getElementId = function(element) {
            return "".concat(_this.state.instancePrefix, "-").concat(element);
        };
        _this.getComponents = function() {
            return (0, $fc2pq.F)(_this.props);
        };
        _this.buildCategorizedOptions = function() {
            return $4c0cb255ecf8b430$var$buildCategorizedOptions(_this.props, _this.state.selectValue);
        };
        _this.getCategorizedOptions = function() {
            return _this.props.menuIsOpen ? _this.buildCategorizedOptions() : [];
        };
        _this.buildFocusableOptions = function() {
            return $4c0cb255ecf8b430$var$buildFocusableOptionsFromCategorizedOptions(_this.buildCategorizedOptions());
        };
        _this.getFocusableOptions = function() {
            return _this.props.menuIsOpen ? _this.buildFocusableOptions() : [];
        };
        _this.ariaOnChange = function(value, actionMeta) {
            _this.setState({
                ariaSelection: (0, $lWmb7.default)({
                    value: value
                }, actionMeta)
            });
        };
        _this.onMenuMouseDown = function(event) {
            if (event.button !== 0) return;
            event.stopPropagation();
            event.preventDefault();
            _this.focusInput();
        };
        _this.onMenuMouseMove = function(event) {
            _this.blockOptionHover = false;
        };
        _this.onControlMouseDown = function(event) {
            // Event captured by dropdown indicator
            if (event.defaultPrevented) return;
            var openMenuOnClick = _this.props.openMenuOnClick;
            if (!_this.state.isFocused) {
                if (openMenuOnClick) _this.openAfterFocus = true;
                _this.focusInput();
            } else if (!_this.props.menuIsOpen) {
                if (openMenuOnClick) _this.openMenu("first");
            } else if (event.target.tagName !== "INPUT" && event.target.tagName !== "TEXTAREA") _this.onMenuClose();
            if (event.target.tagName !== "INPUT" && event.target.tagName !== "TEXTAREA") event.preventDefault();
        };
        _this.onDropdownIndicatorMouseDown = function(event) {
            // ignore mouse events that weren't triggered by the primary button
            if (event && event.type === "mousedown" && event.button !== 0) return;
            if (_this.props.isDisabled) return;
            var _this$props4 = _this.props, isMulti = _this$props4.isMulti, menuIsOpen = _this$props4.menuIsOpen;
            _this.focusInput();
            if (menuIsOpen) {
                _this.setState({
                    inputIsHiddenAfterUpdate: !isMulti
                });
                _this.onMenuClose();
            } else _this.openMenu("first");
            event.preventDefault();
        };
        _this.onClearIndicatorMouseDown = function(event) {
            // ignore mouse events that weren't triggered by the primary button
            if (event && event.type === "mousedown" && event.button !== 0) return;
            _this.clearValue();
            event.preventDefault();
            _this.openAfterFocus = false;
            if (event.type === "touchend") _this.focusInput();
            else setTimeout(function() {
                return _this.focusInput();
            });
        };
        _this.onScroll = function(event) {
            if (typeof _this.props.closeMenuOnScroll === "boolean") {
                if (event.target instanceof HTMLElement && (0, $fc2pq.G)(event.target)) _this.props.onMenuClose();
            } else if (typeof _this.props.closeMenuOnScroll === "function") {
                if (_this.props.closeMenuOnScroll(event)) _this.props.onMenuClose();
            }
        };
        _this.onCompositionStart = function() {
            _this.isComposing = true;
        };
        _this.onCompositionEnd = function() {
            _this.isComposing = false;
        };
        _this.onTouchStart = function(_ref2) {
            var touches = _ref2.touches;
            var touch = touches && touches.item(0);
            if (!touch) return;
            _this.initialTouchX = touch.clientX;
            _this.initialTouchY = touch.clientY;
            _this.userIsDragging = false;
        };
        _this.onTouchMove = function(_ref3) {
            var touches = _ref3.touches;
            var touch = touches && touches.item(0);
            if (!touch) return;
            var deltaX = Math.abs(touch.clientX - _this.initialTouchX);
            var deltaY = Math.abs(touch.clientY - _this.initialTouchY);
            var moveThreshold = 5;
            _this.userIsDragging = deltaX > moveThreshold || deltaY > moveThreshold;
        };
        _this.onTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            // close the menu if the user taps outside
            // we're checking on event.target here instead of event.currentTarget, because we want to assert information
            // on events on child elements, not the document (which we've attached this handler to).
            if (_this.controlRef && !_this.controlRef.contains(event.target) && _this.menuListRef && !_this.menuListRef.contains(event.target)) _this.blurInput();
            // reset move vars
            _this.initialTouchX = 0;
            _this.initialTouchY = 0;
        };
        _this.onControlTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            _this.onControlMouseDown(event);
        };
        _this.onClearIndicatorTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            _this.onClearIndicatorMouseDown(event);
        };
        _this.onDropdownIndicatorTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            _this.onDropdownIndicatorMouseDown(event);
        };
        _this.handleInputChange = function(event) {
            var prevInputValue = _this.props.inputValue;
            var inputValue = event.currentTarget.value;
            _this.setState({
                inputIsHiddenAfterUpdate: false
            });
            _this.onInputChange(inputValue, {
                action: "input-change",
                prevInputValue: prevInputValue
            });
            if (!_this.props.menuIsOpen) _this.onMenuOpen();
        };
        _this.onInputFocus = function(event) {
            if (_this.props.onFocus) _this.props.onFocus(event);
            _this.setState({
                inputIsHiddenAfterUpdate: false,
                isFocused: true
            });
            if (_this.openAfterFocus || _this.props.openMenuOnFocus) _this.openMenu("first");
            _this.openAfterFocus = false;
        };
        _this.onInputBlur = function(event) {
            var prevInputValue = _this.props.inputValue;
            if (_this.menuListRef && _this.menuListRef.contains(document.activeElement)) {
                _this.inputRef.focus();
                return;
            }
            if (_this.props.onBlur) _this.props.onBlur(event);
            _this.onInputChange("", {
                action: "input-blur",
                prevInputValue: prevInputValue
            });
            _this.onMenuClose();
            _this.setState({
                focusedValue: null,
                isFocused: false
            });
        };
        _this.onOptionHover = function(focusedOption) {
            if (_this.blockOptionHover || _this.state.focusedOption === focusedOption) return;
            var options = _this.getFocusableOptions();
            var focusedOptionIndex = options.indexOf(focusedOption);
            _this.setState({
                focusedOption: focusedOption,
                focusedOptionId: focusedOptionIndex > -1 ? _this.getFocusedOptionId(focusedOption) : null
            });
        };
        _this.shouldHideSelectedOptions = function() {
            return $4c0cb255ecf8b430$var$shouldHideSelectedOptions(_this.props);
        };
        _this.onValueInputFocus = function(e) {
            e.preventDefault();
            e.stopPropagation();
            _this.focus();
        };
        _this.onKeyDown = function(event) {
            var _this$props5 = _this.props, isMulti = _this$props5.isMulti, backspaceRemovesValue = _this$props5.backspaceRemovesValue, escapeClearsValue = _this$props5.escapeClearsValue, inputValue = _this$props5.inputValue, isClearable = _this$props5.isClearable, isDisabled = _this$props5.isDisabled, menuIsOpen = _this$props5.menuIsOpen, onKeyDown = _this$props5.onKeyDown, tabSelectsValue = _this$props5.tabSelectsValue, openMenuOnFocus = _this$props5.openMenuOnFocus;
            var _this$state = _this.state, focusedOption = _this$state.focusedOption, focusedValue = _this$state.focusedValue, selectValue = _this$state.selectValue;
            if (isDisabled) return;
            if (typeof onKeyDown === "function") {
                onKeyDown(event);
                if (event.defaultPrevented) return;
            }
            // Block option hover events when the user has just pressed a key
            _this.blockOptionHover = true;
            switch(event.key){
                case "ArrowLeft":
                    if (!isMulti || inputValue) return;
                    _this.focusValue("previous");
                    break;
                case "ArrowRight":
                    if (!isMulti || inputValue) return;
                    _this.focusValue("next");
                    break;
                case "Delete":
                case "Backspace":
                    if (inputValue) return;
                    if (focusedValue) _this.removeValue(focusedValue);
                    else {
                        if (!backspaceRemovesValue) return;
                        if (isMulti) _this.popValue();
                        else if (isClearable) _this.clearValue();
                    }
                    break;
                case "Tab":
                    if (_this.isComposing) return;
                    if (event.shiftKey || !menuIsOpen || !tabSelectsValue || !focusedOption || // don't capture the event if the menu opens on focus and the focused
                    // option is already selected; it breaks the flow of navigation
                    openMenuOnFocus && _this.isOptionSelected(focusedOption, selectValue)) return;
                    _this.selectOption(focusedOption);
                    break;
                case "Enter":
                    if (event.keyCode === 229) break;
                    if (menuIsOpen) {
                        if (!focusedOption) return;
                        if (_this.isComposing) return;
                        _this.selectOption(focusedOption);
                        break;
                    }
                    return;
                case "Escape":
                    if (menuIsOpen) {
                        _this.setState({
                            inputIsHiddenAfterUpdate: false
                        });
                        _this.onInputChange("", {
                            action: "menu-close",
                            prevInputValue: inputValue
                        });
                        _this.onMenuClose();
                    } else if (isClearable && escapeClearsValue) _this.clearValue();
                    break;
                case " ":
                    // space
                    if (inputValue) return;
                    if (!menuIsOpen) {
                        _this.openMenu("first");
                        break;
                    }
                    if (!focusedOption) return;
                    _this.selectOption(focusedOption);
                    break;
                case "ArrowUp":
                    if (menuIsOpen) _this.focusOption("up");
                    else _this.openMenu("last");
                    break;
                case "ArrowDown":
                    if (menuIsOpen) _this.focusOption("down");
                    else _this.openMenu("first");
                    break;
                case "PageUp":
                    if (!menuIsOpen) return;
                    _this.focusOption("pageup");
                    break;
                case "PageDown":
                    if (!menuIsOpen) return;
                    _this.focusOption("pagedown");
                    break;
                case "Home":
                    if (!menuIsOpen) return;
                    _this.focusOption("first");
                    break;
                case "End":
                    if (!menuIsOpen) return;
                    _this.focusOption("last");
                    break;
                default:
                    return;
            }
            event.preventDefault();
        };
        _this.state.instancePrefix = "react-select-" + (_this.props.instanceId || ++$4c0cb255ecf8b430$var$instanceId);
        _this.state.selectValue = (0, $fc2pq.H)(_props.value);
        // Set focusedOption if menuIsOpen is set on init (e.g. defaultMenuIsOpen)
        if (_props.menuIsOpen && _this.state.selectValue.length) {
            var focusableOptionsWithIds = _this.getFocusableOptionsWithIds();
            var focusableOptions = _this.buildFocusableOptions();
            var optionIndex = focusableOptions.indexOf(_this.state.selectValue[0]);
            _this.state.focusableOptionsWithIds = focusableOptionsWithIds;
            _this.state.focusedOption = focusableOptions[optionIndex];
            _this.state.focusedOptionId = $4c0cb255ecf8b430$var$getFocusedOptionId(focusableOptionsWithIds, focusableOptions[optionIndex]);
        }
        return _this;
    }
    (0, $5JW2y.default)(Select, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.startListeningComposition();
                this.startListeningToTouch();
                if (this.props.closeMenuOnScroll && document && document.addEventListener) // Listen to all scroll events, and filter them out inside of 'onScroll'
                document.addEventListener("scroll", this.onScroll, true);
                if (this.props.autoFocus) this.focusInput();
                // Scroll focusedOption into view if menuIsOpen is set on mount (e.g. defaultMenuIsOpen)
                if (this.props.menuIsOpen && this.state.focusedOption && this.menuListRef && this.focusedOptionRef) (0, $fc2pq.I)(this.menuListRef, this.focusedOptionRef);
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                var _this$props6 = this.props, isDisabled = _this$props6.isDisabled, menuIsOpen = _this$props6.menuIsOpen;
                var isFocused = this.state.isFocused;
                if (// ensure focus is restored correctly when the control becomes enabled
                isFocused && !isDisabled && prevProps.isDisabled || // ensure focus is on the Input when the menu opens
                isFocused && menuIsOpen && !prevProps.menuIsOpen) this.focusInput();
                if (isFocused && isDisabled && !prevProps.isDisabled) // ensure select state gets blurred in case Select is programmatically disabled while focused
                // eslint-disable-next-line react/no-did-update-set-state
                this.setState({
                    isFocused: false
                }, this.onMenuClose);
                else if (!isFocused && !isDisabled && prevProps.isDisabled && this.inputRef === document.activeElement) // ensure select state gets focused in case Select is programatically re-enabled while focused (Firefox)
                // eslint-disable-next-line react/no-did-update-set-state
                this.setState({
                    isFocused: true
                });
                // scroll the focused option into view if necessary
                if (this.menuListRef && this.focusedOptionRef && this.scrollToFocusedOptionOnUpdate) {
                    (0, $fc2pq.I)(this.menuListRef, this.focusedOptionRef);
                    this.scrollToFocusedOptionOnUpdate = false;
                }
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.stopListeningComposition();
                this.stopListeningToTouch();
                document.removeEventListener("scroll", this.onScroll, true);
            }
        },
        {
            key: "onMenuOpen",
            value: function onMenuOpen() {
                this.props.onMenuOpen();
            }
        },
        {
            key: "onMenuClose",
            value: function onMenuClose() {
                this.onInputChange("", {
                    action: "menu-close",
                    prevInputValue: this.props.inputValue
                });
                this.props.onMenuClose();
            }
        },
        {
            key: "onInputChange",
            value: function onInputChange(newValue, actionMeta) {
                this.props.onInputChange(newValue, actionMeta);
            }
        },
        {
            key: "focusInput",
            value: function focusInput() {
                if (!this.inputRef) return;
                this.inputRef.focus();
            }
        },
        {
            key: "blurInput",
            value: function blurInput() {
                if (!this.inputRef) return;
                this.inputRef.blur();
            }
        },
        {
            key: "openMenu",
            value: function openMenu(focusOption) {
                var _this2 = this;
                var _this$state2 = this.state, selectValue = _this$state2.selectValue, isFocused = _this$state2.isFocused;
                var focusableOptions = this.buildFocusableOptions();
                var openAtIndex = focusOption === "first" ? 0 : focusableOptions.length - 1;
                if (!this.props.isMulti) {
                    var selectedIndex = focusableOptions.indexOf(selectValue[0]);
                    if (selectedIndex > -1) openAtIndex = selectedIndex;
                }
                // only scroll if the menu isn't already open
                this.scrollToFocusedOptionOnUpdate = !(isFocused && this.menuListRef);
                this.setState({
                    inputIsHiddenAfterUpdate: false,
                    focusedValue: null,
                    focusedOption: focusableOptions[openAtIndex],
                    focusedOptionId: this.getFocusedOptionId(focusableOptions[openAtIndex])
                }, function() {
                    return _this2.onMenuOpen();
                });
            }
        },
        {
            key: "focusValue",
            value: function focusValue(direction) {
                var _this$state3 = this.state, selectValue = _this$state3.selectValue, focusedValue = _this$state3.focusedValue;
                // Only multiselects support value focusing
                if (!this.props.isMulti) return;
                this.setState({
                    focusedOption: null
                });
                var focusedIndex = selectValue.indexOf(focusedValue);
                if (!focusedValue) focusedIndex = -1;
                var lastIndex = selectValue.length - 1;
                var nextFocus = -1;
                if (!selectValue.length) return;
                switch(direction){
                    case "previous":
                        if (focusedIndex === 0) // don't cycle from the start to the end
                        nextFocus = 0;
                        else if (focusedIndex === -1) // if nothing is focused, focus the last value first
                        nextFocus = lastIndex;
                        else nextFocus = focusedIndex - 1;
                        break;
                    case "next":
                        if (focusedIndex > -1 && focusedIndex < lastIndex) nextFocus = focusedIndex + 1;
                        break;
                }
                this.setState({
                    inputIsHidden: nextFocus !== -1,
                    focusedValue: selectValue[nextFocus]
                });
            }
        },
        {
            key: "focusOption",
            value: function focusOption() {
                var direction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "first";
                var pageSize = this.props.pageSize;
                var focusedOption = this.state.focusedOption;
                var options = this.getFocusableOptions();
                if (!options.length) return;
                var nextFocus = 0; // handles 'first'
                var focusedIndex = options.indexOf(focusedOption);
                if (!focusedOption) focusedIndex = -1;
                if (direction === "up") nextFocus = focusedIndex > 0 ? focusedIndex - 1 : options.length - 1;
                else if (direction === "down") nextFocus = (focusedIndex + 1) % options.length;
                else if (direction === "pageup") {
                    nextFocus = focusedIndex - pageSize;
                    if (nextFocus < 0) nextFocus = 0;
                } else if (direction === "pagedown") {
                    nextFocus = focusedIndex + pageSize;
                    if (nextFocus > options.length - 1) nextFocus = options.length - 1;
                } else if (direction === "last") nextFocus = options.length - 1;
                this.scrollToFocusedOptionOnUpdate = true;
                this.setState({
                    focusedOption: options[nextFocus],
                    focusedValue: null,
                    focusedOptionId: this.getFocusedOptionId(options[nextFocus])
                });
            }
        },
        {
            key: "getTheme",
            value: // ==============================
            // Getters
            // ==============================
            function getTheme() {
                // Use the default theme if there are no customisations.
                if (!this.props.theme) return $4c0cb255ecf8b430$export$4368d992c4eafac0;
                // If the theme prop is a function, assume the function
                // knows how to merge the passed-in default theme with
                // its own modifications.
                if (typeof this.props.theme === "function") return this.props.theme($4c0cb255ecf8b430$export$4368d992c4eafac0);
                // Otherwise, if a plain theme object was passed in,
                // overlay it with the default theme.
                return (0, $lWmb7.default)((0, $lWmb7.default)({}, $4c0cb255ecf8b430$export$4368d992c4eafac0), this.props.theme);
            }
        },
        {
            key: "getCommonProps",
            value: function getCommonProps() {
                var clearValue = this.clearValue, cx = this.cx, getStyles = this.getStyles, getClassNames = this.getClassNames, getValue = this.getValue, selectOption = this.selectOption, setValue = this.setValue, props = this.props;
                var isMulti = props.isMulti, isRtl = props.isRtl, options = props.options;
                var hasValue = this.hasValue();
                return {
                    clearValue: clearValue,
                    cx: cx,
                    getStyles: getStyles,
                    getClassNames: getClassNames,
                    getValue: getValue,
                    hasValue: hasValue,
                    isMulti: isMulti,
                    isRtl: isRtl,
                    options: options,
                    selectOption: selectOption,
                    selectProps: props,
                    setValue: setValue,
                    theme: this.getTheme()
                };
            }
        },
        {
            key: "hasValue",
            value: function hasValue() {
                var selectValue = this.state.selectValue;
                return selectValue.length > 0;
            }
        },
        {
            key: "hasOptions",
            value: function hasOptions() {
                return !!this.getFocusableOptions().length;
            }
        },
        {
            key: "isClearable",
            value: function isClearable() {
                var _this$props7 = this.props, isClearable = _this$props7.isClearable, isMulti = _this$props7.isMulti;
                // single select, by default, IS NOT clearable
                // multi select, by default, IS clearable
                if (isClearable === undefined) return isMulti;
                return isClearable;
            }
        },
        {
            key: "isOptionDisabled",
            value: function isOptionDisabled(option, selectValue) {
                return $4c0cb255ecf8b430$var$_isOptionDisabled(this.props, option, selectValue);
            }
        },
        {
            key: "isOptionSelected",
            value: function isOptionSelected(option, selectValue) {
                return $4c0cb255ecf8b430$var$_isOptionSelected(this.props, option, selectValue);
            }
        },
        {
            key: "filterOption",
            value: function filterOption(option, inputValue) {
                return $4c0cb255ecf8b430$var$_filterOption(this.props, option, inputValue);
            }
        },
        {
            key: "formatOptionLabel",
            value: function formatOptionLabel(data, context) {
                if (typeof this.props.formatOptionLabel === "function") {
                    var _inputValue = this.props.inputValue;
                    var _selectValue = this.state.selectValue;
                    return this.props.formatOptionLabel(data, {
                        context: context,
                        inputValue: _inputValue,
                        selectValue: _selectValue
                    });
                } else return this.getOptionLabel(data);
            }
        },
        {
            key: "formatGroupLabel",
            value: function formatGroupLabel(data) {
                return this.props.formatGroupLabel(data);
            }
        },
        {
            key: "startListeningComposition",
            value: // ==============================
            // Composition Handlers
            // ==============================
            function startListeningComposition() {
                if (document && document.addEventListener) {
                    document.addEventListener("compositionstart", this.onCompositionStart, false);
                    document.addEventListener("compositionend", this.onCompositionEnd, false);
                }
            }
        },
        {
            key: "stopListeningComposition",
            value: function stopListeningComposition() {
                if (document && document.removeEventListener) {
                    document.removeEventListener("compositionstart", this.onCompositionStart);
                    document.removeEventListener("compositionend", this.onCompositionEnd);
                }
            }
        },
        {
            key: "startListeningToTouch",
            value: // ==============================
            // Touch Handlers
            // ==============================
            function startListeningToTouch() {
                if (document && document.addEventListener) {
                    document.addEventListener("touchstart", this.onTouchStart, false);
                    document.addEventListener("touchmove", this.onTouchMove, false);
                    document.addEventListener("touchend", this.onTouchEnd, false);
                }
            }
        },
        {
            key: "stopListeningToTouch",
            value: function stopListeningToTouch() {
                if (document && document.removeEventListener) {
                    document.removeEventListener("touchstart", this.onTouchStart);
                    document.removeEventListener("touchmove", this.onTouchMove);
                    document.removeEventListener("touchend", this.onTouchEnd);
                }
            }
        },
        {
            key: "renderInput",
            value: // ==============================
            // Renderers
            // ==============================
            function renderInput() {
                var _this$props8 = this.props, isDisabled = _this$props8.isDisabled, isSearchable = _this$props8.isSearchable, inputId = _this$props8.inputId, inputValue = _this$props8.inputValue, tabIndex = _this$props8.tabIndex, form = _this$props8.form, menuIsOpen = _this$props8.menuIsOpen, required = _this$props8.required;
                var _this$getComponents = this.getComponents(), Input = _this$getComponents.Input;
                var _this$state4 = this.state, inputIsHidden = _this$state4.inputIsHidden, ariaSelection = _this$state4.ariaSelection;
                var commonProps = this.commonProps;
                var id = inputId || this.getElementId("input");
                // aria attributes makes the JSX "noisy", separated for clarity
                var ariaAttributes = (0, $lWmb7.default)((0, $lWmb7.default)((0, $lWmb7.default)({
                    "aria-autocomplete": "list",
                    "aria-expanded": menuIsOpen,
                    "aria-haspopup": true,
                    "aria-errormessage": this.props["aria-errormessage"],
                    "aria-invalid": this.props["aria-invalid"],
                    "aria-label": this.props["aria-label"],
                    "aria-labelledby": this.props["aria-labelledby"],
                    "aria-required": required,
                    role: "combobox",
                    "aria-activedescendant": this.isAppleDevice ? undefined : this.state.focusedOptionId || ""
                }, menuIsOpen && {
                    "aria-controls": this.getElementId("listbox")
                }), !isSearchable && {
                    "aria-readonly": true
                }), this.hasValue() ? (ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === "initial-input-focus" && {
                    "aria-describedby": this.getElementId("live-region")
                } : {
                    "aria-describedby": this.getElementId("placeholder")
                });
                if (!isSearchable) // use a dummy input to maintain focus/blur functionality
                return /*#__PURE__*/ $dAx5m.createElement($4c0cb255ecf8b430$var$DummyInput, (0, $i6L24.default)({
                    id: id,
                    innerRef: this.getInputRef,
                    onBlur: this.onInputBlur,
                    onChange: (0, $fc2pq.J),
                    onFocus: this.onInputFocus,
                    disabled: isDisabled,
                    tabIndex: tabIndex,
                    inputMode: "none",
                    form: form,
                    value: ""
                }, ariaAttributes));
                return /*#__PURE__*/ $dAx5m.createElement(Input, (0, $i6L24.default)({}, commonProps, {
                    autoCapitalize: "none",
                    autoComplete: "off",
                    autoCorrect: "off",
                    id: id,
                    innerRef: this.getInputRef,
                    isDisabled: isDisabled,
                    isHidden: inputIsHidden,
                    onBlur: this.onInputBlur,
                    onChange: this.handleInputChange,
                    onFocus: this.onInputFocus,
                    spellCheck: "false",
                    tabIndex: tabIndex,
                    form: form,
                    type: "text",
                    value: inputValue
                }, ariaAttributes));
            }
        },
        {
            key: "renderPlaceholderOrValue",
            value: function renderPlaceholderOrValue() {
                var _this3 = this;
                var _this$getComponents2 = this.getComponents(), MultiValue = _this$getComponents2.MultiValue, MultiValueContainer = _this$getComponents2.MultiValueContainer, MultiValueLabel = _this$getComponents2.MultiValueLabel, MultiValueRemove = _this$getComponents2.MultiValueRemove, SingleValue = _this$getComponents2.SingleValue, Placeholder = _this$getComponents2.Placeholder;
                var commonProps = this.commonProps;
                var _this$props9 = this.props, controlShouldRenderValue = _this$props9.controlShouldRenderValue, isDisabled = _this$props9.isDisabled, isMulti = _this$props9.isMulti, inputValue = _this$props9.inputValue, placeholder = _this$props9.placeholder;
                var _this$state5 = this.state, selectValue = _this$state5.selectValue, focusedValue = _this$state5.focusedValue, isFocused = _this$state5.isFocused;
                if (!this.hasValue() || !controlShouldRenderValue) return inputValue ? null : /*#__PURE__*/ $dAx5m.createElement(Placeholder, (0, $i6L24.default)({}, commonProps, {
                    key: "placeholder",
                    isDisabled: isDisabled,
                    isFocused: isFocused,
                    innerProps: {
                        id: this.getElementId("placeholder")
                    }
                }), placeholder);
                if (isMulti) return selectValue.map(function(opt, index) {
                    var isOptionFocused = opt === focusedValue;
                    var key = "".concat(_this3.getOptionLabel(opt), "-").concat(_this3.getOptionValue(opt));
                    return /*#__PURE__*/ $dAx5m.createElement(MultiValue, (0, $i6L24.default)({}, commonProps, {
                        components: {
                            Container: MultiValueContainer,
                            Label: MultiValueLabel,
                            Remove: MultiValueRemove
                        },
                        isFocused: isOptionFocused,
                        isDisabled: isDisabled,
                        key: key,
                        index: index,
                        removeProps: {
                            onClick: function onClick() {
                                return _this3.removeValue(opt);
                            },
                            onTouchEnd: function onTouchEnd() {
                                return _this3.removeValue(opt);
                            },
                            onMouseDown: function onMouseDown(e) {
                                e.preventDefault();
                            }
                        },
                        data: opt
                    }), _this3.formatOptionLabel(opt, "value"));
                });
                if (inputValue) return null;
                var singleValue = selectValue[0];
                return /*#__PURE__*/ $dAx5m.createElement(SingleValue, (0, $i6L24.default)({}, commonProps, {
                    data: singleValue,
                    isDisabled: isDisabled
                }), this.formatOptionLabel(singleValue, "value"));
            }
        },
        {
            key: "renderClearIndicator",
            value: function renderClearIndicator() {
                var _this$getComponents3 = this.getComponents(), ClearIndicator = _this$getComponents3.ClearIndicator;
                var commonProps = this.commonProps;
                var _this$props10 = this.props, isDisabled = _this$props10.isDisabled, isLoading = _this$props10.isLoading;
                var isFocused = this.state.isFocused;
                if (!this.isClearable() || !ClearIndicator || isDisabled || !this.hasValue() || isLoading) return null;
                var innerProps = {
                    onMouseDown: this.onClearIndicatorMouseDown,
                    onTouchEnd: this.onClearIndicatorTouchEnd,
                    "aria-hidden": "true"
                };
                return /*#__PURE__*/ $dAx5m.createElement(ClearIndicator, (0, $i6L24.default)({}, commonProps, {
                    innerProps: innerProps,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderLoadingIndicator",
            value: function renderLoadingIndicator() {
                var _this$getComponents4 = this.getComponents(), LoadingIndicator = _this$getComponents4.LoadingIndicator;
                var commonProps = this.commonProps;
                var _this$props11 = this.props, isDisabled = _this$props11.isDisabled, isLoading = _this$props11.isLoading;
                var isFocused = this.state.isFocused;
                if (!LoadingIndicator || !isLoading) return null;
                var innerProps = {
                    "aria-hidden": "true"
                };
                return /*#__PURE__*/ $dAx5m.createElement(LoadingIndicator, (0, $i6L24.default)({}, commonProps, {
                    innerProps: innerProps,
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderIndicatorSeparator",
            value: function renderIndicatorSeparator() {
                var _this$getComponents5 = this.getComponents(), DropdownIndicator = _this$getComponents5.DropdownIndicator, IndicatorSeparator = _this$getComponents5.IndicatorSeparator;
                // separator doesn't make sense without the dropdown indicator
                if (!DropdownIndicator || !IndicatorSeparator) return null;
                var commonProps = this.commonProps;
                var isDisabled = this.props.isDisabled;
                var isFocused = this.state.isFocused;
                return /*#__PURE__*/ $dAx5m.createElement(IndicatorSeparator, (0, $i6L24.default)({}, commonProps, {
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderDropdownIndicator",
            value: function renderDropdownIndicator() {
                var _this$getComponents6 = this.getComponents(), DropdownIndicator = _this$getComponents6.DropdownIndicator;
                if (!DropdownIndicator) return null;
                var commonProps = this.commonProps;
                var isDisabled = this.props.isDisabled;
                var isFocused = this.state.isFocused;
                var innerProps = {
                    onMouseDown: this.onDropdownIndicatorMouseDown,
                    onTouchEnd: this.onDropdownIndicatorTouchEnd,
                    "aria-hidden": "true"
                };
                return /*#__PURE__*/ $dAx5m.createElement(DropdownIndicator, (0, $i6L24.default)({}, commonProps, {
                    innerProps: innerProps,
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderMenu",
            value: function renderMenu() {
                var _this4 = this;
                var _this$getComponents7 = this.getComponents(), Group = _this$getComponents7.Group, GroupHeading = _this$getComponents7.GroupHeading, Menu = _this$getComponents7.Menu, MenuList = _this$getComponents7.MenuList, MenuPortal = _this$getComponents7.MenuPortal, LoadingMessage = _this$getComponents7.LoadingMessage, NoOptionsMessage = _this$getComponents7.NoOptionsMessage, Option = _this$getComponents7.Option;
                var commonProps = this.commonProps;
                var focusedOption = this.state.focusedOption;
                var _this$props12 = this.props, captureMenuScroll = _this$props12.captureMenuScroll, inputValue = _this$props12.inputValue, isLoading = _this$props12.isLoading, loadingMessage = _this$props12.loadingMessage, minMenuHeight = _this$props12.minMenuHeight, maxMenuHeight = _this$props12.maxMenuHeight, menuIsOpen = _this$props12.menuIsOpen, menuPlacement = _this$props12.menuPlacement, menuPosition = _this$props12.menuPosition, menuPortalTarget = _this$props12.menuPortalTarget, menuShouldBlockScroll = _this$props12.menuShouldBlockScroll, menuShouldScrollIntoView = _this$props12.menuShouldScrollIntoView, noOptionsMessage = _this$props12.noOptionsMessage, onMenuScrollToTop = _this$props12.onMenuScrollToTop, onMenuScrollToBottom = _this$props12.onMenuScrollToBottom;
                if (!menuIsOpen) return null;
                // TODO: Internal Option Type here
                var render = function render(props, id) {
                    var type = props.type, data = props.data, isDisabled = props.isDisabled, isSelected = props.isSelected, label = props.label, value = props.value;
                    var isFocused = focusedOption === data;
                    var onHover = isDisabled ? undefined : function() {
                        return _this4.onOptionHover(data);
                    };
                    var onSelect = isDisabled ? undefined : function() {
                        return _this4.selectOption(data);
                    };
                    var optionId = "".concat(_this4.getElementId("option"), "-").concat(id);
                    var innerProps = {
                        id: optionId,
                        onClick: onSelect,
                        onMouseMove: onHover,
                        onMouseOver: onHover,
                        tabIndex: -1,
                        role: "option",
                        "aria-selected": _this4.isAppleDevice ? undefined : isSelected // is not supported on Apple devices
                    };
                    return /*#__PURE__*/ $dAx5m.createElement(Option, (0, $i6L24.default)({}, commonProps, {
                        innerProps: innerProps,
                        data: data,
                        isDisabled: isDisabled,
                        isSelected: isSelected,
                        key: optionId,
                        label: label,
                        type: type,
                        value: value,
                        isFocused: isFocused,
                        innerRef: isFocused ? _this4.getFocusedOptionRef : undefined
                    }), _this4.formatOptionLabel(props.data, "menu"));
                };
                var menuUI;
                if (this.hasOptions()) menuUI = this.getCategorizedOptions().map(function(item) {
                    if (item.type === "group") {
                        var _data = item.data, options = item.options, groupIndex = item.index;
                        var groupId = "".concat(_this4.getElementId("group"), "-").concat(groupIndex);
                        var headingId = "".concat(groupId, "-heading");
                        return /*#__PURE__*/ $dAx5m.createElement(Group, (0, $i6L24.default)({}, commonProps, {
                            key: groupId,
                            data: _data,
                            options: options,
                            Heading: GroupHeading,
                            headingProps: {
                                id: headingId,
                                data: item.data
                            },
                            label: _this4.formatGroupLabel(item.data)
                        }), item.options.map(function(option) {
                            return render(option, "".concat(groupIndex, "-").concat(option.index));
                        }));
                    } else if (item.type === "option") return render(item, "".concat(item.index));
                });
                else if (isLoading) {
                    var message = loadingMessage({
                        inputValue: inputValue
                    });
                    if (message === null) return null;
                    menuUI = /*#__PURE__*/ $dAx5m.createElement(LoadingMessage, commonProps, message);
                } else {
                    var _message = noOptionsMessage({
                        inputValue: inputValue
                    });
                    if (_message === null) return null;
                    menuUI = /*#__PURE__*/ $dAx5m.createElement(NoOptionsMessage, commonProps, _message);
                }
                var menuPlacementProps = {
                    minMenuHeight: minMenuHeight,
                    maxMenuHeight: maxMenuHeight,
                    menuPlacement: menuPlacement,
                    menuPosition: menuPosition,
                    menuShouldScrollIntoView: menuShouldScrollIntoView
                };
                var menuElement = /*#__PURE__*/ $dAx5m.createElement((0, $fc2pq.M), (0, $i6L24.default)({}, commonProps, menuPlacementProps), function(_ref4) {
                    var ref = _ref4.ref, _ref4$placerProps = _ref4.placerProps, placement = _ref4$placerProps.placement, maxHeight = _ref4$placerProps.maxHeight;
                    return /*#__PURE__*/ $dAx5m.createElement(Menu, (0, $i6L24.default)({}, commonProps, menuPlacementProps, {
                        innerRef: ref,
                        innerProps: {
                            onMouseDown: _this4.onMenuMouseDown,
                            onMouseMove: _this4.onMenuMouseMove
                        },
                        isLoading: isLoading,
                        placement: placement
                    }), /*#__PURE__*/ $dAx5m.createElement($4c0cb255ecf8b430$var$ScrollManager, {
                        captureEnabled: captureMenuScroll,
                        onTopArrive: onMenuScrollToTop,
                        onBottomArrive: onMenuScrollToBottom,
                        lockEnabled: menuShouldBlockScroll
                    }, function(scrollTargetRef) {
                        return /*#__PURE__*/ $dAx5m.createElement(MenuList, (0, $i6L24.default)({}, commonProps, {
                            innerRef: function innerRef(instance) {
                                _this4.getMenuListRef(instance);
                                scrollTargetRef(instance);
                            },
                            innerProps: {
                                role: "listbox",
                                "aria-multiselectable": commonProps.isMulti,
                                id: _this4.getElementId("listbox")
                            },
                            isLoading: isLoading,
                            maxHeight: maxHeight,
                            focusedOption: focusedOption
                        }), menuUI);
                    }));
                });
                // positioning behaviour is almost identical for portalled and fixed,
                // so we use the same component. the actual portalling logic is forked
                // within the component based on `menuPosition`
                return menuPortalTarget || menuPosition === "fixed" ? /*#__PURE__*/ $dAx5m.createElement(MenuPortal, (0, $i6L24.default)({}, commonProps, {
                    appendTo: menuPortalTarget,
                    controlElement: this.controlRef,
                    menuPlacement: menuPlacement,
                    menuPosition: menuPosition
                }), menuElement) : menuElement;
            }
        },
        {
            key: "renderFormField",
            value: function renderFormField() {
                var _this5 = this;
                var _this$props13 = this.props, delimiter = _this$props13.delimiter, isDisabled = _this$props13.isDisabled, isMulti = _this$props13.isMulti, name = _this$props13.name, required = _this$props13.required;
                var selectValue = this.state.selectValue;
                if (required && !this.hasValue() && !isDisabled) return /*#__PURE__*/ $dAx5m.createElement($4c0cb255ecf8b430$var$RequiredInput$1, {
                    name: name,
                    onFocus: this.onValueInputFocus
                });
                if (!name || isDisabled) return;
                if (isMulti) {
                    if (delimiter) {
                        var value = selectValue.map(function(opt) {
                            return _this5.getOptionValue(opt);
                        }).join(delimiter);
                        return /*#__PURE__*/ $dAx5m.createElement("input", {
                            name: name,
                            type: "hidden",
                            value: value
                        });
                    } else {
                        var input = selectValue.length > 0 ? selectValue.map(function(opt, i) {
                            return /*#__PURE__*/ $dAx5m.createElement("input", {
                                key: "i-".concat(i),
                                name: name,
                                type: "hidden",
                                value: _this5.getOptionValue(opt)
                            });
                        }) : /*#__PURE__*/ $dAx5m.createElement("input", {
                            name: name,
                            type: "hidden",
                            value: ""
                        });
                        return /*#__PURE__*/ $dAx5m.createElement("div", null, input);
                    }
                } else {
                    var _value = selectValue[0] ? this.getOptionValue(selectValue[0]) : "";
                    return /*#__PURE__*/ $dAx5m.createElement("input", {
                        name: name,
                        type: "hidden",
                        value: _value
                    });
                }
            }
        },
        {
            key: "renderLiveRegion",
            value: function renderLiveRegion() {
                var commonProps = this.commonProps;
                var _this$state6 = this.state, ariaSelection = _this$state6.ariaSelection, focusedOption = _this$state6.focusedOption, focusedValue = _this$state6.focusedValue, isFocused = _this$state6.isFocused, selectValue = _this$state6.selectValue;
                var focusableOptions = this.getFocusableOptions();
                return /*#__PURE__*/ $dAx5m.createElement($4c0cb255ecf8b430$var$LiveRegion$1, (0, $i6L24.default)({}, commonProps, {
                    id: this.getElementId("live-region"),
                    ariaSelection: ariaSelection,
                    focusedOption: focusedOption,
                    focusedValue: focusedValue,
                    isFocused: isFocused,
                    selectValue: selectValue,
                    focusableOptions: focusableOptions,
                    isAppleDevice: this.isAppleDevice
                }));
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$getComponents8 = this.getComponents(), Control = _this$getComponents8.Control, IndicatorsContainer = _this$getComponents8.IndicatorsContainer, SelectContainer = _this$getComponents8.SelectContainer, ValueContainer = _this$getComponents8.ValueContainer;
                var _this$props14 = this.props, className = _this$props14.className, id = _this$props14.id, isDisabled = _this$props14.isDisabled, menuIsOpen = _this$props14.menuIsOpen;
                var isFocused = this.state.isFocused;
                var commonProps = this.commonProps = this.getCommonProps();
                return /*#__PURE__*/ $dAx5m.createElement(SelectContainer, (0, $i6L24.default)({}, commonProps, {
                    className: className,
                    innerProps: {
                        id: id,
                        onKeyDown: this.onKeyDown
                    },
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }), this.renderLiveRegion(), /*#__PURE__*/ $dAx5m.createElement(Control, (0, $i6L24.default)({}, commonProps, {
                    innerRef: this.getControlRef,
                    innerProps: {
                        onMouseDown: this.onControlMouseDown,
                        onTouchEnd: this.onControlTouchEnd
                    },
                    isDisabled: isDisabled,
                    isFocused: isFocused,
                    menuIsOpen: menuIsOpen
                }), /*#__PURE__*/ $dAx5m.createElement(ValueContainer, (0, $i6L24.default)({}, commonProps, {
                    isDisabled: isDisabled
                }), this.renderPlaceholderOrValue(), this.renderInput()), /*#__PURE__*/ $dAx5m.createElement(IndicatorsContainer, (0, $i6L24.default)({}, commonProps, {
                    isDisabled: isDisabled
                }), this.renderClearIndicator(), this.renderLoadingIndicator(), this.renderIndicatorSeparator(), this.renderDropdownIndicator())), this.renderMenu(), this.renderFormField());
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(props, state) {
                var prevProps = state.prevProps, clearFocusValueOnUpdate = state.clearFocusValueOnUpdate, inputIsHiddenAfterUpdate = state.inputIsHiddenAfterUpdate, ariaSelection = state.ariaSelection, isFocused = state.isFocused, prevWasFocused = state.prevWasFocused, instancePrefix = state.instancePrefix;
                var options = props.options, value = props.value, menuIsOpen = props.menuIsOpen, inputValue = props.inputValue, isMulti = props.isMulti;
                var selectValue = (0, $fc2pq.H)(value);
                var newMenuOptionsState = {};
                if (prevProps && (value !== prevProps.value || options !== prevProps.options || menuIsOpen !== prevProps.menuIsOpen || inputValue !== prevProps.inputValue)) {
                    var focusableOptions = menuIsOpen ? $4c0cb255ecf8b430$var$buildFocusableOptions(props, selectValue) : [];
                    var focusableOptionsWithIds = menuIsOpen ? $4c0cb255ecf8b430$var$buildFocusableOptionsWithIds($4c0cb255ecf8b430$var$buildCategorizedOptions(props, selectValue), "".concat(instancePrefix, "-option")) : [];
                    var focusedValue = clearFocusValueOnUpdate ? $4c0cb255ecf8b430$var$getNextFocusedValue(state, selectValue) : null;
                    var focusedOption = $4c0cb255ecf8b430$var$getNextFocusedOption(state, focusableOptions);
                    var focusedOptionId = $4c0cb255ecf8b430$var$getFocusedOptionId(focusableOptionsWithIds, focusedOption);
                    newMenuOptionsState = {
                        selectValue: selectValue,
                        focusedOption: focusedOption,
                        focusedOptionId: focusedOptionId,
                        focusableOptionsWithIds: focusableOptionsWithIds,
                        focusedValue: focusedValue,
                        clearFocusValueOnUpdate: false
                    };
                }
                // some updates should toggle the state of the input visibility
                var newInputIsHiddenState = inputIsHiddenAfterUpdate != null && props !== prevProps ? {
                    inputIsHidden: inputIsHiddenAfterUpdate,
                    inputIsHiddenAfterUpdate: undefined
                } : {};
                var newAriaSelection = ariaSelection;
                var hasKeptFocus = isFocused && prevWasFocused;
                if (isFocused && !hasKeptFocus) {
                    // If `value` or `defaultValue` props are not empty then announce them
                    // when the Select is initially focused
                    newAriaSelection = {
                        value: (0, $fc2pq.D)(isMulti, selectValue, selectValue[0] || null),
                        options: selectValue,
                        action: "initial-input-focus"
                    };
                    hasKeptFocus = !prevWasFocused;
                }
                // If the 'initial-input-focus' action has been set already
                // then reset the ariaSelection to null
                if ((ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === "initial-input-focus") newAriaSelection = null;
                return (0, $lWmb7.default)((0, $lWmb7.default)((0, $lWmb7.default)({}, newMenuOptionsState), newInputIsHiddenState), {}, {
                    prevProps: props,
                    ariaSelection: newAriaSelection,
                    prevWasFocused: hasKeptFocus
                });
            }
        }
    ]);
    return Select;
}((0, $dAx5m.Component));
$4c0cb255ecf8b430$export$25ce5a424b770e84.defaultProps = $4c0cb255ecf8b430$export$407448d2b89b1813;

});
parcelRegister("3Ez4j", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2a904f650d9fa2ef$export$2e2bcd8739ae039; });
function $2a904f650d9fa2ef$export$2e2bcd8739ae039(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}

});

parcelRegister("5JW2y", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $42de2d45bbb91267$export$2e2bcd8739ae039; });

var $3ZtVs = parcelRequire("3ZtVs");
function $42de2d45bbb91267$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, (0, $3ZtVs.default)(o.key), o);
    }
}
function $42de2d45bbb91267$export$2e2bcd8739ae039(e, r, t) {
    return r && $42de2d45bbb91267$var$_defineProperties(e.prototype, r), t && $42de2d45bbb91267$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}

});

parcelRegister("bTgpJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8a81903aa2faa241$export$2e2bcd8739ae039; });

var $49lCG = parcelRequire("49lCG");
function $8a81903aa2faa241$export$2e2bcd8739ae039(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && (0, $49lCG.default)(t, e);
}

});
parcelRegister("49lCG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3058c68a16c2330d$export$2e2bcd8739ae039; });
function $3058c68a16c2330d$export$2e2bcd8739ae039(t, e) {
    return $3058c68a16c2330d$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $3058c68a16c2330d$export$2e2bcd8739ae039(t, e);
}

});


parcelRegister("KsTfi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $08bab4f4fd7fbf66$export$2e2bcd8739ae039; });

var $2dxeu = parcelRequire("2dxeu");

var $8zXZI = parcelRequire("8zXZI");

var $2ToW4 = parcelRequire("2ToW4");
function $08bab4f4fd7fbf66$export$2e2bcd8739ae039(t) {
    var r = (0, $8zXZI.default)();
    return function() {
        var e, o = (0, $2dxeu.default)(t);
        if (r) {
            var s = (0, $2dxeu.default)(this).constructor;
            e = Reflect.construct(o, arguments, s);
        } else e = o.apply(this, arguments);
        return (0, $2ToW4.default)(this, e);
    };
}

});
parcelRegister("2dxeu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $19d692fae32d5f7a$export$2e2bcd8739ae039; });
function $19d692fae32d5f7a$export$2e2bcd8739ae039(t) {
    return $19d692fae32d5f7a$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, $19d692fae32d5f7a$export$2e2bcd8739ae039(t);
}

});

parcelRegister("8zXZI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $63f021444946d487$export$2e2bcd8739ae039; });
function $63f021444946d487$export$2e2bcd8739ae039() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($63f021444946d487$export$2e2bcd8739ae039 = function _isNativeReflectConstruct() {
        return !!t;
    })();
}

});

parcelRegister("2ToW4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $21b40f82c4d171d7$export$2e2bcd8739ae039; });

var $9f2pJ = parcelRequire("9f2pJ");

var $iSRFR = parcelRequire("iSRFR");
function $21b40f82c4d171d7$export$2e2bcd8739ae039(t, e) {
    if (e && ("object" == (0, $9f2pJ.default)(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return (0, $iSRFR.default)(t);
}

});
parcelRegister("iSRFR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dbf6e7b17414ba6e$export$2e2bcd8739ae039; });
function $dbf6e7b17414ba6e$export$2e2bcd8739ae039(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}

});



parcelRegister("jPOzM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e70a03194474bef0$export$2e2bcd8739ae039; });

var $7nI0K = parcelRequire("7nI0K");

var $hHo65 = parcelRequire("hHo65");

var $bxBqk = parcelRequire("bxBqk");

var $dqTxD = parcelRequire("dqTxD");
function $e70a03194474bef0$export$2e2bcd8739ae039(r) {
    return (0, $7nI0K.default)(r) || (0, $hHo65.default)(r) || (0, $bxBqk.default)(r) || (0, $dqTxD.default)();
}

});
parcelRegister("7nI0K", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $55fcd20ac71cabb9$export$2e2bcd8739ae039; });

var $iK4tD = parcelRequire("iK4tD");
function $55fcd20ac71cabb9$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return (0, $iK4tD.default)(r);
}

});

parcelRegister("hHo65", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ce2924ff84c380ba$export$2e2bcd8739ae039; });
function $ce2924ff84c380ba$export$2e2bcd8739ae039(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}

});

parcelRegister("dqTxD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9c78c9707100335d$export$2e2bcd8739ae039; });
function $9c78c9707100335d$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("fc2pq", function(module, exports) {

$parcel$export(module.exports, "J", function () { return $b0f9d86086831776$export$b4171a6734a65d42; });
$parcel$export(module.exports, "E", function () { return $b0f9d86086831776$export$a9c23c6ac3fc3eca; });
$parcel$export(module.exports, "H", function () { return $b0f9d86086831776$export$7f8ddf7c7c20b3cd; });
$parcel$export(module.exports, "G", function () { return $b0f9d86086831776$export$2329c99376c9d0a4; });
$parcel$export(module.exports, "I", function () { return $b0f9d86086831776$export$9bb611d729802a56; });
$parcel$export(module.exports, "z", function () { return $b0f9d86086831776$export$df995fae86a55f06; });
$parcel$export(module.exports, "A", function () { return $b0f9d86086831776$export$ebd11618f299a286; });
$parcel$export(module.exports, "s", function () { return $b0f9d86086831776$export$2408f22a0fab9ae5; });
$parcel$export(module.exports, "K", function () { return $b0f9d86086831776$export$3466f893ebf79586; });
$parcel$export(module.exports, "D", function () { return $b0f9d86086831776$export$96f57966bedc81b4; });
$parcel$export(module.exports, "C", function () { return $b0f9d86086831776$export$e7094788287c5e9b; });
$parcel$export(module.exports, "B", function () { return $b0f9d86086831776$export$ef35774e6d314e91; });
$parcel$export(module.exports, "r", function () { return $b0f9d86086831776$export$43caf9889c228507; });
$parcel$export(module.exports, "m", function () { return $b0f9d86086831776$export$953cecd6e717a553; });
$parcel$export(module.exports, "M", function () { return $b0f9d86086831776$export$3a1a48c8f6ef640e; });
$parcel$export(module.exports, "n", function () { return $b0f9d86086831776$export$7ccc53e8f1e7dfc5; });
$parcel$export(module.exports, "u", function () { return $b0f9d86086831776$export$3b14a55fb2447963; });
$parcel$export(module.exports, "k", function () { return $b0f9d86086831776$export$342063e11d6c3cad; });
$parcel$export(module.exports, "o", function () { return $b0f9d86086831776$export$ae1af26003f05816; });
$parcel$export(module.exports, "b", function () { return $b0f9d86086831776$export$8b22cf2602fb60ce; });
$parcel$export(module.exports, "y", function () { return $b0f9d86086831776$export$4a5767248b18ef41; });
$parcel$export(module.exports, "i", function () { return $b0f9d86086831776$export$23f2a1d2818174ef; });
$parcel$export(module.exports, "e", function () { return $b0f9d86086831776$export$f1e1789686576879; });
$parcel$export(module.exports, "a", function () { return $b0f9d86086831776$export$407448d2b89b1813; });
$parcel$export(module.exports, "h", function () { return $b0f9d86086831776$export$dda1d9f60106f0e9; });
$parcel$export(module.exports, "l", function () { return $b0f9d86086831776$export$882b5998b3b9117c; });
$parcel$export(module.exports, "d", function () { return $b0f9d86086831776$export$4368d992c4eafac0; });
$parcel$export(module.exports, "g", function () { return $b0f9d86086831776$export$39b482c5e57630a8; });
$parcel$export(module.exports, "f", function () { return $b0f9d86086831776$export$2d1720544b23b823; });
$parcel$export(module.exports, "j", function () { return $b0f9d86086831776$export$35e795649ee09318; });
$parcel$export(module.exports, "p", function () { return $b0f9d86086831776$export$ffb5f4729a158638; });
$parcel$export(module.exports, "q", function () { return $b0f9d86086831776$export$9e5f44173e64f162; });
$parcel$export(module.exports, "t", function () { return $b0f9d86086831776$export$625550452a3fa3ec; });
$parcel$export(module.exports, "v", function () { return $b0f9d86086831776$export$90a7f3efeed30595; });
$parcel$export(module.exports, "w", function () { return $b0f9d86086831776$export$efccba1c4a2ef57b; });
$parcel$export(module.exports, "x", function () { return $b0f9d86086831776$export$d141bba7fdc215a3; });
$parcel$export(module.exports, "c", function () { return $b0f9d86086831776$export$db3b6bfb95261072; });
$parcel$export(module.exports, "F", function () { return $b0f9d86086831776$export$d66501df72047452; });

var $lWmb7 = parcelRequire("lWmb7");

var $i6L24 = parcelRequire("i6L24");

var $jVTBW = parcelRequire("jVTBW");

var $8Y5h3 = parcelRequire("8Y5h3");

var $3ci4f = parcelRequire("3ci4f");

var $9f2pJ = parcelRequire("9f2pJ");

var $1TUQY = parcelRequire("1TUQY");

var $fZJbz = parcelRequire("fZJbz");

var $dAx5m = parcelRequire("dAx5m");

var $1MpXQ = parcelRequire("1MpXQ");

var $9Hxa6 = parcelRequire("9Hxa6");

var $3k7Ry = parcelRequire("3k7Ry");
var $b0f9d86086831776$var$_excluded$4 = [
    "className",
    "clearValue",
    "cx",
    "getStyles",
    "getClassNames",
    "getValue",
    "hasValue",
    "isMulti",
    "isRtl",
    "options",
    "selectOption",
    "selectProps",
    "setValue",
    "theme"
];
// ==============================
// NO OP
// ==============================
var $b0f9d86086831776$export$b4171a6734a65d42 = function noop() {};
// ==============================
// Class Name Prefixer
// ==============================
/**
 String representation of component state for styling with class names.

 Expects an array of strings OR a string/object pair:
 - className(['comp', 'comp-arg', 'comp-arg-2'])
   @returns 'react-select__comp react-select__comp-arg react-select__comp-arg-2'
 - className('comp', { some: true, state: false })
   @returns 'react-select__comp react-select__comp--some'
*/ function $b0f9d86086831776$var$applyPrefixToName(prefix, name) {
    if (!name) return prefix;
    else if (name[0] === "-") return prefix + name;
    else return prefix + "__" + name;
}
function $b0f9d86086831776$export$a9c23c6ac3fc3eca(prefix, state) {
    for(var _len = arguments.length, classNameList = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)classNameList[_key - 2] = arguments[_key];
    var arr = [].concat(classNameList);
    if (state && prefix) {
        for(var key in state)if (state.hasOwnProperty(key) && state[key]) arr.push("".concat($b0f9d86086831776$var$applyPrefixToName(prefix, key)));
    }
    return arr.filter(function(i) {
        return i;
    }).map(function(i) {
        return String(i).trim();
    }).join(" ");
}
// ==============================
// Clean Value
// ==============================
var $b0f9d86086831776$export$7f8ddf7c7c20b3cd = function cleanValue(value) {
    if ($b0f9d86086831776$var$isArray(value)) return value.filter(Boolean);
    if ((0, $9f2pJ.default)(value) === "object" && value !== null) return [
        value
    ];
    return [];
};
// ==============================
// Clean Common Props
// ==============================
var $b0f9d86086831776$var$cleanCommonProps = function cleanCommonProps(props) {
    //className
    props.className;
    props.clearValue;
    props.cx;
    props.getStyles;
    props.getClassNames;
    props.getValue;
    props.hasValue;
    props.isMulti;
    props.isRtl;
    props.options;
    props.selectOption;
    props.selectProps;
    props.setValue;
    props.theme;
    var innerProps = (0, $3ci4f.default)(props, $b0f9d86086831776$var$_excluded$4);
    return (0, $lWmb7.default)({}, innerProps);
};
// ==============================
// Get Style Props
// ==============================
var $b0f9d86086831776$var$getStyleProps = function getStyleProps(props, name, classNamesState) {
    var cx = props.cx, getStyles = props.getStyles, getClassNames = props.getClassNames, className = props.className;
    return {
        css: getStyles(name, props),
        className: cx(classNamesState !== null && classNamesState !== void 0 ? classNamesState : {}, getClassNames(name, props), className)
    };
};
// ==============================
// Handle Input Change
// ==============================
function $b0f9d86086831776$export$61196ced6d74a310(inputValue, actionMeta, onInputChange) {
    if (onInputChange) {
        var _newValue = onInputChange(inputValue, actionMeta);
        if (typeof _newValue === "string") return _newValue;
    }
    return inputValue;
}
// ==============================
// Scroll Helpers
// ==============================
function $b0f9d86086831776$export$2329c99376c9d0a4(el) {
    return [
        document.documentElement,
        document.body,
        window
    ].indexOf(el) > -1;
}
// Normalized Scroll Top
// ------------------------------
function $b0f9d86086831776$var$normalizedHeight(el) {
    if ($b0f9d86086831776$export$2329c99376c9d0a4(el)) return window.innerHeight;
    return el.clientHeight;
}
// Normalized scrollTo & scrollTop
// ------------------------------
function $b0f9d86086831776$var$getScrollTop(el) {
    if ($b0f9d86086831776$export$2329c99376c9d0a4(el)) return window.pageYOffset;
    return el.scrollTop;
}
function $b0f9d86086831776$var$scrollTo(el, top) {
    // with a scroll distance, we perform scroll on the element
    if ($b0f9d86086831776$export$2329c99376c9d0a4(el)) {
        window.scrollTo(0, top);
        return;
    }
    el.scrollTop = top;
}
// Get Scroll Parent
// ------------------------------
function $b0f9d86086831776$var$getScrollParent(element) {
    var style = getComputedStyle(element);
    var excludeStaticParent = style.position === "absolute";
    var overflowRx = /(auto|scroll)/;
    if (style.position === "fixed") return document.documentElement;
    for(var parent = element; parent = parent.parentElement;){
        style = getComputedStyle(parent);
        if (excludeStaticParent && style.position === "static") continue;
        if (overflowRx.test(style.overflow + style.overflowY + style.overflowX)) return parent;
    }
    return document.documentElement;
}
// Animated Scroll To
// ------------------------------
/**
  @param t: time (elapsed)
  @param b: initial value
  @param c: amount of change
  @param d: duration
*/ function $b0f9d86086831776$var$easeOutCubic(t, b, c, d) {
    return c * ((t = t / d - 1) * t * t + 1) + b;
}
function $b0f9d86086831776$var$animatedScrollTo(element, to) {
    var duration = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 200;
    var callback = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : $b0f9d86086831776$export$b4171a6734a65d42;
    var start = $b0f9d86086831776$var$getScrollTop(element);
    var change = to - start;
    var increment = 10;
    var currentTime = 0;
    function animateScroll() {
        currentTime += increment;
        var val = $b0f9d86086831776$var$easeOutCubic(currentTime, start, change, duration);
        $b0f9d86086831776$var$scrollTo(element, val);
        if (currentTime < duration) window.requestAnimationFrame(animateScroll);
        else callback(element);
    }
    animateScroll();
}
// Scroll Into View
// ------------------------------
function $b0f9d86086831776$export$9bb611d729802a56(menuEl, focusedEl) {
    var menuRect = menuEl.getBoundingClientRect();
    var focusedRect = focusedEl.getBoundingClientRect();
    var overScroll = focusedEl.offsetHeight / 3;
    if (focusedRect.bottom + overScroll > menuRect.bottom) $b0f9d86086831776$var$scrollTo(menuEl, Math.min(focusedEl.offsetTop + focusedEl.clientHeight - menuEl.offsetHeight + overScroll, menuEl.scrollHeight));
    else if (focusedRect.top - overScroll < menuRect.top) $b0f9d86086831776$var$scrollTo(menuEl, Math.max(focusedEl.offsetTop - overScroll, 0));
}
// ==============================
// Get bounding client object
// ==============================
// cannot get keys using array notation with DOMRect
function $b0f9d86086831776$var$getBoundingClientObj(element) {
    var rect = element.getBoundingClientRect();
    return {
        bottom: rect.bottom,
        height: rect.height,
        left: rect.left,
        right: rect.right,
        top: rect.top,
        width: rect.width
    };
}
// ==============================
// Touch Capability Detector
// ==============================
function $b0f9d86086831776$export$df995fae86a55f06() {
    try {
        document.createEvent("TouchEvent");
        return true;
    } catch (e) {
        return false;
    }
}
// ==============================
// Mobile Device Detector
// ==============================
function $b0f9d86086831776$export$ebd11618f299a286() {
    try {
        return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    } catch (e) {
        return false;
    }
}
// ==============================
// Passive Event Detector
// ==============================
// https://github.com/rafgraph/detect-it/blob/main/src/index.ts#L19-L36
var $b0f9d86086831776$var$passiveOptionAccessed = false;
var $b0f9d86086831776$var$options = {
    get passive () {
        return $b0f9d86086831776$var$passiveOptionAccessed = true;
    }
};
// check for SSR
var $b0f9d86086831776$var$w = typeof window !== "undefined" ? window : {};
if ($b0f9d86086831776$var$w.addEventListener && $b0f9d86086831776$var$w.removeEventListener) {
    $b0f9d86086831776$var$w.addEventListener("p", $b0f9d86086831776$export$b4171a6734a65d42, $b0f9d86086831776$var$options);
    $b0f9d86086831776$var$w.removeEventListener("p", $b0f9d86086831776$export$b4171a6734a65d42, false);
}
var $b0f9d86086831776$export$2408f22a0fab9ae5 = $b0f9d86086831776$var$passiveOptionAccessed;
function $b0f9d86086831776$export$3466f893ebf79586(item) {
    return item != null;
}
function $b0f9d86086831776$var$isArray(arg) {
    return Array.isArray(arg);
}
function $b0f9d86086831776$export$96f57966bedc81b4(isMulti, multiValue, singleValue) {
    return isMulti ? multiValue : singleValue;
}
function $b0f9d86086831776$export$e7094788287c5e9b(singleValue) {
    return singleValue;
}
function $b0f9d86086831776$export$ef35774e6d314e91(multiValue) {
    return multiValue;
}
var $b0f9d86086831776$export$43caf9889c228507 = function removeProps(propsObj) {
    for(var _len2 = arguments.length, properties = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)properties[_key2 - 1] = arguments[_key2];
    var propsMap = Object.entries(propsObj).filter(function(_ref) {
        var _ref2 = (0, $8Y5h3.default)(_ref, 1), key = _ref2[0];
        return !properties.includes(key);
    });
    return propsMap.reduce(function(newProps, _ref3) {
        var _ref4 = (0, $8Y5h3.default)(_ref3, 2), key = _ref4[0], val = _ref4[1];
        newProps[key] = val;
        return newProps;
    }, {});
};
var $b0f9d86086831776$var$_excluded$3 = [
    "children",
    "innerProps"
], $b0f9d86086831776$var$_excluded2$1 = [
    "children",
    "innerProps"
];
function $b0f9d86086831776$var$getMenuPlacement(_ref) {
    var preferredMaxHeight = _ref.maxHeight, menuEl = _ref.menuEl, minHeight = _ref.minHeight, preferredPlacement = _ref.placement, shouldScroll = _ref.shouldScroll, isFixedPosition = _ref.isFixedPosition, controlHeight = _ref.controlHeight;
    var scrollParent = $b0f9d86086831776$var$getScrollParent(menuEl);
    var defaultState = {
        placement: "bottom",
        maxHeight: preferredMaxHeight
    };
    // something went wrong, return default state
    if (!menuEl || !menuEl.offsetParent) return defaultState;
    // we can't trust `scrollParent.scrollHeight` --> it may increase when
    // the menu is rendered
    var _scrollParent$getBoun = scrollParent.getBoundingClientRect(), scrollHeight = _scrollParent$getBoun.height;
    var _menuEl$getBoundingCl = menuEl.getBoundingClientRect(), menuBottom = _menuEl$getBoundingCl.bottom, menuHeight = _menuEl$getBoundingCl.height, menuTop = _menuEl$getBoundingCl.top;
    var _menuEl$offsetParent$ = menuEl.offsetParent.getBoundingClientRect(), containerTop = _menuEl$offsetParent$.top;
    var viewHeight = isFixedPosition ? window.innerHeight : $b0f9d86086831776$var$normalizedHeight(scrollParent);
    var scrollTop = $b0f9d86086831776$var$getScrollTop(scrollParent);
    var marginBottom = parseInt(getComputedStyle(menuEl).marginBottom, 10);
    var marginTop = parseInt(getComputedStyle(menuEl).marginTop, 10);
    var viewSpaceAbove = containerTop - marginTop;
    var viewSpaceBelow = viewHeight - menuTop;
    var scrollSpaceAbove = viewSpaceAbove + scrollTop;
    var scrollSpaceBelow = scrollHeight - scrollTop - menuTop;
    var scrollDown = menuBottom - viewHeight + scrollTop + marginBottom;
    var scrollUp = scrollTop + menuTop - marginTop;
    var scrollDuration = 160;
    switch(preferredPlacement){
        case "auto":
        case "bottom":
            // 1: the menu will fit, do nothing
            if (viewSpaceBelow >= menuHeight) return {
                placement: "bottom",
                maxHeight: preferredMaxHeight
            };
            // 2: the menu will fit, if scrolled
            if (scrollSpaceBelow >= menuHeight && !isFixedPosition) {
                if (shouldScroll) $b0f9d86086831776$var$animatedScrollTo(scrollParent, scrollDown, scrollDuration);
                return {
                    placement: "bottom",
                    maxHeight: preferredMaxHeight
                };
            }
            // 3: the menu will fit, if constrained
            if (!isFixedPosition && scrollSpaceBelow >= minHeight || isFixedPosition && viewSpaceBelow >= minHeight) {
                if (shouldScroll) $b0f9d86086831776$var$animatedScrollTo(scrollParent, scrollDown, scrollDuration);
                // we want to provide as much of the menu as possible to the user,
                // so give them whatever is available below rather than the minHeight.
                var constrainedHeight = isFixedPosition ? viewSpaceBelow - marginBottom : scrollSpaceBelow - marginBottom;
                return {
                    placement: "bottom",
                    maxHeight: constrainedHeight
                };
            }
            // 4. Forked beviour when there isn't enough space below
            // AUTO: flip the menu, render above
            if (preferredPlacement === "auto" || isFixedPosition) {
                // may need to be constrained after flipping
                var _constrainedHeight = preferredMaxHeight;
                var spaceAbove = isFixedPosition ? viewSpaceAbove : scrollSpaceAbove;
                if (spaceAbove >= minHeight) _constrainedHeight = Math.min(spaceAbove - marginBottom - controlHeight, preferredMaxHeight);
                return {
                    placement: "top",
                    maxHeight: _constrainedHeight
                };
            }
            // BOTTOM: allow browser to increase scrollable area and immediately set scroll
            if (preferredPlacement === "bottom") {
                if (shouldScroll) $b0f9d86086831776$var$scrollTo(scrollParent, scrollDown);
                return {
                    placement: "bottom",
                    maxHeight: preferredMaxHeight
                };
            }
            break;
        case "top":
            // 1: the menu will fit, do nothing
            if (viewSpaceAbove >= menuHeight) return {
                placement: "top",
                maxHeight: preferredMaxHeight
            };
            // 2: the menu will fit, if scrolled
            if (scrollSpaceAbove >= menuHeight && !isFixedPosition) {
                if (shouldScroll) $b0f9d86086831776$var$animatedScrollTo(scrollParent, scrollUp, scrollDuration);
                return {
                    placement: "top",
                    maxHeight: preferredMaxHeight
                };
            }
            // 3: the menu will fit, if constrained
            if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) {
                var _constrainedHeight2 = preferredMaxHeight;
                // we want to provide as much of the menu as possible to the user,
                // so give them whatever is available below rather than the minHeight.
                if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) _constrainedHeight2 = isFixedPosition ? viewSpaceAbove - marginTop : scrollSpaceAbove - marginTop;
                if (shouldScroll) $b0f9d86086831776$var$animatedScrollTo(scrollParent, scrollUp, scrollDuration);
                return {
                    placement: "top",
                    maxHeight: _constrainedHeight2
                };
            }
            // 4. not enough space, the browser WILL NOT increase scrollable area when
            // absolutely positioned element rendered above the viewport (only below).
            // Flip the menu, render below
            return {
                placement: "bottom",
                maxHeight: preferredMaxHeight
            };
        default:
            throw new Error('Invalid placement provided "'.concat(preferredPlacement, '".'));
    }
    return defaultState;
}
// Menu Component
// ------------------------------
function $b0f9d86086831776$var$alignToControl(placement) {
    var placementToCSSProp = {
        bottom: "top",
        top: "bottom"
    };
    return placement ? placementToCSSProp[placement] : "bottom";
}
var $b0f9d86086831776$var$coercePlacement = function coercePlacement(p) {
    return p === "auto" ? "bottom" : p;
};
var $b0f9d86086831776$export$953cecd6e717a553 = function menuCSS(_ref2, unstyled) {
    var _objectSpread2;
    var placement = _ref2.placement, _ref2$theme = _ref2.theme, borderRadius = _ref2$theme.borderRadius, spacing = _ref2$theme.spacing, colors = _ref2$theme.colors;
    return (0, $lWmb7.default)((_objectSpread2 = {
        label: "menu"
    }, (0, $fZJbz.default)(_objectSpread2, $b0f9d86086831776$var$alignToControl(placement), "100%"), (0, $fZJbz.default)(_objectSpread2, "position", "absolute"), (0, $fZJbz.default)(_objectSpread2, "width", "100%"), (0, $fZJbz.default)(_objectSpread2, "zIndex", 1), _objectSpread2), unstyled ? {} : {
        backgroundColor: colors.neutral0,
        borderRadius: borderRadius,
        boxShadow: "0 0 0 1px hsla(0, 0%, 0%, 0.1), 0 4px 11px hsla(0, 0%, 0%, 0.1)",
        marginBottom: spacing.menuGutter,
        marginTop: spacing.menuGutter
    });
};
var $b0f9d86086831776$var$PortalPlacementContext = /*#__PURE__*/ (0, $dAx5m.createContext)(null);
// NOTE: internal only
var $b0f9d86086831776$export$3a1a48c8f6ef640e = function MenuPlacer(props) {
    var children = props.children, minMenuHeight = props.minMenuHeight, maxMenuHeight = props.maxMenuHeight, menuPlacement = props.menuPlacement, menuPosition = props.menuPosition, menuShouldScrollIntoView = props.menuShouldScrollIntoView, theme = props.theme;
    var _ref3 = (0, $dAx5m.useContext)($b0f9d86086831776$var$PortalPlacementContext) || {}, setPortalPlacement = _ref3.setPortalPlacement;
    var ref = (0, $dAx5m.useRef)(null);
    var _useState = (0, $dAx5m.useState)(maxMenuHeight), _useState2 = (0, $8Y5h3.default)(_useState, 2), maxHeight = _useState2[0], setMaxHeight = _useState2[1];
    var _useState3 = (0, $dAx5m.useState)(null), _useState4 = (0, $8Y5h3.default)(_useState3, 2), placement = _useState4[0], setPlacement = _useState4[1];
    var controlHeight = theme.spacing.controlHeight;
    (0, $3k7Ry.default)(function() {
        var menuEl = ref.current;
        if (!menuEl) return;
        // DO NOT scroll if position is fixed
        var isFixedPosition = menuPosition === "fixed";
        var shouldScroll = menuShouldScrollIntoView && !isFixedPosition;
        var state = $b0f9d86086831776$var$getMenuPlacement({
            maxHeight: maxMenuHeight,
            menuEl: menuEl,
            minHeight: minMenuHeight,
            placement: menuPlacement,
            shouldScroll: shouldScroll,
            isFixedPosition: isFixedPosition,
            controlHeight: controlHeight
        });
        setMaxHeight(state.maxHeight);
        setPlacement(state.placement);
        setPortalPlacement === null || setPortalPlacement === void 0 || setPortalPlacement(state.placement);
    }, [
        maxMenuHeight,
        menuPlacement,
        menuPosition,
        menuShouldScrollIntoView,
        minMenuHeight,
        setPortalPlacement,
        controlHeight
    ]);
    return children({
        ref: ref,
        placerProps: (0, $lWmb7.default)((0, $lWmb7.default)({}, props), {}, {
            placement: placement || $b0f9d86086831776$var$coercePlacement(menuPlacement),
            maxHeight: maxHeight
        })
    });
};
var $b0f9d86086831776$var$Menu = function Menu(props) {
    var children = props.children, innerRef = props.innerRef, innerProps = props.innerProps;
    return (0, $jVTBW.jsx)("div", (0, $i6L24.default)({}, $b0f9d86086831776$var$getStyleProps(props, "menu", {
        menu: true
    }), {
        ref: innerRef
    }, innerProps), children);
};
var $b0f9d86086831776$var$Menu$1 = $b0f9d86086831776$var$Menu;
// ==============================
// Menu List
// ==============================
var $b0f9d86086831776$export$7ccc53e8f1e7dfc5 = function menuListCSS(_ref4, unstyled) {
    var maxHeight = _ref4.maxHeight, baseUnit = _ref4.theme.spacing.baseUnit;
    return (0, $lWmb7.default)({
        maxHeight: maxHeight,
        overflowY: "auto",
        position: "relative",
        // required for offset[Height, Top] > keyboard scroll
        WebkitOverflowScrolling: "touch"
    }, unstyled ? {} : {
        paddingBottom: baseUnit,
        paddingTop: baseUnit
    });
};
var $b0f9d86086831776$var$MenuList = function MenuList(props) {
    var children = props.children, innerProps = props.innerProps, innerRef = props.innerRef, isMulti = props.isMulti;
    return (0, $jVTBW.jsx)("div", (0, $i6L24.default)({}, $b0f9d86086831776$var$getStyleProps(props, "menuList", {
        "menu-list": true,
        "menu-list--is-multi": isMulti
    }), {
        ref: innerRef
    }, innerProps), children);
};
// ==============================
// Menu Notices
// ==============================
var $b0f9d86086831776$var$noticeCSS = function noticeCSS(_ref5, unstyled) {
    var _ref5$theme = _ref5.theme, baseUnit = _ref5$theme.spacing.baseUnit, colors = _ref5$theme.colors;
    return (0, $lWmb7.default)({
        textAlign: "center"
    }, unstyled ? {} : {
        color: colors.neutral40,
        padding: "".concat(baseUnit * 2, "px ").concat(baseUnit * 3, "px")
    });
};
var $b0f9d86086831776$export$3b14a55fb2447963 = $b0f9d86086831776$var$noticeCSS;
var $b0f9d86086831776$export$342063e11d6c3cad = $b0f9d86086831776$var$noticeCSS;
var $b0f9d86086831776$var$NoOptionsMessage = function NoOptionsMessage(_ref6) {
    var _ref6$children = _ref6.children, children = _ref6$children === void 0 ? "No options" : _ref6$children, innerProps = _ref6.innerProps, restProps = (0, $3ci4f.default)(_ref6, $b0f9d86086831776$var$_excluded$3);
    return (0, $jVTBW.jsx)("div", (0, $i6L24.default)({}, $b0f9d86086831776$var$getStyleProps((0, $lWmb7.default)((0, $lWmb7.default)({}, restProps), {}, {
        children: children,
        innerProps: innerProps
    }), "noOptionsMessage", {
        "menu-notice": true,
        "menu-notice--no-options": true
    }), innerProps), children);
};
var $b0f9d86086831776$var$LoadingMessage = function LoadingMessage(_ref7) {
    var _ref7$children = _ref7.children, children = _ref7$children === void 0 ? "Loading..." : _ref7$children, innerProps = _ref7.innerProps, restProps = (0, $3ci4f.default)(_ref7, $b0f9d86086831776$var$_excluded2$1);
    return (0, $jVTBW.jsx)("div", (0, $i6L24.default)({}, $b0f9d86086831776$var$getStyleProps((0, $lWmb7.default)((0, $lWmb7.default)({}, restProps), {}, {
        children: children,
        innerProps: innerProps
    }), "loadingMessage", {
        "menu-notice": true,
        "menu-notice--loading": true
    }), innerProps), children);
};
// ==============================
// Menu Portal
// ==============================
var $b0f9d86086831776$export$ae1af26003f05816 = function menuPortalCSS(_ref8) {
    var rect = _ref8.rect, offset = _ref8.offset, position = _ref8.position;
    return {
        left: rect.left,
        position: position,
        top: offset,
        width: rect.width,
        zIndex: 1
    };
};
var $b0f9d86086831776$var$MenuPortal = function MenuPortal(props) {
    var appendTo = props.appendTo, children = props.children, controlElement = props.controlElement, innerProps = props.innerProps, menuPlacement = props.menuPlacement, menuPosition = props.menuPosition;
    var menuPortalRef = (0, $dAx5m.useRef)(null);
    var cleanupRef = (0, $dAx5m.useRef)(null);
    var _useState5 = (0, $dAx5m.useState)($b0f9d86086831776$var$coercePlacement(menuPlacement)), _useState6 = (0, $8Y5h3.default)(_useState5, 2), placement = _useState6[0], setPortalPlacement = _useState6[1];
    var portalPlacementContext = (0, $dAx5m.useMemo)(function() {
        return {
            setPortalPlacement: setPortalPlacement
        };
    }, []);
    var _useState7 = (0, $dAx5m.useState)(null), _useState8 = (0, $8Y5h3.default)(_useState7, 2), computedPosition = _useState8[0], setComputedPosition = _useState8[1];
    var updateComputedPosition = (0, $dAx5m.useCallback)(function() {
        if (!controlElement) return;
        var rect = $b0f9d86086831776$var$getBoundingClientObj(controlElement);
        var scrollDistance = menuPosition === "fixed" ? 0 : window.pageYOffset;
        var offset = rect[placement] + scrollDistance;
        if (offset !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.offset) || rect.left !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.left) || rect.width !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.width)) setComputedPosition({
            offset: offset,
            rect: rect
        });
    }, [
        controlElement,
        menuPosition,
        placement,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.offset,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.left,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.width
    ]);
    (0, $3k7Ry.default)(function() {
        updateComputedPosition();
    }, [
        updateComputedPosition
    ]);
    var runAutoUpdate = (0, $dAx5m.useCallback)(function() {
        if (typeof cleanupRef.current === "function") {
            cleanupRef.current();
            cleanupRef.current = null;
        }
        if (controlElement && menuPortalRef.current) cleanupRef.current = (0, $9Hxa6.autoUpdate)(controlElement, menuPortalRef.current, updateComputedPosition, {
            elementResize: "ResizeObserver" in window
        });
    }, [
        controlElement,
        updateComputedPosition
    ]);
    (0, $3k7Ry.default)(function() {
        runAutoUpdate();
    }, [
        runAutoUpdate
    ]);
    var setMenuPortalElement = (0, $dAx5m.useCallback)(function(menuPortalElement) {
        menuPortalRef.current = menuPortalElement;
        runAutoUpdate();
    }, [
        runAutoUpdate
    ]);
    // bail early if required elements aren't present
    if (!appendTo && menuPosition !== "fixed" || !computedPosition) return null;
    // same wrapper element whether fixed or portalled
    var menuWrapper = (0, $jVTBW.jsx)("div", (0, $i6L24.default)({
        ref: setMenuPortalElement
    }, $b0f9d86086831776$var$getStyleProps((0, $lWmb7.default)((0, $lWmb7.default)({}, props), {}, {
        offset: computedPosition.offset,
        position: menuPosition,
        rect: computedPosition.rect
    }), "menuPortal", {
        "menu-portal": true
    }), innerProps), children);
    return (0, $jVTBW.jsx)($b0f9d86086831776$var$PortalPlacementContext.Provider, {
        value: portalPlacementContext
    }, appendTo ? /*#__PURE__*/ (0, $1MpXQ.createPortal)(menuWrapper, appendTo) : menuWrapper);
};
// ==============================
// Root Container
// ==============================
var $b0f9d86086831776$export$8b22cf2602fb60ce = function containerCSS(_ref) {
    var isDisabled = _ref.isDisabled, isRtl = _ref.isRtl;
    return {
        label: "container",
        direction: isRtl ? "rtl" : undefined,
        pointerEvents: isDisabled ? "none" : undefined,
        // cancel mouse events when disabled
        position: "relative"
    };
};
var $b0f9d86086831776$var$SelectContainer = function SelectContainer(props) {
    var children = props.children, innerProps = props.innerProps, isDisabled = props.isDisabled, isRtl = props.isRtl;
    return (0, $jVTBW.jsx)("div", (0, $i6L24.default)({}, $b0f9d86086831776$var$getStyleProps(props, "container", {
        "--is-disabled": isDisabled,
        "--is-rtl": isRtl
    }), innerProps), children);
};
// ==============================
// Value Container
// ==============================
var $b0f9d86086831776$export$4a5767248b18ef41 = function valueContainerCSS(_ref2, unstyled) {
    var spacing = _ref2.theme.spacing, isMulti = _ref2.isMulti, hasValue = _ref2.hasValue, controlShouldRenderValue = _ref2.selectProps.controlShouldRenderValue;
    return (0, $lWmb7.default)({
        alignItems: "center",
        display: isMulti && hasValue && controlShouldRenderValue ? "flex" : "grid",
        flex: 1,
        flexWrap: "wrap",
        WebkitOverflowScrolling: "touch",
        position: "relative",
        overflow: "hidden"
    }, unstyled ? {} : {
        padding: "".concat(spacing.baseUnit / 2, "px ").concat(spacing.baseUnit * 2, "px")
    });
};
var $b0f9d86086831776$var$ValueContainer = function ValueContainer(props) {
    var children = props.children, innerProps = props.innerProps, isMulti = props.isMulti, hasValue = props.hasValue;
    return (0, $jVTBW.jsx)("div", (0, $i6L24.default)({}, $b0f9d86086831776$var$getStyleProps(props, "valueContainer", {
        "value-container": true,
        "value-container--is-multi": isMulti,
        "value-container--has-value": hasValue
    }), innerProps), children);
};
// ==============================
// Indicator Container
// ==============================
var $b0f9d86086831776$export$23f2a1d2818174ef = function indicatorsContainerCSS() {
    return {
        alignItems: "center",
        alignSelf: "stretch",
        display: "flex",
        flexShrink: 0
    };
};
var $b0f9d86086831776$var$IndicatorsContainer = function IndicatorsContainer(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $jVTBW.jsx)("div", (0, $i6L24.default)({}, $b0f9d86086831776$var$getStyleProps(props, "indicatorsContainer", {
        indicators: true
    }), innerProps), children);
};
var $b0f9d86086831776$var$_templateObject;
var $b0f9d86086831776$var$_excluded$2 = [
    "size"
], $b0f9d86086831776$var$_excluded2 = [
    "innerProps",
    "isRtl",
    "size"
];
function $b0f9d86086831776$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// ==============================
// Dropdown & Clear Icons
// ==============================
var $b0f9d86086831776$var$_ref2 = {
    name: "8mmkcg",
    styles: "display:inline-block;fill:currentColor;line-height:1;stroke:currentColor;stroke-width:0"
};
var $b0f9d86086831776$var$Svg = function Svg(_ref) {
    var size = _ref.size, props = (0, $3ci4f.default)(_ref, $b0f9d86086831776$var$_excluded$2);
    return (0, $jVTBW.jsx)("svg", (0, $i6L24.default)({
        height: size,
        width: size,
        viewBox: "0 0 20 20",
        "aria-hidden": "true",
        focusable: "false",
        css: $b0f9d86086831776$var$_ref2
    }, props));
};
var $b0f9d86086831776$var$CrossIcon = function CrossIcon(props) {
    return (0, $jVTBW.jsx)($b0f9d86086831776$var$Svg, (0, $i6L24.default)({
        size: 20
    }, props), (0, $jVTBW.jsx)("path", {
        d: "M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z"
    }));
};
var $b0f9d86086831776$var$DownChevron = function DownChevron(props) {
    return (0, $jVTBW.jsx)($b0f9d86086831776$var$Svg, (0, $i6L24.default)({
        size: 20
    }, props), (0, $jVTBW.jsx)("path", {
        d: "M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"
    }));
};
// ==============================
// Dropdown & Clear Buttons
// ==============================
var $b0f9d86086831776$var$baseCSS = function baseCSS(_ref3, unstyled) {
    var isFocused = _ref3.isFocused, _ref3$theme = _ref3.theme, baseUnit = _ref3$theme.spacing.baseUnit, colors = _ref3$theme.colors;
    return (0, $lWmb7.default)({
        label: "indicatorContainer",
        display: "flex",
        transition: "color 150ms"
    }, unstyled ? {} : {
        color: isFocused ? colors.neutral60 : colors.neutral20,
        padding: baseUnit * 2,
        ":hover": {
            color: isFocused ? colors.neutral80 : colors.neutral40
        }
    });
};
var $b0f9d86086831776$export$f1e1789686576879 = $b0f9d86086831776$var$baseCSS;
var $b0f9d86086831776$var$DropdownIndicator = function DropdownIndicator(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $jVTBW.jsx)("div", (0, $i6L24.default)({}, $b0f9d86086831776$var$getStyleProps(props, "dropdownIndicator", {
        indicator: true,
        "dropdown-indicator": true
    }), innerProps), children || (0, $jVTBW.jsx)($b0f9d86086831776$var$DownChevron, null));
};
var $b0f9d86086831776$export$407448d2b89b1813 = $b0f9d86086831776$var$baseCSS;
var $b0f9d86086831776$var$ClearIndicator = function ClearIndicator(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $jVTBW.jsx)("div", (0, $i6L24.default)({}, $b0f9d86086831776$var$getStyleProps(props, "clearIndicator", {
        indicator: true,
        "clear-indicator": true
    }), innerProps), children || (0, $jVTBW.jsx)($b0f9d86086831776$var$CrossIcon, null));
};
// ==============================
// Separator
// ==============================
var $b0f9d86086831776$export$dda1d9f60106f0e9 = function indicatorSeparatorCSS(_ref4, unstyled) {
    var isDisabled = _ref4.isDisabled, _ref4$theme = _ref4.theme, baseUnit = _ref4$theme.spacing.baseUnit, colors = _ref4$theme.colors;
    return (0, $lWmb7.default)({
        label: "indicatorSeparator",
        alignSelf: "stretch",
        width: 1
    }, unstyled ? {} : {
        backgroundColor: isDisabled ? colors.neutral10 : colors.neutral20,
        marginBottom: baseUnit * 2,
        marginTop: baseUnit * 2
    });
};
var $b0f9d86086831776$var$IndicatorSeparator = function IndicatorSeparator(props) {
    var innerProps = props.innerProps;
    return (0, $jVTBW.jsx)("span", (0, $i6L24.default)({}, innerProps, $b0f9d86086831776$var$getStyleProps(props, "indicatorSeparator", {
        "indicator-separator": true
    })));
};
// ==============================
// Loading
// ==============================
var $b0f9d86086831776$var$loadingDotAnimations = (0, $jVTBW.keyframes)($b0f9d86086831776$var$_templateObject || ($b0f9d86086831776$var$_templateObject = (0, $1TUQY.default)([
    "\n  0%, 80%, 100% { opacity: 0; }\n  40% { opacity: 1; }\n"
])));
var $b0f9d86086831776$export$882b5998b3b9117c = function loadingIndicatorCSS(_ref5, unstyled) {
    var isFocused = _ref5.isFocused, size = _ref5.size, _ref5$theme = _ref5.theme, colors = _ref5$theme.colors, baseUnit = _ref5$theme.spacing.baseUnit;
    return (0, $lWmb7.default)({
        label: "loadingIndicator",
        display: "flex",
        transition: "color 150ms",
        alignSelf: "center",
        fontSize: size,
        lineHeight: 1,
        marginRight: size,
        textAlign: "center",
        verticalAlign: "middle"
    }, unstyled ? {} : {
        color: isFocused ? colors.neutral60 : colors.neutral20,
        padding: baseUnit * 2
    });
};
var $b0f9d86086831776$var$LoadingDot = function LoadingDot(_ref6) {
    var delay = _ref6.delay, offset = _ref6.offset;
    return (0, $jVTBW.jsx)("span", {
        css: /*#__PURE__*/ (0, $jVTBW.css)({
            animation: "".concat($b0f9d86086831776$var$loadingDotAnimations, " 1s ease-in-out ").concat(delay, "ms infinite;"),
            backgroundColor: "currentColor",
            borderRadius: "1em",
            display: "inline-block",
            marginLeft: offset ? "1em" : undefined,
            height: "1em",
            verticalAlign: "top",
            width: "1em"
        }, "", "")
    });
};
var $b0f9d86086831776$var$LoadingIndicator = function LoadingIndicator(_ref7) {
    var innerProps = _ref7.innerProps, isRtl = _ref7.isRtl, _ref7$size = _ref7.size, size = _ref7$size === void 0 ? 4 : _ref7$size, restProps = (0, $3ci4f.default)(_ref7, $b0f9d86086831776$var$_excluded2);
    return (0, $jVTBW.jsx)("div", (0, $i6L24.default)({}, $b0f9d86086831776$var$getStyleProps((0, $lWmb7.default)((0, $lWmb7.default)({}, restProps), {}, {
        innerProps: innerProps,
        isRtl: isRtl,
        size: size
    }), "loadingIndicator", {
        indicator: true,
        "loading-indicator": true
    }), innerProps), (0, $jVTBW.jsx)($b0f9d86086831776$var$LoadingDot, {
        delay: 0,
        offset: isRtl
    }), (0, $jVTBW.jsx)($b0f9d86086831776$var$LoadingDot, {
        delay: 160,
        offset: true
    }), (0, $jVTBW.jsx)($b0f9d86086831776$var$LoadingDot, {
        delay: 320,
        offset: !isRtl
    }));
};
var $b0f9d86086831776$export$4368d992c4eafac0 = function css(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, isFocused = _ref.isFocused, _ref$theme = _ref.theme, colors = _ref$theme.colors, borderRadius = _ref$theme.borderRadius, spacing = _ref$theme.spacing;
    return (0, $lWmb7.default)({
        label: "control",
        alignItems: "center",
        cursor: "default",
        display: "flex",
        flexWrap: "wrap",
        justifyContent: "space-between",
        minHeight: spacing.controlHeight,
        outline: "0 !important",
        position: "relative",
        transition: "all 100ms"
    }, unstyled ? {} : {
        backgroundColor: isDisabled ? colors.neutral5 : colors.neutral0,
        borderColor: isDisabled ? colors.neutral10 : isFocused ? colors.primary : colors.neutral20,
        borderRadius: borderRadius,
        borderStyle: "solid",
        borderWidth: 1,
        boxShadow: isFocused ? "0 0 0 1px ".concat(colors.primary) : undefined,
        "&:hover": {
            borderColor: isFocused ? colors.primary : colors.neutral30
        }
    });
};
var $b0f9d86086831776$var$Control = function Control(props) {
    var children = props.children, isDisabled = props.isDisabled, isFocused = props.isFocused, innerRef = props.innerRef, innerProps = props.innerProps, menuIsOpen = props.menuIsOpen;
    return (0, $jVTBW.jsx)("div", (0, $i6L24.default)({
        ref: innerRef
    }, $b0f9d86086831776$var$getStyleProps(props, "control", {
        control: true,
        "control--is-disabled": isDisabled,
        "control--is-focused": isFocused,
        "control--menu-is-open": menuIsOpen
    }), innerProps, {
        "aria-disabled": isDisabled || undefined
    }), children);
};
var $b0f9d86086831776$var$Control$1 = $b0f9d86086831776$var$Control;
var $b0f9d86086831776$var$_excluded$1 = [
    "data"
];
var $b0f9d86086831776$export$39b482c5e57630a8 = function groupCSS(_ref, unstyled) {
    var spacing = _ref.theme.spacing;
    return unstyled ? {} : {
        paddingBottom: spacing.baseUnit * 2,
        paddingTop: spacing.baseUnit * 2
    };
};
var $b0f9d86086831776$var$Group = function Group(props) {
    var children = props.children, cx = props.cx, getStyles = props.getStyles, getClassNames = props.getClassNames, Heading = props.Heading, headingProps = props.headingProps, innerProps = props.innerProps, label = props.label, theme = props.theme, selectProps = props.selectProps;
    return (0, $jVTBW.jsx)("div", (0, $i6L24.default)({}, $b0f9d86086831776$var$getStyleProps(props, "group", {
        group: true
    }), innerProps), (0, $jVTBW.jsx)(Heading, (0, $i6L24.default)({}, headingProps, {
        selectProps: selectProps,
        theme: theme,
        getStyles: getStyles,
        getClassNames: getClassNames,
        cx: cx
    }), label), (0, $jVTBW.jsx)("div", null, children));
};
var $b0f9d86086831776$export$2d1720544b23b823 = function groupHeadingCSS(_ref2, unstyled) {
    var _ref2$theme = _ref2.theme, colors = _ref2$theme.colors, spacing = _ref2$theme.spacing;
    return (0, $lWmb7.default)({
        label: "group",
        cursor: "default",
        display: "block"
    }, unstyled ? {} : {
        color: colors.neutral40,
        fontSize: "75%",
        fontWeight: 500,
        marginBottom: "0.25em",
        paddingLeft: spacing.baseUnit * 3,
        paddingRight: spacing.baseUnit * 3,
        textTransform: "uppercase"
    });
};
var $b0f9d86086831776$var$GroupHeading = function GroupHeading(props) {
    var _cleanCommonProps = $b0f9d86086831776$var$cleanCommonProps(props);
    _cleanCommonProps.data;
    var innerProps = (0, $3ci4f.default)(_cleanCommonProps, $b0f9d86086831776$var$_excluded$1);
    return (0, $jVTBW.jsx)("div", (0, $i6L24.default)({}, $b0f9d86086831776$var$getStyleProps(props, "groupHeading", {
        "group-heading": true
    }), innerProps));
};
var $b0f9d86086831776$var$Group$1 = $b0f9d86086831776$var$Group;
var $b0f9d86086831776$var$_excluded = [
    "innerRef",
    "isDisabled",
    "isHidden",
    "inputClassName"
];
var $b0f9d86086831776$export$35e795649ee09318 = function inputCSS(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, value = _ref.value, _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, $lWmb7.default)((0, $lWmb7.default)({
        visibility: isDisabled ? "hidden" : "visible",
        // force css to recompute when value change due to @emotion bug.
        // We can remove it whenever the bug is fixed.
        transform: value ? "translateZ(0)" : ""
    }, $b0f9d86086831776$var$containerStyle), unstyled ? {} : {
        margin: spacing.baseUnit / 2,
        paddingBottom: spacing.baseUnit / 2,
        paddingTop: spacing.baseUnit / 2,
        color: colors.neutral80
    });
};
var $b0f9d86086831776$var$spacingStyle = {
    gridArea: "1 / 2",
    font: "inherit",
    minWidth: "2px",
    border: 0,
    margin: 0,
    outline: 0,
    padding: 0
};
var $b0f9d86086831776$var$containerStyle = {
    flex: "1 1 auto",
    display: "inline-grid",
    gridArea: "1 / 1 / 2 / 3",
    gridTemplateColumns: "0 min-content",
    "&:after": (0, $lWmb7.default)({
        content: 'attr(data-value) " "',
        visibility: "hidden",
        whiteSpace: "pre"
    }, $b0f9d86086831776$var$spacingStyle)
};
var $b0f9d86086831776$var$inputStyle = function inputStyle(isHidden) {
    return (0, $lWmb7.default)({
        label: "input",
        color: "inherit",
        background: 0,
        opacity: isHidden ? 0 : 1,
        width: "100%"
    }, $b0f9d86086831776$var$spacingStyle);
};
var $b0f9d86086831776$var$Input = function Input(props) {
    var cx = props.cx, value = props.value;
    var _cleanCommonProps = $b0f9d86086831776$var$cleanCommonProps(props), innerRef = _cleanCommonProps.innerRef, isDisabled = _cleanCommonProps.isDisabled, isHidden = _cleanCommonProps.isHidden, inputClassName = _cleanCommonProps.inputClassName, innerProps = (0, $3ci4f.default)(_cleanCommonProps, $b0f9d86086831776$var$_excluded);
    return (0, $jVTBW.jsx)("div", (0, $i6L24.default)({}, $b0f9d86086831776$var$getStyleProps(props, "input", {
        "input-container": true
    }), {
        "data-value": value || ""
    }), (0, $jVTBW.jsx)("input", (0, $i6L24.default)({
        className: cx({
            input: true
        }, inputClassName),
        ref: innerRef,
        style: $b0f9d86086831776$var$inputStyle(isHidden),
        disabled: isDisabled
    }, innerProps)));
};
var $b0f9d86086831776$var$Input$1 = $b0f9d86086831776$var$Input;
var $b0f9d86086831776$export$ffb5f4729a158638 = function multiValueCSS(_ref, unstyled) {
    var _ref$theme = _ref.theme, spacing = _ref$theme.spacing, borderRadius = _ref$theme.borderRadius, colors = _ref$theme.colors;
    return (0, $lWmb7.default)({
        label: "multiValue",
        display: "flex",
        minWidth: 0
    }, unstyled ? {} : {
        backgroundColor: colors.neutral10,
        borderRadius: borderRadius / 2,
        margin: spacing.baseUnit / 2
    });
};
var $b0f9d86086831776$export$9e5f44173e64f162 = function multiValueLabelCSS(_ref2, unstyled) {
    var _ref2$theme = _ref2.theme, borderRadius = _ref2$theme.borderRadius, colors = _ref2$theme.colors, cropWithEllipsis = _ref2.cropWithEllipsis;
    return (0, $lWmb7.default)({
        overflow: "hidden",
        textOverflow: cropWithEllipsis || cropWithEllipsis === undefined ? "ellipsis" : undefined,
        whiteSpace: "nowrap"
    }, unstyled ? {} : {
        borderRadius: borderRadius / 2,
        color: colors.neutral80,
        fontSize: "85%",
        padding: 3,
        paddingLeft: 6
    });
};
var $b0f9d86086831776$export$625550452a3fa3ec = function multiValueRemoveCSS(_ref3, unstyled) {
    var _ref3$theme = _ref3.theme, spacing = _ref3$theme.spacing, borderRadius = _ref3$theme.borderRadius, colors = _ref3$theme.colors, isFocused = _ref3.isFocused;
    return (0, $lWmb7.default)({
        alignItems: "center",
        display: "flex"
    }, unstyled ? {} : {
        borderRadius: borderRadius / 2,
        backgroundColor: isFocused ? colors.dangerLight : undefined,
        paddingLeft: spacing.baseUnit,
        paddingRight: spacing.baseUnit,
        ":hover": {
            backgroundColor: colors.dangerLight,
            color: colors.danger
        }
    });
};
var $b0f9d86086831776$var$MultiValueGeneric = function MultiValueGeneric(_ref4) {
    var children = _ref4.children, innerProps = _ref4.innerProps;
    return (0, $jVTBW.jsx)("div", innerProps, children);
};
var $b0f9d86086831776$var$MultiValueContainer = $b0f9d86086831776$var$MultiValueGeneric;
var $b0f9d86086831776$var$MultiValueLabel = $b0f9d86086831776$var$MultiValueGeneric;
function $b0f9d86086831776$var$MultiValueRemove(_ref5) {
    var children = _ref5.children, innerProps = _ref5.innerProps;
    return (0, $jVTBW.jsx)("div", (0, $i6L24.default)({
        role: "button"
    }, innerProps), children || (0, $jVTBW.jsx)($b0f9d86086831776$var$CrossIcon, {
        size: 14
    }));
}
var $b0f9d86086831776$var$MultiValue = function MultiValue(props) {
    var children = props.children, components = props.components, data = props.data, innerProps = props.innerProps, isDisabled = props.isDisabled, removeProps = props.removeProps, selectProps = props.selectProps;
    var Container = components.Container, Label = components.Label, Remove = components.Remove;
    return (0, $jVTBW.jsx)(Container, {
        data: data,
        innerProps: (0, $lWmb7.default)((0, $lWmb7.default)({}, $b0f9d86086831776$var$getStyleProps(props, "multiValue", {
            "multi-value": true,
            "multi-value--is-disabled": isDisabled
        })), innerProps),
        selectProps: selectProps
    }, (0, $jVTBW.jsx)(Label, {
        data: data,
        innerProps: (0, $lWmb7.default)({}, $b0f9d86086831776$var$getStyleProps(props, "multiValueLabel", {
            "multi-value__label": true
        })),
        selectProps: selectProps
    }, children), (0, $jVTBW.jsx)(Remove, {
        data: data,
        innerProps: (0, $lWmb7.default)((0, $lWmb7.default)({}, $b0f9d86086831776$var$getStyleProps(props, "multiValueRemove", {
            "multi-value__remove": true
        })), {}, {
            "aria-label": "Remove ".concat(children || "option")
        }, removeProps),
        selectProps: selectProps
    }));
};
var $b0f9d86086831776$var$MultiValue$1 = $b0f9d86086831776$var$MultiValue;
var $b0f9d86086831776$export$90a7f3efeed30595 = function optionCSS(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, isFocused = _ref.isFocused, isSelected = _ref.isSelected, _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, $lWmb7.default)({
        label: "option",
        cursor: "default",
        display: "block",
        fontSize: "inherit",
        width: "100%",
        userSelect: "none",
        WebkitTapHighlightColor: "rgba(0, 0, 0, 0)"
    }, unstyled ? {} : {
        backgroundColor: isSelected ? colors.primary : isFocused ? colors.primary25 : "transparent",
        color: isDisabled ? colors.neutral20 : isSelected ? colors.neutral0 : "inherit",
        padding: "".concat(spacing.baseUnit * 2, "px ").concat(spacing.baseUnit * 3, "px"),
        // provide some affordance on touch devices
        ":active": {
            backgroundColor: !isDisabled ? isSelected ? colors.primary : colors.primary50 : undefined
        }
    });
};
var $b0f9d86086831776$var$Option = function Option(props) {
    var children = props.children, isDisabled = props.isDisabled, isFocused = props.isFocused, isSelected = props.isSelected, innerRef = props.innerRef, innerProps = props.innerProps;
    return (0, $jVTBW.jsx)("div", (0, $i6L24.default)({}, $b0f9d86086831776$var$getStyleProps(props, "option", {
        option: true,
        "option--is-disabled": isDisabled,
        "option--is-focused": isFocused,
        "option--is-selected": isSelected
    }), {
        ref: innerRef,
        "aria-disabled": isDisabled
    }, innerProps), children);
};
var $b0f9d86086831776$var$Option$1 = $b0f9d86086831776$var$Option;
var $b0f9d86086831776$export$efccba1c4a2ef57b = function placeholderCSS(_ref, unstyled) {
    var _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, $lWmb7.default)({
        label: "placeholder",
        gridArea: "1 / 1 / 2 / 3"
    }, unstyled ? {} : {
        color: colors.neutral50,
        marginLeft: spacing.baseUnit / 2,
        marginRight: spacing.baseUnit / 2
    });
};
var $b0f9d86086831776$var$Placeholder = function Placeholder(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $jVTBW.jsx)("div", (0, $i6L24.default)({}, $b0f9d86086831776$var$getStyleProps(props, "placeholder", {
        placeholder: true
    }), innerProps), children);
};
var $b0f9d86086831776$var$Placeholder$1 = $b0f9d86086831776$var$Placeholder;
var $b0f9d86086831776$export$d141bba7fdc215a3 = function css(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, $lWmb7.default)({
        label: "singleValue",
        gridArea: "1 / 1 / 2 / 3",
        maxWidth: "100%",
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap"
    }, unstyled ? {} : {
        color: isDisabled ? colors.neutral40 : colors.neutral80,
        marginLeft: spacing.baseUnit / 2,
        marginRight: spacing.baseUnit / 2
    });
};
var $b0f9d86086831776$var$SingleValue = function SingleValue(props) {
    var children = props.children, isDisabled = props.isDisabled, innerProps = props.innerProps;
    return (0, $jVTBW.jsx)("div", (0, $i6L24.default)({}, $b0f9d86086831776$var$getStyleProps(props, "singleValue", {
        "single-value": true,
        "single-value--is-disabled": isDisabled
    }), innerProps), children);
};
var $b0f9d86086831776$var$SingleValue$1 = $b0f9d86086831776$var$SingleValue;
var $b0f9d86086831776$export$db3b6bfb95261072 = {
    ClearIndicator: $b0f9d86086831776$var$ClearIndicator,
    Control: $b0f9d86086831776$var$Control$1,
    DropdownIndicator: $b0f9d86086831776$var$DropdownIndicator,
    DownChevron: $b0f9d86086831776$var$DownChevron,
    CrossIcon: $b0f9d86086831776$var$CrossIcon,
    Group: $b0f9d86086831776$var$Group$1,
    GroupHeading: $b0f9d86086831776$var$GroupHeading,
    IndicatorsContainer: $b0f9d86086831776$var$IndicatorsContainer,
    IndicatorSeparator: $b0f9d86086831776$var$IndicatorSeparator,
    Input: $b0f9d86086831776$var$Input$1,
    LoadingIndicator: $b0f9d86086831776$var$LoadingIndicator,
    Menu: $b0f9d86086831776$var$Menu$1,
    MenuList: $b0f9d86086831776$var$MenuList,
    MenuPortal: $b0f9d86086831776$var$MenuPortal,
    LoadingMessage: $b0f9d86086831776$var$LoadingMessage,
    NoOptionsMessage: $b0f9d86086831776$var$NoOptionsMessage,
    MultiValue: $b0f9d86086831776$var$MultiValue$1,
    MultiValueContainer: $b0f9d86086831776$var$MultiValueContainer,
    MultiValueLabel: $b0f9d86086831776$var$MultiValueLabel,
    MultiValueRemove: $b0f9d86086831776$var$MultiValueRemove,
    Option: $b0f9d86086831776$var$Option$1,
    Placeholder: $b0f9d86086831776$var$Placeholder$1,
    SelectContainer: $b0f9d86086831776$var$SelectContainer,
    SingleValue: $b0f9d86086831776$var$SingleValue$1,
    ValueContainer: $b0f9d86086831776$var$ValueContainer
};
var $b0f9d86086831776$export$d66501df72047452 = function defaultComponents(props) {
    return (0, $lWmb7.default)((0, $lWmb7.default)({}, $b0f9d86086831776$export$db3b6bfb95261072), props.components);
};

});
parcelRegister("1TUQY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $16270767620d3a61$export$2e2bcd8739ae039; });
function $16270767620d3a61$export$2e2bcd8739ae039(e, t) {
    return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, {
        raw: {
            value: Object.freeze(t)
        }
    }));
}

});

parcelRegister("9Hxa6", function(module, exports) {

$parcel$export(module.exports, "autoUpdate", function () { return $7101da813abaf903$export$deee3a793edee05f; });

var $2mDqQ = parcelRequire("2mDqQ");
var $5CFkC = parcelRequire("5CFkC");

var $5CFkC = parcelRequire("5CFkC");

var $jGErJ = parcelRequire("jGErJ");
function $7101da813abaf903$var$getCssDimensions(element) {
    const css = (0, $jGErJ.getComputedStyle)(element);
    // In testing environments, the `width` and `height` properties are empty
    // strings for SVG elements, returning NaN. Fallback to `0` in this case.
    let width = parseFloat(css.width) || 0;
    let height = parseFloat(css.height) || 0;
    const hasOffset = (0, $jGErJ.isHTMLElement)(element);
    const offsetWidth = hasOffset ? element.offsetWidth : width;
    const offsetHeight = hasOffset ? element.offsetHeight : height;
    const shouldFallback = (0, $5CFkC.round)(width) !== offsetWidth || (0, $5CFkC.round)(height) !== offsetHeight;
    if (shouldFallback) {
        width = offsetWidth;
        height = offsetHeight;
    }
    return {
        width: width,
        height: height,
        $: shouldFallback
    };
}
function $7101da813abaf903$var$unwrapElement(element) {
    return !(0, $jGErJ.isElement)(element) ? element.contextElement : element;
}
function $7101da813abaf903$var$getScale(element) {
    const domElement = $7101da813abaf903$var$unwrapElement(element);
    if (!(0, $jGErJ.isHTMLElement)(domElement)) return (0, $5CFkC.createCoords)(1);
    const rect = domElement.getBoundingClientRect();
    const { width: width, height: height, $: $ } = $7101da813abaf903$var$getCssDimensions(domElement);
    let x = ($ ? (0, $5CFkC.round)(rect.width) : rect.width) / width;
    let y = ($ ? (0, $5CFkC.round)(rect.height) : rect.height) / height;
    // 0, NaN, or Infinity should always fallback to 1.
    if (!x || !Number.isFinite(x)) x = 1;
    if (!y || !Number.isFinite(y)) y = 1;
    return {
        x: x,
        y: y
    };
}
const $7101da813abaf903$var$noOffsets = /*#__PURE__*/ (0, $5CFkC.createCoords)(0);
function $7101da813abaf903$var$getVisualOffsets(element) {
    const win = (0, $jGErJ.getWindow)(element);
    if (!(0, $jGErJ.isWebKit)() || !win.visualViewport) return $7101da813abaf903$var$noOffsets;
    return {
        x: win.visualViewport.offsetLeft,
        y: win.visualViewport.offsetTop
    };
}
function $7101da813abaf903$var$shouldAddVisualOffsets(element, isFixed, floatingOffsetParent) {
    if (isFixed === void 0) isFixed = false;
    if (!floatingOffsetParent || isFixed && floatingOffsetParent !== (0, $jGErJ.getWindow)(element)) return false;
    return isFixed;
}
function $7101da813abaf903$var$getBoundingClientRect(element, includeScale, isFixedStrategy, offsetParent) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    const clientRect = element.getBoundingClientRect();
    const domElement = $7101da813abaf903$var$unwrapElement(element);
    let scale = (0, $5CFkC.createCoords)(1);
    if (includeScale) {
        if (offsetParent) {
            if ((0, $jGErJ.isElement)(offsetParent)) scale = $7101da813abaf903$var$getScale(offsetParent);
        } else scale = $7101da813abaf903$var$getScale(element);
    }
    const visualOffsets = $7101da813abaf903$var$shouldAddVisualOffsets(domElement, isFixedStrategy, offsetParent) ? $7101da813abaf903$var$getVisualOffsets(domElement) : (0, $5CFkC.createCoords)(0);
    let x = (clientRect.left + visualOffsets.x) / scale.x;
    let y = (clientRect.top + visualOffsets.y) / scale.y;
    let width = clientRect.width / scale.x;
    let height = clientRect.height / scale.y;
    if (domElement) {
        const win = (0, $jGErJ.getWindow)(domElement);
        const offsetWin = offsetParent && (0, $jGErJ.isElement)(offsetParent) ? (0, $jGErJ.getWindow)(offsetParent) : offsetParent;
        let currentWin = win;
        let currentIFrame = (0, $jGErJ.getFrameElement)(currentWin);
        while(currentIFrame && offsetParent && offsetWin !== currentWin){
            const iframeScale = $7101da813abaf903$var$getScale(currentIFrame);
            const iframeRect = currentIFrame.getBoundingClientRect();
            const css = (0, $jGErJ.getComputedStyle)(currentIFrame);
            const left = iframeRect.left + (currentIFrame.clientLeft + parseFloat(css.paddingLeft)) * iframeScale.x;
            const top = iframeRect.top + (currentIFrame.clientTop + parseFloat(css.paddingTop)) * iframeScale.y;
            x *= iframeScale.x;
            y *= iframeScale.y;
            width *= iframeScale.x;
            height *= iframeScale.y;
            x += left;
            y += top;
            currentWin = (0, $jGErJ.getWindow)(currentIFrame);
            currentIFrame = (0, $jGErJ.getFrameElement)(currentWin);
        }
    }
    return (0, $5CFkC.rectToClientRect)({
        width: width,
        height: height,
        x: x,
        y: y
    });
}
function $7101da813abaf903$var$convertOffsetParentRelativeRectToViewportRelativeRect(_ref) {
    let { elements: elements, rect: rect, offsetParent: offsetParent, strategy: strategy } = _ref;
    const isFixed = strategy === "fixed";
    const documentElement = (0, $jGErJ.getDocumentElement)(offsetParent);
    const topLayer = elements ? (0, $jGErJ.isTopLayer)(elements.floating) : false;
    if (offsetParent === documentElement || topLayer && isFixed) return rect;
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    let scale = (0, $5CFkC.createCoords)(1);
    const offsets = (0, $5CFkC.createCoords)(0);
    const isOffsetParentAnElement = (0, $jGErJ.isHTMLElement)(offsetParent);
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $jGErJ.getNodeName)(offsetParent) !== "body" || (0, $jGErJ.isOverflowElement)(documentElement)) scroll = (0, $jGErJ.getNodeScroll)(offsetParent);
        if ((0, $jGErJ.isHTMLElement)(offsetParent)) {
            const offsetRect = $7101da813abaf903$var$getBoundingClientRect(offsetParent);
            scale = $7101da813abaf903$var$getScale(offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        }
    }
    return {
        width: rect.width * scale.x,
        height: rect.height * scale.y,
        x: rect.x * scale.x - scroll.scrollLeft * scale.x + offsets.x,
        y: rect.y * scale.y - scroll.scrollTop * scale.y + offsets.y
    };
}
function $7101da813abaf903$var$getClientRects(element) {
    return Array.from(element.getClientRects());
}
// If <html> has a CSS width greater than the viewport, then this will be
// incorrect for RTL.
function $7101da813abaf903$var$getWindowScrollBarX(element, rect) {
    const leftScroll = (0, $jGErJ.getNodeScroll)(element).scrollLeft;
    if (!rect) return $7101da813abaf903$var$getBoundingClientRect((0, $jGErJ.getDocumentElement)(element)).left + leftScroll;
    return rect.left + leftScroll;
}
// Gets the entire size of the scrollable document area, even extending outside
// of the `<html>` and `<body>` rect bounds if horizontally scrollable.
function $7101da813abaf903$var$getDocumentRect(element) {
    const html = (0, $jGErJ.getDocumentElement)(element);
    const scroll = (0, $jGErJ.getNodeScroll)(element);
    const body = element.ownerDocument.body;
    const width = (0, $5CFkC.max)(html.scrollWidth, html.clientWidth, body.scrollWidth, body.clientWidth);
    const height = (0, $5CFkC.max)(html.scrollHeight, html.clientHeight, body.scrollHeight, body.clientHeight);
    let x = -scroll.scrollLeft + $7101da813abaf903$var$getWindowScrollBarX(element);
    const y = -scroll.scrollTop;
    if ((0, $jGErJ.getComputedStyle)(body).direction === "rtl") x += (0, $5CFkC.max)(html.clientWidth, body.clientWidth) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
function $7101da813abaf903$var$getViewportRect(element, strategy) {
    const win = (0, $jGErJ.getWindow)(element);
    const html = (0, $jGErJ.getDocumentElement)(element);
    const visualViewport = win.visualViewport;
    let width = html.clientWidth;
    let height = html.clientHeight;
    let x = 0;
    let y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        const visualViewportBased = (0, $jGErJ.isWebKit)();
        if (!visualViewportBased || visualViewportBased && strategy === "fixed") {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
// Returns the inner client rect, subtracting scrollbars if present.
function $7101da813abaf903$var$getInnerBoundingClientRect(element, strategy) {
    const clientRect = $7101da813abaf903$var$getBoundingClientRect(element, true, strategy === "fixed");
    const top = clientRect.top + element.clientTop;
    const left = clientRect.left + element.clientLeft;
    const scale = (0, $jGErJ.isHTMLElement)(element) ? $7101da813abaf903$var$getScale(element) : (0, $5CFkC.createCoords)(1);
    const width = element.clientWidth * scale.x;
    const height = element.clientHeight * scale.y;
    const x = left * scale.x;
    const y = top * scale.y;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
function $7101da813abaf903$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy) {
    let rect;
    if (clippingAncestor === "viewport") rect = $7101da813abaf903$var$getViewportRect(element, strategy);
    else if (clippingAncestor === "document") rect = $7101da813abaf903$var$getDocumentRect((0, $jGErJ.getDocumentElement)(element));
    else if ((0, $jGErJ.isElement)(clippingAncestor)) rect = $7101da813abaf903$var$getInnerBoundingClientRect(clippingAncestor, strategy);
    else {
        const visualOffsets = $7101da813abaf903$var$getVisualOffsets(element);
        rect = {
            ...clippingAncestor,
            x: clippingAncestor.x - visualOffsets.x,
            y: clippingAncestor.y - visualOffsets.y
        };
    }
    return (0, $5CFkC.rectToClientRect)(rect);
}
function $7101da813abaf903$var$hasFixedPositionAncestor(element, stopNode) {
    const parentNode = (0, $jGErJ.getParentNode)(element);
    if (parentNode === stopNode || !(0, $jGErJ.isElement)(parentNode) || (0, $jGErJ.isLastTraversableNode)(parentNode)) return false;
    return (0, $jGErJ.getComputedStyle)(parentNode).position === "fixed" || $7101da813abaf903$var$hasFixedPositionAncestor(parentNode, stopNode);
}
// A "clipping ancestor" is an `overflow` element with the characteristic of
// clipping (or hiding) child elements. This returns all clipping ancestors
// of the given element up the tree.
function $7101da813abaf903$var$getClippingElementAncestors(element, cache) {
    const cachedResult = cache.get(element);
    if (cachedResult) return cachedResult;
    let result = (0, $jGErJ.getOverflowAncestors)(element, [], false).filter((el)=>(0, $jGErJ.isElement)(el) && (0, $jGErJ.getNodeName)(el) !== "body");
    let currentContainingBlockComputedStyle = null;
    const elementIsFixed = (0, $jGErJ.getComputedStyle)(element).position === "fixed";
    let currentNode = elementIsFixed ? (0, $jGErJ.getParentNode)(element) : element;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    while((0, $jGErJ.isElement)(currentNode) && !(0, $jGErJ.isLastTraversableNode)(currentNode)){
        const computedStyle = (0, $jGErJ.getComputedStyle)(currentNode);
        const currentNodeIsContaining = (0, $jGErJ.isContainingBlock)(currentNode);
        if (!currentNodeIsContaining && computedStyle.position === "fixed") currentContainingBlockComputedStyle = null;
        const shouldDropCurrentNode = elementIsFixed ? !currentNodeIsContaining && !currentContainingBlockComputedStyle : !currentNodeIsContaining && computedStyle.position === "static" && !!currentContainingBlockComputedStyle && [
            "absolute",
            "fixed"
        ].includes(currentContainingBlockComputedStyle.position) || (0, $jGErJ.isOverflowElement)(currentNode) && !currentNodeIsContaining && $7101da813abaf903$var$hasFixedPositionAncestor(element, currentNode);
        if (shouldDropCurrentNode) // Drop non-containing blocks.
        result = result.filter((ancestor)=>ancestor !== currentNode);
        else // Record last containing block for next iteration.
        currentContainingBlockComputedStyle = computedStyle;
        currentNode = (0, $jGErJ.getParentNode)(currentNode);
    }
    cache.set(element, result);
    return result;
}
// Gets the maximum area that the element is visible in due to any number of
// clipping ancestors.
function $7101da813abaf903$var$getClippingRect(_ref) {
    let { element: element, boundary: boundary, rootBoundary: rootBoundary, strategy: strategy } = _ref;
    const elementClippingAncestors = boundary === "clippingAncestors" ? (0, $jGErJ.isTopLayer)(element) ? [] : $7101da813abaf903$var$getClippingElementAncestors(element, this._c) : [].concat(boundary);
    const clippingAncestors = [
        ...elementClippingAncestors,
        rootBoundary
    ];
    const firstClippingAncestor = clippingAncestors[0];
    const clippingRect = clippingAncestors.reduce((accRect, clippingAncestor)=>{
        const rect = $7101da813abaf903$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy);
        accRect.top = (0, $5CFkC.max)(rect.top, accRect.top);
        accRect.right = (0, $5CFkC.min)(rect.right, accRect.right);
        accRect.bottom = (0, $5CFkC.min)(rect.bottom, accRect.bottom);
        accRect.left = (0, $5CFkC.max)(rect.left, accRect.left);
        return accRect;
    }, $7101da813abaf903$var$getClientRectFromClippingAncestor(element, firstClippingAncestor, strategy));
    return {
        width: clippingRect.right - clippingRect.left,
        height: clippingRect.bottom - clippingRect.top,
        x: clippingRect.left,
        y: clippingRect.top
    };
}
function $7101da813abaf903$var$getDimensions(element) {
    const { width: width, height: height } = $7101da813abaf903$var$getCssDimensions(element);
    return {
        width: width,
        height: height
    };
}
function $7101da813abaf903$var$getRectRelativeToOffsetParent(element, offsetParent, strategy) {
    const isOffsetParentAnElement = (0, $jGErJ.isHTMLElement)(offsetParent);
    const documentElement = (0, $jGErJ.getDocumentElement)(offsetParent);
    const isFixed = strategy === "fixed";
    const rect = $7101da813abaf903$var$getBoundingClientRect(element, true, isFixed, offsetParent);
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    const offsets = (0, $5CFkC.createCoords)(0);
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $jGErJ.getNodeName)(offsetParent) !== "body" || (0, $jGErJ.isOverflowElement)(documentElement)) scroll = (0, $jGErJ.getNodeScroll)(offsetParent);
        if (isOffsetParentAnElement) {
            const offsetRect = $7101da813abaf903$var$getBoundingClientRect(offsetParent, true, isFixed, offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        } else if (documentElement) // If the <body> scrollbar appears on the left (e.g. RTL systems). Use
        // Firefox with layout.scrollbar.side = 3 in about:config to test this.
        offsets.x = $7101da813abaf903$var$getWindowScrollBarX(documentElement);
    }
    let htmlX = 0;
    let htmlY = 0;
    if (documentElement && !isOffsetParentAnElement && !isFixed) {
        const htmlRect = documentElement.getBoundingClientRect();
        htmlY = htmlRect.top + scroll.scrollTop;
        htmlX = htmlRect.left + scroll.scrollLeft - // RTL <body> scrollbar.
        $7101da813abaf903$var$getWindowScrollBarX(documentElement, htmlRect);
    }
    const x = rect.left + scroll.scrollLeft - offsets.x - htmlX;
    const y = rect.top + scroll.scrollTop - offsets.y - htmlY;
    return {
        x: x,
        y: y,
        width: rect.width,
        height: rect.height
    };
}
function $7101da813abaf903$var$isStaticPositioned(element) {
    return (0, $jGErJ.getComputedStyle)(element).position === "static";
}
function $7101da813abaf903$var$getTrueOffsetParent(element, polyfill) {
    if (!(0, $jGErJ.isHTMLElement)(element) || (0, $jGErJ.getComputedStyle)(element).position === "fixed") return null;
    if (polyfill) return polyfill(element);
    let rawOffsetParent = element.offsetParent;
    // Firefox returns the <html> element as the offsetParent if it's non-static,
    // while Chrome and Safari return the <body> element. The <body> element must
    // be used to perform the correct calculations even if the <html> element is
    // non-static.
    if ((0, $jGErJ.getDocumentElement)(element) === rawOffsetParent) rawOffsetParent = rawOffsetParent.ownerDocument.body;
    return rawOffsetParent;
}
// Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.
function $7101da813abaf903$var$getOffsetParent(element, polyfill) {
    const win = (0, $jGErJ.getWindow)(element);
    if ((0, $jGErJ.isTopLayer)(element)) return win;
    if (!(0, $jGErJ.isHTMLElement)(element)) {
        let svgOffsetParent = (0, $jGErJ.getParentNode)(element);
        while(svgOffsetParent && !(0, $jGErJ.isLastTraversableNode)(svgOffsetParent)){
            if ((0, $jGErJ.isElement)(svgOffsetParent) && !$7101da813abaf903$var$isStaticPositioned(svgOffsetParent)) return svgOffsetParent;
            svgOffsetParent = (0, $jGErJ.getParentNode)(svgOffsetParent);
        }
        return win;
    }
    let offsetParent = $7101da813abaf903$var$getTrueOffsetParent(element, polyfill);
    while(offsetParent && (0, $jGErJ.isTableElement)(offsetParent) && $7101da813abaf903$var$isStaticPositioned(offsetParent))offsetParent = $7101da813abaf903$var$getTrueOffsetParent(offsetParent, polyfill);
    if (offsetParent && (0, $jGErJ.isLastTraversableNode)(offsetParent) && $7101da813abaf903$var$isStaticPositioned(offsetParent) && !(0, $jGErJ.isContainingBlock)(offsetParent)) return win;
    return offsetParent || (0, $jGErJ.getContainingBlock)(element) || win;
}
const $7101da813abaf903$var$getElementRects = async function(data) {
    const getOffsetParentFn = this.getOffsetParent || $7101da813abaf903$var$getOffsetParent;
    const getDimensionsFn = this.getDimensions;
    const floatingDimensions = await getDimensionsFn(data.floating);
    return {
        reference: $7101da813abaf903$var$getRectRelativeToOffsetParent(data.reference, await getOffsetParentFn(data.floating), data.strategy),
        floating: {
            x: 0,
            y: 0,
            width: floatingDimensions.width,
            height: floatingDimensions.height
        }
    };
};
function $7101da813abaf903$var$isRTL(element) {
    return (0, $jGErJ.getComputedStyle)(element).direction === "rtl";
}
const $7101da813abaf903$export$722a64dea1b767dc = {
    convertOffsetParentRelativeRectToViewportRelativeRect: $7101da813abaf903$var$convertOffsetParentRelativeRectToViewportRelativeRect,
    getDocumentElement: $jGErJ.getDocumentElement,
    getClippingRect: $7101da813abaf903$var$getClippingRect,
    getOffsetParent: $7101da813abaf903$var$getOffsetParent,
    getElementRects: $7101da813abaf903$var$getElementRects,
    getClientRects: $7101da813abaf903$var$getClientRects,
    getDimensions: $7101da813abaf903$var$getDimensions,
    getScale: $7101da813abaf903$var$getScale,
    isElement: $jGErJ.isElement,
    isRTL: $7101da813abaf903$var$isRTL
};
// https://samthor.au/2021/observing-dom/
function $7101da813abaf903$var$observeMove(element, onMove) {
    let io = null;
    let timeoutId;
    const root = (0, $jGErJ.getDocumentElement)(element);
    function cleanup() {
        var _io;
        clearTimeout(timeoutId);
        (_io = io) == null || _io.disconnect();
        io = null;
    }
    function refresh(skip, threshold) {
        if (skip === void 0) skip = false;
        if (threshold === void 0) threshold = 1;
        cleanup();
        const { left: left, top: top, width: width, height: height } = element.getBoundingClientRect();
        if (!skip) onMove();
        if (!width || !height) return;
        const insetTop = (0, $5CFkC.floor)(top);
        const insetRight = (0, $5CFkC.floor)(root.clientWidth - (left + width));
        const insetBottom = (0, $5CFkC.floor)(root.clientHeight - (top + height));
        const insetLeft = (0, $5CFkC.floor)(left);
        const rootMargin = -insetTop + "px " + -insetRight + "px " + -insetBottom + "px " + -insetLeft + "px";
        const options = {
            rootMargin: rootMargin,
            threshold: (0, $5CFkC.max)(0, (0, $5CFkC.min)(1, threshold)) || 1
        };
        let isFirstUpdate = true;
        function handleObserve(entries) {
            const ratio = entries[0].intersectionRatio;
            if (ratio !== threshold) {
                if (!isFirstUpdate) return refresh();
                if (!ratio) // If the reference is clipped, the ratio is 0. Throttle the refresh
                // to prevent an infinite loop of updates.
                timeoutId = setTimeout(()=>{
                    refresh(false, 1e-7);
                }, 1000);
                else refresh(false, ratio);
            }
            isFirstUpdate = false;
        }
        // Older browsers don't support a `document` as the root and will throw an
        // error.
        try {
            io = new IntersectionObserver(handleObserve, {
                ...options,
                // Handle <iframe>s
                root: root.ownerDocument
            });
        } catch (e) {
            io = new IntersectionObserver(handleObserve, options);
        }
        io.observe(element);
    }
    refresh(true);
    return cleanup;
}
/**
 * Automatically updates the position of the floating element when necessary.
 * Should only be called when the floating element is mounted on the DOM or
 * visible on the screen.
 * @returns cleanup function that should be invoked when the floating element is
 * removed from the DOM or hidden from the screen.
 * @see https://floating-ui.com/docs/autoUpdate
 */ function $7101da813abaf903$export$deee3a793edee05f(reference, floating, update, options) {
    if (options === void 0) options = {};
    const { ancestorScroll: ancestorScroll = true, ancestorResize: ancestorResize = true, elementResize: elementResize = typeof ResizeObserver === "function", layoutShift: layoutShift = typeof IntersectionObserver === "function", animationFrame: animationFrame = false } = options;
    const referenceEl = $7101da813abaf903$var$unwrapElement(reference);
    const ancestors = ancestorScroll || ancestorResize ? [
        ...referenceEl ? (0, $jGErJ.getOverflowAncestors)(referenceEl) : [],
        ...(0, $jGErJ.getOverflowAncestors)(floating)
    ] : [];
    ancestors.forEach((ancestor)=>{
        ancestorScroll && ancestor.addEventListener("scroll", update, {
            passive: true
        });
        ancestorResize && ancestor.addEventListener("resize", update);
    });
    const cleanupIo = referenceEl && layoutShift ? $7101da813abaf903$var$observeMove(referenceEl, update) : null;
    let reobserveFrame = -1;
    let resizeObserver = null;
    if (elementResize) {
        resizeObserver = new ResizeObserver((_ref)=>{
            let [firstEntry] = _ref;
            if (firstEntry && firstEntry.target === referenceEl && resizeObserver) {
                // Prevent update loops when using the `size` middleware.
                // https://github.com/floating-ui/floating-ui/issues/1740
                resizeObserver.unobserve(floating);
                cancelAnimationFrame(reobserveFrame);
                reobserveFrame = requestAnimationFrame(()=>{
                    var _resizeObserver;
                    (_resizeObserver = resizeObserver) == null || _resizeObserver.observe(floating);
                });
            }
            update();
        });
        if (referenceEl && !animationFrame) resizeObserver.observe(referenceEl);
        resizeObserver.observe(floating);
    }
    let frameId;
    let prevRefRect = animationFrame ? $7101da813abaf903$var$getBoundingClientRect(reference) : null;
    if (animationFrame) frameLoop();
    function frameLoop() {
        const nextRefRect = $7101da813abaf903$var$getBoundingClientRect(reference);
        if (prevRefRect && (nextRefRect.x !== prevRefRect.x || nextRefRect.y !== prevRefRect.y || nextRefRect.width !== prevRefRect.width || nextRefRect.height !== prevRefRect.height)) update();
        prevRefRect = nextRefRect;
        frameId = requestAnimationFrame(frameLoop);
    }
    update();
    return ()=>{
        var _resizeObserver2;
        ancestors.forEach((ancestor)=>{
            ancestorScroll && ancestor.removeEventListener("scroll", update);
            ancestorResize && ancestor.removeEventListener("resize", update);
        });
        cleanupIo == null || cleanupIo();
        (_resizeObserver2 = resizeObserver) == null || _resizeObserver2.disconnect();
        resizeObserver = null;
        if (animationFrame) cancelAnimationFrame(frameId);
    };
}
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ const $7101da813abaf903$export$37b6bde19b108ecc = (0, $2mDqQ.detectOverflow);
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $7101da813abaf903$export$cc800923e997bb8 = (0, $2mDqQ.offset);
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $7101da813abaf903$export$91fb6ecbd551914 = (0, $2mDqQ.autoPlacement);
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $7101da813abaf903$export$fba63a578e423eb = (0, $2mDqQ.shift);
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $7101da813abaf903$export$8a83211c878a3f1f = (0, $2mDqQ.flip);
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $7101da813abaf903$export$346677f925de839c = (0, $2mDqQ.size);
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $7101da813abaf903$export$fe8985bb6374093c = (0, $2mDqQ.hide);
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const $7101da813abaf903$export$f2120bbfa5450bd2 = (0, $2mDqQ.arrow);
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $7101da813abaf903$export$18c8ad048e32c7d5 = (0, $2mDqQ.inline);
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $7101da813abaf903$export$7bf07e38f3dc4b69 = (0, $2mDqQ.limitShift);
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 */ const $7101da813abaf903$export$48a53dcb22e581d0 = (reference, floating, options)=>{
    // This caches the expensive `getClippingElementAncestors` function so that
    // multiple lifecycle resets re-use the same result. It only lives for a
    // single call. If other functions become expensive, we can add them as well.
    const cache = new Map();
    const mergedOptions = {
        platform: $7101da813abaf903$export$722a64dea1b767dc,
        ...options
    };
    const platformWithCache = {
        ...mergedOptions.platform,
        _c: cache
    };
    return (0, $2mDqQ.computePosition)(reference, floating, {
        ...mergedOptions,
        platform: platformWithCache
    });
};

});
parcelRegister("2mDqQ", function(module, exports) {

$parcel$export(module.exports, "computePosition", function () { return $1b8c3934b281d5b3$export$48a53dcb22e581d0; });
$parcel$export(module.exports, "detectOverflow", function () { return $1b8c3934b281d5b3$export$37b6bde19b108ecc; });
$parcel$export(module.exports, "arrow", function () { return $1b8c3934b281d5b3$export$f2120bbfa5450bd2; });
$parcel$export(module.exports, "autoPlacement", function () { return $1b8c3934b281d5b3$export$91fb6ecbd551914; });
$parcel$export(module.exports, "flip", function () { return $1b8c3934b281d5b3$export$8a83211c878a3f1f; });
$parcel$export(module.exports, "hide", function () { return $1b8c3934b281d5b3$export$fe8985bb6374093c; });
$parcel$export(module.exports, "inline", function () { return $1b8c3934b281d5b3$export$18c8ad048e32c7d5; });
$parcel$export(module.exports, "offset", function () { return $1b8c3934b281d5b3$export$cc800923e997bb8; });
$parcel$export(module.exports, "shift", function () { return $1b8c3934b281d5b3$export$fba63a578e423eb; });
$parcel$export(module.exports, "limitShift", function () { return $1b8c3934b281d5b3$export$7bf07e38f3dc4b69; });
$parcel$export(module.exports, "size", function () { return $1b8c3934b281d5b3$export$346677f925de839c; });
$parcel$export(module.exports, "rectToClientRect", function () { return (parcelRequire("5CFkC")).rectToClientRect; });

var $5CFkC = parcelRequire("5CFkC");
function $1b8c3934b281d5b3$var$computeCoordsFromPlacement(_ref, placement, rtl) {
    let { reference: reference, floating: floating } = _ref;
    const sideAxis = (0, $5CFkC.getSideAxis)(placement);
    const alignmentAxis = (0, $5CFkC.getAlignmentAxis)(placement);
    const alignLength = (0, $5CFkC.getAxisLength)(alignmentAxis);
    const side = (0, $5CFkC.getSide)(placement);
    const isVertical = sideAxis === "y";
    const commonX = reference.x + reference.width / 2 - floating.width / 2;
    const commonY = reference.y + reference.height / 2 - floating.height / 2;
    const commonAlign = reference[alignLength] / 2 - floating[alignLength] / 2;
    let coords;
    switch(side){
        case "top":
            coords = {
                x: commonX,
                y: reference.y - floating.height
            };
            break;
        case "bottom":
            coords = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case "right":
            coords = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case "left":
            coords = {
                x: reference.x - floating.width,
                y: commonY
            };
            break;
        default:
            coords = {
                x: reference.x,
                y: reference.y
            };
    }
    switch((0, $5CFkC.getAlignment)(placement)){
        case "start":
            coords[alignmentAxis] -= commonAlign * (rtl && isVertical ? -1 : 1);
            break;
        case "end":
            coords[alignmentAxis] += commonAlign * (rtl && isVertical ? -1 : 1);
            break;
    }
    return coords;
}
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 *
 * This export does not have any `platform` interface logic. You will need to
 * write one for the platform you are using Floating UI with.
 */ const $1b8c3934b281d5b3$export$48a53dcb22e581d0 = async (reference, floating, config)=>{
    const { placement: placement = "bottom", strategy: strategy = "absolute", middleware: middleware = [], platform: platform } = config;
    const validMiddleware = middleware.filter(Boolean);
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(floating));
    let rects = await platform.getElementRects({
        reference: reference,
        floating: floating,
        strategy: strategy
    });
    let { x: x, y: y } = $1b8c3934b281d5b3$var$computeCoordsFromPlacement(rects, placement, rtl);
    let statefulPlacement = placement;
    let middlewareData = {};
    let resetCount = 0;
    for(let i = 0; i < validMiddleware.length; i++){
        const { name: name, fn: fn } = validMiddleware[i];
        const { x: nextX, y: nextY, data: data, reset: reset } = await fn({
            x: x,
            y: y,
            initialPlacement: placement,
            placement: statefulPlacement,
            strategy: strategy,
            middlewareData: middlewareData,
            rects: rects,
            platform: platform,
            elements: {
                reference: reference,
                floating: floating
            }
        });
        x = nextX != null ? nextX : x;
        y = nextY != null ? nextY : y;
        middlewareData = {
            ...middlewareData,
            [name]: {
                ...middlewareData[name],
                ...data
            }
        };
        if (reset && resetCount <= 50) {
            resetCount++;
            if (typeof reset === "object") {
                if (reset.placement) statefulPlacement = reset.placement;
                if (reset.rects) rects = reset.rects === true ? await platform.getElementRects({
                    reference: reference,
                    floating: floating,
                    strategy: strategy
                }) : reset.rects;
                ({ x: x, y: y } = $1b8c3934b281d5b3$var$computeCoordsFromPlacement(rects, statefulPlacement, rtl));
            }
            i = -1;
        }
    }
    return {
        x: x,
        y: y,
        placement: statefulPlacement,
        strategy: strategy,
        middlewareData: middlewareData
    };
};
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ async function $1b8c3934b281d5b3$export$37b6bde19b108ecc(state, options) {
    var _await$platform$isEle;
    if (options === void 0) options = {};
    const { x: x, y: y, platform: platform, rects: rects, elements: elements, strategy: strategy } = state;
    const { boundary: boundary = "clippingAncestors", rootBoundary: rootBoundary = "viewport", elementContext: elementContext = "floating", altBoundary: altBoundary = false, padding: padding = 0 } = (0, $5CFkC.evaluate)(options, state);
    const paddingObject = (0, $5CFkC.getPaddingObject)(padding);
    const altContext = elementContext === "floating" ? "reference" : "floating";
    const element = elements[altBoundary ? altContext : elementContext];
    const clippingClientRect = (0, $5CFkC.rectToClientRect)(await platform.getClippingRect({
        element: ((_await$platform$isEle = await (platform.isElement == null ? void 0 : platform.isElement(element))) != null ? _await$platform$isEle : true) ? element : element.contextElement || await (platform.getDocumentElement == null ? void 0 : platform.getDocumentElement(elements.floating)),
        boundary: boundary,
        rootBoundary: rootBoundary,
        strategy: strategy
    }));
    const rect = elementContext === "floating" ? {
        x: x,
        y: y,
        width: rects.floating.width,
        height: rects.floating.height
    } : rects.reference;
    const offsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(elements.floating));
    const offsetScale = await (platform.isElement == null ? void 0 : platform.isElement(offsetParent)) ? await (platform.getScale == null ? void 0 : platform.getScale(offsetParent)) || {
        x: 1,
        y: 1
    } : {
        x: 1,
        y: 1
    };
    const elementClientRect = (0, $5CFkC.rectToClientRect)(platform.convertOffsetParentRelativeRectToViewportRelativeRect ? await platform.convertOffsetParentRelativeRectToViewportRelativeRect({
        elements: elements,
        rect: rect,
        offsetParent: offsetParent,
        strategy: strategy
    }) : rect);
    return {
        top: (clippingClientRect.top - elementClientRect.top + paddingObject.top) / offsetScale.y,
        bottom: (elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom) / offsetScale.y,
        left: (clippingClientRect.left - elementClientRect.left + paddingObject.left) / offsetScale.x,
        right: (elementClientRect.right - clippingClientRect.right + paddingObject.right) / offsetScale.x
    };
}
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const $1b8c3934b281d5b3$export$f2120bbfa5450bd2 = (options)=>({
        name: "arrow",
        options: options,
        async fn (state) {
            const { x: x, y: y, placement: placement, rects: rects, platform: platform, elements: elements, middlewareData: middlewareData } = state;
            // Since `element` is required, we don't Partial<> the type.
            const { element: element, padding: padding = 0 } = (0, $5CFkC.evaluate)(options, state) || {};
            if (element == null) return {};
            const paddingObject = (0, $5CFkC.getPaddingObject)(padding);
            const coords = {
                x: x,
                y: y
            };
            const axis = (0, $5CFkC.getAlignmentAxis)(placement);
            const length = (0, $5CFkC.getAxisLength)(axis);
            const arrowDimensions = await platform.getDimensions(element);
            const isYAxis = axis === "y";
            const minProp = isYAxis ? "top" : "left";
            const maxProp = isYAxis ? "bottom" : "right";
            const clientProp = isYAxis ? "clientHeight" : "clientWidth";
            const endDiff = rects.reference[length] + rects.reference[axis] - coords[axis] - rects.floating[length];
            const startDiff = coords[axis] - rects.reference[axis];
            const arrowOffsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(element));
            let clientSize = arrowOffsetParent ? arrowOffsetParent[clientProp] : 0;
            // DOM platform can return `window` as the `offsetParent`.
            if (!clientSize || !await (platform.isElement == null ? void 0 : platform.isElement(arrowOffsetParent))) clientSize = elements.floating[clientProp] || rects.floating[length];
            const centerToReference = endDiff / 2 - startDiff / 2;
            // If the padding is large enough that it causes the arrow to no longer be
            // centered, modify the padding so that it is centered.
            const largestPossiblePadding = clientSize / 2 - arrowDimensions[length] / 2 - 1;
            const minPadding = (0, $5CFkC.min)(paddingObject[minProp], largestPossiblePadding);
            const maxPadding = (0, $5CFkC.min)(paddingObject[maxProp], largestPossiblePadding);
            // Make sure the arrow doesn't overflow the floating element if the center
            // point is outside the floating element's bounds.
            const min$1 = minPadding;
            const max = clientSize - arrowDimensions[length] - maxPadding;
            const center = clientSize / 2 - arrowDimensions[length] / 2 + centerToReference;
            const offset = (0, $5CFkC.clamp)(min$1, center, max);
            // If the reference is small enough that the arrow's padding causes it to
            // to point to nothing for an aligned placement, adjust the offset of the
            // floating element itself. To ensure `shift()` continues to take action,
            // a single reset is performed when this is true.
            const shouldAddOffset = !middlewareData.arrow && (0, $5CFkC.getAlignment)(placement) != null && center !== offset && rects.reference[length] / 2 - (center < min$1 ? minPadding : maxPadding) - arrowDimensions[length] / 2 < 0;
            const alignmentOffset = shouldAddOffset ? center < min$1 ? center - min$1 : center - max : 0;
            return {
                [axis]: coords[axis] + alignmentOffset,
                data: {
                    [axis]: offset,
                    centerOffset: center - offset - alignmentOffset,
                    ...shouldAddOffset && {
                        alignmentOffset: alignmentOffset
                    }
                },
                reset: shouldAddOffset
            };
        }
    });
function $1b8c3934b281d5b3$var$getPlacementList(alignment, autoAlignment, allowedPlacements) {
    const allowedPlacementsSortedByAlignment = alignment ? [
        ...allowedPlacements.filter((placement)=>(0, $5CFkC.getAlignment)(placement) === alignment),
        ...allowedPlacements.filter((placement)=>(0, $5CFkC.getAlignment)(placement) !== alignment)
    ] : allowedPlacements.filter((placement)=>(0, $5CFkC.getSide)(placement) === placement);
    return allowedPlacementsSortedByAlignment.filter((placement)=>{
        if (alignment) return (0, $5CFkC.getAlignment)(placement) === alignment || (autoAlignment ? (0, $5CFkC.getOppositeAlignmentPlacement)(placement) !== placement : false);
        return true;
    });
}
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $1b8c3934b281d5b3$export$91fb6ecbd551914 = function(options) {
    if (options === void 0) options = {};
    return {
        name: "autoPlacement",
        options: options,
        async fn (state) {
            var _middlewareData$autoP, _middlewareData$autoP2, _placementsThatFitOnE;
            const { rects: rects, middlewareData: middlewareData, placement: placement, platform: platform, elements: elements } = state;
            const { crossAxis: crossAxis = false, alignment: alignment, allowedPlacements: allowedPlacements = (0, $5CFkC.placements), autoAlignment: autoAlignment = true, ...detectOverflowOptions } = (0, $5CFkC.evaluate)(options, state);
            const placements$1 = alignment !== undefined || allowedPlacements === (0, $5CFkC.placements) ? $1b8c3934b281d5b3$var$getPlacementList(alignment || null, autoAlignment, allowedPlacements) : allowedPlacements;
            const overflow = await $1b8c3934b281d5b3$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const currentIndex = ((_middlewareData$autoP = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP.index) || 0;
            const currentPlacement = placements$1[currentIndex];
            if (currentPlacement == null) return {};
            const alignmentSides = (0, $5CFkC.getAlignmentSides)(currentPlacement, rects, await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)));
            // Make `computeCoords` start from the right place.
            if (placement !== currentPlacement) return {
                reset: {
                    placement: placements$1[0]
                }
            };
            const currentOverflows = [
                overflow[(0, $5CFkC.getSide)(currentPlacement)],
                overflow[alignmentSides[0]],
                overflow[alignmentSides[1]]
            ];
            const allOverflows = [
                ...((_middlewareData$autoP2 = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP2.overflows) || [],
                {
                    placement: currentPlacement,
                    overflows: currentOverflows
                }
            ];
            const nextPlacement = placements$1[currentIndex + 1];
            // There are more placements to check.
            if (nextPlacement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: nextPlacement
                }
            };
            const placementsSortedByMostSpace = allOverflows.map((d)=>{
                const alignment = (0, $5CFkC.getAlignment)(d.placement);
                return [
                    d.placement,
                    alignment && crossAxis ? // Check along the mainAxis and main crossAxis side.
                    d.overflows.slice(0, 2).reduce((acc, v)=>acc + v, 0) : // Check only the mainAxis.
                    d.overflows[0],
                    d.overflows
                ];
            }).sort((a, b)=>a[1] - b[1]);
            const placementsThatFitOnEachSide = placementsSortedByMostSpace.filter((d)=>d[2].slice(0, // Aligned placements should not check their opposite crossAxis
                // side.
                (0, $5CFkC.getAlignment)(d[0]) ? 2 : 3).every((v)=>v <= 0));
            const resetPlacement = ((_placementsThatFitOnE = placementsThatFitOnEachSide[0]) == null ? void 0 : _placementsThatFitOnE[0]) || placementsSortedByMostSpace[0][0];
            if (resetPlacement !== placement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: resetPlacement
                }
            };
            return {};
        }
    };
};
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $1b8c3934b281d5b3$export$8a83211c878a3f1f = function(options) {
    if (options === void 0) options = {};
    return {
        name: "flip",
        options: options,
        async fn (state) {
            var _middlewareData$arrow, _middlewareData$flip;
            const { placement: placement, middlewareData: middlewareData, rects: rects, initialPlacement: initialPlacement, platform: platform, elements: elements } = state;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true, fallbackPlacements: specifiedFallbackPlacements, fallbackStrategy: fallbackStrategy = "bestFit", fallbackAxisSideDirection: fallbackAxisSideDirection = "none", flipAlignment: flipAlignment = true, ...detectOverflowOptions } = (0, $5CFkC.evaluate)(options, state);
            // If a reset by the arrow was caused due to an alignment offset being
            // added, we should skip any logic now since `flip()` has already done its
            // work.
            // https://github.com/floating-ui/floating-ui/issues/2549#issuecomment-1719601643
            if ((_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            const side = (0, $5CFkC.getSide)(placement);
            const initialSideAxis = (0, $5CFkC.getSideAxis)(initialPlacement);
            const isBasePlacement = (0, $5CFkC.getSide)(initialPlacement) === initialPlacement;
            const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
            const fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipAlignment ? [
                (0, $5CFkC.getOppositePlacement)(initialPlacement)
            ] : (0, $5CFkC.getExpandedPlacements)(initialPlacement));
            const hasFallbackAxisSideDirection = fallbackAxisSideDirection !== "none";
            if (!specifiedFallbackPlacements && hasFallbackAxisSideDirection) fallbackPlacements.push(...(0, $5CFkC.getOppositeAxisPlacements)(initialPlacement, flipAlignment, fallbackAxisSideDirection, rtl));
            const placements = [
                initialPlacement,
                ...fallbackPlacements
            ];
            const overflow = await $1b8c3934b281d5b3$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const overflows = [];
            let overflowsData = ((_middlewareData$flip = middlewareData.flip) == null ? void 0 : _middlewareData$flip.overflows) || [];
            if (checkMainAxis) overflows.push(overflow[side]);
            if (checkCrossAxis) {
                const sides = (0, $5CFkC.getAlignmentSides)(placement, rects, rtl);
                overflows.push(overflow[sides[0]], overflow[sides[1]]);
            }
            overflowsData = [
                ...overflowsData,
                {
                    placement: placement,
                    overflows: overflows
                }
            ];
            // One or more sides is overflowing.
            if (!overflows.every((side)=>side <= 0)) {
                var _middlewareData$flip2, _overflowsData$filter;
                const nextIndex = (((_middlewareData$flip2 = middlewareData.flip) == null ? void 0 : _middlewareData$flip2.index) || 0) + 1;
                const nextPlacement = placements[nextIndex];
                if (nextPlacement) // Try next placement and re-run the lifecycle.
                return {
                    data: {
                        index: nextIndex,
                        overflows: overflowsData
                    },
                    reset: {
                        placement: nextPlacement
                    }
                };
                // First, find the candidates that fit on the mainAxis side of overflow,
                // then find the placement that fits the best on the main crossAxis side.
                let resetPlacement = (_overflowsData$filter = overflowsData.filter((d)=>d.overflows[0] <= 0).sort((a, b)=>a.overflows[1] - b.overflows[1])[0]) == null ? void 0 : _overflowsData$filter.placement;
                // Otherwise fallback.
                if (!resetPlacement) switch(fallbackStrategy){
                    case "bestFit":
                        {
                            var _overflowsData$filter2;
                            const placement = (_overflowsData$filter2 = overflowsData.filter((d)=>{
                                if (hasFallbackAxisSideDirection) {
                                    const currentSideAxis = (0, $5CFkC.getSideAxis)(d.placement);
                                    return currentSideAxis === initialSideAxis || // Create a bias to the `y` side axis due to horizontal
                                    // reading directions favoring greater width.
                                    currentSideAxis === "y";
                                }
                                return true;
                            }).map((d)=>[
                                    d.placement,
                                    d.overflows.filter((overflow)=>overflow > 0).reduce((acc, overflow)=>acc + overflow, 0)
                                ]).sort((a, b)=>a[1] - b[1])[0]) == null ? void 0 : _overflowsData$filter2[0];
                            if (placement) resetPlacement = placement;
                            break;
                        }
                    case "initialPlacement":
                        resetPlacement = initialPlacement;
                        break;
                }
                if (placement !== resetPlacement) return {
                    reset: {
                        placement: resetPlacement
                    }
                };
            }
            return {};
        }
    };
};
function $1b8c3934b281d5b3$var$getSideOffsets(overflow, rect) {
    return {
        top: overflow.top - rect.height,
        right: overflow.right - rect.width,
        bottom: overflow.bottom - rect.height,
        left: overflow.left - rect.width
    };
}
function $1b8c3934b281d5b3$var$isAnySideFullyClipped(overflow) {
    return (0, $5CFkC.sides).some((side)=>overflow[side] >= 0);
}
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $1b8c3934b281d5b3$export$fe8985bb6374093c = function(options) {
    if (options === void 0) options = {};
    return {
        name: "hide",
        options: options,
        async fn (state) {
            const { rects: rects } = state;
            const { strategy: strategy = "referenceHidden", ...detectOverflowOptions } = (0, $5CFkC.evaluate)(options, state);
            switch(strategy){
                case "referenceHidden":
                    {
                        const overflow = await $1b8c3934b281d5b3$export$37b6bde19b108ecc(state, {
                            ...detectOverflowOptions,
                            elementContext: "reference"
                        });
                        const offsets = $1b8c3934b281d5b3$var$getSideOffsets(overflow, rects.reference);
                        return {
                            data: {
                                referenceHiddenOffsets: offsets,
                                referenceHidden: $1b8c3934b281d5b3$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                case "escaped":
                    {
                        const overflow = await $1b8c3934b281d5b3$export$37b6bde19b108ecc(state, {
                            ...detectOverflowOptions,
                            altBoundary: true
                        });
                        const offsets = $1b8c3934b281d5b3$var$getSideOffsets(overflow, rects.floating);
                        return {
                            data: {
                                escapedOffsets: offsets,
                                escaped: $1b8c3934b281d5b3$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                default:
                    return {};
            }
        }
    };
};
function $1b8c3934b281d5b3$var$getBoundingRect(rects) {
    const minX = (0, $5CFkC.min)(...rects.map((rect)=>rect.left));
    const minY = (0, $5CFkC.min)(...rects.map((rect)=>rect.top));
    const maxX = (0, $5CFkC.max)(...rects.map((rect)=>rect.right));
    const maxY = (0, $5CFkC.max)(...rects.map((rect)=>rect.bottom));
    return {
        x: minX,
        y: minY,
        width: maxX - minX,
        height: maxY - minY
    };
}
function $1b8c3934b281d5b3$var$getRectsByLine(rects) {
    const sortedRects = rects.slice().sort((a, b)=>a.y - b.y);
    const groups = [];
    let prevRect = null;
    for(let i = 0; i < sortedRects.length; i++){
        const rect = sortedRects[i];
        if (!prevRect || rect.y - prevRect.y > prevRect.height / 2) groups.push([
            rect
        ]);
        else groups[groups.length - 1].push(rect);
        prevRect = rect;
    }
    return groups.map((rect)=>(0, $5CFkC.rectToClientRect)($1b8c3934b281d5b3$var$getBoundingRect(rect)));
}
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $1b8c3934b281d5b3$export$18c8ad048e32c7d5 = function(options) {
    if (options === void 0) options = {};
    return {
        name: "inline",
        options: options,
        async fn (state) {
            const { placement: placement, elements: elements, rects: rects, platform: platform, strategy: strategy } = state;
            // A MouseEvent's client{X,Y} coords can be up to 2 pixels off a
            // ClientRect's bounds, despite the event listener being triggered. A
            // padding of 2 seems to handle this issue.
            const { padding: padding = 2, x: x, y: y } = (0, $5CFkC.evaluate)(options, state);
            const nativeClientRects = Array.from(await (platform.getClientRects == null ? void 0 : platform.getClientRects(elements.reference)) || []);
            const clientRects = $1b8c3934b281d5b3$var$getRectsByLine(nativeClientRects);
            const fallback = (0, $5CFkC.rectToClientRect)($1b8c3934b281d5b3$var$getBoundingRect(nativeClientRects));
            const paddingObject = (0, $5CFkC.getPaddingObject)(padding);
            function getBoundingClientRect() {
                // There are two rects and they are disjoined.
                if (clientRects.length === 2 && clientRects[0].left > clientRects[1].right && x != null && y != null) // Find the first rect in which the point is fully inside.
                return clientRects.find((rect)=>x > rect.left - paddingObject.left && x < rect.right + paddingObject.right && y > rect.top - paddingObject.top && y < rect.bottom + paddingObject.bottom) || fallback;
                // There are 2 or more connected rects.
                if (clientRects.length >= 2) {
                    if ((0, $5CFkC.getSideAxis)(placement) === "y") {
                        const firstRect = clientRects[0];
                        const lastRect = clientRects[clientRects.length - 1];
                        const isTop = (0, $5CFkC.getSide)(placement) === "top";
                        const top = firstRect.top;
                        const bottom = lastRect.bottom;
                        const left = isTop ? firstRect.left : lastRect.left;
                        const right = isTop ? firstRect.right : lastRect.right;
                        const width = right - left;
                        const height = bottom - top;
                        return {
                            top: top,
                            bottom: bottom,
                            left: left,
                            right: right,
                            width: width,
                            height: height,
                            x: left,
                            y: top
                        };
                    }
                    const isLeftSide = (0, $5CFkC.getSide)(placement) === "left";
                    const maxRight = (0, $5CFkC.max)(...clientRects.map((rect)=>rect.right));
                    const minLeft = (0, $5CFkC.min)(...clientRects.map((rect)=>rect.left));
                    const measureRects = clientRects.filter((rect)=>isLeftSide ? rect.left === minLeft : rect.right === maxRight);
                    const top = measureRects[0].top;
                    const bottom = measureRects[measureRects.length - 1].bottom;
                    const left = minLeft;
                    const right = maxRight;
                    const width = right - left;
                    const height = bottom - top;
                    return {
                        top: top,
                        bottom: bottom,
                        left: left,
                        right: right,
                        width: width,
                        height: height,
                        x: left,
                        y: top
                    };
                }
                return fallback;
            }
            const resetRects = await platform.getElementRects({
                reference: {
                    getBoundingClientRect: getBoundingClientRect
                },
                floating: elements.floating,
                strategy: strategy
            });
            if (rects.reference.x !== resetRects.reference.x || rects.reference.y !== resetRects.reference.y || rects.reference.width !== resetRects.reference.width || rects.reference.height !== resetRects.reference.height) return {
                reset: {
                    rects: resetRects
                }
            };
            return {};
        }
    };
};
// For type backwards-compatibility, the `OffsetOptions` type was also
// Derivable.
async function $1b8c3934b281d5b3$var$convertValueToCoords(state, options) {
    const { placement: placement, platform: platform, elements: elements } = state;
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
    const side = (0, $5CFkC.getSide)(placement);
    const alignment = (0, $5CFkC.getAlignment)(placement);
    const isVertical = (0, $5CFkC.getSideAxis)(placement) === "y";
    const mainAxisMulti = [
        "left",
        "top"
    ].includes(side) ? -1 : 1;
    const crossAxisMulti = rtl && isVertical ? -1 : 1;
    const rawValue = (0, $5CFkC.evaluate)(options, state);
    // eslint-disable-next-line prefer-const
    let { mainAxis: mainAxis, crossAxis: crossAxis, alignmentAxis: alignmentAxis } = typeof rawValue === "number" ? {
        mainAxis: rawValue,
        crossAxis: 0,
        alignmentAxis: null
    } : {
        mainAxis: rawValue.mainAxis || 0,
        crossAxis: rawValue.crossAxis || 0,
        alignmentAxis: rawValue.alignmentAxis
    };
    if (alignment && typeof alignmentAxis === "number") crossAxis = alignment === "end" ? alignmentAxis * -1 : alignmentAxis;
    return isVertical ? {
        x: crossAxis * crossAxisMulti,
        y: mainAxis * mainAxisMulti
    } : {
        x: mainAxis * mainAxisMulti,
        y: crossAxis * crossAxisMulti
    };
}
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $1b8c3934b281d5b3$export$cc800923e997bb8 = function(options) {
    if (options === void 0) options = 0;
    return {
        name: "offset",
        options: options,
        async fn (state) {
            var _middlewareData$offse, _middlewareData$arrow;
            const { x: x, y: y, placement: placement, middlewareData: middlewareData } = state;
            const diffCoords = await $1b8c3934b281d5b3$var$convertValueToCoords(state, options);
            // If the placement is the same and the arrow caused an alignment offset
            // then we don't need to change the positioning coordinates.
            if (placement === ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse.placement) && (_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            return {
                x: x + diffCoords.x,
                y: y + diffCoords.y,
                data: {
                    ...diffCoords,
                    placement: placement
                }
            };
        }
    };
};
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $1b8c3934b281d5b3$export$fba63a578e423eb = function(options) {
    if (options === void 0) options = {};
    return {
        name: "shift",
        options: options,
        async fn (state) {
            const { x: x, y: y, placement: placement } = state;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = false, limiter: limiter = {
                fn: (_ref)=>{
                    let { x: x, y: y } = _ref;
                    return {
                        x: x,
                        y: y
                    };
                }
            }, ...detectOverflowOptions } = (0, $5CFkC.evaluate)(options, state);
            const coords = {
                x: x,
                y: y
            };
            const overflow = await $1b8c3934b281d5b3$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const crossAxis = (0, $5CFkC.getSideAxis)((0, $5CFkC.getSide)(placement));
            const mainAxis = (0, $5CFkC.getOppositeAxis)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            if (checkMainAxis) {
                const minSide = mainAxis === "y" ? "top" : "left";
                const maxSide = mainAxis === "y" ? "bottom" : "right";
                const min = mainAxisCoord + overflow[minSide];
                const max = mainAxisCoord - overflow[maxSide];
                mainAxisCoord = (0, $5CFkC.clamp)(min, mainAxisCoord, max);
            }
            if (checkCrossAxis) {
                const minSide = crossAxis === "y" ? "top" : "left";
                const maxSide = crossAxis === "y" ? "bottom" : "right";
                const min = crossAxisCoord + overflow[minSide];
                const max = crossAxisCoord - overflow[maxSide];
                crossAxisCoord = (0, $5CFkC.clamp)(min, crossAxisCoord, max);
            }
            const limitedCoords = limiter.fn({
                ...state,
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            });
            return {
                ...limitedCoords,
                data: {
                    x: limitedCoords.x - x,
                    y: limitedCoords.y - y,
                    enabled: {
                        [mainAxis]: checkMainAxis,
                        [crossAxis]: checkCrossAxis
                    }
                }
            };
        }
    };
};
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $1b8c3934b281d5b3$export$7bf07e38f3dc4b69 = function(options) {
    if (options === void 0) options = {};
    return {
        options: options,
        fn (state) {
            const { x: x, y: y, placement: placement, rects: rects, middlewareData: middlewareData } = state;
            const { offset: offset = 0, mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true } = (0, $5CFkC.evaluate)(options, state);
            const coords = {
                x: x,
                y: y
            };
            const crossAxis = (0, $5CFkC.getSideAxis)(placement);
            const mainAxis = (0, $5CFkC.getOppositeAxis)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            const rawOffset = (0, $5CFkC.evaluate)(offset, state);
            const computedOffset = typeof rawOffset === "number" ? {
                mainAxis: rawOffset,
                crossAxis: 0
            } : {
                mainAxis: 0,
                crossAxis: 0,
                ...rawOffset
            };
            if (checkMainAxis) {
                const len = mainAxis === "y" ? "height" : "width";
                const limitMin = rects.reference[mainAxis] - rects.floating[len] + computedOffset.mainAxis;
                const limitMax = rects.reference[mainAxis] + rects.reference[len] - computedOffset.mainAxis;
                if (mainAxisCoord < limitMin) mainAxisCoord = limitMin;
                else if (mainAxisCoord > limitMax) mainAxisCoord = limitMax;
            }
            if (checkCrossAxis) {
                var _middlewareData$offse, _middlewareData$offse2;
                const len = mainAxis === "y" ? "width" : "height";
                const isOriginSide = [
                    "top",
                    "left"
                ].includes((0, $5CFkC.getSide)(placement));
                const limitMin = rects.reference[crossAxis] - rects.floating[len] + (isOriginSide ? ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse[crossAxis]) || 0 : 0) + (isOriginSide ? 0 : computedOffset.crossAxis);
                const limitMax = rects.reference[crossAxis] + rects.reference[len] + (isOriginSide ? 0 : ((_middlewareData$offse2 = middlewareData.offset) == null ? void 0 : _middlewareData$offse2[crossAxis]) || 0) - (isOriginSide ? computedOffset.crossAxis : 0);
                if (crossAxisCoord < limitMin) crossAxisCoord = limitMin;
                else if (crossAxisCoord > limitMax) crossAxisCoord = limitMax;
            }
            return {
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            };
        }
    };
};
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $1b8c3934b281d5b3$export$346677f925de839c = function(options) {
    if (options === void 0) options = {};
    return {
        name: "size",
        options: options,
        async fn (state) {
            var _state$middlewareData, _state$middlewareData2;
            const { placement: placement, rects: rects, platform: platform, elements: elements } = state;
            const { apply: apply = ()=>{}, ...detectOverflowOptions } = (0, $5CFkC.evaluate)(options, state);
            const overflow = await $1b8c3934b281d5b3$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const side = (0, $5CFkC.getSide)(placement);
            const alignment = (0, $5CFkC.getAlignment)(placement);
            const isYAxis = (0, $5CFkC.getSideAxis)(placement) === "y";
            const { width: width, height: height } = rects.floating;
            let heightSide;
            let widthSide;
            if (side === "top" || side === "bottom") {
                heightSide = side;
                widthSide = alignment === (await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)) ? "start" : "end") ? "left" : "right";
            } else {
                widthSide = side;
                heightSide = alignment === "end" ? "top" : "bottom";
            }
            const maximumClippingHeight = height - overflow.top - overflow.bottom;
            const maximumClippingWidth = width - overflow.left - overflow.right;
            const overflowAvailableHeight = (0, $5CFkC.min)(height - overflow[heightSide], maximumClippingHeight);
            const overflowAvailableWidth = (0, $5CFkC.min)(width - overflow[widthSide], maximumClippingWidth);
            const noShift = !state.middlewareData.shift;
            let availableHeight = overflowAvailableHeight;
            let availableWidth = overflowAvailableWidth;
            if ((_state$middlewareData = state.middlewareData.shift) != null && _state$middlewareData.enabled.x) availableWidth = maximumClippingWidth;
            if ((_state$middlewareData2 = state.middlewareData.shift) != null && _state$middlewareData2.enabled.y) availableHeight = maximumClippingHeight;
            if (noShift && !alignment) {
                const xMin = (0, $5CFkC.max)(overflow.left, 0);
                const xMax = (0, $5CFkC.max)(overflow.right, 0);
                const yMin = (0, $5CFkC.max)(overflow.top, 0);
                const yMax = (0, $5CFkC.max)(overflow.bottom, 0);
                if (isYAxis) availableWidth = width - 2 * (xMin !== 0 || xMax !== 0 ? xMin + xMax : (0, $5CFkC.max)(overflow.left, overflow.right));
                else availableHeight = height - 2 * (yMin !== 0 || yMax !== 0 ? yMin + yMax : (0, $5CFkC.max)(overflow.top, overflow.bottom));
            }
            await apply({
                ...state,
                availableWidth: availableWidth,
                availableHeight: availableHeight
            });
            const nextDimensions = await platform.getDimensions(elements.floating);
            if (width !== nextDimensions.width || height !== nextDimensions.height) return {
                reset: {
                    rects: true
                }
            };
            return {};
        }
    };
};

});
parcelRegister("5CFkC", function(module, exports) {

$parcel$export(module.exports, "sides", function () { return $41808ff345b590f7$export$832b6fa47fa053d2; });
$parcel$export(module.exports, "placements", function () { return $41808ff345b590f7$export$803cd8101b6c182b; });
$parcel$export(module.exports, "min", function () { return $41808ff345b590f7$export$96ec731ed4dcb222; });
$parcel$export(module.exports, "max", function () { return $41808ff345b590f7$export$8960430cfd85939f; });
$parcel$export(module.exports, "round", function () { return $41808ff345b590f7$export$2077e0241d6afd3c; });
$parcel$export(module.exports, "floor", function () { return $41808ff345b590f7$export$a3fe094919f356fd; });
$parcel$export(module.exports, "createCoords", function () { return $41808ff345b590f7$export$a397704b5e280835; });
$parcel$export(module.exports, "clamp", function () { return $41808ff345b590f7$export$7d15b64cf5a3a4c4; });
$parcel$export(module.exports, "evaluate", function () { return $41808ff345b590f7$export$fef61f332f2c0afc; });
$parcel$export(module.exports, "getSide", function () { return $41808ff345b590f7$export$3c915306cb7fc97a; });
$parcel$export(module.exports, "getAlignment", function () { return $41808ff345b590f7$export$f0989780f32bfcda; });
$parcel$export(module.exports, "getOppositeAxis", function () { return $41808ff345b590f7$export$8a000a963141ac32; });
$parcel$export(module.exports, "getAxisLength", function () { return $41808ff345b590f7$export$320bd9d53520c68a; });
$parcel$export(module.exports, "getSideAxis", function () { return $41808ff345b590f7$export$f28e8f882010718a; });
$parcel$export(module.exports, "getAlignmentAxis", function () { return $41808ff345b590f7$export$2b57e0052a6d6d4c; });
$parcel$export(module.exports, "getAlignmentSides", function () { return $41808ff345b590f7$export$be42861551f17911; });
$parcel$export(module.exports, "getOppositePlacement", function () { return $41808ff345b590f7$export$9c5e28bad23365fa; });
$parcel$export(module.exports, "getExpandedPlacements", function () { return $41808ff345b590f7$export$496432a3699e50b1; });
$parcel$export(module.exports, "getOppositeAlignmentPlacement", function () { return $41808ff345b590f7$export$2b182c584985588b; });
$parcel$export(module.exports, "getOppositeAxisPlacements", function () { return $41808ff345b590f7$export$a9b6fb18fd92c3ec; });
$parcel$export(module.exports, "getPaddingObject", function () { return $41808ff345b590f7$export$598c291c29bc2e71; });
$parcel$export(module.exports, "rectToClientRect", function () { return $41808ff345b590f7$export$ee05aea0aeecbad4; });
/**
 * Custom positioning reference element.
 * @see https://floating-ui.com/docs/virtual-elements
 */ const $41808ff345b590f7$export$832b6fa47fa053d2 = [
    "top",
    "right",
    "bottom",
    "left"
];
const $41808ff345b590f7$export$27b07d8a310ed8b5 = [
    "start",
    "end"
];
const $41808ff345b590f7$export$803cd8101b6c182b = /*#__PURE__*/ $41808ff345b590f7$export$832b6fa47fa053d2.reduce((acc, side)=>acc.concat(side, side + "-" + $41808ff345b590f7$export$27b07d8a310ed8b5[0], side + "-" + $41808ff345b590f7$export$27b07d8a310ed8b5[1]), []);
const $41808ff345b590f7$export$96ec731ed4dcb222 = Math.min;
const $41808ff345b590f7$export$8960430cfd85939f = Math.max;
const $41808ff345b590f7$export$2077e0241d6afd3c = Math.round;
const $41808ff345b590f7$export$a3fe094919f356fd = Math.floor;
const $41808ff345b590f7$export$a397704b5e280835 = (v)=>({
        x: v,
        y: v
    });
const $41808ff345b590f7$var$oppositeSideMap = {
    left: "right",
    right: "left",
    bottom: "top",
    top: "bottom"
};
const $41808ff345b590f7$var$oppositeAlignmentMap = {
    start: "end",
    end: "start"
};
function $41808ff345b590f7$export$7d15b64cf5a3a4c4(start, value, end) {
    return $41808ff345b590f7$export$8960430cfd85939f(start, $41808ff345b590f7$export$96ec731ed4dcb222(value, end));
}
function $41808ff345b590f7$export$fef61f332f2c0afc(value, param) {
    return typeof value === "function" ? value(param) : value;
}
function $41808ff345b590f7$export$3c915306cb7fc97a(placement) {
    return placement.split("-")[0];
}
function $41808ff345b590f7$export$f0989780f32bfcda(placement) {
    return placement.split("-")[1];
}
function $41808ff345b590f7$export$8a000a963141ac32(axis) {
    return axis === "x" ? "y" : "x";
}
function $41808ff345b590f7$export$320bd9d53520c68a(axis) {
    return axis === "y" ? "height" : "width";
}
function $41808ff345b590f7$export$f28e8f882010718a(placement) {
    return [
        "top",
        "bottom"
    ].includes($41808ff345b590f7$export$3c915306cb7fc97a(placement)) ? "y" : "x";
}
function $41808ff345b590f7$export$2b57e0052a6d6d4c(placement) {
    return $41808ff345b590f7$export$8a000a963141ac32($41808ff345b590f7$export$f28e8f882010718a(placement));
}
function $41808ff345b590f7$export$be42861551f17911(placement, rects, rtl) {
    if (rtl === void 0) rtl = false;
    const alignment = $41808ff345b590f7$export$f0989780f32bfcda(placement);
    const alignmentAxis = $41808ff345b590f7$export$2b57e0052a6d6d4c(placement);
    const length = $41808ff345b590f7$export$320bd9d53520c68a(alignmentAxis);
    let mainAlignmentSide = alignmentAxis === "x" ? alignment === (rtl ? "end" : "start") ? "right" : "left" : alignment === "start" ? "bottom" : "top";
    if (rects.reference[length] > rects.floating[length]) mainAlignmentSide = $41808ff345b590f7$export$9c5e28bad23365fa(mainAlignmentSide);
    return [
        mainAlignmentSide,
        $41808ff345b590f7$export$9c5e28bad23365fa(mainAlignmentSide)
    ];
}
function $41808ff345b590f7$export$496432a3699e50b1(placement) {
    const oppositePlacement = $41808ff345b590f7$export$9c5e28bad23365fa(placement);
    return [
        $41808ff345b590f7$export$2b182c584985588b(placement),
        oppositePlacement,
        $41808ff345b590f7$export$2b182c584985588b(oppositePlacement)
    ];
}
function $41808ff345b590f7$export$2b182c584985588b(placement) {
    return placement.replace(/start|end/g, (alignment)=>$41808ff345b590f7$var$oppositeAlignmentMap[alignment]);
}
function $41808ff345b590f7$var$getSideList(side, isStart, rtl) {
    const lr = [
        "left",
        "right"
    ];
    const rl = [
        "right",
        "left"
    ];
    const tb = [
        "top",
        "bottom"
    ];
    const bt = [
        "bottom",
        "top"
    ];
    switch(side){
        case "top":
        case "bottom":
            if (rtl) return isStart ? rl : lr;
            return isStart ? lr : rl;
        case "left":
        case "right":
            return isStart ? tb : bt;
        default:
            return [];
    }
}
function $41808ff345b590f7$export$a9b6fb18fd92c3ec(placement, flipAlignment, direction, rtl) {
    const alignment = $41808ff345b590f7$export$f0989780f32bfcda(placement);
    let list = $41808ff345b590f7$var$getSideList($41808ff345b590f7$export$3c915306cb7fc97a(placement), direction === "start", rtl);
    if (alignment) {
        list = list.map((side)=>side + "-" + alignment);
        if (flipAlignment) list = list.concat(list.map($41808ff345b590f7$export$2b182c584985588b));
    }
    return list;
}
function $41808ff345b590f7$export$9c5e28bad23365fa(placement) {
    return placement.replace(/left|right|bottom|top/g, (side)=>$41808ff345b590f7$var$oppositeSideMap[side]);
}
function $41808ff345b590f7$export$1c66dbf1a9e34223(padding) {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        ...padding
    };
}
function $41808ff345b590f7$export$598c291c29bc2e71(padding) {
    return typeof padding !== "number" ? $41808ff345b590f7$export$1c66dbf1a9e34223(padding) : {
        top: padding,
        right: padding,
        bottom: padding,
        left: padding
    };
}
function $41808ff345b590f7$export$ee05aea0aeecbad4(rect) {
    const { x: x, y: y, width: width, height: height } = rect;
    return {
        width: width,
        height: height,
        top: y,
        left: x,
        right: x + width,
        bottom: y + height,
        x: x,
        y: y
    };
}

});


parcelRegister("jGErJ", function(module, exports) {

$parcel$export(module.exports, "getNodeName", function () { return $e551505f3558db83$export$651544f548703224; });
$parcel$export(module.exports, "getWindow", function () { return $e551505f3558db83$export$38b2d434cce3ea22; });
$parcel$export(module.exports, "getDocumentElement", function () { return $e551505f3558db83$export$e495491855dc5418; });
$parcel$export(module.exports, "isElement", function () { return $e551505f3558db83$export$45a5e7f76e0caa8d; });
$parcel$export(module.exports, "isHTMLElement", function () { return $e551505f3558db83$export$1b3bfaa9684536aa; });
$parcel$export(module.exports, "isOverflowElement", function () { return $e551505f3558db83$export$989e911fa9af580a; });
$parcel$export(module.exports, "getComputedStyle", function () { return $e551505f3558db83$export$3735103072e4a80; });
$parcel$export(module.exports, "isTableElement", function () { return $e551505f3558db83$export$71535ffaa902797f; });
$parcel$export(module.exports, "isTopLayer", function () { return $e551505f3558db83$export$89e651af02346cd4; });
$parcel$export(module.exports, "isContainingBlock", function () { return $e551505f3558db83$export$d6c4e8150c35fed1; });
$parcel$export(module.exports, "isWebKit", function () { return $e551505f3558db83$export$78551043582a6a98; });
$parcel$export(module.exports, "getContainingBlock", function () { return $e551505f3558db83$export$940d8225183e1404; });
$parcel$export(module.exports, "getParentNode", function () { return $e551505f3558db83$export$4e12058fc4d51d56; });
$parcel$export(module.exports, "isLastTraversableNode", function () { return $e551505f3558db83$export$d1162fb0b6d4cd51; });
$parcel$export(module.exports, "getNodeScroll", function () { return $e551505f3558db83$export$dc8fc79fa2800137; });
$parcel$export(module.exports, "getOverflowAncestors", function () { return $e551505f3558db83$export$3b57c1601291186b; });
$parcel$export(module.exports, "getFrameElement", function () { return $e551505f3558db83$export$7bf1f8740e3e34af; });
function $e551505f3558db83$var$hasWindow() {
    return typeof window !== "undefined";
}
function $e551505f3558db83$export$651544f548703224(node) {
    if ($e551505f3558db83$export$8ee0fc9ee280b4ee(node)) return (node.nodeName || "").toLowerCase();
    // Mocked nodes in testing environments may not be instances of Node. By
    // returning `#document` an infinite loop won't occur.
    // https://github.com/floating-ui/floating-ui/issues/2317
    return "#document";
}
function $e551505f3558db83$export$38b2d434cce3ea22(node) {
    var _node$ownerDocument;
    return (node == null || (_node$ownerDocument = node.ownerDocument) == null ? void 0 : _node$ownerDocument.defaultView) || window;
}
function $e551505f3558db83$export$e495491855dc5418(node) {
    var _ref;
    return (_ref = ($e551505f3558db83$export$8ee0fc9ee280b4ee(node) ? node.ownerDocument : node.document) || window.document) == null ? void 0 : _ref.documentElement;
}
function $e551505f3558db83$export$8ee0fc9ee280b4ee(value) {
    if (!$e551505f3558db83$var$hasWindow()) return false;
    return value instanceof Node || value instanceof $e551505f3558db83$export$38b2d434cce3ea22(value).Node;
}
function $e551505f3558db83$export$45a5e7f76e0caa8d(value) {
    if (!$e551505f3558db83$var$hasWindow()) return false;
    return value instanceof Element || value instanceof $e551505f3558db83$export$38b2d434cce3ea22(value).Element;
}
function $e551505f3558db83$export$1b3bfaa9684536aa(value) {
    if (!$e551505f3558db83$var$hasWindow()) return false;
    return value instanceof HTMLElement || value instanceof $e551505f3558db83$export$38b2d434cce3ea22(value).HTMLElement;
}
function $e551505f3558db83$export$af51f0f06c0f328a(value) {
    if (!$e551505f3558db83$var$hasWindow() || typeof ShadowRoot === "undefined") return false;
    return value instanceof ShadowRoot || value instanceof $e551505f3558db83$export$38b2d434cce3ea22(value).ShadowRoot;
}
function $e551505f3558db83$export$989e911fa9af580a(element) {
    const { overflow: overflow, overflowX: overflowX, overflowY: overflowY, display: display } = $e551505f3558db83$export$3735103072e4a80(element);
    return /auto|scroll|overlay|hidden|clip/.test(overflow + overflowY + overflowX) && ![
        "inline",
        "contents"
    ].includes(display);
}
function $e551505f3558db83$export$71535ffaa902797f(element) {
    return [
        "table",
        "td",
        "th"
    ].includes($e551505f3558db83$export$651544f548703224(element));
}
function $e551505f3558db83$export$89e651af02346cd4(element) {
    return [
        ":popover-open",
        ":modal"
    ].some((selector)=>{
        try {
            return element.matches(selector);
        } catch (e) {
            return false;
        }
    });
}
function $e551505f3558db83$export$d6c4e8150c35fed1(elementOrCss) {
    const webkit = $e551505f3558db83$export$78551043582a6a98();
    const css = $e551505f3558db83$export$45a5e7f76e0caa8d(elementOrCss) ? $e551505f3558db83$export$3735103072e4a80(elementOrCss) : elementOrCss;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    return css.transform !== "none" || css.perspective !== "none" || (css.containerType ? css.containerType !== "normal" : false) || !webkit && (css.backdropFilter ? css.backdropFilter !== "none" : false) || !webkit && (css.filter ? css.filter !== "none" : false) || [
        "transform",
        "perspective",
        "filter"
    ].some((value)=>(css.willChange || "").includes(value)) || [
        "paint",
        "layout",
        "strict",
        "content"
    ].some((value)=>(css.contain || "").includes(value));
}
function $e551505f3558db83$export$940d8225183e1404(element) {
    let currentNode = $e551505f3558db83$export$4e12058fc4d51d56(element);
    while($e551505f3558db83$export$1b3bfaa9684536aa(currentNode) && !$e551505f3558db83$export$d1162fb0b6d4cd51(currentNode)){
        if ($e551505f3558db83$export$d6c4e8150c35fed1(currentNode)) return currentNode;
        else if ($e551505f3558db83$export$89e651af02346cd4(currentNode)) return null;
        currentNode = $e551505f3558db83$export$4e12058fc4d51d56(currentNode);
    }
    return null;
}
function $e551505f3558db83$export$78551043582a6a98() {
    if (typeof CSS === "undefined" || !CSS.supports) return false;
    return CSS.supports("-webkit-backdrop-filter", "none");
}
function $e551505f3558db83$export$d1162fb0b6d4cd51(node) {
    return [
        "html",
        "body",
        "#document"
    ].includes($e551505f3558db83$export$651544f548703224(node));
}
function $e551505f3558db83$export$3735103072e4a80(element) {
    return $e551505f3558db83$export$38b2d434cce3ea22(element).getComputedStyle(element);
}
function $e551505f3558db83$export$dc8fc79fa2800137(element) {
    if ($e551505f3558db83$export$45a5e7f76e0caa8d(element)) return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
    return {
        scrollLeft: element.scrollX,
        scrollTop: element.scrollY
    };
}
function $e551505f3558db83$export$4e12058fc4d51d56(node) {
    if ($e551505f3558db83$export$651544f548703224(node) === "html") return node;
    const result = // Step into the shadow DOM of the parent of a slotted node.
    node.assignedSlot || // DOM Element detected.
    node.parentNode || // ShadowRoot detected.
    $e551505f3558db83$export$af51f0f06c0f328a(node) && node.host || // Fallback.
    $e551505f3558db83$export$e495491855dc5418(node);
    return $e551505f3558db83$export$af51f0f06c0f328a(result) ? result.host : result;
}
function $e551505f3558db83$export$7cd01a57c8ca906c(node) {
    const parentNode = $e551505f3558db83$export$4e12058fc4d51d56(node);
    if ($e551505f3558db83$export$d1162fb0b6d4cd51(parentNode)) return node.ownerDocument ? node.ownerDocument.body : node.body;
    if ($e551505f3558db83$export$1b3bfaa9684536aa(parentNode) && $e551505f3558db83$export$989e911fa9af580a(parentNode)) return parentNode;
    return $e551505f3558db83$export$7cd01a57c8ca906c(parentNode);
}
function $e551505f3558db83$export$3b57c1601291186b(node, list, traverseIframes) {
    var _node$ownerDocument2;
    if (list === void 0) list = [];
    if (traverseIframes === void 0) traverseIframes = true;
    const scrollableAncestor = $e551505f3558db83$export$7cd01a57c8ca906c(node);
    const isBody = scrollableAncestor === ((_node$ownerDocument2 = node.ownerDocument) == null ? void 0 : _node$ownerDocument2.body);
    const win = $e551505f3558db83$export$38b2d434cce3ea22(scrollableAncestor);
    if (isBody) {
        const frameElement = $e551505f3558db83$export$7bf1f8740e3e34af(win);
        return list.concat(win, win.visualViewport || [], $e551505f3558db83$export$989e911fa9af580a(scrollableAncestor) ? scrollableAncestor : [], frameElement && traverseIframes ? $e551505f3558db83$export$3b57c1601291186b(frameElement) : []);
    }
    return list.concat(scrollableAncestor, $e551505f3558db83$export$3b57c1601291186b(scrollableAncestor, [], traverseIframes));
}
function $e551505f3558db83$export$7bf1f8740e3e34af(win) {
    return win.parent && Object.getPrototypeOf(win.parent) ? win.frameElement : null;
}

});


parcelRegister("3k7Ry", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $26b956bc170d5dee$export$2e2bcd8739ae039; });

var $dAx5m = parcelRequire("dAx5m");
var $26b956bc170d5dee$var$index = (0, $dAx5m.useLayoutEffect);
var $26b956bc170d5dee$export$2e2bcd8739ae039 = $26b956bc170d5dee$var$index;

});



parcelRegister("9Zr3u", function(module, exports) {

var $hkD8d = parcelRequire("hkD8d");
function $745ecc28ef146ef6$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $745ecc28ef146ef6$var$_objectSpread2(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $745ecc28ef146ef6$var$ownKeys(Object(t), !0).forEach(function(r) {
            $hkD8d(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $745ecc28ef146ef6$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
module.exports = $745ecc28ef146ef6$var$_objectSpread2, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("hkD8d", function(module, exports) {

var $8s4vg = parcelRequire("8s4vg");
function $0341975d8357f625$var$_defineProperty(e, r, t) {
    return (r = $8s4vg(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
module.exports = $0341975d8357f625$var$_defineProperty, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("8s4vg", function(module, exports) {

var $kTnsx = parcelRequire("kTnsx");
var $62746e7ef0ec87ba$var$_typeof = $kTnsx.default;

var $jfHpi = parcelRequire("jfHpi");
function $62746e7ef0ec87ba$var$toPropertyKey(t) {
    var i = $jfHpi(t, "string");
    return "symbol" == $62746e7ef0ec87ba$var$_typeof(i) ? i : i + "";
}
module.exports = $62746e7ef0ec87ba$var$toPropertyKey, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("kTnsx", function(module, exports) {
function $f35b243d37c2b955$var$_typeof(o) {
    "@babel/helpers - typeof";
    return module.exports = $f35b243d37c2b955$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $f35b243d37c2b955$var$_typeof(o);
}
module.exports = $f35b243d37c2b955$var$_typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("jfHpi", function(module, exports) {

var $kTnsx = parcelRequire("kTnsx");
var $e04116c3af10c408$var$_typeof = $kTnsx.default;
function $e04116c3af10c408$var$toPrimitive(t, r) {
    if ("object" != $e04116c3af10c408$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $e04116c3af10c408$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
module.exports = $e04116c3af10c408$var$toPrimitive, module.exports.__esModule = true, module.exports["default"] = module.exports;

});




parcelRegister("cK17F", function(module, exports) {

var $01Onr = parcelRequire("01Onr");

var $cJoSX = parcelRequire("cJoSX");

var $1xXXT = parcelRequire("1xXXT");

var $cMQBa = parcelRequire("cMQBa");
function $946aa6d84a4dd60a$var$_slicedToArray(r, e) {
    return $01Onr(r) || $cJoSX(r, e) || $1xXXT(r, e) || $cMQBa();
}
module.exports = $946aa6d84a4dd60a$var$_slicedToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("01Onr", function(module, exports) {
function $00572bf843b95ec4$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
module.exports = $00572bf843b95ec4$var$_arrayWithHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("cJoSX", function(module, exports) {
function $944cfdb6a793f41c$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
module.exports = $944cfdb6a793f41c$var$_iterableToArrayLimit, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("1xXXT", function(module, exports) {

var $boJTB = parcelRequire("boJTB");
function $1207634a9939f9ec$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $boJTB(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $boJTB(r, a) : void 0;
    }
}
module.exports = $1207634a9939f9ec$var$_unsupportedIterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("boJTB", function(module, exports) {
function $84c5898d9d932217$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
module.exports = $84c5898d9d932217$var$_arrayLikeToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("cMQBa", function(module, exports) {
function $94f2c4adce7b67dd$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
module.exports = $94f2c4adce7b67dd$var$_nonIterableRest, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("7RQoD", function(module, exports) {

var $kFLrG = parcelRequire("kFLrG");
function $5ba62071a08920d9$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $kFLrG(e, t);
    if (Object.getOwnPropertySymbols) {
        var s = Object.getOwnPropertySymbols(e);
        for(r = 0; r < s.length; r++)o = s[r], t.includes(o) || ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
module.exports = $5ba62071a08920d9$var$_objectWithoutProperties, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("kFLrG", function(module, exports) {
function $f0cc70afd3b5cba8$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.includes(n)) continue;
        t[n] = r[n];
    }
    return t;
}
module.exports = $f0cc70afd3b5cba8$var$_objectWithoutPropertiesLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("9B1JN", function(module, exports) {
function $6fc8ead47fff947c$var$_classCallCheck(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
module.exports = $6fc8ead47fff947c$var$_classCallCheck, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("fHWei", function(module, exports) {

var $8s4vg = parcelRequire("8s4vg");
function $b6f80a5a880bfd8c$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, $8s4vg(o.key), o);
    }
}
function $b6f80a5a880bfd8c$var$_createClass(e, r, t) {
    return r && $b6f80a5a880bfd8c$var$_defineProperties(e.prototype, r), t && $b6f80a5a880bfd8c$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}
module.exports = $b6f80a5a880bfd8c$var$_createClass, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("gRE01", function(module, exports) {

var $hi5TG = parcelRequire("hi5TG");
function $c4709f9f5c7358e3$var$_inherits(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && $hi5TG(t, e);
}
module.exports = $c4709f9f5c7358e3$var$_inherits, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("hi5TG", function(module, exports) {
function $c968b12b281afe18$var$_setPrototypeOf(t, e) {
    return module.exports = $c968b12b281afe18$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $c968b12b281afe18$var$_setPrototypeOf(t, e);
}
module.exports = $c968b12b281afe18$var$_setPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("4Szvh", function(module, exports) {

var $fwsHr = parcelRequire("fwsHr");

var $7gpC1 = parcelRequire("7gpC1");

var $2mqJ7 = parcelRequire("2mqJ7");
function $38d7becfe32d886e$var$_createSuper(t) {
    var r = $7gpC1();
    return function() {
        var e, o = $fwsHr(t);
        if (r) {
            var s = $fwsHr(this).constructor;
            e = Reflect.construct(o, arguments, s);
        } else e = o.apply(this, arguments);
        return $2mqJ7(this, e);
    };
}
module.exports = $38d7becfe32d886e$var$_createSuper, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("fwsHr", function(module, exports) {
function $b4d01b5705e28977$var$_getPrototypeOf(t) {
    return module.exports = $b4d01b5705e28977$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $b4d01b5705e28977$var$_getPrototypeOf(t);
}
module.exports = $b4d01b5705e28977$var$_getPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("7gpC1", function(module, exports) {
function $549de513f52efbfa$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return (module.exports = $549de513f52efbfa$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports)();
}
module.exports = $549de513f52efbfa$var$_isNativeReflectConstruct, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("2mqJ7", function(module, exports) {

var $kTnsx = parcelRequire("kTnsx");
var $1b825e34119dfb05$var$_typeof = $kTnsx.default;

var $4DcYE = parcelRequire("4DcYE");
function $1b825e34119dfb05$var$_possibleConstructorReturn(t, e) {
    if (e && ("object" == $1b825e34119dfb05$var$_typeof(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return $4DcYE(t);
}
module.exports = $1b825e34119dfb05$var$_possibleConstructorReturn, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("4DcYE", function(module, exports) {
function $35f4deefa274e613$var$_assertThisInitialized(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}
module.exports = $35f4deefa274e613$var$_assertThisInitialized, module.exports.__esModule = true, module.exports["default"] = module.exports;

});



parcelRegister("iLhwL", function(module, exports) {

var $9WjAP = parcelRequire("9WjAP");

var $5uMM1 = parcelRequire("5uMM1");

var $1xXXT = parcelRequire("1xXXT");

var $030Gg = parcelRequire("030Gg");
function $da8a365d999996e8$var$_toConsumableArray(r) {
    return $9WjAP(r) || $5uMM1(r) || $1xXXT(r) || $030Gg();
}
module.exports = $da8a365d999996e8$var$_toConsumableArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("9WjAP", function(module, exports) {

var $boJTB = parcelRequire("boJTB");
function $73c8ba966fa7e172$var$_arrayWithoutHoles(r) {
    if (Array.isArray(r)) return $boJTB(r);
}
module.exports = $73c8ba966fa7e172$var$_arrayWithoutHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("5uMM1", function(module, exports) {
function $4005968542f5f063$var$_iterableToArray(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
module.exports = $4005968542f5f063$var$_iterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("030Gg", function(module, exports) {
function $0090cf14c0acedad$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
module.exports = $0090cf14c0acedad$var$_nonIterableSpread, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("agZsZ", function(module, exports) {
function $77ab140234feb101$var$_taggedTemplateLiteral(e, t) {
    return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, {
        raw: {
            value: Object.freeze(t)
        }
    }));
}
module.exports = $77ab140234feb101$var$_taggedTemplateLiteral, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("ae7Ah", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7721183d37b18d3f$export$2e2bcd8739ae039; });
var $7721183d37b18d3f$export$2e2bcd8739ae039 = function(channel) {
    return function(payload) {
        return function(createAnalyticsEvent) {
            var consumerEvent = createAnalyticsEvent(payload);
            var clonedEvent = consumerEvent.clone();
            if (clonedEvent) clonedEvent.fire(channel);
            return consumerEvent;
        };
    };
};

});

parcelRegister("1yqRj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $121dcd0e9a4ac009$export$2e2bcd8739ae039; });

var $ddhXb = parcelRequire("ddhXb");

var $gvqMl = parcelRequire("gvqMl");

var $aJTPI = parcelRequire("aJTPI");

var $dAx5m = parcelRequire("dAx5m");

var $cctkx = parcelRequire("cctkx");
var $121dcd0e9a4ac009$var$_excluded = [
    "analyticsContext"
];
function $121dcd0e9a4ac009$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $121dcd0e9a4ac009$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $121dcd0e9a4ac009$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($gvqMl)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $121dcd0e9a4ac009$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $121dcd0e9a4ac009$var$withAnalyticsContext = function withAnalyticsContext(defaultData) {
    return function(WrappedComponent) {
        var WithAnalyticsContext = /*#__PURE__*/ (0, $dAx5m.forwardRef)(function(_ref, ref) {
            var analyticsContext = _ref.analyticsContext, rest = (0, (/*@__PURE__*/$parcel$interopDefault($aJTPI)))(_ref, $121dcd0e9a4ac009$var$_excluded);
            var analyticsData = (0, $dAx5m.useMemo)(function() {
                return $121dcd0e9a4ac009$var$_objectSpread($121dcd0e9a4ac009$var$_objectSpread({}, defaultData), analyticsContext);
            }, [
                analyticsContext
            ]);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $cctkx.default), {
                data: analyticsData
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement(WrappedComponent, (0, (/*@__PURE__*/$parcel$interopDefault($ddhXb)))({}, rest, {
                ref: ref
            })));
        });
        WithAnalyticsContext.displayName = "WithAnalyticsContext(".concat(WrappedComponent.displayName || WrappedComponent.name, ")");
        return WithAnalyticsContext;
    };
};
var $121dcd0e9a4ac009$export$2e2bcd8739ae039 = $121dcd0e9a4ac009$var$withAnalyticsContext;

});
parcelRegister("ddhXb", function(module, exports) {
function $99ea6a70c8a8f92a$var$_extends() {
    return module.exports = $99ea6a70c8a8f92a$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $99ea6a70c8a8f92a$var$_extends.apply(null, arguments);
}
module.exports = $99ea6a70c8a8f92a$var$_extends, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("gvqMl", function(module, exports) {

var $ksQI6 = parcelRequire("ksQI6");
function $c04450493144ab3c$var$_defineProperty(e, r, t) {
    return (r = $ksQI6(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
module.exports = $c04450493144ab3c$var$_defineProperty, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("ksQI6", function(module, exports) {

var $gb7w6 = parcelRequire("gb7w6");
var $ee5f4f593361476f$var$_typeof = $gb7w6.default;

var $gz7OX = parcelRequire("gz7OX");
function $ee5f4f593361476f$var$toPropertyKey(t) {
    var i = $gz7OX(t, "string");
    return "symbol" == $ee5f4f593361476f$var$_typeof(i) ? i : i + "";
}
module.exports = $ee5f4f593361476f$var$toPropertyKey, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("gb7w6", function(module, exports) {
function $bc738117c0cb66ad$var$_typeof(o) {
    "@babel/helpers - typeof";
    return module.exports = $bc738117c0cb66ad$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $bc738117c0cb66ad$var$_typeof(o);
}
module.exports = $bc738117c0cb66ad$var$_typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("gz7OX", function(module, exports) {

var $gb7w6 = parcelRequire("gb7w6");
var $c0f5fb44bfc1626f$var$_typeof = $gb7w6.default;
function $c0f5fb44bfc1626f$var$toPrimitive(t, r) {
    if ("object" != $c0f5fb44bfc1626f$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $c0f5fb44bfc1626f$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
module.exports = $c0f5fb44bfc1626f$var$toPrimitive, module.exports.__esModule = true, module.exports["default"] = module.exports;

});



parcelRegister("aJTPI", function(module, exports) {

var $aHqQP = parcelRequire("aHqQP");
function $7d196aa16740d370$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $aHqQP(e, t);
    if (Object.getOwnPropertySymbols) {
        var s = Object.getOwnPropertySymbols(e);
        for(r = 0; r < s.length; r++)o = s[r], t.includes(o) || ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
module.exports = $7d196aa16740d370$var$_objectWithoutProperties, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("aHqQP", function(module, exports) {
function $7ca2bf9ce70e54d4$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.includes(n)) continue;
        t[n] = r[n];
    }
    return t;
}
module.exports = $7ca2bf9ce70e54d4$var$_objectWithoutPropertiesLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("cctkx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8e1d5b62f0a1feee$export$2e2bcd8739ae039; });

var $dAx5m = parcelRequire("dAx5m");

var $6QZem = parcelRequire("6QZem");

var $jRnYs = parcelRequire("jRnYs");

var $84Eqk = parcelRequire("84Eqk");

var $jiEJM = parcelRequire("jiEJM");
var $8e1d5b62f0a1feee$var$ExportedAnalyticsContext = function ExportedAnalyticsContext(props) {
    var isModernContext = (0, $jRnYs.default) || (0, $6QZem.fg)("platform.analytics-next-use-modern-context_fqgbx");
    return isModernContext ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $jiEJM.default), props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $84Eqk.default), props);
};
var $8e1d5b62f0a1feee$export$2e2bcd8739ae039 = $8e1d5b62f0a1feee$var$ExportedAnalyticsContext;

});
parcelRegister("6QZem", function(module, exports) {

$parcel$export(module.exports, "fg", function () { return $4fd7188ede98baea$export$b40ec24ac8275656; });

var $hA3MK = parcelRequire("hA3MK");
function $4fd7188ede98baea$export$ba05d765b8392e5e(flagResolver) {
    (0, $hA3MK.setBooleanResolver)(flagResolver);
}
function $4fd7188ede98baea$export$470e5c2be1411c89(name) {
    return (0, $hA3MK.resolveBooleanFlag)(name);
}
function $4fd7188ede98baea$export$b40ec24ac8275656(name) {
    return (0, $hA3MK.resolveBooleanFlag)(name);
}

});
parcelRegister("hA3MK", function(module, exports) {

$parcel$export(module.exports, "setBooleanResolver", function () { return $ccc8bc2655512a8e$export$f2b591175b3e424c; });
$parcel$export(module.exports, "resolveBooleanFlag", function () { return $ccc8bc2655512a8e$export$6333b6aff9fc6275; });

var $c7b5J = parcelRequire("c7b5J");

var $ahJoN = parcelRequire("ahJoN");
var $ccc8bc2655512a8e$var$pkgName = "@atlaskit/platform-feature-flags";
var $ccc8bc2655512a8e$export$7e41b1b2bdee3f98 = "__PLATFORM_FEATURE_FLAGS__";
var $ccc8bc2655512a8e$var$hasProcessEnv = typeof $ahJoN !== "undefined" && typeof $ahJoN.env !== "undefined";
// FF global overrides can be configured by test runners or Storybook
var $ccc8bc2655512a8e$var$ENV_ENABLE_PLATFORM_FF = $ccc8bc2655512a8e$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
// STORYBOOK_ENABLE_PLATFORM_FF is included as storybook only allows env vars prefixed with STORYBOOK
// https://github.com/storybookjs/storybook/issues/12270
var $ccc8bc2655512a8e$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF = $ccc8bc2655512a8e$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
var $ccc8bc2655512a8e$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE = $ccc8bc2655512a8e$var$ENV_ENABLE_PLATFORM_FF || $ccc8bc2655512a8e$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF;
var $ccc8bc2655512a8e$var$DEFAULT_PFF_GLOBAL = {
    // In development mode we want to capture any feature flag checks that happen using the default resolver and log this result when the resolver is replaced.
    // This is because evaluating feature flags when the resolver/FF client is loaded asynchronously could cause unexpected issues.
    earlyResolvedFlags: new Map(),
    booleanResolver: function booleanResolver(flagKey) {
        var unresolvedFlagCount;
        return false;
    }
};
var $ccc8bc2655512a8e$var$globalVar = typeof window !== "undefined" ? window : globalThis;
$ccc8bc2655512a8e$var$globalVar[$ccc8bc2655512a8e$export$7e41b1b2bdee3f98] = $ccc8bc2655512a8e$var$globalVar[$ccc8bc2655512a8e$export$7e41b1b2bdee3f98] || $ccc8bc2655512a8e$var$DEFAULT_PFF_GLOBAL;
function $ccc8bc2655512a8e$export$f2b591175b3e424c(resolver) {
    $ccc8bc2655512a8e$var$globalVar[$ccc8bc2655512a8e$export$7e41b1b2bdee3f98].booleanResolver = resolver;
    var _globalVar$PFF_GLOBAL;
}
function $ccc8bc2655512a8e$export$6333b6aff9fc6275(flagKey) {
    if ($ccc8bc2655512a8e$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE) {
        (0, $c7b5J.debug)('[%s]: The feature flags were enabled while running tests. The flag "%s" will be always enabled.', $ccc8bc2655512a8e$var$pkgName, flagKey);
        return true;
    }
    try {
        var _globalVar$PFF_GLOBAL2;
        var result = (_globalVar$PFF_GLOBAL2 = $ccc8bc2655512a8e$var$globalVar[$ccc8bc2655512a8e$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL2 === void 0 ? void 0 : _globalVar$PFF_GLOBAL2.booleanResolver(flagKey);
        if (typeof result !== "boolean") {
            // eslint-disable-next-line no-console
            console.warn("".concat(flagKey, " resolved to a non-boolean value, returning false for safety"));
            return false;
        }
        return result;
    } catch (e) {
        return false;
    }
}

});
parcelRegister("c7b5J", function(module, exports) {

$parcel$export(module.exports, "debug", function () { return $8d1ebe0145fc0a55$export$1c9f709888824e05; });
var $8d1ebe0145fc0a55$var$_ref, $8d1ebe0145fc0a55$var$_process, $8d1ebe0145fc0a55$var$_process2;
// We can't rely on NODE_ENV === 'test' if its value is already configured by the consumer to some other value, so better to use JEST_WORKER_ID
// https://jestjs.io/docs/environment-variables#jest_worker_id
var $8d1ebe0145fc0a55$var$TESTS_MODE = ($8d1ebe0145fc0a55$var$_ref = (globalThis === null || globalThis === void 0 || ($8d1ebe0145fc0a55$var$_process = globalThis.process) === null || $8d1ebe0145fc0a55$var$_process === void 0 || ($8d1ebe0145fc0a55$var$_process = $8d1ebe0145fc0a55$var$_process.env) === null || $8d1ebe0145fc0a55$var$_process === void 0 ? void 0 : $8d1ebe0145fc0a55$var$_process.JEST_WORKER_ID) !== undefined, $8d1ebe0145fc0a55$var$_ref !== void 0) ? $8d1ebe0145fc0a55$var$_ref : false;
var $8d1ebe0145fc0a55$var$DEBUG_MODE = !$8d1ebe0145fc0a55$var$TESTS_MODE && (globalThis === null || globalThis === void 0 || ($8d1ebe0145fc0a55$var$_process2 = globalThis.process) === null || $8d1ebe0145fc0a55$var$_process2 === void 0 || ($8d1ebe0145fc0a55$var$_process2 = $8d1ebe0145fc0a55$var$_process2.env) === null || $8d1ebe0145fc0a55$var$_process2 === void 0 ? void 0 : $8d1ebe0145fc0a55$var$_process2.NODE_ENV) !== "production";
var $8d1ebe0145fc0a55$export$1c9f709888824e05 = function debug() {
    var _console;
    if (!$8d1ebe0145fc0a55$var$DEBUG_MODE) return;
    // eslint-disable-next-line no-console
    (_console = console).debug.apply(_console, arguments);
};

});



parcelRegister("jRnYs", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e7559050cb5db882$export$2e2bcd8739ae039; });

var $ahJoN = parcelRequire("ahJoN");
var $e7559050cb5db882$var$_process$env;
var $e7559050cb5db882$export$2e2bcd8739ae039 = typeof $ahJoN !== "undefined" && $ahJoN !== null && (($e7559050cb5db882$var$_process$env = {}, $e7559050cb5db882$var$_process$env === void 0) ? void 0 : $e7559050cb5db882$var$_process$env["ANALYTICS_NEXT_MODERN_CONTEXT"]);

});

parcelRegister("84Eqk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $01845b0f8ce6d534$export$2e2bcd8739ae039; });

var $bslcD = parcelRequire("bslcD");

var $jYzo9 = parcelRequire("jYzo9");

var $eCdDc = parcelRequire("eCdDc");

var $7nGU9 = parcelRequire("7nGU9");

var $4TW8y = parcelRequire("4TW8y");

var $lXiHY = parcelRequire("lXiHY");

var $jNO0s = parcelRequire("jNO0s");

var $gvqMl = parcelRequire("gvqMl");

var $dAx5m = parcelRequire("dAx5m");

var $hyn2k = parcelRequire("hyn2k");

var $h0bf1 = parcelRequire("h0bf1");
function $01845b0f8ce6d534$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $01845b0f8ce6d534$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, (/*@__PURE__*/$parcel$interopDefault($jNO0s)))(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, (/*@__PURE__*/$parcel$interopDefault($jNO0s)))(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, (/*@__PURE__*/$parcel$interopDefault($lXiHY)))(this, result);
    };
}
function $01845b0f8ce6d534$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($01845b0f8ce6d534$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $01845b0f8ce6d534$var$ContextTypes = {
    getAtlaskitAnalyticsContext: (0, (/*@__PURE__*/$parcel$interopDefault($hyn2k))).func,
    getAtlaskitAnalyticsEventHandlers: (0, (/*@__PURE__*/$parcel$interopDefault($hyn2k))).func
};
var $01845b0f8ce6d534$var$noop = function noop() {
    return [];
};
// eslint-disable-next-line @repo/internal/react/no-class-components
var $01845b0f8ce6d534$var$AnalyticsContext = /*#__PURE__*/ function(_Component) {
    (0, (/*@__PURE__*/$parcel$interopDefault($4TW8y)))(AnalyticsContext, _Component);
    var _super = $01845b0f8ce6d534$var$_createSuper(AnalyticsContext);
    function AnalyticsContext(props) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($jYzo9)))(this, AnalyticsContext);
        _this = _super.call(this, props);
        (0, (/*@__PURE__*/$parcel$interopDefault($gvqMl)))((0, (/*@__PURE__*/$parcel$interopDefault($7nGU9)))(_this), "getChildContext", function() {
            return {
                getAtlaskitAnalyticsContext: _this.getAnalyticsContext
            };
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($gvqMl)))((0, (/*@__PURE__*/$parcel$interopDefault($7nGU9)))(_this), "getAnalyticsContext", function() {
            var data = _this.props.data;
            var _this$context$getAtla = _this.context.getAtlaskitAnalyticsContext, getAtlaskitAnalyticsContext = _this$context$getAtla === void 0 ? $01845b0f8ce6d534$var$noop : _this$context$getAtla;
            return [].concat((0, (/*@__PURE__*/$parcel$interopDefault($bslcD)))(getAtlaskitAnalyticsContext()), [
                data
            ]);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($gvqMl)))((0, (/*@__PURE__*/$parcel$interopDefault($7nGU9)))(_this), "getAnalyticsEventHandlers", function() {
            var _this$context$getAtla2 = _this.context.getAtlaskitAnalyticsEventHandlers, getAtlaskitAnalyticsEventHandlers = _this$context$getAtla2 === void 0 ? $01845b0f8ce6d534$var$noop : _this$context$getAtla2;
            return getAtlaskitAnalyticsEventHandlers();
        });
        _this.contextValue = {
            getAtlaskitAnalyticsContext: _this.getAnalyticsContext,
            getAtlaskitAnalyticsEventHandlers: _this.getAnalyticsEventHandlers
        };
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eCdDc)))(AnalyticsContext, [
        {
            key: "render",
            value: function render() {
                var children = this.props.children;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $h0bf1.default).Provider, {
                    value: this.contextValue
                }, children);
            }
        }
    ]);
    return AnalyticsContext;
}((0, $dAx5m.Component));
(0, (/*@__PURE__*/$parcel$interopDefault($gvqMl)))($01845b0f8ce6d534$var$AnalyticsContext, "contextTypes", $01845b0f8ce6d534$var$ContextTypes);
(0, (/*@__PURE__*/$parcel$interopDefault($gvqMl)))($01845b0f8ce6d534$var$AnalyticsContext, "childContextTypes", $01845b0f8ce6d534$var$ContextTypes);
var $01845b0f8ce6d534$export$2e2bcd8739ae039 = $01845b0f8ce6d534$var$AnalyticsContext;

});
parcelRegister("bslcD", function(module, exports) {

var $grcY4 = parcelRequire("grcY4");

var $lD0py = parcelRequire("lD0py");

var $8CMGv = parcelRequire("8CMGv");

var $9XBui = parcelRequire("9XBui");
function $8572c1a5ec1a8c40$var$_toConsumableArray(r) {
    return $grcY4(r) || $lD0py(r) || $8CMGv(r) || $9XBui();
}
module.exports = $8572c1a5ec1a8c40$var$_toConsumableArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("grcY4", function(module, exports) {

var $cJaqe = parcelRequire("cJaqe");
function $bf793a1a51256977$var$_arrayWithoutHoles(r) {
    if (Array.isArray(r)) return $cJaqe(r);
}
module.exports = $bf793a1a51256977$var$_arrayWithoutHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("cJaqe", function(module, exports) {
function $9441c59c63c40756$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
module.exports = $9441c59c63c40756$var$_arrayLikeToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("lD0py", function(module, exports) {
function $fbed8f20cb7ade90$var$_iterableToArray(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
module.exports = $fbed8f20cb7ade90$var$_iterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("8CMGv", function(module, exports) {

var $cJaqe = parcelRequire("cJaqe");
function $019ed53619a424db$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $cJaqe(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $cJaqe(r, a) : void 0;
    }
}
module.exports = $019ed53619a424db$var$_unsupportedIterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("9XBui", function(module, exports) {
function $7406b3fd92361477$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
module.exports = $7406b3fd92361477$var$_nonIterableSpread, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("jYzo9", function(module, exports) {
function $e8af1252217ca0f9$var$_classCallCheck(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
module.exports = $e8af1252217ca0f9$var$_classCallCheck, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("eCdDc", function(module, exports) {

var $ksQI6 = parcelRequire("ksQI6");
function $aa3f302f4e2fe411$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, $ksQI6(o.key), o);
    }
}
function $aa3f302f4e2fe411$var$_createClass(e, r, t) {
    return r && $aa3f302f4e2fe411$var$_defineProperties(e.prototype, r), t && $aa3f302f4e2fe411$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}
module.exports = $aa3f302f4e2fe411$var$_createClass, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("7nGU9", function(module, exports) {
function $55fbf65592241294$var$_assertThisInitialized(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}
module.exports = $55fbf65592241294$var$_assertThisInitialized, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("4TW8y", function(module, exports) {

var $clyex = parcelRequire("clyex");
function $3919654502698503$var$_inherits(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && $clyex(t, e);
}
module.exports = $3919654502698503$var$_inherits, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("clyex", function(module, exports) {
function $8fd200411187f1d6$var$_setPrototypeOf(t, e) {
    return module.exports = $8fd200411187f1d6$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $8fd200411187f1d6$var$_setPrototypeOf(t, e);
}
module.exports = $8fd200411187f1d6$var$_setPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("lXiHY", function(module, exports) {

var $gb7w6 = parcelRequire("gb7w6");
var $ffbd9ebc9d6a54cd$var$_typeof = $gb7w6.default;

var $7nGU9 = parcelRequire("7nGU9");
function $ffbd9ebc9d6a54cd$var$_possibleConstructorReturn(t, e) {
    if (e && ("object" == $ffbd9ebc9d6a54cd$var$_typeof(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return $7nGU9(t);
}
module.exports = $ffbd9ebc9d6a54cd$var$_possibleConstructorReturn, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("jNO0s", function(module, exports) {
function $e6a962244559bac8$var$_getPrototypeOf(t) {
    return module.exports = $e6a962244559bac8$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $e6a962244559bac8$var$_getPrototypeOf(t);
}
module.exports = $e6a962244559bac8$var$_getPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("jiEJM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e0cf4c609ccd1546$export$2e2bcd8739ae039; });

var $bslcD = parcelRequire("bslcD");

var $dAx5m = parcelRequire("dAx5m");

var $h0bf1 = parcelRequire("h0bf1");

var $6cP3W = parcelRequire("6cP3W");

var $ix640 = parcelRequire("ix640");
var $e0cf4c609ccd1546$var$AnalyticsContext = function AnalyticsContext(_ref) {
    var data = _ref.data, children = _ref.children;
    var dataRef = (0, $ix640.useTrackedRef)(data);
    var _useAnalyticsContext = (0, $6cP3W.useAnalyticsContext)(), getAtlaskitAnalyticsEventHandlers = _useAnalyticsContext.getAtlaskitAnalyticsEventHandlers, getOriginalAnalyticsContext = _useAnalyticsContext.getAtlaskitAnalyticsContext;
    var getAtlaskitAnalyticsContext = (0, $dAx5m.useCallback)(function() {
        return [].concat((0, (/*@__PURE__*/$parcel$interopDefault($bslcD)))(getOriginalAnalyticsContext()), [
            dataRef.current
        ]);
    }, [
        getOriginalAnalyticsContext,
        dataRef
    ]);
    var value = (0, $dAx5m.useMemo)(function() {
        return {
            getAtlaskitAnalyticsContext: getAtlaskitAnalyticsContext,
            getAtlaskitAnalyticsEventHandlers: getAtlaskitAnalyticsEventHandlers
        };
    }, [
        getAtlaskitAnalyticsContext,
        getAtlaskitAnalyticsEventHandlers
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $h0bf1.default).Provider, {
        value: value
    }, children);
};
var $e0cf4c609ccd1546$export$2e2bcd8739ae039 = $e0cf4c609ccd1546$var$AnalyticsContext;

});
parcelRegister("6cP3W", function(module, exports) {

$parcel$export(module.exports, "useAnalyticsContext", function () { return $484b7909905ef699$export$d1f587f82ad51c4; });

var $dAx5m = parcelRequire("dAx5m");

var $h0bf1 = parcelRequire("h0bf1");
var $484b7909905ef699$export$d1f587f82ad51c4 = function useAnalyticsContext() {
    return (0, $dAx5m.useContext)((0, $h0bf1.default));
};

});

parcelRegister("ix640", function(module, exports) {

$parcel$export(module.exports, "useTrackedRef", function () { return $d7e0032be8e36857$export$1d27a74659855e44; });

var $dAx5m = parcelRequire("dAx5m");
var $d7e0032be8e36857$export$1d27a74659855e44 = function useTrackedRef(value) {
    var ref = (0, $dAx5m.useRef)(value);
    ref.current = value;
    return ref;
};

});




parcelRegister("8n0Fr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6180fd3a300bcb3d$export$2e2bcd8739ae039; });

var $ddhXb = parcelRequire("ddhXb");

var $dAx5m = parcelRequire("dAx5m");

var $lI1XG = parcelRequire("lI1XG");

var $bKDat = parcelRequire("bKDat");
var $6180fd3a300bcb3d$var$withAnalyticsEvents = function withAnalyticsEvents() {
    var createEventMap = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return function(WrappedComponent) {
        var WithAnalyticsEvents = /*#__PURE__*/ (0, $dAx5m.forwardRef)(function(props, ref) {
            var _usePatchedProps = (0, $bKDat.usePatchedProps)(createEventMap, props), patchedEventProps = _usePatchedProps.patchedEventProps;
            var _useAnalyticsEvents = (0, $lI1XG.useAnalyticsEvents)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement(WrappedComponent, (0, (/*@__PURE__*/$parcel$interopDefault($ddhXb)))({}, props, patchedEventProps, {
                createAnalyticsEvent: createAnalyticsEvent,
                ref: ref
            }));
        });
        WithAnalyticsEvents.displayName = "WithAnalyticsEvents(".concat(WrappedComponent.displayName || WrappedComponent.name, ")");
        return WithAnalyticsEvents;
    };
};
var $6180fd3a300bcb3d$export$2e2bcd8739ae039 = $6180fd3a300bcb3d$var$withAnalyticsEvents;

});
parcelRegister("lI1XG", function(module, exports) {

$parcel$export(module.exports, "useAnalyticsEvents", function () { return $fcdf3a90b0bf0ba2$export$5bf35293e545f20c; });

var $tWuif = parcelRequire("tWuif");

var $4IvMz = parcelRequire("4IvMz");

var $6cP3W = parcelRequire("6cP3W");
function $fcdf3a90b0bf0ba2$export$5bf35293e545f20c() {
    var analyticsContext = (0, $6cP3W.useAnalyticsContext)();
    var createAnalyticsEvent = (0, $tWuif.useCallbackOne)(function(payload) {
        return new (0, $4IvMz.default)({
            context: analyticsContext.getAtlaskitAnalyticsContext(),
            handlers: analyticsContext.getAtlaskitAnalyticsEventHandlers(),
            payload: payload
        });
    }, [
        analyticsContext
    ]);
    return {
        createAnalyticsEvent: createAnalyticsEvent
    };
}

});
parcelRegister("4IvMz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $36f3eccedcc5497e$export$2e2bcd8739ae039; });

var $bslcD = parcelRequire("bslcD");

var $jYzo9 = parcelRequire("jYzo9");

var $eCdDc = parcelRequire("eCdDc");

var $7nGU9 = parcelRequire("7nGU9");

var $iXTxn = parcelRequire("iXTxn");

var $4TW8y = parcelRequire("4TW8y");

var $lXiHY = parcelRequire("lXiHY");

var $jNO0s = parcelRequire("jNO0s");

var $gvqMl = parcelRequire("gvqMl");

var $fiB8E = parcelRequire("fiB8E");
function $36f3eccedcc5497e$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $36f3eccedcc5497e$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, (/*@__PURE__*/$parcel$interopDefault($jNO0s)))(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, (/*@__PURE__*/$parcel$interopDefault($jNO0s)))(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, (/*@__PURE__*/$parcel$interopDefault($lXiHY)))(this, result);
    };
}
function $36f3eccedcc5497e$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($36f3eccedcc5497e$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $36f3eccedcc5497e$export$35f8383928ba8d7 = function isUIAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $36f3eccedcc5497e$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isUIAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === "UIAnalyticsEvent";
};
var $36f3eccedcc5497e$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_AnalyticsEvent) {
    (0, (/*@__PURE__*/$parcel$interopDefault($4TW8y)))(UIAnalyticsEvent, _AnalyticsEvent);
    var _super = $36f3eccedcc5497e$var$_createSuper(UIAnalyticsEvent);
    function UIAnalyticsEvent(props) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($jYzo9)))(this, UIAnalyticsEvent);
        _this = _super.call(this, props);
        (0, (/*@__PURE__*/$parcel$interopDefault($gvqMl)))((0, (/*@__PURE__*/$parcel$interopDefault($7nGU9)))(_this), "_isUIAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($gvqMl)))((0, (/*@__PURE__*/$parcel$interopDefault($7nGU9)))(_this), "clone", function() {
            if (_this.hasFired) return null;
            var context = (0, (/*@__PURE__*/$parcel$interopDefault($bslcD)))(_this.context);
            var handlers = (0, (/*@__PURE__*/$parcel$interopDefault($bslcD)))(_this.handlers);
            /**
       * A hacky "deep clone" of the object. This is limited in that it wont
       * support functions, regexs, Maps, Sets, etc, but none of those need to
       * be represented in our payload.
       */ var payload = JSON.parse(JSON.stringify(_this.payload));
            return new UIAnalyticsEvent({
                context: context,
                handlers: handlers,
                payload: payload
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($gvqMl)))((0, (/*@__PURE__*/$parcel$interopDefault($7nGU9)))(_this), "fire", function(channel) {
            if (_this.hasFired) return;
            _this.handlers.forEach(function(handler) {
                return handler((0, (/*@__PURE__*/$parcel$interopDefault($7nGU9)))(_this), channel);
            });
            _this.hasFired = true;
        });
        _this.context = props.context || [];
        _this.handlers = props.handlers || [];
        _this.hasFired = false;
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eCdDc)))(UIAnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (this.hasFired) return this;
                return (0, (/*@__PURE__*/$parcel$interopDefault($iXTxn)))((0, (/*@__PURE__*/$parcel$interopDefault($jNO0s)))(UIAnalyticsEvent.prototype), "update", this).call(this, updater);
            }
        }
    ]);
    return UIAnalyticsEvent;
}((0, $fiB8E.default));

});
parcelRegister("iXTxn", function(module, exports) {

var $1ZUJQ = parcelRequire("1ZUJQ");
function $dce8d13e076be75e$var$_get() {
    return module.exports = $dce8d13e076be75e$var$_get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function(e, t, r) {
        var p = $1ZUJQ(e, t);
        if (p) {
            var n = Object.getOwnPropertyDescriptor(p, t);
            return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value;
        }
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $dce8d13e076be75e$var$_get.apply(null, arguments);
}
module.exports = $dce8d13e076be75e$var$_get, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("1ZUJQ", function(module, exports) {

var $jNO0s = parcelRequire("jNO0s");
function $174780039536f0cc$var$_superPropBase(t, o) {
    for(; !({}).hasOwnProperty.call(t, o) && null !== (t = $jNO0s(t)););
    return t;
}
module.exports = $174780039536f0cc$var$_superPropBase, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("fiB8E", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b2355864fa2827d0$export$2e2bcd8739ae039; });

var $gb7w6 = parcelRequire("gb7w6");

var $jYzo9 = parcelRequire("jYzo9");

var $eCdDc = parcelRequire("eCdDc");

var $gvqMl = parcelRequire("gvqMl");
function $b2355864fa2827d0$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $b2355864fa2827d0$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $b2355864fa2827d0$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($gvqMl)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $b2355864fa2827d0$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $b2355864fa2827d0$export$ad4be5c2ec28cecf = function isAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $b2355864fa2827d0$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === "AnalyticsEvent";
};
var $b2355864fa2827d0$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function AnalyticsEvent(props) {
        var _this = this;
        (0, (/*@__PURE__*/$parcel$interopDefault($jYzo9)))(this, AnalyticsEvent);
        (0, (/*@__PURE__*/$parcel$interopDefault($gvqMl)))(this, "_isAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($gvqMl)))(this, "clone", function() {
            // just a shallow clone, don't change sub refs unless you want to
            // affect the original's too
            var payload = $b2355864fa2827d0$var$_objectSpread({}, _this.payload);
            return new AnalyticsEvent({
                payload: payload
            });
        });
        this.payload = props.payload;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eCdDc)))(AnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (typeof updater === "function") this.payload = updater(this.payload);
                if ((0, (/*@__PURE__*/$parcel$interopDefault($gb7w6)))(updater) === "object") this.payload = $b2355864fa2827d0$var$_objectSpread($b2355864fa2827d0$var$_objectSpread({}, this.payload), updater);
                return this;
            }
        }
    ]);
    return AnalyticsEvent;
}();

});



parcelRegister("bKDat", function(module, exports) {

$parcel$export(module.exports, "usePatchedProps", function () { return $88e25f7f3dab3e78$export$9ebb5a84d17e5d18; });

var $gvqMl = parcelRequire("gvqMl");

var $gb7w6 = parcelRequire("gb7w6");

var $dAx5m = parcelRequire("dAx5m");

var $lI1XG = parcelRequire("lI1XG");
function $88e25f7f3dab3e78$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $88e25f7f3dab3e78$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $88e25f7f3dab3e78$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($gvqMl)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $88e25f7f3dab3e78$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $88e25f7f3dab3e78$export$9ebb5a84d17e5d18() {
    var createEventMap = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var wrappedComponentProps = arguments.length > 1 ? arguments[1] : undefined;
    var _useAnalyticsEvents = (0, $lI1XG.useAnalyticsEvents)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    var handlerCache = (0, $dAx5m.useRef)({});
    var patchedProps = (0, $dAx5m.useMemo)(function() {
        var cache = handlerCache.current;
        // Clean up no longer used handlers in cache
        Object.keys(cache).filter(function(key) {
            return !(key in createEventMap);
        }).forEach(function(key) {
            return delete cache[key];
        });
        return Object.keys(createEventMap).reduce(function(p, k) {
            var eventCreator = createEventMap[k];
            if (![
                "object",
                "function"
            ].includes((0, (/*@__PURE__*/$parcel$interopDefault($gb7w6)))(eventCreator))) return p;
            var propValue = wrappedComponentProps[k];
            if (k in cache && cache[k].eventCreator === eventCreator && cache[k].propValue === propValue) return $88e25f7f3dab3e78$var$_objectSpread($88e25f7f3dab3e78$var$_objectSpread({}, p), {}, (0, (/*@__PURE__*/$parcel$interopDefault($gvqMl)))({}, k, cache[k].wrappedCallback));
            var wrappedCallback = function wrappedCallback() {
                var analyticsEvent = typeof eventCreator === "function" ? eventCreator(createAnalyticsEvent, wrappedComponentProps) : createAnalyticsEvent(eventCreator);
                if (propValue && typeof propValue === "function") {
                    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                    propValue.apply(void 0, args.concat([
                        analyticsEvent
                    ]));
                }
            };
            cache[k] = {
                eventCreator: eventCreator,
                wrappedCallback: wrappedCallback,
                propValue: propValue
            };
            return $88e25f7f3dab3e78$var$_objectSpread($88e25f7f3dab3e78$var$_objectSpread({}, p), {}, (0, (/*@__PURE__*/$parcel$interopDefault($gvqMl)))({}, k, wrappedCallback));
        }, {});
    }, [
        createEventMap,
        wrappedComponentProps,
        createAnalyticsEvent,
        handlerCache
    ]);
    return {
        patchedEventProps: patchedProps
    };
}

});


parcelRegister("2hDPH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1a9c1147c58a10f0$export$2e2bcd8739ae039; });

var $ddhXb = parcelRequire("ddhXb");

var $gvqMl = parcelRequire("gvqMl");

var $aJTPI = parcelRequire("aJTPI");

var $dAx5m = parcelRequire("dAx5m");

var $6wOet = parcelRequire("6wOet");

var $dxgqb = parcelRequire("dxgqb");

var $9tRNH = parcelRequire("9tRNH");

var $9GNOg = parcelRequire("9GNOg");
var $fn8ld = parcelRequire("fn8ld");

var $9ExPh = parcelRequire("9ExPh");

var $6aJAL = parcelRequire("6aJAL");
var $1a9c1147c58a10f0$var$_excluded = [
    "appearance",
    "ariaLiveMessages",
    "components",
    "isInvalid",
    "onClickPreventDefault",
    "spacing",
    "styles",
    "tabSelectsValue",
    "validationState"
];
function $1a9c1147c58a10f0$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $1a9c1147c58a10f0$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $1a9c1147c58a10f0$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($gvqMl)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $1a9c1147c58a10f0$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $1a9c1147c58a10f0$export$2e2bcd8739ae039(WrappedComponent) {
    var AtlaskitSelect = /*#__PURE__*/ (0, $dAx5m.forwardRef)(function AtlaskitSelect(props, forwardedRef) {
        var appearance = props.appearance, ariaLiveMessages = props.ariaLiveMessages, componentsProp = props.components, isInvalid = props.isInvalid, _props$onClickPrevent = props.onClickPreventDefault, onClickPreventDefault = _props$onClickPrevent === void 0 ? true : _props$onClickPrevent, _props$spacing = props.spacing, spacing = _props$spacing === void 0 ? "default" : _props$spacing, _props$styles = props.styles, styles = _props$styles === void 0 ? {} : _props$styles, _props$tabSelectsValu = props.tabSelectsValue, tabSelectsValue = _props$tabSelectsValu === void 0 ? false : _props$tabSelectsValu, _props$validationStat = props.validationState, validationState = _props$validationStat === void 0 ? "default" : _props$validationStat, restProps = (0, (/*@__PURE__*/$parcel$interopDefault($aJTPI)))(props, $1a9c1147c58a10f0$var$_excluded);
        var internalSelectRef = (0, $dAx5m.useRef)(null);
        var components = (0, $dAx5m.useMemo)(function() {
            return $1a9c1147c58a10f0$var$_objectSpread({
                ClearIndicator: (0, $9GNOg.ClearIndicator),
                DropdownIndicator: (0, $9GNOg.DropdownIndicator),
                LoadingIndicator: (0, $9GNOg.LoadingIndicator),
                MultiValueRemove: (0, $fn8ld.MultiValueRemove),
                IndicatorSeparator: (0, $fn8ld.IndicatorSeparator),
                Input: (0, $dxgqb.Input),
                NoOptionsMessage: (0, $9tRNH.NoOptionsMessage)
            }, componentsProp);
        }, [
            componentsProp
        ]);
        var descriptionId = props["aria-describedby"];
        var isSearchable = props.isSearchable;
        (0, $dAx5m.useEffect)(function() {
            if (!isSearchable && descriptionId) {
                var _internalSelectRef$cu;
                // when isSearchable is false, react-select will create its own dummy input instead of using ours,
                // so we need to manually add the additional aria-describedby using ref.
                var input = (_internalSelectRef$cu = internalSelectRef.current) === null || _internalSelectRef$cu === void 0 ? void 0 : _internalSelectRef$cu.inputRef;
                var ariaDescribedby = input === null || input === void 0 ? void 0 : input.getAttribute("aria-describedby");
                if (!(ariaDescribedby !== null && ariaDescribedby !== void 0 && ariaDescribedby.includes(descriptionId))) input === null || input === void 0 || input.setAttribute("aria-describedby", "".concat(ariaDescribedby, " ").concat(descriptionId));
            }
        }, [
            descriptionId,
            isSearchable
        ]);
        var isCompact = spacing === "compact";
        /**
     * The following `useImperativeHandle` hook exists for the sake of backwards compatibility.
     * This component used to be a class component which set the value of the `ref` prop to object with the properties and value as below.
     * This has lead to slightly odd usage of refs with this component, e.g. `myRef.current.select.select.controlRef` instead of just `myRef.current.select.controlRef`
     * In the next major release, this should removed and the ref should be passed directly to the wrapped component (given users have updated usage)
     * More info https://stash.atlassian.com/projects/ATLASSIAN/repos/atlassian-frontend-monorepo/pull-requests/88021/overview
     */ (0, $dAx5m.useImperativeHandle)(forwardedRef, function() {
            return {
                select: internalSelectRef.current,
                focus: function focus() {
                    var _internalSelectRef$cu2;
                    return (_internalSelectRef$cu2 = internalSelectRef.current) === null || _internalSelectRef$cu2 === void 0 ? void 0 : _internalSelectRef$cu2.focus();
                },
                blur: function blur() {
                    var _internalSelectRef$cu3;
                    return (_internalSelectRef$cu3 = internalSelectRef.current) === null || _internalSelectRef$cu3 === void 0 ? void 0 : _internalSelectRef$cu3.blur();
                }
            };
        }, []);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement(WrappedComponent, (0, (/*@__PURE__*/$parcel$interopDefault($ddhXb)))({
            ref: internalSelectRef,
            "aria-live": "assertive",
            ariaLiveMessages: (0, $6aJAL.isOptionsGrouped)(props.options) ? $1a9c1147c58a10f0$var$_objectSpread({
                onFocus: (0, $6aJAL.onFocus)
            }, ariaLiveMessages) : $1a9c1147c58a10f0$var$_objectSpread({}, ariaLiveMessages),
            tabSelectsValue: tabSelectsValue,
            onClickPreventDefault: onClickPreventDefault
        }, restProps, {
            components: components,
            styles: (0, $6wOet.m)((0, $9ExPh.default)(// This will cover both props for invalid state while giving priority to isInvalid. When cleaning up validationState, we can just keep the inner condition.
            typeof isInvalid !== "undefined" ? isInvalid ? "error" : "default" : validationState, isCompact, appearance || "default"), styles)
        }));
    });
    AtlaskitSelect.displayName = "AtlaskitSelect";
    return AtlaskitSelect;
}

});
parcelRegister("dxgqb", function(module, exports) {

$parcel$export(module.exports, "Input", function () { return $9dab18606311e75c$export$f5b8910cec6cf069; });

var $ddhXb = parcelRequire("ddhXb");

var $dAx5m = parcelRequire("dAx5m");

var $fc2pq = parcelRequire("fc2pq");
function $9dab18606311e75c$export$f5b8910cec6cf069(props) {
    var ariaDescribedByAttribute;
    var passed_describedby = props.selectProps["aria-describedby"];
    if (props["aria-describedby"] && passed_describedby) ariaDescribedByAttribute = props["aria-describedby"] + " " + passed_describedby;
    else ariaDescribedByAttribute = props["aria-describedby"] || passed_describedby;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $fc2pq.c).Input, (0, (/*@__PURE__*/$parcel$interopDefault($ddhXb)))({}, props, {
        "aria-describedby": ariaDescribedByAttribute
    }));
}

});

parcelRegister("9tRNH", function(module, exports) {

$parcel$export(module.exports, "NoOptionsMessage", function () { return $6e708e28a36de961$export$d58b72b7d3c4072c; });

var $dAx5m = parcelRequire("dAx5m");

var $fc2pq = parcelRequire("fc2pq");
var $6e708e28a36de961$export$d58b72b7d3c4072c = function NoOptionsMessage(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $fc2pq.c).NoOptionsMessage, props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement("span", {
        id: "no-options",
        role: "alert"
    }, props.children || "No options"));
};

});

parcelRegister("9GNOg", function(module, exports) {

$parcel$export(module.exports, "ClearIndicator", function () { return $70deac79168e3e5d$export$ecf9cf59142dd54a; });
$parcel$export(module.exports, "DropdownIndicator", function () { return $70deac79168e3e5d$export$ec98719d3db7f2e4; });
$parcel$export(module.exports, "LoadingIndicator", function () { return $70deac79168e3e5d$export$7c20be4c1d342248; });

var $ddhXb = parcelRequire("ddhXb");

var $gvqMl = parcelRequire("gvqMl");

var $jVTBW = parcelRequire("jVTBW");

var $fc2pq = parcelRequire("fc2pq");

var $irjFl = parcelRequire("irjFl");
var $3SYWB = parcelRequire("3SYWB");

var $8aQLQ = parcelRequire("8aQLQ");

var $hWOpk = parcelRequire("hWOpk");

var $hquSE = parcelRequire("hquSE");
function $70deac79168e3e5d$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $70deac79168e3e5d$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $70deac79168e3e5d$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($gvqMl)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $70deac79168e3e5d$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $70deac79168e3e5d$var$iconContainerStyles = (0, $3SYWB.xcss)({
    all: "unset",
    outline: "revert",
    display: "flex",
    alignItems: "center"
});
var $70deac79168e3e5d$export$ecf9cf59142dd54a = function ClearIndicator(props) {
    return (0, $jVTBW.jsx)((0, $fc2pq.c).ClearIndicator, $70deac79168e3e5d$var$_objectSpread($70deac79168e3e5d$var$_objectSpread({}, props), {}, {
        innerProps: $70deac79168e3e5d$var$_objectSpread($70deac79168e3e5d$var$_objectSpread({}, props.innerProps), {}, {
            "aria-hidden": "false"
        })
    }), (0, $jVTBW.jsx)((0, $irjFl.default), {
        xcss: $70deac79168e3e5d$var$iconContainerStyles,
        tabIndex: -1
    }, (0, $jVTBW.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hWOpk))), {
        size: "small",
        label: "clear"
    })));
};
var $70deac79168e3e5d$export$ec98719d3db7f2e4 = function DropdownIndicator(props) {
    return (0, $jVTBW.jsx)((0, $fc2pq.c).DropdownIndicator, props, (0, $jVTBW.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hquSE))), {
        label: "open"
    }));
};
var $70deac79168e3e5d$export$7c20be4c1d342248 = function LoadingIndicator(props) {
    var loadingStyles = (0, $jVTBW.css)(props.getStyles("loadingIndicator", props));
    return(// This *must* be constructed this way because this is being consumed by
    // `react-select` and we don't control what it wants.
    // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
    (0, $jVTBW.jsx)("div", (0, (/*@__PURE__*/$parcel$interopDefault($ddhXb)))({
        css: loadingStyles
    }, props.innerProps), (0, $jVTBW.jsx)((0, $8aQLQ.default), {
        size: "small"
    })));
};

});
parcelRegister("irjFl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0376defb47d06b6b$export$2e2bcd8739ae039; });

var $ddhXb = parcelRequire("ddhXb");

var $bslcD = parcelRequire("bslcD");

var $aJTPI = parcelRequire("aJTPI");

var $dAx5m = parcelRequire("dAx5m");

var $85w6R = parcelRequire("85w6R");

var $Bb0he = parcelRequire("Bb0he");

var $kqsmh = parcelRequire("kqsmh");

var $3SYWB = parcelRequire("3SYWB");

var $9pt9m = parcelRequire("9pt9m");
var $0376defb47d06b6b$var$_excluded = [
    "children",
    "backgroundColor",
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    "isDisabled",
    "type",
    "testId",
    "xcss",
    "onClick",
    "interactionName",
    "componentName",
    "analyticsContext"
];
// TODO: Duplicated FocusRing styles due to lack of `xcss` support
// and to prevent additional dependency
var $0376defb47d06b6b$var$baseFocusRingStyles = {
    outlineColor: "color.border.focused",
    outlineWidth: "border.width.outline",
    outlineStyle: "solid",
    outlineOffset: "space.025"
};
var $0376defb47d06b6b$var$focusRingStyles = (0, $3SYWB.xcss)({
    ":focus-visible": $0376defb47d06b6b$var$baseFocusRingStyles,
    "@supports not selector(*:focus-visible)": {
        ":focus": $0376defb47d06b6b$var$baseFocusRingStyles
    },
    "@media screen and (forced-colors: active), screen and (-ms-high-contrast: active)": {
        ":focus-visible": {
            outline: "1px solid"
        }
    }
});
/**
 * __Pressable__
 *
 * A primitive for building custom buttons.
 *
 * - [Examples](https://atlassian.design/components/primitives/pressable/examples)
 * - [Code](https://atlassian.design/components/primitives/pressable/code)
 * - [Usage](https://atlassian.design/components/primitives/pressable/usage)
 */ var $0376defb47d06b6b$var$Pressable = /*#__PURE__*/ (0, $dAx5m.forwardRef)(function(_ref, ref) {
    var children = _ref.children, backgroundColor = _ref.backgroundColor, padding = _ref.padding, paddingBlock = _ref.paddingBlock, paddingBlockStart = _ref.paddingBlockStart, paddingBlockEnd = _ref.paddingBlockEnd, paddingInline = _ref.paddingInline, paddingInlineStart = _ref.paddingInlineStart, paddingInlineEnd = _ref.paddingInlineEnd, isDisabled = _ref.isDisabled, _ref$type = _ref.type, type = _ref$type === void 0 ? "button" : _ref$type, testId = _ref.testId, xcssStyles = _ref.xcss, _ref$onClick = _ref.onClick, providedOnClick = _ref$onClick === void 0 ? (0, $Bb0he.default) : _ref$onClick, interactionName = _ref.interactionName, componentName = _ref.componentName, analyticsContext = _ref.analyticsContext, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($aJTPI)))(_ref, $0376defb47d06b6b$var$_excluded);
    var interactionContext = (0, $dAx5m.useContext)((0, $kqsmh.default));
    var handleClick = (0, $dAx5m.useCallback)(function(e, analyticsEvent) {
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    var onClick = (0, $85w6R.usePlatformLeafEventHandler)({
        fn: handleClick,
        action: "clicked",
        componentName: componentName || "Pressable",
        packageName: "@atlaskit/primitives",
        packageVersion: "7.0.0",
        analyticsData: analyticsContext,
        actionSubject: "button"
    });
    // Combine default styles with supplied styles. XCSS does not support deep nested arrays
    var styles = [
        (0, $3SYWB.xcss)({
            cursor: isDisabled ? "not-allowed" : "pointer"
        }),
        $0376defb47d06b6b$var$focusRingStyles
    ];
    // We're type coercing this as Compiled styles in an array isn't supported by the types
    // But the runtime accepts it none-the-wiser. We can remove this entire block and replace
    // it with cx(defaultStyles, focusRingStyles, xcssStyles) when we've moved away from Emotion.
    styles = Array.isArray(xcssStyles) ? [].concat((0, (/*@__PURE__*/$parcel$interopDefault($bslcD)))(styles), (0, (/*@__PURE__*/$parcel$interopDefault($bslcD)))(xcssStyles)) : [].concat((0, (/*@__PURE__*/$parcel$interopDefault($bslcD)))(styles), [
        xcssStyles
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $9pt9m.default), (0, (/*@__PURE__*/$parcel$interopDefault($ddhXb)))({}, htmlAttributes, {
        as: "button",
        ref: ref,
        testId: testId,
        type: type,
        onClick: onClick,
        backgroundColor: backgroundColor,
        padding: padding,
        paddingBlock: paddingBlock,
        paddingBlockStart: paddingBlockStart,
        paddingBlockEnd: paddingBlockEnd,
        paddingInline: paddingInline,
        paddingInlineStart: paddingInlineStart,
        paddingInlineEnd: paddingInlineEnd,
        xcss: styles,
        disabled: isDisabled
    }), children);
});
var $0376defb47d06b6b$export$2e2bcd8739ae039 = $0376defb47d06b6b$var$Pressable;

});
parcelRegister("85w6R", function(module, exports) {

$parcel$export(module.exports, "usePlatformLeafEventHandler", function () { return $5e37b2a51c98121c$export$a4687b0234b40e28; });

var $gvqMl = parcelRequire("gvqMl");

var $dAx5m = parcelRequire("dAx5m");

var $lI1XG = parcelRequire("lI1XG");

var $ix640 = parcelRequire("ix640");
function $5e37b2a51c98121c$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $5e37b2a51c98121c$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $5e37b2a51c98121c$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($gvqMl)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $5e37b2a51c98121c$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $5e37b2a51c98121c$export$a4687b0234b40e28(_ref) {
    var fn = _ref.fn, action = _ref.action, componentName = _ref.componentName, actionSubject = _ref.actionSubject, packageName = _ref.packageName, packageVersion = _ref.packageVersion, analyticsData = _ref.analyticsData;
    var _useAnalyticsEvents = (0, $lI1XG.useAnalyticsEvents)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    // We put analyticsData and fn in a ref so that we don't need to break
    // memoization.
    // Generally these could be defined by consumers inline
    // and so we do this to avoid breaking memoization of useCallback
    var dataRef = (0, $ix640.useTrackedRef)(analyticsData);
    var fnRef = (0, $ix640.useTrackedRef)(fn);
    var handler = (0, $dAx5m.useCallback)(function(value) {
        var analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: actionSubject || componentName,
            attributes: {
                componentName: componentName,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
        // To avoid wrapping this component in AnalyticsContext we manually
        // push the parent context's meta data into the context.
        // Note: this new 'context'
        var context = $5e37b2a51c98121c$var$_objectSpread({
            componentName: componentName,
            packageName: packageName,
            packageVersion: packageVersion
        }, dataRef.current);
        analyticsEvent.context.push(context);
        // fire an event on the atlaskit channel
        var clone = analyticsEvent.clone();
        if (clone) clone.fire("atlaskit");
        fnRef.current(value, analyticsEvent);
    }, [
        // These are strings and won't change
        action,
        componentName,
        actionSubject,
        packageName,
        packageVersion,
        // This function is memoized in the context
        createAnalyticsEvent,
        // these are a stable ref because of the useTrackedRef hook
        dataRef,
        fnRef
    ]);
    return handler;
}

});

parcelRegister("3SYWB", function(module, exports) {

$parcel$export(module.exports, "parseXcss", function () { return $2d45b083ce2856df$export$a9c84988c8f81f2d; });
$parcel$export(module.exports, "xcss", function () { return $2d45b083ce2856df$export$f6c783d06584602c; });

var $bslcD = parcelRequire("bslcD");

var $gvqMl = parcelRequire("gvqMl");

var $hGjRc = parcelRequire("hGjRc");

var $gb7w6 = parcelRequire("gb7w6");

var $jVTBW = parcelRequire("jVTBW");

var $hiwXn = parcelRequire("hiwXn");

var $ahJoN = parcelRequire("ahJoN");
function $2d45b083ce2856df$var$_createForOfIteratorHelper(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (!it) {
        if (Array.isArray(o) || (it = $2d45b083ce2856df$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
            if (it) o = it;
            var i = 0;
            var F = function F() {};
            return {
                s: F,
                n: function n() {
                    if (i >= o.length) return {
                        done: true
                    };
                    return {
                        done: false,
                        value: o[i++]
                    };
                },
                e: function e(_e) {
                    throw _e;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var normalCompletion = true, didErr = false, err;
    return {
        s: function s() {
            it = it.call(o);
        },
        n: function n() {
            var step = it.next();
            normalCompletion = step.done;
            return step;
        },
        e: function e(_e2) {
            didErr = true;
            err = _e2;
        },
        f: function f() {
            try {
                if (!normalCompletion && it.return != null) it.return();
            } finally{
                if (didErr) throw err;
            }
        }
    };
}
function $2d45b083ce2856df$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $2d45b083ce2856df$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $2d45b083ce2856df$var$_arrayLikeToArray(o, minLen);
}
function $2d45b083ce2856df$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $2d45b083ce2856df$export$9a199fbafee0014e = {
    backgroundColor: (0, $hiwXn.backgroundColorMap),
    blockSize: (0, $hiwXn.dimensionMap),
    borderBlockColor: (0, $hiwXn.borderColorMap),
    borderBlockEndColor: (0, $hiwXn.borderColorMap),
    borderBlockEndWidth: (0, $hiwXn.borderWidthMap),
    borderBlockStartColor: (0, $hiwXn.borderColorMap),
    borderBlockStartWidth: (0, $hiwXn.borderWidthMap),
    borderBlockWidth: (0, $hiwXn.borderWidthMap),
    borderBottomColor: (0, $hiwXn.borderColorMap),
    borderBottomLeftRadius: (0, $hiwXn.borderRadiusMap),
    borderBottomRightRadius: (0, $hiwXn.borderRadiusMap),
    borderBottomWidth: (0, $hiwXn.borderWidthMap),
    borderColor: (0, $hiwXn.borderColorMap),
    borderEndEndRadius: (0, $hiwXn.borderRadiusMap),
    borderEndStartRadius: (0, $hiwXn.borderRadiusMap),
    borderInlineColor: (0, $hiwXn.borderColorMap),
    borderInlineEndColor: (0, $hiwXn.borderColorMap),
    borderInlineEndWidth: (0, $hiwXn.borderWidthMap),
    borderInlineStartColor: (0, $hiwXn.borderColorMap),
    borderInlineStartWidth: (0, $hiwXn.borderWidthMap),
    borderInlineWidth: (0, $hiwXn.borderWidthMap),
    borderLeftColor: (0, $hiwXn.borderColorMap),
    borderLeftWidth: (0, $hiwXn.borderWidthMap),
    borderRadius: (0, $hiwXn.borderRadiusMap),
    borderRightColor: (0, $hiwXn.borderColorMap),
    borderRightWidth: (0, $hiwXn.borderWidthMap),
    borderStartEndRadius: (0, $hiwXn.borderRadiusMap),
    borderStartStartRadius: (0, $hiwXn.borderRadiusMap),
    borderTopColor: (0, $hiwXn.borderColorMap),
    borderTopLeftRadius: (0, $hiwXn.borderRadiusMap),
    borderTopRightRadius: (0, $hiwXn.borderRadiusMap),
    borderTopWidth: (0, $hiwXn.borderWidthMap),
    borderWidth: (0, $hiwXn.borderWidthMap),
    bottom: (0, $hiwXn.allSpaceMap),
    boxShadow: (0, $hiwXn.shadowMap),
    color: (0, $hiwXn.textColorMap),
    columnGap: (0, $hiwXn.positiveSpaceMap),
    gap: (0, $hiwXn.positiveSpaceMap),
    height: (0, $hiwXn.dimensionMap),
    inlineSize: (0, $hiwXn.dimensionMap),
    inset: (0, $hiwXn.allSpaceMap),
    insetBlock: (0, $hiwXn.allSpaceMap),
    insetBlockEnd: (0, $hiwXn.allSpaceMap),
    insetBlockStart: (0, $hiwXn.allSpaceMap),
    insetInline: (0, $hiwXn.allSpaceMap),
    insetInlineEnd: (0, $hiwXn.allSpaceMap),
    insetInlineStart: (0, $hiwXn.allSpaceMap),
    left: (0, $hiwXn.allSpaceMap),
    margin: (0, $hiwXn.allSpaceMap),
    marginBlock: (0, $hiwXn.allSpaceMap),
    marginBlockEnd: (0, $hiwXn.allSpaceMap),
    marginBlockStart: (0, $hiwXn.allSpaceMap),
    marginBottom: (0, $hiwXn.allSpaceMap),
    marginInline: (0, $hiwXn.allSpaceMap),
    marginInlineEnd: (0, $hiwXn.allSpaceMap),
    marginInlineStart: (0, $hiwXn.allSpaceMap),
    marginLeft: (0, $hiwXn.allSpaceMap),
    marginRight: (0, $hiwXn.allSpaceMap),
    marginTop: (0, $hiwXn.allSpaceMap),
    maxBlockSize: (0, $hiwXn.dimensionMap),
    maxHeight: (0, $hiwXn.dimensionMap),
    maxInlineSize: (0, $hiwXn.dimensionMap),
    maxWidth: (0, $hiwXn.dimensionMap),
    minBlockSize: (0, $hiwXn.dimensionMap),
    minHeight: (0, $hiwXn.dimensionMap),
    minInlineSize: (0, $hiwXn.dimensionMap),
    minWidth: (0, $hiwXn.dimensionMap),
    opacity: (0, $hiwXn.opacityMap),
    outlineColor: (0, $hiwXn.borderColorMap),
    outlineOffset: (0, $hiwXn.positiveSpaceMap),
    outlineWidth: (0, $hiwXn.borderWidthMap),
    padding: (0, $hiwXn.positiveSpaceMap),
    paddingBlock: (0, $hiwXn.positiveSpaceMap),
    paddingBlockEnd: (0, $hiwXn.positiveSpaceMap),
    paddingBlockStart: (0, $hiwXn.positiveSpaceMap),
    paddingBottom: (0, $hiwXn.positiveSpaceMap),
    paddingInline: (0, $hiwXn.positiveSpaceMap),
    paddingInlineEnd: (0, $hiwXn.positiveSpaceMap),
    paddingInlineStart: (0, $hiwXn.positiveSpaceMap),
    paddingLeft: (0, $hiwXn.positiveSpaceMap),
    paddingRight: (0, $hiwXn.positiveSpaceMap),
    paddingTop: (0, $hiwXn.positiveSpaceMap),
    right: (0, $hiwXn.allSpaceMap),
    rowGap: (0, $hiwXn.positiveSpaceMap),
    top: (0, $hiwXn.allSpaceMap),
    width: (0, $hiwXn.dimensionMap),
    zIndex: (0, $hiwXn.layerMap)
};
var $2d45b083ce2856df$var$uniqueSymbol = Symbol("UNSAFE_INTERNAL_styles");
var $2d45b083ce2856df$var$isSafeEnvToThrow = function isSafeEnvToThrow() {
    return (typeof $ahJoN === "undefined" ? "undefined" : (0, (/*@__PURE__*/$parcel$interopDefault($gb7w6)))($ahJoN)) === "object" && (0, (/*@__PURE__*/$parcel$interopDefault($gb7w6)))($ahJoN.env) === "object" && false;
};
var $2d45b083ce2856df$var$reNestedSelectors = /(\.|\s|&+|\*\>|#|\[.*\])/;
var $2d45b083ce2856df$var$safeSelectors = /^@media .*$|^::?.*$|^@supports .*$/;
var $2d45b083ce2856df$var$transformStyles = function transformStyles(styleObj) {
    if (!styleObj || (0, (/*@__PURE__*/$parcel$interopDefault($gb7w6)))(styleObj) !== "object") return styleObj;
    // If styles are defined as a CSSObject[], recursively call on each element until we reach CSSObject
    if (Array.isArray(styleObj)) return styleObj.map(transformStyles);
    // Modifies styleObj in place. Be careful.
    Object.entries(styleObj).forEach(function(_ref) {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($hGjRc)))(_ref, 2), key = _ref2[0], value = _ref2[1];
        // If key is a pseudo class or a pseudo element, then value should be an object.
        // So, call transformStyles on the value
        if ((0, (/*@__PURE__*/$parcel$interopDefault($gb7w6)))(value) === "object" && $2d45b083ce2856df$var$safeSelectors.test(key)) {
            styleObj[key] = transformStyles(value);
            return;
        }
        if ($2d45b083ce2856df$var$isSafeEnvToThrow()) {
            // We don't support `.class`, `[data-testid]`, `> *`, `#some-id`
            if ($2d45b083ce2856df$var$reNestedSelectors.test(key)) throw new Error("Styles not supported for key '".concat(key, "'."));
        }
        // We have now dealt with all the special cases, so,
        // check whether what remains is a style property
        // that can be transformed.
        if (!(key in $2d45b083ce2856df$export$9a199fbafee0014e)) return;
        var tokenValue = $2d45b083ce2856df$export$9a199fbafee0014e[key][value];
        styleObj[key] = tokenValue !== null && tokenValue !== void 0 ? tokenValue : value;
    });
    return styleObj;
};
var $2d45b083ce2856df$var$baseXcss = function baseXcss(style) {
    var transformedStyles = $2d45b083ce2856df$var$transformStyles(style);
    return (0, (/*@__PURE__*/$parcel$interopDefault($gvqMl)))({}, $2d45b083ce2856df$var$uniqueSymbol, (0, $jVTBW.css)(transformedStyles));
};
var $2d45b083ce2856df$export$a9c84988c8f81f2d = function parseXcss(args) {
    if (Array.isArray(args)) {
        var emotion = [];
        var staticArr = [];
        var _iterator = $2d45b083ce2856df$var$_createForOfIteratorHelper(args), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var arg = _step.value;
                var result = parseXcss(arg);
                if (result.emotion) emotion.push.apply(emotion, (0, (/*@__PURE__*/$parcel$interopDefault($bslcD)))(result.emotion));
                if (result.static) staticArr.push(result.static);
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        return {
            emotion: emotion,
            static: staticArr.join(" ")
        };
    }
    var objArgs = args;
    var _ref4 = objArgs || {}, styles = _ref4[$2d45b083ce2856df$var$uniqueSymbol];
    if (styles) return {
        emotion: [
            styles
        ]
    };
    if (args) {
        // We use string interpolation here instead of .toString() just
        // in case the resulting object doesn't have the method available.
        var stringifiedArgs = "".concat(args);
        if (stringifiedArgs) return {
            static: stringifiedArgs
        };
    }
    return {};
};
function $2d45b083ce2856df$export$f6c783d06584602c(style) {
    return $2d45b083ce2856df$var$baseXcss(style);
}

});
parcelRegister("hGjRc", function(module, exports) {

var $lxfq5 = parcelRequire("lxfq5");

var $6gtPI = parcelRequire("6gtPI");

var $8CMGv = parcelRequire("8CMGv");

var $jMwWR = parcelRequire("jMwWR");
function $cdf5c31664531230$var$_slicedToArray(r, e) {
    return $lxfq5(r) || $6gtPI(r, e) || $8CMGv(r, e) || $jMwWR();
}
module.exports = $cdf5c31664531230$var$_slicedToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("lxfq5", function(module, exports) {
function $fad8a414beb551ff$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
module.exports = $fad8a414beb551ff$var$_arrayWithHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("6gtPI", function(module, exports) {
function $48fb60ec6d55b7c8$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
module.exports = $48fb60ec6d55b7c8$var$_iterableToArrayLimit, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("jMwWR", function(module, exports) {
function $e66c0ee1c017b216$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
module.exports = $e66c0ee1c017b216$var$_nonIterableRest, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("hiwXn", function(module, exports) {

$parcel$export(module.exports, "dimensionMap", function () { return $c97dae9ebe90516a$export$6ccdbebca2ee545f; });
$parcel$export(module.exports, "positiveSpaceMap", function () { return $c97dae9ebe90516a$export$958d0ae7f2977ae4; });
$parcel$export(module.exports, "allSpaceMap", function () { return $c97dae9ebe90516a$export$632685d741f3dbbf; });
$parcel$export(module.exports, "opacityMap", function () { return $c97dae9ebe90516a$export$daf94a976c798b4f; });
$parcel$export(module.exports, "shadowMap", function () { return $c97dae9ebe90516a$export$7aff6e7ba39bb774; });
$parcel$export(module.exports, "borderColorMap", function () { return $c97dae9ebe90516a$export$1531ad5bb3fbedac; });
$parcel$export(module.exports, "backgroundColorMap", function () { return $c97dae9ebe90516a$export$d1d79bf68ac056bd; });
$parcel$export(module.exports, "textColorMap", function () { return $c97dae9ebe90516a$export$8473307aa00d6ea1; });
$parcel$export(module.exports, "layerMap", function () { return $c97dae9ebe90516a$export$b5f31a7e431d2eab; });
$parcel$export(module.exports, "borderWidthMap", function () { return $c97dae9ebe90516a$export$e1b83c5210c471b8; });
$parcel$export(module.exports, "borderRadiusMap", function () { return $c97dae9ebe90516a$export$3c0a6c3e64bb180d; });
$parcel$export(module.exports, "paddingStylesMap", function () { return $c97dae9ebe90516a$export$e615f061ca585a6c; });
$parcel$export(module.exports, "backgroundColorStylesMap", function () { return $c97dae9ebe90516a$export$e7af83bafe7f9e63; });
$parcel$export(module.exports, "surfaceColorStylesMap", function () { return $c97dae9ebe90516a$export$ff257d957d48c421; });
$parcel$export(module.exports, "isSurfaceColorToken", function () { return $c97dae9ebe90516a$export$5e65a44e5b6ecadb; });

var $gvqMl = parcelRequire("gvqMl");

var $jVTBW = parcelRequire("jVTBW");

var $5Ktef = parcelRequire("5Ktef");
function $c97dae9ebe90516a$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $c97dae9ebe90516a$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $c97dae9ebe90516a$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($gvqMl)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $c97dae9ebe90516a$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $c97dae9ebe90516a$export$6ccdbebca2ee545f = {
    "100%": "100%",
    "size.100": "1rem",
    "size.200": "1.5rem",
    "size.300": "2rem",
    "size.400": "2.5rem",
    "size.500": "3rem",
    "size.600": "6rem",
    "size.1000": "12rem"
};
var $c97dae9ebe90516a$export$958d0ae7f2977ae4 = {
    "space.0": "var(--ds-space-0, 0px)",
    "space.025": "var(--ds-space-025, 2px)",
    "space.050": "var(--ds-space-050, 4px)",
    "space.075": "var(--ds-space-075, 6px)",
    "space.100": "var(--ds-space-100, 8px)",
    "space.150": "var(--ds-space-150, 12px)",
    "space.200": "var(--ds-space-200, 16px)",
    "space.250": "var(--ds-space-250, 20px)",
    "space.300": "var(--ds-space-300, 24px)",
    "space.400": "var(--ds-space-400, 32px)",
    "space.500": "var(--ds-space-500, 40px)",
    "space.600": "var(--ds-space-600, 48px)",
    "space.800": "var(--ds-space-800, 64px)",
    "space.1000": "var(--ds-space-1000, 80px)"
};
var $c97dae9ebe90516a$export$d2dc61f58390201c = {
    "space.negative.025": "var(--ds-space-negative-025, -2px)",
    "space.negative.050": "var(--ds-space-negative-050, -4px)",
    "space.negative.075": "var(--ds-space-negative-075, -6px)",
    "space.negative.100": "var(--ds-space-negative-100, -8px)",
    "space.negative.150": "var(--ds-space-negative-150, -12px)",
    "space.negative.200": "var(--ds-space-negative-200, -16px)",
    "space.negative.250": "var(--ds-space-negative-250, -20px)",
    "space.negative.300": "var(--ds-space-negative-300, -24px)",
    "space.negative.400": "var(--ds-space-negative-400, -32px)"
};
var $c97dae9ebe90516a$export$632685d741f3dbbf = $c97dae9ebe90516a$var$_objectSpread($c97dae9ebe90516a$var$_objectSpread({}, $c97dae9ebe90516a$export$958d0ae7f2977ae4), $c97dae9ebe90516a$export$d2dc61f58390201c);
var $c97dae9ebe90516a$export$2185ce37f9bdd963 = {
    "color.background.neutral.bold": "color.text.inverse",
    "color.background.neutral.bold.hovered": "color.text.inverse",
    "color.background.neutral.bold.pressed": "color.text.inverse",
    "color.background.selected.bold": "color.text.inverse",
    "color.background.selected.bold.hovered": "color.text.inverse",
    "color.background.selected.bold.pressed": "color.text.inverse",
    "color.background.brand.bold": "color.text.inverse",
    "color.background.brand.bold.hovered": "color.text.inverse",
    "color.background.brand.bold.pressed": "color.text.inverse",
    "color.background.brand.boldest": "color.text.inverse",
    "color.background.brand.boldest.hovered": "color.text.inverse",
    "color.background.brand.boldest.pressed": "color.text.inverse",
    "color.background.danger.bold": "color.text.inverse",
    "color.background.danger.bold.hovered": "color.text.inverse",
    "color.background.danger.bold.pressed": "color.text.inverse",
    "color.background.warning.bold": "color.text.warning.inverse",
    "color.background.warning.bold.hovered": "color.text.warning.inverse",
    "color.background.warning.bold.pressed": "color.text.warning.inverse",
    "color.background.success.bold": "color.text.inverse",
    "color.background.success.bold.hovered": "color.text.inverse",
    "color.background.success.bold.pressed": "color.text.inverse",
    "color.background.discovery.bold": "color.text.inverse",
    "color.background.discovery.bold.hovered": "color.text.inverse",
    "color.background.discovery.bold.pressed": "color.text.inverse",
    "color.background.information.bold": "color.text.inverse",
    "color.background.information.bold.hovered": "color.text.inverse",
    "color.background.information.bold.pressed": "color.text.inverse"
};
var $c97dae9ebe90516a$export$daf94a976c798b4f = {
    "opacity.disabled": "var(--ds-opacity-disabled, 0.4)",
    "opacity.loading": "var(--ds-opacity-loading, 0.2)"
};
var $c97dae9ebe90516a$export$7aff6e7ba39bb774 = {
    "elevation.shadow.overflow": "var(--ds-shadow-overflow, 0px 0px 8px #091e423f, 0px 0px 1px #091e424f)",
    "elevation.shadow.overflow.perimeter": "var(--ds-shadow-overflow-perimeter, #091e421f)",
    "elevation.shadow.overflow.spread": "var(--ds-shadow-overflow-spread, #091e4229)",
    "elevation.shadow.overlay": "var(--ds-shadow-overlay, 0px 8px 12px #091e423f, 0px 0px 1px #091e424f)",
    "elevation.shadow.raised": "var(--ds-shadow-raised, 0px 1px 1px #091e423f, 0px 0px 1px #091e4221)"
};
var $c97dae9ebe90516a$export$41a358c9c2356760 = {
    "elevation.surface": "var(--ds-surface, #FFFFFF)",
    "elevation.surface.hovered": "var(--ds-surface-hovered, #FAFBFC)",
    "elevation.surface.pressed": "var(--ds-surface-pressed, #F4F5F7)",
    "elevation.surface.overlay": "var(--ds-surface-overlay, #FFFFFF)",
    "elevation.surface.overlay.hovered": "var(--ds-surface-overlay-hovered, #FAFBFC)",
    "elevation.surface.overlay.pressed": "var(--ds-surface-overlay-pressed, #F4F5F7)",
    "elevation.surface.raised": "var(--ds-surface-raised, #FFFFFF)",
    "elevation.surface.raised.hovered": "var(--ds-surface-raised-hovered, #FAFBFC)",
    "elevation.surface.raised.pressed": "var(--ds-surface-raised-pressed, #F4F5F7)",
    "elevation.surface.sunken": "var(--ds-surface-sunken, #F4F5F7)"
};
var $c97dae9ebe90516a$export$1531ad5bb3fbedac = {
    "color.border": "var(--ds-border, #091e4221)",
    "color.border.accent.lime": "var(--ds-border-accent-lime, #6A9A23)",
    "color.border.accent.red": "var(--ds-border-accent-red, #FF5630)",
    "color.border.accent.orange": "var(--ds-border-accent-orange, #D94008)",
    "color.border.accent.yellow": "var(--ds-border-accent-yellow, #FFAB00)",
    "color.border.accent.green": "var(--ds-border-accent-green, #36B37E)",
    "color.border.accent.teal": "var(--ds-border-accent-teal, #00B8D9)",
    "color.border.accent.blue": "var(--ds-border-accent-blue, #0065FF)",
    "color.border.accent.purple": "var(--ds-border-accent-purple, #6554C0)",
    "color.border.accent.magenta": "var(--ds-border-accent-magenta, #CD519D)",
    "color.border.accent.gray": "var(--ds-border-accent-gray, #5E6C84)",
    "color.border.disabled": "var(--ds-border-disabled, #FAFBFC)",
    "color.border.focused": "var(--ds-border-focused, #2684FF)",
    "color.border.input": "var(--ds-border-input, #FAFBFC)",
    "color.border.inverse": "var(--ds-border-inverse, #FFFFFF)",
    "color.border.selected": "var(--ds-border-selected, #0052CC)",
    "color.border.brand": "var(--ds-border-brand, #0052CC)",
    "color.border.danger": "var(--ds-border-danger, #FF5630)",
    "color.border.warning": "var(--ds-border-warning, #FFC400)",
    "color.border.success": "var(--ds-border-success, #00875A)",
    "color.border.discovery": "var(--ds-border-discovery, #998DD9)",
    "color.border.information": "var(--ds-border-information, #0065FF)",
    "color.border.bold": "var(--ds-border-bold, #344563)"
};
var $c97dae9ebe90516a$export$d1d79bf68ac056bd = {
    "color.background.accent.lime.subtlest": "var(--ds-background-accent-lime-subtlest, #EEFBDA)",
    "color.background.accent.lime.subtlest.hovered": "var(--ds-background-accent-lime-subtlest-hovered, #D3F1A7)",
    "color.background.accent.lime.subtlest.pressed": "var(--ds-background-accent-lime-subtlest-pressed, #B3DF72)",
    "color.background.accent.lime.subtler": "var(--ds-background-accent-lime-subtler, #D3F1A7)",
    "color.background.accent.lime.subtler.hovered": "var(--ds-background-accent-lime-subtler-hovered, #B3DF72)",
    "color.background.accent.lime.subtler.pressed": "var(--ds-background-accent-lime-subtler-pressed, #94C748)",
    "color.background.accent.lime.subtle": "var(--ds-background-accent-lime-subtle, #94C748)",
    "color.background.accent.lime.subtle.hovered": "var(--ds-background-accent-lime-subtle-hovered, #B3DF72)",
    "color.background.accent.lime.subtle.pressed": "var(--ds-background-accent-lime-subtle-pressed, #D3F1A7)",
    "color.background.accent.lime.bolder": "var(--ds-background-accent-lime-bolder, #5B7F24)",
    "color.background.accent.lime.bolder.hovered": "var(--ds-background-accent-lime-bolder-hovered, #37471F)",
    "color.background.accent.lime.bolder.pressed": "var(--ds-background-accent-lime-bolder-pressed, #37471F)",
    "color.background.accent.red.subtlest": "var(--ds-background-accent-red-subtlest, #FF8F73)",
    "color.background.accent.red.subtlest.hovered": "var(--ds-background-accent-red-subtlest-hovered, #FF7452)",
    "color.background.accent.red.subtlest.pressed": "var(--ds-background-accent-red-subtlest-pressed, #FF5630)",
    "color.background.accent.red.subtler": "var(--ds-background-accent-red-subtler, #FF7452)",
    "color.background.accent.red.subtler.hovered": "var(--ds-background-accent-red-subtler-hovered, #FF5630)",
    "color.background.accent.red.subtler.pressed": "var(--ds-background-accent-red-subtler-pressed, #DE350B)",
    "color.background.accent.red.subtle": "var(--ds-background-accent-red-subtle, #DE350B)",
    "color.background.accent.red.subtle.hovered": "var(--ds-background-accent-red-subtle-hovered, #FF5630)",
    "color.background.accent.red.subtle.pressed": "var(--ds-background-accent-red-subtle-pressed, #FF7452)",
    "color.background.accent.red.bolder": "var(--ds-background-accent-red-bolder, #DE350B)",
    "color.background.accent.red.bolder.hovered": "var(--ds-background-accent-red-bolder-hovered, #FF5630)",
    "color.background.accent.red.bolder.pressed": "var(--ds-background-accent-red-bolder-pressed, #FF7452)",
    "color.background.accent.orange.subtlest": "var(--ds-background-accent-orange-subtlest, #F18D13)",
    "color.background.accent.orange.subtlest.hovered": "var(--ds-background-accent-orange-subtlest-hovered, #FEC57B)",
    "color.background.accent.orange.subtlest.pressed": "var(--ds-background-accent-orange-subtlest-pressed, #FFE2BD)",
    "color.background.accent.orange.subtler": "var(--ds-background-accent-orange-subtler, #B65C02)",
    "color.background.accent.orange.subtler.hovered": "var(--ds-background-accent-orange-subtler-hovered, #F18D13)",
    "color.background.accent.orange.subtler.pressed": "var(--ds-background-accent-orange-subtler-pressed, #FEC57B)",
    "color.background.accent.orange.subtle": "var(--ds-background-accent-orange-subtle, #5F3811)",
    "color.background.accent.orange.subtle.hovered": "var(--ds-background-accent-orange-subtle-hovered, #974F0C)",
    "color.background.accent.orange.subtle.pressed": "var(--ds-background-accent-orange-subtle-pressed, #B65C02)",
    "color.background.accent.orange.bolder": "var(--ds-background-accent-orange-bolder, #43290F)",
    "color.background.accent.orange.bolder.hovered": "var(--ds-background-accent-orange-bolder-hovered, #5F3811)",
    "color.background.accent.orange.bolder.pressed": "var(--ds-background-accent-orange-bolder-pressed, #974F0C)",
    "color.background.accent.yellow.subtlest": "var(--ds-background-accent-yellow-subtlest, #FFE380)",
    "color.background.accent.yellow.subtlest.hovered": "var(--ds-background-accent-yellow-subtlest-hovered, #FFC400)",
    "color.background.accent.yellow.subtlest.pressed": "var(--ds-background-accent-yellow-subtlest-pressed, #FFAB00)",
    "color.background.accent.yellow.subtler": "var(--ds-background-accent-yellow-subtler, #FFC400)",
    "color.background.accent.yellow.subtler.hovered": "var(--ds-background-accent-yellow-subtler-hovered, #FFAB00)",
    "color.background.accent.yellow.subtler.pressed": "var(--ds-background-accent-yellow-subtler-pressed, #FF991F)",
    "color.background.accent.yellow.subtle": "var(--ds-background-accent-yellow-subtle, #FF991F)",
    "color.background.accent.yellow.subtle.hovered": "var(--ds-background-accent-yellow-subtle-hovered, #FFAB00)",
    "color.background.accent.yellow.subtle.pressed": "var(--ds-background-accent-yellow-subtle-pressed, #FFC400)",
    "color.background.accent.yellow.bolder": "var(--ds-background-accent-yellow-bolder, #FF991F)",
    "color.background.accent.yellow.bolder.hovered": "var(--ds-background-accent-yellow-bolder-hovered, #FFAB00)",
    "color.background.accent.yellow.bolder.pressed": "var(--ds-background-accent-yellow-bolder-pressed, #FFC400)",
    "color.background.accent.green.subtlest": "var(--ds-background-accent-green-subtlest, #79F2C0)",
    "color.background.accent.green.subtlest.hovered": "var(--ds-background-accent-green-subtlest-hovered, #57D9A3)",
    "color.background.accent.green.subtlest.pressed": "var(--ds-background-accent-green-subtlest-pressed, #36B37E)",
    "color.background.accent.green.subtler": "var(--ds-background-accent-green-subtler, #57D9A3)",
    "color.background.accent.green.subtler.hovered": "var(--ds-background-accent-green-subtler-hovered, #36B37E)",
    "color.background.accent.green.subtler.pressed": "var(--ds-background-accent-green-subtler-pressed, #00875A)",
    "color.background.accent.green.subtle": "var(--ds-background-accent-green-subtle, #00875A)",
    "color.background.accent.green.subtle.hovered": "var(--ds-background-accent-green-subtle-hovered, #36B37E)",
    "color.background.accent.green.subtle.pressed": "var(--ds-background-accent-green-subtle-pressed, #57D9A3)",
    "color.background.accent.green.bolder": "var(--ds-background-accent-green-bolder, #00875A)",
    "color.background.accent.green.bolder.hovered": "var(--ds-background-accent-green-bolder-hovered, #36B37E)",
    "color.background.accent.green.bolder.pressed": "var(--ds-background-accent-green-bolder-pressed, #57D9A3)",
    "color.background.accent.teal.subtlest": "var(--ds-background-accent-teal-subtlest, #79E2F2)",
    "color.background.accent.teal.subtlest.hovered": "var(--ds-background-accent-teal-subtlest-hovered, #00C7E6)",
    "color.background.accent.teal.subtlest.pressed": "var(--ds-background-accent-teal-subtlest-pressed, #00B8D9)",
    "color.background.accent.teal.subtler": "var(--ds-background-accent-teal-subtler, #00C7E6)",
    "color.background.accent.teal.subtler.hovered": "var(--ds-background-accent-teal-subtler-hovered, #00B8D9)",
    "color.background.accent.teal.subtler.pressed": "var(--ds-background-accent-teal-subtler-pressed, #00A3BF)",
    "color.background.accent.teal.subtle": "var(--ds-background-accent-teal-subtle, #00A3BF)",
    "color.background.accent.teal.subtle.hovered": "var(--ds-background-accent-teal-subtle-hovered, #00B8D9)",
    "color.background.accent.teal.subtle.pressed": "var(--ds-background-accent-teal-subtle-pressed, #00C7E6)",
    "color.background.accent.teal.bolder": "var(--ds-background-accent-teal-bolder, #00A3BF)",
    "color.background.accent.teal.bolder.hovered": "var(--ds-background-accent-teal-bolder-hovered, #00B8D9)",
    "color.background.accent.teal.bolder.pressed": "var(--ds-background-accent-teal-bolder-pressed, #00C7E6)",
    "color.background.accent.blue.subtlest": "var(--ds-background-accent-blue-subtlest, #4C9AFF)",
    "color.background.accent.blue.subtlest.hovered": "var(--ds-background-accent-blue-subtlest-hovered, #2684FF)",
    "color.background.accent.blue.subtlest.pressed": "var(--ds-background-accent-blue-subtlest-pressed, #0065FF)",
    "color.background.accent.blue.subtler": "var(--ds-background-accent-blue-subtler, #2684FF)",
    "color.background.accent.blue.subtler.hovered": "var(--ds-background-accent-blue-subtler-hovered, #0065FF)",
    "color.background.accent.blue.subtler.pressed": "var(--ds-background-accent-blue-subtler-pressed, #0052CC)",
    "color.background.accent.blue.subtle": "var(--ds-background-accent-blue-subtle, #0052CC)",
    "color.background.accent.blue.subtle.hovered": "var(--ds-background-accent-blue-subtle-hovered, #0065FF)",
    "color.background.accent.blue.subtle.pressed": "var(--ds-background-accent-blue-subtle-pressed, #2684FF)",
    "color.background.accent.blue.bolder": "var(--ds-background-accent-blue-bolder, #0052CC)",
    "color.background.accent.blue.bolder.hovered": "var(--ds-background-accent-blue-bolder-hovered, #0065FF)",
    "color.background.accent.blue.bolder.pressed": "var(--ds-background-accent-blue-bolder-pressed, #2684FF)",
    "color.background.accent.purple.subtlest": "var(--ds-background-accent-purple-subtlest, #998DD9)",
    "color.background.accent.purple.subtlest.hovered": "var(--ds-background-accent-purple-subtlest-hovered, #8777D9)",
    "color.background.accent.purple.subtlest.pressed": "var(--ds-background-accent-purple-subtlest-pressed, #6554C0)",
    "color.background.accent.purple.subtler": "var(--ds-background-accent-purple-subtler, #8777D9)",
    "color.background.accent.purple.subtler.hovered": "var(--ds-background-accent-purple-subtler-hovered, #6554C0)",
    "color.background.accent.purple.subtler.pressed": "var(--ds-background-accent-purple-subtler-pressed, #5243AA)",
    "color.background.accent.purple.subtle": "var(--ds-background-accent-purple-subtle, #5243AA)",
    "color.background.accent.purple.subtle.hovered": "var(--ds-background-accent-purple-subtle-hovered, #6554C0)",
    "color.background.accent.purple.subtle.pressed": "var(--ds-background-accent-purple-subtle-pressed, #8777D9)",
    "color.background.accent.purple.bolder": "var(--ds-background-accent-purple-bolder, #5243AA)",
    "color.background.accent.purple.bolder.hovered": "var(--ds-background-accent-purple-bolder-hovered, #6554C0)",
    "color.background.accent.purple.bolder.pressed": "var(--ds-background-accent-purple-bolder-pressed, #8777D9)",
    "color.background.accent.magenta.subtlest": "var(--ds-background-accent-magenta-subtlest, #FFECF8)",
    "color.background.accent.magenta.subtlest.hovered": "var(--ds-background-accent-magenta-subtlest-hovered, #FDD0EC)",
    "color.background.accent.magenta.subtlest.pressed": "var(--ds-background-accent-magenta-subtlest-pressed, #F797D2)",
    "color.background.accent.magenta.subtler": "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
    "color.background.accent.magenta.subtler.hovered": "var(--ds-background-accent-magenta-subtler-hovered, #F797D2)",
    "color.background.accent.magenta.subtler.pressed": "var(--ds-background-accent-magenta-subtler-pressed, #E774BB)",
    "color.background.accent.magenta.subtle": "var(--ds-background-accent-magenta-subtle, #E774BB)",
    "color.background.accent.magenta.subtle.hovered": "var(--ds-background-accent-magenta-subtle-hovered, #F797D2)",
    "color.background.accent.magenta.subtle.pressed": "var(--ds-background-accent-magenta-subtle-pressed, #FDD0EC)",
    "color.background.accent.magenta.bolder": "var(--ds-background-accent-magenta-bolder, #AE4787)",
    "color.background.accent.magenta.bolder.hovered": "var(--ds-background-accent-magenta-bolder-hovered, #943D73)",
    "color.background.accent.magenta.bolder.pressed": "var(--ds-background-accent-magenta-bolder-pressed, #50253F)",
    "color.background.accent.gray.subtlest": "var(--ds-background-accent-gray-subtlest, #6B778C)",
    "color.background.accent.gray.subtlest.hovered": "var(--ds-background-accent-gray-subtlest-hovered, #5E6C84)",
    "color.background.accent.gray.subtlest.pressed": "var(--ds-background-accent-gray-subtlest-pressed, #505F79)",
    "color.background.accent.gray.subtler": "var(--ds-background-accent-gray-subtler, #5E6C84)",
    "color.background.accent.gray.subtler.hovered": "var(--ds-background-accent-gray-subtler-hovered, #505F79)",
    "color.background.accent.gray.subtler.pressed": "var(--ds-background-accent-gray-subtler-pressed, #42526E)",
    "color.background.accent.gray.subtle": "var(--ds-background-accent-gray-subtle, #505F79)",
    "color.background.accent.gray.subtle.hovered": "var(--ds-background-accent-gray-subtle-hovered, #5E6C84)",
    "color.background.accent.gray.subtle.pressed": "var(--ds-background-accent-gray-subtle-pressed, #6B778C)",
    "color.background.accent.gray.bolder": "var(--ds-background-accent-gray-bolder, #42526E)",
    "color.background.accent.gray.bolder.hovered": "var(--ds-background-accent-gray-bolder-hovered, #344563)",
    "color.background.accent.gray.bolder.pressed": "var(--ds-background-accent-gray-bolder-pressed, #253858)",
    "color.background.disabled": "var(--ds-background-disabled, #091e4289)",
    "color.background.input": "var(--ds-background-input, #FAFBFC)",
    "color.background.input.hovered": "var(--ds-background-input-hovered, #EBECF0)",
    "color.background.input.pressed": "var(--ds-background-input-pressed, #FFFFFF)",
    "color.background.inverse.subtle": "var(--ds-background-inverse-subtle, #00000029)",
    "color.background.inverse.subtle.hovered": "var(--ds-background-inverse-subtle-hovered, #0000003D)",
    "color.background.inverse.subtle.pressed": "var(--ds-background-inverse-subtle-pressed, #00000052)",
    "color.background.neutral": "var(--ds-background-neutral, #DFE1E6)",
    "color.background.neutral.hovered": "var(--ds-background-neutral-hovered, #091e4214)",
    "color.background.neutral.pressed": "var(--ds-background-neutral-pressed, #B3D4FF)",
    "color.background.neutral.subtle": "var(--ds-background-neutral-subtle, transparent)",
    "color.background.neutral.subtle.hovered": "var(--ds-background-neutral-subtle-hovered, #091e4214)",
    "color.background.neutral.subtle.pressed": "var(--ds-background-neutral-subtle-pressed, #B3D4FF)",
    "color.background.neutral.bold": "var(--ds-background-neutral-bold, #42526E)",
    "color.background.neutral.bold.hovered": "var(--ds-background-neutral-bold-hovered, #505F79)",
    "color.background.neutral.bold.pressed": "var(--ds-background-neutral-bold-pressed, #344563)",
    "color.background.selected": "var(--ds-background-selected, #DEEBFF)",
    "color.background.selected.hovered": "var(--ds-background-selected-hovered, #B3D4FF)",
    "color.background.selected.pressed": "var(--ds-background-selected-pressed, #4C9AFF)",
    "color.background.selected.bold": "var(--ds-background-selected-bold, #0052CC)",
    "color.background.selected.bold.hovered": "var(--ds-background-selected-bold-hovered, #2684FF)",
    "color.background.selected.bold.pressed": "var(--ds-background-selected-bold-pressed, #0052CC)",
    "color.background.brand.subtlest": "var(--ds-background-brand-subtlest, #B3D4FF)",
    "color.background.brand.subtlest.hovered": "var(--ds-background-brand-subtlest-hovered, #DEEBFF)",
    "color.background.brand.subtlest.pressed": "var(--ds-background-brand-subtlest-pressed, #4C9AFF)",
    "color.background.brand.bold": "var(--ds-background-brand-bold, #0052CC)",
    "color.background.brand.bold.hovered": "var(--ds-background-brand-bold-hovered, #0065FF)",
    "color.background.brand.bold.pressed": "var(--ds-background-brand-bold-pressed, #0747A6)",
    "color.background.brand.boldest": "var(--ds-background-brand-boldest, #0747A6)",
    "color.background.brand.boldest.hovered": "var(--ds-background-brand-boldest-hovered, #0052CC)",
    "color.background.brand.boldest.pressed": "var(--ds-background-brand-boldest-pressed, #0747A6)",
    "color.background.danger": "var(--ds-background-danger, #FFEBE6)",
    "color.background.danger.hovered": "var(--ds-background-danger-hovered, #FFBDAD)",
    "color.background.danger.pressed": "var(--ds-background-danger-pressed, #FF8F73)",
    "color.background.danger.bold": "var(--ds-background-danger-bold, #DE350B)",
    "color.background.danger.bold.hovered": "var(--ds-background-danger-bold-hovered, #FF5630)",
    "color.background.danger.bold.pressed": "var(--ds-background-danger-bold-pressed, #BF2600)",
    "color.background.warning": "var(--ds-background-warning, #FFFAE6)",
    "color.background.warning.hovered": "var(--ds-background-warning-hovered, #FFF0B3)",
    "color.background.warning.pressed": "var(--ds-background-warning-pressed, #FFE380)",
    "color.background.warning.bold": "var(--ds-background-warning-bold, #FFAB00)",
    "color.background.warning.bold.hovered": "var(--ds-background-warning-bold-hovered, #FFC400)",
    "color.background.warning.bold.pressed": "var(--ds-background-warning-bold-pressed, #FF991F)",
    "color.background.success": "var(--ds-background-success, #E3FCEF)",
    "color.background.success.hovered": "var(--ds-background-success-hovered, #ABF5D1)",
    "color.background.success.pressed": "var(--ds-background-success-pressed, #79F2C0)",
    "color.background.success.bold": "var(--ds-background-success-bold, #00875A)",
    "color.background.success.bold.hovered": "var(--ds-background-success-bold-hovered, #57D9A3)",
    "color.background.success.bold.pressed": "var(--ds-background-success-bold-pressed, #00875A)",
    "color.background.discovery": "var(--ds-background-discovery, #EAE6FF)",
    "color.background.discovery.hovered": "var(--ds-background-discovery-hovered, #C0B6F2)",
    "color.background.discovery.pressed": "var(--ds-background-discovery-pressed, #998DD9)",
    "color.background.discovery.bold": "var(--ds-background-discovery-bold, #5243AA)",
    "color.background.discovery.bold.hovered": "var(--ds-background-discovery-bold-hovered, #8777D9)",
    "color.background.discovery.bold.pressed": "var(--ds-background-discovery-bold-pressed, #5243AA)",
    "color.background.information": "var(--ds-background-information, #DEEBFF)",
    "color.background.information.hovered": "var(--ds-background-information-hovered, #B3D4FF)",
    "color.background.information.pressed": "var(--ds-background-information-pressed, #4C9AFF)",
    "color.background.information.bold": "var(--ds-background-information-bold, #0052CC)",
    "color.background.information.bold.hovered": "var(--ds-background-information-bold-hovered, #2684FF)",
    "color.background.information.bold.pressed": "var(--ds-background-information-bold-pressed, #0052CC)",
    "color.blanket": "var(--ds-blanket, #091e4289)",
    "color.blanket.selected": "var(--ds-blanket-selected, #388BFF14)",
    "color.blanket.danger": "var(--ds-blanket-danger, #EF5C4814)",
    "elevation.surface": "var(--ds-surface, #FFFFFF)",
    "elevation.surface.hovered": "var(--ds-surface-hovered, #FAFBFC)",
    "elevation.surface.pressed": "var(--ds-surface-pressed, #F4F5F7)",
    "elevation.surface.overlay": "var(--ds-surface-overlay, #FFFFFF)",
    "elevation.surface.overlay.hovered": "var(--ds-surface-overlay-hovered, #FAFBFC)",
    "elevation.surface.overlay.pressed": "var(--ds-surface-overlay-pressed, #F4F5F7)",
    "elevation.surface.raised": "var(--ds-surface-raised, #FFFFFF)",
    "elevation.surface.raised.hovered": "var(--ds-surface-raised-hovered, #FAFBFC)",
    "elevation.surface.raised.pressed": "var(--ds-surface-raised-pressed, #F4F5F7)",
    "elevation.surface.sunken": "var(--ds-surface-sunken, #F4F5F7)",
    "utility.elevation.surface.current": "var(--ds-elevation-surface-current, #FFFFFF)"
};
var $c97dae9ebe90516a$export$8473307aa00d6ea1 = {
    "color.text": "var(--ds-text, #172B4D)",
    "color.text.accent.lime": "var(--ds-text-accent-lime, #4C6B1F)",
    "color.text.accent.lime.bolder": "var(--ds-text-accent-lime-bolder, #37471F)",
    "color.text.accent.red": "var(--ds-text-accent-red, #DE350B)",
    "color.text.accent.red.bolder": "var(--ds-text-accent-red-bolder, #BF2600)",
    "color.text.accent.orange": "var(--ds-text-accent-orange, #F18D13)",
    "color.text.accent.orange.bolder": "var(--ds-text-accent-orange-bolder, #B65C02)",
    "color.text.accent.yellow": "var(--ds-text-accent-yellow, #FF991F)",
    "color.text.accent.yellow.bolder": "var(--ds-text-accent-yellow-bolder, #FF8B00)",
    "color.text.accent.green": "var(--ds-text-accent-green, #00875A)",
    "color.text.accent.green.bolder": "var(--ds-text-accent-green-bolder, #006644)",
    "color.text.accent.teal": "var(--ds-text-accent-teal, #00A3BF)",
    "color.text.accent.teal.bolder": "var(--ds-text-accent-teal-bolder, #008DA6)",
    "color.text.accent.blue": "var(--ds-text-accent-blue, #0052CC)",
    "color.text.accent.blue.bolder": "var(--ds-text-accent-blue-bolder, #0747A6)",
    "color.text.accent.purple": "var(--ds-text-accent-purple, #5243AA)",
    "color.text.accent.purple.bolder": "var(--ds-text-accent-purple-bolder, #403294)",
    "color.text.accent.magenta": "var(--ds-text-accent-magenta, #E774BB)",
    "color.text.accent.magenta.bolder": "var(--ds-text-accent-magenta-bolder, #DA62AC)",
    "color.text.accent.gray": "var(--ds-text-accent-gray, #505F79)",
    "color.text.accent.gray.bolder": "var(--ds-text-accent-gray-bolder, #172B4D)",
    "color.text.disabled": "var(--ds-text-disabled, #A5ADBA)",
    "color.text.inverse": "var(--ds-text-inverse, #FFFFFF)",
    "color.text.selected": "var(--ds-text-selected, #0052CC)",
    "color.text.brand": "var(--ds-text-brand, #0065FF)",
    "color.text.danger": "var(--ds-text-danger, #DE350B)",
    "color.text.warning": "var(--ds-text-warning, #974F0C)",
    "color.text.warning.inverse": "var(--ds-text-warning-inverse, #172B4D)",
    "color.text.success": "var(--ds-text-success, #006644)",
    "color.text.discovery": "var(--ds-text-discovery, #403294)",
    "color.text.information": "var(--ds-text-information, #0052CC)",
    "color.text.subtlest": "var(--ds-text-subtlest, #7A869A)",
    "color.text.subtle": "var(--ds-text-subtle, #42526E)",
    "color.link": "var(--ds-link, #0052CC)",
    "color.link.pressed": "var(--ds-link-pressed, #0747A6)",
    "color.link.visited": "var(--ds-link-visited, #403294)",
    "color.link.visited.pressed": "var(--ds-link-visited-pressed, #403294)"
};
var $c97dae9ebe90516a$export$498780f74be9af68 = {
    "color.icon": "var(--ds-icon, #505F79)",
    "color.icon.accent.lime": "var(--ds-icon-accent-lime, #6A9A23)",
    "color.icon.accent.red": "var(--ds-icon-accent-red, #FF5630)",
    "color.icon.accent.orange": "var(--ds-icon-accent-orange, #D94008)",
    "color.icon.accent.yellow": "var(--ds-icon-accent-yellow, #FFAB00)",
    "color.icon.accent.green": "var(--ds-icon-accent-green, #36B37E)",
    "color.icon.accent.teal": "var(--ds-icon-accent-teal, #00B8D9)",
    "color.icon.accent.blue": "var(--ds-icon-accent-blue, #0065FF)",
    "color.icon.accent.purple": "var(--ds-icon-accent-purple, #6554C0)",
    "color.icon.accent.magenta": "var(--ds-icon-accent-magenta, #CD519D)",
    "color.icon.accent.gray": "var(--ds-icon-accent-gray, #5E6C84)",
    "color.icon.disabled": "var(--ds-icon-disabled, #8993A4)",
    "color.icon.inverse": "var(--ds-icon-inverse, #FFFFFF)",
    "color.icon.selected": "var(--ds-icon-selected, #0052CC)",
    "color.icon.brand": "var(--ds-icon-brand, #0065FF)",
    "color.icon.danger": "var(--ds-icon-danger, #DE350B)",
    "color.icon.warning": "var(--ds-icon-warning, #FFC400)",
    "color.icon.warning.inverse": "var(--ds-icon-warning-inverse, #253858)",
    "color.icon.success": "var(--ds-icon-success, #00875A)",
    "color.icon.discovery": "var(--ds-icon-discovery, #8777D9)",
    "color.icon.information": "var(--ds-icon-information, #0747A6)",
    "color.icon.subtle": "var(--ds-icon-subtle, #6B778C)"
};
var $c97dae9ebe90516a$export$b5f31a7e431d2eab = {
    card: 100,
    navigation: 200,
    dialog: 300,
    layer: 400,
    blanket: 500,
    modal: 510,
    flag: 600,
    spotlight: 700,
    tooltip: 800
};
var $c97dae9ebe90516a$export$e1b83c5210c471b8 = {
    "border.width": "var(--ds-border-width, 1px)",
    "border.width.0": "var(--ds-border-width-0, 0px)",
    "border.width.indicator": "var(--ds-border-width-indicator, 3px)",
    "border.width.outline": "var(--ds-border-width-outline, 2px)"
};
var $c97dae9ebe90516a$export$3c0a6c3e64bb180d = {
    "border.radius.050": "var(--ds-border-radius-050, 2px)",
    "border.radius": "var(--ds-border-radius, 3px)",
    "border.radius.100": "var(--ds-border-radius-100, 3px)",
    "border.radius.200": "var(--ds-border-radius-200, 8px)",
    "border.radius.300": "var(--ds-border-radius-300, 12px)",
    "border.radius.400": "var(--ds-border-radius-400, 16px)",
    "border.radius.circle": "var(--ds-border-radius-circle, 32032px)"
};
var $c97dae9ebe90516a$export$6cc560b4dedf3816 = {
    medium: 'var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    UNSAFE_small: 'var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    large: 'var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    small: 'var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)'
};
var $c97dae9ebe90516a$export$303e322c6b1ed114 = {
    bold: "var(--ds-font-weight-bold, 700)",
    medium: "var(--ds-font-weight-medium, 500)",
    regular: "var(--ds-font-weight-regular, 400)",
    semibold: "var(--ds-font-weight-semibold, 600)"
};
var $c97dae9ebe90516a$export$3c7e9587132614b4 = {
    "font.family.body": 'var(--ds-font-family-body, ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.family.brand.body": 'var(--ds-font-family-brand-body, "Charlie Text", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.family.brand.heading": 'var(--ds-font-family-brand-heading, "Charlie Display", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.family.code": 'var(--ds-font-family-code, ui-monospace, Menlo, "Segoe UI Mono", "Ubuntu Mono", monospace)',
    "font.family.heading": 'var(--ds-font-family-heading, ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)'
};
/**
 * @codegenEnd
 */ // Generate maps for Box props. backgroundColor, padding, etc
var $c97dae9ebe90516a$var$spacingProperties = [
    // Used by Box
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    // Used by Inline and Stack
    "gap",
    "rowGap",
    "columnGap"
];
var $c97dae9ebe90516a$var$getSerializedStylesMap = function getSerializedStylesMap(cssProperty, tokenMap) {
    return Object.keys(tokenMap).reduce(function(emotionSpacingMap, token) {
        emotionSpacingMap[token] = (0, $jVTBW.css)((0, (/*@__PURE__*/$parcel$interopDefault($gvqMl)))({}, cssProperty, tokenMap[token]));
        return emotionSpacingMap;
    }, {});
};
var $c97dae9ebe90516a$export$e615f061ca585a6c = $c97dae9ebe90516a$var$spacingProperties.reduce(function(styleMap, spacingProperty) {
    styleMap[spacingProperty] = $c97dae9ebe90516a$var$getSerializedStylesMap(spacingProperty, $c97dae9ebe90516a$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
var $c97dae9ebe90516a$export$bf46c3f9eeafc71f = $c97dae9ebe90516a$var$spacingProperties.reduce(function(styleMap, spacingProperty) {
    styleMap[spacingProperty] = $c97dae9ebe90516a$var$getSerializedStylesMap(spacingProperty, $c97dae9ebe90516a$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
var $c97dae9ebe90516a$export$e7af83bafe7f9e63 = $c97dae9ebe90516a$var$getSerializedStylesMap("backgroundColor", $c97dae9ebe90516a$export$d1d79bf68ac056bd);
var $c97dae9ebe90516a$export$3a1bcba60b23d7f0 = $c97dae9ebe90516a$var$getSerializedStylesMap("color", $c97dae9ebe90516a$export$8473307aa00d6ea1);
var $c97dae9ebe90516a$export$45f3f4fe16f9f7d5 = $c97dae9ebe90516a$var$getSerializedStylesMap("fontWeight", $c97dae9ebe90516a$export$303e322c6b1ed114);
var $c97dae9ebe90516a$export$68cc305da27dbaa4 = $c97dae9ebe90516a$var$getSerializedStylesMap("fontFamily", $c97dae9ebe90516a$export$3c7e9587132614b4);
var $c97dae9ebe90516a$export$128f10c238242f83 = $c97dae9ebe90516a$var$getSerializedStylesMap("font", $c97dae9ebe90516a$export$6cc560b4dedf3816);
var $c97dae9ebe90516a$export$ff257d957d48c421 = $c97dae9ebe90516a$var$getSerializedStylesMap((0, $5Ktef.CURRENT_SURFACE_CSS_VAR), $c97dae9ebe90516a$export$41a358c9c2356760);
var $c97dae9ebe90516a$export$5e65a44e5b6ecadb = function isSurfaceColorToken(color) {
    return $c97dae9ebe90516a$export$41a358c9c2356760[color] !== undefined;
};

});
parcelRegister("5Ktef", function(module, exports) {

$parcel$export(module.exports, "CURRENT_SURFACE_CSS_VAR", function () { return $42f7ebde90101bee$export$9d7b58831ae93caa; });
var $42f7ebde90101bee$export$4ef52930e33717cd = "data-theme";
var $42f7ebde90101bee$export$a00eac3f8684bcd0 = "data-color-mode";
var $42f7ebde90101bee$export$2112803007239c61 = "data-contrast-mode";
var $42f7ebde90101bee$export$352e418ed5b6193a = "data-custom-theme";
var $42f7ebde90101bee$export$2faeed762aac6741 = "light";
var $42f7ebde90101bee$export$6f0c6fb8c80fcc92 = "ds";
var $42f7ebde90101bee$export$4d0c7bbf80185957 = [
    "opacity",
    "font",
    "space",
    "border"
];
var $42f7ebde90101bee$export$dddac1532e822863 = "--".concat($42f7ebde90101bee$export$6f0c6fb8c80fcc92, "-token-not-found");
var $42f7ebde90101bee$export$9d7b58831ae93caa = "--".concat($42f7ebde90101bee$export$6f0c6fb8c80fcc92, "-elevation-surface-current");

});



parcelRegister("9pt9m", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6d9d0f70ac8a4cc4$export$2e2bcd8739ae039; });

var $ddhXb = parcelRequire("ddhXb");

var $aJTPI = parcelRequire("aJTPI");

var $dAx5m = parcelRequire("dAx5m");

var $jVTBW = parcelRequire("jVTBW");

var $hiwXn = parcelRequire("hiwXn");

var $3SYWB = parcelRequire("3SYWB");

var $i7GBG = parcelRequire("i7GBG");
var $6d9d0f70ac8a4cc4$var$_excluded = [
    "as",
    "children",
    "backgroundColor",
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    "style",
    "testId",
    "xcss"
], $6d9d0f70ac8a4cc4$var$_excluded2 = [
    "className"
];
var $6d9d0f70ac8a4cc4$export$e71c4d32a2263218 = /*#__PURE__*/ (0, $dAx5m.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? "div" : _ref$as, children = _ref.children, backgroundColor = _ref.backgroundColor, padding = _ref.padding, paddingBlock = _ref.paddingBlock, paddingBlockStart = _ref.paddingBlockStart, paddingBlockEnd = _ref.paddingBlockEnd, paddingInline = _ref.paddingInline, paddingInlineStart = _ref.paddingInlineStart, paddingInlineEnd = _ref.paddingInlineEnd, style = _ref.style, testId = _ref.testId, xcss = _ref.xcss, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($aJTPI)))(_ref, $6d9d0f70ac8a4cc4$var$_excluded);
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($aJTPI)))(htmlAttributes, $6d9d0f70ac8a4cc4$var$_excluded2);
    var resolvedStyles = (0, $3SYWB.parseXcss)(xcss);
    var node = // @ts-expect-error Expression produces a union type that is too complex to represent. I think this is unavoidable
    (0, $jVTBW.jsx)(Component, (0, (/*@__PURE__*/$parcel$interopDefault($ddhXb)))({
        style: style,
        ref: ref,
        className: resolvedStyles.static
    }, safeHtmlAttributes, {
        css: [
            $6d9d0f70ac8a4cc4$var$baseStyles,
            backgroundColor && (0, $hiwXn.backgroundColorStylesMap)[backgroundColor],
            (0, $hiwXn.isSurfaceColorToken)(backgroundColor) && (0, $hiwXn.surfaceColorStylesMap)[backgroundColor],
            padding && (0, $hiwXn.paddingStylesMap).padding[padding],
            paddingBlock && (0, $hiwXn.paddingStylesMap).paddingBlock[paddingBlock],
            paddingBlockStart && (0, $hiwXn.paddingStylesMap).paddingBlockStart[paddingBlockStart],
            paddingBlockEnd && (0, $hiwXn.paddingStylesMap).paddingBlockEnd[paddingBlockEnd],
            paddingInline && (0, $hiwXn.paddingStylesMap).paddingInline[paddingInline],
            paddingInlineStart && (0, $hiwXn.paddingStylesMap).paddingInlineStart[paddingInlineStart],
            paddingInlineEnd && (0, $hiwXn.paddingStylesMap).paddingInlineEnd[paddingInlineEnd],
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
            resolvedStyles.emotion
        ],
        "data-testid": testId
    }), children);
    return backgroundColor ? (0, $jVTBW.jsx)((0, $i7GBG.SurfaceContext).Provider, {
        value: backgroundColor
    }, node) : node;
});
var $6d9d0f70ac8a4cc4$export$2e2bcd8739ae039 = $6d9d0f70ac8a4cc4$export$e71c4d32a2263218;
var $6d9d0f70ac8a4cc4$var$baseStyles = (0, $jVTBW.css)({
    boxSizing: "border-box",
    appearance: "none",
    border: "none"
});

});
parcelRegister("i7GBG", function(module, exports) {

$parcel$export(module.exports, "SurfaceContext", function () { return $d319ee47837c06c5$export$1ca2a26fecb070ae; });

var $dAx5m = parcelRequire("dAx5m");
var $d319ee47837c06c5$export$1ca2a26fecb070ae = /*#__PURE__*/ (0, $dAx5m.createContext)("elevation.surface");
var $d319ee47837c06c5$export$1aeb4f6b93c4540d = function useSurface() {
    return (0, $dAx5m.useContext)($d319ee47837c06c5$export$1ca2a26fecb070ae);
};
$d319ee47837c06c5$export$1ca2a26fecb070ae.displayName = "SurfaceProvider";

});



parcelRegister("8aQLQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5f3831097ef52973$export$2e2bcd8739ae039; });
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $dAx5m = parcelRequire("dAx5m");

var $jVTBW = parcelRequire("jVTBW");

var $kqsmh = parcelRequire("kqsmh");

var $7AJ4z = parcelRequire("7AJ4z");

var $TZINb = parcelRequire("TZINb");
/**
 * Returns the appropriate circle stroke color.
 */ function $5f3831097ef52973$var$getStrokeColor(appearance) {
    return appearance === "inherit" ? "var(--ds-icon-subtle, ".concat((0, $7AJ4z.N500), ")") : "var(--ds-icon-inverse, ".concat((0, $7AJ4z.N0), ")");
}
var $5f3831097ef52973$var$rotate = (0, $jVTBW.keyframes)({
    to: {
        transform: "rotate(360deg)"
    }
});
var $5f3831097ef52973$var$rotateStyles = (0, $jVTBW.css)({
    animation: "".concat($5f3831097ef52973$var$rotate, " 0.86s infinite"),
    animationTimingFunction: "cubic-bezier(0.4, 0.15, 0.6, 0.85)",
    transformOrigin: "center"
});
/**
 * There are three parts to the load in animation:
 * 1. Fade in
 * 2. Accelerated spin
 * 3. Stretch the spinner line
 */ var $5f3831097ef52973$var$loadIn = (0, $jVTBW.keyframes)({
    from: {
        transform: "rotate(50deg)",
        opacity: 0,
        strokeDashoffset: 60
    },
    to: {
        transform: "rotate(230deg)",
        opacity: 1,
        strokeDashoffset: 50
    }
});
var $5f3831097ef52973$var$loadInStyles = (0, $jVTBW.css)({
    animation: "".concat($5f3831097ef52973$var$loadIn, " 1s ease-in-out"),
    /**
   * When the animation completes, stay at the last frame of the animation.
   */ animationFillMode: "forwards",
    /**
   * We are going to animate this in.
   */ opacity: 0
});
var $5f3831097ef52973$var$wrapperStyles = (0, $jVTBW.css)({
    display: "inline-flex",
    /**
   * Align better inline with text.
   */ verticalAlign: "middle"
});
var $5f3831097ef52973$var$circleStyles = (0, $jVTBW.css)({
    fill: "none",
    strokeDasharray: 60,
    strokeDashoffset: "inherit",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    "@media screen and (forced-colors: active)": {
        filter: "grayscale(100%)",
        stroke: "CanvasText"
    }
});
/**
 * `useLayoutEffect` is being used in SSR safe form. On the server, this work doesn’t need to run.
 * `useEffect` is used in-place, because `useEffect` is not run on the server and it matches types
 * which makes things simpler than doing an `isServer` check or a `null` check.
 *
 * @see https://hello.atlassian.net/wiki/spaces/DST/pages/2081696628/DSTDACI-010+-+Interaction+Tracing+hooks+in+DS+components
 */ var $5f3831097ef52973$var$useLayoutEffect = typeof window === "undefined" ? (0, $dAx5m.useEffect) : (0, $dAx5m.useLayoutEffect);
/**
 * __Spinner__
 *
 * A spinner is an animated spinning icon that lets users know content is being loaded.
 *
 * - [Examples](https://atlassian.design/components/spinner/examples)
 * - [Code](https://atlassian.design/components/spinner/code)
 * - [Usage](https://atlassian.design/components/spinner/usage)
 */ var $5f3831097ef52973$var$Spinner = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).forwardRef(function Spinner(_ref, ref) {
    var _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "inherit" : _ref$appearance, _ref$delay = _ref.delay, delay = _ref$delay === void 0 ? 0 : _ref$delay, interactionName = _ref.interactionName, label = _ref.label, _ref$size = _ref.size, providedSize = _ref$size === void 0 ? "medium" : _ref$size, testId = _ref.testId;
    var size = typeof providedSize === "number" ? providedSize : (0, $TZINb.presetSizes)[providedSize];
    var animationDelay = "".concat(delay, "ms");
    var stroke = $5f3831097ef52973$var$getStrokeColor(appearance);
    var context = (0, $dAx5m.useContext)((0, $kqsmh.default));
    $5f3831097ef52973$var$useLayoutEffect(function() {
        if (context != null) return context.hold(interactionName);
    }, [
        context,
        interactionName
    ]);
    /**
   * The Spinner animation uses a combination of two
   * css animations on two separate elements.
   */ return (0, $jVTBW.jsx)("span", {
        /**
     * This span exists to off-load animations from the circle element,
     * which were causing performance issues (style recalculations)
     * on Safari and older versions of Chrome.
     *
     * This can be removed and styles placed back on the circle element once
     * Safari fixes this bug and off-loads rendering to the GPU from the CPU.
     */ css: [
            $5f3831097ef52973$var$wrapperStyles,
            $5f3831097ef52973$var$rotateStyles
        ],
        "data-testid": testId && "".concat(testId, "-wrapper"),
        style: {
            animationDelay: animationDelay,
            width: size,
            height: size
        }
    }, (0, $jVTBW.jsx)("svg", {
        height: size,
        width: size,
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        "data-testid": testId,
        ref: ref,
        "aria-label": label || undefined,
        css: $5f3831097ef52973$var$loadInStyles,
        style: {
            animationDelay: animationDelay
        },
        role: label ? "img" : "none"
    }, (0, $jVTBW.jsx)("circle", {
        cx: "8",
        cy: "8",
        r: "7",
        css: $5f3831097ef52973$var$circleStyles,
        style: {
            stroke: stroke
        }
    })));
}));
var $5f3831097ef52973$export$2e2bcd8739ae039 = $5f3831097ef52973$var$Spinner;

});
parcelRegister("7AJ4z", function(module, exports) {

$parcel$export(module.exports, "N0", function () { return $586edbae8b35e377$export$29a4f05edc054374; });
$parcel$export(module.exports, "N500", function () { return $586edbae8b35e377$export$c39c0fe0f26207ae; });
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // Reds
var $586edbae8b35e377$export$4b84fd0e2c617bd = "#FFEBE6";
var $586edbae8b35e377$export$b34b069eff244586 = "#FFBDAD";
var $586edbae8b35e377$export$be802dd0d8b57f35 = "#FF8F73";
var $586edbae8b35e377$export$60847d42f9da92a6 = "#FF7452";
var $586edbae8b35e377$export$4a7404f376229999 = "#FF5630";
var $586edbae8b35e377$export$2010d0fb4295b346 = "#DE350B";
var $586edbae8b35e377$export$2837b5a1a71d5c02 = "#BF2600";
var $586edbae8b35e377$export$8d9596b529bbb9cf = "#FFFAE6";
var $586edbae8b35e377$export$41060a744ab0b7ae = "#FFF0B3";
var $586edbae8b35e377$export$1cc05bbbf340e559 = "#FFE380";
var $586edbae8b35e377$export$5aae31392d72caaa = "#FFC400";
var $586edbae8b35e377$export$c6930421db9fa514 = "#FFAB00";
var $586edbae8b35e377$export$59619663aa6500fb = "#FF991F";
var $586edbae8b35e377$export$874739ea9e379ab6 = "#FF8B00";
var $586edbae8b35e377$export$8a6341c32b6a3ee6 = "#E3FCEF";
var $586edbae8b35e377$export$69a3bf21b9686c2b = "#ABF5D1";
var $586edbae8b35e377$export$afbce1382ec95f73 = "#79F2C0";
var $586edbae8b35e377$export$747d86715d4175de = "#57D9A3";
var $586edbae8b35e377$export$940e1f69e873f202 = "#36B37E";
var $586edbae8b35e377$export$a49394138f7b8e85 = "#00875A";
var $586edbae8b35e377$export$6fa04827ac68a4fb = "#006644";
var $586edbae8b35e377$export$226de0355ed012f8 = "#DEEBFF";
var $586edbae8b35e377$export$8c13c2ee36917869 = "#B3D4FF";
var $586edbae8b35e377$export$ecfc1dff386a3e7a = "#4C9AFF";
var $586edbae8b35e377$export$215b7063051591f1 = "#2684FF";
var $586edbae8b35e377$export$e62e8919cca44969 = "#0065FF";
var $586edbae8b35e377$export$b3de0ae08da2ce64 = "#0052CC";
var $586edbae8b35e377$export$a6ee3d71bc067634 = "#0747A6";
var $586edbae8b35e377$export$363e4475840015bb = "#EAE6FF";
var $586edbae8b35e377$export$4b0a4417ed59760f = "#C0B6F2";
var $586edbae8b35e377$export$6011520a64d9a187 = "#998DD9";
var $586edbae8b35e377$export$a7175d4e9206bc80 = "#8777D9";
var $586edbae8b35e377$export$b48405b95304b5a1 = "#6554C0";
var $586edbae8b35e377$export$c71e4279dd54a18d = "#5243AA";
var $586edbae8b35e377$export$147899de772240ec = "#403294";
var $586edbae8b35e377$export$2cf711fe14c66f06 = "#E6FCFF";
var $586edbae8b35e377$export$7a8f4d33f6f9772c = "#B3F5FF";
var $586edbae8b35e377$export$776c9c497ef08533 = "#79E2F2";
var $586edbae8b35e377$export$69cb3ca10c1e330e = "#00C7E6";
var $586edbae8b35e377$export$9dc1ef0f3f48059b = "#00B8D9";
var $586edbae8b35e377$export$7c835c78b6fcdef8 = "#00A3BF";
var $586edbae8b35e377$export$6036577f95c3877e = "#008DA6";
var $586edbae8b35e377$export$29a4f05edc054374 = "#FFFFFF";
var $586edbae8b35e377$export$e655ef011c4aa1a2 = "#FAFBFC";
var $586edbae8b35e377$export$9fdfb749e33cdf97 = "#F4F5F7";
var $586edbae8b35e377$export$3e51e8f1440314ba = "#EBECF0";
var $586edbae8b35e377$export$1ce2d1575d444ceb = "#DFE1E6";
var $586edbae8b35e377$export$8754fc7e6d8b3000 = "#C1C7D0";
var $586edbae8b35e377$export$c2e91cbeada39b8b = "#B3BAC5";
var $586edbae8b35e377$export$5f71e19f3a7ad9de = "#A5ADBA";
var $586edbae8b35e377$export$eaa8c8a70ac22806 = "#97A0AF";
var $586edbae8b35e377$export$7c87d337fb91a97d = "#8993A4";
var $586edbae8b35e377$export$d6447c357493214f = "#7A869A";
var $586edbae8b35e377$export$f563ee71e9ee74cd = "#6B778C";
var $586edbae8b35e377$export$e2ef2124cf4024b1 = "#5E6C84";
var $586edbae8b35e377$export$eece5f492e429f08 = "#505F79";
var $586edbae8b35e377$export$c39c0fe0f26207ae = "#42526E";
var $586edbae8b35e377$export$7090862dc3038a9f = "#344563";
var $586edbae8b35e377$export$ad0bacf983b7ddaa = "#253858";
var $586edbae8b35e377$export$7d61b15e0da132af = "#172B4D";
var $586edbae8b35e377$export$fbda843f0a27fe96 = "#091E42";
var $586edbae8b35e377$export$791e57b27ca738ef = "rgba(9, 30, 66, 0.02)";
var $586edbae8b35e377$export$8d43898f60b96a82 = "rgba(9, 30, 66, 0.04)";
var $586edbae8b35e377$export$920c0d5c49070351 = "rgba(9, 30, 66, 0.08)";
var $586edbae8b35e377$export$46987b49aab6d1a8 = "rgba(9, 30, 66, 0.13)";
var $586edbae8b35e377$export$7d3359664e8bb0e5 = "rgba(9, 30, 66, 0.25)";
var $586edbae8b35e377$export$d2d3bedfb276cac0 = "rgba(9, 30, 66, 0.31)";
var $586edbae8b35e377$export$6e5e7499ff054f6d = "rgba(9, 30, 66, 0.36)";
var $586edbae8b35e377$export$59264b346c877fa7 = "rgba(9, 30, 66, 0.42)";
var $586edbae8b35e377$export$d092757d7c64925c = "rgba(9, 30, 66, 0.48)";
var $586edbae8b35e377$export$486ab785e4bac3c6 = "rgba(9, 30, 66, 0.54)";
var $586edbae8b35e377$export$fba592bbc6419fea = "rgba(9, 30, 66, 0.60)";
var $586edbae8b35e377$export$13609db0e6812ab8 = "rgba(9, 30, 66, 0.66)";
var $586edbae8b35e377$export$fbae4efaa892d883 = "rgba(9, 30, 66, 0.71)";
var $586edbae8b35e377$export$f13946d26f440ce6 = "rgba(9, 30, 66, 0.77)";
var $586edbae8b35e377$export$19f58225ac52a306 = "rgba(9, 30, 66, 0.82)";
var $586edbae8b35e377$export$6384f09da70e7b62 = "rgba(9, 30, 66, 0.89)";
var $586edbae8b35e377$export$d0dccc730683edc2 = "rgba(9, 30, 66, 0.95)";
var $586edbae8b35e377$export$2f6319cf7d736c2a = "#E6EDFA";
var $586edbae8b35e377$export$95126bc8884d6634 = "#DCE5F5";
var $586edbae8b35e377$export$8338d8c35d44ff1 = "#CED9EB";
var $586edbae8b35e377$export$5368d76ae4fbbda7 = "#B8C7E0";
var $586edbae8b35e377$export$9f0a771d16ec8d36 = "#ABBBD6";
var $586edbae8b35e377$export$abcf8c38338b4aa5 = "#9FB0CC";
var $586edbae8b35e377$export$97e81faa16a182c7 = "#8C9CB8";
var $586edbae8b35e377$export$bfe21c59123ecf33 = "#7988A3";
var $586edbae8b35e377$export$ee82aa2ea6a1558 = "#67758F";
var $586edbae8b35e377$export$682927c6ed76be02 = "#56637A";
var $586edbae8b35e377$export$91fd9994c5be9757 = "#455166";
var $586edbae8b35e377$export$d281fbfe3cff2df6 = "#3B475C";
var $586edbae8b35e377$export$3902c91d8b98a753 = "#313D52";
var $586edbae8b35e377$export$8e8133c1ba5845b5 = "#283447";
var $586edbae8b35e377$export$33ff357f6620b39 = "#202B3D";
var $586edbae8b35e377$export$633847cf062b69e0 = "#1B2638";
var $586edbae8b35e377$export$9776a6e503bdbf76 = "#121A29";
var $586edbae8b35e377$export$6c813d5160dff5db = "#0E1624";
var $586edbae8b35e377$export$3d4f271a500072a = "#0D1424";
var $586edbae8b35e377$export$fe151285c22759ec = "rgba(13, 20, 36, 0.06)";
var $586edbae8b35e377$export$a101c6190d0da34 = "rgba(13, 20, 36, 0.14)";
var $586edbae8b35e377$export$4b16f52932fda51 = "rgba(13, 20, 36, 0.18)";
var $586edbae8b35e377$export$a74bcd7b9845b0d8 = "rgba(13, 20, 36, 0.29)";
var $586edbae8b35e377$export$9209c179316d1751 = "rgba(13, 20, 36, 0.36)";
var $586edbae8b35e377$export$88f55133f636c8dd = "rgba(13, 20, 36, 0.40)";
var $586edbae8b35e377$export$51126f85d1009512 = "rgba(13, 20, 36, 0.47)";
var $586edbae8b35e377$export$a069b547bd23af78 = "rgba(13, 20, 36, 0.53)";
var $586edbae8b35e377$export$40cce05af3b2600a = "rgba(13, 20, 36, 0.63)";
var $586edbae8b35e377$export$b78942185925a0d = "rgba(13, 20, 36, 0.73)";
var $586edbae8b35e377$export$e058fb44b8eaafca = "rgba(13, 20, 36, 0.78)";
var $586edbae8b35e377$export$92b0b8de26920c18 = "rgba(13, 20, 36, 0.81)";
var $586edbae8b35e377$export$67564f7459d3fc9e = "rgba(13, 20, 36, 0.85)";
var $586edbae8b35e377$export$77868e1ca884ffa3 = "rgba(13, 20, 36, 0.89)";
var $586edbae8b35e377$export$2afd71d7d3ea2cd5 = "rgba(13, 20, 36, 0.92)";
var $586edbae8b35e377$export$f2a0acaab9972c70 = "rgba(13, 20, 36, 0.95)";
var $586edbae8b35e377$export$9ab70e67d6475361 = "rgba(13, 20, 36, 0.97)";

});

parcelRegister("TZINb", function(module, exports) {

$parcel$export(module.exports, "presetSizes", function () { return $0a8503c3afa39d0b$export$4e9f1640bbe7a1a8; });
var $0a8503c3afa39d0b$export$4e9f1640bbe7a1a8 = {
    xsmall: 8,
    small: 16,
    medium: 24,
    large: 48,
    xlarge: 96
};

});


parcelRegister("hWOpk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d10ef454b5902969$var$_react = $d10ef454b5902969$var$_interopRequireDefault((parcelRequire("dAx5m")));

var $jzYs3 = parcelRequire("jzYs3");

var $d10ef454b5902969$var$_crossCircle = $d10ef454b5902969$var$_interopRequireDefault((parcelRequire("fb0jV")));
function $d10ef454b5902969$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $d10ef454b5902969$var$SelectClearIcon = (props)=>/*#__PURE__*/ $d10ef454b5902969$var$_react.default.createElement($jzYs3.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="9" fill="currentcolor"/><path fill="inherit" d="M16.155 14.493a1.174 1.174 0 1 1-1.662 1.663L12 13.662l-2.494 2.494a1.17 1.17 0 0 1-1.662 0 1.176 1.176 0 0 1 0-1.663L10.337 12 7.844 9.507a1.176 1.176 0 0 1 1.662-1.662L12 10.338l2.493-2.493a1.174 1.174 0 1 1 1.662 1.662L13.662 12z"/></g></svg>`
    }, props, {
        newIcon: $d10ef454b5902969$var$_crossCircle.default
    }));
$d10ef454b5902969$var$SelectClearIcon.displayName = "SelectClearIcon";
var $d10ef454b5902969$var$_default = module.exports.default = $d10ef454b5902969$var$SelectClearIcon;

});
parcelRegister("jzYs3", function(module, exports) {

$parcel$export(module.exports, "IconFacade", function () { return $e4102d9c129ecc1e$export$3cfb73f70dfca966; });

var $ddhXb = parcelRequire("ddhXb");

var $aJTPI = parcelRequire("aJTPI");

var $dAx5m = parcelRequire("dAx5m");

var $dx6Sv = parcelRequire("dx6Sv");

var $bS1q5 = parcelRequire("bS1q5");
var $e4102d9c129ecc1e$var$_excluded = [
    "dangerouslySetGlyph"
];
var $e4102d9c129ecc1e$var$sizesEligibleForNewIcons = [
    "small",
    "medium"
];
var $e4102d9c129ecc1e$export$3cfb73f70dfca966 = /*#__PURE__*/ (0, $dAx5m.memo)(function IconFacade(_ref) {
    var _props$size;
    var dangerouslySetGlyph = _ref.dangerouslySetGlyph, props = (0, (/*@__PURE__*/$parcel$interopDefault($aJTPI)))(_ref, $e4102d9c129ecc1e$var$_excluded);
    var NewIcon = props.newIcon;
    // By default, the icon size will be medium and spacing will be none for small icons
    var size = (_props$size = props.size) !== null && _props$size !== void 0 ? _props$size : "medium";
    var spacing = size === "small" ? "none" : "spacious";
    var useNewIcon = !props.isFacadeDisabled && // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
    (0, $dx6Sv.fg)("platform-visual-refresh-icons-legacy-facade") && $e4102d9c129ecc1e$var$sizesEligibleForNewIcons.includes(size);
    if (useNewIcon && NewIcon) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement(NewIcon, (0, (/*@__PURE__*/$parcel$interopDefault($ddhXb)))({}, props, {
        spacing: spacing,
        color: props.primaryColor || "currentColor",
        type: props.iconType
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $bS1q5.default), (0, (/*@__PURE__*/$parcel$interopDefault($ddhXb)))({
        dangerouslySetGlyph: dangerouslySetGlyph
    }, props));
});
var $e4102d9c129ecc1e$export$2e2bcd8739ae039 = $e4102d9c129ecc1e$export$3cfb73f70dfca966;

});
parcelRegister("dx6Sv", function(module, exports) {

$parcel$export(module.exports, "fg", function () { return $9da3b142228c7d1c$export$b40ec24ac8275656; });

var $2ePz4 = parcelRequire("2ePz4");
function $9da3b142228c7d1c$export$ba05d765b8392e5e(flagResolver) {
    (0, $2ePz4.setBooleanResolver)(flagResolver);
}
function $9da3b142228c7d1c$export$470e5c2be1411c89(name) {
    return (0, $2ePz4.resolveBooleanFlag)(name);
}
function $9da3b142228c7d1c$export$b40ec24ac8275656(name) {
    return (0, $2ePz4.resolveBooleanFlag)(name);
}

});
parcelRegister("2ePz4", function(module, exports) {

$parcel$export(module.exports, "setBooleanResolver", function () { return $1a14e33aa733c3d3$export$f2b591175b3e424c; });
$parcel$export(module.exports, "resolveBooleanFlag", function () { return $1a14e33aa733c3d3$export$6333b6aff9fc6275; });

var $joHau = parcelRequire("joHau");

var $ahJoN = parcelRequire("ahJoN");
var $1a14e33aa733c3d3$var$pkgName = "@atlaskit/platform-feature-flags";
var $1a14e33aa733c3d3$export$7e41b1b2bdee3f98 = "__PLATFORM_FEATURE_FLAGS__";
var $1a14e33aa733c3d3$var$hasProcessEnv = typeof $ahJoN !== "undefined" && typeof $ahJoN.env !== "undefined";
// FF global overrides can be configured by test runners or Storybook
var $1a14e33aa733c3d3$var$ENV_ENABLE_PLATFORM_FF = $1a14e33aa733c3d3$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
// STORYBOOK_ENABLE_PLATFORM_FF is included as storybook only allows env vars prefixed with STORYBOOK
// https://github.com/storybookjs/storybook/issues/12270
var $1a14e33aa733c3d3$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF = $1a14e33aa733c3d3$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
var $1a14e33aa733c3d3$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE = $1a14e33aa733c3d3$var$ENV_ENABLE_PLATFORM_FF || $1a14e33aa733c3d3$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF;
var $1a14e33aa733c3d3$var$DEFAULT_PFF_GLOBAL = {
    // In development mode we want to capture any feature flag checks that happen using the default resolver and log this result when the resolver is replaced.
    // This is because evaluating feature flags when the resolver/FF client is loaded asynchronously could cause unexpected issues.
    earlyResolvedFlags: new Map(),
    booleanResolver: function booleanResolver(flagKey) {
        var unresolvedFlagCount;
        return false;
    }
};
var $1a14e33aa733c3d3$var$globalVar = typeof window !== "undefined" ? window : globalThis;
$1a14e33aa733c3d3$var$globalVar[$1a14e33aa733c3d3$export$7e41b1b2bdee3f98] = $1a14e33aa733c3d3$var$globalVar[$1a14e33aa733c3d3$export$7e41b1b2bdee3f98] || $1a14e33aa733c3d3$var$DEFAULT_PFF_GLOBAL;
function $1a14e33aa733c3d3$export$f2b591175b3e424c(resolver) {
    $1a14e33aa733c3d3$var$globalVar[$1a14e33aa733c3d3$export$7e41b1b2bdee3f98].booleanResolver = resolver;
    var _globalVar$PFF_GLOBAL;
}
function $1a14e33aa733c3d3$export$6333b6aff9fc6275(flagKey) {
    if ($1a14e33aa733c3d3$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE) {
        (0, $joHau.debug)('[%s]: The feature flags were enabled while running tests. The flag "%s" will be always enabled.', $1a14e33aa733c3d3$var$pkgName, flagKey);
        return true;
    }
    try {
        var _globalVar$PFF_GLOBAL2;
        var result = (_globalVar$PFF_GLOBAL2 = $1a14e33aa733c3d3$var$globalVar[$1a14e33aa733c3d3$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL2 === void 0 ? void 0 : _globalVar$PFF_GLOBAL2.booleanResolver(flagKey);
        if (typeof result !== "boolean") {
            // eslint-disable-next-line no-console
            console.warn("".concat(flagKey, " resolved to a non-boolean value, returning false for safety"));
            return false;
        }
        return result;
    } catch (e) {
        return false;
    }
}

});
parcelRegister("joHau", function(module, exports) {

$parcel$export(module.exports, "debug", function () { return $e1f1be7e0361e687$export$1c9f709888824e05; });
var $e1f1be7e0361e687$var$_ref, $e1f1be7e0361e687$var$_process, $e1f1be7e0361e687$var$_process2;
// We can't rely on NODE_ENV === 'test' if its value is already configured by the consumer to some other value, so better to use JEST_WORKER_ID
// https://jestjs.io/docs/environment-variables#jest_worker_id
var $e1f1be7e0361e687$var$TESTS_MODE = ($e1f1be7e0361e687$var$_ref = (globalThis === null || globalThis === void 0 || ($e1f1be7e0361e687$var$_process = globalThis.process) === null || $e1f1be7e0361e687$var$_process === void 0 || ($e1f1be7e0361e687$var$_process = $e1f1be7e0361e687$var$_process.env) === null || $e1f1be7e0361e687$var$_process === void 0 ? void 0 : $e1f1be7e0361e687$var$_process.JEST_WORKER_ID) !== undefined, $e1f1be7e0361e687$var$_ref !== void 0) ? $e1f1be7e0361e687$var$_ref : false;
var $e1f1be7e0361e687$var$DEBUG_MODE = !$e1f1be7e0361e687$var$TESTS_MODE && (globalThis === null || globalThis === void 0 || ($e1f1be7e0361e687$var$_process2 = globalThis.process) === null || $e1f1be7e0361e687$var$_process2 === void 0 || ($e1f1be7e0361e687$var$_process2 = $e1f1be7e0361e687$var$_process2.env) === null || $e1f1be7e0361e687$var$_process2 === void 0 ? void 0 : $e1f1be7e0361e687$var$_process2.NODE_ENV) !== "production";
var $e1f1be7e0361e687$export$1c9f709888824e05 = function debug() {
    var _console;
    if (!$e1f1be7e0361e687$var$DEBUG_MODE) return;
    // eslint-disable-next-line no-console
    (_console = console).debug.apply(_console, arguments);
};

});



parcelRegister("bS1q5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8a45d6c8dc43854f$export$2e2bcd8739ae039; });

var $ddhXb = parcelRequire("ddhXb");

var $gvqMl = parcelRequire("gvqMl");

var $dAx5m = parcelRequire("dAx5m");

var $jVTBW = parcelRequire("jVTBW");

var $7h6z5 = parcelRequire("7h6z5");

var $dy69c = parcelRequire("dy69c");
function $8a45d6c8dc43854f$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $8a45d6c8dc43854f$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $8a45d6c8dc43854f$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($gvqMl)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $8a45d6c8dc43854f$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
/**
 * We are hiding these props from consumers as they're used to
 * hack around icon sizing specifically for icon-file-type.
 */ var $8a45d6c8dc43854f$var$iconStyles = (0, $jVTBW.css)({
    display: "inline-block",
    flexShrink: 0,
    lineHeight: 1,
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    "> svg": $8a45d6c8dc43854f$var$_objectSpread($8a45d6c8dc43854f$var$_objectSpread({}, (0, $7h6z5.commonSVGStyles)), {}, {
        maxWidth: "100%",
        maxHeight: "100%",
        color: "var(--icon-primary-color)",
        fill: "var(--icon-secondary-color)",
        verticalAlign: "bottom"
    })
});
/**
 * For windows high contrast mode
 */ var $8a45d6c8dc43854f$var$baseHcmStyles = (0, $jVTBW.css)({
    "@media screen and (forced-colors: active)": {
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        "> svg": {
            filter: "grayscale(1)",
            "--icon-primary-color": "CanvasText",
            // foreground
            "--icon-secondary-color": "Canvas" // background
        }
    }
});
var $8a45d6c8dc43854f$var$primaryEqualsSecondaryHcmStyles = (0, $jVTBW.css)({
    "@media screen and (forced-colors: active)": {
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        "> svg": {
            // if the primaryColor is the same as the secondaryColor we
            // set the --icon-primary-color to Canvas
            // this is usually to convey state i.e. Checkbox checked -> not checked
            "--icon-primary-color": "Canvas" // foreground
        }
    }
});
var $8a45d6c8dc43854f$var$secondaryTransparentHcmStyles = (0, $jVTBW.css)({
    "@media screen and (forced-colors: active)": {
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        "> svg": {
            "--icon-secondary-color": "transparent" // background
        }
    }
});
var $8a45d6c8dc43854f$export$f04a61298a47a40f = /*#__PURE__*/ (0, $dAx5m.memo)(function Icon(props) {
    var _ref = props, Glyph = _ref.glyph, dangerouslySetGlyph = _ref.dangerouslySetGlyph, _ref$primaryColor = _ref.primaryColor, primaryColor = _ref$primaryColor === void 0 ? "currentColor" : _ref$primaryColor, secondaryColor = _ref.secondaryColor, size = _ref.size, testId = _ref.testId, label = _ref.label, width = _ref.width, height = _ref.height, UNSAFE_margin = _ref.UNSAFE_margin;
    var glyphProps = dangerouslySetGlyph ? {
        dangerouslySetInnerHTML: {
            __html: dangerouslySetGlyph
        }
    } : {
        children: Glyph ? (0, $jVTBW.jsx)(Glyph, {
            role: "presentation"
        }) : null
    };
    var dimensions = (0, $7h6z5.getIconSize)({
        width: width,
        height: height,
        size: size
    });
    return (0, $jVTBW.jsx)("span", (0, (/*@__PURE__*/$parcel$interopDefault($ddhXb)))({
        "data-testid": testId,
        "data-vc": "icon-".concat(testId),
        role: label ? "img" : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: $8a45d6c8dc43854f$var$_objectSpread({
            "--icon-primary-color": primaryColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            "--icon-secondary-color": secondaryColor || (0, $dy69c.getBackground)()
        }, UNSAFE_margin ? {
            margin: UNSAFE_margin
        } : {})
    }, glyphProps, {
        css: [
            $8a45d6c8dc43854f$var$iconStyles,
            $8a45d6c8dc43854f$var$baseHcmStyles,
            primaryColor === secondaryColor && $8a45d6c8dc43854f$var$primaryEqualsSecondaryHcmStyles,
            secondaryColor === "transparent" && $8a45d6c8dc43854f$var$secondaryTransparentHcmStyles,
            // NB: This can be resolved if this component, composes base SVG / and/or skeleton
            // We could then simplify how common styles are dealt with simply by encapsulating them
            // at their appropriate level and/or having a singular approach to css variables in the package
            dimensions && // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $jVTBW.css)({
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                width: dimensions.width,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                height: dimensions.height,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                "> svg": dimensions
            })
        ]
    }));
});
var $8a45d6c8dc43854f$export$2e2bcd8739ae039 = $8a45d6c8dc43854f$export$f04a61298a47a40f;

});
parcelRegister("7h6z5", function(module, exports) {

$parcel$export(module.exports, "commonSVGStyles", function () { return $54bf369c6abd8521$export$16374db1c3e6dfba; });
$parcel$export(module.exports, "getIconSize", function () { return $54bf369c6abd8521$export$3eb7d6130acfda37; });

var $7B96k = parcelRequire("7B96k");

var $jVTBW = parcelRequire("jVTBW");
var $54bf369c6abd8521$export$16374db1c3e6dfba = {
    overflow: "hidden",
    pointerEvents: "none",
    /**
   * Stop-color doesn't properly apply in chrome when the inherited/current color changes.
   * We have to initially set stop-color to inherit (either via DOM attribute or an initial CSS
   * rule) and then override it with currentColor for the color changes to be picked up.
   */ stop: {
        stopColor: "currentColor"
    }
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
var $54bf369c6abd8521$var$smallStyles = (0, $jVTBW.css)((0, $7B96k.dimensions).small);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
var $54bf369c6abd8521$var$mediumStyles = (0, $jVTBW.css)((0, $7B96k.dimensions).medium);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
var $54bf369c6abd8521$var$largeStyles = (0, $jVTBW.css)((0, $7B96k.dimensions).large);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
var $54bf369c6abd8521$var$xlargeStyles = (0, $jVTBW.css)((0, $7B96k.dimensions).xlarge);
var $54bf369c6abd8521$export$ef0ad74202575b64 = {
    small: $54bf369c6abd8521$var$smallStyles,
    medium: $54bf369c6abd8521$var$mediumStyles,
    large: $54bf369c6abd8521$var$largeStyles,
    xlarge: $54bf369c6abd8521$var$xlargeStyles
};
var $54bf369c6abd8521$export$3eb7d6130acfda37 = function getIconSize(_ref) {
    var width = _ref.width, height = _ref.height, size = _ref.size;
    if (width && height) return {
        width: width,
        height: height
    };
    if (size) return (0, $7B96k.dimensions)[size];
    return undefined;
};

});
parcelRegister("7B96k", function(module, exports) {

$parcel$export(module.exports, "dimensions", function () { return $58830c67fb275cb7$export$62ad7b0c781000e9; });
var $58830c67fb275cb7$export$c647cb0ee6e282fe = {
    small: "16px",
    medium: "24px",
    large: "32px",
    xlarge: "48px"
};
var $58830c67fb275cb7$export$7bd66fc94c81bf84 = {
    small: "small",
    medium: "medium",
    large: "large",
    xlarge: "xlarge"
};
var $58830c67fb275cb7$export$62ad7b0c781000e9 = {
    small: {
        width: $58830c67fb275cb7$export$c647cb0ee6e282fe.small,
        height: $58830c67fb275cb7$export$c647cb0ee6e282fe.small
    },
    medium: {
        width: $58830c67fb275cb7$export$c647cb0ee6e282fe.medium,
        height: $58830c67fb275cb7$export$c647cb0ee6e282fe.medium
    },
    large: {
        width: $58830c67fb275cb7$export$c647cb0ee6e282fe.large,
        height: $58830c67fb275cb7$export$c647cb0ee6e282fe.large
    },
    xlarge: {
        width: $58830c67fb275cb7$export$c647cb0ee6e282fe.xlarge,
        height: $58830c67fb275cb7$export$c647cb0ee6e282fe.xlarge
    }
};

});


parcelRegister("dy69c", function(module, exports) {

$parcel$export(module.exports, "getBackground", function () { return $9dd33811ff0894b8$export$18cb9425622d4e06; });
var $9dd33811ff0894b8$export$18cb9425622d4e06 = function getBackground() {
    return "var(--ds-surface, #FFFFFF)";
};

});



parcelRegister("fb0jV", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6e3245a4cda5405cbe39cdb10fb1ac0b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $02d9f0071caceb4c$var$_react = $02d9f0071caceb4c$var$_interopRequireDefault((parcelRequire("dAx5m")));

var $02d9f0071caceb4c$var$_UNSAFE_baseNew = $02d9f0071caceb4c$var$_interopRequireDefault((parcelRequire("4MLve")));
function $02d9f0071caceb4c$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "CrossCircle".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: clear text field, error status.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $02d9f0071caceb4c$var$CrossCircleIcon = (props)=>/*#__PURE__*/ $02d9f0071caceb4c$var$_react.default.createElement($02d9f0071caceb4c$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0m4.03 5.03L9.06 8l2.97 2.97-1.06 1.06L8 9.06l-2.97 2.97-1.06-1.06L6.94 8 3.97 5.03l1.06-1.06L8 6.94l2.97-2.97z" clip-rule="evenodd"/>`
    }, props));
$02d9f0071caceb4c$var$CrossCircleIcon.displayName = "CrossCircleIcon";
var $02d9f0071caceb4c$var$_default = module.exports.default = $02d9f0071caceb4c$var$CrossCircleIcon;

});
parcelRegister("4MLve", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("bTGKP")).default; });
$parcel$export(module.exports, "Icon", function () { return (parcelRequire("bTGKP")).Icon; });

var $bTGKP = parcelRequire("bTGKP");

});
parcelRegister("bTGKP", function(module, exports) {

$parcel$export(module.exports, "Icon", function () { return $8a95fedc95256b0c$export$f04a61298a47a40f; });
$parcel$export(module.exports, "default", function () { return $8a95fedc95256b0c$export$2e2bcd8739ae039; });
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $dAx5m = parcelRequire("dAx5m");

var $jVTBW = parcelRequire("jVTBW");

var $dx6Sv = parcelRequire("dx6Sv");
/**
 * We are hiding this props from consumers as it's reserved
 * for use by Icon Tile.
 */ var $8a95fedc95256b0c$var$commonSVGStyles = (0, $jVTBW.css)({
    overflow: "hidden",
    pointerEvents: "none",
    /**
   * Stop-color doesn't properly apply in chrome when the inherited/current color changes.
   * We have to initially set stop-color to inherit (either via DOM attribute or an initial CSS
   * rule) and then override it with currentColor for the color changes to be picked up.
   */ // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    stop: {
        stopColor: "currentColor"
    }
});
var $8a95fedc95256b0c$var$svgStyles = (0, $jVTBW.css)({
    color: "currentColor",
    verticalAlign: "bottom"
});
var $8a95fedc95256b0c$var$iconStyles = (0, $jVTBW.css)({
    display: "inline-block",
    boxSizing: "border-box",
    flexShrink: 0,
    lineHeight: 1,
    paddingInlineEnd: "var(--ds--button--new-icon-padding-end, 0)",
    paddingInlineStart: "var(--ds--button--new-icon-padding-start, 0)"
});
var $8a95fedc95256b0c$var$utilityIconStyles = (0, $jVTBW.css)({
    lineHeight: "var(--ds-space-150, 12px)"
});
var $8a95fedc95256b0c$var$scaleStyles = (0, $jVTBW.css)({
    width: "inherit",
    height: "inherit"
});
/**
 * For windows high contrast mode
 */ var $8a95fedc95256b0c$var$baseHcmStyles = (0, $jVTBW.css)({
    "@media screen and (forced-colors: active)": {
        color: "CanvasText",
        filter: "grayscale(1)"
    }
});
var $8a95fedc95256b0c$var$sizeMap = {
    scale: (0, $jVTBW.css)({
        width: "inherit",
        height: "inherit"
    }),
    utility: (0, $jVTBW.css)({
        width: "var(--ds-space-150, 12px)",
        height: "var(--ds-space-150, 12px)"
    }),
    none: (0, $jVTBW.css)({
        width: "var(--ds-space-200, 16px)",
        height: "var(--ds-space-200, 16px)"
    }),
    spacious: (0, $jVTBW.css)({
        width: "var(--ds-space-300, 24px)",
        height: "var(--ds-space-300, 24px)"
    })
};
var $8a95fedc95256b0c$var$baseSizeMap = {
    global: 16,
    utility: 12
};
var $8a95fedc95256b0c$export$f04a61298a47a40f = /*#__PURE__*/ (0, $dAx5m.memo)(function Icon(props) {
    var _ref = props, providedColor = _ref.color, _ref$spacing = _ref.spacing, providedSpacing = _ref$spacing === void 0 ? "none" : _ref$spacing, testId = _ref.testId, label = _ref.label, LEGACY_primaryColor = _ref.LEGACY_primaryColor, LEGACY_secondaryColor = _ref.LEGACY_secondaryColor, LEGACY_size = _ref.LEGACY_size, FallbackIcon = _ref.LEGACY_fallbackIcon, _ref$type = _ref.type, type = _ref$type === void 0 ? "global" : _ref$type, dangerouslySetGlyph = _ref.dangerouslySetGlyph, shouldScale = _ref.shouldScale, LEGACY_margin = _ref.LEGACY_margin;
    var fallbackColor = "var(--ds-icon, #44546F)";
    if ((0, $dx6Sv.fg)("platform-design-system-new-icon-default-color") || (0, $dx6Sv.fg)("platform-design-system-new-icon-default-color-2")) fallbackColor = "currentColor";
    var color = providedColor !== null && providedColor !== void 0 ? providedColor : fallbackColor;
    var dangerouslySetInnerHTML = dangerouslySetGlyph ? {
        __html: dangerouslySetGlyph
    } : undefined;
    // Fall back to old icon
    if (FallbackIcon && !(0, $dx6Sv.fg)("platform.design-system-team.enable-new-icons")) // parse out unnecessary props
    return (0, $jVTBW.jsx)(FallbackIcon, {
        primaryColor: LEGACY_primaryColor !== null && LEGACY_primaryColor !== void 0 ? LEGACY_primaryColor : color,
        secondaryColor: LEGACY_secondaryColor,
        size: LEGACY_size,
        label: label,
        testId: testId,
        UNSAFE_margin: LEGACY_margin
    });
    // Utility icons don't have 'spacing' as a type, but in case it's provided, we default to 'none'
    var spacing = type === "utility" ? "none" : providedSpacing;
    var baseSize = $8a95fedc95256b0c$var$baseSizeMap[type];
    var size = type === "utility" ? "utility" : shouldScale ? "scale" : spacing;
    var viewBoxPadding = spacing === "spacious" ? 4 : 0;
    var viewBoxSize = baseSize + 2 * viewBoxPadding;
    // Workaround for the transparency in our disabled icon token.
    // Because we have multiple strokes in icons, opacities overlap
    // This filter has an impact on render performance, but this is
    // acceptable as icons aren't commonly disabled en-masse
    var iconColor = color;
    if (dangerouslySetInnerHTML && color === "var(--ds-icon-disabled, #091E424F)") {
        dangerouslySetInnerHTML.__html = '\n<filter id="ds-newIconOpacityFilter">\n  <feFlood flood-color="var(--ds-icon-disabled)" />\n  <feComposite in2="SourceGraphic" operator="in" />\n</filter>\n<g filter="url(#ds-newIconOpacityFilter)">\n  '.concat(dangerouslySetInnerHTML.__html, "\n</g>");
        iconColor = "var(--ds-icon, #44546F)";
    }
    return (0, $jVTBW.jsx)("span", {
        "data-testid": testId,
        role: label ? "img" : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: {
            color: iconColor
        },
        css: [
            $8a95fedc95256b0c$var$iconStyles,
            $8a95fedc95256b0c$var$baseHcmStyles,
            shouldScale && $8a95fedc95256b0c$var$scaleStyles,
            type === "utility" && $8a95fedc95256b0c$var$utilityIconStyles
        ]
    }, (0, $jVTBW.jsx)("svg", {
        fill: "none",
        viewBox: "".concat(0 - viewBoxPadding, " ").concat(0 - viewBoxPadding, " ").concat(viewBoxSize, " ").concat(viewBoxSize),
        role: "presentation",
        css: [
            $8a95fedc95256b0c$var$commonSVGStyles,
            $8a95fedc95256b0c$var$svgStyles,
            $8a95fedc95256b0c$var$sizeMap[size]
        ],
        dangerouslySetInnerHTML: dangerouslySetInnerHTML
    }));
});
var $8a95fedc95256b0c$export$2e2bcd8739ae039 = $8a95fedc95256b0c$export$f04a61298a47a40f;

});




parcelRegister("hquSE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $cafcd19256c074de$var$_react = $cafcd19256c074de$var$_interopRequireDefault((parcelRequire("dAx5m")));

var $jzYs3 = parcelRequire("jzYs3");

var $cafcd19256c074de$var$_chevronDown = $cafcd19256c074de$var$_interopRequireDefault((parcelRequire("fb1Pr")));
function $cafcd19256c074de$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $cafcd19256c074de$var$ChevronDownIcon = (props)=>/*#__PURE__*/ $cafcd19256c074de$var$_react.default.createElement($jzYs3.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M8.292 10.293a1.01 1.01 0 0 0 0 1.419l2.939 2.965c.218.215.5.322.779.322s.556-.107.769-.322l2.93-2.955a1.01 1.01 0 0 0 0-1.419.987.987 0 0 0-1.406 0l-2.298 2.317-2.307-2.327a.99.99 0 0 0-1.406 0"/></svg>`
    }, props, {
        newIcon: $cafcd19256c074de$var$_chevronDown.default,
        iconType: "utility"
    }));
$cafcd19256c074de$var$ChevronDownIcon.displayName = "ChevronDownIcon";
var $cafcd19256c074de$var$_default = module.exports.default = $cafcd19256c074de$var$ChevronDownIcon;

});
parcelRegister("fb1Pr", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3eb2993a427b2667a5277a7a906fec96>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b0c94d408c72a870$var$_react = $b0c94d408c72a870$var$_interopRequireDefault((parcelRequire("dAx5m")));

var $b0c94d408c72a870$var$_UNSAFE_baseNew = $b0c94d408c72a870$var$_interopRequireDefault((parcelRequire("4MLve")));
function $b0c94d408c72a870$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "ChevronDown".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for dropdown menus, selects, accordions, and expands.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b0c94d408c72a870$var$ChevronDownIcon = (props)=>/*#__PURE__*/ $b0c94d408c72a870$var$_react.default.createElement($b0c94d408c72a870$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M10.5 4.5 8.25 6.75 6 9 3.75 6.75 1.5 4.5"/>`,
        type: "utility"
    }, props));
$b0c94d408c72a870$var$ChevronDownIcon.displayName = "ChevronDownIcon";
var $b0c94d408c72a870$var$_default = module.exports.default = $b0c94d408c72a870$var$ChevronDownIcon;

});



parcelRegister("fn8ld", function(module, exports) {

$parcel$export(module.exports, "MultiValueRemove", function () { return $b30f79653fdf17d4$export$8e1fd1a40e7a2f4a; });
$parcel$export(module.exports, "IndicatorSeparator", function () { return $b30f79653fdf17d4$export$bd638c2ba7915668; });
/** @jsx jsx */ 
var $jVTBW = parcelRequire("jVTBW");

var $hWOpk = parcelRequire("hWOpk");

var $fc2pq = parcelRequire("fc2pq");

var $9GNOg = parcelRequire("9GNOg");
var $b30f79653fdf17d4$var$disabledStyles = (0, $jVTBW.css)({
    display: "none"
});
var $b30f79653fdf17d4$var$enabledStyles = (0, $jVTBW.css)({
    display: "inherit"
});
var $b30f79653fdf17d4$export$8e1fd1a40e7a2f4a = function MultiValueRemove(props) {
    var isDisabled = props.selectProps.isDisabled;
    return (0, $jVTBW.jsx)((0, $fc2pq.c).MultiValueRemove, props, (0, $jVTBW.jsx)("div", {
        css: isDisabled ? $b30f79653fdf17d4$var$disabledStyles : $b30f79653fdf17d4$var$enabledStyles,
        "data-testid": isDisabled ? "hide-clear-icon" : "show-clear-icon"
    }, (0, $jVTBW.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hWOpk))), {
        label: "Clear",
        size: "small",
        primaryColor: "transparent",
        secondaryColor: "inherit"
    })));
};
var $b30f79653fdf17d4$export$bd638c2ba7915668 = null;

});

parcelRegister("9ExPh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $707216a7c7dac785$export$2e2bcd8739ae039; });

var $gvqMl = parcelRequire("gvqMl");

var $dC8eV = parcelRequire("dC8eV");

var $dzFGL = parcelRequire("dzFGL");
function $707216a7c7dac785$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $707216a7c7dac785$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $707216a7c7dac785$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($gvqMl)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $707216a7c7dac785$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $707216a7c7dac785$export$2e2bcd8739ae039(validationState) {
    var isCompact = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var appearance = arguments.length > 2 ? arguments[2] : undefined;
    return {
        container: function container(css, _ref) {
            var isDisabled = _ref.isDisabled;
            return $707216a7c7dac785$var$_objectSpread($707216a7c7dac785$var$_objectSpread($707216a7c7dac785$var$_objectSpread({}, css), (0, $dzFGL.getBooleanFF)("platform.design-system-team.select-new-typography_7m89c") ? {
                font: 'var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)'
            } : {
                fontFamily: 'var(--ds-font-family-body, ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)'
            }), {}, {
                // react-select disables pointer events when isDisabled is true.
                // We override this and make the inner container turn it off instead.
                pointerEvents: "all",
                cursor: isDisabled ? "not-allowed" : css.cursor
            });
        },
        input: function input(css) {
            return $707216a7c7dac785$var$_objectSpread($707216a7c7dac785$var$_objectSpread({}, css), {}, {
                color: "var(--ds-text, hsl(0, 0%, 20%))"
            });
        },
        control: function control(css, _ref2) {
            var isFocused = _ref2.isFocused, isDisabled = _ref2.isDisabled;
            var borderColor = isFocused ? "var(--ds-border-focused, ".concat((0, $dC8eV.B100), ")") : "var(--ds-border-input, ".concat((0, $dC8eV.N100), ")");
            var backgroundColor = isFocused ? "var(--ds-background-input-pressed, ".concat((0, $dC8eV.N0), ")") : "var(--ds-background-input, ".concat((0, $dC8eV.N20), ")");
            var backgroundColorHover = isFocused ? "var(--ds-background-input-pressed, ".concat((0, $dC8eV.N0), ")") : "var(--ds-background-input-hovered, ".concat((0, $dC8eV.N30), ")");
            if (isDisabled) {
                backgroundColor = "var(--ds-background-disabled, ".concat((0, $dC8eV.N20), ")");
                borderColor = "var(--ds-background-disabled, ".concat((0, $dC8eV.N20), ")");
            }
            if (validationState === "error") borderColor = "var(--ds-border-danger, ".concat((0, $dC8eV.R400), ")");
            if (validationState === "success") borderColor = "var(--ds-border-success, ".concat((0, $dC8eV.G400), ")");
            var borderColorHover = isFocused ? "var(--ds-border-focused, ".concat((0, $dC8eV.B100), ")") : "var(--ds-border-input, ".concat((0, $dC8eV.N100), ")");
            if (validationState === "error") borderColorHover = "var(--ds-border-danger, ".concat((0, $dC8eV.R400), ")");
            if (validationState === "success") borderColorHover = "var(--ds-border-success, ".concat((0, $dC8eV.G400), ")");
            var transitionDuration = "200ms";
            if (appearance === "subtle") {
                borderColor = isFocused ? "var(--ds-border-focused, ".concat((0, $dC8eV.B100), ")") : "transparent";
                backgroundColor = isFocused ? "var(--ds-surface, ".concat((0, $dC8eV.N0), ")") : "transparent";
                backgroundColorHover = isFocused ? "var(--ds-background-input-pressed, ".concat((0, $dC8eV.N0), ")") : "var(--ds-background-input-hovered, ".concat((0, $dC8eV.N30), ")");
            }
            if (appearance === "none") {
                borderColor = "transparent";
                backgroundColor = "transparent";
                backgroundColorHover = "transparent";
                borderColorHover = "transparent";
            }
            return $707216a7c7dac785$var$_objectSpread($707216a7c7dac785$var$_objectSpread({}, css), {}, {
                // Turn pointer events off when disabled - this makes it so hover etc don't work.
                pointerEvents: isDisabled ? "none" : undefined,
                backgroundColor: backgroundColor,
                borderColor: borderColor,
                borderStyle: "solid",
                borderRadius: "var(--ds-border-radius-100, 3px)",
                borderWidth: "var(--ds-border-width, 1px)",
                boxShadow: validationState === "error" ? "inset 0 0 0 ".concat("var(--ds-border-width, 1px)", " ", borderColor) : "none",
                "&:focus-within": {
                    boxShadow: "inset 0 0 0 ".concat("var(--ds-border-width, 1px)", " ", borderColor)
                },
                minHeight: isCompact ? 32 : 40,
                padding: 0,
                transition: "background-color ".concat(transitionDuration, " ease-in-out,\n        border-color ").concat(transitionDuration, " ease-in-out"),
                "::-webkit-scrollbar": {
                    height: 8,
                    width: 8
                },
                "::-webkit-scrollbar-corner": {
                    display: "none"
                },
                ":hover": {
                    "::-webkit-scrollbar-thumb": {
                        // scrollbars occur only if the user passes in a custom component with overflow: scroll
                        backgroundColor: "rgba(0,0,0,0.2)"
                    },
                    cursor: "pointer",
                    backgroundColor: backgroundColorHover,
                    borderColor: borderColorHover
                },
                "::-webkit-scrollbar-thumb:hover": {
                    backgroundColor: "rgba(0,0,0,0.4)"
                }
            });
        },
        valueContainer: function valueContainer(css) {
            return $707216a7c7dac785$var$_objectSpread($707216a7c7dac785$var$_objectSpread({}, css), {}, {
                paddingLeft: "var(--ds-space-075, 6px)",
                paddingRight: "var(--ds-space-075, 6px)",
                paddingBottom: isCompact ? 0 : 2,
                paddingTop: isCompact ? 0 : 2
            });
        },
        clearIndicator: function clearIndicator(css) {
            return $707216a7c7dac785$var$_objectSpread($707216a7c7dac785$var$_objectSpread({}, css), {}, {
                color: "var(--ds-text-subtlest, ".concat((0, $dC8eV.N70), ")"),
                paddingLeft: "var(--ds-space-025, 2px)",
                paddingRight: "var(--ds-space-025, 2px)",
                paddingBottom: isCompact ? 0 : 6,
                paddingTop: isCompact ? 0 : 6,
                ":hover": {
                    color: "var(--ds-text-subtle, ".concat((0, $dC8eV.N500), ")")
                }
            });
        },
        loadingIndicator: function loadingIndicator(css) {
            return $707216a7c7dac785$var$_objectSpread($707216a7c7dac785$var$_objectSpread({}, css), {}, {
                paddingBottom: isCompact ? 0 : 6,
                paddingTop: isCompact ? 0 : 6
            });
        },
        dropdownIndicator: function dropdownIndicator(css, _ref3) {
            var isDisabled = _ref3.isDisabled;
            var color = "var(--ds-text-subtle, ".concat((0, $dC8eV.N500), ")");
            if (isDisabled) color = "var(--ds-text-disabled, ".concat((0, $dC8eV.N70), ")");
            return $707216a7c7dac785$var$_objectSpread($707216a7c7dac785$var$_objectSpread({}, css), {}, {
                color: color,
                paddingLeft: "var(--ds-space-025, 2px)",
                paddingRight: "var(--ds-space-025, 2px)",
                paddingBottom: isCompact ? 0 : 6,
                paddingTop: isCompact ? 0 : 6,
                ":hover": {
                    color: "var(--ds-text-subtle, ".concat((0, $dC8eV.N200), ")")
                }
            });
        },
        indicatorsContainer: function indicatorsContainer(css) {
            return $707216a7c7dac785$var$_objectSpread($707216a7c7dac785$var$_objectSpread({}, css), {}, {
                paddingRight: "var(--ds-space-050, 4px)"
            });
        },
        option: function option(css, _ref4) {
            var isFocused = _ref4.isFocused, isSelected = _ref4.isSelected, isDisabled = _ref4.isDisabled;
            var color = "var(--ds-text, ".concat((0, $dC8eV.N800), ")");
            if (isDisabled) color = "var(--ds-text-disabled, ".concat((0, $dC8eV.N70), ")");
            else if (isSelected) color = "var(--ds-text-selected, ".concat((0, $dC8eV.B400), ")");
            var boxShadow;
            var backgroundColor;
            if (isDisabled) backgroundColor = undefined;
            else if (isSelected && isFocused) backgroundColor = "var(--ds-background-selected-hovered, ".concat((0, $dC8eV.B50), ")");
            else if (isSelected) backgroundColor = "var(--ds-background-selected, ".concat((0, $dC8eV.B50), ")");
            else if (isFocused) backgroundColor = "var(--ds-background-neutral-subtle-hovered, ".concat((0, $dC8eV.N20), ")");
            if (!isDisabled && (isFocused || isSelected)) boxShadow = "inset 2px 0px 0px ".concat("var(--ds-border-selected, ".concat((0, $dC8eV.B400), ")"));
            var cursor = isDisabled ? "not-allowed" : css.cursor;
            return $707216a7c7dac785$var$_objectSpread($707216a7c7dac785$var$_objectSpread({}, css), {}, {
                padding: "6px 12px",
                backgroundColor: backgroundColor,
                color: color,
                cursor: cursor,
                boxShadow: boxShadow,
                ":active": {
                    backgroundColor: !isDisabled ? isSelected ? "var(--ds-background-selected-pressed, ".concat((0, $dC8eV.N20), ")") : "var(--ds-background-neutral-subtle-pressed, ".concat((0, $dC8eV.N30), ")") : undefined
                },
                "@media screen and (-ms-high-contrast: active)": {
                    borderLeft: !isDisabled && (isFocused || isSelected) ? "2px solid transparent" : ""
                }
            });
        },
        placeholder: function placeholder(css, _ref5) {
            var isDisabled = _ref5.isDisabled;
            return $707216a7c7dac785$var$_objectSpread($707216a7c7dac785$var$_objectSpread({}, css), {}, {
                color: isDisabled ? "var(--ds-text-disabled, ".concat((0, $dC8eV.N300), ")") : "var(--ds-text-subtlest, ".concat((0, $dC8eV.N200), ")")
            });
        },
        singleValue: function singleValue(css, _ref6) {
            var isDisabled = _ref6.isDisabled;
            return $707216a7c7dac785$var$_objectSpread($707216a7c7dac785$var$_objectSpread({}, css), {}, {
                color: isDisabled ? "var(--ds-text-disabled, ".concat((0, $dC8eV.N70), ")") : "var(--ds-text, ".concat((0, $dC8eV.N800), ")")
            }, !(0, $dzFGL.getBooleanFF)("platform.design-system-team.select-new-typography_7m89c") && {
                lineHeight: "1rem"
            });
        },
        menu: function menu(css) {
            return $707216a7c7dac785$var$_objectSpread($707216a7c7dac785$var$_objectSpread({}, css), {}, {
                backgroundColor: "var(--ds-surface-overlay, white)",
                boxShadow: "var(--ds-shadow-overlay, 0 0 0 1px hsl(0deg 0% 0% / 10%), 0 4px 11px hsl(0deg 0% 0% / 10%))"
            });
        },
        menuList: function menuList(css) {
            return $707216a7c7dac785$var$_objectSpread($707216a7c7dac785$var$_objectSpread({}, css), {}, {
                paddingTop: "var(--ds-space-100, 8px)",
                paddingBottom: "var(--ds-space-100, 8px)"
            });
        },
        multiValue: function multiValue(css, _ref7) {
            var isDisabled = _ref7.isDisabled, isFocused = _ref7.isFocused;
            var backgroundColor;
            var color;
            if (isDisabled) {
                // Use the basic neutral background so it is slightly separate from the
                // field's background
                backgroundColor = "var(--ds-background-neutral, ".concat((0, $dC8eV.N40), ")");
                color = "var(--ds-text-disabled, ".concat((0, $dC8eV.N70), ")");
            } else if (isFocused) {
                backgroundColor = "var(--ds-background-selected, ".concat((0, $dC8eV.N40), ")");
                color = "var(--ds-text-selected, hsl(0, 0%, 20%))";
            } else {
                backgroundColor = "var(--ds-background-neutral, ".concat((0, $dC8eV.N40), ")");
                color = "var(--ds-text, hsl(0, 0%, 20%))";
            }
            return $707216a7c7dac785$var$_objectSpread($707216a7c7dac785$var$_objectSpread({}, css), {}, {
                borderRadius: "var(--ds-border-radius-050, 2px)",
                backgroundColor: backgroundColor,
                boxShadow: isFocused ? "0 0 0 2px ".concat("var(--ds-surface, transparent)", ", 0 0 0 4px ", "var(--ds-border-focused, transparent)") : "none",
                maxWidth: "100%",
                "@media screen and (-ms-high-contrast: active)": {
                    border: isFocused ? "1px solid transparent" : "none"
                },
                color: color
            });
        },
        multiValueLabel: function multiValueLabel(css, _ref8) {
            var isDisabled = _ref8.isDisabled;
            return $707216a7c7dac785$var$_objectSpread($707216a7c7dac785$var$_objectSpread({}, css), {}, {
                padding: "var(--ds-space-025, 2px)",
                color: isDisabled ? "var(--ds-text-disabled, ".concat((0, $dC8eV.N70), ")") : "inherit",
                paddingRight: "var(--ds-space-025, 2px)"
            });
        },
        multiValueRemove: function multiValueRemove(css, _ref9) {
            var isFocused = _ref9.isFocused;
            return $707216a7c7dac785$var$_objectSpread($707216a7c7dac785$var$_objectSpread({}, css), {}, {
                backgroundColor: isFocused ? "var(--ds-UNSAFE-transparent, ".concat((0, $dC8eV.R75), ")") : undefined,
                fill: isFocused ? "var(--ds-text-selected, #000)" : "var(--ds-text, #000)",
                paddingLeft: "var(--ds-space-025, 2px)",
                paddingRight: "var(--ds-space-025, 2px)",
                borderRadius: "0px 2px 2px 0px",
                // DSP-6470 we should style like Tag once we have the :has selector
                ":hover": {
                    backgroundColor: "var(--ds-background-danger-hovered, ".concat((0, $dC8eV.R75), ")"),
                    fill: "var(--ds-text-danger, #000)"
                },
                ":active": {
                    backgroundColor: "var(--ds-background-danger-pressed, ".concat((0, $dC8eV.R75), ")"),
                    fill: "var(--ds-text-danger, #000)"
                }
            });
        },
        groupHeading: function groupHeading(css) {
            return $707216a7c7dac785$var$_objectSpread($707216a7c7dac785$var$_objectSpread($707216a7c7dac785$var$_objectSpread({}, css), (0, $dzFGL.getBooleanFF)("platform.design-system-team.select-new-typography_7m89c") && {
                font: 'var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)'
            }), {}, {
                color: "var(--ds-text-subtle, ".concat((0, $dC8eV.N200), ")")
            });
        }
    };
}

});
parcelRegister("dC8eV", function(module, exports) {

$parcel$export(module.exports, "R75", function () { return $9e95373159f60f1e$export$b34b069eff244586; });
$parcel$export(module.exports, "R400", function () { return $9e95373159f60f1e$export$2010d0fb4295b346; });
$parcel$export(module.exports, "G400", function () { return $9e95373159f60f1e$export$a49394138f7b8e85; });
$parcel$export(module.exports, "B50", function () { return $9e95373159f60f1e$export$226de0355ed012f8; });
$parcel$export(module.exports, "B100", function () { return $9e95373159f60f1e$export$ecfc1dff386a3e7a; });
$parcel$export(module.exports, "B200", function () { return $9e95373159f60f1e$export$215b7063051591f1; });
$parcel$export(module.exports, "B400", function () { return $9e95373159f60f1e$export$b3de0ae08da2ce64; });
$parcel$export(module.exports, "N0", function () { return $9e95373159f60f1e$export$29a4f05edc054374; });
$parcel$export(module.exports, "N20", function () { return $9e95373159f60f1e$export$9fdfb749e33cdf97; });
$parcel$export(module.exports, "N30", function () { return $9e95373159f60f1e$export$3e51e8f1440314ba; });
$parcel$export(module.exports, "N40", function () { return $9e95373159f60f1e$export$1ce2d1575d444ceb; });
$parcel$export(module.exports, "N70", function () { return $9e95373159f60f1e$export$5f71e19f3a7ad9de; });
$parcel$export(module.exports, "N100", function () { return $9e95373159f60f1e$export$d6447c357493214f; });
$parcel$export(module.exports, "N200", function () { return $9e95373159f60f1e$export$f563ee71e9ee74cd; });
$parcel$export(module.exports, "N300", function () { return $9e95373159f60f1e$export$e2ef2124cf4024b1; });
$parcel$export(module.exports, "N500", function () { return $9e95373159f60f1e$export$c39c0fe0f26207ae; });
$parcel$export(module.exports, "N800", function () { return $9e95373159f60f1e$export$7d61b15e0da132af; });
$parcel$export(module.exports, "N30A", function () { return $9e95373159f60f1e$export$920c0d5c49070351; });
$parcel$export(module.exports, "skeleton", function () { return $9e95373159f60f1e$export$2a0674ff2eb10214; });
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ 
var $apn14 = parcelRequire("apn14");
var $9e95373159f60f1e$export$4b84fd0e2c617bd = "#FFEBE6";
var $9e95373159f60f1e$export$b34b069eff244586 = "#FFBDAD";
var $9e95373159f60f1e$export$be802dd0d8b57f35 = "#FF8F73";
var $9e95373159f60f1e$export$60847d42f9da92a6 = "#FF7452";
var $9e95373159f60f1e$export$4a7404f376229999 = "#FF5630";
var $9e95373159f60f1e$export$2010d0fb4295b346 = "#DE350B";
var $9e95373159f60f1e$export$2837b5a1a71d5c02 = "#BF2600";
var $9e95373159f60f1e$export$8d9596b529bbb9cf = "#FFFAE6";
var $9e95373159f60f1e$export$41060a744ab0b7ae = "#FFF0B3";
var $9e95373159f60f1e$export$1cc05bbbf340e559 = "#FFE380";
var $9e95373159f60f1e$export$5aae31392d72caaa = "#FFC400";
var $9e95373159f60f1e$export$c6930421db9fa514 = "#FFAB00";
var $9e95373159f60f1e$export$59619663aa6500fb = "#FF991F";
var $9e95373159f60f1e$export$874739ea9e379ab6 = "#FF8B00";
var $9e95373159f60f1e$export$8a6341c32b6a3ee6 = "#E3FCEF";
var $9e95373159f60f1e$export$69a3bf21b9686c2b = "#ABF5D1";
var $9e95373159f60f1e$export$afbce1382ec95f73 = "#79F2C0";
var $9e95373159f60f1e$export$747d86715d4175de = "#57D9A3";
var $9e95373159f60f1e$export$940e1f69e873f202 = "#36B37E";
var $9e95373159f60f1e$export$a49394138f7b8e85 = "#00875A";
var $9e95373159f60f1e$export$6fa04827ac68a4fb = "#006644";
var $9e95373159f60f1e$export$226de0355ed012f8 = "#DEEBFF";
var $9e95373159f60f1e$export$8c13c2ee36917869 = "#B3D4FF";
var $9e95373159f60f1e$export$ecfc1dff386a3e7a = "#4C9AFF";
var $9e95373159f60f1e$export$215b7063051591f1 = "#2684FF";
var $9e95373159f60f1e$export$e62e8919cca44969 = "#0065FF";
var $9e95373159f60f1e$export$b3de0ae08da2ce64 = "#0052CC";
var $9e95373159f60f1e$export$a6ee3d71bc067634 = "#0747A6";
var $9e95373159f60f1e$export$363e4475840015bb = "#EAE6FF";
var $9e95373159f60f1e$export$4b0a4417ed59760f = "#C0B6F2";
var $9e95373159f60f1e$export$6011520a64d9a187 = "#998DD9";
var $9e95373159f60f1e$export$a7175d4e9206bc80 = "#8777D9";
var $9e95373159f60f1e$export$b48405b95304b5a1 = "#6554C0";
var $9e95373159f60f1e$export$c71e4279dd54a18d = "#5243AA";
var $9e95373159f60f1e$export$147899de772240ec = "#403294";
var $9e95373159f60f1e$export$2cf711fe14c66f06 = "#E6FCFF";
var $9e95373159f60f1e$export$7a8f4d33f6f9772c = "#B3F5FF";
var $9e95373159f60f1e$export$776c9c497ef08533 = "#79E2F2";
var $9e95373159f60f1e$export$69cb3ca10c1e330e = "#00C7E6";
var $9e95373159f60f1e$export$9dc1ef0f3f48059b = "#00B8D9";
var $9e95373159f60f1e$export$7c835c78b6fcdef8 = "#00A3BF";
var $9e95373159f60f1e$export$6036577f95c3877e = "#008DA6";
var $9e95373159f60f1e$export$29a4f05edc054374 = "#FFFFFF";
var $9e95373159f60f1e$export$e655ef011c4aa1a2 = "#FAFBFC";
var $9e95373159f60f1e$export$9fdfb749e33cdf97 = "#F4F5F7";
var $9e95373159f60f1e$export$3e51e8f1440314ba = "#EBECF0";
var $9e95373159f60f1e$export$1ce2d1575d444ceb = "#DFE1E6";
var $9e95373159f60f1e$export$8754fc7e6d8b3000 = "#C1C7D0";
var $9e95373159f60f1e$export$c2e91cbeada39b8b = "#B3BAC5";
var $9e95373159f60f1e$export$5f71e19f3a7ad9de = "#A5ADBA";
var $9e95373159f60f1e$export$eaa8c8a70ac22806 = "#97A0AF";
var $9e95373159f60f1e$export$7c87d337fb91a97d = "#8993A4";
var $9e95373159f60f1e$export$d6447c357493214f = "#7A869A";
var $9e95373159f60f1e$export$f563ee71e9ee74cd = "#6B778C";
var $9e95373159f60f1e$export$e2ef2124cf4024b1 = "#5E6C84";
var $9e95373159f60f1e$export$eece5f492e429f08 = "#505F79";
var $9e95373159f60f1e$export$c39c0fe0f26207ae = "#42526E";
var $9e95373159f60f1e$export$7090862dc3038a9f = "#344563";
var $9e95373159f60f1e$export$ad0bacf983b7ddaa = "#253858";
var $9e95373159f60f1e$export$7d61b15e0da132af = "#172B4D";
var $9e95373159f60f1e$export$fbda843f0a27fe96 = "#091E42";
var $9e95373159f60f1e$export$791e57b27ca738ef = "rgba(9, 30, 66, 0.02)";
var $9e95373159f60f1e$export$8d43898f60b96a82 = "rgba(9, 30, 66, 0.04)";
var $9e95373159f60f1e$export$920c0d5c49070351 = "rgba(9, 30, 66, 0.08)";
var $9e95373159f60f1e$export$46987b49aab6d1a8 = "rgba(9, 30, 66, 0.13)";
var $9e95373159f60f1e$export$7d3359664e8bb0e5 = "rgba(9, 30, 66, 0.25)";
var $9e95373159f60f1e$export$d2d3bedfb276cac0 = "rgba(9, 30, 66, 0.31)";
var $9e95373159f60f1e$export$6e5e7499ff054f6d = "rgba(9, 30, 66, 0.36)";
var $9e95373159f60f1e$export$59264b346c877fa7 = "rgba(9, 30, 66, 0.42)";
var $9e95373159f60f1e$export$d092757d7c64925c = "rgba(9, 30, 66, 0.48)";
var $9e95373159f60f1e$export$486ab785e4bac3c6 = "rgba(9, 30, 66, 0.54)";
var $9e95373159f60f1e$export$fba592bbc6419fea = "rgba(9, 30, 66, 0.60)";
var $9e95373159f60f1e$export$13609db0e6812ab8 = "rgba(9, 30, 66, 0.66)";
var $9e95373159f60f1e$export$fbae4efaa892d883 = "rgba(9, 30, 66, 0.71)";
var $9e95373159f60f1e$export$f13946d26f440ce6 = "rgba(9, 30, 66, 0.77)";
var $9e95373159f60f1e$export$19f58225ac52a306 = "rgba(9, 30, 66, 0.82)";
var $9e95373159f60f1e$export$6384f09da70e7b62 = "rgba(9, 30, 66, 0.89)";
var $9e95373159f60f1e$export$d0dccc730683edc2 = "rgba(9, 30, 66, 0.95)";
var $9e95373159f60f1e$export$2f6319cf7d736c2a = "#E6EDFA";
var $9e95373159f60f1e$export$95126bc8884d6634 = "#DCE5F5";
var $9e95373159f60f1e$export$8338d8c35d44ff1 = "#CED9EB";
var $9e95373159f60f1e$export$5368d76ae4fbbda7 = "#B8C7E0";
var $9e95373159f60f1e$export$9f0a771d16ec8d36 = "#ABBBD6";
var $9e95373159f60f1e$export$abcf8c38338b4aa5 = "#9FB0CC";
var $9e95373159f60f1e$export$97e81faa16a182c7 = "#8C9CB8";
var $9e95373159f60f1e$export$bfe21c59123ecf33 = "#7988A3";
var $9e95373159f60f1e$export$ee82aa2ea6a1558 = "#67758F";
var $9e95373159f60f1e$export$682927c6ed76be02 = "#56637A";
var $9e95373159f60f1e$export$91fd9994c5be9757 = "#455166";
var $9e95373159f60f1e$export$d281fbfe3cff2df6 = "#3B475C";
var $9e95373159f60f1e$export$3902c91d8b98a753 = "#313D52";
var $9e95373159f60f1e$export$8e8133c1ba5845b5 = "#283447";
var $9e95373159f60f1e$export$33ff357f6620b39 = "#202B3D";
var $9e95373159f60f1e$export$633847cf062b69e0 = "#1B2638";
var $9e95373159f60f1e$export$9776a6e503bdbf76 = "#121A29";
var $9e95373159f60f1e$export$6c813d5160dff5db = "#0E1624";
var $9e95373159f60f1e$export$3d4f271a500072a = "#0D1424";
var $9e95373159f60f1e$export$fe151285c22759ec = "rgba(13, 20, 36, 0.06)";
var $9e95373159f60f1e$export$a101c6190d0da34 = "rgba(13, 20, 36, 0.14)";
var $9e95373159f60f1e$export$4b16f52932fda51 = "rgba(13, 20, 36, 0.18)";
var $9e95373159f60f1e$export$a74bcd7b9845b0d8 = "rgba(13, 20, 36, 0.29)";
var $9e95373159f60f1e$export$9209c179316d1751 = "rgba(13, 20, 36, 0.36)";
var $9e95373159f60f1e$export$88f55133f636c8dd = "rgba(13, 20, 36, 0.40)";
var $9e95373159f60f1e$export$51126f85d1009512 = "rgba(13, 20, 36, 0.47)";
var $9e95373159f60f1e$export$a069b547bd23af78 = "rgba(13, 20, 36, 0.53)";
var $9e95373159f60f1e$export$40cce05af3b2600a = "rgba(13, 20, 36, 0.63)";
var $9e95373159f60f1e$export$b78942185925a0d = "rgba(13, 20, 36, 0.73)";
var $9e95373159f60f1e$export$e058fb44b8eaafca = "rgba(13, 20, 36, 0.78)";
var $9e95373159f60f1e$export$92b0b8de26920c18 = "rgba(13, 20, 36, 0.81)";
var $9e95373159f60f1e$export$67564f7459d3fc9e = "rgba(13, 20, 36, 0.85)";
var $9e95373159f60f1e$export$77868e1ca884ffa3 = "rgba(13, 20, 36, 0.89)";
var $9e95373159f60f1e$export$2afd71d7d3ea2cd5 = "rgba(13, 20, 36, 0.92)";
var $9e95373159f60f1e$export$f2a0acaab9972c70 = "rgba(13, 20, 36, 0.95)";
var $9e95373159f60f1e$export$9ab70e67d6475361 = "rgba(13, 20, 36, 0.97)";
var $9e95373159f60f1e$export$8ce1fd94bee2f412 = (0, $apn14.default)({
    light: "var(--ds-surface, ".concat($9e95373159f60f1e$export$29a4f05edc054374, ")"),
    dark: "var(--ds-surface, ".concat($9e95373159f60f1e$export$633847cf062b69e0, ")")
});
var $9e95373159f60f1e$export$b861914ea877b580 = (0, $apn14.default)({
    light: "var(--ds-background-selected, ".concat($9e95373159f60f1e$export$226de0355ed012f8, ")"),
    dark: "var(--ds-background-selected, ".concat($9e95373159f60f1e$export$8c13c2ee36917869, ")")
});
var $9e95373159f60f1e$export$3f1b020df94387af = (0, $apn14.default)({
    light: "var(--ds-background-neutral-hovered, ".concat($9e95373159f60f1e$export$3e51e8f1440314ba, ")"),
    dark: "var(--ds-background-neutral-hovered, ".concat($9e95373159f60f1e$export$d281fbfe3cff2df6, ")")
});
var $9e95373159f60f1e$export$c0183dbab98ca63e = (0, $apn14.default)({
    light: "var(--ds-surface-overlay, ".concat($9e95373159f60f1e$export$29a4f05edc054374, ")"),
    dark: "var(--ds-surface-overlay, ".concat($9e95373159f60f1e$export$8e8133c1ba5845b5, ")")
});
var $9e95373159f60f1e$export$6f093cfa640b7166 = (0, $apn14.default)({
    light: "var(--ds-text, ".concat($9e95373159f60f1e$export$fbda843f0a27fe96, ")"),
    dark: "var(--ds-text, ".concat($9e95373159f60f1e$export$5368d76ae4fbbda7, ")")
});
var $9e95373159f60f1e$export$42f8e9c698766e7a = (0, $apn14.default)({
    light: "var(--ds-text, ".concat($9e95373159f60f1e$export$7d61b15e0da132af, ")"),
    dark: "var(--ds-text, ".concat($9e95373159f60f1e$export$5368d76ae4fbbda7, ")")
});
var $9e95373159f60f1e$export$c2d157ca1c34b6e3 = (0, $apn14.default)({
    light: "var(--ds-text-selected, ".concat($9e95373159f60f1e$export$b3de0ae08da2ce64, ")"),
    dark: "var(--ds-text-selected, ".concat($9e95373159f60f1e$export$b3de0ae08da2ce64, ")")
});
var $9e95373159f60f1e$export$1905ba28d7cf066f = (0, $apn14.default)({
    light: "var(--ds-text-subtlest, ".concat($9e95373159f60f1e$export$f563ee71e9ee74cd, ")"),
    dark: "var(--ds-text-subtlest, ".concat($9e95373159f60f1e$export$97e81faa16a182c7, ")")
});
var $9e95373159f60f1e$export$bd9002130d306d39 = (0, $apn14.default)({
    light: "var(--ds-text-subtlest, ".concat($9e95373159f60f1e$export$f563ee71e9ee74cd, ")"),
    dark: "var(--ds-text-subtlest, ".concat($9e95373159f60f1e$export$bfe21c59123ecf33, ")")
});
var $9e95373159f60f1e$export$46e4a324ac90507f = (0, $apn14.default)({
    light: "var(--ds-text, ".concat($9e95373159f60f1e$export$7d61b15e0da132af, ")"),
    dark: "var(--ds-text, ".concat($9e95373159f60f1e$export$5368d76ae4fbbda7, ")")
});
var $9e95373159f60f1e$export$79f3f2b82beb0d36 = (0, $apn14.default)({
    light: "var(--ds-text-subtlest, ".concat($9e95373159f60f1e$export$f563ee71e9ee74cd, ")"),
    dark: "var(--ds-text-subtlest, ".concat($9e95373159f60f1e$export$97e81faa16a182c7, ")")
});
var $9e95373159f60f1e$export$7bb0d5c671655cc4 = (0, $apn14.default)({
    light: $9e95373159f60f1e$export$9fdfb749e33cdf97,
    dark: $9e95373159f60f1e$export$8e8133c1ba5845b5
});
var $9e95373159f60f1e$export$9c30223ca0a664fb = (0, $apn14.default)({
    light: "var(--ds-link, ".concat($9e95373159f60f1e$export$b3de0ae08da2ce64, ")"),
    dark: "var(--ds-link, ".concat($9e95373159f60f1e$export$ecfc1dff386a3e7a, ")")
});
var $9e95373159f60f1e$export$7ed258b0728b004b = (0, $apn14.default)({
    light: "var(--ds-link-pressed, ".concat($9e95373159f60f1e$export$e62e8919cca44969, ")"),
    dark: "var(--ds-link-pressed, ".concat($9e95373159f60f1e$export$215b7063051591f1, ")")
});
var $9e95373159f60f1e$export$dfa920d8decc8a59 = (0, $apn14.default)({
    light: "var(--ds-link-pressed, ".concat($9e95373159f60f1e$export$a6ee3d71bc067634, ")"),
    dark: "var(--ds-link-pressed, ".concat($9e95373159f60f1e$export$ecfc1dff386a3e7a, ")")
});
var $9e95373159f60f1e$export$6069e6ad5c78f632 = (0, $apn14.default)({
    light: "var(--ds-border-focused, ".concat($9e95373159f60f1e$export$215b7063051591f1, ")"),
    dark: "var(--ds-border-focused, ".concat($9e95373159f60f1e$export$215b7063051591f1, ")")
});
var $9e95373159f60f1e$export$9ad721cf3b3debe0 = (0, $apn14.default)({
    light: "var(--ds-background-brand-bold, ".concat($9e95373159f60f1e$export$b3de0ae08da2ce64, ")"),
    dark: "var(--ds-background-brand-bold, ".concat($9e95373159f60f1e$export$ecfc1dff386a3e7a, ")")
});
var $9e95373159f60f1e$export$2aa0182783e7e9de = (0, $apn14.default)({
    light: $9e95373159f60f1e$export$b3de0ae08da2ce64,
    dark: $9e95373159f60f1e$export$ecfc1dff386a3e7a
});
var $9e95373159f60f1e$export$8bf7dff220b82b4a = (0, $apn14.default)({
    light: $9e95373159f60f1e$export$9dc1ef0f3f48059b,
    dark: $9e95373159f60f1e$export$69cb3ca10c1e330e
});
var $9e95373159f60f1e$export$e13cce2a2d16a9d4 = (0, $apn14.default)({
    light: $9e95373159f60f1e$export$b48405b95304b5a1,
    dark: $9e95373159f60f1e$export$6011520a64d9a187
});
var $9e95373159f60f1e$export$a90204d1394caf30 = (0, $apn14.default)({
    light: $9e95373159f60f1e$export$4a7404f376229999,
    dark: $9e95373159f60f1e$export$4a7404f376229999
});
var $9e95373159f60f1e$export$594c5a8758200c32 = (0, $apn14.default)({
    light: $9e95373159f60f1e$export$c6930421db9fa514,
    dark: $9e95373159f60f1e$export$c6930421db9fa514
});
var $9e95373159f60f1e$export$955a2ebd2fb142ae = (0, $apn14.default)({
    light: $9e95373159f60f1e$export$940e1f69e873f202,
    dark: $9e95373159f60f1e$export$940e1f69e873f202
});
var $9e95373159f60f1e$export$2a0674ff2eb10214 = function skeleton() {
    return "var(--ds-skeleton, ".concat($9e95373159f60f1e$export$8d43898f60b96a82, ")");
};

});
parcelRegister("apn14", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $793e17becf7ee14f$export$2e2bcd8739ae039; });
/* eslint-disable prefer-rest-params */ 
var $2Dpqx = parcelRequire("2Dpqx");
// Unpack custom variants, and get correct value for the current theme
function $793e17becf7ee14f$var$themedVariants(variantProp, variants) {
    return function(props) {
        var theme = (0, $2Dpqx.default)(props);
        if (props && props[variantProp] && variants) {
            var modes = variants[props[variantProp]];
            if (modes && modes[theme.mode]) {
                var value = modes[theme.mode];
                if (value) return value;
                 // TS believes value can be undefined
            }
        }
        return "";
    };
}
function $793e17becf7ee14f$export$2e2bcd8739ae039(modesOrVariant, variantModes) {
    if (typeof modesOrVariant === "string") return $793e17becf7ee14f$var$themedVariants(modesOrVariant, variantModes);
    var modes = modesOrVariant;
    return function(props) {
        // Get theme from the user's props
        var theme = (0, $2Dpqx.default)(props);
        // User isn't required to provide both light and dark values
        if (theme.mode in modes) {
            var value = modes[theme.mode]; // TS believes value can be undefined
            if (value) return value;
        }
        return "";
    };
}

});
parcelRegister("2Dpqx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1eb2f28b682b5a49$export$2e2bcd8739ae039; });

var $b8nNN = parcelRequire("b8nNN");
function $1eb2f28b682b5a49$export$2e2bcd8739ae039(props) {
    if (props && props.theme) {
        // Theme is the global Atlaskit theme
        if ((0, $b8nNN.CHANNEL) in props.theme) return props.theme[0, $b8nNN.CHANNEL];
        else if ("mode" in props.theme && (0, $b8nNN.THEME_MODES).includes(props.theme.mode)) return props.theme;
    }
    // If format not supported (or no theme provided), return standard theme
    return {
        mode: (0, $b8nNN.DEFAULT_THEME_MODE)
    };
}

});
parcelRegister("b8nNN", function(module, exports) {

$parcel$export(module.exports, "CHANNEL", function () { return $81b2e7b23c32870c$export$44ffba16bd48dac6; });
$parcel$export(module.exports, "DEFAULT_THEME_MODE", function () { return $81b2e7b23c32870c$export$c93026a968943f95; });
$parcel$export(module.exports, "THEME_MODES", function () { return $81b2e7b23c32870c$export$6ba72c8346b4c57e; });

var $e2xkU = parcelRequire("e2xkU");

var $dC8eV = parcelRequire("dC8eV");
var $81b2e7b23c32870c$export$44ffba16bd48dac6 = "__ATLASKIT_THEME__";
var $81b2e7b23c32870c$export$c93026a968943f95 = "light";
var $81b2e7b23c32870c$export$6ba72c8346b4c57e = [
    "light",
    "dark"
];
var $81b2e7b23c32870c$export$7a57f79000377ca2 = function borderRadius() {
    return 3;
};
var $81b2e7b23c32870c$export$6d8204c2cb2e06b8 = function gridSize() {
    return 8;
};
var $81b2e7b23c32870c$export$85e3c3ca0c6fb93 = function fontSize() {
    return 14;
};
var $81b2e7b23c32870c$export$6746fe0d9c9fab54 = function fontSizeSmall() {
    return 11;
};
var $81b2e7b23c32870c$export$a5975749f0374264 = function fontFamily() {
    return "-apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif";
};
var $81b2e7b23c32870c$export$356129969ee49c55 = function codeFontFamily() {
    return "'SFMono-Medium', 'SF Mono', 'Segoe UI Mono', 'Roboto Mono', 'Ubuntu Mono', Menlo, Consolas, Courier, monospace";
};
var $81b2e7b23c32870c$export$8e24544ddba725ee = function focusRing() {
    var color = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "var(--ds-border-focused, ".concat((0, $dC8eV.B200), ")");
    var outlineWidth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $81b2e7b23c32870c$export$6d8204c2cb2e06b8() / 4;
    (0, $e2xkU.default)("@atlaskit/theme", "focus ring mixin", "Please use `@atlaskit/focus-ring` instead.");
    return "\n  &:focus {\n    outline: none;\n    box-shadow: 0px 0px 0px ".concat(outlineWidth, "px ").concat(color, ";\n  }\n");
};
var $81b2e7b23c32870c$export$c0dd343266bc3261 = function noFocusRing() {
    return "\n  box-shadow: none;\n";
};
var $81b2e7b23c32870c$export$7be255094ccdc533 = {
    card: function card() {
        return 100;
    },
    navigation: function navigation() {
        return 200;
    },
    dialog: function dialog() {
        return 300;
    },
    layer: function layer() {
        return 400;
    },
    blanket: function blanket() {
        return 500;
    },
    modal: function modal() {
        return 510;
    },
    flag: function flag() {
        return 600;
    },
    spotlight: function spotlight() {
        return 700;
    },
    tooltip: function tooltip() {
        return 9999;
    }
};
var $81b2e7b23c32870c$export$a1b3edb637fb4f35 = function visuallyHidden() {
    (0, $e2xkU.default)("@atlaskit/theme", "visually hidden mixin", "Please use `@atlaskit/visually-hidden` instead.");
    return {
        border: "0 !important",
        clip: "rect(1px, 1px, 1px, 1px) !important",
        height: "1px !important",
        overflow: "hidden !important",
        padding: "0 !important",
        position: "absolute !important",
        width: "1px !important",
        whiteSpace: "nowrap !important"
    };
};
var $81b2e7b23c32870c$export$ba1d834b86d72a09 = $81b2e7b23c32870c$export$a1b3edb637fb4f35;
var $81b2e7b23c32870c$export$e497e856b4f89fcd = function skeletonShimmer() {
    return {
        css: {
            backgroundColor: "var(--ds-skeleton, ".concat((0, $dC8eV.skeleton)(), ")"),
            animationDuration: "1.5s",
            animationIterationCount: "infinite",
            animationTimingFunction: "linear",
            animationDirection: "alternate"
        },
        keyframes: {
            from: {
                backgroundColor: "var(--ds-skeleton, ".concat((0, $dC8eV.skeleton)(), ")")
            },
            to: {
                backgroundColor: "var(--ds-skeleton-subtle, ".concat((0, $dC8eV.N30A), ")")
            }
        }
    };
};

});




parcelRegister("dzFGL", function(module, exports) {

$parcel$export(module.exports, "getBooleanFF", function () { return $9e1ee1c641183e39$export$470e5c2be1411c89; });

var $ex8Vx = parcelRequire("ex8Vx");
function $9e1ee1c641183e39$export$ba05d765b8392e5e(flagResolver) {
    (0, $ex8Vx.setBooleanResolver)(flagResolver);
}
function $9e1ee1c641183e39$export$470e5c2be1411c89(name) {
    return (0, $ex8Vx.resolveBooleanFlag)(name);
}
function $9e1ee1c641183e39$export$b40ec24ac8275656(name) {
    return (0, $ex8Vx.resolveBooleanFlag)(name);
}

});
parcelRegister("ex8Vx", function(module, exports) {

$parcel$export(module.exports, "setBooleanResolver", function () { return $a94b127c1d581bdf$export$f2b591175b3e424c; });
$parcel$export(module.exports, "resolveBooleanFlag", function () { return $a94b127c1d581bdf$export$6333b6aff9fc6275; });

var $8SHiu = parcelRequire("8SHiu");

var $ahJoN = parcelRequire("ahJoN");
var $a94b127c1d581bdf$var$pkgName = "@atlaskit/platform-feature-flags";
var $a94b127c1d581bdf$export$7e41b1b2bdee3f98 = "__PLATFORM_FEATURE_FLAGS__";
var $a94b127c1d581bdf$var$hasProcessEnv = typeof $ahJoN !== "undefined" && typeof $ahJoN.env !== "undefined";
// FF global overrides can be configured by test runners or Storybook
var $a94b127c1d581bdf$var$ENV_ENABLE_PLATFORM_FF = $a94b127c1d581bdf$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
// STORYBOOK_ENABLE_PLATFORM_FF is included as storybook only allows env vars prefixed with STORYBOOK
// https://github.com/storybookjs/storybook/issues/12270
var $a94b127c1d581bdf$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF = $a94b127c1d581bdf$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
var $a94b127c1d581bdf$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE = $a94b127c1d581bdf$var$ENV_ENABLE_PLATFORM_FF || $a94b127c1d581bdf$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF;
var $a94b127c1d581bdf$var$DEFAULT_PFF_GLOBAL = {
    // In development mode we want to capture any feature flag checks that happen using the default resolver and log this result when the resolver is replaced.
    // This is because evaluating feature flags when the resolver/FF client is loaded asynchronously could cause unexpected issues.
    earlyResolvedFlags: new Map(),
    booleanResolver: function booleanResolver(flagKey) {
        var unresolvedFlagCount;
        return false;
    }
};
var $a94b127c1d581bdf$var$globalVar = typeof window !== "undefined" ? window : globalThis;
$a94b127c1d581bdf$var$globalVar[$a94b127c1d581bdf$export$7e41b1b2bdee3f98] = $a94b127c1d581bdf$var$globalVar[$a94b127c1d581bdf$export$7e41b1b2bdee3f98] || $a94b127c1d581bdf$var$DEFAULT_PFF_GLOBAL;
function $a94b127c1d581bdf$export$f2b591175b3e424c(resolver) {
    $a94b127c1d581bdf$var$globalVar[$a94b127c1d581bdf$export$7e41b1b2bdee3f98].booleanResolver = resolver;
    var _globalVar$PFF_GLOBAL;
}
function $a94b127c1d581bdf$export$6333b6aff9fc6275(flagKey) {
    if ($a94b127c1d581bdf$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE) {
        (0, $8SHiu.debug)('[%s]: The feature flags were enabled while running tests. The flag "%s" will be always enabled.', $a94b127c1d581bdf$var$pkgName, flagKey);
        return true;
    }
    try {
        var _globalVar$PFF_GLOBAL2;
        var result = (_globalVar$PFF_GLOBAL2 = $a94b127c1d581bdf$var$globalVar[$a94b127c1d581bdf$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL2 === void 0 ? void 0 : _globalVar$PFF_GLOBAL2.booleanResolver(flagKey);
        if (typeof result !== "boolean") {
            // eslint-disable-next-line no-console
            console.warn("".concat(flagKey, " resolved to a non-boolean value, returning false for safety"));
            return false;
        }
        return result;
    } catch (e) {
        return false;
    }
}

});
parcelRegister("8SHiu", function(module, exports) {

$parcel$export(module.exports, "debug", function () { return $6774f3c6f24855f5$export$1c9f709888824e05; });
var $6774f3c6f24855f5$var$_ref, $6774f3c6f24855f5$var$_process, $6774f3c6f24855f5$var$_process2;
// We can't rely on NODE_ENV === 'test' if its value is already configured by the consumer to some other value, so better to use JEST_WORKER_ID
// https://jestjs.io/docs/environment-variables#jest_worker_id
var $6774f3c6f24855f5$var$TESTS_MODE = ($6774f3c6f24855f5$var$_ref = (globalThis === null || globalThis === void 0 || ($6774f3c6f24855f5$var$_process = globalThis.process) === null || $6774f3c6f24855f5$var$_process === void 0 || ($6774f3c6f24855f5$var$_process = $6774f3c6f24855f5$var$_process.env) === null || $6774f3c6f24855f5$var$_process === void 0 ? void 0 : $6774f3c6f24855f5$var$_process.JEST_WORKER_ID) !== undefined, $6774f3c6f24855f5$var$_ref !== void 0) ? $6774f3c6f24855f5$var$_ref : false;
var $6774f3c6f24855f5$var$DEBUG_MODE = !$6774f3c6f24855f5$var$TESTS_MODE && (globalThis === null || globalThis === void 0 || ($6774f3c6f24855f5$var$_process2 = globalThis.process) === null || $6774f3c6f24855f5$var$_process2 === void 0 || ($6774f3c6f24855f5$var$_process2 = $6774f3c6f24855f5$var$_process2.env) === null || $6774f3c6f24855f5$var$_process2 === void 0 ? void 0 : $6774f3c6f24855f5$var$_process2.NODE_ENV) !== "production";
var $6774f3c6f24855f5$export$1c9f709888824e05 = function debug() {
    var _console;
    if (!$6774f3c6f24855f5$var$DEBUG_MODE) return;
    // eslint-disable-next-line no-console
    (_console = console).debug.apply(_console, arguments);
};

});




parcelRegister("6aJAL", function(module, exports) {

$parcel$export(module.exports, "onFocus", function () { return $47e70ae3aa50a04e$export$ecf9bf35ad97eb74; });
$parcel$export(module.exports, "isOptionsGrouped", function () { return $47e70ae3aa50a04e$export$d2756249f53f9f8; });
// Used for overwriting ariaLiveMessages builtin onFocus method.
// Returns custom built string while focusing each group option. This string is used for screen reader announcement.
function $47e70ae3aa50a04e$export$ecf9bf35ad97eb74(props) {
    var _groupData$options$fi;
    var focused = props.focused, options = props.options;
    var isOptionFocused = function isOptionFocused(option) {
        return option === focused;
    };
    var groupData = options === null || options === void 0 ? void 0 : options.find(function(option) {
        var _option$options;
        return (_option$options = option.options) === null || _option$options === void 0 ? void 0 : _option$options.some(isOptionFocused);
    });
    var groupOptionIndex = (_groupData$options$fi = groupData === null || groupData === void 0 ? void 0 : groupData.options.findIndex(isOptionFocused)) !== null && _groupData$options$fi !== void 0 ? _groupData$options$fi : 0;
    return "Option ".concat(focused.label, ", ").concat(groupData === null || groupData === void 0 ? void 0 : groupData.label, " group, item ").concat(groupOptionIndex + 1, " out of ").concat(groupData === null || groupData === void 0 ? void 0 : groupData.options.length, ". All in all ");
}
var $47e70ae3aa50a04e$export$d2756249f53f9f8 = function isOptionsGrouped(arr) {
    return arr === null || arr === void 0 ? void 0 : arr.every(function(obj) {
        return obj.hasOwnProperty("options");
    });
};

});



parcelRegister("lU1oo", function(module, exports) {

$parcel$export(module.exports, "LoadingPlaceHolder", function () { return (parcelRequire("2pRqv")).LoadingPlaceHolder; });

var $2pRqv = parcelRequire("2pRqv");

});
parcelRegister("2pRqv", function(module, exports) {

$parcel$export(module.exports, "LoadingPlaceHolder", function () { return $c091d9d41b01e22f$export$cfda1c0d43c93ee0; });

var $ku6eE = parcelRequire("ku6eE");

var $jVTBW = parcelRequire("jVTBW");

var $5MUVm = parcelRequire("5MUVm");

var $gbKg7 = parcelRequire("gbKg7");
const $c091d9d41b01e22f$var$loadingPlaceholder = (0, $jVTBW.keyframes)`
  from {
    background-position: -360px 0
  }

  to {
    background-position: 100% 0
  }
`;
const $c091d9d41b01e22f$export$cfda1c0d43c93ee0 = (0, $ku6eE.default).div`
  height: ${(0, $gbKg7.default)("space.500", "40px")};
  width: 100%;
  background-color: ${(0, $gbKg7.default)("color.background.accent.gray.subtlest", (0, $5MUVm).N10)};
  background: linear-gradient(
    to right,
    ${(0, $gbKg7.default)("color.background.accent.gray.subtlest", (0, $5MUVm).N20)} 8%,
    ${(0, $gbKg7.default)("color.background.accent.gray.subtler", (0, $5MUVm).N30)} 18%,
    ${(0, $gbKg7.default)("color.background.accent.gray.subtlest", (0, $5MUVm).N20)} 33%
  );
  animation: ${$c091d9d41b01e22f$var$loadingPlaceholder} 2s forwards linear infinite;
`;

});


parcelRegister("ak3Un", function(module, exports) {

$parcel$export(module.exports, "ManageProfileUserQueryKey", function () { return $942f46c371ca3ba4$export$4695519067b93cbb; });
$parcel$export(module.exports, "useManageProfileUser", function () { return $942f46c371ca3ba4$export$de7cf2ec3f9cba72; });

var $4MHck = parcelRequire("4MHck");

var $iDL5l = parcelRequire("iDL5l");

var $5Tbmh = parcelRequire("5Tbmh");
parcelRequire("jShba");
var $1Bj4T = parcelRequire("1Bj4T");
const $942f46c371ca3ba4$export$4695519067b93cbb = "ManageProfileUser";
const $942f46c371ca3ba4$var$manageProfileUserQueryFn = async ({ userId: userId, stargateRoot: stargateRoot })=>{
    const url = `${stargateRoot}/users/${userId}/manage/profile`;
    const response = await (0, $iDL5l.fetchApi)(url);
    const data = await response.json();
    return (0, $5Tbmh.fromManageAPIResponse)(data);
};
const $942f46c371ca3ba4$export$de7cf2ec3f9cba72 = (userId)=>{
    const { stargateRoot: stargateRoot } = (0, $1Bj4T.getConfig)();
    const { data: data, isLoading: isLoading, isError: isError, error: error } = (0, $4MHck.useQuery)({
        queryKey: [
            $942f46c371ca3ba4$export$4695519067b93cbb,
            userId
        ],
        queryFn: ()=>$942f46c371ca3ba4$var$manageProfileUserQueryFn({
                userId: userId,
                stargateRoot: stargateRoot
            }),
        enabled: !!userId
    });
    return {
        user: data,
        isLoading: isLoading,
        isError: isError,
        error: error
    };
};

});
parcelRegister("5Tbmh", function(module, exports) {

$parcel$export(module.exports, "fromManageAPIResponse", function () { return $75480b14224cf397$export$5299664357e4f3dd; });
$parcel$export(module.exports, "toManageAPIInput", function () { return $75480b14224cf397$export$7b103107c889cb67; });

var $fFs19 = parcelRequire("fFs19");
const $75480b14224cf397$var$timeZones = new Set((0, (/*@__PURE__*/$parcel$interopDefault($fFs19))).tz.names());
// Key (left-side) is field name which is used in our app.
// Value (right-side) is field name which is used by data in services
const $75480b14224cf397$var$PROFILE_PROPS_MAP = {
    id: "account_id",
    fullName: "name",
    nickname: "nickname",
    timezone: "zoneinfo",
    locale: "locale",
    avatarUrl: "picture",
    email: "email"
};
// Key (left-side) is field name which is used in our app.
// Value (right-side) is field name which is used by data in services
const $75480b14224cf397$var$EXTENDED_PROFILE_PROPS_MAP = {
    title: "job_title",
    department: "department",
    companyName: "organization",
    location: "location",
    phoneNumber: "phone_number"
};
const $75480b14224cf397$export$5299664357e4f3dd = (res)=>{
    const data = res.account;
    const extendedData = data && data.extended_profile || {};
    if (!data) return null;
    const timeZone = data.zoneinfo;
    const localTime = ({ locale: locale, format: format })=>{
        if (!timeZone || !$75480b14224cf397$var$timeZones.has(timeZone)) return undefined;
        return (0, (/*@__PURE__*/$parcel$interopDefault($fFs19)))(new Date()).locale(locale).tz(timeZone).format(format);
    };
    const profile = Object.entries($75480b14224cf397$var$PROFILE_PROPS_MAP).reduce((acc, [internalFieldName, apiFieldName])=>{
        acc[internalFieldName] = data[apiFieldName];
        return acc;
    }, {});
    const extendedProfile = Object.entries($75480b14224cf397$var$EXTENDED_PROFILE_PROPS_MAP).reduce((acc, [internalFieldName, apiFieldName])=>{
        acc[internalFieldName] = extendedData[apiFieldName];
        return acc;
    }, {});
    const result = {
        ...profile,
        ...extendedProfile,
        id: data.account_id,
        localTime: localTime,
        remoteWeekdayIndex: localTime({
            format: "d",
            locale: data.locale
        }),
        remoteWeekdayString: localTime({
            format: "ddd",
            locale: data.locale
        }),
        remoteTimeString: localTime({
            format: "h:mma ([GMT]Z)",
            locale: data.locale
        })
    };
    return result;
};
const $75480b14224cf397$export$7b103107c889cb67 = (input)=>{
    const output = {
        extended_profile: {}
    };
    Object.keys(input).forEach((key)=>{
        if ($75480b14224cf397$var$PROFILE_PROPS_MAP[key]) output[$75480b14224cf397$var$PROFILE_PROPS_MAP[key]] = input[key];
        if ($75480b14224cf397$var$EXTENDED_PROFILE_PROPS_MAP[key]) output.extended_profile[$75480b14224cf397$var$EXTENDED_PROFILE_PROPS_MAP[key]] = input[key];
    });
    return output;
};

});
parcelRegister("fFs19", function(module, exports) {

//! moment-timezone.js
//! version : 0.5.45
//! Copyright (c) JS Foundation and other contributors
//! license : MIT
//! github.com/moment/moment-timezone
(function(root, factory) {
    "use strict";
    /*global define*/ if (0, module.exports) module.exports = factory((parcelRequire("gH4MD"))); // Node
    else if (typeof define === "function" && define.amd) define([
        "moment"
    ], factory); // AMD
    else factory(root.moment); // Browser
})(module.exports, function(moment) {
    "use strict";
    // Resolves es6 module loading issue
    if (moment.version === undefined && moment.default) moment = moment.default;
    // Do not load moment-timezone a second time.
    // if (moment.tz !== undefined) {
    // 	logError('Moment Timezone ' + moment.tz.version + ' was already loaded ' + (moment.tz.dataVersion ? 'with data from ' : 'without any data') + moment.tz.dataVersion);
    // 	return moment;
    // }
    var VERSION = "0.5.45", zones = {}, links = {}, countries = {}, names = {}, guesses = {}, cachedGuess;
    if (!moment || typeof moment.version !== "string") logError("Moment Timezone requires Moment.js. See https://momentjs.com/timezone/docs/#/use-it/browser/");
    var momentVersion = moment.version.split("."), major = +momentVersion[0], minor = +momentVersion[1];
    // Moment.js version check
    if (major < 2 || major === 2 && minor < 6) logError("Moment Timezone requires Moment.js >= 2.6.0. You are using Moment.js " + moment.version + ". See momentjs.com");
    /************************************
		Unpacking
	************************************/ function charCodeToInt(charCode) {
        if (charCode > 96) return charCode - 87;
        else if (charCode > 64) return charCode - 29;
        return charCode - 48;
    }
    function unpackBase60(string) {
        var i = 0, parts = string.split("."), whole = parts[0], fractional = parts[1] || "", multiplier = 1, num, out = 0, sign = 1;
        // handle negative numbers
        if (string.charCodeAt(0) === 45) {
            i = 1;
            sign = -1;
        }
        // handle digits before the decimal
        for(i; i < whole.length; i++){
            num = charCodeToInt(whole.charCodeAt(i));
            out = 60 * out + num;
        }
        // handle digits after the decimal
        for(i = 0; i < fractional.length; i++){
            multiplier = multiplier / 60;
            num = charCodeToInt(fractional.charCodeAt(i));
            out += num * multiplier;
        }
        return out * sign;
    }
    function arrayToInt(array) {
        for(var i = 0; i < array.length; i++)array[i] = unpackBase60(array[i]);
    }
    function intToUntil(array, length) {
        for(var i = 0; i < length; i++)array[i] = Math.round((array[i - 1] || 0) + array[i] * 60000); // minutes to milliseconds
        array[length - 1] = Infinity;
    }
    function mapIndices(source, indices) {
        var out = [], i;
        for(i = 0; i < indices.length; i++)out[i] = source[indices[i]];
        return out;
    }
    function unpack(string) {
        var data = string.split("|"), offsets = data[2].split(" "), indices = data[3].split(""), untils = data[4].split(" ");
        arrayToInt(offsets);
        arrayToInt(indices);
        arrayToInt(untils);
        intToUntil(untils, indices.length);
        return {
            name: data[0],
            abbrs: mapIndices(data[1].split(" "), indices),
            offsets: mapIndices(offsets, indices),
            untils: untils,
            population: data[5] | 0
        };
    }
    /************************************
		Zone object
	************************************/ function Zone(packedString) {
        if (packedString) this._set(unpack(packedString));
    }
    function closest(num, arr) {
        var len = arr.length;
        if (num < arr[0]) return 0;
        else if (len > 1 && arr[len - 1] === Infinity && num >= arr[len - 2]) return len - 1;
        else if (num >= arr[len - 1]) return -1;
        var mid;
        var lo = 0;
        var hi = len - 1;
        while(hi - lo > 1){
            mid = Math.floor((lo + hi) / 2);
            if (arr[mid] <= num) lo = mid;
            else hi = mid;
        }
        return hi;
    }
    Zone.prototype = {
        _set: function(unpacked) {
            this.name = unpacked.name;
            this.abbrs = unpacked.abbrs;
            this.untils = unpacked.untils;
            this.offsets = unpacked.offsets;
            this.population = unpacked.population;
        },
        _index: function(timestamp) {
            var target = +timestamp, untils = this.untils, i;
            i = closest(target, untils);
            if (i >= 0) return i;
        },
        countries: function() {
            var zone_name = this.name;
            return Object.keys(countries).filter(function(country_code) {
                return countries[country_code].zones.indexOf(zone_name) !== -1;
            });
        },
        parse: function(timestamp) {
            var target = +timestamp, offsets = this.offsets, untils = this.untils, max = untils.length - 1, offset, offsetNext, offsetPrev, i;
            for(i = 0; i < max; i++){
                offset = offsets[i];
                offsetNext = offsets[i + 1];
                offsetPrev = offsets[i ? i - 1 : i];
                if (offset < offsetNext && tz.moveAmbiguousForward) offset = offsetNext;
                else if (offset > offsetPrev && tz.moveInvalidForward) offset = offsetPrev;
                if (target < untils[i] - offset * 60000) return offsets[i];
            }
            return offsets[max];
        },
        abbr: function(mom) {
            return this.abbrs[this._index(mom)];
        },
        offset: function(mom) {
            logError("zone.offset has been deprecated in favor of zone.utcOffset");
            return this.offsets[this._index(mom)];
        },
        utcOffset: function(mom) {
            return this.offsets[this._index(mom)];
        }
    };
    /************************************
		Country object
	************************************/ function Country(country_name, zone_names) {
        this.name = country_name;
        this.zones = zone_names;
    }
    /************************************
		Current Timezone
	************************************/ function OffsetAt(at) {
        var timeString = at.toTimeString();
        var abbr = timeString.match(/\([a-z ]+\)/i);
        if (abbr && abbr[0]) {
            // 17:56:31 GMT-0600 (CST)
            // 17:56:31 GMT-0600 (Central Standard Time)
            abbr = abbr[0].match(/[A-Z]/g);
            abbr = abbr ? abbr.join("") : undefined;
        } else {
            // 17:56:31 CST
            // 17:56:31 GMT+0800 (台北標準時間)
            abbr = timeString.match(/[A-Z]{3,5}/g);
            abbr = abbr ? abbr[0] : undefined;
        }
        if (abbr === "GMT") abbr = undefined;
        this.at = +at;
        this.abbr = abbr;
        this.offset = at.getTimezoneOffset();
    }
    function ZoneScore(zone) {
        this.zone = zone;
        this.offsetScore = 0;
        this.abbrScore = 0;
    }
    ZoneScore.prototype.scoreOffsetAt = function(offsetAt) {
        this.offsetScore += Math.abs(this.zone.utcOffset(offsetAt.at) - offsetAt.offset);
        if (this.zone.abbr(offsetAt.at).replace(/[^A-Z]/g, "") !== offsetAt.abbr) this.abbrScore++;
    };
    function findChange(low, high) {
        var mid, diff;
        while(diff = ((high.at - low.at) / 12e4 | 0) * 6e4){
            mid = new OffsetAt(new Date(low.at + diff));
            if (mid.offset === low.offset) low = mid;
            else high = mid;
        }
        return low;
    }
    function userOffsets() {
        var startYear = new Date().getFullYear() - 2, last = new OffsetAt(new Date(startYear, 0, 1)), lastOffset = last.offset, offsets = [
            last
        ], change, next, nextOffset, i;
        for(i = 1; i < 48; i++){
            nextOffset = new Date(startYear, i, 1).getTimezoneOffset();
            if (nextOffset !== lastOffset) {
                // Create OffsetAt here to avoid unnecessary abbr parsing before checking offsets
                next = new OffsetAt(new Date(startYear, i, 1));
                change = findChange(last, next);
                offsets.push(change);
                offsets.push(new OffsetAt(new Date(change.at + 6e4)));
                last = next;
                lastOffset = nextOffset;
            }
        }
        for(i = 0; i < 4; i++){
            offsets.push(new OffsetAt(new Date(startYear + i, 0, 1)));
            offsets.push(new OffsetAt(new Date(startYear + i, 6, 1)));
        }
        return offsets;
    }
    function sortZoneScores(a, b) {
        if (a.offsetScore !== b.offsetScore) return a.offsetScore - b.offsetScore;
        if (a.abbrScore !== b.abbrScore) return a.abbrScore - b.abbrScore;
        if (a.zone.population !== b.zone.population) return b.zone.population - a.zone.population;
        return b.zone.name.localeCompare(a.zone.name);
    }
    function addToGuesses(name, offsets) {
        var i, offset;
        arrayToInt(offsets);
        for(i = 0; i < offsets.length; i++){
            offset = offsets[i];
            guesses[offset] = guesses[offset] || {};
            guesses[offset][name] = true;
        }
    }
    function guessesForUserOffsets(offsets) {
        var offsetsLength = offsets.length, filteredGuesses = {}, out = [], checkedOffsets = {}, i, j, offset, guessesOffset;
        for(i = 0; i < offsetsLength; i++){
            offset = offsets[i].offset;
            if (checkedOffsets.hasOwnProperty(offset)) continue;
            guessesOffset = guesses[offset] || {};
            for(j in guessesOffset)if (guessesOffset.hasOwnProperty(j)) filteredGuesses[j] = true;
            checkedOffsets[offset] = true;
        }
        for(i in filteredGuesses)if (filteredGuesses.hasOwnProperty(i)) out.push(names[i]);
        return out;
    }
    function rebuildGuess() {
        // use Intl API when available and returning valid time zone
        try {
            var intlName = Intl.DateTimeFormat().resolvedOptions().timeZone;
            if (intlName && intlName.length > 3) {
                var name = names[normalizeName(intlName)];
                if (name) return name;
                logError("Moment Timezone found " + intlName + " from the Intl api, but did not have that data loaded.");
            }
        } catch (e) {
        // Intl unavailable, fall back to manual guessing.
        }
        var offsets = userOffsets(), offsetsLength = offsets.length, guesses = guessesForUserOffsets(offsets), zoneScores = [], zoneScore, i, j;
        for(i = 0; i < guesses.length; i++){
            zoneScore = new ZoneScore(getZone(guesses[i]), offsetsLength);
            for(j = 0; j < offsetsLength; j++)zoneScore.scoreOffsetAt(offsets[j]);
            zoneScores.push(zoneScore);
        }
        zoneScores.sort(sortZoneScores);
        return zoneScores.length > 0 ? zoneScores[0].zone.name : undefined;
    }
    function guess(ignoreCache) {
        if (!cachedGuess || ignoreCache) cachedGuess = rebuildGuess();
        return cachedGuess;
    }
    /************************************
		Global Methods
	************************************/ function normalizeName(name) {
        return (name || "").toLowerCase().replace(/\//g, "_");
    }
    function addZone(packed) {
        var i, name, split, normalized;
        if (typeof packed === "string") packed = [
            packed
        ];
        for(i = 0; i < packed.length; i++){
            split = packed[i].split("|");
            name = split[0];
            normalized = normalizeName(name);
            zones[normalized] = packed[i];
            names[normalized] = name;
            addToGuesses(normalized, split[2].split(" "));
        }
    }
    function getZone(name, caller) {
        name = normalizeName(name);
        var zone = zones[name];
        var link;
        if (zone instanceof Zone) return zone;
        if (typeof zone === "string") {
            zone = new Zone(zone);
            zones[name] = zone;
            return zone;
        }
        // Pass getZone to prevent recursion more than 1 level deep
        if (links[name] && caller !== getZone && (link = getZone(links[name], getZone))) {
            zone = zones[name] = new Zone();
            zone._set(link);
            zone.name = names[name];
            return zone;
        }
        return null;
    }
    function getNames() {
        var i, out = [];
        for(i in names)if (names.hasOwnProperty(i) && (zones[i] || zones[links[i]]) && names[i]) out.push(names[i]);
        return out.sort();
    }
    function getCountryNames() {
        return Object.keys(countries);
    }
    function addLink(aliases) {
        var i, alias, normal0, normal1;
        if (typeof aliases === "string") aliases = [
            aliases
        ];
        for(i = 0; i < aliases.length; i++){
            alias = aliases[i].split("|");
            normal0 = normalizeName(alias[0]);
            normal1 = normalizeName(alias[1]);
            links[normal0] = normal1;
            names[normal0] = alias[0];
            links[normal1] = normal0;
            names[normal1] = alias[1];
        }
    }
    function addCountries(data) {
        var i, country_code, country_zones, split;
        if (!data || !data.length) return;
        for(i = 0; i < data.length; i++){
            split = data[i].split("|");
            country_code = split[0].toUpperCase();
            country_zones = split[1].split(" ");
            countries[country_code] = new Country(country_code, country_zones);
        }
    }
    function getCountry(name) {
        name = name.toUpperCase();
        return countries[name] || null;
    }
    function zonesForCountry(country, with_offset) {
        country = getCountry(country);
        if (!country) return null;
        var zones = country.zones.sort();
        if (with_offset) return zones.map(function(zone_name) {
            var zone = getZone(zone_name);
            return {
                name: zone_name,
                offset: zone.utcOffset(new Date())
            };
        });
        return zones;
    }
    function loadData(data) {
        addZone(data.zones);
        addLink(data.links);
        addCountries(data.countries);
        tz.dataVersion = data.version;
    }
    function zoneExists(name) {
        if (!zoneExists.didShowError) {
            zoneExists.didShowError = true;
            logError("moment.tz.zoneExists('" + name + "') has been deprecated in favor of !moment.tz.zone('" + name + "')");
        }
        return !!getZone(name);
    }
    function needsOffset(m) {
        var isUnixTimestamp = m._f === "X" || m._f === "x";
        return !!(m._a && m._tzm === undefined && !isUnixTimestamp);
    }
    function logError(message) {
        if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
    }
    /************************************
		moment.tz namespace
	************************************/ function tz(input) {
        var args = Array.prototype.slice.call(arguments, 0, -1), name = arguments[arguments.length - 1], out = moment.utc.apply(null, args), zone;
        if (!moment.isMoment(input) && needsOffset(out) && (zone = getZone(name))) out.add(zone.parse(out), "minutes");
        out.tz(name);
        return out;
    }
    tz.version = VERSION;
    tz.dataVersion = "";
    tz._zones = zones;
    tz._links = links;
    tz._names = names;
    tz._countries = countries;
    tz.add = addZone;
    tz.link = addLink;
    tz.load = loadData;
    tz.zone = getZone;
    tz.zoneExists = zoneExists; // deprecated in 0.1.0
    tz.guess = guess;
    tz.names = getNames;
    tz.Zone = Zone;
    tz.unpack = unpack;
    tz.unpackBase60 = unpackBase60;
    tz.needsOffset = needsOffset;
    tz.moveInvalidForward = true;
    tz.moveAmbiguousForward = false;
    tz.countries = getCountryNames;
    tz.zonesForCountry = zonesForCountry;
    /************************************
		Interface with Moment.js
	************************************/ var fn = moment.fn;
    moment.tz = tz;
    moment.defaultZone = null;
    moment.updateOffset = function(mom, keepTime) {
        var zone = moment.defaultZone, offset;
        if (mom._z === undefined) {
            if (zone && needsOffset(mom) && !mom._isUTC && mom.isValid()) {
                mom._d = moment.utc(mom._a)._d;
                mom.utc().add(zone.parse(mom), "minutes");
            }
            mom._z = zone;
        }
        if (mom._z) {
            offset = mom._z.utcOffset(mom);
            if (Math.abs(offset) < 16) offset = offset / 60;
            if (mom.utcOffset !== undefined) {
                var z = mom._z;
                mom.utcOffset(-offset, keepTime);
                mom._z = z;
            } else mom.zone(offset, keepTime);
        }
    };
    fn.tz = function(name, keepTime) {
        if (name) {
            if (typeof name !== "string") throw new Error("Time zone name must be a string, got " + name + " [" + typeof name + "]");
            this._z = getZone(name);
            if (this._z) moment.updateOffset(this, keepTime);
            else logError("Moment Timezone has no data for " + name + ". See http://momentjs.com/timezone/docs/#/data-loading/.");
            return this;
        }
        if (this._z) return this._z.name;
    };
    function abbrWrap(old) {
        return function() {
            if (this._z) return this._z.abbr(this);
            return old.call(this);
        };
    }
    function resetZoneWrap(old) {
        return function() {
            this._z = null;
            return old.apply(this, arguments);
        };
    }
    function resetZoneWrap2(old) {
        return function() {
            if (arguments.length > 0) this._z = null;
            return old.apply(this, arguments);
        };
    }
    fn.zoneName = abbrWrap(fn.zoneName);
    fn.zoneAbbr = abbrWrap(fn.zoneAbbr);
    fn.utc = resetZoneWrap(fn.utc);
    fn.local = resetZoneWrap(fn.local);
    fn.utcOffset = resetZoneWrap2(fn.utcOffset);
    moment.tz.setDefault = function(name) {
        if (major < 2 || major === 2 && minor < 9) logError("Moment Timezone setDefault() requires Moment.js >= 2.9.0. You are using Moment.js " + moment.version + ".");
        moment.defaultZone = name ? getZone(name) : null;
        return moment;
    };
    // Cloning a moment should include the _z property.
    var momentProperties = moment.momentProperties;
    if (Object.prototype.toString.call(momentProperties) === "[object Array]") {
        // moment 2.8.1+
        momentProperties.push("_z");
        momentProperties.push("_a");
    } else if (momentProperties) // moment 2.7.0
    momentProperties._z = null;
    loadData({
        "version": "2024a",
        "zones": [
            "Africa/Abidjan|GMT|0|0||48e5",
            "Africa/Nairobi|EAT|-30|0||47e5",
            "Africa/Algiers|CET|-10|0||26e5",
            "Africa/Lagos|WAT|-10|0||17e6",
            "Africa/Maputo|CAT|-20|0||26e5",
            "Africa/Cairo|EET EEST|-20 -30|01010|1M2m0 gL0 e10 mn0|15e6",
            "Africa/Casablanca|+00 +01|0 -10|010101010101010101010101010101010101|1H3C0 wM0 co0 go0 1o00 s00 dA0 vc0 11A0 A00 e00 y00 11A0 uM0 e00 Dc0 11A0 s00 e00 IM0 WM0 mo0 gM0 LA0 WM0 jA0 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0|32e5",
            "Europe/Paris|CET CEST|-10 -20|01010101010101010101010|1GNB0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0|11e6",
            "Africa/Johannesburg|SAST|-20|0||84e5",
            "Africa/Juba|EAT CAT|-30 -20|01|24nx0|",
            "Africa/Khartoum|EAT CAT|-30 -20|01|1Usl0|51e5",
            "Africa/Sao_Tome|GMT WAT|0 -10|010|1UQN0 2q00|",
            "Africa/Tripoli|EET CET CEST|-20 -10 -20|0120|1IlA0 TA0 1o00|11e5",
            "Africa/Windhoek|CAT WAT|-20 -10|0101010101010|1GQo0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0|32e4",
            "America/Adak|HST HDT|a0 90|01010101010101010101010|1GIc0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0|326",
            "America/Anchorage|AKST AKDT|90 80|01010101010101010101010|1GIb0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0|30e4",
            "America/Santo_Domingo|AST|40|0||29e5",
            "America/Araguaina|-03 -02|30 20|010|1IdD0 Lz0|14e4",
            "America/Fortaleza|-03|30|0||34e5",
            "America/Asuncion|-03 -04|30 40|01010101010101010101010|1GTf0 1cN0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0|28e5",
            "America/Panama|EST|50|0||15e5",
            "America/Mexico_City|CST CDT|60 50|01010101010101010101010|1GQw0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0|20e6",
            "America/Bahia|-02 -03|20 30|01|1GCq0|27e5",
            "America/Managua|CST|60|0||22e5",
            "America/La_Paz|-04|40|0||19e5",
            "America/Lima|-05|50|0||11e6",
            "America/Denver|MST MDT|70 60|01010101010101010101010|1GI90 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0|26e5",
            "America/Campo_Grande|-03 -04|30 40|0101010101010101|1GCr0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1HB0 FX0|77e4",
            "America/Cancun|CST CDT EST|60 50 50|01010102|1GQw0 1nX0 14p0 1lb0 14p0 1lb0 Dd0|63e4",
            "America/Caracas|-0430 -04|4u 40|01|1QMT0|29e5",
            "America/Chicago|CST CDT|60 50|01010101010101010101010|1GI80 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0|92e5",
            "America/Chihuahua|MST MDT CST|70 60 60|01010101010101010101012|1GQx0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0|81e4",
            "America/Ciudad_Juarez|MST MDT CST|70 60 60|010101010101010101010120|1GI90 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1wn0 cm0|",
            "America/Phoenix|MST|70|0||42e5",
            "America/Whitehorse|PST PDT MST|80 70 70|0101010101010101012|1GIa0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1z90|23e3",
            "America/New_York|EST EDT|50 40|01010101010101010101010|1GI70 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0|21e6",
            "America/Rio_Branco|-04 -05|40 50|01|1KLE0|31e4",
            "America/Los_Angeles|PST PDT|80 70|01010101010101010101010|1GIa0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0|15e6",
            "America/Fort_Nelson|PST PDT MST|80 70 70|01010102|1GIa0 1zb0 Op0 1zb0 Op0 1zb0 Op0|39e2",
            "America/Halifax|AST ADT|40 30|01010101010101010101010|1GI60 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0|39e4",
            "America/Godthab|-03 -02|30 20|01010101010101010101010|1GNB0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0|17e3",
            "America/Grand_Turk|EST EDT AST|50 40 40|010101021010101010|1GI70 1zb0 Op0 1zb0 Op0 1zb0 Op0 7jA0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0|37e2",
            "America/Havana|CST CDT|50 40|01010101010101010101010|1GQt0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0|21e5",
            "America/Mazatlan|MST MDT|70 60|01010101010101010101010|1GQx0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0|44e4",
            "America/Metlakatla|PST AKST AKDT|80 90 80|01212120121212121|1PAa0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 uM0 jB0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0|14e2",
            "America/Miquelon|-03 -02|30 20|01010101010101010101010|1GI50 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0|61e2",
            "America/Montevideo|-02 -03|20 30|01010101|1GI40 1o10 11z0 1o10 11z0 1o10 11z0|17e5",
            "America/Noronha|-02|20|0||30e2",
            "America/Ojinaga|MST MDT CST|70 60 60|01010101010101010101012|1GI90 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1wn0|23e3",
            "America/Port-au-Prince|EST EDT|50 40|010101010101010101010|1GI70 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 3iN0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0|23e5",
            "Antarctica/Palmer|-03 -04|30 40|010101010|1H3D0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0|40",
            "America/Santiago|-03 -04|30 40|010101010101010101010|1H3D0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1zb0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0|62e5",
            "America/Sao_Paulo|-02 -03|20 30|0101010101010101|1GCq0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1HB0 FX0|20e6",
            "Atlantic/Azores|-01 +00|10 0|01010101010101010101010|1GNB0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0|25e4",
            "America/St_Johns|NST NDT|3u 2u|01010101010101010101010|1GI5u 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0|11e4",
            "Antarctica/Casey|+11 +08|-b0 -80|0101010101010|1GAF0 blz0 3m10 1o30 14k0 1kr0 12l0 1o01 14kX 1lf1 14kX 1lf1|10",
            "Antarctica/Davis|+05 +07|-50 -70|01|1GAI0|70",
            "Pacific/Port_Moresby|+10|-a0|0||25e4",
            "Australia/Sydney|AEDT AEST|-b0 -a0|01010101010101010101010|1GQg0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0|40e5",
            "Asia/Tashkent|+05|-50|0||23e5",
            "Pacific/Auckland|NZDT NZST|-d0 -c0|01010101010101010101010|1GQe0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00|14e5",
            "Asia/Baghdad|+03|-30|0||66e5",
            "Antarctica/Troll|+00 +02|0 -20|01010101010101010101010|1GNB0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0|40",
            "Asia/Bangkok|+07|-70|0||15e6",
            "Asia/Dhaka|+06|-60|0||16e6",
            "Asia/Amman|EET EEST +03|-20 -30 -30|010101010101010101012|1GPy0 4bX0 Dd0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 LA0 1C00|25e5",
            "Asia/Kamchatka|+12|-c0|0||18e4",
            "Asia/Baku|+04 +05|-40 -50|010101010|1GNA0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|27e5",
            "Asia/Barnaul|+07 +06|-70 -60|010|1N7v0 3rd0|",
            "Asia/Beirut|EET EEST|-20 -30|01010101010101010101010|1GNy0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0|22e5",
            "Asia/Kuala_Lumpur|+08|-80|0||71e5",
            "Asia/Kolkata|IST|-5u|0||15e6",
            "Asia/Chita|+10 +08 +09|-a0 -80 -90|012|1N7s0 3re0|33e4",
            "Asia/Ulaanbaatar|+08 +09|-80 -90|01010|1O8G0 1cJ0 1cP0 1cJ0|12e5",
            "Asia/Shanghai|CST|-80|0||23e6",
            "Asia/Colombo|+0530|-5u|0||22e5",
            "Asia/Damascus|EET EEST +03|-20 -30 -30|01010101010101010101012|1GPy0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0|26e5",
            "Asia/Dili|+09|-90|0||19e4",
            "Asia/Dubai|+04|-40|0||39e5",
            "Asia/Famagusta|EET EEST +03|-20 -30 -30|0101010101201010101010|1GNB0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 15U0 2Ks0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0|",
            "Asia/Gaza|EET EEST|-20 -30|01010101010101010101010|1GPy0 1a00 1fA0 1cL0 1cN0 1nX0 1210 1nA0 1210 1qL0 WN0 1qL0 WN0 1qL0 11c0 1on0 11B0 1o00 11A0 1qo0 XA0 1qp0|18e5",
            "Asia/Hong_Kong|HKT|-80|0||73e5",
            "Asia/Hovd|+07 +08|-70 -80|01010|1O8H0 1cJ0 1cP0 1cJ0|81e3",
            "Asia/Irkutsk|+09 +08|-90 -80|01|1N7t0|60e4",
            "Europe/Istanbul|EET EEST +03|-20 -30 -30|01010101012|1GNB0 1qM0 11A0 1o00 1200 1nA0 11A0 1tA0 U00 15w0|13e6",
            "Asia/Jakarta|WIB|-70|0||31e6",
            "Asia/Jayapura|WIT|-90|0||26e4",
            "Asia/Jerusalem|IST IDT|-20 -30|01010101010101010101010|1GPA0 1aL0 1eN0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0|81e4",
            "Asia/Kabul|+0430|-4u|0||46e5",
            "Asia/Karachi|PKT|-50|0||24e6",
            "Asia/Kathmandu|+0545|-5J|0||12e5",
            "Asia/Yakutsk|+10 +09|-a0 -90|01|1N7s0|28e4",
            "Asia/Krasnoyarsk|+08 +07|-80 -70|01|1N7u0|10e5",
            "Asia/Magadan|+12 +10 +11|-c0 -a0 -b0|012|1N7q0 3Cq0|95e3",
            "Asia/Makassar|WITA|-80|0||15e5",
            "Asia/Manila|PST|-80|0||24e6",
            "Europe/Athens|EET EEST|-20 -30|01010101010101010101010|1GNB0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0|35e5",
            "Asia/Novosibirsk|+07 +06|-70 -60|010|1N7v0 4eN0|15e5",
            "Asia/Omsk|+07 +06|-70 -60|01|1N7v0|12e5",
            "Asia/Pyongyang|KST KST|-90 -8u|010|1P4D0 6BA0|29e5",
            "Asia/Qyzylorda|+06 +05|-60 -50|01|1Xei0|73e4",
            "Asia/Rangoon|+0630|-6u|0||48e5",
            "Asia/Sakhalin|+11 +10|-b0 -a0|010|1N7r0 3rd0|58e4",
            "Asia/Seoul|KST|-90|0||23e6",
            "Asia/Srednekolymsk|+12 +11|-c0 -b0|01|1N7q0|35e2",
            "Asia/Tehran|+0330 +0430|-3u -4u|01010101010101010101010|1GLUu 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0|14e6",
            "Asia/Tokyo|JST|-90|0||38e6",
            "Asia/Tomsk|+07 +06|-70 -60|010|1N7v0 3Qp0|10e5",
            "Asia/Vladivostok|+11 +10|-b0 -a0|01|1N7r0|60e4",
            "Asia/Yekaterinburg|+06 +05|-60 -50|01|1N7w0|14e5",
            "Europe/Lisbon|WET WEST|0 -10|01010101010101010101010|1GNB0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0|27e5",
            "Atlantic/Cape_Verde|-01|10|0||50e4",
            "Australia/Adelaide|ACDT ACST|-au -9u|01010101010101010101010|1GQgu 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0|11e5",
            "Australia/Brisbane|AEST|-a0|0||20e5",
            "Australia/Darwin|ACST|-9u|0||12e4",
            "Australia/Eucla|+0845|-8J|0||368",
            "Australia/Lord_Howe|+11 +1030|-b0 -au|01010101010101010101010|1GQf0 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu|347",
            "Australia/Perth|AWST|-80|0||18e5",
            "Pacific/Easter|-05 -06|50 60|010101010101010101010|1H3D0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1zb0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0|30e2",
            "Europe/Dublin|GMT IST|0 -10|01010101010101010101010|1GNB0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0|12e5",
            "Etc/GMT-1|+01|-10|0||",
            "Pacific/Guadalcanal|+11|-b0|0||11e4",
            "Pacific/Fakaofo|+13|-d0|0||483",
            "Pacific/Kiritimati|+14|-e0|0||51e2",
            "Etc/GMT-2|+02|-20|0||",
            "Pacific/Tahiti|-10|a0|0||18e4",
            "Pacific/Niue|-11|b0|0||12e2",
            "Etc/GMT+12|-12|c0|0||",
            "Pacific/Galapagos|-06|60|0||25e3",
            "Etc/GMT+7|-07|70|0||",
            "Pacific/Pitcairn|-08|80|0||56",
            "Pacific/Gambier|-09|90|0||125",
            "Etc/UTC|UTC|0|0||",
            "Europe/Ulyanovsk|+04 +03|-40 -30|010|1N7y0 3rd0|13e5",
            "Europe/London|GMT BST|0 -10|01010101010101010101010|1GNB0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0|10e6",
            "Europe/Chisinau|EET EEST|-20 -30|01010101010101010101010|1GNA0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0|67e4",
            "Europe/Kaliningrad|+03 EET|-30 -20|01|1N7z0|44e4",
            "Europe/Moscow|MSK MSK|-40 -30|01|1N7y0|16e6",
            "Europe/Saratov|+04 +03|-40 -30|010|1N7y0 5810|",
            "Europe/Simferopol|EET EEST MSK MSK|-20 -30 -40 -30|0101023|1GNB0 1qM0 11A0 1o00 11z0 1nW0|33e4",
            "Europe/Volgograd|MSK MSK +04|-40 -30 -40|0121|1N7y0 9Jd0 5gn0|10e5",
            "Pacific/Honolulu|HST|a0|0||37e4",
            "MET|MET MEST|-10 -20|01010101010101010101010|1GNB0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0|",
            "Pacific/Chatham|+1345 +1245|-dJ -cJ|01010101010101010101010|1GQe0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00|600",
            "Pacific/Apia|+14 +13|-e0 -d0|01010101010101010101|1GQe0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0|37e3",
            "Pacific/Bougainville|+10 +11|-a0 -b0|01|1NwE0|18e4",
            "Pacific/Fiji|+13 +12|-d0 -c0|01010101010101010101|1Goe0 1Nc0 Ao0 1Q00 xz0 1SN0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 20o0 pc0 2hc0 bc0|88e4",
            "Pacific/Guam|ChST|-a0|0||17e4",
            "Pacific/Marquesas|-0930|9u|0||86e2",
            "Pacific/Pago_Pago|SST|b0|0||37e2",
            "Pacific/Norfolk|+1130 +11 +12|-bu -b0 -c0|012121212|1PoCu 9Jcu 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0|25e4",
            "Pacific/Tongatapu|+13 +14|-d0 -e0|010|1S4d0 s00|75e3"
        ],
        "links": [
            "Africa/Abidjan|Africa/Accra",
            "Africa/Abidjan|Africa/Bamako",
            "Africa/Abidjan|Africa/Banjul",
            "Africa/Abidjan|Africa/Bissau",
            "Africa/Abidjan|Africa/Conakry",
            "Africa/Abidjan|Africa/Dakar",
            "Africa/Abidjan|Africa/Freetown",
            "Africa/Abidjan|Africa/Lome",
            "Africa/Abidjan|Africa/Monrovia",
            "Africa/Abidjan|Africa/Nouakchott",
            "Africa/Abidjan|Africa/Ouagadougou",
            "Africa/Abidjan|Africa/Timbuktu",
            "Africa/Abidjan|America/Danmarkshavn",
            "Africa/Abidjan|Atlantic/Reykjavik",
            "Africa/Abidjan|Atlantic/St_Helena",
            "Africa/Abidjan|Etc/GMT",
            "Africa/Abidjan|Etc/GMT+0",
            "Africa/Abidjan|Etc/GMT-0",
            "Africa/Abidjan|Etc/GMT0",
            "Africa/Abidjan|Etc/Greenwich",
            "Africa/Abidjan|GMT",
            "Africa/Abidjan|GMT+0",
            "Africa/Abidjan|GMT-0",
            "Africa/Abidjan|GMT0",
            "Africa/Abidjan|Greenwich",
            "Africa/Abidjan|Iceland",
            "Africa/Algiers|Africa/Tunis",
            "Africa/Cairo|Egypt",
            "Africa/Casablanca|Africa/El_Aaiun",
            "Africa/Johannesburg|Africa/Maseru",
            "Africa/Johannesburg|Africa/Mbabane",
            "Africa/Lagos|Africa/Bangui",
            "Africa/Lagos|Africa/Brazzaville",
            "Africa/Lagos|Africa/Douala",
            "Africa/Lagos|Africa/Kinshasa",
            "Africa/Lagos|Africa/Libreville",
            "Africa/Lagos|Africa/Luanda",
            "Africa/Lagos|Africa/Malabo",
            "Africa/Lagos|Africa/Ndjamena",
            "Africa/Lagos|Africa/Niamey",
            "Africa/Lagos|Africa/Porto-Novo",
            "Africa/Maputo|Africa/Blantyre",
            "Africa/Maputo|Africa/Bujumbura",
            "Africa/Maputo|Africa/Gaborone",
            "Africa/Maputo|Africa/Harare",
            "Africa/Maputo|Africa/Kigali",
            "Africa/Maputo|Africa/Lubumbashi",
            "Africa/Maputo|Africa/Lusaka",
            "Africa/Nairobi|Africa/Addis_Ababa",
            "Africa/Nairobi|Africa/Asmara",
            "Africa/Nairobi|Africa/Asmera",
            "Africa/Nairobi|Africa/Dar_es_Salaam",
            "Africa/Nairobi|Africa/Djibouti",
            "Africa/Nairobi|Africa/Kampala",
            "Africa/Nairobi|Africa/Mogadishu",
            "Africa/Nairobi|Indian/Antananarivo",
            "Africa/Nairobi|Indian/Comoro",
            "Africa/Nairobi|Indian/Mayotte",
            "Africa/Tripoli|Libya",
            "America/Adak|America/Atka",
            "America/Adak|US/Aleutian",
            "America/Anchorage|America/Juneau",
            "America/Anchorage|America/Nome",
            "America/Anchorage|America/Sitka",
            "America/Anchorage|America/Yakutat",
            "America/Anchorage|US/Alaska",
            "America/Campo_Grande|America/Cuiaba",
            "America/Chicago|America/Indiana/Knox",
            "America/Chicago|America/Indiana/Tell_City",
            "America/Chicago|America/Knox_IN",
            "America/Chicago|America/Matamoros",
            "America/Chicago|America/Menominee",
            "America/Chicago|America/North_Dakota/Beulah",
            "America/Chicago|America/North_Dakota/Center",
            "America/Chicago|America/North_Dakota/New_Salem",
            "America/Chicago|America/Rainy_River",
            "America/Chicago|America/Rankin_Inlet",
            "America/Chicago|America/Resolute",
            "America/Chicago|America/Winnipeg",
            "America/Chicago|CST6CDT",
            "America/Chicago|Canada/Central",
            "America/Chicago|US/Central",
            "America/Chicago|US/Indiana-Starke",
            "America/Denver|America/Boise",
            "America/Denver|America/Cambridge_Bay",
            "America/Denver|America/Edmonton",
            "America/Denver|America/Inuvik",
            "America/Denver|America/Shiprock",
            "America/Denver|America/Yellowknife",
            "America/Denver|Canada/Mountain",
            "America/Denver|MST7MDT",
            "America/Denver|Navajo",
            "America/Denver|US/Mountain",
            "America/Fortaleza|America/Argentina/Buenos_Aires",
            "America/Fortaleza|America/Argentina/Catamarca",
            "America/Fortaleza|America/Argentina/ComodRivadavia",
            "America/Fortaleza|America/Argentina/Cordoba",
            "America/Fortaleza|America/Argentina/Jujuy",
            "America/Fortaleza|America/Argentina/La_Rioja",
            "America/Fortaleza|America/Argentina/Mendoza",
            "America/Fortaleza|America/Argentina/Rio_Gallegos",
            "America/Fortaleza|America/Argentina/Salta",
            "America/Fortaleza|America/Argentina/San_Juan",
            "America/Fortaleza|America/Argentina/San_Luis",
            "America/Fortaleza|America/Argentina/Tucuman",
            "America/Fortaleza|America/Argentina/Ushuaia",
            "America/Fortaleza|America/Belem",
            "America/Fortaleza|America/Buenos_Aires",
            "America/Fortaleza|America/Catamarca",
            "America/Fortaleza|America/Cayenne",
            "America/Fortaleza|America/Cordoba",
            "America/Fortaleza|America/Jujuy",
            "America/Fortaleza|America/Maceio",
            "America/Fortaleza|America/Mendoza",
            "America/Fortaleza|America/Paramaribo",
            "America/Fortaleza|America/Recife",
            "America/Fortaleza|America/Rosario",
            "America/Fortaleza|America/Santarem",
            "America/Fortaleza|Antarctica/Rothera",
            "America/Fortaleza|Atlantic/Stanley",
            "America/Fortaleza|Etc/GMT+3",
            "America/Godthab|America/Nuuk",
            "America/Halifax|America/Glace_Bay",
            "America/Halifax|America/Goose_Bay",
            "America/Halifax|America/Moncton",
            "America/Halifax|America/Thule",
            "America/Halifax|Atlantic/Bermuda",
            "America/Halifax|Canada/Atlantic",
            "America/Havana|Cuba",
            "America/La_Paz|America/Boa_Vista",
            "America/La_Paz|America/Guyana",
            "America/La_Paz|America/Manaus",
            "America/La_Paz|America/Porto_Velho",
            "America/La_Paz|Brazil/West",
            "America/La_Paz|Etc/GMT+4",
            "America/Lima|America/Bogota",
            "America/Lima|America/Guayaquil",
            "America/Lima|Etc/GMT+5",
            "America/Los_Angeles|America/Ensenada",
            "America/Los_Angeles|America/Santa_Isabel",
            "America/Los_Angeles|America/Tijuana",
            "America/Los_Angeles|America/Vancouver",
            "America/Los_Angeles|Canada/Pacific",
            "America/Los_Angeles|Mexico/BajaNorte",
            "America/Los_Angeles|PST8PDT",
            "America/Los_Angeles|US/Pacific",
            "America/Managua|America/Belize",
            "America/Managua|America/Costa_Rica",
            "America/Managua|America/El_Salvador",
            "America/Managua|America/Guatemala",
            "America/Managua|America/Regina",
            "America/Managua|America/Swift_Current",
            "America/Managua|America/Tegucigalpa",
            "America/Managua|Canada/Saskatchewan",
            "America/Mazatlan|Mexico/BajaSur",
            "America/Mexico_City|America/Bahia_Banderas",
            "America/Mexico_City|America/Merida",
            "America/Mexico_City|America/Monterrey",
            "America/Mexico_City|Mexico/General",
            "America/New_York|America/Detroit",
            "America/New_York|America/Fort_Wayne",
            "America/New_York|America/Indiana/Indianapolis",
            "America/New_York|America/Indiana/Marengo",
            "America/New_York|America/Indiana/Petersburg",
            "America/New_York|America/Indiana/Vevay",
            "America/New_York|America/Indiana/Vincennes",
            "America/New_York|America/Indiana/Winamac",
            "America/New_York|America/Indianapolis",
            "America/New_York|America/Iqaluit",
            "America/New_York|America/Kentucky/Louisville",
            "America/New_York|America/Kentucky/Monticello",
            "America/New_York|America/Louisville",
            "America/New_York|America/Montreal",
            "America/New_York|America/Nassau",
            "America/New_York|America/Nipigon",
            "America/New_York|America/Pangnirtung",
            "America/New_York|America/Thunder_Bay",
            "America/New_York|America/Toronto",
            "America/New_York|Canada/Eastern",
            "America/New_York|EST5EDT",
            "America/New_York|US/East-Indiana",
            "America/New_York|US/Eastern",
            "America/New_York|US/Michigan",
            "America/Noronha|Atlantic/South_Georgia",
            "America/Noronha|Brazil/DeNoronha",
            "America/Noronha|Etc/GMT+2",
            "America/Panama|America/Atikokan",
            "America/Panama|America/Cayman",
            "America/Panama|America/Coral_Harbour",
            "America/Panama|America/Jamaica",
            "America/Panama|EST",
            "America/Panama|Jamaica",
            "America/Phoenix|America/Creston",
            "America/Phoenix|America/Dawson_Creek",
            "America/Phoenix|America/Hermosillo",
            "America/Phoenix|MST",
            "America/Phoenix|US/Arizona",
            "America/Rio_Branco|America/Eirunepe",
            "America/Rio_Branco|America/Porto_Acre",
            "America/Rio_Branco|Brazil/Acre",
            "America/Santiago|Chile/Continental",
            "America/Santo_Domingo|America/Anguilla",
            "America/Santo_Domingo|America/Antigua",
            "America/Santo_Domingo|America/Aruba",
            "America/Santo_Domingo|America/Barbados",
            "America/Santo_Domingo|America/Blanc-Sablon",
            "America/Santo_Domingo|America/Curacao",
            "America/Santo_Domingo|America/Dominica",
            "America/Santo_Domingo|America/Grenada",
            "America/Santo_Domingo|America/Guadeloupe",
            "America/Santo_Domingo|America/Kralendijk",
            "America/Santo_Domingo|America/Lower_Princes",
            "America/Santo_Domingo|America/Marigot",
            "America/Santo_Domingo|America/Martinique",
            "America/Santo_Domingo|America/Montserrat",
            "America/Santo_Domingo|America/Port_of_Spain",
            "America/Santo_Domingo|America/Puerto_Rico",
            "America/Santo_Domingo|America/St_Barthelemy",
            "America/Santo_Domingo|America/St_Kitts",
            "America/Santo_Domingo|America/St_Lucia",
            "America/Santo_Domingo|America/St_Thomas",
            "America/Santo_Domingo|America/St_Vincent",
            "America/Santo_Domingo|America/Tortola",
            "America/Santo_Domingo|America/Virgin",
            "America/Sao_Paulo|Brazil/East",
            "America/St_Johns|Canada/Newfoundland",
            "America/Whitehorse|America/Dawson",
            "America/Whitehorse|Canada/Yukon",
            "Antarctica/Palmer|America/Punta_Arenas",
            "Asia/Baghdad|Antarctica/Syowa",
            "Asia/Baghdad|Asia/Aden",
            "Asia/Baghdad|Asia/Bahrain",
            "Asia/Baghdad|Asia/Kuwait",
            "Asia/Baghdad|Asia/Qatar",
            "Asia/Baghdad|Asia/Riyadh",
            "Asia/Baghdad|Etc/GMT-3",
            "Asia/Baghdad|Europe/Minsk",
            "Asia/Bangkok|Antarctica/Vostok",
            "Asia/Bangkok|Asia/Ho_Chi_Minh",
            "Asia/Bangkok|Asia/Novokuznetsk",
            "Asia/Bangkok|Asia/Phnom_Penh",
            "Asia/Bangkok|Asia/Saigon",
            "Asia/Bangkok|Asia/Vientiane",
            "Asia/Bangkok|Etc/GMT-7",
            "Asia/Bangkok|Indian/Christmas",
            "Asia/Dhaka|Asia/Almaty",
            "Asia/Dhaka|Asia/Bishkek",
            "Asia/Dhaka|Asia/Dacca",
            "Asia/Dhaka|Asia/Kashgar",
            "Asia/Dhaka|Asia/Qostanay",
            "Asia/Dhaka|Asia/Thimbu",
            "Asia/Dhaka|Asia/Thimphu",
            "Asia/Dhaka|Asia/Urumqi",
            "Asia/Dhaka|Etc/GMT-6",
            "Asia/Dhaka|Indian/Chagos",
            "Asia/Dili|Etc/GMT-9",
            "Asia/Dili|Pacific/Palau",
            "Asia/Dubai|Asia/Muscat",
            "Asia/Dubai|Asia/Tbilisi",
            "Asia/Dubai|Asia/Yerevan",
            "Asia/Dubai|Etc/GMT-4",
            "Asia/Dubai|Europe/Samara",
            "Asia/Dubai|Indian/Mahe",
            "Asia/Dubai|Indian/Mauritius",
            "Asia/Dubai|Indian/Reunion",
            "Asia/Gaza|Asia/Hebron",
            "Asia/Hong_Kong|Hongkong",
            "Asia/Jakarta|Asia/Pontianak",
            "Asia/Jerusalem|Asia/Tel_Aviv",
            "Asia/Jerusalem|Israel",
            "Asia/Kamchatka|Asia/Anadyr",
            "Asia/Kamchatka|Etc/GMT-12",
            "Asia/Kamchatka|Kwajalein",
            "Asia/Kamchatka|Pacific/Funafuti",
            "Asia/Kamchatka|Pacific/Kwajalein",
            "Asia/Kamchatka|Pacific/Majuro",
            "Asia/Kamchatka|Pacific/Nauru",
            "Asia/Kamchatka|Pacific/Tarawa",
            "Asia/Kamchatka|Pacific/Wake",
            "Asia/Kamchatka|Pacific/Wallis",
            "Asia/Kathmandu|Asia/Katmandu",
            "Asia/Kolkata|Asia/Calcutta",
            "Asia/Kuala_Lumpur|Asia/Brunei",
            "Asia/Kuala_Lumpur|Asia/Kuching",
            "Asia/Kuala_Lumpur|Asia/Singapore",
            "Asia/Kuala_Lumpur|Etc/GMT-8",
            "Asia/Kuala_Lumpur|Singapore",
            "Asia/Makassar|Asia/Ujung_Pandang",
            "Asia/Rangoon|Asia/Yangon",
            "Asia/Rangoon|Indian/Cocos",
            "Asia/Seoul|ROK",
            "Asia/Shanghai|Asia/Chongqing",
            "Asia/Shanghai|Asia/Chungking",
            "Asia/Shanghai|Asia/Harbin",
            "Asia/Shanghai|Asia/Macao",
            "Asia/Shanghai|Asia/Macau",
            "Asia/Shanghai|Asia/Taipei",
            "Asia/Shanghai|PRC",
            "Asia/Shanghai|ROC",
            "Asia/Tashkent|Antarctica/Mawson",
            "Asia/Tashkent|Asia/Aqtau",
            "Asia/Tashkent|Asia/Aqtobe",
            "Asia/Tashkent|Asia/Ashgabat",
            "Asia/Tashkent|Asia/Ashkhabad",
            "Asia/Tashkent|Asia/Atyrau",
            "Asia/Tashkent|Asia/Dushanbe",
            "Asia/Tashkent|Asia/Oral",
            "Asia/Tashkent|Asia/Samarkand",
            "Asia/Tashkent|Etc/GMT-5",
            "Asia/Tashkent|Indian/Kerguelen",
            "Asia/Tashkent|Indian/Maldives",
            "Asia/Tehran|Iran",
            "Asia/Tokyo|Japan",
            "Asia/Ulaanbaatar|Asia/Choibalsan",
            "Asia/Ulaanbaatar|Asia/Ulan_Bator",
            "Asia/Vladivostok|Asia/Ust-Nera",
            "Asia/Yakutsk|Asia/Khandyga",
            "Atlantic/Azores|America/Scoresbysund",
            "Atlantic/Cape_Verde|Etc/GMT+1",
            "Australia/Adelaide|Australia/Broken_Hill",
            "Australia/Adelaide|Australia/South",
            "Australia/Adelaide|Australia/Yancowinna",
            "Australia/Brisbane|Australia/Lindeman",
            "Australia/Brisbane|Australia/Queensland",
            "Australia/Darwin|Australia/North",
            "Australia/Lord_Howe|Australia/LHI",
            "Australia/Perth|Australia/West",
            "Australia/Sydney|Antarctica/Macquarie",
            "Australia/Sydney|Australia/ACT",
            "Australia/Sydney|Australia/Canberra",
            "Australia/Sydney|Australia/Currie",
            "Australia/Sydney|Australia/Hobart",
            "Australia/Sydney|Australia/Melbourne",
            "Australia/Sydney|Australia/NSW",
            "Australia/Sydney|Australia/Tasmania",
            "Australia/Sydney|Australia/Victoria",
            "Etc/UTC|Etc/UCT",
            "Etc/UTC|Etc/Universal",
            "Etc/UTC|Etc/Zulu",
            "Etc/UTC|UCT",
            "Etc/UTC|UTC",
            "Etc/UTC|Universal",
            "Etc/UTC|Zulu",
            "Europe/Athens|Asia/Nicosia",
            "Europe/Athens|EET",
            "Europe/Athens|Europe/Bucharest",
            "Europe/Athens|Europe/Helsinki",
            "Europe/Athens|Europe/Kiev",
            "Europe/Athens|Europe/Kyiv",
            "Europe/Athens|Europe/Mariehamn",
            "Europe/Athens|Europe/Nicosia",
            "Europe/Athens|Europe/Riga",
            "Europe/Athens|Europe/Sofia",
            "Europe/Athens|Europe/Tallinn",
            "Europe/Athens|Europe/Uzhgorod",
            "Europe/Athens|Europe/Vilnius",
            "Europe/Athens|Europe/Zaporozhye",
            "Europe/Chisinau|Europe/Tiraspol",
            "Europe/Dublin|Eire",
            "Europe/Istanbul|Asia/Istanbul",
            "Europe/Istanbul|Turkey",
            "Europe/Lisbon|Atlantic/Canary",
            "Europe/Lisbon|Atlantic/Faeroe",
            "Europe/Lisbon|Atlantic/Faroe",
            "Europe/Lisbon|Atlantic/Madeira",
            "Europe/Lisbon|Portugal",
            "Europe/Lisbon|WET",
            "Europe/London|Europe/Belfast",
            "Europe/London|Europe/Guernsey",
            "Europe/London|Europe/Isle_of_Man",
            "Europe/London|Europe/Jersey",
            "Europe/London|GB",
            "Europe/London|GB-Eire",
            "Europe/Moscow|Europe/Kirov",
            "Europe/Moscow|W-SU",
            "Europe/Paris|Africa/Ceuta",
            "Europe/Paris|Arctic/Longyearbyen",
            "Europe/Paris|Atlantic/Jan_Mayen",
            "Europe/Paris|CET",
            "Europe/Paris|Europe/Amsterdam",
            "Europe/Paris|Europe/Andorra",
            "Europe/Paris|Europe/Belgrade",
            "Europe/Paris|Europe/Berlin",
            "Europe/Paris|Europe/Bratislava",
            "Europe/Paris|Europe/Brussels",
            "Europe/Paris|Europe/Budapest",
            "Europe/Paris|Europe/Busingen",
            "Europe/Paris|Europe/Copenhagen",
            "Europe/Paris|Europe/Gibraltar",
            "Europe/Paris|Europe/Ljubljana",
            "Europe/Paris|Europe/Luxembourg",
            "Europe/Paris|Europe/Madrid",
            "Europe/Paris|Europe/Malta",
            "Europe/Paris|Europe/Monaco",
            "Europe/Paris|Europe/Oslo",
            "Europe/Paris|Europe/Podgorica",
            "Europe/Paris|Europe/Prague",
            "Europe/Paris|Europe/Rome",
            "Europe/Paris|Europe/San_Marino",
            "Europe/Paris|Europe/Sarajevo",
            "Europe/Paris|Europe/Skopje",
            "Europe/Paris|Europe/Stockholm",
            "Europe/Paris|Europe/Tirane",
            "Europe/Paris|Europe/Vaduz",
            "Europe/Paris|Europe/Vatican",
            "Europe/Paris|Europe/Vienna",
            "Europe/Paris|Europe/Warsaw",
            "Europe/Paris|Europe/Zagreb",
            "Europe/Paris|Europe/Zurich",
            "Europe/Paris|Poland",
            "Europe/Ulyanovsk|Europe/Astrakhan",
            "Pacific/Auckland|Antarctica/McMurdo",
            "Pacific/Auckland|Antarctica/South_Pole",
            "Pacific/Auckland|NZ",
            "Pacific/Chatham|NZ-CHAT",
            "Pacific/Easter|Chile/EasterIsland",
            "Pacific/Fakaofo|Etc/GMT-13",
            "Pacific/Fakaofo|Pacific/Enderbury",
            "Pacific/Fakaofo|Pacific/Kanton",
            "Pacific/Galapagos|Etc/GMT+6",
            "Pacific/Gambier|Etc/GMT+9",
            "Pacific/Guadalcanal|Etc/GMT-11",
            "Pacific/Guadalcanal|Pacific/Efate",
            "Pacific/Guadalcanal|Pacific/Kosrae",
            "Pacific/Guadalcanal|Pacific/Noumea",
            "Pacific/Guadalcanal|Pacific/Pohnpei",
            "Pacific/Guadalcanal|Pacific/Ponape",
            "Pacific/Guam|Pacific/Saipan",
            "Pacific/Honolulu|HST",
            "Pacific/Honolulu|Pacific/Johnston",
            "Pacific/Honolulu|US/Hawaii",
            "Pacific/Kiritimati|Etc/GMT-14",
            "Pacific/Niue|Etc/GMT+11",
            "Pacific/Pago_Pago|Pacific/Midway",
            "Pacific/Pago_Pago|Pacific/Samoa",
            "Pacific/Pago_Pago|US/Samoa",
            "Pacific/Pitcairn|Etc/GMT+8",
            "Pacific/Port_Moresby|Antarctica/DumontDUrville",
            "Pacific/Port_Moresby|Etc/GMT-10",
            "Pacific/Port_Moresby|Pacific/Chuuk",
            "Pacific/Port_Moresby|Pacific/Truk",
            "Pacific/Port_Moresby|Pacific/Yap",
            "Pacific/Tahiti|Etc/GMT+10",
            "Pacific/Tahiti|Pacific/Rarotonga"
        ],
        "countries": [
            "AD|Europe/Andorra",
            "AE|Asia/Dubai",
            "AF|Asia/Kabul",
            "AG|America/Puerto_Rico America/Antigua",
            "AI|America/Puerto_Rico America/Anguilla",
            "AL|Europe/Tirane",
            "AM|Asia/Yerevan",
            "AO|Africa/Lagos Africa/Luanda",
            "AQ|Antarctica/Casey Antarctica/Davis Antarctica/Mawson Antarctica/Palmer Antarctica/Rothera Antarctica/Troll Antarctica/Vostok Pacific/Auckland Pacific/Port_Moresby Asia/Riyadh Antarctica/McMurdo Antarctica/DumontDUrville Antarctica/Syowa",
            "AR|America/Argentina/Buenos_Aires America/Argentina/Cordoba America/Argentina/Salta America/Argentina/Jujuy America/Argentina/Tucuman America/Argentina/Catamarca America/Argentina/La_Rioja America/Argentina/San_Juan America/Argentina/Mendoza America/Argentina/San_Luis America/Argentina/Rio_Gallegos America/Argentina/Ushuaia",
            "AS|Pacific/Pago_Pago",
            "AT|Europe/Vienna",
            "AU|Australia/Lord_Howe Antarctica/Macquarie Australia/Hobart Australia/Melbourne Australia/Sydney Australia/Broken_Hill Australia/Brisbane Australia/Lindeman Australia/Adelaide Australia/Darwin Australia/Perth Australia/Eucla",
            "AW|America/Puerto_Rico America/Aruba",
            "AX|Europe/Helsinki Europe/Mariehamn",
            "AZ|Asia/Baku",
            "BA|Europe/Belgrade Europe/Sarajevo",
            "BB|America/Barbados",
            "BD|Asia/Dhaka",
            "BE|Europe/Brussels",
            "BF|Africa/Abidjan Africa/Ouagadougou",
            "BG|Europe/Sofia",
            "BH|Asia/Qatar Asia/Bahrain",
            "BI|Africa/Maputo Africa/Bujumbura",
            "BJ|Africa/Lagos Africa/Porto-Novo",
            "BL|America/Puerto_Rico America/St_Barthelemy",
            "BM|Atlantic/Bermuda",
            "BN|Asia/Kuching Asia/Brunei",
            "BO|America/La_Paz",
            "BQ|America/Puerto_Rico America/Kralendijk",
            "BR|America/Noronha America/Belem America/Fortaleza America/Recife America/Araguaina America/Maceio America/Bahia America/Sao_Paulo America/Campo_Grande America/Cuiaba America/Santarem America/Porto_Velho America/Boa_Vista America/Manaus America/Eirunepe America/Rio_Branco",
            "BS|America/Toronto America/Nassau",
            "BT|Asia/Thimphu",
            "BW|Africa/Maputo Africa/Gaborone",
            "BY|Europe/Minsk",
            "BZ|America/Belize",
            "CA|America/St_Johns America/Halifax America/Glace_Bay America/Moncton America/Goose_Bay America/Toronto America/Iqaluit America/Winnipeg America/Resolute America/Rankin_Inlet America/Regina America/Swift_Current America/Edmonton America/Cambridge_Bay America/Inuvik America/Dawson_Creek America/Fort_Nelson America/Whitehorse America/Dawson America/Vancouver America/Panama America/Puerto_Rico America/Phoenix America/Blanc-Sablon America/Atikokan America/Creston",
            "CC|Asia/Yangon Indian/Cocos",
            "CD|Africa/Maputo Africa/Lagos Africa/Kinshasa Africa/Lubumbashi",
            "CF|Africa/Lagos Africa/Bangui",
            "CG|Africa/Lagos Africa/Brazzaville",
            "CH|Europe/Zurich",
            "CI|Africa/Abidjan",
            "CK|Pacific/Rarotonga",
            "CL|America/Santiago America/Punta_Arenas Pacific/Easter",
            "CM|Africa/Lagos Africa/Douala",
            "CN|Asia/Shanghai Asia/Urumqi",
            "CO|America/Bogota",
            "CR|America/Costa_Rica",
            "CU|America/Havana",
            "CV|Atlantic/Cape_Verde",
            "CW|America/Puerto_Rico America/Curacao",
            "CX|Asia/Bangkok Indian/Christmas",
            "CY|Asia/Nicosia Asia/Famagusta",
            "CZ|Europe/Prague",
            "DE|Europe/Zurich Europe/Berlin Europe/Busingen",
            "DJ|Africa/Nairobi Africa/Djibouti",
            "DK|Europe/Berlin Europe/Copenhagen",
            "DM|America/Puerto_Rico America/Dominica",
            "DO|America/Santo_Domingo",
            "DZ|Africa/Algiers",
            "EC|America/Guayaquil Pacific/Galapagos",
            "EE|Europe/Tallinn",
            "EG|Africa/Cairo",
            "EH|Africa/El_Aaiun",
            "ER|Africa/Nairobi Africa/Asmara",
            "ES|Europe/Madrid Africa/Ceuta Atlantic/Canary",
            "ET|Africa/Nairobi Africa/Addis_Ababa",
            "FI|Europe/Helsinki",
            "FJ|Pacific/Fiji",
            "FK|Atlantic/Stanley",
            "FM|Pacific/Kosrae Pacific/Port_Moresby Pacific/Guadalcanal Pacific/Chuuk Pacific/Pohnpei",
            "FO|Atlantic/Faroe",
            "FR|Europe/Paris",
            "GA|Africa/Lagos Africa/Libreville",
            "GB|Europe/London",
            "GD|America/Puerto_Rico America/Grenada",
            "GE|Asia/Tbilisi",
            "GF|America/Cayenne",
            "GG|Europe/London Europe/Guernsey",
            "GH|Africa/Abidjan Africa/Accra",
            "GI|Europe/Gibraltar",
            "GL|America/Nuuk America/Danmarkshavn America/Scoresbysund America/Thule",
            "GM|Africa/Abidjan Africa/Banjul",
            "GN|Africa/Abidjan Africa/Conakry",
            "GP|America/Puerto_Rico America/Guadeloupe",
            "GQ|Africa/Lagos Africa/Malabo",
            "GR|Europe/Athens",
            "GS|Atlantic/South_Georgia",
            "GT|America/Guatemala",
            "GU|Pacific/Guam",
            "GW|Africa/Bissau",
            "GY|America/Guyana",
            "HK|Asia/Hong_Kong",
            "HN|America/Tegucigalpa",
            "HR|Europe/Belgrade Europe/Zagreb",
            "HT|America/Port-au-Prince",
            "HU|Europe/Budapest",
            "ID|Asia/Jakarta Asia/Pontianak Asia/Makassar Asia/Jayapura",
            "IE|Europe/Dublin",
            "IL|Asia/Jerusalem",
            "IM|Europe/London Europe/Isle_of_Man",
            "IN|Asia/Kolkata",
            "IO|Indian/Chagos",
            "IQ|Asia/Baghdad",
            "IR|Asia/Tehran",
            "IS|Africa/Abidjan Atlantic/Reykjavik",
            "IT|Europe/Rome",
            "JE|Europe/London Europe/Jersey",
            "JM|America/Jamaica",
            "JO|Asia/Amman",
            "JP|Asia/Tokyo",
            "KE|Africa/Nairobi",
            "KG|Asia/Bishkek",
            "KH|Asia/Bangkok Asia/Phnom_Penh",
            "KI|Pacific/Tarawa Pacific/Kanton Pacific/Kiritimati",
            "KM|Africa/Nairobi Indian/Comoro",
            "KN|America/Puerto_Rico America/St_Kitts",
            "KP|Asia/Pyongyang",
            "KR|Asia/Seoul",
            "KW|Asia/Riyadh Asia/Kuwait",
            "KY|America/Panama America/Cayman",
            "KZ|Asia/Almaty Asia/Qyzylorda Asia/Qostanay Asia/Aqtobe Asia/Aqtau Asia/Atyrau Asia/Oral",
            "LA|Asia/Bangkok Asia/Vientiane",
            "LB|Asia/Beirut",
            "LC|America/Puerto_Rico America/St_Lucia",
            "LI|Europe/Zurich Europe/Vaduz",
            "LK|Asia/Colombo",
            "LR|Africa/Monrovia",
            "LS|Africa/Johannesburg Africa/Maseru",
            "LT|Europe/Vilnius",
            "LU|Europe/Brussels Europe/Luxembourg",
            "LV|Europe/Riga",
            "LY|Africa/Tripoli",
            "MA|Africa/Casablanca",
            "MC|Europe/Paris Europe/Monaco",
            "MD|Europe/Chisinau",
            "ME|Europe/Belgrade Europe/Podgorica",
            "MF|America/Puerto_Rico America/Marigot",
            "MG|Africa/Nairobi Indian/Antananarivo",
            "MH|Pacific/Tarawa Pacific/Kwajalein Pacific/Majuro",
            "MK|Europe/Belgrade Europe/Skopje",
            "ML|Africa/Abidjan Africa/Bamako",
            "MM|Asia/Yangon",
            "MN|Asia/Ulaanbaatar Asia/Hovd Asia/Choibalsan",
            "MO|Asia/Macau",
            "MP|Pacific/Guam Pacific/Saipan",
            "MQ|America/Martinique",
            "MR|Africa/Abidjan Africa/Nouakchott",
            "MS|America/Puerto_Rico America/Montserrat",
            "MT|Europe/Malta",
            "MU|Indian/Mauritius",
            "MV|Indian/Maldives",
            "MW|Africa/Maputo Africa/Blantyre",
            "MX|America/Mexico_City America/Cancun America/Merida America/Monterrey America/Matamoros America/Chihuahua America/Ciudad_Juarez America/Ojinaga America/Mazatlan America/Bahia_Banderas America/Hermosillo America/Tijuana",
            "MY|Asia/Kuching Asia/Singapore Asia/Kuala_Lumpur",
            "MZ|Africa/Maputo",
            "NA|Africa/Windhoek",
            "NC|Pacific/Noumea",
            "NE|Africa/Lagos Africa/Niamey",
            "NF|Pacific/Norfolk",
            "NG|Africa/Lagos",
            "NI|America/Managua",
            "NL|Europe/Brussels Europe/Amsterdam",
            "NO|Europe/Berlin Europe/Oslo",
            "NP|Asia/Kathmandu",
            "NR|Pacific/Nauru",
            "NU|Pacific/Niue",
            "NZ|Pacific/Auckland Pacific/Chatham",
            "OM|Asia/Dubai Asia/Muscat",
            "PA|America/Panama",
            "PE|America/Lima",
            "PF|Pacific/Tahiti Pacific/Marquesas Pacific/Gambier",
            "PG|Pacific/Port_Moresby Pacific/Bougainville",
            "PH|Asia/Manila",
            "PK|Asia/Karachi",
            "PL|Europe/Warsaw",
            "PM|America/Miquelon",
            "PN|Pacific/Pitcairn",
            "PR|America/Puerto_Rico",
            "PS|Asia/Gaza Asia/Hebron",
            "PT|Europe/Lisbon Atlantic/Madeira Atlantic/Azores",
            "PW|Pacific/Palau",
            "PY|America/Asuncion",
            "QA|Asia/Qatar",
            "RE|Asia/Dubai Indian/Reunion",
            "RO|Europe/Bucharest",
            "RS|Europe/Belgrade",
            "RU|Europe/Kaliningrad Europe/Moscow Europe/Simferopol Europe/Kirov Europe/Volgograd Europe/Astrakhan Europe/Saratov Europe/Ulyanovsk Europe/Samara Asia/Yekaterinburg Asia/Omsk Asia/Novosibirsk Asia/Barnaul Asia/Tomsk Asia/Novokuznetsk Asia/Krasnoyarsk Asia/Irkutsk Asia/Chita Asia/Yakutsk Asia/Khandyga Asia/Vladivostok Asia/Ust-Nera Asia/Magadan Asia/Sakhalin Asia/Srednekolymsk Asia/Kamchatka Asia/Anadyr",
            "RW|Africa/Maputo Africa/Kigali",
            "SA|Asia/Riyadh",
            "SB|Pacific/Guadalcanal",
            "SC|Asia/Dubai Indian/Mahe",
            "SD|Africa/Khartoum",
            "SE|Europe/Berlin Europe/Stockholm",
            "SG|Asia/Singapore",
            "SH|Africa/Abidjan Atlantic/St_Helena",
            "SI|Europe/Belgrade Europe/Ljubljana",
            "SJ|Europe/Berlin Arctic/Longyearbyen",
            "SK|Europe/Prague Europe/Bratislava",
            "SL|Africa/Abidjan Africa/Freetown",
            "SM|Europe/Rome Europe/San_Marino",
            "SN|Africa/Abidjan Africa/Dakar",
            "SO|Africa/Nairobi Africa/Mogadishu",
            "SR|America/Paramaribo",
            "SS|Africa/Juba",
            "ST|Africa/Sao_Tome",
            "SV|America/El_Salvador",
            "SX|America/Puerto_Rico America/Lower_Princes",
            "SY|Asia/Damascus",
            "SZ|Africa/Johannesburg Africa/Mbabane",
            "TC|America/Grand_Turk",
            "TD|Africa/Ndjamena",
            "TF|Asia/Dubai Indian/Maldives Indian/Kerguelen",
            "TG|Africa/Abidjan Africa/Lome",
            "TH|Asia/Bangkok",
            "TJ|Asia/Dushanbe",
            "TK|Pacific/Fakaofo",
            "TL|Asia/Dili",
            "TM|Asia/Ashgabat",
            "TN|Africa/Tunis",
            "TO|Pacific/Tongatapu",
            "TR|Europe/Istanbul",
            "TT|America/Puerto_Rico America/Port_of_Spain",
            "TV|Pacific/Tarawa Pacific/Funafuti",
            "TW|Asia/Taipei",
            "TZ|Africa/Nairobi Africa/Dar_es_Salaam",
            "UA|Europe/Simferopol Europe/Kyiv",
            "UG|Africa/Nairobi Africa/Kampala",
            "UM|Pacific/Pago_Pago Pacific/Tarawa Pacific/Midway Pacific/Wake",
            "US|America/New_York America/Detroit America/Kentucky/Louisville America/Kentucky/Monticello America/Indiana/Indianapolis America/Indiana/Vincennes America/Indiana/Winamac America/Indiana/Marengo America/Indiana/Petersburg America/Indiana/Vevay America/Chicago America/Indiana/Tell_City America/Indiana/Knox America/Menominee America/North_Dakota/Center America/North_Dakota/New_Salem America/North_Dakota/Beulah America/Denver America/Boise America/Phoenix America/Los_Angeles America/Anchorage America/Juneau America/Sitka America/Metlakatla America/Yakutat America/Nome America/Adak Pacific/Honolulu",
            "UY|America/Montevideo",
            "UZ|Asia/Samarkand Asia/Tashkent",
            "VA|Europe/Rome Europe/Vatican",
            "VC|America/Puerto_Rico America/St_Vincent",
            "VE|America/Caracas",
            "VG|America/Puerto_Rico America/Tortola",
            "VI|America/Puerto_Rico America/St_Thomas",
            "VN|Asia/Bangkok Asia/Ho_Chi_Minh",
            "VU|Pacific/Efate",
            "WF|Pacific/Tarawa Pacific/Wallis",
            "WS|Pacific/Apia",
            "YE|Asia/Riyadh Asia/Aden",
            "YT|Africa/Nairobi Indian/Mayotte",
            "ZA|Africa/Johannesburg",
            "ZM|Africa/Maputo Africa/Lusaka",
            "ZW|Africa/Maputo Africa/Harare"
        ]
    });
    function staleDataWarning() {
        if (moment.suppressDeprecationWarnings === false && typeof console !== "undefined" && console.warn) console.warn("Deprecation warning: Moment Timezone has been loaded from a file containing data from 2012 to 2022 only. This file is out of date and may be removed in a future release. Dates and times for the current year might be incorrect.");
    }
    staleDataWarning();
    return moment;
});

});
parcelRegister("gH4MD", function(module, exports) {
//! moment.js
//! version : 2.30.1
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com
(function(global, factory) {
    module.exports = factory();
})(this, function() {
    "use strict";
    var hookCallback;
    function hooks() {
        return hookCallback.apply(null, arguments);
    }
    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback(callback) {
        hookCallback = callback;
    }
    function isArray(input) {
        return input instanceof Array || Object.prototype.toString.call(input) === "[object Array]";
    }
    function isObject(input) {
        // IE8 will treat undefined and null as object if it wasn't for
        // input != null
        return input != null && Object.prototype.toString.call(input) === "[object Object]";
    }
    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }
    function isObjectEmpty(obj) {
        if (Object.getOwnPropertyNames) return Object.getOwnPropertyNames(obj).length === 0;
        else {
            var k;
            for(k in obj){
                if (hasOwnProp(obj, k)) return false;
            }
            return true;
        }
    }
    function isUndefined(input) {
        return input === void 0;
    }
    function isNumber(input) {
        return typeof input === "number" || Object.prototype.toString.call(input) === "[object Number]";
    }
    function isDate(input) {
        return input instanceof Date || Object.prototype.toString.call(input) === "[object Date]";
    }
    function map(arr, fn) {
        var res = [], i, arrLen = arr.length;
        for(i = 0; i < arrLen; ++i)res.push(fn(arr[i], i));
        return res;
    }
    function extend(a, b) {
        for(var i in b)if (hasOwnProp(b, i)) a[i] = b[i];
        if (hasOwnProp(b, "toString")) a.toString = b.toString;
        if (hasOwnProp(b, "valueOf")) a.valueOf = b.valueOf;
        return a;
    }
    function createUTC(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }
    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty: false,
            unusedTokens: [],
            unusedInput: [],
            overflow: -2,
            charsLeftOver: 0,
            nullInput: false,
            invalidEra: null,
            invalidMonth: null,
            invalidFormat: false,
            userInvalidated: false,
            iso: false,
            parsedDateParts: [],
            era: null,
            meridiem: null,
            rfc2822: false,
            weekdayMismatch: false
        };
    }
    function getParsingFlags(m) {
        if (m._pf == null) m._pf = defaultParsingFlags();
        return m._pf;
    }
    var some;
    if (Array.prototype.some) some = Array.prototype.some;
    else some = function(fun) {
        var t = Object(this), len = t.length >>> 0, i;
        for(i = 0; i < len; i++){
            if (i in t && fun.call(this, t[i], i, t)) return true;
        }
        return false;
    };
    function isValid(m) {
        var flags = null, parsedParts = false, isNowValid = m._d && !isNaN(m._d.getTime());
        if (isNowValid) {
            flags = getParsingFlags(m);
            parsedParts = some.call(flags.parsedDateParts, function(i) {
                return i != null;
            });
            isNowValid = flags.overflow < 0 && !flags.empty && !flags.invalidEra && !flags.invalidMonth && !flags.invalidWeekday && !flags.weekdayMismatch && !flags.nullInput && !flags.invalidFormat && !flags.userInvalidated && (!flags.meridiem || flags.meridiem && parsedParts);
            if (m._strict) isNowValid = isNowValid && flags.charsLeftOver === 0 && flags.unusedTokens.length === 0 && flags.bigHour === undefined;
        }
        if (Object.isFrozen == null || !Object.isFrozen(m)) m._isValid = isNowValid;
        else return isNowValid;
        return m._isValid;
    }
    function createInvalid(flags) {
        var m = createUTC(NaN);
        if (flags != null) extend(getParsingFlags(m), flags);
        else getParsingFlags(m).userInvalidated = true;
        return m;
    }
    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = hooks.momentProperties = [], updateInProgress = false;
    function copyConfig(to, from) {
        var i, prop, val, momentPropertiesLen = momentProperties.length;
        if (!isUndefined(from._isAMomentObject)) to._isAMomentObject = from._isAMomentObject;
        if (!isUndefined(from._i)) to._i = from._i;
        if (!isUndefined(from._f)) to._f = from._f;
        if (!isUndefined(from._l)) to._l = from._l;
        if (!isUndefined(from._strict)) to._strict = from._strict;
        if (!isUndefined(from._tzm)) to._tzm = from._tzm;
        if (!isUndefined(from._isUTC)) to._isUTC = from._isUTC;
        if (!isUndefined(from._offset)) to._offset = from._offset;
        if (!isUndefined(from._pf)) to._pf = getParsingFlags(from);
        if (!isUndefined(from._locale)) to._locale = from._locale;
        if (momentPropertiesLen > 0) for(i = 0; i < momentPropertiesLen; i++){
            prop = momentProperties[i];
            val = from[prop];
            if (!isUndefined(val)) to[prop] = val;
        }
        return to;
    }
    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        if (!this.isValid()) this._d = new Date(NaN);
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            hooks.updateOffset(this);
            updateInProgress = false;
        }
    }
    function isMoment(obj) {
        return obj instanceof Moment || obj != null && obj._isAMomentObject != null;
    }
    function warn(msg) {
        if (hooks.suppressDeprecationWarnings === false && typeof console !== "undefined" && console.warn) console.warn("Deprecation warning: " + msg);
    }
    function deprecate(msg, fn) {
        var firstTime = true;
        return extend(function() {
            if (hooks.deprecationHandler != null) hooks.deprecationHandler(null, msg);
            if (firstTime) {
                var args = [], arg, i, key, argLen = arguments.length;
                for(i = 0; i < argLen; i++){
                    arg = "";
                    if (typeof arguments[i] === "object") {
                        arg += "\n[" + i + "] ";
                        for(key in arguments[0])if (hasOwnProp(arguments[0], key)) arg += key + ": " + arguments[0][key] + ", ";
                        arg = arg.slice(0, -2); // Remove trailing comma and space
                    } else arg = arguments[i];
                    args.push(arg);
                }
                warn(msg + "\nArguments: " + Array.prototype.slice.call(args).join("") + "\n" + new Error().stack);
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }
    var deprecations = {};
    function deprecateSimple(name, msg) {
        if (hooks.deprecationHandler != null) hooks.deprecationHandler(name, msg);
        if (!deprecations[name]) {
            warn(msg);
            deprecations[name] = true;
        }
    }
    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;
    function isFunction(input) {
        return typeof Function !== "undefined" && input instanceof Function || Object.prototype.toString.call(input) === "[object Function]";
    }
    function set(config) {
        var prop, i;
        for(i in config)if (hasOwnProp(config, i)) {
            prop = config[i];
            if (isFunction(prop)) this[i] = prop;
            else this["_" + i] = prop;
        }
        this._config = config;
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
        // TODO: Remove "ordinalParse" fallback in next major release.
        this._dayOfMonthOrdinalParseLenient = new RegExp((this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) + "|" + /\d{1,2}/.source);
    }
    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig), prop;
        for(prop in childConfig)if (hasOwnProp(childConfig, prop)) {
            if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                res[prop] = {};
                extend(res[prop], parentConfig[prop]);
                extend(res[prop], childConfig[prop]);
            } else if (childConfig[prop] != null) res[prop] = childConfig[prop];
            else delete res[prop];
        }
        for(prop in parentConfig)if (hasOwnProp(parentConfig, prop) && !hasOwnProp(childConfig, prop) && isObject(parentConfig[prop])) // make sure changes to properties don't modify parent config
        res[prop] = extend({}, res[prop]);
        return res;
    }
    function Locale(config) {
        if (config != null) this.set(config);
    }
    var keys;
    if (Object.keys) keys = Object.keys;
    else keys = function(obj) {
        var i, res = [];
        for(i in obj)if (hasOwnProp(obj, i)) res.push(i);
        return res;
    };
    var defaultCalendar = {
        sameDay: "[Today at] LT",
        nextDay: "[Tomorrow at] LT",
        nextWeek: "dddd [at] LT",
        lastDay: "[Yesterday at] LT",
        lastWeek: "[Last] dddd [at] LT",
        sameElse: "L"
    };
    function calendar(key, mom, now) {
        var output = this._calendar[key] || this._calendar["sameElse"];
        return isFunction(output) ? output.call(mom, now) : output;
    }
    function zeroFill(number, targetLength, forceSign) {
        var absNumber = "" + Math.abs(number), zerosToFill = targetLength - absNumber.length, sign = number >= 0;
        return (sign ? forceSign ? "+" : "" : "-") + Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
    }
    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g, localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g, formatFunctions = {}, formatTokenFunctions = {};
    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken(token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === "string") func = function() {
            return this[callback]();
        };
        if (token) formatTokenFunctions[token] = func;
        if (padded) formatTokenFunctions[padded[0]] = function() {
            return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
        };
        if (ordinal) formatTokenFunctions[ordinal] = function() {
            return this.localeData().ordinal(func.apply(this, arguments), token);
        };
    }
    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) return input.replace(/^\[|\]$/g, "");
        return input.replace(/\\/g, "");
    }
    function makeFormatFunction(format) {
        var array = format.match(formattingTokens), i, length;
        for(i = 0, length = array.length; i < length; i++)if (formatTokenFunctions[array[i]]) array[i] = formatTokenFunctions[array[i]];
        else array[i] = removeFormattingTokens(array[i]);
        return function(mom) {
            var output = "", i;
            for(i = 0; i < length; i++)output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
            return output;
        };
    }
    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) return m.localeData().invalidDate();
        format = expandFormat(format, m.localeData());
        formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);
        return formatFunctions[format](m);
    }
    function expandFormat(format, locale) {
        var i = 5;
        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }
        localFormattingTokens.lastIndex = 0;
        while(i >= 0 && localFormattingTokens.test(format)){
            format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }
        return format;
    }
    var defaultLongDateFormat = {
        LTS: "h:mm:ss A",
        LT: "h:mm A",
        L: "MM/DD/YYYY",
        LL: "MMMM D, YYYY",
        LLL: "MMMM D, YYYY h:mm A",
        LLLL: "dddd, MMMM D, YYYY h:mm A"
    };
    function longDateFormat(key) {
        var format = this._longDateFormat[key], formatUpper = this._longDateFormat[key.toUpperCase()];
        if (format || !formatUpper) return format;
        this._longDateFormat[key] = formatUpper.match(formattingTokens).map(function(tok) {
            if (tok === "MMMM" || tok === "MM" || tok === "DD" || tok === "dddd") return tok.slice(1);
            return tok;
        }).join("");
        return this._longDateFormat[key];
    }
    var defaultInvalidDate = "Invalid date";
    function invalidDate() {
        return this._invalidDate;
    }
    var defaultOrdinal = "%d", defaultDayOfMonthOrdinalParse = /\d{1,2}/;
    function ordinal(number) {
        return this._ordinal.replace("%d", number);
    }
    var defaultRelativeTime = {
        future: "in %s",
        past: "%s ago",
        s: "a few seconds",
        ss: "%d seconds",
        m: "a minute",
        mm: "%d minutes",
        h: "an hour",
        hh: "%d hours",
        d: "a day",
        dd: "%d days",
        w: "a week",
        ww: "%d weeks",
        M: "a month",
        MM: "%d months",
        y: "a year",
        yy: "%d years"
    };
    function relativeTime(number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return isFunction(output) ? output(number, withoutSuffix, string, isFuture) : output.replace(/%d/i, number);
    }
    function pastFuture(diff, output) {
        var format = this._relativeTime[diff > 0 ? "future" : "past"];
        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }
    var aliases = {
        D: "date",
        dates: "date",
        date: "date",
        d: "day",
        days: "day",
        day: "day",
        e: "weekday",
        weekdays: "weekday",
        weekday: "weekday",
        E: "isoWeekday",
        isoweekdays: "isoWeekday",
        isoweekday: "isoWeekday",
        DDD: "dayOfYear",
        dayofyears: "dayOfYear",
        dayofyear: "dayOfYear",
        h: "hour",
        hours: "hour",
        hour: "hour",
        ms: "millisecond",
        milliseconds: "millisecond",
        millisecond: "millisecond",
        m: "minute",
        minutes: "minute",
        minute: "minute",
        M: "month",
        months: "month",
        month: "month",
        Q: "quarter",
        quarters: "quarter",
        quarter: "quarter",
        s: "second",
        seconds: "second",
        second: "second",
        gg: "weekYear",
        weekyears: "weekYear",
        weekyear: "weekYear",
        GG: "isoWeekYear",
        isoweekyears: "isoWeekYear",
        isoweekyear: "isoWeekYear",
        w: "week",
        weeks: "week",
        week: "week",
        W: "isoWeek",
        isoweeks: "isoWeek",
        isoweek: "isoWeek",
        y: "year",
        years: "year",
        year: "year"
    };
    function normalizeUnits(units) {
        return typeof units === "string" ? aliases[units] || aliases[units.toLowerCase()] : undefined;
    }
    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {}, normalizedProp, prop;
        for(prop in inputObject)if (hasOwnProp(inputObject, prop)) {
            normalizedProp = normalizeUnits(prop);
            if (normalizedProp) normalizedInput[normalizedProp] = inputObject[prop];
        }
        return normalizedInput;
    }
    var priorities = {
        date: 9,
        day: 11,
        weekday: 11,
        isoWeekday: 11,
        dayOfYear: 4,
        hour: 13,
        millisecond: 16,
        minute: 14,
        month: 8,
        quarter: 7,
        second: 15,
        weekYear: 1,
        isoWeekYear: 1,
        week: 5,
        isoWeek: 5,
        year: 1
    };
    function getPrioritizedUnits(unitsObj) {
        var units = [], u;
        for(u in unitsObj)if (hasOwnProp(unitsObj, u)) units.push({
            unit: u,
            priority: priorities[u]
        });
        units.sort(function(a, b) {
            return a.priority - b.priority;
        });
        return units;
    }
    var match1 = /\d/, match2 = /\d\d/, match3 = /\d{3}/, match4 = /\d{4}/, match6 = /[+-]?\d{6}/, match1to2 = /\d\d?/, match3to4 = /\d\d\d\d?/, match5to6 = /\d\d\d\d\d\d?/, match1to3 = /\d{1,3}/, match1to4 = /\d{1,4}/, match1to6 = /[+-]?\d{1,6}/, matchUnsigned = /\d+/, matchSigned = /[+-]?\d+/, matchOffset = /Z|[+-]\d\d:?\d\d/gi, matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, // any word (or two) characters or numbers including two/three word month in arabic.
    // includes scottish gaelic two word and hyphenated months
    matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i, match1to2NoLeadingZero = /^[1-9]\d?/, match1to2HasZero = /^([1-9]\d|\d)/, regexes;
    regexes = {};
    function addRegexToken(token, regex, strictRegex) {
        regexes[token] = isFunction(regex) ? regex : function(isStrict, localeData) {
            return isStrict && strictRegex ? strictRegex : regex;
        };
    }
    function getParseRegexForToken(token, config) {
        if (!hasOwnProp(regexes, token)) return new RegExp(unescapeFormat(token));
        return regexes[token](config._strict, config._locale);
    }
    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(s.replace("\\", "").replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function(matched, p1, p2, p3, p4) {
            return p1 || p2 || p3 || p4;
        }));
    }
    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&");
    }
    function absFloor(number) {
        if (number < 0) // -0 -> 0
        return Math.ceil(number) || 0;
        else return Math.floor(number);
    }
    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion, value = 0;
        if (coercedNumber !== 0 && isFinite(coercedNumber)) value = absFloor(coercedNumber);
        return value;
    }
    var tokens = {};
    function addParseToken(token, callback) {
        var i, func = callback, tokenLen;
        if (typeof token === "string") token = [
            token
        ];
        if (isNumber(callback)) func = function(input, array) {
            array[callback] = toInt(input);
        };
        tokenLen = token.length;
        for(i = 0; i < tokenLen; i++)tokens[token[i]] = func;
    }
    function addWeekParseToken(token, callback) {
        addParseToken(token, function(input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }
    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) tokens[token](input, config._a, config, token);
    }
    function isLeapYear(year) {
        return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
    }
    var YEAR = 0, MONTH = 1, DATE = 2, HOUR = 3, MINUTE = 4, SECOND = 5, MILLISECOND = 6, WEEK = 7, WEEKDAY = 8;
    // FORMATTING
    addFormatToken("Y", 0, 0, function() {
        var y = this.year();
        return y <= 9999 ? zeroFill(y, 4) : "+" + y;
    });
    addFormatToken(0, [
        "YY",
        2
    ], 0, function() {
        return this.year() % 100;
    });
    addFormatToken(0, [
        "YYYY",
        4
    ], 0, "year");
    addFormatToken(0, [
        "YYYYY",
        5
    ], 0, "year");
    addFormatToken(0, [
        "YYYYYY",
        6,
        true
    ], 0, "year");
    // PARSING
    addRegexToken("Y", matchSigned);
    addRegexToken("YY", match1to2, match2);
    addRegexToken("YYYY", match1to4, match4);
    addRegexToken("YYYYY", match1to6, match6);
    addRegexToken("YYYYYY", match1to6, match6);
    addParseToken([
        "YYYYY",
        "YYYYYY"
    ], YEAR);
    addParseToken("YYYY", function(input, array) {
        array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken("YY", function(input, array) {
        array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken("Y", function(input, array) {
        array[YEAR] = parseInt(input, 10);
    });
    // HELPERS
    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }
    // HOOKS
    hooks.parseTwoDigitYear = function(input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };
    // MOMENTS
    var getSetYear = makeGetSet("FullYear", true);
    function getIsLeapYear() {
        return isLeapYear(this.year());
    }
    function makeGetSet(unit, keepTime) {
        return function(value) {
            if (value != null) {
                set$1(this, unit, value);
                hooks.updateOffset(this, keepTime);
                return this;
            } else return get(this, unit);
        };
    }
    function get(mom, unit) {
        if (!mom.isValid()) return NaN;
        var d = mom._d, isUTC = mom._isUTC;
        switch(unit){
            case "Milliseconds":
                return isUTC ? d.getUTCMilliseconds() : d.getMilliseconds();
            case "Seconds":
                return isUTC ? d.getUTCSeconds() : d.getSeconds();
            case "Minutes":
                return isUTC ? d.getUTCMinutes() : d.getMinutes();
            case "Hours":
                return isUTC ? d.getUTCHours() : d.getHours();
            case "Date":
                return isUTC ? d.getUTCDate() : d.getDate();
            case "Day":
                return isUTC ? d.getUTCDay() : d.getDay();
            case "Month":
                return isUTC ? d.getUTCMonth() : d.getMonth();
            case "FullYear":
                return isUTC ? d.getUTCFullYear() : d.getFullYear();
            default:
                return NaN; // Just in case
        }
    }
    function set$1(mom, unit, value) {
        var d, isUTC, year, month, date;
        if (!mom.isValid() || isNaN(value)) return;
        d = mom._d;
        isUTC = mom._isUTC;
        switch(unit){
            case "Milliseconds":
                return void (isUTC ? d.setUTCMilliseconds(value) : d.setMilliseconds(value));
            case "Seconds":
                return void (isUTC ? d.setUTCSeconds(value) : d.setSeconds(value));
            case "Minutes":
                return void (isUTC ? d.setUTCMinutes(value) : d.setMinutes(value));
            case "Hours":
                return void (isUTC ? d.setUTCHours(value) : d.setHours(value));
            case "Date":
                return void (isUTC ? d.setUTCDate(value) : d.setDate(value));
            // case 'Day': // Not real
            //    return void (isUTC ? d.setUTCDay(value) : d.setDay(value));
            // case 'Month': // Not used because we need to pass two variables
            //     return void (isUTC ? d.setUTCMonth(value) : d.setMonth(value));
            case "FullYear":
                break; // See below ...
            default:
                return; // Just in case
        }
        year = value;
        month = mom.month();
        date = mom.date();
        date = date === 29 && month === 1 && !isLeapYear(year) ? 28 : date;
        isUTC ? d.setUTCFullYear(year, month, date) : d.setFullYear(year, month, date);
    }
    // MOMENTS
    function stringGet(units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) return this[units]();
        return this;
    }
    function stringSet(units, value) {
        if (typeof units === "object") {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units), i, prioritizedLen = prioritized.length;
            for(i = 0; i < prioritizedLen; i++)this[prioritized[i].unit](units[prioritized[i].unit]);
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) return this[units](value);
        }
        return this;
    }
    function mod(n, x) {
        return (n % x + x) % x;
    }
    var indexOf;
    if (Array.prototype.indexOf) indexOf = Array.prototype.indexOf;
    else indexOf = function(o) {
        // I know
        var i;
        for(i = 0; i < this.length; ++i){
            if (this[i] === o) return i;
        }
        return -1;
    };
    function daysInMonth(year, month) {
        if (isNaN(year) || isNaN(month)) return NaN;
        var modMonth = mod(month, 12);
        year += (month - modMonth) / 12;
        return modMonth === 1 ? isLeapYear(year) ? 29 : 28 : 31 - modMonth % 7 % 2;
    }
    // FORMATTING
    addFormatToken("M", [
        "MM",
        2
    ], "Mo", function() {
        return this.month() + 1;
    });
    addFormatToken("MMM", 0, 0, function(format) {
        return this.localeData().monthsShort(this, format);
    });
    addFormatToken("MMMM", 0, 0, function(format) {
        return this.localeData().months(this, format);
    });
    // PARSING
    addRegexToken("M", match1to2, match1to2NoLeadingZero);
    addRegexToken("MM", match1to2, match2);
    addRegexToken("MMM", function(isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken("MMMM", function(isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });
    addParseToken([
        "M",
        "MM"
    ], function(input, array) {
        array[MONTH] = toInt(input) - 1;
    });
    addParseToken([
        "MMM",
        "MMMM"
    ], function(input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) array[MONTH] = month;
        else getParsingFlags(config).invalidMonth = input;
    });
    // LOCALES
    var defaultLocaleMonths = "January_February_March_April_May_June_July_August_September_October_November_December".split("_"), defaultLocaleMonthsShort = "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"), MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/, defaultMonthsShortRegex = matchWord, defaultMonthsRegex = matchWord;
    function localeMonths(m, format) {
        if (!m) return isArray(this._months) ? this._months : this._months["standalone"];
        return isArray(this._months) ? this._months[m.month()] : this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? "format" : "standalone"][m.month()];
    }
    function localeMonthsShort(m, format) {
        if (!m) return isArray(this._monthsShort) ? this._monthsShort : this._monthsShort["standalone"];
        return isArray(this._monthsShort) ? this._monthsShort[m.month()] : this._monthsShort[MONTHS_IN_FORMAT.test(format) ? "format" : "standalone"][m.month()];
    }
    function handleStrictParse(monthName, format, strict) {
        var i, ii, mom, llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            // this is not used
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for(i = 0; i < 12; ++i){
                mom = createUTC([
                    2000,
                    i
                ]);
                this._shortMonthsParse[i] = this.monthsShort(mom, "").toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, "").toLocaleLowerCase();
            }
        }
        if (strict) {
            if (format === "MMM") {
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else if (format === "MMM") {
            ii = indexOf.call(this._shortMonthsParse, llc);
            if (ii !== -1) return ii;
            ii = indexOf.call(this._longMonthsParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf.call(this._longMonthsParse, llc);
            if (ii !== -1) return ii;
            ii = indexOf.call(this._shortMonthsParse, llc);
            return ii !== -1 ? ii : null;
        }
    }
    function localeMonthsParse(monthName, format, strict) {
        var i, mom, regex;
        if (this._monthsParseExact) return handleStrictParse.call(this, monthName, format, strict);
        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }
        // TODO: add sorting
        // Sorting makes sure if one month (or abbr) is a prefix of another
        // see sorting in computeMonthsParse
        for(i = 0; i < 12; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                i
            ]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp("^" + this.months(mom, "").replace(".", "") + "$", "i");
                this._shortMonthsParse[i] = new RegExp("^" + this.monthsShort(mom, "").replace(".", "") + "$", "i");
            }
            if (!strict && !this._monthsParse[i]) {
                regex = "^" + this.months(mom, "") + "|^" + this.monthsShort(mom, "");
                this._monthsParse[i] = new RegExp(regex.replace(".", ""), "i");
            }
            // test the regex
            if (strict && format === "MMMM" && this._longMonthsParse[i].test(monthName)) return i;
            else if (strict && format === "MMM" && this._shortMonthsParse[i].test(monthName)) return i;
            else if (!strict && this._monthsParse[i].test(monthName)) return i;
        }
    }
    // MOMENTS
    function setMonth(mom, value) {
        if (!mom.isValid()) // No op
        return mom;
        if (typeof value === "string") {
            if (/^\d+$/.test(value)) value = toInt(value);
            else {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (!isNumber(value)) return mom;
            }
        }
        var month = value, date = mom.date();
        date = date < 29 ? date : Math.min(date, daysInMonth(mom.year(), month));
        mom._isUTC ? mom._d.setUTCMonth(month, date) : mom._d.setMonth(month, date);
        return mom;
    }
    function getSetMonth(value) {
        if (value != null) {
            setMonth(this, value);
            hooks.updateOffset(this, true);
            return this;
        } else return get(this, "Month");
    }
    function getDaysInMonth() {
        return daysInMonth(this.year(), this.month());
    }
    function monthsShortRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, "_monthsRegex")) computeMonthsParse.call(this);
            if (isStrict) return this._monthsShortStrictRegex;
            else return this._monthsShortRegex;
        } else {
            if (!hasOwnProp(this, "_monthsShortRegex")) this._monthsShortRegex = defaultMonthsShortRegex;
            return this._monthsShortStrictRegex && isStrict ? this._monthsShortStrictRegex : this._monthsShortRegex;
        }
    }
    function monthsRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, "_monthsRegex")) computeMonthsParse.call(this);
            if (isStrict) return this._monthsStrictRegex;
            else return this._monthsRegex;
        } else {
            if (!hasOwnProp(this, "_monthsRegex")) this._monthsRegex = defaultMonthsRegex;
            return this._monthsStrictRegex && isStrict ? this._monthsStrictRegex : this._monthsRegex;
        }
    }
    function computeMonthsParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }
        var shortPieces = [], longPieces = [], mixedPieces = [], i, mom, shortP, longP;
        for(i = 0; i < 12; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                i
            ]);
            shortP = regexEscape(this.monthsShort(mom, ""));
            longP = regexEscape(this.months(mom, ""));
            shortPieces.push(shortP);
            longPieces.push(longP);
            mixedPieces.push(longP);
            mixedPieces.push(shortP);
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        this._monthsRegex = new RegExp("^(" + mixedPieces.join("|") + ")", "i");
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp("^(" + longPieces.join("|") + ")", "i");
        this._monthsShortStrictRegex = new RegExp("^(" + shortPieces.join("|") + ")", "i");
    }
    function createDate(y, m, d, h, M, s, ms) {
        // can't just apply() to create a date:
        // https://stackoverflow.com/q/181348
        var date;
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            date = new Date(y + 400, m, d, h, M, s, ms);
            if (isFinite(date.getFullYear())) date.setFullYear(y);
        } else date = new Date(y, m, d, h, M, s, ms);
        return date;
    }
    function createUTCDate(y) {
        var date, args;
        // the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            args = Array.prototype.slice.call(arguments);
            // preserve leap years using a full 400 year cycle, then reset
            args[0] = y + 400;
            date = new Date(Date.UTC.apply(null, args));
            if (isFinite(date.getUTCFullYear())) date.setUTCFullYear(y);
        } else date = new Date(Date.UTC.apply(null, arguments));
        return date;
    }
    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var fwd = 7 + dow - doy, // first-week day local weekday -- which local weekday is fwd
        fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
        return -fwdlw + fwd - 1;
    }
    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7, weekOffset = firstWeekOffset(year, dow, doy), dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset, resYear, resDayOfYear;
        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }
        return {
            year: resYear,
            dayOfYear: resDayOfYear
        };
    }
    function weekOfYear(mom, dow, doy) {
        var weekOffset = firstWeekOffset(mom.year(), dow, doy), week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1, resWeek, resYear;
        if (week < 1) {
            resYear = mom.year() - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(mom.year(), dow, doy)) {
            resWeek = week - weeksInYear(mom.year(), dow, doy);
            resYear = mom.year() + 1;
        } else {
            resYear = mom.year();
            resWeek = week;
        }
        return {
            week: resWeek,
            year: resYear
        };
    }
    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy), weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }
    // FORMATTING
    addFormatToken("w", [
        "ww",
        2
    ], "wo", "week");
    addFormatToken("W", [
        "WW",
        2
    ], "Wo", "isoWeek");
    // PARSING
    addRegexToken("w", match1to2, match1to2NoLeadingZero);
    addRegexToken("ww", match1to2, match2);
    addRegexToken("W", match1to2, match1to2NoLeadingZero);
    addRegexToken("WW", match1to2, match2);
    addWeekParseToken([
        "w",
        "ww",
        "W",
        "WW"
    ], function(input, week, config, token) {
        week[token.substr(0, 1)] = toInt(input);
    });
    // HELPERS
    // LOCALES
    function localeWeek(mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }
    var defaultLocaleWeek = {
        dow: 0,
        doy: 6
    };
    function localeFirstDayOfWeek() {
        return this._week.dow;
    }
    function localeFirstDayOfYear() {
        return this._week.doy;
    }
    // MOMENTS
    function getSetWeek(input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, "d");
    }
    function getSetISOWeek(input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, "d");
    }
    // FORMATTING
    addFormatToken("d", 0, "do", "day");
    addFormatToken("dd", 0, 0, function(format) {
        return this.localeData().weekdaysMin(this, format);
    });
    addFormatToken("ddd", 0, 0, function(format) {
        return this.localeData().weekdaysShort(this, format);
    });
    addFormatToken("dddd", 0, 0, function(format) {
        return this.localeData().weekdays(this, format);
    });
    addFormatToken("e", 0, 0, "weekday");
    addFormatToken("E", 0, 0, "isoWeekday");
    // PARSING
    addRegexToken("d", match1to2);
    addRegexToken("e", match1to2);
    addRegexToken("E", match1to2);
    addRegexToken("dd", function(isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken("ddd", function(isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken("dddd", function(isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });
    addWeekParseToken([
        "dd",
        "ddd",
        "dddd"
    ], function(input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) week.d = weekday;
        else getParsingFlags(config).invalidWeekday = input;
    });
    addWeekParseToken([
        "d",
        "e",
        "E"
    ], function(input, week, config, token) {
        week[token] = toInt(input);
    });
    // HELPERS
    function parseWeekday(input, locale) {
        if (typeof input !== "string") return input;
        if (!isNaN(input)) return parseInt(input, 10);
        input = locale.weekdaysParse(input);
        if (typeof input === "number") return input;
        return null;
    }
    function parseIsoWeekday(input, locale) {
        if (typeof input === "string") return locale.weekdaysParse(input) % 7 || 7;
        return isNaN(input) ? null : input;
    }
    // LOCALES
    function shiftWeekdays(ws, n) {
        return ws.slice(n, 7).concat(ws.slice(0, n));
    }
    var defaultLocaleWeekdays = "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), defaultLocaleWeekdaysShort = "Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"), defaultLocaleWeekdaysMin = "Su_Mo_Tu_We_Th_Fr_Sa".split("_"), defaultWeekdaysRegex = matchWord, defaultWeekdaysShortRegex = matchWord, defaultWeekdaysMinRegex = matchWord;
    function localeWeekdays(m, format) {
        var weekdays = isArray(this._weekdays) ? this._weekdays : this._weekdays[m && m !== true && this._weekdays.isFormat.test(format) ? "format" : "standalone"];
        return m === true ? shiftWeekdays(weekdays, this._week.dow) : m ? weekdays[m.day()] : weekdays;
    }
    function localeWeekdaysShort(m) {
        return m === true ? shiftWeekdays(this._weekdaysShort, this._week.dow) : m ? this._weekdaysShort[m.day()] : this._weekdaysShort;
    }
    function localeWeekdaysMin(m) {
        return m === true ? shiftWeekdays(this._weekdaysMin, this._week.dow) : m ? this._weekdaysMin[m.day()] : this._weekdaysMin;
    }
    function handleStrictParse$1(weekdayName, format, strict) {
        var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];
            for(i = 0; i < 7; ++i){
                mom = createUTC([
                    2000,
                    1
                ]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(mom, "").toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(mom, "").toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, "").toLocaleLowerCase();
            }
        }
        if (strict) {
            if (format === "dddd") {
                ii = indexOf.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === "ddd") {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === "dddd") {
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === "ddd") {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }
    function localeWeekdaysParse(weekdayName, format, strict) {
        var i, mom, regex;
        if (this._weekdaysParseExact) return handleStrictParse$1.call(this, weekdayName, format, strict);
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }
        for(i = 0; i < 7; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                1
            ]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp("^" + this.weekdays(mom, "").replace(".", "\\.?") + "$", "i");
                this._shortWeekdaysParse[i] = new RegExp("^" + this.weekdaysShort(mom, "").replace(".", "\\.?") + "$", "i");
                this._minWeekdaysParse[i] = new RegExp("^" + this.weekdaysMin(mom, "").replace(".", "\\.?") + "$", "i");
            }
            if (!this._weekdaysParse[i]) {
                regex = "^" + this.weekdays(mom, "") + "|^" + this.weekdaysShort(mom, "") + "|^" + this.weekdaysMin(mom, "");
                this._weekdaysParse[i] = new RegExp(regex.replace(".", ""), "i");
            }
            // test the regex
            if (strict && format === "dddd" && this._fullWeekdaysParse[i].test(weekdayName)) return i;
            else if (strict && format === "ddd" && this._shortWeekdaysParse[i].test(weekdayName)) return i;
            else if (strict && format === "dd" && this._minWeekdaysParse[i].test(weekdayName)) return i;
            else if (!strict && this._weekdaysParse[i].test(weekdayName)) return i;
        }
    }
    // MOMENTS
    function getSetDayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        var day = get(this, "Day");
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, "d");
        } else return day;
    }
    function getSetLocaleDayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, "d");
    }
    function getSetISODayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.
        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else return this.day() || 7;
    }
    function weekdaysRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, "_weekdaysRegex")) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysStrictRegex;
            else return this._weekdaysRegex;
        } else {
            if (!hasOwnProp(this, "_weekdaysRegex")) this._weekdaysRegex = defaultWeekdaysRegex;
            return this._weekdaysStrictRegex && isStrict ? this._weekdaysStrictRegex : this._weekdaysRegex;
        }
    }
    function weekdaysShortRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, "_weekdaysRegex")) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysShortStrictRegex;
            else return this._weekdaysShortRegex;
        } else {
            if (!hasOwnProp(this, "_weekdaysShortRegex")) this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            return this._weekdaysShortStrictRegex && isStrict ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
        }
    }
    function weekdaysMinRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, "_weekdaysRegex")) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysMinStrictRegex;
            else return this._weekdaysMinRegex;
        } else {
            if (!hasOwnProp(this, "_weekdaysMinRegex")) this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            return this._weekdaysMinStrictRegex && isStrict ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
        }
    }
    function computeWeekdaysParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }
        var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [], i, mom, minp, shortp, longp;
        for(i = 0; i < 7; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                1
            ]).day(i);
            minp = regexEscape(this.weekdaysMin(mom, ""));
            shortp = regexEscape(this.weekdaysShort(mom, ""));
            longp = regexEscape(this.weekdays(mom, ""));
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }
        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
        // will match the longer piece.
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        this._weekdaysRegex = new RegExp("^(" + mixedPieces.join("|") + ")", "i");
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;
        this._weekdaysStrictRegex = new RegExp("^(" + longPieces.join("|") + ")", "i");
        this._weekdaysShortStrictRegex = new RegExp("^(" + shortPieces.join("|") + ")", "i");
        this._weekdaysMinStrictRegex = new RegExp("^(" + minPieces.join("|") + ")", "i");
    }
    // FORMATTING
    function hFormat() {
        return this.hours() % 12 || 12;
    }
    function kFormat() {
        return this.hours() || 24;
    }
    addFormatToken("H", [
        "HH",
        2
    ], 0, "hour");
    addFormatToken("h", [
        "hh",
        2
    ], 0, hFormat);
    addFormatToken("k", [
        "kk",
        2
    ], 0, kFormat);
    addFormatToken("hmm", 0, 0, function() {
        return "" + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });
    addFormatToken("hmmss", 0, 0, function() {
        return "" + hFormat.apply(this) + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
    });
    addFormatToken("Hmm", 0, 0, function() {
        return "" + this.hours() + zeroFill(this.minutes(), 2);
    });
    addFormatToken("Hmmss", 0, 0, function() {
        return "" + this.hours() + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
    });
    function meridiem(token, lowercase) {
        addFormatToken(token, 0, 0, function() {
            return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
        });
    }
    meridiem("a", true);
    meridiem("A", false);
    // PARSING
    function matchMeridiem(isStrict, locale) {
        return locale._meridiemParse;
    }
    addRegexToken("a", matchMeridiem);
    addRegexToken("A", matchMeridiem);
    addRegexToken("H", match1to2, match1to2HasZero);
    addRegexToken("h", match1to2, match1to2NoLeadingZero);
    addRegexToken("k", match1to2, match1to2NoLeadingZero);
    addRegexToken("HH", match1to2, match2);
    addRegexToken("hh", match1to2, match2);
    addRegexToken("kk", match1to2, match2);
    addRegexToken("hmm", match3to4);
    addRegexToken("hmmss", match5to6);
    addRegexToken("Hmm", match3to4);
    addRegexToken("Hmmss", match5to6);
    addParseToken([
        "H",
        "HH"
    ], HOUR);
    addParseToken([
        "k",
        "kk"
    ], function(input, array, config) {
        var kInput = toInt(input);
        array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken([
        "a",
        "A"
    ], function(input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken([
        "h",
        "hh"
    ], function(input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken("hmm", function(input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken("hmmss", function(input, array, config) {
        var pos1 = input.length - 4, pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken("Hmm", function(input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken("Hmmss", function(input, array, config) {
        var pos1 = input.length - 4, pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });
    // LOCALES
    function localeIsPM(input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return (input + "").toLowerCase().charAt(0) === "p";
    }
    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i, // Setting the hour should keep the time, because the user explicitly
    // specified which hour they want. So trying to maintain the same hour (in
    // a new timezone) makes sense. Adding/subtracting hours does not follow
    // this rule.
    getSetHour = makeGetSet("Hours", true);
    function localeMeridiem(hours, minutes, isLower) {
        if (hours > 11) return isLower ? "pm" : "PM";
        else return isLower ? "am" : "AM";
    }
    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
        relativeTime: defaultRelativeTime,
        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,
        week: defaultLocaleWeek,
        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,
        meridiemParse: defaultLocaleMeridiemParse
    };
    // internal storage for locale config files
    var locales = {}, localeFamilies = {}, globalLocale;
    function commonPrefix(arr1, arr2) {
        var i, minl = Math.min(arr1.length, arr2.length);
        for(i = 0; i < minl; i += 1){
            if (arr1[i] !== arr2[i]) return i;
        }
        return minl;
    }
    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace("_", "-") : key;
    }
    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0, j, next, locale, split;
        while(i < names.length){
            split = normalizeLocale(names[i]).split("-");
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split("-") : null;
            while(j > 0){
                locale = loadLocale(split.slice(0, j).join("-"));
                if (locale) return locale;
                if (next && next.length >= j && commonPrefix(split, next) >= j - 1) break;
                j--;
            }
            i++;
        }
        return globalLocale;
    }
    function isLocaleNameSane(name) {
        // Prevent names that look like filesystem paths, i.e contain '/' or '\'
        // Ensure name is available and function returns boolean
        return !!(name && name.match("^[^/\\\\]*$"));
    }
    function loadLocale(name) {
        var oldLocale = null, aliasedRequire;
        // TODO: Find a better way to register and load all the locales in Node
        if (locales[name] === undefined && true && module && module.exports && isLocaleNameSane(name)) try {
            oldLocale = globalLocale._abbr;
            aliasedRequire = undefined;
            aliasedRequire("./locale/" + name);
            getSetGlobalLocale(oldLocale);
        } catch (e) {
            // mark as not found to avoid repeating expensive file require call causing high CPU
            // when trying to find en-US, en_US, en-us for every format call
            locales[name] = null; // null means not found
        }
        return locales[name];
    }
    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function getSetGlobalLocale(key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) data = getLocale(key);
            else data = defineLocale(key, values);
            if (data) // moment.duration._locale = moment._locale = data;
            globalLocale = data;
            else if (typeof console !== "undefined" && console.warn) //warn user if arguments are passed but the locale could not be set
            console.warn("Locale " + key + " not found. Did you forget to load it?");
        }
        return globalLocale._abbr;
    }
    function defineLocale(name, config) {
        if (config !== null) {
            var locale, parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple("defineLocaleOverride", "use moment.updateLocale(localeName, config) to change an existing locale. moment.defineLocale(localeName, config) should only be used for creating a new locale See http://momentjs.com/guides/#/warnings/define-locale/ for more info.");
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) parentConfig = locales[config.parentLocale]._config;
                else {
                    locale = loadLocale(config.parentLocale);
                    if (locale != null) parentConfig = locale._config;
                    else {
                        if (!localeFamilies[config.parentLocale]) localeFamilies[config.parentLocale] = [];
                        localeFamilies[config.parentLocale].push({
                            name: name,
                            config: config
                        });
                        return null;
                    }
                }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));
            if (localeFamilies[name]) localeFamilies[name].forEach(function(x) {
                defineLocale(x.name, x.config);
            });
            // backwards compat for now: also set the locale
            // make sure we set the locale AFTER all child locales have been
            // created, so we won't end up with the child locale set.
            getSetGlobalLocale(name);
            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }
    function updateLocale(name, config) {
        if (config != null) {
            var locale, tmpLocale, parentConfig = baseConfig;
            if (locales[name] != null && locales[name].parentLocale != null) // Update existing child locale in-place to avoid memory-leaks
            locales[name].set(mergeConfigs(locales[name]._config, config));
            else {
                // MERGE
                tmpLocale = loadLocale(name);
                if (tmpLocale != null) parentConfig = tmpLocale._config;
                config = mergeConfigs(parentConfig, config);
                if (tmpLocale == null) // updateLocale is called for creating a new locale
                // Set abbr so it will have a name (getters return
                // undefined otherwise).
                config.abbr = name;
                locale = new Locale(config);
                locale.parentLocale = locales[name];
                locales[name] = locale;
            }
            // backwards compat for now: also set the locale
            getSetGlobalLocale(name);
        } else // pass null for config to unupdate, useful for tests
        if (locales[name] != null) {
            if (locales[name].parentLocale != null) {
                locales[name] = locales[name].parentLocale;
                if (name === getSetGlobalLocale()) getSetGlobalLocale(name);
            } else if (locales[name] != null) delete locales[name];
        }
        return locales[name];
    }
    // returns locale data
    function getLocale(key) {
        var locale;
        if (key && key._locale && key._locale._abbr) key = key._locale._abbr;
        if (!key) return globalLocale;
        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) return locale;
            key = [
                key
            ];
        }
        return chooseLocale(key);
    }
    function listLocales() {
        return keys(locales);
    }
    function checkOverflow(m) {
        var overflow, a = m._a;
        if (a && getParsingFlags(m).overflow === -2) {
            overflow = a[MONTH] < 0 || a[MONTH] > 11 ? MONTH : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH]) ? DATE : a[HOUR] < 0 || a[HOUR] > 24 || a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0) ? HOUR : a[MINUTE] < 0 || a[MINUTE] > 59 ? MINUTE : a[SECOND] < 0 || a[SECOND] > 59 ? SECOND : a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND : -1;
            if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) overflow = DATE;
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) overflow = WEEK;
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) overflow = WEEKDAY;
            getParsingFlags(m).overflow = overflow;
        }
        return m;
    }
    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, tzRegex = /Z|[+-]\d\d(?::?\d\d)?/, isoDates = [
        [
            "YYYYYY-MM-DD",
            /[+-]\d{6}-\d\d-\d\d/
        ],
        [
            "YYYY-MM-DD",
            /\d{4}-\d\d-\d\d/
        ],
        [
            "GGGG-[W]WW-E",
            /\d{4}-W\d\d-\d/
        ],
        [
            "GGGG-[W]WW",
            /\d{4}-W\d\d/,
            false
        ],
        [
            "YYYY-DDD",
            /\d{4}-\d{3}/
        ],
        [
            "YYYY-MM",
            /\d{4}-\d\d/,
            false
        ],
        [
            "YYYYYYMMDD",
            /[+-]\d{10}/
        ],
        [
            "YYYYMMDD",
            /\d{8}/
        ],
        [
            "GGGG[W]WWE",
            /\d{4}W\d{3}/
        ],
        [
            "GGGG[W]WW",
            /\d{4}W\d{2}/,
            false
        ],
        [
            "YYYYDDD",
            /\d{7}/
        ],
        [
            "YYYYMM",
            /\d{6}/,
            false
        ],
        [
            "YYYY",
            /\d{4}/,
            false
        ]
    ], // iso time formats and regexes
    isoTimes = [
        [
            "HH:mm:ss.SSSS",
            /\d\d:\d\d:\d\d\.\d+/
        ],
        [
            "HH:mm:ss,SSSS",
            /\d\d:\d\d:\d\d,\d+/
        ],
        [
            "HH:mm:ss",
            /\d\d:\d\d:\d\d/
        ],
        [
            "HH:mm",
            /\d\d:\d\d/
        ],
        [
            "HHmmss.SSSS",
            /\d\d\d\d\d\d\.\d+/
        ],
        [
            "HHmmss,SSSS",
            /\d\d\d\d\d\d,\d+/
        ],
        [
            "HHmmss",
            /\d\d\d\d\d\d/
        ],
        [
            "HHmm",
            /\d\d\d\d/
        ],
        [
            "HH",
            /\d\d/
        ]
    ], aspNetJsonRegex = /^\/?Date\((-?\d+)/i, // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
    rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/, obsOffsets = {
        UT: 0,
        GMT: 0,
        EDT: -240,
        EST: -300,
        CDT: -300,
        CST: -360,
        MDT: -360,
        MST: -420,
        PDT: -420,
        PST: -480
    };
    // date from iso format
    function configFromISO(config) {
        var i, l, string = config._i, match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string), allowTime, dateFormat, timeFormat, tzFormat, isoDatesLen = isoDates.length, isoTimesLen = isoTimes.length;
        if (match) {
            getParsingFlags(config).iso = true;
            for(i = 0, l = isoDatesLen; i < l; i++)if (isoDates[i][1].exec(match[1])) {
                dateFormat = isoDates[i][0];
                allowTime = isoDates[i][2] !== false;
                break;
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for(i = 0, l = isoTimesLen; i < l; i++)if (isoTimes[i][1].exec(match[3])) {
                    // match[2] should be 'T' or space
                    timeFormat = (match[2] || " ") + isoTimes[i][0];
                    break;
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) tzFormat = "Z";
                else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || "") + (tzFormat || "");
            configFromStringAndFormat(config);
        } else config._isValid = false;
    }
    function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
        var result = [
            untruncateYear(yearStr),
            defaultLocaleMonthsShort.indexOf(monthStr),
            parseInt(dayStr, 10),
            parseInt(hourStr, 10),
            parseInt(minuteStr, 10)
        ];
        if (secondStr) result.push(parseInt(secondStr, 10));
        return result;
    }
    function untruncateYear(yearStr) {
        var year = parseInt(yearStr, 10);
        if (year <= 49) return 2000 + year;
        else if (year <= 999) return 1900 + year;
        return year;
    }
    function preprocessRFC2822(s) {
        // Remove comments and folding whitespace and replace multiple-spaces with a single space
        return s.replace(/\([^()]*\)|[\n\t]/g, " ").replace(/(\s\s+)/g, " ").replace(/^\s\s*/, "").replace(/\s\s*$/, "");
    }
    function checkWeekday(weekdayStr, parsedInput, config) {
        if (weekdayStr) {
            // TODO: Replace the vanilla JS Date object with an independent day-of-week check.
            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr), weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();
            if (weekdayProvided !== weekdayActual) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return false;
            }
        }
        return true;
    }
    function calculateOffset(obsOffset, militaryOffset, numOffset) {
        if (obsOffset) return obsOffsets[obsOffset];
        else if (militaryOffset) // the only allowed military tz is Z
        return 0;
        else {
            var hm = parseInt(numOffset, 10), m = hm % 100, h = (hm - m) / 100;
            return h * 60 + m;
        }
    }
    // date and time from ref 2822 format
    function configFromRFC2822(config) {
        var match = rfc2822.exec(preprocessRFC2822(config._i)), parsedArray;
        if (match) {
            parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);
            if (!checkWeekday(match[1], parsedArray, config)) return;
            config._a = parsedArray;
            config._tzm = calculateOffset(match[8], match[9], match[10]);
            config._d = createUTCDate.apply(null, config._a);
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
            getParsingFlags(config).rfc2822 = true;
        } else config._isValid = false;
    }
    // date from 1) ASP.NET, 2) ISO, 3) RFC 2822 formats, or 4) optional fallback if parsing isn't strict
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);
        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }
        configFromISO(config);
        if (config._isValid === false) delete config._isValid;
        else return;
        configFromRFC2822(config);
        if (config._isValid === false) delete config._isValid;
        else return;
        if (config._strict) config._isValid = false;
        else // Final attempt, use Input Fallback
        hooks.createFromInputFallback(config);
    }
    hooks.createFromInputFallback = deprecate("value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.", function(config) {
        config._d = new Date(config._i + (config._useUTC ? " UTC" : ""));
    });
    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) return a;
        if (b != null) return b;
        return c;
    }
    function currentDateArray(config) {
        // hooks is actually the exported moment object
        var nowValue = new Date(hooks.now());
        if (config._useUTC) return [
            nowValue.getUTCFullYear(),
            nowValue.getUTCMonth(),
            nowValue.getUTCDate()
        ];
        return [
            nowValue.getFullYear(),
            nowValue.getMonth(),
            nowValue.getDate()
        ];
    }
    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray(config) {
        var i, date, input = [], currentDate, expectedWeekday, yearToUse;
        if (config._d) return;
        currentDate = currentDateArray(config);
        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) dayOfYearFromWeekInfo(config);
        //if the day of the year is set, figure out what it is
        if (config._dayOfYear != null) {
            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);
            if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) getParsingFlags(config)._overflowDayOfYear = true;
            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }
        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for(i = 0; i < 3 && config._a[i] == null; ++i)config._a[i] = input[i] = currentDate[i];
        // Zero out whatever was not defaulted, including time
        for(; i < 7; i++)config._a[i] = input[i] = config._a[i] == null ? i === 2 ? 1 : 0 : config._a[i];
        // Check for 24:00:00.000
        if (config._a[HOUR] === 24 && config._a[MINUTE] === 0 && config._a[SECOND] === 0 && config._a[MILLISECOND] === 0) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }
        config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
        expectedWeekday = config._useUTC ? config._d.getUTCDay() : config._d.getDay();
        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        if (config._nextDay) config._a[HOUR] = 24;
        // check for mismatching day of week
        if (config._w && typeof config._w.d !== "undefined" && config._w.d !== expectedWeekday) getParsingFlags(config).weekdayMismatch = true;
    }
    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;
        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;
            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) weekdayOverflow = true;
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;
            curWeek = weekOfYear(createLocal(), dow, doy);
            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);
            // Default to current week.
            week = defaults(w.w, curWeek.week);
            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) weekdayOverflow = true;
            } else if (w.e != null) {
                // local weekday -- counting starts from beginning of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) weekdayOverflow = true;
            } else // default to beginning of week
            weekday = dow;
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) getParsingFlags(config)._overflowWeeks = true;
        else if (weekdayOverflow != null) getParsingFlags(config)._overflowWeekday = true;
        else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }
    // constant that refers to the ISO standard
    hooks.ISO_8601 = function() {};
    // constant that refers to the RFC 2822 form
    hooks.RFC_2822 = function() {};
    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === hooks.ISO_8601) {
            configFromISO(config);
            return;
        }
        if (config._f === hooks.RFC_2822) {
            configFromRFC2822(config);
            return;
        }
        config._a = [];
        getParsingFlags(config).empty = true;
        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = "" + config._i, i, parsedInput, tokens, token, skipped, stringLength = string.length, totalParsedInputLength = 0, era, tokenLen;
        tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];
        tokenLen = tokens.length;
        for(i = 0; i < tokenLen; i++){
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) getParsingFlags(config).unusedInput.push(skipped);
                string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) getParsingFlags(config).empty = false;
                else getParsingFlags(config).unusedTokens.push(token);
                addTimeToArrayFromToken(token, parsedInput, config);
            } else if (config._strict && !parsedInput) getParsingFlags(config).unusedTokens.push(token);
        }
        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
        if (string.length > 0) getParsingFlags(config).unusedInput.push(string);
        // clear _12h flag if hour is <= 12
        if (config._a[HOUR] <= 12 && getParsingFlags(config).bigHour === true && config._a[HOUR] > 0) getParsingFlags(config).bigHour = undefined;
        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);
        // handle era
        era = getParsingFlags(config).era;
        if (era !== null) config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
        configFromArray(config);
        checkOverflow(config);
    }
    function meridiemFixWrap(locale, hour, meridiem) {
        var isPm;
        if (meridiem == null) // nothing to do
        return hour;
        if (locale.meridiemHour != null) return locale.meridiemHour(hour, meridiem);
        else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) hour += 12;
            if (!isPm && hour === 12) hour = 0;
            return hour;
        } else // this is not supposed to happen
        return hour;
    }
    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig, bestMoment, scoreToBeat, i, currentScore, validFormatFound, bestFormatIsValid = false, configfLen = config._f.length;
        if (configfLen === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }
        for(i = 0; i < configfLen; i++){
            currentScore = 0;
            validFormatFound = false;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) tempConfig._useUTC = config._useUTC;
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);
            if (isValid(tempConfig)) validFormatFound = true;
            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;
            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
            getParsingFlags(tempConfig).score = currentScore;
            if (!bestFormatIsValid) {
                if (scoreToBeat == null || currentScore < scoreToBeat || validFormatFound) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                    if (validFormatFound) bestFormatIsValid = true;
                }
            } else if (currentScore < scoreToBeat) {
                scoreToBeat = currentScore;
                bestMoment = tempConfig;
            }
        }
        extend(config, bestMoment || tempConfig);
    }
    function configFromObject(config) {
        if (config._d) return;
        var i = normalizeObjectUnits(config._i), dayOrDate = i.day === undefined ? i.date : i.day;
        config._a = map([
            i.year,
            i.month,
            dayOrDate,
            i.hour,
            i.minute,
            i.second,
            i.millisecond
        ], function(obj) {
            return obj && parseInt(obj, 10);
        });
        configFromArray(config);
    }
    function createFromConfig(config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, "d");
            res._nextDay = undefined;
        }
        return res;
    }
    function prepareConfig(config) {
        var input = config._i, format = config._f;
        config._locale = config._locale || getLocale(config._l);
        if (input === null || format === undefined && input === "") return createInvalid({
            nullInput: true
        });
        if (typeof input === "string") config._i = input = config._locale.preparse(input);
        if (isMoment(input)) return new Moment(checkOverflow(input));
        else if (isDate(input)) config._d = input;
        else if (isArray(format)) configFromStringAndArray(config);
        else if (format) configFromStringAndFormat(config);
        else configFromInput(config);
        if (!isValid(config)) config._d = null;
        return config;
    }
    function configFromInput(config) {
        var input = config._i;
        if (isUndefined(input)) config._d = new Date(hooks.now());
        else if (isDate(input)) config._d = new Date(input.valueOf());
        else if (typeof input === "string") configFromString(config);
        else if (isArray(input)) {
            config._a = map(input.slice(0), function(obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (isObject(input)) configFromObject(config);
        else if (isNumber(input)) // from milliseconds
        config._d = new Date(input);
        else hooks.createFromInputFallback(config);
    }
    function createLocalOrUTC(input, format, locale, strict, isUTC) {
        var c = {};
        if (format === true || format === false) {
            strict = format;
            format = undefined;
        }
        if (locale === true || locale === false) {
            strict = locale;
            locale = undefined;
        }
        if (isObject(input) && isObjectEmpty(input) || isArray(input) && input.length === 0) input = undefined;
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;
        return createFromConfig(c);
    }
    function createLocal(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }
    var prototypeMin = deprecate("moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/", function() {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) return other < this ? this : other;
        else return createInvalid();
    }), prototypeMax = deprecate("moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/", function() {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) return other > this ? this : other;
        else return createInvalid();
    });
    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) moments = moments[0];
        if (!moments.length) return createLocal();
        res = moments[0];
        for(i = 1; i < moments.length; ++i)if (!moments[i].isValid() || moments[i][fn](res)) res = moments[i];
        return res;
    }
    // TODO: Use [].sort instead?
    function min() {
        var args = [].slice.call(arguments, 0);
        return pickBy("isBefore", args);
    }
    function max() {
        var args = [].slice.call(arguments, 0);
        return pickBy("isAfter", args);
    }
    var now = function() {
        return Date.now ? Date.now() : +new Date();
    };
    var ordering = [
        "year",
        "quarter",
        "month",
        "week",
        "day",
        "hour",
        "minute",
        "second",
        "millisecond"
    ];
    function isDurationValid(m) {
        var key, unitHasDecimal = false, i, orderLen = ordering.length;
        for(key in m){
            if (hasOwnProp(m, key) && !(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) return false;
        }
        for(i = 0; i < orderLen; ++i)if (m[ordering[i]]) {
            if (unitHasDecimal) return false; // only allow non-integers for smallest unit
            if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) unitHasDecimal = true;
        }
        return true;
    }
    function isValid$1() {
        return this._isValid;
    }
    function createInvalid$1() {
        return createDuration(NaN);
    }
    function Duration(duration) {
        var normalizedInput = normalizeObjectUnits(duration), years = normalizedInput.year || 0, quarters = normalizedInput.quarter || 0, months = normalizedInput.month || 0, weeks = normalizedInput.week || normalizedInput.isoWeek || 0, days = normalizedInput.day || 0, hours = normalizedInput.hour || 0, minutes = normalizedInput.minute || 0, seconds = normalizedInput.second || 0, milliseconds = normalizedInput.millisecond || 0;
        this._isValid = isDurationValid(normalizedInput);
        // representation for dateAddRemove
        this._milliseconds = +milliseconds + seconds * 1e3 + // 1000
        minutes * 6e4 + // 1000 * 60
        hours * 3600000; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days + weeks * 7;
        // It is impossible to translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months + quarters * 3 + years * 12;
        this._data = {};
        this._locale = getLocale();
        this._bubble();
    }
    function isDuration(obj) {
        return obj instanceof Duration;
    }
    function absRound(number) {
        if (number < 0) return Math.round(-1 * number) * -1;
        else return Math.round(number);
    }
    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length), lengthDiff = Math.abs(array1.length - array2.length), diffs = 0, i;
        for(i = 0; i < len; i++)if (dontConvert && array1[i] !== array2[i] || !dontConvert && toInt(array1[i]) !== toInt(array2[i])) diffs++;
        return diffs + lengthDiff;
    }
    // FORMATTING
    function offset(token, separator) {
        addFormatToken(token, 0, 0, function() {
            var offset = this.utcOffset(), sign = "+";
            if (offset < 0) {
                offset = -offset;
                sign = "-";
            }
            return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~offset % 60, 2);
        });
    }
    offset("Z", ":");
    offset("ZZ", "");
    // PARSING
    addRegexToken("Z", matchShortOffset);
    addRegexToken("ZZ", matchShortOffset);
    addParseToken([
        "Z",
        "ZZ"
    ], function(input, array, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(matchShortOffset, input);
    });
    // HELPERS
    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;
    function offsetFromString(matcher, string) {
        var matches = (string || "").match(matcher), chunk, parts, minutes;
        if (matches === null) return null;
        chunk = matches[matches.length - 1] || [];
        parts = (chunk + "").match(chunkOffset) || [
            "-",
            0,
            0
        ];
        minutes = +(parts[1] * 60) + toInt(parts[2]);
        return minutes === 0 ? 0 : parts[0] === "+" ? minutes : -minutes;
    }
    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(res._d.valueOf() + diff);
            hooks.updateOffset(res, false);
            return res;
        } else return createLocal(input).local();
    }
    function getDateOffset(m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset());
    }
    // HOOKS
    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    hooks.updateOffset = function() {};
    // MOMENTS
    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset(input, keepLocalTime, keepMinutes) {
        var offset = this._offset || 0, localAdjust;
        if (!this.isValid()) return input != null ? this : NaN;
        if (input != null) {
            if (typeof input === "string") {
                input = offsetFromString(matchShortOffset, input);
                if (input === null) return this;
            } else if (Math.abs(input) < 16 && !keepMinutes) input = input * 60;
            if (!this._isUTC && keepLocalTime) localAdjust = getDateOffset(this);
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) this.add(localAdjust, "m");
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) addSubtract(this, createDuration(input - offset, "m"), 1, false);
                else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else return this._isUTC ? offset : getDateOffset(this);
    }
    function getSetZone(input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== "string") input = -input;
            this.utcOffset(input, keepLocalTime);
            return this;
        } else return -this.utcOffset();
    }
    function setOffsetToUTC(keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }
    function setOffsetToLocal(keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;
            if (keepLocalTime) this.subtract(getDateOffset(this), "m");
        }
        return this;
    }
    function setOffsetToParsedOffset() {
        if (this._tzm != null) this.utcOffset(this._tzm, false, true);
        else if (typeof this._i === "string") {
            var tZone = offsetFromString(matchOffset, this._i);
            if (tZone != null) this.utcOffset(tZone);
            else this.utcOffset(0, true);
        }
        return this;
    }
    function hasAlignedHourOffset(input) {
        if (!this.isValid()) return false;
        input = input ? createLocal(input).utcOffset() : 0;
        return (this.utcOffset() - input) % 60 === 0;
    }
    function isDaylightSavingTime() {
        return this.utcOffset() > this.clone().month(0).utcOffset() || this.utcOffset() > this.clone().month(5).utcOffset();
    }
    function isDaylightSavingTimeShifted() {
        if (!isUndefined(this._isDSTShifted)) return this._isDSTShifted;
        var c = {}, other;
        copyConfig(c, this);
        c = prepareConfig(c);
        if (c._a) {
            other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
            this._isDSTShifted = this.isValid() && compareArrays(c._a, other.toArray()) > 0;
        } else this._isDSTShifted = false;
        return this._isDSTShifted;
    }
    function isLocal() {
        return this.isValid() ? !this._isUTC : false;
    }
    function isUtcOffset() {
        return this.isValid() ? this._isUTC : false;
    }
    function isUtc() {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }
    // ASP.NET json date format regex
    var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/, // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
    // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
    // and further modified to allow for strings containing both week and day
    isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
    function createDuration(input, key) {
        var duration = input, // matching against regexp is expensive, do it on demand
        match = null, sign, ret, diffRes;
        if (isDuration(input)) duration = {
            ms: input._milliseconds,
            d: input._days,
            M: input._months
        };
        else if (isNumber(input) || !isNaN(+input)) {
            duration = {};
            if (key) duration[key] = +input;
            else duration.milliseconds = +input;
        } else if (match = aspNetRegex.exec(input)) {
            sign = match[1] === "-" ? -1 : 1;
            duration = {
                y: 0,
                d: toInt(match[DATE]) * sign,
                h: toInt(match[HOUR]) * sign,
                m: toInt(match[MINUTE]) * sign,
                s: toInt(match[SECOND]) * sign,
                ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign
            };
        } else if (match = isoRegex.exec(input)) {
            sign = match[1] === "-" ? -1 : 1;
            duration = {
                y: parseIso(match[2], sign),
                M: parseIso(match[3], sign),
                w: parseIso(match[4], sign),
                d: parseIso(match[5], sign),
                h: parseIso(match[6], sign),
                m: parseIso(match[7], sign),
                s: parseIso(match[8], sign)
            };
        } else if (duration == null) // checks for null or undefined
        duration = {};
        else if (typeof duration === "object" && ("from" in duration || "to" in duration)) {
            diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));
            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }
        ret = new Duration(duration);
        if (isDuration(input) && hasOwnProp(input, "_locale")) ret._locale = input._locale;
        if (isDuration(input) && hasOwnProp(input, "_isValid")) ret._isValid = input._isValid;
        return ret;
    }
    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid$1;
    function parseIso(inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(",", "."));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }
    function positiveMomentsDifference(base, other) {
        var res = {};
        res.months = other.month() - base.month() + (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, "M").isAfter(other)) --res.months;
        res.milliseconds = +other - +base.clone().add(res.months, "M");
        return res;
    }
    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) return {
            milliseconds: 0,
            months: 0
        };
        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) res = positiveMomentsDifference(base, other);
        else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }
        return res;
    }
    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function(val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(name, "moment()." + name + "(period, number) is deprecated. Please use moment()." + name + "(number, period). " + "See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.");
                tmp = val;
                val = period;
                period = tmp;
            }
            dur = createDuration(val, period);
            addSubtract(this, dur, direction);
            return this;
        };
    }
    function addSubtract(mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds, days = absRound(duration._days), months = absRound(duration._months);
        if (!mom.isValid()) // No op
        return;
        updateOffset = updateOffset == null ? true : updateOffset;
        if (months) setMonth(mom, get(mom, "Month") + months * isAdding);
        if (days) set$1(mom, "Date", get(mom, "Date") + days * isAdding);
        if (milliseconds) mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        if (updateOffset) hooks.updateOffset(mom, days || months);
    }
    var add = createAdder(1, "add"), subtract = createAdder(-1, "subtract");
    function isString(input) {
        return typeof input === "string" || input instanceof String;
    }
    // type MomentInput = Moment | Date | string | number | (number | string)[] | MomentInputObject | void; // null | undefined
    function isMomentInput(input) {
        return isMoment(input) || isDate(input) || isString(input) || isNumber(input) || isNumberOrStringArray(input) || isMomentInputObject(input) || input === null || input === undefined;
    }
    function isMomentInputObject(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input), propertyTest = false, properties = [
            "years",
            "year",
            "y",
            "months",
            "month",
            "M",
            "days",
            "day",
            "d",
            "dates",
            "date",
            "D",
            "hours",
            "hour",
            "h",
            "minutes",
            "minute",
            "m",
            "seconds",
            "second",
            "s",
            "milliseconds",
            "millisecond",
            "ms"
        ], i, property, propertyLen = properties.length;
        for(i = 0; i < propertyLen; i += 1){
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }
        return objectTest && propertyTest;
    }
    function isNumberOrStringArray(input) {
        var arrayTest = isArray(input), dataTypeTest = false;
        if (arrayTest) dataTypeTest = input.filter(function(item) {
            return !isNumber(item) && isString(input);
        }).length === 0;
        return arrayTest && dataTypeTest;
    }
    function isCalendarSpec(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input), propertyTest = false, properties = [
            "sameDay",
            "nextDay",
            "lastDay",
            "nextWeek",
            "lastWeek",
            "sameElse"
        ], i, property;
        for(i = 0; i < properties.length; i += 1){
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }
        return objectTest && propertyTest;
    }
    function getCalendarFormat(myMoment, now) {
        var diff = myMoment.diff(now, "days", true);
        return diff < -6 ? "sameElse" : diff < -1 ? "lastWeek" : diff < 0 ? "lastDay" : diff < 1 ? "sameDay" : diff < 2 ? "nextDay" : diff < 7 ? "nextWeek" : "sameElse";
    }
    function calendar$1(time, formats) {
        // Support for single parameter, formats only overload to the calendar function
        if (arguments.length === 1) {
            if (!arguments[0]) {
                time = undefined;
                formats = undefined;
            } else if (isMomentInput(arguments[0])) {
                time = arguments[0];
                formats = undefined;
            } else if (isCalendarSpec(arguments[0])) {
                formats = arguments[0];
                time = undefined;
            }
        }
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || createLocal(), sod = cloneWithOffset(now, this).startOf("day"), format = hooks.calendarFormat(this, sod) || "sameElse", output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);
        return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
    }
    function clone() {
        return new Moment(this);
    }
    function isAfter(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || "millisecond";
        if (units === "millisecond") return this.valueOf() > localInput.valueOf();
        else return localInput.valueOf() < this.clone().startOf(units).valueOf();
    }
    function isBefore(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || "millisecond";
        if (units === "millisecond") return this.valueOf() < localInput.valueOf();
        else return this.clone().endOf(units).valueOf() < localInput.valueOf();
    }
    function isBetween(from, to, units, inclusivity) {
        var localFrom = isMoment(from) ? from : createLocal(from), localTo = isMoment(to) ? to : createLocal(to);
        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) return false;
        inclusivity = inclusivity || "()";
        return (inclusivity[0] === "(" ? this.isAfter(localFrom, units) : !this.isBefore(localFrom, units)) && (inclusivity[1] === ")" ? this.isBefore(localTo, units) : !this.isAfter(localTo, units));
    }
    function isSame(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input), inputMs;
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || "millisecond";
        if (units === "millisecond") return this.valueOf() === localInput.valueOf();
        else {
            inputMs = localInput.valueOf();
            return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
        }
    }
    function isSameOrAfter(input, units) {
        return this.isSame(input, units) || this.isAfter(input, units);
    }
    function isSameOrBefore(input, units) {
        return this.isSame(input, units) || this.isBefore(input, units);
    }
    function diff(input, units, asFloat) {
        var that, zoneDelta, output;
        if (!this.isValid()) return NaN;
        that = cloneWithOffset(input, this);
        if (!that.isValid()) return NaN;
        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
        units = normalizeUnits(units);
        switch(units){
            case "year":
                output = monthDiff(this, that) / 12;
                break;
            case "month":
                output = monthDiff(this, that);
                break;
            case "quarter":
                output = monthDiff(this, that) / 3;
                break;
            case "second":
                output = (this - that) / 1e3;
                break; // 1000
            case "minute":
                output = (this - that) / 6e4;
                break; // 1000 * 60
            case "hour":
                output = (this - that) / 36e5;
                break; // 1000 * 60 * 60
            case "day":
                output = (this - that - zoneDelta) / 864e5;
                break; // 1000 * 60 * 60 * 24, negate dst
            case "week":
                output = (this - that - zoneDelta) / 6048e5;
                break; // 1000 * 60 * 60 * 24 * 7, negate dst
            default:
                output = this - that;
        }
        return asFloat ? output : absFloor(output);
    }
    function monthDiff(a, b) {
        if (a.date() < b.date()) // end-of-month calculations work correct when the start month has more
        // days than the end month.
        return -monthDiff(b, a);
        // difference in months
        var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()), // b is in (anchor - 1 month, anchor + 1 month)
        anchor = a.clone().add(wholeMonthDiff, "months"), anchor2, adjust;
        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, "months");
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, "months");
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }
        //check for negative zero, return zero if negative zero
        return -(wholeMonthDiff + adjust) || 0;
    }
    hooks.defaultFormat = "YYYY-MM-DDTHH:mm:ssZ";
    hooks.defaultFormatUtc = "YYYY-MM-DDTHH:mm:ss[Z]";
    function toString() {
        return this.clone().locale("en").format("ddd MMM DD YYYY HH:mm:ss [GMT]ZZ");
    }
    function toISOString(keepOffset) {
        if (!this.isValid()) return null;
        var utc = keepOffset !== true, m = utc ? this.clone().utc() : this;
        if (m.year() < 0 || m.year() > 9999) return formatMoment(m, utc ? "YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYYYY-MM-DD[T]HH:mm:ss.SSSZ");
        if (isFunction(Date.prototype.toISOString)) {
            // native implementation is ~50x faster, use it when we can
            if (utc) return this.toDate().toISOString();
            else return new Date(this.valueOf() + this.utcOffset() * 60000).toISOString().replace("Z", formatMoment(m, "Z"));
        }
        return formatMoment(m, utc ? "YYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYY-MM-DD[T]HH:mm:ss.SSSZ");
    }
    /**
     * Return a human readable representation of a moment that can
     * also be evaluated to get a new moment which is the same
     *
     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
     */ function inspect() {
        if (!this.isValid()) return "moment.invalid(/* " + this._i + " */)";
        var func = "moment", zone = "", prefix, year, datetime, suffix;
        if (!this.isLocal()) {
            func = this.utcOffset() === 0 ? "moment.utc" : "moment.parseZone";
            zone = "Z";
        }
        prefix = "[" + func + '("]';
        year = 0 <= this.year() && this.year() <= 9999 ? "YYYY" : "YYYYYY";
        datetime = "-MM-DD[T]HH:mm:ss.SSS";
        suffix = zone + '[")]';
        return this.format(prefix + year + datetime + suffix);
    }
    function format(inputString) {
        if (!inputString) inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }
    function from(time, withoutSuffix) {
        if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) return createDuration({
            to: this,
            from: time
        }).locale(this.locale()).humanize(!withoutSuffix);
        else return this.localeData().invalidDate();
    }
    function fromNow(withoutSuffix) {
        return this.from(createLocal(), withoutSuffix);
    }
    function to(time, withoutSuffix) {
        if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) return createDuration({
            from: this,
            to: time
        }).locale(this.locale()).humanize(!withoutSuffix);
        else return this.localeData().invalidDate();
    }
    function toNow(withoutSuffix) {
        return this.to(createLocal(), withoutSuffix);
    }
    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale(key) {
        var newLocaleData;
        if (key === undefined) return this._locale._abbr;
        else {
            newLocaleData = getLocale(key);
            if (newLocaleData != null) this._locale = newLocaleData;
            return this;
        }
    }
    var lang = deprecate("moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.", function(key) {
        if (key === undefined) return this.localeData();
        else return this.locale(key);
    });
    function localeData() {
        return this._locale;
    }
    var MS_PER_SECOND = 1000, MS_PER_MINUTE = 60 * MS_PER_SECOND, MS_PER_HOUR = 60 * MS_PER_MINUTE, MS_PER_400_YEARS = 3506328 * MS_PER_HOUR;
    // actual modulo - handles negative numbers (for dates before 1970):
    function mod$1(dividend, divisor) {
        return (dividend % divisor + divisor) % divisor;
    }
    function localStartOfDate(y, m, d) {
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) // preserve leap years using a full 400 year cycle, then reset
        return new Date(y + 400, m, d) - MS_PER_400_YEARS;
        else return new Date(y, m, d).valueOf();
    }
    function utcStartOfDate(y, m, d) {
        // Date.UTC remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) // preserve leap years using a full 400 year cycle, then reset
        return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
        else return Date.UTC(y, m, d);
    }
    function startOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === "millisecond" || !this.isValid()) return this;
        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
        switch(units){
            case "year":
                time = startOfDate(this.year(), 0, 1);
                break;
            case "quarter":
                time = startOfDate(this.year(), this.month() - this.month() % 3, 1);
                break;
            case "month":
                time = startOfDate(this.year(), this.month(), 1);
                break;
            case "week":
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday());
                break;
            case "isoWeek":
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1));
                break;
            case "day":
            case "date":
                time = startOfDate(this.year(), this.month(), this.date());
                break;
            case "hour":
                time = this._d.valueOf();
                time -= mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR);
                break;
            case "minute":
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_MINUTE);
                break;
            case "second":
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_SECOND);
                break;
        }
        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }
    function endOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === "millisecond" || !this.isValid()) return this;
        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
        switch(units){
            case "year":
                time = startOfDate(this.year() + 1, 0, 1) - 1;
                break;
            case "quarter":
                time = startOfDate(this.year(), this.month() - this.month() % 3 + 3, 1) - 1;
                break;
            case "month":
                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
                break;
            case "week":
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday() + 7) - 1;
                break;
            case "isoWeek":
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1) + 7) - 1;
                break;
            case "day":
            case "date":
                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
                break;
            case "hour":
                time = this._d.valueOf();
                time += MS_PER_HOUR - mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR) - 1;
                break;
            case "minute":
                time = this._d.valueOf();
                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
                break;
            case "second":
                time = this._d.valueOf();
                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
                break;
        }
        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }
    function valueOf() {
        return this._d.valueOf() - (this._offset || 0) * 60000;
    }
    function unix() {
        return Math.floor(this.valueOf() / 1000);
    }
    function toDate() {
        return new Date(this.valueOf());
    }
    function toArray() {
        var m = this;
        return [
            m.year(),
            m.month(),
            m.date(),
            m.hour(),
            m.minute(),
            m.second(),
            m.millisecond()
        ];
    }
    function toObject() {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds()
        };
    }
    function toJSON() {
        // new Date(NaN).toJSON() === null
        return this.isValid() ? this.toISOString() : null;
    }
    function isValid$2() {
        return isValid(this);
    }
    function parsingFlags() {
        return extend({}, getParsingFlags(this));
    }
    function invalidAt() {
        return getParsingFlags(this).overflow;
    }
    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict
        };
    }
    addFormatToken("N", 0, 0, "eraAbbr");
    addFormatToken("NN", 0, 0, "eraAbbr");
    addFormatToken("NNN", 0, 0, "eraAbbr");
    addFormatToken("NNNN", 0, 0, "eraName");
    addFormatToken("NNNNN", 0, 0, "eraNarrow");
    addFormatToken("y", [
        "y",
        1
    ], "yo", "eraYear");
    addFormatToken("y", [
        "yy",
        2
    ], 0, "eraYear");
    addFormatToken("y", [
        "yyy",
        3
    ], 0, "eraYear");
    addFormatToken("y", [
        "yyyy",
        4
    ], 0, "eraYear");
    addRegexToken("N", matchEraAbbr);
    addRegexToken("NN", matchEraAbbr);
    addRegexToken("NNN", matchEraAbbr);
    addRegexToken("NNNN", matchEraName);
    addRegexToken("NNNNN", matchEraNarrow);
    addParseToken([
        "N",
        "NN",
        "NNN",
        "NNNN",
        "NNNNN"
    ], function(input, array, config, token) {
        var era = config._locale.erasParse(input, token, config._strict);
        if (era) getParsingFlags(config).era = era;
        else getParsingFlags(config).invalidEra = input;
    });
    addRegexToken("y", matchUnsigned);
    addRegexToken("yy", matchUnsigned);
    addRegexToken("yyy", matchUnsigned);
    addRegexToken("yyyy", matchUnsigned);
    addRegexToken("yo", matchEraYearOrdinal);
    addParseToken([
        "y",
        "yy",
        "yyy",
        "yyyy"
    ], YEAR);
    addParseToken([
        "yo"
    ], function(input, array, config, token) {
        var match;
        if (config._locale._eraYearOrdinalRegex) match = input.match(config._locale._eraYearOrdinalRegex);
        if (config._locale.eraYearOrdinalParse) array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
        else array[YEAR] = parseInt(input, 10);
    });
    function localeEras(m, format) {
        var i, l, date, eras = this._eras || getLocale("en")._eras;
        for(i = 0, l = eras.length; i < l; ++i){
            switch(typeof eras[i].since){
                case "string":
                    // truncate time
                    date = hooks(eras[i].since).startOf("day");
                    eras[i].since = date.valueOf();
                    break;
            }
            switch(typeof eras[i].until){
                case "undefined":
                    eras[i].until = Infinity;
                    break;
                case "string":
                    // truncate time
                    date = hooks(eras[i].until).startOf("day").valueOf();
                    eras[i].until = date.valueOf();
                    break;
            }
        }
        return eras;
    }
    function localeErasParse(eraName, format, strict) {
        var i, l, eras = this.eras(), name, abbr, narrow;
        eraName = eraName.toUpperCase();
        for(i = 0, l = eras.length; i < l; ++i){
            name = eras[i].name.toUpperCase();
            abbr = eras[i].abbr.toUpperCase();
            narrow = eras[i].narrow.toUpperCase();
            if (strict) switch(format){
                case "N":
                case "NN":
                case "NNN":
                    if (abbr === eraName) return eras[i];
                    break;
                case "NNNN":
                    if (name === eraName) return eras[i];
                    break;
                case "NNNNN":
                    if (narrow === eraName) return eras[i];
                    break;
            }
            else if ([
                name,
                abbr,
                narrow
            ].indexOf(eraName) >= 0) return eras[i];
        }
    }
    function localeErasConvertYear(era, year) {
        var dir = era.since <= era.until ? 1 : -1;
        if (year === undefined) return hooks(era.since).year();
        else return hooks(era.since).year() + (year - era.offset) * dir;
    }
    function getEraName() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf("day").valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].name;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].name;
        }
        return "";
    }
    function getEraNarrow() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf("day").valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].narrow;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].narrow;
        }
        return "";
    }
    function getEraAbbr() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf("day").valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].abbr;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].abbr;
        }
        return "";
    }
    function getEraYear() {
        var i, l, dir, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            dir = eras[i].since <= eras[i].until ? 1 : -1;
            // truncate time
            val = this.clone().startOf("day").valueOf();
            if (eras[i].since <= val && val <= eras[i].until || eras[i].until <= val && val <= eras[i].since) return (this.year() - hooks(eras[i].since).year()) * dir + eras[i].offset;
        }
        return this.year();
    }
    function erasNameRegex(isStrict) {
        if (!hasOwnProp(this, "_erasNameRegex")) computeErasParse.call(this);
        return isStrict ? this._erasNameRegex : this._erasRegex;
    }
    function erasAbbrRegex(isStrict) {
        if (!hasOwnProp(this, "_erasAbbrRegex")) computeErasParse.call(this);
        return isStrict ? this._erasAbbrRegex : this._erasRegex;
    }
    function erasNarrowRegex(isStrict) {
        if (!hasOwnProp(this, "_erasNarrowRegex")) computeErasParse.call(this);
        return isStrict ? this._erasNarrowRegex : this._erasRegex;
    }
    function matchEraAbbr(isStrict, locale) {
        return locale.erasAbbrRegex(isStrict);
    }
    function matchEraName(isStrict, locale) {
        return locale.erasNameRegex(isStrict);
    }
    function matchEraNarrow(isStrict, locale) {
        return locale.erasNarrowRegex(isStrict);
    }
    function matchEraYearOrdinal(isStrict, locale) {
        return locale._eraYearOrdinalRegex || matchUnsigned;
    }
    function computeErasParse() {
        var abbrPieces = [], namePieces = [], narrowPieces = [], mixedPieces = [], i, l, erasName, erasAbbr, erasNarrow, eras = this.eras();
        for(i = 0, l = eras.length; i < l; ++i){
            erasName = regexEscape(eras[i].name);
            erasAbbr = regexEscape(eras[i].abbr);
            erasNarrow = regexEscape(eras[i].narrow);
            namePieces.push(erasName);
            abbrPieces.push(erasAbbr);
            narrowPieces.push(erasNarrow);
            mixedPieces.push(erasName);
            mixedPieces.push(erasAbbr);
            mixedPieces.push(erasNarrow);
        }
        this._erasRegex = new RegExp("^(" + mixedPieces.join("|") + ")", "i");
        this._erasNameRegex = new RegExp("^(" + namePieces.join("|") + ")", "i");
        this._erasAbbrRegex = new RegExp("^(" + abbrPieces.join("|") + ")", "i");
        this._erasNarrowRegex = new RegExp("^(" + narrowPieces.join("|") + ")", "i");
    }
    // FORMATTING
    addFormatToken(0, [
        "gg",
        2
    ], 0, function() {
        return this.weekYear() % 100;
    });
    addFormatToken(0, [
        "GG",
        2
    ], 0, function() {
        return this.isoWeekYear() % 100;
    });
    function addWeekYearFormatToken(token, getter) {
        addFormatToken(0, [
            token,
            token.length
        ], 0, getter);
    }
    addWeekYearFormatToken("gggg", "weekYear");
    addWeekYearFormatToken("ggggg", "weekYear");
    addWeekYearFormatToken("GGGG", "isoWeekYear");
    addWeekYearFormatToken("GGGGG", "isoWeekYear");
    // ALIASES
    // PARSING
    addRegexToken("G", matchSigned);
    addRegexToken("g", matchSigned);
    addRegexToken("GG", match1to2, match2);
    addRegexToken("gg", match1to2, match2);
    addRegexToken("GGGG", match1to4, match4);
    addRegexToken("gggg", match1to4, match4);
    addRegexToken("GGGGG", match1to6, match6);
    addRegexToken("ggggg", match1to6, match6);
    addWeekParseToken([
        "gggg",
        "ggggg",
        "GGGG",
        "GGGGG"
    ], function(input, week, config, token) {
        week[token.substr(0, 2)] = toInt(input);
    });
    addWeekParseToken([
        "gg",
        "GG"
    ], function(input, week, config, token) {
        week[token] = hooks.parseTwoDigitYear(input);
    });
    // MOMENTS
    function getSetWeekYear(input) {
        return getSetWeekYearHelper.call(this, input, this.week(), this.weekday() + this.localeData()._week.dow, this.localeData()._week.dow, this.localeData()._week.doy);
    }
    function getSetISOWeekYear(input) {
        return getSetWeekYearHelper.call(this, input, this.isoWeek(), this.isoWeekday(), 1, 4);
    }
    function getISOWeeksInYear() {
        return weeksInYear(this.year(), 1, 4);
    }
    function getISOWeeksInISOWeekYear() {
        return weeksInYear(this.isoWeekYear(), 1, 4);
    }
    function getWeeksInYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }
    function getWeeksInWeekYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
    }
    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) return weekOfYear(this, dow, doy).year;
        else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) week = weeksTarget;
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }
    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy), date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }
    // FORMATTING
    addFormatToken("Q", 0, "Qo", "quarter");
    // PARSING
    addRegexToken("Q", match1);
    addParseToken("Q", function(input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });
    // MOMENTS
    function getSetQuarter(input) {
        return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
    }
    // FORMATTING
    addFormatToken("D", [
        "DD",
        2
    ], "Do", "date");
    // PARSING
    addRegexToken("D", match1to2, match1to2NoLeadingZero);
    addRegexToken("DD", match1to2, match2);
    addRegexToken("Do", function(isStrict, locale) {
        // TODO: Remove "ordinalParse" fallback in next major release.
        return isStrict ? locale._dayOfMonthOrdinalParse || locale._ordinalParse : locale._dayOfMonthOrdinalParseLenient;
    });
    addParseToken([
        "D",
        "DD"
    ], DATE);
    addParseToken("Do", function(input, array) {
        array[DATE] = toInt(input.match(match1to2)[0]);
    });
    // MOMENTS
    var getSetDayOfMonth = makeGetSet("Date", true);
    // FORMATTING
    addFormatToken("DDD", [
        "DDDD",
        3
    ], "DDDo", "dayOfYear");
    // PARSING
    addRegexToken("DDD", match1to3);
    addRegexToken("DDDD", match3);
    addParseToken([
        "DDD",
        "DDDD"
    ], function(input, array, config) {
        config._dayOfYear = toInt(input);
    });
    // HELPERS
    // MOMENTS
    function getSetDayOfYear(input) {
        var dayOfYear = Math.round((this.clone().startOf("day") - this.clone().startOf("year")) / 864e5) + 1;
        return input == null ? dayOfYear : this.add(input - dayOfYear, "d");
    }
    // FORMATTING
    addFormatToken("m", [
        "mm",
        2
    ], 0, "minute");
    // PARSING
    addRegexToken("m", match1to2, match1to2HasZero);
    addRegexToken("mm", match1to2, match2);
    addParseToken([
        "m",
        "mm"
    ], MINUTE);
    // MOMENTS
    var getSetMinute = makeGetSet("Minutes", false);
    // FORMATTING
    addFormatToken("s", [
        "ss",
        2
    ], 0, "second");
    // PARSING
    addRegexToken("s", match1to2, match1to2HasZero);
    addRegexToken("ss", match1to2, match2);
    addParseToken([
        "s",
        "ss"
    ], SECOND);
    // MOMENTS
    var getSetSecond = makeGetSet("Seconds", false);
    // FORMATTING
    addFormatToken("S", 0, 0, function() {
        return ~~(this.millisecond() / 100);
    });
    addFormatToken(0, [
        "SS",
        2
    ], 0, function() {
        return ~~(this.millisecond() / 10);
    });
    addFormatToken(0, [
        "SSS",
        3
    ], 0, "millisecond");
    addFormatToken(0, [
        "SSSS",
        4
    ], 0, function() {
        return this.millisecond() * 10;
    });
    addFormatToken(0, [
        "SSSSS",
        5
    ], 0, function() {
        return this.millisecond() * 100;
    });
    addFormatToken(0, [
        "SSSSSS",
        6
    ], 0, function() {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, [
        "SSSSSSS",
        7
    ], 0, function() {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, [
        "SSSSSSSS",
        8
    ], 0, function() {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, [
        "SSSSSSSSS",
        9
    ], 0, function() {
        return this.millisecond() * 1000000;
    });
    // PARSING
    addRegexToken("S", match1to3, match1);
    addRegexToken("SS", match1to3, match2);
    addRegexToken("SSS", match1to3, match3);
    var token, getSetMillisecond;
    for(token = "SSSS"; token.length <= 9; token += "S")addRegexToken(token, matchUnsigned);
    function parseMs(input, array) {
        array[MILLISECOND] = toInt(("0." + input) * 1000);
    }
    for(token = "S"; token.length <= 9; token += "S")addParseToken(token, parseMs);
    getSetMillisecond = makeGetSet("Milliseconds", false);
    // FORMATTING
    addFormatToken("z", 0, 0, "zoneAbbr");
    addFormatToken("zz", 0, 0, "zoneName");
    // MOMENTS
    function getZoneAbbr() {
        return this._isUTC ? "UTC" : "";
    }
    function getZoneName() {
        return this._isUTC ? "Coordinated Universal Time" : "";
    }
    var proto = Moment.prototype;
    proto.add = add;
    proto.calendar = calendar$1;
    proto.clone = clone;
    proto.diff = diff;
    proto.endOf = endOf;
    proto.format = format;
    proto.from = from;
    proto.fromNow = fromNow;
    proto.to = to;
    proto.toNow = toNow;
    proto.get = stringGet;
    proto.invalidAt = invalidAt;
    proto.isAfter = isAfter;
    proto.isBefore = isBefore;
    proto.isBetween = isBetween;
    proto.isSame = isSame;
    proto.isSameOrAfter = isSameOrAfter;
    proto.isSameOrBefore = isSameOrBefore;
    proto.isValid = isValid$2;
    proto.lang = lang;
    proto.locale = locale;
    proto.localeData = localeData;
    proto.max = prototypeMax;
    proto.min = prototypeMin;
    proto.parsingFlags = parsingFlags;
    proto.set = stringSet;
    proto.startOf = startOf;
    proto.subtract = subtract;
    proto.toArray = toArray;
    proto.toObject = toObject;
    proto.toDate = toDate;
    proto.toISOString = toISOString;
    proto.inspect = inspect;
    if (typeof Symbol !== "undefined" && Symbol.for != null) proto[Symbol.for("nodejs.util.inspect.custom")] = function() {
        return "Moment<" + this.format() + ">";
    };
    proto.toJSON = toJSON;
    proto.toString = toString;
    proto.unix = unix;
    proto.valueOf = valueOf;
    proto.creationData = creationData;
    proto.eraName = getEraName;
    proto.eraNarrow = getEraNarrow;
    proto.eraAbbr = getEraAbbr;
    proto.eraYear = getEraYear;
    proto.year = getSetYear;
    proto.isLeapYear = getIsLeapYear;
    proto.weekYear = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;
    proto.quarter = proto.quarters = getSetQuarter;
    proto.month = getSetMonth;
    proto.daysInMonth = getDaysInMonth;
    proto.week = proto.weeks = getSetWeek;
    proto.isoWeek = proto.isoWeeks = getSetISOWeek;
    proto.weeksInYear = getWeeksInYear;
    proto.weeksInWeekYear = getWeeksInWeekYear;
    proto.isoWeeksInYear = getISOWeeksInYear;
    proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
    proto.date = getSetDayOfMonth;
    proto.day = proto.days = getSetDayOfWeek;
    proto.weekday = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear = getSetDayOfYear;
    proto.hour = proto.hours = getSetHour;
    proto.minute = proto.minutes = getSetMinute;
    proto.second = proto.seconds = getSetSecond;
    proto.millisecond = proto.milliseconds = getSetMillisecond;
    proto.utcOffset = getSetOffset;
    proto.utc = setOffsetToUTC;
    proto.local = setOffsetToLocal;
    proto.parseZone = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST = isDaylightSavingTime;
    proto.isLocal = isLocal;
    proto.isUtcOffset = isUtcOffset;
    proto.isUtc = isUtc;
    proto.isUTC = isUtc;
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;
    proto.dates = deprecate("dates accessor is deprecated. Use date instead.", getSetDayOfMonth);
    proto.months = deprecate("months accessor is deprecated. Use month instead", getSetMonth);
    proto.years = deprecate("years accessor is deprecated. Use year instead", getSetYear);
    proto.zone = deprecate("moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/", getSetZone);
    proto.isDSTShifted = deprecate("isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information", isDaylightSavingTimeShifted);
    function createUnix(input) {
        return createLocal(input * 1000);
    }
    function createInZone() {
        return createLocal.apply(null, arguments).parseZone();
    }
    function preParsePostFormat(string) {
        return string;
    }
    var proto$1 = Locale.prototype;
    proto$1.calendar = calendar;
    proto$1.longDateFormat = longDateFormat;
    proto$1.invalidDate = invalidDate;
    proto$1.ordinal = ordinal;
    proto$1.preparse = preParsePostFormat;
    proto$1.postformat = preParsePostFormat;
    proto$1.relativeTime = relativeTime;
    proto$1.pastFuture = pastFuture;
    proto$1.set = set;
    proto$1.eras = localeEras;
    proto$1.erasParse = localeErasParse;
    proto$1.erasConvertYear = localeErasConvertYear;
    proto$1.erasAbbrRegex = erasAbbrRegex;
    proto$1.erasNameRegex = erasNameRegex;
    proto$1.erasNarrowRegex = erasNarrowRegex;
    proto$1.months = localeMonths;
    proto$1.monthsShort = localeMonthsShort;
    proto$1.monthsParse = localeMonthsParse;
    proto$1.monthsRegex = monthsRegex;
    proto$1.monthsShortRegex = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;
    proto$1.weekdays = localeWeekdays;
    proto$1.weekdaysMin = localeWeekdaysMin;
    proto$1.weekdaysShort = localeWeekdaysShort;
    proto$1.weekdaysParse = localeWeekdaysParse;
    proto$1.weekdaysRegex = weekdaysRegex;
    proto$1.weekdaysShortRegex = weekdaysShortRegex;
    proto$1.weekdaysMinRegex = weekdaysMinRegex;
    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;
    function get$1(format, index, field, setter) {
        var locale = getLocale(), utc = createUTC().set(setter, index);
        return locale[field](utc, format);
    }
    function listMonthsImpl(format, index, field) {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }
        format = format || "";
        if (index != null) return get$1(format, index, field, "month");
        var i, out = [];
        for(i = 0; i < 12; i++)out[i] = get$1(format, i, field, "month");
        return out;
    }
    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl(localeSorted, format, index, field) {
        if (typeof localeSorted === "boolean") {
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }
            format = format || "";
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }
            format = format || "";
        }
        var locale = getLocale(), shift = localeSorted ? locale._week.dow : 0, i, out = [];
        if (index != null) return get$1(format, (index + shift) % 7, field, "day");
        for(i = 0; i < 7; i++)out[i] = get$1(format, (i + shift) % 7, field, "day");
        return out;
    }
    function listMonths(format, index) {
        return listMonthsImpl(format, index, "months");
    }
    function listMonthsShort(format, index) {
        return listMonthsImpl(format, index, "monthsShort");
    }
    function listWeekdays(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, "weekdays");
    }
    function listWeekdaysShort(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, "weekdaysShort");
    }
    function listWeekdaysMin(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, "weekdaysMin");
    }
    getSetGlobalLocale("en", {
        eras: [
            {
                since: "0001-01-01",
                until: Infinity,
                offset: 1,
                name: "Anno Domini",
                narrow: "AD",
                abbr: "AD"
            },
            {
                since: "0000-12-31",
                until: -Infinity,
                offset: 1,
                name: "Before Christ",
                narrow: "BC",
                abbr: "BC"
            }
        ],
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal: function(number) {
            var b = number % 10, output = toInt(number % 100 / 10) === 1 ? "th" : b === 1 ? "st" : b === 2 ? "nd" : b === 3 ? "rd" : "th";
            return number + output;
        }
    });
    // Side effect imports
    hooks.lang = deprecate("moment.lang is deprecated. Use moment.locale instead.", getSetGlobalLocale);
    hooks.langData = deprecate("moment.langData is deprecated. Use moment.localeData instead.", getLocale);
    var mathAbs = Math.abs;
    function abs() {
        var data = this._data;
        this._milliseconds = mathAbs(this._milliseconds);
        this._days = mathAbs(this._days);
        this._months = mathAbs(this._months);
        data.milliseconds = mathAbs(data.milliseconds);
        data.seconds = mathAbs(data.seconds);
        data.minutes = mathAbs(data.minutes);
        data.hours = mathAbs(data.hours);
        data.months = mathAbs(data.months);
        data.years = mathAbs(data.years);
        return this;
    }
    function addSubtract$1(duration, input, value, direction) {
        var other = createDuration(input, value);
        duration._milliseconds += direction * other._milliseconds;
        duration._days += direction * other._days;
        duration._months += direction * other._months;
        return duration._bubble();
    }
    // supports only 2.0-style add(1, 's') or add(duration)
    function add$1(input, value) {
        return addSubtract$1(this, input, value, 1);
    }
    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function subtract$1(input, value) {
        return addSubtract$1(this, input, value, -1);
    }
    function absCeil(number) {
        if (number < 0) return Math.floor(number);
        else return Math.ceil(number);
    }
    function bubble() {
        var milliseconds = this._milliseconds, days = this._days, months = this._months, data = this._data, seconds, minutes, hours, years, monthsFromDays;
        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (!(milliseconds >= 0 && days >= 0 && months >= 0 || milliseconds <= 0 && days <= 0 && months <= 0)) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }
        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;
        seconds = absFloor(milliseconds / 1000);
        data.seconds = seconds % 60;
        minutes = absFloor(seconds / 60);
        data.minutes = minutes % 60;
        hours = absFloor(minutes / 60);
        data.hours = hours % 24;
        days += absFloor(hours / 24);
        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));
        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;
        data.days = days;
        data.months = months;
        data.years = years;
        return this;
    }
    function daysToMonths(days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return days * 4800 / 146097;
    }
    function monthsToDays(months) {
        // the reverse of daysToMonths
        return months * 146097 / 4800;
    }
    function as(units) {
        if (!this.isValid()) return NaN;
        var days, months, milliseconds = this._milliseconds;
        units = normalizeUnits(units);
        if (units === "month" || units === "quarter" || units === "year") {
            days = this._days + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            switch(units){
                case "month":
                    return months;
                case "quarter":
                    return months / 3;
                case "year":
                    return months / 12;
            }
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch(units){
                case "week":
                    return days / 7 + milliseconds / 6048e5;
                case "day":
                    return days + milliseconds / 864e5;
                case "hour":
                    return days * 24 + milliseconds / 36e5;
                case "minute":
                    return days * 1440 + milliseconds / 6e4;
                case "second":
                    return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case "millisecond":
                    return Math.floor(days * 864e5) + milliseconds;
                default:
                    throw new Error("Unknown unit " + units);
            }
        }
    }
    function makeAs(alias) {
        return function() {
            return this.as(alias);
        };
    }
    var asMilliseconds = makeAs("ms"), asSeconds = makeAs("s"), asMinutes = makeAs("m"), asHours = makeAs("h"), asDays = makeAs("d"), asWeeks = makeAs("w"), asMonths = makeAs("M"), asQuarters = makeAs("Q"), asYears = makeAs("y"), valueOf$1 = asMilliseconds;
    function clone$1() {
        return createDuration(this);
    }
    function get$2(units) {
        units = normalizeUnits(units);
        return this.isValid() ? this[units + "s"]() : NaN;
    }
    function makeGetter(name) {
        return function() {
            return this.isValid() ? this._data[name] : NaN;
        };
    }
    var milliseconds = makeGetter("milliseconds"), seconds = makeGetter("seconds"), minutes = makeGetter("minutes"), hours = makeGetter("hours"), days = makeGetter("days"), months = makeGetter("months"), years = makeGetter("years");
    function weeks() {
        return absFloor(this.days() / 7);
    }
    var round = Math.round, thresholds = {
        ss: 44,
        s: 45,
        m: 45,
        h: 22,
        d: 26,
        w: null,
        M: 11
    };
    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }
    function relativeTime$1(posNegDuration, withoutSuffix, thresholds, locale) {
        var duration = createDuration(posNegDuration).abs(), seconds = round(duration.as("s")), minutes = round(duration.as("m")), hours = round(duration.as("h")), days = round(duration.as("d")), months = round(duration.as("M")), weeks = round(duration.as("w")), years = round(duration.as("y")), a = seconds <= thresholds.ss && [
            "s",
            seconds
        ] || seconds < thresholds.s && [
            "ss",
            seconds
        ] || minutes <= 1 && [
            "m"
        ] || minutes < thresholds.m && [
            "mm",
            minutes
        ] || hours <= 1 && [
            "h"
        ] || hours < thresholds.h && [
            "hh",
            hours
        ] || days <= 1 && [
            "d"
        ] || days < thresholds.d && [
            "dd",
            days
        ];
        if (thresholds.w != null) a = a || weeks <= 1 && [
            "w"
        ] || weeks < thresholds.w && [
            "ww",
            weeks
        ];
        a = a || months <= 1 && [
            "M"
        ] || months < thresholds.M && [
            "MM",
            months
        ] || years <= 1 && [
            "y"
        ] || [
            "yy",
            years
        ];
        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }
    // This function allows you to set the rounding function for relative time strings
    function getSetRelativeTimeRounding(roundingFunction) {
        if (roundingFunction === undefined) return round;
        if (typeof roundingFunction === "function") {
            round = roundingFunction;
            return true;
        }
        return false;
    }
    // This function allows you to set a threshold for relative time strings
    function getSetRelativeTimeThreshold(threshold, limit) {
        if (thresholds[threshold] === undefined) return false;
        if (limit === undefined) return thresholds[threshold];
        thresholds[threshold] = limit;
        if (threshold === "s") thresholds.ss = limit - 1;
        return true;
    }
    function humanize(argWithSuffix, argThresholds) {
        if (!this.isValid()) return this.localeData().invalidDate();
        var withSuffix = false, th = thresholds, locale, output;
        if (typeof argWithSuffix === "object") {
            argThresholds = argWithSuffix;
            argWithSuffix = false;
        }
        if (typeof argWithSuffix === "boolean") withSuffix = argWithSuffix;
        if (typeof argThresholds === "object") {
            th = Object.assign({}, thresholds, argThresholds);
            if (argThresholds.s != null && argThresholds.ss == null) th.ss = argThresholds.s - 1;
        }
        locale = this.localeData();
        output = relativeTime$1(this, !withSuffix, th, locale);
        if (withSuffix) output = locale.pastFuture(+this, output);
        return locale.postformat(output);
    }
    var abs$1 = Math.abs;
    function sign(x) {
        return (x > 0) - (x < 0) || +x;
    }
    function toISOString$1() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        if (!this.isValid()) return this.localeData().invalidDate();
        var seconds = abs$1(this._milliseconds) / 1000, days = abs$1(this._days), months = abs$1(this._months), minutes, hours, years, s, total = this.asSeconds(), totalSign, ymSign, daysSign, hmsSign;
        if (!total) // this is the same as C#'s (Noda) and python (isodate)...
        // but not other JS (goog.date)
        return "P0D";
        // 3600 seconds -> 60 minutes -> 1 hour
        minutes = absFloor(seconds / 60);
        hours = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;
        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;
        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, "") : "";
        totalSign = total < 0 ? "-" : "";
        ymSign = sign(this._months) !== sign(total) ? "-" : "";
        daysSign = sign(this._days) !== sign(total) ? "-" : "";
        hmsSign = sign(this._milliseconds) !== sign(total) ? "-" : "";
        return totalSign + "P" + (years ? ymSign + years + "Y" : "") + (months ? ymSign + months + "M" : "") + (days ? daysSign + days + "D" : "") + (hours || minutes || seconds ? "T" : "") + (hours ? hmsSign + hours + "H" : "") + (minutes ? hmsSign + minutes + "M" : "") + (seconds ? hmsSign + s + "S" : "");
    }
    var proto$2 = Duration.prototype;
    proto$2.isValid = isValid$1;
    proto$2.abs = abs;
    proto$2.add = add$1;
    proto$2.subtract = subtract$1;
    proto$2.as = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds = asSeconds;
    proto$2.asMinutes = asMinutes;
    proto$2.asHours = asHours;
    proto$2.asDays = asDays;
    proto$2.asWeeks = asWeeks;
    proto$2.asMonths = asMonths;
    proto$2.asQuarters = asQuarters;
    proto$2.asYears = asYears;
    proto$2.valueOf = valueOf$1;
    proto$2._bubble = bubble;
    proto$2.clone = clone$1;
    proto$2.get = get$2;
    proto$2.milliseconds = milliseconds;
    proto$2.seconds = seconds;
    proto$2.minutes = minutes;
    proto$2.hours = hours;
    proto$2.days = days;
    proto$2.weeks = weeks;
    proto$2.months = months;
    proto$2.years = years;
    proto$2.humanize = humanize;
    proto$2.toISOString = toISOString$1;
    proto$2.toString = toISOString$1;
    proto$2.toJSON = toISOString$1;
    proto$2.locale = locale;
    proto$2.localeData = localeData;
    proto$2.toIsoString = deprecate("toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)", toISOString$1);
    proto$2.lang = lang;
    // FORMATTING
    addFormatToken("X", 0, 0, "unix");
    addFormatToken("x", 0, 0, "valueOf");
    // PARSING
    addRegexToken("x", matchSigned);
    addRegexToken("X", matchTimestamp);
    addParseToken("X", function(input, array, config) {
        config._d = new Date(parseFloat(input) * 1000);
    });
    addParseToken("x", function(input, array, config) {
        config._d = new Date(toInt(input));
    });
    //! moment.js
    hooks.version = "2.30.1";
    setHookCallback(createLocal);
    hooks.fn = proto;
    hooks.min = min;
    hooks.max = max;
    hooks.now = now;
    hooks.utc = createUTC;
    hooks.unix = createUnix;
    hooks.months = listMonths;
    hooks.isDate = isDate;
    hooks.locale = getSetGlobalLocale;
    hooks.invalid = createInvalid;
    hooks.duration = createDuration;
    hooks.isMoment = isMoment;
    hooks.weekdays = listWeekdays;
    hooks.parseZone = createInZone;
    hooks.localeData = getLocale;
    hooks.isDuration = isDuration;
    hooks.monthsShort = listMonthsShort;
    hooks.weekdaysMin = listWeekdaysMin;
    hooks.defineLocale = defineLocale;
    hooks.updateLocale = updateLocale;
    hooks.locales = listLocales;
    hooks.weekdaysShort = listWeekdaysShort;
    hooks.normalizeUnits = normalizeUnits;
    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat = getCalendarFormat;
    hooks.prototype = proto;
    // currently HTML5 input type only supports 24-hour formats
    hooks.HTML5_FMT = {
        DATETIME_LOCAL: "YYYY-MM-DDTHH:mm",
        DATETIME_LOCAL_SECONDS: "YYYY-MM-DDTHH:mm:ss",
        DATETIME_LOCAL_MS: "YYYY-MM-DDTHH:mm:ss.SSS",
        DATE: "YYYY-MM-DD",
        TIME: "HH:mm",
        TIME_SECONDS: "HH:mm:ss",
        TIME_MS: "HH:mm:ss.SSS",
        WEEK: "GGGG-[W]WW",
        MONTH: "YYYY-MM"
    };
    return hooks;
});

});




parcelRegister("kil2v", function(module, exports) {

$parcel$export(module.exports, "default", function () { return (parcelRequire("dggvN")).default; });

var $dggvN = parcelRequire("dggvN");

});
parcelRegister("dggvN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9cbd47d272312d2e$export$2e2bcd8739ae039; });

var $bibO8 = parcelRequire("bibO8");
parcelRequire("dAx5m");
parcelRequire("jQGCp");
var $7PWYP = parcelRequire("7PWYP");
parcelRequire("jShba");
var $1QRhz = parcelRequire("1QRhz");
function $9cbd47d272312d2e$var$mapStateToProps(rootState, ownProps) {
    const { user: user } = rootState;
    const { params: params } = ownProps;
    return {
        userId: params && params.userId ? params.userId : user.data && user.data.accountId
    };
}
function $9cbd47d272312d2e$export$2e2bcd8739ae039(WrappedComponent, options = {}) {
    const WithUserIdWrapper = (props)=>{
        const { userId: userId } = props;
        if (!userId) {
            if (options.loading === undefined) return /*#__PURE__*/ (0, $bibO8.jsx)((0, $1QRhz.default), {
                size: "medium",
                "data-testid": "loading-spinner"
            });
            else return /*#__PURE__*/ (0, $bibO8.jsx)((0, $bibO8.Fragment), {
                children: options.loading
            });
        }
        return /*#__PURE__*/ (0, $bibO8.jsx)(WrappedComponent, {
            ...props,
            userId: userId
        });
    };
    // @ts-expect-error i give up
    return (0, $7PWYP.default)($9cbd47d272312d2e$var$mapStateToProps)(WithUserIdWrapper);
}

});


parcelRegister("87zUj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e49cda55825c701a$export$2e2bcd8739ae039; });

var $bibO8 = parcelRequire("bibO8");
parcelRequire("dAx5m");

var $55TWT = parcelRequire("55TWT");
var $dZHnD = parcelRequire("dZHnD");

var $l06Mf = parcelRequire("l06Mf");

var $Ia2MJ = parcelRequire("Ia2MJ");

var $fhHY5 = parcelRequire("fhHY5");

var $hkAex = parcelRequire("hkAex");

var $jIOoq = parcelRequire("jIOoq");
var $hxi5h = parcelRequire("hxi5h");
parcelRequire("1afLa");
var $euho0 = parcelRequire("euho0");
parcelRequire("jShba");
var $1UxEK = parcelRequire("1UxEK");
const $e49cda55825c701a$export$612b007ca49617c8 = ({ isManaged: isManaged })=>{
    const { formatMessage: formatMessage } = (0, $dZHnD.default)();
    return /*#__PURE__*/ (0, $bibO8.jsxs)((0, $bibO8.Fragment), {
        children: [
            /*#__PURE__*/ (0, $bibO8.jsx)($hxi5h.SettingsSection, {
                children: /*#__PURE__*/ (0, $bibO8.jsx)($hxi5h.SettingsDescription, {
                    children: /*#__PURE__*/ (0, $bibO8.jsx)((0, $55TWT.default), {
                        tagName: "h3",
                        id: "ptc-directory.settings.close-account.heading",
                        defaultMessage: "Delete your account",
                        description: 'Title for the "Delete account" settings screen'
                    })
                })
            }),
            /*#__PURE__*/ (0, $bibO8.jsx)($hxi5h.SettingsSection, {
                children: isManaged ? /*#__PURE__*/ (0, $bibO8.jsxs)((0, $l06Mf.default), {
                    appearance: "warning",
                    children: [
                        /*#__PURE__*/ (0, $bibO8.jsx)($jIOoq.SectionMessageTitle, {
                            children: /*#__PURE__*/ (0, $bibO8.jsx)((0, $55TWT.default), {
                                id: "ptc-directory.settings.section-message.title",
                                defaultMessage: "Your account is managed",
                                description: "Title for the section message for managed user"
                            })
                        }),
                        /*#__PURE__*/ (0, $bibO8.jsx)((0, $55TWT.default), {
                            id: "ptc-directory.settings.section-message.description",
                            defaultMessage: "You can't deactivate or delete your Atlassian account because it's owned and managed by an organization. Contact your organization's admin for assistance.",
                            description: "Description for the section message for managed user",
                            tagName: "p"
                        }),
                        /*#__PURE__*/ (0, $bibO8.jsx)("p", {
                            children: /*#__PURE__*/ (0, $bibO8.jsx)((0, $1UxEK.default), {
                                target: "_blank",
                                href: "https://confluence.atlassian.com/cloud/delete-your-account-976161188.html",
                                children: /*#__PURE__*/ (0, $bibO8.jsx)((0, $55TWT.default), {
                                    id: "ptc-directory.settings.close-account.learnmore",
                                    defaultMessage: "Learn more",
                                    description: "Hyperlink label for learn more"
                                })
                            })
                        })
                    ]
                }) : /*#__PURE__*/ (0, $bibO8.jsxs)((0, $bibO8.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $bibO8.jsx)((0, $55TWT.default), {
                            tagName: "p",
                            id: "ptc-directory.settings.close-account.detailed.message",
                            defaultMessage: "When you delete your account, you lose access to Atlassian account services, and we permanently delete your personal data. You can cancel the deletion within 14 days.",
                            description: 'Detailed message on "Delete account" screen'
                        }),
                        /*#__PURE__*/ (0, $bibO8.jsx)("br", {}),
                        /*#__PURE__*/ (0, $bibO8.jsxs)((0, $Ia2MJ.default), {
                            children: [
                                /*#__PURE__*/ (0, $bibO8.jsx)((0, $euho0.default), {}),
                                /*#__PURE__*/ (0, $bibO8.jsx)((0, $fhHY5.default), {
                                    appearance: "link",
                                    target: "_blank",
                                    href: "https://confluence.atlassian.com/x/pAkvOg",
                                    iconAfter: /*#__PURE__*/ (0, $bibO8.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hkAex))), {
                                        label: formatMessage({
                                            id: "ptc-directory.settings.close-account.learnmore",
                                            defaultMessage: "Learn more",
                                            description: "Hyperlink label for learn more"
                                        }),
                                        size: "small"
                                    }),
                                    children: /*#__PURE__*/ (0, $bibO8.jsx)((0, $55TWT.default), {
                                        id: "ptc-directory.settings.close-account.learnmore",
                                        defaultMessage: "Learn more",
                                        description: "Hyperlink label for learn more"
                                    })
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
var $e49cda55825c701a$export$2e2bcd8739ae039 = $e49cda55825c701a$export$612b007ca49617c8;

});
parcelRegister("l06Mf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f49edada85673f36$export$2e2bcd8739ae039; });

var $dAx5m = parcelRequire("dAx5m");

var $kegKO = parcelRequire("kegKO");

var $1UvUH = parcelRequire("1UvUH");
var $6hOx2 = parcelRequire("6hOx2");
var $6rPY8 = parcelRequire("6rPY8");
var $4UPjW = parcelRequire("4UPjW");
var $bLE1l = parcelRequire("bLE1l");

var $3XhKI = parcelRequire("3XhKI");
var $f49edada85673f36$var$sectionMessageStyles = (0, $bLE1l.xcss)({
    wordBreak: "break-word",
    borderRadius: "border.radius"
});
var $f49edada85673f36$var$bleedStyles = (0, $bLE1l.xcss)({
    display: "flex",
    marginBlock: "space.negative.025"
});
/**
 * __Section message__
 *
 * A section message is used to alert users to a particular section of the screen.
 *
 * - [Examples](https://atlassian.design/components/section-message/examples)
 * - [Code](https://atlassian.design/components/section-message/code)
 * - [Usage](https://atlassian.design/components/section-message/usage)
 */ var $f49edada85673f36$var$SectionMessage = /*#__PURE__*/ (0, $dAx5m.forwardRef)(function SectionMessage(_ref, ref) {
    var children = _ref.children, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "information" : _ref$appearance, actions = _ref.actions, title = _ref.title, icon = _ref.icon, testId = _ref.testId;
    var _getAppearanceIconSty = (0, $3XhKI.getAppearanceIconStyles)(appearance, icon), primaryColor = _getAppearanceIconSty.primaryIconColor, secondaryColor = _getAppearanceIconSty.backgroundColor, Icon = _getAppearanceIconSty.Icon;
    var actionElements = actions && actions.type === (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).Fragment ? actions.props.children : actions;
    var actionsArray = (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).Children.toArray(actionElements);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $1UvUH.default), {
        as: "section",
        backgroundColor: $f49edada85673f36$var$appearanceMap[appearance],
        padding: "space.200",
        testId: testId,
        ref: ref,
        xcss: $f49edada85673f36$var$sectionMessageStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $6hOx2.default), {
        space: "space.200",
        alignBlock: "stretch"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $1UvUH.default), {
        xcss: $f49edada85673f36$var$bleedStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement(Icon, {
        size: "medium",
        primaryColor: primaryColor,
        secondaryColor: secondaryColor
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $6rPY8.default), {
        space: "space.100",
        testId: testId && "".concat(testId, "--content")
    }, !!title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $kegKO.default), {
        as: "h2",
        level: "h500"
    }, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $4UPjW.default), null, children), actionsArray.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $6hOx2.default), {
        shouldWrap: true,
        testId: testId && "".concat(testId, "--actions"),
        separator: "\xb7",
        space: "space.100",
        rowSpace: "space.0"
    }, actionsArray))));
});
var $f49edada85673f36$var$appearanceMap = {
    information: "color.background.information",
    warning: "color.background.warning",
    error: "color.background.danger",
    success: "color.background.success",
    discovery: "color.background.discovery"
};
$f49edada85673f36$var$SectionMessage.displayName = "SectionMessage";
var $f49edada85673f36$export$2e2bcd8739ae039 = $f49edada85673f36$var$SectionMessage;

});
parcelRegister("kegKO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $eba21c75bad96b5d$export$2e2bcd8739ae039; });

var $gpRqE = parcelRequire("gpRqE");

var $i77m2 = parcelRequire("i77m2");

var $6SC0T = parcelRequire("6SC0T");

var $jVTBW = parcelRequire("jVTBW");

var $fRXi1 = parcelRequire("fRXi1");

var $1wKlZ = parcelRequire("1wKlZ");

var $ahJoN = parcelRequire("ahJoN");
var $eba21c75bad96b5d$var$_excluded = [
    "level"
];
// https://atlassian.design/foundations/typography
var $eba21c75bad96b5d$var$levelMap = {
    h900: "h1",
    h800: "h1",
    h700: "h2",
    h600: "h3",
    h500: "h4",
    h400: "h5",
    h300: "h6",
    // NB: These two levels are not covered at all by the existing @atlaskit/css-reset
    h200: "div",
    h100: "div"
};
var $eba21c75bad96b5d$var$headingResetStyles = (0, $jVTBW.css)({
    color: "var(--ds-text, #172B4D)",
    marginBlock: "var(--ds-space-0, 0px)"
});
var $eba21c75bad96b5d$var$h900Styles = (0, $jVTBW.css)({
    fontSize: "var(--ds-font-size-600, 35px)",
    fontWeight: "var(--ds-font-weight-medium, 500)",
    letterSpacing: "-0.01em",
    lineHeight: "var(--ds-font-lineHeight-600, 40px)"
});
var $eba21c75bad96b5d$var$h800Styles = (0, $jVTBW.css)({
    fontSize: "var(--ds-font-size-500, 29px)",
    fontWeight: "var(--ds-font-weight-semibold, 600)",
    letterSpacing: "-0.01em",
    lineHeight: "var(--ds-font-lineHeight-500, 32px)"
});
var $eba21c75bad96b5d$var$h700Styles = (0, $jVTBW.css)({
    fontSize: "var(--ds-font-size-400, 24px)",
    fontWeight: "var(--ds-font-weight-medium, 500)",
    letterSpacing: "-0.01em",
    lineHeight: "var(--ds-font-lineHeight-400, 28px)"
});
var $eba21c75bad96b5d$var$h600Styles = (0, $jVTBW.css)({
    fontSize: "var(--ds-font-size-300, 20px)",
    fontWeight: "var(--ds-font-weight-medium, 500)",
    letterSpacing: "-0.008em",
    lineHeight: "var(--ds-font-lineHeight-300, 24px)"
});
var $eba21c75bad96b5d$var$h500Styles = (0, $jVTBW.css)({
    fontSize: "var(--ds-font-size-200, 16px)",
    fontWeight: "var(--ds-font-weight-semibold, 600)",
    letterSpacing: "-0.006em",
    lineHeight: "var(--ds-font-lineHeight-200, 20px)"
});
var $eba21c75bad96b5d$var$h400Styles = (0, $jVTBW.css)({
    fontSize: "var(--ds-font-size-100, 14px)",
    fontWeight: "var(--ds-font-weight-semibold, 600)",
    letterSpacing: "-0.003em",
    lineHeight: "var(--ds-font-lineHeight-100, 16px)"
});
var $eba21c75bad96b5d$var$h300Styles = (0, $jVTBW.css)({
    fontSize: "var(--ds-font-size-075, 12px)",
    fontWeight: "var(--ds-font-weight-semibold, 600)",
    letterSpacing: 0,
    lineHeight: "var(--ds-font-lineHeight-100, 16px)",
    textTransform: "uppercase"
});
var $eba21c75bad96b5d$var$h200Styles = (0, $jVTBW.css)({
    fontSize: "var(--ds-font-size-075, 12px)",
    fontWeight: "var(--ds-font-weight-semibold, 600)",
    letterSpacing: 0,
    lineHeight: "var(--ds-font-lineHeight-100, 16px)"
});
var $eba21c75bad96b5d$var$h100Styles = (0, $jVTBW.css)({
    fontSize: "var(--ds-font-size-050, 11px)",
    fontWeight: "var(--ds-font-weight-bold, 700)",
    letterSpacing: 0,
    lineHeight: "var(--ds-font-lineHeight-100, 16px)"
});
var $eba21c75bad96b5d$var$inverseStyles = (0, $jVTBW.css)({
    color: "var(--ds-text-inverse, #FFF)"
});
var $eba21c75bad96b5d$var$subtlestStyles = (0, $jVTBW.css)({
    color: "var(--ds-text-subtlest, #6B778C)"
});
/**
 * __Heading__
 *
 * A heading is a typography component used to display text in different sizes and formats.
 *
 * @example
 *
 * ```jsx
 * import Heading from '@atlaskit/heading';
 *
 * const H100 = () => (
 *   <Heading level="h100">h100</Heading>
 * );
 * ```
 */ var $eba21c75bad96b5d$var$OldHeading = function OldHeading(_ref) {
    var children = _ref.children, level = _ref.level, id = _ref.id, testId = _ref.testId, as = _ref.as, _ref$color = _ref.color, color = _ref$color === void 0 ? "default" : _ref$color;
    typeof $ahJoN;
    var _useHeading = (0, $fRXi1.useHeading)($eba21c75bad96b5d$var$levelMap[level]), _useHeading2 = (0, (/*@__PURE__*/$parcel$interopDefault($6SC0T)))(_useHeading, 2), hLevel = _useHeading2[0], inferredElement = _useHeading2[1];
    var Markup = as || inferredElement;
    var isSubtleHeading = level === "h200" || level === "h100";
    var needsAriaRole = Markup === "div" && hLevel;
    return (0, $jVTBW.jsx)(Markup, {
        id: id,
        "data-testid": testId,
        role: needsAriaRole ? "heading" : undefined,
        "aria-level": needsAriaRole ? hLevel : undefined,
        css: [
            $eba21c75bad96b5d$var$headingResetStyles,
            level === "h100" && $eba21c75bad96b5d$var$h100Styles,
            level === "h200" && $eba21c75bad96b5d$var$h200Styles,
            level === "h300" && $eba21c75bad96b5d$var$h300Styles,
            level === "h400" && $eba21c75bad96b5d$var$h400Styles,
            level === "h500" && $eba21c75bad96b5d$var$h500Styles,
            level === "h600" && $eba21c75bad96b5d$var$h600Styles,
            level === "h700" && $eba21c75bad96b5d$var$h700Styles,
            level === "h800" && $eba21c75bad96b5d$var$h800Styles,
            level === "h900" && $eba21c75bad96b5d$var$h900Styles,
            color === "inverse" && $eba21c75bad96b5d$var$inverseStyles,
            color === "default" && isSubtleHeading && $eba21c75bad96b5d$var$subtlestStyles
        ]
    }, children);
};
/**
 * __Heading__
 *
 * A heading is a typography component used to display text in different sizes and formats.
 *
 * @example
 *
 * ```jsx
 * import Heading from '@atlaskit/heading';
 *
 * // New component
 * <Heading size="xxlarge">Page title</Heading>
 *
 * // Old component
 * const H100 = () => (
 *   <Heading level="h100">h100</Heading>
 * );
 * ```
 */ var $eba21c75bad96b5d$var$Heading = function Heading(_ref2) {
    var level = _ref2.level, props = (0, (/*@__PURE__*/$parcel$interopDefault($i77m2)))(_ref2, $eba21c75bad96b5d$var$_excluded);
    return level ? // eslint-disable-next-line jsx-a11y/heading-has-content, @repo/internal/react/no-unsafe-spread-props
    (0, $jVTBW.jsx)($eba21c75bad96b5d$var$OldHeading, (0, (/*@__PURE__*/$parcel$interopDefault($gpRqE)))({
        level: level
    }, props)) : // eslint-disable-next-line jsx-a11y/heading-has-content, @repo/internal/react/no-unsafe-spread-props
    (0, $jVTBW.jsx)((0, $1wKlZ.default), props);
};
var $eba21c75bad96b5d$export$2e2bcd8739ae039 = $eba21c75bad96b5d$var$Heading;

});
parcelRegister("gpRqE", function(module, exports) {
function $bf386d002482883b$var$_extends() {
    return module.exports = $bf386d002482883b$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $bf386d002482883b$var$_extends.apply(null, arguments);
}
module.exports = $bf386d002482883b$var$_extends, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("i77m2", function(module, exports) {

var $3NOnt = parcelRequire("3NOnt");
function $d2fe95e5a990ea1a$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $3NOnt(e, t);
    if (Object.getOwnPropertySymbols) {
        var s = Object.getOwnPropertySymbols(e);
        for(r = 0; r < s.length; r++)o = s[r], t.includes(o) || ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
module.exports = $d2fe95e5a990ea1a$var$_objectWithoutProperties, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("3NOnt", function(module, exports) {
function $2c4d06a92391918d$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.includes(n)) continue;
        t[n] = r[n];
    }
    return t;
}
module.exports = $2c4d06a92391918d$var$_objectWithoutPropertiesLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("6SC0T", function(module, exports) {

var $g9Z7N = parcelRequire("g9Z7N");

var $8ZKod = parcelRequire("8ZKod");

var $1X67X = parcelRequire("1X67X");

var $59Wc5 = parcelRequire("59Wc5");
function $502545de4dd9783f$var$_slicedToArray(r, e) {
    return $g9Z7N(r) || $8ZKod(r, e) || $1X67X(r, e) || $59Wc5();
}
module.exports = $502545de4dd9783f$var$_slicedToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("g9Z7N", function(module, exports) {
function $bc3ce6b19a33da39$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
module.exports = $bc3ce6b19a33da39$var$_arrayWithHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("8ZKod", function(module, exports) {
function $68c8013b0ff211bb$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
module.exports = $68c8013b0ff211bb$var$_iterableToArrayLimit, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("1X67X", function(module, exports) {

var $hxI3g = parcelRequire("hxI3g");
function $16c00ddeebcd002d$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $hxI3g(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $hxI3g(r, a) : void 0;
    }
}
module.exports = $16c00ddeebcd002d$var$_unsupportedIterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("hxI3g", function(module, exports) {
function $cc57b0770bd8a539$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
module.exports = $cc57b0770bd8a539$var$_arrayLikeToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("59Wc5", function(module, exports) {
function $3c1aef241dc21f68$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
module.exports = $3c1aef241dc21f68$var$_nonIterableRest, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("fRXi1", function(module, exports) {

$parcel$export(module.exports, "useHeading", function () { return $02fb4139a03d52db$export$97a37b1befbbf9b1; });

var $dAx5m = parcelRequire("dAx5m");
// Allows support for heading levels 1-9 via aria-level
var $02fb4139a03d52db$var$HeadingLevelContext = /*#__PURE__*/ (0, $dAx5m.createContext)(0);
var $02fb4139a03d52db$export$6a64a1e2d0bbbf75 = function useHeadingLevel() {
    return (0, $dAx5m.useContext)($02fb4139a03d52db$var$HeadingLevelContext);
};
var $02fb4139a03d52db$export$97a37b1befbbf9b1 = function useHeading(fallback) {
    var hLevel = $02fb4139a03d52db$export$6a64a1e2d0bbbf75();
    /**
   * Order here is important, we for now apply
   * 1. inferred a11y level (this only applies if context is present)
   * 2. default final fallback
   */ return [
        hLevel,
        hLevel && (hLevel > 6 ? "div" : "h".concat(hLevel)) || fallback
    ];
};
/**
 * __Heading level provider__
 *
 * The Heading level provider injects the heading level to all `Heading` components below it in the component tree.
 *
 * @example
 * ```tsx
 * // Will correctly infer the heading level
 * <HeadingContext value={1}>
 *  <Heading>H1</Heading>
 *  <HeadingContext>
 *    <Heading>H2</Heading>
 *  </HeadingContext>
 * </HeadingContext>
 * ```
 */ var $02fb4139a03d52db$var$HeadingLevelContextProvider = function HeadingLevelContextProvider(_ref) {
    var children = _ref.children, value = _ref.value;
    var parentHeadingLevel = $02fb4139a03d52db$export$6a64a1e2d0bbbf75();
    var headingLevel = parentHeadingLevel + 1;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement($02fb4139a03d52db$var$HeadingLevelContext.Provider, {
        value: value || headingLevel
    }, children);
};
var $02fb4139a03d52db$export$2e2bcd8739ae039 = $02fb4139a03d52db$var$HeadingLevelContextProvider;

});

parcelRegister("1wKlZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $11ccbc7c6fc885d1$export$2e2bcd8739ae039; });

var $6SC0T = parcelRequire("6SC0T");

var $jVTBW = parcelRequire("jVTBW");

var $9eHA8 = parcelRequire("9eHA8");
var $hHkUx = parcelRequire("hHkUx");

var $fRXi1 = parcelRequire("fRXi1");

var $ahJoN = parcelRequire("ahJoN");
var $11ccbc7c6fc885d1$var$sizeTagMap = {
    xxlarge: "h1",
    xlarge: "h1",
    large: "h2",
    medium: "h3",
    small: "h4",
    xsmall: "h5",
    xxsmall: "h6"
};
var $11ccbc7c6fc885d1$var$headingResetStyles = (0, $jVTBW.css)({
    letterSpacing: "normal",
    marginBlock: 0,
    textTransform: "none"
});
var $11ccbc7c6fc885d1$var$useColor = function useColor(colorProp) {
    var surface = (0, $hHkUx.useSurface)();
    /**
   * Where the color of the surface is inverted we always override the color
   * as there is no valid choice that is not covered by the override.
   */ if ((0, $9eHA8.inverseColorMap).hasOwnProperty(surface)) return (0, $9eHA8.inverseColorMap)[surface];
    return colorProp || "color.text";
};
/**
 * __Heading__
 *
 * Heading is a typography component used to display text in defined sizes and styles.
 *
 * @example
 *
 * ```jsx
 * <Heading size="xxlarge">Page title</Heading>
 * ```
 */ var $11ccbc7c6fc885d1$var$Heading = function Heading(_ref) {
    var children = _ref.children, size = _ref.size, id = _ref.id, testId = _ref.testId, as = _ref.as, colorProp = _ref.color;
    typeof $ahJoN;
    // Technically size can be undefined here due to how the types work.
    // Once removing the level prop this assertion can be removed since size will be a required prop.
    var _useHeading = (0, $fRXi1.useHeading)($11ccbc7c6fc885d1$var$sizeTagMap[size]), _useHeading2 = (0, (/*@__PURE__*/$parcel$interopDefault($6SC0T)))(_useHeading, 2), hLevel = _useHeading2[0], inferredElement = _useHeading2[1];
    var Component = as || inferredElement;
    var needsAriaRole = Component === "div" && hLevel;
    var color = $11ccbc7c6fc885d1$var$useColor(colorProp);
    return (0, $jVTBW.jsx)(Component, {
        id: id,
        "data-testid": testId,
        role: needsAriaRole ? "heading" : undefined,
        "aria-level": needsAriaRole ? hLevel : undefined,
        css: [
            $11ccbc7c6fc885d1$var$headingResetStyles,
            size && $11ccbc7c6fc885d1$var$headingSizeStylesMap[size],
            $11ccbc7c6fc885d1$export$93e8ddd840a408f9[color]
        ]
    }, children);
};
var $11ccbc7c6fc885d1$export$93e8ddd840a408f9 = {
    "color.text": (0, $jVTBW.css)({
        color: "var(--ds-text, #172B4D)"
    }),
    "color.text.inverse": (0, $jVTBW.css)({
        color: "var(--ds-text-inverse, #FFFFFF)"
    }),
    "color.text.warning.inverse": (0, $jVTBW.css)({
        color: "var(--ds-text-warning-inverse, #172B4D)"
    })
};
/**
 * THIS SECTION WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d7d7bb136aa9b7935c15f8e85d0916d7>>
 * @codegenId typography
 * @codegenCommand yarn workspace @atlaskit/heading codegen
 */ var $11ccbc7c6fc885d1$var$headingSizeStylesMap = {
    xxlarge: (0, $jVTBW.css)({
        font: 'var(--ds-font-heading-xxlarge, normal 500 35px/40px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)'
    }),
    xlarge: (0, $jVTBW.css)({
        font: 'var(--ds-font-heading-xlarge, normal 600 29px/32px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)'
    }),
    large: (0, $jVTBW.css)({
        font: 'var(--ds-font-heading-large, normal 500 24px/28px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)'
    }),
    medium: (0, $jVTBW.css)({
        font: 'var(--ds-font-heading-medium, normal 500 20px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)'
    }),
    small: (0, $jVTBW.css)({
        font: 'var(--ds-font-heading-small, normal 600 16px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)'
    }),
    xsmall: (0, $jVTBW.css)({
        font: 'var(--ds-font-heading-xsmall, normal 600 14px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)'
    }),
    xxsmall: (0, $jVTBW.css)({
        font: 'var(--ds-font-heading-xxsmall, normal 600 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)'
    })
};
var /**
 * @codegenEnd
 */ $11ccbc7c6fc885d1$export$2e2bcd8739ae039 = $11ccbc7c6fc885d1$var$Heading;

});
parcelRegister("9eHA8", function(module, exports) {

$parcel$export(module.exports, "dimensionMap", function () { return $6b973a4bf6af2429$export$6ccdbebca2ee545f; });
$parcel$export(module.exports, "positiveSpaceMap", function () { return $6b973a4bf6af2429$export$958d0ae7f2977ae4; });
$parcel$export(module.exports, "allSpaceMap", function () { return $6b973a4bf6af2429$export$632685d741f3dbbf; });
$parcel$export(module.exports, "inverseColorMap", function () { return $6b973a4bf6af2429$export$2185ce37f9bdd963; });
$parcel$export(module.exports, "opacityMap", function () { return $6b973a4bf6af2429$export$daf94a976c798b4f; });
$parcel$export(module.exports, "shadowMap", function () { return $6b973a4bf6af2429$export$7aff6e7ba39bb774; });
$parcel$export(module.exports, "borderColorMap", function () { return $6b973a4bf6af2429$export$1531ad5bb3fbedac; });
$parcel$export(module.exports, "backgroundColorMap", function () { return $6b973a4bf6af2429$export$d1d79bf68ac056bd; });
$parcel$export(module.exports, "textColorMap", function () { return $6b973a4bf6af2429$export$8473307aa00d6ea1; });
$parcel$export(module.exports, "layerMap", function () { return $6b973a4bf6af2429$export$b5f31a7e431d2eab; });
$parcel$export(module.exports, "borderWidthMap", function () { return $6b973a4bf6af2429$export$e1b83c5210c471b8; });
$parcel$export(module.exports, "borderRadiusMap", function () { return $6b973a4bf6af2429$export$3c0a6c3e64bb180d; });
$parcel$export(module.exports, "paddingStylesMap", function () { return $6b973a4bf6af2429$export$e615f061ca585a6c; });
$parcel$export(module.exports, "spaceStylesMap", function () { return $6b973a4bf6af2429$export$bf46c3f9eeafc71f; });
$parcel$export(module.exports, "backgroundColorStylesMap", function () { return $6b973a4bf6af2429$export$e7af83bafe7f9e63; });
$parcel$export(module.exports, "textColorStylesMap", function () { return $6b973a4bf6af2429$export$3a1bcba60b23d7f0; });
$parcel$export(module.exports, "fontWeightStylesMap", function () { return $6b973a4bf6af2429$export$45f3f4fe16f9f7d5; });
$parcel$export(module.exports, "fontStylesMap", function () { return $6b973a4bf6af2429$export$128f10c238242f83; });
$parcel$export(module.exports, "surfaceColorStylesMap", function () { return $6b973a4bf6af2429$export$ff257d957d48c421; });
$parcel$export(module.exports, "isSurfaceColorToken", function () { return $6b973a4bf6af2429$export$5e65a44e5b6ecadb; });

var $98i6Z = parcelRequire("98i6Z");

var $jVTBW = parcelRequire("jVTBW");

var $jGh1E = parcelRequire("jGh1E");
function $6b973a4bf6af2429$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $6b973a4bf6af2429$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $6b973a4bf6af2429$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($98i6Z)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $6b973a4bf6af2429$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $6b973a4bf6af2429$export$6ccdbebca2ee545f = {
    "100%": "100%",
    "size.100": "1rem",
    "size.200": "1.5rem",
    "size.300": "2rem",
    "size.400": "2.5rem",
    "size.500": "3rem",
    "size.600": "6rem",
    "size.1000": "12rem"
};
var $6b973a4bf6af2429$export$958d0ae7f2977ae4 = {
    "space.0": "var(--ds-space-0, 0px)",
    "space.025": "var(--ds-space-025, 2px)",
    "space.050": "var(--ds-space-050, 4px)",
    "space.075": "var(--ds-space-075, 6px)",
    "space.100": "var(--ds-space-100, 8px)",
    "space.150": "var(--ds-space-150, 12px)",
    "space.200": "var(--ds-space-200, 16px)",
    "space.250": "var(--ds-space-250, 20px)",
    "space.300": "var(--ds-space-300, 24px)",
    "space.400": "var(--ds-space-400, 32px)",
    "space.500": "var(--ds-space-500, 40px)",
    "space.600": "var(--ds-space-600, 48px)",
    "space.800": "var(--ds-space-800, 64px)",
    "space.1000": "var(--ds-space-1000, 80px)"
};
var $6b973a4bf6af2429$export$d2dc61f58390201c = {
    "space.negative.025": "var(--ds-space-negative-025, -2px)",
    "space.negative.050": "var(--ds-space-negative-050, -4px)",
    "space.negative.075": "var(--ds-space-negative-075, -6px)",
    "space.negative.100": "var(--ds-space-negative-100, -8px)",
    "space.negative.150": "var(--ds-space-negative-150, -12px)",
    "space.negative.200": "var(--ds-space-negative-200, -16px)",
    "space.negative.250": "var(--ds-space-negative-250, -20px)",
    "space.negative.300": "var(--ds-space-negative-300, -24px)",
    "space.negative.400": "var(--ds-space-negative-400, -32px)"
};
var $6b973a4bf6af2429$export$632685d741f3dbbf = $6b973a4bf6af2429$var$_objectSpread($6b973a4bf6af2429$var$_objectSpread({}, $6b973a4bf6af2429$export$958d0ae7f2977ae4), $6b973a4bf6af2429$export$d2dc61f58390201c);
var $6b973a4bf6af2429$export$2185ce37f9bdd963 = {
    "color.background.neutral.bold": "color.text.inverse",
    "color.background.neutral.bold.hovered": "color.text.inverse",
    "color.background.neutral.bold.pressed": "color.text.inverse",
    "color.background.selected.bold": "color.text.inverse",
    "color.background.selected.bold.hovered": "color.text.inverse",
    "color.background.selected.bold.pressed": "color.text.inverse",
    "color.background.brand.bold": "color.text.inverse",
    "color.background.brand.bold.hovered": "color.text.inverse",
    "color.background.brand.bold.pressed": "color.text.inverse",
    "color.background.brand.boldest": "color.text.inverse",
    "color.background.brand.boldest.hovered": "color.text.inverse",
    "color.background.brand.boldest.pressed": "color.text.inverse",
    "color.background.danger.bold": "color.text.inverse",
    "color.background.danger.bold.hovered": "color.text.inverse",
    "color.background.danger.bold.pressed": "color.text.inverse",
    "color.background.warning.bold": "color.text.warning.inverse",
    "color.background.warning.bold.hovered": "color.text.warning.inverse",
    "color.background.warning.bold.pressed": "color.text.warning.inverse",
    "color.background.success.bold": "color.text.inverse",
    "color.background.success.bold.hovered": "color.text.inverse",
    "color.background.success.bold.pressed": "color.text.inverse",
    "color.background.discovery.bold": "color.text.inverse",
    "color.background.discovery.bold.hovered": "color.text.inverse",
    "color.background.discovery.bold.pressed": "color.text.inverse",
    "color.background.information.bold": "color.text.inverse",
    "color.background.information.bold.hovered": "color.text.inverse",
    "color.background.information.bold.pressed": "color.text.inverse"
};
var $6b973a4bf6af2429$export$daf94a976c798b4f = {
    "opacity.disabled": "var(--ds-opacity-disabled, 0.4)",
    "opacity.loading": "var(--ds-opacity-loading, 0.2)"
};
var $6b973a4bf6af2429$export$7aff6e7ba39bb774 = {
    "elevation.shadow.overflow": "var(--ds-shadow-overflow, 0px 0px 8px #091e423f, 0px 0px 1px #091e424f)",
    "elevation.shadow.overflow.perimeter": "var(--ds-shadow-overflow-perimeter, #091e421f)",
    "elevation.shadow.overflow.spread": "var(--ds-shadow-overflow-spread, #091e4229)",
    "elevation.shadow.overlay": "var(--ds-shadow-overlay, 0px 8px 12px #091e423f, 0px 0px 1px #091e424f)",
    "elevation.shadow.raised": "var(--ds-shadow-raised, 0px 1px 1px #091e423f, 0px 0px 1px #091e4221)"
};
var $6b973a4bf6af2429$export$41a358c9c2356760 = {
    "elevation.surface": "var(--ds-surface, #FFFFFF)",
    "elevation.surface.hovered": "var(--ds-surface-hovered, #FAFBFC)",
    "elevation.surface.pressed": "var(--ds-surface-pressed, #F4F5F7)",
    "elevation.surface.overlay": "var(--ds-surface-overlay, #FFFFFF)",
    "elevation.surface.overlay.hovered": "var(--ds-surface-overlay-hovered, #FAFBFC)",
    "elevation.surface.overlay.pressed": "var(--ds-surface-overlay-pressed, #F4F5F7)",
    "elevation.surface.raised": "var(--ds-surface-raised, #FFFFFF)",
    "elevation.surface.raised.hovered": "var(--ds-surface-raised-hovered, #FAFBFC)",
    "elevation.surface.raised.pressed": "var(--ds-surface-raised-pressed, #F4F5F7)",
    "elevation.surface.sunken": "var(--ds-surface-sunken, #F4F5F7)"
};
var $6b973a4bf6af2429$export$1531ad5bb3fbedac = {
    "color.border": "var(--ds-border, #091e4221)",
    "color.border.accent.lime": "var(--ds-border-accent-lime, #6A9A23)",
    "color.border.accent.red": "var(--ds-border-accent-red, #FF5630)",
    "color.border.accent.orange": "var(--ds-border-accent-orange, #D94008)",
    "color.border.accent.yellow": "var(--ds-border-accent-yellow, #FFAB00)",
    "color.border.accent.green": "var(--ds-border-accent-green, #36B37E)",
    "color.border.accent.teal": "var(--ds-border-accent-teal, #00B8D9)",
    "color.border.accent.blue": "var(--ds-border-accent-blue, #0065FF)",
    "color.border.accent.purple": "var(--ds-border-accent-purple, #6554C0)",
    "color.border.accent.magenta": "var(--ds-border-accent-magenta, #CD519D)",
    "color.border.accent.gray": "var(--ds-border-accent-gray, #5E6C84)",
    "color.border.disabled": "var(--ds-border-disabled, #FAFBFC)",
    "color.border.focused": "var(--ds-border-focused, #2684FF)",
    "color.border.input": "var(--ds-border-input, #FAFBFC)",
    "color.border.inverse": "var(--ds-border-inverse, #FFFFFF)",
    "color.border.selected": "var(--ds-border-selected, #0052CC)",
    "color.border.brand": "var(--ds-border-brand, #0052CC)",
    "color.border.danger": "var(--ds-border-danger, #FF5630)",
    "color.border.warning": "var(--ds-border-warning, #FFC400)",
    "color.border.success": "var(--ds-border-success, #00875A)",
    "color.border.discovery": "var(--ds-border-discovery, #998DD9)",
    "color.border.information": "var(--ds-border-information, #0065FF)",
    "color.border.bold": "var(--ds-border-bold, #344563)"
};
var $6b973a4bf6af2429$export$d1d79bf68ac056bd = {
    "color.background.accent.lime.subtlest": "var(--ds-background-accent-lime-subtlest, #EEFBDA)",
    "color.background.accent.lime.subtlest.hovered": "var(--ds-background-accent-lime-subtlest-hovered, #D3F1A7)",
    "color.background.accent.lime.subtlest.pressed": "var(--ds-background-accent-lime-subtlest-pressed, #B3DF72)",
    "color.background.accent.lime.subtler": "var(--ds-background-accent-lime-subtler, #D3F1A7)",
    "color.background.accent.lime.subtler.hovered": "var(--ds-background-accent-lime-subtler-hovered, #B3DF72)",
    "color.background.accent.lime.subtler.pressed": "var(--ds-background-accent-lime-subtler-pressed, #94C748)",
    "color.background.accent.lime.subtle": "var(--ds-background-accent-lime-subtle, #94C748)",
    "color.background.accent.lime.subtle.hovered": "var(--ds-background-accent-lime-subtle-hovered, #B3DF72)",
    "color.background.accent.lime.subtle.pressed": "var(--ds-background-accent-lime-subtle-pressed, #D3F1A7)",
    "color.background.accent.lime.bolder": "var(--ds-background-accent-lime-bolder, #5B7F24)",
    "color.background.accent.lime.bolder.hovered": "var(--ds-background-accent-lime-bolder-hovered, #37471F)",
    "color.background.accent.lime.bolder.pressed": "var(--ds-background-accent-lime-bolder-pressed, #37471F)",
    "color.background.accent.red.subtlest": "var(--ds-background-accent-red-subtlest, #FF8F73)",
    "color.background.accent.red.subtlest.hovered": "var(--ds-background-accent-red-subtlest-hovered, #FF7452)",
    "color.background.accent.red.subtlest.pressed": "var(--ds-background-accent-red-subtlest-pressed, #FF5630)",
    "color.background.accent.red.subtler": "var(--ds-background-accent-red-subtler, #FF7452)",
    "color.background.accent.red.subtler.hovered": "var(--ds-background-accent-red-subtler-hovered, #FF5630)",
    "color.background.accent.red.subtler.pressed": "var(--ds-background-accent-red-subtler-pressed, #DE350B)",
    "color.background.accent.red.subtle": "var(--ds-background-accent-red-subtle, #DE350B)",
    "color.background.accent.red.subtle.hovered": "var(--ds-background-accent-red-subtle-hovered, #FF5630)",
    "color.background.accent.red.subtle.pressed": "var(--ds-background-accent-red-subtle-pressed, #FF7452)",
    "color.background.accent.red.bolder": "var(--ds-background-accent-red-bolder, #DE350B)",
    "color.background.accent.red.bolder.hovered": "var(--ds-background-accent-red-bolder-hovered, #FF5630)",
    "color.background.accent.red.bolder.pressed": "var(--ds-background-accent-red-bolder-pressed, #FF7452)",
    "color.background.accent.orange.subtlest": "var(--ds-background-accent-orange-subtlest, #F18D13)",
    "color.background.accent.orange.subtlest.hovered": "var(--ds-background-accent-orange-subtlest-hovered, #FEC57B)",
    "color.background.accent.orange.subtlest.pressed": "var(--ds-background-accent-orange-subtlest-pressed, #FFE2BD)",
    "color.background.accent.orange.subtler": "var(--ds-background-accent-orange-subtler, #B65C02)",
    "color.background.accent.orange.subtler.hovered": "var(--ds-background-accent-orange-subtler-hovered, #F18D13)",
    "color.background.accent.orange.subtler.pressed": "var(--ds-background-accent-orange-subtler-pressed, #FEC57B)",
    "color.background.accent.orange.subtle": "var(--ds-background-accent-orange-subtle, #5F3811)",
    "color.background.accent.orange.subtle.hovered": "var(--ds-background-accent-orange-subtle-hovered, #974F0C)",
    "color.background.accent.orange.subtle.pressed": "var(--ds-background-accent-orange-subtle-pressed, #B65C02)",
    "color.background.accent.orange.bolder": "var(--ds-background-accent-orange-bolder, #43290F)",
    "color.background.accent.orange.bolder.hovered": "var(--ds-background-accent-orange-bolder-hovered, #5F3811)",
    "color.background.accent.orange.bolder.pressed": "var(--ds-background-accent-orange-bolder-pressed, #974F0C)",
    "color.background.accent.yellow.subtlest": "var(--ds-background-accent-yellow-subtlest, #FFE380)",
    "color.background.accent.yellow.subtlest.hovered": "var(--ds-background-accent-yellow-subtlest-hovered, #FFC400)",
    "color.background.accent.yellow.subtlest.pressed": "var(--ds-background-accent-yellow-subtlest-pressed, #FFAB00)",
    "color.background.accent.yellow.subtler": "var(--ds-background-accent-yellow-subtler, #FFC400)",
    "color.background.accent.yellow.subtler.hovered": "var(--ds-background-accent-yellow-subtler-hovered, #FFAB00)",
    "color.background.accent.yellow.subtler.pressed": "var(--ds-background-accent-yellow-subtler-pressed, #FF991F)",
    "color.background.accent.yellow.subtle": "var(--ds-background-accent-yellow-subtle, #FF991F)",
    "color.background.accent.yellow.subtle.hovered": "var(--ds-background-accent-yellow-subtle-hovered, #FFAB00)",
    "color.background.accent.yellow.subtle.pressed": "var(--ds-background-accent-yellow-subtle-pressed, #FFC400)",
    "color.background.accent.yellow.bolder": "var(--ds-background-accent-yellow-bolder, #FF991F)",
    "color.background.accent.yellow.bolder.hovered": "var(--ds-background-accent-yellow-bolder-hovered, #FFAB00)",
    "color.background.accent.yellow.bolder.pressed": "var(--ds-background-accent-yellow-bolder-pressed, #FFC400)",
    "color.background.accent.green.subtlest": "var(--ds-background-accent-green-subtlest, #79F2C0)",
    "color.background.accent.green.subtlest.hovered": "var(--ds-background-accent-green-subtlest-hovered, #57D9A3)",
    "color.background.accent.green.subtlest.pressed": "var(--ds-background-accent-green-subtlest-pressed, #36B37E)",
    "color.background.accent.green.subtler": "var(--ds-background-accent-green-subtler, #57D9A3)",
    "color.background.accent.green.subtler.hovered": "var(--ds-background-accent-green-subtler-hovered, #36B37E)",
    "color.background.accent.green.subtler.pressed": "var(--ds-background-accent-green-subtler-pressed, #00875A)",
    "color.background.accent.green.subtle": "var(--ds-background-accent-green-subtle, #00875A)",
    "color.background.accent.green.subtle.hovered": "var(--ds-background-accent-green-subtle-hovered, #36B37E)",
    "color.background.accent.green.subtle.pressed": "var(--ds-background-accent-green-subtle-pressed, #57D9A3)",
    "color.background.accent.green.bolder": "var(--ds-background-accent-green-bolder, #00875A)",
    "color.background.accent.green.bolder.hovered": "var(--ds-background-accent-green-bolder-hovered, #36B37E)",
    "color.background.accent.green.bolder.pressed": "var(--ds-background-accent-green-bolder-pressed, #57D9A3)",
    "color.background.accent.teal.subtlest": "var(--ds-background-accent-teal-subtlest, #79E2F2)",
    "color.background.accent.teal.subtlest.hovered": "var(--ds-background-accent-teal-subtlest-hovered, #00C7E6)",
    "color.background.accent.teal.subtlest.pressed": "var(--ds-background-accent-teal-subtlest-pressed, #00B8D9)",
    "color.background.accent.teal.subtler": "var(--ds-background-accent-teal-subtler, #00C7E6)",
    "color.background.accent.teal.subtler.hovered": "var(--ds-background-accent-teal-subtler-hovered, #00B8D9)",
    "color.background.accent.teal.subtler.pressed": "var(--ds-background-accent-teal-subtler-pressed, #00A3BF)",
    "color.background.accent.teal.subtle": "var(--ds-background-accent-teal-subtle, #00A3BF)",
    "color.background.accent.teal.subtle.hovered": "var(--ds-background-accent-teal-subtle-hovered, #00B8D9)",
    "color.background.accent.teal.subtle.pressed": "var(--ds-background-accent-teal-subtle-pressed, #00C7E6)",
    "color.background.accent.teal.bolder": "var(--ds-background-accent-teal-bolder, #00A3BF)",
    "color.background.accent.teal.bolder.hovered": "var(--ds-background-accent-teal-bolder-hovered, #00B8D9)",
    "color.background.accent.teal.bolder.pressed": "var(--ds-background-accent-teal-bolder-pressed, #00C7E6)",
    "color.background.accent.blue.subtlest": "var(--ds-background-accent-blue-subtlest, #4C9AFF)",
    "color.background.accent.blue.subtlest.hovered": "var(--ds-background-accent-blue-subtlest-hovered, #2684FF)",
    "color.background.accent.blue.subtlest.pressed": "var(--ds-background-accent-blue-subtlest-pressed, #0065FF)",
    "color.background.accent.blue.subtler": "var(--ds-background-accent-blue-subtler, #2684FF)",
    "color.background.accent.blue.subtler.hovered": "var(--ds-background-accent-blue-subtler-hovered, #0065FF)",
    "color.background.accent.blue.subtler.pressed": "var(--ds-background-accent-blue-subtler-pressed, #0052CC)",
    "color.background.accent.blue.subtle": "var(--ds-background-accent-blue-subtle, #0052CC)",
    "color.background.accent.blue.subtle.hovered": "var(--ds-background-accent-blue-subtle-hovered, #0065FF)",
    "color.background.accent.blue.subtle.pressed": "var(--ds-background-accent-blue-subtle-pressed, #2684FF)",
    "color.background.accent.blue.bolder": "var(--ds-background-accent-blue-bolder, #0052CC)",
    "color.background.accent.blue.bolder.hovered": "var(--ds-background-accent-blue-bolder-hovered, #0065FF)",
    "color.background.accent.blue.bolder.pressed": "var(--ds-background-accent-blue-bolder-pressed, #2684FF)",
    "color.background.accent.purple.subtlest": "var(--ds-background-accent-purple-subtlest, #998DD9)",
    "color.background.accent.purple.subtlest.hovered": "var(--ds-background-accent-purple-subtlest-hovered, #8777D9)",
    "color.background.accent.purple.subtlest.pressed": "var(--ds-background-accent-purple-subtlest-pressed, #6554C0)",
    "color.background.accent.purple.subtler": "var(--ds-background-accent-purple-subtler, #8777D9)",
    "color.background.accent.purple.subtler.hovered": "var(--ds-background-accent-purple-subtler-hovered, #6554C0)",
    "color.background.accent.purple.subtler.pressed": "var(--ds-background-accent-purple-subtler-pressed, #5243AA)",
    "color.background.accent.purple.subtle": "var(--ds-background-accent-purple-subtle, #5243AA)",
    "color.background.accent.purple.subtle.hovered": "var(--ds-background-accent-purple-subtle-hovered, #6554C0)",
    "color.background.accent.purple.subtle.pressed": "var(--ds-background-accent-purple-subtle-pressed, #8777D9)",
    "color.background.accent.purple.bolder": "var(--ds-background-accent-purple-bolder, #5243AA)",
    "color.background.accent.purple.bolder.hovered": "var(--ds-background-accent-purple-bolder-hovered, #6554C0)",
    "color.background.accent.purple.bolder.pressed": "var(--ds-background-accent-purple-bolder-pressed, #8777D9)",
    "color.background.accent.magenta.subtlest": "var(--ds-background-accent-magenta-subtlest, #FFECF8)",
    "color.background.accent.magenta.subtlest.hovered": "var(--ds-background-accent-magenta-subtlest-hovered, #FDD0EC)",
    "color.background.accent.magenta.subtlest.pressed": "var(--ds-background-accent-magenta-subtlest-pressed, #F797D2)",
    "color.background.accent.magenta.subtler": "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
    "color.background.accent.magenta.subtler.hovered": "var(--ds-background-accent-magenta-subtler-hovered, #F797D2)",
    "color.background.accent.magenta.subtler.pressed": "var(--ds-background-accent-magenta-subtler-pressed, #E774BB)",
    "color.background.accent.magenta.subtle": "var(--ds-background-accent-magenta-subtle, #E774BB)",
    "color.background.accent.magenta.subtle.hovered": "var(--ds-background-accent-magenta-subtle-hovered, #F797D2)",
    "color.background.accent.magenta.subtle.pressed": "var(--ds-background-accent-magenta-subtle-pressed, #FDD0EC)",
    "color.background.accent.magenta.bolder": "var(--ds-background-accent-magenta-bolder, #AE4787)",
    "color.background.accent.magenta.bolder.hovered": "var(--ds-background-accent-magenta-bolder-hovered, #943D73)",
    "color.background.accent.magenta.bolder.pressed": "var(--ds-background-accent-magenta-bolder-pressed, #50253F)",
    "color.background.accent.gray.subtlest": "var(--ds-background-accent-gray-subtlest, #6B778C)",
    "color.background.accent.gray.subtlest.hovered": "var(--ds-background-accent-gray-subtlest-hovered, #5E6C84)",
    "color.background.accent.gray.subtlest.pressed": "var(--ds-background-accent-gray-subtlest-pressed, #505F79)",
    "color.background.accent.gray.subtler": "var(--ds-background-accent-gray-subtler, #5E6C84)",
    "color.background.accent.gray.subtler.hovered": "var(--ds-background-accent-gray-subtler-hovered, #505F79)",
    "color.background.accent.gray.subtler.pressed": "var(--ds-background-accent-gray-subtler-pressed, #42526E)",
    "color.background.accent.gray.subtle": "var(--ds-background-accent-gray-subtle, #505F79)",
    "color.background.accent.gray.subtle.hovered": "var(--ds-background-accent-gray-subtle-hovered, #5E6C84)",
    "color.background.accent.gray.subtle.pressed": "var(--ds-background-accent-gray-subtle-pressed, #6B778C)",
    "color.background.accent.gray.bolder": "var(--ds-background-accent-gray-bolder, #42526E)",
    "color.background.accent.gray.bolder.hovered": "var(--ds-background-accent-gray-bolder-hovered, #344563)",
    "color.background.accent.gray.bolder.pressed": "var(--ds-background-accent-gray-bolder-pressed, #253858)",
    "color.background.disabled": "var(--ds-background-disabled, #091e4289)",
    "color.background.input": "var(--ds-background-input, #FAFBFC)",
    "color.background.input.hovered": "var(--ds-background-input-hovered, #EBECF0)",
    "color.background.input.pressed": "var(--ds-background-input-pressed, #FFFFFF)",
    "color.background.inverse.subtle": "var(--ds-background-inverse-subtle, #00000029)",
    "color.background.inverse.subtle.hovered": "var(--ds-background-inverse-subtle-hovered, #0000003D)",
    "color.background.inverse.subtle.pressed": "var(--ds-background-inverse-subtle-pressed, #00000052)",
    "color.background.neutral": "var(--ds-background-neutral, #DFE1E6)",
    "color.background.neutral.hovered": "var(--ds-background-neutral-hovered, #091e4214)",
    "color.background.neutral.pressed": "var(--ds-background-neutral-pressed, #B3D4FF)",
    "color.background.neutral.subtle": "var(--ds-background-neutral-subtle, transparent)",
    "color.background.neutral.subtle.hovered": "var(--ds-background-neutral-subtle-hovered, #091e4214)",
    "color.background.neutral.subtle.pressed": "var(--ds-background-neutral-subtle-pressed, #B3D4FF)",
    "color.background.neutral.bold": "var(--ds-background-neutral-bold, #42526E)",
    "color.background.neutral.bold.hovered": "var(--ds-background-neutral-bold-hovered, #505F79)",
    "color.background.neutral.bold.pressed": "var(--ds-background-neutral-bold-pressed, #344563)",
    "color.background.selected": "var(--ds-background-selected, #DEEBFF)",
    "color.background.selected.hovered": "var(--ds-background-selected-hovered, #B3D4FF)",
    "color.background.selected.pressed": "var(--ds-background-selected-pressed, #4C9AFF)",
    "color.background.selected.bold": "var(--ds-background-selected-bold, #0052CC)",
    "color.background.selected.bold.hovered": "var(--ds-background-selected-bold-hovered, #2684FF)",
    "color.background.selected.bold.pressed": "var(--ds-background-selected-bold-pressed, #0052CC)",
    "color.background.brand.subtlest": "var(--ds-background-brand-subtlest, #B3D4FF)",
    "color.background.brand.subtlest.hovered": "var(--ds-background-brand-subtlest-hovered, #DEEBFF)",
    "color.background.brand.subtlest.pressed": "var(--ds-background-brand-subtlest-pressed, #4C9AFF)",
    "color.background.brand.bold": "var(--ds-background-brand-bold, #0052CC)",
    "color.background.brand.bold.hovered": "var(--ds-background-brand-bold-hovered, #0065FF)",
    "color.background.brand.bold.pressed": "var(--ds-background-brand-bold-pressed, #0747A6)",
    "color.background.brand.boldest": "var(--ds-background-brand-boldest, #0747A6)",
    "color.background.brand.boldest.hovered": "var(--ds-background-brand-boldest-hovered, #0052CC)",
    "color.background.brand.boldest.pressed": "var(--ds-background-brand-boldest-pressed, #0747A6)",
    "color.background.danger": "var(--ds-background-danger, #FFEBE6)",
    "color.background.danger.hovered": "var(--ds-background-danger-hovered, #FFBDAD)",
    "color.background.danger.pressed": "var(--ds-background-danger-pressed, #FF8F73)",
    "color.background.danger.bold": "var(--ds-background-danger-bold, #DE350B)",
    "color.background.danger.bold.hovered": "var(--ds-background-danger-bold-hovered, #FF5630)",
    "color.background.danger.bold.pressed": "var(--ds-background-danger-bold-pressed, #BF2600)",
    "color.background.warning": "var(--ds-background-warning, #FFFAE6)",
    "color.background.warning.hovered": "var(--ds-background-warning-hovered, #FFF0B3)",
    "color.background.warning.pressed": "var(--ds-background-warning-pressed, #FFE380)",
    "color.background.warning.bold": "var(--ds-background-warning-bold, #FFAB00)",
    "color.background.warning.bold.hovered": "var(--ds-background-warning-bold-hovered, #FFC400)",
    "color.background.warning.bold.pressed": "var(--ds-background-warning-bold-pressed, #FF991F)",
    "color.background.success": "var(--ds-background-success, #E3FCEF)",
    "color.background.success.hovered": "var(--ds-background-success-hovered, #ABF5D1)",
    "color.background.success.pressed": "var(--ds-background-success-pressed, #79F2C0)",
    "color.background.success.bold": "var(--ds-background-success-bold, #00875A)",
    "color.background.success.bold.hovered": "var(--ds-background-success-bold-hovered, #57D9A3)",
    "color.background.success.bold.pressed": "var(--ds-background-success-bold-pressed, #00875A)",
    "color.background.discovery": "var(--ds-background-discovery, #EAE6FF)",
    "color.background.discovery.hovered": "var(--ds-background-discovery-hovered, #C0B6F2)",
    "color.background.discovery.pressed": "var(--ds-background-discovery-pressed, #998DD9)",
    "color.background.discovery.bold": "var(--ds-background-discovery-bold, #5243AA)",
    "color.background.discovery.bold.hovered": "var(--ds-background-discovery-bold-hovered, #8777D9)",
    "color.background.discovery.bold.pressed": "var(--ds-background-discovery-bold-pressed, #5243AA)",
    "color.background.information": "var(--ds-background-information, #DEEBFF)",
    "color.background.information.hovered": "var(--ds-background-information-hovered, #B3D4FF)",
    "color.background.information.pressed": "var(--ds-background-information-pressed, #4C9AFF)",
    "color.background.information.bold": "var(--ds-background-information-bold, #0052CC)",
    "color.background.information.bold.hovered": "var(--ds-background-information-bold-hovered, #2684FF)",
    "color.background.information.bold.pressed": "var(--ds-background-information-bold-pressed, #0052CC)",
    "color.blanket": "var(--ds-blanket, #091e4289)",
    "color.blanket.selected": "var(--ds-blanket-selected, #388BFF14)",
    "color.blanket.danger": "var(--ds-blanket-danger, #EF5C4814)",
    "elevation.surface": "var(--ds-surface, #FFFFFF)",
    "elevation.surface.hovered": "var(--ds-surface-hovered, #FAFBFC)",
    "elevation.surface.pressed": "var(--ds-surface-pressed, #F4F5F7)",
    "elevation.surface.overlay": "var(--ds-surface-overlay, #FFFFFF)",
    "elevation.surface.overlay.hovered": "var(--ds-surface-overlay-hovered, #FAFBFC)",
    "elevation.surface.overlay.pressed": "var(--ds-surface-overlay-pressed, #F4F5F7)",
    "elevation.surface.raised": "var(--ds-surface-raised, #FFFFFF)",
    "elevation.surface.raised.hovered": "var(--ds-surface-raised-hovered, #FAFBFC)",
    "elevation.surface.raised.pressed": "var(--ds-surface-raised-pressed, #F4F5F7)",
    "elevation.surface.sunken": "var(--ds-surface-sunken, #F4F5F7)",
    "utility.elevation.surface.current": "var(--ds-elevation-surface-current, #FFFFFF)"
};
var $6b973a4bf6af2429$export$8473307aa00d6ea1 = {
    "color.text": "var(--ds-text, #172B4D)",
    "color.text.accent.lime": "var(--ds-text-accent-lime, #4C6B1F)",
    "color.text.accent.lime.bolder": "var(--ds-text-accent-lime-bolder, #37471F)",
    "color.text.accent.red": "var(--ds-text-accent-red, #DE350B)",
    "color.text.accent.red.bolder": "var(--ds-text-accent-red-bolder, #BF2600)",
    "color.text.accent.orange": "var(--ds-text-accent-orange, #F18D13)",
    "color.text.accent.orange.bolder": "var(--ds-text-accent-orange-bolder, #B65C02)",
    "color.text.accent.yellow": "var(--ds-text-accent-yellow, #FF991F)",
    "color.text.accent.yellow.bolder": "var(--ds-text-accent-yellow-bolder, #FF8B00)",
    "color.text.accent.green": "var(--ds-text-accent-green, #00875A)",
    "color.text.accent.green.bolder": "var(--ds-text-accent-green-bolder, #006644)",
    "color.text.accent.teal": "var(--ds-text-accent-teal, #00A3BF)",
    "color.text.accent.teal.bolder": "var(--ds-text-accent-teal-bolder, #008DA6)",
    "color.text.accent.blue": "var(--ds-text-accent-blue, #0052CC)",
    "color.text.accent.blue.bolder": "var(--ds-text-accent-blue-bolder, #0747A6)",
    "color.text.accent.purple": "var(--ds-text-accent-purple, #5243AA)",
    "color.text.accent.purple.bolder": "var(--ds-text-accent-purple-bolder, #403294)",
    "color.text.accent.magenta": "var(--ds-text-accent-magenta, #E774BB)",
    "color.text.accent.magenta.bolder": "var(--ds-text-accent-magenta-bolder, #DA62AC)",
    "color.text.accent.gray": "var(--ds-text-accent-gray, #505F79)",
    "color.text.accent.gray.bolder": "var(--ds-text-accent-gray-bolder, #172B4D)",
    "color.text.disabled": "var(--ds-text-disabled, #A5ADBA)",
    "color.text.inverse": "var(--ds-text-inverse, #FFFFFF)",
    "color.text.selected": "var(--ds-text-selected, #0052CC)",
    "color.text.brand": "var(--ds-text-brand, #0065FF)",
    "color.text.danger": "var(--ds-text-danger, #DE350B)",
    "color.text.warning": "var(--ds-text-warning, #974F0C)",
    "color.text.warning.inverse": "var(--ds-text-warning-inverse, #172B4D)",
    "color.text.success": "var(--ds-text-success, #006644)",
    "color.text.discovery": "var(--ds-text-discovery, #403294)",
    "color.text.information": "var(--ds-text-information, #0052CC)",
    "color.text.subtlest": "var(--ds-text-subtlest, #7A869A)",
    "color.text.subtle": "var(--ds-text-subtle, #42526E)",
    "color.link": "var(--ds-link, #0052CC)",
    "color.link.pressed": "var(--ds-link-pressed, #0747A6)",
    "color.link.visited": "var(--ds-link-visited, #403294)",
    "color.link.visited.pressed": "var(--ds-link-visited-pressed, #403294)"
};
var $6b973a4bf6af2429$export$498780f74be9af68 = {
    "color.icon": "var(--ds-icon, #505F79)",
    "color.icon.accent.lime": "var(--ds-icon-accent-lime, #6A9A23)",
    "color.icon.accent.red": "var(--ds-icon-accent-red, #FF5630)",
    "color.icon.accent.orange": "var(--ds-icon-accent-orange, #D94008)",
    "color.icon.accent.yellow": "var(--ds-icon-accent-yellow, #FFAB00)",
    "color.icon.accent.green": "var(--ds-icon-accent-green, #36B37E)",
    "color.icon.accent.teal": "var(--ds-icon-accent-teal, #00B8D9)",
    "color.icon.accent.blue": "var(--ds-icon-accent-blue, #0065FF)",
    "color.icon.accent.purple": "var(--ds-icon-accent-purple, #6554C0)",
    "color.icon.accent.magenta": "var(--ds-icon-accent-magenta, #CD519D)",
    "color.icon.accent.gray": "var(--ds-icon-accent-gray, #5E6C84)",
    "color.icon.disabled": "var(--ds-icon-disabled, #8993A4)",
    "color.icon.inverse": "var(--ds-icon-inverse, #FFFFFF)",
    "color.icon.selected": "var(--ds-icon-selected, #0052CC)",
    "color.icon.brand": "var(--ds-icon-brand, #0065FF)",
    "color.icon.danger": "var(--ds-icon-danger, #DE350B)",
    "color.icon.warning": "var(--ds-icon-warning, #FFC400)",
    "color.icon.warning.inverse": "var(--ds-icon-warning-inverse, #253858)",
    "color.icon.success": "var(--ds-icon-success, #00875A)",
    "color.icon.discovery": "var(--ds-icon-discovery, #8777D9)",
    "color.icon.information": "var(--ds-icon-information, #0747A6)",
    "color.icon.subtle": "var(--ds-icon-subtle, #6B778C)"
};
var $6b973a4bf6af2429$export$b5f31a7e431d2eab = {
    card: 100,
    navigation: 200,
    dialog: 300,
    layer: 400,
    blanket: 500,
    modal: 510,
    flag: 600,
    spotlight: 700,
    tooltip: 800
};
var $6b973a4bf6af2429$export$e1b83c5210c471b8 = {
    "border.width": "var(--ds-border-width, 1px)",
    "border.width.0": "var(--ds-border-width-0, 0px)",
    "border.width.indicator": "var(--ds-border-width-indicator, 3px)",
    "border.width.outline": "var(--ds-border-width-outline, 2px)"
};
var $6b973a4bf6af2429$export$3c0a6c3e64bb180d = {
    "border.radius.050": "var(--ds-border-radius-050, 2px)",
    "border.radius": "var(--ds-border-radius, 3px)",
    "border.radius.100": "var(--ds-border-radius-100, 3px)",
    "border.radius.200": "var(--ds-border-radius-200, 8px)",
    "border.radius.300": "var(--ds-border-radius-300, 12px)",
    "border.radius.400": "var(--ds-border-radius-400, 16px)",
    "border.radius.circle": "var(--ds-border-radius-circle, 32032px)"
};
var $6b973a4bf6af2429$export$6cc560b4dedf3816 = {
    medium: 'var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    UNSAFE_small: 'var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    large: 'var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    small: 'var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)'
};
var $6b973a4bf6af2429$export$303e322c6b1ed114 = {
    bold: "var(--ds-font-weight-bold, 700)",
    medium: "var(--ds-font-weight-medium, 500)",
    regular: "var(--ds-font-weight-regular, 400)",
    semibold: "var(--ds-font-weight-semibold, 600)"
};
var $6b973a4bf6af2429$export$3c7e9587132614b4 = {
    "font.family.body": 'var(--ds-font-family-body, ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.family.brand.body": 'var(--ds-font-family-brand-body, "Charlie Text", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.family.brand.heading": 'var(--ds-font-family-brand-heading, "Charlie Display", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.family.code": 'var(--ds-font-family-code, ui-monospace, Menlo, "Segoe UI Mono", "Ubuntu Mono", monospace)',
    "font.family.heading": 'var(--ds-font-family-heading, ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)'
};
/**
 * @codegenEnd
 */ // Generate maps for Box props. backgroundColor, padding, etc
var $6b973a4bf6af2429$var$spacingProperties = [
    // Used by Box
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    // Used by Inline and Stack
    "gap",
    "rowGap",
    "columnGap"
];
var $6b973a4bf6af2429$var$getSerializedStylesMap = function getSerializedStylesMap(cssProperty, tokenMap) {
    return Object.keys(tokenMap).reduce(function(emotionSpacingMap, token) {
        emotionSpacingMap[token] = (0, $jVTBW.css)((0, (/*@__PURE__*/$parcel$interopDefault($98i6Z)))({}, cssProperty, tokenMap[token]));
        return emotionSpacingMap;
    }, {});
};
var $6b973a4bf6af2429$export$e615f061ca585a6c = $6b973a4bf6af2429$var$spacingProperties.reduce(function(styleMap, spacingProperty) {
    styleMap[spacingProperty] = $6b973a4bf6af2429$var$getSerializedStylesMap(spacingProperty, $6b973a4bf6af2429$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
var $6b973a4bf6af2429$export$bf46c3f9eeafc71f = $6b973a4bf6af2429$var$spacingProperties.reduce(function(styleMap, spacingProperty) {
    styleMap[spacingProperty] = $6b973a4bf6af2429$var$getSerializedStylesMap(spacingProperty, $6b973a4bf6af2429$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
var $6b973a4bf6af2429$export$e7af83bafe7f9e63 = $6b973a4bf6af2429$var$getSerializedStylesMap("backgroundColor", $6b973a4bf6af2429$export$d1d79bf68ac056bd);
var $6b973a4bf6af2429$export$3a1bcba60b23d7f0 = $6b973a4bf6af2429$var$getSerializedStylesMap("color", $6b973a4bf6af2429$export$8473307aa00d6ea1);
var $6b973a4bf6af2429$export$45f3f4fe16f9f7d5 = $6b973a4bf6af2429$var$getSerializedStylesMap("fontWeight", $6b973a4bf6af2429$export$303e322c6b1ed114);
var $6b973a4bf6af2429$export$68cc305da27dbaa4 = $6b973a4bf6af2429$var$getSerializedStylesMap("fontFamily", $6b973a4bf6af2429$export$3c7e9587132614b4);
var $6b973a4bf6af2429$export$128f10c238242f83 = $6b973a4bf6af2429$var$getSerializedStylesMap("font", $6b973a4bf6af2429$export$6cc560b4dedf3816);
var $6b973a4bf6af2429$export$ff257d957d48c421 = $6b973a4bf6af2429$var$getSerializedStylesMap((0, $jGh1E.CURRENT_SURFACE_CSS_VAR), $6b973a4bf6af2429$export$41a358c9c2356760);
var $6b973a4bf6af2429$export$5e65a44e5b6ecadb = function isSurfaceColorToken(color) {
    return $6b973a4bf6af2429$export$41a358c9c2356760[color] !== undefined;
};

});
parcelRegister("98i6Z", function(module, exports) {

var $ijxoD = parcelRequire("ijxoD");
function $6a62e908734eb170$var$_defineProperty(e, r, t) {
    return (r = $ijxoD(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
module.exports = $6a62e908734eb170$var$_defineProperty, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("ijxoD", function(module, exports) {

var $13c3T = parcelRequire("13c3T");
var $d553e82d55059a7c$var$_typeof = $13c3T.default;

var $2PuIS = parcelRequire("2PuIS");
function $d553e82d55059a7c$var$toPropertyKey(t) {
    var i = $2PuIS(t, "string");
    return "symbol" == $d553e82d55059a7c$var$_typeof(i) ? i : i + "";
}
module.exports = $d553e82d55059a7c$var$toPropertyKey, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("13c3T", function(module, exports) {
function $0c3f6d7efe0e2b1b$var$_typeof(o) {
    "@babel/helpers - typeof";
    return module.exports = $0c3f6d7efe0e2b1b$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $0c3f6d7efe0e2b1b$var$_typeof(o);
}
module.exports = $0c3f6d7efe0e2b1b$var$_typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("2PuIS", function(module, exports) {

var $13c3T = parcelRequire("13c3T");
var $20f82d187ab3ae34$var$_typeof = $13c3T.default;
function $20f82d187ab3ae34$var$toPrimitive(t, r) {
    if ("object" != $20f82d187ab3ae34$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $20f82d187ab3ae34$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
module.exports = $20f82d187ab3ae34$var$toPrimitive, module.exports.__esModule = true, module.exports["default"] = module.exports;

});



parcelRegister("jGh1E", function(module, exports) {

$parcel$export(module.exports, "CURRENT_SURFACE_CSS_VAR", function () { return $e53f257afff8b835$export$9d7b58831ae93caa; });
var $e53f257afff8b835$export$4ef52930e33717cd = "data-theme";
var $e53f257afff8b835$export$a00eac3f8684bcd0 = "data-color-mode";
var $e53f257afff8b835$export$2112803007239c61 = "data-contrast-mode";
var $e53f257afff8b835$export$352e418ed5b6193a = "data-custom-theme";
var $e53f257afff8b835$export$2faeed762aac6741 = "light";
var $e53f257afff8b835$export$6f0c6fb8c80fcc92 = "ds";
var $e53f257afff8b835$export$4d0c7bbf80185957 = [
    "opacity",
    "font",
    "space",
    "border"
];
var $e53f257afff8b835$export$dddac1532e822863 = "--".concat($e53f257afff8b835$export$6f0c6fb8c80fcc92, "-token-not-found");
var $e53f257afff8b835$export$9d7b58831ae93caa = "--".concat($e53f257afff8b835$export$6f0c6fb8c80fcc92, "-elevation-surface-current");

});


parcelRegister("hHkUx", function(module, exports) {

$parcel$export(module.exports, "SurfaceContext", function () { return $ce26ac4bbf8dfff1$export$1ca2a26fecb070ae; });
$parcel$export(module.exports, "useSurface", function () { return $ce26ac4bbf8dfff1$export$1aeb4f6b93c4540d; });

var $dAx5m = parcelRequire("dAx5m");
var $ce26ac4bbf8dfff1$export$1ca2a26fecb070ae = /*#__PURE__*/ (0, $dAx5m.createContext)("elevation.surface");
var $ce26ac4bbf8dfff1$export$1aeb4f6b93c4540d = function useSurface() {
    return (0, $dAx5m.useContext)($ce26ac4bbf8dfff1$export$1ca2a26fecb070ae);
};
$ce26ac4bbf8dfff1$export$1ca2a26fecb070ae.displayName = "SurfaceProvider";

});



parcelRegister("1UvUH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1643c6c886c736c5$export$2e2bcd8739ae039; });

var $gpRqE = parcelRequire("gpRqE");

var $i77m2 = parcelRequire("i77m2");

var $dAx5m = parcelRequire("dAx5m");

var $jVTBW = parcelRequire("jVTBW");

var $9eHA8 = parcelRequire("9eHA8");

var $bLE1l = parcelRequire("bLE1l");

var $hHkUx = parcelRequire("hHkUx");
var $1643c6c886c736c5$var$_excluded = [
    "as",
    "children",
    "backgroundColor",
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    "style",
    "testId",
    "xcss"
], $1643c6c886c736c5$var$_excluded2 = [
    "className"
];
var $1643c6c886c736c5$export$e71c4d32a2263218 = /*#__PURE__*/ (0, $dAx5m.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? "div" : _ref$as, children = _ref.children, backgroundColor = _ref.backgroundColor, padding = _ref.padding, paddingBlock = _ref.paddingBlock, paddingBlockStart = _ref.paddingBlockStart, paddingBlockEnd = _ref.paddingBlockEnd, paddingInline = _ref.paddingInline, paddingInlineStart = _ref.paddingInlineStart, paddingInlineEnd = _ref.paddingInlineEnd, style = _ref.style, testId = _ref.testId, xcss = _ref.xcss, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($i77m2)))(_ref, $1643c6c886c736c5$var$_excluded);
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($i77m2)))(htmlAttributes, $1643c6c886c736c5$var$_excluded2);
    var resolvedStyles = (0, $bLE1l.parseXcss)(xcss);
    var node = // @ts-expect-error Expression produces a union type that is too complex to represent. I think this is unavoidable
    (0, $jVTBW.jsx)(Component, (0, (/*@__PURE__*/$parcel$interopDefault($gpRqE)))({
        style: style,
        ref: ref,
        className: resolvedStyles.static
    }, safeHtmlAttributes, {
        css: [
            $1643c6c886c736c5$var$baseStyles,
            backgroundColor && (0, $9eHA8.backgroundColorStylesMap)[backgroundColor],
            (0, $9eHA8.isSurfaceColorToken)(backgroundColor) && (0, $9eHA8.surfaceColorStylesMap)[backgroundColor],
            padding && (0, $9eHA8.paddingStylesMap).padding[padding],
            paddingBlock && (0, $9eHA8.paddingStylesMap).paddingBlock[paddingBlock],
            paddingBlockStart && (0, $9eHA8.paddingStylesMap).paddingBlockStart[paddingBlockStart],
            paddingBlockEnd && (0, $9eHA8.paddingStylesMap).paddingBlockEnd[paddingBlockEnd],
            paddingInline && (0, $9eHA8.paddingStylesMap).paddingInline[paddingInline],
            paddingInlineStart && (0, $9eHA8.paddingStylesMap).paddingInlineStart[paddingInlineStart],
            paddingInlineEnd && (0, $9eHA8.paddingStylesMap).paddingInlineEnd[paddingInlineEnd],
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
            resolvedStyles.emotion
        ],
        "data-testid": testId
    }), children);
    return backgroundColor ? (0, $jVTBW.jsx)((0, $hHkUx.SurfaceContext).Provider, {
        value: backgroundColor
    }, node) : node;
});
var $1643c6c886c736c5$export$2e2bcd8739ae039 = $1643c6c886c736c5$export$e71c4d32a2263218;
var $1643c6c886c736c5$var$baseStyles = (0, $jVTBW.css)({
    boxSizing: "border-box",
    appearance: "none",
    border: "none"
});

});
parcelRegister("bLE1l", function(module, exports) {

$parcel$export(module.exports, "parseXcss", function () { return $891320c6b3cd67e8$export$a9c84988c8f81f2d; });
$parcel$export(module.exports, "xcss", function () { return $891320c6b3cd67e8$export$f6c783d06584602c; });

var $hnzEk = parcelRequire("hnzEk");

var $98i6Z = parcelRequire("98i6Z");

var $6SC0T = parcelRequire("6SC0T");

var $13c3T = parcelRequire("13c3T");

var $jVTBW = parcelRequire("jVTBW");

var $9eHA8 = parcelRequire("9eHA8");

var $ahJoN = parcelRequire("ahJoN");
function $891320c6b3cd67e8$var$_createForOfIteratorHelper(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (!it) {
        if (Array.isArray(o) || (it = $891320c6b3cd67e8$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
            if (it) o = it;
            var i = 0;
            var F = function F() {};
            return {
                s: F,
                n: function n() {
                    if (i >= o.length) return {
                        done: true
                    };
                    return {
                        done: false,
                        value: o[i++]
                    };
                },
                e: function e(_e) {
                    throw _e;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var normalCompletion = true, didErr = false, err;
    return {
        s: function s() {
            it = it.call(o);
        },
        n: function n() {
            var step = it.next();
            normalCompletion = step.done;
            return step;
        },
        e: function e(_e2) {
            didErr = true;
            err = _e2;
        },
        f: function f() {
            try {
                if (!normalCompletion && it.return != null) it.return();
            } finally{
                if (didErr) throw err;
            }
        }
    };
}
function $891320c6b3cd67e8$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $891320c6b3cd67e8$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $891320c6b3cd67e8$var$_arrayLikeToArray(o, minLen);
}
function $891320c6b3cd67e8$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $891320c6b3cd67e8$export$9a199fbafee0014e = {
    backgroundColor: (0, $9eHA8.backgroundColorMap),
    blockSize: (0, $9eHA8.dimensionMap),
    borderBlockColor: (0, $9eHA8.borderColorMap),
    borderBlockEndColor: (0, $9eHA8.borderColorMap),
    borderBlockEndWidth: (0, $9eHA8.borderWidthMap),
    borderBlockStartColor: (0, $9eHA8.borderColorMap),
    borderBlockStartWidth: (0, $9eHA8.borderWidthMap),
    borderBlockWidth: (0, $9eHA8.borderWidthMap),
    borderBottomColor: (0, $9eHA8.borderColorMap),
    borderBottomLeftRadius: (0, $9eHA8.borderRadiusMap),
    borderBottomRightRadius: (0, $9eHA8.borderRadiusMap),
    borderBottomWidth: (0, $9eHA8.borderWidthMap),
    borderColor: (0, $9eHA8.borderColorMap),
    borderEndEndRadius: (0, $9eHA8.borderRadiusMap),
    borderEndStartRadius: (0, $9eHA8.borderRadiusMap),
    borderInlineColor: (0, $9eHA8.borderColorMap),
    borderInlineEndColor: (0, $9eHA8.borderColorMap),
    borderInlineEndWidth: (0, $9eHA8.borderWidthMap),
    borderInlineStartColor: (0, $9eHA8.borderColorMap),
    borderInlineStartWidth: (0, $9eHA8.borderWidthMap),
    borderInlineWidth: (0, $9eHA8.borderWidthMap),
    borderLeftColor: (0, $9eHA8.borderColorMap),
    borderLeftWidth: (0, $9eHA8.borderWidthMap),
    borderRadius: (0, $9eHA8.borderRadiusMap),
    borderRightColor: (0, $9eHA8.borderColorMap),
    borderRightWidth: (0, $9eHA8.borderWidthMap),
    borderStartEndRadius: (0, $9eHA8.borderRadiusMap),
    borderStartStartRadius: (0, $9eHA8.borderRadiusMap),
    borderTopColor: (0, $9eHA8.borderColorMap),
    borderTopLeftRadius: (0, $9eHA8.borderRadiusMap),
    borderTopRightRadius: (0, $9eHA8.borderRadiusMap),
    borderTopWidth: (0, $9eHA8.borderWidthMap),
    borderWidth: (0, $9eHA8.borderWidthMap),
    bottom: (0, $9eHA8.allSpaceMap),
    boxShadow: (0, $9eHA8.shadowMap),
    color: (0, $9eHA8.textColorMap),
    columnGap: (0, $9eHA8.positiveSpaceMap),
    gap: (0, $9eHA8.positiveSpaceMap),
    height: (0, $9eHA8.dimensionMap),
    inlineSize: (0, $9eHA8.dimensionMap),
    inset: (0, $9eHA8.allSpaceMap),
    insetBlock: (0, $9eHA8.allSpaceMap),
    insetBlockEnd: (0, $9eHA8.allSpaceMap),
    insetBlockStart: (0, $9eHA8.allSpaceMap),
    insetInline: (0, $9eHA8.allSpaceMap),
    insetInlineEnd: (0, $9eHA8.allSpaceMap),
    insetInlineStart: (0, $9eHA8.allSpaceMap),
    left: (0, $9eHA8.allSpaceMap),
    margin: (0, $9eHA8.allSpaceMap),
    marginBlock: (0, $9eHA8.allSpaceMap),
    marginBlockEnd: (0, $9eHA8.allSpaceMap),
    marginBlockStart: (0, $9eHA8.allSpaceMap),
    marginBottom: (0, $9eHA8.allSpaceMap),
    marginInline: (0, $9eHA8.allSpaceMap),
    marginInlineEnd: (0, $9eHA8.allSpaceMap),
    marginInlineStart: (0, $9eHA8.allSpaceMap),
    marginLeft: (0, $9eHA8.allSpaceMap),
    marginRight: (0, $9eHA8.allSpaceMap),
    marginTop: (0, $9eHA8.allSpaceMap),
    maxBlockSize: (0, $9eHA8.dimensionMap),
    maxHeight: (0, $9eHA8.dimensionMap),
    maxInlineSize: (0, $9eHA8.dimensionMap),
    maxWidth: (0, $9eHA8.dimensionMap),
    minBlockSize: (0, $9eHA8.dimensionMap),
    minHeight: (0, $9eHA8.dimensionMap),
    minInlineSize: (0, $9eHA8.dimensionMap),
    minWidth: (0, $9eHA8.dimensionMap),
    opacity: (0, $9eHA8.opacityMap),
    outlineColor: (0, $9eHA8.borderColorMap),
    outlineOffset: (0, $9eHA8.positiveSpaceMap),
    outlineWidth: (0, $9eHA8.borderWidthMap),
    padding: (0, $9eHA8.positiveSpaceMap),
    paddingBlock: (0, $9eHA8.positiveSpaceMap),
    paddingBlockEnd: (0, $9eHA8.positiveSpaceMap),
    paddingBlockStart: (0, $9eHA8.positiveSpaceMap),
    paddingBottom: (0, $9eHA8.positiveSpaceMap),
    paddingInline: (0, $9eHA8.positiveSpaceMap),
    paddingInlineEnd: (0, $9eHA8.positiveSpaceMap),
    paddingInlineStart: (0, $9eHA8.positiveSpaceMap),
    paddingLeft: (0, $9eHA8.positiveSpaceMap),
    paddingRight: (0, $9eHA8.positiveSpaceMap),
    paddingTop: (0, $9eHA8.positiveSpaceMap),
    right: (0, $9eHA8.allSpaceMap),
    rowGap: (0, $9eHA8.positiveSpaceMap),
    top: (0, $9eHA8.allSpaceMap),
    width: (0, $9eHA8.dimensionMap),
    zIndex: (0, $9eHA8.layerMap)
};
var $891320c6b3cd67e8$var$uniqueSymbol = Symbol("UNSAFE_INTERNAL_styles");
var $891320c6b3cd67e8$var$isSafeEnvToThrow = function isSafeEnvToThrow() {
    return (typeof $ahJoN === "undefined" ? "undefined" : (0, (/*@__PURE__*/$parcel$interopDefault($13c3T)))($ahJoN)) === "object" && (0, (/*@__PURE__*/$parcel$interopDefault($13c3T)))($ahJoN.env) === "object" && false;
};
var $891320c6b3cd67e8$var$reNestedSelectors = /(\.|\s|&+|\*\>|#|\[.*\])/;
var $891320c6b3cd67e8$var$safeSelectors = /^@media .*$|^::?.*$|^@supports .*$/;
var $891320c6b3cd67e8$var$transformStyles = function transformStyles(styleObj) {
    if (!styleObj || (0, (/*@__PURE__*/$parcel$interopDefault($13c3T)))(styleObj) !== "object") return styleObj;
    // If styles are defined as a CSSObject[], recursively call on each element until we reach CSSObject
    if (Array.isArray(styleObj)) return styleObj.map(transformStyles);
    // Modifies styleObj in place. Be careful.
    Object.entries(styleObj).forEach(function(_ref) {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($6SC0T)))(_ref, 2), key = _ref2[0], value = _ref2[1];
        // If key is a pseudo class or a pseudo element, then value should be an object.
        // So, call transformStyles on the value
        if ((0, (/*@__PURE__*/$parcel$interopDefault($13c3T)))(value) === "object" && $891320c6b3cd67e8$var$safeSelectors.test(key)) {
            styleObj[key] = transformStyles(value);
            return;
        }
        if ($891320c6b3cd67e8$var$isSafeEnvToThrow()) {
            // We don't support `.class`, `[data-testid]`, `> *`, `#some-id`
            if ($891320c6b3cd67e8$var$reNestedSelectors.test(key)) throw new Error("Styles not supported for key '".concat(key, "'."));
        }
        // We have now dealt with all the special cases, so,
        // check whether what remains is a style property
        // that can be transformed.
        if (!(key in $891320c6b3cd67e8$export$9a199fbafee0014e)) return;
        var tokenValue = $891320c6b3cd67e8$export$9a199fbafee0014e[key][value];
        styleObj[key] = tokenValue !== null && tokenValue !== void 0 ? tokenValue : value;
    });
    return styleObj;
};
var $891320c6b3cd67e8$var$baseXcss = function baseXcss(style) {
    var transformedStyles = $891320c6b3cd67e8$var$transformStyles(style);
    return (0, (/*@__PURE__*/$parcel$interopDefault($98i6Z)))({}, $891320c6b3cd67e8$var$uniqueSymbol, (0, $jVTBW.css)(transformedStyles));
};
var $891320c6b3cd67e8$export$a9c84988c8f81f2d = function parseXcss(args) {
    if (Array.isArray(args)) {
        var emotion = [];
        var staticArr = [];
        var _iterator = $891320c6b3cd67e8$var$_createForOfIteratorHelper(args), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var arg = _step.value;
                var result = parseXcss(arg);
                if (result.emotion) emotion.push.apply(emotion, (0, (/*@__PURE__*/$parcel$interopDefault($hnzEk)))(result.emotion));
                if (result.static) staticArr.push(result.static);
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        return {
            emotion: emotion,
            static: staticArr.join(" ")
        };
    }
    var objArgs = args;
    var _ref4 = objArgs || {}, styles = _ref4[$891320c6b3cd67e8$var$uniqueSymbol];
    if (styles) return {
        emotion: [
            styles
        ]
    };
    if (args) {
        // We use string interpolation here instead of .toString() just
        // in case the resulting object doesn't have the method available.
        var stringifiedArgs = "".concat(args);
        if (stringifiedArgs) return {
            static: stringifiedArgs
        };
    }
    return {};
};
function $891320c6b3cd67e8$export$f6c783d06584602c(style) {
    return $891320c6b3cd67e8$var$baseXcss(style);
}

});
parcelRegister("hnzEk", function(module, exports) {

var $cwRCp = parcelRequire("cwRCp");

var $i6CBi = parcelRequire("i6CBi");

var $1X67X = parcelRequire("1X67X");

var $9ItRT = parcelRequire("9ItRT");
function $ca703cdff01d01a4$var$_toConsumableArray(r) {
    return $cwRCp(r) || $i6CBi(r) || $1X67X(r) || $9ItRT();
}
module.exports = $ca703cdff01d01a4$var$_toConsumableArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("cwRCp", function(module, exports) {

var $hxI3g = parcelRequire("hxI3g");
function $91f210b3da24c6cb$var$_arrayWithoutHoles(r) {
    if (Array.isArray(r)) return $hxI3g(r);
}
module.exports = $91f210b3da24c6cb$var$_arrayWithoutHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("i6CBi", function(module, exports) {
function $d2e6bacc00b606cf$var$_iterableToArray(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
module.exports = $d2e6bacc00b606cf$var$_iterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("9ItRT", function(module, exports) {
function $712f64531d80fd05$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
module.exports = $712f64531d80fd05$var$_nonIterableSpread, module.exports.__esModule = true, module.exports["default"] = module.exports;

});




parcelRegister("6hOx2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $493b87328ca05512$export$2e2bcd8739ae039; });

var $hnzEk = parcelRequire("hnzEk");

var $dAx5m = parcelRequire("dAx5m");

var $jVTBW = parcelRequire("jVTBW");

var $bLE1l = parcelRequire("bLE1l");

var $9U2vO = parcelRequire("9U2vO");
var $493b87328ca05512$var$flexGrowMap = {
    hug: (0, $bLE1l.xcss)({
        flexGrow: 0
    }),
    fill: (0, $bLE1l.xcss)({
        width: "100%",
        flexGrow: 1
    })
};
var $493b87328ca05512$var$separatorStyles = (0, $jVTBW.css)({
    color: "var(--ds-text-subtle, #42526E)",
    marginBlock: "var(--ds-space-0, 0px)",
    marginInline: "var(--ds-space-negative-025, -2px)",
    pointerEvents: "none",
    userSelect: "none"
});
var $493b87328ca05512$var$Separator = function Separator(_ref) {
    var children = _ref.children;
    return (0, $jVTBW.jsx)("span", {
        css: $493b87328ca05512$var$separatorStyles
    }, children);
};
/**
 * __Inline__
 *
 * Inline is a primitive component based on CSS Flexbox that manages the horizontal layout of direct children.
 *
 * @example
 * ```tsx
 *  <Inline>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *  </Inline>
 * ```
 *
 */ var $493b87328ca05512$var$Inline = /*#__PURE__*/ (0, $dAx5m.memo)(/*#__PURE__*/ (0, $dAx5m.forwardRef)(function(_ref2, ref) {
    var as = _ref2.as, alignInline = _ref2.alignInline, _ref2$alignBlock = _ref2.alignBlock, alignItems = _ref2$alignBlock === void 0 ? "start" : _ref2$alignBlock, _ref2$shouldWrap = _ref2.shouldWrap, shouldWrap = _ref2$shouldWrap === void 0 ? false : _ref2$shouldWrap, spread = _ref2.spread, grow = _ref2.grow, space = _ref2.space, rowSpace = _ref2.rowSpace, separator = _ref2.separator, xcss = _ref2.xcss, testId = _ref2.testId, role = _ref2.role, rawChildren = _ref2.children;
    var separatorComponent = typeof separator === "string" ? (0, $jVTBW.jsx)($493b87328ca05512$var$Separator, null, separator) : separator;
    var children = separatorComponent ? (0, $dAx5m.Children).toArray(rawChildren).filter(Boolean).map(function(child, index) {
        return (0, $jVTBW.jsx)((0, $dAx5m.Fragment), {
            key: index
        }, separator && index > 0 ? separatorComponent : null, child);
    }) : rawChildren;
    var justifyContent = spread || alignInline;
    // We're type coercing this as Compiled styles in an array isn't supported by the types
    // But the runtime accepts it none-the-wiser. We can remove this entire block and replace
    // it with cx(defaultStyles, focusRingStyles, xcssStyles) when we've moved away from Emotion.
    var styles = grow ? [
        $493b87328ca05512$var$flexGrowMap[grow]
    ].concat((0, (/*@__PURE__*/$parcel$interopDefault($hnzEk)))(Array.isArray(xcss) ? xcss : [
        xcss
    ])) : xcss;
    return (0, $jVTBW.jsx)((0, $9U2vO.default), {
        as: as,
        role: role,
        alignItems: alignItems,
        justifyContent: justifyContent,
        direction: "row",
        gap: space,
        rowGap: rowSpace,
        wrap: shouldWrap ? "wrap" : undefined,
        xcss: styles,
        testId: testId,
        ref: ref
    }, children);
}));
$493b87328ca05512$var$Inline.displayName = "Inline";
var $493b87328ca05512$export$2e2bcd8739ae039 = $493b87328ca05512$var$Inline;

});
parcelRegister("9U2vO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $735b4ae51785baa2$export$2e2bcd8739ae039; });
/** @jsx jsx */ 
var $dAx5m = parcelRequire("dAx5m");

var $jVTBW = parcelRequire("jVTBW");

var $9eHA8 = parcelRequire("9eHA8");

var $bLE1l = parcelRequire("bLE1l");
var $735b4ae51785baa2$var$justifyContentMap = {
    start: (0, $jVTBW.css)({
        justifyContent: "start"
    }),
    center: (0, $jVTBW.css)({
        justifyContent: "center"
    }),
    end: (0, $jVTBW.css)({
        justifyContent: "end"
    }),
    "space-between": (0, $jVTBW.css)({
        justifyContent: "space-between"
    }),
    "space-around": (0, $jVTBW.css)({
        justifyContent: "space-around"
    }),
    "space-evenly": (0, $jVTBW.css)({
        justifyContent: "space-evenly"
    }),
    stretch: (0, $jVTBW.css)({
        justifyContent: "stretch"
    })
};
var $735b4ae51785baa2$var$flexDirectionMap = {
    column: (0, $jVTBW.css)({
        flexDirection: "column"
    }),
    row: (0, $jVTBW.css)({
        flexDirection: "row"
    })
};
var $735b4ae51785baa2$var$flexWrapMap = {
    wrap: (0, $jVTBW.css)({
        flexWrap: "wrap"
    }),
    nowrap: (0, $jVTBW.css)({
        flexWrap: "nowrap"
    })
};
var $735b4ae51785baa2$var$alignItemsMap = {
    start: (0, $jVTBW.css)({
        alignItems: "start"
    }),
    center: (0, $jVTBW.css)({
        alignItems: "center"
    }),
    baseline: (0, $jVTBW.css)({
        alignItems: "baseline"
    }),
    end: (0, $jVTBW.css)({
        alignItems: "end"
    }),
    stretch: (0, $jVTBW.css)({
        alignItems: "stretch"
    })
};
var $735b4ae51785baa2$var$baseStyles = (0, $jVTBW.css)({
    display: "flex",
    boxSizing: "border-box"
});
/**
 * __Flex__
 *
 * `Flex` is a primitive component that implements the CSS Flexbox API.
 *
 * - [Examples](https://atlassian.design/components/primitives/flex/examples)
 * - [Code](https://atlassian.design/components/primitives/flex/code)
 *
 * @example
 * ```tsx
 * import { Flex, Box } from '@atlaskit/primitives'
 *
 * const Component = () => (
 *   <Flex direction="column">
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *   </Flex>
 * )
 * ```
 */ var $735b4ae51785baa2$var$Flex = /*#__PURE__*/ (0, $dAx5m.memo)(/*#__PURE__*/ (0, $dAx5m.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? "div" : _ref$as, role = _ref.role, alignItems = _ref.alignItems, justifyContent = _ref.justifyContent, gap = _ref.gap, columnGap = _ref.columnGap, rowGap = _ref.rowGap, children = _ref.children, testId = _ref.testId, direction = _ref.direction, wrap = _ref.wrap, xcss = _ref.xcss;
    var resolvedStyles = (0, $bLE1l.parseXcss)(xcss);
    return (0, $jVTBW.jsx)(Component, {
        role: role,
        className: resolvedStyles.static,
        css: [
            $735b4ae51785baa2$var$baseStyles,
            gap && (0, $9eHA8.spaceStylesMap).gap[gap],
            columnGap && (0, $9eHA8.spaceStylesMap).columnGap[columnGap],
            rowGap && (0, $9eHA8.spaceStylesMap).rowGap[rowGap],
            alignItems && $735b4ae51785baa2$var$alignItemsMap[alignItems],
            direction && $735b4ae51785baa2$var$flexDirectionMap[direction],
            justifyContent && $735b4ae51785baa2$var$justifyContentMap[justifyContent],
            wrap && $735b4ae51785baa2$var$flexWrapMap[wrap],
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
            resolvedStyles.emotion
        ],
        "data-testid": testId,
        ref: ref
    }, children);
}));
$735b4ae51785baa2$var$Flex.displayName = "Flex";
var $735b4ae51785baa2$export$2e2bcd8739ae039 = $735b4ae51785baa2$var$Flex;

});


parcelRegister("6rPY8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4b1d939fe21a1834$export$2e2bcd8739ae039; });

var $hnzEk = parcelRequire("hnzEk");

var $dAx5m = parcelRequire("dAx5m");

var $jVTBW = parcelRequire("jVTBW");

var $bLE1l = parcelRequire("bLE1l");

var $9U2vO = parcelRequire("9U2vO");
var $4b1d939fe21a1834$var$flexGrowMap = {
    hug: (0, $bLE1l.xcss)({
        flexGrow: 0
    }),
    fill: (0, $bLE1l.xcss)({
        width: "100%",
        flexGrow: 1
    })
};
/**
 * __Stack__
 *
 * Stack is a primitive component based on flexbox that manages the block layout of direct children.
 *
 * @example
 * ```tsx
 *  <Stack>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *  </Stack>
 * ```
 *
 */ var $4b1d939fe21a1834$var$Stack = /*#__PURE__*/ (0, $dAx5m.memo)(/*#__PURE__*/ (0, $dAx5m.forwardRef)(function(_ref, ref) {
    var as = _ref.as, alignItems = _ref.alignInline, _ref$alignBlock = _ref.alignBlock, alignBlock = _ref$alignBlock === void 0 ? "stretch" : _ref$alignBlock, spread = _ref.spread, grow = _ref.grow, space = _ref.space, children = _ref.children, testId = _ref.testId, xcss = _ref.xcss, role = _ref.role;
    var justifyContent = spread || alignBlock;
    // We're type coercing this as Compiled styles in an array isn't supported by the types
    // But the runtime accepts it none-the-wiser. We can remove this entire block and replace
    // it with cx(defaultStyles, focusRingStyles, xcssStyles) when we've moved away from Emotion.
    var styles = grow ? [
        $4b1d939fe21a1834$var$flexGrowMap[grow]
    ].concat((0, (/*@__PURE__*/$parcel$interopDefault($hnzEk)))(Array.isArray(xcss) ? xcss : [
        xcss
    ])) : xcss;
    return (0, $jVTBW.jsx)((0, $9U2vO.default), {
        as: as,
        role: role,
        gap: space,
        direction: "column",
        alignItems: alignItems,
        justifyContent: justifyContent,
        xcss: styles,
        testId: testId,
        ref: ref
    }, children);
}));
$4b1d939fe21a1834$var$Stack.displayName = "Stack";
var $4b1d939fe21a1834$export$2e2bcd8739ae039 = $4b1d939fe21a1834$var$Stack;

});

parcelRegister("4UPjW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3944339227eb6706$export$2e2bcd8739ae039; });
/** @jsx jsx */ 
var $dAx5m = parcelRequire("dAx5m");

var $jVTBW = parcelRequire("jVTBW");

var $3P18c = parcelRequire("3P18c");

var $9eHA8 = parcelRequire("9eHA8");

var $hHkUx = parcelRequire("hHkUx");
var $3944339227eb6706$var$asAllowlist = [
    "span",
    "p",
    "strong",
    "em"
];
// We're doing this because our CSS reset can add top margins to elements such as `p` which is totally insane.
// Long term we should remove those instances from the reset - it should be a reset to 0.
// For now, at least we know <Text> will be unaffected by this.
var $3944339227eb6706$var$resetStyles = (0, $jVTBW.css)({
    margin: 0
});
var $3944339227eb6706$var$strongStyles = (0, $jVTBW.css)({
    fontWeight: "bold"
});
var $3944339227eb6706$var$emStyles = (0, $jVTBW.css)({
    fontStyle: "italic"
});
var $3944339227eb6706$var$textAlignMap = {
    center: (0, $jVTBW.css)({
        textAlign: "center"
    }),
    end: (0, $jVTBW.css)({
        textAlign: "end"
    }),
    start: (0, $jVTBW.css)({
        textAlign: "start"
    })
};
var $3944339227eb6706$var$truncationStyles = (0, $jVTBW.css)({
    display: "-webkit-box",
    overflow: "hidden",
    WebkitBoxOrient: "vertical"
});
var $3944339227eb6706$var$wordBreakMap = {
    breakAll: (0, $jVTBW.css)({
        wordBreak: "break-all"
    })
};
var $3944339227eb6706$var$HasTextAncestorContext = /*#__PURE__*/ (0, $dAx5m.createContext)(false);
var $3944339227eb6706$var$useHasTextAncestor = function useHasTextAncestor() {
    return (0, $dAx5m.useContext)($3944339227eb6706$var$HasTextAncestorContext);
};
/**
 * Custom hook designed to abstract the parsing of the color props and make it clearer in the future how color is reconciled between themes and tokens.
 */ var $3944339227eb6706$var$useColor = function useColor(colorProp, hasTextAncestor) {
    var surface = (0, $hHkUx.useSurface)();
    /**
   * Where the color of the surface is inverted we always override the color
   * as there is no valid choice that is not covered by the override.
   */ if ((0, $9eHA8.inverseColorMap).hasOwnProperty(surface)) return (0, $9eHA8.inverseColorMap)[surface];
    if (colorProp === "inherit") return undefined;
    if (!colorProp && hasTextAncestor) return undefined;
    return colorProp || "color.text";
};
/**
 * __Text__
 *
 * Text is a primitive component that has the Atlassian Design System's design guidelines baked in.
 * This includes considerations for text attributes such as color, font size, font weight, and line height.
 * It renders a `span` by default.
 *
 * @internal
 */ var $3944339227eb6706$var$Text = /*#__PURE__*/ (0, $dAx5m.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? "span" : _ref$as, colorProp = _ref.color, align = _ref.align, testId = _ref.testId, id = _ref.id, _ref$size = _ref.size, size = _ref$size === void 0 ? "medium" : _ref$size, weight = _ref.weight, maxLines = _ref.maxLines, children = _ref.children;
    (0, $3P18c.default)($3944339227eb6706$var$asAllowlist.includes(Component), '@atlaskit/primitives: Text received an invalid "as" value of "'.concat(Component, '"'));
    var hasTextAncestor = $3944339227eb6706$var$useHasTextAncestor();
    var color = $3944339227eb6706$var$useColor(colorProp, hasTextAncestor);
    var component = (0, $jVTBW.jsx)(Component, {
        ref: ref,
        css: [
            $3944339227eb6706$var$resetStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $9eHA8.fontStylesMap)[size],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            color && (0, $9eHA8.textColorStylesMap)[color],
            maxLines && $3944339227eb6706$var$truncationStyles,
            maxLines === 1 && $3944339227eb6706$var$wordBreakMap.breakAll,
            align && $3944339227eb6706$var$textAlignMap[align],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            weight && (0, $9eHA8.fontWeightStylesMap)[weight],
            Component === "em" && $3944339227eb6706$var$emStyles,
            Component === "strong" && $3944339227eb6706$var$strongStyles
        ],
        style: {
            WebkitLineClamp: maxLines
        },
        "data-testid": testId,
        id: id
    }, children);
    return hasTextAncestor ? // no need to re-apply context if the text is already wrapped
    component : (0, $jVTBW.jsx)($3944339227eb6706$var$HasTextAncestorContext.Provider, {
        value: true
    }, component);
});
var $3944339227eb6706$export$2e2bcd8739ae039 = $3944339227eb6706$var$Text;

});

parcelRegister("3XhKI", function(module, exports) {

$parcel$export(module.exports, "getAppearanceIconStyles", function () { return $2e14a70d978c49eb$export$e9b82d2e21ac0c1f; });

var $98i6Z = parcelRequire("98i6Z");

var $dAx5m = parcelRequire("dAx5m");

var $lMe0h = parcelRequire("lMe0h");

var $lPU7p = parcelRequire("lPU7p");

var $1AV7l = parcelRequire("1AV7l");

var $9sLA5 = parcelRequire("9sLA5");

var $jsTBk = parcelRequire("jsTBk");

var $83Zvp = parcelRequire("83Zvp");
function $2e14a70d978c49eb$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $2e14a70d978c49eb$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $2e14a70d978c49eb$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($98i6Z)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $2e14a70d978c49eb$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $2e14a70d978c49eb$export$faa35441caff5bb6 = {
    information: {
        backgroundColor: "var(--ds-background-information, ".concat((0, $83Zvp.B50), ")"),
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($1AV7l))),
        primaryIconColor: "var(--ds-icon-information, ".concat((0, $83Zvp.B500), ")")
    },
    warning: {
        backgroundColor: "var(--ds-background-warning, ".concat((0, $83Zvp.Y50), ")"),
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($jsTBk))),
        primaryIconColor: "var(--ds-icon-warning, ".concat((0, $83Zvp.Y500), ")")
    },
    error: {
        backgroundColor: "var(--ds-background-danger, ".concat((0, $83Zvp.R50), ")"),
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($lPU7p))),
        primaryIconColor: "var(--ds-icon-danger, ".concat((0, $83Zvp.R500), ")")
    },
    success: {
        backgroundColor: "var(--ds-background-success, ".concat((0, $83Zvp.G50), ")"),
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($lMe0h))),
        primaryIconColor: "var(--ds-icon-success, ".concat((0, $83Zvp.G500), ")")
    },
    discovery: {
        backgroundColor: "var(--ds-background-discovery, ".concat((0, $83Zvp.P50), ")"),
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($9sLA5))),
        primaryIconColor: "var(--ds-icon-discovery, ".concat((0, $83Zvp.P500), ")")
    }
};
function $2e14a70d978c49eb$export$e9b82d2e21ac0c1f(appearance, icon) {
    var appearanceIconStyles = $2e14a70d978c49eb$export$faa35441caff5bb6[appearance] || $2e14a70d978c49eb$export$faa35441caff5bb6.information;
    var AppearanceIcon = function AppearanceIcon(_ref) {
        var size = _ref.size, primaryColor = _ref.primaryColor, secondaryColor = _ref.secondaryColor;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement(appearanceIconStyles.Icon, {
            size: size,
            primaryColor: primaryColor,
            secondaryColor: secondaryColor,
            label: appearance
        });
    };
    var Icon = icon || AppearanceIcon;
    return $2e14a70d978c49eb$var$_objectSpread($2e14a70d978c49eb$var$_objectSpread({}, appearanceIconStyles), {}, {
        Icon: Icon
    });
}

});
parcelRegister("lMe0h", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $fda8f17af97f2e21$var$_react = $fda8f17af97f2e21$var$_interopRequireDefault((parcelRequire("dAx5m")));

var $eAey6 = parcelRequire("eAey6");

var $fda8f17af97f2e21$var$_success = $fda8f17af97f2e21$var$_interopRequireDefault((parcelRequire("4jfp5")));
function $fda8f17af97f2e21$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $fda8f17af97f2e21$var$CheckCircleIcon = (props)=>/*#__PURE__*/ $fda8f17af97f2e21$var$_react.default.createElement($eAey6.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="10" fill="currentcolor"/><path fill="inherit" d="M9.707 11.293a1 1 0 1 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4a1 1 0 1 0-1.414-1.414L11 12.586z"/></g></svg>`
    }, props, {
        newIcon: $fda8f17af97f2e21$var$_success.default
    }));
$fda8f17af97f2e21$var$CheckCircleIcon.displayName = "CheckCircleIcon";
var $fda8f17af97f2e21$var$_default = module.exports.default = $fda8f17af97f2e21$var$CheckCircleIcon;

});
parcelRegister("eAey6", function(module, exports) {

$parcel$export(module.exports, "IconFacade", function () { return $a9dfb6a34f7f470c$export$3cfb73f70dfca966; });

var $gpRqE = parcelRequire("gpRqE");

var $i77m2 = parcelRequire("i77m2");

var $dAx5m = parcelRequire("dAx5m");

var $hOJiY = parcelRequire("hOJiY");

var $421zI = parcelRequire("421zI");
var $a9dfb6a34f7f470c$var$_excluded = [
    "dangerouslySetGlyph"
];
var $a9dfb6a34f7f470c$var$sizesEligibleForNewIcons = [
    "small",
    "medium"
];
var $a9dfb6a34f7f470c$export$3cfb73f70dfca966 = /*#__PURE__*/ (0, $dAx5m.memo)(function IconFacade(_ref) {
    var _props$size;
    var dangerouslySetGlyph = _ref.dangerouslySetGlyph, props = (0, (/*@__PURE__*/$parcel$interopDefault($i77m2)))(_ref, $a9dfb6a34f7f470c$var$_excluded);
    var NewIcon = props.newIcon;
    // By default, the icon size will be medium and spacing will be none for small icons
    var size = (_props$size = props.size) !== null && _props$size !== void 0 ? _props$size : "medium";
    var spacing = size === "small" ? "none" : "spacious";
    var useNewIcon = !props.isFacadeDisabled && // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
    (0, $hOJiY.fg)("platform-visual-refresh-icons-legacy-facade") && $a9dfb6a34f7f470c$var$sizesEligibleForNewIcons.includes(size);
    if (useNewIcon && NewIcon) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement(NewIcon, (0, (/*@__PURE__*/$parcel$interopDefault($gpRqE)))({}, props, {
        spacing: spacing,
        color: props.primaryColor || "currentColor",
        type: props.iconType
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $421zI.default), (0, (/*@__PURE__*/$parcel$interopDefault($gpRqE)))({
        dangerouslySetGlyph: dangerouslySetGlyph
    }, props));
});
var $a9dfb6a34f7f470c$export$2e2bcd8739ae039 = $a9dfb6a34f7f470c$export$3cfb73f70dfca966;

});
parcelRegister("hOJiY", function(module, exports) {

$parcel$export(module.exports, "fg", function () { return $cf8a3fcb784ac81a$export$b40ec24ac8275656; });

var $fpbUw = parcelRequire("fpbUw");
function $cf8a3fcb784ac81a$export$ba05d765b8392e5e(flagResolver) {
    (0, $fpbUw.setBooleanResolver)(flagResolver);
}
function $cf8a3fcb784ac81a$export$470e5c2be1411c89(name) {
    return (0, $fpbUw.resolveBooleanFlag)(name);
}
function $cf8a3fcb784ac81a$export$b40ec24ac8275656(name) {
    return (0, $fpbUw.resolveBooleanFlag)(name);
}

});
parcelRegister("fpbUw", function(module, exports) {

$parcel$export(module.exports, "setBooleanResolver", function () { return $b3726e0824307247$export$f2b591175b3e424c; });
$parcel$export(module.exports, "resolveBooleanFlag", function () { return $b3726e0824307247$export$6333b6aff9fc6275; });

var $b7gNV = parcelRequire("b7gNV");

var $ahJoN = parcelRequire("ahJoN");
var $b3726e0824307247$var$pkgName = "@atlaskit/platform-feature-flags";
var $b3726e0824307247$export$7e41b1b2bdee3f98 = "__PLATFORM_FEATURE_FLAGS__";
var $b3726e0824307247$var$hasProcessEnv = typeof $ahJoN !== "undefined" && typeof $ahJoN.env !== "undefined";
// FF global overrides can be configured by test runners or Storybook
var $b3726e0824307247$var$ENV_ENABLE_PLATFORM_FF = $b3726e0824307247$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
// STORYBOOK_ENABLE_PLATFORM_FF is included as storybook only allows env vars prefixed with STORYBOOK
// https://github.com/storybookjs/storybook/issues/12270
var $b3726e0824307247$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF = $b3726e0824307247$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
var $b3726e0824307247$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE = $b3726e0824307247$var$ENV_ENABLE_PLATFORM_FF || $b3726e0824307247$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF;
var $b3726e0824307247$var$DEFAULT_PFF_GLOBAL = {
    // In development mode we want to capture any feature flag checks that happen using the default resolver and log this result when the resolver is replaced.
    // This is because evaluating feature flags when the resolver/FF client is loaded asynchronously could cause unexpected issues.
    earlyResolvedFlags: new Map(),
    booleanResolver: function booleanResolver(flagKey) {
        var unresolvedFlagCount;
        return false;
    }
};
var $b3726e0824307247$var$globalVar = typeof window !== "undefined" ? window : globalThis;
$b3726e0824307247$var$globalVar[$b3726e0824307247$export$7e41b1b2bdee3f98] = $b3726e0824307247$var$globalVar[$b3726e0824307247$export$7e41b1b2bdee3f98] || $b3726e0824307247$var$DEFAULT_PFF_GLOBAL;
function $b3726e0824307247$export$f2b591175b3e424c(resolver) {
    $b3726e0824307247$var$globalVar[$b3726e0824307247$export$7e41b1b2bdee3f98].booleanResolver = resolver;
    var _globalVar$PFF_GLOBAL;
}
function $b3726e0824307247$export$6333b6aff9fc6275(flagKey) {
    if ($b3726e0824307247$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE) {
        (0, $b7gNV.debug)('[%s]: The feature flags were enabled while running tests. The flag "%s" will be always enabled.', $b3726e0824307247$var$pkgName, flagKey);
        return true;
    }
    try {
        var _globalVar$PFF_GLOBAL2;
        var result = (_globalVar$PFF_GLOBAL2 = $b3726e0824307247$var$globalVar[$b3726e0824307247$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL2 === void 0 ? void 0 : _globalVar$PFF_GLOBAL2.booleanResolver(flagKey);
        if (typeof result !== "boolean") {
            // eslint-disable-next-line no-console
            console.warn("".concat(flagKey, " resolved to a non-boolean value, returning false for safety"));
            return false;
        }
        return result;
    } catch (e) {
        return false;
    }
}

});
parcelRegister("b7gNV", function(module, exports) {

$parcel$export(module.exports, "debug", function () { return $817d622022d5318d$export$1c9f709888824e05; });
var $817d622022d5318d$var$_ref, $817d622022d5318d$var$_process, $817d622022d5318d$var$_process2;
// We can't rely on NODE_ENV === 'test' if its value is already configured by the consumer to some other value, so better to use JEST_WORKER_ID
// https://jestjs.io/docs/environment-variables#jest_worker_id
var $817d622022d5318d$var$TESTS_MODE = ($817d622022d5318d$var$_ref = (globalThis === null || globalThis === void 0 || ($817d622022d5318d$var$_process = globalThis.process) === null || $817d622022d5318d$var$_process === void 0 || ($817d622022d5318d$var$_process = $817d622022d5318d$var$_process.env) === null || $817d622022d5318d$var$_process === void 0 ? void 0 : $817d622022d5318d$var$_process.JEST_WORKER_ID) !== undefined, $817d622022d5318d$var$_ref !== void 0) ? $817d622022d5318d$var$_ref : false;
var $817d622022d5318d$var$DEBUG_MODE = !$817d622022d5318d$var$TESTS_MODE && (globalThis === null || globalThis === void 0 || ($817d622022d5318d$var$_process2 = globalThis.process) === null || $817d622022d5318d$var$_process2 === void 0 || ($817d622022d5318d$var$_process2 = $817d622022d5318d$var$_process2.env) === null || $817d622022d5318d$var$_process2 === void 0 ? void 0 : $817d622022d5318d$var$_process2.NODE_ENV) !== "production";
var $817d622022d5318d$export$1c9f709888824e05 = function debug() {
    var _console;
    if (!$817d622022d5318d$var$DEBUG_MODE) return;
    // eslint-disable-next-line no-console
    (_console = console).debug.apply(_console, arguments);
};

});



parcelRegister("421zI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2ef8921483dd5541$export$2e2bcd8739ae039; });

var $gpRqE = parcelRequire("gpRqE");

var $98i6Z = parcelRequire("98i6Z");

var $dAx5m = parcelRequire("dAx5m");

var $jVTBW = parcelRequire("jVTBW");

var $2Z3sK = parcelRequire("2Z3sK");

var $7sWVu = parcelRequire("7sWVu");
function $2ef8921483dd5541$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $2ef8921483dd5541$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $2ef8921483dd5541$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($98i6Z)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $2ef8921483dd5541$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
/**
 * We are hiding these props from consumers as they're used to
 * hack around icon sizing specifically for icon-file-type.
 */ var $2ef8921483dd5541$var$iconStyles = (0, $jVTBW.css)({
    display: "inline-block",
    flexShrink: 0,
    lineHeight: 1,
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    "> svg": $2ef8921483dd5541$var$_objectSpread($2ef8921483dd5541$var$_objectSpread({}, (0, $2Z3sK.commonSVGStyles)), {}, {
        maxWidth: "100%",
        maxHeight: "100%",
        color: "var(--icon-primary-color)",
        fill: "var(--icon-secondary-color)",
        verticalAlign: "bottom"
    })
});
/**
 * For windows high contrast mode
 */ var $2ef8921483dd5541$var$baseHcmStyles = (0, $jVTBW.css)({
    "@media screen and (forced-colors: active)": {
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        "> svg": {
            filter: "grayscale(1)",
            "--icon-primary-color": "CanvasText",
            // foreground
            "--icon-secondary-color": "Canvas" // background
        }
    }
});
var $2ef8921483dd5541$var$primaryEqualsSecondaryHcmStyles = (0, $jVTBW.css)({
    "@media screen and (forced-colors: active)": {
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        "> svg": {
            // if the primaryColor is the same as the secondaryColor we
            // set the --icon-primary-color to Canvas
            // this is usually to convey state i.e. Checkbox checked -> not checked
            "--icon-primary-color": "Canvas" // foreground
        }
    }
});
var $2ef8921483dd5541$var$secondaryTransparentHcmStyles = (0, $jVTBW.css)({
    "@media screen and (forced-colors: active)": {
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        "> svg": {
            "--icon-secondary-color": "transparent" // background
        }
    }
});
var $2ef8921483dd5541$export$f04a61298a47a40f = /*#__PURE__*/ (0, $dAx5m.memo)(function Icon(props) {
    var _ref = props, Glyph = _ref.glyph, dangerouslySetGlyph = _ref.dangerouslySetGlyph, _ref$primaryColor = _ref.primaryColor, primaryColor = _ref$primaryColor === void 0 ? "currentColor" : _ref$primaryColor, secondaryColor = _ref.secondaryColor, size = _ref.size, testId = _ref.testId, label = _ref.label, width = _ref.width, height = _ref.height, UNSAFE_margin = _ref.UNSAFE_margin;
    var glyphProps = dangerouslySetGlyph ? {
        dangerouslySetInnerHTML: {
            __html: dangerouslySetGlyph
        }
    } : {
        children: Glyph ? (0, $jVTBW.jsx)(Glyph, {
            role: "presentation"
        }) : null
    };
    var dimensions = (0, $2Z3sK.getIconSize)({
        width: width,
        height: height,
        size: size
    });
    return (0, $jVTBW.jsx)("span", (0, (/*@__PURE__*/$parcel$interopDefault($gpRqE)))({
        "data-testid": testId,
        "data-vc": "icon-".concat(testId),
        role: label ? "img" : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: $2ef8921483dd5541$var$_objectSpread({
            "--icon-primary-color": primaryColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            "--icon-secondary-color": secondaryColor || (0, $7sWVu.getBackground)()
        }, UNSAFE_margin ? {
            margin: UNSAFE_margin
        } : {})
    }, glyphProps, {
        css: [
            $2ef8921483dd5541$var$iconStyles,
            $2ef8921483dd5541$var$baseHcmStyles,
            primaryColor === secondaryColor && $2ef8921483dd5541$var$primaryEqualsSecondaryHcmStyles,
            secondaryColor === "transparent" && $2ef8921483dd5541$var$secondaryTransparentHcmStyles,
            // NB: This can be resolved if this component, composes base SVG / and/or skeleton
            // We could then simplify how common styles are dealt with simply by encapsulating them
            // at their appropriate level and/or having a singular approach to css variables in the package
            dimensions && // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $jVTBW.css)({
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                width: dimensions.width,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                height: dimensions.height,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                "> svg": dimensions
            })
        ]
    }));
});
var $2ef8921483dd5541$export$2e2bcd8739ae039 = $2ef8921483dd5541$export$f04a61298a47a40f;

});
parcelRegister("2Z3sK", function(module, exports) {

$parcel$export(module.exports, "commonSVGStyles", function () { return $22c3f6e7b2559de1$export$16374db1c3e6dfba; });
$parcel$export(module.exports, "getIconSize", function () { return $22c3f6e7b2559de1$export$3eb7d6130acfda37; });

var $1sVdZ = parcelRequire("1sVdZ");

var $jVTBW = parcelRequire("jVTBW");
var $22c3f6e7b2559de1$export$16374db1c3e6dfba = {
    overflow: "hidden",
    pointerEvents: "none",
    /**
   * Stop-color doesn't properly apply in chrome when the inherited/current color changes.
   * We have to initially set stop-color to inherit (either via DOM attribute or an initial CSS
   * rule) and then override it with currentColor for the color changes to be picked up.
   */ stop: {
        stopColor: "currentColor"
    }
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
var $22c3f6e7b2559de1$var$smallStyles = (0, $jVTBW.css)((0, $1sVdZ.dimensions).small);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
var $22c3f6e7b2559de1$var$mediumStyles = (0, $jVTBW.css)((0, $1sVdZ.dimensions).medium);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
var $22c3f6e7b2559de1$var$largeStyles = (0, $jVTBW.css)((0, $1sVdZ.dimensions).large);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
var $22c3f6e7b2559de1$var$xlargeStyles = (0, $jVTBW.css)((0, $1sVdZ.dimensions).xlarge);
var $22c3f6e7b2559de1$export$ef0ad74202575b64 = {
    small: $22c3f6e7b2559de1$var$smallStyles,
    medium: $22c3f6e7b2559de1$var$mediumStyles,
    large: $22c3f6e7b2559de1$var$largeStyles,
    xlarge: $22c3f6e7b2559de1$var$xlargeStyles
};
var $22c3f6e7b2559de1$export$3eb7d6130acfda37 = function getIconSize(_ref) {
    var width = _ref.width, height = _ref.height, size = _ref.size;
    if (width && height) return {
        width: width,
        height: height
    };
    if (size) return (0, $1sVdZ.dimensions)[size];
    return undefined;
};

});
parcelRegister("1sVdZ", function(module, exports) {

$parcel$export(module.exports, "dimensions", function () { return $1114cb9901b8cc5a$export$62ad7b0c781000e9; });
var $1114cb9901b8cc5a$export$c647cb0ee6e282fe = {
    small: "16px",
    medium: "24px",
    large: "32px",
    xlarge: "48px"
};
var $1114cb9901b8cc5a$export$7bd66fc94c81bf84 = {
    small: "small",
    medium: "medium",
    large: "large",
    xlarge: "xlarge"
};
var $1114cb9901b8cc5a$export$62ad7b0c781000e9 = {
    small: {
        width: $1114cb9901b8cc5a$export$c647cb0ee6e282fe.small,
        height: $1114cb9901b8cc5a$export$c647cb0ee6e282fe.small
    },
    medium: {
        width: $1114cb9901b8cc5a$export$c647cb0ee6e282fe.medium,
        height: $1114cb9901b8cc5a$export$c647cb0ee6e282fe.medium
    },
    large: {
        width: $1114cb9901b8cc5a$export$c647cb0ee6e282fe.large,
        height: $1114cb9901b8cc5a$export$c647cb0ee6e282fe.large
    },
    xlarge: {
        width: $1114cb9901b8cc5a$export$c647cb0ee6e282fe.xlarge,
        height: $1114cb9901b8cc5a$export$c647cb0ee6e282fe.xlarge
    }
};

});


parcelRegister("7sWVu", function(module, exports) {

$parcel$export(module.exports, "getBackground", function () { return $56f8db77f6153ceb$export$18cb9425622d4e06; });
var $56f8db77f6153ceb$export$18cb9425622d4e06 = function getBackground() {
    return "var(--ds-surface, #FFFFFF)";
};

});



parcelRegister("4jfp5", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a280b44c69b6de4f4f93ebdb24542b07>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3234e299174758b5$var$_react = $3234e299174758b5$var$_interopRequireDefault((parcelRequire("dAx5m")));

var $3234e299174758b5$var$_UNSAFE_baseNew = $3234e299174758b5$var$_interopRequireDefault((parcelRequire("gfy4o")));
function $3234e299174758b5$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Success".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single-purpose - Reserved for success section messages and form validation messages.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3234e299174758b5$var$SuccessIcon = (props)=>/*#__PURE__*/ $3234e299174758b5$var$_react.default.createElement($3234e299174758b5$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m12.326-2.52-1.152-.96L6.75 9.828 4.826 7.52l-1.152.96 2.5 3a.75.75 0 0 0 1.152 0z" clip-rule="evenodd"/>`
    }, props));
$3234e299174758b5$var$SuccessIcon.displayName = "SuccessIcon";
var $3234e299174758b5$var$_default = module.exports.default = $3234e299174758b5$var$SuccessIcon;

});
parcelRegister("gfy4o", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("8ReQo")).default; });
$parcel$export(module.exports, "Icon", function () { return (parcelRequire("8ReQo")).Icon; });

var $8ReQo = parcelRequire("8ReQo");

});
parcelRegister("8ReQo", function(module, exports) {

$parcel$export(module.exports, "Icon", function () { return $672ec9a96a5bfd3a$export$f04a61298a47a40f; });
$parcel$export(module.exports, "default", function () { return $672ec9a96a5bfd3a$export$2e2bcd8739ae039; });
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $dAx5m = parcelRequire("dAx5m");

var $jVTBW = parcelRequire("jVTBW");

var $hOJiY = parcelRequire("hOJiY");
/**
 * We are hiding this props from consumers as it's reserved
 * for use by Icon Tile.
 */ var $672ec9a96a5bfd3a$var$commonSVGStyles = (0, $jVTBW.css)({
    overflow: "hidden",
    pointerEvents: "none",
    /**
   * Stop-color doesn't properly apply in chrome when the inherited/current color changes.
   * We have to initially set stop-color to inherit (either via DOM attribute or an initial CSS
   * rule) and then override it with currentColor for the color changes to be picked up.
   */ // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    stop: {
        stopColor: "currentColor"
    }
});
var $672ec9a96a5bfd3a$var$svgStyles = (0, $jVTBW.css)({
    color: "currentColor",
    verticalAlign: "bottom"
});
var $672ec9a96a5bfd3a$var$iconStyles = (0, $jVTBW.css)({
    display: "inline-block",
    boxSizing: "border-box",
    flexShrink: 0,
    lineHeight: 1,
    paddingInlineEnd: "var(--ds--button--new-icon-padding-end, 0)",
    paddingInlineStart: "var(--ds--button--new-icon-padding-start, 0)"
});
var $672ec9a96a5bfd3a$var$utilityIconStyles = (0, $jVTBW.css)({
    lineHeight: "var(--ds-space-150, 12px)"
});
var $672ec9a96a5bfd3a$var$scaleStyles = (0, $jVTBW.css)({
    width: "inherit",
    height: "inherit"
});
/**
 * For windows high contrast mode
 */ var $672ec9a96a5bfd3a$var$baseHcmStyles = (0, $jVTBW.css)({
    "@media screen and (forced-colors: active)": {
        color: "CanvasText",
        filter: "grayscale(1)"
    }
});
var $672ec9a96a5bfd3a$var$sizeMap = {
    scale: (0, $jVTBW.css)({
        width: "inherit",
        height: "inherit"
    }),
    utility: (0, $jVTBW.css)({
        width: "var(--ds-space-150, 12px)",
        height: "var(--ds-space-150, 12px)"
    }),
    none: (0, $jVTBW.css)({
        width: "var(--ds-space-200, 16px)",
        height: "var(--ds-space-200, 16px)"
    }),
    spacious: (0, $jVTBW.css)({
        width: "var(--ds-space-300, 24px)",
        height: "var(--ds-space-300, 24px)"
    })
};
var $672ec9a96a5bfd3a$var$baseSizeMap = {
    global: 16,
    utility: 12
};
var $672ec9a96a5bfd3a$export$f04a61298a47a40f = /*#__PURE__*/ (0, $dAx5m.memo)(function Icon(props) {
    var _ref = props, providedColor = _ref.color, _ref$spacing = _ref.spacing, providedSpacing = _ref$spacing === void 0 ? "none" : _ref$spacing, testId = _ref.testId, label = _ref.label, LEGACY_primaryColor = _ref.LEGACY_primaryColor, LEGACY_secondaryColor = _ref.LEGACY_secondaryColor, LEGACY_size = _ref.LEGACY_size, FallbackIcon = _ref.LEGACY_fallbackIcon, _ref$type = _ref.type, type = _ref$type === void 0 ? "global" : _ref$type, dangerouslySetGlyph = _ref.dangerouslySetGlyph, shouldScale = _ref.shouldScale, LEGACY_margin = _ref.LEGACY_margin;
    var fallbackColor = "var(--ds-icon, #44546F)";
    if ((0, $hOJiY.fg)("platform-design-system-new-icon-default-color") || (0, $hOJiY.fg)("platform-design-system-new-icon-default-color-2")) fallbackColor = "currentColor";
    var color = providedColor !== null && providedColor !== void 0 ? providedColor : fallbackColor;
    var dangerouslySetInnerHTML = dangerouslySetGlyph ? {
        __html: dangerouslySetGlyph
    } : undefined;
    // Fall back to old icon
    if (FallbackIcon && !(0, $hOJiY.fg)("platform.design-system-team.enable-new-icons")) // parse out unnecessary props
    return (0, $jVTBW.jsx)(FallbackIcon, {
        primaryColor: LEGACY_primaryColor !== null && LEGACY_primaryColor !== void 0 ? LEGACY_primaryColor : color,
        secondaryColor: LEGACY_secondaryColor,
        size: LEGACY_size,
        label: label,
        testId: testId,
        UNSAFE_margin: LEGACY_margin
    });
    // Utility icons don't have 'spacing' as a type, but in case it's provided, we default to 'none'
    var spacing = type === "utility" ? "none" : providedSpacing;
    var baseSize = $672ec9a96a5bfd3a$var$baseSizeMap[type];
    var size = type === "utility" ? "utility" : shouldScale ? "scale" : spacing;
    var viewBoxPadding = spacing === "spacious" ? 4 : 0;
    var viewBoxSize = baseSize + 2 * viewBoxPadding;
    // Workaround for the transparency in our disabled icon token.
    // Because we have multiple strokes in icons, opacities overlap
    // This filter has an impact on render performance, but this is
    // acceptable as icons aren't commonly disabled en-masse
    var iconColor = color;
    if (dangerouslySetInnerHTML && color === "var(--ds-icon-disabled, #091E424F)") {
        dangerouslySetInnerHTML.__html = '\n<filter id="ds-newIconOpacityFilter">\n  <feFlood flood-color="var(--ds-icon-disabled)" />\n  <feComposite in2="SourceGraphic" operator="in" />\n</filter>\n<g filter="url(#ds-newIconOpacityFilter)">\n  '.concat(dangerouslySetInnerHTML.__html, "\n</g>");
        iconColor = "var(--ds-icon, #44546F)";
    }
    return (0, $jVTBW.jsx)("span", {
        "data-testid": testId,
        role: label ? "img" : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: {
            color: iconColor
        },
        css: [
            $672ec9a96a5bfd3a$var$iconStyles,
            $672ec9a96a5bfd3a$var$baseHcmStyles,
            shouldScale && $672ec9a96a5bfd3a$var$scaleStyles,
            type === "utility" && $672ec9a96a5bfd3a$var$utilityIconStyles
        ]
    }, (0, $jVTBW.jsx)("svg", {
        fill: "none",
        viewBox: "".concat(0 - viewBoxPadding, " ").concat(0 - viewBoxPadding, " ").concat(viewBoxSize, " ").concat(viewBoxSize),
        role: "presentation",
        css: [
            $672ec9a96a5bfd3a$var$commonSVGStyles,
            $672ec9a96a5bfd3a$var$svgStyles,
            $672ec9a96a5bfd3a$var$sizeMap[size]
        ],
        dangerouslySetInnerHTML: dangerouslySetInnerHTML
    }));
});
var $672ec9a96a5bfd3a$export$2e2bcd8739ae039 = $672ec9a96a5bfd3a$export$f04a61298a47a40f;

});




parcelRegister("lPU7p", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $fe59e45c919e0476$var$_react = $fe59e45c919e0476$var$_interopRequireDefault((parcelRequire("dAx5m")));

var $eAey6 = parcelRequire("eAey6");

var $fe59e45c919e0476$var$_error = $fe59e45c919e0476$var$_interopRequireDefault((parcelRequire("34tpq")));
function $fe59e45c919e0476$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $fe59e45c919e0476$var$ErrorIcon = (props)=>/*#__PURE__*/ $fe59e45c919e0476$var$_react.default.createElement($eAey6.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><path fill="currentcolor" d="M13.416 4.417a2 2 0 0 0-2.832 0l-6.168 6.167a2 2 0 0 0 0 2.833l6.168 6.167a2 2 0 0 0 2.832 0l6.168-6.167a2 2 0 0 0 0-2.833z"/><path fill="inherit" d="M12 14a1 1 0 0 1-1-1V8a1 1 0 0 1 2 0v5a1 1 0 0 1-1 1m0 3a1 1 0 0 1 0-2 1 1 0 0 1 0 2"/></g></svg>`
    }, props, {
        newIcon: $fe59e45c919e0476$var$_error.default
    }));
$fe59e45c919e0476$var$ErrorIcon.displayName = "ErrorIcon";
var $fe59e45c919e0476$var$_default = module.exports.default = $fe59e45c919e0476$var$ErrorIcon;

});
parcelRegister("34tpq", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::796368f5d379f034b5d96a253e623668>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $23c88edf208f9b88$var$_react = $23c88edf208f9b88$var$_interopRequireDefault((parcelRequire("dAx5m")));

var $23c88edf208f9b88$var$_UNSAFE_baseNew = $23c88edf208f9b88$var$_interopRequireDefault((parcelRequire("gfy4o")));
function $23c88edf208f9b88$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Error".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for when there is an error.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $23c88edf208f9b88$var$ErrorIcon = (props)=>/*#__PURE__*/ $23c88edf208f9b88$var$_react.default.createElement($23c88edf208f9b88$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.586.603a2 2 0 0 1 2.828 0l5.982 5.983a2 2 0 0 1 0 2.828l-5.982 5.982a2 2 0 0 1-2.828 0L.604 9.414a2 2 0 0 1 0-2.828zM7.25 9V3.75h1.5V9zM8 12.25a1 1 0 1 0 0-2 1 1 0 0 0 0 2" clip-rule="evenodd"/>`
    }, props));
$23c88edf208f9b88$var$ErrorIcon.displayName = "ErrorIcon";
var $23c88edf208f9b88$var$_default = module.exports.default = $23c88edf208f9b88$var$ErrorIcon;

});


parcelRegister("1AV7l", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1295758e6c6cefe5$var$_react = $1295758e6c6cefe5$var$_interopRequireDefault((parcelRequire("dAx5m")));

var $eAey6 = parcelRequire("eAey6");

var $1295758e6c6cefe5$var$_information = $1295758e6c6cefe5$var$_interopRequireDefault((parcelRequire("3Fl6v")));
function $1295758e6c6cefe5$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $1295758e6c6cefe5$var$InfoIcon = (props)=>/*#__PURE__*/ $1295758e6c6cefe5$var$_react.default.createElement($eAey6.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><path fill="currentcolor" d="M2 12c0 5.523 4.477 10 10 10s10-4.477 10-10S17.523 2 12 2 2 6.477 2 12"/><rect width="2" height="7" x="11" y="10" fill="inherit" rx="1"/><circle cx="12" cy="8" r="1" fill="inherit"/></g></svg>`
    }, props, {
        newIcon: $1295758e6c6cefe5$var$_information.default
    }));
$1295758e6c6cefe5$var$InfoIcon.displayName = "InfoIcon";
var $1295758e6c6cefe5$var$_default = module.exports.default = $1295758e6c6cefe5$var$InfoIcon;

});
parcelRegister("3Fl6v", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::cfc592cc61140d99cb4eaed527408acf>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2ab59238dd4cc7e7$var$_react = $2ab59238dd4cc7e7$var$_interopRequireDefault((parcelRequire("dAx5m")));

var $2ab59238dd4cc7e7$var$_UNSAFE_baseNew = $2ab59238dd4cc7e7$var$_interopRequireDefault((parcelRequire("gfy4o")));
function $2ab59238dd4cc7e7$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Information".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Known uses: information state in section messages or inline messages.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $2ab59238dd4cc7e7$var$InformationIcon = (props)=>/*#__PURE__*/ $2ab59238dd4cc7e7$var$_react.default.createElement($2ab59238dd4cc7e7$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m6.5-1.25H8a.75.75 0 0 1 .75.75v5h-1.5V8.25H6.5zM8 5.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2" clip-rule="evenodd"/>`
    }, props));
$2ab59238dd4cc7e7$var$InformationIcon.displayName = "InformationIcon";
var $2ab59238dd4cc7e7$var$_default = module.exports.default = $2ab59238dd4cc7e7$var$InformationIcon;

});


parcelRegister("9sLA5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6e3ba32dd73eb7d1$var$_react = $6e3ba32dd73eb7d1$var$_interopRequireDefault((parcelRequire("dAx5m")));

var $eAey6 = parcelRequire("eAey6");

var $6e3ba32dd73eb7d1$var$_questionCircle = $6e3ba32dd73eb7d1$var$_interopRequireDefault((parcelRequire("iZsU0")));
function $6e3ba32dd73eb7d1$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $6e3ba32dd73eb7d1$var$QuestionCircleIcon = (props)=>/*#__PURE__*/ $6e3ba32dd73eb7d1$var$_react.default.createElement($eAey6.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="10" fill="currentcolor"/><circle cx="12" cy="18" r="1" fill="inherit"/><path fill="inherit" d="M15.89 9.05a3.98 3.98 0 0 0-2.957-2.942C10.321 5.514 8.017 7.446 8 9.95l.005.147a.99.99 0 0 0 .982.904c.552 0 1-.447 1.002-.998a2.004 2.004 0 0 1 4.007-.002c0 1.102-.898 2-2.003 2H12a1 1 0 0 0-1 .987v2.014a1.001 1.001 0 0 0 2.004 0v-.782c0-.217.145-.399.35-.472A3.99 3.99 0 0 0 15.89 9.05"/></g></svg>`
    }, props, {
        newIcon: $6e3ba32dd73eb7d1$var$_questionCircle.default
    }));
$6e3ba32dd73eb7d1$var$QuestionCircleIcon.displayName = "QuestionCircleIcon";
var $6e3ba32dd73eb7d1$var$_default = module.exports.default = $6e3ba32dd73eb7d1$var$QuestionCircleIcon;

});
parcelRegister("iZsU0", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::44f68a28e7579c1e69613bedc98a8120>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $dd3457e5a0ee5ef7$var$_react = $dd3457e5a0ee5ef7$var$_interopRequireDefault((parcelRequire("dAx5m")));

var $dd3457e5a0ee5ef7$var$_UNSAFE_baseNew = $dd3457e5a0ee5ef7$var$_interopRequireDefault((parcelRequire("gfy4o")));
function $dd3457e5a0ee5ef7$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "QuestionCircle".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: help, tip.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $dd3457e5a0ee5ef7$var$QuestionCircleIcon = (props)=>/*#__PURE__*/ $dd3457e5a0ee5ef7$var$_react.default.createElement($dd3457e5a0ee5ef7$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M6.25 6C6.25 5 7 4.25 8 4.25S9.75 5 9.75 6C9.75 7.5 8 7.5 8 8.75v.75M15.25 8A7.25 7.25 0 1 1 .75 8a7.25 7.25 0 0 1 14.5 0Z"/><path fill="currentcolor" d="M9 11.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0"/>`
    }, props));
$dd3457e5a0ee5ef7$var$QuestionCircleIcon.displayName = "QuestionCircleIcon";
var $dd3457e5a0ee5ef7$var$_default = module.exports.default = $dd3457e5a0ee5ef7$var$QuestionCircleIcon;

});


parcelRegister("jsTBk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e2bbc314082c7fc4$var$_react = $e2bbc314082c7fc4$var$_interopRequireDefault((parcelRequire("dAx5m")));

var $eAey6 = parcelRequire("eAey6");

var $e2bbc314082c7fc4$var$_warning = $e2bbc314082c7fc4$var$_interopRequireDefault((parcelRequire("3m5we")));
function $e2bbc314082c7fc4$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $e2bbc314082c7fc4$var$WarningIcon = (props)=>/*#__PURE__*/ $e2bbc314082c7fc4$var$_react.default.createElement($eAey6.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><path fill="currentcolor" d="M12.938 4.967c-.518-.978-1.36-.974-1.876 0L3.938 18.425c-.518.978-.045 1.771 1.057 1.771h14.01c1.102 0 1.573-.797 1.057-1.771z"/><path fill="inherit" d="M12 15a1 1 0 0 1-1-1V9a1 1 0 0 1 2 0v5a1 1 0 0 1-1 1m0 3a1 1 0 0 1 0-2 1 1 0 0 1 0 2"/></g></svg>`
    }, props, {
        newIcon: $e2bbc314082c7fc4$var$_warning.default
    }));
$e2bbc314082c7fc4$var$WarningIcon.displayName = "WarningIcon";
var $e2bbc314082c7fc4$var$_default = module.exports.default = $e2bbc314082c7fc4$var$WarningIcon;

});
parcelRegister("3m5we", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5bbc66a5bafbc3dabace12fa6936c92e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2717b51e6079395b$var$_react = $2717b51e6079395b$var$_interopRequireDefault((parcelRequire("dAx5m")));

var $2717b51e6079395b$var$_UNSAFE_baseNew = $2717b51e6079395b$var$_interopRequireDefault((parcelRequire("gfy4o")));
function $2717b51e6079395b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Warning".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for warning system status.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $2717b51e6079395b$var$WarningIcon = (props)=>/*#__PURE__*/ $2717b51e6079395b$var$_react.default.createElement($2717b51e6079395b$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.242 1.168c.757-1.396 2.76-1.396 3.516 0l5.9 10.878c.723 1.332-.242 2.953-1.758 2.953H2.1C.584 15-.38 13.38.342 12.046zM7.25 9.499v-5h1.5v5zM8 12.75a1 1 0 1 0 0-2 1 1 0 0 0 0 2" clip-rule="evenodd"/>`
    }, props));
$2717b51e6079395b$var$WarningIcon.displayName = "WarningIcon";
var $2717b51e6079395b$var$_default = module.exports.default = $2717b51e6079395b$var$WarningIcon;

});


parcelRegister("83Zvp", function(module, exports) {

$parcel$export(module.exports, "R50", function () { return $5dee504b7d2ae1f0$export$4b84fd0e2c617bd; });
$parcel$export(module.exports, "R300", function () { return $5dee504b7d2ae1f0$export$4a7404f376229999; });
$parcel$export(module.exports, "R400", function () { return $5dee504b7d2ae1f0$export$2010d0fb4295b346; });
$parcel$export(module.exports, "R500", function () { return $5dee504b7d2ae1f0$export$2837b5a1a71d5c02; });
$parcel$export(module.exports, "Y50", function () { return $5dee504b7d2ae1f0$export$8d9596b529bbb9cf; });
$parcel$export(module.exports, "Y200", function () { return $5dee504b7d2ae1f0$export$5aae31392d72caaa; });
$parcel$export(module.exports, "Y300", function () { return $5dee504b7d2ae1f0$export$c6930421db9fa514; });
$parcel$export(module.exports, "Y400", function () { return $5dee504b7d2ae1f0$export$59619663aa6500fb; });
$parcel$export(module.exports, "Y500", function () { return $5dee504b7d2ae1f0$export$874739ea9e379ab6; });
$parcel$export(module.exports, "G50", function () { return $5dee504b7d2ae1f0$export$8a6341c32b6a3ee6; });
$parcel$export(module.exports, "G500", function () { return $5dee504b7d2ae1f0$export$6fa04827ac68a4fb; });
$parcel$export(module.exports, "B50", function () { return $5dee504b7d2ae1f0$export$226de0355ed012f8; });
$parcel$export(module.exports, "B75", function () { return $5dee504b7d2ae1f0$export$8c13c2ee36917869; });
$parcel$export(module.exports, "B100", function () { return $5dee504b7d2ae1f0$export$ecfc1dff386a3e7a; });
$parcel$export(module.exports, "B200", function () { return $5dee504b7d2ae1f0$export$215b7063051591f1; });
$parcel$export(module.exports, "B300", function () { return $5dee504b7d2ae1f0$export$e62e8919cca44969; });
$parcel$export(module.exports, "B400", function () { return $5dee504b7d2ae1f0$export$b3de0ae08da2ce64; });
$parcel$export(module.exports, "B500", function () { return $5dee504b7d2ae1f0$export$a6ee3d71bc067634; });
$parcel$export(module.exports, "P50", function () { return $5dee504b7d2ae1f0$export$363e4475840015bb; });
$parcel$export(module.exports, "P500", function () { return $5dee504b7d2ae1f0$export$147899de772240ec; });
$parcel$export(module.exports, "N0", function () { return $5dee504b7d2ae1f0$export$29a4f05edc054374; });
$parcel$export(module.exports, "N20", function () { return $5dee504b7d2ae1f0$export$9fdfb749e33cdf97; });
$parcel$export(module.exports, "N70", function () { return $5dee504b7d2ae1f0$export$5f71e19f3a7ad9de; });
$parcel$export(module.exports, "N90", function () { return $5dee504b7d2ae1f0$export$7c87d337fb91a97d; });
$parcel$export(module.exports, "N200", function () { return $5dee504b7d2ae1f0$export$f563ee71e9ee74cd; });
$parcel$export(module.exports, "N400", function () { return $5dee504b7d2ae1f0$export$eece5f492e429f08; });
$parcel$export(module.exports, "N500", function () { return $5dee504b7d2ae1f0$export$c39c0fe0f26207ae; });
$parcel$export(module.exports, "N700", function () { return $5dee504b7d2ae1f0$export$ad0bacf983b7ddaa; });
$parcel$export(module.exports, "N800", function () { return $5dee504b7d2ae1f0$export$7d61b15e0da132af; });
$parcel$export(module.exports, "N20A", function () { return $5dee504b7d2ae1f0$export$8d43898f60b96a82; });
$parcel$export(module.exports, "N30A", function () { return $5dee504b7d2ae1f0$export$920c0d5c49070351; });
$parcel$export(module.exports, "DN400", function () { return $5dee504b7d2ae1f0$export$abcf8c38338b4aa5; });
$parcel$export(module.exports, "DN300", function () { return $5dee504b7d2ae1f0$export$97e81faa16a182c7; });
$parcel$export(module.exports, "DN100", function () { return $5dee504b7d2ae1f0$export$ee82aa2ea6a1558; });
$parcel$export(module.exports, "DN70", function () { return $5dee504b7d2ae1f0$export$d281fbfe3cff2df6; });
$parcel$export(module.exports, "DN60", function () { return $5dee504b7d2ae1f0$export$3902c91d8b98a753; });
$parcel$export(module.exports, "DN30", function () { return $5dee504b7d2ae1f0$export$633847cf062b69e0; });
$parcel$export(module.exports, "DN0", function () { return $5dee504b7d2ae1f0$export$3d4f271a500072a; });
$parcel$export(module.exports, "skeleton", function () { return $5dee504b7d2ae1f0$export$2a0674ff2eb10214; });
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ 
var $l4usv = parcelRequire("l4usv");
var $5dee504b7d2ae1f0$export$4b84fd0e2c617bd = "#FFEBE6";
var $5dee504b7d2ae1f0$export$b34b069eff244586 = "#FFBDAD";
var $5dee504b7d2ae1f0$export$be802dd0d8b57f35 = "#FF8F73";
var $5dee504b7d2ae1f0$export$60847d42f9da92a6 = "#FF7452";
var $5dee504b7d2ae1f0$export$4a7404f376229999 = "#FF5630";
var $5dee504b7d2ae1f0$export$2010d0fb4295b346 = "#DE350B";
var $5dee504b7d2ae1f0$export$2837b5a1a71d5c02 = "#BF2600";
var $5dee504b7d2ae1f0$export$8d9596b529bbb9cf = "#FFFAE6";
var $5dee504b7d2ae1f0$export$41060a744ab0b7ae = "#FFF0B3";
var $5dee504b7d2ae1f0$export$1cc05bbbf340e559 = "#FFE380";
var $5dee504b7d2ae1f0$export$5aae31392d72caaa = "#FFC400";
var $5dee504b7d2ae1f0$export$c6930421db9fa514 = "#FFAB00";
var $5dee504b7d2ae1f0$export$59619663aa6500fb = "#FF991F";
var $5dee504b7d2ae1f0$export$874739ea9e379ab6 = "#FF8B00";
var $5dee504b7d2ae1f0$export$8a6341c32b6a3ee6 = "#E3FCEF";
var $5dee504b7d2ae1f0$export$69a3bf21b9686c2b = "#ABF5D1";
var $5dee504b7d2ae1f0$export$afbce1382ec95f73 = "#79F2C0";
var $5dee504b7d2ae1f0$export$747d86715d4175de = "#57D9A3";
var $5dee504b7d2ae1f0$export$940e1f69e873f202 = "#36B37E";
var $5dee504b7d2ae1f0$export$a49394138f7b8e85 = "#00875A";
var $5dee504b7d2ae1f0$export$6fa04827ac68a4fb = "#006644";
var $5dee504b7d2ae1f0$export$226de0355ed012f8 = "#DEEBFF";
var $5dee504b7d2ae1f0$export$8c13c2ee36917869 = "#B3D4FF";
var $5dee504b7d2ae1f0$export$ecfc1dff386a3e7a = "#4C9AFF";
var $5dee504b7d2ae1f0$export$215b7063051591f1 = "#2684FF";
var $5dee504b7d2ae1f0$export$e62e8919cca44969 = "#0065FF";
var $5dee504b7d2ae1f0$export$b3de0ae08da2ce64 = "#0052CC";
var $5dee504b7d2ae1f0$export$a6ee3d71bc067634 = "#0747A6";
var $5dee504b7d2ae1f0$export$363e4475840015bb = "#EAE6FF";
var $5dee504b7d2ae1f0$export$4b0a4417ed59760f = "#C0B6F2";
var $5dee504b7d2ae1f0$export$6011520a64d9a187 = "#998DD9";
var $5dee504b7d2ae1f0$export$a7175d4e9206bc80 = "#8777D9";
var $5dee504b7d2ae1f0$export$b48405b95304b5a1 = "#6554C0";
var $5dee504b7d2ae1f0$export$c71e4279dd54a18d = "#5243AA";
var $5dee504b7d2ae1f0$export$147899de772240ec = "#403294";
var $5dee504b7d2ae1f0$export$2cf711fe14c66f06 = "#E6FCFF";
var $5dee504b7d2ae1f0$export$7a8f4d33f6f9772c = "#B3F5FF";
var $5dee504b7d2ae1f0$export$776c9c497ef08533 = "#79E2F2";
var $5dee504b7d2ae1f0$export$69cb3ca10c1e330e = "#00C7E6";
var $5dee504b7d2ae1f0$export$9dc1ef0f3f48059b = "#00B8D9";
var $5dee504b7d2ae1f0$export$7c835c78b6fcdef8 = "#00A3BF";
var $5dee504b7d2ae1f0$export$6036577f95c3877e = "#008DA6";
var $5dee504b7d2ae1f0$export$29a4f05edc054374 = "#FFFFFF";
var $5dee504b7d2ae1f0$export$e655ef011c4aa1a2 = "#FAFBFC";
var $5dee504b7d2ae1f0$export$9fdfb749e33cdf97 = "#F4F5F7";
var $5dee504b7d2ae1f0$export$3e51e8f1440314ba = "#EBECF0";
var $5dee504b7d2ae1f0$export$1ce2d1575d444ceb = "#DFE1E6";
var $5dee504b7d2ae1f0$export$8754fc7e6d8b3000 = "#C1C7D0";
var $5dee504b7d2ae1f0$export$c2e91cbeada39b8b = "#B3BAC5";
var $5dee504b7d2ae1f0$export$5f71e19f3a7ad9de = "#A5ADBA";
var $5dee504b7d2ae1f0$export$eaa8c8a70ac22806 = "#97A0AF";
var $5dee504b7d2ae1f0$export$7c87d337fb91a97d = "#8993A4";
var $5dee504b7d2ae1f0$export$d6447c357493214f = "#7A869A";
var $5dee504b7d2ae1f0$export$f563ee71e9ee74cd = "#6B778C";
var $5dee504b7d2ae1f0$export$e2ef2124cf4024b1 = "#5E6C84";
var $5dee504b7d2ae1f0$export$eece5f492e429f08 = "#505F79";
var $5dee504b7d2ae1f0$export$c39c0fe0f26207ae = "#42526E";
var $5dee504b7d2ae1f0$export$7090862dc3038a9f = "#344563";
var $5dee504b7d2ae1f0$export$ad0bacf983b7ddaa = "#253858";
var $5dee504b7d2ae1f0$export$7d61b15e0da132af = "#172B4D";
var $5dee504b7d2ae1f0$export$fbda843f0a27fe96 = "#091E42";
var $5dee504b7d2ae1f0$export$791e57b27ca738ef = "rgba(9, 30, 66, 0.02)";
var $5dee504b7d2ae1f0$export$8d43898f60b96a82 = "rgba(9, 30, 66, 0.04)";
var $5dee504b7d2ae1f0$export$920c0d5c49070351 = "rgba(9, 30, 66, 0.08)";
var $5dee504b7d2ae1f0$export$46987b49aab6d1a8 = "rgba(9, 30, 66, 0.13)";
var $5dee504b7d2ae1f0$export$7d3359664e8bb0e5 = "rgba(9, 30, 66, 0.25)";
var $5dee504b7d2ae1f0$export$d2d3bedfb276cac0 = "rgba(9, 30, 66, 0.31)";
var $5dee504b7d2ae1f0$export$6e5e7499ff054f6d = "rgba(9, 30, 66, 0.36)";
var $5dee504b7d2ae1f0$export$59264b346c877fa7 = "rgba(9, 30, 66, 0.42)";
var $5dee504b7d2ae1f0$export$d092757d7c64925c = "rgba(9, 30, 66, 0.48)";
var $5dee504b7d2ae1f0$export$486ab785e4bac3c6 = "rgba(9, 30, 66, 0.54)";
var $5dee504b7d2ae1f0$export$fba592bbc6419fea = "rgba(9, 30, 66, 0.60)";
var $5dee504b7d2ae1f0$export$13609db0e6812ab8 = "rgba(9, 30, 66, 0.66)";
var $5dee504b7d2ae1f0$export$fbae4efaa892d883 = "rgba(9, 30, 66, 0.71)";
var $5dee504b7d2ae1f0$export$f13946d26f440ce6 = "rgba(9, 30, 66, 0.77)";
var $5dee504b7d2ae1f0$export$19f58225ac52a306 = "rgba(9, 30, 66, 0.82)";
var $5dee504b7d2ae1f0$export$6384f09da70e7b62 = "rgba(9, 30, 66, 0.89)";
var $5dee504b7d2ae1f0$export$d0dccc730683edc2 = "rgba(9, 30, 66, 0.95)";
var $5dee504b7d2ae1f0$export$2f6319cf7d736c2a = "#E6EDFA";
var $5dee504b7d2ae1f0$export$95126bc8884d6634 = "#DCE5F5";
var $5dee504b7d2ae1f0$export$8338d8c35d44ff1 = "#CED9EB";
var $5dee504b7d2ae1f0$export$5368d76ae4fbbda7 = "#B8C7E0";
var $5dee504b7d2ae1f0$export$9f0a771d16ec8d36 = "#ABBBD6";
var $5dee504b7d2ae1f0$export$abcf8c38338b4aa5 = "#9FB0CC";
var $5dee504b7d2ae1f0$export$97e81faa16a182c7 = "#8C9CB8";
var $5dee504b7d2ae1f0$export$bfe21c59123ecf33 = "#7988A3";
var $5dee504b7d2ae1f0$export$ee82aa2ea6a1558 = "#67758F";
var $5dee504b7d2ae1f0$export$682927c6ed76be02 = "#56637A";
var $5dee504b7d2ae1f0$export$91fd9994c5be9757 = "#455166";
var $5dee504b7d2ae1f0$export$d281fbfe3cff2df6 = "#3B475C";
var $5dee504b7d2ae1f0$export$3902c91d8b98a753 = "#313D52";
var $5dee504b7d2ae1f0$export$8e8133c1ba5845b5 = "#283447";
var $5dee504b7d2ae1f0$export$33ff357f6620b39 = "#202B3D";
var $5dee504b7d2ae1f0$export$633847cf062b69e0 = "#1B2638";
var $5dee504b7d2ae1f0$export$9776a6e503bdbf76 = "#121A29";
var $5dee504b7d2ae1f0$export$6c813d5160dff5db = "#0E1624";
var $5dee504b7d2ae1f0$export$3d4f271a500072a = "#0D1424";
var $5dee504b7d2ae1f0$export$fe151285c22759ec = "rgba(13, 20, 36, 0.06)";
var $5dee504b7d2ae1f0$export$a101c6190d0da34 = "rgba(13, 20, 36, 0.14)";
var $5dee504b7d2ae1f0$export$4b16f52932fda51 = "rgba(13, 20, 36, 0.18)";
var $5dee504b7d2ae1f0$export$a74bcd7b9845b0d8 = "rgba(13, 20, 36, 0.29)";
var $5dee504b7d2ae1f0$export$9209c179316d1751 = "rgba(13, 20, 36, 0.36)";
var $5dee504b7d2ae1f0$export$88f55133f636c8dd = "rgba(13, 20, 36, 0.40)";
var $5dee504b7d2ae1f0$export$51126f85d1009512 = "rgba(13, 20, 36, 0.47)";
var $5dee504b7d2ae1f0$export$a069b547bd23af78 = "rgba(13, 20, 36, 0.53)";
var $5dee504b7d2ae1f0$export$40cce05af3b2600a = "rgba(13, 20, 36, 0.63)";
var $5dee504b7d2ae1f0$export$b78942185925a0d = "rgba(13, 20, 36, 0.73)";
var $5dee504b7d2ae1f0$export$e058fb44b8eaafca = "rgba(13, 20, 36, 0.78)";
var $5dee504b7d2ae1f0$export$92b0b8de26920c18 = "rgba(13, 20, 36, 0.81)";
var $5dee504b7d2ae1f0$export$67564f7459d3fc9e = "rgba(13, 20, 36, 0.85)";
var $5dee504b7d2ae1f0$export$77868e1ca884ffa3 = "rgba(13, 20, 36, 0.89)";
var $5dee504b7d2ae1f0$export$2afd71d7d3ea2cd5 = "rgba(13, 20, 36, 0.92)";
var $5dee504b7d2ae1f0$export$f2a0acaab9972c70 = "rgba(13, 20, 36, 0.95)";
var $5dee504b7d2ae1f0$export$9ab70e67d6475361 = "rgba(13, 20, 36, 0.97)";
var $5dee504b7d2ae1f0$export$8ce1fd94bee2f412 = (0, $l4usv.default)({
    light: "var(--ds-surface, ".concat($5dee504b7d2ae1f0$export$29a4f05edc054374, ")"),
    dark: "var(--ds-surface, ".concat($5dee504b7d2ae1f0$export$633847cf062b69e0, ")")
});
var $5dee504b7d2ae1f0$export$b861914ea877b580 = (0, $l4usv.default)({
    light: "var(--ds-background-selected, ".concat($5dee504b7d2ae1f0$export$226de0355ed012f8, ")"),
    dark: "var(--ds-background-selected, ".concat($5dee504b7d2ae1f0$export$8c13c2ee36917869, ")")
});
var $5dee504b7d2ae1f0$export$3f1b020df94387af = (0, $l4usv.default)({
    light: "var(--ds-background-neutral-hovered, ".concat($5dee504b7d2ae1f0$export$3e51e8f1440314ba, ")"),
    dark: "var(--ds-background-neutral-hovered, ".concat($5dee504b7d2ae1f0$export$d281fbfe3cff2df6, ")")
});
var $5dee504b7d2ae1f0$export$c0183dbab98ca63e = (0, $l4usv.default)({
    light: "var(--ds-surface-overlay, ".concat($5dee504b7d2ae1f0$export$29a4f05edc054374, ")"),
    dark: "var(--ds-surface-overlay, ".concat($5dee504b7d2ae1f0$export$8e8133c1ba5845b5, ")")
});
var $5dee504b7d2ae1f0$export$6f093cfa640b7166 = (0, $l4usv.default)({
    light: "var(--ds-text, ".concat($5dee504b7d2ae1f0$export$fbda843f0a27fe96, ")"),
    dark: "var(--ds-text, ".concat($5dee504b7d2ae1f0$export$5368d76ae4fbbda7, ")")
});
var $5dee504b7d2ae1f0$export$42f8e9c698766e7a = (0, $l4usv.default)({
    light: "var(--ds-text, ".concat($5dee504b7d2ae1f0$export$7d61b15e0da132af, ")"),
    dark: "var(--ds-text, ".concat($5dee504b7d2ae1f0$export$5368d76ae4fbbda7, ")")
});
var $5dee504b7d2ae1f0$export$c2d157ca1c34b6e3 = (0, $l4usv.default)({
    light: "var(--ds-text-selected, ".concat($5dee504b7d2ae1f0$export$b3de0ae08da2ce64, ")"),
    dark: "var(--ds-text-selected, ".concat($5dee504b7d2ae1f0$export$b3de0ae08da2ce64, ")")
});
var $5dee504b7d2ae1f0$export$1905ba28d7cf066f = (0, $l4usv.default)({
    light: "var(--ds-text-subtlest, ".concat($5dee504b7d2ae1f0$export$f563ee71e9ee74cd, ")"),
    dark: "var(--ds-text-subtlest, ".concat($5dee504b7d2ae1f0$export$97e81faa16a182c7, ")")
});
var $5dee504b7d2ae1f0$export$bd9002130d306d39 = (0, $l4usv.default)({
    light: "var(--ds-text-subtlest, ".concat($5dee504b7d2ae1f0$export$f563ee71e9ee74cd, ")"),
    dark: "var(--ds-text-subtlest, ".concat($5dee504b7d2ae1f0$export$bfe21c59123ecf33, ")")
});
var $5dee504b7d2ae1f0$export$46e4a324ac90507f = (0, $l4usv.default)({
    light: "var(--ds-text, ".concat($5dee504b7d2ae1f0$export$7d61b15e0da132af, ")"),
    dark: "var(--ds-text, ".concat($5dee504b7d2ae1f0$export$5368d76ae4fbbda7, ")")
});
var $5dee504b7d2ae1f0$export$79f3f2b82beb0d36 = (0, $l4usv.default)({
    light: "var(--ds-text-subtlest, ".concat($5dee504b7d2ae1f0$export$f563ee71e9ee74cd, ")"),
    dark: "var(--ds-text-subtlest, ".concat($5dee504b7d2ae1f0$export$97e81faa16a182c7, ")")
});
var $5dee504b7d2ae1f0$export$7bb0d5c671655cc4 = (0, $l4usv.default)({
    light: $5dee504b7d2ae1f0$export$9fdfb749e33cdf97,
    dark: $5dee504b7d2ae1f0$export$8e8133c1ba5845b5
});
var $5dee504b7d2ae1f0$export$9c30223ca0a664fb = (0, $l4usv.default)({
    light: "var(--ds-link, ".concat($5dee504b7d2ae1f0$export$b3de0ae08da2ce64, ")"),
    dark: "var(--ds-link, ".concat($5dee504b7d2ae1f0$export$ecfc1dff386a3e7a, ")")
});
var $5dee504b7d2ae1f0$export$7ed258b0728b004b = (0, $l4usv.default)({
    light: "var(--ds-link-pressed, ".concat($5dee504b7d2ae1f0$export$e62e8919cca44969, ")"),
    dark: "var(--ds-link-pressed, ".concat($5dee504b7d2ae1f0$export$215b7063051591f1, ")")
});
var $5dee504b7d2ae1f0$export$dfa920d8decc8a59 = (0, $l4usv.default)({
    light: "var(--ds-link-pressed, ".concat($5dee504b7d2ae1f0$export$a6ee3d71bc067634, ")"),
    dark: "var(--ds-link-pressed, ".concat($5dee504b7d2ae1f0$export$ecfc1dff386a3e7a, ")")
});
var $5dee504b7d2ae1f0$export$6069e6ad5c78f632 = (0, $l4usv.default)({
    light: "var(--ds-border-focused, ".concat($5dee504b7d2ae1f0$export$215b7063051591f1, ")"),
    dark: "var(--ds-border-focused, ".concat($5dee504b7d2ae1f0$export$215b7063051591f1, ")")
});
var $5dee504b7d2ae1f0$export$9ad721cf3b3debe0 = (0, $l4usv.default)({
    light: "var(--ds-background-brand-bold, ".concat($5dee504b7d2ae1f0$export$b3de0ae08da2ce64, ")"),
    dark: "var(--ds-background-brand-bold, ".concat($5dee504b7d2ae1f0$export$ecfc1dff386a3e7a, ")")
});
var $5dee504b7d2ae1f0$export$2aa0182783e7e9de = (0, $l4usv.default)({
    light: $5dee504b7d2ae1f0$export$b3de0ae08da2ce64,
    dark: $5dee504b7d2ae1f0$export$ecfc1dff386a3e7a
});
var $5dee504b7d2ae1f0$export$8bf7dff220b82b4a = (0, $l4usv.default)({
    light: $5dee504b7d2ae1f0$export$9dc1ef0f3f48059b,
    dark: $5dee504b7d2ae1f0$export$69cb3ca10c1e330e
});
var $5dee504b7d2ae1f0$export$e13cce2a2d16a9d4 = (0, $l4usv.default)({
    light: $5dee504b7d2ae1f0$export$b48405b95304b5a1,
    dark: $5dee504b7d2ae1f0$export$6011520a64d9a187
});
var $5dee504b7d2ae1f0$export$a90204d1394caf30 = (0, $l4usv.default)({
    light: $5dee504b7d2ae1f0$export$4a7404f376229999,
    dark: $5dee504b7d2ae1f0$export$4a7404f376229999
});
var $5dee504b7d2ae1f0$export$594c5a8758200c32 = (0, $l4usv.default)({
    light: $5dee504b7d2ae1f0$export$c6930421db9fa514,
    dark: $5dee504b7d2ae1f0$export$c6930421db9fa514
});
var $5dee504b7d2ae1f0$export$955a2ebd2fb142ae = (0, $l4usv.default)({
    light: $5dee504b7d2ae1f0$export$940e1f69e873f202,
    dark: $5dee504b7d2ae1f0$export$940e1f69e873f202
});
var $5dee504b7d2ae1f0$export$2a0674ff2eb10214 = function skeleton() {
    return "var(--ds-skeleton, ".concat($5dee504b7d2ae1f0$export$8d43898f60b96a82, ")");
};

});
parcelRegister("l4usv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f57199303e753fd9$export$2e2bcd8739ae039; });
/* eslint-disable prefer-rest-params */ 
var $24wmN = parcelRequire("24wmN");
// Unpack custom variants, and get correct value for the current theme
function $f57199303e753fd9$var$themedVariants(variantProp, variants) {
    return function(props) {
        var theme = (0, $24wmN.default)(props);
        if (props && props[variantProp] && variants) {
            var modes = variants[props[variantProp]];
            if (modes && modes[theme.mode]) {
                var value = modes[theme.mode];
                if (value) return value;
                 // TS believes value can be undefined
            }
        }
        return "";
    };
}
function $f57199303e753fd9$export$2e2bcd8739ae039(modesOrVariant, variantModes) {
    if (typeof modesOrVariant === "string") return $f57199303e753fd9$var$themedVariants(modesOrVariant, variantModes);
    var modes = modesOrVariant;
    return function(props) {
        // Get theme from the user's props
        var theme = (0, $24wmN.default)(props);
        // User isn't required to provide both light and dark values
        if (theme.mode in modes) {
            var value = modes[theme.mode]; // TS believes value can be undefined
            if (value) return value;
        }
        return "";
    };
}

});
parcelRegister("24wmN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $18250fd849367ced$export$2e2bcd8739ae039; });

var $nNcmP = parcelRequire("nNcmP");
function $18250fd849367ced$export$2e2bcd8739ae039(props) {
    if (props && props.theme) {
        // Theme is the global Atlaskit theme
        if ((0, $nNcmP.CHANNEL) in props.theme) return props.theme[0, $nNcmP.CHANNEL];
        else if ("mode" in props.theme && (0, $nNcmP.THEME_MODES).includes(props.theme.mode)) return props.theme;
    }
    // If format not supported (or no theme provided), return standard theme
    return {
        mode: (0, $nNcmP.DEFAULT_THEME_MODE)
    };
}

});
parcelRegister("nNcmP", function(module, exports) {

$parcel$export(module.exports, "CHANNEL", function () { return $04784fe3783e9801$export$44ffba16bd48dac6; });
$parcel$export(module.exports, "DEFAULT_THEME_MODE", function () { return $04784fe3783e9801$export$c93026a968943f95; });
$parcel$export(module.exports, "THEME_MODES", function () { return $04784fe3783e9801$export$6ba72c8346b4c57e; });
$parcel$export(module.exports, "gridSize", function () { return $04784fe3783e9801$export$6d8204c2cb2e06b8; });
$parcel$export(module.exports, "fontSize", function () { return $04784fe3783e9801$export$85e3c3ca0c6fb93; });

var $e2xkU = parcelRequire("e2xkU");

var $83Zvp = parcelRequire("83Zvp");
var $04784fe3783e9801$export$44ffba16bd48dac6 = "__ATLASKIT_THEME__";
var $04784fe3783e9801$export$c93026a968943f95 = "light";
var $04784fe3783e9801$export$6ba72c8346b4c57e = [
    "light",
    "dark"
];
var $04784fe3783e9801$export$7a57f79000377ca2 = function borderRadius() {
    return 3;
};
var $04784fe3783e9801$export$6d8204c2cb2e06b8 = function gridSize() {
    return 8;
};
var $04784fe3783e9801$export$85e3c3ca0c6fb93 = function fontSize() {
    return 14;
};
var $04784fe3783e9801$export$6746fe0d9c9fab54 = function fontSizeSmall() {
    return 11;
};
var $04784fe3783e9801$export$a5975749f0374264 = function fontFamily() {
    return "-apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif";
};
var $04784fe3783e9801$export$356129969ee49c55 = function codeFontFamily() {
    return "'SFMono-Medium', 'SF Mono', 'Segoe UI Mono', 'Roboto Mono', 'Ubuntu Mono', Menlo, Consolas, Courier, monospace";
};
var $04784fe3783e9801$export$8e24544ddba725ee = function focusRing() {
    var color = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "var(--ds-border-focused, ".concat((0, $83Zvp.B200), ")");
    var outlineWidth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $04784fe3783e9801$export$6d8204c2cb2e06b8() / 4;
    (0, $e2xkU.default)("@atlaskit/theme", "focus ring mixin", "Please use `@atlaskit/focus-ring` instead.");
    return "\n  &:focus {\n    outline: none;\n    box-shadow: 0px 0px 0px ".concat(outlineWidth, "px ").concat(color, ";\n  }\n");
};
var $04784fe3783e9801$export$c0dd343266bc3261 = function noFocusRing() {
    return "\n  box-shadow: none;\n";
};
var $04784fe3783e9801$export$7be255094ccdc533 = {
    card: function card() {
        return 100;
    },
    navigation: function navigation() {
        return 200;
    },
    dialog: function dialog() {
        return 300;
    },
    layer: function layer() {
        return 400;
    },
    blanket: function blanket() {
        return 500;
    },
    modal: function modal() {
        return 510;
    },
    flag: function flag() {
        return 600;
    },
    spotlight: function spotlight() {
        return 700;
    },
    tooltip: function tooltip() {
        return 9999;
    }
};
var $04784fe3783e9801$export$a1b3edb637fb4f35 = function visuallyHidden() {
    (0, $e2xkU.default)("@atlaskit/theme", "visually hidden mixin", "Please use `@atlaskit/visually-hidden` instead.");
    return {
        border: "0 !important",
        clip: "rect(1px, 1px, 1px, 1px) !important",
        height: "1px !important",
        overflow: "hidden !important",
        padding: "0 !important",
        position: "absolute !important",
        width: "1px !important",
        whiteSpace: "nowrap !important"
    };
};
var $04784fe3783e9801$export$ba1d834b86d72a09 = $04784fe3783e9801$export$a1b3edb637fb4f35;
var $04784fe3783e9801$export$e497e856b4f89fcd = function skeletonShimmer() {
    return {
        css: {
            backgroundColor: "var(--ds-skeleton, ".concat((0, $83Zvp.skeleton)(), ")"),
            animationDuration: "1.5s",
            animationIterationCount: "infinite",
            animationTimingFunction: "linear",
            animationDirection: "alternate"
        },
        keyframes: {
            from: {
                backgroundColor: "var(--ds-skeleton, ".concat((0, $83Zvp.skeleton)(), ")")
            },
            to: {
                backgroundColor: "var(--ds-skeleton-subtle, ".concat((0, $83Zvp.N30A), ")")
            }
        }
    };
};

});






parcelRegister("Ia2MJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $084be6b03a58d1e0$export$2e2bcd8739ae039; });
/** @jsx jsx */ 
var $dAx5m = parcelRequire("dAx5m");

var $jVTBW = parcelRequire("jVTBW");
var $084be6b03a58d1e0$var$buttonGroupStyles = (0, $jVTBW.css)({
    display: "inline-flex",
    gap: "var(--ds-space-050, 4px)",
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
    "> *": {
        flex: "1 0 auto"
    }
});
function $084be6b03a58d1e0$export$2e2bcd8739ae039(_ref) {
    var appearance = _ref.appearance, children = _ref.children, testId = _ref.testId, label = _ref.label, titleId = _ref.titleId;
    return (0, $jVTBW.jsx)("div", {
        css: $084be6b03a58d1e0$var$buttonGroupStyles,
        "data-testid": testId,
        role: "group",
        "aria-label": label,
        "aria-labelledby": titleId
    }, (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).Children.map((0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).Children.toArray(children), function(child, idx) {
        if (!child) return null;
        return (0, $jVTBW.jsx)((0, $dAx5m.Fragment), {
            key: idx
        }, appearance ? /*#__PURE__*/ // eslint-disable-next-line @repo/internal/react/no-clone-element
        (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).cloneElement(child, {
            appearance: appearance
        }) : child);
    }));
}

});

parcelRegister("hkAex", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c9e06924a6b6a762$var$_react = $c9e06924a6b6a762$var$_interopRequireDefault((parcelRequire("dAx5m")));

var $9eGJl = parcelRequire("9eGJl");
function $c9e06924a6b6a762$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $c9e06924a6b6a762$var$ShortcutIcon = (props)=>/*#__PURE__*/ $c9e06924a6b6a762$var$_react.default.createElement($9eGJl.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentColor"><path d="M19.005 19c-.003 0-.005.002-.005.002l.005-.002zM5 19.006c0-.004-.002-.006-.005-.006H5v.006zM5 4.994V5v-.006zM19 19v-6h2v6.002A1.996 1.996 0 0119.005 21H4.995A1.996 1.996 0 013 19.006V4.994C3 3.893 3.896 3 4.997 3H11v2H5v14h14zM5 4.994V5v-.006zm0 14.012c0-.004-.002-.006-.005-.006H5v.006zM11 5H5v14h14v-6h2v6.002A1.996 1.996 0 0119.005 21H4.995A1.996 1.996 0 013 19.006V4.994C3 3.893 3.896 3 4.997 3H11v2zm8 0v3a1 1 0 002 0V4a1 1 0 00-1-1h-4a1 1 0 000 2h3z"/><path d="M12.707 12.707l8-8a1 1 0 10-1.414-1.414l-8 8a1 1 0 001.414 1.414z"/></g></svg>`
    }, props));
$c9e06924a6b6a762$var$ShortcutIcon.displayName = "ShortcutIcon";
var $c9e06924a6b6a762$var$_default = $c9e06924a6b6a762$var$ShortcutIcon;
module.exports.default = $c9e06924a6b6a762$var$_default;

});

parcelRegister("jIOoq", function(module, exports) {

$parcel$export(module.exports, "SectionMessageTitle", function () { return $ed40468737a1beb0$export$fe0e512f8a70bd16; });
$parcel$export(module.exports, "SettingsDescription", function () { return (parcelRequire("hxi5h")).SettingsDescription; });
$parcel$export(module.exports, "SettingsSection", function () { return (parcelRequire("hxi5h")).SettingsSection; });

var $ku6eE = parcelRequire("ku6eE");

var $hxi5h = parcelRequire("hxi5h");
const $ed40468737a1beb0$export$fe0e512f8a70bd16 = (0, $ku6eE.default).div`
  font-weight: 600;
`;

});

parcelRegister("1afLa", function(module, exports) {

$parcel$export(module.exports, "default", function () { return (parcelRequire("euho0")).default; });

var $euho0 = parcelRequire("euho0");

});
parcelRegister("euho0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2d1fffc90306c49f$export$2e2bcd8739ae039; });

var $irIFF = parcelRequire("irIFF");
var $2d1fffc90306c49f$export$2e2bcd8739ae039 = (0, $irIFF.default);

});
parcelRegister("irIFF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $57707bbf018500be$export$2e2bcd8739ae039; });

var $bibO8 = parcelRequire("bibO8");
parcelRequire("dAx5m");
parcelRequire("jShba");
var $9S009 = parcelRequire("9S009");
var $9FKx7 = parcelRequire("9FKx7");
parcelRequire("7d7uA");
var $KIb9t = parcelRequire("KIb9t");

var $bvU5q = parcelRequire("bvU5q");
var $57707bbf018500be$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, $bibO8.jsx)((0, $KIb9t.default), {
        request: (0, $9FKx7.default).deleteUser,
        children: ({ loading: isOnCompleteLoading, error: error }, deleteUser)=>/*#__PURE__*/ (0, $bibO8.jsx)((0, $KIb9t.default), {
                request: (0, $9S009.default).getAvailableSites,
                children: ({ data: sitesData }, getAvailableSites)=>/*#__PURE__*/ (0, $bibO8.jsx)((0, $bvU5q.default), {
                        getAccessibleSites: getAvailableSites,
                        accessibleSites: sitesData,
                        isOnDeleteUserLoading: isOnCompleteLoading,
                        deleteUser: deleteUser,
                        onDeleteError: error
                    })
            })
    });

});
parcelRegister("7d7uA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return (parcelRequire("KIb9t")).default; });

var $KIb9t = parcelRequire("KIb9t");

});
parcelRegister("KIb9t", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3c7963508d17b5f7$export$2e2bcd8739ae039; });

var $bibO8 = parcelRequire("bibO8");

var $dAx5m = parcelRequire("dAx5m");
const $3c7963508d17b5f7$export$7fa6c5b6f8193917 = ({ children: children, fireOnMount: fireOnMount, request: requestFn, variables: variables })=>{
    const [loading, setLoading] = (0, $dAx5m.useState)(undefined);
    const [error, setError] = (0, $dAx5m.useState)(null);
    const [data, setData] = (0, $dAx5m.useState)(undefined);
    /**
   * Send request on mount if props.fireOnMount is true
   */ (0, $dAx5m.useEffect)(()=>{
        if (fireOnMount) {
            if (variables) sendRequest(...variables);
            else sendRequest();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const setStateToRejected = (error)=>{
        setData(null);
        setError(error);
        setLoading(false);
    };
    const setStateToPending = ()=>{
        setError(null);
        setLoading(true);
    };
    const setStateToFulfilled = (data)=>{
        setData(data);
        setError(null);
        setLoading(false);
    };
    /**
   * Makes the async request, keeping the child render function up-to-date with
   * the state of the request.
   */ const sendRequest = (0, $dAx5m.useCallback)(async (...args)=>{
        const requestArguments = args.length ? args : variables;
        const request = requestArguments ? ()=>requestFn(...requestArguments) : ()=>requestFn();
        try {
            // Make the request, set state to pending
            setStateToPending();
            const resp = await request();
            // On success, set state to fulfilled
            setStateToFulfilled(resp);
        } catch (e) {
            // On error, set state to rejected
            setStateToRejected(e);
        }
    }, [
        requestFn,
        variables
    ]);
    return /*#__PURE__*/ (0, $bibO8.jsx)((0, $bibO8.Fragment), {
        children: children({
            loading: loading,
            error: error,
            data: data
        }, sendRequest)
    });
};
var $3c7963508d17b5f7$export$2e2bcd8739ae039 = $3c7963508d17b5f7$export$7fa6c5b6f8193917;

});


parcelRegister("bvU5q", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a1e25d42d3520836$export$2e2bcd8739ae039; });

var $bibO8 = parcelRequire("bibO8");

var $dAx5m = parcelRequire("dAx5m");

var $55TWT = parcelRequire("55TWT");
var $dZHnD = parcelRequire("dZHnD");

var $fIjLq = parcelRequire("fIjLq");
parcelRequire("2xGms");
var $9RxSY = parcelRequire("9RxSY");
var $j4C8S = parcelRequire("j4C8S");
parcelRequire("jShba");
var $3kXiv = parcelRequire("3kXiv");
var $fjOHq = parcelRequire("fjOHq");
var $1Bj4T = parcelRequire("1Bj4T");
var $9FKx7 = parcelRequire("9FKx7");
var $58n8k = parcelRequire("58n8k");

var $eN1Wl = parcelRequire("eN1Wl");

var $d59gI = parcelRequire("d59gI");

var $9n2A2 = parcelRequire("9n2A2");

var $3N6J0 = parcelRequire("3N6J0");
parcelRequire("ggxSz");
var $i4ou0 = parcelRequire("i4ou0");

var $5fi8x = parcelRequire("5fi8x");
parcelRequire("bXDKf");
var $9MaY0 = parcelRequire("9MaY0");
parcelRequire("jQGCp");
var $7PWYP = parcelRequire("7PWYP");

var $132jP = parcelRequire("132jP");
const $a1e25d42d3520836$var$canCloseAccountQueryKey = "canCloseAccountKey";
function $a1e25d42d3520836$export$3322cc76013bcb6a({ accessibleSites: accessibleSites, addFlag: addFlag, analytics: analytics, deleteUser: deleteUser, email: email, getAccessibleSites: getAccessibleSites, isOnDeleteUserLoading: isOnDeleteUserLoading, onDeleteError: onDeleteError, userId: userId }) {
    const { formatMessage: formatMessage } = (0, $dZHnD.default)();
    const { openDialog: openDialog } = (0, $5fi8x.default)();
    const queryClient = (0, $132jP.useQueryClient)();
    const [isFocusedTaskOpen, setIsFocusedTaskOpen] = (0, $dAx5m.useState)(false);
    const [isCheckCanCloseAccountLoading, setIsCheckCanCloseAccountLoading] = (0, $dAx5m.useState)(false);
    const previousOnDeleteError = (0, $i4ou0.usePrevious)(onDeleteError);
    const previousIsOnDeleteUserLoading = (0, $i4ou0.usePrevious)(isOnDeleteUserLoading);
    (0, $dAx5m.useEffect)(()=>{
        const hasOnDeleteError = onDeleteError && onDeleteError !== previousOnDeleteError;
        if (hasOnDeleteError) {
            analytics.pushTrackEvent({
                source: (0, $fjOHq.AnalyticsEventSource).DELETE_ACCOUNT_WARNING_MODAL,
                action: (0, $fjOHq.AnalyticsEventActions).FAILED,
                actionSubject: "deleteAccount"
            });
            addFlag({
                type: "error",
                title: formatMessage({
                    id: "ptc-directory.settings.close-account.delete-account-error.title.text",
                    defaultMessage: "We weren't able to delete your account.",
                    description: "Flag title when error is received"
                }),
                id: "delete.account.error"
            });
        }
        const isFinishedDeletingUser = !hasOnDeleteError && !isOnDeleteUserLoading && isOnDeleteUserLoading !== previousIsOnDeleteUserLoading;
        if (isFinishedDeletingUser) (0, $eN1Wl.redirect)(`${(0, $1Bj4T.getConfig)().atlassianAccountUrl}/logout?${(0, (/*@__PURE__*/$parcel$interopDefault($3N6J0))).stringify({
            continue: `${(0, $1Bj4T.getConfig)().atlassianAccountUrl}/login/deletion-request-confirmation`,
            prompt: "none"
        })}`);
    }, [
        formatMessage,
        previousIsOnDeleteUserLoading,
        previousOnDeleteError,
        analytics,
        addFlag,
        isOnDeleteUserLoading,
        onDeleteError
    ]);
    const fetchCanCloseAccount = async (userId)=>await queryClient.fetchQuery({
            queryKey: [
                $a1e25d42d3520836$var$canCloseAccountQueryKey,
                userId
            ],
            queryFn: async ()=>await (0, $9FKx7.default).checkCloseAccount(userId),
            staleTime: 120000
        });
    const handleDeleteAccountButtonInTabOnClick = async ()=>{
        analytics.pushUIEvent({
            source: (0, $fjOHq.AnalyticsEventSource).MANAGE_ACCOUNT_CLOSE_ACCOUNT_TAB,
            actionSubject: "deleteAccountButton",
            action: (0, $fjOHq.AnalyticsEventActions).CLICKED
        });
        try {
            setIsCheckCanCloseAccountLoading(true);
            const data = await fetchCanCloseAccount(userId);
            if (data.errors.length > 0) openDialog((0, $d59gI.default), {
                content: data.errors
            });
            else {
                await getAccessibleSites();
                setIsFocusedTaskOpen(true);
            }
        } catch (e) {
            addFlag({
                type: "error",
                title: formatMessage({
                    id: "ptc-directory.settings.close-account.check-for-warnings-error.title.text",
                    defaultMessage: "Something went wrong trying to delete your account. Please try again later.",
                    description: "Flag title when the user cannot start the Delete Account flow"
                }),
                id: "delete.account.check.error"
            });
        } finally{
            setIsCheckCanCloseAccountLoading(false);
        }
    };
    const openWarningModal = async ()=>{
        const data = await fetchCanCloseAccount(userId);
        openDialog((0, $9n2A2.default), {
            content: data?.warnings,
            onSubmit: handleDeleteOnClick,
            isLoading: isOnDeleteUserLoading,
            hasWarnings: data && data.warnings.length > 0,
            products: productsList()
        });
    };
    const handleDeleteButtonInTaskOnClick = ()=>{
        analytics.pushUIEvent({
            source: (0, $fjOHq.AnalyticsEventSource).DELETE_ACCOUNT_FOCUSED_TASK,
            actionSubject: "deleteAccountButton",
            action: (0, $fjOHq.AnalyticsEventActions).CLICKED
        });
        openWarningModal();
    };
    const handleFocusedTaskClose = ()=>{
        // push analytics on close of Delete Account focused task
        analytics.pushUIEvent({
            source: (0, $fjOHq.AnalyticsEventSource).DELETE_ACCOUNT_FOCUSED_TASK,
            actionSubject: "deleteAccountFocusedTask",
            action: (0, $fjOHq.AnalyticsEventActions).CLOSED
        });
        setIsFocusedTaskOpen(false);
    };
    const handleDeleteOnClick = ()=>{
        deleteUser(userId);
    };
    const productsList = ()=>{
        const sites = !accessibleSites ? [] : accessibleSites.sites;
        const productsList = sites.map(({ products: products = [] })=>products).reduce((a, b)=>a.concat(b), []);
        return [
            ...new Set(productsList)
        ];
    };
    const renderFinalSubmitButton = ()=>/*#__PURE__*/ (0, $bibO8.jsx)((0, $fIjLq.default), {
            appearance: "primary",
            onClick: handleDeleteButtonInTaskOnClick,
            children: /*#__PURE__*/ (0, $bibO8.jsx)((0, $55TWT.default), {
                id: "ptc-directory.settings.close-account.delete-account.button.text",
                defaultMessage: "Delete account",
                description: "Text for the button that deletes the user's account"
            })
        });
    const { avatarByAccountIdData: avatarByAccountIdData } = (0, $9MaY0.useAvatarByAccountIdQuery)(userId, 128);
    const renderDeleteUserOverviewScreen = ()=>{
        const avatarUrl = avatarByAccountIdData?.avatarUrl || "";
        const fullName = avatarByAccountIdData?.fullName || "";
        const sites = !accessibleSites ? [] : accessibleSites.sites.map(({ url: url })=>url.replace("https://", ""));
        return /*#__PURE__*/ (0, $bibO8.jsx)((0, $9RxSY.default), {
            accessibleSites: sites,
            isCurrentUser: true,
            user: {
                avatarUrl: avatarUrl,
                fullName: fullName,
                email: email
            },
            deactivateUserHandler: undefined,
            isUserDeactivated: false
        });
    };
    return /*#__PURE__*/ (0, $bibO8.jsxs)((0, $bibO8.Fragment), {
        children: [
            /*#__PURE__*/ (0, $bibO8.jsx)((0, $fIjLq.default), {
                appearance: "default",
                testId: "start-close-account-flow-button" // used in pollinators
                ,
                isLoading: isCheckCanCloseAccountLoading,
                onClick: handleDeleteAccountButtonInTabOnClick,
                children: /*#__PURE__*/ (0, $bibO8.jsx)((0, $55TWT.default), {
                    id: "ptc-directory.settings.close-account.button.text",
                    defaultMessage: "Delete account",
                    description: "Text for the button that begins deletion of the user's account"
                })
            }),
            isFocusedTaskOpen && /*#__PURE__*/ (0, $bibO8.jsx)((0, $j4C8S.default), {
                onClose: handleFocusedTaskClose,
                isOpen: true,
                screens: [
                    renderDeleteUserOverviewScreen()
                ],
                submitButton: renderFinalSubmitButton(),
                learnMoreLink: "https://confluence.atlassian.com/x/pAkvOg"
            })
        ]
    });
}
const $a1e25d42d3520836$var$mapDispatchToProps = (dispatch)=>({
        addFlag: (flag)=>dispatch((0, $3kXiv.addFlag)(flag))
    });
const $a1e25d42d3520836$var$mapStateToProps = ({ user: user })=>({
        userId: user.data.accountId,
        email: user.data.email
    });
var $a1e25d42d3520836$export$2e2bcd8739ae039 = (0, $7PWYP.default)($a1e25d42d3520836$var$mapStateToProps, $a1e25d42d3520836$var$mapDispatchToProps)((0, $58n8k.default)($a1e25d42d3520836$export$3322cc76013bcb6a));

});
parcelRegister("2xGms", function(module, exports) {

$parcel$export(module.exports, "FocusedTaskCloseAccount", function () { return (parcelRequire("j4C8S")).default; });
$parcel$export(module.exports, "DeleteUserOverviewScreen", function () { return (parcelRequire("9RxSY")).default; });
parcelRequire("4G48m");
var $j4C8S = parcelRequire("j4C8S");
parcelRequire("7TFao");
var $kFH64 = parcelRequire("kFH64");
parcelRequire("bkckr");
var $9RxSY = parcelRequire("9RxSY");
parcelRequire("bJeIz");
var $kJ8rD = parcelRequire("kJ8rD");

});
parcelRegister("4G48m", function(module, exports) {

$parcel$export(module.exports, "default", function () { return (parcelRequire("j4C8S")).default; });

var $j4C8S = parcelRequire("j4C8S");

});
parcelRegister("j4C8S", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $de2bfa4460d90fe0$export$2e2bcd8739ae039; });

var $8TMbA = parcelRequire("8TMbA");

var $5MUML = parcelRequire("5MUML");

var $dXLvS = parcelRequire("dXLvS");

var $4irYd = parcelRequire("4irYd");

var $lKQfu = parcelRequire("lKQfu");

var $fKxww = parcelRequire("fKxww");

var $ilqjt = parcelRequire("ilqjt");

var $iDtim = parcelRequire("iDtim");

var $dAx5m = parcelRequire("dAx5m");

var $55TWT = parcelRequire("55TWT");

var $fIjLq = parcelRequire("fIjLq");

var $edHut = parcelRequire("edHut");

var $5rapc = parcelRequire("5rapc");

var $gLQuH = parcelRequire("gLQuH");
parcelRequire("5Sc6l");
var $iEIrF = parcelRequire("iEIrF");

var $jrFqr = parcelRequire("jrFqr");

var $05eJd = parcelRequire("05eJd");
function $de2bfa4460d90fe0$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $de2bfa4460d90fe0$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, (/*@__PURE__*/$parcel$interopDefault($ilqjt)))(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, (/*@__PURE__*/$parcel$interopDefault($ilqjt)))(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, (/*@__PURE__*/$parcel$interopDefault($fKxww)))(this, result);
    };
}
function $de2bfa4460d90fe0$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($de2bfa4460d90fe0$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $de2bfa4460d90fe0$export$3ed3dab6de0c9b2f = /*#__PURE__*/ function(_React$Component) {
    (0, (/*@__PURE__*/$parcel$interopDefault($lKQfu)))(FocusedTaskCloseAccount, _React$Component);
    var _super = $de2bfa4460d90fe0$var$_createSuper(FocusedTaskCloseAccount);
    function FocusedTaskCloseAccount() {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($5MUML)))(this, FocusedTaskCloseAccount);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, (/*@__PURE__*/$parcel$interopDefault($iDtim)))((0, (/*@__PURE__*/$parcel$interopDefault($4irYd)))(_this), "state", {
            currentScreenIdx: 0
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($iDtim)))((0, (/*@__PURE__*/$parcel$interopDefault($4irYd)))(_this), "nextScreen", function() {
            var screens = _this.props.screens;
            var currentScreenIdx = _this.state.currentScreenIdx;
            var nextScreenIdx = currentScreenIdx < screens.length - 1 ? currentScreenIdx + 1 : screens.length - 1;
            _this.setState({
                currentScreenIdx: nextScreenIdx
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($iDtim)))((0, (/*@__PURE__*/$parcel$interopDefault($4irYd)))(_this), "previousScreen", function() {
            var currentScreenIdx = _this.state.currentScreenIdx;
            var previousScreenIdx = currentScreenIdx - 1 >= 0 ? currentScreenIdx - 1 : 0;
            _this.setState({
                currentScreenIdx: previousScreenIdx
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($iDtim)))((0, (/*@__PURE__*/$parcel$interopDefault($4irYd)))(_this), "renderCurrentScreen", function() {
            var currentScreen = _this.props.screens[_this.state.currentScreenIdx];
            return currentScreen;
        });
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($dXLvS)))(FocusedTaskCloseAccount, [
        {
            key: "render",
            value: function render() {
                var _this$props = this.props, isOpen = _this$props.isOpen, onClose = _this$props.onClose, screens = _this$props.screens, submitButton = _this$props.submitButton, learnMoreLink = _this$props.learnMoreLink;
                var currentScreenIdx = this.state.currentScreenIdx;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $05eJd.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $edHut.default), {
                    icon: function icon(props) {
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5rapc))), (0, (/*@__PURE__*/$parcel$interopDefault($8TMbA)))({
                            label: ""
                        }, props, {
                            size: "medium"
                        }));
                    },
                    isOpen: isOpen,
                    onClose: onClose,
                    width: "full"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement($gLQuH.DrawerInner, null, this.renderCurrentScreen(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $iEIrF.default), {
                    numScreens: screens.length,
                    currentScreenIdx: currentScreenIdx,
                    onCancel: onClose,
                    onNext: this.nextScreen,
                    onPrevious: this.previousScreen,
                    secondaryActions: learnMoreLink && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $fIjLq.default), {
                        appearance: "subtle-link",
                        spacing: "none",
                        href: learnMoreLink,
                        target: "_blank"
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $55TWT.default), (0, $jrFqr.commonMessages).learnMore), " "),
                    submitButton: submitButton
                }))));
            }
        }
    ]);
    return FocusedTaskCloseAccount;
}((0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).Component);
var $de2bfa4460d90fe0$export$2e2bcd8739ae039 = $de2bfa4460d90fe0$export$3ed3dab6de0c9b2f;

});
parcelRegister("8TMbA", function(module, exports) {
function $67a8d684f8ff2752$var$_extends() {
    return module.exports = $67a8d684f8ff2752$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $67a8d684f8ff2752$var$_extends.apply(null, arguments);
}
module.exports = $67a8d684f8ff2752$var$_extends, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("5MUML", function(module, exports) {
function $436d7be438aeb534$var$_classCallCheck(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
module.exports = $436d7be438aeb534$var$_classCallCheck, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("dXLvS", function(module, exports) {

var $9O3Sk = parcelRequire("9O3Sk");
function $a2a5a42c4c061dd7$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, $9O3Sk(o.key), o);
    }
}
function $a2a5a42c4c061dd7$var$_createClass(e, r, t) {
    return r && $a2a5a42c4c061dd7$var$_defineProperties(e.prototype, r), t && $a2a5a42c4c061dd7$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}
module.exports = $a2a5a42c4c061dd7$var$_createClass, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("9O3Sk", function(module, exports) {

var $jRSpJ = parcelRequire("jRSpJ");
var $723bca1db59a9f58$var$_typeof = $jRSpJ.default;

var $5HBXu = parcelRequire("5HBXu");
function $723bca1db59a9f58$var$toPropertyKey(t) {
    var i = $5HBXu(t, "string");
    return "symbol" == $723bca1db59a9f58$var$_typeof(i) ? i : i + "";
}
module.exports = $723bca1db59a9f58$var$toPropertyKey, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("jRSpJ", function(module, exports) {
function $e76d2d07f60a13de$var$_typeof(o) {
    "@babel/helpers - typeof";
    return module.exports = $e76d2d07f60a13de$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $e76d2d07f60a13de$var$_typeof(o);
}
module.exports = $e76d2d07f60a13de$var$_typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("5HBXu", function(module, exports) {

var $jRSpJ = parcelRequire("jRSpJ");
var $426e69a79a0f0d17$var$_typeof = $jRSpJ.default;
function $426e69a79a0f0d17$var$toPrimitive(t, r) {
    if ("object" != $426e69a79a0f0d17$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $426e69a79a0f0d17$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
module.exports = $426e69a79a0f0d17$var$toPrimitive, module.exports.__esModule = true, module.exports["default"] = module.exports;

});



parcelRegister("4irYd", function(module, exports) {
function $320e8a2b23791c0c$var$_assertThisInitialized(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}
module.exports = $320e8a2b23791c0c$var$_assertThisInitialized, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("lKQfu", function(module, exports) {

var $kOxRy = parcelRequire("kOxRy");
function $fd666c6664bc2717$var$_inherits(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && $kOxRy(t, e);
}
module.exports = $fd666c6664bc2717$var$_inherits, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("kOxRy", function(module, exports) {
function $f272be93857c18cb$var$_setPrototypeOf(t, e) {
    return module.exports = $f272be93857c18cb$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $f272be93857c18cb$var$_setPrototypeOf(t, e);
}
module.exports = $f272be93857c18cb$var$_setPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("fKxww", function(module, exports) {

var $jRSpJ = parcelRequire("jRSpJ");
var $b77527f2833bafef$var$_typeof = $jRSpJ.default;

var $4irYd = parcelRequire("4irYd");
function $b77527f2833bafef$var$_possibleConstructorReturn(t, e) {
    if (e && ("object" == $b77527f2833bafef$var$_typeof(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return $4irYd(t);
}
module.exports = $b77527f2833bafef$var$_possibleConstructorReturn, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("ilqjt", function(module, exports) {
function $d5ae9965d1759e90$var$_getPrototypeOf(t) {
    return module.exports = $d5ae9965d1759e90$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $d5ae9965d1759e90$var$_getPrototypeOf(t);
}
module.exports = $d5ae9965d1759e90$var$_getPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("iDtim", function(module, exports) {

var $9O3Sk = parcelRequire("9O3Sk");
function $d91297ef48c0e463$var$_defineProperty(e, r, t) {
    return (r = $9O3Sk(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
module.exports = $d91297ef48c0e463$var$_defineProperty, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("edHut", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a5a403e5d4db52ec$export$2e2bcd8739ae039; });

var $5MUML = parcelRequire("5MUML");

var $dXLvS = parcelRequire("dXLvS");

var $4irYd = parcelRequire("4irYd");

var $lKQfu = parcelRequire("lKQfu");

var $fKxww = parcelRequire("fKxww");

var $ilqjt = parcelRequire("ilqjt");

var $iDtim = parcelRequire("iDtim");

var $dAx5m = parcelRequire("dAx5m");

var $5Fvus = parcelRequire("5Fvus");

var $6cgWr = parcelRequire("6cgWr");
var $hYxkU = parcelRequire("hYxkU");
var $jaHCf = parcelRequire("jaHCf");

var $k4dMs = parcelRequire("k4dMs");

var $1XHoZ = parcelRequire("1XHoZ");

var $1EvNv = parcelRequire("1EvNv");

var $8Qja1 = parcelRequire("8Qja1");
function $a5a403e5d4db52ec$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $a5a403e5d4db52ec$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $a5a403e5d4db52ec$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($iDtim)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $a5a403e5d4db52ec$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $a5a403e5d4db52ec$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $a5a403e5d4db52ec$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, (/*@__PURE__*/$parcel$interopDefault($ilqjt)))(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, (/*@__PURE__*/$parcel$interopDefault($ilqjt)))(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, (/*@__PURE__*/$parcel$interopDefault($fKxww)))(this, result);
    };
}
function $a5a403e5d4db52ec$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($a5a403e5d4db52ec$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $a5a403e5d4db52ec$var$packageName = "@atlaskit/drawer";
var $a5a403e5d4db52ec$var$packageVersion = "7.10.0";
var $a5a403e5d4db52ec$var$createAndFireEventOnAtlaskit = (0, $6cgWr.default)("atlaskit");
var $a5a403e5d4db52ec$var$createAndFireOnClick = function createAndFireOnClick(createAnalyticsEvent, trigger) {
    return $a5a403e5d4db52ec$var$createAndFireEventOnAtlaskit({
        action: "dismissed",
        actionSubject: "drawer",
        attributes: {
            componentName: "drawer",
            packageName: $a5a403e5d4db52ec$var$packageName,
            packageVersion: $a5a403e5d4db52ec$var$packageVersion,
            trigger: trigger
        }
    })(createAnalyticsEvent);
};
var $a5a403e5d4db52ec$export$b66bc6457778cdcb = /*#__PURE__*/ function(_Component) {
    (0, (/*@__PURE__*/$parcel$interopDefault($lKQfu)))(DrawerBase, _Component);
    var _super = $a5a403e5d4db52ec$var$_createSuper(DrawerBase);
    function DrawerBase() {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($5MUML)))(this, DrawerBase);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, (/*@__PURE__*/$parcel$interopDefault($iDtim)))((0, (/*@__PURE__*/$parcel$interopDefault($4irYd)))(_this), "state", {
            renderPortal: false
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($iDtim)))((0, (/*@__PURE__*/$parcel$interopDefault($4irYd)))(_this), "body", (0, $5Fvus.canUseDOM) ? document.querySelector("body") : undefined);
        (0, (/*@__PURE__*/$parcel$interopDefault($iDtim)))((0, (/*@__PURE__*/$parcel$interopDefault($4irYd)))(_this), "handleBlanketClick", function(event) {
            _this.handleClose(event, "blanket");
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($iDtim)))((0, (/*@__PURE__*/$parcel$interopDefault($4irYd)))(_this), "handleBackButtonClick", function(event) {
            _this.handleClose(event, "backButton");
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($iDtim)))((0, (/*@__PURE__*/$parcel$interopDefault($4irYd)))(_this), "handleClose", function(event, trigger) {
            var _this$props = _this.props, createAnalyticsEvent = _this$props.createAnalyticsEvent, onClose = _this$props.onClose;
            var analyticsEvent = createAnalyticsEvent && $a5a403e5d4db52ec$var$createAndFireOnClick(createAnalyticsEvent, trigger);
            if (onClose) onClose(event, analyticsEvent);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($iDtim)))((0, (/*@__PURE__*/$parcel$interopDefault($4irYd)))(_this), "handleKeyDown", function(event) {
            var _this$props2 = _this.props, isOpen = _this$props2.isOpen, onKeyDown = _this$props2.onKeyDown;
            if (event.key === "Escape" && isOpen) _this.handleClose(event, "escKey");
            if (onKeyDown) onKeyDown(event);
        });
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($dXLvS)))(DrawerBase, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var isOpen = this.props.isOpen;
                if (isOpen) window.addEventListener("keydown", this.handleKeyDown);
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                window.removeEventListener("keydown", this.handleKeyDown);
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                var isOpen = this.props.isOpen;
                if (isOpen !== prevProps.isOpen) {
                    if (isOpen) window.addEventListener("keydown", this.handleKeyDown);
                    else window.removeEventListener("keydown", this.handleKeyDown);
                }
            }
        },
        {
            key: "render",
            value: function render() {
                if (!this.body) return null;
                var _this$props3 = this.props, testId = _this$props3.testId, isOpen = _this$props3.isOpen, children = _this$props3.children, icon = _this$props3.icon, closeLabel = _this$props3.closeLabel, width = _this$props3.width, shouldUnmountOnExit = _this$props3.shouldUnmountOnExit, onCloseComplete = _this$props3.onCloseComplete, onOpenComplete = _this$props3.onOpenComplete, autoFocusFirstElem = _this$props3.autoFocusFirstElem, isFocusLockEnabled = _this$props3.isFocusLockEnabled, shouldReturnFocus = _this$props3.shouldReturnFocus, overrides = _this$props3.overrides, _this$props3$zIndex = _this$props3.zIndex, zIndex = _this$props3$zIndex === void 0 ? "unset" : _this$props3$zIndex, label = _this$props3.label, titleId = _this$props3.titleId;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $k4dMs.default), {
                    zIndex: zIndex
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $1EvNv.default), {
                    isOpen: isOpen,
                    onBlanketClicked: this.handleBlanketClick,
                    testId: testId && "".concat(testId, "--blanket")
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $8Qja1.default), {
                    testId: testId,
                    icon: icon,
                    closeLabel: closeLabel,
                    in: isOpen,
                    onClose: this.handleBackButtonClick,
                    onCloseComplete: onCloseComplete,
                    onOpenComplete: onOpenComplete,
                    width: width,
                    label: label,
                    titleId: titleId,
                    shouldUnmountOnExit: shouldUnmountOnExit,
                    overrides: overrides,
                    autoFocusFirstElem: autoFocusFirstElem,
                    isFocusLockEnabled: isFocusLockEnabled,
                    shouldReturnFocus: shouldReturnFocus
                }, children));
            }
        }
    ]);
    return DrawerBase;
}((0, $dAx5m.Component));
(0, (/*@__PURE__*/$parcel$interopDefault($iDtim)))($a5a403e5d4db52ec$export$b66bc6457778cdcb, "defaultProps", $a5a403e5d4db52ec$var$_objectSpread({
    width: "narrow"
}, (0, $1XHoZ.defaultFocusLockSettings)));
var $a5a403e5d4db52ec$export$2e2bcd8739ae039 = (0, $hYxkU.default)({
    componentName: "drawer",
    packageName: $a5a403e5d4db52ec$var$packageName,
    packageVersion: $a5a403e5d4db52ec$var$packageVersion
})((0, $jaHCf.default)()($a5a403e5d4db52ec$export$b66bc6457778cdcb));

});
parcelRegister("6cgWr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $483101559a23d803$export$2e2bcd8739ae039; });
var $483101559a23d803$export$2e2bcd8739ae039 = function(channel) {
    return function(payload) {
        return function(createAnalyticsEvent) {
            var consumerEvent = createAnalyticsEvent(payload);
            var clonedEvent = consumerEvent.clone();
            if (clonedEvent) clonedEvent.fire(channel);
            return consumerEvent;
        };
    };
};

});

parcelRegister("hYxkU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d161e6271fbd2cad$export$2e2bcd8739ae039; });

var $8TMbA = parcelRequire("8TMbA");

var $iDtim = parcelRequire("iDtim");

var $8jzoy = parcelRequire("8jzoy");

var $dAx5m = parcelRequire("dAx5m");

var $drGKX = parcelRequire("drGKX");
var $d161e6271fbd2cad$var$_excluded = [
    "analyticsContext"
];
function $d161e6271fbd2cad$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $d161e6271fbd2cad$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $d161e6271fbd2cad$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($iDtim)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $d161e6271fbd2cad$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $d161e6271fbd2cad$var$withAnalyticsContext = function withAnalyticsContext(defaultData) {
    return function(WrappedComponent) {
        var WithAnalyticsContext = /*#__PURE__*/ (0, $dAx5m.forwardRef)(function(_ref, ref) {
            var analyticsContext = _ref.analyticsContext, rest = (0, (/*@__PURE__*/$parcel$interopDefault($8jzoy)))(_ref, $d161e6271fbd2cad$var$_excluded);
            var analyticsData = (0, $dAx5m.useMemo)(function() {
                return $d161e6271fbd2cad$var$_objectSpread($d161e6271fbd2cad$var$_objectSpread({}, defaultData), analyticsContext);
            }, [
                analyticsContext
            ]);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $drGKX.default), {
                data: analyticsData
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement(WrappedComponent, (0, (/*@__PURE__*/$parcel$interopDefault($8TMbA)))({}, rest, {
                ref: ref
            })));
        });
        WithAnalyticsContext.displayName = "WithAnalyticsContext(".concat(WrappedComponent.displayName || WrappedComponent.name, ")");
        return WithAnalyticsContext;
    };
};
var $d161e6271fbd2cad$export$2e2bcd8739ae039 = $d161e6271fbd2cad$var$withAnalyticsContext;

});
parcelRegister("8jzoy", function(module, exports) {

var $9i82i = parcelRequire("9i82i");
function $60db8dc966724d0a$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $9i82i(e, t);
    if (Object.getOwnPropertySymbols) {
        var s = Object.getOwnPropertySymbols(e);
        for(r = 0; r < s.length; r++)o = s[r], t.includes(o) || ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
module.exports = $60db8dc966724d0a$var$_objectWithoutProperties, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("9i82i", function(module, exports) {
function $6c3c074f90296807$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.includes(n)) continue;
        t[n] = r[n];
    }
    return t;
}
module.exports = $6c3c074f90296807$var$_objectWithoutPropertiesLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("drGKX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9c9ef67e7e1db7ef$export$2e2bcd8739ae039; });

var $dAx5m = parcelRequire("dAx5m");

var $cmq4J = parcelRequire("cmq4J");

var $kqY8Z = parcelRequire("kqY8Z");

var $ljj6u = parcelRequire("ljj6u");

var $hA9kW = parcelRequire("hA9kW");
var $9c9ef67e7e1db7ef$var$ExportedAnalyticsContext = function ExportedAnalyticsContext(props) {
    var isModernContext = (0, $kqY8Z.default) || (0, $cmq4J.fg)("platform.analytics-next-use-modern-context_fqgbx");
    return isModernContext ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $hA9kW.default), props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $ljj6u.default), props);
};
var $9c9ef67e7e1db7ef$export$2e2bcd8739ae039 = $9c9ef67e7e1db7ef$var$ExportedAnalyticsContext;

});
parcelRegister("cmq4J", function(module, exports) {

$parcel$export(module.exports, "fg", function () { return $8ffbc422506d22e2$export$b40ec24ac8275656; });

var $kCbbl = parcelRequire("kCbbl");
function $8ffbc422506d22e2$export$ba05d765b8392e5e(flagResolver) {
    (0, $kCbbl.setBooleanResolver)(flagResolver);
}
function $8ffbc422506d22e2$export$470e5c2be1411c89(name) {
    return (0, $kCbbl.resolveBooleanFlag)(name);
}
function $8ffbc422506d22e2$export$b40ec24ac8275656(name) {
    return (0, $kCbbl.resolveBooleanFlag)(name);
}

});
parcelRegister("kCbbl", function(module, exports) {

$parcel$export(module.exports, "setBooleanResolver", function () { return $f02007c691d23130$export$f2b591175b3e424c; });
$parcel$export(module.exports, "resolveBooleanFlag", function () { return $f02007c691d23130$export$6333b6aff9fc6275; });

var $cTcLd = parcelRequire("cTcLd");

var $ahJoN = parcelRequire("ahJoN");
var $f02007c691d23130$var$pkgName = "@atlaskit/platform-feature-flags";
var $f02007c691d23130$export$7e41b1b2bdee3f98 = "__PLATFORM_FEATURE_FLAGS__";
var $f02007c691d23130$var$hasProcessEnv = typeof $ahJoN !== "undefined" && typeof $ahJoN.env !== "undefined";
// FF global overrides can be configured by test runners or Storybook
var $f02007c691d23130$var$ENV_ENABLE_PLATFORM_FF = $f02007c691d23130$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
// STORYBOOK_ENABLE_PLATFORM_FF is included as storybook only allows env vars prefixed with STORYBOOK
// https://github.com/storybookjs/storybook/issues/12270
var $f02007c691d23130$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF = $f02007c691d23130$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
var $f02007c691d23130$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE = $f02007c691d23130$var$ENV_ENABLE_PLATFORM_FF || $f02007c691d23130$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF;
var $f02007c691d23130$var$DEFAULT_PFF_GLOBAL = {
    // In development mode we want to capture any feature flag checks that happen using the default resolver and log this result when the resolver is replaced.
    // This is because evaluating feature flags when the resolver/FF client is loaded asynchronously could cause unexpected issues.
    earlyResolvedFlags: new Map(),
    booleanResolver: function booleanResolver(flagKey) {
        var unresolvedFlagCount;
        return false;
    }
};
var $f02007c691d23130$var$globalVar = typeof window !== "undefined" ? window : globalThis;
$f02007c691d23130$var$globalVar[$f02007c691d23130$export$7e41b1b2bdee3f98] = $f02007c691d23130$var$globalVar[$f02007c691d23130$export$7e41b1b2bdee3f98] || $f02007c691d23130$var$DEFAULT_PFF_GLOBAL;
function $f02007c691d23130$export$f2b591175b3e424c(resolver) {
    $f02007c691d23130$var$globalVar[$f02007c691d23130$export$7e41b1b2bdee3f98].booleanResolver = resolver;
    var _globalVar$PFF_GLOBAL;
}
function $f02007c691d23130$export$6333b6aff9fc6275(flagKey) {
    if ($f02007c691d23130$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE) {
        (0, $cTcLd.debug)('[%s]: The feature flags were enabled while running tests. The flag "%s" will be always enabled.', $f02007c691d23130$var$pkgName, flagKey);
        return true;
    }
    try {
        var _globalVar$PFF_GLOBAL2;
        var result = (_globalVar$PFF_GLOBAL2 = $f02007c691d23130$var$globalVar[$f02007c691d23130$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL2 === void 0 ? void 0 : _globalVar$PFF_GLOBAL2.booleanResolver(flagKey);
        if (typeof result !== "boolean") {
            // eslint-disable-next-line no-console
            console.warn("".concat(flagKey, " resolved to a non-boolean value, returning false for safety"));
            return false;
        }
        return result;
    } catch (e) {
        return false;
    }
}

});
parcelRegister("cTcLd", function(module, exports) {

$parcel$export(module.exports, "debug", function () { return $96248510048ca0c8$export$1c9f709888824e05; });
var $96248510048ca0c8$var$_ref, $96248510048ca0c8$var$_process, $96248510048ca0c8$var$_process2;
// We can't rely on NODE_ENV === 'test' if its value is already configured by the consumer to some other value, so better to use JEST_WORKER_ID
// https://jestjs.io/docs/environment-variables#jest_worker_id
var $96248510048ca0c8$var$TESTS_MODE = ($96248510048ca0c8$var$_ref = (globalThis === null || globalThis === void 0 || ($96248510048ca0c8$var$_process = globalThis.process) === null || $96248510048ca0c8$var$_process === void 0 || ($96248510048ca0c8$var$_process = $96248510048ca0c8$var$_process.env) === null || $96248510048ca0c8$var$_process === void 0 ? void 0 : $96248510048ca0c8$var$_process.JEST_WORKER_ID) !== undefined, $96248510048ca0c8$var$_ref !== void 0) ? $96248510048ca0c8$var$_ref : false;
var $96248510048ca0c8$var$DEBUG_MODE = !$96248510048ca0c8$var$TESTS_MODE && (globalThis === null || globalThis === void 0 || ($96248510048ca0c8$var$_process2 = globalThis.process) === null || $96248510048ca0c8$var$_process2 === void 0 || ($96248510048ca0c8$var$_process2 = $96248510048ca0c8$var$_process2.env) === null || $96248510048ca0c8$var$_process2 === void 0 ? void 0 : $96248510048ca0c8$var$_process2.NODE_ENV) !== "production";
var $96248510048ca0c8$export$1c9f709888824e05 = function debug() {
    var _console;
    if (!$96248510048ca0c8$var$DEBUG_MODE) return;
    // eslint-disable-next-line no-console
    (_console = console).debug.apply(_console, arguments);
};

});



parcelRegister("kqY8Z", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ee04e3b1d6d567a1$export$2e2bcd8739ae039; });

var $ahJoN = parcelRequire("ahJoN");
var $ee04e3b1d6d567a1$var$_process$env;
var $ee04e3b1d6d567a1$export$2e2bcd8739ae039 = typeof $ahJoN !== "undefined" && $ahJoN !== null && (($ee04e3b1d6d567a1$var$_process$env = {}, $ee04e3b1d6d567a1$var$_process$env === void 0) ? void 0 : $ee04e3b1d6d567a1$var$_process$env["ANALYTICS_NEXT_MODERN_CONTEXT"]);

});

parcelRegister("ljj6u", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f83a30f071024eca$export$2e2bcd8739ae039; });

var $k2EOa = parcelRequire("k2EOa");

var $5MUML = parcelRequire("5MUML");

var $dXLvS = parcelRequire("dXLvS");

var $4irYd = parcelRequire("4irYd");

var $lKQfu = parcelRequire("lKQfu");

var $fKxww = parcelRequire("fKxww");

var $ilqjt = parcelRequire("ilqjt");

var $iDtim = parcelRequire("iDtim");

var $dAx5m = parcelRequire("dAx5m");

var $hyn2k = parcelRequire("hyn2k");

var $h0bf1 = parcelRequire("h0bf1");
function $f83a30f071024eca$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $f83a30f071024eca$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, (/*@__PURE__*/$parcel$interopDefault($ilqjt)))(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, (/*@__PURE__*/$parcel$interopDefault($ilqjt)))(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, (/*@__PURE__*/$parcel$interopDefault($fKxww)))(this, result);
    };
}
function $f83a30f071024eca$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($f83a30f071024eca$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $f83a30f071024eca$var$ContextTypes = {
    getAtlaskitAnalyticsContext: (0, (/*@__PURE__*/$parcel$interopDefault($hyn2k))).func,
    getAtlaskitAnalyticsEventHandlers: (0, (/*@__PURE__*/$parcel$interopDefault($hyn2k))).func
};
var $f83a30f071024eca$var$noop = function noop() {
    return [];
};
// eslint-disable-next-line @repo/internal/react/no-class-components
var $f83a30f071024eca$var$AnalyticsContext = /*#__PURE__*/ function(_Component) {
    (0, (/*@__PURE__*/$parcel$interopDefault($lKQfu)))(AnalyticsContext, _Component);
    var _super = $f83a30f071024eca$var$_createSuper(AnalyticsContext);
    function AnalyticsContext(props) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($5MUML)))(this, AnalyticsContext);
        _this = _super.call(this, props);
        (0, (/*@__PURE__*/$parcel$interopDefault($iDtim)))((0, (/*@__PURE__*/$parcel$interopDefault($4irYd)))(_this), "getChildContext", function() {
            return {
                getAtlaskitAnalyticsContext: _this.getAnalyticsContext
            };
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($iDtim)))((0, (/*@__PURE__*/$parcel$interopDefault($4irYd)))(_this), "getAnalyticsContext", function() {
            var data = _this.props.data;
            var _this$context$getAtla = _this.context.getAtlaskitAnalyticsContext, getAtlaskitAnalyticsContext = _this$context$getAtla === void 0 ? $f83a30f071024eca$var$noop : _this$context$getAtla;
            return [].concat((0, (/*@__PURE__*/$parcel$interopDefault($k2EOa)))(getAtlaskitAnalyticsContext()), [
                data
            ]);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($iDtim)))((0, (/*@__PURE__*/$parcel$interopDefault($4irYd)))(_this), "getAnalyticsEventHandlers", function() {
            var _this$context$getAtla2 = _this.context.getAtlaskitAnalyticsEventHandlers, getAtlaskitAnalyticsEventHandlers = _this$context$getAtla2 === void 0 ? $f83a30f071024eca$var$noop : _this$context$getAtla2;
            return getAtlaskitAnalyticsEventHandlers();
        });
        _this.contextValue = {
            getAtlaskitAnalyticsContext: _this.getAnalyticsContext,
            getAtlaskitAnalyticsEventHandlers: _this.getAnalyticsEventHandlers
        };
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($dXLvS)))(AnalyticsContext, [
        {
            key: "render",
            value: function render() {
                var children = this.props.children;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $h0bf1.default).Provider, {
                    value: this.contextValue
                }, children);
            }
        }
    ]);
    return AnalyticsContext;
}((0, $dAx5m.Component));
(0, (/*@__PURE__*/$parcel$interopDefault($iDtim)))($f83a30f071024eca$var$AnalyticsContext, "contextTypes", $f83a30f071024eca$var$ContextTypes);
(0, (/*@__PURE__*/$parcel$interopDefault($iDtim)))($f83a30f071024eca$var$AnalyticsContext, "childContextTypes", $f83a30f071024eca$var$ContextTypes);
var $f83a30f071024eca$export$2e2bcd8739ae039 = $f83a30f071024eca$var$AnalyticsContext;

});
parcelRegister("k2EOa", function(module, exports) {

var $hSKjc = parcelRequire("hSKjc");

var $4Bo3s = parcelRequire("4Bo3s");

var $5mvmw = parcelRequire("5mvmw");

var $6IX1r = parcelRequire("6IX1r");
function $e973a62f0175b320$var$_toConsumableArray(r) {
    return $hSKjc(r) || $4Bo3s(r) || $5mvmw(r) || $6IX1r();
}
module.exports = $e973a62f0175b320$var$_toConsumableArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("hSKjc", function(module, exports) {

var $eYi7n = parcelRequire("eYi7n");
function $d04b66bf299066b3$var$_arrayWithoutHoles(r) {
    if (Array.isArray(r)) return $eYi7n(r);
}
module.exports = $d04b66bf299066b3$var$_arrayWithoutHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("eYi7n", function(module, exports) {
function $ae64b926c3563a1c$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
module.exports = $ae64b926c3563a1c$var$_arrayLikeToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("4Bo3s", function(module, exports) {
function $359d46e8363a949f$var$_iterableToArray(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
module.exports = $359d46e8363a949f$var$_iterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("5mvmw", function(module, exports) {

var $eYi7n = parcelRequire("eYi7n");
function $3e7755ba7162602e$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $eYi7n(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $eYi7n(r, a) : void 0;
    }
}
module.exports = $3e7755ba7162602e$var$_unsupportedIterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("6IX1r", function(module, exports) {
function $4e54a2c0539626ca$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
module.exports = $4e54a2c0539626ca$var$_nonIterableSpread, module.exports.__esModule = true, module.exports["default"] = module.exports;

});



parcelRegister("hA9kW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cccd0a8a0cd97ca6$export$2e2bcd8739ae039; });

var $k2EOa = parcelRequire("k2EOa");

var $dAx5m = parcelRequire("dAx5m");

var $h0bf1 = parcelRequire("h0bf1");

var $aKvho = parcelRequire("aKvho");

var $CVDHe = parcelRequire("CVDHe");
var $cccd0a8a0cd97ca6$var$AnalyticsContext = function AnalyticsContext(_ref) {
    var data = _ref.data, children = _ref.children;
    var dataRef = (0, $CVDHe.useTrackedRef)(data);
    var _useAnalyticsContext = (0, $aKvho.useAnalyticsContext)(), getAtlaskitAnalyticsEventHandlers = _useAnalyticsContext.getAtlaskitAnalyticsEventHandlers, getOriginalAnalyticsContext = _useAnalyticsContext.getAtlaskitAnalyticsContext;
    var getAtlaskitAnalyticsContext = (0, $dAx5m.useCallback)(function() {
        return [].concat((0, (/*@__PURE__*/$parcel$interopDefault($k2EOa)))(getOriginalAnalyticsContext()), [
            dataRef.current
        ]);
    }, [
        getOriginalAnalyticsContext,
        dataRef
    ]);
    var value = (0, $dAx5m.useMemo)(function() {
        return {
            getAtlaskitAnalyticsContext: getAtlaskitAnalyticsContext,
            getAtlaskitAnalyticsEventHandlers: getAtlaskitAnalyticsEventHandlers
        };
    }, [
        getAtlaskitAnalyticsContext,
        getAtlaskitAnalyticsEventHandlers
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $h0bf1.default).Provider, {
        value: value
    }, children);
};
var $cccd0a8a0cd97ca6$export$2e2bcd8739ae039 = $cccd0a8a0cd97ca6$var$AnalyticsContext;

});
parcelRegister("aKvho", function(module, exports) {

$parcel$export(module.exports, "useAnalyticsContext", function () { return $7d3676b427c0b469$export$d1f587f82ad51c4; });

var $dAx5m = parcelRequire("dAx5m");

var $h0bf1 = parcelRequire("h0bf1");
var $7d3676b427c0b469$export$d1f587f82ad51c4 = function useAnalyticsContext() {
    return (0, $dAx5m.useContext)((0, $h0bf1.default));
};

});

parcelRegister("CVDHe", function(module, exports) {

$parcel$export(module.exports, "useTrackedRef", function () { return $075042ae8e0c08d9$export$1d27a74659855e44; });

var $dAx5m = parcelRequire("dAx5m");
var $075042ae8e0c08d9$export$1d27a74659855e44 = function useTrackedRef(value) {
    var ref = (0, $dAx5m.useRef)(value);
    ref.current = value;
    return ref;
};

});




parcelRegister("jaHCf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $df50c8b79abe2c51$export$2e2bcd8739ae039; });

var $8TMbA = parcelRequire("8TMbA");

var $dAx5m = parcelRequire("dAx5m");

var $nLm1R = parcelRequire("nLm1R");

var $3vWfj = parcelRequire("3vWfj");
var $df50c8b79abe2c51$var$withAnalyticsEvents = function withAnalyticsEvents() {
    var createEventMap = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return function(WrappedComponent) {
        var WithAnalyticsEvents = /*#__PURE__*/ (0, $dAx5m.forwardRef)(function(props, ref) {
            var _usePatchedProps = (0, $3vWfj.usePatchedProps)(createEventMap, props), patchedEventProps = _usePatchedProps.patchedEventProps;
            var _useAnalyticsEvents = (0, $nLm1R.useAnalyticsEvents)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement(WrappedComponent, (0, (/*@__PURE__*/$parcel$interopDefault($8TMbA)))({}, props, patchedEventProps, {
                createAnalyticsEvent: createAnalyticsEvent,
                ref: ref
            }));
        });
        WithAnalyticsEvents.displayName = "WithAnalyticsEvents(".concat(WrappedComponent.displayName || WrappedComponent.name, ")");
        return WithAnalyticsEvents;
    };
};
var $df50c8b79abe2c51$export$2e2bcd8739ae039 = $df50c8b79abe2c51$var$withAnalyticsEvents;

});
parcelRegister("nLm1R", function(module, exports) {

$parcel$export(module.exports, "useAnalyticsEvents", function () { return $0476e1ad15a077fb$export$5bf35293e545f20c; });

var $tWuif = parcelRequire("tWuif");

var $kbtUI = parcelRequire("kbtUI");

var $aKvho = parcelRequire("aKvho");
function $0476e1ad15a077fb$export$5bf35293e545f20c() {
    var analyticsContext = (0, $aKvho.useAnalyticsContext)();
    var createAnalyticsEvent = (0, $tWuif.useCallbackOne)(function(payload) {
        return new (0, $kbtUI.default)({
            context: analyticsContext.getAtlaskitAnalyticsContext(),
            handlers: analyticsContext.getAtlaskitAnalyticsEventHandlers(),
            payload: payload
        });
    }, [
        analyticsContext
    ]);
    return {
        createAnalyticsEvent: createAnalyticsEvent
    };
}

});
parcelRegister("kbtUI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $eb1c09f50f252662$export$2e2bcd8739ae039; });

var $k2EOa = parcelRequire("k2EOa");

var $5MUML = parcelRequire("5MUML");

var $dXLvS = parcelRequire("dXLvS");

var $4irYd = parcelRequire("4irYd");

var $gcao5 = parcelRequire("gcao5");

var $lKQfu = parcelRequire("lKQfu");

var $fKxww = parcelRequire("fKxww");

var $ilqjt = parcelRequire("ilqjt");

var $iDtim = parcelRequire("iDtim");

var $dQGiX = parcelRequire("dQGiX");
function $eb1c09f50f252662$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $eb1c09f50f252662$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, (/*@__PURE__*/$parcel$interopDefault($ilqjt)))(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, (/*@__PURE__*/$parcel$interopDefault($ilqjt)))(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, (/*@__PURE__*/$parcel$interopDefault($fKxww)))(this, result);
    };
}
function $eb1c09f50f252662$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($eb1c09f50f252662$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $eb1c09f50f252662$export$35f8383928ba8d7 = function isUIAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $eb1c09f50f252662$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isUIAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === "UIAnalyticsEvent";
};
var $eb1c09f50f252662$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_AnalyticsEvent) {
    (0, (/*@__PURE__*/$parcel$interopDefault($lKQfu)))(UIAnalyticsEvent, _AnalyticsEvent);
    var _super = $eb1c09f50f252662$var$_createSuper(UIAnalyticsEvent);
    function UIAnalyticsEvent(props) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($5MUML)))(this, UIAnalyticsEvent);
        _this = _super.call(this, props);
        (0, (/*@__PURE__*/$parcel$interopDefault($iDtim)))((0, (/*@__PURE__*/$parcel$interopDefault($4irYd)))(_this), "_isUIAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($iDtim)))((0, (/*@__PURE__*/$parcel$interopDefault($4irYd)))(_this), "clone", function() {
            if (_this.hasFired) return null;
            var context = (0, (/*@__PURE__*/$parcel$interopDefault($k2EOa)))(_this.context);
            var handlers = (0, (/*@__PURE__*/$parcel$interopDefault($k2EOa)))(_this.handlers);
            /**
       * A hacky "deep clone" of the object. This is limited in that it wont
       * support functions, regexs, Maps, Sets, etc, but none of those need to
       * be represented in our payload.
       */ var payload = JSON.parse(JSON.stringify(_this.payload));
            return new UIAnalyticsEvent({
                context: context,
                handlers: handlers,
                payload: payload
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($iDtim)))((0, (/*@__PURE__*/$parcel$interopDefault($4irYd)))(_this), "fire", function(channel) {
            if (_this.hasFired) return;
            _this.handlers.forEach(function(handler) {
                return handler((0, (/*@__PURE__*/$parcel$interopDefault($4irYd)))(_this), channel);
            });
            _this.hasFired = true;
        });
        _this.context = props.context || [];
        _this.handlers = props.handlers || [];
        _this.hasFired = false;
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($dXLvS)))(UIAnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (this.hasFired) return this;
                return (0, (/*@__PURE__*/$parcel$interopDefault($gcao5)))((0, (/*@__PURE__*/$parcel$interopDefault($ilqjt)))(UIAnalyticsEvent.prototype), "update", this).call(this, updater);
            }
        }
    ]);
    return UIAnalyticsEvent;
}((0, $dQGiX.default));

});
parcelRegister("gcao5", function(module, exports) {

var $171Le = parcelRequire("171Le");
function $bca5d30cc507fdeb$var$_get() {
    return module.exports = $bca5d30cc507fdeb$var$_get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function(e, t, r) {
        var p = $171Le(e, t);
        if (p) {
            var n = Object.getOwnPropertyDescriptor(p, t);
            return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value;
        }
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $bca5d30cc507fdeb$var$_get.apply(null, arguments);
}
module.exports = $bca5d30cc507fdeb$var$_get, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("171Le", function(module, exports) {

var $ilqjt = parcelRequire("ilqjt");
function $0cf7cf927510eb1e$var$_superPropBase(t, o) {
    for(; !({}).hasOwnProperty.call(t, o) && null !== (t = $ilqjt(t)););
    return t;
}
module.exports = $0cf7cf927510eb1e$var$_superPropBase, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("dQGiX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a150f28e5957d6b2$export$2e2bcd8739ae039; });

var $jRSpJ = parcelRequire("jRSpJ");

var $5MUML = parcelRequire("5MUML");

var $dXLvS = parcelRequire("dXLvS");

var $iDtim = parcelRequire("iDtim");
function $a150f28e5957d6b2$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $a150f28e5957d6b2$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $a150f28e5957d6b2$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($iDtim)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $a150f28e5957d6b2$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $a150f28e5957d6b2$export$ad4be5c2ec28cecf = function isAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $a150f28e5957d6b2$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === "AnalyticsEvent";
};
var $a150f28e5957d6b2$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function AnalyticsEvent(props) {
        var _this = this;
        (0, (/*@__PURE__*/$parcel$interopDefault($5MUML)))(this, AnalyticsEvent);
        (0, (/*@__PURE__*/$parcel$interopDefault($iDtim)))(this, "_isAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($iDtim)))(this, "clone", function() {
            // just a shallow clone, don't change sub refs unless you want to
            // affect the original's too
            var payload = $a150f28e5957d6b2$var$_objectSpread({}, _this.payload);
            return new AnalyticsEvent({
                payload: payload
            });
        });
        this.payload = props.payload;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($dXLvS)))(AnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (typeof updater === "function") this.payload = updater(this.payload);
                if ((0, (/*@__PURE__*/$parcel$interopDefault($jRSpJ)))(updater) === "object") this.payload = $a150f28e5957d6b2$var$_objectSpread($a150f28e5957d6b2$var$_objectSpread({}, this.payload), updater);
                return this;
            }
        }
    ]);
    return AnalyticsEvent;
}();

});



parcelRegister("3vWfj", function(module, exports) {

$parcel$export(module.exports, "usePatchedProps", function () { return $28f172c893dac87a$export$9ebb5a84d17e5d18; });

var $iDtim = parcelRequire("iDtim");

var $jRSpJ = parcelRequire("jRSpJ");

var $dAx5m = parcelRequire("dAx5m");

var $nLm1R = parcelRequire("nLm1R");
function $28f172c893dac87a$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $28f172c893dac87a$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $28f172c893dac87a$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($iDtim)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $28f172c893dac87a$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $28f172c893dac87a$export$9ebb5a84d17e5d18() {
    var createEventMap = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var wrappedComponentProps = arguments.length > 1 ? arguments[1] : undefined;
    var _useAnalyticsEvents = (0, $nLm1R.useAnalyticsEvents)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    var handlerCache = (0, $dAx5m.useRef)({});
    var patchedProps = (0, $dAx5m.useMemo)(function() {
        var cache = handlerCache.current;
        // Clean up no longer used handlers in cache
        Object.keys(cache).filter(function(key) {
            return !(key in createEventMap);
        }).forEach(function(key) {
            return delete cache[key];
        });
        return Object.keys(createEventMap).reduce(function(p, k) {
            var eventCreator = createEventMap[k];
            if (![
                "object",
                "function"
            ].includes((0, (/*@__PURE__*/$parcel$interopDefault($jRSpJ)))(eventCreator))) return p;
            var propValue = wrappedComponentProps[k];
            if (k in cache && cache[k].eventCreator === eventCreator && cache[k].propValue === propValue) return $28f172c893dac87a$var$_objectSpread($28f172c893dac87a$var$_objectSpread({}, p), {}, (0, (/*@__PURE__*/$parcel$interopDefault($iDtim)))({}, k, cache[k].wrappedCallback));
            var wrappedCallback = function wrappedCallback() {
                var analyticsEvent = typeof eventCreator === "function" ? eventCreator(createAnalyticsEvent, wrappedComponentProps) : createAnalyticsEvent(eventCreator);
                if (propValue && typeof propValue === "function") {
                    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                    propValue.apply(void 0, args.concat([
                        analyticsEvent
                    ]));
                }
            };
            cache[k] = {
                eventCreator: eventCreator,
                wrappedCallback: wrappedCallback,
                propValue: propValue
            };
            return $28f172c893dac87a$var$_objectSpread($28f172c893dac87a$var$_objectSpread({}, p), {}, (0, (/*@__PURE__*/$parcel$interopDefault($iDtim)))({}, k, wrappedCallback));
        }, {});
    }, [
        createEventMap,
        wrappedComponentProps,
        createAnalyticsEvent,
        handlerCache
    ]);
    return {
        patchedEventProps: patchedProps
    };
}

});


parcelRegister("1XHoZ", function(module, exports) {

$parcel$export(module.exports, "transitionDurationMs", function () { return $16dcf7e456b57cce$export$614e920ab938d7a6; });
$parcel$export(module.exports, "animationTimingFunction", function () { return $16dcf7e456b57cce$export$aa1acbd7fbaf45a2; });
$parcel$export(module.exports, "defaultFocusLockSettings", function () { return $16dcf7e456b57cce$export$95a69bf7d3b83292; });

var $kjzyh = parcelRequire("kjzyh");
var $16dcf7e456b57cce$export$3105270315df0e7 = "0.22s";
var $16dcf7e456b57cce$export$614e920ab938d7a6 = 220;
var $16dcf7e456b57cce$export$5cc90842f5a0bf76 = (0, $kjzyh.easeOut);
var $16dcf7e456b57cce$export$790206ddaae8bb6a = [
    "narrow",
    "medium",
    "wide",
    "extended",
    "full"
];
var $16dcf7e456b57cce$export$aa1acbd7fbaf45a2 = function animationTimingFunction() {
    return 0, $kjzyh.easeOut;
};
var $16dcf7e456b57cce$export$95a69bf7d3b83292 = {
    isFocusLockEnabled: true,
    shouldReturnFocus: true,
    autoFocusFirstElem: true
};

});
parcelRegister("kjzyh", function(module, exports) {

$parcel$export(module.exports, "easeInOut", function () { return $eca128e2176031f4$export$c07234257a03d5e9; });
$parcel$export(module.exports, "easeOut", function () { return $eca128e2176031f4$export$57636bb43b1ccbb0; });
$parcel$export(module.exports, "easeIn", function () { return $eca128e2176031f4$export$929e5a82286172a6; });
var $eca128e2176031f4$export$c07234257a03d5e9 = "cubic-bezier(0.15,1,0.3,1)";
var $eca128e2176031f4$export$57636bb43b1ccbb0 = "cubic-bezier(0.2,0,0,1)";
var $eca128e2176031f4$export$929e5a82286172a6 = "cubic-bezier(0.8,0,0,0.8)";

});


parcelRegister("1EvNv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1342312c263b1345$export$2e2bcd8739ae039; });
/** @jsx jsx */ parcelRequire("dAx5m");

var $jVTBW = parcelRequire("jVTBW");

var $5pFiO = parcelRequire("5pFiO");

var $erihP = parcelRequire("erihP");
var $5QWE6 = parcelRequire("5QWE6");

var $1XHoZ = parcelRequire("1XHoZ");
var $1342312c263b1345$var$blanketStyles = (0, $jVTBW.css)({
    position: "relative"
});
/**
 * A wrapper around `@atlaskit/blanket` that adds a fade in/out transition.
 */ var $1342312c263b1345$var$Blanket = function Blanket(_ref) {
    var isOpen = _ref.isOpen, onBlanketClicked = _ref.onBlanketClicked, testId = _ref.testId;
    return (0, $jVTBW.jsx)((0, $erihP.default), {
        appear: true
    }, isOpen && (0, $jVTBW.jsx)((0, $5QWE6.default), {
        duration: (0, $1XHoZ.transitionDurationMs) * 2,
        animationTimingFunction: (0, $1XHoZ.animationTimingFunction)
    }, function(_ref2) {
        var className = _ref2.className;
        return (0, $jVTBW.jsx)("div", {
            css: $1342312c263b1345$var$blanketStyles,
            className: className
        }, (0, $jVTBW.jsx)((0, $5pFiO.default), {
            isTinted: true,
            onBlanketClicked: onBlanketClicked,
            testId: testId && testId
        }));
    }));
};
var $1342312c263b1345$export$2e2bcd8739ae039 = $1342312c263b1345$var$Blanket;

});
parcelRegister("5pFiO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3f0f535c1f931989$export$2e2bcd8739ae039; });

var $j3Net = parcelRequire("j3Net");

var $dAx5m = parcelRequire("dAx5m");

var $jVTBW = parcelRequire("jVTBW");

var $z7Tov = parcelRequire("z7Tov");

var $Bb0he = parcelRequire("Bb0he");

var $gn485 = parcelRequire("gn485");

var $gecEH = parcelRequire("gecEH");
function $3f0f535c1f931989$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $3f0f535c1f931989$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $3f0f535c1f931989$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($j3Net)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $3f0f535c1f931989$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $3f0f535c1f931989$var$packageName = "@atlaskit/blanket";
var $3f0f535c1f931989$var$packageVersion = "13.3.1";
var $3f0f535c1f931989$var$analyticsAttributes = {
    componentName: "blanket",
    packageName: $3f0f535c1f931989$var$packageName,
    packageVersion: $3f0f535c1f931989$var$packageVersion
};
var $3f0f535c1f931989$var$baseStyles = (0, $jVTBW.css)({
    position: "fixed",
    zIndex: (0, $gecEH.layers).blanket(),
    inset: 0,
    backgroundColor: "var(--ds-blanket, ".concat((0, $gn485.N100A), ")"),
    overflowY: "auto",
    pointerEvents: "initial"
});
var $3f0f535c1f931989$var$shouldAllowClickThroughStyles = (0, $jVTBW.css)({
    pointerEvents: "none"
});
var $3f0f535c1f931989$var$invisibleStyles = (0, $jVTBW.css)({
    backgroundColor: "transparent"
});
/**
 * __Blanket__
 *
 * A Blanket provides the overlay layer for components such as a modal dialog or a tooltip
 *
 * - [Examples](https://atlaskit.atlassian.com/examples/design-system/blanket/basic-usage)
 */ var $3f0f535c1f931989$var$Blanket = /*#__PURE__*/ (0, $dAx5m.memo)(/*#__PURE__*/ (0, $dAx5m.forwardRef)(function Blanket(_ref, ref) {
    var _ref$shouldAllowClick = _ref.shouldAllowClickThrough, shouldAllowClickThrough = _ref$shouldAllowClick === void 0 ? false : _ref$shouldAllowClick, _ref$isTinted = _ref.isTinted, isTinted = _ref$isTinted === void 0 ? false : _ref$isTinted, _ref$onBlanketClicked = _ref.onBlanketClicked, onBlanketClicked = _ref$onBlanketClicked === void 0 ? (0, $Bb0he.default) : _ref$onBlanketClicked, testId = _ref.testId, children = _ref.children, analyticsContext = _ref.analyticsContext;
    var mouseDownTarget = (0, $dAx5m.useRef)(null);
    var onBlanketClickedWithAnalytics = (0, $z7Tov.usePlatformLeafEventHandler)($3f0f535c1f931989$var$_objectSpread({
        fn: onBlanketClicked,
        action: "clicked",
        analyticsData: analyticsContext
    }, $3f0f535c1f931989$var$analyticsAttributes));
    var blanketClickOutsideChildren = (0, $dAx5m.useCallback)(function(e) {
        return e.currentTarget === e.target && mouseDownTarget.current === e.target ? onBlanketClickedWithAnalytics(e) : undefined;
    }, [
        onBlanketClickedWithAnalytics
    ]);
    var onClick = shouldAllowClickThrough ? undefined : blanketClickOutsideChildren;
    var onMouseDown = (0, $dAx5m.useCallback)(function(e) {
        mouseDownTarget.current = e.target;
    }, []);
    return(/**
     * It is not normally acceptable to add click and key handlers to non-interactive
     * elements as this is an accessibility anti-pattern. However, because this
     * instance is to enable light dismiss functionality instead of creating an
     * inaccessible custom element, we can add role="presentation" so that there
     * are no negative impacts to assistive technologies.
     */ (0, $jVTBW.jsx)("div", {
        role: "presentation",
        css: [
            $3f0f535c1f931989$var$baseStyles,
            shouldAllowClickThrough && $3f0f535c1f931989$var$shouldAllowClickThroughStyles,
            !isTinted && $3f0f535c1f931989$var$invisibleStyles
        ],
        onClick: onClick,
        onMouseDown: onMouseDown,
        "data-testid": testId,
        ref: ref
    }, children));
}));
$3f0f535c1f931989$var$Blanket.displayName = "Blanket";
var $3f0f535c1f931989$export$2e2bcd8739ae039 = $3f0f535c1f931989$var$Blanket;

});
parcelRegister("j3Net", function(module, exports) {

var $eZPaT = parcelRequire("eZPaT");
function $de047cad86cae11f$var$_defineProperty(e, r, t) {
    return (r = $eZPaT(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
module.exports = $de047cad86cae11f$var$_defineProperty, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("eZPaT", function(module, exports) {

var $48mQQ = parcelRequire("48mQQ");
var $aeae75705132553d$var$_typeof = $48mQQ.default;

var $gyFkG = parcelRequire("gyFkG");
function $aeae75705132553d$var$toPropertyKey(t) {
    var i = $gyFkG(t, "string");
    return "symbol" == $aeae75705132553d$var$_typeof(i) ? i : i + "";
}
module.exports = $aeae75705132553d$var$toPropertyKey, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("48mQQ", function(module, exports) {
function $3029a29555b92003$var$_typeof(o) {
    "@babel/helpers - typeof";
    return module.exports = $3029a29555b92003$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $3029a29555b92003$var$_typeof(o);
}
module.exports = $3029a29555b92003$var$_typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("gyFkG", function(module, exports) {

var $48mQQ = parcelRequire("48mQQ");
var $c0dfe21f7b088259$var$_typeof = $48mQQ.default;
function $c0dfe21f7b088259$var$toPrimitive(t, r) {
    if ("object" != $c0dfe21f7b088259$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $c0dfe21f7b088259$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
module.exports = $c0dfe21f7b088259$var$toPrimitive, module.exports.__esModule = true, module.exports["default"] = module.exports;

});



parcelRegister("z7Tov", function(module, exports) {

$parcel$export(module.exports, "usePlatformLeafEventHandler", function () { return $06996446d58e906a$export$a4687b0234b40e28; });

var $j3Net = parcelRequire("j3Net");

var $dAx5m = parcelRequire("dAx5m");

var $6F9Kx = parcelRequire("6F9Kx");

var $dmANI = parcelRequire("dmANI");
function $06996446d58e906a$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $06996446d58e906a$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $06996446d58e906a$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($j3Net)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $06996446d58e906a$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $06996446d58e906a$export$a4687b0234b40e28(_ref) {
    var fn = _ref.fn, action = _ref.action, componentName = _ref.componentName, actionSubject = _ref.actionSubject, packageName = _ref.packageName, packageVersion = _ref.packageVersion, analyticsData = _ref.analyticsData;
    var _useAnalyticsEvents = (0, $6F9Kx.useAnalyticsEvents)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    // We put analyticsData and fn in a ref so that we don't need to break
    // memoization.
    // Generally these could be defined by consumers inline
    // and so we do this to avoid breaking memoization of useCallback
    var dataRef = (0, $dmANI.useTrackedRef)(analyticsData);
    var fnRef = (0, $dmANI.useTrackedRef)(fn);
    var handler = (0, $dAx5m.useCallback)(function(value) {
        var analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: actionSubject || componentName,
            attributes: {
                componentName: componentName,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
        // To avoid wrapping this component in AnalyticsContext we manually
        // push the parent context's meta data into the context.
        // Note: this new 'context'
        var context = $06996446d58e906a$var$_objectSpread({
            componentName: componentName,
            packageName: packageName,
            packageVersion: packageVersion
        }, dataRef.current);
        analyticsEvent.context.push(context);
        // fire an event on the atlaskit channel
        var clone = analyticsEvent.clone();
        if (clone) clone.fire("atlaskit");
        fnRef.current(value, analyticsEvent);
    }, [
        // These are strings and won't change
        action,
        componentName,
        actionSubject,
        packageName,
        packageVersion,
        // This function is memoized in the context
        createAnalyticsEvent,
        // these are a stable ref because of the useTrackedRef hook
        dataRef,
        fnRef
    ]);
    return handler;
}

});
parcelRegister("6F9Kx", function(module, exports) {

$parcel$export(module.exports, "useAnalyticsEvents", function () { return $4d9e227ce9083671$export$5bf35293e545f20c; });

var $tWuif = parcelRequire("tWuif");

var $7Qhq4 = parcelRequire("7Qhq4");

var $kAvZj = parcelRequire("kAvZj");
function $4d9e227ce9083671$export$5bf35293e545f20c() {
    var analyticsContext = (0, $kAvZj.useAnalyticsContext)();
    var createAnalyticsEvent = (0, $tWuif.useCallbackOne)(function(payload) {
        return new (0, $7Qhq4.default)({
            context: analyticsContext.getAtlaskitAnalyticsContext(),
            handlers: analyticsContext.getAtlaskitAnalyticsEventHandlers(),
            payload: payload
        });
    }, [
        analyticsContext
    ]);
    return {
        createAnalyticsEvent: createAnalyticsEvent
    };
}

});
parcelRegister("7Qhq4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5b5ae6e316c55190$export$2e2bcd8739ae039; });

var $kTAt0 = parcelRequire("kTAt0");

var $kL4w3 = parcelRequire("kL4w3");

var $3XHha = parcelRequire("3XHha");

var $iGB31 = parcelRequire("iGB31");

var $fLP73 = parcelRequire("fLP73");

var $8Qhxx = parcelRequire("8Qhxx");

var $108bJ = parcelRequire("108bJ");

var $h54a4 = parcelRequire("h54a4");

var $j3Net = parcelRequire("j3Net");

var $5gdBB = parcelRequire("5gdBB");
function $5b5ae6e316c55190$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $5b5ae6e316c55190$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, (/*@__PURE__*/$parcel$interopDefault($h54a4)))(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, (/*@__PURE__*/$parcel$interopDefault($h54a4)))(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, (/*@__PURE__*/$parcel$interopDefault($108bJ)))(this, result);
    };
}
function $5b5ae6e316c55190$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($5b5ae6e316c55190$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $5b5ae6e316c55190$export$35f8383928ba8d7 = function isUIAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $5b5ae6e316c55190$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isUIAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === "UIAnalyticsEvent";
};
var $5b5ae6e316c55190$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_AnalyticsEvent) {
    (0, (/*@__PURE__*/$parcel$interopDefault($8Qhxx)))(UIAnalyticsEvent, _AnalyticsEvent);
    var _super = $5b5ae6e316c55190$var$_createSuper(UIAnalyticsEvent);
    function UIAnalyticsEvent(props) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($kL4w3)))(this, UIAnalyticsEvent);
        _this = _super.call(this, props);
        (0, (/*@__PURE__*/$parcel$interopDefault($j3Net)))((0, (/*@__PURE__*/$parcel$interopDefault($iGB31)))(_this), "_isUIAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($j3Net)))((0, (/*@__PURE__*/$parcel$interopDefault($iGB31)))(_this), "clone", function() {
            if (_this.hasFired) return null;
            var context = (0, (/*@__PURE__*/$parcel$interopDefault($kTAt0)))(_this.context);
            var handlers = (0, (/*@__PURE__*/$parcel$interopDefault($kTAt0)))(_this.handlers);
            /**
       * A hacky "deep clone" of the object. This is limited in that it wont
       * support functions, regexs, Maps, Sets, etc, but none of those need to
       * be represented in our payload.
       */ var payload = JSON.parse(JSON.stringify(_this.payload));
            return new UIAnalyticsEvent({
                context: context,
                handlers: handlers,
                payload: payload
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($j3Net)))((0, (/*@__PURE__*/$parcel$interopDefault($iGB31)))(_this), "fire", function(channel) {
            if (_this.hasFired) return;
            _this.handlers.forEach(function(handler) {
                return handler((0, (/*@__PURE__*/$parcel$interopDefault($iGB31)))(_this), channel);
            });
            _this.hasFired = true;
        });
        _this.context = props.context || [];
        _this.handlers = props.handlers || [];
        _this.hasFired = false;
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($3XHha)))(UIAnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (this.hasFired) return this;
                return (0, (/*@__PURE__*/$parcel$interopDefault($fLP73)))((0, (/*@__PURE__*/$parcel$interopDefault($h54a4)))(UIAnalyticsEvent.prototype), "update", this).call(this, updater);
            }
        }
    ]);
    return UIAnalyticsEvent;
}((0, $5gdBB.default));

});
parcelRegister("kTAt0", function(module, exports) {

var $1N6OE = parcelRequire("1N6OE");

var $iYpof = parcelRequire("iYpof");

var $1OVpe = parcelRequire("1OVpe");

var $dIE7Q = parcelRequire("dIE7Q");
function $f3653b3cc0ae438b$var$_toConsumableArray(r) {
    return $1N6OE(r) || $iYpof(r) || $1OVpe(r) || $dIE7Q();
}
module.exports = $f3653b3cc0ae438b$var$_toConsumableArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("1N6OE", function(module, exports) {

var $lCWNi = parcelRequire("lCWNi");
function $14dfa790444bd046$var$_arrayWithoutHoles(r) {
    if (Array.isArray(r)) return $lCWNi(r);
}
module.exports = $14dfa790444bd046$var$_arrayWithoutHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("lCWNi", function(module, exports) {
function $fbeac0e18fd27141$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
module.exports = $fbeac0e18fd27141$var$_arrayLikeToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("iYpof", function(module, exports) {
function $dd01868695cde049$var$_iterableToArray(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
module.exports = $dd01868695cde049$var$_iterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("1OVpe", function(module, exports) {

var $lCWNi = parcelRequire("lCWNi");
function $1536fd95412a44da$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $lCWNi(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $lCWNi(r, a) : void 0;
    }
}
module.exports = $1536fd95412a44da$var$_unsupportedIterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("dIE7Q", function(module, exports) {
function $9fce827e559b8dbe$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
module.exports = $9fce827e559b8dbe$var$_nonIterableSpread, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("kL4w3", function(module, exports) {
function $f1cbb3395882de9f$var$_classCallCheck(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
module.exports = $f1cbb3395882de9f$var$_classCallCheck, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("3XHha", function(module, exports) {

var $eZPaT = parcelRequire("eZPaT");
function $2e287375cb9b0326$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, $eZPaT(o.key), o);
    }
}
function $2e287375cb9b0326$var$_createClass(e, r, t) {
    return r && $2e287375cb9b0326$var$_defineProperties(e.prototype, r), t && $2e287375cb9b0326$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}
module.exports = $2e287375cb9b0326$var$_createClass, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("iGB31", function(module, exports) {
function $d9a8e32a044127e5$var$_assertThisInitialized(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}
module.exports = $d9a8e32a044127e5$var$_assertThisInitialized, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("fLP73", function(module, exports) {

var $2ry7u = parcelRequire("2ry7u");
function $b7b2e4b66de1a496$var$_get() {
    return module.exports = $b7b2e4b66de1a496$var$_get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function(e, t, r) {
        var p = $2ry7u(e, t);
        if (p) {
            var n = Object.getOwnPropertyDescriptor(p, t);
            return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value;
        }
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $b7b2e4b66de1a496$var$_get.apply(null, arguments);
}
module.exports = $b7b2e4b66de1a496$var$_get, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("2ry7u", function(module, exports) {

var $h54a4 = parcelRequire("h54a4");
function $1c7891d86a752d62$var$_superPropBase(t, o) {
    for(; !({}).hasOwnProperty.call(t, o) && null !== (t = $h54a4(t)););
    return t;
}
module.exports = $1c7891d86a752d62$var$_superPropBase, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("h54a4", function(module, exports) {
function $c6f621b01dc28409$var$_getPrototypeOf(t) {
    return module.exports = $c6f621b01dc28409$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $c6f621b01dc28409$var$_getPrototypeOf(t);
}
module.exports = $c6f621b01dc28409$var$_getPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

});



parcelRegister("8Qhxx", function(module, exports) {

var $33LQ6 = parcelRequire("33LQ6");
function $6700c91c98dd8125$var$_inherits(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && $33LQ6(t, e);
}
module.exports = $6700c91c98dd8125$var$_inherits, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("33LQ6", function(module, exports) {
function $23a6c2d653661b24$var$_setPrototypeOf(t, e) {
    return module.exports = $23a6c2d653661b24$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $23a6c2d653661b24$var$_setPrototypeOf(t, e);
}
module.exports = $23a6c2d653661b24$var$_setPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("108bJ", function(module, exports) {

var $48mQQ = parcelRequire("48mQQ");
var $0bac248f592c3a2d$var$_typeof = $48mQQ.default;

var $iGB31 = parcelRequire("iGB31");
function $0bac248f592c3a2d$var$_possibleConstructorReturn(t, e) {
    if (e && ("object" == $0bac248f592c3a2d$var$_typeof(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return $iGB31(t);
}
module.exports = $0bac248f592c3a2d$var$_possibleConstructorReturn, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("5gdBB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3d490024ece92369$export$2e2bcd8739ae039; });

var $48mQQ = parcelRequire("48mQQ");

var $kL4w3 = parcelRequire("kL4w3");

var $3XHha = parcelRequire("3XHha");

var $j3Net = parcelRequire("j3Net");
function $3d490024ece92369$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $3d490024ece92369$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $3d490024ece92369$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($j3Net)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $3d490024ece92369$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $3d490024ece92369$export$ad4be5c2ec28cecf = function isAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $3d490024ece92369$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === "AnalyticsEvent";
};
var $3d490024ece92369$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function AnalyticsEvent(props) {
        var _this = this;
        (0, (/*@__PURE__*/$parcel$interopDefault($kL4w3)))(this, AnalyticsEvent);
        (0, (/*@__PURE__*/$parcel$interopDefault($j3Net)))(this, "_isAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($j3Net)))(this, "clone", function() {
            // just a shallow clone, don't change sub refs unless you want to
            // affect the original's too
            var payload = $3d490024ece92369$var$_objectSpread({}, _this.payload);
            return new AnalyticsEvent({
                payload: payload
            });
        });
        this.payload = props.payload;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($3XHha)))(AnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (typeof updater === "function") this.payload = updater(this.payload);
                if ((0, (/*@__PURE__*/$parcel$interopDefault($48mQQ)))(updater) === "object") this.payload = $3d490024ece92369$var$_objectSpread($3d490024ece92369$var$_objectSpread({}, this.payload), updater);
                return this;
            }
        }
    ]);
    return AnalyticsEvent;
}();

});


parcelRegister("kAvZj", function(module, exports) {

$parcel$export(module.exports, "useAnalyticsContext", function () { return $efcffb9423a0a905$export$d1f587f82ad51c4; });

var $dAx5m = parcelRequire("dAx5m");

var $h0bf1 = parcelRequire("h0bf1");
var $efcffb9423a0a905$export$d1f587f82ad51c4 = function useAnalyticsContext() {
    return (0, $dAx5m.useContext)((0, $h0bf1.default));
};

});


parcelRegister("dmANI", function(module, exports) {

$parcel$export(module.exports, "useTrackedRef", function () { return $9ba9e0510e376362$export$1d27a74659855e44; });

var $dAx5m = parcelRequire("dAx5m");
var $9ba9e0510e376362$export$1d27a74659855e44 = function useTrackedRef(value) {
    var ref = (0, $dAx5m.useRef)(value);
    ref.current = value;
    return ref;
};

});


parcelRegister("gn485", function(module, exports) {

$parcel$export(module.exports, "B200", function () { return $beb1ff5cb068cc62$export$215b7063051591f1; });
$parcel$export(module.exports, "N20A", function () { return $beb1ff5cb068cc62$export$8d43898f60b96a82; });
$parcel$export(module.exports, "N30A", function () { return $beb1ff5cb068cc62$export$920c0d5c49070351; });
$parcel$export(module.exports, "N100A", function () { return $beb1ff5cb068cc62$export$486ab785e4bac3c6; });
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // Reds
var $beb1ff5cb068cc62$export$4b84fd0e2c617bd = "#FFEBE6";
var $beb1ff5cb068cc62$export$b34b069eff244586 = "#FFBDAD";
var $beb1ff5cb068cc62$export$be802dd0d8b57f35 = "#FF8F73";
var $beb1ff5cb068cc62$export$60847d42f9da92a6 = "#FF7452";
var $beb1ff5cb068cc62$export$4a7404f376229999 = "#FF5630";
var $beb1ff5cb068cc62$export$2010d0fb4295b346 = "#DE350B";
var $beb1ff5cb068cc62$export$2837b5a1a71d5c02 = "#BF2600";
var $beb1ff5cb068cc62$export$8d9596b529bbb9cf = "#FFFAE6";
var $beb1ff5cb068cc62$export$41060a744ab0b7ae = "#FFF0B3";
var $beb1ff5cb068cc62$export$1cc05bbbf340e559 = "#FFE380";
var $beb1ff5cb068cc62$export$5aae31392d72caaa = "#FFC400";
var $beb1ff5cb068cc62$export$c6930421db9fa514 = "#FFAB00";
var $beb1ff5cb068cc62$export$59619663aa6500fb = "#FF991F";
var $beb1ff5cb068cc62$export$874739ea9e379ab6 = "#FF8B00";
var $beb1ff5cb068cc62$export$8a6341c32b6a3ee6 = "#E3FCEF";
var $beb1ff5cb068cc62$export$69a3bf21b9686c2b = "#ABF5D1";
var $beb1ff5cb068cc62$export$afbce1382ec95f73 = "#79F2C0";
var $beb1ff5cb068cc62$export$747d86715d4175de = "#57D9A3";
var $beb1ff5cb068cc62$export$940e1f69e873f202 = "#36B37E";
var $beb1ff5cb068cc62$export$a49394138f7b8e85 = "#00875A";
var $beb1ff5cb068cc62$export$6fa04827ac68a4fb = "#006644";
var $beb1ff5cb068cc62$export$226de0355ed012f8 = "#DEEBFF";
var $beb1ff5cb068cc62$export$8c13c2ee36917869 = "#B3D4FF";
var $beb1ff5cb068cc62$export$ecfc1dff386a3e7a = "#4C9AFF";
var $beb1ff5cb068cc62$export$215b7063051591f1 = "#2684FF";
var $beb1ff5cb068cc62$export$e62e8919cca44969 = "#0065FF";
var $beb1ff5cb068cc62$export$b3de0ae08da2ce64 = "#0052CC";
var $beb1ff5cb068cc62$export$a6ee3d71bc067634 = "#0747A6";
var $beb1ff5cb068cc62$export$363e4475840015bb = "#EAE6FF";
var $beb1ff5cb068cc62$export$4b0a4417ed59760f = "#C0B6F2";
var $beb1ff5cb068cc62$export$6011520a64d9a187 = "#998DD9";
var $beb1ff5cb068cc62$export$a7175d4e9206bc80 = "#8777D9";
var $beb1ff5cb068cc62$export$b48405b95304b5a1 = "#6554C0";
var $beb1ff5cb068cc62$export$c71e4279dd54a18d = "#5243AA";
var $beb1ff5cb068cc62$export$147899de772240ec = "#403294";
var $beb1ff5cb068cc62$export$2cf711fe14c66f06 = "#E6FCFF";
var $beb1ff5cb068cc62$export$7a8f4d33f6f9772c = "#B3F5FF";
var $beb1ff5cb068cc62$export$776c9c497ef08533 = "#79E2F2";
var $beb1ff5cb068cc62$export$69cb3ca10c1e330e = "#00C7E6";
var $beb1ff5cb068cc62$export$9dc1ef0f3f48059b = "#00B8D9";
var $beb1ff5cb068cc62$export$7c835c78b6fcdef8 = "#00A3BF";
var $beb1ff5cb068cc62$export$6036577f95c3877e = "#008DA6";
var $beb1ff5cb068cc62$export$29a4f05edc054374 = "#FFFFFF";
var $beb1ff5cb068cc62$export$e655ef011c4aa1a2 = "#FAFBFC";
var $beb1ff5cb068cc62$export$9fdfb749e33cdf97 = "#F4F5F7";
var $beb1ff5cb068cc62$export$3e51e8f1440314ba = "#EBECF0";
var $beb1ff5cb068cc62$export$1ce2d1575d444ceb = "#DFE1E6";
var $beb1ff5cb068cc62$export$8754fc7e6d8b3000 = "#C1C7D0";
var $beb1ff5cb068cc62$export$c2e91cbeada39b8b = "#B3BAC5";
var $beb1ff5cb068cc62$export$5f71e19f3a7ad9de = "#A5ADBA";
var $beb1ff5cb068cc62$export$eaa8c8a70ac22806 = "#97A0AF";
var $beb1ff5cb068cc62$export$7c87d337fb91a97d = "#8993A4";
var $beb1ff5cb068cc62$export$d6447c357493214f = "#7A869A";
var $beb1ff5cb068cc62$export$f563ee71e9ee74cd = "#6B778C";
var $beb1ff5cb068cc62$export$e2ef2124cf4024b1 = "#5E6C84";
var $beb1ff5cb068cc62$export$eece5f492e429f08 = "#505F79";
var $beb1ff5cb068cc62$export$c39c0fe0f26207ae = "#42526E";
var $beb1ff5cb068cc62$export$7090862dc3038a9f = "#344563";
var $beb1ff5cb068cc62$export$ad0bacf983b7ddaa = "#253858";
var $beb1ff5cb068cc62$export$7d61b15e0da132af = "#172B4D";
var $beb1ff5cb068cc62$export$fbda843f0a27fe96 = "#091E42";
var $beb1ff5cb068cc62$export$791e57b27ca738ef = "rgba(9, 30, 66, 0.02)";
var $beb1ff5cb068cc62$export$8d43898f60b96a82 = "rgba(9, 30, 66, 0.04)";
var $beb1ff5cb068cc62$export$920c0d5c49070351 = "rgba(9, 30, 66, 0.08)";
var $beb1ff5cb068cc62$export$46987b49aab6d1a8 = "rgba(9, 30, 66, 0.13)";
var $beb1ff5cb068cc62$export$7d3359664e8bb0e5 = "rgba(9, 30, 66, 0.25)";
var $beb1ff5cb068cc62$export$d2d3bedfb276cac0 = "rgba(9, 30, 66, 0.31)";
var $beb1ff5cb068cc62$export$6e5e7499ff054f6d = "rgba(9, 30, 66, 0.36)";
var $beb1ff5cb068cc62$export$59264b346c877fa7 = "rgba(9, 30, 66, 0.42)";
var $beb1ff5cb068cc62$export$d092757d7c64925c = "rgba(9, 30, 66, 0.48)";
var $beb1ff5cb068cc62$export$486ab785e4bac3c6 = "rgba(9, 30, 66, 0.54)";
var $beb1ff5cb068cc62$export$fba592bbc6419fea = "rgba(9, 30, 66, 0.60)";
var $beb1ff5cb068cc62$export$13609db0e6812ab8 = "rgba(9, 30, 66, 0.66)";
var $beb1ff5cb068cc62$export$fbae4efaa892d883 = "rgba(9, 30, 66, 0.71)";
var $beb1ff5cb068cc62$export$f13946d26f440ce6 = "rgba(9, 30, 66, 0.77)";
var $beb1ff5cb068cc62$export$19f58225ac52a306 = "rgba(9, 30, 66, 0.82)";
var $beb1ff5cb068cc62$export$6384f09da70e7b62 = "rgba(9, 30, 66, 0.89)";
var $beb1ff5cb068cc62$export$d0dccc730683edc2 = "rgba(9, 30, 66, 0.95)";
var $beb1ff5cb068cc62$export$2f6319cf7d736c2a = "#E6EDFA";
var $beb1ff5cb068cc62$export$95126bc8884d6634 = "#DCE5F5";
var $beb1ff5cb068cc62$export$8338d8c35d44ff1 = "#CED9EB";
var $beb1ff5cb068cc62$export$5368d76ae4fbbda7 = "#B8C7E0";
var $beb1ff5cb068cc62$export$9f0a771d16ec8d36 = "#ABBBD6";
var $beb1ff5cb068cc62$export$abcf8c38338b4aa5 = "#9FB0CC";
var $beb1ff5cb068cc62$export$97e81faa16a182c7 = "#8C9CB8";
var $beb1ff5cb068cc62$export$bfe21c59123ecf33 = "#7988A3";
var $beb1ff5cb068cc62$export$ee82aa2ea6a1558 = "#67758F";
var $beb1ff5cb068cc62$export$682927c6ed76be02 = "#56637A";
var $beb1ff5cb068cc62$export$91fd9994c5be9757 = "#455166";
var $beb1ff5cb068cc62$export$d281fbfe3cff2df6 = "#3B475C";
var $beb1ff5cb068cc62$export$3902c91d8b98a753 = "#313D52";
var $beb1ff5cb068cc62$export$8e8133c1ba5845b5 = "#283447";
var $beb1ff5cb068cc62$export$33ff357f6620b39 = "#202B3D";
var $beb1ff5cb068cc62$export$633847cf062b69e0 = "#1B2638";
var $beb1ff5cb068cc62$export$9776a6e503bdbf76 = "#121A29";
var $beb1ff5cb068cc62$export$6c813d5160dff5db = "#0E1624";
var $beb1ff5cb068cc62$export$3d4f271a500072a = "#0D1424";
var $beb1ff5cb068cc62$export$fe151285c22759ec = "rgba(13, 20, 36, 0.06)";
var $beb1ff5cb068cc62$export$a101c6190d0da34 = "rgba(13, 20, 36, 0.14)";
var $beb1ff5cb068cc62$export$4b16f52932fda51 = "rgba(13, 20, 36, 0.18)";
var $beb1ff5cb068cc62$export$a74bcd7b9845b0d8 = "rgba(13, 20, 36, 0.29)";
var $beb1ff5cb068cc62$export$9209c179316d1751 = "rgba(13, 20, 36, 0.36)";
var $beb1ff5cb068cc62$export$88f55133f636c8dd = "rgba(13, 20, 36, 0.40)";
var $beb1ff5cb068cc62$export$51126f85d1009512 = "rgba(13, 20, 36, 0.47)";
var $beb1ff5cb068cc62$export$a069b547bd23af78 = "rgba(13, 20, 36, 0.53)";
var $beb1ff5cb068cc62$export$40cce05af3b2600a = "rgba(13, 20, 36, 0.63)";
var $beb1ff5cb068cc62$export$b78942185925a0d = "rgba(13, 20, 36, 0.73)";
var $beb1ff5cb068cc62$export$e058fb44b8eaafca = "rgba(13, 20, 36, 0.78)";
var $beb1ff5cb068cc62$export$92b0b8de26920c18 = "rgba(13, 20, 36, 0.81)";
var $beb1ff5cb068cc62$export$67564f7459d3fc9e = "rgba(13, 20, 36, 0.85)";
var $beb1ff5cb068cc62$export$77868e1ca884ffa3 = "rgba(13, 20, 36, 0.89)";
var $beb1ff5cb068cc62$export$2afd71d7d3ea2cd5 = "rgba(13, 20, 36, 0.92)";
var $beb1ff5cb068cc62$export$f2a0acaab9972c70 = "rgba(13, 20, 36, 0.95)";
var $beb1ff5cb068cc62$export$9ab70e67d6475361 = "rgba(13, 20, 36, 0.97)";

});

parcelRegister("gecEH", function(module, exports) {

$parcel$export(module.exports, "layers", function () { return $bd07c5441eb42f82$export$7be255094ccdc533; });

var $e2xkU = parcelRequire("e2xkU");

var $gn485 = parcelRequire("gn485");
var $bd07c5441eb42f82$export$44ffba16bd48dac6 = "__ATLASKIT_THEME__";
var $bd07c5441eb42f82$export$c93026a968943f95 = "light";
var $bd07c5441eb42f82$export$6ba72c8346b4c57e = [
    "light",
    "dark"
];
var $bd07c5441eb42f82$export$7a57f79000377ca2 = function borderRadius() {
    return 3;
};
var $bd07c5441eb42f82$export$6d8204c2cb2e06b8 = function gridSize() {
    return 8;
};
var $bd07c5441eb42f82$export$85e3c3ca0c6fb93 = function fontSize() {
    return 14;
};
var $bd07c5441eb42f82$export$6746fe0d9c9fab54 = function fontSizeSmall() {
    return 11;
};
var $bd07c5441eb42f82$export$a5975749f0374264 = function fontFamily() {
    return "-apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif";
};
var $bd07c5441eb42f82$export$356129969ee49c55 = function codeFontFamily() {
    return "'SFMono-Medium', 'SF Mono', 'Segoe UI Mono', 'Roboto Mono', 'Ubuntu Mono', Menlo, Consolas, Courier, monospace";
};
var $bd07c5441eb42f82$export$8e24544ddba725ee = function focusRing() {
    var color = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "var(--ds-border-focused, ".concat((0, $gn485.B200), ")");
    var outlineWidth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $bd07c5441eb42f82$export$6d8204c2cb2e06b8() / 4;
    (0, $e2xkU.default)("@atlaskit/theme", "focus ring mixin", "Please use `@atlaskit/focus-ring` instead.");
    return "\n  &:focus {\n    outline: none;\n    box-shadow: 0px 0px 0px ".concat(outlineWidth, "px ").concat(color, ";\n  }\n");
};
var $bd07c5441eb42f82$export$c0dd343266bc3261 = function noFocusRing() {
    return "\n  box-shadow: none;\n";
};
var $bd07c5441eb42f82$export$7be255094ccdc533 = {
    card: function card() {
        return 100;
    },
    navigation: function navigation() {
        return 200;
    },
    dialog: function dialog() {
        return 300;
    },
    layer: function layer() {
        return 400;
    },
    blanket: function blanket() {
        return 500;
    },
    modal: function modal() {
        return 510;
    },
    flag: function flag() {
        return 600;
    },
    spotlight: function spotlight() {
        return 700;
    },
    tooltip: function tooltip() {
        return 9999;
    }
};
var $bd07c5441eb42f82$export$a1b3edb637fb4f35 = function visuallyHidden() {
    (0, $e2xkU.default)("@atlaskit/theme", "visually hidden mixin", "Please use `@atlaskit/visually-hidden` instead.");
    return {
        border: "0 !important",
        clip: "rect(1px, 1px, 1px, 1px) !important",
        height: "1px !important",
        overflow: "hidden !important",
        padding: "0 !important",
        position: "absolute !important",
        width: "1px !important",
        whiteSpace: "nowrap !important"
    };
};
var $bd07c5441eb42f82$export$ba1d834b86d72a09 = $bd07c5441eb42f82$export$a1b3edb637fb4f35;
var $bd07c5441eb42f82$export$e497e856b4f89fcd = function skeletonShimmer() {
    return {
        css: {
            backgroundColor: "var(--ds-skeleton, ".concat((0, $gn485.N20A), ")"),
            animationDuration: "1.5s",
            animationIterationCount: "infinite",
            animationTimingFunction: "linear",
            animationDirection: "alternate"
        },
        keyframes: {
            from: {
                backgroundColor: "var(--ds-skeleton, ".concat((0, $gn485.N20A), ")")
            },
            to: {
                backgroundColor: "var(--ds-skeleton-subtle, ".concat((0, $gn485.N30A), ")")
            }
        }
    };
};

});


parcelRegister("erihP", function(module, exports) {

$parcel$export(module.exports, "useExitingPersistence", function () { return $a831c5a62fca9324$export$3b6f38abbdcbd000; });
$parcel$export(module.exports, "default", function () { return $a831c5a62fca9324$export$2e2bcd8739ae039; });

var $6RxC1 = parcelRequire("6RxC1");

var $dAx5m = parcelRequire("dAx5m");

var $7YQAW = parcelRequire("7YQAW");
var $a831c5a62fca9324$export$d1e013d71d2e2121 = {
    // Motions will always appear if not inside a exiting persistence component.
    appear: true,
    isExiting: false
};
var $a831c5a62fca9324$export$b9c4904d7a6929e6 = /*#__PURE__*/ (0, $dAx5m.createContext)($a831c5a62fca9324$export$d1e013d71d2e2121);
var $a831c5a62fca9324$export$e4c4c45693c3a7c = function wrapChildWithContextProvider(child) {
    var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $a831c5a62fca9324$export$d1e013d71d2e2121;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement($a831c5a62fca9324$export$b9c4904d7a6929e6.Provider, {
        key: "".concat(child.key, "-provider"),
        value: value
    }, child);
};
var $a831c5a62fca9324$export$7032ae6d9d98bedd = function childrenToArray(children) {
    var childrenAsArray = [];
    // We convert children to an array using this helper method as it will add keys to children that do not
    // have them, such as when we have hardcoded children that are conditionally rendered.
    (0, $dAx5m.Children).toArray(children).forEach(function(child) {
        // We ignore any boolean children to make our code a little more simple later on,
        // and also filter out any falsies (empty strings, nulls, and undefined).
        if (typeof child !== "boolean" && Boolean(child)) // Children WILL have a key after being forced into an array using the React.Children helper.
        childrenAsArray.push(child);
    });
    return childrenAsArray;
};
var $a831c5a62fca9324$export$2ccbe4ff092af328 = function spliceNewElementsIntoPrevious(current, previous) {
    var splicedChildren = previous.concat([]);
    var previousMap = $a831c5a62fca9324$export$1d8c49f95a162a41(previous);
    for(var i = 0; i < current.length; i++){
        var child = current[i];
        var childIsNew = !previousMap[child.key];
        if (childIsNew) // This will insert the new element after the previous element.
        splicedChildren.splice(i + 1, 0, child);
    }
    return splicedChildren;
};
var $a831c5a62fca9324$export$1d8c49f95a162a41 = function childrenToObj(children) {
    return children.reduce(function(acc, child) {
        acc[child.key] = child;
        return acc;
    }, {});
};
var $a831c5a62fca9324$var$getMissingKeys = function getMissingKeys(current, previous) {
    var currentMapKeys = new Set(current.map(function(child) {
        return child.key;
    }));
    var missing = new Set();
    for(var i = 0; i < previous.length; i++){
        var element = previous[i];
        var _key = element.key;
        if (!currentMapKeys.has(_key)) missing.add(_key);
    }
    return missing;
};
/**
 * __ExitingPersistence__
 *
 * Useful for enabling elements to persist and animate away when they are removed from the DOM.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motions)
 */ var $a831c5a62fca9324$var$ExitingPersistence = /*#__PURE__*/ (0, $dAx5m.memo)(function(_ref) {
    var _ref$appear = _ref.appear, appear = _ref$appear === void 0 ? false : _ref$appear, children = _ref.children, exitThenEnter = _ref.exitThenEnter;
    var _useState = (0, $dAx5m.useState)([
        null,
        children
    ]), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($6RxC1)))(_useState, 2), stateChildren = _useState2[0], setChildren = _useState2[1];
    var _useState3 = (0, $dAx5m.useState)([]), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($6RxC1)))(_useState3, 2), exitingChildren = _useState4[0], setExitingChildren = _useState4[1];
    var _useState5 = (0, $dAx5m.useState)(function() {
        return {
            appear: appear,
            isExiting: false
        };
    }), _useState6 = (0, (/*@__PURE__*/$parcel$interopDefault($6RxC1)))(_useState5, 2), defaultContext = _useState6[0], setDefaultContext = _useState6[1];
    (0, $dAx5m.useEffect)(function() {
        if (!defaultContext.appear) setDefaultContext({
            appear: true,
            isExiting: false
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    if ((0, $7YQAW.isReducedMotion)()) return children;
    /**
   * NOTE: This is a workaround for the test case written in Jira where the stateChildren is a boolean value because
   * useState is mocked to return a boolean value.
   */ if (typeof stateChildren === "boolean") return children;
    var _stateChildren = (0, (/*@__PURE__*/$parcel$interopDefault($6RxC1)))(stateChildren, 2), previousChildren = _stateChildren[0], currentChildren = _stateChildren[1];
    var previous = $a831c5a62fca9324$export$7032ae6d9d98bedd(previousChildren);
    var current = $a831c5a62fca9324$export$7032ae6d9d98bedd(currentChildren);
    if (currentChildren !== children) setChildren([
        currentChildren,
        children
    ]);
    var missingKeys = $a831c5a62fca9324$var$getMissingKeys(current, previous);
    var isSomeChildRemoved = !!missingKeys.size;
    var visibleChildren = current;
    if (isSomeChildRemoved) visibleChildren = $a831c5a62fca9324$export$2ccbe4ff092af328(current, previous);
    if (exitThenEnter) {
        if (exitingChildren.length) visibleChildren = exitingChildren;
        else {
            var nextExitingChildren = visibleChildren.filter(function(child) {
                return missingKeys.has(child.key);
            });
            if (nextExitingChildren.length) setExitingChildren(nextExitingChildren);
        }
    }
    if (missingKeys.size) visibleChildren = visibleChildren.map(function(child) {
        var isExiting = missingKeys.has(child.key);
        return $a831c5a62fca9324$export$e4c4c45693c3a7c(child, {
            appear: true,
            isExiting: isExiting,
            onFinish: isExiting ? function() {
                missingKeys.delete(child.key);
                if (missingKeys.size === 0) {
                    setChildren([
                        null,
                        children
                    ]);
                    setExitingChildren([]);
                }
            } : undefined
        });
    });
    else visibleChildren = visibleChildren.map(function(child) {
        return $a831c5a62fca9324$export$e4c4c45693c3a7c(child, defaultContext);
    });
    return visibleChildren;
});
var $a831c5a62fca9324$export$3b6f38abbdcbd000 = function useExitingPersistence() {
    return (0, $dAx5m.useContext)($a831c5a62fca9324$export$b9c4904d7a6929e6);
};
$a831c5a62fca9324$var$ExitingPersistence.displayName = "ExitingPersistence";
var $a831c5a62fca9324$export$2e2bcd8739ae039 = $a831c5a62fca9324$var$ExitingPersistence;

});
parcelRegister("6RxC1", function(module, exports) {

var $fiYvz = parcelRequire("fiYvz");

var $9ugBO = parcelRequire("9ugBO");

var $5mvmw = parcelRequire("5mvmw");

var $ddVu7 = parcelRequire("ddVu7");
function $4ff1c40066fcad75$var$_slicedToArray(r, e) {
    return $fiYvz(r) || $9ugBO(r, e) || $5mvmw(r, e) || $ddVu7();
}
module.exports = $4ff1c40066fcad75$var$_slicedToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("fiYvz", function(module, exports) {
function $b247791da6f19569$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
module.exports = $b247791da6f19569$var$_arrayWithHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("9ugBO", function(module, exports) {
function $6e83cc8f1aa28567$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
module.exports = $6e83cc8f1aa28567$var$_iterableToArrayLimit, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("ddVu7", function(module, exports) {
function $9a091490ceb2a888$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
module.exports = $9a091490ceb2a888$var$_nonIterableRest, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("7YQAW", function(module, exports) {

$parcel$export(module.exports, "isReducedMotion", function () { return $5cf6ef40e2390e0d$export$b7baf7667a68d87c; });
$parcel$export(module.exports, "reduceMotionAsPerUserPreference", function () { return $5cf6ef40e2390e0d$export$f0f789643ba5a83c; });

var $6RxC1 = parcelRequire("6RxC1");

var $dAx5m = parcelRequire("dAx5m");

var $dd4sf = parcelRequire("dd4sf");
var $5cf6ef40e2390e0d$var$isMatchMediaAvailable = function isMatchMediaAvailable() {
    return typeof window !== "undefined" && "matchMedia" in window;
};
var $5cf6ef40e2390e0d$export$b7baf7667a68d87c = function isReducedMotion() {
    if (!$5cf6ef40e2390e0d$var$isMatchMediaAvailable()) return false;
    var _window$matchMedia = window.matchMedia("(prefers-reduced-motion: reduce)"), matches = _window$matchMedia.matches;
    return matches;
};
var $5cf6ef40e2390e0d$export$c537e63161742ce3 = function useIsReducedMotion() {
    var _useState = (0, $dAx5m.useState)($5cf6ef40e2390e0d$export$b7baf7667a68d87c), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($6RxC1)))(_useState, 2), prefersReducedMotion = _useState2[0], setPrefersReducedMotion = _useState2[1];
    (0, $dAx5m.useEffect)(function() {
        if (!$5cf6ef40e2390e0d$var$isMatchMediaAvailable()) return;
        var mediaQueryList = window.matchMedia("(prefers-reduced-motion: reduce)");
        var onChange = function onChange(event) {
            return setPrefersReducedMotion(event.matches);
        };
        return (0, $dd4sf.bind)(mediaQueryList, {
            type: "change",
            listener: onChange
        });
    }, []);
    return prefersReducedMotion;
};
var $5cf6ef40e2390e0d$export$f0f789643ba5a83c = {
    "@media (prefers-reduced-motion: reduce)": {
        animation: "none",
        transition: "none"
    }
};
var $5cf6ef40e2390e0d$export$ff7706047246b98b = function prefersReducedMotion() {
    return $5cf6ef40e2390e0d$export$f0f789643ba5a83c;
};

});


parcelRegister("5QWE6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $442f4ce5d5b3125b$export$2e2bcd8739ae039; });

var $iDtim = parcelRequire("iDtim");

var $dAx5m = parcelRequire("dAx5m");

var $kjzyh = parcelRequire("kjzyh");

var $9Bh6U = parcelRequire("9Bh6U");

var $5zLEw = parcelRequire("5zLEw");
function $442f4ce5d5b3125b$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $442f4ce5d5b3125b$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $442f4ce5d5b3125b$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($iDtim)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $442f4ce5d5b3125b$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $442f4ce5d5b3125b$var$directionMotions = {
    proportional: {
        bottom: "translate3d(0, calc(5% + 4px), 0)",
        left: "translate3d(calc(-5% - 4px), 0, 0)",
        right: "translate3d(calc(5% + 4px), 0, 0)",
        top: "translate3d(0, calc(-5% - 4px), 0)"
    },
    constant: {
        bottom: "translate3d(0, 4px, 0)",
        left: "translate3d(-4px, 0, 0)",
        right: "translate3d(4px, 0, 0)",
        top: "translate3d(0, -4px, 0)"
    }
};
var $442f4ce5d5b3125b$var$invertedDirection = {
    top: "bottom",
    bottom: "top",
    left: "right",
    right: "left"
};
var $442f4ce5d5b3125b$export$8497679fcaaeceb = function fadeInAnimation(direction) {
    var distance = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "proportional";
    return {
        from: $442f4ce5d5b3125b$var$_objectSpread({
            opacity: 0
        }, direction !== undefined && {
            transform: $442f4ce5d5b3125b$var$directionMotions[distance][direction]
        }),
        "50%": {
            opacity: 1
        },
        to: {
            transform: direction !== undefined ? "none" : undefined
        }
    };
};
var $442f4ce5d5b3125b$export$c9190c6659ea755b = function fadeOutAnimation(direction) {
    var distance = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "proportional";
    return {
        from: {
            opacity: 1,
            transform: direction !== undefined ? "translate3d(0, 0, 0)" : undefined
        },
        to: $442f4ce5d5b3125b$var$_objectSpread({
            opacity: 0
        }, direction !== undefined && {
            transform: $442f4ce5d5b3125b$var$directionMotions[distance][direction]
        })
    };
};
/**
 * Props for controlling the behavior of the FadeIn animation
 */ /**
 * __FadeIn__
 *
 * Useful for fading in one or more elements.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motions)
 */ var $442f4ce5d5b3125b$var$FadeIn = function FadeIn(_ref) {
    var children = _ref.children, _ref$duration = _ref.duration, duration = _ref$duration === void 0 ? (0, $9Bh6U.largeDurationMs) : _ref$duration, entranceDirection = _ref.entranceDirection, exitDirection = _ref.exitDirection, _ref$distance = _ref.distance, distance = _ref$distance === void 0 ? "proportional" : _ref$distance, onFinish = _ref.onFinish, isPaused = _ref.isPaused;
    var invertedEntranceDirection = entranceDirection && $442f4ce5d5b3125b$var$invertedDirection[entranceDirection];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $5zLEw.default), {
        duration: duration,
        enteringAnimation: $442f4ce5d5b3125b$export$8497679fcaaeceb(entranceDirection, distance),
        exitingAnimation: $442f4ce5d5b3125b$export$c9190c6659ea755b(exitDirection || invertedEntranceDirection, distance),
        animationTimingFunction: function animationTimingFunction() {
            return 0, $kjzyh.easeInOut;
        },
        onFinish: onFinish,
        isPaused: isPaused
    }, children);
};
var $442f4ce5d5b3125b$export$2e2bcd8739ae039 = $442f4ce5d5b3125b$var$FadeIn;

});
parcelRegister("9Bh6U", function(module, exports) {

$parcel$export(module.exports, "mediumDurationMs", function () { return $6fd4d789387f94cf$export$6fa259be09e118a7; });
$parcel$export(module.exports, "largeDurationMs", function () { return $6fd4d789387f94cf$export$9424640c29bc466d; });
/**
 * Think of this as the motion equivalent of the @atlaskit/theme `grid()`.
 */ var $6fd4d789387f94cf$export$368bacef0dacbe05 = 25;
var $6fd4d789387f94cf$export$2023a81c8547415f = $6fd4d789387f94cf$export$368bacef0dacbe05 * 4;
var $6fd4d789387f94cf$export$6fa259be09e118a7 = $6fd4d789387f94cf$export$368bacef0dacbe05 * 14;
var $6fd4d789387f94cf$export$9424640c29bc466d = $6fd4d789387f94cf$export$368bacef0dacbe05 * 28;

});

parcelRegister("5zLEw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $40f52f6e37872ce4$export$2e2bcd8739ae039; });

var $iDtim = parcelRequire("iDtim");

var $6RxC1 = parcelRequire("6RxC1");

var $dAx5m = parcelRequire("dAx5m");

var $jVTBW = parcelRequire("jVTBW");

var $7YQAW = parcelRequire("7YQAW");

var $9Bh6U = parcelRequire("9Bh6U");

var $in0I2 = parcelRequire("in0I2");

var $erihP = parcelRequire("erihP");

var $4bZn0 = parcelRequire("4bZn0");
function $40f52f6e37872ce4$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $40f52f6e37872ce4$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $40f52f6e37872ce4$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($iDtim)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $40f52f6e37872ce4$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
/**
 * These are props that motions should use as their external props for consumers.
 * See [FadeIn](packages/helpers/motion/src/entering/fade-in.tsx) for an example usage.
 */ /**
 * Used to multiply the initial duration for exiting motions.
 */ var $40f52f6e37872ce4$var$EXITING_MOTION_MULTIPLIER = 0.5;
/**
 * This is the base INTERNAL component used for all other entering motions.
 * This does not need Javascript to execute on the client so it will run immediately
 * for any SSR rendered React apps before the JS has executed.
 */ var $40f52f6e37872ce4$var$EnteringMotion = function EnteringMotion(_ref) {
    var children = _ref.children, animationTimingFunction = _ref.animationTimingFunction, enteringAnimation = _ref.enteringAnimation, exitingAnimation = _ref.exitingAnimation, isPaused = _ref.isPaused, onFinishMotion = _ref.onFinish, _ref$duration = _ref.duration, duration = _ref$duration === void 0 ? (0, $9Bh6U.largeDurationMs) : _ref$duration;
    var staggered = (0, $4bZn0.useStaggeredEntrance)();
    var _useExitingPersistenc = (0, $erihP.useExitingPersistence)(), isExiting = _useExitingPersistenc.isExiting, onExitFinished = _useExitingPersistenc.onFinish, appear = _useExitingPersistenc.appear;
    var setTimeout = (0, $in0I2.useSetTimeout)();
    var paused = isPaused || !staggered.isReady;
    var delay = isExiting ? 0 : staggered.delay;
    var state = isExiting ? "exiting" : "entering";
    var _useState = (0, $dAx5m.useState)(appear), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($6RxC1)))(_useState, 2), hasAnimationStyles = _useState2[0], setHasAnimationStyles = _useState2[1];
    (0, $dAx5m.useEffect)(function() {
        // Tracking this to prevent changing state on an unmounted component
        var isCancelled = false;
        if (paused) return;
        // On initial mount if elements aren't set to animate on appear, we return early and callback
        if (!appear) {
            onFinishMotion && onFinishMotion(state);
            return;
        }
        // Elements may need animation styles back after initial mount (they could animate out)
        setHasAnimationStyles(true);
        setTimeout(function() {
            if (state === "exiting") onExitFinished && onExitFinished();
            if (!isCancelled) setHasAnimationStyles(false);
            onFinishMotion && onFinishMotion(state);
        }, isExiting ? duration * $40f52f6e37872ce4$var$EXITING_MOTION_MULTIPLIER : duration + delay);
        return function() {
            isCancelled = true;
        };
    // We ignore this for onFinishMotion as consumers could potentially inline the function
    // which would then trigger this effect every re-render.
    // We want to make it easier for consumers so we go down this path unfortunately.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        onExitFinished,
        state,
        isExiting,
        duration,
        delay,
        paused,
        setTimeout
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $jVTBW.ClassNames), null, function(_ref2) {
        var css = _ref2.css;
        return children({
            ref: staggered.ref,
            className: hasAnimationStyles ? css($40f52f6e37872ce4$var$_objectSpread($40f52f6e37872ce4$var$_objectSpread({}, (0, $7YQAW.reduceMotionAsPerUserPreference)), {}, {
                animationDelay: "".concat(delay, "ms"),
                animationDuration: "".concat(isExiting ? duration * $40f52f6e37872ce4$var$EXITING_MOTION_MULTIPLIER : duration, "ms"),
                animationFillMode: isExiting ? "forwards" : "backwards",
                animationName: "".concat((0, $jVTBW.keyframes)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                isExiting ? exitingAnimation || enteringAnimation : enteringAnimation)),
                animationPlayState: paused ? "paused" : "running",
                animationTimingFunction: animationTimingFunction(state)
            })) : ""
        }, state);
    });
};
var $40f52f6e37872ce4$export$2e2bcd8739ae039 = $40f52f6e37872ce4$var$EnteringMotion;

});
parcelRegister("in0I2", function(module, exports) {

$parcel$export(module.exports, "useSetTimeout", function () { return $d5faecd4b94d5f1e$export$4f34107a2b00f39c; });

var $dAx5m = parcelRequire("dAx5m");
var $d5faecd4b94d5f1e$var$getHookDeps = function getHookDeps(opts) {
    switch(opts.cleanup){
        case "next-effect":
            return undefined;
        case "unmount":
        default:
            return [];
    }
};
var $d5faecd4b94d5f1e$export$1775f27e7c8051ca = function useRequestAnimationFrame() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        cleanup: "unmount"
    };
    var frames = (0, $dAx5m.useRef)([]);
    (0, $dAx5m.useEffect)(function() {
        return function() {
            if (frames.current.length) {
                frames.current.forEach(function(id) {
                    return cancelAnimationFrame(id);
                });
                frames.current = [];
            }
        };
    // We dynamically set this so we either clean up on the next effect - or on unmount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, $d5faecd4b94d5f1e$var$getHookDeps(opts));
    return (0, $dAx5m.useCallback)(function(handler) {
        var id = requestAnimationFrame(function(time) {
            frames.current = frames.current.filter(function(frameId) {
                return frameId !== id;
            });
            handler(time);
        });
        frames.current.push(id);
    }, []);
};
var $d5faecd4b94d5f1e$export$4f34107a2b00f39c = function useSetTimeout() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        cleanup: "unmount"
    };
    var timeouts = (0, $dAx5m.useRef)([]);
    (0, $dAx5m.useEffect)(function() {
        return function() {
            if (timeouts.current.length) {
                timeouts.current.forEach(function(id) {
                    return clearTimeout(id);
                });
                timeouts.current = [];
            }
        };
    // We dynamically set this so we either clean up on the next effect - or on unmount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, $d5faecd4b94d5f1e$var$getHookDeps(opts));
    return (0, $dAx5m.useCallback)(function(handler, timeout) {
        for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
        var id = setTimeout.apply(void 0, [
            function() {
                timeouts.current = timeouts.current.filter(function(timeoutId) {
                    return timeoutId !== id;
                });
                handler();
            },
            timeout
        ].concat(args));
        timeouts.current.push(id);
    }, []);
};

});

parcelRegister("4bZn0", function(module, exports) {

$parcel$export(module.exports, "useStaggeredEntrance", function () { return $30d7cb50f64b0e3f$export$25c7213fc07ec080; });

var $6RxC1 = parcelRequire("6RxC1");

var $dAx5m = parcelRequire("dAx5m");

var $Bb0he = parcelRequire("Bb0he");

var $j2Mbn = parcelRequire("j2Mbn");

var $2uJSD = parcelRequire("2uJSD");
var $30d7cb50f64b0e3f$var$StaggeredEntranceContext = /*#__PURE__*/ (0, $dAx5m.createContext)(function() {
    return {
        isReady: true,
        delay: 0,
        ref: (0, $Bb0he.default)
    };
});
var $30d7cb50f64b0e3f$export$25c7213fc07ec080 = function useStaggeredEntrance() {
    var indentifier = (0, $2uJSD.useUniqueId)();
    var context = (0, $dAx5m.useContext)($30d7cb50f64b0e3f$var$StaggeredEntranceContext);
    return context(indentifier);
};
/**
 * For a list of elements that need to animate in,
 * this should be used in conjunction with entering components.
 * This does not need Javascript to execute so it will run immediately for any SSR rendered React apps before the JS has executed.
 *
 * Will dynamically add delay to each child entering component.
 * Unfortunately all entering components _NEED_ to be a direct descendant.
 */ var $30d7cb50f64b0e3f$var$StaggeredEntrance = function StaggeredEntrance(_ref) {
    var children = _ref.children, column = _ref.column, _ref$columns = _ref.columns, columns = _ref$columns === void 0 ? "responsive" : _ref$columns, _ref$delayStep = _ref.delayStep, delayStep = _ref$delayStep === void 0 ? 50 : _ref$delayStep;
    var elementRefs = (0, $dAx5m.useRef)([]);
    var indexes = [];
    var _useState = (0, $dAx5m.useState)(function() {
        if (typeof columns === "number") // A hardcoded columns is set so bail out and set it to that!
        return columns;
        if (typeof column === "number") // A hardcoded column is set so we will set actualColumns to be 1.
        return 1;
        // We are in "responsive" mode.
        // So we will be calculating when the Javascript executes on the client how many columns there will be.
        return 0;
    }), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($6RxC1)))(_useState, 2), actualColumns = _useState2[0], setActualColumns = _useState2[1];
    (0, $j2Mbn.useLayoutEffect)(function() {
        // We want to only run this code when we are in "responsive" mode.
        // It is assumed we are in responsive mode if `columns` is "responsive",
        // we have children element refs ready to be read (i.e. if there are no children this won't run as well)
        // and finally that `actualColumns` is `0` - this is because for the first render cycle `actualColumns` will be `0` (set above)
        // and then after this layout effect runs the value for `actualColumns` will then be calculated and set.
        if (columns === "responsive" && elementRefs.current.length && actualColumns === 0) {
            var currentTop = 0;
            var numberColumns = 0;
            if (elementRefs.current.length <= 1) {
                setActualColumns(1);
                return;
            }
            // We set the current top to the first elements.
            // We will be comparing this and incrementing the column count
            // until we hit an element that has a different offset top (or we run out of elements).
            currentTop = elementRefs.current[0] ? elementRefs.current[0].offsetTop : 0;
            for(var i = 0; i < elementRefs.current.length; i++){
                var child = elementRefs.current[i];
                if (!child) break;
                if (currentTop === child.offsetTop) {
                    numberColumns += 1;
                    if (elementRefs.current.length - 1 === i) setActualColumns(numberColumns);
                    continue;
                }
                setActualColumns(numberColumns);
                break;
            }
        }
    // We only want this effect to run once - on initial mount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement($30d7cb50f64b0e3f$var$StaggeredEntranceContext.Provider, {
        value: function value(id) {
            if (!indexes.includes(id)) indexes.push(id);
            var isReady = actualColumns > 0;
            var index = indexes.indexOf(id);
            var currentColumn = column || index % actualColumns;
            var currentRow = Math.floor(index / actualColumns);
            var distanceFromTopLeftElement = currentRow + currentColumn;
            // We don't want loads of elements to have the same staggered delay as it ends up looking slow for users.
            // To get around that we calculate the logarithm using `distanceFromTopLeftElement` which ends making
            // elements appear faster the further away from the top left element.
            var delay = Math.ceil(Math.log(distanceFromTopLeftElement + 1) * delayStep * 1.5) || 0;
            return {
                delay: delay,
                isReady: isReady,
                ref: function ref(element) {
                    return elementRefs.current[index] = element;
                }
            };
        }
    }, children);
};
var $30d7cb50f64b0e3f$export$2e2bcd8739ae039 = $30d7cb50f64b0e3f$var$StaggeredEntrance;

});
parcelRegister("j2Mbn", function(module, exports) {

$parcel$export(module.exports, "useLayoutEffect", function () { return $ddd39446801fd69e$export$e5c5a5f917a5871c; });

var $dAx5m = parcelRequire("dAx5m");
var $ddd39446801fd69e$export$e5c5a5f917a5871c = typeof window === "undefined" ? (0, $dAx5m.useEffect) : (0, $dAx5m.useLayoutEffect);

});

parcelRegister("2uJSD", function(module, exports) {

$parcel$export(module.exports, "useUniqueId", function () { return $1d11f8f3d37f0fda$export$c485849f2e393253; });
/* eslint-disable @repo/internal/react/disallow-unstable-values */ 
var $dAx5m = parcelRequire("dAx5m");
function $1d11f8f3d37f0fda$export$c485849f2e393253() {
    var identifier = (0, $dAx5m.useRef)("");
    if (!identifier.current) identifier.current = "_" + (Number(String(Math.random()).slice(2)) + Date.now() + Math.round(performance.now())).toString(36);
    return identifier.current;
}

});





parcelRegister("8Qja1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $67020af7ccc06b4e$export$2e2bcd8739ae039; });

var $8TMbA = parcelRequire("8TMbA");

var $8jzoy = parcelRequire("8jzoy");

var $dAx5m = parcelRequire("dAx5m");

var $jVTBW = parcelRequire("jVTBW");

var $ht0QE = parcelRequire("ht0QE");

var $1Zl8g = parcelRequire("1Zl8g");

var $erihP = parcelRequire("erihP");
var $i9KVl = parcelRequire("i9KVl");

var $1XHoZ = parcelRequire("1XHoZ");

var $3QLyo = parcelRequire("3QLyo");

var $bFV6j = parcelRequire("bFV6j");

var $335tc = parcelRequire("335tc");

var $3yKv3 = parcelRequire("3yKv3");

var $dsf6a = parcelRequire("dsf6a");
var $67020af7ccc06b4e$var$_excluded = [
    "component"
], $67020af7ccc06b4e$var$_excluded2 = [
    "component"
];
// Misc.
// ------------------------------
var $67020af7ccc06b4e$var$defaults = {
    Sidebar: (0, $dsf6a.default),
    Content: (0, $bFV6j.default)
};
/**
 * This wrapper is used to specify separate durations for enter and exit.
 */ var $67020af7ccc06b4e$var$CustomSlideIn = function CustomSlideIn(_ref) {
    var children = _ref.children, onFinish = _ref.onFinish;
    var _useExitingPersistenc = (0, $erihP.useExitingPersistence)(), isExiting = _useExitingPersistenc.isExiting;
    /**
   * The actual duration should be the same for both enter and exit,
   * but motion halves the passed duration for exit animations,
   * so we double it when exiting.
   */ var duration = isExiting ? (0, $1XHoZ.transitionDurationMs) * 2 : (0, $1XHoZ.transitionDurationMs);
    return (0, $jVTBW.jsx)((0, $i9KVl.default), {
        animationTimingFunction: (0, $1XHoZ.animationTimingFunction),
        duration: duration,
        enterFrom: "left",
        exitTo: "left",
        fade: "none",
        onFinish: onFinish
    }, children);
};
var $67020af7ccc06b4e$var$DrawerPrimitive = function DrawerPrimitive(_ref2) {
    var children = _ref2.children, Icon = _ref2.icon, _ref2$closeLabel = _ref2.closeLabel, closeLabel = _ref2$closeLabel === void 0 ? "Close drawer" : _ref2$closeLabel, onClose = _ref2.onClose, onCloseComplete = _ref2.onCloseComplete, onOpenComplete = _ref2.onOpenComplete, overrides = _ref2.overrides, testId = _ref2.testId, isOpen = _ref2.in, shouldReturnFocus = _ref2.shouldReturnFocus, autoFocusFirstElem = _ref2.autoFocusFirstElem, isFocusLockEnabled = _ref2.isFocusLockEnabled, width = _ref2.width, label = _ref2.label, titleId = _ref2.titleId;
    var getOverrides = (0, $3QLyo.createExtender)($67020af7ccc06b4e$var$defaults, overrides);
    var _getOverrides = getOverrides("Sidebar"), Sidebar = _getOverrides.component, sideBarOverrides = (0, (/*@__PURE__*/$parcel$interopDefault($8jzoy)))(_getOverrides, $67020af7ccc06b4e$var$_excluded);
    var _getOverrides2 = getOverrides("Content"), Content = _getOverrides2.component, contentOverrides = (0, (/*@__PURE__*/$parcel$interopDefault($8jzoy)))(_getOverrides2, $67020af7ccc06b4e$var$_excluded2);
    /**
   * A ref to point to our wrapper, passed to `onCloseComplete` and `onOpenComplete` callbacks.
   */ var drawerRef = (0, $dAx5m.useRef)(null);
    var onFinish = (0, $dAx5m.useCallback)(function(state) {
        if (state === "entering") onOpenComplete === null || onOpenComplete === void 0 || onOpenComplete(drawerRef.current);
        else if (state === "exiting") onCloseComplete === null || onCloseComplete === void 0 || onCloseComplete(drawerRef.current);
    }, [
        onCloseComplete,
        onOpenComplete
    ]);
    return (0, $jVTBW.jsx)((0, $erihP.default), {
        appear: true
    }, isOpen && (0, $jVTBW.jsx)($67020af7ccc06b4e$var$CustomSlideIn, {
        onFinish: onFinish
    }, function(_ref3) {
        var className = _ref3.className;
        return (0, $jVTBW.jsx)((0, $3yKv3.default), {
            autoFocusFirstElem: autoFocusFirstElem,
            isFocusLockEnabled: isFocusLockEnabled,
            shouldReturnFocus: shouldReturnFocus
        }, (0, $jVTBW.jsx)((0, $335tc.default), {
            className: className,
            width: width,
            testId: testId,
            drawerRef: drawerRef,
            label: label,
            titleId: titleId
        }, (0, $jVTBW.jsx)(Sidebar, sideBarOverrides, (0, $jVTBW.jsx)((0, $ht0QE.default), {
            onClick: onClose,
            testId: testId && "DrawerPrimitiveSidebarCloseButton",
            icon: Icon ? function(iconProps) {
                return (0, $jVTBW.jsx)(Icon, (0, (/*@__PURE__*/$parcel$interopDefault($8TMbA)))({}, iconProps, {
                    size: "large"
                }));
            } : (0, (/*@__PURE__*/$parcel$interopDefault($1Zl8g))),
            label: closeLabel,
            shape: "circle",
            appearance: "subtle"
        })), (0, $jVTBW.jsx)(Content, contentOverrides, children)));
    }));
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$67020af7ccc06b4e$export$2e2bcd8739ae039 = $67020af7ccc06b4e$var$DrawerPrimitive;

});
parcelRegister("ht0QE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cb75cd83daa4786c$export$2e2bcd8739ae039; });

var $8TMbA = parcelRequire("8TMbA");

var $8jzoy = parcelRequire("8jzoy");

var $dAx5m = parcelRequire("dAx5m");

var $j7nj6 = parcelRequire("j7nj6");

var $9FYbu = parcelRequire("9FYbu");

var $cj4Qn = parcelRequire("cj4Qn");
var $cb75cd83daa4786c$var$_excluded = [
    "aria-label",
    "analyticsContext",
    "appearance",
    "autoFocus",
    "icon",
    "interactionName",
    "isDisabled",
    "isLoading",
    "isSelected",
    "isTooltipDisabled",
    "label",
    "onClick",
    "onClickCapture",
    "onKeyDownCapture",
    "onKeyUpCapture",
    "onMouseDownCapture",
    "onMouseUpCapture",
    "onPointerDownCapture",
    "onPointerUpCapture",
    "onTouchEndCapture",
    "onTouchStartCapture",
    "overlay",
    "shape",
    "spacing",
    "testId",
    "tooltip",
    "type",
    "UNSAFE_size"
];
/**
 * __Icon Button__
 *
 * TODO: Description
 *
 * - [Examples](https://atlassian.design/components/icon-button/examples)
 * - [Code](https://atlassian.design/components/icon-button/code)
 * - [Usage](https://atlassian.design/components/icon-button/usage)
 */ var $cb75cd83daa4786c$var$IconButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).forwardRef(function Button(_ref, ref) {
    var preventedAriaLabel = _ref["aria-label"], analyticsContext = _ref.analyticsContext, appearance = _ref.appearance, autoFocus = _ref.autoFocus, icon = _ref.icon, interactionName = _ref.interactionName, isDisabled = _ref.isDisabled, isLoading = _ref.isLoading, isSelected = _ref.isSelected, _ref$isTooltipDisable = _ref.isTooltipDisabled, isTooltipDisabled = _ref$isTooltipDisable === void 0 ? true : _ref$isTooltipDisable, label = _ref.label, onClick = _ref.onClick, onClickCapture = _ref.onClickCapture, onKeyDownCapture = _ref.onKeyDownCapture, onKeyUpCapture = _ref.onKeyUpCapture, onMouseDownCapture = _ref.onMouseDownCapture, onMouseUpCapture = _ref.onMouseUpCapture, onPointerDownCapture = _ref.onPointerDownCapture, onPointerUpCapture = _ref.onPointerUpCapture, onTouchEndCapture = _ref.onTouchEndCapture, onTouchStartCapture = _ref.onTouchStartCapture, overlay = _ref.overlay, shape = _ref.shape, spacing = _ref.spacing, testId = _ref.testId, tooltip = _ref.tooltip, _ref$type = _ref.type, type = _ref$type === void 0 ? "button" : _ref$type, UNSAFE_size = _ref.UNSAFE_size, rest = (0, (/*@__PURE__*/$parcel$interopDefault($8jzoy)))(_ref, $cb75cd83daa4786c$var$_excluded);
    /**
   * TODO: At some stage I'll look into re-using more logic across 'default' and 'icon'
   * buttons. It's currently duplicated and mostly the same.
   */ var baseProps = (0, $cj4Qn.default)({
        analyticsContext: analyticsContext,
        appearance: appearance,
        autoFocus: autoFocus,
        buttonType: "button",
        icon: icon,
        interactionName: interactionName,
        isDisabled: isDisabled,
        isSelected: isSelected,
        isLoading: isLoading,
        label: label,
        onClick: onClick,
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onTouchStartCapture: onTouchStartCapture,
        onTouchEndCapture: onTouchEndCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onClickCapture: onClickCapture,
        overlay: overlay,
        ref: ref,
        shape: shape,
        spacing: spacing,
        UNSAFE_size: UNSAFE_size
    });
    if (!isTooltipDisabled) {
        var _tooltip$content;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $9FYbu.default), {
            content: (_tooltip$content = tooltip === null || tooltip === void 0 ? void 0 : tooltip.content) !== null && _tooltip$content !== void 0 ? _tooltip$content : label,
            testId: tooltip === null || tooltip === void 0 ? void 0 : tooltip.testId,
            position: tooltip === null || tooltip === void 0 ? void 0 : tooltip.position,
            delay: tooltip === null || tooltip === void 0 ? void 0 : tooltip.delay,
            onShow: tooltip === null || tooltip === void 0 ? void 0 : tooltip.onShow,
            onHide: tooltip === null || tooltip === void 0 ? void 0 : tooltip.onHide,
            mousePosition: tooltip === null || tooltip === void 0 ? void 0 : tooltip.mousePosition,
            analyticsContext: tooltip === null || tooltip === void 0 ? void 0 : tooltip.analyticsContext,
            strategy: tooltip === null || tooltip === void 0 ? void 0 : tooltip.strategy,
            tag: tooltip === null || tooltip === void 0 ? void 0 : tooltip.tag,
            truncate: tooltip === null || tooltip === void 0 ? void 0 : tooltip.truncate,
            component: tooltip === null || tooltip === void 0 ? void 0 : tooltip.component,
            hideTooltipOnClick: tooltip === null || tooltip === void 0 ? void 0 : tooltip.hideTooltipOnClick,
            hideTooltipOnMouseDown: tooltip === null || tooltip === void 0 ? void 0 : tooltip.hideTooltipOnMouseDown
        }, function(triggerProps) {
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $j7nj6.default), (0, (/*@__PURE__*/$parcel$interopDefault($8TMbA)))({}, rest, {
                type: type,
                testId: testId,
                componentName: "IconButton",
                analyticsContext: analyticsContext,
                interactionName: interactionName,
                onMouseOver: function onMouseOver(e) {
                    var _triggerProps$onMouse, _rest$onMouseOver;
                    (_triggerProps$onMouse = triggerProps.onMouseOver) === null || _triggerProps$onMouse === void 0 || _triggerProps$onMouse.call(triggerProps, e);
                    (_rest$onMouseOver = rest.onMouseOver) === null || _rest$onMouseOver === void 0 || _rest$onMouseOver.call(rest, e);
                },
                onMouseOut: function onMouseOut(e) {
                    var _triggerProps$onMouse2, _rest$onMouseOut;
                    (_triggerProps$onMouse2 = triggerProps.onMouseOut) === null || _triggerProps$onMouse2 === void 0 || _triggerProps$onMouse2.call(triggerProps, e);
                    (_rest$onMouseOut = rest.onMouseOut) === null || _rest$onMouseOut === void 0 || _rest$onMouseOut.call(rest, e);
                },
                onMouseMove: function onMouseMove(e) {
                    var _triggerProps$onMouse3, _rest$onMouseMove;
                    (_triggerProps$onMouse3 = triggerProps.onMouseMove) === null || _triggerProps$onMouse3 === void 0 || _triggerProps$onMouse3.call(triggerProps, e);
                    (_rest$onMouseMove = rest.onMouseMove) === null || _rest$onMouseMove === void 0 || _rest$onMouseMove.call(rest, e);
                },
                onMouseDown: function onMouseDown(e) {
                    var _triggerProps$onMouse4, _rest$onMouseDown;
                    (_triggerProps$onMouse4 = triggerProps.onMouseDown) === null || _triggerProps$onMouse4 === void 0 || _triggerProps$onMouse4.call(triggerProps, e);
                    (_rest$onMouseDown = rest.onMouseDown) === null || _rest$onMouseDown === void 0 || _rest$onMouseDown.call(rest, e);
                },
                onFocus: function onFocus(e) {
                    var _triggerProps$onFocus, _rest$onFocus;
                    (_triggerProps$onFocus = triggerProps.onFocus) === null || _triggerProps$onFocus === void 0 || _triggerProps$onFocus.call(triggerProps, e);
                    (_rest$onFocus = rest.onFocus) === null || _rest$onFocus === void 0 || _rest$onFocus.call(rest, e);
                },
                onBlur: function onBlur(e) {
                    var _triggerProps$onBlur, _rest$onBlur;
                    (_triggerProps$onBlur = triggerProps.onBlur) === null || _triggerProps$onBlur === void 0 || _triggerProps$onBlur.call(triggerProps, e);
                    (_rest$onBlur = rest.onBlur) === null || _rest$onBlur === void 0 || _rest$onBlur.call(rest, e);
                },
                onClick: function onClick(event, analyticsEvent) {
                    var _baseProps$onClick, _triggerProps$onClick;
                    baseProps === null || baseProps === void 0 || (_baseProps$onClick = baseProps.onClick) === null || _baseProps$onClick === void 0 || _baseProps$onClick.call(baseProps, event, analyticsEvent);
                    triggerProps === null || triggerProps === void 0 || (_triggerProps$onClick = triggerProps.onClick) === null || _triggerProps$onClick === void 0 || _triggerProps$onClick.call(triggerProps, event);
                },
                ref: function ref(_ref2) {
                    var _triggerProps$ref;
                    baseProps.ref(_ref2);
                    triggerProps === null || triggerProps === void 0 || (_triggerProps$ref = triggerProps.ref) === null || _triggerProps$ref === void 0 || _triggerProps$ref.call(triggerProps, _ref2);
                },
                xcss: baseProps.xcss,
                isDisabled: baseProps.isDisabled,
                onMouseDownCapture: baseProps.onMouseDownCapture,
                onMouseUpCapture: baseProps.onMouseUpCapture,
                onKeyDownCapture: baseProps.onKeyDownCapture,
                onKeyUpCapture: baseProps.onKeyUpCapture,
                onTouchStartCapture: baseProps.onTouchStartCapture,
                onTouchEndCapture: baseProps.onTouchEndCapture,
                onPointerDownCapture: baseProps.onPointerDownCapture,
                onPointerUpCapture: baseProps.onPointerUpCapture,
                onClickCapture: baseProps.onClickCapture
            }), baseProps.children);
        });
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $j7nj6.default), (0, (/*@__PURE__*/$parcel$interopDefault($8TMbA)))({}, rest, {
        ref: baseProps.ref,
        xcss: baseProps.xcss,
        isDisabled: baseProps.isDisabled,
        onClick: baseProps.onClick,
        onMouseDownCapture: baseProps.onMouseDownCapture,
        onMouseUpCapture: baseProps.onMouseUpCapture,
        onKeyDownCapture: baseProps.onKeyDownCapture,
        onKeyUpCapture: baseProps.onKeyUpCapture,
        onTouchStartCapture: baseProps.onTouchStartCapture,
        onTouchEndCapture: baseProps.onTouchEndCapture,
        onPointerDownCapture: baseProps.onPointerDownCapture,
        onPointerUpCapture: baseProps.onPointerUpCapture,
        onClickCapture: baseProps.onClickCapture,
        type: type,
        testId: testId,
        componentName: "IconButton",
        analyticsContext: analyticsContext,
        interactionName: interactionName
    }), baseProps.children);
}));
$cb75cd83daa4786c$var$IconButton.displayName = "IconButton";
var $cb75cd83daa4786c$export$2e2bcd8739ae039 = $cb75cd83daa4786c$var$IconButton;

});
parcelRegister("j7nj6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $deb0c00cb1209f26$export$2e2bcd8739ae039; });

var $8TMbA = parcelRequire("8TMbA");

var $k2EOa = parcelRequire("k2EOa");

var $8jzoy = parcelRequire("8jzoy");

var $dAx5m = parcelRequire("dAx5m");

var $jvVvy = parcelRequire("jvVvy");

var $Bb0he = parcelRequire("Bb0he");

var $kqsmh = parcelRequire("kqsmh");

var $aGSBL = parcelRequire("aGSBL");

var $iGrUY = parcelRequire("iGrUY");
var $deb0c00cb1209f26$var$_excluded = [
    "children",
    "backgroundColor",
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    "isDisabled",
    "type",
    "testId",
    "xcss",
    "onClick",
    "interactionName",
    "componentName",
    "analyticsContext"
];
// TODO: Duplicated FocusRing styles due to lack of `xcss` support
// and to prevent additional dependency
var $deb0c00cb1209f26$var$baseFocusRingStyles = {
    outlineColor: "color.border.focused",
    outlineWidth: "border.width.outline",
    outlineStyle: "solid",
    outlineOffset: "space.025"
};
var $deb0c00cb1209f26$var$focusRingStyles = (0, $aGSBL.xcss)({
    ":focus-visible": $deb0c00cb1209f26$var$baseFocusRingStyles,
    "@supports not selector(*:focus-visible)": {
        ":focus": $deb0c00cb1209f26$var$baseFocusRingStyles
    },
    "@media screen and (forced-colors: active), screen and (-ms-high-contrast: active)": {
        ":focus-visible": {
            outline: "1px solid"
        }
    }
});
/**
 * __Pressable__
 *
 * A primitive for building custom buttons.
 *
 * - [Examples](https://atlassian.design/components/primitives/pressable/examples)
 * - [Code](https://atlassian.design/components/primitives/pressable/code)
 * - [Usage](https://atlassian.design/components/primitives/pressable/usage)
 */ var $deb0c00cb1209f26$var$Pressable = /*#__PURE__*/ (0, $dAx5m.forwardRef)(function(_ref, ref) {
    var children = _ref.children, backgroundColor = _ref.backgroundColor, padding = _ref.padding, paddingBlock = _ref.paddingBlock, paddingBlockStart = _ref.paddingBlockStart, paddingBlockEnd = _ref.paddingBlockEnd, paddingInline = _ref.paddingInline, paddingInlineStart = _ref.paddingInlineStart, paddingInlineEnd = _ref.paddingInlineEnd, isDisabled = _ref.isDisabled, _ref$type = _ref.type, type = _ref$type === void 0 ? "button" : _ref$type, testId = _ref.testId, xcssStyles = _ref.xcss, _ref$onClick = _ref.onClick, providedOnClick = _ref$onClick === void 0 ? (0, $Bb0he.default) : _ref$onClick, interactionName = _ref.interactionName, componentName = _ref.componentName, analyticsContext = _ref.analyticsContext, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($8jzoy)))(_ref, $deb0c00cb1209f26$var$_excluded);
    var interactionContext = (0, $dAx5m.useContext)((0, $kqsmh.default));
    var handleClick = (0, $dAx5m.useCallback)(function(e, analyticsEvent) {
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    var onClick = (0, $jvVvy.usePlatformLeafEventHandler)({
        fn: handleClick,
        action: "clicked",
        componentName: componentName || "Pressable",
        packageName: "@atlaskit/primitives",
        packageVersion: "6.3.0",
        analyticsData: analyticsContext,
        actionSubject: "button"
    });
    // Combine default styles with supplied styles. XCSS does not support deep nested arrays
    var styles = [
        (0, $aGSBL.xcss)({
            cursor: isDisabled ? "not-allowed" : "pointer"
        }),
        $deb0c00cb1209f26$var$focusRingStyles
    ];
    // We're type coercing this as Compiled styles in an array isn't supported by the types
    // But the runtime accepts it none-the-wiser. We can remove this entire block and replace
    // it with cx(defaultStyles, focusRingStyles, xcssStyles) when we've moved away from Emotion.
    styles = Array.isArray(xcssStyles) ? [].concat((0, (/*@__PURE__*/$parcel$interopDefault($k2EOa)))(styles), (0, (/*@__PURE__*/$parcel$interopDefault($k2EOa)))(xcssStyles)) : [].concat((0, (/*@__PURE__*/$parcel$interopDefault($k2EOa)))(styles), [
        xcssStyles
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $iGrUY.default), (0, (/*@__PURE__*/$parcel$interopDefault($8TMbA)))({}, htmlAttributes, {
        as: "button",
        ref: ref,
        testId: testId,
        type: type,
        onClick: onClick,
        backgroundColor: backgroundColor,
        padding: padding,
        paddingBlock: paddingBlock,
        paddingBlockStart: paddingBlockStart,
        paddingBlockEnd: paddingBlockEnd,
        paddingInline: paddingInline,
        paddingInlineStart: paddingInlineStart,
        paddingInlineEnd: paddingInlineEnd,
        xcss: styles,
        disabled: isDisabled
    }), children);
});
var $deb0c00cb1209f26$export$2e2bcd8739ae039 = $deb0c00cb1209f26$var$Pressable;

});
parcelRegister("jvVvy", function(module, exports) {

$parcel$export(module.exports, "usePlatformLeafEventHandler", function () { return $e34d856ff55ba84b$export$a4687b0234b40e28; });

var $iDtim = parcelRequire("iDtim");

var $dAx5m = parcelRequire("dAx5m");

var $nLm1R = parcelRequire("nLm1R");

var $CVDHe = parcelRequire("CVDHe");
function $e34d856ff55ba84b$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $e34d856ff55ba84b$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $e34d856ff55ba84b$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($iDtim)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $e34d856ff55ba84b$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $e34d856ff55ba84b$export$a4687b0234b40e28(_ref) {
    var fn = _ref.fn, action = _ref.action, componentName = _ref.componentName, actionSubject = _ref.actionSubject, packageName = _ref.packageName, packageVersion = _ref.packageVersion, analyticsData = _ref.analyticsData;
    var _useAnalyticsEvents = (0, $nLm1R.useAnalyticsEvents)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    // We put analyticsData and fn in a ref so that we don't need to break
    // memoization.
    // Generally these could be defined by consumers inline
    // and so we do this to avoid breaking memoization of useCallback
    var dataRef = (0, $CVDHe.useTrackedRef)(analyticsData);
    var fnRef = (0, $CVDHe.useTrackedRef)(fn);
    var handler = (0, $dAx5m.useCallback)(function(value) {
        var analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: actionSubject || componentName,
            attributes: {
                componentName: componentName,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
        // To avoid wrapping this component in AnalyticsContext we manually
        // push the parent context's meta data into the context.
        // Note: this new 'context'
        var context = $e34d856ff55ba84b$var$_objectSpread({
            componentName: componentName,
            packageName: packageName,
            packageVersion: packageVersion
        }, dataRef.current);
        analyticsEvent.context.push(context);
        // fire an event on the atlaskit channel
        var clone = analyticsEvent.clone();
        if (clone) clone.fire("atlaskit");
        fnRef.current(value, analyticsEvent);
    }, [
        // These are strings and won't change
        action,
        componentName,
        actionSubject,
        packageName,
        packageVersion,
        // This function is memoized in the context
        createAnalyticsEvent,
        // these are a stable ref because of the useTrackedRef hook
        dataRef,
        fnRef
    ]);
    return handler;
}

});

parcelRegister("aGSBL", function(module, exports) {

$parcel$export(module.exports, "parseXcss", function () { return $7c882fae208a62b7$export$a9c84988c8f81f2d; });
$parcel$export(module.exports, "xcss", function () { return $7c882fae208a62b7$export$f6c783d06584602c; });

var $k2EOa = parcelRequire("k2EOa");

var $iDtim = parcelRequire("iDtim");

var $6RxC1 = parcelRequire("6RxC1");

var $jRSpJ = parcelRequire("jRSpJ");

var $jVTBW = parcelRequire("jVTBW");

var $783dw = parcelRequire("783dw");

var $ahJoN = parcelRequire("ahJoN");
function $7c882fae208a62b7$var$_createForOfIteratorHelper(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (!it) {
        if (Array.isArray(o) || (it = $7c882fae208a62b7$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
            if (it) o = it;
            var i = 0;
            var F = function F() {};
            return {
                s: F,
                n: function n() {
                    if (i >= o.length) return {
                        done: true
                    };
                    return {
                        done: false,
                        value: o[i++]
                    };
                },
                e: function e(_e) {
                    throw _e;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var normalCompletion = true, didErr = false, err;
    return {
        s: function s() {
            it = it.call(o);
        },
        n: function n() {
            var step = it.next();
            normalCompletion = step.done;
            return step;
        },
        e: function e(_e2) {
            didErr = true;
            err = _e2;
        },
        f: function f() {
            try {
                if (!normalCompletion && it.return != null) it.return();
            } finally{
                if (didErr) throw err;
            }
        }
    };
}
function $7c882fae208a62b7$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $7c882fae208a62b7$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $7c882fae208a62b7$var$_arrayLikeToArray(o, minLen);
}
function $7c882fae208a62b7$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $7c882fae208a62b7$export$9a199fbafee0014e = {
    backgroundColor: (0, $783dw.backgroundColorMap),
    blockSize: (0, $783dw.dimensionMap),
    borderBlockColor: (0, $783dw.borderColorMap),
    borderBlockEndColor: (0, $783dw.borderColorMap),
    borderBlockEndWidth: (0, $783dw.borderWidthMap),
    borderBlockStartColor: (0, $783dw.borderColorMap),
    borderBlockStartWidth: (0, $783dw.borderWidthMap),
    borderBlockWidth: (0, $783dw.borderWidthMap),
    borderBottomColor: (0, $783dw.borderColorMap),
    borderBottomLeftRadius: (0, $783dw.borderRadiusMap),
    borderBottomRightRadius: (0, $783dw.borderRadiusMap),
    borderBottomWidth: (0, $783dw.borderWidthMap),
    borderColor: (0, $783dw.borderColorMap),
    borderEndEndRadius: (0, $783dw.borderRadiusMap),
    borderEndStartRadius: (0, $783dw.borderRadiusMap),
    borderInlineColor: (0, $783dw.borderColorMap),
    borderInlineEndColor: (0, $783dw.borderColorMap),
    borderInlineEndWidth: (0, $783dw.borderWidthMap),
    borderInlineStartColor: (0, $783dw.borderColorMap),
    borderInlineStartWidth: (0, $783dw.borderWidthMap),
    borderInlineWidth: (0, $783dw.borderWidthMap),
    borderLeftColor: (0, $783dw.borderColorMap),
    borderLeftWidth: (0, $783dw.borderWidthMap),
    borderRadius: (0, $783dw.borderRadiusMap),
    borderRightColor: (0, $783dw.borderColorMap),
    borderRightWidth: (0, $783dw.borderWidthMap),
    borderStartEndRadius: (0, $783dw.borderRadiusMap),
    borderStartStartRadius: (0, $783dw.borderRadiusMap),
    borderTopColor: (0, $783dw.borderColorMap),
    borderTopLeftRadius: (0, $783dw.borderRadiusMap),
    borderTopRightRadius: (0, $783dw.borderRadiusMap),
    borderTopWidth: (0, $783dw.borderWidthMap),
    borderWidth: (0, $783dw.borderWidthMap),
    bottom: (0, $783dw.allSpaceMap),
    boxShadow: (0, $783dw.shadowMap),
    color: (0, $783dw.textColorMap),
    columnGap: (0, $783dw.positiveSpaceMap),
    gap: (0, $783dw.positiveSpaceMap),
    height: (0, $783dw.dimensionMap),
    inlineSize: (0, $783dw.dimensionMap),
    inset: (0, $783dw.allSpaceMap),
    insetBlock: (0, $783dw.allSpaceMap),
    insetBlockEnd: (0, $783dw.allSpaceMap),
    insetBlockStart: (0, $783dw.allSpaceMap),
    insetInline: (0, $783dw.allSpaceMap),
    insetInlineEnd: (0, $783dw.allSpaceMap),
    insetInlineStart: (0, $783dw.allSpaceMap),
    left: (0, $783dw.allSpaceMap),
    margin: (0, $783dw.allSpaceMap),
    marginBlock: (0, $783dw.allSpaceMap),
    marginBlockEnd: (0, $783dw.allSpaceMap),
    marginBlockStart: (0, $783dw.allSpaceMap),
    marginBottom: (0, $783dw.allSpaceMap),
    marginInline: (0, $783dw.allSpaceMap),
    marginInlineEnd: (0, $783dw.allSpaceMap),
    marginInlineStart: (0, $783dw.allSpaceMap),
    marginLeft: (0, $783dw.allSpaceMap),
    marginRight: (0, $783dw.allSpaceMap),
    marginTop: (0, $783dw.allSpaceMap),
    maxBlockSize: (0, $783dw.dimensionMap),
    maxHeight: (0, $783dw.dimensionMap),
    maxInlineSize: (0, $783dw.dimensionMap),
    maxWidth: (0, $783dw.dimensionMap),
    minBlockSize: (0, $783dw.dimensionMap),
    minHeight: (0, $783dw.dimensionMap),
    minInlineSize: (0, $783dw.dimensionMap),
    minWidth: (0, $783dw.dimensionMap),
    opacity: (0, $783dw.opacityMap),
    outlineColor: (0, $783dw.borderColorMap),
    outlineOffset: (0, $783dw.positiveSpaceMap),
    outlineWidth: (0, $783dw.borderWidthMap),
    padding: (0, $783dw.positiveSpaceMap),
    paddingBlock: (0, $783dw.positiveSpaceMap),
    paddingBlockEnd: (0, $783dw.positiveSpaceMap),
    paddingBlockStart: (0, $783dw.positiveSpaceMap),
    paddingBottom: (0, $783dw.positiveSpaceMap),
    paddingInline: (0, $783dw.positiveSpaceMap),
    paddingInlineEnd: (0, $783dw.positiveSpaceMap),
    paddingInlineStart: (0, $783dw.positiveSpaceMap),
    paddingLeft: (0, $783dw.positiveSpaceMap),
    paddingRight: (0, $783dw.positiveSpaceMap),
    paddingTop: (0, $783dw.positiveSpaceMap),
    right: (0, $783dw.allSpaceMap),
    rowGap: (0, $783dw.positiveSpaceMap),
    top: (0, $783dw.allSpaceMap),
    width: (0, $783dw.dimensionMap),
    zIndex: (0, $783dw.layerMap)
};
var $7c882fae208a62b7$var$uniqueSymbol = Symbol("UNSAFE_INTERNAL_styles");
var $7c882fae208a62b7$var$isSafeEnvToThrow = function isSafeEnvToThrow() {
    return (typeof $ahJoN === "undefined" ? "undefined" : (0, (/*@__PURE__*/$parcel$interopDefault($jRSpJ)))($ahJoN)) === "object" && (0, (/*@__PURE__*/$parcel$interopDefault($jRSpJ)))($ahJoN.env) === "object" && false;
};
var $7c882fae208a62b7$var$reNestedSelectors = /(\.|\s|&+|\*\>|#|\[.*\])/;
var $7c882fae208a62b7$var$safeSelectors = /^@media .*$|^::?.*$|^@supports .*$/;
var $7c882fae208a62b7$var$transformStyles = function transformStyles(styleObj) {
    if (!styleObj || (0, (/*@__PURE__*/$parcel$interopDefault($jRSpJ)))(styleObj) !== "object") return styleObj;
    // If styles are defined as a CSSObject[], recursively call on each element until we reach CSSObject
    if (Array.isArray(styleObj)) return styleObj.map(transformStyles);
    // Modifies styleObj in place. Be careful.
    Object.entries(styleObj).forEach(function(_ref) {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($6RxC1)))(_ref, 2), key = _ref2[0], value = _ref2[1];
        // If key is a pseudo class or a pseudo element, then value should be an object.
        // So, call transformStyles on the value
        if ((0, (/*@__PURE__*/$parcel$interopDefault($jRSpJ)))(value) === "object" && $7c882fae208a62b7$var$safeSelectors.test(key)) {
            styleObj[key] = transformStyles(value);
            return;
        }
        if ($7c882fae208a62b7$var$isSafeEnvToThrow()) {
            // We don't support `.class`, `[data-testid]`, `> *`, `#some-id`
            if ($7c882fae208a62b7$var$reNestedSelectors.test(key)) throw new Error("Styles not supported for key '".concat(key, "'."));
        }
        // We have now dealt with all the special cases, so,
        // check whether what remains is a style property
        // that can be transformed.
        if (!(key in $7c882fae208a62b7$export$9a199fbafee0014e)) return;
        var tokenValue = $7c882fae208a62b7$export$9a199fbafee0014e[key][value];
        styleObj[key] = tokenValue !== null && tokenValue !== void 0 ? tokenValue : value;
    });
    return styleObj;
};
var $7c882fae208a62b7$var$baseXcss = function baseXcss(style) {
    var transformedStyles = $7c882fae208a62b7$var$transformStyles(style);
    return (0, (/*@__PURE__*/$parcel$interopDefault($iDtim)))({}, $7c882fae208a62b7$var$uniqueSymbol, (0, $jVTBW.css)(transformedStyles));
};
var $7c882fae208a62b7$export$a9c84988c8f81f2d = function parseXcss(args) {
    if (Array.isArray(args)) {
        var emotion = [];
        var staticArr = [];
        var _iterator = $7c882fae208a62b7$var$_createForOfIteratorHelper(args), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var arg = _step.value;
                var result = parseXcss(arg);
                if (result.emotion) emotion.push.apply(emotion, (0, (/*@__PURE__*/$parcel$interopDefault($k2EOa)))(result.emotion));
                if (result.static) staticArr.push(result.static);
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        return {
            emotion: emotion,
            static: staticArr.join(" ")
        };
    }
    var objArgs = args;
    var _ref4 = objArgs || {}, styles = _ref4[$7c882fae208a62b7$var$uniqueSymbol];
    if (styles) return {
        emotion: [
            styles
        ]
    };
    if (args) {
        // We use string interpolation here instead of .toString() just
        // in case the resulting object doesn't have the method available.
        var stringifiedArgs = "".concat(args);
        if (stringifiedArgs) return {
            static: stringifiedArgs
        };
    }
    return {};
};
function $7c882fae208a62b7$export$f6c783d06584602c(style) {
    return $7c882fae208a62b7$var$baseXcss(style);
}

});
parcelRegister("783dw", function(module, exports) {

$parcel$export(module.exports, "dimensionMap", function () { return $530bc6a13b54af63$export$6ccdbebca2ee545f; });
$parcel$export(module.exports, "positiveSpaceMap", function () { return $530bc6a13b54af63$export$958d0ae7f2977ae4; });
$parcel$export(module.exports, "allSpaceMap", function () { return $530bc6a13b54af63$export$632685d741f3dbbf; });
$parcel$export(module.exports, "opacityMap", function () { return $530bc6a13b54af63$export$daf94a976c798b4f; });
$parcel$export(module.exports, "shadowMap", function () { return $530bc6a13b54af63$export$7aff6e7ba39bb774; });
$parcel$export(module.exports, "borderColorMap", function () { return $530bc6a13b54af63$export$1531ad5bb3fbedac; });
$parcel$export(module.exports, "backgroundColorMap", function () { return $530bc6a13b54af63$export$d1d79bf68ac056bd; });
$parcel$export(module.exports, "textColorMap", function () { return $530bc6a13b54af63$export$8473307aa00d6ea1; });
$parcel$export(module.exports, "layerMap", function () { return $530bc6a13b54af63$export$b5f31a7e431d2eab; });
$parcel$export(module.exports, "borderWidthMap", function () { return $530bc6a13b54af63$export$e1b83c5210c471b8; });
$parcel$export(module.exports, "borderRadiusMap", function () { return $530bc6a13b54af63$export$3c0a6c3e64bb180d; });
$parcel$export(module.exports, "paddingStylesMap", function () { return $530bc6a13b54af63$export$e615f061ca585a6c; });
$parcel$export(module.exports, "backgroundColorStylesMap", function () { return $530bc6a13b54af63$export$e7af83bafe7f9e63; });
$parcel$export(module.exports, "surfaceColorStylesMap", function () { return $530bc6a13b54af63$export$ff257d957d48c421; });
$parcel$export(module.exports, "isSurfaceColorToken", function () { return $530bc6a13b54af63$export$5e65a44e5b6ecadb; });

var $iDtim = parcelRequire("iDtim");

var $jVTBW = parcelRequire("jVTBW");

var $cAXjb = parcelRequire("cAXjb");
function $530bc6a13b54af63$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $530bc6a13b54af63$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $530bc6a13b54af63$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($iDtim)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $530bc6a13b54af63$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $530bc6a13b54af63$export$6ccdbebca2ee545f = {
    "100%": "100%",
    "size.100": "1rem",
    "size.200": "1.5rem",
    "size.300": "2rem",
    "size.400": "2.5rem",
    "size.500": "3rem",
    "size.600": "6rem",
    "size.1000": "12rem"
};
var $530bc6a13b54af63$export$958d0ae7f2977ae4 = {
    "space.0": "var(--ds-space-0, 0px)",
    "space.025": "var(--ds-space-025, 2px)",
    "space.050": "var(--ds-space-050, 4px)",
    "space.075": "var(--ds-space-075, 6px)",
    "space.100": "var(--ds-space-100, 8px)",
    "space.150": "var(--ds-space-150, 12px)",
    "space.200": "var(--ds-space-200, 16px)",
    "space.250": "var(--ds-space-250, 20px)",
    "space.300": "var(--ds-space-300, 24px)",
    "space.400": "var(--ds-space-400, 32px)",
    "space.500": "var(--ds-space-500, 40px)",
    "space.600": "var(--ds-space-600, 48px)",
    "space.800": "var(--ds-space-800, 64px)",
    "space.1000": "var(--ds-space-1000, 80px)"
};
var $530bc6a13b54af63$export$d2dc61f58390201c = {
    "space.negative.025": "var(--ds-space-negative-025, -2px)",
    "space.negative.050": "var(--ds-space-negative-050, -4px)",
    "space.negative.075": "var(--ds-space-negative-075, -6px)",
    "space.negative.100": "var(--ds-space-negative-100, -8px)",
    "space.negative.150": "var(--ds-space-negative-150, -12px)",
    "space.negative.200": "var(--ds-space-negative-200, -16px)",
    "space.negative.250": "var(--ds-space-negative-250, -20px)",
    "space.negative.300": "var(--ds-space-negative-300, -24px)",
    "space.negative.400": "var(--ds-space-negative-400, -32px)"
};
var $530bc6a13b54af63$export$632685d741f3dbbf = $530bc6a13b54af63$var$_objectSpread($530bc6a13b54af63$var$_objectSpread({}, $530bc6a13b54af63$export$958d0ae7f2977ae4), $530bc6a13b54af63$export$d2dc61f58390201c);
var $530bc6a13b54af63$export$2185ce37f9bdd963 = {
    "color.background.neutral.bold": "color.text.inverse",
    "color.background.neutral.bold.hovered": "color.text.inverse",
    "color.background.neutral.bold.pressed": "color.text.inverse",
    "color.background.selected.bold": "color.text.inverse",
    "color.background.selected.bold.hovered": "color.text.inverse",
    "color.background.selected.bold.pressed": "color.text.inverse",
    "color.background.brand.bold": "color.text.inverse",
    "color.background.brand.bold.hovered": "color.text.inverse",
    "color.background.brand.bold.pressed": "color.text.inverse",
    "color.background.brand.boldest": "color.text.inverse",
    "color.background.brand.boldest.hovered": "color.text.inverse",
    "color.background.brand.boldest.pressed": "color.text.inverse",
    "color.background.danger.bold": "color.text.inverse",
    "color.background.danger.bold.hovered": "color.text.inverse",
    "color.background.danger.bold.pressed": "color.text.inverse",
    "color.background.warning.bold": "color.text.warning.inverse",
    "color.background.warning.bold.hovered": "color.text.warning.inverse",
    "color.background.warning.bold.pressed": "color.text.warning.inverse",
    "color.background.success.bold": "color.text.inverse",
    "color.background.success.bold.hovered": "color.text.inverse",
    "color.background.success.bold.pressed": "color.text.inverse",
    "color.background.discovery.bold": "color.text.inverse",
    "color.background.discovery.bold.hovered": "color.text.inverse",
    "color.background.discovery.bold.pressed": "color.text.inverse",
    "color.background.information.bold": "color.text.inverse",
    "color.background.information.bold.hovered": "color.text.inverse",
    "color.background.information.bold.pressed": "color.text.inverse"
};
var $530bc6a13b54af63$export$daf94a976c798b4f = {
    "opacity.disabled": "var(--ds-opacity-disabled, 0.4)",
    "opacity.loading": "var(--ds-opacity-loading, 0.2)"
};
var $530bc6a13b54af63$export$7aff6e7ba39bb774 = {
    "elevation.shadow.overflow": "var(--ds-shadow-overflow, 0px 0px 8px #091e423f, 0px 0px 1px #091e424f)",
    "elevation.shadow.overflow.perimeter": "var(--ds-shadow-overflow-perimeter, #091e421f)",
    "elevation.shadow.overflow.spread": "var(--ds-shadow-overflow-spread, #091e4229)",
    "elevation.shadow.overlay": "var(--ds-shadow-overlay, 0px 8px 12px #091e423f, 0px 0px 1px #091e424f)",
    "elevation.shadow.raised": "var(--ds-shadow-raised, 0px 1px 1px #091e423f, 0px 0px 1px #091e4221)"
};
var $530bc6a13b54af63$export$41a358c9c2356760 = {
    "elevation.surface": "var(--ds-surface, #FFFFFF)",
    "elevation.surface.hovered": "var(--ds-surface-hovered, #FAFBFC)",
    "elevation.surface.pressed": "var(--ds-surface-pressed, #F4F5F7)",
    "elevation.surface.overlay": "var(--ds-surface-overlay, #FFFFFF)",
    "elevation.surface.overlay.hovered": "var(--ds-surface-overlay-hovered, #FAFBFC)",
    "elevation.surface.overlay.pressed": "var(--ds-surface-overlay-pressed, #F4F5F7)",
    "elevation.surface.raised": "var(--ds-surface-raised, #FFFFFF)",
    "elevation.surface.raised.hovered": "var(--ds-surface-raised-hovered, #FAFBFC)",
    "elevation.surface.raised.pressed": "var(--ds-surface-raised-pressed, #F4F5F7)",
    "elevation.surface.sunken": "var(--ds-surface-sunken, #F4F5F7)"
};
var $530bc6a13b54af63$export$1531ad5bb3fbedac = {
    "color.border": "var(--ds-border, #091e4221)",
    "color.border.accent.lime": "var(--ds-border-accent-lime, #6A9A23)",
    "color.border.accent.red": "var(--ds-border-accent-red, #FF5630)",
    "color.border.accent.orange": "var(--ds-border-accent-orange, #D94008)",
    "color.border.accent.yellow": "var(--ds-border-accent-yellow, #FFAB00)",
    "color.border.accent.green": "var(--ds-border-accent-green, #36B37E)",
    "color.border.accent.teal": "var(--ds-border-accent-teal, #00B8D9)",
    "color.border.accent.blue": "var(--ds-border-accent-blue, #0065FF)",
    "color.border.accent.purple": "var(--ds-border-accent-purple, #6554C0)",
    "color.border.accent.magenta": "var(--ds-border-accent-magenta, #CD519D)",
    "color.border.accent.gray": "var(--ds-border-accent-gray, #5E6C84)",
    "color.border.disabled": "var(--ds-border-disabled, #FAFBFC)",
    "color.border.focused": "var(--ds-border-focused, #2684FF)",
    "color.border.input": "var(--ds-border-input, #FAFBFC)",
    "color.border.inverse": "var(--ds-border-inverse, #FFFFFF)",
    "color.border.selected": "var(--ds-border-selected, #0052CC)",
    "color.border.brand": "var(--ds-border-brand, #0052CC)",
    "color.border.danger": "var(--ds-border-danger, #FF5630)",
    "color.border.warning": "var(--ds-border-warning, #FFC400)",
    "color.border.success": "var(--ds-border-success, #00875A)",
    "color.border.discovery": "var(--ds-border-discovery, #998DD9)",
    "color.border.information": "var(--ds-border-information, #0065FF)",
    "color.border.bold": "var(--ds-border-bold, #344563)"
};
var $530bc6a13b54af63$export$d1d79bf68ac056bd = {
    "color.background.accent.lime.subtlest": "var(--ds-background-accent-lime-subtlest, #EEFBDA)",
    "color.background.accent.lime.subtlest.hovered": "var(--ds-background-accent-lime-subtlest-hovered, #D3F1A7)",
    "color.background.accent.lime.subtlest.pressed": "var(--ds-background-accent-lime-subtlest-pressed, #B3DF72)",
    "color.background.accent.lime.subtler": "var(--ds-background-accent-lime-subtler, #D3F1A7)",
    "color.background.accent.lime.subtler.hovered": "var(--ds-background-accent-lime-subtler-hovered, #B3DF72)",
    "color.background.accent.lime.subtler.pressed": "var(--ds-background-accent-lime-subtler-pressed, #94C748)",
    "color.background.accent.lime.subtle": "var(--ds-background-accent-lime-subtle, #94C748)",
    "color.background.accent.lime.subtle.hovered": "var(--ds-background-accent-lime-subtle-hovered, #B3DF72)",
    "color.background.accent.lime.subtle.pressed": "var(--ds-background-accent-lime-subtle-pressed, #D3F1A7)",
    "color.background.accent.lime.bolder": "var(--ds-background-accent-lime-bolder, #5B7F24)",
    "color.background.accent.lime.bolder.hovered": "var(--ds-background-accent-lime-bolder-hovered, #37471F)",
    "color.background.accent.lime.bolder.pressed": "var(--ds-background-accent-lime-bolder-pressed, #37471F)",
    "color.background.accent.red.subtlest": "var(--ds-background-accent-red-subtlest, #FF8F73)",
    "color.background.accent.red.subtlest.hovered": "var(--ds-background-accent-red-subtlest-hovered, #FF7452)",
    "color.background.accent.red.subtlest.pressed": "var(--ds-background-accent-red-subtlest-pressed, #FF5630)",
    "color.background.accent.red.subtler": "var(--ds-background-accent-red-subtler, #FF7452)",
    "color.background.accent.red.subtler.hovered": "var(--ds-background-accent-red-subtler-hovered, #FF5630)",
    "color.background.accent.red.subtler.pressed": "var(--ds-background-accent-red-subtler-pressed, #DE350B)",
    "color.background.accent.red.subtle": "var(--ds-background-accent-red-subtle, #DE350B)",
    "color.background.accent.red.subtle.hovered": "var(--ds-background-accent-red-subtle-hovered, #FF5630)",
    "color.background.accent.red.subtle.pressed": "var(--ds-background-accent-red-subtle-pressed, #FF7452)",
    "color.background.accent.red.bolder": "var(--ds-background-accent-red-bolder, #DE350B)",
    "color.background.accent.red.bolder.hovered": "var(--ds-background-accent-red-bolder-hovered, #FF5630)",
    "color.background.accent.red.bolder.pressed": "var(--ds-background-accent-red-bolder-pressed, #FF7452)",
    "color.background.accent.orange.subtlest": "var(--ds-background-accent-orange-subtlest, #F18D13)",
    "color.background.accent.orange.subtlest.hovered": "var(--ds-background-accent-orange-subtlest-hovered, #FEC57B)",
    "color.background.accent.orange.subtlest.pressed": "var(--ds-background-accent-orange-subtlest-pressed, #FFE2BD)",
    "color.background.accent.orange.subtler": "var(--ds-background-accent-orange-subtler, #B65C02)",
    "color.background.accent.orange.subtler.hovered": "var(--ds-background-accent-orange-subtler-hovered, #F18D13)",
    "color.background.accent.orange.subtler.pressed": "var(--ds-background-accent-orange-subtler-pressed, #FEC57B)",
    "color.background.accent.orange.subtle": "var(--ds-background-accent-orange-subtle, #5F3811)",
    "color.background.accent.orange.subtle.hovered": "var(--ds-background-accent-orange-subtle-hovered, #974F0C)",
    "color.background.accent.orange.subtle.pressed": "var(--ds-background-accent-orange-subtle-pressed, #B65C02)",
    "color.background.accent.orange.bolder": "var(--ds-background-accent-orange-bolder, #43290F)",
    "color.background.accent.orange.bolder.hovered": "var(--ds-background-accent-orange-bolder-hovered, #5F3811)",
    "color.background.accent.orange.bolder.pressed": "var(--ds-background-accent-orange-bolder-pressed, #974F0C)",
    "color.background.accent.yellow.subtlest": "var(--ds-background-accent-yellow-subtlest, #FFE380)",
    "color.background.accent.yellow.subtlest.hovered": "var(--ds-background-accent-yellow-subtlest-hovered, #FFC400)",
    "color.background.accent.yellow.subtlest.pressed": "var(--ds-background-accent-yellow-subtlest-pressed, #FFAB00)",
    "color.background.accent.yellow.subtler": "var(--ds-background-accent-yellow-subtler, #FFC400)",
    "color.background.accent.yellow.subtler.hovered": "var(--ds-background-accent-yellow-subtler-hovered, #FFAB00)",
    "color.background.accent.yellow.subtler.pressed": "var(--ds-background-accent-yellow-subtler-pressed, #FF991F)",
    "color.background.accent.yellow.subtle": "var(--ds-background-accent-yellow-subtle, #FF991F)",
    "color.background.accent.yellow.subtle.hovered": "var(--ds-background-accent-yellow-subtle-hovered, #FFAB00)",
    "color.background.accent.yellow.subtle.pressed": "var(--ds-background-accent-yellow-subtle-pressed, #FFC400)",
    "color.background.accent.yellow.bolder": "var(--ds-background-accent-yellow-bolder, #FF991F)",
    "color.background.accent.yellow.bolder.hovered": "var(--ds-background-accent-yellow-bolder-hovered, #FFAB00)",
    "color.background.accent.yellow.bolder.pressed": "var(--ds-background-accent-yellow-bolder-pressed, #FFC400)",
    "color.background.accent.green.subtlest": "var(--ds-background-accent-green-subtlest, #79F2C0)",
    "color.background.accent.green.subtlest.hovered": "var(--ds-background-accent-green-subtlest-hovered, #57D9A3)",
    "color.background.accent.green.subtlest.pressed": "var(--ds-background-accent-green-subtlest-pressed, #36B37E)",
    "color.background.accent.green.subtler": "var(--ds-background-accent-green-subtler, #57D9A3)",
    "color.background.accent.green.subtler.hovered": "var(--ds-background-accent-green-subtler-hovered, #36B37E)",
    "color.background.accent.green.subtler.pressed": "var(--ds-background-accent-green-subtler-pressed, #00875A)",
    "color.background.accent.green.subtle": "var(--ds-background-accent-green-subtle, #00875A)",
    "color.background.accent.green.subtle.hovered": "var(--ds-background-accent-green-subtle-hovered, #36B37E)",
    "color.background.accent.green.subtle.pressed": "var(--ds-background-accent-green-subtle-pressed, #57D9A3)",
    "color.background.accent.green.bolder": "var(--ds-background-accent-green-bolder, #00875A)",
    "color.background.accent.green.bolder.hovered": "var(--ds-background-accent-green-bolder-hovered, #36B37E)",
    "color.background.accent.green.bolder.pressed": "var(--ds-background-accent-green-bolder-pressed, #57D9A3)",
    "color.background.accent.teal.subtlest": "var(--ds-background-accent-teal-subtlest, #79E2F2)",
    "color.background.accent.teal.subtlest.hovered": "var(--ds-background-accent-teal-subtlest-hovered, #00C7E6)",
    "color.background.accent.teal.subtlest.pressed": "var(--ds-background-accent-teal-subtlest-pressed, #00B8D9)",
    "color.background.accent.teal.subtler": "var(--ds-background-accent-teal-subtler, #00C7E6)",
    "color.background.accent.teal.subtler.hovered": "var(--ds-background-accent-teal-subtler-hovered, #00B8D9)",
    "color.background.accent.teal.subtler.pressed": "var(--ds-background-accent-teal-subtler-pressed, #00A3BF)",
    "color.background.accent.teal.subtle": "var(--ds-background-accent-teal-subtle, #00A3BF)",
    "color.background.accent.teal.subtle.hovered": "var(--ds-background-accent-teal-subtle-hovered, #00B8D9)",
    "color.background.accent.teal.subtle.pressed": "var(--ds-background-accent-teal-subtle-pressed, #00C7E6)",
    "color.background.accent.teal.bolder": "var(--ds-background-accent-teal-bolder, #00A3BF)",
    "color.background.accent.teal.bolder.hovered": "var(--ds-background-accent-teal-bolder-hovered, #00B8D9)",
    "color.background.accent.teal.bolder.pressed": "var(--ds-background-accent-teal-bolder-pressed, #00C7E6)",
    "color.background.accent.blue.subtlest": "var(--ds-background-accent-blue-subtlest, #4C9AFF)",
    "color.background.accent.blue.subtlest.hovered": "var(--ds-background-accent-blue-subtlest-hovered, #2684FF)",
    "color.background.accent.blue.subtlest.pressed": "var(--ds-background-accent-blue-subtlest-pressed, #0065FF)",
    "color.background.accent.blue.subtler": "var(--ds-background-accent-blue-subtler, #2684FF)",
    "color.background.accent.blue.subtler.hovered": "var(--ds-background-accent-blue-subtler-hovered, #0065FF)",
    "color.background.accent.blue.subtler.pressed": "var(--ds-background-accent-blue-subtler-pressed, #0052CC)",
    "color.background.accent.blue.subtle": "var(--ds-background-accent-blue-subtle, #0052CC)",
    "color.background.accent.blue.subtle.hovered": "var(--ds-background-accent-blue-subtle-hovered, #0065FF)",
    "color.background.accent.blue.subtle.pressed": "var(--ds-background-accent-blue-subtle-pressed, #2684FF)",
    "color.background.accent.blue.bolder": "var(--ds-background-accent-blue-bolder, #0052CC)",
    "color.background.accent.blue.bolder.hovered": "var(--ds-background-accent-blue-bolder-hovered, #0065FF)",
    "color.background.accent.blue.bolder.pressed": "var(--ds-background-accent-blue-bolder-pressed, #2684FF)",
    "color.background.accent.purple.subtlest": "var(--ds-background-accent-purple-subtlest, #998DD9)",
    "color.background.accent.purple.subtlest.hovered": "var(--ds-background-accent-purple-subtlest-hovered, #8777D9)",
    "color.background.accent.purple.subtlest.pressed": "var(--ds-background-accent-purple-subtlest-pressed, #6554C0)",
    "color.background.accent.purple.subtler": "var(--ds-background-accent-purple-subtler, #8777D9)",
    "color.background.accent.purple.subtler.hovered": "var(--ds-background-accent-purple-subtler-hovered, #6554C0)",
    "color.background.accent.purple.subtler.pressed": "var(--ds-background-accent-purple-subtler-pressed, #5243AA)",
    "color.background.accent.purple.subtle": "var(--ds-background-accent-purple-subtle, #5243AA)",
    "color.background.accent.purple.subtle.hovered": "var(--ds-background-accent-purple-subtle-hovered, #6554C0)",
    "color.background.accent.purple.subtle.pressed": "var(--ds-background-accent-purple-subtle-pressed, #8777D9)",
    "color.background.accent.purple.bolder": "var(--ds-background-accent-purple-bolder, #5243AA)",
    "color.background.accent.purple.bolder.hovered": "var(--ds-background-accent-purple-bolder-hovered, #6554C0)",
    "color.background.accent.purple.bolder.pressed": "var(--ds-background-accent-purple-bolder-pressed, #8777D9)",
    "color.background.accent.magenta.subtlest": "var(--ds-background-accent-magenta-subtlest, #FFECF8)",
    "color.background.accent.magenta.subtlest.hovered": "var(--ds-background-accent-magenta-subtlest-hovered, #FDD0EC)",
    "color.background.accent.magenta.subtlest.pressed": "var(--ds-background-accent-magenta-subtlest-pressed, #F797D2)",
    "color.background.accent.magenta.subtler": "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
    "color.background.accent.magenta.subtler.hovered": "var(--ds-background-accent-magenta-subtler-hovered, #F797D2)",
    "color.background.accent.magenta.subtler.pressed": "var(--ds-background-accent-magenta-subtler-pressed, #E774BB)",
    "color.background.accent.magenta.subtle": "var(--ds-background-accent-magenta-subtle, #E774BB)",
    "color.background.accent.magenta.subtle.hovered": "var(--ds-background-accent-magenta-subtle-hovered, #F797D2)",
    "color.background.accent.magenta.subtle.pressed": "var(--ds-background-accent-magenta-subtle-pressed, #FDD0EC)",
    "color.background.accent.magenta.bolder": "var(--ds-background-accent-magenta-bolder, #AE4787)",
    "color.background.accent.magenta.bolder.hovered": "var(--ds-background-accent-magenta-bolder-hovered, #943D73)",
    "color.background.accent.magenta.bolder.pressed": "var(--ds-background-accent-magenta-bolder-pressed, #50253F)",
    "color.background.accent.gray.subtlest": "var(--ds-background-accent-gray-subtlest, #6B778C)",
    "color.background.accent.gray.subtlest.hovered": "var(--ds-background-accent-gray-subtlest-hovered, #5E6C84)",
    "color.background.accent.gray.subtlest.pressed": "var(--ds-background-accent-gray-subtlest-pressed, #505F79)",
    "color.background.accent.gray.subtler": "var(--ds-background-accent-gray-subtler, #5E6C84)",
    "color.background.accent.gray.subtler.hovered": "var(--ds-background-accent-gray-subtler-hovered, #505F79)",
    "color.background.accent.gray.subtler.pressed": "var(--ds-background-accent-gray-subtler-pressed, #42526E)",
    "color.background.accent.gray.subtle": "var(--ds-background-accent-gray-subtle, #505F79)",
    "color.background.accent.gray.subtle.hovered": "var(--ds-background-accent-gray-subtle-hovered, #5E6C84)",
    "color.background.accent.gray.subtle.pressed": "var(--ds-background-accent-gray-subtle-pressed, #6B778C)",
    "color.background.accent.gray.bolder": "var(--ds-background-accent-gray-bolder, #42526E)",
    "color.background.accent.gray.bolder.hovered": "var(--ds-background-accent-gray-bolder-hovered, #344563)",
    "color.background.accent.gray.bolder.pressed": "var(--ds-background-accent-gray-bolder-pressed, #253858)",
    "color.background.disabled": "var(--ds-background-disabled, #091e4289)",
    "color.background.input": "var(--ds-background-input, #FAFBFC)",
    "color.background.input.hovered": "var(--ds-background-input-hovered, #EBECF0)",
    "color.background.input.pressed": "var(--ds-background-input-pressed, #FFFFFF)",
    "color.background.inverse.subtle": "var(--ds-background-inverse-subtle, #00000029)",
    "color.background.inverse.subtle.hovered": "var(--ds-background-inverse-subtle-hovered, #0000003D)",
    "color.background.inverse.subtle.pressed": "var(--ds-background-inverse-subtle-pressed, #00000052)",
    "color.background.neutral": "var(--ds-background-neutral, #DFE1E6)",
    "color.background.neutral.hovered": "var(--ds-background-neutral-hovered, #091e4214)",
    "color.background.neutral.pressed": "var(--ds-background-neutral-pressed, #B3D4FF)",
    "color.background.neutral.subtle": "var(--ds-background-neutral-subtle, transparent)",
    "color.background.neutral.subtle.hovered": "var(--ds-background-neutral-subtle-hovered, #091e4214)",
    "color.background.neutral.subtle.pressed": "var(--ds-background-neutral-subtle-pressed, #B3D4FF)",
    "color.background.neutral.bold": "var(--ds-background-neutral-bold, #42526E)",
    "color.background.neutral.bold.hovered": "var(--ds-background-neutral-bold-hovered, #505F79)",
    "color.background.neutral.bold.pressed": "var(--ds-background-neutral-bold-pressed, #344563)",
    "color.background.selected": "var(--ds-background-selected, #DEEBFF)",
    "color.background.selected.hovered": "var(--ds-background-selected-hovered, #B3D4FF)",
    "color.background.selected.pressed": "var(--ds-background-selected-pressed, #4C9AFF)",
    "color.background.selected.bold": "var(--ds-background-selected-bold, #0052CC)",
    "color.background.selected.bold.hovered": "var(--ds-background-selected-bold-hovered, #2684FF)",
    "color.background.selected.bold.pressed": "var(--ds-background-selected-bold-pressed, #0052CC)",
    "color.background.brand.subtlest": "var(--ds-background-brand-subtlest, #B3D4FF)",
    "color.background.brand.subtlest.hovered": "var(--ds-background-brand-subtlest-hovered, #DEEBFF)",
    "color.background.brand.subtlest.pressed": "var(--ds-background-brand-subtlest-pressed, #4C9AFF)",
    "color.background.brand.bold": "var(--ds-background-brand-bold, #0052CC)",
    "color.background.brand.bold.hovered": "var(--ds-background-brand-bold-hovered, #0065FF)",
    "color.background.brand.bold.pressed": "var(--ds-background-brand-bold-pressed, #0747A6)",
    "color.background.brand.boldest": "var(--ds-background-brand-boldest, #0747A6)",
    "color.background.brand.boldest.hovered": "var(--ds-background-brand-boldest-hovered, #0052CC)",
    "color.background.brand.boldest.pressed": "var(--ds-background-brand-boldest-pressed, #0747A6)",
    "color.background.danger": "var(--ds-background-danger, #FFEBE6)",
    "color.background.danger.hovered": "var(--ds-background-danger-hovered, #FFBDAD)",
    "color.background.danger.pressed": "var(--ds-background-danger-pressed, #FF8F73)",
    "color.background.danger.bold": "var(--ds-background-danger-bold, #DE350B)",
    "color.background.danger.bold.hovered": "var(--ds-background-danger-bold-hovered, #FF5630)",
    "color.background.danger.bold.pressed": "var(--ds-background-danger-bold-pressed, #BF2600)",
    "color.background.warning": "var(--ds-background-warning, #FFFAE6)",
    "color.background.warning.hovered": "var(--ds-background-warning-hovered, #FFF0B3)",
    "color.background.warning.pressed": "var(--ds-background-warning-pressed, #FFE380)",
    "color.background.warning.bold": "var(--ds-background-warning-bold, #FFAB00)",
    "color.background.warning.bold.hovered": "var(--ds-background-warning-bold-hovered, #FFC400)",
    "color.background.warning.bold.pressed": "var(--ds-background-warning-bold-pressed, #FF991F)",
    "color.background.success": "var(--ds-background-success, #E3FCEF)",
    "color.background.success.hovered": "var(--ds-background-success-hovered, #ABF5D1)",
    "color.background.success.pressed": "var(--ds-background-success-pressed, #79F2C0)",
    "color.background.success.bold": "var(--ds-background-success-bold, #00875A)",
    "color.background.success.bold.hovered": "var(--ds-background-success-bold-hovered, #57D9A3)",
    "color.background.success.bold.pressed": "var(--ds-background-success-bold-pressed, #00875A)",
    "color.background.discovery": "var(--ds-background-discovery, #EAE6FF)",
    "color.background.discovery.hovered": "var(--ds-background-discovery-hovered, #C0B6F2)",
    "color.background.discovery.pressed": "var(--ds-background-discovery-pressed, #998DD9)",
    "color.background.discovery.bold": "var(--ds-background-discovery-bold, #5243AA)",
    "color.background.discovery.bold.hovered": "var(--ds-background-discovery-bold-hovered, #8777D9)",
    "color.background.discovery.bold.pressed": "var(--ds-background-discovery-bold-pressed, #5243AA)",
    "color.background.information": "var(--ds-background-information, #DEEBFF)",
    "color.background.information.hovered": "var(--ds-background-information-hovered, #B3D4FF)",
    "color.background.information.pressed": "var(--ds-background-information-pressed, #4C9AFF)",
    "color.background.information.bold": "var(--ds-background-information-bold, #0052CC)",
    "color.background.information.bold.hovered": "var(--ds-background-information-bold-hovered, #2684FF)",
    "color.background.information.bold.pressed": "var(--ds-background-information-bold-pressed, #0052CC)",
    "color.blanket": "var(--ds-blanket, #091e4289)",
    "color.blanket.selected": "var(--ds-blanket-selected, #388BFF14)",
    "color.blanket.danger": "var(--ds-blanket-danger, #EF5C4814)",
    "elevation.surface": "var(--ds-surface, #FFFFFF)",
    "elevation.surface.hovered": "var(--ds-surface-hovered, #FAFBFC)",
    "elevation.surface.pressed": "var(--ds-surface-pressed, #F4F5F7)",
    "elevation.surface.overlay": "var(--ds-surface-overlay, #FFFFFF)",
    "elevation.surface.overlay.hovered": "var(--ds-surface-overlay-hovered, #FAFBFC)",
    "elevation.surface.overlay.pressed": "var(--ds-surface-overlay-pressed, #F4F5F7)",
    "elevation.surface.raised": "var(--ds-surface-raised, #FFFFFF)",
    "elevation.surface.raised.hovered": "var(--ds-surface-raised-hovered, #FAFBFC)",
    "elevation.surface.raised.pressed": "var(--ds-surface-raised-pressed, #F4F5F7)",
    "elevation.surface.sunken": "var(--ds-surface-sunken, #F4F5F7)",
    "utility.elevation.surface.current": "var(--ds-elevation-surface-current, #FFFFFF)"
};
var $530bc6a13b54af63$export$8473307aa00d6ea1 = {
    "color.text": "var(--ds-text, #172B4D)",
    "color.text.accent.lime": "var(--ds-text-accent-lime, #4C6B1F)",
    "color.text.accent.lime.bolder": "var(--ds-text-accent-lime-bolder, #37471F)",
    "color.text.accent.red": "var(--ds-text-accent-red, #DE350B)",
    "color.text.accent.red.bolder": "var(--ds-text-accent-red-bolder, #BF2600)",
    "color.text.accent.orange": "var(--ds-text-accent-orange, #F18D13)",
    "color.text.accent.orange.bolder": "var(--ds-text-accent-orange-bolder, #B65C02)",
    "color.text.accent.yellow": "var(--ds-text-accent-yellow, #FF991F)",
    "color.text.accent.yellow.bolder": "var(--ds-text-accent-yellow-bolder, #FF8B00)",
    "color.text.accent.green": "var(--ds-text-accent-green, #00875A)",
    "color.text.accent.green.bolder": "var(--ds-text-accent-green-bolder, #006644)",
    "color.text.accent.teal": "var(--ds-text-accent-teal, #00A3BF)",
    "color.text.accent.teal.bolder": "var(--ds-text-accent-teal-bolder, #008DA6)",
    "color.text.accent.blue": "var(--ds-text-accent-blue, #0052CC)",
    "color.text.accent.blue.bolder": "var(--ds-text-accent-blue-bolder, #0747A6)",
    "color.text.accent.purple": "var(--ds-text-accent-purple, #5243AA)",
    "color.text.accent.purple.bolder": "var(--ds-text-accent-purple-bolder, #403294)",
    "color.text.accent.magenta": "var(--ds-text-accent-magenta, #E774BB)",
    "color.text.accent.magenta.bolder": "var(--ds-text-accent-magenta-bolder, #DA62AC)",
    "color.text.accent.gray": "var(--ds-text-accent-gray, #505F79)",
    "color.text.accent.gray.bolder": "var(--ds-text-accent-gray-bolder, #172B4D)",
    "color.text.disabled": "var(--ds-text-disabled, #A5ADBA)",
    "color.text.inverse": "var(--ds-text-inverse, #FFFFFF)",
    "color.text.selected": "var(--ds-text-selected, #0052CC)",
    "color.text.brand": "var(--ds-text-brand, #0065FF)",
    "color.text.danger": "var(--ds-text-danger, #DE350B)",
    "color.text.warning": "var(--ds-text-warning, #974F0C)",
    "color.text.warning.inverse": "var(--ds-text-warning-inverse, #172B4D)",
    "color.text.success": "var(--ds-text-success, #006644)",
    "color.text.discovery": "var(--ds-text-discovery, #403294)",
    "color.text.information": "var(--ds-text-information, #0052CC)",
    "color.text.subtlest": "var(--ds-text-subtlest, #7A869A)",
    "color.text.subtle": "var(--ds-text-subtle, #42526E)",
    "color.link": "var(--ds-link, #0052CC)",
    "color.link.pressed": "var(--ds-link-pressed, #0747A6)",
    "color.link.visited": "var(--ds-link-visited, #403294)",
    "color.link.visited.pressed": "var(--ds-link-visited-pressed, #403294)"
};
var $530bc6a13b54af63$export$498780f74be9af68 = {
    "color.icon": "var(--ds-icon, #505F79)",
    "color.icon.accent.lime": "var(--ds-icon-accent-lime, #6A9A23)",
    "color.icon.accent.red": "var(--ds-icon-accent-red, #FF5630)",
    "color.icon.accent.orange": "var(--ds-icon-accent-orange, #D94008)",
    "color.icon.accent.yellow": "var(--ds-icon-accent-yellow, #FFAB00)",
    "color.icon.accent.green": "var(--ds-icon-accent-green, #36B37E)",
    "color.icon.accent.teal": "var(--ds-icon-accent-teal, #00B8D9)",
    "color.icon.accent.blue": "var(--ds-icon-accent-blue, #0065FF)",
    "color.icon.accent.purple": "var(--ds-icon-accent-purple, #6554C0)",
    "color.icon.accent.magenta": "var(--ds-icon-accent-magenta, #CD519D)",
    "color.icon.accent.gray": "var(--ds-icon-accent-gray, #5E6C84)",
    "color.icon.disabled": "var(--ds-icon-disabled, #8993A4)",
    "color.icon.inverse": "var(--ds-icon-inverse, #FFFFFF)",
    "color.icon.selected": "var(--ds-icon-selected, #0052CC)",
    "color.icon.brand": "var(--ds-icon-brand, #0065FF)",
    "color.icon.danger": "var(--ds-icon-danger, #DE350B)",
    "color.icon.warning": "var(--ds-icon-warning, #FFC400)",
    "color.icon.warning.inverse": "var(--ds-icon-warning-inverse, #253858)",
    "color.icon.success": "var(--ds-icon-success, #00875A)",
    "color.icon.discovery": "var(--ds-icon-discovery, #8777D9)",
    "color.icon.information": "var(--ds-icon-information, #0747A6)",
    "color.icon.subtle": "var(--ds-icon-subtle, #6B778C)"
};
var $530bc6a13b54af63$export$b5f31a7e431d2eab = {
    card: 100,
    navigation: 200,
    dialog: 300,
    layer: 400,
    blanket: 500,
    modal: 510,
    flag: 600,
    spotlight: 700,
    tooltip: 800
};
var $530bc6a13b54af63$export$e1b83c5210c471b8 = {
    "border.width": "var(--ds-border-width, 1px)",
    "border.width.0": "var(--ds-border-width-0, 0px)",
    "border.width.indicator": "var(--ds-border-width-indicator, 3px)",
    "border.width.outline": "var(--ds-border-width-outline, 2px)"
};
var $530bc6a13b54af63$export$3c0a6c3e64bb180d = {
    "border.radius.050": "var(--ds-border-radius-050, 2px)",
    "border.radius": "var(--ds-border-radius, 3px)",
    "border.radius.100": "var(--ds-border-radius-100, 3px)",
    "border.radius.200": "var(--ds-border-radius-200, 8px)",
    "border.radius.300": "var(--ds-border-radius-300, 12px)",
    "border.radius.400": "var(--ds-border-radius-400, 16px)",
    "border.radius.circle": "var(--ds-border-radius-circle, 32032px)"
};
var $530bc6a13b54af63$export$6cc560b4dedf3816 = {
    medium: 'var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    UNSAFE_small: 'var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    large: 'var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    small: 'var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)'
};
var $530bc6a13b54af63$export$303e322c6b1ed114 = {
    bold: "var(--ds-font-weight-bold, 700)",
    medium: "var(--ds-font-weight-medium, 500)",
    regular: "var(--ds-font-weight-regular, 400)",
    semibold: "var(--ds-font-weight-semibold, 600)"
};
var $530bc6a13b54af63$export$3c7e9587132614b4 = {
    "font.family.body": 'var(--ds-font-family-body, ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.family.brand.body": 'var(--ds-font-family-brand-body, "Charlie Text", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.family.brand.heading": 'var(--ds-font-family-brand-heading, "Charlie Display", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.family.code": 'var(--ds-font-family-code, ui-monospace, Menlo, "Segoe UI Mono", "Ubuntu Mono", monospace)',
    "font.family.heading": 'var(--ds-font-family-heading, ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)'
};
/**
 * @codegenEnd
 */ // Generate maps for Box props. backgroundColor, padding, etc
var $530bc6a13b54af63$var$spacingProperties = [
    // Used by Box
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    // Used by Inline and Stack
    "gap",
    "rowGap",
    "columnGap"
];
var $530bc6a13b54af63$var$getSerializedStylesMap = function getSerializedStylesMap(cssProperty, tokenMap) {
    return Object.keys(tokenMap).reduce(function(emotionSpacingMap, token) {
        emotionSpacingMap[token] = (0, $jVTBW.css)((0, (/*@__PURE__*/$parcel$interopDefault($iDtim)))({}, cssProperty, tokenMap[token]));
        return emotionSpacingMap;
    }, {});
};
var $530bc6a13b54af63$export$e615f061ca585a6c = $530bc6a13b54af63$var$spacingProperties.reduce(function(styleMap, spacingProperty) {
    styleMap[spacingProperty] = $530bc6a13b54af63$var$getSerializedStylesMap(spacingProperty, $530bc6a13b54af63$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
var $530bc6a13b54af63$export$bf46c3f9eeafc71f = $530bc6a13b54af63$var$spacingProperties.reduce(function(styleMap, spacingProperty) {
    styleMap[spacingProperty] = $530bc6a13b54af63$var$getSerializedStylesMap(spacingProperty, $530bc6a13b54af63$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
var $530bc6a13b54af63$export$e7af83bafe7f9e63 = $530bc6a13b54af63$var$getSerializedStylesMap("backgroundColor", $530bc6a13b54af63$export$d1d79bf68ac056bd);
var $530bc6a13b54af63$export$3a1bcba60b23d7f0 = $530bc6a13b54af63$var$getSerializedStylesMap("color", $530bc6a13b54af63$export$8473307aa00d6ea1);
var $530bc6a13b54af63$export$45f3f4fe16f9f7d5 = $530bc6a13b54af63$var$getSerializedStylesMap("fontWeight", $530bc6a13b54af63$export$303e322c6b1ed114);
var $530bc6a13b54af63$export$68cc305da27dbaa4 = $530bc6a13b54af63$var$getSerializedStylesMap("fontFamily", $530bc6a13b54af63$export$3c7e9587132614b4);
var $530bc6a13b54af63$export$128f10c238242f83 = $530bc6a13b54af63$var$getSerializedStylesMap("font", $530bc6a13b54af63$export$6cc560b4dedf3816);
var $530bc6a13b54af63$export$ff257d957d48c421 = $530bc6a13b54af63$var$getSerializedStylesMap((0, $cAXjb.CURRENT_SURFACE_CSS_VAR), $530bc6a13b54af63$export$41a358c9c2356760);
var $530bc6a13b54af63$export$5e65a44e5b6ecadb = function isSurfaceColorToken(color) {
    return $530bc6a13b54af63$export$41a358c9c2356760[color] !== undefined;
};

});
parcelRegister("cAXjb", function(module, exports) {

$parcel$export(module.exports, "CURRENT_SURFACE_CSS_VAR", function () { return $92b6da4475f0451f$export$9d7b58831ae93caa; });
var $92b6da4475f0451f$export$4ef52930e33717cd = "data-theme";
var $92b6da4475f0451f$export$a00eac3f8684bcd0 = "data-color-mode";
var $92b6da4475f0451f$export$2112803007239c61 = "data-contrast-mode";
var $92b6da4475f0451f$export$352e418ed5b6193a = "data-custom-theme";
var $92b6da4475f0451f$export$2faeed762aac6741 = "light";
var $92b6da4475f0451f$export$6f0c6fb8c80fcc92 = "ds";
var $92b6da4475f0451f$export$4d0c7bbf80185957 = [
    "opacity",
    "font",
    "space",
    "border"
];
var $92b6da4475f0451f$export$dddac1532e822863 = "--".concat($92b6da4475f0451f$export$6f0c6fb8c80fcc92, "-token-not-found");
var $92b6da4475f0451f$export$9d7b58831ae93caa = "--".concat($92b6da4475f0451f$export$6f0c6fb8c80fcc92, "-elevation-surface-current");

});



parcelRegister("iGrUY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d9a1ce2b389466a7$export$2e2bcd8739ae039; });

var $8TMbA = parcelRequire("8TMbA");

var $8jzoy = parcelRequire("8jzoy");

var $dAx5m = parcelRequire("dAx5m");

var $jVTBW = parcelRequire("jVTBW");

var $783dw = parcelRequire("783dw");

var $aGSBL = parcelRequire("aGSBL");

var $69jou = parcelRequire("69jou");
var $d9a1ce2b389466a7$var$_excluded = [
    "as",
    "children",
    "backgroundColor",
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    "style",
    "testId",
    "xcss"
], $d9a1ce2b389466a7$var$_excluded2 = [
    "className"
];
var $d9a1ce2b389466a7$export$e71c4d32a2263218 = /*#__PURE__*/ (0, $dAx5m.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? "div" : _ref$as, children = _ref.children, backgroundColor = _ref.backgroundColor, padding = _ref.padding, paddingBlock = _ref.paddingBlock, paddingBlockStart = _ref.paddingBlockStart, paddingBlockEnd = _ref.paddingBlockEnd, paddingInline = _ref.paddingInline, paddingInlineStart = _ref.paddingInlineStart, paddingInlineEnd = _ref.paddingInlineEnd, style = _ref.style, testId = _ref.testId, xcss = _ref.xcss, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($8jzoy)))(_ref, $d9a1ce2b389466a7$var$_excluded);
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($8jzoy)))(htmlAttributes, $d9a1ce2b389466a7$var$_excluded2);
    var resolvedStyles = (0, $aGSBL.parseXcss)(xcss);
    var node = // @ts-expect-error Expression produces a union type that is too complex to represent. I think this is unavoidable
    (0, $jVTBW.jsx)(Component, (0, (/*@__PURE__*/$parcel$interopDefault($8TMbA)))({
        style: style,
        ref: ref,
        className: resolvedStyles.static
    }, safeHtmlAttributes, {
        css: [
            $d9a1ce2b389466a7$var$baseStyles,
            backgroundColor && (0, $783dw.backgroundColorStylesMap)[backgroundColor],
            (0, $783dw.isSurfaceColorToken)(backgroundColor) && (0, $783dw.surfaceColorStylesMap)[backgroundColor],
            padding && (0, $783dw.paddingStylesMap).padding[padding],
            paddingBlock && (0, $783dw.paddingStylesMap).paddingBlock[paddingBlock],
            paddingBlockStart && (0, $783dw.paddingStylesMap).paddingBlockStart[paddingBlockStart],
            paddingBlockEnd && (0, $783dw.paddingStylesMap).paddingBlockEnd[paddingBlockEnd],
            paddingInline && (0, $783dw.paddingStylesMap).paddingInline[paddingInline],
            paddingInlineStart && (0, $783dw.paddingStylesMap).paddingInlineStart[paddingInlineStart],
            paddingInlineEnd && (0, $783dw.paddingStylesMap).paddingInlineEnd[paddingInlineEnd],
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
            resolvedStyles.emotion
        ],
        "data-testid": testId
    }), children);
    return backgroundColor ? (0, $jVTBW.jsx)((0, $69jou.SurfaceContext).Provider, {
        value: backgroundColor
    }, node) : node;
});
var $d9a1ce2b389466a7$export$2e2bcd8739ae039 = $d9a1ce2b389466a7$export$e71c4d32a2263218;
var $d9a1ce2b389466a7$var$baseStyles = (0, $jVTBW.css)({
    boxSizing: "border-box",
    appearance: "none",
    border: "none"
});

});
parcelRegister("69jou", function(module, exports) {

$parcel$export(module.exports, "SurfaceContext", function () { return $47a2a09b8acf3f5e$export$1ca2a26fecb070ae; });

var $dAx5m = parcelRequire("dAx5m");
var $47a2a09b8acf3f5e$export$1ca2a26fecb070ae = /*#__PURE__*/ (0, $dAx5m.createContext)("elevation.surface");
var $47a2a09b8acf3f5e$export$1aeb4f6b93c4540d = function useSurface() {
    return (0, $dAx5m.useContext)($47a2a09b8acf3f5e$export$1ca2a26fecb070ae);
};
$47a2a09b8acf3f5e$export$1ca2a26fecb070ae.displayName = "SurfaceProvider";

});



parcelRegister("9FYbu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $70b6a0bb45278d32$export$2e2bcd8739ae039; });

var $8TMbA = parcelRequire("8TMbA");

var $6RxC1 = parcelRequire("6RxC1");

var $iDtim = parcelRequire("iDtim");

var $dAx5m = parcelRequire("dAx5m");

var $dd4sf = parcelRequire("dd4sf");

var $8oPSU = parcelRequire("8oPSU");

var $Bb0he = parcelRequire("Bb0he");

var $6Oq6X = parcelRequire("6Oq6X");

var $cX24d = parcelRequire("cX24d");
var $3R3i6 = parcelRequire("3R3i6");

var $a6gax = parcelRequire("a6gax");

var $gbM0g = parcelRequire("gbM0g");

var $azbnm = parcelRequire("azbnm");

var $hrGjC = parcelRequire("hrGjC");

var $chd6R = parcelRequire("chd6R");

var $lBNBW = parcelRequire("lBNBW");

var $5niz9 = parcelRequire("5niz9");

var $f5p8F = parcelRequire("f5p8F");

var $6HRoa = parcelRequire("6HRoa");
function $70b6a0bb45278d32$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $70b6a0bb45278d32$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $70b6a0bb45278d32$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($iDtim)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $70b6a0bb45278d32$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $70b6a0bb45278d32$var$tooltipZIndex = (0, $hrGjC.layers).tooltip();
var $70b6a0bb45278d32$var$analyticsAttributes = {
    componentName: "tooltip",
    packageName: "@atlaskit/tooltip",
    packageVersion: "18.5.1"
};
// Inverts motion direction
var $70b6a0bb45278d32$var$invertedDirection = {
    top: "bottom",
    bottom: "top",
    left: "right",
    right: "left"
};
/**
 * Converts a Popper placement to it's general direction.
 *
 * @param placement - Popper Placement value, e.g. 'top-start'
 * @returns Popper Direction, e.g. 'top'
 */ var $70b6a0bb45278d32$var$getDirectionFromPlacement = function getDirectionFromPlacement(placement) {
    return placement.split("-")[0];
};
function $70b6a0bb45278d32$var$Tooltip(_ref) {
    var children = _ref.children, _ref$position = _ref.position, position = _ref$position === void 0 ? "bottom" : _ref$position, _ref$mousePosition = _ref.mousePosition, mousePosition = _ref$mousePosition === void 0 ? "bottom" : _ref$mousePosition, content = _ref.content, _ref$truncate = _ref.truncate, truncate = _ref$truncate === void 0 ? false : _ref$truncate, _ref$component = _ref.component, Container = _ref$component === void 0 ? (0, $f5p8F.default) : _ref$component, _ref$tag = _ref.tag, TargetContainer = _ref$tag === void 0 ? "div" : _ref$tag, testId = _ref.testId, _ref$delay = _ref.delay, delay = _ref$delay === void 0 ? 300 : _ref$delay, _ref$onShow = _ref.onShow, onShow = _ref$onShow === void 0 ? (0, $Bb0he.default) : _ref$onShow, _ref$onHide = _ref.onHide, onHide = _ref$onHide === void 0 ? (0, $Bb0he.default) : _ref$onHide, _ref$hideTooltipOnCli = _ref.hideTooltipOnClick, hideTooltipOnClick = _ref$hideTooltipOnCli === void 0 ? false : _ref$hideTooltipOnCli, _ref$hideTooltipOnMou = _ref.hideTooltipOnMouseDown, hideTooltipOnMouseDown = _ref$hideTooltipOnMou === void 0 ? false : _ref$hideTooltipOnMou, analyticsContext = _ref.analyticsContext, _ref$strategy = _ref.strategy, strategy = _ref$strategy === void 0 ? "fixed" : _ref$strategy, _ref$ignoreTooltipPoi = _ref.ignoreTooltipPointerEvents, ignoreTooltipPointerEvents = _ref$ignoreTooltipPoi === void 0 ? false : _ref$ignoreTooltipPoi;
    var tooltipPosition = position === "mouse" ? mousePosition : position;
    var onShowHandler = (0, $8oPSU.usePlatformLeafSyntheticEventHandler)($70b6a0bb45278d32$var$_objectSpread({
        fn: onShow,
        action: "displayed",
        analyticsData: analyticsContext
    }, $70b6a0bb45278d32$var$analyticsAttributes));
    var onHideHandler = (0, $8oPSU.usePlatformLeafSyntheticEventHandler)($70b6a0bb45278d32$var$_objectSpread({
        fn: onHide,
        action: "hidden",
        analyticsData: analyticsContext
    }, $70b6a0bb45278d32$var$analyticsAttributes));
    var apiRef = (0, $dAx5m.useRef)(null);
    var _useState = (0, $dAx5m.useState)("hide"), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($6RxC1)))(_useState, 2), state = _useState2[0], setState = _useState2[1];
    var targetRef = (0, $dAx5m.useRef)(null);
    var containerRef = (0, $dAx5m.useRef)(null);
    // This function is deliberately _not_ memoized as it needs to re-run every render
    // to pick up any child ref changes. If you use render props you don't have this issue.
    var setImplicitRefFromChildren = function setImplicitRefFromChildren(node) {
        containerRef.current = node;
        targetRef.current = node ? node.firstElementChild : null;
    };
    // This is memoized and passed into the render props callback.
    var setDirectRef = (0, $dAx5m.useCallback)(function(node) {
        targetRef.current = node;
    }, []);
    // Putting a few things into refs so that we don't have to break memoization
    var lastState = (0, $dAx5m.useRef)(state);
    var lastDelay = (0, $dAx5m.useRef)(delay);
    var lastHandlers = (0, $dAx5m.useRef)({
        onShowHandler: onShowHandler,
        onHideHandler: onHideHandler
    });
    var hasCalledShowHandler = (0, $dAx5m.useRef)(false);
    (0, $dAx5m.useEffect)(function() {
        lastState.current = state;
        lastDelay.current = delay;
        lastHandlers.current = {
            onShowHandler: onShowHandler,
            onHideHandler: onHideHandler
        };
    }, [
        delay,
        onHideHandler,
        onShowHandler,
        state
    ]);
    var start = (0, $dAx5m.useCallback)(function(api) {
        // @ts-ignore
        apiRef.current = api;
        hasCalledShowHandler.current = false;
    }, []);
    var done = (0, $dAx5m.useCallback)(function() {
        if (!apiRef.current) return;
        // Only call onHideHandler if we have called onShowHandler
        if (hasCalledShowHandler.current) lastHandlers.current.onHideHandler();
        // @ts-ignore
        apiRef.current = null;
        // @ts-ignore
        hasCalledShowHandler.current = false;
        // just in case
        setState("hide");
    }, []);
    var abort = (0, $dAx5m.useCallback)(function() {
        if (!apiRef.current) return;
        apiRef.current.abort();
        // Only call onHideHandler if we have called onShowHandler
        if (hasCalledShowHandler.current) lastHandlers.current.onHideHandler();
        // @ts-ignore
        apiRef.current = null;
    }, []);
    (0, $dAx5m.useEffect)(function mount() {
        return function unmount() {
            if (apiRef.current) abort();
        };
    }, [
        abort
    ]);
    var isDraggingRef = (0, $dAx5m.useRef)(false);
    (0, $dAx5m.useEffect)(function() {
        return (0, $chd6R.register)({
            onRegister: function onRegister(_ref2) {
                var isDragging = _ref2.isDragging;
                isDraggingRef.current = isDragging;
            },
            onDragStart: function onDragStart() {
                var _apiRef$current;
                /**
         * Hiding any visible tooltips when a drag starts because otherwise it
         * looks janky (disappears and reappears), and is not required.
         */ (_apiRef$current = apiRef.current) === null || _apiRef$current === void 0 || _apiRef$current.requestHide({
                    isImmediate: true
                });
                isDraggingRef.current = true;
            },
            onDragEnd: function onDragEnd() {
                isDraggingRef.current = false;
            }
        });
    }, []);
    var showTooltip = (0, $dAx5m.useCallback)(function(source) {
        /**
     * Prevent tooltips from being shown during a drag. This can occur with
     * the native drag and drop API, where some pointer events can fire
     * when they should not and lead to jank with tooltips.
     */ if (isDraggingRef.current) return;
        if (apiRef.current && !apiRef.current.isActive()) abort();
        // Tell the tooltip to keep showing
        if (apiRef.current && apiRef.current.isActive()) {
            apiRef.current.keep();
            return;
        }
        var entry = {
            source: source,
            delay: lastDelay.current,
            show: function show(_ref3) {
                var isImmediate = _ref3.isImmediate;
                // Call the onShow handler if it hasn't been called yet
                if (!hasCalledShowHandler.current) {
                    hasCalledShowHandler.current = true;
                    lastHandlers.current.onShowHandler();
                }
                setState(isImmediate ? "show-immediate" : "fade-in");
            },
            hide: function hide(_ref4) {
                var isImmediate = _ref4.isImmediate;
                if (isImmediate) setState("hide");
                else setState("before-fade-out");
            },
            done: done
        };
        var api = (0, $lBNBW.show)(entry);
        start(api);
    }, [
        abort,
        done,
        start
    ]);
    var hideTooltipOnEsc = (0, $dAx5m.useCallback)(function() {
        var _apiRef$current2;
        (_apiRef$current2 = apiRef.current) === null || _apiRef$current2 === void 0 || _apiRef$current2.requestHide({
            isImmediate: true
        });
    }, [
        apiRef
    ]);
    (0, $6Oq6X.default)({
        onClose: hideTooltipOnEsc,
        isDisabled: state === "hide" || state === "fade-out"
    });
    (0, $dAx5m.useEffect)(function() {
        if (state === "hide") return 0, $Bb0he.default;
        if (state === "before-fade-out") setState("fade-out");
        var unbind = (0, $dd4sf.bind)(window, {
            type: "scroll",
            listener: function listener() {
                if (apiRef.current) apiRef.current.requestHide({
                    isImmediate: true
                });
            },
            options: {
                capture: true,
                passive: true,
                once: true
            }
        });
        return unbind;
    }, [
        state
    ]);
    var onMouseDown = (0, $dAx5m.useCallback)(function() {
        if (hideTooltipOnMouseDown && apiRef.current) apiRef.current.requestHide({
            isImmediate: true
        });
    }, [
        hideTooltipOnMouseDown
    ]);
    var onClick = (0, $dAx5m.useCallback)(function() {
        if (hideTooltipOnClick && apiRef.current) apiRef.current.requestHide({
            isImmediate: true
        });
    }, [
        hideTooltipOnClick
    ]);
    // Ideally we would be using onMouseEnter here, but
    // because we are binding the event to the target parent
    // we need to listen for the mouseover of all sub elements
    // This means when moving along a tooltip we are quickly toggling
    // between api.requestHide and api.keep. This it not ideal
    var onMouseOver = (0, $dAx5m.useCallback)(function(event) {
        // Ignoring events from the container ref
        if (containerRef.current && event.target === containerRef.current) return;
        // Using prevent default as a signal that parent tooltips
        if (event.defaultPrevented) return;
        event.preventDefault();
        var source = position === "mouse" ? {
            type: "mouse",
            // TODO: ideally not recalculating this object each time
            mouse: (0, $6HRoa.getMousePosition)({
                left: event.clientX,
                top: event.clientY
            })
        } : {
            type: "keyboard"
        };
        showTooltip(source);
    }, [
        position,
        showTooltip
    ]);
    // Ideally we would be using onMouseEnter here, but
    // because we are binding the event to the target parent
    // we need to listen for the mouseout of all sub elements
    // This means when moving along a tooltip we are quickly toggling
    // between api.requestHide and api.keep. This it not ideal
    var onMouseOut = (0, $dAx5m.useCallback)(function(event) {
        // Ignoring events from the container ref
        if (containerRef.current && event.target === containerRef.current) return;
        // Using prevent default as a signal that parent tooltips
        if (event.defaultPrevented) return;
        event.preventDefault();
        if (apiRef.current) apiRef.current.requestHide({
            isImmediate: false
        });
    }, []);
    var onMouseMove = position === "mouse" ? function(event) {
        var _apiRef$current3;
        if ((_apiRef$current3 = apiRef.current) !== null && _apiRef$current3 !== void 0 && _apiRef$current3.isActive()) apiRef.current.mousePosition = (0, $6HRoa.getMousePosition)({
            left: event.clientX,
            top: event.clientY
        });
    } : undefined;
    var onMouseOverTooltip = (0, $dAx5m.useCallback)(function() {
        if (apiRef.current && apiRef.current.isActive()) {
            apiRef.current.keep();
            return;
        }
    }, []);
    var onFocus = (0, $dAx5m.useCallback)(function() {
        showTooltip({
            type: "keyboard"
        });
    }, [
        showTooltip
    ]);
    var onBlur = (0, $dAx5m.useCallback)(function() {
        if (apiRef.current) apiRef.current.requestHide({
            isImmediate: false
        });
    }, []);
    var onAnimationFinished = (0, $dAx5m.useCallback)(function(transition) {
        // Using lastState here because motion is not picking up the latest value
        if (transition === "exiting" && lastState.current === "fade-out" && apiRef.current) // @ts-ignore: refs are writeable
        apiRef.current.finishHideAnimation();
    }, []);
    // Doing a cast because typescript is struggling to narrow the type
    var CastTargetContainer = TargetContainer;
    var shouldRenderTooltipContainer = state !== "hide" && Boolean(content);
    var shouldRenderTooltipChildren = state !== "hide" && state !== "fade-out";
    var getReferenceElement = function getReferenceElement() {
        var _apiRef$current4;
        if (position === "mouse" && (_apiRef$current4 = apiRef.current) !== null && _apiRef$current4 !== void 0 && _apiRef$current4.mousePosition) {
            var _apiRef$current5;
            return (_apiRef$current5 = apiRef.current) === null || _apiRef$current5 === void 0 ? void 0 : _apiRef$current5.mousePosition;
        }
        return targetRef.current || undefined;
    };
    var tooltipId = (0, $5niz9.default)("tooltip", shouldRenderTooltipContainer);
    var tooltipTriggerProps = {
        onMouseOver: onMouseOver,
        onMouseOut: onMouseOut,
        onMouseMove: onMouseMove,
        onMouseDown: onMouseDown,
        onClick: onClick,
        onFocus: onFocus,
        onBlur: onBlur
    };
    // Don't set `data-testid` unless it's defined, as it's not in the interface.
    if (testId) // @ts-expect-error - Adding `data-testid` to the TriggerProps interface breaks Buttons.
    tooltipTriggerProps["data-testid"] = "".concat(testId, "--container");
    // This useEffect is purely for managing the aria attribute when using the
    // wrapped children approach.
    (0, $dAx5m.useEffect)(function() {
        // If there is no container element, we should exit early, because that
        // means they are using the render prop API, and that is implemented in a
        // different way. If there is no target element yet or tooltipId, we also
        // shouldn't do anything because there is nothing to operate on or with.
        if (!containerRef.current || !targetRef.current || !tooltipId) return;
        var target = targetRef.current;
        if (shouldRenderTooltipContainer) target.setAttribute("aria-describedby", tooltipId);
        else target.removeAttribute("aria-describedby");
    }, [
        shouldRenderTooltipContainer,
        tooltipId
    ]);
    var hiddenContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement("span", {
        "data-testid": testId ? "".concat(testId, "-hidden") : undefined,
        hidden: true,
        id: tooltipId
    }, typeof content === "function" ? content({}) : content);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).Fragment, null, typeof children === "function" ? /*#__PURE__*/ // once we deprecate the wrapped approach, we can put the aria
    // attribute back into the tooltipTriggerProps and make it required
    // instead of optional in `types`
    (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).Fragment, null, children($70b6a0bb45278d32$var$_objectSpread($70b6a0bb45278d32$var$_objectSpread({}, tooltipTriggerProps), {}, {
        "aria-describedby": tooltipId,
        ref: setDirectRef
    })), shouldRenderTooltipContainer && hiddenContent) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement(CastTargetContainer, (0, (/*@__PURE__*/$parcel$interopDefault($8TMbA)))({}, tooltipTriggerProps, {
        ref: setImplicitRefFromChildren,
        role: "presentation"
    }), children, shouldRenderTooltipContainer && hiddenContent), shouldRenderTooltipContainer ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $azbnm.default), {
        zIndex: $70b6a0bb45278d32$var$tooltipZIndex
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $gbM0g.Popper), {
        placement: tooltipPosition,
        referenceElement: getReferenceElement(),
        strategy: strategy
    }, function(_ref5) {
        var ref = _ref5.ref, style = _ref5.style, update = _ref5.update, placement = _ref5.placement;
        // Invert the entrance and exit directions.
        // E.g. a tooltip's position is on the 'right', it should enter from and exit to the 'left'
        // This gives the effect the tooltip is appearing from the target
        var direction = position === "mouse" ? undefined : $70b6a0bb45278d32$var$invertedDirection[$70b6a0bb45278d32$var$getDirectionFromPlacement(placement)];
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $cX24d.default), {
            appear: true
        }, shouldRenderTooltipChildren && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $3R3i6.default), {
            distance: "constant",
            entranceDirection: direction,
            exitDirection: direction,
            onFinish: onAnimationFinished,
            duration: state === "show-immediate" ? 0 : (0, $a6gax.mediumDurationMs)
        }, function(_ref6) {
            var className = _ref6.className;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement(Container, {
                ref: ref,
                className: "Tooltip ".concat(className),
                style: $70b6a0bb45278d32$var$_objectSpread($70b6a0bb45278d32$var$_objectSpread({}, style), ignoreTooltipPointerEvents && {
                    pointerEvents: "none"
                }),
                truncate: truncate,
                placement: tooltipPosition,
                testId: getReferenceElement() ? testId : testId && "".concat(testId, "--unresolved"),
                onMouseOut: onMouseOut,
                onMouseOver: onMouseOverTooltip
            }, typeof content === "function" ? content({
                update: update
            }) : content);
        }));
    })) : null);
}
$70b6a0bb45278d32$var$Tooltip.displayName = "Tooltip";
var $70b6a0bb45278d32$export$2e2bcd8739ae039 = $70b6a0bb45278d32$var$Tooltip;

});
parcelRegister("8oPSU", function(module, exports) {

$parcel$export(module.exports, "usePlatformLeafSyntheticEventHandler", function () { return $61d8cfd9773fd749$export$1a04351537078b55; });

var $iDtim = parcelRequire("iDtim");

var $dAx5m = parcelRequire("dAx5m");

var $nLm1R = parcelRequire("nLm1R");

var $CVDHe = parcelRequire("CVDHe");
function $61d8cfd9773fd749$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $61d8cfd9773fd749$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $61d8cfd9773fd749$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($iDtim)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $61d8cfd9773fd749$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $61d8cfd9773fd749$export$1a04351537078b55(_ref) {
    var fn = _ref.fn, action = _ref.action, componentName = _ref.componentName, packageName = _ref.packageName, packageVersion = _ref.packageVersion, analyticsData = _ref.analyticsData;
    var _useAnalyticsEvents = (0, $nLm1R.useAnalyticsEvents)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    // We put analyticsData and fn in a ref so that we don't need to break
    // memoization.
    // Generally these could be defined by consumers inline
    // and so we do this to avoid breaking memoization of useCallback
    var dataRef = (0, $CVDHe.useTrackedRef)(analyticsData);
    var fnRef = (0, $CVDHe.useTrackedRef)(fn);
    var handler = (0, $dAx5m.useCallback)(function() {
        var analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: componentName,
            attributes: {
                componentName: componentName,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
        // To avoid wrapping this component in AnalyticsContext we manually
        // push the parent context's meta data into the context.
        // Note: this new 'context'
        var context = $61d8cfd9773fd749$var$_objectSpread({
            componentName: componentName,
            packageName: packageName,
            packageVersion: packageVersion
        }, dataRef.current);
        analyticsEvent.context.push(context);
        // fire an event on the atlaskit channel
        var clone = analyticsEvent.clone();
        if (clone) clone.fire("atlaskit");
        fnRef.current(analyticsEvent);
    }, [
        // These are strings and won't change
        action,
        componentName,
        packageName,
        packageVersion,
        // This function is memoized in the context
        createAnalyticsEvent,
        // these are a stable ref because of the useTrackedRef hook
        dataRef,
        fnRef
    ]);
    return handler;
}

});

parcelRegister("cX24d", function(module, exports) {

$parcel$export(module.exports, "wrapChildWithContextProvider", function () { return $96dc99345f20d38d$export$e4c4c45693c3a7c; });
$parcel$export(module.exports, "childrenToArray", function () { return $96dc99345f20d38d$export$7032ae6d9d98bedd; });
$parcel$export(module.exports, "spliceNewElementsIntoPrevious", function () { return $96dc99345f20d38d$export$2ccbe4ff092af328; });
$parcel$export(module.exports, "childrenToObj", function () { return $96dc99345f20d38d$export$1d8c49f95a162a41; });
$parcel$export(module.exports, "useExitingPersistence", function () { return $96dc99345f20d38d$export$3b6f38abbdcbd000; });
$parcel$export(module.exports, "default", function () { return $96dc99345f20d38d$export$2e2bcd8739ae039; });

var $dAx5m = parcelRequire("dAx5m");

var $l7mxy = parcelRequire("l7mxy");

var $aWp4d = parcelRequire("aWp4d");

var $38Opd = parcelRequire("38Opd");
var $96dc99345f20d38d$export$d1e013d71d2e2121 = {
    // Motions will always appear if not inside a exiting persistence component.
    appear: true,
    isExiting: false
};
var $96dc99345f20d38d$export$b9c4904d7a6929e6 = /*#__PURE__*/ (0, $dAx5m.createContext)($96dc99345f20d38d$export$d1e013d71d2e2121);
var $96dc99345f20d38d$export$e4c4c45693c3a7c = function wrapChildWithContextProvider(child) {
    var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $96dc99345f20d38d$export$d1e013d71d2e2121;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement($96dc99345f20d38d$export$b9c4904d7a6929e6.Provider, {
        key: "".concat(child.key, "-provider"),
        value: value
    }, child);
};
var $96dc99345f20d38d$export$7032ae6d9d98bedd = function childrenToArray(children) {
    var childrenAsArray = [];
    // We convert children to an array using this helper method as it will add keys to children that do not
    // have them, such as when we have hardcoded children that are conditionally rendered.
    (0, $dAx5m.Children).toArray(children).forEach(function(child) {
        // We ignore any boolean children to make our code a little more simple later on,
        // and also filter out any falsies (empty strings, nulls, and undefined).
        if (typeof child !== "boolean" && Boolean(child)) // Children WILL have a key after being forced into an array using the React.Children helper.
        childrenAsArray.push(child);
    });
    return childrenAsArray;
};
var $96dc99345f20d38d$export$2ccbe4ff092af328 = function spliceNewElementsIntoPrevious(current, previous) {
    var splicedChildren = previous.concat([]);
    var previousMap = $96dc99345f20d38d$export$1d8c49f95a162a41(previous);
    for(var i = 0; i < current.length; i++){
        var child = current[i];
        var childIsNew = !previousMap[child.key];
        if (childIsNew) // This will insert the new element after the previous element.
        splicedChildren.splice(i + 1, 0, child);
    }
    return splicedChildren;
};
var $96dc99345f20d38d$export$1d8c49f95a162a41 = function childrenToObj(children) {
    return children.reduce(function(acc, child) {
        acc[child.key] = child;
        return acc;
    }, {});
};
/**
 * __ExitingPersistence__
 *
 * Useful for enabling elements to persist and animate away when they are removed from the DOM.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motions)
 */ var $96dc99345f20d38d$var$ExitingPersistence = /*#__PURE__*/ (0, $dAx5m.memo)(function(_ref) {
    var _ref$appear = _ref.appear, appear = _ref$appear === void 0 ? false : _ref$appear, children = _ref.children, exitThenEnter = _ref.exitThenEnter;
    return (0, $l7mxy.getBooleanFF)("platform.design-system-team.update-motion-for-strict-mode_p6qs0") ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $aWp4d.default), {
        appear: appear,
        children: children,
        exitThenEnter: exitThenEnter
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $38Opd.default), {
        appear: appear,
        children: children,
        exitThenEnter: exitThenEnter
    });
});
var $96dc99345f20d38d$export$3b6f38abbdcbd000 = function useExitingPersistence() {
    return (0, $dAx5m.useContext)($96dc99345f20d38d$export$b9c4904d7a6929e6);
};
$96dc99345f20d38d$var$ExitingPersistence.displayName = "ExitingPersistence";
var $96dc99345f20d38d$export$2e2bcd8739ae039 = $96dc99345f20d38d$var$ExitingPersistence;

});
parcelRegister("l7mxy", function(module, exports) {

$parcel$export(module.exports, "getBooleanFF", function () { return $f5fbbc6fe9c48fdd$export$470e5c2be1411c89; });

var $7aMky = parcelRequire("7aMky");
function $f5fbbc6fe9c48fdd$export$ba05d765b8392e5e(flagResolver) {
    (0, $7aMky.setBooleanResolver)(flagResolver);
}
function $f5fbbc6fe9c48fdd$export$470e5c2be1411c89(name) {
    return (0, $7aMky.resolveBooleanFlag)(name);
}

});
parcelRegister("7aMky", function(module, exports) {

$parcel$export(module.exports, "setBooleanResolver", function () { return $538ef50263b712aa$export$f2b591175b3e424c; });
$parcel$export(module.exports, "resolveBooleanFlag", function () { return $538ef50263b712aa$export$6333b6aff9fc6275; });

var $apf7l = parcelRequire("apf7l");

var $ahJoN = parcelRequire("ahJoN");
var $538ef50263b712aa$var$pkgName = "@atlaskit/platform-feature-flags";
var $538ef50263b712aa$export$7e41b1b2bdee3f98 = "__PLATFORM_FEATURE_FLAGS__";
var $538ef50263b712aa$var$hasProcessEnv = typeof $ahJoN !== "undefined" && typeof $ahJoN.env !== "undefined";
// FF global overrides can be configured by test runners or Storybook
var $538ef50263b712aa$var$ENV_ENABLE_PLATFORM_FF = $538ef50263b712aa$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
// STORYBOOK_ENABLE_PLATFORM_FF is included as storybook only allows env vars prefixed with STORYBOOK
// https://github.com/storybookjs/storybook/issues/12270
var $538ef50263b712aa$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF = $538ef50263b712aa$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
var $538ef50263b712aa$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE = $538ef50263b712aa$var$ENV_ENABLE_PLATFORM_FF || $538ef50263b712aa$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF;
var $538ef50263b712aa$var$DEFAULT_PFF_GLOBAL = {
    // In development mode we want to capture any feature flag checks that happen using the default resolver and log this result when the resolver is replaced.
    // This is because evaluating feature flags when the resolver/FF client is loaded asynchronously could cause unexpected issues.
    earlyResolvedFlags: new Map(),
    booleanResolver: function booleanResolver(flagKey) {
        var unresolvedFlagCount;
        return false;
    }
};
var $538ef50263b712aa$var$globalVar = typeof window !== "undefined" ? window : globalThis;
$538ef50263b712aa$var$globalVar[$538ef50263b712aa$export$7e41b1b2bdee3f98] = $538ef50263b712aa$var$globalVar[$538ef50263b712aa$export$7e41b1b2bdee3f98] || $538ef50263b712aa$var$DEFAULT_PFF_GLOBAL;
function $538ef50263b712aa$export$f2b591175b3e424c(resolver) {
    $538ef50263b712aa$var$globalVar[$538ef50263b712aa$export$7e41b1b2bdee3f98].booleanResolver = resolver;
    var _globalVar$PFF_GLOBAL;
}
function $538ef50263b712aa$export$6333b6aff9fc6275(flagKey) {
    if ($538ef50263b712aa$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE) {
        (0, $apf7l.debug)('[%s]: The feature flags were enabled while running tests. The flag "%s" will be always enabled.', $538ef50263b712aa$var$pkgName, flagKey);
        return true;
    }
    try {
        var _globalVar$PFF_GLOBAL2;
        var result = (_globalVar$PFF_GLOBAL2 = $538ef50263b712aa$var$globalVar[$538ef50263b712aa$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL2 === void 0 ? void 0 : _globalVar$PFF_GLOBAL2.booleanResolver(flagKey);
        if (typeof result !== "boolean") {
            // eslint-disable-next-line no-console
            console.warn("".concat(flagKey, " resolved to a non-boolean value, returning false for safety"));
            return false;
        }
        return result;
    } catch (e) {
        return false;
    }
}

});
parcelRegister("apf7l", function(module, exports) {

$parcel$export(module.exports, "debug", function () { return $7937f72e02a3eab8$export$1c9f709888824e05; });
var $7937f72e02a3eab8$var$_ref, $7937f72e02a3eab8$var$_process, $7937f72e02a3eab8$var$_process2;
// We can't rely on NODE_ENV === 'test' if its value is already configured by the consumer to some other value, so better to use JEST_WORKER_ID
// https://jestjs.io/docs/environment-variables#jest_worker_id
var $7937f72e02a3eab8$var$TESTS_MODE = ($7937f72e02a3eab8$var$_ref = (globalThis === null || globalThis === void 0 || ($7937f72e02a3eab8$var$_process = globalThis.process) === null || $7937f72e02a3eab8$var$_process === void 0 || ($7937f72e02a3eab8$var$_process = $7937f72e02a3eab8$var$_process.env) === null || $7937f72e02a3eab8$var$_process === void 0 ? void 0 : $7937f72e02a3eab8$var$_process.JEST_WORKER_ID) !== undefined, $7937f72e02a3eab8$var$_ref !== void 0) ? $7937f72e02a3eab8$var$_ref : false;
var $7937f72e02a3eab8$var$DEBUG_MODE = !$7937f72e02a3eab8$var$TESTS_MODE && (globalThis === null || globalThis === void 0 || ($7937f72e02a3eab8$var$_process2 = globalThis.process) === null || $7937f72e02a3eab8$var$_process2 === void 0 || ($7937f72e02a3eab8$var$_process2 = $7937f72e02a3eab8$var$_process2.env) === null || $7937f72e02a3eab8$var$_process2 === void 0 ? void 0 : $7937f72e02a3eab8$var$_process2.NODE_ENV) !== "production";
var $7937f72e02a3eab8$export$1c9f709888824e05 = function debug() {
    var _console;
    if (!$7937f72e02a3eab8$var$DEBUG_MODE) return;
    // eslint-disable-next-line no-console
    (_console = console).debug.apply(_console, arguments);
};

});



parcelRegister("aWp4d", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7f72c3eb81afedc4$export$2e2bcd8739ae039; });

var $6RxC1 = parcelRequire("6RxC1");

var $dAx5m = parcelRequire("dAx5m");

var $h41cG = parcelRequire("h41cG");

var $cX24d = parcelRequire("cX24d");
var $7f72c3eb81afedc4$var$getMissingKeys = function getMissingKeys(current, previous) {
    var currentMapKeys = new Set(current.map(function(child) {
        return child.key;
    }));
    var missing = new Set();
    for(var i = 0; i < previous.length; i++){
        var element = previous[i];
        var key = element.key;
        if (!currentMapKeys.has(key)) missing.add(key);
    }
    return missing;
};
/**
 * __WithStrictModeSupport__
 *
 * Useful for enabling elements to persist and animate away when they are removed from the DOM.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motions)
 */ var $7f72c3eb81afedc4$var$WithStrictModeSupport = /*#__PURE__*/ (0, $dAx5m.memo)(function(_ref) {
    var _ref$appear = _ref.appear, appear = _ref$appear === void 0 ? false : _ref$appear, children = _ref.children, exitThenEnter = _ref.exitThenEnter;
    var _useState = (0, $dAx5m.useState)([
        null,
        children
    ]), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($6RxC1)))(_useState, 2), stateChildren = _useState2[0], setChildren = _useState2[1];
    var _useState3 = (0, $dAx5m.useState)([]), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($6RxC1)))(_useState3, 2), exitingChildren = _useState4[0], setExitingChildren = _useState4[1];
    var _useState5 = (0, $dAx5m.useState)(function() {
        return {
            appear: appear,
            isExiting: false
        };
    }), _useState6 = (0, (/*@__PURE__*/$parcel$interopDefault($6RxC1)))(_useState5, 2), defaultContext = _useState6[0], setDefaultContext = _useState6[1];
    (0, $dAx5m.useEffect)(function() {
        if (!defaultContext.appear) setDefaultContext({
            appear: true,
            isExiting: false
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    if ((0, $h41cG.isReducedMotion)()) return children;
    /**
   * NOTE: This is a workaround for the test case written in Jira where the stateChildren is a boolean value because
   * useState is mocked to return a boolean value.
   */ if (typeof stateChildren === "boolean") return children;
    var _stateChildren = (0, (/*@__PURE__*/$parcel$interopDefault($6RxC1)))(stateChildren, 2), previousChildren = _stateChildren[0], currentChildren = _stateChildren[1];
    var previous = (0, $cX24d.childrenToArray)(previousChildren);
    var current = (0, $cX24d.childrenToArray)(currentChildren);
    if (currentChildren !== children) setChildren([
        currentChildren,
        children
    ]);
    var missingKeys = $7f72c3eb81afedc4$var$getMissingKeys(current, previous);
    var isSomeChildRemoved = !!missingKeys.size;
    var visibleChildren = current;
    if (isSomeChildRemoved) visibleChildren = (0, $cX24d.spliceNewElementsIntoPrevious)(current, previous);
    if (exitThenEnter) {
        if (exitingChildren.length) visibleChildren = exitingChildren;
        else {
            var nextExitingChildren = visibleChildren.filter(function(child) {
                return missingKeys.has(child.key);
            });
            if (nextExitingChildren.length) setExitingChildren(nextExitingChildren);
        }
    }
    if (missingKeys.size) visibleChildren = visibleChildren.map(function(child) {
        var isExiting = missingKeys.has(child.key);
        return (0, $cX24d.wrapChildWithContextProvider)(child, {
            appear: true,
            isExiting: isExiting,
            onFinish: isExiting ? function() {
                missingKeys.delete(child.key);
                if (missingKeys.size === 0) {
                    setChildren([
                        null,
                        children
                    ]);
                    setExitingChildren([]);
                }
            } : undefined
        });
    });
    else visibleChildren = visibleChildren.map(function(child) {
        return (0, $cX24d.wrapChildWithContextProvider)(child, defaultContext);
    });
    return visibleChildren;
});
var $7f72c3eb81afedc4$export$2e2bcd8739ae039 = $7f72c3eb81afedc4$var$WithStrictModeSupport;

});
parcelRegister("h41cG", function(module, exports) {

$parcel$export(module.exports, "isReducedMotion", function () { return $c6c3be6515489828$export$b7baf7667a68d87c; });
$parcel$export(module.exports, "reduceMotionAsPerUserPreference", function () { return $c6c3be6515489828$export$f0f789643ba5a83c; });

var $6RxC1 = parcelRequire("6RxC1");

var $dAx5m = parcelRequire("dAx5m");

var $dd4sf = parcelRequire("dd4sf");
var $c6c3be6515489828$var$isMatchMediaAvailable = function isMatchMediaAvailable() {
    return typeof window !== "undefined" && "matchMedia" in window;
};
var $c6c3be6515489828$export$b7baf7667a68d87c = function isReducedMotion() {
    if (!$c6c3be6515489828$var$isMatchMediaAvailable()) return false;
    var _window$matchMedia = window.matchMedia("(prefers-reduced-motion: reduce)"), matches = _window$matchMedia.matches;
    return matches;
};
var $c6c3be6515489828$export$c537e63161742ce3 = function useIsReducedMotion() {
    var _useState = (0, $dAx5m.useState)($c6c3be6515489828$export$b7baf7667a68d87c), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($6RxC1)))(_useState, 2), prefersReducedMotion = _useState2[0], setPrefersReducedMotion = _useState2[1];
    (0, $dAx5m.useEffect)(function() {
        if (!$c6c3be6515489828$var$isMatchMediaAvailable()) return;
        var mediaQueryList = window.matchMedia("(prefers-reduced-motion: reduce)");
        var onChange = function onChange(event) {
            return setPrefersReducedMotion(event.matches);
        };
        return (0, $dd4sf.bind)(mediaQueryList, {
            type: "change",
            listener: onChange
        });
    }, []);
    return prefersReducedMotion;
};
var $c6c3be6515489828$export$f0f789643ba5a83c = {
    "@media (prefers-reduced-motion: reduce)": {
        animation: "none",
        transition: "none"
    }
};
var $c6c3be6515489828$export$ff7706047246b98b = function prefersReducedMotion() {
    return $c6c3be6515489828$export$f0f789643ba5a83c;
};

});


parcelRegister("38Opd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $24993800356604ca$export$2e2bcd8739ae039; });

var $dAx5m = parcelRequire("dAx5m");

var $h41cG = parcelRequire("h41cG");

var $hhBaS = parcelRequire("hhBaS");

var $cX24d = parcelRequire("cX24d");
var $24993800356604ca$var$isAnyPreviousKeysMissingFromCurrent = function isAnyPreviousKeysMissingFromCurrent(currentMap, previous) {
    for(var i = 0; i < previous.length; i++){
        var element = previous[i];
        var _key = element.key;
        if (!currentMap[_key]) return true;
    }
    return false;
};
/**
 * This handles the case when a render updates during an exit motion.
 * If any child is mounted again we removed them from the exiting children object and return true.
 */ var $24993800356604ca$var$hasAnyExitingChildMountedAgain = function hasAnyExitingChildMountedAgain(exitingChildren, children) {
    var exitingChildMountedAgain = false;
    children.forEach(function(child) {
        if (exitingChildren.current[child.key]) {
            exitingChildMountedAgain = true;
            delete exitingChildren.current[child.key];
        }
    });
    return exitingChildMountedAgain;
};
/**
 * __ExitingPersistence__
 *
 * Useful for enabling elements to persist and animate away when they are removed from the DOM.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motions)
 */ var $24993800356604ca$var$WithoutStrictModeSupport = /*#__PURE__*/ (0, $dAx5m.memo)(function(_ref) {
    var _ref$appear = _ref.appear, appearFromProp = _ref$appear === void 0 ? false : _ref$appear, childs = _ref.children, exitThenEnter = _ref.exitThenEnter;
    var children = (0, $cX24d.childrenToArray)(childs);
    var childrenObj = (0, $cX24d.childrenToObj)(children);
    var previousChildren = (0, $dAx5m.useRef)([]);
    var persistedChildren = (0, $dAx5m.useRef)([]);
    var forceRender = (0, $hhBaS.useForceRender)();
    var exitingChildren = (0, $dAx5m.useRef)({});
    var appear = (0, $dAx5m.useRef)(appearFromProp);
    var defaultContextValue = (0, $dAx5m.useMemo)(function() {
        return {
            appear: appear.current,
            isExiting: false
        };
    }, // React rules of hooks says this isn't needed because mutating appear won't cause a re-render.
    // While technically true - it will trigger this to make a new object on the _next_ render which is what we want.
    // Remove this or use appear instead of appear.current and you will notice a test breaks.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        appear.current
    ]);
    if ((0, $h41cG.isReducedMotion)()) return children;
    if (!appear.current) // We always want child motions to appear after the initial mount.
    appear.current = true;
    // This entire block can't be an effect because we need it to run synchronously during a render
    // else when elements are being removed they will be remounted instead of being updated.
    if (previousChildren.current.length && $24993800356604ca$var$isAnyPreviousKeysMissingFromCurrent(childrenObj, previousChildren.current)) {
        if (persistedChildren.current.length === 0 || $24993800356604ca$var$hasAnyExitingChildMountedAgain(exitingChildren, children)) persistedChildren.current = previousChildren.current;
        // We have persisted children now set from previous children.
        // Let's update previous children so we have it available next render.
        previousChildren.current = children;
        return (exitThenEnter ? persistedChildren.current : (0, $cX24d.spliceNewElementsIntoPrevious)(children, persistedChildren.current)).map(function(child) {
            // eslint-disable-next-line @repo/internal/react/no-children-properties-access
            var currentChild = childrenObj[child.key];
            if (!currentChild) {
                // We've found an exiting child - mark it!
                exitingChildren.current[child.key] = true;
                return (0, $cX24d.wrapChildWithContextProvider)(child, {
                    isExiting: true,
                    appear: true,
                    onFinish: function onFinish() {
                        delete exitingChildren.current[child.key];
                        // We will only remove the exiting elements when any subsequent exiting elements have also finished.
                        // Think of removing many items from a todo list - when removing a few over a few clicks we don't
                        // want the list jumping around when they exit.
                        if (Object.keys(exitingChildren.current).length === 0) {
                            // Set previous children to nothing.
                            // This let's us skip the next render check as it's assumed children and previous will be the same.
                            previousChildren.current = [];
                            persistedChildren.current = [];
                            // Re-render after the element(s) have animated away which will end up rendering the latest children.
                            forceRender();
                        }
                    }
                });
            }
            // This element isn't exiting.
            // Wrap context and let's continue on our way.
            return (0, $cX24d.wrapChildWithContextProvider)(currentChild, defaultContextValue);
        });
    } else previousChildren.current = children;
    return children.map(function(child) {
        return (0, $cX24d.wrapChildWithContextProvider)(child, defaultContextValue);
    });
});
var $24993800356604ca$export$2e2bcd8739ae039 = $24993800356604ca$var$WithoutStrictModeSupport;

});
parcelRegister("hhBaS", function(module, exports) {

$parcel$export(module.exports, "useForceRender", function () { return $c950dc46685d451a$export$b902f6ef73d6633a; });

var $6RxC1 = parcelRequire("6RxC1");

var $dAx5m = parcelRequire("dAx5m");
var $c950dc46685d451a$export$b902f6ef73d6633a = function useForceRender() {
    var _useState = (0, $dAx5m.useState)({}), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($6RxC1)))(_useState, 2), updateState = _useState2[1];
    var forceRender = (0, $dAx5m.useCallback)(function() {
        return updateState({});
    }, []);
    return forceRender;
};

});



parcelRegister("3R3i6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2ce8dfd5c8f2aab3$export$2e2bcd8739ae039; });

var $iDtim = parcelRequire("iDtim");

var $dAx5m = parcelRequire("dAx5m");

var $gw0SM = parcelRequire("gw0SM");

var $a6gax = parcelRequire("a6gax");

var $gsZib = parcelRequire("gsZib");
function $2ce8dfd5c8f2aab3$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $2ce8dfd5c8f2aab3$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $2ce8dfd5c8f2aab3$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($iDtim)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $2ce8dfd5c8f2aab3$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $2ce8dfd5c8f2aab3$var$directionMotions = {
    proportional: {
        bottom: "translate3d(0, calc(5% + 4px), 0)",
        left: "translate3d(calc(-5% - 4px), 0, 0)",
        right: "translate3d(calc(5% + 4px), 0, 0)",
        top: "translate3d(0, calc(-5% - 4px), 0)"
    },
    constant: {
        bottom: "translate3d(0, 4px, 0)",
        left: "translate3d(-4px, 0, 0)",
        right: "translate3d(4px, 0, 0)",
        top: "translate3d(0, -4px, 0)"
    }
};
var $2ce8dfd5c8f2aab3$var$invertedDirection = {
    top: "bottom",
    bottom: "top",
    left: "right",
    right: "left"
};
var $2ce8dfd5c8f2aab3$export$8497679fcaaeceb = function fadeInAnimation(direction) {
    var distance = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "proportional";
    return {
        from: $2ce8dfd5c8f2aab3$var$_objectSpread({
            opacity: 0
        }, direction !== undefined && {
            transform: $2ce8dfd5c8f2aab3$var$directionMotions[distance][direction]
        }),
        "50%": {
            opacity: 1
        },
        to: {
            transform: direction !== undefined ? "none" : undefined
        }
    };
};
var $2ce8dfd5c8f2aab3$export$c9190c6659ea755b = function fadeOutAnimation(direction) {
    var distance = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "proportional";
    return {
        from: {
            opacity: 1,
            transform: direction !== undefined ? "translate3d(0, 0, 0)" : undefined
        },
        to: $2ce8dfd5c8f2aab3$var$_objectSpread({
            opacity: 0
        }, direction !== undefined && {
            transform: $2ce8dfd5c8f2aab3$var$directionMotions[distance][direction]
        })
    };
};
/**
 * Props for controlling the behavior of the FadeIn animation
 */ /**
 * __FadeIn__
 *
 * Useful for fading in one or more elements.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motions)
 */ var $2ce8dfd5c8f2aab3$var$FadeIn = function FadeIn(_ref) {
    var children = _ref.children, _ref$duration = _ref.duration, duration = _ref$duration === void 0 ? (0, $a6gax.largeDurationMs) : _ref$duration, entranceDirection = _ref.entranceDirection, exitDirection = _ref.exitDirection, _ref$distance = _ref.distance, distance = _ref$distance === void 0 ? "proportional" : _ref$distance, onFinish = _ref.onFinish, isPaused = _ref.isPaused;
    var invertedEntranceDirection = entranceDirection && $2ce8dfd5c8f2aab3$var$invertedDirection[entranceDirection];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $gsZib.default), {
        duration: duration,
        enteringAnimation: $2ce8dfd5c8f2aab3$export$8497679fcaaeceb(entranceDirection, distance),
        exitingAnimation: $2ce8dfd5c8f2aab3$export$c9190c6659ea755b(exitDirection || invertedEntranceDirection, distance),
        animationTimingFunction: function animationTimingFunction() {
            return 0, $gw0SM.easeInOut;
        },
        onFinish: onFinish,
        isPaused: isPaused
    }, children);
};
var $2ce8dfd5c8f2aab3$export$2e2bcd8739ae039 = $2ce8dfd5c8f2aab3$var$FadeIn;

});
parcelRegister("gw0SM", function(module, exports) {

$parcel$export(module.exports, "easeInOut", function () { return $c06051c7a1e15c68$export$c07234257a03d5e9; });
var $c06051c7a1e15c68$export$c07234257a03d5e9 = "cubic-bezier(0.15,1,0.3,1)";
var $c06051c7a1e15c68$export$57636bb43b1ccbb0 = "cubic-bezier(0.2,0,0,1)";
var $c06051c7a1e15c68$export$929e5a82286172a6 = "cubic-bezier(0.8,0,0,0.8)";

});

parcelRegister("a6gax", function(module, exports) {

$parcel$export(module.exports, "mediumDurationMs", function () { return $01e5ca59b1051b14$export$6fa259be09e118a7; });
$parcel$export(module.exports, "largeDurationMs", function () { return $01e5ca59b1051b14$export$9424640c29bc466d; });
/**
 * Think of this as the motion equivalent of the @atlaskit/theme `grid()`.
 */ var $01e5ca59b1051b14$export$368bacef0dacbe05 = 25;
var $01e5ca59b1051b14$export$2023a81c8547415f = $01e5ca59b1051b14$export$368bacef0dacbe05 * 4;
var $01e5ca59b1051b14$export$6fa259be09e118a7 = $01e5ca59b1051b14$export$368bacef0dacbe05 * 14;
var $01e5ca59b1051b14$export$9424640c29bc466d = $01e5ca59b1051b14$export$368bacef0dacbe05 * 28;

});

parcelRegister("gsZib", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bfcece37f6ef2b79$export$2e2bcd8739ae039; });

var $iDtim = parcelRequire("iDtim");

var $6RxC1 = parcelRequire("6RxC1");

var $dAx5m = parcelRequire("dAx5m");

var $jVTBW = parcelRequire("jVTBW");

var $h41cG = parcelRequire("h41cG");

var $a6gax = parcelRequire("a6gax");

var $gphdU = parcelRequire("gphdU");

var $cX24d = parcelRequire("cX24d");

var $9eNIf = parcelRequire("9eNIf");
function $bfcece37f6ef2b79$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $bfcece37f6ef2b79$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $bfcece37f6ef2b79$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($iDtim)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $bfcece37f6ef2b79$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
/**
 * These are props that motions should use as their external props for consumers.
 * See [FadeIn](packages/helpers/motion/src/entering/fade-in.tsx) for an example usage.
 */ /**
 * Used to multiply the initial duration for exiting motions.
 */ var $bfcece37f6ef2b79$var$EXITING_MOTION_MULTIPLIER = 0.5;
/**
 * This is the base INTERNAL component used for all other entering motions.
 * This does not need Javascript to execute on the client so it will run immediately
 * for any SSR rendered React apps before the JS has executed.
 */ var $bfcece37f6ef2b79$var$EnteringMotion = function EnteringMotion(_ref) {
    var children = _ref.children, animationTimingFunction = _ref.animationTimingFunction, enteringAnimation = _ref.enteringAnimation, exitingAnimation = _ref.exitingAnimation, isPaused = _ref.isPaused, onFinishMotion = _ref.onFinish, _ref$duration = _ref.duration, duration = _ref$duration === void 0 ? (0, $a6gax.largeDurationMs) : _ref$duration;
    var staggered = (0, $9eNIf.useStaggeredEntrance)();
    var _useExitingPersistenc = (0, $cX24d.useExitingPersistence)(), isExiting = _useExitingPersistenc.isExiting, onExitFinished = _useExitingPersistenc.onFinish, appear = _useExitingPersistenc.appear;
    var setTimeout = (0, $gphdU.useSetTimeout)();
    var paused = isPaused || !staggered.isReady;
    var delay = isExiting ? 0 : staggered.delay;
    var state = isExiting ? "exiting" : "entering";
    var _useState = (0, $dAx5m.useState)(appear), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($6RxC1)))(_useState, 2), hasAnimationStyles = _useState2[0], setHasAnimationStyles = _useState2[1];
    (0, $dAx5m.useEffect)(function() {
        // Tracking this to prevent changing state on an unmounted component
        var isCancelled = false;
        if (paused) return;
        // On initial mount if elements aren't set to animate on appear, we return early and callback
        if (!appear) {
            onFinishMotion && onFinishMotion(state);
            return;
        }
        // Elements may need animation styles back after initial mount (they could animate out)
        setHasAnimationStyles(true);
        setTimeout(function() {
            if (state === "exiting") onExitFinished && onExitFinished();
            if (!isCancelled) setHasAnimationStyles(false);
            onFinishMotion && onFinishMotion(state);
        }, isExiting ? duration * $bfcece37f6ef2b79$var$EXITING_MOTION_MULTIPLIER : duration + delay);
        return function() {
            isCancelled = true;
        };
    // We ignore this for onFinishMotion as consumers could potentially inline the function
    // which would then trigger this effect every re-render.
    // We want to make it easier for consumers so we go down this path unfortunately.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        onExitFinished,
        state,
        isExiting,
        duration,
        delay,
        paused,
        setTimeout
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $jVTBW.ClassNames), null, function(_ref2) {
        var css = _ref2.css;
        return children({
            ref: staggered.ref,
            className: hasAnimationStyles ? css($bfcece37f6ef2b79$var$_objectSpread($bfcece37f6ef2b79$var$_objectSpread({}, (0, $h41cG.reduceMotionAsPerUserPreference)), {}, {
                animationDelay: "".concat(delay, "ms"),
                animationDuration: "".concat(isExiting ? duration * $bfcece37f6ef2b79$var$EXITING_MOTION_MULTIPLIER : duration, "ms"),
                animationFillMode: isExiting ? "forwards" : "backwards",
                animationName: "".concat((0, $jVTBW.keyframes)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                isExiting ? exitingAnimation || enteringAnimation : enteringAnimation)),
                animationPlayState: paused ? "paused" : "running",
                animationTimingFunction: animationTimingFunction(state)
            })) : ""
        }, state);
    });
};
var $bfcece37f6ef2b79$export$2e2bcd8739ae039 = $bfcece37f6ef2b79$var$EnteringMotion;

});
parcelRegister("gphdU", function(module, exports) {

$parcel$export(module.exports, "useSetTimeout", function () { return $bf1c57553bc7b4bb$export$4f34107a2b00f39c; });

var $dAx5m = parcelRequire("dAx5m");
var $bf1c57553bc7b4bb$var$getHookDeps = function getHookDeps(opts) {
    switch(opts.cleanup){
        case "next-effect":
            return undefined;
        case "unmount":
        default:
            return [];
    }
};
var $bf1c57553bc7b4bb$export$1775f27e7c8051ca = function useRequestAnimationFrame() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        cleanup: "unmount"
    };
    var frames = (0, $dAx5m.useRef)([]);
    (0, $dAx5m.useEffect)(function() {
        return function() {
            if (frames.current.length) {
                frames.current.forEach(function(id) {
                    return cancelAnimationFrame(id);
                });
                frames.current = [];
            }
        };
    // We dynamically set this so we either clean up on the next effect - or on unmount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, $bf1c57553bc7b4bb$var$getHookDeps(opts));
    return (0, $dAx5m.useCallback)(function(handler) {
        var id = requestAnimationFrame(function(time) {
            frames.current = frames.current.filter(function(frameId) {
                return frameId !== id;
            });
            handler(time);
        });
        frames.current.push(id);
    }, []);
};
var $bf1c57553bc7b4bb$export$4f34107a2b00f39c = function useSetTimeout() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        cleanup: "unmount"
    };
    var timeouts = (0, $dAx5m.useRef)([]);
    (0, $dAx5m.useEffect)(function() {
        return function() {
            if (timeouts.current.length) {
                timeouts.current.forEach(function(id) {
                    return clearTimeout(id);
                });
                timeouts.current = [];
            }
        };
    // We dynamically set this so we either clean up on the next effect - or on unmount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, $bf1c57553bc7b4bb$var$getHookDeps(opts));
    return (0, $dAx5m.useCallback)(function(handler, timeout) {
        for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
        var id = setTimeout.apply(void 0, [
            function() {
                timeouts.current = timeouts.current.filter(function(timeoutId) {
                    return timeoutId !== id;
                });
                handler();
            },
            timeout
        ].concat(args));
        timeouts.current.push(id);
    }, []);
};

});

parcelRegister("9eNIf", function(module, exports) {

$parcel$export(module.exports, "useStaggeredEntrance", function () { return $6b9bfbc6897d68ba$export$25c7213fc07ec080; });

var $6RxC1 = parcelRequire("6RxC1");

var $dAx5m = parcelRequire("dAx5m");

var $Bb0he = parcelRequire("Bb0he");

var $i34Nu = parcelRequire("i34Nu");

var $qEDW0 = parcelRequire("qEDW0");
var $6b9bfbc6897d68ba$var$StaggeredEntranceContext = /*#__PURE__*/ (0, $dAx5m.createContext)(function() {
    return {
        isReady: true,
        delay: 0,
        ref: (0, $Bb0he.default)
    };
});
var $6b9bfbc6897d68ba$export$25c7213fc07ec080 = function useStaggeredEntrance() {
    var indentifier = (0, $qEDW0.useUniqueId)();
    var context = (0, $dAx5m.useContext)($6b9bfbc6897d68ba$var$StaggeredEntranceContext);
    return context(indentifier);
};
/**
 * For a list of elements that need to animate in,
 * this should be used in conjunction with entering components.
 * This does not need Javascript to execute so it will run immediately for any SSR rendered React apps before the JS has executed.
 *
 * Will dynamically add delay to each child entering component.
 * Unfortunately all entering components _NEED_ to be a direct descendant.
 */ var $6b9bfbc6897d68ba$var$StaggeredEntrance = function StaggeredEntrance(_ref) {
    var children = _ref.children, column = _ref.column, _ref$columns = _ref.columns, columns = _ref$columns === void 0 ? "responsive" : _ref$columns, _ref$delayStep = _ref.delayStep, delayStep = _ref$delayStep === void 0 ? 50 : _ref$delayStep;
    var elementRefs = (0, $dAx5m.useRef)([]);
    var indexes = [];
    var _useState = (0, $dAx5m.useState)(function() {
        if (typeof columns === "number") // A hardcoded columns is set so bail out and set it to that!
        return columns;
        if (typeof column === "number") // A hardcoded column is set so we will set actualColumns to be 1.
        return 1;
        // We are in "responsive" mode.
        // So we will be calculating when the Javascript executes on the client how many columns there will be.
        return 0;
    }), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($6RxC1)))(_useState, 2), actualColumns = _useState2[0], setActualColumns = _useState2[1];
    (0, $i34Nu.useLayoutEffect)(function() {
        // We want to only run this code when we are in "responsive" mode.
        // It is assumed we are in responsive mode if `columns` is "responsive",
        // we have children element refs ready to be read (i.e. if there are no children this won't run as well)
        // and finally that `actualColumns` is `0` - this is because for the first render cycle `actualColumns` will be `0` (set above)
        // and then after this layout effect runs the value for `actualColumns` will then be calculated and set.
        if (columns === "responsive" && elementRefs.current.length && actualColumns === 0) {
            var currentTop = 0;
            var numberColumns = 0;
            if (elementRefs.current.length <= 1) {
                setActualColumns(1);
                return;
            }
            // We set the current top to the first elements.
            // We will be comparing this and incrementing the column count
            // until we hit an element that has a different offset top (or we run out of elements).
            currentTop = elementRefs.current[0] ? elementRefs.current[0].offsetTop : 0;
            for(var i = 0; i < elementRefs.current.length; i++){
                var child = elementRefs.current[i];
                if (!child) break;
                if (currentTop === child.offsetTop) {
                    numberColumns += 1;
                    if (elementRefs.current.length - 1 === i) setActualColumns(numberColumns);
                    continue;
                }
                setActualColumns(numberColumns);
                break;
            }
        }
    // We only want this effect to run once - on initial mount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement($6b9bfbc6897d68ba$var$StaggeredEntranceContext.Provider, {
        value: function value(id) {
            if (!indexes.includes(id)) indexes.push(id);
            var isReady = actualColumns > 0;
            var index = indexes.indexOf(id);
            var currentColumn = column || index % actualColumns;
            var currentRow = Math.floor(index / actualColumns);
            var distanceFromTopLeftElement = currentRow + currentColumn;
            // We don't want loads of elements to have the same staggered delay as it ends up looking slow for users.
            // To get around that we calculate the logarithm using `distanceFromTopLeftElement` which ends making
            // elements appear faster the further away from the top left element.
            var delay = Math.ceil(Math.log(distanceFromTopLeftElement + 1) * delayStep * 1.5) || 0;
            return {
                delay: delay,
                isReady: isReady,
                ref: function ref(element) {
                    return elementRefs.current[index] = element;
                }
            };
        }
    }, children);
};
var $6b9bfbc6897d68ba$export$2e2bcd8739ae039 = $6b9bfbc6897d68ba$var$StaggeredEntrance;

});
parcelRegister("i34Nu", function(module, exports) {

$parcel$export(module.exports, "useLayoutEffect", function () { return $d23c3a7273bc6cd3$export$e5c5a5f917a5871c; });

var $dAx5m = parcelRequire("dAx5m");
var $d23c3a7273bc6cd3$export$e5c5a5f917a5871c = typeof window === "undefined" ? (0, $dAx5m.useEffect) : (0, $dAx5m.useLayoutEffect);

});

parcelRegister("qEDW0", function(module, exports) {

$parcel$export(module.exports, "useUniqueId", function () { return $0501f4b266f753c9$export$c485849f2e393253; });
/* eslint-disable @repo/internal/react/disallow-unstable-values */ 
var $dAx5m = parcelRequire("dAx5m");
function $0501f4b266f753c9$export$c485849f2e393253() {
    var identifier = (0, $dAx5m.useRef)("");
    if (!identifier.current) identifier.current = "_" + (Number(String(Math.random()).slice(2)) + Date.now() + Math.round(performance.now())).toString(36);
    return identifier.current;
}

});




parcelRegister("gbM0g", function(module, exports) {

$parcel$export(module.exports, "Popper", function () { return $bc92e8e4ea2dc7ff$export$badac9ada3a0bdf9; });

var $k2EOa = parcelRequire("k2EOa");

var $6RxC1 = parcelRequire("6RxC1");

var $dAx5m = parcelRequire("dAx5m");

var $2BQLr = parcelRequire("2BQLr");

// Export types from PopperJS / React Popper
var $bc92e8e4ea2dc7ff$var$constantModifiers = [
    {
        name: "flip",
        options: {
            flipVariations: false,
            padding: 5,
            boundary: "clippingParents",
            rootBoundary: "viewport"
        }
    },
    {
        name: "preventOverflow",
        options: {
            padding: 5,
            rootBoundary: "document"
        }
    }
];
function $bc92e8e4ea2dc7ff$var$defaultChildrenFn() {
    return null;
}
var $bc92e8e4ea2dc7ff$var$defaultOffset = [
    0,
    8
];
function $bc92e8e4ea2dc7ff$export$badac9ada3a0bdf9(_ref) {
    var _ref$children = _ref.children, children = _ref$children === void 0 ? $bc92e8e4ea2dc7ff$var$defaultChildrenFn : _ref$children, _ref$offset = _ref.offset, offset = _ref$offset === void 0 ? $bc92e8e4ea2dc7ff$var$defaultOffset : _ref$offset, _ref$placement = _ref.placement, placement = _ref$placement === void 0 ? "bottom-start" : _ref$placement, _ref$referenceElement = _ref.referenceElement, referenceElement = _ref$referenceElement === void 0 ? undefined : _ref$referenceElement, modifiers = _ref.modifiers, _ref$strategy = _ref.strategy, strategy = _ref$strategy === void 0 ? "fixed" : _ref$strategy;
    var _offset = (0, (/*@__PURE__*/$parcel$interopDefault($6RxC1)))(offset, 2), offsetX = _offset[0], offsetY = _offset[1];
    // Merge a new offset modifier only if new offset values passed in
    var internalModifiers = (0, $dAx5m.useMemo)(function() {
        var offsetModifier = {
            name: "offset",
            options: {
                offset: [
                    offsetX,
                    offsetY
                ]
            }
        };
        return [].concat($bc92e8e4ea2dc7ff$var$constantModifiers, [
            offsetModifier
        ]);
    }, [
        offsetX,
        offsetY
    ]);
    // Merge custom props and memoize
    var mergedModifiers = (0, $dAx5m.useMemo)(function() {
        if (modifiers == null) return internalModifiers;
        return [].concat((0, (/*@__PURE__*/$parcel$interopDefault($k2EOa)))(internalModifiers), (0, (/*@__PURE__*/$parcel$interopDefault($k2EOa)))(modifiers));
    }, [
        internalModifiers,
        modifiers
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $2BQLr.Popper), {
        modifiers: mergedModifiers,
        placement: placement,
        strategy: strategy,
        referenceElement: referenceElement
    }, children);
}

});

parcelRegister("azbnm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7b15ff3fd73add87$export$2e2bcd8739ae039; });

var $dAx5m = parcelRequire("dAx5m");

var $94IRS = parcelRequire("94IRS");

var $aifqP = parcelRequire("aifqP");

var $bSZgm = parcelRequire("bSZgm");
function $7b15ff3fd73add87$export$2e2bcd8739ae039(_ref) {
    var _ref$zIndex = _ref.zIndex, zIndex = _ref$zIndex === void 0 ? 0 : _ref$zIndex, children = _ref.children, _ref$mountStrategy = _ref.mountStrategy, mountStrategy = _ref$mountStrategy === void 0 ? "effect" : _ref$mountStrategy;
    var isSubsequentRender = (0, $aifqP.default)(mountStrategy);
    (0, $bSZgm.default)(zIndex);
    return isSubsequentRender ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $94IRS.default), {
        zIndex: zIndex
    }, children) : null;
}

});
parcelRegister("94IRS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $69b74aa5a6d460e5$export$2e2bcd8739ae039; });

var $dAx5m = parcelRequire("dAx5m");

var $1MpXQ = parcelRequire("1MpXQ");

var $hmNp6 = parcelRequire("hmNp6");
function $69b74aa5a6d460e5$export$2e2bcd8739ae039(props) {
    var zIndex = props.zIndex, children = props.children;
    var container = (0, $dAx5m.useMemo)(function() {
        return (0, $hmNp6.createContainer)(zIndex);
    }, [
        zIndex
    ]);
    // This is in the render method instead of useEffect so that
    // the portal will be added to the DOM before the children render.
    // For any further changes, ensure that the container does not have a
    // parent besides the portal parent.
    (0, $hmNp6.appendPortalContainerIfNotAppended)(container);
    (0, $dAx5m.useEffect)(function() {
        return function() {
            (0, $hmNp6.removePortalContainer)(container);
        };
    }, [
        container
    ]);
    return /*#__PURE__*/ (0, $1MpXQ.createPortal)(children, container);
}

});
parcelRegister("hmNp6", function(module, exports) {

$parcel$export(module.exports, "createContainer", function () { return $ca4ad051dff7706a$export$26ae5ca175b4ec5a; });
$parcel$export(module.exports, "removePortalContainer", function () { return $ca4ad051dff7706a$export$da99f98bf3fe55b3; });
$parcel$export(module.exports, "appendPortalContainerIfNotAppended", function () { return $ca4ad051dff7706a$export$c582005add11e141; });

var $hmInB = parcelRequire("hmInB");
var $ca4ad051dff7706a$export$26ae5ca175b4ec5a = function createContainer(zIndex) {
    var container = document.createElement("div");
    container.className = (0, $hmInB.portalClassName);
    container.style.zIndex = "".concat(zIndex);
    return container;
};
/**
 * Returns document body element
 * @return {number} - The document body element
 */ var $ca4ad051dff7706a$var$getBody = function getBody() {
    return document.body;
};
/**
 * Returns portal parent container. If no container exists already then it creates a new container with class name 'atlaskit-portal-container'
 * @return {Element} - The portal parent container div element
 */ var $ca4ad051dff7706a$var$getPortalParent = function getPortalParent() {
    var parentElement = document.querySelector((0, $hmInB.portalParentSelector));
    if (!parentElement) {
        var _getBody;
        var parent = document.createElement("div");
        parent.className = (0, $hmInB.portalParentClassName);
        // we are setting display to flex because we want each portal to create a new stacking context
        // See https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Positioning/Understanding_z_index/The_stacking_context
        parent.style.display = "flex";
        (_getBody = $ca4ad051dff7706a$var$getBody()) === null || _getBody === void 0 || _getBody.appendChild(parent);
        return parent;
    }
    return parentElement;
};
var $ca4ad051dff7706a$export$da99f98bf3fe55b3 = function removePortalContainer(container) {
    $ca4ad051dff7706a$var$getPortalParent().removeChild(container);
};
var $ca4ad051dff7706a$export$c582005add11e141 = function appendPortalContainerIfNotAppended(container) {
    if (!container.parentElement) $ca4ad051dff7706a$var$getPortalParent().appendChild(container);
};

});
parcelRegister("hmInB", function(module, exports) {

$parcel$export(module.exports, "portalParentClassName", function () { return $ca46eaa437edbe8a$export$e4c79eb95c23a0da; });
$parcel$export(module.exports, "portalParentSelector", function () { return $ca46eaa437edbe8a$export$72f415121273627e; });
$parcel$export(module.exports, "portalClassName", function () { return $ca46eaa437edbe8a$export$13f57c02915787b3; });
var $ca46eaa437edbe8a$export$e4c79eb95c23a0da = "atlaskit-portal-container";
var $ca46eaa437edbe8a$export$72f415121273627e = "body > .atlaskit-portal-container";
var $ca46eaa437edbe8a$export$13f57c02915787b3 = "atlaskit-portal";

});



parcelRegister("aifqP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $77e78e3900207c53$export$2e2bcd8739ae039; });

var $6RxC1 = parcelRequire("6RxC1");

var $dAx5m = parcelRequire("dAx5m");

var $i5CuK = parcelRequire("i5CuK");
var $77e78e3900207c53$var$useIsSubsequentRender = function useIsSubsequentRender(mountStrategy) {
    var _useState = (0, $dAx5m.useState)(false), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($6RxC1)))(_useState, 2), isSubsequentRender = _useState2[0], setIsSubsequentRender = _useState2[1];
    var _useState3 = (0, $dAx5m.useState)(function() {
        return mountStrategy === "layoutEffect" ? (0, $i5CuK.useIsomorphicLayoutEffect) : (0, $dAx5m.useEffect);
    }), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($6RxC1)))(_useState3, 1), useMountEffect = _useState4[0];
    useMountEffect(function() {
        setIsSubsequentRender(true);
    }, []);
    return isSubsequentRender;
};
var $77e78e3900207c53$export$2e2bcd8739ae039 = $77e78e3900207c53$var$useIsSubsequentRender;

});
parcelRegister("i5CuK", function(module, exports) {

$parcel$export(module.exports, "useIsomorphicLayoutEffect", function () { return $d2b68de8b22cb686$export$700979bc83e7db82; });

var $dAx5m = parcelRequire("dAx5m");
var $d2b68de8b22cb686$export$700979bc83e7db82 = typeof window !== "undefined" ? (0, $dAx5m.useLayoutEffect) : (0, $dAx5m.useEffect);

});


parcelRegister("bSZgm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8a74426257286156$export$2e2bcd8739ae039; });

var $dAx5m = parcelRequire("dAx5m");

var $jiLGf = parcelRequire("jiLGf");

var $931Ni = parcelRequire("931Ni");
var $8a74426257286156$var$useFirePortalEvent = function useFirePortalEvent(zIndex) {
    var zIndexNumber = Number(zIndex);
    (0, $dAx5m.useEffect)(function() {
        (0, $931Ni.default)((0, $jiLGf.PORTAL_MOUNT_EVENT), zIndexNumber);
        return function() {
            (0, $931Ni.default)((0, $jiLGf.PORTAL_UNMOUNT_EVENT), zIndexNumber);
        };
    }, [
        zIndexNumber
    ]);
};
var $8a74426257286156$export$2e2bcd8739ae039 = $8a74426257286156$var$useFirePortalEvent;

});
parcelRegister("jiLGf", function(module, exports) {

$parcel$export(module.exports, "PORTAL_MOUNT_EVENT", function () { return $e0d4af19e16fd916$export$ed5835cc67e87f72; });
$parcel$export(module.exports, "PORTAL_UNMOUNT_EVENT", function () { return $e0d4af19e16fd916$export$80816bd900e5bd00; });
var $e0d4af19e16fd916$export$ed5835cc67e87f72 = "akPortalMount";
var $e0d4af19e16fd916$export$80816bd900e5bd00 = "akPortalUnmount";

});

parcelRegister("931Ni", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6965c9277d411e85$export$2e2bcd8739ae039; });
var $6965c9277d411e85$var$zIndexToName = {
    100: "card",
    200: "navigation",
    300: "dialog",
    400: "layer",
    500: "blanket",
    510: "modal",
    600: "flag",
    700: "spotlight",
    9999: "tooltip"
};
/**
 * return layer name in Atlassian design system corresponding to given z-index
 * @param {number} zIndex - z-index value for which layer name is needed
 * @returns {LayerName | null} - The layer name for given z-index. If layer name is not found then null is returned
 */ var $6965c9277d411e85$var$getLayerName = function getLayerName(zIndex) {
    return $6965c9277d411e85$var$zIndexToName.hasOwnProperty(zIndex) ? $6965c9277d411e85$var$zIndexToName[zIndex] : null;
};
/**
 * Creates a PortalEvent object with given eventName, given zIndex and corresponding layer
 * @param {string} eventName - either of Mount or Unmount event name
 * @param {number} zIndex - z-index value which will be included in the event to be dispatched
 * @returns {PortalEvent} - The newly created PortalEvent object
 */ var $6965c9277d411e85$var$getEvent = function getEvent(eventName, zIndex) {
    var detail = {
        layer: $6965c9277d411e85$var$getLayerName(Number(zIndex)),
        zIndex: zIndex
    };
    return new CustomEvent(eventName, {
        detail: detail
    });
};
function $6965c9277d411e85$export$2e2bcd8739ae039(eventName, zIndex) {
    var event = $6965c9277d411e85$var$getEvent(eventName, zIndex);
    window.dispatchEvent(event);
}

});



parcelRegister("hrGjC", function(module, exports) {

$parcel$export(module.exports, "CHANNEL", function () { return $cb35c83dc728070d$export$44ffba16bd48dac6; });
$parcel$export(module.exports, "DEFAULT_THEME_MODE", function () { return $cb35c83dc728070d$export$c93026a968943f95; });
$parcel$export(module.exports, "THEME_MODES", function () { return $cb35c83dc728070d$export$6ba72c8346b4c57e; });
$parcel$export(module.exports, "borderRadius", function () { return $cb35c83dc728070d$export$7a57f79000377ca2; });
$parcel$export(module.exports, "gridSize", function () { return $cb35c83dc728070d$export$6d8204c2cb2e06b8; });
$parcel$export(module.exports, "fontSize", function () { return $cb35c83dc728070d$export$85e3c3ca0c6fb93; });
$parcel$export(module.exports, "layers", function () { return $cb35c83dc728070d$export$7be255094ccdc533; });

var $e2xkU = parcelRequire("e2xkU");

var $lmjFT = parcelRequire("lmjFT");
var $cb35c83dc728070d$export$44ffba16bd48dac6 = "__ATLASKIT_THEME__";
var $cb35c83dc728070d$export$c93026a968943f95 = "light";
var $cb35c83dc728070d$export$6ba72c8346b4c57e = [
    "light",
    "dark"
];
var $cb35c83dc728070d$export$7a57f79000377ca2 = function borderRadius() {
    return 3;
};
var $cb35c83dc728070d$export$6d8204c2cb2e06b8 = function gridSize() {
    return 8;
};
var $cb35c83dc728070d$export$85e3c3ca0c6fb93 = function fontSize() {
    return 14;
};
var $cb35c83dc728070d$export$6746fe0d9c9fab54 = function fontSizeSmall() {
    return 11;
};
var $cb35c83dc728070d$export$a5975749f0374264 = function fontFamily() {
    return "-apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif";
};
var $cb35c83dc728070d$export$356129969ee49c55 = function codeFontFamily() {
    return "'SFMono-Medium', 'SF Mono', 'Segoe UI Mono', 'Roboto Mono', 'Ubuntu Mono', Menlo, Consolas, Courier, monospace";
};
var $cb35c83dc728070d$export$8e24544ddba725ee = function focusRing() {
    var color = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "var(--ds-border-focused, ".concat((0, $lmjFT.B200), ")");
    var outlineWidth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $cb35c83dc728070d$export$6d8204c2cb2e06b8() / 4;
    (0, $e2xkU.default)("@atlaskit/theme", "focus ring mixin", "Please use `@atlaskit/focus-ring` instead.");
    return "\n  &:focus {\n    outline: none;\n    box-shadow: 0px 0px 0px ".concat(outlineWidth, "px ").concat(color, ";\n  }\n");
};
var $cb35c83dc728070d$export$c0dd343266bc3261 = function noFocusRing() {
    return "\n  box-shadow: none;\n";
};
var $cb35c83dc728070d$export$7be255094ccdc533 = {
    card: function card() {
        return 100;
    },
    navigation: function navigation() {
        return 200;
    },
    dialog: function dialog() {
        return 300;
    },
    layer: function layer() {
        return 400;
    },
    blanket: function blanket() {
        return 500;
    },
    modal: function modal() {
        return 510;
    },
    flag: function flag() {
        return 600;
    },
    spotlight: function spotlight() {
        return 700;
    },
    tooltip: function tooltip() {
        return 9999;
    }
};
var $cb35c83dc728070d$export$a1b3edb637fb4f35 = function visuallyHidden() {
    (0, $e2xkU.default)("@atlaskit/theme", "visually hidden mixin", "Please use `@atlaskit/visually-hidden` instead.");
    return {
        border: "0 !important",
        clip: "rect(1px, 1px, 1px, 1px) !important",
        height: "1px !important",
        overflow: "hidden !important",
        padding: "0 !important",
        position: "absolute !important",
        width: "1px !important",
        whiteSpace: "nowrap !important"
    };
};
var $cb35c83dc728070d$export$ba1d834b86d72a09 = $cb35c83dc728070d$export$a1b3edb637fb4f35;
var $cb35c83dc728070d$export$e497e856b4f89fcd = function skeletonShimmer() {
    return {
        css: {
            backgroundColor: "var(--ds-skeleton, ".concat((0, $lmjFT.skeleton)(), ")"),
            animationDuration: "1.5s",
            animationIterationCount: "infinite",
            animationTimingFunction: "linear",
            animationDirection: "alternate"
        },
        keyframes: {
            from: {
                backgroundColor: "var(--ds-skeleton, ".concat((0, $lmjFT.skeleton)(), ")")
            },
            to: {
                backgroundColor: "var(--ds-skeleton-subtle, ".concat((0, $lmjFT.N30A), ")")
            }
        }
    };
};

});
parcelRegister("lmjFT", function(module, exports) {

$parcel$export(module.exports, "R300", function () { return $f8caea0be66af7b4$export$4a7404f376229999; });
$parcel$export(module.exports, "R400", function () { return $f8caea0be66af7b4$export$2010d0fb4295b346; });
$parcel$export(module.exports, "R500", function () { return $f8caea0be66af7b4$export$2837b5a1a71d5c02; });
$parcel$export(module.exports, "Y400", function () { return $f8caea0be66af7b4$export$59619663aa6500fb; });
$parcel$export(module.exports, "G300", function () { return $f8caea0be66af7b4$export$940e1f69e873f202; });
$parcel$export(module.exports, "G400", function () { return $f8caea0be66af7b4$export$a49394138f7b8e85; });
$parcel$export(module.exports, "B50", function () { return $f8caea0be66af7b4$export$226de0355ed012f8; });
$parcel$export(module.exports, "B75", function () { return $f8caea0be66af7b4$export$8c13c2ee36917869; });
$parcel$export(module.exports, "B200", function () { return $f8caea0be66af7b4$export$215b7063051591f1; });
$parcel$export(module.exports, "B300", function () { return $f8caea0be66af7b4$export$e62e8919cca44969; });
$parcel$export(module.exports, "B400", function () { return $f8caea0be66af7b4$export$b3de0ae08da2ce64; });
$parcel$export(module.exports, "B500", function () { return $f8caea0be66af7b4$export$a6ee3d71bc067634; });
$parcel$export(module.exports, "P300", function () { return $f8caea0be66af7b4$export$b48405b95304b5a1; });
$parcel$export(module.exports, "N0", function () { return $f8caea0be66af7b4$export$29a4f05edc054374; });
$parcel$export(module.exports, "N20", function () { return $f8caea0be66af7b4$export$9fdfb749e33cdf97; });
$parcel$export(module.exports, "N40", function () { return $f8caea0be66af7b4$export$1ce2d1575d444ceb; });
$parcel$export(module.exports, "N90", function () { return $f8caea0be66af7b4$export$7c87d337fb91a97d; });
$parcel$export(module.exports, "N200", function () { return $f8caea0be66af7b4$export$f563ee71e9ee74cd; });
$parcel$export(module.exports, "N400", function () { return $f8caea0be66af7b4$export$eece5f492e429f08; });
$parcel$export(module.exports, "N500", function () { return $f8caea0be66af7b4$export$c39c0fe0f26207ae; });
$parcel$export(module.exports, "N700", function () { return $f8caea0be66af7b4$export$ad0bacf983b7ddaa; });
$parcel$export(module.exports, "N800", function () { return $f8caea0be66af7b4$export$7d61b15e0da132af; });
$parcel$export(module.exports, "N20A", function () { return $f8caea0be66af7b4$export$8d43898f60b96a82; });
$parcel$export(module.exports, "N30A", function () { return $f8caea0be66af7b4$export$920c0d5c49070351; });
$parcel$export(module.exports, "N50A", function () { return $f8caea0be66af7b4$export$7d3359664e8bb0e5; });
$parcel$export(module.exports, "N60A", function () { return $f8caea0be66af7b4$export$d2d3bedfb276cac0; });
$parcel$export(module.exports, "N70A", function () { return $f8caea0be66af7b4$export$6e5e7499ff054f6d; });
$parcel$export(module.exports, "heading", function () { return $f8caea0be66af7b4$export$46e4a324ac90507f; });
$parcel$export(module.exports, "subtleHeading", function () { return $f8caea0be66af7b4$export$79f3f2b82beb0d36; });
$parcel$export(module.exports, "skeleton", function () { return $f8caea0be66af7b4$export$2a0674ff2eb10214; });
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ 
var $wEo3O = parcelRequire("wEo3O");
var $f8caea0be66af7b4$export$4b84fd0e2c617bd = "#FFEBE6";
var $f8caea0be66af7b4$export$b34b069eff244586 = "#FFBDAD";
var $f8caea0be66af7b4$export$be802dd0d8b57f35 = "#FF8F73";
var $f8caea0be66af7b4$export$60847d42f9da92a6 = "#FF7452";
var $f8caea0be66af7b4$export$4a7404f376229999 = "#FF5630";
var $f8caea0be66af7b4$export$2010d0fb4295b346 = "#DE350B";
var $f8caea0be66af7b4$export$2837b5a1a71d5c02 = "#BF2600";
var $f8caea0be66af7b4$export$8d9596b529bbb9cf = "#FFFAE6";
var $f8caea0be66af7b4$export$41060a744ab0b7ae = "#FFF0B3";
var $f8caea0be66af7b4$export$1cc05bbbf340e559 = "#FFE380";
var $f8caea0be66af7b4$export$5aae31392d72caaa = "#FFC400";
var $f8caea0be66af7b4$export$c6930421db9fa514 = "#FFAB00";
var $f8caea0be66af7b4$export$59619663aa6500fb = "#FF991F";
var $f8caea0be66af7b4$export$874739ea9e379ab6 = "#FF8B00";
var $f8caea0be66af7b4$export$8a6341c32b6a3ee6 = "#E3FCEF";
var $f8caea0be66af7b4$export$69a3bf21b9686c2b = "#ABF5D1";
var $f8caea0be66af7b4$export$afbce1382ec95f73 = "#79F2C0";
var $f8caea0be66af7b4$export$747d86715d4175de = "#57D9A3";
var $f8caea0be66af7b4$export$940e1f69e873f202 = "#36B37E";
var $f8caea0be66af7b4$export$a49394138f7b8e85 = "#00875A";
var $f8caea0be66af7b4$export$6fa04827ac68a4fb = "#006644";
var $f8caea0be66af7b4$export$226de0355ed012f8 = "#DEEBFF";
var $f8caea0be66af7b4$export$8c13c2ee36917869 = "#B3D4FF";
var $f8caea0be66af7b4$export$ecfc1dff386a3e7a = "#4C9AFF";
var $f8caea0be66af7b4$export$215b7063051591f1 = "#2684FF";
var $f8caea0be66af7b4$export$e62e8919cca44969 = "#0065FF";
var $f8caea0be66af7b4$export$b3de0ae08da2ce64 = "#0052CC";
var $f8caea0be66af7b4$export$a6ee3d71bc067634 = "#0747A6";
var $f8caea0be66af7b4$export$363e4475840015bb = "#EAE6FF";
var $f8caea0be66af7b4$export$4b0a4417ed59760f = "#C0B6F2";
var $f8caea0be66af7b4$export$6011520a64d9a187 = "#998DD9";
var $f8caea0be66af7b4$export$a7175d4e9206bc80 = "#8777D9";
var $f8caea0be66af7b4$export$b48405b95304b5a1 = "#6554C0";
var $f8caea0be66af7b4$export$c71e4279dd54a18d = "#5243AA";
var $f8caea0be66af7b4$export$147899de772240ec = "#403294";
var $f8caea0be66af7b4$export$2cf711fe14c66f06 = "#E6FCFF";
var $f8caea0be66af7b4$export$7a8f4d33f6f9772c = "#B3F5FF";
var $f8caea0be66af7b4$export$776c9c497ef08533 = "#79E2F2";
var $f8caea0be66af7b4$export$69cb3ca10c1e330e = "#00C7E6";
var $f8caea0be66af7b4$export$9dc1ef0f3f48059b = "#00B8D9";
var $f8caea0be66af7b4$export$7c835c78b6fcdef8 = "#00A3BF";
var $f8caea0be66af7b4$export$6036577f95c3877e = "#008DA6";
var $f8caea0be66af7b4$export$29a4f05edc054374 = "#FFFFFF";
var $f8caea0be66af7b4$export$e655ef011c4aa1a2 = "#FAFBFC";
var $f8caea0be66af7b4$export$9fdfb749e33cdf97 = "#F4F5F7";
var $f8caea0be66af7b4$export$3e51e8f1440314ba = "#EBECF0";
var $f8caea0be66af7b4$export$1ce2d1575d444ceb = "#DFE1E6";
var $f8caea0be66af7b4$export$8754fc7e6d8b3000 = "#C1C7D0";
var $f8caea0be66af7b4$export$c2e91cbeada39b8b = "#B3BAC5";
var $f8caea0be66af7b4$export$5f71e19f3a7ad9de = "#A5ADBA";
var $f8caea0be66af7b4$export$eaa8c8a70ac22806 = "#97A0AF";
var $f8caea0be66af7b4$export$7c87d337fb91a97d = "#8993A4";
var $f8caea0be66af7b4$export$d6447c357493214f = "#7A869A";
var $f8caea0be66af7b4$export$f563ee71e9ee74cd = "#6B778C";
var $f8caea0be66af7b4$export$e2ef2124cf4024b1 = "#5E6C84";
var $f8caea0be66af7b4$export$eece5f492e429f08 = "#505F79";
var $f8caea0be66af7b4$export$c39c0fe0f26207ae = "#42526E";
var $f8caea0be66af7b4$export$7090862dc3038a9f = "#344563";
var $f8caea0be66af7b4$export$ad0bacf983b7ddaa = "#253858";
var $f8caea0be66af7b4$export$7d61b15e0da132af = "#172B4D";
var $f8caea0be66af7b4$export$fbda843f0a27fe96 = "#091E42";
var $f8caea0be66af7b4$export$791e57b27ca738ef = "rgba(9, 30, 66, 0.02)";
var $f8caea0be66af7b4$export$8d43898f60b96a82 = "rgba(9, 30, 66, 0.04)";
var $f8caea0be66af7b4$export$920c0d5c49070351 = "rgba(9, 30, 66, 0.08)";
var $f8caea0be66af7b4$export$46987b49aab6d1a8 = "rgba(9, 30, 66, 0.13)";
var $f8caea0be66af7b4$export$7d3359664e8bb0e5 = "rgba(9, 30, 66, 0.25)";
var $f8caea0be66af7b4$export$d2d3bedfb276cac0 = "rgba(9, 30, 66, 0.31)";
var $f8caea0be66af7b4$export$6e5e7499ff054f6d = "rgba(9, 30, 66, 0.36)";
var $f8caea0be66af7b4$export$59264b346c877fa7 = "rgba(9, 30, 66, 0.42)";
var $f8caea0be66af7b4$export$d092757d7c64925c = "rgba(9, 30, 66, 0.48)";
var $f8caea0be66af7b4$export$486ab785e4bac3c6 = "rgba(9, 30, 66, 0.54)";
var $f8caea0be66af7b4$export$fba592bbc6419fea = "rgba(9, 30, 66, 0.60)";
var $f8caea0be66af7b4$export$13609db0e6812ab8 = "rgba(9, 30, 66, 0.66)";
var $f8caea0be66af7b4$export$fbae4efaa892d883 = "rgba(9, 30, 66, 0.71)";
var $f8caea0be66af7b4$export$f13946d26f440ce6 = "rgba(9, 30, 66, 0.77)";
var $f8caea0be66af7b4$export$19f58225ac52a306 = "rgba(9, 30, 66, 0.82)";
var $f8caea0be66af7b4$export$6384f09da70e7b62 = "rgba(9, 30, 66, 0.89)";
var $f8caea0be66af7b4$export$d0dccc730683edc2 = "rgba(9, 30, 66, 0.95)";
var $f8caea0be66af7b4$export$2f6319cf7d736c2a = "#E6EDFA";
var $f8caea0be66af7b4$export$95126bc8884d6634 = "#DCE5F5";
var $f8caea0be66af7b4$export$8338d8c35d44ff1 = "#CED9EB";
var $f8caea0be66af7b4$export$5368d76ae4fbbda7 = "#B8C7E0";
var $f8caea0be66af7b4$export$9f0a771d16ec8d36 = "#ABBBD6";
var $f8caea0be66af7b4$export$abcf8c38338b4aa5 = "#9FB0CC";
var $f8caea0be66af7b4$export$97e81faa16a182c7 = "#8C9CB8";
var $f8caea0be66af7b4$export$bfe21c59123ecf33 = "#7988A3";
var $f8caea0be66af7b4$export$ee82aa2ea6a1558 = "#67758F";
var $f8caea0be66af7b4$export$682927c6ed76be02 = "#56637A";
var $f8caea0be66af7b4$export$91fd9994c5be9757 = "#455166";
var $f8caea0be66af7b4$export$d281fbfe3cff2df6 = "#3B475C";
var $f8caea0be66af7b4$export$3902c91d8b98a753 = "#313D52";
var $f8caea0be66af7b4$export$8e8133c1ba5845b5 = "#283447";
var $f8caea0be66af7b4$export$33ff357f6620b39 = "#202B3D";
var $f8caea0be66af7b4$export$633847cf062b69e0 = "#1B2638";
var $f8caea0be66af7b4$export$9776a6e503bdbf76 = "#121A29";
var $f8caea0be66af7b4$export$6c813d5160dff5db = "#0E1624";
var $f8caea0be66af7b4$export$3d4f271a500072a = "#0D1424";
var $f8caea0be66af7b4$export$fe151285c22759ec = "rgba(13, 20, 36, 0.06)";
var $f8caea0be66af7b4$export$a101c6190d0da34 = "rgba(13, 20, 36, 0.14)";
var $f8caea0be66af7b4$export$4b16f52932fda51 = "rgba(13, 20, 36, 0.18)";
var $f8caea0be66af7b4$export$a74bcd7b9845b0d8 = "rgba(13, 20, 36, 0.29)";
var $f8caea0be66af7b4$export$9209c179316d1751 = "rgba(13, 20, 36, 0.36)";
var $f8caea0be66af7b4$export$88f55133f636c8dd = "rgba(13, 20, 36, 0.40)";
var $f8caea0be66af7b4$export$51126f85d1009512 = "rgba(13, 20, 36, 0.47)";
var $f8caea0be66af7b4$export$a069b547bd23af78 = "rgba(13, 20, 36, 0.53)";
var $f8caea0be66af7b4$export$40cce05af3b2600a = "rgba(13, 20, 36, 0.63)";
var $f8caea0be66af7b4$export$b78942185925a0d = "rgba(13, 20, 36, 0.73)";
var $f8caea0be66af7b4$export$e058fb44b8eaafca = "rgba(13, 20, 36, 0.78)";
var $f8caea0be66af7b4$export$92b0b8de26920c18 = "rgba(13, 20, 36, 0.81)";
var $f8caea0be66af7b4$export$67564f7459d3fc9e = "rgba(13, 20, 36, 0.85)";
var $f8caea0be66af7b4$export$77868e1ca884ffa3 = "rgba(13, 20, 36, 0.89)";
var $f8caea0be66af7b4$export$2afd71d7d3ea2cd5 = "rgba(13, 20, 36, 0.92)";
var $f8caea0be66af7b4$export$f2a0acaab9972c70 = "rgba(13, 20, 36, 0.95)";
var $f8caea0be66af7b4$export$9ab70e67d6475361 = "rgba(13, 20, 36, 0.97)";
var $f8caea0be66af7b4$export$8ce1fd94bee2f412 = (0, $wEo3O.default)({
    light: "var(--ds-surface, ".concat($f8caea0be66af7b4$export$29a4f05edc054374, ")"),
    dark: "var(--ds-surface, ".concat($f8caea0be66af7b4$export$633847cf062b69e0, ")")
});
var $f8caea0be66af7b4$export$b861914ea877b580 = (0, $wEo3O.default)({
    light: "var(--ds-background-selected, ".concat($f8caea0be66af7b4$export$226de0355ed012f8, ")"),
    dark: "var(--ds-background-selected, ".concat($f8caea0be66af7b4$export$8c13c2ee36917869, ")")
});
var $f8caea0be66af7b4$export$3f1b020df94387af = (0, $wEo3O.default)({
    light: "var(--ds-background-neutral-hovered, ".concat($f8caea0be66af7b4$export$3e51e8f1440314ba, ")"),
    dark: "var(--ds-background-neutral-hovered, ".concat($f8caea0be66af7b4$export$d281fbfe3cff2df6, ")")
});
var $f8caea0be66af7b4$export$c0183dbab98ca63e = (0, $wEo3O.default)({
    light: "var(--ds-surface-overlay, ".concat($f8caea0be66af7b4$export$29a4f05edc054374, ")"),
    dark: "var(--ds-surface-overlay, ".concat($f8caea0be66af7b4$export$8e8133c1ba5845b5, ")")
});
var $f8caea0be66af7b4$export$6f093cfa640b7166 = (0, $wEo3O.default)({
    light: "var(--ds-text, ".concat($f8caea0be66af7b4$export$fbda843f0a27fe96, ")"),
    dark: "var(--ds-text, ".concat($f8caea0be66af7b4$export$5368d76ae4fbbda7, ")")
});
var $f8caea0be66af7b4$export$42f8e9c698766e7a = (0, $wEo3O.default)({
    light: "var(--ds-text, ".concat($f8caea0be66af7b4$export$7d61b15e0da132af, ")"),
    dark: "var(--ds-text, ".concat($f8caea0be66af7b4$export$5368d76ae4fbbda7, ")")
});
var $f8caea0be66af7b4$export$c2d157ca1c34b6e3 = (0, $wEo3O.default)({
    light: "var(--ds-text-selected, ".concat($f8caea0be66af7b4$export$b3de0ae08da2ce64, ")"),
    dark: "var(--ds-text-selected, ".concat($f8caea0be66af7b4$export$b3de0ae08da2ce64, ")")
});
var $f8caea0be66af7b4$export$1905ba28d7cf066f = (0, $wEo3O.default)({
    light: "var(--ds-text-subtlest, ".concat($f8caea0be66af7b4$export$f563ee71e9ee74cd, ")"),
    dark: "var(--ds-text-subtlest, ".concat($f8caea0be66af7b4$export$97e81faa16a182c7, ")")
});
var $f8caea0be66af7b4$export$bd9002130d306d39 = (0, $wEo3O.default)({
    light: "var(--ds-text-subtlest, ".concat($f8caea0be66af7b4$export$f563ee71e9ee74cd, ")"),
    dark: "var(--ds-text-subtlest, ".concat($f8caea0be66af7b4$export$bfe21c59123ecf33, ")")
});
var $f8caea0be66af7b4$export$46e4a324ac90507f = (0, $wEo3O.default)({
    light: "var(--ds-text, ".concat($f8caea0be66af7b4$export$7d61b15e0da132af, ")"),
    dark: "var(--ds-text, ".concat($f8caea0be66af7b4$export$5368d76ae4fbbda7, ")")
});
var $f8caea0be66af7b4$export$79f3f2b82beb0d36 = (0, $wEo3O.default)({
    light: "var(--ds-text-subtlest, ".concat($f8caea0be66af7b4$export$f563ee71e9ee74cd, ")"),
    dark: "var(--ds-text-subtlest, ".concat($f8caea0be66af7b4$export$97e81faa16a182c7, ")")
});
var $f8caea0be66af7b4$export$7bb0d5c671655cc4 = (0, $wEo3O.default)({
    light: $f8caea0be66af7b4$export$9fdfb749e33cdf97,
    dark: $f8caea0be66af7b4$export$8e8133c1ba5845b5
});
var $f8caea0be66af7b4$export$9c30223ca0a664fb = (0, $wEo3O.default)({
    light: "var(--ds-link, ".concat($f8caea0be66af7b4$export$b3de0ae08da2ce64, ")"),
    dark: "var(--ds-link, ".concat($f8caea0be66af7b4$export$ecfc1dff386a3e7a, ")")
});
var $f8caea0be66af7b4$export$7ed258b0728b004b = (0, $wEo3O.default)({
    light: "var(--ds-link-pressed, ".concat($f8caea0be66af7b4$export$e62e8919cca44969, ")"),
    dark: "var(--ds-link-pressed, ".concat($f8caea0be66af7b4$export$215b7063051591f1, ")")
});
var $f8caea0be66af7b4$export$dfa920d8decc8a59 = (0, $wEo3O.default)({
    light: "var(--ds-link-pressed, ".concat($f8caea0be66af7b4$export$a6ee3d71bc067634, ")"),
    dark: "var(--ds-link-pressed, ".concat($f8caea0be66af7b4$export$ecfc1dff386a3e7a, ")")
});
var $f8caea0be66af7b4$export$6069e6ad5c78f632 = (0, $wEo3O.default)({
    light: "var(--ds-border-focused, ".concat($f8caea0be66af7b4$export$215b7063051591f1, ")"),
    dark: "var(--ds-border-focused, ".concat($f8caea0be66af7b4$export$215b7063051591f1, ")")
});
var $f8caea0be66af7b4$export$9ad721cf3b3debe0 = (0, $wEo3O.default)({
    light: "var(--ds-background-brand-bold, ".concat($f8caea0be66af7b4$export$b3de0ae08da2ce64, ")"),
    dark: "var(--ds-background-brand-bold, ".concat($f8caea0be66af7b4$export$ecfc1dff386a3e7a, ")")
});
var $f8caea0be66af7b4$export$2aa0182783e7e9de = (0, $wEo3O.default)({
    light: $f8caea0be66af7b4$export$b3de0ae08da2ce64,
    dark: $f8caea0be66af7b4$export$ecfc1dff386a3e7a
});
var $f8caea0be66af7b4$export$8bf7dff220b82b4a = (0, $wEo3O.default)({
    light: $f8caea0be66af7b4$export$9dc1ef0f3f48059b,
    dark: $f8caea0be66af7b4$export$69cb3ca10c1e330e
});
var $f8caea0be66af7b4$export$e13cce2a2d16a9d4 = (0, $wEo3O.default)({
    light: $f8caea0be66af7b4$export$b48405b95304b5a1,
    dark: $f8caea0be66af7b4$export$6011520a64d9a187
});
var $f8caea0be66af7b4$export$a90204d1394caf30 = (0, $wEo3O.default)({
    light: $f8caea0be66af7b4$export$4a7404f376229999,
    dark: $f8caea0be66af7b4$export$4a7404f376229999
});
var $f8caea0be66af7b4$export$594c5a8758200c32 = (0, $wEo3O.default)({
    light: $f8caea0be66af7b4$export$c6930421db9fa514,
    dark: $f8caea0be66af7b4$export$c6930421db9fa514
});
var $f8caea0be66af7b4$export$955a2ebd2fb142ae = (0, $wEo3O.default)({
    light: $f8caea0be66af7b4$export$940e1f69e873f202,
    dark: $f8caea0be66af7b4$export$940e1f69e873f202
});
var $f8caea0be66af7b4$export$2a0674ff2eb10214 = function skeleton() {
    return "var(--ds-skeleton, ".concat($f8caea0be66af7b4$export$8d43898f60b96a82, ")");
};

});
parcelRegister("wEo3O", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0622514e06458fda$export$2e2bcd8739ae039; });
/* eslint-disable prefer-rest-params */ 
var $1yFTx = parcelRequire("1yFTx");
// Unpack custom variants, and get correct value for the current theme
function $0622514e06458fda$var$themedVariants(variantProp, variants) {
    return function(props) {
        var theme = (0, $1yFTx.default)(props);
        if (props && props[variantProp] && variants) {
            var modes = variants[props[variantProp]];
            if (modes && modes[theme.mode]) {
                var value = modes[theme.mode];
                if (value) return value;
                 // TS believes value can be undefined
            }
        }
        return "";
    };
}
function $0622514e06458fda$export$2e2bcd8739ae039(modesOrVariant, variantModes) {
    if (typeof modesOrVariant === "string") return $0622514e06458fda$var$themedVariants(modesOrVariant, variantModes);
    var modes = modesOrVariant;
    return function(props) {
        // Get theme from the user's props
        var theme = (0, $1yFTx.default)(props);
        // User isn't required to provide both light and dark values
        if (theme.mode in modes) {
            var value = modes[theme.mode]; // TS believes value can be undefined
            if (value) return value;
        }
        return "";
    };
}

});
parcelRegister("1yFTx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $122976d422c13c91$export$2e2bcd8739ae039; });

var $hrGjC = parcelRequire("hrGjC");
function $122976d422c13c91$export$2e2bcd8739ae039(props) {
    if (props && props.theme) {
        // Theme is the global Atlaskit theme
        if ((0, $hrGjC.CHANNEL) in props.theme) return props.theme[0, $hrGjC.CHANNEL];
        else if ("mode" in props.theme && (0, $hrGjC.THEME_MODES).includes(props.theme.mode)) return props.theme;
    }
    // If format not supported (or no theme provided), return standard theme
    return {
        mode: (0, $hrGjC.DEFAULT_THEME_MODE)
    };
}

});




parcelRegister("chd6R", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $8f013dda54b231b0$export$6503ec6e8aabbaf; });
/* eslint-disable @atlaskit/design-system/no-direct-use-of-web-platform-drag-and-drop */ /**
 * We are listening directly to drag events instead of using a monitor from
 * `@atlaskit/pragmatic-drag-and-drop` to avoid the bundle size cost, as it
 * would affect almost every view in every product.
 *
 * We can reconsider this choice in the future.
 */ 
var $dd4sf = parcelRequire("dd4sf");
var $8f013dda54b231b0$var$registrations = new Set();
var $8f013dda54b231b0$var$cleanupEndEventListeners = null;
function $8f013dda54b231b0$var$onDragStart() {
    if ($8f013dda54b231b0$var$cleanupEndEventListeners) // If the cleanup function exists then we've already run this
    return;
    $8f013dda54b231b0$var$cleanupEndEventListeners = (0, $dd4sf.bindAll)(window, [
        {
            type: "dragend",
            listener: $8f013dda54b231b0$var$onDragEnd
        },
        {
            type: "pointerdown",
            listener: $8f013dda54b231b0$var$onDragEnd
        },
        {
            type: "pointermove",
            listener: function() {
                var callCount = 0;
                return function listener() {
                    // Using 20 as it is far bigger than the most observed (3)
                    if (callCount < 20) {
                        callCount++;
                        return;
                    }
                    $8f013dda54b231b0$var$onDragEnd();
                };
            }()
        }
    ]);
    var clone = Array.from($8f013dda54b231b0$var$registrations);
    clone.forEach(function(subscriber) {
        subscriber.onDragStart();
    });
}
function $8f013dda54b231b0$var$onDragEnd() {
    var _cleanupEndEventListe;
    (_cleanupEndEventListe = $8f013dda54b231b0$var$cleanupEndEventListeners) === null || _cleanupEndEventListe === void 0 || _cleanupEndEventListe();
    $8f013dda54b231b0$var$cleanupEndEventListeners = null;
    var clone = Array.from($8f013dda54b231b0$var$registrations);
    clone.forEach(function(subscriber) {
        subscriber.onDragEnd();
    });
}
function $8f013dda54b231b0$var$bindStartEvents() {
    return (0, $dd4sf.bindAll)(window, [
        {
            type: "dragstart",
            listener: $8f013dda54b231b0$var$onDragStart
        },
        {
            type: "dragenter",
            listener: $8f013dda54b231b0$var$onDragStart
        }
    ]);
}
var $8f013dda54b231b0$var$cleanupStartEventListeners = null;
function $8f013dda54b231b0$export$6503ec6e8aabbaf(registration) {
    // if first registration, bind event listeners
    if (!$8f013dda54b231b0$var$cleanupStartEventListeners) // note: currently never unbinding these event listeners
    $8f013dda54b231b0$var$cleanupStartEventListeners = $8f013dda54b231b0$var$bindStartEvents();
    $8f013dda54b231b0$var$registrations.add(registration);
    /**
   * The reasoning for this behavior is so that if a tooltip mounts during
   * a drag it can still be suppressed.
   *
   * We use a separate callback instead of onDragStart to avoid infinite loops.
   */ registration.onRegister({
        isDragging: $8f013dda54b231b0$var$cleanupEndEventListeners !== null
    });
    return function unregister() {
        $8f013dda54b231b0$var$registrations.delete(registration);
        if ($8f013dda54b231b0$var$registrations.size === 0) {
            var _cleanupStartEventLis;
            (_cleanupStartEventLis = $8f013dda54b231b0$var$cleanupStartEventListeners) === null || _cleanupStartEventLis === void 0 || _cleanupStartEventLis();
            $8f013dda54b231b0$var$cleanupStartEventListeners = null;
        }
    };
}

});

parcelRegister("lBNBW", function(module, exports) {

$parcel$export(module.exports, "show", function () { return $fbb389663f6d4523$export$57bf213be019eeb0; });

var $6f5G6 = parcelRequire("6f5G6");
// This file is a singleton for managing tooltips
var $fbb389663f6d4523$var$active = null;
function $fbb389663f6d4523$export$57bf213be019eeb0(entry) {
    var phase = "waiting-to-show";
    function isActive() {
        return Boolean($fbb389663f6d4523$var$active && $fbb389663f6d4523$var$active.entry === entry);
    }
    function cleanup() {
        if (isActive()) {
            (0, $6f5G6.clearScheduled)();
            $fbb389663f6d4523$var$active = null;
        }
    }
    function done() {
        if (isActive()) entry.done();
        phase = "done";
        cleanup();
    }
    function immediatelyHideAndDone() {
        if (isActive()) entry.hide({
            isImmediate: true
        });
        done();
    }
    function keep() {
        if (!isActive()) return;
        // aborting a wait to hide
        if (phase === "waiting-to-hide") {
            phase = "shown";
            (0, $6f5G6.clearScheduled)();
            return;
        }
        // aborting hide animation
        if (phase === "hide-animating") {
            phase = "shown";
            (0, $6f5G6.clearScheduled)();
            entry.show({
                isImmediate: false
            });
            return;
        }
    }
    function requestHide(_ref) {
        var isImmediate = _ref.isImmediate;
        if (!isActive()) return;
        // If we were not showing yet anyway; finish straight away
        if (phase === "waiting-to-show") {
            immediatelyHideAndDone();
            return;
        }
        // already waiting to hide
        if (phase === "waiting-to-hide") return;
        if (isImmediate) {
            immediatelyHideAndDone();
            return;
        }
        phase = "waiting-to-hide";
        (0, $6f5G6.scheduleTimeout)(function() {
            phase = "hide-animating";
            entry.hide({
                isImmediate: false
            });
        }, entry.delay);
    }
    function finishHideAnimation() {
        if (isActive() && phase === "hide-animating") done();
    }
    function isVisible() {
        return phase === "shown" || phase === "waiting-to-hide" || phase === "hide-animating";
    }
    function getInitialMouse() {
        if (entry.source.type === "mouse") return entry.source.mouse;
        return null;
    }
    function start() {
        var showImmediately = Boolean($fbb389663f6d4523$var$active && $fbb389663f6d4523$var$active.isVisible());
        // If there was an active tooltip; we tell it to remove itself at once!
        if ($fbb389663f6d4523$var$active) {
            (0, $6f5G6.clearScheduled)();
            $fbb389663f6d4523$var$active.entry.hide({
                isImmediate: true
            });
            $fbb389663f6d4523$var$active.entry.done();
            $fbb389663f6d4523$var$active = null;
        }
        // this tooltip is now the active tooltip
        $fbb389663f6d4523$var$active = {
            entry: entry,
            isVisible: isVisible
        };
        function show() {
            phase = "shown";
            entry.show({
                isImmediate: showImmediately
            });
        }
        if (showImmediately) {
            show();
            return;
        }
        phase = "waiting-to-show";
        (0, $6f5G6.scheduleTimeout)(show, entry.delay);
    }
    // let's get started!
    start();
    var result = {
        keep: keep,
        abort: cleanup,
        isActive: isActive,
        requestHide: requestHide,
        finishHideAnimation: finishHideAnimation,
        mousePosition: getInitialMouse()
    };
    return result;
}

});
parcelRegister("6f5G6", function(module, exports) {

$parcel$export(module.exports, "clearScheduled", function () { return $48b88c51ba54dd23$export$eaf678f6f93f5250; });
$parcel$export(module.exports, "scheduleTimeout", function () { return $48b88c51ba54dd23$export$5f4d6617421d489b; });
var $48b88c51ba54dd23$var$delayId = null;
function $48b88c51ba54dd23$export$eaf678f6f93f5250() {
    if ($48b88c51ba54dd23$var$delayId != null) {
        window.clearTimeout($48b88c51ba54dd23$var$delayId);
        $48b88c51ba54dd23$var$delayId = null;
    }
}
function $48b88c51ba54dd23$export$5f4d6617421d489b(fn, delay) {
    $48b88c51ba54dd23$export$eaf678f6f93f5250();
    $48b88c51ba54dd23$var$delayId = window.setTimeout(function() {
        $48b88c51ba54dd23$var$delayId = null;
        fn();
    }, delay);
}

});


parcelRegister("5niz9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3e9d808e12b46cd9$export$2e2bcd8739ae039; });

var $D9YLo = parcelRequire("D9YLo");
function $3e9d808e12b46cd9$export$2e2bcd8739ae039(prefix, shouldRenderId) {
    var seed = (0, $D9YLo.useUIDSeed)();
    return shouldRenderId ? "".concat(seed(prefix)) : undefined;
}

});

parcelRegister("f5p8F", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $afbad2af3775b43d$export$2e2bcd8739ae039; });
/**
 * @jsxRuntime classic
 */ /** @jsx jsx */ 
var $dAx5m = parcelRequire("dAx5m");

var $jVTBW = parcelRequire("jVTBW");

var $lmjFT = parcelRequire("lmjFT");

var $9S2Wp = parcelRequire("9S2Wp");
var $afbad2af3775b43d$var$baseStyles = (0, $jVTBW.css)({
    boxSizing: "border-box",
    maxWidth: "240px",
    padding: "var(--ds-space-025, 2px)".concat(" ", "var(--ds-space-075, 6px)"),
    insetBlockStart: "var(--ds-space-0, 0px)",
    insetInlineStart: "var(--ds-space-0, 0px)",
    borderRadius: "var(--ds-border-radius, 3px)",
    font: 'var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    overflowWrap: "break-word",
    wordWrap: "break-word",
    backgroundColor: "var(--ds-background-neutral-bold, ".concat((0, $lmjFT.N800), ")"),
    color: "var(--ds-text-inverse, ".concat((0, $lmjFT.N0), ")")
});
var $afbad2af3775b43d$var$truncateStyles = (0, $jVTBW.css)({
    maxWidth: "420px",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap"
});
var $afbad2af3775b43d$var$TooltipContainer = /*#__PURE__*/ (0, $dAx5m.forwardRef)(function TooltipContainer(_ref, ref) {
    var style = _ref.style, className = _ref.className, children = _ref.children, truncate = _ref.truncate, placement = _ref.placement, testId = _ref.testId, onMouseOut = _ref.onMouseOut, onMouseOver = _ref.onMouseOver, id = _ref.id;
    return (0, $jVTBW.jsx)((0, $9S2Wp.default), {
        ref: ref,
        style: style,
        className: className,
        placement: placement,
        testId: testId,
        id: id,
        onMouseOut: onMouseOut,
        onMouseOver: onMouseOver,
        css: [
            $afbad2af3775b43d$var$baseStyles,
            truncate ? $afbad2af3775b43d$var$truncateStyles : null
        ]
    }, children);
});
$afbad2af3775b43d$var$TooltipContainer.displayName = "TooltipContainer";
var $afbad2af3775b43d$export$2e2bcd8739ae039 = $afbad2af3775b43d$var$TooltipContainer;

});
parcelRegister("9S2Wp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $72fb7042ba33dcb9$export$2e2bcd8739ae039; });

var $iDtim = parcelRequire("iDtim");

var $dAx5m = parcelRequire("dAx5m");

var $jVTBW = parcelRequire("jVTBW");

var $hrGjC = parcelRequire("hrGjC");
function $72fb7042ba33dcb9$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $72fb7042ba33dcb9$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $72fb7042ba33dcb9$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($iDtim)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $72fb7042ba33dcb9$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $72fb7042ba33dcb9$var$VAR_PRIMITIVE_ZINDEX = "tooltipPrimitiveZindex";
var $72fb7042ba33dcb9$var$primitiveStyles = (0, $jVTBW.css)({
    zindex: "var(".concat($72fb7042ba33dcb9$var$VAR_PRIMITIVE_ZINDEX, ")"),
    cursor: "default"
});
var $72fb7042ba33dcb9$var$TooltipPrimitive = /*#__PURE__*/ (0, $dAx5m.forwardRef)(function TooltipPrimitive(_ref, ref) {
    var style = _ref.style, className = _ref.className, children = _ref.children, placement = _ref.placement, testId = _ref.testId, onMouseOut = _ref.onMouseOut, onMouseOver = _ref.onMouseOver, id = _ref.id;
    var styleWithZIndex = $72fb7042ba33dcb9$var$_objectSpread($72fb7042ba33dcb9$var$_objectSpread({}, style), {}, (0, (/*@__PURE__*/$parcel$interopDefault($iDtim)))({}, $72fb7042ba33dcb9$var$VAR_PRIMITIVE_ZINDEX, (0, $hrGjC.layers).tooltip()));
    return (0, $jVTBW.jsx)("div", {
        ref: ref,
        style: styleWithZIndex,
        "data-testid": testId ? "".concat(testId, "--wrapper") : undefined
    }, (0, $jVTBW.jsx)("div", {
        role: "tooltip",
        className: className,
        onMouseOut: onMouseOut,
        onMouseOver: onMouseOver,
        css: $72fb7042ba33dcb9$var$primitiveStyles,
        "data-placement": placement,
        "data-testid": testId,
        id: id
    }, children));
});
$72fb7042ba33dcb9$var$TooltipPrimitive.displayName = "TooltipPrimitive";
var $72fb7042ba33dcb9$export$2e2bcd8739ae039 = $72fb7042ba33dcb9$var$TooltipPrimitive;

});


parcelRegister("6HRoa", function(module, exports) {

$parcel$export(module.exports, "getMousePosition", function () { return $4e202c1fda7e9bc9$export$642213d516a9b928; });
function $4e202c1fda7e9bc9$export$642213d516a9b928(mouseCoordinates) {
    var safeMouse = mouseCoordinates || {
        top: 0,
        left: 0
    };
    var getBoundingClientRect = function getBoundingClientRect() {
        return {
            top: safeMouse.top,
            left: safeMouse.left,
            bottom: safeMouse.top,
            right: safeMouse.left,
            width: 0,
            height: 0
        };
    };
    return {
        getBoundingClientRect: getBoundingClientRect,
        clientWidth: 0,
        clientHeight: 0
    };
}

});


parcelRegister("cj4Qn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8f5b04451aae0793$export$2e2bcd8739ae039; });

var $dAx5m = parcelRequire("dAx5m");

var $ez4n6 = parcelRequire("ez4n6");

var $No0DT = parcelRequire("No0DT");

var $kD8GD = parcelRequire("kD8GD");

var $86M4Q = parcelRequire("86M4Q");
/**
 * __Use icon button__
 *
 * A React hook that accepts a set of icon Button props,
 * and processes them to return consistent base props for usage
 * across IconButton and LinkIconButton variants.
 *
 * @private
 */ var $8f5b04451aae0793$var$useIconButton = function useIconButton(_ref) {
    var analyticsContext = _ref.analyticsContext, appearance = _ref.appearance, autoFocus = _ref.autoFocus, buttonType = _ref.buttonType, Icon = _ref.icon, interactionName = _ref.interactionName, isDisabled = _ref.isDisabled, isSelected = _ref.isSelected, isLoading = _ref.isLoading, label = _ref.label, onClick = _ref.onClick, onMouseDownCapture = _ref.onMouseDownCapture, onMouseUpCapture = _ref.onMouseUpCapture, onKeyDownCapture = _ref.onKeyDownCapture, onKeyUpCapture = _ref.onKeyUpCapture, onTouchStartCapture = _ref.onTouchStartCapture, onTouchEndCapture = _ref.onTouchEndCapture, onPointerDownCapture = _ref.onPointerDownCapture, onPointerUpCapture = _ref.onPointerUpCapture, onClickCapture = _ref.onClickCapture, overlay = _ref.overlay, ref = _ref.ref, shape = _ref.shape, shouldFitContainer = _ref.shouldFitContainer, spacing = _ref.spacing, UNSAFE_size = _ref.UNSAFE_size;
    var hasOverlay = Boolean(overlay || isLoading);
    var isCircle = shape === "circle";
    var baseProps = (0, $86M4Q.default)({
        analyticsContext: analyticsContext,
        appearance: appearance,
        autoFocus: autoFocus,
        buttonType: buttonType,
        children: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $No0DT.default), {
            type: "icon",
            hasOverlay: hasOverlay
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement(Icon, {
            label: "",
            size: UNSAFE_size,
            color: "currentColor"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $ez4n6.default), null, label)),
        interactionName: interactionName,
        isDisabled: isDisabled,
        isLoading: isLoading,
        isSelected: isSelected,
        isIconButton: true,
        isCircle: isCircle,
        onClick: onClick,
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onTouchStartCapture: onTouchStartCapture,
        onTouchEndCapture: onTouchEndCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onClickCapture: onClickCapture,
        overlay: isLoading ? (0, $kD8GD.default)({
            spacing: spacing,
            appearance: appearance,
            isDisabled: isDisabled,
            isSelected: isSelected
        }) : overlay,
        ref: ref,
        shouldFitContainer: shouldFitContainer,
        spacing: spacing
    });
    return baseProps;
};
var $8f5b04451aae0793$export$2e2bcd8739ae039 = $8f5b04451aae0793$var$useIconButton;

});
parcelRegister("No0DT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0947337a190872dc$export$2e2bcd8739ae039; });

var $k2EOa = parcelRequire("k2EOa");

var $dAx5m = parcelRequire("dAx5m");

var $iGrUY = parcelRequire("iGrUY");
var $aGSBL = parcelRequire("aGSBL");
var $0947337a190872dc$var$textStyles = (0, $aGSBL.xcss)({
    // content can grow and shrink
    flexGrow: 1,
    flexShrink: 1,
    // ellipsis for overflow text
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap"
});
var $0947337a190872dc$var$iconStyles = (0, $aGSBL.xcss)({
    display: "flex",
    // icon size cannot grow and shrink
    flexGrow: 0,
    flexShrink: 0,
    alignSelf: "center",
    fontSize: 0,
    lineHeight: 0,
    userSelect: "none"
});
var $0947337a190872dc$var$commonStyles = (0, $aGSBL.xcss)({
    transition: "opacity 0.3s"
});
var $0947337a190872dc$var$fadeStyles = (0, $aGSBL.xcss)({
    opacity: 0
});
/**
 * These CSS variables consumed by the new icons, to allow them to have appropriate
 * padding inside Button while also maintaining spacing for the existing icons.
 *
 * These styles can be removed once the new icons are fully rolled out, feature flag
 * platform.design-system-team.enable-new-icons is cleaned up,
 * and we bump Button to set padding based on the new icons.
 */ var $0947337a190872dc$var$beforeIconStyles = (0, $aGSBL.xcss)({
    // @ts-ignore
    "--ds--button--new-icon-padding-start": "var(--ds-space-050, 4px)",
    // @ts-ignore
    "--ds--button--new-icon-padding-end": "var(--ds-space-025, 2px)"
});
var $0947337a190872dc$var$afterIconStyles = (0, $aGSBL.xcss)({
    // @ts-ignore
    "--ds--button--new-icon-padding-start": "var(--ds-space-025, 2px)",
    // @ts-ignore
    "--ds--button--new-icon-padding-end": "var(--ds-space-050, 4px)"
});
/**
 * __Content__
 *
 * Used for slots within a Button, including icons and text content.
 */ var $0947337a190872dc$var$Content = function Content(_ref) {
    var children = _ref.children, _ref$type = _ref.type, type = _ref$type === void 0 ? "text" : _ref$type, hasOverlay = _ref.hasOverlay, position = _ref.position;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $iGrUY.default), {
        as: "span",
        xcss: [
            $0947337a190872dc$var$commonStyles
        ].concat((0, (/*@__PURE__*/$parcel$interopDefault($k2EOa)))(type === "text" ? [
            $0947337a190872dc$var$textStyles
        ] : [
            $0947337a190872dc$var$iconStyles
        ]), (0, (/*@__PURE__*/$parcel$interopDefault($k2EOa)))(hasOverlay ? [
            $0947337a190872dc$var$fadeStyles
        ] : []), (0, (/*@__PURE__*/$parcel$interopDefault($k2EOa)))(position === "before" ? [
            $0947337a190872dc$var$beforeIconStyles
        ] : []), (0, (/*@__PURE__*/$parcel$interopDefault($k2EOa)))(position === "after" ? [
            $0947337a190872dc$var$afterIconStyles
        ] : []))
    }, children);
};
var $0947337a190872dc$export$2e2bcd8739ae039 = $0947337a190872dc$var$Content;

});

parcelRegister("kD8GD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f04e302b5b3012d5$export$2e2bcd8739ae039; });

var $dAx5m = parcelRequire("dAx5m");

var $4EnCe = parcelRequire("4EnCe");
function $f04e302b5b3012d5$var$getIconSpacing(spacing) {
    switch(spacing){
        case "compact":
            return "small";
        case "none":
            return "xsmall";
        default:
            return "medium";
    }
}
function $f04e302b5b3012d5$var$getSpinnerAppearance(_ref) {
    var appearance = _ref.appearance, isDisabled = _ref.isDisabled, isSelected = _ref.isSelected;
    if (isDisabled || isSelected) return "inherit";
    if (appearance === "primary" || appearance === "danger" || appearance === "discovery") return "invert";
    return "inherit";
}
function $f04e302b5b3012d5$export$2e2bcd8739ae039(_ref2) {
    var appearance = _ref2.appearance, spacing = _ref2.spacing, isDisabled = _ref2.isDisabled, isSelected = _ref2.isSelected;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $4EnCe.default), {
        label: ", Loading",
        size: $f04e302b5b3012d5$var$getIconSpacing(spacing),
        appearance: $f04e302b5b3012d5$var$getSpinnerAppearance({
            appearance: appearance,
            isDisabled: isDisabled,
            isSelected: isSelected
        })
    });
}

});
parcelRegister("4EnCe", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $362d3767a4c900cc$export$2e2bcd8739ae039; });
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $dAx5m = parcelRequire("dAx5m");

var $jVTBW = parcelRequire("jVTBW");

var $kqsmh = parcelRequire("kqsmh");

var $SIMoX = parcelRequire("SIMoX");

var $9TQ8Q = parcelRequire("9TQ8Q");
/**
 * Returns the appropriate circle stroke color.
 */ function $362d3767a4c900cc$var$getStrokeColor(appearance) {
    return appearance === "inherit" ? "var(--ds-icon-subtle, ".concat((0, $SIMoX.N500), ")") : "var(--ds-icon-inverse, ".concat((0, $SIMoX.N0), ")");
}
var $362d3767a4c900cc$var$rotate = (0, $jVTBW.keyframes)({
    to: {
        transform: "rotate(360deg)"
    }
});
var $362d3767a4c900cc$var$rotateStyles = (0, $jVTBW.css)({
    animation: "".concat($362d3767a4c900cc$var$rotate, " 0.86s infinite"),
    animationTimingFunction: "cubic-bezier(0.4, 0.15, 0.6, 0.85)",
    transformOrigin: "center"
});
/**
 * There are three parts to the load in animation:
 * 1. Fade in
 * 2. Accelerated spin
 * 3. Stretch the spinner line
 */ var $362d3767a4c900cc$var$loadIn = (0, $jVTBW.keyframes)({
    from: {
        transform: "rotate(50deg)",
        opacity: 0,
        strokeDashoffset: 60
    },
    to: {
        transform: "rotate(230deg)",
        opacity: 1,
        strokeDashoffset: 50
    }
});
var $362d3767a4c900cc$var$loadInStyles = (0, $jVTBW.css)({
    animation: "".concat($362d3767a4c900cc$var$loadIn, " 1s ease-in-out"),
    /**
   * When the animation completes, stay at the last frame of the animation.
   */ animationFillMode: "forwards",
    /**
   * We are going to animate this in.
   */ opacity: 0
});
var $362d3767a4c900cc$var$wrapperStyles = (0, $jVTBW.css)({
    display: "inline-flex",
    /**
   * Align better inline with text.
   */ verticalAlign: "middle"
});
var $362d3767a4c900cc$var$circleStyles = (0, $jVTBW.css)({
    fill: "none",
    strokeDasharray: 60,
    strokeDashoffset: "inherit",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    "@media screen and (forced-colors: active)": {
        filter: "grayscale(100%)",
        stroke: "CanvasText"
    }
});
/**
 * `useLayoutEffect` is being used in SSR safe form. On the server, this work doesn’t need to run.
 * `useEffect` is used in-place, because `useEffect` is not run on the server and it matches types
 * which makes things simpler than doing an `isServer` check or a `null` check.
 *
 * @see https://hello.atlassian.net/wiki/spaces/DST/pages/2081696628/DSTDACI-010+-+Interaction+Tracing+hooks+in+DS+components
 */ var $362d3767a4c900cc$var$useLayoutEffect = typeof window === "undefined" ? (0, $dAx5m.useEffect) : (0, $dAx5m.useLayoutEffect);
/**
 * __Spinner__
 *
 * A spinner is an animated spinning icon that lets users know content is being loaded.
 *
 * - [Examples](https://atlassian.design/components/spinner/examples)
 * - [Code](https://atlassian.design/components/spinner/code)
 * - [Usage](https://atlassian.design/components/spinner/usage)
 */ var $362d3767a4c900cc$var$Spinner = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).forwardRef(function Spinner(_ref, ref) {
    var _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "inherit" : _ref$appearance, _ref$delay = _ref.delay, delay = _ref$delay === void 0 ? 0 : _ref$delay, interactionName = _ref.interactionName, label = _ref.label, _ref$size = _ref.size, providedSize = _ref$size === void 0 ? "medium" : _ref$size, testId = _ref.testId;
    var size = typeof providedSize === "number" ? providedSize : (0, $9TQ8Q.presetSizes)[providedSize];
    var animationDelay = "".concat(delay, "ms");
    var stroke = $362d3767a4c900cc$var$getStrokeColor(appearance);
    var context = (0, $dAx5m.useContext)((0, $kqsmh.default));
    $362d3767a4c900cc$var$useLayoutEffect(function() {
        if (context != null) return context.hold(interactionName);
    }, [
        context,
        interactionName
    ]);
    /**
   * The Spinner animation uses a combination of two
   * css animations on two separate elements.
   */ return (0, $jVTBW.jsx)("span", {
        /**
     * This span exists to off-load animations from the circle element,
     * which were causing performance issues (style recalculations)
     * on Safari and older versions of Chrome.
     *
     * This can be removed and styles placed back on the circle element once
     * Safari fixes this bug and off-loads rendering to the GPU from the CPU.
     */ css: [
            $362d3767a4c900cc$var$wrapperStyles,
            $362d3767a4c900cc$var$rotateStyles
        ],
        "data-testid": testId && "".concat(testId, "-wrapper"),
        style: {
            animationDelay: animationDelay,
            width: size,
            height: size
        }
    }, (0, $jVTBW.jsx)("svg", {
        height: size,
        width: size,
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        "data-testid": testId,
        ref: ref,
        "aria-label": label || undefined,
        css: $362d3767a4c900cc$var$loadInStyles,
        style: {
            animationDelay: animationDelay
        },
        role: label ? "img" : "none"
    }, (0, $jVTBW.jsx)("circle", {
        cx: "8",
        cy: "8",
        r: "7",
        css: $362d3767a4c900cc$var$circleStyles,
        style: {
            stroke: stroke
        }
    })));
}));
var $362d3767a4c900cc$export$2e2bcd8739ae039 = $362d3767a4c900cc$var$Spinner;

});
parcelRegister("SIMoX", function(module, exports) {

$parcel$export(module.exports, "N0", function () { return $0a47c791fa2fca2b$export$29a4f05edc054374; });
$parcel$export(module.exports, "N500", function () { return $0a47c791fa2fca2b$export$c39c0fe0f26207ae; });
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // Reds
var $0a47c791fa2fca2b$export$4b84fd0e2c617bd = "#FFEBE6";
var $0a47c791fa2fca2b$export$b34b069eff244586 = "#FFBDAD";
var $0a47c791fa2fca2b$export$be802dd0d8b57f35 = "#FF8F73";
var $0a47c791fa2fca2b$export$60847d42f9da92a6 = "#FF7452";
var $0a47c791fa2fca2b$export$4a7404f376229999 = "#FF5630";
var $0a47c791fa2fca2b$export$2010d0fb4295b346 = "#DE350B";
var $0a47c791fa2fca2b$export$2837b5a1a71d5c02 = "#BF2600";
var $0a47c791fa2fca2b$export$8d9596b529bbb9cf = "#FFFAE6";
var $0a47c791fa2fca2b$export$41060a744ab0b7ae = "#FFF0B3";
var $0a47c791fa2fca2b$export$1cc05bbbf340e559 = "#FFE380";
var $0a47c791fa2fca2b$export$5aae31392d72caaa = "#FFC400";
var $0a47c791fa2fca2b$export$c6930421db9fa514 = "#FFAB00";
var $0a47c791fa2fca2b$export$59619663aa6500fb = "#FF991F";
var $0a47c791fa2fca2b$export$874739ea9e379ab6 = "#FF8B00";
var $0a47c791fa2fca2b$export$8a6341c32b6a3ee6 = "#E3FCEF";
var $0a47c791fa2fca2b$export$69a3bf21b9686c2b = "#ABF5D1";
var $0a47c791fa2fca2b$export$afbce1382ec95f73 = "#79F2C0";
var $0a47c791fa2fca2b$export$747d86715d4175de = "#57D9A3";
var $0a47c791fa2fca2b$export$940e1f69e873f202 = "#36B37E";
var $0a47c791fa2fca2b$export$a49394138f7b8e85 = "#00875A";
var $0a47c791fa2fca2b$export$6fa04827ac68a4fb = "#006644";
var $0a47c791fa2fca2b$export$226de0355ed012f8 = "#DEEBFF";
var $0a47c791fa2fca2b$export$8c13c2ee36917869 = "#B3D4FF";
var $0a47c791fa2fca2b$export$ecfc1dff386a3e7a = "#4C9AFF";
var $0a47c791fa2fca2b$export$215b7063051591f1 = "#2684FF";
var $0a47c791fa2fca2b$export$e62e8919cca44969 = "#0065FF";
var $0a47c791fa2fca2b$export$b3de0ae08da2ce64 = "#0052CC";
var $0a47c791fa2fca2b$export$a6ee3d71bc067634 = "#0747A6";
var $0a47c791fa2fca2b$export$363e4475840015bb = "#EAE6FF";
var $0a47c791fa2fca2b$export$4b0a4417ed59760f = "#C0B6F2";
var $0a47c791fa2fca2b$export$6011520a64d9a187 = "#998DD9";
var $0a47c791fa2fca2b$export$a7175d4e9206bc80 = "#8777D9";
var $0a47c791fa2fca2b$export$b48405b95304b5a1 = "#6554C0";
var $0a47c791fa2fca2b$export$c71e4279dd54a18d = "#5243AA";
var $0a47c791fa2fca2b$export$147899de772240ec = "#403294";
var $0a47c791fa2fca2b$export$2cf711fe14c66f06 = "#E6FCFF";
var $0a47c791fa2fca2b$export$7a8f4d33f6f9772c = "#B3F5FF";
var $0a47c791fa2fca2b$export$776c9c497ef08533 = "#79E2F2";
var $0a47c791fa2fca2b$export$69cb3ca10c1e330e = "#00C7E6";
var $0a47c791fa2fca2b$export$9dc1ef0f3f48059b = "#00B8D9";
var $0a47c791fa2fca2b$export$7c835c78b6fcdef8 = "#00A3BF";
var $0a47c791fa2fca2b$export$6036577f95c3877e = "#008DA6";
var $0a47c791fa2fca2b$export$29a4f05edc054374 = "#FFFFFF";
var $0a47c791fa2fca2b$export$e655ef011c4aa1a2 = "#FAFBFC";
var $0a47c791fa2fca2b$export$9fdfb749e33cdf97 = "#F4F5F7";
var $0a47c791fa2fca2b$export$3e51e8f1440314ba = "#EBECF0";
var $0a47c791fa2fca2b$export$1ce2d1575d444ceb = "#DFE1E6";
var $0a47c791fa2fca2b$export$8754fc7e6d8b3000 = "#C1C7D0";
var $0a47c791fa2fca2b$export$c2e91cbeada39b8b = "#B3BAC5";
var $0a47c791fa2fca2b$export$5f71e19f3a7ad9de = "#A5ADBA";
var $0a47c791fa2fca2b$export$eaa8c8a70ac22806 = "#97A0AF";
var $0a47c791fa2fca2b$export$7c87d337fb91a97d = "#8993A4";
var $0a47c791fa2fca2b$export$d6447c357493214f = "#7A869A";
var $0a47c791fa2fca2b$export$f563ee71e9ee74cd = "#6B778C";
var $0a47c791fa2fca2b$export$e2ef2124cf4024b1 = "#5E6C84";
var $0a47c791fa2fca2b$export$eece5f492e429f08 = "#505F79";
var $0a47c791fa2fca2b$export$c39c0fe0f26207ae = "#42526E";
var $0a47c791fa2fca2b$export$7090862dc3038a9f = "#344563";
var $0a47c791fa2fca2b$export$ad0bacf983b7ddaa = "#253858";
var $0a47c791fa2fca2b$export$7d61b15e0da132af = "#172B4D";
var $0a47c791fa2fca2b$export$fbda843f0a27fe96 = "#091E42";
var $0a47c791fa2fca2b$export$791e57b27ca738ef = "rgba(9, 30, 66, 0.02)";
var $0a47c791fa2fca2b$export$8d43898f60b96a82 = "rgba(9, 30, 66, 0.04)";
var $0a47c791fa2fca2b$export$920c0d5c49070351 = "rgba(9, 30, 66, 0.08)";
var $0a47c791fa2fca2b$export$46987b49aab6d1a8 = "rgba(9, 30, 66, 0.13)";
var $0a47c791fa2fca2b$export$7d3359664e8bb0e5 = "rgba(9, 30, 66, 0.25)";
var $0a47c791fa2fca2b$export$d2d3bedfb276cac0 = "rgba(9, 30, 66, 0.31)";
var $0a47c791fa2fca2b$export$6e5e7499ff054f6d = "rgba(9, 30, 66, 0.36)";
var $0a47c791fa2fca2b$export$59264b346c877fa7 = "rgba(9, 30, 66, 0.42)";
var $0a47c791fa2fca2b$export$d092757d7c64925c = "rgba(9, 30, 66, 0.48)";
var $0a47c791fa2fca2b$export$486ab785e4bac3c6 = "rgba(9, 30, 66, 0.54)";
var $0a47c791fa2fca2b$export$fba592bbc6419fea = "rgba(9, 30, 66, 0.60)";
var $0a47c791fa2fca2b$export$13609db0e6812ab8 = "rgba(9, 30, 66, 0.66)";
var $0a47c791fa2fca2b$export$fbae4efaa892d883 = "rgba(9, 30, 66, 0.71)";
var $0a47c791fa2fca2b$export$f13946d26f440ce6 = "rgba(9, 30, 66, 0.77)";
var $0a47c791fa2fca2b$export$19f58225ac52a306 = "rgba(9, 30, 66, 0.82)";
var $0a47c791fa2fca2b$export$6384f09da70e7b62 = "rgba(9, 30, 66, 0.89)";
var $0a47c791fa2fca2b$export$d0dccc730683edc2 = "rgba(9, 30, 66, 0.95)";
var $0a47c791fa2fca2b$export$2f6319cf7d736c2a = "#E6EDFA";
var $0a47c791fa2fca2b$export$95126bc8884d6634 = "#DCE5F5";
var $0a47c791fa2fca2b$export$8338d8c35d44ff1 = "#CED9EB";
var $0a47c791fa2fca2b$export$5368d76ae4fbbda7 = "#B8C7E0";
var $0a47c791fa2fca2b$export$9f0a771d16ec8d36 = "#ABBBD6";
var $0a47c791fa2fca2b$export$abcf8c38338b4aa5 = "#9FB0CC";
var $0a47c791fa2fca2b$export$97e81faa16a182c7 = "#8C9CB8";
var $0a47c791fa2fca2b$export$bfe21c59123ecf33 = "#7988A3";
var $0a47c791fa2fca2b$export$ee82aa2ea6a1558 = "#67758F";
var $0a47c791fa2fca2b$export$682927c6ed76be02 = "#56637A";
var $0a47c791fa2fca2b$export$91fd9994c5be9757 = "#455166";
var $0a47c791fa2fca2b$export$d281fbfe3cff2df6 = "#3B475C";
var $0a47c791fa2fca2b$export$3902c91d8b98a753 = "#313D52";
var $0a47c791fa2fca2b$export$8e8133c1ba5845b5 = "#283447";
var $0a47c791fa2fca2b$export$33ff357f6620b39 = "#202B3D";
var $0a47c791fa2fca2b$export$633847cf062b69e0 = "#1B2638";
var $0a47c791fa2fca2b$export$9776a6e503bdbf76 = "#121A29";
var $0a47c791fa2fca2b$export$6c813d5160dff5db = "#0E1624";
var $0a47c791fa2fca2b$export$3d4f271a500072a = "#0D1424";
var $0a47c791fa2fca2b$export$fe151285c22759ec = "rgba(13, 20, 36, 0.06)";
var $0a47c791fa2fca2b$export$a101c6190d0da34 = "rgba(13, 20, 36, 0.14)";
var $0a47c791fa2fca2b$export$4b16f52932fda51 = "rgba(13, 20, 36, 0.18)";
var $0a47c791fa2fca2b$export$a74bcd7b9845b0d8 = "rgba(13, 20, 36, 0.29)";
var $0a47c791fa2fca2b$export$9209c179316d1751 = "rgba(13, 20, 36, 0.36)";
var $0a47c791fa2fca2b$export$88f55133f636c8dd = "rgba(13, 20, 36, 0.40)";
var $0a47c791fa2fca2b$export$51126f85d1009512 = "rgba(13, 20, 36, 0.47)";
var $0a47c791fa2fca2b$export$a069b547bd23af78 = "rgba(13, 20, 36, 0.53)";
var $0a47c791fa2fca2b$export$40cce05af3b2600a = "rgba(13, 20, 36, 0.63)";
var $0a47c791fa2fca2b$export$b78942185925a0d = "rgba(13, 20, 36, 0.73)";
var $0a47c791fa2fca2b$export$e058fb44b8eaafca = "rgba(13, 20, 36, 0.78)";
var $0a47c791fa2fca2b$export$92b0b8de26920c18 = "rgba(13, 20, 36, 0.81)";
var $0a47c791fa2fca2b$export$67564f7459d3fc9e = "rgba(13, 20, 36, 0.85)";
var $0a47c791fa2fca2b$export$77868e1ca884ffa3 = "rgba(13, 20, 36, 0.89)";
var $0a47c791fa2fca2b$export$2afd71d7d3ea2cd5 = "rgba(13, 20, 36, 0.92)";
var $0a47c791fa2fca2b$export$f2a0acaab9972c70 = "rgba(13, 20, 36, 0.95)";
var $0a47c791fa2fca2b$export$9ab70e67d6475361 = "rgba(13, 20, 36, 0.97)";

});

parcelRegister("9TQ8Q", function(module, exports) {

$parcel$export(module.exports, "presetSizes", function () { return $7351b2613dd58488$export$4e9f1640bbe7a1a8; });
var $7351b2613dd58488$export$4e9f1640bbe7a1a8 = {
    xsmall: 8,
    small: 16,
    medium: 24,
    large: 48,
    xlarge: 96
};

});



parcelRegister("86M4Q", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5e742d5dd814aec6$export$2e2bcd8739ae039; });

var $iDtim = parcelRequire("iDtim");

var $dAx5m = parcelRequire("dAx5m");

var $2Dg3J = parcelRequire("2Dg3J");

var $gMIYi = parcelRequire("gMIYi");

var $5im4X = parcelRequire("5im4X");

var $iGrUY = parcelRequire("iGrUY");
var $aGSBL = parcelRequire("aGSBL");

var $lmjFT = parcelRequire("lmjFT");

var $hrGjC = parcelRequire("hrGjC");

var $glm91 = parcelRequire("glm91");

var $aNabl = parcelRequire("aNabl");
function $5e742d5dd814aec6$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $5e742d5dd814aec6$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $5e742d5dd814aec6$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($iDtim)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $5e742d5dd814aec6$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $5e742d5dd814aec6$var$fontSize = (0, $hrGjC.fontSize)();
var $5e742d5dd814aec6$var$buttonStyles = (0, $aGSBL.xcss)({
    display: "inline-flex",
    boxSizing: "border-box",
    width: "auto",
    maxWidth: "100%",
    position: "relative",
    alignItems: "baseline",
    justifyContent: "center",
    columnGap: "space.050",
    background: "var(--ds-background-neutral, ".concat($lmjFT.N20A, ")"),
    borderRadius: "border.radius.100",
    borderWidth: "border.width.0",
    // @ts-expect-error
    color: "var(--ds-text, ".concat($lmjFT.N500, ")"),
    flexShrink: 0,
    height: "".concat(32 / $5e742d5dd814aec6$var$fontSize, "em"),
    paddingInlineEnd: "space.150",
    paddingInlineStart: "space.150",
    textAlign: "center",
    transition: "background 0.1s ease-out, box-shadow 0.15s cubic-bezier(0.47, 0.03, 0.49, 1.38)",
    verticalAlign: "middle",
    ":visited": {
        // @ts-expect-error
        color: "var(--ds-text, ".concat($lmjFT.N500, ")")
    }
});
var $5e742d5dd814aec6$var$baseButtonStyles = (0, $aGSBL.xcss)({
    fontFamily: "inherit",
    fontSize: "inherit",
    fontStyle: "normal",
    fontWeight: 500,
    lineHeight: "".concat(32 / $5e742d5dd814aec6$var$fontSize, "em"),
    paddingBlock: "space.0"
});
var $5e742d5dd814aec6$var$tokenizedButtonStyles = (0, $aGSBL.xcss)({
    font: 'var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    fontWeight: "var(--ds-font-weight-medium, 500)",
    paddingBlock: "space.075"
});
var $5e742d5dd814aec6$var$defaultInteractiveStyles = (0, $aGSBL.xcss)({
    ":hover": {
        background: "var(--ds-background-neutral-hovered, #091e4214)",
        // @ts-expect-error
        color: "var(--ds-text, ".concat($lmjFT.N500, ")"),
        transitionDuration: "0s, 0.15s"
    },
    ":active": {
        background: "var(--ds-background-neutral-pressed, ".concat($lmjFT.B75, ")"),
        // @ts-expect-error
        color: "var(--ds-text, ".concat($lmjFT.B400, ")"),
        transitionDuration: "0s, 0s"
    }
});
var $5e742d5dd814aec6$var$primaryStyles = (0, $aGSBL.xcss)({
    background: "var(--ds-background-brand-bold, #0052CC)",
    // @ts-expect-error
    color: "var(--ds-text-inverse, #FFFFFF)",
    ":visited": {
        // @ts-expect-error
        color: "var(--ds-text-inverse, #FFFFFF)"
    }
});
var $5e742d5dd814aec6$var$primaryInteractiveStyles = (0, $aGSBL.xcss)({
    ":hover": {
        // @ts-expect-error
        color: "var(--ds-text-inverse, #FFFFFF)",
        background: "var(--ds-background-brand-bold-hovered, #0065FF)"
    },
    ":active": {
        // @ts-expect-error
        color: "var(--ds-text-inverse, #FFFFFF)",
        background: "var(--ds-background-brand-bold-pressed, #0747A6)"
    }
});
var $5e742d5dd814aec6$var$warningStyles = (0, $aGSBL.xcss)({
    background: "var(--ds-background-warning-bold, #FFAB00)",
    // @ts-expect-error
    color: "var(--ds-text-warning-inverse, #172B4D)",
    ":visited": {
        // @ts-expect-error
        color: "var(--ds-text-warning-inverse, #172B4D)"
    }
});
var $5e742d5dd814aec6$var$warningInteractiveStyles = (0, $aGSBL.xcss)({
    ":hover": {
        // @ts-expect-error
        color: "var(--ds-text-warning-inverse, #172B4D)",
        background: "var(--ds-background-warning-bold-hovered, #FFC400)"
    },
    ":active": {
        // @ts-expect-error
        color: "var(--ds-text-warning-inverse, #172B4D)",
        background: "var(--ds-background-warning-bold-pressed, #FF991F)"
    }
});
var $5e742d5dd814aec6$var$dangerStyles = (0, $aGSBL.xcss)({
    background: "var(--ds-background-danger-bold, #DE350B)",
    color: "color.text.inverse",
    ":visited": {
        color: "color.text.inverse"
    }
});
var $5e742d5dd814aec6$var$dangerInteractiveStyles = (0, $aGSBL.xcss)({
    ":hover": {
        color: "color.text.inverse",
        background: "var(--ds-background-danger-bold-hovered, #FF5630)"
    },
    ":active": {
        color: "color.text.inverse",
        background: "var(--ds-background-danger-bold-pressed, #BF2600)"
    }
});
var $5e742d5dd814aec6$var$discoveryStyles = (0, $aGSBL.xcss)({
    background: "var(--ds-background-discovery-bold, #5243AA)",
    color: "color.text.inverse",
    ":visited": {
        color: "color.text.inverse"
    }
});
var $5e742d5dd814aec6$var$discoveryInteractiveStyles = (0, $aGSBL.xcss)({
    ":hover": {
        color: "color.text.inverse",
        background: "var(--ds-background-discovery-bold-hovered, #8777D9)"
    },
    ":active": {
        color: "color.text.inverse",
        background: "var(--ds-background-discovery-bold-pressed, #5243AA)"
    }
});
var $5e742d5dd814aec6$var$subtleStyles = (0, $aGSBL.xcss)({
    background: "var(--ds-background-neutral-subtle, transparent)",
    // @ts-expect-error
    color: "var(--ds-text, #42526E)",
    ":visited": {
        // @ts-expect-error
        color: "var(--ds-text, #42526E)"
    }
});
var $5e742d5dd814aec6$var$subtleInteractiveStyles = (0, $aGSBL.xcss)({
    ":hover": {
        background: "var(--ds-background-neutral-subtle-hovered, #091e4214)",
        // @ts-expect-error
        color: "var(--ds-text, #42526E)"
    },
    ":active": {
        background: "var(--ds-background-neutral-subtle-pressed, #B3D4FF)",
        // @ts-expect-error
        color: "var(--ds-text, #42526E)"
    }
});
var $5e742d5dd814aec6$var$linkStyles = (0, $aGSBL.xcss)({
    // @ts-expect-error
    color: "var(--ds-link, ".concat($lmjFT.B400, ")"),
    background: "var(--ds-background-neutral-subtle, transparent)",
    textDecoration: "none",
    ":hover": {
        // @ts-expect-error
        color: "var(--ds-link, ".concat($lmjFT.B300, ")"),
        background: "var(--ds-background-neutral-subtle, transparent)"
    },
    ":active": {
        // @ts-expect-error
        color: "var(--ds-link-pressed, #0055CC)",
        background: "var(--ds-background-neutral-subtle, transparent)"
    },
    ":visited": {
        // @ts-expect-error
        color: "var(--ds-link, ".concat($lmjFT.B400, ")")
    }
});
var $5e742d5dd814aec6$var$subtleLinkStyles = (0, $aGSBL.xcss)({
    // @ts-expect-error
    color: "var(--ds-text-subtle, ".concat($lmjFT.N200, ")"),
    background: "var(--ds-background-neutral-subtle, transparent)",
    textDecoration: "none",
    ":hover": {
        // @ts-expect-error
        color: "var(--ds-text-subtle, ".concat($lmjFT.N90, ")"),
        background: "var(--ds-background-neutral-subtle, transparent)"
    },
    ":active": {
        // @ts-expect-error
        color: "var(--ds-text, ".concat($lmjFT.N400, ")"),
        background: "var(--ds-background-neutral-subtle, transparent)"
    },
    ":visited": {
        // @ts-expect-error
        color: "var(--ds-text-subtle, ".concat($lmjFT.N200, ")")
    }
});
// Required due to Jira's AUI CSS reset: https://product-fabric.atlassian.net/browse/DSP-15687
var $5e742d5dd814aec6$var$linkDecorationUnsetStyles = (0, $aGSBL.xcss)({
    textDecoration: "none",
    ":hover": {
        textDecoration: "none"
    },
    ":active": {
        textDecoration: "none"
    },
    ":focus": {
        textDecoration: "none"
    }
});
var $5e742d5dd814aec6$var$linkDecorationStyles = (0, $aGSBL.xcss)({
    ":hover": {
        textDecoration: "underline"
    },
    ":focus": {
        textDecoration: "underline"
    }
});
var $5e742d5dd814aec6$var$disabledStyles = (0, $aGSBL.xcss)({
    background: "var(--ds-background-disabled, ".concat($lmjFT.N20A, ")"),
    // @ts-expect-error
    color: "var(--ds-text-disabled, #091E424F)",
    ":hover": {
        background: "var(--ds-background-disabled, ".concat($lmjFT.N20A, ")"),
        // @ts-expect-error
        color: "var(--ds-text-disabled, #091E424F)"
    },
    ":active": {
        background: "var(--ds-background-disabled, ".concat($lmjFT.N20A, ")"),
        // @ts-expect-error
        color: "var(--ds-text-disabled, #091E424F)"
    }
});
var $5e742d5dd814aec6$var$selectedStyles = (0, $aGSBL.xcss)({
    background: "var(--ds-background-selected, ".concat($lmjFT.N700, ")"),
    // @ts-expect-error
    color: "var(--ds-text-selected, ".concat($lmjFT.N20, ")"),
    ":visited": {
        // @ts-expect-error
        color: "var(--ds-text-selected, ".concat($lmjFT.N20, ")")
    }
});
var $5e742d5dd814aec6$var$selectedInteractiveStyles = (0, $aGSBL.xcss)({
    ":hover": {
        // @ts-expect-error
        color: "var(--ds-text-selected, ".concat($lmjFT.N20, ")"),
        background: "var(--ds-background-selected-hovered, ".concat($lmjFT.N700, ")")
    },
    ":active": {
        // @ts-expect-error
        color: "var(--ds-text-selected, ".concat($lmjFT.N20, ")"),
        background: "var(--ds-background-selected-pressed, ".concat($lmjFT.N700, ")")
    }
});
// TODO: Remove me once we kill color fallbacks
var $5e742d5dd814aec6$var$selectedWarningStyles = (0, $aGSBL.xcss)({
    background: "var(--ds-background-selected, ".concat($lmjFT.Y400, ")"),
    // @ts-expect-error
    color: "var(--ds-text-selected, ".concat($lmjFT.N800, ")"),
    ":hover": {
        // @ts-expect-error
        color: "var(--ds-text-selected, ".concat($lmjFT.N20, ")"),
        background: "var(--ds-background-selected, ".concat($lmjFT.Y400, ")")
    },
    ":active": {
        // @ts-expect-error
        color: "var(--ds-text-selected, ".concat($lmjFT.N20, ")"),
        background: "var(--ds-background-selected, ".concat($lmjFT.Y400, ")")
    }
});
// TODO: Remove me once we kill color fallbacks
var $5e742d5dd814aec6$var$selectedDangerStyles = (0, $aGSBL.xcss)({
    background: "var(--ds-background-selected, ".concat($lmjFT.R500, ")"),
    // @ts-expect-error
    color: "var(--ds-text-selected, ".concat($lmjFT.N20, ")"),
    ":hover": {
        // @ts-expect-error
        color: "var(--ds-text-selected, ".concat($lmjFT.N20, ")"),
        background: "var(--ds-background-selected, ".concat($lmjFT.R500, ")")
    },
    ":active": {
        // @ts-expect-error
        color: "var(--ds-text-selected, ".concat($lmjFT.N20, ")"),
        background: "var(--ds-background-selected, ".concat($lmjFT.R500, ")")
    }
});
// TODO: Remove me once we kill color fallbacks
var $5e742d5dd814aec6$var$selectedDiscoveryStyles = (0, $aGSBL.xcss)({
    background: "var(--ds-background-selected, #403294)",
    // @ts-expect-error
    color: "var(--ds-text-selected, ".concat($lmjFT.N20, ")"),
    ":hover": {
        // @ts-expect-error
        color: "var(--ds-text-selected, ".concat($lmjFT.N20, ")"),
        background: "var(--ds-background-selected, #403294)"
    },
    ":active": {
        // @ts-expect-error
        color: "var(--ds-text-selected, ".concat($lmjFT.N20, ")"),
        background: "var(--ds-background-selected, #403294)"
    }
});
var $5e742d5dd814aec6$var$spacingCompactStyles = (0, $aGSBL.xcss)({
    columnGap: "space.050",
    height: "".concat(24 / $5e742d5dd814aec6$var$fontSize, "em"),
    paddingInlineEnd: "space.150",
    paddingInlineStart: "space.150",
    verticalAlign: "middle"
});
var $5e742d5dd814aec6$var$baseSpacingCompactStyles = (0, $aGSBL.xcss)({
    lineHeight: "".concat(24 / $5e742d5dd814aec6$var$fontSize, "em")
});
var $5e742d5dd814aec6$var$tokenizedSpacingCompactStyles = (0, $aGSBL.xcss)({
    paddingBlock: "space.025"
});
var $5e742d5dd814aec6$var$spacingNoneStyles = (0, $aGSBL.xcss)({
    columnGap: "space.0",
    height: "auto",
    lineHeight: "inherit",
    paddingInlineEnd: "space.0",
    paddingInlineStart: "space.0",
    verticalAlign: "baseline"
});
var $5e742d5dd814aec6$var$tokenizedSpacingNoneStyles = (0, $aGSBL.xcss)({
    paddingBlock: "space.0"
});
var $5e742d5dd814aec6$var$circleStyles = (0, $aGSBL.xcss)({
    borderRadius: "border.radius.circle"
});
var $5e742d5dd814aec6$var$fullWidthStyles = (0, $aGSBL.xcss)({
    width: "100%"
});
var $5e742d5dd814aec6$var$loadingOverlayStyles = (0, $aGSBL.xcss)({
    cursor: "progress"
});
var $5e742d5dd814aec6$var$nonInteractiveStyles = (0, $aGSBL.xcss)({
    cursor: "not-allowed"
});
var $5e742d5dd814aec6$var$iconButtonStyles = (0, $aGSBL.xcss)({
    height: "".concat(32 / $5e742d5dd814aec6$var$fontSize, "em"),
    width: "".concat(32 / $5e742d5dd814aec6$var$fontSize, "em"),
    paddingInlineEnd: "space.0",
    paddingInlineStart: "space.0"
});
var $5e742d5dd814aec6$var$iconButtonCompactStyles = (0, $aGSBL.xcss)({
    width: "".concat(24 / $5e742d5dd814aec6$var$fontSize, "em"),
    height: "".concat(24 / $5e742d5dd814aec6$var$fontSize, "em")
});
var $5e742d5dd814aec6$var$buttonIconBeforeStyles = (0, $aGSBL.xcss)({
    paddingInlineStart: "space.100"
});
var $5e742d5dd814aec6$var$buttonIconAfterStyles = (0, $aGSBL.xcss)({
    paddingInlineEnd: "space.100"
});
var $5e742d5dd814aec6$var$splitButtonStyles = (0, $aGSBL.xcss)({
    ":focus-visible": {
        zIndex: "card"
    }
});
var $5e742d5dd814aec6$var$navigationSplitButtonStyles = (0, $aGSBL.xcss)({
    width: "24px",
    backgroundColor: "color.background.neutral.subtle",
    paddingInlineEnd: "space.075",
    paddingInlineStart: "space.075"
});
var $5e742d5dd814aec6$var$overlayStyles = (0, $aGSBL.xcss)({
    display: "flex",
    position: "absolute",
    alignItems: "center",
    justifyContent: "center",
    insetBlockEnd: "space.0",
    insetBlockStart: "space.0",
    insetInlineEnd: "space.0",
    insetInlineStart: "space.0"
});
/**
 * __Use button base__
 *
 * A React hook that accepts a set of common Button props,
 * and processes them to return consistent base props for usage
 * across various Button components.
 *
 * It also:
 * - Implements auto focus when enabled.
 * - Appends the `onClick` event with UFO analytics tracking.
 *
 * @private
 */ var $5e742d5dd814aec6$var$useButtonBase = function useButtonBase(_ref) {
    var _ref$appearance = _ref.appearance, propAppearance = _ref$appearance === void 0 ? "default" : _ref$appearance, _ref$autoFocus = _ref.autoFocus, autoFocus = _ref$autoFocus === void 0 ? false : _ref$autoFocus, _ref$isDisabled = _ref.isDisabled, propIsDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled, _ref$isLoading = _ref.isLoading, isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading, _ref$isSelected = _ref.isSelected, isSelected = _ref$isSelected === void 0 ? false : _ref$isSelected, _ref$isIconButton = _ref.isIconButton, isIconButton = _ref$isIconButton === void 0 ? false : _ref$isIconButton, _ref$isCircle = _ref.isCircle, isCircle = _ref$isCircle === void 0 ? false : _ref$isCircle, _ref$hasIconBefore = _ref.hasIconBefore, hasIconBefore = _ref$hasIconBefore === void 0 ? false : _ref$hasIconBefore, _ref$hasIconAfter = _ref.hasIconAfter, hasIconAfter = _ref$hasIconAfter === void 0 ? false : _ref$hasIconAfter, children = _ref.children, onClick = _ref.onClick, onMouseDownCapture = _ref.onMouseDownCapture, onMouseUpCapture = _ref.onMouseUpCapture, onKeyDownCapture = _ref.onKeyDownCapture, onKeyUpCapture = _ref.onKeyUpCapture, onTouchStartCapture = _ref.onTouchStartCapture, onTouchEndCapture = _ref.onTouchEndCapture, onPointerDownCapture = _ref.onPointerDownCapture, onPointerUpCapture = _ref.onPointerUpCapture, onClickCapture = _ref.onClickCapture, overlay = _ref.overlay, ref = _ref.ref, _ref$shouldFitContain = _ref.shouldFitContainer, shouldFitContainer = _ref$shouldFitContain === void 0 ? false : _ref$shouldFitContain, _ref$spacing = _ref.spacing, propSpacing = _ref$spacing === void 0 ? "default" : _ref$spacing;
    var localRef = (0, $dAx5m.useRef)(null);
    var splitButtonContext = (0, $glm91.useSplitButtonContext)();
    var isSplitButton = Boolean(splitButtonContext);
    var isNavigationSplitButton = (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.isNavigationSplitButton) || false;
    var appearance = (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.appearance) || propAppearance;
    var spacing = (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.spacing) || propSpacing;
    var isDisabled = (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.isDisabled) || propIsDisabled;
    var hasOverlay = Boolean(overlay);
    var isInteractive = !isDisabled && !isLoading && !hasOverlay;
    var isEffectivelyDisabled = isDisabled || Boolean(overlay);
    (0, $gMIYi.default)(localRef, autoFocus);
    return $5e742d5dd814aec6$var$_objectSpread({
        ref: (0, $2Dg3J.default)([
            localRef,
            ref
        ]),
        xcss: [
            (0, $5im4X.getBooleanFF)("platform.design-system-team.button-tokenised-typography-styles") ? $5e742d5dd814aec6$var$tokenizedButtonStyles : $5e742d5dd814aec6$var$baseButtonStyles,
            $5e742d5dd814aec6$var$buttonStyles,
            appearance === "default" && isInteractive && $5e742d5dd814aec6$var$defaultInteractiveStyles,
            appearance === "primary" && $5e742d5dd814aec6$var$primaryStyles,
            appearance === "primary" && isInteractive && $5e742d5dd814aec6$var$primaryInteractiveStyles,
            appearance === "warning" && $5e742d5dd814aec6$var$warningStyles,
            appearance === "warning" && isInteractive && $5e742d5dd814aec6$var$warningInteractiveStyles,
            appearance === "danger" && $5e742d5dd814aec6$var$dangerStyles,
            appearance === "danger" && isInteractive && $5e742d5dd814aec6$var$dangerInteractiveStyles,
            appearance === "discovery" && $5e742d5dd814aec6$var$discoveryStyles,
            appearance === "discovery" && isInteractive && $5e742d5dd814aec6$var$discoveryInteractiveStyles,
            appearance === "subtle" && $5e742d5dd814aec6$var$subtleStyles,
            appearance === "subtle" && isInteractive && $5e742d5dd814aec6$var$subtleInteractiveStyles,
            appearance === "link" && $5e742d5dd814aec6$var$linkStyles,
            appearance === "subtle-link" && $5e742d5dd814aec6$var$subtleLinkStyles,
            !isSelected && (appearance === "link" || appearance === "subtle-link") ? $5e742d5dd814aec6$var$linkDecorationStyles : $5e742d5dd814aec6$var$linkDecorationUnsetStyles,
            isSelected && $5e742d5dd814aec6$var$selectedStyles,
            isSelected && isInteractive && $5e742d5dd814aec6$var$selectedInteractiveStyles,
            // TODO: remove me once we kill color fallbacks
            isSelected && appearance === "danger" && $5e742d5dd814aec6$var$selectedDangerStyles,
            // TODO: remove me once we kill color fallbacks
            isSelected && appearance === "warning" && $5e742d5dd814aec6$var$selectedWarningStyles,
            // TODO: remove me once we kill color fallbacks
            isSelected && appearance === "discovery" && $5e742d5dd814aec6$var$selectedDiscoveryStyles,
            isDisabled && $5e742d5dd814aec6$var$disabledStyles,
            isCircle && !isSplitButton && $5e742d5dd814aec6$var$circleStyles,
            spacing === "compact" && $5e742d5dd814aec6$var$spacingCompactStyles,
            spacing === "compact" && ((0, $5im4X.getBooleanFF)("platform.design-system-team.button-tokenised-typography-styles") ? $5e742d5dd814aec6$var$tokenizedSpacingCompactStyles : $5e742d5dd814aec6$var$baseSpacingCompactStyles),
            spacing === "none" && $5e742d5dd814aec6$var$spacingNoneStyles,
            spacing === "none" && (0, $5im4X.getBooleanFF)("platform.design-system-team.button-tokenised-typography-styles") && $5e742d5dd814aec6$var$tokenizedSpacingNoneStyles,
            spacing !== "none" && hasIconBefore && $5e742d5dd814aec6$var$buttonIconBeforeStyles,
            spacing !== "none" && hasIconAfter && $5e742d5dd814aec6$var$buttonIconAfterStyles,
            isIconButton && $5e742d5dd814aec6$var$iconButtonStyles,
            isIconButton && spacing === "compact" && $5e742d5dd814aec6$var$iconButtonCompactStyles,
            shouldFitContainer && $5e742d5dd814aec6$var$fullWidthStyles,
            isLoading && $5e742d5dd814aec6$var$loadingOverlayStyles,
            (isDisabled || hasOverlay && !isLoading) && $5e742d5dd814aec6$var$nonInteractiveStyles,
            isSplitButton && $5e742d5dd814aec6$var$splitButtonStyles,
            isNavigationSplitButton && $5e742d5dd814aec6$var$navigationSplitButtonStyles
        ],
        // Consider overlay buttons to be effectively disabled
        isDisabled: isEffectivelyDisabled,
        children: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $dAx5m.Fragment), null, children, overlay ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $iGrUY.default), {
            as: "span",
            xcss: $5e742d5dd814aec6$var$overlayStyles
        }, overlay) : null)
    }, (0, $aNabl.default)(isEffectivelyDisabled, {
        onClick: onClick,
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onTouchStartCapture: onTouchStartCapture,
        onTouchEndCapture: onTouchEndCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onClickCapture: onClickCapture
    }));
};
var $5e742d5dd814aec6$export$2e2bcd8739ae039 = $5e742d5dd814aec6$var$useButtonBase;

});
parcelRegister("5im4X", function(module, exports) {

$parcel$export(module.exports, "getBooleanFF", function () { return $3dafc2a31031ff24$export$470e5c2be1411c89; });

var $kvhKV = parcelRequire("kvhKV");
function $3dafc2a31031ff24$export$ba05d765b8392e5e(flagResolver) {
    (0, $kvhKV.setBooleanResolver)(flagResolver);
}
function $3dafc2a31031ff24$export$470e5c2be1411c89(name) {
    return (0, $kvhKV.resolveBooleanFlag)(name);
}

});
parcelRegister("kvhKV", function(module, exports) {

$parcel$export(module.exports, "setBooleanResolver", function () { return $eed479d35134b8f3$export$f2b591175b3e424c; });
$parcel$export(module.exports, "resolveBooleanFlag", function () { return $eed479d35134b8f3$export$6333b6aff9fc6275; });

var $48sWu = parcelRequire("48sWu");

var $ahJoN = parcelRequire("ahJoN");
var $eed479d35134b8f3$var$pkgName = "@atlaskit/platform-feature-flags";
var $eed479d35134b8f3$export$7e41b1b2bdee3f98 = "__PLATFORM_FEATURE_FLAGS__";
var $eed479d35134b8f3$var$hasProcessEnv = typeof $ahJoN !== "undefined" && typeof $ahJoN.env !== "undefined";
// FF global overrides can be configured by test runners or Storybook
var $eed479d35134b8f3$var$ENV_ENABLE_PLATFORM_FF = $eed479d35134b8f3$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
// STORYBOOK_ENABLE_PLATFORM_FF is included as storybook only allows env vars prefixed with STORYBOOK
// https://github.com/storybookjs/storybook/issues/12270
var $eed479d35134b8f3$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF = $eed479d35134b8f3$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
var $eed479d35134b8f3$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE = $eed479d35134b8f3$var$ENV_ENABLE_PLATFORM_FF || $eed479d35134b8f3$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF;
var $eed479d35134b8f3$var$DEFAULT_PFF_GLOBAL = {
    // In development mode we want to capture any feature flag checks that happen using the default resolver and log this result when the resolver is replaced.
    // This is because evaluating feature flags when the resolver/FF client is loaded asynchronously could cause unexpected issues.
    earlyResolvedFlags: new Map(),
    booleanResolver: function booleanResolver(flagKey) {
        var unresolvedFlagCount;
        return false;
    }
};
var $eed479d35134b8f3$var$globalVar = typeof window !== "undefined" ? window : globalThis;
$eed479d35134b8f3$var$globalVar[$eed479d35134b8f3$export$7e41b1b2bdee3f98] = $eed479d35134b8f3$var$globalVar[$eed479d35134b8f3$export$7e41b1b2bdee3f98] || $eed479d35134b8f3$var$DEFAULT_PFF_GLOBAL;
function $eed479d35134b8f3$export$f2b591175b3e424c(resolver) {
    $eed479d35134b8f3$var$globalVar[$eed479d35134b8f3$export$7e41b1b2bdee3f98].booleanResolver = resolver;
    var _globalVar$PFF_GLOBAL;
}
function $eed479d35134b8f3$export$6333b6aff9fc6275(flagKey) {
    if ($eed479d35134b8f3$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE) {
        (0, $48sWu.debug)('[%s]: The feature flags were enabled while running tests. The flag "%s" will be always enabled.', $eed479d35134b8f3$var$pkgName, flagKey);
        return true;
    }
    try {
        var _globalVar$PFF_GLOBAL2;
        var result = (_globalVar$PFF_GLOBAL2 = $eed479d35134b8f3$var$globalVar[$eed479d35134b8f3$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL2 === void 0 ? void 0 : _globalVar$PFF_GLOBAL2.booleanResolver(flagKey);
        if (typeof result !== "boolean") {
            // eslint-disable-next-line no-console
            console.warn("".concat(flagKey, " resolved to a non-boolean value, returning false for safety"));
            return false;
        }
        return result;
    } catch (e) {
        return false;
    }
}

});
parcelRegister("48sWu", function(module, exports) {

$parcel$export(module.exports, "debug", function () { return $302e5c246098e260$export$1c9f709888824e05; });
var $302e5c246098e260$var$_ref, $302e5c246098e260$var$_process, $302e5c246098e260$var$_process2;
// We can't rely on NODE_ENV === 'test' if its value is already configured by the consumer to some other value, so better to use JEST_WORKER_ID
// https://jestjs.io/docs/environment-variables#jest_worker_id
var $302e5c246098e260$var$TESTS_MODE = ($302e5c246098e260$var$_ref = (globalThis === null || globalThis === void 0 || ($302e5c246098e260$var$_process = globalThis.process) === null || $302e5c246098e260$var$_process === void 0 || ($302e5c246098e260$var$_process = $302e5c246098e260$var$_process.env) === null || $302e5c246098e260$var$_process === void 0 ? void 0 : $302e5c246098e260$var$_process.JEST_WORKER_ID) !== undefined, $302e5c246098e260$var$_ref !== void 0) ? $302e5c246098e260$var$_ref : false;
var $302e5c246098e260$var$DEBUG_MODE = !$302e5c246098e260$var$TESTS_MODE && (globalThis === null || globalThis === void 0 || ($302e5c246098e260$var$_process2 = globalThis.process) === null || $302e5c246098e260$var$_process2 === void 0 || ($302e5c246098e260$var$_process2 = $302e5c246098e260$var$_process2.env) === null || $302e5c246098e260$var$_process2 === void 0 ? void 0 : $302e5c246098e260$var$_process2.NODE_ENV) !== "production";
var $302e5c246098e260$export$1c9f709888824e05 = function debug() {
    var _console;
    if (!$302e5c246098e260$var$DEBUG_MODE) return;
    // eslint-disable-next-line no-console
    (_console = console).debug.apply(_console, arguments);
};

});



parcelRegister("glm91", function(module, exports) {

$parcel$export(module.exports, "useSplitButtonContext", function () { return $be5fc8ece92a82c3$export$47e2c6fdb142d947; });

var $dAx5m = parcelRequire("dAx5m");
var $be5fc8ece92a82c3$export$4b86304b2c0d7e71 = /*#__PURE__*/ (0, $dAx5m.createContext)(undefined);
var $be5fc8ece92a82c3$export$47e2c6fdb142d947 = function useSplitButtonContext() {
    var context = (0, $dAx5m.useContext)($be5fc8ece92a82c3$export$4b86304b2c0d7e71);
    if (!context) return undefined;
    if (context.appearance === "navigation") {
        var newContext = {
            spacing: "default",
            appearance: "subtle",
            isDisabled: false,
            isActiveOverSelected: false,
            isNavigationSplitButton: true,
            isHighlighted: context.isHighlighted
        };
        return newContext;
    }
    var splitButtonContext = {
        spacing: context.spacing,
        appearance: context.appearance,
        isDisabled: context.isDisabled,
        isActiveOverSelected: true,
        isNavigationSplitButton: false,
        isHighlighted: false
    };
    return splitButtonContext;
};

});

parcelRegister("aNabl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7db660e864e5162e$export$2e2bcd8739ae039; });
function $7db660e864e5162e$var$abort(event) {
    event.preventDefault();
    event.stopPropagation();
}
var $7db660e864e5162e$var$tabKeyCode = 9;
function $7db660e864e5162e$var$onKey(event) {
    // Allowing tab so that a user can move focus away
    if (event.keyCode === $7db660e864e5162e$var$tabKeyCode) return;
    $7db660e864e5162e$var$abort(event);
}
function $7db660e864e5162e$export$2e2bcd8739ae039(shouldBlockEvents, events) {
    return shouldBlockEvents ? {
        onMouseDownCapture: $7db660e864e5162e$var$abort,
        onMouseUpCapture: $7db660e864e5162e$var$abort,
        onKeyDownCapture: $7db660e864e5162e$var$onKey,
        onKeyUpCapture: $7db660e864e5162e$var$onKey,
        onTouchStartCapture: $7db660e864e5162e$var$abort,
        onTouchEndCapture: $7db660e864e5162e$var$abort,
        onPointerDownCapture: $7db660e864e5162e$var$abort,
        onPointerUpCapture: $7db660e864e5162e$var$abort,
        onClickCapture: $7db660e864e5162e$var$abort,
        // Just smashing the existing onClick for good measure
        onClick: $7db660e864e5162e$var$abort
    } : events;
}

});




parcelRegister("1Zl8g", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $172be166ab946800$var$_react = $172be166ab946800$var$_interopRequireDefault((parcelRequire("dAx5m")));

var $3AZdd = parcelRequire("3AZdd");

var $172be166ab946800$var$_arrowLeft = $172be166ab946800$var$_interopRequireDefault((parcelRequire("fwzaC")));
function $172be166ab946800$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $172be166ab946800$var$ArrowLeftIcon = (props)=>/*#__PURE__*/ $172be166ab946800$var$_react.default.createElement($3AZdd.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M12.207 5.793a1 1 0 0 1 0 1.414L8.414 11H18a1 1 0 1 1 0 2H8.414l3.793 3.793a1 1 0 1 1-1.415 1.414l-5.499-5.5A1 1 0 0 1 5 12.028v-.057a1 1 0 0 1 .293-.678l5.499-5.5a1 1 0 0 1 1.415 0" clip-rule="evenodd"/></svg>`
    }, props, {
        newIcon: $172be166ab946800$var$_arrowLeft.default
    }));
$172be166ab946800$var$ArrowLeftIcon.displayName = "ArrowLeftIcon";
var $172be166ab946800$var$_default = module.exports.default = $172be166ab946800$var$ArrowLeftIcon;

});
parcelRegister("3AZdd", function(module, exports) {

$parcel$export(module.exports, "IconFacade", function () { return $29e4375655223580$export$3cfb73f70dfca966; });

var $8TMbA = parcelRequire("8TMbA");

var $8jzoy = parcelRequire("8jzoy");

var $dAx5m = parcelRequire("dAx5m");

var $3C1O0 = parcelRequire("3C1O0");

var $gHO5y = parcelRequire("gHO5y");
var $29e4375655223580$var$_excluded = [
    "dangerouslySetGlyph"
];
var $29e4375655223580$var$sizesEligibleForNewIcons = [
    "small",
    "medium"
];
var $29e4375655223580$export$3cfb73f70dfca966 = /*#__PURE__*/ (0, $dAx5m.memo)(function IconFacade(_ref) {
    var _props$size;
    var dangerouslySetGlyph = _ref.dangerouslySetGlyph, props = (0, (/*@__PURE__*/$parcel$interopDefault($8jzoy)))(_ref, $29e4375655223580$var$_excluded);
    var NewIcon = props.newIcon;
    // By default, the icon size will be medium and spacing will be none for small icons
    var size = (_props$size = props.size) !== null && _props$size !== void 0 ? _props$size : "medium";
    var spacing = size === "small" ? "none" : "spacious";
    var useNewIcon = !props.isFacadeDisabled && // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
    (0, $3C1O0.fg)("platform-visual-refresh-icons-legacy-facade") && $29e4375655223580$var$sizesEligibleForNewIcons.includes(size);
    if (useNewIcon && NewIcon) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement(NewIcon, (0, (/*@__PURE__*/$parcel$interopDefault($8TMbA)))({}, props, {
        spacing: spacing,
        color: props.primaryColor || "currentColor",
        type: props.iconType
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $gHO5y.default), (0, (/*@__PURE__*/$parcel$interopDefault($8TMbA)))({
        dangerouslySetGlyph: dangerouslySetGlyph
    }, props));
});
var $29e4375655223580$export$2e2bcd8739ae039 = $29e4375655223580$export$3cfb73f70dfca966;

});
parcelRegister("3C1O0", function(module, exports) {

$parcel$export(module.exports, "fg", function () { return $2a16523d80d00e5b$export$b40ec24ac8275656; });

var $gyCvY = parcelRequire("gyCvY");
function $2a16523d80d00e5b$export$ba05d765b8392e5e(flagResolver) {
    (0, $gyCvY.setBooleanResolver)(flagResolver);
}
function $2a16523d80d00e5b$export$470e5c2be1411c89(name) {
    return (0, $gyCvY.resolveBooleanFlag)(name);
}
function $2a16523d80d00e5b$export$b40ec24ac8275656(name) {
    return (0, $gyCvY.resolveBooleanFlag)(name);
}

});
parcelRegister("gyCvY", function(module, exports) {

$parcel$export(module.exports, "setBooleanResolver", function () { return $c0ddb28bf2a2e45d$export$f2b591175b3e424c; });
$parcel$export(module.exports, "resolveBooleanFlag", function () { return $c0ddb28bf2a2e45d$export$6333b6aff9fc6275; });

var $lVgd6 = parcelRequire("lVgd6");

var $ahJoN = parcelRequire("ahJoN");
var $c0ddb28bf2a2e45d$var$pkgName = "@atlaskit/platform-feature-flags";
var $c0ddb28bf2a2e45d$export$7e41b1b2bdee3f98 = "__PLATFORM_FEATURE_FLAGS__";
var $c0ddb28bf2a2e45d$var$hasProcessEnv = typeof $ahJoN !== "undefined" && typeof $ahJoN.env !== "undefined";
// FF global overrides can be configured by test runners or Storybook
var $c0ddb28bf2a2e45d$var$ENV_ENABLE_PLATFORM_FF = $c0ddb28bf2a2e45d$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
// STORYBOOK_ENABLE_PLATFORM_FF is included as storybook only allows env vars prefixed with STORYBOOK
// https://github.com/storybookjs/storybook/issues/12270
var $c0ddb28bf2a2e45d$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF = $c0ddb28bf2a2e45d$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
var $c0ddb28bf2a2e45d$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE = $c0ddb28bf2a2e45d$var$ENV_ENABLE_PLATFORM_FF || $c0ddb28bf2a2e45d$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF;
var $c0ddb28bf2a2e45d$var$DEFAULT_PFF_GLOBAL = {
    // In development mode we want to capture any feature flag checks that happen using the default resolver and log this result when the resolver is replaced.
    // This is because evaluating feature flags when the resolver/FF client is loaded asynchronously could cause unexpected issues.
    earlyResolvedFlags: new Map(),
    booleanResolver: function booleanResolver(flagKey) {
        var unresolvedFlagCount;
        return false;
    }
};
var $c0ddb28bf2a2e45d$var$globalVar = typeof window !== "undefined" ? window : globalThis;
$c0ddb28bf2a2e45d$var$globalVar[$c0ddb28bf2a2e45d$export$7e41b1b2bdee3f98] = $c0ddb28bf2a2e45d$var$globalVar[$c0ddb28bf2a2e45d$export$7e41b1b2bdee3f98] || $c0ddb28bf2a2e45d$var$DEFAULT_PFF_GLOBAL;
function $c0ddb28bf2a2e45d$export$f2b591175b3e424c(resolver) {
    $c0ddb28bf2a2e45d$var$globalVar[$c0ddb28bf2a2e45d$export$7e41b1b2bdee3f98].booleanResolver = resolver;
    var _globalVar$PFF_GLOBAL;
}
function $c0ddb28bf2a2e45d$export$6333b6aff9fc6275(flagKey) {
    if ($c0ddb28bf2a2e45d$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE) {
        (0, $lVgd6.debug)('[%s]: The feature flags were enabled while running tests. The flag "%s" will be always enabled.', $c0ddb28bf2a2e45d$var$pkgName, flagKey);
        return true;
    }
    try {
        var _globalVar$PFF_GLOBAL2;
        var result = (_globalVar$PFF_GLOBAL2 = $c0ddb28bf2a2e45d$var$globalVar[$c0ddb28bf2a2e45d$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL2 === void 0 ? void 0 : _globalVar$PFF_GLOBAL2.booleanResolver(flagKey);
        if (typeof result !== "boolean") {
            // eslint-disable-next-line no-console
            console.warn("".concat(flagKey, " resolved to a non-boolean value, returning false for safety"));
            return false;
        }
        return result;
    } catch (e) {
        return false;
    }
}

});
parcelRegister("lVgd6", function(module, exports) {

$parcel$export(module.exports, "debug", function () { return $ff5b7ee066839dc1$export$1c9f709888824e05; });
var $ff5b7ee066839dc1$var$_ref, $ff5b7ee066839dc1$var$_process, $ff5b7ee066839dc1$var$_process2;
// We can't rely on NODE_ENV === 'test' if its value is already configured by the consumer to some other value, so better to use JEST_WORKER_ID
// https://jestjs.io/docs/environment-variables#jest_worker_id
var $ff5b7ee066839dc1$var$TESTS_MODE = ($ff5b7ee066839dc1$var$_ref = (globalThis === null || globalThis === void 0 || ($ff5b7ee066839dc1$var$_process = globalThis.process) === null || $ff5b7ee066839dc1$var$_process === void 0 || ($ff5b7ee066839dc1$var$_process = $ff5b7ee066839dc1$var$_process.env) === null || $ff5b7ee066839dc1$var$_process === void 0 ? void 0 : $ff5b7ee066839dc1$var$_process.JEST_WORKER_ID) !== undefined, $ff5b7ee066839dc1$var$_ref !== void 0) ? $ff5b7ee066839dc1$var$_ref : false;
var $ff5b7ee066839dc1$var$DEBUG_MODE = !$ff5b7ee066839dc1$var$TESTS_MODE && (globalThis === null || globalThis === void 0 || ($ff5b7ee066839dc1$var$_process2 = globalThis.process) === null || $ff5b7ee066839dc1$var$_process2 === void 0 || ($ff5b7ee066839dc1$var$_process2 = $ff5b7ee066839dc1$var$_process2.env) === null || $ff5b7ee066839dc1$var$_process2 === void 0 ? void 0 : $ff5b7ee066839dc1$var$_process2.NODE_ENV) !== "production";
var $ff5b7ee066839dc1$export$1c9f709888824e05 = function debug() {
    var _console;
    if (!$ff5b7ee066839dc1$var$DEBUG_MODE) return;
    // eslint-disable-next-line no-console
    (_console = console).debug.apply(_console, arguments);
};

});



parcelRegister("gHO5y", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c297840bb3433394$export$2e2bcd8739ae039; });

var $8TMbA = parcelRequire("8TMbA");

var $iDtim = parcelRequire("iDtim");

var $dAx5m = parcelRequire("dAx5m");

var $jVTBW = parcelRequire("jVTBW");

var $QEefo = parcelRequire("QEefo");

var $f1f75 = parcelRequire("f1f75");
function $c297840bb3433394$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $c297840bb3433394$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $c297840bb3433394$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($iDtim)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $c297840bb3433394$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
/**
 * We are hiding these props from consumers as they're used to
 * hack around icon sizing specifically for icon-file-type.
 */ var $c297840bb3433394$var$iconStyles = (0, $jVTBW.css)({
    display: "inline-block",
    flexShrink: 0,
    lineHeight: 1,
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    "> svg": $c297840bb3433394$var$_objectSpread($c297840bb3433394$var$_objectSpread({}, (0, $QEefo.commonSVGStyles)), {}, {
        maxWidth: "100%",
        maxHeight: "100%",
        color: "var(--icon-primary-color)",
        fill: "var(--icon-secondary-color)",
        verticalAlign: "bottom"
    })
});
/**
 * For windows high contrast mode
 */ var $c297840bb3433394$var$baseHcmStyles = (0, $jVTBW.css)({
    "@media screen and (forced-colors: active)": {
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        "> svg": {
            filter: "grayscale(1)",
            "--icon-primary-color": "CanvasText",
            // foreground
            "--icon-secondary-color": "Canvas" // background
        }
    }
});
var $c297840bb3433394$var$primaryEqualsSecondaryHcmStyles = (0, $jVTBW.css)({
    "@media screen and (forced-colors: active)": {
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        "> svg": {
            // if the primaryColor is the same as the secondaryColor we
            // set the --icon-primary-color to Canvas
            // this is usually to convey state i.e. Checkbox checked -> not checked
            "--icon-primary-color": "Canvas" // foreground
        }
    }
});
var $c297840bb3433394$var$secondaryTransparentHcmStyles = (0, $jVTBW.css)({
    "@media screen and (forced-colors: active)": {
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        "> svg": {
            "--icon-secondary-color": "transparent" // background
        }
    }
});
var $c297840bb3433394$export$f04a61298a47a40f = /*#__PURE__*/ (0, $dAx5m.memo)(function Icon(props) {
    var _ref = props, Glyph = _ref.glyph, dangerouslySetGlyph = _ref.dangerouslySetGlyph, _ref$primaryColor = _ref.primaryColor, primaryColor = _ref$primaryColor === void 0 ? "currentColor" : _ref$primaryColor, secondaryColor = _ref.secondaryColor, size = _ref.size, testId = _ref.testId, label = _ref.label, width = _ref.width, height = _ref.height, UNSAFE_margin = _ref.UNSAFE_margin;
    var glyphProps = dangerouslySetGlyph ? {
        dangerouslySetInnerHTML: {
            __html: dangerouslySetGlyph
        }
    } : {
        children: Glyph ? (0, $jVTBW.jsx)(Glyph, {
            role: "presentation"
        }) : null
    };
    var dimensions = (0, $QEefo.getIconSize)({
        width: width,
        height: height,
        size: size
    });
    return (0, $jVTBW.jsx)("span", (0, (/*@__PURE__*/$parcel$interopDefault($8TMbA)))({
        "data-testid": testId,
        "data-vc": "icon-".concat(testId),
        role: label ? "img" : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: $c297840bb3433394$var$_objectSpread({
            "--icon-primary-color": primaryColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            "--icon-secondary-color": secondaryColor || (0, $f1f75.getBackground)()
        }, UNSAFE_margin ? {
            margin: UNSAFE_margin
        } : {})
    }, glyphProps, {
        css: [
            $c297840bb3433394$var$iconStyles,
            $c297840bb3433394$var$baseHcmStyles,
            primaryColor === secondaryColor && $c297840bb3433394$var$primaryEqualsSecondaryHcmStyles,
            secondaryColor === "transparent" && $c297840bb3433394$var$secondaryTransparentHcmStyles,
            // NB: This can be resolved if this component, composes base SVG / and/or skeleton
            // We could then simplify how common styles are dealt with simply by encapsulating them
            // at their appropriate level and/or having a singular approach to css variables in the package
            dimensions && // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $jVTBW.css)({
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                width: dimensions.width,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                height: dimensions.height,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                "> svg": dimensions
            })
        ]
    }));
});
var $c297840bb3433394$export$2e2bcd8739ae039 = $c297840bb3433394$export$f04a61298a47a40f;

});
parcelRegister("QEefo", function(module, exports) {

$parcel$export(module.exports, "commonSVGStyles", function () { return $09e4100b5e5b2272$export$16374db1c3e6dfba; });
$parcel$export(module.exports, "getIconSize", function () { return $09e4100b5e5b2272$export$3eb7d6130acfda37; });

var $5AL5C = parcelRequire("5AL5C");

var $jVTBW = parcelRequire("jVTBW");
var $09e4100b5e5b2272$export$16374db1c3e6dfba = {
    overflow: "hidden",
    pointerEvents: "none",
    /**
   * Stop-color doesn't properly apply in chrome when the inherited/current color changes.
   * We have to initially set stop-color to inherit (either via DOM attribute or an initial CSS
   * rule) and then override it with currentColor for the color changes to be picked up.
   */ stop: {
        stopColor: "currentColor"
    }
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
var $09e4100b5e5b2272$var$smallStyles = (0, $jVTBW.css)((0, $5AL5C.dimensions).small);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
var $09e4100b5e5b2272$var$mediumStyles = (0, $jVTBW.css)((0, $5AL5C.dimensions).medium);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
var $09e4100b5e5b2272$var$largeStyles = (0, $jVTBW.css)((0, $5AL5C.dimensions).large);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
var $09e4100b5e5b2272$var$xlargeStyles = (0, $jVTBW.css)((0, $5AL5C.dimensions).xlarge);
var $09e4100b5e5b2272$export$ef0ad74202575b64 = {
    small: $09e4100b5e5b2272$var$smallStyles,
    medium: $09e4100b5e5b2272$var$mediumStyles,
    large: $09e4100b5e5b2272$var$largeStyles,
    xlarge: $09e4100b5e5b2272$var$xlargeStyles
};
var $09e4100b5e5b2272$export$3eb7d6130acfda37 = function getIconSize(_ref) {
    var width = _ref.width, height = _ref.height, size = _ref.size;
    if (width && height) return {
        width: width,
        height: height
    };
    if (size) return (0, $5AL5C.dimensions)[size];
    return undefined;
};

});
parcelRegister("5AL5C", function(module, exports) {

$parcel$export(module.exports, "dimensions", function () { return $4124d78ff43d98aa$export$62ad7b0c781000e9; });
var $4124d78ff43d98aa$export$c647cb0ee6e282fe = {
    small: "16px",
    medium: "24px",
    large: "32px",
    xlarge: "48px"
};
var $4124d78ff43d98aa$export$7bd66fc94c81bf84 = {
    small: "small",
    medium: "medium",
    large: "large",
    xlarge: "xlarge"
};
var $4124d78ff43d98aa$export$62ad7b0c781000e9 = {
    small: {
        width: $4124d78ff43d98aa$export$c647cb0ee6e282fe.small,
        height: $4124d78ff43d98aa$export$c647cb0ee6e282fe.small
    },
    medium: {
        width: $4124d78ff43d98aa$export$c647cb0ee6e282fe.medium,
        height: $4124d78ff43d98aa$export$c647cb0ee6e282fe.medium
    },
    large: {
        width: $4124d78ff43d98aa$export$c647cb0ee6e282fe.large,
        height: $4124d78ff43d98aa$export$c647cb0ee6e282fe.large
    },
    xlarge: {
        width: $4124d78ff43d98aa$export$c647cb0ee6e282fe.xlarge,
        height: $4124d78ff43d98aa$export$c647cb0ee6e282fe.xlarge
    }
};

});


parcelRegister("f1f75", function(module, exports) {

$parcel$export(module.exports, "getBackground", function () { return $aef2ac2fc5565c2d$export$18cb9425622d4e06; });
var $aef2ac2fc5565c2d$export$18cb9425622d4e06 = function getBackground() {
    return "var(--ds-surface, #FFFFFF)";
};

});



parcelRegister("fwzaC", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3a37d280aae57eeab1805b026c5caa66>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b4d52041674d25a0$var$_react = $b4d52041674d25a0$var$_interopRequireDefault((parcelRequire("dAx5m")));

var $b4d52041674d25a0$var$_UNSAFE_baseNew = $b4d52041674d25a0$var$_interopRequireDefault((parcelRequire("jbpyS")));
function $b4d52041674d25a0$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "ArrowLeft".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: back to previous screen, previous slide.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b4d52041674d25a0$var$ArrowLeftIcon = (props)=>/*#__PURE__*/ $b4d52041674d25a0$var$_react.default.createElement($b4d52041674d25a0$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M15 8H2.25m4.5-5-5 5 5 5"/>`
    }, props));
$b4d52041674d25a0$var$ArrowLeftIcon.displayName = "ArrowLeftIcon";
var $b4d52041674d25a0$var$_default = module.exports.default = $b4d52041674d25a0$var$ArrowLeftIcon;

});
parcelRegister("jbpyS", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("5TePt")).default; });
$parcel$export(module.exports, "Icon", function () { return (parcelRequire("5TePt")).Icon; });

var $5TePt = parcelRequire("5TePt");

});
parcelRegister("5TePt", function(module, exports) {

$parcel$export(module.exports, "Icon", function () { return $449d97979b724945$export$f04a61298a47a40f; });
$parcel$export(module.exports, "default", function () { return $449d97979b724945$export$2e2bcd8739ae039; });
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $dAx5m = parcelRequire("dAx5m");

var $jVTBW = parcelRequire("jVTBW");

var $3C1O0 = parcelRequire("3C1O0");
/**
 * We are hiding this props from consumers as it's reserved
 * for use by Icon Tile.
 */ var $449d97979b724945$var$commonSVGStyles = (0, $jVTBW.css)({
    overflow: "hidden",
    pointerEvents: "none",
    /**
   * Stop-color doesn't properly apply in chrome when the inherited/current color changes.
   * We have to initially set stop-color to inherit (either via DOM attribute or an initial CSS
   * rule) and then override it with currentColor for the color changes to be picked up.
   */ // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    stop: {
        stopColor: "currentColor"
    }
});
var $449d97979b724945$var$svgStyles = (0, $jVTBW.css)({
    color: "currentColor",
    verticalAlign: "bottom"
});
var $449d97979b724945$var$iconStyles = (0, $jVTBW.css)({
    display: "inline-block",
    boxSizing: "border-box",
    flexShrink: 0,
    lineHeight: 1,
    paddingInlineEnd: "var(--ds--button--new-icon-padding-end, 0)",
    paddingInlineStart: "var(--ds--button--new-icon-padding-start, 0)"
});
var $449d97979b724945$var$utilityIconStyles = (0, $jVTBW.css)({
    lineHeight: "var(--ds-space-150, 12px)"
});
var $449d97979b724945$var$scaleStyles = (0, $jVTBW.css)({
    width: "inherit",
    height: "inherit"
});
/**
 * For windows high contrast mode
 */ var $449d97979b724945$var$baseHcmStyles = (0, $jVTBW.css)({
    "@media screen and (forced-colors: active)": {
        color: "CanvasText",
        filter: "grayscale(1)"
    }
});
var $449d97979b724945$var$sizeMap = {
    scale: (0, $jVTBW.css)({
        width: "inherit",
        height: "inherit"
    }),
    utility: (0, $jVTBW.css)({
        width: "var(--ds-space-150, 12px)",
        height: "var(--ds-space-150, 12px)"
    }),
    none: (0, $jVTBW.css)({
        width: "var(--ds-space-200, 16px)",
        height: "var(--ds-space-200, 16px)"
    }),
    spacious: (0, $jVTBW.css)({
        width: "var(--ds-space-300, 24px)",
        height: "var(--ds-space-300, 24px)"
    })
};
var $449d97979b724945$var$baseSizeMap = {
    global: 16,
    utility: 12
};
var $449d97979b724945$export$f04a61298a47a40f = /*#__PURE__*/ (0, $dAx5m.memo)(function Icon(props) {
    var _ref = props, providedColor = _ref.color, _ref$spacing = _ref.spacing, providedSpacing = _ref$spacing === void 0 ? "none" : _ref$spacing, testId = _ref.testId, label = _ref.label, LEGACY_primaryColor = _ref.LEGACY_primaryColor, LEGACY_secondaryColor = _ref.LEGACY_secondaryColor, LEGACY_size = _ref.LEGACY_size, FallbackIcon = _ref.LEGACY_fallbackIcon, _ref$type = _ref.type, type = _ref$type === void 0 ? "global" : _ref$type, dangerouslySetGlyph = _ref.dangerouslySetGlyph, shouldScale = _ref.shouldScale, LEGACY_margin = _ref.LEGACY_margin;
    var fallbackColor = "var(--ds-icon, #44546F)";
    if ((0, $3C1O0.fg)("platform-design-system-new-icon-default-color") || (0, $3C1O0.fg)("platform-design-system-new-icon-default-color-2")) fallbackColor = "currentColor";
    var color = providedColor !== null && providedColor !== void 0 ? providedColor : fallbackColor;
    var dangerouslySetInnerHTML = dangerouslySetGlyph ? {
        __html: dangerouslySetGlyph
    } : undefined;
    // Fall back to old icon
    if (FallbackIcon && !(0, $3C1O0.fg)("platform.design-system-team.enable-new-icons")) // parse out unnecessary props
    return (0, $jVTBW.jsx)(FallbackIcon, {
        primaryColor: LEGACY_primaryColor !== null && LEGACY_primaryColor !== void 0 ? LEGACY_primaryColor : color,
        secondaryColor: LEGACY_secondaryColor,
        size: LEGACY_size,
        label: label,
        testId: testId,
        UNSAFE_margin: LEGACY_margin
    });
    // Utility icons don't have 'spacing' as a type, but in case it's provided, we default to 'none'
    var spacing = type === "utility" ? "none" : providedSpacing;
    var baseSize = $449d97979b724945$var$baseSizeMap[type];
    var size = type === "utility" ? "utility" : shouldScale ? "scale" : spacing;
    var viewBoxPadding = spacing === "spacious" ? 4 : 0;
    var viewBoxSize = baseSize + 2 * viewBoxPadding;
    // Workaround for the transparency in our disabled icon token.
    // Because we have multiple strokes in icons, opacities overlap
    // This filter has an impact on render performance, but this is
    // acceptable as icons aren't commonly disabled en-masse
    var iconColor = color;
    if (dangerouslySetInnerHTML && color === "var(--ds-icon-disabled, #091E424F)") {
        dangerouslySetInnerHTML.__html = '\n<filter id="ds-newIconOpacityFilter">\n  <feFlood flood-color="var(--ds-icon-disabled)" />\n  <feComposite in2="SourceGraphic" operator="in" />\n</filter>\n<g filter="url(#ds-newIconOpacityFilter)">\n  '.concat(dangerouslySetInnerHTML.__html, "\n</g>");
        iconColor = "var(--ds-icon, #44546F)";
    }
    return (0, $jVTBW.jsx)("span", {
        "data-testid": testId,
        role: label ? "img" : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: {
            color: iconColor
        },
        css: [
            $449d97979b724945$var$iconStyles,
            $449d97979b724945$var$baseHcmStyles,
            shouldScale && $449d97979b724945$var$scaleStyles,
            type === "utility" && $449d97979b724945$var$utilityIconStyles
        ]
    }, (0, $jVTBW.jsx)("svg", {
        fill: "none",
        viewBox: "".concat(0 - viewBoxPadding, " ").concat(0 - viewBoxPadding, " ").concat(viewBoxSize, " ").concat(viewBoxSize),
        role: "presentation",
        css: [
            $449d97979b724945$var$commonSVGStyles,
            $449d97979b724945$var$svgStyles,
            $449d97979b724945$var$sizeMap[size]
        ],
        dangerouslySetInnerHTML: dangerouslySetInnerHTML
    }));
});
var $449d97979b724945$export$2e2bcd8739ae039 = $449d97979b724945$export$f04a61298a47a40f;

});




parcelRegister("i9KVl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d37d775d47a5133e$export$2e2bcd8739ae039; });

var $iDtim = parcelRequire("iDtim");

var $dAx5m = parcelRequire("dAx5m");

var $kjzyh = parcelRequire("kjzyh");

var $9Bh6U = parcelRequire("9Bh6U");

var $5zLEw = parcelRequire("5zLEw");
var $d37d775d47a5133e$export$97192c8fa0d5e26b = function slideInAnimation(from, state, fade) {
    var _ref;
    var initial = state === "entering" ? "0%" : "100%";
    var end = state === "entering" ? "100%" : "0%";
    var fromMap = {
        top: "translate3d(0, -100%, 0)",
        right: "translate3d(100%, 0, 0)",
        bottom: "translate3d(0, 100%, 0)",
        left: "translate3d(-100%, 0, 0)"
    };
    var animateOpacity = fade === "inout" || fade === "in" && state === "entering" || fade === "out" && state === "exiting";
    return _ref = {}, (0, (/*@__PURE__*/$parcel$interopDefault($iDtim)))(_ref, initial, {
        transform: fromMap[from],
        opacity: animateOpacity ? 0 : 1
    }), (0, (/*@__PURE__*/$parcel$interopDefault($iDtim)))(_ref, end, {
        transform: "none",
        opacity: 1
    }), _ref;
};
/**
 * __SlideIn__
 *
 * Will slide an element into position, generally used for things that appear from outside of the viewport into view.
 *
 * See [examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motions).
 */ var $d37d775d47a5133e$var$SlideIn = function SlideIn(_ref2) {
    var children = _ref2.children, enterFrom = _ref2.enterFrom, exitTo = _ref2.exitTo, _ref2$fade = _ref2.fade, fade = _ref2$fade === void 0 ? "none" : _ref2$fade, _ref2$duration = _ref2.duration, duration = _ref2$duration === void 0 ? (0, $9Bh6U.mediumDurationMs) : _ref2$duration, isPaused = _ref2.isPaused, onFinish = _ref2.onFinish, _ref2$animationTiming = _ref2.animationTimingFunction, animationTimingFunction = _ref2$animationTiming === void 0 ? function(state) {
        return state === "entering" ? (0, $kjzyh.easeOut) : (0, $kjzyh.easeIn);
    } : _ref2$animationTiming;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $5zLEw.default), {
        duration: duration,
        enteringAnimation: $d37d775d47a5133e$export$97192c8fa0d5e26b(enterFrom, "entering", fade),
        exitingAnimation: $d37d775d47a5133e$export$97192c8fa0d5e26b(exitTo || enterFrom, "exiting", fade),
        animationTimingFunction: animationTimingFunction,
        isPaused: isPaused,
        onFinish: onFinish
    }, children);
};
var $d37d775d47a5133e$export$2e2bcd8739ae039 = $d37d775d47a5133e$var$SlideIn;

});

parcelRegister("3QLyo", function(module, exports) {

$parcel$export(module.exports, "createExtender", function () { return $2cdb1d9710d87637$export$3f052dbd10b2d4da; });
// eslint-disable-next-line @repo/internal/react/consistent-types-definitions
/**
 * @deprecated Please avoid using this function as we intend to remote it in a future release. See DSP-2673 for more information.
 */ var $2cdb1d9710d87637$export$3f052dbd10b2d4da = function createExtender(defaults) {
    var overrides = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Object.create(Object.prototype);
    if (!defaults) throw new Error("a default set of overrides *must* be passed in as the first argument");
    return function getOverrides(key) {
        var _defaults$key = defaults[key], defaultCssFn = _defaults$key.cssFn, defaultComponent = _defaults$key.component;
        if (!overrides[key]) return {
            cssFn: defaultCssFn,
            component: defaultComponent
        };
        var _overrides$key = overrides[key], customCssFn = _overrides$key.cssFn, customComponent = _overrides$key.component;
        var composedCssFn = function composedCssFn(state) {
            return customCssFn(defaultCssFn(state), state);
        };
        return {
            cssFn: customCssFn ? composedCssFn : defaultCssFn,
            component: customComponent || defaultComponent
        };
    };
};

});

parcelRegister("bFV6j", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $87ffd10f31ae8f16$export$2e2bcd8739ae039; });

var $8TMbA = parcelRequire("8TMbA");

var $8jzoy = parcelRequire("8jzoy");

var $jVTBW = parcelRequire("jVTBW");
var $87ffd10f31ae8f16$var$_excluded = [
    "cssFn"
];
var $87ffd10f31ae8f16$var$defaultStyles = {
    flex: 1,
    overflow: "auto",
    marginTop: "var(--ds-space-300, 24px)"
};
var $87ffd10f31ae8f16$var$contentCSS = function contentCSS() {
    return $87ffd10f31ae8f16$var$defaultStyles;
};
var $87ffd10f31ae8f16$var$Content = function Content(_ref) {
    var cssFn = _ref.cssFn, props = (0, (/*@__PURE__*/$parcel$interopDefault($8jzoy)))(_ref, $87ffd10f31ae8f16$var$_excluded);
    return(/**
     * I noticed the implementation at @atlaskit/checkbox would send the props to cssFn rather
     * than the defaultStyles as the overrides guide suggests. I went with what the overrides
     * guide suggested as it made more sense as a transformer of the current styles rather than
     * a complete override with no chance of partially changing styles.
     */ // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @repo/internal/react/no-unsafe-spread-props
    (0, $jVTBW.jsx)("div", (0, (/*@__PURE__*/$parcel$interopDefault($8TMbA)))({
        css: (0, $jVTBW.css)(cssFn($87ffd10f31ae8f16$var$defaultStyles))
    }, props)));
};
var $87ffd10f31ae8f16$export$2e2bcd8739ae039 = {
    component: $87ffd10f31ae8f16$var$Content,
    cssFn: $87ffd10f31ae8f16$var$contentCSS
};

});

parcelRegister("335tc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2385e52270cfd33f$export$2e2bcd8739ae039; });

var $iDtim = parcelRequire("iDtim");

var $dAx5m = parcelRequire("dAx5m");

var $jVTBW = parcelRequire("jVTBW");

var $8pNC4 = parcelRequire("8pNC4");

var $lmjFT = parcelRequire("lmjFT");

var $cAXjb = parcelRequire("cAXjb");

var $8vEK9 = parcelRequire("8vEK9");
var $2385e52270cfd33f$var$_css;
var $2385e52270cfd33f$export$f693ac40d0904cc2 = {
    full: {
        width: "100vw"
    },
    extended: {
        width: "95vw"
    },
    narrow: {
        width: 360
    },
    medium: {
        width: 480
    },
    wide: {
        width: 600
    }
};
var $2385e52270cfd33f$var$wrapperStyles = (0, $jVTBW.css)(($2385e52270cfd33f$var$_css = {
    display: "flex",
    height: "100vh",
    position: "fixed",
    zIndex: 500,
    backgroundColor: "var(--ds-surface-overlay, ".concat((0, $lmjFT.N0), ")")
}, (0, (/*@__PURE__*/$parcel$interopDefault($iDtim)))($2385e52270cfd33f$var$_css, (0, $cAXjb.CURRENT_SURFACE_CSS_VAR), "var(--ds-surface-overlay, ".concat((0, $lmjFT.N0), ")")), (0, (/*@__PURE__*/$parcel$interopDefault($iDtim)))($2385e52270cfd33f$var$_css, "insetBlockStart", 0), (0, (/*@__PURE__*/$parcel$interopDefault($iDtim)))($2385e52270cfd33f$var$_css, "insetInlineStart", 0), (0, (/*@__PURE__*/$parcel$interopDefault($iDtim)))($2385e52270cfd33f$var$_css, "overflow", "hidden"), $2385e52270cfd33f$var$_css));
/**
 * A wrapper that controls the styling of the drawer with a few hacks with refs to get our Touch±Scroll locks working.
 */ var $2385e52270cfd33f$var$DrawerWrapper = /*#__PURE__*/ (0, $dAx5m.forwardRef)(function(_ref, scrollRef) {
    var children = _ref.children, className = _ref.className, _ref$width = _ref.width, width = _ref$width === void 0 ? "narrow" : _ref$width, testId = _ref.testId, drawerRef = _ref.drawerRef, label = _ref.label, titleId = _ref.titleId;
    /**
   * We use a callback ref to assign the `<Content />` component to the forwarded `scrollRef`.
   * This ref comes from `react-scrolllock` to allow touch scrolling, eg.: `<ScrollLock><TouchScrollable>{children}</TouchScrollable><ScrollLock>`
   *
   * This is because we do not control the `<Content />` component in order to forward a ref to it (given it can be overriden via `DrawerPrimitiveProps['overrides']['Content']['component']`).
   * Additionally, we target the last child because with `props.overrides.Sidebar.component = () => null` you only have one child.
   * If both `Sidebar.component` and `Content.component` return null you will have no children and this will throw an error, but that doesn't seem valid.
   */ var assignSecondChildRef = (0, $dAx5m.useCallback)(function(node) {
        var _node$children;
        if (node !== null && node !== void 0 && (_node$children = node.children) !== null && _node$children !== void 0 && _node$children.length && typeof scrollRef === "function") scrollRef(node.children[node.children.length - 1]);
    }, [
        scrollRef
    ]);
    var ref = (0, $8pNC4.useMergeRefs)([
        drawerRef,
        assignSecondChildRef
    ]);
    (0, $8vEK9.default)();
    return (0, $jVTBW.jsx)("div", {
        css: $2385e52270cfd33f$var$wrapperStyles,
        style: $2385e52270cfd33f$export$f693ac40d0904cc2[width],
        className: className,
        "data-testid": testId,
        ref: ref,
        "aria-modal": true,
        role: "dialog",
        "aria-label": label,
        "aria-labelledby": titleId
    }, children);
});
var $2385e52270cfd33f$export$2e2bcd8739ae039 = $2385e52270cfd33f$var$DrawerWrapper;

});
parcelRegister("8vEK9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6320d2c8162fc2a8$export$2e2bcd8739ae039; });

var $6RxC1 = parcelRequire("6RxC1");

var $dAx5m = parcelRequire("dAx5m");

var $dd4sf = parcelRequire("dd4sf");
/**
 * Returns how far the body is scrolled from the top of the viewport.
 *
 * ⚠️ This is copied from `packages/design-system/modal-dialog/src/internal/hooks/use-prevent-programmatic-scroll.tsx`
 *
 *   ____
 * ||____|| <-- overflow
 *  |    |  <-- viewport
 *  |____|
 *
 * Scroll distance is the height of overflow outside the viewport.
 */ function $6320d2c8162fc2a8$var$getScrollDistance() {
    var _document$documentEle, _document$body;
    return window.pageYOffset || ((_document$documentEle = document.documentElement) === null || _document$documentEle === void 0 ? void 0 : _document$documentEle.scrollTop) || ((_document$body = document.body) === null || _document$body === void 0 ? void 0 : _document$body.scrollTop) || 0;
}
function $6320d2c8162fc2a8$export$2e2bcd8739ae039() {
    var _useState = (0, $dAx5m.useState)(0), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($6RxC1)))(_useState, 2), scrollTopOffset = _useState2[0], setScrollTopOffset = _useState2[1];
    (0, $dAx5m.useLayoutEffect)(function() {
        setScrollTopOffset($6320d2c8162fc2a8$var$getScrollDistance());
    }, []);
    var onWindowScroll = (0, $dAx5m.useCallback)(function() {
        if ($6320d2c8162fc2a8$var$getScrollDistance() !== scrollTopOffset) window.scrollTo(window.pageXOffset, scrollTopOffset);
    }, [
        scrollTopOffset
    ]);
    (0, $dAx5m.useEffect)(function() {
        return (0, $dd4sf.bind)(window, {
            type: "scroll",
            listener: onWindowScroll
        });
    }, [
        onWindowScroll
    ]);
    return scrollTopOffset;
}

});


parcelRegister("3yKv3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $29789df9d69c42a4$export$2e2bcd8739ae039; });

var $5MUML = parcelRequire("5MUML");

var $dXLvS = parcelRequire("dXLvS");

var $4irYd = parcelRequire("4irYd");

var $lKQfu = parcelRequire("lKQfu");

var $fKxww = parcelRequire("fKxww");

var $ilqjt = parcelRequire("ilqjt");

var $iDtim = parcelRequire("iDtim");

var $dAx5m = parcelRequire("dAx5m");

var $hKRkP = parcelRequire("hKRkP");

var $5SgSF = parcelRequire("5SgSF");


var $1XHoZ = parcelRequire("1XHoZ");

var $ahJoN = parcelRequire("ahJoN");
function $29789df9d69c42a4$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $29789df9d69c42a4$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $29789df9d69c42a4$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($iDtim)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $29789df9d69c42a4$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $29789df9d69c42a4$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $29789df9d69c42a4$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, (/*@__PURE__*/$parcel$interopDefault($ilqjt)))(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, (/*@__PURE__*/$parcel$interopDefault($ilqjt)))(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, (/*@__PURE__*/$parcel$interopDefault($fKxww)))(this, result);
    };
}
function $29789df9d69c42a4$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($29789df9d69c42a4$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
// Thin wrapper over react-focus-lock. This wrapper only exists to ensure API compatibility.
// This component should be deleted during https://ecosystem.atlassian.net/browse/AK-5658
var $29789df9d69c42a4$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_Component) {
    (0, (/*@__PURE__*/$parcel$interopDefault($lKQfu)))(FocusLock, _Component);
    var _super = $29789df9d69c42a4$var$_createSuper(FocusLock);
    function FocusLock() {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($5MUML)))(this, FocusLock);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, (/*@__PURE__*/$parcel$interopDefault($iDtim)))((0, (/*@__PURE__*/$parcel$interopDefault($4irYd)))(_this), "getFocusTarget", function() {
            var shouldReturnFocus = _this.props.shouldReturnFocus;
            if (typeof shouldReturnFocus === "boolean") return shouldReturnFocus;
            return false;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($iDtim)))((0, (/*@__PURE__*/$parcel$interopDefault($4irYd)))(_this), "onDeactivation", function() {
            var shouldReturnFocus = _this.props.shouldReturnFocus;
            if (typeof shouldReturnFocus !== "boolean") window.setTimeout(function() {
                var _shouldReturnFocus$cu;
                shouldReturnFocus === null || shouldReturnFocus === void 0 || (_shouldReturnFocus$cu = shouldReturnFocus.current) === null || _shouldReturnFocus$cu === void 0 || _shouldReturnFocus$cu.focus();
            }, 0);
        });
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($dXLvS)))(FocusLock, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var _this$props = this.props, isFocusLockEnabled = _this$props.isFocusLockEnabled, autoFocusFirstElem = _this$props.autoFocusFirstElem;
                typeof $ahJoN;
                if (typeof autoFocusFirstElem === "function" && isFocusLockEnabled) {
                    var elem = autoFocusFirstElem();
                    if (elem && elem.focus) elem.focus();
                }
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props2 = this.props, isFocusLockEnabled = _this$props2.isFocusLockEnabled, autoFocusFirstElem = _this$props2.autoFocusFirstElem, children = _this$props2.children;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $hKRkP.default), {
                    disabled: !isFocusLockEnabled,
                    autoFocus: !!autoFocusFirstElem,
                    returnFocus: this.getFocusTarget(),
                    onDeactivation: this.onDeactivation
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5SgSF))), null, children));
            }
        }
    ]);
    return FocusLock;
}((0, $dAx5m.Component));
(0, (/*@__PURE__*/$parcel$interopDefault($iDtim)))($29789df9d69c42a4$export$2e2bcd8739ae039, "defaultProps", $29789df9d69c42a4$var$_objectSpread({}, (0, $1XHoZ.defaultFocusLockSettings)));

});

parcelRegister("dsf6a", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9cb99a276fc1ee87$export$2e2bcd8739ae039; });

var $8TMbA = parcelRequire("8TMbA");

var $8jzoy = parcelRequire("8jzoy");

var $jVTBW = parcelRequire("jVTBW");

var $lmjFT = parcelRequire("lmjFT");
var $9cb99a276fc1ee87$var$_excluded = [
    "cssFn"
];
var $9cb99a276fc1ee87$var$defaultStyle = {
    alignItems: "center",
    boxSizing: "border-box",
    color: "var(--ds-text-subtle, ".concat((0, $lmjFT.N500), ")"),
    display: "flex",
    flexShrink: 0,
    flexDirection: "column",
    height: "100vh",
    paddingBottom: "var(--ds-space-200, 16px)",
    paddingTop: "var(--ds-space-300, 24px)",
    width: "var(--ds-space-800, 64px)"
};
var $9cb99a276fc1ee87$var$sidebarCSS = function sidebarCSS() {
    return $9cb99a276fc1ee87$var$defaultStyle;
};
var $9cb99a276fc1ee87$var$Sidebar = function Sidebar(_ref) {
    var cssFn = _ref.cssFn, props = (0, (/*@__PURE__*/$parcel$interopDefault($8jzoy)))(_ref, $9cb99a276fc1ee87$var$_excluded);
    // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @repo/internal/react/no-unsafe-spread-props
    return (0, $jVTBW.jsx)("div", (0, (/*@__PURE__*/$parcel$interopDefault($8TMbA)))({
        css: (0, $jVTBW.css)(cssFn($9cb99a276fc1ee87$var$defaultStyle))
    }, props));
};
var $9cb99a276fc1ee87$export$2e2bcd8739ae039 = {
    component: $9cb99a276fc1ee87$var$Sidebar,
    cssFn: $9cb99a276fc1ee87$var$sidebarCSS
};

});



parcelRegister("5rapc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3f578bac1b21962c$var$_react = $3f578bac1b21962c$var$_interopRequireDefault((parcelRequire("dAx5m")));

var $3AZdd = parcelRequire("3AZdd");

var $3f578bac1b21962c$var$_close = $3f578bac1b21962c$var$_interopRequireDefault((parcelRequire("jrF2P")));
function $3f578bac1b21962c$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $3f578bac1b21962c$var$CrossIcon = (props)=>/*#__PURE__*/ $3f578bac1b21962c$var$_react.default.createElement($3AZdd.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M12 10.586 6.707 5.293a1 1 0 0 0-1.414 1.414L10.586 12l-5.293 5.293a1 1 0 0 0 1.414 1.414L12 13.414l5.293 5.293a1 1 0 0 0 1.414-1.414L13.414 12l5.293-5.293a1 1 0 1 0-1.414-1.414z"/></svg>`
    }, props, {
        newIcon: $3f578bac1b21962c$var$_close.default
    }));
$3f578bac1b21962c$var$CrossIcon.displayName = "CrossIcon";
var $3f578bac1b21962c$var$_default = module.exports.default = $3f578bac1b21962c$var$CrossIcon;

});
parcelRegister("jrF2P", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e1d767c2bf4320bb7e127b754b192d24>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e280608ff23c153d$var$_react = $e280608ff23c153d$var$_interopRequireDefault((parcelRequire("dAx5m")));

var $e280608ff23c153d$var$_UNSAFE_baseNew = $e280608ff23c153d$var$_interopRequireDefault((parcelRequire("jbpyS")));
function $e280608ff23c153d$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Close".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for closing an element.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e280608ff23c153d$var$CloseIcon = (props)=>/*#__PURE__*/ $e280608ff23c153d$var$_react.default.createElement($e280608ff23c153d$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M2.5 13.5 8 8m5.5-5.5L8 8m0 0L2.5 2.5M8 8l5.5 5.5"/>`
    }, props));
$e280608ff23c153d$var$CloseIcon.displayName = "CloseIcon";
var $e280608ff23c153d$var$_default = module.exports.default = $e280608ff23c153d$var$CloseIcon;

});


parcelRegister("gLQuH", function(module, exports) {

$parcel$export(module.exports, "DrawerInner", function () { return $c359c1613fe23a36$export$2f76d09cb125fa40; });

var $45N2i = parcelRequire("45N2i");

var $ku6eE = parcelRequire("ku6eE");
var $c359c1613fe23a36$var$_templateObject, $c359c1613fe23a36$var$_templateObject2, $c359c1613fe23a36$var$_templateObject3;
var $c359c1613fe23a36$export$2f76d09cb125fa40 = (0, $ku6eE.default).div($c359c1613fe23a36$var$_templateObject || ($c359c1613fe23a36$var$_templateObject = (0, (/*@__PURE__*/$parcel$interopDefault($45N2i)))([
    "\n  display: flex;\n  flex-wrap: wrap;\n  flex-direction: column;\n  align-items: center;\n"
])));
var $c359c1613fe23a36$export$8f19479c4e4f4bea = (0, $ku6eE.default).div($c359c1613fe23a36$var$_templateObject2 || ($c359c1613fe23a36$var$_templateObject2 = (0, (/*@__PURE__*/$parcel$interopDefault($45N2i)))([
    "\n  display: flex;\n  justify-content: flex-end;\n"
])));
var $c359c1613fe23a36$export$612c8fee292cf7ab = (0, $ku6eE.default).div($c359c1613fe23a36$var$_templateObject3 || ($c359c1613fe23a36$var$_templateObject3 = (0, (/*@__PURE__*/$parcel$interopDefault($45N2i)))([
    "\n  width: 352px;\n"
])));

});
parcelRegister("45N2i", function(module, exports) {
function $2fadaa9c2cb21d94$var$_taggedTemplateLiteral(e, t) {
    return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, {
        raw: {
            value: Object.freeze(t)
        }
    }));
}
module.exports = $2fadaa9c2cb21d94$var$_taggedTemplateLiteral, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("5Sc6l", function(module, exports) {

$parcel$export(module.exports, "default", function () { return (parcelRequire("iEIrF")).default; });

var $iEIrF = parcelRequire("iEIrF");

});
parcelRegister("iEIrF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d94e704c24adb749$export$2e2bcd8739ae039; });

var $5MUML = parcelRequire("5MUML");

var $dXLvS = parcelRequire("dXLvS");

var $lKQfu = parcelRequire("lKQfu");

var $fKxww = parcelRequire("fKxww");

var $ilqjt = parcelRequire("ilqjt");

var $dAx5m = parcelRequire("dAx5m");

var $Ia2MJ = parcelRequire("Ia2MJ");

var $fIjLq = parcelRequire("fIjLq");

var $8FbV2 = parcelRequire("8FbV2");
function $d94e704c24adb749$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $d94e704c24adb749$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, (/*@__PURE__*/$parcel$interopDefault($ilqjt)))(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, (/*@__PURE__*/$parcel$interopDefault($ilqjt)))(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, (/*@__PURE__*/$parcel$interopDefault($fKxww)))(this, result);
    };
}
function $d94e704c24adb749$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($d94e704c24adb749$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $d94e704c24adb749$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_React$Component) {
    (0, (/*@__PURE__*/$parcel$interopDefault($lKQfu)))(Footer, _React$Component);
    var _super = $d94e704c24adb749$var$_createSuper(Footer);
    function Footer() {
        (0, (/*@__PURE__*/$parcel$interopDefault($5MUML)))(this, Footer);
        return _super.apply(this, arguments);
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($dXLvS)))(Footer, [
        {
            key: "render",
            value: function render() {
                var _this$props = this.props, currentScreenIdx = _this$props.currentScreenIdx, numScreens = _this$props.numScreens, onCancel = _this$props.onCancel, onNext = _this$props.onNext, onPrevious = _this$props.onPrevious, secondaryActions = _this$props.secondaryActions, submitButton = _this$props.submitButton;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement($8FbV2.FooterOuter, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement("div", null, secondaryActions), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $Ia2MJ.default), null, currentScreenIdx < 1 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $fIjLq.default), {
                    onClick: onCancel
                }, "Cancel") : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $fIjLq.default), {
                    onClick: onPrevious
                }, "Previous"), currentScreenIdx < numScreens - 1 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $fIjLq.default), {
                    appearance: "primary",
                    onClick: onNext
                }, "Next") : submitButton));
            }
        }
    ]);
    return Footer;
}((0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).Component);

});
parcelRegister("8FbV2", function(module, exports) {

$parcel$export(module.exports, "FooterOuter", function () { return $64eb65f1d0b6bffd$export$62744312a84a7fcb; });

var $45N2i = parcelRequire("45N2i");

var $ku6eE = parcelRequire("ku6eE");

var $60Te3 = parcelRequire("60Te3");
var $64eb65f1d0b6bffd$var$_templateObject;
var $64eb65f1d0b6bffd$export$62744312a84a7fcb = (0, $ku6eE.default).div($64eb65f1d0b6bffd$var$_templateObject || ($64eb65f1d0b6bffd$var$_templateObject = (0, (/*@__PURE__*/$parcel$interopDefault($45N2i)))([
    "\n  display: flex;\n  width: 100%;\n  max-width: 640px;\n  @media screen and (max-width: 640px) {\n    justify-content: space-evenly;\n    padding-bottom: ",
    "px;\n    align-items: center;\n  }\n  justify-content: space-between;\n  margin-top: ",
    "px;\n"
])), (0, $60Te3.default)(3), (0, $60Te3.default)(4));

});
parcelRegister("60Te3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $460d94d37b2d787e$export$2e2bcd8739ae039; });

var $hrGjC = parcelRequire("hrGjC");
var $460d94d37b2d787e$var$gridSizeTimes = function gridSizeTimes(n) {
    return n * (0, $hrGjC.gridSize)();
};
var $460d94d37b2d787e$export$2e2bcd8739ae039 = $460d94d37b2d787e$var$gridSizeTimes;

});




parcelRegister("jrFqr", function(module, exports) {

$parcel$export(module.exports, "commonMessages", function () { return $e280ac283861eda0$export$822cdd78febe6c96; });
$parcel$export(module.exports, "overviewMessages", function () { return $e280ac283861eda0$export$fc48309289dd3d68; });
$parcel$export(module.exports, "deactivateUserOverviewMessages", function () { return $e280ac283861eda0$export$7a8cbf7d2dd3baff; });
$parcel$export(module.exports, "contentPreviewMessages", function () { return $e280ac283861eda0$export$bc41d552226ebbe2; });
$parcel$export(module.exports, "dropDownListMessages", function () { return $e280ac283861eda0$export$ed6a941319924afa; });

var $lKhJJ = parcelRequire("lKhJJ");
var $e280ac283861eda0$export$822cdd78febe6c96 = (0, $lKhJJ.defineMessages)({
    deactivateAccount: {
        id: "focused-task-close-account.deactivate-account",
        defaultMessage: "Deactivate account",
        description: "Text that appears in a button, link or heading for the action of deactivating an account"
    },
    deleteAccount: {
        id: "focused-task-close-account.delete-account",
        defaultMessage: "Delete account",
        description: "Text that appears in a button, link or heading for the action of deleting an account"
    },
    learnMore: {
        id: "focused-task-close-account.learnMore",
        defaultMessage: "Learn more",
        description: "Text for a link to a page where a user can learn more about a particular topic"
    },
    cancel: {
        id: "focused-task-close-account.cancel",
        defaultMessage: "Cancel",
        description: "Text for a button for a user to cancel the current task/process"
    },
    next: {
        id: "focused-task-close-account.next",
        defaultMessage: "Next",
        description: "Text for a button for a user to proceed to the next step of a process"
    },
    previous: {
        id: "focused-task-close-account.previous",
        defaultMessage: "Previous",
        description: "Text for a button for a user to go back to the previous step of a process"
    }
});
var $e280ac283861eda0$export$fc48309289dd3d68 = (0, $lKhJJ.defineMessages)({
    headingSelf: {
        id: "focused-task-close-account.delete-account.overview.heading.self",
        defaultMessage: "Delete your account",
        description: "Heading for the screen that explains what happens when a user's account is deleted"
    },
    headingAdmin: {
        id: "focused-task-close-account.delete-account.overview.heading.admin",
        defaultMessage: "Delete account",
        description: "Heading for the screen that explains what happens when an admin deletes a user's account"
    },
    firstLineSelf: {
        id: "focused-task-close-account.delete-account.overview.first.line.self",
        defaultMessage: "You're about to delete your account:",
        description: "First line for the screen when the admin is about to delete another user"
    },
    firstLineAdmin: {
        id: "focused-task-close-account.delete-account.overview.first.line.admin",
        defaultMessage: "You're about to delete the account of:",
        description: "First line for the screen when the user is about to delete their own account"
    },
    warningSectionBody: {
        id: "focused-task-close-account.delete-account.overview.warning-section.body",
        defaultMessage: "After a 14-day grace period, you won\u2019t be able to cancel the deletion of the account. If you think you\u2019ll need the account later, deactivate it instead.",
        description: "A warning message shown to users when they try to delete their account."
    },
    warningSectionBodyDeactivated: {
        id: "focused-task-close-account.delete-account.overview.warning-section.deactivated.body",
        defaultMessage: "After a 14-day grace period, you won\u2019t be able to cancel the deletion of the account.",
        description: "A warning message shown to deactivated users when they try to delete their account."
    },
    paragraphAboutToDeleteAdmin: {
        id: "focused-task-close-account.delete-account.overview.paragraph.about-to-delete.admin",
        defaultMessage: "When you delete the account:",
        description: "A paragraph explaining that the admin is about to delete another user"
    },
    paragraphAboutToDeleteSelf: {
        id: "focused-task-close-account.delete-account.overview.paragraph.about-to-delete.self",
        defaultMessage: "When you delete your account:",
        description: "A paragraph explaining that user is about to delete their own account"
    },
    paragraphLoseAccessAdmin: {
        id: "focused-task-close-account.delete-account.overview.paragraph.loseAccess.admin",
        defaultMessage: "{fullName} will <b>immediately lose access</b> to all Atlassian account services. They currently have access to: ",
        description: "A paragraph explaining that upon deletion the user will lose access to certain services. The second sentence is to begin a list of services the user-to-be-deleted can currently access. {fullName} is filled in by the web app."
    },
    paragraphLoseAccessSelf: {
        id: "focused-task-close-account.delete-account.overview.paragraph.loseAccess.self",
        defaultMessage: "You'll <b>immediately lose access</b> to all Atlassian account services. You currently have access to:",
        description: "A paragraph explaining that upon deletion the user will lose access to certain services. The second sentence is to begin a list of services the user-to-be-deleted can currently access."
    },
    paragraphLoseAccessAdminNoSites: {
        id: "focused-task-close-account.delete-account.overview.paragraph.loseAccess.admin.noSites",
        defaultMessage: "{fullName} will <b>immediately lose access</b> to all Atlassian account services. Currently, they don\u2019t have access to any, except services like Community and Marketplace. ",
        description: "A paragraph explaining that upon deletion the user will lose access to certain services. The second sentence is to begin a list of services the user-to-be-deleted can currently access. {fullName} is filled in by the web app."
    },
    paragraphLoseAccessSelfNoSites: {
        id: "focused-task-close-account.delete-account.overview.paragraph.loseAccess.self.noSites",
        defaultMessage: "You'll <b>immediately lose access</b> to all Atlassian account services. Currently, you don\u2019t have access to any, except services like Community and Marketplace.",
        description: "A paragraph explaining that upon deletion the user will lose access to certain services. The second sentence is to begin a list of services the user-to-be-deleted can currently access."
    },
    paragraphLoseAccessFootnote: {
        id: "focused-task-close-account.delete-account.overview.paragraph.loseAccess.footnote",
        defaultMessage: "Other Atlassian account services, such as Atlassian Community and Marketplace. ",
        description: "A paragraph explaining that upon deletion the user may also lose access to services that weren't listed prior."
    },
    paragraphContentCreatedAdmin: {
        id: "focused-task-close-account.delete-account.overview.paragraph.content-created.admin",
        defaultMessage: "The content they've created will remain in Atlassian account services.",
        description: "A paragraph explaining that although the user's details will be deleted, content they have created will remain."
    },
    paragraphContentCreatedSelf: {
        id: "focused-task-close-account.delete-account.overview.paragraph.content-created.self",
        defaultMessage: "The content you've created will remain in Atlassian account services.",
        description: "A paragraph explaining that although the user's details will be deleted, content they have created will remain."
    },
    inlineDialogContentCreatedAdmin: {
        id: "focused-task-close-account.delete-account.overview.inline-dialog.content-created.admin",
        defaultMessage: "For example, pages, issues, and comments they've created in products.",
        description: "Examples of what constitutes as created content. Appears when the user hovers over the info icon"
    },
    inlineDialogContentCreatedSelf: {
        id: "focused-task-close-account.delete-account.overview.inline-dialog.content-created.self",
        defaultMessage: "For example, pages, issues, and comments you've created in products.",
        description: "Examples of what constitutes as created content. Appears when the user hovers over the info icon"
    },
    paragraphPersonalDataWillBeDeletedAdmin: {
        id: "focused-task-close-account.delete-account.overview.paragraph.personal-data-will-be-deleted.admin",
        defaultMessage: "We'll <b>delete their personal data</b>, such as their full name and email address, from Atlassian account services within 30 days, except in a few cases where required for legitimate business or legal purposes. ",
        description: "A paragraph explaining what parts of the user's personal data will be deleted"
    },
    paragraphPersonalDataWillBeDeletedSelf: {
        id: "focused-task-close-account.delete-account.overview.paragraph.personal-data-will-be-deleted.self",
        defaultMessage: "We'll <b>delete your personal data</b>, such as your full name and email address, from Atlassian account services within 30 days, except in a few cases where required for legitimate business or legal purposes. ",
        description: "A paragraph explaining what parts of the user's personal data will be deleted"
    },
    paragraphListOfAppsWithPersonalDataAdmin: {
        id: "focused-task-close-account.delete-account.overview.paragraph.list-of-apps-with-personal-data.admin",
        defaultMessage: "We\u2019ll email you a list of apps that may have stored their personal data.",
        description: "A note explaining that about apps storing personal data"
    },
    paragraphListOfAppsWithPersonalDataSelf: {
        id: "focused-task-close-account.delete-account.overview.paragraph.list-of-apps-with-personal-data.self",
        defaultMessage: "We\u2019ll email you a list of apps that may have stored your personal data.",
        description: "A note explaining that about apps storing personal data"
    },
    paragraphGracePeriodAdmin: {
        id: "focused-task-close-account.delete-account.overview.paragraph.grace-period.admin",
        defaultMessage: "After a 14-day grace period, you won\u2019t be able to cancel the deletion of the account.",
        description: "A note explaining about the grace period"
    },
    inlineDialogDataWillBeDeletedP1Admin: {
        id: "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.p1.admin",
        defaultMessage: "We keep personal data for limited periods when we have legitimate business or legal purposes. Some examples include:",
        description: "Text elaborating on the note that some personal data is required to be saved from deletion for legal purposes."
    },
    inlineDialogDataWillBeDeletedP1Self: {
        id: "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.p1.self",
        defaultMessage: "We keep personal data for limited periods when we have legitimate business or legal purposes. Some examples include:",
        description: "Text elaborating on the note that some personal data is required to be saved from deletion for legal purposes."
    },
    inlineDialogDataWillBeDeletedLi1Admin: {
        id: "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.li1.admin",
        defaultMessage: "Information related to purchases, which we're required to keep for financial reporting.",
        description: "Text elaborating on the note that some personal data is required to be saved from deletion for legal purposes."
    },
    inlineDialogDataWillBeDeletedLi1Self: {
        id: "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.li1.self",
        defaultMessage: "Information related to purchases, which we're required to keep for financial reporting.",
        description: "Text elaborating on the note that some personal data is required to be saved from deletion for legal purposes."
    },
    inlineDialogDataWillBeDeletedLi2Admin: {
        id: "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.li2.admin",
        defaultMessage: "Records showing that we deleted someone's account, which we may need to provide to regulators.",
        description: "Text elaborating on the note that some personal data is required to be saved from deletion for legal purposes."
    },
    inlineDialogDataWillBeDeletedLi2Self: {
        id: "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.li2.self",
        defaultMessage: "Records showing that we deleted someone's account, which we may need to provide to regulators.",
        description: "Text elaborating on the note that some personal data is required to be saved from deletion for legal purposes."
    },
    inlineDialogDataWillBeDeletedLi3Admin: {
        id: "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.li3.admin",
        defaultMessage: "Data that's part of an active lawsuit, which we're required to keep by law.",
        description: "Text elaborating on the note that some personal data is required to be saved from deletion for legal purposes."
    },
    inlineDialogDataWillBeDeletedLi3Self: {
        id: "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.li3.self",
        defaultMessage: "Data that's part of an active lawsuit, which we're required to keep by law.",
        description: "Text elaborating on the note that some personal data is required to be saved from deletion for legal purposes."
    },
    inlineDialogDataWillBeDeletedP2Admin: {
        id: "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.p2.admin",
        defaultMessage: "We don\u2019t delete any personal data from content created by users, such as names or email addresses they typed in a page or issue. The product admins need to delete that data manually.",
        description: "Text elaborating on the note that some personal data is required to be saved from deletion for legal purposes."
    },
    inlineDialogDataWillBeDeletedP2Self: {
        id: "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.p2.self",
        defaultMessage: "We don't delete any personal data from content created by you or other people, such as names or email addresses typed into a page or issue. Your product admins need to delete that data manually.",
        description: "Text elaborating on the note that some personal data is required to be saved from deletion for legal purposes."
    },
    inlineDialogDataWillBeDeletedP3Admin: {
        id: "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.p3.admin",
        defaultMessage: "Users have the right to submit complaints to the supervisory authority in their country.",
        description: "Text elaborating on the note that some personal data is required to be saved from deletion for legal purposes."
    },
    inlineDialogDataWillBeDeletedP3Self: {
        id: "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.p3.self",
        defaultMessage: "You have the right to submit complaints to the supervisory authority in your country.",
        description: "Text elaborating on the note that some personal data is required to be saved from deletion for legal purposes."
    },
    inlineDialogDataAppsAdmin: {
        id: "focused-task-close-account.delete-account.overview.inline-dialog.data-apps.admin",
        defaultMessage: "You or other users may have installed apps that add features to Atlassian products. These apps may have stored the user\u2019s profile information.",
        description: "Text elaborating on the note about apps storing personal data"
    },
    inlineDialogDataAppsSelf: {
        id: "focused-task-close-account.delete-account.overview.inline-dialog.data-apps.self",
        defaultMessage: "You or other users may have installed apps that add features to Atlassian products. These apps may have stored your profile information.",
        description: "Text elaborating on the note about apps storing personal data"
    }
});
var $e280ac283861eda0$export$7a8cbf7d2dd3baff = (0, $lKhJJ.defineMessages)({
    headingSelf: {
        id: "focused-task-close-account.deactivate-account.overview.heading.self",
        defaultMessage: "Deactivate account",
        description: "Heading for the screen that explains what happens when a user's account is deactivated"
    },
    headingAdmin: {
        id: "focused-task-close-account.deactivate-account.overview.heading.admin",
        defaultMessage: "Deactivate account",
        description: "Heading for the screen that explains what happens when an admin deactivates a user's account"
    },
    firstLineSelf: {
        id: "focused-task-close-account.deactivate-account.overview.first.line.self",
        defaultMessage: "You're about to deactivate the user account of:",
        description: "First line for the screen when the user is about to deactivate self"
    },
    firstLineAdmin: {
        id: "focused-task-close-account.deactivate-account.overview.first.line.admin",
        defaultMessage: "You're about to deactivate the user account of:",
        description: "First line for the screen when the admin is about to deactivate another user"
    },
    lastLineSelf: {
        id: "focused-task-close-account.deactivate-account.overview.last.line.self",
        defaultMessage: "You can reactivate the account at any time.",
        description: "First line for the screen when the user is about to deactivate self"
    },
    lastLineAdmin: {
        id: "focused-task-close-account.deactivate-account.overview.last.line.admin",
        defaultMessage: "You can reactivate the account at any time.",
        description: "First line for the screen when the admin is about to deactivate another user"
    },
    paragraphAboutToDeactivateAdmin: {
        id: "focused-task-close-account.deactivate-account.overview.paragraph.about-to-deactivate.admin",
        defaultMessage: "When you deactivate the account:",
        description: "A paragraph explaining that the admin is about to deactivate another user"
    },
    paragraphAboutToDeactivateSelf: {
        id: "focused-task-close-account.deactivate-account.overview.paragraph.about-to-deactivate.self",
        defaultMessage: "When you deactivate the account:",
        description: "A paragraph explaining that user is about to deactivate their own account"
    },
    paragraphLoseAccessAdmin: {
        id: "focused-task-close-account.deactivate-account.overview.paragraph.loseAccess.admin",
        defaultMessage: "{fullName} will <b>immediately lose access</b> to all Atlassian account services. They currently have access to: ",
        description: "A paragraph explaining that upon deactivation the user will lose access to certain services. The second sentence is to begin a list of services the user-to-be-deactivated can currently access. {fullName} is filled in by the web app."
    },
    paragraphLoseAccessSelf: {
        id: "focused-task-close-account.deactivate-account.overview.paragraph.loseAccess.self",
        defaultMessage: "You'll <b>immediately lose access</b> to all Atlassian account services. You currently have access to:",
        description: "A paragraph explaining that upon deactivation the user will lose access to certain services. The second sentence is to begin a list of services the user-to-be-deactivated can currently access."
    },
    paragraphLoseAccessAdminNoSites: {
        id: "focused-task-close-account.deactivate-account.overview.paragraph.loseAccess.admin.noSites",
        defaultMessage: "{fullName} will <b>immediately lose access</b> to all Atlassian account services. Currently, they don\u2019t have access to any, except services like Community and Marketplace. ",
        description: "A paragraph explaining that upon deactivation the user will lose access to certain services. The second sentence is to begin a list of services the user-to-be-deactivated can currently access. {fullName} is filled in by the web app."
    },
    paragraphLoseAccessSelfNoSites: {
        id: "focused-task-close-account.deactivate-account.overview.paragraph.loseAccess.self.noSites",
        defaultMessage: "You'll <b>immediately lose access</b> to all Atlassian account services. Currently, you don\u2019t have access to any, except services like Community and Marketplace.",
        description: "A paragraph explaining that upon deactivation the user will lose access to certain services. The second sentence is to begin a list of services the user-to-be-deactivated can currently access."
    },
    paragraphLoseAccessFootnote: {
        id: "focused-task-close-account.deactivate-account.overview.paragraph.loseAccess.footnote",
        defaultMessage: "Other Atlassian account services, such as Atlassian Community and Marketplace. ",
        description: "A paragraph explaining that upon deletion the user may also lose access to services that weren't listed prior."
    },
    paragraphPersonalDataAdmin: {
        id: "focused-task-close-account.deactivate-account.overview.paragraph.personal-data.admin",
        defaultMessage: "Their personal data, such as their full name and email address, and content they've created will remain in Atlassian account services.",
        description: "A paragraph explaining what will happen to the user's personal data"
    },
    paragraphPersonalDataSelf: {
        id: "focused-task-close-account.deactivate-account.overview.paragraph.personal-data.self",
        defaultMessage: "Their personal data, such as their full name and email address, and content they've created will remain in Atlassian account services.",
        description: "A paragraph explaining what will happen to the user's personal data"
    },
    paragraphBillingAdmin: {
        id: "focused-task-close-account.deactivate-account.overview.paragraph.billing.admin",
        defaultMessage: "We'll no longer bill you for them.",
        description: "A paragraph explaining the billing for the products"
    },
    paragraphBillingSelf: {
        id: "focused-task-close-account.deactivate-account.overview.paragraph.billing.self",
        defaultMessage: "We'll no longer bill you for them.",
        description: "A paragraph explaining the billing for the products"
    }
});
var $e280ac283861eda0$export$bc41d552226ebbe2 = (0, $lKhJJ.defineMessages)({
    headingAdmin: {
        id: "focused-task-close-account.delete-account.content-preview.heading.admin",
        defaultMessage: "How would you prefer the deleted user to appear?",
        description: "Heading for the screen that explains admin would prefer user to be remembered"
    },
    headingSelf: {
        id: "focused-task-close-account.delete-account.content-preview.heading.self",
        defaultMessage: "How would you prefer your deleted account to appear?",
        description: "Heading for the screen that explains how users would prefer to be remembered"
    },
    paragraphSurveyAdmin: {
        id: "focused-task-close-account.delete-account.content-preview.paragraph.survey.admin",
        defaultMessage: "After the user\u2019s account is deleted, they\u2019ll appear as \u201CFormer user\u201D to other users. Please take a moment to answer our survey question.",
        description: "First paragraph for the survey for admins"
    },
    paragraphSurveySelf: {
        id: "focused-task-close-account.delete-account.content-preview.paragraph.survey.self",
        defaultMessage: "After your account is deleted, you\u2019ll appear as \u201CFormer user\u201D to other users. Please take a moment to answer our survey question.",
        description: "First paragraph for the survey for personal accounts"
    },
    lineSurveyAdmin: {
        id: "focused-task-close-account.delete-account.content-preview.line.survey.admin",
        defaultMessage: "If we gave you a choice, how would you like the deleted user to appear to other users?",
        description: "Second paragraph for the survey for admins"
    },
    lineSurveySelf: {
        id: "focused-task-close-account.delete-account.content-preview.line.survey.self",
        defaultMessage: "If we gave you a choice, how would you like to appear to other users?",
        description: "Second paragraph for the survey for personal accounts"
    },
    footnoteAdmin: {
        id: "focused-task-close-account.delete-account.content-preview.footnote.admin",
        defaultMessage: "Note: Answering this survey will help us make a better experience for all users. The user will still appear as \u201CFormer user\u201D after you delete their account.",
        description: "Note to admins that the users would still be saved as Former User"
    },
    footnoteSelf: {
        id: "focused-task-close-account.delete-account.content-preview.footnote.self",
        defaultMessage: "Note: Answering this survey will help us make a better experience for all users, including those deleting their accounts. You\u2019ll still appear as \u201CFormer user\u201D after you delete your account.",
        description: "Note to users that they would still be saved as Former User"
    },
    formerUser: {
        id: "focused-task-close-account.delete-account.content-preview.formerUser",
        defaultMessage: "Former user",
        description: "The display name for a user when they do not select their name"
    }
});
var $e280ac283861eda0$export$ed6a941319924afa = (0, $lKhJJ.defineMessages)({
    expandButton: {
        id: "focused-task-close-account.delete-account.drop-down-expand-button",
        defaultMessage: "{num} more",
        description: "Button text displaying number of available sites greater than 3 on expand"
    },
    collapseButton: {
        id: "focused-task-close-account.delete-account.drop-down-collapse-button",
        defaultMessage: "Show less",
        description: "Button text displaying text on collapse"
    }
});

});

parcelRegister("05eJd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $00fbe474d37f07ad$export$2e2bcd8739ae039; });

var $5MUML = parcelRequire("5MUML");

var $dXLvS = parcelRequire("dXLvS");

var $lKQfu = parcelRequire("lKQfu");

var $fKxww = parcelRequire("fKxww");

var $ilqjt = parcelRequire("ilqjt");

var $dAx5m = parcelRequire("dAx5m");

var $ja4jS = parcelRequire("ja4jS");
var $6PkJI = parcelRequire("6PkJI");

var $ipBXS = parcelRequire("ipBXS");
function $00fbe474d37f07ad$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $00fbe474d37f07ad$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, (/*@__PURE__*/$parcel$interopDefault($ilqjt)))(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, (/*@__PURE__*/$parcel$interopDefault($ilqjt)))(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, (/*@__PURE__*/$parcel$interopDefault($fKxww)))(this, result);
    };
}
function $00fbe474d37f07ad$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($00fbe474d37f07ad$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $00fbe474d37f07ad$var$MessagesIntlProvider = /*#__PURE__*/ function(_React$Component) {
    (0, (/*@__PURE__*/$parcel$interopDefault($lKQfu)))(MessagesIntlProvider, _React$Component);
    var _super = $00fbe474d37f07ad$var$_createSuper(MessagesIntlProvider);
    function MessagesIntlProvider() {
        (0, (/*@__PURE__*/$parcel$interopDefault($5MUML)))(this, MessagesIntlProvider);
        return _super.apply(this, arguments);
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($dXLvS)))(MessagesIntlProvider, [
        {
            key: "render",
            value: function render() {
                var _this$props = this.props, intl = _this$props.intl, children = _this$props.children;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $6PkJI.default), {
                    messages: (0, $ipBXS.getMessagesForLocale)(intl.locale),
                    locale: intl.locale,
                    defaultLocale: "en-US"
                }, children);
            }
        }
    ]);
    return MessagesIntlProvider;
}((0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).Component);
var $00fbe474d37f07ad$export$2e2bcd8739ae039 = (0, $ja4jS.default)($00fbe474d37f07ad$var$MessagesIntlProvider);

});
parcelRegister("ipBXS", function(module, exports) {

$parcel$export(module.exports, "getMessagesForLocale", function () { return $d67802c72abc4e57$export$d0a3169680473b6c; });
parcelRequire("4ZNSi");
var $5MvQQ = parcelRequire("5MvQQ");
var $bKpJ8 = parcelRequire("bKpJ8");
var $1tmaR = parcelRequire("1tmaR");
var $al8Xx = parcelRequire("al8Xx");
var $kyaiT = parcelRequire("kyaiT");
var $8WpiL = parcelRequire("8WpiL");
var $bbOue = parcelRequire("bbOue");
var $h8EpX = parcelRequire("h8EpX");
var $4kzoy = parcelRequire("4kzoy");
var $8gxuB = parcelRequire("8gxuB");
var $2Mydj = parcelRequire("2Mydj");
var $29HcH = parcelRequire("29HcH");
var $1Ctbk = parcelRequire("1Ctbk");
var $hLCIS = parcelRequire("hLCIS");
var $hoYKf = parcelRequire("hoYKf");
var $bfxaI = parcelRequire("bfxaI");
var $dO366 = parcelRequire("dO366");
var $3miiB = parcelRequire("3miiB");
var $fxmzz = parcelRequire("fxmzz");
var $5rCkh = parcelRequire("5rCkh");
var $24Mv3 = parcelRequire("24Mv3");
var $bshoi = parcelRequire("bshoi");
var $ifNq0 = parcelRequire("ifNq0");
var $kIKcj = parcelRequire("kIKcj");
var $d67802c72abc4e57$var$localesMessagesMap = {
    cs: (0, $5MvQQ.default),
    da: (0, $bKpJ8.default),
    de: (0, $1tmaR.default),
    en: (0, $al8Xx.default),
    en_GB: (0, $kyaiT.default),
    es: (0, $8WpiL.default),
    et: (0, $bbOue.default),
    fi: (0, $h8EpX.default),
    fr: (0, $4kzoy.default),
    hu: (0, $8gxuB.default),
    is: (0, $2Mydj.default),
    it: (0, $29HcH.default),
    ja: (0, $1Ctbk.default),
    ko: (0, $hLCIS.default),
    nb: (0, $hoYKf.default),
    nl: (0, $bfxaI.default),
    pl: (0, $dO366.default),
    pt_BR: (0, $3miiB.default),
    "pt-BR": (0, $3miiB.default),
    // should resolve pt-BR and pt_BR
    pt_PT: (0, $fxmzz.default),
    "pt-PT": (0, $fxmzz.default),
    ro: (0, $5rCkh.default),
    ru: (0, $24Mv3.default),
    sk: (0, $bshoi.default),
    sv: (0, $ifNq0.default),
    zh: (0, $kIKcj.default)
};
var $d67802c72abc4e57$export$d0a3169680473b6c = function getMessagesForLocale(locale) {
    var messages = $d67802c72abc4e57$var$localesMessagesMap[locale];
    if (!messages) {
        var parentLocale = locale.split(/[-_]/)[0];
        messages = $d67802c72abc4e57$var$localesMessagesMap[parentLocale];
    }
    if (!messages) messages = (0, $al8Xx.default);
    return messages;
};

});
parcelRegister("4ZNSi", function(module, exports) {

$parcel$export(module.exports, "zh", function () { return (parcelRequire("kIKcj")).default; });
$parcel$export(module.exports, "cs", function () { return (parcelRequire("5MvQQ")).default; });
$parcel$export(module.exports, "da", function () { return (parcelRequire("bKpJ8")).default; });
$parcel$export(module.exports, "nl", function () { return (parcelRequire("bfxaI")).default; });
$parcel$export(module.exports, "et", function () { return (parcelRequire("bbOue")).default; });
$parcel$export(module.exports, "fi", function () { return (parcelRequire("h8EpX")).default; });
$parcel$export(module.exports, "fr", function () { return (parcelRequire("4kzoy")).default; });
$parcel$export(module.exports, "de", function () { return (parcelRequire("1tmaR")).default; });
$parcel$export(module.exports, "hu", function () { return (parcelRequire("8gxuB")).default; });
$parcel$export(module.exports, "it", function () { return (parcelRequire("29HcH")).default; });
$parcel$export(module.exports, "ja", function () { return (parcelRequire("1Ctbk")).default; });
$parcel$export(module.exports, "ko", function () { return (parcelRequire("hLCIS")).default; });
$parcel$export(module.exports, "nb", function () { return (parcelRequire("hoYKf")).default; });
$parcel$export(module.exports, "pl", function () { return (parcelRequire("dO366")).default; });
$parcel$export(module.exports, "pt_BR", function () { return (parcelRequire("3miiB")).default; });
$parcel$export(module.exports, "pt_PT", function () { return (parcelRequire("fxmzz")).default; });
$parcel$export(module.exports, "ru", function () { return (parcelRequire("24Mv3")).default; });
$parcel$export(module.exports, "sk", function () { return (parcelRequire("bshoi")).default; });
$parcel$export(module.exports, "es", function () { return (parcelRequire("8WpiL")).default; });
$parcel$export(module.exports, "sv", function () { return (parcelRequire("ifNq0")).default; });
$parcel$export(module.exports, "en", function () { return (parcelRequire("al8Xx")).default; });
$parcel$export(module.exports, "en_GB", function () { return (parcelRequire("kyaiT")).default; });
$parcel$export(module.exports, "is", function () { return (parcelRequire("2Mydj")).default; });
$parcel$export(module.exports, "ro", function () { return (parcelRequire("5rCkh")).default; });
/**
 * NOTE:
 *
 * This file is automatically generated by i18n-tools.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $kIKcj = parcelRequire("kIKcj");

var $fwL8w = parcelRequire("fwL8w");

var $5MvQQ = parcelRequire("5MvQQ");

var $bKpJ8 = parcelRequire("bKpJ8");

var $bfxaI = parcelRequire("bfxaI");

var $bbOue = parcelRequire("bbOue");

var $h8EpX = parcelRequire("h8EpX");

var $4kzoy = parcelRequire("4kzoy");

var $1tmaR = parcelRequire("1tmaR");

var $8gxuB = parcelRequire("8gxuB");

var $29HcH = parcelRequire("29HcH");

var $1Ctbk = parcelRequire("1Ctbk");

var $hLCIS = parcelRequire("hLCIS");

var $hoYKf = parcelRequire("hoYKf");

var $dO366 = parcelRequire("dO366");

var $3miiB = parcelRequire("3miiB");

var $fxmzz = parcelRequire("fxmzz");

var $24Mv3 = parcelRequire("24Mv3");

var $bshoi = parcelRequire("bshoi");

var $8WpiL = parcelRequire("8WpiL");

var $ifNq0 = parcelRequire("ifNq0");

var $giAee = parcelRequire("giAee");

var $pjI5g = parcelRequire("pjI5g");

var $fiFad = parcelRequire("fiFad");

var $bA1fB = parcelRequire("bA1fB");

var $al8Xx = parcelRequire("al8Xx");

var $kyaiT = parcelRequire("kyaiT");

var $2Mydj = parcelRequire("2Mydj");

var $5rCkh = parcelRequire("5rCkh");

});
parcelRegister("kIKcj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f15bc091b4f47f8b$export$2e2bcd8739ae039; });
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Chinese (Simplified)
var $f15bc091b4f47f8b$export$2e2bcd8739ae039 = {
    "focused-task-close-account.cancel": "\u53D6\u6D88",
    "focused-task-close-account.deactivate-account": "\u505C\u7528\u5E10\u6237",
    "focused-task-close-account.deactivate-account.overview.first.line.admin": "\u60A8\u5373\u5C06\u505C\u7528\u7684\u7528\u6237\u5E10\u6237\uFF1A",
    "focused-task-close-account.deactivate-account.overview.first.line.self": "\u60A8\u5373\u5C06\u505C\u7528\u7684\u7528\u6237\u5E10\u6237\uFF1A",
    "focused-task-close-account.deactivate-account.overview.heading.admin": "\u505C\u7528\u5E10\u6237",
    "focused-task-close-account.deactivate-account.overview.heading.self": "\u505C\u7528\u5E10\u6237",
    "focused-task-close-account.deactivate-account.overview.last.line.admin": "\u60A8\u53EF\u4EE5\u5728\u4EFB\u4F55\u65F6\u5019\u91CD\u65B0\u6FC0\u6D3B\u8BE5\u5E10\u6237\u3002",
    "focused-task-close-account.deactivate-account.overview.last.line.self": "\u60A8\u53EF\u4EE5\u5728\u4EFB\u4F55\u65F6\u5019\u91CD\u65B0\u6FC0\u6D3B\u8BE5\u5E10\u6237\u3002",
    "focused-task-close-account.deactivate-account.overview.paragraph.about-to-deactivate.admin": "\u5F53\u60A8\u505C\u7528\u5E10\u6237\uFF1A",
    "focused-task-close-account.deactivate-account.overview.paragraph.about-to-deactivate.self": "\u5F53\u60A8\u505C\u7528\u5E10\u6237\uFF1A",
    "focused-task-close-account.deactivate-account.overview.paragraph.billing.admin": "\u6211\u4EEC\u4E0D\u518D\u4E3A\u6B64\u5411\u60A8\u6536\u8D39\u3002",
    "focused-task-close-account.deactivate-account.overview.paragraph.billing.self": "\u6211\u4EEC\u4E0D\u518D\u4E3A\u6B64\u5411\u60A8\u6536\u8D39\u3002",
    "focused-task-close-account.deactivate-account.overview.paragraph.loseAccess.admin": "{fullName}\u5C06<b>\u7ACB\u5373\u5931\u53BB\u5BF9\u6240\u6709 Atlassian \u5E10\u6237\u670D\u52A1\u7684\u8BBF\u95EE\u6743\u9650</b>\u3002 \u4ED6\u4EEC\u76EE\u524D\u53EF\u4EE5\u8BBF\u95EE\uFF1A",
    "focused-task-close-account.deactivate-account.overview.paragraph.loseAccess.admin.noSites": "{fullName}\u5C06<b>\u7ACB\u5373\u5931\u53BB\u5BF9\u6240\u6709 Atlassian \u5E10\u6237\u670D\u52A1\u7684\u8BBF\u95EE\u6743\u9650</b>\u3002\u76EE\u524D\uFF0C\u9664\u793E\u533A\u548C\u5546\u57CE\u7B49\u670D\u52A1\u5916\uFF0C\u4ED6\u4EEC\u65E0\u6743\u8BBF\u95EE\u4EFB\u4F55\u670D\u52A1\u3002",
    "focused-task-close-account.deactivate-account.overview.paragraph.loseAccess.footnote": "\u5176\u4ED6 Atlassian \u5E10\u6237\u670D\u52A1\uFF0C\u5982 Atlassian \u793E\u533A\u548C\u5546\u57CE\u3002",
    "focused-task-close-account.deactivate-account.overview.paragraph.loseAccess.self": "\u60A8\u5C06<b>\u7ACB\u5373\u5931\u53BB\u5BF9\u6240\u6709 Atlassian \u5E10\u6237\u670D\u52A1\u7684\u8BBF\u95EE\u6743\u9650</b>\u3002 \u60A8\u76EE\u524D\u53EF\u4EE5\u8BBF\u95EE\uFF1A",
    "focused-task-close-account.deactivate-account.overview.paragraph.loseAccess.self.noSites": "\u60A8\u5C06<b>\u7ACB\u5373\u5931\u53BB\u5BF9\u6240\u6709 Atlassian \u5E10\u6237\u670D\u52A1\u7684\u8BBF\u95EE\u6743\u9650</b>\u3002\u76EE\u524D\uFF0C\u9664\u793E\u533A\u548C\u5546\u57CE\u7B49\u670D\u52A1\u5916\uFF0C\u60A8\u65E0\u6743\u8BBF\u95EE\u4EFB\u4F55\u670D\u52A1\u3002",
    "focused-task-close-account.deactivate-account.overview.paragraph.personal-data.admin": "\u4ED6\u4EEC\u7684\u4E2A\u4EBA\u6570\u636E\uFF0C\u5982\u5168\u540D\u3001\u7535\u5B50\u90AE\u4EF6\u5730\u5740\uFF0C\u4EE5\u53CA\u4ED6\u4EEC\u521B\u5EFA\u7684\u5185\u5BB9\uFF0C\u5C06\u4FDD\u7559\u5728Atlassian \u5E10\u6237\u670D\u52A1\u4E2D\u3002",
    "focused-task-close-account.deactivate-account.overview.paragraph.personal-data.self": "\u4ED6\u4EEC\u7684\u4E2A\u4EBA\u6570\u636E\uFF0C\u5982\u5168\u540D\u3001\u7535\u5B50\u90AE\u4EF6\u5730\u5740\uFF0C\u4EE5\u53CA\u4ED6\u4EEC\u521B\u5EFA\u7684\u5185\u5BB9\uFF0C\u5C06\u4FDD\u7559\u5728Atlassian \u5E10\u6237\u670D\u52A1\u4E2D\u3002",
    "focused-task-close-account.delete-account": "\u5220\u9664\u5E10\u6237",
    "focused-task-close-account.delete-account.content-preview.footnote.admin": "\u6CE8\u610F\uFF1A\u56DE\u7B54\u6B64\u8C03\u67E5\u95EE\u5377\u5C06\u5E2E\u52A9\u6211\u4EEC\u4E3A\u6240\u6709\u7528\u6237\u63D0\u4F9B\u66F4\u597D\u7684\u4F53\u9A8C\u3002\u5728\u60A8\u5220\u9664\u7528\u6237\u5E10\u6237\u540E\uFF0C\u7528\u6237\u4ECD\u5C06\u4F5C\u4E3A\u201C\u524D\u7528\u6237\u201D\u663E\u793A\u3002",
    "focused-task-close-account.delete-account.content-preview.footnote.self": "\u6CE8\u610F\uFF1A\u56DE\u7B54\u6B64\u8C03\u67E5\u95EE\u5377\u5C06\u5E2E\u52A9\u6211\u4EEC\u4E3A\u6240\u6709\u7528\u6237\u63D0\u4F9B\u66F4\u597D\u7684\u4F53\u9A8C\uFF0C\u5305\u62EC\u5DF2\u5220\u9664\u5176\u5E10\u6237\u7684\u7528\u6237\u3002\u5728\u60A8\u5220\u9664\u5E10\u6237\u540E\uFF0C\u60A8\u4ECD\u5C06\u4F5C\u4E3A\u201C\u524D\u7528\u6237\u201D\u663E\u793A\u3002",
    "focused-task-close-account.delete-account.content-preview.formerUser": "\u524D\u7528\u6237",
    "focused-task-close-account.delete-account.content-preview.heading.admin": "\u60A8\u5E0C\u671B\u5982\u4F55\u663E\u793A\u5DF2\u5220\u9664\u7684\u7528\u6237\uFF1F",
    "focused-task-close-account.delete-account.content-preview.heading.self": "\u60A8\u5E0C\u671B\u5982\u4F55\u663E\u793A\u60A8\u5DF2\u5220\u9664\u7684\u5E10\u6237\uFF1F",
    "focused-task-close-account.delete-account.content-preview.line.survey.admin": "\u5982\u679C\u6211\u4EEC\u8BA9\u60A8\u9009\u62E9\uFF0C\u60A8\u5E0C\u671B\u5DF2\u5220\u9664\u7684\u7528\u6237\u5982\u4F55\u5411\u5176\u4ED6\u7528\u6237\u663E\u793A\uFF1F",
    "focused-task-close-account.delete-account.content-preview.line.survey.self": "\u5982\u679C\u6211\u4EEC\u8BA9\u60A8\u9009\u62E9\uFF0C\u60A8\u5E0C\u671B\u5982\u4F55\u5411\u5176\u4ED6\u7528\u6237\u663E\u793A\uFF1F",
    "focused-task-close-account.delete-account.content-preview.paragraph.survey.admin": "\u7528\u6237\u5E10\u6237\u5220\u9664\u540E\uFF0C\u4ED6\u4EEC\u5411\u5176\u4ED6\u7528\u6237\u663E\u793A\u4E3A\u201C\u524D\u7528\u6237\u201D\u3002\u8BF7\u601D\u8003\u4E00\u4E0B\uFF0C\u7136\u540E\u56DE\u7B54\u6211\u4EEC\u7684\u95EE\u5377\u95EE\u9898\u3002",
    "focused-task-close-account.delete-account.content-preview.paragraph.survey.self": "\u7528\u6237\u5E10\u6237\u5220\u9664\u540E\uFF0C\u60A8\u4F1A\u5411\u5176\u4ED6\u7528\u6237\u663E\u793A\u4E3A\u201C\u524D\u7528\u6237\u201D\u3002\u8BF7\u601D\u8003\u4E00\u4E0B\uFF0C\u7136\u540E\u56DE\u7B54\u6211\u4EEC\u7684\u95EE\u5377\u95EE\u9898\u3002",
    "focused-task-close-account.delete-account.drop-down-collapse-button": "\u663E\u793A\u66F4\u5C11",
    "focused-task-close-account.delete-account.drop-down-expand-button": "{num}\u66F4\u591A",
    "focused-task-close-account.delete-account.overview.first.line.admin": "\u60A8\u5373\u5C06\u5220\u9664\u4EE5\u4E0B\u5E10\u6237\uFF1A",
    "focused-task-close-account.delete-account.overview.first.line.self": "\u60A8\u5373\u5C06\u5220\u9664\u60A8\u7684\u5E10\u6237\uFF1A",
    "focused-task-close-account.delete-account.overview.heading.admin": "\u5220\u9664\u5E10\u6237",
    "focused-task-close-account.delete-account.overview.heading.self": "\u5220\u9664\u60A8\u7684\u5E10\u6237",
    "focused-task-close-account.delete-account.overview.inline-dialog.content-created.admin": "\u4F8B\u5982\uFF0C\u4ED6\u4EEC\u5728\u4EA7\u54C1\u4E2D\u521B\u5EFA\u7684\u9875\u9762\u3001\u4E8B\u52A1\u548C\u8BC4\u8BBA\u3002",
    "focused-task-close-account.delete-account.overview.inline-dialog.content-created.self": "\u4F8B\u5982\uFF0C\u60A8\u5728\u4EA7\u54C1\u4E2D\u521B\u5EFA\u7684\u9875\u9762\u3001\u4E8B\u52A1\u548C\u8BC4\u8BBA\u3002",
    "focused-task-close-account.delete-account.overview.inline-dialog.data-apps.admin": "\u60A8\u6216\u5176\u4ED6\u7528\u6237\u53EF\u80FD\u5DF2\u7ECF\u5B89\u88C5\u4E86\u5411 Atlassian \u4EA7\u54C1\u6DFB\u52A0\u529F\u80FD\u7684\u5E94\u7528\u7A0B\u5E8F\u3002\u8FD9\u4E9B\u5E94\u7528\u7A0B\u5E8F\u53EF\u80FD\u5B58\u50A8\u4E86\u7528\u6237\u7684\u4E2A\u4EBA\u4FE1\u606F\u3002",
    "focused-task-close-account.delete-account.overview.inline-dialog.data-apps.self": "\u60A8\u6216\u5176\u4ED6\u7528\u6237\u53EF\u80FD\u5DF2\u7ECF\u5B89\u88C5\u4E86\u5411 Atlassian \u4EA7\u54C1\u6DFB\u52A0\u529F\u80FD\u7684\u5E94\u7528\u7A0B\u5E8F\u3002\u8FD9\u4E9B\u5E94\u7528\u7A0B\u5E8F\u53EF\u80FD\u5B58\u50A8\u4E86\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\u3002",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.li1.admin": "\u6211\u4EEC\u9700\u8981\u4E3A\u8D22\u52A1\u62A5\u544A\u4FDD\u7559\u4E0E\u8D2D\u4E70\u76F8\u5173\u7684\u4FE1\u606F\u3002",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.li1.self": "\u6211\u4EEC\u9700\u8981\u4E3A\u8D22\u52A1\u62A5\u544A\u4FDD\u7559\u4E0E\u8D2D\u4E70\u76F8\u5173\u7684\u4FE1\u606F\u3002",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.li2.admin": "\u8BB0\u5F55\u663E\u793A\u6211\u4EEC\u5220\u9664\u4E86\u67D0\u4EBA\u7684\u5E10\u6237\uFF0C\u6211\u4EEC\u53EF\u80FD\u9700\u8981\u5411\u76D1\u7BA1\u673A\u6784\u63D0\u4F9B\u6B64\u5E10\u6237\u4FE1\u606F\u3002",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.li2.self": "\u8BB0\u5F55\u663E\u793A\u6211\u4EEC\u5220\u9664\u4E86\u67D0\u4EBA\u7684\u5E10\u6237\uFF0C\u6211\u4EEC\u53EF\u80FD\u9700\u8981\u5411\u76D1\u7BA1\u673A\u6784\u63D0\u4F9B\u6B64\u5E10\u6237\u4FE1\u606F\u3002",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.li3.admin": "\u6211\u4EEC\u9700\u8981\u4F9D\u6CD5\u4FDD\u7559\u4F5C\u4E3A\u6709\u6548\u8BC9\u8BBC\u7684\u4E00\u90E8\u5206\u7684\u6570\u636E\u3002",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.li3.self": "\u6211\u4EEC\u9700\u8981\u4F9D\u6CD5\u4FDD\u7559\u4F5C\u4E3A\u6709\u6548\u8BC9\u8BBC\u7684\u4E00\u90E8\u5206\u7684\u6570\u636E\u3002",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.p1.admin": "\u5F53\u6211\u4EEC\u51FA\u4E8E\u5408\u6CD5\u7684\u4E1A\u52A1\u6216\u6CD5\u5F8B\u76EE\u7684\u65F6\uFF0C\u6211\u4EEC\u4F1A\u5728\u4E00\u5B9A\u7684\u65F6\u95F4\u5185\u4FDD\u7559\u4E2A\u4EBA\u6570\u636E\u3002\u4E00\u4E9B\u4F8B\u5B50\u5305\u62EC\uFF1A",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.p1.self": "\u5F53\u6211\u4EEC\u51FA\u4E8E\u5408\u6CD5\u7684\u4E1A\u52A1\u6216\u6CD5\u5F8B\u76EE\u7684\u65F6\uFF0C\u6211\u4EEC\u4F1A\u5728\u4E00\u5B9A\u7684\u65F6\u95F4\u5185\u4FDD\u7559\u4E2A\u4EBA\u6570\u636E\u3002\u4E00\u4E9B\u4F8B\u5B50\u5305\u62EC\uFF1A",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.p2.admin": "\u6211\u4EEC\u4E0D\u4F1A\u4ECE\u7528\u6237\u521B\u5EFA\u7684\u5185\u5BB9\u4E2D\u5220\u9664\u4EFB\u4F55\u4E2A\u4EBA\u6570\u636E\uFF0C\u4F8B\u5982\u4ED6\u4EEC\u5728\u9875\u9762\u6216\u4E8B\u52A1\u4E2D\u952E\u5165\u7684\u59D3\u540D\u6216\u7535\u5B50\u90AE\u4EF6\u5730\u5740\u3002\u4EA7\u54C1\u7BA1\u7406\u5458\u9700\u8981\u624B\u52A8\u5220\u9664\u8BE5\u6570\u636E\u3002",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.p2.self": "\u6211\u4EEC\u4E0D\u4F1A\u4ECE\u60A8\u6216\u5176\u4ED6\u4EBA\u521B\u5EFA\u7684\u5185\u5BB9\u4E2D\u5220\u9664\u4EFB\u4F55\u4E2A\u4EBA\u6570\u636E\uFF0C\u4F8B\u5982\u5728\u9875\u9762\u6216\u4E8B\u52A1\u4E2D\u952E\u5165\u7684\u59D3\u540D\u6216\u7535\u5B50\u90AE\u4EF6\u5730\u5740\u3002\u60A8\u7684\u4EA7\u54C1\u7BA1\u7406\u5458\u9700\u8981\u624B\u52A8\u5220\u9664\u8BE5\u6570\u636E\u3002",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.p3.admin": "\u7528\u6237\u6709\u6743\u5411\u5176\u6240\u5728\u56FD\u5BB6/\u5730\u533A\u7684\u76D1\u7BA1\u5F53\u5C40\u63D0\u51FA\u6295\u8BC9\u3002",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.p3.self": "\u60A8\u6709\u6743\u5411\u60A8\u6240\u5728\u7684\u56FD\u5BB6/\u5730\u533A\u7684\u76D1\u7BA1\u5F53\u5C40\u63D0\u51FA\u7533\u8BC9\u3002",
    "focused-task-close-account.delete-account.overview.paragraph.about-to-delete.admin": "\u5F53\u60A8\u5220\u9664\u5E10\u6237\u65F6\uFF1A",
    "focused-task-close-account.delete-account.overview.paragraph.about-to-delete.self": "\u5F53\u60A8\u5220\u9664\u5E10\u6237\u65F6\uFF1A",
    "focused-task-close-account.delete-account.overview.paragraph.content-created.admin": "\u4ED6\u4EEC\u521B\u5EFA\u7684\u5185\u5BB9\u5C06\u4FDD\u7559\u5728 Atlassian \u5E10\u6237\u670D\u52A1\u4E2D\u3002",
    "focused-task-close-account.delete-account.overview.paragraph.content-created.self": "\u60A8\u521B\u5EFA\u7684\u5185\u5BB9\u5C06\u4FDD\u7559\u5728 Atlassian \u5E10\u6237\u670D\u52A1\u4E2D\u3002",
    "focused-task-close-account.delete-account.overview.paragraph.grace-period.admin": "\u5728 14 \u5929\u7684\u5BBD\u9650\u671F\u540E\uFF0C\u60A8\u5C06\u65E0\u6CD5\u53D6\u6D88\u5220\u9664\u5E10\u6237\u3002",
    "focused-task-close-account.delete-account.overview.paragraph.list-of-apps-with-personal-data.admin": "\u6211\u4EEC\u5C06\u901A\u8FC7\u7535\u5B50\u90AE\u4EF6\u5411\u60A8\u53D1\u9001\u53EF\u80FD\u5B58\u50A8\u5176\u4E2A\u4EBA\u6570\u636E\u7684\u5E94\u7528\u7A0B\u5E8F\u5217\u8868\u3002",
    "focused-task-close-account.delete-account.overview.paragraph.list-of-apps-with-personal-data.self": "\u6211\u4EEC\u5C06\u901A\u8FC7\u7535\u5B50\u90AE\u4EF6\u5411\u60A8\u53D1\u9001\u53EF\u80FD\u5B58\u50A8\u60A8\u4E2A\u4EBA\u6570\u636E\u7684\u5E94\u7528\u7A0B\u5E8F\u5217\u8868\u3002",
    "focused-task-close-account.delete-account.overview.paragraph.loseAccess.admin": "{fullName}\u5C06<b>\u7ACB\u5373\u5931\u53BB\u5BF9\u6240\u6709 Atlassian \u5E10\u6237\u670D\u52A1\u7684\u8BBF\u95EE\u6743\u9650</b>\u3002 \u4ED6\u4EEC\u76EE\u524D\u53EF\u4EE5\u8BBF\u95EE\uFF1A",
    "focused-task-close-account.delete-account.overview.paragraph.loseAccess.admin.noSites": "{fullName}\u5C06<b>\u7ACB\u5373\u5931\u53BB\u5BF9\u6240\u6709 Atlassian \u5E10\u6237\u670D\u52A1\u7684\u8BBF\u95EE\u6743\u9650</b>\u3002\u76EE\u524D\uFF0C\u9664\u793E\u533A\u548C\u5546\u57CE\u7B49\u670D\u52A1\u5916\uFF0C\u4ED6\u4EEC\u65E0\u6743\u8BBF\u95EE\u4EFB\u4F55\u670D\u52A1\u3002",
    "focused-task-close-account.delete-account.overview.paragraph.loseAccess.footnote": "\u5176\u4ED6 Atlassian \u5E10\u6237\u670D\u52A1\uFF0C\u5982 Atlassian \u793E\u533A\u548C\u5546\u57CE\u3002",
    "focused-task-close-account.delete-account.overview.paragraph.loseAccess.self": "\u60A8\u5C06<b>\u7ACB\u5373\u5931\u53BB\u5BF9\u6240\u6709 Atlassian \u5E10\u6237\u670D\u52A1\u7684\u8BBF\u95EE\u6743\u9650</b>\u3002 \u60A8\u76EE\u524D\u53EF\u4EE5\u8BBF\u95EE\uFF1A",
    "focused-task-close-account.delete-account.overview.paragraph.loseAccess.self.noSites": "\u60A8\u5C06<b>\u7ACB\u5373\u5931\u53BB\u5BF9\u6240\u6709 Atlassian \u5E10\u6237\u670D\u52A1\u7684\u8BBF\u95EE\u6743\u9650</b>\u3002\u76EE\u524D\uFF0C\u9664\u793E\u533A\u548C\u5546\u57CE\u7B49\u670D\u52A1\u5916\uFF0C\u60A8\u65E0\u6743\u8BBF\u95EE\u4EFB\u4F55\u670D\u52A1\u3002",
    "focused-task-close-account.delete-account.overview.paragraph.personal-data-will-be-deleted.admin": "\u6211\u4EEC\u5C06\u5728 30 \u5929\u5185\u4ECE Atlassian \u5E10\u6237\u670D\u52A1\u4E2D<b>\u5220\u9664\u4ED6\u4EEC\u7684\u4E2A\u4EBA\u6570\u636E</b>\uFF0C\u5982\u5168\u540D\u548C\u7535\u5B50\u90AE\u4EF6\u5730\u5740\uFF0C\u4F46\u51FA\u4E8E\u5408\u6CD5\u4E1A\u52A1\u6216\u6CD5\u5F8B\u76EE\u7684\u7684\u5C11\u6570\u60C5\u51B5\u9664\u5916\u3002",
    "focused-task-close-account.delete-account.overview.paragraph.personal-data-will-be-deleted.self": "\u6211\u4EEC\u5C06\u5728 30 \u5929\u5185\u4ECE Atlassian \u5E10\u6237\u670D\u52A1\u4E2D<b>\u5220\u9664\u60A8\u7684\u4E2A\u4EBA\u6570\u636E</b>\uFF0C\u5982\u60A8\u7684\u5168\u540D\u548C\u7535\u5B50\u90AE\u4EF6\u5730\u5740\uFF0C\u4F46\u51FA\u4E8E\u5408\u6CD5\u4E1A\u52A1\u6216\u6CD5\u5F8B\u76EE\u7684\u7684\u5C11\u6570\u60C5\u51B5\u9664\u5916\u3002",
    "focused-task-close-account.delete-account.overview.warning-section.body": "\u5728 14\u5929 \u7684\u5BBD\u9650\u671F\u540E\uFF0C\u60A8\u5C06\u65E0\u6CD5\u53D6\u6D88\u5BF9\u5E10\u6237\u7684\u5220\u9664\u3002\u5982\u679C\u60A8\u8BA4\u4E3A\u4EE5\u540E\u9700\u8981\u8BE5\u5E10\u6237\uFF0C\u8BF7\u5C06\u5176\u505C\u7528\u3002",
    "focused-task-close-account.delete-account.overview.warning-section.deactivated.body": "\u572814\u5929\u7684\u5BBD\u9650\u671F\u540E\uFF0C\u60A8\u5C06\u65E0\u6CD5\u53D6\u6D88\u5220\u9664\u5E10\u6237\u3002",
    "focused-task-close-account.learnMore": "\u4E86\u89E3\u66F4\u591A",
    "focused-task-close-account.next": "\u4E0B\u4E00\u6B65",
    "focused-task-close-account.previous": "\u4E0A\u4E00\u6B65"
};

});

parcelRegister("fwL8w", function(module, exports) {
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Chinese (Traditional)
var $b4de687d2c1bc01d$export$2e2bcd8739ae039 = {
    "focused-task-close-account.cancel": "\u53D6\u6D88",
    "focused-task-close-account.deactivate-account": "\u505C\u7528\u5E33\u6236",
    "focused-task-close-account.deactivate-account.overview.first.line.admin": "\u60A8\u5373\u5C07\u505C\u7528\u4EE5\u4E0B\u7684\u4F7F\u7528\u8005\u5E33\u6236\uFF1A",
    "focused-task-close-account.deactivate-account.overview.first.line.self": "\u60A8\u5373\u5C07\u505C\u7528\u4EE5\u4E0B\u7684\u4F7F\u7528\u8005\u5E33\u6236\uFF1A",
    "focused-task-close-account.deactivate-account.overview.heading.admin": "\u505C\u7528\u5E33\u6236",
    "focused-task-close-account.deactivate-account.overview.heading.self": "\u505C\u7528\u5E33\u6236",
    "focused-task-close-account.deactivate-account.overview.last.line.admin": "\u60A8\u53EF\u4EE5\u96A8\u6642\u91CD\u65B0\u555F\u7528\u6B64\u5E33\u6236\u3002",
    "focused-task-close-account.deactivate-account.overview.last.line.self": "\u60A8\u53EF\u4EE5\u96A8\u6642\u91CD\u65B0\u555F\u7528\u6B64\u5E33\u6236\u3002",
    "focused-task-close-account.deactivate-account.overview.paragraph.about-to-deactivate.admin": "\u7576\u60A8\u505C\u7528\u6B64\u5E33\u6236\u6642\uFF1A",
    "focused-task-close-account.deactivate-account.overview.paragraph.about-to-deactivate.self": "\u7576\u60A8\u505C\u7528\u6B64\u5E33\u6236\u6642\uFF1A",
    "focused-task-close-account.deactivate-account.overview.paragraph.billing.admin": "\u6211\u5011\u4E0D\u6703\u518D\u5411\u60A8\u6536\u53D6\u5176\u8CBB\u7528\u3002",
    "focused-task-close-account.deactivate-account.overview.paragraph.billing.self": "\u6211\u5011\u4E0D\u6703\u518D\u5411\u60A8\u6536\u53D6\u5176\u8CBB\u7528\u3002",
    "focused-task-close-account.deactivate-account.overview.paragraph.loseAccess.admin": "{fullName} \u6703<b>\u7ACB\u5373\u5931\u53BB</b>\u6240\u6709 Atlassian \u5E33\u6236\u670D\u52D9\u7684\u5B58\u53D6\u6B0A\u3002\u4ED6\u5011\u76EE\u524D\u53EF\u5B58\u53D6\u4EE5\u4E0B\u9805\u76EE\uFF1A",
    "focused-task-close-account.deactivate-account.overview.paragraph.loseAccess.admin.noSites": "{fullName} \u6703<b>\u7ACB\u5373\u5931\u53BB</b>\u6240\u6709 Atlassian \u5E33\u6236\u670D\u52D9\u7684\u5B58\u53D6\u6B0A\u3002\u4ED6\u5011\u76EE\u524D\u7121\u6CD5\u5B58\u53D6\u4EFB\u4F55\u9805\u76EE\uFF0C\u793E\u7FA4\u548C\u5E02\u96C6\u4E4B\u985E\u7684\u670D\u52D9\u9664\u5916\u3002",
    "focused-task-close-account.deactivate-account.overview.paragraph.loseAccess.footnote": "\u5176\u4ED6 Atlassian \u5E33\u6236\u670D\u52D9\uFF0C\u4F8B\u5982 Atlassian Community \u548C Marketplace\u3002",
    "focused-task-close-account.deactivate-account.overview.paragraph.loseAccess.self": "\u60A8\u6703<b>\u7ACB\u5373\u5931\u53BB</b>\u6240\u6709 Atlassian \u5E33\u6236\u670D\u52D9\u7684\u5B58\u53D6\u6B0A\u3002\u60A8\u76EE\u524D\u53EF\u5B58\u53D6\u4EE5\u4E0B\u9805\u76EE\uFF1A",
    "focused-task-close-account.deactivate-account.overview.paragraph.loseAccess.self.noSites": "\u60A8\u6703<b>\u7ACB\u5373\u5931\u53BB</b>\u6240\u6709 Atlassian \u5E33\u6236\u670D\u52D9\u7684\u5B58\u53D6\u6B0A\u3002\u60A8\u76EE\u524D\u7121\u6CD5\u5B58\u53D6\u4EFB\u4F55\u9805\u76EE\uFF0C\u793E\u7FA4\u548C\u5E02\u96C6\u4E4B\u985E\u7684\u670D\u52D9\u9664\u5916\u3002",
    "focused-task-close-account.deactivate-account.overview.paragraph.personal-data.admin": "\u5176\u500B\u4EBA\u8CC7\u6599 (\u4F8B\u5982\u5176\u5168\u540D\u548C\u96FB\u5B50\u90F5\u4EF6\u5730\u5740)\uFF0C\u4EE5\u53CA\u5176\u5EFA\u7ACB\u7684\u5167\u5BB9\u5C07\u4FDD\u7559\u5728 Atlassian \u5E33\u6236\u670D\u52D9\u4E2D\u3002",
    "focused-task-close-account.deactivate-account.overview.paragraph.personal-data.self": "\u5176\u500B\u4EBA\u8CC7\u6599 (\u4F8B\u5982\u5176\u5168\u540D\u548C\u96FB\u5B50\u90F5\u4EF6\u5730\u5740)\uFF0C\u4EE5\u53CA\u5176\u5EFA\u7ACB\u7684\u5167\u5BB9\u5C07\u4FDD\u7559\u5728 Atlassian \u5E33\u6236\u670D\u52D9\u4E2D\u3002",
    "focused-task-close-account.delete-account": "\u522A\u9664\u5E33\u6236",
    "focused-task-close-account.delete-account.content-preview.footnote.admin": "\u8ACB\u7559\u610F\uFF1A\u56DE\u7B54\u6B64\u8ABF\u67E5\uFF0C\u53EF\u5354\u52A9\u6211\u5011\u70BA\u6240\u6709\u4F7F\u7528\u8005\u63D0\u4F9B\u66F4\u5B8C\u5584\u7684\u9AD4\u9A57\u3002\u5728\u60A8\u522A\u9664\u5E33\u6236\u5F8C\uFF0C\u9019\u4E9B\u4F7F\u7528\u8005\u4ECD\u6703\u986F\u793A\u70BA\u300C\u820A\u4F7F\u7528\u8005\u300D\u3002",
    "focused-task-close-account.delete-account.content-preview.footnote.self": "\u8ACB\u7559\u610F\uFF1A\u56DE\u7B54\u6B64\u8ABF\u67E5\uFF0C\u53EF\u5354\u52A9\u6211\u5011\u70BA\u6240\u6709\u4F7F\u7528\u8005 (\u5305\u542B\u522A\u9664\u5E33\u6236\u7684\u4F7F\u7528\u8005) \u63D0\u4F9B\u66F4\u5B8C\u5584\u7684\u9AD4\u9A57\u3002\u5728\u522A\u9664\u5E33\u6236\u5F8C\uFF0C\u60A8\u4ECD\u6703\u986F\u793A\u70BA\u300C\u820A\u4F7F\u7528\u8005\u300D\u3002",
    "focused-task-close-account.delete-account.content-preview.formerUser": "\u820A\u4F7F\u7528\u8005",
    "focused-task-close-account.delete-account.content-preview.heading.admin": "\u60A8\u5E0C\u671B\u4EE5\u4F55\u7A2E\u65B9\u5F0F\u986F\u793A\u5DF2\u522A\u9664\u7684\u4F7F\u7528\u8005\uFF1F",
    "focused-task-close-account.delete-account.content-preview.heading.self": "\u60A8\u5E0C\u671B\u4EE5\u4F55\u7A2E\u65B9\u5F0F\u986F\u793A\u5DF2\u522A\u9664\u7684\u5E33\u6236\uFF1F",
    "focused-task-close-account.delete-account.content-preview.line.survey.admin": "\u5982\u679C\u80FD\u5920\u9078\u64C7\uFF0C\u60A8\u5E0C\u671B\u4EE5\u4F55\u7A2E\u65B9\u5F0F\u5C0D\u5176\u4ED6\u4F7F\u7528\u8005\u986F\u793A\u5DF2\u522A\u9664\u7684\u4F7F\u7528\u8005\uFF1F",
    "focused-task-close-account.delete-account.content-preview.line.survey.self": "\u5982\u679C\u80FD\u5920\u9078\u64C7\uFF0C\u60A8\u5E0C\u671B\u4EE5\u4F55\u7A2E\u65B9\u5F0F\u5C0D\u5176\u4ED6\u4F7F\u7528\u8005\u986F\u793A\u60A8\uFF1F",
    "focused-task-close-account.delete-account.content-preview.paragraph.survey.admin": "\u5728\u4F7F\u7528\u8005\u5E33\u6236\u906D\u522A\u9664\u5F8C\uFF0C\u5176\u4ED6\u4F7F\u7528\u8005\u6703\u770B\u5230\u9019\u4E9B\u4F7F\u7528\u8005\u986F\u793A\u70BA\u300C\u820A\u4F7F\u7528\u8005\u300D\u3002\u8ACB\u82B1\u5E7E\u5206\u9418\u4F86\u56DE\u7B54\u6211\u5011\u7684\u8ABF\u67E5\u554F\u984C\u3002",
    "focused-task-close-account.delete-account.content-preview.paragraph.survey.self": "\u5728\u60A8\u7684\u5E33\u6236\u906D\u522A\u9664\u5F8C\uFF0C\u5176\u4ED6\u4F7F\u7528\u8005\u6703\u770B\u5230\u60A8\u986F\u793A\u70BA\u300C\u820A\u4F7F\u7528\u8005\u300D\u3002\u8ACB\u82B1\u5E7E\u5206\u9418\u4F86\u56DE\u7B54\u6211\u5011\u7684\u8ABF\u67E5\u554F\u984C\u3002",
    "focused-task-close-account.delete-account.drop-down-collapse-button": "\u986F\u793A\u8F03\u5C11",
    "focused-task-close-account.delete-account.drop-down-expand-button": "\u9084\u6709 {num} \u500B",
    "focused-task-close-account.delete-account.overview.first.line.admin": "\u60A8\u5373\u5C07\u522A\u9664\u4EE5\u4E0B\u5E33\u6236\uFF1A",
    "focused-task-close-account.delete-account.overview.first.line.self": "\u60A8\u5373\u5C07\u522A\u9664\u60A8\u7684\u5E33\u6236\uFF1A",
    "focused-task-close-account.delete-account.overview.heading.admin": "\u522A\u9664\u5E33\u6236",
    "focused-task-close-account.delete-account.overview.heading.self": "\u522A\u9664\u5E33\u6236",
    "focused-task-close-account.delete-account.overview.inline-dialog.content-created.admin": "\u4F8B\u5982\uFF0C\u4F7F\u7528\u8005\u5728\u7522\u54C1\u4E2D\u5EFA\u7ACB\u7684\u9801\u9762\u3001\u554F\u984C\u548C\u7559\u8A00\u3002",
    "focused-task-close-account.delete-account.overview.inline-dialog.content-created.self": "\u4F8B\u5982\uFF0C\u60A8\u5728\u7522\u54C1\u4E2D\u5EFA\u7ACB\u7684\u9801\u9762\u3001\u554F\u984C\u548C\u7559\u8A00\u3002",
    "focused-task-close-account.delete-account.overview.inline-dialog.data-apps.admin": "\u60A8\u6216\u5176\u4ED6\u4F7F\u7528\u8005\u53EF\u80FD\u5DF2\u5B89\u88DD\u61C9\u7528\u7A0B\u5F0F\uFF0C\u9019\u4E9B\u61C9\u7528\u7A0B\u5F0F\u6703\u5728 Atlassian \u7522\u54C1\u4E2D\u65B0\u589E\u529F\u80FD\u3002\u9019\u4E9B\u61C9\u7528\u7A0B\u5F0F\u53EF\u80FD\u5DF2\u5132\u5B58\u4F7F\u7528\u8005\u7684\u8A2D\u5B9A\u6A94\u8CC7\u8A0A\u3002",
    "focused-task-close-account.delete-account.overview.inline-dialog.data-apps.self": "\u60A8\u6216\u5176\u4ED6\u4F7F\u7528\u8005\u53EF\u80FD\u5DF2\u5B89\u88DD\u61C9\u7528\u7A0B\u5F0F\uFF0C\u9019\u4E9B\u61C9\u7528\u7A0B\u5F0F\u6703\u5728 Atlassian \u7522\u54C1\u4E2D\u65B0\u589E\u529F\u80FD\u3002\u9019\u4E9B\u61C9\u7528\u7A0B\u5F0F\u53EF\u80FD\u5DF2\u5132\u5B58\u60A8\u7684\u8A2D\u5B9A\u6A94\u8CC7\u8A0A\u3002",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.li1.admin": "\u6211\u5011\u9700\u8981\u4FDD\u7559\u8207\u8CFC\u8CB7\u76F8\u95DC\u7684\u8CC7\u8A0A\u4EE5\u88FD\u4F5C\u8CA1\u52D9\u5831\u544A\u3002",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.li1.self": "\u6211\u5011\u9700\u8981\u4FDD\u7559\u8207\u8CFC\u8CB7\u76F8\u95DC\u7684\u8CC7\u8A0A\u4EE5\u88FD\u4F5C\u8CA1\u52D9\u5831\u544A\u3002",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.li2.admin": "\u6211\u5011\u53EF\u80FD\u9700\u8981\u5411\u76E3\u7BA1\u6A5F\u69CB\u63D0\u4F9B\u986F\u793A\u6211\u5011\u5DF2\u522A\u9664\u67D0\u4EBA\u5E33\u6236\u7684\u8A18\u9304\u3002",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.li2.self": "\u6211\u5011\u53EF\u80FD\u9700\u8981\u5411\u76E3\u7BA1\u6A5F\u69CB\u63D0\u4F9B\u986F\u793A\u6211\u5011\u5DF2\u522A\u9664\u67D0\u4EBA\u5E33\u6236\u7684\u8A18\u9304\u3002",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.li3.admin": "\u6211\u5011\u9700\u8981\u4F9D\u6CD5\u4FDD\u7559\u6B63\u5728\u9032\u884C\u8A34\u8A1F\u7684\u8CC7\u6599\u3002",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.li3.self": "\u6211\u5011\u9700\u8981\u4F9D\u6CD5\u4FDD\u7559\u6B63\u5728\u9032\u884C\u8A34\u8A1F\u7684\u8CC7\u6599\u3002",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.p1.admin": "\u6211\u5011\u6703\u5C07\u500B\u4EBA\u8CC7\u6599\u4FDD\u7559\u4E00\u6BB5\u6642\u9593\uFF0C\u4EE5\u4F9B\u5408\u6CD5\u696D\u52D9\u6216\u6CD5\u5F8B\u76EE\u7684\u4F7F\u7528\u3002\u4E00\u4E9B\u7BC4\u4F8B\u5305\u542B\uFF1A",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.p1.self": "\u6211\u5011\u6703\u5C07\u500B\u4EBA\u8CC7\u6599\u4FDD\u7559\u4E00\u6BB5\u6642\u9593\uFF0C\u4EE5\u4F9B\u5408\u6CD5\u696D\u52D9\u6216\u6CD5\u5F8B\u76EE\u7684\u4F7F\u7528\u3002\u4E00\u4E9B\u7BC4\u4F8B\u5305\u542B\uFF1A",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.p2.admin": "\u6211\u5011\u4E0D\u6703\u5F9E\u4F7F\u7528\u8005\u5EFA\u7ACB\u7684\u5167\u5BB9\u4E2D\u522A\u9664\u4EFB\u4F55\u500B\u4EBA\u8CC7\u6599\uFF0C\u4F8B\u5982\u4ED6\u5011\u5728\u9801\u9762\u6216\u554F\u984C\u4E2D\u8F38\u5165\u7684\u540D\u7A31\u6216\u96FB\u5B50\u90F5\u4EF6\u5730\u5740\u3002\u7522\u54C1\u7BA1\u7406\u54E1\u9700\u8981\u624B\u52D5\u522A\u9664\u8A72\u8CC7\u6599\u3002",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.p2.self": "\u6211\u5011\u4E0D\u6703\u5F9E\u60A8\u6216\u5176\u4ED6\u4F7F\u7528\u8005\u5EFA\u7ACB\u7684\u5167\u5BB9\u4E2D\u522A\u9664\u4EFB\u4F55\u500B\u4EBA\u8CC7\u6599\uFF0C\u4F8B\u5982\u5728\u9801\u9762\u6216\u554F\u984C\u4E2D\u8F38\u5165\u7684\u540D\u7A31\u6216\u96FB\u5B50\u90F5\u4EF6\u5730\u5740\u3002\u7522\u54C1\u7BA1\u7406\u54E1\u9700\u8981\u624B\u52D5\u522A\u9664\u8A72\u8CC7\u6599\u3002",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.p3.admin": "\u4F7F\u7528\u8005\u6709\u6B0A\u5411\u5176\u570B\u5BB6/\u5730\u5340\u7684\u76E3\u5BDF\u6A5F\u95DC\u63D0\u8ACB\u6295\u8A34\u3002",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.p3.self": "\u60A8\u6709\u6B0A\u5411\u60A8\u6240\u5728\u570B\u5BB6/\u5730\u5340\u7684\u76E3\u5BDF\u6A5F\u95DC\u63D0\u8ACB\u6295\u8A34\u3002",
    "focused-task-close-account.delete-account.overview.paragraph.about-to-delete.admin": "\u522A\u9664\u5E33\u6236\u6642\uFF1A",
    "focused-task-close-account.delete-account.overview.paragraph.about-to-delete.self": "\u522A\u9664\u5E33\u6236\u6642\uFF1A",
    "focused-task-close-account.delete-account.overview.paragraph.content-created.admin": "\u4ED6\u5011\u5EFA\u7ACB\u7684\u5167\u5BB9\u6703\u4FDD\u7559\u5728 Atlassian \u5E33\u6236\u670D\u52D9\u4E2D\u3002",
    "focused-task-close-account.delete-account.overview.paragraph.content-created.self": "\u60A8\u5EFA\u7ACB\u7684\u5167\u5BB9\u6703\u4FDD\u7559\u5728 Atlassian \u5E33\u6236\u670D\u52D9\u4E2D\u3002",
    "focused-task-close-account.delete-account.overview.paragraph.grace-period.admin": "\u5728 14 \u5929\u5BEC\u9650\u671F\u5F8C\uFF0C\u60A8\u5C31\u7121\u6CD5\u53D6\u6D88\u5E33\u6236\u7684\u522A\u9664\u3002",
    "focused-task-close-account.delete-account.overview.paragraph.list-of-apps-with-personal-data.admin": "\u6211\u5011\u6703\u5BC4\u7D66\u60A8\u4E00\u500B\u6E05\u55AE\uFF0C\u5176\u4E2D\u5217\u51FA\u53EF\u80FD\u5132\u5B58\u500B\u4EBA\u8CC7\u6599\u7684\u61C9\u7528\u7A0B\u5F0F\u3002",
    "focused-task-close-account.delete-account.overview.paragraph.list-of-apps-with-personal-data.self": "\u6211\u5011\u6703\u5BC4\u7D66\u60A8\u4E00\u500B\u6E05\u55AE\uFF0C\u5176\u4E2D\u5217\u51FA\u53EF\u80FD\u5132\u5B58\u60A8\u500B\u4EBA\u8CC7\u6599\u7684\u61C9\u7528\u7A0B\u5F0F\u3002",
    "focused-task-close-account.delete-account.overview.paragraph.loseAccess.admin": "{fullName} \u6703<b>\u7ACB\u5373\u5931\u53BB</b>\u6240\u6709 Atlassian \u5E33\u6236\u670D\u52D9\u7684\u5B58\u53D6\u6B0A\u3002\u4ED6\u5011\u76EE\u524D\u53EF\u5B58\u53D6\u4EE5\u4E0B\u9805\u76EE\uFF1A",
    "focused-task-close-account.delete-account.overview.paragraph.loseAccess.admin.noSites": "{fullName} \u6703<b>\u7ACB\u5373\u5931\u53BB</b>\u6240\u6709 Atlassian \u5E33\u6236\u670D\u52D9\u7684\u5B58\u53D6\u6B0A\u3002\u4ED6\u5011\u76EE\u524D\u7121\u6CD5\u5B58\u53D6\u4EFB\u4F55\u9805\u76EE\uFF0C\u793E\u7FA4\u548C\u5E02\u96C6\u4E4B\u985E\u7684\u670D\u52D9\u9664\u5916\u3002",
    "focused-task-close-account.delete-account.overview.paragraph.loseAccess.footnote": "\u5176\u4ED6 Atlassian \u5E33\u6236\u670D\u52D9\uFF0C\u4F8B\u5982 Atlassian Community \u548C Marketplace\u3002",
    "focused-task-close-account.delete-account.overview.paragraph.loseAccess.self": "\u60A8\u6703<b>\u7ACB\u5373\u5931\u53BB</b>\u6240\u6709 Atlassian \u5E33\u6236\u670D\u52D9\u7684\u5B58\u53D6\u6B0A\u3002\u60A8\u76EE\u524D\u53EF\u5B58\u53D6\u4EE5\u4E0B\u9805\u76EE\uFF1A",
    "focused-task-close-account.delete-account.overview.paragraph.loseAccess.self.noSites": "\u60A8\u6703<b>\u7ACB\u5373\u5931\u53BB</b>\u6240\u6709 Atlassian \u5E33\u6236\u670D\u52D9\u7684\u5B58\u53D6\u6B0A\u3002\u60A8\u76EE\u524D\u7121\u6CD5\u5B58\u53D6\u4EFB\u4F55\u9805\u76EE\uFF0C\u793E\u7FA4\u548C\u5E02\u96C6\u4E4B\u985E\u7684\u670D\u52D9\u9664\u5916\u3002",
    "focused-task-close-account.delete-account.overview.paragraph.personal-data-will-be-deleted.admin": "\u6211\u5011\u6703\u5728 30 \u5929\u5167\u5F9E Atlassian \u5E33\u6236\u670D\u52D9\u4E2D<b>\u522A\u9664\u4F7F\u7528\u8005\u7684\u500B\u4EBA\u8CC7\u6599</b>\uFF0C\u4F8B\u5982\u5168\u540D\u548C\u96FB\u5B50\u90F5\u4EF6\u5730\u5740\uFF0C\u5C11\u6578\u5E7E\u500B\u5408\u6CD5\u696D\u52D9\u6216\u6CD5\u5F8B\u76EE\u7684\u9700\u8981\u7684\u60C5\u6CC1\u4E0B\u9664\u5916\u3002",
    "focused-task-close-account.delete-account.overview.paragraph.personal-data-will-be-deleted.self": "\u6211\u5011\u6703\u5728 30 \u5929\u5167\u5F9E Atlassian \u5E33\u6236\u670D\u52D9\u4E2D<b>\u522A\u9664\u60A8\u7684\u500B\u4EBA\u8CC7\u6599</b>\uFF0C\u4F8B\u5982\u5168\u540D\u548C\u96FB\u5B50\u90F5\u4EF6\u5730\u5740\uFF0C\u5C11\u6578\u5E7E\u500B\u5408\u6CD5\u696D\u52D9\u6216\u6CD5\u5F8B\u76EE\u7684\u9700\u8981\u7684\u60C5\u6CC1\u4E0B\u9664\u5916\u3002",
    "focused-task-close-account.delete-account.overview.warning-section.body": "\u5728 14 \u5929\u5BEC\u9650\u671F\u5F8C\uFF0C\u60A8\u5C31\u7121\u6CD5\u53D6\u6D88\u5E33\u6236\u522A\u9664\u3002\u5982\u679C\u60A8\u8A8D\u70BA\u4E4B\u5F8C\u6703\u9700\u8981\u6B64\u5E33\u6236\uFF0C\u8ACB\u6539\u70BA\u5C07\u5176\u505C\u7528\u3002",
    "focused-task-close-account.delete-account.overview.warning-section.deactivated.body": "\u5728 14 \u5929\u5BEC\u9650\u671F\u5F8C\uFF0C\u60A8\u5C31\u7121\u6CD5\u53D6\u6D88\u5E33\u6236\u522A\u9664\u3002",
    "focused-task-close-account.learnMore": "\u4E86\u89E3\u66F4\u591A",
    "focused-task-close-account.next": "\u4E0B\u4E00\u6B65",
    "focused-task-close-account.previous": "\u4E0A\u4E00\u6B65"
};

});

parcelRegister("5MvQQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $435a247a004deda7$export$2e2bcd8739ae039; });
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Czech
var $435a247a004deda7$export$2e2bcd8739ae039 = {
    "focused-task-close-account.cancel": "Zru\u0161it",
    "focused-task-close-account.deactivate-account": "Deaktivovat \xfa\u010Det",
    "focused-task-close-account.deactivate-account.overview.first.line.admin": "Chyst\xe1te se deaktivovat u\u017Eivatelsk\xfd \xfa\u010Det:",
    "focused-task-close-account.deactivate-account.overview.first.line.self": "Chyst\xe1te se deaktivovat u\u017Eivatelsk\xfd \xfa\u010Det:",
    "focused-task-close-account.deactivate-account.overview.heading.admin": "Deaktivovat \xfa\u010Det",
    "focused-task-close-account.deactivate-account.overview.heading.self": "Deaktivovat \xfa\u010Det",
    "focused-task-close-account.deactivate-account.overview.last.line.admin": "\xda\u010Det m\u016F\u017Eete kdykoli zase aktivovat.",
    "focused-task-close-account.deactivate-account.overview.last.line.self": "\xda\u010Det m\u016F\u017Eete kdykoli zase aktivovat.",
    "focused-task-close-account.deactivate-account.overview.paragraph.about-to-deactivate.admin": "Kdy\u017E deaktivujete \xfa\u010Det:",
    "focused-task-close-account.deactivate-account.overview.paragraph.about-to-deactivate.self": "Kdy\u017E deaktivujete \xfa\u010Det:",
    "focused-task-close-account.deactivate-account.overview.paragraph.billing.admin": "Tohoto u\u017Eivatele v\xe1m u\u017E nebudeme fakturovat.",
    "focused-task-close-account.deactivate-account.overview.paragraph.billing.self": "Tohoto u\u017Eivatele v\xe1m u\u017E nebudeme fakturovat.",
    "focused-task-close-account.deactivate-account.overview.paragraph.loseAccess.admin": "U\u017Eivatel {fullName} <b>okam\u017Eit\u011B ztrat\xed p\u0159\xedstup</b> ke v\u0161em slu\u017Eb\xe1m \xfa\u010Dtu Atlassian. Nyn\xed m\xe1 p\u0159\xedstup k:",
    "focused-task-close-account.deactivate-account.overview.paragraph.loseAccess.admin.noSites": "U\u017Eivatel {fullName} <b>okam\u017Eit\u011B ztrat\xed p\u0159\xedstup</b> ke v\u0161em slu\u017Eb\xe1m \xfa\u010Dtu Atlassian. Nyn\xed nem\xe1 p\u0159\xedstup k \u017E\xe1dn\xfdm slu\u017Eb\xe1m krom\u011B slu\u017Eeb jako Community nebo Marketplace.",
    "focused-task-close-account.deactivate-account.overview.paragraph.loseAccess.footnote": "Dal\u0161\xed slu\u017Eby \xfa\u010Dtu Atlassian jako Atlassian Community a Marketplace.",
    "focused-task-close-account.deactivate-account.overview.paragraph.loseAccess.self": "<b>Okam\u017Eit\u011B ztrat\xedte p\u0159\xedstup</b> ke v\u0161em slu\u017Eb\xe1m \xfa\u010Dtu Atlassian. Nyn\xed m\xe1te p\u0159\xedstup k:",
    "focused-task-close-account.deactivate-account.overview.paragraph.loseAccess.self.noSites": "<b>Okam\u017Eit\u011B ztrat\xedte p\u0159\xedstup</b> ke v\u0161em slu\u017Eb\xe1m \xfa\u010Dtu Atlassian. Nyn\xed nem\xe1te p\u0159\xedstup k \u017E\xe1dn\xfdm slu\u017Eb\xe1m krom\u011B slu\u017Eeb jako Community nebo Marketplace.",
    "focused-task-close-account.deactivate-account.overview.paragraph.personal-data.admin": "Osobn\xed \xfadaje u\u017Eivatel\u016F, jako je cel\xe9 jm\xe9no a e-mailov\xe1 adresa, a obsah, kter\xfd vytvo\u0159ili, ve slu\u017Eb\xe1ch \xfa\u010Dtu Atlassian z\u016Fstane.",
    "focused-task-close-account.deactivate-account.overview.paragraph.personal-data.self": "Osobn\xed \xfadaje u\u017Eivatel\u016F, jako je cel\xe9 jm\xe9no a e-mailov\xe1 adresa, a obsah, kter\xfd vytvo\u0159ili, ve slu\u017Eb\xe1ch \xfa\u010Dtu Atlassian z\u016Fstane.",
    "focused-task-close-account.delete-account": "Smazat \xfa\u010Det",
    "focused-task-close-account.delete-account.content-preview.footnote.admin": "Pozn\xe1mka: Vypln\u011Bn\xedm tohoto dotazn\xedku n\xe1m umo\u017En\xedte vytv\xe1\u0159et pro v\u0161echny u\u017Eivatele lep\u0161\xed prost\u0159ed\xed. U\u017Eivatel se st\xe1le bude zobrazovat jako \u201Eb\xfdval\xfd u\u017Eivatel\u201C, jakmile jeho \xfa\u010Det sma\u017Eete.",
    "focused-task-close-account.delete-account.content-preview.footnote.self": "Pozn\xe1mka: Vypln\u011Bn\xedm tohoto dotazn\xedku n\xe1m umo\u017En\xedte vytv\xe1\u0159et pro v\u0161echny u\u017Eivatele, v\u010Detn\u011B t\u011Bch, kt\u011B\u0159\xed sv\xe9 \xfa\u010Dty sma\u017Eou, lep\u0161\xed prost\u0159ed\xed. Jakmile sv\u016Fj \xfa\u010Det sma\u017Eete, st\xe1le se budete zobrazovat jako \u201Eb\xfdval\xfd u\u017Eivatel\u201C.",
    "focused-task-close-account.delete-account.content-preview.formerUser": "B\xfdval\xfd u\u017Eivatel",
    "focused-task-close-account.delete-account.content-preview.heading.admin": "Jak by se m\u011Bl smazan\xfd u\u017Eivatel zobrazovat?",
    "focused-task-close-account.delete-account.content-preview.heading.self": "Jak by se m\u011Bl v\xe1\u0161 smazan\xfd \xfa\u010Det zobrazovat?",
    "focused-task-close-account.delete-account.content-preview.line.survey.admin": "Kdybyste m\u011Bli na vybranou, jak by se smazan\xfd u\u017Eivatel zobrazoval dal\u0161\xedm u\u017Eivatel\u016Fm?",
    "focused-task-close-account.delete-account.content-preview.line.survey.self": "Kdybyste m\u011Bli na vybranou, jak byste se m\u011Bli zobrazovat dal\u0161\xedm u\u017Eivatel\u016Fm?",
    "focused-task-close-account.delete-account.content-preview.paragraph.survey.admin": "Jakmile dojde ke smaz\xe1n\xed \xfa\u010Dtu u\u017Eivatele, ostatn\xedm u\u017Eivatel\u016Fm se zobrazuje jako \u201Eb\xfdval\xfd u\u017Eivatel\u201C. Ud\u011Blejte si pros\xedm chvilku a zodpov\u011Bzte ot\xe1zku z na\u0161eho pr\u016Fzkumu.",
    "focused-task-close-account.delete-account.content-preview.paragraph.survey.self": "Jakmile dojde ke smaz\xe1n\xed va\u0161eho \xfa\u010Dtu, ostatn\xedm u\u017Eivatel\u016Fm se zobrazujete jako \u201Eb\xfdval\xfd u\u017Eivatel\u201C. Ud\u011Blejte si pros\xedm chvilku a zodpov\u011Bzte ot\xe1zku z na\u0161eho pr\u016Fzkumu.",
    "focused-task-close-account.delete-account.drop-down-collapse-button": "Zobrazit m\xe9n\u011B",
    "focused-task-close-account.delete-account.drop-down-expand-button": "{num} dal\u0161\xed(ch)",
    "focused-task-close-account.delete-account.overview.first.line.admin": "Chyst\xe1te se smazat \xfa\u010Det:",
    "focused-task-close-account.delete-account.overview.first.line.self": "Chyst\xe1te se smazat sv\u016Fj \xfa\u010Det:",
    "focused-task-close-account.delete-account.overview.heading.admin": "Smazat \xfa\u010Det",
    "focused-task-close-account.delete-account.overview.heading.self": "Smaz\xe1n\xed va\u0161eho \xfa\u010Dtu",
    "focused-task-close-account.delete-account.overview.inline-dialog.content-created.admin": "Nap\u0159\xedklad str\xe1nky, po\u017Eadavky a koment\xe1\u0159e, kter\xe9 v produktech vytvo\u0159ili.",
    "focused-task-close-account.delete-account.overview.inline-dialog.content-created.self": "Nap\u0159\xedklad str\xe1nky, po\u017Eadavky a koment\xe1\u0159e, kter\xe9 jste v produktech vytvo\u0159ili.",
    "focused-task-close-account.delete-account.overview.inline-dialog.data-apps.admin": "Vy nebo jin\xed u\u017Eivatel\xe9 jste si mohli nainstalovat aplikace, kter\xe9 p\u0159id\xe1vaj\xed do produkt\u016F Atlassian funkce. Tyto aplikace mohly ulo\u017Eit \xfadaje o u\u017Eivatelsk\xe9m profilu.",
    "focused-task-close-account.delete-account.overview.inline-dialog.data-apps.self": "Vy nebo jin\xed u\u017Eivatel\xe9 jste si mohli nainstalovat aplikace, kter\xe9 p\u0159id\xe1vaj\xed do produkt\u016F Atlassian funkce. Tyto aplikace mohly ulo\u017Eit \xfadaje o va\u0161em profilu.",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.li1.admin": "Informace souvisej\xedc\xed s n\xe1kupy, kter\xe9 mus\xedme uchovat kv\u016Fli finan\u010Dn\xedm zpr\xe1v\xe1m.",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.li1.self": "Informace souvisej\xedc\xed s n\xe1kupy, kter\xe9 mus\xedme uchovat kv\u016Fli finan\u010Dn\xedm zpr\xe1v\xe1m.",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.li2.admin": "Z\xe1znamy, kter\xe9 ukazuj\xed, \u017Ee jsme smazali n\u011B\u010D\xed \xfa\u010Det, a kter\xe9 m\u016F\u017Eeme b\xfdt povinni poskytnout kontroln\xedm org\xe1n\u016Fm.",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.li2.self": "Z\xe1znamy, kter\xe9 ukazuj\xed, \u017Ee jsme smazali n\u011B\u010D\xed \xfa\u010Det, a kter\xe9 m\u016F\u017Eeme b\xfdt povinni poskytnout kontroln\xedm org\xe1n\u016Fm.",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.li3.admin": "\xdadaje, kter\xe9 jsou sou\u010D\xe1st\xed prob\xedhaj\xedc\xedho soudn\xedho \u0159\xedzen\xed a kter\xe9 jsme dle z\xe1kona povinni uchov\xe1vat.",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.li3.self": "\xdadaje, kter\xe9 jsou sou\u010D\xe1st\xed prob\xedhaj\xedc\xedho soudn\xedho \u0159\xedzen\xed a kter\xe9 jsme dle z\xe1kona povinni uchov\xe1vat.",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.p1.admin": "Osobn\xed \xfadaje uchov\xe1v\xe1me po omezenou dobu, z opr\xe1vn\u011Bn\xfdch obchodn\xedch nebo pr\xe1vn\xfdch d\u016Fvod\u016F. N\u011Bkter\xe9 p\u0159\xedklady zahrnuj\xed:",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.p1.self": "Osobn\xed \xfadaje uchov\xe1v\xe1me po omezenou dobu, z opr\xe1vn\u011Bn\xfdch obchodn\xedch nebo pr\xe1vn\xfdch d\u016Fvod\u016F. N\u011Bkter\xe9 p\u0159\xedklady zahrnuj\xed:",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.p2.admin": "Nema\u017Eeme \u017E\xe1dn\xe9 osobn\xed \xfadaje z obsahu vytvo\u0159en\xe9ho u\u017Eivateli, jako jsou jm\xe9na nebo e-mailov\xe9 adresy, kter\xe9 uvedli na str\xe1nce nebo v po\u017Eadavku. Administr\xe1to\u0159i produkt\u016F mus\xed tyto \xfadaje smazat ru\u010Dn\u011B.",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.p2.self": "Nema\u017Eeme \u017E\xe1dn\xe9 osobn\xed \xfadaje z obsahu vytvo\u0159en\xe9ho v\xe1mi nebo dal\u0161\xedmi lidmi, jako jsou jm\xe9na nebo e-mailov\xe9 adresy uveden\xe9 na str\xe1nce nebo v po\u017Eadavku. Administr\xe1to\u0159i va\u0161ich produkt\u016F mus\xed tyto \xfadaje smazat ru\u010Dn\u011B.",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.p3.admin": "U\u017Eivatel\xe9 maj\xed pr\xe1vo podat st\xed\u017Enost dozorov\xe9mu \xfa\u0159adu ve sv\xe9 zemi.",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.p3.self": "M\xe1te pr\xe1vo podat st\xed\u017Enost dozorov\xe9mu \xfa\u0159adu ve sv\xe9 zemi.",
    "focused-task-close-account.delete-account.overview.paragraph.about-to-delete.admin": "Kdy\u017E sma\u017Eete \xfa\u010Det:",
    "focused-task-close-account.delete-account.overview.paragraph.about-to-delete.self": "Kdy\u017E sma\u017Eete sv\u016Fj \xfa\u010Det:",
    "focused-task-close-account.delete-account.overview.paragraph.content-created.admin": "Obsah, kter\xfd vytvo\u0159ili, z\u016Fstane ve slu\u017Eb\xe1ch \xfa\u010Dtu Atlassian.",
    "focused-task-close-account.delete-account.overview.paragraph.content-created.self": "Obsah, kter\xfd jste vytvo\u0159ili, z\u016Fstane ve slu\u017Eb\xe1ch \xfa\u010Dtu Atlassian.",
    "focused-task-close-account.delete-account.overview.paragraph.grace-period.admin": "Po \u010Dtrn\xe1ctidenn\xed lh\u016Ft\u011B nebudete moci zru\u0161it smaz\xe1n\xed \xfa\u010Dtu.",
    "focused-task-close-account.delete-account.overview.paragraph.list-of-apps-with-personal-data.admin": "E-mailem v\xe1m po\u0161leme seznam aplikac\xed, kter\xe9 mohly ulo\u017Eit jejich osobn\xed \xfadaje.",
    "focused-task-close-account.delete-account.overview.paragraph.list-of-apps-with-personal-data.self": "E-mailem v\xe1m po\u0161leme seznam aplikac\xed, kter\xe9 mohly ulo\u017Eit va\u0161e osobn\xed \xfadaje.",
    "focused-task-close-account.delete-account.overview.paragraph.loseAccess.admin": "U\u017Eivatel {fullName} <b>okam\u017Eit\u011B ztrat\xed p\u0159\xedstup</b> ke v\u0161em slu\u017Eb\xe1m \xfa\u010Dtu Atlassian. Nyn\xed m\xe1 p\u0159\xedstup k:",
    "focused-task-close-account.delete-account.overview.paragraph.loseAccess.admin.noSites": "U\u017Eivatel {fullName} <b>okam\u017Eit\u011B ztrat\xed p\u0159\xedstup</b> ke v\u0161em slu\u017Eb\xe1m \xfa\u010Dtu Atlassian. Nyn\xed nem\xe1 p\u0159\xedstup k \u017E\xe1dn\xfdm slu\u017Eb\xe1m krom\u011B slu\u017Eeb jako Community nebo Marketplace.",
    "focused-task-close-account.delete-account.overview.paragraph.loseAccess.footnote": "Dal\u0161\xed slu\u017Eby \xfa\u010Dtu Atlassian jako Atlassian Community a Marketplace.",
    "focused-task-close-account.delete-account.overview.paragraph.loseAccess.self": "<b>Okam\u017Eit\u011B ztrat\xedte p\u0159\xedstup</b> ke v\u0161em slu\u017Eb\xe1m \xfa\u010Dtu Atlassian. Nyn\xed m\xe1te p\u0159\xedstup k:",
    "focused-task-close-account.delete-account.overview.paragraph.loseAccess.self.noSites": "<b>Okam\u017Eit\u011B ztrat\xedte p\u0159\xedstup</b> ke v\u0161em slu\u017Eb\xe1m \xfa\u010Dtu Atlassian. Nyn\xed nem\xe1te p\u0159\xedstup k \u017E\xe1dn\xfdm slu\u017Eb\xe1m krom\u011B slu\u017Eeb jako Community nebo Marketplace.",
    "focused-task-close-account.delete-account.overview.paragraph.personal-data-will-be-deleted.admin": "Ze slu\u017Eeb \xfa\u010Dtu Atlassian b\u011Bhem 30 dn\xed <b>sma\u017Eeme jejich osobn\xed \xfadaje</b>, jako je jejich cel\xe9 jm\xe9no a e-mailov\xe1 adresa, s v\xfdjimkou p\u0159\xedpad\u016F, kdy jsou pot\u0159eba z opr\xe1vn\u011Bn\xfdch obchodn\xedch nebo pr\xe1vn\xfdch d\u016Fvod\u016F.",
    "focused-task-close-account.delete-account.overview.paragraph.personal-data-will-be-deleted.self": "Ze slu\u017Eeb \xfa\u010Dtu Atlassian b\u011Bhem 30 dn\xed <b>sma\u017Eeme va\u0161e osobn\xed \xfadaje</b>, jako je va\u0161e cel\xe9 jm\xe9no a e-mailov\xe1 adresa, s v\xfdjimkou p\u0159\xedpad\u016F, kdy jsou pot\u0159eba z opr\xe1vn\u011Bn\xfdch obchodn\xedch nebo pr\xe1vn\xfdch d\u016Fvod\u016F.",
    "focused-task-close-account.delete-account.overview.warning-section.body": "Po \u010Dtrn\xe1ctidenn\xed lh\u016Ft\u011B nebudete moci zru\u0161it smaz\xe1n\xed \xfa\u010Dtu. Pokud si mysl\xedte, \u017Ee byste pozd\u011Bji mohli \xfa\u010Det pot\u0159ebovat, m\xedsto toho jej deaktivujte.",
    "focused-task-close-account.delete-account.overview.warning-section.deactivated.body": "Po \u010Dtrn\xe1ctidenn\xed lh\u016Ft\u011B nebudete moci zru\u0161it smaz\xe1n\xed \xfa\u010Dtu.",
    "focused-task-close-account.learnMore": "Dal\u0161\xed informace",
    "focused-task-close-account.next": "Dal\u0161\xed",
    "focused-task-close-account.previous": "P\u0159edchoz\xed"
};

});

parcelRegister("bKpJ8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $88d7f272b59336f9$export$2e2bcd8739ae039; });
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Danish (Denmark)
var $88d7f272b59336f9$export$2e2bcd8739ae039 = {
    "focused-task-close-account.cancel": "Annull\xe9r",
    "focused-task-close-account.deactivate-account": "Deaktiv\xe9r konto",
    "focused-task-close-account.deactivate-account.overview.first.line.admin": "Du er ved at deaktivere brugerkontoen for:",
    "focused-task-close-account.deactivate-account.overview.first.line.self": "Du er ved at deaktivere brugerkontoen for:",
    "focused-task-close-account.deactivate-account.overview.heading.admin": "Deaktiv\xe9r konto",
    "focused-task-close-account.deactivate-account.overview.heading.self": "Deaktiv\xe9r konto",
    "focused-task-close-account.deactivate-account.overview.last.line.admin": "Du kan genaktivere kontoen n\xe5r som helst.",
    "focused-task-close-account.deactivate-account.overview.last.line.self": "Du kan genaktivere kontoen n\xe5r som helst.",
    "focused-task-close-account.deactivate-account.overview.paragraph.about-to-deactivate.admin": "N\xe5r du deaktiverer kontoen:",
    "focused-task-close-account.deactivate-account.overview.paragraph.about-to-deactivate.self": "N\xe5r du deaktiverer kontoen:",
    "focused-task-close-account.deactivate-account.overview.paragraph.billing.admin": "Fakturerer vi dig ikke l\xe6ngere for vedkommende.",
    "focused-task-close-account.deactivate-account.overview.paragraph.billing.self": "Fakturerer vi dig ikke l\xe6ngere for vedkommende.",
    "focused-task-close-account.deactivate-account.overview.paragraph.loseAccess.admin": "{fullName} <b>mister \xf8jeblikkeligt adgang</b> til alle Atlassian-kontotjenester. Personen har p.t. adgang til:",
    "focused-task-close-account.deactivate-account.overview.paragraph.loseAccess.admin.noSites": "{fullName} <b>mister \xf8jeblikkeligt adgang</b> til alle Atlassian-kontotjenester. Personen har p.t. ikke adgang til nogen bortset fra tjenester som Community og Marketplace.",
    "focused-task-close-account.deactivate-account.overview.paragraph.loseAccess.footnote": "Andre Atlassian-kontotjenester s\xe5som Atlassian Community og Marketplace.",
    "focused-task-close-account.deactivate-account.overview.paragraph.loseAccess.self": "Du <b>mister \xf8jeblikkeligt adgang</b> til alle Atlassian-kontotjenester. Du har p.t. adgang til:",
    "focused-task-close-account.deactivate-account.overview.paragraph.loseAccess.self.noSites": "Du <b>mister \xf8jeblikkeligt adgang</b> til alle Atlassian-kontotjenester. Du har p.t. ikke adgang til nogen bortset fra tjenester som Community og Marketplace.",
    "focused-task-close-account.deactivate-account.overview.paragraph.personal-data.admin": "Vedkommendes personoplysninger s\xe5som fulde navn og e-mailadresse samt indhold, vedkommende har oprettet, vil blive i Atlassian-kontotjenesterne.",
    "focused-task-close-account.deactivate-account.overview.paragraph.personal-data.self": "Vedkommendes personoplysninger s\xe5som fulde navn og e-mailadresse samt indhold, vedkommende har oprettet, vil blive i Atlassian-kontotjenesterne.",
    "focused-task-close-account.delete-account": "Slet konto",
    "focused-task-close-account.delete-account.content-preview.footnote.admin": 'Bem\xe6rk: Du hj\xe6lper os med at sikre alle brugere en bedre oplevelse ved at svare p\xe5 denne unders\xf8gelse. Brugeren fremst\xe5r stadig som en "Tidligere bruger", efter kontoen slettes.',
    "focused-task-close-account.delete-account.content-preview.footnote.self": 'Bem\xe6rk: Du hj\xe6lper os med at sikre alle brugere en bedre oplevelse, ved at svare p\xe5 denne unders\xf8gelse, herunder ogs\xe5 de der sletter deres kontoer. Du bliver stadig vist som "Tidligere bruger", efter din konto slettes.',
    "focused-task-close-account.delete-account.content-preview.formerUser": "Tidligere bruger",
    "focused-task-close-account.delete-account.content-preview.heading.admin": "Hvordan foretr\xe6kker du, at den slettede bruger bliver vist?",
    "focused-task-close-account.delete-account.content-preview.heading.self": "Hvordan foretr\xe6kker du, at din slettede konto bliver vist?",
    "focused-task-close-account.delete-account.content-preview.line.survey.admin": "Hvis du fik valget, hvordan ville du s\xe5 foretr\xe6kke, at den slettede bruger blev vist overfor andre brugere?",
    "focused-task-close-account.delete-account.content-preview.line.survey.self": "Hvis du fik valget, hvordan ville du s\xe5 foretr\xe6kke at blive vist overfor andre brugere?",
    "focused-task-close-account.delete-account.content-preview.paragraph.survey.admin": 'N\xe5r din brugers konto slettes, bliver de vist som "Tidligere bruger" overfor andre brugere. Brug et \xf8jeblik p\xe5 at besvare vores unders\xf8gelsessp\xf8rgsm\xe5l.',
    "focused-task-close-account.delete-account.content-preview.paragraph.survey.self": 'N\xe5r din konto slettes, bliver du vist som "Tidligere bruger" overfor andre brugere. Brug et \xf8jeblik p\xe5 at besvare vores unders\xf8gelsessp\xf8rgsm\xe5l.',
    "focused-task-close-account.delete-account.drop-down-collapse-button": "Vis mindre",
    "focused-task-close-account.delete-account.drop-down-expand-button": "{num} mere",
    "focused-task-close-account.delete-account.overview.first.line.admin": "Du er ved at slette kontoen for:",
    "focused-task-close-account.delete-account.overview.first.line.self": "Du er ved at slette din konto:",
    "focused-task-close-account.delete-account.overview.heading.admin": "Slet konto",
    "focused-task-close-account.delete-account.overview.heading.self": "Slet din konto",
    "focused-task-close-account.delete-account.overview.inline-dialog.content-created.admin": "For eksempel sider, opgaver og kommentarer, personen har tilf\xf8jet til produkter.",
    "focused-task-close-account.delete-account.overview.inline-dialog.content-created.self": "For eksempel sider, opgaver og kommentarer, du har tilf\xf8jet til produkter.",
    "focused-task-close-account.delete-account.overview.inline-dialog.data-apps.admin": "Du og andre brugere kan have installeret apps, der tilf\xf8jer funktioner til Atlassian-produkter. Disse apps kan indeholde brugerens profiloplysninger.",
    "focused-task-close-account.delete-account.overview.inline-dialog.data-apps.self": "Du og andre brugere kan have installeret apps, der tilf\xf8jer funktioner til Atlassian-produkter. Disse apps kan indeholde brugerens profiloplysninger.",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.li1.admin": "Information vedr\xf8rende k\xf8b, som vi er forpligtede til at beholde af hensyn til finansiel rapportering.",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.li1.self": "Information vedr\xf8rende k\xf8b, som vi er forpligtede til at beholde af hensyn til finansiel rapportering.",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.li2.admin": "Fortegnelser, der viser, at vi slettet en persons konto, som kan v\xe6re forpligtede til at videregive til lovgivere.",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.li2.self": "Fortegnelser, der viser, at vi slettet en persons konto, som kan v\xe6re forpligtede til at videregive til lovgivere.",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.li3.admin": "Data, som indg\xe5r i en aktiv retssag, og som loven p\xe5byder os at beholde.",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.li3.self": "Data, som indg\xe5r i en aktiv retssag, og som loven p\xe5byder os at beholde.",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.p1.admin": "Vi beholder private oplysninger i begr\xe6nsede tidsrum, n\xe5r de er p\xe5kr\xe6vede til drift af lovlig virksomhed eller juridiske form\xe5l. Eksempler omfatter:",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.p1.self": "Vi beholder private oplysninger i begr\xe6nsede tidsrum, n\xe5r de er p\xe5kr\xe6vede til drift af lovlig virksomhed eller juridiske form\xe5l. Eksempler omfatter:",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.p2.admin": "Vi sletter ikke private oplysninger fra indhold, brugere har oprettet, s\xe5som navne og e-mailadresser, de har indtastet p\xe5 en side eller i en opgave. Disse oplysninger skal slettes manuelt af produktadministratorerne.",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.p2.self": "Vi sletter ikke private oplysninger fra indhold, brugere har oprettet, s\xe5som navne og e-mailadresser, de har indtastet p\xe5 en side eller i en opgave. Disse oplysninger skal slettes manuelt af produktadministratorerne.",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.p3.admin": "Brugere har ret til at indsende klager til den relevante myndighed i deres land.",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.p3.self": "Du har ret til at indsende klager til den relevante myndighed i dit land.",
    "focused-task-close-account.delete-account.overview.paragraph.about-to-delete.admin": "N\xe5r du sletter kontoen:",
    "focused-task-close-account.delete-account.overview.paragraph.about-to-delete.self": "N\xe5r du sletter din konto:",
    "focused-task-close-account.delete-account.overview.paragraph.content-created.admin": "Indholdet, personen har oprettet, vil blive i Atlassian-kontotjenesterne.",
    "focused-task-close-account.delete-account.overview.paragraph.content-created.self": "Indholdet, du har oprettet, vil blive i Atlassian-kontotjenesterne.",
    "focused-task-close-account.delete-account.overview.paragraph.grace-period.admin": "Efter en henstandsperiode p\xe5 14 dage vil du ikke kunne annullere sletningen af din konto.",
    "focused-task-close-account.delete-account.overview.paragraph.list-of-apps-with-personal-data.admin": "Vi sender dig en e-mail med en liste over apps, der kan indeholde personens private oplysninger.",
    "focused-task-close-account.delete-account.overview.paragraph.list-of-apps-with-personal-data.self": "Vi sender dig en e-mail med en liste over apps, der kan indeholde dine private oplysninger.",
    "focused-task-close-account.delete-account.overview.paragraph.loseAccess.admin": "{fullName} vil <b>\xf8jeblikkeligt miste adgang</b> til alle Atlassian-kontotjenester. Vedkommende har p.t. adgang til:",
    "focused-task-close-account.delete-account.overview.paragraph.loseAccess.admin.noSites": "{fullName} vil <b>\xf8jeblikkeligt miste adgang</b> til alle Atlassian-kontotjenester. Personen har p.t. ikke adgang til nogen, bortset fra tjenester som F\xe6llesskab og Markedsplads.",
    "focused-task-close-account.delete-account.overview.paragraph.loseAccess.footnote": "Andre Atlassian-kontotjenester, s\xe5som Atlassian F\xe6llesskab og Markedsplads.",
    "focused-task-close-account.delete-account.overview.paragraph.loseAccess.self": "Du vil <b>\xf8jeblikkeligt miste adgang</b> til alle Atlassian-kontotjenester. Du har p.t. adgang til:",
    "focused-task-close-account.delete-account.overview.paragraph.loseAccess.self.noSites": "Du vil <b>\xf8jeblikkeligt miste adgang</b> til alle Atlassian-kontotjenester. Du har p.t. ikke adgang til nogen, bortset fra tjenester som F\xe6llesskab og Markedsplads.",
    "focused-task-close-account.delete-account.overview.paragraph.personal-data-will-be-deleted.admin": "Vi vil<b>slette personens private oplysninger</b>, s\xe5som vedkommendes fulde navn og e-mailadresse, fra Atlassian-kontotjenester inden for 30 dage, bortset fra nogle f\xe5 tilf\xe6lde, hvor de er p\xe5kr\xe6vede til drift af lovlig virksomhed eller juridiske form\xe5l.",
    "focused-task-close-account.delete-account.overview.paragraph.personal-data-will-be-deleted.self": "Vi vil<b>slette dine private oplysninger</b>, s\xe5som dit fulde navn og e-mailadresse, fra Atlassian-kontotjenester inden for 30 dage, bortset fra nogle f\xe5 tilf\xe6lde, hvor de er p\xe5kr\xe6vede til drift af lovlig virksomhed eller juridiske form\xe5l.",
    "focused-task-close-account.delete-account.overview.warning-section.body": "Efter en henstandsperiode p\xe5 14 dage vil du ikke kunne annullere sletningen af kontoen. Hvis du tror, at du f\xe5r brug for kontoen senere, skal du deaktivere den i stedet.",
    "focused-task-close-account.delete-account.overview.warning-section.deactivated.body": "Efter en henstandsperiode p\xe5 14 dage vil du ikke kunne annullere sletningen af kontoen.",
    "focused-task-close-account.learnMore": "L\xe6s mere",
    "focused-task-close-account.next": "N\xe6ste",
    "focused-task-close-account.previous": "Seneste"
};

});

parcelRegister("bfxaI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $830ad3ad2ba307c1$export$2e2bcd8739ae039; });
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Dutch (Netherlands)
var $830ad3ad2ba307c1$export$2e2bcd8739ae039 = {
    "focused-task-close-account.cancel": "Annuleren",
    "focused-task-close-account.deactivate-account": "Account deactiveren",
    "focused-task-close-account.deactivate-account.overview.first.line.admin": "Je staat op het punt om de account te deactiveren van:",
    "focused-task-close-account.deactivate-account.overview.first.line.self": "Je staat op het punt om de account te deactiveren van:",
    "focused-task-close-account.deactivate-account.overview.heading.admin": "Account deactiveren",
    "focused-task-close-account.deactivate-account.overview.heading.self": "Account deactiveren",
    "focused-task-close-account.deactivate-account.overview.last.line.admin": "Je kunt de account op elk gewenst moment weer activeren.",
    "focused-task-close-account.deactivate-account.overview.last.line.self": "Je kunt de account op elk gewenst moment weer activeren.",
    "focused-task-close-account.deactivate-account.overview.paragraph.about-to-deactivate.admin": "Wanneer je de account deactiveert:",
    "focused-task-close-account.deactivate-account.overview.paragraph.about-to-deactivate.self": "Wanneer je de account deactiveert:",
    "focused-task-close-account.deactivate-account.overview.paragraph.billing.admin": "Deze gebruiker wordt niet meer in rekening gebracht.",
    "focused-task-close-account.deactivate-account.overview.paragraph.billing.self": "Deze gebruiker wordt niet meer in rekening gebracht.",
    "focused-task-close-account.deactivate-account.overview.paragraph.loseAccess.admin": "{fullName} zal <b>direct toegang verliezen</b> tot alle Atlassian-accountservices. Deze gebruiker heeft momenteel toegang tot:",
    "focused-task-close-account.deactivate-account.overview.paragraph.loseAccess.admin.noSites": "{fullName} zal <b>direct toegang verliezen</b> tot alle Atlassian-accountservices. Deze gebruiker heeft momenteel geen toegang tot een service, behalve Community en Marketplace.",
    "focused-task-close-account.deactivate-account.overview.paragraph.loseAccess.footnote": "Andere Atlassian-accountservices, zoals Atlassian Community en Marketplace.",
    "focused-task-close-account.deactivate-account.overview.paragraph.loseAccess.self": "Je zult <b>direct toegang verliezen</b> tot alle Atlassian-accountservices. Je hebt momenteel toegang tot:",
    "focused-task-close-account.deactivate-account.overview.paragraph.loseAccess.self.noSites": "Je zult <b>direct toegang verliezen</b> tot alle Atlassian-accountservices. Je hebt momenteel geen toegang tot een service, behalve Community en Marketplace.",
    "focused-task-close-account.deactivate-account.overview.paragraph.personal-data.admin": "Hun persoonsgegevens, zoals hun volledige naam en e-mailadres, en content die ze hebben gemaakt blijven bewaard in de Atlassian-accountservices.",
    "focused-task-close-account.deactivate-account.overview.paragraph.personal-data.self": "Hun persoonsgegevens, zoals hun volledige naam en e-mailadres, en content die ze hebben gemaakt blijven bewaard in de Atlassian-accountservices.",
    "focused-task-close-account.delete-account": "Account verwijderen",
    "focused-task-close-account.delete-account.content-preview.footnote.admin": "Opmerking: door deze enqu\xeate te beantwoorden, help je ons alle gebruikers een betere ervaring te bieden. De gebruiker zal nog steeds worden weergegeven als \u201CVoormalige gebruiker\u201D nadat je het account hebt verwijderd.",
    "focused-task-close-account.delete-account.content-preview.footnote.self": "Opmerking: door deze enqu\xeate te beantwoorden, help je ons alle gebruikers een betere ervaring te bieden, inclusief gebruikers die hun account verwijderen. Je zult nog steeds als \u201CVoormalige gebruiker\u201D worden getoond nadat je je account hebt verwijderd.",
    "focused-task-close-account.delete-account.content-preview.formerUser": "Voormalige gebruiker",
    "focused-task-close-account.delete-account.content-preview.heading.admin": "Hoe wil je dat de verwijderde gebruiker wordt getoond?",
    "focused-task-close-account.delete-account.content-preview.heading.self": "Hoe wil je dat je verwijderde account wordt getoond?",
    "focused-task-close-account.delete-account.content-preview.line.survey.admin": "Als je de keus had, hoe zou je dan de verwijderde gebruiker aan andere gebruikers willen tonen?",
    "focused-task-close-account.delete-account.content-preview.line.survey.self": "Als je de keus had, hoe zou je dan aan andere gebruikers getoond willen worden?",
    "focused-task-close-account.delete-account.content-preview.paragraph.survey.admin": "Nadat het account van de gebruiker is verwijderd, zal hij of zij aan andere gebruikers worden getoond als \u201CVoormalige gebruiker\u201D. Neem even de tijd om onze enqu\xeatevraag te beantwoorden.",
    "focused-task-close-account.delete-account.content-preview.paragraph.survey.self": "Nadat je account is verwijderd, zal je aan andere gebruikers als \u201CVoormalige gebruiker\u201D worden getoond. Neem even de tijd om onze enqu\xeatevraag te beantwoorden.",
    "focused-task-close-account.delete-account.drop-down-collapse-button": "Minder tonen",
    "focused-task-close-account.delete-account.drop-down-expand-button": "{num} meer",
    "focused-task-close-account.delete-account.overview.first.line.admin": "Je staat op het punt om de account te verwijderen van:",
    "focused-task-close-account.delete-account.overview.first.line.self": "Je staat op het punt om je account te verwijderen:",
    "focused-task-close-account.delete-account.overview.heading.admin": "Account verwijderen",
    "focused-task-close-account.delete-account.overview.heading.self": "Je account verwijderen",
    "focused-task-close-account.delete-account.overview.inline-dialog.content-created.admin": "Bijvoorbeeld pagina's, issues en opmerkingen die ze hebben gemaakt in producten.",
    "focused-task-close-account.delete-account.overview.inline-dialog.content-created.self": "Bijvoorbeeld pagina's, issues en opmerkingen die je hebt gemaakt in producten.",
    "focused-task-close-account.delete-account.overview.inline-dialog.data-apps.admin": "Jij of andere gebruikers hebben misschien apps ge\xefnstalleerd die functies toevoegen aan Atlassian-producten. Deze apps hebben mogelijk profielinformatie van de gebruiker opgeslagen.",
    "focused-task-close-account.delete-account.overview.inline-dialog.data-apps.self": "Jij of andere gebruikers hebben misschien apps ge\xefnstalleerd die functies toevoegen aan Atlassian-producten. Deze apps hebben mogelijk jouw profielinformatie opgeslagen.",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.li1.admin": "Informatie met betrekking tot aankopen, die we verplicht zijn om te bewaren wegens financi\xeble verslaggeving.",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.li1.self": "Informatie met betrekking tot aankopen, die we verplicht zijn om te bewaren wegens financi\xeble verslaggeving.",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.li2.admin": "Gegevens waarmee we kunnen aantonen dat iemands account is verwijderd, mocht deze informatie overlegd moeten worden aan toezichthouders.",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.li2.self": "Gegevens waarmee we kunnen aantonen dat iemands account is verwijderd, mocht deze informatie overlegd moeten worden aan toezichthouders.",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.li3.admin": "Data die deel uitmaakt van een lopende rechtszaak, welke we wettelijk verplicht zijn om te bewaren.",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.li3.self": "Data die deel uitmaakt van een lopende rechtszaak, welke we wettelijk verplicht zijn om te bewaren.",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.p1.admin": "We bewaren persoonlijke gegevens voor een beperkte periode om zakelijke of juridische redenen. Voorbeelden zijn onder andere:",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.p1.self": "We bewaren persoonlijke gegevens voor een beperkte periode om zakelijke of juridische redenen. Voorbeelden zijn onder andere:",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.p2.admin": "We verwijderen geen persoonlijke gegevens uit content die door gebruikers is gemaakt, bijvoorbeeld namen of e-mailadressen die door hen in een pagina of issue zijn gezet. De productbeheerders moeten deze gegevens handmatig verwijderen.",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.p2.self": "We verwijderen geen persoonlijke gegevens uit content die door jou of andere mensen is gemaakt, bijvoorbeeld namen of e-mailadressen die in een pagina of issue zijn gezet. Je productbeheerders moeten deze gegevens handmatig verwijderen.",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.p3.admin": "Gebruikers hebben het recht om een klacht in te dienen bij de toezichthoudende autoriteit in hun land.",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.p3.self": "Je hebt het recht om een klacht in te dienen bij de toezichthoudende autoriteit in jouw land.",
    "focused-task-close-account.delete-account.overview.paragraph.about-to-delete.admin": "Wanneer je de account verwijdert:",
    "focused-task-close-account.delete-account.overview.paragraph.about-to-delete.self": "Wanneer je je account verwijdert:",
    "focused-task-close-account.delete-account.overview.paragraph.content-created.admin": "De content die ze hebben gemaakt, blijft bewaard in de Atlassian-accountservices.",
    "focused-task-close-account.delete-account.overview.paragraph.content-created.self": "De content die je hebt gemaakt, blijft bewaard in de Atlassian-accountservices.",
    "focused-task-close-account.delete-account.overview.paragraph.grace-period.admin": "Na een wachtperiode van 14 dagen kan het verwijderen van de account niet meer geannuleerd worden.",
    "focused-task-close-account.delete-account.overview.paragraph.list-of-apps-with-personal-data.admin": "We zullen je een lijst met apps sturen die mogelijk hun persoonlijke gegevens hebben opgeslagen.",
    "focused-task-close-account.delete-account.overview.paragraph.list-of-apps-with-personal-data.self": "We zullen je een lijst met apps sturen die mogelijk je persoonlijke gegevens hebben opgeslagen.",
    "focused-task-close-account.delete-account.overview.paragraph.loseAccess.admin": "{fullName} zal <b>direct toegang verliezen</b> tot alle Atlassian-accountservices. Deze gebruiker heeft momenteel toegang tot:",
    "focused-task-close-account.delete-account.overview.paragraph.loseAccess.admin.noSites": "{fullName} zal <b>direct toegang verliezen</b> tot alle Atlassian-accountservices. Deze gebruiker heeft momenteel geen toegang tot een service, behalve Community en Marketplace.",
    "focused-task-close-account.delete-account.overview.paragraph.loseAccess.footnote": "Andere Atlassian-accountservices, zoals Atlassian Community en Marketplace.",
    "focused-task-close-account.delete-account.overview.paragraph.loseAccess.self": "Je zult <b>direct toegang verliezen</b> tot alle Atlassian-accountservices. Je hebt momenteel toegang tot:",
    "focused-task-close-account.delete-account.overview.paragraph.loseAccess.self.noSites": "Je zult <b>direct toegang verliezen</b> tot alle Atlassian-accountservices. Je hebt momenteel geen toegang tot een service, behalve Community en Marketplace.",
    "focused-task-close-account.delete-account.overview.paragraph.personal-data-will-be-deleted.admin": "We <b>verwijderen hun persoonlijke gegevens</b>, zoals hun volledige naam en e-mailadres, binnen 30 dagen van de Atlassian-accountservices. Er zijn echter een aantal uitzonderingen waarin we bepaalde gegevens moeten bewaren om zakelijke of juridische redenen.",
    "focused-task-close-account.delete-account.overview.paragraph.personal-data-will-be-deleted.self": "We <b>verwijderen je persoonlijke gegevens</b>, zoals je volledige naam en e-mailadres, binnen 30 dagen van de Atlassian-accountservices. Er zijn echter een aantal uitzonderingen waarin we bepaalde gegevens moeten bewaren om zakelijke of juridische redenen.",
    "focused-task-close-account.delete-account.overview.warning-section.body": "Na een wachtperiode van 14 dagen kan het verwijderen van de account niet meer geannuleerd worden. Als je denkt dat je de account later toch nog nodig hebt, deactiveer hem dan.",
    "focused-task-close-account.delete-account.overview.warning-section.deactivated.body": "Na een wachtperiode van 14 dagen kan het verwijderen van de account niet meer geannuleerd worden.",
    "focused-task-close-account.learnMore": "Meer informatie",
    "focused-task-close-account.next": "Volgende",
    "focused-task-close-account.previous": "Vorige"
};

});

parcelRegister("bbOue", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8257e25c9178608e$export$2e2bcd8739ae039; });
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Estonian
var $8257e25c9178608e$export$2e2bcd8739ae039 = {
    "focused-task-close-account.cancel": "T\xfchista",
    "focused-task-close-account.deactivate-account": "Konto deaktiveerimine",
    "focused-task-close-account.deactivate-account.overview.first.line.admin": "Oled keelamas kontot, mis kuulub kasutajale:",
    "focused-task-close-account.deactivate-account.overview.first.line.self": "Oled keelamas kontot, mis kuulub kasutajale:",
    "focused-task-close-account.deactivate-account.overview.heading.admin": "Keela konto",
    "focused-task-close-account.deactivate-account.overview.heading.self": "Keela konto",
    "focused-task-close-account.deactivate-account.overview.last.line.admin": "V\xf5id kontot igal ajal lubada.",
    "focused-task-close-account.deactivate-account.overview.last.line.self": "V\xf5id kontot igal ajal lubada.",
    "focused-task-close-account.deactivate-account.overview.paragraph.about-to-deactivate.admin": "Konto keelamisel:",
    "focused-task-close-account.deactivate-account.overview.paragraph.about-to-deactivate.self": "Konto keelamisel:",
    "focused-task-close-account.deactivate-account.overview.paragraph.billing.admin": "Me ei esita nende eest enam arvet",
    "focused-task-close-account.deactivate-account.overview.paragraph.billing.self": "Me ei esita nende eest enam arvet",
    "focused-task-close-account.deactivate-account.overview.paragraph.loseAccess.admin": "{fullName} <b>kaotab ligip\xe4\xe4su kohe</b> k\xf5ikidele Atlassiani konto teenustele. Hetkel on tal ligip\xe4\xe4s:",
    "focused-task-close-account.deactivate-account.overview.paragraph.loseAccess.admin.noSites": "{fullName} <b>kaotab ligip\xe4\xe4su kohe</b> k\xf5ikidele Atlassiani konto teenustele. Hetkel on neil ligip\xe4\xe4s ainult Community-le ja Marketplace'le.",
    "focused-task-close-account.deactivate-account.overview.paragraph.loseAccess.footnote": "Muud Atlassiani konto teenused nagu Atlassian Community ja Marketplace.",
    "focused-task-close-account.deactivate-account.overview.paragraph.loseAccess.self": "<b>kaotad ligip\xe4\xe4su kohe</b> k\xf5ikidele Atlassiani teenustele. Hetkel p\xe4\xe4sed ligi:",
    "focused-task-close-account.deactivate-account.overview.paragraph.loseAccess.self.noSites": "<b>kaotad ligip\xe4\xe4su kohe</b> k\xf5ikidele Atlassiani teenustele. Hetkel p\xe4\xe4sed ligi ainult Community-le ja Marketplace-le.",
    "focused-task-close-account.deactivate-account.overview.paragraph.personal-data.admin": "Nende isiklikud andmed nagu t\xe4isnimi ja e-posti aadress ning nende loodud sisu j\xe4\xe4vad Atlassiani konto teenustesse.",
    "focused-task-close-account.deactivate-account.overview.paragraph.personal-data.self": "Nende isiklikud andmed nagu t\xe4isnimi ja e-posti aadress ning nende loodud sisu j\xe4\xe4vad Atlassiani konto teenustesse.",
    "focused-task-close-account.delete-account": "Kustuta konto",
    "focused-task-close-account.delete-account.content-preview.footnote.admin": "M\xe4rkus: sellele k\xfcsimustikule vastamine aitab meil parandada k\xf5igi kasutajate kogemust. P\xe4rast kasutaja konto kustutamist esitletakse teda ikka endise kasutajana.",
    "focused-task-close-account.delete-account.content-preview.footnote.self": "M\xe4rkus: sellele k\xfcsimustikule vastamine aitab meil parandada k\xf5igi, ka oma konto kustutanud, kasutajate kogemust. P\xe4rast oma konto kustutamist esitletakse sind ikka endise kasutajana.",
    "focused-task-close-account.delete-account.content-preview.formerUser": "Endine kasutaja",
    "focused-task-close-account.delete-account.content-preview.heading.admin": "Kuidas eelistad esitleda kustutatud kasutajat?",
    "focused-task-close-account.delete-account.content-preview.heading.self": "Kuidas eelistad esitleda oma kustutatud kontot?",
    "focused-task-close-account.delete-account.content-preview.line.survey.admin": "Kui annaksime valida, siis kuidas soovite esitleda kustutatud kasutajat teistele kasutajatele?",
    "focused-task-close-account.delete-account.content-preview.line.survey.self": "Kui annaksime valida, siis kuidas soovid end esitleda teistele kasutajatele?",
    "focused-task-close-account.delete-account.content-preview.paragraph.survey.admin": "P\xe4rast kasutaja konto kustutamist esitletakse teda teistele kasutajatele endise kasutajana. Palun leia hetk vastata meie k\xfcsimustiku k\xfcsimusele.",
    "focused-task-close-account.delete-account.content-preview.paragraph.survey.self": "P\xe4rast sinu konto kustutamist esitletakse sind teistele kasutajatele endise kasutajana. Palun leia hetk vastata meie k\xfcsimustiku k\xfcsimusele.",
    "focused-task-close-account.delete-account.drop-down-collapse-button": "N\xe4ita v\xe4hem",
    "focused-task-close-account.delete-account.drop-down-expand-button": "veel {num}",
    "focused-task-close-account.delete-account.overview.first.line.admin": "Oled kustutamas kontot, mis kuulub:",
    "focused-task-close-account.delete-account.overview.first.line.self": "Oled kustutamas oma kontot:",
    "focused-task-close-account.delete-account.overview.heading.admin": "Kustuta konto",
    "focused-task-close-account.delete-account.overview.heading.self": "Kustuta oma konto",
    "focused-task-close-account.delete-account.overview.inline-dialog.content-created.admin": "N\xe4iteks toodetes loodud lehed, probleemid ja arvustused.",
    "focused-task-close-account.delete-account.overview.inline-dialog.content-created.self": "N\xe4iteks toodetes loodud lehed, probleemid ja arvustused.",
    "focused-task-close-account.delete-account.overview.inline-dialog.data-apps.admin": "Sina v\xf5i muud kasutajad v\xf5ivad olla paigaldanud rakendusi, mis lisavad Atlassiani toodetele funktsioone. Need rakendused v\xf5isid s\xe4ilitada kasutajate profiiliteavet.",
    "focused-task-close-account.delete-account.overview.inline-dialog.data-apps.self": "Sina v\xf5i muud kasutajad v\xf5ivad olla paigaldanud rakendusi, mis lisavad Atlassiani toodetele funktsioone. Need rakendused v\xf5isid s\xe4ilitada sinu profiiliteavet.",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.li1.admin": "Ostudega seotud teave, mida oleme kohustatud s\xe4ilitama finantsaruandluse jaoks.",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.li1.self": "Ostudega seotud teave, mida oleme kohustatud s\xe4ilitama finantsaruandluse jaoks.",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.li2.admin": "Andmed, mis n\xe4itavad, et oleme kustutanud kellegi konto, mille peame esitama ametiasutustele.",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.li2.self": "Andmed, mis n\xe4itavad, et oleme kustutanud kellegi konto, mille peame esitama ametiasutustele.",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.li3.admin": "K\xe4imasoleva juurdluse andmed, mida oleme kohustatud s\xe4ilitama vastavalt seadusele.",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.li3.self": "K\xe4imasoleva juurdluse andmed, mida oleme kohustatud s\xe4ilitama vastavalt seadusele.",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.p1.admin": "S\xe4ilitame isiklikud andmed teatud ajaks, kui seda n\xf5uab seaduslik \xe4ri v\xf5i seadus. Sellisteks juhtudeks v\xf5ib olla:",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.p1.self": "S\xe4ilitame isiklikud andmed teatud ajaks, kui seda n\xf5uab seaduslik \xe4ri v\xf5i seadus. Sellisteks juhtudeks v\xf5ib olla:",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.p2.admin": "Me ei kustuta kasutajate loodud sisust mistahes isiklikke andmeid nagu nimed v\xf5i e-posti aadressid, mida nad kirjutasid lehele v\xf5i probleemi. Toote adminid peavad kustutama need andmed k\xe4sitsi.",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.p2.self": "Me ei kustuta kasutajate loodud sisust mistahes isiklikke andmeid nagu nimed v\xf5i e-posti aadressid, mida nad kirjutasid lehele v\xf5i probleemi. Toote adminid peavad kustutama need andmed k\xe4sitsi.",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.p3.admin": "Kasutajatel on \xf5igus esitada oma s\xfcnniriigi j\xe4relevalveasutusele kaebuseid.",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.p3.self": "Sul on \xf5igus esitada oma s\xfcnniriigi j\xe4relevalveasutusele kaebuseid.",
    "focused-task-close-account.delete-account.overview.paragraph.about-to-delete.admin": "Konto kustutamisel:",
    "focused-task-close-account.delete-account.overview.paragraph.about-to-delete.self": "Oma konto kustutamisel:",
    "focused-task-close-account.delete-account.overview.paragraph.content-created.admin": "Nende loodud sisu s\xe4ilib Atlassiani konto teenustes.",
    "focused-task-close-account.delete-account.overview.paragraph.content-created.self": "SInu loodud sisu s\xe4ilib Atlassiani konto teenustes.",
    "focused-task-close-account.delete-account.overview.paragraph.grace-period.admin": "P\xe4rast 14 p\xe4evast lisaaega ei saa konto kustutamist t\xfchistada.",
    "focused-task-close-account.delete-account.overview.paragraph.list-of-apps-with-personal-data.admin": "Saadame e-kirja, kus loendame rakendusi, mis v\xf5ivad hoiustada nende isiklikke andmeid.",
    "focused-task-close-account.delete-account.overview.paragraph.list-of-apps-with-personal-data.self": "Saadame e-kirja, kus loendame rakendusi, mis v\xf5ivad hoiustada sinu isiklikke andmeid.",
    "focused-task-close-account.delete-account.overview.paragraph.loseAccess.admin": "{fullName} <b>kaotab ligip\xe4\xe4su kohe</b> k\xf5ikidele Atlassiani konto teenustele. Hetkel on tal ligip\xe4\xe4s:",
    "focused-task-close-account.delete-account.overview.paragraph.loseAccess.admin.noSites": "{fullName} <b>kaotab ligip\xe4\xe4su kohe</b> k\xf5ikidele Atlassiani konto teenustele. Hetkel on neil ligip\xe4\xe4s ainult Community-le ja Marketplace'le.",
    "focused-task-close-account.delete-account.overview.paragraph.loseAccess.footnote": "Muud Atlassiani konto teenused nagu Atlassian Community ja Marketplace.",
    "focused-task-close-account.delete-account.overview.paragraph.loseAccess.self": "<b>Kaotad ligip\xe4\xe4su kohe</b> k\xf5ikidele Atlassiani teenustele. Hetkel p\xe4\xe4sed ligi:",
    "focused-task-close-account.delete-account.overview.paragraph.loseAccess.self.noSites": "<b>Kaotad ligip\xe4\xe4su kohe</b> k\xf5ikidele Atlassiani teenustele. Hetkel p\xe4\xe4sed ligi ainult Community-le ja Marketplace-le.",
    "focused-task-close-account.delete-account.overview.paragraph.personal-data-will-be-deleted.admin": "<b>Kustutame nende isiklikud andmed</b> nagu t\xe4isnimi ja e-posti aadressi Atlassiani konto teenustest 30 p\xe4eva jooksul, va paaril juhul, kui seda n\xf5uab seaduslik \xe4ritegevus v\xf5i seadus.",
    "focused-task-close-account.delete-account.overview.paragraph.personal-data-will-be-deleted.self": "<b>Kustutame sinu isiklikud andmed</b> nagu t\xe4isnimi ja e-posti aadressi Atlassiani konto teenustest 30 p\xe4eva jooksul, va paaril juhul, kui seda n\xf5uab seaduslik \xe4ritegevus v\xf5i seadus.",
    "focused-task-close-account.delete-account.overview.warning-section.body": "P\xe4rast 14 p\xe4evast lisaaaega ei saa konto kustutamist enam t\xfchistada. Kui arvad, et kontot l\xe4heb hiljem vaja, siis hoopis deaktiveeri see.",
    "focused-task-close-account.delete-account.overview.warning-section.deactivated.body": "P\xe4rast 14 p\xe4evast lisaaega ei saa konto kustutamist t\xfchistada.",
    "focused-task-close-account.learnMore": "Lisateave",
    "focused-task-close-account.next": "Edasi",
    "focused-task-close-account.previous": "Tagasi"
};

});

parcelRegister("h8EpX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c7a2891b2e2f0057$export$2e2bcd8739ae039; });
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Finnish
var $c7a2891b2e2f0057$export$2e2bcd8739ae039 = {
    "focused-task-close-account.cancel": "Peruuta",
    "focused-task-close-account.deactivate-account": "Poista tili k\xe4yt\xf6st\xe4",
    "focused-task-close-account.deactivate-account.overview.first.line.admin": "Olet poistamassa k\xe4yt\xf6st\xe4 seuraavan henkil\xf6n tilin:",
    "focused-task-close-account.deactivate-account.overview.first.line.self": "Olet poistamassa k\xe4yt\xf6st\xe4 seuraavan henkil\xf6n tilin:",
    "focused-task-close-account.deactivate-account.overview.heading.admin": "Poista tili k\xe4yt\xf6st\xe4",
    "focused-task-close-account.deactivate-account.overview.heading.self": "Poista tili k\xe4yt\xf6st\xe4",
    "focused-task-close-account.deactivate-account.overview.last.line.admin": "Voit ottaa tilin uudelleen k\xe4ytt\xf6\xf6n milloin tahansa.",
    "focused-task-close-account.deactivate-account.overview.last.line.self": "Voit ottaa tilin uudelleen k\xe4ytt\xf6\xf6n milloin tahansa.",
    "focused-task-close-account.deactivate-account.overview.paragraph.about-to-deactivate.admin": "Kun poistat tilin k\xe4yt\xf6st\xe4 tapahtuu seuraavaa:",
    "focused-task-close-account.deactivate-account.overview.paragraph.about-to-deactivate.self": "Kun poistat tilin k\xe4yt\xf6st\xe4 tapahtuu seuraavaa:",
    "focused-task-close-account.deactivate-account.overview.paragraph.billing.admin": "Emme en\xe4\xe4 laskuta sinua h\xe4nest\xe4.",
    "focused-task-close-account.deactivate-account.overview.paragraph.billing.self": "Emme en\xe4\xe4 laskuta sinua h\xe4nest\xe4.",
    "focused-task-close-account.deactivate-account.overview.paragraph.loseAccess.admin": "{fullName} <b>menett\xe4\xe4 heti p\xe4\xe4syn</b> kaikkiin Atlassian-tilipalveluihin. T\xe4ll\xe4 hetkell\xe4 h\xe4nell\xe4 on p\xe4\xe4sy seuraaviin kohteisiin:",
    "focused-task-close-account.deactivate-account.overview.paragraph.loseAccess.admin.noSites": "{fullName} <b>menett\xe4\xe4 heti p\xe4\xe4syn</b> kaikkiin Atlassian-tilipalveluihin. T\xe4ll\xe4 hetkell\xe4 h\xe4nell\xe4 ei ole p\xe4\xe4sy\xe4 mihink\xe4\xe4n palveluihin, paitsi Yhteis\xf6n ja Marketplacen kaltaisiin palveluihin.",
    "focused-task-close-account.deactivate-account.overview.paragraph.loseAccess.footnote": "Muut Atlassian-tilipalvelut, kuten Atlassian-Yhteis\xf6 ja Marketplace.",
    "focused-task-close-account.deactivate-account.overview.paragraph.loseAccess.self": "Menet\xe4t <b>heti p\xe4\xe4syn</b> kaikkiin Atlassian-tilipalveluihin. T\xe4ll\xe4 hetkell\xe4 sinulla on p\xe4\xe4sy seuraaviin kohteisiin:",
    "focused-task-close-account.deactivate-account.overview.paragraph.loseAccess.self.noSites": "Menet\xe4t <b>heti p\xe4\xe4syn</b> kaikkiin Atlassian-tilipalveluihin. T\xe4ll\xe4 hetkell\xe4 sinulla ei ole p\xe4\xe4sy\xe4 mihink\xe4\xe4n palveluihin, paitsi Yhteis\xf6n ja Marketplacen kaltaisiin palveluihin.",
    "focused-task-close-account.deactivate-account.overview.paragraph.personal-data.admin": "H\xe4nen henkil\xf6tietonsa, kuten h\xe4nen koko nimens\xe4 ja s\xe4hk\xf6postiosoitteensa, sek\xe4 h\xe4nen luomansa sis\xe4lt\xf6 pysyv\xe4t Atlassian-tilipalveluissa.",
    "focused-task-close-account.deactivate-account.overview.paragraph.personal-data.self": "H\xe4nen henkil\xf6tietonsa, kuten h\xe4nen koko nimens\xe4 ja s\xe4hk\xf6postiosoitteensa, sek\xe4 h\xe4nen luomansa sis\xe4lt\xf6 pysyv\xe4t Atlassian-tilipalveluissa.",
    "focused-task-close-account.delete-account": "Poista tili",
    "focused-task-close-account.delete-account.content-preview.footnote.admin": 'Huomaa: Vastaamalla t\xe4h\xe4n kyselyyn autat meit\xe4 luomaan paremman kokemuksen kaikille k\xe4ytt\xe4jille. K\xe4ytt\xe4j\xe4 n\xe4kyy edelleen "Entisen\xe4 k\xe4ytt\xe4j\xe4n\xe4" sen j\xe4lkeen, kun olet poistanut h\xe4nen tilins\xe4.',
    "focused-task-close-account.delete-account.content-preview.footnote.self": 'Huomaa: Vastaamalla t\xe4h\xe4n kyselyyn autat meit\xe4 luomaan paremman kokemuksen kaikille k\xe4ytt\xe4jille, my\xf6s niille, jotka ovat poistamassa tilins\xe4. N\xe4yt edelleen "Entisen\xe4 k\xe4ytt\xe4j\xe4n\xe4" sen j\xe4lkeen, kun olet poistanut tilisi.',
    "focused-task-close-account.delete-account.content-preview.formerUser": "Entinen k\xe4ytt\xe4j\xe4",
    "focused-task-close-account.delete-account.content-preview.heading.admin": "Milt\xe4 haluat poistetun k\xe4ytt\xe4j\xe4n n\xe4ytt\xe4v\xe4n?",
    "focused-task-close-account.delete-account.content-preview.heading.self": "Milt\xe4 haluat poistetun tilisi n\xe4ytt\xe4v\xe4n?",
    "focused-task-close-account.delete-account.content-preview.line.survey.admin": "Jos saisit valita, milt\xe4 haluaisit poistetun k\xe4ytt\xe4j\xe4n n\xe4ytt\xe4v\xe4n muille k\xe4ytt\xe4jille?",
    "focused-task-close-account.delete-account.content-preview.line.survey.self": "Jos saisit valita, miten haluaisit n\xe4ky\xe4 muille k\xe4ytt\xe4jille?",
    "focused-task-close-account.delete-account.content-preview.paragraph.survey.admin": 'Sen j\xe4lkeen, kun k\xe4ytt\xe4j\xe4n tili on poistettu, h\xe4n n\xe4kyy "Entisen\xe4 k\xe4ytt\xe4j\xe4n\xe4" muille k\xe4ytt\xe4jille. K\xe4yt\xe4 hetki kyselymme kysymykseen vastaamiseen.',
    "focused-task-close-account.delete-account.content-preview.paragraph.survey.self": 'Sen j\xe4lkeen, kun tilisi on poistettu, n\xe4yt "Entisen\xe4 k\xe4ytt\xe4j\xe4n\xe4" muille k\xe4ytt\xe4jille. K\xe4yt\xe4 hetki kyselymme kysymykseen vastaamiseen.',
    "focused-task-close-account.delete-account.drop-down-collapse-button": "N\xe4yt\xe4 v\xe4hemm\xe4n",
    "focused-task-close-account.delete-account.drop-down-expand-button": "{num} lis\xe4\xe4",
    "focused-task-close-account.delete-account.overview.first.line.admin": "Olet poistamassa seuraavan henkil\xf6n tilin:",
    "focused-task-close-account.delete-account.overview.first.line.self": "Olet poistamassa tilisi:",
    "focused-task-close-account.delete-account.overview.heading.admin": "Poista tili",
    "focused-task-close-account.delete-account.overview.heading.self": "Poista tilisi",
    "focused-task-close-account.delete-account.overview.inline-dialog.content-created.admin": "Esimerkiksi, sivut, asiat ja kommentit, jotka h\xe4n on luonut tuotteissa.",
    "focused-task-close-account.delete-account.overview.inline-dialog.content-created.self": "Esimerkiksi, sivut, asiat ja kommentit, jotka olet luonut tuotteissa.",
    "focused-task-close-account.delete-account.overview.inline-dialog.data-apps.admin": "Sin\xe4 tai muut k\xe4ytt\xe4j\xe4t olette ehk\xe4 asentaneet sovelluksia, jotka lis\xe4\xe4v\xe4t ominaisuuksia Atlassian-tuotteisiin. N\xe4m\xe4 sovellukset ovat saattaneet tallentaa k\xe4ytt\xe4j\xe4n profiilitietoja.",
    "focused-task-close-account.delete-account.overview.inline-dialog.data-apps.self": "Sin\xe4 tai muut k\xe4ytt\xe4j\xe4t olette ehk\xe4 asentaneet sovelluksia, jotka lis\xe4\xe4v\xe4t ominaisuuksia Atlassian-tuotteisiin. N\xe4m\xe4 sovellukset ovat saattaneet tallentaa sinun profiilitietojasi.",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.li1.admin": "Ostoksiin liittyv\xe4t tiedot, jotka meid\xe4n tulee s\xe4ilytt\xe4\xe4 talousraportteja varten.",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.li1.self": "Ostoksiin liittyv\xe4t tiedot, jotka meid\xe4n tulee s\xe4ilytt\xe4\xe4 talousraportteja varten.",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.li2.admin": "Kirjanpidossa n\xe4kyy, ett\xe4 poistimme jonkun henkil\xf6n tilin, ja meid\xe4n tulee ehk\xe4 todistaa t\xe4m\xe4 valvojille.",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.li2.self": "Kirjanpidossa n\xe4kyy, ett\xe4 poistimme jonkun henkil\xf6n tilin, ja meid\xe4n tulee ehk\xe4 todistaa t\xe4m\xe4 valvojille.",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.li3.admin": "K\xe4ynniss\xe4 olevaan oikeusjuttuun liittyv\xe4t tiedot, joita meid\xe4n tulee s\xe4ilytt\xe4\xe4 lain mukaan.",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.li3.self": "K\xe4ynniss\xe4 olevaan oikeusjuttuun liittyv\xe4t tiedot, joita meid\xe4n tulee s\xe4ilytt\xe4\xe4 lain mukaan.",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.p1.admin": "S\xe4ilyt\xe4mme henkil\xf6tietoja rajoitetun ajanjakson ajan laillisia liiketoiminnallisia tai oikeudellisia tarkoituksia varten. Esimerkkej\xe4 n\xe4ist\xe4:",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.p1.self": "S\xe4ilyt\xe4mme henkil\xf6tietoja rajoitetun ajanjakson ajan laillisia liiketoiminnallisia tai oikeudellisia tarkoituksia varten. Esimerkkej\xe4 n\xe4ist\xe4:",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.p2.admin": "Emme poista mit\xe4\xe4n henkil\xf6tietoja k\xe4ytt\xe4jien luomasta sis\xe4ll\xf6st\xe4, kuten nimi\xe4 tai s\xe4hk\xf6postiosoitteita, joita he kirjoittivat sivulle tai asiaan. Tuotteen p\xe4\xe4k\xe4ytt\xe4jien tulee poistaa n\xe4m\xe4 tiedot manuaalisesti.",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.p2.self": "Emme poista mit\xe4\xe4n henkil\xf6tietoja sinun tai muiden luomasta sis\xe4ll\xf6st\xe4, kuten nimi\xe4 tai s\xe4hk\xf6postiosoitteita, joita he kirjoittivat sivulle tai asiaan. Tuotteen p\xe4\xe4k\xe4ytt\xe4jiesi tulee poistaa n\xe4m\xe4 tiedot manuaalisesti.",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.p3.admin": "K\xe4ytt\xe4jill\xe4 on oikeus j\xe4tt\xe4\xe4 valituksia maansa valvontaviranomaisille.",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.p3.self": "Sinulla on oikeus j\xe4tt\xe4\xe4 valituksia maasi valvontaviranomaisille.",
    "focused-task-close-account.delete-account.overview.paragraph.about-to-delete.admin": "Kun poistat tilin tapahtuu seuraavaa:",
    "focused-task-close-account.delete-account.overview.paragraph.about-to-delete.self": "Kun poistat tilisi tapahtuu seuraavaa:",
    "focused-task-close-account.delete-account.overview.paragraph.content-created.admin": "H\xe4nen luomansa sis\xe4lt\xf6 pysyy Atlassian-tilipalveluissa.",
    "focused-task-close-account.delete-account.overview.paragraph.content-created.self": "Luomasi sis\xe4lt\xf6 pysyy Atlassian-tilipalveluissa.",
    "focused-task-close-account.delete-account.overview.paragraph.grace-period.admin": "14 p\xe4iv\xe4n lis\xe4ajan j\xe4lkeen et voi peruuttaa tilin poistamista.",
    "focused-task-close-account.delete-account.overview.paragraph.list-of-apps-with-personal-data.admin": "L\xe4het\xe4mme sinulle s\xe4hk\xf6postitse luettelon sovelluksista, jotka ovat saattaneet tallentaa h\xe4nen henkil\xf6tietojaan.",
    "focused-task-close-account.delete-account.overview.paragraph.list-of-apps-with-personal-data.self": "L\xe4het\xe4mme sinulle s\xe4hk\xf6postitse luettelon sovelluksista, jotka ovat saattaneet tallentaa sinun henkil\xf6tietojasi.",
    "focused-task-close-account.delete-account.overview.paragraph.loseAccess.admin": "{fullName} <b>menett\xe4\xe4 heti p\xe4\xe4syn</b> kaikkiin Atlassian-tilipalveluihin. T\xe4ll\xe4 hetkell\xe4 h\xe4nell\xe4 on p\xe4\xe4sy seuraaviin kohteisiin:",
    "focused-task-close-account.delete-account.overview.paragraph.loseAccess.admin.noSites": "{fullName} <b>menett\xe4\xe4 heti p\xe4\xe4syn</b> kaikkiin Atlassian-tilipalveluihin. T\xe4ll\xe4 hetkell\xe4 h\xe4nell\xe4 ei ole p\xe4\xe4sy\xe4 mihink\xe4\xe4n palveluihin, paitsi Yhteis\xf6n ja Marketplacen kaltaisiin palveluihin.",
    "focused-task-close-account.delete-account.overview.paragraph.loseAccess.footnote": "Muut Atlassian-tilipalvelut, kuten Atlassian-Yhteis\xf6 ja Marketplace.",
    "focused-task-close-account.delete-account.overview.paragraph.loseAccess.self": "Menet\xe4t <b>heti p\xe4\xe4syn</b> kaikkiin Atlassian-tilipalveluihin. T\xe4ll\xe4 hetkell\xe4 sinulla on p\xe4\xe4sy seuraaviin kohteisiin:",
    "focused-task-close-account.delete-account.overview.paragraph.loseAccess.self.noSites": "Menet\xe4t <b>heti p\xe4\xe4syn</b> kaikkiin Atlassian-tilipalveluihin. T\xe4ll\xe4 hetkell\xe4 sinulla ei ole p\xe4\xe4sy\xe4 mihink\xe4\xe4n palveluihin, paitsi Yhteis\xf6n ja Marketplacen kaltaisiin palveluihin.",
    "focused-task-close-account.delete-account.overview.paragraph.personal-data-will-be-deleted.admin": "Poistamme <b>h\xe4nen henkil\xf6tietonsa</b>, kuten koko nimen ja s\xe4hk\xf6postiosoitteen, Atlassian-tilipalveluista 30 p\xe4iv\xe4n sis\xe4ll\xe4, paitsi muutamassa tapauksessa, kun niit\xe4 tarvitaan laillisiin liiketoiminnallisiin tai oikeudellisiin tarkoituksiin.",
    "focused-task-close-account.delete-account.overview.paragraph.personal-data-will-be-deleted.self": "Poistamme <b>henkil\xf6tietosi</b>, kuten koko nimesi ja s\xe4hk\xf6postiosoitteesi, Atlassian-tilipalveluista 30 p\xe4iv\xe4n sis\xe4ll\xe4, paitsi muutamassa tapauksessa, kun niit\xe4 tarvitaan laillisiin liiketoiminnallisiin tai oikeudellisiin tarkoituksiin.",
    "focused-task-close-account.delete-account.overview.warning-section.body": "14 p\xe4iv\xe4n lis\xe4ajan j\xe4lkeen et voi peruuttaa tilin poistamista. Jos luulet, ett\xe4 tarvitset tili\xe4 my\xf6hemmin, poista se sen sijaan k\xe4yt\xf6st\xe4.",
    "focused-task-close-account.delete-account.overview.warning-section.deactivated.body": "14 p\xe4iv\xe4n lis\xe4ajan j\xe4lkeen et voi peruuttaa tilin poistamista.",
    "focused-task-close-account.learnMore": "Lue lis\xe4\xe4",
    "focused-task-close-account.next": "Seuraava",
    "focused-task-close-account.previous": "Edellinen"
};

});

parcelRegister("4kzoy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $32747c6401dfa359$export$2e2bcd8739ae039; });
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //French (France)
var $32747c6401dfa359$export$2e2bcd8739ae039 = {
    "focused-task-close-account.cancel": "Annuler",
    "focused-task-close-account.deactivate-account": "D\xe9sactiver le compte",
    "focused-task-close-account.deactivate-account.overview.first.line.admin": "Vous \xeates sur le point de d\xe9sactiver le compte utilisateur de\xa0:",
    "focused-task-close-account.deactivate-account.overview.first.line.self": "Vous \xeates sur le point de d\xe9sactiver le compte utilisateur de\xa0:",
    "focused-task-close-account.deactivate-account.overview.heading.admin": "D\xe9sactiver le compte",
    "focused-task-close-account.deactivate-account.overview.heading.self": "D\xe9sactiver le compte",
    "focused-task-close-account.deactivate-account.overview.last.line.admin": "Vous pouvez r\xe9activer le compte \xe0 tout moment.",
    "focused-task-close-account.deactivate-account.overview.last.line.self": "Vous pouvez r\xe9activer le compte \xe0 tout moment.",
    "focused-task-close-account.deactivate-account.overview.paragraph.about-to-deactivate.admin": "Lorsque vous d\xe9sactivez le compte\xa0:",
    "focused-task-close-account.deactivate-account.overview.paragraph.about-to-deactivate.self": "Lorsque vous d\xe9sactivez votre compte\xa0:",
    "focused-task-close-account.deactivate-account.overview.paragraph.billing.admin": "Il ne vous sera plus factur\xe9.",
    "focused-task-close-account.deactivate-account.overview.paragraph.billing.self": "Il ne vous sera plus factur\xe9.",
    "focused-task-close-account.deactivate-account.overview.paragraph.loseAccess.admin": "{fullName} <b>perdra imm\xe9diatement l'acc\xe8s</b> \xe0 tous les services de compte Atlassian. Cet utilisateur a actuellement acc\xe8s \xe0\xa0:",
    "focused-task-close-account.deactivate-account.overview.paragraph.loseAccess.admin.noSites": "{fullName} <b>perdra imm\xe9diatement l'acc\xe8s</b> \xe0 tous les services de compte Atlassian. Cet utilisateur a pour le moment seulement acc\xe8s \xe0 des services comme Community et Marketplace.",
    "focused-task-close-account.deactivate-account.overview.paragraph.loseAccess.footnote": "Autres services de compte Atlassian, comme Atlassian\xa0Community et Marketplace.",
    "focused-task-close-account.deactivate-account.overview.paragraph.loseAccess.self": "Vous <b>perdrez imm\xe9diatement l'acc\xe8s</b> \xe0 tous les services de compte Atlassian. Vous avez actuellement acc\xe8s \xe0\xa0:",
    "focused-task-close-account.deactivate-account.overview.paragraph.loseAccess.self.noSites": "Vous <b>perdrez imm\xe9diatement l'acc\xe8s</b> \xe0 tous les services de compte Atlassian. Vous avez pour le moment seulement acc\xe8s \xe0 des services comme Community et Marketplace.",
    "focused-task-close-account.deactivate-account.overview.paragraph.personal-data.admin": "Ses donn\xe9es personnelles, comme son nom complet et son adresse e-mail, ainsi que son contenu cr\xe9\xe9 seront toujours disponibles dans les services de compte Atlassian.",
    "focused-task-close-account.deactivate-account.overview.paragraph.personal-data.self": "Ses donn\xe9es personnelles, comme son nom complet et son adresse e-mail, ainsi que son contenu cr\xe9\xe9 seront toujours disponibles dans les services de compte Atlassian.",
    "focused-task-close-account.delete-account": "Supprimer le compte",
    "focused-task-close-account.delete-account.content-preview.footnote.admin": "Remarque\xa0: R\xe9pondez \xe0 cette enqu\xeate pour nous permettre de proposer une meilleure exp\xe9rience \xe0 tous les utilisateurs. L'utilisateur appara\xeetra toujours comme \xab\xa0Ancien utilisateur\xa0\xbb apr\xe8s la suppression de son compte.",
    "focused-task-close-account.delete-account.content-preview.footnote.self": "Remarque\xa0: R\xe9pondez \xe0 cette enqu\xeate pour nous permettre de proposer une meilleure exp\xe9rience \xe0 tous les utilisateurs, y compris ceux qui suppriment leur compte. Vous appara\xeetrez toujours comme \xab\xa0Ancien utilisateur\xa0\xbb apr\xe8s la suppression de votre compte.",
    "focused-task-close-account.delete-account.content-preview.formerUser": "Ancien utilisateur",
    "focused-task-close-account.delete-account.content-preview.heading.admin": "Comment souhaiteriez-vous afficher l'utilisateur supprim\xe9\xa0?",
    "focused-task-close-account.delete-account.content-preview.heading.self": "Comment souhaiteriez-vous afficher votre compte supprim\xe9\xa0?",
    "focused-task-close-account.delete-account.content-preview.line.survey.admin": "Si vous aviez le choix, comment souhaiteriez-vous afficher l'utilisateur supprim\xe9\xa0?",
    "focused-task-close-account.delete-account.content-preview.line.survey.self": "Si vous aviez le choix, comment souhaiteriez-vous appara\xeetre aux autres utilisateurs\xa0?",
    "focused-task-close-account.delete-account.content-preview.paragraph.survey.admin": "Apr\xe8s la suppression du compte de l'utilisateur, il appara\xeet comme \xab\xa0Ancien utilisateur\xa0\xbb. Prenez un moment pour r\xe9pondre \xe0 notre question d'enqu\xeate.",
    "focused-task-close-account.delete-account.content-preview.paragraph.survey.self": "Une fois votre compte supprim\xe9, vous apparaissez comme \xab\xa0Ancien utilisateur\xa0\xbb. Prenez un moment pour r\xe9pondre \xe0 notre question d'enqu\xeate.",
    "focused-task-close-account.delete-account.drop-down-collapse-button": "Afficher moins",
    "focused-task-close-account.delete-account.drop-down-expand-button": "{num}\xa0autres",
    "focused-task-close-account.delete-account.overview.first.line.admin": "Vous \xeates sur le point de supprimer le compte de\xa0:",
    "focused-task-close-account.delete-account.overview.first.line.self": "Vous \xeates sur le point de supprimer votre compte\xa0:",
    "focused-task-close-account.delete-account.overview.heading.admin": "Supprimer le compte",
    "focused-task-close-account.delete-account.overview.heading.self": "Supprimer votre compte",
    "focused-task-close-account.delete-account.overview.inline-dialog.content-created.admin": "Par exemple, les pages, les tickets et les commentaires qu'il a cr\xe9\xe9s dans les produits.",
    "focused-task-close-account.delete-account.overview.inline-dialog.content-created.self": "Par exemple, les pages, les tickets et les commentaires que vous avez cr\xe9\xe9s dans les produits.",
    "focused-task-close-account.delete-account.overview.inline-dialog.data-apps.admin": "Vous ou d'autres utilisateurs avez pu installer des applications permettant d'ajouter des fonctionnalit\xe9s aux produits Atlassian. Ces applications ont pu enregistrer les informations du profil de l'utilisateur.",
    "focused-task-close-account.delete-account.overview.inline-dialog.data-apps.self": "Vous ou d'autres utilisateurs avez pu installer des applications permettant d'ajouter des fonctionnalit\xe9s aux produits Atlassian. Ces applications ont pu conserver les informations de votre profil.",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.li1.admin": "Informations relatives aux achats que nous devons conserver pour l'\xe9tablissement des rapports financiers.",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.li1.self": "Informations relatives aux achats que nous devons conserver pour l'\xe9tablissement des rapports financiers.",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.li2.admin": "Enregistrements indiquant que nous avons supprim\xe9 le compte d'une personne (ils peuvent \xeatre demand\xe9s par les organismes de r\xe9glementation)",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.li2.self": "Enregistrements indiquant que nous avons supprim\xe9 le compte d'une personne (ils peuvent \xeatre demand\xe9s par les organismes de r\xe9glementation)",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.li3.admin": "Les donn\xe9es concern\xe9es par une poursuite active que nous sommes tenus de conserver en vertu de la loi.",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.li3.self": "Les donn\xe9es concern\xe9es par une poursuite active que nous sommes tenus de conserver en vertu de la loi.",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.p1.admin": "Nous conservons les donn\xe9es personnelles pendant une p\xe9riode limit\xe9e pour des raisons juridiques ou commerciales l\xe9gitimes. En voici quelques exemples\xa0:",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.p1.self": "Nous conservons les donn\xe9es personnelles pendant une p\xe9riode limit\xe9e pour des raisons juridiques ou commerciales l\xe9gitimes. En voici quelques exemples\xa0:",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.p2.admin": "Nous ne supprimons aucune donn\xe9e personnelle pour le contenu cr\xe9\xe9 par les utilisateurs, comme les noms ou les adresses e-mail saisis dans une page ou un ticket. Les administrateurs de produit doivent supprimer ces donn\xe9es manuellement.",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.p2.self": "Nous ne supprimons aucune donn\xe9e personnelle pour le contenu cr\xe9\xe9 par d'autres personnes ou par vous, comme les noms ou les adresses e-mail saisis dans une page ou un ticket. Les administrateurs de votre produit doivent supprimer ces donn\xe9es manuellement.",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.p3.admin": "Les utilisateurs peuvent d\xe9poser des r\xe9clamations aupr\xe8s des autorit\xe9s de surveillance de leur pays.",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.p3.self": "Vous pouvez d\xe9poser des r\xe9clamations aupr\xe8s des autorit\xe9s de surveillance de votre pays.",
    "focused-task-close-account.delete-account.overview.paragraph.about-to-delete.admin": "Lorsque vous supprimez le compte\xa0:",
    "focused-task-close-account.delete-account.overview.paragraph.about-to-delete.self": "Lorsque vous supprimez votre compte\xa0:",
    "focused-task-close-account.delete-account.overview.paragraph.content-created.admin": "Le contenu qu'il a cr\xe9\xe9 sera toujours disponible dans les services de compte Atlassian.",
    "focused-task-close-account.delete-account.overview.paragraph.content-created.self": "Le contenu que vous avez cr\xe9\xe9 sera toujours disponible dans les services de compte Atlassian.",
    "focused-task-close-account.delete-account.overview.paragraph.grace-period.admin": "Apr\xe8s un d\xe9lai de gr\xe2ce de 14\xa0jours, vous ne pourrez plus annuler la suppression du compte.",
    "focused-task-close-account.delete-account.overview.paragraph.list-of-apps-with-personal-data.admin": "Nous vous enverrons par e-mail une liste des applications qui ont pu conserver ses donn\xe9es personnelles.",
    "focused-task-close-account.delete-account.overview.paragraph.list-of-apps-with-personal-data.self": "Nous vous enverrons par e-mail une liste des applications qui ont pu conserver vos donn\xe9es personnelles.",
    "focused-task-close-account.delete-account.overview.paragraph.loseAccess.admin": "{fullName} <b>perdra imm\xe9diatement l'acc\xe8s</b> \xe0 tous les services de compte Atlassian. Cet utilisateur a actuellement acc\xe8s \xe0\xa0:",
    "focused-task-close-account.delete-account.overview.paragraph.loseAccess.admin.noSites": "{fullName} <b>perdra imm\xe9diatement l'acc\xe8s</b> \xe0 tous les services de compte Atlassian. Cet utilisateur a pour le moment seulement acc\xe8s \xe0 des services comme Community et Marketplace.",
    "focused-task-close-account.delete-account.overview.paragraph.loseAccess.footnote": "Autres services de compte Atlassian, comme Atlassian Community et Marketplace.",
    "focused-task-close-account.delete-account.overview.paragraph.loseAccess.self": "Vous <b>perdrez imm\xe9diatement l'acc\xe8s</b> \xe0 tous les services de compte Atlassian. Vous avez actuellement acc\xe8s \xe0\xa0:",
    "focused-task-close-account.delete-account.overview.paragraph.loseAccess.self.noSites": "Vous <b>perdrez imm\xe9diatement l'acc\xe8s</b> \xe0 tous les services de compte Atlassian. Vous avez pour le moment seulement acc\xe8s \xe0 des services comme Community et Marketplace.",
    "focused-task-close-account.delete-account.overview.paragraph.personal-data-will-be-deleted.admin": "Ses <b>donn\xe9es personnelles</b>, comme son nom complet et son adresse e-mail, seront supprim\xe9es des services de compte Atlassian dans les 30\xa0jours, sauf dans de rares cas lorsque des raisons juridiques ou commerciales l\xe9gitimes le requi\xe8rent.",
    "focused-task-close-account.delete-account.overview.paragraph.personal-data-will-be-deleted.self": "Vos <b>donn\xe9es personnelles</b>, comme votre nom complet et votre adresse e-mail, seront supprim\xe9es des services de compte Atlassian dans les 30\xa0jours, sauf dans de rares cas lorsque des raisons juridiques ou commerciales l\xe9gitimes le requi\xe8rent.",
    "focused-task-close-account.delete-account.overview.warning-section.body": "Apr\xe8s un d\xe9lai de gr\xe2ce de 14\xa0jours, vous ne pourrez plus annuler la suppression du compte. Si vous pensez avoir besoin de ce compte ult\xe9rieurement, il vaut mieux le d\xe9sactiver.",
    "focused-task-close-account.delete-account.overview.warning-section.deactivated.body": "Apr\xe8s un d\xe9lai de gr\xe2ce de 14\xa0jours, vous ne pourrez plus annuler la suppression du compte.",
    "focused-task-close-account.learnMore": "En savoir plus",
    "focused-task-close-account.next": "Suivant",
    "focused-task-close-account.previous": "Pr\xe9c\xe9dent"
};

});

parcelRegister("1tmaR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1129b3345281e2a6$export$2e2bcd8739ae039; });
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //German (Germany)
var $1129b3345281e2a6$export$2e2bcd8739ae039 = {
    "focused-task-close-account.cancel": "Abbrechen",
    "focused-task-close-account.deactivate-account": "Konto deaktivieren",
    "focused-task-close-account.deactivate-account.overview.first.line.admin": "Sie sind dabei, das Benutzerkonto zu l\xf6schen von:",
    "focused-task-close-account.deactivate-account.overview.first.line.self": "Sie sind dabei, das Benutzerkonto zu l\xf6schen von:",
    "focused-task-close-account.deactivate-account.overview.heading.admin": "Konto deaktivieren",
    "focused-task-close-account.deactivate-account.overview.heading.self": "Konto deaktivieren",
    "focused-task-close-account.deactivate-account.overview.last.line.admin": "Sie k\xf6nnen das Konto jederzeit reaktivieren.",
    "focused-task-close-account.deactivate-account.overview.last.line.self": "Sie k\xf6nnen das Konto jederzeit reaktivieren.",
    "focused-task-close-account.deactivate-account.overview.paragraph.about-to-deactivate.admin": "Wenn Sie das Konto deaktivieren:",
    "focused-task-close-account.deactivate-account.overview.paragraph.about-to-deactivate.self": "Wenn Sie das Konto deaktivieren:",
    "focused-task-close-account.deactivate-account.overview.paragraph.billing.admin": "F\xfcr diesen Benutzer wird Ihnen nichts mehr berechnet.",
    "focused-task-close-account.deactivate-account.overview.paragraph.billing.self": "F\xfcr diesen Benutzer wird Ihnen nichts mehr berechnet.",
    "focused-task-close-account.deactivate-account.overview.paragraph.loseAccess.admin": "{fullName} <b>verliert sofort den Zugriff</b> auf alle Atlassian-Kontoservices. Er/sie hat derzeit Zugriff auf:",
    "focused-task-close-account.deactivate-account.overview.paragraph.loseAccess.admin.noSites": "{fullName} <b>verliert sofort den Zugriff</b> auf alle Atlassian-Kontoservices. Derzeit hat er/sie ausschlie\xdflich Zugriff auf Services wie Community und Marketplace.",
    "focused-task-close-account.deactivate-account.overview.paragraph.loseAccess.footnote": "Andere Atlassian-Kontoservices, wie Atlassian Community und Marketplace.",
    "focused-task-close-account.deactivate-account.overview.paragraph.loseAccess.self": "Sie <b>verlieren sofort den Zugriff</b> auf alle Atlassian-Kontoservices. Sie haben derzeit Zugriff auf:",
    "focused-task-close-account.deactivate-account.overview.paragraph.loseAccess.self.noSites": "Sie <b>verlieren sofort den Zugriff</b> auf alle Atlassian-Kontoservices. Derzeit haben Sie ausschlie\xdflich Zugriff auf Services wie Community und Marketplace.",
    "focused-task-close-account.deactivate-account.overview.paragraph.personal-data.admin": "Die personenbezogenen Daten, wie der vollst\xe4ndige Name und die E-Mail-Adresse, und erstellte Inhalte bleiben in den Atlassian-Kontoservices bestehen.",
    "focused-task-close-account.deactivate-account.overview.paragraph.personal-data.self": "Die personenbezogenen Daten, wie der vollst\xe4ndige Name und die E-Mail-Adresse, und erstellte Inhalte bleiben in den Atlassian-Kontoservices bestehen.",
    "focused-task-close-account.delete-account": "Konto l\xf6schen",
    "focused-task-close-account.delete-account.content-preview.footnote.admin": "Hinweis: Wenn Sie an dieser Umfrage teilnehmen, k\xf6nnen wir die Benutzerfreundlichkeit f\xfcr alle verbessern. Wenn Sie sein Konto l\xf6schen, erscheint der Benutzer dennoch als \u201EEhemaliger Benutzer\u201C.",
    "focused-task-close-account.delete-account.content-preview.footnote.self": "Hinweis: Wenn Sie an dieser Umfrage teilnehmen, k\xf6nnen wir die Benutzerfreundlichkeit f\xfcr alle verbessern, auch f\xfcr diejenigen, die ihr Konto l\xf6schen. Wenn Sie Ihr Konto l\xf6schen, erscheinen Sie dennoch als \u201EEhemaliger Benutzer\u201C.",
    "focused-task-close-account.delete-account.content-preview.formerUser": "Ehemaliger Benutzer",
    "focused-task-close-account.delete-account.content-preview.heading.admin": "Wie sollte Ihrer Meinung nach der gel\xf6schte Benutzer angezeigt werden?",
    "focused-task-close-account.delete-account.content-preview.heading.self": "Wie sollte Ihrer Meinung nach Ihr gel\xf6schtes Konto angezeigt werden?",
    "focused-task-close-account.delete-account.content-preview.line.survey.admin": "Wenn Sie die Wahl h\xe4tten, wie sollte Ihrer Meinung nach der gel\xf6schte Benutzer f\xfcr andere Benutzer angezeigt werden?",
    "focused-task-close-account.delete-account.content-preview.line.survey.self": "Wenn Sie die Wahl h\xe4tten, wie sollten Sie Ihrer Meinung nach f\xfcr andere Benutzer angezeigt werden?",
    "focused-task-close-account.delete-account.content-preview.paragraph.survey.admin": "Nach der L\xf6schung des Kontos des Benutzers erscheint er f\xfcr andere Benutzer als \u201EEhemaliger Benutzer\u201C. Bitte nehmen Sie sich einen Moment Zeit, an unserer Umfrage teilzunehmen.",
    "focused-task-close-account.delete-account.content-preview.paragraph.survey.self": "Nach der L\xf6schung Ihres Kontos erscheinen Sie f\xfcr andere Benutzer als \u201EEhemaliger Benutzer\u201C. Bitte nehmen Sie sich einen Moment Zeit, an unserer Umfrage teilzunehmen.",
    "focused-task-close-account.delete-account.drop-down-collapse-button": "Weniger anzeigen",
    "focused-task-close-account.delete-account.drop-down-expand-button": "{num} weitere",
    "focused-task-close-account.delete-account.overview.first.line.admin": "Sie sind dabei, das Konto zu l\xf6schen von:",
    "focused-task-close-account.delete-account.overview.first.line.self": "Sie sind dabei, Ihr Konto zu l\xf6schen:",
    "focused-task-close-account.delete-account.overview.heading.admin": "Konto l\xf6schen",
    "focused-task-close-account.delete-account.overview.heading.self": "Ihr Konto l\xf6schen",
    "focused-task-close-account.delete-account.overview.inline-dialog.content-created.admin": "Zum Beispiel Seiten, Vorg\xe4nge und Kommentare, die in den Produkten erstellt wurden.",
    "focused-task-close-account.delete-account.overview.inline-dialog.content-created.self": "Zum Beispiel Seiten, Vorg\xe4nge und Kommentare, die Sie in den Produkten erstellt haben.",
    "focused-task-close-account.delete-account.overview.inline-dialog.data-apps.admin": "Sie und andere Benutzer haben ggf. installierte Apps, die Funktionen zu Atlassian-Produkten hinzuf\xfcgen. Diese Apps haben ggf. die Profilinformationen des Benutzers gespeichert.",
    "focused-task-close-account.delete-account.overview.inline-dialog.data-apps.self": "Sie oder andere Benutzer haben ggf. installierte Apps, die Funktionen zu Atlassian-Produkten hinzuf\xfcgen. Diese Apps haben ggf. Ihre Profilinformationen gespeichert.",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.li1.admin": "Mit K\xe4ufen verbundene Informationen, die f\xfcr den Finanzbericht gespeichert wurden.",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.li1.self": "Mit K\xe4ufen verbundene Informationen, die f\xfcr den Finanzbericht gespeichert wurden.",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.li2.admin": "Eintr\xe4ge zeigen, dass ein Konto einer Person gel\xf6scht wurde, das wir ggf. einer Aufsichtsbeh\xf6rde melden m\xfcssen.",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.li2.self": "Eintr\xe4ge zeigen, dass ein Konto einer Person gel\xf6scht wurde, das wir ggf. einer Aufsichtsbeh\xf6rde melden m\xfcssen.",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.li3.admin": "Daten, die Teil eines laufenden Verfahrens sind, die von Rechts wegen gespeichert wurden.",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.li3.self": "Daten, die Teil eines laufenden Verfahrens sind, die von Rechts wegen gespeichert wurden.",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.p1.admin": "Wir speichern personenbezogene Daten f\xfcr einen begrenzten Zeitraum, wenn wir daf\xfcr notwendige gesch\xe4ftliche oder legale Zwecke haben. Dazu geh\xf6ren unter anderem:",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.p1.self": "Wir speichern personenbezogene Daten f\xfcr einen begrenzten Zeitraum, wenn wir daf\xfcr notwendige gesch\xe4ftliche oder legale Zwecke haben. Dazu geh\xf6ren unter anderem:",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.p2.admin": "Wir l\xf6schen keine personenbezogenen Daten von von anderen Personen erstellten Inhalten, wie Namen oder E-Mail-Adressen, die in eine Seite oder einen Vorgang eingegeben wurden. Die Produktadministratoren m\xfcssen diese Daten manuell l\xf6schen.",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.p2.self": "Wir l\xf6schen keine personenbezogenen Daten von von Ihnen oder anderen Personen erstellten Inhalten, wie Namen oder E-Mail-Adressen, die in eine Seite oder einen Vorgang eingegeben wurden. Ihre Produktadministratoren m\xfcssen diese Daten manuell l\xf6schen.",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.p3.admin": "Benutzer haben das Recht, Beschwerde bei einer Aufsichtsbeh\xf6rde in ihrem Land einzureichen.",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.p3.self": "Sie haben das Recht, Beschwerde bei einer Aufsichtsbeh\xf6rde in Ihrem Land einzureichen.",
    "focused-task-close-account.delete-account.overview.paragraph.about-to-delete.admin": "Wenn Sie das Konto l\xf6schen:",
    "focused-task-close-account.delete-account.overview.paragraph.about-to-delete.self": "Wenn Sie Ihr Konto l\xf6schen:",
    "focused-task-close-account.delete-account.overview.paragraph.content-created.admin": "Die erstellten Inhalte bleiben in den Atlassian-Kontoservices bestehen.",
    "focused-task-close-account.delete-account.overview.paragraph.content-created.self": "Die von Ihnen erstellten Inhalte bleiben in den Atlassian-Kontoservices bestehen.",
    "focused-task-close-account.delete-account.overview.paragraph.grace-period.admin": "Nach einer 14-t\xe4gigen Nachfrist k\xf6nnen Sie die L\xf6schung des Kontos nicht mehr r\xfcckg\xe4ngig mache.",
    "focused-task-close-account.delete-account.overview.paragraph.list-of-apps-with-personal-data.admin": "Sie erhalten per E-Mail eine Liste mit Apps, in denen ggf. Ihre personenbezogenen Daten gespeichert sind.",
    "focused-task-close-account.delete-account.overview.paragraph.list-of-apps-with-personal-data.self": "Sie erhalten per E-Mail eine Liste mit Apps, in denen ggf. Ihre personenbezogenen Daten gespeichert sind.",
    "focused-task-close-account.delete-account.overview.paragraph.loseAccess.admin": "{fullName} <b>verliert sofort den Zugriff</b> auf alle Atlassian-Kontoservices. Er/sie hat derzeit Zugriff auf:",
    "focused-task-close-account.delete-account.overview.paragraph.loseAccess.admin.noSites": "{fullName} <b>verliert sofort den Zugriff</b> auf alle Atlassian-Kontoservices. Derzeit hat er/sie ausschlie\xdflich Zugriff auf Services wie Community und Marketplace.",
    "focused-task-close-account.delete-account.overview.paragraph.loseAccess.footnote": "Andere Atlassian-Kontoservices, wie Atlassian Community und Marketplace.",
    "focused-task-close-account.delete-account.overview.paragraph.loseAccess.self": "Sie <b>verlieren sofort den Zugriff</b> auf alle Atlassian-Kontoservices. Sie haben derzeit Zugriff auf:",
    "focused-task-close-account.delete-account.overview.paragraph.loseAccess.self.noSites": "Sie <b>verlieren sofort den Zugriff</b> auf alle Atlassian-Kontoservices. Derzeit haben Sie ausschlie\xdflich Zugriff auf Services wie Community und Marketplace.",
    "focused-task-close-account.delete-account.overview.paragraph.personal-data-will-be-deleted.admin": "Wir <b>l\xf6schen die personenbezogenen Daten</b>, wie den vollst\xe4ndigen Namen und die E-Mail-Adresse der Atlassian-Kontoservices innerhalb von 30 Tagen, au\xdfer in einigen F\xe4llen, falls f\xfcr notwendige gesch\xe4ftliche oder legale Zwecke erforderlich.",
    "focused-task-close-account.delete-account.overview.paragraph.personal-data-will-be-deleted.self": "Wir <b>l\xf6schen Ihre personenbezogenen Daten</b>, wie Ihren vollst\xe4ndigen Namen und Ihre E-Mail-Adresse der Atlassian-Kontoservices innerhalb von 30 Tagen, au\xdfer in einigen F\xe4llen, falls f\xfcr notwendige gesch\xe4ftliche oder legale Zwecke erforderlich.",
    "focused-task-close-account.delete-account.overview.warning-section.body": "Nach einer 14-t\xe4gigen Nachfrist k\xf6nnen Sie die L\xf6schung des Kontos nicht mehr r\xfcckg\xe4ngig machen. Wenn Sie Ihr Konto sp\xe4ter weiterverwenden m\xf6chten, sollten Sie es nur deaktivieren.",
    "focused-task-close-account.delete-account.overview.warning-section.deactivated.body": "Nach einer 14-t\xe4gigen Nachfrist k\xf6nnen Sie die L\xf6schung des Kontos nicht mehr r\xfcckg\xe4ngig machen.",
    "focused-task-close-account.learnMore": "Mehr erfahren",
    "focused-task-close-account.next": "Weiter",
    "focused-task-close-account.previous": "Zur\xfcck"
};

});

parcelRegister("8gxuB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6049cc4bf6e189c2$export$2e2bcd8739ae039; });
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Hungarian
var $6049cc4bf6e189c2$export$2e2bcd8739ae039 = {
    "focused-task-close-account.cancel": "M\xe9gse",
    "focused-task-close-account.deactivate-account": "Fi\xf3k inaktiv\xe1l\xe1sa",
    "focused-task-close-account.deactivate-account.overview.first.line.admin": "A k\xf6vetkez\u0151 felhaszn\xe1l\xf3i fi\xf3k inaktiv\xe1l\xe1s\xe1ra k\xe9sz\xfcl:",
    "focused-task-close-account.deactivate-account.overview.first.line.self": "A k\xf6vetkez\u0151 felhaszn\xe1l\xf3i fi\xf3k inaktiv\xe1l\xe1s\xe1ra k\xe9sz\xfcl:",
    "focused-task-close-account.deactivate-account.overview.heading.admin": "Fi\xf3k inaktiv\xe1l\xe1sa",
    "focused-task-close-account.deactivate-account.overview.heading.self": "Fi\xf3k inaktiv\xe1l\xe1sa",
    "focused-task-close-account.deactivate-account.overview.last.line.admin": "A fi\xf3kot b\xe1rmikor \xfajraaktiv\xe1lhatja.",
    "focused-task-close-account.deactivate-account.overview.last.line.self": "A fi\xf3kot b\xe1rmikor \xfajraaktiv\xe1lhatja.",
    "focused-task-close-account.deactivate-account.overview.paragraph.about-to-deactivate.admin": "Ha inaktiv\xe1lja a fi\xf3kot:",
    "focused-task-close-account.deactivate-account.overview.paragraph.about-to-deactivate.self": "Ha inaktiv\xe1lja a fi\xf3kot:",
    "focused-task-close-account.deactivate-account.overview.paragraph.billing.admin": "A tov\xe1bbiakban nem sz\xe1ml\xe1zzuk ki ezen term\xe9kek d\xedjait.",
    "focused-task-close-account.deactivate-account.overview.paragraph.billing.self": "A tov\xe1bbiakban nem sz\xe1ml\xe1zzuk ki ezen term\xe9kek d\xedjait.",
    "focused-task-close-account.deactivate-account.overview.paragraph.loseAccess.admin": "{fullName} <b>azonnal elvesz\xedti hozz\xe1f\xe9r\xe9s\xe9t</b> az \xf6sszes Atlassian-fi\xf3kszolg\xe1ltat\xe1shoz. Jelenleg a k\xf6vetkez\u0151kh\xf6z van hozz\xe1f\xe9r\xe9se:",
    "focused-task-close-account.deactivate-account.overview.paragraph.loseAccess.admin.noSites": "{fullName} <b>azonnal elvesz\xedti hozz\xe1f\xe9r\xe9s\xe9t</b> az \xf6sszes Atlassian-fi\xf3kszolg\xe1ltat\xe1shoz. Jelenleg kiz\xe1r\xf3lag a Community \xe9s a Marketplace szolg\xe1ltat\xe1shoz van hozz\xe1f\xe9r\xe9se.",
    "focused-task-close-account.deactivate-account.overview.paragraph.loseAccess.footnote": "Egy\xe9b Atlassian-fi\xf3kszolg\xe1ltat\xe1sok, p\xe9ld\xe1ul az Atlassian Community \xe9s Marketplace.",
    "focused-task-close-account.deactivate-account.overview.paragraph.loseAccess.self": "\xd6n <b>azonnal elvesz\xedti hozz\xe1f\xe9r\xe9s\xe9t</b> az \xf6sszes Atlassian-fi\xf3kszolg\xe1ltat\xe1shoz. Jelenleg a k\xf6vetkez\u0151kh\xf6z van hozz\xe1f\xe9r\xe9se:",
    "focused-task-close-account.deactivate-account.overview.paragraph.loseAccess.self.noSites": "\xd6n <b>azonnal elvesz\xedti hozz\xe1f\xe9r\xe9s\xe9t</b> az \xf6sszes Atlassian-fi\xf3kszolg\xe1ltat\xe1shoz. Jelenleg kiz\xe1r\xf3lag a Community \xe9s a Marketplace szolg\xe1ltat\xe1shoz van hozz\xe1f\xe9r\xe9se.",
    "focused-task-close-account.deactivate-account.overview.paragraph.personal-data.admin": "A felhaszn\xe1l\xf3 szem\xe9lyes adatait, \xedgy a teljes nev\xe9t \xe9s e-mail-c\xedm\xe9t, valamint az \xe1ltala l\xe9trehozott tartalmat a rendszer meg\u0151rzi az Atlassian-fi\xf3kszolg\xe1ltat\xe1sokban.",
    "focused-task-close-account.deactivate-account.overview.paragraph.personal-data.self": "A felhaszn\xe1l\xf3 szem\xe9lyes adatait, \xedgy a teljes nev\xe9t \xe9s e-mail-c\xedm\xe9t, valamint az \xe1ltala l\xe9trehozott tartalmat a rendszer meg\u0151rzi az Atlassian-fi\xf3kszolg\xe1ltat\xe1sokban.",
    "focused-task-close-account.delete-account": "Fi\xf3k t\xf6rl\xe9se",
    "focused-task-close-account.delete-account.content-preview.footnote.admin": "Megjegyz\xe9s: A felm\xe9r\xe9s megv\xe1laszol\xe1s\xe1val seg\xedthet, hogy jobb \xe9lm\xe9nyt ny\xfajthassunk felhaszn\xe1l\xf3inknak. A felhaszn\xe1l\xf3 tov\xe1bbra is \u201EKor\xe1bbi felhaszn\xe1l\xf3\u201D jel\xf6l\xe9ssel lesz l\xe1that\xf3 a fi\xf3k t\xf6rl\xe9se ut\xe1n.",
    "focused-task-close-account.delete-account.content-preview.footnote.self": "Megjegyz\xe9s: A felm\xe9r\xe9s megv\xe1laszol\xe1s\xe1val seg\xedthet, hogy jobb \xe9lm\xe9nyt ny\xfajthassunk felhaszn\xe1l\xf3inknak. \xd6n tov\xe1bbra is \u201EKor\xe1bbi felhaszn\xe1l\xf3\u201D jel\xf6l\xe9ssel lesz l\xe1that\xf3 a fi\xf3k t\xf6rl\xe9se ut\xe1n.",
    "focused-task-close-account.delete-account.content-preview.formerUser": "Kor\xe1bbi felhaszn\xe1l\xf3",
    "focused-task-close-account.delete-account.content-preview.heading.admin": "Hogyan szeretn\xe9, hogy a t\xf6r\xf6lt felhaszn\xe1l\xf3 l\xe1tsz\xf3djon?",
    "focused-task-close-account.delete-account.content-preview.heading.self": "Hogyan szeretn\xe9, hogy az \xd6n t\xf6r\xf6lt fi\xf3kja l\xe1tsz\xf3djon?",
    "focused-task-close-account.delete-account.content-preview.line.survey.admin": "Ha v\xe1laszthatna, hogyan szeretn\xe9, hogy a t\xf6r\xf6lt felhaszn\xe1l\xf3 l\xe1tsz\xf3djon a t\xf6bbi felhaszn\xe1l\xf3 sz\xe1m\xe1ra?",
    "focused-task-close-account.delete-account.content-preview.line.survey.self": "Ha v\xe1laszthatna, hogyan szeretne l\xe1tszani a t\xf6bbi felhaszn\xe1l\xf3 sz\xe1m\xe1ra?",
    "focused-task-close-account.delete-account.content-preview.paragraph.survey.admin": "A felhaszn\xe1l\xf3i fi\xf3k t\xf6rl\xe9se ut\xe1n az illet\u0151 \u201EKor\xe1bbi felhaszn\xe1l\xf3\u201D jel\xf6l\xe9ssel lesz l\xe1that\xf3 a t\xf6bbi felhaszn\xe1l\xf3 sz\xe1m\xe1ra. Sz\xe1njon egy kis id\u0151t a felm\xe9r\xe9s\xfcnkben szerepl\u0151 k\xe9rd\xe9s megv\xe1laszol\xe1s\xe1ra.",
    "focused-task-close-account.delete-account.content-preview.paragraph.survey.self": "A felhaszn\xe1l\xf3i fi\xf3kja t\xf6rl\xe9se ut\xe1n \xd6n \u201EKor\xe1bbi felhaszn\xe1l\xf3\u201D jel\xf6l\xe9ssel lesz l\xe1that\xf3 a t\xf6bbi felhaszn\xe1l\xf3 sz\xe1m\xe1ra. Sz\xe1njon egy kis id\u0151t a felm\xe9r\xe9s\xfcnkben szerepl\u0151 k\xe9rd\xe9s megv\xe1laszol\xe1s\xe1ra.",
    "focused-task-close-account.delete-account.drop-down-collapse-button": "Kevesebb",
    "focused-task-close-account.delete-account.drop-down-expand-button": "{num} tov\xe1bbi",
    "focused-task-close-account.delete-account.overview.first.line.admin": "A k\xf6vetkez\u0151 fi\xf3k t\xf6rl\xe9s\xe9re k\xe9sz\xfcl:",
    "focused-task-close-account.delete-account.overview.first.line.self": "A fi\xf3k t\xf6rl\xe9s\xe9re k\xe9sz\xfcl:",
    "focused-task-close-account.delete-account.overview.heading.admin": "Fi\xf3k t\xf6rl\xe9se",
    "focused-task-close-account.delete-account.overview.heading.self": "Az \xd6n fi\xf3kj\xe1nak t\xf6rl\xe9se",
    "focused-task-close-account.delete-account.overview.inline-dialog.content-created.admin": "P\xe9ld\xe1ul a term\xe9kekben l\xe9trehozott oldalak, \xfcgyek \xe9s megjegyz\xe9sek.",
    "focused-task-close-account.delete-account.overview.inline-dialog.content-created.self": "P\xe9ld\xe1ul a term\xe9kekben \xd6n \xe1ltal l\xe9trehozott oldalak, \xfcgyek \xe9s megjegyz\xe9sek.",
    "focused-task-close-account.delete-account.overview.inline-dialog.data-apps.admin": "\xd6n vagy m\xe1s felhaszn\xe1l\xf3k olyan alkalmaz\xe1sokat telep\xedthettek, amelyek szolg\xe1ltat\xe1sokkal b\u0151v\xedtik az Atlassian-term\xe9keket. Ezek az alkalmaz\xe1sok t\xe1rolhatj\xe1k a felhaszn\xe1l\xf3k profiladatait.",
    "focused-task-close-account.delete-account.overview.inline-dialog.data-apps.self": "\xd6n vagy m\xe1s felhaszn\xe1l\xf3k olyan alkalmaz\xe1sokat telep\xedthettek, amelyek szolg\xe1ltat\xe1sokkal b\u0151v\xedtik az Atlassian-term\xe9keket. Ezek az alkalmaz\xe1sok t\xe1rolhatj\xe1k az \xd6n profiladatait.",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.li1.admin": "V\xe1s\xe1rl\xe1sokkal kapcsolatos inform\xe1ci\xf3k, amelyeket meg kell \u0151rizn\xfcnk a p\xe9nz\xfcgyi besz\xe1mol\xe1sokhoz.",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.li1.self": "V\xe1s\xe1rl\xe1sokkal kapcsolatos inform\xe1ci\xf3k, amelyeket meg kell \u0151rizn\xfcnk a p\xe9nz\xfcgyi besz\xe1mol\xe1sokhoz.",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.li2.admin": "A felhaszn\xe1l\xf3 fi\xf3kj\xe1nak t\xf6rl\xe9s\xe9t igazol\xf3 rekordok, amelyeket esetleg be kell mutatnunk a szab\xe1lyoz\xf3 hat\xf3s\xe1goknak.",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.li2.self": "A felhaszn\xe1l\xf3 fi\xf3kj\xe1nak t\xf6rl\xe9s\xe9t igazol\xf3 rekordok, amelyeket esetleg be kell mutatnunk a szab\xe1lyoz\xf3 hat\xf3s\xe1goknak.",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.li3.admin": "Egy akt\xedv per r\xe9sz\xe9t k\xe9pez\u0151 adatok, amelyeket a jogszab\xe1lyokban el\u0151\xedrtak \xe9rtelm\xe9ben meg kell \u0151rizn\xfcnk.",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.li3.self": "Egy akt\xedv per r\xe9sz\xe9t k\xe9pez\u0151 adatok, amelyeket a jogszab\xe1lyokban el\u0151\xedrtak \xe9rtelm\xe9ben meg kell \u0151rizn\xfcnk.",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.p1.admin": "Korl\xe1tozott ideig meg\u0151rizz\xfck a szem\xe9lyes adatokat, ha t\xf6rv\xe9nyes \xfczleti vagy jogi okokb\xf3l erre sz\xfcks\xe9g van. Ilyen adatok lehetnek p\xe9ld\xe1ul a k\xf6vetkez\u0151k:",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.p1.self": "Korl\xe1tozott ideig meg\u0151rizz\xfck a szem\xe9lyes adatokat, ha t\xf6rv\xe9nyes \xfczleti vagy jogi okokb\xf3l erre sz\xfcks\xe9g van. Ilyen adatok lehetnek p\xe9ld\xe1ul a k\xf6vetkez\u0151k:",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.p2.admin": "Nem t\xf6r\xf6lj\xfck a szem\xe9lyes adatokat a felhaszn\xe1l\xf3k \xe1ltal l\xe9trehozott tartalomb\xf3l, \xedgy p\xe9ld\xe1ul az oldalakon vagy \xfcgyekben beg\xe9pelt neveket vagy e-mail-c\xedmeket. A term\xe9kadminisztr\xe1toroknak k\xe9zzel kell t\xf6r\xf6lni\xfck ezeket az adatokat.",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.p2.self": "Nem t\xf6r\xf6lj\xfck a szem\xe9lyes adatokat az \xd6n vagy m\xe1s szem\xe9lyek \xe1ltal l\xe9trehozott tartalomb\xf3l, \xedgy p\xe9ld\xe1ul az oldalakon vagy \xfcgyekben beg\xe9pelt neveket vagy e-mail-c\xedmeket. Az \xd6n term\xe9kadminisztr\xe1torainak k\xe9zzel kell t\xf6r\xf6lni\xfck ezeket az adatokat.",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.p3.admin": "A felhaszn\xe1l\xf3knak joguk van arra, hogy panaszt ny\xfajtsanak be az orsz\xe1gukban illet\xe9kes fel\xfcgyeleti hat\xf3s\xe1gnak.",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.p3.self": "\xd6nnek joga van arra, hogy panaszt ny\xfajtson be az orsz\xe1g\xe1ban illet\xe9kes fel\xfcgyeleti hat\xf3s\xe1gnak.",
    "focused-task-close-account.delete-account.overview.paragraph.about-to-delete.admin": "Ha t\xf6rli a fi\xf3kot:",
    "focused-task-close-account.delete-account.overview.paragraph.about-to-delete.self": "Ha t\xf6rli a fi\xf3kj\xe1t:",
    "focused-task-close-account.delete-account.overview.paragraph.content-created.admin": "A felhaszn\xe1l\xf3 \xe1ltal l\xe9trehozott tartalmat a rendszer meg\u0151rzi az Atlassian-fi\xf3kszolg\xe1ltat\xe1sokban.",
    "focused-task-close-account.delete-account.overview.paragraph.content-created.self": "Az \xd6n \xe1ltal l\xe9trehozott tartalmat a rendszer meg\u0151rzi az Atlassian-fi\xf3kszolg\xe1ltat\xe1sokban.",
    "focused-task-close-account.delete-account.overview.paragraph.grace-period.admin": "A 14 napos t\xfcrelmi id\u0151szakot k\xf6vet\u0151en nem tudja majd visszavonni a fi\xf3k t\xf6rl\xe9s\xe9t.",
    "focused-task-close-account.delete-account.overview.paragraph.list-of-apps-with-personal-data.admin": "E-mailben elk\xfcldj\xfck \xd6nnek azon alkalmaz\xe1sok list\xe1j\xe1t, amelyek t\xe1rolhatj\xe1k a felhaszn\xe1l\xf3 szem\xe9lyes adatait.",
    "focused-task-close-account.delete-account.overview.paragraph.list-of-apps-with-personal-data.self": "E-mailben elk\xfcldj\xfck \xd6nnek azon alkalmaz\xe1sok list\xe1j\xe1t, amelyek t\xe1rolhatj\xe1k az \xd6n szem\xe9lyes adatait.",
    "focused-task-close-account.delete-account.overview.paragraph.loseAccess.admin": "{fullName} <b>azonnal elvesz\xedti hozz\xe1f\xe9r\xe9s\xe9t</b> az \xf6sszes Atlassian-fi\xf3kszolg\xe1ltat\xe1shoz. Jelenleg a k\xf6vetkez\u0151kh\xf6z van hozz\xe1f\xe9r\xe9se:",
    "focused-task-close-account.delete-account.overview.paragraph.loseAccess.admin.noSites": "{fullName} <b>azonnal elvesz\xedti hozz\xe1f\xe9r\xe9s\xe9t</b> az \xf6sszes Atlassian-fi\xf3kszolg\xe1ltat\xe1shoz. Jelenleg kiz\xe1r\xf3lag a Community \xe9s a Marketplace szolg\xe1ltat\xe1shoz van hozz\xe1f\xe9r\xe9se.",
    "focused-task-close-account.delete-account.overview.paragraph.loseAccess.footnote": "Egy\xe9b Atlassian-fi\xf3kszolg\xe1ltat\xe1sok, p\xe9ld\xe1ul az Atlassian Community \xe9s Marketplace.",
    "focused-task-close-account.delete-account.overview.paragraph.loseAccess.self": "\xd6n <b>azonnal elvesz\xedti hozz\xe1f\xe9r\xe9s\xe9t</b> az \xf6sszes Atlassian-fi\xf3kszolg\xe1ltat\xe1shoz. Jelenleg a k\xf6vetkez\u0151kh\xf6z van hozz\xe1f\xe9r\xe9se:",
    "focused-task-close-account.delete-account.overview.paragraph.loseAccess.self.noSites": "\xd6n <b>azonnal elvesz\xedti hozz\xe1f\xe9r\xe9s\xe9t</b> az \xf6sszes Atlassian-fi\xf3kszolg\xe1ltat\xe1shoz. Jelenleg kiz\xe1r\xf3lag a Community \xe9s a Marketplace szolg\xe1ltat\xe1shoz van hozz\xe1f\xe9r\xe9se.",
    "focused-task-close-account.delete-account.overview.paragraph.personal-data-will-be-deleted.admin": "30 napon bel\xfcl <b>t\xf6r\xf6lni fogjuk a felhaszn\xe1l\xf3 szem\xe9lyes adatait</b>, p\xe9ld\xe1ul a teljes nev\xe9t \xe9s e-mail-c\xedm\xe9t az Atlassian-fi\xf3kszolg\xe1ltat\xe1sokb\xf3l, n\xe9h\xe1ny esetet kiv\xe9ve, amikor t\xf6rv\xe9nyes \xfczleti vagy jogi okokb\xf3l sz\xfcks\xe9g van ezekre az adatokra.",
    "focused-task-close-account.delete-account.overview.paragraph.personal-data-will-be-deleted.self": "30 napon bel\xfcl <b>t\xf6r\xf6lni fogjuk az \xd6n szem\xe9lyes adatait</b>, p\xe9ld\xe1ul a teljes nev\xe9t \xe9s e-mail-c\xedm\xe9t az Atlassian-fi\xf3kszolg\xe1ltat\xe1sokb\xf3l, n\xe9h\xe1ny esetet kiv\xe9ve, amikor t\xf6rv\xe9nyes \xfczleti vagy jogi okokb\xf3l sz\xfcks\xe9g van ezekre az adatokra.",
    "focused-task-close-account.delete-account.overview.warning-section.body": "A 14 napos t\xfcrelmi id\u0151szakot k\xf6vet\u0151en nem tudja majd visszavonni a fi\xf3k t\xf6rl\xe9s\xe9t. Ha \xfagy gondolja, hogy k\xe9s\u0151bb sz\xfcks\xe9ge lesz a fi\xf3kra, akkor \xe9rdemes ink\xe1bb inaktiv\xe1lnia azt.",
    "focused-task-close-account.delete-account.overview.warning-section.deactivated.body": "A 14 napos t\xfcrelmi id\u0151szakot k\xf6vet\u0151en nem tudja majd visszavonni a fi\xf3k t\xf6rl\xe9s\xe9t.",
    "focused-task-close-account.learnMore": "Tov\xe1bbi inform\xe1ci\xf3",
    "focused-task-close-account.next": "K\xf6vetkez\u0151",
    "focused-task-close-account.previous": "El\u0151z\u0151"
};

});

parcelRegister("29HcH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $191def6685d64969$export$2e2bcd8739ae039; });
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Italian (Italy)
var $191def6685d64969$export$2e2bcd8739ae039 = {
    "focused-task-close-account.cancel": "Annulla",
    "focused-task-close-account.deactivate-account": "Disattiva account",
    "focused-task-close-account.deactivate-account.overview.first.line.admin": "Stai per disattivare l\u2019account utente di:",
    "focused-task-close-account.deactivate-account.overview.first.line.self": "Stai per disattivare l\u2019account utente di:",
    "focused-task-close-account.deactivate-account.overview.heading.admin": "Disattiva account",
    "focused-task-close-account.deactivate-account.overview.heading.self": "Disattiva account",
    "focused-task-close-account.deactivate-account.overview.last.line.admin": "Puoi riattivare l\u2019account in qualsiasi momento.",
    "focused-task-close-account.deactivate-account.overview.last.line.self": "Puoi riattivare l\u2019account in qualsiasi momento.",
    "focused-task-close-account.deactivate-account.overview.paragraph.about-to-deactivate.admin": "Quando disattivi l\u2019account:",
    "focused-task-close-account.deactivate-account.overview.paragraph.about-to-deactivate.self": "Quando disattivi l\u2019account:",
    "focused-task-close-account.deactivate-account.overview.paragraph.billing.admin": "Non te li faremo pi\xf9 pagare.",
    "focused-task-close-account.deactivate-account.overview.paragraph.billing.self": "Non te li faremo pi\xf9 pagare.",
    "focused-task-close-account.deactivate-account.overview.paragraph.loseAccess.admin": "{fullName} <b>perder\xe0 immediatamente l\u2019accesso</b> a tutti i servizi dell\u2019account Atlassian. Attualmente l\u2019utente ha accesso a:",
    "focused-task-close-account.deactivate-account.overview.paragraph.loseAccess.admin.noSites": "{fullName} <b>perder\xe0 immediatamente l\u2019accesso</b> a tutti i servizi dell\u2019account Atlassian. Attualmente l\u2019utente non ha accesso ad alcun servizio, eccetto la Community e il Marketplace.",
    "focused-task-close-account.deactivate-account.overview.paragraph.loseAccess.footnote": "Altri servizi dell\u2019account Atlassian, come Atlassian Community  e Atlassian Marketplace.",
    "focused-task-close-account.deactivate-account.overview.paragraph.loseAccess.self": "<b>Perderai immediatamente l'accesso</b> a tutti i servizi dell\u2019account Atlassian. Attualmente hai accesso a:",
    "focused-task-close-account.deactivate-account.overview.paragraph.loseAccess.self.noSites": "<b>Perderai immediatamente l\u2019accesso</b> a tutti i servizi dell\u2019account Atlassian. Attualmente non hai accesso ad alcun servizio, eccetto Atlassian Community e Atlassian Marketplace.",
    "focused-task-close-account.deactivate-account.overview.paragraph.personal-data.admin": "I dati personali, come nome e indirizzo e-mail, e i contenuti creati resteranno nei servizi dell\u2019account Atlassian.",
    "focused-task-close-account.deactivate-account.overview.paragraph.personal-data.self": "I dati personali, come nome e indirizzo e-mail, e i contenuti creati resteranno nei servizi dell\u2019account Atlassian.",
    "focused-task-close-account.delete-account": "Elimina account",
    "focused-task-close-account.delete-account.content-preview.footnote.admin": "Nota: le risposte di questo sondaggio ci aiuteranno a migliorare l\u2019esperienza di tutti gli utenti. L\u2019utente apparir\xe0 comunque come \u201CEx utente\u201D anche una volta eliminato l\u2019account.",
    "focused-task-close-account.delete-account.content-preview.footnote.self": "Nota: le risposte di questo sondaggio ci aiuteranno a migliorare l\u2019esperienza di tutti gli utenti, compresi quelli che eliminano i propri account. Continuerai comunque ad apparire come \u201CEx utente\u201D una volta eliminato l\u2019account.",
    "focused-task-close-account.delete-account.content-preview.formerUser": "Ex utente",
    "focused-task-close-account.delete-account.content-preview.heading.admin": "Come vorresti che apparisse l\u2019utente che ha eliminato il proprio account?",
    "focused-task-close-account.delete-account.content-preview.heading.self": "Come vorresti che apparisse il tuo account eliminato?",
    "focused-task-close-account.delete-account.content-preview.line.survey.admin": "Se potessi scegliere, come vorresti che apparisse l\u2019utente dell'account eliminato agli altri utenti?",
    "focused-task-close-account.delete-account.content-preview.line.survey.self": "Se potessi scegliere, come vorresti apparire agli altri utenti?",
    "focused-task-close-account.delete-account.content-preview.paragraph.survey.admin": "Una volta eliminato il proprio account, l\u2019utente apparir\xe0 come \u201CEx utente\u201D agli altri. Prenditi un attimo di tempo per rispondere alla domanda del sondaggio.",
    "focused-task-close-account.delete-account.content-preview.paragraph.survey.self": "Una volta eliminato il tuo account, apparirai come \u201CEx utente\u201D agli altri. Prenditi un attimo di tempo per rispondere alla domanda del sondaggio.",
    "focused-task-close-account.delete-account.drop-down-collapse-button": "Mostra meno",
    "focused-task-close-account.delete-account.drop-down-expand-button": "{num} in pi\xf9",
    "focused-task-close-account.delete-account.overview.first.line.admin": "Stai per eliminare l\u2019account di:",
    "focused-task-close-account.delete-account.overview.first.line.self": "Stai per eliminare questo account:",
    "focused-task-close-account.delete-account.overview.heading.admin": "Elimina account",
    "focused-task-close-account.delete-account.overview.heading.self": "Elimina il tuo account",
    "focused-task-close-account.delete-account.overview.inline-dialog.content-created.admin": "Ad esempio, pagine, ticket e commenti che hanno creato nei prodotti.",
    "focused-task-close-account.delete-account.overview.inline-dialog.content-created.self": "Ad esempio, pagine, ticket e commenti che hai creato nei prodotti.",
    "focused-task-close-account.delete-account.overview.inline-dialog.data-apps.admin": "\xc8 possibile che in alcune app installate da te o da altri utenti per aggiungere funzionalit\xe0 ai prodotti Atlassian, siano memorizzate informazioni del profilo dell\u2019utente.",
    "focused-task-close-account.delete-account.overview.inline-dialog.data-apps.self": "\xc8 possibile che in alcune app installate da te o da altri utenti per aggiungere funzionalit\xe0 ai prodotti Atlassian, siano memorizzate informazioni del tuo profilo.",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.li1.admin": "Informazioni relative agli acquisti, che devono essere conservate per i report finanziari.",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.li1.self": "Informazioni relative agli acquisti, che devono essere conservate per i report finanziari.",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.li2.admin": "Record che mostrano che l\u2019account di un utente \xe8 stato eliminato e che potrebbe essere necessario fornire all\u2019autorit\xe0 di controllo.",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.li2.self": "Record che mostrano che l\u2019account di un utente \xe8 stato eliminato e che potrebbe essere necessario fornire all\u2019autorit\xe0 di controllo.",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.li3.admin": "I dati che sono parte di cause aperte e che devono essere conservati per legge.",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.li3.self": "I dati che sono parte di cause aperte e che devono essere conservati per legge.",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.p1.admin": "I dati personali vengono conservati per periodi di tempo limitati per legittime finalit\xe0 commerciali o legali. Alcuni esempi comprendono:",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.p1.self": "I dati personali vengono conservati per periodi di tempo limitati per legittime finalit\xe0 commerciali o legali. Alcuni esempi comprendono:",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.p2.admin": "Non viene eliminato alcun dato personale dal contenuto creato dagli utenti, ad esempio nomi o indirizzi e-mail inseriti in una pagina o in un ticket. Tali dati devono essere eliminati manualmente dagli amministratori di prodotto.",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.p2.self": "Non viene eliminato alcun dato personale dal contenuto creato da te o da altri utenti, ad esempio nomi o indirizzi e-mail inseriti in una pagina o in un ticket. Tali dati devono essere eliminati manualmente dagli amministratori di prodotto.",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.p3.admin": "Gli utenti hanno il diritto di presentare i reclami all\u2019autorit\xe0 di sorveglianza nel proprio paese.",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.p3.self": "Hai il diritto di presentare i reclami all\u2019autorit\xe0 di sorveglianza nel tuo paese.",
    "focused-task-close-account.delete-account.overview.paragraph.about-to-delete.admin": "Quando elimini l\u2019account:",
    "focused-task-close-account.delete-account.overview.paragraph.about-to-delete.self": "Quando elimini il tuo account:",
    "focused-task-close-account.delete-account.overview.paragraph.content-created.admin": "Il contenuto creato dagli utenti rester\xe0 nei servizi dell\u2019account Atlassian.",
    "focused-task-close-account.delete-account.overview.paragraph.content-created.self": "Il contenuto che hai creato rester\xe0 nei servizi dell\u2019account Atlassian.",
    "focused-task-close-account.delete-account.overview.paragraph.grace-period.admin": "Trascorso il periodo di grazia di 14 giorni, non potrai pi\xf9 annullare l\u2019eliminazione dell\u2019account.",
    "focused-task-close-account.delete-account.overview.paragraph.list-of-apps-with-personal-data.admin": "Ti invieremo un elenco di app in cui \xe8 possibile che siano stati memorizzati i dati personali degli utenti.",
    "focused-task-close-account.delete-account.overview.paragraph.list-of-apps-with-personal-data.self": "Ti invieremo un elenco di app in cui \xe8 possibile che siano stati memorizzati i tuoi dati personali.",
    "focused-task-close-account.delete-account.overview.paragraph.loseAccess.admin": "{fullName} <b>perder\xe0 immediatamente l\u2019accesso</b> a tutti i servizi dell\u2019account Atlassian. Attualmente l\u2019utente ha accesso a:",
    "focused-task-close-account.delete-account.overview.paragraph.loseAccess.admin.noSites": "{fullName} <b>perder\xe0 immediatamente l\u2019accesso</b> a tutti i servizi dell\u2019account Atlassian. Attualmente, l\u2019utente non ha accesso ad alcun servizio, eccetto la Community e il Marketplace.",
    "focused-task-close-account.delete-account.overview.paragraph.loseAccess.footnote": "Altri servizi dell\u2019account Atlassian, come Atlassian Community e Atlassian Marketplace.",
    "focused-task-close-account.delete-account.overview.paragraph.loseAccess.self": "<b>Perderai immediatamente l'accesso</b> a tutti i servizi dell\u2019account Atlassian. Attualmente hai accesso a:",
    "focused-task-close-account.delete-account.overview.paragraph.loseAccess.self.noSites": "<b>Perderai immediatamente l\u2019accesso</b> a tutti i servizi dell\u2019account Atlassian. Attualmente non hai accesso ad alcun servizio, eccetto la Community e il Marketplace.",
    "focused-task-close-account.delete-account.overview.paragraph.personal-data-will-be-deleted.admin": "<b>I dati personali degli utenti</b>, ad esempio nome e cognome, nonch\xe9 l\u2019indirizzo e-mail, verranno eliminati entro 30 giorni dai servizi dell\u2019account Atlassian, ad eccezione di alcuni casi in cui tali informazioni siano richieste per legittime finalit\xe0 commerciali o legali.",
    "focused-task-close-account.delete-account.overview.paragraph.personal-data-will-be-deleted.self": "<b>I tuoi dati personali</b>, ad esempio nome e cognome, nonch\xe9 l\u2019indirizzo e-mail, verranno eliminati entro 30 giorni dai servizi dell\u2019account Atlassian, ad eccezione di alcuni casi in cui tali informazioni siano richieste per legittime finalit\xe0 commerciali o legali.",
    "focused-task-close-account.delete-account.overview.warning-section.body": "Trascorso il periodo di grazia di 14 giorni, non potrai pi\xf9 annullare l\u2019eliminazione dell\u2019account. Se pensi di aver bisogno dell\u2019account in un secondo momento, disattivalo invece di eliminarlo.",
    "focused-task-close-account.delete-account.overview.warning-section.deactivated.body": "Trascorso il periodo di grazia di 14 giorni, non potrai pi\xf9 annullare l\u2019eliminazione dell\u2019account.",
    "focused-task-close-account.learnMore": "Maggiori informazioni",
    "focused-task-close-account.next": "Avanti",
    "focused-task-close-account.previous": "Indietro"
};

});

parcelRegister("1Ctbk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $12dff9eb0a11757d$export$2e2bcd8739ae039; });
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Japanese
var $12dff9eb0a11757d$export$2e2bcd8739ae039 = {
    "focused-task-close-account.cancel": "\u30AD\u30E3\u30F3\u30BB\u30EB",
    "focused-task-close-account.deactivate-account": "\u30A2\u30AB\u30A6\u30F3\u30C8\u306E\u7121\u52B9\u5316",
    "focused-task-close-account.deactivate-account.overview.first.line.admin": "\u6B21\u306E\u30E6\u30FC\u30B6\u30FC \u30A2\u30AB\u30A6\u30F3\u30C8\u3092\u7121\u52B9\u5316\u3057\u3088\u3046\u3068\u3057\u3066\u3044\u307E\u3059:",
    "focused-task-close-account.deactivate-account.overview.first.line.self": "\u6B21\u306E\u30E6\u30FC\u30B6\u30FC \u30A2\u30AB\u30A6\u30F3\u30C8\u3092\u7121\u52B9\u5316\u3057\u3088\u3046\u3068\u3057\u3066\u3044\u307E\u3059:",
    "focused-task-close-account.deactivate-account.overview.heading.admin": "\u30A2\u30AB\u30A6\u30F3\u30C8\u306E\u7121\u52B9\u5316",
    "focused-task-close-account.deactivate-account.overview.heading.self": "\u30A2\u30AB\u30A6\u30F3\u30C8\u306E\u7121\u52B9\u5316",
    "focused-task-close-account.deactivate-account.overview.last.line.admin": "\u30A2\u30AB\u30A6\u30F3\u30C8\u306F\u3044\u3064\u3067\u3082\u518D\u6709\u52B9\u5316\u3067\u304D\u307E\u3059\u3002",
    "focused-task-close-account.deactivate-account.overview.last.line.self": "\u30A2\u30AB\u30A6\u30F3\u30C8\u306F\u3044\u3064\u3067\u3082\u518D\u6709\u52B9\u5316\u3067\u304D\u307E\u3059\u3002",
    "focused-task-close-account.deactivate-account.overview.paragraph.about-to-deactivate.admin": "\u30A2\u30AB\u30A6\u30F3\u30C8\u3092\u7121\u52B9\u5316\u3059\u308B\u3068:",
    "focused-task-close-account.deactivate-account.overview.paragraph.about-to-deactivate.self": "\u30A2\u30AB\u30A6\u30F3\u30C8\u3092\u7121\u52B9\u5316\u3059\u308B\u3068:",
    "focused-task-close-account.deactivate-account.overview.paragraph.billing.admin": "\u3053\u306E\u30E6\u30FC\u30B6\u30FC\u306B\u5BFE\u3059\u308B\u8ACB\u6C42\u306F\u767A\u751F\u3057\u306A\u304F\u306A\u308A\u307E\u3059\u3002",
    "focused-task-close-account.deactivate-account.overview.paragraph.billing.self": "\u3053\u306E\u30E6\u30FC\u30B6\u30FC\u306B\u5BFE\u3059\u308B\u8ACB\u6C42\u306F\u767A\u751F\u3057\u306A\u304F\u306A\u308A\u307E\u3059\u3002",
    "focused-task-close-account.deactivate-account.overview.paragraph.loseAccess.admin": "{fullName} \u3055\u3093\u306F\u30A2\u30C8\u30E9\u30B7\u30A2\u30F3\u306E\u3059\u3079\u3066\u306E\u30A2\u30AB\u30A6\u30F3\u30C8 \u30B5\u30FC\u30D3\u30B9\u3078\u306E<b>\u30A2\u30AF\u30BB\u30B9\u6A29\u9650\u3092\u76F4\u3061\u306B\u5931\u3044\u307E\u3059</b>\u3002\u73FE\u5728\u30A2\u30AF\u30BB\u30B9\u6A29\u9650\u306E\u3042\u308B\u30B5\u30FC\u30D3\u30B9:",
    "focused-task-close-account.deactivate-account.overview.paragraph.loseAccess.admin.noSites": "{fullName} \u3055\u3093\u306F\u30A2\u30C8\u30E9\u30B7\u30A2\u30F3\u306E\u3059\u3079\u3066\u306E\u30A2\u30AB\u30A6\u30F3\u30C8 \u30B5\u30FC\u30D3\u30B9\u3078\u306E<b>\u30A2\u30AF\u30BB\u30B9\u6A29\u9650\u3092\u76F4\u3061\u306B\u5931\u3044\u307E\u3059</b>\u3002\u73FE\u5728\u3001\u30B3\u30DF\u30E5\u30CB\u30C6\u30A3\u3084 Marketplace \u306A\u3069\u306E\u30B5\u30FC\u30D3\u30B9\u3092\u9664\u3044\u3066\u3001\u30A2\u30AF\u30BB\u30B9\u6A29\u9650\u306F\u3042\u308A\u307E\u305B\u3093\u3002",
    "focused-task-close-account.deactivate-account.overview.paragraph.loseAccess.footnote": "\u30A2\u30C8\u30E9\u30B7\u30A2\u30F3 \u30B3\u30DF\u30E5\u30CB\u30C6\u30A3\u3084 Marketplace \u306A\u3069\u3001\u305D\u306E\u4ED6\u306E Atlassian \u30A2\u30AB\u30A6\u30F3\u30C8 \u30B5\u30FC\u30D3\u30B9\u3002",
    "focused-task-close-account.deactivate-account.overview.paragraph.loseAccess.self": "Atlassian \u306E\u3059\u3079\u3066\u306E\u30A2\u30AB\u30A6\u30F3\u30C8 \u30B5\u30FC\u30D3\u30B9\u3078\u306E<b>\u30A2\u30AF\u30BB\u30B9\u6A29\u9650\u3092\u76F4\u3061\u306B\u5931\u3044\u307E\u3059</b>\u3002\u73FE\u5728\u30A2\u30AF\u30BB\u30B9\u6A29\u9650\u306E\u3042\u308B\u30B5\u30FC\u30D3\u30B9:",
    "focused-task-close-account.deactivate-account.overview.paragraph.loseAccess.self.noSites": "Atlassian \u306E\u3059\u3079\u3066\u306E\u30A2\u30AB\u30A6\u30F3\u30C8 \u30B5\u30FC\u30D3\u30B9\u3078\u306E<b>\u30A2\u30AF\u30BB\u30B9\u6A29\u9650\u3092\u76F4\u3061\u306B\u5931\u3044\u307E\u3059</b>\u3002\u73FE\u5728\u3001\u30B3\u30DF\u30E5\u30CB\u30C6\u30A3\u3084 Marketplace \u306A\u3069\u306E\u30B5\u30FC\u30D3\u30B9\u3092\u9664\u3044\u3066\u3001\u30A2\u30AF\u30BB\u30B9\u6A29\u9650\u306F\u3042\u308A\u307E\u305B\u3093\u3002",
    "focused-task-close-account.deactivate-account.overview.paragraph.personal-data.admin": "\u6C0F\u540D\u3084\u30E1\u30FC\u30EB \u30A2\u30C9\u30EC\u30B9\u306A\u3069\u306E\u500B\u4EBA\u60C5\u5831\u304A\u3088\u3073\u4F5C\u6210\u3057\u305F\u30B3\u30F3\u30C6\u30F3\u30C4\u306F Atlassian \u30A2\u30AB\u30A6\u30F3\u30C8\u306E\u30B5\u30FC\u30D3\u30B9\u304B\u3089\u524A\u9664\u3055\u308C\u307E\u305B\u3093\u3002",
    "focused-task-close-account.deactivate-account.overview.paragraph.personal-data.self": "\u6C0F\u540D\u3084\u30E1\u30FC\u30EB \u30A2\u30C9\u30EC\u30B9\u306A\u3069\u306E\u500B\u4EBA\u60C5\u5831\u304A\u3088\u3073\u4F5C\u6210\u3057\u305F\u30B3\u30F3\u30C6\u30F3\u30C4\u306F Atlassian \u30A2\u30AB\u30A6\u30F3\u30C8\u306E\u30B5\u30FC\u30D3\u30B9\u304B\u3089\u524A\u9664\u3055\u308C\u307E\u305B\u3093\u3002",
    "focused-task-close-account.delete-account": "\u30A2\u30AB\u30A6\u30F3\u30C8\u306E\u524A\u9664",
    "focused-task-close-account.delete-account.content-preview.footnote.admin": "\u6CE8: \u3053\u306E\u30A2\u30F3\u30B1\u30FC\u30C8\u3078\u306E\u56DE\u7B54\u306F\u3001\u3059\u3079\u3066\u306E\u30E6\u30FC\u30B6\u30FC\u306E\u4F53\u9A13\u3092\u5411\u4E0A\u3059\u308B\u305F\u3081\u306B\u5F79\u7ACB\u3061\u307E\u3059\u3002\u30A2\u30AB\u30A6\u30F3\u30C8\u3092\u524A\u9664\u3057\u305F\u5F8C\u3001\u30E6\u30FC\u30B6\u30FC\u306F\u300C\u65E7\u30E6\u30FC\u30B6\u30FC\u300D\u3068\u3057\u3066\u8868\u793A\u3055\u308C\u307E\u3059\u3002",
    "focused-task-close-account.delete-account.content-preview.footnote.self": "\u6CE8: \u3053\u306E\u30A2\u30F3\u30B1\u30FC\u30C8\u3078\u306E\u56DE\u7B54\u306F\u3001\u30A2\u30AB\u30A6\u30F3\u30C8\u3092\u524A\u9664\u3057\u3088\u3046\u3068\u3057\u3066\u3044\u308B\u30E6\u30FC\u30B6\u30FC\u3092\u542B\u3080\u3059\u3079\u3066\u306E\u30E6\u30FC\u30B6\u30FC\u4F53\u9A13\u306E\u5411\u4E0A\u306B\u5F79\u7ACB\u3061\u307E\u3059\u3002\u30A2\u30AB\u30A6\u30F3\u30C8\u3092\u524A\u9664\u3057\u305F\u5F8C\u3001\u3042\u306A\u305F\u306F\u300C\u65E7\u30E6\u30FC\u30B6\u30FC\u300D\u3068\u3057\u3066\u8868\u793A\u3055\u308C\u307E\u3059\u3002",
    "focused-task-close-account.delete-account.content-preview.formerUser": "\u65E7\u30E6\u30FC\u30B6\u30FC",
    "focused-task-close-account.delete-account.content-preview.heading.admin": "\u524A\u9664\u3055\u308C\u305F\u30E6\u30FC\u30B6\u30FC\u306F\u3069\u306E\u3088\u3046\u306B\u8868\u793A\u3055\u308C\u305F\u3089\u3044\u3044\u3068\u601D\u3044\u307E\u3059\u304B?",
    "focused-task-close-account.delete-account.content-preview.heading.self": "\u524A\u9664\u3055\u308C\u305F\u30A2\u30AB\u30A6\u30F3\u30C8\u306F\u3069\u306E\u3088\u3046\u306B\u8868\u793A\u3055\u308C\u305F\u3089\u3044\u3044\u3068\u601D\u3044\u307E\u3059\u304B?",
    "focused-task-close-account.delete-account.content-preview.line.survey.admin": "\u9078\u629E\u80A2\u304C\u3042\u308B\u3068\u3057\u305F\u3089\u3001\u524A\u9664\u3055\u308C\u305F\u30E6\u30FC\u30B6\u30FC\u304C\u4ED6\u306E\u30E6\u30FC\u30B6\u30FC\u306B\u5BFE\u3057\u3066\u3069\u306E\u3088\u3046\u306B\u8868\u793A\u3055\u308C\u308B\u3053\u3068\u3092\u5E0C\u671B\u3057\u307E\u3059\u304B?",
    "focused-task-close-account.delete-account.content-preview.line.survey.self": "\u9078\u629E\u80A2\u304C\u3042\u308B\u3068\u3057\u305F\u3089\u3001\u4ED6\u306E\u30E6\u30FC\u30B6\u30FC\u306B\u3069\u306E\u3088\u3046\u306B\u8868\u793A\u3055\u308C\u308B\u3053\u3068\u3092\u5E0C\u671B\u3057\u307E\u3059\u304B?",
    "focused-task-close-account.delete-account.content-preview.paragraph.survey.admin": "\u30A2\u30AB\u30A6\u30F3\u30C8\u304C\u524A\u9664\u3055\u308C\u308B\u3068\u3001\u305D\u306E\u30E6\u30FC\u30B6\u30FC\u306F\u4ED6\u306E\u30E6\u30FC\u30B6\u30FC\u306E\u753B\u9762\u3067\u300C\u65E7\u30E6\u30FC\u30B6\u30FC\u300D\u3068\u3057\u3066\u8868\u793A\u3055\u308C\u307E\u3059\u3002\u3053\u306E\u70B9\u306B\u3064\u3044\u3066\u3001\u4EE5\u4E0B\u306E\u30A2\u30F3\u30B1\u30FC\u30C8\u306B\u304A\u7B54\u3048\u304F\u3060\u3055\u3044\u3002",
    "focused-task-close-account.delete-account.content-preview.paragraph.survey.self": "\u30A2\u30AB\u30A6\u30F3\u30C8\u304C\u524A\u9664\u3055\u308C\u308B\u3068\u3001\u3042\u306A\u305F\u306F\u4ED6\u306E\u30E6\u30FC\u30B6\u30FC\u306E\u753B\u9762\u3067\u300C\u65E7\u30E6\u30FC\u30B6\u30FC\u300D\u3068\u3057\u3066\u8868\u793A\u3055\u308C\u307E\u3059\u3002\u3053\u306E\u70B9\u306B\u3064\u3044\u3066\u3001\u4EE5\u4E0B\u306E\u30A2\u30F3\u30B1\u30FC\u30C8\u306B\u304A\u7B54\u3048\u304F\u3060\u3055\u3044\u3002",
    "focused-task-close-account.delete-account.drop-down-collapse-button": "\u7701\u7565\u8868\u793A",
    "focused-task-close-account.delete-account.drop-down-expand-button": "\u3042\u3068 {num} \u500B",
    "focused-task-close-account.delete-account.overview.first.line.admin": "\u6B21\u306E\u30A2\u30AB\u30A6\u30F3\u30C8\u3092\u524A\u9664\u3057\u3088\u3046\u3068\u3057\u3066\u3044\u307E\u3059:",
    "focused-task-close-account.delete-account.overview.first.line.self": "\u6B21\u306E\u30A2\u30AB\u30A6\u30F3\u30C8\u3092\u524A\u9664\u3057\u3088\u3046\u3068\u3057\u3066\u3044\u307E\u3059:",
    "focused-task-close-account.delete-account.overview.heading.admin": "\u30A2\u30AB\u30A6\u30F3\u30C8\u306E\u524A\u9664",
    "focused-task-close-account.delete-account.overview.heading.self": "\u30A2\u30AB\u30A6\u30F3\u30C8\u306E\u524A\u9664",
    "focused-task-close-account.delete-account.overview.inline-dialog.content-created.admin": "\u88FD\u54C1\u3067\u4F5C\u6210\u3057\u305F\u30DA\u30FC\u30B8\u3001\u8AB2\u984C\u3001\u30B3\u30E1\u30F3\u30C8\u306A\u3069\u3002",
    "focused-task-close-account.delete-account.overview.inline-dialog.content-created.self": "\u88FD\u54C1\u3067\u4F5C\u6210\u3057\u305F\u30DA\u30FC\u30B8\u3001\u8AB2\u984C\u3001\u30B3\u30E1\u30F3\u30C8\u306A\u3069\u3002",
    "focused-task-close-account.delete-account.overview.inline-dialog.data-apps.admin": "\u3042\u306A\u305F\u3001\u307E\u305F\u306F\u4ED6\u306E\u30E6\u30FC\u30B6\u30FC\u304C\u30A2\u30C8\u30E9\u30B7\u30A2\u30F3\u88FD\u54C1\u306B\u6A5F\u80FD\u3092\u8FFD\u52A0\u3059\u308B\u30A2\u30D7\u30EA\u30B1\u30FC\u30B7\u30E7\u30F3\u3092\u30A4\u30F3\u30B9\u30C8\u30FC\u30EB\u3057\u3066\u3044\u308B\u53EF\u80FD\u6027\u304C\u3042\u308A\u307E\u3059\u3002\u3053\u308C\u3089\u306E\u30A2\u30D7\u30EA\u306F\u30E6\u30FC\u30B6\u30FC\u306E\u30D7\u30ED\u30D5\u30A1\u30A4\u30EB\u60C5\u5831\u3092\u4FDD\u5B58\u3057\u3066\u3044\u308B\u53EF\u80FD\u6027\u304C\u3042\u308A\u307E\u3059\u3002",
    "focused-task-close-account.delete-account.overview.inline-dialog.data-apps.self": "\u3042\u306A\u305F\u3001\u307E\u305F\u306F\u4ED6\u306E\u30E6\u30FC\u30B6\u30FC\u304C\u30A2\u30C8\u30E9\u30B7\u30A2\u30F3\u88FD\u54C1\u306B\u6A5F\u80FD\u3092\u8FFD\u52A0\u3059\u308B\u30A2\u30D7\u30EA\u30B1\u30FC\u30B7\u30E7\u30F3\u3092\u30A4\u30F3\u30B9\u30C8\u30FC\u30EB\u3057\u3066\u3044\u308B\u53EF\u80FD\u6027\u304C\u3042\u308A\u307E\u3059\u3002\u3053\u308C\u3089\u306E\u30A2\u30D7\u30EA\u306F\u30D7\u30ED\u30D5\u30A1\u30A4\u30EB\u60C5\u5831\u3092\u4FDD\u5B58\u3057\u3066\u3044\u308B\u53EF\u80FD\u6027\u304C\u3042\u308A\u307E\u3059\u3002",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.li1.admin": "\u8CA1\u52D9\u5831\u544A\u306E\u305F\u3081\u306B\u4FDD\u7BA1\u3059\u308B\u5FC5\u8981\u304C\u3042\u308B\u8CFC\u5165\u306B\u95A2\u3059\u308B\u60C5\u5831\u3002",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.li1.self": "\u8CA1\u52D9\u5831\u544A\u306E\u305F\u3081\u306B\u4FDD\u7BA1\u3059\u308B\u5FC5\u8981\u304C\u3042\u308B\u8CFC\u5165\u306B\u95A2\u3059\u308B\u60C5\u5831\u3002",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.li2.admin": "\u30A2\u30AB\u30A6\u30F3\u30C8\u306E\u524A\u9664\u3092\u793A\u3059\u8A18\u9332\u3002\u898F\u5236\u5F53\u5C40\u3078\u63D0\u51FA\u3059\u308B\u5FC5\u8981\u304C\u3042\u308B\u5834\u5408\u304C\u3042\u308A\u307E\u3059\u3002",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.li2.self": "\u30A2\u30AB\u30A6\u30F3\u30C8\u306E\u524A\u9664\u3092\u793A\u3059\u8A18\u9332\u3002\u898F\u5236\u5F53\u5C40\u3078\u63D0\u51FA\u3059\u308B\u5FC5\u8981\u304C\u3042\u308B\u5834\u5408\u304C\u3042\u308A\u307E\u3059\u3002",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.li3.admin": "\u9032\u884C\u4E2D\u306E\u8A34\u8A1F\u306E\u4E00\u90E8\u3067\u3042\u308A\u3001\u6CD5\u5F8B\u4E0A\u3001\u4FDD\u5B58\u3059\u308B\u5FC5\u8981\u306E\u3042\u308B\u30C7\u30FC\u30BF\u3002",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.li3.self": "\u9032\u884C\u4E2D\u306E\u8A34\u8A1F\u306E\u4E00\u90E8\u3067\u3042\u308A\u3001\u6CD5\u5F8B\u4E0A\u3001\u4FDD\u5B58\u3059\u308B\u5FC5\u8981\u306E\u3042\u308B\u30C7\u30FC\u30BF\u3002",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.p1.admin": "\u6B63\u5F53\u306A\u696D\u52D9\u4E0A\u307E\u305F\u306F\u6CD5\u5F8B\u4E0A\u306E\u76EE\u7684\u3067\u3001\u500B\u4EBA\u30C7\u30FC\u30BF\u3092\u9650\u3089\u308C\u305F\u671F\u9593\u4FDD\u7BA1\u3057\u307E\u3059\u3002\u4F8B:",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.p1.self": "\u6B63\u5F53\u306A\u696D\u52D9\u4E0A\u307E\u305F\u306F\u6CD5\u5F8B\u4E0A\u306E\u76EE\u7684\u3067\u3001\u500B\u4EBA\u60C5\u5831\u3092\u9650\u3089\u308C\u305F\u671F\u9593\u4FDD\u7BA1\u3057\u307E\u3059\u3002\u4F8B:",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.p2.admin": "\u30DA\u30FC\u30B8\u3084\u8AB2\u984C\u306B\u5165\u529B\u3055\u308C\u305F\u540D\u524D\u3084\u30E1\u30FC\u30EB \u30A2\u30C9\u30EC\u30B9\u306A\u3069\u3001\u30E6\u30FC\u30B6\u30FC\u304C\u4F5C\u6210\u3057\u305F\u30B3\u30F3\u30C6\u30F3\u30C4\u304B\u3089\u500B\u4EBA\u60C5\u5831\u304C\u524A\u9664\u3055\u308C\u308B\u3053\u3068\u306F\u3042\u308A\u307E\u305B\u3093\u3002\u3053\u308C\u3089\u306E\u500B\u4EBA\u60C5\u5831\u306F\u88FD\u54C1\u7BA1\u7406\u8005\u304C\u624B\u52D5\u3067\u524A\u9664\u3059\u308B\u5FC5\u8981\u304C\u3042\u308A\u307E\u3059\u3002",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.p2.self": "\u30DA\u30FC\u30B8\u3084\u8AB2\u984C\u306B\u5165\u529B\u3055\u308C\u305F\u540D\u524D\u3084\u30E1\u30FC\u30EB \u30A2\u30C9\u30EC\u30B9\u306A\u3069\u3001\u3042\u306A\u305F\u3084\u4ED6\u306E\u4EBA\u304C\u4F5C\u6210\u3057\u305F\u30B3\u30F3\u30C6\u30F3\u30C4\u304B\u3089\u500B\u4EBA\u60C5\u5831\u304C\u524A\u9664\u3055\u308C\u308B\u3053\u3068\u306F\u3042\u308A\u307E\u305B\u3093\u3002\u3053\u308C\u3089\u306E\u500B\u4EBA\u60C5\u5831\u306F\u88FD\u54C1\u7BA1\u7406\u8005\u304C\u624B\u52D5\u3067\u524A\u9664\u3059\u308B\u5FC5\u8981\u304C\u3042\u308A\u307E\u3059\u3002",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.p3.admin": "\u30E6\u30FC\u30B6\u30FC\u306F\u81EA\u56FD\u306E\u76E3\u7763\u5F53\u5C40\u306B\u82E6\u60C5\u3092\u63D0\u8D77\u3059\u308B\u6A29\u5229\u3092\u6709\u3057\u3066\u3044\u307E\u3059\u3002",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.p3.self": "\u304A\u5BA2\u69D8\u306F\u304A\u4F4F\u307E\u3044\u306E\u5730\u57DF\u306E\u76E3\u7763\u5F53\u5C40\u306B\u82E6\u60C5\u3092\u63D0\u8D77\u3059\u308B\u6A29\u5229\u3092\u6709\u3057\u3066\u3044\u307E\u3059\u3002",
    "focused-task-close-account.delete-account.overview.paragraph.about-to-delete.admin": "\u30A2\u30AB\u30A6\u30F3\u30C8\u3092\u524A\u9664\u3059\u308B\u3068:",
    "focused-task-close-account.delete-account.overview.paragraph.about-to-delete.self": "\u30A2\u30AB\u30A6\u30F3\u30C8\u3092\u524A\u9664\u3059\u308B\u3068:",
    "focused-task-close-account.delete-account.overview.paragraph.content-created.admin": "\u4F5C\u6210\u3057\u305F\u30B3\u30F3\u30C6\u30F3\u30C4\u306F Atlassian \u30A2\u30AB\u30A6\u30F3\u30C8 \u30B5\u30FC\u30D3\u30B9\u304B\u3089\u524A\u9664\u3055\u308C\u307E\u305B\u3093\u3002",
    "focused-task-close-account.delete-account.overview.paragraph.content-created.self": "\u4F5C\u6210\u3057\u305F\u30B3\u30F3\u30C6\u30F3\u30C4\u306F Atlassian \u30A2\u30AB\u30A6\u30F3\u30C8 \u30B5\u30FC\u30D3\u30B9\u304B\u3089\u524A\u9664\u3055\u308C\u307E\u305B\u3093\u3002",
    "focused-task-close-account.delete-account.overview.paragraph.grace-period.admin": "14 \u65E5\u9593\u306E\u7336\u4E88\u671F\u9593\u5F8C\u306F\u3001\u30A2\u30AB\u30A6\u30F3\u30C8\u306E\u524A\u9664\u3092\u53D6\u308A\u6D88\u3059\u3053\u3068\u306F\u3067\u304D\u307E\u305B\u3093\u3002",
    "focused-task-close-account.delete-account.overview.paragraph.list-of-apps-with-personal-data.admin": "\u500B\u4EBA\u60C5\u5831\u3092\u4FDD\u5B58\u3057\u3066\u3044\u308B\u53EF\u80FD\u6027\u306E\u3042\u308B\u30A2\u30D7\u30EA\u306E\u4E00\u89A7\u3092\u30E1\u30FC\u30EB\u3067\u304A\u77E5\u3089\u305B\u3057\u307E\u3059\u3002",
    "focused-task-close-account.delete-account.overview.paragraph.list-of-apps-with-personal-data.self": "\u500B\u4EBA\u60C5\u5831\u3092\u4FDD\u5B58\u3057\u3066\u3044\u308B\u53EF\u80FD\u6027\u306E\u3042\u308B\u30A2\u30D7\u30EA\u306E\u4E00\u89A7\u3092\u30E1\u30FC\u30EB\u3067\u304A\u77E5\u3089\u305B\u3057\u307E\u3059\u3002",
    "focused-task-close-account.delete-account.overview.paragraph.loseAccess.admin": "{fullName} \u3055\u3093\u306F Atlassian \u306E\u3059\u3079\u3066\u306E\u30A2\u30AB\u30A6\u30F3\u30C8 \u30B5\u30FC\u30D3\u30B9\u3078\u306E<b>\u30A2\u30AF\u30BB\u30B9\u6A29\u9650\u3092\u76F4\u3061\u306B\u5931\u3044\u307E\u3059</b>\u3002\u73FE\u5728\u30A2\u30AF\u30BB\u30B9\u6A29\u9650\u306E\u3042\u308B\u30B5\u30FC\u30D3\u30B9:",
    "focused-task-close-account.delete-account.overview.paragraph.loseAccess.admin.noSites": "{fullName} \u3055\u3093\u306F Atlassian \u306E\u3059\u3079\u3066\u306E\u30A2\u30AB\u30A6\u30F3\u30C8 \u30B5\u30FC\u30D3\u30B9\u3078\u306E<b>\u30A2\u30AF\u30BB\u30B9\u6A29\u9650\u3092\u76F4\u3061\u306B\u5931\u3044\u307E\u3059</b>\u3002\u73FE\u5728\u3001\u30B3\u30DF\u30E5\u30CB\u30C6\u30A3\u3084 Marketplace \u306A\u3069\u306E\u30B5\u30FC\u30D3\u30B9\u3092\u9664\u3044\u3066\u3001\u30A2\u30AF\u30BB\u30B9\u6A29\u9650\u306F\u3042\u308A\u307E\u305B\u3093\u3002",
    "focused-task-close-account.delete-account.overview.paragraph.loseAccess.footnote": "\u30A2\u30C8\u30E9\u30B7\u30A2\u30F3 \u30B3\u30DF\u30E5\u30CB\u30C6\u30A3\u3084 Marketplace \u306A\u3069\u3001\u305D\u306E\u4ED6\u306E Atlassian \u30A2\u30AB\u30A6\u30F3\u30C8 \u30B5\u30FC\u30D3\u30B9\u3002",
    "focused-task-close-account.delete-account.overview.paragraph.loseAccess.self": "\u30A2\u30C8\u30E9\u30B7\u30A2\u30F3\u306E\u3059\u3079\u3066\u306E\u30A2\u30AB\u30A6\u30F3\u30C8 \u30B5\u30FC\u30D3\u30B9\u3078\u306E<b>\u30A2\u30AF\u30BB\u30B9\u6A29\u9650\u3092\u76F4\u3061\u306B\u5931\u3044\u307E\u3059</b>\u3002 \u73FE\u5728\u30A2\u30AF\u30BB\u30B9\u6A29\u9650\u306E\u3042\u308B\u30B5\u30FC\u30D3\u30B9:",
    "focused-task-close-account.delete-account.overview.paragraph.loseAccess.self.noSites": "\u30A2\u30C8\u30E9\u30B7\u30A2\u30F3\u306E\u3059\u3079\u3066\u306E\u30A2\u30AB\u30A6\u30F3\u30C8 \u30B5\u30FC\u30D3\u30B9\u3078\u306E<b>\u30A2\u30AF\u30BB\u30B9\u6A29\u9650\u3092\u76F4\u3061\u306B\u5931\u3044\u307E\u3059</b>\u3002\u73FE\u5728\u3001\u30B3\u30DF\u30E5\u30CB\u30C6\u30A3\u3084 Marketplace \u306A\u3069\u306E\u30B5\u30FC\u30D3\u30B9\u3092\u9664\u3044\u3066\u3001\u30A2\u30AF\u30BB\u30B9\u6A29\u9650\u306F\u3042\u308A\u307E\u305B\u3093\u3002",
    "focused-task-close-account.delete-account.overview.paragraph.personal-data-will-be-deleted.admin": "\u6B63\u5F53\u306A\u696D\u52D9\u4E0A\u307E\u305F\u306F\u6CD5\u5F8B\u4E0A\u306E\u76EE\u7684\u3067\u5FC5\u8981\u3068\u3055\u308C\u308B\u5834\u5408\u3092\u9664\u304D\u300130 \u65E5\u4EE5\u5185\u306B Atlassian \u30A2\u30AB\u30A6\u30F3\u30C8 \u30B5\u30FC\u30D3\u30B9\u304B\u3089\u6C0F\u540D\u3084\u30E1\u30FC\u30EB \u30A2\u30C9\u30EC\u30B9\u306A\u3069\u306E<b>\u500B\u4EBA\u60C5\u5831\u306F\u524A\u9664</b>\u3055\u308C\u307E\u3059\u3002",
    "focused-task-close-account.delete-account.overview.paragraph.personal-data-will-be-deleted.self": "\u6B63\u5F53\u306A\u696D\u52D9\u4E0A\u307E\u305F\u306F\u6CD5\u5F8B\u4E0A\u306E\u76EE\u7684\u3067\u5FC5\u8981\u3068\u3055\u308C\u308B\u5834\u5408\u3092\u9664\u304D\u300130 \u65E5\u4EE5\u5185\u306B Atlassian \u30A2\u30AB\u30A6\u30F3\u30C8 \u30B5\u30FC\u30D3\u30B9\u304B\u3089\u6C0F\u540D\u3084\u30E1\u30FC\u30EB \u30A2\u30C9\u30EC\u30B9\u306A\u3069\u306E<b>\u500B\u4EBA\u60C5\u5831\u306F\u524A\u9664</b>\u3055\u308C\u307E\u3059\u3002",
    "focused-task-close-account.delete-account.overview.warning-section.body": "14 \u65E5\u9593\u306E\u7336\u4E88\u671F\u9593\u5F8C\u306F\u3001\u30A2\u30AB\u30A6\u30F3\u30C8\u306E\u524A\u9664\u3092\u53D6\u308A\u6D88\u3059\u3053\u3068\u306F\u3067\u304D\u307E\u305B\u3093\u3002\u5F8C\u3067\u30A2\u30AB\u30A6\u30F3\u30C8\u304C\u5FC5\u8981\u306B\u306A\u308B\u3068\u601D\u308F\u308C\u308B\u5834\u5408\u306F\u3001\u4EE3\u308F\u308A\u306B\u30A2\u30AB\u30A6\u30F3\u30C8\u3092\u7121\u52B9\u306B\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
    "focused-task-close-account.delete-account.overview.warning-section.deactivated.body": "14 \u65E5\u9593\u306E\u7336\u4E88\u671F\u9593\u5F8C\u306F\u3001\u30A2\u30AB\u30A6\u30F3\u30C8\u306E\u524A\u9664\u3092\u53D6\u308A\u6D88\u3059\u3053\u3068\u306F\u3067\u304D\u307E\u305B\u3093\u3002",
    "focused-task-close-account.learnMore": "\u8A73\u7D30",
    "focused-task-close-account.next": "\u6B21\u3078",
    "focused-task-close-account.previous": "\u623B\u308B"
};

});

parcelRegister("hLCIS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cef4dd025124b843$export$2e2bcd8739ae039; });
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Korean
var $cef4dd025124b843$export$2e2bcd8739ae039 = {
    "focused-task-close-account.cancel": "\uCDE8\uC18C",
    "focused-task-close-account.deactivate-account": "\uACC4\uC815 \uBE44\uD65C\uC131\uD654",
    "focused-task-close-account.deactivate-account.overview.first.line.admin": "\uB2E4\uC74C \uC0AC\uC6A9\uC790 \uACC4\uC815\uC744 \uBE44\uD65C\uC131\uD654\uD558\uB824\uACE0 \uD569\uB2C8\uB2E4:",
    "focused-task-close-account.deactivate-account.overview.first.line.self": "\uB2E4\uC74C \uC0AC\uC6A9\uC790 \uACC4\uC815\uC744 \uBE44\uD65C\uC131\uD654\uD558\uB824\uACE0 \uD569\uB2C8\uB2E4:",
    "focused-task-close-account.deactivate-account.overview.heading.admin": "\uACC4\uC815 \uBE44\uD65C\uC131\uD654",
    "focused-task-close-account.deactivate-account.overview.heading.self": "\uACC4\uC815 \uBE44\uD65C\uC131\uD654",
    "focused-task-close-account.deactivate-account.overview.last.line.admin": "\uC5B8\uC81C\uB4E0\uC9C0 \uACC4\uC815\uC744 \uB2E4\uC2DC \uD65C\uC131\uD654\uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4.",
    "focused-task-close-account.deactivate-account.overview.last.line.self": "\uC5B8\uC81C\uB4E0\uC9C0 \uACC4\uC815\uC744 \uB2E4\uC2DC \uD65C\uC131\uD654\uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4.",
    "focused-task-close-account.deactivate-account.overview.paragraph.about-to-deactivate.admin": "\uACC4\uC815\uC744 \uBE44\uD65C\uC131\uD654\uD560 \uB54C:",
    "focused-task-close-account.deactivate-account.overview.paragraph.about-to-deactivate.self": "\uACC4\uC815\uC744 \uBE44\uD65C\uC131\uD654\uD560 \uB54C:",
    "focused-task-close-account.deactivate-account.overview.paragraph.billing.admin": "\uC774\uC5D0 \uB300\uD574 \uB354 \uC774\uC0C1 \uCCAD\uAD6C\uB97C \uBC1B\uC9C0 \uC54A\uC744 \uAC83\uC785\uB2C8\uB2E4.",
    "focused-task-close-account.deactivate-account.overview.paragraph.billing.self": "\uC774\uC5D0 \uB300\uD574 \uB354 \uC774\uC0C1 \uCCAD\uAD6C\uB97C \uBC1B\uC9C0 \uC54A\uC744 \uAC83\uC785\uB2C8\uB2E4.",
    "focused-task-close-account.deactivate-account.overview.paragraph.loseAccess.admin": "{fullName}\uC740(\uB294) \uBAA8\uB4E0 Atlassian \uACC4\uC815 \uC11C\uBE44\uC2A4\uC5D0 \uB300\uD55C <b>\uC561\uC138\uC2A4 \uAD8C\uD55C\uC744 \uC989\uC2DC \uC0C1\uC2E4</b>\uD558\uAC8C \uB429\uB2C8\uB2E4. \uD604\uC7AC \uC561\uC138\uC2A4\uD560 \uC218 \uC788\uB294 \uD56D\uBAA9\uC740 \uB2E4\uC74C\uACFC \uAC19\uC2B5\uB2C8\uB2E4.",
    "focused-task-close-account.deactivate-account.overview.paragraph.loseAccess.admin.noSites": "{fullName}\uC740(\uB294) \uBAA8\uB4E0 Atlassian \uACC4\uC815 \uC11C\uBE44\uC2A4\uC5D0 \uB300\uD55C <b>\uC561\uC138\uC2A4 \uAD8C\uD55C\uC744 \uC989\uC2DC \uC0C1\uC2E4</b>\uD558\uAC8C \uB429\uB2C8\uB2E4. \uD604\uC7AC \uC0AC\uC6A9\uC790\uB294 \uCEE4\uBBA4\uB2C8\uD2F0 \uBC0F Marketplace\uC640 \uAC19\uC740 \uC11C\uBE44\uC2A4 \uC678\uC5D0 \uC561\uC138\uC2A4 \uAD8C\uD55C\uC744 \uAC00\uC9C0\uACE0 \uC788\uC9C0 \uC54A\uC2B5\uB2C8\uB2E4.",
    "focused-task-close-account.deactivate-account.overview.paragraph.loseAccess.footnote": "Atlassian \uCEE4\uBBA4\uB2C8\uD2F0 \uBC0F Marketplace\uC640 \uAC19\uC740 \uAE30\uD0C0 Atlassian \uACC4\uC815 \uC11C\uBE44\uC2A4.",
    "focused-task-close-account.deactivate-account.overview.paragraph.loseAccess.self": "\uC0AC\uC6A9\uC790\uB294 \uC989\uC2DC Atlassian \uACC4\uC815 \uC11C\uBE44\uC2A4\uC5D0 \uB300\uD55C <b>\uC561\uC138\uC2A4 \uAD8C\uD55C\uC744 \uC0C1\uC2E4</b>\uD558\uAC8C \uB429\uB2C8\uB2E4. \uD604\uC7AC \uC561\uC138\uC2A4\uD560 \uC218 \uC788\uB294 \uD56D\uBAA9\uC740 \uB2E4\uC74C\uACFC \uAC19\uC2B5\uB2C8\uB2E4.",
    "focused-task-close-account.deactivate-account.overview.paragraph.loseAccess.self.noSites": "\uC0AC\uC6A9\uC790\uB294 \uBAA8\uB4E0 Atlassian \uACC4\uC815 \uC11C\uBE44\uC2A4\uC5D0 \uB300\uD55C <b>\uC561\uC138\uC2A4 \uAD8C\uD55C\uC744 \uC989\uC2DC \uC0C1\uC2E4</b>\uD558\uAC8C \uB429\uB2C8\uB2E4. \uD604\uC7AC \uADC0\uD558\uB294 \uCEE4\uBBA4\uB2C8\uD2F0 \uBC0F Marketplace\uC640 \uAC19\uC740 \uC11C\uBE44\uC2A4 \uC678\uC5D0\uB294 \uC561\uC138\uC2A4 \uAD8C\uD55C\uC744 \uAC00\uC9C0\uACE0 \uC788\uC9C0 \uC54A\uC2B5\uB2C8\uB2E4.",
    "focused-task-close-account.deactivate-account.overview.paragraph.personal-data.admin": "\uC0AC\uC6A9\uC790\uC758 \uC131\uBA85 \uBC0F \uC774\uBA54\uC77C \uC8FC\uC18C\uC640 \uAC19\uC740 \uAC1C\uC778 \uB370\uC774\uD130 \uBC0F \uC0AC\uC6A9\uC790\uAC00 \uB9CC\uB4E0 \uCF58\uD150\uCE20\uB294 Atlassian \uACC4\uC815 \uC11C\uBE44\uC2A4 \uB0B4\uC5D0 \uB0A8\uC2B5\uB2C8\uB2E4.",
    "focused-task-close-account.deactivate-account.overview.paragraph.personal-data.self": "\uC0AC\uC6A9\uC790\uC758 \uC131\uBA85 \uBC0F \uC774\uBA54\uC77C \uC8FC\uC18C\uC640 \uAC19\uC740 \uAC1C\uC778 \uB370\uC774\uD130 \uBC0F \uC0AC\uC6A9\uC790\uAC00 \uB9CC\uB4E0 \uCF58\uD150\uCE20\uB294 Atlassian \uACC4\uC815 \uC11C\uBE44\uC2A4 \uB0B4\uC5D0 \uB0A8\uC2B5\uB2C8\uB2E4.",
    "focused-task-close-account.delete-account": "\uACC4\uC815 \uC0AD\uC81C",
    "focused-task-close-account.delete-account.content-preview.footnote.admin": "\uCC38\uACE0: \uC774 \uC124\uBB38\uC870\uC0AC\uC758 \uC9C8\uBB38\uC5D0 \uB2F5\uD574\uC8FC\uC2DC\uBA74 Atlassian\uC5D0\uC11C \uBAA8\uB4E0 \uC0AC\uC6A9\uC790\uC5D0\uAC8C \uB354 \uB098\uC740 \uACBD\uD5D8\uC744 \uC81C\uACF5\uD558\uB294 \uB370 \uB3C4\uC6C0\uC774 \uB429\uB2C8\uB2E4. \uACC4\uC815\uC744 \uC0AD\uC81C\uD55C \uD6C4\uC5D0 \uC0AD\uC81C\uB41C \uC0AC\uC6A9\uC790\uB294 \uC5EC\uC804\uD788 '\uC774\uC804 \uC0AC\uC6A9\uC790'\uB85C \uD45C\uC2DC\uB429\uB2C8\uB2E4.",
    "focused-task-close-account.delete-account.content-preview.footnote.self": "\uCC38\uACE0: \uC774 \uC124\uBB38\uC870\uC0AC\uC758 \uC9C8\uBB38\uC5D0 \uB2F5\uD574\uC8FC\uC2DC\uBA74 \uACC4\uC815\uC744 \uC0AD\uC81C\uD558\uB294 \uC0AC\uC6A9\uC790\uB97C \uD3EC\uD568\uD558\uC5EC Atlassian\uC5D0\uC11C \uBAA8\uB4E0 \uC0AC\uC6A9\uC790\uC5D0\uAC8C \uB354 \uB098\uC740 \uACBD\uD5D8\uC744 \uC81C\uACF5\uD558\uB294 \uB370 \uB3C4\uC6C0\uC774 \uB429\uB2C8\uB2E4. \uACC4\uC815\uC744 \uC0AD\uC81C\uD55C \uD6C4\uC5D0 \uC5EC\uC804\uD788 '\uC774\uC804 \uC0AC\uC6A9\uC790'\uB85C \uD45C\uC2DC\uB429\uB2C8\uB2E4.",
    "focused-task-close-account.delete-account.content-preview.formerUser": "\uC774\uC804 \uC0AC\uC6A9\uC790",
    "focused-task-close-account.delete-account.content-preview.heading.admin": "\uC0AD\uC81C\uB41C \uC0AC\uC6A9\uC790\uAC00 \uC5B4\uB5BB\uAC8C \uD45C\uC2DC\uB418\uAE38 \uC6D0\uD558\uC2ED\uB2C8\uAE4C?",
    "focused-task-close-account.delete-account.content-preview.heading.self": "\uC0AD\uC81C\uB41C \uACC4\uC815\uC774 \uC5B4\uB5BB\uAC8C \uD45C\uC2DC\uB418\uAE38 \uC6D0\uD558\uC2ED\uB2C8\uAE4C?",
    "focused-task-close-account.delete-account.content-preview.line.survey.admin": "\uC120\uD0DD\uD560 \uC218 \uC788\uB2E4\uBA74, \uC0AD\uC81C\uB41C \uC0AC\uC6A9\uC790\uAC00 \uB2E4\uB978 \uC0AC\uC6A9\uC790\uC5D0\uAC8C \uC5B4\uB5BB\uAC8C \uD45C\uC2DC\uB418\uAE30\uB97C \uC6D0\uD558\uC2DC\uB098\uC694?",
    "focused-task-close-account.delete-account.content-preview.line.survey.self": "\uC120\uD0DD\uD560 \uC218 \uC788\uB2E4\uBA74, \uB2E4\uB978 \uC0AC\uC6A9\uC790\uC5D0\uAC8C \uC5B4\uB5BB\uAC8C \uD45C\uC2DC\uB418\uAE30\uB97C \uC6D0\uD558\uC2DC\uB098\uC694?",
    "focused-task-close-account.delete-account.content-preview.paragraph.survey.admin": "\uC0AC\uC6A9\uC790 \uACC4\uC815\uC774 \uC0AD\uC81C\uB41C \uD6C4\uC5D0 \uC774\uB4E4\uC740 \uB2E4\uB978 \uC0AC\uC6A9\uC790\uC5D0\uAC8C '\uC774\uC804 \uC0AC\uC6A9\uC790'\uB85C \uD45C\uC2DC\uB429\uB2C8\uB2E4. \uC7A0\uC2DC \uC2DC\uAC04\uC744 \uB0B4\uC5B4 \uC124\uBB38\uC870\uC0AC \uC9C8\uBB38\uC5D0 \uB2F5\uD574\uC8FC\uC138\uC694.",
    "focused-task-close-account.delete-account.content-preview.paragraph.survey.self": "\uC0AC\uC6A9\uC790 \uACC4\uC815\uC774 \uC0AD\uC81C\uB41C \uD6C4\uC5D0 \uB2E4\uB978 \uC0AC\uC6A9\uC790\uC5D0\uAC8C '\uC774\uC804 \uC0AC\uC6A9\uC790'\uB85C \uD45C\uC2DC\uB429\uB2C8\uB2E4. \uC7A0\uC2DC \uC2DC\uAC04\uC744 \uB0B4\uC5B4 \uC124\uBB38\uC870\uC0AC \uC9C8\uBB38\uC5D0 \uB2F5\uD574\uC8FC\uC138\uC694.",
    "focused-task-close-account.delete-account.drop-down-collapse-button": "\uAC04\uB7B5\uD788 \uBCF4\uAE30",
    "focused-task-close-account.delete-account.drop-down-expand-button": "\uC678 {num}\uAC1C",
    "focused-task-close-account.delete-account.overview.first.line.admin": "\uB2E4\uC74C\uC758 \uACC4\uC815\uC744 \uC0AD\uC81C\uD558\uB824\uACE0 \uD569\uB2C8\uB2E4:",
    "focused-task-close-account.delete-account.overview.first.line.self": "\uBCF8\uC778\uC758 \uB2E4\uC74C \uACC4\uC815\uC744 \uC0AD\uC81C\uD558\uB824\uACE0 \uD569\uB2C8\uB2E4:",
    "focused-task-close-account.delete-account.overview.heading.admin": "\uACC4\uC815 \uC0AD\uC81C",
    "focused-task-close-account.delete-account.overview.heading.self": "\uC0AC\uC6A9\uC790 \uACC4\uC815 \uC0AD\uC81C",
    "focused-task-close-account.delete-account.overview.inline-dialog.content-created.admin": "\uC608\uB97C \uB4E4\uC5B4 \uC0AC\uC6A9\uC790\uAC00 \uC81C\uD488 \uB0B4\uC5D0\uC11C \uB9CC\uB4E0 \uD398\uC774\uC9C0, \uC774\uC288 \uBC0F \uB313\uAE00\uC785\uB2C8\uB2E4.",
    "focused-task-close-account.delete-account.overview.inline-dialog.content-created.self": "\uC608\uB97C \uB4E4\uC5B4 \uADC0\uD558\uAC00 \uC81C\uD488 \uB0B4\uC5D0\uC11C \uB9CC\uB4E0 \uD398\uC774\uC9C0, \uC774\uC288 \uBC0F \uB313\uAE00\uC785\uB2C8\uB2E4.",
    "focused-task-close-account.delete-account.overview.inline-dialog.data-apps.admin": "\uADC0\uD558 \uB610\uB294 \uB2E4\uB978 \uC0AC\uC6A9\uC790\uAC00 Atlassian \uC81C\uD488\uC5D0 \uAE30\uB2A5\uC744 \uCD94\uAC00\uD558\uB294 \uC571\uC744 \uC124\uCE58\uD588\uC744 \uC218 \uC788\uC2B5\uB2C8\uB2E4. \uC774\uB7F0 \uC571\uC740 \uC0AC\uC6A9\uC790\uC758 \uD504\uB85C\uD544 \uC815\uBCF4\uB97C \uC800\uC7A5\uD588\uC744 \uC218 \uC788\uC2B5\uB2C8\uB2E4.",
    "focused-task-close-account.delete-account.overview.inline-dialog.data-apps.self": "\uADC0\uD558 \uB610\uB294 \uB2E4\uB978 \uC0AC\uC6A9\uC790\uAC00 Atlassian \uC81C\uD488\uC5D0 \uAE30\uB2A5\uC744 \uCD94\uAC00\uD558\uB294 \uC571\uC744 \uC124\uCE58\uD588\uC744 \uC218 \uC788\uC2B5\uB2C8\uB2E4. \uC774\uB7F0 \uC571\uC740 \uC0AC\uC6A9\uC790\uC758 \uD504\uB85C\uD544 \uC815\uBCF4\uB97C \uC800\uC7A5\uD588\uC744 \uC218 \uC788\uC2B5\uB2C8\uB2E4.",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.li1.admin": "\uC7AC\uC815 \uBCF4\uACE0\uC11C\uB97C \uC704\uD574 \uBCF4\uC874\uD558\uB294 \uAD6C\uB9E4 \uAD00\uB828 \uC815\uBCF4\uC785\uB2C8\uB2E4.",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.li1.self": "\uC7AC\uC815 \uBCF4\uACE0\uC11C\uB97C \uC704\uD574 \uBCF4\uC874\uD558\uB294 \uAD6C\uB9E4 \uAD00\uB828 \uC815\uBCF4\uC785\uB2C8\uB2E4.",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.li2.admin": "Atlassian\uC774 \uC0AD\uC81C\uD55C \uC0AC\uC6A9\uC790 \uACC4\uC815\uC5D0 \uB300\uD55C \uAE30\uB85D\uC73C\uB85C \uD544\uC694\uD55C \uACBD\uC6B0 \uADDC\uC81C \uAE30\uAD00\uC5D0 \uC81C\uACF5\uD569\uB2C8\uB2E4.",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.li2.self": "Atlassian\uC774 \uC0AD\uC81C\uD55C \uC0AC\uC6A9\uC790 \uACC4\uC815\uC5D0 \uB300\uD55C \uAE30\uB85D\uC73C\uB85C \uD544\uC694\uD55C \uACBD\uC6B0 \uADDC\uC81C \uAE30\uAD00\uC5D0 \uC81C\uACF5\uD569\uB2C8\uB2E4.",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.li3.admin": "\uC9C4\uD589 \uC911\uC778 \uC18C\uC1A1\uC758 \uC77C\uBD80\uC5D0 \uD574\uB2F9\uD558\uB294 \uB370\uC774\uD130\uB85C \uBC95\uC5D0 \uB530\uB77C \uBCF4\uC874\uD574\uC57C \uD569\uB2C8\uB2E4.",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.li3.self": "\uC9C4\uD589 \uC911\uC778 \uC18C\uC1A1\uC758 \uC77C\uBD80\uC5D0 \uD574\uB2F9\uD558\uB294 \uB370\uC774\uD130\uB85C \uBC95\uC5D0 \uB530\uB77C \uBCF4\uC874\uD574\uC57C \uD569\uB2C8\uB2E4.",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.p1.admin": "Atlassian\uC740 \uD569\uBC95\uC801\uC778 \uBE44\uC988\uB2C8\uC2A4 \uB610\uB294 \uBC95\uB960\uC0C1\uC758 \uBAA9\uC801\uC774 \uC788\uC73C\uBA74 \uC81C\uD55C\uB41C \uAE30\uAC04 \uB3D9\uC548 \uAC1C\uC778 \uB370\uC774\uD130\uB97C \uBCF4\uC874\uD569\uB2C8\uB2E4. \uC77C\uBD80 \uC608\uB294 \uB2E4\uC74C\uACFC \uAC19\uC2B5\uB2C8\uB2E4.",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.p1.self": "Atlassian\uC740 \uD569\uBC95\uC801\uC778 \uBE44\uC988\uB2C8\uC2A4 \uB610\uB294 \uBC95\uB960\uC0C1\uC758 \uBAA9\uC801\uC774 \uC788\uC73C\uBA74 \uC81C\uD55C\uB41C \uAE30\uAC04 \uB3D9\uC548 \uAC1C\uC778 \uB370\uC774\uD130\uB97C \uBCF4\uC874\uD569\uB2C8\uB2E4. \uC77C\uBD80 \uC608\uB294 \uB2E4\uC74C\uACFC \uAC19\uC2B5\uB2C8\uB2E4.",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.p2.admin": "\uD398\uC774\uC9C0 \uB610\uB294 \uC774\uC288\uC5D0 \uC785\uB825\uD55C \uC774\uB984 \uB610\uB294 \uC774\uBA54\uC77C \uC8FC\uC18C\uC640 \uAC19\uC774 \uC0AC\uC6A9\uC790\uAC00 \uB9CC\uB4E0 \uCF58\uD150\uCE20 \uB0B4\uC758 \uAC1C\uC778\uC801\uC778 \uC815\uBCF4\uB294 \uC0AD\uC81C\uB418\uC9C0 \uC54A\uC2B5\uB2C8\uB2E4. \uC81C\uD488 \uAD00\uB9AC\uC790\uAC00 \uC218\uB3D9\uC73C\uB85C \uC774\uB7F0 \uB370\uC774\uD130\uB97C \uC0AD\uC81C\uD574\uC57C \uD569\uB2C8\uB2E4.",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.p2.self": "\uD398\uC774\uC9C0 \uB610\uB294 \uC774\uC288\uC5D0 \uC785\uB825\uD55C \uC774\uB984 \uB610\uB294 \uC774\uBA54\uC77C \uC8FC\uC18C\uC640 \uAC19\uC774 \uC0AC\uC6A9\uC790 \uB610\uB294 \uB2E4\uB978 \uC0AC\uC6A9\uC790\uAC00 \uB9CC\uB4E0 \uCF58\uD150\uCE20 \uB0B4\uC758 \uAC1C\uC778\uC801\uC778 \uC815\uBCF4\uB294 \uC0AD\uC81C\uB418\uC9C0 \uC54A\uC2B5\uB2C8\uB2E4. \uC81C\uD488 \uAD00\uB9AC\uC790\uAC00 \uC218\uB3D9\uC73C\uB85C \uC774\uB7F0 \uB370\uC774\uD130\uB97C \uC0AD\uC81C\uD574\uC57C \uD569\uB2C8\uB2E4.",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.p3.admin": "\uC0AC\uC6A9\uC790\uC758 \uC790\uC2E0\uC758 \uAD6D\uAC00\uC758 \uAC10\uB3C5 \uAE30\uAD00\uC5D0 \uC774\uC758 \uC0AC\uD56D\uC744 \uC81C\uCD9C\uD560 \uAD8C\uB9AC\uAC00 \uC788\uC2B5\uB2C8\uB2E4.",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.p3.self": "\uC0AC\uC6A9\uC790\uC758 \uC790\uC2E0\uC758 \uAD6D\uAC00\uC758 \uAC10\uB3C5 \uAE30\uAD00\uC5D0 \uC774\uC758 \uC0AC\uD56D\uC744 \uC81C\uCD9C\uD560 \uAD8C\uB9AC\uAC00 \uC788\uC2B5\uB2C8\uB2E4.",
    "focused-task-close-account.delete-account.overview.paragraph.about-to-delete.admin": "\uACC4\uC815\uC744 \uC0AD\uC81C\uD560 \uB54C:",
    "focused-task-close-account.delete-account.overview.paragraph.about-to-delete.self": "\uACC4\uC815\uC744 \uC0AD\uC81C\uD560 \uB54C:",
    "focused-task-close-account.delete-account.overview.paragraph.content-created.admin": "\uC0AC\uC6A9\uC790\uAC00 \uB9CC\uB4E0 \uCF58\uD150\uCE20\uB294 Atlassian \uACC4\uC815 \uC11C\uBE44\uC2A4 \uB0B4\uC5D0 \uB0A8\uC2B5\uB2C8\uB2E4.",
    "focused-task-close-account.delete-account.overview.paragraph.content-created.self": "\uC0AC\uC6A9\uC790\uAC00 \uB9CC\uB4E0 \uCF58\uD150\uCE20\uB294 Atlassian \uACC4\uC815 \uC11C\uBE44\uC2A4 \uB0B4\uC5D0 \uB0A8\uC2B5\uB2C8\uB2E4.",
    "focused-task-close-account.delete-account.overview.paragraph.grace-period.admin": "14\uC77C\uC758 \uC720\uC608 \uAE30\uAC04 \uC774\uD6C4\uC5D0\uB294 \uACC4\uC815 \uC0AD\uC81C\uB97C \uCDE8\uC18C\uD560 \uC218 \uC5C6\uC2B5\uB2C8\uB2E4.",
    "focused-task-close-account.delete-account.overview.paragraph.list-of-apps-with-personal-data.admin": "\uC0AC\uC6A9\uC790 \uAC1C\uC778 \uB370\uC774\uD130\uB97C \uC800\uC7A5\uD558\uACE0 \uC788\uC744 \uC218 \uC788\uB294 \uC571 \uBAA9\uB85D\uC744 \uC774\uBA54\uC77C\uB85C \uBCF4\uB0B4\uB4DC\uB9AC\uACA0\uC2B5\uB2C8\uB2E4.",
    "focused-task-close-account.delete-account.overview.paragraph.list-of-apps-with-personal-data.self": "\uC0AC\uC6A9\uC790 \uAC1C\uC778 \uB370\uC774\uD130\uB97C \uC800\uC7A5\uD558\uACE0 \uC788\uC744 \uC218 \uC788\uB294 \uC571 \uBAA9\uB85D\uC744 \uC774\uBA54\uC77C\uB85C \uBCF4\uB0B4\uB4DC\uB9AC\uACA0\uC2B5\uB2C8\uB2E4.",
    "focused-task-close-account.delete-account.overview.paragraph.loseAccess.admin": "{fullName}\uC740(\uB294) \uC989\uC2DC Atlassian \uACC4\uC815 \uC11C\uBE44\uC2A4\uC5D0 \uB300\uD55C <b>\uC561\uC138\uC2A4 \uAD8C\uD55C\uC744 \uC0C1\uC2E4</b>\uD558\uAC8C \uB429\uB2C8\uB2E4. \uD604\uC7AC \uC561\uC138\uC2A4\uD560 \uC218 \uC788\uB294 \uD56D\uBAA9\uC740 \uB2E4\uC74C\uACFC \uAC19\uC2B5\uB2C8\uB2E4.",
    "focused-task-close-account.delete-account.overview.paragraph.loseAccess.admin.noSites": "{fullName}\uC740(\uB294) \uBAA8\uB4E0 Atlassian \uACC4\uC815 \uC11C\uBE44\uC2A4\uC5D0 \uB300\uD55C <b>\uC561\uC138\uC2A4 \uAD8C\uD55C\uC744 \uC989\uC2DC \uC0C1\uC2E4</b>\uD558\uAC8C \uB429\uB2C8\uB2E4. \uD604\uC7AC \uC0AC\uC6A9\uC790\uB294 \uCEE4\uBBA4\uB2C8\uD2F0 \uBC0F Marketplace\uC640 \uAC19\uC740 \uC11C\uBE44\uC2A4 \uC678\uC5D0 \uC561\uC138\uC2A4 \uAD8C\uD55C\uC744 \uAC00\uC9C0\uACE0 \uC788\uC9C0 \uC54A\uC2B5\uB2C8\uB2E4.",
    "focused-task-close-account.delete-account.overview.paragraph.loseAccess.footnote": "Atlassian \uCEE4\uBBA4\uB2C8\uD2F0 \uBC0F Marketplace\uC640 \uAC19\uC740 \uAE30\uD0C0 Atlassian \uACC4\uC815 \uC11C\uBE44\uC2A4.",
    "focused-task-close-account.delete-account.overview.paragraph.loseAccess.self": "\uC0AC\uC6A9\uC790\uB294 \uC989\uC2DC Atlassian \uACC4\uC815 \uC11C\uBE44\uC2A4\uC5D0 \uB300\uD55C <b>\uC561\uC138\uC2A4 \uAD8C\uD55C\uC744 \uC0C1\uC2E4</b>\uD558\uAC8C \uB429\uB2C8\uB2E4. \uD604\uC7AC \uC561\uC138\uC2A4\uD560 \uC218 \uC788\uB294 \uD56D\uBAA9\uC740 \uB2E4\uC74C\uACFC \uAC19\uC2B5\uB2C8\uB2E4.",
    "focused-task-close-account.delete-account.overview.paragraph.loseAccess.self.noSites": "\uC0AC\uC6A9\uC790\uB294 \uBAA8\uB4E0 Atlassian \uACC4\uC815 \uC11C\uBE44\uC2A4\uC5D0 \uB300\uD55C <b>\uC561\uC138\uC2A4 \uAD8C\uD55C\uC744 \uC989\uC2DC \uC0C1\uC2E4</b>\uD558\uAC8C \uB429\uB2C8\uB2E4. \uD604\uC7AC \uADC0\uD558\uB294 \uCEE4\uBBA4\uB2C8\uD2F0 \uBC0F Marketplace\uC640 \uAC19\uC740 \uC11C\uBE44\uC2A4 \uC678\uC5D0\uB294 \uC561\uC138\uC2A4 \uAD8C\uD55C\uC744 \uAC00\uC9C0\uACE0 \uC788\uC9C0 \uC54A\uC2B5\uB2C8\uB2E4.",
    "focused-task-close-account.delete-account.overview.paragraph.personal-data-will-be-deleted.admin": "Atlassian\uC740 Atlassian \uACC4\uC815 \uC11C\uBE44\uC2A4\uC5D0\uC11C 30\uC77C \uB0B4\uC5D0 \uD569\uBC95\uC801 \uBE44\uC988\uB2C8\uC2A4 \uB610\uB294 \uBC95\uB960\uC0C1\uC758 \uBAA9\uC801\uC73C\uB85C \uD544\uC694\uD55C \uACBD\uC6B0\uB97C \uC81C\uC678\uD558\uACE0 \uC0AC\uC6A9\uC790\uC758 \uC131\uBA85 \uBC0F \uC774\uBA54\uC77C \uC8FC\uC18C\uC640 \uAC19\uC740 <b>\uAC1C\uC778 \uB370\uC774\uD130\uB97C \uC0AD\uC81C\uD569\uB2C8\uB2E4</b>.",
    "focused-task-close-account.delete-account.overview.paragraph.personal-data-will-be-deleted.self": "Atlassian\uC740 Atlassian \uACC4\uC815 \uC11C\uBE44\uC2A4\uC5D0\uC11C 30\uC77C \uB0B4\uC5D0 \uD569\uBC95\uC801 \uBE44\uC988\uB2C8\uC2A4 \uB610\uB294 \uBC95\uB960\uC0C1\uC758 \uBAA9\uC801\uC73C\uB85C \uD544\uC694\uD55C \uACBD\uC6B0\uB97C \uC81C\uC678\uD558\uACE0 \uADC0\uD558\uC758 \uC131\uBA85 \uBC0F \uC774\uBA54\uC77C \uC8FC\uC18C\uC640 \uAC19\uC740 <b>\uAC1C\uC778 \uB370\uC774\uD130\uB97C \uC0AD\uC81C\uD569\uB2C8\uB2E4</b>.",
    "focused-task-close-account.delete-account.overview.warning-section.body": "14\uC77C\uC758 \uC720\uC608 \uAE30\uAC04 \uC774\uD6C4\uC5D0\uB294 \uACC4\uC815 \uC0AD\uC81C\uB97C \uCDE8\uC18C\uD560 \uC218 \uC5C6\uC2B5\uB2C8\uB2E4. \uB098\uC911\uC5D0 \uACC4\uC815\uC744 \uC0AC\uC6A9\uD560 \uC218\uB3C4 \uC788\uB2E4\uBA74 \uB300\uC2E0\uC5D0 \uBE44\uD65C\uC131\uD654\uB97C \uD558\uC2ED\uC2DC\uC624.",
    "focused-task-close-account.delete-account.overview.warning-section.deactivated.body": "14\uC77C\uC758 \uC720\uC608 \uAE30\uAC04 \uC774\uD6C4\uC5D0\uB294 \uACC4\uC815 \uC0AD\uC81C\uB97C \uCDE8\uC18C\uD560 \uC218 \uC5C6\uC2B5\uB2C8\uB2E4.",
    "focused-task-close-account.learnMore": "\uC790\uC138\uD788 \uC54C\uC544\uBCF4\uAE30",
    "focused-task-close-account.next": "\uB2E4\uC74C",
    "focused-task-close-account.previous": "\uC774\uC804"
};

});

parcelRegister("hoYKf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cab3cc369ae2d4ea$export$2e2bcd8739ae039; });
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Norwegian (Bokmål)
var $cab3cc369ae2d4ea$export$2e2bcd8739ae039 = {
    "focused-task-close-account.cancel": "Avbryt",
    "focused-task-close-account.deactivate-account": "Deaktiver konto",
    "focused-task-close-account.deactivate-account.overview.first.line.admin": "Du er i ferd med \xe5 slette brukerkolonnen til",
    "focused-task-close-account.deactivate-account.overview.first.line.self": "Du er i ferd med \xe5 slette brukerkolonnen til",
    "focused-task-close-account.deactivate-account.overview.heading.admin": "Deaktiver konto",
    "focused-task-close-account.deactivate-account.overview.heading.self": "Deaktiver konto",
    "focused-task-close-account.deactivate-account.overview.last.line.admin": "Du kan n\xe5r som helst aktivere kontoen igjen.",
    "focused-task-close-account.deactivate-account.overview.last.line.self": "Du kan n\xe5r som helst aktivere kontoen igjen.",
    "focused-task-close-account.deactivate-account.overview.paragraph.about-to-deactivate.admin": "N\xe5r du deaktiverer kolonnen:",
    "focused-task-close-account.deactivate-account.overview.paragraph.about-to-deactivate.self": "N\xe5r du deaktiverer kontoen:",
    "focused-task-close-account.deactivate-account.overview.paragraph.billing.admin": "Vi vil ikke lenger fakturere deg for dem.",
    "focused-task-close-account.deactivate-account.overview.paragraph.billing.self": "Vi vil ikke lenger fakturere deg for dem.",
    "focused-task-close-account.deactivate-account.overview.paragraph.loseAccess.admin": "{fullName} <b>mister tilgangen \xf8yeblikkelig</b> til alle Atlassian-kontotjenester. For \xf8yeblikket har de tilgang til:",
    "focused-task-close-account.deactivate-account.overview.paragraph.loseAccess.admin.noSites": "{fullName} <b>mister tilgangen \xf8yeblikkelig</b> til alle Atlassian-kontotjenester.  For \xf8yeblikket har de ikke tilgang til noen, bortsett fra tjenester som Community og Marketplace.",
    "focused-task-close-account.deactivate-account.overview.paragraph.loseAccess.footnote": "andre Atlassian-kontotjenester, som Atlassian Community og Marketplace.",
    "focused-task-close-account.deactivate-account.overview.paragraph.loseAccess.self": "Du <b>mister tilgangen \xf8yeblikkelig</b> til alle Atlassian-kontotjenester. For \xf8yeblikket har du tilgang til:",
    "focused-task-close-account.deactivate-account.overview.paragraph.loseAccess.self.noSites": "Du <b>mister tilgangen \xf8yeblikkelig</b> til alle Atlassian-kontotjenester.  For \xf8yeblikket har du ikke tilgang til noen, bortsett fra tjenester som Community og Marketplace.",
    "focused-task-close-account.deactivate-account.overview.paragraph.personal-data.admin": "Personopplysningene deres, som fullt navn og e-postadresse, og innhold de har opprettet, forblir i Atlassian-kontotjenester.",
    "focused-task-close-account.deactivate-account.overview.paragraph.personal-data.self": "Personopplysningene deres, som fullt navn og e-postadresse, og innhold de har opprettet, forblir i Atlassian-kontotjenester.",
    "focused-task-close-account.delete-account": "Slett konto",
    "focused-task-close-account.delete-account.content-preview.footnote.admin": "Merknad: N\xe5r du svarer p\xe5 denne sp\xf8rreunders\xf8kelsen, hjelper du oss til \xe5 skape en bedre opplevelse for alle brukere. Brukeren vil fortsatt vises som \xabTidligere bruker\xbb etter at kontoen er slettet.",
    "focused-task-close-account.delete-account.content-preview.footnote.self": "Merknad: N\xe5r du svarer p\xe5 denne sp\xf8rreunders\xf8kelsen, hjelper du oss med \xe5 skape en bedre opplevelse for alle brukere, ogs\xe5 dem som sletter kontoen sin. Du vil fortsatt vises som \xabTidligere bruker\xbb etter at du har slettet kontoen.",
    "focused-task-close-account.delete-account.content-preview.formerUser": "Tidligere bruker",
    "focused-task-close-account.delete-account.content-preview.heading.admin": "Hvordan ville du foretrekke at den slettede brukeren ble vist?",
    "focused-task-close-account.delete-account.content-preview.heading.self": "Hvordan ville du foretrekke at den slettede kontoen din ble vist?",
    "focused-task-close-account.delete-account.content-preview.line.survey.admin": "Hvordan ville du foretrekke at den slettede brukeren ble vist til andre brukere hvis du kunne velge?",
    "focused-task-close-account.delete-account.content-preview.line.survey.self": "Hvordan ville du foretrekke \xe5 bli vist for andre brukere hvis du kunne velge?",
    "focused-task-close-account.delete-account.content-preview.paragraph.survey.admin": "N\xe5r konto er slettet, blir brukeren vist som \xabTidligere bruker\xbb for andre brukere. Vi vil sette pris p\xe5 om du setter av et \xf8yeblikk til \xe5 svare p\xe5 sp\xf8rreunders\xf8kelsen v\xe5r.",
    "focused-task-close-account.delete-account.content-preview.paragraph.survey.self": "N\xe5r kontoen er slettet, vises du som \xabTidligere bruker\xbb for andre brukere. Vi vil sette pris p\xe5 om du setter av et \xf8yeblikk p\xe5 \xe5 svare p\xe5 sp\xf8rreunders\xf8kelsen v\xe5r.",
    "focused-task-close-account.delete-account.drop-down-collapse-button": "Vis mindre",
    "focused-task-close-account.delete-account.drop-down-expand-button": "{num} mer",
    "focused-task-close-account.delete-account.overview.first.line.admin": "Du er i ferd med \xe5 slette kolonnen til",
    "focused-task-close-account.delete-account.overview.first.line.self": "Du er i ferd med \xe5 slette kontoen din",
    "focused-task-close-account.delete-account.overview.heading.admin": "Slett konto",
    "focused-task-close-account.delete-account.overview.heading.self": "Slett kontoen",
    "focused-task-close-account.delete-account.overview.inline-dialog.content-created.admin": "For eksempel sider, saker og kommentarer de har opprettet i produkter.",
    "focused-task-close-account.delete-account.overview.inline-dialog.content-created.self": "For eksempel sider, saker og kommentarer du har opprettet i produkter.",
    "focused-task-close-account.delete-account.overview.inline-dialog.data-apps.admin": "Du eller andre brukere kan ha installert apper som legger til funksjoner i Atlassian-produkter. Disse appene kan ha lagret brukerens profilinformasjon.",
    "focused-task-close-account.delete-account.overview.inline-dialog.data-apps.self": "Du eller andre brukere kan ha installert apper som legger til funksjoner i Atlassian-produkter. Disse appene kan ha lagret profilinformasjonen din.",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.li1.admin": "informasjon knyttet til kj\xf8p, som vi m\xe5 oppbevare av hensyn til \xf8konomisk rapportering",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.li1.self": "informasjon knyttet til kj\xf8p, som vi m\xe5 oppbevare av hensyn til \xf8konomisk rapportering",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.li2.admin": "registreringer som viser at vi har slettet en persons konto, som vi kanskje m\xe5 gi til tilsynsorganer",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.li2.self": "registreringer som viser at vi har slettet en persons konto, som vi kanskje m\xe5 gi til tilsynsorganer",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.li3.admin": "data som brukes i et aktiv s\xf8ksm\xe5l, som vi er p\xe5lagt ved lov \xe5 lagre",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.li3.self": "data som brukes i et aktiv s\xf8ksm\xe5l, som vi er p\xe5lagt ved lov \xe5 lagre",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.p1.admin": "Vi tar vare p\xe5 personopplysninger i en begrenset tid n\xe5r vi har legitime grunner forbundet med lov eller forretningsdriften. Noen eksempler inkluderer",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.p1.self": "Vi tar vare p\xe5 personopplysninger i en begrenset tid n\xe5r vi har legitime grunner forbundet med lov eller forretningsdriften. Noen eksempler inkluderer",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.p2.admin": "Vi sletter ikke personopplysninger fra innhold opprettet av brukere, som navn eller e-postadresser de har skrevet inn p\xe5 en side eller en sak. Produktadministratorene m\xe5 slette informasjonen manuelt.",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.p2.self": "Vi sletter ikke personopplysninger fra innhold opprettet av deg eller andre personer, som navn eller e-postadresser dere har skrevet inn p\xe5 en side eller en sak. Produktadministratorene m\xe5 slette informasjonen manuelt.",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.p3.admin": "Brukerne har rett til \xe5 sende inn klager til tilsynsmyndigheten i landet der de bor.",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.p3.self": "Du har rett til \xe5 sende inn klager til tilsynsmyndigheten i landet der du bor.",
    "focused-task-close-account.delete-account.overview.paragraph.about-to-delete.admin": "N\xe5r du sletter kolonnen",
    "focused-task-close-account.delete-account.overview.paragraph.about-to-delete.self": "N\xe5r du sletter kolonnen din:",
    "focused-task-close-account.delete-account.overview.paragraph.content-created.admin": "Innholdet de har opprettet, forblir i Atlassian-kontotjenestene.",
    "focused-task-close-account.delete-account.overview.paragraph.content-created.self": "Innholdet du har opprettet, forblir i Atlassian-kontotjenestene.",
    "focused-task-close-account.delete-account.overview.paragraph.grace-period.admin": "Etter en 14-dagers sk\xe5nefrist kan du ikke kansellere slettingen av kontoen.",
    "focused-task-close-account.delete-account.overview.paragraph.list-of-apps-with-personal-data.admin": "Vi vil sende deg en liste over apper som kan ha lagret personopplysningene deres.",
    "focused-task-close-account.delete-account.overview.paragraph.list-of-apps-with-personal-data.self": "Vi sender deg en liste over apper som kan ha lagret personopplysningene dine.",
    "focused-task-close-account.delete-account.overview.paragraph.loseAccess.admin": "{fullName} <b>mister tilgangen \xf8yeblikkelig</b> til alle Atlassian-kontotjenester. For \xf8yeblikket har de tilgang til:",
    "focused-task-close-account.delete-account.overview.paragraph.loseAccess.admin.noSites": "{fullName} <b>mister tilgangen \xf8yeblikkelig</b> til alle Atlassian-kontotjenester.  For \xf8yeblikket har vedkommende ikke tilgang til noen tjenester, bortsett fra tjenester som Community og Marketplace.",
    "focused-task-close-account.delete-account.overview.paragraph.loseAccess.footnote": "Andre Atlassian-kontotjenester, som Atlassian Community og Marketplace.",
    "focused-task-close-account.delete-account.overview.paragraph.loseAccess.self": "Du <b>mister tilgangen \xf8yeblikkelig</b> til alle Atlassian-kontotjenester. For \xf8yeblikket har du tilgang til:",
    "focused-task-close-account.delete-account.overview.paragraph.loseAccess.self.noSites": "Du <b>mister tilgangen \xf8yeblikkelig</b> til alle Atlassian-kontotjenester.  For \xf8yeblikket har du ikke tilgang til noen tjenester, bortsett fra tjenester som Community og Marketplace.",
    "focused-task-close-account.delete-account.overview.paragraph.personal-data-will-be-deleted.admin": "Vi sletter <b>personopplysningene deres</b>, som fullt navn og e-postadresse, fra Atlassian-kontotjenester innen 30 dager, unntatt i noen tilfeller der det kreves for legitime forretningsform\xe5l eller juridiske form\xe5l.",
    "focused-task-close-account.delete-account.overview.paragraph.personal-data-will-be-deleted.self": "Vi sletter <b>personopplysningene dine</b>, som fullt navn og e-postadresse, fra Atlassian-kontotjenester innen 30 dager, unntatt i noen tilfeller der det kreves for legitime forretningsform\xe5l eller juridiske form\xe5l.",
    "focused-task-close-account.delete-account.overview.warning-section.body": "Etter en 14-dagers sk\xe5nefrist kan du ikke kansellere slettingen av kontoen. Hvis du tror at du trenger kontoen senere, m\xe5 du deaktivere den i stedet.",
    "focused-task-close-account.delete-account.overview.warning-section.deactivated.body": "Etter en 14-dagers sk\xe5nefrist kan du ikke kansellere slettingen av kontoen.",
    "focused-task-close-account.learnMore": "Les mer",
    "focused-task-close-account.next": "Neste",
    "focused-task-close-account.previous": "Forrige"
};

});

parcelRegister("dO366", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a0d258f0622b765e$export$2e2bcd8739ae039; });
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Polish (Poland)
var $a0d258f0622b765e$export$2e2bcd8739ae039 = {
    "focused-task-close-account.cancel": "Anuluj",
    "focused-task-close-account.deactivate-account": "Dezaktywuj konto",
    "focused-task-close-account.deactivate-account.overview.first.line.admin": "Zamierzasz dezaktywowa\u0107 konto u\u017Cytkownika:",
    "focused-task-close-account.deactivate-account.overview.first.line.self": "Zamierzasz dezaktywowa\u0107 konto u\u017Cytkownika:",
    "focused-task-close-account.deactivate-account.overview.heading.admin": "Dezaktywuj konto",
    "focused-task-close-account.deactivate-account.overview.heading.self": "Dezaktywuj konto",
    "focused-task-close-account.deactivate-account.overview.last.line.admin": "W ka\u017Cdej chwili mo\u017Cesz ponownie aktywowa\u0107 konto.",
    "focused-task-close-account.deactivate-account.overview.last.line.self": "W ka\u017Cdej chwili mo\u017Cesz ponownie aktywowa\u0107 konto.",
    "focused-task-close-account.deactivate-account.overview.paragraph.about-to-deactivate.admin": "Gdy dezaktywujesz konto:",
    "focused-task-close-account.deactivate-account.overview.paragraph.about-to-deactivate.self": "Gdy dezaktywujesz konto:",
    "focused-task-close-account.deactivate-account.overview.paragraph.billing.admin": "W zwi\u0105zku z tym nie b\u0119dziemy ju\u017C nalicza\u0107 Ci op\u0142at za tych u\u017Cytkownik\xf3w.",
    "focused-task-close-account.deactivate-account.overview.paragraph.billing.self": "W zwi\u0105zku z tym nie b\u0119dziemy ju\u017C nalicza\u0107 Ci op\u0142at za tych u\u017Cytkownik\xf3w.",
    "focused-task-close-account.deactivate-account.overview.paragraph.loseAccess.admin": "{fullName} <b>natychmiast utraci dost\u0119p</b> do wszystkich us\u0142ug kont Atlassian. Obecnie ma dost\u0119p do:",
    "focused-task-close-account.deactivate-account.overview.paragraph.loseAccess.admin.noSites": "{fullName} natychmiast <b>utraci dost\u0119p</b> do wszystkich us\u0142ug kont Atlassian. Obecnie nie ma dost\u0119pu do \u017Cadnych innych us\u0142ug z wyj\u0105tkiem Community i Marketplace.",
    "focused-task-close-account.deactivate-account.overview.paragraph.loseAccess.footnote": "Inne us\u0142ugi konta Atlassian, takie jak spo\u0142eczno\u015B\u0107 Atlassian Community i sklep Atlassian Marketplace.",
    "focused-task-close-account.deactivate-account.overview.paragraph.loseAccess.self": "<b>Natychmiast utracisz dost\u0119p</b> do wszystkich us\u0142ug kont Atlassian. Obecnie masz dost\u0119p do:",
    "focused-task-close-account.deactivate-account.overview.paragraph.loseAccess.self.noSites": "Natychmiast <b>utracisz dost\u0119p</b> do wszystkich us\u0142ug kont Atlassian. Obecnie nie masz dost\u0119pu do \u017Cadnych innych us\u0142ug z wyj\u0105tkiem Community i Marketplace.",
    "focused-task-close-account.deactivate-account.overview.paragraph.personal-data.admin": "Dane osobowe, takie jak imi\u0119 i nazwisko i adres e-mail oraz utworzona tre\u015B\u0107 pozostan\u0105 w us\u0142ugach konta Atlassian.",
    "focused-task-close-account.deactivate-account.overview.paragraph.personal-data.self": "Dane osobowe, takie jak imi\u0119 i nazwisko i adres e-mail oraz utworzona tre\u015B\u0107 pozostan\u0105 w us\u0142ugach konta Atlassian.",
    "focused-task-close-account.delete-account": "Usu\u0144 konto",
    "focused-task-close-account.delete-account.content-preview.footnote.admin": "Uwaga: odpowiedzi udzielone w tej ankiecie pomog\u0105 nam zapewni\u0107 lepsz\u0105 obs\u0142ug\u0119 wszystkim u\u017Cytkownikom. Po usuni\u0119ciu konta u\u017Cytkownik nadal b\u0119dzie wy\u015Bwietlany jako \u201EBy\u0142y u\u017Cytkownik\u201D.",
    "focused-task-close-account.delete-account.content-preview.footnote.self": "Uwaga: odpowiedzi udzielone w tej ankiecie pomog\u0105 nam zapewni\u0107 lepsz\u0105 obs\u0142ug\u0119 wszystkim u\u017Cytkownikom, r\xf3wnie\u017C tym, kt\xf3rzy usun\u0119li swoje konta. Po usuni\u0119ciu konta u\u017Cytkownik nadal b\u0119dzie wy\u015Bwietlany jako \u201EBy\u0142y u\u017Cytkownik\u201D.",
    "focused-task-close-account.delete-account.content-preview.formerUser": "By\u0142y u\u017Cytkownik",
    "focused-task-close-account.delete-account.content-preview.heading.admin": "Jak Twoim zdaniem usuni\u0119ty u\u017Cytkownik powinien by\u0107 widoczny?",
    "focused-task-close-account.delete-account.content-preview.heading.self": "Jak Twoim zdaniem powinno by\u0107 widoczne usuni\u0119te konto?",
    "focused-task-close-account.delete-account.content-preview.line.survey.admin": "Jak Twoim zdaniem usuni\u0119ty u\u017Cytkownik powinien by\u0107 widoczny dla innych u\u017Cytkownik\xf3w?",
    "focused-task-close-account.delete-account.content-preview.line.survey.self": "Jak po usuni\u0119ciu Twojego konta powinno ono by\u0107 widoczne dla innych u\u017Cytkownik\xf3w?",
    "focused-task-close-account.delete-account.content-preview.paragraph.survey.admin": "Po usuni\u0119ciu konta u\u017Cytkownika b\u0119dzie on widoczny jako \u201EBy\u0142y u\u017Cytkownik\u201D dla innych u\u017Cytkownik\xf3w. Po\u015Bwi\u0119\u0107 chwil\u0119, aby odpowiedzie\u0107 na nasze pytanie w ankiecie.",
    "focused-task-close-account.delete-account.content-preview.paragraph.survey.self": "Po usuni\u0119ciu konta b\u0119dziesz widoczny dla innych u\u017Cytkownik\xf3w jako \u201EBy\u0142y u\u017Cytkownik\u201D. Po\u015Bwi\u0119\u0107 chwil\u0119, aby odpowiedzie\u0107 na nasze pytanie w ankiecie.",
    "focused-task-close-account.delete-account.drop-down-collapse-button": "Poka\u017C mniej",
    "focused-task-close-account.delete-account.drop-down-expand-button": "jeszcze {num}",
    "focused-task-close-account.delete-account.overview.first.line.admin": "Zamierzasz usun\u0105\u0107 konto:",
    "focused-task-close-account.delete-account.overview.first.line.self": "Zamierzasz usun\u0105\u0107 swoje konto:",
    "focused-task-close-account.delete-account.overview.heading.admin": "Usu\u0144 konto",
    "focused-task-close-account.delete-account.overview.heading.self": "Usu\u0144 konto",
    "focused-task-close-account.delete-account.overview.inline-dialog.content-created.admin": "Na przyk\u0142ad strony, zg\u0142oszenia i komentarze, kt\xf3re zosta\u0142y utworzone w produktach.",
    "focused-task-close-account.delete-account.overview.inline-dialog.content-created.self": "Na przyk\u0142ad strony, zg\u0142oszenia i komentarze utworzone w produktach.",
    "focused-task-close-account.delete-account.overview.inline-dialog.data-apps.admin": "Ty lub inni u\u017Cytkownicy mog\u0105 mie\u0107 zainstalowane aplikacje, kt\xf3re dodaj\u0105 funkcje do produkt\xf3w Atlassian. Aplikacje te mog\u0142y przechowywa\u0107 informacje o profilu u\u017Cytkownika.",
    "focused-task-close-account.delete-account.overview.inline-dialog.data-apps.self": "Ty lub inni u\u017Cytkownicy mog\u0105 mie\u0107 zainstalowane aplikacje, kt\xf3re dodaj\u0105 funkcje do produkt\xf3w Atlassian. Aplikacje te mog\u0142y przechowywa\u0107 informacje o Twoim profilu.",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.li1.admin": "Informacje zwi\u0105zane z zakupami, kt\xf3re jeste\u015Bmy zobowi\u0105zani przechowywa\u0107 do cel\xf3w sprawozdawczo\u015Bci finansowej.",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.li1.self": "Informacje zwi\u0105zane z zakupami, kt\xf3re jeste\u015Bmy zobowi\u0105zani przechowywa\u0107 do cel\xf3w sprawozdawczo\u015Bci finansowej.",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.li2.admin": "Zapisy wskazuj\u0105ce, \u017Ce usun\u0119li\u015Bmy czyje\u015B konto, kt\xf3re by\u0107 mo\u017Ce b\u0119dziemy musieli przekaza\u0107 organom regulacyjnym.",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.li2.self": "Zapisy wskazuj\u0105ce, \u017Ce usun\u0119li\u015Bmy czyje\u015B konto, kt\xf3re by\u0107 mo\u017Ce b\u0119dziemy musieli przekaza\u0107 organom regulacyjnym.",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.li3.admin": "Dane, kt\xf3re s\u0105 cz\u0119\u015Bci\u0105 aktywnego procesu s\u0105dowego, do przechowywania kt\xf3rych jeste\u015Bmy zobowi\u0105zani na mocy prawa.",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.li3.self": "Dane, kt\xf3re s\u0105 cz\u0119\u015Bci\u0105 aktywnego procesu s\u0105dowego, do przechowywania kt\xf3rych jeste\u015Bmy zobowi\u0105zani na mocy prawa.",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.p1.admin": "Dane osobowe przechowujemy przez ograniczony czas, gdy mamy uzasadnione cele biznesowe lub prawne. Oto kilka przyk\u0142ad\xf3w:",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.p1.self": "Dane osobowe przechowujemy przez ograniczony czas, gdy mamy uzasadnione cele biznesowe lub prawne. Oto kilka przyk\u0142ad\xf3w:",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.p2.admin": "Nie usuwamy \u017Cadnych danych osobowych z tre\u015Bci tworzonych przez u\u017Cytkownik\xf3w, takich jak imiona i nazwiska lub adresy e-mail, kt\xf3re wpisali na stronie lub w zg\u0142oszeniu. Administratorzy produkt\xf3w musz\u0105 usun\u0105\u0107 te dane r\u0119cznie.",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.p2.self": "Nie usuwamy \u017Cadnych danych osobowych z tre\u015Bci stworzonych przez Ciebie lub inne osoby, takich jak imiona i nazwiska lub adresy e-mail wpisane na stronie lub w zg\u0142oszeniu. Administratorzy produkt\xf3w musz\u0105 usun\u0105\u0107 te dane r\u0119cznie.",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.p3.admin": "U\u017Cytkownicy maj\u0105 prawo do sk\u0142adania skarg do organu nadzorczego w swoim kraju.",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.p3.self": "Masz prawo do sk\u0142adania skarg do organu nadzorczego w swoim kraju.",
    "focused-task-close-account.delete-account.overview.paragraph.about-to-delete.admin": "Gdy usuniesz konto:",
    "focused-task-close-account.delete-account.overview.paragraph.about-to-delete.self": "Gdy usuniesz swoje konto:",
    "focused-task-close-account.delete-account.overview.paragraph.content-created.admin": "Utworzone przez nich tre\u015Bci pozostan\u0105 w us\u0142ugach kont Atlassian.",
    "focused-task-close-account.delete-account.overview.paragraph.content-created.self": "Utworzone przez Ciebie tre\u015Bci pozostan\u0105 w us\u0142ugach kont Atlassian.",
    "focused-task-close-account.delete-account.overview.paragraph.grace-period.admin": "Po 14-dniowym okresie anulowanie usuni\u0119cia konta nie b\u0119dzie mo\u017Cliwe.",
    "focused-task-close-account.delete-account.overview.paragraph.list-of-apps-with-personal-data.admin": "Wy\u015Blemy Ci e-mail z list\u0105 aplikacji, kt\xf3re mog\u0142y przechowywa\u0107 dane osobowe.",
    "focused-task-close-account.delete-account.overview.paragraph.list-of-apps-with-personal-data.self": "Wy\u015Blemy Ci e-mail z list\u0105 aplikacji, kt\xf3re mog\u0142y przechowywa\u0107 dane osobowe.",
    "focused-task-close-account.delete-account.overview.paragraph.loseAccess.admin": "{fullName} <b>natychmiast utraci dost\u0119p</b> do wszystkich us\u0142ug kont Atlassian. Obecnie ma dost\u0119p do:",
    "focused-task-close-account.delete-account.overview.paragraph.loseAccess.admin.noSites": "{fullName} <b>natychmiast utraci dost\u0119p</b> do wszystkich us\u0142ug kont Atlassian. Obecnie nie ma dost\u0119pu do \u017Cadnych innych us\u0142ug z wyj\u0105tkiem Community i Marketplace.",
    "focused-task-close-account.delete-account.overview.paragraph.loseAccess.footnote": "Inne us\u0142ugi konta Atlassian, takie jak spo\u0142eczno\u015B\u0107 Atlassian Community i sklep Atlassian Marketplace.",
    "focused-task-close-account.delete-account.overview.paragraph.loseAccess.self": "<b>Natychmiast utracisz dost\u0119p</b> do wszystkich us\u0142ug kont Atlassian. Obecnie masz dost\u0119p do:",
    "focused-task-close-account.delete-account.overview.paragraph.loseAccess.self.noSites": "<b>Natychmiast utracisz dost\u0119p</b> do wszystkich us\u0142ug kont Atlassian. Obecnie nie masz dost\u0119pu do \u017Cadnych innych us\u0142ug z wyj\u0105tkiem Community i Marketplace.",
    "focused-task-close-account.delete-account.overview.paragraph.personal-data-will-be-deleted.admin": "W ci\u0105gu 30 dni <b>usuniemy ich dane osobowe</b>, takie jak imi\u0119 i nazwisko oraz adres e-mail, z us\u0142ug kont Atlassian, z wyj\u0105tkiem kilku przypadk\xf3w, gdy jest to wymagane w uzasadnionych celach biznesowych lub prawnych.",
    "focused-task-close-account.delete-account.overview.paragraph.personal-data-will-be-deleted.self": "W ci\u0105gu 30 dni <b>usuniemy Twoje dane osobowe</b>, takie jak imi\u0119 i nazwisko oraz adres e-mail, z us\u0142ug kont Atlassian, z wyj\u0105tkiem kilku przypadk\xf3w, gdy jest to wymagane w uzasadnionych celach biznesowych lub prawnych.",
    "focused-task-close-account.delete-account.overview.warning-section.body": "Po 14-dniowym okresie anulowanie usuni\u0119cia konta nie b\u0119dzie mo\u017Cliwe. Je\u015Bli uwa\u017Casz, \u017Ce konto mo\u017Ce by\u0107 Ci potrzebne p\xf3\u017Aniej, dezaktywuj je.",
    "focused-task-close-account.delete-account.overview.warning-section.deactivated.body": "Po 14-dniowym okresie anulowanie usuni\u0119cia konta nie b\u0119dzie mo\u017Cliwe.",
    "focused-task-close-account.learnMore": "Dowiedz si\u0119 wi\u0119cej",
    "focused-task-close-account.next": "Dalej",
    "focused-task-close-account.previous": "Wstecz"
};

});

parcelRegister("3miiB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $27219efa2da25e66$export$2e2bcd8739ae039; });
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Portuguese (Brazil)
var $27219efa2da25e66$export$2e2bcd8739ae039 = {
    "focused-task-close-account.cancel": "Cancelar",
    "focused-task-close-account.deactivate-account": "Desativar conta",
    "focused-task-close-account.deactivate-account.overview.first.line.admin": "Voc\xea est\xe1 prestes a desativar a conta de usu\xe1rio de:",
    "focused-task-close-account.deactivate-account.overview.first.line.self": "Voc\xea est\xe1 prestes a desativar a conta de usu\xe1rio de:",
    "focused-task-close-account.deactivate-account.overview.heading.admin": "Desativar conta",
    "focused-task-close-account.deactivate-account.overview.heading.self": "Desativar conta",
    "focused-task-close-account.deactivate-account.overview.last.line.admin": "Voc\xea pode reativar a conta a qualquer momento.",
    "focused-task-close-account.deactivate-account.overview.last.line.self": "Voc\xea pode reativar a conta a qualquer momento.",
    "focused-task-close-account.deactivate-account.overview.paragraph.about-to-deactivate.admin": "Quando voc\xea desativar a conta:",
    "focused-task-close-account.deactivate-account.overview.paragraph.about-to-deactivate.self": "Quando voc\xea desativar a conta:",
    "focused-task-close-account.deactivate-account.overview.paragraph.billing.admin": "N\xe3o vamos mais cobrar voc\xea por esse usu\xe1rio.",
    "focused-task-close-account.deactivate-account.overview.paragraph.billing.self": "N\xe3o vamos mais cobrar voc\xea por esse usu\xe1rio.",
    "focused-task-close-account.deactivate-account.overview.paragraph.loseAccess.admin": "{fullName} <b>perder\xe1 o acesso imediatamente</b> a todos os servi\xe7os de conta da Atlassian. Atualmente ele(a) possui acesso a:",
    "focused-task-close-account.deactivate-account.overview.paragraph.loseAccess.admin.noSites": "{fullName} <b>perder\xe1 o acesso imediatamente</b> a todos os servi\xe7os de conta da Atlassian. Atualmente ele(a) n\xe3o possui acesso a nenhum servi\xe7o, exceto servi\xe7os como Community e Marketplace.",
    "focused-task-close-account.deactivate-account.overview.paragraph.loseAccess.footnote": "Outros servi\xe7os de conta da Atlassian, como a Atlassian Community e o Marketplace.",
    "focused-task-close-account.deactivate-account.overview.paragraph.loseAccess.self": "Voc\xea <b>perder\xe1 o acesso imediatamente</b> a todos os servi\xe7os de conta da Atlassian. Atualmente voc\xea possui acesso a:",
    "focused-task-close-account.deactivate-account.overview.paragraph.loseAccess.self.noSites": "Voc\xea <b>perder\xe1 o acesso imediatamente</b> a todos os servi\xe7os de conta da Atlassian. Atualmente voc\xea n\xe3o possui acesso a nenhum servi\xe7o, exceto servi\xe7os como Community e Marketplace.",
    "focused-task-close-account.deactivate-account.overview.paragraph.personal-data.admin": "Seus dados pessoais, como nome completo e endere\xe7o de e-mail, e o conte\xfado criado permanecer\xe3o nos servi\xe7os de conta da Atlassian.",
    "focused-task-close-account.deactivate-account.overview.paragraph.personal-data.self": "Seus dados pessoais, como nome completo e endere\xe7o de e-mail, e o conte\xfado criado permanecer\xe3o nos servi\xe7os de conta da Atlassian.",
    "focused-task-close-account.delete-account": "Excluir conta",
    "focused-task-close-account.delete-account.content-preview.footnote.admin": 'Observa\xe7\xe3o: responder a esta pesquisa nos ajudar\xe1 a melhorar a experi\xeancia para todos os usu\xe1rios. O usu\xe1rio continuar\xe1 sendo exibido como "Ex-usu\xe1rio" depois que voc\xea excluir a conta dele.',
    "focused-task-close-account.delete-account.content-preview.footnote.self": 'Observa\xe7\xe3o: responder a esta pesquisa nos ajudar\xe1 a melhorar a experi\xeancia para todos os usu\xe1rios, inclusive para quem excluir a pr\xf3pria conta. Voc\xea continuar\xe1 sendo exibido(a) como "Ex-usu\xe1rio" depois de excluir sua conta.',
    "focused-task-close-account.delete-account.content-preview.formerUser": "Ex-usu\xe1rio",
    "focused-task-close-account.delete-account.content-preview.heading.admin": "Como voc\xea prefere que o usu\xe1rio exclu\xeddo seja exibido?",
    "focused-task-close-account.delete-account.content-preview.heading.self": "Como voc\xea prefere que sua conta exclu\xedda seja exibida?",
    "focused-task-close-account.delete-account.content-preview.line.survey.admin": "Se voc\xea pudesse escolher, como preferiria que o usu\xe1rio exclu\xeddo fosse exibido aos outros usu\xe1rios?",
    "focused-task-close-account.delete-account.content-preview.line.survey.self": "Se voc\xea pudesse escolher, como preferiria ser exibido(a) aos outros usu\xe1rios?",
    "focused-task-close-account.delete-account.content-preview.paragraph.survey.admin": 'Depois que a conta do usu\xe1rio for exclu\xedda, ele ser\xe1 exibido como "Ex-usu\xe1rio" para os outros usu\xe1rios. Reserve um momento para responder \xe0 pergunta da nossa pesquisa.',
    "focused-task-close-account.delete-account.content-preview.paragraph.survey.self": 'Depois que sua conta for exclu\xedda, voc\xea ser\xe1 exibido(a) como "Ex-usu\xe1rio" para os outros usu\xe1rios. Reserve um momento para responder \xe0 pergunta da nossa pesquisa.',
    "focused-task-close-account.delete-account.drop-down-collapse-button": "Mostrar menos",
    "focused-task-close-account.delete-account.drop-down-expand-button": "{num} mais",
    "focused-task-close-account.delete-account.overview.first.line.admin": "Voc\xea est\xe1 prestes a excluir a conta de:",
    "focused-task-close-account.delete-account.overview.first.line.self": "Voc\xea est\xe1 prestes a excluir sua conta:",
    "focused-task-close-account.delete-account.overview.heading.admin": "Excluir conta",
    "focused-task-close-account.delete-account.overview.heading.self": "Excluir sua conta",
    "focused-task-close-account.delete-account.overview.inline-dialog.content-created.admin": "Por exemplo, p\xe1ginas, itens e coment\xe1rios que ele(a) criou em produtos.",
    "focused-task-close-account.delete-account.overview.inline-dialog.content-created.self": "Por exemplo, p\xe1ginas, itens e coment\xe1rios que voc\xea criou em produtos.",
    "focused-task-close-account.delete-account.overview.inline-dialog.data-apps.admin": "Voc\xea ou outros usu\xe1rios podem ter instalado aplicativos que adicionam fun\xe7\xf5es aos produtos da Atlassian. Esses aplicativos podem ter armazenado as informa\xe7\xf5es de perfil do usu\xe1rio.",
    "focused-task-close-account.delete-account.overview.inline-dialog.data-apps.self": "Voc\xea ou outros usu\xe1rios podem ter instalado aplicativos que adicionam fun\xe7\xf5es aos produtos da Atlassian. Esses aplicativos podem ter armazenado suas informa\xe7\xf5es de perfil.",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.li1.admin": "Informa\xe7\xf5es relacionadas a compras, que precisamos manter para relat\xf3rios financeiros.",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.li1.self": "Informa\xe7\xf5es relacionadas a compras, que precisamos manter para relat\xf3rios financeiros.",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.li2.admin": "Registros que mostram que exclu\xedmos a conta de algu\xe9m, que podemos precisar fornecer a \xf3rg\xe3os reguladores.",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.li2.self": "Registros que mostram que exclu\xedmos a conta de algu\xe9m, que podemos precisar fornecer a \xf3rg\xe3os reguladores.",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.li3.admin": "Dados que fazem parte de uma a\xe7\xe3o judicial em atividade que, por lei, somos obrigados a manter.",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.li3.self": "Dados que fazem parte de uma a\xe7\xe3o judicial em atividade que, por lei, somos obrigados a manter.",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.p1.admin": "Mantemos dados pessoais por per\xedodos limitados quando temos fins comerciais ou legais leg\xedtimos. Alguns exemplos incluem:",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.p1.self": "Mantemos dados pessoais por per\xedodos limitados quando temos fins comerciais ou legais leg\xedtimos. Alguns exemplos incluem:",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.p2.admin": "N\xe3o exclu\xedmos dados pessoais de conte\xfados criados por usu\xe1rios, como nomes e endere\xe7os de e-mail digitados em uma p\xe1gina ou item. Os administradores do produto precisam excluir esses dados manualmente.",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.p2.self": "N\xe3o exclu\xedmos dados pessoais de conte\xfados criados por voc\xea ou outras pessoas, como nomes e endere\xe7os de e-mail digitados em uma p\xe1gina ou item. Seus administradores do produto precisam excluir esses dados manualmente.",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.p3.admin": "Usu\xe1rios t\xeam o direito de enviar queixas \xe0 autoridade fiscalizadora do seu pa\xeds.",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.p3.self": "Voc\xea tem o direito de enviar queixas \xe0 autoridade fiscalizadora do seu pa\xeds.",
    "focused-task-close-account.delete-account.overview.paragraph.about-to-delete.admin": "Quando voc\xea excluir a conta:",
    "focused-task-close-account.delete-account.overview.paragraph.about-to-delete.self": "Quando voc\xea excluir sua conta:",
    "focused-task-close-account.delete-account.overview.paragraph.content-created.admin": "O conte\xfado criado permanecer\xe1 nos servi\xe7os de conta da Atlassian.",
    "focused-task-close-account.delete-account.overview.paragraph.content-created.self": "O conte\xfado criado permanecer\xe1 nos servi\xe7os de conta da Atlassian.",
    "focused-task-close-account.delete-account.overview.paragraph.grace-period.admin": "Depois de um per\xedodo de car\xeancia de 14 dias, voc\xea n\xe3o poder\xe1 cancelar a exclus\xe3o da conta.",
    "focused-task-close-account.delete-account.overview.paragraph.list-of-apps-with-personal-data.admin": "Vamos enviar um e-mail para voc\xea com uma lista de aplicativos que podem ter armazenado seus dados pessoais.",
    "focused-task-close-account.delete-account.overview.paragraph.list-of-apps-with-personal-data.self": "Vamos enviar um e-mail para voc\xea com uma lista de aplicativos que podem ter armazenado seus dados pessoais.",
    "focused-task-close-account.delete-account.overview.paragraph.loseAccess.admin": "{fullName} <b>perder\xe1 o acesso imediatamente</b> a todos os servi\xe7os de conta da Atlassian. Atualmente ele(a) possui acesso a:",
    "focused-task-close-account.delete-account.overview.paragraph.loseAccess.admin.noSites": "{fullName} <b>perder\xe1 o acesso imediatamente</b> a todos os servi\xe7os de conta da Atlassian. Atualmente ele(a) n\xe3o possui acesso a nenhum servi\xe7o, exceto servi\xe7os como Community e Marketplace.",
    "focused-task-close-account.delete-account.overview.paragraph.loseAccess.footnote": "Outros servi\xe7os de conta da Atlassian, como a Atlassian Community e o Marketplace.",
    "focused-task-close-account.delete-account.overview.paragraph.loseAccess.self": "Voc\xea <b>perder\xe1 o acesso imediatamente</b> a todos os servi\xe7os de conta da Atlassian. Atualmente voc\xea possui acesso a:",
    "focused-task-close-account.delete-account.overview.paragraph.loseAccess.self.noSites": "Voc\xea <b>perder\xe1 o acesso imediatamente</b> a todos os servi\xe7os de conta da Atlassian. Atualmente voc\xea n\xe3o possui acesso a nenhum servi\xe7o, exceto servi\xe7os como Community e Marketplace.",
    "focused-task-close-account.delete-account.overview.paragraph.personal-data-will-be-deleted.admin": "Vamos <b>excluir seus dados pessoais</b>, tais como nome completo e endere\xe7o de e-mail, dos servi\xe7os de conta da Atlassian dentro de 30 dias, exceto em alguns casos obrigat\xf3rios para fins comerciais ou legais leg\xedtimos.",
    "focused-task-close-account.delete-account.overview.paragraph.personal-data-will-be-deleted.self": "Vamos <b>excluir seus dados pessoais</b>, tais como nome completo e endere\xe7o de e-mail, dos servi\xe7os de conta da Atlassian dentro de 30 dias, exceto em alguns casos obrigat\xf3rios para fins comerciais ou legais leg\xedtimos.",
    "focused-task-close-account.delete-account.overview.warning-section.body": "Depois de um per\xedodo de car\xeancia de 14 dias, voc\xea n\xe3o poder\xe1 cancelar a exclus\xe3o da conta. Se voc\xea achar que vai precisar da conta depois, desative-a.",
    "focused-task-close-account.delete-account.overview.warning-section.deactivated.body": "Depois de um per\xedodo de car\xeancia de 14 dias, voc\xea n\xe3o poder\xe1 cancelar a exclus\xe3o da conta.",
    "focused-task-close-account.learnMore": "Saiba mais",
    "focused-task-close-account.next": "Pr\xf3ximo",
    "focused-task-close-account.previous": "Anterior"
};

});

parcelRegister("fxmzz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b4fb728ade14f68c$export$2e2bcd8739ae039; });
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Portuguese (Portugal)
var $b4fb728ade14f68c$export$2e2bcd8739ae039 = {
    "focused-task-close-account.cancel": "Cancelar",
    "focused-task-close-account.deactivate-account": "Desativar conta",
    "focused-task-close-account.deactivate-account.overview.first.line.admin": "Est\xe1 prestes a desativar a conta de utilizador de:",
    "focused-task-close-account.deactivate-account.overview.first.line.self": "Est\xe1 prestes a desativar a conta de utilizador de:",
    "focused-task-close-account.deactivate-account.overview.heading.admin": "Desativar conta",
    "focused-task-close-account.deactivate-account.overview.heading.self": "Desativar conta",
    "focused-task-close-account.deactivate-account.overview.last.line.admin": "Pode reativar a conta quando quiser.",
    "focused-task-close-account.deactivate-account.overview.last.line.self": "Pode reativar a conta quando quiser.",
    "focused-task-close-account.deactivate-account.overview.paragraph.about-to-deactivate.admin": "Quando desativa a conta:",
    "focused-task-close-account.deactivate-account.overview.paragraph.about-to-deactivate.self": "Quando desativa a conta:",
    "focused-task-close-account.deactivate-account.overview.paragraph.billing.admin": "J\xe1 n\xe3o ser\xe1 cobrado por estes utilizadores.",
    "focused-task-close-account.deactivate-account.overview.paragraph.billing.self": "J\xe1 n\xe3o ser\xe1 cobrado por estes utilizadores.",
    "focused-task-close-account.deactivate-account.overview.paragraph.loseAccess.admin": "{fullName} ir\xe1 <b>perder acesso imediatamente</b> a todos os servi\xe7os da conta Atlassian. Atualmente tem acesso a:",
    "focused-task-close-account.deactivate-account.overview.paragraph.loseAccess.admin.noSites": "{fullName} ir\xe1 <b>perder acesso imediatamente</b> a todos os servi\xe7os da conta Atlassian. Atualmente, n\xe3o tem acesso a nenhum servi\xe7o, exceto \xe0 Comunidade e ao Marketplace.",
    "focused-task-close-account.deactivate-account.overview.paragraph.loseAccess.footnote": "Outros servi\xe7os da conta Atlassian, tais como a Comunidade Atlassian e o Marketplace.",
    "focused-task-close-account.deactivate-account.overview.paragraph.loseAccess.self": "Ir\xe1 <b>perder acesso imediatamente</b> a todos os servi\xe7os da conta Atlassian. Atualmente tem acesso a:",
    "focused-task-close-account.deactivate-account.overview.paragraph.loseAccess.self.noSites": "Ir\xe1 <b>perder acesso imediatamente</b> a todos os servi\xe7os da conta Atlassian. Atualmente, n\xe3o tem acesso a nenhum servi\xe7o, exceto \xe0 Comunidade e ao Marketplace.",
    "focused-task-close-account.deactivate-account.overview.paragraph.personal-data.admin": "Os dados pessoais, tais como o nome completo e endere\xe7o de e-mail, e o conte\xfado criado pelos mesmos ser\xe1 mantido nos servi\xe7os da conta Atlassian.",
    "focused-task-close-account.deactivate-account.overview.paragraph.personal-data.self": "Os dados pessoais, tais como o nome completo e endere\xe7o de e-mail, e o conte\xfado criado pelos mesmos ser\xe1 mantido nos servi\xe7os da conta Atlassian.",
    "focused-task-close-account.delete-account": "Eliminar conta",
    "focused-task-close-account.delete-account.content-preview.footnote.admin": "Nota: responder a este inqu\xe9rito ir\xe1 ajudar-nos a criar uma melhor experi\xeancia para todos os utilizadores. O utilizador continua a ser apresentado como \u201CUtilizador antigo\u201D ap\xf3s eliminar a conta.",
    "focused-task-close-account.delete-account.content-preview.footnote.self": "Nota: responder a este inqu\xe9rito ir\xe1 ajudar-nos a criar uma melhor experi\xeancia para todos os utilizadores, incluindo os utilizadores que eliminaram as suas contas. O utilizador continua a ser apresentado como \u201CUtilizador antigo\u201D ap\xf3s eliminar a conta.",
    "focused-task-close-account.delete-account.content-preview.formerUser": "Utilizador antigo",
    "focused-task-close-account.delete-account.content-preview.heading.admin": "Como pretende que o utilizador eliminado seja apresentado?",
    "focused-task-close-account.delete-account.content-preview.heading.self": "Como pretende que a conta eliminada seja apresentado?",
    "focused-task-close-account.delete-account.content-preview.line.survey.admin": "Se pudesse escolher, como gostaria que o utilizador eliminado fosse apresentado aos outros utilizadores?",
    "focused-task-close-account.delete-account.content-preview.line.survey.self": "Se pudesse escolher, como gostaria de ser apresentado aos outros utilizadores?",
    "focused-task-close-account.delete-account.content-preview.paragraph.survey.admin": 'Ap\xf3s a conta do utilizador ser eliminada, o utilizador \xe9 apresentado aos outros utilizadores como "Utilizador antigo". Dedique algum tempo a responder \xe0 pergunta do nosso inqu\xe9rito.',
    "focused-task-close-account.delete-account.content-preview.paragraph.survey.self": 'Ap\xf3s a sua conta ser eliminada, \xe9 apresentado aos outros utilizadores como "Utilizador antigo". Dedique algum tempo a responder \xe0 pergunta do nosso inqu\xe9rito.',
    "focused-task-close-account.delete-account.drop-down-collapse-button": "Mostrar menos",
    "focused-task-close-account.delete-account.drop-down-expand-button": "mais {num}",
    "focused-task-close-account.delete-account.overview.first.line.admin": "Est\xe1 prestes a eliminar a conta de:",
    "focused-task-close-account.delete-account.overview.first.line.self": "Est\xe1 prestes a eliminar a sua conta:",
    "focused-task-close-account.delete-account.overview.heading.admin": "Elimina\xe7\xe3o da conta",
    "focused-task-close-account.delete-account.overview.heading.self": "Elimina\xe7\xe3o da conta",
    "focused-task-close-account.delete-account.overview.inline-dialog.content-created.admin": "Por exemplo, p\xe1ginas, problemas e coment\xe1rios que criaram nos produtos.",
    "focused-task-close-account.delete-account.overview.inline-dialog.content-created.self": "Por exemplo, p\xe1ginas, problemas e coment\xe1rios que criou nos produtos.",
    "focused-task-close-account.delete-account.overview.inline-dialog.data-apps.admin": "O utilizador ou outros poder\xe3o ter instalado aplica\xe7\xf5es que adicionam funcionalidades aos produtos Atlassian. Estas aplica\xe7\xf5es poder\xe3o ter armazenado as informa\xe7\xf5es de perfil do utilizador.",
    "focused-task-close-account.delete-account.overview.inline-dialog.data-apps.self": "O utilizador ou outros poder\xe3o ter instalado aplica\xe7\xf5es que adicionam funcionalidades aos produtos Atlassian. Estas aplica\xe7\xf5es poder\xe3o ter armazenado as suas informa\xe7\xf5es de perfil.",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.li1.admin": "Informa\xe7\xf5es relacionadas com compras, que t\xeam de ser mantidas para relat\xf3rios financeiros.",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.li1.self": "Informa\xe7\xf5es relacionadas com compras, as quais t\xeam de ser mantidas para relat\xf3rios financeiros.",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.li2.admin": "Registos que demonstra\xe7\xe3o a elimina\xe7\xe3o da conta de um utilizador, que poder\xe3o ser necess\xe1rios para apresenta\xe7\xe3o a reguladores.",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.li2.self": "Registos que demonstra\xe7\xe3o a elimina\xe7\xe3o da conta de um utilizador, que poder\xe3o ser necess\xe1rios para apresenta\xe7\xe3o a reguladores.",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.li3.admin": "Dados que pertencem a um processo legal ativo e que  t\xeam de ser mantidos, tal como requerido por lei.",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.li3.self": "Dados que pertencem a um processo legal ativo e que  t\xeam de ser mantidos, tal como requerido por lei.",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.p1.admin": "Mantemos os dados pessoais por per\xedodos de tempo limitados para fins legais ou de neg\xf3cio leg\xedtimos. Alguns exemplos incluem:",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.p1.self": "Mantemos os dados pessoais por per\xedodos de tempo limitados para fins legais ou de neg\xf3cio leg\xedtimos. Alguns exemplos incluem:",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.p2.admin": "N\xe3o eliminamos quaisquer dados pessoais no conte\xfado criado pelos utilizadores, tais como nomes ou endere\xe7os de e-mail introduzidos numa p\xe1gina ou num problema. Os administradores do produto ter\xe3o de eliminar manualmente os respetivos dados.",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.p2.self": "N\xe3o eliminamos quaisquer dados pessoais no conte\xfado criado por si ou por outros utilizadores, tais como nomes ou endere\xe7os de e-mail introduzidos numa p\xe1gina ou num problema. Os administradores do produto ter\xe3o de eliminar manualmente os respetivos dados.",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.p3.admin": "Os utilizadores t\xeam o direito de enviar reclama\xe7\xf5es \xe0 autoridade de supervis\xe3o do seu pa\xeds.",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.p3.self": "Tem o direito de enviar reclama\xe7\xf5es \xe0 autoridade de supervis\xe3o do seu pa\xeds.",
    "focused-task-close-account.delete-account.overview.paragraph.about-to-delete.admin": "Quando elimina a conta:",
    "focused-task-close-account.delete-account.overview.paragraph.about-to-delete.self": "Quando elimina a sua conta:",
    "focused-task-close-account.delete-account.overview.paragraph.content-created.admin": "O conte\xfado criado pelos mesmos ser\xe1 mantido nos servi\xe7os da conta Atlassian.",
    "focused-task-close-account.delete-account.overview.paragraph.content-created.self": "O conte\xfado criado por si ser\xe1 mantido nos servi\xe7os da conta Atlassian.",
    "focused-task-close-account.delete-account.overview.paragraph.grace-period.admin": "Ap\xf3s uma prorroga\xe7\xe3o de 14 dias, n\xe3o poder\xe1 cancelar o processo de elimina\xe7\xe3o da conta.",
    "focused-task-close-account.delete-account.overview.paragraph.list-of-apps-with-personal-data.admin": "Ser\xe1 enviado um e-mail com a lista das aplica\xe7\xf5es que poder\xe3o ter armazenado os dados pessoais.",
    "focused-task-close-account.delete-account.overview.paragraph.list-of-apps-with-personal-data.self": "Ser\xe1 enviado um e-mail com a lista das aplica\xe7\xf5es que poder\xe3o ter armazenado os seus dados pessoais.",
    "focused-task-close-account.delete-account.overview.paragraph.loseAccess.admin": "{fullName} ir\xe1 <b>perder acesso imediatamente</b> a todos os servi\xe7os da conta Atlassian. Atualmente tem acesso a:",
    "focused-task-close-account.delete-account.overview.paragraph.loseAccess.admin.noSites": "{fullName} ir\xe1 <b>perder acesso imediatamente</b> a todos os servi\xe7os da conta Atlassian. Atualmente, n\xe3o tem acesso a nenhum servi\xe7o, exceto \xe0 Comunidade e ao Marketplace.",
    "focused-task-close-account.delete-account.overview.paragraph.loseAccess.footnote": "Outros servi\xe7os da conta Atlassian, tais como a Comunidade Atlassian e o Marketplace.",
    "focused-task-close-account.delete-account.overview.paragraph.loseAccess.self": "Ir\xe1 <b>perder acesso imediatamente</b> a todos os servi\xe7os da conta Atlassian. Atualmente tem acesso a:",
    "focused-task-close-account.delete-account.overview.paragraph.loseAccess.self.noSites": "Ir\xe1 <b>perder acesso imediatamente</b> a todos os servi\xe7os da conta Atlassian. Atualmente, n\xe3o tem acesso a nenhum servi\xe7o, exceto \xe0 Comunidade e ao Marketplace.",
    "focused-task-close-account.delete-account.overview.paragraph.personal-data-will-be-deleted.admin": "Iremos <b>eliminar os dados pessoais</b>, tais como o nome completo e endere\xe7o de e-mail, dos servi\xe7os da conta Atlassian dentro de 30 dias, exceto nos poucos casos onde t\xeam de ser mantidos para fins legais ou leg\xedtimos de neg\xf3cio.",
    "focused-task-close-account.delete-account.overview.paragraph.personal-data-will-be-deleted.self": "Iremos <b>eliminar os seus dados pessoais</b>, tais como o seu nome completo e endere\xe7o de e-mail, dos servi\xe7os da conta Atlassian dentro de 30 dias, exceto nos poucos casos onde t\xeam de ser mantidos para fins legais ou leg\xedtimos de neg\xf3cio.",
    "focused-task-close-account.delete-account.overview.warning-section.body": "Ap\xf3s uma prorroga\xe7\xe3o de 14 dias, n\xe3o poder\xe1 cancelar o processo de elimina\xe7\xe3o da conta. Se achar que poder\xe1 necessitar da conta mais tarde, opte por desativ\xe1-la.",
    "focused-task-close-account.delete-account.overview.warning-section.deactivated.body": "Ap\xf3s uma prorroga\xe7\xe3o de 14 dias, n\xe3o poder\xe1 cancelar o processo de elimina\xe7\xe3o da conta.",
    "focused-task-close-account.learnMore": "Obter mais informa\xe7\xf5es",
    "focused-task-close-account.next": "Seguinte",
    "focused-task-close-account.previous": "Anterior"
};

});

parcelRegister("24Mv3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1831939397eb2288$export$2e2bcd8739ae039; });
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Russian
var $1831939397eb2288$export$2e2bcd8739ae039 = {
    "focused-task-close-account.cancel": "\u041E\u0442\u043C\u0435\u043D\u0438\u0442\u044C",
    "focused-task-close-account.deactivate-account": "\u0414\u0435\u0430\u043A\u0442\u0438\u0432\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u0430\u043A\u043A\u0430\u0443\u043D\u0442",
    "focused-task-close-account.deactivate-account.overview.first.line.admin": "\u0412\u044B \u0441\u043E\u0431\u0438\u0440\u0430\u0435\u0442\u0435\u0441\u044C \u043E\u0442\u043A\u043B\u044E\u0447\u0438\u0442\u044C \u0430\u043A\u043A\u0430\u0443\u043D\u0442 \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F:",
    "focused-task-close-account.deactivate-account.overview.first.line.self": "\u0412\u044B \u0441\u043E\u0431\u0438\u0440\u0430\u0435\u0442\u0435\u0441\u044C \u043E\u0442\u043A\u043B\u044E\u0447\u0438\u0442\u044C \u0430\u043A\u043A\u0430\u0443\u043D\u0442 \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F:",
    "focused-task-close-account.deactivate-account.overview.heading.admin": "\u041E\u0442\u043A\u043B\u044E\u0447\u0435\u043D\u0438\u0435 \u0430\u043A\u043A\u0430\u0443\u043D\u0442\u0430",
    "focused-task-close-account.deactivate-account.overview.heading.self": "\u041E\u0442\u043A\u043B\u044E\u0447\u0435\u043D\u0438\u0435 \u0430\u043A\u043A\u0430\u0443\u043D\u0442\u0430",
    "focused-task-close-account.deactivate-account.overview.last.line.admin": "\u0410\u043A\u043A\u0430\u0443\u043D\u0442 \u043C\u043E\u0436\u043D\u043E \u0432\u043E\u0441\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u044C \u0432 \u043B\u044E\u0431\u043E\u0435 \u0432\u0440\u0435\u043C\u044F.",
    "focused-task-close-account.deactivate-account.overview.last.line.self": "\u0410\u043A\u043A\u0430\u0443\u043D\u0442 \u043C\u043E\u0436\u043D\u043E \u0432\u043E\u0441\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u044C \u0432 \u043B\u044E\u0431\u043E\u0435 \u0432\u0440\u0435\u043C\u044F.",
    "focused-task-close-account.deactivate-account.overview.paragraph.about-to-deactivate.admin": "\u041A\u043E\u0433\u0434\u0430 \u0432\u044B \u043E\u0442\u043A\u043B\u044E\u0447\u0438\u0442\u0435 \u0430\u043A\u043A\u0430\u0443\u043D\u0442:",
    "focused-task-close-account.deactivate-account.overview.paragraph.about-to-deactivate.self": "\u041A\u043E\u0433\u0434\u0430 \u0432\u044B \u043E\u0442\u043A\u043B\u044E\u0447\u0438\u0442\u0435 \u0430\u043A\u043A\u0430\u0443\u043D\u0442:",
    "focused-task-close-account.deactivate-account.overview.paragraph.billing.admin": "\u041C\u044B \u0431\u043E\u043B\u044C\u0448\u0435 \u043D\u0435 \u0431\u0443\u0434\u0435\u043C \u0432\u0437\u0438\u043C\u0430\u0442\u044C \u0441 \u0432\u0430\u0441 \u043F\u043B\u0430\u0442\u0443 \u0437\u0430 \u043D\u0438\u0445.",
    "focused-task-close-account.deactivate-account.overview.paragraph.billing.self": "\u041C\u044B \u0431\u043E\u043B\u044C\u0448\u0435 \u043D\u0435 \u0431\u0443\u0434\u0435\u043C \u0432\u0437\u0438\u043C\u0430\u0442\u044C \u0441 \u0432\u0430\u0441 \u043F\u043B\u0430\u0442\u0443 \u0437\u0430 \u043D\u0438\u0445.",
    "focused-task-close-account.deactivate-account.overview.paragraph.loseAccess.admin": "{fullName} <b>\u043D\u0435\u043C\u0435\u0434\u043B\u0435\u043D\u043D\u043E \u043F\u043E\u0442\u0435\u0440\u044F\u0435\u0442 \u0434\u043E\u0441\u0442\u0443\u043F</b> \u043A\u043E \u0432\u0441\u0435\u043C \u0441\u0435\u0440\u0432\u0438\u0441\u0430\u043C, \u0441\u0432\u044F\u0437\u0430\u043D\u043D\u044B\u043C \u0441 \u0430\u043A\u043A\u0430\u0443\u043D\u0442\u043E\u043C Atlassian. \u0421\u0435\u0439\u0447\u0430\u0441 \u044D\u0442\u043E\u0442 \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044C \u0440\u0430\u0431\u043E\u0442\u0430\u0435\u0442 \u0441\u043E \u0441\u043B\u0435\u0434\u0443\u044E\u0449\u0438\u043C\u0438 \u0441\u0435\u0440\u0432\u0438\u0441\u0430\u043C\u0438:",
    "focused-task-close-account.deactivate-account.overview.paragraph.loseAccess.admin.noSites": "{fullName} <b>\u043D\u0435\u043C\u0435\u0434\u043B\u0435\u043D\u043D\u043E \u043F\u043E\u0442\u0435\u0440\u044F\u0435\u0442 \u0434\u043E\u0441\u0442\u0443\u043F</b> \u043A\u043E \u0432\u0441\u0435\u043C \u0441\u0435\u0440\u0432\u0438\u0441\u0430\u043C, \u0441\u0432\u044F\u0437\u0430\u043D\u043D\u044B\u043C \u0441 \u0430\u043A\u043A\u0430\u0443\u043D\u0442\u043E\u043C Atlassian. \u0421\u0435\u0439\u0447\u0430\u0441 \u0443 \u044D\u0442\u043E\u0433\u043E \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F \u0435\u0441\u0442\u044C \u0434\u043E\u0441\u0442\u0443\u043F \u0442\u043E\u043B\u044C\u043A\u043E \u043A \u0421\u043E\u043E\u0431\u0449\u0435\u0441\u0442\u0432\u0443 Atlassian \u0438 Marketplace.",
    "focused-task-close-account.deactivate-account.overview.paragraph.loseAccess.footnote": "\u0414\u0440\u0443\u0433\u0438\u0435 \u0441\u0435\u0440\u0432\u0438\u0441\u044B, \u0441\u0432\u044F\u0437\u0430\u043D\u043D\u044B\u0435 \u0441 \u0430\u043A\u043A\u0430\u0443\u043D\u0442\u043E\u043C Atlassian, \u043D\u0430\u043F\u0440\u0438\u043C\u0435\u0440 \u0421\u043E\u043E\u0431\u0449\u0435\u0441\u0442\u0432\u043E Atlassian \u0438 Marketplace.",
    "focused-task-close-account.deactivate-account.overview.paragraph.loseAccess.self": "\u0412\u044B <b>\u043D\u0435\u043C\u0435\u0434\u043B\u0435\u043D\u043D\u043E \u043F\u043E\u0442\u0435\u0440\u044F\u0435\u0442\u0435 \u0434\u043E\u0441\u0442\u0443\u043F</b> \u043A\u043E \u0432\u0441\u0435\u043C \u0441\u0435\u0440\u0432\u0438\u0441\u0430\u043C, \u0441\u0432\u044F\u0437\u0430\u043D\u043D\u044B\u043C \u0441 \u0430\u043A\u043A\u0430\u0443\u043D\u0442\u043E\u043C Atlassian. \u0421\u0435\u0439\u0447\u0430\u0441 \u0432\u044B \u0440\u0430\u0431\u043E\u0442\u0430\u0435\u0442\u0435 \u0441\u043E \u0441\u043B\u0435\u0434\u0443\u044E\u0449\u0438\u043C\u0438 \u0441\u0435\u0440\u0432\u0438\u0441\u0430\u043C\u0438:",
    "focused-task-close-account.deactivate-account.overview.paragraph.loseAccess.self.noSites": "\u0412\u044B <b>\u043D\u0435\u043C\u0435\u0434\u043B\u0435\u043D\u043D\u043E \u043F\u043E\u0442\u0435\u0440\u044F\u0435\u0442\u0435 \u0434\u043E\u0441\u0442\u0443\u043F</b> \u043A\u043E \u0432\u0441\u0435\u043C \u0441\u0435\u0440\u0432\u0438\u0441\u0430\u043C, \u0441\u0432\u044F\u0437\u0430\u043D\u043D\u044B\u043C \u0441 \u0430\u043A\u043A\u0430\u0443\u043D\u0442\u043E\u043C Atlassian. \u0421\u0435\u0439\u0447\u0430\u0441 \u0443 \u0432\u0430\u0441 \u0435\u0441\u0442\u044C \u0434\u043E\u0441\u0442\u0443\u043F \u0442\u043E\u043B\u044C\u043A\u043E \u043A \u0421\u043E\u043E\u0431\u0449\u0435\u0441\u0442\u0432\u0443 Atlassian \u0438 Marketplace.",
    "focused-task-close-account.deactivate-account.overview.paragraph.personal-data.admin": "\u041F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u0435 \u0434\u0430\u043D\u043D\u044B\u0435, \u043D\u0430\u043F\u0440\u0438\u043C\u0435\u0440 \u043F\u043E\u043B\u043D\u043E\u0435 \u0438\u043C\u044F \u0438 \u0430\u0434\u0440\u0435\u0441 \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u043E\u0439 \u043F\u043E\u0447\u0442\u044B, \u0430 \u0442\u0430\u043A\u0436\u0435 \u0441\u043E\u0437\u0434\u0430\u043D\u043D\u044B\u0439 \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0435\u043C \u043A\u043E\u043D\u0442\u0435\u043D\u0442, \u0441\u043E\u0445\u0440\u0430\u043D\u044F\u0442\u0441\u044F \u0432 \u0441\u0435\u0440\u0432\u0438\u0441\u0430\u0445, \u0441\u0432\u044F\u0437\u0430\u043D\u043D\u044B\u0445 \u0441 \u0430\u043A\u043A\u0430\u0443\u043D\u0442\u043E\u043C Atlassian.",
    "focused-task-close-account.deactivate-account.overview.paragraph.personal-data.self": "\u041F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u0435 \u0434\u0430\u043D\u043D\u044B\u0435, \u043D\u0430\u043F\u0440\u0438\u043C\u0435\u0440 \u043F\u043E\u043B\u043D\u043E\u0435 \u0438\u043C\u044F \u0438 \u0430\u0434\u0440\u0435\u0441 \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u043E\u0439 \u043F\u043E\u0447\u0442\u044B, \u0430 \u0442\u0430\u043A\u0436\u0435 \u0441\u043E\u0437\u0434\u0430\u043D\u043D\u044B\u0439 \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0435\u043C \u043A\u043E\u043D\u0442\u0435\u043D\u0442, \u0441\u043E\u0445\u0440\u0430\u043D\u044F\u0442\u0441\u044F \u0432 \u0441\u0435\u0440\u0432\u0438\u0441\u0430\u0445, \u0441\u0432\u044F\u0437\u0430\u043D\u043D\u044B\u0445 \u0441 \u0430\u043A\u043A\u0430\u0443\u043D\u0442\u043E\u043C Atlassian.",
    "focused-task-close-account.delete-account": "\u0423\u0434\u0430\u043B\u0438\u0442\u044C \u0430\u043A\u043A\u0430\u0443\u043D\u0442",
    "focused-task-close-account.delete-account.content-preview.footnote.admin": "\u041F\u0440\u0438\u043C\u0435\u0447\u0430\u043D\u0438\u0435. \u041E\u0442\u0432\u0435\u0442\u0438\u0432 \u043D\u0430 \u044D\u0442\u0438 \u0432\u043E\u043F\u0440\u043E\u0441\u044B, \u0432\u044B \u043F\u043E\u043C\u043E\u0436\u0435\u0442\u0435 \u043D\u0430\u043C \u0441\u0434\u0435\u043B\u0430\u0442\u044C \u0441\u0435\u0440\u0432\u0438\u0441 \u0435\u0449\u0435 \u0443\u0434\u043E\u0431\u043D\u0435\u0435 \u0434\u043B\u044F \u0432\u0441\u0435\u0445 \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0435\u0439. \u0423 \u043B\u044E\u0434\u0435\u0439, \u0447\u044C\u0438 \u0430\u043A\u043A\u0430\u0443\u043D\u0442\u044B \u0432\u044B \u0443\u0434\u0430\u043B\u0438\u0442\u0435, \u043F\u043E-\u043F\u0440\u0435\u0436\u043D\u0435\u043C\u0443 \u0431\u0443\u0434\u0435\u0442 \u0441\u0442\u0430\u0442\u0443\u0441 \xab\u0411\u044B\u0432\u0448\u0438\u0439 \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044C\xbb.",
    "focused-task-close-account.delete-account.content-preview.footnote.self": "\u041F\u0440\u0438\u043C\u0435\u0447\u0430\u043D\u0438\u0435. \u041F\u0440\u043E\u0439\u0434\u044F \u044D\u0442\u043E\u0442 \u043E\u043F\u0440\u043E\u0441, \u0432\u044B \u043F\u043E\u043C\u043E\u0436\u0435\u0442\u0435 \u043D\u0430\u043C \u0443\u043B\u0443\u0447\u0448\u0438\u0442\u044C \u0441\u0435\u0440\u0432\u0438\u0441 \u0434\u043B\u044F \u0432\u0441\u0435\u0445 \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0435\u0439, \u0432 \u0442\u043E\u043C \u0447\u0438\u0441\u043B\u0435 \u0442\u0435\u0445, \u043A\u0442\u043E \u0443\u0434\u0430\u043B\u044F\u0435\u0442 \u0441\u0432\u043E\u0438 \u0430\u043A\u043A\u0430\u0443\u043D\u0442\u044B. \u041F\u043E\u0441\u043B\u0435 \u0443\u0434\u0430\u043B\u0435\u043D\u0438\u044F \u0430\u043A\u043A\u0430\u0443\u043D\u0442\u0430 \u0443 \u0432\u0430\u0441 \u0441\u043E\u0445\u0440\u0430\u043D\u0438\u0442\u0441\u044F \u0441\u0442\u0430\u0442\u0443\u0441 \xab\u0411\u044B\u0432\u0448\u0438\u0439 \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044C\xbb.",
    "focused-task-close-account.delete-account.content-preview.formerUser": "\u0411\u044B\u0432\u0448\u0438\u0439 \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044C",
    "focused-task-close-account.delete-account.content-preview.heading.admin": "\u041A\u0430\u043A \u0432\u044B \u0441\u0447\u0438\u0442\u0430\u0435\u0442\u0435, \u043A\u0430\u043A\u043E\u0439 \u0441\u0442\u0430\u0442\u0443\u0441 \u0432 \u0441\u0438\u0441\u0442\u0435\u043C\u0435 \u0434\u043E\u043B\u0436\u0435\u043D \u0431\u044B\u0442\u044C \u0443 \u0443\u0434\u0430\u043B\u0435\u043D\u043D\u044B\u0445 \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0435\u0439?",
    "focused-task-close-account.delete-account.content-preview.heading.self": "\u041A\u0430\u043A \u0432\u044B \u0441\u0447\u0438\u0442\u0430\u0435\u0442\u0435, \u043A\u0430\u043A\u043E\u0439 \u0441\u0442\u0430\u0442\u0443\u0441 \u0432 \u0441\u0438\u0441\u0442\u0435\u043C\u0435 \u0434\u043E\u043B\u0436\u0435\u043D \u0431\u044B\u0442\u044C \u0443 \u0432\u0430\u0448\u0435\u0433\u043E \u0443\u0434\u0430\u043B\u0435\u043D\u043D\u043E\u0433\u043E \u0430\u043A\u043A\u0430\u0443\u043D\u0442\u0430?",
    "focused-task-close-account.delete-account.content-preview.line.survey.admin": "\u0415\u0441\u043B\u0438 \u0431\u044B \u044D\u0442\u043E \u0437\u0430\u0432\u0438\u0441\u0435\u043B\u043E \u043E\u0442 \u0432\u0430\u0441, \u043A\u0430\u043A\u043E\u0439 \u0441\u0442\u0430\u0442\u0443\u0441 \u0432 \u0441\u0438\u0441\u0442\u0435\u043C\u0435 \u0431\u044B\u043B \u0431\u044B \u0443 \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0435\u0439 \u0441 \u0443\u0434\u0430\u043B\u0435\u043D\u043D\u044B\u043C\u0438 \u0430\u043A\u043A\u0430\u0443\u043D\u0442\u0430\u043C\u0438?",
    "focused-task-close-account.delete-account.content-preview.line.survey.self": "\u0415\u0441\u043B\u0438 \u0431\u044B \u0432\u044B \u043C\u043E\u0433\u043B\u0438 \u0432\u044B\u0431\u0440\u0430\u0442\u044C \u0441\u0432\u043E\u0439 \u0441\u0442\u0430\u0442\u0443\u0441 \u0432 \u0441\u0438\u0441\u0442\u0435\u043C\u0435, \u043A\u0430\u043A\u0438\u043C \u0431\u044B \u043E\u043D \u0431\u044B\u043B?",
    "focused-task-close-account.delete-account.content-preview.paragraph.survey.admin": "\u0427\u0435\u043B\u043E\u0432\u0435\u043A, \u0447\u0435\u0439 \u0430\u043A\u043A\u0430\u0443\u043D\u0442 \u0432\u044B \u0443\u0434\u0430\u043B\u0438\u0442\u0435, \u043F\u043E\u043B\u0443\u0447\u0438\u0442 \u0432 \u0441\u0438\u0441\u0442\u0435\u043C\u0435 \u0441\u0442\u0430\u0442\u0443\u0441 \xab\u0411\u044B\u0432\u0448\u0438\u0439 \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044C\xbb. \u0412\u044B \u043E\u0447\u0435\u043D\u044C \u043F\u043E\u043C\u043E\u0436\u0435\u0442\u0435 \u043D\u0430\u043C, \u0435\u0441\u043B\u0438 \u043E\u0442\u0432\u0435\u0442\u0438\u0442\u0435 \u043D\u0430 \u043A\u043E\u0440\u043E\u0442\u043A\u0438\u0439 \u0432\u043E\u043F\u0440\u043E\u0441. \u042D\u0442\u043E \u0437\u0430\u0439\u043C\u0435\u0442 \u0432\u0441\u0435\u0433\u043E \u043F\u0430\u0440\u0443 \u043C\u0438\u043D\u0443\u0442.",
    "focused-task-close-account.delete-account.content-preview.paragraph.survey.self": "\u041F\u043E\u0441\u043B\u0435 \u0442\u043E\u0433\u043E \u043A\u0430\u043A \u043C\u044B \u0443\u0434\u0430\u043B\u0438\u043C \u0432\u0430\u0448 \u0430\u043A\u043A\u0430\u0443\u043D\u0442, \u0432\u044B \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u0435 \u0432 \u0441\u0438\u0441\u0442\u0435\u043C\u0435 \u0441\u0442\u0430\u0442\u0443\u0441 \xab\u0411\u044B\u0432\u0448\u0438\u0439 \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044C\xbb. \u0412\u044B \u043E\u0447\u0435\u043D\u044C \u043F\u043E\u043C\u043E\u0436\u0435\u0442\u0435 \u043D\u0430\u043C, \u0435\u0441\u043B\u0438 \u043E\u0442\u0432\u0435\u0442\u0438\u0442\u0435 \u043D\u0430 \u043A\u043E\u0440\u043E\u0442\u043A\u0438\u0439 \u0432\u043E\u043F\u0440\u043E\u0441. \u042D\u0442\u043E \u0437\u0430\u0439\u043C\u0435\u0442 \u0432\u0441\u0435\u0433\u043E \u043F\u0430\u0440\u0443 \u043C\u0438\u043D\u0443\u0442.",
    "focused-task-close-account.delete-account.drop-down-collapse-button": "\u0421\u0432\u0435\u0440\u043D\u0443\u0442\u044C",
    "focused-task-close-account.delete-account.drop-down-expand-button": "\u0415\u0449\u0435 {num}",
    "focused-task-close-account.delete-account.overview.first.line.admin": "\u0412\u044B \u0441\u043E\u0431\u0438\u0440\u0430\u0435\u0442\u0435\u0441\u044C \u0443\u0434\u0430\u043B\u0438\u0442\u044C \u0430\u043A\u043A\u0430\u043D\u0443\u0442:",
    "focused-task-close-account.delete-account.overview.first.line.self": "\u0412\u044B \u0441\u043E\u0431\u0438\u0440\u0430\u0435\u0442\u0435\u0441\u044C \u0443\u0434\u0430\u043B\u0438\u0442\u044C \u0430\u043A\u043A\u0430\u043D\u0443\u0442:",
    "focused-task-close-account.delete-account.overview.heading.admin": "\u0423\u0434\u0430\u043B\u0435\u043D\u0438\u0435 \u0430\u043A\u043A\u0430\u0443\u043D\u0442\u0430",
    "focused-task-close-account.delete-account.overview.heading.self": "\u0423\u0434\u0430\u043B\u0435\u043D\u0438\u0435 \u0430\u043A\u043A\u0430\u0443\u043D\u0442\u0430",
    "focused-task-close-account.delete-account.overview.inline-dialog.content-created.admin": "\u041D\u0430\u043F\u0440\u0438\u043C\u0435\u0440, \u0435\u0433\u043E \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u044B, \u0437\u0430\u0434\u0430\u0447\u0438 \u0438 \u043A\u043E\u043C\u043C\u0435\u043D\u0442\u0430\u0440\u0438\u0438 \u0432 \u043F\u0440\u043E\u0434\u0443\u043A\u0442\u0430\u0445.",
    "focused-task-close-account.delete-account.overview.inline-dialog.content-created.self": "\u041D\u0430\u043F\u0440\u0438\u043C\u0435\u0440, \u0432\u0430\u0448\u0438 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u044B, \u0437\u0430\u0434\u0430\u0447\u0438 \u0438 \u043A\u043E\u043C\u043C\u0435\u043D\u0442\u0430\u0440\u0438\u0438 \u0432 \u043F\u0440\u043E\u0434\u0443\u043A\u0442\u0430\u0445.",
    "focused-task-close-account.delete-account.overview.inline-dialog.data-apps.admin": "\u0412\u043E\u0437\u043C\u043E\u0436\u043D\u043E, \u0432\u044B \u0438\u043B\u0438 \u0434\u0440\u0443\u0433\u0438\u0435 \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0438 \u0443\u0441\u0442\u0430\u043D\u0430\u0432\u043B\u0438\u0432\u0430\u043B\u0438 \u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u044F, \u0440\u0430\u0441\u0448\u0438\u0440\u044F\u044E\u0449\u0438\u0435 \u0444\u0443\u043D\u043A\u0446\u0438\u0438 \u043F\u0440\u043E\u0434\u0443\u043A\u0442\u043E\u0432 Atlassian. \u0412 \u0442\u0430\u043A\u0438\u0445 \u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u044F\u0445 \u0442\u0430\u043A\u0436\u0435 \u043C\u043E\u0436\u0435\u0442 \u0445\u0440\u0430\u043D\u0438\u0442\u044C\u0441\u044F \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u044F \u0438\u0437 \u043F\u0440\u043E\u0444\u0438\u043B\u0435\u0439 \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0435\u0439.",
    "focused-task-close-account.delete-account.overview.inline-dialog.data-apps.self": "\u0412\u043E\u0437\u043C\u043E\u0436\u043D\u043E, \u0432\u044B \u0438\u043B\u0438 \u0434\u0440\u0443\u0433\u0438\u0435 \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0438 \u0443\u0441\u0442\u0430\u043D\u0430\u0432\u043B\u0438\u0432\u0430\u043B\u0438 \u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u044F, \u0440\u0430\u0441\u0448\u0438\u0440\u044F\u044E\u0449\u0438\u0435 \u0444\u0443\u043D\u043A\u0446\u0438\u0438 \u043F\u0440\u043E\u0434\u0443\u043A\u0442\u043E\u0432 Atlassian. \u0412 \u0442\u0430\u043A\u0438\u0445 \u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u044F\u0445 \u0442\u0430\u043A\u0436\u0435 \u043C\u043E\u0436\u0435\u0442 \u0445\u0440\u0430\u043D\u0438\u0442\u044C\u0441\u044F \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u044F \u0438\u0437 \u0432\u0430\u0448\u0435\u0433\u043E \u043F\u0440\u043E\u0444\u0438\u043B\u044F.",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.li1.admin": "\u0418\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u044F \u043E \u043F\u043E\u043A\u0443\u043F\u043A\u0430\u0445, \u043A\u043E\u0442\u043E\u0440\u0430\u044F \u043D\u0435\u043E\u0431\u0445\u043E\u0434\u0438\u043C\u0430 \u043D\u0430\u043C \u0434\u043B\u044F \u0444\u0438\u043D\u0430\u043D\u0441\u043E\u0432\u043E\u0439 \u043E\u0442\u0447\u0435\u0442\u043D\u043E\u0441\u0442\u0438.",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.li1.self": "\u0418\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u044F \u043E \u043F\u043E\u043A\u0443\u043F\u043A\u0430\u0445, \u043A\u043E\u0442\u043E\u0440\u0430\u044F \u043D\u0435\u043E\u0431\u0445\u043E\u0434\u0438\u043C\u0430 \u043D\u0430\u043C \u0434\u043B\u044F \u0444\u0438\u043D\u0430\u043D\u0441\u043E\u0432\u043E\u0439 \u043E\u0442\u0447\u0435\u0442\u043D\u043E\u0441\u0442\u0438.",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.li2.admin": "\u041C\u044B \u0443\u0434\u0430\u043B\u0438\u043B\u0438 \u0430\u043A\u043A\u0430\u0443\u043D\u0442 \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F, \u043E\u0434\u043D\u0430\u043A\u043E, \u0432\u043E\u0437\u043C\u043E\u0436\u043D\u043E, \u043D\u0430\u043C \u043F\u043E\u043D\u0430\u0434\u043E\u0431\u0438\u0442\u0441\u044F \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u0438\u0442\u044C \u0435\u0433\u043E \u0434\u0430\u043D\u043D\u044B\u0435 \u0433\u043E\u0441\u0443\u0434\u0430\u0440\u0441\u0442\u0432\u0435\u043D\u043D\u044B\u043C \u043E\u0440\u0433\u0430\u043D\u0430\u043C \u043F\u043E \u0441\u043E\u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0443\u044E\u0449\u0435\u043C\u0443 \u0437\u0430\u043F\u0440\u043E\u0441\u0443.",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.li2.self": "\u041C\u044B \u0443\u0434\u0430\u043B\u0438\u043B\u0438 \u0430\u043A\u043A\u0430\u0443\u043D\u0442 \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F, \u043E\u0434\u043D\u0430\u043A\u043E, \u0432\u043E\u0437\u043C\u043E\u0436\u043D\u043E, \u043D\u0430\u043C \u043F\u043E\u043D\u0430\u0434\u043E\u0431\u0438\u0442\u0441\u044F \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u0438\u0442\u044C \u0435\u0433\u043E \u0434\u0430\u043D\u043D\u044B\u0435 \u0433\u043E\u0441\u0443\u0434\u0430\u0440\u0441\u0442\u0432\u0435\u043D\u043D\u044B\u043C \u043E\u0440\u0433\u0430\u043D\u0430\u043C \u043F\u043E \u0441\u043E\u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0443\u044E\u0449\u0435\u043C\u0443 \u0437\u0430\u043F\u0440\u043E\u0441\u0443.",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.li3.admin": "\u0414\u0430\u043D\u043D\u044B\u0435, \u043A\u043E\u0442\u043E\u0440\u044B\u0435 \u0432\u043E\u0441\u0442\u0440\u0435\u0431\u043E\u0432\u0430\u043D\u044B \u0432 \u0440\u0430\u043C\u043A\u0430\u0445 \u0434\u0435\u0439\u0441\u0442\u0432\u0443\u044E\u0449\u0435\u0433\u043E \u0441\u0443\u0434\u0435\u0431\u043D\u043E\u0433\u043E \u043F\u0440\u043E\u0446\u0435\u0441\u0441\u0430, \u043C\u044B \u043D\u0435 \u0438\u043C\u0435\u0435\u043C \u043F\u0440\u0430\u0432\u0430 \u0443\u0434\u0430\u043B\u044F\u0442\u044C.",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.li3.self": "\u0414\u0430\u043D\u043D\u044B\u0435, \u043A\u043E\u0442\u043E\u0440\u044B\u0435 \u0432\u043E\u0441\u0442\u0440\u0435\u0431\u043E\u0432\u0430\u043D\u044B \u0432 \u0440\u0430\u043C\u043A\u0430\u0445 \u0434\u0435\u0439\u0441\u0442\u0432\u0443\u044E\u0449\u0435\u0433\u043E \u0441\u0443\u0434\u0435\u0431\u043D\u043E\u0433\u043E \u043F\u0440\u043E\u0446\u0435\u0441\u0441\u0430, \u043C\u044B \u043D\u0435 \u0438\u043C\u0435\u0435\u043C \u043F\u0440\u0430\u0432\u0430 \u0443\u0434\u0430\u043B\u044F\u0442\u044C.",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.p1.admin": "\u0412 \u0441\u0438\u043B\u0443 \u044E\u0440\u0438\u0434\u0438\u0447\u0435\u0441\u043A\u0438\u0445 \u043F\u0440\u0438\u0447\u0438\u043D \u043C\u044B \u0445\u0440\u0430\u043D\u0438\u043C \u043B\u0438\u0447\u043D\u044B\u0435 \u0434\u0430\u043D\u043D\u044B\u0435 \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0435\u0439 \u0432 \u0442\u0435\u0447\u0435\u043D\u0438\u0435 \u043E\u0433\u0440\u0430\u043D\u0438\u0447\u0435\u043D\u043D\u043E\u0433\u043E \u0432\u0440\u0435\u043C\u0435\u043D\u0438. \u0412\u043E\u0442 \u043D\u0435\u0441\u043A\u043E\u043B\u044C\u043A\u043E \u043F\u0440\u0438\u043C\u0435\u0440\u043E\u0432:",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.p1.self": "\u0412 \u0441\u0438\u043B\u0443 \u044E\u0440\u0438\u0434\u0438\u0447\u0435\u0441\u043A\u0438\u0445 \u043F\u0440\u0438\u0447\u0438\u043D \u043C\u044B \u0445\u0440\u0430\u043D\u0438\u043C \u043B\u0438\u0447\u043D\u044B\u0435 \u0434\u0430\u043D\u043D\u044B\u0435 \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0435\u0439 \u0432 \u0442\u0435\u0447\u0435\u043D\u0438\u0435 \u043E\u0433\u0440\u0430\u043D\u0438\u0447\u0435\u043D\u043D\u043E\u0433\u043E \u0432\u0440\u0435\u043C\u0435\u043D\u0438. \u0412\u043E\u0442 \u043D\u0435\u0441\u043A\u043E\u043B\u044C\u043A\u043E \u043F\u0440\u0438\u043C\u0435\u0440\u043E\u0432:",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.p2.admin": "\u041C\u044B \u043D\u0435 \u0443\u0434\u0430\u043B\u044F\u0435\u043C \u043B\u0438\u0447\u043D\u044B\u0435 \u0434\u0430\u043D\u043D\u044B\u0435 \u0438\u0437 \u043A\u043E\u043D\u0442\u0435\u043D\u0442\u0430, \u0441\u043E\u0437\u0434\u0430\u043D\u043D\u043E\u0433\u043E \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F\u043C\u0438 (\u043D\u0430\u043F\u0440\u0438\u043C\u0435\u0440, \u0438\u043C\u0435\u043D\u0430 \u0438 \u0430\u0434\u0440\u0435\u0441\u0430 \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u043E\u0439 \u043F\u043E\u0447\u0442\u044B, \u0443\u043A\u0430\u0437\u0430\u043D\u043D\u044B\u0435 \u043D\u0430 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0435 \u0438\u043B\u0438 \u0432 \u0437\u0430\u0434\u0430\u0447\u0435). \u042D\u0442\u0438 \u0434\u0430\u043D\u043D\u044B\u0435 \u0443\u0434\u0430\u043B\u044F\u044E\u0442 \u0430\u0434\u043C\u0438\u043D\u0438\u0441\u0442\u0440\u0430\u0442\u043E\u0440\u044B \u0432\u0440\u0443\u0447\u043D\u0443\u044E.",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.p2.self": "\u041C\u044B \u043D\u0435 \u0443\u0434\u0430\u043B\u044F\u0435\u043C \u043B\u0438\u0447\u043D\u044B\u0435 \u0434\u0430\u043D\u043D\u044B\u0435 \u0438\u0437 \u043A\u043E\u043D\u0442\u0435\u043D\u0442\u0430, \u0441\u043E\u0437\u0434\u0430\u043D\u043D\u043E\u0433\u043E \u0432\u0430\u043C\u0438 \u0438\u043B\u0438 \u0434\u0440\u0443\u0433\u0438\u043C\u0438 \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F\u043C\u0438 (\u043D\u0430\u043F\u0440\u0438\u043C\u0435\u0440, \u0438\u043C\u0435\u043D\u0430 \u0438 \u0430\u0434\u0440\u0435\u0441\u0430 \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u043E\u0439 \u043F\u043E\u0447\u0442\u044B, \u0443\u043A\u0430\u0437\u0430\u043D\u043D\u044B\u0435 \u043D\u0430 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0435 \u0438\u043B\u0438 \u0432 \u0437\u0430\u0434\u0430\u0447\u0435). \u042D\u0442\u0438 \u0434\u0430\u043D\u043D\u044B\u0435 \u0443\u0434\u0430\u043B\u044F\u044E\u0442 \u0430\u0434\u043C\u0438\u043D\u0438\u0441\u0442\u0440\u0430\u0442\u043E\u0440\u044B \u0432\u0440\u0443\u0447\u043D\u0443\u044E.",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.p3.admin": "\u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0438 \u0438\u043C\u0435\u044E\u0442 \u043F\u0440\u0430\u0432\u043E \u043F\u043E\u0434\u0430\u0442\u044C \u0436\u0430\u043B\u043E\u0431\u0443 \u0432 \u043A\u043E\u043D\u0442\u0440\u043E\u043B\u0438\u0440\u0443\u044E\u0449\u0438\u0435 \u043E\u0440\u0433\u0430\u043D\u044B \u043F\u043E \u043C\u0435\u0441\u0442\u0443 \u0436\u0438\u0442\u0435\u043B\u044C\u0441\u0442\u0432\u0430.",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.p3.self": "\u0412\u044B \u0438\u043C\u0435\u0435\u0442\u0435 \u043F\u0440\u0430\u0432\u043E \u043F\u043E\u0434\u0430\u0442\u044C \u0436\u0430\u043B\u043E\u0431\u0443 \u0432 \u043A\u043E\u043D\u0442\u0440\u043E\u043B\u0438\u0440\u0443\u044E\u0449\u0438\u0435 \u043E\u0440\u0433\u0430\u043D\u044B \u043F\u043E \u043C\u0435\u0441\u0442\u0443 \u0432\u0430\u0448\u0435\u0433\u043E \u0436\u0438\u0442\u0435\u043B\u044C\u0441\u0442\u0432\u0430.",
    "focused-task-close-account.delete-account.overview.paragraph.about-to-delete.admin": "\u041F\u043E\u0441\u043B\u0435 \u0443\u0434\u0430\u043B\u0435\u043D\u0438\u044F \u0430\u043A\u043A\u0430\u0443\u043D\u0442\u0430:",
    "focused-task-close-account.delete-account.overview.paragraph.about-to-delete.self": "\u041F\u043E\u0441\u043B\u0435 \u0443\u0434\u0430\u043B\u0435\u043D\u0438\u044F \u0430\u043A\u043A\u0430\u0443\u043D\u0442\u0430:",
    "focused-task-close-account.delete-account.overview.paragraph.content-created.admin": "\u041A\u043E\u043D\u0442\u0435\u043D\u0442, \u0441\u043E\u0437\u0434\u0430\u043D\u043D\u044B\u0439 \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0435\u043C, \u0441\u043E\u0445\u0440\u0430\u043D\u0438\u0442\u0441\u044F \u0432 \u0441\u0435\u0440\u0432\u0438\u0441\u0430\u0445, \u0441\u0432\u044F\u0437\u0430\u043D\u043D\u044B\u0445 \u0441 \u0430\u043A\u043A\u0430\u0443\u043D\u0442\u043E\u043C Atlassian.",
    "focused-task-close-account.delete-account.overview.paragraph.content-created.self": "\u0421\u043E\u0437\u0434\u0430\u043D\u043D\u044B\u0439 \u0432\u0430\u043C\u0438 \u043A\u043E\u043D\u0442\u0435\u043D\u0442 \u0441\u043E\u0445\u0440\u0430\u043D\u0438\u0442\u0441\u044F \u0432 \u0441\u0435\u0440\u0432\u0438\u0441\u0430\u0445, \u0441\u0432\u044F\u0437\u0430\u043D\u043D\u044B\u0445 \u0441 \u0430\u043A\u043A\u0430\u0443\u043D\u0442\u043E\u043C Atlassian.",
    "focused-task-close-account.delete-account.overview.paragraph.grace-period.admin": "\u041E\u0442\u043C\u0435\u043D\u0438\u0442\u044C \u0443\u0434\u0430\u043B\u0435\u043D\u0438\u0435 \u0430\u043A\u043A\u0430\u0443\u043D\u0442\u0430 \u043C\u043E\u0436\u043D\u043E \u0442\u043E\u043B\u044C\u043A\u043E \u0432 \u0442\u0435\u0447\u0435\u043D\u0438\u0435 \u043F\u0435\u0440\u0432\u044B\u0445 14\xa0\u0434\u043D\u0435\u0439.",
    "focused-task-close-account.delete-account.overview.paragraph.list-of-apps-with-personal-data.admin": "\u041C\u044B \u0432\u044B\u0448\u043B\u0435\u043C \u0432\u0430\u043C \u043F\u043E \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u043E\u0439 \u043F\u043E\u0447\u0442\u0435 \u0441\u043F\u0438\u0441\u043E\u043A \u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u0439, \u043A\u043E\u0442\u043E\u0440\u044B\u0435 \u043C\u043E\u0433\u043B\u0438 \u0441\u043E\u0445\u0440\u0430\u043D\u044F\u0442\u044C \u043B\u0438\u0447\u043D\u044B\u0435 \u0434\u0430\u043D\u043D\u044B\u0435 \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0435\u0439.",
    "focused-task-close-account.delete-account.overview.paragraph.list-of-apps-with-personal-data.self": "\u041C\u044B \u0432\u044B\u0448\u043B\u0435\u043C \u0432\u0430\u043C \u043F\u043E \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u043E\u0439 \u043F\u043E\u0447\u0442\u0435 \u0441\u043F\u0438\u0441\u043E\u043A \u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u0439, \u043A\u043E\u0442\u043E\u0440\u044B\u0435 \u043C\u043E\u0433\u043B\u0438 \u0441\u043E\u0445\u0440\u0430\u043D\u044F\u0442\u044C \u0432\u0430\u0448\u0438 \u043B\u0438\u0447\u043D\u044B\u0435 \u0434\u0430\u043D\u043D\u044B\u0435.",
    "focused-task-close-account.delete-account.overview.paragraph.loseAccess.admin": "{fullName} <b>\u043D\u0435\u043C\u0435\u0434\u043B\u0435\u043D\u043D\u043E \u043F\u043E\u0442\u0435\u0440\u044F\u0435\u0442 \u0434\u043E\u0441\u0442\u0443\u043F</b> \u043A\u043E \u0432\u0441\u0435\u043C \u0441\u0435\u0440\u0432\u0438\u0441\u0430\u043C, \u0441\u0432\u044F\u0437\u0430\u043D\u043D\u044B\u043C \u0441 \u0430\u043A\u043A\u0430\u0443\u043D\u0442\u043E\u043C Atlassian. \u0421\u0435\u0439\u0447\u0430\u0441 \u044D\u0442\u043E\u0442 \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044C \u0440\u0430\u0431\u043E\u0442\u0430\u0435\u0442 \u0441\u043E \u0441\u043B\u0435\u0434\u0443\u044E\u0449\u0438\u043C\u0438 \u0441\u0435\u0440\u0432\u0438\u0441\u0430\u043C\u0438:",
    "focused-task-close-account.delete-account.overview.paragraph.loseAccess.admin.noSites": "{fullName} <b>\u043D\u0435\u043C\u0435\u0434\u043B\u0435\u043D\u043D\u043E \u043F\u043E\u0442\u0435\u0440\u044F\u0435\u0442 \u0434\u043E\u0441\u0442\u0443\u043F</b> \u043A\u043E \u0432\u0441\u0435\u043C \u0441\u0435\u0440\u0432\u0438\u0441\u0430\u043C, \u0441\u0432\u044F\u0437\u0430\u043D\u043D\u044B\u043C \u0441 \u0430\u043A\u043A\u0430\u0443\u043D\u0442\u043E\u043C Atlassian. \u0421\u0435\u0439\u0447\u0430\u0441 \u0443 \u044D\u0442\u043E\u0433\u043E \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F \u0435\u0441\u0442\u044C \u0434\u043E\u0441\u0442\u0443\u043F \u0442\u043E\u043B\u044C\u043A\u043E \u043A \u0421\u043E\u043E\u0431\u0449\u0435\u0441\u0442\u0432\u0443 Atlassian \u0438 Marketplace.",
    "focused-task-close-account.delete-account.overview.paragraph.loseAccess.footnote": "\u0414\u0440\u0443\u0433\u0438\u0435 \u0441\u0435\u0440\u0432\u0438\u0441\u044B, \u0441\u0432\u044F\u0437\u0430\u043D\u043D\u044B\u0435 \u0441 \u0430\u043A\u043A\u0430\u0443\u043D\u0442\u043E\u043C Atlassian, \u043D\u0430\u043F\u0440\u0438\u043C\u0435\u0440 \u0421\u043E\u043E\u0431\u0449\u0435\u0441\u0442\u0432\u043E Atlassian \u0438 Marketplace.",
    "focused-task-close-account.delete-account.overview.paragraph.loseAccess.self": "\u0412\u044B <b>\u043D\u0435\u043C\u0435\u0434\u043B\u0435\u043D\u043D\u043E \u043F\u043E\u0442\u0435\u0440\u044F\u0435\u0442\u0435 \u0434\u043E\u0441\u0442\u0443\u043F</b> \u043A\u043E \u0432\u0441\u0435\u043C \u0441\u0435\u0440\u0432\u0438\u0441\u0430\u043C, \u0441\u0432\u044F\u0437\u0430\u043D\u043D\u044B\u043C \u0441 \u0430\u043A\u043A\u0430\u0443\u043D\u0442\u043E\u043C Atlassian. \u0421\u0435\u0439\u0447\u0430\u0441 \u0432\u044B \u0440\u0430\u0431\u043E\u0442\u0430\u0435\u0442\u0435 \u0441\u043E \u0441\u043B\u0435\u0434\u0443\u044E\u0449\u0438\u043C\u0438 \u0441\u0435\u0440\u0432\u0438\u0441\u0430\u043C\u0438:",
    "focused-task-close-account.delete-account.overview.paragraph.loseAccess.self.noSites": "\u0412\u044B <b>\u043D\u0435\u043C\u0435\u0434\u043B\u0435\u043D\u043D\u043E \u043F\u043E\u0442\u0435\u0440\u044F\u0435\u0442\u0435 \u0434\u043E\u0441\u0442\u0443\u043F</b> \u043A\u043E \u0432\u0441\u0435\u043C \u0441\u0435\u0440\u0432\u0438\u0441\u0430\u043C, \u0441\u0432\u044F\u0437\u0430\u043D\u043D\u044B\u043C \u0441 \u0430\u043A\u043A\u0430\u0443\u043D\u0442\u043E\u043C Atlassian. \u0421\u0435\u0439\u0447\u0430\u0441 \u0443 \u0432\u0430\u0441 \u0435\u0441\u0442\u044C \u0434\u043E\u0441\u0442\u0443\u043F \u0442\u043E\u043B\u044C\u043A\u043E \u043A \u0421\u043E\u043E\u0431\u0449\u0435\u0441\u0442\u0432\u0443 Atlassian \u0438 Marketplace.",
    "focused-task-close-account.delete-account.overview.paragraph.personal-data-will-be-deleted.admin": "\u041C\u044B \u0443\u0434\u0430\u043B\u0438\u043C <b>\u043B\u0438\u0447\u043D\u044B\u0435 \u0434\u0430\u043D\u043D\u044B\u0435 \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F</b> (\u043D\u0430\u043F\u0440\u0438\u043C\u0435\u0440, \u0435\u0433\u043E \u043F\u043E\u043B\u043D\u043E\u0435 \u0438\u043C\u044F \u0438 \u0430\u0434\u0440\u0435\u0441 \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u043E\u0439 \u043F\u043E\u0447\u0442\u044B) \u0438\u0437 \u0441\u0435\u0440\u0432\u0438\u0441\u043E\u0432, \u0441\u0432\u044F\u0437\u0430\u043D\u043D\u044B\u0445 \u0441 \u0430\u043A\u043A\u0430\u0443\u043D\u0442\u043E\u043C Atlassian, \u0432 \u0442\u0435\u0447\u0435\u043D\u0438\u0435 30\xa0\u0434\u043D\u0435\u0439. \u0418\u0441\u043A\u043B\u044E\u0447\u0435\u043D\u0438\u0435 \u0441\u043E\u0441\u0442\u0430\u0432\u043B\u044F\u044E\u0442 \u0441\u043B\u0443\u0447\u0430\u0438, \u043A\u043E\u0433\u0434\u0430 \u044D\u0442\u043E \u043D\u0435\u0432\u043E\u0437\u043C\u043E\u0436\u043D\u043E \u0441\u0434\u0435\u043B\u0430\u0442\u044C \u043F\u043E \u044E\u0440\u0438\u0434\u0438\u0447\u0435\u0441\u043A\u0438\u043C \u043F\u0440\u0438\u0447\u0438\u043D\u0430\u043C.",
    "focused-task-close-account.delete-account.overview.paragraph.personal-data-will-be-deleted.self": "\u041C\u044B \u0443\u0434\u0430\u043B\u0438\u043C <b>\u0432\u0430\u0448\u0438 \u043B\u0438\u0447\u043D\u044B\u0435 \u0434\u0430\u043D\u043D\u044B\u0435</b> (\u043D\u0430\u043F\u0440\u0438\u043C\u0435\u0440, \u043F\u043E\u043B\u043D\u043E\u0435 \u0438\u043C\u044F \u0438 \u0430\u0434\u0440\u0435\u0441 \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u043E\u0439 \u043F\u043E\u0447\u0442\u044B) \u0438\u0437 \u0441\u0435\u0440\u0432\u0438\u0441\u043E\u0432, \u0441\u0432\u044F\u0437\u0430\u043D\u043D\u044B\u0445 \u0441 \u0430\u043A\u043A\u0430\u0443\u043D\u0442\u043E\u043C Atlassian, \u0432 \u0442\u0435\u0447\u0435\u043D\u0438\u0435 30\xa0\u0434\u043D\u0435\u0439. \u0418\u0441\u043A\u043B\u044E\u0447\u0435\u043D\u0438\u0435 \u0441\u043E\u0441\u0442\u0430\u0432\u043B\u044F\u044E\u0442 \u0441\u043B\u0443\u0447\u0430\u0438, \u043A\u043E\u0433\u0434\u0430 \u044D\u0442\u043E \u043D\u0435\u0432\u043E\u0437\u043C\u043E\u0436\u043D\u043E \u0441\u0434\u0435\u043B\u0430\u0442\u044C \u043F\u043E \u044E\u0440\u0438\u0434\u0438\u0447\u0435\u0441\u043A\u0438\u043C \u043F\u0440\u0438\u0447\u0438\u043D\u0430\u043C.",
    "focused-task-close-account.delete-account.overview.warning-section.body": "\u041E\u0442\u043C\u0435\u043D\u0438\u0442\u044C \u0443\u0434\u0430\u043B\u0435\u043D\u0438\u0435 \u0430\u043A\u043A\u0430\u0443\u043D\u0442\u0430 \u043C\u043E\u0436\u043D\u043E \u0442\u043E\u043B\u044C\u043A\u043E \u0432 \u0442\u0435\u0447\u0435\u043D\u0438\u0435 \u043F\u0435\u0440\u0432\u044B\u0445 14\xa0\u0434\u043D\u0435\u0439. \u0415\u0441\u043B\u0438 \u0432\u044B \u0441\u0447\u0438\u0442\u0430\u0435\u0442\u0435, \u0447\u0442\u043E \u0430\u043A\u043A\u0430\u0443\u043D\u0442 \u043F\u043E\u043D\u0430\u0434\u043E\u0431\u0438\u0442\u0441\u044F \u0432\u0430\u043C \u0432 \u0434\u0430\u043B\u044C\u043D\u0435\u0439\u0448\u0435\u043C, \u043F\u0440\u043E\u0441\u0442\u043E \u0434\u0435\u0430\u043A\u0442\u0438\u0432\u0438\u0440\u0443\u0439\u0442\u0435 \u0435\u0433\u043E.",
    "focused-task-close-account.delete-account.overview.warning-section.deactivated.body": "\u041E\u0442\u043C\u0435\u043D\u0438\u0442\u044C \u0443\u0434\u0430\u043B\u0435\u043D\u0438\u0435 \u0430\u043A\u043A\u0430\u0443\u043D\u0442\u0430 \u043C\u043E\u0436\u043D\u043E \u0442\u043E\u043B\u044C\u043A\u043E \u0432 \u0442\u0435\u0447\u0435\u043D\u0438\u0435 \u043F\u0435\u0440\u0432\u044B\u0445 14\xa0\u0434\u043D\u0435\u0439.",
    "focused-task-close-account.learnMore": "\u041F\u043E\u0434\u0440\u043E\u0431\u043D\u0435\u0435",
    "focused-task-close-account.next": "\u0414\u0430\u043B\u0435\u0435",
    "focused-task-close-account.previous": "\u041D\u0430\u0437\u0430\u0434"
};

});

parcelRegister("bshoi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $856fccac86ce37d5$export$2e2bcd8739ae039; });
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Slovak
var $856fccac86ce37d5$export$2e2bcd8739ae039 = {
    "focused-task-close-account.cancel": "Zru\u0161i\u0165",
    "focused-task-close-account.deactivate-account": "Deaktivova\u0165 konto",
    "focused-task-close-account.deactivate-account.overview.first.line.admin": "Chyst\xe1te sa deaktivova\u0165 pou\u017E\xedvate\u013Esk\xe9 konto:",
    "focused-task-close-account.deactivate-account.overview.first.line.self": "Chyst\xe1te sa deaktivova\u0165 pou\u017E\xedvate\u013Esk\xe9 konto:",
    "focused-task-close-account.deactivate-account.overview.heading.admin": "Deaktiv\xe1cia konta",
    "focused-task-close-account.deactivate-account.overview.heading.self": "Deaktiv\xe1cia konta",
    "focused-task-close-account.deactivate-account.overview.last.line.admin": "Konto m\xf4\u017Eete kedyko\u013Evek znovu aktivova\u0165.",
    "focused-task-close-account.deactivate-account.overview.last.line.self": "Konto m\xf4\u017Eete kedyko\u013Evek znovu aktivova\u0165.",
    "focused-task-close-account.deactivate-account.overview.paragraph.about-to-deactivate.admin": "Po deaktiv\xe1cii konta:",
    "focused-task-close-account.deactivate-account.overview.paragraph.about-to-deactivate.self": "Po deaktiv\xe1cii konta:",
    "focused-task-close-account.deactivate-account.overview.paragraph.billing.admin": "T\xfato polo\u017Eku v\xe1m u\u017E nebudeme \xfa\u010Dtova\u0165.",
    "focused-task-close-account.deactivate-account.overview.paragraph.billing.self": "T\xfato polo\u017Eku v\xe1m u\u017E nebudeme \xfa\u010Dtova\u0165.",
    "focused-task-close-account.deactivate-account.overview.paragraph.loseAccess.admin": "Pou\u017E\xedvate\u013E {fullName} <b>okam\u017Eite strat\xed pr\xedstup</b> k v\u0161etk\xfdm slu\u017Eb\xe1m konta Atlassian. Moment\xe1lne m\xe1 pr\xedstup k:",
    "focused-task-close-account.deactivate-account.overview.paragraph.loseAccess.admin.noSites": "Pou\u017E\xedvate\u013E {fullName} <b>okam\u017Eite strat\xed pr\xedstup</b> k v\u0161etk\xfdm slu\u017Eb\xe1m konta Atlassian. Moment\xe1lne nem\xe1 pr\xedstup k \u017Eiadnym slu\u017Eb\xe1m, okrem slu\u017Eieb typu Komunita a Obchod.",
    "focused-task-close-account.deactivate-account.overview.paragraph.loseAccess.footnote": "\u010Eal\u0161ie slu\u017Eby konta Atlassian, ako napr\xedklad Komunita Atlassian a Obchod.",
    "focused-task-close-account.deactivate-account.overview.paragraph.loseAccess.self": "<b>Okam\u017Eite strat\xedte pr\xedstup</b> k v\u0161etk\xfdm slu\u017Eb\xe1m konta Atlassian. Moment\xe1lne m\xe1te pr\xedstup k:",
    "focused-task-close-account.deactivate-account.overview.paragraph.loseAccess.self.noSites": "<b>Okam\u017Eite strat\xedte pr\xedstup</b> k v\u0161etk\xfdm slu\u017Eb\xe1m konta Atlassian. Moment\xe1lne nem\xe1te pr\xedstup k \u017Eiadnym slu\u017Eb\xe1m, okrem slu\u017Eieb typu Komunita a Obchod.",
    "focused-task-close-account.deactivate-account.overview.paragraph.personal-data.admin": "Osobn\xe9 \xfadaje, ako napr\xedklad cel\xe9 meno a e-mailov\xe1 adresa, a obsah, ktor\xfd vytvorili, ostane v slu\u017Eb\xe1ch konta Atlassian.",
    "focused-task-close-account.deactivate-account.overview.paragraph.personal-data.self": "Osobn\xe9 \xfadaje, ako napr\xedklad cel\xe9 meno a e-mailov\xe1 adresa, a obsah, ktor\xfd vytvorili, ostane v slu\u017Eb\xe1ch konta Atlassian.",
    "focused-task-close-account.delete-account": "Odstr\xe1ni\u0165 konto",
    "focused-task-close-account.delete-account.content-preview.footnote.admin": "Pozn\xe1mka: Vyplnen\xedm tohto prieskumu n\xe1m pom\xf4\u017Eete vytvori\u0165 lep\u0161iu sk\xfasenos\u0165 pre v\u0161etk\xfdch pou\u017E\xedvate\u013Eov. Po odstr\xe1nen\xed konta sa pou\u017E\xedvate\u013E bude st\xe1le zobrazova\u0165 ako \u201Eb\xfdval\xfd pou\u017E\xedvate\u013E\u201C.",
    "focused-task-close-account.delete-account.content-preview.footnote.self": "Pozn\xe1mka: Vyplnen\xedm tohto prieskumu n\xe1m pom\xf4\u017Eete vytvori\u0165 lep\u0161iu sk\xfasenos\u0165 pre v\u0161etk\xfdch pou\u017E\xedvate\u013Eov vr\xe1tane t\xfdch, ktor\xed odstr\xe1nili svoje kont\xe1. Po odstr\xe1nen\xed konta sa st\xe1le budete zobrazova\u0165 ako \u201Eb\xfdval\xfd pou\u017E\xedvate\u013E\u201C.",
    "focused-task-close-account.delete-account.content-preview.formerUser": "B\xfdval\xfd pou\u017E\xedvate\u013E",
    "focused-task-close-account.delete-account.content-preview.heading.admin": "Ako chcete zobrazova\u0165 odstr\xe1nen\xe9ho pou\u017E\xedvate\u013Ea?",
    "focused-task-close-account.delete-account.content-preview.heading.self": "Ako chcete zobrazova\u0165 odstr\xe1nen\xe9 konto?",
    "focused-task-close-account.delete-account.content-preview.line.survey.admin": "Keby ste mali na v\xfdber, ako by sa mal odstr\xe1nen\xfd pou\u017E\xedvate\u013E zobrazova\u0165 ostatn\xfdm pou\u017E\xedvate\u013Eom?",
    "focused-task-close-account.delete-account.content-preview.line.survey.self": "Keby ste mali na v\xfdber, ako by ste sa chceli zobrazova\u0165 ostatn\xfdm pou\u017E\xedvate\u013Eom?",
    "focused-task-close-account.delete-account.content-preview.paragraph.survey.admin": "Po odstr\xe1nen\xed konta pou\u017E\xedvate\u013Ea sa pou\u017E\xedvate\u013E bude ostatn\xfdm pou\u017E\xedvate\u013Eom zobrazova\u0165 ako \u201Eb\xfdval\xfd pou\u017E\xedvate\u013E\u201C. N\xe1jdite si chv\xed\u013Eu \u010Das a odpovedzte na ot\xe1zku z n\xe1\u0161ho prieskumu.",
    "focused-task-close-account.delete-account.content-preview.paragraph.survey.self": "Po odstr\xe1nen\xed v\xe1\u0161ho konta sa ostatn\xfdm pou\u017E\xedvate\u013Eom budete zobrazova\u0165 ako \u201Eb\xfdval\xfd pou\u017E\xedvate\u013E\u201C. N\xe1jdite si chv\xed\u013Eu \u010Das a odpovedzte na ot\xe1zku z n\xe1\u0161ho prieskumu.",
    "focused-task-close-account.delete-account.drop-down-collapse-button": "Zobrazi\u0165 menej",
    "focused-task-close-account.delete-account.drop-down-expand-button": "\u010Eal\u0161ie: {num}",
    "focused-task-close-account.delete-account.overview.first.line.admin": "Chyst\xe1te sa odstr\xe1ni\u0165 konto:",
    "focused-task-close-account.delete-account.overview.first.line.self": "Chyst\xe1te sa odstr\xe1ni\u0165 svoje konto:",
    "focused-task-close-account.delete-account.overview.heading.admin": "Odstr\xe1nenie konta",
    "focused-task-close-account.delete-account.overview.heading.self": "Odstr\xe1nenie konta",
    "focused-task-close-account.delete-account.overview.inline-dialog.content-created.admin": "Napr\xedklad str\xe1nky, probl\xe9my a koment\xe1re, ktor\xe9 vytvorili v produktoch.",
    "focused-task-close-account.delete-account.overview.inline-dialog.content-created.self": "Napr\xedklad str\xe1nky, probl\xe9my a koment\xe1re, ktor\xe9 ste vytvorili v produktoch.",
    "focused-task-close-account.delete-account.overview.inline-dialog.data-apps.admin": "Vy alebo in\xed pou\u017E\xedvatelia m\xf4\u017Eete ma\u0165 nain\u0161talovan\xe9 aplik\xe1cie, ktor\xe9 prid\xe1vaj\xfa funkcie do produktov spolo\u010Dnosti Atlassian. Tieto aplik\xe1cie m\xf4\u017Eu uklada\u0165 inform\xe1cie o profile pou\u017E\xedvate\u013Ea.",
    "focused-task-close-account.delete-account.overview.inline-dialog.data-apps.self": "Vy alebo in\xed pou\u017E\xedvatelia m\xf4\u017Eete ma\u0165 nain\u0161talovan\xe9 aplik\xe1cie, ktor\xe9 prid\xe1vaj\xfa funkcie do produktov spolo\u010Dnosti Atlassian. Tieto aplik\xe1cie m\xf4\u017Eu uklada\u0165 inform\xe1cie o va\u0161om profile.",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.li1.admin": "Inform\xe1cie t\xfdkaj\xface sa n\xe1kupov, ktor\xe9 mus\xedme uchov\xe1va\u0165 pre finan\u010Dn\xe9 v\xfdkazn\xedctvo.",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.li1.self": "Inform\xe1cie t\xfdkaj\xface sa n\xe1kupov, ktor\xe9 mus\xedme uchov\xe1va\u0165 pre finan\u010Dn\xe9 v\xfdkazn\xedctvo.",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.li2.admin": "Z\xe1znamy, ktor\xe9 obsahuj\xfa inform\xe1cie o odstr\xe1nen\xed konta ur\u010Ditej osoby, ktor\xe9 mo\u017Eno budeme musie\u0165 poskytn\xfa\u0165 regula\u010Dn\xfdm org\xe1nom.",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.li2.self": "Z\xe1znamy, ktor\xe9 obsahuj\xfa inform\xe1cie o odstr\xe1nen\xed konta ur\u010Ditej osoby, ktor\xe9 mo\u017Eno budeme musie\u0165 poskytn\xfa\u0165 regula\u010Dn\xfdm org\xe1nom.",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.li3.admin": "\xdadaje, ktor\xe9 s\xfa s\xfa\u010Das\u0165ou prebiehaj\xfaceho s\xfadneho sporu, ktor\xe9 mus\xedme pod\u013Ea z\xe1kona uchov\xe1va\u0165.",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.li3.self": "\xdadaje, ktor\xe9 s\xfa s\xfa\u010Das\u0165ou prebiehaj\xfaceho s\xfadneho sporu, ktor\xe9 mus\xedme pod\u013Ea z\xe1kona uchov\xe1va\u0165.",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.p1.admin": "Osobn\xe9 \xfadaje uchov\xe1vame na obmedzen\xe9 obdobia, ak m\xe1me legit\xedmne obchodn\xe9 alebo pr\xe1vne z\xe1ujmy. Niektor\xe9 pr\xedklady zah\u0155\u0148aj\xfa:",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.p1.self": "Osobn\xe9 \xfadaje uchov\xe1vame na obmedzen\xe9 obdobia, ak m\xe1me legit\xedmne obchodn\xe9 alebo pr\xe1vne z\xe1ujmy. Niektor\xe9 pr\xedklady zah\u0155\u0148aj\xfa:",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.p2.admin": "Neodstr\xe1nime \u017Eiadne osobn\xe9 \xfadaje z obsahu vytvoren\xe9ho pou\u017E\xedvate\u013Emi, ako napr\xedklad men\xe1 alebo e-mailov\xe9 adresy, ktor\xe9 zadali na str\xe1nke alebo v probl\xe9me. Spr\xe1vcovia produktov musia tieto \xfadaje odstr\xe1ni\u0165 manu\xe1lne.",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.p2.self": "Neodstr\xe1nime \u017Eiadne osobn\xe9 \xfadaje z obsahu vytvoren\xe9ho vami alebo in\xfdmi osobami, ako napr\xedklad men\xe1 alebo e-mailov\xe9 adresy, ktor\xe9 sa zadali na str\xe1nke alebo v probl\xe9me. Spr\xe1vcovia produktov musia tieto \xfadaje odstr\xe1ni\u0165 manu\xe1lne.",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.p3.admin": "Pou\u017E\xedvatelia maj\xfa pr\xe1vo pod\xe1va\u0165 s\u0165a\u017Enosti dozorn\xe9mu org\xe1nu vo svojej krajine.",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.p3.self": "M\xe1te pr\xe1vo pod\xe1va\u0165 s\u0165a\u017Enosti dozorn\xe9mu org\xe1nu vo svojej krajine.",
    "focused-task-close-account.delete-account.overview.paragraph.about-to-delete.admin": "Po odstr\xe1nen\xed konta:",
    "focused-task-close-account.delete-account.overview.paragraph.about-to-delete.self": "Po odstr\xe1nen\xed konta:",
    "focused-task-close-account.delete-account.overview.paragraph.content-created.admin": "Obsah, ktor\xfd vytvorili, ostane v slu\u017Eb\xe1ch konta Atlassian.",
    "focused-task-close-account.delete-account.overview.paragraph.content-created.self": "Obsah, ktor\xfd ste vytvorili, ostane v slu\u017Eb\xe1ch konta Atlassian.",
    "focused-task-close-account.delete-account.overview.paragraph.grace-period.admin": "Po uplynut\xed 14-d\u0148ov\xe9ho prechodn\xe9ho obdobia nebudete m\xf4c\u0165 zru\u0161i\u0165 odstr\xe1nenie konta.",
    "focused-task-close-account.delete-account.overview.paragraph.list-of-apps-with-personal-data.admin": "Po\u0161leme v\xe1m e-mail so zoznamom aplik\xe1ci\xed, ktor\xe9 m\xf4\u017Eu uklada\u0165 ich osobn\xe9 \xfadaje.",
    "focused-task-close-account.delete-account.overview.paragraph.list-of-apps-with-personal-data.self": "Po\u0161leme v\xe1m e-mail so zoznamom aplik\xe1ci\xed, ktor\xe9 m\xf4\u017Eu uklada\u0165 va\u0161e osobn\xe9 \xfadaje.",
    "focused-task-close-account.delete-account.overview.paragraph.loseAccess.admin": "Pou\u017E\xedvate\u013E {fullName} <b>okam\u017Eite strat\xed pr\xedstup</b> k v\u0161etk\xfdm slu\u017Eb\xe1m konta Atlassian. Moment\xe1lne m\xe1 pr\xedstup k:",
    "focused-task-close-account.delete-account.overview.paragraph.loseAccess.admin.noSites": "Pou\u017E\xedvate\u013E {fullName} <b>okam\u017Eite strat\xed pr\xedstup</b> k v\u0161etk\xfdm slu\u017Eb\xe1m konta Atlassian. Moment\xe1lne nem\xe1 pr\xedstup k \u017Eiadnym slu\u017Eb\xe1m, okrem slu\u017Eieb typu Komunita a Obchod.",
    "focused-task-close-account.delete-account.overview.paragraph.loseAccess.footnote": "\u010Eal\u0161ie slu\u017Eby konta Atlassian, ako napr\xedklad Komunita Atlassian a Obchod.",
    "focused-task-close-account.delete-account.overview.paragraph.loseAccess.self": "<b>Okam\u017Eite strat\xedte pr\xedstup</b> k v\u0161etk\xfdm slu\u017Eb\xe1m konta Atlassian. Moment\xe1lne m\xe1te pr\xedstup k:",
    "focused-task-close-account.delete-account.overview.paragraph.loseAccess.self.noSites": "<b>Okam\u017Eite strat\xedte pr\xedstup</b> k v\u0161etk\xfdm slu\u017Eb\xe1m konta Atlassian. Moment\xe1lne nem\xe1te pr\xedstup k \u017Eiadnym slu\u017Eb\xe1m, okrem slu\u017Eieb typu Komunita a Obchod.",
    "focused-task-close-account.delete-account.overview.paragraph.personal-data-will-be-deleted.admin": "<b>Odstr\xe1nime ich osobn\xe9 \xfadaje</b>, ako napr\xedklad cel\xe9 meno a e-mailov\xfa adresu zo slu\u017Eieb konta Atlassian do 30 dn\xed, s v\xfdnimkou nieko\u013Ek\xfdch pr\xedpadov, ke\u010F s\xfa potrebn\xe9 na legit\xedmne obchodn\xe9 alebo pr\xe1vne \xfa\u010Dely.",
    "focused-task-close-account.delete-account.overview.paragraph.personal-data-will-be-deleted.self": "<b>Odstr\xe1nime va\u0161e osobn\xe9 \xfadaje</b>, ako napr\xedklad cel\xe9 meno a e-mailov\xfa adresu zo slu\u017Eieb konta Atlassian do 30 dn\xed, s v\xfdnimkou nieko\u013Ek\xfdch pr\xedpadov, ke\u010F s\xfa potrebn\xe9 na legit\xedmne obchodn\xe9 alebo pr\xe1vne \xfa\u010Dely.",
    "focused-task-close-account.delete-account.overview.warning-section.body": "Po uplynut\xed 14-d\u0148ov\xe9ho prechodn\xe9ho obdobia nebudete m\xf4c\u0165 zru\u0161i\u0165 odstr\xe1nenie konta. Ak si mysl\xedte, \u017Ee konto budete nesk\xf4r potrebova\u0165, namiesto toho ho deaktivujte.",
    "focused-task-close-account.delete-account.overview.warning-section.deactivated.body": "Po uplynut\xed 14-d\u0148ov\xe9ho prechodn\xe9ho obdobia nebudete m\xf4c\u0165 zru\u0161i\u0165 odstr\xe1nenie konta.",
    "focused-task-close-account.learnMore": "\u010Eal\u0161ie inform\xe1cie",
    "focused-task-close-account.next": "\u010Ealej",
    "focused-task-close-account.previous": "Sp\xe4\u0165"
};

});

parcelRegister("8WpiL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $68275de1e4b24049$export$2e2bcd8739ae039; });
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Spanish (International)
var $68275de1e4b24049$export$2e2bcd8739ae039 = {
    "focused-task-close-account.cancel": "Cancelar",
    "focused-task-close-account.deactivate-account": "Desactivar la cuenta",
    "focused-task-close-account.deactivate-account.overview.first.line.admin": "Est\xe1s a punto de desactivar la cuenta de:",
    "focused-task-close-account.deactivate-account.overview.first.line.self": "Est\xe1s a punto de desactivar la cuenta de:",
    "focused-task-close-account.deactivate-account.overview.heading.admin": "Desactivar la cuenta",
    "focused-task-close-account.deactivate-account.overview.heading.self": "Desactivar la cuenta",
    "focused-task-close-account.deactivate-account.overview.last.line.admin": "Puedes volver a activar la cuenta en cualquier momento.",
    "focused-task-close-account.deactivate-account.overview.last.line.self": "Puedes volver a activar la cuenta en cualquier momento.",
    "focused-task-close-account.deactivate-account.overview.paragraph.about-to-deactivate.admin": "Cuando desactives la cuenta:",
    "focused-task-close-account.deactivate-account.overview.paragraph.about-to-deactivate.self": "Cuando desactives la cuenta:",
    "focused-task-close-account.deactivate-account.overview.paragraph.billing.admin": "Dejaremos de facturarte por este usuario.",
    "focused-task-close-account.deactivate-account.overview.paragraph.billing.self": "Dejaremos de facturarte por este usuario.",
    "focused-task-close-account.deactivate-account.overview.paragraph.loseAccess.admin": "{fullName} <b>perder\xe1 el acceso de inmediato</b> a todos los servicios de la cuenta de Atlassian. En este momento, tiene acceso a:",
    "focused-task-close-account.deactivate-account.overview.paragraph.loseAccess.admin.noSites": "{fullName} <b>perder\xe1 el acceso de inmediato</b> a todos los servicios de la cuenta de Atlassian. En este momento, no tiene acceso a ninguno de ellos, excepto a servicios como Community o Marketplace.",
    "focused-task-close-account.deactivate-account.overview.paragraph.loseAccess.footnote": "Otros servicios de la cuenta de Atlassian, como Atlassian Community y Marketplace.",
    "focused-task-close-account.deactivate-account.overview.paragraph.loseAccess.self": "<b>Perder\xe1s el acceso de inmediato</b> a todos los servicios de la cuenta de Atlassian. En este momento, tienes acceso a:",
    "focused-task-close-account.deactivate-account.overview.paragraph.loseAccess.self.noSites": "<b>Perder\xe1s el acceso de inmediato</b> a todos los servicios de la cuenta de Atlassian. En este momento, no tienes acceso a ninguno de ellos, excepto a servicios como Community y Marketplace.",
    "focused-task-close-account.deactivate-account.overview.paragraph.personal-data.admin": "Sus datos personales, como su nombre completo y su direcci\xf3n de correo electr\xf3nico, y el contenido que hayan creado permanecer\xe1n en los servicios de la cuenta de Atlassian.",
    "focused-task-close-account.deactivate-account.overview.paragraph.personal-data.self": "Sus datos personales, como su nombre completo y su direcci\xf3n de correo electr\xf3nico, y el contenido que hayan creado permanecer\xe1n en los servicios de la cuenta de Atlassian.",
    "focused-task-close-account.delete-account": "Eliminar la cuenta",
    "focused-task-close-account.delete-account.content-preview.footnote.admin": 'Nota: Si respondes a esta encuesta, nos ayudar\xe1s a ofrecer una experiencia mejor a todos los usuarios. El usuario seguir\xe1 apareciendo como "Usuario antiguo" una vez que hayas eliminado su cuenta.',
    "focused-task-close-account.delete-account.content-preview.footnote.self": 'Nota: Si respondes a esta encuesta, nos ayudar\xe1s a ofrecer una experiencia mejor a todos los usuarios, incluso a aquellos que eliminen sus cuentas. Una vez que elimines tu cuenta, te seguir\xe1n viendo como "Usuario antiguo".',
    "focused-task-close-account.delete-account.content-preview.formerUser": "Usuario antiguo",
    "focused-task-close-account.delete-account.content-preview.heading.admin": "\xbfC\xf3mo preferir\xedas ver al usuario eliminado?",
    "focused-task-close-account.delete-account.content-preview.heading.self": "\xbfC\xf3mo preferir\xedas que se viese tu cuenta eliminada?",
    "focused-task-close-account.delete-account.content-preview.line.survey.admin": "Si pudieses elegir, \xbfc\xf3mo te gustar\xeda que viesen los dem\xe1s usuarios al usuario eliminado?",
    "focused-task-close-account.delete-account.content-preview.line.survey.self": "Si pudieses elegir, \xbfc\xf3mo te gustar\xeda que te viesen los dem\xe1s usuarios?",
    "focused-task-close-account.delete-account.content-preview.paragraph.survey.admin": 'Una vez que se elimine la cuenta del usuario, los dem\xe1s lo ver\xe1n como "Usuario antiguo". T\xf3mate un momento para responder a la pregunta de nuestra encuesta.',
    "focused-task-close-account.delete-account.content-preview.paragraph.survey.self": 'Una vez que se elimine tu cuenta, los dem\xe1s te ver\xe1n como "Usuario antiguo". T\xf3mate un momento para responder a la pregunta de nuestra encuesta.',
    "focused-task-close-account.delete-account.drop-down-collapse-button": "Mostrar menos",
    "focused-task-close-account.delete-account.drop-down-expand-button": "{num}\xa0m\xe1s",
    "focused-task-close-account.delete-account.overview.first.line.admin": "Est\xe1s a punto de eliminar la cuenta de:",
    "focused-task-close-account.delete-account.overview.first.line.self": "Est\xe1s a punto de eliminar tu cuenta:",
    "focused-task-close-account.delete-account.overview.heading.admin": "Eliminar la cuenta",
    "focused-task-close-account.delete-account.overview.heading.self": "Eliminar tu cuenta",
    "focused-task-close-account.delete-account.overview.inline-dialog.content-created.admin": "Por ejemplo, p\xe1ginas, incidencias y comentarios que han creado en los productos.",
    "focused-task-close-account.delete-account.overview.inline-dialog.content-created.self": "Por ejemplo, p\xe1ginas, incidencias y comentarios que has creado en los productos.",
    "focused-task-close-account.delete-account.overview.inline-dialog.data-apps.admin": "Es posible que t\xfa u otros usuarios hay\xe1is instalado aplicaciones que a\xf1adan funciones a los productos de Atlassian. Estas aplicaciones pueden haber almacenado la informaci\xf3n del perfil del usuario.",
    "focused-task-close-account.delete-account.overview.inline-dialog.data-apps.self": "Es posible que t\xfa u otros usuarios hay\xe1is instalado aplicaciones que a\xf1adan funciones a los productos de Atlassian. Estas aplicaciones pueden haber almacenado la informaci\xf3n de tu perfil.",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.li1.admin": "Informaci\xf3n relacionada con las compras, que debemos conservar para los informes financieros.",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.li1.self": "Informaci\xf3n relacionada con las compras, que debemos conservar para los informes financieros.",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.li2.admin": "Los registros que muestran que hemos eliminado la cuenta de alguien, que podr\xedamos necesitar para facilit\xe1rselos a los organismos reguladores.",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.li2.self": "Los registros que muestran que hemos eliminado la cuenta de alguien, que podr\xedamos necesitar para facilit\xe1rselos a los organismos reguladores.",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.li3.admin": "Los datos que forman parte de una demanda judicial en curso, que estamos obligados a guardar por ley.",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.li3.self": "Los datos que forman parte de una demanda judicial en curso, que estamos obligados a guardar por ley.",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.p1.admin": "En caso de que los datos personales sean necesarios para fines empresariales o legales leg\xedtimos, los conservamos durante per\xedodos de tiempo limitados. Por ejemplo:",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.p1.self": "En caso de que los datos personales sean necesarios para fines empresariales o legales leg\xedtimos, los conservamos durante per\xedodos de tiempo limitados. Por ejemplo:",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.p2.admin": "No eliminamos ning\xfan dato personal del contenido creado por los usuarios, como nombres o direcciones de correo electr\xf3nico escritas en una p\xe1gina o una incidencia. Los administradores del producto son quienes deben eliminar esos datos manualmente.",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.p2.self": "No eliminamos ning\xfan dato personal del contenido que creas t\xfa o crean otras personas, como nombres o direcciones de correo electr\xf3nico escritas en una p\xe1gina o una incidencia. Los administradores del producto son quienes deben eliminar esos datos manualmente.",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.p3.admin": "Los usuarios tienen derecho a presentar denuncias a la autoridad de control de su pa\xeds.",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.p3.self": "Tienes derecho a presentar denuncias a la autoridad de control de tu pa\xeds.",
    "focused-task-close-account.delete-account.overview.paragraph.about-to-delete.admin": "Cuando elimines la cuenta:",
    "focused-task-close-account.delete-account.overview.paragraph.about-to-delete.self": "Cuando elimines tu cuenta:",
    "focused-task-close-account.delete-account.overview.paragraph.content-created.admin": "El contenido que han creado permanecer\xe1 en los servicios de la cuenta de Atlassian.",
    "focused-task-close-account.delete-account.overview.paragraph.content-created.self": "El contenido que has creado permanecer\xe1 en los servicios de la cuenta de Atlassian.",
    "focused-task-close-account.delete-account.overview.paragraph.grace-period.admin": "Tras un per\xedodo de gracia de 14\xa0d\xedas, no podr\xe1s cancelar la eliminaci\xf3n de la cuenta.",
    "focused-task-close-account.delete-account.overview.paragraph.list-of-apps-with-personal-data.admin": "Te enviaremos por correo electr\xf3nico una lista de las aplicaciones que pueden haber almacenado datos personales.",
    "focused-task-close-account.delete-account.overview.paragraph.list-of-apps-with-personal-data.self": "Te enviaremos por correo electr\xf3nico una lista de las aplicaciones que pueden haber almacenado datos personales.",
    "focused-task-close-account.delete-account.overview.paragraph.loseAccess.admin": "{fullName} <b>perder\xe1 el acceso de inmediato</b> a todos los servicios de la cuenta de Atlassian. En este momento, tiene acceso a:",
    "focused-task-close-account.delete-account.overview.paragraph.loseAccess.admin.noSites": "{fullName} <b>perder\xe1 el acceso de inmediato</b> a todos los servicios de la cuenta de Atlassian. En este momento, no tiene acceso a ninguno, excepto a servicios como Community o Marketplace.",
    "focused-task-close-account.delete-account.overview.paragraph.loseAccess.footnote": "Otros servicios de la cuenta de Atlassian, como Atlassian Community y Marketplace.",
    "focused-task-close-account.delete-account.overview.paragraph.loseAccess.self": "<b>Perder\xe1s el acceso de inmediato</b> a todos los servicios de la cuenta de Atlassian. En este momento, tienes acceso a:",
    "focused-task-close-account.delete-account.overview.paragraph.loseAccess.self.noSites": "<b>Perder\xe1s el acceso de inmediato</b> a todos los servicios de la cuenta de Atlassian. En este momento, no tienes acceso a ninguno, excepto a servicios como Community o Marketplace.",
    "focused-task-close-account.delete-account.overview.paragraph.personal-data-will-be-deleted.admin": "<b>Eliminaremos los datos personales</b>, como el nombre completo y la direcci\xf3n de correo electr\xf3nico, de los servicios de la cuenta de Atlassian en un plazo de 30\xa0d\xedas, excepto en algunos casos en los que sean necesarios para fines empresariales o legales leg\xedtimos.",
    "focused-task-close-account.delete-account.overview.paragraph.personal-data-will-be-deleted.self": "<b>Eliminaremos tus datos personales</b>, como tu nombre completo y direcci\xf3n de correo electr\xf3nico, de los servicios de la cuenta de Atlassian en un plazo de 30\xa0d\xedas, excepto en algunos casos en los que sean necesarios para fines empresariales o legales leg\xedtimos.",
    "focused-task-close-account.delete-account.overview.warning-section.body": "Tras un per\xedodo de gracia de 14\xa0d\xedas, no podr\xe1s cancelar la eliminaci\xf3n de la cuenta. Si crees que necesitar\xe1s la cuenta m\xe1s adelante, lo que debes hacer es desactivarla.",
    "focused-task-close-account.delete-account.overview.warning-section.deactivated.body": "Tras un per\xedodo de gracia de 14\xa0d\xedas, no podr\xe1s cancelar la eliminaci\xf3n de la cuenta.",
    "focused-task-close-account.learnMore": "M\xe1s informaci\xf3n",
    "focused-task-close-account.next": "Siguiente",
    "focused-task-close-account.previous": "Anterior"
};

});

parcelRegister("ifNq0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d49ff63254a51fc9$export$2e2bcd8739ae039; });
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Swedish
var $d49ff63254a51fc9$export$2e2bcd8739ae039 = {
    "focused-task-close-account.cancel": "Avbryt",
    "focused-task-close-account.deactivate-account": "Inaktivera konto",
    "focused-task-close-account.deactivate-account.overview.first.line.admin": "Du \xe4r p\xe5 v\xe4g att inaktivera anv\xe4ndarkontot f\xf6r:",
    "focused-task-close-account.deactivate-account.overview.first.line.self": "Du \xe4r p\xe5 v\xe4g att inaktivera anv\xe4ndarkontot f\xf6r:",
    "focused-task-close-account.deactivate-account.overview.heading.admin": "Inaktivera konto",
    "focused-task-close-account.deactivate-account.overview.heading.self": "Inaktivera konto",
    "focused-task-close-account.deactivate-account.overview.last.line.admin": "Du kan n\xe4r som helst \xe5teraktivera kontot.",
    "focused-task-close-account.deactivate-account.overview.last.line.self": "Du kan n\xe4r som helst \xe5teraktivera kontot.",
    "focused-task-close-account.deactivate-account.overview.paragraph.about-to-deactivate.admin": "N\xe4r du inaktiverar kontot:",
    "focused-task-close-account.deactivate-account.overview.paragraph.about-to-deactivate.self": "N\xe4r du inaktiverar kontot:",
    "focused-task-close-account.deactivate-account.overview.paragraph.billing.admin": "Vi kommer inte l\xe4ngre att ta betalt f\xf6r dem.",
    "focused-task-close-account.deactivate-account.overview.paragraph.billing.self": "Vi kommer inte l\xe4ngre att ta betalt f\xf6r dem.",
    "focused-task-close-account.deactivate-account.overview.paragraph.loseAccess.admin": "{fullName} kommer <b>omedelbart att f\xf6rlora \xe5tkomst</b> till samtliga Atlassian-kontotj\xe4nster. F\xf6r n\xe4rvarande ges \xe5tkomst till:",
    "focused-task-close-account.deactivate-account.overview.paragraph.loseAccess.admin.noSites": "{fullName} kommer <b>omedelbart att f\xf6rlora \xe5tkomst</b> till samtliga Atlassian-kontotj\xe4nster. I nul\xe4get har de inte \xe5tkomst till n\xe5gra, med undantag av tj\xe4nster s\xe5 som Community och Marketplace.",
    "focused-task-close-account.deactivate-account.overview.paragraph.loseAccess.footnote": "Andra Atlassian-kontotj\xe4nster, s\xe5 som Atlassian Community och Marketplace.",
    "focused-task-close-account.deactivate-account.overview.paragraph.loseAccess.self": "Du kommer <b>omedelbart att f\xf6rlora \xe5tkomst</b> till samtliga Atlassian-kontotj\xe4nster. Du har har f\xf6r n\xe4rvarande \xe5tkomst till:",
    "focused-task-close-account.deactivate-account.overview.paragraph.loseAccess.self.noSites": "Du kommer <b>omedelbart att f\xf6rlora \xe5tkomst</b> till samtliga Atlassian-kontotj\xe4nster. I nul\xe4get har du inte \xe5tkomst till n\xe5gra, med undantag av tj\xe4nster s\xe5 som Community och Marketplace.",
    "focused-task-close-account.deactivate-account.overview.paragraph.personal-data.admin": "Deras personuppgifter, till exempel deras fullst\xe4ndiga namn och e-postadress, och inneh\xe5ll som de har skapat kommer att finnas kvar i Atlassian-kontotj\xe4nster.",
    "focused-task-close-account.deactivate-account.overview.paragraph.personal-data.self": "Deras personuppgifter, till exempel deras fullst\xe4ndiga namn och e-postadress, och inneh\xe5ll som de har skapat kommer att finnas kvar i Atlassian-kontotj\xe4nster.",
    "focused-task-close-account.delete-account": "Ta bort konto",
    "focused-task-close-account.delete-account.content-preview.footnote.admin": 'Obs: Genom att svara p\xe5 enk\xe4ten hj\xe4lper du oss att skapa en b\xe4ttre upplevelse f\xf6r alla anv\xe4ndare. Anv\xe4ndaren kommer fortfarande att visas som "F\xf6re detta anv\xe4ndare" efter att du har tagit bort deras konto.',
    "focused-task-close-account.delete-account.content-preview.footnote.self": 'Obs: Genom att svara p\xe5 enk\xe4ten hj\xe4lper du oss att skapa en b\xe4ttre upplevelse f\xf6r alla anv\xe4ndare, inklusive dem som tar bort sina konton. Du kommer fortfarande att visas som "F\xf6re detta anv\xe4ndare" efter att du har tagit bort ditt konto.',
    "focused-task-close-account.delete-account.content-preview.formerUser": "F\xf6re detta anv\xe4ndare",
    "focused-task-close-account.delete-account.content-preview.heading.admin": "Hur vill du att den borttagna anv\xe4ndaren ska visas?",
    "focused-task-close-account.delete-account.content-preview.heading.self": "Hur vill du att det borttagna kontot ska visas?",
    "focused-task-close-account.delete-account.content-preview.line.survey.admin": "Om du fick v\xe4lja, hur skulle du vilja att den borttagna anv\xe4ndaren ska visas f\xf6r andra anv\xe4ndare?",
    "focused-task-close-account.delete-account.content-preview.line.survey.self": "Om du fick v\xe4lja, hur skulle du vilja att den ska visas f\xf6r andra anv\xe4ndare?",
    "focused-task-close-account.delete-account.content-preview.paragraph.survey.admin": 'N\xe4r anv\xe4ndarens konto har tagits bort visas det som "F\xf6re detta anv\xe4ndare" f\xf6r andra anv\xe4ndare. Ta en stund och svara p\xe5 v\xe5r enk\xe4t.',
    "focused-task-close-account.delete-account.content-preview.paragraph.survey.self": 'N\xe4r ditt konto har tagits bort visas det som "F\xf6re detta anv\xe4ndare" f\xf6r andra anv\xe4ndare. Ta en stund och svara p\xe5 v\xe5r enk\xe4t.',
    "focused-task-close-account.delete-account.drop-down-collapse-button": "Visa mindre",
    "focused-task-close-account.delete-account.drop-down-expand-button": "{num} mer",
    "focused-task-close-account.delete-account.overview.first.line.admin": "Du \xe4r p\xe5 v\xe4g att ta bort kontot f\xf6r:",
    "focused-task-close-account.delete-account.overview.first.line.self": "Du \xe4r p\xe5 v\xe4g att ta bort ditt konto:",
    "focused-task-close-account.delete-account.overview.heading.admin": "Ta bort konto",
    "focused-task-close-account.delete-account.overview.heading.self": "Ta bort ditt konto",
    "focused-task-close-account.delete-account.overview.inline-dialog.content-created.admin": "Till exempel sidor, \xe4renden och kommentarer som de har skapat i produkter.",
    "focused-task-close-account.delete-account.overview.inline-dialog.content-created.self": "Till exempel sidor, \xe4renden och kommentarer som du har skapat i produkter.",
    "focused-task-close-account.delete-account.overview.inline-dialog.data-apps.admin": "Du eller andra anv\xe4ndare kan ha installerat appar som l\xe4gger till funktioner till Atlassian-produkter. Dessa appar kan ha lagrat anv\xe4ndarens profilinformation.",
    "focused-task-close-account.delete-account.overview.inline-dialog.data-apps.self": "Du eller andra anv\xe4ndare kan ha installerat appar som l\xe4gger till funktioner till Atlassian-produkter. Dessa appar kan ha lagrat din profilinformation.",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.li1.admin": "Information relaterat till k\xf6p som vi m\xe5ste spara f\xf6r redovisning och finansiell rapportering.",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.li1.self": "Information relaterat till k\xf6p som vi m\xe5ste spara f\xf6r redovisning och finansiell rapportering.",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.li2.admin": "Register som visar att vi har raderat n\xe5gons konto, vilket tillsynsmyndigheter kan beg\xe4ra ut.",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.li2.self": "Register som visar att vi har raderat n\xe5gons konto, vilket tillsynsmyndigheter kan beg\xe4ra ut.",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.li3.admin": "Data som \xe4r del i en p\xe5g\xe5ende r\xe4tteg\xe5ng, som vi \xe4r skyldiga att spara enligt lag.",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.li3.self": "Data som \xe4r del i en p\xe5g\xe5ende r\xe4tteg\xe5ng, som vi \xe4r skyldiga att spara enligt lag.",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.p1.admin": "Vi sparar personuppgifter under begr\xe4nsade tidsperioder n\xe4r vi har legitima verksamhetssk\xe4l eller juridiska sk\xe4l. N\xe5gra exempel \xe4r:",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.p1.self": "Vi sparar personuppgifter under begr\xe4nsade tidsperioder n\xe4r vi har legitima verksamhetssk\xe4l eller juridiska sk\xe4l. N\xe5gra exempel \xe4r:",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.p2.admin": "Vi tar inte bort n\xe5gra personuppgifter fr\xe5n inneh\xe5ll som har skapats av anv\xe4ndare, till exempel namn eller e-postadresser som de skrivit p\xe5 en sida eller ett \xe4rende. Produktadministrat\xf6rerna m\xe5ste ta bort dessa data manuellt.",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.p2.self": "Vi tar inte bort n\xe5gra personuppgifter fr\xe5n inneh\xe5ll som har skapats av dig eller andra personer, till exempel namn eller e-postadresser som har skrivits p\xe5 en sida eller i ett \xe4rende. Produktadministrat\xf6rerna m\xe5ste ta bort dessa data manuellt.",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.p3.admin": "Anv\xe4ndare har r\xe4tt att framf\xf6ra klagom\xe5l till tillsynsmyndigheten i anv\xe4ndarens land.",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.p3.self": "Du har r\xe4tt att framf\xf6ra klagom\xe5l till tillsynsmyndigheten i ditt land.",
    "focused-task-close-account.delete-account.overview.paragraph.about-to-delete.admin": "N\xe4r du tar bort kontot:",
    "focused-task-close-account.delete-account.overview.paragraph.about-to-delete.self": "N\xe4r du tar bort ditt konto:",
    "focused-task-close-account.delete-account.overview.paragraph.content-created.admin": "Inneh\xe5llet som de redan har skapat kommer att finnas kvar hos Atlassian-kontotj\xe4nsterna.",
    "focused-task-close-account.delete-account.overview.paragraph.content-created.self": "Inneh\xe5llet som du redan har skapat kommer att finnas kvar hos Atlassian-kontotj\xe4nsterna.",
    "focused-task-close-account.delete-account.overview.paragraph.grace-period.admin": "Efter en 14 dagars respitperiod kan du inte l\xe4ngre avbryta borttagningen av kontot.",
    "focused-task-close-account.delete-account.overview.paragraph.list-of-apps-with-personal-data.admin": "Vi kommer att mejla en lista p\xe5 appar som kan ha lagrat deras personuppgifter.",
    "focused-task-close-account.delete-account.overview.paragraph.list-of-apps-with-personal-data.self": "Vi kommer att mejla en lista p\xe5 appar som kan ha lagrat deras personuppgifter.",
    "focused-task-close-account.delete-account.overview.paragraph.loseAccess.admin": "{fullName} kommer <b>omedelbart att f\xf6rlora \xe5tkomst</b> till samtliga Atlassian-kontotj\xe4nster. De har f\xf6r n\xe4rvarande \xe5tkomst till:",
    "focused-task-close-account.delete-account.overview.paragraph.loseAccess.admin.noSites": "{fullName} kommer <b>omedelbart att f\xf6rlora \xe5tkomst</b> till samtliga Atlassian-kontotj\xe4nster. I nul\xe4get har de inte \xe5tkomst till n\xe5gra, med undantag av tj\xe4nster s\xe5 som Community och Marketplace.",
    "focused-task-close-account.delete-account.overview.paragraph.loseAccess.footnote": "Andra Atlassian-kontotj\xe4nster, s\xe5 som Atlassian Community och Marketplace.",
    "focused-task-close-account.delete-account.overview.paragraph.loseAccess.self": "Du kommer <b>omedelbart att f\xf6rlora \xe5tkomst</b> till samtliga Atlassian-kontotj\xe4nster. Du har har f\xf6r n\xe4rvarande \xe5tkomst till:",
    "focused-task-close-account.delete-account.overview.paragraph.loseAccess.self.noSites": "Du kommer <b>omedelbart att f\xf6rlora \xe5tkomst</b> till samtliga Atlassian-kontotj\xe4nster. I nul\xe4get har du inte \xe5tkomst till n\xe5gra, med undantag av tj\xe4nster s\xe5 som Community och Marketplace.",
    "focused-task-close-account.delete-account.overview.paragraph.personal-data-will-be-deleted.admin": "Vi kommer att <b>radera deras personuppgifter</b>, s\xe5 som fullst\xe4ndigt namn och e-postadress fr\xe5n Atlassian-kontotj\xe4nsterna inom 30 dagar med n\xe5gra f\xe5 undantag n\xe4r s\xe5 kr\xe4vs av verksamhetssk\xe4l eller juridiska sk\xe4l.",
    "focused-task-close-account.delete-account.overview.paragraph.personal-data-will-be-deleted.self": "Vi kommer att <b>radera dina personuppgifter</b>, s\xe5 som fullst\xe4ndigt namn och e-postadress fr\xe5n Atlassian-kontotj\xe4nsterna inom 30 dagar med n\xe5gra f\xe5 undantag n\xe4r s\xe5 kr\xe4vs av verksamhetssk\xe4l eller juridiska sk\xe4l.",
    "focused-task-close-account.delete-account.overview.warning-section.body": "Efter en 14 dagars respitperiod kan du inte l\xe4ngre avbryta borttagningen av kontot. Om du tror att du kommer att beh\xf6va ditt konto senare b\xf6r du inaktivera det ist\xe4llet.",
    "focused-task-close-account.delete-account.overview.warning-section.deactivated.body": "Efter en 14 dagars respitperiod kan du inte l\xe4ngre avbryta borttagningen av kontot.",
    "focused-task-close-account.learnMore": "L\xe4s mer",
    "focused-task-close-account.next": "N\xe4sta",
    "focused-task-close-account.previous": "F\xf6reg\xe5ende"
};

});

parcelRegister("giAee", function(module, exports) {
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Thai (Thailand)
var $bdda6e0561303c6c$export$2e2bcd8739ae039 = {
    "focused-task-close-account.cancel": "\u0E22\u0E01\u0E40\u0E25\u0E34\u0E01",
    "focused-task-close-account.deactivate-account": "\u0E1B\u0E34\u0E14\u0E43\u0E0A\u0E49\u0E07\u0E32\u0E19\u0E1A\u0E31\u0E0D\u0E0A\u0E35",
    "focused-task-close-account.deactivate-account.overview.first.line.admin": "\u0E04\u0E38\u0E13\u0E01\u0E33\u0E25\u0E31\u0E07\u0E1B\u0E34\u0E14\u0E01\u0E32\u0E23\u0E43\u0E0A\u0E49\u0E07\u0E32\u0E19\u0E1A\u0E31\u0E0D\u0E0A\u0E35\u0E02\u0E2D\u0E07:",
    "focused-task-close-account.deactivate-account.overview.first.line.self": "\u0E04\u0E38\u0E13\u0E01\u0E33\u0E25\u0E31\u0E07\u0E1B\u0E34\u0E14\u0E01\u0E32\u0E23\u0E43\u0E0A\u0E49\u0E07\u0E32\u0E19\u0E1A\u0E31\u0E0D\u0E0A\u0E35\u0E02\u0E2D\u0E07:",
    "focused-task-close-account.deactivate-account.overview.heading.admin": "\u0E1B\u0E34\u0E14\u0E43\u0E0A\u0E49\u0E07\u0E32\u0E19\u0E1A\u0E31\u0E0D\u0E0A\u0E35",
    "focused-task-close-account.deactivate-account.overview.heading.self": "\u0E1B\u0E34\u0E14\u0E43\u0E0A\u0E49\u0E07\u0E32\u0E19\u0E1A\u0E31\u0E0D\u0E0A\u0E35",
    "focused-task-close-account.deactivate-account.overview.last.line.admin": "\u0E04\u0E38\u0E13\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E40\u0E1B\u0E34\u0E14\u0E43\u0E0A\u0E49\u0E07\u0E32\u0E19\u0E1A\u0E31\u0E0D\u0E0A\u0E35\u0E2D\u0E35\u0E01\u0E04\u0E23\u0E31\u0E49\u0E07\u0E44\u0E14\u0E49\u0E17\u0E38\u0E01\u0E40\u0E21\u0E37\u0E48\u0E2D",
    "focused-task-close-account.deactivate-account.overview.last.line.self": "\u0E04\u0E38\u0E13\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E40\u0E1B\u0E34\u0E14\u0E43\u0E0A\u0E49\u0E07\u0E32\u0E19\u0E1A\u0E31\u0E0D\u0E0A\u0E35\u0E2D\u0E35\u0E01\u0E04\u0E23\u0E31\u0E49\u0E07\u0E44\u0E14\u0E49\u0E17\u0E38\u0E01\u0E40\u0E21\u0E37\u0E48\u0E2D",
    "focused-task-close-account.deactivate-account.overview.paragraph.about-to-deactivate.admin": "\u0E40\u0E21\u0E37\u0E48\u0E2D\u0E04\u0E38\u0E13\u0E1B\u0E34\u0E14\u0E43\u0E0A\u0E49\u0E07\u0E32\u0E19\u0E1A\u0E31\u0E0D\u0E0A\u0E35:",
    "focused-task-close-account.deactivate-account.overview.paragraph.about-to-deactivate.self": "\u0E40\u0E21\u0E37\u0E48\u0E2D\u0E04\u0E38\u0E13\u0E1B\u0E34\u0E14\u0E43\u0E0A\u0E49\u0E07\u0E32\u0E19\u0E1A\u0E31\u0E0D\u0E0A\u0E35:",
    "focused-task-close-account.deactivate-account.overview.paragraph.billing.admin": "\u0E40\u0E23\u0E32\u0E08\u0E30\u0E44\u0E21\u0E48\u0E40\u0E23\u0E35\u0E22\u0E01\u0E40\u0E01\u0E47\u0E1A\u0E40\u0E07\u0E34\u0E19\u0E2A\u0E33\u0E2B\u0E23\u0E31\u0E1A\u0E1A\u0E31\u0E0D\u0E0A\u0E35\u0E40\u0E2B\u0E25\u0E48\u0E32\u0E19\u0E31\u0E49\u0E19\u0E01\u0E31\u0E1A\u0E04\u0E38\u0E13\u0E2D\u0E35\u0E01\u0E15\u0E48\u0E2D\u0E44\u0E1B",
    "focused-task-close-account.deactivate-account.overview.paragraph.billing.self": "\u0E40\u0E23\u0E32\u0E08\u0E30\u0E44\u0E21\u0E48\u0E40\u0E23\u0E35\u0E22\u0E01\u0E40\u0E01\u0E47\u0E1A\u0E40\u0E07\u0E34\u0E19\u0E2A\u0E33\u0E2B\u0E23\u0E31\u0E1A\u0E1A\u0E31\u0E0D\u0E0A\u0E35\u0E40\u0E2B\u0E25\u0E48\u0E32\u0E19\u0E31\u0E49\u0E19\u0E01\u0E31\u0E1A\u0E04\u0E38\u0E13\u0E2D\u0E35\u0E01\u0E15\u0E48\u0E2D\u0E44\u0E1B",
    "focused-task-close-account.deactivate-account.overview.paragraph.loseAccess.admin": "{fullName} \u0E08\u0E30<b>\u0E40\u0E2A\u0E35\u0E22\u0E2A\u0E34\u0E17\u0E18\u0E34\u0E4C\u0E01\u0E32\u0E23\u0E40\u0E02\u0E49\u0E32\u0E16\u0E36\u0E07</b>\u0E1A\u0E23\u0E34\u0E01\u0E32\u0E23\u0E02\u0E2D\u0E07\u0E1A\u0E31\u0E0D\u0E0A\u0E35 Atlassian \u0E17\u0E31\u0E49\u0E07\u0E2B\u0E21\u0E14\u0E17\u0E31\u0E19\u0E17\u0E35 \u0E42\u0E14\u0E22\u0E1B\u0E31\u0E08\u0E08\u0E38\u0E1A\u0E31\u0E19 \u0E1C\u0E39\u0E49\u0E43\u0E0A\u0E49\u0E21\u0E35\u0E2A\u0E34\u0E17\u0E18\u0E34\u0E4C\u0E40\u0E02\u0E49\u0E32\u0E16\u0E36\u0E07:",
    "focused-task-close-account.deactivate-account.overview.paragraph.loseAccess.admin.noSites": "{fullName} \u0E08\u0E30<b>\u0E40\u0E2A\u0E35\u0E22\u0E2A\u0E34\u0E17\u0E18\u0E34\u0E4C\u0E01\u0E32\u0E23\u0E40\u0E02\u0E49\u0E32\u0E16\u0E36\u0E07</b>\u0E1A\u0E23\u0E34\u0E01\u0E32\u0E23\u0E02\u0E2D\u0E07\u0E1A\u0E31\u0E0D\u0E0A\u0E35 Atlassian \u0E17\u0E31\u0E49\u0E07\u0E2B\u0E21\u0E14\u0E17\u0E31\u0E19\u0E17\u0E35 \u0E42\u0E14\u0E22\u0E1B\u0E31\u0E08\u0E08\u0E38\u0E1A\u0E31\u0E19 \u0E1C\u0E39\u0E49\u0E43\u0E0A\u0E49\u0E44\u0E21\u0E48\u0E21\u0E35\u0E2A\u0E34\u0E17\u0E18\u0E34\u0E4C\u0E40\u0E02\u0E49\u0E32\u0E16\u0E36\u0E07\u0E1A\u0E23\u0E34\u0E01\u0E32\u0E23\u0E43\u0E14 \u0E46 \u0E22\u0E01\u0E40\u0E27\u0E49\u0E19\u0E1A\u0E23\u0E34\u0E01\u0E32\u0E23 \u0E40\u0E0A\u0E48\u0E19 \u0E0A\u0E38\u0E21\u0E0A\u0E19\u0E41\u0E25\u0E30 Marketplace",
    "focused-task-close-account.deactivate-account.overview.paragraph.loseAccess.footnote": "\u0E1A\u0E23\u0E34\u0E01\u0E32\u0E23\u0E1A\u0E31\u0E0D\u0E0A\u0E35 Atlassian \u0E2D\u0E37\u0E48\u0E19 \u0E46 \u0E40\u0E0A\u0E48\u0E19 \u0E0A\u0E38\u0E21\u0E0A\u0E19 Atlassian \u0E41\u0E25\u0E30 Marketplace",
    "focused-task-close-account.deactivate-account.overview.paragraph.loseAccess.self": "\u0E04\u0E38\u0E13\u0E08\u0E30<b>\u0E40\u0E2A\u0E35\u0E22\u0E2A\u0E34\u0E17\u0E18\u0E34\u0E4C\u0E01\u0E32\u0E23\u0E40\u0E02\u0E49\u0E32\u0E16\u0E36\u0E07</b> \u0E1A\u0E23\u0E34\u0E01\u0E32\u0E23\u0E02\u0E2D\u0E07\u0E1A\u0E31\u0E0D\u0E0A\u0E35 Atlassian \u0E17\u0E31\u0E49\u0E07\u0E2B\u0E21\u0E14\u0E17\u0E31\u0E19\u0E17\u0E35 \u0E42\u0E14\u0E22\u0E1B\u0E31\u0E08\u0E08\u0E38\u0E1A\u0E31\u0E19 \u0E04\u0E38\u0E13\u0E21\u0E35\u0E2A\u0E34\u0E17\u0E18\u0E34\u0E4C\u0E40\u0E02\u0E49\u0E32\u0E16\u0E36\u0E07:",
    "focused-task-close-account.deactivate-account.overview.paragraph.loseAccess.self.noSites": "\u0E04\u0E38\u0E13\u0E08\u0E30<b>\u0E40\u0E2A\u0E35\u0E22\u0E2A\u0E34\u0E17\u0E18\u0E34\u0E4C\u0E01\u0E32\u0E23\u0E40\u0E02\u0E49\u0E32\u0E16\u0E36\u0E07</b> \u0E1A\u0E23\u0E34\u0E01\u0E32\u0E23\u0E02\u0E2D\u0E07\u0E1A\u0E31\u0E0D\u0E0A\u0E35 Atlassian \u0E17\u0E31\u0E49\u0E07\u0E2B\u0E21\u0E14\u0E17\u0E31\u0E19\u0E17\u0E35 \u0E42\u0E14\u0E22\u0E1B\u0E31\u0E08\u0E08\u0E38\u0E1A\u0E31\u0E19 \u0E04\u0E38\u0E13\u0E44\u0E21\u0E48\u0E21\u0E35\u0E2A\u0E34\u0E17\u0E18\u0E34\u0E4C\u0E40\u0E02\u0E49\u0E32\u0E16\u0E36\u0E07\u0E1A\u0E23\u0E34\u0E01\u0E32\u0E23\u0E43\u0E14 \u0E46 \u0E22\u0E01\u0E40\u0E27\u0E49\u0E19\u0E1A\u0E23\u0E34\u0E01\u0E32\u0E23 \u0E40\u0E0A\u0E48\u0E19 \u0E0A\u0E38\u0E21\u0E0A\u0E19 \u0E41\u0E25\u0E30 Marketplace",
    "focused-task-close-account.deactivate-account.overview.paragraph.personal-data.admin": "\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E2A\u0E48\u0E27\u0E19\u0E15\u0E31\u0E27\u0E02\u0E2D\u0E07\u0E1A\u0E31\u0E0D\u0E0A\u0E35 \u0E40\u0E0A\u0E48\u0E19 \u0E0A\u0E37\u0E48\u0E2D \u0E19\u0E32\u0E21\u0E2A\u0E01\u0E38\u0E25\u0E41\u0E25\u0E30\u0E17\u0E35\u0E48\u0E2D\u0E22\u0E39\u0E48\u0E2D\u0E35\u0E40\u0E21\u0E25 \u0E2B\u0E23\u0E37\u0E2D\u0E40\u0E19\u0E37\u0E49\u0E2D\u0E2B\u0E32\u0E17\u0E35\u0E48\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E02\u0E36\u0E49\u0E19\u0E08\u0E30\u0E22\u0E31\u0E07\u0E04\u0E07\u0E2D\u0E22\u0E39\u0E48\u0E43\u0E19\u0E1A\u0E23\u0E34\u0E01\u0E32\u0E23\u0E1A\u0E31\u0E0D\u0E0A\u0E35 Atlassian",
    "focused-task-close-account.deactivate-account.overview.paragraph.personal-data.self": "\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E2A\u0E48\u0E27\u0E19\u0E15\u0E31\u0E27\u0E02\u0E2D\u0E07\u0E1A\u0E31\u0E0D\u0E0A\u0E35 \u0E40\u0E0A\u0E48\u0E19 \u0E0A\u0E37\u0E48\u0E2D \u0E19\u0E32\u0E21\u0E2A\u0E01\u0E38\u0E25\u0E41\u0E25\u0E30\u0E17\u0E35\u0E48\u0E2D\u0E22\u0E39\u0E48\u0E2D\u0E35\u0E40\u0E21\u0E25 \u0E2B\u0E23\u0E37\u0E2D\u0E40\u0E19\u0E37\u0E49\u0E2D\u0E2B\u0E32\u0E17\u0E35\u0E48\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E02\u0E36\u0E49\u0E19\u0E08\u0E30\u0E22\u0E31\u0E07\u0E04\u0E07\u0E2D\u0E22\u0E39\u0E48\u0E43\u0E19\u0E1A\u0E23\u0E34\u0E01\u0E32\u0E23\u0E1A\u0E31\u0E0D\u0E0A\u0E35 Atlassian",
    "focused-task-close-account.delete-account": "\u0E25\u0E1A\u0E1A\u0E31\u0E0D\u0E0A\u0E35",
    "focused-task-close-account.delete-account.content-preview.footnote.admin": '\u0E2B\u0E21\u0E32\u0E22\u0E40\u0E2B\u0E15\u0E38: \u0E01\u0E32\u0E23\u0E15\u0E2D\u0E1A\u0E41\u0E1A\u0E1A\u0E2A\u0E33\u0E23\u0E27\u0E08\u0E19\u0E35\u0E49\u0E08\u0E30\u0E0A\u0E48\u0E27\u0E22\u0E43\u0E2B\u0E49\u0E40\u0E23\u0E32\u0E1B\u0E23\u0E31\u0E1A\u0E1B\u0E23\u0E38\u0E07\u0E1B\u0E23\u0E30\u0E2A\u0E1A\u0E01\u0E32\u0E23\u0E13\u0E4C\u0E2A\u0E33\u0E2B\u0E23\u0E31\u0E1A\u0E1C\u0E39\u0E49\u0E43\u0E0A\u0E49\u0E17\u0E38\u0E01\u0E04\u0E19\u0E43\u0E2B\u0E49\u0E14\u0E35\u0E22\u0E34\u0E48\u0E07\u0E02\u0E36\u0E49\u0E19\u0E44\u0E14\u0E49 \u0E1C\u0E39\u0E49\u0E43\u0E0A\u0E49\u0E08\u0E30\u0E22\u0E31\u0E07\u0E04\u0E07\u0E1B\u0E23\u0E32\u0E01\u0E0F\u0E40\u0E1B\u0E47\u0E19 "\u0E1C\u0E39\u0E49\u0E43\u0E0A\u0E49\u0E40\u0E14\u0E34\u0E21" \u0E2B\u0E25\u0E31\u0E07\u0E08\u0E32\u0E01\u0E04\u0E38\u0E13\u0E25\u0E1A\u0E1A\u0E31\u0E0D\u0E0A\u0E35\u0E02\u0E2D\u0E07\u0E1E\u0E27\u0E01\u0E40\u0E02\u0E32\u0E41\u0E25\u0E49\u0E27',
    "focused-task-close-account.delete-account.content-preview.footnote.self": '\u0E2B\u0E21\u0E32\u0E22\u0E40\u0E2B\u0E15\u0E38: \u0E01\u0E32\u0E23\u0E15\u0E2D\u0E1A\u0E41\u0E1A\u0E1A\u0E2A\u0E33\u0E23\u0E27\u0E08\u0E19\u0E35\u0E49\u0E08\u0E30\u0E0A\u0E48\u0E27\u0E22\u0E43\u0E2B\u0E49\u0E40\u0E23\u0E32\u0E1B\u0E23\u0E31\u0E1A\u0E1B\u0E23\u0E38\u0E07\u0E1B\u0E23\u0E30\u0E2A\u0E1A\u0E01\u0E32\u0E23\u0E13\u0E4C\u0E2A\u0E33\u0E2B\u0E23\u0E31\u0E1A\u0E1C\u0E39\u0E49\u0E43\u0E0A\u0E49\u0E17\u0E38\u0E01\u0E04\u0E19\u0E43\u0E2B\u0E49\u0E14\u0E35\u0E22\u0E34\u0E48\u0E07\u0E02\u0E36\u0E49\u0E19\u0E44\u0E14\u0E49 \u0E23\u0E27\u0E21\u0E16\u0E36\u0E07\u0E1C\u0E39\u0E49\u0E43\u0E0A\u0E49\u0E17\u0E35\u0E48\u0E25\u0E1A\u0E1A\u0E31\u0E0D\u0E0A\u0E35\u0E02\u0E2D\u0E07\u0E15\u0E19\u0E2D\u0E2D\u0E01\u0E44\u0E1B\u0E41\u0E25\u0E49\u0E27\u0E14\u0E49\u0E27\u0E22 \u0E04\u0E38\u0E13\u0E08\u0E30\u0E22\u0E31\u0E07\u0E04\u0E07\u0E1B\u0E23\u0E32\u0E01\u0E0F\u0E40\u0E1B\u0E47\u0E19 "\u0E1C\u0E39\u0E49\u0E43\u0E0A\u0E49\u0E40\u0E14\u0E34\u0E21" \u0E2B\u0E25\u0E31\u0E07\u0E08\u0E32\u0E01\u0E04\u0E38\u0E13\u0E25\u0E1A\u0E1A\u0E31\u0E0D\u0E0A\u0E35\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E41\u0E25\u0E49\u0E27',
    "focused-task-close-account.delete-account.content-preview.formerUser": "\u0E1C\u0E39\u0E49\u0E43\u0E0A\u0E49\u0E40\u0E14\u0E34\u0E21",
    "focused-task-close-account.delete-account.content-preview.heading.admin": "\u0E04\u0E38\u0E13\u0E15\u0E49\u0E2D\u0E07\u0E01\u0E32\u0E23\u0E43\u0E2B\u0E49\u0E1C\u0E39\u0E49\u0E43\u0E0A\u0E49\u0E17\u0E35\u0E48\u0E25\u0E1A\u0E2D\u0E2D\u0E01\u0E44\u0E1B\u0E41\u0E25\u0E49\u0E27\u0E1B\u0E23\u0E32\u0E01\u0E0F\u0E02\u0E36\u0E49\u0E19\u0E2D\u0E22\u0E48\u0E32\u0E07\u0E44\u0E23",
    "focused-task-close-account.delete-account.content-preview.heading.self": "\u0E04\u0E38\u0E13\u0E15\u0E49\u0E2D\u0E07\u0E01\u0E32\u0E23\u0E43\u0E2B\u0E49\u0E1A\u0E31\u0E0D\u0E0A\u0E35\u0E17\u0E35\u0E48\u0E25\u0E1A\u0E2D\u0E2D\u0E01\u0E44\u0E1B\u0E41\u0E25\u0E49\u0E27\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E1B\u0E23\u0E32\u0E01\u0E0F\u0E02\u0E36\u0E49\u0E19\u0E2D\u0E22\u0E48\u0E32\u0E07\u0E44\u0E23",
    "focused-task-close-account.delete-account.content-preview.line.survey.admin": "\u0E2B\u0E32\u0E01\u0E40\u0E23\u0E32\u0E43\u0E2B\u0E49\u0E15\u0E31\u0E27\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E41\u0E01\u0E48\u0E04\u0E38\u0E13 \u0E04\u0E38\u0E13\u0E08\u0E30\u0E15\u0E49\u0E2D\u0E07\u0E01\u0E32\u0E23\u0E43\u0E2B\u0E49\u0E1C\u0E39\u0E49\u0E43\u0E0A\u0E49\u0E17\u0E35\u0E48\u0E25\u0E1A\u0E2D\u0E2D\u0E01\u0E44\u0E1B\u0E41\u0E25\u0E49\u0E27\u0E1B\u0E23\u0E32\u0E01\u0E0F\u0E15\u0E48\u0E2D\u0E1C\u0E39\u0E49\u0E43\u0E0A\u0E49\u0E2D\u0E37\u0E48\u0E19\u0E2D\u0E22\u0E48\u0E32\u0E07\u0E44\u0E23",
    "focused-task-close-account.delete-account.content-preview.line.survey.self": "\u0E2B\u0E32\u0E01\u0E40\u0E23\u0E32\u0E43\u0E2B\u0E49\u0E15\u0E31\u0E27\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E41\u0E01\u0E48\u0E04\u0E38\u0E13 \u0E04\u0E38\u0E13\u0E08\u0E30\u0E15\u0E49\u0E2D\u0E07\u0E01\u0E32\u0E23\u0E1B\u0E23\u0E32\u0E01\u0E0F\u0E15\u0E48\u0E2D\u0E1C\u0E39\u0E49\u0E43\u0E0A\u0E49\u0E2D\u0E37\u0E48\u0E19\u0E2D\u0E22\u0E48\u0E32\u0E07\u0E44\u0E23",
    "focused-task-close-account.delete-account.content-preview.paragraph.survey.admin": '\u0E2B\u0E25\u0E31\u0E07\u0E08\u0E32\u0E01\u0E1A\u0E31\u0E0D\u0E0A\u0E35\u0E02\u0E2D\u0E07\u0E1C\u0E39\u0E49\u0E43\u0E0A\u0E49\u0E16\u0E39\u0E01\u0E25\u0E1A\u0E41\u0E25\u0E49\u0E27 \u0E1A\u0E31\u0E0D\u0E0A\u0E35\u0E40\u0E2B\u0E25\u0E48\u0E32\u0E19\u0E31\u0E49\u0E19\u0E08\u0E30\u0E1B\u0E23\u0E32\u0E01\u0E0F\u0E40\u0E1B\u0E47\u0E19 "\u0E1C\u0E39\u0E49\u0E43\u0E0A\u0E49\u0E40\u0E14\u0E34\u0E21" \u0E43\u0E2B\u0E49\u0E1C\u0E39\u0E49\u0E43\u0E0A\u0E49\u0E2D\u0E37\u0E48\u0E19\u0E44\u0E14\u0E49\u0E40\u0E2B\u0E47\u0E19 \u0E42\u0E1B\u0E23\u0E14\u0E2A\u0E25\u0E30\u0E40\u0E27\u0E25\u0E32\u0E2A\u0E31\u0E01\u0E04\u0E23\u0E39\u0E48\u0E43\u0E19\u0E01\u0E32\u0E23\u0E15\u0E2D\u0E1A\u0E04\u0E33\u0E16\u0E32\u0E21\u0E41\u0E1A\u0E1A\u0E2A\u0E33\u0E23\u0E27\u0E08\u0E02\u0E2D\u0E07\u0E40\u0E23\u0E32',
    "focused-task-close-account.delete-account.content-preview.paragraph.survey.self": '\u0E2B\u0E25\u0E31\u0E07\u0E08\u0E32\u0E01\u0E1A\u0E31\u0E0D\u0E0A\u0E35\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E16\u0E39\u0E01\u0E25\u0E1A\u0E41\u0E25\u0E49\u0E27 \u0E04\u0E38\u0E13\u0E08\u0E30\u0E1B\u0E23\u0E32\u0E01\u0E0F\u0E40\u0E1B\u0E47\u0E19 "\u0E1C\u0E39\u0E49\u0E43\u0E0A\u0E49\u0E40\u0E14\u0E34\u0E21" \u0E43\u0E2B\u0E49\u0E1C\u0E39\u0E49\u0E43\u0E0A\u0E49\u0E2D\u0E37\u0E48\u0E19\u0E44\u0E14\u0E49\u0E40\u0E2B\u0E47\u0E19 \u0E42\u0E1B\u0E23\u0E14\u0E2A\u0E25\u0E30\u0E40\u0E27\u0E25\u0E32\u0E2A\u0E31\u0E01\u0E04\u0E23\u0E39\u0E48\u0E43\u0E19\u0E01\u0E32\u0E23\u0E15\u0E2D\u0E1A\u0E04\u0E33\u0E16\u0E32\u0E21\u0E41\u0E1A\u0E1A\u0E2A\u0E33\u0E23\u0E27\u0E08\u0E02\u0E2D\u0E07\u0E40\u0E23\u0E32',
    "focused-task-close-account.delete-account.drop-down-collapse-button": "\u0E41\u0E2A\u0E14\u0E07\u0E19\u0E49\u0E2D\u0E22\u0E25\u0E07",
    "focused-task-close-account.delete-account.drop-down-expand-button": "\u0E21\u0E32\u0E01\u0E01\u0E27\u0E48\u0E32 {num}",
    "focused-task-close-account.delete-account.overview.first.line.admin": "\u0E04\u0E38\u0E13\u0E01\u0E33\u0E25\u0E31\u0E07\u0E08\u0E30\u0E25\u0E1A\u0E1A\u0E31\u0E0D\u0E0A\u0E35\u0E02\u0E2D\u0E07:",
    "focused-task-close-account.delete-account.overview.first.line.self": "\u0E04\u0E38\u0E13\u0E01\u0E33\u0E25\u0E31\u0E07\u0E08\u0E30\u0E25\u0E1A\u0E1A\u0E31\u0E0D\u0E0A\u0E35\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13:",
    "focused-task-close-account.delete-account.overview.heading.admin": "\u0E25\u0E1A\u0E1A\u0E31\u0E0D\u0E0A\u0E35",
    "focused-task-close-account.delete-account.overview.heading.self": "\u0E25\u0E1A\u0E1A\u0E31\u0E0D\u0E0A\u0E35\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13",
    "focused-task-close-account.delete-account.overview.inline-dialog.content-created.admin": "\u0E15\u0E31\u0E27\u0E2D\u0E22\u0E48\u0E32\u0E07\u0E40\u0E0A\u0E48\u0E19 \u0E2B\u0E19\u0E49\u0E32\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25 \u0E1B\u0E31\u0E0D\u0E2B\u0E32 \u0E41\u0E25\u0E30\u0E04\u0E27\u0E32\u0E21\u0E04\u0E34\u0E14\u0E40\u0E2B\u0E47\u0E19\u0E15\u0E48\u0E32\u0E07 \u0E46 \u0E17\u0E35\u0E48\u0E1C\u0E39\u0E49\u0E43\u0E0A\u0E49\u0E40\u0E2B\u0E25\u0E48\u0E32\u0E19\u0E31\u0E49\u0E19\u0E44\u0E14\u0E49\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E44\u0E27\u0E49\u0E43\u0E19\u0E1C\u0E25\u0E34\u0E15\u0E20\u0E31\u0E13\u0E11\u0E4C",
    "focused-task-close-account.delete-account.overview.inline-dialog.content-created.self": "\u0E15\u0E31\u0E27\u0E2D\u0E22\u0E48\u0E32\u0E07\u0E40\u0E0A\u0E48\u0E19 \u0E2B\u0E19\u0E49\u0E32\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25 \u0E1B\u0E31\u0E0D\u0E2B\u0E32 \u0E41\u0E25\u0E30\u0E04\u0E27\u0E32\u0E21\u0E04\u0E34\u0E14\u0E40\u0E2B\u0E47\u0E19\u0E15\u0E48\u0E32\u0E07 \u0E46 \u0E17\u0E35\u0E48\u0E04\u0E38\u0E13\u0E44\u0E14\u0E49\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E44\u0E27\u0E49\u0E43\u0E19\u0E1C\u0E25\u0E34\u0E15\u0E20\u0E31\u0E13\u0E11\u0E4C",
    "focused-task-close-account.delete-account.overview.inline-dialog.data-apps.admin": "\u0E04\u0E38\u0E13\u0E2B\u0E23\u0E37\u0E2D\u0E1C\u0E39\u0E49\u0E43\u0E0A\u0E49\u0E2D\u0E37\u0E48\u0E19\u0E2D\u0E32\u0E08\u0E44\u0E14\u0E49\u0E15\u0E34\u0E14\u0E15\u0E31\u0E49\u0E07\u0E41\u0E2D\u0E1B\u0E17\u0E35\u0E48\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E04\u0E38\u0E13\u0E2A\u0E21\u0E1A\u0E31\u0E15\u0E34\u0E15\u0E48\u0E32\u0E07 \u0E46 \u0E44\u0E1B\u0E22\u0E31\u0E07\u0E1C\u0E25\u0E34\u0E15\u0E20\u0E31\u0E13\u0E11\u0E4C\u0E02\u0E2D\u0E07 Atlassian \u0E0B\u0E36\u0E48\u0E07\u0E41\u0E2D\u0E1B\u0E40\u0E2B\u0E25\u0E48\u0E32\u0E19\u0E35\u0E49\u0E2D\u0E32\u0E08\u0E40\u0E01\u0E47\u0E1A\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E42\u0E1B\u0E23\u0E44\u0E1F\u0E25\u0E4C\u0E02\u0E2D\u0E07\u0E1C\u0E39\u0E49\u0E43\u0E0A\u0E49",
    "focused-task-close-account.delete-account.overview.inline-dialog.data-apps.self": "\u0E04\u0E38\u0E13\u0E2B\u0E23\u0E37\u0E2D\u0E1C\u0E39\u0E49\u0E43\u0E0A\u0E49\u0E2D\u0E37\u0E48\u0E19\u0E2D\u0E32\u0E08\u0E44\u0E14\u0E49\u0E15\u0E34\u0E14\u0E15\u0E31\u0E49\u0E07\u0E41\u0E2D\u0E1B\u0E17\u0E35\u0E48\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E04\u0E38\u0E13\u0E2A\u0E21\u0E1A\u0E31\u0E15\u0E34\u0E15\u0E48\u0E32\u0E07 \u0E46 \u0E44\u0E1B\u0E22\u0E31\u0E07\u0E1C\u0E25\u0E34\u0E15\u0E20\u0E31\u0E13\u0E11\u0E4C\u0E02\u0E2D\u0E07 Atlassian \u0E0B\u0E36\u0E48\u0E07\u0E41\u0E2D\u0E1B\u0E40\u0E2B\u0E25\u0E48\u0E32\u0E19\u0E35\u0E49\u0E2D\u0E32\u0E08\u0E40\u0E01\u0E47\u0E1A\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E42\u0E1B\u0E23\u0E44\u0E1F\u0E25\u0E4C\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.li1.admin": "\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E40\u0E01\u0E35\u0E48\u0E22\u0E27\u0E01\u0E31\u0E1A\u0E01\u0E32\u0E23\u0E0B\u0E37\u0E49\u0E2D\u0E02\u0E32\u0E22 \u0E0B\u0E36\u0E48\u0E07\u0E40\u0E23\u0E32\u0E08\u0E33\u0E40\u0E1B\u0E47\u0E19\u0E15\u0E49\u0E2D\u0E07\u0E40\u0E01\u0E47\u0E1A\u0E44\u0E27\u0E49\u0E2A\u0E33\u0E2B\u0E23\u0E31\u0E1A\u0E01\u0E32\u0E23\u0E23\u0E32\u0E22\u0E07\u0E32\u0E19\u0E17\u0E32\u0E07\u0E01\u0E32\u0E23\u0E40\u0E07\u0E34\u0E19",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.li1.self": "\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E40\u0E01\u0E35\u0E48\u0E22\u0E27\u0E01\u0E31\u0E1A\u0E01\u0E32\u0E23\u0E0B\u0E37\u0E49\u0E2D\u0E02\u0E32\u0E22 \u0E0B\u0E36\u0E48\u0E07\u0E40\u0E23\u0E32\u0E08\u0E33\u0E40\u0E1B\u0E47\u0E19\u0E15\u0E49\u0E2D\u0E07\u0E40\u0E01\u0E47\u0E1A\u0E44\u0E27\u0E49\u0E2A\u0E33\u0E2B\u0E23\u0E31\u0E1A\u0E01\u0E32\u0E23\u0E23\u0E32\u0E22\u0E07\u0E32\u0E19\u0E17\u0E32\u0E07\u0E01\u0E32\u0E23\u0E40\u0E07\u0E34\u0E19",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.li2.admin": "\u0E1A\u0E31\u0E19\u0E17\u0E36\u0E01\u0E17\u0E35\u0E48\u0E41\u0E2A\u0E14\u0E07\u0E43\u0E2B\u0E49\u0E40\u0E2B\u0E47\u0E19\u0E27\u0E48\u0E32\u0E40\u0E23\u0E32\u0E44\u0E14\u0E49\u0E25\u0E1A\u0E1A\u0E31\u0E0D\u0E0A\u0E35\u0E02\u0E2D\u0E07\u0E1C\u0E39\u0E49\u0E2D\u0E37\u0E48\u0E19\u0E44\u0E1B \u0E0B\u0E36\u0E48\u0E07\u0E40\u0E23\u0E32\u0E2D\u0E32\u0E08\u0E08\u0E33\u0E40\u0E1B\u0E47\u0E19\u0E15\u0E49\u0E2D\u0E07\u0E43\u0E2B\u0E49\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E41\u0E01\u0E48\u0E1C\u0E39\u0E49\u0E04\u0E27\u0E1A\u0E04\u0E38\u0E21",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.li2.self": "\u0E1A\u0E31\u0E19\u0E17\u0E36\u0E01\u0E17\u0E35\u0E48\u0E41\u0E2A\u0E14\u0E07\u0E43\u0E2B\u0E49\u0E40\u0E2B\u0E47\u0E19\u0E27\u0E48\u0E32\u0E40\u0E23\u0E32\u0E44\u0E14\u0E49\u0E25\u0E1A\u0E1A\u0E31\u0E0D\u0E0A\u0E35\u0E02\u0E2D\u0E07\u0E1C\u0E39\u0E49\u0E2D\u0E37\u0E48\u0E19\u0E44\u0E1B \u0E0B\u0E36\u0E48\u0E07\u0E40\u0E23\u0E32\u0E2D\u0E32\u0E08\u0E08\u0E33\u0E40\u0E1B\u0E47\u0E19\u0E15\u0E49\u0E2D\u0E07\u0E43\u0E2B\u0E49\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E41\u0E01\u0E48\u0E1C\u0E39\u0E49\u0E04\u0E27\u0E1A\u0E04\u0E38\u0E21",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.li3.admin": "\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E17\u0E35\u0E48\u0E40\u0E1B\u0E47\u0E19\u0E2A\u0E48\u0E27\u0E19\u0E2B\u0E19\u0E36\u0E48\u0E07\u0E02\u0E2D\u0E07\u0E04\u0E14\u0E35\u0E04\u0E27\u0E32\u0E21\u0E17\u0E35\u0E48\u0E21\u0E35\u0E01\u0E32\u0E23\u0E1F\u0E49\u0E2D\u0E07\u0E23\u0E49\u0E2D\u0E07 \u0E0B\u0E36\u0E48\u0E07\u0E40\u0E23\u0E32\u0E08\u0E33\u0E40\u0E1B\u0E47\u0E19\u0E15\u0E49\u0E2D\u0E07\u0E40\u0E01\u0E47\u0E1A\u0E44\u0E27\u0E49\u0E15\u0E32\u0E21\u0E01\u0E0E\u0E2B\u0E21\u0E32\u0E22",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.li3.self": "\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E17\u0E35\u0E48\u0E40\u0E1B\u0E47\u0E19\u0E2A\u0E48\u0E27\u0E19\u0E2B\u0E19\u0E36\u0E48\u0E07\u0E02\u0E2D\u0E07\u0E04\u0E14\u0E35\u0E04\u0E27\u0E32\u0E21\u0E17\u0E35\u0E48\u0E21\u0E35\u0E01\u0E32\u0E23\u0E1F\u0E49\u0E2D\u0E07\u0E23\u0E49\u0E2D\u0E07 \u0E0B\u0E36\u0E48\u0E07\u0E40\u0E23\u0E32\u0E08\u0E33\u0E40\u0E1B\u0E47\u0E19\u0E15\u0E49\u0E2D\u0E07\u0E40\u0E01\u0E47\u0E1A\u0E44\u0E27\u0E49\u0E15\u0E32\u0E21\u0E01\u0E0E\u0E2B\u0E21\u0E32\u0E22",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.p1.admin": "\u0E40\u0E23\u0E32\u0E40\u0E01\u0E47\u0E1A\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E2A\u0E48\u0E27\u0E19\u0E1A\u0E38\u0E04\u0E04\u0E25\u0E44\u0E27\u0E49\u0E43\u0E19\u0E23\u0E30\u0E22\u0E30\u0E40\u0E27\u0E25\u0E32\u0E17\u0E35\u0E48\u0E08\u0E33\u0E01\u0E31\u0E14\u0E40\u0E21\u0E37\u0E48\u0E2D\u0E40\u0E23\u0E32\u0E21\u0E35\u0E18\u0E38\u0E23\u0E01\u0E34\u0E08\u0E17\u0E35\u0E48\u0E16\u0E39\u0E01\u0E15\u0E49\u0E2D\u0E07\u0E15\u0E32\u0E21\u0E01\u0E0E\u0E2B\u0E21\u0E32\u0E22\u0E2B\u0E23\u0E37\u0E2D\u0E21\u0E35\u0E08\u0E38\u0E14\u0E1B\u0E23\u0E30\u0E2A\u0E07\u0E04\u0E4C\u0E43\u0E19\u0E40\u0E0A\u0E34\u0E07\u0E01\u0E0E\u0E2B\u0E21\u0E32\u0E22 \u0E15\u0E31\u0E27\u0E2D\u0E22\u0E48\u0E32\u0E07\u0E40\u0E0A\u0E48\u0E19:",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.p1.self": "\u0E40\u0E23\u0E32\u0E40\u0E01\u0E47\u0E1A\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E2A\u0E48\u0E27\u0E19\u0E1A\u0E38\u0E04\u0E04\u0E25\u0E44\u0E27\u0E49\u0E43\u0E19\u0E23\u0E30\u0E22\u0E30\u0E40\u0E27\u0E25\u0E32\u0E17\u0E35\u0E48\u0E08\u0E33\u0E01\u0E31\u0E14\u0E40\u0E21\u0E37\u0E48\u0E2D\u0E40\u0E23\u0E32\u0E21\u0E35\u0E18\u0E38\u0E23\u0E01\u0E34\u0E08\u0E17\u0E35\u0E48\u0E16\u0E39\u0E01\u0E15\u0E49\u0E2D\u0E07\u0E15\u0E32\u0E21\u0E01\u0E0E\u0E2B\u0E21\u0E32\u0E22\u0E2B\u0E23\u0E37\u0E2D\u0E21\u0E35\u0E08\u0E38\u0E14\u0E1B\u0E23\u0E30\u0E2A\u0E07\u0E04\u0E4C\u0E43\u0E19\u0E40\u0E0A\u0E34\u0E07\u0E01\u0E0E\u0E2B\u0E21\u0E32\u0E22 \u0E15\u0E31\u0E27\u0E2D\u0E22\u0E48\u0E32\u0E07\u0E40\u0E0A\u0E48\u0E19:",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.p2.admin": "\u0E40\u0E23\u0E32\u0E44\u0E21\u0E48\u0E25\u0E1A\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E2A\u0E48\u0E27\u0E19\u0E1A\u0E38\u0E04\u0E04\u0E25\u0E43\u0E14 \u0E46 \u0E08\u0E32\u0E01\u0E40\u0E19\u0E37\u0E49\u0E2D\u0E2B\u0E32\u0E17\u0E35\u0E48\u0E1C\u0E39\u0E49\u0E43\u0E0A\u0E49\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E02\u0E36\u0E49\u0E19\u0E40\u0E2D\u0E07 \u0E40\u0E0A\u0E48\u0E19 \u0E0A\u0E37\u0E48\u0E2D\u0E2B\u0E23\u0E37\u0E2D\u0E17\u0E35\u0E48\u0E2D\u0E22\u0E39\u0E48\u0E2D\u0E35\u0E40\u0E21\u0E25\u0E17\u0E35\u0E48\u0E1C\u0E39\u0E49\u0E43\u0E0A\u0E49\u0E1E\u0E34\u0E21\u0E1E\u0E4C\u0E44\u0E27\u0E49\u0E43\u0E19\u0E2B\u0E19\u0E49\u0E32\u0E40\u0E1E\u0E08\u0E2B\u0E23\u0E37\u0E2D\u0E1B\u0E31\u0E0D\u0E2B\u0E32 \u0E1C\u0E39\u0E49\u0E14\u0E39\u0E41\u0E25\u0E1C\u0E25\u0E34\u0E15\u0E20\u0E31\u0E13\u0E11\u0E4C\u0E08\u0E33\u0E40\u0E1B\u0E47\u0E19\u0E15\u0E49\u0E2D\u0E07\u0E25\u0E1A\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E19\u0E31\u0E49\u0E19\u0E14\u0E49\u0E27\u0E22\u0E15\u0E19\u0E40\u0E2D\u0E07",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.p2.self": "\u0E40\u0E23\u0E32\u0E44\u0E21\u0E48\u0E25\u0E1A\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E2A\u0E48\u0E27\u0E19\u0E1A\u0E38\u0E04\u0E04\u0E25\u0E43\u0E14 \u0E46 \u0E08\u0E32\u0E01\u0E40\u0E19\u0E37\u0E49\u0E2D\u0E2B\u0E32\u0E17\u0E35\u0E48\u0E04\u0E38\u0E13\u0E2B\u0E23\u0E37\u0E2D\u0E1C\u0E39\u0E49\u0E43\u0E0A\u0E49\u0E2D\u0E37\u0E48\u0E19\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E02\u0E36\u0E49\u0E19\u0E40\u0E2D\u0E07 \u0E40\u0E0A\u0E48\u0E19 \u0E0A\u0E37\u0E48\u0E2D\u0E2B\u0E23\u0E37\u0E2D\u0E17\u0E35\u0E48\u0E2D\u0E22\u0E39\u0E48\u0E2D\u0E35\u0E40\u0E21\u0E25\u0E17\u0E35\u0E48\u0E04\u0E38\u0E13\u0E1E\u0E34\u0E21\u0E1E\u0E4C\u0E44\u0E27\u0E49\u0E43\u0E19\u0E2B\u0E19\u0E49\u0E32\u0E40\u0E1E\u0E08\u0E2B\u0E23\u0E37\u0E2D\u0E1B\u0E31\u0E0D\u0E2B\u0E32 \u0E1C\u0E39\u0E49\u0E14\u0E39\u0E41\u0E25\u0E1C\u0E25\u0E34\u0E15\u0E20\u0E31\u0E13\u0E11\u0E4C\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E08\u0E33\u0E40\u0E1B\u0E47\u0E19\u0E15\u0E49\u0E2D\u0E07\u0E25\u0E1A\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E19\u0E31\u0E49\u0E19\u0E14\u0E49\u0E27\u0E22\u0E15\u0E19\u0E40\u0E2D\u0E07",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.p3.admin": "\u0E1C\u0E39\u0E49\u0E43\u0E0A\u0E49\u0E21\u0E35\u0E2A\u0E34\u0E17\u0E18\u0E34\u0E4C\u0E2A\u0E48\u0E07\u0E04\u0E33\u0E23\u0E49\u0E2D\u0E07\u0E44\u0E1B\u0E22\u0E31\u0E07\u0E2B\u0E19\u0E48\u0E27\u0E22\u0E07\u0E32\u0E19\u0E17\u0E35\u0E48\u0E21\u0E35\u0E2B\u0E19\u0E49\u0E32\u0E17\u0E35\u0E48\u0E43\u0E19\u0E01\u0E32\u0E23\u0E01\u0E33\u0E01\u0E31\u0E1A\u0E14\u0E39\u0E41\u0E25\u0E43\u0E19\u0E1B\u0E23\u0E30\u0E40\u0E17\u0E28\u0E02\u0E2D\u0E07\u0E15\u0E19\u0E44\u0E14\u0E49",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.p3.self": "\u0E04\u0E38\u0E13\u0E21\u0E35\u0E2A\u0E34\u0E17\u0E18\u0E34\u0E4C\u0E2A\u0E48\u0E07\u0E04\u0E33\u0E23\u0E49\u0E2D\u0E07\u0E44\u0E1B\u0E22\u0E31\u0E07\u0E2B\u0E19\u0E48\u0E27\u0E22\u0E07\u0E32\u0E19\u0E17\u0E35\u0E48\u0E21\u0E35\u0E2B\u0E19\u0E49\u0E32\u0E17\u0E35\u0E48\u0E43\u0E19\u0E01\u0E32\u0E23\u0E01\u0E33\u0E01\u0E31\u0E1A\u0E14\u0E39\u0E41\u0E25\u0E43\u0E19\u0E1B\u0E23\u0E30\u0E40\u0E17\u0E28\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E44\u0E14\u0E49",
    "focused-task-close-account.delete-account.overview.paragraph.about-to-delete.admin": "\u0E40\u0E21\u0E37\u0E48\u0E2D\u0E04\u0E38\u0E13\u0E25\u0E1A\u0E1A\u0E31\u0E0D\u0E0A\u0E35:",
    "focused-task-close-account.delete-account.overview.paragraph.about-to-delete.self": "\u0E40\u0E21\u0E37\u0E48\u0E2D\u0E04\u0E38\u0E13\u0E25\u0E1A\u0E1A\u0E31\u0E0D\u0E0A\u0E35\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13:",
    "focused-task-close-account.delete-account.overview.paragraph.content-created.admin": "\u0E40\u0E19\u0E37\u0E49\u0E2D\u0E2B\u0E32\u0E17\u0E35\u0E48\u0E1C\u0E39\u0E49\u0E43\u0E0A\u0E49\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E02\u0E36\u0E49\u0E19\u0E08\u0E30\u0E22\u0E31\u0E07\u0E04\u0E07\u0E2D\u0E22\u0E39\u0E48\u0E43\u0E19\u0E1A\u0E23\u0E34\u0E01\u0E32\u0E23\u0E02\u0E2D\u0E07\u0E1A\u0E31\u0E0D\u0E0A\u0E35 Atlassian",
    "focused-task-close-account.delete-account.overview.paragraph.content-created.self": "\u0E40\u0E19\u0E37\u0E49\u0E2D\u0E2B\u0E32\u0E17\u0E35\u0E48\u0E04\u0E38\u0E13\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E02\u0E36\u0E49\u0E19\u0E08\u0E30\u0E22\u0E31\u0E07\u0E04\u0E07\u0E2D\u0E22\u0E39\u0E48\u0E43\u0E19\u0E1A\u0E23\u0E34\u0E01\u0E32\u0E23\u0E02\u0E2D\u0E07\u0E1A\u0E31\u0E0D\u0E0A\u0E35 Atlassian",
    "focused-task-close-account.delete-account.overview.paragraph.grace-period.admin": "\u0E2B\u0E25\u0E31\u0E07\u0E08\u0E32\u0E01\u0E1C\u0E48\u0E32\u0E19\u0E40\u0E27\u0E25\u0E32\u0E1C\u0E48\u0E2D\u0E19\u0E1C\u0E31\u0E19 14 \u0E27\u0E31\u0E19\u0E41\u0E25\u0E49\u0E27 \u0E04\u0E38\u0E13\u0E08\u0E30\u0E44\u0E21\u0E48\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E22\u0E01\u0E40\u0E25\u0E34\u0E01\u0E01\u0E32\u0E23\u0E25\u0E1A\u0E1A\u0E31\u0E0D\u0E0A\u0E35\u0E44\u0E14\u0E49",
    "focused-task-close-account.delete-account.overview.paragraph.list-of-apps-with-personal-data.admin": "\u0E40\u0E23\u0E32\u0E08\u0E30\u0E2A\u0E48\u0E07\u0E23\u0E32\u0E22\u0E0A\u0E37\u0E48\u0E2D\u0E41\u0E2D\u0E1B\u0E17\u0E35\u0E48\u0E2D\u0E32\u0E08\u0E08\u0E31\u0E14\u0E40\u0E01\u0E47\u0E1A\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E2A\u0E48\u0E27\u0E19\u0E1A\u0E38\u0E04\u0E04\u0E25\u0E02\u0E2D\u0E07\u0E1C\u0E39\u0E49\u0E43\u0E0A\u0E49\u0E44\u0E1B\u0E43\u0E2B\u0E49\u0E04\u0E38\u0E13\u0E17\u0E32\u0E07\u0E2D\u0E35\u0E40\u0E21\u0E25",
    "focused-task-close-account.delete-account.overview.paragraph.list-of-apps-with-personal-data.self": "\u0E40\u0E23\u0E32\u0E08\u0E30\u0E2A\u0E48\u0E07\u0E23\u0E32\u0E22\u0E0A\u0E37\u0E48\u0E2D\u0E41\u0E2D\u0E1B\u0E17\u0E35\u0E48\u0E2D\u0E32\u0E08\u0E08\u0E31\u0E14\u0E40\u0E01\u0E47\u0E1A\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E2A\u0E48\u0E27\u0E19\u0E1A\u0E38\u0E04\u0E04\u0E25\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E44\u0E1B\u0E43\u0E2B\u0E49\u0E04\u0E38\u0E13\u0E17\u0E32\u0E07\u0E2D\u0E35\u0E40\u0E21\u0E25",
    "focused-task-close-account.delete-account.overview.paragraph.loseAccess.admin": "{fullName} \u0E08\u0E30<b>\u0E40\u0E2A\u0E35\u0E22\u0E2A\u0E34\u0E17\u0E18\u0E34\u0E4C\u0E01\u0E32\u0E23\u0E40\u0E02\u0E49\u0E32\u0E16\u0E36\u0E07</b>\u0E1A\u0E23\u0E34\u0E01\u0E32\u0E23\u0E02\u0E2D\u0E07\u0E1A\u0E31\u0E0D\u0E0A\u0E35 Atlassian \u0E17\u0E31\u0E49\u0E07\u0E2B\u0E21\u0E14\u0E17\u0E31\u0E19\u0E17\u0E35 \u0E42\u0E14\u0E22\u0E1B\u0E31\u0E08\u0E08\u0E38\u0E1A\u0E31\u0E19 \u0E1C\u0E39\u0E49\u0E43\u0E0A\u0E49\u0E21\u0E35\u0E2A\u0E34\u0E17\u0E18\u0E34\u0E4C\u0E40\u0E02\u0E49\u0E32\u0E16\u0E36\u0E07:",
    "focused-task-close-account.delete-account.overview.paragraph.loseAccess.admin.noSites": "{fullName} \u0E08\u0E30<b>\u0E40\u0E2A\u0E35\u0E22\u0E2A\u0E34\u0E17\u0E18\u0E34\u0E4C\u0E01\u0E32\u0E23\u0E40\u0E02\u0E49\u0E32\u0E16\u0E36\u0E07</b>\u0E1A\u0E23\u0E34\u0E01\u0E32\u0E23\u0E02\u0E2D\u0E07\u0E1A\u0E31\u0E0D\u0E0A\u0E35 Atlassian \u0E17\u0E31\u0E49\u0E07\u0E2B\u0E21\u0E14\u0E17\u0E31\u0E19\u0E17\u0E35 \u0E42\u0E14\u0E22\u0E1B\u0E31\u0E08\u0E08\u0E38\u0E1A\u0E31\u0E19 \u0E1C\u0E39\u0E49\u0E43\u0E0A\u0E49\u0E44\u0E21\u0E48\u0E21\u0E35\u0E2A\u0E34\u0E17\u0E18\u0E34\u0E4C\u0E40\u0E02\u0E49\u0E32\u0E16\u0E36\u0E07\u0E1A\u0E23\u0E34\u0E01\u0E32\u0E23\u0E43\u0E14 \u0E46 \u0E22\u0E01\u0E40\u0E27\u0E49\u0E19\u0E1A\u0E23\u0E34\u0E01\u0E32\u0E23 \u0E40\u0E0A\u0E48\u0E19 \u0E0A\u0E38\u0E21\u0E0A\u0E19\u0E41\u0E25\u0E30 Marketplace",
    "focused-task-close-account.delete-account.overview.paragraph.loseAccess.footnote": "\u0E1A\u0E23\u0E34\u0E01\u0E32\u0E23\u0E1A\u0E31\u0E0D\u0E0A\u0E35 Atlassian \u0E2D\u0E37\u0E48\u0E19 \u0E46 \u0E40\u0E0A\u0E48\u0E19 \u0E0A\u0E38\u0E21\u0E0A\u0E19 Atlassian \u0E41\u0E25\u0E30 Marketplace",
    "focused-task-close-account.delete-account.overview.paragraph.loseAccess.self": "\u0E04\u0E38\u0E13\u0E08\u0E30<b>\u0E40\u0E2A\u0E35\u0E22\u0E2A\u0E34\u0E17\u0E18\u0E34\u0E4C\u0E01\u0E32\u0E23\u0E40\u0E02\u0E49\u0E32\u0E16\u0E36\u0E07</b> \u0E1A\u0E23\u0E34\u0E01\u0E32\u0E23\u0E02\u0E2D\u0E07\u0E1A\u0E31\u0E0D\u0E0A\u0E35 Atlassian \u0E17\u0E31\u0E49\u0E07\u0E2B\u0E21\u0E14\u0E17\u0E31\u0E19\u0E17\u0E35 \u0E42\u0E14\u0E22\u0E1B\u0E31\u0E08\u0E08\u0E38\u0E1A\u0E31\u0E19 \u0E04\u0E38\u0E13\u0E21\u0E35\u0E2A\u0E34\u0E17\u0E18\u0E34\u0E4C\u0E40\u0E02\u0E49\u0E32\u0E16\u0E36\u0E07:",
    "focused-task-close-account.delete-account.overview.paragraph.loseAccess.self.noSites": "\u0E04\u0E38\u0E13\u0E08\u0E30<b>\u0E40\u0E2A\u0E35\u0E22\u0E2A\u0E34\u0E17\u0E18\u0E34\u0E4C\u0E01\u0E32\u0E23\u0E40\u0E02\u0E49\u0E32\u0E16\u0E36\u0E07</b> \u0E1A\u0E23\u0E34\u0E01\u0E32\u0E23\u0E02\u0E2D\u0E07\u0E1A\u0E31\u0E0D\u0E0A\u0E35 Atlassian \u0E17\u0E31\u0E49\u0E07\u0E2B\u0E21\u0E14\u0E17\u0E31\u0E19\u0E17\u0E35 \u0E42\u0E14\u0E22\u0E1B\u0E31\u0E08\u0E08\u0E38\u0E1A\u0E31\u0E19 \u0E04\u0E38\u0E13\u0E44\u0E21\u0E48\u0E21\u0E35\u0E2A\u0E34\u0E17\u0E18\u0E34\u0E4C\u0E40\u0E02\u0E49\u0E32\u0E16\u0E36\u0E07\u0E1A\u0E23\u0E34\u0E01\u0E32\u0E23\u0E43\u0E14 \u0E46 \u0E22\u0E01\u0E40\u0E27\u0E49\u0E19\u0E1A\u0E23\u0E34\u0E01\u0E32\u0E23 \u0E40\u0E0A\u0E48\u0E19 \u0E0A\u0E38\u0E21\u0E0A\u0E19 \u0E41\u0E25\u0E30 Marketplace",
    "focused-task-close-account.delete-account.overview.paragraph.personal-data-will-be-deleted.admin": "\u0E40\u0E23\u0E32\u0E08\u0E30<b>\u0E25\u0E1A\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E2A\u0E48\u0E27\u0E19\u0E1A\u0E38\u0E04\u0E04\u0E25\u0E02\u0E2D\u0E07\u0E1C\u0E39\u0E49\u0E43\u0E0A\u0E49\u0E40\u0E2B\u0E25\u0E48\u0E32\u0E19\u0E31\u0E49\u0E19</b> \u0E40\u0E0A\u0E48\u0E19 \u0E0A\u0E37\u0E48\u0E2D \u0E19\u0E32\u0E21\u0E2A\u0E01\u0E38\u0E25 \u0E41\u0E25\u0E30\u0E17\u0E35\u0E48\u0E2D\u0E22\u0E39\u0E48\u0E2D\u0E35\u0E40\u0E21\u0E25\u0E02\u0E2D\u0E07\u0E1E\u0E27\u0E01\u0E40\u0E02\u0E32\u0E2D\u0E2D\u0E01\u0E08\u0E32\u0E01\u0E1A\u0E23\u0E34\u0E01\u0E32\u0E23\u0E1A\u0E31\u0E0D\u0E0A\u0E35 Atlassian \u0E20\u0E32\u0E22\u0E43\u0E19 30 \u0E27\u0E31\u0E19 \u0E22\u0E01\u0E40\u0E27\u0E49\u0E19\u0E43\u0E19\u0E1A\u0E32\u0E07\u0E01\u0E23\u0E13\u0E35\u0E17\u0E35\u0E48\u0E2D\u0E32\u0E08\u0E08\u0E33\u0E40\u0E1B\u0E47\u0E19\u0E15\u0E49\u0E2D\u0E07\u0E21\u0E35\u0E01\u0E32\u0E23\u0E40\u0E01\u0E47\u0E1A\u0E44\u0E27\u0E49\u0E2A\u0E33\u0E2B\u0E23\u0E31\u0E1A\u0E18\u0E38\u0E23\u0E01\u0E34\u0E08\u0E17\u0E35\u0E48\u0E16\u0E39\u0E01\u0E15\u0E49\u0E2D\u0E07\u0E15\u0E32\u0E21\u0E01\u0E0E\u0E2B\u0E21\u0E32\u0E22\u0E2B\u0E23\u0E37\u0E2D\u0E21\u0E35\u0E08\u0E38\u0E14\u0E1B\u0E23\u0E30\u0E2A\u0E07\u0E04\u0E4C\u0E43\u0E19\u0E40\u0E0A\u0E34\u0E07\u0E01\u0E0E\u0E2B\u0E21\u0E32\u0E22",
    "focused-task-close-account.delete-account.overview.paragraph.personal-data-will-be-deleted.self": "\u0E40\u0E23\u0E32\u0E08\u0E30<b>\u0E25\u0E1A\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E2A\u0E48\u0E27\u0E19\u0E1A\u0E38\u0E04\u0E04\u0E25\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13</b> \u0E40\u0E0A\u0E48\u0E19 \u0E0A\u0E37\u0E48\u0E2D\u0E08\u0E23\u0E34\u0E07\u0E41\u0E25\u0E30\u0E19\u0E32\u0E21\u0E2A\u0E01\u0E38\u0E25 \u0E41\u0E25\u0E30\u0E17\u0E35\u0E48\u0E2D\u0E22\u0E39\u0E48\u0E2D\u0E35\u0E40\u0E21\u0E25\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E2D\u0E2D\u0E01\u0E08\u0E32\u0E01\u0E1A\u0E23\u0E34\u0E01\u0E32\u0E23\u0E1A\u0E31\u0E0D\u0E0A\u0E35 Atlassian \u0E20\u0E32\u0E22\u0E43\u0E19 30 \u0E27\u0E31\u0E19 \u0E22\u0E01\u0E40\u0E27\u0E49\u0E19\u0E43\u0E19\u0E1A\u0E32\u0E07\u0E01\u0E23\u0E13\u0E35\u0E17\u0E35\u0E48\u0E2D\u0E32\u0E08\u0E08\u0E33\u0E40\u0E1B\u0E47\u0E19\u0E15\u0E49\u0E2D\u0E07\u0E21\u0E35\u0E01\u0E32\u0E23\u0E40\u0E01\u0E47\u0E1A\u0E44\u0E27\u0E49\u0E2A\u0E33\u0E2B\u0E23\u0E31\u0E1A\u0E18\u0E38\u0E23\u0E01\u0E34\u0E08\u0E17\u0E35\u0E48\u0E16\u0E39\u0E01\u0E15\u0E49\u0E2D\u0E07\u0E15\u0E32\u0E21\u0E01\u0E0E\u0E2B\u0E21\u0E32\u0E22\u0E2B\u0E23\u0E37\u0E2D\u0E21\u0E35\u0E08\u0E38\u0E14\u0E1B\u0E23\u0E30\u0E2A\u0E07\u0E04\u0E4C\u0E43\u0E19\u0E40\u0E0A\u0E34\u0E07\u0E01\u0E0E\u0E2B\u0E21\u0E32\u0E22",
    "focused-task-close-account.delete-account.overview.warning-section.body": "\u0E2B\u0E25\u0E31\u0E07\u0E08\u0E32\u0E01\u0E1C\u0E48\u0E32\u0E19\u0E40\u0E27\u0E25\u0E32\u0E1C\u0E48\u0E2D\u0E19\u0E1C\u0E31\u0E19 14 \u0E27\u0E31\u0E19\u0E41\u0E25\u0E49\u0E27 \u0E04\u0E38\u0E13\u0E08\u0E30\u0E44\u0E21\u0E48\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E22\u0E01\u0E40\u0E25\u0E34\u0E01\u0E01\u0E32\u0E23\u0E25\u0E1A\u0E1A\u0E31\u0E0D\u0E0A\u0E35\u0E44\u0E14\u0E49 \u0E2B\u0E32\u0E01\u0E04\u0E38\u0E13\u0E04\u0E34\u0E14\u0E27\u0E48\u0E32\u0E04\u0E38\u0E13\u0E2D\u0E32\u0E08\u0E15\u0E49\u0E2D\u0E07\u0E01\u0E32\u0E23\u0E1A\u0E31\u0E0D\u0E0A\u0E35\u0E43\u0E19\u0E20\u0E32\u0E22\u0E2B\u0E25\u0E31\u0E07 \u0E43\u0E2B\u0E49\u0E17\u0E33\u0E01\u0E32\u0E23\u0E22\u0E01\u0E40\u0E25\u0E34\u0E01\u0E01\u0E32\u0E23\u0E43\u0E0A\u0E49\u0E07\u0E32\u0E19\u0E41\u0E17\u0E19\u0E01\u0E32\u0E23\u0E25\u0E1A",
    "focused-task-close-account.delete-account.overview.warning-section.deactivated.body": "\u0E2B\u0E25\u0E31\u0E07\u0E08\u0E32\u0E01\u0E1C\u0E48\u0E32\u0E19\u0E40\u0E27\u0E25\u0E32\u0E1C\u0E48\u0E2D\u0E19\u0E1C\u0E31\u0E19 14 \u0E27\u0E31\u0E19\u0E41\u0E25\u0E49\u0E27 \u0E04\u0E38\u0E13\u0E08\u0E30\u0E44\u0E21\u0E48\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E22\u0E01\u0E40\u0E25\u0E34\u0E01\u0E01\u0E32\u0E23\u0E25\u0E1A\u0E1A\u0E31\u0E0D\u0E0A\u0E35\u0E44\u0E14\u0E49",
    "focused-task-close-account.learnMore": "\u0E40\u0E23\u0E35\u0E22\u0E19\u0E23\u0E39\u0E49\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E40\u0E15\u0E34\u0E21",
    "focused-task-close-account.next": "\u0E16\u0E31\u0E14\u0E44\u0E1B",
    "focused-task-close-account.previous": "\u0E01\u0E48\u0E2D\u0E19\u0E2B\u0E19\u0E49\u0E32"
};

});

parcelRegister("pjI5g", function(module, exports) {
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Turkish (Turkey)
var $04c19fea64caaaa4$export$2e2bcd8739ae039 = {
    "focused-task-close-account.cancel": "\u0130ptal",
    "focused-task-close-account.deactivate-account": "Hesab\u0131 devre d\u0131\u015F\u0131 b\u0131rak",
    "focused-task-close-account.deactivate-account.overview.first.line.admin": "\u015Eu kullan\u0131c\u0131n\u0131n hesab\u0131n\u0131 devre d\u0131\u015F\u0131 b\u0131rakmak \xfczeresiniz:",
    "focused-task-close-account.deactivate-account.overview.first.line.self": "\u015Eu kullan\u0131c\u0131n\u0131n hesab\u0131n\u0131 devre d\u0131\u015F\u0131 b\u0131rakmak \xfczeresiniz:",
    "focused-task-close-account.deactivate-account.overview.heading.admin": "Hesab\u0131 devre d\u0131\u015F\u0131 b\u0131rak",
    "focused-task-close-account.deactivate-account.overview.heading.self": "Hesab\u0131 devre d\u0131\u015F\u0131 b\u0131rakma",
    "focused-task-close-account.deactivate-account.overview.last.line.admin": "Hesab\u0131 diledi\u011Finiz zaman yeniden etkinle\u015Ftirebilirsiniz.",
    "focused-task-close-account.deactivate-account.overview.last.line.self": "Hesab\u0131 diledi\u011Finiz zaman yeniden etkinle\u015Ftirebilirsiniz.",
    "focused-task-close-account.deactivate-account.overview.paragraph.about-to-deactivate.admin": "Hesab\u0131 devre d\u0131\u015F\u0131 b\u0131rakt\u0131\u011F\u0131n\u0131zda:",
    "focused-task-close-account.deactivate-account.overview.paragraph.about-to-deactivate.self": "Hesab\u0131 devre d\u0131\u015F\u0131 b\u0131rakt\u0131\u011F\u0131n\u0131zda:",
    "focused-task-close-account.deactivate-account.overview.paragraph.billing.admin": "Bu hesaplar art\u0131k size faturaland\u0131r\u0131lmaz.",
    "focused-task-close-account.deactivate-account.overview.paragraph.billing.self": "Bu hesaplar art\u0131k size faturaland\u0131r\u0131lmaz.",
    "focused-task-close-account.deactivate-account.overview.paragraph.loseAccess.admin": "{fullName} adl\u0131 kullan\u0131c\u0131 t\xfcm Atlassian hesab\u0131 hizmetlerine <b>eri\u015Fimini hemen kaybeder</b>. \u015Eu anda \u015Fu hizmetlere eri\u015Febiliyor:",
    "focused-task-close-account.deactivate-account.overview.paragraph.loseAccess.admin.noSites": "{fullName} adl\u0131 kullan\u0131c\u0131 t\xfcm Atlassian hesab\u0131 hizmetlerine <b>eri\u015Fimini hemen kaybeder</b>. \u015Eu anda Community ve Marketplace gibi hizmetler d\u0131\u015F\u0131nda hi\xe7bir hizmete eri\u015Fimi yok.",
    "focused-task-close-account.deactivate-account.overview.paragraph.loseAccess.footnote": "Atlassian Toplulu\u011Fu ve Marketplace gibi di\u011Fer Atlassian hesab\u0131 hizmetleri.",
    "focused-task-close-account.deactivate-account.overview.paragraph.loseAccess.self": "T\xfcm Atlassian hesab\u0131 hizmetlerine <b>eri\u015Fiminizi hemen kaybedersiniz</b>. \u015Eu anda \u015Fu hizmetlere eri\u015Febiliyorsunuz:",
    "focused-task-close-account.deactivate-account.overview.paragraph.loseAccess.self.noSites": "T\xfcm Atlassian hesab\u0131 hizmetlerine <b>eri\u015Fiminizi hemen kaybedeceksiniz</b>. \u015Eu anda Community ve Marketplace gibi hizmetler d\u0131\u015F\u0131nda hi\xe7bir hizmete eri\u015Fiminiz yok.",
    "focused-task-close-account.deactivate-account.overview.paragraph.personal-data.admin": "Hesaplar\u0131n ad, soyad\u0131 ve e-posta adresi gibi ki\u015Fisel verileri ve olu\u015Fturduklar\u0131 i\xe7erikler, Atlassian hesab\u0131 hizmetlerinde kal\u0131r.",
    "focused-task-close-account.deactivate-account.overview.paragraph.personal-data.self": "Hesaplar\u0131n ad, soyad\u0131 ve e-posta adresi gibi ki\u015Fisel verileri ve olu\u015Fturduklar\u0131 i\xe7erikler, Atlassian hesab\u0131 hizmetlerinde kal\u0131r.",
    "focused-task-close-account.delete-account": "Hesab\u0131 sil",
    "focused-task-close-account.delete-account.content-preview.footnote.admin": 'Not: Bu anketi yan\u0131tlaman\u0131z t\xfcm kullan\u0131c\u0131lara daha iyi bir deneyim sunmam\u0131za yard\u0131mc\u0131 olur. Hesab\u0131n\u0131 sildi\u011Finizde bu kullan\u0131c\u0131y\u0131 "Eski kullan\u0131c\u0131" olarak g\xf6r\xfcrs\xfcn\xfcz.',
    "focused-task-close-account.delete-account.content-preview.footnote.self": 'Not: Bu anketi yan\u0131tlaman\u0131z, hesaplar\u0131n\u0131 silenler de dahil olmak \xfczere t\xfcm kullan\u0131c\u0131lara daha iyi bir deneyim sunmam\u0131za yard\u0131mc\u0131 olur. Hesab\u0131n\u0131z\u0131 sildi\u011Finizde "Eski kullan\u0131c\u0131" olarak g\xf6r\xfcn\xfcrs\xfcn\xfcz.',
    "focused-task-close-account.delete-account.content-preview.formerUser": "Eski kullan\u0131c\u0131",
    "focused-task-close-account.delete-account.content-preview.heading.admin": "Hesab\u0131 silinen kullan\u0131c\u0131n\u0131n nas\u0131l g\xf6r\xfcnmesini tercih edersiniz?",
    "focused-task-close-account.delete-account.content-preview.heading.self": "Silinen hesab\u0131n\u0131z\u0131n nas\u0131l g\xf6r\xfcnmesini tercih edersiniz?",
    "focused-task-close-account.delete-account.content-preview.line.survey.admin": "Tercih imkan\u0131n\u0131z olsa di\u011Fer kullan\u0131c\u0131lar\u0131n hesab\u0131 silinen kullan\u0131c\u0131y\u0131 nas\u0131l g\xf6rmesini isterdiniz?",
    "focused-task-close-account.delete-account.content-preview.line.survey.self": "Tercih imkan\u0131n\u0131z olsa di\u011Fer kullan\u0131c\u0131lar\u0131n silinen hesab\u0131n\u0131z\u0131 nas\u0131l g\xf6rmesini isterdiniz?",
    "focused-task-close-account.delete-account.content-preview.paragraph.survey.admin": 'Kullan\u0131c\u0131n\u0131n hesab\u0131 silindikten sonra di\u011Fer kullan\u0131c\u0131lar bu hesab\u0131 "Eski kullan\u0131c\u0131" olarak g\xf6r\xfcr. L\xfctfen biraz vaktinizi ay\u0131r\u0131p anket sorumuzu yan\u0131tlay\u0131n.',
    "focused-task-close-account.delete-account.content-preview.paragraph.survey.self": 'Hesab\u0131n\u0131z silindikten sonra di\u011Fer kullan\u0131c\u0131lar hesab\u0131n\u0131z\u0131 "Eski kullan\u0131c\u0131" olarak g\xf6r\xfcr. L\xfctfen biraz vaktinizi ay\u0131r\u0131p anket sorumuzu yan\u0131tlay\u0131n.',
    "focused-task-close-account.delete-account.drop-down-collapse-button": "Daha az g\xf6ster",
    "focused-task-close-account.delete-account.drop-down-expand-button": "{num} adet daha",
    "focused-task-close-account.delete-account.overview.first.line.admin": "\u015Eu kullan\u0131c\u0131n\u0131n hesab\u0131n\u0131 silmek \xfczeresiniz:",
    "focused-task-close-account.delete-account.overview.first.line.self": "Hesab\u0131n\u0131z\u0131 silmek \xfczeresiniz:",
    "focused-task-close-account.delete-account.overview.heading.admin": "Hesab\u0131 silme",
    "focused-task-close-account.delete-account.overview.heading.self": "Hesab\u0131n\u0131z\u0131 silme",
    "focused-task-close-account.delete-account.overview.inline-dialog.content-created.admin": "\xd6rnek olarak kullan\u0131c\u0131n\u0131n \xfcr\xfcnlerde olu\u015Fturdu\u011Fu sayfalar, konular ve yorumlar verilebilir.",
    "focused-task-close-account.delete-account.overview.inline-dialog.content-created.self": "\xd6rnek olarak \xfcr\xfcnlerde olu\u015Fturdu\u011Funuz sayfalar, konular ve yorumlar verilebilir.",
    "focused-task-close-account.delete-account.overview.inline-dialog.data-apps.admin": "Siz veya di\u011Fer kullan\u0131c\u0131lar, Atlassian \xfcr\xfcnlerine \xf6zellik ekleyen uygulamalar y\xfcklemi\u015F olabilirsiniz. Bu uygulamalar kullan\u0131c\u0131n\u0131n profil bilgilerini depolam\u0131\u015F olabilir.",
    "focused-task-close-account.delete-account.overview.inline-dialog.data-apps.self": "Siz veya di\u011Fer kullan\u0131c\u0131lar, Atlassian \xfcr\xfcnlerine \xf6zellik ekleyen uygulamalar y\xfcklemi\u015F olabilirsiniz. Bu uygulamalar profil bilgilerinizi depolam\u0131\u015F olabilir.",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.li1.admin": "Sat\u0131n al\u0131mlarla ilgili, finansal raporlama i\xe7in saklamam\u0131z gereken bilgiler.",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.li1.self": "Sat\u0131n al\u0131mlarla ilgili, finansal raporlama i\xe7in saklamam\u0131z gereken bilgiler.",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.li2.admin": "Bir kullan\u0131c\u0131n\u0131n hesab\u0131n\u0131 sildi\u011Fimizi g\xf6steren ve d\xfczenleyicilere sa\u011Flamak zorunda olabilece\u011Fimiz kay\u0131tlar.",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.li2.self": "Bir kullan\u0131c\u0131n\u0131n hesab\u0131n\u0131 sildi\u011Fimizi g\xf6steren ve d\xfczenleyicilere sa\u011Flamak zorunda olabilece\u011Fimiz kay\u0131tlar.",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.li3.admin": "Devam eden bir yarg\u0131lama s\xfcrecine ait ve yasalar gere\u011Fi saklamam\u0131z gereken veriler.",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.li3.self": "Devam eden bir yarg\u0131lama s\xfcrecine ait ve yasalar gere\u011Fi saklamam\u0131z gereken veriler.",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.p1.admin": "\u0130\u015Fle ilgili veya hukuki me\u015Fru ama\xe7lar\u0131m\u0131z do\u011Frultusunda ki\u015Fisel verileri s\u0131n\u0131rl\u0131 bir s\xfcre i\xe7in saklar\u0131z. Buna \xf6rnek olarak \u015Funlar verilebilir:",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.p1.self": "\u0130\u015Fle ilgili veya hukuki me\u015Fru ama\xe7lar\u0131m\u0131z do\u011Frultusunda ki\u015Fisel verileri s\u0131n\u0131rl\u0131 bir s\xfcre i\xe7in saklar\u0131z. Buna \xf6rnek olarak \u015Funlar verilebilir:",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.p2.admin": "Kullan\u0131c\u0131lar taraf\u0131ndan olu\u015Fturulan i\xe7eriklerde bulunan, bir sayfaya veya konuya girilmi\u015F adlar veya e-posta adresleri gibi ki\u015Fisel verileri silmeyiz. \xdcr\xfcn y\xf6neticilerinin bu verileri manuel olarak silmesi gerekir.",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.p2.self": "Sizin olu\u015Fturdu\u011Funuz veya di\u011Fer ki\u015Filer taraf\u0131ndan olu\u015Fturulan i\xe7eriklerde bulunan, bir sayfaya veya konuya girilmi\u015F adlar ve e-posta adresleri gibi ki\u015Fisel verileri silmeyiz. \xdcr\xfcn y\xf6neticilerinizin bu verileri manuel olarak silmesi gerekir.",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.p3.admin": "Kullan\u0131c\u0131lar dilerlerse bulunduklar\u0131 \xfclkedeki denetleyici kuruma \u015Fikayetlerini g\xf6nderebilir.",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.p3.self": "\u0130sterseniz, bulundu\u011Funuz \xfclkedeki denetleyici kuruma \u015Fikayette bulunabilirsiniz.",
    "focused-task-close-account.delete-account.overview.paragraph.about-to-delete.admin": "Hesab\u0131 sildi\u011Finizde:",
    "focused-task-close-account.delete-account.overview.paragraph.about-to-delete.self": "Hesab\u0131n\u0131z\u0131 sildi\u011Finizde:",
    "focused-task-close-account.delete-account.overview.paragraph.content-created.admin": "Kullan\u0131c\u0131n\u0131n olu\u015Fturdu\u011Fu i\xe7erikler Atlassian hesab\u0131 hizmetlerinden silinmez.",
    "focused-task-close-account.delete-account.overview.paragraph.content-created.self": "Olu\u015Fturdu\u011Funuz i\xe7erikler Atlassian hesab\u0131 hizmetlerinden silinmez.",
    "focused-task-close-account.delete-account.overview.paragraph.grace-period.admin": "14 g\xfcnl\xfck m\xfchlet sona erdikten sonra hesab\u0131n silinmesini iptal edemezsiniz.",
    "focused-task-close-account.delete-account.overview.paragraph.list-of-apps-with-personal-data.admin": "Kullan\u0131c\u0131n\u0131n ki\u015Fisel verilerini depolam\u0131\u015F olabilecek uygulamalar\u0131n listesini size e-posta ile g\xf6nderece\u011Fiz.",
    "focused-task-close-account.delete-account.overview.paragraph.list-of-apps-with-personal-data.self": "Ki\u015Fisel verilerinizi depolam\u0131\u015F olabilecek uygulamalar\u0131n listesini size e-posta ile g\xf6ndeririz.",
    "focused-task-close-account.delete-account.overview.paragraph.loseAccess.admin": "{fullName} adl\u0131 kullan\u0131c\u0131 t\xfcm Atlassian hesab\u0131 hizmetlerine <b>eri\u015Fimini hemen kaybeder</b>. \u015Eu anda \u015Fu hizmetlere eri\u015Febiliyor:",
    "focused-task-close-account.delete-account.overview.paragraph.loseAccess.admin.noSites": "{fullName} adl\u0131 kullan\u0131c\u0131 t\xfcm Atlassian hesab\u0131 hizmetlerine <b>eri\u015Fimini hemen kaybeder</b>. \u015Eu anda Community ve Marketplace gibi hizmetler d\u0131\u015F\u0131nda hi\xe7bir hizmete eri\u015Fimi yok.",
    "focused-task-close-account.delete-account.overview.paragraph.loseAccess.footnote": "Atlassian Toplulu\u011Fu ve Marketplace gibi di\u011Fer Atlassian hesab\u0131 hizmetleri.",
    "focused-task-close-account.delete-account.overview.paragraph.loseAccess.self": "T\xfcm Atlassian hesab\u0131 hizmetlerine <b>eri\u015Fiminizi hemen kaybedersiniz</b>. \u015Eu anda \u015Fu hizmetlere eri\u015Febiliyorsunuz:",
    "focused-task-close-account.delete-account.overview.paragraph.loseAccess.self.noSites": "T\xfcm Atlassian hesab\u0131 hizmetlerine <b>eri\u015Fiminizi hemen kaybedeceksiniz</b>. \u015Eu anda Community ve Marketplace gibi hizmetler d\u0131\u015F\u0131nda hi\xe7bir hizmete eri\u015Fiminiz yok.",
    "focused-task-close-account.delete-account.overview.paragraph.personal-data-will-be-deleted.admin": "\u0130\u015Fle ilgili veya hukuki me\u015Fru ama\xe7lar\u0131m\u0131z do\u011Frultusunda saklamam\u0131z gereken baz\u0131 durumlar d\u0131\u015F\u0131nda, kullan\u0131c\u0131n\u0131n ad\u0131 ve soyad\u0131 ile e-posta adresi gibi ki\u015Fisel verilerini 30 g\xfcn i\xe7inde Atlassian hesab\u0131 hizmetlerinden <b>sileriz</b>.",
    "focused-task-close-account.delete-account.overview.paragraph.personal-data-will-be-deleted.self": "\u0130\u015Fle ilgili veya hukuki me\u015Fru ama\xe7lar\u0131m\u0131z do\u011Frultusunda saklamam\u0131z gereken baz\u0131 durumlar d\u0131\u015F\u0131nda, ad\u0131n\u0131z veya soyad\u0131n\u0131z ile e-posta adresiniz gibi ki\u015Fisel verilerinizi 30 g\xfcn i\xe7inde Atlassian hesab\u0131 hizmetlerinden <b>sileriz</b>.",
    "focused-task-close-account.delete-account.overview.warning-section.body": "14 g\xfcnl\xfck m\xfchlet sona erdikten sonra hesab\u0131n silinmesini iptal edemezsiniz. \u0130leride bu hesab\u0131 kullanman\u0131z gerekebilece\u011Fini d\xfc\u015F\xfcn\xfcyorsan\u0131z hesab\u0131 silmek yerine devre d\u0131\u015F\u0131 b\u0131rak\u0131n.",
    "focused-task-close-account.delete-account.overview.warning-section.deactivated.body": "14 g\xfcnl\xfck m\xfchlet sona erdikten sonra hesab\u0131n silinmesini iptal edemezsiniz.",
    "focused-task-close-account.learnMore": "Daha fazla bilgi edinin",
    "focused-task-close-account.next": "\u0130leri",
    "focused-task-close-account.previous": "Geri"
};

});

parcelRegister("fiFad", function(module, exports) {
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Ukrainian (Ukraine)
var $b23877bb749e31fd$export$2e2bcd8739ae039 = {
    "focused-task-close-account.cancel": "\u0421\u043A\u0430\u0441\u0443\u0432\u0430\u0442\u0438",
    "focused-task-close-account.deactivate-account": "\u0414\u0435\u0430\u043A\u0442\u0438\u0432\u0443\u0432\u0430\u0442\u0438 \u043E\u0431\u043B\u0456\u043A\u043E\u0432\u0438\u0439 \u0437\u0430\u043F\u0438\u0441",
    "focused-task-close-account.deactivate-account.overview.first.line.admin": "\u0411\u0443\u0434\u0435 \u0434\u0435\u0430\u043A\u0442\u0438\u0432\u043E\u0432\u0430\u043D\u043E \u043E\u0431\u043B\u0456\u043A\u043E\u0432\u0438\u0439 \u0437\u0430\u043F\u0438\u0441 \u0442\u0430\u043A\u043E\u0433\u043E \u043A\u043E\u0440\u0438\u0441\u0442\u0443\u0432\u0430\u0447\u0430:",
    "focused-task-close-account.deactivate-account.overview.first.line.self": "\u0411\u0443\u0434\u0435 \u0434\u0435\u0430\u043A\u0442\u0438\u0432\u043E\u0432\u0430\u043D\u043E \u043E\u0431\u043B\u0456\u043A\u043E\u0432\u0438\u0439 \u0437\u0430\u043F\u0438\u0441 \u0442\u0430\u043A\u043E\u0433\u043E \u043A\u043E\u0440\u0438\u0441\u0442\u0443\u0432\u0430\u0447\u0430:",
    "focused-task-close-account.deactivate-account.overview.heading.admin": "\u0414\u0435\u0430\u043A\u0442\u0438\u0432\u0430\u0446\u0456\u044F \u043E\u0431\u043B\u0456\u043A\u043E\u0432\u043E\u0433\u043E \u0437\u0430\u043F\u0438\u0441\u0443",
    "focused-task-close-account.deactivate-account.overview.heading.self": "\u0414\u0435\u0430\u043A\u0442\u0438\u0432\u0430\u0446\u0456\u044F \u043E\u0431\u043B\u0456\u043A\u043E\u0432\u043E\u0433\u043E \u0437\u0430\u043F\u0438\u0441\u0443",
    "focused-task-close-account.deactivate-account.overview.last.line.admin": "\u041E\u0431\u043B\u0456\u043A\u043E\u0432\u0438\u0439 \u0437\u0430\u043F\u0438\u0441 \u043C\u043E\u0436\u043D\u0430 \u0431\u0443\u0434\u0435 \u043F\u043E\u0432\u0442\u043E\u0440\u043D\u043E \u0430\u043A\u0442\u0438\u0432\u0443\u0432\u0430\u0442\u0438 \u0432 \u0431\u0443\u0434\u044C-\u044F\u043A\u0438\u0439 \u0447\u0430\u0441.",
    "focused-task-close-account.deactivate-account.overview.last.line.self": "\u041E\u0431\u043B\u0456\u043A\u043E\u0432\u0438\u0439 \u0437\u0430\u043F\u0438\u0441 \u043C\u043E\u0436\u043D\u0430 \u0431\u0443\u0434\u0435 \u043F\u043E\u0432\u0442\u043E\u0440\u043D\u043E \u0430\u043A\u0442\u0438\u0432\u0443\u0432\u0430\u0442\u0438 \u0432 \u0431\u0443\u0434\u044C-\u044F\u043A\u0438\u0439 \u0447\u0430\u0441.",
    "focused-task-close-account.deactivate-account.overview.paragraph.about-to-deactivate.admin": "\u0414\u0430\u043B\u0456 \u043E\u043F\u0438\u0441\u0430\u043D\u043E \u043D\u0430\u0441\u043B\u0456\u0434\u043A\u0438 \u0434\u0435\u0430\u043A\u0442\u0438\u0432\u0430\u0446\u0456\u0457 \u0446\u044C\u043E\u0433\u043E \u043E\u0431\u043B\u0456\u043A\u043E\u0432\u043E\u0433\u043E \u0437\u0430\u043F\u0438\u0441\u0443.",
    "focused-task-close-account.deactivate-account.overview.paragraph.about-to-deactivate.self": "\u0414\u0430\u043B\u0456 \u043E\u043F\u0438\u0441\u0430\u043D\u043E \u043D\u0430\u0441\u043B\u0456\u0434\u043A\u0438 \u0434\u0435\u0430\u043A\u0442\u0438\u0432\u0430\u0446\u0456\u0457 \u0446\u044C\u043E\u0433\u043E \u043E\u0431\u043B\u0456\u043A\u043E\u0432\u043E\u0433\u043E \u0437\u0430\u043F\u0438\u0441\u0443.",
    "focused-task-close-account.deactivate-account.overview.paragraph.billing.admin": "\u0420\u0430\u0445\u0443\u043D\u043E\u043A \u0437\u0430 \u043D\u0438\u0445 \u043D\u0435 \u0432\u0438\u0441\u0442\u0430\u0432\u043B\u044F\u0442\u0438\u043C\u0435\u0442\u044C\u0441\u044F.",
    "focused-task-close-account.deactivate-account.overview.paragraph.billing.self": "\u0420\u0430\u0445\u0443\u043D\u043E\u043A \u0437\u0430 \u043D\u0438\u0445 \u043D\u0435 \u0432\u0438\u0441\u0442\u0430\u0432\u043B\u044F\u0442\u0438\u043C\u0435\u0442\u044C\u0441\u044F.",
    "focused-task-close-account.deactivate-account.overview.paragraph.loseAccess.admin": "{fullName} <b>\u0432\u0456\u0434\u0440\u0430\u0437\u0443 \u0432\u0442\u0440\u0430\u0442\u0438\u0442\u044C \u0434\u043E\u0441\u0442\u0443\u043F</b> \u0434\u043E \u0432\u0441\u0456\u0445 \u0441\u043B\u0443\u0436\u0431 \u043E\u0431\u043B\u0456\u043A\u043E\u0432\u043E\u0433\u043E \u0437\u0430\u043F\u0438\u0441\u0443 Atlassian. \u041D\u0430\u0440\u0430\u0437\u0456 \u0446\u0435\u0439 \u043A\u043E\u0440\u0438\u0441\u0442\u0443\u0432\u0430\u0447 \u043C\u0430\u0454 \u0434\u043E\u0441\u0442\u0443\u043F \u0434\u043E \u0442\u0430\u043A\u0438\u0445 \u0441\u043B\u0443\u0436\u0431:",
    "focused-task-close-account.deactivate-account.overview.paragraph.loseAccess.admin.noSites": "{fullName} <b>\u0432\u0456\u0434\u0440\u0430\u0437\u0443 \u0432\u0442\u0440\u0430\u0442\u0438\u0442\u044C \u0434\u043E\u0441\u0442\u0443\u043F</b> \u0434\u043E \u0432\u0441\u0456\u0445 \u0441\u043B\u0443\u0436\u0431 \u043E\u0431\u043B\u0456\u043A\u043E\u0432\u043E\u0433\u043E \u0437\u0430\u043F\u0438\u0441\u0443 Atlassian. \u041D\u0430\u0440\u0430\u0437\u0456 \u0446\u0435\u0439 \u043A\u043E\u0440\u0438\u0441\u0442\u0443\u0432\u0430\u0447 \u043D\u0435 \u043C\u0430\u0454 \u0434\u043E\u0441\u0442\u0443\u043F\u0443 \u0434\u043E \u0436\u043E\u0434\u043D\u0438\u0445 \u0441\u043B\u0443\u0436\u0431, \u043E\u043A\u0440\u0456\u043C \u0421\u043F\u0456\u043B\u044C\u043D\u043E\u0442\u0438 \u0442\u0430 Marketplace.",
    "focused-task-close-account.deactivate-account.overview.paragraph.loseAccess.footnote": "\u0406\u043D\u0448\u0456 \u0441\u043B\u0443\u0436\u0431\u0438 \u043E\u0431\u043B\u0456\u043A\u043E\u0432\u043E\u0433\u043E \u0437\u0430\u043F\u0438\u0441\u0443 Atlassian, \u044F\u043A-\u043E\u0442 \u0421\u043F\u0456\u043B\u044C\u043D\u043E\u0442\u0430 Atlassian \u0456 Marketplace.",
    "focused-task-close-account.deactivate-account.overview.paragraph.loseAccess.self": "\u0412\u0438 <b>\u0432\u0456\u0434\u0440\u0430\u0437\u0443 \u0432\u0442\u0440\u0430\u0442\u0438\u0442\u0435 \u0434\u043E\u0441\u0442\u0443\u043F</b> \u0434\u043E \u0432\u0441\u0456\u0445 \u0441\u043B\u0443\u0436\u0431 \u043E\u0431\u043B\u0456\u043A\u043E\u0432\u043E\u0433\u043E \u0437\u0430\u043F\u0438\u0441\u0443 Atlassian. \u041D\u0430\u0440\u0430\u0437\u0456 \u0432\u0438 \u043C\u0430\u0454\u0442\u0435 \u0434\u043E\u0441\u0442\u0443\u043F \u0434\u043E \u0442\u0430\u043A\u0438\u0445 \u0441\u043B\u0443\u0436\u0431:",
    "focused-task-close-account.deactivate-account.overview.paragraph.loseAccess.self.noSites": "\u0412\u0438 <b>\u0432\u0456\u0434\u0440\u0430\u0437\u0443 \u0432\u0442\u0440\u0430\u0442\u0438\u0442\u0435 \u0434\u043E\u0441\u0442\u0443\u043F</b> \u0434\u043E \u0432\u0441\u0456\u0445 \u0441\u043B\u0443\u0436\u0431 \u043E\u0431\u043B\u0456\u043A\u043E\u0432\u043E\u0433\u043E \u0437\u0430\u043F\u0438\u0441\u0443 Atlassian. \u041D\u0430\u0440\u0430\u0437\u0456 \u0446\u0435\u0439 \u0432\u0438 \u043D\u0435 \u043C\u0430\u0454\u0442\u0435 \u0434\u043E\u0441\u0442\u0443\u043F\u0443 \u0434\u043E \u0436\u043E\u0434\u043D\u0438\u0445 \u0441\u043B\u0443\u0436\u0431, \u043E\u043A\u0440\u0456\u043C \u0421\u043F\u0456\u043B\u044C\u043D\u043E\u0442\u0438 \u0442\u0430 Marketplace.",
    "focused-task-close-account.deactivate-account.overview.paragraph.personal-data.admin": "\u041E\u0441\u043E\u0431\u0438\u0441\u0442\u0456 \u0434\u0430\u043D\u0456 \u043A\u043E\u0440\u0438\u0441\u0442\u0443\u0432\u0430\u0447\u0430, \u0442\u0430\u043A\u0456 \u044F\u043A \u043F\u043E\u0432\u043D\u0435 \u0456\u043C\u2019\u044F \u0442\u0430 \u0430\u0434\u0440\u0435\u0441\u0430 \u0435\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u043E\u0457 \u043F\u043E\u0448\u0442\u0438, \u0430 \u0442\u0430\u043A\u043E\u0436 \u0441\u0442\u0432\u043E\u0440\u0435\u043D\u0438\u0439 \u043A\u043E\u043D\u0442\u0435\u043D\u0442 \u0437\u0431\u0435\u0440\u0456\u0433\u0430\u0442\u0438\u043C\u0443\u0442\u044C\u0441\u044F \u0432 \u0441\u043B\u0443\u0436\u0431\u0430\u0445 \u043E\u0431\u043B\u0456\u043A\u043E\u0432\u0438\u0445 \u0437\u0430\u043F\u0438\u0441\u0456\u0432 Atlassian.",
    "focused-task-close-account.deactivate-account.overview.paragraph.personal-data.self": "\u041E\u0441\u043E\u0431\u0438\u0441\u0442\u0456 \u0434\u0430\u043D\u0456 \u043A\u043E\u0440\u0438\u0441\u0442\u0443\u0432\u0430\u0447\u0430, \u0442\u0430\u043A\u0456 \u044F\u043A \u043F\u043E\u0432\u043D\u0435 \u0456\u043C\u2019\u044F \u0442\u0430 \u0430\u0434\u0440\u0435\u0441\u0430 \u0435\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u043E\u0457 \u043F\u043E\u0448\u0442\u0438, \u0430 \u0442\u0430\u043A\u043E\u0436 \u0441\u0442\u0432\u043E\u0440\u0435\u043D\u0438\u0439 \u043A\u043E\u043D\u0442\u0435\u043D\u0442 \u0437\u0431\u0435\u0440\u0456\u0433\u0430\u0442\u0438\u043C\u0443\u0442\u044C\u0441\u044F \u0432 \u0441\u043B\u0443\u0436\u0431\u0430\u0445 \u043E\u0431\u043B\u0456\u043A\u043E\u0432\u0438\u0445 \u0437\u0430\u043F\u0438\u0441\u0456\u0432 Atlassian.",
    "focused-task-close-account.delete-account": "\u0412\u0438\u0434\u0430\u043B\u0438\u0442\u0438 \u043E\u0431\u043B\u0456\u043A\u043E\u0432\u0438\u0439 \u0437\u0430\u043F\u0438\u0441",
    "focused-task-close-account.delete-account.content-preview.footnote.admin": "\u041F\u0440\u0438\u043C\u0456\u0442\u043A\u0430. \u0412\u0456\u0434\u043F\u043E\u0432\u0456\u0434\u0456 \u0432 \u0446\u044C\u043E\u043C\u0443 \u043E\u043F\u0438\u0442\u0443\u0432\u0430\u043D\u043D\u0456 \u0434\u043E\u043F\u043E\u043C\u043E\u0436\u0443\u0442\u044C \u043D\u0430\u043C \u043A\u0440\u0430\u0449\u0435 \u043E\u0431\u0441\u043B\u0443\u0433\u043E\u0432\u0443\u0432\u0430\u0442\u0438 \u0432\u0441\u0456\u0445 \u043A\u043E\u0440\u0438\u0441\u0442\u0443\u0432\u0430\u0447\u0456\u0432. \u041A\u043E\u0440\u0438\u0441\u0442\u0443\u0432\u0430\u0447 \u0456 \u043D\u0430\u0434\u0430\u043B\u0456 \u0432\u0456\u0434\u043E\u0431\u0440\u0430\u0436\u0430\u0442\u0438\u043C\u0435\u0442\u044C\u0441\u044F \u044F\u043A \xab\u041A\u043E\u043B\u0438\u0448\u043D\u0456\u0439 \u043A\u043E\u0440\u0438\u0441\u0442\u0443\u0432\u0430\u0447\xbb \u043F\u0456\u0441\u043B\u044F \u0432\u0438\u0434\u0430\u043B\u0435\u043D\u043D\u044F \u0439\u043E\u0433\u043E \u043E\u0431\u043B\u0456\u043A\u043E\u0432\u043E\u0433\u043E \u0437\u0430\u043F\u0438\u0441\u0443.",
    "focused-task-close-account.delete-account.content-preview.footnote.self": "\u041F\u0440\u0438\u043C\u0456\u0442\u043A\u0430. \u0412\u0456\u0434\u043F\u043E\u0432\u0456\u0434\u0456 \u0432 \u0446\u044C\u043E\u043C\u0443 \u043E\u043F\u0438\u0442\u0443\u0432\u0430\u043D\u043D\u0456 \u0434\u043E\u043F\u043E\u043C\u043E\u0436\u0443\u0442\u044C \u043D\u0430\u043C \u043A\u0440\u0430\u0449\u0435 \u043E\u0431\u0441\u043B\u0443\u0433\u043E\u0432\u0443\u0432\u0430\u0442\u0438 \u0432\u0441\u0456\u0445 \u043A\u043E\u0440\u0438\u0441\u0442\u0443\u0432\u0430\u0447\u0456\u0432, \u0437\u043E\u043A\u0440\u0435\u043C\u0430 \u0439 \u0442\u0438\u0445, \u0449\u043E \u0432\u0438\u0434\u0430\u043B\u044F\u044E\u0442\u044C \u0441\u0432\u043E\u0457 \u043E\u0431\u043B\u0456\u043A\u043E\u0432\u0456 \u0437\u0430\u043F\u0438\u0441\u0438. \u041F\u0456\u0441\u043B\u044F \u0432\u0438\u0434\u0430\u043B\u0435\u043D\u043D\u044F \u043E\u0431\u043B\u0456\u043A\u043E\u0432\u043E\u0433\u043E \u0437\u0430\u043F\u0438\u0441\u0443 \u0432\u0438 \u0439 \u043D\u0430\u0434\u0430\u043B\u0456 \u0432\u0456\u0434\u043E\u0431\u0440\u0430\u0436\u0430\u0442\u0438\u043C\u0435\u0442\u0435\u0441\u044F \u044F\u043A \xab\u041A\u043E\u043B\u0438\u0448\u043D\u0456\u0439 \u043A\u043E\u0440\u0438\u0441\u0442\u0443\u0432\u0430\u0447\xbb.",
    "focused-task-close-account.delete-account.content-preview.formerUser": "\u041A\u043E\u043B\u0438\u0448\u043D\u0456\u0439 \u043A\u043E\u0440\u0438\u0441\u0442\u0443\u0432\u0430\u0447",
    "focused-task-close-account.delete-account.content-preview.heading.admin": "\u042F\u043A \u0431\u0438 \u0432\u0438 \u0445\u043E\u0442\u0456\u043B\u0438, \u0449\u043E\u0431 \u0432\u0456\u0434\u043E\u0431\u0440\u0430\u0436\u0430\u0432\u0441\u044F \u0432\u0438\u0434\u0430\u043B\u0435\u043D\u0438\u0439 \u043A\u043E\u0440\u0438\u0441\u0442\u0443\u0432\u0430\u0447?",
    "focused-task-close-account.delete-account.content-preview.heading.self": "\u042F\u043A \u0431\u0438 \u0432\u0438 \u0445\u043E\u0442\u0456\u043B\u0438, \u0449\u043E\u0431 \u0432\u0456\u0434\u043E\u0431\u0440\u0430\u0436\u0430\u0432\u0441\u044F \u0432\u0430\u0448 \u0432\u0438\u0434\u0430\u043B\u0435\u043D\u0438\u0439 \u043E\u0431\u043B\u0456\u043A\u043E\u0432\u0438\u0439 \u0437\u0430\u043F\u0438\u0441?",
    "focused-task-close-account.delete-account.content-preview.line.survey.admin": "\u042F\u043A\u0438\u0439 \u0432\u0430\u0440\u0456\u0430\u043D\u0442 \u0432\u0456\u0434\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u043D\u044F \u0432\u0438\u0434\u0430\u043B\u0435\u043D\u043E\u0433\u043E \u043A\u043E\u0440\u0438\u0441\u0442\u0443\u0432\u0430\u0447\u0430 \u0456\u043D\u0448\u0438\u043C \u043A\u043E\u0440\u0438\u0441\u0442\u0443\u0432\u0430\u0447\u0430\u043C \u0432\u0438 \u0431 \u0432\u0438\u0431\u0440\u0430\u043B\u0438, \u044F\u043A\u0431\u0438 \u043C\u0430\u043B\u0438 \u0442\u0430\u043A\u0443 \u043C\u043E\u0436\u043B\u0438\u0432\u0456\u0441\u0442\u044C?",
    "focused-task-close-account.delete-account.content-preview.line.survey.self": "\u042F\u043A\u0438\u0439 \u0432\u0430\u0440\u0456\u0430\u043D\u0442 \u0432\u0456\u0434\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u043D\u044F \u0432\u0430\u0448\u043E\u0433\u043E \u043E\u0431\u043B\u0456\u043A\u043E\u0432\u043E\u0433\u043E \u0437\u0430\u043F\u0438\u0441\u0443 \u0456\u043D\u0448\u0438\u043C \u043A\u043E\u0440\u0438\u0441\u0442\u0443\u0432\u0430\u0447\u0430\u043C \u0432\u0438 \u0431 \u0432\u0438\u0431\u0440\u0430\u043B\u0438, \u044F\u043A\u0431\u0438 \u043C\u0430\u043B\u0438 \u0442\u0430\u043A\u0443 \u043C\u043E\u0436\u043B\u0438\u0432\u0456\u0441\u0442\u044C?",
    "focused-task-close-account.delete-account.content-preview.paragraph.survey.admin": "\u041F\u0456\u0441\u043B\u044F \u0432\u0438\u0434\u0430\u043B\u0435\u043D\u043D\u044F \u043E\u0431\u043B\u0456\u043A\u043E\u0432\u043E\u0433\u043E \u0437\u0430\u043F\u0438\u0441\u0443 \u043A\u043E\u0440\u0438\u0441\u0442\u0443\u0432\u0430\u0447 \u0432\u0456\u0434\u043E\u0431\u0440\u0430\u0436\u0430\u0442\u0438\u043C\u0435\u0442\u044C\u0441\u044F \u0456\u043D\u0448\u0438\u043C \u044F\u043A \xab\u041A\u043E\u043B\u0438\u0448\u043D\u0456\u0439 \u043A\u043E\u0440\u0438\u0441\u0442\u0443\u0432\u0430\u0447\xbb. \u041F\u0440\u0438\u0434\u0456\u043B\u0456\u0442\u044C \u0445\u0432\u0438\u043B\u0438\u043D\u043A\u0443, \u0449\u043E\u0431 \u043F\u0440\u043E\u0439\u0442\u0438 \u043E\u043F\u0438\u0442\u0443\u0432\u0430\u043D\u043D\u044F.",
    "focused-task-close-account.delete-account.content-preview.paragraph.survey.self": "\u041F\u0456\u0441\u043B\u044F \u0432\u0438\u0434\u0430\u043B\u0435\u043D\u043D\u044F \u043E\u0431\u043B\u0456\u043A\u043E\u0432\u043E\u0433\u043E \u0437\u0430\u043F\u0438\u0441\u0443 \u0432\u0438 \u0432\u0456\u0434\u043E\u0431\u0440\u0430\u0436\u0430\u0442\u0438\u043C\u0435\u0442\u0435\u0441\u044C \u0456\u043D\u0448\u0438\u043C \u044F\u043A \xab\u041A\u043E\u043B\u0438\u0448\u043D\u0456\u0439 \u043A\u043E\u0440\u0438\u0441\u0442\u0443\u0432\u0430\u0447\xbb. \u041F\u0440\u0438\u0434\u0456\u043B\u0456\u0442\u044C \u0445\u0432\u0438\u043B\u0438\u043D\u043A\u0443, \u0449\u043E\u0431 \u043F\u0440\u043E\u0439\u0442\u0438 \u043E\u043F\u0438\u0442\u0443\u0432\u0430\u043D\u043D\u044F.",
    "focused-task-close-account.delete-account.drop-down-collapse-button": "\u041F\u043E\u043A\u0430\u0437\u0430\u0442\u0438 \u043C\u0435\u043D\u0448\u0435",
    "focused-task-close-account.delete-account.drop-down-expand-button": "\u0429\u0435 {num}",
    "focused-task-close-account.delete-account.overview.first.line.admin": "\u0411\u0443\u0434\u0435 \u0432\u0438\u0434\u0430\u043B\u0435\u043D\u043E \u043E\u0431\u043B\u0456\u043A\u043E\u0432\u0438\u0439 \u0437\u0430\u043F\u0438\u0441 \u0442\u0430\u043A\u043E\u0433\u043E \u043A\u043E\u0440\u0438\u0441\u0442\u0443\u0432\u0430\u0447\u0430:",
    "focused-task-close-account.delete-account.overview.first.line.self": "\u0411\u0443\u0434\u0435 \u0432\u0438\u0434\u0430\u043B\u0435\u043D\u043E \u0432\u0430\u0448 \u043E\u0431\u043B\u0456\u043A\u043E\u0432\u0438\u0439 \u0437\u0430\u043F\u0438\u0441:",
    "focused-task-close-account.delete-account.overview.heading.admin": "\u0412\u0438\u0434\u0430\u043B\u0435\u043D\u043D\u044F \u043E\u0431\u043B\u0456\u043A\u043E\u0432\u043E\u0433\u043E \u0437\u0430\u043F\u0438\u0441\u0443",
    "focused-task-close-account.delete-account.overview.heading.self": "\u0412\u0438\u0434\u0430\u043B\u0435\u043D\u043D\u044F \u0432\u0430\u0448\u043E\u0433\u043E \u043E\u0431\u043B\u0456\u043A\u043E\u0432\u043E\u0433\u043E \u0437\u0430\u043F\u0438\u0441\u0443",
    "focused-task-close-account.delete-account.overview.inline-dialog.content-created.admin": "\u0426\u0435, \u043D\u0430\u043F\u0440\u0438\u043A\u043B\u0430\u0434, \u0441\u0442\u043E\u0440\u0456\u043D\u043A\u0438, \u043F\u0440\u043E\u0431\u043B\u0435\u043C\u0438 \u0439 \u043A\u043E\u043C\u0435\u043D\u0442\u0430\u0440\u0456, \u0441\u0442\u0432\u043E\u0440\u0435\u043D\u0456 \u043A\u043E\u0440\u0438\u0441\u0442\u0443\u0432\u0430\u0447\u0435\u043C \u0443 \u043F\u0440\u043E\u0434\u0443\u043A\u0442\u0430\u0445.",
    "focused-task-close-account.delete-account.overview.inline-dialog.content-created.self": "\u0426\u0435, \u043D\u0430\u043F\u0440\u0438\u043A\u043B\u0430\u0434, \u0441\u0442\u043E\u0440\u0456\u043D\u043A\u0438, \u043F\u0440\u043E\u0431\u043B\u0435\u043C\u0438 \u0439 \u043A\u043E\u043C\u0435\u043D\u0442\u0430\u0440\u0456, \u0441\u0442\u0432\u043E\u0440\u0435\u043D\u0456 \u0432\u0430\u043C\u0438 \u0432 \u043F\u0440\u043E\u0434\u0443\u043A\u0442\u0430\u0445.",
    "focused-task-close-account.delete-account.overview.inline-dialog.data-apps.admin": "\u0412\u0438 \u0430\u0431\u043E \u0456\u043D\u0448\u0456 \u043A\u043E\u0440\u0438\u0441\u0442\u0443\u0432\u0430\u0447\u0456 \u043C\u043E\u0433\u043B\u0438 \u0432\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u0438 \u0434\u043E\u0434\u0430\u0442\u043A\u0438, \u044F\u043A\u0456 \u0434\u043E\u0434\u0430\u044E\u0442\u044C \u043F\u0435\u0432\u043D\u0456 \u0444\u0443\u043D\u043A\u0446\u0456\u0457 \u0434\u043E \u043F\u0440\u043E\u0434\u0443\u043A\u0442\u0456\u0432 Atlassian. \u0426\u0456 \u0434\u043E\u0434\u0430\u0442\u043A\u0438 \u043C\u043E\u0433\u043B\u0438 \u0437\u0431\u0435\u0440\u0456\u0433\u0430\u0442\u0438 \u0456\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0456\u044E \u0437 \u043F\u0440\u043E\u0444\u0456\u043B\u044E \u043A\u043E\u0440\u0438\u0441\u0442\u0443\u0432\u0430\u0447\u0430.",
    "focused-task-close-account.delete-account.overview.inline-dialog.data-apps.self": "\u0412\u0438 \u0430\u0431\u043E \u0456\u043D\u0448\u0456 \u043A\u043E\u0440\u0438\u0441\u0442\u0443\u0432\u0430\u0447\u0456 \u043C\u043E\u0433\u043B\u0438 \u0432\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u0438 \u0434\u043E\u0434\u0430\u0442\u043A\u0438, \u044F\u043A\u0456 \u0434\u043E\u0434\u0430\u044E\u0442\u044C \u043F\u0435\u0432\u043D\u0456 \u0444\u0443\u043D\u043A\u0446\u0456\u0457 \u0434\u043E \u043F\u0440\u043E\u0434\u0443\u043A\u0442\u0456\u0432 Atlassian. \u0426\u0456 \u0434\u043E\u0434\u0430\u0442\u043A\u0438 \u043C\u043E\u0433\u043B\u0438 \u0437\u0431\u0435\u0440\u0456\u0433\u0430\u0442\u0438 \u0456\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0456\u044E \u0437 \u0432\u0430\u0448\u043E\u0433\u043E \u043F\u0440\u043E\u0444\u0456\u043B\u044E.",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.li1.admin": "\u0406\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0456\u044F, \u043F\u043E\u0432\u2019\u044F\u0437\u0430\u043D\u0430 \u0437 \u043F\u043E\u043A\u0443\u043F\u043A\u0430\u043C\u0438, \u044F\u043A\u0430 \u043D\u0430\u043C \u043F\u043E\u0442\u0440\u0456\u0431\u043D\u0430 \u0434\u043B\u044F \u0444\u0456\u043D\u0430\u043D\u0441\u043E\u0432\u043E\u0457 \u0437\u0432\u0456\u0442\u043D\u043E\u0441\u0442\u0456.",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.li1.self": "\u0406\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0456\u044F, \u043F\u043E\u0432\u2019\u044F\u0437\u0430\u043D\u0430 \u0437 \u043F\u043E\u043A\u0443\u043F\u043A\u0430\u043C\u0438, \u044F\u043A\u0430 \u043D\u0430\u043C \u043F\u043E\u0442\u0440\u0456\u0431\u043D\u0430 \u0434\u043B\u044F \u0444\u0456\u043D\u0430\u043D\u0441\u043E\u0432\u043E\u0457 \u0437\u0432\u0456\u0442\u043D\u043E\u0441\u0442\u0456.",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.li2.admin": "\u0417\u0430\u043F\u0438\u0441\u0438 \u043F\u0440\u043E \u0442\u0435, \u0449\u043E \u043C\u0438 \u0432\u0438\u0434\u0430\u043B\u0438\u043B\u0438 \u043E\u0431\u043B\u0456\u043A\u043E\u0432\u0438\u0439 \u0437\u0430\u043F\u0438\u0441 \u043A\u043E\u0440\u0438\u0441\u0442\u0443\u0432\u0430\u0447\u0430, \u044F\u043A\u0456 \u043D\u0430\u043C, \u043C\u043E\u0436\u043B\u0438\u0432\u043E, \u043F\u043E\u0442\u0440\u0456\u0431\u043D\u043E \u0431\u0443\u0434\u0435 \u043D\u0430\u0434\u0430\u0442\u0438 \u043A\u043E\u043D\u0442\u0440\u043E\u043B\u044C\u043D\u0438\u043C \u043E\u0440\u0433\u0430\u043D\u0430\u043C.",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.li2.self": "\u0417\u0430\u043F\u0438\u0441\u0438 \u043F\u0440\u043E \u0442\u0435, \u0449\u043E \u043C\u0438 \u0432\u0438\u0434\u0430\u043B\u0438\u043B\u0438 \u043E\u0431\u043B\u0456\u043A\u043E\u0432\u0438\u0439 \u0437\u0430\u043F\u0438\u0441 \u043A\u043E\u0440\u0438\u0441\u0442\u0443\u0432\u0430\u0447\u0430, \u044F\u043A\u0456 \u043D\u0430\u043C, \u043C\u043E\u0436\u043B\u0438\u0432\u043E, \u043F\u043E\u0442\u0440\u0456\u0431\u043D\u043E \u0431\u0443\u0434\u0435 \u043D\u0430\u0434\u0430\u0442\u0438 \u043A\u043E\u043D\u0442\u0440\u043E\u043B\u044C\u043D\u0438\u043C \u043E\u0440\u0433\u0430\u043D\u0430\u043C.",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.li3.admin": "\u0414\u0430\u043D\u0456, \u0437\u0430\u0434\u0456\u044F\u043D\u0456 \u0432 \u043F\u043E\u0442\u043E\u0447\u043D\u043E\u043C\u0443 \u0441\u0443\u0434\u043E\u0432\u043E\u043C\u0443 \u043F\u0440\u043E\u0446\u0435\u0441\u0456, \u044F\u043A\u0456 \u043D\u0430\u043C \u043F\u043E\u0442\u0440\u0456\u0431\u043D\u043E \u0437\u0431\u0435\u0440\u0456\u0433\u0430\u0442\u0438 \u0432\u0456\u0434\u043F\u043E\u0432\u0456\u0434\u043D\u043E \u0434\u043E \u0432\u0438\u043C\u043E\u0433 \u0437\u0430\u043A\u043E\u043D\u043E\u0434\u0430\u0432\u0441\u0442\u0432\u0430.",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.li3.self": "\u0414\u0430\u043D\u0456, \u0437\u0430\u0434\u0456\u044F\u043D\u0456 \u0432 \u043F\u043E\u0442\u043E\u0447\u043D\u043E\u043C\u0443 \u0441\u0443\u0434\u043E\u0432\u043E\u043C\u0443 \u043F\u0440\u043E\u0446\u0435\u0441\u0456, \u044F\u043A\u0456 \u043D\u0430\u043C \u043F\u043E\u0442\u0440\u0456\u0431\u043D\u043E \u0437\u0431\u0435\u0440\u0456\u0433\u0430\u0442\u0438 \u0432\u0456\u0434\u043F\u043E\u0432\u0456\u0434\u043D\u043E \u0434\u043E \u0432\u0438\u043C\u043E\u0433 \u0437\u0430\u043A\u043E\u043D\u043E\u0434\u0430\u0432\u0441\u0442\u0432\u0430.",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.p1.admin": "\u041C\u0438 \u0437\u0431\u0435\u0440\u0456\u0433\u0430\u0454\u043C\u043E \u043F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u0456 \u0434\u0430\u043D\u0456 \u043F\u0440\u043E\u0442\u044F\u0433\u043E\u043C \u043E\u0431\u043C\u0435\u0436\u0435\u043D\u043E\u0433\u043E \u0447\u0430\u0441\u0443 \u0434\u043B\u044F \u0437\u0430\u043A\u043E\u043D\u043D\u0438\u0445 \u044E\u0440\u0438\u0434\u0438\u0447\u043D\u0438\u0445 \u0430\u0431\u043E \u0431\u0456\u0437\u043D\u0435\u0441-\u0446\u0456\u043B\u0435\u0439. \u0414\u043E \u043D\u0438\u0445 \u043D\u0430\u043B\u0435\u0436\u0430\u0442\u044C, \u043D\u0430\u043F\u0440\u0438\u043A\u043B\u0430\u0434, \u0442\u0430\u043A\u0456:",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.p1.self": "\u041C\u0438 \u0437\u0431\u0435\u0440\u0456\u0433\u0430\u0454\u043C\u043E \u043F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u0456 \u0434\u0430\u043D\u0456 \u043F\u0440\u043E\u0442\u044F\u0433\u043E\u043C \u043E\u0431\u043C\u0435\u0436\u0435\u043D\u043E\u0433\u043E \u0447\u0430\u0441\u0443 \u0434\u043B\u044F \u0437\u0430\u043A\u043E\u043D\u043D\u0438\u0445 \u044E\u0440\u0438\u0434\u0438\u0447\u043D\u0438\u0445 \u0430\u0431\u043E \u0431\u0456\u0437\u043D\u0435\u0441-\u0446\u0456\u043B\u0435\u0439. \u0414\u043E \u043D\u0438\u0445 \u043D\u0430\u043B\u0435\u0436\u0430\u0442\u044C, \u043D\u0430\u043F\u0440\u0438\u043A\u043B\u0430\u0434, \u0442\u0430\u043A\u0456:",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.p2.admin": "\u041C\u0438 \u043D\u0435 \u0432\u0438\u0434\u0430\u043B\u044F\u0454\u043C\u043E \u043F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u0456 \u0434\u0430\u043D\u0456 \u0437 \u0432\u043C\u0456\u0441\u0442\u0443, \u0441\u0442\u0432\u043E\u0440\u0435\u043D\u043E\u0433\u043E \u043A\u043E\u0440\u0438\u0441\u0442\u0443\u0432\u0430\u0447\u0430\u043C\u0438, \u044F\u043A-\u043E\u0442 \u0456\u043C\u0435\u043D\u0430 \u0430\u0431\u043E \u0435\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u0456 \u0430\u0434\u0440\u0435\u0441\u0438, \u0432\u0432\u0435\u0434\u0435\u043D\u0456 \u043D\u0430 \u0441\u0442\u043E\u0440\u0456\u043D\u0446\u0456 \u0430\u0431\u043E \u0432 \u0434\u0430\u043D\u0438\u0445 \u043F\u0440\u043E\u0431\u043B\u0435\u043C\u0438. \u0410\u0434\u043C\u0456\u043D\u0456\u0441\u0442\u0440\u0430\u0442\u043E\u0440\u0438 \u043F\u0440\u043E\u0434\u0443\u043A\u0442\u0456\u0432 \u043F\u043E\u0432\u0438\u043D\u043D\u0456 \u0432\u0438\u0434\u0430\u043B\u044F\u0442\u0438 \u0442\u0430\u043A\u0456 \u0434\u0430\u043D\u0456 \u0432\u0440\u0443\u0447\u043D\u0443.",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.p2.self": "\u041C\u0438 \u043D\u0435 \u0432\u0438\u0434\u0430\u043B\u044F\u0454\u043C\u043E \u043F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u0456 \u0434\u0430\u043D\u0456 \u0437 \u0432\u043C\u0456\u0441\u0442\u0443, \u0441\u0442\u0432\u043E\u0440\u0435\u043D\u043E\u0433\u043E \u0432\u0430\u043C\u0438 \u0430\u0431\u043E \u0456\u043D\u0448\u0438\u043C\u0438 \u043A\u043E\u0440\u0438\u0441\u0442\u0443\u0432\u0430\u0447\u0430\u043C\u0438, \u044F\u043A-\u043E\u0442 \u0456\u043C\u0435\u043D\u0430 \u0430\u0431\u043E \u0435\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u0456 \u0430\u0434\u0440\u0435\u0441\u0438, \u0432\u0432\u0435\u0434\u0435\u043D\u0456 \u043D\u0430 \u0441\u0442\u043E\u0440\u0456\u043D\u0446\u0456 \u0430\u0431\u043E \u0432 \u0434\u0430\u043D\u0438\u0445 \u043F\u0440\u043E\u0431\u043B\u0435\u043C\u0438. \u0410\u0434\u043C\u0456\u043D\u0456\u0441\u0442\u0440\u0430\u0442\u043E\u0440\u0438 \u043F\u0440\u043E\u0434\u0443\u043A\u0442\u0456\u0432 \u043F\u043E\u0432\u0438\u043D\u043D\u0456 \u0432\u0438\u0434\u0430\u043B\u044F\u0442\u0438 \u0442\u0430\u043A\u0456 \u0434\u0430\u043D\u0456 \u0432\u0440\u0443\u0447\u043D\u0443.",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.p3.admin": "\u041A\u043E\u0440\u0438\u0441\u0442\u0443\u0432\u0430\u0447\u0456 \u043C\u0430\u044E\u0442\u044C \u043F\u0440\u0430\u0432\u043E \u043F\u043E\u0434\u0430\u0432\u0430\u0442\u0438 \u0441\u043A\u0430\u0440\u0433\u0438 \u0434\u043E \u043E\u0440\u0433\u0430\u043D\u0456\u0432 \u043D\u0430\u0433\u043B\u044F\u0434\u043E\u0432\u043E\u0433\u043E \u043A\u043E\u043D\u0442\u0440\u043E\u043B\u044E \u0441\u0432\u043E\u0454\u0457 \u043A\u0440\u0430\u0457\u043D\u0438.",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.p3.self": "\u0412\u0438 \u043C\u0430\u0454\u0442\u0435 \u043F\u0440\u0430\u0432\u043E \u043F\u043E\u0434\u0430\u0432\u0430\u0442\u0438 \u0441\u043A\u0430\u0440\u0433\u0438 \u0434\u043E \u043E\u0440\u0433\u0430\u043D\u0456\u0432 \u043D\u0430\u0433\u043B\u044F\u0434\u043E\u0432\u043E\u0433\u043E \u043A\u043E\u043D\u0442\u0440\u043E\u043B\u044E \u0441\u0432\u043E\u0454\u0457 \u043A\u0440\u0430\u0457\u043D\u0438.",
    "focused-task-close-account.delete-account.overview.paragraph.about-to-delete.admin": "\u0414\u0430\u043B\u0456 \u043E\u043F\u0438\u0441\u0430\u043D\u043E \u043D\u0430\u0441\u043B\u0456\u0434\u043A\u0438 \u0432\u0438\u0434\u0430\u043B\u0435\u043D\u043D\u044F \u0446\u044C\u043E\u0433\u043E \u043E\u0431\u043B\u0456\u043A\u043E\u0432\u043E\u0433\u043E \u0437\u0430\u043F\u0438\u0441\u0443.",
    "focused-task-close-account.delete-account.overview.paragraph.about-to-delete.self": "\u0414\u0430\u043B\u0456 \u043E\u043F\u0438\u0441\u0430\u043D\u043E \u043D\u0430\u0441\u043B\u0456\u0434\u043A\u0438 \u0432\u0438\u0434\u0430\u043B\u0435\u043D\u043D\u044F \u0432\u0430\u0448\u043E\u0433\u043E \u043E\u0431\u043B\u0456\u043A\u043E\u0432\u043E\u0433\u043E \u0437\u0430\u043F\u0438\u0441\u0443.",
    "focused-task-close-account.delete-account.overview.paragraph.content-created.admin": "\u0421\u0442\u0432\u043E\u0440\u0435\u043D\u0438\u0439 \u043A\u043E\u0440\u0438\u0441\u0442\u0443\u0432\u0430\u0447\u0435\u043C \u0432\u043C\u0456\u0441\u0442 \u0437\u0430\u043B\u0438\u0448\u0438\u0442\u044C\u0441\u044F \u0432 \u0441\u043B\u0443\u0436\u0431\u0430\u0445 \u043E\u0431\u043B\u0456\u043A\u043E\u0432\u0438\u0445 \u0437\u0430\u043F\u0438\u0441\u0456\u0432 Atlassian.",
    "focused-task-close-account.delete-account.overview.paragraph.content-created.self": "\u0421\u0442\u0432\u043E\u0440\u0435\u043D\u0438\u0439 \u0432\u0430\u043C\u0438 \u0432\u043C\u0456\u0441\u0442 \u0437\u0430\u043B\u0438\u0448\u0438\u0442\u044C\u0441\u044F \u0432 \u0441\u043B\u0443\u0436\u0431\u0430\u0445 \u043E\u0431\u043B\u0456\u043A\u043E\u0432\u0438\u0445 \u0437\u0430\u043F\u0438\u0441\u0456\u0432 Atlassian.",
    "focused-task-close-account.delete-account.overview.paragraph.grace-period.admin": "\u041F\u0456\u0441\u043B\u044F 14-\u0434\u0435\u043D\u043D\u043E\u0433\u043E \u043F\u0435\u0440\u0456\u043E\u0434\u0443 \u043E\u0447\u0456\u043A\u0443\u0432\u0430\u043D\u043D\u044F \u0441\u043A\u0430\u0441\u0443\u0432\u0430\u0442\u0438 \u0432\u0438\u0434\u0430\u043B\u0435\u043D\u043D\u044F \u043E\u0431\u043B\u0456\u043A\u043E\u0432\u043E\u0433\u043E \u0437\u0430\u043F\u0438\u0441\u0443 \u0431\u0443\u0434\u0435 \u043D\u0435\u043C\u043E\u0436\u043B\u0438\u0432\u043E.",
    "focused-task-close-account.delete-account.overview.paragraph.list-of-apps-with-personal-data.admin": "\u041C\u0438 \u043D\u0430\u0434\u0456\u0448\u043B\u0435\u043C\u043E \u0432\u0430\u043C \u0441\u043F\u0438\u0441\u043E\u043A \u0434\u043E\u0434\u0430\u0442\u043A\u0456\u0432, \u0434\u0435 \u043C\u043E\u0433\u043B\u0438 \u0437\u0431\u0435\u0440\u0456\u0433\u0430\u0442\u0438\u0441\u044F \u043F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u0456 \u0434\u0430\u043D\u0456 \u043A\u043E\u0440\u0438\u0441\u0442\u0443\u0432\u0430\u0447\u0430.",
    "focused-task-close-account.delete-account.overview.paragraph.list-of-apps-with-personal-data.self": "\u041C\u0438 \u043D\u0430\u0434\u0456\u0448\u043B\u0435\u043C\u043E \u0432\u0430\u043C \u0441\u043F\u0438\u0441\u043E\u043A \u0434\u043E\u0434\u0430\u0442\u043A\u0456\u0432, \u0434\u0435 \u043C\u043E\u0433\u043B\u0438 \u0437\u0431\u0435\u0440\u0456\u0433\u0430\u0442\u0438\u0441\u044F \u0432\u0430\u0448\u0456 \u043F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u0456 \u0434\u0430\u043D\u0456.",
    "focused-task-close-account.delete-account.overview.paragraph.loseAccess.admin": "{fullName} <b>\u0432\u0456\u0434\u0440\u0430\u0437\u0443 \u0432\u0442\u0440\u0430\u0442\u0438\u0442\u044C \u0434\u043E\u0441\u0442\u0443\u043F</b> \u0434\u043E \u0432\u0441\u0456\u0445 \u0441\u043B\u0443\u0436\u0431 \u043E\u0431\u043B\u0456\u043A\u043E\u0432\u0438\u0445 \u0437\u0430\u043F\u0438\u0441\u0456\u0432 Atlassian. \u041D\u0430\u0440\u0430\u0437\u0456 \u0446\u0435\u0439 \u043A\u043E\u0440\u0438\u0441\u0442\u0443\u0432\u0430\u0447 \u043C\u0430\u0454 \u0434\u043E\u0441\u0442\u0443\u043F \u0434\u043E \u0442\u0430\u043A\u0438\u0445 \u0441\u043B\u0443\u0436\u0431:",
    "focused-task-close-account.delete-account.overview.paragraph.loseAccess.admin.noSites": "{fullName} <b>\u0432\u0456\u0434\u0440\u0430\u0437\u0443 \u0432\u0442\u0440\u0430\u0442\u0438\u0442\u044C \u0434\u043E\u0441\u0442\u0443\u043F</b> \u0434\u043E \u0432\u0441\u0456\u0445 \u0441\u043B\u0443\u0436\u0431 \u043E\u0431\u043B\u0456\u043A\u043E\u0432\u0438\u0445 \u0437\u0430\u043F\u0438\u0441\u0456\u0432 Atlassian. \u041D\u0430\u0440\u0430\u0437\u0456 \u0446\u0435\u0439 \u043A\u043E\u0440\u0438\u0441\u0442\u0443\u0432\u0430\u0447 \u043D\u0435 \u043C\u0430\u0454 \u0434\u043E\u0441\u0442\u0443\u043F\u0443 \u0434\u043E \u0436\u043E\u0434\u043D\u0438\u0445 \u0441\u043B\u0443\u0436\u0431, \u043E\u043A\u0440\u0456\u043C \u0421\u043F\u0456\u043B\u044C\u043D\u043E\u0442\u0438 \u0442\u0430 Marketplace.",
    "focused-task-close-account.delete-account.overview.paragraph.loseAccess.footnote": "\u0406\u043D\u0448\u0456 \u0441\u043B\u0443\u0436\u0431\u0438 \u043E\u0431\u043B\u0456\u043A\u043E\u0432\u0438\u0445 \u0437\u0430\u043F\u0438\u0441\u0456\u0432 Atlassian, \u044F\u043A-\u043E\u0442 \u0421\u043F\u0456\u043B\u044C\u043D\u043E\u0442\u0430 Atlassian \u0456 Marketplace.",
    "focused-task-close-account.delete-account.overview.paragraph.loseAccess.self": "\u0412\u0438 <b>\u0432\u0456\u0434\u0440\u0430\u0437\u0443 \u0432\u0442\u0440\u0430\u0442\u0438\u0442\u0435 \u0434\u043E\u0441\u0442\u0443\u043F</b> \u0434\u043E \u0432\u0441\u0456\u0445 \u0441\u043B\u0443\u0436\u0431 \u043E\u0431\u043B\u0456\u043A\u043E\u0432\u0438\u0445 \u0437\u0430\u043F\u0438\u0441\u0456\u0432 Atlassian. \u041D\u0430\u0440\u0430\u0437\u0456 \u0432\u0438 \u043C\u0430\u0454\u0442\u0435 \u0434\u043E\u0441\u0442\u0443\u043F \u0434\u043E \u0442\u0430\u043A\u0438\u0445 \u0441\u043B\u0443\u0436\u0431:",
    "focused-task-close-account.delete-account.overview.paragraph.loseAccess.self.noSites": "\u0412\u0438 <b>\u0432\u0456\u0434\u0440\u0430\u0437\u0443 \u0432\u0442\u0440\u0430\u0442\u0438\u0442\u0435 \u0434\u043E\u0441\u0442\u0443\u043F</b> \u0434\u043E \u0432\u0441\u0456\u0445 \u0441\u043B\u0443\u0436\u0431 \u043E\u0431\u043B\u0456\u043A\u043E\u0432\u0438\u0445 \u0437\u0430\u043F\u0438\u0441\u0456\u0432 Atlassian. \u041D\u0430\u0440\u0430\u0437\u0456 \u0446\u0435\u0439 \u0432\u0438 \u043D\u0435 \u043C\u0430\u0454\u0442\u0435 \u0434\u043E\u0441\u0442\u0443\u043F\u0443 \u0434\u043E \u0436\u043E\u0434\u043D\u0438\u0445 \u0441\u043B\u0443\u0436\u0431, \u043E\u043A\u0440\u0456\u043C \u0421\u043F\u0456\u043B\u044C\u043D\u043E\u0442\u0438 \u0442\u0430 Marketplace.",
    "focused-task-close-account.delete-account.overview.paragraph.personal-data-will-be-deleted.admin": "\u041C\u0438 <b>\u0432\u0438\u0434\u0430\u043B\u0438\u043C\u043E \u043F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u0456 \u0434\u0430\u043D\u0456 \u043A\u043E\u0440\u0438\u0441\u0442\u0443\u0432\u0430\u0447\u0430</b>, \u044F\u043A-\u043E\u0442 \u0439\u043E\u0433\u043E \u043F\u043E\u0432\u043D\u0435 \u0456\u043C\u2019\u044F \u0439 \u0435\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u0443 \u0430\u0434\u0440\u0435\u0441\u0443, \u0437\u0456 \u0441\u043B\u0443\u0436\u0431 \u043E\u0431\u043B\u0456\u043A\u043E\u0432\u0438\u0445 \u0437\u0430\u043F\u0438\u0441\u0456\u0432 Atlassian \u043F\u0440\u043E\u0442\u044F\u0433\u043E\u043C 30 \u0434\u043D\u0456\u0432, \u043E\u043A\u0440\u0456\u043C \u0432\u0438\u043F\u0430\u0434\u043A\u0456\u0432, \u043A\u043E\u043B\u0438 \u0446\u0456 \u0434\u0430\u043D\u0456 \u043F\u043E\u0442\u0440\u0456\u0431\u043D\u0456 \u0434\u043B\u044F \u0437\u0430\u043A\u043E\u043D\u043D\u0438\u0445 \u044E\u0440\u0438\u0434\u0438\u0447\u043D\u0438\u0445 \u0430\u0431\u043E \u0431\u0456\u0437\u043D\u0435\u0441-\u0446\u0456\u043B\u0435\u0439.",
    "focused-task-close-account.delete-account.overview.paragraph.personal-data-will-be-deleted.self": "\u041C\u0438 <b>\u0432\u0438\u0434\u0430\u043B\u0438\u043C\u043E \u0432\u0430\u0448\u0456 \u043F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u0456 \u0434\u0430\u043D\u0456</b>, \u044F\u043A-\u043E\u0442 \u043F\u043E\u0432\u043D\u0435 \u0456\u043C\u2019\u044F \u0439 \u0435\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u0443 \u0430\u0434\u0440\u0435\u0441\u0443, \u0437\u0456 \u0441\u043B\u0443\u0436\u0431 \u043E\u0431\u043B\u0456\u043A\u043E\u0432\u043E\u0433\u043E \u0437\u0430\u043F\u0438\u0441\u0443 Atlassian \u043F\u0440\u043E\u0442\u044F\u0433\u043E\u043C 30 \u0434\u043D\u0456\u0432, \u043E\u043A\u0440\u0456\u043C \u0432\u0438\u043F\u0430\u0434\u043A\u0456\u0432, \u043A\u043E\u043B\u0438 \u0446\u0456 \u0434\u0430\u043D\u0456 \u043F\u043E\u0442\u0440\u0456\u0431\u043D\u0456 \u0434\u043B\u044F \u0437\u0430\u043A\u043E\u043D\u043D\u0438\u0445 \u044E\u0440\u0438\u0434\u0438\u0447\u043D\u0438\u0445 \u0430\u0431\u043E \u0431\u0456\u0437\u043D\u0435\u0441-\u0446\u0456\u043B\u0435\u0439.",
    "focused-task-close-account.delete-account.overview.warning-section.body": "\u041F\u0456\u0441\u043B\u044F 14-\u0434\u0435\u043D\u043D\u043E\u0433\u043E \u043F\u0435\u0440\u0456\u043E\u0434\u0443 \u043E\u0447\u0456\u043A\u0443\u0432\u0430\u043D\u043D\u044F \u0441\u043A\u0430\u0441\u0443\u0432\u0430\u0442\u0438 \u0432\u0438\u0434\u0430\u043B\u0435\u043D\u043D\u044F \u043E\u0431\u043B\u0456\u043A\u043E\u0432\u043E\u0433\u043E \u0437\u0430\u043F\u0438\u0441\u0443 \u0431\u0443\u0434\u0435 \u043D\u0435\u043C\u043E\u0436\u043B\u0438\u0432\u043E. \u042F\u043A\u0449\u043E \u0432\u0438 \u0432\u0432\u0430\u0436\u0430\u0454\u0442\u0435, \u0449\u043E \u043E\u0431\u043B\u0456\u043A\u043E\u0432\u0438\u0439 \u0437\u0430\u043F\u0438\u0441 \u0437\u043D\u0430\u0434\u043E\u0431\u0438\u0442\u044C\u0441\u044F \u0432\u0430\u043C \u043F\u0456\u0437\u043D\u0456\u0448\u0435, \u0434\u0435\u0430\u043A\u0442\u0438\u0432\u0443\u0439\u0442\u0435 \u0439\u043E\u0433\u043E.",
    "focused-task-close-account.delete-account.overview.warning-section.deactivated.body": "\u041F\u0456\u0441\u043B\u044F 14-\u0434\u0435\u043D\u043D\u043E\u0433\u043E \u043F\u0435\u0440\u0456\u043E\u0434\u0443 \u043E\u0447\u0456\u043A\u0443\u0432\u0430\u043D\u043D\u044F \u0441\u043A\u0430\u0441\u0443\u0432\u0430\u0442\u0438 \u0432\u0438\u0434\u0430\u043B\u0435\u043D\u043D\u044F \u043E\u0431\u043B\u0456\u043A\u043E\u0432\u043E\u0433\u043E \u0437\u0430\u043F\u0438\u0441\u0443 \u0431\u0443\u0434\u0435 \u043D\u0435\u043C\u043E\u0436\u043B\u0438\u0432\u043E.",
    "focused-task-close-account.learnMore": "\u0414\u043E\u043A\u043B\u0430\u0434\u043D\u0456\u0448\u0435",
    "focused-task-close-account.next": "\u0414\u0430\u043B\u0456",
    "focused-task-close-account.previous": "\u041D\u0430\u0437\u0430\u0434"
};

});

parcelRegister("bA1fB", function(module, exports) {
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Vietnamese (Vietnam)
var $86e406e0968b4ab0$export$2e2bcd8739ae039 = {
    "focused-task-close-account.cancel": "H\u1EE7y",
    "focused-task-close-account.deactivate-account": "H\u1EE7y k\xedch ho\u1EA1t t\xe0i kho\u1EA3n",
    "focused-task-close-account.deactivate-account.overview.first.line.admin": "B\u1EA1n s\u1EAFp h\u1EE7y k\xedch ho\u1EA1t t\xe0i kho\u1EA3n ng\u01B0\u1EDDi d\xf9ng c\u1EE7a:",
    "focused-task-close-account.deactivate-account.overview.first.line.self": "B\u1EA1n s\u1EAFp h\u1EE7y k\xedch ho\u1EA1t tai kho\u1EA3n ng\u01B0\u1EDDi d\xf9ng c\u1EE7a:",
    "focused-task-close-account.deactivate-account.overview.heading.admin": "H\u1EE7y k\xedch ho\u1EA1t t\xe0i kho\u1EA3n",
    "focused-task-close-account.deactivate-account.overview.heading.self": "H\u1EE7y k\xedch ho\u1EA1t t\xe0i kho\u1EA3n",
    "focused-task-close-account.deactivate-account.overview.last.line.admin": "B\u1EA1n c\xf3 th\u1EC3 k\xedch ho\u1EA1t l\u1EA1i t\xe0i kho\u1EA3n b\u1EA5t c\u1EE9 l\xfac n\xe0o.",
    "focused-task-close-account.deactivate-account.overview.last.line.self": "B\u1EA1n c\xf3 th\u1EC3 k\xedch ho\u1EA1t l\u1EA1i t\xe0i kho\u1EA3n b\u1EA5t c\u1EE9 l\xfac n\xe0o.",
    "focused-task-close-account.deactivate-account.overview.paragraph.about-to-deactivate.admin": "Khi b\u1EA1n h\u1EE7y k\xedch ho\u1EA1t t\xe0i kho\u1EA3n:",
    "focused-task-close-account.deactivate-account.overview.paragraph.about-to-deactivate.self": "Khi b\u1EA1n h\u1EE7y k\xedch ho\u1EA1t t\xe0i kho\u1EA3n:",
    "focused-task-close-account.deactivate-account.overview.paragraph.billing.admin": "Ch\xfang t\xf4i s\u1EBD kh\xf4ng c\xf2n t\xednh ph\xed c\xe1c t\xe0i kho\u1EA3n n\xe0y cho b\u1EA1n n\u1EEFa.",
    "focused-task-close-account.deactivate-account.overview.paragraph.billing.self": "Ch\xfang t\xf4i s\u1EBD kh\xf4ng c\xf2n t\xednh ph\xed c\xe1c t\xe0i kho\u1EA3n n\xe0y cho b\u1EA1n n\u1EEFa.",
    "focused-task-close-account.deactivate-account.overview.paragraph.loseAccess.admin": "{fullName} s\u1EBD <b>ngay l\u1EADp t\u1EE9c m\u1EA5t quy\u1EC1n truy c\u1EADp</b> v\xe0o t\u1EA5t c\u1EA3 c\xe1c d\u1ECBch v\u1EE5 t\xe0i kho\u1EA3n Atlassian. H\u1ECD hi\u1EC7n c\xf3 quy\u1EC1n truy c\u1EADp v\xe0o:",
    "focused-task-close-account.deactivate-account.overview.paragraph.loseAccess.admin.noSites": "{fullName} s\u1EBD <b>ngay l\u1EADp t\u1EE9c m\u1EA5t quy\u1EC1n truy c\u1EADp</b> v\xe0o t\u1EA5t c\u1EA3 c\xe1c d\u1ECBch v\u1EE5 t\xe0i kho\u1EA3n Atlassian. Hi\u1EC7n t\u1EA1i, h\u1ECD kh\xf4ng c\xf3 quy\u1EC1n truy c\u1EADp v\xe0o b\u1EA5t k\u1EF3 d\u1ECBch v\u1EE5 n\xe0o, ngo\u1EA1i tr\u1EEB c\xe1c d\u1ECBch v\u1EE5 nh\u01B0 Community v\xe0 Marketplace.",
    "focused-task-close-account.deactivate-account.overview.paragraph.loseAccess.footnote": "C\xe1c d\u1ECBch v\u1EE5 t\xe0i kho\u1EA3n Atlassian kh\xe1c, nh\u01B0 Atlassian Community v\xe0 Marketplace.",
    "focused-task-close-account.deactivate-account.overview.paragraph.loseAccess.self": "B\u1EA1n s\u1EBD <b>ngay l\u1EADp t\u1EE9c m\u1EA5t quy\u1EC1n truy c\u1EADp</b> v\xe0o t\u1EA5t c\u1EA3 c\xe1c d\u1ECBch v\u1EE5 t\xe0i kho\u1EA3n Atlassian. B\u1EA1n hi\u1EC7n c\xf3 quy\u1EC1n truy c\u1EADp v\xe0o:",
    "focused-task-close-account.deactivate-account.overview.paragraph.loseAccess.self.noSites": "B\u1EA1n s\u1EBD <b>ngay l\u1EADp t\u1EE9c m\u1EA5t quy\u1EC1n truy c\u1EADp</b> v\xe0o t\u1EA5t c\u1EA3 c\xe1c d\u1ECBch v\u1EE5 t\xe0i kho\u1EA3n Atlassian. Hi\u1EC7n t\u1EA1i, b\u1EA1n kh\xf4ng c\xf3 quy\u1EC1n truy c\u1EADp v\xe0o b\u1EA5t k\u1EF3 d\u1ECBch v\u1EE5 n\xe0o, ngo\u1EA1i tr\u1EEB c\xe1c d\u1ECBch v\u1EE5 nh\u01B0 Community v\xe0 Marketplace.",
    "focused-task-close-account.deactivate-account.overview.paragraph.personal-data.admin": "D\u1EEF li\u1EC7u c\xe1 nh\xe2n c\u1EE7a t\xe0i kho\u1EA3n, ch\u1EB3ng h\u1EA1n nh\u01B0 t\xean \u0111\u1EA7y \u0111\u1EE7 v\xe0 \u0111\u1ECBa ch\u1EC9 email c\u1EE7a t\xe0i kho\u1EA3n c\u0169ng nh\u01B0 n\u1ED9i dung t\xe0i kho\u1EA3n \u0111\xe3 t\u1EA1o s\u1EBD v\u1EABn c\xf2n trong c\xe1c d\u1ECBch v\u1EE5 t\xe0i kho\u1EA3n Atlassian.",
    "focused-task-close-account.deactivate-account.overview.paragraph.personal-data.self": "D\u1EEF li\u1EC7u c\xe1 nh\xe2n c\u1EE7a t\xe0i kho\u1EA3n, ch\u1EB3ng h\u1EA1n nh\u01B0 t\xean \u0111\u1EA7y \u0111\u1EE7 v\xe0 \u0111\u1ECBa ch\u1EC9 email c\u1EE7a t\xe0i kho\u1EA3n c\u0169ng nh\u01B0 n\u1ED9i dung t\xe0i kho\u1EA3n \u0111\xe3 t\u1EA1o s\u1EBD v\u1EABn c\xf2n trong c\xe1c d\u1ECBch v\u1EE5 t\xe0i kho\u1EA3n Atlassian.",
    "focused-task-close-account.delete-account": "X\xf3a t\xe0i kho\u1EA3n",
    "focused-task-close-account.delete-account.content-preview.footnote.admin": "L\u01B0u \xfd: Vi\u1EC7c tr\u1EA3 l\u1EDDi cu\u1ED9c kh\u1EA3o s\xe1t n\xe0y s\u1EBD gi\xfap ch\xfang t\xf4i t\u1EA1o ra tr\u1EA3i nghi\u1EC7m t\u1ED1t h\u01A1n cho t\u1EA5t c\u1EA3 ng\u01B0\u1EDDi d\xf9ng. Ng\u01B0\u1EDDi d\xf9ng v\u1EABn s\u1EBD xu\u1EA5t hi\u1EC7n d\u01B0\u1EDBi d\u1EA1ng \u201CNg\u01B0\u1EDDi d\xf9ng tr\u01B0\u1EDBc \u0111\xe2y\u201D sau khi b\u1EA1n x\xf3a t\xe0i kho\u1EA3n c\u1EE7a h\u1ECD.",
    "focused-task-close-account.delete-account.content-preview.footnote.self": "L\u01B0u \xfd: Vi\u1EC7c tr\u1EA3 l\u1EDDi cu\u1ED9c kh\u1EA3o s\xe1t n\xe0y s\u1EBD gi\xfap ch\xfang t\xf4i t\u1EA1o ra tr\u1EA3i nghi\u1EC7m t\u1ED1t h\u01A1n cho t\u1EA5t c\u1EA3 ng\u01B0\u1EDDi d\xf9ng. B\u1EA1n v\u1EABn s\u1EBD xu\u1EA5t hi\u1EC7n d\u01B0\u1EDBi d\u1EA1ng \u201CNg\u01B0\u1EDDi d\xf9ng tr\u01B0\u1EDBc \u0111\xe2y\u201D sau khi b\u1EA1n x\xf3a t\xe0i kho\u1EA3n c\u1EE7a m\xecnh.",
    "focused-task-close-account.delete-account.content-preview.formerUser": "Ng\u01B0\u1EDDi d\xf9ng c\u0169",
    "focused-task-close-account.delete-account.content-preview.heading.admin": "B\u1EA1n mu\u1ED1n ng\u01B0\u1EDDi d\xf9ng \u0111\xe3 b\u1ECB x\xf3a xu\u1EA5t hi\u1EC7n nh\u01B0 th\u1EBF n\xe0o?",
    "focused-task-close-account.delete-account.content-preview.heading.self": "B\u1EA1n mu\u1ED1n t\xe0i kho\u1EA3n \u0111\xe3 b\u1ECB x\xf3a c\u1EE7a m\xecnh xu\u1EA5t hi\u1EC7n nh\u01B0 th\u1EBF n\xe0o?",
    "focused-task-close-account.delete-account.content-preview.line.survey.admin": "N\u1EBFu ch\xfang t\xf4i cho b\u1EA1n l\u1EF1a ch\u1ECDn, b\u1EA1n mu\u1ED1n ng\u01B0\u1EDDi d\xf9ng \u0111\xe3 b\u1ECB x\xf3a xu\u1EA5t hi\u1EC7n nh\u01B0 th\u1EBF n\xe0o tr\u01B0\u1EDBc nh\u1EEFng ng\u01B0\u1EDDi d\xf9ng kh\xe1c?",
    "focused-task-close-account.delete-account.content-preview.line.survey.self": "N\u1EBFu ch\xfang t\xf4i cho b\u1EA1n l\u1EF1a ch\u1ECDn, b\u1EA1n mu\u1ED1n xu\u1EA5t hi\u1EC7n nh\u01B0 th\u1EBF n\xe0o tr\u01B0\u1EDBc nh\u1EEFng ng\u01B0\u1EDDi d\xf9ng kh\xe1c?",
    "focused-task-close-account.delete-account.content-preview.paragraph.survey.admin": "Sau khi t\xe0i kho\u1EA3n ng\u01B0\u1EDDi d\xf9ng b\u1ECB x\xf3a, h\u1ECD s\u1EBD xu\u1EA5t hi\u1EC7n tr\u01B0\u1EDBc nh\u1EEFng ng\u01B0\u1EDDi d\xf9ng kh\xe1c l\xe0 \u201CNg\u01B0\u1EDDi d\xf9ng tr\u01B0\u1EDBc \u0111\xe2y\u201D. Vui l\xf2ng d\xe0nh ch\xfat th\u1EDDi gian tr\u1EA3 l\u1EDDi c\xe2u h\u1ECFi kh\u1EA3o s\xe1t c\u1EE7a ch\xfang t\xf4i.",
    "focused-task-close-account.delete-account.content-preview.paragraph.survey.self": "Sau khi t\xe0i kho\u1EA3n c\u1EE7a b\u1EA1n b\u1ECB x\xf3a, b\u1EA1n s\u1EBD xu\u1EA5t hi\u1EC7n tr\u01B0\u1EDBc nh\u1EEFng ng\u01B0\u1EDDi d\xf9ng kh\xe1c l\xe0 \u201CNg\u01B0\u1EDDi d\xf9ng tr\u01B0\u1EDBc \u0111\xe2y\u201D. Vui l\xf2ng d\xe0nh ch\xfat th\u1EDDi gian tr\u1EA3 l\u1EDDi c\xe2u h\u1ECFi kh\u1EA3o s\xe1t c\u1EE7a ch\xfang t\xf4i.",
    "focused-task-close-account.delete-account.drop-down-collapse-button": "Hi\u1EC3n th\u1ECB \xedt h\u01A1n",
    "focused-task-close-account.delete-account.drop-down-expand-button": "h\u01A1n {num}",
    "focused-task-close-account.delete-account.overview.first.line.admin": "B\u1EA1n s\u1EAFp x\xf3a t\xe0i kho\u1EA3n c\u1EE7a:",
    "focused-task-close-account.delete-account.overview.first.line.self": "B\u1EA1n s\u1EAFp x\xf3a t\xe0i kho\u1EA3n c\u1EE7a m\xecnh:",
    "focused-task-close-account.delete-account.overview.heading.admin": "X\xf3a t\xe0i kho\u1EA3n",
    "focused-task-close-account.delete-account.overview.heading.self": "X\xf3a t\xe0i kho\u1EA3n c\u1EE7a b\u1EA1n",
    "focused-task-close-account.delete-account.overview.inline-dialog.content-created.admin": "V\xed d\u1EE5: c\xe1c trang, c\xe1c v\u1EA5n \u0111\u1EC1 v\xe0 nh\u1EADn x\xe9t m\xe0 h\u1ECD \u0111\xe3 t\u1EA1o ra trong s\u1EA3n ph\u1EA9m.",
    "focused-task-close-account.delete-account.overview.inline-dialog.content-created.self": "V\xed d\u1EE5: c\xe1c trang, c\xe1c v\u1EA5n \u0111\u1EC1 v\xe0 nh\u1EADn x\xe9t m\xe0 b\u1EA1n \u0111\xe3 t\u1EA1o ra trong s\u1EA3n ph\u1EA9m.",
    "focused-task-close-account.delete-account.overview.inline-dialog.data-apps.admin": "B\u1EA1n ho\u1EB7c nh\u1EEFng ng\u01B0\u1EDDi d\xf9ng kh\xe1c c\xf3 th\u1EC3 \u0111\xe3 c\xe0i \u0111\u1EB7t c\xe1c \u1EE9ng d\u1EE5ng b\u1ED5 sung c\xe1c t\xednh n\u0103ng v\xe0o s\u1EA3n ph\u1EA9m Atlassian. Nh\u1EEFng \u1EE9ng d\u1EE5ng n\xe0y c\xf3 th\u1EC3 \u0111\xe3 l\u01B0u th\xf4ng tin h\u1ED3 s\u01A1 ng\u01B0\u1EDDi d\xf9ng.",
    "focused-task-close-account.delete-account.overview.inline-dialog.data-apps.self": "B\u1EA1n ho\u1EB7c nh\u1EEFng ng\u01B0\u1EDDi d\xf9ng kh\xe1c c\xf3 th\u1EC3 \u0111\xe3 c\xe0i \u0111\u1EB7t c\xe1c \u1EE9ng d\u1EE5ng b\u1ED5 sung c\xe1c t\xednh n\u0103ng v\xe0o s\u1EA3n ph\u1EA9m Atlassian. Nh\u1EEFng \u1EE9ng d\u1EE5ng n\xe0y c\xf3 th\u1EC3 \u0111\xe3 l\u01B0u th\xf4ng tin h\u1ED3 s\u01A1 c\u1EE7a b\u1EA1n.",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.li1.admin": "Th\xf4ng tin li\xean quan \u0111\u1EBFn vi\u1EC7c mua h\xe0ng m\xe0 ch\xfang t\xf4i b\u1EAFt bu\u1ED9c ph\u1EA3i l\u01B0u gi\u1EEF l\u1EA1i \u0111\u1EC3 l\u1EADp b\xe1o c\xe1o t\xe0i ch\xednh.",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.li1.self": "Th\xf4ng tin li\xean quan \u0111\u1EBFn vi\u1EC7c mua h\xe0ng m\xe0 ch\xfang t\xf4i b\u1EAFt bu\u1ED9c ph\u1EA3i l\u01B0u gi\u1EEF l\u1EA1i \u0111\u1EC3 l\u1EADp b\xe1o c\xe1o t\xe0i ch\xednh.",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.li2.admin": "H\u1ED3 s\u01A1 cho th\u1EA5y r\u1EB1ng ch\xfang t\xf4i \u0111\xe3 x\xf3a t\xe0i kho\u1EA3n c\u1EE7a ai \u0111\xf3 m\xe0 ch\xfang t\xf4i c\xf3 th\u1EC3 c\u1EA7n cung c\u1EA5p cho c\u01A1 quan qu\u1EA3n l\xfd.",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.li2.self": "H\u1ED3 s\u01A1 cho th\u1EA5y r\u1EB1ng ch\xfang t\xf4i \u0111\xe3 x\xf3a t\xe0i kho\u1EA3n c\u1EE7a ai \u0111\xf3 m\xe0 ch\xfang t\xf4i c\xf3 th\u1EC3 c\u1EA7n cung c\u1EA5p cho c\u01A1 quan qu\u1EA3n l\xfd.",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.li3.admin": "D\u1EEF li\u1EC7u \u0111\u01B0\u1EE3c s\u1EED d\u1EE5ng cho v\u1EE5 ki\u1EC7n \u0111ang di\u1EC5n ra m\xe0 ch\xfang t\xf4i b\u1EAFt bu\u1ED9c ph\u1EA3i gi\u1EEF l\u1EA1i theo y\xeau c\u1EA7u c\u1EE7a ph\xe1p lu\u1EADt.",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.li3.self": "D\u1EEF li\u1EC7u \u0111\u01B0\u1EE3c s\u1EED d\u1EE5ng cho v\u1EE5 ki\u1EC7n \u0111ang di\u1EC5n ra m\xe0 ch\xfang t\xf4i b\u1EAFt bu\u1ED9c ph\u1EA3i gi\u1EEF l\u1EA1i theo y\xeau c\u1EA7u c\u1EE7a ph\xe1p lu\u1EADt.",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.p1.admin": "Ch\xfang t\xf4i l\u01B0u gi\u1EEF d\u1EEF li\u1EC7u c\xe1 nh\xe2n trong kho\u1EA3ng th\u1EDDi gian gi\u1EDBi h\u1EA1n khi ch\xfang t\xf4i c\xf3 ho\u1EA1t \u0111\u1ED9ng kinh doanh ch\xednh \u0111\xe1ng ho\u1EB7c m\u1EE5c \u0111\xedch h\u1EE3p ph\xe1p. M\u1ED9t s\u1ED1 v\xed d\u1EE5 bao g\u1ED3m:",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.p1.self": "Ch\xfang t\xf4i l\u01B0u gi\u1EEF d\u1EEF li\u1EC7u c\xe1 nh\xe2n trong kho\u1EA3ng th\u1EDDi gian gi\u1EDBi h\u1EA1n khi ch\xfang t\xf4i c\xf3 ho\u1EA1t \u0111\u1ED9ng kinh doanh ch\xednh \u0111\xe1ng ho\u1EB7c m\u1EE5c \u0111\xedch h\u1EE3p ph\xe1p. M\u1ED9t s\u1ED1 v\xed d\u1EE5 bao g\u1ED3m:",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.p2.admin": "Ch\xfang t\xf4i kh\xf4ng x\xf3a b\u1EA5t k\u1EF3 d\u1EEF li\u1EC7u c\xe1 nh\xe2n n\xe0o kh\u1ECFi n\u1ED9i dung do ng\u01B0\u1EDDi d\xf9ng t\u1EA1o, nh\u01B0 t\xean ho\u1EB7c \u0111\u1ECBa ch\u1EC9 email m\xe0 h\u1ECD \u0111\xe3 nh\u1EADp v\xe0o trang ho\u1EB7c \u1EA5n ph\u1EA9m. Qu\u1EA3n tr\u1ECB vi\xean s\u1EA3n ph\u1EA9m c\u1EA7n x\xf3a d\u1EEF li\u1EC7u \u0111\xf3 theo c\xe1ch th\u1EE7 c\xf4ng.",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.p2.self": "Ch\xfang t\xf4i kh\xf4ng x\xf3a b\u1EA5t k\u1EF3 d\u1EEF li\u1EC7u c\xe1 nh\xe2n n\xe0o kh\u1ECFi n\u1ED9i dung m\xe0 b\u1EA1n ho\u1EB7c ng\u01B0\u1EDDi kh\xe1c \u0111\xe3 t\u1EA1o, nh\u01B0 t\xean ho\u1EB7c \u0111\u1ECBa ch\u1EC9 email \u0111\xe3 \u0111\u01B0\u1EE3c nh\u1EADp v\xe0o trang ho\u1EB7c \u1EA5n ph\u1EA9m. Qu\u1EA3n tr\u1ECB vi\xean s\u1EA3n ph\u1EA9m c\u1EE7a b\u1EA1n c\u1EA7n x\xf3a d\u1EEF li\u1EC7u \u0111\xf3 theo c\xe1ch th\u1EE7 c\xf4ng.",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.p3.admin": "Ng\u01B0\u1EDDi d\xf9ng c\xf3 quy\u1EC1n g\u1EEDi khi\u1EBFu n\u1EA1i cho c\u01A1 quan qu\u1EA3n l\xfd t\u1EA1i qu\u1ED1c gia c\u1EE7a h\u1ECD.",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.p3.self": "B\u1EA1n c\xf3 quy\u1EC1n g\u1EEDi khi\u1EBFu n\u1EA1i cho c\u01A1 quan qu\u1EA3n l\xfd t\u1EA1i qu\u1ED1c gia c\u1EE7a b\u1EA1n.",
    "focused-task-close-account.delete-account.overview.paragraph.about-to-delete.admin": "Khi b\u1EA1n x\xf3a t\xe0i kho\u1EA3n:",
    "focused-task-close-account.delete-account.overview.paragraph.about-to-delete.self": "Khi b\u1EA1n x\xf3a t\xe0i kho\u1EA3n c\u1EE7a m\xecnh:",
    "focused-task-close-account.delete-account.overview.paragraph.content-created.admin": "N\u1ED9i dung m\xe0 h\u1ECD \u0111\xe3 t\u1EA1o s\u1EBD v\u1EABn c\xf3 trong d\u1ECBch v\u1EE5 t\xe0i kho\u1EA3n Atlassian.",
    "focused-task-close-account.delete-account.overview.paragraph.content-created.self": "N\u1ED9i dung m\xe0 b\u1EA1n \u0111\xe3 t\u1EA1o s\u1EBD v\u1EABn c\xf3 trong d\u1ECBch v\u1EE5 t\xe0i kho\u1EA3n Atlassian.",
    "focused-task-close-account.delete-account.overview.paragraph.grace-period.admin": "Sau th\u1EDDi gian \xe2n h\u1EA1n 14 ng\xe0y, b\u1EA1n s\u1EBD kh\xf4ng th\u1EC3 h\u1EE7y x\xf3a t\xe0i kho\u1EA3n.",
    "focused-task-close-account.delete-account.overview.paragraph.list-of-apps-with-personal-data.admin": "Ch\xfang t\xf4i s\u1EBD g\u1EEDi cho b\u1EA1n danh s\xe1ch c\xe1c \u1EE9ng d\u1EE5ng c\xf3 th\u1EC3 \u0111\xe3 l\u01B0u d\u1EEF li\u1EC7u c\xe1 nh\xe2n c\u1EE7a h\u1ECD qua email.",
    "focused-task-close-account.delete-account.overview.paragraph.list-of-apps-with-personal-data.self": "Ch\xfang t\xf4i s\u1EBD g\u1EEDi cho b\u1EA1n danh s\xe1ch c\xe1c \u1EE9ng d\u1EE5ng c\xf3 th\u1EC3 \u0111\xe3 l\u01B0u d\u1EEF li\u1EC7u c\xe1 nh\xe2n c\u1EE7a b\u1EA1n qua email.",
    "focused-task-close-account.delete-account.overview.paragraph.loseAccess.admin": "{fullName} s\u1EBD <b>ngay l\u1EADp t\u1EE9c m\u1EA5t quy\u1EC1n truy c\u1EADp</b> v\xe0o t\u1EA5t c\u1EA3 c\xe1c d\u1ECBch v\u1EE5 t\xe0i kho\u1EA3n Atlassian. H\u1ECD hi\u1EC7n c\xf3 quy\u1EC1n truy c\u1EADp v\xe0o:",
    "focused-task-close-account.delete-account.overview.paragraph.loseAccess.admin.noSites": "{fullName} s\u1EBD <b>ngay l\u1EADp t\u1EE9c m\u1EA5t quy\u1EC1n truy c\u1EADp</b> v\xe0o t\u1EA5t c\u1EA3 c\xe1c d\u1ECBch v\u1EE5 t\xe0i kho\u1EA3n Atlassian. Hi\u1EC7n t\u1EA1i, h\u1ECD kh\xf4ng c\xf3 quy\u1EC1n truy c\u1EADp v\xe0o b\u1EA5t k\u1EF3 d\u1ECBch v\u1EE5 n\xe0o, ngo\u1EA1i tr\u1EEB c\xe1c d\u1ECBch v\u1EE5 nh\u01B0 Community v\xe0 Marketplace.",
    "focused-task-close-account.delete-account.overview.paragraph.loseAccess.footnote": "C\xe1c d\u1ECBch v\u1EE5 t\xe0i kho\u1EA3n Atlassian kh\xe1c, nh\u01B0 Atlassian Community v\xe0 Marketplace.",
    "focused-task-close-account.delete-account.overview.paragraph.loseAccess.self": "B\u1EA1n s\u1EBD <b>ngay l\u1EADp t\u1EE9c m\u1EA5t quy\u1EC1n truy c\u1EADp</b> v\xe0o t\u1EA5t c\u1EA3 c\xe1c d\u1ECBch v\u1EE5 t\xe0i kho\u1EA3n Atlassian. B\u1EA1n hi\u1EC7n c\xf3 quy\u1EC1n truy c\u1EADp v\xe0o:",
    "focused-task-close-account.delete-account.overview.paragraph.loseAccess.self.noSites": "B\u1EA1n s\u1EBD <b>ngay l\u1EADp t\u1EE9c m\u1EA5t quy\u1EC1n truy c\u1EADp</b> v\xe0o t\u1EA5t c\u1EA3 c\xe1c d\u1ECBch v\u1EE5 t\xe0i kho\u1EA3n Atlassian. Hi\u1EC7n t\u1EA1i, b\u1EA1n kh\xf4ng c\xf3 quy\u1EC1n truy c\u1EADp v\xe0o b\u1EA5t k\u1EF3 d\u1ECBch v\u1EE5 n\xe0o, ngo\u1EA1i tr\u1EEB c\xe1c d\u1ECBch v\u1EE5 nh\u01B0 Community v\xe0 Marketplace.",
    "focused-task-close-account.delete-account.overview.paragraph.personal-data-will-be-deleted.admin": "Ch\xfang t\xf4i s\u1EBD <b>x\xf3a d\u1EEF li\u1EC7u c\xe1 nh\xe2n c\u1EE7a h\u1ECD</b>, nh\u01B0 h\u1ECD t\xean v\xe0 \u0111\u1ECBa ch\u1EC9 email, kh\u1ECFi d\u1ECBch v\u1EE5 t\xe0i kho\u1EA3n Atlassian trong v\xf2ng 30 ng\xe0y, tr\u1EEB m\u1ED9t s\u1ED1 tr\u01B0\u1EDDng h\u1EE3p b\u1EAFt bu\u1ED9c ph\u1EA3i l\u01B0u gi\u1EEF cho c\xe1c ho\u1EA1t \u0111\u1ED9ng kinh doanh ch\xednh \u0111\xe1ng ho\u1EB7c m\u1EE5c \u0111\xedch h\u1EE3p ph\xe1p.",
    "focused-task-close-account.delete-account.overview.paragraph.personal-data-will-be-deleted.self": "Ch\xfang t\xf4i s\u1EBD <b>x\xf3a d\u1EEF li\u1EC7u c\xe1 nh\xe2n c\u1EE7a b\u1EA1n</b>, nh\u01B0 h\u1ECD t\xean v\xe0 \u0111\u1ECBa ch\u1EC9 email, kh\u1ECFi d\u1ECBch v\u1EE5 t\xe0i kho\u1EA3n Atlassian trong v\xf2ng 30 ng\xe0y, tr\u1EEB m\u1ED9t s\u1ED1 tr\u01B0\u1EDDng h\u1EE3p b\u1EAFt bu\u1ED9c ph\u1EA3i l\u01B0u gi\u1EEF cho c\xe1c ho\u1EA1t \u0111\u1ED9ng kinh doanh ch\xednh \u0111\xe1ng ho\u1EB7c m\u1EE5c \u0111\xedch h\u1EE3p ph\xe1p.",
    "focused-task-close-account.delete-account.overview.warning-section.body": "Sau th\u1EDDi gian \xe2n h\u1EA1n 14 ng\xe0y, b\u1EA1n s\u1EBD kh\xf4ng th\u1EC3 h\u1EE7y x\xf3a t\xe0i kho\u1EA3n. N\u1EBFu b\u1EA1n cho r\u1EB1ng sau n\xe0y b\u1EA1n s\u1EBD c\u1EA7n \u0111\u1EBFn t\xe0i kho\u1EA3n n\xe0y th\xec thay v\xec x\xf3a, h\xe3y h\u1EE7y k\xedch ho\u1EA1t t\xe0i kho\u1EA3n.",
    "focused-task-close-account.delete-account.overview.warning-section.deactivated.body": "Sau th\u1EDDi gian \xe2n h\u1EA1n 14 ng\xe0y, b\u1EA1n s\u1EBD kh\xf4ng th\u1EC3 h\u1EE7y x\xf3a t\xe0i kho\u1EA3n.",
    "focused-task-close-account.learnMore": "T\xecm hi\u1EC3u th\xeam",
    "focused-task-close-account.next": "Ti\u1EBFp theo",
    "focused-task-close-account.previous": "Tr\u01B0\u1EDBc"
};

});

parcelRegister("al8Xx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7872d0ad6ae29048$export$2e2bcd8739ae039; });
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //
var $7872d0ad6ae29048$export$2e2bcd8739ae039 = {
    "focused-task-close-account.cancel": "Cancel",
    "focused-task-close-account.deactivate-account": "Deactivate account",
    "focused-task-close-account.deactivate-account.overview.first.line.admin": "You're about to deactivate the user account of:",
    "focused-task-close-account.deactivate-account.overview.first.line.self": "You're about to deactivate the user account of:",
    "focused-task-close-account.deactivate-account.overview.heading.admin": "Deactivate account",
    "focused-task-close-account.deactivate-account.overview.heading.self": "Deactivate account",
    "focused-task-close-account.deactivate-account.overview.last.line.admin": "You can reactivate the account at any time.",
    "focused-task-close-account.deactivate-account.overview.last.line.self": "You can reactivate the account at any time.",
    "focused-task-close-account.deactivate-account.overview.paragraph.about-to-deactivate.admin": "When you deactivate the account:",
    "focused-task-close-account.deactivate-account.overview.paragraph.about-to-deactivate.self": "When you deactivate the account:",
    "focused-task-close-account.deactivate-account.overview.paragraph.billing.admin": "We'll no longer bill you for them.",
    "focused-task-close-account.deactivate-account.overview.paragraph.billing.self": "We'll no longer bill you for them.",
    "focused-task-close-account.deactivate-account.overview.paragraph.loseAccess.admin": "{fullName} will <b>immediately lose access</b> to all Atlassian account services. They currently have access to:",
    "focused-task-close-account.deactivate-account.overview.paragraph.loseAccess.admin.noSites": "{fullName} will <b>immediately lose access</b> to all Atlassian account services. Currently, they don\u2019t have access to any, except services like Community and Marketplace.",
    "focused-task-close-account.deactivate-account.overview.paragraph.loseAccess.footnote": "Other Atlassian account services, such as Atlassian Community and Marketplace.",
    "focused-task-close-account.deactivate-account.overview.paragraph.loseAccess.self": "You'll <b>immediately lose access</b> to all Atlassian account services. You currently have access to:",
    "focused-task-close-account.deactivate-account.overview.paragraph.loseAccess.self.noSites": "You'll <b>immediately lose access</b> to all Atlassian account services. Currently, you don\u2019t have access to any, except services like Community and Marketplace.",
    "focused-task-close-account.deactivate-account.overview.paragraph.personal-data.admin": "Their personal data, such as their full name and email address, and content they've created will remain in Atlassian account services.",
    "focused-task-close-account.deactivate-account.overview.paragraph.personal-data.self": "Their personal data, such as their full name and email address, and content they've created will remain in Atlassian account services.",
    "focused-task-close-account.delete-account": "Delete account",
    "focused-task-close-account.delete-account.content-preview.footnote.admin": "Note: Answering this survey will help us make a better experience for all users. The user will still appear as \u201CFormer user\u201D after you delete their account.",
    "focused-task-close-account.delete-account.content-preview.footnote.self": "Note: Answering this survey will help us make a better experience for all users, including those deleting their accounts. You\u2019ll still appear as \u201CFormer user\u201D after you delete your account.",
    "focused-task-close-account.delete-account.content-preview.formerUser": "Former user",
    "focused-task-close-account.delete-account.content-preview.heading.admin": "How would you prefer the deleted user to appear?",
    "focused-task-close-account.delete-account.content-preview.heading.self": "How would you prefer your deleted account to appear?",
    "focused-task-close-account.delete-account.content-preview.line.survey.admin": "If we gave you a choice, how would you like the deleted user to appear to other users?",
    "focused-task-close-account.delete-account.content-preview.line.survey.self": "If we gave you a choice, how would you like to appear to other users?",
    "focused-task-close-account.delete-account.content-preview.paragraph.survey.admin": "After the user\u2019s account is deleted, they\u2019ll appear as \u201CFormer user\u201D to other users. Please take a moment to answer our survey question.",
    "focused-task-close-account.delete-account.content-preview.paragraph.survey.self": "After your account is deleted, you\u2019ll appear as \u201CFormer user\u201D to other users. Please take a moment to answer our survey question.",
    "focused-task-close-account.delete-account.drop-down-collapse-button": "Show less",
    "focused-task-close-account.delete-account.drop-down-expand-button": "{num} more",
    "focused-task-close-account.delete-account.overview.first.line.admin": "You're about to delete the account of:",
    "focused-task-close-account.delete-account.overview.first.line.self": "You're about to delete your account:",
    "focused-task-close-account.delete-account.overview.heading.admin": "Delete account",
    "focused-task-close-account.delete-account.overview.heading.self": "Delete your account",
    "focused-task-close-account.delete-account.overview.inline-dialog.content-created.admin": "For example, pages, issues, and comments they've created in products.",
    "focused-task-close-account.delete-account.overview.inline-dialog.content-created.self": "For example, pages, issues, and comments you've created in products.",
    "focused-task-close-account.delete-account.overview.inline-dialog.data-apps.admin": "You or other users may have installed apps that add features to Atlassian products. These apps may have stored the user\u2019s profile information.",
    "focused-task-close-account.delete-account.overview.inline-dialog.data-apps.self": "You or other users may have installed apps that add features to Atlassian products. These apps may have stored your profile information.",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.li1.admin": "Information related to purchases, which we're required to keep for financial reporting.",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.li1.self": "Information related to purchases, which we're required to keep for financial reporting.",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.li2.admin": "Records showing that we deleted someone's account, which we may need to provide to regulators.",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.li2.self": "Records showing that we deleted someone's account, which we may need to provide to regulators.",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.li3.admin": "Data that's part of an active lawsuit, which we're required to keep by law.",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.li3.self": "Data that's part of an active lawsuit, which we're required to keep by law.",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.p1.admin": "We keep personal data for limited periods when we have legitimate business or legal purposes. Some examples include:",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.p1.self": "We keep personal data for limited periods when we have legitimate business or legal purposes. Some examples include:",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.p2.admin": "We don\u2019t delete any personal data from content created by users, such as names or email addresses they typed in a page or issue. The product admins need to delete that data manually.",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.p2.self": "We don't delete any personal data from content created by you or other people, such as names or email addresses typed into a page or issue. Your product admins need to delete that data manually.",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.p3.admin": "Users have the right to submit complaints to the supervisory authority in their country.",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.p3.self": "You have the right to submit complaints to the supervisory authority in your country.",
    "focused-task-close-account.delete-account.overview.paragraph.about-to-delete.admin": "When you delete the account:",
    "focused-task-close-account.delete-account.overview.paragraph.about-to-delete.self": "When you delete your account:",
    "focused-task-close-account.delete-account.overview.paragraph.content-created.admin": "The content they've created will remain in Atlassian account services.",
    "focused-task-close-account.delete-account.overview.paragraph.content-created.self": "The content you've created will remain in Atlassian account services.",
    "focused-task-close-account.delete-account.overview.paragraph.grace-period.admin": "After a 14-day grace period, you won\u2019t be able to cancel the deletion of the account.",
    "focused-task-close-account.delete-account.overview.paragraph.list-of-apps-with-personal-data.admin": "We\u2019ll email you a list of apps that may have stored their personal data.",
    "focused-task-close-account.delete-account.overview.paragraph.list-of-apps-with-personal-data.self": "We\u2019ll email you a list of apps that may have stored your personal data.",
    "focused-task-close-account.delete-account.overview.paragraph.loseAccess.admin": "{fullName} will <b>immediately lose access</b> to all Atlassian account services. They currently have access to:",
    "focused-task-close-account.delete-account.overview.paragraph.loseAccess.admin.noSites": "{fullName} will <b>immediately lose access</b> to all Atlassian account services. Currently, they don\u2019t have access to any, except services like Community and Marketplace.",
    "focused-task-close-account.delete-account.overview.paragraph.loseAccess.footnote": "Other Atlassian account services, such as Atlassian Community and Marketplace.",
    "focused-task-close-account.delete-account.overview.paragraph.loseAccess.self": "You'll <b>immediately lose access</b> to all Atlassian account services. You currently have access to:",
    "focused-task-close-account.delete-account.overview.paragraph.loseAccess.self.noSites": "You'll <b>immediately lose access</b> to all Atlassian account services. Currently, you don\u2019t have access to any, except services like Community and Marketplace.",
    "focused-task-close-account.delete-account.overview.paragraph.personal-data-will-be-deleted.admin": "We'll <b>delete their personal data</b>, such as their full name and email address, from Atlassian account services within 30 days, except in a few cases where required for legitimate business or legal purposes.",
    "focused-task-close-account.delete-account.overview.paragraph.personal-data-will-be-deleted.self": "We'll <b>delete your personal data</b>, such as your full name and email address, from Atlassian account services within 30 days, except in a few cases where required for legitimate business or legal purposes.",
    "focused-task-close-account.delete-account.overview.warning-section.body": "After a 14-day grace period, you won\u2019t be able to cancel the deletion of the account. If you think you\u2019ll need the account later, deactivate it instead.",
    "focused-task-close-account.delete-account.overview.warning-section.deactivated.body": "After a 14-day grace period, you won\u2019t be able to cancel the deletion of the account.",
    "focused-task-close-account.learnMore": "Learn more",
    "focused-task-close-account.next": "Next",
    "focused-task-close-account.previous": "Previous"
};

});

parcelRegister("kyaiT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ef5ef9bbc2ef5d6d$export$2e2bcd8739ae039; });
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //English (United Kingdom)
var $ef5ef9bbc2ef5d6d$export$2e2bcd8739ae039 = {
    "focused-task-close-account.cancel": "Cancel",
    "focused-task-close-account.deactivate-account": "Deactivate account",
    "focused-task-close-account.deactivate-account.overview.first.line.admin": "You're about to deactivate the user account of:",
    "focused-task-close-account.deactivate-account.overview.first.line.self": "You're about to deactivate the user account of:",
    "focused-task-close-account.deactivate-account.overview.heading.admin": "Deactivate account",
    "focused-task-close-account.deactivate-account.overview.heading.self": "Deactivate account",
    "focused-task-close-account.deactivate-account.overview.last.line.admin": "You can reactivate the account at any time.",
    "focused-task-close-account.deactivate-account.overview.last.line.self": "You can reactivate the account at any time.",
    "focused-task-close-account.deactivate-account.overview.paragraph.about-to-deactivate.admin": "When you deactivate the account:",
    "focused-task-close-account.deactivate-account.overview.paragraph.about-to-deactivate.self": "When you deactivate the account:",
    "focused-task-close-account.deactivate-account.overview.paragraph.billing.admin": "We'll no longer bill you for them.",
    "focused-task-close-account.deactivate-account.overview.paragraph.billing.self": "We'll no longer bill you for them.",
    "focused-task-close-account.deactivate-account.overview.paragraph.loseAccess.admin": "{fullName} will <b>immediately lose access</b> to all Atlassian account services. They currently have access to:",
    "focused-task-close-account.deactivate-account.overview.paragraph.loseAccess.admin.noSites": "{fullName} will <b>immediately lose access</b> to all Atlassian account services. Currently, they don\u2019t have access to any, except services like Community and Marketplace.",
    "focused-task-close-account.deactivate-account.overview.paragraph.loseAccess.footnote": "Other Atlassian account services, such as Atlassian Community and Marketplace.",
    "focused-task-close-account.deactivate-account.overview.paragraph.loseAccess.self": "You'll <b>immediately lose access</b> to all Atlassian account services. You currently have access to:",
    "focused-task-close-account.deactivate-account.overview.paragraph.loseAccess.self.noSites": "You'll <b>immediately lose access</b> to all Atlassian account services. Currently, you don\u2019t have access to any, except services like Community and Marketplace.",
    "focused-task-close-account.deactivate-account.overview.paragraph.personal-data.admin": "Their personal data, such as their full name and email address, and content they've created will remain in Atlassian account services.",
    "focused-task-close-account.deactivate-account.overview.paragraph.personal-data.self": "Their personal data, such as their full name and email address, and content they've created will remain in Atlassian account services.",
    "focused-task-close-account.delete-account": "Delete account",
    "focused-task-close-account.delete-account.content-preview.footnote.admin": "Note: Answering this survey will help us make a better experience for all users. The user will still appear as \u201CFormer user\u201D after you delete their account.",
    "focused-task-close-account.delete-account.content-preview.footnote.self": "Note: Answering this survey will help us make a better experience for all users, including those deleting their accounts. You\u2019ll still appear as \u201CFormer user\u201D after you delete your account.",
    "focused-task-close-account.delete-account.content-preview.formerUser": "Former user",
    "focused-task-close-account.delete-account.content-preview.heading.admin": "How would you prefer the deleted user to appear?",
    "focused-task-close-account.delete-account.content-preview.heading.self": "How would you prefer your deleted account to appear?",
    "focused-task-close-account.delete-account.content-preview.line.survey.admin": "If we gave you a choice, how would you like the deleted user to appear to other users?",
    "focused-task-close-account.delete-account.content-preview.line.survey.self": "If we gave you a choice, how would you like to appear to other users?",
    "focused-task-close-account.delete-account.content-preview.paragraph.survey.admin": "After the user\u2019s account is deleted, they\u2019ll appear as \u201CFormer user\u201D to other users. Please take a moment to answer our survey question.",
    "focused-task-close-account.delete-account.content-preview.paragraph.survey.self": "After your account is deleted, you\u2019ll appear as \u201CFormer user\u201D to other users. Please take a moment to answer our survey question.",
    "focused-task-close-account.delete-account.drop-down-collapse-button": "Show less",
    "focused-task-close-account.delete-account.drop-down-expand-button": "{num} more",
    "focused-task-close-account.delete-account.overview.first.line.admin": "You're about to delete the account of:",
    "focused-task-close-account.delete-account.overview.first.line.self": "You're about to delete your account:",
    "focused-task-close-account.delete-account.overview.heading.admin": "Delete account",
    "focused-task-close-account.delete-account.overview.heading.self": "Delete your account",
    "focused-task-close-account.delete-account.overview.inline-dialog.content-created.admin": "For example, pages, issues, and comments they've created in products.",
    "focused-task-close-account.delete-account.overview.inline-dialog.content-created.self": "For example, pages, issues, and comments you've created in products.",
    "focused-task-close-account.delete-account.overview.inline-dialog.data-apps.admin": "You or other users may have installed apps that add features to Atlassian products. These apps may have stored the user\u2019s profile information.",
    "focused-task-close-account.delete-account.overview.inline-dialog.data-apps.self": "You or other users may have installed apps that add features to Atlassian products. These apps may have stored your profile information.",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.li1.admin": "Information related to purchases, which we're required to keep for financial reporting.",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.li1.self": "Information related to purchases, which we're required to keep for financial reporting.",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.li2.admin": "Records showing that we deleted someone's account, which we may need to provide to regulators.",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.li2.self": "Records showing that we deleted someone's account, which we may need to provide to regulators.",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.li3.admin": "Data that's part of an active lawsuit, which we're required to keep by law.",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.li3.self": "Data that's part of an active lawsuit, which we're required to keep by law.",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.p1.admin": "We keep personal data for limited periods when we have legitimate business or legal purposes. Some examples include:",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.p1.self": "We keep personal data for limited periods when we have legitimate business or legal purposes. Some examples include:",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.p2.admin": "We don\u2019t delete any personal data from content created by users, such as names or email addresses they typed in a page or issue. The product admins need to delete that data manually.",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.p2.self": "We don't delete any personal data from content created by you or other people, such as names or email addresses typed into a page or issue. Your product admins need to delete that data manually.",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.p3.admin": "Users have the right to submit complaints to the supervisory authority in their country.",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.p3.self": "You have the right to submit complaints to the supervisory authority in your country.",
    "focused-task-close-account.delete-account.overview.paragraph.about-to-delete.admin": "When you delete the account:",
    "focused-task-close-account.delete-account.overview.paragraph.about-to-delete.self": "When you delete your account:",
    "focused-task-close-account.delete-account.overview.paragraph.content-created.admin": "The content they've created will remain in Atlassian account services.",
    "focused-task-close-account.delete-account.overview.paragraph.content-created.self": "The content you've created will remain in Atlassian account services.",
    "focused-task-close-account.delete-account.overview.paragraph.grace-period.admin": "After a 14-day grace period, you won\u2019t be able to cancel the deletion of the account.",
    "focused-task-close-account.delete-account.overview.paragraph.list-of-apps-with-personal-data.admin": "We\u2019ll email you a list of apps that may have stored their personal data.",
    "focused-task-close-account.delete-account.overview.paragraph.list-of-apps-with-personal-data.self": "We\u2019ll email you a list of apps that may have stored your personal data.",
    "focused-task-close-account.delete-account.overview.paragraph.loseAccess.admin": "{fullName} will <b>immediately lose access</b> to all Atlassian account services. They currently have access to:",
    "focused-task-close-account.delete-account.overview.paragraph.loseAccess.admin.noSites": "{fullName} will <b>immediately lose access</b> to all Atlassian account services. Currently, they don\u2019t have access to any, except services like Community and Marketplace.",
    "focused-task-close-account.delete-account.overview.paragraph.loseAccess.footnote": "Other Atlassian account services, such as Atlassian Community and Marketplace.",
    "focused-task-close-account.delete-account.overview.paragraph.loseAccess.self": "You'll <b>immediately lose access</b> to all Atlassian account services. You currently have access to:",
    "focused-task-close-account.delete-account.overview.paragraph.loseAccess.self.noSites": "You'll <b>immediately lose access</b> to all Atlassian account services. Currently, you don\u2019t have access to any, except services like Community and Marketplace.",
    "focused-task-close-account.delete-account.overview.paragraph.personal-data-will-be-deleted.admin": "We'll <b>delete their personal data</b>, such as their full name and email address, from Atlassian account services within 30 days, except in a few cases where required for legitimate business or legal purposes.",
    "focused-task-close-account.delete-account.overview.paragraph.personal-data-will-be-deleted.self": "We'll <b>delete your personal data</b>, such as your full name and email address, from Atlassian account services within 30 days, except in a few cases where required for legitimate business or legal purposes.",
    "focused-task-close-account.delete-account.overview.warning-section.body": "After a 14-day grace period, you won\u2019t be able to cancel the deletion of the account. If you think you\u2019ll need the account later, deactivate it instead.",
    "focused-task-close-account.delete-account.overview.warning-section.deactivated.body": "After a 14-day grace period, you won\u2019t be able to cancel the deletion of the account.",
    "focused-task-close-account.learnMore": "Learn more",
    "focused-task-close-account.next": "Next",
    "focused-task-close-account.previous": "Previous"
};

});

parcelRegister("2Mydj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $206a9a982da008f3$export$2e2bcd8739ae039; });
/**
 * NOTE:
 *
 * This file is automatically generated by i18n-tools.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ // Icelandic
var $206a9a982da008f3$export$2e2bcd8739ae039 = {
    "focused-task-close-account.deactivate-account": "Gera reikning \xf3virkan",
    "focused-task-close-account.delete-account": "Ey\xf0a reikningi",
    "focused-task-close-account.learnMore": "F\xe1\xf0u a\xf0 vita meira ",
    "focused-task-close-account.cancel": "H\xe6tta vi\xf0 ",
    "focused-task-close-account.next": "N\xe6sta",
    "focused-task-close-account.previous": "Fyrra",
    "focused-task-close-account.delete-account.overview.heading.self": "\xdeegar reikningnum \xfe\xednum er eytt",
    "focused-task-close-account.delete-account.overview.heading.admin": "Ey\xf0a reikningi",
    "focused-task-close-account.delete-account.overview.first.line.self": "\xde\xfa er vi\xf0 \xfea\xf0 a\xf0 ey\xf0a reikningnum \xfe\xednum:",
    "focused-task-close-account.delete-account.overview.first.line.admin": "\xde\xfa er vi\xf0 \xfea\xf0 a\xf0 ey\xf0a reikningi:",
    "focused-task-close-account.delete-account.overview.warning-section.body": "Eftir 14-daga grei\xf0slufrest muntu ekki geta h\xe6tt vi\xf0 ey\xf0ingu reikningsins. Ef \xfe\xfa heldur a\xf0 \xfe\xfa g\xe6tir \xfeurft \xe1 honum a\xf0 halda s\xed\xf0ar, ger\xf0u hann \xfe\xe1 frekar \xf3virkan.",
    "focused-task-close-account.delete-account.overview.warning-section.deactivated.body": " Eftir 14-daga grei\xf0slufrest muntu ekki geta h\xe6tt vi\xf0 ey\xf0ingu reikningsins.",
    "focused-task-close-account.delete-account.overview.paragraph.about-to-delete.admin": "\xdeegar \xfe\xfa ey\xf0a reikningum:",
    "focused-task-close-account.delete-account.overview.paragraph.about-to-delete.self": "\xdeegar \xfe\xfa ey\xf0ir reikningum \xfe\xednum:",
    "focused-task-close-account.delete-account.overview.paragraph.loseAccess.admin": "{fullName} mun <b>tafarlaust missa a\xf0gang</b> a\xf0 allri Atlassian reiknings\xfej\xf3nustu. \xcd augnablikinu hafa \xfeeir a\xf0gang a\xf0:",
    "focused-task-close-account.delete-account.overview.paragraph.loseAccess.self": "\xde\xfa munt <b>tafarlaust missa a\xf0gang</b> a\xf0 allri Atlassian reiknings\xfej\xf3nustu. \xcd augnablikinu hefur \xfe\xfa a\xf0gang a\xf0:",
    "focused-task-close-account.delete-account.overview.paragraph.loseAccess.admin.noSites": "{fullName} mun <b>tafarlaust missa a\xf0gang</b> a\xf0 allri Atlassian reiknings\xfej\xf3nustu.  \xcd augnablikinu hafa \xfeeir a\xf0gang a\xf0 neinni \xfej\xf3nustu nema \xfej\xf3nustu eins og Community og Marketplace.",
    "focused-task-close-account.delete-account.overview.paragraph.loseAccess.self.noSites": "\xde\xfa munt<b>tafarlaust missa a\xf0gang</b> a\xf0 allri Atlassian reiknings\xfej\xf3nustu. \xcd augnablikinu hefur \xfe\xfa ekki a\xf0gang a\xf0 neinni \xfej\xf3nustu nema \xfej\xf3nustu eins og Community og Marketplace.",
    "focused-task-close-account.delete-account.overview.paragraph.loseAccess.footnote": "\xd6nnur Atlassian reiknings\xfej\xf3nusta, eins og Atlassian Community og Marketplace.",
    "focused-task-close-account.delete-account.overview.paragraph.content-created.admin": "Innihaldi\xf0 sem notandi hefur b\xfai\xf0 til mun vera \xe1framhaldandi \xed Atlassian reiknings\xfej\xf3nustu.",
    "focused-task-close-account.delete-account.overview.paragraph.content-created.self": "Innihaldi\xf0 sem \xfe\xfa hefur b\xfai\xf0 til mun vera \xe1framhaldandi \xed Atlassian reiknings\xfej\xf3nustu.",
    "focused-task-close-account.delete-account.overview.inline-dialog.content-created.admin": "Til d\xe6mis s\xed\xf0ur, m\xe1lefni og athugasemdir sem \xfeeir hafa b\xfai\xf0 til \xed v\xf6rum.",
    "focused-task-close-account.delete-account.overview.inline-dialog.content-created.self": "Til d\xe6mis s\xed\xf0ur, m\xe1lefni og athugasemdir sem \xfe\xfa hefur b\xfai\xf0 til \xed v\xf6rum.",
    "focused-task-close-account.delete-account.overview.paragraph.personal-data-will-be-deleted.admin": "Vi\xf0 munum <b>ey\xf0a pers\xf3nuuppl\xfdsingunum \xfeeirra</b>, eins og til d\xe6mis fullu nafni og netfangi, af Atlassian reikningum innan 30 daga, a\xf0 \xf6rf\xe1um tilvikum undanskildum \xfear sem \xfe\xe6r eru nau\xf0synlegar fyrir l\xf6gleg fyrirt\xe6ki og \xed lagalegum tilgangi.",
    "focused-task-close-account.delete-account.overview.paragraph.personal-data-will-be-deleted.self": "Vi\xf0 munum <b>ey\xf0a pers\xf3nuuppl\xfdsingunum \xfe\xednum</b>, eins og til d\xe6mis fullu nafni og netfangi, af Atlassian reikningum innan 30 daga, a\xf0 \xf6rf\xe1um tilvikum undanskildum \xfear sem \xfe\xe6r eru nau\xf0synlegar fyrir l\xf6gleg fyrirt\xe6ki og \xed lagalegum tilgangi.",
    "focused-task-close-account.delete-account.overview.paragraph.list-of-apps-with-personal-data.admin": "Vi\xf0 munum senda \xfe\xe9r lista me\xf0 t\xf6lvup\xf3sti af forritum sem g\xe6tu hafa geymt pers\xf3nuuppl\xfdsingarnar \xfeeirra. ",
    "focused-task-close-account.delete-account.overview.paragraph.list-of-apps-with-personal-data.self": "Vi\xf0 munum senda \xfe\xe9r lista me\xf0 t\xf6lvup\xf3sti af forritum sem g\xe6tu hafa geymt pers\xf3nuuppl\xfdsingarnar \xfe\xednar. ",
    "focused-task-close-account.delete-account.overview.paragraph.grace-period.admin": " Eftir 14-daga grei\xf0slufrest muntu ekki geta h\xe6tt vi\xf0 ey\xf0ingu reikningsins.",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.p1.admin": "Vi\xf0 geymum pers\xf3nuuppl\xfdsingar \xed takmarka\xf0an t\xedma \xfeegar um l\xf6gleg fyrirt\xe6ki e\xf0a lagalegan tilgang er a\xf0 r\xe6\xf0a. Sum \xfeessara tilvika eru:",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.p1.self": "Vi\xf0 geymum pers\xf3nuuppl\xfdsingar \xed takmarka\xf0an t\xedma \xfeegar um l\xf6gleg fyrirt\xe6ki e\xf0a lagalegan tilgang er a\xf0 r\xe6\xf0a. Sum \xfeessara tilvika eru:",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.li1.admin": "Uppl\xfdsingar sem tengjast v\xf6rukaupum sem okkur er \xe1skili\xf0 a\xf0 geyma fyrir fj\xe1rhagslegar sk\xfdrsluger\xf0ir.",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.li1.self": "Uppl\xfdsingar sem tengjast v\xf6rukaupum sem okkur er \xe1skili\xf0 a\xf0 geyma fyrir fj\xe1rhagslegar sk\xfdrsluger\xf0ir.",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.li2.admin": "G\xf6gn sem s\xfdna a\xf0 vi\xf0 h\xf6fum eytt reikningi einhvers, sem vi\xf0 g\xe6tum \xfeurft a\xf0 gefa upp til eftirlitsa\xf0ila.",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.li2.self": "G\xf6gn sem s\xfdna a\xf0 vi\xf0 h\xf6fum eytt reikningi einhvers, sem vi\xf0 g\xe6tum \xfeurft a\xf0 gefa upp til eftirlitsa\xf0ila.",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.li3.admin": "G\xf6gn sem eru hluti af virkri m\xe1lss\xf3kn, sem okkur er \xe1skili\xf0 a\xf0 geyma samkv\xe6mt l\xf6gum.",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.li3.self": "G\xf6gn sem eru hluti af virkri m\xe1lss\xf3kn, sem okkur er \xe1skili\xf0 a\xf0 geyma samkv\xe6mt l\xf6gum.",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.p2.admin": "Vi\xf0 ey\xf0um ekki neinum pers\xf3nuuppl\xfdsingum \xfar innihaldi sem b\xfai\xf0 til var af notendum, eins og n\xf6fnum og netf\xf6ngum sem \xfeeir sl\xf3gu inn \xe1 s\xed\xf0u e\xf0a m\xe1lefni. V\xf6rustj\xf3rnendurnir ver\xf0a a\xf0 ey\xf0a \xfeeim uppl\xfdsingum handvirkt.",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.p2.self": "Vi\xf0 ey\xf0um ekki neinum pers\xf3nuuppl\xfdsingum \xfar innihaldi sem b\xfai\xf0 til var af \xfe\xe9r e\xf0a \xf6\xf0rum a\xf0ilum, eins og n\xf6fnum og netf\xf6ngum sem slegin hafa veri\xf0 inn \xe1 s\xed\xf0u e\xf0a m\xe1lefni. V\xf6rustj\xf3rnendurnir \xfe\xednir ver\xf0a a\xf0 ey\xf0a \xfeeim uppl\xfdsingum handvirkt.",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.p3.admin": "Notendur hafa r\xe9tt \xe1 \xfev\xed a\xf0 leggja fram kvartanir til eftirlitsstofnunar landsins s\xedns.",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.p3.self": "\xde\xfa hefur r\xe9tt \xe1 \xfev\xed a\xf0 leggja fram kvartanir til eftirlitsstofnunar landsins \xfe\xedns.",
    "focused-task-close-account.delete-account.overview.inline-dialog.data-apps.admin": "\xde\xfa og a\xf0rir notendur g\xe6tu\xf0 hafa sett upp forrit sem b\xe6ta eiginleikum vi\xf0 Atlassian v\xf6rur. \xdeessi forrit g\xe6tu hafa geymt notendas\xed\xf0uuppl\xfdsingar notandans.",
    "focused-task-close-account.delete-account.overview.inline-dialog.data-apps.self": "\xde\xfa og a\xf0rir notendur g\xe6tu\xf0 hafa sett upp forrit sem b\xe6ta eiginleikum vi\xf0 Atlassian v\xf6rur. \xdeessi forrit g\xe6tu hafa geymt notendas\xed\xf0uuppl\xfdsingar notandans.",
    "focused-task-close-account.deactivate-account.overview.heading.self": "Gera reikning \xf3virkan",
    "focused-task-close-account.deactivate-account.overview.heading.admin": "Gera reikning \xf3virkan",
    "focused-task-close-account.deactivate-account.overview.first.line.self": "\xde\xfa er vi\xf0 \xfea\xf0 a\xf0 sl\xf6kkva reikningi:",
    "focused-task-close-account.deactivate-account.overview.first.line.admin": "\xde\xfa er vi\xf0 \xfea\xf0 a\xf0 sl\xf6kkva reikningi:",
    "focused-task-close-account.deactivate-account.overview.last.line.self": "\xde\xfa getur endurvirkja\xf0 reikninginn hven\xe6r sem er.",
    "focused-task-close-account.deactivate-account.overview.last.line.admin": "\xde\xfa getur endurvirkja\xf0 reikninginn hven\xe6r sem er.",
    "focused-task-close-account.deactivate-account.overview.paragraph.about-to-deactivate.admin": "\xdeegar \xfe\xfa sl\xf6kkva \xe1 reikningum:",
    "focused-task-close-account.deactivate-account.overview.paragraph.about-to-deactivate.self": "\xdeegar \xfe\xfa sl\xf6kkva \xe1 reikningum:",
    "focused-task-close-account.deactivate-account.overview.paragraph.loseAccess.admin": "{fullName} mun <b>tafarlaust missa a\xf0gang</b> a\xf0 allri Atlassian reiknings\xfej\xf3nustu. \xcd augnablikinu hafa \xfeeir a\xf0gang a\xf0:",
    "focused-task-close-account.deactivate-account.overview.paragraph.loseAccess.self": "\xde\xfa munt <b>tafarlaust missa a\xf0gang</b> a\xf0 allri Atlassian reiknings\xfej\xf3nustu. \xcd augnablikinu hefur \xfe\xfa a\xf0gang a\xf0:",
    "focused-task-close-account.deactivate-account.overview.paragraph.loseAccess.admin.noSites": "{fullName} mun <b>tafarlaust missa a\xf0gang</b> a\xf0 allri Atlassian reiknings\xfej\xf3nustu.  \xcd augnablikinu hafa \xfeeir a\xf0gang a\xf0 neinni \xfej\xf3nustu nema \xfej\xf3nustu eins og Community og Marketplace.",
    "focused-task-close-account.deactivate-account.overview.paragraph.loseAccess.self.noSites": "\xde\xfa munt<b>tafarlaust missa a\xf0gang</b> a\xf0 allri Atlassian reiknings\xfej\xf3nustu. \xcd augnablikinu hefur \xfe\xfa ekki a\xf0gang a\xf0 neinni \xfej\xf3nustu nema \xfej\xf3nustu eins og Community og Marketplace.",
    "focused-task-close-account.deactivate-account.overview.paragraph.loseAccess.footnote": "\xd6nnur Atlassian reiknings\xfej\xf3nusta, eins og Atlassian Community og Marketplace.",
    "focused-task-close-account.deactivate-account.overview.paragraph.personal-data.admin": "Pers\xf3nuleg g\xf6gn, svo sem fullt nafn og netfang, og innihaldi\xf0 sem notandi hefur b\xfai\xf0 til mun vera \xe1framhaldandi \xed Atlassian reiknings\xfej\xf3nustu.",
    "focused-task-close-account.deactivate-account.overview.paragraph.personal-data.self": "Pers\xf3nuleg g\xf6gn, svo sem fullt nafn og netfang, og innihaldi\xf0 sem notandi hefur b\xfai\xf0 til mun vera \xe1framhaldandi \xed Atlassian reiknings\xfej\xf3nustu.",
    "focused-task-close-account.deactivate-account.overview.paragraph.billing.admin": "Vi\xf0 munum ekki rukka \xfeig lengur fyrir \xfe\xe6r.",
    "focused-task-close-account.deactivate-account.overview.paragraph.billing.self": "Vi\xf0 munum ekki rukka \xfeig lengur fyrir \xfe\xe6r.",
    "focused-task-close-account.delete-account.content-preview.heading.admin": "Hvernig myndir \xfe\xfa vilja a\xf0 notandinn sem eytt hefur veri\xf0 myndi birtast?",
    "focused-task-close-account.delete-account.content-preview.heading.self": "Hvernig myndir \xfe\xfa vilja a\xf0 reikningi sem eytt hefur veri\xf0 myndi birtast?",
    "focused-task-close-account.delete-account.content-preview.paragraph.survey.admin": "Eftir a\xf0 reikningi notandans hefur veri\xf0 eytt mun vi\xf0komandi birtast \xf6\xf0rum notendum sem \u201EFyrrum notandi\u201C. Vinsamlegast gef\xf0u \xfe\xe9r sm\xe1 stund til a\xf0 svara spurningu k\xf6nnunarinnar okkar.",
    "focused-task-close-account.delete-account.content-preview.paragraph.survey.self": "Eftir a\xf0 reikningnum \xfe\xednum hefur veri\xf0 eytt muntu birtast \xf6\xf0rum notendum sem \u201EFyrrum notandi\u201C. Vinsamlegast gef\xf0u \xfe\xe9r sm\xe1 stund til a\xf0 svara spurningu k\xf6nnunarinnar okkar.",
    "focused-task-close-account.delete-account.content-preview.line.survey.admin": "Ef vi\xf0 g\xe6fum \xfe\xe9r val, hvernig myndir \xfe\xfa vilja a\xf0 notandinn sem eytt hefur veri\xf0 myndi birtast \xf6\xf0rum notendum?",
    "focused-task-close-account.delete-account.content-preview.line.survey.self": "Ef vi\xf0 g\xe6fum \xfe\xe9r val, hvernig myndir \xfe\xfa vilja birtast \xf6\xf0rum notendum?",
    "focused-task-close-account.delete-account.content-preview.footnote.admin": "Athugi\xf0: Me\xf0 \xfev\xed a\xf0 svara \xfeessari k\xf6nnun getur\xf0u hj\xe1lpa\xf0 okkur vi\xf0 a\xf0 gera upplifunina betri fyrir alla notendur. Notandinn mun \xe1fram birtast sem \u201EFyrrum notandi\u201C eftir a\xf0 \xfe\xfa ey\xf0ir reikningi vi\xf0komandi.",
    "focused-task-close-account.delete-account.content-preview.footnote.self": "Athugi\xf0: Me\xf0 \xfev\xed a\xf0 svara \xfeessari k\xf6nnun getur\xf0u hj\xe1lpa\xf0 okkur vi\xf0 a\xf0 gera upplifunina betri fyrir alla notendur, \xfear \xe1 me\xf0al fyrir \xfe\xe1 sem eru a\xf0 ey\xf0a reikningum s\xednum. \xde\xfa munt \xe1fram birtast sem \u201EFyrrum notandi\u201C eftir a\xf0 \xfe\xfa ey\xf0ir reikningnum \xfe\xednum.",
    "focused-task-close-account.delete-account.content-preview.formerUser": "Fyrrum notandi",
    "focused-task-close-account.delete-account.drop-down-expand-button": "{num} meira",
    "focused-task-close-account.delete-account.drop-down-collapse-button": "S\xfdna minna "
};

});

parcelRegister("5rCkh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3f6d34253608d3d9$export$2e2bcd8739ae039; });
/**
 * NOTE:
 *
 * This file is automatically generated by i18n-tools.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ // Romanian
var $3f6d34253608d3d9$export$2e2bcd8739ae039 = {
    "focused-task-close-account.deactivate-account": "Dezactivare cont",
    "focused-task-close-account.delete-account": "\u0218tergere cont",
    "focused-task-close-account.learnMore": "Afla\u021Bi mai multe",
    "focused-task-close-account.cancel": "Anulare",
    "focused-task-close-account.next": "\xcenainte",
    "focused-task-close-account.previous": "\xcenapoi",
    "focused-task-close-account.delete-account.overview.heading.self": "\u0218tergerea contului dvs.",
    "focused-task-close-account.delete-account.overview.heading.admin": "\u0218tergere cont",
    "focused-task-close-account.delete-account.overview.first.line.self": "Urmeaz\u0103 s\u0103 v\u0103 \u0219terge\u021Bi contul:",
    "focused-task-close-account.delete-account.overview.first.line.admin": "Urmeaz\u0103 s\u0103 \u0219terge\u021Bi contul lui:",
    "focused-task-close-account.delete-account.overview.warning-section.body": "Dup\u0103 perioada de gra\u021Bie de 14 zile, nu vom mai putea anula \u0219tergerea contului. Dac\u0103 crede\u021Bi c\u0103 ve\u021Bi avea nevoie de cont ulterior, dezactiva\u021Bi-l mai bine.",
    "focused-task-close-account.delete-account.overview.warning-section.deactivated.body": "Dup\u0103 perioada de gra\u021Bie de 14 zile, nu vom mai putea anula \u0219tergerea contului.",
    "focused-task-close-account.delete-account.overview.paragraph.about-to-delete.admin": "C\xe2nd \u0219terge\u021Bi contul:",
    "focused-task-close-account.delete-account.overview.paragraph.about-to-delete.self": "C\xe2nd v\u0103 \u0219terge\u021Bi contul:",
    "focused-task-close-account.delete-account.overview.paragraph.loseAccess.admin": "{fullName} va <b>pierde imediat accesul</b> la toate serviciile din contul Atlassian. \xcen acest moment, persoana are acces la:",
    "focused-task-close-account.delete-account.overview.paragraph.loseAccess.self": "Ve\u021Bi <b>pierde imediat accesul</b> la toate serviciile din contul Altassian. \xcen acest moment, ave\u021Bi acces la:",
    "focused-task-close-account.delete-account.overview.paragraph.loseAccess.admin.noSites": "{fullName} va <b>pierde imediat accesul</b> la toate serviciile din contul Atlassian. \xcen acest moment, persoana nu are acces la niciun serviciu, cu excep\u021Bia Comunitate \u0219i Marketplace.",
    "focused-task-close-account.delete-account.overview.paragraph.loseAccess.self.noSites": "Ve\u021Bi <b>pierde imediat accesul</b> la toate serviciile din contul Altassian. \xcen acest moment, nu ave\u021Bi acces la niciun serviciu, cu excep\u021Bia Comunitate \u0219i Marketplace.",
    "focused-task-close-account.delete-account.overview.paragraph.loseAccess.footnote": "Alte servicii din contul Atlassian, precum Comunitate \u0219i Marketplace Atlassian.",
    "focused-task-close-account.delete-account.overview.paragraph.content-created.admin": "Con\u021Binutul creat va r\u0103m\xe2ne \xeen serviciile din contul Atlassian.",
    "focused-task-close-account.delete-account.overview.paragraph.content-created.self": "Con\u021Binutul pe care l-a\u021Bi creat va r\u0103m\xe2ne \xeen serviciile din contul Atlassian.",
    "focused-task-close-account.delete-account.overview.inline-dialog.content-created.admin": "De exemplu, paginile, problemele \u0219i comentariile pe care le-au creat \xeen produse.",
    "focused-task-close-account.delete-account.overview.inline-dialog.content-created.self": "De exemplu, paginile, problemele \u0219i comentariile pe care le-a\u021Bi creat \xeen produse.",
    "focused-task-close-account.delete-account.overview.paragraph.personal-data-will-be-deleted.admin": "Vom <b>\u0219terge datele cu caracter personal</b>, precum numele complet \u0219i adresa de e-mail, din serviciile contului Atlassian \xeentr-un interval de 30 de zile, cu excep\u021Bia unor cazuri obligatorii din motive legale sau de afaceri.",
    "focused-task-close-account.delete-account.overview.paragraph.personal-data-will-be-deleted.self": "Vom <b>\u0219terge datele dvs. cu caracter personal</b>, precum numele complet \u0219i adresa de e-mail, din serviciile contului Atlassian \xeentr-un interval de 30 de zile, cu excep\u021Bia unor cazuri obligatorii din motive legale sau de afaceri.",
    "focused-task-close-account.delete-account.overview.paragraph.list-of-apps-with-personal-data.admin": "V\u0103 vom trimite prin e-mail o list\u0103 cu aplica\u021Biile care au stocat datele acestora cu caracter personal.",
    "focused-task-close-account.delete-account.overview.paragraph.list-of-apps-with-personal-data.self": "V\u0103 vom trimite prin e-mail o list\u0103 cu aplica\u021Biile care au stocat datele dvs. cu caracter personal.",
    "focused-task-close-account.delete-account.overview.paragraph.grace-period.admin": "Dup\u0103 perioada de gra\u021Bie de 14 zile, nu vom mai putea anula \u0219tergerea contului.",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.p1.admin": "P\u0103str\u0103m datele cu caracter personal pentru perioade limitate de timp, din motive legale sau de afaceri. Unele exemple includ:",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.p1.self": "P\u0103str\u0103m datele cu caracter personal pentru perioade limitate de timp, din motive legale sau de afaceri. Unele exemple includ:",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.li1.admin": "Informa\u021Bii privind achizi\u021Biile, pe care suntem obliga\u021Bi s\u0103 le p\u0103str\u0103m pentru raport\u0103rile financiare.",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.li1.self": "Informa\u021Bii privind achizi\u021Biile, pe care suntem obliga\u021Bi s\u0103 le p\u0103str\u0103m pentru raport\u0103rile financiare.",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.li2.admin": "\xcenregistr\u0103rile care demonstreaz\u0103 c\u0103 am \u0219ters contul unei persoane, pe care le putem prezenta agen\u021Biilor de reglementare.",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.li2.self": "\xcenregistr\u0103rile care demonstreaz\u0103 c\u0103 am \u0219ters contul unei persoane, pe care le putem prezenta agen\u021Biilor de reglementare.",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.li3.admin": "Datele care fac parte dintr-o ac\u021Biune \xeen justi\u021Bie, pe care avem obliga\u021Bia legal\u0103 de a le p\u0103stra.",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.li3.self": "Datele care fac parte dintr-o ac\u021Biune \xeen justi\u021Bie, pe care avem obliga\u021Bia legal\u0103 de a le p\u0103stra.",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.p2.admin": "Nu vom \u0219terge datele cu caracter personal din con\u021Binutul creat de utilizatori, precum numele sau adresele de e-mail introduse pe o pagin\u0103 sau la o problem\u0103. Adminii de produs trebuie s\u0103 \u0219tearg\u0103 aceste date manual.",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.p2.self": "Nu vom \u0219terge datele cu caracter personal din con\u021Binutul creat de dvs. sau de alte persoane, precum numele sau adresele de e-mail introduse pe o pagin\u0103 sau la o problem\u0103. Adminii produselor dvs. trebuie s\u0103 \u0219tearg\u0103 aceste date manual.",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.p3.admin": "Utilizatorii au dreptul de a trimite pl\xe2ngeri c\u0103tre autoritatea de supraveghere din \u021Bara natal\u0103.",
    "focused-task-close-account.delete-account.overview.inline-dialog.personal-data-will-be-deleted.p3.self": "Ave\u021Bi dreptul de a trimite pl\xe2ngeri c\u0103tre autoritatea de supraveghere din \u021Bara natal\u0103.",
    "focused-task-close-account.delete-account.overview.inline-dialog.data-apps.admin": "Dvs. sau al\u021Bi utilizatori a\u021Bi instalat aplica\u021Bii care adaug\u0103 func\u021Bii produselor Atlassian. Este posibil ca aceste aplica\u021Bii s\u0103 fi stocat informa\u021Bii privind profilul utilizatorului.",
    "focused-task-close-account.delete-account.overview.inline-dialog.data-apps.self": "Dvs. sau al\u021Bi utilizatori a\u021Bi instalat aplica\u021Bii care adaug\u0103 func\u021Bii produselor Atlassian. Este posibil ca aceste aplica\u021Bii s\u0103 fi stocat informa\u021Bii privind profilul dvs.",
    "focused-task-close-account.deactivate-account.overview.heading.self": "Dezactivare cont",
    "focused-task-close-account.deactivate-account.overview.heading.admin": "Dezactivare cont",
    "focused-task-close-account.deactivate-account.overview.first.line.self": "Urmeaz\u0103 s\u0103 dezactiva\u021Bi contul de utilizator al lui:",
    "focused-task-close-account.deactivate-account.overview.first.line.admin": "Urmeaz\u0103 s\u0103 dezactiva\u021Bi contul de utilizator al lui:",
    "focused-task-close-account.deactivate-account.overview.last.line.self": "Pute\u021Bi reactiva contul oric\xe2nd.",
    "focused-task-close-account.deactivate-account.overview.last.line.admin": "Pute\u021Bi reactiva contul oric\xe2nd.",
    "focused-task-close-account.deactivate-account.overview.paragraph.about-to-deactivate.admin": "C\xe2nd dezactiva\u021Bi contul:",
    "focused-task-close-account.deactivate-account.overview.paragraph.about-to-deactivate.self": "C\xe2nd dezactiva\u021Bi contul:",
    "focused-task-close-account.deactivate-account.overview.paragraph.loseAccess.admin": "{fullName} va <b>pierde imediat accesul</b> la toate serviciile din contul Atlassian. \xcen acest moment, persoana are acces la:",
    "focused-task-close-account.deactivate-account.overview.paragraph.loseAccess.self": "Ve\u021Bi <b>pierde imediat accesul</b> la toate serviciile din contul Altassian. \xcen acest moment, ave\u021Bi acces la:",
    "focused-task-close-account.deactivate-account.overview.paragraph.loseAccess.admin.noSites": "{fullName} va <b>pierde imediat accesul</b> la toate serviciile din contul Atlassian. \xcen acest moment, persoana nu are acces la niciun serviciu, cu excep\u021Bia Comunitate \u0219i Marketplace.",
    "focused-task-close-account.deactivate-account.overview.paragraph.loseAccess.self.noSites": "Ve\u021Bi <b>pierde imediat accesul</b> la toate serviciile din contul Altassian. \xcen acest moment, nu ave\u021Bi acces la niciun serviciu, cu excep\u021Bia Comunitate \u0219i Marketplace.",
    "focused-task-close-account.deactivate-account.overview.paragraph.loseAccess.footnote": "Alte servicii din contul Atlassian, precum Comunitate \u0219i Marketplace Atlassian.",
    "focused-task-close-account.deactivate-account.overview.paragraph.personal-data.admin": "Datele cu caracter personal, precum numele complet \u0219i adresa de e-mail, \u0219i con\u021Binutul creat vor r\u0103m\xe2ne \xeen serviciile de cont Atlassian.",
    "focused-task-close-account.deactivate-account.overview.paragraph.personal-data.self": "Datele cu caracter personal, precum numele complet \u0219i adresa de e-mail, \u0219i con\u021Binutul creat vor r\u0103m\xe2ne \xeen serviciile de cont Atlassian.",
    "focused-task-close-account.deactivate-account.overview.paragraph.billing.admin": "Nu ve\u021Bi mai fi tarifat pentru aceste conturi.",
    "focused-task-close-account.deactivate-account.overview.paragraph.billing.self": "Nu ve\u021Bi mai fi tarifat pentru aceste conturi.",
    "focused-task-close-account.delete-account.content-preview.heading.admin": "Cum a\u021Bi dori s\u0103 apar\u0103 utilizatorul \u0219ters?",
    "focused-task-close-account.delete-account.content-preview.heading.self": "Cum a\u021Bi dori s\u0103 apar\u0103 contul \u0219ters?",
    "focused-task-close-account.delete-account.content-preview.paragraph.survey.admin": "Ulterior \u0219tergerii contului utilizatorului, acesta va ap\u0103rea ca \u201EFost utilizator\u201D fa\u021B\u0103 de al\u021Bi utilizatori. Acorda\u021Bi un moment r\u0103spunsului la \xeentrebarea din sondajul nostru.",
    "focused-task-close-account.delete-account.content-preview.paragraph.survey.self": "Ulterior \u0219tergerii contului dvs., ve\u021Bi ap\u0103rea ca \u201EFost utilizator\u201D fa\u021B\u0103 de al\u021Bi utilizatori. Acorda\u021Bi un moment r\u0103spunsului la \xeentrebarea din sondajul nostru.",
    "focused-task-close-account.delete-account.content-preview.line.survey.admin": "Dac\u0103 a\u021Bi avea de ales, cum a\u021Bi dori s\u0103 apar\u0103 utilizatorul \u0219ters fa\u021B\u0103 de ceilal\u021Bi utilizatori?",
    "focused-task-close-account.delete-account.content-preview.line.survey.self": "Dac\u0103 a\u021Bi avea de ales, cum a\u021Bi dori s\u0103 ap\u0103re\u021Bi fa\u021B\u0103 de ceilal\u021Bi utilizatori?",
    "focused-task-close-account.delete-account.content-preview.footnote.admin": "Not\u0103: R\u0103spunsul \xeen acest sondaj ne va ajuta s\u0103 cre\u0103m o experien\u021B\u0103 \xeembun\u0103t\u0103\u021Bit\u0103 pentru toti utilizatorii. Utilizatorul va ap\u0103rea \xeen continuare ca \u201EFost utilizator\u201D ulterior \u0219tergerii contului.",
    "focused-task-close-account.delete-account.content-preview.footnote.self": "Not\u0103: R\u0103spunsul \xeen acest sondaj ne va ajuta s\u0103 cre\u0103m o experien\u021B\u0103 \xeembun\u0103t\u0103\u021Bit\u0103 pentru to\u021Bi utilizatorii, inclusiv cei care \xee\u0219i vor \u0219terge conturile. Ve\u021Bi ap\u0103rea \xeen continuare ca \u201EFost utilizator\u201D ulterior \u0219tergerii contului.",
    "focused-task-close-account.delete-account.content-preview.formerUser": "Fost utilizator",
    "focused-task-close-account.delete-account.drop-down-expand-button": "\xcenc\u0103 {num}",
    "focused-task-close-account.delete-account.drop-down-collapse-button": "Afi\u0219are mai pu\u021Bine"
};

});






parcelRegister("7TFao", function(module, exports) {

var $kFH64 = parcelRequire("kFH64");

});
parcelRegister("kFH64", function(module, exports) {

var $8TMbA = parcelRequire("8TMbA");

var $5MUML = parcelRequire("5MUML");

var $dXLvS = parcelRequire("dXLvS");

var $4irYd = parcelRequire("4irYd");

var $lKQfu = parcelRequire("lKQfu");

var $fKxww = parcelRequire("fKxww");

var $ilqjt = parcelRequire("ilqjt");

var $iDtim = parcelRequire("iDtim");

var $dAx5m = parcelRequire("dAx5m");

var $55TWT = parcelRequire("55TWT");

var $d5Kdn = parcelRequire("d5Kdn");

var $jrFqr = parcelRequire("jrFqr");

var $e2MCy = parcelRequire("e2MCy");

var $05eJd = parcelRequire("05eJd");
function $f0c911255e04541d$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $f0c911255e04541d$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, (/*@__PURE__*/$parcel$interopDefault($ilqjt)))(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, (/*@__PURE__*/$parcel$interopDefault($ilqjt)))(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, (/*@__PURE__*/$parcel$interopDefault($fKxww)))(this, result);
    };
}
function $f0c911255e04541d$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($f0c911255e04541d$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $f0c911255e04541d$export$619a632ea416d25a = /*#__PURE__*/ function(_React$Component) {
    (0, (/*@__PURE__*/$parcel$interopDefault($lKQfu)))(DeleteUserContentPreviewScreen, _React$Component);
    var _super = $f0c911255e04541d$var$_createSuper(DeleteUserContentPreviewScreen);
    function DeleteUserContentPreviewScreen() {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($5MUML)))(this, DeleteUserContentPreviewScreen);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, (/*@__PURE__*/$parcel$interopDefault($iDtim)))((0, (/*@__PURE__*/$parcel$interopDefault($4irYd)))(_this), "state", {
            currentActive: -1
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($iDtim)))((0, (/*@__PURE__*/$parcel$interopDefault($4irYd)))(_this), "handleClickSection", function(userName, position) {
            return function() {
                _this.props.preferenceSelection(userName);
                _this.setState({
                    currentActive: position
                });
            };
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($iDtim)))((0, (/*@__PURE__*/$parcel$interopDefault($4irYd)))(_this), "isCardSelected", function(position) {
            return position === _this.state.currentActive;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($iDtim)))((0, (/*@__PURE__*/$parcel$interopDefault($4irYd)))(_this), "selectAdminOrSelfCopy", function(adminCopy, selfCopy) {
            return _this.props.isCurrentUser ? selfCopy : adminCopy;
        });
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($dXLvS)))(DeleteUserContentPreviewScreen, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.props.preferenceSelection("");
            }
        },
        {
            key: "render",
            value: function render() {
                var user = this.props.user;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $05eJd.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement($e2MCy.Screen, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement($e2MCy.Title, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $55TWT.default), this.selectAdminOrSelfCopy((0, $jrFqr.contentPreviewMessages).headingAdmin, (0, $jrFqr.contentPreviewMessages).headingSelf))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $55TWT.default), (0, (/*@__PURE__*/$parcel$interopDefault($8TMbA)))({}, this.selectAdminOrSelfCopy((0, $jrFqr.contentPreviewMessages).paragraphSurveyAdmin, (0, $jrFqr.contentPreviewMessages).paragraphSurveySelf), {
                    tagName: "p"
                })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $55TWT.default), (0, (/*@__PURE__*/$parcel$interopDefault($8TMbA)))({}, this.selectAdminOrSelfCopy((0, $jrFqr.contentPreviewMessages).lineSurveyAdmin, (0, $jrFqr.contentPreviewMessages).lineSurveySelf), {
                    tagName: "p"
                })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement($e2MCy.SectionCard, {
                    className: "nameSectionCard",
                    onClick: this.handleClickSection("Name", 1),
                    isSelected: 1 === this.state.currentActive
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement($e2MCy.Avatar, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $d5Kdn.default), {
                    size: "large",
                    src: ""
                })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement($e2MCy.UserDetails, null, user.fullName)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement($e2MCy.SectionCard, {
                    className: "formerUserSectionCard",
                    onClick: this.handleClickSection("Former User", 0),
                    isSelected: 0 === this.state.currentActive
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement($e2MCy.Avatar, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $d5Kdn.default), {
                    size: "large",
                    src: ""
                })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement($e2MCy.UserDetails, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $55TWT.default), (0, $jrFqr.contentPreviewMessages).formerUser))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $55TWT.default), (0, (/*@__PURE__*/$parcel$interopDefault($8TMbA)))({}, this.selectAdminOrSelfCopy((0, $jrFqr.contentPreviewMessages).footnoteAdmin, (0, $jrFqr.contentPreviewMessages).footnoteSelf), {
                    tagName: "p"
                }))));
            }
        }
    ]);
    return DeleteUserContentPreviewScreen;
}((0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).Component);
var $f0c911255e04541d$export$2e2bcd8739ae039 = $f0c911255e04541d$export$619a632ea416d25a;

});
parcelRegister("d5Kdn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $987f9744180f6621$export$2e2bcd8739ae039; });

var $iDtim = parcelRequire("iDtim");

var $45N2i = parcelRequire("45N2i");

var $dAx5m = parcelRequire("dAx5m");

var $jVTBW = parcelRequire("jVTBW");

var $D9YLo = parcelRequire("D9YLo");

var $nLm1R = parcelRequire("nLm1R");

var $lmjFT = parcelRequire("lmjFT");

var $1SX2H = parcelRequire("1SX2H");

var $es8Gl = parcelRequire("es8Gl");

var $8wg12 = parcelRequire("8wg12");

var $li7cx = parcelRequire("li7cx");

var $kKEdL = parcelRequire("kKEdL");

var $68EOj = parcelRequire("68EOj");
var $987f9744180f6621$var$_templateObject;
function $987f9744180f6621$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $987f9744180f6621$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $987f9744180f6621$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($iDtim)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $987f9744180f6621$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $987f9744180f6621$var$packageName = "@atlaskit/avatar";
var $987f9744180f6621$var$packageVersion = "21.9.0";
// eslint-disable-next-line @repo/internal/react/consistent-types-definitions
var $987f9744180f6621$var$getStyles = function getStyles(css, _ref) {
    var size = _ref.size, radius = _ref.radius, appearance = _ref.appearance, _ref$borderColor = _ref.borderColor, borderColor = _ref$borderColor === void 0 ? "var(--ds-surface-overlay, ".concat((0, $lmjFT.N0), ")") : _ref$borderColor, stackIndex = _ref.stackIndex, isInteractive = _ref.isInteractive, isDisabled = _ref.isDisabled;
    return css($987f9744180f6621$var$_templateObject || ($987f9744180f6621$var$_templateObject = (0, (/*@__PURE__*/$parcel$interopDefault($45N2i)))([
        "\n    height: ",
        "px;\n    width: ",
        "px;\n    align-items: stretch;\n    background-color: ",
        ";\n    border-radius: ",
        ";\n    box-sizing: content-box;\n    cursor: inherit;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    outline: none;\n    overflow: hidden;\n    position: static;\n    transform: translateZ(0);\n    transition: transform 200ms, opacity 200ms;\n    box-shadow: 0 0 0 ",
        "px ",
        ";\n    border: none;\n    margin: ",
        ";\n    padding: ",
        ";\n\n    /* Added font-size and font-family styles to fix alignment issue in firefox for interactive button avatar */\n    font-size: inherit;\n    font-family: inherit;\n\n    &::-moz-focus-inner {\n      border: 0;\n      margin: ",
        ";\n      padding: ",
        ";\n    }\n\n    &::after {\n      background-color: transparent;\n      inset: 0px;\n\n      /* Added border-radius style to fix hover issue in safari */\n      border-radius: ",
        ";\n      content: ' ';\n      opacity: 0;\n      pointer-events: none;\n      position: absolute;\n      transition: opacity 200ms;\n      width: 100%;\n    }\n\n    ",
        "\n\n    ",
        "\n\n    ",
        "\n  "
    ])), size, size, borderColor, appearance === "circle" ? "50%" : "".concat(radius, "px"), (0, $es8Gl.BORDER_WIDTH), borderColor, "var(--ds-space-025, 2px)", "var(--ds-space-0, 0px)", "var(--ds-space-0, 0px)", "var(--ds-space-0, 0px)", appearance === "circle" ? "50%" : "".concat(radius, "px"), stackIndex && "position: relative;", isInteractive && "\n      cursor: pointer;\n\n      :focus {\n        outline: none;\n        box-shadow: 0 0 0 ".concat((0, $es8Gl.BORDER_WIDTH), "px ", "var(--ds-border-focused, ".concat((0, $lmjFT.B300), ")"), "\n      }\n\n      :hover {\n        &::after {\n          background-color: ", "var(--ds-interaction-hovered, ".concat((0, $lmjFT.N70A), ")"), ";\n          opacity: 1;\n        }\n      }\n\n      :active {\n        &::after {\n          background-color: ", "var(--ds-interaction-pressed, ".concat((0, $lmjFT.N70A), ")"), ";\n          opacity: 1;\n        }\n      }\n\n      :active {\n        transform: scale(").concat((0, $es8Gl.ACTIVE_SCALE_FACTOR), ");\n      }\n\n      @media screen and (forced-colors: active) {\n        &:focus-visible {\n          outline: 1px solid\n        }\n      }\n    "), isDisabled && "\n        cursor: not-allowed;\n\n        &::after {\n          opacity: ".concat("var(--ds-opacity-disabled, 0.7)", ";\n          pointer-events: none;\n          background-color: ", "var(--ds-surface, ".concat((0, $lmjFT.N0), ")"), ";\n        }\n      "));
};
/**
 * __Avatar__
 *
 * An avatar is a visual representation of a user or entity.
 *
 * - [Examples](https://atlassian.design/components/avatar/examples)
 * - [Code](https://atlassian.design/components/avatar/code)
 * - [Usage](https://atlassian.design/components/avatar/usage)
 */ var $987f9744180f6621$var$Avatar = /*#__PURE__*/ (0, $dAx5m.forwardRef)(function(_ref2, ref) {
    var analyticsContext = _ref2.analyticsContext, _ref2$appearance = _ref2.appearance, appearance = _ref2$appearance === void 0 ? "circle" : _ref2$appearance, label = _ref2.label, borderColor = _ref2.borderColor, children = _ref2.children, href = _ref2.href, isDisabled = _ref2.isDisabled, name = _ref2.name, onClick = _ref2.onClick, presence = _ref2.presence, _ref2$size = _ref2.size, sizeProp = _ref2$size === void 0 ? "medium" : _ref2$size, src = _ref2.src, stackIndex = _ref2.stackIndex, status = _ref2.status, target = _ref2.target, testId = _ref2.testId, _ref2$as = _ref2.as, AvatarContainer = _ref2$as === void 0 ? "div" : _ref2$as;
    var _useAnalyticsEvents = (0, $nLm1R.useAnalyticsEvents)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    var context = (0, $8wg12.useAvatarContext)();
    var size = (context === null || context === void 0 ? void 0 : context.size) || sizeProp;
    var customPresenceNode = /*#__PURE__*/ (0, $dAx5m.isValidElement)(presence) ? presence : null;
    var customStatusNode = /*#__PURE__*/ (0, $dAx5m.isValidElement)(status) ? status : null;
    var isValidIconSize = size !== "xxlarge" && size !== "xsmall";
    var lastAnalytics = (0, $dAx5m.useRef)(analyticsContext);
    var uuid = (0, $D9YLo.useUIDSeed)()("avatar");
    (0, $dAx5m.useEffect)(function() {
        lastAnalytics.current = analyticsContext;
    }, [
        analyticsContext
    ]);
    var onClickHandler = (0, $dAx5m.useCallback)(function(event) {
        if (isDisabled || typeof onClick !== "function") return;
        var analyticsEvent = createAnalyticsEvent({
            action: "clicked",
            actionSubject: "avatar",
            attributes: {
                componentName: "avatar",
                packageName: $987f9744180f6621$var$packageName,
                packageVersion: $987f9744180f6621$var$packageVersion
            }
        });
        /**
     * To avoid wrapping this component in AnalyticsContext we manually
     * push the parent context's meta data into the context.
     */ var context = $987f9744180f6621$var$_objectSpread({
            componentName: "avatar",
            packageName: $987f9744180f6621$var$packageName,
            packageVersion: $987f9744180f6621$var$packageVersion
        }, lastAnalytics.current);
        analyticsEvent.context.push(context);
        /**
     * Replicating the logic in the `withAnalyticsEvents` HOC.
     */ var clone = analyticsEvent.clone();
        if (clone) clone.fire("atlaskit");
        onClick(event, analyticsEvent);
    }, [
        createAnalyticsEvent,
        isDisabled,
        onClick
    ]);
    var getTestId = function getTestId(testId, children) {
        return !children ? {
            "data-testid": "".concat(testId, "--inner")
        } : {
            testId: "".concat(testId, "--inner")
        };
    };
    var componentProps = function componentProps() {
        if (isDisabled) return {
            disabled: true
        };
        // return only relevant props for either anchor or button elements
        return $987f9744180f6621$var$_objectSpread($987f9744180f6621$var$_objectSpread({}, href && (0, $68EOj.getLinkProps)(href, target)), onClick && !href ? (0, $68EOj.getButtonProps)(onClickHandler) : {
            onClick: onClick
        });
    };
    var isPresence = isValidIconSize && presence && !status;
    var isStatus = isValidIconSize && status;
    // add presence or status to the label by default if presence and status are passed as a string
    // if status or presence are nodes this is not added to the label by default
    var defaultLabel = [
        name,
        isStatus && !customStatusNode && "(".concat(status, ")"),
        isPresence && !customPresenceNode && "(".concat(presence, ")")
    ].filter(Boolean).join(" ");
    var isInteractive = onClick || href || isDisabled;
    var containerShouldBeImage = Boolean(!isInteractive && defaultLabel);
    return (0, $jVTBW.jsx)(AvatarContainer, {
        "data-testid": testId,
        role: containerShouldBeImage ? "img" : undefined,
        "aria-labelledby": containerShouldBeImage ? "".concat(uuid, "-label") : undefined,
        style: {
            display: "inline-block",
            position: "relative",
            outline: 0,
            zIndex: stackIndex
        }
    }, (0, $jVTBW.jsx)((0, $jVTBW.ClassNames), null, function(_ref3) {
        var css = _ref3.css;
        var props = $987f9744180f6621$var$_objectSpread($987f9744180f6621$var$_objectSpread($987f9744180f6621$var$_objectSpread($987f9744180f6621$var$_objectSpread({
            className: $987f9744180f6621$var$getStyles(css, {
                size: (0, $es8Gl.AVATAR_SIZES)[size],
                radius: (0, $es8Gl.AVATAR_RADIUS)[size],
                appearance: appearance,
                borderColor: borderColor,
                stackIndex: stackIndex,
                isInteractive: Boolean(href || onClick) && !isDisabled,
                isDisabled: isDisabled
            })
        }, componentProps()), testId && getTestId(testId, children)), (isInteractive || children) && {
            "aria-label": label || defaultLabel
        }), {}, {
            children: (0, $jVTBW.jsx)((0, $1SX2H.default), {
                alt: !containerShouldBeImage && src ? name : undefined,
                appearance: appearance,
                size: size,
                src: src,
                testId: testId
            }),
            ref: ref
        });
        return children ? children(props) : /*#__PURE__*/ (0, $dAx5m.createElement)((0, $68EOj.getCustomElement)(isDisabled, href, onClick), props);
    }), isPresence && (0, $jVTBW.jsx)((0, $li7cx.PresenceWrapper), {
        appearance: appearance,
        size: size,
        presence: typeof presence === "string" ? presence : undefined,
        testId: testId
    }, customPresenceNode), isStatus && (0, $jVTBW.jsx)((0, $kKEdL.StatusWrapper), {
        appearance: appearance,
        size: size,
        borderColor: borderColor,
        status: typeof status === "string" ? status : undefined,
        testId: testId
    }, customStatusNode), containerShouldBeImage ? (0, $jVTBW.jsx)("span", {
        "data-testid": testId && "".concat(testId, "--label"),
        id: "".concat(uuid, "-label"),
        hidden: true
    }, defaultLabel) : undefined);
});
$987f9744180f6621$var$Avatar.displayName = "Avatar";
var $987f9744180f6621$export$2e2bcd8739ae039 = $987f9744180f6621$var$Avatar;

});
parcelRegister("1SX2H", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $15f8a23929b14e59$export$2e2bcd8739ae039; });

var $iDtim = parcelRequire("iDtim");

var $6RxC1 = parcelRequire("6RxC1");

var $dAx5m = parcelRequire("dAx5m");

var $jVTBW = parcelRequire("jVTBW");

var $22Dd6 = parcelRequire("22Dd6");

var $76HNn = parcelRequire("76HNn");

var $lmjFT = parcelRequire("lmjFT");

var $es8Gl = parcelRequire("es8Gl");
function $15f8a23929b14e59$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $15f8a23929b14e59$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $15f8a23929b14e59$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($iDtim)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $15f8a23929b14e59$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $15f8a23929b14e59$export$ebe0b8fe8b6acbfd = "var(--ds-icon-inverse, ".concat((0, $lmjFT.N0), ")");
var $15f8a23929b14e59$export$72502e51aebdd94e = "var(--ds-icon-subtle, ".concat((0, $lmjFT.N90), ")");
var $15f8a23929b14e59$var$avatarDefaultIconStyles = (0, $jVTBW.css)({
    display: "block",
    width: "100%",
    height: "100%",
    backgroundColor: $15f8a23929b14e59$export$72502e51aebdd94e
});
var $15f8a23929b14e59$var$nestedAvatarStyles = Object.entries((0, $es8Gl.AVATAR_SIZES)).reduce(function(styles, _ref) {
    var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($6RxC1)))(_ref, 2), key = _ref2[0], size = _ref2[1];
    return $15f8a23929b14e59$var$_objectSpread($15f8a23929b14e59$var$_objectSpread({}, styles), {}, (0, (/*@__PURE__*/$parcel$interopDefault($iDtim)))({}, key, (0, $jVTBW.css)({
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
        "& svg": {
            width: "".concat(size, "px"),
            height: "".concat(size, "px")
        }
    })));
}, {});
var $15f8a23929b14e59$var$avatarImageStyles = (0, $jVTBW.css)({
    display: "flex",
    width: "100%",
    height: "100%",
    flex: "1 1 100%"
});
/**
 * __Avatar image__
 *
 * An avatar image is an internal component used to control the rendering phases of an image.
 */ var $15f8a23929b14e59$var$AvatarImage = function AvatarImage(_ref3) {
    var _ref3$alt = _ref3.alt, alt = _ref3$alt === void 0 ? "" : _ref3$alt, src = _ref3.src, appearance = _ref3.appearance, size = _ref3.size, testId = _ref3.testId;
    var _useState = (0, $dAx5m.useState)(false), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($6RxC1)))(_useState, 2), hasImageErrored = _useState2[0], setHasImageErrored = _useState2[1];
    var borderRadius = appearance === "circle" ? "50%" : "".concat((0, $es8Gl.AVATAR_RADIUS)[size], "px");
    var isHidden = !alt ? true : undefined;
    // If src changes, reset state
    (0, $dAx5m.useEffect)(function() {
        setHasImageErrored(false);
    }, [
        src
    ]);
    if (!src || hasImageErrored) return (0, $jVTBW.jsx)("span", {
        css: [
            $15f8a23929b14e59$var$avatarDefaultIconStyles,
            $15f8a23929b14e59$var$nestedAvatarStyles[size]
        ]
    }, appearance === "circle" ? (0, $jVTBW.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($22Dd6))), {
        label: alt,
        primaryColor: $15f8a23929b14e59$export$ebe0b8fe8b6acbfd,
        secondaryColor: $15f8a23929b14e59$export$72502e51aebdd94e,
        testId: testId && "".concat(testId, "--person"),
        "aria-hidden": isHidden
    }) : (0, $jVTBW.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($76HNn))), {
        label: alt,
        primaryColor: $15f8a23929b14e59$export$ebe0b8fe8b6acbfd,
        secondaryColor: $15f8a23929b14e59$export$72502e51aebdd94e,
        testId: testId && "".concat(testId, "--ship"),
        "aria-hidden": isHidden
    }));
    return (0, $jVTBW.jsx)("img", {
        src: src,
        alt: alt,
        "data-testid": testId && "".concat(testId, "--image"),
        css: $15f8a23929b14e59$var$avatarImageStyles,
        style: {
            borderRadius: borderRadius
        },
        onError: function onError() {
            return setHasImageErrored(true);
        },
        "aria-hidden": isHidden
    });
};
var $15f8a23929b14e59$export$2e2bcd8739ae039 = $15f8a23929b14e59$var$AvatarImage;

});
parcelRegister("22Dd6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $17ca2f015a703d43$var$_react = $17ca2f015a703d43$var$_interopRequireDefault((parcelRequire("dAx5m")));

var $3AZdd = parcelRequire("3AZdd");

var $17ca2f015a703d43$var$_person = $17ca2f015a703d43$var$_interopRequireDefault((parcelRequire("jezmK")));
function $17ca2f015a703d43$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $17ca2f015a703d43$var$PersonIcon = (props)=>/*#__PURE__*/ $17ca2f015a703d43$var$_react.default.createElement($3AZdd.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="M6 14c0-1.105.902-2 2.009-2h7.982c1.11 0 2.009.894 2.009 2.006v4.44c0 3.405-12 3.405-12 0z"/><circle cx="12" cy="7" r="4"/></g></svg>`
    }, props, {
        newIcon: $17ca2f015a703d43$var$_person.default
    }));
$17ca2f015a703d43$var$PersonIcon.displayName = "PersonIcon";
var $17ca2f015a703d43$var$_default = module.exports.default = $17ca2f015a703d43$var$PersonIcon;

});
parcelRegister("jezmK", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::112dba5b505c6a9c25d6aa59e6867dde>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e00ac20a3e206b71$var$_react = $e00ac20a3e206b71$var$_interopRequireDefault((parcelRequire("dAx5m")));

var $e00ac20a3e206b71$var$_UNSAFE_baseNew = $e00ac20a3e206b71$var$_interopRequireDefault((parcelRequire("jbpyS")));
function $e00ac20a3e206b71$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Person".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Known uses: representing a person or user, owner, contributor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e00ac20a3e206b71$var$PersonIcon = (props)=>/*#__PURE__*/ $e00ac20a3e206b71$var$_react.default.createElement($e00ac20a3e206b71$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M13.25 15v-2.25a3 3 0 0 0-3-3h-4.5a3 3 0 0 0-3 3V15m8.5-11a3.25 3.25 0 1 1-6.5 0 3.25 3.25 0 0 1 6.5 0Z"/>`
    }, props));
$e00ac20a3e206b71$var$PersonIcon.displayName = "PersonIcon";
var $e00ac20a3e206b71$var$_default = module.exports.default = $e00ac20a3e206b71$var$PersonIcon;

});


parcelRegister("76HNn", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $52cb10cc526991a0$var$_react = $52cb10cc526991a0$var$_interopRequireDefault((parcelRequire("dAx5m")));

var $3AZdd = parcelRequire("3AZdd");

var $52cb10cc526991a0$var$_release = $52cb10cc526991a0$var$_interopRequireDefault((parcelRequire("01lkg")));
function $52cb10cc526991a0$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $52cb10cc526991a0$var$ShipIcon = (props)=>/*#__PURE__*/ $52cb10cc526991a0$var$_react.default.createElement($3AZdd.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path fill-rule="nonzero" d="M6 12h8v-2H6zM4 8.99C4 8.445 4.456 8 5.002 8h9.996C15.55 8 16 8.451 16 8.99V14H4z"/><path d="M6 7.005C6 5.898 6.898 5 7.998 5h2.004C11.106 5 12 5.894 12 7.005V10H6zm4 0V7H7.999c.005 0 .002.003.002.005V8h2z"/><path fill-rule="nonzero" d="M4.5 17h13.994l1.002-3H4.14zm-2.495-4.012A.862.862 0 0 1 2.883 12h18.393c.55 0 .857.417.681.944l-1.707 5.112c-.174.521-.758.944-1.315.944H3.725a1.15 1.15 0 0 1-1.118-.988z"/></g></svg>`
    }, props, {
        newIcon: $52cb10cc526991a0$var$_release.default
    }));
$52cb10cc526991a0$var$ShipIcon.displayName = "ShipIcon";
var $52cb10cc526991a0$var$_default = module.exports.default = $52cb10cc526991a0$var$ShipIcon;

});
parcelRegister("01lkg", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d0402f1ef768e7347d258c7ff3a4357a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0040a300d88c4f5b$var$_react = $0040a300d88c4f5b$var$_interopRequireDefault((parcelRequire("dAx5m")));

var $0040a300d88c4f5b$var$_UNSAFE_baseNew = $0040a300d88c4f5b$var$_interopRequireDefault((parcelRequire("jbpyS")));
function $0040a300d88c4f5b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Release".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for releases in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0040a300d88c4f5b$var$ReleaseIcon = (props)=>/*#__PURE__*/ $0040a300d88c4f5b$var$_react.default.createElement($0040a300d88c4f5b$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="M.75 7.75V7a.75.75 0 0 0-.75.75zm14.5 0 .646.382A.75.75 0 0 0 15.25 7zm-12.5-3V4a.75.75 0 0 0-.75.75zm6.25 0 .648-.378A.75.75 0 0 0 9 4zm-4.25-2V2H4v.75zm1.5 0H7V2h-.75zm6.113 9.886.646.382zm2.241-5.268-2.887 4.886 1.292.764 2.887-4.886zM11.287 12.5H2V14h9.287zM1.5 12V7.75H0V12zM.75 8.5h2V7h-2zm2.75-.75v-3H2v3zm-.75.75h8V7h-8zm8 0h4.5V7h-4.5zM8.352 5.128l1.75 3 1.296-.756-1.75-3zM2.75 5.5h2V4h-2zm2.75-.75v-2H4v2zM4.75 3.5h1.5V2h-1.5zm0 2h1.5V4h-1.5zm1.5 0H9V4H6.25zM5.5 2.75v2H7v-2zM2 12.5a.5.5 0 0 1-.5-.5H0a2 2 0 0 0 2 2zm9.717-.246a.5.5 0 0 1-.43.246V14a2 2 0 0 0 1.722-.982z"/>`
    }, props));
$0040a300d88c4f5b$var$ReleaseIcon.displayName = "ReleaseIcon";
var $0040a300d88c4f5b$var$_default = module.exports.default = $0040a300d88c4f5b$var$ReleaseIcon;

});


parcelRegister("es8Gl", function(module, exports) {

$parcel$export(module.exports, "AVATAR_SIZES", function () { return $a85a6a4a53cb1213$export$9a270941bcff7e77; });
$parcel$export(module.exports, "AVATAR_RADIUS", function () { return $a85a6a4a53cb1213$export$e6da6efe4d1a5c9b; });
$parcel$export(module.exports, "BORDER_WIDTH", function () { return $a85a6a4a53cb1213$export$e2bd4c1faded7921; });
$parcel$export(module.exports, "ACTIVE_SCALE_FACTOR", function () { return $a85a6a4a53cb1213$export$89a980dfdf90df51; });
$parcel$export(module.exports, "ICON_SIZES", function () { return $a85a6a4a53cb1213$export$fdc820179f1f9be4; });
$parcel$export(module.exports, "ICON_OFFSET", function () { return $a85a6a4a53cb1213$export$382610e783aa2ae8; });
// eslint-disable-next-line @repo/internal/fs/filename-pattern-match, @atlaskit/design-system/no-deprecated-imports

var $hrGjC = parcelRequire("hrGjC");
var $a85a6a4a53cb1213$export$9a270941bcff7e77 = {
    xsmall: (0, $hrGjC.gridSize)() * 2,
    small: (0, $hrGjC.gridSize)() * 3,
    medium: (0, $hrGjC.gridSize)() * 4,
    large: (0, $hrGjC.gridSize)() * 5,
    xlarge: (0, $hrGjC.gridSize)() * 12,
    xxlarge: (0, $hrGjC.gridSize)() * 16
};
var $a85a6a4a53cb1213$export$e6da6efe4d1a5c9b = {
    xsmall: 2,
    small: 2,
    medium: 3,
    large: 3,
    xlarge: 6,
    xxlarge: 12
};
var $a85a6a4a53cb1213$export$e2bd4c1faded7921 = 2;
var $a85a6a4a53cb1213$export$89a980dfdf90df51 = 0.9;
var $a85a6a4a53cb1213$export$3c061e31594ebabe = "--avatar-background-color";
var $a85a6a4a53cb1213$export$fdc820179f1f9be4 = {
    small: 12,
    medium: 14,
    large: 15,
    xlarge: 18
};
var $a85a6a4a53cb1213$export$382610e783aa2ae8 = {
    small: 0,
    medium: 0,
    large: 1,
    xlarge: 7
};

});


parcelRegister("8wg12", function(module, exports) {

$parcel$export(module.exports, "useAvatarContext", function () { return $633dbc4c42c81251$export$b50b87a1c4086b23; });

var $dAx5m = parcelRequire("dAx5m");
var $633dbc4c42c81251$export$a20dad690e1279e2 = /*#__PURE__*/ (0, $dAx5m.createContext)(undefined);
var $633dbc4c42c81251$export$b50b87a1c4086b23 = function useAvatarContext() {
    return (0, $dAx5m.useContext)($633dbc4c42c81251$export$a20dad690e1279e2);
};

});

parcelRegister("li7cx", function(module, exports) {

$parcel$export(module.exports, "PresenceWrapper", function () { return $f800dd6eb97c3262$export$972c5e90200fa0ef; });
// eslint-disable-next-line @repo/internal/fs/filename-pattern-match

var $dAx5m = parcelRequire("dAx5m");

var $lmjFT = parcelRequire("lmjFT");

var $es8Gl = parcelRequire("es8Gl");

var $ccAtW = parcelRequire("ccAtW");
var $f800dd6eb97c3262$var$BusyIndicator = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $dAx5m.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement("circle", {
    fill: "var(--ds-icon-danger, ".concat((0, $lmjFT.R300), ")"),
    cx: "4",
    cy: "4",
    r: "4"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement("path", {
    fill: "var(--ds-surface-overlay, ".concat((0, $lmjFT.N0), ")"),
    d: "M3.3,1.9l2.8,2.8c0.2,0.2,0.2,0.5,0,0.7L5.4,6.1c-0.2,0.2-0.5,0.2-0.7,0L1.9,3.3c-0.2-0.2-0.2-0.5,0-0.7l0.7-0.7C2.8,1.7,3.1,1.7,3.3,1.9z"
}));
var $f800dd6eb97c3262$var$FocusIndicator = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $dAx5m.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement("path", {
    fill: "var(--ds-icon-discovery, ".concat((0, $lmjFT.P300), ")"),
    d: "M4,8 C1.790861,8 0,6.209139 0,4 C0,1.790861 1.790861,0 4,0 C6.209139,0 8,1.790861 8,4 C8,6.209139 6.209139,8 4,8 Z M4,6.66666667 C5.47275933,6.66666667 6.66666667,5.47275933 6.66666667,4 C6.66666667,2.52724067 5.47275933,1.33333333 4,1.33333333 C2.52724067,1.33333333 1.33333333,2.52724067 1.33333333,4 C1.33333333,5.47275933 2.52724067,6.66666667 4,6.66666667 Z M4,5.33333333 C3.26362033,5.33333333 2.66666667,4.73637967 2.66666667,4 C2.66666667,3.26362033 3.26362033,2.66666667 4,2.66666667 C4.73637967,2.66666667 5.33333333,3.26362033 5.33333333,4 C5.33333333,4.73637967 4.73637967,5.33333333 4,5.33333333 Z"
}));
var $f800dd6eb97c3262$var$OfflineIndicator = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $dAx5m.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement("path", {
    fill: "var(--ds-text-subtlest, ".concat((0, $lmjFT.N200), ")"),
    d: "M4,8 C6.209139,8 8,6.209139 8,4 C8,1.790861 6.209139,0 4,0 C1.790861,0 0,1.790861 0,4 C0,6.209139 1.790861,8 4,8 Z M4,6 C5.1045695,6 6,5.1045695 6,4 C6,2.8954305 5.1045695,2 4,2 C2.8954305,2 2,2.8954305 2,4 C2,5.1045695 2.8954305,6 4,6 Z"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement("path", {
    fill: "var(--ds-surface-overlay, ".concat((0, $lmjFT.N40), ")"),
    d: "M4,6 C5.1045695,6 6,5.1045695 6,4 C6,2.8954305 5.1045695,2 4,2 C2.8954305,2 2,2.8954305 2,4 C2,5.1045695 2.8954305,6 4,6 Z"
}));
var $f800dd6eb97c3262$var$OnlineIndicator = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement("circle", {
    fill: "var(--ds-icon-success, ".concat((0, $lmjFT.G300), ")"),
    cx: "4",
    cy: "4",
    r: "4"
});
function $f800dd6eb97c3262$var$getPresence(presence) {
    switch(presence){
        case "busy":
            return $f800dd6eb97c3262$var$BusyIndicator;
        case "focus":
            return $f800dd6eb97c3262$var$FocusIndicator;
        case "offline":
            return $f800dd6eb97c3262$var$OfflineIndicator;
        case "online":
            return $f800dd6eb97c3262$var$OnlineIndicator;
    }
}
/**
 * __Avatar presence__
 *
 * A presence shows an avatar’s availability.
 *
 * - [Examples](https://atlassian.design/components/avatar/avatar-presence/examples)
 * - [Code](https://atlassian.design/components/avatar/avatar-presence/code)
 * - [Usage](https://atlassian.design/components/avatar/avatar-presence/usage)
 */ var $f800dd6eb97c3262$var$AvatarPresence = function AvatarPresence(_ref) {
    var borderColor = _ref.borderColor, children = _ref.children, presence = _ref.presence;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $ccAtW.default), {
        bgColor: borderColor
    }, presence ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement("svg", {
        height: "100%",
        version: "1.1",
        viewBox: "0 0 8 8",
        width: "100%",
        xmlns: "http://www.w3.org/2000/svg"
    }, $f800dd6eb97c3262$var$getPresence(presence)) : children);
};
var $f800dd6eb97c3262$export$2e2bcd8739ae039 = $f800dd6eb97c3262$var$AvatarPresence;
var $f800dd6eb97c3262$export$972c5e90200fa0ef = function PresenceWrapper(_ref2) {
    var size = _ref2.size, appearance = _ref2.appearance, children = _ref2.children, borderColor = _ref2.borderColor, presence = _ref2.presence, testId = _ref2.testId;
    var position = appearance === "square" ? -4 : (0, $es8Gl.ICON_OFFSET)[size];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement("span", {
        "aria-hidden": "true",
        "data-testid": testId && "".concat(testId, "--presence"),
        style: {
            pointerEvents: "none",
            position: "absolute",
            bottom: "".concat(position, "px"),
            height: "".concat((0, $es8Gl.ICON_SIZES)[size], "px"),
            right: "".concat(position, "px"),
            width: "".concat((0, $es8Gl.ICON_SIZES)[size], "px")
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement($f800dd6eb97c3262$var$AvatarPresence, {
        borderColor: borderColor,
        presence: !children ? presence : undefined
    }, children));
};

});
parcelRegister("ccAtW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8e22e79318d75d6a$export$2e2bcd8739ae039; });
/** @jsx jsx */ // eslint-disable-next-line @repo/internal/fs/filename-pattern-match

var $jVTBW = parcelRequire("jVTBW");

var $lmjFT = parcelRequire("lmjFT");

var $es8Gl = parcelRequire("es8Gl");
var $8e22e79318d75d6a$var$iconWrapperStyles = (0, $jVTBW.css)({
    display: "flex",
    boxSizing: "border-box",
    width: "100%",
    height: "100%",
    alignItems: "center",
    alignContent: "center",
    borderRadius: "var(--ds-border-radius-circle, 50%)",
    overflow: "hidden"
});
/**
 * __Icon wrapper__
 *
 * An icon wrapper is used internally only.
 */ var $8e22e79318d75d6a$var$IconWrapper = function IconWrapper(_ref) {
    var _ref$bgColor = _ref.bgColor, bgColor = _ref$bgColor === void 0 ? "var(--ds-surface-overlay, ".concat((0, $lmjFT.N0), ")") : _ref$bgColor, children = _ref.children;
    return (0, $jVTBW.jsx)("span", {
        css: $8e22e79318d75d6a$var$iconWrapperStyles,
        role: "presentation",
        style: {
            border: "".concat((0, $es8Gl.BORDER_WIDTH), "px solid ").concat(bgColor),
            backgroundColor: bgColor
        }
    }, children);
};
var $8e22e79318d75d6a$export$2e2bcd8739ae039 = $8e22e79318d75d6a$var$IconWrapper;

});


parcelRegister("kKEdL", function(module, exports) {

$parcel$export(module.exports, "StatusWrapper", function () { return $f1b74d93491228ab$export$8045894f255f9726; });
// eslint-disable-next-line @repo/internal/fs/filename-pattern-match

var $dAx5m = parcelRequire("dAx5m");

var $lmjFT = parcelRequire("lmjFT");

var $es8Gl = parcelRequire("es8Gl");

var $ccAtW = parcelRequire("ccAtW");
var $f1b74d93491228ab$var$ApprovedIndicator = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $dAx5m.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement("circle", {
    fill: "var(--ds-icon-success, ".concat((0, $lmjFT.G400), ")"),
    cx: "4",
    cy: "4",
    r: "4"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement("path", {
    fill: "var(--ds-surface-overlay, ".concat((0, $lmjFT.N0), ")"),
    d: "M2.47140452,3.52859548 C2.21105499,3.26824595 1.78894501,3.26824595 1.52859548,3.52859548 C1.26824595,3.78894501 1.26824595,4.21105499 1.52859548,4.47140452 L2.86192881,5.80473785 C3.12227834,6.06508738 3.54438833,6.06508738 3.80473785,5.80473785 L6.47140452,3.13807119 C6.73175405,2.87772166 6.73175405,2.45561167 6.47140452,2.19526215 C6.21105499,1.93491262 5.78894501,1.93491262 5.52859548,2.19526215 L3.33333333,4.39052429 L2.47140452,3.52859548 Z"
}));
var $f1b74d93491228ab$var$DeclinedIndicator = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $dAx5m.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement("circle", {
    fill: "var(--ds-icon-danger, ".concat((0, $lmjFT.R400), ")"),
    cx: "4",
    cy: "4",
    r: "4"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement("path", {
    fill: "var(--ds-surface-overlay, ".concat((0, $lmjFT.N0), ")"),
    d: "M4.890661,4.0088336 L5.81806461,3.07802178 C6.06167933,2.83351177 6.06048933,2.43826992 5.81540668,2.19522442 C5.57032402,1.95217891 5.17415651,1.95336612 4.93054179,2.19787613 L4.00765946,3.12415007 L3.06906871,2.18377143 C2.82523777,1.93947602 2.42906937,1.93863765 2.18420182,2.18189887 C1.93933427,2.42516008 1.93849394,2.82040282 2.18232488,3.06469822 L3.12544091,4.00961077 L2.20275024,4.93569234 C1.95913552,5.18020236 1.96032551,5.5754442 2.20540817,5.81848971 C2.45049083,6.06153521 2.84665833,6.060348 3.09027306,5.81583799 L4.00844245,4.89429431 L4.9092123,5.79678001 C5.15304324,6.04107541 5.54921164,6.04191379 5.79407919,5.79865257 C6.03894674,5.55539135 6.03978708,5.16014862 5.79595614,4.91585321 L4.890661,4.0088336 Z"
}));
var $f1b74d93491228ab$var$LockedIndicator = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $dAx5m.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement("circle", {
    fill: "var(--ds-text-subtlest, ".concat((0, $lmjFT.N40), ")"),
    cx: "4",
    cy: "4",
    r: "4"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement("path", {
    fill: "var(--ds-surface-overlay, ".concat((0, $lmjFT.N500), ")"),
    d: "M4.13074827,1.21766493 L4.10368158,1.21766493 C3.36340745,1.21766493 2.76388015,1.80793503 2.76388015,2.5367787 L2.76388015,3.21632216 L3.44054754,3.21632216 L3.44054754,2.54344089 C3.44054754,2.17901906 3.74031119,1.88388401 4.11044825,1.88388401 L4.1239816,1.88388401 C4.49411866,1.88388401 4.79388232,2.17901906 4.79388232,2.54344089 L4.79388232,3.21632216 L5.47054971,3.21632216 L5.47054971,2.5367787 C5.47054971,1.80793503 4.8710224,1.21766493 4.13074827,1.21766493 M2.76388015,3.21632216 L3.44054754,3.21632216 L3.44054754,3.88254123 L2.76388015,3.88254123 L2.76388015,3.21632216 Z M4.79388232,3.21632216 L5.47054971,3.21632216 L5.47054971,3.88254123 L4.79388232,3.88254123 L4.79388232,3.21632216 Z M4.79401765,3.88254123 L3.44068287,3.88254123 L2.76401548,3.88254123 C2.39049508,3.88254123 2.08734809,4.18100738 2.08734809,4.54876031 L2.08734809,5.54808892 C2.08734809,6.10000287 2.53735205,6.54741753 3.09094491,6.54741753 L5.14375561,6.54741753 C5.69802683,6.54741753 6.14735243,6.10385072 6.14735243,5.54808892 L6.14735243,4.54876031 C6.14735243,4.18100738 5.84420544,3.88254123 5.47068504,3.88254123 L4.79401765,3.88254123 Z"
}));
function $f1b74d93491228ab$var$getStatus(status) {
    switch(status){
        case "approved":
            return $f1b74d93491228ab$var$ApprovedIndicator;
        case "declined":
            return $f1b74d93491228ab$var$DeclinedIndicator;
        case "locked":
            return $f1b74d93491228ab$var$LockedIndicator;
    }
}
/**
 * __Avatar status__
 *
 * An avatar status shows contextual information, such as if someone approves or declines something.
 *
 * - [Examples](https://atlassian.design/components/avatar/avatar-status/examples)
 * - [Code](https://atlassian.design/components/avatar/avatar-status/code)
 */ var $f1b74d93491228ab$var$AvatarStatus = function AvatarStatus(_ref) {
    var borderColor = _ref.borderColor, children = _ref.children, status = _ref.status;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $ccAtW.default), {
        bgColor: borderColor
    }, status ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement("svg", {
        height: "100%",
        version: "1.1",
        viewBox: "0 0 8 8",
        width: "100%",
        xmlns: "http://www.w3.org/2000/svg"
    }, $f1b74d93491228ab$var$getStatus(status)) : children);
};
var $f1b74d93491228ab$export$2e2bcd8739ae039 = $f1b74d93491228ab$var$AvatarStatus;
var $f1b74d93491228ab$export$8045894f255f9726 = function StatusWrapper(_ref2) {
    var size = _ref2.size, status = _ref2.status, appearance = _ref2.appearance, borderColor = _ref2.borderColor, children = _ref2.children, testId = _ref2.testId;
    var position = appearance === "square" ? 0 : (0, $es8Gl.ICON_OFFSET)[size];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement("span", {
        "aria-hidden": "true",
        "data-testid": testId && "".concat(testId, "--status"),
        style: {
            position: "absolute",
            height: "".concat((0, $es8Gl.ICON_SIZES)[size], "px"),
            right: "".concat(position, "px"),
            top: "".concat(position, "px"),
            width: "".concat((0, $es8Gl.ICON_SIZES)[size], "px")
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement($f1b74d93491228ab$var$AvatarStatus, {
        borderColor: borderColor,
        status: !children ? status : undefined
    }, children));
};

});

parcelRegister("68EOj", function(module, exports) {

$parcel$export(module.exports, "getLinkProps", function () { return $4783258e163a669f$export$60113ebe1cf0ecf; });
$parcel$export(module.exports, "getButtonProps", function () { return $4783258e163a669f$export$cca6f1bef43616d3; });
$parcel$export(module.exports, "getCustomElement", function () { return $4783258e163a669f$export$83ee468102cdf04c; });
// eslint-disable-next-line @repo/internal/fs/filename-pattern-match
var $4783258e163a669f$export$60113ebe1cf0ecf = function getLinkProps(href, target) {
    return {
        href: href,
        rel: target === "_blank" ? "noopener noreferrer" : null,
        target: target
    };
};
var $4783258e163a669f$export$cca6f1bef43616d3 = function getButtonProps(onClick) {
    return {
        type: "button",
        onClick: onClick
    };
};
var $4783258e163a669f$export$83ee468102cdf04c = function getCustomElement(isDisabled, href, onClick) {
    if (href && !isDisabled) return "a";
    if (onClick || isDisabled) return "button";
    return "span";
};

});


parcelRegister("e2MCy", function(module, exports) {

$parcel$export(module.exports, "Screen", function () { return $a396f7afecbcc25c$export$a98515d67472a41f; });
$parcel$export(module.exports, "Title", function () { return $a396f7afecbcc25c$export$f99233281efd08a0; });
$parcel$export(module.exports, "SectionCard", function () { return $a396f7afecbcc25c$export$69ed894a7932b604; });
$parcel$export(module.exports, "Avatar", function () { return $a396f7afecbcc25c$export$e2255cf6045e8d47; });
$parcel$export(module.exports, "UserDetails", function () { return $a396f7afecbcc25c$export$a398983943bbde23; });

var $45N2i = parcelRequire("45N2i");

var $ku6eE = parcelRequire("ku6eE");

var $hrGjC = parcelRequire("hrGjC");

var $lmjFT = parcelRequire("lmjFT");

var $450dQ = parcelRequire("450dQ");

var $60Te3 = parcelRequire("60Te3");
var $a396f7afecbcc25c$var$_templateObject, $a396f7afecbcc25c$var$_templateObject2, $a396f7afecbcc25c$var$_templateObject3, $a396f7afecbcc25c$var$_templateObject4, $a396f7afecbcc25c$var$_templateObject5;
var $a396f7afecbcc25c$var$getSelectedCardColor = function getSelectedCardColor(props) {
    return props.isSelected && "".concat("var(--ds-background-selected, ".concat((0, $lmjFT.B50), ")"));
};
var $a396f7afecbcc25c$export$a98515d67472a41f = (0, $ku6eE.default).div($a396f7afecbcc25c$var$_templateObject || ($a396f7afecbcc25c$var$_templateObject = (0, (/*@__PURE__*/$parcel$interopDefault($45N2i)))([
    "\n  width: 100%;\n  max-width: 640px;\n  margin-bottom: ",
    "px;\n"
])), (0, $60Te3.default)(4));
var $a396f7afecbcc25c$export$f99233281efd08a0 = (0, $ku6eE.default).div($a396f7afecbcc25c$var$_templateObject2 || ($a396f7afecbcc25c$var$_templateObject2 = (0, (/*@__PURE__*/$parcel$interopDefault($45N2i)))([
    "\n  ",
    ";\n  margin-bottom: ",
    "px;\n  margin-top: 0;\n"
])), (0, $450dQ.h700), (0, $60Te3.default)(4));
var $a396f7afecbcc25c$export$69ed894a7932b604 = (0, $ku6eE.default).div($a396f7afecbcc25c$var$_templateObject3 || ($a396f7afecbcc25c$var$_templateObject3 = (0, (/*@__PURE__*/$parcel$interopDefault($45N2i)))([
    "\n  position: relative;\n  display: flex;\n  padding: ",
    "px;\n  width: 100%;\n  background-color: ",
    ";\n  border-radius: ",
    "px;\n  box-shadow: ",
    ";\n  margin-top: ",
    "px;\n"
])), (0, $60Te3.default)(2.5), function(props) {
    return $a396f7afecbcc25c$var$getSelectedCardColor(props);
}, (0, $hrGjC.borderRadius)(), "var(--ds-shadow-overlay, ".concat("0 4px 8px -2px ".concat((0, $lmjFT.N50A), ", 0 0 1px ").concat((0, $lmjFT.N60A)), ")"), (0, $60Te3.default)(2));
var $a396f7afecbcc25c$export$e2255cf6045e8d47 = (0, $ku6eE.default).div($a396f7afecbcc25c$var$_templateObject4 || ($a396f7afecbcc25c$var$_templateObject4 = (0, (/*@__PURE__*/$parcel$interopDefault($45N2i)))([
    "\n  display: flex;\n  flex-direction: column;\n  margin-left: ",
    "px;\n  margin-right: ",
    "px;\n"
])), (0, $60Te3.default)(2.5), (0, $60Te3.default)(1));
var $a396f7afecbcc25c$export$a398983943bbde23 = (0, $ku6eE.default).div($a396f7afecbcc25c$var$_templateObject5 || ($a396f7afecbcc25c$var$_templateObject5 = (0, (/*@__PURE__*/$parcel$interopDefault($45N2i)))([
    "\n  display: flex;\n  flex-direction: column;\n  margin-top: ",
    "px;\n  font-weight: 600;\n  color: ",
    ";\n"
])), (0, $60Te3.default)(1.5), "var(--ds-text-accent-blue, ".concat((0, $lmjFT.B400), ")"));

});
parcelRegister("450dQ", function(module, exports) {

$parcel$export(module.exports, "h700", function () { return $2f87cd2c54cee133$export$e4f993a313607daa; });
$parcel$export(module.exports, "h500", function () { return $2f87cd2c54cee133$export$85aa43a9b9f06707; });

var $iDtim = parcelRequire("iDtim");

var $lmjFT = parcelRequire("lmjFT");

var $hrGjC = parcelRequire("hrGjC");
function $2f87cd2c54cee133$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $2f87cd2c54cee133$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $2f87cd2c54cee133$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($iDtim)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $2f87cd2c54cee133$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $2f87cd2c54cee133$export$2a99220fb32ec798 = {
    heading: {
        xxlarge: 'normal 500 35px/40px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
        xlarge: 'normal 600 29px/32px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
        large: 'normal 500 24px/28px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
        medium: 'normal 500 20px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
        small: 'normal 600 16px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
        xsmall: 'normal 600 14px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
        xxsmall: 'normal 600 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif'
    },
    body: {
        large: 'normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
        medium: 'normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
        UNSAFE_small: 'normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
        small: 'normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif'
    }
};
var $2f87cd2c54cee133$var$baseHeading = function baseHeading(size, lineHeight) {
    return {
        fontSize: "".concat(size / 14, "em"),
        fontStyle: "inherit",
        lineHeight: lineHeight / size
    };
};
var $2f87cd2c54cee133$export$bc02e067df412c3b = {
    h900: {
        size: 35,
        lineHeight: 40
    },
    h800: {
        size: 29,
        lineHeight: 32
    },
    h700: {
        size: 24,
        lineHeight: 28
    },
    h600: {
        size: 20,
        lineHeight: 24
    },
    h500: {
        size: 16,
        lineHeight: 20
    },
    h400: {
        size: 14,
        lineHeight: 16
    },
    h300: {
        size: 12,
        lineHeight: 16
    },
    h200: {
        size: 12,
        lineHeight: 16
    },
    h100: {
        size: 11,
        lineHeight: 16
    }
};
var $2f87cd2c54cee133$export$bdb8f897727a9c67 = function h900() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return $2f87cd2c54cee133$var$_objectSpread($2f87cd2c54cee133$var$_objectSpread({}, $2f87cd2c54cee133$var$baseHeading($2f87cd2c54cee133$export$bc02e067df412c3b.h900.size, $2f87cd2c54cee133$export$bc02e067df412c3b.h900.lineHeight)), {}, {
        color: "var(--ds-text, ".concat((0, $lmjFT.heading)(props), ")"),
        fontWeight: "var(--ds-font-weight-medium, 500)",
        letterSpacing: "-0.01em",
        marginTop: "".concat((0, $hrGjC.gridSize)() * 6.5, "px")
    });
};
var $2f87cd2c54cee133$export$3953fb6fbd158d23 = function h800() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return $2f87cd2c54cee133$var$_objectSpread($2f87cd2c54cee133$var$_objectSpread({}, $2f87cd2c54cee133$var$baseHeading($2f87cd2c54cee133$export$bc02e067df412c3b.h800.size, $2f87cd2c54cee133$export$bc02e067df412c3b.h800.lineHeight)), {}, {
        color: "var(--ds-text, ".concat((0, $lmjFT.heading)(props), ")"),
        fontWeight: "var(--ds-font-weight-semibold, 600)",
        letterSpacing: "-0.01em",
        marginTop: "".concat((0, $hrGjC.gridSize)() * 5, "px")
    });
};
var $2f87cd2c54cee133$export$e4f993a313607daa = function h700() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return $2f87cd2c54cee133$var$_objectSpread($2f87cd2c54cee133$var$_objectSpread({}, $2f87cd2c54cee133$var$baseHeading($2f87cd2c54cee133$export$bc02e067df412c3b.h700.size, $2f87cd2c54cee133$export$bc02e067df412c3b.h700.lineHeight)), {}, {
        color: "var(--ds-text, ".concat((0, $lmjFT.heading)(props), ")"),
        fontWeight: "var(--ds-font-weight-medium, 500)",
        letterSpacing: "-0.01em",
        marginTop: "".concat((0, $hrGjC.gridSize)() * 5, "px")
    });
};
var $2f87cd2c54cee133$export$1e8b2acea3fb3119 = function h600() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return $2f87cd2c54cee133$var$_objectSpread($2f87cd2c54cee133$var$_objectSpread({}, $2f87cd2c54cee133$var$baseHeading($2f87cd2c54cee133$export$bc02e067df412c3b.h600.size, $2f87cd2c54cee133$export$bc02e067df412c3b.h600.lineHeight)), {}, {
        color: "var(--ds-text, ".concat((0, $lmjFT.heading)(props), ")"),
        fontWeight: "var(--ds-font-weight-medium, 500)",
        letterSpacing: "-0.008em",
        marginTop: "".concat((0, $hrGjC.gridSize)() * 3.5, "px")
    });
};
var $2f87cd2c54cee133$export$85aa43a9b9f06707 = function h500() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return $2f87cd2c54cee133$var$_objectSpread($2f87cd2c54cee133$var$_objectSpread({}, $2f87cd2c54cee133$var$baseHeading($2f87cd2c54cee133$export$bc02e067df412c3b.h500.size, $2f87cd2c54cee133$export$bc02e067df412c3b.h500.lineHeight)), {}, {
        color: "var(--ds-text, ".concat((0, $lmjFT.heading)(props), ")"),
        fontWeight: "var(--ds-font-weight-semibold, 600)",
        letterSpacing: "-0.006em",
        marginTop: "".concat((0, $hrGjC.gridSize)() * 3, "px")
    });
};
var $2f87cd2c54cee133$export$fcb7764b80bd908f = function h400() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return $2f87cd2c54cee133$var$_objectSpread($2f87cd2c54cee133$var$_objectSpread({}, $2f87cd2c54cee133$var$baseHeading($2f87cd2c54cee133$export$bc02e067df412c3b.h400.size, $2f87cd2c54cee133$export$bc02e067df412c3b.h400.lineHeight)), {}, {
        color: "var(--ds-text, ".concat((0, $lmjFT.heading)(props), ")"),
        fontWeight: "var(--ds-font-weight-semibold, 600)",
        letterSpacing: "-0.003em",
        marginTop: "".concat((0, $hrGjC.gridSize)() * 2, "px")
    });
};
var $2f87cd2c54cee133$export$a0e59c3bbc05e815 = function h300() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return $2f87cd2c54cee133$var$_objectSpread($2f87cd2c54cee133$var$_objectSpread({}, $2f87cd2c54cee133$var$baseHeading($2f87cd2c54cee133$export$bc02e067df412c3b.h300.size, $2f87cd2c54cee133$export$bc02e067df412c3b.h300.lineHeight)), {}, {
        color: "var(--ds-text, ".concat((0, $lmjFT.heading)(props), ")"),
        fontWeight: "var(--ds-font-weight-semibold, 600)",
        marginTop: "".concat((0, $hrGjC.gridSize)() * 2.5, "px"),
        textTransform: "uppercase"
    });
};
var $2f87cd2c54cee133$export$7ccf32eb2150ac7e = function h200() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return $2f87cd2c54cee133$var$_objectSpread($2f87cd2c54cee133$var$_objectSpread({}, $2f87cd2c54cee133$var$baseHeading($2f87cd2c54cee133$export$bc02e067df412c3b.h200.size, $2f87cd2c54cee133$export$bc02e067df412c3b.h200.lineHeight)), {}, {
        color: "var(--ds-text-subtlest, ".concat((0, $lmjFT.subtleHeading)(props), ")"),
        fontWeight: "var(--ds-font-weight-semibold, 600)",
        marginTop: "".concat((0, $hrGjC.gridSize)() * 2, "px")
    });
};
var $2f87cd2c54cee133$export$dfc0e69214efdc3c = function h100() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return $2f87cd2c54cee133$var$_objectSpread($2f87cd2c54cee133$var$_objectSpread({}, $2f87cd2c54cee133$var$baseHeading($2f87cd2c54cee133$export$bc02e067df412c3b.h100.size, $2f87cd2c54cee133$export$bc02e067df412c3b.h100.lineHeight)), {}, {
        color: "var(--ds-text-subtlest, ".concat((0, $lmjFT.subtleHeading)(props), ")"),
        fontWeight: "var(--ds-font-weight-bold, 700)",
        marginTop: "".concat((0, $hrGjC.gridSize)() * 2, "px")
    });
};

});




parcelRegister("bkckr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return (parcelRequire("9RxSY")).default; });

var $9RxSY = parcelRequire("9RxSY");

});
parcelRegister("9RxSY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $72e35947a74c9f34$export$2e2bcd8739ae039; });

var $8TMbA = parcelRequire("8TMbA");

var $5MUML = parcelRequire("5MUML");

var $dXLvS = parcelRequire("dXLvS");

var $4irYd = parcelRequire("4irYd");

var $lKQfu = parcelRequire("lKQfu");

var $fKxww = parcelRequire("fKxww");

var $ilqjt = parcelRequire("ilqjt");

var $iDtim = parcelRequire("iDtim");

var $dAx5m = parcelRequire("dAx5m");

var $55TWT = parcelRequire("55TWT");

var $fIjLq = parcelRequire("fIjLq");

var $l06Mf = parcelRequire("l06Mf");

var $kefZ7 = parcelRequire("kefZ7");

var $jrFqr = parcelRequire("jrFqr");
parcelRequire("3UqGB");
var $jJJmU = parcelRequire("jJJmU");
parcelRequire("cdg3t");
var $01PEk = parcelRequire("01PEk");

var $isv74 = parcelRequire("isv74");
parcelRequire("18rL9");
var $jUaEE = parcelRequire("jUaEE");

var $05eJd = parcelRequire("05eJd");
function $72e35947a74c9f34$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $72e35947a74c9f34$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, (/*@__PURE__*/$parcel$interopDefault($ilqjt)))(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, (/*@__PURE__*/$parcel$interopDefault($ilqjt)))(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, (/*@__PURE__*/$parcel$interopDefault($fKxww)))(this, result);
    };
}
function $72e35947a74c9f34$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($72e35947a74c9f34$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $72e35947a74c9f34$export$7255dce7940905bf = /*#__PURE__*/ function(_React$Component) {
    (0, (/*@__PURE__*/$parcel$interopDefault($lKQfu)))(DeleteUserOverviewScreen, _React$Component);
    var _super = $72e35947a74c9f34$var$_createSuper(DeleteUserOverviewScreen);
    function DeleteUserOverviewScreen() {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($5MUML)))(this, DeleteUserOverviewScreen);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, (/*@__PURE__*/$parcel$interopDefault($iDtim)))((0, (/*@__PURE__*/$parcel$interopDefault($4irYd)))(_this), "selectAdminOrSelfCopy", function(adminCopy, selfCopy) {
            return _this.props.isCurrentUser ? selfCopy : adminCopy;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($iDtim)))((0, (/*@__PURE__*/$parcel$interopDefault($4irYd)))(_this), "displayFirstListElement", function() {
            var _this$props = _this.props, accessibleSites = _this$props.accessibleSites, user = _this$props.user, isUserDeactivated = _this$props.isUserDeactivated;
            if (isUserDeactivated) return null;
            var hasAccessibleSites = accessibleSites && accessibleSites.length > 0;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement("li", null, !hasAccessibleSites && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $55TWT.default), (0, (/*@__PURE__*/$parcel$interopDefault($8TMbA)))({}, _this.selectAdminOrSelfCopy((0, $jrFqr.overviewMessages).paragraphLoseAccessAdminNoSites, (0, $jrFqr.overviewMessages).paragraphLoseAccessSelfNoSites), {
                values: {
                    fullName: user.fullName,
                    b: function b(s) {
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement("b", null, s);
                    }
                }
            })), hasAccessibleSites && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $55TWT.default), (0, (/*@__PURE__*/$parcel$interopDefault($8TMbA)))({}, _this.selectAdminOrSelfCopy((0, $jrFqr.overviewMessages).paragraphLoseAccessAdmin, (0, $jrFqr.overviewMessages).paragraphLoseAccessSelf), {
                values: {
                    fullName: user.fullName,
                    b: function b(s) {
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement("b", null, s);
                    }
                },
                tagName: "p"
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $jUaEE.DropdownList), {
                accessibleSites: accessibleSites
            })));
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($iDtim)))((0, (/*@__PURE__*/$parcel$interopDefault($4irYd)))(_this), "displaySecondListElement", function() {
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement("li", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $55TWT.default), (0, (/*@__PURE__*/$parcel$interopDefault($8TMbA)))({}, _this.selectAdminOrSelfCopy((0, $jrFqr.overviewMessages).paragraphPersonalDataWillBeDeletedAdmin, (0, $jrFqr.overviewMessages).paragraphPersonalDataWillBeDeletedSelf), {
                values: {
                    b: function b(s) {
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement("b", null, s);
                    }
                }
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement($isv74.IconHoverWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $jJJmU.default), {
                placement: "auto-start",
                content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement($isv74.InlineDialogContent, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $55TWT.default), (0, (/*@__PURE__*/$parcel$interopDefault($8TMbA)))({}, _this.selectAdminOrSelfCopy((0, $jrFqr.overviewMessages).inlineDialogDataWillBeDeletedP1Admin, (0, $jrFqr.overviewMessages).inlineDialogDataWillBeDeletedP1Self), {
                    tagName: "p"
                })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $55TWT.default), (0, (/*@__PURE__*/$parcel$interopDefault($8TMbA)))({}, _this.selectAdminOrSelfCopy((0, $jrFqr.overviewMessages).inlineDialogDataWillBeDeletedLi1Admin, (0, $jrFqr.overviewMessages).inlineDialogDataWillBeDeletedLi1Self), {
                    tagName: "li"
                })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $55TWT.default), (0, (/*@__PURE__*/$parcel$interopDefault($8TMbA)))({}, _this.selectAdminOrSelfCopy((0, $jrFqr.overviewMessages).inlineDialogDataWillBeDeletedLi2Admin, (0, $jrFqr.overviewMessages).inlineDialogDataWillBeDeletedLi2Self), {
                    tagName: "li"
                })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $55TWT.default), (0, (/*@__PURE__*/$parcel$interopDefault($8TMbA)))({}, _this.selectAdminOrSelfCopy((0, $jrFqr.overviewMessages).inlineDialogDataWillBeDeletedLi3Admin, (0, $jrFqr.overviewMessages).inlineDialogDataWillBeDeletedLi3Self), {
                    tagName: "li"
                })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $55TWT.default), (0, (/*@__PURE__*/$parcel$interopDefault($8TMbA)))({}, _this.selectAdminOrSelfCopy((0, $jrFqr.overviewMessages).inlineDialogDataWillBeDeletedP2Admin, (0, $jrFqr.overviewMessages).inlineDialogDataWillBeDeletedP2Self), {
                    tagName: "p"
                })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $55TWT.default), (0, (/*@__PURE__*/$parcel$interopDefault($8TMbA)))({}, _this.selectAdminOrSelfCopy((0, $jrFqr.overviewMessages).inlineDialogDataWillBeDeletedP3Admin, (0, $jrFqr.overviewMessages).inlineDialogDataWillBeDeletedP3Self), {
                    tagName: "p"
                })))
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kefZ7))), {
                label: "",
                size: "small"
            }))));
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($iDtim)))((0, (/*@__PURE__*/$parcel$interopDefault($4irYd)))(_this), "displayThirdListElement", function() {
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement("li", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $55TWT.default), _this.selectAdminOrSelfCopy((0, $jrFqr.overviewMessages).paragraphListOfAppsWithPersonalDataAdmin, (0, $jrFqr.overviewMessages).paragraphListOfAppsWithPersonalDataSelf)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement($isv74.IconHoverWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $jJJmU.default), {
                placement: "auto-start",
                content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $55TWT.default), _this.selectAdminOrSelfCopy((0, $jrFqr.overviewMessages).inlineDialogDataAppsAdmin, (0, $jrFqr.overviewMessages).inlineDialogDataAppsSelf))
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kefZ7))), {
                label: "",
                size: "small"
            }))));
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($iDtim)))((0, (/*@__PURE__*/$parcel$interopDefault($4irYd)))(_this), "displayFourthListElement", function() {
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement("li", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $55TWT.default), _this.selectAdminOrSelfCopy((0, $jrFqr.overviewMessages).paragraphContentCreatedAdmin, (0, $jrFqr.overviewMessages).paragraphContentCreatedSelf)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement($isv74.IconHoverWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $jJJmU.default), {
                placement: "auto-start",
                content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $55TWT.default), _this.selectAdminOrSelfCopy((0, $jrFqr.overviewMessages).inlineDialogContentCreatedAdmin, (0, $jrFqr.overviewMessages).inlineDialogContentCreatedSelf))
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kefZ7))), {
                label: "",
                size: "small"
            }))));
        });
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($dXLvS)))(DeleteUserOverviewScreen, [
        {
            key: "render",
            value: function render() {
                var _this$props2 = this.props, user = _this$props2.user, deactivateUserHandler = _this$props2.deactivateUserHandler, isUserDeactivated = _this$props2.isUserDeactivated;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $05eJd.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement($isv74.Screen, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement($isv74.Title, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $55TWT.default), this.selectAdminOrSelfCopy((0, $jrFqr.overviewMessages).headingAdmin, (0, $jrFqr.overviewMessages).headingSelf))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $55TWT.default), (0, (/*@__PURE__*/$parcel$interopDefault($8TMbA)))({}, this.selectAdminOrSelfCopy((0, $jrFqr.overviewMessages).firstLineAdmin, (0, $jrFqr.overviewMessages).firstLineSelf), {
                    tagName: "p"
                })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $01PEk.default), {
                    user: user
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $55TWT.default), this.selectAdminOrSelfCopy((0, $jrFqr.overviewMessages).paragraphAboutToDeleteAdmin, (0, $jrFqr.overviewMessages).paragraphAboutToDeleteSelf)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement($isv74.MainInformationList, null, this.displayFirstListElement(), this.displaySecondListElement(), this.displayThirdListElement(), this.displayFourthListElement()), deactivateUserHandler && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement($isv74.SectionMessageOuter, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $l06Mf.default), {
                    appearance: "warning"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $55TWT.default), isUserDeactivated ? (0, $jrFqr.overviewMessages).warningSectionBodyDeactivated : (0, $jrFqr.overviewMessages).warningSectionBody), !isUserDeactivated && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement("p", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $fIjLq.default), {
                    appearance: "link",
                    spacing: "none",
                    onClick: deactivateUserHandler
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $55TWT.default), (0, $jrFqr.commonMessages).deactivateAccount)))))));
            }
        }
    ]);
    return DeleteUserOverviewScreen;
}((0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).Component);
(0, (/*@__PURE__*/$parcel$interopDefault($iDtim)))($72e35947a74c9f34$export$7255dce7940905bf, "defaultProps", {
    isCurrentUser: false
});
var $72e35947a74c9f34$export$2e2bcd8739ae039 = $72e35947a74c9f34$export$7255dce7940905bf;

});
parcelRegister("kefZ7", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $eba183b75beffbb2$var$_react = $eba183b75beffbb2$var$_interopRequireDefault((parcelRequire("dAx5m")));

var $3AZdd = parcelRequire("3AZdd");

var $eba183b75beffbb2$var$_information = $eba183b75beffbb2$var$_interopRequireDefault((parcelRequire("dkePu")));
function $eba183b75beffbb2$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $eba183b75beffbb2$var$InfoIcon = (props)=>/*#__PURE__*/ $eba183b75beffbb2$var$_react.default.createElement($3AZdd.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><path fill="currentcolor" d="M2 12c0 5.523 4.477 10 10 10s10-4.477 10-10S17.523 2 12 2 2 6.477 2 12"/><rect width="2" height="7" x="11" y="10" fill="inherit" rx="1"/><circle cx="12" cy="8" r="1" fill="inherit"/></g></svg>`
    }, props, {
        newIcon: $eba183b75beffbb2$var$_information.default
    }));
$eba183b75beffbb2$var$InfoIcon.displayName = "InfoIcon";
var $eba183b75beffbb2$var$_default = module.exports.default = $eba183b75beffbb2$var$InfoIcon;

});
parcelRegister("dkePu", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::cfc592cc61140d99cb4eaed527408acf>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9b38a57415f2a4a1$var$_react = $9b38a57415f2a4a1$var$_interopRequireDefault((parcelRequire("dAx5m")));

var $9b38a57415f2a4a1$var$_UNSAFE_baseNew = $9b38a57415f2a4a1$var$_interopRequireDefault((parcelRequire("jbpyS")));
function $9b38a57415f2a4a1$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Information".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Known uses: information state in section messages or inline messages.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $9b38a57415f2a4a1$var$InformationIcon = (props)=>/*#__PURE__*/ $9b38a57415f2a4a1$var$_react.default.createElement($9b38a57415f2a4a1$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m6.5-1.25H8a.75.75 0 0 1 .75.75v5h-1.5V8.25H6.5zM8 5.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2" clip-rule="evenodd"/>`
    }, props));
$9b38a57415f2a4a1$var$InformationIcon.displayName = "InformationIcon";
var $9b38a57415f2a4a1$var$_default = module.exports.default = $9b38a57415f2a4a1$var$InformationIcon;

});


parcelRegister("3UqGB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return (parcelRequire("jJJmU")).default; });

var $jJJmU = parcelRequire("jJJmU");

});
parcelRegister("jJJmU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e5e5698c92d5b72c$export$2e2bcd8739ae039; });

var $5MUML = parcelRequire("5MUML");

var $dXLvS = parcelRequire("dXLvS");

var $4irYd = parcelRequire("4irYd");

var $lKQfu = parcelRequire("lKQfu");

var $fKxww = parcelRequire("fKxww");

var $ilqjt = parcelRequire("ilqjt");

var $iDtim = parcelRequire("iDtim");

var $dAx5m = parcelRequire("dAx5m");

var $4FNod = parcelRequire("4FNod");
function $e5e5698c92d5b72c$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $e5e5698c92d5b72c$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, (/*@__PURE__*/$parcel$interopDefault($ilqjt)))(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, (/*@__PURE__*/$parcel$interopDefault($ilqjt)))(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, (/*@__PURE__*/$parcel$interopDefault($fKxww)))(this, result);
    };
}
function $e5e5698c92d5b72c$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($e5e5698c92d5b72c$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $e5e5698c92d5b72c$export$3e2cfc8a5decc158 = /*#__PURE__*/ function(_React$Component) {
    (0, (/*@__PURE__*/$parcel$interopDefault($lKQfu)))(StatefulInlineDialog, _React$Component);
    var _super = $e5e5698c92d5b72c$var$_createSuper(StatefulInlineDialog);
    function StatefulInlineDialog() {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($5MUML)))(this, StatefulInlineDialog);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, (/*@__PURE__*/$parcel$interopDefault($iDtim)))((0, (/*@__PURE__*/$parcel$interopDefault($4irYd)))(_this), "state", {
            isOpen: false
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($iDtim)))((0, (/*@__PURE__*/$parcel$interopDefault($4irYd)))(_this), "openDialog", function() {
            _this.setState({
                isOpen: true
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($iDtim)))((0, (/*@__PURE__*/$parcel$interopDefault($4irYd)))(_this), "closeDialog", function() {
            _this.setState({
                isOpen: false
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($iDtim)))((0, (/*@__PURE__*/$parcel$interopDefault($4irYd)))(_this), "handleMouseOver", function() {
            _this.openDialog();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($iDtim)))((0, (/*@__PURE__*/$parcel$interopDefault($4irYd)))(_this), "handleMouseOut", function() {
            _this.closeDialog();
        });
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($dXLvS)))(StatefulInlineDialog, [
        {
            key: "render",
            value: function render() {
                var _this$props = this.props, children = _this$props.children, content = _this$props.content, placement = _this$props.placement;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $4FNod.default), {
                    content: content,
                    placement: placement,
                    isOpen: this.state.isOpen
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement("span", {
                    onMouseOver: this.handleMouseOver,
                    onMouseOut: this.handleMouseOut
                }, children));
            }
        }
    ]);
    return StatefulInlineDialog;
}((0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).Component);
var $e5e5698c92d5b72c$export$2e2bcd8739ae039 = $e5e5698c92d5b72c$export$3e2cfc8a5decc158;

});


parcelRegister("cdg3t", function(module, exports) {

$parcel$export(module.exports, "default", function () { return (parcelRequire("01PEk")).default; });

var $01PEk = parcelRequire("01PEk");

});
parcelRegister("01PEk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $005828a37cbe7c39$export$2e2bcd8739ae039; });

var $5MUML = parcelRequire("5MUML");

var $dXLvS = parcelRequire("dXLvS");

var $lKQfu = parcelRequire("lKQfu");

var $fKxww = parcelRequire("fKxww");

var $ilqjt = parcelRequire("ilqjt");

var $dAx5m = parcelRequire("dAx5m");

var $d5Kdn = parcelRequire("d5Kdn");

var $6EAbd = parcelRequire("6EAbd");
function $005828a37cbe7c39$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $005828a37cbe7c39$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, (/*@__PURE__*/$parcel$interopDefault($ilqjt)))(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, (/*@__PURE__*/$parcel$interopDefault($ilqjt)))(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, (/*@__PURE__*/$parcel$interopDefault($fKxww)))(this, result);
    };
}
function $005828a37cbe7c39$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($005828a37cbe7c39$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $005828a37cbe7c39$export$c6ede3bfc40c5e4b = /*#__PURE__*/ function(_React$Component) {
    (0, (/*@__PURE__*/$parcel$interopDefault($lKQfu)))(UserInfo, _React$Component);
    var _super = $005828a37cbe7c39$var$_createSuper(UserInfo);
    function UserInfo() {
        (0, (/*@__PURE__*/$parcel$interopDefault($5MUML)))(this, UserInfo);
        return _super.apply(this, arguments);
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($dXLvS)))(UserInfo, [
        {
            key: "render",
            value: function render() {
                var user = this.props.user;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement($6EAbd.UserInfoOuter, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement($6EAbd.Avatar, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $d5Kdn.default), {
                    size: "large",
                    src: user.avatarUrl
                })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement($6EAbd.UserDetails, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement($6EAbd.UserName, null, user.fullName), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement($6EAbd.UserEmail, null, user.email)));
            }
        }
    ]);
    return UserInfo;
}((0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).Component);
var $005828a37cbe7c39$export$2e2bcd8739ae039 = $005828a37cbe7c39$export$c6ede3bfc40c5e4b;

});
parcelRegister("6EAbd", function(module, exports) {

$parcel$export(module.exports, "UserInfoOuter", function () { return $4d828b12f3e2f924$export$79137477deca36bd; });
$parcel$export(module.exports, "Avatar", function () { return $4d828b12f3e2f924$export$e2255cf6045e8d47; });
$parcel$export(module.exports, "UserDetails", function () { return $4d828b12f3e2f924$export$a398983943bbde23; });
$parcel$export(module.exports, "UserName", function () { return $4d828b12f3e2f924$export$7bf5e3f2a1fc0a63; });
$parcel$export(module.exports, "UserEmail", function () { return $4d828b12f3e2f924$export$4410a700a49d2f86; });

var $45N2i = parcelRequire("45N2i");

var $ku6eE = parcelRequire("ku6eE");

var $hrGjC = parcelRequire("hrGjC");

var $450dQ = parcelRequire("450dQ");

var $lmjFT = parcelRequire("lmjFT");

var $60Te3 = parcelRequire("60Te3");
var $4d828b12f3e2f924$var$_templateObject, $4d828b12f3e2f924$var$_templateObject2, $4d828b12f3e2f924$var$_templateObject3, $4d828b12f3e2f924$var$_templateObject4, $4d828b12f3e2f924$var$_templateObject5;
var $4d828b12f3e2f924$var$baseHeading = function baseHeading(size, lineHeight) {
    return "\n  font-size: ".concat(size / (0, $hrGjC.fontSize)(), "em;\n  font-style: inherit;\n  line-height: ").concat(lineHeight / size, ";\n");
};
var $4d828b12f3e2f924$export$79137477deca36bd = (0, $ku6eE.default).div($4d828b12f3e2f924$var$_templateObject || ($4d828b12f3e2f924$var$_templateObject = (0, (/*@__PURE__*/$parcel$interopDefault($45N2i)))([
    "\n  display: flex;\n  align-items: center;\n  width: 100%;\n  margin-bottom: ",
    "px;\n"
])), (0, $60Te3.default)(2));
var $4d828b12f3e2f924$export$e2255cf6045e8d47 = (0, $ku6eE.default).div($4d828b12f3e2f924$var$_templateObject2 || ($4d828b12f3e2f924$var$_templateObject2 = (0, (/*@__PURE__*/$parcel$interopDefault($45N2i)))([
    "\n  display: flex;\n  flex-direction: column;\n  margin-left: ",
    "px;\n  margin-right: ",
    "px;\n"
])), (0, $60Te3.default)(2.5), (0, $60Te3.default)(1));
var $4d828b12f3e2f924$export$a398983943bbde23 = (0, $ku6eE.default).div($4d828b12f3e2f924$var$_templateObject3 || ($4d828b12f3e2f924$var$_templateObject3 = (0, (/*@__PURE__*/$parcel$interopDefault($45N2i)))([
    "\n  display: flex;\n  flex-direction: column;\n  margin-left: ",
    "px;\n"
])), (0, $60Te3.default)(0.5));
var $4d828b12f3e2f924$export$7bf5e3f2a1fc0a63 = (0, $ku6eE.default).span($4d828b12f3e2f924$var$_templateObject4 || ($4d828b12f3e2f924$var$_templateObject4 = (0, (/*@__PURE__*/$parcel$interopDefault($45N2i)))([
    "\n  ",
    ";\n  margin-top: 0;\n"
])), (0, $450dQ.h500));
var $4d828b12f3e2f924$export$4410a700a49d2f86 = (0, $ku6eE.default).span($4d828b12f3e2f924$var$_templateObject5 || ($4d828b12f3e2f924$var$_templateObject5 = (0, (/*@__PURE__*/$parcel$interopDefault($45N2i)))([
    "\n  ",
    " color: ",
    ";\n  font-weight: 300;\n  margin-top: ",
    "px;\n"
])), $4d828b12f3e2f924$var$baseHeading(11, 16), "var(--ds-text-subtlest, ".concat((0, $lmjFT.N200), ")"), (0, $60Te3.default)(0.5));

});



parcelRegister("isv74", function(module, exports) {

$parcel$export(module.exports, "Screen", function () { return $d702f9ee8e9849f0$export$a98515d67472a41f; });
$parcel$export(module.exports, "Title", function () { return $d702f9ee8e9849f0$export$f99233281efd08a0; });
$parcel$export(module.exports, "SectionMessageOuter", function () { return $d702f9ee8e9849f0$export$8e124e30bdc76d96; });
$parcel$export(module.exports, "MainInformationList", function () { return $d702f9ee8e9849f0$export$e189358d897f3de5; });
$parcel$export(module.exports, "IconHoverWrapper", function () { return $d702f9ee8e9849f0$export$fa7a6522d99fda80; });
$parcel$export(module.exports, "InlineDialogContent", function () { return $d702f9ee8e9849f0$export$ebb46fff1ff37318; });

var $45N2i = parcelRequire("45N2i");

var $ku6eE = parcelRequire("ku6eE");

var $lmjFT = parcelRequire("lmjFT");

var $450dQ = parcelRequire("450dQ");

var $60Te3 = parcelRequire("60Te3");
var $d702f9ee8e9849f0$var$_templateObject, $d702f9ee8e9849f0$var$_templateObject2, $d702f9ee8e9849f0$var$_templateObject3, $d702f9ee8e9849f0$var$_templateObject4, $d702f9ee8e9849f0$var$_templateObject5, $d702f9ee8e9849f0$var$_templateObject6, $d702f9ee8e9849f0$var$_templateObject7;
var $d702f9ee8e9849f0$export$a98515d67472a41f = (0, $ku6eE.default).div($d702f9ee8e9849f0$var$_templateObject || ($d702f9ee8e9849f0$var$_templateObject = (0, (/*@__PURE__*/$parcel$interopDefault($45N2i)))([
    "\n  width: 100%;\n  max-width: 640px;\n  margin-bottom: ",
    "px;\n  > p {\n    margin-top: ",
    "px;\n    margin-bottom: ",
    "px;\n  }\n"
])), (0, $60Te3.default)(2), (0, $60Te3.default)(3), (0, $60Te3.default)(2));
var $d702f9ee8e9849f0$export$43a792a870d28db2 = (0, $ku6eE.default).div($d702f9ee8e9849f0$var$_templateObject2 || ($d702f9ee8e9849f0$var$_templateObject2 = (0, (/*@__PURE__*/$parcel$interopDefault($45N2i)))([
    "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 500px;\n"
])));
var $d702f9ee8e9849f0$export$f99233281efd08a0 = (0, $ku6eE.default).div($d702f9ee8e9849f0$var$_templateObject3 || ($d702f9ee8e9849f0$var$_templateObject3 = (0, (/*@__PURE__*/$parcel$interopDefault($45N2i)))([
    "\n  ",
    ";\n  margin-bottom: ",
    "px;\n  margin-top: 0;\n"
])), (0, $450dQ.h700), (0, $60Te3.default)(3));
var $d702f9ee8e9849f0$export$8e124e30bdc76d96 = (0, $ku6eE.default).div($d702f9ee8e9849f0$var$_templateObject4 || ($d702f9ee8e9849f0$var$_templateObject4 = (0, (/*@__PURE__*/$parcel$interopDefault($45N2i)))([
    "\n  margin: ",
    "px 0;\n"
])), (0, $60Te3.default)(3));
var $d702f9ee8e9849f0$export$e189358d897f3de5 = (0, $ku6eE.default).ul($d702f9ee8e9849f0$var$_templateObject5 || ($d702f9ee8e9849f0$var$_templateObject5 = (0, (/*@__PURE__*/$parcel$interopDefault($45N2i)))([
    "\n  > li b {\n    font-weight: 600;\n  }\n  p + ul {\n    margin-top: ",
    "px;\n  }\n"
])), (0, $60Te3.default)(1.5));
var $d702f9ee8e9849f0$export$fa7a6522d99fda80 = (0, $ku6eE.default).span($d702f9ee8e9849f0$var$_templateObject6 || ($d702f9ee8e9849f0$var$_templateObject6 = (0, (/*@__PURE__*/$parcel$interopDefault($45N2i)))([
    "\n  color: ",
    ";\n  padding-left: ",
    "px;\n  &:hover {\n    color: ",
    ";\n  }\n"
])), "var(--ds-background-information-bold, ".concat((0, $lmjFT.B500), ")"), (0, $60Te3.default)(0.5), "var(--ds-background-information-bold-hovered, ".concat((0, $lmjFT.B200), ")"));
var $d702f9ee8e9849f0$export$ebb46fff1ff37318 = (0, $ku6eE.default).div($d702f9ee8e9849f0$var$_templateObject7 || ($d702f9ee8e9849f0$var$_templateObject7 = (0, (/*@__PURE__*/$parcel$interopDefault($45N2i)))([
    "\n  li {\n    margin-left: ",
    "px;\n    margin-top: ",
    "px;\n    padding-left: ",
    "px;\n  }\n"
])), (0, $60Te3.default)(3), (0, $60Te3.default)(1), (0, $60Te3.default)(1));

});

parcelRegister("18rL9", function(module, exports) {

$parcel$export(module.exports, "DropdownList", function () { return (parcelRequire("jUaEE")).DropdownList; });

var $jUaEE = parcelRequire("jUaEE");

});
parcelRegister("jUaEE", function(module, exports) {

$parcel$export(module.exports, "DropdownList", function () { return $e7db831652f6efab$export$e40cc1c58d22b809; });

var $8TMbA = parcelRequire("8TMbA");

var $5MUML = parcelRequire("5MUML");

var $dXLvS = parcelRequire("dXLvS");

var $4irYd = parcelRequire("4irYd");

var $lKQfu = parcelRequire("lKQfu");

var $fKxww = parcelRequire("fKxww");

var $ilqjt = parcelRequire("ilqjt");

var $iDtim = parcelRequire("iDtim");

var $dAx5m = parcelRequire("dAx5m");

var $55TWT = parcelRequire("55TWT");

var $fIjLq = parcelRequire("fIjLq");

var $fl1eD = parcelRequire("fl1eD");

var $jrFqr = parcelRequire("jrFqr");
function $e7db831652f6efab$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $e7db831652f6efab$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, (/*@__PURE__*/$parcel$interopDefault($ilqjt)))(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, (/*@__PURE__*/$parcel$interopDefault($ilqjt)))(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, (/*@__PURE__*/$parcel$interopDefault($fKxww)))(this, result);
    };
}
function $e7db831652f6efab$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($e7db831652f6efab$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $e7db831652f6efab$var$COLLAPSED_LIST_SITE_COUNT = 3;
var $e7db831652f6efab$export$e40cc1c58d22b809 = /*#__PURE__*/ function(_React$Component) {
    (0, (/*@__PURE__*/$parcel$interopDefault($lKQfu)))(DropdownList, _React$Component);
    var _super = $e7db831652f6efab$var$_createSuper(DropdownList);
    function DropdownList() {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($5MUML)))(this, DropdownList);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, (/*@__PURE__*/$parcel$interopDefault($iDtim)))((0, (/*@__PURE__*/$parcel$interopDefault($4irYd)))(_this), "state", {
            isExpanded: false
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($iDtim)))((0, (/*@__PURE__*/$parcel$interopDefault($4irYd)))(_this), "showDropdownList", function() {
            _this.setState({
                isExpanded: true
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($iDtim)))((0, (/*@__PURE__*/$parcel$interopDefault($4irYd)))(_this), "hideDropdownList", function() {
            _this.setState({
                isExpanded: false
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($iDtim)))((0, (/*@__PURE__*/$parcel$interopDefault($4irYd)))(_this), "getVisibleSites", function() {
            return _this.state.isExpanded ? _this.props.accessibleSites : _this.props.accessibleSites.slice(0, $e7db831652f6efab$var$COLLAPSED_LIST_SITE_COUNT);
        });
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($dXLvS)))(DropdownList, [
        {
            key: "render",
            value: function render() {
                var accessibleSites = this.props.accessibleSites;
                var isExpanded = this.state.isExpanded;
                var visibleSites = this.getVisibleSites();
                var footNote = visibleSites.length === accessibleSites.length && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement($fl1eD.AccessibleSitesListFootnote, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $55TWT.default), (0, $jrFqr.overviewMessages).paragraphLoseAccessFootnote));
                var toggleExpand = accessibleSites.length > $e7db831652f6efab$var$COLLAPSED_LIST_SITE_COUNT && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement($fl1eD.ButtonWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $fIjLq.default), {
                    onClick: isExpanded ? this.hideDropdownList : this.showDropdownList,
                    appearance: "link",
                    spacing: "none"
                }, isExpanded ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $55TWT.default), (0, $jrFqr.dropDownListMessages).collapseButton) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $55TWT.default), (0, (/*@__PURE__*/$parcel$interopDefault($8TMbA)))({}, (0, $jrFqr.dropDownListMessages).expandButton, {
                    values: {
                        num: accessibleSites.length - 3
                    }
                }))));
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement($fl1eD.AccessibleSitesList, null, visibleSites.map(function(url, idx) {
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement("li", {
                        key: idx
                    }, url);
                })), footNote, toggleExpand);
            }
        }
    ]);
    return DropdownList;
}((0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).Component);
var $e7db831652f6efab$export$2e2bcd8739ae039 = $e7db831652f6efab$export$e40cc1c58d22b809;

});
parcelRegister("fl1eD", function(module, exports) {

$parcel$export(module.exports, "AccessibleSitesList", function () { return $b2a9c669a327b94b$export$55cfcb4bca88443c; });
$parcel$export(module.exports, "AccessibleSitesListFootnote", function () { return $b2a9c669a327b94b$export$b686ea76b7c7b103; });
$parcel$export(module.exports, "ButtonWrapper", function () { return $b2a9c669a327b94b$export$d53c836cccbb0d90; });

var $45N2i = parcelRequire("45N2i");

var $ku6eE = parcelRequire("ku6eE");

var $60Te3 = parcelRequire("60Te3");
var $b2a9c669a327b94b$var$_templateObject, $b2a9c669a327b94b$var$_templateObject2, $b2a9c669a327b94b$var$_templateObject3;
var $b2a9c669a327b94b$export$55cfcb4bca88443c = (0, $ku6eE.default).ul($b2a9c669a327b94b$var$_templateObject || ($b2a9c669a327b94b$var$_templateObject = (0, (/*@__PURE__*/$parcel$interopDefault($45N2i)))([
    "\n  list-style: none;\n  padding-left: 0;\n  font-weight: 600;\n  margin-left: ",
    "px;\n  > li {\n    margin-top: 0;\n  }\n"
])), (0, $60Te3.default)(1));
var $b2a9c669a327b94b$export$b686ea76b7c7b103 = (0, $ku6eE.default).div($b2a9c669a327b94b$var$_templateObject2 || ($b2a9c669a327b94b$var$_templateObject2 = (0, (/*@__PURE__*/$parcel$interopDefault($45N2i)))([
    "\n  padding-left: 0;\n  margin-left: ",
    "px;\n"
])), (0, $60Te3.default)(1));
var $b2a9c669a327b94b$export$d53c836cccbb0d90 = (0, $ku6eE.default).div($b2a9c669a327b94b$var$_templateObject3 || ($b2a9c669a327b94b$var$_templateObject3 = (0, (/*@__PURE__*/$parcel$interopDefault($45N2i)))([
    "\n  padding: 0 ",
    "px;\n"
])), (0, $60Te3.default)(1));

});





parcelRegister("bJeIz", function(module, exports) {

var $kJ8rD = parcelRequire("kJ8rD");

});
parcelRegister("kJ8rD", function(module, exports) {

var $8TMbA = parcelRequire("8TMbA");

var $5MUML = parcelRequire("5MUML");

var $dXLvS = parcelRequire("dXLvS");

var $4irYd = parcelRequire("4irYd");

var $lKQfu = parcelRequire("lKQfu");

var $fKxww = parcelRequire("fKxww");

var $ilqjt = parcelRequire("ilqjt");

var $iDtim = parcelRequire("iDtim");

var $dAx5m = parcelRequire("dAx5m");

var $55TWT = parcelRequire("55TWT");

var $jrFqr = parcelRequire("jrFqr");
parcelRequire("cdg3t");
var $01PEk = parcelRequire("01PEk");

var $d4tTe = parcelRequire("d4tTe");
parcelRequire("18rL9");
var $jUaEE = parcelRequire("jUaEE");

var $05eJd = parcelRequire("05eJd");
function $f16e8f901dacc147$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $f16e8f901dacc147$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, (/*@__PURE__*/$parcel$interopDefault($ilqjt)))(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, (/*@__PURE__*/$parcel$interopDefault($ilqjt)))(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, (/*@__PURE__*/$parcel$interopDefault($fKxww)))(this, result);
    };
}
function $f16e8f901dacc147$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($f16e8f901dacc147$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $f16e8f901dacc147$export$cc2d4897ee42bd01 = /*#__PURE__*/ function(_React$Component) {
    (0, (/*@__PURE__*/$parcel$interopDefault($lKQfu)))(DeactivateUserOverviewScreen, _React$Component);
    var _super = $f16e8f901dacc147$var$_createSuper(DeactivateUserOverviewScreen);
    function DeactivateUserOverviewScreen() {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($5MUML)))(this, DeactivateUserOverviewScreen);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, (/*@__PURE__*/$parcel$interopDefault($iDtim)))((0, (/*@__PURE__*/$parcel$interopDefault($4irYd)))(_this), "selectAdminOrSelfCopy", function(adminCopy, selfCopy) {
            return _this.props.isCurrentUser ? selfCopy : adminCopy;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($iDtim)))((0, (/*@__PURE__*/$parcel$interopDefault($4irYd)))(_this), "renderLoseAccessListElement", function() {
            var _this$props = _this.props, accessibleSites = _this$props.accessibleSites, user = _this$props.user;
            var hasAccessibleSites = accessibleSites && accessibleSites.length > 0;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement("li", null, !hasAccessibleSites && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $55TWT.default), (0, (/*@__PURE__*/$parcel$interopDefault($8TMbA)))({}, _this.selectAdminOrSelfCopy((0, $jrFqr.deactivateUserOverviewMessages).paragraphLoseAccessAdminNoSites, (0, $jrFqr.deactivateUserOverviewMessages).paragraphLoseAccessSelfNoSites), {
                values: {
                    fullName: user.fullName,
                    b: function b(s) {
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement("b", null, s);
                    }
                }
            })), hasAccessibleSites && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $55TWT.default), (0, (/*@__PURE__*/$parcel$interopDefault($8TMbA)))({}, _this.selectAdminOrSelfCopy((0, $jrFqr.deactivateUserOverviewMessages).paragraphLoseAccessAdmin, (0, $jrFqr.deactivateUserOverviewMessages).paragraphLoseAccessSelf), {
                values: {
                    fullName: user.fullName,
                    b: function b(s) {
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement("b", null, s);
                    }
                },
                tagName: "p"
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement($d4tTe.AccessibleSitesWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $jUaEE.DropdownList), {
                accessibleSites: accessibleSites
            }))));
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($iDtim)))((0, (/*@__PURE__*/$parcel$interopDefault($4irYd)))(_this), "renderPersonalDataListElement", function() {
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement("li", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $55TWT.default), _this.selectAdminOrSelfCopy((0, $jrFqr.deactivateUserOverviewMessages).paragraphPersonalDataAdmin, (0, $jrFqr.deactivateUserOverviewMessages).paragraphPersonalDataSelf)));
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($iDtim)))((0, (/*@__PURE__*/$parcel$interopDefault($4irYd)))(_this), "renderBillingListElement", function() {
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement("li", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $55TWT.default), _this.selectAdminOrSelfCopy((0, $jrFqr.deactivateUserOverviewMessages).paragraphBillingAdmin, (0, $jrFqr.deactivateUserOverviewMessages).paragraphBillingSelf)));
        });
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($dXLvS)))(DeactivateUserOverviewScreen, [
        {
            key: "render",
            value: function render() {
                var user = this.props.user;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $05eJd.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement($d4tTe.Screen, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement($d4tTe.Title, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $55TWT.default), this.selectAdminOrSelfCopy((0, $jrFqr.deactivateUserOverviewMessages).headingAdmin, (0, $jrFqr.deactivateUserOverviewMessages).headingSelf))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $55TWT.default), (0, (/*@__PURE__*/$parcel$interopDefault($8TMbA)))({}, this.selectAdminOrSelfCopy((0, $jrFqr.deactivateUserOverviewMessages).firstLineAdmin, (0, $jrFqr.deactivateUserOverviewMessages).firstLineSelf), {
                    tagName: "p"
                })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $01PEk.default), {
                    user: user
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $55TWT.default), this.selectAdminOrSelfCopy((0, $jrFqr.deactivateUserOverviewMessages).paragraphAboutToDeactivateAdmin, (0, $jrFqr.deactivateUserOverviewMessages).paragraphAboutToDeactivateSelf)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement($d4tTe.MainInformationList, null, this.renderLoseAccessListElement(), this.renderPersonalDataListElement(), this.renderBillingListElement()), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $55TWT.default), (0, (/*@__PURE__*/$parcel$interopDefault($8TMbA)))({}, this.selectAdminOrSelfCopy((0, $jrFqr.deactivateUserOverviewMessages).lastLineAdmin, (0, $jrFqr.deactivateUserOverviewMessages).lastLineSelf), {
                    tagName: "p"
                }))));
            }
        }
    ]);
    return DeactivateUserOverviewScreen;
}((0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).Component);
(0, (/*@__PURE__*/$parcel$interopDefault($iDtim)))($f16e8f901dacc147$export$cc2d4897ee42bd01, "defaultProps", {
    isCurrentUser: false
});
var $f16e8f901dacc147$export$2e2bcd8739ae039 = $f16e8f901dacc147$export$cc2d4897ee42bd01;

});
parcelRegister("d4tTe", function(module, exports) {

$parcel$export(module.exports, "Screen", function () { return $9842d5934f9ffffb$export$a98515d67472a41f; });
$parcel$export(module.exports, "Title", function () { return $9842d5934f9ffffb$export$f99233281efd08a0; });
$parcel$export(module.exports, "MainInformationList", function () { return $9842d5934f9ffffb$export$e189358d897f3de5; });
$parcel$export(module.exports, "AccessibleSitesWrapper", function () { return $9842d5934f9ffffb$export$cbabc569cce3835; });

var $45N2i = parcelRequire("45N2i");

var $ku6eE = parcelRequire("ku6eE");

var $450dQ = parcelRequire("450dQ");

var $60Te3 = parcelRequire("60Te3");
var $9842d5934f9ffffb$var$_templateObject, $9842d5934f9ffffb$var$_templateObject2, $9842d5934f9ffffb$var$_templateObject3, $9842d5934f9ffffb$var$_templateObject4, $9842d5934f9ffffb$var$_templateObject5;
var $9842d5934f9ffffb$export$a98515d67472a41f = (0, $ku6eE.default).div($9842d5934f9ffffb$var$_templateObject || ($9842d5934f9ffffb$var$_templateObject = (0, (/*@__PURE__*/$parcel$interopDefault($45N2i)))([
    "\n  width: 100%;\n  max-width: 640px;\n  margin-bottom: ",
    "px;\n  > p {\n    margin-top: ",
    "px;\n    margin-bottom: ",
    "px;\n  }\n"
])), (0, $60Te3.default)(2), (0, $60Te3.default)(3), (0, $60Te3.default)(2));
var $9842d5934f9ffffb$export$43a792a870d28db2 = (0, $ku6eE.default).div($9842d5934f9ffffb$var$_templateObject2 || ($9842d5934f9ffffb$var$_templateObject2 = (0, (/*@__PURE__*/$parcel$interopDefault($45N2i)))([
    "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 500px;\n"
])));
var $9842d5934f9ffffb$export$f99233281efd08a0 = (0, $ku6eE.default).div($9842d5934f9ffffb$var$_templateObject3 || ($9842d5934f9ffffb$var$_templateObject3 = (0, (/*@__PURE__*/$parcel$interopDefault($45N2i)))([
    "\n  ",
    ";\n  margin-bottom: ",
    "px;\n  margin-top: 0;\n"
])), (0, $450dQ.h700), (0, $60Te3.default)(3));
var $9842d5934f9ffffb$export$e189358d897f3de5 = (0, $ku6eE.default).ul($9842d5934f9ffffb$var$_templateObject4 || ($9842d5934f9ffffb$var$_templateObject4 = (0, (/*@__PURE__*/$parcel$interopDefault($45N2i)))([
    "\n  > li b {\n    font-weight: 600;\n  }\n"
])));
var $9842d5934f9ffffb$export$cbabc569cce3835 = (0, $ku6eE.default).div($9842d5934f9ffffb$var$_templateObject5 || ($9842d5934f9ffffb$var$_templateObject5 = (0, (/*@__PURE__*/$parcel$interopDefault($45N2i)))([
    "\n  margin-top: ",
    "px;\n"
])), (0, $60Te3.default)(1.5));

});




parcelRegister("eN1Wl", function(module, exports) {

$parcel$export(module.exports, "redirect", function () { return $fc639e84f43fbdf0$export$89e12c5b50f7529d; });
$parcel$export(module.exports, "reload", function () { return $fc639e84f43fbdf0$export$32da5b5043dcd88c; });
/**
 * Abstractions over functions of the window object to facilitate mocking in tests.
 */ function $fc639e84f43fbdf0$export$89e12c5b50f7529d(hostname) {
    window.location.assign(hostname);
}
function $fc639e84f43fbdf0$export$32da5b5043dcd88c() {
    window.location.reload();
}

});

parcelRegister("d59gI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bc55c9332eae6005$export$2e2bcd8739ae039; });

var $cUsaH = parcelRequire("cUsaH");

const $bc55c9332eae6005$var$ErrorModalDialogLazy = (0, (/*@__PURE__*/$parcel$interopDefault($cUsaH)))({
    loader: ()=>(parcelRequire("l5y0t")),
    loading: ()=>null
});
$bc55c9332eae6005$var$ErrorModalDialogLazy.displayName = "lazy(ErrorModalDialog)";
var $bc55c9332eae6005$export$2e2bcd8739ae039 = $bc55c9332eae6005$var$ErrorModalDialogLazy;

});
parcelRegister("l5y0t", function(module, exports) {

var $6aCUT = parcelRequire("6aCUT");
module.exports = Promise.all([
    $6aCUT("935eB"),
    $6aCUT("2fcNx"),
    $6aCUT("5kTaM")
]).then(()=>parcelRequire("6SweT"));

});


parcelRegister("9n2A2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c9ec48731e4fb32f$export$2e2bcd8739ae039; });

var $cUsaH = parcelRequire("cUsaH");

const $c9ec48731e4fb32f$var$WarningModalDialogLazy = (0, (/*@__PURE__*/$parcel$interopDefault($cUsaH)))({
    loader: ()=>(parcelRequire("7Ey0X")),
    loading: ()=>null
});
$c9ec48731e4fb32f$var$WarningModalDialogLazy.displayName = "lazy(WarningModalDialog)";
var $c9ec48731e4fb32f$export$2e2bcd8739ae039 = $c9ec48731e4fb32f$var$WarningModalDialogLazy;

});
parcelRegister("7Ey0X", function(module, exports) {

var $6aCUT = parcelRequire("6aCUT");
module.exports = Promise.all([
    $6aCUT("935eB"),
    $6aCUT("2fcNx"),
    $6aCUT("7kkXx")
]).then(()=>parcelRequire("lDaeg"));

});


parcelRegister("ggxSz", function(module, exports) {
$parcel$export(module.exports, "useOnceWhen", function () { return (parcelRequire("6Q4AU")).useOnceWhen; });
$parcel$export(module.exports, "usePrevious", function () { return (parcelRequire("i4ou0")).usePrevious; });
parcelRequire("6Q4AU");
parcelRequire("i4ou0");

});
parcelRegister("6Q4AU", function(module, exports) {

$parcel$export(module.exports, "useOnceWhen", function () { return $55e9ba47b500a631$export$4ff988088e6353d2; });

var $dAx5m = parcelRequire("dAx5m");
const $55e9ba47b500a631$export$602521d848dcbc8f = (fn, deps = [])=>{
    const called = (0, $dAx5m.useRef)(false);
    return (0, $dAx5m.useCallback)(()=>{
        if (!called.current) {
            called.current = true;
            fn();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, deps);
};
const $55e9ba47b500a631$export$4ff988088e6353d2 = (condition, fn, deps)=>{
    const fire = $55e9ba47b500a631$export$602521d848dcbc8f(fn, deps);
    (0, $dAx5m.useEffect)(()=>{
        if (condition) fire();
    }, [
        condition,
        fire
    ]);
};

});

parcelRegister("i4ou0", function(module, exports) {

$parcel$export(module.exports, "usePrevious", function () { return $b34f4bbd612dfb14$export$5cae361ad82dce8b; });

var $dAx5m = parcelRequire("dAx5m");
function $b34f4bbd612dfb14$export$5cae361ad82dce8b(newValue) {
    const previousRef = (0, $dAx5m.useRef)();
    (0, $dAx5m.useEffect)(()=>{
        previousRef.current = newValue;
    });
    return previousRef.current;
}

});







parcelRegister("kA6jR", function(module, exports) {

var $6aCUT = parcelRequire("6aCUT");
module.exports = Promise.all([
    $6aCUT("ckeVw"),
    $6aCUT("935eB"),
    $6aCUT("2fcNx"),
    $6aCUT("9PsDR")
]).then(()=>parcelRequire("fDowG"));

});

parcelRegister("cTT9B", function(module, exports) {

var $6aCUT = parcelRequire("6aCUT");
module.exports = Promise.all([
    $6aCUT("cNijL"),
    $6aCUT("935eB"),
    $6aCUT("2fcNx"),
    $6aCUT("gVUjg")
]).then(()=>parcelRequire("2ezlW"));

});

parcelRegister("hYSeX", function(module, exports) {

var $6aCUT = parcelRequire("6aCUT");
module.exports = $6aCUT("av3UL").then(()=>parcelRequire("9bCBE"));

});

parcelRegister("bEokL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $87b64e5c5398c6e5$export$2e2bcd8739ae039; });
/**
 * __Section__
 *
 * A dropdown item group includes all the actions or items in a dropdown menu.
 *
 * - [Examples](https://atlassian.design/components/dropdown-menu/dropdown-item-group/examples)
 * - [Code](https://atlassian.design/components/dropdown-menu/dropdown-item-group/code)
 * - [Usage](https://atlassian.design/components/dropdown-menu/dropdown-item-group/usage)
 */ 
var $alMln = parcelRequire("alMln");
var $87b64e5c5398c6e5$export$2e2bcd8739ae039 = (0, $alMln.default);

});
parcelRegister("alMln", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $78915d9830052c9e$export$2e2bcd8739ae039; });

var $4VswB = parcelRequire("4VswB");

var $dtPp3 = parcelRequire("dtPp3");

var $dAx5m = parcelRequire("dAx5m");

var $jVTBW = parcelRequire("jVTBW");

var $e2xkU = parcelRequire("e2xkU");

var $xcnsi = parcelRequire("xcnsi");

var $9lCOE = parcelRequire("9lCOE");

var $koyev = parcelRequire("koyev");

var $3t4n1 = parcelRequire("3t4n1");

var $cFlEW = parcelRequire("cFlEW");
var $78915d9830052c9e$var$_excluded = [
    "children",
    "overrides",
    "title",
    "testId",
    "isScrollable",
    "hasSeparator",
    "id",
    "isList",
    "className"
];
var $78915d9830052c9e$var$gridSize = (0, $koyev.gridSize)();
var $78915d9830052c9e$var$itemHeadingTopMargin = $78915d9830052c9e$var$gridSize * 2.5;
var $78915d9830052c9e$var$itemHeadingBottomMargin = $78915d9830052c9e$var$gridSize * 0.75;
// Skeleton content is slightly shorter than the real content.
// Because of that we slightly increase the top margin to offset this so the
// containing size both real and skeleton always equal approx 30px.
var $78915d9830052c9e$var$itemHeadingContentHeight = (0, $3t4n1.headingSizes).h100.lineHeight;
var $78915d9830052c9e$var$skeletonHeadingHeight = $78915d9830052c9e$var$gridSize;
var $78915d9830052c9e$var$skeletonHeadingMarginOffset = 3;
var $78915d9830052c9e$var$skeletonHeadingTopMargin = $78915d9830052c9e$var$itemHeadingTopMargin + ($78915d9830052c9e$var$itemHeadingContentHeight - $78915d9830052c9e$var$skeletonHeadingHeight) - $78915d9830052c9e$var$skeletonHeadingMarginOffset;
// We want to move the entire body up by 3px without affecting the height of the skeleton container.
var $78915d9830052c9e$var$skeletonHeadingBottomMargin = $78915d9830052c9e$var$itemHeadingBottomMargin + $78915d9830052c9e$var$skeletonHeadingMarginOffset;
var $78915d9830052c9e$var$sectionPaddingTopBottom = $78915d9830052c9e$var$gridSize * 0.75;
var $78915d9830052c9e$var$VAR_SEPARATOR_COLOR = "--ds-menu-seperator-color";
var $78915d9830052c9e$var$sectionStyles = (0, $jVTBW.css)({
    "&::before, &::after": {
        display: "block",
        height: $78915d9830052c9e$var$sectionPaddingTopBottom,
        content: '""'
    },
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
    "& [data-ds--menu--heading-item]": {
        marginBlockEnd: $78915d9830052c9e$var$itemHeadingBottomMargin,
        marginBlockStart: $78915d9830052c9e$var$itemHeadingTopMargin,
        "&:first-of-type": {
            marginBlockStart: $78915d9830052c9e$var$itemHeadingTopMargin - $78915d9830052c9e$var$sectionPaddingTopBottom
        }
    },
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
    "& [data-ds--menu--skeleton-heading-item]": {
        marginBlockEnd: $78915d9830052c9e$var$skeletonHeadingBottomMargin,
        marginBlockStart: $78915d9830052c9e$var$skeletonHeadingTopMargin,
        "&:first-of-type": {
            marginBlockStart: $78915d9830052c9e$var$skeletonHeadingTopMargin - $78915d9830052c9e$var$sectionPaddingTopBottom
        }
    },
    "&:focus": {
        // NOTE: Firefox allows elements that have "overflow: auto" to gain focus (as if it had tab-index="0")
        // We have made a deliberate choice to leave this behaviour as is.
        // This makes the outline go inside by 1px so it can actually be displayed
        // else it gets cut off from the overflow: scroll from the parent menu group.
        outlineOffset: -1
    }
});
var $78915d9830052c9e$var$scrollableStyles = (0, $jVTBW.css)({
    flexShrink: 1,
    overflow: "auto"
});
var $78915d9830052c9e$var$unscrollableStyles = (0, $jVTBW.css)({
    flexShrink: 0
});
var $78915d9830052c9e$var$thickSeparatorStyles = (0, $jVTBW.css)({
    borderBlockStart: "2px solid var(".concat($78915d9830052c9e$var$VAR_SEPARATOR_COLOR, ", ", "var(--ds-border, ".concat((0, $9lCOE.N30A), ")"), ")")
});
var $78915d9830052c9e$var$thinSeparatorStyles = (0, $jVTBW.css)({
    borderBlockStart: "1px solid var(".concat($78915d9830052c9e$var$VAR_SEPARATOR_COLOR, ", ", "var(--ds-border, ".concat((0, $9lCOE.N30A), ")"), ")")
});
var $78915d9830052c9e$var$noSeparatorStyles = (0, $jVTBW.css)({
    // this is to ensure that adjacent sections without separators don't get additional margins.
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
    "[data-section] + &": {
        marginBlockStart: -6
    }
});
/**
 * __Section__
 *
 * A section includes related actions or items in a menu.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/section)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ var $78915d9830052c9e$var$Section = /*#__PURE__*/ (0, $dAx5m.forwardRef)(function(_ref, ref) {
    var children = _ref.children, overrides = _ref.overrides, title = _ref.title, testId = _ref.testId, isScrollable = _ref.isScrollable, hasSeparator = _ref.hasSeparator, id = _ref.id, _ref$isList = _ref.isList, isList = _ref$isList === void 0 ? false : _ref$isList, UNSAFE_className = _ref.className, rest = (0, (/*@__PURE__*/$parcel$interopDefault($dtPp3)))(_ref, $78915d9830052c9e$var$_excluded);
    (0, $e2xkU.propDeprecationWarning)("@atlaskit/menu", "overrides", overrides !== undefined, "" // TODO: Create DAC post when primitives/xcss are available as alternatives
    );
    var UNSAFE_headingOverrides = (0, $xcnsi.getBooleanFF)("platform.design-system-team.unsafe-overrides-killswitch_c8j9m") ? undefined : overrides && overrides.HeadingItem && overrides.HeadingItem.cssFn;
    var content = isList ? (0, $jVTBW.jsx)("ul", {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            margin: 0,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            padding: 0
        }
    }, (0, $dAx5m.Children).map((0, $dAx5m.Children).toArray(children), function(child, index) {
        return (0, $jVTBW.jsx)("li", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: {
                listStyleType: "none",
                margin: 0,
                padding: 0
            },
            key: index
        }, child);
    })) : children;
    var childrenMarkup = title !== undefined ? (0, $jVTBW.jsx)((0, $dAx5m.Fragment), null, (0, $jVTBW.jsx)((0, $cFlEW.default), {
        cssFn: UNSAFE_headingOverrides,
        testId: testId && "".concat(testId, "--heading"),
        "aria-hidden": true
    }, title), content) : (0, $jVTBW.jsx)((0, $dAx5m.Fragment), null, content);
    return (0, $jVTBW.jsx)("div", (0, (/*@__PURE__*/$parcel$interopDefault($4VswB)))({}, rest, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $xcnsi.getBooleanFF)("platform.design-system-team.unsafe-overrides-killswitch_c8j9m") ? undefined : UNSAFE_className,
        id: id,
        css: [
            $78915d9830052c9e$var$sectionStyles,
            isScrollable ? $78915d9830052c9e$var$scrollableStyles : $78915d9830052c9e$var$unscrollableStyles,
            hasSeparator ? (0, $xcnsi.getBooleanFF)("platform.design-system-team.section-1px-seperator-borders") ? $78915d9830052c9e$var$thinSeparatorStyles : $78915d9830052c9e$var$thickSeparatorStyles : $78915d9830052c9e$var$noSeparatorStyles
        ],
        "aria-label": title,
        "data-testid": testId,
        role: "group",
        "data-section": true,
        ref: ref
    }), childrenMarkup);
});
var $78915d9830052c9e$export$2e2bcd8739ae039 = $78915d9830052c9e$var$Section;

});
parcelRegister("3t4n1", function(module, exports) {

$parcel$export(module.exports, "headingSizes", function () { return $2867785d3693c343$export$bc02e067df412c3b; });

var $fzkYl = parcelRequire("fzkYl");

var $9lCOE = parcelRequire("9lCOE");

var $koyev = parcelRequire("koyev");
function $2867785d3693c343$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $2867785d3693c343$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $2867785d3693c343$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($fzkYl)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $2867785d3693c343$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $2867785d3693c343$export$2a99220fb32ec798 = {
    heading: {
        xxlarge: 'normal 500 35px/40px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
        xlarge: 'normal 600 29px/32px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
        large: 'normal 500 24px/28px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
        medium: 'normal 500 20px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
        small: 'normal 600 16px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
        xsmall: 'normal 600 14px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
        xxsmall: 'normal 600 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif'
    },
    body: {
        large: 'normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
        medium: 'normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
        UNSAFE_small: 'normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
        small: 'normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif'
    }
};
var $2867785d3693c343$var$baseHeading = function baseHeading(size, lineHeight) {
    return {
        fontSize: "".concat(size / 14, "em"),
        fontStyle: "inherit",
        lineHeight: lineHeight / size
    };
};
var $2867785d3693c343$export$bc02e067df412c3b = {
    h900: {
        size: 35,
        lineHeight: 40
    },
    h800: {
        size: 29,
        lineHeight: 32
    },
    h700: {
        size: 24,
        lineHeight: 28
    },
    h600: {
        size: 20,
        lineHeight: 24
    },
    h500: {
        size: 16,
        lineHeight: 20
    },
    h400: {
        size: 14,
        lineHeight: 16
    },
    h300: {
        size: 12,
        lineHeight: 16
    },
    h200: {
        size: 12,
        lineHeight: 16
    },
    h100: {
        size: 11,
        lineHeight: 16
    }
};
var $2867785d3693c343$export$bdb8f897727a9c67 = function h900() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return $2867785d3693c343$var$_objectSpread($2867785d3693c343$var$_objectSpread({}, $2867785d3693c343$var$baseHeading($2867785d3693c343$export$bc02e067df412c3b.h900.size, $2867785d3693c343$export$bc02e067df412c3b.h900.lineHeight)), {}, {
        color: "var(--ds-text, ".concat((0, $9lCOE.heading)(props), ")"),
        fontWeight: "var(--ds-font-weight-medium, 500)",
        letterSpacing: "-0.01em",
        marginTop: "".concat((0, $koyev.gridSize)() * 6.5, "px")
    });
};
var $2867785d3693c343$export$3953fb6fbd158d23 = function h800() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return $2867785d3693c343$var$_objectSpread($2867785d3693c343$var$_objectSpread({}, $2867785d3693c343$var$baseHeading($2867785d3693c343$export$bc02e067df412c3b.h800.size, $2867785d3693c343$export$bc02e067df412c3b.h800.lineHeight)), {}, {
        color: "var(--ds-text, ".concat((0, $9lCOE.heading)(props), ")"),
        fontWeight: "var(--ds-font-weight-semibold, 600)",
        letterSpacing: "-0.01em",
        marginTop: "".concat((0, $koyev.gridSize)() * 5, "px")
    });
};
var $2867785d3693c343$export$e4f993a313607daa = function h700() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return $2867785d3693c343$var$_objectSpread($2867785d3693c343$var$_objectSpread({}, $2867785d3693c343$var$baseHeading($2867785d3693c343$export$bc02e067df412c3b.h700.size, $2867785d3693c343$export$bc02e067df412c3b.h700.lineHeight)), {}, {
        color: "var(--ds-text, ".concat((0, $9lCOE.heading)(props), ")"),
        fontWeight: "var(--ds-font-weight-medium, 500)",
        letterSpacing: "-0.01em",
        marginTop: "".concat((0, $koyev.gridSize)() * 5, "px")
    });
};
var $2867785d3693c343$export$1e8b2acea3fb3119 = function h600() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return $2867785d3693c343$var$_objectSpread($2867785d3693c343$var$_objectSpread({}, $2867785d3693c343$var$baseHeading($2867785d3693c343$export$bc02e067df412c3b.h600.size, $2867785d3693c343$export$bc02e067df412c3b.h600.lineHeight)), {}, {
        color: "var(--ds-text, ".concat((0, $9lCOE.heading)(props), ")"),
        fontWeight: "var(--ds-font-weight-medium, 500)",
        letterSpacing: "-0.008em",
        marginTop: "".concat((0, $koyev.gridSize)() * 3.5, "px")
    });
};
var $2867785d3693c343$export$85aa43a9b9f06707 = function h500() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return $2867785d3693c343$var$_objectSpread($2867785d3693c343$var$_objectSpread({}, $2867785d3693c343$var$baseHeading($2867785d3693c343$export$bc02e067df412c3b.h500.size, $2867785d3693c343$export$bc02e067df412c3b.h500.lineHeight)), {}, {
        color: "var(--ds-text, ".concat((0, $9lCOE.heading)(props), ")"),
        fontWeight: "var(--ds-font-weight-semibold, 600)",
        letterSpacing: "-0.006em",
        marginTop: "".concat((0, $koyev.gridSize)() * 3, "px")
    });
};
var $2867785d3693c343$export$fcb7764b80bd908f = function h400() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return $2867785d3693c343$var$_objectSpread($2867785d3693c343$var$_objectSpread({}, $2867785d3693c343$var$baseHeading($2867785d3693c343$export$bc02e067df412c3b.h400.size, $2867785d3693c343$export$bc02e067df412c3b.h400.lineHeight)), {}, {
        color: "var(--ds-text, ".concat((0, $9lCOE.heading)(props), ")"),
        fontWeight: "var(--ds-font-weight-semibold, 600)",
        letterSpacing: "-0.003em",
        marginTop: "".concat((0, $koyev.gridSize)() * 2, "px")
    });
};
var $2867785d3693c343$export$a0e59c3bbc05e815 = function h300() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return $2867785d3693c343$var$_objectSpread($2867785d3693c343$var$_objectSpread({}, $2867785d3693c343$var$baseHeading($2867785d3693c343$export$bc02e067df412c3b.h300.size, $2867785d3693c343$export$bc02e067df412c3b.h300.lineHeight)), {}, {
        color: "var(--ds-text, ".concat((0, $9lCOE.heading)(props), ")"),
        fontWeight: "var(--ds-font-weight-semibold, 600)",
        marginTop: "".concat((0, $koyev.gridSize)() * 2.5, "px"),
        textTransform: "uppercase"
    });
};
var $2867785d3693c343$export$7ccf32eb2150ac7e = function h200() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return $2867785d3693c343$var$_objectSpread($2867785d3693c343$var$_objectSpread({}, $2867785d3693c343$var$baseHeading($2867785d3693c343$export$bc02e067df412c3b.h200.size, $2867785d3693c343$export$bc02e067df412c3b.h200.lineHeight)), {}, {
        color: "var(--ds-text-subtlest, ".concat((0, $9lCOE.subtleHeading)(props), ")"),
        fontWeight: "var(--ds-font-weight-semibold, 600)",
        marginTop: "".concat((0, $koyev.gridSize)() * 2, "px")
    });
};
var $2867785d3693c343$export$dfc0e69214efdc3c = function h100() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return $2867785d3693c343$var$_objectSpread($2867785d3693c343$var$_objectSpread({}, $2867785d3693c343$var$baseHeading($2867785d3693c343$export$bc02e067df412c3b.h100.size, $2867785d3693c343$export$bc02e067df412c3b.h100.lineHeight)), {}, {
        color: "var(--ds-text-subtlest, ".concat((0, $9lCOE.subtleHeading)(props), ")"),
        fontWeight: "var(--ds-font-weight-bold, 700)",
        marginTop: "".concat((0, $koyev.gridSize)() * 2, "px")
    });
};

});

parcelRegister("cFlEW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $938a1d77301cb493$export$2e2bcd8739ae039; });

var $4VswB = parcelRequire("4VswB");

var $dtPp3 = parcelRequire("dtPp3");

var $dAx5m = parcelRequire("dAx5m");

var $jVTBW = parcelRequire("jVTBW");

var $e2xkU = parcelRequire("e2xkU");

var $Bb0he = parcelRequire("Bb0he");

var $xcnsi = parcelRequire("xcnsi");

var $9lCOE = parcelRequire("9lCOE");

var $3t4n1 = parcelRequire("3t4n1");
var $938a1d77301cb493$var$_excluded = [
    "children",
    "testId",
    "headingLevel",
    "id",
    "cssFn",
    "className"
];
var $938a1d77301cb493$var$itemHeadingContentHeight = (0, $3t4n1.headingSizes).h100.lineHeight;
var $938a1d77301cb493$var$itemHeadingFontSize = (0, $3t4n1.headingSizes).h100.size;
var $938a1d77301cb493$var$headingStyles = (0, $jVTBW.css)({
    color: "var(--ds-text-subtle, ".concat((0, $9lCOE.N300), ")"),
    paddingBlock: "var(--ds-space-0, 0px)",
    paddingInline: "var(--ds-space-200, 16px)",
    textTransform: "uppercase"
});
var $938a1d77301cb493$var$baseHeadingStyles = (0, $jVTBW.css)({
    fontSize: $938a1d77301cb493$var$itemHeadingFontSize,
    fontWeight: "var(--ds-font-weight-bold, 700)",
    lineHeight: $938a1d77301cb493$var$itemHeadingContentHeight / $938a1d77301cb493$var$itemHeadingFontSize
});
var $938a1d77301cb493$var$tokenizedHeadingStyles = (0, $jVTBW.css)({
    font: 'var(--ds-font-heading-xxsmall, normal 600 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)'
});
/**
 * __Heading item__
 *
 * A heading item is used to describe sibling menu items.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/heading-item)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ var $938a1d77301cb493$var$HeadingItem = /*#__PURE__*/ (0, $dAx5m.memo)(function(_ref) {
    var children = _ref.children, testId = _ref.testId, _ref$headingLevel = _ref.headingLevel, headingLevel = _ref$headingLevel === void 0 ? 2 : _ref$headingLevel, id = _ref.id, _ref$cssFn = _ref.cssFn, cssFn = _ref$cssFn === void 0 ? (0, $Bb0he.default) : _ref$cssFn, UNSAFE_className = _ref.className, rest = (0, (/*@__PURE__*/$parcel$interopDefault($dtPp3)))(_ref, $938a1d77301cb493$var$_excluded);
    (0, $e2xkU.propDeprecationWarning)("@atlaskit/menu", "cssFn", cssFn !== (0, $Bb0he.default), "" // TODO: Create DAC post when primitives/xcss are available as alternatives
    );
    var UNSAFE_overrides = (0, $xcnsi.getBooleanFF)("platform.design-system-team.unsafe-overrides-killswitch_c8j9m") ? undefined : (0, $jVTBW.css)(cssFn(undefined));
    return (0, $jVTBW.jsx)("div", (0, (/*@__PURE__*/$parcel$interopDefault($4VswB)))({
        css: [
            $938a1d77301cb493$var$headingStyles,
            (0, $xcnsi.getBooleanFF)("platform.design-system-team.menu-tokenised-typography-styles") ? $938a1d77301cb493$var$tokenizedHeadingStyles : $938a1d77301cb493$var$baseHeadingStyles,
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
            UNSAFE_overrides
        ],
        role: "heading",
        "aria-level": headingLevel,
        "data-testid": testId,
        "data-ds--menu--heading-item": true,
        id: id,
        className: (0, $xcnsi.getBooleanFF)("platform.design-system-team.unsafe-overrides-killswitch_c8j9m") ? undefined : UNSAFE_className
    }, rest), children);
});
var $938a1d77301cb493$export$2e2bcd8739ae039 = $938a1d77301cb493$var$HeadingItem;

});



parcelRegister("7Eyf8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5926d4ca396a42f0$var$_react = $5926d4ca396a42f0$var$_interopRequireDefault((parcelRequire("dAx5m")));

var $9eGJl = parcelRequire("9eGJl");
function $5926d4ca396a42f0$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $5926d4ca396a42f0$var$ChevronDownIcon = (props)=>/*#__PURE__*/ $5926d4ca396a42f0$var$_react.default.createElement($9eGJl.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path d="M8.292 10.293a1.009 1.009 0 000 1.419l2.939 2.965c.218.215.5.322.779.322s.556-.107.769-.322l2.93-2.955a1.01 1.01 0 000-1.419.987.987 0 00-1.406 0l-2.298 2.317-2.307-2.327a.99.99 0 00-1.406 0z" fill="currentColor" fill-rule="evenodd"/></svg>`
    }, props));
$5926d4ca396a42f0$var$ChevronDownIcon.displayName = "ChevronDownIcon";
var $5926d4ca396a42f0$var$_default = $5926d4ca396a42f0$var$ChevronDownIcon;
module.exports.default = $5926d4ca396a42f0$var$_default;

});

parcelRegister("7bo29", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $53ac340cce6902c7$export$2e2bcd8739ae039; });

var $biutv = parcelRequire("biutv");

var $6P33l = parcelRequire("6P33l");

var $dAx5m = parcelRequire("dAx5m");

var $jVTBW = parcelRequire("jVTBW");

var $lIEia = parcelRequire("lIEia");

var $ca8LS = parcelRequire("ca8LS");

var $YuKRy = parcelRequire("YuKRy");
var $53ac340cce6902c7$var$_excluded = [
    "as",
    "children",
    "backgroundColor",
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    "style",
    "testId",
    "xcss"
], $53ac340cce6902c7$var$_excluded2 = [
    "className"
];
var $53ac340cce6902c7$export$e71c4d32a2263218 = /*#__PURE__*/ (0, $dAx5m.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, as = _ref$as === void 0 ? "div" : _ref$as, children = _ref.children, backgroundColor = _ref.backgroundColor, padding = _ref.padding, paddingBlock = _ref.paddingBlock, paddingBlockStart = _ref.paddingBlockStart, paddingBlockEnd = _ref.paddingBlockEnd, paddingInline = _ref.paddingInline, paddingInlineStart = _ref.paddingInlineStart, paddingInlineEnd = _ref.paddingInlineEnd, style = _ref.style, testId = _ref.testId, xcss = _ref.xcss, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($6P33l)))(_ref, $53ac340cce6902c7$var$_excluded);
    var Component = as;
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($6P33l)))(htmlAttributes, $53ac340cce6902c7$var$_excluded2);
    var className = xcss && (0, $ca8LS.parseXcss)(xcss);
    var node = // @ts-expect-error Expression produces a union type that is too complex to represent. I think this is unavoidable
    (0, $jVTBW.jsx)(Component, (0, (/*@__PURE__*/$parcel$interopDefault($biutv)))({
        style: style,
        ref: ref
    }, safeHtmlAttributes, {
        css: [
            $53ac340cce6902c7$var$baseStyles,
            backgroundColor && (0, $lIEia.backgroundColorStylesMap)[backgroundColor],
            (0, $lIEia.isSurfaceColorToken)(backgroundColor) && (0, $lIEia.surfaceColorStylesMap)[backgroundColor],
            padding && (0, $lIEia.paddingStylesMap).padding[padding],
            paddingBlock && (0, $lIEia.paddingStylesMap).paddingBlock[paddingBlock],
            paddingBlockStart && (0, $lIEia.paddingStylesMap).paddingBlockStart[paddingBlockStart],
            paddingBlockEnd && (0, $lIEia.paddingStylesMap).paddingBlockEnd[paddingBlockEnd],
            paddingInline && (0, $lIEia.paddingStylesMap).paddingInline[paddingInline],
            paddingInlineStart && (0, $lIEia.paddingStylesMap).paddingInlineStart[paddingInlineStart],
            paddingInlineEnd && (0, $lIEia.paddingStylesMap).paddingInlineEnd[paddingInlineEnd],
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
            className
        ],
        "data-testid": testId
    }), children);
    return backgroundColor ? (0, $jVTBW.jsx)((0, $YuKRy.SurfaceContext).Provider, {
        value: backgroundColor
    }, node) : node;
});
var $53ac340cce6902c7$export$2e2bcd8739ae039 = $53ac340cce6902c7$export$e71c4d32a2263218;
var $53ac340cce6902c7$var$baseStyles = (0, $jVTBW.css)({
    boxSizing: "border-box",
    appearance: "none",
    border: "none"
});

});
parcelRegister("biutv", function(module, exports) {
function $839903d981ec699a$var$_extends() {
    return module.exports = $839903d981ec699a$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $839903d981ec699a$var$_extends.apply(null, arguments);
}
module.exports = $839903d981ec699a$var$_extends, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("6P33l", function(module, exports) {

var $5FnUF = parcelRequire("5FnUF");
function $4f79dfbc63ceb6dc$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $5FnUF(e, t);
    if (Object.getOwnPropertySymbols) {
        var s = Object.getOwnPropertySymbols(e);
        for(r = 0; r < s.length; r++)o = s[r], t.includes(o) || ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
module.exports = $4f79dfbc63ceb6dc$var$_objectWithoutProperties, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("5FnUF", function(module, exports) {
function $420354b2a13ae20d$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.includes(n)) continue;
        t[n] = r[n];
    }
    return t;
}
module.exports = $420354b2a13ae20d$var$_objectWithoutPropertiesLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("lIEia", function(module, exports) {

$parcel$export(module.exports, "dimensionMap", function () { return $fcfcf62dd0ece1f3$export$6ccdbebca2ee545f; });
$parcel$export(module.exports, "positiveSpaceMap", function () { return $fcfcf62dd0ece1f3$export$958d0ae7f2977ae4; });
$parcel$export(module.exports, "allSpaceMap", function () { return $fcfcf62dd0ece1f3$export$632685d741f3dbbf; });
$parcel$export(module.exports, "inverseColorMap", function () { return $fcfcf62dd0ece1f3$export$2185ce37f9bdd963; });
$parcel$export(module.exports, "opacityMap", function () { return $fcfcf62dd0ece1f3$export$daf94a976c798b4f; });
$parcel$export(module.exports, "shadowMap", function () { return $fcfcf62dd0ece1f3$export$7aff6e7ba39bb774; });
$parcel$export(module.exports, "borderColorMap", function () { return $fcfcf62dd0ece1f3$export$1531ad5bb3fbedac; });
$parcel$export(module.exports, "backgroundColorMap", function () { return $fcfcf62dd0ece1f3$export$d1d79bf68ac056bd; });
$parcel$export(module.exports, "textColorMap", function () { return $fcfcf62dd0ece1f3$export$8473307aa00d6ea1; });
$parcel$export(module.exports, "layerMap", function () { return $fcfcf62dd0ece1f3$export$b5f31a7e431d2eab; });
$parcel$export(module.exports, "borderWidthMap", function () { return $fcfcf62dd0ece1f3$export$e1b83c5210c471b8; });
$parcel$export(module.exports, "borderRadiusMap", function () { return $fcfcf62dd0ece1f3$export$3c0a6c3e64bb180d; });
$parcel$export(module.exports, "paddingStylesMap", function () { return $fcfcf62dd0ece1f3$export$e615f061ca585a6c; });
$parcel$export(module.exports, "spaceStylesMap", function () { return $fcfcf62dd0ece1f3$export$bf46c3f9eeafc71f; });
$parcel$export(module.exports, "backgroundColorStylesMap", function () { return $fcfcf62dd0ece1f3$export$e7af83bafe7f9e63; });
$parcel$export(module.exports, "textColorStylesMap", function () { return $fcfcf62dd0ece1f3$export$3a1bcba60b23d7f0; });
$parcel$export(module.exports, "bodyTextStylesMap", function () { return $fcfcf62dd0ece1f3$export$a1962444bbf058e; });
$parcel$export(module.exports, "uiTextStylesMap", function () { return $fcfcf62dd0ece1f3$export$ca3e246f24657bd6; });
$parcel$export(module.exports, "surfaceColorStylesMap", function () { return $fcfcf62dd0ece1f3$export$ff257d957d48c421; });
$parcel$export(module.exports, "isSurfaceColorToken", function () { return $fcfcf62dd0ece1f3$export$5e65a44e5b6ecadb; });

var $1hEVr = parcelRequire("1hEVr");

var $jVTBW = parcelRequire("jVTBW");

var $ajMcn = parcelRequire("ajMcn");
function $fcfcf62dd0ece1f3$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $fcfcf62dd0ece1f3$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $fcfcf62dd0ece1f3$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($1hEVr)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $fcfcf62dd0ece1f3$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $fcfcf62dd0ece1f3$export$6ccdbebca2ee545f = {
    "100%": "100%",
    "size.100": "1rem",
    "size.200": "1.5rem",
    "size.300": "2rem",
    "size.400": "2.5rem",
    "size.500": "3rem",
    "size.600": "6rem",
    "size.1000": "12rem"
};
var $fcfcf62dd0ece1f3$export$958d0ae7f2977ae4 = {
    "space.0": "var(--ds-space-0, 0px)",
    "space.025": "var(--ds-space-025, 2px)",
    "space.050": "var(--ds-space-050, 4px)",
    "space.075": "var(--ds-space-075, 6px)",
    "space.100": "var(--ds-space-100, 8px)",
    "space.150": "var(--ds-space-150, 12px)",
    "space.200": "var(--ds-space-200, 16px)",
    "space.250": "var(--ds-space-250, 20px)",
    "space.300": "var(--ds-space-300, 24px)",
    "space.400": "var(--ds-space-400, 32px)",
    "space.500": "var(--ds-space-500, 40px)",
    "space.600": "var(--ds-space-600, 48px)",
    "space.800": "var(--ds-space-800, 64px)",
    "space.1000": "var(--ds-space-1000, 80px)"
};
var $fcfcf62dd0ece1f3$export$d2dc61f58390201c = {
    "space.negative.025": "var(--ds-space-negative-025, -2px)",
    "space.negative.050": "var(--ds-space-negative-050, -4px)",
    "space.negative.075": "var(--ds-space-negative-075, -6px)",
    "space.negative.100": "var(--ds-space-negative-100, -8px)",
    "space.negative.150": "var(--ds-space-negative-150, -12px)",
    "space.negative.200": "var(--ds-space-negative-200, -16px)",
    "space.negative.250": "var(--ds-space-negative-250, -20px)",
    "space.negative.300": "var(--ds-space-negative-300, -24px)",
    "space.negative.400": "var(--ds-space-negative-400, -32px)"
};
var $fcfcf62dd0ece1f3$export$632685d741f3dbbf = $fcfcf62dd0ece1f3$var$_objectSpread($fcfcf62dd0ece1f3$var$_objectSpread({}, $fcfcf62dd0ece1f3$export$958d0ae7f2977ae4), $fcfcf62dd0ece1f3$export$d2dc61f58390201c);
var $fcfcf62dd0ece1f3$export$2185ce37f9bdd963 = {
    "color.background.neutral.bold": "color.text.inverse",
    "color.background.neutral.bold.hovered": "color.text.inverse",
    "color.background.neutral.bold.pressed": "color.text.inverse",
    "color.background.selected.bold": "color.text.inverse",
    "color.background.selected.bold.hovered": "color.text.inverse",
    "color.background.selected.bold.pressed": "color.text.inverse",
    "color.background.brand.bold": "color.text.inverse",
    "color.background.brand.bold.hovered": "color.text.inverse",
    "color.background.brand.bold.pressed": "color.text.inverse",
    "color.background.brand.boldest": "color.text.inverse",
    "color.background.brand.boldest.hovered": "color.text.inverse",
    "color.background.brand.boldest.pressed": "color.text.inverse",
    "color.background.danger.bold": "color.text.inverse",
    "color.background.danger.bold.hovered": "color.text.inverse",
    "color.background.danger.bold.pressed": "color.text.inverse",
    "color.background.warning.bold": "color.text.warning.inverse",
    "color.background.warning.bold.hovered": "color.text.warning.inverse",
    "color.background.warning.bold.pressed": "color.text.warning.inverse",
    "color.background.success.bold": "color.text.inverse",
    "color.background.success.bold.hovered": "color.text.inverse",
    "color.background.success.bold.pressed": "color.text.inverse",
    "color.background.discovery.bold": "color.text.inverse",
    "color.background.discovery.bold.hovered": "color.text.inverse",
    "color.background.discovery.bold.pressed": "color.text.inverse",
    "color.background.information.bold": "color.text.inverse",
    "color.background.information.bold.hovered": "color.text.inverse",
    "color.background.information.bold.pressed": "color.text.inverse"
};
var $fcfcf62dd0ece1f3$export$daf94a976c798b4f = {
    "opacity.disabled": "var(--ds-opacity-disabled, 0.4)",
    "opacity.loading": "var(--ds-opacity-loading, 0.2)"
};
var $fcfcf62dd0ece1f3$export$7aff6e7ba39bb774 = {
    "elevation.shadow.overflow": "var(--ds-shadow-overflow, 0px 0px 8px #091e423f, 0px 0px 1px #091e424f)",
    "elevation.shadow.overflow.perimeter": "var(--ds-shadow-overflow-perimeter, #091e421f)",
    "elevation.shadow.overflow.spread": "var(--ds-shadow-overflow-spread, #091e4229)",
    "elevation.shadow.overlay": "var(--ds-shadow-overlay, 0px 8px 12px #091e423f, 0px 0px 1px #091e424f)",
    "elevation.shadow.raised": "var(--ds-shadow-raised, 0px 1px 1px #091e423f, 0px 0px 1px #091e4221)"
};
var $fcfcf62dd0ece1f3$export$41a358c9c2356760 = {
    "elevation.surface": "var(--ds-surface, #FFFFFF)",
    "elevation.surface.hovered": "var(--ds-surface-hovered, #FAFBFC)",
    "elevation.surface.pressed": "var(--ds-surface-pressed, #F4F5F7)",
    "elevation.surface.overlay": "var(--ds-surface-overlay, #FFFFFF)",
    "elevation.surface.overlay.hovered": "var(--ds-surface-overlay-hovered, #FAFBFC)",
    "elevation.surface.overlay.pressed": "var(--ds-surface-overlay-pressed, #F4F5F7)",
    "elevation.surface.raised": "var(--ds-surface-raised, #FFFFFF)",
    "elevation.surface.raised.hovered": "var(--ds-surface-raised-hovered, #FAFBFC)",
    "elevation.surface.raised.pressed": "var(--ds-surface-raised-pressed, #F4F5F7)",
    "elevation.surface.sunken": "var(--ds-surface-sunken, #F4F5F7)"
};
var $fcfcf62dd0ece1f3$export$1531ad5bb3fbedac = {
    "color.border": "var(--ds-border, #091e4221)",
    "color.border.accent.lime": "var(--ds-border-accent-lime, #6A9A23)",
    "color.border.accent.red": "var(--ds-border-accent-red, #FF5630)",
    "color.border.accent.orange": "var(--ds-border-accent-orange, #D94008)",
    "color.border.accent.yellow": "var(--ds-border-accent-yellow, #FFAB00)",
    "color.border.accent.green": "var(--ds-border-accent-green, #36B37E)",
    "color.border.accent.teal": "var(--ds-border-accent-teal, #00B8D9)",
    "color.border.accent.blue": "var(--ds-border-accent-blue, #0065FF)",
    "color.border.accent.purple": "var(--ds-border-accent-purple, #6554C0)",
    "color.border.accent.magenta": "var(--ds-border-accent-magenta, #CD519D)",
    "color.border.accent.gray": "var(--ds-border-accent-gray, #5E6C84)",
    "color.border.disabled": "var(--ds-border-disabled, #FAFBFC)",
    "color.border.focused": "var(--ds-border-focused, #2684FF)",
    "color.border.input": "var(--ds-border-input, #FAFBFC)",
    "color.border.inverse": "var(--ds-border-inverse, #FFFFFF)",
    "color.border.selected": "var(--ds-border-selected, #0052CC)",
    "color.border.brand": "var(--ds-border-brand, #0052CC)",
    "color.border.danger": "var(--ds-border-danger, #FF5630)",
    "color.border.warning": "var(--ds-border-warning, #FFC400)",
    "color.border.success": "var(--ds-border-success, #00875A)",
    "color.border.discovery": "var(--ds-border-discovery, #998DD9)",
    "color.border.information": "var(--ds-border-information, #0065FF)",
    "color.border.bold": "var(--ds-border-bold, #344563)"
};
var $fcfcf62dd0ece1f3$export$d1d79bf68ac056bd = {
    "color.background.accent.lime.subtlest": "var(--ds-background-accent-lime-subtlest, #EEFBDA)",
    "color.background.accent.lime.subtlest.hovered": "var(--ds-background-accent-lime-subtlest-hovered, #D3F1A7)",
    "color.background.accent.lime.subtlest.pressed": "var(--ds-background-accent-lime-subtlest-pressed, #B3DF72)",
    "color.background.accent.lime.subtler": "var(--ds-background-accent-lime-subtler, #D3F1A7)",
    "color.background.accent.lime.subtler.hovered": "var(--ds-background-accent-lime-subtler-hovered, #B3DF72)",
    "color.background.accent.lime.subtler.pressed": "var(--ds-background-accent-lime-subtler-pressed, #94C748)",
    "color.background.accent.lime.subtle": "var(--ds-background-accent-lime-subtle, #94C748)",
    "color.background.accent.lime.subtle.hovered": "var(--ds-background-accent-lime-subtle-hovered, #B3DF72)",
    "color.background.accent.lime.subtle.pressed": "var(--ds-background-accent-lime-subtle-pressed, #D3F1A7)",
    "color.background.accent.lime.bolder": "var(--ds-background-accent-lime-bolder, #5B7F24)",
    "color.background.accent.lime.bolder.hovered": "var(--ds-background-accent-lime-bolder-hovered, #37471F)",
    "color.background.accent.lime.bolder.pressed": "var(--ds-background-accent-lime-bolder-pressed, #37471F)",
    "color.background.accent.red.subtlest": "var(--ds-background-accent-red-subtlest, #FF8F73)",
    "color.background.accent.red.subtlest.hovered": "var(--ds-background-accent-red-subtlest-hovered, #FF7452)",
    "color.background.accent.red.subtlest.pressed": "var(--ds-background-accent-red-subtlest-pressed, #FF5630)",
    "color.background.accent.red.subtler": "var(--ds-background-accent-red-subtler, #FF7452)",
    "color.background.accent.red.subtler.hovered": "var(--ds-background-accent-red-subtler-hovered, #FF5630)",
    "color.background.accent.red.subtler.pressed": "var(--ds-background-accent-red-subtler-pressed, #DE350B)",
    "color.background.accent.red.subtle": "var(--ds-background-accent-red-subtle, #DE350B)",
    "color.background.accent.red.subtle.hovered": "var(--ds-background-accent-red-subtle-hovered, #FF5630)",
    "color.background.accent.red.subtle.pressed": "var(--ds-background-accent-red-subtle-pressed, #FF7452)",
    "color.background.accent.red.bolder": "var(--ds-background-accent-red-bolder, #DE350B)",
    "color.background.accent.red.bolder.hovered": "var(--ds-background-accent-red-bolder-hovered, #FF5630)",
    "color.background.accent.red.bolder.pressed": "var(--ds-background-accent-red-bolder-pressed, #FF7452)",
    "color.background.accent.orange.subtlest": "var(--ds-background-accent-orange-subtlest, #F18D13)",
    "color.background.accent.orange.subtlest.hovered": "var(--ds-background-accent-orange-subtlest-hovered, #FEC57B)",
    "color.background.accent.orange.subtlest.pressed": "var(--ds-background-accent-orange-subtlest-pressed, #FFE2BD)",
    "color.background.accent.orange.subtler": "var(--ds-background-accent-orange-subtler, #B65C02)",
    "color.background.accent.orange.subtler.hovered": "var(--ds-background-accent-orange-subtler-hovered, #F18D13)",
    "color.background.accent.orange.subtler.pressed": "var(--ds-background-accent-orange-subtler-pressed, #FEC57B)",
    "color.background.accent.orange.subtle": "var(--ds-background-accent-orange-subtle, #5F3811)",
    "color.background.accent.orange.subtle.hovered": "var(--ds-background-accent-orange-subtle-hovered, #974F0C)",
    "color.background.accent.orange.subtle.pressed": "var(--ds-background-accent-orange-subtle-pressed, #B65C02)",
    "color.background.accent.orange.bolder": "var(--ds-background-accent-orange-bolder, #43290F)",
    "color.background.accent.orange.bolder.hovered": "var(--ds-background-accent-orange-bolder-hovered, #5F3811)",
    "color.background.accent.orange.bolder.pressed": "var(--ds-background-accent-orange-bolder-pressed, #974F0C)",
    "color.background.accent.yellow.subtlest": "var(--ds-background-accent-yellow-subtlest, #FFE380)",
    "color.background.accent.yellow.subtlest.hovered": "var(--ds-background-accent-yellow-subtlest-hovered, #FFC400)",
    "color.background.accent.yellow.subtlest.pressed": "var(--ds-background-accent-yellow-subtlest-pressed, #FFAB00)",
    "color.background.accent.yellow.subtler": "var(--ds-background-accent-yellow-subtler, #FFC400)",
    "color.background.accent.yellow.subtler.hovered": "var(--ds-background-accent-yellow-subtler-hovered, #FFAB00)",
    "color.background.accent.yellow.subtler.pressed": "var(--ds-background-accent-yellow-subtler-pressed, #FF991F)",
    "color.background.accent.yellow.subtle": "var(--ds-background-accent-yellow-subtle, #FF991F)",
    "color.background.accent.yellow.subtle.hovered": "var(--ds-background-accent-yellow-subtle-hovered, #FFAB00)",
    "color.background.accent.yellow.subtle.pressed": "var(--ds-background-accent-yellow-subtle-pressed, #FFC400)",
    "color.background.accent.yellow.bolder": "var(--ds-background-accent-yellow-bolder, #FF991F)",
    "color.background.accent.yellow.bolder.hovered": "var(--ds-background-accent-yellow-bolder-hovered, #FFAB00)",
    "color.background.accent.yellow.bolder.pressed": "var(--ds-background-accent-yellow-bolder-pressed, #FFC400)",
    "color.background.accent.green.subtlest": "var(--ds-background-accent-green-subtlest, #79F2C0)",
    "color.background.accent.green.subtlest.hovered": "var(--ds-background-accent-green-subtlest-hovered, #57D9A3)",
    "color.background.accent.green.subtlest.pressed": "var(--ds-background-accent-green-subtlest-pressed, #36B37E)",
    "color.background.accent.green.subtler": "var(--ds-background-accent-green-subtler, #57D9A3)",
    "color.background.accent.green.subtler.hovered": "var(--ds-background-accent-green-subtler-hovered, #36B37E)",
    "color.background.accent.green.subtler.pressed": "var(--ds-background-accent-green-subtler-pressed, #00875A)",
    "color.background.accent.green.subtle": "var(--ds-background-accent-green-subtle, #00875A)",
    "color.background.accent.green.subtle.hovered": "var(--ds-background-accent-green-subtle-hovered, #36B37E)",
    "color.background.accent.green.subtle.pressed": "var(--ds-background-accent-green-subtle-pressed, #57D9A3)",
    "color.background.accent.green.bolder": "var(--ds-background-accent-green-bolder, #00875A)",
    "color.background.accent.green.bolder.hovered": "var(--ds-background-accent-green-bolder-hovered, #36B37E)",
    "color.background.accent.green.bolder.pressed": "var(--ds-background-accent-green-bolder-pressed, #57D9A3)",
    "color.background.accent.teal.subtlest": "var(--ds-background-accent-teal-subtlest, #79E2F2)",
    "color.background.accent.teal.subtlest.hovered": "var(--ds-background-accent-teal-subtlest-hovered, #00C7E6)",
    "color.background.accent.teal.subtlest.pressed": "var(--ds-background-accent-teal-subtlest-pressed, #00B8D9)",
    "color.background.accent.teal.subtler": "var(--ds-background-accent-teal-subtler, #00C7E6)",
    "color.background.accent.teal.subtler.hovered": "var(--ds-background-accent-teal-subtler-hovered, #00B8D9)",
    "color.background.accent.teal.subtler.pressed": "var(--ds-background-accent-teal-subtler-pressed, #00A3BF)",
    "color.background.accent.teal.subtle": "var(--ds-background-accent-teal-subtle, #00A3BF)",
    "color.background.accent.teal.subtle.hovered": "var(--ds-background-accent-teal-subtle-hovered, #00B8D9)",
    "color.background.accent.teal.subtle.pressed": "var(--ds-background-accent-teal-subtle-pressed, #00C7E6)",
    "color.background.accent.teal.bolder": "var(--ds-background-accent-teal-bolder, #00A3BF)",
    "color.background.accent.teal.bolder.hovered": "var(--ds-background-accent-teal-bolder-hovered, #00B8D9)",
    "color.background.accent.teal.bolder.pressed": "var(--ds-background-accent-teal-bolder-pressed, #00C7E6)",
    "color.background.accent.blue.subtlest": "var(--ds-background-accent-blue-subtlest, #4C9AFF)",
    "color.background.accent.blue.subtlest.hovered": "var(--ds-background-accent-blue-subtlest-hovered, #2684FF)",
    "color.background.accent.blue.subtlest.pressed": "var(--ds-background-accent-blue-subtlest-pressed, #0065FF)",
    "color.background.accent.blue.subtler": "var(--ds-background-accent-blue-subtler, #2684FF)",
    "color.background.accent.blue.subtler.hovered": "var(--ds-background-accent-blue-subtler-hovered, #0065FF)",
    "color.background.accent.blue.subtler.pressed": "var(--ds-background-accent-blue-subtler-pressed, #0052CC)",
    "color.background.accent.blue.subtle": "var(--ds-background-accent-blue-subtle, #0052CC)",
    "color.background.accent.blue.subtle.hovered": "var(--ds-background-accent-blue-subtle-hovered, #0065FF)",
    "color.background.accent.blue.subtle.pressed": "var(--ds-background-accent-blue-subtle-pressed, #2684FF)",
    "color.background.accent.blue.bolder": "var(--ds-background-accent-blue-bolder, #0052CC)",
    "color.background.accent.blue.bolder.hovered": "var(--ds-background-accent-blue-bolder-hovered, #0065FF)",
    "color.background.accent.blue.bolder.pressed": "var(--ds-background-accent-blue-bolder-pressed, #2684FF)",
    "color.background.accent.purple.subtlest": "var(--ds-background-accent-purple-subtlest, #998DD9)",
    "color.background.accent.purple.subtlest.hovered": "var(--ds-background-accent-purple-subtlest-hovered, #8777D9)",
    "color.background.accent.purple.subtlest.pressed": "var(--ds-background-accent-purple-subtlest-pressed, #6554C0)",
    "color.background.accent.purple.subtler": "var(--ds-background-accent-purple-subtler, #8777D9)",
    "color.background.accent.purple.subtler.hovered": "var(--ds-background-accent-purple-subtler-hovered, #6554C0)",
    "color.background.accent.purple.subtler.pressed": "var(--ds-background-accent-purple-subtler-pressed, #5243AA)",
    "color.background.accent.purple.subtle": "var(--ds-background-accent-purple-subtle, #5243AA)",
    "color.background.accent.purple.subtle.hovered": "var(--ds-background-accent-purple-subtle-hovered, #6554C0)",
    "color.background.accent.purple.subtle.pressed": "var(--ds-background-accent-purple-subtle-pressed, #8777D9)",
    "color.background.accent.purple.bolder": "var(--ds-background-accent-purple-bolder, #5243AA)",
    "color.background.accent.purple.bolder.hovered": "var(--ds-background-accent-purple-bolder-hovered, #6554C0)",
    "color.background.accent.purple.bolder.pressed": "var(--ds-background-accent-purple-bolder-pressed, #8777D9)",
    "color.background.accent.magenta.subtlest": "var(--ds-background-accent-magenta-subtlest, #FFECF8)",
    "color.background.accent.magenta.subtlest.hovered": "var(--ds-background-accent-magenta-subtlest-hovered, #FDD0EC)",
    "color.background.accent.magenta.subtlest.pressed": "var(--ds-background-accent-magenta-subtlest-pressed, #F797D2)",
    "color.background.accent.magenta.subtler": "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
    "color.background.accent.magenta.subtler.hovered": "var(--ds-background-accent-magenta-subtler-hovered, #F797D2)",
    "color.background.accent.magenta.subtler.pressed": "var(--ds-background-accent-magenta-subtler-pressed, #E774BB)",
    "color.background.accent.magenta.subtle": "var(--ds-background-accent-magenta-subtle, #E774BB)",
    "color.background.accent.magenta.subtle.hovered": "var(--ds-background-accent-magenta-subtle-hovered, #F797D2)",
    "color.background.accent.magenta.subtle.pressed": "var(--ds-background-accent-magenta-subtle-pressed, #FDD0EC)",
    "color.background.accent.magenta.bolder": "var(--ds-background-accent-magenta-bolder, #AE4787)",
    "color.background.accent.magenta.bolder.hovered": "var(--ds-background-accent-magenta-bolder-hovered, #943D73)",
    "color.background.accent.magenta.bolder.pressed": "var(--ds-background-accent-magenta-bolder-pressed, #50253F)",
    "color.background.accent.gray.subtlest": "var(--ds-background-accent-gray-subtlest, #6B778C)",
    "color.background.accent.gray.subtlest.hovered": "var(--ds-background-accent-gray-subtlest-hovered, #5E6C84)",
    "color.background.accent.gray.subtlest.pressed": "var(--ds-background-accent-gray-subtlest-pressed, #505F79)",
    "color.background.accent.gray.subtler": "var(--ds-background-accent-gray-subtler, #5E6C84)",
    "color.background.accent.gray.subtler.hovered": "var(--ds-background-accent-gray-subtler-hovered, #505F79)",
    "color.background.accent.gray.subtler.pressed": "var(--ds-background-accent-gray-subtler-pressed, #42526E)",
    "color.background.accent.gray.subtle": "var(--ds-background-accent-gray-subtle, #505F79)",
    "color.background.accent.gray.subtle.hovered": "var(--ds-background-accent-gray-subtle-hovered, #5E6C84)",
    "color.background.accent.gray.subtle.pressed": "var(--ds-background-accent-gray-subtle-pressed, #6B778C)",
    "color.background.accent.gray.bolder": "var(--ds-background-accent-gray-bolder, #42526E)",
    "color.background.accent.gray.bolder.hovered": "var(--ds-background-accent-gray-bolder-hovered, #344563)",
    "color.background.accent.gray.bolder.pressed": "var(--ds-background-accent-gray-bolder-pressed, #253858)",
    "color.background.disabled": "var(--ds-background-disabled, #091e4289)",
    "color.background.input": "var(--ds-background-input, #FAFBFC)",
    "color.background.input.hovered": "var(--ds-background-input-hovered, #EBECF0)",
    "color.background.input.pressed": "var(--ds-background-input-pressed, #FFFFFF)",
    "color.background.inverse.subtle": "var(--ds-background-inverse-subtle, #00000029)",
    "color.background.inverse.subtle.hovered": "var(--ds-background-inverse-subtle-hovered, #0000003D)",
    "color.background.inverse.subtle.pressed": "var(--ds-background-inverse-subtle-pressed, #00000052)",
    "color.background.neutral": "var(--ds-background-neutral, #DFE1E6)",
    "color.background.neutral.hovered": "var(--ds-background-neutral-hovered, #091e4214)",
    "color.background.neutral.pressed": "var(--ds-background-neutral-pressed, #B3D4FF)",
    "color.background.neutral.subtle": "var(--ds-background-neutral-subtle, transparent)",
    "color.background.neutral.subtle.hovered": "var(--ds-background-neutral-subtle-hovered, #091e4214)",
    "color.background.neutral.subtle.pressed": "var(--ds-background-neutral-subtle-pressed, #B3D4FF)",
    "color.background.neutral.bold": "var(--ds-background-neutral-bold, #42526E)",
    "color.background.neutral.bold.hovered": "var(--ds-background-neutral-bold-hovered, #505F79)",
    "color.background.neutral.bold.pressed": "var(--ds-background-neutral-bold-pressed, #344563)",
    "color.background.selected": "var(--ds-background-selected, #DEEBFF)",
    "color.background.selected.hovered": "var(--ds-background-selected-hovered, #B3D4FF)",
    "color.background.selected.pressed": "var(--ds-background-selected-pressed, #4C9AFF)",
    "color.background.selected.bold": "var(--ds-background-selected-bold, #0052CC)",
    "color.background.selected.bold.hovered": "var(--ds-background-selected-bold-hovered, #2684FF)",
    "color.background.selected.bold.pressed": "var(--ds-background-selected-bold-pressed, #0052CC)",
    "color.background.brand.subtlest": "var(--ds-background-brand-subtlest, #B3D4FF)",
    "color.background.brand.subtlest.hovered": "var(--ds-background-brand-subtlest-hovered, #DEEBFF)",
    "color.background.brand.subtlest.pressed": "var(--ds-background-brand-subtlest-pressed, #4C9AFF)",
    "color.background.brand.bold": "var(--ds-background-brand-bold, #0052CC)",
    "color.background.brand.bold.hovered": "var(--ds-background-brand-bold-hovered, #0065FF)",
    "color.background.brand.bold.pressed": "var(--ds-background-brand-bold-pressed, #0747A6)",
    "color.background.brand.boldest": "var(--ds-background-brand-boldest, #0747A6)",
    "color.background.brand.boldest.hovered": "var(--ds-background-brand-boldest-hovered, #0052CC)",
    "color.background.brand.boldest.pressed": "var(--ds-background-brand-boldest-pressed, #0747A6)",
    "color.background.danger": "var(--ds-background-danger, #FFEBE6)",
    "color.background.danger.hovered": "var(--ds-background-danger-hovered, #FFBDAD)",
    "color.background.danger.pressed": "var(--ds-background-danger-pressed, #FF8F73)",
    "color.background.danger.bold": "var(--ds-background-danger-bold, #DE350B)",
    "color.background.danger.bold.hovered": "var(--ds-background-danger-bold-hovered, #FF5630)",
    "color.background.danger.bold.pressed": "var(--ds-background-danger-bold-pressed, #BF2600)",
    "color.background.warning": "var(--ds-background-warning, #FFFAE6)",
    "color.background.warning.hovered": "var(--ds-background-warning-hovered, #FFF0B3)",
    "color.background.warning.pressed": "var(--ds-background-warning-pressed, #FFE380)",
    "color.background.warning.bold": "var(--ds-background-warning-bold, #FFAB00)",
    "color.background.warning.bold.hovered": "var(--ds-background-warning-bold-hovered, #FFC400)",
    "color.background.warning.bold.pressed": "var(--ds-background-warning-bold-pressed, #FF991F)",
    "color.background.success": "var(--ds-background-success, #E3FCEF)",
    "color.background.success.hovered": "var(--ds-background-success-hovered, #ABF5D1)",
    "color.background.success.pressed": "var(--ds-background-success-pressed, #79F2C0)",
    "color.background.success.bold": "var(--ds-background-success-bold, #00875A)",
    "color.background.success.bold.hovered": "var(--ds-background-success-bold-hovered, #57D9A3)",
    "color.background.success.bold.pressed": "var(--ds-background-success-bold-pressed, #00875A)",
    "color.background.discovery": "var(--ds-background-discovery, #EAE6FF)",
    "color.background.discovery.hovered": "var(--ds-background-discovery-hovered, #C0B6F2)",
    "color.background.discovery.pressed": "var(--ds-background-discovery-pressed, #998DD9)",
    "color.background.discovery.bold": "var(--ds-background-discovery-bold, #5243AA)",
    "color.background.discovery.bold.hovered": "var(--ds-background-discovery-bold-hovered, #8777D9)",
    "color.background.discovery.bold.pressed": "var(--ds-background-discovery-bold-pressed, #5243AA)",
    "color.background.information": "var(--ds-background-information, #DEEBFF)",
    "color.background.information.hovered": "var(--ds-background-information-hovered, #B3D4FF)",
    "color.background.information.pressed": "var(--ds-background-information-pressed, #4C9AFF)",
    "color.background.information.bold": "var(--ds-background-information-bold, #0052CC)",
    "color.background.information.bold.hovered": "var(--ds-background-information-bold-hovered, #2684FF)",
    "color.background.information.bold.pressed": "var(--ds-background-information-bold-pressed, #0052CC)",
    "color.blanket": "var(--ds-blanket, #091e4289)",
    "color.blanket.selected": "var(--ds-blanket-selected, #388BFF14)",
    "color.blanket.danger": "var(--ds-blanket-danger, #EF5C4814)",
    "elevation.surface": "var(--ds-surface, #FFFFFF)",
    "elevation.surface.hovered": "var(--ds-surface-hovered, #FAFBFC)",
    "elevation.surface.pressed": "var(--ds-surface-pressed, #F4F5F7)",
    "elevation.surface.overlay": "var(--ds-surface-overlay, #FFFFFF)",
    "elevation.surface.overlay.hovered": "var(--ds-surface-overlay-hovered, #FAFBFC)",
    "elevation.surface.overlay.pressed": "var(--ds-surface-overlay-pressed, #F4F5F7)",
    "elevation.surface.raised": "var(--ds-surface-raised, #FFFFFF)",
    "elevation.surface.raised.hovered": "var(--ds-surface-raised-hovered, #FAFBFC)",
    "elevation.surface.raised.pressed": "var(--ds-surface-raised-pressed, #F4F5F7)",
    "elevation.surface.sunken": "var(--ds-surface-sunken, #F4F5F7)",
    "utility.elevation.surface.current": "var(--ds-elevation-surface-current, #FFFFFF)"
};
var $fcfcf62dd0ece1f3$export$8473307aa00d6ea1 = {
    "color.text": "var(--ds-text, #172B4D)",
    "color.text.accent.lime": "var(--ds-text-accent-lime, #4C6B1F)",
    "color.text.accent.lime.bolder": "var(--ds-text-accent-lime-bolder, #37471F)",
    "color.text.accent.red": "var(--ds-text-accent-red, #DE350B)",
    "color.text.accent.red.bolder": "var(--ds-text-accent-red-bolder, #BF2600)",
    "color.text.accent.orange": "var(--ds-text-accent-orange, #F18D13)",
    "color.text.accent.orange.bolder": "var(--ds-text-accent-orange-bolder, #B65C02)",
    "color.text.accent.yellow": "var(--ds-text-accent-yellow, #FF991F)",
    "color.text.accent.yellow.bolder": "var(--ds-text-accent-yellow-bolder, #FF8B00)",
    "color.text.accent.green": "var(--ds-text-accent-green, #00875A)",
    "color.text.accent.green.bolder": "var(--ds-text-accent-green-bolder, #006644)",
    "color.text.accent.teal": "var(--ds-text-accent-teal, #00A3BF)",
    "color.text.accent.teal.bolder": "var(--ds-text-accent-teal-bolder, #008DA6)",
    "color.text.accent.blue": "var(--ds-text-accent-blue, #0052CC)",
    "color.text.accent.blue.bolder": "var(--ds-text-accent-blue-bolder, #0747A6)",
    "color.text.accent.purple": "var(--ds-text-accent-purple, #5243AA)",
    "color.text.accent.purple.bolder": "var(--ds-text-accent-purple-bolder, #403294)",
    "color.text.accent.magenta": "var(--ds-text-accent-magenta, #E774BB)",
    "color.text.accent.magenta.bolder": "var(--ds-text-accent-magenta-bolder, #DA62AC)",
    "color.text.accent.gray": "var(--ds-text-accent-gray, #505F79)",
    "color.text.accent.gray.bolder": "var(--ds-text-accent-gray-bolder, #172B4D)",
    "color.text.disabled": "var(--ds-text-disabled, #A5ADBA)",
    "color.text.inverse": "var(--ds-text-inverse, #FFFFFF)",
    "color.text.selected": "var(--ds-text-selected, #0052CC)",
    "color.text.brand": "var(--ds-text-brand, #0065FF)",
    "color.text.danger": "var(--ds-text-danger, #DE350B)",
    "color.text.warning": "var(--ds-text-warning, #974F0C)",
    "color.text.warning.inverse": "var(--ds-text-warning-inverse, #172B4D)",
    "color.text.success": "var(--ds-text-success, #006644)",
    "color.text.discovery": "var(--ds-text-discovery, #403294)",
    "color.text.information": "var(--ds-text-information, #0052CC)",
    "color.text.subtlest": "var(--ds-text-subtlest, #7A869A)",
    "color.text.subtle": "var(--ds-text-subtle, #42526E)",
    "color.link": "var(--ds-link, #0052CC)",
    "color.link.pressed": "var(--ds-link-pressed, #0747A6)",
    "color.link.visited": "var(--ds-link-visited, #403294)"
};
var $fcfcf62dd0ece1f3$export$498780f74be9af68 = {
    "color.icon": "var(--ds-icon, #505F79)",
    "color.icon.accent.lime": "var(--ds-icon-accent-lime, #6A9A23)",
    "color.icon.accent.red": "var(--ds-icon-accent-red, #FF5630)",
    "color.icon.accent.orange": "var(--ds-icon-accent-orange, #D94008)",
    "color.icon.accent.yellow": "var(--ds-icon-accent-yellow, #FFAB00)",
    "color.icon.accent.green": "var(--ds-icon-accent-green, #36B37E)",
    "color.icon.accent.teal": "var(--ds-icon-accent-teal, #00B8D9)",
    "color.icon.accent.blue": "var(--ds-icon-accent-blue, #0065FF)",
    "color.icon.accent.purple": "var(--ds-icon-accent-purple, #6554C0)",
    "color.icon.accent.magenta": "var(--ds-icon-accent-magenta, #CD519D)",
    "color.icon.accent.gray": "var(--ds-icon-accent-gray, #5E6C84)",
    "color.icon.disabled": "var(--ds-icon-disabled, #8993A4)",
    "color.icon.inverse": "var(--ds-icon-inverse, #FFFFFF)",
    "color.icon.selected": "var(--ds-icon-selected, #0052CC)",
    "color.icon.brand": "var(--ds-icon-brand, #0065FF)",
    "color.icon.danger": "var(--ds-icon-danger, #DE350B)",
    "color.icon.warning": "var(--ds-icon-warning, #FFC400)",
    "color.icon.warning.inverse": "var(--ds-icon-warning-inverse, #253858)",
    "color.icon.success": "var(--ds-icon-success, #00875A)",
    "color.icon.discovery": "var(--ds-icon-discovery, #8777D9)",
    "color.icon.information": "var(--ds-icon-information, #0747A6)",
    "color.icon.subtle": "var(--ds-icon-subtle, #6B778C)"
};
var $fcfcf62dd0ece1f3$export$b5f31a7e431d2eab = {
    card: 100,
    navigation: 200,
    dialog: 300,
    layer: 400,
    blanket: 500,
    modal: 510,
    flag: 600,
    spotlight: 700,
    tooltip: 800
};
var $fcfcf62dd0ece1f3$export$e1b83c5210c471b8 = {
    "border.width": "var(--ds-border-width, 1px)",
    "border.width.0": "var(--ds-border-width-0, 0px)",
    "border.width.indicator": "var(--ds-border-width-indicator, 3px)",
    "border.width.outline": "var(--ds-border-width-outline, 2px)"
};
var $fcfcf62dd0ece1f3$export$3c0a6c3e64bb180d = {
    "border.radius.050": "var(--ds-border-radius-050, 2px)",
    "border.radius": "var(--ds-border-radius, 3px)",
    "border.radius.100": "var(--ds-border-radius-100, 3px)",
    "border.radius.200": "var(--ds-border-radius-200, 8px)",
    "border.radius.300": "var(--ds-border-radius-300, 12px)",
    "border.radius.400": "var(--ds-border-radius-400, 16px)",
    "border.radius.circle": "var(--ds-border-radius-circle, 32032px)"
};
var $fcfcf62dd0ece1f3$export$6cc560b4dedf3816 = {
    "font.size.050": "var(--ds-font-size-050, 11px)",
    "font.size.075": "var(--ds-font-size-075, 12px)",
    "font.size.100": "var(--ds-font-size-100, 14px)",
    "font.size.200": "var(--ds-font-size-200, 16px)",
    "font.size.300": "var(--ds-font-size-300, 20px)",
    "font.size.400": "var(--ds-font-size-400, 24px)",
    "font.size.500": "var(--ds-font-size-500, 29px)",
    "font.size.600": "var(--ds-font-size-600, 35px)"
};
var $fcfcf62dd0ece1f3$export$303e322c6b1ed114 = {
    "font.weight.bold": "var(--ds-font-weight-bold, 700)",
    "font.weight.medium": "var(--ds-font-weight-medium, 500)",
    "font.weight.regular": "var(--ds-font-weight-regular, 400)",
    "font.weight.semibold": "var(--ds-font-weight-semibold, 600)"
};
var $fcfcf62dd0ece1f3$export$3c7e9587132614b4 = {
    "font.family.body": 'var(--ds-font-family-body, ui-sans-serif, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.family.brand": "var(--ds-font-family-brand, Charlie Sans)",
    "font.family.code": 'var(--ds-font-family-code, ui-monospace, Menlo, "Segoe UI Mono", "Ubuntu Mono", monospace)',
    "font.family.heading": 'var(--ds-font-family-heading, ui-sans-serif, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.family.monospace": 'var(--ds-font-family-monospace, ui-monospace, Menlo, "Segoe UI Mono", "Ubuntu Mono", monospace)',
    "font.family.sans": 'var(--ds-font-family-sans, -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif)'
};
var $fcfcf62dd0ece1f3$export$360c29a380c1a34 = {
    "font.lineHeight.1": "var(--ds-font-lineHeight-1, 1)",
    "font.lineHeight.100": "var(--ds-font-lineHeight-100, 16px)",
    "font.lineHeight.200": "var(--ds-font-lineHeight-200, 20px)",
    "font.lineHeight.300": "var(--ds-font-lineHeight-300, 24px)",
    "font.lineHeight.400": "var(--ds-font-lineHeight-400, 28px)",
    "font.lineHeight.500": "var(--ds-font-lineHeight-500, 32px)",
    "font.lineHeight.600": "var(--ds-font-lineHeight-600, 40px)"
};
var $fcfcf62dd0ece1f3$export$b5bac06d7d8fd0d1 = {
    body: "var(--ds-font-body, normal 400 14px/20px var(--ds-font-family-body))",
    "body.large": "var(--ds-font-body-large, normal 400 16px/24px var(--ds-font-family-body))",
    "body.small": "var(--ds-font-body-small, normal 400 11px/16px var(--ds-font-family-body))"
};
var $fcfcf62dd0ece1f3$export$b27166c9cf2c9f74 = {
    ui: "var(--ds-font-ui, normal 400 14px/1 var(--ds-font-family-body))",
    "ui.small": "var(--ds-font-ui-small, normal 400 11px/1 var(--ds-font-family-body))"
};
/**
 * @codegenEnd
 */ // Generate maps for Box props. backgroundColor, padding, etc
var $fcfcf62dd0ece1f3$var$spacingProperties = [
    // Used by Box
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    // Used by Inline and Stack
    "gap",
    "rowGap",
    "columnGap"
];
var $fcfcf62dd0ece1f3$var$getSerializedStylesMap = function getSerializedStylesMap(cssProperty, tokenMap) {
    return Object.keys(tokenMap).reduce(function(emotionSpacingMap, token) {
        emotionSpacingMap[token] = (0, $jVTBW.css)((0, (/*@__PURE__*/$parcel$interopDefault($1hEVr)))({}, cssProperty, tokenMap[token]));
        return emotionSpacingMap;
    }, {});
};
var $fcfcf62dd0ece1f3$export$e615f061ca585a6c = $fcfcf62dd0ece1f3$var$spacingProperties.reduce(function(styleMap, spacingProperty) {
    styleMap[spacingProperty] = $fcfcf62dd0ece1f3$var$getSerializedStylesMap(spacingProperty, $fcfcf62dd0ece1f3$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
var $fcfcf62dd0ece1f3$export$bf46c3f9eeafc71f = $fcfcf62dd0ece1f3$var$spacingProperties.reduce(function(styleMap, spacingProperty) {
    styleMap[spacingProperty] = $fcfcf62dd0ece1f3$var$getSerializedStylesMap(spacingProperty, $fcfcf62dd0ece1f3$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
var $fcfcf62dd0ece1f3$export$e7af83bafe7f9e63 = $fcfcf62dd0ece1f3$var$getSerializedStylesMap("backgroundColor", $fcfcf62dd0ece1f3$export$d1d79bf68ac056bd);
var $fcfcf62dd0ece1f3$export$3a1bcba60b23d7f0 = $fcfcf62dd0ece1f3$var$getSerializedStylesMap("color", $fcfcf62dd0ece1f3$export$8473307aa00d6ea1);
var $fcfcf62dd0ece1f3$export$f7183c9e2dbc2543 = $fcfcf62dd0ece1f3$var$getSerializedStylesMap("fontSize", $fcfcf62dd0ece1f3$export$6cc560b4dedf3816);
var $fcfcf62dd0ece1f3$export$45f3f4fe16f9f7d5 = $fcfcf62dd0ece1f3$var$getSerializedStylesMap("fontWeight", $fcfcf62dd0ece1f3$export$303e322c6b1ed114);
var $fcfcf62dd0ece1f3$export$68cc305da27dbaa4 = $fcfcf62dd0ece1f3$var$getSerializedStylesMap("fontFamily", $fcfcf62dd0ece1f3$export$3c7e9587132614b4);
var $fcfcf62dd0ece1f3$export$8be4a21014f48eb1 = $fcfcf62dd0ece1f3$var$getSerializedStylesMap("lineHeight", $fcfcf62dd0ece1f3$export$360c29a380c1a34);
var $fcfcf62dd0ece1f3$export$a1962444bbf058e = $fcfcf62dd0ece1f3$var$getSerializedStylesMap("font", $fcfcf62dd0ece1f3$export$b5bac06d7d8fd0d1);
var $fcfcf62dd0ece1f3$export$ca3e246f24657bd6 = $fcfcf62dd0ece1f3$var$getSerializedStylesMap("font", $fcfcf62dd0ece1f3$export$b27166c9cf2c9f74);
var $fcfcf62dd0ece1f3$export$ff257d957d48c421 = $fcfcf62dd0ece1f3$var$getSerializedStylesMap((0, $ajMcn.CURRENT_SURFACE_CSS_VAR), $fcfcf62dd0ece1f3$export$41a358c9c2356760);
var $fcfcf62dd0ece1f3$export$5e65a44e5b6ecadb = function isSurfaceColorToken(color) {
    return $fcfcf62dd0ece1f3$export$41a358c9c2356760[color] !== undefined;
};

});
parcelRegister("1hEVr", function(module, exports) {

var $185hx = parcelRequire("185hx");
function $0ef71fe70be554e0$var$_defineProperty(e, r, t) {
    return (r = $185hx(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
module.exports = $0ef71fe70be554e0$var$_defineProperty, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("185hx", function(module, exports) {

var $b8aZW = parcelRequire("b8aZW");
var $0d2aa2ae6ad46164$var$_typeof = $b8aZW.default;

var $o9tAB = parcelRequire("o9tAB");
function $0d2aa2ae6ad46164$var$toPropertyKey(t) {
    var i = $o9tAB(t, "string");
    return "symbol" == $0d2aa2ae6ad46164$var$_typeof(i) ? i : i + "";
}
module.exports = $0d2aa2ae6ad46164$var$toPropertyKey, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("b8aZW", function(module, exports) {
function $81a8f90d907bfd73$var$_typeof(o) {
    "@babel/helpers - typeof";
    return module.exports = $81a8f90d907bfd73$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $81a8f90d907bfd73$var$_typeof(o);
}
module.exports = $81a8f90d907bfd73$var$_typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("o9tAB", function(module, exports) {

var $b8aZW = parcelRequire("b8aZW");
var $048997ca8c18174b$var$_typeof = $b8aZW.default;
function $048997ca8c18174b$var$toPrimitive(t, r) {
    if ("object" != $048997ca8c18174b$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $048997ca8c18174b$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
module.exports = $048997ca8c18174b$var$toPrimitive, module.exports.__esModule = true, module.exports["default"] = module.exports;

});



parcelRegister("ajMcn", function(module, exports) {

$parcel$export(module.exports, "CURRENT_SURFACE_CSS_VAR", function () { return $783110f4a809758e$export$9d7b58831ae93caa; });
var $783110f4a809758e$export$4ef52930e33717cd = "data-theme";
var $783110f4a809758e$export$a00eac3f8684bcd0 = "data-color-mode";
var $783110f4a809758e$export$2112803007239c61 = "data-contrast-mode";
var $783110f4a809758e$export$352e418ed5b6193a = "data-custom-theme";
var $783110f4a809758e$export$2faeed762aac6741 = "light";
var $783110f4a809758e$export$6f0c6fb8c80fcc92 = "ds";
var $783110f4a809758e$export$4d0c7bbf80185957 = [
    "opacity",
    "font",
    "space",
    "border"
];
var $783110f4a809758e$export$dddac1532e822863 = "--".concat($783110f4a809758e$export$6f0c6fb8c80fcc92, "-token-not-found");
var $783110f4a809758e$export$9d7b58831ae93caa = "--".concat($783110f4a809758e$export$6f0c6fb8c80fcc92, "-elevation-surface-current");

});


parcelRegister("ca8LS", function(module, exports) {

$parcel$export(module.exports, "parseXcss", function () { return $8dad38fcdf7ac54a$export$a9c84988c8f81f2d; });
$parcel$export(module.exports, "xcss", function () { return $8dad38fcdf7ac54a$export$f6c783d06584602c; });

var $1hEVr = parcelRequire("1hEVr");

var $6hPyu = parcelRequire("6hPyu");

var $b8aZW = parcelRequire("b8aZW");

var $jVTBW = parcelRequire("jVTBW");

var $lIEia = parcelRequire("lIEia");

var $ahJoN = parcelRequire("ahJoN");
var $8dad38fcdf7ac54a$var$tokensMap = {
    backgroundColor: (0, $lIEia.backgroundColorMap),
    blockSize: (0, $lIEia.dimensionMap),
    borderBlockColor: (0, $lIEia.borderColorMap),
    borderBlockEndColor: (0, $lIEia.borderColorMap),
    borderBlockEndWidth: (0, $lIEia.borderWidthMap),
    borderBlockStartColor: (0, $lIEia.borderColorMap),
    borderBlockStartWidth: (0, $lIEia.borderWidthMap),
    borderBlockWidth: (0, $lIEia.borderWidthMap),
    borderBottomColor: (0, $lIEia.borderColorMap),
    borderBottomLeftRadius: (0, $lIEia.borderRadiusMap),
    borderBottomRightRadius: (0, $lIEia.borderRadiusMap),
    borderBottomWidth: (0, $lIEia.borderWidthMap),
    borderColor: (0, $lIEia.borderColorMap),
    borderEndEndRadius: (0, $lIEia.borderRadiusMap),
    borderEndStartRadius: (0, $lIEia.borderRadiusMap),
    borderInlineColor: (0, $lIEia.borderColorMap),
    borderInlineEndColor: (0, $lIEia.borderColorMap),
    borderInlineEndWidth: (0, $lIEia.borderWidthMap),
    borderInlineStartColor: (0, $lIEia.borderColorMap),
    borderInlineStartWidth: (0, $lIEia.borderWidthMap),
    borderInlineWidth: (0, $lIEia.borderWidthMap),
    borderLeftColor: (0, $lIEia.borderColorMap),
    borderLeftWidth: (0, $lIEia.borderWidthMap),
    borderRadius: (0, $lIEia.borderRadiusMap),
    borderRightColor: (0, $lIEia.borderColorMap),
    borderRightWidth: (0, $lIEia.borderWidthMap),
    borderStartEndRadius: (0, $lIEia.borderRadiusMap),
    borderStartStartRadius: (0, $lIEia.borderRadiusMap),
    borderTopColor: (0, $lIEia.borderColorMap),
    borderTopLeftRadius: (0, $lIEia.borderRadiusMap),
    borderTopRightRadius: (0, $lIEia.borderRadiusMap),
    borderTopWidth: (0, $lIEia.borderWidthMap),
    borderWidth: (0, $lIEia.borderWidthMap),
    bottom: (0, $lIEia.allSpaceMap),
    boxShadow: (0, $lIEia.shadowMap),
    color: (0, $lIEia.textColorMap),
    columnGap: (0, $lIEia.positiveSpaceMap),
    gap: (0, $lIEia.positiveSpaceMap),
    height: (0, $lIEia.dimensionMap),
    inlineSize: (0, $lIEia.dimensionMap),
    inset: (0, $lIEia.allSpaceMap),
    insetBlock: (0, $lIEia.allSpaceMap),
    insetBlockEnd: (0, $lIEia.allSpaceMap),
    insetBlockStart: (0, $lIEia.allSpaceMap),
    insetInline: (0, $lIEia.allSpaceMap),
    insetInlineEnd: (0, $lIEia.allSpaceMap),
    insetInlineStart: (0, $lIEia.allSpaceMap),
    left: (0, $lIEia.allSpaceMap),
    margin: (0, $lIEia.allSpaceMap),
    marginBlock: (0, $lIEia.allSpaceMap),
    marginBlockEnd: (0, $lIEia.allSpaceMap),
    marginBlockStart: (0, $lIEia.allSpaceMap),
    marginBottom: (0, $lIEia.allSpaceMap),
    marginInline: (0, $lIEia.allSpaceMap),
    marginInlineEnd: (0, $lIEia.allSpaceMap),
    marginInlineStart: (0, $lIEia.allSpaceMap),
    marginLeft: (0, $lIEia.allSpaceMap),
    marginRight: (0, $lIEia.allSpaceMap),
    marginTop: (0, $lIEia.allSpaceMap),
    maxBlockSize: (0, $lIEia.dimensionMap),
    maxHeight: (0, $lIEia.dimensionMap),
    maxInlineSize: (0, $lIEia.dimensionMap),
    maxWidth: (0, $lIEia.dimensionMap),
    minBlockSize: (0, $lIEia.dimensionMap),
    minHeight: (0, $lIEia.dimensionMap),
    minInlineSize: (0, $lIEia.dimensionMap),
    minWidth: (0, $lIEia.dimensionMap),
    opacity: (0, $lIEia.opacityMap),
    outlineColor: (0, $lIEia.borderColorMap),
    outlineOffset: (0, $lIEia.positiveSpaceMap),
    outlineWidth: (0, $lIEia.borderWidthMap),
    padding: (0, $lIEia.positiveSpaceMap),
    paddingBlock: (0, $lIEia.positiveSpaceMap),
    paddingBlockEnd: (0, $lIEia.positiveSpaceMap),
    paddingBlockStart: (0, $lIEia.positiveSpaceMap),
    paddingBottom: (0, $lIEia.positiveSpaceMap),
    paddingInline: (0, $lIEia.positiveSpaceMap),
    paddingInlineEnd: (0, $lIEia.positiveSpaceMap),
    paddingInlineStart: (0, $lIEia.positiveSpaceMap),
    paddingLeft: (0, $lIEia.positiveSpaceMap),
    paddingRight: (0, $lIEia.positiveSpaceMap),
    paddingTop: (0, $lIEia.positiveSpaceMap),
    right: (0, $lIEia.allSpaceMap),
    rowGap: (0, $lIEia.positiveSpaceMap),
    top: (0, $lIEia.allSpaceMap),
    width: (0, $lIEia.dimensionMap),
    zIndex: (0, $lIEia.layerMap)
};
var $8dad38fcdf7ac54a$var$uniqueSymbol = Symbol("UNSAFE_INTERNAL_styles");
var $8dad38fcdf7ac54a$var$isSafeEnvToThrow = function isSafeEnvToThrow() {
    return (typeof $ahJoN === "undefined" ? "undefined" : (0, (/*@__PURE__*/$parcel$interopDefault($b8aZW)))($ahJoN)) === "object" && (0, (/*@__PURE__*/$parcel$interopDefault($b8aZW)))($ahJoN.env) === "object" && false;
};
var $8dad38fcdf7ac54a$var$reNestedSelectors = /(\.|\s|&+|\*\>|#|\[.*\])/;
var $8dad38fcdf7ac54a$var$safeSelectors = /^@media .*$|^::?.*$|^@supports .*$/;
var $8dad38fcdf7ac54a$var$transformStyles = function transformStyles(styleObj) {
    if (!styleObj || (0, (/*@__PURE__*/$parcel$interopDefault($b8aZW)))(styleObj) !== "object") return styleObj;
    // If styles are defined as a CSSObject[], recursively call on each element until we reach CSSObject
    if (Array.isArray(styleObj)) return styleObj.map(transformStyles);
    // Modifies styleObj in place. Be careful.
    Object.entries(styleObj).forEach(function(_ref) {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($6hPyu)))(_ref, 2), key = _ref2[0], value = _ref2[1];
        // If key is a pseudo class or a pseudo element, then value should be an object.
        // So, call transformStyles on the value
        if ((0, (/*@__PURE__*/$parcel$interopDefault($b8aZW)))(value) === "object" && $8dad38fcdf7ac54a$var$safeSelectors.test(key)) {
            styleObj[key] = transformStyles(value);
            return;
        }
        if ($8dad38fcdf7ac54a$var$isSafeEnvToThrow()) {
            // We don't support `.class`, `[data-testid]`, `> *`, `#some-id`
            if ($8dad38fcdf7ac54a$var$reNestedSelectors.test(key)) throw new Error("Styles not supported for key '".concat(key, "'."));
        }
        // We have now dealt with all the special cases, so,
        // check whether what remains is a style property
        // that can be transformed.
        if (!(key in $8dad38fcdf7ac54a$var$tokensMap)) return;
        var tokenValue = $8dad38fcdf7ac54a$var$tokensMap[key][value];
        styleObj[key] = tokenValue !== null && tokenValue !== void 0 ? tokenValue : value;
    });
    return styleObj;
};
var $8dad38fcdf7ac54a$var$baseXcss = function baseXcss(style) {
    var transformedStyles = $8dad38fcdf7ac54a$var$transformStyles(style);
    return (0, (/*@__PURE__*/$parcel$interopDefault($1hEVr)))({}, $8dad38fcdf7ac54a$var$uniqueSymbol, (0, $jVTBW.css)(transformedStyles));
};
var $8dad38fcdf7ac54a$export$a9c84988c8f81f2d = function parseXcss(args) {
    if (Array.isArray(args)) return args.map(function(x) {
        return x && parseXcss(x);
    }).filter(Boolean);
    var styles = args[$8dad38fcdf7ac54a$var$uniqueSymbol];
    typeof $ahJoN === "undefined" || (0, (/*@__PURE__*/$parcel$interopDefault($b8aZW)))($ahJoN);
    return styles;
};
function $8dad38fcdf7ac54a$export$f6c783d06584602c(style) {
    return $8dad38fcdf7ac54a$var$baseXcss(style);
}

});
parcelRegister("6hPyu", function(module, exports) {

var $3ntz7 = parcelRequire("3ntz7");

var $51yG3 = parcelRequire("51yG3");

var $ddMa8 = parcelRequire("ddMa8");

var $22FM4 = parcelRequire("22FM4");
function $493c526f57aa9295$var$_slicedToArray(r, e) {
    return $3ntz7(r) || $51yG3(r, e) || $ddMa8(r, e) || $22FM4();
}
module.exports = $493c526f57aa9295$var$_slicedToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("3ntz7", function(module, exports) {
function $275a742e9f9105f3$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
module.exports = $275a742e9f9105f3$var$_arrayWithHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("51yG3", function(module, exports) {
function $3a87f1f0d8464e64$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
module.exports = $3a87f1f0d8464e64$var$_iterableToArrayLimit, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("ddMa8", function(module, exports) {

var $2qJRz = parcelRequire("2qJRz");
function $9a01d9533fd8a8c9$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $2qJRz(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $2qJRz(r, a) : void 0;
    }
}
module.exports = $9a01d9533fd8a8c9$var$_unsupportedIterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("2qJRz", function(module, exports) {
function $1c5195ee042b19e0$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
module.exports = $1c5195ee042b19e0$var$_arrayLikeToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("22FM4", function(module, exports) {
function $17cc2c363e50bdef$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
module.exports = $17cc2c363e50bdef$var$_nonIterableRest, module.exports.__esModule = true, module.exports["default"] = module.exports;

});



parcelRegister("YuKRy", function(module, exports) {

$parcel$export(module.exports, "SurfaceContext", function () { return $0b5d75fbe1eead26$export$1ca2a26fecb070ae; });
$parcel$export(module.exports, "useSurface", function () { return $0b5d75fbe1eead26$export$1aeb4f6b93c4540d; });

var $dAx5m = parcelRequire("dAx5m");
var $0b5d75fbe1eead26$export$1ca2a26fecb070ae = /*#__PURE__*/ (0, $dAx5m.createContext)("elevation.surface");
var $0b5d75fbe1eead26$export$1aeb4f6b93c4540d = function useSurface() {
    return (0, $dAx5m.useContext)($0b5d75fbe1eead26$export$1ca2a26fecb070ae);
};
$0b5d75fbe1eead26$export$1ca2a26fecb070ae.displayName = "SurfaceProvider";

});


parcelRegister("4R5hd", function(module, exports) {

var $6fd5r = parcelRequire("6fd5r");

var $hMB37 = parcelRequire("hMB37");

var $i0TNS = parcelRequire("i0TNS");

var $7q0VY = parcelRequire("7q0VY");
function $3890347ff2859b9b$var$_slicedToArray(r, e) {
    return $6fd5r(r) || $hMB37(r, e) || $i0TNS(r, e) || $7q0VY();
}
module.exports = $3890347ff2859b9b$var$_slicedToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("6fd5r", function(module, exports) {
function $48be4b923df3a65f$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
module.exports = $48be4b923df3a65f$var$_arrayWithHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("hMB37", function(module, exports) {
function $cf23a8903a0ac37d$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
module.exports = $cf23a8903a0ac37d$var$_iterableToArrayLimit, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("i0TNS", function(module, exports) {

var $jGGMe = parcelRequire("jGGMe");
function $d1d3837c7fdb5aa0$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $jGGMe(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $jGGMe(r, a) : void 0;
    }
}
module.exports = $d1d3837c7fdb5aa0$var$_unsupportedIterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("jGGMe", function(module, exports) {
function $e5531f2fb88c26f8$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
module.exports = $e5531f2fb88c26f8$var$_arrayLikeToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("7q0VY", function(module, exports) {
function $566baf9ed841326f$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
module.exports = $566baf9ed841326f$var$_nonIterableRest, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("hhJNI", function(module, exports) {
function $c9578d4bde4fa807$var$asyncGeneratorStep(n, t, e, r, o, a, c) {
    try {
        var i = n[a](c), u = i.value;
    } catch (n) {
        return void e(n);
    }
    i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function $c9578d4bde4fa807$var$_asyncToGenerator(n) {
    return function() {
        var t = this, e = arguments;
        return new Promise(function(r, o) {
            var a = n.apply(t, e);
            function _next(n) {
                $c9578d4bde4fa807$var$asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
            }
            function _throw(n) {
                $c9578d4bde4fa807$var$asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
            }
            _next(void 0);
        });
    };
}
module.exports = $c9578d4bde4fa807$var$_asyncToGenerator, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("14yZW", function(module, exports) {
function $0c81500e0dda3687$var$_classCallCheck(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
module.exports = $0c81500e0dda3687$var$_classCallCheck, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("7wq2F", function(module, exports) {

var $9N2p6 = parcelRequire("9N2p6");
function $579fb8f6ea8b0886$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, $9N2p6(o.key), o);
    }
}
function $579fb8f6ea8b0886$var$_createClass(e, r, t) {
    return r && $579fb8f6ea8b0886$var$_defineProperties(e.prototype, r), t && $579fb8f6ea8b0886$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}
module.exports = $579fb8f6ea8b0886$var$_createClass, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("9N2p6", function(module, exports) {

var $6u39b = parcelRequire("6u39b");
var $720a8e061e78aa92$var$_typeof = $6u39b.default;

var $23fQa = parcelRequire("23fQa");
function $720a8e061e78aa92$var$toPropertyKey(t) {
    var i = $23fQa(t, "string");
    return "symbol" == $720a8e061e78aa92$var$_typeof(i) ? i : i + "";
}
module.exports = $720a8e061e78aa92$var$toPropertyKey, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("6u39b", function(module, exports) {
function $4b87fc5ddfc0e53d$var$_typeof(o) {
    "@babel/helpers - typeof";
    return module.exports = $4b87fc5ddfc0e53d$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $4b87fc5ddfc0e53d$var$_typeof(o);
}
module.exports = $4b87fc5ddfc0e53d$var$_typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("23fQa", function(module, exports) {

var $6u39b = parcelRequire("6u39b");
var $17e826248cc94f2d$var$_typeof = $6u39b.default;
function $17e826248cc94f2d$var$toPrimitive(t, r) {
    if ("object" != $17e826248cc94f2d$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $17e826248cc94f2d$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
module.exports = $17e826248cc94f2d$var$toPrimitive, module.exports.__esModule = true, module.exports["default"] = module.exports;

});



parcelRegister("bxoWL", function(module, exports) {
function $866620ad57aea2b5$var$_assertThisInitialized(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}
module.exports = $866620ad57aea2b5$var$_assertThisInitialized, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("jHNYu", function(module, exports) {

var $iFGYS = parcelRequire("iFGYS");
function $e588cc64631b40bc$var$_inherits(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && $iFGYS(t, e);
}
module.exports = $e588cc64631b40bc$var$_inherits, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("iFGYS", function(module, exports) {
function $d97d656ed63c0c1f$var$_setPrototypeOf(t, e) {
    return module.exports = $d97d656ed63c0c1f$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $d97d656ed63c0c1f$var$_setPrototypeOf(t, e);
}
module.exports = $d97d656ed63c0c1f$var$_setPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("eNVL5", function(module, exports) {

var $6u39b = parcelRequire("6u39b");
var $ac7271ebd2695fc4$var$_typeof = $6u39b.default;

var $bxoWL = parcelRequire("bxoWL");
function $ac7271ebd2695fc4$var$_possibleConstructorReturn(t, e) {
    if (e && ("object" == $ac7271ebd2695fc4$var$_typeof(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return $bxoWL(t);
}
module.exports = $ac7271ebd2695fc4$var$_possibleConstructorReturn, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("8mDaf", function(module, exports) {
function $616ec2038c5f1444$var$_getPrototypeOf(t) {
    return module.exports = $616ec2038c5f1444$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $616ec2038c5f1444$var$_getPrototypeOf(t);
}
module.exports = $616ec2038c5f1444$var$_getPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("56sX4", function(module, exports) {

var $9N2p6 = parcelRequire("9N2p6");
function $3b73f8812dca7b36$var$_defineProperty(e, r, t) {
    return (r = $9N2p6(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
module.exports = $3b73f8812dca7b36$var$_defineProperty, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("jNWd4", function(module, exports) {
// TODO(Babel 8): Remove this file.

var $e6afbf333d7c21d3$var$runtime = (parcelRequire("21MC7"))();
module.exports = $e6afbf333d7c21d3$var$runtime;
// Copied from https://github.com/facebook/regenerator/blob/main/packages/runtime/runtime.js#L736=
try {
    regeneratorRuntime = $e6afbf333d7c21d3$var$runtime;
} catch (accidentalStrictMode) {
    if (typeof globalThis === "object") globalThis.regeneratorRuntime = $e6afbf333d7c21d3$var$runtime;
    else Function("r", "regeneratorRuntime = r")($e6afbf333d7c21d3$var$runtime);
}

});
parcelRegister("21MC7", function(module, exports) {

var $6u39b = parcelRequire("6u39b");
var $17a162783951c2aa$var$_typeof = $6u39b.default;
function $17a162783951c2aa$var$_regeneratorRuntime() {
    "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ 
    module.exports = $17a162783951c2aa$var$_regeneratorRuntime = function _regeneratorRuntime() {
        return e;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports;
    var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function(t, e, r) {
        t[e] = r.value;
    }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag";
    function define(t, e, r) {
        return Object.defineProperty(t, e, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }), t[e];
    }
    try {
        define({}, "");
    } catch (t) {
        define = function define(t, e, r) {
            return t[e] = r;
        };
    }
    function wrap(t, e, r, n) {
        var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []);
        return o(a, "_invoke", {
            value: makeInvokeMethod(t, r, c)
        }), a;
    }
    function tryCatch(t, e, r) {
        try {
            return {
                type: "normal",
                arg: t.call(e, r)
            };
        } catch (t) {
            return {
                type: "throw",
                arg: t
            };
        }
    }
    e.wrap = wrap;
    var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {};
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    var p = {};
    define(p, a, function() {
        return this;
    });
    var d = Object.getPrototypeOf, v = d && d(d(values([])));
    v && v !== r && n.call(v, a) && (p = v);
    var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
    function defineIteratorMethods(t) {
        [
            "next",
            "throw",
            "return"
        ].forEach(function(e) {
            define(t, e, function(t) {
                return this._invoke(e, t);
            });
        });
    }
    function AsyncIterator(t, e) {
        function invoke(r, o, i, a) {
            var c = tryCatch(t[r], t, o);
            if ("throw" !== c.type) {
                var u = c.arg, h = u.value;
                return h && "object" == $17a162783951c2aa$var$_typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function(t) {
                    invoke("next", t, i, a);
                }, function(t) {
                    invoke("throw", t, i, a);
                }) : e.resolve(h).then(function(t) {
                    u.value = t, i(u);
                }, function(t) {
                    return invoke("throw", t, i, a);
                });
            }
            a(c.arg);
        }
        var r;
        o(this, "_invoke", {
            value: function value(t, n) {
                function callInvokeWithMethodAndArg() {
                    return new e(function(e, r) {
                        invoke(t, n, e, r);
                    });
                }
                return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
            }
        });
    }
    function makeInvokeMethod(e, r, n) {
        var o = h;
        return function(i, a) {
            if (o === f) throw Error("Generator is already running");
            if (o === s) {
                if ("throw" === i) throw a;
                return {
                    value: t,
                    done: !0
                };
            }
            for(n.method = i, n.arg = a;;){
                var c = n.delegate;
                if (c) {
                    var u = maybeInvokeDelegate(c, n);
                    if (u) {
                        if (u === y) continue;
                        return u;
                    }
                }
                if ("next" === n.method) n.sent = n._sent = n.arg;
                else if ("throw" === n.method) {
                    if (o === h) throw o = s, n.arg;
                    n.dispatchException(n.arg);
                } else "return" === n.method && n.abrupt("return", n.arg);
                o = f;
                var p = tryCatch(e, r, n);
                if ("normal" === p.type) {
                    if (o = n.done ? s : l, p.arg === y) continue;
                    return {
                        value: p.arg,
                        done: n.done
                    };
                }
                "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
            }
        };
    }
    function maybeInvokeDelegate(e, r) {
        var n = r.method, o = e.iterator[n];
        if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
        var i = tryCatch(o, e.iterator, r.arg);
        if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
        var a = i.arg;
        return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
    }
    function pushTryEntry(t) {
        var e = {
            tryLoc: t[0]
        };
        1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
    }
    function resetTryEntry(t) {
        var e = t.completion || {};
        e.type = "normal", delete e.arg, t.completion = e;
    }
    function Context(t) {
        this.tryEntries = [
            {
                tryLoc: "root"
            }
        ], t.forEach(pushTryEntry, this), this.reset(!0);
    }
    function values(e) {
        if (e || "" === e) {
            var r = e[a];
            if (r) return r.call(e);
            if ("function" == typeof e.next) return e;
            if (!isNaN(e.length)) {
                var o = -1, i = function next() {
                    for(; ++o < e.length;)if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
                    return next.value = t, next.done = !0, next;
                };
                return i.next = i;
            }
        }
        throw new TypeError($17a162783951c2aa$var$_typeof(e) + " is not iterable");
    }
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
        value: GeneratorFunctionPrototype,
        configurable: !0
    }), o(GeneratorFunctionPrototype, "constructor", {
        value: GeneratorFunction,
        configurable: !0
    }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function(t) {
        var e = "function" == typeof t && t.constructor;
        return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
    }, e.mark = function(t) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
    }, e.awrap = function(t) {
        return {
            __await: t
        };
    }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function() {
        return this;
    }), e.AsyncIterator = AsyncIterator, e.async = function(t, r, n, o, i) {
        void 0 === i && (i = Promise);
        var a = new AsyncIterator(wrap(t, r, n, o), i);
        return e.isGeneratorFunction(r) ? a : a.next().then(function(t) {
            return t.done ? t.value : a.next();
        });
    }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function() {
        return this;
    }), define(g, "toString", function() {
        return "[object Generator]";
    }), e.keys = function(t) {
        var e = Object(t), r = [];
        for(var n in e)r.push(n);
        return r.reverse(), function next() {
            for(; r.length;){
                var t = r.pop();
                if (t in e) return next.value = t, next.done = !1, next;
            }
            return next.done = !0, next;
        };
    }, e.values = values, Context.prototype = {
        constructor: Context,
        reset: function reset(e) {
            if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for(var r in this)"t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
        },
        stop: function stop() {
            this.done = !0;
            var t = this.tryEntries[0].completion;
            if ("throw" === t.type) throw t.arg;
            return this.rval;
        },
        dispatchException: function dispatchException(e) {
            if (this.done) throw e;
            var r = this;
            function handle(n, o) {
                return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
            }
            for(var o = this.tryEntries.length - 1; o >= 0; --o){
                var i = this.tryEntries[o], a = i.completion;
                if ("root" === i.tryLoc) return handle("end");
                if (i.tryLoc <= this.prev) {
                    var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc");
                    if (c && u) {
                        if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                        if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
                    } else if (c) {
                        if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                    } else {
                        if (!u) throw Error("try statement without catch or finally");
                        if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
                    }
                }
            }
        },
        abrupt: function abrupt(t, e) {
            for(var r = this.tryEntries.length - 1; r >= 0; --r){
                var o = this.tryEntries[r];
                if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
                    var i = o;
                    break;
                }
            }
            i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
            var a = i ? i.completion : {};
            return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
        },
        complete: function complete(t, e) {
            if ("throw" === t.type) throw t.arg;
            return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
        },
        finish: function finish(t) {
            for(var e = this.tryEntries.length - 1; e >= 0; --e){
                var r = this.tryEntries[e];
                if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
            }
        },
        "catch": function _catch(t) {
            for(var e = this.tryEntries.length - 1; e >= 0; --e){
                var r = this.tryEntries[e];
                if (r.tryLoc === t) {
                    var n = r.completion;
                    if ("throw" === n.type) {
                        var o = n.arg;
                        resetTryEntry(r);
                    }
                    return o;
                }
            }
            throw Error("illegal catch attempt");
        },
        delegateYield: function delegateYield(e, r, n) {
            return this.delegate = {
                iterator: values(e),
                resultName: r,
                nextLoc: n
            }, "next" === this.method && (this.arg = t), y;
        }
    }, e;
}
module.exports = $17a162783951c2aa$var$_regeneratorRuntime, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("c8xEF", function(module, exports) {

var $6aCUT = parcelRequire("6aCUT");
module.exports = $6aCUT("7qjXj").then(()=>parcelRequire("dseDT"));

});

parcelRegister("4AXoV", function(module, exports) {

var $6aCUT = parcelRequire("6aCUT");
module.exports = Promise.all([
    $6aCUT("f4Y8I"),
    $6aCUT("6ONGF"),
    $6aCUT("7dcgU")
]).then(()=>parcelRequire("drteE"));

});

parcelRegister("fVPP0", function(module, exports) {

var $6aCUT = parcelRequire("6aCUT");
module.exports = $6aCUT("5B99T").then(()=>parcelRequire("2aL3D"));

});

parcelRegister("3kwhV", function(module, exports) {

var $6aCUT = parcelRequire("6aCUT");
module.exports = Promise.all([
    $6aCUT("f4Y8I"),
    $6aCUT("6ONGF"),
    $6aCUT("2iVxb")
]).then(()=>parcelRequire("kf8Fl"));

});

parcelRegister("lhTtx", function(module, exports) {

var $6aCUT = parcelRequire("6aCUT");
module.exports = Promise.all([
    $6aCUT("f4Y8I"),
    $6aCUT("6ONGF"),
    $6aCUT("7Zq0Q")
]).then(()=>parcelRequire("ipirK"));

});

parcelRegister("awtnL", function(module, exports) {

$parcel$export(module.exports, "useProfileDetailsMutabilityConstraints", function () { return $7f18fc9f2b617498$export$81812e9a6c91079c; });

var $4MHck = parcelRequire("4MHck");

var $iDL5l = parcelRequire("iDL5l");

var $1Bj4T = parcelRequire("1Bj4T");
const $7f18fc9f2b617498$var$ProfileDetailsMutabilityConstraint = "ProfileDetailsMutabilityConstraint";
const $7f18fc9f2b617498$var$MUTABILITY_DETAILS_MAP = {
    fullName: "name",
    nickname: "nickname",
    timezone: "zoneinfo",
    locale: "locale",
    email: "email",
    apiTokenCreate: "apiToken.create",
    // extended profile
    title: "extended_profile.job_title",
    phoneNumber: "extended_profile.phone_number",
    companyName: "extended_profile.organization",
    department: "extended_profile.department",
    location: "extended_profile.location"
};
const $7f18fc9f2b617498$var$CUSTOM_FIELD_PLACE = {
    email: "email.set",
    picture: "avatar",
    apiTokenCreate: "apiToken.create"
};
const $7f18fc9f2b617498$var$getFieldConfig = (data, field)=>{
    const fieldPath = $7f18fc9f2b617498$var$CUSTOM_FIELD_PLACE[field];
    if (fieldPath) return data[fieldPath];
    const mappedFieldKey = $7f18fc9f2b617498$var$MUTABILITY_DETAILS_MAP[field];
    return data["profile.write"][mappedFieldKey];
};
const $7f18fc9f2b617498$var$getMutabilityConstraintFor = (data, field)=>{
    const fieldConfig = $7f18fc9f2b617498$var$getFieldConfig(data, field) || {};
    const { extra: extra } = fieldConfig;
    if (fieldConfig.allowed && !extra) return null;
    const reason = fieldConfig.reason;
    return {
        field: field,
        reason: reason && reason.key || null,
        extra: extra ?? null
    };
};
const $7f18fc9f2b617498$export$d7725d3d27b80a68 = (data)=>Object.keys($7f18fc9f2b617498$var$MUTABILITY_DETAILS_MAP).map((field)=>$7f18fc9f2b617498$var$getMutabilityConstraintFor(data, field)).filter((constraint)=>constraint !== null);
const $7f18fc9f2b617498$var$userManageQueryFn = async ({ userId: userId })=>{
    const { stargateRoot: stargateRoot } = (0, $1Bj4T.getConfig)();
    const url = `${stargateRoot}/users/${userId}/manage`;
    const response = await (0, $iDL5l.fetchApi)(url);
    const data = await response.json();
    return $7f18fc9f2b617498$export$d7725d3d27b80a68(data);
};
const $7f18fc9f2b617498$export$81812e9a6c91079c = (userId)=>{
    const { data: data, isLoading: isLoading, isError: isError } = (0, $4MHck.useQuery)({
        queryKey: [
            $7f18fc9f2b617498$var$ProfileDetailsMutabilityConstraint,
            userId
        ],
        queryFn: ()=>$7f18fc9f2b617498$var$userManageQueryFn({
                userId: userId
            })
    });
    return {
        data: data,
        isLoading: isLoading,
        isError: isError
    };
};

});

parcelRegister("jJ5hV", function(module, exports) {

var $6aCUT = parcelRequire("6aCUT");
module.exports = Promise.all([
    $6aCUT("gQCmS"),
    $6aCUT("935eB"),
    $6aCUT("2fcNx"),
    $6aCUT("4WYNg")
]).then(()=>parcelRequire("6HgVW"));

});

parcelRegister("7NOng", function(module, exports) {

var $6aCUT = parcelRequire("6aCUT");
module.exports = $6aCUT("hbQpg").then(()=>parcelRequire("a9GGp"));

});

parcelRegister("cYdtN", function(module, exports) {

var $6aCUT = parcelRequire("6aCUT");
module.exports = $6aCUT("8WmXq").then(()=>parcelRequire("bWHyo"));

});

parcelRegister("hBDFq", function(module, exports) {

var $6aCUT = parcelRequire("6aCUT");
module.exports = $6aCUT("aAoJ2").then(()=>parcelRequire("cZyID"));

});

parcelRegister("lNy2N", function(module, exports) {

var $6aCUT = parcelRequire("6aCUT");
module.exports = $6aCUT("5f0w9").then(()=>parcelRequire("cwbAG"));

});

parcelRegister("9rJaf", function(module, exports) {

var $6aCUT = parcelRequire("6aCUT");
module.exports = $6aCUT("8R4YG").then(()=>parcelRequire("6R2BG"));

});

parcelRegister("9YMcj", function(module, exports) {

var $6aCUT = parcelRequire("6aCUT");
module.exports = $6aCUT("eZZoo").then(()=>parcelRequire("8QgiS"));

});

parcelRegister("kcKcT", function(module, exports) {

var $6aCUT = parcelRequire("6aCUT");
module.exports = $6aCUT("6hNUP").then(()=>parcelRequire("f6lVl"));

});

parcelRegister("1ufeS", function(module, exports) {

var $6aCUT = parcelRequire("6aCUT");
module.exports = $6aCUT("lrf5O").then(()=>parcelRequire("lSBnI"));

});

parcelRegister("9hLrj", function(module, exports) {

var $6aCUT = parcelRequire("6aCUT");
module.exports = $6aCUT("duW7d").then(()=>parcelRequire("l45Yi"));

});

parcelRegister("Ot4RZ", function(module, exports) {

var $6aCUT = parcelRequire("6aCUT");
module.exports = $6aCUT("4pVog").then(()=>parcelRequire("2jhXm"));

});

parcelRegister("kpItI", function(module, exports) {

var $6aCUT = parcelRequire("6aCUT");
module.exports = $6aCUT("aQ86D").then(()=>parcelRequire("1bxQx"));

});

parcelRegister("aOmuX", function(module, exports) {

var $6aCUT = parcelRequire("6aCUT");
module.exports = $6aCUT("ebazV").then(()=>parcelRequire("iSxIy"));

});

parcelRegister("2rlJ6", function(module, exports) {

var $6aCUT = parcelRequire("6aCUT");
module.exports = $6aCUT("dyOT9").then(()=>parcelRequire("lLL8b"));

});

parcelRegister("ar9IB", function(module, exports) {

var $6aCUT = parcelRequire("6aCUT");
module.exports = $6aCUT("4KchB").then(()=>parcelRequire("vDZzh"));

});

parcelRegister("7FcXi", function(module, exports) {

var $6aCUT = parcelRequire("6aCUT");
module.exports = $6aCUT("krHF4").then(()=>parcelRequire("gPtSf"));

});

parcelRegister("lWDom", function(module, exports) {

var $6aCUT = parcelRequire("6aCUT");
module.exports = $6aCUT("8MZgc").then(()=>parcelRequire("jw2oP"));

});

parcelRegister("lgJbm", function(module, exports) {

var $6aCUT = parcelRequire("6aCUT");
module.exports = $6aCUT("4tfT2").then(()=>parcelRequire("edce7"));

});

parcelRegister("gLtaN", function(module, exports) {

var $6aCUT = parcelRequire("6aCUT");
module.exports = $6aCUT("dKrdv").then(()=>parcelRequire("iXZ3l"));

});

parcelRegister("5ZOAV", function(module, exports) {

var $6aCUT = parcelRequire("6aCUT");
module.exports = $6aCUT("cRbFl").then(()=>parcelRequire("4PZkA"));

});

parcelRegister("76gVk", function(module, exports) {

var $6aCUT = parcelRequire("6aCUT");
module.exports = $6aCUT("4p67i").then(()=>parcelRequire("lx18T"));

});

parcelRegister("80lCc", function(module, exports) {

var $6aCUT = parcelRequire("6aCUT");
module.exports = $6aCUT("49JrD").then(()=>parcelRequire("kMjCR"));

});

parcelRegister("2EQ59", function(module, exports) {

var $6aCUT = parcelRequire("6aCUT");
module.exports = $6aCUT("jYeQy").then(()=>parcelRequire("8IFNt"));

});

parcelRegister("dRz54", function(module, exports) {

var $6aCUT = parcelRequire("6aCUT");
module.exports = $6aCUT("1fTdJ").then(()=>parcelRequire("kuhPY"));

});

parcelRegister("7BvRj", function(module, exports) {

var $6aCUT = parcelRequire("6aCUT");
module.exports = $6aCUT("ecuXW").then(()=>parcelRequire("lWY2R"));

});

parcelRegister("lu27I", function(module, exports) {

var $6aCUT = parcelRequire("6aCUT");
module.exports = $6aCUT("4NhAf").then(()=>parcelRequire("eAj9J"));

});

parcelRegister("a9NoB", function(module, exports) {

var $6aCUT = parcelRequire("6aCUT");
module.exports = $6aCUT("60wI2").then(()=>parcelRequire("b99hm"));

});

parcelRegister("dO3xV", function(module, exports) {

var $6aCUT = parcelRequire("6aCUT");
module.exports = $6aCUT("dLcPq").then(()=>parcelRequire("gzQ2U"));

});

parcelRegister("1ueaC", function(module, exports) {

var $6aCUT = parcelRequire("6aCUT");
module.exports = $6aCUT("arHib").then(()=>parcelRequire("Olz28"));

});

parcelRegister("4tA0t", function(module, exports) {

var $6aCUT = parcelRequire("6aCUT");
module.exports = $6aCUT("jzaRp").then(()=>parcelRequire("2Hkm1"));

});

parcelRegister("gPvnh", function(module, exports) {

$parcel$export(module.exports, "retryOnException", function () { return $c409bf0e90c0f306$export$1d94629c94e7a17f; });

var $hnc5f = parcelRequire("hnc5f");

var $66KAd = parcelRequire("66KAd");

var $dtIOT = parcelRequire("dtIOT");

var $keLWF = parcelRequire("keLWF");

var $4LwyZ = parcelRequire("4LwyZ");

var $5I6on = parcelRequire("5I6on");
var $c409bf0e90c0f306$export$5c069c93d2b7493f = function wait(ms) {
    return new Promise(function(resolve) {
        setTimeout(resolve, ms);
    });
};
var $c409bf0e90c0f306$var$NO_CALLS_ERROR = "No calls made";
var $c409bf0e90c0f306$export$1d94629c94e7a17f = /*#__PURE__*/ function() {
    var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($66KAd)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dtIOT))).mark(function _callee(invokeOperation, _ref) {
        var _ref$intervalsMS, intervalsMS, _ref$retryOn, retryOn, captureException, onRetry, intervals, nextMSInterval, error;
        return (0, (/*@__PURE__*/$parcel$interopDefault($dtIOT))).wrap(function _callee$(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    _ref$intervalsMS = _ref.intervalsMS, intervalsMS = _ref$intervalsMS === void 0 ? (0, $4LwyZ.NO_RETRIES) : _ref$intervalsMS, _ref$retryOn = _ref.retryOn, retryOn = _ref$retryOn === void 0 ? [
                        (0, $5I6on.default)
                    ] : _ref$retryOn, captureException = _ref.captureException, onRetry = _ref.onRetry;
                    intervals = (0, (/*@__PURE__*/$parcel$interopDefault($hnc5f)))(intervalsMS);
                    nextMSInterval = 0;
                    error = new Error($c409bf0e90c0f306$var$NO_CALLS_ERROR);
                case 4:
                    if (!(nextMSInterval !== undefined)) {
                        _context.next = 22;
                        break;
                    }
                    _context.prev = 5;
                    if (!(nextMSInterval > 0)) {
                        _context.next = 9;
                        break;
                    }
                    _context.next = 9;
                    return $c409bf0e90c0f306$export$5c069c93d2b7493f(nextMSInterval);
                case 9:
                    if (onRetry && error.message !== $c409bf0e90c0f306$var$NO_CALLS_ERROR) onRetry(error);
                    _context.next = 12;
                    return invokeOperation();
                case 12:
                    return _context.abrupt("return", _context.sent);
                case 15:
                    _context.prev = 15;
                    _context.t0 = _context["catch"](5);
                    error = (0, $keLWF.default)(_context.t0);
                    if (captureException) captureException(error);
                    // Retry ONLY when the error is an instance of one of the provided `retryOn` errors, or passes the `retryOn` test.
                    // You need to ensure you are throwing one of the `retryOn` errors if that is the method you are using.
                    if (typeof retryOn === "function" ? retryOn(error) : retryOn.some(function(err) {
                        return error instanceof err;
                    })) nextMSInterval = intervals.shift();
                    else nextMSInterval = undefined;
                case 20:
                    _context.next = 4;
                    break;
                case 22:
                    throw error;
                case 23:
                case "end":
                    return _context.stop();
            }
        }, _callee, null, [
            [
                5,
                15
            ]
        ]);
    }));
    return function retryOnException(_x, _x2) {
        return _ref2.apply(this, arguments);
    };
}();

});
parcelRegister("hnc5f", function(module, exports) {

var $cU2wf = parcelRequire("cU2wf");

var $7Zqve = parcelRequire("7Zqve");

var $cP5fF = parcelRequire("cP5fF");

var $6KXnP = parcelRequire("6KXnP");
function $ca5df5387d2d4171$var$_toConsumableArray(r) {
    return $cU2wf(r) || $7Zqve(r) || $cP5fF(r) || $6KXnP();
}
module.exports = $ca5df5387d2d4171$var$_toConsumableArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("cU2wf", function(module, exports) {

var $lw60i = parcelRequire("lw60i");
function $964cab38905bdc79$var$_arrayWithoutHoles(r) {
    if (Array.isArray(r)) return $lw60i(r);
}
module.exports = $964cab38905bdc79$var$_arrayWithoutHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("lw60i", function(module, exports) {
function $faa13e58fb1ca194$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
module.exports = $faa13e58fb1ca194$var$_arrayLikeToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("7Zqve", function(module, exports) {
function $5d12c9cdaf2395d3$var$_iterableToArray(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
module.exports = $5d12c9cdaf2395d3$var$_iterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("cP5fF", function(module, exports) {

var $lw60i = parcelRequire("lw60i");
function $955e525a3082790b$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $lw60i(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $lw60i(r, a) : void 0;
    }
}
module.exports = $955e525a3082790b$var$_unsupportedIterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("6KXnP", function(module, exports) {
function $4eb51a3c71178998$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
module.exports = $4eb51a3c71178998$var$_nonIterableSpread, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("66KAd", function(module, exports) {
function $4727701004a8f3f8$var$asyncGeneratorStep(n, t, e, r, o, a, c) {
    try {
        var i = n[a](c), u = i.value;
    } catch (n) {
        return void e(n);
    }
    i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function $4727701004a8f3f8$var$_asyncToGenerator(n) {
    return function() {
        var t = this, e = arguments;
        return new Promise(function(r, o) {
            var a = n.apply(t, e);
            function _next(n) {
                $4727701004a8f3f8$var$asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
            }
            function _throw(n) {
                $4727701004a8f3f8$var$asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
            }
            _next(void 0);
        });
    };
}
module.exports = $4727701004a8f3f8$var$_asyncToGenerator, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("dtIOT", function(module, exports) {
// TODO(Babel 8): Remove this file.

var $9d00c013d870ea47$var$runtime = (parcelRequire("cjOWv"))();
module.exports = $9d00c013d870ea47$var$runtime;
// Copied from https://github.com/facebook/regenerator/blob/main/packages/runtime/runtime.js#L736=
try {
    regeneratorRuntime = $9d00c013d870ea47$var$runtime;
} catch (accidentalStrictMode) {
    if (typeof globalThis === "object") globalThis.regeneratorRuntime = $9d00c013d870ea47$var$runtime;
    else Function("r", "regeneratorRuntime = r")($9d00c013d870ea47$var$runtime);
}

});
parcelRegister("cjOWv", function(module, exports) {

var $fHh8c = parcelRequire("fHh8c");
var $8f7ec68cc1f3d801$var$_typeof = $fHh8c.default;
function $8f7ec68cc1f3d801$var$_regeneratorRuntime() {
    "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ 
    module.exports = $8f7ec68cc1f3d801$var$_regeneratorRuntime = function _regeneratorRuntime() {
        return e;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports;
    var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function(t, e, r) {
        t[e] = r.value;
    }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag";
    function define(t, e, r) {
        return Object.defineProperty(t, e, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }), t[e];
    }
    try {
        define({}, "");
    } catch (t) {
        define = function define(t, e, r) {
            return t[e] = r;
        };
    }
    function wrap(t, e, r, n) {
        var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []);
        return o(a, "_invoke", {
            value: makeInvokeMethod(t, r, c)
        }), a;
    }
    function tryCatch(t, e, r) {
        try {
            return {
                type: "normal",
                arg: t.call(e, r)
            };
        } catch (t) {
            return {
                type: "throw",
                arg: t
            };
        }
    }
    e.wrap = wrap;
    var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {};
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    var p = {};
    define(p, a, function() {
        return this;
    });
    var d = Object.getPrototypeOf, v = d && d(d(values([])));
    v && v !== r && n.call(v, a) && (p = v);
    var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
    function defineIteratorMethods(t) {
        [
            "next",
            "throw",
            "return"
        ].forEach(function(e) {
            define(t, e, function(t) {
                return this._invoke(e, t);
            });
        });
    }
    function AsyncIterator(t, e) {
        function invoke(r, o, i, a) {
            var c = tryCatch(t[r], t, o);
            if ("throw" !== c.type) {
                var u = c.arg, h = u.value;
                return h && "object" == $8f7ec68cc1f3d801$var$_typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function(t) {
                    invoke("next", t, i, a);
                }, function(t) {
                    invoke("throw", t, i, a);
                }) : e.resolve(h).then(function(t) {
                    u.value = t, i(u);
                }, function(t) {
                    return invoke("throw", t, i, a);
                });
            }
            a(c.arg);
        }
        var r;
        o(this, "_invoke", {
            value: function value(t, n) {
                function callInvokeWithMethodAndArg() {
                    return new e(function(e, r) {
                        invoke(t, n, e, r);
                    });
                }
                return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
            }
        });
    }
    function makeInvokeMethod(e, r, n) {
        var o = h;
        return function(i, a) {
            if (o === f) throw Error("Generator is already running");
            if (o === s) {
                if ("throw" === i) throw a;
                return {
                    value: t,
                    done: !0
                };
            }
            for(n.method = i, n.arg = a;;){
                var c = n.delegate;
                if (c) {
                    var u = maybeInvokeDelegate(c, n);
                    if (u) {
                        if (u === y) continue;
                        return u;
                    }
                }
                if ("next" === n.method) n.sent = n._sent = n.arg;
                else if ("throw" === n.method) {
                    if (o === h) throw o = s, n.arg;
                    n.dispatchException(n.arg);
                } else "return" === n.method && n.abrupt("return", n.arg);
                o = f;
                var p = tryCatch(e, r, n);
                if ("normal" === p.type) {
                    if (o = n.done ? s : l, p.arg === y) continue;
                    return {
                        value: p.arg,
                        done: n.done
                    };
                }
                "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
            }
        };
    }
    function maybeInvokeDelegate(e, r) {
        var n = r.method, o = e.iterator[n];
        if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
        var i = tryCatch(o, e.iterator, r.arg);
        if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
        var a = i.arg;
        return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
    }
    function pushTryEntry(t) {
        var e = {
            tryLoc: t[0]
        };
        1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
    }
    function resetTryEntry(t) {
        var e = t.completion || {};
        e.type = "normal", delete e.arg, t.completion = e;
    }
    function Context(t) {
        this.tryEntries = [
            {
                tryLoc: "root"
            }
        ], t.forEach(pushTryEntry, this), this.reset(!0);
    }
    function values(e) {
        if (e || "" === e) {
            var r = e[a];
            if (r) return r.call(e);
            if ("function" == typeof e.next) return e;
            if (!isNaN(e.length)) {
                var o = -1, i = function next() {
                    for(; ++o < e.length;)if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
                    return next.value = t, next.done = !0, next;
                };
                return i.next = i;
            }
        }
        throw new TypeError($8f7ec68cc1f3d801$var$_typeof(e) + " is not iterable");
    }
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
        value: GeneratorFunctionPrototype,
        configurable: !0
    }), o(GeneratorFunctionPrototype, "constructor", {
        value: GeneratorFunction,
        configurable: !0
    }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function(t) {
        var e = "function" == typeof t && t.constructor;
        return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
    }, e.mark = function(t) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
    }, e.awrap = function(t) {
        return {
            __await: t
        };
    }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function() {
        return this;
    }), e.AsyncIterator = AsyncIterator, e.async = function(t, r, n, o, i) {
        void 0 === i && (i = Promise);
        var a = new AsyncIterator(wrap(t, r, n, o), i);
        return e.isGeneratorFunction(r) ? a : a.next().then(function(t) {
            return t.done ? t.value : a.next();
        });
    }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function() {
        return this;
    }), define(g, "toString", function() {
        return "[object Generator]";
    }), e.keys = function(t) {
        var e = Object(t), r = [];
        for(var n in e)r.push(n);
        return r.reverse(), function next() {
            for(; r.length;){
                var t = r.pop();
                if (t in e) return next.value = t, next.done = !1, next;
            }
            return next.done = !0, next;
        };
    }, e.values = values, Context.prototype = {
        constructor: Context,
        reset: function reset(e) {
            if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for(var r in this)"t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
        },
        stop: function stop() {
            this.done = !0;
            var t = this.tryEntries[0].completion;
            if ("throw" === t.type) throw t.arg;
            return this.rval;
        },
        dispatchException: function dispatchException(e) {
            if (this.done) throw e;
            var r = this;
            function handle(n, o) {
                return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
            }
            for(var o = this.tryEntries.length - 1; o >= 0; --o){
                var i = this.tryEntries[o], a = i.completion;
                if ("root" === i.tryLoc) return handle("end");
                if (i.tryLoc <= this.prev) {
                    var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc");
                    if (c && u) {
                        if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                        if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
                    } else if (c) {
                        if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                    } else {
                        if (!u) throw Error("try statement without catch or finally");
                        if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
                    }
                }
            }
        },
        abrupt: function abrupt(t, e) {
            for(var r = this.tryEntries.length - 1; r >= 0; --r){
                var o = this.tryEntries[r];
                if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
                    var i = o;
                    break;
                }
            }
            i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
            var a = i ? i.completion : {};
            return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
        },
        complete: function complete(t, e) {
            if ("throw" === t.type) throw t.arg;
            return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
        },
        finish: function finish(t) {
            for(var e = this.tryEntries.length - 1; e >= 0; --e){
                var r = this.tryEntries[e];
                if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
            }
        },
        "catch": function _catch(t) {
            for(var e = this.tryEntries.length - 1; e >= 0; --e){
                var r = this.tryEntries[e];
                if (r.tryLoc === t) {
                    var n = r.completion;
                    if ("throw" === n.type) {
                        var o = n.arg;
                        resetTryEntry(r);
                    }
                    return o;
                }
            }
            throw Error("illegal catch attempt");
        },
        delegateYield: function delegateYield(e, r, n) {
            return this.delegate = {
                iterator: values(e),
                resultName: r,
                nextLoc: n
            }, "next" === this.method && (this.arg = t), y;
        }
    }, e;
}
module.exports = $8f7ec68cc1f3d801$var$_regeneratorRuntime, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("fHh8c", function(module, exports) {
function $b6d8291808c475c4$var$_typeof(o) {
    "@babel/helpers - typeof";
    return module.exports = $b6d8291808c475c4$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $b6d8291808c475c4$var$_typeof(o);
}
module.exports = $b6d8291808c475c4$var$_typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

});



parcelRegister("keLWF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ebba4e5ad32b5cd1$export$2e2bcd8739ae039; });

var $fHh8c = parcelRequire("fHh8c");
var $ebba4e5ad32b5cd1$var$convertToError = function convertToError(e) {
    var error;
    if (e instanceof Error) error = e;
    else if (typeof e === "string") error = new Error(e);
    else if ((0, (/*@__PURE__*/$parcel$interopDefault($fHh8c)))(e) === "object") try {
        error = new Error("Object error instance thrown for operation: " + JSON.stringify(e));
    } catch (jsonError) {
        error = new Error("Object serialisation error thrown during operation: " + String(e));
    }
    else error = new Error("No error instance thrown for operation: " + String(e));
    return error;
};
var $ebba4e5ad32b5cd1$export$2e2bcd8739ae039 = $ebba4e5ad32b5cd1$var$convertToError;

});

parcelRegister("4LwyZ", function(module, exports) {

$parcel$export(module.exports, "NO_RETRIES", function () { return $3784cf9d29705328$export$a0a1c8f90becc136; });
var $3784cf9d29705328$export$a0a1c8f90becc136 = [];
var $3784cf9d29705328$export$972171517b12aa4 = [
    0,
    0
];
var $3784cf9d29705328$export$746d2203ed8cdc40 = [
    0,
    50,
    100
];
var $3784cf9d29705328$export$f6858378b665f957 = [
    100,
    500,
    1000
];

});

parcelRegister("5I6on", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $42860526c82a1822$export$2e2bcd8739ae039; });

var $aT71j = parcelRequire("aT71j");

var $5TUtp = parcelRequire("5TUtp");

var $4Wgek = parcelRequire("4Wgek");

var $hKQYu = parcelRequire("hKQYu");

var $cGhpd = parcelRequire("cGhpd");

var $dmcVX = parcelRequire("dmcVX");
function $42860526c82a1822$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $42860526c82a1822$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, (/*@__PURE__*/$parcel$interopDefault($cGhpd)))(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, (/*@__PURE__*/$parcel$interopDefault($cGhpd)))(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, (/*@__PURE__*/$parcel$interopDefault($hKQYu)))(this, result);
    };
}
function $42860526c82a1822$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($42860526c82a1822$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $42860526c82a1822$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_Error) {
    (0, (/*@__PURE__*/$parcel$interopDefault($4Wgek)))(FailedFetchError, _Error);
    var _super = $42860526c82a1822$var$_createSuper(FailedFetchError);
    function FailedFetchError(_ref) {
        var _this;
        var error = _ref.error, path = _ref.path, method = _ref.method;
        (0, (/*@__PURE__*/$parcel$interopDefault($5TUtp)))(this, FailedFetchError);
        _this = _super.call(this);
        _this.name = "FailedFetchError";
        _this.message = error.message || "Unknown fetch error";
        _this.stack = error.stack;
        _this.originalName = error.name;
        _this.method = method;
        var p = path.split("?")[0];
        _this.path = /^[/-a-z]+$/i.test(p) ? p : "";
        return _this;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($aT71j)))(FailedFetchError);
}(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dmcVX)))(Error));

});
parcelRegister("aT71j", function(module, exports) {

var $1EFjm = parcelRequire("1EFjm");
function $7ed47c7d2f2fa288$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, $1EFjm(o.key), o);
    }
}
function $7ed47c7d2f2fa288$var$_createClass(e, r, t) {
    return r && $7ed47c7d2f2fa288$var$_defineProperties(e.prototype, r), t && $7ed47c7d2f2fa288$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}
module.exports = $7ed47c7d2f2fa288$var$_createClass, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("1EFjm", function(module, exports) {

var $fHh8c = parcelRequire("fHh8c");
var $1349926c0241a2ff$var$_typeof = $fHh8c.default;

var $8OdxI = parcelRequire("8OdxI");
function $1349926c0241a2ff$var$toPropertyKey(t) {
    var i = $8OdxI(t, "string");
    return "symbol" == $1349926c0241a2ff$var$_typeof(i) ? i : i + "";
}
module.exports = $1349926c0241a2ff$var$toPropertyKey, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("8OdxI", function(module, exports) {

var $fHh8c = parcelRequire("fHh8c");
var $669d7f95d0fde192$var$_typeof = $fHh8c.default;
function $669d7f95d0fde192$var$toPrimitive(t, r) {
    if ("object" != $669d7f95d0fde192$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $669d7f95d0fde192$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
module.exports = $669d7f95d0fde192$var$toPrimitive, module.exports.__esModule = true, module.exports["default"] = module.exports;

});



parcelRegister("5TUtp", function(module, exports) {
function $44bde5388576a6ef$var$_classCallCheck(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
module.exports = $44bde5388576a6ef$var$_classCallCheck, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("4Wgek", function(module, exports) {

var $eBDUF = parcelRequire("eBDUF");
function $39892b2c86d84207$var$_inherits(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && $eBDUF(t, e);
}
module.exports = $39892b2c86d84207$var$_inherits, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("eBDUF", function(module, exports) {
function $aa237b4d8ca11826$var$_setPrototypeOf(t, e) {
    return module.exports = $aa237b4d8ca11826$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $aa237b4d8ca11826$var$_setPrototypeOf(t, e);
}
module.exports = $aa237b4d8ca11826$var$_setPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("hKQYu", function(module, exports) {

var $fHh8c = parcelRequire("fHh8c");
var $cecfd338a902f635$var$_typeof = $fHh8c.default;

var $7Ecwg = parcelRequire("7Ecwg");
function $cecfd338a902f635$var$_possibleConstructorReturn(t, e) {
    if (e && ("object" == $cecfd338a902f635$var$_typeof(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return $7Ecwg(t);
}
module.exports = $cecfd338a902f635$var$_possibleConstructorReturn, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("7Ecwg", function(module, exports) {
function $5915fae9ccf5d7fc$var$_assertThisInitialized(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}
module.exports = $5915fae9ccf5d7fc$var$_assertThisInitialized, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("cGhpd", function(module, exports) {
function $93b6e8ae31493240$var$_getPrototypeOf(t) {
    return module.exports = $93b6e8ae31493240$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $93b6e8ae31493240$var$_getPrototypeOf(t);
}
module.exports = $93b6e8ae31493240$var$_getPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("dmcVX", function(module, exports) {

var $cGhpd = parcelRequire("cGhpd");

var $eBDUF = parcelRequire("eBDUF");

var $bnQwf = parcelRequire("bnQwf");

var $1NfNF = parcelRequire("1NfNF");
function $9b975cd0f8422be3$var$_wrapNativeSuper(t) {
    var r = "function" == typeof Map ? new Map() : void 0;
    return module.exports = $9b975cd0f8422be3$var$_wrapNativeSuper = function _wrapNativeSuper(t) {
        if (null === t || !$bnQwf(t)) return t;
        if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function");
        if (void 0 !== r) {
            if (r.has(t)) return r.get(t);
            r.set(t, Wrapper);
        }
        function Wrapper() {
            return $1NfNF(t, arguments, $cGhpd(this).constructor);
        }
        return Wrapper.prototype = Object.create(t.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: !1,
                writable: !0,
                configurable: !0
            }
        }), $eBDUF(Wrapper, t);
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $9b975cd0f8422be3$var$_wrapNativeSuper(t);
}
module.exports = $9b975cd0f8422be3$var$_wrapNativeSuper, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("bnQwf", function(module, exports) {
function $849a94e3a88fbf80$var$_isNativeFunction(t) {
    try {
        return -1 !== Function.toString.call(t).indexOf("[native code]");
    } catch (n) {
        return "function" == typeof t;
    }
}
module.exports = $849a94e3a88fbf80$var$_isNativeFunction, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("1NfNF", function(module, exports) {

var $itScg = parcelRequire("itScg");

var $eBDUF = parcelRequire("eBDUF");
function $14e69f9b1536b6e0$var$_construct(t, e, r) {
    if ($itScg()) return Reflect.construct.apply(null, arguments);
    var o = [
        null
    ];
    o.push.apply(o, e);
    var p = new (t.bind.apply(t, o))();
    return r && $eBDUF(p, r.prototype), p;
}
module.exports = $14e69f9b1536b6e0$var$_construct, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("itScg", function(module, exports) {
function $d744f9ca44c98c22$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return (module.exports = $d744f9ca44c98c22$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports)();
}
module.exports = $d744f9ca44c98c22$var$_isNativeReflectConstruct, module.exports.__esModule = true, module.exports["default"] = module.exports;

});





parcelRegister("av9lC", function(module, exports) {
"use strict";
var $7a540cdddae95b1d$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.FeatureGatesInitialization = void 0;

var $dAx5m = parcelRequire("dAx5m");

const $7a540cdddae95b1d$var$feature_gate_js_client_1 = $7a540cdddae95b1d$var$__importDefault((parcelRequire("hoOY2")));

var $k7Pk1 = parcelRequire("k7Pk1");
/**
 * This component initializes the @atlassian/feature-flag-js-client by fetching the gate and experiment
 * evaluations for the given user, and blocks rendering of the children until the rendering is complete.
 */ const $7a540cdddae95b1d$var$FeatureGatesInitialization = ({ children: children, enabled: enabled = true, identifiers: identifiers, customAttributes: customAttributes, options: options, initializingComponent: initializingComponent, overrides: overrides, onReady: onReady })=>{
    // Rather than checking the state of all overrides, we can just assume that if overrides are provided
    // then some sort of update will need to be performed, and hold off rendering until the useEffect is run.
    const [isInitialized, setInitialized] = (0, $dAx5m.useState)(!overrides && (0, $k7Pk1.isClientAlreadyInCorrectState)(identifiers, customAttributes));
    // Use a ref for the options, so that we can use them within the following useEffect
    // without adding options as a dependency.
    // This avoids the user updating every time an option is changed.
    const optionsRef = (0, $dAx5m.useRef)(options);
    (0, $dAx5m.useEffect)(()=>{
        optionsRef.current = options;
    }, [
        options
    ]);
    (0, $dAx5m.useEffect)(()=>{
        if (enabled) {
            if ((0, $k7Pk1.isClientAlreadyInCorrectState)(identifiers, customAttributes)) {
                (0, $k7Pk1.applyOverrides)(overrides);
                setInitialized(true);
                onReady === null || onReady === void 0 || onReady();
            } else {
                setInitialized(false);
                const initPromise = $7a540cdddae95b1d$var$feature_gate_js_client_1.default.initializeCalled() ? $7a540cdddae95b1d$var$feature_gate_js_client_1.default.updateUser(optionsRef.current, identifiers, customAttributes) : $7a540cdddae95b1d$var$feature_gate_js_client_1.default.initialize(optionsRef.current, identifiers, customAttributes);
                initPromise.then(()=>(0, $k7Pk1.applyOverrides)(overrides)).catch((err)=>(0, $k7Pk1.toError)(err)).then((err)=>{
                    setInitialized(true);
                    onReady === null || onReady === void 0 || onReady(err || undefined);
                });
            }
        } else {
            setInitialized(true);
            onReady === null || onReady === void 0 || onReady();
        }
        return ()=>(0, $k7Pk1.clearOverrides)(overrides);
    }, [
        enabled,
        identifiers,
        customAttributes,
        overrides
    ]);
    return (0, $k7Pk1.pickChildToRender)(enabled, isInitialized, children, initializingComponent);
};
module.exports.FeatureGatesInitialization = $7a540cdddae95b1d$var$FeatureGatesInitialization;
module.exports.default = module.exports.FeatureGatesInitialization;

});
parcelRegister("hoOY2", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("fWbo7")).default; });
$parcel$export(module.exports, "FeatureGateEnvironment", function () { return (parcelRequire("kvFVg")).FeatureGateEnvironment; });
$parcel$export(module.exports, "PerimeterType", function () { return (parcelRequire("kvFVg")).PerimeterType; });
$parcel$export(module.exports, "DynamicConfig", function () { return (parcelRequire("btpuG")).DynamicConfig; });
$parcel$export(module.exports, "EvaluationReason", function () { return (parcelRequire("btpuG")).EvaluationReason; });

var $fWbo7 = parcelRequire("fWbo7");
var $btpuG = parcelRequire("btpuG");
var $kvFVg = parcelRequire("kvFVg");

});

parcelRegister("k7Pk1", function(module, exports) {
"use strict";
var $ea6c458c9aa5e533$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.clearOverrides = module.exports.applyOverrides = module.exports.toError = module.exports.pickChildToRender = module.exports.isClientAlreadyInCorrectState = void 0;

const $ea6c458c9aa5e533$var$react_1 = $ea6c458c9aa5e533$var$__importDefault((parcelRequire("dAx5m")));

const $ea6c458c9aa5e533$var$feature_gate_js_client_1 = $ea6c458c9aa5e533$var$__importDefault((parcelRequire("hoOY2")));
let $ea6c458c9aa5e533$var$hasWarnedAboutMissingOverrideSupport = false;
function $ea6c458c9aa5e533$var$isClientAlreadyInCorrectState(identifiers, customAttributes) {
    var _a, _b;
    // If either of these methods don't exist (ie. if the product is using <v4.2.0), then this method will always return false
    return ((_a = $ea6c458c9aa5e533$var$feature_gate_js_client_1.default.initializeCompleted) === null || _a === void 0 ? void 0 : _a.call($ea6c458c9aa5e533$var$feature_gate_js_client_1.default)) && ((_b = $ea6c458c9aa5e533$var$feature_gate_js_client_1.default.isCurrentUser) === null || _b === void 0 ? void 0 : _b.call($ea6c458c9aa5e533$var$feature_gate_js_client_1.default, identifiers, customAttributes));
}
module.exports.isClientAlreadyInCorrectState = $ea6c458c9aa5e533$var$isClientAlreadyInCorrectState;
function $ea6c458c9aa5e533$var$pickChildToRender(enabled, isInitialized, children, initializingComponent) {
    if (!enabled || isInitialized) return $ea6c458c9aa5e533$var$react_1.default.createElement($ea6c458c9aa5e533$var$react_1.default.Fragment, null, children);
    if (initializingComponent != null) return $ea6c458c9aa5e533$var$react_1.default.createElement($ea6c458c9aa5e533$var$react_1.default.Fragment, null, initializingComponent);
    return null;
}
module.exports.pickChildToRender = $ea6c458c9aa5e533$var$pickChildToRender;
function $ea6c458c9aa5e533$var$toError(err) {
    if (err instanceof Error) return err;
    return new Error(err === null || err === void 0 ? void 0 : err.toString());
}
module.exports.toError = $ea6c458c9aa5e533$var$toError;
function $ea6c458c9aa5e533$var$applyOverrides(overrides) {
    // Allow newer versions of the React SDK to be used with older v3.x JS client versions,
    // provided the caller does not try to leverage the overrides which were introduced in v4.
    if (overrides && (!$ea6c458c9aa5e533$var$feature_gate_js_client_1.default.overrideGate || !$ea6c458c9aa5e533$var$feature_gate_js_client_1.default.overrideConfig)) {
        if (!$ea6c458c9aa5e533$var$hasWarnedAboutMissingOverrideSupport) {
            console.warn("Overrides are only supported in @atlaskit/feature-gate-js-client v4.0.0+");
            $ea6c458c9aa5e533$var$hasWarnedAboutMissingOverrideSupport = true;
        }
        return;
    }
    Object.entries((overrides === null || overrides === void 0 ? void 0 : overrides.gates) || {}).forEach(([gateName, value])=>{
        var _a;
        (_a = $ea6c458c9aa5e533$var$feature_gate_js_client_1.default.overrideGate) === null || _a === void 0 || _a.call($ea6c458c9aa5e533$var$feature_gate_js_client_1.default, gateName, value);
    });
    Object.entries((overrides === null || overrides === void 0 ? void 0 : overrides.configs) || {}).forEach(([configName, values])=>{
        var _a;
        (_a = $ea6c458c9aa5e533$var$feature_gate_js_client_1.default.overrideConfig) === null || _a === void 0 || _a.call($ea6c458c9aa5e533$var$feature_gate_js_client_1.default, configName, values);
    });
}
module.exports.applyOverrides = $ea6c458c9aa5e533$var$applyOverrides;
function $ea6c458c9aa5e533$var$clearOverrides(overrides) {
    Object.keys((overrides === null || overrides === void 0 ? void 0 : overrides.gates) || {}).forEach((gateName)=>{
        var _a;
        (_a = $ea6c458c9aa5e533$var$feature_gate_js_client_1.default.clearGateOverride) === null || _a === void 0 || _a.call($ea6c458c9aa5e533$var$feature_gate_js_client_1.default, gateName);
    });
    Object.keys((overrides === null || overrides === void 0 ? void 0 : overrides.configs) || {}).forEach((configName)=>{
        var _a;
        (_a = $ea6c458c9aa5e533$var$feature_gate_js_client_1.default.clearConfigOverride) === null || _a === void 0 || _a.call($ea6c458c9aa5e533$var$feature_gate_js_client_1.default, configName);
    });
}
module.exports.clearOverrides = $ea6c458c9aa5e533$var$clearOverrides;

});


parcelRegister("gyREU", function(module, exports) {
"use strict";
var $c0e971d837cc327b$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.FeatureGatesInitializationWithDefaults = void 0;

var $dAx5m = parcelRequire("dAx5m");

const $c0e971d837cc327b$var$feature_gate_js_client_1 = $c0e971d837cc327b$var$__importDefault((parcelRequire("hoOY2")));

var $k7Pk1 = parcelRequire("k7Pk1");
/**
 * This component initializes the @atlassian/feature-flag-js-client by fetching the gate and experiment
 * evaluations for the given user, and blocks rendering of the children until the rendering is complete.
 */ const $c0e971d837cc327b$var$FeatureGatesInitializationWithDefaults = ({ children: children, enabled: enabled = true, identifiers: identifiers, customAttributes: customAttributes, options: options, overrides: overrides, onReady: onReady })=>{
    // Rather than checking the state of all overrides, we can just assume that if overrides are provided
    // then some sort of update will need to be performed, and hold off rendering until the useEffect is run.
    const [isInitialized, setInitialized] = (0, $dAx5m.useState)(!overrides && (0, $k7Pk1.isClientAlreadyInCorrectState)(identifiers, customAttributes));
    // Use a ref for the options, so that we can use them within the following useEffect
    // without adding options as a dependency.
    // This avoids the user updating every time an option is changed.
    const optionsRef = (0, $dAx5m.useRef)(options);
    (0, $dAx5m.useEffect)(()=>{
        optionsRef.current = options;
    }, [
        options
    ]);
    (0, $dAx5m.useEffect)(()=>{
        if (enabled) {
            if ((0, $k7Pk1.isClientAlreadyInCorrectState)(identifiers, customAttributes)) {
                (0, $k7Pk1.applyOverrides)(overrides);
                setInitialized(true);
                onReady === null || onReady === void 0 || onReady();
            } else {
                setInitialized(false);
                const initPromise = $c0e971d837cc327b$var$feature_gate_js_client_1.default.initializeCalled() ? $c0e971d837cc327b$var$feature_gate_js_client_1.default.updateUserWithValues(identifiers, customAttributes) : $c0e971d837cc327b$var$feature_gate_js_client_1.default.initializeFromValues(Object.assign({
                    sdkKey: "client-default-key"
                }, optionsRef.current || {}), identifiers, customAttributes);
                initPromise.then(()=>(0, $k7Pk1.applyOverrides)(overrides)).catch((err)=>(0, $k7Pk1.toError)(err)).then((err)=>{
                    setInitialized(true);
                    onReady === null || onReady === void 0 || onReady(err || undefined);
                });
            }
        } else {
            setInitialized(true);
            onReady === null || onReady === void 0 || onReady();
        }
        return ()=>(0, $k7Pk1.clearOverrides)(overrides);
    }, [
        enabled,
        identifiers,
        customAttributes,
        overrides
    ]);
    return (0, $k7Pk1.pickChildToRender)(enabled, isInitialized, children);
};
module.exports.FeatureGatesInitializationWithDefaults = $c0e971d837cc327b$var$FeatureGatesInitializationWithDefaults;
module.exports.default = module.exports.FeatureGatesInitializationWithDefaults;

});

parcelRegister("agmYQ", function(module, exports) {
"use strict";
var $778d396a0a3a949e$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.FeatureGatesInitializationWithValues = void 0;

var $dAx5m = parcelRequire("dAx5m");

const $778d396a0a3a949e$var$feature_gate_js_client_1 = $778d396a0a3a949e$var$__importDefault((parcelRequire("hoOY2")));

var $k7Pk1 = parcelRequire("k7Pk1");
/**
 * This component initializes the @atlassian/feature-flag-js-client by fetching the gate and experiment
 * evaluations for the given user, and blocks rendering of the children until the rendering is complete.
 */ const $778d396a0a3a949e$var$FeatureGatesInitializationWithValues = ({ children: children, enabled: enabled = true, identifiers: identifiers, customAttributes: customAttributes, options: options, initializeValues: initializeValues, overrides: overrides, onReady: onReady })=>{
    // Rather than checking the state of all overrides, we can just assume that if overrides are provided
    // then some sort of update will need to be performed, and hold off rendering until the useEffect is run.
    const [isInitialized, setInitialized] = (0, $dAx5m.useState)(!overrides && (0, $k7Pk1.isClientAlreadyInCorrectState)(identifiers, customAttributes));
    // Use a ref for the options, so that we can use them within the following useEffect
    // without adding options as a dependency.
    // This avoids the user updating every time an option is changed.
    const optionsRef = (0, $dAx5m.useRef)(options);
    (0, $dAx5m.useEffect)(()=>{
        optionsRef.current = options;
    }, [
        options
    ]);
    (0, $dAx5m.useEffect)(()=>{
        if (enabled) {
            if ((0, $k7Pk1.isClientAlreadyInCorrectState)(identifiers, customAttributes)) {
                (0, $k7Pk1.applyOverrides)(overrides);
                setInitialized(true);
                onReady === null || onReady === void 0 || onReady();
            } else {
                setInitialized(false);
                const initPromise = $778d396a0a3a949e$var$feature_gate_js_client_1.default.initializeCalled() ? $778d396a0a3a949e$var$feature_gate_js_client_1.default.updateUserWithValues(identifiers, customAttributes, initializeValues) : $778d396a0a3a949e$var$feature_gate_js_client_1.default.initializeFromValues(optionsRef.current, identifiers, customAttributes, initializeValues);
                initPromise.then(()=>(0, $k7Pk1.applyOverrides)(overrides)).catch((err)=>(0, $k7Pk1.toError)(err)).then((err)=>{
                    setInitialized(true);
                    onReady === null || onReady === void 0 || onReady(err || undefined);
                });
            }
        } else {
            setInitialized(true);
            onReady === null || onReady === void 0 || onReady();
        }
        return ()=>(0, $k7Pk1.clearOverrides)(overrides);
    }, [
        enabled,
        identifiers,
        customAttributes,
        initializeValues,
        overrides
    ]);
    return (0, $k7Pk1.pickChildToRender)(enabled, isInitialized, children);
};
module.exports.FeatureGatesInitializationWithValues = $778d396a0a3a949e$var$FeatureGatesInitializationWithValues;
module.exports.default = module.exports.FeatureGatesInitializationWithValues;

});

parcelRegister("bzBux", function(module, exports) {

var $9iRWr = parcelRequire("9iRWr");
var $86d00b9d026eeccc$var$_typeof = $9iRWr.default;
function $86d00b9d026eeccc$var$_regeneratorRuntime() {
    "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ 
    module.exports = $86d00b9d026eeccc$var$_regeneratorRuntime = function _regeneratorRuntime() {
        return e;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports;
    var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function(t, e, r) {
        t[e] = r.value;
    }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag";
    function define(t, e, r) {
        return Object.defineProperty(t, e, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }), t[e];
    }
    try {
        define({}, "");
    } catch (t) {
        define = function define(t, e, r) {
            return t[e] = r;
        };
    }
    function wrap(t, e, r, n) {
        var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []);
        return o(a, "_invoke", {
            value: makeInvokeMethod(t, r, c)
        }), a;
    }
    function tryCatch(t, e, r) {
        try {
            return {
                type: "normal",
                arg: t.call(e, r)
            };
        } catch (t) {
            return {
                type: "throw",
                arg: t
            };
        }
    }
    e.wrap = wrap;
    var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {};
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    var p = {};
    define(p, a, function() {
        return this;
    });
    var d = Object.getPrototypeOf, v = d && d(d(values([])));
    v && v !== r && n.call(v, a) && (p = v);
    var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
    function defineIteratorMethods(t) {
        [
            "next",
            "throw",
            "return"
        ].forEach(function(e) {
            define(t, e, function(t) {
                return this._invoke(e, t);
            });
        });
    }
    function AsyncIterator(t, e) {
        function invoke(r, o, i, a) {
            var c = tryCatch(t[r], t, o);
            if ("throw" !== c.type) {
                var u = c.arg, h = u.value;
                return h && "object" == $86d00b9d026eeccc$var$_typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function(t) {
                    invoke("next", t, i, a);
                }, function(t) {
                    invoke("throw", t, i, a);
                }) : e.resolve(h).then(function(t) {
                    u.value = t, i(u);
                }, function(t) {
                    return invoke("throw", t, i, a);
                });
            }
            a(c.arg);
        }
        var r;
        o(this, "_invoke", {
            value: function value(t, n) {
                function callInvokeWithMethodAndArg() {
                    return new e(function(e, r) {
                        invoke(t, n, e, r);
                    });
                }
                return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
            }
        });
    }
    function makeInvokeMethod(e, r, n) {
        var o = h;
        return function(i, a) {
            if (o === f) throw Error("Generator is already running");
            if (o === s) {
                if ("throw" === i) throw a;
                return {
                    value: t,
                    done: !0
                };
            }
            for(n.method = i, n.arg = a;;){
                var c = n.delegate;
                if (c) {
                    var u = maybeInvokeDelegate(c, n);
                    if (u) {
                        if (u === y) continue;
                        return u;
                    }
                }
                if ("next" === n.method) n.sent = n._sent = n.arg;
                else if ("throw" === n.method) {
                    if (o === h) throw o = s, n.arg;
                    n.dispatchException(n.arg);
                } else "return" === n.method && n.abrupt("return", n.arg);
                o = f;
                var p = tryCatch(e, r, n);
                if ("normal" === p.type) {
                    if (o = n.done ? s : l, p.arg === y) continue;
                    return {
                        value: p.arg,
                        done: n.done
                    };
                }
                "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
            }
        };
    }
    function maybeInvokeDelegate(e, r) {
        var n = r.method, o = e.iterator[n];
        if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
        var i = tryCatch(o, e.iterator, r.arg);
        if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
        var a = i.arg;
        return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
    }
    function pushTryEntry(t) {
        var e = {
            tryLoc: t[0]
        };
        1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
    }
    function resetTryEntry(t) {
        var e = t.completion || {};
        e.type = "normal", delete e.arg, t.completion = e;
    }
    function Context(t) {
        this.tryEntries = [
            {
                tryLoc: "root"
            }
        ], t.forEach(pushTryEntry, this), this.reset(!0);
    }
    function values(e) {
        if (e || "" === e) {
            var r = e[a];
            if (r) return r.call(e);
            if ("function" == typeof e.next) return e;
            if (!isNaN(e.length)) {
                var o = -1, i = function next() {
                    for(; ++o < e.length;)if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
                    return next.value = t, next.done = !0, next;
                };
                return i.next = i;
            }
        }
        throw new TypeError($86d00b9d026eeccc$var$_typeof(e) + " is not iterable");
    }
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
        value: GeneratorFunctionPrototype,
        configurable: !0
    }), o(GeneratorFunctionPrototype, "constructor", {
        value: GeneratorFunction,
        configurable: !0
    }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function(t) {
        var e = "function" == typeof t && t.constructor;
        return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
    }, e.mark = function(t) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
    }, e.awrap = function(t) {
        return {
            __await: t
        };
    }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function() {
        return this;
    }), e.AsyncIterator = AsyncIterator, e.async = function(t, r, n, o, i) {
        void 0 === i && (i = Promise);
        var a = new AsyncIterator(wrap(t, r, n, o), i);
        return e.isGeneratorFunction(r) ? a : a.next().then(function(t) {
            return t.done ? t.value : a.next();
        });
    }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function() {
        return this;
    }), define(g, "toString", function() {
        return "[object Generator]";
    }), e.keys = function(t) {
        var e = Object(t), r = [];
        for(var n in e)r.push(n);
        return r.reverse(), function next() {
            for(; r.length;){
                var t = r.pop();
                if (t in e) return next.value = t, next.done = !1, next;
            }
            return next.done = !0, next;
        };
    }, e.values = values, Context.prototype = {
        constructor: Context,
        reset: function reset(e) {
            if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for(var r in this)"t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
        },
        stop: function stop() {
            this.done = !0;
            var t = this.tryEntries[0].completion;
            if ("throw" === t.type) throw t.arg;
            return this.rval;
        },
        dispatchException: function dispatchException(e) {
            if (this.done) throw e;
            var r = this;
            function handle(n, o) {
                return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
            }
            for(var o = this.tryEntries.length - 1; o >= 0; --o){
                var i = this.tryEntries[o], a = i.completion;
                if ("root" === i.tryLoc) return handle("end");
                if (i.tryLoc <= this.prev) {
                    var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc");
                    if (c && u) {
                        if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                        if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
                    } else if (c) {
                        if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                    } else {
                        if (!u) throw Error("try statement without catch or finally");
                        if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
                    }
                }
            }
        },
        abrupt: function abrupt(t, e) {
            for(var r = this.tryEntries.length - 1; r >= 0; --r){
                var o = this.tryEntries[r];
                if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
                    var i = o;
                    break;
                }
            }
            i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
            var a = i ? i.completion : {};
            return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
        },
        complete: function complete(t, e) {
            if ("throw" === t.type) throw t.arg;
            return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
        },
        finish: function finish(t) {
            for(var e = this.tryEntries.length - 1; e >= 0; --e){
                var r = this.tryEntries[e];
                if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
            }
        },
        "catch": function _catch(t) {
            for(var e = this.tryEntries.length - 1; e >= 0; --e){
                var r = this.tryEntries[e];
                if (r.tryLoc === t) {
                    var n = r.completion;
                    if ("throw" === n.type) {
                        var o = n.arg;
                        resetTryEntry(r);
                    }
                    return o;
                }
            }
            throw Error("illegal catch attempt");
        },
        delegateYield: function delegateYield(e, r, n) {
            return this.delegate = {
                iterator: values(e),
                resultName: r,
                nextLoc: n
            }, "next" === this.method && (this.arg = t), y;
        }
    }, e;
}
module.exports = $86d00b9d026eeccc$var$_regeneratorRuntime, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("9iRWr", function(module, exports) {
function $6c5fa32aafcaa4e9$var$_typeof(o) {
    "@babel/helpers - typeof";
    return module.exports = $6c5fa32aafcaa4e9$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $6c5fa32aafcaa4e9$var$_typeof(o);
}
module.exports = $6c5fa32aafcaa4e9$var$_typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("9JXtK", function(module, exports) {

$parcel$export(module.exports, "GET_MY_PREFERENCES", function () { return $11e691841785c8d4$export$42ad2c52552135b7; });
$parcel$export(module.exports, "UPDATE_MY_PREFERENCES", function () { return $11e691841785c8d4$export$75370b4bf95bca9c; });
$parcel$export(module.exports, "default", function () { return $11e691841785c8d4$export$2e2bcd8739ae039; });
const $11e691841785c8d4$export$42ad2c52552135b7 = "GET_MY_PREFERENCES";
const $11e691841785c8d4$export$75370b4bf95bca9c = "UPDATE_MY_PREFERENCES";
const $11e691841785c8d4$export$d4c72bab9d6cc13a = {
    isLoading: false,
    hasLoaded: false,
    hasError: false,
    userPreferences: {
        defaultAppearance: "inline",
        appearances: []
    }
};
var $11e691841785c8d4$export$2e2bcd8739ae039 = (state = $11e691841785c8d4$export$d4c72bab9d6cc13a, action)=>{
    switch(action.type){
        case `${$11e691841785c8d4$export$42ad2c52552135b7}_PENDING`:
            return {
                ...state,
                isLoading: true
            };
        case `${$11e691841785c8d4$export$42ad2c52552135b7}_FULFILLED`:
            return {
                ...state,
                isLoading: false,
                hasLoaded: true,
                hasError: false,
                userPreferences: action.payload
            };
        case `${$11e691841785c8d4$export$42ad2c52552135b7}_REJECTED`:
            if (action.payload.status === 404) return {
                ...state,
                isLoading: false,
                hasLoaded: true,
                hasError: false,
                userPreferences: {
                    defaultAppearance: "inline",
                    appearances: []
                }
            };
            return {
                ...state,
                hasError: true
            };
        case `${$11e691841785c8d4$export$75370b4bf95bca9c}_PENDING`:
            return {
                ...state,
                userPreferences: action.meta || state.userPreferences
            };
        case `${$11e691841785c8d4$export$75370b4bf95bca9c}_FULFILLED`:
            return {
                ...state,
                userPreferences: action.payload
            };
        default:
            return state;
    }
};

});

// we want to import this before anything else

var $bibO8 = parcelRequire("bibO8");
// This is the entry point for time-critical scripts that we want run as soon as possible during app load,
// even before our mega-size bundles (which include React, Atlaskit...) are downloaded and run.
//
// One example is the code to fetch logged-in user information (locale, account ID). It is part of this entry
// point because we want the fetch request to happen in parallel with the main app download and execution, not
// after. That way, components in the main app do typically not have to wait for the data, and improves initial page load.
//
// Be mindful when adding more code/dependencies to this entry point, because once it gets larger,
// it will take longer till the time-critical piece of code is executed, and thus cancel the possible performance gain.
// Warning: `import { ... } from './common';` will increase time taken by early-init.ts significantly
// so we should instead import directly like below

var $5eCIB = parcelRequire("5eCIB");

var $fCHnn = parcelRequire("fCHnn");
(0, $fCHnn.userInfoProvider).get((0, $5eCIB.withDefaultExponentialBackoff)(fetch));


parcelRequire("dAx5m");
var $e2247254f7ec34f2$export$882461b6382ed46c;
var $e2247254f7ec34f2$export$757ceba2d55c277e;
"use strict";

var $1MpXQ = parcelRequire("1MpXQ");
var $e2247254f7ec34f2$var$i;
$e2247254f7ec34f2$export$882461b6382ed46c = $1MpXQ.createRoot;
$e2247254f7ec34f2$export$757ceba2d55c277e = $1MpXQ.hydrateRoot;




parcelRequire("jShba");
var $7pLec = parcelRequire("7pLec");
var $jLJT8 = parcelRequire("jLJT8");
var $djcZD = parcelRequire("djcZD");
var $77YRX = parcelRequire("77YRX");
var $iyr2L = parcelRequire("iyr2L");
var $fCHnn = parcelRequire("fCHnn");

var $9Z3Ln = parcelRequire("9Z3Ln");

var $gVKiB = parcelRequire("gVKiB");

var $7rgZR = parcelRequire("7rgZR");

var $f9YR6 = parcelRequire("f9YR6");

var $eEAbY = parcelRequire("eEAbY");

var $8TkP5 = parcelRequire("8TkP5");

var $awgKP = parcelRequire("awgKP");

var $3TgUs = parcelRequire("3TgUs");

var $c2GEI = parcelRequire("c2GEI");
function $35d0d19dac5ccba7$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $35d0d19dac5ccba7$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $35d0d19dac5ccba7$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($9Z3Ln)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $35d0d19dac5ccba7$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $35d0d19dac5ccba7$var$makeBrowserMetrics = function makeBrowserMetrics() {
    var bm = {
        init: function init(config) {
            var _config$events$BMEven, _config$ssr;
            (0, $eEAbY.visibilityChangeObserver).start();
            if ((_config$events$BMEven = config.events[(0, $c2GEI.BMEventsType).WEB_VITALS]) !== null && _config$events$BMEven !== void 0 && _config$events$BMEven.enabled) (0, $8TkP5.webVitalsObserver).start();
            if (config.debug) {
                (0, $7rgZR.logger).enable();
                (0, $3TgUs.submitter).setDebug(true);
                (0, $f9YR6.pageLoadMetaMetric).setDebug(true);
            }
            (0, $3TgUs.submitter).configure(config);
            if ((_config$ssr = config.ssr) !== null && _config$ssr !== void 0 && _config$ssr.getDoneMark) (0, $gVKiB.SSRGetDoneMark).setGetDoneMark(config.ssr.getDoneMark);
        },
        setRoute: function setRoute(newRoute) {
            (0, $awgKP.Route).setRoute(newRoute);
        },
        startPageLoad: function startPageLoad(params) {
            (0, $f9YR6.pageLoadMetaMetric).startPageLoad($35d0d19dac5ccba7$var$_objectSpread({
                isInitial: false,
                cancelStarted: true
            }, params));
        },
        getPageLoadMetric: function getPageLoadMetric() {
            return 0, $f9YR6.pageLoadMetaMetric;
        },
        experimental__addPageLoadTimingFromPerformanceMarks: function experimental__addPageLoadTimingFromPerformanceMarks(name, startMark, stopMark) {
            var initialOnly = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
            if (initialOnly && !(0, $f9YR6.pageLoadMetaMetric).isInitialLoad()) return;
            var start = performance.getEntriesByName(startMark);
            var stop = performance.getEntriesByName(stopMark);
            if (start.length > 0 && stop.length > 0) {
                if ((0, $f9YR6.pageLoadMetaMetric).isDebugMode()) try {
                    performance.measure(name, startMark, stopMark);
                } catch (e) {}
                var pageLoadData = (0, $f9YR6.pageLoadMetaMetric).getData();
                if (pageLoadData.start !== null) {
                    var _startMark = start[start.length - 1];
                    var timing = {
                        startTime: Math.round(_startMark.startTime - pageLoadData.start),
                        duration: Math.round(stop[stop.length - 1].startTime - _startMark.startTime)
                    };
                    (0, $f9YR6.pageLoadMetaMetric).experimental__addExplicitTiming(name, timing);
                }
            }
        }
    };
    return bm;
};
var $35d0d19dac5ccba7$export$c08e7affcf78b064 = $35d0d19dac5ccba7$var$makeBrowserMetrics();



var $c2GEI = parcelRequire("c2GEI");

var $dAx5m = parcelRequire("dAx5m");

var $djcZD = parcelRequire("djcZD");

var $4ffTz = parcelRequire("4ffTz");
const $ae2108313eafd9b1$export$7cf313435eb9a801 = (analyticsClient)=>{
    const info = {
        app: {
            version: {
                web: "404bf65f795e7e45c518f46bdeb15a0d8d3a6a3f-6179-2025-04-28" ?? "no-version"
            },
            framework: {
                name: "react",
                version: $dAx5m.version
            }
        },
        // because this has already been defined as part of sending gasv3 events
        product: "identity",
        // Region is used for "Split by" in Perf Portal.
        region: "unknown"
    };
    const endpoints = {
        eventPipelineClient: Promise.resolve(analyticsClient.getAnalyticsWebClient())
    };
    const events = {
        [(0, $c2GEI.BMEventsType).WEB_VITALS]: {
            enabled: true
        }
    };
    const plugins = {
        featureFlags: {
            client: Promise.resolve({
                getValue: (gate)=>(0, $4ffTz.checkFeatureGate)(gate)
            })
        },
        resourceTimings: {
            /**
       * Browser Metrics track all the network calls and add them automatically to the performance events.
       * To ensure we're not recording any UGC / PII, we need to provide a sanitise method.
       */ sanitiseEndpoints: (url)=>{
                // Remove sensitive PII data (i.e. all URL params)
                return url.split("?")[0];
            },
            mapResources: (url)=>{
                if (!url.includes("ptc-directory")) // This is an external URL where we can't guarantee the URL structure, therefore cannot do any mapping.
                return url;
                // hashedFileName = login.28848bff.chunk.js
                const hashedFileName = url.split("/").pop() ?? "unknown";
                const parts = hashedFileName.split(".");
                const ext = parts.length > 1 ? parts.pop() : "unknown";
                // Returning login.js
                return `${parts[0]}.${ext}`;
            },
            // If url supports TimingAllowOrigin header, then BM calculates cache status of static resources:
            hasTimingHeaders: ()=>false
        }
    };
    (0, $35d0d19dac5ccba7$export$c08e7affcf78b064).init({
        info: info,
        endpoints: endpoints,
        plugins: plugins,
        events: events,
        debug: (0, $djcZD.getEnv)() !== "prod"
    });
    (0, $35d0d19dac5ccba7$export$c08e7affcf78b064).startPageLoad({
        isInitial: true
    });
};



var $bibO8 = parcelRequire("bibO8");
parcelRequire("dAx5m");

var $5Zreo = parcelRequire("5Zreo");
parcelRequire("jQGCp");
var $72LdD = parcelRequire("72LdD");
parcelRequire("jShba");
var $hYcP6 = parcelRequire("hYcP6");
var $9lQ50 = parcelRequire("9lQ50");
var $9Rq8g = parcelRequire("9Rq8g");
var $djcZD = parcelRequire("djcZD");
var $l5OgO = parcelRequire("l5OgO");

var $dAx5m = parcelRequire("dAx5m");

var $4ffTz = parcelRequire("4ffTz");
var $3eb93755e0c29936$exports = {};
function $3eb93755e0c29936$var$asyncGeneratorStep(n, t, e, r, o, a, c) {
    try {
        var i = n[a](c), u = i.value;
    } catch (n) {
        return void e(n);
    }
    i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function $3eb93755e0c29936$var$_asyncToGenerator(n) {
    return function() {
        var t = this, e = arguments;
        return new Promise(function(r, o) {
            var a = n.apply(t, e);
            function _next(n) {
                $3eb93755e0c29936$var$asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
            }
            function _throw(n) {
                $3eb93755e0c29936$var$asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
            }
            _next(void 0);
        });
    };
}
$3eb93755e0c29936$exports = $3eb93755e0c29936$var$_asyncToGenerator, $3eb93755e0c29936$exports.__esModule = true, $3eb93755e0c29936$exports["default"] = $3eb93755e0c29936$exports;


var $55f3f7993ef5ab08$exports = {};
// TODO(Babel 8): Remove this file.

var $55f3f7993ef5ab08$var$runtime = (parcelRequire("h6uNY"))();
$55f3f7993ef5ab08$exports = $55f3f7993ef5ab08$var$runtime;
// Copied from https://github.com/facebook/regenerator/blob/main/packages/runtime/runtime.js#L736=
try {
    regeneratorRuntime = $55f3f7993ef5ab08$var$runtime;
} catch (accidentalStrictMode) {
    if (typeof globalThis === "object") globalThis.regeneratorRuntime = $55f3f7993ef5ab08$var$runtime;
    else Function("r", "regeneratorRuntime = r")($55f3f7993ef5ab08$var$runtime);
}



var $18rB9 = parcelRequire("18rB9");

var $hSHEC = parcelRequire("hSHEC");

var $bCORa = parcelRequire("bCORa");

var $64Sai = parcelRequire("64Sai");

var $18rB9 = parcelRequire("18rB9");

var $b0tKs = parcelRequire("b0tKs");

var $18rB9 = parcelRequire("18rB9");

var $da8nl = parcelRequire("da8nl");

var $hSHEC = parcelRequire("hSHEC");

var $3RQ7P = parcelRequire("3RQ7P");

var $64Sai = parcelRequire("64Sai");

var $hSHEC = parcelRequire("hSHEC");
var $9a8ef449f7289de2$var$themeKinds = [
    "light",
    "dark",
    "spacing",
    "typography",
    "shape"
];
var $9a8ef449f7289de2$var$customThemeOptions = "UNSAFE_themeOptions";
var $9a8ef449f7289de2$var$isThemeKind = function isThemeKind(themeKind) {
    return $9a8ef449f7289de2$var$themeKinds.find(function(kind) {
        return kind === themeKind;
    }) !== undefined;
};
var $9a8ef449f7289de2$var$isThemeIds = function isThemeIds(themeId) {
    return (0, $hSHEC.themeIds).find(function(id) {
        return id === themeId;
    }) !== undefined;
};
var $9a8ef449f7289de2$var$isColorMode = function isColorMode(modeId) {
    return [
        "light",
        "dark",
        "auto"
    ].includes(modeId);
};
var $9a8ef449f7289de2$export$f19b488f7c0547ee = function themeStringToObject(themeState) {
    return themeState.split(" ").map(function(theme) {
        return theme.split(/:([^]*)/);
    }).reduce(function(themeObject, _ref) {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($64Sai)))(_ref, 2), kind = _ref2[0], id = _ref2[1];
        if (kind === "colorMode" && $9a8ef449f7289de2$var$isColorMode(id)) themeObject[kind] = id;
        if ($9a8ef449f7289de2$var$isThemeKind(kind) && $9a8ef449f7289de2$var$isThemeIds(id)) // @ts-expect-error FIXME - this is a valid ts error
        themeObject[kind] = id;
        if (kind === $9a8ef449f7289de2$var$customThemeOptions) try {
            themeObject[$9a8ef449f7289de2$var$customThemeOptions] = JSON.parse(id);
        } catch (e) {
            new Error("Invalid custom theme string");
        }
        return themeObject;
    }, {});
};
var $9a8ef449f7289de2$export$62c37ab81302621a = function themeObjectToString(themeState) {
    return Object.entries(themeState).reduce(function(themeString, _ref3) {
        var _ref4 = (0, (/*@__PURE__*/$parcel$interopDefault($64Sai)))(_ref3, 2), kind = _ref4[0], id = _ref4[1];
        if (// colorMode theme state
        kind === "colorMode" && typeof id === "string" && $9a8ef449f7289de2$var$isColorMode(id) || // custom theme state
        kind === $9a8ef449f7289de2$var$customThemeOptions && (0, (/*@__PURE__*/$parcel$interopDefault($3RQ7P)))(id) === "object" || // other theme states
        $9a8ef449f7289de2$var$isThemeKind(kind) && typeof id === "string" && $9a8ef449f7289de2$var$isThemeIds(id)) return themeString + "".concat(themeString ? " " : "") + "".concat(kind, ":").concat((0, (/*@__PURE__*/$parcel$interopDefault($3RQ7P)))(id) === "object" ? JSON.stringify(id) : id);
        return themeString;
    }, "");
};



var $bCORa = parcelRequire("bCORa");

var $dBfsM = parcelRequire("dBfsM");
function $da02656b26a4b648$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $da02656b26a4b648$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $da02656b26a4b648$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($b0tKs)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $da02656b26a4b648$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $da02656b26a4b648$var$defaultColorMode = "light";
var $da02656b26a4b648$var$defaultContrastMode = "no-preference";
/**
 * Server-side rendering utility. Generates the valid HTML attributes for a given theme.
 * Note: this utility does not handle automatic theme switching.
 *
 * @param {Object<string, string>} themeOptions - Theme options object
 * @param {string} themeState.colorMode Determines which color theme is applied. If set to `auto`, the theme applied will be determined by the OS setting.
 * @param {string} themeState.dark The color theme to be applied when the color mode resolves to 'dark'.
 * @param {string} themeState.light The color theme to be applied when the color mode resolves to 'light'.
 * @param {string} themeState.spacing The spacing theme to be applied.
 * @param {string} themeState.typography The typography theme to be applied.
 * @param {Object} themeState.UNSAFE_themeOptions The custom branding options to be used for custom theme generation
 *
 * @returns {Object} Object of HTML attributes to be applied to the document root
 */ var $da02656b26a4b648$var$getThemeHtmlAttrs = function getThemeHtmlAttrs() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref$colorMode = _ref.colorMode, colorMode = _ref$colorMode === void 0 ? (0, $hSHEC.themeStateDefaults)["colorMode"] : _ref$colorMode, _ref$dark = _ref.dark, dark = _ref$dark === void 0 ? (0, $hSHEC.themeStateDefaults)["dark"] : _ref$dark, _ref$light = _ref.light, light = _ref$light === void 0 ? (0, $hSHEC.themeStateDefaults)["light"] : _ref$light, _ref$contrastMode = _ref.contrastMode, contrastMode = _ref$contrastMode === void 0 ? (0, $hSHEC.themeStateDefaults)["contrastMode"] : _ref$contrastMode, _ref$shape = _ref.shape, shape = _ref$shape === void 0 ? (0, $hSHEC.themeStateDefaults)["shape"] : _ref$shape, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? (0, $hSHEC.themeStateDefaults)["spacing"] : _ref$spacing, _ref$typography = _ref.typography, typography = _ref$typography === void 0 ? (0, $hSHEC.themeStateDefaults)["typography"]() : _ref$typography, _ref$UNSAFE_themeOpti = _ref.UNSAFE_themeOptions, UNSAFE_themeOptions = _ref$UNSAFE_themeOpti === void 0 ? (0, $hSHEC.themeStateDefaults)["UNSAFE_themeOptions"] : _ref$UNSAFE_themeOpti;
    var themeAttribute = (0, $9a8ef449f7289de2$export$62c37ab81302621a)({
        dark: dark,
        light: light,
        shape: shape,
        spacing: spacing,
        typography: typography
    });
    var result = (0, (/*@__PURE__*/$parcel$interopDefault($b0tKs)))((0, (/*@__PURE__*/$parcel$interopDefault($b0tKs)))({}, (0, $da8nl.THEME_DATA_ATTRIBUTE), themeAttribute), (0, $da8nl.COLOR_MODE_ATTRIBUTE), colorMode === "auto" ? $da02656b26a4b648$var$defaultColorMode : colorMode);
    if ((0, $18rB9.fg)("platform_increased-contrast-themes")) result = $da02656b26a4b648$var$_objectSpread($da02656b26a4b648$var$_objectSpread({}, result), {}, (0, (/*@__PURE__*/$parcel$interopDefault($b0tKs)))({}, (0, $da8nl.CONTRAST_MODE_ATTRIBUTE), contrastMode === "auto" ? $da02656b26a4b648$var$defaultContrastMode : contrastMode));
    if (UNSAFE_themeOptions && (0, $bCORa.isValidBrandHex)(UNSAFE_themeOptions.brandColor)) {
        var optionString = JSON.stringify(UNSAFE_themeOptions);
        var uniqueId = (0, $dBfsM.hash)(optionString);
        result[0, $da8nl.CUSTOM_THEME_ATTRIBUTE] = uniqueId;
    }
    return result;
};
var $da02656b26a4b648$export$2e2bcd8739ae039 = $da02656b26a4b648$var$getThemeHtmlAttrs;



var $kreZW = parcelRequire("kreZW");

var $9kHty = parcelRequire("9kHty");

var $b0tKs = parcelRequire("b0tKs");

var $dd4sf = parcelRequire("dd4sf");

var $da8nl = parcelRequire("da8nl");



var $18rB9 = parcelRequire("18rB9");
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * This file contains a dynamic import for each theme this package exports.
 * Themes are loaded asynchronously at runtime to minimise the amount of CSS we send to the client.
 * This allows users to compose their themes and only use the tokens that are requested.
 * When a new theme is created, the import should automatically be added to the map
 *
 * @codegen <<SignedSource::8352f41e09dfe9d45ead708661744456>>
 * @codegenCommand yarn build tokens
 */ 














var $39095e5866f9dcea$var$themeImportsMap = {
    "light": function light() {
        return (parcelRequire("jKM4s"));
    },
    "light-future": function lightFuture() {
        return (parcelRequire("66m9D"));
    },
    "light-increased-contrast": function lightIncreasedContrast() {
        return (parcelRequire("lzHUs"));
    },
    "dark": function dark() {
        return (parcelRequire("afCjQ"));
    },
    "dark-future": function darkFuture() {
        return (parcelRequire("ezHh3"));
    },
    "dark-increased-contrast": function darkIncreasedContrast() {
        return (parcelRequire("aFtYc"));
    },
    "legacy-light": function legacyLight() {
        return (parcelRequire("2pYof"));
    },
    "legacy-dark": function legacyDark() {
        return (parcelRequire("70xpV"));
    },
    "spacing": function spacing() {
        return (parcelRequire("lgJq4"));
    },
    "typography-adg3": function typographyAdg3() {
        return (parcelRequire("iGNVw"));
    },
    "shape": function shape() {
        return (parcelRequire("8ocrC"));
    },
    "typography-modernized": function typographyModernized() {
        return (parcelRequire("a7Jto"));
    },
    "typography-refreshed": function typographyRefreshed() {
        return (parcelRequire("eXBd8"));
    },
    "light-brand-refresh": function lightBrandRefresh() {
        return (parcelRequire("6Bdbd"));
    },
    "dark-brand-refresh": function darkBrandRefresh() {
        return (parcelRequire("8VokN"));
    }
};
var $39095e5866f9dcea$export$2e2bcd8739ae039 = $39095e5866f9dcea$var$themeImportsMap;



var $da8nl = parcelRequire("da8nl");
var $227251ce43ac6023$export$26cd7ae85c7144e5 = /*#__PURE__*/ function() {
    var _ref = (0, (/*@__PURE__*/$parcel$interopDefault($3eb93755e0c29936$exports)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($55f3f7993ef5ab08$exports))).mark(function _callee(themeId) {
        var themeCss, style;
        return (0, (/*@__PURE__*/$parcel$interopDefault($55f3f7993ef5ab08$exports))).wrap(function _callee$(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    if (!document.head.querySelector("style[".concat((0, $da8nl.THEME_DATA_ATTRIBUTE), '="').concat(themeId, '"]:not([').concat((0, $da8nl.CUSTOM_THEME_ATTRIBUTE), "])"))) {
                        _context.next = 2;
                        break;
                    }
                    return _context.abrupt("return");
                case 2:
                    if (themeId) {
                        _context.next = 4;
                        break;
                    }
                    return _context.abrupt("return");
                case 4:
                    _context.next = 6;
                    return $227251ce43ac6023$export$8a48286ed7df6720(themeId);
                case 6:
                    themeCss = _context.sent;
                    style = document.createElement("style");
                    style.textContent = themeCss;
                    style.dataset.theme = themeId;
                    document.head.appendChild(style);
                case 11:
                case "end":
                    return _context.stop();
            }
        }, _callee);
    }));
    return function loadAndAppendThemeCss(_x) {
        return _ref.apply(this, arguments);
    };
}();
var $227251ce43ac6023$export$8a48286ed7df6720 = /*#__PURE__*/ function() {
    var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($3eb93755e0c29936$exports)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($55f3f7993ef5ab08$exports))).mark(function _callee2(themeId) {
        var _yield$themeImportMap, themeCss;
        return (0, (/*@__PURE__*/$parcel$interopDefault($55f3f7993ef5ab08$exports))).wrap(function _callee2$(_context2) {
            while(true)switch(_context2.prev = _context2.next){
                case 0:
                    if ((themeId === "light" || themeId === "dark") && (0, $18rB9.fg)("platform-component-visual-refresh")) themeId += "-brand-refresh";
                    _context2.next = 3;
                    return (0, $39095e5866f9dcea$export$2e2bcd8739ae039)[themeId]();
                case 3:
                    _yield$themeImportMap = _context2.sent;
                    themeCss = _yield$themeImportMap.default;
                    return _context2.abrupt("return", themeCss);
                case 6:
                case "end":
                    return _context2.stop();
            }
        }, _callee2);
    }));
    return function loadThemeCss(_x2) {
        return _ref2.apply(this, arguments);
    };
}();
var $227251ce43ac6023$export$bb1e815119d30f8b = "(prefers-color-scheme: dark)";
var $227251ce43ac6023$export$8662df6937d86fcb = "(prefers-contrast: more)";


var $31c94491f1a09e10$var$isMatchMediaAvailable = typeof window !== "undefined" && "matchMedia" in window;
/**
 * Updates the current theme when the system theme changes. Should be bound
 * to an event listener listening on the '(prefers-color-scheme: dark)' query
 * @param e The event representing a change in system theme.
 */ function $31c94491f1a09e10$var$checkNativeListener(e) {
    var element = document.documentElement;
    element.setAttribute((0, $da8nl.COLOR_MODE_ATTRIBUTE), e.matches ? "dark" : "light");
}
var $31c94491f1a09e10$var$darkModeMql = $31c94491f1a09e10$var$isMatchMediaAvailable && window.matchMedia((0, $227251ce43ac6023$export$bb1e815119d30f8b));
var $31c94491f1a09e10$var$ColorModeObserver = /*#__PURE__*/ function() {
    function ColorModeObserver() {
        (0, (/*@__PURE__*/$parcel$interopDefault($kreZW)))(this, ColorModeObserver);
        (0, (/*@__PURE__*/$parcel$interopDefault($b0tKs)))(this, "unbindThemeChangeListener", null);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($9kHty)))(ColorModeObserver, [
        {
            key: "getColorMode",
            value: function getColorMode() {
                if (!$31c94491f1a09e10$var$darkModeMql) return "light";
                return $31c94491f1a09e10$var$darkModeMql !== null && $31c94491f1a09e10$var$darkModeMql !== void 0 && $31c94491f1a09e10$var$darkModeMql.matches ? "dark" : "light";
            }
        },
        {
            key: "bind",
            value: function bind() {
                if ($31c94491f1a09e10$var$darkModeMql && this.unbindThemeChangeListener === null) this.unbindThemeChangeListener = (0, $dd4sf.bind)($31c94491f1a09e10$var$darkModeMql, {
                    type: "change",
                    listener: $31c94491f1a09e10$var$checkNativeListener
                });
            }
        },
        {
            key: "unbind",
            value: function unbind() {
                if (this.unbindThemeChangeListener) {
                    this.unbindThemeChangeListener();
                    this.unbindThemeChangeListener = null;
                }
            }
        }
    ]);
}();
/**
 * A singleton color mode observer - binds "auto" switching logic to a single `mediaQueryList` listener
 * that can be unbound by any consumer when no longer needed.
 */ var $31c94491f1a09e10$var$SingletonColorModeObserver = new $31c94491f1a09e10$var$ColorModeObserver();
var $31c94491f1a09e10$export$2e2bcd8739ae039 = $31c94491f1a09e10$var$SingletonColorModeObserver;



var $kreZW = parcelRequire("kreZW");

var $9kHty = parcelRequire("9kHty");

var $b0tKs = parcelRequire("b0tKs");

var $dd4sf = parcelRequire("dd4sf");

var $da8nl = parcelRequire("da8nl");

var $a754a40140901e43$var$isMatchMediaAvailable = typeof window !== "undefined" && "matchMedia" in window;
/**
 * Updates the current theme when the system contrast preference changes. Should be bound
 * to an event listener listening on the '(prefers-contrast: more)' query
 * @param e The event representing a change in system theme.
 */ function $a754a40140901e43$var$checkNativeListener(e) {
    var element = document.documentElement;
    element.setAttribute((0, $da8nl.CONTRAST_MODE_ATTRIBUTE), e.matches ? "more" : "no-preference");
}
var $a754a40140901e43$var$contrastModeMql = $a754a40140901e43$var$isMatchMediaAvailable && window.matchMedia((0, $227251ce43ac6023$export$8662df6937d86fcb));
var $a754a40140901e43$var$ContrastModeObserver = /*#__PURE__*/ function() {
    function ContrastModeObserver() {
        (0, (/*@__PURE__*/$parcel$interopDefault($kreZW)))(this, ContrastModeObserver);
        (0, (/*@__PURE__*/$parcel$interopDefault($b0tKs)))(this, "unbindContrastChangeListener", null);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($9kHty)))(ContrastModeObserver, [
        {
            key: "getContrastMode",
            value: function getContrastMode() {
                if (!$a754a40140901e43$var$contrastModeMql) return "no-preference";
                return $a754a40140901e43$var$contrastModeMql !== null && $a754a40140901e43$var$contrastModeMql !== void 0 && $a754a40140901e43$var$contrastModeMql.matches ? "more" : "no-preference";
            }
        },
        {
            key: "bind",
            value: function bind() {
                if ($a754a40140901e43$var$contrastModeMql && this.unbindContrastChangeListener === null) this.unbindContrastChangeListener = (0, $dd4sf.bind)($a754a40140901e43$var$contrastModeMql, {
                    type: "change",
                    listener: $a754a40140901e43$var$checkNativeListener
                });
            }
        },
        {
            key: "unbind",
            value: function unbind() {
                if (this.unbindContrastChangeListener) {
                    this.unbindContrastChangeListener();
                    this.unbindContrastChangeListener = null;
                }
            }
        }
    ]);
}();
/**
 * A singleton contrast mode observer - binds "auto" switching logic to a single `mediaQueryList` listener
 * that can be unbound by any consumer when no longer needed.
 */ var $a754a40140901e43$var$SingletonContrastModeObserver = new $a754a40140901e43$var$ContrastModeObserver();
var $a754a40140901e43$export$2e2bcd8739ae039 = $a754a40140901e43$var$SingletonContrastModeObserver;


function $b1d4f1669d5dcd9b$export$2e2bcd8739ae039(themeState) {
    if (themeState.colorMode === "auto") {
        // Set colorMode based on the user preference
        themeState.colorMode = (0, $31c94491f1a09e10$export$2e2bcd8739ae039).getColorMode();
        // Bind a listener (if one doesn't already exist) to keep colorMode updated
        (0, $31c94491f1a09e10$export$2e2bcd8739ae039).bind();
    } else (0, $31c94491f1a09e10$export$2e2bcd8739ae039).unbind();
    if ((0, $18rB9.fg)("platform_increased-contrast-themes")) {
        if (themeState.contrastMode === "auto") {
            // Set contrastMode based on the user preference
            themeState.contrastMode = (0, $a754a40140901e43$export$2e2bcd8739ae039).getContrastMode();
            // Bind a listener (if one doesn't already exist) to keep contrastMode updated
            (0, $a754a40140901e43$export$2e2bcd8739ae039).bind();
        } else (0, $a754a40140901e43$export$2e2bcd8739ae039).unbind();
    }
    var themeAttributes = (0, $da02656b26a4b648$export$2e2bcd8739ae039)(themeState);
    Object.entries(themeAttributes).forEach(function(_ref) {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($64Sai)))(_ref, 2), key = _ref2[0], value = _ref2[1];
        document.documentElement.setAttribute(key, value);
    });
    return function() {
        (0, $31c94491f1a09e10$export$2e2bcd8739ae039).unbind();
        if ((0, $18rB9.fg)("platform_increased-contrast-themes")) (0, $a754a40140901e43$export$2e2bcd8739ae039).unbind();
    };
}



var $84EaV = parcelRequire("84EaV");

var $cgqdi = parcelRequire("cgqdi");

var $18rB9 = parcelRequire("18rB9");

var $64Sai = parcelRequire("64Sai");

var $hSHEC = parcelRequire("hSHEC");
function $1057e50735884542$export$2e2bcd8739ae039(themeId) {
    var _Object$entries$find;
    return (_Object$entries$find = Object.entries((0, $hSHEC.default)).find(function(_ref) {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($64Sai)))(_ref, 2), increasesContrastFor = _ref2[1].increasesContrastFor;
        return increasesContrastFor === themeId;
    })) === null || _Object$entries$find === void 0 ? void 0 : _Object$entries$find[1].id;
}


var $fbdc9aec8db8aa81$export$dd6aeb7c823fc03d = function getThemePreferences(themeState) {
    var colorMode = themeState.colorMode, contrastMode = themeState.contrastMode, dark = themeState.dark, light = themeState.light, shape = themeState.shape, spacing = themeState.spacing, typography = themeState.typography;
    var autoColorModeThemes = [
        light,
        dark
    ];
    var themePreferences = [];
    if (colorMode === "auto") {
        if (contrastMode !== "no-preference" && (0, $18rB9.fg)("platform_increased-contrast-themes")) autoColorModeThemes.forEach(function(normalTheme) {
            var increasedContrastTheme = (0, $1057e50735884542$export$2e2bcd8739ae039)(normalTheme);
            if (increasedContrastTheme) autoColorModeThemes.push(increasedContrastTheme);
        });
        themePreferences.push.apply(themePreferences, autoColorModeThemes);
    } else {
        themePreferences.push(themeState[colorMode]);
        if (contrastMode !== "no-preference" && (0, $18rB9.fg)("platform_increased-contrast-themes")) {
            var increasedContrastTheme = (0, $1057e50735884542$export$2e2bcd8739ae039)(themeState[colorMode]);
            if (increasedContrastTheme) themePreferences.push(increasedContrastTheme);
        }
    }
    [
        shape,
        spacing,
        typography
    ].forEach(function(themeId) {
        if (themeId) themePreferences.push(themeId);
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($cgqdi)))(new Set(themePreferences));
};
var $fbdc9aec8db8aa81$export$5d76d7014f4a5d08 = function getThemeOverridePreferences(_themeState) {
    var themeOverridePreferences = [];
    return (0, (/*@__PURE__*/$parcel$interopDefault($cgqdi)))(new Set(themeOverridePreferences));
};



function $1b86c45d2581ee88$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $1b86c45d2581ee88$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $1b86c45d2581ee88$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $1b86c45d2581ee88$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $1b86c45d2581ee88$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $1b86c45d2581ee88$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}

/**
 * Sets the theme globally at runtime. This updates the `data-theme` and `data-color-mode` attributes on your page's <html> tag.
 *
 * @param {Object<string, string>} themeState The themes and color mode that should be applied.
 * @param {string} themeState.colorMode Determines which color theme is applied. If set to `auto`, the theme applied will be determined by the OS setting.
 * @param {string} themeState.contrastMode The contrast mode theme to be applied. If set to `auto`, the theme applied will be determined by the OS setting.set to `auto`, the theme applied will be determined by the OS setting.
 * @param {string} themeState.dark The color theme to be applied when the color mode resolves to 'dark'.
 * @param {string} themeState.light The color theme to be applied when the color mode resolves to 'light'.
 * @param {string} themeState.shape The shape theme to be applied.
 * @param {string} themeState.spacing The spacing theme to be applied.
 * @param {string} themeState.typography The typography theme to be applied.
 * @param {Object} themeState.UNSAFE_themeOptions The custom branding options to be used for custom theme generation
 * @param {function} themeLoader Callback function used to override the default theme loading functionality.
 *
 * @returns A Promise of an unbind function, that can be used to stop listening for changes to system theme.
 *
 * @example
 * ```
 * setGlobalTheme({colorMode: 'auto', light: 'light', dark: 'dark', spacing: 'spacing'});
 * ```
 */ var $1b86c45d2581ee88$var$setGlobalTheme = /*#__PURE__*/ function() {
    var _ref = (0, (/*@__PURE__*/$parcel$interopDefault($3eb93755e0c29936$exports)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($55f3f7993ef5ab08$exports))).mark(function _callee3() {
        var _ref2, _ref2$colorMode, colorMode, _ref2$contrastMode, contrastMode, _ref2$dark, dark, _ref2$light, light, _ref2$shape, shape, _ref2$spacing, spacing, _ref2$typography, typography, _ref2$UNSAFE_themeOpt, UNSAFE_themeOptions, themeLoader, themeState, themePreferences, loadingStrategy, loadingTasks, mode, attrOfMissingCustomStyles, themeOverridePreferences, _iterator, _step, themeId, autoUnbind, _args3 = arguments;
        return (0, (/*@__PURE__*/$parcel$interopDefault($55f3f7993ef5ab08$exports))).wrap(function _callee3$(_context3) {
            while(true)switch(_context3.prev = _context3.next){
                case 0:
                    _ref2 = _args3.length > 0 && _args3[0] !== undefined ? _args3[0] : {}, _ref2$colorMode = _ref2.colorMode, colorMode = _ref2$colorMode === void 0 ? (0, $hSHEC.themeStateDefaults)["colorMode"] : _ref2$colorMode, _ref2$contrastMode = _ref2.contrastMode, contrastMode = _ref2$contrastMode === void 0 ? (0, $hSHEC.themeStateDefaults)["contrastMode"] : _ref2$contrastMode, _ref2$dark = _ref2.dark, dark = _ref2$dark === void 0 ? (0, $hSHEC.themeStateDefaults)["dark"] : _ref2$dark, _ref2$light = _ref2.light, light = _ref2$light === void 0 ? (0, $hSHEC.themeStateDefaults)["light"] : _ref2$light, _ref2$shape = _ref2.shape, shape = _ref2$shape === void 0 ? (0, $hSHEC.themeStateDefaults)["shape"] : _ref2$shape, _ref2$spacing = _ref2.spacing, spacing = _ref2$spacing === void 0 ? (0, $hSHEC.themeStateDefaults)["spacing"] : _ref2$spacing, _ref2$typography = _ref2.typography, typography = _ref2$typography === void 0 ? (0, $hSHEC.themeStateDefaults)["typography"]() : _ref2$typography, _ref2$UNSAFE_themeOpt = _ref2.UNSAFE_themeOptions, UNSAFE_themeOptions = _ref2$UNSAFE_themeOpt === void 0 ? (0, $hSHEC.themeStateDefaults)["UNSAFE_themeOptions"] : _ref2$UNSAFE_themeOpt;
                    themeLoader = _args3.length > 1 ? _args3[1] : undefined;
                    // CLEANUP: Remove. This blocks application of increased contrast themes
                    // without the feature flag enabled.
                    if (!(0, $18rB9.fg)("platform_increased-contrast-themes")) {
                        if (light === "light-increased-contrast") light = "light";
                        if (dark === "dark-increased-contrast") dark = "dark";
                    }
                    themeState = {
                        colorMode: colorMode,
                        contrastMode: contrastMode,
                        dark: dark,
                        light: light,
                        shape: shape,
                        spacing: spacing,
                        typography: typography,
                        UNSAFE_themeOptions: themeLoader ? undefined : UNSAFE_themeOptions
                    }; // Determine what to load and loading strategy
                    themePreferences = (0, $fbdc9aec8db8aa81$export$dd6aeb7c823fc03d)(themeState);
                    loadingStrategy = themeLoader ? themeLoader : (0, $227251ce43ac6023$export$26cd7ae85c7144e5); // Load standard themes
                    loadingTasks = themePreferences.map(/*#__PURE__*/ function() {
                        var _ref3 = (0, (/*@__PURE__*/$parcel$interopDefault($3eb93755e0c29936$exports)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($55f3f7993ef5ab08$exports))).mark(function _callee(themeId) {
                            return (0, (/*@__PURE__*/$parcel$interopDefault($55f3f7993ef5ab08$exports))).wrap(function _callee$(_context) {
                                while(true)switch(_context.prev = _context.next){
                                    case 0:
                                        _context.next = 2;
                                        return loadingStrategy(themeId);
                                    case 2:
                                        return _context.abrupt("return", _context.sent);
                                    case 3:
                                    case "end":
                                        return _context.stop();
                                }
                            }, _callee);
                        }));
                        return function(_x) {
                            return _ref3.apply(this, arguments);
                        };
                    }()); // Load custom themes if needed
                    if (!themeLoader && UNSAFE_themeOptions && (0, $bCORa.isValidBrandHex)(UNSAFE_themeOptions === null || UNSAFE_themeOptions === void 0 ? void 0 : UNSAFE_themeOptions.brandColor)) {
                        mode = colorMode || (0, $hSHEC.themeStateDefaults)["colorMode"];
                        attrOfMissingCustomStyles = (0, $84EaV.findMissingCustomStyleElements)(UNSAFE_themeOptions, mode);
                        if (attrOfMissingCustomStyles.length > 0) // Load custom theme styles
                        loadingTasks.push((0, (/*@__PURE__*/$parcel$interopDefault($3eb93755e0c29936$exports)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($55f3f7993ef5ab08$exports))).mark(function _callee2() {
                            var _yield$import, loadAndAppendCustomThemeCss;
                            return (0, (/*@__PURE__*/$parcel$interopDefault($55f3f7993ef5ab08$exports))).wrap(function _callee2$(_context2) {
                                while(true)switch(_context2.prev = _context2.next){
                                    case 0:
                                        _context2.next = 2;
                                        return (parcelRequire("eckKF"));
                                    case 2:
                                        _yield$import = _context2.sent;
                                        loadAndAppendCustomThemeCss = _yield$import.loadAndAppendCustomThemeCss;
                                        loadAndAppendCustomThemeCss({
                                            colorMode: attrOfMissingCustomStyles.length === 2 ? "auto" : // only load the missing custom theme styles
                                            attrOfMissingCustomStyles[0],
                                            UNSAFE_themeOptions: UNSAFE_themeOptions
                                        });
                                    case 5:
                                    case "end":
                                        return _context2.stop();
                                }
                            }, _callee2);
                        }))());
                    }
                    _context3.next = 10;
                    return Promise.all(loadingTasks);
                case 10:
                    // Load override themes after standard themes
                    themeOverridePreferences = (0, $fbdc9aec8db8aa81$export$5d76d7014f4a5d08)(themeState);
                    _iterator = $1b86c45d2581ee88$var$_createForOfIteratorHelper(themeOverridePreferences);
                    _context3.prev = 12;
                    _iterator.s();
                case 14:
                    if ((_step = _iterator.n()).done) {
                        _context3.next = 20;
                        break;
                    }
                    themeId = _step.value;
                    _context3.next = 18;
                    return loadingStrategy(themeId);
                case 18:
                    _context3.next = 14;
                    break;
                case 20:
                    _context3.next = 25;
                    break;
                case 22:
                    _context3.prev = 22;
                    _context3.t0 = _context3["catch"](12);
                    _iterator.e(_context3.t0);
                case 25:
                    _context3.prev = 25;
                    _iterator.f();
                    return _context3.finish(25);
                case 28:
                    autoUnbind = (0, $b1d4f1669d5dcd9b$export$2e2bcd8739ae039)(themeState);
                    return _context3.abrupt("return", autoUnbind);
                case 30:
                case "end":
                    return _context3.stop();
            }
        }, _callee3, null, [
            [
                12,
                22,
                25,
                28
            ]
        ]);
    }));
    return function setGlobalTheme() {
        return _ref.apply(this, arguments);
    };
}();
var $1b86c45d2581ee88$export$2e2bcd8739ae039 = $1b86c45d2581ee88$var$setGlobalTheme;


const $5b1e29b530174d83$export$2db4d14f7453cf8e = ()=>{
    (0, $dAx5m.useLayoutEffect)(()=>{
        if ((0, $4ffTz.checkFeatureGate)((0, $4ffTz.FeatureGate).ENABLE_SETTINGS_MENU_AND_COLOR_THEMES)) {
            const currentTheme = window.localStorage.getItem("theme");
            if (currentTheme === "light" || currentTheme === "dark" || currentTheme === "auto") (0, $1b86c45d2581ee88$export$2e2bcd8739ae039)({
                colorMode: currentTheme,
                spacing: "spacing",
                shape: "shape"
            });
        }
    }, []);
};





var $bibO8 = parcelRequire("bibO8");

var $dAx5m = parcelRequire("dAx5m");
parcelRequire("jShba");
var $fjOHq = parcelRequire("fjOHq");
var $7pLec = parcelRequire("7pLec");
var $77YRX = parcelRequire("77YRX");
class $98e49059712ea403$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).Component {
    static getDerivedStateFromError(error) {
        // Update state so the next render will show the fallback UI.
        return {
            hasError: true
        };
    }
    componentDidCatch(error, errorInfo) {
        const { analytics: analytics } = this.props;
        (0, $77YRX.logException)(error, "Error caught in ErrorBoundary", {
            info: errorInfo,
            tags: {
                severity: "high"
            }
        });
        analytics.pushOperationalEvent({
            source: (0, $fjOHq.AnalyticsEventSource).CLIENT_METRICS,
            actionSubject: "errorBoundary",
            action: (0, $fjOHq.AnalyticsEventActions).TRIGGERED,
            attributes: {
                product: "manage-profile-app",
                boundary: "app",
                error: error.toString()
            },
            tags: [
                "error",
                "error-boundary"
            ]
        });
    }
    render() {
        if (!this.state.hasError) return this.props.children;
        return /*#__PURE__*/ (0, $bibO8.jsx)((0, $7pLec.GenericErrorPage), {
            hasSupportLink: true
        });
    }
    constructor(...args){
        super(...args);
        this.state = {
            hasError: false
        };
    }
}




parcelRequire("fYdPZ");
var $cZlBJ = parcelRequire("cZlBJ");

var $bibO8 = parcelRequire("bibO8");

var $dAx5m = parcelRequire("dAx5m");

var $lairn = parcelRequire("lairn");parcelRequire("5Zreo");
var $lairn = parcelRequire("lairn");
parcelRequire("jQGCp");
var $7PWYP = parcelRequire("7PWYP");

var $bibO8 = parcelRequire("bibO8");

var $dAx5m = parcelRequire("dAx5m");
var $26bb7fa76339df09$exports = {};
"use strict";

var $dAx5m = parcelRequire("dAx5m");

var $hyn2k = parcelRequire("hyn2k");
var $8fe1f1136b260f72$exports = {};
"use strict";
function $8fe1f1136b260f72$var$_interopDefault(ex) {
    return ex && typeof ex === "object" && "default" in ex ? ex["default"] : ex;
}

var $dAx5m = parcelRequire("dAx5m");
var $8fe1f1136b260f72$var$React__default = $8fe1f1136b260f72$var$_interopDefault($dAx5m);

var $8fe1f1136b260f72$var$ExecutionEnvironment = $8fe1f1136b260f72$var$_interopDefault((parcelRequire("5Fvus")));

var $8fe1f1136b260f72$var$shallowEqual = $8fe1f1136b260f72$var$_interopDefault((parcelRequire("fxo4p")));
function $8fe1f1136b260f72$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $8fe1f1136b260f72$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $8fe1f1136b260f72$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
function $8fe1f1136b260f72$var$withSideEffect(reducePropsToState, handleStateChangeOnClient, mapStateOnServer) {
    if (typeof reducePropsToState !== "function") throw new Error("Expected reducePropsToState to be a function.");
    if (typeof handleStateChangeOnClient !== "function") throw new Error("Expected handleStateChangeOnClient to be a function.");
    if (typeof mapStateOnServer !== "undefined" && typeof mapStateOnServer !== "function") throw new Error("Expected mapStateOnServer to either be undefined or a function.");
    function getDisplayName(WrappedComponent) {
        return WrappedComponent.displayName || WrappedComponent.name || "Component";
    }
    return function wrap(WrappedComponent) {
        if (typeof WrappedComponent !== "function") throw new Error("Expected WrappedComponent to be a React component.");
        var mountedInstances = [];
        var state = void 0;
        function emitChange() {
            state = reducePropsToState(mountedInstances.map(function(instance) {
                return instance.props;
            }));
            if (SideEffect.canUseDOM) handleStateChangeOnClient(state);
            else if (mapStateOnServer) state = mapStateOnServer(state);
        }
        var SideEffect = function(_Component) {
            $8fe1f1136b260f72$var$_inherits(SideEffect, _Component);
            function SideEffect() {
                $8fe1f1136b260f72$var$_classCallCheck(this, SideEffect);
                return $8fe1f1136b260f72$var$_possibleConstructorReturn(this, _Component.apply(this, arguments));
            }
            // Try to use displayName of wrapped component
            SideEffect.peek = function peek() {
                return state;
            };
            // Expose canUseDOM so tests can monkeypatch it
            SideEffect.rewind = function rewind() {
                if (SideEffect.canUseDOM) throw new Error("You may only call rewind() on the server. Call peek() to read the current state.");
                var recordedState = state;
                state = undefined;
                mountedInstances = [];
                return recordedState;
            };
            SideEffect.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
                return !$8fe1f1136b260f72$var$shallowEqual(nextProps, this.props);
            };
            SideEffect.prototype.componentWillMount = function componentWillMount() {
                mountedInstances.push(this);
                emitChange();
            };
            SideEffect.prototype.componentDidUpdate = function componentDidUpdate() {
                emitChange();
            };
            SideEffect.prototype.componentWillUnmount = function componentWillUnmount() {
                var index = mountedInstances.indexOf(this);
                mountedInstances.splice(index, 1);
                emitChange();
            };
            SideEffect.prototype.render = function render() {
                return $8fe1f1136b260f72$var$React__default.createElement(WrappedComponent, this.props);
            };
            return SideEffect;
        }($dAx5m.Component);
        SideEffect.displayName = "SideEffect(" + getDisplayName(WrappedComponent) + ")";
        SideEffect.canUseDOM = $8fe1f1136b260f72$var$ExecutionEnvironment.canUseDOM;
        return SideEffect;
    };
}
$8fe1f1136b260f72$exports = $8fe1f1136b260f72$var$withSideEffect;


function $26bb7fa76339df09$var$reducePropsToState(propsList) {
    var innermostProps = propsList[propsList.length - 1];
    if (innermostProps) return innermostProps.title;
}
function $26bb7fa76339df09$var$handleStateChangeOnClient(title) {
    var nextTitle = title || "";
    if (nextTitle !== document.title) document.title = nextTitle;
}
function $26bb7fa76339df09$var$DocumentTitle() {}
$26bb7fa76339df09$var$DocumentTitle.prototype = Object.create($dAx5m.Component.prototype);
$26bb7fa76339df09$var$DocumentTitle.displayName = "DocumentTitle";
$26bb7fa76339df09$var$DocumentTitle.propTypes = {
    title: $hyn2k.string.isRequired
};
$26bb7fa76339df09$var$DocumentTitle.prototype.render = function() {
    if (this.props.children) return $dAx5m.Children.only(this.props.children);
    else return null;
};
$26bb7fa76339df09$exports = $8fe1f1136b260f72$exports($26bb7fa76339df09$var$reducePropsToState, $26bb7fa76339df09$var$handleStateChangeOnClient)($26bb7fa76339df09$var$DocumentTitle);



var $lKhJJ = parcelRequire("lKhJJ");
var $55TWT = parcelRequire("55TWT");
var $dZHnD = parcelRequire("dZHnD");

var $5Zreo = parcelRequire("5Zreo");
var $lairn = parcelRequire("lairn");

var $6qH56 = parcelRequire("6qH56");

var $dViVv = parcelRequire("dViVv");

var $5Xjg2 = parcelRequire("5Xjg2");
/** @jsx jsx */ 
var $jVTBW = parcelRequire("jVTBW");
var $659b468336d903e3$exports = {};
var $50ecce5f2a920896$exports = {};
var $a5e7ba7423f4d949$exports = {};
function $a5e7ba7423f4d949$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $a5e7ba7423f4d949$exports = $a5e7ba7423f4d949$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $a5e7ba7423f4d949$exports.__esModule = true, $a5e7ba7423f4d949$exports["default"] = $a5e7ba7423f4d949$exports, $a5e7ba7423f4d949$var$_typeof(o);
}
$a5e7ba7423f4d949$exports = $a5e7ba7423f4d949$var$_typeof, $a5e7ba7423f4d949$exports.__esModule = true, $a5e7ba7423f4d949$exports["default"] = $a5e7ba7423f4d949$exports;


var $50ecce5f2a920896$var$_typeof = $a5e7ba7423f4d949$exports.default;
var $176842f706e09463$exports = {};

var $176842f706e09463$var$_typeof = $a5e7ba7423f4d949$exports.default;
function $176842f706e09463$var$toPrimitive(t, r) {
    if ("object" != $176842f706e09463$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $176842f706e09463$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
$176842f706e09463$exports = $176842f706e09463$var$toPrimitive, $176842f706e09463$exports.__esModule = true, $176842f706e09463$exports["default"] = $176842f706e09463$exports;


function $50ecce5f2a920896$var$toPropertyKey(t) {
    var i = $176842f706e09463$exports(t, "string");
    return "symbol" == $50ecce5f2a920896$var$_typeof(i) ? i : i + "";
}
$50ecce5f2a920896$exports = $50ecce5f2a920896$var$toPropertyKey, $50ecce5f2a920896$exports.__esModule = true, $50ecce5f2a920896$exports["default"] = $50ecce5f2a920896$exports;


function $659b468336d903e3$var$_defineProperty(e, r, t) {
    return (r = $50ecce5f2a920896$exports(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
$659b468336d903e3$exports = $659b468336d903e3$var$_defineProperty, $659b468336d903e3$exports.__esModule = true, $659b468336d903e3$exports["default"] = $659b468336d903e3$exports;



var $dAx5m = parcelRequire("dAx5m");

var $dAx5m = parcelRequire("dAx5m");
var $5045c954f65507ac$var$_ref, $5045c954f65507ac$var$_process, $5045c954f65507ac$var$_process2;
// We can't rely on NODE_ENV === 'test' if its value is already configured by the consumer to some other value, so better to use JEST_WORKER_ID
// https://jestjs.io/docs/environment-variables#jest_worker_id
var $5045c954f65507ac$var$TESTS_MODE = ($5045c954f65507ac$var$_ref = (globalThis === null || globalThis === void 0 || ($5045c954f65507ac$var$_process = globalThis.process) === null || $5045c954f65507ac$var$_process === void 0 || ($5045c954f65507ac$var$_process = $5045c954f65507ac$var$_process.env) === null || $5045c954f65507ac$var$_process === void 0 ? void 0 : $5045c954f65507ac$var$_process.JEST_WORKER_ID) !== undefined, $5045c954f65507ac$var$_ref !== void 0) ? $5045c954f65507ac$var$_ref : false;
var $5045c954f65507ac$var$DEBUG_MODE = !$5045c954f65507ac$var$TESTS_MODE && (globalThis === null || globalThis === void 0 || ($5045c954f65507ac$var$_process2 = globalThis.process) === null || $5045c954f65507ac$var$_process2 === void 0 || ($5045c954f65507ac$var$_process2 = $5045c954f65507ac$var$_process2.env) === null || $5045c954f65507ac$var$_process2 === void 0 ? void 0 : $5045c954f65507ac$var$_process2.NODE_ENV) !== "production";
var $5045c954f65507ac$export$1c9f709888824e05 = function debug() {
    var _console;
    if (!$5045c954f65507ac$var$DEBUG_MODE) return;
    // eslint-disable-next-line no-console
    (_console = console).debug.apply(_console, arguments);
};



var $ahJoN = parcelRequire("ahJoN");
var $85b5a3e3c1cd608b$var$pkgName = "@atlaskit/platform-feature-flags";
var $85b5a3e3c1cd608b$export$7e41b1b2bdee3f98 = "__PLATFORM_FEATURE_FLAGS__";
var $85b5a3e3c1cd608b$var$hasProcessEnv = typeof $ahJoN !== "undefined" && typeof $ahJoN.env !== "undefined";
// FF global overrides can be configured by test runners or Storybook
var $85b5a3e3c1cd608b$var$ENV_ENABLE_PLATFORM_FF = $85b5a3e3c1cd608b$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
// STORYBOOK_ENABLE_PLATFORM_FF is included as storybook only allows env vars prefixed with STORYBOOK
// https://github.com/storybookjs/storybook/issues/12270
var $85b5a3e3c1cd608b$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF = $85b5a3e3c1cd608b$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
var $85b5a3e3c1cd608b$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE = $85b5a3e3c1cd608b$var$ENV_ENABLE_PLATFORM_FF || $85b5a3e3c1cd608b$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF;
var $85b5a3e3c1cd608b$var$DEFAULT_PFF_GLOBAL = {
    // In development mode we want to capture any feature flag checks that happen using the default resolver and log this result when the resolver is replaced.
    // This is because evaluating feature flags when the resolver/FF client is loaded asynchronously could cause unexpected issues.
    earlyResolvedFlags: new Map(),
    booleanResolver: function booleanResolver(flagKey) {
        var unresolvedFlagCount;
        return false;
    }
};
var $85b5a3e3c1cd608b$var$globalVar = typeof window !== "undefined" ? window : globalThis;
$85b5a3e3c1cd608b$var$globalVar[$85b5a3e3c1cd608b$export$7e41b1b2bdee3f98] = $85b5a3e3c1cd608b$var$globalVar[$85b5a3e3c1cd608b$export$7e41b1b2bdee3f98] || $85b5a3e3c1cd608b$var$DEFAULT_PFF_GLOBAL;
function $85b5a3e3c1cd608b$export$f2b591175b3e424c(resolver) {
    $85b5a3e3c1cd608b$var$globalVar[$85b5a3e3c1cd608b$export$7e41b1b2bdee3f98].booleanResolver = resolver;
    var _globalVar$PFF_GLOBAL;
}
function $85b5a3e3c1cd608b$export$6333b6aff9fc6275(flagKey) {
    if ($85b5a3e3c1cd608b$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE) {
        (0, $5045c954f65507ac$export$1c9f709888824e05)('[%s]: The feature flags were enabled while running tests. The flag "%s" will be always enabled.', $85b5a3e3c1cd608b$var$pkgName, flagKey);
        return true;
    }
    try {
        var _globalVar$PFF_GLOBAL2;
        var result = (_globalVar$PFF_GLOBAL2 = $85b5a3e3c1cd608b$var$globalVar[$85b5a3e3c1cd608b$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL2 === void 0 ? void 0 : _globalVar$PFF_GLOBAL2.booleanResolver(flagKey);
        if (typeof result !== "boolean") {
            // eslint-disable-next-line no-console
            console.warn("".concat(flagKey, " resolved to a non-boolean value, returning false for safety"));
            return false;
        }
        return result;
    } catch (e) {
        return false;
    }
}


function $fa11bbf67da7a934$export$ba05d765b8392e5e(flagResolver) {
    (0, $85b5a3e3c1cd608b$export$f2b591175b3e424c)(flagResolver);
}
function $fa11bbf67da7a934$export$470e5c2be1411c89(name) {
    return (0, $85b5a3e3c1cd608b$export$6333b6aff9fc6275)(name);
}
function $fa11bbf67da7a934$export$b40ec24ac8275656(name) {
    return (0, $85b5a3e3c1cd608b$export$6333b6aff9fc6275)(name);
}



var $ahJoN = parcelRequire("ahJoN");
var $3035ca1dc5568ab9$var$_process$env;
var $3035ca1dc5568ab9$export$2e2bcd8739ae039 = typeof $ahJoN !== "undefined" && $ahJoN !== null && (($3035ca1dc5568ab9$var$_process$env = {}, $3035ca1dc5568ab9$var$_process$env === void 0) ? void 0 : $3035ca1dc5568ab9$var$_process$env["ANALYTICS_NEXT_MODERN_CONTEXT"]);


var $753005c0c019cc18$exports = {};
var $4673aa62481ab682$exports = {};
var $0c4a454410fafe59$exports = {};
function $0c4a454410fafe59$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
$0c4a454410fafe59$exports = $0c4a454410fafe59$var$_arrayLikeToArray, $0c4a454410fafe59$exports.__esModule = true, $0c4a454410fafe59$exports["default"] = $0c4a454410fafe59$exports;


function $4673aa62481ab682$var$_arrayWithoutHoles(r) {
    if (Array.isArray(r)) return $0c4a454410fafe59$exports(r);
}
$4673aa62481ab682$exports = $4673aa62481ab682$var$_arrayWithoutHoles, $4673aa62481ab682$exports.__esModule = true, $4673aa62481ab682$exports["default"] = $4673aa62481ab682$exports;


var $040720236fd2ed0c$exports = {};
function $040720236fd2ed0c$var$_iterableToArray(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
$040720236fd2ed0c$exports = $040720236fd2ed0c$var$_iterableToArray, $040720236fd2ed0c$exports.__esModule = true, $040720236fd2ed0c$exports["default"] = $040720236fd2ed0c$exports;


var $a6d1ee6d681d70fa$exports = {};

function $a6d1ee6d681d70fa$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $0c4a454410fafe59$exports(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $0c4a454410fafe59$exports(r, a) : void 0;
    }
}
$a6d1ee6d681d70fa$exports = $a6d1ee6d681d70fa$var$_unsupportedIterableToArray, $a6d1ee6d681d70fa$exports.__esModule = true, $a6d1ee6d681d70fa$exports["default"] = $a6d1ee6d681d70fa$exports;


var $e0f1f628b220467a$exports = {};
function $e0f1f628b220467a$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
$e0f1f628b220467a$exports = $e0f1f628b220467a$var$_nonIterableSpread, $e0f1f628b220467a$exports.__esModule = true, $e0f1f628b220467a$exports["default"] = $e0f1f628b220467a$exports;


function $753005c0c019cc18$var$_toConsumableArray(r) {
    return $4673aa62481ab682$exports(r) || $040720236fd2ed0c$exports(r) || $a6d1ee6d681d70fa$exports(r) || $e0f1f628b220467a$exports();
}
$753005c0c019cc18$exports = $753005c0c019cc18$var$_toConsumableArray, $753005c0c019cc18$exports.__esModule = true, $753005c0c019cc18$exports["default"] = $753005c0c019cc18$exports;


var $840057b0a8ac24e4$exports = {};
function $840057b0a8ac24e4$var$_classCallCheck(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
$840057b0a8ac24e4$exports = $840057b0a8ac24e4$var$_classCallCheck, $840057b0a8ac24e4$exports.__esModule = true, $840057b0a8ac24e4$exports["default"] = $840057b0a8ac24e4$exports;


var $2acdb663cf966f60$exports = {};

function $2acdb663cf966f60$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, $50ecce5f2a920896$exports(o.key), o);
    }
}
function $2acdb663cf966f60$var$_createClass(e, r, t) {
    return r && $2acdb663cf966f60$var$_defineProperties(e.prototype, r), t && $2acdb663cf966f60$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}
$2acdb663cf966f60$exports = $2acdb663cf966f60$var$_createClass, $2acdb663cf966f60$exports.__esModule = true, $2acdb663cf966f60$exports["default"] = $2acdb663cf966f60$exports;


var $0e21e01afc3a739e$exports = {};
function $0e21e01afc3a739e$var$_assertThisInitialized(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}
$0e21e01afc3a739e$exports = $0e21e01afc3a739e$var$_assertThisInitialized, $0e21e01afc3a739e$exports.__esModule = true, $0e21e01afc3a739e$exports["default"] = $0e21e01afc3a739e$exports;


var $d2a9048bb4b38f76$exports = {};
var $a1fa86528bbd4a2e$exports = {};
function $a1fa86528bbd4a2e$var$_setPrototypeOf(t, e) {
    return $a1fa86528bbd4a2e$exports = $a1fa86528bbd4a2e$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $a1fa86528bbd4a2e$exports.__esModule = true, $a1fa86528bbd4a2e$exports["default"] = $a1fa86528bbd4a2e$exports, $a1fa86528bbd4a2e$var$_setPrototypeOf(t, e);
}
$a1fa86528bbd4a2e$exports = $a1fa86528bbd4a2e$var$_setPrototypeOf, $a1fa86528bbd4a2e$exports.__esModule = true, $a1fa86528bbd4a2e$exports["default"] = $a1fa86528bbd4a2e$exports;


function $d2a9048bb4b38f76$var$_inherits(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && $a1fa86528bbd4a2e$exports(t, e);
}
$d2a9048bb4b38f76$exports = $d2a9048bb4b38f76$var$_inherits, $d2a9048bb4b38f76$exports.__esModule = true, $d2a9048bb4b38f76$exports["default"] = $d2a9048bb4b38f76$exports;


var $e7dca18d1e5e3b81$exports = {};

var $e7dca18d1e5e3b81$var$_typeof = $a5e7ba7423f4d949$exports.default;

function $e7dca18d1e5e3b81$var$_possibleConstructorReturn(t, e) {
    if (e && ("object" == $e7dca18d1e5e3b81$var$_typeof(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return $0e21e01afc3a739e$exports(t);
}
$e7dca18d1e5e3b81$exports = $e7dca18d1e5e3b81$var$_possibleConstructorReturn, $e7dca18d1e5e3b81$exports.__esModule = true, $e7dca18d1e5e3b81$exports["default"] = $e7dca18d1e5e3b81$exports;


var $0fffda067e78c05f$exports = {};
function $0fffda067e78c05f$var$_getPrototypeOf(t) {
    return $0fffda067e78c05f$exports = $0fffda067e78c05f$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, $0fffda067e78c05f$exports.__esModule = true, $0fffda067e78c05f$exports["default"] = $0fffda067e78c05f$exports, $0fffda067e78c05f$var$_getPrototypeOf(t);
}
$0fffda067e78c05f$exports = $0fffda067e78c05f$var$_getPrototypeOf, $0fffda067e78c05f$exports.__esModule = true, $0fffda067e78c05f$exports["default"] = $0fffda067e78c05f$exports;




var $dAx5m = parcelRequire("dAx5m");

var $hyn2k = parcelRequire("hyn2k");

var $h0bf1 = parcelRequire("h0bf1");
function $38b790c9e9355b2f$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $38b790c9e9355b2f$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, (/*@__PURE__*/$parcel$interopDefault($0fffda067e78c05f$exports)))(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, (/*@__PURE__*/$parcel$interopDefault($0fffda067e78c05f$exports)))(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, (/*@__PURE__*/$parcel$interopDefault($e7dca18d1e5e3b81$exports)))(this, result);
    };
}
function $38b790c9e9355b2f$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($38b790c9e9355b2f$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $38b790c9e9355b2f$var$ContextTypes = {
    getAtlaskitAnalyticsContext: (0, (/*@__PURE__*/$parcel$interopDefault($hyn2k))).func,
    getAtlaskitAnalyticsEventHandlers: (0, (/*@__PURE__*/$parcel$interopDefault($hyn2k))).func
};
var $38b790c9e9355b2f$var$noop = function noop() {
    return [];
};
// eslint-disable-next-line @repo/internal/react/no-class-components
var $38b790c9e9355b2f$var$AnalyticsContext = /*#__PURE__*/ function(_Component) {
    (0, (/*@__PURE__*/$parcel$interopDefault($d2a9048bb4b38f76$exports)))(AnalyticsContext, _Component);
    var _super = $38b790c9e9355b2f$var$_createSuper(AnalyticsContext);
    function AnalyticsContext(props) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($840057b0a8ac24e4$exports)))(this, AnalyticsContext);
        _this = _super.call(this, props);
        (0, (/*@__PURE__*/$parcel$interopDefault($659b468336d903e3$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($0e21e01afc3a739e$exports)))(_this), "getChildContext", function() {
            return {
                getAtlaskitAnalyticsContext: _this.getAnalyticsContext
            };
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($659b468336d903e3$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($0e21e01afc3a739e$exports)))(_this), "getAnalyticsContext", function() {
            var data = _this.props.data;
            var _this$context$getAtla = _this.context.getAtlaskitAnalyticsContext, getAtlaskitAnalyticsContext = _this$context$getAtla === void 0 ? $38b790c9e9355b2f$var$noop : _this$context$getAtla;
            return [].concat((0, (/*@__PURE__*/$parcel$interopDefault($753005c0c019cc18$exports)))(getAtlaskitAnalyticsContext()), [
                data
            ]);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($659b468336d903e3$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($0e21e01afc3a739e$exports)))(_this), "getAnalyticsEventHandlers", function() {
            var _this$context$getAtla2 = _this.context.getAtlaskitAnalyticsEventHandlers, getAtlaskitAnalyticsEventHandlers = _this$context$getAtla2 === void 0 ? $38b790c9e9355b2f$var$noop : _this$context$getAtla2;
            return getAtlaskitAnalyticsEventHandlers();
        });
        _this.contextValue = {
            getAtlaskitAnalyticsContext: _this.getAnalyticsContext,
            getAtlaskitAnalyticsEventHandlers: _this.getAnalyticsEventHandlers
        };
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($2acdb663cf966f60$exports)))(AnalyticsContext, [
        {
            key: "render",
            value: function render() {
                var children = this.props.children;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $h0bf1.default).Provider, {
                    value: this.contextValue
                }, children);
            }
        }
    ]);
    return AnalyticsContext;
}((0, $dAx5m.Component));
(0, (/*@__PURE__*/$parcel$interopDefault($659b468336d903e3$exports)))($38b790c9e9355b2f$var$AnalyticsContext, "contextTypes", $38b790c9e9355b2f$var$ContextTypes);
(0, (/*@__PURE__*/$parcel$interopDefault($659b468336d903e3$exports)))($38b790c9e9355b2f$var$AnalyticsContext, "childContextTypes", $38b790c9e9355b2f$var$ContextTypes);
var $38b790c9e9355b2f$export$2e2bcd8739ae039 = $38b790c9e9355b2f$var$AnalyticsContext;




var $dAx5m = parcelRequire("dAx5m");

var $h0bf1 = parcelRequire("h0bf1");

var $dAx5m = parcelRequire("dAx5m");

var $h0bf1 = parcelRequire("h0bf1");
var $76d1caf681957871$export$d1f587f82ad51c4 = function useAnalyticsContext() {
    return (0, $dAx5m.useContext)((0, $h0bf1.default));
};



var $dAx5m = parcelRequire("dAx5m");
var $f59d8a2be817b0a3$export$1d27a74659855e44 = function useTrackedRef(value) {
    var ref = (0, $dAx5m.useRef)(value);
    ref.current = value;
    return ref;
};


var $3fbb5eca5cc1e22b$var$AnalyticsContext = function AnalyticsContext(_ref) {
    var data = _ref.data, children = _ref.children;
    var dataRef = (0, $f59d8a2be817b0a3$export$1d27a74659855e44)(data);
    var _useAnalyticsContext = (0, $76d1caf681957871$export$d1f587f82ad51c4)(), getAtlaskitAnalyticsEventHandlers = _useAnalyticsContext.getAtlaskitAnalyticsEventHandlers, getOriginalAnalyticsContext = _useAnalyticsContext.getAtlaskitAnalyticsContext;
    var getAtlaskitAnalyticsContext = (0, $dAx5m.useCallback)(function() {
        return [].concat((0, (/*@__PURE__*/$parcel$interopDefault($753005c0c019cc18$exports)))(getOriginalAnalyticsContext()), [
            dataRef.current
        ]);
    }, [
        getOriginalAnalyticsContext,
        dataRef
    ]);
    var value = (0, $dAx5m.useMemo)(function() {
        return {
            getAtlaskitAnalyticsContext: getAtlaskitAnalyticsContext,
            getAtlaskitAnalyticsEventHandlers: getAtlaskitAnalyticsEventHandlers
        };
    }, [
        getAtlaskitAnalyticsContext,
        getAtlaskitAnalyticsEventHandlers
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $h0bf1.default).Provider, {
        value: value
    }, children);
};
var $3fbb5eca5cc1e22b$export$2e2bcd8739ae039 = $3fbb5eca5cc1e22b$var$AnalyticsContext;


var $042d5e071181fd5d$var$ExportedAnalyticsContext = function ExportedAnalyticsContext(props) {
    var isModernContext = (0, $3035ca1dc5568ab9$export$2e2bcd8739ae039) || (0, $fa11bbf67da7a934$export$b40ec24ac8275656)("platform.analytics-next-use-modern-context_fqgbx");
    return isModernContext ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $3fbb5eca5cc1e22b$export$2e2bcd8739ae039), props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $38b790c9e9355b2f$export$2e2bcd8739ae039), props);
};
var $042d5e071181fd5d$export$2e2bcd8739ae039 = $042d5e071181fd5d$var$ExportedAnalyticsContext;


var $d8ae4f29192cf49c$var$createNamespaceContext = function createNamespaceContext(namespace) {
    var displayName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "NamespacedContext";
    var Component = function Component(props) {
        var newData = (0, (/*@__PURE__*/$parcel$interopDefault($659b468336d903e3$exports)))({}, namespace, props.data);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $042d5e071181fd5d$export$2e2bcd8739ae039), {
            data: newData
        }, (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).Children.only(props.children));
    };
    Component.displayName = displayName;
    return Component;
};
var $d8ae4f29192cf49c$export$2e2bcd8739ae039 = $d8ae4f29192cf49c$var$createNamespaceContext;


var $8d49c434cfa97775$export$80450e0a84a5ede9 = "fabricElementsCtx";
var $8d49c434cfa97775$export$3fe25500478a635c = (0, $d8ae4f29192cf49c$export$2e2bcd8739ae039)($8d49c434cfa97775$export$80450e0a84a5ede9, "FabricElementsAnalyticsContext");



var $12b8a4963edf4e39$export$1fd3aad76a7c6788 = "navigationCtx";
var $12b8a4963edf4e39$export$d0a82da1a0b94929 = (0, $d8ae4f29192cf49c$export$2e2bcd8739ae039)($12b8a4963edf4e39$export$1fd3aad76a7c6788, "NavigationAnalyticsContext");



var $d4d3dc2faf7efceb$export$8c8f6d8f1fa796f0 = "fabricEditorCtx";
var $d4d3dc2faf7efceb$export$9eb2b47430ed3f7c = /*#__PURE__*/ function(EDITOR_APPEARANCE_CONTEXT) {
    EDITOR_APPEARANCE_CONTEXT["FIXED_WIDTH"] = "fixedWidth";
    EDITOR_APPEARANCE_CONTEXT["FULL_WIDTH"] = "fullWidth";
    EDITOR_APPEARANCE_CONTEXT["COMMENT"] = "comment";
    EDITOR_APPEARANCE_CONTEXT["CHROMELESS"] = "chromeless";
    EDITOR_APPEARANCE_CONTEXT["MOBILE"] = "mobile";
    return EDITOR_APPEARANCE_CONTEXT;
}({});
var $d4d3dc2faf7efceb$export$629cada6c5e621e1 = (0, $d8ae4f29192cf49c$export$2e2bcd8739ae039)($d4d3dc2faf7efceb$export$8c8f6d8f1fa796f0, "FabricEditorAnalyticsContext");


// Media uses a namespaced analytics context under the following key MEDIA_CONTEXT.
var $ea9a0affc933a408$export$70df29c238ba7306 = "mediaCtx"; // However we don't export any JSX component to create that namespaced analytics context.
 // In media components, analytics context is being created by this component:
 // @see packages/media/media-common/src/analytics/withMediaAnalyticsContext.tsx



var $297414b21bef3a97$export$b326383bee6cb993 = "peopleTeamsCtx";
var $297414b21bef3a97$export$4119ddb38ccbfb87 = (0, $d8ae4f29192cf49c$export$2e2bcd8739ae039)($297414b21bef3a97$export$b326383bee6cb993, "PeopleTeamsAnalyticsContext");



var $66efc5493f5b7cc4$export$da1befb791e93c7e = "NotificationsCtx";
var $66efc5493f5b7cc4$export$6f8e7ff1e3feafd7 = (0, $d8ae4f29192cf49c$export$2e2bcd8739ae039)($66efc5493f5b7cc4$export$da1befb791e93c7e, "NotificationsAnalyticsContext");



var $5682e58ab0be0521$export$fc7a65795610cb71 = "RecentWorkCtx";
var $5682e58ab0be0521$export$745926731087ebe2 = (0, $d8ae4f29192cf49c$export$2e2bcd8739ae039)($5682e58ab0be0521$export$fc7a65795610cb71, "RecentWorkAnalyticsContext");



var $4ac29d0187628161$export$4906017439f33fc0 = "atlasCtx";
var $4ac29d0187628161$export$43ebbe41370d4543 = (0, $d8ae4f29192cf49c$export$2e2bcd8739ae039)($4ac29d0187628161$export$4906017439f33fc0, "AtlasAnalyticsContext");



var $e8d490cf14f595e8$export$3240443bf2b83834 = "linkingPlatformCtx";
var $e8d490cf14f595e8$export$6d568da622ce0a08 = (0, $d8ae4f29192cf49c$export$2e2bcd8739ae039)($e8d490cf14f595e8$export$3240443bf2b83834, "LinkingPlatformAnalyticsContext");



var $843586062fc2bc80$export$ef0c05448f0f8f9 = "postOfficeCtx";
var $843586062fc2bc80$export$dcd232f3be312f94 = (0, $d8ae4f29192cf49c$export$2e2bcd8739ae039)($843586062fc2bc80$export$ef0c05448f0f8f9, "PostOfficeAnalyticsContext");



var $1a9d2594950f76f5$export$5c3a6fd8b96e8b66 = "aiMateCtx";
var $1a9d2594950f76f5$export$de3826c30468da26 = (0, $d8ae4f29192cf49c$export$2e2bcd8739ae039)($1a9d2594950f76f5$export$5c3a6fd8b96e8b66, "AIMateAnalyticsContext");




var $aaeeadb2235b63b4$var$_ref, $aaeeadb2235b63b4$var$_process, $aaeeadb2235b63b4$var$_process2;
// We can't rely on NODE_ENV === 'test' if its value is already configured by the consumer to some other value, so better to use JEST_WORKER_ID
// https://jestjs.io/docs/environment-variables#jest_worker_id
var $aaeeadb2235b63b4$var$TESTS_MODE = ($aaeeadb2235b63b4$var$_ref = (globalThis === null || globalThis === void 0 || ($aaeeadb2235b63b4$var$_process = globalThis.process) === null || $aaeeadb2235b63b4$var$_process === void 0 || ($aaeeadb2235b63b4$var$_process = $aaeeadb2235b63b4$var$_process.env) === null || $aaeeadb2235b63b4$var$_process === void 0 ? void 0 : $aaeeadb2235b63b4$var$_process.JEST_WORKER_ID) !== undefined, $aaeeadb2235b63b4$var$_ref !== void 0) ? $aaeeadb2235b63b4$var$_ref : false;
var $aaeeadb2235b63b4$var$DEBUG_MODE = !$aaeeadb2235b63b4$var$TESTS_MODE && (globalThis === null || globalThis === void 0 || ($aaeeadb2235b63b4$var$_process2 = globalThis.process) === null || $aaeeadb2235b63b4$var$_process2 === void 0 || ($aaeeadb2235b63b4$var$_process2 = $aaeeadb2235b63b4$var$_process2.env) === null || $aaeeadb2235b63b4$var$_process2 === void 0 ? void 0 : $aaeeadb2235b63b4$var$_process2.NODE_ENV) !== "production";
var $aaeeadb2235b63b4$export$1c9f709888824e05 = function debug() {
    var _console;
    if (!$aaeeadb2235b63b4$var$DEBUG_MODE) return;
    // eslint-disable-next-line no-console
    (_console = console).debug.apply(_console, arguments);
};



var $ahJoN = parcelRequire("ahJoN");
var $df7fb4e8d807ffae$var$pkgName = "@atlaskit/platform-feature-flags";
var $df7fb4e8d807ffae$export$7e41b1b2bdee3f98 = "__PLATFORM_FEATURE_FLAGS__";
var $df7fb4e8d807ffae$var$hasProcessEnv = typeof $ahJoN !== "undefined" && typeof $ahJoN.env !== "undefined";
// FF global overrides can be configured by test runners or Storybook
var $df7fb4e8d807ffae$var$ENV_ENABLE_PLATFORM_FF = $df7fb4e8d807ffae$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
// STORYBOOK_ENABLE_PLATFORM_FF is included as storybook only allows env vars prefixed with STORYBOOK
// https://github.com/storybookjs/storybook/issues/12270
var $df7fb4e8d807ffae$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF = $df7fb4e8d807ffae$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
var $df7fb4e8d807ffae$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE = $df7fb4e8d807ffae$var$ENV_ENABLE_PLATFORM_FF || $df7fb4e8d807ffae$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF;
var $df7fb4e8d807ffae$var$DEFAULT_PFF_GLOBAL = {
    // In development mode we want to capture any feature flag checks that happen using the default resolver and log this result when the resolver is replaced.
    // This is because evaluating feature flags when the resolver/FF client is loaded asynchronously could cause unexpected issues.
    earlyResolvedFlags: new Map(),
    booleanResolver: function booleanResolver(flagKey) {
        var unresolvedFlagCount;
        return false;
    }
};
var $df7fb4e8d807ffae$var$globalVar = typeof window !== "undefined" ? window : globalThis;
$df7fb4e8d807ffae$var$globalVar[$df7fb4e8d807ffae$export$7e41b1b2bdee3f98] = $df7fb4e8d807ffae$var$globalVar[$df7fb4e8d807ffae$export$7e41b1b2bdee3f98] || $df7fb4e8d807ffae$var$DEFAULT_PFF_GLOBAL;
function $df7fb4e8d807ffae$export$f2b591175b3e424c(resolver) {
    $df7fb4e8d807ffae$var$globalVar[$df7fb4e8d807ffae$export$7e41b1b2bdee3f98].booleanResolver = resolver;
    var _globalVar$PFF_GLOBAL;
}
function $df7fb4e8d807ffae$export$6333b6aff9fc6275(flagKey) {
    if ($df7fb4e8d807ffae$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE) {
        (0, $aaeeadb2235b63b4$export$1c9f709888824e05)('[%s]: The feature flags were enabled while running tests. The flag "%s" will be always enabled.', $df7fb4e8d807ffae$var$pkgName, flagKey);
        return true;
    }
    try {
        var _globalVar$PFF_GLOBAL2;
        var result = (_globalVar$PFF_GLOBAL2 = $df7fb4e8d807ffae$var$globalVar[$df7fb4e8d807ffae$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL2 === void 0 ? void 0 : _globalVar$PFF_GLOBAL2.booleanResolver(flagKey);
        if (typeof result !== "boolean") {
            // eslint-disable-next-line no-console
            console.warn("".concat(flagKey, " resolved to a non-boolean value, returning false for safety"));
            return false;
        }
        return result;
    } catch (e) {
        return false;
    }
}


function $af5ef12ad3f1989a$export$ba05d765b8392e5e(flagResolver) {
    (0, $df7fb4e8d807ffae$export$f2b591175b3e424c)(flagResolver);
}
function $af5ef12ad3f1989a$export$470e5c2be1411c89(name) {
    return (0, $df7fb4e8d807ffae$export$6333b6aff9fc6275)(name);
}
function $af5ef12ad3f1989a$export$b40ec24ac8275656(name) {
    return (0, $df7fb4e8d807ffae$export$6333b6aff9fc6275)(name);
}


/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ /* eslint-disable prefer-rest-params */ 
var $e2xkU = parcelRequire("e2xkU");

var $5488eaedb733a0fa$export$44ffba16bd48dac6 = "__ATLASKIT_THEME__";
var $5488eaedb733a0fa$export$c93026a968943f95 = "light";
var $5488eaedb733a0fa$export$6ba72c8346b4c57e = [
    "light",
    "dark"
];
var $5488eaedb733a0fa$export$7a57f79000377ca2 = function borderRadius() {
    return 3;
};
var $5488eaedb733a0fa$export$6d8204c2cb2e06b8 = function gridSize() {
    return 8;
};
var $5488eaedb733a0fa$export$85e3c3ca0c6fb93 = function fontSize() {
    return 14;
};
var $5488eaedb733a0fa$export$6746fe0d9c9fab54 = function fontSizeSmall() {
    return 11;
};
var $5488eaedb733a0fa$export$a5975749f0374264 = function fontFamily() {
    return "-apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif";
};
var $5488eaedb733a0fa$export$356129969ee49c55 = function codeFontFamily() {
    return "'SFMono-Medium', 'SF Mono', 'Segoe UI Mono', 'Roboto Mono', 'Ubuntu Mono', Menlo, Consolas, Courier, monospace";
};
var $5488eaedb733a0fa$export$8e24544ddba725ee = function focusRing() {
    var color = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "var(--ds-border-focused, ".concat((0, $bbdbd5c17cc03a8e$export$215b7063051591f1), ")");
    var outlineWidth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $5488eaedb733a0fa$export$6d8204c2cb2e06b8() / 4;
    (0, $e2xkU.default)("@atlaskit/theme", "focus ring mixin", "Please use `@atlaskit/focus-ring` instead.");
    return "\n  &:focus {\n    outline: none;\n    box-shadow: 0px 0px 0px ".concat(outlineWidth, "px ").concat(color, ";\n  }\n");
};
var $5488eaedb733a0fa$export$c0dd343266bc3261 = function noFocusRing() {
    return "\n  box-shadow: none;\n";
};
var $5488eaedb733a0fa$export$7be255094ccdc533 = {
    card: function card() {
        return 100;
    },
    navigation: function navigation() {
        return 200;
    },
    dialog: function dialog() {
        return 300;
    },
    layer: function layer() {
        return 400;
    },
    blanket: function blanket() {
        return 500;
    },
    modal: function modal() {
        return 510;
    },
    flag: function flag() {
        return 600;
    },
    spotlight: function spotlight() {
        return 700;
    },
    tooltip: function tooltip() {
        return 9999;
    }
};
var $5488eaedb733a0fa$export$a1b3edb637fb4f35 = function visuallyHidden() {
    (0, $e2xkU.default)("@atlaskit/theme", "visually hidden mixin", "Please use `@atlaskit/visually-hidden` instead.");
    return {
        border: "0 !important",
        clip: "rect(1px, 1px, 1px, 1px) !important",
        height: "1px !important",
        overflow: "hidden !important",
        padding: "0 !important",
        position: "absolute !important",
        width: "1px !important",
        whiteSpace: "nowrap !important"
    };
};
var $5488eaedb733a0fa$export$ba1d834b86d72a09 = $5488eaedb733a0fa$export$a1b3edb637fb4f35;
var $5488eaedb733a0fa$export$e497e856b4f89fcd = function skeletonShimmer() {
    return {
        css: {
            backgroundColor: "var(--ds-skeleton, ".concat((0, $bbdbd5c17cc03a8e$export$2a0674ff2eb10214)(), ")"),
            animationDuration: "1.5s",
            animationIterationCount: "infinite",
            animationTimingFunction: "linear",
            animationDirection: "alternate"
        },
        keyframes: {
            from: {
                backgroundColor: "var(--ds-skeleton, ".concat((0, $bbdbd5c17cc03a8e$export$2a0674ff2eb10214)(), ")")
            },
            to: {
                backgroundColor: "var(--ds-skeleton-subtle, ".concat((0, $bbdbd5c17cc03a8e$export$920c0d5c49070351), ")")
            }
        }
    };
};


function $873c851dde6e185f$export$2e2bcd8739ae039(props) {
    if (props && props.theme) {
        // Theme is the global Atlaskit theme
        if ((0, $5488eaedb733a0fa$export$44ffba16bd48dac6) in props.theme) return props.theme[0, $5488eaedb733a0fa$export$44ffba16bd48dac6];
        else if ("mode" in props.theme && (0, $5488eaedb733a0fa$export$6ba72c8346b4c57e).includes(props.theme.mode)) return props.theme;
    }
    // If format not supported (or no theme provided), return standard theme
    return {
        mode: (0, $5488eaedb733a0fa$export$c93026a968943f95)
    };
}


// Unpack custom variants, and get correct value for the current theme
function $e1a63ec7e14662fa$var$themedVariants(variantProp, variants) {
    return function(props) {
        var theme = (0, $873c851dde6e185f$export$2e2bcd8739ae039)(props);
        if (props && props[variantProp] && variants) {
            var modes = variants[props[variantProp]];
            if (modes && modes[theme.mode]) {
                var value = modes[theme.mode];
                if (value) return value;
                 // TS believes value can be undefined
            }
        }
        return "";
    };
}
function $e1a63ec7e14662fa$export$2e2bcd8739ae039(modesOrVariant, variantModes) {
    if (typeof modesOrVariant === "string") return $e1a63ec7e14662fa$var$themedVariants(modesOrVariant, variantModes);
    var modes = modesOrVariant;
    return function(props) {
        // Get theme from the user's props
        var theme = (0, $873c851dde6e185f$export$2e2bcd8739ae039)(props);
        // User isn't required to provide both light and dark values
        if (theme.mode in modes) {
            var value = modes[theme.mode]; // TS believes value can be undefined
            if (value) return value;
        }
        return "";
    };
}


var $bbdbd5c17cc03a8e$export$4b84fd0e2c617bd = "#FFEBE6";
var $bbdbd5c17cc03a8e$export$b34b069eff244586 = "#FFBDAD";
var $bbdbd5c17cc03a8e$export$be802dd0d8b57f35 = "#FF8F73";
var $bbdbd5c17cc03a8e$export$60847d42f9da92a6 = "#FF7452";
var $bbdbd5c17cc03a8e$export$4a7404f376229999 = "#FF5630";
var $bbdbd5c17cc03a8e$export$2010d0fb4295b346 = "#DE350B";
var $bbdbd5c17cc03a8e$export$2837b5a1a71d5c02 = "#BF2600";
var $bbdbd5c17cc03a8e$export$8d9596b529bbb9cf = "#FFFAE6";
var $bbdbd5c17cc03a8e$export$41060a744ab0b7ae = "#FFF0B3";
var $bbdbd5c17cc03a8e$export$1cc05bbbf340e559 = "#FFE380";
var $bbdbd5c17cc03a8e$export$5aae31392d72caaa = "#FFC400";
var $bbdbd5c17cc03a8e$export$c6930421db9fa514 = "#FFAB00";
var $bbdbd5c17cc03a8e$export$59619663aa6500fb = "#FF991F";
var $bbdbd5c17cc03a8e$export$874739ea9e379ab6 = "#FF8B00";
var $bbdbd5c17cc03a8e$export$8a6341c32b6a3ee6 = "#E3FCEF";
var $bbdbd5c17cc03a8e$export$69a3bf21b9686c2b = "#ABF5D1";
var $bbdbd5c17cc03a8e$export$afbce1382ec95f73 = "#79F2C0";
var $bbdbd5c17cc03a8e$export$747d86715d4175de = "#57D9A3";
var $bbdbd5c17cc03a8e$export$940e1f69e873f202 = "#36B37E";
var $bbdbd5c17cc03a8e$export$a49394138f7b8e85 = "#00875A";
var $bbdbd5c17cc03a8e$export$6fa04827ac68a4fb = "#006644";
var $bbdbd5c17cc03a8e$export$226de0355ed012f8 = "#DEEBFF";
var $bbdbd5c17cc03a8e$export$8c13c2ee36917869 = "#B3D4FF";
var $bbdbd5c17cc03a8e$export$ecfc1dff386a3e7a = "#4C9AFF";
var $bbdbd5c17cc03a8e$export$215b7063051591f1 = "#2684FF";
var $bbdbd5c17cc03a8e$export$e62e8919cca44969 = "#0065FF";
var $bbdbd5c17cc03a8e$export$b3de0ae08da2ce64 = "#0052CC";
var $bbdbd5c17cc03a8e$export$a6ee3d71bc067634 = "#0747A6";
var $bbdbd5c17cc03a8e$export$363e4475840015bb = "#EAE6FF";
var $bbdbd5c17cc03a8e$export$4b0a4417ed59760f = "#C0B6F2";
var $bbdbd5c17cc03a8e$export$6011520a64d9a187 = "#998DD9";
var $bbdbd5c17cc03a8e$export$a7175d4e9206bc80 = "#8777D9";
var $bbdbd5c17cc03a8e$export$b48405b95304b5a1 = "#6554C0";
var $bbdbd5c17cc03a8e$export$c71e4279dd54a18d = "#5243AA";
var $bbdbd5c17cc03a8e$export$147899de772240ec = "#403294";
var $bbdbd5c17cc03a8e$export$2cf711fe14c66f06 = "#E6FCFF";
var $bbdbd5c17cc03a8e$export$7a8f4d33f6f9772c = "#B3F5FF";
var $bbdbd5c17cc03a8e$export$776c9c497ef08533 = "#79E2F2";
var $bbdbd5c17cc03a8e$export$69cb3ca10c1e330e = "#00C7E6";
var $bbdbd5c17cc03a8e$export$9dc1ef0f3f48059b = "#00B8D9";
var $bbdbd5c17cc03a8e$export$7c835c78b6fcdef8 = "#00A3BF";
var $bbdbd5c17cc03a8e$export$6036577f95c3877e = "#008DA6";
var $bbdbd5c17cc03a8e$export$29a4f05edc054374 = "#FFFFFF";
var $bbdbd5c17cc03a8e$export$e655ef011c4aa1a2 = "#FAFBFC";
var $bbdbd5c17cc03a8e$export$9fdfb749e33cdf97 = "#F4F5F7";
var $bbdbd5c17cc03a8e$export$3e51e8f1440314ba = "#EBECF0";
var $bbdbd5c17cc03a8e$export$1ce2d1575d444ceb = "#DFE1E6";
var $bbdbd5c17cc03a8e$export$8754fc7e6d8b3000 = "#C1C7D0";
var $bbdbd5c17cc03a8e$export$c2e91cbeada39b8b = "#B3BAC5";
var $bbdbd5c17cc03a8e$export$5f71e19f3a7ad9de = "#A5ADBA";
var $bbdbd5c17cc03a8e$export$eaa8c8a70ac22806 = "#97A0AF";
var $bbdbd5c17cc03a8e$export$7c87d337fb91a97d = "#8993A4";
var $bbdbd5c17cc03a8e$export$d6447c357493214f = "#7A869A";
var $bbdbd5c17cc03a8e$export$f563ee71e9ee74cd = "#6B778C";
var $bbdbd5c17cc03a8e$export$e2ef2124cf4024b1 = "#5E6C84";
var $bbdbd5c17cc03a8e$export$eece5f492e429f08 = "#505F79";
var $bbdbd5c17cc03a8e$export$c39c0fe0f26207ae = "#42526E";
var $bbdbd5c17cc03a8e$export$7090862dc3038a9f = "#344563";
var $bbdbd5c17cc03a8e$export$ad0bacf983b7ddaa = "#253858";
var $bbdbd5c17cc03a8e$export$7d61b15e0da132af = "#172B4D";
var $bbdbd5c17cc03a8e$export$fbda843f0a27fe96 = "#091E42";
var $bbdbd5c17cc03a8e$export$791e57b27ca738ef = "rgba(9, 30, 66, 0.02)";
var $bbdbd5c17cc03a8e$export$8d43898f60b96a82 = "rgba(9, 30, 66, 0.04)";
var $bbdbd5c17cc03a8e$export$920c0d5c49070351 = "rgba(9, 30, 66, 0.08)";
var $bbdbd5c17cc03a8e$export$46987b49aab6d1a8 = "rgba(9, 30, 66, 0.13)";
var $bbdbd5c17cc03a8e$export$7d3359664e8bb0e5 = "rgba(9, 30, 66, 0.25)";
var $bbdbd5c17cc03a8e$export$d2d3bedfb276cac0 = "rgba(9, 30, 66, 0.31)";
var $bbdbd5c17cc03a8e$export$6e5e7499ff054f6d = "rgba(9, 30, 66, 0.36)";
var $bbdbd5c17cc03a8e$export$59264b346c877fa7 = "rgba(9, 30, 66, 0.42)";
var $bbdbd5c17cc03a8e$export$d092757d7c64925c = "rgba(9, 30, 66, 0.48)";
var $bbdbd5c17cc03a8e$export$486ab785e4bac3c6 = "rgba(9, 30, 66, 0.54)";
var $bbdbd5c17cc03a8e$export$fba592bbc6419fea = "rgba(9, 30, 66, 0.60)";
var $bbdbd5c17cc03a8e$export$13609db0e6812ab8 = "rgba(9, 30, 66, 0.66)";
var $bbdbd5c17cc03a8e$export$fbae4efaa892d883 = "rgba(9, 30, 66, 0.71)";
var $bbdbd5c17cc03a8e$export$f13946d26f440ce6 = "rgba(9, 30, 66, 0.77)";
var $bbdbd5c17cc03a8e$export$19f58225ac52a306 = "rgba(9, 30, 66, 0.82)";
var $bbdbd5c17cc03a8e$export$6384f09da70e7b62 = "rgba(9, 30, 66, 0.89)";
var $bbdbd5c17cc03a8e$export$d0dccc730683edc2 = "rgba(9, 30, 66, 0.95)";
var $bbdbd5c17cc03a8e$export$2f6319cf7d736c2a = "#E6EDFA";
var $bbdbd5c17cc03a8e$export$95126bc8884d6634 = "#DCE5F5";
var $bbdbd5c17cc03a8e$export$8338d8c35d44ff1 = "#CED9EB";
var $bbdbd5c17cc03a8e$export$5368d76ae4fbbda7 = "#B8C7E0";
var $bbdbd5c17cc03a8e$export$9f0a771d16ec8d36 = "#ABBBD6";
var $bbdbd5c17cc03a8e$export$abcf8c38338b4aa5 = "#9FB0CC";
var $bbdbd5c17cc03a8e$export$97e81faa16a182c7 = "#8C9CB8";
var $bbdbd5c17cc03a8e$export$bfe21c59123ecf33 = "#7988A3";
var $bbdbd5c17cc03a8e$export$ee82aa2ea6a1558 = "#67758F";
var $bbdbd5c17cc03a8e$export$682927c6ed76be02 = "#56637A";
var $bbdbd5c17cc03a8e$export$91fd9994c5be9757 = "#455166";
var $bbdbd5c17cc03a8e$export$d281fbfe3cff2df6 = "#3B475C";
var $bbdbd5c17cc03a8e$export$3902c91d8b98a753 = "#313D52";
var $bbdbd5c17cc03a8e$export$8e8133c1ba5845b5 = "#283447";
var $bbdbd5c17cc03a8e$export$33ff357f6620b39 = "#202B3D";
var $bbdbd5c17cc03a8e$export$633847cf062b69e0 = "#1B2638";
var $bbdbd5c17cc03a8e$export$9776a6e503bdbf76 = "#121A29";
var $bbdbd5c17cc03a8e$export$6c813d5160dff5db = "#0E1624";
var $bbdbd5c17cc03a8e$export$3d4f271a500072a = "#0D1424";
var $bbdbd5c17cc03a8e$export$fe151285c22759ec = "rgba(13, 20, 36, 0.06)";
var $bbdbd5c17cc03a8e$export$a101c6190d0da34 = "rgba(13, 20, 36, 0.14)";
var $bbdbd5c17cc03a8e$export$4b16f52932fda51 = "rgba(13, 20, 36, 0.18)";
var $bbdbd5c17cc03a8e$export$a74bcd7b9845b0d8 = "rgba(13, 20, 36, 0.29)";
var $bbdbd5c17cc03a8e$export$9209c179316d1751 = "rgba(13, 20, 36, 0.36)";
var $bbdbd5c17cc03a8e$export$88f55133f636c8dd = "rgba(13, 20, 36, 0.40)";
var $bbdbd5c17cc03a8e$export$51126f85d1009512 = "rgba(13, 20, 36, 0.47)";
var $bbdbd5c17cc03a8e$export$a069b547bd23af78 = "rgba(13, 20, 36, 0.53)";
var $bbdbd5c17cc03a8e$export$40cce05af3b2600a = "rgba(13, 20, 36, 0.63)";
var $bbdbd5c17cc03a8e$export$b78942185925a0d = "rgba(13, 20, 36, 0.73)";
var $bbdbd5c17cc03a8e$export$e058fb44b8eaafca = "rgba(13, 20, 36, 0.78)";
var $bbdbd5c17cc03a8e$export$92b0b8de26920c18 = "rgba(13, 20, 36, 0.81)";
var $bbdbd5c17cc03a8e$export$67564f7459d3fc9e = "rgba(13, 20, 36, 0.85)";
var $bbdbd5c17cc03a8e$export$77868e1ca884ffa3 = "rgba(13, 20, 36, 0.89)";
var $bbdbd5c17cc03a8e$export$2afd71d7d3ea2cd5 = "rgba(13, 20, 36, 0.92)";
var $bbdbd5c17cc03a8e$export$f2a0acaab9972c70 = "rgba(13, 20, 36, 0.95)";
var $bbdbd5c17cc03a8e$export$9ab70e67d6475361 = "rgba(13, 20, 36, 0.97)";
var $bbdbd5c17cc03a8e$export$8ce1fd94bee2f412 = (0, $e1a63ec7e14662fa$export$2e2bcd8739ae039)({
    light: "var(--ds-surface, ".concat($bbdbd5c17cc03a8e$export$29a4f05edc054374, ")"),
    dark: "var(--ds-surface, ".concat($bbdbd5c17cc03a8e$export$633847cf062b69e0, ")")
});
var $bbdbd5c17cc03a8e$export$b861914ea877b580 = (0, $e1a63ec7e14662fa$export$2e2bcd8739ae039)({
    light: "var(--ds-background-selected, ".concat($bbdbd5c17cc03a8e$export$226de0355ed012f8, ")"),
    dark: "var(--ds-background-selected, ".concat($bbdbd5c17cc03a8e$export$8c13c2ee36917869, ")")
});
var $bbdbd5c17cc03a8e$export$3f1b020df94387af = (0, $e1a63ec7e14662fa$export$2e2bcd8739ae039)({
    light: "var(--ds-background-neutral-hovered, ".concat($bbdbd5c17cc03a8e$export$3e51e8f1440314ba, ")"),
    dark: "var(--ds-background-neutral-hovered, ".concat($bbdbd5c17cc03a8e$export$d281fbfe3cff2df6, ")")
});
var $bbdbd5c17cc03a8e$export$c0183dbab98ca63e = (0, $e1a63ec7e14662fa$export$2e2bcd8739ae039)({
    light: "var(--ds-surface-overlay, ".concat($bbdbd5c17cc03a8e$export$29a4f05edc054374, ")"),
    dark: "var(--ds-surface-overlay, ".concat($bbdbd5c17cc03a8e$export$8e8133c1ba5845b5, ")")
});
var $bbdbd5c17cc03a8e$export$6f093cfa640b7166 = (0, $e1a63ec7e14662fa$export$2e2bcd8739ae039)({
    light: "var(--ds-text, ".concat($bbdbd5c17cc03a8e$export$fbda843f0a27fe96, ")"),
    dark: "var(--ds-text, ".concat($bbdbd5c17cc03a8e$export$5368d76ae4fbbda7, ")")
});
var $bbdbd5c17cc03a8e$export$42f8e9c698766e7a = (0, $e1a63ec7e14662fa$export$2e2bcd8739ae039)({
    light: "var(--ds-text, ".concat($bbdbd5c17cc03a8e$export$7d61b15e0da132af, ")"),
    dark: "var(--ds-text, ".concat($bbdbd5c17cc03a8e$export$5368d76ae4fbbda7, ")")
});
var $bbdbd5c17cc03a8e$export$c2d157ca1c34b6e3 = (0, $e1a63ec7e14662fa$export$2e2bcd8739ae039)({
    light: "var(--ds-text-selected, ".concat($bbdbd5c17cc03a8e$export$b3de0ae08da2ce64, ")"),
    dark: "var(--ds-text-selected, ".concat($bbdbd5c17cc03a8e$export$b3de0ae08da2ce64, ")")
});
var $bbdbd5c17cc03a8e$export$1905ba28d7cf066f = (0, $e1a63ec7e14662fa$export$2e2bcd8739ae039)({
    light: "var(--ds-text-subtlest, ".concat($bbdbd5c17cc03a8e$export$f563ee71e9ee74cd, ")"),
    dark: "var(--ds-text-subtlest, ".concat($bbdbd5c17cc03a8e$export$97e81faa16a182c7, ")")
});
var $bbdbd5c17cc03a8e$export$bd9002130d306d39 = (0, $e1a63ec7e14662fa$export$2e2bcd8739ae039)({
    light: "var(--ds-text-subtlest, ".concat($bbdbd5c17cc03a8e$export$f563ee71e9ee74cd, ")"),
    dark: "var(--ds-text-subtlest, ".concat($bbdbd5c17cc03a8e$export$bfe21c59123ecf33, ")")
});
var $bbdbd5c17cc03a8e$export$46e4a324ac90507f = (0, $e1a63ec7e14662fa$export$2e2bcd8739ae039)({
    light: "var(--ds-text, ".concat($bbdbd5c17cc03a8e$export$7d61b15e0da132af, ")"),
    dark: "var(--ds-text, ".concat($bbdbd5c17cc03a8e$export$5368d76ae4fbbda7, ")")
});
var $bbdbd5c17cc03a8e$export$79f3f2b82beb0d36 = (0, $e1a63ec7e14662fa$export$2e2bcd8739ae039)({
    light: "var(--ds-text-subtlest, ".concat($bbdbd5c17cc03a8e$export$f563ee71e9ee74cd, ")"),
    dark: "var(--ds-text-subtlest, ".concat($bbdbd5c17cc03a8e$export$97e81faa16a182c7, ")")
});
var $bbdbd5c17cc03a8e$export$7bb0d5c671655cc4 = (0, $e1a63ec7e14662fa$export$2e2bcd8739ae039)({
    light: $bbdbd5c17cc03a8e$export$9fdfb749e33cdf97,
    dark: $bbdbd5c17cc03a8e$export$8e8133c1ba5845b5
});
var $bbdbd5c17cc03a8e$export$9c30223ca0a664fb = (0, $e1a63ec7e14662fa$export$2e2bcd8739ae039)({
    light: "var(--ds-link, ".concat($bbdbd5c17cc03a8e$export$b3de0ae08da2ce64, ")"),
    dark: "var(--ds-link, ".concat($bbdbd5c17cc03a8e$export$ecfc1dff386a3e7a, ")")
});
var $bbdbd5c17cc03a8e$export$7ed258b0728b004b = (0, $e1a63ec7e14662fa$export$2e2bcd8739ae039)({
    light: "var(--ds-link-pressed, ".concat($bbdbd5c17cc03a8e$export$e62e8919cca44969, ")"),
    dark: "var(--ds-link-pressed, ".concat($bbdbd5c17cc03a8e$export$215b7063051591f1, ")")
});
var $bbdbd5c17cc03a8e$export$dfa920d8decc8a59 = (0, $e1a63ec7e14662fa$export$2e2bcd8739ae039)({
    light: "var(--ds-link-pressed, ".concat($bbdbd5c17cc03a8e$export$a6ee3d71bc067634, ")"),
    dark: "var(--ds-link-pressed, ".concat($bbdbd5c17cc03a8e$export$ecfc1dff386a3e7a, ")")
});
var $bbdbd5c17cc03a8e$export$6069e6ad5c78f632 = (0, $e1a63ec7e14662fa$export$2e2bcd8739ae039)({
    light: "var(--ds-border-focused, ".concat($bbdbd5c17cc03a8e$export$215b7063051591f1, ")"),
    dark: "var(--ds-border-focused, ".concat($bbdbd5c17cc03a8e$export$215b7063051591f1, ")")
});
var $bbdbd5c17cc03a8e$export$9ad721cf3b3debe0 = (0, $e1a63ec7e14662fa$export$2e2bcd8739ae039)({
    light: "var(--ds-background-brand-bold, ".concat($bbdbd5c17cc03a8e$export$b3de0ae08da2ce64, ")"),
    dark: "var(--ds-background-brand-bold, ".concat($bbdbd5c17cc03a8e$export$ecfc1dff386a3e7a, ")")
});
var $bbdbd5c17cc03a8e$export$2aa0182783e7e9de = (0, $e1a63ec7e14662fa$export$2e2bcd8739ae039)({
    light: $bbdbd5c17cc03a8e$export$b3de0ae08da2ce64,
    dark: $bbdbd5c17cc03a8e$export$ecfc1dff386a3e7a
});
var $bbdbd5c17cc03a8e$export$8bf7dff220b82b4a = (0, $e1a63ec7e14662fa$export$2e2bcd8739ae039)({
    light: $bbdbd5c17cc03a8e$export$9dc1ef0f3f48059b,
    dark: $bbdbd5c17cc03a8e$export$69cb3ca10c1e330e
});
var $bbdbd5c17cc03a8e$export$e13cce2a2d16a9d4 = (0, $e1a63ec7e14662fa$export$2e2bcd8739ae039)({
    light: $bbdbd5c17cc03a8e$export$b48405b95304b5a1,
    dark: $bbdbd5c17cc03a8e$export$6011520a64d9a187
});
var $bbdbd5c17cc03a8e$export$a90204d1394caf30 = (0, $e1a63ec7e14662fa$export$2e2bcd8739ae039)({
    light: $bbdbd5c17cc03a8e$export$4a7404f376229999,
    dark: $bbdbd5c17cc03a8e$export$4a7404f376229999
});
var $bbdbd5c17cc03a8e$export$594c5a8758200c32 = (0, $e1a63ec7e14662fa$export$2e2bcd8739ae039)({
    light: $bbdbd5c17cc03a8e$export$c6930421db9fa514,
    dark: $bbdbd5c17cc03a8e$export$c6930421db9fa514
});
var $bbdbd5c17cc03a8e$export$955a2ebd2fb142ae = (0, $e1a63ec7e14662fa$export$2e2bcd8739ae039)({
    light: $bbdbd5c17cc03a8e$export$940e1f69e873f202,
    dark: $bbdbd5c17cc03a8e$export$940e1f69e873f202
});
var $bbdbd5c17cc03a8e$export$2a0674ff2eb10214 = function skeleton() {
    return "var(--ds-skeleton, ".concat($bbdbd5c17cc03a8e$export$8d43898f60b96a82, ")");
};



var $477d219a351dcce0$export$85e3c3ca0c6fb93 = (0, $5488eaedb733a0fa$export$85e3c3ca0c6fb93)();
var $477d219a351dcce0$export$30fa7cc5f2690a43 = 56;
var $477d219a351dcce0$export$4033a111ca79977d = 1280;
var $477d219a351dcce0$export$24ec62cee78b7042 = 1130;
var $477d219a351dcce0$export$d8bde68ac946124f = "--ds--ans--fbc";
var $477d219a351dcce0$export$73e44f54603a0964 = "--ds--ans--hbgc";
var $477d219a351dcce0$export$13f8aa8f663f4c99 = "--ds--ans--bgc";
var $477d219a351dcce0$export$d81606c1fc5119bc = "--ds--ans--c";
var $477d219a351dcce0$export$65f656ad520ea71 = "--ds--ans--bc";







function $d49ba35090ee3f46$var$fromHex(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    n = n.replace("#", "").match(/.{2}/g);
    for(var a = 0; a < n.length; a++)n[a] = parseInt(n[a], 16);
    switch(e){
        case "rgb":
            return {
                r: n[0],
                g: n[1],
                b: n[2]
            };
        default:
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, {
                r: n[0],
                g: n[1],
                b: n[2]
            });
    }
}
function $d49ba35090ee3f46$var$fromRgb(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "hex":
            return 1 == (g = Math.round(n.r).toString(16)).length && (g = "0" + g), 1 == (y = Math.round(n.g).toString(16)).length && (y = "0" + y), 1 == (_ = Math.round(n.b).toString(16)).length && (_ = "0" + _), "#" + g + y + _;
        case "cssrgb":
            return "rgb(" + Math.round(n.r) + "," + Math.round(n.g) + "," + Math.round(n.b) + ")";
        case "hsl":
            var a = [
                g = n.r / 255,
                y = n.g / 255,
                _ = n.b / 255
            ].sort(), i = (a[0] + a[2]) / 2 * 100;
            return a[0] == a[2] ? (b = 0, d = 0) : (b = i >= 50 ? (a[2] - a[0]) / (2 - a[2] - a[0]) * 100 : (a[2] - a[0]) / (a[2] + a[0]) * 100, (d = a[2] == g ? (y - _) / (a[2] - a[0]) * 60 : a[2] == y ? 60 * (2 + (_ - g) / (a[2] - a[0])) : 60 * (4 + (g - y) / (a[2] - a[0]))) < 0 ? d += 360 : d > 360 && (d %= 360)), {
                h: d,
                s: b,
                l: i
            };
        case "csshsl":
            var c = o.convert({
                conversions: t,
                helpers: s
            }, "hsl", n);
            return "hsl(" + Math.round(c.h) + "," + Math.round(c.s) + "%," + Math.round(c.l) + "%)";
        case "cmyk":
            var u = n.r / 255, l = n.g / 255, h = n.b / 255, v = 1 - Math.max(u, l, h);
            if (1 != v) var p = (1 - u - v) / (1 - v), f = (1 - l - v) / (1 - v), m = (1 - h - v) / (1 - v);
            else var p = 0, f = 0, m = 0;
            return {
                c: p,
                m: f,
                y: m,
                k: v
            };
        case "hsv":
            var d, b, g = n.r / 255, y = n.g / 255, _ = n.b / 255, M = Math.min(g, y, _), Y = Math.max(g, y, _), L = Y - M, X = Y;
            if (0 == L) d = 0, b = 0;
            else {
                b = L / Y;
                var Z = ((Y - g) / 6 + L / 2) / L, R = ((Y - y) / 6 + L / 2) / L, w = ((Y - _) / 6 + L / 2) / L;
                g == Y ? d = w - R : y == Y ? d = 1 / 3 + Z - w : _ == Y && (d = 2 / 3 + R - Z), d < 0 && (d += 1), d > 1 && (d -= 1);
            }
            return {
                h: 360 * d,
                s: 100 * b,
                v: 100 * X
            };
        case "yiq":
            var m = n.r / 255 * .299 + n.g / 255 * .587 + n.b / 255 * .114, C = n.r / 255 * .596 + n.g / 255 * -0.274 + n.b / 255 * -0.322, x = n.r / 255 * .211 + n.g / 255 * -0.523 + n.b / 255 * .312;
            return C = s.bounded(C, [
                -0.5957,
                .5957
            ]), x = s.bounded(x, [
                -0.5226,
                .5226
            ]), {
                y: m,
                i: C,
                q: x
            };
        case "XYZ":
            var A = [
                n.r,
                n.g,
                n.b
            ].map(function(r) {
                return r / 255;
            }).map(function(r) {
                return r <= .04045 ? r / 12.92 : Math.pow((r + .055) / 1.055, 2.4);
            }), S = s.getTransform("SRGB_XYZ").map(function(r) {
                return A.reduce(function(e, n, t) {
                    return r[t] * n + e;
                }, 0);
            }).map(function(r) {
                return 100 * r;
            }), O = $d49ba35090ee3f46$var$slicedToArray(S, 3);
            return {
                X: O[0],
                Y: O[1],
                Z: O[2]
            };
        case "lms":
        case "cielab":
        case "cieluv":
        case "xyY":
            var I = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "XYZ", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, I);
        case "cielch":
            var j = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "cieluv", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, j);
        case "hsluv":
            var D = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "cielch", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, D);
    }
}
function $d49ba35090ee3f46$var$fromCssRgb(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    n = n.replace(/((rgb\(|\))|[\s]*)/g, "").split(",");
    for(var a = 0; a < n.length; a++)n[a] = parseInt(n[a]);
    switch(e){
        case "rgb":
            return {
                r: n[0],
                g: n[1],
                b: n[2]
            };
        default:
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, {
                r: n[0],
                g: n[1],
                b: n[2]
            });
    }
}
function $d49ba35090ee3f46$var$fromHsl(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "rgb":
            if (0 == n.s) {
                var a = n.l / 100 * 255;
                return {
                    r: a,
                    g: a,
                    b: a
                };
            }
            var i, c, u;
            i = n.l >= 50 ? n.l / 100 + n.s / 100 - n.l / 100 * (n.s / 100) : n.l / 100 * (1 + n.s / 100), c = n.l / 100 * 2 - i;
            var l, h, v, p = ((u = n.h / 360) + .333) % 1, f = u, m = s.negMod(u - .333, 1);
            return l = 6 * p < 1 ? c + 6 * (i - c) * p : 2 * p < 1 ? i : 3 * p < 2 ? c + 6 * (.666 - p) * (i - c) : c, h = 6 * f < 1 ? c + 6 * (i - c) * f : 2 * f < 1 ? i : 3 * f < 2 ? c + 6 * (.666 - f) * (i - c) : c, v = 6 * m < 1 ? c + 6 * (i - c) * m : 2 * m < 1 ? i : 3 * m < 2 ? c + 6 * (.666 - m) * (i - c) : c, l < 0 && (l = 0), h < 0 && (h = 0), v < 0 && (v = 0), {
                r: 255 * l,
                g: 255 * h,
                b: 255 * v
            };
        case "csshsl":
            return "hsl(" + Math.round(n.h) + "," + Math.round(n.s) + "%," + Math.round(n.l) + "%)";
        case "hsv":
            n.s = n.s / 100, n.l = n.l / 100;
            var d = n.s * (n.l < .5 ? n.l : 1 - n.l);
            return {
                h: n.h,
                s: 100 * (2 * d / (n.l + d)),
                v: 100 * (n.l + d)
            };
        default:
            var b = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "rgb", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, b);
    }
}
function $d49ba35090ee3f46$var$fromCssHsl(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    n = n.replace(/(hsl\(|\)|%|[\s]*)/g, "").split(",");
    for(var a = 0; a < n.length; a++)n[a] = parseInt(n[a]);
    switch(e){
        case "hsl":
            return {
                h: n[0],
                s: n[1],
                l: n[2]
            };
        default:
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, {
                h: n[0],
                s: n[1],
                l: n[2]
            });
    }
}
function $d49ba35090ee3f46$var$fromHsv(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "rgb":
            var a, i, c;
            n.h = n.h / 360, n.s = n.s / 100, n.v = n.v / 100;
            var u = 6 * n.h;
            6 == u && (u = 0);
            var l, h, v, p = Math.round(u), f = n.v * (1 - n.s), m = n.v * (1 - n.s * (u - p)), d = n.v * (1 - n.s * (1 - (u - p)));
            return 0 == p ? (l = n.v, h = d, v = f) : 1 == p ? (l = m, h = n.v, v = f) : 2 == p ? (l = f, h = n.v, v = d) : 3 == p ? (l = f, h = m, v = n.v) : 4 == p ? (l = d, h = f, v = n.v) : (l = n.v, h = f, v = m), a = 255 * l, i = 255 * h, c = 255 * v, {
                r: a,
                g: i,
                b: c
            };
        case "hsl":
            n.h = n.h / 360, n.s = n.s / 100, n.v = n.v / 100;
            return {
                h: 360 * n.h,
                s: 100 * ((2 - n.s) * n.v < 1 ? n.s * n.v / ((2 - n.s) * n.v) : n.s * n.v / (2 - (2 - n.s) * n.v)),
                l: 100 * ((2 - n.s) * n.v / 2)
            };
        default:
            var b = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "rgb", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, b);
    }
}
function $d49ba35090ee3f46$var$fromCmyk(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "rgb":
            return {
                r: a = 255 * (1 - n.c) * (1 - n.k),
                g: i = 255 * (1 - n.m) * (1 - n.k),
                b: c = 255 * (1 - n.y) * (1 - n.k)
            };
        case "cssrgb":
            var a = 255 * (1 - n.c) * (1 - n.k), i = 255 * (1 - n.m) * (1 - n.k), c = 255 * (1 - n.y) * (1 - n.k);
            return "rgb(" + Math.round(a) + "," + Math.round(i) + "," + Math.round(c) + ")";
        default:
            var u = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "rgb", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, u);
    }
}
function $d49ba35090ee3f46$var$fromYiq(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(n.i = s.bounded(n.i, [
        -0.5957,
        .5957
    ]), n.q = s.bounded(n.q, [
        -0.5226,
        .5226
    ]), e){
        case "rgb":
            var a = 255 * (n.y + .956 * n.i + .621 * n.q), i = 255 * (n.y + -0.272 * n.i + -0.647 * n.q), c = 255 * (n.y + -1.106 * n.i + -1.703 * n.q);
            return a = s.bounded(a, [
                0,
                255
            ]), i = s.bounded(i, [
                0,
                255
            ]), c = s.bounded(c, [
                0,
                255
            ]), {
                r: a,
                g: i,
                b: c
            };
        default:
            var u = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "rgb", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, u);
    }
}
function $d49ba35090ee3f46$var$fromXYZ(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers, a = s.getIlluminant("D65");
    switch(e){
        case "rgb":
            var i = [
                n.X,
                n.Y,
                n.Z
            ].map(function(r) {
                return r / 100;
            }), c = s.getTransform("INVERSE_SRGB_XYZ").map(function(r) {
                return i.reduce(function(e, n, t) {
                    return r[t] * n + e;
                }, 0);
            }).map(function(r) {
                return r <= .0031308 ? 12.92 * r : 1.055 * Math.pow(r, 1 / 2.4) - .055;
            }).map(function(r) {
                return 255 * r;
            }), u = $d49ba35090ee3f46$var$slicedToArray(c, 3), l = u[0], h = u[1], v = u[2];
            return s.boundedRgb({
                r: l,
                g: h,
                b: v
            });
        case "lms":
            var p = [
                n.X,
                n.Y,
                n.Z
            ].map(function(r) {
                return r / 100;
            }), f = s.getTransform("BRADFORD").map(function(r) {
                return p.reduce(function(e, n, t) {
                    return r[t] * n + e;
                }, 0);
            });
            return {
                rho: f[0],
                gamma: f[1],
                beta: f[2]
            };
        case "cielab":
            var m = n.X / a.X, d = n.Y / a.Y, b = n.Z / a.Z, g = function(r) {
                return r > .008856 ? s.cbrt(r) : (903.3 * r + 16) / 116;
            }, y = g(m), _ = g(d);
            return {
                L: 116 * _ - 16,
                a: 500 * (y - _),
                b: 200 * (_ - g(b))
            };
        case "cieluv":
            var M = n.Y / a.Y, Y = M > .008856 ? 116 * s.cbrt(M) - 16 : 903.3 * M, L = function(r) {
                return 4 * r.X / (r.X + 15 * r.Y + 3 * r.Z);
            }, X = function(r) {
                return 9 * r.Y / (r.X + 15 * r.Y + 3 * r.Z);
            };
            return {
                L: Y,
                u: 13 * Y * (L(n) - L(a)),
                v: 13 * Y * (X(n) - X(a))
            };
        case "xyY":
            return {
                x: n.X / (n.X + n.Y + n.Z),
                y: n.Y / (n.X + n.Y + n.Z),
                Y: n.Y
            };
        default:
            var Z = s.boundedRgb(o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "rgb", n));
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, Z);
    }
}
function $d49ba35090ee3f46$var$fromxyY(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "XYZ":
            var a = n.Y / n.y * n.x, i = n.Y / n.y * (1 - n.x - n.y);
            return {
                X: a,
                Y: n.Y,
                Z: i
            };
        default:
            var c = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "XYZ", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, c);
    }
}
function $d49ba35090ee3f46$var$fromLms(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "XYZ":
            var a = [
                n.rho,
                n.gamma,
                n.beta
            ], i = s.getTransform("INVERSE_BRADFORD").map(function(r) {
                return a.reduce(function(e, n, t) {
                    return r[t] * n + e;
                }, 0);
            });
            return {
                X: 100 * i[0],
                Y: 100 * i[1],
                Z: 100 * i[2]
            };
        default:
            var c = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "XYZ", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, c);
    }
}
function $d49ba35090ee3f46$var$fromCieLab(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "XYZ":
            var a = s.getIlluminant("D65"), i = (n.L + 16) / 116, c = n.a / 500 + i, u = i - n.b / 200, l = function(r) {
                return Math.pow(r, 3) > .008856 ? Math.pow(r, 3) : (116 * r - 16) / 903.3;
            }, h = l(c), v = l(u), p = n.L > 903.3 * .008856 ? Math.pow(i, 3) : n.L / 903.3;
            return {
                X: h * a.X,
                Y: p * a.Y,
                Z: v * a.Z
            };
        default:
            var f = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "XYZ", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, f);
    }
}
function $d49ba35090ee3f46$var$fromCieLuv(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "XYZ":
            var a = s.getIlluminant("D65"), i = function(r) {
                return 4 * r.X / (r.X + 15 * r.Y + 3 * r.Z);
            }(a), c = function(r) {
                return 9 * r.Y / (r.X + 15 * r.Y + 3 * r.Z);
            }(a), u = 1 / 3 * (52 * n.L / (n.u + 13 * n.L * i) - 1), l = n.L > 903.3 * .008856 ? Math.pow((n.L + 16) / 116, 3) : n.L / 903.3, h = -5 * l, v = (l * (39 * n.L / (n.v + 13 * n.L * c) - 5) - h) / (u - -1 / 3);
            return {
                X: 100 * v,
                Y: 100 * l,
                Z: 100 * (v * u + h)
            };
        case "cielch":
            var p = Math.sqrt(Math.pow(n.u, 2) + Math.pow(n.v, 2)), f = Math.atan2(n.v, n.u);
            return f < 0 && (f += 2 * Math.PI), f = s.toDeg(f), {
                L: n.L,
                C: p,
                h: f
            };
        default:
            var m = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "XYZ", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, m);
    }
}
function $d49ba35090ee3f46$var$fromCieLch(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "cieluv":
            var a = s.toRad(n.h), i = n.C * Math.cos(a), c = n.C * Math.sin(a);
            return {
                L: n.L,
                u: i,
                v: c
            };
        case "hsluv":
            if (n.L > 99.9999999) return {
                hu: n.h,
                s: 0,
                l: 100
            };
            if (n.L < 1e-8) return {
                hu: n.h,
                s: 0,
                l: 0
            };
            for(var u = (n.L + 16) / 1560896, l = u > .008856 ? u : n.L / 903.3, h = s.getTransform("INVERSE_SRGB_XYZ"), v = [], p = 0; p < 3; p++)for(var f = h[p][0], m = h[p][1], d = h[p][2], b = 0; b < 2; b++){
                var g = (284517 * f - 94839 * d) * l, y = (838422 * d + 769860 * m + 731718 * f) * n.L * l - 769860 * b * n.L, _ = (632260 * d - 126452 * m) * l + 126452 * b;
                v.push({
                    m: g / _,
                    b: y / _
                });
            }
            var M = Number.MAX_VALUE, Y = s.toRad(n.h);
            v.forEach(function(r) {
                var e = r.b / (Math.sin(Y) - r.m * Math.cos(Y));
                e >= 0 && (M = Math.min(M, e));
            });
            var L = M;
            return {
                hu: n.h,
                s: n.C / L * 100,
                l: n.L
            };
        default:
            var X = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "cieluv", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, X);
    }
}
function $d49ba35090ee3f46$var$fromCieLch$1(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "cielch":
            if (n.L > 99.9999999) return {
                L: 100,
                C: 0,
                h: n.hu
            };
            if (n.L < 1e-8) return {
                L: 0,
                C: 0,
                h: n.hu
            };
            for(var a = (n.l + 16) / 1560896, i = a > .008856 ? a : n.l / 903.3, c = s.getTransform("INVERSE_SRGB_XYZ"), u = [], l = 0; l < 3; l++)for(var h = c[l][0], v = c[l][1], p = c[l][2], f = 0; f < 2; f++){
                var m = (284517 * h - 94839 * p) * i, d = (838422 * p + 769860 * v + 731718 * h) * n.l * i - 769860 * f * n.l, b = (632260 * p - 126452 * v) * i + 126452 * f;
                u.push({
                    m: m / b,
                    b: d / b
                });
            }
            var g = Number.MAX_VALUE, y = s.toRad(n.hu);
            u.forEach(function(r) {
                var e = r.b / (Math.sin(y) - r.m * Math.cos(y));
                e >= 0 && (g = Math.min(g, e));
            });
            var _ = g;
            return {
                L: n.l,
                C: _ / 100 * n.s,
                h: n.hu
            };
        default:
            var M = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "cielch", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, M);
    }
}
function $d49ba35090ee3f46$var$contains(r, e) {
    return Object.keys(r).every(function(r) {
        return -1 !== e.indexOf(r);
    });
}
function $d49ba35090ee3f46$var$adapt(r, e, n, t) {
    var o = r.operations.convert(r, "XYZ", e), s = r.operations.convert(r, "lms", n);
    if (t) a = r.operations.convert(r, "lms", t);
    else var a = r.operations.convert(r, "lms", r.helpers.getIlluminant("D65"));
    var i = r.helpers.getTransform("BRADFORD"), c = r.helpers.getTransform("INVERSE_BRADFORD"), u = [
        [
            s.rho / a.rho,
            0,
            0
        ],
        [
            0,
            s.gamma / a.gamma,
            0
        ],
        [
            0,
            0,
            s.beta / a.beta
        ]
    ], l = r.helpers.matrixMultiply(c, u), h = r.helpers.matrixMultiply(l, i), v = [
        [
            o.X
        ],
        [
            o.Y
        ],
        [
            o.Z
        ]
    ], p = r.helpers.matrixMultiply(h, v), f = {
        X: p[0][0],
        Y: p[1][0],
        Z: p[2][0]
    };
    return r.helpers.ready(r, f);
}
function $d49ba35090ee3f46$var$adjacent(r, e, n, t) {
    for(var o = r.operations.convert(r, "hsl", t), s = [
        {
            h: o.h,
            s: o.s,
            l: o.l
        }
    ], a = 0; a < n - 1; a++)o.h = r.helpers.negMod(o.h + e, 360), s.push({
        h: o.h,
        s: o.s,
        l: o.l
    });
    return r.helpers.ready(r, s);
}
function $d49ba35090ee3f46$var$brightness(r, e, n) {
    var t = r.operations.convert(r, "hsl", n);
    return t.l += e, t.l < 0 ? t.l = 0 : t.l > 100 && (t.l = 100), r.helpers.ready(r, t);
}
function $d49ba35090ee3f46$var$complementary(r, e) {
    var n = r.operations.convert(r, "hsl", e);
    return n.h = (n.h + 180) % 360, r.helpers.ready(r, n);
}
function $d49ba35090ee3f46$var$contrast(r, e, n) {
    var t = r.operations.convert(r, "rgb", n);
    return t.r = 255 * ((t.r / 255 - .5) * e + .5), t.r < 0 ? t.r = 0 : t.r > 255 && (t.r = 255), t.g = 255 * ((t.g / 255 - .5) * e + .5), t.g < 0 ? t.g = 0 : t.g > 255 && (t.g = 255), t.b = 255 * ((t.b / 255 - .5) * e + .5), t.b < 0 ? t.b = 0 : t.b > 255 && (t.b = 255), r.helpers.ready(r, t);
}
function $d49ba35090ee3f46$var$contrastRatio(r, e) {
    var n = r.operations.convert(r, "rgb", e);
    return n = (299 * n.r + 587 * n.g + 114 * n.b) / 1e3 >= 128 ? {
        r: 0,
        g: 0,
        b: 0
    } : {
        r: 255,
        g: 255,
        b: 255
    }, r.helpers.ready(r, n);
}
function $d49ba35090ee3f46$var$convert(r, e, n) {
    if (Object.keys(r.conversions).indexOf(e) > -1) {
        n.colour ? n = n.colour : n.colours && (n = n.colours);
        var t = r.helpers.determineMode(n);
        return t != e ? r.conversions[t].convert(r, e, n) : n;
    }
    return r.helpers.ready(r, e);
}
function $d49ba35090ee3f46$var$difference(r, e, n, t, o) {
    t = t || 1, o = o || 1;
    var s = r.operations.convert(r, "cielab", e), a = r.operations.convert(r, "cielab", n), i = Math.sqrt(Math.pow(s.a, 2) + Math.pow(s.b, 2)), c = i - Math.sqrt(Math.pow(a.a, 2) + Math.pow(a.b, 2)), u = s.L - a.L, l = s.a - a.a, h = s.b - a.b, v = Math.sqrt(Math.pow(l, 2) + Math.pow(h, 2) - Math.pow(c, 2)), p = s.L < 16 ? .511 : .040975 * s.L / (1.01765 * s.L), f = .0638 * i / (1.0131 * i), m = Math.atan2(s.b, s.a), d = m >= 0 ? m : m + 360, b = 164 <= d && d <= 345 ? .56 + Math.abs(.2 * Math.cos(r.helpers.toRad(d + 168))) : .36 + Math.abs(.4 * Math.cos(r.helpers.toRad(d + 35))), g = Math.pow(i, 4) / (Math.pow(i, 4) + 1900), y = f * (g * b + 1 - g), _ = Math.pow(u / (t * p), 2);
    return Math.sqrt(_ + _ + _);
}
function $d49ba35090ee3f46$var$fade(r, e, n, t) {
    var o = r.operations.convert(r, "rgb", n), s = r.operations.convert(r, "rgb", t), a = [
        o
    ];
    e -= 1;
    for(var i = (s.r - o.r) / e, c = (s.g - o.g) / e, u = (s.b - o.b) / e, l = {
        r: o.r,
        g: o.g,
        b: o.b
    }, h = 0; h < e - 1; h++)l.r = r.helpers.slopeMod(l.r + i, 255), l.g = r.helpers.slopeMod(l.g + c, 255), l.b = r.helpers.slopeMod(l.b + u, 255), a.push({
        r: l.r,
        g: l.g,
        b: l.b
    });
    return a.push(s), r.helpers.ready(r, a);
}
function $d49ba35090ee3f46$var$greyscale(r, e) {
    var n = r.operations.convert(r, "rgb", e), t = (n.r + n.g + n.b) / 3;
    return n = {
        r: t,
        g: t,
        b: t
    }, r.helpers.ready(r, n);
}
function $d49ba35090ee3f46$var$hue(r, e, n) {
    var t = r.operations.convert(r, "hsl", n);
    return t.h = r.helpers.negMod(t.h + e, 360), r.helpers.ready(r, t);
}
function $d49ba35090ee3f46$var$invert(r, e) {
    var n = r.operations.convert(r, "rgb", e);
    return n.r = r.helpers.negMod(255 - n.r, 255), n.g = r.helpers.negMod(255 - n.g, 255), n.b = r.helpers.negMod(255 - n.b, 255), r.helpers.ready(r, n);
}
function $d49ba35090ee3f46$var$invertLightness(r, e) {
    var n = r.operations.convert(r, "hsl", e);
    return n.l = 100 - n.l, r.helpers.ready(r, n);
}
function $d49ba35090ee3f46$var$mid(r, e, n) {
    var t = r.operations.convert(r, "hsl", e), o = r.operations.convert(r, "hsl", n), s = {
        h: (t.h + o.h) / 2,
        s: (t.s + o.s) / 2,
        l: (t.l + o.l) / 2
    };
    return r.helpers.ready(r, s);
}
function $d49ba35090ee3f46$var$multiply(r, e, n) {
    var t = r.operations.convert(r, "hsl", e), o = r.operations.convert(r, "hsl", n), s = {
        h: t.h,
        s: t.s,
        l: t.l / 100 * (o.l / 100) * 100
    };
    return s.l = s.l > 100 ? 100 : s.l, s.l = s.l < 0 ? 0 : s.l, r.helpers.ready(r, s);
}
function $d49ba35090ee3f46$var$saturation(r, e, n) {
    var t = r.operations.convert(r, "hsl", n);
    return t.s += e, t.s < 0 ? t.s = 0 : t.s > 100 && (t.s = 100), r.helpers.ready(r, t);
}
function $d49ba35090ee3f46$var$sepia(r, e) {
    var n = r.operations.convert(r, "rgb", e), t = {};
    return t.r = .393 * n.r + .769 * n.g + .189 * n.b, t.g = .349 * n.r + .686 * n.g + .168 * n.b, t.b = .272 * n.r + .534 * n.g + .131 * n.b, r.helpers.ready(r, t);
}
function $d49ba35090ee3f46$var$shade(r, e, n) {
    var t = r.operations.convert(r, "hsv", n);
    return t.v += e, t.v < 0 ? t.v = 0 : t.v > 100 && (t.v = 100), r.helpers.ready(r, t);
}
function $d49ba35090ee3f46$var$temperature(r, e) {
    var n = r.operations.convert(r, "xyY", e), t = (n.x - .332) / (n.y - .1858);
    return -449 * Math.pow(t, 3) + 3525 * Math.pow(t, 2) - 6823.3 * t + 5520.33;
}
function $d49ba35090ee3f46$var$tetrad(r, e) {
    for(var n = r.operations.convert(r, "hsl", e), t = [
        {
            h: n.h,
            s: n.s,
            l: n.l
        }
    ], o = 0; o < 3; o++)n.h = (n.h + 90) % 360, t.push({
        h: n.h,
        s: n.s,
        l: n.l
    });
    return r.helpers.ready(r, t);
}
function $d49ba35090ee3f46$var$triad(r, e) {
    for(var n = r.operations.convert(r, "hsl", e), t = [
        {
            h: n.h,
            s: n.s,
            l: n.l
        }
    ], o = 0; o < 2; o++)n.h = (n.h + 120) % 360, t.push({
        h: n.h,
        s: n.s,
        l: n.l
    });
    return r.helpers.ready(r, t);
}
var $d49ba35090ee3f46$var$fromHex_1 = $d49ba35090ee3f46$var$fromHex, $d49ba35090ee3f46$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(r) {
    return typeof r;
} : function(r) {
    return r && "function" == typeof Symbol && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
}, $d49ba35090ee3f46$var$slicedToArray = function() {
    function r(r, e) {
        var n = [], t = !0, o = !1, s = void 0;
        try {
            for(var a, i = r[Symbol.iterator](); !(t = (a = i.next()).done) && (n.push(a.value), !e || n.length !== e); t = !0);
        } catch (r) {
            o = !0, s = r;
        } finally{
            try {
                !t && i.return && i.return();
            } finally{
                if (o) throw s;
            }
        }
        return n;
    }
    return function(e, n) {
        if (Array.isArray(e)) return e;
        if (Symbol.iterator in Object(e)) return r(e, n);
        throw new TypeError("Invalid attempt to destructure non-iterable instance");
    };
}(), $d49ba35090ee3f46$var$toConsumableArray = function(r) {
    if (Array.isArray(r)) {
        for(var e = 0, n = Array(r.length); e < r.length; e++)n[e] = r[e];
        return n;
    }
    return Array.from(r);
}, $d49ba35090ee3f46$var$fromRgb_1 = $d49ba35090ee3f46$var$fromRgb, $d49ba35090ee3f46$var$fromCssRgb_1 = $d49ba35090ee3f46$var$fromCssRgb, $d49ba35090ee3f46$var$fromHsl_1 = $d49ba35090ee3f46$var$fromHsl, $d49ba35090ee3f46$var$fromCssHsl_1 = $d49ba35090ee3f46$var$fromCssHsl, $d49ba35090ee3f46$var$fromHsv_1 = $d49ba35090ee3f46$var$fromHsv, $d49ba35090ee3f46$var$fromCmyk_1 = $d49ba35090ee3f46$var$fromCmyk, $d49ba35090ee3f46$var$fromYiq_1 = $d49ba35090ee3f46$var$fromYiq, $d49ba35090ee3f46$var$fromXYZ_1 = $d49ba35090ee3f46$var$fromXYZ, $d49ba35090ee3f46$var$fromxyY_1 = $d49ba35090ee3f46$var$fromxyY, $d49ba35090ee3f46$var$fromLms_1 = $d49ba35090ee3f46$var$fromLms, $d49ba35090ee3f46$var$fromCieLab_1 = $d49ba35090ee3f46$var$fromCieLab, $d49ba35090ee3f46$var$fromCieLuv_1 = $d49ba35090ee3f46$var$fromCieLuv, $d49ba35090ee3f46$var$fromCieLch_1 = $d49ba35090ee3f46$var$fromCieLch, $d49ba35090ee3f46$var$fromHsluv = $d49ba35090ee3f46$var$fromCieLch$1, $d49ba35090ee3f46$var$index = {
    hex: {
        test: function(r) {
            return "string" == typeof r && "#" === r.slice(0, 1);
        },
        convert: $d49ba35090ee3f46$var$fromHex_1
    },
    rgb: {
        test: function(r) {
            return $d49ba35090ee3f46$var$contains(r, [
                "r",
                "g",
                "b"
            ]);
        },
        convert: $d49ba35090ee3f46$var$fromRgb_1
    },
    cssrgb: {
        test: function(r) {
            return "string" == typeof r && "rgb(" === r.slice(0, 4);
        },
        convert: $d49ba35090ee3f46$var$fromCssRgb_1
    },
    hsl: {
        test: function(r) {
            return $d49ba35090ee3f46$var$contains(r, [
                "h",
                "s",
                "l"
            ]);
        },
        convert: $d49ba35090ee3f46$var$fromHsl_1
    },
    csshsl: {
        test: function(r) {
            return "string" == typeof r && "hsl(" === r.slice(0, 4);
        },
        convert: $d49ba35090ee3f46$var$fromCssHsl_1
    },
    hsv: {
        test: function(r) {
            return $d49ba35090ee3f46$var$contains(r, [
                "h",
                "s",
                "v"
            ]);
        },
        convert: $d49ba35090ee3f46$var$fromHsv_1
    },
    cmyk: {
        test: function(r) {
            return $d49ba35090ee3f46$var$contains(r, [
                "c",
                "m",
                "y",
                "k"
            ]);
        },
        convert: $d49ba35090ee3f46$var$fromCmyk_1
    },
    yiq: {
        test: function(r) {
            return $d49ba35090ee3f46$var$contains(r, [
                "y",
                "i",
                "q"
            ]);
        },
        convert: $d49ba35090ee3f46$var$fromYiq_1
    },
    XYZ: {
        test: function(r) {
            return $d49ba35090ee3f46$var$contains(r, [
                "X",
                "Y",
                "Z"
            ]);
        },
        convert: $d49ba35090ee3f46$var$fromXYZ_1
    },
    xyY: {
        test: function(r) {
            return $d49ba35090ee3f46$var$contains(r, [
                "x",
                "y",
                "Y"
            ]);
        },
        convert: $d49ba35090ee3f46$var$fromxyY_1
    },
    lms: {
        test: function(r) {
            return $d49ba35090ee3f46$var$contains(r, [
                "rho",
                "gamma",
                "beta"
            ]);
        },
        convert: $d49ba35090ee3f46$var$fromLms_1
    },
    cielab: {
        test: function(r) {
            return $d49ba35090ee3f46$var$contains(r, [
                "L",
                "a",
                "b"
            ]);
        },
        convert: $d49ba35090ee3f46$var$fromCieLab_1
    },
    cieluv: {
        test: function(r) {
            return $d49ba35090ee3f46$var$contains(r, [
                "L",
                "u",
                "v"
            ]);
        },
        convert: $d49ba35090ee3f46$var$fromCieLuv_1
    },
    cielch: {
        test: function(r) {
            return $d49ba35090ee3f46$var$contains(r, [
                "L",
                "C",
                "h"
            ]);
        },
        convert: $d49ba35090ee3f46$var$fromCieLch_1
    },
    hsluv: {
        test: function(r) {
            return $d49ba35090ee3f46$var$contains(r, [
                "hu",
                "s",
                "l"
            ]);
        },
        convert: $d49ba35090ee3f46$var$fromHsluv
    }
}, $d49ba35090ee3f46$var$adapt_1 = $d49ba35090ee3f46$var$adapt, $d49ba35090ee3f46$var$adjacent_1 = $d49ba35090ee3f46$var$adjacent, $d49ba35090ee3f46$var$brightness_1 = $d49ba35090ee3f46$var$brightness, $d49ba35090ee3f46$var$complementary_1 = $d49ba35090ee3f46$var$complementary, $d49ba35090ee3f46$var$contrast_1 = $d49ba35090ee3f46$var$contrast, $d49ba35090ee3f46$var$contrastRatio_1 = $d49ba35090ee3f46$var$contrastRatio, $d49ba35090ee3f46$var$convert_1 = $d49ba35090ee3f46$var$convert, $d49ba35090ee3f46$var$difference_1 = $d49ba35090ee3f46$var$difference, $d49ba35090ee3f46$var$fade_1 = $d49ba35090ee3f46$var$fade, $d49ba35090ee3f46$var$greyscale_1 = $d49ba35090ee3f46$var$greyscale, $d49ba35090ee3f46$var$hue_1 = $d49ba35090ee3f46$var$hue, $d49ba35090ee3f46$var$invert_1 = $d49ba35090ee3f46$var$invert, $d49ba35090ee3f46$var$invertLightness_1 = $d49ba35090ee3f46$var$invertLightness, $d49ba35090ee3f46$var$mid_1 = $d49ba35090ee3f46$var$mid, $d49ba35090ee3f46$var$multiply_1 = $d49ba35090ee3f46$var$multiply, $d49ba35090ee3f46$var$saturation_1 = $d49ba35090ee3f46$var$saturation, $d49ba35090ee3f46$var$sepia_1 = $d49ba35090ee3f46$var$sepia, $d49ba35090ee3f46$var$shade_1 = $d49ba35090ee3f46$var$shade, $d49ba35090ee3f46$var$temperature_1 = $d49ba35090ee3f46$var$temperature, $d49ba35090ee3f46$var$tetrad_1 = $d49ba35090ee3f46$var$tetrad, $d49ba35090ee3f46$var$triad_1 = $d49ba35090ee3f46$var$triad, $d49ba35090ee3f46$var$index$2 = {
    adapt: $d49ba35090ee3f46$var$adapt_1,
    adjacent: $d49ba35090ee3f46$var$adjacent_1,
    brightness: $d49ba35090ee3f46$var$brightness_1,
    complementary: $d49ba35090ee3f46$var$complementary_1,
    contrast: $d49ba35090ee3f46$var$contrast_1,
    contrastRatio: $d49ba35090ee3f46$var$contrastRatio_1,
    convert: $d49ba35090ee3f46$var$convert_1,
    difference: $d49ba35090ee3f46$var$difference_1,
    fade: $d49ba35090ee3f46$var$fade_1,
    greyscale: $d49ba35090ee3f46$var$greyscale_1,
    hue: $d49ba35090ee3f46$var$hue_1,
    invert: $d49ba35090ee3f46$var$invert_1,
    invertLightness: $d49ba35090ee3f46$var$invertLightness_1,
    mid: $d49ba35090ee3f46$var$mid_1,
    multiply: $d49ba35090ee3f46$var$multiply_1,
    saturation: $d49ba35090ee3f46$var$saturation_1,
    sepia: $d49ba35090ee3f46$var$sepia_1,
    shade: $d49ba35090ee3f46$var$shade_1,
    temperature: $d49ba35090ee3f46$var$temperature_1,
    tetrad: $d49ba35090ee3f46$var$tetrad_1,
    triad: $d49ba35090ee3f46$var$triad_1
}, $d49ba35090ee3f46$var$constants = {
    ILLUMINANTS: {
        A: {
            X: 1.0985 * 100,
            Y: 100,
            Z: 35.585
        },
        B: {
            X: 99.072,
            Y: 100,
            Z: 85.223
        },
        C: {
            X: 98.074,
            Y: 100,
            Z: 118.232
        },
        D50: {
            X: 96.422,
            Y: 100,
            Z: 82.521
        },
        D55: {
            X: 95.682,
            Y: 100,
            Z: 92.149
        },
        D65: {
            X: 95.047,
            Y: 100,
            Z: 108.883
        },
        D75: {
            X: 94.972,
            Y: 100,
            Z: 122.638
        },
        E: {
            X: 100,
            Y: 100,
            Z: 100
        },
        F2: {
            X: .99186 * 100,
            Y: 100,
            Z: 67.393
        },
        F7: {
            X: 95.041,
            Y: 100,
            Z: 108.747
        },
        F11: {
            X: 1.00962 * 100,
            Y: 100,
            Z: 64.35
        }
    },
    TRANSFORMS: {
        BRADFORD: [
            [
                .8951,
                .2664,
                -0.1614
            ],
            [
                -0.7502,
                1.7135,
                .0367
            ],
            [
                .0389,
                -0.0685,
                1.0296
            ]
        ],
        INVERSE_BRADFORD: [
            [
                .9869929,
                -0.1470543,
                .1599627
            ],
            [
                .4323053,
                .5183603,
                .0492912
            ],
            [
                -0.0085287,
                .0400428,
                .9684867
            ]
        ],
        SRGB_XYZ: [
            [
                .4124,
                .3576,
                .1805
            ],
            [
                .2126,
                .7152,
                .0722
            ],
            [
                .0193,
                .1192,
                .9505
            ]
        ],
        INVERSE_SRGB_XYZ: [
            [
                3.2406,
                -1.5372,
                -0.4986
            ],
            [
                -0.9689,
                1.8758,
                .0415
            ],
            [
                .0557,
                -0.204,
                1.057
            ]
        ]
    }
}, $d49ba35090ee3f46$var$api = function(r, e, n) {
    var t = Object.keys(r.operations).reduce(function(e, t) {
        var o = r.operations[t];
        return e[t] = function() {
            for(var e = arguments.length, t = Array(e), s = 0; s < e; s++)t[s] = arguments[s];
            var a = t.slice(0).map(function(r) {
                return "object" === (void 0 === r ? "undefined" : $d49ba35090ee3f46$var$_typeof(r)) ? Object.assign({}, r) : r;
            });
            if (n && n.colours) return function e(n) {
                var t = n.map(function(n) {
                    if (Array.isArray(n)) {
                        var t = e(n);
                        return t.colours || t.colour;
                    }
                    var s = o.apply(void 0, [
                        r
                    ].concat($d49ba35090ee3f46$var$toConsumableArray(a), [
                        n
                    ]));
                    return "object" === (void 0 === s ? "undefined" : $d49ba35090ee3f46$var$_typeof(s)) ? s.colours || s.colour : s;
                });
                return "number" != typeof t[0] ? r.helpers.ready(r, t) : t;
            }(n.colours);
            return o.apply(void 0, [
                r
            ].concat($d49ba35090ee3f46$var$toConsumableArray(a), [
                n ? n.colour : void 0
            ]));
        }, e;
    }, {});
    return n || (t = Object.assign(t, e)), t;
}, $d49ba35090ee3f46$var$api_1 = $d49ba35090ee3f46$var$api, $d49ba35090ee3f46$var$helpers = {
    getIlluminant: function(r) {
        return $d49ba35090ee3f46$var$constants.ILLUMINANTS[r];
    },
    getTransform: function(r) {
        return $d49ba35090ee3f46$var$constants.TRANSFORMS[r];
    },
    matrixMultiply: function(r, e) {
        for(var n = [], t = 0; t < r.length; t++){
            n[t] = [];
            for(var o = 0; o < e[0].length; o++){
                for(var s = 0, a = 0; a < r[0].length; a++)s += r[t][a] * e[a][o];
                n[t][o] = s;
            }
        }
        return n;
    },
    cbrt: function(r) {
        if (Math.cbrt) return Math.cbrt(r);
        var e = Math.pow(Math.abs(r), 1 / 3);
        return r < 0 ? -e : e;
    },
    toRad: function(r) {
        return r * (Math.PI / 180);
    },
    toDeg: function(r) {
        return r * (180 / Math.PI);
    },
    negMod: function(r, e) {
        return (r % e + e) % e;
    },
    slopeMod: function(r) {
        function e(e, n) {
            return r.apply(this, arguments);
        }
        return e.toString = function() {
            return r.toString();
        }, e;
    }(function(r, e) {
        return r > 2 * e ? slopeMod(r - 2 * e, e) : r > e ? 2 * e - r : r < 0 ? slopeMod(r + 2 * e, e) : r;
    }),
    bounded: function(r, e) {
        return r < e[0] ? r = e[0] : r > e[1] && (r = e[1]), r;
    },
    boundedRgb: function(r) {
        var e = this, n = function(r) {
            return e.bounded(r, [
                0,
                255
            ]);
        };
        return {
            r: n(r.r),
            g: n(r.g),
            b: n(r.b)
        };
    },
    determineMode: function(r) {
        for(var e in $d49ba35090ee3f46$var$index)if ($d49ba35090ee3f46$var$index.hasOwnProperty(e) && $d49ba35090ee3f46$var$index[e].test(r)) return e;
        return null;
    },
    ready: function(r, e) {
        var n = r.conversions, t = r.operations, o = r.helpers, s = {};
        switch(Object.prototype.toString.call(e)){
            case "[object Object]":
            case "[object String]":
                s.colour = e;
                for(var a in n)n.hasOwnProperty(a) && function(r) {
                    Object.defineProperty(s, r, {
                        get: function() {
                            o.determineMode(e);
                            return t.convert({
                                conversions: n,
                                operations: t,
                                helpers: o
                            }, r, e);
                        },
                        enumerable: !0
                    });
                }(a);
                return s = Object.assign(s, $d49ba35090ee3f46$var$api_1({
                    conversions: n,
                    operations: t,
                    helpers: o
                }, $d49ba35090ee3f46$var$constants, s));
            case "[object Array]":
                s.colours = e;
                for(var i in n)n.hasOwnProperty(i) && function(r) {
                    Object.defineProperty(s, r, {
                        get: function() {
                            return function e(s) {
                                return s.map(function(s) {
                                    return Array.isArray(s) ? e(s) : t.convert({
                                        conversions: n,
                                        operations: t,
                                        helpers: o
                                    }, r, s);
                                });
                            }(e);
                        },
                        enumerable: !0
                    });
                }(i);
                return s = Object.assign(s, $d49ba35090ee3f46$var$api_1({
                    conversions: n,
                    operations: t,
                    helpers: o
                }, $d49ba35090ee3f46$var$constants, s));
            default:
                return null;
        }
    }
}, $d49ba35090ee3f46$var$helpers_1 = $d49ba35090ee3f46$var$helpers, $d49ba35090ee3f46$var$dependencies = {
    conversions: $d49ba35090ee3f46$var$index,
    operations: $d49ba35090ee3f46$var$index$2,
    helpers: $d49ba35090ee3f46$var$helpers_1
}, $d49ba35090ee3f46$var$entry = $d49ba35090ee3f46$var$api_1($d49ba35090ee3f46$var$dependencies, $d49ba35090ee3f46$var$constants);
var $d49ba35090ee3f46$export$2e2bcd8739ae039 = $d49ba35090ee3f46$var$entry;


function $3b261d7d4e24dc14$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $3b261d7d4e24dc14$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $3b261d7d4e24dc14$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($659b468336d903e3$exports)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $3b261d7d4e24dc14$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $3b261d7d4e24dc14$export$7229be6d7219ee6a = function hexToRGBA(hex) {
    var opacity = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
    var rgba = $3b261d7d4e24dc14$var$_objectSpread($3b261d7d4e24dc14$var$_objectSpread({}, (0, $d49ba35090ee3f46$export$2e2bcd8739ae039).convert(hex).rgb), {
        a: opacity
    });
    return "rgba(".concat(Object.values(rgba).join(", "), ")");
};
var $3b261d7d4e24dc14$export$bba5a971afe05444 = function getBoxShadow(color) {
    return "0 0 0 2px ".concat(color);
};
var $3b261d7d4e24dc14$var$hex = "[a-z0-9]";
var $3b261d7d4e24dc14$var$shortHandHexColorPattern = new RegExp("#(".concat($3b261d7d4e24dc14$var$hex, ")(").concat($3b261d7d4e24dc14$var$hex, ")(").concat($3b261d7d4e24dc14$var$hex, ")"), "i");
var $3b261d7d4e24dc14$var$repeat = function repeat(str, times) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($753005c0c019cc18$exports)))(Array(times)).map(function() {
        return str;
    }).join("");
};
var $3b261d7d4e24dc14$var$isShortHexColor = function isShortHexColor(color) {
    return color && color.length === 4;
};
var $3b261d7d4e24dc14$var$completeHexColor = function completeHexColor(colors) {
    var hex = colors.map(function(color) {
        return $3b261d7d4e24dc14$var$repeat(color, 2);
    }).join("");
    return "#".concat(hex);
};
var $3b261d7d4e24dc14$var$completeTriplet = function completeTriplet(colors) {
    return "#".concat($3b261d7d4e24dc14$var$repeat(colors[1], 6));
};
var $3b261d7d4e24dc14$var$isTriplet = function isTriplet(colors) {
    return colors[0] === colors[1] && colors[1] === colors[2];
};
var $3b261d7d4e24dc14$export$db8d2130677f868c = function convertHexShorthand(color) {
    if ($3b261d7d4e24dc14$var$isShortHexColor(color)) {
        // when color = '#ccc', matches is structured as ['#ccc', 'c', 'c', 'c', ...]
        var matches = color.match($3b261d7d4e24dc14$var$shortHandHexColorPattern);
        if (matches) {
            var colors = matches.slice(1, 4);
            if ($3b261d7d4e24dc14$var$isTriplet(colors)) return $3b261d7d4e24dc14$var$completeTriplet(colors);
            else return $3b261d7d4e24dc14$var$completeHexColor(colors);
        }
    }
    // return the color as is when it's not hex color shorthand
    return color;
};
var $3b261d7d4e24dc14$export$10a10e7cd1193377 = function generateTextColor(color) {
    var converted = $3b261d7d4e24dc14$export$db8d2130677f868c(color);
    return (0, $d49ba35090ee3f46$export$2e2bcd8739ae039).contrastRatio(converted).hex;
};
var $3b261d7d4e24dc14$export$77a1051494882576 = function getContrastColor(contrastValue, opacityValue, color) {
    return $3b261d7d4e24dc14$export$7229be6d7219ee6a((0, $d49ba35090ee3f46$export$2e2bcd8739ae039).contrast(contrastValue, color).hex, opacityValue);
};


var $51572b14f1052191$var$defaultTheme = {
    mode: {
        create: {
            active: {
                color: "var(--ds-text-inverse, ".concat((0, $bbdbd5c17cc03a8e$export$29a4f05edc054374), ")"),
                backgroundColor: "var(--ds-background-brand-bold-pressed, ".concat((0, $3b261d7d4e24dc14$export$7229be6d7219ee6a)((0, $bbdbd5c17cc03a8e$export$b3de0ae08da2ce64), 0.8), ")"),
                boxShadow: ""
            },
            default: {
                color: "var(--ds-text-inverse, ".concat((0, $bbdbd5c17cc03a8e$export$29a4f05edc054374), ")"),
                backgroundColor: "var(--ds-background-brand-bold, ".concat((0, $bbdbd5c17cc03a8e$export$b3de0ae08da2ce64), ")"),
                boxShadow: ""
            },
            focus: {
                color: "var(--ds-text-inverse, ".concat((0, $bbdbd5c17cc03a8e$export$29a4f05edc054374), ")"),
                backgroundColor: "",
                boxShadow: ""
            },
            hover: {
                color: "var(--ds-text-inverse, ".concat((0, $bbdbd5c17cc03a8e$export$29a4f05edc054374), ")"),
                backgroundColor: "var(--ds-background-brand-bold-hovered, ".concat((0, $3b261d7d4e24dc14$export$7229be6d7219ee6a)((0, $bbdbd5c17cc03a8e$export$b3de0ae08da2ce64), 0.9), ")"),
                boxShadow: ""
            },
            selected: {
                color: "",
                backgroundColor: "",
                boxShadow: ""
            }
        },
        iconButton: {
            active: {
                color: "var(--ds-text-subtle, ".concat((0, $bbdbd5c17cc03a8e$export$b3de0ae08da2ce64), ")"),
                backgroundColor: "var(--ds-background-neutral-pressed, ".concat((0, $3b261d7d4e24dc14$export$7229be6d7219ee6a)((0, $bbdbd5c17cc03a8e$export$226de0355ed012f8), 0.6), ")"),
                boxShadow: ""
            },
            default: {
                color: "var(--ds-text-subtle, ".concat((0, $bbdbd5c17cc03a8e$export$7090862dc3038a9f), ")"),
                backgroundColor: "transparent",
                boxShadow: ""
            },
            focus: {
                color: "var(--ds-text-subtle, ".concat((0, $bbdbd5c17cc03a8e$export$7090862dc3038a9f), ")"),
                backgroundColor: "",
                boxShadow: ""
            },
            hover: {
                color: "var(--ds-text-subtle, ".concat((0, $bbdbd5c17cc03a8e$export$b3de0ae08da2ce64), ")"),
                backgroundColor: "var(--ds-background-neutral-hovered, ".concat((0, $3b261d7d4e24dc14$export$7229be6d7219ee6a)((0, $bbdbd5c17cc03a8e$export$226de0355ed012f8), 0.9), ")"),
                boxShadow: ""
            },
            selected: {
                color: "var(--ds-text-selected, ".concat((0, $bbdbd5c17cc03a8e$export$b3de0ae08da2ce64), ")"),
                backgroundColor: "var(--ds-background-selected, ".concat((0, $3b261d7d4e24dc14$export$7229be6d7219ee6a)((0, $bbdbd5c17cc03a8e$export$226de0355ed012f8), 0.6), ")"),
                boxShadow: ""
            },
            selectedHover: {
                color: "var(--ds-text-selected, ".concat((0, $bbdbd5c17cc03a8e$export$b3de0ae08da2ce64), ")"),
                backgroundColor: "var(--ds-background-selected-hovered, ".concat((0, $3b261d7d4e24dc14$export$7229be6d7219ee6a)((0, $bbdbd5c17cc03a8e$export$226de0355ed012f8), 0.6), ")"),
                boxShadow: ""
            }
        },
        navigation: {
            backgroundColor: "var(--ds-surface, ".concat((0, $bbdbd5c17cc03a8e$export$29a4f05edc054374), ")"),
            color: "var(--ds-text-subtlest, ".concat((0, $bbdbd5c17cc03a8e$export$f563ee71e9ee74cd), ")")
        },
        productHome: {
            backgroundColor: "var(--ds-text-brand, ".concat((0, $bbdbd5c17cc03a8e$export$b3de0ae08da2ce64), ")"),
            color: "var(--ds-text, ".concat((0, $bbdbd5c17cc03a8e$export$ad0bacf983b7ddaa), ")"),
            borderRight: "1px solid ".concat("var(--ds-border, ".concat((0, $3b261d7d4e24dc14$export$7229be6d7219ee6a)((0, $bbdbd5c17cc03a8e$export$f563ee71e9ee74cd), 0.3), ")")),
            // TODO: (DSP-1256) These colors should be moved into the Logo package
            // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
            iconGradientStart: (0, $bbdbd5c17cc03a8e$export$b3de0ae08da2ce64),
            // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
            iconGradientStop: (0, $bbdbd5c17cc03a8e$export$215b7063051591f1),
            // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
            iconColor: (0, $af5ef12ad3f1989a$export$470e5c2be1411c89)("platform.design-system-team.brand-refresh-update-product-logos_q7coo") ? "#357DE8" : (0, $bbdbd5c17cc03a8e$export$215b7063051591f1)
        },
        primaryButton: {
            active: {
                color: "var(--ds-text-subtle, ".concat((0, $bbdbd5c17cc03a8e$export$b3de0ae08da2ce64), ")"),
                backgroundColor: "var(--ds-background-neutral-pressed, ".concat((0, $3b261d7d4e24dc14$export$7229be6d7219ee6a)((0, $bbdbd5c17cc03a8e$export$226de0355ed012f8), 0.7), ")"),
                boxShadow: ""
            },
            default: {
                color: "var(--ds-text-subtle, ".concat((0, $bbdbd5c17cc03a8e$export$7090862dc3038a9f), ")"),
                backgroundColor: "transparent",
                boxShadow: ""
            },
            focus: {
                color: "var(--ds-text-subtle, ".concat((0, $bbdbd5c17cc03a8e$export$7090862dc3038a9f), ")"),
                backgroundColor: "",
                boxShadow: ""
            },
            hover: {
                color: "var(--ds-text-subtle, ".concat((0, $bbdbd5c17cc03a8e$export$b3de0ae08da2ce64), ")"),
                backgroundColor: "var(--ds-background-neutral-hovered, ".concat((0, $3b261d7d4e24dc14$export$7229be6d7219ee6a)((0, $bbdbd5c17cc03a8e$export$226de0355ed012f8), 0.9), ")"),
                boxShadow: ""
            },
            selected: {
                color: "var(--ds-text-selected, ".concat((0, $bbdbd5c17cc03a8e$export$b3de0ae08da2ce64), ")"),
                backgroundColor: "var(--ds-background-selected, ".concat((0, $3b261d7d4e24dc14$export$7229be6d7219ee6a)((0, $bbdbd5c17cc03a8e$export$226de0355ed012f8), 0.7), ")"),
                boxShadow: "",
                borderColor: "var(--ds-border-selected, ".concat((0, $bbdbd5c17cc03a8e$export$b3de0ae08da2ce64), ")")
            },
            selectedHover: {
                color: "var(--ds-text-selected, ".concat((0, $bbdbd5c17cc03a8e$export$b3de0ae08da2ce64), ")"),
                backgroundColor: "var(--ds-background-selected-hovered, ".concat((0, $3b261d7d4e24dc14$export$7229be6d7219ee6a)((0, $bbdbd5c17cc03a8e$export$226de0355ed012f8), 0.6), ")"),
                boxShadow: "",
                borderColor: "var(--ds-border-selected, ".concat((0, $bbdbd5c17cc03a8e$export$b3de0ae08da2ce64), ")")
            }
        },
        search: {
            default: {
                backgroundColor: "var(--ds-background-input, ".concat((0, $bbdbd5c17cc03a8e$export$29a4f05edc054374), ")"),
                color: "var(--ds-text-subtlest, ".concat((0, $bbdbd5c17cc03a8e$export$f563ee71e9ee74cd), ")"),
                borderColor: "var(--ds-border-input, ".concat((0, $af5ef12ad3f1989a$export$470e5c2be1411c89)("platform.design-system-team.border-checkbox_nyoiu") ? (0, $bbdbd5c17cc03a8e$export$d6447c357493214f) : (0, $bbdbd5c17cc03a8e$export$1ce2d1575d444ceb), ")")
            },
            focus: {
                borderColor: "var(--ds-border-focused, ".concat((0, $bbdbd5c17cc03a8e$export$215b7063051591f1), ")")
            },
            hover: {
                backgroundColor: "var(--ds-background-input-hovered, ".concat((0, $bbdbd5c17cc03a8e$export$29a4f05edc054374), ")")
            }
        },
        skeleton: {
            backgroundColor: "var(--ds-background-neutral, ".concat((0, $bbdbd5c17cc03a8e$export$9fdfb749e33cdf97), ")"),
            opacity: 1
        }
    }
};
var $51572b14f1052191$export$2491e13b198e597d = "atlassian";
var $51572b14f1052191$export$2e2bcd8739ae039 = $51572b14f1052191$var$defaultTheme;





function $ccde517e706abf3b$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $ccde517e706abf3b$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $ccde517e706abf3b$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($659b468336d903e3$exports)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $ccde517e706abf3b$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $ccde517e706abf3b$var$generateOpacityValue = function generateOpacityValue(color) {
    return color === "#000000" ? 0.3 : 0.6;
};
// eslint-disable-next-line @repo/internal/react/consistent-types-definitions
var $ccde517e706abf3b$var$generateButtonCSSStates = function generateButtonCSSStates(colors, buttonType) {
    var backgroundColor = colors.backgroundColor, color = colors.color, highlightColor = colors.highlightColor;
    // Add less opacity for white text so it is still legible.
    var opacityValue = $ccde517e706abf3b$var$generateOpacityValue(color);
    var isCreateButton = buttonType === "create";
    return {
        active: {
            backgroundColor: isCreateButton ? (0, $3b261d7d4e24dc14$export$7229be6d7219ee6a)(backgroundColor, 0.65) : (0, $3b261d7d4e24dc14$export$77a1051494882576)(0.3, opacityValue, backgroundColor),
            boxShadow: (0, $3b261d7d4e24dc14$export$bba5a971afe05444)("transparent"),
            color: color
        },
        default: {
            backgroundColor: backgroundColor,
            boxShadow: (0, $3b261d7d4e24dc14$export$bba5a971afe05444)("transparent"),
            color: color
        },
        focus: {
            boxShadow: "none",
            color: color,
            backgroundColor: backgroundColor
        },
        hover: {
            backgroundColor: isCreateButton ? (0, $3b261d7d4e24dc14$export$7229be6d7219ee6a)(backgroundColor, 0.8) : (0, $3b261d7d4e24dc14$export$77a1051494882576)(0.1, opacityValue, backgroundColor),
            boxShadow: (0, $3b261d7d4e24dc14$export$bba5a971afe05444)("transparent"),
            color: color
        },
        selected: {
            color: color,
            backgroundColor: (0, $3b261d7d4e24dc14$export$77a1051494882576)(0.3, opacityValue, backgroundColor),
            borderColor: highlightColor,
            boxShadow: (0, $3b261d7d4e24dc14$export$bba5a971afe05444)("transparent")
        },
        selectedHover: {
            color: color,
            backgroundColor: (0, $3b261d7d4e24dc14$export$77a1051494882576)(0.3, opacityValue, backgroundColor),
            borderColor: highlightColor,
            boxShadow: (0, $3b261d7d4e24dc14$export$bba5a971afe05444)("transparent")
        }
    };
};
var $ccde517e706abf3b$var$generateCreateButtonColors = function generateCreateButtonColors(themeBackground, themeHighlight) {
    return {
        backgroundColor: themeHighlight,
        color: (0, $3b261d7d4e24dc14$export$10a10e7cd1193377)(themeHighlight),
        highlightColor: themeHighlight
    };
};
var $ccde517e706abf3b$export$2e4ecffaca289a18 = function generateTheme(themeColors) {
    var backgroundColor = themeColors.backgroundColor, highlightColor = themeColors.highlightColor, name = themeColors.name;
    var color = (0, $3b261d7d4e24dc14$export$10a10e7cd1193377)(backgroundColor);
    var colors = $ccde517e706abf3b$var$_objectSpread($ccde517e706abf3b$var$_objectSpread({}, themeColors), {}, {
        color: color
    });
    if (name === (0, $51572b14f1052191$export$2491e13b198e597d)) return 0, $51572b14f1052191$export$2e2bcd8739ae039;
    return {
        mode: {
            create: $ccde517e706abf3b$var$generateButtonCSSStates($ccde517e706abf3b$var$generateCreateButtonColors(backgroundColor, highlightColor), "create"),
            iconButton: $ccde517e706abf3b$var$generateButtonCSSStates(colors, "iconButton"),
            primaryButton: $ccde517e706abf3b$var$generateButtonCSSStates(colors, "primaryButton"),
            navigation: {
                backgroundColor: backgroundColor,
                color: color
            },
            productHome: {
                color: color,
                backgroundColor: highlightColor,
                borderRight: "1px solid ".concat((0, $3b261d7d4e24dc14$export$7229be6d7219ee6a)(color, 0.5))
            },
            search: {
                default: {
                    backgroundColor: backgroundColor,
                    color: color,
                    borderColor: (0, $3b261d7d4e24dc14$export$7229be6d7219ee6a)(color, 0.5)
                },
                focus: {
                    borderColor: (0, $3b261d7d4e24dc14$export$7229be6d7219ee6a)(highlightColor, 0.8),
                    boxShadow: (0, $3b261d7d4e24dc14$export$bba5a971afe05444)((0, $3b261d7d4e24dc14$export$7229be6d7219ee6a)(highlightColor, 0.5))
                },
                hover: {
                    backgroundColor: (0, $3b261d7d4e24dc14$export$77a1051494882576)(0.1, $ccde517e706abf3b$var$generateOpacityValue(color), backgroundColor),
                    color: color
                }
            },
            skeleton: {
                backgroundColor: color,
                opacity: 0.08
            }
        }
    };
};
var $ccde517e706abf3b$export$2e2bcd8739ae039 = $ccde517e706abf3b$export$2e4ecffaca289a18;


var $d03dce0456a4ec9e$export$eeee8619e1b91cb0 = (0, $ccde517e706abf3b$export$2e4ecffaca289a18)({
    name: (0, $51572b14f1052191$export$2491e13b198e597d),
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
    backgroundColor: (0, $bbdbd5c17cc03a8e$export$29a4f05edc054374),
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
    highlightColor: (0, $bbdbd5c17cc03a8e$export$b3de0ae08da2ce64)
});
var $d03dce0456a4ec9e$export$164de7ab8df77ef0 = $d03dce0456a4ec9e$export$eeee8619e1b91cb0;


var $dAx5m = parcelRequire("dAx5m");

var $0c371fb60a7c6f5e$export$2c657da244d00bd6 = /*#__PURE__*/ (0, $dAx5m.createContext)((0, $d03dce0456a4ec9e$export$164de7ab8df77ef0));
var $0c371fb60a7c6f5e$export$d8964aec282183a3 = $0c371fb60a7c6f5e$export$2c657da244d00bd6.Provider;


var $147dc3434bd55d1d$exports = {};
function $147dc3434bd55d1d$var$_extends() {
    return $147dc3434bd55d1d$exports = $147dc3434bd55d1d$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $147dc3434bd55d1d$exports.__esModule = true, $147dc3434bd55d1d$exports["default"] = $147dc3434bd55d1d$exports, $147dc3434bd55d1d$var$_extends.apply(null, arguments);
}
$147dc3434bd55d1d$exports = $147dc3434bd55d1d$var$_extends, $147dc3434bd55d1d$exports.__esModule = true, $147dc3434bd55d1d$exports["default"] = $147dc3434bd55d1d$exports;


var $96b147e8280c5691$exports = {};
var $416229d94af96b09$exports = {};
function $416229d94af96b09$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
$416229d94af96b09$exports = $416229d94af96b09$var$_arrayWithHoles, $416229d94af96b09$exports.__esModule = true, $416229d94af96b09$exports["default"] = $416229d94af96b09$exports;


var $380150459fa68226$exports = {};
function $380150459fa68226$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
$380150459fa68226$exports = $380150459fa68226$var$_iterableToArrayLimit, $380150459fa68226$exports.__esModule = true, $380150459fa68226$exports["default"] = $380150459fa68226$exports;



var $5b7c5ef1f155b4cd$exports = {};
function $5b7c5ef1f155b4cd$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
$5b7c5ef1f155b4cd$exports = $5b7c5ef1f155b4cd$var$_nonIterableRest, $5b7c5ef1f155b4cd$exports.__esModule = true, $5b7c5ef1f155b4cd$exports["default"] = $5b7c5ef1f155b4cd$exports;


function $96b147e8280c5691$var$_slicedToArray(r, e) {
    return $416229d94af96b09$exports(r) || $380150459fa68226$exports(r, e) || $a6d1ee6d681d70fa$exports(r, e) || $5b7c5ef1f155b4cd$exports();
}
$96b147e8280c5691$exports = $96b147e8280c5691$var$_slicedToArray, $96b147e8280c5691$exports.__esModule = true, $96b147e8280c5691$exports["default"] = $96b147e8280c5691$exports;



var $dAx5m = parcelRequire("dAx5m");

var $jVTBW = parcelRequire("jVTBW");

var $7vqkt = parcelRequire("7vqkt");

var $dAx5m = parcelRequire("dAx5m");
var $fffc53ad4733fd41$exports = {};
var $9bf3f9276c45e2f8$exports = {};
function $9bf3f9276c45e2f8$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
$9bf3f9276c45e2f8$exports = $9bf3f9276c45e2f8$var$_arrayWithHoles, $9bf3f9276c45e2f8$exports.__esModule = true, $9bf3f9276c45e2f8$exports["default"] = $9bf3f9276c45e2f8$exports;


var $6218a789e2cc62a3$exports = {};
function $6218a789e2cc62a3$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
$6218a789e2cc62a3$exports = $6218a789e2cc62a3$var$_iterableToArrayLimit, $6218a789e2cc62a3$exports.__esModule = true, $6218a789e2cc62a3$exports["default"] = $6218a789e2cc62a3$exports;


var $d09cd62bfd29f4ee$exports = {};
var $e5aeccb5fc6fd1b5$exports = {};
function $e5aeccb5fc6fd1b5$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
$e5aeccb5fc6fd1b5$exports = $e5aeccb5fc6fd1b5$var$_arrayLikeToArray, $e5aeccb5fc6fd1b5$exports.__esModule = true, $e5aeccb5fc6fd1b5$exports["default"] = $e5aeccb5fc6fd1b5$exports;


function $d09cd62bfd29f4ee$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $e5aeccb5fc6fd1b5$exports(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $e5aeccb5fc6fd1b5$exports(r, a) : void 0;
    }
}
$d09cd62bfd29f4ee$exports = $d09cd62bfd29f4ee$var$_unsupportedIterableToArray, $d09cd62bfd29f4ee$exports.__esModule = true, $d09cd62bfd29f4ee$exports["default"] = $d09cd62bfd29f4ee$exports;


var $a311be60d16b075b$exports = {};
function $a311be60d16b075b$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
$a311be60d16b075b$exports = $a311be60d16b075b$var$_nonIterableRest, $a311be60d16b075b$exports.__esModule = true, $a311be60d16b075b$exports["default"] = $a311be60d16b075b$exports;


function $fffc53ad4733fd41$var$_slicedToArray(r, e) {
    return $9bf3f9276c45e2f8$exports(r) || $6218a789e2cc62a3$exports(r, e) || $d09cd62bfd29f4ee$exports(r, e) || $a311be60d16b075b$exports();
}
$fffc53ad4733fd41$exports = $fffc53ad4733fd41$var$_slicedToArray, $fffc53ad4733fd41$exports.__esModule = true, $fffc53ad4733fd41$exports["default"] = $fffc53ad4733fd41$exports;



var $dAx5m = parcelRequire("dAx5m");


var $dAx5m = parcelRequire("dAx5m");
function $930718726049328a$export$2f62ee6831462844() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var ref = (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).useRef();
    var observerInstance = (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).useRef();
    var _React$useState = (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).useState({
        inView: false,
        entry: undefined,
        target: undefined
    }), _React$useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($fffc53ad4733fd41$exports)))(_React$useState, 2), state = _React$useState2[0], setState = _React$useState2[1];
    var threshold = options.threshold, root = options.root, rootMargin = options.rootMargin;
    var setRef = (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).useCallback(function(node) {
        observerInstance.current = new IntersectionObserver(function(entries) {
            if (entries && entries.length) {
                var intersection = entries[0];
                var isIntersecting = intersection.isIntersecting, intersectionRatio = intersection.intersectionRatio;
                if (intersectionRatio >= 0) {
                    var inView = intersectionRatio >= (threshold || 0);
                    if (isIntersecting !== undefined) inView = inView && isIntersecting;
                    setState({
                        inView: inView,
                        entry: intersection,
                        target: node
                    });
                }
            }
        }, {
            threshold: threshold,
            root: root,
            rootMargin: rootMargin
        });
        if (ref.current) observerInstance.current.unobserve(ref.current);
        if (node) observerInstance.current.observe(node);
        // Store a reference to the node
        ref.current = node;
    }, [
        threshold,
        root,
        rootMargin
    ]);
    /**
   * Unsubscribe IntersectionObserver before unmounting a component.
   */ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).useEffect(function() {
        return function() {
            if (observerInstance.current && ref.current) observerInstance.current.unobserve(ref.current);
        };
    }, []);
    return [
        setRef,
        state.inView,
        state.target,
        state.entry
    ];
}


var $961cf3a9bd2ac412$export$ff983d2a2b6112ea = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).memo(function(_ref) {
    var setWidth = _ref.setWidth, offscreen = _ref.offscreen;
    var _useInView = (0, $930718726049328a$export$2f62ee6831462844)({
        /* Optional options */ threshold: 0
    }), _useInView2 = (0, (/*@__PURE__*/$parcel$interopDefault($fffc53ad4733fd41$exports)))(_useInView, 3), inViewRef = _useInView2[0], inView = _useInView2[1], target = _useInView2[2];
    var observer = (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).useRef(function() {
        if (typeof window === "undefined") return null;
        // https://github.com/DefinitelyTyped/DefinitelyTyped/pull/40909
        // @ts-ignore
        return new ResizeObserver(function(entries) {
            if (!Array.isArray(entries) || !entries.length) return;
            var width = entries[0].contentRect.width;
            setWidth(Math.round(width));
        });
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).useEffect(function() {
        var currentObserver = observer.current;
        var resizeObserver = currentObserver();
        if (resizeObserver === null) return;
        if (target) {
            if (inView || offscreen) resizeObserver.observe(target);
            else resizeObserver.unobserve(target);
        }
        return function() {
            resizeObserver.disconnect();
        };
    }, [
        target,
        inView,
        offscreen
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement("div", {
        style: {
            display: "block",
            width: "100%",
            position: "absolute"
        },
        ref: inViewRef
    });
});


var $633a0c7fa4c70dcd$export$b2ad68b9bc407b80 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).memo(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $961cf3a9bd2ac412$export$ff983d2a2b6112ea), {
        setWidth: props.setWidth,
        offscreen: props.offscreen
    });
});
var $633a0c7fa4c70dcd$export$2e2bcd8739ae039 = $633a0c7fa4c70dcd$export$b2ad68b9bc407b80;




var $dAx5m = parcelRequire("dAx5m");
var $30c0045f222c0b2e$exports = {};
var $13b8fb4520826cc9$exports = {};

var $2fw24 = parcelRequire("2fw24");
var $48e74c8932a188d0$exports = {};

var $dLxmN = parcelRequire("dLxmN");
/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */ var $48e74c8932a188d0$var$now = function() {
    return $dLxmN.Date.now();
};
$48e74c8932a188d0$exports = $48e74c8932a188d0$var$now;



var $fIIJN = parcelRequire("fIIJN");
/** Error message constants. */ var $13b8fb4520826cc9$var$FUNC_ERROR_TEXT = "Expected a function";
/* Built-in method references for those with the same name as other `lodash` methods. */ var $13b8fb4520826cc9$var$nativeMax = Math.max, $13b8fb4520826cc9$var$nativeMin = Math.min;
/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */ function $13b8fb4520826cc9$var$debounce(func, wait, options) {
    var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
    if (typeof func != "function") throw new TypeError($13b8fb4520826cc9$var$FUNC_ERROR_TEXT);
    wait = $fIIJN(wait) || 0;
    if ($2fw24(options)) {
        leading = !!options.leading;
        maxing = "maxWait" in options;
        maxWait = maxing ? $13b8fb4520826cc9$var$nativeMax($fIIJN(options.maxWait) || 0, wait) : maxWait;
        trailing = "trailing" in options ? !!options.trailing : trailing;
    }
    function invokeFunc(time) {
        var args = lastArgs, thisArg = lastThis;
        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
    }
    function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
    }
    function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
        return maxing ? $13b8fb4520826cc9$var$nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
    }
    function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
    }
    function timerExpired() {
        var time = $48e74c8932a188d0$exports();
        if (shouldInvoke(time)) return trailingEdge(time);
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
    }
    function trailingEdge(time) {
        timerId = undefined;
        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) return invokeFunc(time);
        lastArgs = lastThis = undefined;
        return result;
    }
    function cancel() {
        if (timerId !== undefined) clearTimeout(timerId);
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
    }
    function flush() {
        return timerId === undefined ? result : trailingEdge($48e74c8932a188d0$exports());
    }
    function debounced() {
        var time = $48e74c8932a188d0$exports(), isInvoking = shouldInvoke(time);
        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;
        if (isInvoking) {
            if (timerId === undefined) return leadingEdge(lastCallTime);
            if (maxing) {
                // Handle invocations in a tight loop.
                clearTimeout(timerId);
                timerId = setTimeout(timerExpired, wait);
                return invokeFunc(lastCallTime);
            }
        }
        if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
        return result;
    }
    debounced.cancel = cancel;
    debounced.flush = flush;
    return debounced;
}
$13b8fb4520826cc9$exports = $13b8fb4520826cc9$var$debounce;



var $2fw24 = parcelRequire("2fw24");
/** Error message constants. */ var $30c0045f222c0b2e$var$FUNC_ERROR_TEXT = "Expected a function";
/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */ function $30c0045f222c0b2e$var$throttle(func, wait, options) {
    var leading = true, trailing = true;
    if (typeof func != "function") throw new TypeError($30c0045f222c0b2e$var$FUNC_ERROR_TEXT);
    if ($2fw24(options)) {
        leading = "leading" in options ? !!options.leading : leading;
        trailing = "trailing" in options ? !!options.trailing : trailing;
    }
    return $13b8fb4520826cc9$exports(func, wait, {
        "leading": leading,
        "maxWait": wait,
        "trailing": trailing
    });
}
$30c0045f222c0b2e$exports = $30c0045f222c0b2e$var$throttle;



var $Bb0he = parcelRequire("Bb0he");
// Prevent width detector from triggering too many re-renders
var $23c1a26819a49d2a$var$THROTTLE_INTERVAL = 64;
// Approx min width of items (based of "More" size)
var $23c1a26819a49d2a$var$ITEM_APPROX_MINWIDTH = 70;
var $23c1a26819a49d2a$var$calculateHash = function calculateHash(w, n) {
    return w + "#" + n;
};
var $23c1a26819a49d2a$var$updateHashRef = function updateHashRef(currentRef, value) {
    currentRef.unshift(value);
    currentRef.length = 3;
};
var $23c1a26819a49d2a$var$OverflowContext = /*#__PURE__*/ (0, $dAx5m.createContext)({
    isVisible: true,
    openOverflowMenu: (0, $Bb0he.default),
    closeOverflowMenu: (0, $Bb0he.default)
});
var $23c1a26819a49d2a$export$a3a2def3937905a0 = function OverflowProvider(_ref) {
    var children = _ref.children, isVisible = _ref.isVisible, openOverflowMenu = _ref.openOverflowMenu, closeOverflowMenu = _ref.closeOverflowMenu;
    var Provider = $23c1a26819a49d2a$var$OverflowContext.Provider;
    var value = (0, $dAx5m.useMemo)(function() {
        return {
            isVisible: isVisible,
            openOverflowMenu: openOverflowMenu,
            closeOverflowMenu: closeOverflowMenu
        };
    }, [
        isVisible,
        openOverflowMenu,
        closeOverflowMenu
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement(Provider, {
        value: value
    }, children);
};
var $23c1a26819a49d2a$export$3fcfc71fab3314f2 = function useOverflowStatus() {
    return (0, $dAx5m.useContext)($23c1a26819a49d2a$var$OverflowContext);
};
var $23c1a26819a49d2a$export$705aa66a39c35bf7 = function useOverflowController(nodes) {
    var items = (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).Children.toArray(nodes);
    var _useState = (0, $dAx5m.useState)(9999), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($96b147e8280c5691$exports)))(_useState, 2), width = _useState2[0], setWidth = _useState2[1];
    var _useState3 = (0, $dAx5m.useState)(items.length), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($96b147e8280c5691$exports)))(_useState3, 2), itemsLimit = _useState4[0], setItemsLimit = _useState4[1];
    var _useState5 = (0, $dAx5m.useState)({}), _useState6 = (0, (/*@__PURE__*/$parcel$interopDefault($96b147e8280c5691$exports)))(_useState5, 2), forceEffectValue = _useState6[0], triggerForceEffect = _useState6[1];
    // Storing items approximate width so we can try expanding when there is enough room
    var itemsWidths = (0, $dAx5m.useRef)([]).current;
    // Storing a couple of width + items count in order to stabilize
    var hashRef = (0, $dAx5m.useRef)([]);
    // AFP-2511 TODO: Fix automatic suppressions below
    // eslint-disable-next-line react-hooks/exhaustive-deps
    var throttleSetWidth = (0, $dAx5m.useCallback)((0, (/*@__PURE__*/$parcel$interopDefault($30c0045f222c0b2e$exports)))(setWidth, $23c1a26819a49d2a$var$THROTTLE_INTERVAL), [
        setWidth
    ]);
    (0, $dAx5m.useEffect)(function() {
        var lastItemWidth = itemsWidths[itemsLimit] || 0;
        var wasJustLimited = lastItemWidth < 0;
        var currentHash = $23c1a26819a49d2a$var$calculateHash(width, itemsLimit);
        if (hashRef.current[0] === currentHash) {
            // After removing an item, if width has not changed yet we schedule a force update
            // to handle case where removing an item does not actually trigger width change
            var t = setTimeout(function() {
                $23c1a26819a49d2a$var$updateHashRef(hashRef.current, "");
                triggerForceEffect({});
            }, $23c1a26819a49d2a$var$THROTTLE_INTERVAL * 1.5);
            return function() {
                return clearTimeout(t);
            };
        }
        if (wasJustLimited) {
            // Width was updated either via resize or after changing the limit
            // we cap the width between ITEM_APPROX_MINWIDTH and 2*ITEM_APPROX_MINWIDTH
            // because width is throttled as when fast expanding/resizing partialWidth
            // will not be reliable (edge case)
            var partialWidth = Math.max(Math.min(width + lastItemWidth, $23c1a26819a49d2a$var$ITEM_APPROX_MINWIDTH * 2), $23c1a26819a49d2a$var$ITEM_APPROX_MINWIDTH);
            itemsWidths[itemsLimit] = partialWidth;
        }
        if (width < $23c1a26819a49d2a$var$ITEM_APPROX_MINWIDTH * 0.9 && itemsLimit) {
            // If current width is less than an item approx width we remove an item
            // marking the width as negative so we will calculate it on width update
            // plus we set the hash to stabilise and not removing more than one element
            // until we are sure width was updated
            var nextHash = $23c1a26819a49d2a$var$calculateHash(width, itemsLimit - 1);
            if (hashRef.current.indexOf(nextHash) === -1) {
                setItemsLimit(itemsLimit - 1);
                itemsWidths[itemsLimit - 1] = -(width || 1);
                $23c1a26819a49d2a$var$updateHashRef(hashRef.current, nextHash);
            }
            return;
        }
        /**
     * This is not necessarily equal to `lastItemWidth` because the
     * ```js
     * if (wasJustLimited) {}
     * ```
     * branch above modifies `itemsWidths`.
     *
     * Using `lastItemWidth` here can cause collapsing behavior to fail,
     * such as the issue reported in DSP-7329.
     */ var currentLastItemWidth = itemsWidths[itemsLimit] || 0;
        if (width - currentLastItemWidth > $23c1a26819a49d2a$var$ITEM_APPROX_MINWIDTH * 1.1 && itemsLimit < items.length) {
            // If we have enough room to accomodate next item width we increase the limit
            // unless it has been recently removed
            var _nextHash = $23c1a26819a49d2a$var$calculateHash(width, itemsLimit + 1);
            if (hashRef.current.indexOf(_nextHash) === -1) {
                setItemsLimit(itemsLimit + 1);
                $23c1a26819a49d2a$var$updateHashRef(hashRef.current, _nextHash);
            }
            return;
        }
    }, [
        width,
        hashRef,
        itemsLimit,
        itemsWidths,
        forceEffectValue,
        items.length
    ]);
    return {
        visibleItems: items.slice(0, itemsLimit),
        overflowItems: items.slice(itemsLimit),
        updateWidth: throttleSetWidth
    };
};
var // Used to extract props for useOverflowStatus();
// eslint-disable-next-line @repo/internal/react/use-noop
$23c1a26819a49d2a$export$2e2bcd8739ae039 = function(props) {};




var $dAx5m = parcelRequire("dAx5m");

var $jVTBW = parcelRequire("jVTBW");
var $ce72403cb4576c12$exports = {};
"use strict";
Object.defineProperty($ce72403cb4576c12$exports, "__esModule", {
    value: true
});
$ce72403cb4576c12$exports.default = void 0;

var $ce72403cb4576c12$var$_react = $ce72403cb4576c12$var$_interopRequireDefault((parcelRequire("dAx5m")));

var $cada364311d44bd0$exports = {};
var $2ea47869f6c500a8$exports = {};
function $2ea47869f6c500a8$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.includes(n)) continue;
        t[n] = r[n];
    }
    return t;
}
$2ea47869f6c500a8$exports = $2ea47869f6c500a8$var$_objectWithoutPropertiesLoose, $2ea47869f6c500a8$exports.__esModule = true, $2ea47869f6c500a8$exports["default"] = $2ea47869f6c500a8$exports;


function $cada364311d44bd0$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $2ea47869f6c500a8$exports(e, t);
    if (Object.getOwnPropertySymbols) {
        var s = Object.getOwnPropertySymbols(e);
        for(r = 0; r < s.length; r++)o = s[r], t.includes(o) || ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
$cada364311d44bd0$exports = $cada364311d44bd0$var$_objectWithoutProperties, $cada364311d44bd0$exports.__esModule = true, $cada364311d44bd0$exports["default"] = $cada364311d44bd0$exports;



var $dAx5m = parcelRequire("dAx5m");

var $hlM0a = parcelRequire("hlM0a");



var $dAx5m = parcelRequire("dAx5m");

var $jVTBW = parcelRequire("jVTBW");
var $e2fa540d0e66dd98$export$c647cb0ee6e282fe = {
    small: "16px",
    medium: "24px",
    large: "32px",
    xlarge: "48px"
};
var $e2fa540d0e66dd98$export$7bd66fc94c81bf84 = {
    small: "small",
    medium: "medium",
    large: "large",
    xlarge: "xlarge"
};
var $e2fa540d0e66dd98$export$62ad7b0c781000e9 = {
    small: {
        width: $e2fa540d0e66dd98$export$c647cb0ee6e282fe.small,
        height: $e2fa540d0e66dd98$export$c647cb0ee6e282fe.small
    },
    medium: {
        width: $e2fa540d0e66dd98$export$c647cb0ee6e282fe.medium,
        height: $e2fa540d0e66dd98$export$c647cb0ee6e282fe.medium
    },
    large: {
        width: $e2fa540d0e66dd98$export$c647cb0ee6e282fe.large,
        height: $e2fa540d0e66dd98$export$c647cb0ee6e282fe.large
    },
    xlarge: {
        width: $e2fa540d0e66dd98$export$c647cb0ee6e282fe.xlarge,
        height: $e2fa540d0e66dd98$export$c647cb0ee6e282fe.xlarge
    }
};



var $jVTBW = parcelRequire("jVTBW");
var $564ed012667bc7bc$export$16374db1c3e6dfba = {
    overflow: "hidden",
    pointerEvents: "none",
    /**
   * Stop-color doesn't properly apply in chrome when the inherited/current color changes.
   * We have to initially set stop-color to inherit (either via DOM attribute or an initial CSS
   * rule) and then override it with currentColor for the color changes to be picked up.
   */ stop: {
        stopColor: "currentColor"
    }
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
var $564ed012667bc7bc$var$smallStyles = (0, $jVTBW.css)((0, $e2fa540d0e66dd98$export$62ad7b0c781000e9).small);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
var $564ed012667bc7bc$var$mediumStyles = (0, $jVTBW.css)((0, $e2fa540d0e66dd98$export$62ad7b0c781000e9).medium);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
var $564ed012667bc7bc$var$largeStyles = (0, $jVTBW.css)((0, $e2fa540d0e66dd98$export$62ad7b0c781000e9).large);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
var $564ed012667bc7bc$var$xlargeStyles = (0, $jVTBW.css)((0, $e2fa540d0e66dd98$export$62ad7b0c781000e9).xlarge);
var $564ed012667bc7bc$export$ef0ad74202575b64 = {
    small: $564ed012667bc7bc$var$smallStyles,
    medium: $564ed012667bc7bc$var$mediumStyles,
    large: $564ed012667bc7bc$var$largeStyles,
    xlarge: $564ed012667bc7bc$var$xlargeStyles
};
var $564ed012667bc7bc$export$3eb7d6130acfda37 = function getIconSize(_ref) {
    var width = _ref.width, height = _ref.height, size = _ref.size;
    if (width && height) return {
        width: width,
        height: height
    };
    if (size) return (0, $e2fa540d0e66dd98$export$62ad7b0c781000e9)[size];
    return undefined;
};


var $29487675a5cc61c9$export$18cb9425622d4e06 = function getBackground() {
    return "var(--ds-surface, #FFFFFF)";
};


function $2fa0080174637a37$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $2fa0080174637a37$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $2fa0080174637a37$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($659b468336d903e3$exports)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $2fa0080174637a37$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
/**
 * We are hiding these props from consumers as they're used to
 * hack around icon sizing specifically for icon-file-type.
 */ var $2fa0080174637a37$var$iconStyles = (0, $jVTBW.css)({
    display: "inline-block",
    flexShrink: 0,
    lineHeight: 1,
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    "> svg": $2fa0080174637a37$var$_objectSpread($2fa0080174637a37$var$_objectSpread({}, (0, $564ed012667bc7bc$export$16374db1c3e6dfba)), {}, {
        maxWidth: "100%",
        maxHeight: "100%",
        color: "var(--icon-primary-color)",
        fill: "var(--icon-secondary-color)",
        verticalAlign: "bottom"
    })
});
/**
 * For windows high contrast mode
 */ var $2fa0080174637a37$var$baseHcmStyles = (0, $jVTBW.css)({
    "@media screen and (forced-colors: active)": {
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        "> svg": {
            filter: "grayscale(1)",
            "--icon-primary-color": "CanvasText",
            // foreground
            "--icon-secondary-color": "Canvas" // background
        }
    }
});
var $2fa0080174637a37$var$primaryEqualsSecondaryHcmStyles = (0, $jVTBW.css)({
    "@media screen and (forced-colors: active)": {
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        "> svg": {
            // if the primaryColor is the same as the secondaryColor we
            // set the --icon-primary-color to Canvas
            // this is usually to convey state i.e. Checkbox checked -> not checked
            "--icon-primary-color": "Canvas" // foreground
        }
    }
});
var $2fa0080174637a37$var$secondaryTransparentHcmStyles = (0, $jVTBW.css)({
    "@media screen and (forced-colors: active)": {
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        "> svg": {
            "--icon-secondary-color": "transparent" // background
        }
    }
});
var $2fa0080174637a37$export$f04a61298a47a40f = /*#__PURE__*/ (0, $dAx5m.memo)(function Icon(props) {
    var _ref = props, Glyph = _ref.glyph, dangerouslySetGlyph = _ref.dangerouslySetGlyph, _ref$primaryColor = _ref.primaryColor, primaryColor = _ref$primaryColor === void 0 ? "currentColor" : _ref$primaryColor, secondaryColor = _ref.secondaryColor, size = _ref.size, testId = _ref.testId, label = _ref.label, width = _ref.width, height = _ref.height, UNSAFE_margin = _ref.UNSAFE_margin;
    var glyphProps = dangerouslySetGlyph ? {
        dangerouslySetInnerHTML: {
            __html: dangerouslySetGlyph
        }
    } : {
        children: Glyph ? (0, $jVTBW.jsx)(Glyph, {
            role: "presentation"
        }) : null
    };
    var dimensions = (0, $564ed012667bc7bc$export$3eb7d6130acfda37)({
        width: width,
        height: height,
        size: size
    });
    return (0, $jVTBW.jsx)("span", (0, (/*@__PURE__*/$parcel$interopDefault($147dc3434bd55d1d$exports)))({
        "data-testid": testId,
        "data-vc": "icon-".concat(testId),
        role: label ? "img" : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: $2fa0080174637a37$var$_objectSpread({
            "--icon-primary-color": primaryColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            "--icon-secondary-color": secondaryColor || (0, $29487675a5cc61c9$export$18cb9425622d4e06)()
        }, UNSAFE_margin ? {
            margin: UNSAFE_margin
        } : {})
    }, glyphProps, {
        css: [
            $2fa0080174637a37$var$iconStyles,
            $2fa0080174637a37$var$baseHcmStyles,
            primaryColor === secondaryColor && $2fa0080174637a37$var$primaryEqualsSecondaryHcmStyles,
            secondaryColor === "transparent" && $2fa0080174637a37$var$secondaryTransparentHcmStyles,
            // NB: This can be resolved if this component, composes base SVG / and/or skeleton
            // We could then simplify how common styles are dealt with simply by encapsulating them
            // at their appropriate level and/or having a singular approach to css variables in the package
            dimensions && // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $jVTBW.css)({
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                width: dimensions.width,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                height: dimensions.height,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                "> svg": dimensions
            })
        ]
    }));
});
var $2fa0080174637a37$export$2e2bcd8739ae039 = $2fa0080174637a37$export$f04a61298a47a40f;


var $2894c4a395f277dd$var$_excluded = [
    "dangerouslySetGlyph"
];
var $2894c4a395f277dd$var$sizesEligibleForNewIcons = [
    "small",
    "medium"
];
var $2894c4a395f277dd$export$3cfb73f70dfca966 = /*#__PURE__*/ (0, $dAx5m.memo)(function IconFacade(_ref) {
    var _props$size;
    var dangerouslySetGlyph = _ref.dangerouslySetGlyph, props = (0, (/*@__PURE__*/$parcel$interopDefault($cada364311d44bd0$exports)))(_ref, $2894c4a395f277dd$var$_excluded);
    var NewIcon = props.newIcon;
    // By default, the icon size will be medium and spacing will be none for small icons
    var size = (_props$size = props.size) !== null && _props$size !== void 0 ? _props$size : "medium";
    var spacing = size === "small" ? "none" : "spacious";
    var useNewIcon = !props.isFacadeDisabled && // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
    (0, $hlM0a.fg)("platform-visual-refresh-icons-legacy-facade") && $2894c4a395f277dd$var$sizesEligibleForNewIcons.includes(size);
    if (useNewIcon && NewIcon) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement(NewIcon, (0, (/*@__PURE__*/$parcel$interopDefault($147dc3434bd55d1d$exports)))({}, props, {
        spacing: spacing,
        color: props.primaryColor || "currentColor",
        type: props.iconType
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $2fa0080174637a37$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($147dc3434bd55d1d$exports)))({
        dangerouslySetGlyph: dangerouslySetGlyph
    }, props));
});
var $2894c4a395f277dd$export$2e2bcd8739ae039 = $2894c4a395f277dd$export$3cfb73f70dfca966;



var $ce72403cb4576c12$var$_chevronDown = $ce72403cb4576c12$var$_interopRequireDefault((parcelRequire("gKpEp")));
function $ce72403cb4576c12$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $ce72403cb4576c12$var$ChevronDownIcon = (props)=>/*#__PURE__*/ $ce72403cb4576c12$var$_react.default.createElement($2894c4a395f277dd$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M8.292 10.293a1.01 1.01 0 0 0 0 1.419l2.939 2.965c.218.215.5.322.779.322s.556-.107.769-.322l2.93-2.955a1.01 1.01 0 0 0 0-1.419.987.987 0 0 0-1.406 0l-2.298 2.317-2.307-2.327a.99.99 0 0 0-1.406 0"/></svg>`
    }, props, {
        newIcon: $ce72403cb4576c12$var$_chevronDown.default,
        iconType: "utility"
    }));
$ce72403cb4576c12$var$ChevronDownIcon.displayName = "ChevronDownIcon";
var $ce72403cb4576c12$var$_default = $ce72403cb4576c12$exports.default = $ce72403cb4576c12$var$ChevronDownIcon;


/** @jsx jsx */ 
var $dAx5m = parcelRequire("dAx5m");

var $jVTBW = parcelRequire("jVTBW");





var $jVTBW = parcelRequire("jVTBW");


var $jVTBW = parcelRequire("jVTBW");
var $8d84445fc6c6caf4$export$4ef52930e33717cd = "data-theme";
var $8d84445fc6c6caf4$export$a00eac3f8684bcd0 = "data-color-mode";
var $8d84445fc6c6caf4$export$2112803007239c61 = "data-contrast-mode";
var $8d84445fc6c6caf4$export$352e418ed5b6193a = "data-custom-theme";
var $8d84445fc6c6caf4$export$2faeed762aac6741 = "light";
var $8d84445fc6c6caf4$export$6f0c6fb8c80fcc92 = "ds";
var $8d84445fc6c6caf4$export$4d0c7bbf80185957 = [
    "opacity",
    "font",
    "space",
    "border"
];
var $8d84445fc6c6caf4$export$dddac1532e822863 = "--".concat($8d84445fc6c6caf4$export$6f0c6fb8c80fcc92, "-token-not-found");
var $8d84445fc6c6caf4$export$9d7b58831ae93caa = "--".concat($8d84445fc6c6caf4$export$6f0c6fb8c80fcc92, "-elevation-surface-current");


function $1b7baf7ec4aec943$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $1b7baf7ec4aec943$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $1b7baf7ec4aec943$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($659b468336d903e3$exports)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $1b7baf7ec4aec943$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $1b7baf7ec4aec943$export$6ccdbebca2ee545f = {
    "100%": "100%",
    "size.100": "1rem",
    "size.200": "1.5rem",
    "size.300": "2rem",
    "size.400": "2.5rem",
    "size.500": "3rem",
    "size.600": "6rem",
    "size.1000": "12rem"
};
var $1b7baf7ec4aec943$export$958d0ae7f2977ae4 = {
    "space.0": "var(--ds-space-0, 0px)",
    "space.025": "var(--ds-space-025, 2px)",
    "space.050": "var(--ds-space-050, 4px)",
    "space.075": "var(--ds-space-075, 6px)",
    "space.100": "var(--ds-space-100, 8px)",
    "space.150": "var(--ds-space-150, 12px)",
    "space.200": "var(--ds-space-200, 16px)",
    "space.250": "var(--ds-space-250, 20px)",
    "space.300": "var(--ds-space-300, 24px)",
    "space.400": "var(--ds-space-400, 32px)",
    "space.500": "var(--ds-space-500, 40px)",
    "space.600": "var(--ds-space-600, 48px)",
    "space.800": "var(--ds-space-800, 64px)",
    "space.1000": "var(--ds-space-1000, 80px)"
};
var $1b7baf7ec4aec943$export$d2dc61f58390201c = {
    "space.negative.025": "var(--ds-space-negative-025, -2px)",
    "space.negative.050": "var(--ds-space-negative-050, -4px)",
    "space.negative.075": "var(--ds-space-negative-075, -6px)",
    "space.negative.100": "var(--ds-space-negative-100, -8px)",
    "space.negative.150": "var(--ds-space-negative-150, -12px)",
    "space.negative.200": "var(--ds-space-negative-200, -16px)",
    "space.negative.250": "var(--ds-space-negative-250, -20px)",
    "space.negative.300": "var(--ds-space-negative-300, -24px)",
    "space.negative.400": "var(--ds-space-negative-400, -32px)"
};
var $1b7baf7ec4aec943$export$632685d741f3dbbf = $1b7baf7ec4aec943$var$_objectSpread($1b7baf7ec4aec943$var$_objectSpread({}, $1b7baf7ec4aec943$export$958d0ae7f2977ae4), $1b7baf7ec4aec943$export$d2dc61f58390201c);
var $1b7baf7ec4aec943$export$2185ce37f9bdd963 = {
    "color.background.neutral.bold": "color.text.inverse",
    "color.background.neutral.bold.hovered": "color.text.inverse",
    "color.background.neutral.bold.pressed": "color.text.inverse",
    "color.background.selected.bold": "color.text.inverse",
    "color.background.selected.bold.hovered": "color.text.inverse",
    "color.background.selected.bold.pressed": "color.text.inverse",
    "color.background.brand.bold": "color.text.inverse",
    "color.background.brand.bold.hovered": "color.text.inverse",
    "color.background.brand.bold.pressed": "color.text.inverse",
    "color.background.brand.boldest": "color.text.inverse",
    "color.background.brand.boldest.hovered": "color.text.inverse",
    "color.background.brand.boldest.pressed": "color.text.inverse",
    "color.background.danger.bold": "color.text.inverse",
    "color.background.danger.bold.hovered": "color.text.inverse",
    "color.background.danger.bold.pressed": "color.text.inverse",
    "color.background.warning.bold": "color.text.warning.inverse",
    "color.background.warning.bold.hovered": "color.text.warning.inverse",
    "color.background.warning.bold.pressed": "color.text.warning.inverse",
    "color.background.success.bold": "color.text.inverse",
    "color.background.success.bold.hovered": "color.text.inverse",
    "color.background.success.bold.pressed": "color.text.inverse",
    "color.background.discovery.bold": "color.text.inverse",
    "color.background.discovery.bold.hovered": "color.text.inverse",
    "color.background.discovery.bold.pressed": "color.text.inverse",
    "color.background.information.bold": "color.text.inverse",
    "color.background.information.bold.hovered": "color.text.inverse",
    "color.background.information.bold.pressed": "color.text.inverse"
};
var $1b7baf7ec4aec943$export$daf94a976c798b4f = {
    "opacity.disabled": "var(--ds-opacity-disabled, 0.4)",
    "opacity.loading": "var(--ds-opacity-loading, 0.2)"
};
var $1b7baf7ec4aec943$export$7aff6e7ba39bb774 = {
    "elevation.shadow.overflow": "var(--ds-shadow-overflow, 0px 0px 8px #091e423f, 0px 0px 1px #091e424f)",
    "elevation.shadow.overflow.perimeter": "var(--ds-shadow-overflow-perimeter, #091e421f)",
    "elevation.shadow.overflow.spread": "var(--ds-shadow-overflow-spread, #091e4229)",
    "elevation.shadow.overlay": "var(--ds-shadow-overlay, 0px 8px 12px #091e423f, 0px 0px 1px #091e424f)",
    "elevation.shadow.raised": "var(--ds-shadow-raised, 0px 1px 1px #091e423f, 0px 0px 1px #091e4221)"
};
var $1b7baf7ec4aec943$export$41a358c9c2356760 = {
    "elevation.surface": "var(--ds-surface, #FFFFFF)",
    "elevation.surface.hovered": "var(--ds-surface-hovered, #FAFBFC)",
    "elevation.surface.pressed": "var(--ds-surface-pressed, #F4F5F7)",
    "elevation.surface.overlay": "var(--ds-surface-overlay, #FFFFFF)",
    "elevation.surface.overlay.hovered": "var(--ds-surface-overlay-hovered, #FAFBFC)",
    "elevation.surface.overlay.pressed": "var(--ds-surface-overlay-pressed, #F4F5F7)",
    "elevation.surface.raised": "var(--ds-surface-raised, #FFFFFF)",
    "elevation.surface.raised.hovered": "var(--ds-surface-raised-hovered, #FAFBFC)",
    "elevation.surface.raised.pressed": "var(--ds-surface-raised-pressed, #F4F5F7)",
    "elevation.surface.sunken": "var(--ds-surface-sunken, #F4F5F7)"
};
var $1b7baf7ec4aec943$export$1531ad5bb3fbedac = {
    "color.border": "var(--ds-border, #091e4221)",
    "color.border.accent.lime": "var(--ds-border-accent-lime, #6A9A23)",
    "color.border.accent.red": "var(--ds-border-accent-red, #FF5630)",
    "color.border.accent.orange": "var(--ds-border-accent-orange, #D94008)",
    "color.border.accent.yellow": "var(--ds-border-accent-yellow, #FFAB00)",
    "color.border.accent.green": "var(--ds-border-accent-green, #36B37E)",
    "color.border.accent.teal": "var(--ds-border-accent-teal, #00B8D9)",
    "color.border.accent.blue": "var(--ds-border-accent-blue, #0065FF)",
    "color.border.accent.purple": "var(--ds-border-accent-purple, #6554C0)",
    "color.border.accent.magenta": "var(--ds-border-accent-magenta, #CD519D)",
    "color.border.accent.gray": "var(--ds-border-accent-gray, #5E6C84)",
    "color.border.disabled": "var(--ds-border-disabled, #FAFBFC)",
    "color.border.focused": "var(--ds-border-focused, #2684FF)",
    "color.border.input": "var(--ds-border-input, #FAFBFC)",
    "color.border.inverse": "var(--ds-border-inverse, #FFFFFF)",
    "color.border.selected": "var(--ds-border-selected, #0052CC)",
    "color.border.brand": "var(--ds-border-brand, #0052CC)",
    "color.border.danger": "var(--ds-border-danger, #FF5630)",
    "color.border.warning": "var(--ds-border-warning, #FFC400)",
    "color.border.success": "var(--ds-border-success, #00875A)",
    "color.border.discovery": "var(--ds-border-discovery, #998DD9)",
    "color.border.information": "var(--ds-border-information, #0065FF)",
    "color.border.bold": "var(--ds-border-bold, #344563)"
};
var $1b7baf7ec4aec943$export$d1d79bf68ac056bd = {
    "color.background.accent.lime.subtlest": "var(--ds-background-accent-lime-subtlest, #EEFBDA)",
    "color.background.accent.lime.subtlest.hovered": "var(--ds-background-accent-lime-subtlest-hovered, #D3F1A7)",
    "color.background.accent.lime.subtlest.pressed": "var(--ds-background-accent-lime-subtlest-pressed, #B3DF72)",
    "color.background.accent.lime.subtler": "var(--ds-background-accent-lime-subtler, #D3F1A7)",
    "color.background.accent.lime.subtler.hovered": "var(--ds-background-accent-lime-subtler-hovered, #B3DF72)",
    "color.background.accent.lime.subtler.pressed": "var(--ds-background-accent-lime-subtler-pressed, #94C748)",
    "color.background.accent.lime.subtle": "var(--ds-background-accent-lime-subtle, #94C748)",
    "color.background.accent.lime.subtle.hovered": "var(--ds-background-accent-lime-subtle-hovered, #B3DF72)",
    "color.background.accent.lime.subtle.pressed": "var(--ds-background-accent-lime-subtle-pressed, #D3F1A7)",
    "color.background.accent.lime.bolder": "var(--ds-background-accent-lime-bolder, #5B7F24)",
    "color.background.accent.lime.bolder.hovered": "var(--ds-background-accent-lime-bolder-hovered, #37471F)",
    "color.background.accent.lime.bolder.pressed": "var(--ds-background-accent-lime-bolder-pressed, #37471F)",
    "color.background.accent.red.subtlest": "var(--ds-background-accent-red-subtlest, #FF8F73)",
    "color.background.accent.red.subtlest.hovered": "var(--ds-background-accent-red-subtlest-hovered, #FF7452)",
    "color.background.accent.red.subtlest.pressed": "var(--ds-background-accent-red-subtlest-pressed, #FF5630)",
    "color.background.accent.red.subtler": "var(--ds-background-accent-red-subtler, #FF7452)",
    "color.background.accent.red.subtler.hovered": "var(--ds-background-accent-red-subtler-hovered, #FF5630)",
    "color.background.accent.red.subtler.pressed": "var(--ds-background-accent-red-subtler-pressed, #DE350B)",
    "color.background.accent.red.subtle": "var(--ds-background-accent-red-subtle, #DE350B)",
    "color.background.accent.red.subtle.hovered": "var(--ds-background-accent-red-subtle-hovered, #FF5630)",
    "color.background.accent.red.subtle.pressed": "var(--ds-background-accent-red-subtle-pressed, #FF7452)",
    "color.background.accent.red.bolder": "var(--ds-background-accent-red-bolder, #DE350B)",
    "color.background.accent.red.bolder.hovered": "var(--ds-background-accent-red-bolder-hovered, #FF5630)",
    "color.background.accent.red.bolder.pressed": "var(--ds-background-accent-red-bolder-pressed, #FF7452)",
    "color.background.accent.orange.subtlest": "var(--ds-background-accent-orange-subtlest, #F18D13)",
    "color.background.accent.orange.subtlest.hovered": "var(--ds-background-accent-orange-subtlest-hovered, #FEC57B)",
    "color.background.accent.orange.subtlest.pressed": "var(--ds-background-accent-orange-subtlest-pressed, #FFE2BD)",
    "color.background.accent.orange.subtler": "var(--ds-background-accent-orange-subtler, #B65C02)",
    "color.background.accent.orange.subtler.hovered": "var(--ds-background-accent-orange-subtler-hovered, #F18D13)",
    "color.background.accent.orange.subtler.pressed": "var(--ds-background-accent-orange-subtler-pressed, #FEC57B)",
    "color.background.accent.orange.subtle": "var(--ds-background-accent-orange-subtle, #5F3811)",
    "color.background.accent.orange.subtle.hovered": "var(--ds-background-accent-orange-subtle-hovered, #974F0C)",
    "color.background.accent.orange.subtle.pressed": "var(--ds-background-accent-orange-subtle-pressed, #B65C02)",
    "color.background.accent.orange.bolder": "var(--ds-background-accent-orange-bolder, #43290F)",
    "color.background.accent.orange.bolder.hovered": "var(--ds-background-accent-orange-bolder-hovered, #5F3811)",
    "color.background.accent.orange.bolder.pressed": "var(--ds-background-accent-orange-bolder-pressed, #974F0C)",
    "color.background.accent.yellow.subtlest": "var(--ds-background-accent-yellow-subtlest, #FFE380)",
    "color.background.accent.yellow.subtlest.hovered": "var(--ds-background-accent-yellow-subtlest-hovered, #FFC400)",
    "color.background.accent.yellow.subtlest.pressed": "var(--ds-background-accent-yellow-subtlest-pressed, #FFAB00)",
    "color.background.accent.yellow.subtler": "var(--ds-background-accent-yellow-subtler, #FFC400)",
    "color.background.accent.yellow.subtler.hovered": "var(--ds-background-accent-yellow-subtler-hovered, #FFAB00)",
    "color.background.accent.yellow.subtler.pressed": "var(--ds-background-accent-yellow-subtler-pressed, #FF991F)",
    "color.background.accent.yellow.subtle": "var(--ds-background-accent-yellow-subtle, #FF991F)",
    "color.background.accent.yellow.subtle.hovered": "var(--ds-background-accent-yellow-subtle-hovered, #FFAB00)",
    "color.background.accent.yellow.subtle.pressed": "var(--ds-background-accent-yellow-subtle-pressed, #FFC400)",
    "color.background.accent.yellow.bolder": "var(--ds-background-accent-yellow-bolder, #FF991F)",
    "color.background.accent.yellow.bolder.hovered": "var(--ds-background-accent-yellow-bolder-hovered, #FFAB00)",
    "color.background.accent.yellow.bolder.pressed": "var(--ds-background-accent-yellow-bolder-pressed, #FFC400)",
    "color.background.accent.green.subtlest": "var(--ds-background-accent-green-subtlest, #79F2C0)",
    "color.background.accent.green.subtlest.hovered": "var(--ds-background-accent-green-subtlest-hovered, #57D9A3)",
    "color.background.accent.green.subtlest.pressed": "var(--ds-background-accent-green-subtlest-pressed, #36B37E)",
    "color.background.accent.green.subtler": "var(--ds-background-accent-green-subtler, #57D9A3)",
    "color.background.accent.green.subtler.hovered": "var(--ds-background-accent-green-subtler-hovered, #36B37E)",
    "color.background.accent.green.subtler.pressed": "var(--ds-background-accent-green-subtler-pressed, #00875A)",
    "color.background.accent.green.subtle": "var(--ds-background-accent-green-subtle, #00875A)",
    "color.background.accent.green.subtle.hovered": "var(--ds-background-accent-green-subtle-hovered, #36B37E)",
    "color.background.accent.green.subtle.pressed": "var(--ds-background-accent-green-subtle-pressed, #57D9A3)",
    "color.background.accent.green.bolder": "var(--ds-background-accent-green-bolder, #00875A)",
    "color.background.accent.green.bolder.hovered": "var(--ds-background-accent-green-bolder-hovered, #36B37E)",
    "color.background.accent.green.bolder.pressed": "var(--ds-background-accent-green-bolder-pressed, #57D9A3)",
    "color.background.accent.teal.subtlest": "var(--ds-background-accent-teal-subtlest, #79E2F2)",
    "color.background.accent.teal.subtlest.hovered": "var(--ds-background-accent-teal-subtlest-hovered, #00C7E6)",
    "color.background.accent.teal.subtlest.pressed": "var(--ds-background-accent-teal-subtlest-pressed, #00B8D9)",
    "color.background.accent.teal.subtler": "var(--ds-background-accent-teal-subtler, #00C7E6)",
    "color.background.accent.teal.subtler.hovered": "var(--ds-background-accent-teal-subtler-hovered, #00B8D9)",
    "color.background.accent.teal.subtler.pressed": "var(--ds-background-accent-teal-subtler-pressed, #00A3BF)",
    "color.background.accent.teal.subtle": "var(--ds-background-accent-teal-subtle, #00A3BF)",
    "color.background.accent.teal.subtle.hovered": "var(--ds-background-accent-teal-subtle-hovered, #00B8D9)",
    "color.background.accent.teal.subtle.pressed": "var(--ds-background-accent-teal-subtle-pressed, #00C7E6)",
    "color.background.accent.teal.bolder": "var(--ds-background-accent-teal-bolder, #00A3BF)",
    "color.background.accent.teal.bolder.hovered": "var(--ds-background-accent-teal-bolder-hovered, #00B8D9)",
    "color.background.accent.teal.bolder.pressed": "var(--ds-background-accent-teal-bolder-pressed, #00C7E6)",
    "color.background.accent.blue.subtlest": "var(--ds-background-accent-blue-subtlest, #4C9AFF)",
    "color.background.accent.blue.subtlest.hovered": "var(--ds-background-accent-blue-subtlest-hovered, #2684FF)",
    "color.background.accent.blue.subtlest.pressed": "var(--ds-background-accent-blue-subtlest-pressed, #0065FF)",
    "color.background.accent.blue.subtler": "var(--ds-background-accent-blue-subtler, #2684FF)",
    "color.background.accent.blue.subtler.hovered": "var(--ds-background-accent-blue-subtler-hovered, #0065FF)",
    "color.background.accent.blue.subtler.pressed": "var(--ds-background-accent-blue-subtler-pressed, #0052CC)",
    "color.background.accent.blue.subtle": "var(--ds-background-accent-blue-subtle, #0052CC)",
    "color.background.accent.blue.subtle.hovered": "var(--ds-background-accent-blue-subtle-hovered, #0065FF)",
    "color.background.accent.blue.subtle.pressed": "var(--ds-background-accent-blue-subtle-pressed, #2684FF)",
    "color.background.accent.blue.bolder": "var(--ds-background-accent-blue-bolder, #0052CC)",
    "color.background.accent.blue.bolder.hovered": "var(--ds-background-accent-blue-bolder-hovered, #0065FF)",
    "color.background.accent.blue.bolder.pressed": "var(--ds-background-accent-blue-bolder-pressed, #2684FF)",
    "color.background.accent.purple.subtlest": "var(--ds-background-accent-purple-subtlest, #998DD9)",
    "color.background.accent.purple.subtlest.hovered": "var(--ds-background-accent-purple-subtlest-hovered, #8777D9)",
    "color.background.accent.purple.subtlest.pressed": "var(--ds-background-accent-purple-subtlest-pressed, #6554C0)",
    "color.background.accent.purple.subtler": "var(--ds-background-accent-purple-subtler, #8777D9)",
    "color.background.accent.purple.subtler.hovered": "var(--ds-background-accent-purple-subtler-hovered, #6554C0)",
    "color.background.accent.purple.subtler.pressed": "var(--ds-background-accent-purple-subtler-pressed, #5243AA)",
    "color.background.accent.purple.subtle": "var(--ds-background-accent-purple-subtle, #5243AA)",
    "color.background.accent.purple.subtle.hovered": "var(--ds-background-accent-purple-subtle-hovered, #6554C0)",
    "color.background.accent.purple.subtle.pressed": "var(--ds-background-accent-purple-subtle-pressed, #8777D9)",
    "color.background.accent.purple.bolder": "var(--ds-background-accent-purple-bolder, #5243AA)",
    "color.background.accent.purple.bolder.hovered": "var(--ds-background-accent-purple-bolder-hovered, #6554C0)",
    "color.background.accent.purple.bolder.pressed": "var(--ds-background-accent-purple-bolder-pressed, #8777D9)",
    "color.background.accent.magenta.subtlest": "var(--ds-background-accent-magenta-subtlest, #FFECF8)",
    "color.background.accent.magenta.subtlest.hovered": "var(--ds-background-accent-magenta-subtlest-hovered, #FDD0EC)",
    "color.background.accent.magenta.subtlest.pressed": "var(--ds-background-accent-magenta-subtlest-pressed, #F797D2)",
    "color.background.accent.magenta.subtler": "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
    "color.background.accent.magenta.subtler.hovered": "var(--ds-background-accent-magenta-subtler-hovered, #F797D2)",
    "color.background.accent.magenta.subtler.pressed": "var(--ds-background-accent-magenta-subtler-pressed, #E774BB)",
    "color.background.accent.magenta.subtle": "var(--ds-background-accent-magenta-subtle, #E774BB)",
    "color.background.accent.magenta.subtle.hovered": "var(--ds-background-accent-magenta-subtle-hovered, #F797D2)",
    "color.background.accent.magenta.subtle.pressed": "var(--ds-background-accent-magenta-subtle-pressed, #FDD0EC)",
    "color.background.accent.magenta.bolder": "var(--ds-background-accent-magenta-bolder, #AE4787)",
    "color.background.accent.magenta.bolder.hovered": "var(--ds-background-accent-magenta-bolder-hovered, #943D73)",
    "color.background.accent.magenta.bolder.pressed": "var(--ds-background-accent-magenta-bolder-pressed, #50253F)",
    "color.background.accent.gray.subtlest": "var(--ds-background-accent-gray-subtlest, #6B778C)",
    "color.background.accent.gray.subtlest.hovered": "var(--ds-background-accent-gray-subtlest-hovered, #5E6C84)",
    "color.background.accent.gray.subtlest.pressed": "var(--ds-background-accent-gray-subtlest-pressed, #505F79)",
    "color.background.accent.gray.subtler": "var(--ds-background-accent-gray-subtler, #5E6C84)",
    "color.background.accent.gray.subtler.hovered": "var(--ds-background-accent-gray-subtler-hovered, #505F79)",
    "color.background.accent.gray.subtler.pressed": "var(--ds-background-accent-gray-subtler-pressed, #42526E)",
    "color.background.accent.gray.subtle": "var(--ds-background-accent-gray-subtle, #505F79)",
    "color.background.accent.gray.subtle.hovered": "var(--ds-background-accent-gray-subtle-hovered, #5E6C84)",
    "color.background.accent.gray.subtle.pressed": "var(--ds-background-accent-gray-subtle-pressed, #6B778C)",
    "color.background.accent.gray.bolder": "var(--ds-background-accent-gray-bolder, #42526E)",
    "color.background.accent.gray.bolder.hovered": "var(--ds-background-accent-gray-bolder-hovered, #344563)",
    "color.background.accent.gray.bolder.pressed": "var(--ds-background-accent-gray-bolder-pressed, #253858)",
    "color.background.disabled": "var(--ds-background-disabled, #091e4289)",
    "color.background.input": "var(--ds-background-input, #FAFBFC)",
    "color.background.input.hovered": "var(--ds-background-input-hovered, #EBECF0)",
    "color.background.input.pressed": "var(--ds-background-input-pressed, #FFFFFF)",
    "color.background.inverse.subtle": "var(--ds-background-inverse-subtle, #00000029)",
    "color.background.inverse.subtle.hovered": "var(--ds-background-inverse-subtle-hovered, #0000003D)",
    "color.background.inverse.subtle.pressed": "var(--ds-background-inverse-subtle-pressed, #00000052)",
    "color.background.neutral": "var(--ds-background-neutral, #DFE1E6)",
    "color.background.neutral.hovered": "var(--ds-background-neutral-hovered, #091e4214)",
    "color.background.neutral.pressed": "var(--ds-background-neutral-pressed, #B3D4FF)",
    "color.background.neutral.subtle": "var(--ds-background-neutral-subtle, transparent)",
    "color.background.neutral.subtle.hovered": "var(--ds-background-neutral-subtle-hovered, #091e4214)",
    "color.background.neutral.subtle.pressed": "var(--ds-background-neutral-subtle-pressed, #B3D4FF)",
    "color.background.neutral.bold": "var(--ds-background-neutral-bold, #42526E)",
    "color.background.neutral.bold.hovered": "var(--ds-background-neutral-bold-hovered, #505F79)",
    "color.background.neutral.bold.pressed": "var(--ds-background-neutral-bold-pressed, #344563)",
    "color.background.selected": "var(--ds-background-selected, #DEEBFF)",
    "color.background.selected.hovered": "var(--ds-background-selected-hovered, #B3D4FF)",
    "color.background.selected.pressed": "var(--ds-background-selected-pressed, #4C9AFF)",
    "color.background.selected.bold": "var(--ds-background-selected-bold, #0052CC)",
    "color.background.selected.bold.hovered": "var(--ds-background-selected-bold-hovered, #2684FF)",
    "color.background.selected.bold.pressed": "var(--ds-background-selected-bold-pressed, #0052CC)",
    "color.background.brand.subtlest": "var(--ds-background-brand-subtlest, #B3D4FF)",
    "color.background.brand.subtlest.hovered": "var(--ds-background-brand-subtlest-hovered, #DEEBFF)",
    "color.background.brand.subtlest.pressed": "var(--ds-background-brand-subtlest-pressed, #4C9AFF)",
    "color.background.brand.bold": "var(--ds-background-brand-bold, #0052CC)",
    "color.background.brand.bold.hovered": "var(--ds-background-brand-bold-hovered, #0065FF)",
    "color.background.brand.bold.pressed": "var(--ds-background-brand-bold-pressed, #0747A6)",
    "color.background.brand.boldest": "var(--ds-background-brand-boldest, #0747A6)",
    "color.background.brand.boldest.hovered": "var(--ds-background-brand-boldest-hovered, #0052CC)",
    "color.background.brand.boldest.pressed": "var(--ds-background-brand-boldest-pressed, #0747A6)",
    "color.background.danger": "var(--ds-background-danger, #FFEBE6)",
    "color.background.danger.hovered": "var(--ds-background-danger-hovered, #FFBDAD)",
    "color.background.danger.pressed": "var(--ds-background-danger-pressed, #FF8F73)",
    "color.background.danger.bold": "var(--ds-background-danger-bold, #DE350B)",
    "color.background.danger.bold.hovered": "var(--ds-background-danger-bold-hovered, #FF5630)",
    "color.background.danger.bold.pressed": "var(--ds-background-danger-bold-pressed, #BF2600)",
    "color.background.warning": "var(--ds-background-warning, #FFFAE6)",
    "color.background.warning.hovered": "var(--ds-background-warning-hovered, #FFF0B3)",
    "color.background.warning.pressed": "var(--ds-background-warning-pressed, #FFE380)",
    "color.background.warning.bold": "var(--ds-background-warning-bold, #FFAB00)",
    "color.background.warning.bold.hovered": "var(--ds-background-warning-bold-hovered, #FFC400)",
    "color.background.warning.bold.pressed": "var(--ds-background-warning-bold-pressed, #FF991F)",
    "color.background.success": "var(--ds-background-success, #E3FCEF)",
    "color.background.success.hovered": "var(--ds-background-success-hovered, #ABF5D1)",
    "color.background.success.pressed": "var(--ds-background-success-pressed, #79F2C0)",
    "color.background.success.bold": "var(--ds-background-success-bold, #00875A)",
    "color.background.success.bold.hovered": "var(--ds-background-success-bold-hovered, #57D9A3)",
    "color.background.success.bold.pressed": "var(--ds-background-success-bold-pressed, #00875A)",
    "color.background.discovery": "var(--ds-background-discovery, #EAE6FF)",
    "color.background.discovery.hovered": "var(--ds-background-discovery-hovered, #C0B6F2)",
    "color.background.discovery.pressed": "var(--ds-background-discovery-pressed, #998DD9)",
    "color.background.discovery.bold": "var(--ds-background-discovery-bold, #5243AA)",
    "color.background.discovery.bold.hovered": "var(--ds-background-discovery-bold-hovered, #8777D9)",
    "color.background.discovery.bold.pressed": "var(--ds-background-discovery-bold-pressed, #5243AA)",
    "color.background.information": "var(--ds-background-information, #DEEBFF)",
    "color.background.information.hovered": "var(--ds-background-information-hovered, #B3D4FF)",
    "color.background.information.pressed": "var(--ds-background-information-pressed, #4C9AFF)",
    "color.background.information.bold": "var(--ds-background-information-bold, #0052CC)",
    "color.background.information.bold.hovered": "var(--ds-background-information-bold-hovered, #2684FF)",
    "color.background.information.bold.pressed": "var(--ds-background-information-bold-pressed, #0052CC)",
    "color.blanket": "var(--ds-blanket, #091e4289)",
    "color.blanket.selected": "var(--ds-blanket-selected, #388BFF14)",
    "color.blanket.danger": "var(--ds-blanket-danger, #EF5C4814)",
    "elevation.surface": "var(--ds-surface, #FFFFFF)",
    "elevation.surface.hovered": "var(--ds-surface-hovered, #FAFBFC)",
    "elevation.surface.pressed": "var(--ds-surface-pressed, #F4F5F7)",
    "elevation.surface.overlay": "var(--ds-surface-overlay, #FFFFFF)",
    "elevation.surface.overlay.hovered": "var(--ds-surface-overlay-hovered, #FAFBFC)",
    "elevation.surface.overlay.pressed": "var(--ds-surface-overlay-pressed, #F4F5F7)",
    "elevation.surface.raised": "var(--ds-surface-raised, #FFFFFF)",
    "elevation.surface.raised.hovered": "var(--ds-surface-raised-hovered, #FAFBFC)",
    "elevation.surface.raised.pressed": "var(--ds-surface-raised-pressed, #F4F5F7)",
    "elevation.surface.sunken": "var(--ds-surface-sunken, #F4F5F7)",
    "utility.elevation.surface.current": "var(--ds-elevation-surface-current, #FFFFFF)"
};
var $1b7baf7ec4aec943$export$8473307aa00d6ea1 = {
    "color.text": "var(--ds-text, #172B4D)",
    "color.text.accent.lime": "var(--ds-text-accent-lime, #4C6B1F)",
    "color.text.accent.lime.bolder": "var(--ds-text-accent-lime-bolder, #37471F)",
    "color.text.accent.red": "var(--ds-text-accent-red, #DE350B)",
    "color.text.accent.red.bolder": "var(--ds-text-accent-red-bolder, #BF2600)",
    "color.text.accent.orange": "var(--ds-text-accent-orange, #F18D13)",
    "color.text.accent.orange.bolder": "var(--ds-text-accent-orange-bolder, #B65C02)",
    "color.text.accent.yellow": "var(--ds-text-accent-yellow, #FF991F)",
    "color.text.accent.yellow.bolder": "var(--ds-text-accent-yellow-bolder, #FF8B00)",
    "color.text.accent.green": "var(--ds-text-accent-green, #00875A)",
    "color.text.accent.green.bolder": "var(--ds-text-accent-green-bolder, #006644)",
    "color.text.accent.teal": "var(--ds-text-accent-teal, #00A3BF)",
    "color.text.accent.teal.bolder": "var(--ds-text-accent-teal-bolder, #008DA6)",
    "color.text.accent.blue": "var(--ds-text-accent-blue, #0052CC)",
    "color.text.accent.blue.bolder": "var(--ds-text-accent-blue-bolder, #0747A6)",
    "color.text.accent.purple": "var(--ds-text-accent-purple, #5243AA)",
    "color.text.accent.purple.bolder": "var(--ds-text-accent-purple-bolder, #403294)",
    "color.text.accent.magenta": "var(--ds-text-accent-magenta, #E774BB)",
    "color.text.accent.magenta.bolder": "var(--ds-text-accent-magenta-bolder, #DA62AC)",
    "color.text.accent.gray": "var(--ds-text-accent-gray, #505F79)",
    "color.text.accent.gray.bolder": "var(--ds-text-accent-gray-bolder, #172B4D)",
    "color.text.disabled": "var(--ds-text-disabled, #A5ADBA)",
    "color.text.inverse": "var(--ds-text-inverse, #FFFFFF)",
    "color.text.selected": "var(--ds-text-selected, #0052CC)",
    "color.text.brand": "var(--ds-text-brand, #0065FF)",
    "color.text.danger": "var(--ds-text-danger, #DE350B)",
    "color.text.warning": "var(--ds-text-warning, #974F0C)",
    "color.text.warning.inverse": "var(--ds-text-warning-inverse, #172B4D)",
    "color.text.success": "var(--ds-text-success, #006644)",
    "color.text.discovery": "var(--ds-text-discovery, #403294)",
    "color.text.information": "var(--ds-text-information, #0052CC)",
    "color.text.subtlest": "var(--ds-text-subtlest, #7A869A)",
    "color.text.subtle": "var(--ds-text-subtle, #42526E)",
    "color.link": "var(--ds-link, #0052CC)",
    "color.link.pressed": "var(--ds-link-pressed, #0747A6)",
    "color.link.visited": "var(--ds-link-visited, #403294)",
    "color.link.visited.pressed": "var(--ds-link-visited-pressed, #403294)"
};
var $1b7baf7ec4aec943$export$498780f74be9af68 = {
    "color.icon": "var(--ds-icon, #505F79)",
    "color.icon.accent.lime": "var(--ds-icon-accent-lime, #6A9A23)",
    "color.icon.accent.red": "var(--ds-icon-accent-red, #FF5630)",
    "color.icon.accent.orange": "var(--ds-icon-accent-orange, #D94008)",
    "color.icon.accent.yellow": "var(--ds-icon-accent-yellow, #FFAB00)",
    "color.icon.accent.green": "var(--ds-icon-accent-green, #36B37E)",
    "color.icon.accent.teal": "var(--ds-icon-accent-teal, #00B8D9)",
    "color.icon.accent.blue": "var(--ds-icon-accent-blue, #0065FF)",
    "color.icon.accent.purple": "var(--ds-icon-accent-purple, #6554C0)",
    "color.icon.accent.magenta": "var(--ds-icon-accent-magenta, #CD519D)",
    "color.icon.accent.gray": "var(--ds-icon-accent-gray, #5E6C84)",
    "color.icon.disabled": "var(--ds-icon-disabled, #8993A4)",
    "color.icon.inverse": "var(--ds-icon-inverse, #FFFFFF)",
    "color.icon.selected": "var(--ds-icon-selected, #0052CC)",
    "color.icon.brand": "var(--ds-icon-brand, #0065FF)",
    "color.icon.danger": "var(--ds-icon-danger, #DE350B)",
    "color.icon.warning": "var(--ds-icon-warning, #FFC400)",
    "color.icon.warning.inverse": "var(--ds-icon-warning-inverse, #253858)",
    "color.icon.success": "var(--ds-icon-success, #00875A)",
    "color.icon.discovery": "var(--ds-icon-discovery, #8777D9)",
    "color.icon.information": "var(--ds-icon-information, #0747A6)",
    "color.icon.subtle": "var(--ds-icon-subtle, #6B778C)"
};
var $1b7baf7ec4aec943$export$b5f31a7e431d2eab = {
    card: 100,
    navigation: 200,
    dialog: 300,
    layer: 400,
    blanket: 500,
    modal: 510,
    flag: 600,
    spotlight: 700,
    tooltip: 800
};
var $1b7baf7ec4aec943$export$e1b83c5210c471b8 = {
    "border.width": "var(--ds-border-width, 1px)",
    "border.width.0": "var(--ds-border-width-0, 0px)",
    "border.width.indicator": "var(--ds-border-width-indicator, 3px)",
    "border.width.outline": "var(--ds-border-width-outline, 2px)"
};
var $1b7baf7ec4aec943$export$3c0a6c3e64bb180d = {
    "border.radius.050": "var(--ds-border-radius-050, 2px)",
    "border.radius": "var(--ds-border-radius, 3px)",
    "border.radius.100": "var(--ds-border-radius-100, 3px)",
    "border.radius.200": "var(--ds-border-radius-200, 8px)",
    "border.radius.300": "var(--ds-border-radius-300, 12px)",
    "border.radius.400": "var(--ds-border-radius-400, 16px)",
    "border.radius.circle": "var(--ds-border-radius-circle, 32032px)"
};
var $1b7baf7ec4aec943$export$6cc560b4dedf3816 = {
    medium: 'var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    UNSAFE_small: 'var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    large: 'var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    small: 'var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)'
};
var $1b7baf7ec4aec943$export$303e322c6b1ed114 = {
    bold: "var(--ds-font-weight-bold, 700)",
    medium: "var(--ds-font-weight-medium, 500)",
    regular: "var(--ds-font-weight-regular, 400)",
    semibold: "var(--ds-font-weight-semibold, 600)"
};
var $1b7baf7ec4aec943$export$3c7e9587132614b4 = {
    "font.family.brand.body": 'var(--ds-font-family-brand-body, "Charlie Text", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.family.brand.heading": 'var(--ds-font-family-brand-heading, "Charlie Display", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)'
};
/**
 * @codegenEnd
 */ // Generate maps for Box props. backgroundColor, padding, etc
var $1b7baf7ec4aec943$var$spacingProperties = [
    // Used by Box
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    // Used by Inline and Stack
    "gap",
    "rowGap",
    "columnGap"
];
var $1b7baf7ec4aec943$var$getSerializedStylesMap = function getSerializedStylesMap(cssProperty, tokenMap) {
    return Object.keys(tokenMap).reduce(function(emotionSpacingMap, token) {
        emotionSpacingMap[token] = (0, $jVTBW.css)((0, (/*@__PURE__*/$parcel$interopDefault($659b468336d903e3$exports)))({}, cssProperty, tokenMap[token]));
        return emotionSpacingMap;
    }, {});
};
var $1b7baf7ec4aec943$export$e615f061ca585a6c = $1b7baf7ec4aec943$var$spacingProperties.reduce(function(styleMap, spacingProperty) {
    styleMap[spacingProperty] = $1b7baf7ec4aec943$var$getSerializedStylesMap(spacingProperty, $1b7baf7ec4aec943$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
var $1b7baf7ec4aec943$export$bf46c3f9eeafc71f = $1b7baf7ec4aec943$var$spacingProperties.reduce(function(styleMap, spacingProperty) {
    styleMap[spacingProperty] = $1b7baf7ec4aec943$var$getSerializedStylesMap(spacingProperty, $1b7baf7ec4aec943$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
var $1b7baf7ec4aec943$export$e7af83bafe7f9e63 = $1b7baf7ec4aec943$var$getSerializedStylesMap("backgroundColor", $1b7baf7ec4aec943$export$d1d79bf68ac056bd);
var $1b7baf7ec4aec943$export$3a1bcba60b23d7f0 = $1b7baf7ec4aec943$var$getSerializedStylesMap("color", $1b7baf7ec4aec943$export$8473307aa00d6ea1);
var $1b7baf7ec4aec943$export$45f3f4fe16f9f7d5 = $1b7baf7ec4aec943$var$getSerializedStylesMap("fontWeight", $1b7baf7ec4aec943$export$303e322c6b1ed114);
var $1b7baf7ec4aec943$export$68cc305da27dbaa4 = $1b7baf7ec4aec943$var$getSerializedStylesMap("fontFamily", $1b7baf7ec4aec943$export$3c7e9587132614b4);
var $1b7baf7ec4aec943$export$128f10c238242f83 = $1b7baf7ec4aec943$var$getSerializedStylesMap("font", $1b7baf7ec4aec943$export$6cc560b4dedf3816);
var $1b7baf7ec4aec943$export$ff257d957d48c421 = $1b7baf7ec4aec943$var$getSerializedStylesMap((0, $8d84445fc6c6caf4$export$9d7b58831ae93caa), $1b7baf7ec4aec943$export$41a358c9c2356760);
var $1b7baf7ec4aec943$export$5e65a44e5b6ecadb = function isSurfaceColorToken(color) {
    return $1b7baf7ec4aec943$export$41a358c9c2356760[color] !== undefined;
};



var $ahJoN = parcelRequire("ahJoN");
function $4db63e30be897e1a$var$_createForOfIteratorHelper(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (!it) {
        if (Array.isArray(o) || (it = $4db63e30be897e1a$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
            if (it) o = it;
            var i = 0;
            var F = function F() {};
            return {
                s: F,
                n: function n() {
                    if (i >= o.length) return {
                        done: true
                    };
                    return {
                        done: false,
                        value: o[i++]
                    };
                },
                e: function e(_e) {
                    throw _e;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var normalCompletion = true, didErr = false, err;
    return {
        s: function s() {
            it = it.call(o);
        },
        n: function n() {
            var step = it.next();
            normalCompletion = step.done;
            return step;
        },
        e: function e(_e2) {
            didErr = true;
            err = _e2;
        },
        f: function f() {
            try {
                if (!normalCompletion && it.return != null) it.return();
            } finally{
                if (didErr) throw err;
            }
        }
    };
}
function $4db63e30be897e1a$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $4db63e30be897e1a$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $4db63e30be897e1a$var$_arrayLikeToArray(o, minLen);
}
function $4db63e30be897e1a$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $4db63e30be897e1a$export$9a199fbafee0014e = {
    backgroundColor: (0, $1b7baf7ec4aec943$export$d1d79bf68ac056bd),
    blockSize: (0, $1b7baf7ec4aec943$export$6ccdbebca2ee545f),
    borderBlockColor: (0, $1b7baf7ec4aec943$export$1531ad5bb3fbedac),
    borderBlockEndColor: (0, $1b7baf7ec4aec943$export$1531ad5bb3fbedac),
    borderBlockEndWidth: (0, $1b7baf7ec4aec943$export$e1b83c5210c471b8),
    borderBlockStartColor: (0, $1b7baf7ec4aec943$export$1531ad5bb3fbedac),
    borderBlockStartWidth: (0, $1b7baf7ec4aec943$export$e1b83c5210c471b8),
    borderBlockWidth: (0, $1b7baf7ec4aec943$export$e1b83c5210c471b8),
    borderBottomColor: (0, $1b7baf7ec4aec943$export$1531ad5bb3fbedac),
    borderBottomLeftRadius: (0, $1b7baf7ec4aec943$export$3c0a6c3e64bb180d),
    borderBottomRightRadius: (0, $1b7baf7ec4aec943$export$3c0a6c3e64bb180d),
    borderBottomWidth: (0, $1b7baf7ec4aec943$export$e1b83c5210c471b8),
    borderColor: (0, $1b7baf7ec4aec943$export$1531ad5bb3fbedac),
    borderEndEndRadius: (0, $1b7baf7ec4aec943$export$3c0a6c3e64bb180d),
    borderEndStartRadius: (0, $1b7baf7ec4aec943$export$3c0a6c3e64bb180d),
    borderInlineColor: (0, $1b7baf7ec4aec943$export$1531ad5bb3fbedac),
    borderInlineEndColor: (0, $1b7baf7ec4aec943$export$1531ad5bb3fbedac),
    borderInlineEndWidth: (0, $1b7baf7ec4aec943$export$e1b83c5210c471b8),
    borderInlineStartColor: (0, $1b7baf7ec4aec943$export$1531ad5bb3fbedac),
    borderInlineStartWidth: (0, $1b7baf7ec4aec943$export$e1b83c5210c471b8),
    borderInlineWidth: (0, $1b7baf7ec4aec943$export$e1b83c5210c471b8),
    borderLeftColor: (0, $1b7baf7ec4aec943$export$1531ad5bb3fbedac),
    borderLeftWidth: (0, $1b7baf7ec4aec943$export$e1b83c5210c471b8),
    borderRadius: (0, $1b7baf7ec4aec943$export$3c0a6c3e64bb180d),
    borderRightColor: (0, $1b7baf7ec4aec943$export$1531ad5bb3fbedac),
    borderRightWidth: (0, $1b7baf7ec4aec943$export$e1b83c5210c471b8),
    borderStartEndRadius: (0, $1b7baf7ec4aec943$export$3c0a6c3e64bb180d),
    borderStartStartRadius: (0, $1b7baf7ec4aec943$export$3c0a6c3e64bb180d),
    borderTopColor: (0, $1b7baf7ec4aec943$export$1531ad5bb3fbedac),
    borderTopLeftRadius: (0, $1b7baf7ec4aec943$export$3c0a6c3e64bb180d),
    borderTopRightRadius: (0, $1b7baf7ec4aec943$export$3c0a6c3e64bb180d),
    borderTopWidth: (0, $1b7baf7ec4aec943$export$e1b83c5210c471b8),
    borderWidth: (0, $1b7baf7ec4aec943$export$e1b83c5210c471b8),
    bottom: (0, $1b7baf7ec4aec943$export$632685d741f3dbbf),
    boxShadow: (0, $1b7baf7ec4aec943$export$7aff6e7ba39bb774),
    color: (0, $1b7baf7ec4aec943$export$8473307aa00d6ea1),
    columnGap: (0, $1b7baf7ec4aec943$export$958d0ae7f2977ae4),
    gap: (0, $1b7baf7ec4aec943$export$958d0ae7f2977ae4),
    height: (0, $1b7baf7ec4aec943$export$6ccdbebca2ee545f),
    inlineSize: (0, $1b7baf7ec4aec943$export$6ccdbebca2ee545f),
    inset: (0, $1b7baf7ec4aec943$export$632685d741f3dbbf),
    insetBlock: (0, $1b7baf7ec4aec943$export$632685d741f3dbbf),
    insetBlockEnd: (0, $1b7baf7ec4aec943$export$632685d741f3dbbf),
    insetBlockStart: (0, $1b7baf7ec4aec943$export$632685d741f3dbbf),
    insetInline: (0, $1b7baf7ec4aec943$export$632685d741f3dbbf),
    insetInlineEnd: (0, $1b7baf7ec4aec943$export$632685d741f3dbbf),
    insetInlineStart: (0, $1b7baf7ec4aec943$export$632685d741f3dbbf),
    left: (0, $1b7baf7ec4aec943$export$632685d741f3dbbf),
    margin: (0, $1b7baf7ec4aec943$export$632685d741f3dbbf),
    marginBlock: (0, $1b7baf7ec4aec943$export$632685d741f3dbbf),
    marginBlockEnd: (0, $1b7baf7ec4aec943$export$632685d741f3dbbf),
    marginBlockStart: (0, $1b7baf7ec4aec943$export$632685d741f3dbbf),
    marginBottom: (0, $1b7baf7ec4aec943$export$632685d741f3dbbf),
    marginInline: (0, $1b7baf7ec4aec943$export$632685d741f3dbbf),
    marginInlineEnd: (0, $1b7baf7ec4aec943$export$632685d741f3dbbf),
    marginInlineStart: (0, $1b7baf7ec4aec943$export$632685d741f3dbbf),
    marginLeft: (0, $1b7baf7ec4aec943$export$632685d741f3dbbf),
    marginRight: (0, $1b7baf7ec4aec943$export$632685d741f3dbbf),
    marginTop: (0, $1b7baf7ec4aec943$export$632685d741f3dbbf),
    maxBlockSize: (0, $1b7baf7ec4aec943$export$6ccdbebca2ee545f),
    maxHeight: (0, $1b7baf7ec4aec943$export$6ccdbebca2ee545f),
    maxInlineSize: (0, $1b7baf7ec4aec943$export$6ccdbebca2ee545f),
    maxWidth: (0, $1b7baf7ec4aec943$export$6ccdbebca2ee545f),
    minBlockSize: (0, $1b7baf7ec4aec943$export$6ccdbebca2ee545f),
    minHeight: (0, $1b7baf7ec4aec943$export$6ccdbebca2ee545f),
    minInlineSize: (0, $1b7baf7ec4aec943$export$6ccdbebca2ee545f),
    minWidth: (0, $1b7baf7ec4aec943$export$6ccdbebca2ee545f),
    opacity: (0, $1b7baf7ec4aec943$export$daf94a976c798b4f),
    outlineColor: (0, $1b7baf7ec4aec943$export$1531ad5bb3fbedac),
    outlineOffset: (0, $1b7baf7ec4aec943$export$958d0ae7f2977ae4),
    outlineWidth: (0, $1b7baf7ec4aec943$export$e1b83c5210c471b8),
    padding: (0, $1b7baf7ec4aec943$export$958d0ae7f2977ae4),
    paddingBlock: (0, $1b7baf7ec4aec943$export$958d0ae7f2977ae4),
    paddingBlockEnd: (0, $1b7baf7ec4aec943$export$958d0ae7f2977ae4),
    paddingBlockStart: (0, $1b7baf7ec4aec943$export$958d0ae7f2977ae4),
    paddingBottom: (0, $1b7baf7ec4aec943$export$958d0ae7f2977ae4),
    paddingInline: (0, $1b7baf7ec4aec943$export$958d0ae7f2977ae4),
    paddingInlineEnd: (0, $1b7baf7ec4aec943$export$958d0ae7f2977ae4),
    paddingInlineStart: (0, $1b7baf7ec4aec943$export$958d0ae7f2977ae4),
    paddingLeft: (0, $1b7baf7ec4aec943$export$958d0ae7f2977ae4),
    paddingRight: (0, $1b7baf7ec4aec943$export$958d0ae7f2977ae4),
    paddingTop: (0, $1b7baf7ec4aec943$export$958d0ae7f2977ae4),
    right: (0, $1b7baf7ec4aec943$export$632685d741f3dbbf),
    rowGap: (0, $1b7baf7ec4aec943$export$958d0ae7f2977ae4),
    top: (0, $1b7baf7ec4aec943$export$632685d741f3dbbf),
    width: (0, $1b7baf7ec4aec943$export$6ccdbebca2ee545f),
    zIndex: (0, $1b7baf7ec4aec943$export$b5f31a7e431d2eab)
};
var $4db63e30be897e1a$var$uniqueSymbol = Symbol("UNSAFE_INTERNAL_styles");
var $4db63e30be897e1a$var$isSafeEnvToThrow = function isSafeEnvToThrow() {
    return (typeof $ahJoN === "undefined" ? "undefined" : (0, (/*@__PURE__*/$parcel$interopDefault($a5e7ba7423f4d949$exports)))($ahJoN)) === "object" && (0, (/*@__PURE__*/$parcel$interopDefault($a5e7ba7423f4d949$exports)))($ahJoN.env) === "object" && false;
};
var $4db63e30be897e1a$var$reNestedSelectors = /(\.|\s|&+|\*\>|#|\[.*\])/;
var $4db63e30be897e1a$var$safeSelectors = /^@media .*$|^::?.*$|^@supports .*$/;
var $4db63e30be897e1a$var$transformStyles = function transformStyles(styleObj) {
    if (!styleObj || (0, (/*@__PURE__*/$parcel$interopDefault($a5e7ba7423f4d949$exports)))(styleObj) !== "object") return styleObj;
    // If styles are defined as a CSSObject[], recursively call on each element until we reach CSSObject
    if (Array.isArray(styleObj)) return styleObj.map(transformStyles);
    // Modifies styleObj in place. Be careful.
    Object.entries(styleObj).forEach(function(_ref) {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($96b147e8280c5691$exports)))(_ref, 2), key = _ref2[0], value = _ref2[1];
        // If key is a pseudo class or a pseudo element, then value should be an object.
        // So, call transformStyles on the value
        if ((0, (/*@__PURE__*/$parcel$interopDefault($a5e7ba7423f4d949$exports)))(value) === "object" && $4db63e30be897e1a$var$safeSelectors.test(key)) {
            styleObj[key] = transformStyles(value);
            return;
        }
        if ($4db63e30be897e1a$var$isSafeEnvToThrow()) {
            // We don't support `.class`, `[data-testid]`, `> *`, `#some-id`
            if ($4db63e30be897e1a$var$reNestedSelectors.test(key)) throw new Error("Styles not supported for key '".concat(key, "'."));
        }
        // We have now dealt with all the special cases, so,
        // check whether what remains is a style property
        // that can be transformed.
        if (!(key in $4db63e30be897e1a$export$9a199fbafee0014e)) return;
        var tokenValue = $4db63e30be897e1a$export$9a199fbafee0014e[key][value];
        styleObj[key] = tokenValue !== null && tokenValue !== void 0 ? tokenValue : value;
    });
    return styleObj;
};
var $4db63e30be897e1a$var$baseXcss = function baseXcss(style) {
    var transformedStyles = $4db63e30be897e1a$var$transformStyles(style);
    return (0, (/*@__PURE__*/$parcel$interopDefault($659b468336d903e3$exports)))({}, $4db63e30be897e1a$var$uniqueSymbol, (0, $jVTBW.css)(transformedStyles));
};
var $4db63e30be897e1a$export$a9c84988c8f81f2d = function parseXcss(args) {
    if (Array.isArray(args)) {
        var emotion = [];
        var staticArr = [];
        var _iterator = $4db63e30be897e1a$var$_createForOfIteratorHelper(args), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var arg = _step.value;
                var result = parseXcss(arg);
                if (result.emotion) emotion.push.apply(emotion, (0, (/*@__PURE__*/$parcel$interopDefault($753005c0c019cc18$exports)))(result.emotion));
                if (result.static) staticArr.push(result.static);
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        return {
            emotion: emotion,
            static: staticArr.join(" ")
        };
    }
    var objArgs = args;
    var _ref4 = objArgs || {}, styles = _ref4[$4db63e30be897e1a$var$uniqueSymbol];
    if (styles) return {
        emotion: [
            styles
        ]
    };
    if (args) {
        // We use string interpolation here instead of .toString() just
        // in case the resulting object doesn't have the method available.
        var stringifiedArgs = "".concat(args);
        if (stringifiedArgs) return {
            static: stringifiedArgs
        };
    }
    return {};
};
function $4db63e30be897e1a$export$f6c783d06584602c(style) {
    return $4db63e30be897e1a$var$baseXcss(style);
}


var $7709ea17ce5d2546$var$baseStyles = (0, $jVTBW.css)({
    boxSizing: "border-box"
});
var $7709ea17ce5d2546$var$blockBleedMap = {
    "space.025": (0, $jVTBW.css)({
        marginBlock: "var(--ds-space-negative-025, -0.125rem)"
    }),
    "space.050": (0, $jVTBW.css)({
        marginBlock: "var(--ds-space-negative-050, -0.25rem)"
    }),
    "space.100": (0, $jVTBW.css)({
        marginBlock: "var(--ds-space-negative-100, -0.5rem)"
    }),
    "space.150": (0, $jVTBW.css)({
        marginBlock: "var(--ds-space-negative-150, -0.75rem)"
    }),
    "space.200": (0, $jVTBW.css)({
        marginBlock: "var(--ds-space-negative-200, -1rem)"
    })
};
var $7709ea17ce5d2546$var$inlineBleedMap = {
    "space.025": (0, $jVTBW.css)({
        marginInline: "var(--ds-space-negative-025, -0.125rem)"
    }),
    "space.050": (0, $jVTBW.css)({
        marginInline: "var(--ds-space-negative-050, -0.25rem)"
    }),
    "space.100": (0, $jVTBW.css)({
        marginInline: "var(--ds-space-negative-100, -0.5rem)"
    }),
    "space.150": (0, $jVTBW.css)({
        marginInline: "var(--ds-space-negative-150, -0.75rem)"
    }),
    "space.200": (0, $jVTBW.css)({
        marginInline: "var(--ds-space-negative-200, -1rem)"
    })
};
/**
 * __Bleed__
 *
 * `Bleed` is a primitive layout component that controls negative whitespace.
 *
 * - [Examples](https://atlassian.design/components/primitives/bleed/examples)
 * - [Code](https://atlassian.design/components/primitives/bleed/code)
 */ var $7709ea17ce5d2546$var$Bleed = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).memo(function(_ref) {
    var children = _ref.children, testId = _ref.testId, inline = _ref.inline, block = _ref.block, all = _ref.all, xcss = _ref.xcss;
    var resolvedStyles = (0, $4db63e30be897e1a$export$a9c84988c8f81f2d)(xcss);
    return (0, $jVTBW.jsx)("div", {
        className: resolvedStyles.static,
        css: [
            $7709ea17ce5d2546$var$baseStyles,
            (inline || all) && $7709ea17ce5d2546$var$inlineBleedMap[inline || all],
            (block || all) && $7709ea17ce5d2546$var$blockBleedMap[block || all],
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
            resolvedStyles.emotion
        ],
        "data-testid": testId
    }, children);
});
$7709ea17ce5d2546$var$Bleed.displayName = "Bleed";
var $7709ea17ce5d2546$export$2e2bcd8739ae039 = $7709ea17ce5d2546$var$Bleed;






var $dAx5m = parcelRequire("dAx5m");

var $jVTBW = parcelRequire("jVTBW");

var $fIjLq = parcelRequire("fIjLq");




var $dAx5m = parcelRequire("dAx5m");

var $dd4sf = parcelRequire("dd4sf");


var $dAx5m = parcelRequire("dAx5m");

var $tWuif = parcelRequire("tWuif");




var $3f8a6f524df40be8$exports = {};
var $02abeb010351f7b9$exports = {};

function $02abeb010351f7b9$var$_superPropBase(t, o) {
    for(; !({}).hasOwnProperty.call(t, o) && null !== (t = $0fffda067e78c05f$exports(t)););
    return t;
}
$02abeb010351f7b9$exports = $02abeb010351f7b9$var$_superPropBase, $02abeb010351f7b9$exports.__esModule = true, $02abeb010351f7b9$exports["default"] = $02abeb010351f7b9$exports;


function $3f8a6f524df40be8$var$_get() {
    return $3f8a6f524df40be8$exports = $3f8a6f524df40be8$var$_get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function(e, t, r) {
        var p = $02abeb010351f7b9$exports(e, t);
        if (p) {
            var n = Object.getOwnPropertyDescriptor(p, t);
            return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value;
        }
    }, $3f8a6f524df40be8$exports.__esModule = true, $3f8a6f524df40be8$exports["default"] = $3f8a6f524df40be8$exports, $3f8a6f524df40be8$var$_get.apply(null, arguments);
}
$3f8a6f524df40be8$exports = $3f8a6f524df40be8$var$_get, $3f8a6f524df40be8$exports.__esModule = true, $3f8a6f524df40be8$exports["default"] = $3f8a6f524df40be8$exports;










function $e75f7a741a3ad8d5$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $e75f7a741a3ad8d5$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $e75f7a741a3ad8d5$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($659b468336d903e3$exports)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $e75f7a741a3ad8d5$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $e75f7a741a3ad8d5$export$ad4be5c2ec28cecf = function isAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $e75f7a741a3ad8d5$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === "AnalyticsEvent";
};
var $e75f7a741a3ad8d5$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function AnalyticsEvent(props) {
        var _this = this;
        (0, (/*@__PURE__*/$parcel$interopDefault($840057b0a8ac24e4$exports)))(this, AnalyticsEvent);
        (0, (/*@__PURE__*/$parcel$interopDefault($659b468336d903e3$exports)))(this, "_isAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($659b468336d903e3$exports)))(this, "clone", function() {
            // just a shallow clone, don't change sub refs unless you want to
            // affect the original's too
            var payload = $e75f7a741a3ad8d5$var$_objectSpread({}, _this.payload);
            return new AnalyticsEvent({
                payload: payload
            });
        });
        this.payload = props.payload;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($2acdb663cf966f60$exports)))(AnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (typeof updater === "function") this.payload = updater(this.payload);
                if ((0, (/*@__PURE__*/$parcel$interopDefault($a5e7ba7423f4d949$exports)))(updater) === "object") this.payload = $e75f7a741a3ad8d5$var$_objectSpread($e75f7a741a3ad8d5$var$_objectSpread({}, this.payload), updater);
                return this;
            }
        }
    ]);
    return AnalyticsEvent;
}();


function $40155b29a6d75c7d$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $40155b29a6d75c7d$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, (/*@__PURE__*/$parcel$interopDefault($0fffda067e78c05f$exports)))(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, (/*@__PURE__*/$parcel$interopDefault($0fffda067e78c05f$exports)))(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, (/*@__PURE__*/$parcel$interopDefault($e7dca18d1e5e3b81$exports)))(this, result);
    };
}
function $40155b29a6d75c7d$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($40155b29a6d75c7d$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $40155b29a6d75c7d$export$35f8383928ba8d7 = function isUIAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $40155b29a6d75c7d$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isUIAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === "UIAnalyticsEvent";
};
var $40155b29a6d75c7d$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_AnalyticsEvent) {
    (0, (/*@__PURE__*/$parcel$interopDefault($d2a9048bb4b38f76$exports)))(UIAnalyticsEvent, _AnalyticsEvent);
    var _super = $40155b29a6d75c7d$var$_createSuper(UIAnalyticsEvent);
    function UIAnalyticsEvent(props) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($840057b0a8ac24e4$exports)))(this, UIAnalyticsEvent);
        _this = _super.call(this, props);
        (0, (/*@__PURE__*/$parcel$interopDefault($659b468336d903e3$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($0e21e01afc3a739e$exports)))(_this), "_isUIAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($659b468336d903e3$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($0e21e01afc3a739e$exports)))(_this), "clone", function() {
            if (_this.hasFired) return null;
            var context = (0, (/*@__PURE__*/$parcel$interopDefault($753005c0c019cc18$exports)))(_this.context);
            var handlers = (0, (/*@__PURE__*/$parcel$interopDefault($753005c0c019cc18$exports)))(_this.handlers);
            /**
       * A hacky "deep clone" of the object. This is limited in that it wont
       * support functions, regexs, Maps, Sets, etc, but none of those need to
       * be represented in our payload.
       */ var payload = JSON.parse(JSON.stringify(_this.payload));
            return new UIAnalyticsEvent({
                context: context,
                handlers: handlers,
                payload: payload
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($659b468336d903e3$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($0e21e01afc3a739e$exports)))(_this), "fire", function(channel) {
            if (_this.hasFired) return;
            _this.handlers.forEach(function(handler) {
                return handler((0, (/*@__PURE__*/$parcel$interopDefault($0e21e01afc3a739e$exports)))(_this), channel);
            });
            _this.hasFired = true;
        });
        _this.context = props.context || [];
        _this.handlers = props.handlers || [];
        _this.hasFired = false;
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($2acdb663cf966f60$exports)))(UIAnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (this.hasFired) return this;
                return (0, (/*@__PURE__*/$parcel$interopDefault($3f8a6f524df40be8$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($0fffda067e78c05f$exports)))(UIAnalyticsEvent.prototype), "update", this).call(this, updater);
            }
        }
    ]);
    return UIAnalyticsEvent;
}((0, $e75f7a741a3ad8d5$export$2e2bcd8739ae039));



var $dAx5m = parcelRequire("dAx5m");

var $h0bf1 = parcelRequire("h0bf1");
var $f58230b6803bdb63$export$d1f587f82ad51c4 = function useAnalyticsContext() {
    return (0, $dAx5m.useContext)((0, $h0bf1.default));
};


function $2298b00c36654ba9$export$5bf35293e545f20c() {
    var analyticsContext = (0, $f58230b6803bdb63$export$d1f587f82ad51c4)();
    var createAnalyticsEvent = (0, $tWuif.useCallbackOne)(function(payload) {
        return new (0, $40155b29a6d75c7d$export$2e2bcd8739ae039)({
            context: analyticsContext.getAtlaskitAnalyticsContext(),
            handlers: analyticsContext.getAtlaskitAnalyticsEventHandlers(),
            payload: payload
        });
    }, [
        analyticsContext
    ]);
    return {
        createAnalyticsEvent: createAnalyticsEvent
    };
}



var $dAx5m = parcelRequire("dAx5m");
var $032942acf62538f6$export$1d27a74659855e44 = function useTrackedRef(value) {
    var ref = (0, $dAx5m.useRef)(value);
    ref.current = value;
    return ref;
};


function $f80b5c134ffe70e6$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $f80b5c134ffe70e6$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $f80b5c134ffe70e6$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($659b468336d903e3$exports)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $f80b5c134ffe70e6$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $f80b5c134ffe70e6$export$1a04351537078b55(_ref) {
    var fn = _ref.fn, action = _ref.action, componentName = _ref.componentName, packageName = _ref.packageName, packageVersion = _ref.packageVersion, analyticsData = _ref.analyticsData;
    var _useAnalyticsEvents = (0, $2298b00c36654ba9$export$5bf35293e545f20c)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    // We put analyticsData and fn in a ref so that we don't need to break
    // memoization.
    // Generally these could be defined by consumers inline
    // and so we do this to avoid breaking memoization of useCallback
    var dataRef = (0, $032942acf62538f6$export$1d27a74659855e44)(analyticsData);
    var fnRef = (0, $032942acf62538f6$export$1d27a74659855e44)(fn);
    var handler = (0, $dAx5m.useCallback)(function() {
        var analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: componentName,
            attributes: {
                componentName: componentName,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
        // To avoid wrapping this component in AnalyticsContext we manually
        // push the parent context's meta data into the context.
        // Note: this new 'context'
        var context = $f80b5c134ffe70e6$var$_objectSpread({
            componentName: componentName,
            packageName: packageName,
            packageVersion: packageVersion
        }, dataRef.current);
        analyticsEvent.context.push(context);
        // fire an event on the atlaskit channel
        var clone = analyticsEvent.clone();
        if (clone) clone.fire("atlaskit");
        fnRef.current(analyticsEvent);
    }, [
        // These are strings and won't change
        action,
        componentName,
        packageName,
        packageVersion,
        // This function is memoized in the context
        createAnalyticsEvent,
        // these are a stable ref because of the useTrackedRef hook
        dataRef,
        fnRef
    ]);
    return handler;
}



var $Bb0he = parcelRequire("Bb0he");

var $6Oq6X = parcelRequire("6Oq6X");


var $dAx5m = parcelRequire("dAx5m");


var $dAx5m = parcelRequire("dAx5m");

var $dd4sf = parcelRequire("dd4sf");
var $49759912eaeb24a1$var$isMatchMediaAvailable = function isMatchMediaAvailable() {
    return typeof window !== "undefined" && "matchMedia" in window;
};
var $49759912eaeb24a1$export$b7baf7667a68d87c = function isReducedMotion() {
    if (!$49759912eaeb24a1$var$isMatchMediaAvailable()) return false;
    var _window$matchMedia = window.matchMedia("(prefers-reduced-motion: reduce)"), matches = _window$matchMedia.matches;
    return matches;
};
var $49759912eaeb24a1$export$c537e63161742ce3 = function useIsReducedMotion() {
    var _useState = (0, $dAx5m.useState)($49759912eaeb24a1$export$b7baf7667a68d87c), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($96b147e8280c5691$exports)))(_useState, 2), prefersReducedMotion = _useState2[0], setPrefersReducedMotion = _useState2[1];
    (0, $dAx5m.useEffect)(function() {
        if (!$49759912eaeb24a1$var$isMatchMediaAvailable()) return;
        var mediaQueryList = window.matchMedia("(prefers-reduced-motion: reduce)");
        var onChange = function onChange(event) {
            return setPrefersReducedMotion(event.matches);
        };
        return (0, $dd4sf.bind)(mediaQueryList, {
            type: "change",
            listener: onChange
        });
    }, []);
    return prefersReducedMotion;
};
var $49759912eaeb24a1$export$f0f789643ba5a83c = {
    "@media (prefers-reduced-motion: reduce)": {
        animation: "none",
        transition: "none"
    }
};
var $49759912eaeb24a1$export$ff7706047246b98b = function prefersReducedMotion() {
    return $49759912eaeb24a1$export$f0f789643ba5a83c;
};


var $110220dbdcac0464$export$d1e013d71d2e2121 = {
    // Motions will always appear if not inside a exiting persistence component.
    appear: true,
    isExiting: false
};
var $110220dbdcac0464$export$b9c4904d7a6929e6 = /*#__PURE__*/ (0, $dAx5m.createContext)($110220dbdcac0464$export$d1e013d71d2e2121);
var $110220dbdcac0464$export$e4c4c45693c3a7c = function wrapChildWithContextProvider(child) {
    var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $110220dbdcac0464$export$d1e013d71d2e2121;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement($110220dbdcac0464$export$b9c4904d7a6929e6.Provider, {
        key: "".concat(child.key, "-provider"),
        value: value
    }, child);
};
var $110220dbdcac0464$export$7032ae6d9d98bedd = function childrenToArray(children) {
    var childrenAsArray = [];
    // We convert children to an array using this helper method as it will add keys to children that do not
    // have them, such as when we have hardcoded children that are conditionally rendered.
    (0, $dAx5m.Children).toArray(children).forEach(function(child) {
        // We ignore any boolean children to make our code a little more simple later on,
        // and also filter out any falsies (empty strings, nulls, and undefined).
        if (typeof child !== "boolean" && Boolean(child)) // Children WILL have a key after being forced into an array using the React.Children helper.
        childrenAsArray.push(child);
    });
    return childrenAsArray;
};
var $110220dbdcac0464$export$2ccbe4ff092af328 = function spliceNewElementsIntoPrevious(current, previous) {
    var splicedChildren = previous.concat([]);
    var previousMap = $110220dbdcac0464$export$1d8c49f95a162a41(previous);
    for(var i = 0; i < current.length; i++){
        var child = current[i];
        var childIsNew = !previousMap[child.key];
        if (childIsNew) // This will insert the new element after the previous element.
        splicedChildren.splice(i + 1, 0, child);
    }
    return splicedChildren;
};
var $110220dbdcac0464$export$1d8c49f95a162a41 = function childrenToObj(children) {
    return children.reduce(function(acc, child) {
        acc[child.key] = child;
        return acc;
    }, {});
};
var $110220dbdcac0464$var$getMissingKeys = function getMissingKeys(current, previous) {
    var currentMapKeys = new Set(current.map(function(child) {
        return child.key;
    }));
    var missing = new Set();
    for(var i = 0; i < previous.length; i++){
        var element = previous[i];
        var _key = element.key;
        if (!currentMapKeys.has(_key)) missing.add(_key);
    }
    return missing;
};
/**
 * __ExitingPersistence__
 *
 * Useful for enabling elements to persist and animate away when they are removed from the DOM.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motions)
 */ var $110220dbdcac0464$var$ExitingPersistence = /*#__PURE__*/ (0, $dAx5m.memo)(function(_ref) {
    var _ref$appear = _ref.appear, appear = _ref$appear === void 0 ? false : _ref$appear, children = _ref.children, exitThenEnter = _ref.exitThenEnter;
    var _useState = (0, $dAx5m.useState)([
        null,
        children
    ]), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($96b147e8280c5691$exports)))(_useState, 2), stateChildren = _useState2[0], setChildren = _useState2[1];
    var _useState3 = (0, $dAx5m.useState)([]), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($96b147e8280c5691$exports)))(_useState3, 2), exitingChildren = _useState4[0], setExitingChildren = _useState4[1];
    var _useState5 = (0, $dAx5m.useState)(function() {
        return {
            appear: appear,
            isExiting: false
        };
    }), _useState6 = (0, (/*@__PURE__*/$parcel$interopDefault($96b147e8280c5691$exports)))(_useState5, 2), defaultContext = _useState6[0], setDefaultContext = _useState6[1];
    (0, $dAx5m.useEffect)(function() {
        if (!defaultContext.appear) setDefaultContext({
            appear: true,
            isExiting: false
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    if ((0, $49759912eaeb24a1$export$b7baf7667a68d87c)()) return children;
    /**
   * NOTE: This is a workaround for the test case written in Jira where the stateChildren is a boolean value because
   * useState is mocked to return a boolean value.
   */ if (typeof stateChildren === "boolean") return children;
    var _stateChildren = (0, (/*@__PURE__*/$parcel$interopDefault($96b147e8280c5691$exports)))(stateChildren, 2), previousChildren = _stateChildren[0], currentChildren = _stateChildren[1];
    var previous = $110220dbdcac0464$export$7032ae6d9d98bedd(previousChildren);
    var current = $110220dbdcac0464$export$7032ae6d9d98bedd(currentChildren);
    if (currentChildren !== children) setChildren([
        currentChildren,
        children
    ]);
    var missingKeys = $110220dbdcac0464$var$getMissingKeys(current, previous);
    var isSomeChildRemoved = !!missingKeys.size;
    var visibleChildren = current;
    if (isSomeChildRemoved) visibleChildren = $110220dbdcac0464$export$2ccbe4ff092af328(current, previous);
    if (exitThenEnter) {
        if (exitingChildren.length) visibleChildren = exitingChildren;
        else {
            var nextExitingChildren = visibleChildren.filter(function(child) {
                return missingKeys.has(child.key);
            });
            if (nextExitingChildren.length) setExitingChildren(nextExitingChildren);
        }
    }
    if (missingKeys.size) visibleChildren = visibleChildren.map(function(child) {
        var isExiting = missingKeys.has(child.key);
        return $110220dbdcac0464$export$e4c4c45693c3a7c(child, {
            appear: true,
            isExiting: isExiting,
            onFinish: isExiting ? function() {
                missingKeys.delete(child.key);
                if (missingKeys.size === 0) {
                    setChildren([
                        null,
                        children
                    ]);
                    setExitingChildren([]);
                }
            } : undefined
        });
    });
    else visibleChildren = visibleChildren.map(function(child) {
        return $110220dbdcac0464$export$e4c4c45693c3a7c(child, defaultContext);
    });
    return visibleChildren;
});
var $110220dbdcac0464$export$3b6f38abbdcbd000 = function useExitingPersistence() {
    return (0, $dAx5m.useContext)($110220dbdcac0464$export$b9c4904d7a6929e6);
};
$110220dbdcac0464$var$ExitingPersistence.displayName = "ExitingPersistence";
var $110220dbdcac0464$export$2e2bcd8739ae039 = $110220dbdcac0464$var$ExitingPersistence;



var $dAx5m = parcelRequire("dAx5m");
var $3f521a9befaf5c72$export$c07234257a03d5e9 = "cubic-bezier(0.15,1,0.3,1)";
var $3f521a9befaf5c72$export$57636bb43b1ccbb0 = "cubic-bezier(0.2,0,0,1)";
var $3f521a9befaf5c72$export$929e5a82286172a6 = "cubic-bezier(0.8,0,0,0.8)";


/**
 * Think of this as the motion equivalent of the @atlaskit/theme `grid()`.
 */ var $75e0d026b358fd49$export$368bacef0dacbe05 = 25;
var $75e0d026b358fd49$export$2023a81c8547415f = $75e0d026b358fd49$export$368bacef0dacbe05 * 4;
var $75e0d026b358fd49$export$6fa259be09e118a7 = $75e0d026b358fd49$export$368bacef0dacbe05 * 14;
var $75e0d026b358fd49$export$9424640c29bc466d = $75e0d026b358fd49$export$368bacef0dacbe05 * 28;





var $dAx5m = parcelRequire("dAx5m");

var $jVTBW = parcelRequire("jVTBW");



var $dAx5m = parcelRequire("dAx5m");
var $661e1ef721dd897d$var$getHookDeps = function getHookDeps(opts) {
    switch(opts.cleanup){
        case "next-effect":
            return undefined;
        case "unmount":
        default:
            return [];
    }
};
var $661e1ef721dd897d$export$1775f27e7c8051ca = function useRequestAnimationFrame() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        cleanup: "unmount"
    };
    var frames = (0, $dAx5m.useRef)([]);
    (0, $dAx5m.useEffect)(function() {
        return function() {
            if (frames.current.length) {
                frames.current.forEach(function(id) {
                    return cancelAnimationFrame(id);
                });
                frames.current = [];
            }
        };
    // We dynamically set this so we either clean up on the next effect - or on unmount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, $661e1ef721dd897d$var$getHookDeps(opts));
    return (0, $dAx5m.useCallback)(function(handler) {
        var id = requestAnimationFrame(function(time) {
            frames.current = frames.current.filter(function(frameId) {
                return frameId !== id;
            });
            handler(time);
        });
        frames.current.push(id);
    }, []);
};
var $661e1ef721dd897d$export$4f34107a2b00f39c = function useSetTimeout() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        cleanup: "unmount"
    };
    var timeouts = (0, $dAx5m.useRef)([]);
    (0, $dAx5m.useEffect)(function() {
        return function() {
            if (timeouts.current.length) {
                timeouts.current.forEach(function(id) {
                    return clearTimeout(id);
                });
                timeouts.current = [];
            }
        };
    // We dynamically set this so we either clean up on the next effect - or on unmount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, $661e1ef721dd897d$var$getHookDeps(opts));
    return (0, $dAx5m.useCallback)(function(handler, timeout) {
        for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
        var id = setTimeout.apply(void 0, [
            function() {
                timeouts.current = timeouts.current.filter(function(timeoutId) {
                    return timeoutId !== id;
                });
                handler();
            },
            timeout
        ].concat(args));
        timeouts.current.push(id);
    }, []);
};





var $dAx5m = parcelRequire("dAx5m");

var $Bb0he = parcelRequire("Bb0he");

var $dAx5m = parcelRequire("dAx5m");
var $4e01fb9d65c47f03$export$e5c5a5f917a5871c = typeof window === "undefined" ? (0, $dAx5m.useEffect) : (0, $dAx5m.useLayoutEffect);


/* eslint-disable @repo/internal/react/disallow-unstable-values */ 
var $dAx5m = parcelRequire("dAx5m");
function $e2a7f3bb42460921$export$c485849f2e393253() {
    var identifier = (0, $dAx5m.useRef)("");
    if (!identifier.current) identifier.current = "_" + (Number(String(Math.random()).slice(2)) + Date.now() + Math.round(performance.now())).toString(36);
    return identifier.current;
}


var $b13de14feabbcd96$var$StaggeredEntranceContext = /*#__PURE__*/ (0, $dAx5m.createContext)(function() {
    return {
        isReady: true,
        delay: 0,
        ref: (0, $Bb0he.default)
    };
});
var $b13de14feabbcd96$export$25c7213fc07ec080 = function useStaggeredEntrance() {
    var indentifier = (0, $e2a7f3bb42460921$export$c485849f2e393253)();
    var context = (0, $dAx5m.useContext)($b13de14feabbcd96$var$StaggeredEntranceContext);
    return context(indentifier);
};
/**
 * For a list of elements that need to animate in,
 * this should be used in conjunction with entering components.
 * This does not need Javascript to execute so it will run immediately for any SSR rendered React apps before the JS has executed.
 *
 * Will dynamically add delay to each child entering component.
 * Unfortunately all entering components _NEED_ to be a direct descendant.
 */ var $b13de14feabbcd96$var$StaggeredEntrance = function StaggeredEntrance(_ref) {
    var children = _ref.children, column = _ref.column, _ref$columns = _ref.columns, columns = _ref$columns === void 0 ? "responsive" : _ref$columns, _ref$delayStep = _ref.delayStep, delayStep = _ref$delayStep === void 0 ? 50 : _ref$delayStep;
    var elementRefs = (0, $dAx5m.useRef)([]);
    var indexes = [];
    var _useState = (0, $dAx5m.useState)(function() {
        if (typeof columns === "number") // A hardcoded columns is set so bail out and set it to that!
        return columns;
        if (typeof column === "number") // A hardcoded column is set so we will set actualColumns to be 1.
        return 1;
        // We are in "responsive" mode.
        // So we will be calculating when the Javascript executes on the client how many columns there will be.
        return 0;
    }), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($96b147e8280c5691$exports)))(_useState, 2), actualColumns = _useState2[0], setActualColumns = _useState2[1];
    (0, $4e01fb9d65c47f03$export$e5c5a5f917a5871c)(function() {
        // We want to only run this code when we are in "responsive" mode.
        // It is assumed we are in responsive mode if `columns` is "responsive",
        // we have children element refs ready to be read (i.e. if there are no children this won't run as well)
        // and finally that `actualColumns` is `0` - this is because for the first render cycle `actualColumns` will be `0` (set above)
        // and then after this layout effect runs the value for `actualColumns` will then be calculated and set.
        if (columns === "responsive" && elementRefs.current.length && actualColumns === 0) {
            var currentTop = 0;
            var numberColumns = 0;
            if (elementRefs.current.length <= 1) {
                setActualColumns(1);
                return;
            }
            // We set the current top to the first elements.
            // We will be comparing this and incrementing the column count
            // until we hit an element that has a different offset top (or we run out of elements).
            currentTop = elementRefs.current[0] ? elementRefs.current[0].offsetTop : 0;
            for(var i = 0; i < elementRefs.current.length; i++){
                var child = elementRefs.current[i];
                if (!child) break;
                if (currentTop === child.offsetTop) {
                    numberColumns += 1;
                    if (elementRefs.current.length - 1 === i) setActualColumns(numberColumns);
                    continue;
                }
                setActualColumns(numberColumns);
                break;
            }
        }
    // We only want this effect to run once - on initial mount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement($b13de14feabbcd96$var$StaggeredEntranceContext.Provider, {
        value: function value(id) {
            if (!indexes.includes(id)) indexes.push(id);
            var isReady = actualColumns > 0;
            var index = indexes.indexOf(id);
            var currentColumn = column || index % actualColumns;
            var currentRow = Math.floor(index / actualColumns);
            var distanceFromTopLeftElement = currentRow + currentColumn;
            // We don't want loads of elements to have the same staggered delay as it ends up looking slow for users.
            // To get around that we calculate the logarithm using `distanceFromTopLeftElement` which ends making
            // elements appear faster the further away from the top left element.
            var delay = Math.ceil(Math.log(distanceFromTopLeftElement + 1) * delayStep * 1.5) || 0;
            return {
                delay: delay,
                isReady: isReady,
                ref: function ref(element) {
                    return elementRefs.current[index] = element;
                }
            };
        }
    }, children);
};
var $b13de14feabbcd96$export$2e2bcd8739ae039 = $b13de14feabbcd96$var$StaggeredEntrance;


function $fdc23bf41f8ea661$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $fdc23bf41f8ea661$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $fdc23bf41f8ea661$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($659b468336d903e3$exports)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $fdc23bf41f8ea661$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
/**
 * These are props that motions should use as their external props for consumers.
 * See [FadeIn](packages/helpers/motion/src/entering/fade-in.tsx) for an example usage.
 */ /**
 * Used to multiply the initial duration for exiting motions.
 */ var $fdc23bf41f8ea661$var$EXITING_MOTION_MULTIPLIER = 0.5;
/**
 * This is the base INTERNAL component used for all other entering motions.
 * This does not need Javascript to execute on the client so it will run immediately
 * for any SSR rendered React apps before the JS has executed.
 */ var $fdc23bf41f8ea661$var$EnteringMotion = function EnteringMotion(_ref) {
    var children = _ref.children, animationTimingFunction = _ref.animationTimingFunction, enteringAnimation = _ref.enteringAnimation, exitingAnimation = _ref.exitingAnimation, isPaused = _ref.isPaused, onFinishMotion = _ref.onFinish, _ref$duration = _ref.duration, duration = _ref$duration === void 0 ? (0, $75e0d026b358fd49$export$9424640c29bc466d) : _ref$duration;
    var staggered = (0, $b13de14feabbcd96$export$25c7213fc07ec080)();
    var _useExitingPersistenc = (0, $110220dbdcac0464$export$3b6f38abbdcbd000)(), isExiting = _useExitingPersistenc.isExiting, onExitFinished = _useExitingPersistenc.onFinish, appear = _useExitingPersistenc.appear;
    var setTimeout = (0, $661e1ef721dd897d$export$4f34107a2b00f39c)();
    var paused = isPaused || !staggered.isReady;
    var delay = isExiting ? 0 : staggered.delay;
    var state = isExiting ? "exiting" : "entering";
    var _useState = (0, $dAx5m.useState)(appear), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($96b147e8280c5691$exports)))(_useState, 2), hasAnimationStyles = _useState2[0], setHasAnimationStyles = _useState2[1];
    (0, $dAx5m.useEffect)(function() {
        // Tracking this to prevent changing state on an unmounted component
        var isCancelled = false;
        if (paused) return;
        // On initial mount if elements aren't set to animate on appear, we return early and callback
        if (!appear) {
            onFinishMotion && onFinishMotion(state);
            return;
        }
        // Elements may need animation styles back after initial mount (they could animate out)
        setHasAnimationStyles(true);
        setTimeout(function() {
            if (state === "exiting") onExitFinished && onExitFinished();
            if (!isCancelled) setHasAnimationStyles(false);
            onFinishMotion && onFinishMotion(state);
        }, isExiting ? duration * $fdc23bf41f8ea661$var$EXITING_MOTION_MULTIPLIER : duration + delay);
        return function() {
            isCancelled = true;
        };
    // We ignore this for onFinishMotion as consumers could potentially inline the function
    // which would then trigger this effect every re-render.
    // We want to make it easier for consumers so we go down this path unfortunately.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        onExitFinished,
        state,
        isExiting,
        duration,
        delay,
        paused,
        setTimeout
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $jVTBW.ClassNames), null, function(_ref2) {
        var css = _ref2.css;
        return children({
            ref: staggered.ref,
            className: hasAnimationStyles ? css($fdc23bf41f8ea661$var$_objectSpread($fdc23bf41f8ea661$var$_objectSpread({}, (0, $49759912eaeb24a1$export$f0f789643ba5a83c)), {}, {
                animationDelay: "".concat(delay, "ms"),
                animationDuration: "".concat(isExiting ? duration * $fdc23bf41f8ea661$var$EXITING_MOTION_MULTIPLIER : duration, "ms"),
                animationFillMode: isExiting ? "forwards" : "backwards",
                animationName: "".concat((0, $jVTBW.keyframes)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                isExiting ? exitingAnimation || enteringAnimation : enteringAnimation)),
                animationPlayState: paused ? "paused" : "running",
                animationTimingFunction: animationTimingFunction(state)
            })) : ""
        }, state);
    });
};
var $fdc23bf41f8ea661$export$2e2bcd8739ae039 = $fdc23bf41f8ea661$var$EnteringMotion;


function $4a76f9191c006c0c$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $4a76f9191c006c0c$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $4a76f9191c006c0c$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($659b468336d903e3$exports)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $4a76f9191c006c0c$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $4a76f9191c006c0c$var$directionMotions = {
    proportional: {
        bottom: "translate3d(0, calc(5% + 4px), 0)",
        left: "translate3d(calc(-5% - 4px), 0, 0)",
        right: "translate3d(calc(5% + 4px), 0, 0)",
        top: "translate3d(0, calc(-5% - 4px), 0)"
    },
    constant: {
        bottom: "translate3d(0, 4px, 0)",
        left: "translate3d(-4px, 0, 0)",
        right: "translate3d(4px, 0, 0)",
        top: "translate3d(0, -4px, 0)"
    }
};
var $4a76f9191c006c0c$var$invertedDirection = {
    top: "bottom",
    bottom: "top",
    left: "right",
    right: "left"
};
var $4a76f9191c006c0c$export$8497679fcaaeceb = function fadeInAnimation(direction) {
    var distance = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "proportional";
    return {
        from: $4a76f9191c006c0c$var$_objectSpread({
            opacity: 0
        }, direction !== undefined && {
            transform: $4a76f9191c006c0c$var$directionMotions[distance][direction]
        }),
        "50%": {
            opacity: 1
        },
        to: {
            transform: direction !== undefined ? "none" : undefined
        }
    };
};
var $4a76f9191c006c0c$export$c9190c6659ea755b = function fadeOutAnimation(direction) {
    var distance = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "proportional";
    return {
        from: {
            opacity: 1,
            transform: direction !== undefined ? "translate3d(0, 0, 0)" : undefined
        },
        to: $4a76f9191c006c0c$var$_objectSpread({
            opacity: 0
        }, direction !== undefined && {
            transform: $4a76f9191c006c0c$var$directionMotions[distance][direction]
        })
    };
};
/**
 * Props for controlling the behavior of the FadeIn animation
 */ /**
 * __FadeIn__
 *
 * Useful for fading in one or more elements.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motions)
 */ var $4a76f9191c006c0c$var$FadeIn = function FadeIn(_ref) {
    var children = _ref.children, _ref$duration = _ref.duration, duration = _ref$duration === void 0 ? (0, $75e0d026b358fd49$export$9424640c29bc466d) : _ref$duration, entranceDirection = _ref.entranceDirection, exitDirection = _ref.exitDirection, _ref$distance = _ref.distance, distance = _ref$distance === void 0 ? "proportional" : _ref$distance, onFinish = _ref.onFinish, isPaused = _ref.isPaused;
    var invertedEntranceDirection = entranceDirection && $4a76f9191c006c0c$var$invertedDirection[entranceDirection];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $fdc23bf41f8ea661$export$2e2bcd8739ae039), {
        duration: duration,
        enteringAnimation: $4a76f9191c006c0c$export$8497679fcaaeceb(entranceDirection, distance),
        exitingAnimation: $4a76f9191c006c0c$export$c9190c6659ea755b(exitDirection || invertedEntranceDirection, distance),
        animationTimingFunction: function animationTimingFunction() {
            return 0, $3f521a9befaf5c72$export$c07234257a03d5e9;
        },
        onFinish: onFinish,
        isPaused: isPaused
    }, children);
};
var $4a76f9191c006c0c$export$2e2bcd8739ae039 = $4a76f9191c006c0c$var$FadeIn;






var $dAx5m = parcelRequire("dAx5m");

var $2BQLr = parcelRequire("2BQLr");

// Export types from PopperJS / React Popper
var $40098aebefbb692f$var$constantModifiers = [
    {
        name: "flip",
        options: {
            flipVariations: false,
            padding: 5,
            boundary: "clippingParents",
            rootBoundary: "viewport"
        }
    },
    {
        name: "preventOverflow",
        options: {
            padding: 5,
            rootBoundary: "document"
        }
    }
];
function $40098aebefbb692f$var$defaultChildrenFn() {
    return null;
}
var $40098aebefbb692f$var$defaultOffset = [
    0,
    8
];
function $40098aebefbb692f$export$badac9ada3a0bdf9(_ref) {
    var _ref$children = _ref.children, children = _ref$children === void 0 ? $40098aebefbb692f$var$defaultChildrenFn : _ref$children, _ref$offset = _ref.offset, offset = _ref$offset === void 0 ? $40098aebefbb692f$var$defaultOffset : _ref$offset, _ref$placement = _ref.placement, placement = _ref$placement === void 0 ? "bottom-start" : _ref$placement, _ref$referenceElement = _ref.referenceElement, referenceElement = _ref$referenceElement === void 0 ? undefined : _ref$referenceElement, modifiers = _ref.modifiers, _ref$strategy = _ref.strategy, strategy = _ref$strategy === void 0 ? "fixed" : _ref$strategy;
    var _offset = (0, (/*@__PURE__*/$parcel$interopDefault($96b147e8280c5691$exports)))(offset, 2), offsetX = _offset[0], offsetY = _offset[1];
    // Merge a new offset modifier only if new offset values passed in
    var internalModifiers = (0, $dAx5m.useMemo)(function() {
        var offsetModifier = {
            name: "offset",
            options: {
                offset: [
                    offsetX,
                    offsetY
                ]
            }
        };
        return [].concat($40098aebefbb692f$var$constantModifiers, [
            offsetModifier
        ]);
    }, [
        offsetX,
        offsetY
    ]);
    // Merge custom props and memoize
    var mergedModifiers = (0, $dAx5m.useMemo)(function() {
        if (modifiers == null) return internalModifiers;
        return [].concat((0, (/*@__PURE__*/$parcel$interopDefault($753005c0c019cc18$exports)))(internalModifiers), (0, (/*@__PURE__*/$parcel$interopDefault($753005c0c019cc18$exports)))(modifiers));
    }, [
        internalModifiers,
        modifiers
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $2BQLr.Popper), {
        modifiers: mergedModifiers,
        placement: placement,
        strategy: strategy,
        referenceElement: referenceElement
    }, children);
}



var $k4dMs = parcelRequire("k4dMs");

var $e2xkU = parcelRequire("e2xkU");
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // Reds
var $b7abe4260f63dc29$export$4b84fd0e2c617bd = "#FFEBE6";
var $b7abe4260f63dc29$export$b34b069eff244586 = "#FFBDAD";
var $b7abe4260f63dc29$export$be802dd0d8b57f35 = "#FF8F73";
var $b7abe4260f63dc29$export$60847d42f9da92a6 = "#FF7452";
var $b7abe4260f63dc29$export$4a7404f376229999 = "#FF5630";
var $b7abe4260f63dc29$export$2010d0fb4295b346 = "#DE350B";
var $b7abe4260f63dc29$export$2837b5a1a71d5c02 = "#BF2600";
var $b7abe4260f63dc29$export$8d9596b529bbb9cf = "#FFFAE6";
var $b7abe4260f63dc29$export$41060a744ab0b7ae = "#FFF0B3";
var $b7abe4260f63dc29$export$1cc05bbbf340e559 = "#FFE380";
var $b7abe4260f63dc29$export$5aae31392d72caaa = "#FFC400";
var $b7abe4260f63dc29$export$c6930421db9fa514 = "#FFAB00";
var $b7abe4260f63dc29$export$59619663aa6500fb = "#FF991F";
var $b7abe4260f63dc29$export$874739ea9e379ab6 = "#FF8B00";
var $b7abe4260f63dc29$export$8a6341c32b6a3ee6 = "#E3FCEF";
var $b7abe4260f63dc29$export$69a3bf21b9686c2b = "#ABF5D1";
var $b7abe4260f63dc29$export$afbce1382ec95f73 = "#79F2C0";
var $b7abe4260f63dc29$export$747d86715d4175de = "#57D9A3";
var $b7abe4260f63dc29$export$940e1f69e873f202 = "#36B37E";
var $b7abe4260f63dc29$export$a49394138f7b8e85 = "#00875A";
var $b7abe4260f63dc29$export$6fa04827ac68a4fb = "#006644";
var $b7abe4260f63dc29$export$226de0355ed012f8 = "#DEEBFF";
var $b7abe4260f63dc29$export$8c13c2ee36917869 = "#B3D4FF";
var $b7abe4260f63dc29$export$ecfc1dff386a3e7a = "#4C9AFF";
var $b7abe4260f63dc29$export$215b7063051591f1 = "#2684FF";
var $b7abe4260f63dc29$export$e62e8919cca44969 = "#0065FF";
var $b7abe4260f63dc29$export$b3de0ae08da2ce64 = "#0052CC";
var $b7abe4260f63dc29$export$a6ee3d71bc067634 = "#0747A6";
var $b7abe4260f63dc29$export$363e4475840015bb = "#EAE6FF";
var $b7abe4260f63dc29$export$4b0a4417ed59760f = "#C0B6F2";
var $b7abe4260f63dc29$export$6011520a64d9a187 = "#998DD9";
var $b7abe4260f63dc29$export$a7175d4e9206bc80 = "#8777D9";
var $b7abe4260f63dc29$export$b48405b95304b5a1 = "#6554C0";
var $b7abe4260f63dc29$export$c71e4279dd54a18d = "#5243AA";
var $b7abe4260f63dc29$export$147899de772240ec = "#403294";
var $b7abe4260f63dc29$export$2cf711fe14c66f06 = "#E6FCFF";
var $b7abe4260f63dc29$export$7a8f4d33f6f9772c = "#B3F5FF";
var $b7abe4260f63dc29$export$776c9c497ef08533 = "#79E2F2";
var $b7abe4260f63dc29$export$69cb3ca10c1e330e = "#00C7E6";
var $b7abe4260f63dc29$export$9dc1ef0f3f48059b = "#00B8D9";
var $b7abe4260f63dc29$export$7c835c78b6fcdef8 = "#00A3BF";
var $b7abe4260f63dc29$export$6036577f95c3877e = "#008DA6";
var $b7abe4260f63dc29$export$29a4f05edc054374 = "#FFFFFF";
var $b7abe4260f63dc29$export$e655ef011c4aa1a2 = "#FAFBFC";
var $b7abe4260f63dc29$export$9fdfb749e33cdf97 = "#F4F5F7";
var $b7abe4260f63dc29$export$3e51e8f1440314ba = "#EBECF0";
var $b7abe4260f63dc29$export$1ce2d1575d444ceb = "#DFE1E6";
var $b7abe4260f63dc29$export$8754fc7e6d8b3000 = "#C1C7D0";
var $b7abe4260f63dc29$export$c2e91cbeada39b8b = "#B3BAC5";
var $b7abe4260f63dc29$export$5f71e19f3a7ad9de = "#A5ADBA";
var $b7abe4260f63dc29$export$eaa8c8a70ac22806 = "#97A0AF";
var $b7abe4260f63dc29$export$7c87d337fb91a97d = "#8993A4";
var $b7abe4260f63dc29$export$d6447c357493214f = "#7A869A";
var $b7abe4260f63dc29$export$f563ee71e9ee74cd = "#6B778C";
var $b7abe4260f63dc29$export$e2ef2124cf4024b1 = "#5E6C84";
var $b7abe4260f63dc29$export$eece5f492e429f08 = "#505F79";
var $b7abe4260f63dc29$export$c39c0fe0f26207ae = "#42526E";
var $b7abe4260f63dc29$export$7090862dc3038a9f = "#344563";
var $b7abe4260f63dc29$export$ad0bacf983b7ddaa = "#253858";
var $b7abe4260f63dc29$export$7d61b15e0da132af = "#172B4D";
var $b7abe4260f63dc29$export$fbda843f0a27fe96 = "#091E42";
var $b7abe4260f63dc29$export$791e57b27ca738ef = "rgba(9, 30, 66, 0.02)";
var $b7abe4260f63dc29$export$8d43898f60b96a82 = "rgba(9, 30, 66, 0.04)";
var $b7abe4260f63dc29$export$920c0d5c49070351 = "rgba(9, 30, 66, 0.08)";
var $b7abe4260f63dc29$export$46987b49aab6d1a8 = "rgba(9, 30, 66, 0.13)";
var $b7abe4260f63dc29$export$7d3359664e8bb0e5 = "rgba(9, 30, 66, 0.25)";
var $b7abe4260f63dc29$export$d2d3bedfb276cac0 = "rgba(9, 30, 66, 0.31)";
var $b7abe4260f63dc29$export$6e5e7499ff054f6d = "rgba(9, 30, 66, 0.36)";
var $b7abe4260f63dc29$export$59264b346c877fa7 = "rgba(9, 30, 66, 0.42)";
var $b7abe4260f63dc29$export$d092757d7c64925c = "rgba(9, 30, 66, 0.48)";
var $b7abe4260f63dc29$export$486ab785e4bac3c6 = "rgba(9, 30, 66, 0.54)";
var $b7abe4260f63dc29$export$fba592bbc6419fea = "rgba(9, 30, 66, 0.60)";
var $b7abe4260f63dc29$export$13609db0e6812ab8 = "rgba(9, 30, 66, 0.66)";
var $b7abe4260f63dc29$export$fbae4efaa892d883 = "rgba(9, 30, 66, 0.71)";
var $b7abe4260f63dc29$export$f13946d26f440ce6 = "rgba(9, 30, 66, 0.77)";
var $b7abe4260f63dc29$export$19f58225ac52a306 = "rgba(9, 30, 66, 0.82)";
var $b7abe4260f63dc29$export$6384f09da70e7b62 = "rgba(9, 30, 66, 0.89)";
var $b7abe4260f63dc29$export$d0dccc730683edc2 = "rgba(9, 30, 66, 0.95)";
var $b7abe4260f63dc29$export$2f6319cf7d736c2a = "#E6EDFA";
var $b7abe4260f63dc29$export$95126bc8884d6634 = "#DCE5F5";
var $b7abe4260f63dc29$export$8338d8c35d44ff1 = "#CED9EB";
var $b7abe4260f63dc29$export$5368d76ae4fbbda7 = "#B8C7E0";
var $b7abe4260f63dc29$export$9f0a771d16ec8d36 = "#ABBBD6";
var $b7abe4260f63dc29$export$abcf8c38338b4aa5 = "#9FB0CC";
var $b7abe4260f63dc29$export$97e81faa16a182c7 = "#8C9CB8";
var $b7abe4260f63dc29$export$bfe21c59123ecf33 = "#7988A3";
var $b7abe4260f63dc29$export$ee82aa2ea6a1558 = "#67758F";
var $b7abe4260f63dc29$export$682927c6ed76be02 = "#56637A";
var $b7abe4260f63dc29$export$91fd9994c5be9757 = "#455166";
var $b7abe4260f63dc29$export$d281fbfe3cff2df6 = "#3B475C";
var $b7abe4260f63dc29$export$3902c91d8b98a753 = "#313D52";
var $b7abe4260f63dc29$export$8e8133c1ba5845b5 = "#283447";
var $b7abe4260f63dc29$export$33ff357f6620b39 = "#202B3D";
var $b7abe4260f63dc29$export$633847cf062b69e0 = "#1B2638";
var $b7abe4260f63dc29$export$9776a6e503bdbf76 = "#121A29";
var $b7abe4260f63dc29$export$6c813d5160dff5db = "#0E1624";
var $b7abe4260f63dc29$export$3d4f271a500072a = "#0D1424";
var $b7abe4260f63dc29$export$fe151285c22759ec = "rgba(13, 20, 36, 0.06)";
var $b7abe4260f63dc29$export$a101c6190d0da34 = "rgba(13, 20, 36, 0.14)";
var $b7abe4260f63dc29$export$4b16f52932fda51 = "rgba(13, 20, 36, 0.18)";
var $b7abe4260f63dc29$export$a74bcd7b9845b0d8 = "rgba(13, 20, 36, 0.29)";
var $b7abe4260f63dc29$export$9209c179316d1751 = "rgba(13, 20, 36, 0.36)";
var $b7abe4260f63dc29$export$88f55133f636c8dd = "rgba(13, 20, 36, 0.40)";
var $b7abe4260f63dc29$export$51126f85d1009512 = "rgba(13, 20, 36, 0.47)";
var $b7abe4260f63dc29$export$a069b547bd23af78 = "rgba(13, 20, 36, 0.53)";
var $b7abe4260f63dc29$export$40cce05af3b2600a = "rgba(13, 20, 36, 0.63)";
var $b7abe4260f63dc29$export$b78942185925a0d = "rgba(13, 20, 36, 0.73)";
var $b7abe4260f63dc29$export$e058fb44b8eaafca = "rgba(13, 20, 36, 0.78)";
var $b7abe4260f63dc29$export$92b0b8de26920c18 = "rgba(13, 20, 36, 0.81)";
var $b7abe4260f63dc29$export$67564f7459d3fc9e = "rgba(13, 20, 36, 0.85)";
var $b7abe4260f63dc29$export$77868e1ca884ffa3 = "rgba(13, 20, 36, 0.89)";
var $b7abe4260f63dc29$export$2afd71d7d3ea2cd5 = "rgba(13, 20, 36, 0.92)";
var $b7abe4260f63dc29$export$f2a0acaab9972c70 = "rgba(13, 20, 36, 0.95)";
var $b7abe4260f63dc29$export$9ab70e67d6475361 = "rgba(13, 20, 36, 0.97)";


var $fd5bbd4983d78882$export$44ffba16bd48dac6 = "__ATLASKIT_THEME__";
var $fd5bbd4983d78882$export$c93026a968943f95 = "light";
var $fd5bbd4983d78882$export$6ba72c8346b4c57e = [
    "light",
    "dark"
];
var $fd5bbd4983d78882$export$7a57f79000377ca2 = function borderRadius() {
    return 3;
};
var $fd5bbd4983d78882$export$6d8204c2cb2e06b8 = function gridSize() {
    return 8;
};
var $fd5bbd4983d78882$export$85e3c3ca0c6fb93 = function fontSize() {
    return 14;
};
var $fd5bbd4983d78882$export$6746fe0d9c9fab54 = function fontSizeSmall() {
    return 11;
};
var $fd5bbd4983d78882$export$a5975749f0374264 = function fontFamily() {
    return "-apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif";
};
var $fd5bbd4983d78882$export$356129969ee49c55 = function codeFontFamily() {
    return "'SFMono-Medium', 'SF Mono', 'Segoe UI Mono', 'Roboto Mono', 'Ubuntu Mono', Menlo, Consolas, Courier, monospace";
};
var $fd5bbd4983d78882$export$8e24544ddba725ee = function focusRing() {
    var color = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "var(--ds-border-focused, ".concat((0, $b7abe4260f63dc29$export$215b7063051591f1), ")");
    var outlineWidth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $fd5bbd4983d78882$export$6d8204c2cb2e06b8() / 4;
    (0, $e2xkU.default)("@atlaskit/theme", "focus ring mixin", "Please use `@atlaskit/focus-ring` instead.");
    return "\n  &:focus {\n    outline: none;\n    box-shadow: 0px 0px 0px ".concat(outlineWidth, "px ").concat(color, ";\n  }\n");
};
var $fd5bbd4983d78882$export$c0dd343266bc3261 = function noFocusRing() {
    return "\n  box-shadow: none;\n";
};
var $fd5bbd4983d78882$export$7be255094ccdc533 = {
    card: function card() {
        return 100;
    },
    navigation: function navigation() {
        return 200;
    },
    dialog: function dialog() {
        return 300;
    },
    layer: function layer() {
        return 400;
    },
    blanket: function blanket() {
        return 500;
    },
    modal: function modal() {
        return 510;
    },
    flag: function flag() {
        return 600;
    },
    spotlight: function spotlight() {
        return 700;
    },
    tooltip: function tooltip() {
        return 9999;
    }
};
var $fd5bbd4983d78882$export$a1b3edb637fb4f35 = function visuallyHidden() {
    (0, $e2xkU.default)("@atlaskit/theme", "visually hidden mixin", "Please use `@atlaskit/visually-hidden` instead.");
    return {
        border: "0 !important",
        clip: "rect(1px, 1px, 1px, 1px) !important",
        height: "1px !important",
        overflow: "hidden !important",
        padding: "0 !important",
        position: "absolute !important",
        width: "1px !important",
        whiteSpace: "nowrap !important"
    };
};
var $fd5bbd4983d78882$export$ba1d834b86d72a09 = $fd5bbd4983d78882$export$a1b3edb637fb4f35;
var $fd5bbd4983d78882$export$e497e856b4f89fcd = function skeletonShimmer() {
    return {
        css: {
            backgroundColor: "var(--ds-skeleton, ".concat((0, $b7abe4260f63dc29$export$8d43898f60b96a82), ")"),
            animationDuration: "1.5s",
            animationIterationCount: "infinite",
            animationTimingFunction: "linear",
            animationDirection: "alternate"
        },
        keyframes: {
            from: {
                backgroundColor: "var(--ds-skeleton, ".concat((0, $b7abe4260f63dc29$export$8d43898f60b96a82), ")")
            },
            to: {
                backgroundColor: "var(--ds-skeleton-subtle, ".concat((0, $b7abe4260f63dc29$export$920c0d5c49070351), ")")
            }
        }
    };
};


/* eslint-disable @atlaskit/design-system/no-direct-use-of-web-platform-drag-and-drop */ /**
 * We are listening directly to drag events instead of using a monitor from
 * `@atlaskit/pragmatic-drag-and-drop` to avoid the bundle size cost, as it
 * would affect almost every view in every product.
 *
 * We can reconsider this choice in the future.
 */ 
var $dd4sf = parcelRequire("dd4sf");
var $6c88864ae36fa62d$var$registrations = new Set();
var $6c88864ae36fa62d$var$cleanupEndEventListeners = null;
function $6c88864ae36fa62d$var$onDragStart() {
    if ($6c88864ae36fa62d$var$cleanupEndEventListeners) // If the cleanup function exists then we've already run this
    return;
    $6c88864ae36fa62d$var$cleanupEndEventListeners = (0, $dd4sf.bindAll)(window, [
        {
            type: "dragend",
            listener: $6c88864ae36fa62d$var$onDragEnd
        },
        {
            type: "pointerdown",
            listener: $6c88864ae36fa62d$var$onDragEnd
        },
        {
            type: "pointermove",
            listener: function() {
                var callCount = 0;
                return function listener() {
                    // Using 20 as it is far bigger than the most observed (3)
                    if (callCount < 20) {
                        callCount++;
                        return;
                    }
                    $6c88864ae36fa62d$var$onDragEnd();
                };
            }()
        }
    ]);
    var clone = Array.from($6c88864ae36fa62d$var$registrations);
    clone.forEach(function(subscriber) {
        subscriber.onDragStart();
    });
}
function $6c88864ae36fa62d$var$onDragEnd() {
    var _cleanupEndEventListe;
    (_cleanupEndEventListe = $6c88864ae36fa62d$var$cleanupEndEventListeners) === null || _cleanupEndEventListe === void 0 || _cleanupEndEventListe();
    $6c88864ae36fa62d$var$cleanupEndEventListeners = null;
    var clone = Array.from($6c88864ae36fa62d$var$registrations);
    clone.forEach(function(subscriber) {
        subscriber.onDragEnd();
    });
}
function $6c88864ae36fa62d$var$bindStartEvents() {
    return (0, $dd4sf.bindAll)(window, [
        {
            type: "dragstart",
            listener: $6c88864ae36fa62d$var$onDragStart
        },
        {
            type: "dragenter",
            listener: $6c88864ae36fa62d$var$onDragStart
        }
    ]);
}
var $6c88864ae36fa62d$var$cleanupStartEventListeners = null;
function $6c88864ae36fa62d$export$6503ec6e8aabbaf(registration) {
    // if first registration, bind event listeners
    if (!$6c88864ae36fa62d$var$cleanupStartEventListeners) // note: currently never unbinding these event listeners
    $6c88864ae36fa62d$var$cleanupStartEventListeners = $6c88864ae36fa62d$var$bindStartEvents();
    $6c88864ae36fa62d$var$registrations.add(registration);
    /**
   * The reasoning for this behavior is so that if a tooltip mounts during
   * a drag it can still be suppressed.
   *
   * We use a separate callback instead of onDragStart to avoid infinite loops.
   */ registration.onRegister({
        isDragging: $6c88864ae36fa62d$var$cleanupEndEventListeners !== null
    });
    return function unregister() {
        $6c88864ae36fa62d$var$registrations.delete(registration);
        if ($6c88864ae36fa62d$var$registrations.size === 0) {
            var _cleanupStartEventLis;
            (_cleanupStartEventLis = $6c88864ae36fa62d$var$cleanupStartEventListeners) === null || _cleanupStartEventLis === void 0 || _cleanupStartEventLis();
            $6c88864ae36fa62d$var$cleanupStartEventListeners = null;
        }
    };
}


var $7a3ad755f9878345$var$delayId = null;
function $7a3ad755f9878345$export$eaf678f6f93f5250() {
    if ($7a3ad755f9878345$var$delayId != null) {
        window.clearTimeout($7a3ad755f9878345$var$delayId);
        $7a3ad755f9878345$var$delayId = null;
    }
}
function $7a3ad755f9878345$export$5f4d6617421d489b(fn, delay) {
    $7a3ad755f9878345$export$eaf678f6f93f5250();
    $7a3ad755f9878345$var$delayId = window.setTimeout(function() {
        $7a3ad755f9878345$var$delayId = null;
        fn();
    }, delay);
}


// This file is a singleton for managing tooltips
var $ae33c75c559844c0$var$active = null;
function $ae33c75c559844c0$export$57bf213be019eeb0(entry) {
    var phase = "waiting-to-show";
    function isActive() {
        return Boolean($ae33c75c559844c0$var$active && $ae33c75c559844c0$var$active.entry === entry);
    }
    function cleanup() {
        if (isActive()) {
            (0, $7a3ad755f9878345$export$eaf678f6f93f5250)();
            $ae33c75c559844c0$var$active = null;
        }
    }
    function done() {
        if (isActive()) entry.done();
        phase = "done";
        cleanup();
    }
    function immediatelyHideAndDone() {
        if (isActive()) entry.hide({
            isImmediate: true
        });
        done();
    }
    function keep() {
        if (!isActive()) return;
        // aborting a wait to hide
        if (phase === "waiting-to-hide") {
            phase = "shown";
            (0, $7a3ad755f9878345$export$eaf678f6f93f5250)();
            return;
        }
        // aborting hide animation
        if (phase === "hide-animating") {
            phase = "shown";
            (0, $7a3ad755f9878345$export$eaf678f6f93f5250)();
            entry.show({
                isImmediate: false
            });
            return;
        }
    }
    function requestHide(_ref) {
        var isImmediate = _ref.isImmediate;
        if (!isActive()) return;
        // If we were not showing yet anyway; finish straight away
        if (phase === "waiting-to-show") {
            immediatelyHideAndDone();
            return;
        }
        // already waiting to hide
        if (phase === "waiting-to-hide") return;
        if (isImmediate) {
            immediatelyHideAndDone();
            return;
        }
        phase = "waiting-to-hide";
        (0, $7a3ad755f9878345$export$5f4d6617421d489b)(function() {
            phase = "hide-animating";
            entry.hide({
                isImmediate: false
            });
        }, entry.delay);
    }
    function finishHideAnimation() {
        if (isActive() && phase === "hide-animating") done();
    }
    function isVisible() {
        return phase === "shown" || phase === "waiting-to-hide" || phase === "hide-animating";
    }
    function getInitialMouse() {
        if (entry.source.type === "mouse") return entry.source.mouse;
        return null;
    }
    function start() {
        var showImmediately = Boolean($ae33c75c559844c0$var$active && $ae33c75c559844c0$var$active.isVisible());
        // If there was an active tooltip; we tell it to remove itself at once!
        if ($ae33c75c559844c0$var$active) {
            (0, $7a3ad755f9878345$export$eaf678f6f93f5250)();
            $ae33c75c559844c0$var$active.entry.hide({
                isImmediate: true
            });
            $ae33c75c559844c0$var$active.entry.done();
            $ae33c75c559844c0$var$active = null;
        }
        // this tooltip is now the active tooltip
        $ae33c75c559844c0$var$active = {
            entry: entry,
            isVisible: isVisible
        };
        function show() {
            phase = "shown";
            entry.show({
                isImmediate: showImmediately
            });
        }
        if (showImmediately) {
            show();
            return;
        }
        phase = "waiting-to-show";
        (0, $7a3ad755f9878345$export$5f4d6617421d489b)(show, entry.delay);
    }
    // let's get started!
    start();
    var result = {
        keep: keep,
        abort: cleanup,
        isActive: isActive,
        requestHide: requestHide,
        finishHideAnimation: finishHideAnimation,
        mousePosition: getInitialMouse()
    };
    return result;
}



var $lyB4O = parcelRequire("lyB4O");
function $ad5c0fcf12360529$export$2e2bcd8739ae039(prefix, shouldRenderId) {
    var seed = (0, $lyB4O.useIdSeed)();
    return shouldRenderId ? "".concat(seed(prefix)) : undefined;
}


/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $dAx5m = parcelRequire("dAx5m");

var $jVTBW = parcelRequire("jVTBW");



var $dAx5m = parcelRequire("dAx5m");

var $jVTBW = parcelRequire("jVTBW");

function $8a638282feb3fedb$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $8a638282feb3fedb$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $8a638282feb3fedb$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($659b468336d903e3$exports)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $8a638282feb3fedb$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $8a638282feb3fedb$var$VAR_PRIMITIVE_ZINDEX = "tooltipPrimitiveZindex";
var $8a638282feb3fedb$var$primitiveStyles = (0, $jVTBW.css)({
    zindex: "var(".concat($8a638282feb3fedb$var$VAR_PRIMITIVE_ZINDEX, ")"),
    cursor: "default"
});
var $8a638282feb3fedb$var$TooltipPrimitive = /*#__PURE__*/ (0, $dAx5m.forwardRef)(function TooltipPrimitive(_ref, ref) {
    var style = _ref.style, className = _ref.className, children = _ref.children, placement = _ref.placement, testId = _ref.testId, onMouseOut = _ref.onMouseOut, onMouseOver = _ref.onMouseOver, id = _ref.id;
    var styleWithZIndex = $8a638282feb3fedb$var$_objectSpread($8a638282feb3fedb$var$_objectSpread({}, style), {}, (0, (/*@__PURE__*/$parcel$interopDefault($659b468336d903e3$exports)))({}, $8a638282feb3fedb$var$VAR_PRIMITIVE_ZINDEX, (0, $fd5bbd4983d78882$export$7be255094ccdc533).tooltip()));
    return (0, $jVTBW.jsx)("div", {
        ref: ref,
        style: styleWithZIndex,
        "data-testid": testId ? "".concat(testId, "--wrapper") : undefined
    }, (0, $jVTBW.jsx)("div", {
        role: "tooltip",
        className: className,
        onMouseOut: onMouseOut,
        onMouseOver: onMouseOver,
        css: $8a638282feb3fedb$var$primitiveStyles,
        "data-placement": placement,
        "data-testid": testId,
        id: id
    }, children));
});
$8a638282feb3fedb$var$TooltipPrimitive.displayName = "TooltipPrimitive";
var $8a638282feb3fedb$export$2e2bcd8739ae039 = $8a638282feb3fedb$var$TooltipPrimitive;


var $8628630a417d281b$var$baseStyles = (0, $jVTBW.css)({
    boxSizing: "border-box",
    maxWidth: "240px",
    padding: "var(--ds-space-025, 2px)".concat(" ", "var(--ds-space-075, 6px)"),
    insetBlockStart: "var(--ds-space-0, 0px)",
    insetInlineStart: "var(--ds-space-0, 0px)",
    borderRadius: "var(--ds-border-radius, 3px)",
    font: 'var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    overflowWrap: "break-word",
    wordWrap: "break-word",
    backgroundColor: "var(--ds-background-neutral-bold, ".concat((0, $b7abe4260f63dc29$export$7d61b15e0da132af), ")"),
    color: "var(--ds-text-inverse, ".concat((0, $b7abe4260f63dc29$export$29a4f05edc054374), ")")
});
var $8628630a417d281b$var$truncateStyles = (0, $jVTBW.css)({
    maxWidth: "420px",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap"
});
var $8628630a417d281b$var$TooltipContainer = /*#__PURE__*/ (0, $dAx5m.forwardRef)(function TooltipContainer(_ref, ref) {
    var style = _ref.style, className = _ref.className, children = _ref.children, truncate = _ref.truncate, placement = _ref.placement, testId = _ref.testId, onMouseOut = _ref.onMouseOut, onMouseOver = _ref.onMouseOver, id = _ref.id;
    return (0, $jVTBW.jsx)((0, $8a638282feb3fedb$export$2e2bcd8739ae039), {
        ref: ref,
        style: style,
        className: className,
        placement: placement,
        testId: testId,
        id: id,
        onMouseOut: onMouseOut,
        onMouseOver: onMouseOver,
        css: [
            $8628630a417d281b$var$baseStyles,
            truncate ? $8628630a417d281b$var$truncateStyles : null
        ]
    }, children);
});
$8628630a417d281b$var$TooltipContainer.displayName = "TooltipContainer";
var $8628630a417d281b$export$2e2bcd8739ae039 = $8628630a417d281b$var$TooltipContainer;


function $79dfb23389c4faa3$export$642213d516a9b928(mouseCoordinates) {
    var safeMouse = mouseCoordinates || {
        top: 0,
        left: 0
    };
    var getBoundingClientRect = function getBoundingClientRect() {
        return {
            top: safeMouse.top,
            left: safeMouse.left,
            bottom: safeMouse.top,
            right: safeMouse.left,
            width: 0,
            height: 0
        };
    };
    return {
        getBoundingClientRect: getBoundingClientRect,
        clientWidth: 0,
        clientHeight: 0
    };
}


function $283c3d996293cc99$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $283c3d996293cc99$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $283c3d996293cc99$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($659b468336d903e3$exports)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $283c3d996293cc99$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $283c3d996293cc99$var$tooltipZIndex = (0, $fd5bbd4983d78882$export$7be255094ccdc533).tooltip();
var $283c3d996293cc99$var$analyticsAttributes = {
    componentName: "tooltip",
    packageName: "@atlaskit/tooltip",
    packageVersion: "18.7.2"
};
// Inverts motion direction
var $283c3d996293cc99$var$invertedDirection = {
    top: "bottom",
    bottom: "top",
    left: "right",
    right: "left"
};
/**
 * Converts a Popper placement to it's general direction.
 *
 * @param placement - Popper Placement value, e.g. 'top-start'
 * @returns Popper Direction, e.g. 'top'
 */ var $283c3d996293cc99$var$getDirectionFromPlacement = function getDirectionFromPlacement(placement) {
    return placement.split("-")[0];
};
function $283c3d996293cc99$var$Tooltip(_ref) {
    var children = _ref.children, _ref$position = _ref.position, position = _ref$position === void 0 ? "bottom" : _ref$position, _ref$mousePosition = _ref.mousePosition, mousePosition = _ref$mousePosition === void 0 ? "bottom" : _ref$mousePosition, content = _ref.content, _ref$truncate = _ref.truncate, truncate = _ref$truncate === void 0 ? false : _ref$truncate, _ref$component = _ref.component, Container = _ref$component === void 0 ? (0, $8628630a417d281b$export$2e2bcd8739ae039) : _ref$component, _ref$tag = _ref.tag, TargetContainer = _ref$tag === void 0 ? "div" : _ref$tag, testId = _ref.testId, _ref$delay = _ref.delay, delay = _ref$delay === void 0 ? 300 : _ref$delay, _ref$onShow = _ref.onShow, onShow = _ref$onShow === void 0 ? (0, $Bb0he.default) : _ref$onShow, _ref$onHide = _ref.onHide, onHide = _ref$onHide === void 0 ? (0, $Bb0he.default) : _ref$onHide, _ref$hideTooltipOnCli = _ref.hideTooltipOnClick, hideTooltipOnClick = _ref$hideTooltipOnCli === void 0 ? false : _ref$hideTooltipOnCli, _ref$hideTooltipOnMou = _ref.hideTooltipOnMouseDown, hideTooltipOnMouseDown = _ref$hideTooltipOnMou === void 0 ? false : _ref$hideTooltipOnMou, analyticsContext = _ref.analyticsContext, _ref$strategy = _ref.strategy, strategy = _ref$strategy === void 0 ? "fixed" : _ref$strategy, _ref$ignoreTooltipPoi = _ref.ignoreTooltipPointerEvents, ignoreTooltipPointerEvents = _ref$ignoreTooltipPoi === void 0 ? false : _ref$ignoreTooltipPoi;
    var tooltipPosition = position === "mouse" ? mousePosition : position;
    var onShowHandler = (0, $f80b5c134ffe70e6$export$1a04351537078b55)($283c3d996293cc99$var$_objectSpread({
        fn: onShow,
        action: "displayed",
        analyticsData: analyticsContext
    }, $283c3d996293cc99$var$analyticsAttributes));
    var onHideHandler = (0, $f80b5c134ffe70e6$export$1a04351537078b55)($283c3d996293cc99$var$_objectSpread({
        fn: onHide,
        action: "hidden",
        analyticsData: analyticsContext
    }, $283c3d996293cc99$var$analyticsAttributes));
    var apiRef = (0, $dAx5m.useRef)(null);
    var _useState = (0, $dAx5m.useState)("hide"), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($96b147e8280c5691$exports)))(_useState, 2), state = _useState2[0], setState = _useState2[1];
    var targetRef = (0, $dAx5m.useRef)(null);
    var containerRef = (0, $dAx5m.useRef)(null);
    // This function is deliberately _not_ memoized as it needs to re-run every render
    // to pick up any child ref changes. If you use render props you don't have this issue.
    var setImplicitRefFromChildren = function setImplicitRefFromChildren(node) {
        containerRef.current = node;
        targetRef.current = node ? node.firstElementChild : null;
    };
    // This is memoized and passed into the render props callback.
    var setDirectRef = (0, $dAx5m.useCallback)(function(node) {
        targetRef.current = node;
    }, []);
    // Putting a few things into refs so that we don't have to break memoization
    var lastState = (0, $dAx5m.useRef)(state);
    var lastDelay = (0, $dAx5m.useRef)(delay);
    var lastHandlers = (0, $dAx5m.useRef)({
        onShowHandler: onShowHandler,
        onHideHandler: onHideHandler
    });
    var hasCalledShowHandler = (0, $dAx5m.useRef)(false);
    (0, $dAx5m.useEffect)(function() {
        lastState.current = state;
        lastDelay.current = delay;
        lastHandlers.current = {
            onShowHandler: onShowHandler,
            onHideHandler: onHideHandler
        };
    }, [
        delay,
        onHideHandler,
        onShowHandler,
        state
    ]);
    var start = (0, $dAx5m.useCallback)(function(api) {
        // @ts-ignore
        apiRef.current = api;
        hasCalledShowHandler.current = false;
    }, []);
    var done = (0, $dAx5m.useCallback)(function() {
        if (!apiRef.current) return;
        // Only call onHideHandler if we have called onShowHandler
        if (hasCalledShowHandler.current) lastHandlers.current.onHideHandler();
        // @ts-ignore
        apiRef.current = null;
        // @ts-ignore
        hasCalledShowHandler.current = false;
        // just in case
        setState("hide");
    }, []);
    var abort = (0, $dAx5m.useCallback)(function() {
        if (!apiRef.current) return;
        apiRef.current.abort();
        // Only call onHideHandler if we have called onShowHandler
        if (hasCalledShowHandler.current) lastHandlers.current.onHideHandler();
        // @ts-ignore
        apiRef.current = null;
    }, []);
    (0, $dAx5m.useEffect)(function mount() {
        return function unmount() {
            if (apiRef.current) abort();
        };
    }, [
        abort
    ]);
    var isDraggingRef = (0, $dAx5m.useRef)(false);
    (0, $dAx5m.useEffect)(function() {
        return (0, $6c88864ae36fa62d$export$6503ec6e8aabbaf)({
            onRegister: function onRegister(_ref2) {
                var isDragging = _ref2.isDragging;
                isDraggingRef.current = isDragging;
            },
            onDragStart: function onDragStart() {
                var _apiRef$current;
                /**
         * Hiding any visible tooltips when a drag starts because otherwise it
         * looks janky (disappears and reappears), and is not required.
         */ (_apiRef$current = apiRef.current) === null || _apiRef$current === void 0 || _apiRef$current.requestHide({
                    isImmediate: true
                });
                isDraggingRef.current = true;
            },
            onDragEnd: function onDragEnd() {
                isDraggingRef.current = false;
            }
        });
    }, []);
    var showTooltip = (0, $dAx5m.useCallback)(function(source) {
        /**
     * Prevent tooltips from being shown during a drag. This can occur with
     * the native drag and drop API, where some pointer events can fire
     * when they should not and lead to jank with tooltips.
     */ if (isDraggingRef.current) return;
        if (apiRef.current && !apiRef.current.isActive()) abort();
        // Tell the tooltip to keep showing
        if (apiRef.current && apiRef.current.isActive()) {
            apiRef.current.keep();
            return;
        }
        var entry = {
            source: source,
            delay: lastDelay.current,
            show: function show(_ref3) {
                var isImmediate = _ref3.isImmediate;
                // Call the onShow handler if it hasn't been called yet
                if (!hasCalledShowHandler.current) {
                    hasCalledShowHandler.current = true;
                    lastHandlers.current.onShowHandler();
                }
                setState(isImmediate ? "show-immediate" : "fade-in");
            },
            hide: function hide(_ref4) {
                var isImmediate = _ref4.isImmediate;
                if (isImmediate) setState("hide");
                else setState("before-fade-out");
            },
            done: done
        };
        var api = (0, $ae33c75c559844c0$export$57bf213be019eeb0)(entry);
        start(api);
    }, [
        abort,
        done,
        start
    ]);
    var hideTooltipOnEsc = (0, $dAx5m.useCallback)(function() {
        var _apiRef$current2;
        (_apiRef$current2 = apiRef.current) === null || _apiRef$current2 === void 0 || _apiRef$current2.requestHide({
            isImmediate: true
        });
    }, [
        apiRef
    ]);
    (0, $6Oq6X.default)({
        onClose: hideTooltipOnEsc,
        isDisabled: state === "hide" || state === "fade-out"
    });
    (0, $dAx5m.useEffect)(function() {
        if (state === "hide") return 0, $Bb0he.default;
        if (state === "before-fade-out") setState("fade-out");
        var unbind = (0, $dd4sf.bind)(window, {
            type: "scroll",
            listener: function listener() {
                if (apiRef.current) apiRef.current.requestHide({
                    isImmediate: true
                });
            },
            options: {
                capture: true,
                passive: true,
                once: true
            }
        });
        return unbind;
    }, [
        state
    ]);
    var onMouseDown = (0, $dAx5m.useCallback)(function() {
        if (hideTooltipOnMouseDown && apiRef.current) apiRef.current.requestHide({
            isImmediate: true
        });
    }, [
        hideTooltipOnMouseDown
    ]);
    var onClick = (0, $dAx5m.useCallback)(function() {
        if (hideTooltipOnClick && apiRef.current) apiRef.current.requestHide({
            isImmediate: true
        });
    }, [
        hideTooltipOnClick
    ]);
    // Ideally we would be using onMouseEnter here, but
    // because we are binding the event to the target parent
    // we need to listen for the mouseover of all sub elements
    // This means when moving along a tooltip we are quickly toggling
    // between api.requestHide and api.keep. This it not ideal
    var onMouseOver = (0, $dAx5m.useCallback)(function(event) {
        // Ignoring events from the container ref
        if (containerRef.current && event.target === containerRef.current) return;
        // Using prevent default as a signal that parent tooltips
        if (event.defaultPrevented) return;
        event.preventDefault();
        var source = position === "mouse" ? {
            type: "mouse",
            // TODO: ideally not recalculating this object each time
            mouse: (0, $79dfb23389c4faa3$export$642213d516a9b928)({
                left: event.clientX,
                top: event.clientY
            })
        } : {
            type: "keyboard"
        };
        showTooltip(source);
    }, [
        position,
        showTooltip
    ]);
    // Ideally we would be using onMouseEnter here, but
    // because we are binding the event to the target parent
    // we need to listen for the mouseout of all sub elements
    // This means when moving along a tooltip we are quickly toggling
    // between api.requestHide and api.keep. This it not ideal
    var onMouseOut = (0, $dAx5m.useCallback)(function(event) {
        // Ignoring events from the container ref
        if (containerRef.current && event.target === containerRef.current) return;
        // Using prevent default as a signal that parent tooltips
        if (event.defaultPrevented) return;
        event.preventDefault();
        if (apiRef.current) apiRef.current.requestHide({
            isImmediate: false
        });
    }, []);
    var onMouseMove = position === "mouse" ? function(event) {
        var _apiRef$current3;
        if ((_apiRef$current3 = apiRef.current) !== null && _apiRef$current3 !== void 0 && _apiRef$current3.isActive()) apiRef.current.mousePosition = (0, $79dfb23389c4faa3$export$642213d516a9b928)({
            left: event.clientX,
            top: event.clientY
        });
    } : undefined;
    var onMouseOverTooltip = (0, $dAx5m.useCallback)(function() {
        if (apiRef.current && apiRef.current.isActive()) {
            apiRef.current.keep();
            return;
        }
    }, []);
    var onFocus = (0, $dAx5m.useCallback)(function() {
        showTooltip({
            type: "keyboard"
        });
    }, [
        showTooltip
    ]);
    var onBlur = (0, $dAx5m.useCallback)(function() {
        if (apiRef.current) apiRef.current.requestHide({
            isImmediate: false
        });
    }, []);
    var onAnimationFinished = (0, $dAx5m.useCallback)(function(transition) {
        // Using lastState here because motion is not picking up the latest value
        if (transition === "exiting" && lastState.current === "fade-out" && apiRef.current) // @ts-ignore: refs are writeable
        apiRef.current.finishHideAnimation();
    }, []);
    // Doing a cast because typescript is struggling to narrow the type
    var CastTargetContainer = TargetContainer;
    var shouldRenderTooltipContainer = state !== "hide" && Boolean(content);
    var shouldRenderTooltipChildren = state !== "hide" && state !== "fade-out";
    var getReferenceElement = function getReferenceElement() {
        var _apiRef$current4;
        if (position === "mouse" && (_apiRef$current4 = apiRef.current) !== null && _apiRef$current4 !== void 0 && _apiRef$current4.mousePosition) {
            var _apiRef$current5;
            return (_apiRef$current5 = apiRef.current) === null || _apiRef$current5 === void 0 ? void 0 : _apiRef$current5.mousePosition;
        }
        return targetRef.current || undefined;
    };
    var tooltipId = (0, $ad5c0fcf12360529$export$2e2bcd8739ae039)("tooltip", shouldRenderTooltipContainer);
    var tooltipTriggerProps = {
        onMouseOver: onMouseOver,
        onMouseOut: onMouseOut,
        onMouseMove: onMouseMove,
        onMouseDown: onMouseDown,
        onClick: onClick,
        onFocus: onFocus,
        onBlur: onBlur
    };
    // Don't set `data-testid` unless it's defined, as it's not in the interface.
    if (testId) // @ts-expect-error - Adding `data-testid` to the TriggerProps interface breaks Buttons.
    tooltipTriggerProps["data-testid"] = "".concat(testId, "--container");
    // This useEffect is purely for managing the aria attribute when using the
    // wrapped children approach.
    (0, $dAx5m.useEffect)(function() {
        // If there is no container element, we should exit early, because that
        // means they are using the render prop API, and that is implemented in a
        // different way. If there is no target element yet or tooltipId, we also
        // shouldn't do anything because there is nothing to operate on or with.
        if (!containerRef.current || !targetRef.current || !tooltipId) return;
        var target = targetRef.current;
        if (shouldRenderTooltipContainer) target.setAttribute("aria-describedby", tooltipId);
        else target.removeAttribute("aria-describedby");
    }, [
        shouldRenderTooltipContainer,
        tooltipId
    ]);
    var hiddenContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement("span", {
        "data-testid": testId ? "".concat(testId, "-hidden") : undefined,
        hidden: true,
        id: tooltipId
    }, typeof content === "function" ? content({}) : content);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).Fragment, null, typeof children === "function" ? /*#__PURE__*/ // once we deprecate the wrapped approach, we can put the aria
    // attribute back into the tooltipTriggerProps and make it required
    // instead of optional in `types`
    (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).Fragment, null, children($283c3d996293cc99$var$_objectSpread($283c3d996293cc99$var$_objectSpread({}, tooltipTriggerProps), {}, {
        "aria-describedby": tooltipId,
        ref: setDirectRef
    })), shouldRenderTooltipContainer && hiddenContent) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement(CastTargetContainer, (0, (/*@__PURE__*/$parcel$interopDefault($147dc3434bd55d1d$exports)))({}, tooltipTriggerProps, {
        ref: setImplicitRefFromChildren,
        role: "presentation"
    }), children, shouldRenderTooltipContainer && hiddenContent), shouldRenderTooltipContainer ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $k4dMs.default), {
        zIndex: $283c3d996293cc99$var$tooltipZIndex
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $40098aebefbb692f$export$badac9ada3a0bdf9), {
        placement: tooltipPosition,
        referenceElement: getReferenceElement(),
        strategy: strategy
    }, function(_ref5) {
        var ref = _ref5.ref, style = _ref5.style, update = _ref5.update, placement = _ref5.placement;
        // Invert the entrance and exit directions.
        // E.g. a tooltip's position is on the 'right', it should enter from and exit to the 'left'
        // This gives the effect the tooltip is appearing from the target
        var direction = position === "mouse" ? undefined : $283c3d996293cc99$var$invertedDirection[$283c3d996293cc99$var$getDirectionFromPlacement(placement)];
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $110220dbdcac0464$export$2e2bcd8739ae039), {
            appear: true
        }, shouldRenderTooltipChildren && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $4a76f9191c006c0c$export$2e2bcd8739ae039), {
            distance: "constant",
            entranceDirection: direction,
            exitDirection: direction,
            onFinish: onAnimationFinished,
            duration: state === "show-immediate" ? 0 : (0, $75e0d026b358fd49$export$6fa259be09e118a7)
        }, function(_ref6) {
            var className = _ref6.className;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement(Container, {
                ref: ref,
                className: "Tooltip ".concat(className),
                style: $283c3d996293cc99$var$_objectSpread($283c3d996293cc99$var$_objectSpread({}, style), ignoreTooltipPointerEvents && {
                    pointerEvents: "none"
                }),
                truncate: truncate,
                placement: tooltipPosition,
                testId: getReferenceElement() ? testId : testId && "".concat(testId, "--unresolved"),
                onMouseOut: onMouseOut,
                onMouseOver: onMouseOverTooltip
            }, typeof content === "function" ? content({
                update: update
            }) : content);
        }));
    })) : null);
}
$283c3d996293cc99$var$Tooltip.displayName = "Tooltip";
var $283c3d996293cc99$export$2e2bcd8739ae039 = $283c3d996293cc99$var$Tooltip;



var $dAx5m = parcelRequire("dAx5m");

var $9afc2d28bb10b801$export$93d4e7f90805808f = function useTheme() {
    return (0, $dAx5m.useContext)((0, $0c371fb60a7c6f5e$export$2c657da244d00bd6));
};



function $22df435053e495a5$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $22df435053e495a5$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $22df435053e495a5$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($659b468336d903e3$exports)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $22df435053e495a5$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $22df435053e495a5$export$14dd6915caf431fe = function getPrimaryButtonTheme(_ref) {
    var primaryButton = _ref.mode.primaryButton;
    return function(current, props) {
        var _current = current(props), buttonStyles = _current.buttonStyles, spinnerStyles = _current.spinnerStyles;
        return {
            buttonStyles: $22df435053e495a5$var$_objectSpread($22df435053e495a5$var$_objectSpread($22df435053e495a5$var$_objectSpread($22df435053e495a5$var$_objectSpread({}, buttonStyles), primaryButton.default), props.isSelected && primaryButton.selected), {}, {
                fontWeight: 500,
                padding: "0 ".concat("var(--ds-space-050, 4px)"),
                marginLeft: 0,
                marginRight: 0,
                ":hover": props.isSelected ? primaryButton.selectedHover : primaryButton.hover,
                ":focus": primaryButton.focus,
                // :active doesn't work in FF, because we do a
                // e.preventDefault() on mouse down in Button.
                // '&&' is required to add more CSS specificity
                // && it not a valid CSSObject property
                // @ts-ignore
                "&&": $22df435053e495a5$var$_objectSpread({}, props.state === "active" && primaryButton.active)
            }),
            spinnerStyles: spinnerStyles
        };
    };
};


var $2c0dc2a163ac4c58$var$_excluded = [
    "children",
    "testId",
    "tooltip",
    "isSelected",
    "isHighlighted"
];
var $2c0dc2a163ac4c58$var$VAR_BUTTON_SELECTED_COLOR = "--button-selected-color";
var $2c0dc2a163ac4c58$var$VAR_BUTTON_SELECTED_BORDER_COLOR = "--button-selected-border-color";
var $2c0dc2a163ac4c58$var$buttonBaseStyles = (0, $jVTBW.css)({
    display: "flex",
    height: "100%",
    position: "relative",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column"
});
var $2c0dc2a163ac4c58$var$buttonHighlightedStyles = (0, $jVTBW.css)({
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
    "&& > *": {
        color: "var(".concat($2c0dc2a163ac4c58$var$VAR_BUTTON_SELECTED_COLOR, ")")
    },
    "&:after": {
        height: 3,
        position: "absolute",
        backgroundColor: "var(".concat($2c0dc2a163ac4c58$var$VAR_BUTTON_SELECTED_BORDER_COLOR, ")"),
        borderStartEndRadius: "var(--ds-border-radius-050, 1px)",
        borderStartStartRadius: "var(--ds-border-radius-050, 1px)",
        content: '""',
        insetBlockEnd: 0,
        insetInlineEnd: "var(--ds-space-050, 4px)",
        insetInlineStart: "var(--ds-space-050, 4px)"
    }
});
var $2c0dc2a163ac4c58$export$ac16a6a04d9b7c84 = /*#__PURE__*/ (0, $dAx5m.forwardRef)(function(props, ref) {
    var _ref;
    var children = props.children, testId = props.testId, tooltip = props.tooltip, isSelected = props.isSelected, isHighlighted = props.isHighlighted, buttonProps = (0, (/*@__PURE__*/$parcel$interopDefault($cada364311d44bd0$exports)))(props, $2c0dc2a163ac4c58$var$_excluded);
    var theme = (0, $9afc2d28bb10b801$export$93d4e7f90805808f)();
    var button = (0, $jVTBW.jsx)("div", {
        style: (_ref = {}, (0, (/*@__PURE__*/$parcel$interopDefault($659b468336d903e3$exports)))(_ref, $2c0dc2a163ac4c58$var$VAR_BUTTON_SELECTED_COLOR, theme.mode.primaryButton.selected.color), (0, (/*@__PURE__*/$parcel$interopDefault($659b468336d903e3$exports)))(_ref, $2c0dc2a163ac4c58$var$VAR_BUTTON_SELECTED_BORDER_COLOR, theme.mode.primaryButton.selected.borderColor), _ref),
        css: [
            $2c0dc2a163ac4c58$var$buttonBaseStyles,
            isHighlighted && $2c0dc2a163ac4c58$var$buttonHighlightedStyles
        ],
        role: "listitem"
    }, (0, $jVTBW.jsx)((0, $fIjLq.default), (0, (/*@__PURE__*/$parcel$interopDefault($147dc3434bd55d1d$exports)))({
        appearance: "primary",
        testId: testId,
        ref: ref,
        isSelected: isSelected,
        theme: (0, $22df435053e495a5$export$14dd6915caf431fe)(theme)
    }, buttonProps), children));
    if (tooltip) return (0, $jVTBW.jsx)((0, $283c3d996293cc99$export$2e2bcd8739ae039), {
        content: tooltip,
        hideTooltipOnClick: true
    }, button);
    return button;
});
var $2c0dc2a163ac4c58$export$2e2bcd8739ae039 = $2c0dc2a163ac4c58$export$ac16a6a04d9b7c84;


var $9313bc2135291c72$var$chevronIconStylesWithSpacingFixStyles = (0, $4db63e30be897e1a$export$f6c783d06584602c)({
    marginInlineEnd: "space.negative.050"
});
var $9313bc2135291c72$export$bb3af89fb196520d = /*#__PURE__*/ (0, $dAx5m.forwardRef)(function(props, ref) {
    return (0, $jVTBW.jsx)((0, $2c0dc2a163ac4c58$export$ac16a6a04d9b7c84), (0, (/*@__PURE__*/$parcel$interopDefault($147dc3434bd55d1d$exports)))({
        iconAfter: (0, $jVTBW.jsx)((0, $7709ea17ce5d2546$export$2e2bcd8739ae039), {
            xcss: $9313bc2135291c72$var$chevronIconStylesWithSpacingFixStyles,
            inline: "space.100"
        }, (0, $jVTBW.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ce72403cb4576c12$exports))), {
            label: ""
        })),
        ref: ref
    }, props));
});
var $9313bc2135291c72$export$2e2bcd8739ae039 = $9313bc2135291c72$export$bb3af89fb196520d;


var $e58f0e7030a1fb9c$var$containerStyles = (0, $jVTBW.css)({
    display: "flex",
    height: "100%",
    position: "relative",
    alignItems: "stretch",
    flexBasis: 0,
    flexGrow: 1,
    flexShrink: 0,
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
    "& > *": {
        margin: "0 ".concat("var(--ds-space-050, 4px)"),
        flexShrink: 0
    }
});
var $e58f0e7030a1fb9c$var$widthObserverContainerStyles = (0, $jVTBW.css)({
    width: "100%",
    minWidth: "1px",
    margin: "0px",
    position: "relative",
    flexShrink: 1
});
var $e58f0e7030a1fb9c$export$43e704064d596a9e = function PrimaryItemsContainer(_ref) {
    var moreLabel = _ref.moreLabel, items = _ref.items, Create = _ref.create, theme = _ref.theme, testId = _ref.testId;
    var _useState = (0, $dAx5m.useState)(false), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($96b147e8280c5691$exports)))(_useState, 2), isMoreOpen = _useState2[0], setIsMoreOpen = _useState2[1];
    var _useOverflowControlle = (0, $23c1a26819a49d2a$export$705aa66a39c35bf7)(items), updateWidth = _useOverflowControlle.updateWidth, visibleItems = _useOverflowControlle.visibleItems, overflowItems = _useOverflowControlle.overflowItems;
    var onMoreClick = (0, $dAx5m.useCallback)(function() {
        setIsMoreOpen(!isMoreOpen);
    }, [
        isMoreOpen,
        setIsMoreOpen
    ]);
    var onMoreClose = (0, $dAx5m.useCallback)(function() {
        setIsMoreOpen(false);
    }, []);
    var openOverflowMenu = (0, $dAx5m.useCallback)(function() {
        setIsMoreOpen(true);
    }, []);
    var trigger = (0, $dAx5m.useCallback)(function(triggerProps) {
        return (0, $jVTBW.jsx)((0, $9313bc2135291c72$export$bb3af89fb196520d), (0, (/*@__PURE__*/$parcel$interopDefault($147dc3434bd55d1d$exports)))({
            onClick: onMoreClick,
            isSelected: isMoreOpen,
            testId: testId ? "".concat(testId, "-overflow-menu-trigger") : "overflow-menu-trigger"
        }, triggerProps), moreLabel);
    }, [
        moreLabel,
        onMoreClick,
        isMoreOpen,
        testId
    ]);
    var content = (0, $dAx5m.useCallback)(function() {
        return (0, $jVTBW.jsx)((0, $23c1a26819a49d2a$export$a3a2def3937905a0), {
            isVisible: false,
            openOverflowMenu: openOverflowMenu,
            closeOverflowMenu: onMoreClose
        }, overflowItems);
    }, // Overflow items has an unstable reference - so we will only recalculate
    // content if `overflowItems` length changes.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        overflowItems.length,
        openOverflowMenu,
        onMoreClose
    ]);
    return (0, $jVTBW.jsx)("div", {
        css: $e58f0e7030a1fb9c$var$containerStyles,
        "data-testid": testId && "".concat(testId, "-primary-actions"),
        role: "list"
    }, (0, $jVTBW.jsx)((0, $23c1a26819a49d2a$export$a3a2def3937905a0), {
        isVisible: true,
        openOverflowMenu: openOverflowMenu,
        closeOverflowMenu: onMoreClose
    }, visibleItems), overflowItems.length > 0 && (0, $jVTBW.jsx)((0, $7vqkt.default), {
        shouldRenderToParent: true,
        placement: "bottom-start",
        content: content,
        isOpen: isMoreOpen,
        onClose: onMoreClose,
        trigger: trigger,
        testId: testId ? "".concat(testId, "-overflow-menu-popup") : "overflow-menu-popup"
    }), Create && (0, $jVTBW.jsx)(Create, null), (0, $jVTBW.jsx)("div", {
        css: $e58f0e7030a1fb9c$var$widthObserverContainerStyles
    }, (0, $jVTBW.jsx)((0, $633a0c7fa4c70dcd$export$b2ad68b9bc407b80), {
        offscreen: true,
        setWidth: updateWidth
    })));
};






var $dAx5m = parcelRequire("dAx5m");

var $7vqkt = parcelRequire("7vqkt");



var $dAx5m = parcelRequire("dAx5m");

var $jVTBW = parcelRequire("jVTBW");



var $dAx5m = parcelRequire("dAx5m");
var $159434f742c558b6$export$1ca2a26fecb070ae = /*#__PURE__*/ (0, $dAx5m.createContext)("elevation.surface");
var $159434f742c558b6$export$1aeb4f6b93c4540d = function useSurface() {
    return (0, $dAx5m.useContext)($159434f742c558b6$export$1ca2a26fecb070ae);
};
$159434f742c558b6$export$1ca2a26fecb070ae.displayName = "SurfaceProvider";


var $8c46e09dbe4c745c$var$_excluded = [
    "as",
    "children",
    "backgroundColor",
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    "style",
    "testId",
    "xcss"
], $8c46e09dbe4c745c$var$_excluded2 = [
    "className"
];
var $8c46e09dbe4c745c$export$e71c4d32a2263218 = /*#__PURE__*/ (0, $dAx5m.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? "div" : _ref$as, children = _ref.children, backgroundColor = _ref.backgroundColor, padding = _ref.padding, paddingBlock = _ref.paddingBlock, paddingBlockStart = _ref.paddingBlockStart, paddingBlockEnd = _ref.paddingBlockEnd, paddingInline = _ref.paddingInline, paddingInlineStart = _ref.paddingInlineStart, paddingInlineEnd = _ref.paddingInlineEnd, style = _ref.style, testId = _ref.testId, xcss = _ref.xcss, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($cada364311d44bd0$exports)))(_ref, $8c46e09dbe4c745c$var$_excluded);
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($cada364311d44bd0$exports)))(htmlAttributes, $8c46e09dbe4c745c$var$_excluded2);
    var resolvedStyles = (0, $4db63e30be897e1a$export$a9c84988c8f81f2d)(xcss);
    var node = // @ts-expect-error Expression produces a union type that is too complex to represent. I think this is unavoidable
    (0, $jVTBW.jsx)(Component, (0, (/*@__PURE__*/$parcel$interopDefault($147dc3434bd55d1d$exports)))({
        style: style,
        ref: ref,
        className: resolvedStyles.static
    }, safeHtmlAttributes, {
        css: [
            $8c46e09dbe4c745c$var$baseStyles,
            backgroundColor && (0, $1b7baf7ec4aec943$export$e7af83bafe7f9e63)[backgroundColor],
            (0, $1b7baf7ec4aec943$export$5e65a44e5b6ecadb)(backgroundColor) && (0, $1b7baf7ec4aec943$export$ff257d957d48c421)[backgroundColor],
            padding && (0, $1b7baf7ec4aec943$export$e615f061ca585a6c).padding[padding],
            paddingBlock && (0, $1b7baf7ec4aec943$export$e615f061ca585a6c).paddingBlock[paddingBlock],
            paddingBlockStart && (0, $1b7baf7ec4aec943$export$e615f061ca585a6c).paddingBlockStart[paddingBlockStart],
            paddingBlockEnd && (0, $1b7baf7ec4aec943$export$e615f061ca585a6c).paddingBlockEnd[paddingBlockEnd],
            paddingInline && (0, $1b7baf7ec4aec943$export$e615f061ca585a6c).paddingInline[paddingInline],
            paddingInlineStart && (0, $1b7baf7ec4aec943$export$e615f061ca585a6c).paddingInlineStart[paddingInlineStart],
            paddingInlineEnd && (0, $1b7baf7ec4aec943$export$e615f061ca585a6c).paddingInlineEnd[paddingInlineEnd],
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
            resolvedStyles.emotion
        ],
        "data-testid": testId
    }), children);
    return backgroundColor ? (0, $jVTBW.jsx)((0, $159434f742c558b6$export$1ca2a26fecb070ae).Provider, {
        value: backgroundColor
    }, node) : node;
});
var $8c46e09dbe4c745c$export$2e2bcd8739ae039 = $8c46e09dbe4c745c$export$e71c4d32a2263218;
var $8c46e09dbe4c745c$var$baseStyles = (0, $jVTBW.css)({
    boxSizing: "border-box",
    appearance: "none",
    border: "none"
});



var $dAx5m = parcelRequire("dAx5m");

var $jVTBW = parcelRequire("jVTBW");

/** @jsx jsx */ 
var $dAx5m = parcelRequire("dAx5m");

var $jVTBW = parcelRequire("jVTBW");


var $93c23ec02b4025f4$var$justifyContentMap = {
    start: (0, $jVTBW.css)({
        justifyContent: "start"
    }),
    center: (0, $jVTBW.css)({
        justifyContent: "center"
    }),
    end: (0, $jVTBW.css)({
        justifyContent: "end"
    }),
    "space-between": (0, $jVTBW.css)({
        justifyContent: "space-between"
    }),
    "space-around": (0, $jVTBW.css)({
        justifyContent: "space-around"
    }),
    "space-evenly": (0, $jVTBW.css)({
        justifyContent: "space-evenly"
    }),
    stretch: (0, $jVTBW.css)({
        justifyContent: "stretch"
    })
};
var $93c23ec02b4025f4$var$flexDirectionMap = {
    column: (0, $jVTBW.css)({
        flexDirection: "column"
    }),
    row: (0, $jVTBW.css)({
        flexDirection: "row"
    })
};
var $93c23ec02b4025f4$var$flexWrapMap = {
    wrap: (0, $jVTBW.css)({
        flexWrap: "wrap"
    }),
    nowrap: (0, $jVTBW.css)({
        flexWrap: "nowrap"
    })
};
var $93c23ec02b4025f4$var$alignItemsMap = {
    start: (0, $jVTBW.css)({
        alignItems: "start"
    }),
    center: (0, $jVTBW.css)({
        alignItems: "center"
    }),
    baseline: (0, $jVTBW.css)({
        alignItems: "baseline"
    }),
    end: (0, $jVTBW.css)({
        alignItems: "end"
    }),
    stretch: (0, $jVTBW.css)({
        alignItems: "stretch"
    })
};
var $93c23ec02b4025f4$var$baseStyles = (0, $jVTBW.css)({
    display: "flex",
    boxSizing: "border-box"
});
/**
 * __Flex__
 *
 * `Flex` is a primitive component that implements the CSS Flexbox API.
 *
 * - [Examples](https://atlassian.design/components/primitives/flex/examples)
 * - [Code](https://atlassian.design/components/primitives/flex/code)
 *
 * @example
 * ```tsx
 * import { Flex, Box } from '@atlaskit/primitives'
 *
 * const Component = () => (
 *   <Flex direction="column">
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *   </Flex>
 * )
 * ```
 */ var $93c23ec02b4025f4$var$Flex = /*#__PURE__*/ (0, $dAx5m.memo)(/*#__PURE__*/ (0, $dAx5m.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? "div" : _ref$as, role = _ref.role, alignItems = _ref.alignItems, justifyContent = _ref.justifyContent, gap = _ref.gap, columnGap = _ref.columnGap, rowGap = _ref.rowGap, children = _ref.children, testId = _ref.testId, direction = _ref.direction, wrap = _ref.wrap, xcss = _ref.xcss;
    var resolvedStyles = (0, $4db63e30be897e1a$export$a9c84988c8f81f2d)(xcss);
    return (0, $jVTBW.jsx)(Component, {
        role: role,
        className: resolvedStyles.static,
        css: [
            $93c23ec02b4025f4$var$baseStyles,
            gap && (0, $1b7baf7ec4aec943$export$bf46c3f9eeafc71f).gap[gap],
            columnGap && (0, $1b7baf7ec4aec943$export$bf46c3f9eeafc71f).columnGap[columnGap],
            rowGap && (0, $1b7baf7ec4aec943$export$bf46c3f9eeafc71f).rowGap[rowGap],
            alignItems && $93c23ec02b4025f4$var$alignItemsMap[alignItems],
            direction && $93c23ec02b4025f4$var$flexDirectionMap[direction],
            justifyContent && $93c23ec02b4025f4$var$justifyContentMap[justifyContent],
            wrap && $93c23ec02b4025f4$var$flexWrapMap[wrap],
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
            resolvedStyles.emotion
        ],
        "data-testid": testId,
        ref: ref
    }, children);
}));
$93c23ec02b4025f4$var$Flex.displayName = "Flex";
var $93c23ec02b4025f4$export$2e2bcd8739ae039 = $93c23ec02b4025f4$var$Flex;


var $f4cd0041db3eeae5$var$flexGrowMap = {
    hug: (0, $4db63e30be897e1a$export$f6c783d06584602c)({
        flexGrow: 0
    }),
    fill: (0, $4db63e30be897e1a$export$f6c783d06584602c)({
        width: "100%",
        flexGrow: 1
    })
};
var $f4cd0041db3eeae5$var$separatorStyles = (0, $jVTBW.css)({
    color: "var(--ds-text-subtle, #42526E)",
    marginBlock: "var(--ds-space-0, 0px)",
    marginInline: "var(--ds-space-negative-025, -2px)",
    pointerEvents: "none",
    userSelect: "none"
});
var $f4cd0041db3eeae5$var$Separator = function Separator(_ref) {
    var children = _ref.children;
    return (0, $jVTBW.jsx)("span", {
        css: $f4cd0041db3eeae5$var$separatorStyles
    }, children);
};
/**
 * __Inline__
 *
 * Inline is a primitive component based on CSS Flexbox that manages the horizontal layout of direct children.
 *
 * @example
 * ```tsx
 *  <Inline>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *  </Inline>
 * ```
 *
 */ var $f4cd0041db3eeae5$var$Inline = /*#__PURE__*/ (0, $dAx5m.memo)(/*#__PURE__*/ (0, $dAx5m.forwardRef)(function(_ref2, ref) {
    var as = _ref2.as, alignInline = _ref2.alignInline, _ref2$alignBlock = _ref2.alignBlock, alignItems = _ref2$alignBlock === void 0 ? "start" : _ref2$alignBlock, _ref2$shouldWrap = _ref2.shouldWrap, shouldWrap = _ref2$shouldWrap === void 0 ? false : _ref2$shouldWrap, spread = _ref2.spread, grow = _ref2.grow, space = _ref2.space, rowSpace = _ref2.rowSpace, separator = _ref2.separator, xcss = _ref2.xcss, testId = _ref2.testId, role = _ref2.role, rawChildren = _ref2.children;
    var separatorComponent = typeof separator === "string" ? (0, $jVTBW.jsx)($f4cd0041db3eeae5$var$Separator, null, separator) : separator;
    var children = separatorComponent ? (0, $dAx5m.Children).toArray(rawChildren).filter(Boolean).map(function(child, index) {
        return (0, $jVTBW.jsx)((0, $dAx5m.Fragment), {
            key: index
        }, separator && index > 0 ? separatorComponent : null, child);
    }) : rawChildren;
    var justifyContent = spread || alignInline;
    // We're type coercing this as Compiled styles in an array isn't supported by the types
    // But the runtime accepts it none-the-wiser. We can remove this entire block and replace
    // it with cx(defaultStyles, focusRingStyles, xcssStyles) when we've moved away from Emotion.
    var styles = grow ? [
        $f4cd0041db3eeae5$var$flexGrowMap[grow]
    ].concat((0, (/*@__PURE__*/$parcel$interopDefault($753005c0c019cc18$exports)))(Array.isArray(xcss) ? xcss : [
        xcss
    ])) : xcss;
    return (0, $jVTBW.jsx)((0, $93c23ec02b4025f4$export$2e2bcd8739ae039), {
        as: as,
        role: role,
        alignItems: alignItems,
        justifyContent: justifyContent,
        direction: "row",
        gap: space,
        rowGap: rowSpace,
        wrap: shouldWrap ? "wrap" : undefined,
        xcss: styles,
        testId: testId,
        ref: ref
    }, children);
}));
$f4cd0041db3eeae5$var$Inline.displayName = "Inline";
var $f4cd0041db3eeae5$export$2e2bcd8739ae039 = $f4cd0041db3eeae5$var$Inline;


/**
 * This is an object of usable media query helpers using our internal breakpoints configuration.
 *
 * When using Compiled CSS-in-JS, please ensure that only a single declaration can take effect at a time.
 * This means that you should avoid multiple breakpoints taking effect at the same time,
 * eg. ```{ [media.above.xs]: { color: 'red' }, [media.above.sm]: { color: 'green' }}```.
 * Instead, make sure that only one breakpoint can take effect at a time,
 * e.g, ```{ [media.only.xs]: { color: 'red' }, [media.above.sm]: { color: 'green' }}```.
 * For more details, please see <https://compiledcssinjs.com/docs/atomic-css#selector-specificity>.
 */ var $cb007fe69a2ff170$export$987d49ffe1b0900f = {
    above: {
        xxs: "@media all",
        xs: "@media (min-width: 30rem)",
        sm: "@media (min-width: 48rem)",
        md: "@media (min-width: 64rem)",
        lg: "@media (min-width: 90rem)",
        xl: "@media (min-width: 110rem)"
    },
    only: {
        xxs: "@media (min-width: 0rem) and (max-width: 29.99rem)",
        xs: "@media (min-width: 30rem) and (max-width: 47.99rem)",
        sm: "@media (min-width: 48rem) and (max-width: 63.99rem)",
        md: "@media (min-width: 64rem) and (max-width: 89.99rem)",
        lg: "@media (min-width: 90rem) and (max-width: 109.99rem)",
        xl: "@media (min-width: 110rem)"
    },
    below: {
        xs: "@media not all and (min-width: 30rem)",
        sm: "@media not all and (min-width: 48rem)",
        md: "@media not all and (min-width: 64rem)",
        lg: "@media not all and (min-width: 90rem)",
        xl: "@media not all and (min-width: 110rem)"
    }
};
var $cb007fe69a2ff170$export$c881183ca713c214 = $cb007fe69a2ff170$export$987d49ffe1b0900f;


var $dAx5m = parcelRequire("dAx5m");

var $dd4sf = parcelRequire("dd4sf");

var $2c57189aea1385f7$var$_window, $2c57189aea1385f7$var$_window$matchMedia, $2c57189aea1385f7$var$_window2, $2c57189aea1385f7$var$_window2$matchMedia, $2c57189aea1385f7$var$_window3, $2c57189aea1385f7$var$_window3$matchMedia, $2c57189aea1385f7$var$_window4, $2c57189aea1385f7$var$_window4$matchMedia, $2c57189aea1385f7$var$_window5, $2c57189aea1385f7$var$_window5$matchMedia, $2c57189aea1385f7$var$_window6, $2c57189aea1385f7$var$_window6$matchMedia, $2c57189aea1385f7$var$_window7, $2c57189aea1385f7$var$_window7$matchMedia, $2c57189aea1385f7$var$_window8, $2c57189aea1385f7$var$_window8$matchMedia, $2c57189aea1385f7$var$_window9, $2c57189aea1385f7$var$_window9$matchMedia, $2c57189aea1385f7$var$_window10, $2c57189aea1385f7$var$_window10$matchMedia, $2c57189aea1385f7$var$_window11, $2c57189aea1385f7$var$_window11$matchMedia;
var $2c57189aea1385f7$var$queries = {
    "above.xxs": typeof window === "undefined" ? undefined : ($2c57189aea1385f7$var$_window = window) === null || $2c57189aea1385f7$var$_window === void 0 || ($2c57189aea1385f7$var$_window$matchMedia = $2c57189aea1385f7$var$_window.matchMedia) === null || $2c57189aea1385f7$var$_window$matchMedia === void 0 ? void 0 : $2c57189aea1385f7$var$_window$matchMedia.call($2c57189aea1385f7$var$_window, (0, $cb007fe69a2ff170$export$c881183ca713c214).above.xxs.replace("@media ", "").trim()),
    "above.xs": typeof window === "undefined" ? undefined : ($2c57189aea1385f7$var$_window2 = window) === null || $2c57189aea1385f7$var$_window2 === void 0 || ($2c57189aea1385f7$var$_window2$matchMedia = $2c57189aea1385f7$var$_window2.matchMedia) === null || $2c57189aea1385f7$var$_window2$matchMedia === void 0 ? void 0 : $2c57189aea1385f7$var$_window2$matchMedia.call($2c57189aea1385f7$var$_window2, (0, $cb007fe69a2ff170$export$c881183ca713c214).above.xs.replace("@media ", "").trim()),
    "above.sm": typeof window === "undefined" ? undefined : ($2c57189aea1385f7$var$_window3 = window) === null || $2c57189aea1385f7$var$_window3 === void 0 || ($2c57189aea1385f7$var$_window3$matchMedia = $2c57189aea1385f7$var$_window3.matchMedia) === null || $2c57189aea1385f7$var$_window3$matchMedia === void 0 ? void 0 : $2c57189aea1385f7$var$_window3$matchMedia.call($2c57189aea1385f7$var$_window3, (0, $cb007fe69a2ff170$export$c881183ca713c214).above.sm.replace("@media ", "").trim()),
    "above.md": typeof window === "undefined" ? undefined : ($2c57189aea1385f7$var$_window4 = window) === null || $2c57189aea1385f7$var$_window4 === void 0 || ($2c57189aea1385f7$var$_window4$matchMedia = $2c57189aea1385f7$var$_window4.matchMedia) === null || $2c57189aea1385f7$var$_window4$matchMedia === void 0 ? void 0 : $2c57189aea1385f7$var$_window4$matchMedia.call($2c57189aea1385f7$var$_window4, (0, $cb007fe69a2ff170$export$c881183ca713c214).above.md.replace("@media ", "").trim()),
    "above.lg": typeof window === "undefined" ? undefined : ($2c57189aea1385f7$var$_window5 = window) === null || $2c57189aea1385f7$var$_window5 === void 0 || ($2c57189aea1385f7$var$_window5$matchMedia = $2c57189aea1385f7$var$_window5.matchMedia) === null || $2c57189aea1385f7$var$_window5$matchMedia === void 0 ? void 0 : $2c57189aea1385f7$var$_window5$matchMedia.call($2c57189aea1385f7$var$_window5, (0, $cb007fe69a2ff170$export$c881183ca713c214).above.lg.replace("@media ", "").trim()),
    "above.xl": typeof window === "undefined" ? undefined : ($2c57189aea1385f7$var$_window6 = window) === null || $2c57189aea1385f7$var$_window6 === void 0 || ($2c57189aea1385f7$var$_window6$matchMedia = $2c57189aea1385f7$var$_window6.matchMedia) === null || $2c57189aea1385f7$var$_window6$matchMedia === void 0 ? void 0 : $2c57189aea1385f7$var$_window6$matchMedia.call($2c57189aea1385f7$var$_window6, (0, $cb007fe69a2ff170$export$c881183ca713c214).above.xl.replace("@media ", "").trim()),
    "below.xs": typeof window === "undefined" ? undefined : ($2c57189aea1385f7$var$_window7 = window) === null || $2c57189aea1385f7$var$_window7 === void 0 || ($2c57189aea1385f7$var$_window7$matchMedia = $2c57189aea1385f7$var$_window7.matchMedia) === null || $2c57189aea1385f7$var$_window7$matchMedia === void 0 ? void 0 : $2c57189aea1385f7$var$_window7$matchMedia.call($2c57189aea1385f7$var$_window7, (0, $cb007fe69a2ff170$export$c881183ca713c214).below.xs.replace("@media ", "").trim()),
    "below.sm": typeof window === "undefined" ? undefined : ($2c57189aea1385f7$var$_window8 = window) === null || $2c57189aea1385f7$var$_window8 === void 0 || ($2c57189aea1385f7$var$_window8$matchMedia = $2c57189aea1385f7$var$_window8.matchMedia) === null || $2c57189aea1385f7$var$_window8$matchMedia === void 0 ? void 0 : $2c57189aea1385f7$var$_window8$matchMedia.call($2c57189aea1385f7$var$_window8, (0, $cb007fe69a2ff170$export$c881183ca713c214).below.sm.replace("@media ", "").trim()),
    "below.md": typeof window === "undefined" ? undefined : ($2c57189aea1385f7$var$_window9 = window) === null || $2c57189aea1385f7$var$_window9 === void 0 || ($2c57189aea1385f7$var$_window9$matchMedia = $2c57189aea1385f7$var$_window9.matchMedia) === null || $2c57189aea1385f7$var$_window9$matchMedia === void 0 ? void 0 : $2c57189aea1385f7$var$_window9$matchMedia.call($2c57189aea1385f7$var$_window9, (0, $cb007fe69a2ff170$export$c881183ca713c214).below.md.replace("@media ", "").trim()),
    "below.lg": typeof window === "undefined" ? undefined : ($2c57189aea1385f7$var$_window10 = window) === null || $2c57189aea1385f7$var$_window10 === void 0 || ($2c57189aea1385f7$var$_window10$matchMedia = $2c57189aea1385f7$var$_window10.matchMedia) === null || $2c57189aea1385f7$var$_window10$matchMedia === void 0 ? void 0 : $2c57189aea1385f7$var$_window10$matchMedia.call($2c57189aea1385f7$var$_window10, (0, $cb007fe69a2ff170$export$c881183ca713c214).below.lg.replace("@media ", "").trim()),
    "below.xl": typeof window === "undefined" ? undefined : ($2c57189aea1385f7$var$_window11 = window) === null || $2c57189aea1385f7$var$_window11 === void 0 || ($2c57189aea1385f7$var$_window11$matchMedia = $2c57189aea1385f7$var$_window11.matchMedia) === null || $2c57189aea1385f7$var$_window11$matchMedia === void 0 ? void 0 : $2c57189aea1385f7$var$_window11$matchMedia.call($2c57189aea1385f7$var$_window11, (0, $cb007fe69a2ff170$export$c881183ca713c214).below.xl.replace("@media ", "").trim())
};
var $2c57189aea1385f7$export$49e55ae2c03d6045 = function UNSAFE_useMediaQuery(queryString, listener) {
    var listenerRef = (0, $dAx5m.useRef)(listener);
    (0, $dAx5m.useEffect)(function() {
        // Bind the listener if changed so it's called on the next change event; no guarantee on timing.
        listenerRef.current = listener;
    }, [
        listener
    ]);
    /**
   * We explicitly only react to boolean changes for binding our listener
   * Changes to the functional reference are ignored.
   */ var hasListener = !!listener;
    /**
   * The `matchMedia(…)` return value for our breakpoint query.
   */ var mq = $2c57189aea1385f7$var$queries[queryString];
    (0, $dAx5m.useLayoutEffect)(function() {
        listenerRef.current = listener; // Bind the listener now in case the `useEffect` hasn't fired above yet
        if (!mq || !hasListener || !listenerRef.current) return;
        return (0, $dd4sf.bind)(mq, {
            type: "change",
            listener: function listener(event) {
                // We explicitly call the current version of the function
                return listenerRef.current(event);
            }
        });
    }, // eslint-disable-next-line react-hooks/exhaustive-deps -- explicitly do not trigger the effect on `listener` reference change, only on a boolean representation of it.
    [
        mq,
        hasListener
    ]);
    return mq || null;
};




var $ef0025bc4c4dd242$var$_xcss2;
var $ef0025bc4c4dd242$var$containerWrapperStyles = (0, $4db63e30be897e1a$export$f6c783d06584602c)({
    height: "100%"
});
var $ef0025bc4c4dd242$var$sharedContainerStyles = (0, $4db63e30be897e1a$export$f6c783d06584602c)({
    height: "100%",
    alignItems: "stretch",
    paddingInlineEnd: "space.050",
    gap: "space.100"
});
var $ef0025bc4c4dd242$var$smallContainerStyles = (0, $4db63e30be897e1a$export$f6c783d06584602c)((0, (/*@__PURE__*/$parcel$interopDefault($659b468336d903e3$exports)))({}, (0, $cb007fe69a2ff170$export$987d49ffe1b0900f).above.sm, {
    display: "none"
}));
var $ef0025bc4c4dd242$var$mediumContainerStyles = (0, $4db63e30be897e1a$export$f6c783d06584602c)(($ef0025bc4c4dd242$var$_xcss2 = {
    display: "none"
}, (0, (/*@__PURE__*/$parcel$interopDefault($659b468336d903e3$exports)))($ef0025bc4c4dd242$var$_xcss2, (0, $cb007fe69a2ff170$export$987d49ffe1b0900f).above.sm, {
    display: "flex"
}), (0, (/*@__PURE__*/$parcel$interopDefault($659b468336d903e3$exports)))($ef0025bc4c4dd242$var$_xcss2, (0, $cb007fe69a2ff170$export$987d49ffe1b0900f).above.lg, {
    display: "none"
}), $ef0025bc4c4dd242$var$_xcss2));
var $ef0025bc4c4dd242$var$largeContainerStyles = (0, $4db63e30be897e1a$export$f6c783d06584602c)((0, (/*@__PURE__*/$parcel$interopDefault($659b468336d903e3$exports)))({
    display: "none"
}, (0, $cb007fe69a2ff170$export$987d49ffe1b0900f).above.lg, {
    display: "flex"
}));
var $ef0025bc4c4dd242$var$MoreItemsPopup = function MoreItemsPopup(_ref) {
    var moreLabel = _ref.moreLabel, testId = _ref.testId, items = _ref.items;
    var _useState = (0, $dAx5m.useState)(false), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($96b147e8280c5691$exports)))(_useState, 2), isMoreOpen = _useState2[0], setIsMoreOpen = _useState2[1];
    var onMoreClose = (0, $dAx5m.useCallback)(function() {
        return setIsMoreOpen(false);
    }, []);
    var onMoreClick = (0, $dAx5m.useCallback)(function() {
        return setIsMoreOpen(function(current) {
            return !current;
        });
    }, []);
    var openOverflowMenu = (0, $dAx5m.useCallback)(function() {
        return setIsMoreOpen(true);
    }, []);
    var trigger = (0, $dAx5m.useCallback)(function(triggerProps) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $9313bc2135291c72$export$bb3af89fb196520d), (0, (/*@__PURE__*/$parcel$interopDefault($147dc3434bd55d1d$exports)))({
            onClick: onMoreClick,
            isSelected: isMoreOpen,
            testId: testId ? "".concat(testId, "-overflow-menu-trigger") : "overflow-menu-trigger"
        }, triggerProps), moreLabel);
    }, [
        moreLabel,
        onMoreClick,
        isMoreOpen,
        testId
    ]);
    var content = (0, $dAx5m.useCallback)(function() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $23c1a26819a49d2a$export$a3a2def3937905a0), {
            isVisible: false,
            openOverflowMenu: openOverflowMenu,
            closeOverflowMenu: onMoreClose
        }, items);
    }, [
        items,
        openOverflowMenu,
        onMoreClose
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $7vqkt.default), {
        shouldRenderToParent: true,
        placement: "bottom-start",
        isOpen: isMoreOpen,
        onClose: onMoreClose,
        trigger: trigger,
        content: content,
        testId: testId ? "".concat(testId, "-overflow-menu-popup") : "overflow-menu-popup"
    });
};
var $ef0025bc4c4dd242$export$43e704064d596a9e = /*#__PURE__*/ (0, $dAx5m.memo)(function(_ref2) {
    var moreLabel = _ref2.moreLabel, items = _ref2.items, Create = _ref2.create, theme = _ref2.theme, testId = _ref2.testId;
    // We render a CSS media query based nav at first to handle SSR, then use
    // our useMediaQuery hook once we are hydrated so there is only one set of nav items
    var _useState3 = (0, $dAx5m.useState)(false), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($96b147e8280c5691$exports)))(_useState3, 2), isClient = _useState4[0], setIsClient = _useState4[1];
    (0, $dAx5m.useEffect)(function() {
        setIsClient(true);
    }, []);
    // Setting up our media queries to use once app is hydrated
    var mqSm = (0, $2c57189aea1385f7$export$49e55ae2c03d6045)("above.sm", function(event) {
        return setIsAboveSm(event.matches);
    });
    var _useState5 = (0, $dAx5m.useState)(mqSm === null || mqSm === void 0 ? void 0 : mqSm.matches), _useState6 = (0, (/*@__PURE__*/$parcel$interopDefault($96b147e8280c5691$exports)))(_useState5, 2), isAboveSm = _useState6[0], setIsAboveSm = _useState6[1];
    var mqLg = (0, $2c57189aea1385f7$export$49e55ae2c03d6045)("above.lg", function(event) {
        return setIsAboveLg(event.matches);
    });
    var _useState7 = (0, $dAx5m.useState)(mqLg === null || mqLg === void 0 ? void 0 : mqLg.matches), _useState8 = (0, (/*@__PURE__*/$parcel$interopDefault($96b147e8280c5691$exports)))(_useState7, 2), isAboveLg = _useState8[0], setIsAboveLg = _useState8[1];
    // Filter out any falsy items passed in
    var filteredItems = (0, $dAx5m.useMemo)(function() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).Children.toArray(items).filter(function(item) {
            return !!item;
        });
    }, [
        items
    ]);
    // NOTE: we could make these max items configurable in the future. For now
    // we are using sensible defaults. Anything over the max gets put in the
    // overflow menu for that screen size.
    // While it may be tempting to use more than 3 items for the medium nav when
    // you see the available space, you need to consider internationalistion.
    // 3 is the safe, defensive choice across many languages and scripts.
    var smallMaxItems = 0;
    var mediumMaxItems = 3;
    var largeMaxItems = 8;
    // We re-use this in both the CSS media query nav that loads in for SSR,
    // and the JS/hook media query nav that is used once hydrated
    var navItems = (0, $dAx5m.useMemo)(function() {
        return {
            small: {
                navBarItems: [],
                overflowItems: filteredItems
            },
            medium: {
                navBarItems: filteredItems.slice(0, mediumMaxItems),
                overflowItems: filteredItems.slice(mediumMaxItems, filteredItems.length)
            },
            large: {
                navBarItems: filteredItems.slice(0, largeMaxItems),
                overflowItems: filteredItems.slice(largeMaxItems, filteredItems.length)
            }
        };
    }, [
        filteredItems
    ]);
    var hydratedNavItems = (0, $dAx5m.useMemo)(function() {
        if (isAboveLg) return navItems.large;
        if (isAboveSm && !isAboveLg) return navItems.medium;
        return navItems.small;
    }, [
        isAboveLg,
        isAboveSm,
        navItems.large,
        navItems.medium,
        navItems.small
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).Fragment, null, isClient ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $8c46e09dbe4c745c$export$2e2bcd8739ae039), {
        role: "list",
        xcss: $ef0025bc4c4dd242$var$containerWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $f4cd0041db3eeae5$export$2e2bcd8739ae039), {
        testId: testId && "".concat(testId, "-primary-actions"),
        xcss: $ef0025bc4c4dd242$var$sharedContainerStyles
    }, hydratedNavItems.navBarItems, hydratedNavItems.overflowItems.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement($ef0025bc4c4dd242$var$MoreItemsPopup, {
        moreLabel: moreLabel,
        items: hydratedNavItems.overflowItems,
        testId: testId
    }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $8c46e09dbe4c745c$export$2e2bcd8739ae039), {
        role: "list",
        xcss: $ef0025bc4c4dd242$var$containerWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $f4cd0041db3eeae5$export$2e2bcd8739ae039), {
        xcss: [
            $ef0025bc4c4dd242$var$sharedContainerStyles,
            $ef0025bc4c4dd242$var$smallContainerStyles
        ]
    }, filteredItems.length > smallMaxItems && /*#__PURE__*/ // We don't need to pass items into popup, it won't be interactive (SSR only)
    (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement($ef0025bc4c4dd242$var$MoreItemsPopup, {
        moreLabel: moreLabel,
        testId: testId
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $f4cd0041db3eeae5$export$2e2bcd8739ae039), {
        xcss: [
            $ef0025bc4c4dd242$var$sharedContainerStyles,
            $ef0025bc4c4dd242$var$mediumContainerStyles
        ]
    }, navItems.medium.navBarItems, navItems.medium.overflowItems.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement($ef0025bc4c4dd242$var$MoreItemsPopup, {
        moreLabel: moreLabel,
        testId: testId
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $f4cd0041db3eeae5$export$2e2bcd8739ae039), {
        xcss: [
            $ef0025bc4c4dd242$var$sharedContainerStyles,
            $ef0025bc4c4dd242$var$largeContainerStyles
        ]
    }, navItems.large.navBarItems, navItems.large.overflowItems.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement($ef0025bc4c4dd242$var$MoreItemsPopup, {
        moreLabel: moreLabel,
        testId: testId
    }))), Create && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement(Create, null));
});


var $eb154661c545c745$var$containerStyles = (0, $jVTBW.css)({
    display: "flex",
    boxSizing: "border-box",
    height: (0, $477d219a351dcce0$export$30fa7cc5f2690a43),
    position: "relative",
    alignItems: "center",
    justifyContent: "space-between",
    flexShrink: 0,
    borderBlockEnd: "1px solid ".concat("var(--ds-border, ".concat((0, $bbdbd5c17cc03a8e$export$3e51e8f1440314ba), ")")),
    paddingInlineEnd: "var(--ds-space-150, 12px)",
    paddingInlineStart: "var(--ds-space-150, 12px)"
});
var $eb154661c545c745$var$leftStyles = (0, $jVTBW.css)({
    display: "flex",
    minWidth: 0,
    height: "inherit",
    alignItems: "center",
    flexGrow: 1,
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
    "& > *": {
        flexShrink: 0
    }
});
var $eb154661c545c745$var$rightStyles = (0, $jVTBW.css)({
    display: "flex",
    alignItems: "center",
    flexShrink: 0,
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
    "& > *": {
        flexShrink: 0,
        marginInlineEnd: "var(--ds-space-050, 4px)"
    }
});
var $eb154661c545c745$var$noRightMarginStyles = (0, $jVTBW.css)({
    marginInlineEnd: 0
});
var $eb154661c545c745$var$analyticsData = {
    attributes: {
        navigationLayer: "global"
    },
    componentName: "atlassianNavigation"
};
var $eb154661c545c745$export$f66ccb39f60980e5 = function AtlassianNavigation(props) {
    var label = props.label, _props$primaryItems = props.primaryItems, primaryItems = _props$primaryItems === void 0 ? [] : _props$primaryItems, AppSwitcher = props.renderAppSwitcher, create = props.renderCreate, Help = props.renderHelp, Notifications = props.renderNotifications, ProductHome = props.renderProductHome, Profile = props.renderProfile, Search = props.renderSearch, SignIn = props.renderSignIn, Settings = props.renderSettings, _props$moreLabel = props.moreLabel, moreLabel = _props$moreLabel === void 0 ? "\u2026" : _props$moreLabel, _props$theme = props.theme, theme = _props$theme === void 0 ? (0, $d03dce0456a4ec9e$export$164de7ab8df77ef0) : _props$theme, testId = props.testId;
    return (0, $jVTBW.jsx)((0, $0c371fb60a7c6f5e$export$d8964aec282183a3), {
        value: theme
    }, (0, $jVTBW.jsx)((0, $12b8a4963edf4e39$export$d0a82da1a0b94929), {
        data: $eb154661c545c745$var$analyticsData
    }, (0, $jVTBW.jsx)("header", {
        style: theme.mode.navigation,
        css: $eb154661c545c745$var$containerStyles,
        "data-testid": testId && "".concat(testId, "-header"),
        role: "banner"
    }, (0, $jVTBW.jsx)("nav", {
        css: $eb154661c545c745$var$leftStyles,
        "aria-label": label
    }, AppSwitcher && (0, $jVTBW.jsx)(AppSwitcher, null), ProductHome && (0, $jVTBW.jsx)(ProductHome, null), (0, $af5ef12ad3f1989a$export$470e5c2be1411c89)("platform.design-system-team.navigation-v2-no-jank_5yhbd") ? (0, $jVTBW.jsx)((0, $ef0025bc4c4dd242$export$43e704064d596a9e), {
        testId: testId,
        moreLabel: moreLabel,
        items: primaryItems,
        create: create,
        theme: theme
    }) : (0, $jVTBW.jsx)((0, $e58f0e7030a1fb9c$export$43e704064d596a9e), {
        testId: testId,
        moreLabel: moreLabel,
        items: primaryItems,
        create: create,
        theme: theme
    })), (0, $jVTBW.jsx)("div", {
        css: $eb154661c545c745$var$rightStyles,
        "data-testid": testId && "".concat(testId, "-secondary-actions")
    }, Search && (0, $jVTBW.jsx)(Search, null), (0, $jVTBW.jsx)("div", {
        role: "list",
        css: [
            $eb154661c545c745$var$rightStyles,
            $eb154661c545c745$var$noRightMarginStyles
        ]
    }, Notifications && (0, $jVTBW.jsx)(Notifications, null), Help && (0, $jVTBW.jsx)(Help, null), Settings && (0, $jVTBW.jsx)(Settings, null), SignIn && (0, $jVTBW.jsx)(SignIn, null), Profile && (0, $jVTBW.jsx)(Profile, null))))));
};
var $eb154661c545c745$export$2e2bcd8739ae039 = $eb154661c545c745$export$f66ccb39f60980e5;


/** @jsx jsx */ 
var $jVTBW = parcelRequire("jVTBW");
// dimension vars
var $b1a529b255355df4$export$cbfb0f5b2869b17b = "leftPanelWidth";
var $b1a529b255355df4$export$a30f2e00489a8957 = "leftSidebarWidth";
var $b1a529b255355df4$export$c103b605cd368aed = "rightSidebarWidth";
var $b1a529b255355df4$export$fa34f417972d6341 = "rightPanelWidth";
var $b1a529b255355df4$export$3a6a779d9181047c = "topNavigationHeight";
var $b1a529b255355df4$export$bcd94a6a792e7f96 = "bannerHeight";
var $b1a529b255355df4$export$b6744d31294864fd = "leftSidebarFlyoutWidth";
var $b1a529b255355df4$export$d67ac355184b7646 = [
    $b1a529b255355df4$export$cbfb0f5b2869b17b,
    $b1a529b255355df4$export$fa34f417972d6341,
    $b1a529b255355df4$export$bcd94a6a792e7f96,
    $b1a529b255355df4$export$3a6a779d9181047c,
    $b1a529b255355df4$export$a30f2e00489a8957,
    $b1a529b255355df4$export$c103b605cd368aed
];
var $b1a529b255355df4$export$344062f7cfc9528e = "left-panel";
var $b1a529b255355df4$export$c7139cc2d6110b5f = "right-panel";
var $b1a529b255355df4$export$238d30785c4bca84 = "banner";
var $b1a529b255355df4$export$bec6dca2e63de4ae = "top-navigation";
var $b1a529b255355df4$export$d1213e82613ff4df = "content";
var $b1a529b255355df4$export$2d8180803f50fc5 = "main";
var $b1a529b255355df4$export$50ea883ba6f28ff5 = "left-sidebar";
var $b1a529b255355df4$export$7bf43119a6b49ddb = "right-sidebar";
var $b1a529b255355df4$export$be83e7118304b28e = 56;
var $b1a529b255355df4$export$4a98ee0bd1ae362 = 56;
var $b1a529b255355df4$export$539e68c09584883a = 240;
var $b1a529b255355df4$export$b92df8810d2fcd01 = 280;
var $b1a529b255355df4$export$c3e41153b9288bcf = 368;
var $b1a529b255355df4$export$c4d6152f86ea28f6 = 368;
var $b1a529b255355df4$export$46acf8758e9e2636 = 20;
var $b1a529b255355df4$export$70740f5ad8360a78 = 16;
var $b1a529b255355df4$export$f562af313cda0684 = 80;
var $b1a529b255355df4$export$991d5285ad765a3d = 240;
var $b1a529b255355df4$export$6949d4f32b161684 = 200;
var $b1a529b255355df4$export$d6e7e8af042815bb = 350;
var $b1a529b255355df4$export$3749e1104328fde4 = 300;
var $b1a529b255355df4$export$1074d925b0b82be5 = 200;
var $b1a529b255355df4$export$24d54fc362d78805 = "expandedLeftSidebarWidth";
var $b1a529b255355df4$export$451e84a45a9e4a75 = "DS_PAGE_LAYOUT_UI_STATE";
var $b1a529b255355df4$export$802bb2c050f3db5c = "data-is-sidebar-dragging";
var $b1a529b255355df4$export$5e5e1875c3fd8f4f = "data-is-sidebar-collapsing";
var $b1a529b255355df4$export$60b3bc5d4ac00d5e = "data-is-flyout-open";
var $b1a529b255355df4$export$70c702a8c5895f03 = "data-grab-area-line";
var $b1a529b255355df4$export$48a43f91e4becf4e = "data-grab-area";
var $b1a529b255355df4$export$dac2fb31a9f6844d = "data-resize-button";
var $b1a529b255355df4$export$9ecd22db14e6c70e = "data-resize-control";
var $b1a529b255355df4$export$5253dd9707b8c3ba = "data-ds--page-layout--slot";
var $b1a529b255355df4$export$206a08f7f8beb554 = "Skip to:";
var $b1a529b255355df4$export$659ee746b31b360d = "data-layout-container";
var $b1a529b255355df4$export$f963aecf2d4465bd = "var(--".concat($b1a529b255355df4$export$cbfb0f5b2869b17b, ", 0px)");
var $b1a529b255355df4$export$750459958906793 = "var(--".concat($b1a529b255355df4$export$fa34f417972d6341, ", 0px)");
var $b1a529b255355df4$export$f897e1ed9f8ed251 = "var(--".concat($b1a529b255355df4$export$a30f2e00489a8957, ", 0px)");
var $b1a529b255355df4$export$b44ab66843c05a69 = "var(--".concat($b1a529b255355df4$export$c103b605cd368aed, ", 0px)");
var $b1a529b255355df4$export$aeff86a16f13529 = "var(--".concat($b1a529b255355df4$export$3a6a779d9181047c, ", 0px)");
var $b1a529b255355df4$export$ed7cc0d417ee89e = "var(--".concat($b1a529b255355df4$export$bcd94a6a792e7f96, ", 0px)");
var $b1a529b255355df4$export$d2fa14f05b61e66 = "var(--".concat($b1a529b255355df4$export$b6744d31294864fd, ", ").concat($b1a529b255355df4$export$991d5285ad765a3d, "px)");


var $aec8c280efcaa306$var$contentStyles = (0, $jVTBW.css)({
    display: "flex",
    height: "100%",
    position: "relative",
    gridArea: (0, $b1a529b255355df4$export$d1213e82613ff4df)
});
/**
 * __Content__
 *
 * Provides a slot for your application content within the PageLayout.
 *
 * - [Examples](https://atlassian.design/components/page-layout/examples)
 * - [Code](https://atlassian.design/components/page-layout/code)
 */ var $aec8c280efcaa306$var$Content = function Content(props) {
    var children = props.children, testId = props.testId;
    return (0, $jVTBW.jsx)("div", {
        "data-testid": testId,
        css: $aec8c280efcaa306$var$contentStyles
    }, children);
};
var $aec8c280efcaa306$export$2e2bcd8739ae039 = $aec8c280efcaa306$var$Content;

var $928891c66494309d$exports = {};
function $928891c66494309d$var$_extends() {
    return $928891c66494309d$exports = $928891c66494309d$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $928891c66494309d$exports.__esModule = true, $928891c66494309d$exports["default"] = $928891c66494309d$exports, $928891c66494309d$var$_extends.apply(null, arguments);
}
$928891c66494309d$exports = $928891c66494309d$var$_extends, $928891c66494309d$exports.__esModule = true, $928891c66494309d$exports["default"] = $928891c66494309d$exports;



var $dAx5m = parcelRequire("dAx5m");

var $jVTBW = parcelRequire("jVTBW");
var $41070cf19ed9e650$exports = {};
var $b3fb0867deb6dd96$exports = {};
function $b3fb0867deb6dd96$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
$b3fb0867deb6dd96$exports = $b3fb0867deb6dd96$var$_arrayWithHoles, $b3fb0867deb6dd96$exports.__esModule = true, $b3fb0867deb6dd96$exports["default"] = $b3fb0867deb6dd96$exports;


var $a79ffc9bc6df63db$exports = {};
function $a79ffc9bc6df63db$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
$a79ffc9bc6df63db$exports = $a79ffc9bc6df63db$var$_iterableToArrayLimit, $a79ffc9bc6df63db$exports.__esModule = true, $a79ffc9bc6df63db$exports["default"] = $a79ffc9bc6df63db$exports;


var $c26b780589d11ab6$exports = {};
var $38544e7f0f173349$exports = {};
function $38544e7f0f173349$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
$38544e7f0f173349$exports = $38544e7f0f173349$var$_arrayLikeToArray, $38544e7f0f173349$exports.__esModule = true, $38544e7f0f173349$exports["default"] = $38544e7f0f173349$exports;


function $c26b780589d11ab6$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $38544e7f0f173349$exports(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $38544e7f0f173349$exports(r, a) : void 0;
    }
}
$c26b780589d11ab6$exports = $c26b780589d11ab6$var$_unsupportedIterableToArray, $c26b780589d11ab6$exports.__esModule = true, $c26b780589d11ab6$exports["default"] = $c26b780589d11ab6$exports;


var $178a709f91bff452$exports = {};
function $178a709f91bff452$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
$178a709f91bff452$exports = $178a709f91bff452$var$_nonIterableRest, $178a709f91bff452$exports.__esModule = true, $178a709f91bff452$exports["default"] = $178a709f91bff452$exports;


function $41070cf19ed9e650$var$_slicedToArray(r, e) {
    return $b3fb0867deb6dd96$exports(r) || $a79ffc9bc6df63db$exports(r, e) || $c26b780589d11ab6$exports(r, e) || $178a709f91bff452$exports();
}
$41070cf19ed9e650$exports = $41070cf19ed9e650$var$_slicedToArray, $41070cf19ed9e650$exports.__esModule = true, $41070cf19ed9e650$exports["default"] = $41070cf19ed9e650$exports;



var $dAx5m = parcelRequire("dAx5m");

var $dd4sf = parcelRequire("dd4sf");
var $d2c51736466554a9$var$isMatchMediaAvailable = function isMatchMediaAvailable() {
    return typeof window !== "undefined" && "matchMedia" in window;
};
var $d2c51736466554a9$export$b7baf7667a68d87c = function isReducedMotion() {
    if (!$d2c51736466554a9$var$isMatchMediaAvailable()) return false;
    var _window$matchMedia = window.matchMedia("(prefers-reduced-motion: reduce)"), matches = _window$matchMedia.matches;
    return matches;
};
var $d2c51736466554a9$export$c537e63161742ce3 = function useIsReducedMotion() {
    var _useState = (0, $dAx5m.useState)($d2c51736466554a9$export$b7baf7667a68d87c), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($41070cf19ed9e650$exports)))(_useState, 2), prefersReducedMotion = _useState2[0], setPrefersReducedMotion = _useState2[1];
    (0, $dAx5m.useEffect)(function() {
        if (!$d2c51736466554a9$var$isMatchMediaAvailable()) return;
        var mediaQueryList = window.matchMedia("(prefers-reduced-motion: reduce)");
        var onChange = function onChange(event) {
            return setPrefersReducedMotion(event.matches);
        };
        return (0, $dd4sf.bind)(mediaQueryList, {
            type: "change",
            listener: onChange
        });
    }, []);
    return prefersReducedMotion;
};
var $d2c51736466554a9$export$f0f789643ba5a83c = {
    "@media (prefers-reduced-motion: reduce)": {
        animation: "none",
        transition: "none"
    }
};
var $d2c51736466554a9$export$ff7706047246b98b = function prefersReducedMotion() {
    return $d2c51736466554a9$export$f0f789643ba5a83c;
};


var $5d9ccc9db19f5ae4$export$c07234257a03d5e9 = "cubic-bezier(0.15,1,0.3,1)";
var $5d9ccc9db19f5ae4$export$57636bb43b1ccbb0 = "cubic-bezier(0.2,0,0,1)";
var $5d9ccc9db19f5ae4$export$929e5a82286172a6 = "cubic-bezier(0.8,0,0,0.8)";





var $dAx5m = parcelRequire("dAx5m");

var $62087b429ca5c676$var$getIsDragging = function getIsDragging() {
    // SSR bail-out because document is undefined on the server
    if (typeof document === "undefined") return false;
    return document.documentElement.getAttribute((0, $b1a529b255355df4$export$802bb2c050f3db5c)) === "true";
};
// TODO: I think this should be derived from the sidebar state,
// and not indirectly from observing an attribute change
var $62087b429ca5c676$var$useIsSidebarDragging = function useIsSidebarDragging() {
    var _useState = (0, $dAx5m.useState)($62087b429ca5c676$var$getIsDragging), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($41070cf19ed9e650$exports)))(_useState, 2), isDragging = _useState2[0], setIsDragging = _useState2[1];
    (0, $dAx5m.useEffect)(function() {
        var observer = new MutationObserver(function() {
            setIsDragging($62087b429ca5c676$var$getIsDragging);
        });
        observer.observe(document.documentElement, {
            attributeFilter: [
                (0, $b1a529b255355df4$export$802bb2c050f3db5c)
            ]
        });
        return function() {
            observer.disconnect();
        };
    }, []);
    return isDragging;
};
var $62087b429ca5c676$export$2e2bcd8739ae039 = $62087b429ca5c676$var$useIsSidebarDragging;


var $49a8658da987ab6b$exports = {};
function $49a8658da987ab6b$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $49a8658da987ab6b$exports = $49a8658da987ab6b$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $49a8658da987ab6b$exports.__esModule = true, $49a8658da987ab6b$exports["default"] = $49a8658da987ab6b$exports, $49a8658da987ab6b$var$_typeof(o);
}
$49a8658da987ab6b$exports = $49a8658da987ab6b$var$_typeof, $49a8658da987ab6b$exports.__esModule = true, $49a8658da987ab6b$exports["default"] = $49a8658da987ab6b$exports;


var $4b3bc1d4103a914b$exports = {};
var $18ef7d9196991f20$exports = {};

var $18ef7d9196991f20$var$_typeof = $49a8658da987ab6b$exports.default;
var $134d84cf814dd9d2$exports = {};

var $134d84cf814dd9d2$var$_typeof = $49a8658da987ab6b$exports.default;
function $134d84cf814dd9d2$var$toPrimitive(t, r) {
    if ("object" != $134d84cf814dd9d2$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $134d84cf814dd9d2$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
$134d84cf814dd9d2$exports = $134d84cf814dd9d2$var$toPrimitive, $134d84cf814dd9d2$exports.__esModule = true, $134d84cf814dd9d2$exports["default"] = $134d84cf814dd9d2$exports;


function $18ef7d9196991f20$var$toPropertyKey(t) {
    var i = $134d84cf814dd9d2$exports(t, "string");
    return "symbol" == $18ef7d9196991f20$var$_typeof(i) ? i : i + "";
}
$18ef7d9196991f20$exports = $18ef7d9196991f20$var$toPropertyKey, $18ef7d9196991f20$exports.__esModule = true, $18ef7d9196991f20$exports["default"] = $18ef7d9196991f20$exports;


function $4b3bc1d4103a914b$var$_defineProperty(e, r, t) {
    return (r = $18ef7d9196991f20$exports(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
$4b3bc1d4103a914b$exports = $4b3bc1d4103a914b$var$_defineProperty, $4b3bc1d4103a914b$exports.__esModule = true, $4b3bc1d4103a914b$exports["default"] = $4b3bc1d4103a914b$exports;



// Reliably test against conditions like
// localStorage being full or private mode in Safari being a .
// https://gist.github.com/paulirish/5558557
var $38191c9c25525ef8$var$isLocalStorageSupported = function isLocalStorageSupported() {
    try {
        // use an random key to test
        // eslint-disable-next-line @repo/internal/react/disallow-unstable-values
        var testKey = "__test_".concat(Date.now(), "__");
        localStorage.setItem(testKey, testKey);
        localStorage.removeItem(testKey);
        return true;
    } catch (e) {
        return false;
    }
};
var $38191c9c25525ef8$var$safeLocalStorage = function safeLocalStorage() {
    if ($38191c9c25525ef8$var$isLocalStorageSupported()) return localStorage;
    // Returning a mock object here in the case that this is run in SSR mode
    if (typeof window === "undefined") return {
        getItem: function getItem(_key) {
            return null;
        },
        setItem: function setItem(_key, _value) {
            return null;
        },
        removeItem: function removeItem(_key) {
            return null;
        },
        clear: function clear() {
            return null;
        },
        key: function key(_index) {
            return null;
        },
        get length () {
            return 0;
        }
    };
    if (window.__localStorageFallback && Object.keys(window.__localStorageFallback).length !== 0) return window.__localStorageFallback;
    var storageAPI = {
        getItem: function getItem(key) {
            if (window.__localStorageFallback.hasOwnProperty(key)) return window.__localStorageFallback[key];
            return null;
        },
        setItem: function setItem(key, value) {
            window.__localStorageFallback[key] = String(value);
        },
        removeItem: function removeItem(key) {
            delete window.__localStorageFallback[key];
        },
        clear: function clear() {
            for(var key in window.__localStorageFallback)if (window.__localStorageFallback.hasOwnProperty(key)) delete window.__localStorageFallback[key];
        },
        get length () {
            if (!window.__localStorageFallback) return 0;
            return Object.keys(window.__localStorageFallback).length;
        }
    };
    window.__localStorageFallback = Object.create(storageAPI);
    return window.__localStorageFallback;
};
var $38191c9c25525ef8$export$2e2bcd8739ae039 = $38191c9c25525ef8$var$safeLocalStorage;


function $62f1b441135b82b3$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $62f1b441135b82b3$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $62f1b441135b82b3$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($4b3bc1d4103a914b$exports)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $62f1b441135b82b3$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $62f1b441135b82b3$export$576dabd404a1ed99 = (0, $b1a529b255355df4$export$d67ac355184b7646).reduce(function(acc, currentValue) {
    return $62f1b441135b82b3$var$_objectSpread($62f1b441135b82b3$var$_objectSpread({}, acc), {}, (0, (/*@__PURE__*/$parcel$interopDefault($4b3bc1d4103a914b$exports)))({}, currentValue, 0));
}, {});
var $62f1b441135b82b3$export$f8355a2df0f4a946 = function mergeGridStateIntoStorage(key, value) {
    var storageValue = JSON.parse((0, $38191c9c25525ef8$export$2e2bcd8739ae039)().getItem((0, $b1a529b255355df4$export$451e84a45a9e4a75)) || "{}");
    if (value !== null && (0, (/*@__PURE__*/$parcel$interopDefault($49a8658da987ab6b$exports)))(value) === "object") storageValue[key] = $62f1b441135b82b3$var$_objectSpread($62f1b441135b82b3$var$_objectSpread({}, storageValue[key]), value);
    else storageValue[key] = value;
    (0, $38191c9c25525ef8$export$2e2bcd8739ae039)().setItem((0, $b1a529b255355df4$export$451e84a45a9e4a75), JSON.stringify(storageValue));
};
var $62f1b441135b82b3$export$d95e99d8116d17dc = function getGridStateFromStorage(key) {
    var storageValue = JSON.parse((0, $38191c9c25525ef8$export$2e2bcd8739ae039)().getItem((0, $b1a529b255355df4$export$451e84a45a9e4a75)) || "{}");
    return storageValue[key];
};
var $62f1b441135b82b3$export$17e3760e0b35f1cd = function removeFromGridStateInStorage(key, secondKey) {
    var storageValue = JSON.parse((0, $38191c9c25525ef8$export$2e2bcd8739ae039)().getItem((0, $b1a529b255355df4$export$451e84a45a9e4a75)) || "{}");
    if (secondKey && storageValue[key]) delete storageValue[key][secondKey];
    else delete storageValue[key];
    (0, $38191c9c25525ef8$export$2e2bcd8739ae039)().setItem((0, $b1a529b255355df4$export$451e84a45a9e4a75), JSON.stringify(storageValue));
};
var $62f1b441135b82b3$export$74732e47915c7839 = function resolveDimension(key) {
    var dimension = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var shouldPersist = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    if (shouldPersist) {
        var cachedGridState = $62f1b441135b82b3$export$d95e99d8116d17dc("gridState");
        return cachedGridState && Object.keys(cachedGridState).length > 0 && cachedGridState[key] ? cachedGridState[key] : dimension;
    }
    return dimension;
};
var $62f1b441135b82b3$export$b089e01213f07bd = function getLeftPanelWidth() {
    if (typeof window === "undefined") return 0;
    return parseInt(window.getComputedStyle(document.documentElement).getPropertyValue("--".concat((0, $b1a529b255355df4$export$f963aecf2d4465bd))), 10) || 0;
};
var $62f1b441135b82b3$export$2bca58b6ee823bf7 = function getLeftSidebarPercentage(currentWidth, maxWidth) {
    var total = (currentWidth - (0, $b1a529b255355df4$export$539e68c09584883a)) / (maxWidth - (0, $b1a529b255355df4$export$539e68c09584883a));
    if (total < 0) return 0;
    if (total > 1) return 100;
    return Math.floor(total * 100);
};
var $62f1b441135b82b3$export$e895e3e8b708ae2a = function getPageLayoutSlotSelector(slotName) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($4b3bc1d4103a914b$exports)))({}, (0, $b1a529b255355df4$export$5253dd9707b8c3ba), slotName);
};
var $62f1b441135b82b3$export$218ece2c32b7db0e = function getPageLayoutSlotCSSSelector(slotName) {
    return "[".concat((0, $b1a529b255355df4$export$5253dd9707b8c3ba), "='").concat(slotName, "']");
};



var $eb873fe7f27edc90$exports = {};
var $c15ec8f1ed867bcd$exports = {};
function $c15ec8f1ed867bcd$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.includes(n)) continue;
        t[n] = r[n];
    }
    return t;
}
$c15ec8f1ed867bcd$exports = $c15ec8f1ed867bcd$var$_objectWithoutPropertiesLoose, $c15ec8f1ed867bcd$exports.__esModule = true, $c15ec8f1ed867bcd$exports["default"] = $c15ec8f1ed867bcd$exports;


function $eb873fe7f27edc90$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $c15ec8f1ed867bcd$exports(e, t);
    if (Object.getOwnPropertySymbols) {
        var s = Object.getOwnPropertySymbols(e);
        for(r = 0; r < s.length; r++)o = s[r], t.includes(o) || ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
$eb873fe7f27edc90$exports = $eb873fe7f27edc90$var$_objectWithoutProperties, $eb873fe7f27edc90$exports.__esModule = true, $eb873fe7f27edc90$exports["default"] = $eb873fe7f27edc90$exports;



var $dAx5m = parcelRequire("dAx5m");

var $Bb0he = parcelRequire("Bb0he");
var $1c13d5885e083c22$var$_ref, $1c13d5885e083c22$var$_process, $1c13d5885e083c22$var$_process2;
// We can't rely on NODE_ENV === 'test' if its value is already configured by the consumer to some other value, so better to use JEST_WORKER_ID
// https://jestjs.io/docs/environment-variables#jest_worker_id
var $1c13d5885e083c22$var$TESTS_MODE = ($1c13d5885e083c22$var$_ref = (globalThis === null || globalThis === void 0 || ($1c13d5885e083c22$var$_process = globalThis.process) === null || $1c13d5885e083c22$var$_process === void 0 || ($1c13d5885e083c22$var$_process = $1c13d5885e083c22$var$_process.env) === null || $1c13d5885e083c22$var$_process === void 0 ? void 0 : $1c13d5885e083c22$var$_process.JEST_WORKER_ID) !== undefined, $1c13d5885e083c22$var$_ref !== void 0) ? $1c13d5885e083c22$var$_ref : false;
var $1c13d5885e083c22$var$DEBUG_MODE = !$1c13d5885e083c22$var$TESTS_MODE && (globalThis === null || globalThis === void 0 || ($1c13d5885e083c22$var$_process2 = globalThis.process) === null || $1c13d5885e083c22$var$_process2 === void 0 || ($1c13d5885e083c22$var$_process2 = $1c13d5885e083c22$var$_process2.env) === null || $1c13d5885e083c22$var$_process2 === void 0 ? void 0 : $1c13d5885e083c22$var$_process2.NODE_ENV) !== "production";
var $1c13d5885e083c22$export$1c9f709888824e05 = function debug() {
    var _console;
    if (!$1c13d5885e083c22$var$DEBUG_MODE) return;
    // eslint-disable-next-line no-console
    (_console = console).debug.apply(_console, arguments);
};



var $ahJoN = parcelRequire("ahJoN");
var $87385ad7962f4fbf$var$pkgName = "@atlaskit/platform-feature-flags";
var $87385ad7962f4fbf$export$7e41b1b2bdee3f98 = "__PLATFORM_FEATURE_FLAGS__";
var $87385ad7962f4fbf$var$hasProcessEnv = typeof $ahJoN !== "undefined" && typeof $ahJoN.env !== "undefined";
// FF global overrides can be configured by test runners or Storybook
var $87385ad7962f4fbf$var$ENV_ENABLE_PLATFORM_FF = $87385ad7962f4fbf$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
// STORYBOOK_ENABLE_PLATFORM_FF is included as storybook only allows env vars prefixed with STORYBOOK
// https://github.com/storybookjs/storybook/issues/12270
var $87385ad7962f4fbf$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF = $87385ad7962f4fbf$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
var $87385ad7962f4fbf$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE = $87385ad7962f4fbf$var$ENV_ENABLE_PLATFORM_FF || $87385ad7962f4fbf$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF;
var $87385ad7962f4fbf$var$DEFAULT_PFF_GLOBAL = {
    // In development mode we want to capture any feature flag checks that happen using the default resolver and log this result when the resolver is replaced.
    // This is because evaluating feature flags when the resolver/FF client is loaded asynchronously could cause unexpected issues.
    earlyResolvedFlags: new Map(),
    booleanResolver: function booleanResolver(flagKey) {
        var unresolvedFlagCount;
        return false;
    }
};
var $87385ad7962f4fbf$var$globalVar = typeof window !== "undefined" ? window : globalThis;
$87385ad7962f4fbf$var$globalVar[$87385ad7962f4fbf$export$7e41b1b2bdee3f98] = $87385ad7962f4fbf$var$globalVar[$87385ad7962f4fbf$export$7e41b1b2bdee3f98] || $87385ad7962f4fbf$var$DEFAULT_PFF_GLOBAL;
function $87385ad7962f4fbf$export$f2b591175b3e424c(resolver) {
    $87385ad7962f4fbf$var$globalVar[$87385ad7962f4fbf$export$7e41b1b2bdee3f98].booleanResolver = resolver;
    var _globalVar$PFF_GLOBAL;
}
function $87385ad7962f4fbf$export$6333b6aff9fc6275(flagKey) {
    if ($87385ad7962f4fbf$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE) {
        (0, $1c13d5885e083c22$export$1c9f709888824e05)('[%s]: The feature flags were enabled while running tests. The flag "%s" will be always enabled.', $87385ad7962f4fbf$var$pkgName, flagKey);
        return true;
    }
    try {
        var _globalVar$PFF_GLOBAL2;
        var result = (_globalVar$PFF_GLOBAL2 = $87385ad7962f4fbf$var$globalVar[$87385ad7962f4fbf$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL2 === void 0 ? void 0 : _globalVar$PFF_GLOBAL2.booleanResolver(flagKey);
        if (typeof result !== "boolean") {
            // eslint-disable-next-line no-console
            console.warn("".concat(flagKey, " resolved to a non-boolean value, returning false for safety"));
            return false;
        }
        return result;
    } catch (e) {
        return false;
    }
}


function $39f13c832a050bab$export$ba05d765b8392e5e(flagResolver) {
    (0, $87385ad7962f4fbf$export$f2b591175b3e424c)(flagResolver);
}
function $39f13c832a050bab$export$470e5c2be1411c89(name) {
    return (0, $87385ad7962f4fbf$export$6333b6aff9fc6275)(name);
}
function $39f13c832a050bab$export$b40ec24ac8275656(name) {
    return (0, $87385ad7962f4fbf$export$6333b6aff9fc6275)(name);
}


var $daaba0212c9fc0a0$var$_excluded = [
    "setLeftSidebarState"
];
function $daaba0212c9fc0a0$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $daaba0212c9fc0a0$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $daaba0212c9fc0a0$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($4b3bc1d4103a914b$exports)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $daaba0212c9fc0a0$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $daaba0212c9fc0a0$var$leftSidebarState = {
    isFlyoutOpen: false,
    isResizing: false,
    isLeftSidebarCollapsed: false,
    leftSidebarWidth: 0,
    lastLeftSidebarWidth: 0,
    flyoutLockCount: 0,
    isFixed: true
};
var $daaba0212c9fc0a0$export$aa5a712eea4c2ae8 = /*#__PURE__*/ (0, $dAx5m.createContext)({
    isLeftSidebarCollapsed: false,
    expandLeftSidebar: (0, $Bb0he.default),
    collapseLeftSidebar: (0, $Bb0he.default),
    leftSidebarState: $daaba0212c9fc0a0$var$leftSidebarState,
    setLeftSidebarState: (0, $Bb0he.default),
    toggleLeftSidebar: (0, $Bb0he.default)
});
var $daaba0212c9fc0a0$export$10c7104037a7af62 = function usePageLayoutResize() {
    var _useContext = (0, $dAx5m.useContext)($daaba0212c9fc0a0$export$aa5a712eea4c2ae8), setLeftSidebarState = _useContext.setLeftSidebarState, context = (0, (/*@__PURE__*/$parcel$interopDefault($eb873fe7f27edc90$exports)))(_useContext, $daaba0212c9fc0a0$var$_excluded);
    return context;
};
var $daaba0212c9fc0a0$export$94561f6055639ef7 = function useLeftSidebarFlyoutLock() {
    var _useContext2 = (0, $dAx5m.useContext)($daaba0212c9fc0a0$export$aa5a712eea4c2ae8), setLeftSidebarState = _useContext2.setLeftSidebarState;
    (0, $dAx5m.useEffect)(function() {
        setLeftSidebarState(function(current) {
            return $daaba0212c9fc0a0$var$_objectSpread($daaba0212c9fc0a0$var$_objectSpread({}, current), {}, {
                flyoutLockCount: current.flyoutLockCount + 1
            });
        });
        return function() {
            setLeftSidebarState(function(current) {
                return $daaba0212c9fc0a0$var$_objectSpread($daaba0212c9fc0a0$var$_objectSpread({}, current), {}, {
                    flyoutLockCount: current.flyoutLockCount - 1
                });
            });
        };
    }, [
        setLeftSidebarState
    ]);
};
var $daaba0212c9fc0a0$export$f37b9b9b883352cf = function UNSAFE_useSetLeftSidebarState() {
    var _useContext3 = (0, $dAx5m.useContext)($daaba0212c9fc0a0$export$aa5a712eea4c2ae8), setLeftSidebarState = _useContext3.setLeftSidebarState;
    return (0, $39f13c832a050bab$export$470e5c2be1411c89)("platform.atlassian.griffin-navigation-redesign") ? setLeftSidebarState : (0, $Bb0he.default);
};


var $dAx5m = parcelRequire("dAx5m");

var $Bb0he = parcelRequire("Bb0he");
var $bd651192f4e0270e$export$4c5cc3b14c7678a = /*#__PURE__*/ (0, $dAx5m.createContext)({
    skipLinksData: [],
    registerSkipLink: (0, $Bb0he.default),
    unregisterSkipLink: (0, $Bb0he.default)
});
var $bd651192f4e0270e$export$c9d9cb2ee9590f87 = function useSkipLinks() {
    return (0, $dAx5m.useContext)($bd651192f4e0270e$export$4c5cc3b14c7678a);
};
var $bd651192f4e0270e$export$89d9323301efc7d6 = function useSkipLink(id, skipLinkTitle) {
    var _useSkipLinks = $bd651192f4e0270e$export$c9d9cb2ee9590f87(), registerSkipLink = _useSkipLinks.registerSkipLink, unregisterSkipLink = _useSkipLinks.unregisterSkipLink;
    (0, $dAx5m.useEffect)(function() {
        if (id && skipLinkTitle) registerSkipLink({
            id: id,
            skipLinkTitle: skipLinkTitle
        });
        return function() {
            unregisterSkipLink(id);
        };
    }, [
        id,
        skipLinkTitle,
        registerSkipLink,
        unregisterSkipLink
    ]);
};


/** @jsx jsx */ 
var $jVTBW = parcelRequire("jVTBW");
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ /* eslint-disable prefer-rest-params */ 
var $e2xkU = parcelRequire("e2xkU");

var $443020244433ecf4$export$44ffba16bd48dac6 = "__ATLASKIT_THEME__";
var $443020244433ecf4$export$c93026a968943f95 = "light";
var $443020244433ecf4$export$6ba72c8346b4c57e = [
    "light",
    "dark"
];
var $443020244433ecf4$export$7a57f79000377ca2 = function borderRadius() {
    return 3;
};
var $443020244433ecf4$export$6d8204c2cb2e06b8 = function gridSize() {
    return 8;
};
var $443020244433ecf4$export$85e3c3ca0c6fb93 = function fontSize() {
    return 14;
};
var $443020244433ecf4$export$6746fe0d9c9fab54 = function fontSizeSmall() {
    return 11;
};
var $443020244433ecf4$export$a5975749f0374264 = function fontFamily() {
    return "-apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif";
};
var $443020244433ecf4$export$356129969ee49c55 = function codeFontFamily() {
    return "'SFMono-Medium', 'SF Mono', 'Segoe UI Mono', 'Roboto Mono', 'Ubuntu Mono', Menlo, Consolas, Courier, monospace";
};
var $443020244433ecf4$export$8e24544ddba725ee = function focusRing() {
    var color = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "var(--ds-border-focused, ".concat((0, $1899d18108226451$export$215b7063051591f1), ")");
    var outlineWidth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $443020244433ecf4$export$6d8204c2cb2e06b8() / 4;
    (0, $e2xkU.default)("@atlaskit/theme", "focus ring mixin", "Please use `@atlaskit/focus-ring` instead.");
    return "\n  &:focus {\n    outline: none;\n    box-shadow: 0px 0px 0px ".concat(outlineWidth, "px ").concat(color, ";\n  }\n");
};
var $443020244433ecf4$export$c0dd343266bc3261 = function noFocusRing() {
    return "\n  box-shadow: none;\n";
};
var $443020244433ecf4$export$7be255094ccdc533 = {
    card: function card() {
        return 100;
    },
    navigation: function navigation() {
        return 200;
    },
    dialog: function dialog() {
        return 300;
    },
    layer: function layer() {
        return 400;
    },
    blanket: function blanket() {
        return 500;
    },
    modal: function modal() {
        return 510;
    },
    flag: function flag() {
        return 600;
    },
    spotlight: function spotlight() {
        return 700;
    },
    tooltip: function tooltip() {
        return 9999;
    }
};
var $443020244433ecf4$export$a1b3edb637fb4f35 = function visuallyHidden() {
    (0, $e2xkU.default)("@atlaskit/theme", "visually hidden mixin", "Please use `@atlaskit/visually-hidden` instead.");
    return {
        border: "0 !important",
        clip: "rect(1px, 1px, 1px, 1px) !important",
        height: "1px !important",
        overflow: "hidden !important",
        padding: "0 !important",
        position: "absolute !important",
        width: "1px !important",
        whiteSpace: "nowrap !important"
    };
};
var $443020244433ecf4$export$ba1d834b86d72a09 = $443020244433ecf4$export$a1b3edb637fb4f35;
var $443020244433ecf4$export$e497e856b4f89fcd = function skeletonShimmer() {
    return {
        css: {
            backgroundColor: "var(--ds-skeleton, ".concat((0, $1899d18108226451$export$2a0674ff2eb10214)(), ")"),
            animationDuration: "1.5s",
            animationIterationCount: "infinite",
            animationTimingFunction: "linear",
            animationDirection: "alternate"
        },
        keyframes: {
            from: {
                backgroundColor: "var(--ds-skeleton, ".concat((0, $1899d18108226451$export$2a0674ff2eb10214)(), ")")
            },
            to: {
                backgroundColor: "var(--ds-skeleton-subtle, ".concat((0, $1899d18108226451$export$920c0d5c49070351), ")")
            }
        }
    };
};


function $014321158bfc6350$export$2e2bcd8739ae039(props) {
    if (props && props.theme) {
        // Theme is the global Atlaskit theme
        if ((0, $443020244433ecf4$export$44ffba16bd48dac6) in props.theme) return props.theme[0, $443020244433ecf4$export$44ffba16bd48dac6];
        else if ("mode" in props.theme && (0, $443020244433ecf4$export$6ba72c8346b4c57e).includes(props.theme.mode)) return props.theme;
    }
    // If format not supported (or no theme provided), return standard theme
    return {
        mode: (0, $443020244433ecf4$export$c93026a968943f95)
    };
}


// Unpack custom variants, and get correct value for the current theme
function $6b1df7b83fbfb754$var$themedVariants(variantProp, variants) {
    return function(props) {
        var theme = (0, $014321158bfc6350$export$2e2bcd8739ae039)(props);
        if (props && props[variantProp] && variants) {
            var modes = variants[props[variantProp]];
            if (modes && modes[theme.mode]) {
                var value = modes[theme.mode];
                if (value) return value;
                 // TS believes value can be undefined
            }
        }
        return "";
    };
}
function $6b1df7b83fbfb754$export$2e2bcd8739ae039(modesOrVariant, variantModes) {
    if (typeof modesOrVariant === "string") return $6b1df7b83fbfb754$var$themedVariants(modesOrVariant, variantModes);
    var modes = modesOrVariant;
    return function(props) {
        // Get theme from the user's props
        var theme = (0, $014321158bfc6350$export$2e2bcd8739ae039)(props);
        // User isn't required to provide both light and dark values
        if (theme.mode in modes) {
            var value = modes[theme.mode]; // TS believes value can be undefined
            if (value) return value;
        }
        return "";
    };
}


var $1899d18108226451$export$4b84fd0e2c617bd = "#FFEBE6";
var $1899d18108226451$export$b34b069eff244586 = "#FFBDAD";
var $1899d18108226451$export$be802dd0d8b57f35 = "#FF8F73";
var $1899d18108226451$export$60847d42f9da92a6 = "#FF7452";
var $1899d18108226451$export$4a7404f376229999 = "#FF5630";
var $1899d18108226451$export$2010d0fb4295b346 = "#DE350B";
var $1899d18108226451$export$2837b5a1a71d5c02 = "#BF2600";
var $1899d18108226451$export$8d9596b529bbb9cf = "#FFFAE6";
var $1899d18108226451$export$41060a744ab0b7ae = "#FFF0B3";
var $1899d18108226451$export$1cc05bbbf340e559 = "#FFE380";
var $1899d18108226451$export$5aae31392d72caaa = "#FFC400";
var $1899d18108226451$export$c6930421db9fa514 = "#FFAB00";
var $1899d18108226451$export$59619663aa6500fb = "#FF991F";
var $1899d18108226451$export$874739ea9e379ab6 = "#FF8B00";
var $1899d18108226451$export$8a6341c32b6a3ee6 = "#E3FCEF";
var $1899d18108226451$export$69a3bf21b9686c2b = "#ABF5D1";
var $1899d18108226451$export$afbce1382ec95f73 = "#79F2C0";
var $1899d18108226451$export$747d86715d4175de = "#57D9A3";
var $1899d18108226451$export$940e1f69e873f202 = "#36B37E";
var $1899d18108226451$export$a49394138f7b8e85 = "#00875A";
var $1899d18108226451$export$6fa04827ac68a4fb = "#006644";
var $1899d18108226451$export$226de0355ed012f8 = "#DEEBFF";
var $1899d18108226451$export$8c13c2ee36917869 = "#B3D4FF";
var $1899d18108226451$export$ecfc1dff386a3e7a = "#4C9AFF";
var $1899d18108226451$export$215b7063051591f1 = "#2684FF";
var $1899d18108226451$export$e62e8919cca44969 = "#0065FF";
var $1899d18108226451$export$b3de0ae08da2ce64 = "#0052CC";
var $1899d18108226451$export$a6ee3d71bc067634 = "#0747A6";
var $1899d18108226451$export$363e4475840015bb = "#EAE6FF";
var $1899d18108226451$export$4b0a4417ed59760f = "#C0B6F2";
var $1899d18108226451$export$6011520a64d9a187 = "#998DD9";
var $1899d18108226451$export$a7175d4e9206bc80 = "#8777D9";
var $1899d18108226451$export$b48405b95304b5a1 = "#6554C0";
var $1899d18108226451$export$c71e4279dd54a18d = "#5243AA";
var $1899d18108226451$export$147899de772240ec = "#403294";
var $1899d18108226451$export$2cf711fe14c66f06 = "#E6FCFF";
var $1899d18108226451$export$7a8f4d33f6f9772c = "#B3F5FF";
var $1899d18108226451$export$776c9c497ef08533 = "#79E2F2";
var $1899d18108226451$export$69cb3ca10c1e330e = "#00C7E6";
var $1899d18108226451$export$9dc1ef0f3f48059b = "#00B8D9";
var $1899d18108226451$export$7c835c78b6fcdef8 = "#00A3BF";
var $1899d18108226451$export$6036577f95c3877e = "#008DA6";
var $1899d18108226451$export$29a4f05edc054374 = "#FFFFFF";
var $1899d18108226451$export$e655ef011c4aa1a2 = "#FAFBFC";
var $1899d18108226451$export$9fdfb749e33cdf97 = "#F4F5F7";
var $1899d18108226451$export$3e51e8f1440314ba = "#EBECF0";
var $1899d18108226451$export$1ce2d1575d444ceb = "#DFE1E6";
var $1899d18108226451$export$8754fc7e6d8b3000 = "#C1C7D0";
var $1899d18108226451$export$c2e91cbeada39b8b = "#B3BAC5";
var $1899d18108226451$export$5f71e19f3a7ad9de = "#A5ADBA";
var $1899d18108226451$export$eaa8c8a70ac22806 = "#97A0AF";
var $1899d18108226451$export$7c87d337fb91a97d = "#8993A4";
var $1899d18108226451$export$d6447c357493214f = "#7A869A";
var $1899d18108226451$export$f563ee71e9ee74cd = "#6B778C";
var $1899d18108226451$export$e2ef2124cf4024b1 = "#5E6C84";
var $1899d18108226451$export$eece5f492e429f08 = "#505F79";
var $1899d18108226451$export$c39c0fe0f26207ae = "#42526E";
var $1899d18108226451$export$7090862dc3038a9f = "#344563";
var $1899d18108226451$export$ad0bacf983b7ddaa = "#253858";
var $1899d18108226451$export$7d61b15e0da132af = "#172B4D";
var $1899d18108226451$export$fbda843f0a27fe96 = "#091E42";
var $1899d18108226451$export$791e57b27ca738ef = "rgba(9, 30, 66, 0.02)";
var $1899d18108226451$export$8d43898f60b96a82 = "rgba(9, 30, 66, 0.04)";
var $1899d18108226451$export$920c0d5c49070351 = "rgba(9, 30, 66, 0.08)";
var $1899d18108226451$export$46987b49aab6d1a8 = "rgba(9, 30, 66, 0.13)";
var $1899d18108226451$export$7d3359664e8bb0e5 = "rgba(9, 30, 66, 0.25)";
var $1899d18108226451$export$d2d3bedfb276cac0 = "rgba(9, 30, 66, 0.31)";
var $1899d18108226451$export$6e5e7499ff054f6d = "rgba(9, 30, 66, 0.36)";
var $1899d18108226451$export$59264b346c877fa7 = "rgba(9, 30, 66, 0.42)";
var $1899d18108226451$export$d092757d7c64925c = "rgba(9, 30, 66, 0.48)";
var $1899d18108226451$export$486ab785e4bac3c6 = "rgba(9, 30, 66, 0.54)";
var $1899d18108226451$export$fba592bbc6419fea = "rgba(9, 30, 66, 0.60)";
var $1899d18108226451$export$13609db0e6812ab8 = "rgba(9, 30, 66, 0.66)";
var $1899d18108226451$export$fbae4efaa892d883 = "rgba(9, 30, 66, 0.71)";
var $1899d18108226451$export$f13946d26f440ce6 = "rgba(9, 30, 66, 0.77)";
var $1899d18108226451$export$19f58225ac52a306 = "rgba(9, 30, 66, 0.82)";
var $1899d18108226451$export$6384f09da70e7b62 = "rgba(9, 30, 66, 0.89)";
var $1899d18108226451$export$d0dccc730683edc2 = "rgba(9, 30, 66, 0.95)";
var $1899d18108226451$export$2f6319cf7d736c2a = "#E6EDFA";
var $1899d18108226451$export$95126bc8884d6634 = "#DCE5F5";
var $1899d18108226451$export$8338d8c35d44ff1 = "#CED9EB";
var $1899d18108226451$export$5368d76ae4fbbda7 = "#B8C7E0";
var $1899d18108226451$export$9f0a771d16ec8d36 = "#ABBBD6";
var $1899d18108226451$export$abcf8c38338b4aa5 = "#9FB0CC";
var $1899d18108226451$export$97e81faa16a182c7 = "#8C9CB8";
var $1899d18108226451$export$bfe21c59123ecf33 = "#7988A3";
var $1899d18108226451$export$ee82aa2ea6a1558 = "#67758F";
var $1899d18108226451$export$682927c6ed76be02 = "#56637A";
var $1899d18108226451$export$91fd9994c5be9757 = "#455166";
var $1899d18108226451$export$d281fbfe3cff2df6 = "#3B475C";
var $1899d18108226451$export$3902c91d8b98a753 = "#313D52";
var $1899d18108226451$export$8e8133c1ba5845b5 = "#283447";
var $1899d18108226451$export$33ff357f6620b39 = "#202B3D";
var $1899d18108226451$export$633847cf062b69e0 = "#1B2638";
var $1899d18108226451$export$9776a6e503bdbf76 = "#121A29";
var $1899d18108226451$export$6c813d5160dff5db = "#0E1624";
var $1899d18108226451$export$3d4f271a500072a = "#0D1424";
var $1899d18108226451$export$fe151285c22759ec = "rgba(13, 20, 36, 0.06)";
var $1899d18108226451$export$a101c6190d0da34 = "rgba(13, 20, 36, 0.14)";
var $1899d18108226451$export$4b16f52932fda51 = "rgba(13, 20, 36, 0.18)";
var $1899d18108226451$export$a74bcd7b9845b0d8 = "rgba(13, 20, 36, 0.29)";
var $1899d18108226451$export$9209c179316d1751 = "rgba(13, 20, 36, 0.36)";
var $1899d18108226451$export$88f55133f636c8dd = "rgba(13, 20, 36, 0.40)";
var $1899d18108226451$export$51126f85d1009512 = "rgba(13, 20, 36, 0.47)";
var $1899d18108226451$export$a069b547bd23af78 = "rgba(13, 20, 36, 0.53)";
var $1899d18108226451$export$40cce05af3b2600a = "rgba(13, 20, 36, 0.63)";
var $1899d18108226451$export$b78942185925a0d = "rgba(13, 20, 36, 0.73)";
var $1899d18108226451$export$e058fb44b8eaafca = "rgba(13, 20, 36, 0.78)";
var $1899d18108226451$export$92b0b8de26920c18 = "rgba(13, 20, 36, 0.81)";
var $1899d18108226451$export$67564f7459d3fc9e = "rgba(13, 20, 36, 0.85)";
var $1899d18108226451$export$77868e1ca884ffa3 = "rgba(13, 20, 36, 0.89)";
var $1899d18108226451$export$2afd71d7d3ea2cd5 = "rgba(13, 20, 36, 0.92)";
var $1899d18108226451$export$f2a0acaab9972c70 = "rgba(13, 20, 36, 0.95)";
var $1899d18108226451$export$9ab70e67d6475361 = "rgba(13, 20, 36, 0.97)";
var $1899d18108226451$export$8ce1fd94bee2f412 = (0, $6b1df7b83fbfb754$export$2e2bcd8739ae039)({
    light: "var(--ds-surface, ".concat($1899d18108226451$export$29a4f05edc054374, ")"),
    dark: "var(--ds-surface, ".concat($1899d18108226451$export$633847cf062b69e0, ")")
});
var $1899d18108226451$export$b861914ea877b580 = (0, $6b1df7b83fbfb754$export$2e2bcd8739ae039)({
    light: "var(--ds-background-selected, ".concat($1899d18108226451$export$226de0355ed012f8, ")"),
    dark: "var(--ds-background-selected, ".concat($1899d18108226451$export$8c13c2ee36917869, ")")
});
var $1899d18108226451$export$3f1b020df94387af = (0, $6b1df7b83fbfb754$export$2e2bcd8739ae039)({
    light: "var(--ds-background-neutral-hovered, ".concat($1899d18108226451$export$3e51e8f1440314ba, ")"),
    dark: "var(--ds-background-neutral-hovered, ".concat($1899d18108226451$export$d281fbfe3cff2df6, ")")
});
var $1899d18108226451$export$c0183dbab98ca63e = (0, $6b1df7b83fbfb754$export$2e2bcd8739ae039)({
    light: "var(--ds-surface-overlay, ".concat($1899d18108226451$export$29a4f05edc054374, ")"),
    dark: "var(--ds-surface-overlay, ".concat($1899d18108226451$export$8e8133c1ba5845b5, ")")
});
var $1899d18108226451$export$6f093cfa640b7166 = (0, $6b1df7b83fbfb754$export$2e2bcd8739ae039)({
    light: "var(--ds-text, ".concat($1899d18108226451$export$fbda843f0a27fe96, ")"),
    dark: "var(--ds-text, ".concat($1899d18108226451$export$5368d76ae4fbbda7, ")")
});
var $1899d18108226451$export$42f8e9c698766e7a = (0, $6b1df7b83fbfb754$export$2e2bcd8739ae039)({
    light: "var(--ds-text, ".concat($1899d18108226451$export$7d61b15e0da132af, ")"),
    dark: "var(--ds-text, ".concat($1899d18108226451$export$5368d76ae4fbbda7, ")")
});
var $1899d18108226451$export$c2d157ca1c34b6e3 = (0, $6b1df7b83fbfb754$export$2e2bcd8739ae039)({
    light: "var(--ds-text-selected, ".concat($1899d18108226451$export$b3de0ae08da2ce64, ")"),
    dark: "var(--ds-text-selected, ".concat($1899d18108226451$export$b3de0ae08da2ce64, ")")
});
var $1899d18108226451$export$1905ba28d7cf066f = (0, $6b1df7b83fbfb754$export$2e2bcd8739ae039)({
    light: "var(--ds-text-subtlest, ".concat($1899d18108226451$export$f563ee71e9ee74cd, ")"),
    dark: "var(--ds-text-subtlest, ".concat($1899d18108226451$export$97e81faa16a182c7, ")")
});
var $1899d18108226451$export$bd9002130d306d39 = (0, $6b1df7b83fbfb754$export$2e2bcd8739ae039)({
    light: "var(--ds-text-subtlest, ".concat($1899d18108226451$export$f563ee71e9ee74cd, ")"),
    dark: "var(--ds-text-subtlest, ".concat($1899d18108226451$export$bfe21c59123ecf33, ")")
});
var $1899d18108226451$export$46e4a324ac90507f = (0, $6b1df7b83fbfb754$export$2e2bcd8739ae039)({
    light: "var(--ds-text, ".concat($1899d18108226451$export$7d61b15e0da132af, ")"),
    dark: "var(--ds-text, ".concat($1899d18108226451$export$5368d76ae4fbbda7, ")")
});
var $1899d18108226451$export$79f3f2b82beb0d36 = (0, $6b1df7b83fbfb754$export$2e2bcd8739ae039)({
    light: "var(--ds-text-subtlest, ".concat($1899d18108226451$export$f563ee71e9ee74cd, ")"),
    dark: "var(--ds-text-subtlest, ".concat($1899d18108226451$export$97e81faa16a182c7, ")")
});
var $1899d18108226451$export$7bb0d5c671655cc4 = (0, $6b1df7b83fbfb754$export$2e2bcd8739ae039)({
    light: $1899d18108226451$export$9fdfb749e33cdf97,
    dark: $1899d18108226451$export$8e8133c1ba5845b5
});
var $1899d18108226451$export$9c30223ca0a664fb = (0, $6b1df7b83fbfb754$export$2e2bcd8739ae039)({
    light: "var(--ds-link, ".concat($1899d18108226451$export$b3de0ae08da2ce64, ")"),
    dark: "var(--ds-link, ".concat($1899d18108226451$export$ecfc1dff386a3e7a, ")")
});
var $1899d18108226451$export$7ed258b0728b004b = (0, $6b1df7b83fbfb754$export$2e2bcd8739ae039)({
    light: "var(--ds-link-pressed, ".concat($1899d18108226451$export$e62e8919cca44969, ")"),
    dark: "var(--ds-link-pressed, ".concat($1899d18108226451$export$215b7063051591f1, ")")
});
var $1899d18108226451$export$dfa920d8decc8a59 = (0, $6b1df7b83fbfb754$export$2e2bcd8739ae039)({
    light: "var(--ds-link-pressed, ".concat($1899d18108226451$export$a6ee3d71bc067634, ")"),
    dark: "var(--ds-link-pressed, ".concat($1899d18108226451$export$ecfc1dff386a3e7a, ")")
});
var $1899d18108226451$export$6069e6ad5c78f632 = (0, $6b1df7b83fbfb754$export$2e2bcd8739ae039)({
    light: "var(--ds-border-focused, ".concat($1899d18108226451$export$215b7063051591f1, ")"),
    dark: "var(--ds-border-focused, ".concat($1899d18108226451$export$215b7063051591f1, ")")
});
var $1899d18108226451$export$9ad721cf3b3debe0 = (0, $6b1df7b83fbfb754$export$2e2bcd8739ae039)({
    light: "var(--ds-background-brand-bold, ".concat($1899d18108226451$export$b3de0ae08da2ce64, ")"),
    dark: "var(--ds-background-brand-bold, ".concat($1899d18108226451$export$ecfc1dff386a3e7a, ")")
});
var $1899d18108226451$export$2aa0182783e7e9de = (0, $6b1df7b83fbfb754$export$2e2bcd8739ae039)({
    light: $1899d18108226451$export$b3de0ae08da2ce64,
    dark: $1899d18108226451$export$ecfc1dff386a3e7a
});
var $1899d18108226451$export$8bf7dff220b82b4a = (0, $6b1df7b83fbfb754$export$2e2bcd8739ae039)({
    light: $1899d18108226451$export$9dc1ef0f3f48059b,
    dark: $1899d18108226451$export$69cb3ca10c1e330e
});
var $1899d18108226451$export$e13cce2a2d16a9d4 = (0, $6b1df7b83fbfb754$export$2e2bcd8739ae039)({
    light: $1899d18108226451$export$b48405b95304b5a1,
    dark: $1899d18108226451$export$6011520a64d9a187
});
var $1899d18108226451$export$a90204d1394caf30 = (0, $6b1df7b83fbfb754$export$2e2bcd8739ae039)({
    light: $1899d18108226451$export$4a7404f376229999,
    dark: $1899d18108226451$export$4a7404f376229999
});
var $1899d18108226451$export$594c5a8758200c32 = (0, $6b1df7b83fbfb754$export$2e2bcd8739ae039)({
    light: $1899d18108226451$export$c6930421db9fa514,
    dark: $1899d18108226451$export$c6930421db9fa514
});
var $1899d18108226451$export$955a2ebd2fb142ae = (0, $6b1df7b83fbfb754$export$2e2bcd8739ae039)({
    light: $1899d18108226451$export$940e1f69e873f202,
    dark: $1899d18108226451$export$940e1f69e873f202
});
var $1899d18108226451$export$2a0674ff2eb10214 = function skeleton() {
    return "var(--ds-skeleton, ".concat($1899d18108226451$export$8d43898f60b96a82, ")");
};


var $f4839139b4407f5b$var$focusStyles = (0, $jVTBW.css)({
    ":focus": {
        outline: "none",
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
        "> div": {
            boxShadow: "0px 0px 0px 2px inset ".concat("var(--ds-border-focused, ".concat((0, $1899d18108226451$export$ecfc1dff386a3e7a), ")")),
            outline: "none"
        }
    }
});
/**
 * Sidebars have an outer and inner component,
 * so the nested selector needs to target an extra level deeper.
 */ var $f4839139b4407f5b$var$sidebarFocusStyles = (0, $jVTBW.css)({
    ":focus": {
        outline: "none",
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
        "> div > div": {
            boxShadow: "0px 0px 0px 2px inset ".concat("var(--ds-border-focused, ".concat((0, $1899d18108226451$export$ecfc1dff386a3e7a), ")")),
            outline: "none"
        }
    }
});
/**
 * We don't use `@atlaskit/focus-ring` here,
 * because we need inset focus styles and:
 *
 * 1. If we set them directly to the layout element,
 *    then any child element's background will cover the shadow.
 * 2. We cannot wrap `children` in `FocusRing`,
 *    because there's no guarantee the passed child takes `className`.
 */ var $f4839139b4407f5b$var$SlotFocusRing = function SlotFocusRing(_ref) {
    var children = _ref.children, _ref$isSidebar = _ref.isSidebar, isSidebar = _ref$isSidebar === void 0 ? false : _ref$isSidebar;
    return (0, $jVTBW.jsx)((0, $jVTBW.ClassNames), null, function(_ref2) {
        var css = _ref2.css;
        return children({
            className: isSidebar ? css($f4839139b4407f5b$var$sidebarFocusStyles) : css($f4839139b4407f5b$var$focusStyles)
        });
    });
};
var $f4839139b4407f5b$export$2e2bcd8739ae039 = $f4839139b4407f5b$var$SlotFocusRing;


// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
var $6186749b3e08b3b8$var$prefersReducedMotionStyles = (0, $jVTBW.css)((0, $d2c51736466554a9$export$ff7706047246b98b)());
var $6186749b3e08b3b8$var$mainStyles = (0, $jVTBW.css)({
    minWidth: 0,
    flexGrow: 1,
    marginInlineStart: 0,
    transition: "margin-left ".concat((0, $b1a529b255355df4$export$3749e1104328fde4), "ms ").concat((0, $5d9ccc9db19f5ae4$export$57636bb43b1ccbb0), " 0s")
});
var $6186749b3e08b3b8$var$draggingStyles = (0, $jVTBW.css)({
    // Make sure drag to resize remains snappy.
    transition: "none"
});
/**
 * Adds a negative left margin to main,
 * which transitions at the same speed as the left sidebar's width increase.
 * This give an illusion that the flyout is appearing on top of the main content,
 * while main remains in place.
 */ var $6186749b3e08b3b8$var$flyoutStyles = (0, $jVTBW.css)({
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
    marginInlineStart: "calc(-1 * var(--".concat((0, $b1a529b255355df4$export$b6744d31294864fd), ", ").concat((0, $b1a529b255355df4$export$991d5285ad765a3d), "px) + ").concat((0, $b1a529b255355df4$export$46acf8758e9e2636), "px)")
});
/**
 * __Main__
 *
 * Provides a slot for main content within the PageLayout.
 *
 * - [Examples](https://atlassian.design/components/page-layout/examples)
 * - [Code](https://atlassian.design/components/page-layout/code)
 */ var $6186749b3e08b3b8$var$Main = function Main(props) {
    var children = props.children, testId = props.testId, id = props.id, skipLinkTitle = props.skipLinkTitle;
    (0, $bd651192f4e0270e$export$89d9323301efc7d6)(id, skipLinkTitle);
    var isDragging = (0, $62087b429ca5c676$export$2e2bcd8739ae039)();
    var _useContext = (0, $dAx5m.useContext)((0, $daaba0212c9fc0a0$export$aa5a712eea4c2ae8)), _useContext$leftSideb = _useContext.leftSidebarState, isFlyoutOpen = _useContext$leftSideb.isFlyoutOpen, isFixed = _useContext$leftSideb.isFixed;
    return (0, $jVTBW.jsx)((0, $f4839139b4407f5b$export$2e2bcd8739ae039), null, function(_ref) {
        var className = _ref.className;
        return (0, $jVTBW.jsx)("main", (0, (/*@__PURE__*/$parcel$interopDefault($928891c66494309d$exports)))({
            "data-testid": testId,
            css: [
                $6186749b3e08b3b8$var$mainStyles,
                isDragging && $6186749b3e08b3b8$var$draggingStyles,
                isFlyoutOpen && !isFixed && $6186749b3e08b3b8$var$flyoutStyles,
                $6186749b3e08b3b8$var$prefersReducedMotionStyles
            ],
            className: className,
            id: id
        }, (0, $62f1b441135b82b3$export$e895e3e8b708ae2a)("main")), children);
    });
};
var $6186749b3e08b3b8$export$2e2bcd8739ae039 = $6186749b3e08b3b8$var$Main;



var $7vqkt = parcelRequire("7vqkt");
parcelRequire("8p3sV");
parcelRequire("1abnK");
var $f9232 = parcelRequire("f9232");

var $3B7Hp = parcelRequire("3B7Hp");

var $ku6eE = parcelRequire("ku6eE");

var $5MUVm = parcelRequire("5MUVm");




var $dAx5m = parcelRequire("dAx5m");

var $jVTBW = parcelRequire("jVTBW");



var $38555f2952fe80d0$export$dad497fe1f6e27c0 = function getTag(onClick, href) {
    if (href) return "a";
    if (onClick) return "button";
    return "div";
};


var $98f5aa17f3ff163c$var$_excluded = [
    "icon",
    "logo",
    "siteTitle",
    "onClick",
    "href",
    "onMouseDown",
    "testId",
    "logoMaxWidth"
];
var $98f5aa17f3ff163c$var$_css;
var $98f5aa17f3ff163c$var$VAR_LOGO_MAX_WIDTH = "--logo-max-width";
var $98f5aa17f3ff163c$var$VAR_PRODUCT_HOME_COLOR_ACTIVE = "--product-home-color-active";
var $98f5aa17f3ff163c$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_ACTIVE = "--product-home-bg-color-active";
var $98f5aa17f3ff163c$var$VAR_PRODUCT_HOME_BOX_SHADOW_ACTIVE = "--product-home-box-shadow-active";
var $98f5aa17f3ff163c$var$VAR_PRODUCT_HOME_COLOR_FOCUS = "--product-home-color-focus";
var $98f5aa17f3ff163c$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_FOCUS = "--product-home-bg-color-focus";
var $98f5aa17f3ff163c$var$VAR_PRODUCT_HOME_BOX_SHADOW_FOCUS = "--product-home-box-shadow-focus";
var $98f5aa17f3ff163c$var$VAR_PRODUCT_HOME_COLOR_HOVER = "--product-home-color-hover";
var $98f5aa17f3ff163c$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_HOVER = "--product-home-bg-color-hover";
var $98f5aa17f3ff163c$var$VAR_PRODUCT_HOME_BOX_SHADOW_HOVER = "--product-home-box-shadow-hover";
var $98f5aa17f3ff163c$var$productHomeButtonStyles = (0, $jVTBW.css)(($98f5aa17f3ff163c$var$_css = {
    display: "flex",
    padding: "var(--ds-space-050, 4px)",
    alignItems: "center",
    background: "none",
    border: 0,
    borderRadius: "var(--ds-border-radius, 3px)",
    color: "inherit",
    cursor: "pointer",
    "&::-moz-focus-inner": {
        border: 0
    },
    "&:first-of-type": {
        marginLeft: 0
    },
    "&:hover": {
        backgroundColor: "var(".concat($98f5aa17f3ff163c$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_HOVER, ")"),
        boxShadow: "var(".concat($98f5aa17f3ff163c$var$VAR_PRODUCT_HOME_BOX_SHADOW_HOVER, ")"),
        color: "var(".concat($98f5aa17f3ff163c$var$VAR_PRODUCT_HOME_COLOR_HOVER, ")")
    },
    "&:active": {
        backgroundColor: "var(".concat($98f5aa17f3ff163c$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_ACTIVE, ")"),
        boxShadow: "var(".concat($98f5aa17f3ff163c$var$VAR_PRODUCT_HOME_BOX_SHADOW_ACTIVE, ")"),
        color: "var(".concat($98f5aa17f3ff163c$var$VAR_PRODUCT_HOME_COLOR_ACTIVE, ")")
    },
    "&:focus-visible": {
        backgroundColor: "var(".concat($98f5aa17f3ff163c$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_FOCUS, ")"),
        color: "var(".concat($98f5aa17f3ff163c$var$VAR_PRODUCT_HOME_COLOR_FOCUS, ")"),
        outline: "var(--ds-border-width-outline, 2px)".concat(" solid ", "var(--ds-border-focused, #4C9AFF)")
    },
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
    "div&": {
        pointerEvents: "none"
    }
}, (0, (/*@__PURE__*/$parcel$interopDefault($659b468336d903e3$exports)))($98f5aa17f3ff163c$var$_css, "@media (max-width: ".concat((0, $477d219a351dcce0$export$4033a111ca79977d) - 0.1, "px)"), {
    margin: "0 ".concat("var(--ds-space-100, 8px)")
}), (0, (/*@__PURE__*/$parcel$interopDefault($659b468336d903e3$exports)))($98f5aa17f3ff163c$var$_css, "@media (min-width: ".concat((0, $477d219a351dcce0$export$4033a111ca79977d), "px)"), {
    margin: "0 ".concat("var(--ds-space-200, 16px)")
}), $98f5aa17f3ff163c$var$_css));
var $98f5aa17f3ff163c$var$productLogoStyles = (0, $jVTBW.css)((0, (/*@__PURE__*/$parcel$interopDefault($659b468336d903e3$exports)))({
    // Ensure anything passed into
    // productHome is aligned correctly
    display: "flex",
    maxWidth: "var(".concat($98f5aa17f3ff163c$var$VAR_LOGO_MAX_WIDTH, ")"),
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
    "& > *": {
        maxHeight: 24
    },
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
    "& > span > svg": {
        maxWidth: "var(".concat($98f5aa17f3ff163c$var$VAR_LOGO_MAX_WIDTH, ")")
    }
}, "@media (max-width: ".concat((0, $477d219a351dcce0$export$4033a111ca79977d) - 0.1, "px)"), {
    display: "none"
}));
var $98f5aa17f3ff163c$var$customMaxHeightStyles = (0, $jVTBW.css)({
    maxHeight: 28
});
var $98f5aa17f3ff163c$var$productIconStyles = (0, $jVTBW.css)((0, (/*@__PURE__*/$parcel$interopDefault($659b468336d903e3$exports)))({
    // Ensure anything passed into
    // productHome is aligned correctly
    display: "flex",
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
    "& > *": {
        maxHeight: 24
    }
}, "@media (min-width: ".concat((0, $477d219a351dcce0$export$4033a111ca79977d), "px)"), {
    display: "none"
}));
var $98f5aa17f3ff163c$var$siteTitleStyles = (0, $jVTBW.css)({
    display: "flex",
    // Overridden in PFF styles applied below; consolidate in FF cleanup
    marginRight: "var(--ds-space-050, 4px)",
    marginLeft: "var(--ds-space-050, 4px)",
    paddingRight: "var(--ds-space-200, 16px)",
    alignItems: "center"
});
// When cleaning up feature flag, these styles can be moved into the above block
var $98f5aa17f3ff163c$var$featureFlaggedSiteTitleStyles = (0, $jVTBW.css)((0, (/*@__PURE__*/$parcel$interopDefault($659b468336d903e3$exports)))({
    // Under the FF, we've made the site title handle it's spacing, with the
    // PrimaryItemsContainer not needing to worry about its paddingInlineStart.
    // This makes it cleaner for the title styles to appear and disappear with mq's
    marginRight: "var(--ds-space-100, 8px)"
}, "@media (max-width: ".concat((0, $477d219a351dcce0$export$4033a111ca79977d) - 0.1, "px)"), {
    display: "none"
}));
/**
 * __Product home__
 *
 * The ProductHome component displays the product visual identity composed of:
 * logo, icon, and optional text. Values for logo and icon are never displayed
 * at the same time, where icon is used only when space is restricted. Should be
 * passed into `AtlassianNavigation`'s `renderProductHome` prop.
 *
 * - [Examples](https://atlassian.design/components/atlassian-navigation/examples#product-home)
 * - [Code](https://atlassian.design/components/atlassian-navigation/code)
 */ var $98f5aa17f3ff163c$var$ProductHome = function ProductHome(_ref) {
    var _productHomeButtonDyn;
    var Icon = _ref.icon, Logo = _ref.logo, siteTitle = _ref.siteTitle, onClick = _ref.onClick, href = _ref.href, onMouseDown = _ref.onMouseDown, testId = _ref.testId, _ref$logoMaxWidth = _ref.logoMaxWidth, logoMaxWidth = _ref$logoMaxWidth === void 0 ? 260 : _ref$logoMaxWidth, rest = (0, (/*@__PURE__*/$parcel$interopDefault($cada364311d44bd0$exports)))(_ref, $98f5aa17f3ff163c$var$_excluded);
    var theme = (0, $9afc2d28bb10b801$export$93d4e7f90805808f)();
    var primaryButton = theme.mode.primaryButton;
    var _theme$mode$productHo = theme.mode.productHome, _theme$mode$productHo2 = _theme$mode$productHo.iconColor, iconColor = _theme$mode$productHo2 === void 0 ? "inherit" : _theme$mode$productHo2, _theme$mode$productHo3 = _theme$mode$productHo.iconGradientStart, iconGradientStart = _theme$mode$productHo3 === void 0 ? "inherit" : _theme$mode$productHo3, _theme$mode$productHo4 = _theme$mode$productHo.iconGradientStop, iconGradientStop = _theme$mode$productHo4 === void 0 ? "inherit" : _theme$mode$productHo4, _theme$mode$productHo5 = _theme$mode$productHo.textColor, textColor = _theme$mode$productHo5 === void 0 ? theme.mode.productHome.color : _theme$mode$productHo5;
    var Tag = (0, $38555f2952fe80d0$export$dad497fe1f6e27c0)(onClick, href);
    var preventFocusRing = function preventFocusRing(e) {
        e.preventDefault();
        onMouseDown && onMouseDown(e);
    };
    var productHomeButtonDynamicStyles = (_productHomeButtonDyn = {}, (0, (/*@__PURE__*/$parcel$interopDefault($659b468336d903e3$exports)))(_productHomeButtonDyn, $98f5aa17f3ff163c$var$VAR_PRODUCT_HOME_COLOR_ACTIVE, primaryButton.active.color), (0, (/*@__PURE__*/$parcel$interopDefault($659b468336d903e3$exports)))(_productHomeButtonDyn, $98f5aa17f3ff163c$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_ACTIVE, primaryButton.active.backgroundColor), (0, (/*@__PURE__*/$parcel$interopDefault($659b468336d903e3$exports)))(_productHomeButtonDyn, $98f5aa17f3ff163c$var$VAR_PRODUCT_HOME_BOX_SHADOW_ACTIVE, primaryButton.active.boxShadow), (0, (/*@__PURE__*/$parcel$interopDefault($659b468336d903e3$exports)))(_productHomeButtonDyn, $98f5aa17f3ff163c$var$VAR_PRODUCT_HOME_COLOR_FOCUS, primaryButton.focus.color), (0, (/*@__PURE__*/$parcel$interopDefault($659b468336d903e3$exports)))(_productHomeButtonDyn, $98f5aa17f3ff163c$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_FOCUS, primaryButton.focus.backgroundColor), (0, (/*@__PURE__*/$parcel$interopDefault($659b468336d903e3$exports)))(_productHomeButtonDyn, $98f5aa17f3ff163c$var$VAR_PRODUCT_HOME_BOX_SHADOW_FOCUS, primaryButton.focus.boxShadow), (0, (/*@__PURE__*/$parcel$interopDefault($659b468336d903e3$exports)))(_productHomeButtonDyn, $98f5aa17f3ff163c$var$VAR_PRODUCT_HOME_COLOR_HOVER, primaryButton.hover.color), (0, (/*@__PURE__*/$parcel$interopDefault($659b468336d903e3$exports)))(_productHomeButtonDyn, $98f5aa17f3ff163c$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_HOVER, primaryButton.hover.backgroundColor), (0, (/*@__PURE__*/$parcel$interopDefault($659b468336d903e3$exports)))(_productHomeButtonDyn, $98f5aa17f3ff163c$var$VAR_PRODUCT_HOME_BOX_SHADOW_HOVER, primaryButton.hover.boxShadow), (0, (/*@__PURE__*/$parcel$interopDefault($659b468336d903e3$exports)))(_productHomeButtonDyn, $98f5aa17f3ff163c$var$VAR_LOGO_MAX_WIDTH, "".concat(logoMaxWidth, "px")), _productHomeButtonDyn);
    return (0, $jVTBW.jsx)((0, $dAx5m.Fragment), null, (0, $jVTBW.jsx)(Tag, (0, (/*@__PURE__*/$parcel$interopDefault($147dc3434bd55d1d$exports)))({
        style: productHomeButtonDynamicStyles,
        css: $98f5aa17f3ff163c$var$productHomeButtonStyles,
        href: href,
        onClick: onClick,
        onMouseDown: preventFocusRing,
        "data-testid": testId && "".concat(testId, "-container")
    }, rest), (0, $jVTBW.jsx)("div", {
        css: [
            $98f5aa17f3ff163c$var$customMaxHeightStyles,
            $98f5aa17f3ff163c$var$productLogoStyles
        ],
        "data-testid": testId && "".concat(testId, "-logo")
    }, (0, $jVTBW.jsx)(Logo, {
        iconGradientStart: iconGradientStart,
        iconGradientStop: iconGradientStop,
        iconColor: iconColor,
        textColor: textColor
    })), (0, $jVTBW.jsx)("div", {
        css: [
            $98f5aa17f3ff163c$var$customMaxHeightStyles,
            $98f5aa17f3ff163c$var$productIconStyles
        ],
        "data-testid": testId && "".concat(testId, "-icon")
    }, (0, $jVTBW.jsx)(Icon, {
        iconGradientStart: iconGradientStart,
        iconGradientStop: iconGradientStop,
        iconColor: iconColor
    }))), siteTitle && (0, $jVTBW.jsx)("div", {
        style: {
            borderRight: theme.mode.productHome.borderRight
        },
        css: [
            $98f5aa17f3ff163c$var$siteTitleStyles,
            (0, $af5ef12ad3f1989a$export$470e5c2be1411c89)("platform.design-system-team.navigation-v2-no-jank_5yhbd") && $98f5aa17f3ff163c$var$featureFlaggedSiteTitleStyles
        ],
        "data-testid": testId && "".concat(testId, "-site-title")
    }, siteTitle));
};
var $98f5aa17f3ff163c$export$2e2bcd8739ae039 = $98f5aa17f3ff163c$var$ProductHome;



var $gbKg7 = parcelRequire("gbKg7");
const $a658dd997fa974ff$export$4ee2721235c833ba = (n)=>100 * n;
const $a658dd997fa974ff$export$a5c9f6dcfaa13620 = 20;
const $a658dd997fa974ff$export$6955bcca4cd3539f = (0, $ku6eE.default).div`
  max-height: 100vh;
  min-height: 100%;
`;
const $a658dd997fa974ff$export$f77ec19837119c86 = (0, $ku6eE.default)((0, $98f5aa17f3ff163c$export$2e2bcd8739ae039))`
  &:hover {
    background-color: ${(0, $gbKg7.default)("color.background.neutral", (0, $5MUVm).N30)};
  }
`;
const $a658dd997fa974ff$export$7fd01d24c9175e32 = (0, $ku6eE.default).div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;

  min-height: 100%;
  max-width: ${$a658dd997fa974ff$export$4ee2721235c833ba(7.8)}px;

  margin: 0 auto;

  /**
 * Set a 20px horizontal padding to produce a full 40px between a
 * column's content and the edge of the page when added to the column's padding
 */
  padding: 0 ${$a658dd997fa974ff$export$a5c9f6dcfaa13620}px;

  padding-bottom: ${(0, $gbKg7.default)("space.400", "32px")};
`;
const $a658dd997fa974ff$export$2d5d2ba3c7c8c40b = (0, $ku6eE.default)((0, $2c0dc2a163ac4c58$export$ac16a6a04d9b7c84))`
  color: ${(props)=>props.isHighlighted ? (0, $gbKg7.default)("color.text.selected", (0, $5MUVm).B400) : (0, $gbKg7.default)("color.text.subtle", (0, $5MUVm).N800)} !important; /* need important here to override :link and :visited styles from @atlaskit/button */

  &:hover {
    background-color: ${(props)=>props.isHighlighted ? (0, $gbKg7.default)("color.background.selected", (0, $5MUVm).B50) : (0, $gbKg7.default)("color.background.neutral", (0, $5MUVm).N30)}!important;
    color: ${(props)=>props.isHighlighted ? (0, $gbKg7.default)("color.text.selected", (0, $5MUVm).B400) : (0, $gbKg7.default)("color.text.subtle", (0, $5MUVm).N800)} !important;
  }
`;
const $a658dd997fa974ff$export$12da5b7dd1435002 = (0, $ku6eE.default).div`
  display: flex;
  gap: 1px;
  position: relative;

  a,
  button {
    color: ${(props)=>props.isHighlighted || props.isOpen ? (0, $gbKg7.default)("color.text.selected", (0, $5MUVm).B400) : (0, $gbKg7.default)("color.text.subtle", (0, $5MUVm).N800)} !important; /* need important here to override :link and :visited styles from @atlaskit/button */
  }
  
  a:hover {
    text-decoration: none;
  }

  &:hover a,
  &:hover button {
    background-color: ${(props)=>props.isHighlighted || props.isOpen ? (0, $gbKg7.default)("color.background.selected", (0, $5MUVm).B50) : (0, $gbKg7.default)("color.background.neutral", (0, $5MUVm).N30)};
    color: ${(props)=>props.isHighlighted || props.isOpen ? (0, $gbKg7.default)("color.text.selected", (0, $5MUVm).B400) : (0, $gbKg7.default)("color.text.subtle", (0, $5MUVm).N800)} !important; /* need important here to override :link and :visited styles from @atlaskit/button */
  &:hover {
    background-color: ${(props)=>props.isHighlighted || props.isOpen ? (0, $gbKg7.default)("color.background.selected.hovered", (0, $5MUVm).B75) : (0, $gbKg7.default)("color.background.neutral.hovered", (0, $5MUVm).N40)};
    color: ${(props)=>props.isHighlighted || props.isOpen ? (0, $gbKg7.default)("color.text.selected", (0, $5MUVm).B400) : (0, $gbKg7.default)("color.text.subtle", (0, $5MUVm).N800)} !important; /* need important here to override :link and :visited styles from @atlaskit/button */

    &:active {
      background-color: ${(props)=>props.isHighlighted || props.isOpen ? (0, $gbKg7.default)("color.background.selected.pressed", (0, $5MUVm).B75) : (0, $gbKg7.default)("color.background.neutral.pressed", (0, $5MUVm).N40)} !important; /* need important here to override :link and :visited styles from @atlaskit/button */
      color: ${(props)=>props.isHighlighted || props.isOpen ? (0, $gbKg7.default)("color.text.selected", (0, $5MUVm).B400) : (0, $gbKg7.default)("color.text.subtle", (0, $5MUVm).N800)} !important; /* need important here to override :link and :visited styles from @atlaskit/button */
    }
  }
`;
const $a658dd997fa974ff$export$f1f3f49a698e2b09 = (0, $ku6eE.default)((0, $2c0dc2a163ac4c58$export$ac16a6a04d9b7c84))`
  border-top-right-radius: 0px !important;
  border-bottom-right-radius: 0px !important;
`;
const $a658dd997fa974ff$export$f0536fb13b75c0c = (0, $ku6eE.default)((0, $9313bc2135291c72$export$bb3af89fb196520d))`
  border-top-left-radius: 0px !important;
  border-bottom-left-radius: 0px !important;
  padding: 0 6px;

  span {
    opacity: 1;
  }
`;
const $a658dd997fa974ff$export$a7decb6e86733638 = (0, $ku6eE.default)((0, $9313bc2135291c72$export$bb3af89fb196520d))`
  display: flex;
  right: 20px;

  span {
    span {
      margin-right: 0 !important;
      margin-left: 0 !important;
    }
  }
`;
const $a658dd997fa974ff$export$9362d48db9369c0f = (0, $ku6eE.default).div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
`;
const $a658dd997fa974ff$export$1a662afb46f800e2 = (0, $ku6eE.default).div`
  position: absolute;
  bottom: 0;
  left: 4px;
  right: 4px;
  height: 3px;
  background-color: ${(0, $gbKg7.default)("color.border.selected", (0, $5MUVm).B400)};
  border-top-left-radius: 1px;
  border-top-right-radius: 1px;
`;



var $bibO8 = parcelRequire("bibO8");

var $dAx5m = parcelRequire("dAx5m");
parcelRequire("jQGCp");
var $7PWYP = parcelRequire("7PWYP");
parcelRequire("jShba");
var $fjOHq = parcelRequire("fjOHq");
var $grRLU = parcelRequire("grRLU");

var $1Bj4T = parcelRequire("1Bj4T");

var $3B7Hp = parcelRequire("3B7Hp");

var $bibO8 = parcelRequire("bibO8");
parcelRequire("dAx5m");
var $419966e524ab767e$exports = {};
var $13264f1778635a57$exports = {};
var $0dc21db264965426$exports = {};
function $0dc21db264965426$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $0dc21db264965426$exports = $0dc21db264965426$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $0dc21db264965426$exports.__esModule = true, $0dc21db264965426$exports["default"] = $0dc21db264965426$exports, $0dc21db264965426$var$_typeof(o);
}
$0dc21db264965426$exports = $0dc21db264965426$var$_typeof, $0dc21db264965426$exports.__esModule = true, $0dc21db264965426$exports["default"] = $0dc21db264965426$exports;


var $13264f1778635a57$var$_typeof = $0dc21db264965426$exports.default;
var $4cc4087fd284cc42$exports = {};

var $4cc4087fd284cc42$var$_typeof = $0dc21db264965426$exports.default;
function $4cc4087fd284cc42$var$toPrimitive(t, r) {
    if ("object" != $4cc4087fd284cc42$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $4cc4087fd284cc42$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
$4cc4087fd284cc42$exports = $4cc4087fd284cc42$var$toPrimitive, $4cc4087fd284cc42$exports.__esModule = true, $4cc4087fd284cc42$exports["default"] = $4cc4087fd284cc42$exports;


function $13264f1778635a57$var$toPropertyKey(t) {
    var i = $4cc4087fd284cc42$exports(t, "string");
    return "symbol" == $13264f1778635a57$var$_typeof(i) ? i : i + "";
}
$13264f1778635a57$exports = $13264f1778635a57$var$toPropertyKey, $13264f1778635a57$exports.__esModule = true, $13264f1778635a57$exports["default"] = $13264f1778635a57$exports;


function $419966e524ab767e$var$_defineProperty(e, r, t) {
    return (r = $13264f1778635a57$exports(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
$419966e524ab767e$exports = $419966e524ab767e$var$_defineProperty, $419966e524ab767e$exports.__esModule = true, $419966e524ab767e$exports["default"] = $419966e524ab767e$exports;



var $dAx5m = parcelRequire("dAx5m");

var $dAx5m = parcelRequire("dAx5m");
var $8052cc79cc1980b1$var$_ref, $8052cc79cc1980b1$var$_process, $8052cc79cc1980b1$var$_process2;
// We can't rely on NODE_ENV === 'test' if its value is already configured by the consumer to some other value, so better to use JEST_WORKER_ID
// https://jestjs.io/docs/environment-variables#jest_worker_id
var $8052cc79cc1980b1$var$TESTS_MODE = ($8052cc79cc1980b1$var$_ref = (globalThis === null || globalThis === void 0 || ($8052cc79cc1980b1$var$_process = globalThis.process) === null || $8052cc79cc1980b1$var$_process === void 0 || ($8052cc79cc1980b1$var$_process = $8052cc79cc1980b1$var$_process.env) === null || $8052cc79cc1980b1$var$_process === void 0 ? void 0 : $8052cc79cc1980b1$var$_process.JEST_WORKER_ID) !== undefined, $8052cc79cc1980b1$var$_ref !== void 0) ? $8052cc79cc1980b1$var$_ref : false;
var $8052cc79cc1980b1$var$DEBUG_MODE = !$8052cc79cc1980b1$var$TESTS_MODE && (globalThis === null || globalThis === void 0 || ($8052cc79cc1980b1$var$_process2 = globalThis.process) === null || $8052cc79cc1980b1$var$_process2 === void 0 || ($8052cc79cc1980b1$var$_process2 = $8052cc79cc1980b1$var$_process2.env) === null || $8052cc79cc1980b1$var$_process2 === void 0 ? void 0 : $8052cc79cc1980b1$var$_process2.NODE_ENV) !== "production";
var $8052cc79cc1980b1$export$1c9f709888824e05 = function debug() {
    var _console;
    if (!$8052cc79cc1980b1$var$DEBUG_MODE) return;
    // eslint-disable-next-line no-console
    (_console = console).debug.apply(_console, arguments);
};



var $ahJoN = parcelRequire("ahJoN");
var $3602ce2a860711d3$var$pkgName = "@atlaskit/platform-feature-flags";
var $3602ce2a860711d3$export$7e41b1b2bdee3f98 = "__PLATFORM_FEATURE_FLAGS__";
var $3602ce2a860711d3$var$hasProcessEnv = typeof $ahJoN !== "undefined" && typeof $ahJoN.env !== "undefined";
// FF global overrides can be configured by test runners or Storybook
var $3602ce2a860711d3$var$ENV_ENABLE_PLATFORM_FF = $3602ce2a860711d3$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
// STORYBOOK_ENABLE_PLATFORM_FF is included as storybook only allows env vars prefixed with STORYBOOK
// https://github.com/storybookjs/storybook/issues/12270
var $3602ce2a860711d3$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF = $3602ce2a860711d3$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
var $3602ce2a860711d3$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE = $3602ce2a860711d3$var$ENV_ENABLE_PLATFORM_FF || $3602ce2a860711d3$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF;
var $3602ce2a860711d3$var$DEFAULT_PFF_GLOBAL = {
    // In development mode we want to capture any feature flag checks that happen using the default resolver and log this result when the resolver is replaced.
    // This is because evaluating feature flags when the resolver/FF client is loaded asynchronously could cause unexpected issues.
    earlyResolvedFlags: new Map(),
    booleanResolver: function booleanResolver(flagKey) {
        var unresolvedFlagCount;
        return false;
    }
};
var $3602ce2a860711d3$var$globalVar = typeof window !== "undefined" ? window : globalThis;
$3602ce2a860711d3$var$globalVar[$3602ce2a860711d3$export$7e41b1b2bdee3f98] = $3602ce2a860711d3$var$globalVar[$3602ce2a860711d3$export$7e41b1b2bdee3f98] || $3602ce2a860711d3$var$DEFAULT_PFF_GLOBAL;
function $3602ce2a860711d3$export$f2b591175b3e424c(resolver) {
    $3602ce2a860711d3$var$globalVar[$3602ce2a860711d3$export$7e41b1b2bdee3f98].booleanResolver = resolver;
    var _globalVar$PFF_GLOBAL;
}
function $3602ce2a860711d3$export$6333b6aff9fc6275(flagKey) {
    if ($3602ce2a860711d3$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE) {
        (0, $8052cc79cc1980b1$export$1c9f709888824e05)('[%s]: The feature flags were enabled while running tests. The flag "%s" will be always enabled.', $3602ce2a860711d3$var$pkgName, flagKey);
        return true;
    }
    try {
        var _globalVar$PFF_GLOBAL2;
        var result = (_globalVar$PFF_GLOBAL2 = $3602ce2a860711d3$var$globalVar[$3602ce2a860711d3$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL2 === void 0 ? void 0 : _globalVar$PFF_GLOBAL2.booleanResolver(flagKey);
        if (typeof result !== "boolean") {
            // eslint-disable-next-line no-console
            console.warn("".concat(flagKey, " resolved to a non-boolean value, returning false for safety"));
            return false;
        }
        return result;
    } catch (e) {
        return false;
    }
}


function $6e9a8111550be9ea$export$ba05d765b8392e5e(flagResolver) {
    (0, $3602ce2a860711d3$export$f2b591175b3e424c)(flagResolver);
}
function $6e9a8111550be9ea$export$470e5c2be1411c89(name) {
    return (0, $3602ce2a860711d3$export$6333b6aff9fc6275)(name);
}
function $6e9a8111550be9ea$export$b40ec24ac8275656(name) {
    return (0, $3602ce2a860711d3$export$6333b6aff9fc6275)(name);
}



var $ahJoN = parcelRequire("ahJoN");
var $ff97ed3a935db858$var$_process$env;
var $ff97ed3a935db858$export$2e2bcd8739ae039 = typeof $ahJoN !== "undefined" && $ahJoN !== null && (($ff97ed3a935db858$var$_process$env = {}, $ff97ed3a935db858$var$_process$env === void 0) ? void 0 : $ff97ed3a935db858$var$_process$env["ANALYTICS_NEXT_MODERN_CONTEXT"]);


var $de49149b07582fbc$exports = {};
var $a5e6354556636b3a$exports = {};
var $5f8e744a93b3aa5e$exports = {};
function $5f8e744a93b3aa5e$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
$5f8e744a93b3aa5e$exports = $5f8e744a93b3aa5e$var$_arrayLikeToArray, $5f8e744a93b3aa5e$exports.__esModule = true, $5f8e744a93b3aa5e$exports["default"] = $5f8e744a93b3aa5e$exports;


function $a5e6354556636b3a$var$_arrayWithoutHoles(r) {
    if (Array.isArray(r)) return $5f8e744a93b3aa5e$exports(r);
}
$a5e6354556636b3a$exports = $a5e6354556636b3a$var$_arrayWithoutHoles, $a5e6354556636b3a$exports.__esModule = true, $a5e6354556636b3a$exports["default"] = $a5e6354556636b3a$exports;


var $b1f4701d03b6067b$exports = {};
function $b1f4701d03b6067b$var$_iterableToArray(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
$b1f4701d03b6067b$exports = $b1f4701d03b6067b$var$_iterableToArray, $b1f4701d03b6067b$exports.__esModule = true, $b1f4701d03b6067b$exports["default"] = $b1f4701d03b6067b$exports;


var $7f2befea71827119$exports = {};

function $7f2befea71827119$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $5f8e744a93b3aa5e$exports(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $5f8e744a93b3aa5e$exports(r, a) : void 0;
    }
}
$7f2befea71827119$exports = $7f2befea71827119$var$_unsupportedIterableToArray, $7f2befea71827119$exports.__esModule = true, $7f2befea71827119$exports["default"] = $7f2befea71827119$exports;


var $9490ea3f725a7384$exports = {};
function $9490ea3f725a7384$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
$9490ea3f725a7384$exports = $9490ea3f725a7384$var$_nonIterableSpread, $9490ea3f725a7384$exports.__esModule = true, $9490ea3f725a7384$exports["default"] = $9490ea3f725a7384$exports;


function $de49149b07582fbc$var$_toConsumableArray(r) {
    return $a5e6354556636b3a$exports(r) || $b1f4701d03b6067b$exports(r) || $7f2befea71827119$exports(r) || $9490ea3f725a7384$exports();
}
$de49149b07582fbc$exports = $de49149b07582fbc$var$_toConsumableArray, $de49149b07582fbc$exports.__esModule = true, $de49149b07582fbc$exports["default"] = $de49149b07582fbc$exports;


var $514fe3cf92855132$exports = {};
function $514fe3cf92855132$var$_classCallCheck(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
$514fe3cf92855132$exports = $514fe3cf92855132$var$_classCallCheck, $514fe3cf92855132$exports.__esModule = true, $514fe3cf92855132$exports["default"] = $514fe3cf92855132$exports;


var $2d61ad5e3379f722$exports = {};

function $2d61ad5e3379f722$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, $13264f1778635a57$exports(o.key), o);
    }
}
function $2d61ad5e3379f722$var$_createClass(e, r, t) {
    return r && $2d61ad5e3379f722$var$_defineProperties(e.prototype, r), t && $2d61ad5e3379f722$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}
$2d61ad5e3379f722$exports = $2d61ad5e3379f722$var$_createClass, $2d61ad5e3379f722$exports.__esModule = true, $2d61ad5e3379f722$exports["default"] = $2d61ad5e3379f722$exports;


var $508396ad410007a0$exports = {};
function $508396ad410007a0$var$_assertThisInitialized(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}
$508396ad410007a0$exports = $508396ad410007a0$var$_assertThisInitialized, $508396ad410007a0$exports.__esModule = true, $508396ad410007a0$exports["default"] = $508396ad410007a0$exports;


var $71f69ef1a22b0aa5$exports = {};
var $675917c785ace2f2$exports = {};
function $675917c785ace2f2$var$_setPrototypeOf(t, e) {
    return $675917c785ace2f2$exports = $675917c785ace2f2$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $675917c785ace2f2$exports.__esModule = true, $675917c785ace2f2$exports["default"] = $675917c785ace2f2$exports, $675917c785ace2f2$var$_setPrototypeOf(t, e);
}
$675917c785ace2f2$exports = $675917c785ace2f2$var$_setPrototypeOf, $675917c785ace2f2$exports.__esModule = true, $675917c785ace2f2$exports["default"] = $675917c785ace2f2$exports;


function $71f69ef1a22b0aa5$var$_inherits(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && $675917c785ace2f2$exports(t, e);
}
$71f69ef1a22b0aa5$exports = $71f69ef1a22b0aa5$var$_inherits, $71f69ef1a22b0aa5$exports.__esModule = true, $71f69ef1a22b0aa5$exports["default"] = $71f69ef1a22b0aa5$exports;


var $16519607699dd9c8$exports = {};

var $16519607699dd9c8$var$_typeof = $0dc21db264965426$exports.default;

function $16519607699dd9c8$var$_possibleConstructorReturn(t, e) {
    if (e && ("object" == $16519607699dd9c8$var$_typeof(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return $508396ad410007a0$exports(t);
}
$16519607699dd9c8$exports = $16519607699dd9c8$var$_possibleConstructorReturn, $16519607699dd9c8$exports.__esModule = true, $16519607699dd9c8$exports["default"] = $16519607699dd9c8$exports;


var $fde670a5abe41c67$exports = {};
function $fde670a5abe41c67$var$_getPrototypeOf(t) {
    return $fde670a5abe41c67$exports = $fde670a5abe41c67$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, $fde670a5abe41c67$exports.__esModule = true, $fde670a5abe41c67$exports["default"] = $fde670a5abe41c67$exports, $fde670a5abe41c67$var$_getPrototypeOf(t);
}
$fde670a5abe41c67$exports = $fde670a5abe41c67$var$_getPrototypeOf, $fde670a5abe41c67$exports.__esModule = true, $fde670a5abe41c67$exports["default"] = $fde670a5abe41c67$exports;




var $dAx5m = parcelRequire("dAx5m");

var $hyn2k = parcelRequire("hyn2k");

var $h0bf1 = parcelRequire("h0bf1");
function $30e783a4c788759f$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $30e783a4c788759f$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, (/*@__PURE__*/$parcel$interopDefault($fde670a5abe41c67$exports)))(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, (/*@__PURE__*/$parcel$interopDefault($fde670a5abe41c67$exports)))(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, (/*@__PURE__*/$parcel$interopDefault($16519607699dd9c8$exports)))(this, result);
    };
}
function $30e783a4c788759f$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($30e783a4c788759f$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $30e783a4c788759f$var$ContextTypes = {
    getAtlaskitAnalyticsContext: (0, (/*@__PURE__*/$parcel$interopDefault($hyn2k))).func,
    getAtlaskitAnalyticsEventHandlers: (0, (/*@__PURE__*/$parcel$interopDefault($hyn2k))).func
};
var $30e783a4c788759f$var$noop = function noop() {
    return [];
};
// eslint-disable-next-line @repo/internal/react/no-class-components
var $30e783a4c788759f$var$AnalyticsContext = /*#__PURE__*/ function(_Component) {
    (0, (/*@__PURE__*/$parcel$interopDefault($71f69ef1a22b0aa5$exports)))(AnalyticsContext, _Component);
    var _super = $30e783a4c788759f$var$_createSuper(AnalyticsContext);
    function AnalyticsContext(props) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($514fe3cf92855132$exports)))(this, AnalyticsContext);
        _this = _super.call(this, props);
        (0, (/*@__PURE__*/$parcel$interopDefault($419966e524ab767e$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($508396ad410007a0$exports)))(_this), "getChildContext", function() {
            return {
                getAtlaskitAnalyticsContext: _this.getAnalyticsContext
            };
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($419966e524ab767e$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($508396ad410007a0$exports)))(_this), "getAnalyticsContext", function() {
            var data = _this.props.data;
            var _this$context$getAtla = _this.context.getAtlaskitAnalyticsContext, getAtlaskitAnalyticsContext = _this$context$getAtla === void 0 ? $30e783a4c788759f$var$noop : _this$context$getAtla;
            return [].concat((0, (/*@__PURE__*/$parcel$interopDefault($de49149b07582fbc$exports)))(getAtlaskitAnalyticsContext()), [
                data
            ]);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($419966e524ab767e$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($508396ad410007a0$exports)))(_this), "getAnalyticsEventHandlers", function() {
            var _this$context$getAtla2 = _this.context.getAtlaskitAnalyticsEventHandlers, getAtlaskitAnalyticsEventHandlers = _this$context$getAtla2 === void 0 ? $30e783a4c788759f$var$noop : _this$context$getAtla2;
            return getAtlaskitAnalyticsEventHandlers();
        });
        _this.contextValue = {
            getAtlaskitAnalyticsContext: _this.getAnalyticsContext,
            getAtlaskitAnalyticsEventHandlers: _this.getAnalyticsEventHandlers
        };
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($2d61ad5e3379f722$exports)))(AnalyticsContext, [
        {
            key: "render",
            value: function render() {
                var children = this.props.children;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $h0bf1.default).Provider, {
                    value: this.contextValue
                }, children);
            }
        }
    ]);
    return AnalyticsContext;
}((0, $dAx5m.Component));
(0, (/*@__PURE__*/$parcel$interopDefault($419966e524ab767e$exports)))($30e783a4c788759f$var$AnalyticsContext, "contextTypes", $30e783a4c788759f$var$ContextTypes);
(0, (/*@__PURE__*/$parcel$interopDefault($419966e524ab767e$exports)))($30e783a4c788759f$var$AnalyticsContext, "childContextTypes", $30e783a4c788759f$var$ContextTypes);
var $30e783a4c788759f$export$2e2bcd8739ae039 = $30e783a4c788759f$var$AnalyticsContext;




var $dAx5m = parcelRequire("dAx5m");

var $h0bf1 = parcelRequire("h0bf1");

var $dAx5m = parcelRequire("dAx5m");

var $h0bf1 = parcelRequire("h0bf1");
var $17c1a17da76902e9$export$d1f587f82ad51c4 = function useAnalyticsContext() {
    return (0, $dAx5m.useContext)((0, $h0bf1.default));
};



var $dAx5m = parcelRequire("dAx5m");
var $266e7b4fa4b20924$export$1d27a74659855e44 = function useTrackedRef(value) {
    var ref = (0, $dAx5m.useRef)(value);
    ref.current = value;
    return ref;
};


var $db90d358068d19ba$var$AnalyticsContext = function AnalyticsContext(_ref) {
    var data = _ref.data, children = _ref.children;
    var dataRef = (0, $266e7b4fa4b20924$export$1d27a74659855e44)(data);
    var _useAnalyticsContext = (0, $17c1a17da76902e9$export$d1f587f82ad51c4)(), getAtlaskitAnalyticsEventHandlers = _useAnalyticsContext.getAtlaskitAnalyticsEventHandlers, getOriginalAnalyticsContext = _useAnalyticsContext.getAtlaskitAnalyticsContext;
    var getAtlaskitAnalyticsContext = (0, $dAx5m.useCallback)(function() {
        return [].concat((0, (/*@__PURE__*/$parcel$interopDefault($de49149b07582fbc$exports)))(getOriginalAnalyticsContext()), [
            dataRef.current
        ]);
    }, [
        getOriginalAnalyticsContext,
        dataRef
    ]);
    var value = (0, $dAx5m.useMemo)(function() {
        return {
            getAtlaskitAnalyticsContext: getAtlaskitAnalyticsContext,
            getAtlaskitAnalyticsEventHandlers: getAtlaskitAnalyticsEventHandlers
        };
    }, [
        getAtlaskitAnalyticsContext,
        getAtlaskitAnalyticsEventHandlers
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $h0bf1.default).Provider, {
        value: value
    }, children);
};
var $db90d358068d19ba$export$2e2bcd8739ae039 = $db90d358068d19ba$var$AnalyticsContext;


var $78c241438805c0c5$var$ExportedAnalyticsContext = function ExportedAnalyticsContext(props) {
    var isModernContext = (0, $ff97ed3a935db858$export$2e2bcd8739ae039) || (0, $6e9a8111550be9ea$export$b40ec24ac8275656)("platform.analytics-next-use-modern-context_fqgbx");
    return isModernContext ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $db90d358068d19ba$export$2e2bcd8739ae039), props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $30e783a4c788759f$export$2e2bcd8739ae039), props);
};
var $78c241438805c0c5$export$2e2bcd8739ae039 = $78c241438805c0c5$var$ExportedAnalyticsContext;


var $45eb56b42e6f1e5e$var$createNamespaceContext = function createNamespaceContext(namespace) {
    var displayName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "NamespacedContext";
    var Component = function Component(props) {
        var newData = (0, (/*@__PURE__*/$parcel$interopDefault($419966e524ab767e$exports)))({}, namespace, props.data);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $78c241438805c0c5$export$2e2bcd8739ae039), {
            data: newData
        }, (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).Children.only(props.children));
    };
    Component.displayName = displayName;
    return Component;
};
var $45eb56b42e6f1e5e$export$2e2bcd8739ae039 = $45eb56b42e6f1e5e$var$createNamespaceContext;


var $b65f5659a3eac1bc$export$80450e0a84a5ede9 = "fabricElementsCtx";
var $b65f5659a3eac1bc$export$3fe25500478a635c = (0, $45eb56b42e6f1e5e$export$2e2bcd8739ae039)($b65f5659a3eac1bc$export$80450e0a84a5ede9, "FabricElementsAnalyticsContext");



var $d543f8437edc6f97$export$1fd3aad76a7c6788 = "navigationCtx";
var $d543f8437edc6f97$export$d0a82da1a0b94929 = (0, $45eb56b42e6f1e5e$export$2e2bcd8739ae039)($d543f8437edc6f97$export$1fd3aad76a7c6788, "NavigationAnalyticsContext");



var $dfc1ba8be7f6acd0$export$8c8f6d8f1fa796f0 = "fabricEditorCtx";
var $dfc1ba8be7f6acd0$export$9eb2b47430ed3f7c = /*#__PURE__*/ function(EDITOR_APPEARANCE_CONTEXT) {
    EDITOR_APPEARANCE_CONTEXT["FIXED_WIDTH"] = "fixedWidth";
    EDITOR_APPEARANCE_CONTEXT["FULL_WIDTH"] = "fullWidth";
    EDITOR_APPEARANCE_CONTEXT["COMMENT"] = "comment";
    EDITOR_APPEARANCE_CONTEXT["CHROMELESS"] = "chromeless";
    EDITOR_APPEARANCE_CONTEXT["MOBILE"] = "mobile";
    return EDITOR_APPEARANCE_CONTEXT;
}({});
var $dfc1ba8be7f6acd0$export$629cada6c5e621e1 = (0, $45eb56b42e6f1e5e$export$2e2bcd8739ae039)($dfc1ba8be7f6acd0$export$8c8f6d8f1fa796f0, "FabricEditorAnalyticsContext");


// Media uses a namespaced analytics context under the following key MEDIA_CONTEXT.
var $67fe0ab0b50ee9e5$export$70df29c238ba7306 = "mediaCtx"; // However we don't export any JSX component to create that namespaced analytics context.
 // In media components, analytics context is being created by this component:
 // @see packages/media/media-common/src/analytics/withMediaAnalyticsContext.tsx



var $051fd2497077277c$export$b326383bee6cb993 = "peopleTeamsCtx";
var $051fd2497077277c$export$4119ddb38ccbfb87 = (0, $45eb56b42e6f1e5e$export$2e2bcd8739ae039)($051fd2497077277c$export$b326383bee6cb993, "PeopleTeamsAnalyticsContext");



var $870dd1308ae383aa$export$da1befb791e93c7e = "NotificationsCtx";
var $870dd1308ae383aa$export$6f8e7ff1e3feafd7 = (0, $45eb56b42e6f1e5e$export$2e2bcd8739ae039)($870dd1308ae383aa$export$da1befb791e93c7e, "NotificationsAnalyticsContext");



var $4134b29d9baa82fb$export$fc7a65795610cb71 = "RecentWorkCtx";
var $4134b29d9baa82fb$export$745926731087ebe2 = (0, $45eb56b42e6f1e5e$export$2e2bcd8739ae039)($4134b29d9baa82fb$export$fc7a65795610cb71, "RecentWorkAnalyticsContext");



var $47041d0b43944b41$export$4906017439f33fc0 = "atlasCtx";
var $47041d0b43944b41$export$43ebbe41370d4543 = (0, $45eb56b42e6f1e5e$export$2e2bcd8739ae039)($47041d0b43944b41$export$4906017439f33fc0, "AtlasAnalyticsContext");



var $1198014d21d09121$export$3240443bf2b83834 = "linkingPlatformCtx";
var $1198014d21d09121$export$6d568da622ce0a08 = (0, $45eb56b42e6f1e5e$export$2e2bcd8739ae039)($1198014d21d09121$export$3240443bf2b83834, "LinkingPlatformAnalyticsContext");



var $933f737246b3ca6e$export$ef0c05448f0f8f9 = "postOfficeCtx";
var $933f737246b3ca6e$export$dcd232f3be312f94 = (0, $45eb56b42e6f1e5e$export$2e2bcd8739ae039)($933f737246b3ca6e$export$ef0c05448f0f8f9, "PostOfficeAnalyticsContext");



var $3da9121fb6876fd3$export$5c3a6fd8b96e8b66 = "aiMateCtx";
var $3da9121fb6876fd3$export$de3826c30468da26 = (0, $45eb56b42e6f1e5e$export$2e2bcd8739ae039)($3da9121fb6876fd3$export$5c3a6fd8b96e8b66, "AIMateAnalyticsContext");



var $0de07e7748fb9b45$export$c2a811a4e42f4af5 = "avpCtx";
var $0de07e7748fb9b45$export$da383e8879a25b03 = (0, $45eb56b42e6f1e5e$export$2e2bcd8739ae039)($0de07e7748fb9b45$export$c2a811a4e42f4af5, "AVPAnalyticsContext");




const $bdef4a5a08f4b14c$export$515664faa1398f37 = "navigation";
const $bdef4a5a08f4b14c$export$3cbe56a0cabcff38 = {
    source: "atlassianAccountMenu",
    componentName: "atlassianAccountMenu",
    packageName: undefined,
    packageVersion: undefined
};


/** @jsxRuntime classic */ /** @jsx jsx */ 
var $dAx5m = parcelRequire("dAx5m");

var $jVTBW = parcelRequire("jVTBW");

var $ku6eE = parcelRequire("ku6eE");

var $55TWT = parcelRequire("55TWT");

var $3FJlW = parcelRequire("3FJlW");

var $6xDaL = parcelRequire("6xDaL");

var $7SVKm = parcelRequire("7SVKm");

var $7hhP0 = parcelRequire("7hhP0");

var $dAx5m = parcelRequire("dAx5m");

var $jVTBW = parcelRequire("jVTBW");

var $5MUVm = parcelRequire("5MUVm");

var $6W4m7 = parcelRequire("6W4m7");

var $6NpRk = parcelRequire("6NpRk");
/** @jsx jsx */ // eslint-disable-next-line @repo/internal/fs/filename-pattern-match

var $jVTBW = parcelRequire("jVTBW");

var $5MUVm = parcelRequire("5MUVm");
var $aeb9d36ba4dc9fbd$var$baseStyles = (0, $jVTBW.css)({
    display: "block",
    margin: "var(--ds-space-0, 0px)",
    color: "var(--ds-text, ".concat((0, $5MUVm.N900), ")")
});
var $aeb9d36ba4dc9fbd$var$truncateStyles = (0, $jVTBW.css)({
    overflowX: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap"
});
var $aeb9d36ba4dc9fbd$var$secondaryStyles = (0, $jVTBW.css)({
    color: "var(--ds-text-subtlest, ".concat((0, $5MUVm.N200), ")"),
    fontSize: "0.85em"
});
/**
 * __Text__
 *
 * Text is used internally only.
 */ var $aeb9d36ba4dc9fbd$var$Text = function Text(_ref) {
    var isSecondary = _ref.isSecondary, children = _ref.children, shouldTruncate = _ref.shouldTruncate;
    return (0, $jVTBW.jsx)("span", {
        css: [
            $aeb9d36ba4dc9fbd$var$baseStyles,
            isSecondary && $aeb9d36ba4dc9fbd$var$secondaryStyles,
            shouldTruncate && $aeb9d36ba4dc9fbd$var$truncateStyles
        ]
    }, children);
};
var $aeb9d36ba4dc9fbd$export$2e2bcd8739ae039 = $aeb9d36ba4dc9fbd$var$Text;



var $cfnBx = parcelRequire("cfnBx");
var $3e1ac8fecd4bc2b8$var$_templateObject;
function $3e1ac8fecd4bc2b8$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $3e1ac8fecd4bc2b8$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $3e1ac8fecd4bc2b8$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($7SVKm)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $3e1ac8fecd4bc2b8$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $3e1ac8fecd4bc2b8$var$avatarItemStyles = (0, $jVTBW.css)({
    minWidth: 0,
    maxWidth: "100%",
    flex: "1 1 100%",
    lineHeight: "1.4",
    paddingInlineStart: "var(--ds-space-100, 8px)"
});
var $3e1ac8fecd4bc2b8$var$getStyles = function getStyles(css, _ref) {
    var backgroundColor = _ref.backgroundColor, isInteractive = _ref.isInteractive, isDisabled = _ref.isDisabled;
    return css($3e1ac8fecd4bc2b8$var$_templateObject || ($3e1ac8fecd4bc2b8$var$_templateObject = (0, (/*@__PURE__*/$parcel$interopDefault($7hhP0)))([
        "\n    align-items: center;\n    background-color: ",
        ";\n    border-radius: ",
        "px;\n    border: ",
        "px solid transparent;\n    box-sizing: border-box;\n    color: inherit;\n    display: flex;\n    font-size: inherit;\n    font-style: normal;\n    font-weight: normal;\n    line-height: 1;\n    outline: none;\n    margin: ",
        ";\n    padding: ",
        ";\n    text-align: left;\n    text-decoration: none;\n    width: 100%;\n\n    ",
        "\n\n    ",
        "\n  "
    ])), backgroundColor, (0, $6W4m7.borderRadius)(), (0, $6NpRk.BORDER_WIDTH), "var(--ds-space-0, 0px)", "var(--ds-space-050, 4px)", isInteractive && "\n        :hover {\n          background-color: ".concat("var(--ds-background-neutral-subtle-hovered, ".concat((0, $5MUVm.N30), ")"), ";\n          cursor: pointer;\n          text-decoration: none;\n        }\n\n        :focus {\n          outline: none;\n          border-color: ", "var(--ds-border-focused, ".concat((0, $5MUVm.B200), ")"), ";\n        }\n\n        :active {\n          background-color: ", "var(--ds-background-neutral-subtle-pressed, ".concat((0, $5MUVm.B50), ")"), ";\n        }\n      "), isDisabled && "\n        cursor: not-allowed;\n        opacity: ".concat("var(--ds-opacity-disabled, 0.5)", ";\n        pointer-events: none;\n      "));
};
/**
 * __Avatar item__
 *
 * An avatar item is a wrapper that goes around an avatar when it's displayed alongside text, such as a name or status.
 *
 * - [Examples](https://atlassian.design/components/avatar/avatar-item/examples)
 * - [Code](https://atlassian.design/components/avatar/avatar-item/code)
 */ var $3e1ac8fecd4bc2b8$var$AvatarItem = /*#__PURE__*/ (0, $dAx5m.forwardRef)(function(_ref2, ref) {
    var avatar = _ref2.avatar, _ref2$backgroundColor = _ref2.backgroundColor, backgroundColor = _ref2$backgroundColor === void 0 ? "transparent" : _ref2$backgroundColor, children = _ref2.children, isTruncationDisabled = _ref2.isTruncationDisabled, href = _ref2.href, isDisabled = _ref2.isDisabled, onClick = _ref2.onClick, primaryText = _ref2.primaryText, secondaryText = _ref2.secondaryText, target = _ref2.target, testId = _ref2.testId, label = _ref2.label;
    var getTestId = function getTestId(testId, children) {
        return !children ? {
            "data-testid": "".concat(testId, "--itemInner")
        } : {
            testId: "".concat(testId, "--itemInner")
        };
    };
    var componentProps = function componentProps() {
        if (isDisabled) return {
            disabled: true
        };
        // return only relevant props for either anchor or button elements
        return $3e1ac8fecd4bc2b8$var$_objectSpread($3e1ac8fecd4bc2b8$var$_objectSpread({}, href && (0, $cfnBx.getLinkProps)(href, target)), onClick && !href ? (0, $cfnBx.getButtonProps)(onClick) : {
            onClick: onClick
        });
    };
    return (0, $jVTBW.jsx)((0, $jVTBW.ClassNames), null, function(_ref3) {
        var css = _ref3.css;
        var props = $3e1ac8fecd4bc2b8$var$_objectSpread($3e1ac8fecd4bc2b8$var$_objectSpread($3e1ac8fecd4bc2b8$var$_objectSpread($3e1ac8fecd4bc2b8$var$_objectSpread({
            ref: ref,
            className: $3e1ac8fecd4bc2b8$var$getStyles(css, {
                backgroundColor: backgroundColor,
                isInteractive: Boolean(onClick || href),
                isDisabled: isDisabled
            })
        }, componentProps()), testId && getTestId(testId, children)), (onClick || href) && {
            "aria-label": label
        }), {}, {
            children: (0, $jVTBW.jsx)((0, $dAx5m.Fragment), null, avatar, (0, $jVTBW.jsx)("div", {
                css: $3e1ac8fecd4bc2b8$var$avatarItemStyles
            }, (0, $jVTBW.jsx)((0, $aeb9d36ba4dc9fbd$export$2e2bcd8739ae039), {
                shouldTruncate: !isTruncationDisabled
            }, primaryText), (0, $jVTBW.jsx)((0, $aeb9d36ba4dc9fbd$export$2e2bcd8739ae039), {
                isSecondary: true,
                shouldTruncate: !isTruncationDisabled
            }, secondaryText)))
        });
        return children ? children(props) : /*#__PURE__*/ (0, $dAx5m.createElement)((0, $cfnBx.getCustomElement)(isDisabled, href, onClick), props);
    });
});
$3e1ac8fecd4bc2b8$var$AvatarItem.displayName = "AvatarItem";
var $3e1ac8fecd4bc2b8$export$2e2bcd8739ae039 = $3e1ac8fecd4bc2b8$var$AvatarItem;


var $7H29x = parcelRequire("7H29x");
var $84f270712ae1e281$exports = {};
"use strict";
Object.defineProperty($84f270712ae1e281$exports, "__esModule", {
    value: true
});
$84f270712ae1e281$exports.default = void 0;

var $84f270712ae1e281$var$_react = $84f270712ae1e281$var$_interopRequireDefault((parcelRequire("dAx5m")));

var $9eGJl = parcelRequire("9eGJl");
function $84f270712ae1e281$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $84f270712ae1e281$var$SettingsIcon = (props)=>/*#__PURE__*/ $84f270712ae1e281$var$_react.default.createElement($9eGJl.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path d="M11.701 16.7a5.002 5.002 0 110-10.003 5.002 5.002 0 010 10.004m8.368-3.117a1.995 1.995 0 01-1.346-1.885c0-.876.563-1.613 1.345-1.885a.48.48 0 00.315-.574 8.947 8.947 0 00-.836-1.993.477.477 0 00-.598-.195 2.04 2.04 0 01-1.29.08 1.988 1.988 0 01-1.404-1.395 2.04 2.04 0 01.076-1.297.478.478 0 00-.196-.597 8.98 8.98 0 00-1.975-.826.479.479 0 00-.574.314 1.995 1.995 0 01-1.885 1.346 1.994 1.994 0 01-1.884-1.345.482.482 0 00-.575-.315c-.708.2-1.379.485-2.004.842a.47.47 0 00-.198.582A2.002 2.002 0 014.445 7.06a.478.478 0 00-.595.196 8.946 8.946 0 00-.833 1.994.48.48 0 00.308.572 1.995 1.995 0 011.323 1.877c0 .867-.552 1.599-1.324 1.877a.479.479 0 00-.308.57 8.99 8.99 0 00.723 1.79.477.477 0 00.624.194c.595-.273 1.343-.264 2.104.238.117.077.225.185.302.3.527.8.512 1.58.198 2.188a.473.473 0 00.168.628 8.946 8.946 0 002.11.897.474.474 0 00.57-.313 1.995 1.995 0 011.886-1.353c.878 0 1.618.567 1.887 1.353a.475.475 0 00.57.313 8.964 8.964 0 002.084-.883.473.473 0 00.167-.631c-.318-.608-.337-1.393.191-2.195.077-.116.185-.225.302-.302.772-.511 1.527-.513 2.125-.23a.477.477 0 00.628-.19 8.925 8.925 0 00.728-1.793.478.478 0 00-.314-.573" fill="currentColor" fill-rule="evenodd"/></svg>`
    }, props));
$84f270712ae1e281$var$SettingsIcon.displayName = "SettingsIcon";
var $84f270712ae1e281$var$_default = $84f270712ae1e281$var$SettingsIcon;
$84f270712ae1e281$exports.default = $84f270712ae1e281$var$_default;



var $g061O = parcelRequire("g061O");
var $10AFn = parcelRequire("10AFn");
var $alMln = parcelRequire("alMln");

var $6W4m7 = parcelRequire("6W4m7");

/** @jsxRuntime classic */ /** @jsx jsx */ 
var $jVTBW = parcelRequire("jVTBW");

var $ku6eE = parcelRequire("ku6eE");

var $55TWT = parcelRequire("55TWT");

var $5MUVm = parcelRequire("5MUVm");

var $6W4m7 = parcelRequire("6W4m7");

var $gbKg7 = parcelRequire("gbKg7");

var $bibO8 = parcelRequire("bibO8");
parcelRequire("dAx5m");

var $9eGJl = parcelRequire("9eGJl");
const $ea5c7b081e16dc39$export$b59bd42a398a2b3c = (props)=>/*#__PURE__*/ (0, $bibO8.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        ...props,
        children: /*#__PURE__*/ (0, $bibO8.jsx)("path", {
            fill: "currentColor",
            d: "M13.523 11.3a4.504 4.504 0 0 1 4.478 4.063l.017.218.005.219v2.5c0 .964-.685 1.78-1.66 1.966l-.165.025-.175.009h-8c-.964 0-1.78-.686-1.966-1.66l-.025-.166-.009-.174v-2.5a4.504 4.504 0 0 1 4.064-4.478l.217-.017.22-.005h3Zm0 2H10.55l-.165.003a2.5 2.5 0 0 0-2.356 2.332l-.006.165-.001 2.442.001.058 7.943.002.057-.002v-2.473l-.003-.165a2.5 2.5 0 0 0-2.332-2.357l-.165-.005Zm-1.5-10a3.5 3.5 0 1 1 0 7 3.5 3.5 0 0 1 0-7Zm0 2a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Z"
        })
    });
function $ea5c7b081e16dc39$export$7dcc8f518762622d(props) {
    return /*#__PURE__*/ (0, $bibO8.jsx)((0, $9eGJl.default), {
        ...props,
        glyph: $ea5c7b081e16dc39$export$b59bd42a398a2b3c
    });
}


/** @jsxRuntime classic */ /** @jsx jsx */ 
var $jVTBW = parcelRequire("jVTBW");
var $24b61f3f66d39989$exports = {};
"use strict";
Object.defineProperty($24b61f3f66d39989$exports, "__esModule", {
    value: true
});
$24b61f3f66d39989$exports.default = void 0;

var $24b61f3f66d39989$var$_react = $24b61f3f66d39989$var$_interopRequireDefault((parcelRequire("dAx5m")));

var $9eGJl = parcelRequire("9eGJl");
function $24b61f3f66d39989$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $24b61f3f66d39989$var$UserAvatarCircleIcon = (props)=>/*#__PURE__*/ $24b61f3f66d39989$var$_react.default.createElement($9eGJl.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle fill="currentColor" cx="12" cy="12" r="10"/><circle fill="inherit" cx="12" cy="9" r="3"/><path d="M7 18.245A7.966 7.966 0 0012 20c1.892 0 3.63-.657 5-1.755V15c0-1.115-.895-2-2-2H9c-1.113 0-2 .895-2 2v3.245z" fill="inherit" fill-rule="nonzero"/></g></svg>`
    }, props));
$24b61f3f66d39989$var$UserAvatarCircleIcon.displayName = "UserAvatarCircleIcon";
var $24b61f3f66d39989$var$_default = $24b61f3f66d39989$var$UserAvatarCircleIcon;
$24b61f3f66d39989$exports.default = $24b61f3f66d39989$var$_default;



var $5MUVm = parcelRequire("5MUVm");

var $gbKg7 = parcelRequire("gbKg7");

var $dAx5m = parcelRequire("dAx5m");
const $eb71a6fac5171c50$export$2c1df3428fc3264c = (src)=>{
    const [state, setState] = (0, $dAx5m.useState)("pending");
    const imgRef = (0, $dAx5m.useRef)();
    (0, $dAx5m.useEffect)(()=>{
        if (!imgRef.current) {
            imgRef.current = new Image();
            imgRef.current.onload = ()=>setState("loaded");
            imgRef.current.onerror = ()=>setState("error");
        }
        setState("pending");
        imgRef.current.src = src;
    }, [
        src
    ]);
    return state;
};


const $6c069d3299adfc83$export$2d75367b6e042d67 = ({ testId: testId, src: src, size: size, className: className })=>{
    const state = (0, $eb71a6fac5171c50$export$2c1df3428fc3264c)(src || "");
    const displayImage = src && state === "loaded";
    const displayFallback = src && state === "error";
    const displaySkeleton = !displayImage && !displayFallback;
    return /*#__PURE__*/ (0, $jVTBW.jsx)("div", {
        "data-testid": testId,
        className: className,
        css: {
            width: size,
            height: size,
            ...displaySkeleton && {
                borderRadius: "50%",
                backgroundColor: (0, $gbKg7.default)("color.background.neutral", (0, $5MUVm.N20A))
            },
            "& svg, & img": {
                width: size,
                height: size
            }
        }
    }, displayImage && /*#__PURE__*/ (0, $jVTBW.jsx)("img", {
        alt: "display image",
        "data-testid": testId && `${testId}--img`,
        src: src,
        css: {
            display: "block",
            borderRadius: "50%"
        }
    }), displayFallback && /*#__PURE__*/ (0, $jVTBW.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($24b61f3f66d39989$exports))), {
        testId: testId && `${testId}--fallback`,
        label: "",
        primaryColor: (0, $gbKg7.default)("color.text.subtlest", (0, $5MUVm.N90)),
        secondaryColor: (0, $gbKg7.default)("color.text.inverse", (0, $5MUVm.N0))
    }));
};



var $ku6eE = parcelRequire("ku6eE");

var $5MUVm = parcelRequire("5MUVm");

var $gbKg7 = parcelRequire("gbKg7");
const $5acc807c7a983516$export$cb6ddd830302c2a8 = (0, $ku6eE.default).span({
    display: "inline-block",
    height: "1em",
    borderRadius: "0.5em",
    backgroundColor: (0, $gbKg7.default)("color.background.neutral", (0, $5MUVm.N20A))
}, ({ length: length })=>({
        width: length
    }));


const $466e60c6ecb152c2$export$66e04d0aacdb3b2 = ({ testId: testId, name: name, picture: picture, email: email, managedBy: managedBy })=>/*#__PURE__*/ (0, $jVTBW.jsx)($466e60c6ecb152c2$var$Container, {
        "data-testid": testId
    }, managedBy && /*#__PURE__*/ (0, $jVTBW.jsx)($466e60c6ecb152c2$var$ManagedBy, null, /*#__PURE__*/ (0, $jVTBW.jsx)($466e60c6ecb152c2$var$PersonIconWrapper, null, /*#__PURE__*/ (0, $jVTBW.jsx)((0, $ea5c7b081e16dc39$export$7dcc8f518762622d), {
        label: "",
        size: "small"
    })), /*#__PURE__*/ (0, $jVTBW.jsx)((0, $55TWT.default), {
        id: "identity.account-menu.account-menu-details.managed-account",
        defaultMessage: "This account is managed by <b>{managedBy}</b>",
        description: "Label showing the user which organisation manages their Atlassian account",
        values: {
            b: (text)=>/*#__PURE__*/ (0, $jVTBW.jsx)("strong", null, text),
            managedBy: managedBy
        }
    })), /*#__PURE__*/ (0, $jVTBW.jsx)($466e60c6ecb152c2$var$Content, {
        hasHeader: !!managedBy
    }, /*#__PURE__*/ (0, $jVTBW.jsx)($466e60c6ecb152c2$var$Profile, {
        testId: testId,
        name: name,
        picture: picture,
        email: email
    })));
const $466e60c6ecb152c2$var$Container = (0, $ku6eE.default).section({
    display: "flex",
    flexDirection: "column",
    margin: `0 ${(0, $6W4m7.gridSize)()}px`
});
const $466e60c6ecb152c2$var$ManagedBy = (0, $ku6eE.default).small({
    display: "box",
    margin: "0px",
    padding: `${(0, $6W4m7.gridSize)() / 4}px ${(0, $6W4m7.gridSize)()}px`,
    textAlign: "center",
    borderRadius: `${(0, $6W4m7.borderRadius)()}px ${(0, $6W4m7.borderRadius)()}px 0 0`,
    background: (0, $gbKg7.default)("color.background.information", (0, $5MUVm.B50)),
    color: (0, $gbKg7.default)("color.text.subtle", "#44546F")
});
const $466e60c6ecb152c2$var$PersonIconWrapper = (0, $ku6eE.default).span({
    marginRight: `${(0, $6W4m7.gridSize)() / 2}px`,
    "& > span": {
        width: "12px",
        height: "12px"
    }
});
const $466e60c6ecb152c2$var$Content = (0, $ku6eE.default).div({
    display: "flex",
    flexDirection: "column",
    background: (0, $gbKg7.default)("elevation.surface.sunken", (0, $5MUVm.N20A))
}, ({ hasHeader: hasHeader })=>({
        borderRadius: hasHeader ? `0 0 ${(0, $6W4m7.borderRadius)()}px ${(0, $6W4m7.borderRadius)()}px` : `${(0, $6W4m7.borderRadius)()}px`
    }));
const $466e60c6ecb152c2$var$Profile = ({ name: name, email: email, picture: picture, testId: testId })=>/*#__PURE__*/ (0, $jVTBW.jsx)($466e60c6ecb152c2$var$ProfileWrapper, null, /*#__PURE__*/ (0, $jVTBW.jsx)((0, $6c069d3299adfc83$export$2d75367b6e042d67), {
        src: picture,
        size: (0, $6W4m7.gridSize)() * 8,
        testId: testId && `${testId}--picture`
    }), /*#__PURE__*/ (0, $jVTBW.jsx)($466e60c6ecb152c2$var$NameAndEmail, null, /*#__PURE__*/ (0, $jVTBW.jsx)($466e60c6ecb152c2$var$DisplayName, {
        "data-testid": testId && `${testId}--name`
    }, name || /*#__PURE__*/ (0, $jVTBW.jsx)((0, $5acc807c7a983516$export$cb6ddd830302c2a8), {
        length: "6em"
    })), /*#__PURE__*/ (0, $jVTBW.jsx)($466e60c6ecb152c2$var$EmailAddress, {
        "data-testid": testId && `${testId}--email`
    }, email || /*#__PURE__*/ (0, $jVTBW.jsx)((0, $5acc807c7a983516$export$cb6ddd830302c2a8), {
        length: "10em"
    }))));
const $466e60c6ecb152c2$var$ProfileWrapper = (0, $ku6eE.default).div({
    display: "flex",
    flexDirection: "row",
    margin: `${(0, $6W4m7.gridSize)() * 2}px ${(0, $6W4m7.gridSize)() * 2}px`
});
const $466e60c6ecb152c2$var$NameAndEmail = (0, $ku6eE.default).div({
    display: "flex",
    flexDirection: "column",
    margin: `auto 0 auto ${(0, $6W4m7.gridSize)() * 2}px`
});
const $466e60c6ecb152c2$var$DisplayName = (0, $ku6eE.default).h3({
    color: (0, $gbKg7.default)("color.text", (0, $5MUVm.N800)),
    margin: 0
});
const $466e60c6ecb152c2$var$EmailAddress = (0, $ku6eE.default).p({
    marginTop: `${(0, $6W4m7.gridSize)() / 4}px`,
    color: (0, $gbKg7.default)("color.text.subtlest", "#626F86"),
    fontWeight: 400
});



var $bibO8 = parcelRequire("bibO8");
parcelRequire("dAx5m");

var $9eGJl = parcelRequire("9eGJl");
const $c53c0b5d2865bb49$var$PeopleGlyph = (props)=>/*#__PURE__*/ (0, $bibO8.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        ...props,
        children: /*#__PURE__*/ (0, $bibO8.jsx)("path", {
            fill: "currentColor",
            d: "M10.523 11.3a4.5 4.5 0 0 1 4.5 4.5v2.5a2 2 0 0 1-2 2h-8a2 2 0 0 1-2-2v-2.5a4.5 4.5 0 0 1 4.5-4.5h3Zm6 0 .212.005a4.5 4.5 0 0 1 4.283 4.277l.005.218v2.5l-.005.15a2 2 0 0 1-1.838 1.844l-.157.006h-2l-.116-.007a1 1 0 0 1 0-1.986l.116-.007h2v-2.5l-.005-.165a2.5 2.5 0 0 0-2.33-2.33l-.165-.005h-.5l-.116-.007a1 1 0 0 1 0-1.986l.116-.007h.5Zm-6 2h-3a2.5 2.5 0 0 0-2.5 2.5v2.5h8v-2.5a2.5 2.5 0 0 0-2.5-2.5Zm-1.5-10a3.5 3.5 0 1 1 0 7 3.5 3.5 0 0 1 0-7Zm4.61.294a3.5 3.5 0 1 1 0 6.412 1 1 0 0 1 .694-1.872l.24.09a1.5 1.5 0 1 0 .012-2.852l-.252.094a1 1 0 0 1-.693-1.872ZM9.024 5.3a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Z"
        })
    });
function $c53c0b5d2865bb49$export$a0096b57009ecc7c(props) {
    return /*#__PURE__*/ (0, $bibO8.jsx)((0, $9eGJl.default), {
        ...props,
        glyph: $c53c0b5d2865bb49$var$PeopleGlyph
    });
}




var $bibO8 = parcelRequire("bibO8");
parcelRequire("dAx5m");

var $9eGJl = parcelRequire("9eGJl");
const $faef1547b2aa8867$export$1baa85ec8ca55263 = (props)=>/*#__PURE__*/ (0, $bibO8.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        ...props,
        children: /*#__PURE__*/ (0, $bibO8.jsx)("path", {
            fill: "currentColor",
            d: "m6.023 4.3-.149.005A2 2 0 0 0 4.024 6.3v12l.005.15a2 2 0 0 0 1.994 1.85h5l.117-.007a1 1 0 0 0-.117-1.993h-5v-12h5l.117-.007a1 1 0 0 0-.117-1.993h-5Zm9.293 4.293a1 1 0 0 0-.083 1.32l.084.094 1.292 1.292H9.023a1 1 0 0 0-.125 1.993l.125.008 7.586-.001-1.293 1.294a1 1 0 0 0-.083 1.32l.084.094a1 1 0 0 0 1.32.083l.094-.083 2.974-2.975c.096-.09.175-.198.23-.32l.011-.028a.757.757 0 0 0 .031-.083l.008-.027a.767.767 0 0 0 .02-.08l.007-.042a.767.767 0 0 0 .011-.133v-.039c0-.024-.002-.05-.004-.074l.004.094a1 1 0 0 0-.022-.215l-.008-.031a.807.807 0 0 0-.021-.074l-.018-.046a.64.64 0 0 0-.025-.062l-.019-.035a.64.64 0 0 0-.049-.083.667.667 0 0 0-.047-.07l-.084-.093-3-2.998a1 1 0 0 0-1.414 0Z"
        })
    });
function $faef1547b2aa8867$export$5bb2595dc31bfece(props) {
    return /*#__PURE__*/ (0, $bibO8.jsx)((0, $9eGJl.default), {
        ...props,
        glyph: $faef1547b2aa8867$export$1baa85ec8ca55263
    });
}



var $bibO8 = parcelRequire("bibO8");
parcelRequire("dAx5m");

var $ku6eE = parcelRequire("ku6eE");

var $lKhJJ = parcelRequire("lKhJJ");
var $55TWT = parcelRequire("55TWT");

var $757qr = parcelRequire("757qr");
var $ikNYA = parcelRequire("ikNYA");

var $3hVkQ = parcelRequire("3hVkQ");

var $gd5aU = parcelRequire("gd5aU");

var $dAx5m = parcelRequire("dAx5m");

var $Bb0he = parcelRequire("Bb0he");

var $kdvLB = parcelRequire("kdvLB");

var $hSAXR = parcelRequire("hSAXR");

var $dAx5m = parcelRequire("dAx5m");
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $dAx5m = parcelRequire("dAx5m");

var $jVTBW = parcelRequire("jVTBW");

var $3YsxU = parcelRequire("3YsxU");

var $7popc = parcelRequire("7popc");
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
var $bdef65a00a03cab1$var$svgStyles = (0, $jVTBW.css)((0, $7popc.commonSVGStyles));
/**
 * __SVG__
 *
 * An icon is used as a visual representation of common actions and commands to provide context.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-svgs)
 */ var $bdef65a00a03cab1$var$SVG = /*#__PURE__*/ (0, $dAx5m.memo)(function SVG(_ref) {
    var _ref$size = _ref.size, size = _ref$size === void 0 ? "medium" : _ref$size, label = _ref.label, _ref$primaryColor = _ref.primaryColor, primaryColor = _ref$primaryColor === void 0 ? "currentColor" : _ref$primaryColor, secondaryColor = _ref.secondaryColor, testId = _ref.testId, children = _ref.children;
    return (0, $jVTBW.jsx)("svg", {
        viewBox: "0 0 24 24",
        style: {
            color: primaryColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            fill: secondaryColor || (0, $3YsxU.getBackground)()
        },
        css: [
            $bdef65a00a03cab1$var$svgStyles,
            (0, $7popc.sizeStyleMap)[size]
        ],
        "data-testid": testId,
        "aria-label": label || undefined,
        role: label ? "img" : "presentation"
    }, children);
});
var $bdef65a00a03cab1$export$2e2bcd8739ae039 = $bdef65a00a03cab1$var$SVG;


var $2d8418110bfa5a4f$var$_ref, $2d8418110bfa5a4f$var$_process, $2d8418110bfa5a4f$var$_process2;
// We can't rely on NODE_ENV === 'test' if its value is already configured by the consumer to some other value, so better to use JEST_WORKER_ID
// https://jestjs.io/docs/environment-variables#jest_worker_id
var $2d8418110bfa5a4f$var$TESTS_MODE = ($2d8418110bfa5a4f$var$_ref = (globalThis === null || globalThis === void 0 || ($2d8418110bfa5a4f$var$_process = globalThis.process) === null || $2d8418110bfa5a4f$var$_process === void 0 || ($2d8418110bfa5a4f$var$_process = $2d8418110bfa5a4f$var$_process.env) === null || $2d8418110bfa5a4f$var$_process === void 0 ? void 0 : $2d8418110bfa5a4f$var$_process.JEST_WORKER_ID) !== undefined, $2d8418110bfa5a4f$var$_ref !== void 0) ? $2d8418110bfa5a4f$var$_ref : false;
var $2d8418110bfa5a4f$var$DEBUG_MODE = !$2d8418110bfa5a4f$var$TESTS_MODE && (globalThis === null || globalThis === void 0 || ($2d8418110bfa5a4f$var$_process2 = globalThis.process) === null || $2d8418110bfa5a4f$var$_process2 === void 0 || ($2d8418110bfa5a4f$var$_process2 = $2d8418110bfa5a4f$var$_process2.env) === null || $2d8418110bfa5a4f$var$_process2 === void 0 ? void 0 : $2d8418110bfa5a4f$var$_process2.NODE_ENV) !== "production";
var $2d8418110bfa5a4f$export$1c9f709888824e05 = function debug() {
    var _console;
    if (!$2d8418110bfa5a4f$var$DEBUG_MODE) return;
    // eslint-disable-next-line no-console
    (_console = console).debug.apply(_console, arguments);
};



var $ahJoN = parcelRequire("ahJoN");
var $51f7d9836c4afa7f$var$pkgName = "@atlaskit/platform-feature-flags";
var $51f7d9836c4afa7f$export$7e41b1b2bdee3f98 = "__PLATFORM_FEATURE_FLAGS__";
var $51f7d9836c4afa7f$var$hasProcessEnv = typeof $ahJoN !== "undefined" && typeof $ahJoN.env !== "undefined";
// FF global overrides can be configured by test runners or Storybook
var $51f7d9836c4afa7f$var$ENV_ENABLE_PLATFORM_FF = $51f7d9836c4afa7f$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
// STORYBOOK_ENABLE_PLATFORM_FF is included as storybook only allows env vars prefixed with STORYBOOK
// https://github.com/storybookjs/storybook/issues/12270
var $51f7d9836c4afa7f$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF = $51f7d9836c4afa7f$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
var $51f7d9836c4afa7f$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE = $51f7d9836c4afa7f$var$ENV_ENABLE_PLATFORM_FF || $51f7d9836c4afa7f$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF;
var $51f7d9836c4afa7f$var$DEFAULT_PFF_GLOBAL = {
    // In development mode we want to capture any feature flag checks that happen using the default resolver and log this result when the resolver is replaced.
    // This is because evaluating feature flags when the resolver/FF client is loaded asynchronously could cause unexpected issues.
    earlyResolvedFlags: new Map(),
    booleanResolver: function booleanResolver(flagKey) {
        var unresolvedFlagCount;
        return false;
    }
};
var $51f7d9836c4afa7f$var$globalVar = typeof window !== "undefined" ? window : globalThis;
$51f7d9836c4afa7f$var$globalVar[$51f7d9836c4afa7f$export$7e41b1b2bdee3f98] = $51f7d9836c4afa7f$var$globalVar[$51f7d9836c4afa7f$export$7e41b1b2bdee3f98] || $51f7d9836c4afa7f$var$DEFAULT_PFF_GLOBAL;
function $51f7d9836c4afa7f$export$f2b591175b3e424c(resolver) {
    $51f7d9836c4afa7f$var$globalVar[$51f7d9836c4afa7f$export$7e41b1b2bdee3f98].booleanResolver = resolver;
    var _globalVar$PFF_GLOBAL;
}
function $51f7d9836c4afa7f$export$6333b6aff9fc6275(flagKey) {
    if ($51f7d9836c4afa7f$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE) {
        (0, $2d8418110bfa5a4f$export$1c9f709888824e05)('[%s]: The feature flags were enabled while running tests. The flag "%s" will be always enabled.', $51f7d9836c4afa7f$var$pkgName, flagKey);
        return true;
    }
    try {
        var _globalVar$PFF_GLOBAL2;
        var result = (_globalVar$PFF_GLOBAL2 = $51f7d9836c4afa7f$var$globalVar[$51f7d9836c4afa7f$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL2 === void 0 ? void 0 : _globalVar$PFF_GLOBAL2.booleanResolver(flagKey);
        if (typeof result !== "boolean") {
            // eslint-disable-next-line no-console
            console.warn("".concat(flagKey, " resolved to a non-boolean value, returning false for safety"));
            return false;
        }
        return result;
    } catch (e) {
        return false;
    }
}


function $1616e43873c1ac84$export$ba05d765b8392e5e(flagResolver) {
    (0, $51f7d9836c4afa7f$export$f2b591175b3e424c)(flagResolver);
}
function $1616e43873c1ac84$export$470e5c2be1411c89(name) {
    return (0, $51f7d9836c4afa7f$export$6333b6aff9fc6275)(name);
}
function $1616e43873c1ac84$export$b40ec24ac8275656(name) {
    return (0, $51f7d9836c4afa7f$export$6333b6aff9fc6275)(name);
}



var $d0MiN = parcelRequire("d0MiN");
/**
 * __Radio icon__
 *
 * Used to visually represent the selected state in DropdownItemRadio
 *
 * @internal
 */ var $1366631b77da946c$var$RadioIcon = function RadioIcon(_ref) {
    var checked = _ref.checked;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $bdef65a00a03cab1$export$2e2bcd8739ae039), {
        label: "",
        size: "medium",
        primaryColor: checked ? "var(--ds-background-selected-bold, ".concat((0, $d0MiN.B400), ")") : "var(--ds-background-input, ".concat((0, $d0MiN.N10), ")"),
        secondaryColor: checked ? "var(--ds-icon-inverse, ".concat((0, $d0MiN.N10), ")") : "transparent"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement("g", {
        fillRule: "evenodd"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement("circle", {
        fill: "currentColor",
        cx: "12",
        cy: "12",
        r: "6",
        stroke: checked ? "var(--ds-border-selected, ".concat((0, $d0MiN.B400), ")") : "var(--ds-border-input, ".concat((0, $1616e43873c1ac84$export$470e5c2be1411c89)("platform.design-system-team.border-checkbox_nyoiu") ? (0, $d0MiN.N100) : (0, $d0MiN.N40), ")"),
        strokeWidth: (0, $1616e43873c1ac84$export$470e5c2be1411c89)("platform.design-system-team.update-input-border-wdith_5abwv") ? 1 : 2
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement("circle", {
        fill: "inherit",
        cx: "12",
        cy: "12",
        r: "2"
    })));
};
var $1366631b77da946c$export$2e2bcd8739ae039 = $1366631b77da946c$var$RadioIcon;



var $iriaf = parcelRequire("iriaf");

var $3hVkQ = parcelRequire("3hVkQ");

var $dAx5m = parcelRequire("dAx5m");

var $ikNYA = parcelRequire("ikNYA");

var $iriaf = parcelRequire("iriaf");

var $3hVkQ = parcelRequire("3hVkQ");

var $gd5aU = parcelRequire("gd5aU");

var $dAx5m = parcelRequire("dAx5m");

var $Bb0he = parcelRequire("Bb0he");

var $alMln = parcelRequire("alMln");

var $eCFGt = parcelRequire("eCFGt");

var $iriaf = parcelRequire("iriaf");
function $201760010aaa9cdc$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $201760010aaa9cdc$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $201760010aaa9cdc$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($iriaf)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $201760010aaa9cdc$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $201760010aaa9cdc$var$resetOptionsInGroup = function resetOptionsInGroup(group) {
    return Object.keys(group || {}).reduce(function(accumulator, current) {
        return $201760010aaa9cdc$var$_objectSpread($201760010aaa9cdc$var$_objectSpread({}, accumulator), {}, (0, (/*@__PURE__*/$parcel$interopDefault($iriaf)))({}, current, typeof group[current] === "undefined" ? undefined : false));
    }, {});
};
var $201760010aaa9cdc$export$2e2bcd8739ae039 = $201760010aaa9cdc$var$resetOptionsInGroup;


var $3f59c74a8e21c2c5$var$_excluded = [
    "children",
    "hasSeparator",
    "id",
    "isList",
    "isScrollable",
    "overrides",
    "testId",
    "title"
];
function $3f59c74a8e21c2c5$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $3f59c74a8e21c2c5$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $3f59c74a8e21c2c5$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($iriaf)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $3f59c74a8e21c2c5$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $3f59c74a8e21c2c5$export$a79eda4ff50e30b6 = /*#__PURE__*/ (0, $dAx5m.createContext)({
    id: "",
    radioGroupState: {},
    selectRadioItem: (0, $Bb0he.default)
});
/**
 * __Dropdown item radio group__
 *  Store which manages the selection state for each DropdownItemRadio
 *  across mount and unmounts.
 *
 */ var $3f59c74a8e21c2c5$var$DropdownItemRadioGroup = function DropdownItemRadioGroup(_ref) {
    var children = _ref.children, hasSeparator = _ref.hasSeparator, id = _ref.id, isList = _ref.isList, isScrollable = _ref.isScrollable, overrides = _ref.overrides, testId = _ref.testId, title = _ref.title, rest = (0, (/*@__PURE__*/$parcel$interopDefault($gd5aU)))(_ref, $3f59c74a8e21c2c5$var$_excluded);
    var _useContext = (0, $dAx5m.useContext)((0, $eCFGt.SelectionStoreContext)), setGroupState = _useContext.setGroupState, getGroupState = _useContext.getGroupState;
    /**
   *  - initially `radioGroupState` is from selection store, so it's safe to update without re-rendering
   *  - we flush a render by updating this local radio group state
   */ var _useState = (0, $dAx5m.useState)(function() {
        return getGroupState(id);
    }), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($3hVkQ)))(_useState, 2), radioGroupState = _useState2[0], setRadioGroupState = _useState2[1];
    var selectRadioItem = function selectRadioItem(childId, value) {
        var newValue = $3f59c74a8e21c2c5$var$_objectSpread($3f59c74a8e21c2c5$var$_objectSpread({}, (0, $201760010aaa9cdc$export$2e2bcd8739ae039)(getGroupState(id))), {}, (0, (/*@__PURE__*/$parcel$interopDefault($iriaf)))({}, childId, value));
        setRadioGroupState(newValue);
        setGroupState(id, newValue);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement($3f59c74a8e21c2c5$export$a79eda4ff50e30b6.Provider, {
        value: {
            id: id,
            radioGroupState: radioGroupState,
            selectRadioItem: selectRadioItem
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $alMln.default), (0, (/*@__PURE__*/$parcel$interopDefault($ikNYA)))({
        hasSeparator: hasSeparator,
        id: id,
        isList: isList,
        isScrollable: isScrollable,
        overrides: overrides,
        testId: testId,
        title: title
    }, rest), children));
};
var $3f59c74a8e21c2c5$export$2e2bcd8739ae039 = $3f59c74a8e21c2c5$var$DropdownItemRadioGroup;



var $eCFGt = parcelRequire("eCFGt");

function $3c2d3d464e2119e0$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $3c2d3d464e2119e0$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $3c2d3d464e2119e0$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($iriaf)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $3c2d3d464e2119e0$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $3c2d3d464e2119e0$var$useRadioState(_ref) {
    var id = _ref.id, isSelected = _ref.isSelected, defaultSelected = _ref.defaultSelected;
    var _useContext = (0, $dAx5m.useContext)((0, $eCFGt.SelectionStoreContext)), setGroupState = _useContext.setGroupState, getGroupState = _useContext.getGroupState;
    var _useContext2 = (0, $dAx5m.useContext)((0, $3f59c74a8e21c2c5$export$a79eda4ff50e30b6)), group = _useContext2.id, radioGroupState = _useContext2.radioGroupState, selectRadioItem = _useContext2.selectRadioItem;
    var persistedIsSelected = radioGroupState[id];
    var _useState = (0, $dAx5m.useState)(function() {
        return persistedIsSelected !== undefined ? persistedIsSelected : defaultSelected || false;
    }), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($3hVkQ)))(_useState, 2), localIsSelected = _useState2[0], setLocalIsSelected = _useState2[1];
    var setLocalState = (0, $dAx5m.useCallback)(function(newValue) {
        if (!persistedIsSelected) {
            var nextValue = newValue(persistedIsSelected);
            selectRadioItem(id, nextValue);
            setLocalIsSelected(nextValue);
        }
    }, [
        persistedIsSelected,
        id,
        selectRadioItem
    ]);
    /**
   * - radio state changes any time a radio child is changed
   * - when it changes we want all radio buttons to update their local state
   * - it takes the value from radio group state and applies it locally if it exists which it will only exist, if it is selected
   */ (0, $dAx5m.useEffect)(function() {
        setLocalIsSelected(function() {
            var existing = radioGroupState[id];
            return existing !== undefined ? existing : defaultSelected || false;
        });
    }, [
        radioGroupState,
        group,
        id,
        defaultSelected
    ]);
    if (typeof isSelected === "boolean") return [
        isSelected,
        function() {
            return false;
        }
    ];
    if (persistedIsSelected === undefined) {
        var existing = getGroupState(group);
        setGroupState(group, $3c2d3d464e2119e0$var$_objectSpread($3c2d3d464e2119e0$var$_objectSpread({}, (0, $201760010aaa9cdc$export$2e2bcd8739ae039)(existing || {})), {}, (0, (/*@__PURE__*/$parcel$interopDefault($iriaf)))({}, id, defaultSelected || false)));
    }
    return [
        localIsSelected,
        setLocalState
    ];
}
var $3c2d3d464e2119e0$export$2e2bcd8739ae039 = $3c2d3d464e2119e0$var$useRadioState;



var $6XugO = parcelRequire("6XugO");
var $5e1b963b93606915$var$canUseDOM = function canUseDOM() {
    return Boolean(typeof window !== "undefined" && window.document && window.document.createElement);
};
/*
 * Making sure we can fallback to browsers doesn't support voice over -
 * we would using menuitemcheckbox / menuitemradio for these that supports voice over, and
 * will fallback to checkbox / radio for these doesn't
 */ var $5e1b963b93606915$var$isVoiceOverSupported = function isVoiceOverSupported() {
    return /Mac OS X/.test($5e1b963b93606915$var$canUseDOM() ? navigator.userAgent : "");
};
var $5e1b963b93606915$export$2e2bcd8739ae039 = $5e1b963b93606915$var$isVoiceOverSupported;



var $ahJoN = parcelRequire("ahJoN");
var $be82474aed2d1355$var$_excluded = [
    "children",
    "defaultSelected",
    "testId",
    "id",
    "title",
    "description",
    "isDisabled",
    "isSelected",
    "onClick",
    "shouldDescriptionWrap",
    "shouldTitleWrap"
];
/**
 * __Dropdown item radio__
 *
 * A dropdown item radio displays groups that have a single selection.
 *
 * - [Examples](https://atlassian.design/components/dropdown-menu/dropdown-item-radio/examples)
 * - [Code](https://atlassian.design/components/dropdown-menu/dropdown-item-radio/code)
 * - [Usage](https://atlassian.design/components/dropdown-menu/dropdown-item-radio/usage)
 */ var $be82474aed2d1355$var$DropdownItemRadio = function DropdownItemRadio(_ref) {
    var children = _ref.children, defaultSelected = _ref.defaultSelected, testId = _ref.testId, id = _ref.id, title = _ref.title, description = _ref.description, isDisabled = _ref.isDisabled, isSelected = _ref.isSelected, _ref$onClick = _ref.onClick, providedOnClick = _ref$onClick === void 0 ? (0, $Bb0he.default) : _ref$onClick, _ref$shouldDescriptio = _ref.shouldDescriptionWrap, shouldDescriptionWrap = _ref$shouldDescriptio === void 0 ? true : _ref$shouldDescriptio, _ref$shouldTitleWrap = _ref.shouldTitleWrap, shouldTitleWrap = _ref$shouldTitleWrap === void 0 ? true : _ref$shouldTitleWrap, rest = (0, (/*@__PURE__*/$parcel$interopDefault($gd5aU)))(_ref, $be82474aed2d1355$var$_excluded);
    typeof $ahJoN;
    var _useRadioState = (0, $3c2d3d464e2119e0$export$2e2bcd8739ae039)({
        id: id,
        isSelected: isSelected,
        defaultSelected: defaultSelected
    }), _useRadioState2 = (0, (/*@__PURE__*/$parcel$interopDefault($3hVkQ)))(_useRadioState, 2), selected = _useRadioState2[0], setSelected = _useRadioState2[1];
    var onClickHandler = (0, $dAx5m.useCallback)(function(event) {
        setSelected(function(selected) {
            return !selected;
        });
        providedOnClick(event);
    }, [
        providedOnClick,
        setSelected
    ]);
    var itemRef = (0, $6XugO.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $kdvLB.SELECTION_STYLE_CONTEXT_DO_NOT_USE).Provider, {
        value: "none"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $hSAXR.default), (0, (/*@__PURE__*/$parcel$interopDefault($ikNYA)))({
        "aria-checked": selected,
        description: description,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $1366631b77da946c$export$2e2bcd8739ae039), {
            checked: selected
        }),
        id: id,
        isDisabled: isDisabled,
        isSelected: selected,
        onClick: onClickHandler,
        ref: itemRef,
        role: (0, $5e1b963b93606915$export$2e2bcd8739ae039)() ? "radio" : "menuitemradio",
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        testId: testId,
        title: title
    }, rest), children));
};
var $be82474aed2d1355$export$2e2bcd8739ae039 = $be82474aed2d1355$var$DropdownItemRadio;


var $2c7dbe478dcc248f$exports = {};
"use strict";
Object.defineProperty($2c7dbe478dcc248f$exports, "__esModule", {
    value: true
});
$2c7dbe478dcc248f$exports.default = void 0;

var $2c7dbe478dcc248f$var$_react = $2c7dbe478dcc248f$var$_interopRequireDefault((parcelRequire("dAx5m")));

var $9eGJl = parcelRequire("9eGJl");
function $2c7dbe478dcc248f$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $2c7dbe478dcc248f$var$ChevronRightIcon = (props)=>/*#__PURE__*/ $2c7dbe478dcc248f$var$_react.default.createElement($9eGJl.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path d="M10.294 9.698a.988.988 0 010-1.407 1.01 1.01 0 011.419 0l2.965 2.94a1.09 1.09 0 010 1.548l-2.955 2.93a1.01 1.01 0 01-1.42 0 .988.988 0 010-1.407l2.318-2.297-2.327-2.307z" fill="currentColor" fill-rule="evenodd"/></svg>`
    }, props));
$2c7dbe478dcc248f$var$ChevronRightIcon.displayName = "ChevronRightIcon";
var $2c7dbe478dcc248f$var$_default = $2c7dbe478dcc248f$var$ChevronRightIcon;
$2c7dbe478dcc248f$exports.default = $2c7dbe478dcc248f$var$_default;



var $hSAXR = parcelRequire("hSAXR");

var $gbKg7 = parcelRequire("gbKg7");

var $bibO8 = parcelRequire("bibO8");
parcelRequire("dAx5m");

var $9eGJl = parcelRequire("9eGJl");
const $6d0d0cee2cb2d0f8$export$b00f7078b5893403 = (props)=>/*#__PURE__*/ (0, $bibO8.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        ...props,
        children: /*#__PURE__*/ (0, $bibO8.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M12 20V4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20ZM12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z",
            fill: "currentColor"
        })
    });
function $6d0d0cee2cb2d0f8$export$e905b311491f0211(props) {
    return /*#__PURE__*/ (0, $bibO8.jsx)((0, $9eGJl.default), {
        ...props,
        glyph: $6d0d0cee2cb2d0f8$export$b00f7078b5893403
    });
}


var $883d5e42137d15c3$exports = {};
$883d5e42137d15c3$exports = new URL("dark-mode.5b7c09da.svg", import.meta.url).toString();


var $56ed1ff90069d93d$exports = {};
$56ed1ff90069d93d$exports = new URL("light-mode.7f9eeb32.svg", import.meta.url).toString();


var $2051043211d10a95$exports = {};
$2051043211d10a95$exports = new URL("match-browser.cf8cedaf.svg", import.meta.url).toString();


const $39f4a87105c8386f$export$9d63163ee2173b37 = ({ testId: testId, onThemeChange: onThemeChange, currentTheme: currentTheme })=>{
    return /*#__PURE__*/ (0, $bibO8.jsx)((0, $757qr.default), {
        testId: testId,
        placement: "auto-start",
        trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ (0, $bibO8.jsx)((0, $hSAXR.default), {
                ref: triggerRef,
                onClick: (event)=>event.stopPropagation(),
                iconBefore: /*#__PURE__*/ (0, $bibO8.jsx)((0, $6d0d0cee2cb2d0f8$export$e905b311491f0211), {
                    label: ""
                }),
                iconAfter: /*#__PURE__*/ (0, $bibO8.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2c7dbe478dcc248f$exports))), {
                    label: ""
                }),
                ...props,
                children: /*#__PURE__*/ (0, $bibO8.jsx)((0, $55TWT.default), {
                    id: "identity.account-menu.theme-switcher.theme-button",
                    defaultMessage: "Theme",
                    description: "Label for button in the account menu to switch to a different theme"
                })
            }),
        children: $39f4a87105c8386f$var$themeOptions.map(({ label: label, value: value, thumbnail: thumbnail })=>/*#__PURE__*/ (0, $bibO8.jsx)((0, $be82474aed2d1355$export$2e2bcd8739ae039), {
                testId: `${testId}--radio-${value}`,
                id: value,
                onClick: ()=>onThemeChange(value),
                isSelected: currentTheme === value,
                children: /*#__PURE__*/ (0, $bibO8.jsxs)($39f4a87105c8386f$var$RadioLabelContainer, {
                    children: [
                        /*#__PURE__*/ (0, $bibO8.jsx)("img", {
                            src: thumbnail,
                            width: 64,
                            height: 48,
                            alt: ""
                        }),
                        label
                    ]
                })
            }, value))
    });
};
const $39f4a87105c8386f$var$RadioLabelContainer = (0, $ku6eE.default).div({
    display: "flex",
    alignItems: "center",
    gap: (0, $gbKg7.default)("space.150", "12px")
});
const $39f4a87105c8386f$var$messages = (0, $lKhJJ.defineMessages)({
    light: {
        id: "identity.account-menu.theme-switcher.light.option",
        defaultMessage: "Light",
        description: "Label for the theme switcher light option"
    },
    dark: {
        id: "identity.account-menu.theme-switcher.dark.option",
        defaultMessage: "Dark",
        description: "Label for the theme switcher dark option"
    },
    matchBrowser: {
        id: "identity.account-menu.theme-switcher.match-browser.option",
        defaultMessage: "Match browser",
        description: "Label for the theme switcher match browser option"
    }
});
const $39f4a87105c8386f$var$themeOptions = [
    {
        label: /*#__PURE__*/ (0, $bibO8.jsx)((0, $55TWT.default), {
            ...$39f4a87105c8386f$var$messages.light
        }),
        value: "light",
        thumbnail: (0, (/*@__PURE__*/$parcel$interopDefault($56ed1ff90069d93d$exports)))
    },
    {
        label: /*#__PURE__*/ (0, $bibO8.jsx)((0, $55TWT.default), {
            ...$39f4a87105c8386f$var$messages.dark
        }),
        value: "dark",
        thumbnail: (0, (/*@__PURE__*/$parcel$interopDefault($883d5e42137d15c3$exports)))
    },
    {
        label: /*#__PURE__*/ (0, $bibO8.jsx)((0, $55TWT.default), {
            ...$39f4a87105c8386f$var$messages.matchBrowser
        }),
        value: "auto",
        thumbnail: (0, (/*@__PURE__*/$parcel$interopDefault($2051043211d10a95$exports)))
    }
];


const $c06b25ec57762796$export$49c2771125e1e9f1 = ({ testId: testId, closePopup: closePopup, name: name, picture: picture, email: email, managedBy: managedBy, manageProfileLink: manageProfileLink, viewProfileLink: viewProfileLink, onViewProfileClick: onViewProfileClick, switchAccountLink: switchAccountLink, getAccountSwitchLink: getAccountSwitchLink, logOutLink: logOutLink, onThemeChange: onThemeChange, currentTheme: currentTheme, associatedSessions: associatedSessions })=>{
    const themeSwitcherProps = onThemeChange && currentTheme;
    const shouldRenderProfileThemeSwitcherSection = Boolean(viewProfileLink || manageProfileLink || themeSwitcherProps);
    return /*#__PURE__*/ (0, $jVTBW.jsx)($c06b25ec57762796$var$Container, {
        "data-testid": testId
    }, /*#__PURE__*/ (0, $jVTBW.jsx)((0, $10AFn.default), null, /*#__PURE__*/ (0, $jVTBW.jsx)((0, $alMln.default), null, /*#__PURE__*/ (0, $jVTBW.jsx)((0, $466e60c6ecb152c2$export$66e04d0aacdb3b2), {
        testId: testId && `${testId}--details`,
        name: name,
        picture: picture,
        email: email,
        managedBy: managedBy
    })), shouldRenderProfileThemeSwitcherSection && /*#__PURE__*/ (0, $jVTBW.jsx)((0, $alMln.default), null, viewProfileLink && /*#__PURE__*/ (0, $jVTBW.jsx)($c06b25ec57762796$var$ViewProfileLink, {
        onClick: onViewProfileClick,
        testId: testId && `${testId}--view-profile`,
        href: viewProfileLink,
        closePopup: closePopup
    }), manageProfileLink && /*#__PURE__*/ (0, $jVTBW.jsx)($c06b25ec57762796$var$ManageProfileLink, {
        testId: testId && `${testId}--manage-profile`,
        href: manageProfileLink,
        closePopup: closePopup
    }), themeSwitcherProps && /*#__PURE__*/ (0, $jVTBW.jsx)((0, $39f4a87105c8386f$export$9d63163ee2173b37), {
        testId: testId && `${testId}--theme-switcher`,
        onThemeChange: onThemeChange,
        currentTheme: currentTheme
    })), associatedSessions && associatedSessions.length > 0 && getAccountSwitchLink && /*#__PURE__*/ (0, $jVTBW.jsx)((0, $alMln.default), {
        hasSeparator: Boolean(viewProfileLink || manageProfileLink),
        title: "Switch Account"
    }, /*#__PURE__*/ (0, $jVTBW.jsx)($c06b25ec57762796$var$InProductSwitchAccountLinks, {
        associatedSessions: associatedSessions,
        getAccountSwitchLink: getAccountSwitchLink
    })), /*#__PURE__*/ (0, $jVTBW.jsx)((0, $alMln.default), {
        hasSeparator: Boolean(shouldRenderProfileThemeSwitcherSection || associatedSessions && associatedSessions.length > 0)
    }, switchAccountLink && (associatedSessions && associatedSessions.length > 0 ? /*#__PURE__*/ (0, $jVTBW.jsx)($c06b25ec57762796$var$AddAccountLink, {
        testId: testId && `${testId}--add-account`,
        href: switchAccountLink,
        closePopup: closePopup
    }) : /*#__PURE__*/ (0, $jVTBW.jsx)($c06b25ec57762796$var$SwitchAccountLink, {
        testId: testId && `${testId}--switch-account`,
        href: switchAccountLink,
        closePopup: closePopup
    })), /*#__PURE__*/ (0, $jVTBW.jsx)($c06b25ec57762796$var$LogOutLink, {
        testId: testId && `${testId}--log-out`,
        href: logOutLink,
        closePopup: closePopup
    }))));
};
const $c06b25ec57762796$var$InProductSwitchAccountLinks = ({ associatedSessions: associatedSessions, getAccountSwitchLink: getAccountSwitchLink })=>{
    return /*#__PURE__*/ (0, $jVTBW.jsx)((0, $dAx5m.Fragment), null, associatedSessions.map((user)=>{
        const url = getAccountSwitchLink(window.location.href, user.email);
        return /*#__PURE__*/ (0, $jVTBW.jsx)((0, $g061O.default), {
            href: url,
            key: user.displayName
        }, /*#__PURE__*/ (0, $jVTBW.jsx)((0, $3e1ac8fecd4bc2b8$export$2e2bcd8739ae039), {
            avatar: /*#__PURE__*/ (0, $jVTBW.jsx)((0, $7H29x.default), {
                src: user.avatarUrl,
                size: "medium"
            }),
            primaryText: user.displayName,
            secondaryText: user.email
        }));
    }));
};
const $c06b25ec57762796$var$AddAccountLink = ({ testId: testId, href: href, closePopup: closePopup })=>/*#__PURE__*/ (0, $jVTBW.jsx)($c06b25ec57762796$var$Link, {
        testId: testId,
        icon: (0, $c53c0b5d2865bb49$export$a0096b57009ecc7c),
        href: href,
        closePopup: closePopup,
        actionSubjectId: "addAccountLink"
    }, /*#__PURE__*/ (0, $jVTBW.jsx)((0, $55TWT.default), {
        id: "identity.account-menu.account-menu-content.add-account-button",
        defaultMessage: "Add account",
        description: "Label for button in account menu to switch to another another account"
    }));
const $c06b25ec57762796$var$Container = (0, $ku6eE.default).div({
    boxSizing: "border-box",
    minWidth: (0, $6W4m7.gridSize)() * 38
});
const $c06b25ec57762796$var$ViewProfileLink = ({ testId: testId, href: href, onClick: onClick, closePopup: closePopup })=>/*#__PURE__*/ (0, $jVTBW.jsx)($c06b25ec57762796$var$Link, {
        testId: testId,
        href: href,
        onClick: onClick,
        icon: (0, $ea5c7b081e16dc39$export$7dcc8f518762622d),
        closePopup: closePopup,
        actionSubjectId: "viewProfileLink"
    }, /*#__PURE__*/ (0, $jVTBW.jsx)((0, $55TWT.default), {
        id: "identity.account-menu.account-details.view-profile-tooltip",
        defaultMessage: "Profile",
        description: "Text shown when hovering over profile information"
    }));
const $c06b25ec57762796$var$ManageProfileLink = ({ testId: testId, href: href, closePopup: closePopup })=>/*#__PURE__*/ (0, $jVTBW.jsx)($c06b25ec57762796$var$Link, {
        testId: testId,
        href: href,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($84f270712ae1e281$exports))),
        closePopup: closePopup,
        actionSubjectId: "manageProfileLink",
        target: "_blank",
        rel: "noopener"
    }, /*#__PURE__*/ (0, $jVTBW.jsx)((0, $55TWT.default), {
        id: "identity.account-menu.account-details.manage-profile-link",
        defaultMessage: "Account settings",
        description: "Text for link to account management page"
    }));
const $c06b25ec57762796$var$SwitchAccountLink = ({ testId: testId, href: href, closePopup: closePopup })=>/*#__PURE__*/ (0, $jVTBW.jsx)($c06b25ec57762796$var$Link, {
        testId: testId,
        icon: (0, $c53c0b5d2865bb49$export$a0096b57009ecc7c),
        href: href,
        closePopup: closePopup,
        actionSubjectId: "switchAccountLink"
    }, /*#__PURE__*/ (0, $jVTBW.jsx)((0, $55TWT.default), {
        id: "identity.account-menu.account-menu-content.switch-account-button",
        defaultMessage: "Switch account",
        description: "Label for button in account menu to switch to another another account"
    }));
const $c06b25ec57762796$var$LogOutLink = ({ testId: testId, href: href, closePopup: closePopup })=>/*#__PURE__*/ (0, $jVTBW.jsx)($c06b25ec57762796$var$Link, {
        testId: testId,
        icon: (0, $faef1547b2aa8867$export$5bb2595dc31bfece),
        href: href,
        closePopup: closePopup,
        actionSubjectId: "logOutLink"
    }, /*#__PURE__*/ (0, $jVTBW.jsx)((0, $55TWT.default), {
        id: "identity.account-menu.account-menu-content.log-out-button",
        defaultMessage: "Log out",
        description: "Label for button in account menu to log out"
    }));
const $c06b25ec57762796$var$Link = ({ testId: testId, closePopup: closePopup, icon: Icon, href: href, onClick: onClick, actionSubjectId: actionSubjectId, children: children, ...props })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $6xDaL.useAnalyticsEvents)();
    const handleClick = (0, $dAx5m.useCallback)((event)=>{
        const analyticsEvent = createAnalyticsEvent({
            eventType: (0, $3FJlW.UI_EVENT_TYPE),
            action: "clicked",
            actionSubject: "menuLinkItem",
            actionSubjectId: actionSubjectId
        });
        const clone = analyticsEvent.clone();
        if (clone) clone.fire((0, $bdef4a5a08f4b14c$export$515664faa1398f37));
        onClick?.(event, analyticsEvent);
        closePopup?.(event);
    }, [
        createAnalyticsEvent,
        onClick,
        closePopup,
        actionSubjectId
    ]);
    return /*#__PURE__*/ (0, $jVTBW.jsx)((0, $g061O.default), {
        testId: testId,
        iconBefore: /*#__PURE__*/ (0, $jVTBW.jsx)(Icon, {
            label: "",
            size: "medium"
        }),
        href: href,
        onClick: handleClick,
        ...props
    }, children);
};



var $bibO8 = parcelRequire("bibO8");
parcelRequire("dAx5m");

var $55TWT = parcelRequire("55TWT");


var $dAx5m = parcelRequire("dAx5m");



var $dAx5m = parcelRequire("dAx5m");

var $fIjLq = parcelRequire("fIjLq");



function $5600f3228a768a6a$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $5600f3228a768a6a$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $5600f3228a768a6a$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($659b468336d903e3$exports)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $5600f3228a768a6a$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $5600f3228a768a6a$export$f32bddcb857301f3 = function getIconButtonTheme(_ref) {
    var iconButton = _ref.mode.iconButton;
    return function(current, props) {
        var _current = current(props), buttonStyles = _current.buttonStyles, spinnerStyles = _current.spinnerStyles;
        return {
            buttonStyles: $5600f3228a768a6a$var$_objectSpread($5600f3228a768a6a$var$_objectSpread($5600f3228a768a6a$var$_objectSpread($5600f3228a768a6a$var$_objectSpread({}, buttonStyles), {}, {
                borderRadius: "var(--ds-border-radius-circle, 100%)",
                display: "flex",
                margin: "0 ".concat("var(--ds-space-025, 2px)"),
                // TODO Delete this comment after verifying space token -> previous value `4`
                padding: "var(--ds-space-050, 4px)",
                height: "auto",
                fontWeight: 500
            }, iconButton.default), {}, {
                ":hover": iconButton.hover,
                ":focus": iconButton.focus,
                // :active doesn't work in FF, because we do a
                // e.preventDefault() on mouse down in Button.
                // '&&' is required to add more CSS specificity
                // && it not a valid CSSObject property
                // @ts-ignore
                "&&": $5600f3228a768a6a$var$_objectSpread({}, props.state === "active" && iconButton.active)
            }, props.state === "selected" && iconButton.selected), {}, {
                "> span": {
                    margin: 0
                }
            }),
            spinnerStyles: spinnerStyles
        };
    };
};


var $3f2c48a613a1b8b8$var$_excluded = [
    "icon",
    "label",
    "testId",
    "tooltip"
];
var $3f2c48a613a1b8b8$export$c25acd513dcc8062 = /*#__PURE__*/ (0, $dAx5m.forwardRef)(function(props, ref) {
    var icon = props.icon, label = props.label, testId = props.testId, tooltip = props.tooltip, buttonProps = (0, (/*@__PURE__*/$parcel$interopDefault($cada364311d44bd0$exports)))(props, $3f2c48a613a1b8b8$var$_excluded);
    var theme = (0, $9afc2d28bb10b801$export$93d4e7f90805808f)();
    var button = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $fIjLq.default), (0, (/*@__PURE__*/$parcel$interopDefault($147dc3434bd55d1d$exports)))({
        appearance: "primary",
        "aria-label": label,
        testId: testId,
        iconBefore: icon,
        ref: ref,
        theme: (0, $5600f3228a768a6a$export$f32bddcb857301f3)(theme)
    }, buttonProps));
    if (tooltip) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $283c3d996293cc99$export$2e2bcd8739ae039), {
        content: tooltip,
        hideTooltipOnClick: true
    }, button);
    return button;
});


var $4d5fcfc07abed2d7$export$5120f2d0b8d4cab8 = /*#__PURE__*/ (0, $dAx5m.forwardRef)(function(props, ref) {
    var labelProp = props.label, tooltip = props.tooltip;
    var label = labelProp || (typeof tooltip === "string" ? tooltip : "Your profile and settings");
    // All other implementations of IconButton within the components are using spread props, so
    // to use explicit props could cause regressions.
    // TODO: Remove these spread props for better static analysis
    // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement("div", {
        role: "listitem"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $3f2c48a613a1b8b8$export$c25acd513dcc8062), (0, (/*@__PURE__*/$parcel$interopDefault($147dc3434bd55d1d$exports)))({
        label: label,
        ref: ref
    }, props)));
});
var // This exists only to extract props.
// eslint-disable-next-line @repo/internal/react/use-noop
$4d5fcfc07abed2d7$export$2e2bcd8739ae039 = function(props) {};




var $bibO8 = parcelRequire("bibO8");
parcelRequire("dAx5m");

var $9eGJl = parcelRequire("9eGJl");
const $ea54f09bff0cae22$export$805c9516e5ba1e65 = (props)=>/*#__PURE__*/ (0, $bibO8.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        ...props,
        children: /*#__PURE__*/ (0, $bibO8.jsx)("path", {
            fill: "currentColor",
            d: "M18.0234 4.29985L18.1727 4.30534C19.2076 4.38169 20.0234 5.24549 20.0234 6.29985V18.2999L20.018 18.4491C19.9416 19.484 19.0778 20.2999 18.0234 20.2999H13.0234L12.9068 20.2931C12.4095 20.2354 12.0234 19.8127 12.0234 19.2999C12.0234 18.7476 12.4712 18.2999 13.0234 18.2999H18.0234V6.29985H13.0234L12.9068 6.29312C12.4095 6.23536 12.0234 5.81269 12.0234 5.29985C12.0234 4.74757 12.4712 4.29985 13.0234 4.29985H18.0234ZM16.0193 12.3935L16.0135 12.4412C16.0104 12.4655 16.006 12.4902 16.0006 12.5148L15.9929 12.5461C15.9872 12.5704 15.9801 12.5951 15.9719 12.6194L15.9543 12.6658C15.9471 12.6865 15.9382 12.7072 15.9286 12.7276C15.922 12.7394 15.9161 12.7512 15.91 12.7629C15.8993 12.7857 15.8866 12.808 15.8729 12.8299C15.8685 12.8348 15.865 12.8402 15.8615 12.8456C15.8473 12.8696 15.831 12.8926 15.8135 12.9151L15.7303 13.0092L12.7303 16.0072C12.3396 16.3976 11.7065 16.3974 11.3161 16.0067C10.9557 15.6461 10.9282 15.0789 11.2334 14.6867L11.3166 14.5925L12.6114 13.2999H5.02344C4.47115 13.2999 4.02344 12.8521 4.02344 12.2999C4.02344 11.79 4.40492 11.3693 4.898 11.3076L5.02344 11.2999H12.6094L11.3161 10.0067C10.9557 9.64611 10.9282 9.07887 11.2334 8.68668L11.3166 8.5925C11.6772 8.23214 12.2444 8.20461 12.6366 8.50976L12.7308 8.59298L15.7046 11.5677C15.801 11.6574 15.8797 11.766 15.9348 11.8876C15.9383 11.8974 15.9424 11.9067 15.9463 11.916C15.9583 11.9428 15.9685 11.9706 15.9774 11.999L15.9846 12.0253C15.9928 12.0515 15.9993 12.0786 16.0047 12.106C16.007 12.1202 16.0094 12.1339 16.0115 12.1476L16.0199 12.215C16.0216 12.2369 16.0227 12.2585 16.0232 12.2802C16.0234 12.2869 16.0234 12.2934 16.0234 12.2999L16.0224 12.3179L16.0193 12.3935Z"
        })
    });
function $ea54f09bff0cae22$export$10cdd1f3e51de455(props) {
    return /*#__PURE__*/ (0, $bibO8.jsx)((0, $9eGJl.default), {
        ...props,
        glyph: $ea54f09bff0cae22$export$805c9516e5ba1e65
    });
}


const $ddce530fd83d1acb$export$904b79312c8d6122 = ({ testId: testId, logInLink: logInLink })=>/*#__PURE__*/ (0, $bibO8.jsx)((0, $4d5fcfc07abed2d7$export$5120f2d0b8d4cab8), {
        testId: testId,
        href: logInLink,
        onClick: (event, analytics)=>{
            analytics.update({
                actionSubjectId: "logInLink"
            }).fire((0, $bdef4a5a08f4b14c$export$515664faa1398f37));
        },
        tooltip: /*#__PURE__*/ (0, $bibO8.jsx)((0, $55TWT.default), {
            id: "identity.account-menu.account-menu-logged-out-state.log-in",
            defaultMessage: "Log in",
            description: "Tooltip for log in button when user is logged out"
        }),
        icon: /*#__PURE__*/ (0, $bibO8.jsx)((0, $ea54f09bff0cae22$export$10cdd1f3e51de455), {
            label: "",
            size: "medium"
        })
    });


/** @jsxRuntime classic */ /** @jsx jsx */ 
var $dAx5m = parcelRequire("dAx5m");

var $jVTBW = parcelRequire("jVTBW");

var $lKhJJ = parcelRequire("lKhJJ");
var $dZHnD = parcelRequire("dZHnD");

var $3FJlW = parcelRequire("3FJlW");

var $dAx5m = parcelRequire("dAx5m");

var $6xDaL = parcelRequire("6xDaL");

var $dAx5m = parcelRequire("dAx5m");
var $add51bff6c8a530b$export$1d27a74659855e44 = function useTrackedRef(value) {
    var ref = (0, $dAx5m.useRef)(value);
    ref.current = value;
    return ref;
};


var $8fd15b0da3dd822b$export$53c2b9c37c40e0d8 = function useCallbackWithAnalytics(method, payload, channel) {
    var _useAnalyticsEvents = (0, $6xDaL.useAnalyticsEvents)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    var methodRef = (0, $add51bff6c8a530b$export$1d27a74659855e44)(method);
    var payloadRef = (0, $add51bff6c8a530b$export$1d27a74659855e44)(payload);
    return (0, $dAx5m.useCallback)(function() {
        var pload = typeof payloadRef.current === "function" ? payloadRef.current.apply(payloadRef, arguments) : payloadRef.current;
        createAnalyticsEvent(pload).fire(channel);
        methodRef.current.apply(methodRef, arguments);
    }, [
        createAnalyticsEvent,
        methodRef,
        payloadRef,
        channel
    ]);
};





var $7vqkt = parcelRequire("7vqkt");

var $6W4m7 = parcelRequire("6W4m7");


const $1ed154f78f293baf$export$473cb05bf335b0e1 = ({ testId: testId, picture: picture, email: email, content: content })=>{
    const [isOpen, setIsOpen] = (0, $dAx5m.useState)(false);
    const close = (0, $8fd15b0da3dd822b$export$53c2b9c37c40e0d8)(()=>setIsOpen(false), {
        eventType: (0, $3FJlW.UI_EVENT_TYPE),
        action: "closed",
        actionSubject: "popup",
        actionSubjectId: "accountMenu"
    }, (0, $bdef4a5a08f4b14c$export$515664faa1398f37));
    const open = (0, $8fd15b0da3dd822b$export$53c2b9c37c40e0d8)(()=>setIsOpen(true), {
        eventType: (0, $3FJlW.UI_EVENT_TYPE),
        action: "opened",
        actionSubject: "popup",
        actionSubjectId: "accountMenu"
    }, (0, $bdef4a5a08f4b14c$export$515664faa1398f37));
    return /*#__PURE__*/ (0, $jVTBW.jsx)((0, $7vqkt.default), {
        isOpen: isOpen,
        onClose: close,
        testId: testId,
        placement: "bottom",
        trigger: (triggerProps)=>/*#__PURE__*/ (0, $jVTBW.jsx)($1ed154f78f293baf$var$AccountMenuTrigger, {
                onClick: isOpen ? close : open,
                testId: testId && `${testId}--trigger`,
                picture: picture,
                email: email,
                ...triggerProps
            }),
        content: content
    });
};
const $1ed154f78f293baf$var$AccountMenuTrigger = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).forwardRef(({ picture: picture, email: email, ...props }, ref)=>{
    const { formatMessage: formatMessage } = (0, $dZHnD.default)();
    const state = (0, $eb71a6fac5171c50$export$2c1df3428fc3264c)(picture || "");
    const tooltip = formatMessage($1ed154f78f293baf$var$messages.triggerTooltip);
    return /*#__PURE__*/ (0, $jVTBW.jsx)((0, $4d5fcfc07abed2d7$export$5120f2d0b8d4cab8), {
        ...props,
        ref: ref,
        tooltip: email || tooltip,
        icon: picture && state === "loaded" ? /*#__PURE__*/ (0, $jVTBW.jsx)("img", {
            css: {
                borderRadius: "50%",
                width: (0, $6W4m7.gridSize)() * 3,
                height: (0, $6W4m7.gridSize)() * 3
            },
            src: picture,
            alt: tooltip
        }) : /*#__PURE__*/ (0, $jVTBW.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($24b61f3f66d39989$exports))), {
            label: tooltip,
            size: "medium"
        })
    });
});
const $1ed154f78f293baf$var$messages = (0, $lKhJJ.defineMessages)({
    triggerTooltip: {
        id: "identity.account-menu.account-menu-popup.skeleton.tooltip",
        defaultMessage: "Account",
        description: "Tooltip and alt-text for the account menu item"
    }
});


const $034f75f59f2e1b15$export$ff20d75d5eda4388 = ({ testId: testId, name: name, picture: picture, email: email, managedBy: managedBy, manageProfileLink: manageProfileLink, viewProfileLink: viewProfileLink, onViewProfileClick: onViewProfileClick, switchAccountLink: switchAccountLink, logOutLink: logOutLink, logInLink: logInLink, onThemeChange: onThemeChange, currentTheme: currentTheme, associatedSessions: associatedSessions, getAccountSwitchLink: getAccountSwitchLink })=>/*#__PURE__*/ (0, $bibO8.jsx)((0, $d543f8437edc6f97$export$d0a82da1a0b94929), {
        data: (0, $bdef4a5a08f4b14c$export$3cbe56a0cabcff38),
        children: logInLink ? /*#__PURE__*/ (0, $bibO8.jsx)((0, $ddce530fd83d1acb$export$904b79312c8d6122), {
            testId: testId && `${testId}--logged-out-state`,
            logInLink: logInLink
        }) : /*#__PURE__*/ (0, $bibO8.jsx)((0, $1ed154f78f293baf$export$473cb05bf335b0e1), {
            testId: testId,
            picture: picture,
            email: email,
            content: ({ onClose: closePopup })=>/*#__PURE__*/ (0, $bibO8.jsx)((0, $c06b25ec57762796$export$49c2771125e1e9f1), {
                    associatedSessions: associatedSessions,
                    testId: testId && `${testId}--content`,
                    closePopup: closePopup,
                    name: name,
                    picture: picture,
                    email: email,
                    managedBy: managedBy,
                    manageProfileLink: manageProfileLink,
                    viewProfileLink: viewProfileLink,
                    onViewProfileClick: onViewProfileClick,
                    switchAccountLink: switchAccountLink,
                    getAccountSwitchLink: getAccountSwitchLink,
                    logOutLink: logOutLink,
                    onThemeChange: onThemeChange,
                    currentTheme: currentTheme
                })
        })
    });







var $bibO8 = parcelRequire("bibO8");
parcelRequire("dAx5m");

var $dAx5m = parcelRequire("dAx5m");

var $40ee9209af546b3a$export$515664faa1398f37 = "navigation";
var $40ee9209af546b3a$export$3cbe56a0cabcff38 = {
    source: "atlassianAccountMenu",
    componentName: "atlassianAccountMenu",
    packageName: "@atlassian/account-menu",
    packageVersion: "0.3.12"
};


var $5fb336a98f9116b4$exports = {};
function $5fb336a98f9116b4$var$_extends() {
    return $5fb336a98f9116b4$exports = $5fb336a98f9116b4$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $5fb336a98f9116b4$exports.__esModule = true, $5fb336a98f9116b4$exports["default"] = $5fb336a98f9116b4$exports, $5fb336a98f9116b4$var$_extends.apply(null, arguments);
}
$5fb336a98f9116b4$exports = $5fb336a98f9116b4$var$_extends, $5fb336a98f9116b4$exports.__esModule = true, $5fb336a98f9116b4$exports["default"] = $5fb336a98f9116b4$exports;


var $74ed1cba0d5551e3$exports = {};
var $42fa17a1c2912871$exports = {};
function $42fa17a1c2912871$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.includes(n)) continue;
        t[n] = r[n];
    }
    return t;
}
$42fa17a1c2912871$exports = $42fa17a1c2912871$var$_objectWithoutPropertiesLoose, $42fa17a1c2912871$exports.__esModule = true, $42fa17a1c2912871$exports["default"] = $42fa17a1c2912871$exports;


function $74ed1cba0d5551e3$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $42fa17a1c2912871$exports(e, t);
    if (Object.getOwnPropertySymbols) {
        var s = Object.getOwnPropertySymbols(e);
        for(r = 0; r < s.length; r++)o = s[r], t.includes(o) || ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
$74ed1cba0d5551e3$exports = $74ed1cba0d5551e3$var$_objectWithoutProperties, $74ed1cba0d5551e3$exports.__esModule = true, $74ed1cba0d5551e3$exports["default"] = $74ed1cba0d5551e3$exports;



var $dAx5m = parcelRequire("dAx5m");

var $jVTBW = parcelRequire("jVTBW");

var $ku6eE = parcelRequire("ku6eE");

var $55TWT = parcelRequire("55TWT");

var $3FJlW = parcelRequire("3FJlW");

var $tWuif = parcelRequire("tWuif");
var $d5f3651f1c5ee1c2$exports = {};
var $a201131a8f79076f$exports = {};
var $14c6d53c535433d2$exports = {};
function $14c6d53c535433d2$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
$14c6d53c535433d2$exports = $14c6d53c535433d2$var$_arrayLikeToArray, $14c6d53c535433d2$exports.__esModule = true, $14c6d53c535433d2$exports["default"] = $14c6d53c535433d2$exports;


function $a201131a8f79076f$var$_arrayWithoutHoles(r) {
    if (Array.isArray(r)) return $14c6d53c535433d2$exports(r);
}
$a201131a8f79076f$exports = $a201131a8f79076f$var$_arrayWithoutHoles, $a201131a8f79076f$exports.__esModule = true, $a201131a8f79076f$exports["default"] = $a201131a8f79076f$exports;


var $2a0c9df66c36598e$exports = {};
function $2a0c9df66c36598e$var$_iterableToArray(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
$2a0c9df66c36598e$exports = $2a0c9df66c36598e$var$_iterableToArray, $2a0c9df66c36598e$exports.__esModule = true, $2a0c9df66c36598e$exports["default"] = $2a0c9df66c36598e$exports;


var $f48dc5cb2289964e$exports = {};

function $f48dc5cb2289964e$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $14c6d53c535433d2$exports(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $14c6d53c535433d2$exports(r, a) : void 0;
    }
}
$f48dc5cb2289964e$exports = $f48dc5cb2289964e$var$_unsupportedIterableToArray, $f48dc5cb2289964e$exports.__esModule = true, $f48dc5cb2289964e$exports["default"] = $f48dc5cb2289964e$exports;


var $4664919fd8361a79$exports = {};
function $4664919fd8361a79$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
$4664919fd8361a79$exports = $4664919fd8361a79$var$_nonIterableSpread, $4664919fd8361a79$exports.__esModule = true, $4664919fd8361a79$exports["default"] = $4664919fd8361a79$exports;


function $d5f3651f1c5ee1c2$var$_toConsumableArray(r) {
    return $a201131a8f79076f$exports(r) || $2a0c9df66c36598e$exports(r) || $f48dc5cb2289964e$exports(r) || $4664919fd8361a79$exports();
}
$d5f3651f1c5ee1c2$exports = $d5f3651f1c5ee1c2$var$_toConsumableArray, $d5f3651f1c5ee1c2$exports.__esModule = true, $d5f3651f1c5ee1c2$exports["default"] = $d5f3651f1c5ee1c2$exports;


var $338b26f50ccea2d2$exports = {};
function $338b26f50ccea2d2$var$_classCallCheck(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
$338b26f50ccea2d2$exports = $338b26f50ccea2d2$var$_classCallCheck, $338b26f50ccea2d2$exports.__esModule = true, $338b26f50ccea2d2$exports["default"] = $338b26f50ccea2d2$exports;


var $f6825da5cb87797f$exports = {};
var $7f4a74793c19555a$exports = {};

var $6J7ZY = parcelRequire("6J7ZY");
var $7f4a74793c19555a$var$_typeof = $6J7ZY.default;
var $f337df534dc9c544$exports = {};

var $6J7ZY = parcelRequire("6J7ZY");
var $f337df534dc9c544$var$_typeof = $6J7ZY.default;
function $f337df534dc9c544$var$toPrimitive(t, r) {
    if ("object" != $f337df534dc9c544$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $f337df534dc9c544$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
$f337df534dc9c544$exports = $f337df534dc9c544$var$toPrimitive, $f337df534dc9c544$exports.__esModule = true, $f337df534dc9c544$exports["default"] = $f337df534dc9c544$exports;


function $7f4a74793c19555a$var$toPropertyKey(t) {
    var i = $f337df534dc9c544$exports(t, "string");
    return "symbol" == $7f4a74793c19555a$var$_typeof(i) ? i : i + "";
}
$7f4a74793c19555a$exports = $7f4a74793c19555a$var$toPropertyKey, $7f4a74793c19555a$exports.__esModule = true, $7f4a74793c19555a$exports["default"] = $7f4a74793c19555a$exports;


function $f6825da5cb87797f$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, $7f4a74793c19555a$exports(o.key), o);
    }
}
function $f6825da5cb87797f$var$_createClass(e, r, t) {
    return r && $f6825da5cb87797f$var$_defineProperties(e.prototype, r), t && $f6825da5cb87797f$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}
$f6825da5cb87797f$exports = $f6825da5cb87797f$var$_createClass, $f6825da5cb87797f$exports.__esModule = true, $f6825da5cb87797f$exports["default"] = $f6825da5cb87797f$exports;


var $a652a3a6cb45a7cf$exports = {};
function $a652a3a6cb45a7cf$var$_assertThisInitialized(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}
$a652a3a6cb45a7cf$exports = $a652a3a6cb45a7cf$var$_assertThisInitialized, $a652a3a6cb45a7cf$exports.__esModule = true, $a652a3a6cb45a7cf$exports["default"] = $a652a3a6cb45a7cf$exports;


var $d1582149da161cd6$exports = {};
var $e10ac8ac7630f197$exports = {};
var $6c6f88cd7dc38741$exports = {};
function $6c6f88cd7dc38741$var$_getPrototypeOf(t) {
    return $6c6f88cd7dc38741$exports = $6c6f88cd7dc38741$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, $6c6f88cd7dc38741$exports.__esModule = true, $6c6f88cd7dc38741$exports["default"] = $6c6f88cd7dc38741$exports, $6c6f88cd7dc38741$var$_getPrototypeOf(t);
}
$6c6f88cd7dc38741$exports = $6c6f88cd7dc38741$var$_getPrototypeOf, $6c6f88cd7dc38741$exports.__esModule = true, $6c6f88cd7dc38741$exports["default"] = $6c6f88cd7dc38741$exports;


function $e10ac8ac7630f197$var$_superPropBase(t, o) {
    for(; !({}).hasOwnProperty.call(t, o) && null !== (t = $6c6f88cd7dc38741$exports(t)););
    return t;
}
$e10ac8ac7630f197$exports = $e10ac8ac7630f197$var$_superPropBase, $e10ac8ac7630f197$exports.__esModule = true, $e10ac8ac7630f197$exports["default"] = $e10ac8ac7630f197$exports;


function $d1582149da161cd6$var$_get() {
    return $d1582149da161cd6$exports = $d1582149da161cd6$var$_get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function(e, t, r) {
        var p = $e10ac8ac7630f197$exports(e, t);
        if (p) {
            var n = Object.getOwnPropertyDescriptor(p, t);
            return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value;
        }
    }, $d1582149da161cd6$exports.__esModule = true, $d1582149da161cd6$exports["default"] = $d1582149da161cd6$exports, $d1582149da161cd6$var$_get.apply(null, arguments);
}
$d1582149da161cd6$exports = $d1582149da161cd6$var$_get, $d1582149da161cd6$exports.__esModule = true, $d1582149da161cd6$exports["default"] = $d1582149da161cd6$exports;


var $66c319fc06465227$exports = {};
var $aac49710db1f864b$exports = {};
function $aac49710db1f864b$var$_setPrototypeOf(t, e) {
    return $aac49710db1f864b$exports = $aac49710db1f864b$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $aac49710db1f864b$exports.__esModule = true, $aac49710db1f864b$exports["default"] = $aac49710db1f864b$exports, $aac49710db1f864b$var$_setPrototypeOf(t, e);
}
$aac49710db1f864b$exports = $aac49710db1f864b$var$_setPrototypeOf, $aac49710db1f864b$exports.__esModule = true, $aac49710db1f864b$exports["default"] = $aac49710db1f864b$exports;


function $66c319fc06465227$var$_inherits(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && $aac49710db1f864b$exports(t, e);
}
$66c319fc06465227$exports = $66c319fc06465227$var$_inherits, $66c319fc06465227$exports.__esModule = true, $66c319fc06465227$exports["default"] = $66c319fc06465227$exports;


var $b7c8bb6ce7659b75$exports = {};

var $6J7ZY = parcelRequire("6J7ZY");
var $b7c8bb6ce7659b75$var$_typeof = $6J7ZY.default;

function $b7c8bb6ce7659b75$var$_possibleConstructorReturn(t, e) {
    if (e && ("object" == $b7c8bb6ce7659b75$var$_typeof(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return $a652a3a6cb45a7cf$exports(t);
}
$b7c8bb6ce7659b75$exports = $b7c8bb6ce7659b75$var$_possibleConstructorReturn, $b7c8bb6ce7659b75$exports.__esModule = true, $b7c8bb6ce7659b75$exports["default"] = $b7c8bb6ce7659b75$exports;



var $c3ec97511ae1ed64$exports = {};

function $c3ec97511ae1ed64$var$_defineProperty(e, r, t) {
    return (r = $7f4a74793c19555a$exports(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
$c3ec97511ae1ed64$exports = $c3ec97511ae1ed64$var$_defineProperty, $c3ec97511ae1ed64$exports.__esModule = true, $c3ec97511ae1ed64$exports["default"] = $c3ec97511ae1ed64$exports;



var $6J7ZY = parcelRequire("6J7ZY");



function $1d345c879c625fe6$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $1d345c879c625fe6$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $1d345c879c625fe6$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($c3ec97511ae1ed64$exports)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $1d345c879c625fe6$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $1d345c879c625fe6$export$ad4be5c2ec28cecf = function isAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $1d345c879c625fe6$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === "AnalyticsEvent";
};
var $1d345c879c625fe6$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function AnalyticsEvent(props) {
        var _this = this;
        (0, (/*@__PURE__*/$parcel$interopDefault($338b26f50ccea2d2$exports)))(this, AnalyticsEvent);
        (0, (/*@__PURE__*/$parcel$interopDefault($c3ec97511ae1ed64$exports)))(this, "_isAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($c3ec97511ae1ed64$exports)))(this, "clone", function() {
            // just a shallow clone, don't change sub refs unless you want to
            // affect the original's too
            var payload = $1d345c879c625fe6$var$_objectSpread({}, _this.payload);
            return new AnalyticsEvent({
                payload: payload
            });
        });
        this.payload = props.payload;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($f6825da5cb87797f$exports)))(AnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (typeof updater === "function") this.payload = updater(this.payload);
                if ((0, (/*@__PURE__*/$parcel$interopDefault($6J7ZY)))(updater) === "object") this.payload = $1d345c879c625fe6$var$_objectSpread($1d345c879c625fe6$var$_objectSpread({}, this.payload), updater);
                return this;
            }
        }
    ]);
    return AnalyticsEvent;
}();


function $983943e54df7160d$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $983943e54df7160d$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, (/*@__PURE__*/$parcel$interopDefault($6c6f88cd7dc38741$exports)))(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, (/*@__PURE__*/$parcel$interopDefault($6c6f88cd7dc38741$exports)))(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, (/*@__PURE__*/$parcel$interopDefault($b7c8bb6ce7659b75$exports)))(this, result);
    };
}
function $983943e54df7160d$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($983943e54df7160d$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $983943e54df7160d$export$35f8383928ba8d7 = function isUIAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $983943e54df7160d$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isUIAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === "UIAnalyticsEvent";
};
var $983943e54df7160d$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_AnalyticsEvent) {
    (0, (/*@__PURE__*/$parcel$interopDefault($66c319fc06465227$exports)))(UIAnalyticsEvent, _AnalyticsEvent);
    var _super = $983943e54df7160d$var$_createSuper(UIAnalyticsEvent);
    function UIAnalyticsEvent(props) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($338b26f50ccea2d2$exports)))(this, UIAnalyticsEvent);
        _this = _super.call(this, props);
        (0, (/*@__PURE__*/$parcel$interopDefault($c3ec97511ae1ed64$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($a652a3a6cb45a7cf$exports)))(_this), "_isUIAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($c3ec97511ae1ed64$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($a652a3a6cb45a7cf$exports)))(_this), "clone", function() {
            if (_this.hasFired) return null;
            var context = (0, (/*@__PURE__*/$parcel$interopDefault($d5f3651f1c5ee1c2$exports)))(_this.context);
            var handlers = (0, (/*@__PURE__*/$parcel$interopDefault($d5f3651f1c5ee1c2$exports)))(_this.handlers);
            /**
       * A hacky "deep clone" of the object. This is limited in that it wont
       * support functions, regexs, Maps, Sets, etc, but none of those need to
       * be represented in our payload.
       */ var payload = JSON.parse(JSON.stringify(_this.payload));
            return new UIAnalyticsEvent({
                context: context,
                handlers: handlers,
                payload: payload
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($c3ec97511ae1ed64$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($a652a3a6cb45a7cf$exports)))(_this), "fire", function(channel) {
            if (_this.hasFired) return;
            _this.handlers.forEach(function(handler) {
                return handler((0, (/*@__PURE__*/$parcel$interopDefault($a652a3a6cb45a7cf$exports)))(_this), channel);
            });
            _this.hasFired = true;
        });
        _this.context = props.context || [];
        _this.handlers = props.handlers || [];
        _this.hasFired = false;
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($f6825da5cb87797f$exports)))(UIAnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (this.hasFired) return this;
                return (0, (/*@__PURE__*/$parcel$interopDefault($d1582149da161cd6$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($6c6f88cd7dc38741$exports)))(UIAnalyticsEvent.prototype), "update", this).call(this, updater);
            }
        }
    ]);
    return UIAnalyticsEvent;
}((0, $1d345c879c625fe6$export$2e2bcd8739ae039));



var $dAx5m = parcelRequire("dAx5m");

var $h0bf1 = parcelRequire("h0bf1");
var $53e932ae8d478bbb$export$d1f587f82ad51c4 = function useAnalyticsContext() {
    return (0, $dAx5m.useContext)((0, $h0bf1.default));
};


function $2d5fdfa21a1e72e4$export$5bf35293e545f20c() {
    var analyticsContext = (0, $53e932ae8d478bbb$export$d1f587f82ad51c4)();
    var createAnalyticsEvent = (0, $tWuif.useCallbackOne)(function(payload) {
        return new (0, $983943e54df7160d$export$2e2bcd8739ae039)({
            context: analyticsContext.getAtlaskitAnalyticsContext(),
            handlers: analyticsContext.getAtlaskitAnalyticsEventHandlers(),
            payload: payload
        });
    }, [
        analyticsContext
    ]);
    return {
        createAnalyticsEvent: createAnalyticsEvent
    };
}


var $e3afb069315125ed$exports = {};
"use strict";
Object.defineProperty($e3afb069315125ed$exports, "__esModule", {
    value: true
});
$e3afb069315125ed$exports.default = void 0;

var $e3afb069315125ed$var$_react = $e3afb069315125ed$var$_interopRequireDefault((parcelRequire("dAx5m")));



var $dAx5m = parcelRequire("dAx5m");

var $jVTBW = parcelRequire("jVTBW");
var $6efa6870c1f8ebc6$export$18cb9425622d4e06 = function getBackground() {
    return "var(--ds-surface, #FFFFFF)";
};


var $195572aa4828077c$export$c647cb0ee6e282fe = {
    small: "16px",
    medium: "24px",
    large: "32px",
    xlarge: "48px"
};
var $195572aa4828077c$export$7bd66fc94c81bf84 = {
    small: "small",
    medium: "medium",
    large: "large",
    xlarge: "xlarge"
};
var $195572aa4828077c$export$62ad7b0c781000e9 = {
    small: {
        width: $195572aa4828077c$export$c647cb0ee6e282fe.small,
        height: $195572aa4828077c$export$c647cb0ee6e282fe.small
    },
    medium: {
        width: $195572aa4828077c$export$c647cb0ee6e282fe.medium,
        height: $195572aa4828077c$export$c647cb0ee6e282fe.medium
    },
    large: {
        width: $195572aa4828077c$export$c647cb0ee6e282fe.large,
        height: $195572aa4828077c$export$c647cb0ee6e282fe.large
    },
    xlarge: {
        width: $195572aa4828077c$export$c647cb0ee6e282fe.xlarge,
        height: $195572aa4828077c$export$c647cb0ee6e282fe.xlarge
    }
};



var $jVTBW = parcelRequire("jVTBW");
var $fdc0f27ff506960b$export$16374db1c3e6dfba = {
    overflow: "hidden",
    pointerEvents: "none",
    /**
   * Stop-color doesn't properly apply in chrome when the inherited/current color changes.
   * We have to initially set stop-color to inherit (either via DOM attribute or an initial CSS
   * rule) and then override it with currentColor for the color changes to be picked up.
   */ stop: {
        stopColor: "currentColor"
    }
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
var $fdc0f27ff506960b$var$smallStyles = (0, $jVTBW.css)((0, $195572aa4828077c$export$62ad7b0c781000e9).small);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
var $fdc0f27ff506960b$var$mediumStyles = (0, $jVTBW.css)((0, $195572aa4828077c$export$62ad7b0c781000e9).medium);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
var $fdc0f27ff506960b$var$largeStyles = (0, $jVTBW.css)((0, $195572aa4828077c$export$62ad7b0c781000e9).large);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
var $fdc0f27ff506960b$var$xlargeStyles = (0, $jVTBW.css)((0, $195572aa4828077c$export$62ad7b0c781000e9).xlarge);
var $fdc0f27ff506960b$export$ef0ad74202575b64 = {
    small: $fdc0f27ff506960b$var$smallStyles,
    medium: $fdc0f27ff506960b$var$mediumStyles,
    large: $fdc0f27ff506960b$var$largeStyles,
    xlarge: $fdc0f27ff506960b$var$xlargeStyles
};
var $fdc0f27ff506960b$export$3eb7d6130acfda37 = function getIconSize(_ref) {
    var width = _ref.width, height = _ref.height, size = _ref.size;
    if (width && height) return {
        width: width,
        height: height
    };
    if (size) return (0, $195572aa4828077c$export$62ad7b0c781000e9)[size];
    return undefined;
};


function $30d9f30932301ff5$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $30d9f30932301ff5$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $30d9f30932301ff5$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($c3ec97511ae1ed64$exports)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $30d9f30932301ff5$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
/**
 * We are hiding these props from consumers as they're used to
 * hack around icon sizing specifically for icon-file-type.
 */ var $30d9f30932301ff5$var$iconStyles = (0, $jVTBW.css)({
    display: "inline-block",
    flexShrink: 0,
    lineHeight: 1,
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    "> svg": $30d9f30932301ff5$var$_objectSpread($30d9f30932301ff5$var$_objectSpread({}, (0, $fdc0f27ff506960b$export$16374db1c3e6dfba)), {}, {
        maxWidth: "100%",
        maxHeight: "100%",
        color: "var(--icon-primary-color)",
        fill: "var(--icon-secondary-color)",
        verticalAlign: "bottom"
    })
});
/**
 * For windows high contrast mode
 */ var $30d9f30932301ff5$var$baseHcmStyles = (0, $jVTBW.css)({
    "@media screen and (forced-colors: active)": {
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        "> svg": {
            filter: "grayscale(1)",
            "--icon-primary-color": "CanvasText",
            // foreground
            "--icon-secondary-color": "Canvas" // background
        }
    }
});
var $30d9f30932301ff5$var$primaryEqualsSecondaryHcmStyles = (0, $jVTBW.css)({
    "@media screen and (forced-colors: active)": {
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        "> svg": {
            // if the primaryColor is the same as the secondaryColor we
            // set the --icon-primary-color to Canvas
            // this is usually to convey state i.e. Checkbox checked -> not checked
            "--icon-primary-color": "Canvas" // foreground
        }
    }
});
var $30d9f30932301ff5$var$secondaryTransparentHcmStyles = (0, $jVTBW.css)({
    "@media screen and (forced-colors: active)": {
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        "> svg": {
            "--icon-secondary-color": "transparent" // background
        }
    }
});
var $30d9f30932301ff5$export$f04a61298a47a40f = /*#__PURE__*/ (0, $dAx5m.memo)(function Icon(props) {
    var _ref = props, Glyph = _ref.glyph, dangerouslySetGlyph = _ref.dangerouslySetGlyph, _ref$primaryColor = _ref.primaryColor, primaryColor = _ref$primaryColor === void 0 ? "currentColor" : _ref$primaryColor, secondaryColor = _ref.secondaryColor, size = _ref.size, testId = _ref.testId, label = _ref.label, width = _ref.width, height = _ref.height;
    var glyphProps = dangerouslySetGlyph ? {
        dangerouslySetInnerHTML: {
            __html: dangerouslySetGlyph
        }
    } : {
        children: Glyph ? (0, $jVTBW.jsx)(Glyph, {
            role: "presentation"
        }) : null
    };
    var dimensions = (0, $fdc0f27ff506960b$export$3eb7d6130acfda37)({
        width: width,
        height: height,
        size: size
    });
    return (0, $jVTBW.jsx)("span", (0, (/*@__PURE__*/$parcel$interopDefault($5fb336a98f9116b4$exports)))({
        "data-testid": testId,
        role: label ? "img" : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: {
            "--icon-primary-color": primaryColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            "--icon-secondary-color": secondaryColor || (0, $6efa6870c1f8ebc6$export$18cb9425622d4e06)()
        }
    }, glyphProps, {
        css: [
            $30d9f30932301ff5$var$iconStyles,
            $30d9f30932301ff5$var$baseHcmStyles,
            primaryColor === secondaryColor && $30d9f30932301ff5$var$primaryEqualsSecondaryHcmStyles,
            secondaryColor === "transparent" && $30d9f30932301ff5$var$secondaryTransparentHcmStyles,
            // NB: This can be resolved if this component, composes base SVG / and/or skeleton
            // We could then simplify how common styles are dealt with simply by encapsulating them
            // at their appropriate level and/or having a singular approach to css variables in the package
            dimensions && // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $jVTBW.css)({
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                width: dimensions.width,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                height: dimensions.height,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                "> svg": dimensions
            })
        ]
    }));
});
var $30d9f30932301ff5$export$2e2bcd8739ae039 = $30d9f30932301ff5$export$f04a61298a47a40f;


function $e3afb069315125ed$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $e3afb069315125ed$var$SettingsIcon = (props)=>/*#__PURE__*/ $e3afb069315125ed$var$_react.default.createElement($30d9f30932301ff5$export$f04a61298a47a40f, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path d="M11.701 16.7a5.002 5.002 0 110-10.003 5.002 5.002 0 010 10.004m8.368-3.117a1.995 1.995 0 01-1.346-1.885c0-.876.563-1.613 1.345-1.885a.48.48 0 00.315-.574 8.947 8.947 0 00-.836-1.993.477.477 0 00-.598-.195 2.04 2.04 0 01-1.29.08 1.988 1.988 0 01-1.404-1.395 2.04 2.04 0 01.076-1.297.478.478 0 00-.196-.597 8.98 8.98 0 00-1.975-.826.479.479 0 00-.574.314 1.995 1.995 0 01-1.885 1.346 1.994 1.994 0 01-1.884-1.345.482.482 0 00-.575-.315c-.708.2-1.379.485-2.004.842a.47.47 0 00-.198.582A2.002 2.002 0 014.445 7.06a.478.478 0 00-.595.196 8.946 8.946 0 00-.833 1.994.48.48 0 00.308.572 1.995 1.995 0 011.323 1.877c0 .867-.552 1.599-1.324 1.877a.479.479 0 00-.308.57 8.99 8.99 0 00.723 1.79.477.477 0 00.624.194c.595-.273 1.343-.264 2.104.238.117.077.225.185.302.3.527.8.512 1.58.198 2.188a.473.473 0 00.168.628 8.946 8.946 0 002.11.897.474.474 0 00.57-.313 1.995 1.995 0 011.886-1.353c.878 0 1.618.567 1.887 1.353a.475.475 0 00.57.313 8.964 8.964 0 002.084-.883.473.473 0 00.167-.631c-.318-.608-.337-1.393.191-2.195.077-.116.185-.225.302-.302.772-.511 1.527-.513 2.125-.23a.477.477 0 00.628-.19 8.925 8.925 0 00.728-1.793.478.478 0 00-.314-.573" fill="currentColor" fill-rule="evenodd"/></svg>`
    }, props));
$e3afb069315125ed$var$SettingsIcon.displayName = "SettingsIcon";
var $e3afb069315125ed$var$_default = $e3afb069315125ed$var$SettingsIcon;
$e3afb069315125ed$exports.default = $e3afb069315125ed$var$_default;





var $dAx5m = parcelRequire("dAx5m");

var $jVTBW = parcelRequire("jVTBW");

var $dAx5m = parcelRequire("dAx5m");

var $dAx5m = parcelRequire("dAx5m");
var $5196eab44c7e1709$export$2931e0ee690eee88 = /*#__PURE__*/ (0, $dAx5m.createContext)({});
/**
 * __RouterLinkProvider__
 *
 * Provides a configured router link component for use
 * within Design System components.
 */ var $5196eab44c7e1709$var$RouterLinkProvider = function RouterLinkProvider(_ref) {
    var routerLinkComponent = _ref.routerLinkComponent, children = _ref.children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement($5196eab44c7e1709$export$2931e0ee690eee88.Provider, {
        value: {
            routerLinkComponent: routerLinkComponent
        }
    }, children);
};
var $5196eab44c7e1709$export$2e2bcd8739ae039 = $5196eab44c7e1709$var$RouterLinkProvider;


/**
 * __useRouterLink()__
 *
 * Hook: Returns app-configured router link component.
 *
 * A generic can be passed to define advanced link configuration:
 * ```
 * type MyRouterLinkConfig = {
 *  to: string;
 *  replace?: boolean;
 * }
 *
 * const RouterLink = useRouterLink<MyRouterLinkConfig>();
 * ```
 */ var $3dadca83bb4f3c17$var$useRouterLink = function useRouterLink() {
    var _useContext = (0, $dAx5m.useContext)((0, $5196eab44c7e1709$export$2931e0ee690eee88)), routerLinkComponent = _useContext.routerLinkComponent;
    if (routerLinkComponent) return routerLinkComponent;
};
var $3dadca83bb4f3c17$export$2e2bcd8739ae039 = $3dadca83bb4f3c17$var$useRouterLink;



var $e2xkU = parcelRequire("e2xkU");

var $Bb0he = parcelRequire("Bb0he");

var $jAmv0 = parcelRequire("jAmv0");
/**
 * @jsxRuntime classic
 */ /** @jsx jsx */ 
var $dAx5m = parcelRequire("dAx5m");

var $jVTBW = parcelRequire("jVTBW");

var $e2xkU = parcelRequire("e2xkU");

var $iAyBE = parcelRequire("iAyBE");

var $jAmv0 = parcelRequire("jAmv0");


var $dAx5m = parcelRequire("dAx5m");

var $jVTBW = parcelRequire("jVTBW");


var $6f4c9344050d46f7$exports = {};
var $309b576bfe472864$exports = {};
function $309b576bfe472864$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
$309b576bfe472864$exports = $309b576bfe472864$var$_arrayWithHoles, $309b576bfe472864$exports.__esModule = true, $309b576bfe472864$exports["default"] = $309b576bfe472864$exports;


var $3b3942960c559c62$exports = {};
function $3b3942960c559c62$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
$3b3942960c559c62$exports = $3b3942960c559c62$var$_iterableToArrayLimit, $3b3942960c559c62$exports.__esModule = true, $3b3942960c559c62$exports["default"] = $3b3942960c559c62$exports;



var $5358c191a666c65a$exports = {};
function $5358c191a666c65a$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
$5358c191a666c65a$exports = $5358c191a666c65a$var$_nonIterableRest, $5358c191a666c65a$exports.__esModule = true, $5358c191a666c65a$exports["default"] = $5358c191a666c65a$exports;


function $6f4c9344050d46f7$var$_slicedToArray(r, e) {
    return $309b576bfe472864$exports(r) || $3b3942960c559c62$exports(r, e) || $f48dc5cb2289964e$exports(r, e) || $5358c191a666c65a$exports();
}
$6f4c9344050d46f7$exports = $6f4c9344050d46f7$var$_slicedToArray, $6f4c9344050d46f7$exports.__esModule = true, $6f4c9344050d46f7$exports["default"] = $6f4c9344050d46f7$exports;



var $6J7ZY = parcelRequire("6J7ZY");

var $jVTBW = parcelRequire("jVTBW");


var $jVTBW = parcelRequire("jVTBW");
var $3af0e6fda2aad772$export$4ef52930e33717cd = "data-theme";
var $3af0e6fda2aad772$export$a00eac3f8684bcd0 = "data-color-mode";
var $3af0e6fda2aad772$export$2112803007239c61 = "data-contrast-mode";
var $3af0e6fda2aad772$export$352e418ed5b6193a = "data-custom-theme";
var $3af0e6fda2aad772$export$2faeed762aac6741 = "light";
var $3af0e6fda2aad772$export$6f0c6fb8c80fcc92 = "ds";
var $3af0e6fda2aad772$export$4d0c7bbf80185957 = [
    "opacity",
    "font",
    "space",
    "border"
];
var $3af0e6fda2aad772$export$dddac1532e822863 = "--".concat($3af0e6fda2aad772$export$6f0c6fb8c80fcc92, "-token-not-found");
var $3af0e6fda2aad772$export$9d7b58831ae93caa = "--".concat($3af0e6fda2aad772$export$6f0c6fb8c80fcc92, "-elevation-surface-current");


function $ebe1decd94278ef0$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $ebe1decd94278ef0$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $ebe1decd94278ef0$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($c3ec97511ae1ed64$exports)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $ebe1decd94278ef0$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $ebe1decd94278ef0$export$6ccdbebca2ee545f = {
    "100%": "100%",
    "size.100": "1rem",
    "size.200": "1.5rem",
    "size.300": "2rem",
    "size.400": "2.5rem",
    "size.500": "3rem",
    "size.600": "6rem",
    "size.1000": "12rem"
};
var $ebe1decd94278ef0$export$958d0ae7f2977ae4 = {
    "space.0": "var(--ds-space-0, 0px)",
    "space.025": "var(--ds-space-025, 2px)",
    "space.050": "var(--ds-space-050, 4px)",
    "space.075": "var(--ds-space-075, 6px)",
    "space.100": "var(--ds-space-100, 8px)",
    "space.150": "var(--ds-space-150, 12px)",
    "space.200": "var(--ds-space-200, 16px)",
    "space.250": "var(--ds-space-250, 20px)",
    "space.300": "var(--ds-space-300, 24px)",
    "space.400": "var(--ds-space-400, 32px)",
    "space.500": "var(--ds-space-500, 40px)",
    "space.600": "var(--ds-space-600, 48px)",
    "space.800": "var(--ds-space-800, 64px)",
    "space.1000": "var(--ds-space-1000, 80px)"
};
var $ebe1decd94278ef0$export$d2dc61f58390201c = {
    "space.negative.025": "var(--ds-space-negative-025, -2px)",
    "space.negative.050": "var(--ds-space-negative-050, -4px)",
    "space.negative.075": "var(--ds-space-negative-075, -6px)",
    "space.negative.100": "var(--ds-space-negative-100, -8px)",
    "space.negative.150": "var(--ds-space-negative-150, -12px)",
    "space.negative.200": "var(--ds-space-negative-200, -16px)",
    "space.negative.250": "var(--ds-space-negative-250, -20px)",
    "space.negative.300": "var(--ds-space-negative-300, -24px)",
    "space.negative.400": "var(--ds-space-negative-400, -32px)"
};
var $ebe1decd94278ef0$export$632685d741f3dbbf = $ebe1decd94278ef0$var$_objectSpread($ebe1decd94278ef0$var$_objectSpread({}, $ebe1decd94278ef0$export$958d0ae7f2977ae4), $ebe1decd94278ef0$export$d2dc61f58390201c);
var $ebe1decd94278ef0$export$2185ce37f9bdd963 = {
    "color.background.neutral.bold": "color.text.inverse",
    "color.background.neutral.bold.hovered": "color.text.inverse",
    "color.background.neutral.bold.pressed": "color.text.inverse",
    "color.background.selected.bold": "color.text.inverse",
    "color.background.selected.bold.hovered": "color.text.inverse",
    "color.background.selected.bold.pressed": "color.text.inverse",
    "color.background.brand.bold": "color.text.inverse",
    "color.background.brand.bold.hovered": "color.text.inverse",
    "color.background.brand.bold.pressed": "color.text.inverse",
    "color.background.brand.boldest": "color.text.inverse",
    "color.background.brand.boldest.hovered": "color.text.inverse",
    "color.background.brand.boldest.pressed": "color.text.inverse",
    "color.background.danger.bold": "color.text.inverse",
    "color.background.danger.bold.hovered": "color.text.inverse",
    "color.background.danger.bold.pressed": "color.text.inverse",
    "color.background.warning.bold": "color.text.warning.inverse",
    "color.background.warning.bold.hovered": "color.text.warning.inverse",
    "color.background.warning.bold.pressed": "color.text.warning.inverse",
    "color.background.success.bold": "color.text.inverse",
    "color.background.success.bold.hovered": "color.text.inverse",
    "color.background.success.bold.pressed": "color.text.inverse",
    "color.background.discovery.bold": "color.text.inverse",
    "color.background.discovery.bold.hovered": "color.text.inverse",
    "color.background.discovery.bold.pressed": "color.text.inverse",
    "color.background.information.bold": "color.text.inverse",
    "color.background.information.bold.hovered": "color.text.inverse",
    "color.background.information.bold.pressed": "color.text.inverse"
};
var $ebe1decd94278ef0$export$daf94a976c798b4f = {
    "opacity.disabled": "var(--ds-opacity-disabled, 0.4)",
    "opacity.loading": "var(--ds-opacity-loading, 0.2)"
};
var $ebe1decd94278ef0$export$7aff6e7ba39bb774 = {
    "elevation.shadow.overflow": "var(--ds-shadow-overflow, 0px 0px 8px #091e423f, 0px 0px 1px #091e424f)",
    "elevation.shadow.overflow.perimeter": "var(--ds-shadow-overflow-perimeter, #091e421f)",
    "elevation.shadow.overflow.spread": "var(--ds-shadow-overflow-spread, #091e4229)",
    "elevation.shadow.overlay": "var(--ds-shadow-overlay, 0px 8px 12px #091e423f, 0px 0px 1px #091e424f)",
    "elevation.shadow.raised": "var(--ds-shadow-raised, 0px 1px 1px #091e423f, 0px 0px 1px #091e4221)"
};
var $ebe1decd94278ef0$export$41a358c9c2356760 = {
    "elevation.surface": "var(--ds-surface, #FFFFFF)",
    "elevation.surface.hovered": "var(--ds-surface-hovered, #FAFBFC)",
    "elevation.surface.pressed": "var(--ds-surface-pressed, #F4F5F7)",
    "elevation.surface.overlay": "var(--ds-surface-overlay, #FFFFFF)",
    "elevation.surface.overlay.hovered": "var(--ds-surface-overlay-hovered, #FAFBFC)",
    "elevation.surface.overlay.pressed": "var(--ds-surface-overlay-pressed, #F4F5F7)",
    "elevation.surface.raised": "var(--ds-surface-raised, #FFFFFF)",
    "elevation.surface.raised.hovered": "var(--ds-surface-raised-hovered, #FAFBFC)",
    "elevation.surface.raised.pressed": "var(--ds-surface-raised-pressed, #F4F5F7)",
    "elevation.surface.sunken": "var(--ds-surface-sunken, #F4F5F7)"
};
var $ebe1decd94278ef0$export$1531ad5bb3fbedac = {
    "color.border": "var(--ds-border, #091e4221)",
    "color.border.accent.lime": "var(--ds-border-accent-lime, #6A9A23)",
    "color.border.accent.red": "var(--ds-border-accent-red, #FF5630)",
    "color.border.accent.orange": "var(--ds-border-accent-orange, #D94008)",
    "color.border.accent.yellow": "var(--ds-border-accent-yellow, #FFAB00)",
    "color.border.accent.green": "var(--ds-border-accent-green, #36B37E)",
    "color.border.accent.teal": "var(--ds-border-accent-teal, #00B8D9)",
    "color.border.accent.blue": "var(--ds-border-accent-blue, #0065FF)",
    "color.border.accent.purple": "var(--ds-border-accent-purple, #6554C0)",
    "color.border.accent.magenta": "var(--ds-border-accent-magenta, #CD519D)",
    "color.border.accent.gray": "var(--ds-border-accent-gray, #5E6C84)",
    "color.border.disabled": "var(--ds-border-disabled, #FAFBFC)",
    "color.border.focused": "var(--ds-border-focused, #2684FF)",
    "color.border.input": "var(--ds-border-input, #FAFBFC)",
    "color.border.inverse": "var(--ds-border-inverse, #FFFFFF)",
    "color.border.selected": "var(--ds-border-selected, #0052CC)",
    "color.border.brand": "var(--ds-border-brand, #0052CC)",
    "color.border.danger": "var(--ds-border-danger, #FF5630)",
    "color.border.warning": "var(--ds-border-warning, #FFC400)",
    "color.border.success": "var(--ds-border-success, #00875A)",
    "color.border.discovery": "var(--ds-border-discovery, #998DD9)",
    "color.border.information": "var(--ds-border-information, #0065FF)",
    "color.border.bold": "var(--ds-border-bold, #344563)"
};
var $ebe1decd94278ef0$export$d1d79bf68ac056bd = {
    "color.background.accent.lime.subtlest": "var(--ds-background-accent-lime-subtlest, #EEFBDA)",
    "color.background.accent.lime.subtlest.hovered": "var(--ds-background-accent-lime-subtlest-hovered, #D3F1A7)",
    "color.background.accent.lime.subtlest.pressed": "var(--ds-background-accent-lime-subtlest-pressed, #B3DF72)",
    "color.background.accent.lime.subtler": "var(--ds-background-accent-lime-subtler, #D3F1A7)",
    "color.background.accent.lime.subtler.hovered": "var(--ds-background-accent-lime-subtler-hovered, #B3DF72)",
    "color.background.accent.lime.subtler.pressed": "var(--ds-background-accent-lime-subtler-pressed, #94C748)",
    "color.background.accent.lime.subtle": "var(--ds-background-accent-lime-subtle, #94C748)",
    "color.background.accent.lime.subtle.hovered": "var(--ds-background-accent-lime-subtle-hovered, #B3DF72)",
    "color.background.accent.lime.subtle.pressed": "var(--ds-background-accent-lime-subtle-pressed, #D3F1A7)",
    "color.background.accent.lime.bolder": "var(--ds-background-accent-lime-bolder, #5B7F24)",
    "color.background.accent.lime.bolder.hovered": "var(--ds-background-accent-lime-bolder-hovered, #37471F)",
    "color.background.accent.lime.bolder.pressed": "var(--ds-background-accent-lime-bolder-pressed, #37471F)",
    "color.background.accent.red.subtlest": "var(--ds-background-accent-red-subtlest, #FF8F73)",
    "color.background.accent.red.subtlest.hovered": "var(--ds-background-accent-red-subtlest-hovered, #FF7452)",
    "color.background.accent.red.subtlest.pressed": "var(--ds-background-accent-red-subtlest-pressed, #FF5630)",
    "color.background.accent.red.subtler": "var(--ds-background-accent-red-subtler, #FF7452)",
    "color.background.accent.red.subtler.hovered": "var(--ds-background-accent-red-subtler-hovered, #FF5630)",
    "color.background.accent.red.subtler.pressed": "var(--ds-background-accent-red-subtler-pressed, #DE350B)",
    "color.background.accent.red.subtle": "var(--ds-background-accent-red-subtle, #DE350B)",
    "color.background.accent.red.subtle.hovered": "var(--ds-background-accent-red-subtle-hovered, #FF5630)",
    "color.background.accent.red.subtle.pressed": "var(--ds-background-accent-red-subtle-pressed, #FF7452)",
    "color.background.accent.red.bolder": "var(--ds-background-accent-red-bolder, #DE350B)",
    "color.background.accent.red.bolder.hovered": "var(--ds-background-accent-red-bolder-hovered, #FF5630)",
    "color.background.accent.red.bolder.pressed": "var(--ds-background-accent-red-bolder-pressed, #FF7452)",
    "color.background.accent.orange.subtlest": "var(--ds-background-accent-orange-subtlest, #F18D13)",
    "color.background.accent.orange.subtlest.hovered": "var(--ds-background-accent-orange-subtlest-hovered, #FEC57B)",
    "color.background.accent.orange.subtlest.pressed": "var(--ds-background-accent-orange-subtlest-pressed, #FFE2BD)",
    "color.background.accent.orange.subtler": "var(--ds-background-accent-orange-subtler, #B65C02)",
    "color.background.accent.orange.subtler.hovered": "var(--ds-background-accent-orange-subtler-hovered, #F18D13)",
    "color.background.accent.orange.subtler.pressed": "var(--ds-background-accent-orange-subtler-pressed, #FEC57B)",
    "color.background.accent.orange.subtle": "var(--ds-background-accent-orange-subtle, #5F3811)",
    "color.background.accent.orange.subtle.hovered": "var(--ds-background-accent-orange-subtle-hovered, #974F0C)",
    "color.background.accent.orange.subtle.pressed": "var(--ds-background-accent-orange-subtle-pressed, #B65C02)",
    "color.background.accent.orange.bolder": "var(--ds-background-accent-orange-bolder, #43290F)",
    "color.background.accent.orange.bolder.hovered": "var(--ds-background-accent-orange-bolder-hovered, #5F3811)",
    "color.background.accent.orange.bolder.pressed": "var(--ds-background-accent-orange-bolder-pressed, #974F0C)",
    "color.background.accent.yellow.subtlest": "var(--ds-background-accent-yellow-subtlest, #FFE380)",
    "color.background.accent.yellow.subtlest.hovered": "var(--ds-background-accent-yellow-subtlest-hovered, #FFC400)",
    "color.background.accent.yellow.subtlest.pressed": "var(--ds-background-accent-yellow-subtlest-pressed, #FFAB00)",
    "color.background.accent.yellow.subtler": "var(--ds-background-accent-yellow-subtler, #FFC400)",
    "color.background.accent.yellow.subtler.hovered": "var(--ds-background-accent-yellow-subtler-hovered, #FFAB00)",
    "color.background.accent.yellow.subtler.pressed": "var(--ds-background-accent-yellow-subtler-pressed, #FF991F)",
    "color.background.accent.yellow.subtle": "var(--ds-background-accent-yellow-subtle, #FF991F)",
    "color.background.accent.yellow.subtle.hovered": "var(--ds-background-accent-yellow-subtle-hovered, #FFAB00)",
    "color.background.accent.yellow.subtle.pressed": "var(--ds-background-accent-yellow-subtle-pressed, #FFC400)",
    "color.background.accent.yellow.bolder": "var(--ds-background-accent-yellow-bolder, #FF991F)",
    "color.background.accent.yellow.bolder.hovered": "var(--ds-background-accent-yellow-bolder-hovered, #FFAB00)",
    "color.background.accent.yellow.bolder.pressed": "var(--ds-background-accent-yellow-bolder-pressed, #FFC400)",
    "color.background.accent.green.subtlest": "var(--ds-background-accent-green-subtlest, #79F2C0)",
    "color.background.accent.green.subtlest.hovered": "var(--ds-background-accent-green-subtlest-hovered, #57D9A3)",
    "color.background.accent.green.subtlest.pressed": "var(--ds-background-accent-green-subtlest-pressed, #36B37E)",
    "color.background.accent.green.subtler": "var(--ds-background-accent-green-subtler, #57D9A3)",
    "color.background.accent.green.subtler.hovered": "var(--ds-background-accent-green-subtler-hovered, #36B37E)",
    "color.background.accent.green.subtler.pressed": "var(--ds-background-accent-green-subtler-pressed, #00875A)",
    "color.background.accent.green.subtle": "var(--ds-background-accent-green-subtle, #00875A)",
    "color.background.accent.green.subtle.hovered": "var(--ds-background-accent-green-subtle-hovered, #36B37E)",
    "color.background.accent.green.subtle.pressed": "var(--ds-background-accent-green-subtle-pressed, #57D9A3)",
    "color.background.accent.green.bolder": "var(--ds-background-accent-green-bolder, #00875A)",
    "color.background.accent.green.bolder.hovered": "var(--ds-background-accent-green-bolder-hovered, #36B37E)",
    "color.background.accent.green.bolder.pressed": "var(--ds-background-accent-green-bolder-pressed, #57D9A3)",
    "color.background.accent.teal.subtlest": "var(--ds-background-accent-teal-subtlest, #79E2F2)",
    "color.background.accent.teal.subtlest.hovered": "var(--ds-background-accent-teal-subtlest-hovered, #00C7E6)",
    "color.background.accent.teal.subtlest.pressed": "var(--ds-background-accent-teal-subtlest-pressed, #00B8D9)",
    "color.background.accent.teal.subtler": "var(--ds-background-accent-teal-subtler, #00C7E6)",
    "color.background.accent.teal.subtler.hovered": "var(--ds-background-accent-teal-subtler-hovered, #00B8D9)",
    "color.background.accent.teal.subtler.pressed": "var(--ds-background-accent-teal-subtler-pressed, #00A3BF)",
    "color.background.accent.teal.subtle": "var(--ds-background-accent-teal-subtle, #00A3BF)",
    "color.background.accent.teal.subtle.hovered": "var(--ds-background-accent-teal-subtle-hovered, #00B8D9)",
    "color.background.accent.teal.subtle.pressed": "var(--ds-background-accent-teal-subtle-pressed, #00C7E6)",
    "color.background.accent.teal.bolder": "var(--ds-background-accent-teal-bolder, #00A3BF)",
    "color.background.accent.teal.bolder.hovered": "var(--ds-background-accent-teal-bolder-hovered, #00B8D9)",
    "color.background.accent.teal.bolder.pressed": "var(--ds-background-accent-teal-bolder-pressed, #00C7E6)",
    "color.background.accent.blue.subtlest": "var(--ds-background-accent-blue-subtlest, #4C9AFF)",
    "color.background.accent.blue.subtlest.hovered": "var(--ds-background-accent-blue-subtlest-hovered, #2684FF)",
    "color.background.accent.blue.subtlest.pressed": "var(--ds-background-accent-blue-subtlest-pressed, #0065FF)",
    "color.background.accent.blue.subtler": "var(--ds-background-accent-blue-subtler, #2684FF)",
    "color.background.accent.blue.subtler.hovered": "var(--ds-background-accent-blue-subtler-hovered, #0065FF)",
    "color.background.accent.blue.subtler.pressed": "var(--ds-background-accent-blue-subtler-pressed, #0052CC)",
    "color.background.accent.blue.subtle": "var(--ds-background-accent-blue-subtle, #0052CC)",
    "color.background.accent.blue.subtle.hovered": "var(--ds-background-accent-blue-subtle-hovered, #0065FF)",
    "color.background.accent.blue.subtle.pressed": "var(--ds-background-accent-blue-subtle-pressed, #2684FF)",
    "color.background.accent.blue.bolder": "var(--ds-background-accent-blue-bolder, #0052CC)",
    "color.background.accent.blue.bolder.hovered": "var(--ds-background-accent-blue-bolder-hovered, #0065FF)",
    "color.background.accent.blue.bolder.pressed": "var(--ds-background-accent-blue-bolder-pressed, #2684FF)",
    "color.background.accent.purple.subtlest": "var(--ds-background-accent-purple-subtlest, #998DD9)",
    "color.background.accent.purple.subtlest.hovered": "var(--ds-background-accent-purple-subtlest-hovered, #8777D9)",
    "color.background.accent.purple.subtlest.pressed": "var(--ds-background-accent-purple-subtlest-pressed, #6554C0)",
    "color.background.accent.purple.subtler": "var(--ds-background-accent-purple-subtler, #8777D9)",
    "color.background.accent.purple.subtler.hovered": "var(--ds-background-accent-purple-subtler-hovered, #6554C0)",
    "color.background.accent.purple.subtler.pressed": "var(--ds-background-accent-purple-subtler-pressed, #5243AA)",
    "color.background.accent.purple.subtle": "var(--ds-background-accent-purple-subtle, #5243AA)",
    "color.background.accent.purple.subtle.hovered": "var(--ds-background-accent-purple-subtle-hovered, #6554C0)",
    "color.background.accent.purple.subtle.pressed": "var(--ds-background-accent-purple-subtle-pressed, #8777D9)",
    "color.background.accent.purple.bolder": "var(--ds-background-accent-purple-bolder, #5243AA)",
    "color.background.accent.purple.bolder.hovered": "var(--ds-background-accent-purple-bolder-hovered, #6554C0)",
    "color.background.accent.purple.bolder.pressed": "var(--ds-background-accent-purple-bolder-pressed, #8777D9)",
    "color.background.accent.magenta.subtlest": "var(--ds-background-accent-magenta-subtlest, #FFECF8)",
    "color.background.accent.magenta.subtlest.hovered": "var(--ds-background-accent-magenta-subtlest-hovered, #FDD0EC)",
    "color.background.accent.magenta.subtlest.pressed": "var(--ds-background-accent-magenta-subtlest-pressed, #F797D2)",
    "color.background.accent.magenta.subtler": "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
    "color.background.accent.magenta.subtler.hovered": "var(--ds-background-accent-magenta-subtler-hovered, #F797D2)",
    "color.background.accent.magenta.subtler.pressed": "var(--ds-background-accent-magenta-subtler-pressed, #E774BB)",
    "color.background.accent.magenta.subtle": "var(--ds-background-accent-magenta-subtle, #E774BB)",
    "color.background.accent.magenta.subtle.hovered": "var(--ds-background-accent-magenta-subtle-hovered, #F797D2)",
    "color.background.accent.magenta.subtle.pressed": "var(--ds-background-accent-magenta-subtle-pressed, #FDD0EC)",
    "color.background.accent.magenta.bolder": "var(--ds-background-accent-magenta-bolder, #AE4787)",
    "color.background.accent.magenta.bolder.hovered": "var(--ds-background-accent-magenta-bolder-hovered, #943D73)",
    "color.background.accent.magenta.bolder.pressed": "var(--ds-background-accent-magenta-bolder-pressed, #50253F)",
    "color.background.accent.gray.subtlest": "var(--ds-background-accent-gray-subtlest, #6B778C)",
    "color.background.accent.gray.subtlest.hovered": "var(--ds-background-accent-gray-subtlest-hovered, #5E6C84)",
    "color.background.accent.gray.subtlest.pressed": "var(--ds-background-accent-gray-subtlest-pressed, #505F79)",
    "color.background.accent.gray.subtler": "var(--ds-background-accent-gray-subtler, #5E6C84)",
    "color.background.accent.gray.subtler.hovered": "var(--ds-background-accent-gray-subtler-hovered, #505F79)",
    "color.background.accent.gray.subtler.pressed": "var(--ds-background-accent-gray-subtler-pressed, #42526E)",
    "color.background.accent.gray.subtle": "var(--ds-background-accent-gray-subtle, #505F79)",
    "color.background.accent.gray.subtle.hovered": "var(--ds-background-accent-gray-subtle-hovered, #5E6C84)",
    "color.background.accent.gray.subtle.pressed": "var(--ds-background-accent-gray-subtle-pressed, #6B778C)",
    "color.background.accent.gray.bolder": "var(--ds-background-accent-gray-bolder, #42526E)",
    "color.background.accent.gray.bolder.hovered": "var(--ds-background-accent-gray-bolder-hovered, #344563)",
    "color.background.accent.gray.bolder.pressed": "var(--ds-background-accent-gray-bolder-pressed, #253858)",
    "color.background.disabled": "var(--ds-background-disabled, #091e4289)",
    "color.background.input": "var(--ds-background-input, #FAFBFC)",
    "color.background.input.hovered": "var(--ds-background-input-hovered, #EBECF0)",
    "color.background.input.pressed": "var(--ds-background-input-pressed, #FFFFFF)",
    "color.background.inverse.subtle": "var(--ds-background-inverse-subtle, #00000029)",
    "color.background.inverse.subtle.hovered": "var(--ds-background-inverse-subtle-hovered, #0000003D)",
    "color.background.inverse.subtle.pressed": "var(--ds-background-inverse-subtle-pressed, #00000052)",
    "color.background.neutral": "var(--ds-background-neutral, #DFE1E6)",
    "color.background.neutral.hovered": "var(--ds-background-neutral-hovered, #091e4214)",
    "color.background.neutral.pressed": "var(--ds-background-neutral-pressed, #B3D4FF)",
    "color.background.neutral.subtle": "var(--ds-background-neutral-subtle, transparent)",
    "color.background.neutral.subtle.hovered": "var(--ds-background-neutral-subtle-hovered, #091e4214)",
    "color.background.neutral.subtle.pressed": "var(--ds-background-neutral-subtle-pressed, #B3D4FF)",
    "color.background.neutral.bold": "var(--ds-background-neutral-bold, #42526E)",
    "color.background.neutral.bold.hovered": "var(--ds-background-neutral-bold-hovered, #505F79)",
    "color.background.neutral.bold.pressed": "var(--ds-background-neutral-bold-pressed, #344563)",
    "color.background.selected": "var(--ds-background-selected, #DEEBFF)",
    "color.background.selected.hovered": "var(--ds-background-selected-hovered, #B3D4FF)",
    "color.background.selected.pressed": "var(--ds-background-selected-pressed, #4C9AFF)",
    "color.background.selected.bold": "var(--ds-background-selected-bold, #0052CC)",
    "color.background.selected.bold.hovered": "var(--ds-background-selected-bold-hovered, #2684FF)",
    "color.background.selected.bold.pressed": "var(--ds-background-selected-bold-pressed, #0052CC)",
    "color.background.brand.subtlest": "var(--ds-background-brand-subtlest, #B3D4FF)",
    "color.background.brand.subtlest.hovered": "var(--ds-background-brand-subtlest-hovered, #DEEBFF)",
    "color.background.brand.subtlest.pressed": "var(--ds-background-brand-subtlest-pressed, #4C9AFF)",
    "color.background.brand.bold": "var(--ds-background-brand-bold, #0052CC)",
    "color.background.brand.bold.hovered": "var(--ds-background-brand-bold-hovered, #0065FF)",
    "color.background.brand.bold.pressed": "var(--ds-background-brand-bold-pressed, #0747A6)",
    "color.background.brand.boldest": "var(--ds-background-brand-boldest, #0747A6)",
    "color.background.brand.boldest.hovered": "var(--ds-background-brand-boldest-hovered, #0052CC)",
    "color.background.brand.boldest.pressed": "var(--ds-background-brand-boldest-pressed, #0747A6)",
    "color.background.danger": "var(--ds-background-danger, #FFEBE6)",
    "color.background.danger.hovered": "var(--ds-background-danger-hovered, #FFBDAD)",
    "color.background.danger.pressed": "var(--ds-background-danger-pressed, #FF8F73)",
    "color.background.danger.bold": "var(--ds-background-danger-bold, #DE350B)",
    "color.background.danger.bold.hovered": "var(--ds-background-danger-bold-hovered, #FF5630)",
    "color.background.danger.bold.pressed": "var(--ds-background-danger-bold-pressed, #BF2600)",
    "color.background.warning": "var(--ds-background-warning, #FFFAE6)",
    "color.background.warning.hovered": "var(--ds-background-warning-hovered, #FFF0B3)",
    "color.background.warning.pressed": "var(--ds-background-warning-pressed, #FFE380)",
    "color.background.warning.bold": "var(--ds-background-warning-bold, #FFAB00)",
    "color.background.warning.bold.hovered": "var(--ds-background-warning-bold-hovered, #FFC400)",
    "color.background.warning.bold.pressed": "var(--ds-background-warning-bold-pressed, #FF991F)",
    "color.background.success": "var(--ds-background-success, #E3FCEF)",
    "color.background.success.hovered": "var(--ds-background-success-hovered, #ABF5D1)",
    "color.background.success.pressed": "var(--ds-background-success-pressed, #79F2C0)",
    "color.background.success.bold": "var(--ds-background-success-bold, #00875A)",
    "color.background.success.bold.hovered": "var(--ds-background-success-bold-hovered, #57D9A3)",
    "color.background.success.bold.pressed": "var(--ds-background-success-bold-pressed, #00875A)",
    "color.background.discovery": "var(--ds-background-discovery, #EAE6FF)",
    "color.background.discovery.hovered": "var(--ds-background-discovery-hovered, #C0B6F2)",
    "color.background.discovery.pressed": "var(--ds-background-discovery-pressed, #998DD9)",
    "color.background.discovery.bold": "var(--ds-background-discovery-bold, #5243AA)",
    "color.background.discovery.bold.hovered": "var(--ds-background-discovery-bold-hovered, #8777D9)",
    "color.background.discovery.bold.pressed": "var(--ds-background-discovery-bold-pressed, #5243AA)",
    "color.background.information": "var(--ds-background-information, #DEEBFF)",
    "color.background.information.hovered": "var(--ds-background-information-hovered, #B3D4FF)",
    "color.background.information.pressed": "var(--ds-background-information-pressed, #4C9AFF)",
    "color.background.information.bold": "var(--ds-background-information-bold, #0052CC)",
    "color.background.information.bold.hovered": "var(--ds-background-information-bold-hovered, #2684FF)",
    "color.background.information.bold.pressed": "var(--ds-background-information-bold-pressed, #0052CC)",
    "color.blanket": "var(--ds-blanket, #091e4289)",
    "color.blanket.selected": "var(--ds-blanket-selected, #388BFF14)",
    "color.blanket.danger": "var(--ds-blanket-danger, #EF5C4814)",
    "color.skeleton": "var(--ds-skeleton, #F4F5F7)",
    "color.skeleton.subtle": "var(--ds-skeleton-subtle, #091e420a)",
    "elevation.surface": "var(--ds-surface, #FFFFFF)",
    "elevation.surface.hovered": "var(--ds-surface-hovered, #FAFBFC)",
    "elevation.surface.pressed": "var(--ds-surface-pressed, #F4F5F7)",
    "elevation.surface.overlay": "var(--ds-surface-overlay, #FFFFFF)",
    "elevation.surface.overlay.hovered": "var(--ds-surface-overlay-hovered, #FAFBFC)",
    "elevation.surface.overlay.pressed": "var(--ds-surface-overlay-pressed, #F4F5F7)",
    "elevation.surface.raised": "var(--ds-surface-raised, #FFFFFF)",
    "elevation.surface.raised.hovered": "var(--ds-surface-raised-hovered, #FAFBFC)",
    "elevation.surface.raised.pressed": "var(--ds-surface-raised-pressed, #F4F5F7)",
    "elevation.surface.sunken": "var(--ds-surface-sunken, #F4F5F7)",
    "utility.elevation.surface.current": "var(--ds-elevation-surface-current, #FFFFFF)"
};
var $ebe1decd94278ef0$export$8473307aa00d6ea1 = {
    "color.text": "var(--ds-text, #172B4D)",
    "color.text.accent.lime": "var(--ds-text-accent-lime, #4C6B1F)",
    "color.text.accent.lime.bolder": "var(--ds-text-accent-lime-bolder, #37471F)",
    "color.text.accent.red": "var(--ds-text-accent-red, #DE350B)",
    "color.text.accent.red.bolder": "var(--ds-text-accent-red-bolder, #BF2600)",
    "color.text.accent.orange": "var(--ds-text-accent-orange, #F18D13)",
    "color.text.accent.orange.bolder": "var(--ds-text-accent-orange-bolder, #B65C02)",
    "color.text.accent.yellow": "var(--ds-text-accent-yellow, #FF991F)",
    "color.text.accent.yellow.bolder": "var(--ds-text-accent-yellow-bolder, #FF8B00)",
    "color.text.accent.green": "var(--ds-text-accent-green, #00875A)",
    "color.text.accent.green.bolder": "var(--ds-text-accent-green-bolder, #006644)",
    "color.text.accent.teal": "var(--ds-text-accent-teal, #00A3BF)",
    "color.text.accent.teal.bolder": "var(--ds-text-accent-teal-bolder, #008DA6)",
    "color.text.accent.blue": "var(--ds-text-accent-blue, #0052CC)",
    "color.text.accent.blue.bolder": "var(--ds-text-accent-blue-bolder, #0747A6)",
    "color.text.accent.purple": "var(--ds-text-accent-purple, #5243AA)",
    "color.text.accent.purple.bolder": "var(--ds-text-accent-purple-bolder, #403294)",
    "color.text.accent.magenta": "var(--ds-text-accent-magenta, #E774BB)",
    "color.text.accent.magenta.bolder": "var(--ds-text-accent-magenta-bolder, #DA62AC)",
    "color.text.accent.gray": "var(--ds-text-accent-gray, #505F79)",
    "color.text.accent.gray.bolder": "var(--ds-text-accent-gray-bolder, #172B4D)",
    "color.text.disabled": "var(--ds-text-disabled, #A5ADBA)",
    "color.text.inverse": "var(--ds-text-inverse, #FFFFFF)",
    "color.text.selected": "var(--ds-text-selected, #0052CC)",
    "color.text.brand": "var(--ds-text-brand, #0065FF)",
    "color.text.danger": "var(--ds-text-danger, #DE350B)",
    "color.text.warning": "var(--ds-text-warning, #974F0C)",
    "color.text.warning.inverse": "var(--ds-text-warning-inverse, #172B4D)",
    "color.text.success": "var(--ds-text-success, #006644)",
    "color.text.discovery": "var(--ds-text-discovery, #403294)",
    "color.text.information": "var(--ds-text-information, #0052CC)",
    "color.text.subtlest": "var(--ds-text-subtlest, #7A869A)",
    "color.text.subtle": "var(--ds-text-subtle, #42526E)",
    "color.link": "var(--ds-link, #0052CC)",
    "color.link.pressed": "var(--ds-link-pressed, #0747A6)",
    "color.link.visited": "var(--ds-link-visited, #403294)",
    "color.link.visited.pressed": "var(--ds-link-visited-pressed, #403294)"
};
var $ebe1decd94278ef0$export$498780f74be9af68 = {
    "color.icon": "var(--ds-icon, #505F79)",
    "color.icon.accent.lime": "var(--ds-icon-accent-lime, #6A9A23)",
    "color.icon.accent.red": "var(--ds-icon-accent-red, #FF5630)",
    "color.icon.accent.orange": "var(--ds-icon-accent-orange, #D94008)",
    "color.icon.accent.yellow": "var(--ds-icon-accent-yellow, #FFAB00)",
    "color.icon.accent.green": "var(--ds-icon-accent-green, #36B37E)",
    "color.icon.accent.teal": "var(--ds-icon-accent-teal, #00B8D9)",
    "color.icon.accent.blue": "var(--ds-icon-accent-blue, #0065FF)",
    "color.icon.accent.purple": "var(--ds-icon-accent-purple, #6554C0)",
    "color.icon.accent.magenta": "var(--ds-icon-accent-magenta, #CD519D)",
    "color.icon.accent.gray": "var(--ds-icon-accent-gray, #5E6C84)",
    "color.icon.disabled": "var(--ds-icon-disabled, #8993A4)",
    "color.icon.inverse": "var(--ds-icon-inverse, #FFFFFF)",
    "color.icon.selected": "var(--ds-icon-selected, #0052CC)",
    "color.icon.brand": "var(--ds-icon-brand, #0065FF)",
    "color.icon.danger": "var(--ds-icon-danger, #DE350B)",
    "color.icon.warning": "var(--ds-icon-warning, #FFC400)",
    "color.icon.warning.inverse": "var(--ds-icon-warning-inverse, #253858)",
    "color.icon.success": "var(--ds-icon-success, #00875A)",
    "color.icon.discovery": "var(--ds-icon-discovery, #8777D9)",
    "color.icon.information": "var(--ds-icon-information, #0747A6)",
    "color.icon.subtle": "var(--ds-icon-subtle, #6B778C)"
};
var $ebe1decd94278ef0$export$b5f31a7e431d2eab = {
    card: 100,
    navigation: 200,
    dialog: 300,
    layer: 400,
    blanket: 500,
    modal: 510,
    flag: 600,
    spotlight: 700,
    tooltip: 800
};
var $ebe1decd94278ef0$export$e1b83c5210c471b8 = {
    "border.width": "var(--ds-border-width, 1px)",
    "border.width.0": "var(--ds-border-width-0, 0px)",
    "border.width.indicator": "var(--ds-border-width-indicator, 3px)",
    "border.width.outline": "var(--ds-border-width-outline, 2px)"
};
var $ebe1decd94278ef0$export$3c0a6c3e64bb180d = {
    "border.radius.050": "var(--ds-border-radius-050, 2px)",
    "border.radius": "var(--ds-border-radius, 3px)",
    "border.radius.100": "var(--ds-border-radius-100, 3px)",
    "border.radius.200": "var(--ds-border-radius-200, 8px)",
    "border.radius.300": "var(--ds-border-radius-300, 12px)",
    "border.radius.400": "var(--ds-border-radius-400, 16px)",
    "border.radius.circle": "var(--ds-border-radius-circle, 32032px)"
};
var $ebe1decd94278ef0$export$6cc560b4dedf3816 = {
    medium: 'var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    UNSAFE_small: 'var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    large: 'var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    small: 'var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)'
};
var $ebe1decd94278ef0$export$303e322c6b1ed114 = {
    bold: "var(--ds-font-weight-bold, 700)",
    medium: "var(--ds-font-weight-medium, 500)",
    regular: "var(--ds-font-weight-regular, 400)",
    semibold: "var(--ds-font-weight-semibold, 600)"
};
var $ebe1decd94278ef0$export$3c7e9587132614b4 = {
    "font.family.body": 'var(--ds-font-family-body, ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.family.brand.body": 'var(--ds-font-family-brand-body, "Charlie Text", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.family.brand.heading": 'var(--ds-font-family-brand-heading, "Charlie Display", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.family.code": 'var(--ds-font-family-code, ui-monospace, Menlo, "Segoe UI Mono", "Ubuntu Mono", monospace)',
    "font.family.heading": 'var(--ds-font-family-heading, ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)'
};
/**
 * @codegenEnd
 */ // Margin needs some bespoke types: https://atlassian.slack.com/archives/CKRHB23K8/p1712623192772909
// Generate maps for Box props. backgroundColor, padding, etc
var $ebe1decd94278ef0$var$spacingProperties = [
    // Used by Box
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    // Used by Inline and Stack
    "gap",
    "rowGap",
    "columnGap"
];
var $ebe1decd94278ef0$var$getSerializedStylesMap = function getSerializedStylesMap(cssProperty, tokenMap) {
    return Object.keys(tokenMap).reduce(function(emotionSpacingMap, token) {
        emotionSpacingMap[token] = (0, $jVTBW.css)((0, (/*@__PURE__*/$parcel$interopDefault($c3ec97511ae1ed64$exports)))({}, cssProperty, tokenMap[token]));
        return emotionSpacingMap;
    }, {});
};
var $ebe1decd94278ef0$export$e615f061ca585a6c = $ebe1decd94278ef0$var$spacingProperties.reduce(function(styleMap, spacingProperty) {
    styleMap[spacingProperty] = $ebe1decd94278ef0$var$getSerializedStylesMap(spacingProperty, $ebe1decd94278ef0$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
var $ebe1decd94278ef0$export$bf46c3f9eeafc71f = $ebe1decd94278ef0$var$spacingProperties.reduce(function(styleMap, spacingProperty) {
    styleMap[spacingProperty] = $ebe1decd94278ef0$var$getSerializedStylesMap(spacingProperty, $ebe1decd94278ef0$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
var $ebe1decd94278ef0$export$e7af83bafe7f9e63 = $ebe1decd94278ef0$var$getSerializedStylesMap("backgroundColor", $ebe1decd94278ef0$export$d1d79bf68ac056bd);
var $ebe1decd94278ef0$export$3a1bcba60b23d7f0 = $ebe1decd94278ef0$var$getSerializedStylesMap("color", $ebe1decd94278ef0$export$8473307aa00d6ea1);
var $ebe1decd94278ef0$export$45f3f4fe16f9f7d5 = $ebe1decd94278ef0$var$getSerializedStylesMap("fontWeight", $ebe1decd94278ef0$export$303e322c6b1ed114);
var $ebe1decd94278ef0$export$68cc305da27dbaa4 = $ebe1decd94278ef0$var$getSerializedStylesMap("fontFamily", $ebe1decd94278ef0$export$3c7e9587132614b4);
var $ebe1decd94278ef0$export$128f10c238242f83 = $ebe1decd94278ef0$var$getSerializedStylesMap("font", $ebe1decd94278ef0$export$6cc560b4dedf3816);
var $ebe1decd94278ef0$export$ff257d957d48c421 = $ebe1decd94278ef0$var$getSerializedStylesMap((0, $3af0e6fda2aad772$export$9d7b58831ae93caa), $ebe1decd94278ef0$export$41a358c9c2356760);
var $ebe1decd94278ef0$export$5e65a44e5b6ecadb = function isSurfaceColorToken(color) {
    return $ebe1decd94278ef0$export$41a358c9c2356760[color] !== undefined;
};



var $ahJoN = parcelRequire("ahJoN");
function $63532adf9c22de9a$var$_createForOfIteratorHelper(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (!it) {
        if (Array.isArray(o) || (it = $63532adf9c22de9a$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
            if (it) o = it;
            var i = 0;
            var F = function F() {};
            return {
                s: F,
                n: function n() {
                    if (i >= o.length) return {
                        done: true
                    };
                    return {
                        done: false,
                        value: o[i++]
                    };
                },
                e: function e(_e) {
                    throw _e;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var normalCompletion = true, didErr = false, err;
    return {
        s: function s() {
            it = it.call(o);
        },
        n: function n() {
            var step = it.next();
            normalCompletion = step.done;
            return step;
        },
        e: function e(_e2) {
            didErr = true;
            err = _e2;
        },
        f: function f() {
            try {
                if (!normalCompletion && it.return != null) it.return();
            } finally{
                if (didErr) throw err;
            }
        }
    };
}
function $63532adf9c22de9a$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $63532adf9c22de9a$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $63532adf9c22de9a$var$_arrayLikeToArray(o, minLen);
}
function $63532adf9c22de9a$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $63532adf9c22de9a$export$9a199fbafee0014e = {
    backgroundColor: (0, $ebe1decd94278ef0$export$d1d79bf68ac056bd),
    blockSize: (0, $ebe1decd94278ef0$export$6ccdbebca2ee545f),
    borderBlockColor: (0, $ebe1decd94278ef0$export$1531ad5bb3fbedac),
    borderBlockEndColor: (0, $ebe1decd94278ef0$export$1531ad5bb3fbedac),
    borderBlockEndWidth: (0, $ebe1decd94278ef0$export$e1b83c5210c471b8),
    borderBlockStartColor: (0, $ebe1decd94278ef0$export$1531ad5bb3fbedac),
    borderBlockStartWidth: (0, $ebe1decd94278ef0$export$e1b83c5210c471b8),
    borderBlockWidth: (0, $ebe1decd94278ef0$export$e1b83c5210c471b8),
    borderBottomColor: (0, $ebe1decd94278ef0$export$1531ad5bb3fbedac),
    borderBottomLeftRadius: (0, $ebe1decd94278ef0$export$3c0a6c3e64bb180d),
    borderBottomRightRadius: (0, $ebe1decd94278ef0$export$3c0a6c3e64bb180d),
    borderBottomWidth: (0, $ebe1decd94278ef0$export$e1b83c5210c471b8),
    borderColor: (0, $ebe1decd94278ef0$export$1531ad5bb3fbedac),
    borderEndEndRadius: (0, $ebe1decd94278ef0$export$3c0a6c3e64bb180d),
    borderEndStartRadius: (0, $ebe1decd94278ef0$export$3c0a6c3e64bb180d),
    borderInlineColor: (0, $ebe1decd94278ef0$export$1531ad5bb3fbedac),
    borderInlineEndColor: (0, $ebe1decd94278ef0$export$1531ad5bb3fbedac),
    borderInlineEndWidth: (0, $ebe1decd94278ef0$export$e1b83c5210c471b8),
    borderInlineStartColor: (0, $ebe1decd94278ef0$export$1531ad5bb3fbedac),
    borderInlineStartWidth: (0, $ebe1decd94278ef0$export$e1b83c5210c471b8),
    borderInlineWidth: (0, $ebe1decd94278ef0$export$e1b83c5210c471b8),
    borderLeftColor: (0, $ebe1decd94278ef0$export$1531ad5bb3fbedac),
    borderLeftWidth: (0, $ebe1decd94278ef0$export$e1b83c5210c471b8),
    borderRadius: (0, $ebe1decd94278ef0$export$3c0a6c3e64bb180d),
    borderRightColor: (0, $ebe1decd94278ef0$export$1531ad5bb3fbedac),
    borderRightWidth: (0, $ebe1decd94278ef0$export$e1b83c5210c471b8),
    borderStartEndRadius: (0, $ebe1decd94278ef0$export$3c0a6c3e64bb180d),
    borderStartStartRadius: (0, $ebe1decd94278ef0$export$3c0a6c3e64bb180d),
    borderTopColor: (0, $ebe1decd94278ef0$export$1531ad5bb3fbedac),
    borderTopLeftRadius: (0, $ebe1decd94278ef0$export$3c0a6c3e64bb180d),
    borderTopRightRadius: (0, $ebe1decd94278ef0$export$3c0a6c3e64bb180d),
    borderTopWidth: (0, $ebe1decd94278ef0$export$e1b83c5210c471b8),
    borderWidth: (0, $ebe1decd94278ef0$export$e1b83c5210c471b8),
    bottom: (0, $ebe1decd94278ef0$export$632685d741f3dbbf),
    boxShadow: (0, $ebe1decd94278ef0$export$7aff6e7ba39bb774),
    color: (0, $ebe1decd94278ef0$export$8473307aa00d6ea1),
    columnGap: (0, $ebe1decd94278ef0$export$958d0ae7f2977ae4),
    gap: (0, $ebe1decd94278ef0$export$958d0ae7f2977ae4),
    height: (0, $ebe1decd94278ef0$export$6ccdbebca2ee545f),
    inlineSize: (0, $ebe1decd94278ef0$export$6ccdbebca2ee545f),
    inset: (0, $ebe1decd94278ef0$export$632685d741f3dbbf),
    insetBlock: (0, $ebe1decd94278ef0$export$632685d741f3dbbf),
    insetBlockEnd: (0, $ebe1decd94278ef0$export$632685d741f3dbbf),
    insetBlockStart: (0, $ebe1decd94278ef0$export$632685d741f3dbbf),
    insetInline: (0, $ebe1decd94278ef0$export$632685d741f3dbbf),
    insetInlineEnd: (0, $ebe1decd94278ef0$export$632685d741f3dbbf),
    insetInlineStart: (0, $ebe1decd94278ef0$export$632685d741f3dbbf),
    left: (0, $ebe1decd94278ef0$export$632685d741f3dbbf),
    margin: (0, $ebe1decd94278ef0$export$632685d741f3dbbf),
    marginBlock: (0, $ebe1decd94278ef0$export$632685d741f3dbbf),
    marginBlockEnd: (0, $ebe1decd94278ef0$export$632685d741f3dbbf),
    marginBlockStart: (0, $ebe1decd94278ef0$export$632685d741f3dbbf),
    marginBottom: (0, $ebe1decd94278ef0$export$632685d741f3dbbf),
    marginInline: (0, $ebe1decd94278ef0$export$632685d741f3dbbf),
    marginInlineEnd: (0, $ebe1decd94278ef0$export$632685d741f3dbbf),
    marginInlineStart: (0, $ebe1decd94278ef0$export$632685d741f3dbbf),
    marginLeft: (0, $ebe1decd94278ef0$export$632685d741f3dbbf),
    marginRight: (0, $ebe1decd94278ef0$export$632685d741f3dbbf),
    marginTop: (0, $ebe1decd94278ef0$export$632685d741f3dbbf),
    maxBlockSize: (0, $ebe1decd94278ef0$export$6ccdbebca2ee545f),
    maxHeight: (0, $ebe1decd94278ef0$export$6ccdbebca2ee545f),
    maxInlineSize: (0, $ebe1decd94278ef0$export$6ccdbebca2ee545f),
    maxWidth: (0, $ebe1decd94278ef0$export$6ccdbebca2ee545f),
    minBlockSize: (0, $ebe1decd94278ef0$export$6ccdbebca2ee545f),
    minHeight: (0, $ebe1decd94278ef0$export$6ccdbebca2ee545f),
    minInlineSize: (0, $ebe1decd94278ef0$export$6ccdbebca2ee545f),
    minWidth: (0, $ebe1decd94278ef0$export$6ccdbebca2ee545f),
    opacity: (0, $ebe1decd94278ef0$export$daf94a976c798b4f),
    outlineColor: (0, $ebe1decd94278ef0$export$1531ad5bb3fbedac),
    outlineOffset: (0, $ebe1decd94278ef0$export$958d0ae7f2977ae4),
    outlineWidth: (0, $ebe1decd94278ef0$export$e1b83c5210c471b8),
    padding: (0, $ebe1decd94278ef0$export$958d0ae7f2977ae4),
    paddingBlock: (0, $ebe1decd94278ef0$export$958d0ae7f2977ae4),
    paddingBlockEnd: (0, $ebe1decd94278ef0$export$958d0ae7f2977ae4),
    paddingBlockStart: (0, $ebe1decd94278ef0$export$958d0ae7f2977ae4),
    paddingBottom: (0, $ebe1decd94278ef0$export$958d0ae7f2977ae4),
    paddingInline: (0, $ebe1decd94278ef0$export$958d0ae7f2977ae4),
    paddingInlineEnd: (0, $ebe1decd94278ef0$export$958d0ae7f2977ae4),
    paddingInlineStart: (0, $ebe1decd94278ef0$export$958d0ae7f2977ae4),
    paddingLeft: (0, $ebe1decd94278ef0$export$958d0ae7f2977ae4),
    paddingRight: (0, $ebe1decd94278ef0$export$958d0ae7f2977ae4),
    paddingTop: (0, $ebe1decd94278ef0$export$958d0ae7f2977ae4),
    right: (0, $ebe1decd94278ef0$export$632685d741f3dbbf),
    rowGap: (0, $ebe1decd94278ef0$export$958d0ae7f2977ae4),
    top: (0, $ebe1decd94278ef0$export$632685d741f3dbbf),
    width: (0, $ebe1decd94278ef0$export$6ccdbebca2ee545f),
    zIndex: (0, $ebe1decd94278ef0$export$b5f31a7e431d2eab)
};
var $63532adf9c22de9a$var$uniqueSymbol = Symbol("UNSAFE_INTERNAL_styles");
var $63532adf9c22de9a$var$isSafeEnvToThrow = function isSafeEnvToThrow() {
    return (typeof $ahJoN === "undefined" ? "undefined" : (0, (/*@__PURE__*/$parcel$interopDefault($6J7ZY)))($ahJoN)) === "object" && (0, (/*@__PURE__*/$parcel$interopDefault($6J7ZY)))($ahJoN.env) === "object" && false;
};
var $63532adf9c22de9a$var$reNestedSelectors = /(\.|\s|&+|\*\>|#|\[.*\])/;
var $63532adf9c22de9a$var$safeSelectors = /^@media .*$|^::?.*$|^@supports .*$/;
var $63532adf9c22de9a$var$transformStyles = function transformStyles(styleObj) {
    if (!styleObj || (0, (/*@__PURE__*/$parcel$interopDefault($6J7ZY)))(styleObj) !== "object") return styleObj;
    // If styles are defined as a CSSObject[], recursively call on each element until we reach CSSObject
    if (Array.isArray(styleObj)) return styleObj.map(transformStyles);
    // Modifies styleObj in place. Be careful.
    Object.entries(styleObj).forEach(function(_ref) {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($6f4c9344050d46f7$exports)))(_ref, 2), key = _ref2[0], value = _ref2[1];
        // If key is a pseudo class or a pseudo element, then value should be an object.
        // So, call transformStyles on the value
        if ((0, (/*@__PURE__*/$parcel$interopDefault($6J7ZY)))(value) === "object" && $63532adf9c22de9a$var$safeSelectors.test(key)) {
            styleObj[key] = transformStyles(value);
            return;
        }
        if ($63532adf9c22de9a$var$isSafeEnvToThrow()) {
            // We don't support `.class`, `[data-testid]`, `> *`, `#some-id`
            if ($63532adf9c22de9a$var$reNestedSelectors.test(key)) throw new Error("Styles not supported for key '".concat(key, "'."));
        }
        // We have now dealt with all the special cases, so,
        // check whether what remains is a style property
        // that can be transformed.
        if (!(key in $63532adf9c22de9a$export$9a199fbafee0014e)) return;
        var tokenValue = $63532adf9c22de9a$export$9a199fbafee0014e[key][value];
        styleObj[key] = tokenValue !== null && tokenValue !== void 0 ? tokenValue : value;
    });
    return styleObj;
};
var $63532adf9c22de9a$var$baseXcss = function baseXcss(style) {
    var transformedStyles = $63532adf9c22de9a$var$transformStyles(style);
    return (0, (/*@__PURE__*/$parcel$interopDefault($c3ec97511ae1ed64$exports)))({}, $63532adf9c22de9a$var$uniqueSymbol, (0, $jVTBW.css)(transformedStyles));
};
var $63532adf9c22de9a$export$a9c84988c8f81f2d = function parseXcss(args) {
    if (Array.isArray(args)) {
        var emotion = [];
        var staticArr = [];
        var _iterator = $63532adf9c22de9a$var$_createForOfIteratorHelper(args), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var arg = _step.value;
                var result = parseXcss(arg);
                if (result.emotion) emotion.push.apply(emotion, (0, (/*@__PURE__*/$parcel$interopDefault($d5f3651f1c5ee1c2$exports)))(result.emotion));
                if (result.static) staticArr.push(result.static);
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        return {
            emotion: emotion,
            static: staticArr.join(" ")
        };
    }
    var objArgs = args;
    var _ref4 = objArgs || {}, styles = _ref4[$63532adf9c22de9a$var$uniqueSymbol];
    if (styles) return {
        emotion: [
            styles
        ]
    };
    if (args) {
        // We use string interpolation here instead of .toString() just
        // in case the resulting object doesn't have the method available.
        var stringifiedArgs = "".concat(args);
        if (stringifiedArgs) return {
            static: stringifiedArgs
        };
    }
    return {};
};
function $63532adf9c22de9a$export$f6c783d06584602c(style) {
    return $63532adf9c22de9a$var$baseXcss(style);
}


/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $dAx5m = parcelRequire("dAx5m");

var $jVTBW = parcelRequire("jVTBW");


var $589b983f60f6a073$var$justifyContentMap = {
    start: (0, $jVTBW.css)({
        justifyContent: "start"
    }),
    center: (0, $jVTBW.css)({
        justifyContent: "center"
    }),
    end: (0, $jVTBW.css)({
        justifyContent: "end"
    }),
    "space-between": (0, $jVTBW.css)({
        justifyContent: "space-between"
    }),
    "space-around": (0, $jVTBW.css)({
        justifyContent: "space-around"
    }),
    "space-evenly": (0, $jVTBW.css)({
        justifyContent: "space-evenly"
    }),
    stretch: (0, $jVTBW.css)({
        justifyContent: "stretch"
    })
};
var $589b983f60f6a073$var$flexDirectionMap = {
    column: (0, $jVTBW.css)({
        flexDirection: "column"
    }),
    row: (0, $jVTBW.css)({
        flexDirection: "row"
    })
};
var $589b983f60f6a073$var$flexWrapMap = {
    wrap: (0, $jVTBW.css)({
        flexWrap: "wrap"
    }),
    nowrap: (0, $jVTBW.css)({
        flexWrap: "nowrap"
    })
};
var $589b983f60f6a073$var$alignItemsMap = {
    start: (0, $jVTBW.css)({
        alignItems: "start"
    }),
    center: (0, $jVTBW.css)({
        alignItems: "center"
    }),
    baseline: (0, $jVTBW.css)({
        alignItems: "baseline"
    }),
    end: (0, $jVTBW.css)({
        alignItems: "end"
    }),
    stretch: (0, $jVTBW.css)({
        alignItems: "stretch"
    })
};
var $589b983f60f6a073$var$baseStyles = (0, $jVTBW.css)({
    display: "flex",
    boxSizing: "border-box"
});
/**
 * __Flex__
 *
 * `Flex` is a primitive component that implements the CSS Flexbox API.
 *
 * - [Examples](https://atlassian.design/components/primitives/flex/examples)
 * - [Code](https://atlassian.design/components/primitives/flex/code)
 *
 * @example
 * ```tsx
 * import { Flex, Box } from '@atlaskit/primitives'
 *
 * const Component = () => (
 *   <Flex direction="column">
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *   </Flex>
 * )
 * ```
 */ var $589b983f60f6a073$var$Flex = /*#__PURE__*/ (0, $dAx5m.memo)(/*#__PURE__*/ (0, $dAx5m.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? "div" : _ref$as, role = _ref.role, alignItems = _ref.alignItems, justifyContent = _ref.justifyContent, gap = _ref.gap, columnGap = _ref.columnGap, rowGap = _ref.rowGap, children = _ref.children, testId = _ref.testId, direction = _ref.direction, wrap = _ref.wrap, xcss = _ref.xcss;
    var resolvedStyles = (0, $63532adf9c22de9a$export$a9c84988c8f81f2d)(xcss);
    return (0, $jVTBW.jsx)(Component, {
        role: role,
        className: resolvedStyles.static,
        css: [
            $589b983f60f6a073$var$baseStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            gap && (0, $ebe1decd94278ef0$export$bf46c3f9eeafc71f).gap[gap],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            columnGap && (0, $ebe1decd94278ef0$export$bf46c3f9eeafc71f).columnGap[columnGap],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            rowGap && (0, $ebe1decd94278ef0$export$bf46c3f9eeafc71f).rowGap[rowGap],
            alignItems && $589b983f60f6a073$var$alignItemsMap[alignItems],
            direction && $589b983f60f6a073$var$flexDirectionMap[direction],
            justifyContent && $589b983f60f6a073$var$justifyContentMap[justifyContent],
            wrap && $589b983f60f6a073$var$flexWrapMap[wrap],
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
            resolvedStyles.emotion
        ],
        "data-testid": testId,
        ref: ref
    }, children);
}));
$589b983f60f6a073$var$Flex.displayName = "Flex";
var $589b983f60f6a073$export$2e2bcd8739ae039 = $589b983f60f6a073$var$Flex;


var $eed02ca94bb77104$var$flexGrowMap = {
    hug: (0, $63532adf9c22de9a$export$f6c783d06584602c)({
        flexGrow: 0
    }),
    fill: (0, $63532adf9c22de9a$export$f6c783d06584602c)({
        width: "100%",
        flexGrow: 1
    })
};
var $eed02ca94bb77104$var$separatorStyles = (0, $jVTBW.css)({
    color: "var(--ds-text-subtle, #42526E)",
    marginBlock: "var(--ds-space-0, 0px)",
    marginInline: "var(--ds-space-negative-025, -2px)",
    pointerEvents: "none",
    userSelect: "none"
});
var $eed02ca94bb77104$var$Separator = function Separator(_ref) {
    var children = _ref.children;
    return (0, $jVTBW.jsx)("span", {
        css: $eed02ca94bb77104$var$separatorStyles
    }, children);
};
/**
 * __Inline__
 *
 * Inline is a primitive component based on CSS Flexbox that manages the horizontal layout of direct children.
 *
 * @example
 * ```tsx
 *  <Inline>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *  </Inline>
 * ```
 *
 */ var $eed02ca94bb77104$var$Inline = /*#__PURE__*/ (0, $dAx5m.memo)(/*#__PURE__*/ (0, $dAx5m.forwardRef)(function(_ref2, ref) {
    var as = _ref2.as, alignInline = _ref2.alignInline, _ref2$alignBlock = _ref2.alignBlock, alignItems = _ref2$alignBlock === void 0 ? "start" : _ref2$alignBlock, _ref2$shouldWrap = _ref2.shouldWrap, shouldWrap = _ref2$shouldWrap === void 0 ? false : _ref2$shouldWrap, spread = _ref2.spread, grow = _ref2.grow, space = _ref2.space, rowSpace = _ref2.rowSpace, separator = _ref2.separator, xcss = _ref2.xcss, testId = _ref2.testId, role = _ref2.role, rawChildren = _ref2.children;
    var separatorComponent = typeof separator === "string" ? (0, $jVTBW.jsx)($eed02ca94bb77104$var$Separator, null, separator) : separator;
    var children = separatorComponent ? (0, $dAx5m.Children).toArray(rawChildren).filter(Boolean).map(function(child, index) {
        return (0, $jVTBW.jsx)((0, $dAx5m.Fragment), {
            key: index
        }, separator && index > 0 ? separatorComponent : null, child);
    }) : rawChildren;
    var justifyContent = spread || alignInline;
    // We're type coercing this as Compiled styles in an array isn't supported by the types
    // But the runtime accepts it none-the-wiser. We can remove this entire block and replace
    // it with cx(defaultStyles, focusRingStyles, xcssStyles) when we've moved away from Emotion.
    var styles = grow ? [
        $eed02ca94bb77104$var$flexGrowMap[grow]
    ].concat((0, (/*@__PURE__*/$parcel$interopDefault($d5f3651f1c5ee1c2$exports)))(Array.isArray(xcss) ? xcss : [
        xcss
    ])) : xcss;
    return (0, $jVTBW.jsx)((0, $589b983f60f6a073$export$2e2bcd8739ae039), {
        as: as,
        role: role,
        alignItems: alignItems,
        justifyContent: justifyContent,
        direction: "row",
        gap: space,
        rowGap: rowSpace,
        wrap: shouldWrap ? "wrap" : undefined,
        xcss: styles,
        testId: testId,
        ref: ref
    }, children);
}));
$eed02ca94bb77104$var$Inline.displayName = "Inline";
var $eed02ca94bb77104$export$2e2bcd8739ae039 = $eed02ca94bb77104$var$Inline;



var $dAx5m = parcelRequire("dAx5m");

var $jVTBW = parcelRequire("jVTBW");


var $9574cd5f9e265737$var$flexGrowMap = {
    hug: (0, $63532adf9c22de9a$export$f6c783d06584602c)({
        flexGrow: 0
    }),
    fill: (0, $63532adf9c22de9a$export$f6c783d06584602c)({
        width: "100%",
        flexGrow: 1
    })
};
/**
 * __Stack__
 *
 * Stack is a primitive component based on flexbox that manages the block layout of direct children.
 *
 * @example
 * ```tsx
 *  <Stack>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *  </Stack>
 * ```
 *
 */ var $9574cd5f9e265737$var$Stack = /*#__PURE__*/ (0, $dAx5m.memo)(/*#__PURE__*/ (0, $dAx5m.forwardRef)(function(_ref, ref) {
    var as = _ref.as, alignItems = _ref.alignInline, _ref$alignBlock = _ref.alignBlock, alignBlock = _ref$alignBlock === void 0 ? "stretch" : _ref$alignBlock, spread = _ref.spread, grow = _ref.grow, space = _ref.space, children = _ref.children, testId = _ref.testId, xcss = _ref.xcss, role = _ref.role;
    var justifyContent = spread || alignBlock;
    // We're type coercing this as Compiled styles in an array isn't supported by the types
    // But the runtime accepts it none-the-wiser. We can remove this entire block and replace
    // it with cx(defaultStyles, focusRingStyles, xcssStyles) when we've moved away from Emotion.
    var styles = grow ? [
        $9574cd5f9e265737$var$flexGrowMap[grow]
    ].concat((0, (/*@__PURE__*/$parcel$interopDefault($d5f3651f1c5ee1c2$exports)))(Array.isArray(xcss) ? xcss : [
        xcss
    ])) : xcss;
    return (0, $jVTBW.jsx)((0, $589b983f60f6a073$export$2e2bcd8739ae039), {
        as: as,
        role: role,
        gap: space,
        direction: "column",
        alignItems: alignItems,
        justifyContent: justifyContent,
        xcss: styles,
        testId: testId,
        ref: ref
    }, children);
}));
$9574cd5f9e265737$var$Stack.displayName = "Stack";
var $9574cd5f9e265737$export$2e2bcd8739ae039 = $9574cd5f9e265737$var$Stack;


/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ /* eslint-disable prefer-rest-params */ 
var $e2xkU = parcelRequire("e2xkU");

var $fadf80e9637982ea$export$44ffba16bd48dac6 = "__ATLASKIT_THEME__";
var $fadf80e9637982ea$export$c93026a968943f95 = "light";
var $fadf80e9637982ea$export$6ba72c8346b4c57e = [
    "light",
    "dark"
];
var $fadf80e9637982ea$export$7a57f79000377ca2 = function borderRadius() {
    return 3;
};
var $fadf80e9637982ea$export$6d8204c2cb2e06b8 = function gridSize() {
    return 8;
};
var $fadf80e9637982ea$export$85e3c3ca0c6fb93 = function fontSize() {
    return 14;
};
var $fadf80e9637982ea$export$6746fe0d9c9fab54 = function fontSizeSmall() {
    return 11;
};
var $fadf80e9637982ea$export$a5975749f0374264 = function fontFamily() {
    return "-apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif";
};
var $fadf80e9637982ea$export$356129969ee49c55 = function codeFontFamily() {
    return "'SFMono-Medium', 'SF Mono', 'Segoe UI Mono', 'Roboto Mono', 'Ubuntu Mono', Menlo, Consolas, Courier, monospace";
};
var $fadf80e9637982ea$export$8e24544ddba725ee = function focusRing() {
    var color = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "var(--ds-border-focused, ".concat((0, $e996865a8c4821b6$export$215b7063051591f1), ")");
    var outlineWidth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $fadf80e9637982ea$export$6d8204c2cb2e06b8() / 4;
    (0, $e2xkU.default)("@atlaskit/theme", "focus ring mixin", "Please use `@atlaskit/focus-ring` instead.");
    return "\n  &:focus {\n    outline: none;\n    box-shadow: 0px 0px 0px ".concat(outlineWidth, "px ").concat(color, ";\n  }\n");
};
var $fadf80e9637982ea$export$c0dd343266bc3261 = function noFocusRing() {
    return "\n  box-shadow: none;\n";
};
var $fadf80e9637982ea$export$7be255094ccdc533 = {
    card: function card() {
        return 100;
    },
    navigation: function navigation() {
        return 200;
    },
    dialog: function dialog() {
        return 300;
    },
    layer: function layer() {
        return 400;
    },
    blanket: function blanket() {
        return 500;
    },
    modal: function modal() {
        return 510;
    },
    flag: function flag() {
        return 600;
    },
    spotlight: function spotlight() {
        return 700;
    },
    tooltip: function tooltip() {
        return 9999;
    }
};
var $fadf80e9637982ea$export$a1b3edb637fb4f35 = function visuallyHidden() {
    (0, $e2xkU.default)("@atlaskit/theme", "visually hidden mixin", "Please use `@atlaskit/visually-hidden` instead.");
    return {
        border: "0 !important",
        clip: "rect(1px, 1px, 1px, 1px) !important",
        height: "1px !important",
        overflow: "hidden !important",
        padding: "0 !important",
        position: "absolute !important",
        width: "1px !important",
        whiteSpace: "nowrap !important"
    };
};
var $fadf80e9637982ea$export$ba1d834b86d72a09 = $fadf80e9637982ea$export$a1b3edb637fb4f35;
var $fadf80e9637982ea$export$e497e856b4f89fcd = function skeletonShimmer() {
    return {
        css: {
            backgroundColor: "var(--ds-skeleton, ".concat((0, $e996865a8c4821b6$export$2a0674ff2eb10214)(), ")"),
            animationDuration: "1.5s",
            animationIterationCount: "infinite",
            animationTimingFunction: "linear",
            animationDirection: "alternate"
        },
        keyframes: {
            from: {
                backgroundColor: "var(--ds-skeleton, ".concat((0, $e996865a8c4821b6$export$2a0674ff2eb10214)(), ")")
            },
            to: {
                backgroundColor: "var(--ds-skeleton-subtle, ".concat((0, $e996865a8c4821b6$export$920c0d5c49070351), ")")
            }
        }
    };
};


function $874b1809f1949ecf$export$2e2bcd8739ae039(props) {
    if (props && props.theme) {
        // Theme is the global Atlaskit theme
        if ((0, $fadf80e9637982ea$export$44ffba16bd48dac6) in props.theme) return props.theme[0, $fadf80e9637982ea$export$44ffba16bd48dac6];
        else if ("mode" in props.theme && (0, $fadf80e9637982ea$export$6ba72c8346b4c57e).includes(props.theme.mode)) return props.theme;
    }
    // If format not supported (or no theme provided), return standard theme
    return {
        mode: (0, $fadf80e9637982ea$export$c93026a968943f95)
    };
}


// Unpack custom variants, and get correct value for the current theme
function $001a839b07442c83$var$themedVariants(variantProp, variants) {
    return function(props) {
        var theme = (0, $874b1809f1949ecf$export$2e2bcd8739ae039)(props);
        if (props && props[variantProp] && variants) {
            var modes = variants[props[variantProp]];
            if (modes && modes[theme.mode]) {
                var value = modes[theme.mode];
                if (value) return value;
                 // TS believes value can be undefined
            }
        }
        return "";
    };
}
function $001a839b07442c83$export$2e2bcd8739ae039(modesOrVariant, variantModes) {
    if (typeof modesOrVariant === "string") return $001a839b07442c83$var$themedVariants(modesOrVariant, variantModes);
    var modes = modesOrVariant;
    return function(props) {
        // Get theme from the user's props
        var theme = (0, $874b1809f1949ecf$export$2e2bcd8739ae039)(props);
        // User isn't required to provide both light and dark values
        if (theme.mode in modes) {
            var value = modes[theme.mode]; // TS believes value can be undefined
            if (value) return value;
        }
        return "";
    };
}


var $e996865a8c4821b6$export$4b84fd0e2c617bd = "#FFEBE6";
var $e996865a8c4821b6$export$b34b069eff244586 = "#FFBDAD";
var $e996865a8c4821b6$export$be802dd0d8b57f35 = "#FF8F73";
var $e996865a8c4821b6$export$60847d42f9da92a6 = "#FF7452";
var $e996865a8c4821b6$export$4a7404f376229999 = "#FF5630";
var $e996865a8c4821b6$export$2010d0fb4295b346 = "#DE350B";
var $e996865a8c4821b6$export$2837b5a1a71d5c02 = "#BF2600";
var $e996865a8c4821b6$export$8d9596b529bbb9cf = "#FFFAE6";
var $e996865a8c4821b6$export$41060a744ab0b7ae = "#FFF0B3";
var $e996865a8c4821b6$export$1cc05bbbf340e559 = "#FFE380";
var $e996865a8c4821b6$export$5aae31392d72caaa = "#FFC400";
var $e996865a8c4821b6$export$c6930421db9fa514 = "#FFAB00";
var $e996865a8c4821b6$export$59619663aa6500fb = "#FF991F";
var $e996865a8c4821b6$export$874739ea9e379ab6 = "#FF8B00";
var $e996865a8c4821b6$export$8a6341c32b6a3ee6 = "#E3FCEF";
var $e996865a8c4821b6$export$69a3bf21b9686c2b = "#ABF5D1";
var $e996865a8c4821b6$export$afbce1382ec95f73 = "#79F2C0";
var $e996865a8c4821b6$export$747d86715d4175de = "#57D9A3";
var $e996865a8c4821b6$export$940e1f69e873f202 = "#36B37E";
var $e996865a8c4821b6$export$a49394138f7b8e85 = "#00875A";
var $e996865a8c4821b6$export$6fa04827ac68a4fb = "#006644";
var $e996865a8c4821b6$export$226de0355ed012f8 = "#DEEBFF";
var $e996865a8c4821b6$export$8c13c2ee36917869 = "#B3D4FF";
var $e996865a8c4821b6$export$ecfc1dff386a3e7a = "#4C9AFF";
var $e996865a8c4821b6$export$215b7063051591f1 = "#2684FF";
var $e996865a8c4821b6$export$e62e8919cca44969 = "#0065FF";
var $e996865a8c4821b6$export$b3de0ae08da2ce64 = "#0052CC";
var $e996865a8c4821b6$export$a6ee3d71bc067634 = "#0747A6";
var $e996865a8c4821b6$export$363e4475840015bb = "#EAE6FF";
var $e996865a8c4821b6$export$4b0a4417ed59760f = "#C0B6F2";
var $e996865a8c4821b6$export$6011520a64d9a187 = "#998DD9";
var $e996865a8c4821b6$export$a7175d4e9206bc80 = "#8777D9";
var $e996865a8c4821b6$export$b48405b95304b5a1 = "#6554C0";
var $e996865a8c4821b6$export$c71e4279dd54a18d = "#5243AA";
var $e996865a8c4821b6$export$147899de772240ec = "#403294";
var $e996865a8c4821b6$export$2cf711fe14c66f06 = "#E6FCFF";
var $e996865a8c4821b6$export$7a8f4d33f6f9772c = "#B3F5FF";
var $e996865a8c4821b6$export$776c9c497ef08533 = "#79E2F2";
var $e996865a8c4821b6$export$69cb3ca10c1e330e = "#00C7E6";
var $e996865a8c4821b6$export$9dc1ef0f3f48059b = "#00B8D9";
var $e996865a8c4821b6$export$7c835c78b6fcdef8 = "#00A3BF";
var $e996865a8c4821b6$export$6036577f95c3877e = "#008DA6";
var $e996865a8c4821b6$export$29a4f05edc054374 = "#FFFFFF";
var $e996865a8c4821b6$export$e655ef011c4aa1a2 = "#FAFBFC";
var $e996865a8c4821b6$export$9fdfb749e33cdf97 = "#F4F5F7";
var $e996865a8c4821b6$export$3e51e8f1440314ba = "#EBECF0";
var $e996865a8c4821b6$export$1ce2d1575d444ceb = "#DFE1E6";
var $e996865a8c4821b6$export$8754fc7e6d8b3000 = "#C1C7D0";
var $e996865a8c4821b6$export$c2e91cbeada39b8b = "#B3BAC5";
var $e996865a8c4821b6$export$5f71e19f3a7ad9de = "#A5ADBA";
var $e996865a8c4821b6$export$eaa8c8a70ac22806 = "#97A0AF";
var $e996865a8c4821b6$export$7c87d337fb91a97d = "#8993A4";
var $e996865a8c4821b6$export$d6447c357493214f = "#7A869A";
var $e996865a8c4821b6$export$f563ee71e9ee74cd = "#6B778C";
var $e996865a8c4821b6$export$e2ef2124cf4024b1 = "#5E6C84";
var $e996865a8c4821b6$export$eece5f492e429f08 = "#505F79";
var $e996865a8c4821b6$export$c39c0fe0f26207ae = "#42526E";
var $e996865a8c4821b6$export$7090862dc3038a9f = "#344563";
var $e996865a8c4821b6$export$ad0bacf983b7ddaa = "#253858";
var $e996865a8c4821b6$export$7d61b15e0da132af = "#172B4D";
var $e996865a8c4821b6$export$fbda843f0a27fe96 = "#091E42";
var $e996865a8c4821b6$export$791e57b27ca738ef = "rgba(9, 30, 66, 0.02)";
var $e996865a8c4821b6$export$8d43898f60b96a82 = "rgba(9, 30, 66, 0.04)";
var $e996865a8c4821b6$export$920c0d5c49070351 = "rgba(9, 30, 66, 0.08)";
var $e996865a8c4821b6$export$46987b49aab6d1a8 = "rgba(9, 30, 66, 0.13)";
var $e996865a8c4821b6$export$7d3359664e8bb0e5 = "rgba(9, 30, 66, 0.25)";
var $e996865a8c4821b6$export$d2d3bedfb276cac0 = "rgba(9, 30, 66, 0.31)";
var $e996865a8c4821b6$export$6e5e7499ff054f6d = "rgba(9, 30, 66, 0.36)";
var $e996865a8c4821b6$export$59264b346c877fa7 = "rgba(9, 30, 66, 0.42)";
var $e996865a8c4821b6$export$d092757d7c64925c = "rgba(9, 30, 66, 0.48)";
var $e996865a8c4821b6$export$486ab785e4bac3c6 = "rgba(9, 30, 66, 0.54)";
var $e996865a8c4821b6$export$fba592bbc6419fea = "rgba(9, 30, 66, 0.60)";
var $e996865a8c4821b6$export$13609db0e6812ab8 = "rgba(9, 30, 66, 0.66)";
var $e996865a8c4821b6$export$fbae4efaa892d883 = "rgba(9, 30, 66, 0.71)";
var $e996865a8c4821b6$export$f13946d26f440ce6 = "rgba(9, 30, 66, 0.77)";
var $e996865a8c4821b6$export$19f58225ac52a306 = "rgba(9, 30, 66, 0.82)";
var $e996865a8c4821b6$export$6384f09da70e7b62 = "rgba(9, 30, 66, 0.89)";
var $e996865a8c4821b6$export$d0dccc730683edc2 = "rgba(9, 30, 66, 0.95)";
var $e996865a8c4821b6$export$2f6319cf7d736c2a = "#E6EDFA";
var $e996865a8c4821b6$export$95126bc8884d6634 = "#DCE5F5";
var $e996865a8c4821b6$export$8338d8c35d44ff1 = "#CED9EB";
var $e996865a8c4821b6$export$5368d76ae4fbbda7 = "#B8C7E0";
var $e996865a8c4821b6$export$9f0a771d16ec8d36 = "#ABBBD6";
var $e996865a8c4821b6$export$abcf8c38338b4aa5 = "#9FB0CC";
var $e996865a8c4821b6$export$97e81faa16a182c7 = "#8C9CB8";
var $e996865a8c4821b6$export$bfe21c59123ecf33 = "#7988A3";
var $e996865a8c4821b6$export$ee82aa2ea6a1558 = "#67758F";
var $e996865a8c4821b6$export$682927c6ed76be02 = "#56637A";
var $e996865a8c4821b6$export$91fd9994c5be9757 = "#455166";
var $e996865a8c4821b6$export$d281fbfe3cff2df6 = "#3B475C";
var $e996865a8c4821b6$export$3902c91d8b98a753 = "#313D52";
var $e996865a8c4821b6$export$8e8133c1ba5845b5 = "#283447";
var $e996865a8c4821b6$export$33ff357f6620b39 = "#202B3D";
var $e996865a8c4821b6$export$633847cf062b69e0 = "#1B2638";
var $e996865a8c4821b6$export$9776a6e503bdbf76 = "#121A29";
var $e996865a8c4821b6$export$6c813d5160dff5db = "#0E1624";
var $e996865a8c4821b6$export$3d4f271a500072a = "#0D1424";
var $e996865a8c4821b6$export$fe151285c22759ec = "rgba(13, 20, 36, 0.06)";
var $e996865a8c4821b6$export$a101c6190d0da34 = "rgba(13, 20, 36, 0.14)";
var $e996865a8c4821b6$export$4b16f52932fda51 = "rgba(13, 20, 36, 0.18)";
var $e996865a8c4821b6$export$a74bcd7b9845b0d8 = "rgba(13, 20, 36, 0.29)";
var $e996865a8c4821b6$export$9209c179316d1751 = "rgba(13, 20, 36, 0.36)";
var $e996865a8c4821b6$export$88f55133f636c8dd = "rgba(13, 20, 36, 0.40)";
var $e996865a8c4821b6$export$51126f85d1009512 = "rgba(13, 20, 36, 0.47)";
var $e996865a8c4821b6$export$a069b547bd23af78 = "rgba(13, 20, 36, 0.53)";
var $e996865a8c4821b6$export$40cce05af3b2600a = "rgba(13, 20, 36, 0.63)";
var $e996865a8c4821b6$export$b78942185925a0d = "rgba(13, 20, 36, 0.73)";
var $e996865a8c4821b6$export$e058fb44b8eaafca = "rgba(13, 20, 36, 0.78)";
var $e996865a8c4821b6$export$92b0b8de26920c18 = "rgba(13, 20, 36, 0.81)";
var $e996865a8c4821b6$export$67564f7459d3fc9e = "rgba(13, 20, 36, 0.85)";
var $e996865a8c4821b6$export$77868e1ca884ffa3 = "rgba(13, 20, 36, 0.89)";
var $e996865a8c4821b6$export$2afd71d7d3ea2cd5 = "rgba(13, 20, 36, 0.92)";
var $e996865a8c4821b6$export$f2a0acaab9972c70 = "rgba(13, 20, 36, 0.95)";
var $e996865a8c4821b6$export$9ab70e67d6475361 = "rgba(13, 20, 36, 0.97)";
var $e996865a8c4821b6$export$8ce1fd94bee2f412 = (0, $001a839b07442c83$export$2e2bcd8739ae039)({
    light: "var(--ds-surface, ".concat($e996865a8c4821b6$export$29a4f05edc054374, ")"),
    dark: "var(--ds-surface, ".concat($e996865a8c4821b6$export$633847cf062b69e0, ")")
});
var $e996865a8c4821b6$export$b861914ea877b580 = (0, $001a839b07442c83$export$2e2bcd8739ae039)({
    light: "var(--ds-background-selected, ".concat($e996865a8c4821b6$export$226de0355ed012f8, ")"),
    dark: "var(--ds-background-selected, ".concat($e996865a8c4821b6$export$8c13c2ee36917869, ")")
});
var $e996865a8c4821b6$export$3f1b020df94387af = (0, $001a839b07442c83$export$2e2bcd8739ae039)({
    light: "var(--ds-background-neutral-hovered, ".concat($e996865a8c4821b6$export$3e51e8f1440314ba, ")"),
    dark: "var(--ds-background-neutral-hovered, ".concat($e996865a8c4821b6$export$d281fbfe3cff2df6, ")")
});
var $e996865a8c4821b6$export$c0183dbab98ca63e = (0, $001a839b07442c83$export$2e2bcd8739ae039)({
    light: "var(--ds-surface-overlay, ".concat($e996865a8c4821b6$export$29a4f05edc054374, ")"),
    dark: "var(--ds-surface-overlay, ".concat($e996865a8c4821b6$export$8e8133c1ba5845b5, ")")
});
var $e996865a8c4821b6$export$6f093cfa640b7166 = (0, $001a839b07442c83$export$2e2bcd8739ae039)({
    light: "var(--ds-text, ".concat($e996865a8c4821b6$export$fbda843f0a27fe96, ")"),
    dark: "var(--ds-text, ".concat($e996865a8c4821b6$export$5368d76ae4fbbda7, ")")
});
var $e996865a8c4821b6$export$42f8e9c698766e7a = (0, $001a839b07442c83$export$2e2bcd8739ae039)({
    light: "var(--ds-text, ".concat($e996865a8c4821b6$export$7d61b15e0da132af, ")"),
    dark: "var(--ds-text, ".concat($e996865a8c4821b6$export$5368d76ae4fbbda7, ")")
});
var $e996865a8c4821b6$export$c2d157ca1c34b6e3 = (0, $001a839b07442c83$export$2e2bcd8739ae039)({
    light: "var(--ds-text-selected, ".concat($e996865a8c4821b6$export$b3de0ae08da2ce64, ")"),
    dark: "var(--ds-text-selected, ".concat($e996865a8c4821b6$export$b3de0ae08da2ce64, ")")
});
var $e996865a8c4821b6$export$1905ba28d7cf066f = (0, $001a839b07442c83$export$2e2bcd8739ae039)({
    light: "var(--ds-text-subtlest, ".concat($e996865a8c4821b6$export$f563ee71e9ee74cd, ")"),
    dark: "var(--ds-text-subtlest, ".concat($e996865a8c4821b6$export$97e81faa16a182c7, ")")
});
var $e996865a8c4821b6$export$bd9002130d306d39 = (0, $001a839b07442c83$export$2e2bcd8739ae039)({
    light: "var(--ds-text-subtlest, ".concat($e996865a8c4821b6$export$f563ee71e9ee74cd, ")"),
    dark: "var(--ds-text-subtlest, ".concat($e996865a8c4821b6$export$bfe21c59123ecf33, ")")
});
var $e996865a8c4821b6$export$46e4a324ac90507f = (0, $001a839b07442c83$export$2e2bcd8739ae039)({
    light: "var(--ds-text, ".concat($e996865a8c4821b6$export$7d61b15e0da132af, ")"),
    dark: "var(--ds-text, ".concat($e996865a8c4821b6$export$5368d76ae4fbbda7, ")")
});
var $e996865a8c4821b6$export$79f3f2b82beb0d36 = (0, $001a839b07442c83$export$2e2bcd8739ae039)({
    light: "var(--ds-text-subtlest, ".concat($e996865a8c4821b6$export$f563ee71e9ee74cd, ")"),
    dark: "var(--ds-text-subtlest, ".concat($e996865a8c4821b6$export$97e81faa16a182c7, ")")
});
var $e996865a8c4821b6$export$7bb0d5c671655cc4 = (0, $001a839b07442c83$export$2e2bcd8739ae039)({
    light: $e996865a8c4821b6$export$9fdfb749e33cdf97,
    dark: $e996865a8c4821b6$export$8e8133c1ba5845b5
});
var $e996865a8c4821b6$export$9c30223ca0a664fb = (0, $001a839b07442c83$export$2e2bcd8739ae039)({
    light: "var(--ds-link, ".concat($e996865a8c4821b6$export$b3de0ae08da2ce64, ")"),
    dark: "var(--ds-link, ".concat($e996865a8c4821b6$export$ecfc1dff386a3e7a, ")")
});
var $e996865a8c4821b6$export$7ed258b0728b004b = (0, $001a839b07442c83$export$2e2bcd8739ae039)({
    light: "var(--ds-link-pressed, ".concat($e996865a8c4821b6$export$e62e8919cca44969, ")"),
    dark: "var(--ds-link-pressed, ".concat($e996865a8c4821b6$export$215b7063051591f1, ")")
});
var $e996865a8c4821b6$export$dfa920d8decc8a59 = (0, $001a839b07442c83$export$2e2bcd8739ae039)({
    light: "var(--ds-link-pressed, ".concat($e996865a8c4821b6$export$a6ee3d71bc067634, ")"),
    dark: "var(--ds-link-pressed, ".concat($e996865a8c4821b6$export$ecfc1dff386a3e7a, ")")
});
var $e996865a8c4821b6$export$6069e6ad5c78f632 = (0, $001a839b07442c83$export$2e2bcd8739ae039)({
    light: "var(--ds-border-focused, ".concat($e996865a8c4821b6$export$215b7063051591f1, ")"),
    dark: "var(--ds-border-focused, ".concat($e996865a8c4821b6$export$215b7063051591f1, ")")
});
var $e996865a8c4821b6$export$9ad721cf3b3debe0 = (0, $001a839b07442c83$export$2e2bcd8739ae039)({
    light: "var(--ds-background-brand-bold, ".concat($e996865a8c4821b6$export$b3de0ae08da2ce64, ")"),
    dark: "var(--ds-background-brand-bold, ".concat($e996865a8c4821b6$export$ecfc1dff386a3e7a, ")")
});
var $e996865a8c4821b6$export$2aa0182783e7e9de = (0, $001a839b07442c83$export$2e2bcd8739ae039)({
    light: $e996865a8c4821b6$export$b3de0ae08da2ce64,
    dark: $e996865a8c4821b6$export$ecfc1dff386a3e7a
});
var $e996865a8c4821b6$export$8bf7dff220b82b4a = (0, $001a839b07442c83$export$2e2bcd8739ae039)({
    light: $e996865a8c4821b6$export$9dc1ef0f3f48059b,
    dark: $e996865a8c4821b6$export$69cb3ca10c1e330e
});
var $e996865a8c4821b6$export$e13cce2a2d16a9d4 = (0, $001a839b07442c83$export$2e2bcd8739ae039)({
    light: $e996865a8c4821b6$export$b48405b95304b5a1,
    dark: $e996865a8c4821b6$export$6011520a64d9a187
});
var $e996865a8c4821b6$export$a90204d1394caf30 = (0, $001a839b07442c83$export$2e2bcd8739ae039)({
    light: $e996865a8c4821b6$export$4a7404f376229999,
    dark: $e996865a8c4821b6$export$4a7404f376229999
});
var $e996865a8c4821b6$export$594c5a8758200c32 = (0, $001a839b07442c83$export$2e2bcd8739ae039)({
    light: $e996865a8c4821b6$export$c6930421db9fa514,
    dark: $e996865a8c4821b6$export$c6930421db9fa514
});
var $e996865a8c4821b6$export$955a2ebd2fb142ae = (0, $001a839b07442c83$export$2e2bcd8739ae039)({
    light: $e996865a8c4821b6$export$940e1f69e873f202,
    dark: $e996865a8c4821b6$export$940e1f69e873f202
});
var $e996865a8c4821b6$export$2a0674ff2eb10214 = function skeleton() {
    return "var(--ds-skeleton, ".concat($e996865a8c4821b6$export$8d43898f60b96a82, ")");
};



var $dAx5m = parcelRequire("dAx5m");
var $933ad5e8f7b65fc2$export$443076ec7ebce042 = /*#__PURE__*/ (0, $dAx5m.createContext)("cozy");
var $933ad5e8f7b65fc2$export$9ca534b70725964d = /*#__PURE__*/ (0, $dAx5m.createContext)("border");


var $a7360decc2ab332b$var$defaultRender = function defaultRender(Component, props) {
    return(// eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    (0, $jVTBW.jsx)(Component, props));
};
var $a7360decc2ab332b$var$beforeAfterElementStyles = (0, $jVTBW.css)({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0
});
var $a7360decc2ab332b$var$contentStyles = (0, $63532adf9c22de9a$export$f6c783d06584602c)({
    outline: "none",
    overflow: "hidden",
    textAlign: "left"
});
var $a7360decc2ab332b$var$baseContentStyles = (0, $63532adf9c22de9a$export$f6c783d06584602c)({
    lineHeight: "16px"
});
var $a7360decc2ab332b$var$truncateStyles = (0, $jVTBW.css)({
    display: "block",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap"
});
var $a7360decc2ab332b$var$titleStyles = (0, $jVTBW.css)({
    font: 'var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)'
});
var $a7360decc2ab332b$var$wordBreakStyles = (0, $jVTBW.css)({
    wordBreak: "break-word"
});
var $a7360decc2ab332b$var$descriptionStyles = (0, $jVTBW.css)({
    color: "var(--ds-text-subtlest, ".concat((0, $e996865a8c4821b6$export$f563ee71e9ee74cd), ")")
});
var $a7360decc2ab332b$var$baseDescriptionStyles = (0, $jVTBW.css)({
    fontSize: "12px",
    marginBlockStart: "var(--ds-space-050, 4px)"
});
var $a7360decc2ab332b$var$tokenizedDescriptionStyles = (0, $jVTBW.css)({
    font: 'var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)'
});
var $a7360decc2ab332b$var$disabledDescriptionStyles = (0, $jVTBW.css)({
    color: "var(--ds-text-disabled, ".concat((0, $e996865a8c4821b6$export$f563ee71e9ee74cd), ")")
});
var $a7360decc2ab332b$var$positionRelativeStyles = (0, $jVTBW.css)({
    position: "relative"
});
var $a7360decc2ab332b$var$primitiveStyles = (0, $jVTBW.css)({
    display: "flex",
    boxSizing: "border-box",
    width: "100%",
    minHeight: 40,
    margin: "var(--ds-space-0, 0px)",
    alignItems: "center",
    border: 0,
    outline: 0,
    textDecoration: "none",
    userSelect: "none",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    "&::-moz-focus-inner": {
        border: 0
    },
    "&:hover": {
        textDecoration: "none"
    }
});
var $a7360decc2ab332b$var$primitiveBaseStyles = (0, $jVTBW.css)({
    fontSize: "14px"
});
var $a7360decc2ab332b$var$spacingMapStyles = {
    cozy: (0, $jVTBW.css)({
        // 8 * 2 (16) + icon (24) === 40
        paddingBlock: "var(--ds-space-100, 8px)",
        paddingInline: "var(--ds-space-200, 16px)"
    }),
    compact: (0, $jVTBW.css)({
        minHeight: 32,
        // 4 * 2 (8) + icon (24) === 32
        paddingBlock: "var(--ds-space-050, 4px)",
        paddingInline: "var(--ds-space-150, 12px)"
    })
};
var $a7360decc2ab332b$var$interactiveStyles = (0, $jVTBW.css)({
    cursor: "pointer"
});
var $a7360decc2ab332b$var$unselectedStyles = (0, $jVTBW.css)({
    backgroundColor: "var(--ds-background-neutral-subtle, transparent)",
    color: "currentColor",
    "&:visited": {
        color: "currentColor"
    },
    "&:hover": {
        backgroundColor: "var(--ds-background-neutral-subtle-hovered, ".concat((0, $e996865a8c4821b6$export$9fdfb749e33cdf97), ")"),
        color: "currentColor"
    },
    "&:active": {
        backgroundColor: "var(--ds-background-neutral-subtle-pressed, ".concat((0, $e996865a8c4821b6$export$3e51e8f1440314ba), ")"),
        boxShadow: "none",
        color: "currentColor"
    }
});
var $a7360decc2ab332b$var$disabledStyles = (0, $jVTBW.css)({
    cursor: "not-allowed",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    "&, :hover, :active": {
        backgroundColor: "var(--ds-background-neutral-subtle, transparent)",
        color: "var(--ds-text-disabled, ".concat((0, $e996865a8c4821b6$export$f563ee71e9ee74cd), ")")
    }
});
var $a7360decc2ab332b$var$selectedBorderStyles = (0, $jVTBW.css)({
    "&::before": {
        width: 2,
        position: "absolute",
        background: "var(--ds-border-selected, transparent)",
        content: '""',
        insetBlockEnd: 0,
        insetBlockStart: 0,
        insetInlineStart: 0
    }
});
var $a7360decc2ab332b$var$selectedNotchStyles = (0, $jVTBW.css)({
    "&::before": {
        width: 4,
        position: "absolute",
        background: "var(--ds-border-selected, transparent)",
        borderRadius: "0 ".concat("var(--ds-border-radius, 4px)", " ", "var(--ds-border-radius, 4px)", " 0"),
        content: '""',
        insetBlockEnd: "var(--ds-space-150, 12px)",
        insetBlockStart: "var(--ds-space-150, 12px)",
        insetInlineStart: 0
    }
});
var $a7360decc2ab332b$var$selectedStyles = (0, $jVTBW.css)({
    backgroundColor: "var(--ds-background-selected, ".concat((0, $e996865a8c4821b6$export$9fdfb749e33cdf97), ")"),
    // Fallback set as babel plugin inserts one otherwise
    color: "var(--ds-text-selected, currentColor)",
    "&:visited": {
        color: "var(--ds-text-selected, currentColor)"
    },
    "&:hover": {
        backgroundColor: "var(--ds-background-selected-hovered, ".concat((0, $e996865a8c4821b6$export$9fdfb749e33cdf97), ")"),
        color: "var(--ds-text-selected, currentColor)"
    },
    "&:active": {
        backgroundColor: "var(--ds-background-selected-pressed, ".concat((0, $e996865a8c4821b6$export$3e51e8f1440314ba), ")"),
        color: "var(--ds-text-selected, currentColor)"
    }
});
var $a7360decc2ab332b$var$gapMap = {
    compact: "space.100",
    cozy: "space.150"
};
/**
 * __Menu item primitive__
 *
 * Menu item primitive contains all the styles for menu items,
 * including support for selected, disabled, and interaction states.
 *
 * Using children as function prop you wire up this to your own host element.
 *
 * ```jsx
 * <MenuItemPrimitive>
 *   {({ children, ...props }) => <button {...props}>{children}</button>}
 * </MenuItemPrimitive>
 * ```
 */ var $a7360decc2ab332b$var$MenuItemPrimitive = function MenuItemPrimitive(_ref) {
    var children = _ref.children, title = _ref.title, description = _ref.description, iconAfter = _ref.iconAfter, iconBefore = _ref.iconBefore, overrides = _ref.overrides, UNSAFE_externalClassName = _ref.className, _ref$shouldTitleWrap = _ref.shouldTitleWrap, shouldTitleWrap = _ref$shouldTitleWrap === void 0 ? false : _ref$shouldTitleWrap, _ref$shouldDescriptio = _ref.shouldDescriptionWrap, shouldDescriptionWrap = _ref$shouldDescriptio === void 0 ? false : _ref$shouldDescriptio, _ref$isDisabled = _ref.isDisabled, isDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled, _ref$isSelected = _ref.isSelected, isSelected = _ref$isSelected === void 0 ? false : _ref$isSelected, testId = _ref.testId;
    (0, $e2xkU.propDeprecationWarning)("@atlaskit/menu", "overrides", overrides !== undefined, "" // TODO: Create DAC post when primitives/xcss are available as alternatives
    );
    var spacing = (0, $dAx5m.useContext)((0, $933ad5e8f7b65fc2$export$443076ec7ebce042));
    var selectionStyle = (0, $dAx5m.useContext)((0, $933ad5e8f7b65fc2$export$9ca534b70725964d));
    var renderTitle = overrides && overrides.Title && overrides.Title.render || $a7360decc2ab332b$var$defaultRender;
    var UNSAFE_className = (0, $jAmv0.getBooleanFF)("platform.design-system-team.unsafe-overrides-killswitch_c8j9m") ? undefined : UNSAFE_externalClassName;
    return (0, $jVTBW.jsx)((0, $jVTBW.ClassNames), null, function(_ref2) {
        var cn = _ref2.css, cx = _ref2.cx;
        return (0, $jVTBW.jsx)((0, $iAyBE.default), {
            isInset: true
        }, children({
            className: cx([
                cn([
                    $a7360decc2ab332b$var$positionRelativeStyles,
                    $a7360decc2ab332b$var$primitiveStyles,
                    (0, $jAmv0.getBooleanFF)("platform.design-system-team.menu-tokenised-typography-styles") ? undefined : $a7360decc2ab332b$var$primitiveBaseStyles,
                    $a7360decc2ab332b$var$spacingMapStyles[spacing],
                    !isDisabled && !isSelected && $a7360decc2ab332b$var$unselectedStyles,
                    !isDisabled && isSelected && [
                        $a7360decc2ab332b$var$selectedStyles,
                        [
                            selectionStyle === "border" && $a7360decc2ab332b$var$selectedBorderStyles,
                            selectionStyle === "notch" && $a7360decc2ab332b$var$selectedNotchStyles
                        ]
                    ],
                    isDisabled ? $a7360decc2ab332b$var$disabledStyles : $a7360decc2ab332b$var$interactiveStyles
                ]),
                UNSAFE_className
            ]),
            children: (0, $jVTBW.jsx)((0, $eed02ca94bb77104$export$2e2bcd8739ae039), {
                as: "span",
                spread: "space-between",
                alignBlock: "center",
                space: $a7360decc2ab332b$var$gapMap[spacing],
                grow: "fill",
                testId: testId && "".concat(testId, "--container")
            }, iconBefore && (0, $jVTBW.jsx)("span", {
                "data-item-elem-before": true,
                css: $a7360decc2ab332b$var$beforeAfterElementStyles,
                "data-testid": testId && "".concat(testId, "--icon-before")
            }, iconBefore), title && (0, $jVTBW.jsx)((0, $9574cd5f9e265737$export$2e2bcd8739ae039), {
                alignBlock: "center",
                grow: "fill",
                xcss: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                (0, $jAmv0.getBooleanFF)("platform.design-system-team.menu-tokenised-typography-styles") ? $a7360decc2ab332b$var$contentStyles : [
                    $a7360decc2ab332b$var$contentStyles,
                    $a7360decc2ab332b$var$baseContentStyles
                ]
            }, renderTitle("span", {
                children: title,
                className: cn((0, $jAmv0.getBooleanFF)("platform.design-system-team.menu-tokenised-typography-styles") ? $a7360decc2ab332b$var$titleStyles : undefined, shouldTitleWrap ? $a7360decc2ab332b$var$wordBreakStyles : $a7360decc2ab332b$var$truncateStyles),
                "data-item-title": true
            }), description && (0, $jVTBW.jsx)("span", {
                "data-item-description": true,
                css: [
                    $a7360decc2ab332b$var$descriptionStyles,
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                    (0, $jAmv0.getBooleanFF)("platform.design-system-team.menu-tokenised-typography-styles") ? $a7360decc2ab332b$var$tokenizedDescriptionStyles : $a7360decc2ab332b$var$baseDescriptionStyles,
                    isDisabled && $a7360decc2ab332b$var$disabledDescriptionStyles,
                    shouldDescriptionWrap ? $a7360decc2ab332b$var$wordBreakStyles : $a7360decc2ab332b$var$truncateStyles
                ]
            }, description)), iconAfter && (0, $jVTBW.jsx)("span", {
                "data-item-elem-after": true,
                css: $a7360decc2ab332b$var$beforeAfterElementStyles,
                "data-testid": testId && "".concat(testId, "--icon-after")
            }, iconAfter))
        }));
    });
};
var $a7360decc2ab332b$export$2e2bcd8739ae039 = $a7360decc2ab332b$var$MenuItemPrimitive;


var $f86a902fec23069e$var$_excluded = [
    "children",
    "href",
    "cssFn",
    "description",
    "iconAfter",
    "iconBefore",
    "isDisabled",
    "isSelected",
    "onClick",
    "testId",
    "overrides",
    "onMouseDown",
    "shouldTitleWrap",
    "shouldDescriptionWrap",
    "className",
    "UNSAFE_shouldDisableRouterLink"
];
var $f86a902fec23069e$var$IS_EXTERNAL_LINK_REGEX = /^(?:(http|https):\/\/)/;
var $f86a902fec23069e$var$IS_NON_HTTP_BASED = /^(((mailto|tel|sms):)|(#))/;
var $f86a902fec23069e$var$preventEvent = function preventEvent(e) {
    e.preventDefault();
};
/**
 * __Link item__
 *
 * A link item is used to populate a menu with items that are links.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/link-item)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ var $f86a902fec23069e$var$LinkItem = /*#__PURE__*/ (0, $dAx5m.memo)(/*#__PURE__*/ (0, $dAx5m.forwardRef)(// Type needed on props to extract types with extract react types.
function(props, ref) {
    var children = props.children, href = props.href, _props$cssFn = props.cssFn, cssFn = _props$cssFn === void 0 ? (0, $Bb0he.default) : _props$cssFn, description = props.description, iconAfter = props.iconAfter, iconBefore = props.iconBefore, _props$isDisabled = props.isDisabled, isDisabled = _props$isDisabled === void 0 ? false : _props$isDisabled, _props$isSelected = props.isSelected, isSelected = _props$isSelected === void 0 ? false : _props$isSelected, onClick = props.onClick, testId = props.testId, overrides = props.overrides, onMouseDown = props.onMouseDown, shouldTitleWrap = props.shouldTitleWrap, shouldDescriptionWrap = props.shouldDescriptionWrap, UNSAFE_className = props.className, UNSAFE_shouldDisableRouterLink = props.UNSAFE_shouldDisableRouterLink, rest = (0, (/*@__PURE__*/$parcel$interopDefault($74ed1cba0d5551e3$exports)))(props, $f86a902fec23069e$var$_excluded);
    var onMouseDownHandler = onMouseDown;
    var RouterLink = (0, $3dadca83bb4f3c17$export$2e2bcd8739ae039)();
    if (!children) return null;
    var isExternal = typeof href === "string" && $f86a902fec23069e$var$IS_EXTERNAL_LINK_REGEX.test(href);
    var isNonHttpBased = typeof href === "string" && $f86a902fec23069e$var$IS_NON_HTTP_BASED.test(href);
    /**
   * Renders a router link if:
   *
   * - a link component is set in the app provider
   * - it's not an external link (starting with `http://` or `https://`)
   * - it's not a non-HTTP-based link (e.g. emails, phone numbers, hash links etc.).
   */ var isRouterLink = !UNSAFE_shouldDisableRouterLink && RouterLink && !isExternal && !isNonHttpBased;
    var Component = isRouterLink && (0, $jAmv0.fg)("platform.wanjel.use-router-links-for-the-linkitem-component") ? RouterLink : "a";
    (0, $e2xkU.propDeprecationWarning)("@atlaskit/menu", "cssFn", cssFn !== (0, $Bb0he.default), "" // TODO: Create DAC post when primitives/xcss are available as alternatives
    );
    return (0, $jVTBW.jsx)((0, $a7360decc2ab332b$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($5fb336a98f9116b4$exports)))({}, rest, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $jAmv0.fg)("platform.design-system-team.unsafe-overrides-killswitch_c8j9m") ? undefined : UNSAFE_className,
        overrides: overrides,
        iconBefore: iconBefore,
        iconAfter: iconAfter,
        isSelected: isSelected,
        isDisabled: isDisabled,
        description: description,
        shouldTitleWrap: shouldTitleWrap,
        shouldDescriptionWrap: shouldDescriptionWrap,
        css: // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        cssFn({
            isSelected: isSelected,
            isDisabled: isDisabled
        }),
        title: children,
        testId: testId && "".concat(testId, "--primitive")
    }), function(_ref) {
        var children = _ref.children, className = _ref.className;
        return (0, $jVTBW.jsx)(Component, (0, (/*@__PURE__*/$parcel$interopDefault($5fb336a98f9116b4$exports)))({
            "data-testid": testId,
            "data-is-router-link": testId ? isRouterLink ? "true" : "false" : undefined
        }, rest, {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            href: isDisabled ? undefined : href
        }, (0, $jAmv0.fg)("platform.wanjel.remove-drag-override-in-menu-items_l1dib") ? {} : {
            draggable: false,
            onDragStart: $f86a902fec23069e$var$preventEvent
        }, {
            onMouseDown: isDisabled ? $f86a902fec23069e$var$preventEvent : onMouseDownHandler,
            onClick: isDisabled ? $f86a902fec23069e$var$preventEvent : onClick,
            "aria-current": isSelected ? "page" : undefined,
            "aria-disabled": isDisabled,
            ref: ref
        }), children);
    });
}));
var $f86a902fec23069e$export$2e2bcd8739ae039 = $f86a902fec23069e$var$LinkItem;




var $jVTBW = parcelRequire("jVTBW");

var $jAmv0 = parcelRequire("jAmv0");

var $47fb6f45f1898158$var$_excluded = [
    "isLoading",
    "maxWidth",
    "minWidth",
    "minHeight",
    "maxHeight",
    "testId",
    "role",
    "spacing",
    "className"
];
var $47fb6f45f1898158$var$baseStyles = (0, $jVTBW.css)({
    display: "flex",
    position: "static",
    flexDirection: "column",
    overflow: "auto"
});
/**
 * __Menu group__
 *
 * A menu group includes all the actions or items in a menu.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/menu-group)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ var $47fb6f45f1898158$var$MenuGroup = function MenuGroup(_ref) {
    var isLoading = _ref.isLoading, maxWidth = _ref.maxWidth, minWidth = _ref.minWidth, minHeight = _ref.minHeight, maxHeight = _ref.maxHeight, testId = _ref.testId, role = _ref.role, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? "cozy" : _ref$spacing, UNSAFE_className = _ref.className, rest = (0, (/*@__PURE__*/$parcel$interopDefault($74ed1cba0d5551e3$exports)))(_ref, $47fb6f45f1898158$var$_excluded);
    return (0, $jVTBW.jsx)((0, $933ad5e8f7b65fc2$export$443076ec7ebce042).Provider, {
        value: spacing
    }, (0, $jVTBW.jsx)((0, $933ad5e8f7b65fc2$export$9ca534b70725964d).Provider, {
        value: "border"
    }, (0, $jVTBW.jsx)("div", (0, (/*@__PURE__*/$parcel$interopDefault($5fb336a98f9116b4$exports)))({
        "aria-busy": isLoading,
        style: {
            minWidth: minWidth,
            maxWidth: maxWidth,
            minHeight: minHeight,
            maxHeight: maxHeight
        },
        css: $47fb6f45f1898158$var$baseStyles,
        "data-testid": testId,
        role: role,
        className: (0, $jAmv0.getBooleanFF)("platform.design-system-team.unsafe-overrides-killswitch_c8j9m") ? undefined : UNSAFE_className
    }, rest))));
};
var $47fb6f45f1898158$export$2e2bcd8739ae039 = $47fb6f45f1898158$var$MenuGroup;




var $dAx5m = parcelRequire("dAx5m");

var $jVTBW = parcelRequire("jVTBW");

var $e2xkU = parcelRequire("e2xkU");

var $jAmv0 = parcelRequire("jAmv0");





function $cbdfda2c6ae17b89$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $cbdfda2c6ae17b89$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $cbdfda2c6ae17b89$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($c3ec97511ae1ed64$exports)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $cbdfda2c6ae17b89$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $cbdfda2c6ae17b89$export$2a99220fb32ec798 = {
    heading: {
        xxlarge: 'normal 500 35px/40px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
        xlarge: 'normal 600 29px/32px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
        large: 'normal 500 24px/28px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
        medium: 'normal 500 20px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
        small: 'normal 600 16px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
        xsmall: 'normal 600 14px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
        xxsmall: 'normal 600 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif'
    },
    body: {
        large: 'normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
        medium: 'normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
        UNSAFE_small: 'normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
        small: 'normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif'
    }
};
var $cbdfda2c6ae17b89$var$baseHeading = function baseHeading(size, lineHeight) {
    return {
        fontSize: "".concat(size / 14, "em"),
        fontStyle: "inherit",
        lineHeight: lineHeight / size
    };
};
var $cbdfda2c6ae17b89$export$bc02e067df412c3b = {
    h900: {
        size: 35,
        lineHeight: 40
    },
    h800: {
        size: 29,
        lineHeight: 32
    },
    h700: {
        size: 24,
        lineHeight: 28
    },
    h600: {
        size: 20,
        lineHeight: 24
    },
    h500: {
        size: 16,
        lineHeight: 20
    },
    h400: {
        size: 14,
        lineHeight: 16
    },
    h300: {
        size: 12,
        lineHeight: 16
    },
    h200: {
        size: 12,
        lineHeight: 16
    },
    h100: {
        size: 11,
        lineHeight: 16
    }
};
var $cbdfda2c6ae17b89$export$bdb8f897727a9c67 = function h900() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return $cbdfda2c6ae17b89$var$_objectSpread($cbdfda2c6ae17b89$var$_objectSpread({}, $cbdfda2c6ae17b89$var$baseHeading($cbdfda2c6ae17b89$export$bc02e067df412c3b.h900.size, $cbdfda2c6ae17b89$export$bc02e067df412c3b.h900.lineHeight)), {}, {
        color: "var(--ds-text, ".concat((0, $e996865a8c4821b6$export$46e4a324ac90507f)(props), ")"),
        fontWeight: "var(--ds-font-weight-medium, 500)",
        letterSpacing: "-0.01em",
        marginTop: "".concat((0, $fadf80e9637982ea$export$6d8204c2cb2e06b8)() * 6.5, "px")
    });
};
var $cbdfda2c6ae17b89$export$3953fb6fbd158d23 = function h800() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return $cbdfda2c6ae17b89$var$_objectSpread($cbdfda2c6ae17b89$var$_objectSpread({}, $cbdfda2c6ae17b89$var$baseHeading($cbdfda2c6ae17b89$export$bc02e067df412c3b.h800.size, $cbdfda2c6ae17b89$export$bc02e067df412c3b.h800.lineHeight)), {}, {
        color: "var(--ds-text, ".concat((0, $e996865a8c4821b6$export$46e4a324ac90507f)(props), ")"),
        fontWeight: "var(--ds-font-weight-semibold, 600)",
        letterSpacing: "-0.01em",
        marginTop: "".concat((0, $fadf80e9637982ea$export$6d8204c2cb2e06b8)() * 5, "px")
    });
};
var $cbdfda2c6ae17b89$export$e4f993a313607daa = function h700() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return $cbdfda2c6ae17b89$var$_objectSpread($cbdfda2c6ae17b89$var$_objectSpread({}, $cbdfda2c6ae17b89$var$baseHeading($cbdfda2c6ae17b89$export$bc02e067df412c3b.h700.size, $cbdfda2c6ae17b89$export$bc02e067df412c3b.h700.lineHeight)), {}, {
        color: "var(--ds-text, ".concat((0, $e996865a8c4821b6$export$46e4a324ac90507f)(props), ")"),
        fontWeight: "var(--ds-font-weight-medium, 500)",
        letterSpacing: "-0.01em",
        marginTop: "".concat((0, $fadf80e9637982ea$export$6d8204c2cb2e06b8)() * 5, "px")
    });
};
var $cbdfda2c6ae17b89$export$1e8b2acea3fb3119 = function h600() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return $cbdfda2c6ae17b89$var$_objectSpread($cbdfda2c6ae17b89$var$_objectSpread({}, $cbdfda2c6ae17b89$var$baseHeading($cbdfda2c6ae17b89$export$bc02e067df412c3b.h600.size, $cbdfda2c6ae17b89$export$bc02e067df412c3b.h600.lineHeight)), {}, {
        color: "var(--ds-text, ".concat((0, $e996865a8c4821b6$export$46e4a324ac90507f)(props), ")"),
        fontWeight: "var(--ds-font-weight-medium, 500)",
        letterSpacing: "-0.008em",
        marginTop: "".concat((0, $fadf80e9637982ea$export$6d8204c2cb2e06b8)() * 3.5, "px")
    });
};
var $cbdfda2c6ae17b89$export$85aa43a9b9f06707 = function h500() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return $cbdfda2c6ae17b89$var$_objectSpread($cbdfda2c6ae17b89$var$_objectSpread({}, $cbdfda2c6ae17b89$var$baseHeading($cbdfda2c6ae17b89$export$bc02e067df412c3b.h500.size, $cbdfda2c6ae17b89$export$bc02e067df412c3b.h500.lineHeight)), {}, {
        color: "var(--ds-text, ".concat((0, $e996865a8c4821b6$export$46e4a324ac90507f)(props), ")"),
        fontWeight: "var(--ds-font-weight-semibold, 600)",
        letterSpacing: "-0.006em",
        marginTop: "".concat((0, $fadf80e9637982ea$export$6d8204c2cb2e06b8)() * 3, "px")
    });
};
var $cbdfda2c6ae17b89$export$fcb7764b80bd908f = function h400() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return $cbdfda2c6ae17b89$var$_objectSpread($cbdfda2c6ae17b89$var$_objectSpread({}, $cbdfda2c6ae17b89$var$baseHeading($cbdfda2c6ae17b89$export$bc02e067df412c3b.h400.size, $cbdfda2c6ae17b89$export$bc02e067df412c3b.h400.lineHeight)), {}, {
        color: "var(--ds-text, ".concat((0, $e996865a8c4821b6$export$46e4a324ac90507f)(props), ")"),
        fontWeight: "var(--ds-font-weight-semibold, 600)",
        letterSpacing: "-0.003em",
        marginTop: "".concat((0, $fadf80e9637982ea$export$6d8204c2cb2e06b8)() * 2, "px")
    });
};
var $cbdfda2c6ae17b89$export$a0e59c3bbc05e815 = function h300() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return $cbdfda2c6ae17b89$var$_objectSpread($cbdfda2c6ae17b89$var$_objectSpread({}, $cbdfda2c6ae17b89$var$baseHeading($cbdfda2c6ae17b89$export$bc02e067df412c3b.h300.size, $cbdfda2c6ae17b89$export$bc02e067df412c3b.h300.lineHeight)), {}, {
        color: "var(--ds-text, ".concat((0, $e996865a8c4821b6$export$46e4a324ac90507f)(props), ")"),
        fontWeight: "var(--ds-font-weight-semibold, 600)",
        marginTop: "".concat((0, $fadf80e9637982ea$export$6d8204c2cb2e06b8)() * 2.5, "px"),
        textTransform: "uppercase"
    });
};
var $cbdfda2c6ae17b89$export$7ccf32eb2150ac7e = function h200() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return $cbdfda2c6ae17b89$var$_objectSpread($cbdfda2c6ae17b89$var$_objectSpread({}, $cbdfda2c6ae17b89$var$baseHeading($cbdfda2c6ae17b89$export$bc02e067df412c3b.h200.size, $cbdfda2c6ae17b89$export$bc02e067df412c3b.h200.lineHeight)), {}, {
        color: "var(--ds-text-subtlest, ".concat((0, $e996865a8c4821b6$export$79f3f2b82beb0d36)(props), ")"),
        fontWeight: "var(--ds-font-weight-semibold, 600)",
        marginTop: "".concat((0, $fadf80e9637982ea$export$6d8204c2cb2e06b8)() * 2, "px")
    });
};
var $cbdfda2c6ae17b89$export$dfc0e69214efdc3c = function h100() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return $cbdfda2c6ae17b89$var$_objectSpread($cbdfda2c6ae17b89$var$_objectSpread({}, $cbdfda2c6ae17b89$var$baseHeading($cbdfda2c6ae17b89$export$bc02e067df412c3b.h100.size, $cbdfda2c6ae17b89$export$bc02e067df412c3b.h100.lineHeight)), {}, {
        color: "var(--ds-text-subtlest, ".concat((0, $e996865a8c4821b6$export$79f3f2b82beb0d36)(props), ")"),
        fontWeight: "var(--ds-font-weight-bold, 700)",
        marginTop: "".concat((0, $fadf80e9637982ea$export$6d8204c2cb2e06b8)() * 2, "px")
    });
};





var $dAx5m = parcelRequire("dAx5m");

var $jVTBW = parcelRequire("jVTBW");

var $e2xkU = parcelRequire("e2xkU");

var $Bb0he = parcelRequire("Bb0he");

var $jAmv0 = parcelRequire("jAmv0");


var $0b8a02eeae9e8bdf$var$_excluded = [
    "children",
    "testId",
    "headingLevel",
    "id",
    "cssFn",
    "className"
];
var $0b8a02eeae9e8bdf$var$itemHeadingContentHeight = (0, $cbdfda2c6ae17b89$export$bc02e067df412c3b).h100.lineHeight;
var $0b8a02eeae9e8bdf$var$itemHeadingFontSize = (0, $cbdfda2c6ae17b89$export$bc02e067df412c3b).h100.size;
var $0b8a02eeae9e8bdf$var$headingStyles = (0, $jVTBW.css)({
    color: "var(--ds-text-subtle, ".concat((0, $e996865a8c4821b6$export$e2ef2124cf4024b1), ")"),
    paddingBlock: "var(--ds-space-0, 0px)",
    paddingInline: "var(--ds-space-200, 16px)",
    textTransform: "uppercase"
});
var $0b8a02eeae9e8bdf$var$baseHeadingStyles = (0, $jVTBW.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    fontSize: $0b8a02eeae9e8bdf$var$itemHeadingFontSize,
    fontWeight: "var(--ds-font-weight-bold, 700)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    lineHeight: $0b8a02eeae9e8bdf$var$itemHeadingContentHeight / $0b8a02eeae9e8bdf$var$itemHeadingFontSize
});
var $0b8a02eeae9e8bdf$var$tokenizedHeadingStyles = (0, $jVTBW.css)({
    font: 'var(--ds-font-heading-xxsmall, normal 600 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)'
});
/**
 * __Heading item__
 *
 * A heading item is used to describe sibling menu items.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/heading-item)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ var $0b8a02eeae9e8bdf$var$HeadingItem = /*#__PURE__*/ (0, $dAx5m.memo)(function(_ref) {
    var children = _ref.children, testId = _ref.testId, _ref$headingLevel = _ref.headingLevel, headingLevel = _ref$headingLevel === void 0 ? 2 : _ref$headingLevel, id = _ref.id, _ref$cssFn = _ref.cssFn, cssFn = _ref$cssFn === void 0 ? (0, $Bb0he.default) : _ref$cssFn, UNSAFE_className = _ref.className, rest = (0, (/*@__PURE__*/$parcel$interopDefault($74ed1cba0d5551e3$exports)))(_ref, $0b8a02eeae9e8bdf$var$_excluded);
    (0, $e2xkU.propDeprecationWarning)("@atlaskit/menu", "cssFn", cssFn !== (0, $Bb0he.default), "" // TODO: Create DAC post when primitives/xcss are available as alternatives
    );
    var UNSAFE_overrides = (0, $jAmv0.getBooleanFF)("platform.design-system-team.unsafe-overrides-killswitch_c8j9m") ? undefined : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    (0, $jVTBW.css)(cssFn(undefined));
    return (0, $jVTBW.jsx)("div", (0, (/*@__PURE__*/$parcel$interopDefault($5fb336a98f9116b4$exports)))({
        css: [
            $0b8a02eeae9e8bdf$var$headingStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $jAmv0.getBooleanFF)("platform.design-system-team.menu-tokenised-typography-styles") ? $0b8a02eeae9e8bdf$var$tokenizedHeadingStyles : $0b8a02eeae9e8bdf$var$baseHeadingStyles,
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
            UNSAFE_overrides
        ],
        role: "heading",
        "aria-level": headingLevel,
        "data-testid": testId,
        "data-ds--menu--heading-item": true,
        id: id,
        className: (0, $jAmv0.getBooleanFF)("platform.design-system-team.unsafe-overrides-killswitch_c8j9m") ? undefined : UNSAFE_className
    }, rest), children);
});
var $0b8a02eeae9e8bdf$export$2e2bcd8739ae039 = $0b8a02eeae9e8bdf$var$HeadingItem;


var $c98b8e1cfa1cc46d$var$_excluded = [
    "children",
    "overrides",
    "title",
    "titleId",
    "testId",
    "isScrollable",
    "hasSeparator",
    "id",
    "isList",
    "className"
];
var $c98b8e1cfa1cc46d$var$gridSize = (0, $fadf80e9637982ea$export$6d8204c2cb2e06b8)();
var $c98b8e1cfa1cc46d$var$itemHeadingTopMargin = $c98b8e1cfa1cc46d$var$gridSize * 2.5;
var $c98b8e1cfa1cc46d$var$itemHeadingBottomMargin = $c98b8e1cfa1cc46d$var$gridSize * 0.75;
// Skeleton content is slightly shorter than the real content.
// Because of that we slightly increase the top margin to offset this so the
// containing size both real and skeleton always equal approx 30px.
var $c98b8e1cfa1cc46d$var$itemHeadingContentHeight = (0, $cbdfda2c6ae17b89$export$bc02e067df412c3b).h100.lineHeight;
var $c98b8e1cfa1cc46d$var$skeletonHeadingHeight = $c98b8e1cfa1cc46d$var$gridSize;
var $c98b8e1cfa1cc46d$var$skeletonHeadingMarginOffset = 3;
var $c98b8e1cfa1cc46d$var$skeletonHeadingTopMargin = $c98b8e1cfa1cc46d$var$itemHeadingTopMargin + ($c98b8e1cfa1cc46d$var$itemHeadingContentHeight - $c98b8e1cfa1cc46d$var$skeletonHeadingHeight) - $c98b8e1cfa1cc46d$var$skeletonHeadingMarginOffset;
// We want to move the entire body up by 3px without affecting the height of the skeleton container.
var $c98b8e1cfa1cc46d$var$skeletonHeadingBottomMargin = $c98b8e1cfa1cc46d$var$itemHeadingBottomMargin + $c98b8e1cfa1cc46d$var$skeletonHeadingMarginOffset;
var $c98b8e1cfa1cc46d$var$sectionPaddingTopBottom = $c98b8e1cfa1cc46d$var$gridSize * 0.75;
var $c98b8e1cfa1cc46d$var$VAR_SEPARATOR_COLOR = "--ds-menu-seperator-color";
var $c98b8e1cfa1cc46d$var$sectionStyles = (0, $jVTBW.css)({
    "&::before, &::after": {
        display: "block",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        height: $c98b8e1cfa1cc46d$var$sectionPaddingTopBottom,
        content: '""'
    },
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    "& [data-ds--menu--heading-item]": {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        marginBlockEnd: $c98b8e1cfa1cc46d$var$itemHeadingBottomMargin,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        marginBlockStart: $c98b8e1cfa1cc46d$var$itemHeadingTopMargin,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        "&:first-of-type": {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            marginBlockStart: $c98b8e1cfa1cc46d$var$itemHeadingTopMargin - $c98b8e1cfa1cc46d$var$sectionPaddingTopBottom
        }
    },
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    "& [data-ds--menu--skeleton-heading-item]": {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        marginBlockEnd: $c98b8e1cfa1cc46d$var$skeletonHeadingBottomMargin,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        marginBlockStart: $c98b8e1cfa1cc46d$var$skeletonHeadingTopMargin,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        "&:first-of-type": {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            marginBlockStart: $c98b8e1cfa1cc46d$var$skeletonHeadingTopMargin - $c98b8e1cfa1cc46d$var$sectionPaddingTopBottom
        }
    },
    "&:focus": {
        // NOTE: Firefox allows elements that have "overflow: auto" to gain focus (as if it had tab-index="0")
        // We have made a deliberate choice to leave this behaviour as is.
        // This makes the outline go inside by 1px so it can actually be displayed
        // else it gets cut off from the overflow: scroll from the parent menu group.
        outlineOffset: -1
    }
});
var $c98b8e1cfa1cc46d$var$scrollableStyles = (0, $jVTBW.css)({
    flexShrink: 1,
    overflow: "auto"
});
var $c98b8e1cfa1cc46d$var$unscrollableStyles = (0, $jVTBW.css)({
    flexShrink: 0
});
var $c98b8e1cfa1cc46d$var$thickSeparatorStyles = (0, $jVTBW.css)({
    borderBlockStart: "2px solid var(".concat($c98b8e1cfa1cc46d$var$VAR_SEPARATOR_COLOR, ", ", "var(--ds-border, ".concat((0, $e996865a8c4821b6$export$920c0d5c49070351), ")"), ")")
});
var $c98b8e1cfa1cc46d$var$thinSeparatorStyles = (0, $jVTBW.css)({
    borderBlockStart: "1px solid var(".concat($c98b8e1cfa1cc46d$var$VAR_SEPARATOR_COLOR, ", ", "var(--ds-border, ".concat((0, $e996865a8c4821b6$export$920c0d5c49070351), ")"), ")")
});
var $c98b8e1cfa1cc46d$var$noSeparatorStyles = (0, $jVTBW.css)({
    // this is to ensure that adjacent sections without separators don't get additional margins.
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    "[data-section] + &": {
        marginBlockStart: -6
    }
});
/**
 * __Section__
 *
 * A section includes related actions or items in a menu.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/section)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ var $c98b8e1cfa1cc46d$var$Section = /*#__PURE__*/ (0, $dAx5m.forwardRef)(function(_ref, ref) {
    var children = _ref.children, overrides = _ref.overrides, title = _ref.title, titleId = _ref.titleId, testId = _ref.testId, isScrollable = _ref.isScrollable, hasSeparator = _ref.hasSeparator, id = _ref.id, _ref$isList = _ref.isList, isList = _ref$isList === void 0 ? false : _ref$isList, UNSAFE_className = _ref.className, rest = (0, (/*@__PURE__*/$parcel$interopDefault($74ed1cba0d5551e3$exports)))(_ref, $c98b8e1cfa1cc46d$var$_excluded);
    (0, $e2xkU.propDeprecationWarning)("@atlaskit/menu", "overrides", overrides !== undefined, "" // TODO: Create DAC post when primitives/xcss are available as alternatives
    );
    var UNSAFE_headingOverrides = (0, $jAmv0.getBooleanFF)("platform.design-system-team.unsafe-overrides-killswitch_c8j9m") ? undefined : overrides && overrides.HeadingItem && overrides.HeadingItem.cssFn;
    var content = isList ? (0, $jVTBW.jsx)("ul", {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            margin: 0,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            padding: 0
        }
    }, (0, $dAx5m.Children).map((0, $dAx5m.Children).toArray(children), function(child, index) {
        return (0, $jVTBW.jsx)("li", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: {
                listStyleType: "none",
                margin: 0,
                padding: 0
            },
            key: index
        }, child);
    })) : children;
    var childrenMarkup = title !== undefined ? (0, $jVTBW.jsx)((0, $dAx5m.Fragment), null, (0, $jVTBW.jsx)((0, $0b8a02eeae9e8bdf$export$2e2bcd8739ae039), {
        cssFn: UNSAFE_headingOverrides,
        testId: testId && "".concat(testId, "--heading"),
        "aria-hidden": true
    }, title), content) : (0, $jVTBW.jsx)((0, $dAx5m.Fragment), null, content);
    return (0, $jVTBW.jsx)("div", (0, (/*@__PURE__*/$parcel$interopDefault($5fb336a98f9116b4$exports)))({}, rest, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $jAmv0.getBooleanFF)("platform.design-system-team.unsafe-overrides-killswitch_c8j9m") ? undefined : UNSAFE_className,
        id: id,
        css: [
            $c98b8e1cfa1cc46d$var$sectionStyles,
            isScrollable ? $c98b8e1cfa1cc46d$var$scrollableStyles : $c98b8e1cfa1cc46d$var$unscrollableStyles,
            hasSeparator ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $jAmv0.getBooleanFF)("platform.design-system-team.section-1px-seperator-borders") ? $c98b8e1cfa1cc46d$var$thinSeparatorStyles : $c98b8e1cfa1cc46d$var$thickSeparatorStyles : $c98b8e1cfa1cc46d$var$noSeparatorStyles
        ],
        "aria-label": title,
        "aria-labelledby": titleId,
        "data-testid": testId,
        role: "group",
        "data-section": true,
        ref: ref
    }), childrenMarkup);
});
var $c98b8e1cfa1cc46d$export$2e2bcd8739ae039 = $c98b8e1cfa1cc46d$var$Section;




/** @jsx jsx */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $jVTBW = parcelRequire("jVTBW");

var $ku6eE = parcelRequire("ku6eE");

var $55TWT = parcelRequire("55TWT");




var $dAx5m = parcelRequire("dAx5m");

var $3b69844328934482$export$b59bd42a398a2b3c = function PersonGlyph(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement("svg", (0, (/*@__PURE__*/$parcel$interopDefault($5fb336a98f9116b4$exports)))({
        width: "24",
        height: "24",
        viewBox: "0 0 24 24"
    }, props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement("path", {
        fill: "currentColor",
        d: "M13.523 11.3a4.504 4.504 0 0 1 4.478 4.063l.017.218.005.219v2.5c0 .964-.685 1.78-1.66 1.966l-.165.025-.175.009h-8c-.964 0-1.78-.686-1.966-1.66l-.025-.166-.009-.174v-2.5a4.504 4.504 0 0 1 4.064-4.478l.217-.017.22-.005h3Zm0 2H10.55l-.165.003a2.5 2.5 0 0 0-2.356 2.332l-.006.165-.001 2.442.001.058 7.943.002.057-.002v-2.473l-.003-.165a2.5 2.5 0 0 0-2.332-2.357l-.165-.005Zm-1.5-10a3.5 3.5 0 1 1 0 7 3.5 3.5 0 0 1 0-7Zm0 2a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Z"
    }));
};
function $3b69844328934482$export$7dcc8f518762622d(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $30d9f30932301ff5$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($5fb336a98f9116b4$exports)))({}, props, {
        glyph: $3b69844328934482$export$b59bd42a398a2b3c
    }));
}




var $jVTBW = parcelRequire("jVTBW");
var $fe6f2addda36a5da$exports = {};
"use strict";
Object.defineProperty($fe6f2addda36a5da$exports, "__esModule", {
    value: true
});
$fe6f2addda36a5da$exports.default = void 0;

var $fe6f2addda36a5da$var$_react = $fe6f2addda36a5da$var$_interopRequireDefault((parcelRequire("dAx5m")));

function $fe6f2addda36a5da$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $fe6f2addda36a5da$var$UserAvatarCircleIcon = (props)=>/*#__PURE__*/ $fe6f2addda36a5da$var$_react.default.createElement($30d9f30932301ff5$export$f04a61298a47a40f, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle fill="currentColor" cx="12" cy="12" r="10"/><circle fill="inherit" cx="12" cy="9" r="3"/><path d="M7 18.245A7.966 7.966 0 0012 20c1.892 0 3.63-.657 5-1.755V15c0-1.115-.895-2-2-2H9c-1.113 0-2 .895-2 2v3.245z" fill="inherit" fill-rule="nonzero"/></g></svg>`
    }, props));
$fe6f2addda36a5da$var$UserAvatarCircleIcon.displayName = "UserAvatarCircleIcon";
var $fe6f2addda36a5da$var$_default = $fe6f2addda36a5da$var$UserAvatarCircleIcon;
$fe6f2addda36a5da$exports.default = $fe6f2addda36a5da$var$_default;





var $dAx5m = parcelRequire("dAx5m");
var $2440faa8ae7a7605$export$2c1df3428fc3264c = function useImageState(src) {
    var _useState = (0, $dAx5m.useState)("pending"), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($6f4c9344050d46f7$exports)))(_useState, 2), state = _useState2[0], setState = _useState2[1];
    var imgRef = (0, $dAx5m.useRef)();
    (0, $dAx5m.useEffect)(function() {
        if (!imgRef.current) {
            imgRef.current = new Image();
            imgRef.current.onload = function() {
                return setState("loaded");
            };
            imgRef.current.onerror = function() {
                return setState("error");
            };
        }
        setState("pending");
        imgRef.current.src = src;
    }, [
        src
    ]);
    return state;
};


function $b2d089e08e93c12a$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $b2d089e08e93c12a$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $b2d089e08e93c12a$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($c3ec97511ae1ed64$exports)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $b2d089e08e93c12a$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $b2d089e08e93c12a$var$imgStyles = (0, $jVTBW.css)({
    display: "block",
    borderRadius: "50%"
});
var $b2d089e08e93c12a$export$2d75367b6e042d67 = function ProfilePicture(_ref) {
    var testId = _ref.testId, src = _ref.src, size = _ref.size, className = _ref.className;
    var state = (0, $2440faa8ae7a7605$export$2c1df3428fc3264c)(src || "");
    var displayImage = src && state === "loaded";
    var displayFallback = src && state === "error";
    var displaySkeleton = !displayImage && !displayFallback;
    return (0, $jVTBW.jsx)("div", {
        "data-testid": testId,
        className: className,
        css: $b2d089e08e93c12a$var$_objectSpread($b2d089e08e93c12a$var$_objectSpread({
            width: size,
            height: size
        }, displaySkeleton && {
            borderRadius: "50%",
            backgroundColor: "var(--ds-background-neutral, ".concat((0, $e996865a8c4821b6$export$8d43898f60b96a82), ")")
        }), {}, {
            "& svg, & img": {
                width: size,
                height: size
            }
        })
    }, displayImage && (0, $jVTBW.jsx)("img", {
        "data-testid": testId && "".concat(testId, "--img"),
        src: src,
        css: $b2d089e08e93c12a$var$imgStyles
    }), displayFallback && (0, $jVTBW.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($fe6f2addda36a5da$exports))), {
        testId: testId && "".concat(testId, "--fallback"),
        label: "",
        primaryColor: "var(--ds-text-subtlest, ".concat((0, $e996865a8c4821b6$export$7c87d337fb91a97d), ")"),
        secondaryColor: "var(--ds-text-inverse, ".concat((0, $e996865a8c4821b6$export$29a4f05edc054374), ")")
    }));
};


// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $ku6eE = parcelRequire("ku6eE");

var $151a7b9bce29650d$export$cb6ddd830302c2a8 = (0, $ku6eE.default).span({
    display: "inline-block",
    height: "1em",
    borderRadius: "0.5em",
    backgroundColor: "var(--ds-background-neutral, ".concat((0, $e996865a8c4821b6$export$8d43898f60b96a82), ")")
}, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
function(_ref) {
    var length = _ref.length;
    return {
        width: length
    };
});


var $97cba483d2d801e5$export$66e04d0aacdb3b2 = function AccountDetails(_ref) {
    var testId = _ref.testId, name = _ref.name, picture = _ref.picture, email = _ref.email, managedBy = _ref.managedBy;
    return (0, $jVTBW.jsx)($97cba483d2d801e5$var$Container, {
        "data-testid": testId
    }, managedBy && (0, $jVTBW.jsx)($97cba483d2d801e5$var$ManagedBy, null, (0, $jVTBW.jsx)($97cba483d2d801e5$var$PersonIconWrapper, null, (0, $jVTBW.jsx)((0, $3b69844328934482$export$7dcc8f518762622d), {
        label: "",
        size: "small"
    })), (0, $jVTBW.jsx)((0, $55TWT.default), {
        id: "identity.account-menu.account-menu-details.managed-account",
        defaultMessage: "This account is managed by <b>{managedBy}</b>",
        description: "Label showing the user which organisation manages their Atlassian account",
        values: {
            b: function b(text) {
                return (0, $jVTBW.jsx)("strong", null, text);
            },
            managedBy: managedBy
        }
    })), (0, $jVTBW.jsx)($97cba483d2d801e5$var$Content, {
        hasHeader: !!managedBy
    }, (0, $jVTBW.jsx)($97cba483d2d801e5$var$Profile, {
        testId: testId,
        name: name,
        picture: picture,
        email: email
    })));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
var $97cba483d2d801e5$var$Container = (0, $ku6eE.default).section({
    display: "flex",
    flexDirection: "column",
    margin: "0 ".concat("var(--ds-space-100, 8px)")
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
var $97cba483d2d801e5$var$ManagedBy = (0, $ku6eE.default).small({
    display: "box",
    margin: "0px",
    padding: "var(--ds-space-025, 2px)".concat(" ", "var(--ds-space-100, 8px)"),
    textAlign: "center",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    borderRadius: "".concat((0, $fadf80e9637982ea$export$7a57f79000377ca2)(), "px ").concat((0, $fadf80e9637982ea$export$7a57f79000377ca2)(), "px 0 0"),
    background: "var(--ds-background-information, ".concat((0, $e996865a8c4821b6$export$226de0355ed012f8), ")"),
    color: "var(--ds-text-subtle, #44546F)"
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
var $97cba483d2d801e5$var$PersonIconWrapper = (0, $ku6eE.default).span({
    marginRight: "var(--ds-space-050, 4px)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    "& > span": {
        width: "12px",
        height: "12px"
    }
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
var $97cba483d2d801e5$var$Content = (0, $ku6eE.default).div({
    display: "flex",
    flexDirection: "column",
    background: "var(--ds-surface-sunken, ".concat((0, $e996865a8c4821b6$export$8d43898f60b96a82), ")")
}, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
function(_ref2) {
    var hasHeader = _ref2.hasHeader;
    return {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        borderRadius: hasHeader ? "0 0 ".concat((0, $fadf80e9637982ea$export$7a57f79000377ca2)(), "px ").concat((0, $fadf80e9637982ea$export$7a57f79000377ca2)(), "px") : "".concat((0, $fadf80e9637982ea$export$7a57f79000377ca2)(), "px")
    };
});
var $97cba483d2d801e5$var$Profile = function Profile(_ref3) {
    var name = _ref3.name, email = _ref3.email, picture = _ref3.picture, testId = _ref3.testId;
    return (0, $jVTBW.jsx)($97cba483d2d801e5$var$ProfileWrapper, null, (0, $jVTBW.jsx)((0, $b2d089e08e93c12a$export$2d75367b6e042d67), {
        src: picture,
        size: (0, $fadf80e9637982ea$export$6d8204c2cb2e06b8)() * 8,
        testId: testId && "".concat(testId, "--picture")
    }), (0, $jVTBW.jsx)($97cba483d2d801e5$var$NameAndEmail, null, (0, $jVTBW.jsx)($97cba483d2d801e5$var$DisplayName, {
        "data-testid": testId && "".concat(testId, "--name")
    }, name || (0, $jVTBW.jsx)((0, $151a7b9bce29650d$export$cb6ddd830302c2a8), {
        length: "6em"
    })), (0, $jVTBW.jsx)($97cba483d2d801e5$var$EmailAddress, {
        "data-testid": testId && "".concat(testId, "--email")
    }, email || (0, $jVTBW.jsx)((0, $151a7b9bce29650d$export$cb6ddd830302c2a8), {
        length: "10em"
    }))));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
var $97cba483d2d801e5$var$ProfileWrapper = (0, $ku6eE.default).div({
    display: "flex",
    flexDirection: "row",
    margin: "var(--ds-space-200, 16px)".concat(" ", "var(--ds-space-200, 16px)")
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
var $97cba483d2d801e5$var$NameAndEmail = (0, $ku6eE.default).div({
    display: "flex",
    flexDirection: "column",
    margin: "auto 0 auto ".concat("var(--ds-space-200, 16px)")
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
var $97cba483d2d801e5$var$DisplayName = (0, $ku6eE.default).h3({
    color: "var(--ds-text, ".concat((0, $e996865a8c4821b6$export$7d61b15e0da132af), ")"),
    margin: 0
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
var $97cba483d2d801e5$var$EmailAddress = (0, $ku6eE.default).p({
    marginTop: "var(--ds-space-025, 2px)",
    color: "var(--ds-text-subtlest, #626F86)",
    fontWeight: 400
});




var $dAx5m = parcelRequire("dAx5m");

var $f237dd7f3fa74295$var$PeopleGlyph = function PeopleGlyph(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement("svg", (0, (/*@__PURE__*/$parcel$interopDefault($5fb336a98f9116b4$exports)))({
        width: "24",
        height: "24",
        viewBox: "0 0 24 24"
    }, props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement("path", {
        fill: "currentColor",
        d: "M10.523 11.3a4.5 4.5 0 0 1 4.5 4.5v2.5a2 2 0 0 1-2 2h-8a2 2 0 0 1-2-2v-2.5a4.5 4.5 0 0 1 4.5-4.5h3Zm6 0 .212.005a4.5 4.5 0 0 1 4.283 4.277l.005.218v2.5l-.005.15a2 2 0 0 1-1.838 1.844l-.157.006h-2l-.116-.007a1 1 0 0 1 0-1.986l.116-.007h2v-2.5l-.005-.165a2.5 2.5 0 0 0-2.33-2.33l-.165-.005h-.5l-.116-.007a1 1 0 0 1 0-1.986l.116-.007h.5Zm-6 2h-3a2.5 2.5 0 0 0-2.5 2.5v2.5h8v-2.5a2.5 2.5 0 0 0-2.5-2.5Zm-1.5-10a3.5 3.5 0 1 1 0 7 3.5 3.5 0 0 1 0-7Zm4.61.294a3.5 3.5 0 1 1 0 6.412 1 1 0 0 1 .694-1.872l.24.09a1.5 1.5 0 1 0 .012-2.852l-.252.094a1 1 0 0 1-.693-1.872ZM9.024 5.3a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Z"
    }));
};
function $f237dd7f3fa74295$export$a0096b57009ecc7c(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $30d9f30932301ff5$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($5fb336a98f9116b4$exports)))({}, props, {
        glyph: $f237dd7f3fa74295$var$PeopleGlyph
    }));
}





var $dAx5m = parcelRequire("dAx5m");

var $1037cc0f3b5d69db$export$1baa85ec8ca55263 = function SignOutGlyph(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement("svg", (0, (/*@__PURE__*/$parcel$interopDefault($5fb336a98f9116b4$exports)))({
        width: "24",
        height: "24",
        viewBox: "0 0 24 24"
    }, props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement("path", {
        fill: "currentColor",
        d: "m6.023 4.3-.149.005A2 2 0 0 0 4.024 6.3v12l.005.15a2 2 0 0 0 1.994 1.85h5l.117-.007a1 1 0 0 0-.117-1.993h-5v-12h5l.117-.007a1 1 0 0 0-.117-1.993h-5Zm9.293 4.293a1 1 0 0 0-.083 1.32l.084.094 1.292 1.292H9.023a1 1 0 0 0-.125 1.993l.125.008 7.586-.001-1.293 1.294a1 1 0 0 0-.083 1.32l.084.094a1 1 0 0 0 1.32.083l.094-.083 2.974-2.975c.096-.09.175-.198.23-.32l.011-.028a.757.757 0 0 0 .031-.083l.008-.027a.767.767 0 0 0 .02-.08l.007-.042a.767.767 0 0 0 .011-.133v-.039c0-.024-.002-.05-.004-.074l.004.094a1 1 0 0 0-.022-.215l-.008-.031a.807.807 0 0 0-.021-.074l-.018-.046a.64.64 0 0 0-.025-.062l-.019-.035a.64.64 0 0 0-.049-.083.667.667 0 0 0-.047-.07l-.084-.093-3-2.998a1 1 0 0 0-1.414 0Z"
    }));
};
function $1037cc0f3b5d69db$export$5bb2595dc31bfece(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $30d9f30932301ff5$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($5fb336a98f9116b4$exports)))({}, props, {
        glyph: $1037cc0f3b5d69db$export$1baa85ec8ca55263
    }));
}





var $dAx5m = parcelRequire("dAx5m");

var $ku6eE = parcelRequire("ku6eE");

var $lKhJJ = parcelRequire("lKhJJ");
var $55TWT = parcelRequire("55TWT");





var $dAx5m = parcelRequire("dAx5m");

var $dd4sf = parcelRequire("dd4sf");



var $dAx5m = parcelRequire("dAx5m");

var $jAmv0 = parcelRequire("jAmv0");



var $dAx5m = parcelRequire("dAx5m");

var $jVTBW = parcelRequire("jVTBW");


var $dAx5m = parcelRequire("dAx5m");

var $tWuif = parcelRequire("tWuif");










var $6J7ZY = parcelRequire("6J7ZY");



function $8fa7b6e3af2840f9$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $8fa7b6e3af2840f9$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $8fa7b6e3af2840f9$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($c3ec97511ae1ed64$exports)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $8fa7b6e3af2840f9$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $8fa7b6e3af2840f9$export$ad4be5c2ec28cecf = function isAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $8fa7b6e3af2840f9$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === "AnalyticsEvent";
};
var $8fa7b6e3af2840f9$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function AnalyticsEvent(props) {
        var _this = this;
        (0, (/*@__PURE__*/$parcel$interopDefault($338b26f50ccea2d2$exports)))(this, AnalyticsEvent);
        (0, (/*@__PURE__*/$parcel$interopDefault($c3ec97511ae1ed64$exports)))(this, "_isAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($c3ec97511ae1ed64$exports)))(this, "clone", function() {
            // just a shallow clone, don't change sub refs unless you want to
            // affect the original's too
            var payload = $8fa7b6e3af2840f9$var$_objectSpread({}, _this.payload);
            return new AnalyticsEvent({
                payload: payload
            });
        });
        this.payload = props.payload;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($f6825da5cb87797f$exports)))(AnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (typeof updater === "function") this.payload = updater(this.payload);
                if ((0, (/*@__PURE__*/$parcel$interopDefault($6J7ZY)))(updater) === "object") this.payload = $8fa7b6e3af2840f9$var$_objectSpread($8fa7b6e3af2840f9$var$_objectSpread({}, this.payload), updater);
                return this;
            }
        }
    ]);
    return AnalyticsEvent;
}();


function $f2db10656a7ef2e5$var$_createSuper(t) {
    var r = $f2db10656a7ef2e5$var$_isNativeReflectConstruct();
    return function() {
        var e, o = (0, (/*@__PURE__*/$parcel$interopDefault($6c6f88cd7dc38741$exports)))(t);
        if (r) {
            var s = (0, (/*@__PURE__*/$parcel$interopDefault($6c6f88cd7dc38741$exports)))(this).constructor;
            e = Reflect.construct(o, arguments, s);
        } else e = o.apply(this, arguments);
        return (0, (/*@__PURE__*/$parcel$interopDefault($b7c8bb6ce7659b75$exports)))(this, e);
    };
}
function $f2db10656a7ef2e5$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($f2db10656a7ef2e5$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $f2db10656a7ef2e5$export$35f8383928ba8d7 = function isUIAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $f2db10656a7ef2e5$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isUIAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === "UIAnalyticsEvent";
};
var $f2db10656a7ef2e5$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_AnalyticsEvent) {
    (0, (/*@__PURE__*/$parcel$interopDefault($66c319fc06465227$exports)))(UIAnalyticsEvent, _AnalyticsEvent);
    var _super = $f2db10656a7ef2e5$var$_createSuper(UIAnalyticsEvent);
    function UIAnalyticsEvent(props) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($338b26f50ccea2d2$exports)))(this, UIAnalyticsEvent);
        _this = _super.call(this, props);
        (0, (/*@__PURE__*/$parcel$interopDefault($c3ec97511ae1ed64$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($a652a3a6cb45a7cf$exports)))(_this), "_isUIAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($c3ec97511ae1ed64$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($a652a3a6cb45a7cf$exports)))(_this), "clone", function() {
            if (_this.hasFired) return null;
            var context = (0, (/*@__PURE__*/$parcel$interopDefault($d5f3651f1c5ee1c2$exports)))(_this.context);
            var handlers = (0, (/*@__PURE__*/$parcel$interopDefault($d5f3651f1c5ee1c2$exports)))(_this.handlers);
            /**
       * A hacky "deep clone" of the object. This is limited in that it wont
       * support functions, regexs, Maps, Sets, etc, but none of those need to
       * be represented in our payload.
       */ var payload = JSON.parse(JSON.stringify(_this.payload));
            return new UIAnalyticsEvent({
                context: context,
                handlers: handlers,
                payload: payload
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($c3ec97511ae1ed64$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($a652a3a6cb45a7cf$exports)))(_this), "fire", function(channel) {
            if (_this.hasFired) return;
            _this.handlers.forEach(function(handler) {
                return handler((0, (/*@__PURE__*/$parcel$interopDefault($a652a3a6cb45a7cf$exports)))(_this), channel);
            });
            _this.hasFired = true;
        });
        _this.context = props.context || [];
        _this.handlers = props.handlers || [];
        _this.hasFired = false;
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($f6825da5cb87797f$exports)))(UIAnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (this.hasFired) return this;
                return (0, (/*@__PURE__*/$parcel$interopDefault($d1582149da161cd6$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($6c6f88cd7dc38741$exports)))(UIAnalyticsEvent.prototype), "update", this).call(this, updater);
            }
        }
    ]);
    return UIAnalyticsEvent;
}((0, $8fa7b6e3af2840f9$export$2e2bcd8739ae039));



var $dAx5m = parcelRequire("dAx5m");

var $h0bf1 = parcelRequire("h0bf1");
var $043d266636f5d30a$export$d1f587f82ad51c4 = function useAnalyticsContext() {
    return (0, $dAx5m.useContext)((0, $h0bf1.default));
};


function $c980a6a81f7c6a1c$export$5bf35293e545f20c() {
    var analyticsContext = (0, $043d266636f5d30a$export$d1f587f82ad51c4)();
    var createAnalyticsEvent = (0, $tWuif.useCallbackOne)(function(payload) {
        return new (0, $f2db10656a7ef2e5$export$2e2bcd8739ae039)({
            context: analyticsContext.getAtlaskitAnalyticsContext(),
            handlers: analyticsContext.getAtlaskitAnalyticsEventHandlers(),
            payload: payload
        });
    }, [
        analyticsContext
    ]);
    return {
        createAnalyticsEvent: createAnalyticsEvent
    };
}



var $dAx5m = parcelRequire("dAx5m");
var $1f2decb2687658c9$export$1d27a74659855e44 = function useTrackedRef(value) {
    var ref = (0, $dAx5m.useRef)(value);
    ref.current = value;
    return ref;
};


function $088c582541946b49$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $088c582541946b49$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $088c582541946b49$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($c3ec97511ae1ed64$exports)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $088c582541946b49$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $088c582541946b49$export$a4687b0234b40e28(_ref) {
    var fn = _ref.fn, action = _ref.action, componentName = _ref.componentName, actionSubject = _ref.actionSubject, packageName = _ref.packageName, packageVersion = _ref.packageVersion, analyticsData = _ref.analyticsData;
    var _useAnalyticsEvents = (0, $c980a6a81f7c6a1c$export$5bf35293e545f20c)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    // We put analyticsData and fn in a ref so that we don't need to break
    // memoization.
    // Generally these could be defined by consumers inline
    // and so we do this to avoid breaking memoization of useCallback
    var dataRef = (0, $1f2decb2687658c9$export$1d27a74659855e44)(analyticsData);
    var fnRef = (0, $1f2decb2687658c9$export$1d27a74659855e44)(fn);
    var handler = (0, $dAx5m.useCallback)(function(value) {
        var analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: actionSubject || componentName,
            attributes: {
                componentName: componentName,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
        // To avoid wrapping this component in AnalyticsContext we manually
        // push the parent context's meta data into the context.
        // Note: this new 'context'
        var context = $088c582541946b49$var$_objectSpread({
            componentName: componentName,
            packageName: packageName,
            packageVersion: packageVersion
        }, dataRef.current);
        analyticsEvent.context.push(context);
        // fire an event on the atlaskit channel
        var clone = analyticsEvent.clone();
        if (clone) clone.fire("atlaskit");
        fnRef.current(value, analyticsEvent);
    }, [
        // These are strings and won't change
        action,
        componentName,
        actionSubject,
        packageName,
        packageVersion,
        // This function is memoized in the context
        createAnalyticsEvent,
        // these are a stable ref because of the useTrackedRef hook
        dataRef,
        fnRef
    ]);
    return handler;
}



var $Bb0he = parcelRequire("Bb0he");

var $kqsmh = parcelRequire("kqsmh");


var $1e6e60f1fe27cc1f$var$_excluded = [
    "children",
    "backgroundColor",
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    "isDisabled",
    "type",
    "onClick",
    "interactionName",
    "componentName",
    "analyticsContext",
    "style",
    "testId",
    "xcss"
], $1e6e60f1fe27cc1f$var$_excluded2 = [
    "className"
];
// This duplicates FocusRing styles from `@atlaskit/focus-ring`.
var $1e6e60f1fe27cc1f$var$focusRingStyles = (0, $jVTBW.css)({
    "&:focus, &:focus-visible": {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        outlineColor: (0, $ebe1decd94278ef0$export$1531ad5bb3fbedac)["color.border.focused"],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        outlineOffset: (0, $ebe1decd94278ef0$export$958d0ae7f2977ae4)["space.025"],
        outlineStyle: "solid",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        outlineWidth: (0, $ebe1decd94278ef0$export$e1b83c5210c471b8)["border.width.outline"]
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    "&:focus:not(:focus-visible)": {
        outline: "none"
    },
    "@media screen and (forced-colors: active), screen and (-ms-high-contrast: active)": {
        "&:focus-visible": {
            outline: "1px solid"
        }
    }
});
var $1e6e60f1fe27cc1f$var$baseStyles = (0, $jVTBW.css)({
    boxSizing: "border-box",
    appearance: "none",
    border: "none"
});
var $1e6e60f1fe27cc1f$var$enabledStyles = (0, $jVTBW.css)({
    cursor: "pointer"
});
var $1e6e60f1fe27cc1f$var$disabledStyles = (0, $jVTBW.css)({
    cursor: "not-allowed"
});
/**
 * __Pressable__
 *
 * A primitive for building custom buttons.
 *
 * - [Examples](https://atlassian.design/components/primitives/pressable/examples)
 * - [Code](https://atlassian.design/components/primitives/pressable/code)
 * - [Usage](https://atlassian.design/components/primitives/pressable/usage)
 */ var $1e6e60f1fe27cc1f$var$Pressable = /*#__PURE__*/ (0, $dAx5m.forwardRef)(function(_ref, ref) {
    var children = _ref.children, backgroundColor = _ref.backgroundColor, padding = _ref.padding, paddingBlock = _ref.paddingBlock, paddingBlockStart = _ref.paddingBlockStart, paddingBlockEnd = _ref.paddingBlockEnd, paddingInline = _ref.paddingInline, paddingInlineStart = _ref.paddingInlineStart, paddingInlineEnd = _ref.paddingInlineEnd, isDisabled = _ref.isDisabled, _ref$type = _ref.type, type = _ref$type === void 0 ? "button" : _ref$type, _ref$onClick = _ref.onClick, providedOnClick = _ref$onClick === void 0 ? (0, $Bb0he.default) : _ref$onClick, interactionName = _ref.interactionName, componentName = _ref.componentName, analyticsContext = _ref.analyticsContext, style = _ref.style, testId = _ref.testId, xcss = _ref.xcss, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($74ed1cba0d5551e3$exports)))(_ref, $1e6e60f1fe27cc1f$var$_excluded);
    var interactionContext = (0, $dAx5m.useContext)((0, $kqsmh.default));
    var handleClick = (0, $dAx5m.useCallback)(function(e, analyticsEvent) {
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    var onClick = (0, $088c582541946b49$export$a4687b0234b40e28)({
        fn: handleClick,
        action: "clicked",
        componentName: componentName || "Pressable",
        packageName: "@atlaskit/primitives",
        packageVersion: "11.1.2",
        analyticsData: analyticsContext,
        actionSubject: "button"
    });
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($74ed1cba0d5551e3$exports)))(htmlAttributes, $1e6e60f1fe27cc1f$var$_excluded2);
    var resolvedStyles = (0, $63532adf9c22de9a$export$a9c84988c8f81f2d)(xcss);
    return(// eslint-disable-next-line @atlaskit/design-system/no-html-button
    (0, $jVTBW.jsx)("button", (0, (/*@__PURE__*/$parcel$interopDefault($5fb336a98f9116b4$exports)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        ref: ref,
        className: resolvedStyles.static
    }, safeHtmlAttributes, {
        // eslint-disable-next-line react/button-has-type
        type: type,
        onClick: onClick,
        disabled: isDisabled,
        css: [
            $1e6e60f1fe27cc1f$var$baseStyles,
            $1e6e60f1fe27cc1f$var$focusRingStyles,
            isDisabled ? $1e6e60f1fe27cc1f$var$disabledStyles : $1e6e60f1fe27cc1f$var$enabledStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            backgroundColor && (0, $ebe1decd94278ef0$export$e7af83bafe7f9e63)[backgroundColor],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            padding && (0, $ebe1decd94278ef0$export$e615f061ca585a6c).padding[padding],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlock && (0, $ebe1decd94278ef0$export$e615f061ca585a6c).paddingBlock[paddingBlock],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockStart && (0, $ebe1decd94278ef0$export$e615f061ca585a6c).paddingBlockStart[paddingBlockStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockEnd && (0, $ebe1decd94278ef0$export$e615f061ca585a6c).paddingBlockEnd[paddingBlockEnd],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInline && (0, $ebe1decd94278ef0$export$e615f061ca585a6c).paddingInline[paddingInline],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineStart && (0, $ebe1decd94278ef0$export$e615f061ca585a6c).paddingInlineStart[paddingInlineStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineEnd && (0, $ebe1decd94278ef0$export$e615f061ca585a6c).paddingInlineEnd[paddingInlineEnd],
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            resolvedStyles.emotion
        ],
        "data-testid": testId
    }), children));
});
var $1e6e60f1fe27cc1f$export$2e2bcd8739ae039 = $1e6e60f1fe27cc1f$var$Pressable;



var $dAx5m = parcelRequire("dAx5m");


var $dAx5m = parcelRequire("dAx5m");



var $dAx5m = parcelRequire("dAx5m");

var $jVTBW = parcelRequire("jVTBW");



var $dAx5m = parcelRequire("dAx5m");
var $f9c3b83b1415ebb3$export$1ca2a26fecb070ae = /*#__PURE__*/ (0, $dAx5m.createContext)("elevation.surface");
var $f9c3b83b1415ebb3$export$1aeb4f6b93c4540d = function useSurface() {
    return (0, $dAx5m.useContext)($f9c3b83b1415ebb3$export$1ca2a26fecb070ae);
};
$f9c3b83b1415ebb3$export$1ca2a26fecb070ae.displayName = "SurfaceProvider";


var $e6d4cc5637a54680$var$_excluded = [
    "as",
    "children",
    "backgroundColor",
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    "style",
    "testId",
    "xcss"
], $e6d4cc5637a54680$var$_excluded2 = [
    "className"
];
var $e6d4cc5637a54680$export$e71c4d32a2263218 = /*#__PURE__*/ (0, $dAx5m.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? "div" : _ref$as, children = _ref.children, backgroundColor = _ref.backgroundColor, padding = _ref.padding, paddingBlock = _ref.paddingBlock, paddingBlockStart = _ref.paddingBlockStart, paddingBlockEnd = _ref.paddingBlockEnd, paddingInline = _ref.paddingInline, paddingInlineStart = _ref.paddingInlineStart, paddingInlineEnd = _ref.paddingInlineEnd, style = _ref.style, testId = _ref.testId, xcss = _ref.xcss, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($74ed1cba0d5551e3$exports)))(_ref, $e6d4cc5637a54680$var$_excluded);
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($74ed1cba0d5551e3$exports)))(htmlAttributes, $e6d4cc5637a54680$var$_excluded2);
    var resolvedStyles = (0, $63532adf9c22de9a$export$a9c84988c8f81f2d)(xcss);
    var node = // @ts-expect-error Expression produces a union type that is too complex to represent. I think this is unavoidable
    (0, $jVTBW.jsx)(Component, (0, (/*@__PURE__*/$parcel$interopDefault($5fb336a98f9116b4$exports)))({
        style: style,
        ref: ref,
        className: resolvedStyles.static
    }, safeHtmlAttributes, {
        css: [
            $e6d4cc5637a54680$var$baseStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            backgroundColor && (0, $ebe1decd94278ef0$export$e7af83bafe7f9e63)[backgroundColor],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $ebe1decd94278ef0$export$5e65a44e5b6ecadb)(backgroundColor) && (0, $ebe1decd94278ef0$export$ff257d957d48c421)[backgroundColor],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            padding && (0, $ebe1decd94278ef0$export$e615f061ca585a6c).padding[padding],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlock && (0, $ebe1decd94278ef0$export$e615f061ca585a6c).paddingBlock[paddingBlock],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockStart && (0, $ebe1decd94278ef0$export$e615f061ca585a6c).paddingBlockStart[paddingBlockStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockEnd && (0, $ebe1decd94278ef0$export$e615f061ca585a6c).paddingBlockEnd[paddingBlockEnd],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInline && (0, $ebe1decd94278ef0$export$e615f061ca585a6c).paddingInline[paddingInline],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineStart && (0, $ebe1decd94278ef0$export$e615f061ca585a6c).paddingInlineStart[paddingInlineStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineEnd && (0, $ebe1decd94278ef0$export$e615f061ca585a6c).paddingInlineEnd[paddingInlineEnd],
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            resolvedStyles.emotion
        ],
        "data-testid": testId
    }), children);
    return backgroundColor ? (0, $jVTBW.jsx)((0, $f9c3b83b1415ebb3$export$1ca2a26fecb070ae).Provider, {
        value: backgroundColor
    }, node) : node;
});
var $e6d4cc5637a54680$export$2e2bcd8739ae039 = $e6d4cc5637a54680$export$e71c4d32a2263218;
var $e6d4cc5637a54680$var$baseStyles = (0, $jVTBW.css)({
    boxSizing: "border-box",
    appearance: "none",
    border: "none"
});


var $0940865cc817fdc8$var$textStyles = (0, $63532adf9c22de9a$export$f6c783d06584602c)({
    // content can grow and shrink
    flexGrow: 1,
    flexShrink: 1,
    // ellipsis for overflow text
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap"
});
var $0940865cc817fdc8$var$iconStyles = (0, $63532adf9c22de9a$export$f6c783d06584602c)({
    display: "flex",
    // icon size cannot grow and shrink
    flexGrow: 0,
    flexShrink: 0,
    alignSelf: "center",
    fontSize: 0,
    lineHeight: 0,
    userSelect: "none"
});
var $0940865cc817fdc8$var$commonStyles = (0, $63532adf9c22de9a$export$f6c783d06584602c)({
    transition: "opacity 0.3s"
});
var $0940865cc817fdc8$var$fadeStyles = (0, $63532adf9c22de9a$export$f6c783d06584602c)({
    opacity: 0
});
/**
 * These CSS variables consumed by the new icons, to allow them to have appropriate
 * padding inside Button while also maintaining spacing for the existing icons.
 *
 * These styles can be removed once the new icons are fully rolled out, feature flag
 * platform.design-system-team.enable-new-icons is cleaned up,
 * and we bump Button to set padding based on the new icons.
 */ var $0940865cc817fdc8$var$beforeIconStyles = (0, $63532adf9c22de9a$export$f6c783d06584602c)({
    // @ts-ignore
    "--ds--button--new-icon-padding-start": "var(--ds-space-050, 4px)",
    // @ts-ignore
    "--ds--button--new-icon-padding-end": "var(--ds-space-025, 2px)"
});
var $0940865cc817fdc8$var$afterIconStyles = (0, $63532adf9c22de9a$export$f6c783d06584602c)({
    // @ts-ignore
    "--ds--button--new-icon-padding-start": "var(--ds-space-025, 2px)",
    // @ts-ignore
    "--ds--button--new-icon-padding-end": "var(--ds-space-050, 4px)"
});
/**
 * __Content__
 *
 * Used for slots within a Button, including icons and text content.
 */ var $0940865cc817fdc8$var$Content = function Content(_ref) {
    var children = _ref.children, _ref$type = _ref.type, type = _ref$type === void 0 ? "text" : _ref$type, isLoading = _ref.isLoading, position = _ref.position;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $e6d4cc5637a54680$export$2e2bcd8739ae039), {
        as: "span",
        xcss: [
            $0940865cc817fdc8$var$commonStyles
        ].concat((0, (/*@__PURE__*/$parcel$interopDefault($d5f3651f1c5ee1c2$exports)))(type === "text" ? [
            $0940865cc817fdc8$var$textStyles
        ] : [
            $0940865cc817fdc8$var$iconStyles
        ]), (0, (/*@__PURE__*/$parcel$interopDefault($d5f3651f1c5ee1c2$exports)))(isLoading ? [
            $0940865cc817fdc8$var$fadeStyles
        ] : []), (0, (/*@__PURE__*/$parcel$interopDefault($d5f3651f1c5ee1c2$exports)))(position === "before" ? [
            $0940865cc817fdc8$var$beforeIconStyles
        ] : []), (0, (/*@__PURE__*/$parcel$interopDefault($d5f3651f1c5ee1c2$exports)))(position === "after" ? [
            $0940865cc817fdc8$var$afterIconStyles
        ] : []))
    }, children);
};
var $0940865cc817fdc8$export$2e2bcd8739ae039 = $0940865cc817fdc8$var$Content;



var $dAx5m = parcelRequire("dAx5m");
function $49c1d773bea318d1$var$isIconRenderProp(func) {
    return !func.displayName && // most function components and class components have a displayName, negate them
    !func.render && // forwardRef doesn't require a display name, however it does include a render function, negate them
    typeof func === "function" // at the very least we need to be a function
    ;
}
/**
 * __Icon renderer__
 *
 * Used to support render props with icons.
 *
 */ var $49c1d773bea318d1$var$IconRenderer = function IconRenderer(_ref) {
    var Icon = _ref.icon, size = _ref.size;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).Fragment, null, $49c1d773bea318d1$var$isIconRenderProp(Icon) ? Icon({
        label: "",
        size: size,
        color: "currentColor"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement(Icon, {
        label: "",
        size: size,
        color: "currentColor"
    }));
};
var $49c1d773bea318d1$export$2e2bcd8739ae039 = $49c1d773bea318d1$var$IconRenderer;




var $dAx5m = parcelRequire("dAx5m");

var $h0JxK = parcelRequire("h0JxK");

var $2Dg3J = parcelRequire("2Dg3J");

var $gMIYi = parcelRequire("gMIYi");

var $jAmv0 = parcelRequire("jAmv0");



var $ez4n6 = parcelRequire("ez4n6");

var $dAx5m = parcelRequire("dAx5m");
var $44b86d3177478458$export$4b86304b2c0d7e71 = /*#__PURE__*/ (0, $dAx5m.createContext)(undefined);
var $44b86d3177478458$export$47e2c6fdb142d947 = function useSplitButtonContext() {
    var context = (0, $dAx5m.useContext)($44b86d3177478458$export$4b86304b2c0d7e71);
    if (!context) return undefined;
    if (context.appearance === "navigation") {
        var newContext = {
            spacing: "default",
            appearance: "subtle",
            isDisabled: false,
            isActiveOverSelected: false,
            isNavigationSplitButton: true,
            isHighlighted: context.isHighlighted
        };
        return newContext;
    }
    var splitButtonContext = {
        spacing: context.spacing,
        appearance: context.appearance,
        isDisabled: context.isDisabled,
        isActiveOverSelected: true,
        isNavigationSplitButton: false,
        isHighlighted: false
    };
    return splitButtonContext;
};


function $6584783d1dd73b46$var$abort(event) {
    event.preventDefault();
    event.stopPropagation();
}
var $6584783d1dd73b46$var$tabKeyCode = 9;
function $6584783d1dd73b46$var$onKey(event) {
    // Allowing tab so that a user can move focus away
    if (event.keyCode === $6584783d1dd73b46$var$tabKeyCode) return;
    $6584783d1dd73b46$var$abort(event);
}
function $6584783d1dd73b46$export$2e2bcd8739ae039(shouldBlockEvents, events) {
    return shouldBlockEvents ? {
        onMouseDownCapture: $6584783d1dd73b46$var$abort,
        onMouseUpCapture: $6584783d1dd73b46$var$abort,
        onKeyDownCapture: $6584783d1dd73b46$var$onKey,
        onKeyUpCapture: $6584783d1dd73b46$var$onKey,
        onTouchStartCapture: $6584783d1dd73b46$var$abort,
        onTouchEndCapture: $6584783d1dd73b46$var$abort,
        onPointerDownCapture: $6584783d1dd73b46$var$abort,
        onPointerUpCapture: $6584783d1dd73b46$var$abort,
        onClickCapture: $6584783d1dd73b46$var$abort,
        // Just smashing the existing onClick for good measure
        onClick: $6584783d1dd73b46$var$abort
    } : events;
}


var $9c0f404cb9dc279e$export$d4c5499dc806c969 = ", Loading";



var $dAx5m = parcelRequire("dAx5m");
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $dAx5m = parcelRequire("dAx5m");

var $jVTBW = parcelRequire("jVTBW");

var $kqsmh = parcelRequire("kqsmh");
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // Reds
var $6f6c0bc90bc4e66c$export$4b84fd0e2c617bd = "#FFEBE6";
var $6f6c0bc90bc4e66c$export$b34b069eff244586 = "#FFBDAD";
var $6f6c0bc90bc4e66c$export$be802dd0d8b57f35 = "#FF8F73";
var $6f6c0bc90bc4e66c$export$60847d42f9da92a6 = "#FF7452";
var $6f6c0bc90bc4e66c$export$4a7404f376229999 = "#FF5630";
var $6f6c0bc90bc4e66c$export$2010d0fb4295b346 = "#DE350B";
var $6f6c0bc90bc4e66c$export$2837b5a1a71d5c02 = "#BF2600";
var $6f6c0bc90bc4e66c$export$8d9596b529bbb9cf = "#FFFAE6";
var $6f6c0bc90bc4e66c$export$41060a744ab0b7ae = "#FFF0B3";
var $6f6c0bc90bc4e66c$export$1cc05bbbf340e559 = "#FFE380";
var $6f6c0bc90bc4e66c$export$5aae31392d72caaa = "#FFC400";
var $6f6c0bc90bc4e66c$export$c6930421db9fa514 = "#FFAB00";
var $6f6c0bc90bc4e66c$export$59619663aa6500fb = "#FF991F";
var $6f6c0bc90bc4e66c$export$874739ea9e379ab6 = "#FF8B00";
var $6f6c0bc90bc4e66c$export$8a6341c32b6a3ee6 = "#E3FCEF";
var $6f6c0bc90bc4e66c$export$69a3bf21b9686c2b = "#ABF5D1";
var $6f6c0bc90bc4e66c$export$afbce1382ec95f73 = "#79F2C0";
var $6f6c0bc90bc4e66c$export$747d86715d4175de = "#57D9A3";
var $6f6c0bc90bc4e66c$export$940e1f69e873f202 = "#36B37E";
var $6f6c0bc90bc4e66c$export$a49394138f7b8e85 = "#00875A";
var $6f6c0bc90bc4e66c$export$6fa04827ac68a4fb = "#006644";
var $6f6c0bc90bc4e66c$export$226de0355ed012f8 = "#DEEBFF";
var $6f6c0bc90bc4e66c$export$8c13c2ee36917869 = "#B3D4FF";
var $6f6c0bc90bc4e66c$export$ecfc1dff386a3e7a = "#4C9AFF";
var $6f6c0bc90bc4e66c$export$215b7063051591f1 = "#2684FF";
var $6f6c0bc90bc4e66c$export$e62e8919cca44969 = "#0065FF";
var $6f6c0bc90bc4e66c$export$b3de0ae08da2ce64 = "#0052CC";
var $6f6c0bc90bc4e66c$export$a6ee3d71bc067634 = "#0747A6";
var $6f6c0bc90bc4e66c$export$363e4475840015bb = "#EAE6FF";
var $6f6c0bc90bc4e66c$export$4b0a4417ed59760f = "#C0B6F2";
var $6f6c0bc90bc4e66c$export$6011520a64d9a187 = "#998DD9";
var $6f6c0bc90bc4e66c$export$a7175d4e9206bc80 = "#8777D9";
var $6f6c0bc90bc4e66c$export$b48405b95304b5a1 = "#6554C0";
var $6f6c0bc90bc4e66c$export$c71e4279dd54a18d = "#5243AA";
var $6f6c0bc90bc4e66c$export$147899de772240ec = "#403294";
var $6f6c0bc90bc4e66c$export$2cf711fe14c66f06 = "#E6FCFF";
var $6f6c0bc90bc4e66c$export$7a8f4d33f6f9772c = "#B3F5FF";
var $6f6c0bc90bc4e66c$export$776c9c497ef08533 = "#79E2F2";
var $6f6c0bc90bc4e66c$export$69cb3ca10c1e330e = "#00C7E6";
var $6f6c0bc90bc4e66c$export$9dc1ef0f3f48059b = "#00B8D9";
var $6f6c0bc90bc4e66c$export$7c835c78b6fcdef8 = "#00A3BF";
var $6f6c0bc90bc4e66c$export$6036577f95c3877e = "#008DA6";
var $6f6c0bc90bc4e66c$export$29a4f05edc054374 = "#FFFFFF";
var $6f6c0bc90bc4e66c$export$e655ef011c4aa1a2 = "#FAFBFC";
var $6f6c0bc90bc4e66c$export$9fdfb749e33cdf97 = "#F4F5F7";
var $6f6c0bc90bc4e66c$export$3e51e8f1440314ba = "#EBECF0";
var $6f6c0bc90bc4e66c$export$1ce2d1575d444ceb = "#DFE1E6";
var $6f6c0bc90bc4e66c$export$8754fc7e6d8b3000 = "#C1C7D0";
var $6f6c0bc90bc4e66c$export$c2e91cbeada39b8b = "#B3BAC5";
var $6f6c0bc90bc4e66c$export$5f71e19f3a7ad9de = "#A5ADBA";
var $6f6c0bc90bc4e66c$export$eaa8c8a70ac22806 = "#97A0AF";
var $6f6c0bc90bc4e66c$export$7c87d337fb91a97d = "#8993A4";
var $6f6c0bc90bc4e66c$export$d6447c357493214f = "#7A869A";
var $6f6c0bc90bc4e66c$export$f563ee71e9ee74cd = "#6B778C";
var $6f6c0bc90bc4e66c$export$e2ef2124cf4024b1 = "#5E6C84";
var $6f6c0bc90bc4e66c$export$eece5f492e429f08 = "#505F79";
var $6f6c0bc90bc4e66c$export$c39c0fe0f26207ae = "#42526E";
var $6f6c0bc90bc4e66c$export$7090862dc3038a9f = "#344563";
var $6f6c0bc90bc4e66c$export$ad0bacf983b7ddaa = "#253858";
var $6f6c0bc90bc4e66c$export$7d61b15e0da132af = "#172B4D";
var $6f6c0bc90bc4e66c$export$fbda843f0a27fe96 = "#091E42";
var $6f6c0bc90bc4e66c$export$791e57b27ca738ef = "rgba(9, 30, 66, 0.02)";
var $6f6c0bc90bc4e66c$export$8d43898f60b96a82 = "rgba(9, 30, 66, 0.04)";
var $6f6c0bc90bc4e66c$export$920c0d5c49070351 = "rgba(9, 30, 66, 0.08)";
var $6f6c0bc90bc4e66c$export$46987b49aab6d1a8 = "rgba(9, 30, 66, 0.13)";
var $6f6c0bc90bc4e66c$export$7d3359664e8bb0e5 = "rgba(9, 30, 66, 0.25)";
var $6f6c0bc90bc4e66c$export$d2d3bedfb276cac0 = "rgba(9, 30, 66, 0.31)";
var $6f6c0bc90bc4e66c$export$6e5e7499ff054f6d = "rgba(9, 30, 66, 0.36)";
var $6f6c0bc90bc4e66c$export$59264b346c877fa7 = "rgba(9, 30, 66, 0.42)";
var $6f6c0bc90bc4e66c$export$d092757d7c64925c = "rgba(9, 30, 66, 0.48)";
var $6f6c0bc90bc4e66c$export$486ab785e4bac3c6 = "rgba(9, 30, 66, 0.54)";
var $6f6c0bc90bc4e66c$export$fba592bbc6419fea = "rgba(9, 30, 66, 0.60)";
var $6f6c0bc90bc4e66c$export$13609db0e6812ab8 = "rgba(9, 30, 66, 0.66)";
var $6f6c0bc90bc4e66c$export$fbae4efaa892d883 = "rgba(9, 30, 66, 0.71)";
var $6f6c0bc90bc4e66c$export$f13946d26f440ce6 = "rgba(9, 30, 66, 0.77)";
var $6f6c0bc90bc4e66c$export$19f58225ac52a306 = "rgba(9, 30, 66, 0.82)";
var $6f6c0bc90bc4e66c$export$6384f09da70e7b62 = "rgba(9, 30, 66, 0.89)";
var $6f6c0bc90bc4e66c$export$d0dccc730683edc2 = "rgba(9, 30, 66, 0.95)";
var $6f6c0bc90bc4e66c$export$2f6319cf7d736c2a = "#E6EDFA";
var $6f6c0bc90bc4e66c$export$95126bc8884d6634 = "#DCE5F5";
var $6f6c0bc90bc4e66c$export$8338d8c35d44ff1 = "#CED9EB";
var $6f6c0bc90bc4e66c$export$5368d76ae4fbbda7 = "#B8C7E0";
var $6f6c0bc90bc4e66c$export$9f0a771d16ec8d36 = "#ABBBD6";
var $6f6c0bc90bc4e66c$export$abcf8c38338b4aa5 = "#9FB0CC";
var $6f6c0bc90bc4e66c$export$97e81faa16a182c7 = "#8C9CB8";
var $6f6c0bc90bc4e66c$export$bfe21c59123ecf33 = "#7988A3";
var $6f6c0bc90bc4e66c$export$ee82aa2ea6a1558 = "#67758F";
var $6f6c0bc90bc4e66c$export$682927c6ed76be02 = "#56637A";
var $6f6c0bc90bc4e66c$export$91fd9994c5be9757 = "#455166";
var $6f6c0bc90bc4e66c$export$d281fbfe3cff2df6 = "#3B475C";
var $6f6c0bc90bc4e66c$export$3902c91d8b98a753 = "#313D52";
var $6f6c0bc90bc4e66c$export$8e8133c1ba5845b5 = "#283447";
var $6f6c0bc90bc4e66c$export$33ff357f6620b39 = "#202B3D";
var $6f6c0bc90bc4e66c$export$633847cf062b69e0 = "#1B2638";
var $6f6c0bc90bc4e66c$export$9776a6e503bdbf76 = "#121A29";
var $6f6c0bc90bc4e66c$export$6c813d5160dff5db = "#0E1624";
var $6f6c0bc90bc4e66c$export$3d4f271a500072a = "#0D1424";
var $6f6c0bc90bc4e66c$export$fe151285c22759ec = "rgba(13, 20, 36, 0.06)";
var $6f6c0bc90bc4e66c$export$a101c6190d0da34 = "rgba(13, 20, 36, 0.14)";
var $6f6c0bc90bc4e66c$export$4b16f52932fda51 = "rgba(13, 20, 36, 0.18)";
var $6f6c0bc90bc4e66c$export$a74bcd7b9845b0d8 = "rgba(13, 20, 36, 0.29)";
var $6f6c0bc90bc4e66c$export$9209c179316d1751 = "rgba(13, 20, 36, 0.36)";
var $6f6c0bc90bc4e66c$export$88f55133f636c8dd = "rgba(13, 20, 36, 0.40)";
var $6f6c0bc90bc4e66c$export$51126f85d1009512 = "rgba(13, 20, 36, 0.47)";
var $6f6c0bc90bc4e66c$export$a069b547bd23af78 = "rgba(13, 20, 36, 0.53)";
var $6f6c0bc90bc4e66c$export$40cce05af3b2600a = "rgba(13, 20, 36, 0.63)";
var $6f6c0bc90bc4e66c$export$b78942185925a0d = "rgba(13, 20, 36, 0.73)";
var $6f6c0bc90bc4e66c$export$e058fb44b8eaafca = "rgba(13, 20, 36, 0.78)";
var $6f6c0bc90bc4e66c$export$92b0b8de26920c18 = "rgba(13, 20, 36, 0.81)";
var $6f6c0bc90bc4e66c$export$67564f7459d3fc9e = "rgba(13, 20, 36, 0.85)";
var $6f6c0bc90bc4e66c$export$77868e1ca884ffa3 = "rgba(13, 20, 36, 0.89)";
var $6f6c0bc90bc4e66c$export$2afd71d7d3ea2cd5 = "rgba(13, 20, 36, 0.92)";
var $6f6c0bc90bc4e66c$export$f2a0acaab9972c70 = "rgba(13, 20, 36, 0.95)";
var $6f6c0bc90bc4e66c$export$9ab70e67d6475361 = "rgba(13, 20, 36, 0.97)";


var $c1407236696fbf71$export$4e9f1640bbe7a1a8 = {
    xsmall: 8,
    small: 16,
    medium: 24,
    large: 48,
    xlarge: 96
};


/**
 * Returns the appropriate circle stroke color.
 */ function $917ea1ded1dd2c62$var$getStrokeColor(appearance) {
    return appearance === "inherit" ? "var(--ds-icon-subtle, ".concat((0, $6f6c0bc90bc4e66c$export$c39c0fe0f26207ae), ")") : "var(--ds-icon-inverse, ".concat((0, $6f6c0bc90bc4e66c$export$29a4f05edc054374), ")");
}
var $917ea1ded1dd2c62$var$rotate = (0, $jVTBW.keyframes)({
    to: {
        transform: "rotate(360deg)"
    }
});
var $917ea1ded1dd2c62$var$rotateStyles = (0, $jVTBW.css)({
    animation: "".concat($917ea1ded1dd2c62$var$rotate, " 0.86s infinite"),
    animationTimingFunction: "cubic-bezier(0.4, 0.15, 0.6, 0.85)",
    transformOrigin: "center"
});
/**
 * There are three parts to the load in animation:
 * 1. Fade in
 * 2. Accelerated spin
 * 3. Stretch the spinner line
 */ var $917ea1ded1dd2c62$var$loadIn = (0, $jVTBW.keyframes)({
    from: {
        transform: "rotate(50deg)",
        opacity: 0,
        strokeDashoffset: 60
    },
    to: {
        transform: "rotate(230deg)",
        opacity: 1,
        strokeDashoffset: 50
    }
});
var $917ea1ded1dd2c62$var$loadInStyles = (0, $jVTBW.css)({
    animation: "".concat($917ea1ded1dd2c62$var$loadIn, " 1s ease-in-out"),
    /**
   * When the animation completes, stay at the last frame of the animation.
   */ animationFillMode: "forwards",
    /**
   * We are going to animate this in.
   */ opacity: 0
});
var $917ea1ded1dd2c62$var$wrapperStyles = (0, $jVTBW.css)({
    display: "inline-flex",
    /**
   * Align better inline with text.
   */ verticalAlign: "middle"
});
var $917ea1ded1dd2c62$var$circleStyles = (0, $jVTBW.css)({
    fill: "none",
    strokeDasharray: 60,
    strokeDashoffset: "inherit",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    "@media screen and (forced-colors: active)": {
        filter: "grayscale(100%)",
        stroke: "CanvasText"
    }
});
/**
 * `useLayoutEffect` is being used in SSR safe form. On the server, this work doesn’t need to run.
 * `useEffect` is used in-place, because `useEffect` is not run on the server and it matches types
 * which makes things simpler than doing an `isServer` check or a `null` check.
 *
 * @see https://hello.atlassian.net/wiki/spaces/DST/pages/2081696628/DSTDACI-010+-+Interaction+Tracing+hooks+in+DS+components
 */ var $917ea1ded1dd2c62$var$useLayoutEffect = typeof window === "undefined" ? (0, $dAx5m.useEffect) : (0, $dAx5m.useLayoutEffect);
/**
 * __Spinner__
 *
 * A spinner is an animated spinning icon that lets users know content is being loaded.
 *
 * - [Examples](https://atlassian.design/components/spinner/examples)
 * - [Code](https://atlassian.design/components/spinner/code)
 * - [Usage](https://atlassian.design/components/spinner/usage)
 */ var $917ea1ded1dd2c62$var$Spinner = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).forwardRef(function Spinner(_ref, ref) {
    var _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "inherit" : _ref$appearance, _ref$delay = _ref.delay, delay = _ref$delay === void 0 ? 0 : _ref$delay, interactionName = _ref.interactionName, label = _ref.label, _ref$size = _ref.size, providedSize = _ref$size === void 0 ? "medium" : _ref$size, testId = _ref.testId;
    var size = typeof providedSize === "number" ? providedSize : (0, $c1407236696fbf71$export$4e9f1640bbe7a1a8)[providedSize];
    var animationDelay = "".concat(delay, "ms");
    var stroke = $917ea1ded1dd2c62$var$getStrokeColor(appearance);
    var context = (0, $dAx5m.useContext)((0, $kqsmh.default));
    $917ea1ded1dd2c62$var$useLayoutEffect(function() {
        if (context != null) return context.hold(interactionName);
    }, [
        context,
        interactionName
    ]);
    /**
   * The Spinner animation uses a combination of two
   * css animations on two separate elements.
   */ return (0, $jVTBW.jsx)("span", {
        /**
     * This span exists to off-load animations from the circle element,
     * which were causing performance issues (style recalculations)
     * on Safari and older versions of Chrome.
     *
     * This can be removed and styles placed back on the circle element once
     * Safari fixes this bug and off-loads rendering to the GPU from the CPU.
     */ css: [
            $917ea1ded1dd2c62$var$wrapperStyles,
            $917ea1ded1dd2c62$var$rotateStyles
        ],
        "data-testid": testId && "".concat(testId, "-wrapper"),
        style: {
            animationDelay: animationDelay,
            width: size,
            height: size
        }
    }, (0, $jVTBW.jsx)("svg", {
        height: size,
        width: size,
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        "data-testid": testId,
        ref: ref,
        "aria-label": label || undefined,
        css: $917ea1ded1dd2c62$var$loadInStyles,
        style: {
            animationDelay: animationDelay
        },
        role: label ? "img" : "none"
    }, (0, $jVTBW.jsx)("circle", {
        cx: "8",
        cy: "8",
        r: "7",
        css: $917ea1ded1dd2c62$var$circleStyles,
        style: {
            stroke: stroke
        }
    })));
}));
var $917ea1ded1dd2c62$export$2e2bcd8739ae039 = $917ea1ded1dd2c62$var$Spinner;


function $eeec9d6e62c64a6a$var$getIconSpacing(spacing) {
    switch(spacing){
        case "compact":
            return "small";
        case "none":
            return "xsmall";
        default:
            return "medium";
    }
}
function $eeec9d6e62c64a6a$var$getSpinnerAppearance(_ref) {
    var appearance = _ref.appearance, isDisabled = _ref.isDisabled, isSelected = _ref.isSelected;
    if (isDisabled || isSelected) return "inherit";
    if (appearance === "primary" || appearance === "danger" || appearance === "discovery") return "invert";
    return "inherit";
}
function $eeec9d6e62c64a6a$export$2e2bcd8739ae039(_ref2) {
    var appearance = _ref2.appearance, spacing = _ref2.spacing, isDisabled = _ref2.isDisabled, isSelected = _ref2.isSelected, testId = _ref2.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $917ea1ded1dd2c62$export$2e2bcd8739ae039), {
        size: $eeec9d6e62c64a6a$var$getIconSpacing(spacing),
        appearance: $eeec9d6e62c64a6a$var$getSpinnerAppearance({
            appearance: appearance,
            isDisabled: isDisabled,
            isSelected: isSelected
        }),
        testId: testId ? "".concat(testId, "--loading-spinner") : undefined
    });
}


function $149fd663360e3021$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $149fd663360e3021$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $149fd663360e3021$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($c3ec97511ae1ed64$exports)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $149fd663360e3021$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $149fd663360e3021$var$buttonStyles = (0, $63532adf9c22de9a$export$f6c783d06584602c)({
    display: "inline-flex",
    boxSizing: "border-box",
    width: "auto",
    maxWidth: "100%",
    position: "relative",
    alignItems: "baseline",
    justifyContent: "center",
    columnGap: "space.050",
    borderRadius: "border.radius.100",
    borderWidth: "border.width.0",
    flexShrink: 0,
    height: "".concat(32 / 14, "em"),
    paddingInlineEnd: "space.150",
    paddingInlineStart: "space.150",
    textAlign: "center",
    transition: "background 0.1s ease-out",
    verticalAlign: "middle",
    "::after": {
        borderRadius: "inherit",
        inset: "space.0",
        borderStyle: "solid",
        borderWidth: "var(--ds-border-width, 1px)",
        pointerEvents: "none",
        position: "absolute"
    }
});
var $149fd663360e3021$var$hardCodedButtonStyles = (0, $63532adf9c22de9a$export$f6c783d06584602c)({
    fontFamily: "inherit",
    fontSize: "inherit",
    fontStyle: "normal",
    fontWeight: 500,
    lineHeight: "".concat(32 / 14, "em"),
    paddingBlock: "space.0"
});
var $149fd663360e3021$var$tokenizedButtonStyles = (0, $63532adf9c22de9a$export$f6c783d06584602c)({
    font: 'var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    fontWeight: "var(--ds-font-weight-medium, 500)",
    paddingBlock: "space.075"
});
var $149fd663360e3021$var$defaultInteractiveStyles = (0, $63532adf9c22de9a$export$f6c783d06584602c)({
    ":hover": {
        background: "var(--ds-background-neutral-hovered, #091e4214)",
        // @ts-expect-error
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        color: "var(--ds-text, ".concat($e996865a8c4821b6$export$c39c0fe0f26207ae, ")")
    },
    ":active": {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        background: "var(--ds-background-neutral-pressed, ".concat($e996865a8c4821b6$export$8c13c2ee36917869, ")"),
        // @ts-expect-error
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        color: "var(--ds-text, ".concat($e996865a8c4821b6$export$b3de0ae08da2ce64, ")")
    }
});
var $149fd663360e3021$var$defaultInteractiveRefreshedStyles = (0, $63532adf9c22de9a$export$f6c783d06584602c)({
    ":hover": {
        background: "var(--ds-background-neutral-subtle-hovered, #091E420F)",
        color: "color.text.subtle"
    },
    ":active": {
        background: "var(--ds-background-neutral-subtle-pressed, #091E4224)",
        color: "color.text.subtle"
    }
});
var $149fd663360e3021$var$defaultStyles = (0, $63532adf9c22de9a$export$f6c783d06584602c)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
    background: "var(--ds-background-neutral, ".concat($e996865a8c4821b6$export$8d43898f60b96a82, ")"),
    // @ts-expect-error — using tokens for explicit fallback usage.
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values --  -- Ignored via go/DSP-18766
    color: "var(--ds-text, ".concat($e996865a8c4821b6$export$c39c0fe0f26207ae, ")"),
    ":visited": {
        // @ts-expect-error
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        color: "var(--ds-text, ".concat($e996865a8c4821b6$export$c39c0fe0f26207ae, ")")
    }
});
var $149fd663360e3021$var$defaultRefreshedStyles = (0, $63532adf9c22de9a$export$f6c783d06584602c)({
    background: "var(--ds-background-neutral-subtle, #00000000)",
    color: "color.text.subtle",
    "::after": {
        content: '""',
        borderColor: "color.border"
    },
    ":visited": {
        color: "color.text.subtle"
    }
});
var $149fd663360e3021$var$primaryStyles = (0, $63532adf9c22de9a$export$f6c783d06584602c)({
    background: "var(--ds-background-brand-bold, #0052CC)",
    // @ts-expect-error
    color: "var(--ds-text-inverse, #FFFFFF)",
    ":visited": {
        // @ts-expect-error
        color: "var(--ds-text-inverse, #FFFFFF)"
    }
});
var $149fd663360e3021$var$primaryInteractiveStyles = (0, $63532adf9c22de9a$export$f6c783d06584602c)({
    ":hover": {
        // @ts-expect-error
        color: "var(--ds-text-inverse, #FFFFFF)",
        background: "var(--ds-background-brand-bold-hovered, #0065FF)"
    },
    ":active": {
        // @ts-expect-error
        color: "var(--ds-text-inverse, #FFFFFF)",
        background: "var(--ds-background-brand-bold-pressed, #0747A6)"
    }
});
var $149fd663360e3021$var$warningStyles = (0, $63532adf9c22de9a$export$f6c783d06584602c)({
    background: "var(--ds-background-warning-bold, #FFAB00)",
    // @ts-expect-error
    color: "var(--ds-text-warning-inverse, #172B4D)",
    ":visited": {
        // @ts-expect-error
        color: "var(--ds-text-warning-inverse, #172B4D)"
    }
});
var $149fd663360e3021$var$warningInteractiveStyles = (0, $63532adf9c22de9a$export$f6c783d06584602c)({
    ":hover": {
        // @ts-expect-error
        color: "var(--ds-text-warning-inverse, #172B4D)",
        background: "var(--ds-background-warning-bold-hovered, #FFC400)"
    },
    ":active": {
        // @ts-expect-error
        color: "var(--ds-text-warning-inverse, #172B4D)",
        background: "var(--ds-background-warning-bold-pressed, #FF991F)"
    }
});
var $149fd663360e3021$var$dangerStyles = (0, $63532adf9c22de9a$export$f6c783d06584602c)({
    background: "var(--ds-background-danger-bold, #DE350B)",
    color: "color.text.inverse",
    ":visited": {
        color: "color.text.inverse"
    }
});
var $149fd663360e3021$var$dangerInteractiveStyles = (0, $63532adf9c22de9a$export$f6c783d06584602c)({
    ":hover": {
        color: "color.text.inverse",
        background: "var(--ds-background-danger-bold-hovered, #FF5630)"
    },
    ":active": {
        color: "color.text.inverse",
        background: "var(--ds-background-danger-bold-pressed, #BF2600)"
    }
});
var $149fd663360e3021$var$discoveryStyles = (0, $63532adf9c22de9a$export$f6c783d06584602c)({
    background: "var(--ds-background-discovery-bold, #5243AA)",
    color: "color.text.inverse",
    ":visited": {
        color: "color.text.inverse"
    }
});
var $149fd663360e3021$var$discoveryInteractiveStyles = (0, $63532adf9c22de9a$export$f6c783d06584602c)({
    ":hover": {
        color: "color.text.inverse",
        background: "var(--ds-background-discovery-bold-hovered, #8777D9)"
    },
    ":active": {
        color: "color.text.inverse",
        background: "var(--ds-background-discovery-bold-pressed, #5243AA)"
    }
});
var $149fd663360e3021$var$subtleStyles = (0, $63532adf9c22de9a$export$f6c783d06584602c)({
    background: "var(--ds-background-neutral-subtle, transparent)",
    // @ts-expect-error
    color: "var(--ds-text, #42526E)",
    ":visited": {
        // @ts-expect-error
        color: "var(--ds-text, #42526E)"
    }
});
var $149fd663360e3021$var$subtleRefreshedStyles = (0, $63532adf9c22de9a$export$f6c783d06584602c)({
    background: "var(--ds-background-neutral-subtle, transparent)",
    color: "color.text.subtle",
    ":visited": {
        color: "color.text.subtle"
    }
});
var $149fd663360e3021$var$subtleInteractiveStyles = (0, $63532adf9c22de9a$export$f6c783d06584602c)({
    ":hover": {
        background: "var(--ds-background-neutral-subtle-hovered, #091e4214)",
        // @ts-expect-error
        color: "var(--ds-text, #42526E)"
    },
    ":active": {
        background: "var(--ds-background-neutral-subtle-pressed, #B3D4FF)",
        // @ts-expect-error
        color: "var(--ds-text, #42526E)"
    }
});
var $149fd663360e3021$var$subtleInteractiveRefreshedStyles = (0, $63532adf9c22de9a$export$f6c783d06584602c)({
    ":hover": {
        background: "var(--ds-background-neutral-subtle-hovered, #091e4214)",
        color: "color.text.subtle"
    },
    ":active": {
        background: "var(--ds-background-neutral-subtle-pressed, #B3D4FF)",
        color: "color.text.subtle"
    }
});
var $149fd663360e3021$var$linkStyles = (0, $63532adf9c22de9a$export$f6c783d06584602c)({
    // @ts-expect-error
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    color: "var(--ds-link, ".concat($e996865a8c4821b6$export$b3de0ae08da2ce64, ")"),
    background: "var(--ds-background-neutral-subtle, transparent)",
    textDecoration: "none",
    ":hover": {
        // @ts-expect-error
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        color: "var(--ds-link, ".concat($e996865a8c4821b6$export$e62e8919cca44969, ")"),
        background: "var(--ds-background-neutral-subtle, transparent)"
    },
    ":active": {
        // @ts-expect-error
        color: "var(--ds-link-pressed, #0055CC)",
        background: "var(--ds-background-neutral-subtle, transparent)"
    },
    ":visited": {
        // @ts-expect-error
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        color: "var(--ds-link, ".concat($e996865a8c4821b6$export$b3de0ae08da2ce64, ")")
    }
});
var $149fd663360e3021$var$subtleLinkStyles = (0, $63532adf9c22de9a$export$f6c783d06584602c)({
    // @ts-expect-error
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    color: "var(--ds-text-subtle, ".concat($e996865a8c4821b6$export$f563ee71e9ee74cd, ")"),
    background: "var(--ds-background-neutral-subtle, transparent)",
    textDecoration: "none",
    ":hover": {
        // @ts-expect-error
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        color: "var(--ds-text-subtle, ".concat($e996865a8c4821b6$export$7c87d337fb91a97d, ")"),
        background: "var(--ds-background-neutral-subtle, transparent)"
    },
    ":active": {
        // @ts-expect-error
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        color: "var(--ds-text, ".concat($e996865a8c4821b6$export$eece5f492e429f08, ")"),
        background: "var(--ds-background-neutral-subtle, transparent)"
    },
    ":visited": {
        // @ts-expect-error
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        color: "var(--ds-text-subtle, ".concat($e996865a8c4821b6$export$f563ee71e9ee74cd, ")")
    }
});
// Required due to Jira's AUI CSS reset: https://product-fabric.atlassian.net/browse/DSP-15687
var $149fd663360e3021$var$linkDecorationUnsetStyles = (0, $63532adf9c22de9a$export$f6c783d06584602c)({
    textDecoration: "none",
    ":hover": {
        textDecoration: "none"
    },
    ":active": {
        textDecoration: "none"
    },
    ":focus": {
        textDecoration: "none"
    }
});
var $149fd663360e3021$var$linkDecorationStyles = (0, $63532adf9c22de9a$export$f6c783d06584602c)({
    ":hover": {
        textDecoration: "underline"
    },
    ":focus": {
        textDecoration: "underline"
    }
});
var $149fd663360e3021$var$disabledStyles = (0, $63532adf9c22de9a$export$f6c783d06584602c)({
    cursor: "not-allowed",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    background: "var(--ds-background-disabled, ".concat($e996865a8c4821b6$export$8d43898f60b96a82, ")"),
    // @ts-expect-error
    color: "var(--ds-text-disabled, #091E424F)",
    ":hover": {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        background: "var(--ds-background-disabled, ".concat($e996865a8c4821b6$export$8d43898f60b96a82, ")"),
        // @ts-expect-error
        color: "var(--ds-text-disabled, #091E424F)"
    },
    ":active": {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        background: "var(--ds-background-disabled, ".concat($e996865a8c4821b6$export$8d43898f60b96a82, ")"),
        // @ts-expect-error
        color: "var(--ds-text-disabled, #091E424F)"
    },
    "::after": {
        content: "none"
    }
});
var $149fd663360e3021$var$selectedStyles = (0, $63532adf9c22de9a$export$f6c783d06584602c)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    background: "var(--ds-background-selected, ".concat($e996865a8c4821b6$export$ad0bacf983b7ddaa, ")"),
    // @ts-expect-error
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    color: "var(--ds-text-selected, ".concat($e996865a8c4821b6$export$9fdfb749e33cdf97, ")"),
    ":visited": {
        // @ts-expect-error
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        color: "var(--ds-text-selected, ".concat($e996865a8c4821b6$export$9fdfb749e33cdf97, ")")
    }
});
var $149fd663360e3021$var$selectedRefreshedStyles = (0, $63532adf9c22de9a$export$f6c783d06584602c)({
    background: "var(--ds-background-selected, #E9F2FF)",
    color: "color.text.selected",
    "::after": {
        content: '""',
        borderColor: "color.border.selected"
    },
    ":visited": {
        color: "color.text.selected"
    }
});
var $149fd663360e3021$var$selectedInsideSplitButtonStyles = (0, $63532adf9c22de9a$export$f6c783d06584602c)({
    // This is 2 so it appears above the split button divider when selected.
    // See split-button.tsx.
    // @ts-expect-error — We need a local zindex just for button.
    zIndex: 2
});
var $149fd663360e3021$var$selectedInteractiveStyles = (0, $63532adf9c22de9a$export$f6c783d06584602c)({
    ":hover": {
        // @ts-expect-error
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        color: "var(--ds-text-selected, ".concat($e996865a8c4821b6$export$9fdfb749e33cdf97, ")"),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        background: "var(--ds-background-selected-hovered, ".concat($e996865a8c4821b6$export$ad0bacf983b7ddaa, ")")
    },
    ":active": {
        // @ts-expect-error
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        color: "var(--ds-text-selected, ".concat($e996865a8c4821b6$export$9fdfb749e33cdf97, ")"),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        background: "var(--ds-background-selected-pressed, ".concat($e996865a8c4821b6$export$ad0bacf983b7ddaa, ")")
    }
});
// TODO: Remove me once we kill color fallbacks
var $149fd663360e3021$var$selectedWarningStyles = (0, $63532adf9c22de9a$export$f6c783d06584602c)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    background: "var(--ds-background-selected, ".concat($e996865a8c4821b6$export$59619663aa6500fb, ")"),
    // @ts-expect-error
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    color: "var(--ds-text-selected, ".concat($e996865a8c4821b6$export$7d61b15e0da132af, ")"),
    ":hover": {
        // @ts-expect-error
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        color: "var(--ds-text-selected, ".concat($e996865a8c4821b6$export$9fdfb749e33cdf97, ")"),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        background: "var(--ds-background-selected, ".concat($e996865a8c4821b6$export$59619663aa6500fb, ")")
    },
    ":active": {
        // @ts-expect-error
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        color: "var(--ds-text-selected, ".concat($e996865a8c4821b6$export$9fdfb749e33cdf97, ")"),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        background: "var(--ds-background-selected, ".concat($e996865a8c4821b6$export$59619663aa6500fb, ")")
    }
});
// TODO: Remove me once we kill color fallbacks
var $149fd663360e3021$var$selectedDangerStyles = (0, $63532adf9c22de9a$export$f6c783d06584602c)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    background: "var(--ds-background-selected, ".concat($e996865a8c4821b6$export$2837b5a1a71d5c02, ")"),
    // @ts-expect-error
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    color: "var(--ds-text-selected, ".concat($e996865a8c4821b6$export$9fdfb749e33cdf97, ")"),
    ":hover": {
        // @ts-expect-error
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        color: "var(--ds-text-selected, ".concat($e996865a8c4821b6$export$9fdfb749e33cdf97, ")"),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        background: "var(--ds-background-selected, ".concat($e996865a8c4821b6$export$2837b5a1a71d5c02, ")")
    },
    ":active": {
        // @ts-expect-error
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        color: "var(--ds-text-selected, ".concat($e996865a8c4821b6$export$9fdfb749e33cdf97, ")"),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        background: "var(--ds-background-selected, ".concat($e996865a8c4821b6$export$2837b5a1a71d5c02, ")")
    }
});
// TODO: Remove me once we kill color fallbacks
var $149fd663360e3021$var$selectedDiscoveryStyles = (0, $63532adf9c22de9a$export$f6c783d06584602c)({
    background: "var(--ds-background-selected, #403294)",
    // @ts-expect-error
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    color: "var(--ds-text-selected, ".concat($e996865a8c4821b6$export$9fdfb749e33cdf97, ")"),
    ":hover": {
        // @ts-expect-error
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        color: "var(--ds-text-selected, ".concat($e996865a8c4821b6$export$9fdfb749e33cdf97, ")"),
        background: "var(--ds-background-selected, #403294)"
    },
    ":active": {
        // @ts-expect-error
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        color: "var(--ds-text-selected, ".concat($e996865a8c4821b6$export$9fdfb749e33cdf97, ")"),
        background: "var(--ds-background-selected, #403294)"
    }
});
var $149fd663360e3021$var$spacingCompactStyles = (0, $63532adf9c22de9a$export$f6c783d06584602c)({
    columnGap: "space.050",
    height: "".concat(24 / 14, "em"),
    paddingInlineEnd: "space.150",
    paddingInlineStart: "space.150",
    verticalAlign: "middle"
});
var $149fd663360e3021$var$baseSpacingCompactStyles = (0, $63532adf9c22de9a$export$f6c783d06584602c)({
    lineHeight: "".concat(24 / 14, "em")
});
var $149fd663360e3021$var$tokenizedSpacingCompactStyles = (0, $63532adf9c22de9a$export$f6c783d06584602c)({
    paddingBlock: "space.025"
});
var $149fd663360e3021$var$spacingNoneStyles = (0, $63532adf9c22de9a$export$f6c783d06584602c)({
    columnGap: "space.0",
    height: "auto",
    lineHeight: "inherit",
    paddingInlineEnd: "space.0",
    paddingInlineStart: "space.0",
    verticalAlign: "baseline"
});
var $149fd663360e3021$var$tokenizedSpacingNoneStyles = (0, $63532adf9c22de9a$export$f6c783d06584602c)({
    paddingBlock: "space.0"
});
var $149fd663360e3021$var$circleStyles = (0, $63532adf9c22de9a$export$f6c783d06584602c)({
    borderRadius: "border.radius.circle"
});
var $149fd663360e3021$var$fullWidthStyles = (0, $63532adf9c22de9a$export$f6c783d06584602c)({
    width: "100%"
});
var $149fd663360e3021$var$loadingStyles = (0, $63532adf9c22de9a$export$f6c783d06584602c)({
    cursor: "progress"
});
var $149fd663360e3021$var$iconButtonStyles = (0, $63532adf9c22de9a$export$f6c783d06584602c)({
    height: "".concat(32 / 14, "em"),
    width: "".concat(32 / 14, "em"),
    paddingInlineEnd: "space.0",
    paddingInlineStart: "space.0"
});
var $149fd663360e3021$var$iconButtonCompactStyles = (0, $63532adf9c22de9a$export$f6c783d06584602c)({
    width: "".concat(24 / 14, "em"),
    height: "".concat(24 / 14, "em")
});
var $149fd663360e3021$var$buttonIconBeforeStyles = (0, $63532adf9c22de9a$export$f6c783d06584602c)({
    paddingInlineStart: "space.100"
});
var $149fd663360e3021$var$buttonIconAfterStyles = (0, $63532adf9c22de9a$export$f6c783d06584602c)({
    paddingInlineEnd: "space.100"
});
var $149fd663360e3021$var$splitButtonStyles = (0, $63532adf9c22de9a$export$f6c783d06584602c)({
    ":focus-visible": {
        zIndex: "card"
    }
});
var $149fd663360e3021$var$navigationSplitButtonStyles = (0, $63532adf9c22de9a$export$f6c783d06584602c)({
    width: "24px",
    backgroundColor: "color.background.neutral.subtle",
    paddingInlineEnd: "space.075",
    paddingInlineStart: "space.075"
});
var $149fd663360e3021$var$loadingOverlayStyles = (0, $63532adf9c22de9a$export$f6c783d06584602c)({
    display: "flex",
    position: "absolute",
    alignItems: "center",
    justifyContent: "center",
    insetBlockEnd: "space.0",
    insetBlockStart: "space.0",
    insetInlineEnd: "space.0",
    insetInlineStart: "space.0"
});
/**
 * __Use button base__
 *
 * A React hook that accepts a set of common Button props,
 * and processes them to return consistent base props for usage
 * across various Button components.
 *
 * It also:
 * - Implements auto focus when enabled.
 * - Appends the `onClick` event with UFO analytics tracking.
 *
 * @private
 */ var $149fd663360e3021$var$useButtonBase = function useButtonBase(_ref) {
    var _ref$appearance = _ref.appearance, propAppearance = _ref$appearance === void 0 ? "default" : _ref$appearance, _ref$autoFocus = _ref.autoFocus, autoFocus = _ref$autoFocus === void 0 ? false : _ref$autoFocus, _ref$isDisabled = _ref.isDisabled, propIsDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled, _ref$isLoading = _ref.isLoading, isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading, _ref$isSelected = _ref.isSelected, propIsSelected = _ref$isSelected === void 0 ? false : _ref$isSelected, _ref$isIconButton = _ref.isIconButton, isIconButton = _ref$isIconButton === void 0 ? false : _ref$isIconButton, _ref$isCircle = _ref.isCircle, isCircle = _ref$isCircle === void 0 ? false : _ref$isCircle, _ref$hasIconBefore = _ref.hasIconBefore, hasIconBefore = _ref$hasIconBefore === void 0 ? false : _ref$hasIconBefore, _ref$hasIconAfter = _ref.hasIconAfter, hasIconAfter = _ref$hasIconAfter === void 0 ? false : _ref$hasIconAfter, children = _ref.children, onClick = _ref.onClick, onMouseDownCapture = _ref.onMouseDownCapture, onMouseUpCapture = _ref.onMouseUpCapture, onKeyDownCapture = _ref.onKeyDownCapture, onKeyUpCapture = _ref.onKeyUpCapture, onTouchStartCapture = _ref.onTouchStartCapture, onTouchEndCapture = _ref.onTouchEndCapture, onPointerDownCapture = _ref.onPointerDownCapture, onPointerUpCapture = _ref.onPointerUpCapture, onClickCapture = _ref.onClickCapture, ref = _ref.ref, _ref$shouldFitContain = _ref.shouldFitContainer, shouldFitContainer = _ref$shouldFitContain === void 0 ? false : _ref$shouldFitContain, _ref$spacing = _ref.spacing, propSpacing = _ref$spacing === void 0 ? "default" : _ref$spacing, testId = _ref.testId, ariaLabel = _ref.ariaLabel, ariaLabelledBy = _ref.ariaLabelledBy;
    var localRef = (0, $dAx5m.useRef)(null);
    var splitButtonContext = (0, $44b86d3177478458$export$47e2c6fdb142d947)();
    // TODO: Use React 18's useId() hook when we update.
    // eslint-disable-next-line @repo/internal/react/disallow-unstable-values
    var loadingLabelId = (0, $h0JxK.uid)({
        ariaLabelledBy: ariaLabelledBy
    });
    var isSplitButton = Boolean(splitButtonContext);
    var isNavigationSplitButton = (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.isNavigationSplitButton) || false;
    var isDefaultAppearanceSplitButton = (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.appearance) === "default";
    var appearance = isDefaultAppearanceSplitButton && (0, $jAmv0.fg)("platform.design-system-team.component-visual-refresh_t8zbo") ? "subtle" : (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.appearance) || propAppearance;
    var spacing = (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.spacing) || propSpacing;
    var isDisabled = (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.isDisabled) || propIsDisabled;
    var isInteractive = !isDisabled && !isLoading;
    // Also treat loading buttons as disabled
    var isEffectivelyDisabled = isDisabled || isLoading;
    var isSelected = propIsSelected && !isDisabled;
    (0, $gMIYi.default)(localRef, autoFocus);
    return $149fd663360e3021$var$_objectSpread({
        ref: (0, $2Dg3J.default)([
            localRef,
            ref
        ]),
        xcss: [
            (0, $jAmv0.fg)("platform.design-system-team.button-tokenised-typography-styles") ? $149fd663360e3021$var$tokenizedButtonStyles : $149fd663360e3021$var$hardCodedButtonStyles,
            $149fd663360e3021$var$buttonStyles,
            appearance === "default" && ((0, $jAmv0.fg)("platform.design-system-team.component-visual-refresh_t8zbo") ? $149fd663360e3021$var$defaultRefreshedStyles : $149fd663360e3021$var$defaultStyles),
            appearance === "default" && isInteractive && ((0, $jAmv0.fg)("platform.design-system-team.component-visual-refresh_t8zbo") ? $149fd663360e3021$var$defaultInteractiveRefreshedStyles : $149fd663360e3021$var$defaultInteractiveStyles),
            appearance === "primary" && $149fd663360e3021$var$primaryStyles,
            appearance === "primary" && isInteractive && $149fd663360e3021$var$primaryInteractiveStyles,
            appearance === "warning" && $149fd663360e3021$var$warningStyles,
            appearance === "warning" && isInteractive && $149fd663360e3021$var$warningInteractiveStyles,
            appearance === "danger" && $149fd663360e3021$var$dangerStyles,
            appearance === "danger" && isInteractive && $149fd663360e3021$var$dangerInteractiveStyles,
            appearance === "discovery" && $149fd663360e3021$var$discoveryStyles,
            appearance === "discovery" && isInteractive && $149fd663360e3021$var$discoveryInteractiveStyles,
            appearance === "subtle" && ((0, $jAmv0.fg)("platform.design-system-team.component-visual-refresh_t8zbo") ? $149fd663360e3021$var$subtleRefreshedStyles : $149fd663360e3021$var$subtleStyles),
            appearance === "subtle" && isInteractive && ((0, $jAmv0.fg)("platform.design-system-team.component-visual-refresh_t8zbo") ? $149fd663360e3021$var$subtleInteractiveRefreshedStyles : $149fd663360e3021$var$subtleInteractiveStyles),
            appearance === "link" && $149fd663360e3021$var$linkStyles,
            appearance === "subtle-link" && $149fd663360e3021$var$subtleLinkStyles,
            !isSelected && (appearance === "link" || appearance === "subtle-link") ? $149fd663360e3021$var$linkDecorationStyles : $149fd663360e3021$var$linkDecorationUnsetStyles,
            isSelected && ((0, $jAmv0.fg)("platform.design-system-team.component-visual-refresh_t8zbo") ? $149fd663360e3021$var$selectedRefreshedStyles : $149fd663360e3021$var$selectedStyles),
            isSelected && isSplitButton && $149fd663360e3021$var$selectedInsideSplitButtonStyles,
            isSelected && isInteractive && $149fd663360e3021$var$selectedInteractiveStyles,
            // TODO: remove me once we kill color fallbacks
            isSelected && appearance === "danger" && $149fd663360e3021$var$selectedDangerStyles,
            // TODO: remove me once we kill color fallbacks
            isSelected && appearance === "warning" && $149fd663360e3021$var$selectedWarningStyles,
            // TODO: remove me once we kill color fallbacks
            isSelected && appearance === "discovery" && $149fd663360e3021$var$selectedDiscoveryStyles,
            isDisabled && $149fd663360e3021$var$disabledStyles,
            isCircle && !isSplitButton && $149fd663360e3021$var$circleStyles,
            spacing === "compact" && $149fd663360e3021$var$spacingCompactStyles,
            spacing === "compact" && ((0, $jAmv0.fg)("platform.design-system-team.button-tokenised-typography-styles") ? $149fd663360e3021$var$tokenizedSpacingCompactStyles : $149fd663360e3021$var$baseSpacingCompactStyles),
            spacing === "none" && $149fd663360e3021$var$spacingNoneStyles,
            spacing === "none" && (0, $jAmv0.fg)("platform.design-system-team.button-tokenised-typography-styles") && $149fd663360e3021$var$tokenizedSpacingNoneStyles,
            spacing !== "none" && hasIconBefore && $149fd663360e3021$var$buttonIconBeforeStyles,
            spacing !== "none" && hasIconAfter && $149fd663360e3021$var$buttonIconAfterStyles,
            isIconButton && $149fd663360e3021$var$iconButtonStyles,
            isIconButton && spacing === "compact" && $149fd663360e3021$var$iconButtonCompactStyles,
            shouldFitContainer && $149fd663360e3021$var$fullWidthStyles,
            isLoading && $149fd663360e3021$var$loadingStyles,
            isSplitButton && $149fd663360e3021$var$splitButtonStyles,
            isNavigationSplitButton && $149fd663360e3021$var$navigationSplitButtonStyles
        ],
        isDisabled: isEffectivelyDisabled,
        children: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $dAx5m.Fragment), null, children, isLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $e6d4cc5637a54680$export$2e2bcd8739ae039), {
            as: "span",
            xcss: $149fd663360e3021$var$loadingOverlayStyles
        }, (0, $eeec9d6e62c64a6a$export$2e2bcd8739ae039)({
            spacing: spacing,
            appearance: appearance,
            isDisabled: isDisabled,
            isSelected: isSelected,
            testId: testId
        })) : null, isLoading && (children && !ariaLabel && !ariaLabelledBy || ariaLabelledBy) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $ez4n6.default), {
            id: loadingLabelId
        }, (0, $9c0f404cb9dc279e$export$d4c5499dc806c969))),
        "aria-label": isLoading && ariaLabel && !ariaLabelledBy ? "".concat(ariaLabel, " ").concat((0, $9c0f404cb9dc279e$export$d4c5499dc806c969)) : ariaLabel,
        "aria-labelledby": isLoading && ariaLabelledBy ? "".concat(ariaLabelledBy, " ").concat(loadingLabelId) : ariaLabelledBy
    }, (0, $6584783d1dd73b46$export$2e2bcd8739ae039)(isEffectivelyDisabled, {
        onClick: onClick,
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onTouchStartCapture: onTouchStartCapture,
        onTouchEndCapture: onTouchEndCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onClickCapture: onClickCapture
    }));
};
var $149fd663360e3021$export$2e2bcd8739ae039 = $149fd663360e3021$var$useButtonBase;


/**
 * __Use default button base__
 *
 * A React hook that accepts a set of default Button props,
 * and processes them to return consistent base props for usage
 * across Button and LinkButton variants.
 *
 * @private
 */ var $bc8a8abf5a258443$var$useDefaultButton = function useDefaultButton(_ref) {
    var analyticsContext = _ref.analyticsContext, appearance = _ref.appearance, ariaLabel = _ref.ariaLabel, ariaLabelledBy = _ref.ariaLabelledBy, autoFocus = _ref.autoFocus, buttonType = _ref.buttonType, children = _ref.children, iconAfter = _ref.iconAfter, iconBefore = _ref.iconBefore, interactionName = _ref.interactionName, isDisabled = _ref.isDisabled, _ref$isLoading = _ref.isLoading, isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading, isSelected = _ref.isSelected, onClick = _ref.onClick, onClickCapture = _ref.onClickCapture, onKeyDownCapture = _ref.onKeyDownCapture, onKeyUpCapture = _ref.onKeyUpCapture, onMouseDownCapture = _ref.onMouseDownCapture, onMouseUpCapture = _ref.onMouseUpCapture, onPointerDownCapture = _ref.onPointerDownCapture, onPointerUpCapture = _ref.onPointerUpCapture, onTouchEndCapture = _ref.onTouchEndCapture, onTouchStartCapture = _ref.onTouchStartCapture, ref = _ref.ref, shouldFitContainer = _ref.shouldFitContainer, spacing = _ref.spacing, testId = _ref.testId, UNSAFE_iconAfter_size = _ref.UNSAFE_iconAfter_size, UNSAFE_iconBefore_size = _ref.UNSAFE_iconBefore_size;
    var baseProps = (0, $149fd663360e3021$export$2e2bcd8739ae039)({
        analyticsContext: analyticsContext,
        appearance: appearance,
        autoFocus: autoFocus,
        ariaLabel: ariaLabel,
        ariaLabelledBy: ariaLabelledBy,
        buttonType: buttonType,
        children: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $dAx5m.Fragment), null, iconBefore && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $0940865cc817fdc8$export$2e2bcd8739ae039), {
            type: "icon",
            position: "before",
            isLoading: isLoading
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $49c1d773bea318d1$export$2e2bcd8739ae039), {
            icon: iconBefore,
            size: UNSAFE_iconBefore_size
        })), children && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $0940865cc817fdc8$export$2e2bcd8739ae039), {
            isLoading: isLoading
        }, children), iconAfter && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $0940865cc817fdc8$export$2e2bcd8739ae039), {
            type: "icon",
            position: "after",
            isLoading: isLoading
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $49c1d773bea318d1$export$2e2bcd8739ae039), {
            icon: iconAfter,
            size: UNSAFE_iconAfter_size
        }))),
        interactionName: interactionName,
        isDisabled: isDisabled,
        isLoading: isLoading,
        isSelected: isSelected,
        onClick: onClick,
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onTouchStartCapture: onTouchStartCapture,
        onTouchEndCapture: onTouchEndCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onClickCapture: onClickCapture,
        ref: ref,
        shouldFitContainer: shouldFitContainer,
        spacing: spacing,
        testId: testId,
        hasIconBefore: Boolean(iconBefore),
        hasIconAfter: Boolean(iconAfter)
    });
    return baseProps;
};
var $bc8a8abf5a258443$export$2e2bcd8739ae039 = $bc8a8abf5a258443$var$useDefaultButton;


var $3b0bd407ca1a8a5f$var$_excluded = [
    "analyticsContext",
    "appearance",
    "aria-label",
    "aria-labelledby",
    "autoFocus",
    "children",
    "iconAfter",
    "iconBefore",
    "interactionName",
    "isDisabled",
    "isLoading",
    "isSelected",
    "onClick",
    "onClickCapture",
    "onKeyDownCapture",
    "onKeyUpCapture",
    "onMouseDownCapture",
    "onMouseUpCapture",
    "onPointerDownCapture",
    "onPointerUpCapture",
    "onTouchEndCapture",
    "onTouchStartCapture",
    "shouldFitContainer",
    "spacing",
    "testId",
    "type",
    "UNSAFE_iconAfter_size",
    "UNSAFE_iconBefore_size"
], $3b0bd407ca1a8a5f$var$_excluded2 = [
    "className",
    "css",
    "as",
    "style"
];
/**
 * __Button__
 *
 * A button triggers an event or action.
 *
 * - [Examples](https://atlassian.design/components/button/examples)
 * - [Code](https://atlassian.design/components/button/code)
 * - [Usage](https://atlassian.design/components/button/usage)
 */ var $3b0bd407ca1a8a5f$var$Button = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).forwardRef(function Button(_ref, ref) {
    var analyticsContext = _ref.analyticsContext, appearance = _ref.appearance, ariaLabel = _ref["aria-label"], ariaLabelledBy = _ref["aria-labelledby"], autoFocus = _ref.autoFocus, children = _ref.children, iconAfter = _ref.iconAfter, iconBefore = _ref.iconBefore, interactionName = _ref.interactionName, isDisabled = _ref.isDisabled, isLoading = _ref.isLoading, isSelected = _ref.isSelected, onClick = _ref.onClick, onClickCapture = _ref.onClickCapture, onKeyDownCapture = _ref.onKeyDownCapture, onKeyUpCapture = _ref.onKeyUpCapture, onMouseDownCapture = _ref.onMouseDownCapture, onMouseUpCapture = _ref.onMouseUpCapture, onPointerDownCapture = _ref.onPointerDownCapture, onPointerUpCapture = _ref.onPointerUpCapture, onTouchEndCapture = _ref.onTouchEndCapture, onTouchStartCapture = _ref.onTouchStartCapture, shouldFitContainer = _ref.shouldFitContainer, spacing = _ref.spacing, testId = _ref.testId, _ref$type = _ref.type, type = _ref$type === void 0 ? "button" : _ref$type, UNSAFE_iconAfter_size = _ref.UNSAFE_iconAfter_size, UNSAFE_iconBefore_size = _ref.UNSAFE_iconBefore_size, unsafeRest = (0, (/*@__PURE__*/$parcel$interopDefault($74ed1cba0d5551e3$exports)))(_ref, $3b0bd407ca1a8a5f$var$_excluded);
    // @ts-expect-error
    var _className = unsafeRest.className, _css = unsafeRest.css, _as = unsafeRest.as, _style = unsafeRest.style, saferRest = (0, (/*@__PURE__*/$parcel$interopDefault($74ed1cba0d5551e3$exports)))(unsafeRest, $3b0bd407ca1a8a5f$var$_excluded2);
    var rest = (0, $jAmv0.getBooleanFF)("platform.design-system-team.remove-unsafe-spread-from-new-button_a2xhw") ? saferRest : unsafeRest;
    var baseProps = (0, $bc8a8abf5a258443$export$2e2bcd8739ae039)({
        ariaLabel: ariaLabel,
        ariaLabelledBy: ariaLabelledBy,
        analyticsContext: analyticsContext,
        appearance: appearance,
        autoFocus: autoFocus,
        buttonType: "button",
        children: children,
        iconAfter: iconAfter,
        iconBefore: iconBefore,
        interactionName: interactionName,
        isDisabled: isDisabled,
        isLoading: isLoading,
        isSelected: isSelected,
        onClick: onClick,
        onClickCapture: onClickCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onTouchEndCapture: onTouchEndCapture,
        onTouchStartCapture: onTouchStartCapture,
        ref: ref,
        shouldFitContainer: shouldFitContainer,
        spacing: spacing,
        testId: testId,
        UNSAFE_iconAfter_size: UNSAFE_iconAfter_size,
        UNSAFE_iconBefore_size: UNSAFE_iconBefore_size
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $1e6e60f1fe27cc1f$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($5fb336a98f9116b4$exports)))({}, rest, {
        "aria-label": baseProps["aria-label"],
        "aria-labelledby": baseProps["aria-labelledby"],
        ref: baseProps.ref,
        xcss: baseProps.xcss,
        isDisabled: baseProps.isDisabled,
        onClick: baseProps.onClick,
        onMouseDownCapture: baseProps.onMouseDownCapture,
        onMouseUpCapture: baseProps.onMouseUpCapture,
        onKeyDownCapture: baseProps.onKeyDownCapture,
        onKeyUpCapture: baseProps.onKeyUpCapture,
        onTouchStartCapture: baseProps.onTouchStartCapture,
        onTouchEndCapture: baseProps.onTouchEndCapture,
        onPointerDownCapture: baseProps.onPointerDownCapture,
        onPointerUpCapture: baseProps.onPointerUpCapture,
        onClickCapture: baseProps.onClickCapture,
        type: type,
        testId: testId,
        analyticsContext: analyticsContext,
        interactionName: interactionName,
        componentName: "Button"
    }), baseProps.children);
}));
$3b0bd407ca1a8a5f$var$Button.displayName = "Button";
var $3b0bd407ca1a8a5f$export$2e2bcd8739ae039 = $3b0bd407ca1a8a5f$var$Button;



var $76DDk = parcelRequire("76DDk");

var $2Dg3J = parcelRequire("2Dg3J");

var $Bb0he = parcelRequire("Bb0he");

var $4Xq7n = parcelRequire("4Xq7n");

var $kzmLI = parcelRequire("kzmLI");
var $21dd8ee589964939$exports = {};
"use strict";
Object.defineProperty($21dd8ee589964939$exports, "__esModule", {
    value: true
});
$21dd8ee589964939$exports.default = void 0;

var $21dd8ee589964939$var$_react = $21dd8ee589964939$var$_interopRequireDefault((parcelRequire("dAx5m")));



var $dAx5m = parcelRequire("dAx5m");

var $jAmv0 = parcelRequire("jAmv0");



var $dAx5m = parcelRequire("dAx5m");

var $jVTBW = parcelRequire("jVTBW");
var $7436aae62e51253d$export$c647cb0ee6e282fe = {
    small: "16px",
    medium: "24px",
    large: "32px",
    xlarge: "48px"
};
var $7436aae62e51253d$export$7bd66fc94c81bf84 = {
    small: "small",
    medium: "medium",
    large: "large",
    xlarge: "xlarge"
};
var $7436aae62e51253d$export$62ad7b0c781000e9 = {
    small: {
        width: $7436aae62e51253d$export$c647cb0ee6e282fe.small,
        height: $7436aae62e51253d$export$c647cb0ee6e282fe.small
    },
    medium: {
        width: $7436aae62e51253d$export$c647cb0ee6e282fe.medium,
        height: $7436aae62e51253d$export$c647cb0ee6e282fe.medium
    },
    large: {
        width: $7436aae62e51253d$export$c647cb0ee6e282fe.large,
        height: $7436aae62e51253d$export$c647cb0ee6e282fe.large
    },
    xlarge: {
        width: $7436aae62e51253d$export$c647cb0ee6e282fe.xlarge,
        height: $7436aae62e51253d$export$c647cb0ee6e282fe.xlarge
    }
};



var $jVTBW = parcelRequire("jVTBW");
var $802a437dfc8c049f$export$16374db1c3e6dfba = {
    overflow: "hidden",
    pointerEvents: "none",
    /**
   * Stop-color doesn't properly apply in chrome when the inherited/current color changes.
   * We have to initially set stop-color to inherit (either via DOM attribute or an initial CSS
   * rule) and then override it with currentColor for the color changes to be picked up.
   */ stop: {
        stopColor: "currentColor"
    }
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
var $802a437dfc8c049f$var$smallStyles = (0, $jVTBW.css)((0, $7436aae62e51253d$export$62ad7b0c781000e9).small);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
var $802a437dfc8c049f$var$mediumStyles = (0, $jVTBW.css)((0, $7436aae62e51253d$export$62ad7b0c781000e9).medium);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
var $802a437dfc8c049f$var$largeStyles = (0, $jVTBW.css)((0, $7436aae62e51253d$export$62ad7b0c781000e9).large);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
var $802a437dfc8c049f$var$xlargeStyles = (0, $jVTBW.css)((0, $7436aae62e51253d$export$62ad7b0c781000e9).xlarge);
var $802a437dfc8c049f$export$ef0ad74202575b64 = {
    small: $802a437dfc8c049f$var$smallStyles,
    medium: $802a437dfc8c049f$var$mediumStyles,
    large: $802a437dfc8c049f$var$largeStyles,
    xlarge: $802a437dfc8c049f$var$xlargeStyles
};
var $802a437dfc8c049f$export$3eb7d6130acfda37 = function getIconSize(_ref) {
    var width = _ref.width, height = _ref.height, size = _ref.size;
    if (width && height) return {
        width: width,
        height: height
    };
    if (size) return (0, $7436aae62e51253d$export$62ad7b0c781000e9)[size];
    return undefined;
};


var $5cea5f38e7297dcb$export$18cb9425622d4e06 = function getBackground() {
    return "var(--ds-surface, #FFFFFF)";
};


function $48c1ae2c413c96f2$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $48c1ae2c413c96f2$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $48c1ae2c413c96f2$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($c3ec97511ae1ed64$exports)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $48c1ae2c413c96f2$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
/**
 * We are hiding these props from consumers as they're used to
 * hack around icon sizing specifically for icon-file-type.
 */ var $48c1ae2c413c96f2$var$iconStyles = (0, $jVTBW.css)({
    display: "inline-block",
    flexShrink: 0,
    lineHeight: 1,
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    "> svg": $48c1ae2c413c96f2$var$_objectSpread($48c1ae2c413c96f2$var$_objectSpread({}, (0, $802a437dfc8c049f$export$16374db1c3e6dfba)), {}, {
        maxWidth: "100%",
        maxHeight: "100%",
        color: "var(--icon-primary-color)",
        fill: "var(--icon-secondary-color)",
        verticalAlign: "bottom"
    })
});
/**
 * For windows high contrast mode
 */ var $48c1ae2c413c96f2$var$baseHcmStyles = (0, $jVTBW.css)({
    "@media screen and (forced-colors: active)": {
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        "> svg": {
            filter: "grayscale(1)",
            "--icon-primary-color": "CanvasText",
            // foreground
            "--icon-secondary-color": "Canvas" // background
        }
    }
});
var $48c1ae2c413c96f2$var$primaryEqualsSecondaryHcmStyles = (0, $jVTBW.css)({
    "@media screen and (forced-colors: active)": {
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        "> svg": {
            // if the primaryColor is the same as the secondaryColor we
            // set the --icon-primary-color to Canvas
            // this is usually to convey state i.e. Checkbox checked -> not checked
            "--icon-primary-color": "Canvas" // foreground
        }
    }
});
var $48c1ae2c413c96f2$var$secondaryTransparentHcmStyles = (0, $jVTBW.css)({
    "@media screen and (forced-colors: active)": {
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        "> svg": {
            "--icon-secondary-color": "transparent" // background
        }
    }
});
var $48c1ae2c413c96f2$export$f04a61298a47a40f = /*#__PURE__*/ (0, $dAx5m.memo)(function Icon(props) {
    var _ref = props, Glyph = _ref.glyph, dangerouslySetGlyph = _ref.dangerouslySetGlyph, _ref$primaryColor = _ref.primaryColor, primaryColor = _ref$primaryColor === void 0 ? "currentColor" : _ref$primaryColor, secondaryColor = _ref.secondaryColor, size = _ref.size, testId = _ref.testId, label = _ref.label, width = _ref.width, height = _ref.height, UNSAFE_margin = _ref.UNSAFE_margin;
    var glyphProps = dangerouslySetGlyph ? {
        dangerouslySetInnerHTML: {
            __html: dangerouslySetGlyph
        }
    } : {
        children: Glyph ? (0, $jVTBW.jsx)(Glyph, {
            role: "presentation"
        }) : null
    };
    var dimensions = (0, $802a437dfc8c049f$export$3eb7d6130acfda37)({
        width: width,
        height: height,
        size: size
    });
    return (0, $jVTBW.jsx)("span", (0, (/*@__PURE__*/$parcel$interopDefault($5fb336a98f9116b4$exports)))({
        "data-testid": testId,
        "data-vc": "icon-".concat(testId),
        role: label ? "img" : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: $48c1ae2c413c96f2$var$_objectSpread({
            "--icon-primary-color": primaryColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            "--icon-secondary-color": secondaryColor || (0, $5cea5f38e7297dcb$export$18cb9425622d4e06)()
        }, UNSAFE_margin ? {
            margin: UNSAFE_margin
        } : {})
    }, glyphProps, {
        css: [
            $48c1ae2c413c96f2$var$iconStyles,
            $48c1ae2c413c96f2$var$baseHcmStyles,
            primaryColor === secondaryColor && $48c1ae2c413c96f2$var$primaryEqualsSecondaryHcmStyles,
            secondaryColor === "transparent" && $48c1ae2c413c96f2$var$secondaryTransparentHcmStyles,
            // NB: This can be resolved if this component, composes base SVG / and/or skeleton
            // We could then simplify how common styles are dealt with simply by encapsulating them
            // at their appropriate level and/or having a singular approach to css variables in the package
            dimensions && // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $jVTBW.css)({
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                width: dimensions.width,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                height: dimensions.height,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                "> svg": dimensions
            })
        ]
    }));
});
var $48c1ae2c413c96f2$export$2e2bcd8739ae039 = $48c1ae2c413c96f2$export$f04a61298a47a40f;


var $e5e2b2ab42e17567$var$_excluded = [
    "dangerouslySetGlyph"
];
var $e5e2b2ab42e17567$var$sizesEligibleForNewIcons = [
    "small",
    "medium"
];
var $e5e2b2ab42e17567$export$3cfb73f70dfca966 = /*#__PURE__*/ (0, $dAx5m.memo)(function IconFacade(_ref) {
    var _props$size;
    var dangerouslySetGlyph = _ref.dangerouslySetGlyph, props = (0, (/*@__PURE__*/$parcel$interopDefault($74ed1cba0d5551e3$exports)))(_ref, $e5e2b2ab42e17567$var$_excluded);
    var NewIcon = props.newIcon;
    // By default, the icon size will be medium and spacing will be none for small icons
    var size = (_props$size = props.size) !== null && _props$size !== void 0 ? _props$size : "medium";
    var spacing = size === "small" ? "none" : "spacious";
    var useNewIcon = !props.isFacadeDisabled && // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
    (0, $jAmv0.fg)("platform-visual-refresh-icons-legacy-facade") && $e5e2b2ab42e17567$var$sizesEligibleForNewIcons.includes(size);
    if (useNewIcon && NewIcon) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement(NewIcon, (0, (/*@__PURE__*/$parcel$interopDefault($5fb336a98f9116b4$exports)))({}, props, {
        spacing: spacing,
        color: props.primaryColor || "currentColor",
        type: props.iconType
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $48c1ae2c413c96f2$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($5fb336a98f9116b4$exports)))({
        dangerouslySetGlyph: dangerouslySetGlyph
    }, props));
});
var $e5e2b2ab42e17567$export$2e2bcd8739ae039 = $e5e2b2ab42e17567$export$3cfb73f70dfca966;



var $21dd8ee589964939$var$_chevronDown = $21dd8ee589964939$var$_interopRequireDefault((parcelRequire("1kknn")));
function $21dd8ee589964939$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $21dd8ee589964939$var$ChevronDownIcon = (props)=>/*#__PURE__*/ $21dd8ee589964939$var$_react.default.createElement($e5e2b2ab42e17567$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M8.292 10.293a1.01 1.01 0 0 0 0 1.419l2.939 2.965c.218.215.5.322.779.322s.556-.107.769-.322l2.93-2.955a1.01 1.01 0 0 0 0-1.419.987.987 0 0 0-1.406 0l-2.298 2.317-2.307-2.327a.99.99 0 0 0-1.406 0"/></svg>`
    }, props, {
        newIcon: $21dd8ee589964939$var$_chevronDown.default,
        iconType: "utility"
    }));
$21dd8ee589964939$var$ChevronDownIcon.displayName = "ChevronDownIcon";
var $21dd8ee589964939$var$_default = $21dd8ee589964939$exports.default = $21dd8ee589964939$var$ChevronDownIcon;




var $dAx5m = parcelRequire("dAx5m");

var $jVTBW = parcelRequire("jVTBW");

var $D9YLo = parcelRequire("D9YLo");

var $dAx5m = parcelRequire("dAx5m");

var $Bb0he = parcelRequire("Bb0he");
var $2df0da70aab367c6$export$650d12d3c2ddb8fc = /*#__PURE__*/ (0, $dAx5m.createContext)(0);
var $2df0da70aab367c6$export$48b383b280e20440 = /*#__PURE__*/ (0, $dAx5m.createContext)({
    topLevelRef: {
        current: null
    },
    setTopLevel: (0, $Bb0he.default)
});
/**
 *
 *  @internal
 * Context Provider Component which provider the current level of nested layers
 * It handles level management when it mounts and unmounts
 *
 */ var $2df0da70aab367c6$var$LevelProvider = function LevelProvider(_ref) {
    var children = _ref.children, currentLevel = _ref.currentLevel;
    var _useContext = (0, $dAx5m.useContext)($2df0da70aab367c6$export$48b383b280e20440), setTopLevel = _useContext.setTopLevel;
    setTopLevel(currentLevel);
    (0, $dAx5m.useEffect)(function() {
        // avoid immediate cleanup using setTimeout when component unmount
        // this will make sure non-top layer components can get the correct top level value
        // when multiple layers trigger onClose in sequence.
        // From React 17, the useEffect cleanup functions are delayed till the commit phase is completed. In other words, the useEffect cleanup functions run asynchronously - for example, if the component is unmounting, the cleanup runs after the screen has been updated.
        // TODO revisit after we migrate to react 18. https://product-fabric.atlassian.net/browse/DSP-13139
        return function() {
            setTimeout(function() {
                setTopLevel(currentLevel - 1);
            }, 0);
        };
    }, [
        setTopLevel,
        currentLevel
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement($2df0da70aab367c6$export$650d12d3c2ddb8fc.Provider, {
        value: currentLevel
    }, children);
};
/**
 *
 *  @internal
 * Context Provider Component which provides the top level of all nested layers
 * It provides initial top level ref value as 0 and set top level method
 *
 */ var $2df0da70aab367c6$var$LayeringProvider = function LayeringProvider(_ref2) {
    var children = _ref2.children;
    var topLevelRef = (0, $dAx5m.useRef)(0);
    var value = (0, $dAx5m.useMemo)(function() {
        return {
            topLevelRef: topLevelRef,
            setTopLevel: function setTopLevel(level) {
                topLevelRef.current = level;
            }
        };
    }, [
        topLevelRef
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement($2df0da70aab367c6$export$48b383b280e20440.Provider, {
        value: value
    }, children);
};
var $2df0da70aab367c6$export$a183686c3f6f4ea8 = function UNSAFE_LAYERING(_ref3) {
    var children = _ref3.children, _ref3$isDisabled = _ref3.isDisabled, isDisabled = _ref3$isDisabled === void 0 ? true : _ref3$isDisabled;
    var currentLevel = (0, $dAx5m.useContext)($2df0da70aab367c6$export$650d12d3c2ddb8fc);
    if (isDisabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).Fragment, null, children);
    var isNested = currentLevel > 0;
    var content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement($2df0da70aab367c6$var$LevelProvider, {
        currentLevel: currentLevel + 1
    }, children);
    return isNested ? content : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement($2df0da70aab367c6$var$LayeringProvider, null, content);
};



var $expeE = parcelRequire("expeE");
var $4Yjoy = parcelRequire("4Yjoy");

var $dAx5m = parcelRequire("dAx5m");

var $dAx5m = parcelRequire("dAx5m");

var $1MpXQ = parcelRequire("1MpXQ");
var $df88a53a5f215c68$export$e4c79eb95c23a0da = "atlaskit-portal-container";
var $df88a53a5f215c68$export$72f415121273627e = "body > .atlaskit-portal-container";
var $df88a53a5f215c68$export$13f57c02915787b3 = "atlaskit-portal";


var $02e4c41e40de6c2d$export$26ae5ca175b4ec5a = function createContainer(zIndex) {
    var container = document.createElement("div");
    container.className = (0, $df88a53a5f215c68$export$13f57c02915787b3);
    container.style.zIndex = "".concat(zIndex);
    return container;
};
/**
 * Returns document body element
 * @return {number} - The document body element
 */ var $02e4c41e40de6c2d$var$getBody = function getBody() {
    return document.body;
};
/**
 * Returns portal parent container. If no container exists already then it creates a new container with class name 'atlaskit-portal-container'
 * @return {Element} - The portal parent container div element
 */ var $02e4c41e40de6c2d$var$getPortalParent = function getPortalParent() {
    var parentElement = document.querySelector((0, $df88a53a5f215c68$export$72f415121273627e));
    if (!parentElement) {
        var _getBody;
        var parent = document.createElement("div");
        parent.className = (0, $df88a53a5f215c68$export$e4c79eb95c23a0da);
        // we are setting display to flex because we want each portal to create a new stacking context
        // See https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Positioning/Understanding_z_index/The_stacking_context
        parent.style.display = "flex";
        (_getBody = $02e4c41e40de6c2d$var$getBody()) === null || _getBody === void 0 || _getBody.appendChild(parent);
        return parent;
    }
    return parentElement;
};
var $02e4c41e40de6c2d$export$da99f98bf3fe55b3 = function removePortalContainer(container) {
    $02e4c41e40de6c2d$var$getPortalParent().removeChild(container);
};
var $02e4c41e40de6c2d$export$c582005add11e141 = function appendPortalContainerIfNotAppended(container) {
    if (!container.parentElement) $02e4c41e40de6c2d$var$getPortalParent().appendChild(container);
};


function $83bdb687909ecd36$export$2e2bcd8739ae039(props) {
    var zIndex = props.zIndex, children = props.children;
    var container = (0, $dAx5m.useMemo)(function() {
        return (0, $02e4c41e40de6c2d$export$26ae5ca175b4ec5a)(zIndex);
    }, [
        zIndex
    ]);
    // This is in the render method instead of useEffect so that
    // the portal will be added to the DOM before the children render.
    // For any further changes, ensure that the container does not have a
    // parent besides the portal parent.
    (0, $02e4c41e40de6c2d$export$c582005add11e141)(container);
    (0, $dAx5m.useEffect)(function() {
        return function() {
            (0, $02e4c41e40de6c2d$export$da99f98bf3fe55b3)(container);
        };
    }, [
        container
    ]);
    return /*#__PURE__*/ (0, $1MpXQ.createPortal)(children, container);
}




var $dAx5m = parcelRequire("dAx5m");

var $dAx5m = parcelRequire("dAx5m");
var $84c535788e5b634b$export$700979bc83e7db82 = typeof window !== "undefined" ? (0, $dAx5m.useLayoutEffect) : (0, $dAx5m.useEffect);


var $1a79c387610545fc$var$useIsSubsequentRender = function useIsSubsequentRender(mountStrategy) {
    var _useState = (0, $dAx5m.useState)(false), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($6f4c9344050d46f7$exports)))(_useState, 2), isSubsequentRender = _useState2[0], setIsSubsequentRender = _useState2[1];
    var _useState3 = (0, $dAx5m.useState)(function() {
        return mountStrategy === "layoutEffect" ? (0, $84c535788e5b634b$export$700979bc83e7db82) : (0, $dAx5m.useEffect);
    }), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($6f4c9344050d46f7$exports)))(_useState3, 1), useMountEffect = _useState4[0];
    useMountEffect(function() {
        setIsSubsequentRender(true);
    }, []);
    return isSubsequentRender;
};
var $1a79c387610545fc$export$2e2bcd8739ae039 = $1a79c387610545fc$var$useIsSubsequentRender;



var $dAx5m = parcelRequire("dAx5m");
var $f1b74cbc5c3eff98$export$ed5835cc67e87f72 = "akPortalMount";
var $f1b74cbc5c3eff98$export$80816bd900e5bd00 = "akPortalUnmount";


var $5fc943dd312c250f$var$zIndexToName = {
    100: "card",
    200: "navigation",
    300: "dialog",
    400: "layer",
    500: "blanket",
    510: "modal",
    600: "flag",
    700: "spotlight",
    9999: "tooltip"
};
/**
 * return layer name in Atlassian design system corresponding to given z-index
 * @param {number} zIndex - z-index value for which layer name is needed
 * @returns {LayerName | null} - The layer name for given z-index. If layer name is not found then null is returned
 */ var $5fc943dd312c250f$var$getLayerName = function getLayerName(zIndex) {
    return $5fc943dd312c250f$var$zIndexToName.hasOwnProperty(zIndex) ? $5fc943dd312c250f$var$zIndexToName[zIndex] : null;
};
/**
 * Creates a PortalEvent object with given eventName, given zIndex and corresponding layer
 * @param {string} eventName - either of Mount or Unmount event name
 * @param {number} zIndex - z-index value which will be included in the event to be dispatched
 * @returns {PortalEvent} - The newly created PortalEvent object
 */ var $5fc943dd312c250f$var$getEvent = function getEvent(eventName, zIndex) {
    var detail = {
        layer: $5fc943dd312c250f$var$getLayerName(Number(zIndex)),
        zIndex: zIndex
    };
    return new CustomEvent(eventName, {
        detail: detail
    });
};
function $5fc943dd312c250f$export$2e2bcd8739ae039(eventName, zIndex) {
    var event = $5fc943dd312c250f$var$getEvent(eventName, zIndex);
    window.dispatchEvent(event);
}


var $78c564253caadf98$var$useFirePortalEvent = function useFirePortalEvent(zIndex) {
    var zIndexNumber = Number(zIndex);
    (0, $dAx5m.useEffect)(function() {
        (0, $5fc943dd312c250f$export$2e2bcd8739ae039)((0, $f1b74cbc5c3eff98$export$ed5835cc67e87f72), zIndexNumber);
        return function() {
            (0, $5fc943dd312c250f$export$2e2bcd8739ae039)((0, $f1b74cbc5c3eff98$export$80816bd900e5bd00), zIndexNumber);
        };
    }, [
        zIndexNumber
    ]);
};
var $78c564253caadf98$export$2e2bcd8739ae039 = $78c564253caadf98$var$useFirePortalEvent;


function $070832f661dcad53$export$2e2bcd8739ae039(_ref) {
    var _ref$zIndex = _ref.zIndex, zIndex = _ref$zIndex === void 0 ? 0 : _ref$zIndex, children = _ref.children, _ref$mountStrategy = _ref.mountStrategy, mountStrategy = _ref$mountStrategy === void 0 ? "effect" : _ref$mountStrategy;
    var isSubsequentRender = (0, $1a79c387610545fc$export$2e2bcd8739ae039)(mountStrategy);
    (0, $78c564253caadf98$export$2e2bcd8739ae039)(zIndex);
    return isSubsequentRender ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $83bdb687909ecd36$export$2e2bcd8739ae039), {
        zIndex: zIndex
    }, children) : null;
}









var $dAx5m = parcelRequire("dAx5m");

var $jVTBW = parcelRequire("jVTBW");

var $dAx5m = parcelRequire("dAx5m");

var $dd4sf = parcelRequire("dd4sf");

var $9e91143110e393a2$var$ESCAPE = "Escape";
function $9e91143110e393a2$export$4a4bf067ea9e7886(_ref) {
    var onClose = _ref.onClose, isDisabled = _ref.isDisabled;
    var escapePressed = (0, $dAx5m.useRef)(false);
    var _UNSAFE_useLayering = $9e91143110e393a2$export$cec37b93989366d4(), isLayerDisabled = _UNSAFE_useLayering.isLayerDisabled;
    var onKeyDown = (0, $dAx5m.useCallback)(function(e) {
        var isDisabledLayer = isLayerDisabled();
        if (isDisabled || escapePressed.current || e.key !== $9e91143110e393a2$var$ESCAPE || isDisabledLayer) // We're either already handling the key down event or it's not escape or disabled.
        // Bail early!
        return;
        escapePressed.current = true;
        onClose(e);
    }, [
        onClose,
        isDisabled,
        isLayerDisabled
    ]);
    var onKeyUp = (0, $dAx5m.useCallback)(function() {
        escapePressed.current = false;
    }, []);
    (0, $dAx5m.useEffect)(function() {
        return (0, $dd4sf.bindAll)(document, [
            {
                type: "keydown",
                listener: onKeyDown
            },
            {
                type: "keyup",
                listener: onKeyUp
            }
        ], {
            capture: false
        });
    }, [
        onKeyDown,
        onKeyUp
    ]);
}
function $9e91143110e393a2$export$cec37b93989366d4() {
    var currentLevel = (0, $dAx5m.useContext)((0, $2df0da70aab367c6$export$650d12d3c2ddb8fc));
    var _useContext = (0, $dAx5m.useContext)((0, $2df0da70aab367c6$export$48b383b280e20440)), topLevelRef = _useContext.topLevelRef;
    var isLayerDisabled = (0, $dAx5m.useCallback)(function() {
        return !!topLevelRef.current && currentLevel !== topLevelRef.current;
    }, [
        currentLevel,
        topLevelRef
    ]);
    return {
        currentLevel: currentLevel,
        topLevelRef: topLevelRef,
        isLayerDisabled: isLayerDisabled
    };
}



var $jAmv0 = parcelRequire("jAmv0");



var $dAx5m = parcelRequire("dAx5m");

var $2BQLr = parcelRequire("2BQLr");

// Export types from PopperJS / React Popper
var $8a3e0847275e802a$var$constantModifiers = [
    {
        name: "flip",
        options: {
            flipVariations: false,
            padding: 5,
            boundary: "clippingParents",
            rootBoundary: "viewport"
        }
    },
    {
        name: "preventOverflow",
        options: {
            padding: 5,
            rootBoundary: "document"
        }
    }
];
function $8a3e0847275e802a$var$defaultChildrenFn() {
    return null;
}
var $8a3e0847275e802a$var$defaultOffset = [
    0,
    8
];
function $8a3e0847275e802a$export$badac9ada3a0bdf9(_ref) {
    var _ref$children = _ref.children, children = _ref$children === void 0 ? $8a3e0847275e802a$var$defaultChildrenFn : _ref$children, _ref$offset = _ref.offset, offset = _ref$offset === void 0 ? $8a3e0847275e802a$var$defaultOffset : _ref$offset, _ref$placement = _ref.placement, placement = _ref$placement === void 0 ? "bottom-start" : _ref$placement, _ref$referenceElement = _ref.referenceElement, referenceElement = _ref$referenceElement === void 0 ? undefined : _ref$referenceElement, modifiers = _ref.modifiers, _ref$strategy = _ref.strategy, strategy = _ref$strategy === void 0 ? "fixed" : _ref$strategy;
    var _offset = (0, (/*@__PURE__*/$parcel$interopDefault($6f4c9344050d46f7$exports)))(offset, 2), offsetX = _offset[0], offsetY = _offset[1];
    // Merge a new offset modifier only if new offset values passed in
    var internalModifiers = (0, $dAx5m.useMemo)(function() {
        var offsetModifier = {
            name: "offset",
            options: {
                offset: [
                    offsetX,
                    offsetY
                ]
            }
        };
        return [].concat($8a3e0847275e802a$var$constantModifiers, [
            offsetModifier
        ]);
    }, [
        offsetX,
        offsetY
    ]);
    // Merge custom props and memoize
    var mergedModifiers = (0, $dAx5m.useMemo)(function() {
        if (modifiers == null) return internalModifiers;
        return [].concat((0, (/*@__PURE__*/$parcel$interopDefault($d5f3651f1c5ee1c2$exports)))(internalModifiers), (0, (/*@__PURE__*/$parcel$interopDefault($d5f3651f1c5ee1c2$exports)))(modifiers));
    }, [
        internalModifiers,
        modifiers
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $2BQLr.Popper), {
        modifiers: mergedModifiers,
        placement: placement,
        strategy: strategy,
        referenceElement: referenceElement
    }, children);
}




var $d609a65dfd65a550$export$4ef52930e33717cd = "data-theme";
var $d609a65dfd65a550$export$a00eac3f8684bcd0 = "data-color-mode";
var $d609a65dfd65a550$export$2112803007239c61 = "data-contrast-mode";
var $d609a65dfd65a550$export$352e418ed5b6193a = "data-custom-theme";
var $d609a65dfd65a550$export$2faeed762aac6741 = "light";
var $d609a65dfd65a550$export$6f0c6fb8c80fcc92 = "ds";
var $d609a65dfd65a550$export$4d0c7bbf80185957 = [
    "opacity",
    "font",
    "space",
    "border"
];
var $d609a65dfd65a550$export$dddac1532e822863 = "--".concat($d609a65dfd65a550$export$6f0c6fb8c80fcc92, "-token-not-found");
var $d609a65dfd65a550$export$9d7b58831ae93caa = "--".concat($d609a65dfd65a550$export$6f0c6fb8c80fcc92, "-elevation-surface-current");



var $dAx5m = parcelRequire("dAx5m");
var $4267a7ca55e70b27$export$51eddd7655ca235a = function RepositionOnUpdate(_ref) {
    var children = _ref.children, update = _ref.update;
    // Ref used here to skip update on first render (when refs haven't been set)
    var isFirstRenderRef = (0, $dAx5m.useRef)(true);
    (0, $dAx5m.useLayoutEffect)(function() {
        if (isFirstRenderRef.current) {
            isFirstRenderRef.current = false;
            return;
        }
        // callback function from popper that repositions pop-up on content Update
        update();
    }, [
        update
    ]);
    // wrapping in fragment to make TS happy (known issue with FC returning children)
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $dAx5m.Fragment), null, children);
};


// eslint-disable-next-line @typescript-eslint/consistent-type-imports

var $dAx5m = parcelRequire("dAx5m");

var $dd4sf = parcelRequire("dd4sf");

var $Bb0he = parcelRequire("Bb0he");


var $jAmv0 = parcelRequire("jAmv0");
var $38ed07431b49bd94$export$92dae2778ae88f9d = function useCloseManager(_ref) {
    var isOpen = _ref.isOpen, onClose = _ref.onClose, popupRef = _ref.popupRef, triggerRef = _ref.triggerRef, capture = _ref.shouldUseCaptureOnOutsideClick, shouldCloseOnTab = _ref.shouldCloseOnTab;
    var _UNSAFE_useLayering = (0, $9e91143110e393a2$export$cec37b93989366d4)(), isLayerDisabled = _UNSAFE_useLayering.isLayerDisabled, currentLevel = _UNSAFE_useLayering.currentLevel;
    (0, $dAx5m.useEffect)(function() {
        if (!isOpen || !popupRef) return 0, $Bb0he.default;
        var closePopup = function closePopup(event) {
            if (onClose) onClose(event);
        };
        // This check is required for cases where components like
        // Select or DDM are placed inside a Popup. A click
        // on a MenuItem or Option would close the Popup, without registering
        // a click on DDM/Select.
        // Users would have to call `onClose` manually to close the Popup in these cases.
        // You can see the bug in action here:
        // https://codesandbox.io/s/atlaskitpopup-default-forked-2eb87?file=/example.tsx:0-1788
        var onClick = function onClick(event) {
            var target = event.target;
            var doesDomNodeExist = document.body.contains(target);
            if (!doesDomNodeExist) return;
            if (isLayerDisabled() && (0, $jAmv0.getBooleanFF)("platform.design-system-team.iframe-layering_p3eb8")) //if it is a disabled layer, we need to disable its click listener.
            return;
            var isClickOnPopup = popupRef && popupRef.contains(target);
            var isClickOnTrigger = triggerRef && triggerRef.contains(target);
            if (!isClickOnPopup && !isClickOnTrigger) closePopup(event);
        };
        var onKeyDown = function onKeyDown(event) {
            if (isLayerDisabled()) return;
            var key = event.key;
            if (key === "Escape" || key === "Esc" || shouldCloseOnTab && key === "Tab") closePopup(event);
        };
        var unbind = (0, $dd4sf.bindAll)(window, [
            {
                type: "click",
                listener: onClick,
                options: {
                    capture: capture
                }
            },
            {
                type: "keydown",
                listener: onKeyDown
            }
        ]);
        // bind onBlur event listener to fix popup not close when clicking on iframe outside
        var unbindBlur = (0, $Bb0he.default);
        if ((0, $jAmv0.getBooleanFF)("platform.design-system-team.iframe-layering_p3eb8")) unbindBlur = (0, $dd4sf.bind)(window, {
            type: "blur",
            listener: function onBlur(e) {
                if (isLayerDisabled() || !(document.activeElement instanceof HTMLIFrameElement)) return;
                var wrapper = document.activeElement.closest("[data-ds--level]");
                if (!wrapper || currentLevel > Number(wrapper.getAttribute("data-ds--level"))) closePopup(e);
            }
        });
        return function() {
            unbind();
            unbindBlur();
        };
    }, [
        isOpen,
        onClose,
        popupRef,
        triggerRef,
        capture,
        isLayerDisabled,
        shouldCloseOnTab,
        currentLevel
    ]);
};



var $dAx5m = parcelRequire("dAx5m");

var $3bwCn = parcelRequire("3bwCn");

var $Bb0he = parcelRequire("Bb0he");
var $f646628571e77e3b$export$10c5169755ce7bd7 = function useFocusManager(_ref) {
    var initialFocusRef = _ref.initialFocusRef, popupRef = _ref.popupRef, shouldCloseOnTab = _ref.shouldCloseOnTab;
    (0, $dAx5m.useEffect)(function() {
        if (!popupRef || shouldCloseOnTab) return 0, $Bb0he.default;
        var trapConfig = {
            clickOutsideDeactivates: true,
            escapeDeactivates: true,
            initialFocus: initialFocusRef || popupRef,
            fallbackFocus: popupRef,
            returnFocusOnDeactivate: true
        };
        var focusTrap = (0, (/*@__PURE__*/$parcel$interopDefault($3bwCn)))(popupRef, trapConfig);
        var frameId = null;
        // wait for the popup to reposition itself before we focus
        frameId = requestAnimationFrame(function() {
            frameId = null;
            focusTrap.activate();
        });
        return function() {
            if (frameId != null) {
                cancelAnimationFrame(frameId);
                frameId = null;
            }
            focusTrap.deactivate();
        };
    }, [
        popupRef,
        initialFocusRef,
        shouldCloseOnTab
    ]);
};


var $d4f048c86b30ab9f$var$_excluded = [
    "shouldRenderToParent",
    "shouldFitContainer",
    "children"
];
var $d4f048c86b30ab9f$var$_css;
var $d4f048c86b30ab9f$var$popupFullWidthStyles = (0, $jVTBW.css)({
    width: "100%"
});
var $d4f048c86b30ab9f$var$popupStyles = (0, $jVTBW.css)(($d4f048c86b30ab9f$var$_css = {
    display: "block",
    boxSizing: "border-box",
    zIndex: (0, $fadf80e9637982ea$export$7be255094ccdc533).layer(),
    flex: "1 1 auto",
    backgroundColor: "var(--ds-surface-overlay, ".concat((0, $e996865a8c4821b6$export$29a4f05edc054374), ")"),
    borderRadius: "var(--ds-border-radius, 3px)",
    boxShadow: "var(--ds-shadow-overlay, ".concat("0 4px 8px -2px ".concat((0, $e996865a8c4821b6$export$7d3359664e8bb0e5), ", 0 0 1px ").concat((0, $e996865a8c4821b6$export$d2d3bedfb276cac0)), ")")
}, (0, (/*@__PURE__*/$parcel$interopDefault($c3ec97511ae1ed64$exports)))($d4f048c86b30ab9f$var$_css, (0, $d609a65dfd65a550$export$9d7b58831ae93caa), "var(--ds-surface-overlay, ".concat((0, $e996865a8c4821b6$export$29a4f05edc054374), ")")), (0, (/*@__PURE__*/$parcel$interopDefault($c3ec97511ae1ed64$exports)))($d4f048c86b30ab9f$var$_css, "&:focus", {
    outline: "none"
}), $d4f048c86b30ab9f$var$_css));
var $d4f048c86b30ab9f$var$popupOverflowStyles = (0, $jVTBW.css)({
    overflow: "auto"
});
// disables iframe pointer events while popup is open, except if iframe is nested inside popup
// solves an issue of popup not being closed on iframe click
var $d4f048c86b30ab9f$var$blockPointerEventsOnExternalIframeStyles = (0, $jVTBW.css)({
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    "iframe:not([data-ds--level] iframe)": {
        pointerEvents: "none"
    }
});
var $d4f048c86b30ab9f$var$DefaultPopupComponent = /*#__PURE__*/ (0, $dAx5m.forwardRef)(function(props, ref) {
    var shouldRenderToParent = props.shouldRenderToParent, shouldFitContainer = props.shouldFitContainer, children = props.children, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($74ed1cba0d5551e3$exports)))(props, $d4f048c86b30ab9f$var$_excluded);
    return (0, $jVTBW.jsx)("div", (0, (/*@__PURE__*/$parcel$interopDefault($5fb336a98f9116b4$exports)))({
        css: [
            $d4f048c86b30ab9f$var$popupStyles,
            !shouldRenderToParent && $d4f048c86b30ab9f$var$popupOverflowStyles,
            shouldFitContainer && $d4f048c86b30ab9f$var$popupFullWidthStyles
        ]
    }, htmlAttributes, {
        ref: ref
    }), children);
});
function $d4f048c86b30ab9f$var$PopperWrapper(_ref) {
    var isOpen = _ref.isOpen, id = _ref.id, offset = _ref.offset, testId = _ref.testId, content = _ref.content, fallbackPlacements = _ref.fallbackPlacements, onClose = _ref.onClose, boundary = _ref.boundary, rootBoundary = _ref.rootBoundary, shouldFlip = _ref.shouldFlip, _ref$placement = _ref.placement, placement = _ref$placement === void 0 ? "auto" : _ref$placement, _ref$popupComponent = _ref.popupComponent, PopupContainer = _ref$popupComponent === void 0 ? $d4f048c86b30ab9f$var$DefaultPopupComponent : _ref$popupComponent, _ref$autoFocus = _ref.autoFocus, autoFocus = _ref$autoFocus === void 0 ? true : _ref$autoFocus, triggerRef = _ref.triggerRef, shouldUseCaptureOnOutsideClick = _ref.shouldUseCaptureOnOutsideClick, shouldRenderToParent = _ref.shouldRenderToParent, shouldFitContainer = _ref.shouldFitContainer, shouldDisableFocusLock = _ref.shouldDisableFocusLock, strategy = _ref.strategy, role = _ref.role, label = _ref.label, titleId = _ref.titleId;
    var _useState = (0, $dAx5m.useState)(null), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($6f4c9344050d46f7$exports)))(_useState, 2), popupRef = _useState2[0], setPopupRef = _useState2[1];
    var _useState3 = (0, $dAx5m.useState)(null), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($6f4c9344050d46f7$exports)))(_useState3, 2), initialFocusRef = _useState4[0], setInitialFocusRef = _useState4[1];
    // We have cases when we need to prohibit focus locking
    // e.g. in DropdownMenu
    var shouldCloseOnTab = shouldRenderToParent && shouldDisableFocusLock;
    (0, $f646628571e77e3b$export$10c5169755ce7bd7)({
        initialFocusRef: initialFocusRef,
        popupRef: popupRef,
        shouldCloseOnTab: shouldCloseOnTab
    });
    (0, $38ed07431b49bd94$export$92dae2778ae88f9d)({
        isOpen: isOpen,
        onClose: onClose,
        popupRef: popupRef,
        triggerRef: triggerRef,
        shouldUseCaptureOnOutsideClick: shouldUseCaptureOnOutsideClick,
        shouldCloseOnTab: shouldCloseOnTab
    });
    var _UNSAFE_useLayering = (0, $9e91143110e393a2$export$cec37b93989366d4)(), currentLevel = _UNSAFE_useLayering.currentLevel;
    var modifiers = (0, $dAx5m.useMemo)(function() {
        return [
            {
                name: "flip",
                enabled: shouldFlip,
                options: {
                    rootBoundary: rootBoundary,
                    boundary: boundary,
                    fallbackPlacements: fallbackPlacements
                }
            }
        ];
    }, [
        shouldFlip,
        rootBoundary,
        boundary,
        fallbackPlacements
    ]);
    return (0, $jVTBW.jsx)((0, $8a3e0847275e802a$export$badac9ada3a0bdf9), {
        placement: placement,
        offset: offset,
        modifiers: modifiers,
        strategy: strategy
    }, function(_ref2) {
        var _ref3 = _ref2.ref, style = _ref2.style, placement = _ref2.placement, update = _ref2.update;
        return (0, $jVTBW.jsx)(PopupContainer, {
            id: id,
            "data-ds--level": currentLevel,
            "data-placement": placement,
            "data-testid": testId,
            role: role,
            "aria-label": label,
            "aria-labelledby": titleId,
            ref: function ref(node) {
                if (node) {
                    if (typeof _ref3 === "function") _ref3(node);
                    else _ref3.current = node;
                    setPopupRef(node);
                }
            },
            style: style,
            tabIndex: autoFocus ? 0 : undefined,
            shouldRenderToParent: shouldRenderToParent,
            shouldFitContainer: shouldFitContainer
        }, (0, $jAmv0.getBooleanFF)("platform.design-system-team.iframe_gojiv") && (0, $jVTBW.jsx)((0, $jVTBW.Global), {
            styles: $d4f048c86b30ab9f$var$blockPointerEventsOnExternalIframeStyles
        }), (0, $jVTBW.jsx)((0, $4267a7ca55e70b27$export$51eddd7655ca235a), {
            update: update
        }, content({
            update: update,
            isOpen: isOpen,
            onClose: onClose,
            setInitialFocusRef: setInitialFocusRef
        })));
    });
}
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$d4f048c86b30ab9f$export$2e2bcd8739ae039 = $d4f048c86b30ab9f$var$PopperWrapper;




var $dAx5m = parcelRequire("dAx5m");

var $dHPoE = parcelRequire("dHPoE");
var $f0c423fb8a5498ee$export$7cc5c058dd769dff = function useGetMemoizedMergedTriggerRef() {
    var _useState = (0, $dAx5m.useState)(function() {
        return (0, $dHPoE.default)(function(ref, setTriggerRef, isOpen) {
            return function(node) {
                if (node && isOpen) {
                    if (typeof ref === "function") ref(node);
                    else if (ref) ref.current = node;
                    setTriggerRef(node);
                }
            };
        });
    }), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($6f4c9344050d46f7$exports)))(_useState, 1), getMemoizedMergedTriggerRef = _useState2[0];
    return getMemoizedMergedTriggerRef;
};


var $9fa8070725053fda$var$defaultLayer = (0, $fadf80e9637982ea$export$7be255094ccdc533).layer();
var $9fa8070725053fda$var$wrapperStyles = (0, $63532adf9c22de9a$export$f6c783d06584602c)({
    position: "relative"
});
var $9fa8070725053fda$export$129a32eedafa97c5 = /*#__PURE__*/ (0, $dAx5m.memo)(function(_ref) {
    var isOpen = _ref.isOpen, providedId = _ref.id, offset = _ref.offset, testId = _ref.testId, trigger = _ref.trigger, content = _ref.content, onClose = _ref.onClose, boundary = _ref.boundary, _ref$rootBoundary = _ref.rootBoundary, rootBoundary = _ref$rootBoundary === void 0 ? "viewport" : _ref$rootBoundary, _ref$shouldFlip = _ref.shouldFlip, shouldFlip = _ref$shouldFlip === void 0 ? true : _ref$shouldFlip, _ref$placement = _ref.placement, placement = _ref$placement === void 0 ? "auto" : _ref$placement, fallbackPlacements = _ref.fallbackPlacements, PopupContainer = _ref.popupComponent, _ref$autoFocus = _ref.autoFocus, autoFocus = _ref$autoFocus === void 0 ? true : _ref$autoFocus, _ref$zIndex = _ref.zIndex, zIndex = _ref$zIndex === void 0 ? $9fa8070725053fda$var$defaultLayer : _ref$zIndex, _ref$shouldUseCapture = _ref.shouldUseCaptureOnOutsideClick, shouldUseCaptureOnOutsideClick = _ref$shouldUseCapture === void 0 ? false : _ref$shouldUseCapture, _ref$shouldRenderToPa = _ref.shouldRenderToParent, shouldRenderToParent = _ref$shouldRenderToPa === void 0 ? false : _ref$shouldRenderToPa, _ref$shouldFitContain = _ref.shouldFitContainer, shouldFitContainer = _ref$shouldFitContain === void 0 ? false : _ref$shouldFitContain, _ref$shouldDisableFoc = _ref.shouldDisableFocusLock, shouldDisableFocusLock = _ref$shouldDisableFoc === void 0 ? false : _ref$shouldDisableFoc, strategy = _ref.strategy, role = _ref.role, label = _ref.label, titleId = _ref.titleId;
    var _useState = (0, $dAx5m.useState)(null), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($6f4c9344050d46f7$exports)))(_useState, 2), triggerRef = _useState2[0], setTriggerRef = _useState2[1];
    var getMergedTriggerRef = (0, $f0c423fb8a5498ee$export$7cc5c058dd769dff)();
    var generatedId = (0, $D9YLo.useUID)();
    var id = providedId || generatedId;
    var renderPopperWrapper = (0, $jVTBW.jsx)((0, $2df0da70aab367c6$export$a183686c3f6f4ea8), {
        isDisabled: false
    }, (0, $jVTBW.jsx)((0, $d4f048c86b30ab9f$export$2e2bcd8739ae039), {
        content: content,
        isOpen: isOpen,
        placement: placement,
        fallbackPlacements: fallbackPlacements,
        boundary: boundary,
        rootBoundary: rootBoundary,
        shouldFlip: shouldFlip,
        offset: offset,
        popupComponent: PopupContainer,
        id: id,
        testId: testId,
        onClose: onClose,
        autoFocus: autoFocus,
        shouldUseCaptureOnOutsideClick: shouldUseCaptureOnOutsideClick,
        shouldRenderToParent: shouldRenderToParent || shouldFitContainer,
        shouldFitContainer: shouldFitContainer,
        shouldDisableFocusLock: shouldDisableFocusLock,
        triggerRef: triggerRef,
        strategy: shouldFitContainer ? "absolute" : strategy,
        role: role,
        label: label,
        titleId: titleId
    }));
    var popupContent = (0, $jVTBW.jsx)((0, $expeE.Manager), null, (0, $jVTBW.jsx)((0, $4Yjoy.Reference), null, function(_ref2) {
        var ref = _ref2.ref;
        return trigger({
            ref: getMergedTriggerRef(ref, setTriggerRef, isOpen),
            "aria-controls": isOpen ? id : undefined,
            "aria-expanded": isOpen,
            "aria-haspopup": true
        });
    }), isOpen && (shouldRenderToParent || shouldFitContainer ? renderPopperWrapper : (0, $jVTBW.jsx)((0, $070832f661dcad53$export$2e2bcd8739ae039), {
        zIndex: zIndex
    }, renderPopperWrapper)));
    if (shouldFitContainer) return (0, $jVTBW.jsx)((0, $e6d4cc5637a54680$export$2e2bcd8739ae039), {
        xcss: $9fa8070725053fda$var$wrapperStyles
    }, popupContent);
    return popupContent;
});
var $9fa8070725053fda$export$2e2bcd8739ae039 = $9fa8070725053fda$export$129a32eedafa97c5;


var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$bb6c61bca55f38e4$export$2e2bcd8739ae039 = (0, $9fa8070725053fda$export$129a32eedafa97c5);




var $dAx5m = parcelRequire("dAx5m");

var $dd4sf = parcelRequire("dd4sf");

var $Bb0he = parcelRequire("Bb0he");



var $76DDk = parcelRequire("76DDk");
var $1d1913fede4373ac$var$_actionMap;
var $1d1913fede4373ac$var$actionMap = ($1d1913fede4373ac$var$_actionMap = {}, (0, (/*@__PURE__*/$parcel$interopDefault($c3ec97511ae1ed64$exports)))($1d1913fede4373ac$var$_actionMap, (0, $76DDk.KEY_DOWN), "next"), (0, (/*@__PURE__*/$parcel$interopDefault($c3ec97511ae1ed64$exports)))($1d1913fede4373ac$var$_actionMap, (0, $76DDk.KEY_UP), "prev"), (0, (/*@__PURE__*/$parcel$interopDefault($c3ec97511ae1ed64$exports)))($1d1913fede4373ac$var$_actionMap, (0, $76DDk.KEY_HOME), "first"), (0, (/*@__PURE__*/$parcel$interopDefault($c3ec97511ae1ed64$exports)))($1d1913fede4373ac$var$_actionMap, (0, $76DDk.KEY_END), "last"), $1d1913fede4373ac$var$_actionMap);
/**
 * `currentFocusedIdx + 1` will not work if the next focusable element
 * is disabled. So, we need to iterate through the following menu items
 * to find one that isn't disabled. If all following elements are disabled,
 * return undefined.
 */ var $1d1913fede4373ac$var$getNextFocusableElement = function getNextFocusableElement(refs, currentFocusedIdx) {
    while(currentFocusedIdx + 1 < refs.length){
        var isDisabled = refs[currentFocusedIdx + 1].hasAttribute("disabled");
        if (!isDisabled) return refs[currentFocusedIdx + 1];
        currentFocusedIdx++;
    }
};
/**
 * `currentFocusedIdx - 1` will not work if the prev focusable element
 * is disabled. So, we need to iterate through the previous menu items
 * to find one that isn't disabled. If all previous elements are disabled,
 * return undefined.
 */ var $1d1913fede4373ac$var$getPrevFocusableElement = function getPrevFocusableElement(refs, currentFocusedIdx) {
    while(currentFocusedIdx > 0){
        var isDisabled = refs[currentFocusedIdx - 1].hasAttribute("disabled");
        if (!isDisabled) return refs[currentFocusedIdx - 1];
        currentFocusedIdx--;
    }
};
function $1d1913fede4373ac$export$2e2bcd8739ae039(refs, isLayerDisabled, onClose) {
    return function(e) {
        var currentFocusedIdx = refs.findIndex(function(el) {
            var _document$activeEleme;
            return (_document$activeEleme = document.activeElement) === null || _document$activeEleme === void 0 ? void 0 : _document$activeEleme.isSameNode(el);
        });
        if (isLayerDisabled()) {
            // if nested dropdown isOpen we need to close on Tab key press
            if (e.key === (0, $76DDk.KEY_TAB) && !e.shiftKey) onClose(e);
            // if it is a nested dropdown and the level of the given dropdown is not the current level,
            // we don't need to have focus on it
            return;
        }
        var action = $1d1913fede4373ac$var$actionMap[e.key];
        switch(action){
            case "next":
                // Always cancelling the event to prevent scrolling
                e.preventDefault();
                if (currentFocusedIdx < refs.length - 1) {
                    var _nextFocusableElement = $1d1913fede4373ac$var$getNextFocusableElement(refs, currentFocusedIdx);
                    _nextFocusableElement === null || _nextFocusableElement === void 0 || _nextFocusableElement.focus();
                } else {
                    var firstFocusableElement = $1d1913fede4373ac$var$getNextFocusableElement(refs, -1);
                    firstFocusableElement === null || firstFocusableElement === void 0 || firstFocusableElement.focus();
                }
                break;
            case "prev":
                // Always cancelling the event to prevent scrolling
                e.preventDefault();
                if (currentFocusedIdx > 0) {
                    var _prevFocusableElement = $1d1913fede4373ac$var$getPrevFocusableElement(refs, currentFocusedIdx);
                    _prevFocusableElement === null || _prevFocusableElement === void 0 || _prevFocusableElement.focus();
                } else {
                    var lastFocusableElement = $1d1913fede4373ac$var$getPrevFocusableElement(refs, refs.length);
                    lastFocusableElement === null || lastFocusableElement === void 0 || lastFocusableElement.focus();
                }
                break;
            case "first":
                e.preventDefault();
                // Search for first non-disabled element if first element is disabled
                var nextFocusableElement = $1d1913fede4373ac$var$getNextFocusableElement(refs, -1);
                nextFocusableElement === null || nextFocusableElement === void 0 || nextFocusableElement.focus();
                break;
            case "last":
                e.preventDefault();
                // Search for last non-disabled element if last element is disabled
                var prevFocusableElement = $1d1913fede4373ac$var$getPrevFocusableElement(refs, refs.length);
                prevFocusableElement === null || prevFocusableElement === void 0 || prevFocusableElement.focus();
                break;
            default:
                return;
        }
    };
}


var $166f31e2cd41db7e$export$f18c1d4fc7326096 = /*#__PURE__*/ (0, $dAx5m.createContext)({
    menuItemRefs: [],
    registerRef: (0, $Bb0he.default)
});
/**
 * Focus manager logic.
 */ var $166f31e2cd41db7e$var$FocusManager = function FocusManager(_ref) {
    var children = _ref.children, onClose = _ref.onClose;
    var menuItemRefs = (0, $dAx5m.useRef)([]);
    var registerRef = (0, $dAx5m.useCallback)(function(ref) {
        if (ref && !menuItemRefs.current.includes(ref)) menuItemRefs.current.push(ref);
    }, []);
    var _UNSAFE_useLayering = (0, $9e91143110e393a2$export$cec37b93989366d4)(), isLayerDisabled = _UNSAFE_useLayering.isLayerDisabled;
    // Intentionally rebinding on each render
    (0, $dAx5m.useEffect)(function() {
        return (0, $dd4sf.bind)(window, {
            type: "keydown",
            listener: (0, $1d1913fede4373ac$export$2e2bcd8739ae039)(menuItemRefs.current, isLayerDisabled, onClose)
        });
    });
    var contextValue = {
        menuItemRefs: menuItemRefs.current,
        registerRef: registerRef
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement($166f31e2cd41db7e$export$f18c1d4fc7326096.Provider, {
        value: contextValue
    }, children);
};
var $166f31e2cd41db7e$export$2e2bcd8739ae039 = $166f31e2cd41db7e$var$FocusManager;


/**
 * @jsxRuntime classic
 */ /** @jsx jsx */ 
var $dAx5m = parcelRequire("dAx5m");

var $jVTBW = parcelRequire("jVTBW");




function $0ba3164360357bd7$export$2e2bcd8739ae039(element) {
    var role = element.getAttribute("role");
    return role === "checkbox" || role === "menuitemcheckbox";
}


function $d1acd6a04c37dc55$export$2e2bcd8739ae039(element) {
    var role = element.getAttribute("role");
    return role === "radio" || role === "menuitemradio";
}


var $3bb6026a5676a514$var$spinnerContainerStyles = (0, $63532adf9c22de9a$export$f6c783d06584602c)({
    display: "flex",
    minWidth: "160px",
    padding: "space.250",
    justifyContent: "center"
});
var $3bb6026a5676a514$var$LoadingIndicator = function LoadingIndicator(_ref) {
    var _ref$statusLabel = _ref.statusLabel, statusLabel = _ref$statusLabel === void 0 ? "Loading" : _ref$statusLabel, testId = _ref.testId;
    return (0, $jVTBW.jsx)((0, $e6d4cc5637a54680$export$2e2bcd8739ae039), {
        xcss: $3bb6026a5676a514$var$spinnerContainerStyles
    }, (0, $jVTBW.jsx)((0, $917ea1ded1dd2c62$export$2e2bcd8739ae039), {
        size: "small",
        label: statusLabel,
        testId: testId
    }));
};
/**
 *
 * MenuWrapper wraps all the menu items.
 * It handles the logic to close the menu when a MenuItem is clicked, but leaves it open
 * if a CheckboxItem or RadioItem is clicked.
 * It also sets focus to the first menu item when opened.
 */ var $3bb6026a5676a514$var$MenuWrapper = function MenuWrapper(_ref2) {
    var children = _ref2.children, isLoading = _ref2.isLoading, maxHeight = _ref2.maxHeight, maxWidth = _ref2.maxWidth, onClose = _ref2.onClose, onUpdate = _ref2.onUpdate, statusLabel = _ref2.statusLabel, setInitialFocusRef = _ref2.setInitialFocusRef, shouldRenderToParent = _ref2.shouldRenderToParent, spacing = _ref2.spacing, testId = _ref2.testId, isTriggeredUsingKeyboard = _ref2.isTriggeredUsingKeyboard, autoFocus = _ref2.autoFocus;
    var _useContext = (0, $dAx5m.useContext)((0, $166f31e2cd41db7e$export$f18c1d4fc7326096)), menuItemRefs = _useContext.menuItemRefs;
    var closeOnMenuItemClick = function closeOnMenuItemClick(e) {
        var isTargetMenuItemOrDecendant = menuItemRefs.some(function(menuItem) {
            var isCheckboxOrRadio = (0, $0ba3164360357bd7$export$2e2bcd8739ae039)(menuItem) || (0, $d1acd6a04c37dc55$export$2e2bcd8739ae039)(menuItem);
            return menuItem.contains(e.target) && !isCheckboxOrRadio;
        });
        // Close menu if the click is triggered from a MenuItem or
        // its descendant. Don't close the menu if the click is triggered
        // from a MenuItemRadio or MenuItemCheckbox so that the user can
        // select multiple items.
        if (isTargetMenuItemOrDecendant && onClose) onClose(e);
    };
    // Using useEffect here causes a flicker.
    // useLayoutEffect ensures that the update and render happen in the same
    // rAF tick.
    (0, $dAx5m.useLayoutEffect)(function() {
        onUpdate();
    }, [
        isLoading,
        onUpdate
    ]);
    (0, $dAx5m.useEffect)(function() {
        var _menuItemRefs$find;
        var firstFocusableRef = (_menuItemRefs$find = menuItemRefs.find(function(ref) {
            return !ref.hasAttribute("disabled");
        })) !== null && _menuItemRefs$find !== void 0 ? _menuItemRefs$find : null;
        if (shouldRenderToParent && (isTriggeredUsingKeyboard || autoFocus)) firstFocusableRef === null || firstFocusableRef === void 0 || firstFocusableRef.focus();
        setInitialFocusRef === null || setInitialFocusRef === void 0 || setInitialFocusRef(firstFocusableRef);
    }, [
        menuItemRefs,
        setInitialFocusRef,
        autoFocus,
        shouldRenderToParent,
        isTriggeredUsingKeyboard
    ]);
    return (0, $jVTBW.jsx)((0, $47fb6f45f1898158$export$2e2bcd8739ae039), {
        isLoading: isLoading,
        maxHeight: maxHeight,
        maxWidth: maxWidth,
        onClick: closeOnMenuItemClick,
        role: "menu",
        spacing: spacing,
        testId: testId && "".concat(testId, "--menu-group")
    }, isLoading ? (0, $jVTBW.jsx)($3bb6026a5676a514$var$LoadingIndicator, {
        statusLabel: statusLabel,
        testId: testId && "".concat(testId, "--loading-indicator")
    }) : children);
};
var $3bb6026a5676a514$export$2e2bcd8739ae039 = $3bb6026a5676a514$var$MenuWrapper;



var $dAx5m = parcelRequire("dAx5m");

var $Bb0he = parcelRequire("Bb0he");
var $c180b9afe496357f$export$756f795847463ebd = /*#__PURE__*/ (0, $dAx5m.createContext)({
    setItemState: (0, $Bb0he.default),
    getItemState: function getItemState() {
        return undefined;
    },
    setGroupState: (0, $Bb0he.default),
    getGroupState: function getGroupState() {
        return {};
    }
});
/**
 * Selection store will persist data as long as it remains mounted.
 * It handles the uncontrolled story for dropdown menu when the menu
 * items can be mounted/unmounted depending if the menu is open or closed.
 */ var $c180b9afe496357f$var$SelectionStore = function SelectionStore(props) {
    var children = props.children;
    var store = (0, $dAx5m.useRef)({});
    var context = (0, $dAx5m.useMemo)(function() {
        return {
            setItemState: function setItemState(group, id, value) {
                if (!store.current[group]) store.current[group] = {};
                store.current[group][id] = value;
            },
            getItemState: function getItemState(group, id) {
                if (!store.current[group]) return undefined;
                return store.current[group][id];
            },
            setGroupState: function setGroupState(group, value) {
                store.current[group] = value;
            },
            getGroupState: function getGroupState(group) {
                return store.current[group] || {};
            }
        };
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement($c180b9afe496357f$export$756f795847463ebd.Provider, {
        value: context
    }, children);
};
var $c180b9afe496357f$export$2e2bcd8739ae039 = $c180b9afe496357f$var$SelectionStore;



var $dAx5m = parcelRequire("dAx5m");

// This function is called whenever a MenuItem mounts.
// The refs stored in the context are used to programatically
// control focus on a user navigates using the keyboard.
function $6579ef48703275a8$var$useRegisterItemWithFocusManager() {
    var _useContext = (0, $dAx5m.useContext)((0, $166f31e2cd41db7e$export$f18c1d4fc7326096)), registerRef = _useContext.registerRef;
    var itemRef = (0, $dAx5m.useRef)(null);
    (0, $dAx5m.useEffect)(function() {
        if (itemRef.current !== null) registerRef(itemRef.current);
    }, [
        registerRef
    ]);
    return itemRef;
}
var $6579ef48703275a8$export$2e2bcd8739ae039 = $6579ef48703275a8$var$useRegisterItemWithFocusManager;



var $dAx5m = parcelRequire("dAx5m");
var $25e5d17c5232c39e$export$8a682ae47622dbb9 = "ds--dropdown--";
var $25e5d17c5232c39e$var$generateRandomString = function generateRandomString() {
    return(// Therefore, so there is no risk of mismatch
    // between server and client generated markup.
    // eslint-disable-next-line @repo/internal/react/disallow-unstable-values
    "".concat($25e5d17c5232c39e$export$8a682ae47622dbb9).concat(Math.random().toString(16).substr(2, 8)));
};
function $25e5d17c5232c39e$export$2e2bcd8739ae039() {
    var cachedId = (0, $dAx5m.useRef)($25e5d17c5232c39e$var$generateRandomString());
    return cachedId.current;
}


var $6103c59ea9e7b4c6$var$_excluded = [
    "ref",
    "aria-controls",
    "aria-expanded",
    "aria-haspopup"
];
function $6103c59ea9e7b4c6$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $6103c59ea9e7b4c6$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $6103c59ea9e7b4c6$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($c3ec97511ae1ed64$exports)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $6103c59ea9e7b4c6$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $6103c59ea9e7b4c6$var$gridSize = (0, $fadf80e9637982ea$export$6d8204c2cb2e06b8)();
var $6103c59ea9e7b4c6$var$MAX_HEIGHT = "calc(100vh - ".concat($6103c59ea9e7b4c6$var$gridSize * 2, "px)");
var $6103c59ea9e7b4c6$var$opposites = {
    top: "bottom",
    bottom: "top",
    left: "right",
    right: "left",
    start: "end",
    auto: "auto",
    end: "start"
};
var $6103c59ea9e7b4c6$var$getFallbackPlacements = function getFallbackPlacements(placement) {
    var placementPieces = placement.split("-");
    var mainAxis = placementPieces[0];
    // Left, right and auto placements can rely on standard popper sliding behaviour
    if (![
        "top",
        "bottom"
    ].includes(mainAxis)) return undefined;
    else if (placementPieces.length === 2 && [
        "start",
        "end"
    ].includes(placementPieces[1])) {
        var crossAxis = placementPieces[1];
        return [
            "".concat(mainAxis),
            "".concat(mainAxis, "-").concat($6103c59ea9e7b4c6$var$opposites[crossAxis]),
            "".concat($6103c59ea9e7b4c6$var$opposites[mainAxis], "-").concat(crossAxis),
            "".concat($6103c59ea9e7b4c6$var$opposites[mainAxis]),
            "".concat($6103c59ea9e7b4c6$var$opposites[mainAxis], "-").concat($6103c59ea9e7b4c6$var$opposites[crossAxis]),
            "auto"
        ];
    } else return [
        "".concat(mainAxis, "-start"),
        "".concat(mainAxis, "-end"),
        "".concat($6103c59ea9e7b4c6$var$opposites[mainAxis]),
        "".concat($6103c59ea9e7b4c6$var$opposites[mainAxis], "-start"),
        "".concat($6103c59ea9e7b4c6$var$opposites[mainAxis], "-end"),
        "auto"
    ];
};
/**
 * __Dropdown menu__
 *
 * A dropdown menu displays a list of actions or options to a user.
 *
 * - [Examples](https://atlassian.design/components/dropdown-menu/examples)
 * - [Code](https://atlassian.design/components/dropdown-menu/code)
 * - [Usage](https://atlassian.design/components/dropdown-menu/usage)
 */ var $6103c59ea9e7b4c6$var$DropdownMenu = function DropdownMenu(_ref) {
    var _ref$autoFocus = _ref.autoFocus, autoFocus = _ref$autoFocus === void 0 ? false : _ref$autoFocus, children = _ref.children, _ref$defaultOpen = _ref.defaultOpen, defaultOpen = _ref$defaultOpen === void 0 ? false : _ref$defaultOpen, _ref$isLoading = _ref.isLoading, isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading, isOpen = _ref.isOpen, _ref$onOpenChange = _ref.onOpenChange, onOpenChange = _ref$onOpenChange === void 0 ? (0, $Bb0he.default) : _ref$onOpenChange, _ref$placement = _ref.placement, placement = _ref$placement === void 0 ? "bottom-start" : _ref$placement, _ref$shouldFitContain = _ref.shouldFitContainer, shouldFitContainer = _ref$shouldFitContain === void 0 ? false : _ref$shouldFitContain, _ref$shouldFlip = _ref.shouldFlip, shouldFlip = _ref$shouldFlip === void 0 ? true : _ref$shouldFlip, _ref$shouldRenderToPa = _ref.shouldRenderToParent, shouldRenderToParent = _ref$shouldRenderToPa === void 0 ? false : _ref$shouldRenderToPa, spacing = _ref.spacing, statusLabel = _ref.statusLabel, testId = _ref.testId, _trigger = _ref.trigger, _ref$zIndex = _ref.zIndex, zIndex = _ref$zIndex === void 0 ? (0, $fadf80e9637982ea$export$7be255094ccdc533).modal() : _ref$zIndex, label = _ref.label;
    var _useControlledState = (0, $4Xq7n.default)(isOpen, function() {
        return defaultOpen;
    }), _useControlledState2 = (0, (/*@__PURE__*/$parcel$interopDefault($6f4c9344050d46f7$exports)))(_useControlledState, 2), isLocalOpen = _useControlledState2[0], setLocalIsOpen = _useControlledState2[1];
    var _useState = (0, $dAx5m.useState)(false), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($6f4c9344050d46f7$exports)))(_useState, 2), isTriggeredUsingKeyboard = _useState2[0], setTriggeredUsingKeyboard = _useState2[1];
    var id = (0, $25e5d17c5232c39e$export$2e2bcd8739ae039)();
    var itemRef = (0, $6579ef48703275a8$export$2e2bcd8739ae039)();
    var fallbackPlacements = (0, $dAx5m.useMemo)(function() {
        return $6103c59ea9e7b4c6$var$getFallbackPlacements(placement);
    }, [
        placement
    ]);
    var handleTriggerClicked = (0, $dAx5m.useCallback)(// TODO: event is an `any` and is being cast incorrectly
    // This means that the public type for `onOpenChange` is incorrect
    // current: (event: React.MouseEvent | React.KeyboardEvent) => void;
    // correct: (event: React.MouseEvent | KeyboardEvent) => void;
    // https://product-fabric.atlassian.net/browse/DSP-4692
    function(event) {
        var newValue = !isLocalOpen;
        var clientX = event.clientX, clientY = event.clientY, type = event.type, detail = event.detail;
        if (type === "keydown") setTriggeredUsingKeyboard(true);
        else if (clientX === 0 || clientY === 0) // Hitting enter/space is registered as a click
        // with both clientX and clientY === 0
        setTriggeredUsingKeyboard(true);
        else if (detail === 0) // Fix for Safari. clientX and clientY !== 0 in Safari
        setTriggeredUsingKeyboard(true);
        else {
            var _itemRef$current;
            // The trigger element must be focused to avoid problems with an incorrectly focused element after closing DropdownMenu
            itemRef === null || itemRef === void 0 || (_itemRef$current = itemRef.current) === null || _itemRef$current === void 0 || _itemRef$current.focus();
            setTriggeredUsingKeyboard(false);
        }
        setLocalIsOpen(newValue);
        onOpenChange({
            isOpen: newValue,
            event: event
        });
    }, [
        itemRef,
        onOpenChange,
        isLocalOpen,
        setLocalIsOpen
    ]);
    var handleOnClose = (0, $dAx5m.useCallback)(function(event) {
        var _event$target, _event$target$closest;
        if (event.key !== "Escape" && event.key !== "Tab" && (_event$target = event.target) !== null && _event$target !== void 0 && (_event$target$closest = _event$target.closest) !== null && _event$target$closest !== void 0 && _event$target$closest.call(_event$target, "[id^=".concat((0, $25e5d17c5232c39e$export$8a682ae47622dbb9), "] [aria-haspopup]"))) // Check if it is within dropdown and it is a trigger button
        // if it is a nested dropdown, clicking trigger won't close the dropdown
        // Dropdown can be closed by pressing Escape, Tab or Shift + Tab
        return;
        if (event.key === "Tab" && event.shiftKey || event.key === "Escape") requestAnimationFrame(function() {
            var _itemRef$current2;
            (_itemRef$current2 = itemRef.current) === null || _itemRef$current2 === void 0 || _itemRef$current2.focus();
        });
        var newValue = false;
        setLocalIsOpen(newValue);
        onOpenChange({
            isOpen: newValue,
            event: event
        });
    }, [
        onOpenChange,
        setLocalIsOpen,
        itemRef
    ]);
    var _useFocus = (0, $kzmLI.default)(), isFocused = _useFocus.isFocused, bindFocus = _useFocus.bindFocus;
    // When a trigger is focused, we want to open the dropdown if
    // the user presses the DownArrow
    (0, $dAx5m.useEffect)(function() {
        // Only need to listen for keydown when focused
        if (!isFocused) return 0, $Bb0he.default;
        // Being safe: we don't want to open the dropdown if it is already open
        // Note: This shouldn't happen as the trigger should not be able to get focus
        if (isLocalOpen) return 0, $Bb0he.default;
        return (0, $dd4sf.bind)(window, {
            type: "keydown",
            listener: function openOnKeyDown(e) {
                var isNestedTriggerButton;
                if (e.target instanceof HTMLElement) isNestedTriggerButton = e.target.closest("[id^=".concat((0, $25e5d17c5232c39e$export$8a682ae47622dbb9), "] [aria-haspopup]"));
                if (e.key === (0, $76DDk.KEY_DOWN) && !isNestedTriggerButton) {
                    // prevent page scroll
                    e.preventDefault();
                    handleTriggerClicked(e);
                } else if ((e.code === (0, $76DDk.KEY_SPACE) || e.key === (0, $76DDk.KEY_ENTER)) && e.detail === 0) // This allows us to focus on the first element if the dropdown was triggered by a custom trigger with a custom onClick
                setTriggeredUsingKeyboard(true);
                else if (e.key === (0, $76DDk.KEY_TAB) && isNestedTriggerButton) // This closes dropdown if it is a nested dropdown
                handleOnClose(e);
            }
        });
    }, [
        isFocused,
        isLocalOpen,
        handleTriggerClicked,
        handleOnClose
    ]);
    /*
   * The Popup component requires either:
   * - shouldFitContainer={true} and shouldRenderToParent={true | undefined}
   * or
   * - shouldFitContainer={false | undefined} and shouldRenderToParent={true | false | undefined}
   *
   * But not:
   * - shouldFitContainer={true} and shouldRenderToParent={false}
   *
   * By only including either shouldFitContainer or shouldRenderToParent, we can ensure that the Popup component
   * types are satisfied.
   */ var conditionalProps = shouldFitContainer ? {
        shouldFitContainer: shouldFitContainer
    } : {
        shouldRenderToParent: shouldRenderToParent
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $c180b9afe496357f$export$2e2bcd8739ae039), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $bb6c61bca55f38e4$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($5fb336a98f9116b4$exports)))({
        id: isLocalOpen ? id : undefined,
        shouldFlip: shouldFlip,
        isOpen: isLocalOpen,
        onClose: handleOnClose,
        zIndex: zIndex,
        placement: placement,
        fallbackPlacements: fallbackPlacements,
        testId: testId && "".concat(testId, "--content"),
        shouldUseCaptureOnOutsideClick: true
    }, conditionalProps, {
        shouldDisableFocusLock: true,
        trigger: function trigger(_ref2) {
            var ref = _ref2.ref, ariaControls = _ref2["aria-controls"], ariaExpanded = _ref2["aria-expanded"], ariaHasPopup = _ref2["aria-haspopup"], rest = (0, (/*@__PURE__*/$parcel$interopDefault($74ed1cba0d5551e3$exports)))(_ref2, $6103c59ea9e7b4c6$var$_excluded);
            if (typeof _trigger === "function") return _trigger($6103c59ea9e7b4c6$var$_objectSpread($6103c59ea9e7b4c6$var$_objectSpread($6103c59ea9e7b4c6$var$_objectSpread({
                "aria-controls": ariaControls,
                "aria-expanded": ariaExpanded,
                "aria-haspopup": ariaHasPopup
            }, rest), bindFocus), {}, {
                triggerRef: (0, $2Dg3J.default)([
                    ref,
                    itemRef
                ]),
                isSelected: isLocalOpen,
                onClick: handleTriggerClicked,
                testId: testId && "".concat(testId, "--trigger")
            }));
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $3b0bd407ca1a8a5f$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($5fb336a98f9116b4$exports)))({}, bindFocus, {
                ref: (0, $2Dg3J.default)([
                    ref,
                    itemRef
                ]),
                "aria-controls": ariaControls,
                "aria-expanded": ariaExpanded,
                "aria-haspopup": ariaHasPopup,
                isSelected: isLocalOpen,
                iconAfter: (0, (/*@__PURE__*/$parcel$interopDefault($21dd8ee589964939$exports))),
                onClick: handleTriggerClicked,
                testId: testId && "".concat(testId, "--trigger"),
                "aria-label": label
            }), _trigger);
        },
        content: function content(_ref3) {
            var setInitialFocusRef = _ref3.setInitialFocusRef, update = _ref3.update;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $166f31e2cd41db7e$export$2e2bcd8739ae039), {
                onClose: handleOnClose
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $3bb6026a5676a514$export$2e2bcd8739ae039), {
                spacing: spacing,
                maxHeight: $6103c59ea9e7b4c6$var$MAX_HEIGHT,
                maxWidth: shouldFitContainer ? undefined : 800,
                onClose: handleOnClose,
                onUpdate: update,
                isLoading: isLoading,
                statusLabel: statusLabel,
                setInitialFocusRef: isTriggeredUsingKeyboard || autoFocus ? setInitialFocusRef : undefined,
                shouldRenderToParent: shouldRenderToParent || shouldFitContainer,
                isTriggeredUsingKeyboard: isTriggeredUsingKeyboard,
                autoFocus: autoFocus,
                testId: testId && "".concat(testId, "--menu-wrapper")
            }, children));
        }
    })));
};
var $6103c59ea9e7b4c6$export$2e2bcd8739ae039 = $6103c59ea9e7b4c6$var$DropdownMenu;





var $dAx5m = parcelRequire("dAx5m");

var $Bb0he = parcelRequire("Bb0he");




var $dAx5m = parcelRequire("dAx5m");

var $jVTBW = parcelRequire("jVTBW");

var $e2xkU = parcelRequire("e2xkU");

var $Bb0he = parcelRequire("Bb0he");

var $jAmv0 = parcelRequire("jAmv0");

var $2e4fa2caee1a954e$var$_excluded = [
    "children",
    "cssFn",
    "description",
    "iconAfter",
    "iconBefore",
    "isDisabled",
    "isSelected",
    "onClick",
    "testId",
    "overrides",
    "onMouseDown",
    "shouldTitleWrap",
    "shouldDescriptionWrap",
    "className"
];
/**
 * __Button item__
 *
 * A button item is used to populate a menu with items that are buttons.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/button-item)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ var $2e4fa2caee1a954e$var$ButtonItem = /*#__PURE__*/ (0, $dAx5m.memo)(/*#__PURE__*/ (0, $dAx5m.forwardRef)(// Type needed on props to extract types with extract react types.
function(props, ref) {
    var children = props.children, _props$cssFn = props.cssFn, cssFn = _props$cssFn === void 0 ? (0, $Bb0he.default) : _props$cssFn, description = props.description, iconAfter = props.iconAfter, iconBefore = props.iconBefore, _props$isDisabled = props.isDisabled, isDisabled = _props$isDisabled === void 0 ? false : _props$isDisabled, _props$isSelected = props.isSelected, isSelected = _props$isSelected === void 0 ? false : _props$isSelected, onClick = props.onClick, testId = props.testId, overrides = props.overrides, onMouseDown = props.onMouseDown, shouldTitleWrap = props.shouldTitleWrap, shouldDescriptionWrap = props.shouldDescriptionWrap, UNSAFE_className = props.className, rest = (0, (/*@__PURE__*/$parcel$interopDefault($74ed1cba0d5551e3$exports)))(props, $2e4fa2caee1a954e$var$_excluded);
    var onMouseDownHandler = onMouseDown;
    if (!children) return null;
    (0, $e2xkU.propDeprecationWarning)("@atlaskit/menu", "cssFn", cssFn !== (0, $Bb0he.default), "" // TODO: Create DAC post when primitives/xcss are available as alternatives
    );
    return (0, $jVTBW.jsx)((0, $a7360decc2ab332b$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($5fb336a98f9116b4$exports)))({
        className: (0, $jAmv0.getBooleanFF)("platform.design-system-team.unsafe-overrides-killswitch_c8j9m") ? undefined : UNSAFE_className
    }, rest, {
        // eslint-disable-next-line @repo/internal/react/no-unsafe-overrides
        overrides: overrides,
        iconBefore: iconBefore,
        iconAfter: iconAfter,
        isDisabled: isDisabled,
        isSelected: isSelected,
        description: description,
        title: children,
        shouldTitleWrap: shouldTitleWrap,
        shouldDescriptionWrap: shouldDescriptionWrap,
        css: // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        cssFn({
            isSelected: isSelected,
            isDisabled: isDisabled
        }),
        testId: testId && "".concat(testId, "--primitive")
    }), function(_ref) {
        var children = _ref.children, className = _ref.className;
        return (0, $jVTBW.jsx)("button", (0, (/*@__PURE__*/$parcel$interopDefault($5fb336a98f9116b4$exports)))({
            "data-testid": testId
        }, rest, {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            ref: ref,
            disabled: isDisabled,
            onClick: onClick,
            onMouseDown: onMouseDownHandler,
            type: "button"
        }), children);
    });
}));
var $2e4fa2caee1a954e$export$2e2bcd8739ae039 = $2e4fa2caee1a954e$var$ButtonItem;



var $dAx5m = parcelRequire("dAx5m");
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $dAx5m = parcelRequire("dAx5m");

var $jVTBW = parcelRequire("jVTBW");


// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
var $8b4f1e23891df9f4$var$svgStyles = (0, $jVTBW.css)((0, $802a437dfc8c049f$export$16374db1c3e6dfba));
/**
 * __SVG__
 *
 * An icon is used as a visual representation of common actions and commands to provide context.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-svgs)
 */ var $8b4f1e23891df9f4$var$SVG = /*#__PURE__*/ (0, $dAx5m.memo)(function SVG(_ref) {
    var _ref$size = _ref.size, size = _ref$size === void 0 ? "medium" : _ref$size, label = _ref.label, _ref$primaryColor = _ref.primaryColor, primaryColor = _ref$primaryColor === void 0 ? "currentColor" : _ref$primaryColor, secondaryColor = _ref.secondaryColor, testId = _ref.testId, children = _ref.children;
    return (0, $jVTBW.jsx)("svg", {
        viewBox: "0 0 24 24",
        style: {
            color: primaryColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            fill: secondaryColor || (0, $5cea5f38e7297dcb$export$18cb9425622d4e06)()
        },
        css: [
            $8b4f1e23891df9f4$var$svgStyles,
            (0, $802a437dfc8c049f$export$ef0ad74202575b64)[size]
        ],
        "data-testid": testId,
        "aria-label": label || undefined,
        role: label ? "img" : "presentation"
    }, children);
});
var $8b4f1e23891df9f4$export$2e2bcd8739ae039 = $8b4f1e23891df9f4$var$SVG;



/**
 * __Radio icon__
 *
 * Used to visually represent the selected state in DropdownItemRadio
 *
 * @internal
 */ var $8bc1009402853642$var$RadioIcon = function RadioIcon(_ref) {
    var checked = _ref.checked;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $8b4f1e23891df9f4$export$2e2bcd8739ae039), {
        label: "",
        size: "medium",
        primaryColor: checked ? "var(--ds-background-selected-bold, ".concat((0, $e996865a8c4821b6$export$b3de0ae08da2ce64), ")") : "var(--ds-background-input, ".concat((0, $e996865a8c4821b6$export$e655ef011c4aa1a2), ")"),
        secondaryColor: checked ? "var(--ds-icon-inverse, ".concat((0, $e996865a8c4821b6$export$e655ef011c4aa1a2), ")") : "transparent"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement("g", {
        fillRule: "evenodd"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement("circle", {
        fill: "currentColor",
        cx: "12",
        cy: "12",
        r: "6",
        stroke: checked ? "var(--ds-border-selected, ".concat((0, $e996865a8c4821b6$export$b3de0ae08da2ce64), ")") : "var(--ds-border-input, ".concat((0, $e996865a8c4821b6$export$d6447c357493214f), ")"),
        strokeWidth: 1
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement("circle", {
        fill: "inherit",
        cx: "12",
        cy: "12",
        r: "2"
    })));
};
var $8bc1009402853642$export$2e2bcd8739ae039 = $8bc1009402853642$var$RadioIcon;





var $dAx5m = parcelRequire("dAx5m");





var $dAx5m = parcelRequire("dAx5m");

var $D9YLo = parcelRequire("D9YLo");

var $Bb0he = parcelRequire("Bb0he");

/**
 * @jsxRuntime classic
 */ /** @jsx jsx */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $jVTBW = parcelRequire("jVTBW");


var $941030332704d212$var$itemHeadingContentHeight = (0, $cbdfda2c6ae17b89$export$bc02e067df412c3b).h100.lineHeight;
var $941030332704d212$var$itemHeadingFontSize = (0, $cbdfda2c6ae17b89$export$bc02e067df412c3b).h100.size;
var $941030332704d212$var$headingStyles = (0, $jVTBW.css)({
    color: "var(--ds-text-subtle, ".concat((0, $e996865a8c4821b6$export$e2ef2124cf4024b1), ")"),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    fontSize: $941030332704d212$var$itemHeadingFontSize,
    fontWeight: "var(--ds-font-weight-bold, 700)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    lineHeight: $941030332704d212$var$itemHeadingContentHeight / $941030332704d212$var$itemHeadingFontSize,
    paddingBlock: "var(--ds-space-0, 0px)",
    paddingInline: "var(--ds-space-200, 16px)",
    textTransform: "uppercase"
});
/**
 * __Group title__
 *
 * Used to visually represent the title for DropdownMenu groups
 *
 * @internal
 */ var $941030332704d212$var$GroupTitle = function GroupTitle(_ref) {
    var id = _ref.id, title = _ref.title;
    return (0, $jVTBW.jsx)("div", {
        "data-ds--menu--heading-item": true,
        role: "menuitem",
        id: id,
        "aria-hidden": "true",
        css: $941030332704d212$var$headingStyles
    }, title);
};
var $941030332704d212$export$2e2bcd8739ae039 = $941030332704d212$var$GroupTitle;




function $6c9eaa7b073faa3a$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $6c9eaa7b073faa3a$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $6c9eaa7b073faa3a$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($c3ec97511ae1ed64$exports)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $6c9eaa7b073faa3a$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $6c9eaa7b073faa3a$var$resetOptionsInGroup = function resetOptionsInGroup(group) {
    return Object.keys(group || {}).reduce(function(accumulator, current) {
        return $6c9eaa7b073faa3a$var$_objectSpread($6c9eaa7b073faa3a$var$_objectSpread({}, accumulator), {}, (0, (/*@__PURE__*/$parcel$interopDefault($c3ec97511ae1ed64$exports)))({}, current, typeof group[current] === "undefined" ? undefined : false));
    }, {});
};
var $6c9eaa7b073faa3a$export$2e2bcd8739ae039 = $6c9eaa7b073faa3a$var$resetOptionsInGroup;


var $e515b86d8a74e0b8$var$_excluded = [
    "children",
    "hasSeparator",
    "id",
    "isList",
    "isScrollable",
    "overrides",
    "testId",
    "title"
];
function $e515b86d8a74e0b8$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $e515b86d8a74e0b8$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $e515b86d8a74e0b8$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($c3ec97511ae1ed64$exports)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $e515b86d8a74e0b8$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $e515b86d8a74e0b8$export$a79eda4ff50e30b6 = /*#__PURE__*/ (0, $dAx5m.createContext)({
    id: "",
    radioGroupState: {},
    selectRadioItem: (0, $Bb0he.default)
});
/**
 * __Dropdown item radio group__
 *  Store which manages the selection state for each DropdownItemRadio
 *  across mount and unmounts.
 *
 */ var $e515b86d8a74e0b8$var$DropdownItemRadioGroup = function DropdownItemRadioGroup(_ref) {
    var children = _ref.children, hasSeparator = _ref.hasSeparator, id = _ref.id, isList = _ref.isList, isScrollable = _ref.isScrollable, overrides = _ref.overrides, testId = _ref.testId, title = _ref.title, rest = (0, (/*@__PURE__*/$parcel$interopDefault($74ed1cba0d5551e3$exports)))(_ref, $e515b86d8a74e0b8$var$_excluded);
    var _useContext = (0, $dAx5m.useContext)((0, $c180b9afe496357f$export$756f795847463ebd)), setGroupState = _useContext.setGroupState, getGroupState = _useContext.getGroupState;
    var uid = (0, $D9YLo.useUID)();
    var titleId = "dropdown-menu-item-radio-group-title-".concat(uid);
    /**
   *  - initially `radioGroupState` is from selection store, so it's safe to update without re-rendering
   *  - we flush a render by updating this local radio group state
   */ var _useState = (0, $dAx5m.useState)(function() {
        return getGroupState(id);
    }), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($6f4c9344050d46f7$exports)))(_useState, 2), radioGroupState = _useState2[0], setRadioGroupState = _useState2[1];
    var selectRadioItem = function selectRadioItem(childId, value) {
        var newValue = $e515b86d8a74e0b8$var$_objectSpread($e515b86d8a74e0b8$var$_objectSpread({}, (0, $6c9eaa7b073faa3a$export$2e2bcd8739ae039)(getGroupState(id))), {}, (0, (/*@__PURE__*/$parcel$interopDefault($c3ec97511ae1ed64$exports)))({}, childId, value));
        setRadioGroupState(newValue);
        setGroupState(id, newValue);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement($e515b86d8a74e0b8$export$a79eda4ff50e30b6.Provider, {
        value: {
            id: id,
            radioGroupState: radioGroupState,
            selectRadioItem: selectRadioItem
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $c98b8e1cfa1cc46d$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($5fb336a98f9116b4$exports)))({
        hasSeparator: hasSeparator,
        id: id,
        isList: isList,
        isScrollable: isScrollable,
        overrides: overrides,
        testId: testId,
        titleId: title ? titleId : undefined
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $941030332704d212$export$2e2bcd8739ae039), {
        id: titleId,
        title: title
    }), children));
};
var $e515b86d8a74e0b8$export$2e2bcd8739ae039 = $e515b86d8a74e0b8$var$DropdownItemRadioGroup;




function $6266ef33f479bebd$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $6266ef33f479bebd$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $6266ef33f479bebd$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($c3ec97511ae1ed64$exports)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $6266ef33f479bebd$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $6266ef33f479bebd$var$useRadioState(_ref) {
    var id = _ref.id, isSelected = _ref.isSelected, defaultSelected = _ref.defaultSelected;
    var _useContext = (0, $dAx5m.useContext)((0, $c180b9afe496357f$export$756f795847463ebd)), setGroupState = _useContext.setGroupState, getGroupState = _useContext.getGroupState;
    var _useContext2 = (0, $dAx5m.useContext)((0, $e515b86d8a74e0b8$export$a79eda4ff50e30b6)), group = _useContext2.id, radioGroupState = _useContext2.radioGroupState, selectRadioItem = _useContext2.selectRadioItem;
    var persistedIsSelected = radioGroupState[id];
    var _useState = (0, $dAx5m.useState)(function() {
        return persistedIsSelected !== undefined ? persistedIsSelected : defaultSelected || false;
    }), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($6f4c9344050d46f7$exports)))(_useState, 2), localIsSelected = _useState2[0], setLocalIsSelected = _useState2[1];
    var setLocalState = (0, $dAx5m.useCallback)(function(newValue) {
        if (!persistedIsSelected) {
            var nextValue = newValue(persistedIsSelected);
            selectRadioItem(id, nextValue);
            setLocalIsSelected(nextValue);
        }
    }, [
        persistedIsSelected,
        id,
        selectRadioItem
    ]);
    /**
   * - radio state changes any time a radio child is changed
   * - when it changes we want all radio buttons to update their local state
   * - it takes the value from radio group state and applies it locally if it exists which it will only exist, if it is selected
   */ (0, $dAx5m.useEffect)(function() {
        setLocalIsSelected(function() {
            var existing = radioGroupState[id];
            return existing !== undefined ? existing : defaultSelected || false;
        });
    }, [
        radioGroupState,
        group,
        id,
        defaultSelected
    ]);
    if (typeof isSelected === "boolean") return [
        isSelected,
        function() {
            return false;
        }
    ];
    if (persistedIsSelected === undefined) {
        var existing = getGroupState(group);
        setGroupState(group, $6266ef33f479bebd$var$_objectSpread($6266ef33f479bebd$var$_objectSpread({}, (0, $6c9eaa7b073faa3a$export$2e2bcd8739ae039)(existing || {})), {}, (0, (/*@__PURE__*/$parcel$interopDefault($c3ec97511ae1ed64$exports)))({}, id, defaultSelected || false)));
    }
    return [
        localIsSelected,
        setLocalState
    ];
}
var $6266ef33f479bebd$export$2e2bcd8739ae039 = $6266ef33f479bebd$var$useRadioState;



var $63a8b631436ee047$var$canUseDOM = function canUseDOM() {
    return Boolean(typeof window !== "undefined" && window.document && window.document.createElement);
};
/*
 * Making sure we can fallback to browsers doesn't support voice over -
 * we would using menuitemcheckbox / menuitemradio for these that supports voice over, and
 * will fallback to checkbox / radio for these doesn't
 */ var $63a8b631436ee047$var$isVoiceOverSupported = function isVoiceOverSupported() {
    return /Mac OS X/.test($63a8b631436ee047$var$canUseDOM() ? navigator.userAgent : "");
};
var $63a8b631436ee047$export$2e2bcd8739ae039 = $63a8b631436ee047$var$isVoiceOverSupported;



var $ahJoN = parcelRequire("ahJoN");
var $6c9ee6fa588d092c$var$_excluded = [
    "children",
    "defaultSelected",
    "testId",
    "id",
    "title",
    "description",
    "isDisabled",
    "isSelected",
    "onClick",
    "shouldDescriptionWrap",
    "shouldTitleWrap"
];
/**
 * __Dropdown item radio__
 *
 * A dropdown item radio displays groups that have a single selection.
 *
 * - [Examples](https://atlassian.design/components/dropdown-menu/dropdown-item-radio/examples)
 * - [Code](https://atlassian.design/components/dropdown-menu/dropdown-item-radio/code)
 * - [Usage](https://atlassian.design/components/dropdown-menu/dropdown-item-radio/usage)
 */ var $6c9ee6fa588d092c$var$DropdownItemRadio = function DropdownItemRadio(_ref) {
    var children = _ref.children, defaultSelected = _ref.defaultSelected, testId = _ref.testId, id = _ref.id, title = _ref.title, description = _ref.description, isDisabled = _ref.isDisabled, isSelected = _ref.isSelected, _ref$onClick = _ref.onClick, providedOnClick = _ref$onClick === void 0 ? (0, $Bb0he.default) : _ref$onClick, _ref$shouldDescriptio = _ref.shouldDescriptionWrap, shouldDescriptionWrap = _ref$shouldDescriptio === void 0 ? true : _ref$shouldDescriptio, _ref$shouldTitleWrap = _ref.shouldTitleWrap, shouldTitleWrap = _ref$shouldTitleWrap === void 0 ? true : _ref$shouldTitleWrap, rest = (0, (/*@__PURE__*/$parcel$interopDefault($74ed1cba0d5551e3$exports)))(_ref, $6c9ee6fa588d092c$var$_excluded);
    typeof $ahJoN;
    var _useRadioState = (0, $6266ef33f479bebd$export$2e2bcd8739ae039)({
        id: id,
        isSelected: isSelected,
        defaultSelected: defaultSelected
    }), _useRadioState2 = (0, (/*@__PURE__*/$parcel$interopDefault($6f4c9344050d46f7$exports)))(_useRadioState, 2), selected = _useRadioState2[0], setSelected = _useRadioState2[1];
    var onClickHandler = (0, $dAx5m.useCallback)(function(event) {
        setSelected(function(selected) {
            return !selected;
        });
        providedOnClick(event);
    }, [
        providedOnClick,
        setSelected
    ]);
    var itemRef = (0, $6579ef48703275a8$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $933ad5e8f7b65fc2$export$9ca534b70725964d).Provider, {
        value: "none"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $2e4fa2caee1a954e$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($5fb336a98f9116b4$exports)))({
        "aria-checked": selected,
        description: description,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $8bc1009402853642$export$2e2bcd8739ae039), {
            checked: selected
        }),
        id: id,
        isDisabled: isDisabled,
        isSelected: selected,
        onClick: onClickHandler,
        ref: itemRef,
        role: (0, $63a8b631436ee047$export$2e2bcd8739ae039)() ? "radio" : "menuitemradio",
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        testId: testId,
        title: title
    }, rest), children));
};
var $6c9ee6fa588d092c$export$2e2bcd8739ae039 = $6c9ee6fa588d092c$var$DropdownItemRadio;


var $9de6cb37cd68c504$exports = {};
"use strict";
Object.defineProperty($9de6cb37cd68c504$exports, "__esModule", {
    value: true
});
$9de6cb37cd68c504$exports.default = void 0;

var $9de6cb37cd68c504$var$_react = $9de6cb37cd68c504$var$_interopRequireDefault((parcelRequire("dAx5m")));

function $9de6cb37cd68c504$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $9de6cb37cd68c504$var$ChevronRightIcon = (props)=>/*#__PURE__*/ $9de6cb37cd68c504$var$_react.default.createElement($30d9f30932301ff5$export$f04a61298a47a40f, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path d="M10.294 9.698a.988.988 0 010-1.407 1.01 1.01 0 011.419 0l2.965 2.94a1.09 1.09 0 010 1.548l-2.955 2.93a1.01 1.01 0 01-1.42 0 .988.988 0 010-1.407l2.318-2.297-2.327-2.307z" fill="currentColor" fill-rule="evenodd"/></svg>`
    }, props));
$9de6cb37cd68c504$var$ChevronRightIcon.displayName = "ChevronRightIcon";
var $9de6cb37cd68c504$var$_default = $9de6cb37cd68c504$var$ChevronRightIcon;
$9de6cb37cd68c504$exports.default = $9de6cb37cd68c504$var$_default;





var $dAx5m = parcelRequire("dAx5m");

var $4c0eb9b92cd1e788$export$b00f7078b5893403 = function ThemeGlyph(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement("svg", (0, (/*@__PURE__*/$parcel$interopDefault($5fb336a98f9116b4$exports)))({
        width: "24",
        height: "24",
        viewBox: "0 0 24 24"
    }, props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12 20V4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20ZM12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z",
        fill: "currentColor"
    }));
};
function $4c0eb9b92cd1e788$export$e905b311491f0211(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $30d9f30932301ff5$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($5fb336a98f9116b4$exports)))({}, props, {
        glyph: $4c0eb9b92cd1e788$export$b00f7078b5893403
    }));
}


var $bd43d74785647dd7$exports = {};
$bd43d74785647dd7$exports = new URL("dark-mode.5b7c09da.svg", import.meta.url).toString();


var $82e7b5fc4390685f$exports = {};
$82e7b5fc4390685f$exports = new URL("light-mode.7f9eeb32.svg", import.meta.url).toString();


var $609643dc9d368a54$exports = {};
$609643dc9d368a54$exports = new URL("match-browser.cf8cedaf.svg", import.meta.url).toString();


var $cd1af3dbc7a012e6$var$_excluded = [
    "triggerRef"
];
var $cd1af3dbc7a012e6$export$9d63163ee2173b37 = function ThemeSwitcher(_ref) {
    var testId = _ref.testId, onThemeChange = _ref.onThemeChange, currentTheme = _ref.currentTheme;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $6103c59ea9e7b4c6$export$2e2bcd8739ae039), {
        testId: testId,
        placement: "auto-start",
        trigger: function trigger(_ref2) {
            var triggerRef = _ref2.triggerRef, props = (0, (/*@__PURE__*/$parcel$interopDefault($74ed1cba0d5551e3$exports)))(_ref2, $cd1af3dbc7a012e6$var$_excluded);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $2e4fa2caee1a954e$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($5fb336a98f9116b4$exports)))({
                ref: triggerRef,
                onClick: function onClick(event) {
                    return event.stopPropagation();
                },
                iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $4c0eb9b92cd1e788$export$e905b311491f0211), {
                    label: ""
                }),
                iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9de6cb37cd68c504$exports))), {
                    label: ""
                })
            }, props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $55TWT.default), {
                id: "identity.account-menu.theme-switcher.theme-button",
                defaultMessage: "Theme",
                description: "Label for button in the account menu to switch to a different theme"
            }));
        }
    }, $cd1af3dbc7a012e6$var$themeOptions.map(function(_ref3) {
        var label = _ref3.label, value = _ref3.value, thumbnail = _ref3.thumbnail;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $6c9ee6fa588d092c$export$2e2bcd8739ae039), {
            testId: "".concat(testId, "--radio-").concat(value),
            id: value,
            key: value,
            onClick: function onClick() {
                return onThemeChange(value);
            },
            isSelected: currentTheme === value
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement($cd1af3dbc7a012e6$var$RadioLabelContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement("img", {
            src: thumbnail,
            width: 64,
            height: 48,
            alt: ""
        }), label));
    }));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
var $cd1af3dbc7a012e6$var$RadioLabelContainer = (0, $ku6eE.default).div({
    display: "flex",
    alignItems: "center",
    gap: "var(--ds-space-150, 12px)"
});
var $cd1af3dbc7a012e6$var$messages = (0, $lKhJJ.defineMessages)({
    light: {
        id: "identity.account-menu.theme-switcher.light.option",
        defaultMessage: "Light",
        description: "Label for the theme switcher light option"
    },
    dark: {
        id: "identity.account-menu.theme-switcher.dark.option",
        defaultMessage: "Dark",
        description: "Label for the theme switcher dark option"
    },
    matchBrowser: {
        id: "identity.account-menu.theme-switcher.match-browser.option",
        defaultMessage: "Match browser",
        description: "Label for the theme switcher match browser option"
    }
});
var $cd1af3dbc7a012e6$var$themeOptions = [
    {
        label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $55TWT.default), $cd1af3dbc7a012e6$var$messages.light),
        value: "light",
        thumbnail: (0, (/*@__PURE__*/$parcel$interopDefault($82e7b5fc4390685f$exports)))
    },
    {
        label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $55TWT.default), $cd1af3dbc7a012e6$var$messages.dark),
        value: "dark",
        thumbnail: (0, (/*@__PURE__*/$parcel$interopDefault($bd43d74785647dd7$exports)))
    },
    {
        label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $55TWT.default), $cd1af3dbc7a012e6$var$messages.matchBrowser),
        value: "auto",
        thumbnail: (0, (/*@__PURE__*/$parcel$interopDefault($609643dc9d368a54$exports)))
    }
];


var $b94349345da8b714$var$_excluded = [
    "testId",
    "closePopup",
    "icon",
    "href",
    "onClick",
    "actionSubjectId",
    "children"
];
var $b94349345da8b714$export$49c2771125e1e9f1 = function AccountMenuContent(_ref) {
    var testId = _ref.testId, closePopup = _ref.closePopup, name = _ref.name, picture = _ref.picture, email = _ref.email, managedBy = _ref.managedBy, manageProfileLink = _ref.manageProfileLink, viewProfileLink = _ref.viewProfileLink, onViewProfileClick = _ref.onViewProfileClick, switchAccountLink = _ref.switchAccountLink, logOutLink = _ref.logOutLink, onThemeChange = _ref.onThemeChange, currentTheme = _ref.currentTheme;
    var themeSwitcherProps = onThemeChange && currentTheme;
    var shouldRenderProfileThemeSwitcherSection = Boolean(viewProfileLink || manageProfileLink || themeSwitcherProps);
    return (0, $jVTBW.jsx)($b94349345da8b714$var$Container, {
        "data-testid": testId
    }, (0, $jVTBW.jsx)((0, $47fb6f45f1898158$export$2e2bcd8739ae039), null, (0, $jVTBW.jsx)((0, $c98b8e1cfa1cc46d$export$2e2bcd8739ae039), null, (0, $jVTBW.jsx)((0, $97cba483d2d801e5$export$66e04d0aacdb3b2), {
        testId: testId && "".concat(testId, "--details"),
        name: name,
        picture: picture,
        email: email,
        managedBy: managedBy
    })), shouldRenderProfileThemeSwitcherSection && (0, $jVTBW.jsx)((0, $c98b8e1cfa1cc46d$export$2e2bcd8739ae039), null, viewProfileLink && (0, $jVTBW.jsx)($b94349345da8b714$var$ViewProfileLink, {
        onClick: onViewProfileClick,
        testId: testId && "".concat(testId, "--view-profile"),
        href: viewProfileLink,
        closePopup: closePopup
    }), manageProfileLink && (0, $jVTBW.jsx)($b94349345da8b714$var$ManageProfileLink, {
        testId: testId && "".concat(testId, "--manage-profile"),
        href: manageProfileLink,
        closePopup: closePopup
    }), themeSwitcherProps && (0, $jVTBW.jsx)((0, $cd1af3dbc7a012e6$export$9d63163ee2173b37), {
        testId: testId && "".concat(testId, "--theme-switcher"),
        onThemeChange: onThemeChange,
        currentTheme: currentTheme
    })), (0, $jVTBW.jsx)((0, $c98b8e1cfa1cc46d$export$2e2bcd8739ae039), {
        hasSeparator: shouldRenderProfileThemeSwitcherSection
    }, switchAccountLink && (0, $jVTBW.jsx)($b94349345da8b714$var$SwitchAccountLink, {
        testId: testId && "".concat(testId, "--switch-account"),
        href: switchAccountLink,
        closePopup: closePopup
    }), (0, $jVTBW.jsx)($b94349345da8b714$var$LogOutLink, {
        testId: testId && "".concat(testId, "--log-out"),
        href: logOutLink,
        closePopup: closePopup
    }))));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
var $b94349345da8b714$var$Container = (0, $ku6eE.default).div({
    boxSizing: "border-box",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    minWidth: (0, $fadf80e9637982ea$export$6d8204c2cb2e06b8)() * 38
});
var $b94349345da8b714$var$ViewProfileLink = function ViewProfileLink(_ref2) {
    var testId = _ref2.testId, href = _ref2.href, onClick = _ref2.onClick, closePopup = _ref2.closePopup;
    return (0, $jVTBW.jsx)($b94349345da8b714$var$Link, {
        testId: testId,
        href: href,
        onClick: onClick,
        icon: (0, $3b69844328934482$export$7dcc8f518762622d),
        closePopup: closePopup,
        actionSubjectId: "viewProfileLink"
    }, (0, $jVTBW.jsx)((0, $55TWT.default), {
        id: "identity.account-menu.account-details.view-profile-tooltip",
        defaultMessage: "Profile",
        description: "Text shown when hovering over profile information"
    }));
};
var $b94349345da8b714$var$ManageProfileLink = function ManageProfileLink(_ref3) {
    var testId = _ref3.testId, href = _ref3.href, closePopup = _ref3.closePopup;
    return (0, $jVTBW.jsx)($b94349345da8b714$var$Link, {
        testId: testId,
        href: href,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($e3afb069315125ed$exports))),
        closePopup: closePopup,
        actionSubjectId: "manageProfileLink",
        target: "_blank",
        rel: "noopener"
    }, (0, $jVTBW.jsx)((0, $55TWT.default), {
        id: "identity.account-menu.account-details.manage-profile-link",
        defaultMessage: "Account settings",
        description: "Text for link to account management page"
    }));
};
var $b94349345da8b714$var$SwitchAccountLink = function SwitchAccountLink(_ref4) {
    var testId = _ref4.testId, href = _ref4.href, closePopup = _ref4.closePopup;
    return (0, $jVTBW.jsx)($b94349345da8b714$var$Link, {
        testId: testId,
        icon: (0, $f237dd7f3fa74295$export$a0096b57009ecc7c),
        href: href,
        closePopup: closePopup,
        actionSubjectId: "switchAccountLink"
    }, (0, $jVTBW.jsx)((0, $55TWT.default), {
        id: "identity.account-menu.account-menu-content.switch-account-button",
        defaultMessage: "Switch account",
        description: "Label for button in account menu to switch to another another account"
    }));
};
var $b94349345da8b714$var$LogOutLink = function LogOutLink(_ref5) {
    var testId = _ref5.testId, href = _ref5.href, closePopup = _ref5.closePopup;
    return (0, $jVTBW.jsx)($b94349345da8b714$var$Link, {
        testId: testId,
        icon: (0, $1037cc0f3b5d69db$export$5bb2595dc31bfece),
        href: href,
        closePopup: closePopup,
        actionSubjectId: "logOutLink"
    }, (0, $jVTBW.jsx)((0, $55TWT.default), {
        id: "identity.account-menu.account-menu-content.log-out-button",
        defaultMessage: "Log out",
        description: "Label for button in account menu to log out"
    }));
};
var $b94349345da8b714$var$Link = function Link(_ref6) {
    var testId = _ref6.testId, closePopup = _ref6.closePopup, Icon = _ref6.icon, href = _ref6.href, onClick = _ref6.onClick, actionSubjectId = _ref6.actionSubjectId, children = _ref6.children, props = (0, (/*@__PURE__*/$parcel$interopDefault($74ed1cba0d5551e3$exports)))(_ref6, $b94349345da8b714$var$_excluded);
    var _useAnalyticsEvents = (0, $2d5fdfa21a1e72e4$export$5bf35293e545f20c)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    var handleClick = (0, $dAx5m.useCallback)(function(event) {
        var analyticsEvent = createAnalyticsEvent({
            eventType: (0, $3FJlW.UI_EVENT_TYPE),
            action: "clicked",
            actionSubject: "menuLinkItem",
            actionSubjectId: actionSubjectId
        });
        var clone = analyticsEvent.clone();
        if (clone) clone.fire((0, $40ee9209af546b3a$export$515664faa1398f37));
        onClick === null || onClick === void 0 || onClick(event, analyticsEvent);
        closePopup === null || closePopup === void 0 || closePopup(event);
    }, [
        createAnalyticsEvent,
        onClick,
        closePopup,
        actionSubjectId
    ]);
    return (0, $jVTBW.jsx)((0, $f86a902fec23069e$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($5fb336a98f9116b4$exports)))({
        testId: testId,
        iconBefore: (0, $jVTBW.jsx)(Icon, {
            label: "",
            size: "medium"
        }),
        href: href,
        onClick: handleClick
    }, props), children);
};


var $8f2b723d5b51e4f7$exports = {};
function $8f2b723d5b51e4f7$var$asyncGeneratorStep(n, t, e, r, o, a, c) {
    try {
        var i = n[a](c), u = i.value;
    } catch (n) {
        return void e(n);
    }
    i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function $8f2b723d5b51e4f7$var$_asyncToGenerator(n) {
    return function() {
        var t = this, e = arguments;
        return new Promise(function(r, o) {
            var a = n.apply(t, e);
            function _next(n) {
                $8f2b723d5b51e4f7$var$asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
            }
            function _throw(n) {
                $8f2b723d5b51e4f7$var$asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
            }
            _next(void 0);
        });
    };
}
$8f2b723d5b51e4f7$exports = $8f2b723d5b51e4f7$var$_asyncToGenerator, $8f2b723d5b51e4f7$exports.__esModule = true, $8f2b723d5b51e4f7$exports["default"] = $8f2b723d5b51e4f7$exports;



var $affac11a746f10ac$exports = {};
// TODO(Babel 8): Remove this file.

var $affac11a746f10ac$var$runtime = (parcelRequire("hpAWv"))();
$affac11a746f10ac$exports = $affac11a746f10ac$var$runtime;
// Copied from https://github.com/facebook/regenerator/blob/main/packages/runtime/runtime.js#L736=
try {
    regeneratorRuntime = $affac11a746f10ac$var$runtime;
} catch (accidentalStrictMode) {
    if (typeof globalThis === "object") globalThis.regeneratorRuntime = $affac11a746f10ac$var$runtime;
    else Function("r", "regeneratorRuntime = r")($affac11a746f10ac$var$runtime);
}



var $dAx5m = parcelRequire("dAx5m");

var $6PkJI = parcelRequire("6PkJI");
var $dZHnD = parcelRequire("dZHnD");
/**
 * NOTE:
 *
 * This file is automatically generated by scripts/generate-i18n-index.ts.
 * DO NOT UPDATE IT BY HAND. Instead, run yarn generate-i18n-index.
 */ 










































var $b2d9efab42071c00$var$lazyMessages = {
    cs: function cs() {
        return (parcelRequire("8u31q"));
    },
    cs_CZ: function cs_CZ() {
        return (parcelRequire("lMEsk"));
    },
    da: function da() {
        return (parcelRequire("8h2kf"));
    },
    da_DK: function da_DK() {
        return (parcelRequire("aBFrD"));
    },
    de: function de() {
        return (parcelRequire("hEJhY"));
    },
    de_DE: function de_DE() {
        return (parcelRequire("kOMMf"));
    },
    en_GB: function en_GB() {
        return (parcelRequire("6twDR"));
    },
    en_ZZ: function en_ZZ() {
        return (parcelRequire("9EScH"));
    },
    es: function es() {
        return (parcelRequire("B0V72"));
    },
    fi: function fi() {
        return (parcelRequire("58rxg"));
    },
    fi_FI: function fi_FI() {
        return (parcelRequire("bt008"));
    },
    fr: function fr() {
        return (parcelRequire("4JghM"));
    },
    fr_FR: function fr_FR() {
        return (parcelRequire("cYfKv"));
    },
    hu: function hu() {
        return (parcelRequire("8J6nR"));
    },
    hu_HU: function hu_HU() {
        return (parcelRequire("4RDQH"));
    },
    it: function it() {
        return (parcelRequire("lihf4"));
    },
    it_IT: function it_IT() {
        return (parcelRequire("afAPz"));
    },
    ja: function ja() {
        return (parcelRequire("2BGl2"));
    },
    ja_JP: function ja_JP() {
        return (parcelRequire("byplY"));
    },
    ko: function ko() {
        return (parcelRequire("9JFVt"));
    },
    ko_KR: function ko_KR() {
        return (parcelRequire("khJ4d"));
    },
    nb: function nb() {
        return (parcelRequire("hs2Qn"));
    },
    nb_NO: function nb_NO() {
        return (parcelRequire("7p1Dq"));
    },
    nl: function nl() {
        return (parcelRequire("bRM5R"));
    },
    nl_NL: function nl_NL() {
        return (parcelRequire("dOF23"));
    },
    pl: function pl() {
        return (parcelRequire("js7SL"));
    },
    pl_PL: function pl_PL() {
        return (parcelRequire("lunyD"));
    },
    pt_BR: function pt_BR() {
        return (parcelRequire("71avd"));
    },
    ru: function ru() {
        return (parcelRequire("gfBBl"));
    },
    ru_RU: function ru_RU() {
        return (parcelRequire("9QL9F"));
    },
    sv: function sv() {
        return (parcelRequire("ixHD9"));
    },
    sv_SE: function sv_SE() {
        return (parcelRequire("6y6dX"));
    },
    th: function th() {
        return (parcelRequire("cEcSp"));
    },
    th_TH: function th_TH() {
        return (parcelRequire("90epT"));
    },
    tr: function tr() {
        return (parcelRequire("deegU"));
    },
    tr_TR: function tr_TR() {
        return (parcelRequire("5Sz54"));
    },
    uk: function uk() {
        return (parcelRequire("9lnnk"));
    },
    uk_UA: function uk_UA() {
        return (parcelRequire("b0v1B"));
    },
    vi: function vi() {
        return (parcelRequire("2chS9"));
    },
    vi_VN: function vi_VN() {
        return (parcelRequire("69bNn"));
    },
    zh: function zh() {
        return (parcelRequire("3pg1P"));
    },
    zh_CN: function zh_CN() {
        return (parcelRequire("7e3IE"));
    },
    zh_TW: function zh_TW() {
        return (parcelRequire("bKBIG"));
    }
};
var $b2d9efab42071c00$export$2e2bcd8739ae039 = $b2d9efab42071c00$var$lazyMessages;


var $4dcdcf79f1936c12$export$6c1f1571e3dd1b34 = function AccountMenuIntlProvider(_ref) {
    var children = _ref.children;
    var _useIntl = (0, $dZHnD.default)(), locale = _useIntl.locale;
    var messages = $4dcdcf79f1936c12$var$useMessages(locale);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $6PkJI.default), {
        locale: locale,
        messages: messages
    }, children);
};
var $4dcdcf79f1936c12$var$useMessages = function useMessages(locale) {
    var _useState = (0, $dAx5m.useState)(), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($6f4c9344050d46f7$exports)))(_useState, 2), messages = _useState2[0], setMessages = _useState2[1];
    (0, $dAx5m.useEffect)(function() {
        if (/^en(-US)?$/i.exec(locale)) // Use fallback messages, which are already US English
        setMessages(undefined);
        else {
            var cancelled = false;
            $4dcdcf79f1936c12$var$loadMessages(locale).catch(function(_error) {
                return undefined;
            }) // TODO: Log error somehow (analytics?)
            .then(function(messages) {
                if (!cancelled) setMessages(messages);
            });
            return function() {
                cancelled = true;
            };
        }
    }, [
        locale,
        setMessages
    ]);
    return messages;
};
var $4dcdcf79f1936c12$var$loadMessages = /*#__PURE__*/ function() {
    var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($8f2b723d5b51e4f7$exports)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($affac11a746f10ac$exports))).mark(function _callee(locale) {
        var _yield, _ref3;
        var _locale$split, _locale$split2, language, _locale$split2$, region;
        return (0, (/*@__PURE__*/$parcel$interopDefault($affac11a746f10ac$exports))).wrap(function _callee$(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    _locale$split = locale.split("-", 2), _locale$split2 = (0, (/*@__PURE__*/$parcel$interopDefault($6f4c9344050d46f7$exports)))(_locale$split, 2), language = _locale$split2[0], _locale$split2$ = _locale$split2[1], region = _locale$split2$ === void 0 ? "" : _locale$split2$;
                    language = language.toLowerCase();
                    region = region.toUpperCase();
                    _context.next = 5;
                    return (_ref3 = (0, $b2d9efab42071c00$export$2e2bcd8739ae039)["".concat(language, "_").concat(region)] || (0, $b2d9efab42071c00$export$2e2bcd8739ae039)[language]) === null || _ref3 === void 0 ? void 0 : _ref3();
                case 5:
                    _context.t1 = _yield = _context.sent;
                    _context.t0 = _context.t1 === null;
                    if (_context.t0) {
                        _context.next = 9;
                        break;
                    }
                    _context.t0 = _yield === void 0;
                case 9:
                    if (!_context.t0) {
                        _context.next = 13;
                        break;
                    }
                    _context.t2 = void 0;
                    _context.next = 14;
                    break;
                case 13:
                    _context.t2 = _yield.default;
                case 14:
                    return _context.abrupt("return", _context.t2);
                case 15:
                case "end":
                    return _context.stop();
            }
        }, _callee);
    }));
    return function loadMessages(_x) {
        return _ref2.apply(this, arguments);
    };
}();



var $dAx5m = parcelRequire("dAx5m");

var $55TWT = parcelRequire("55TWT");


var $dAx5m = parcelRequire("dAx5m");



var $dAx5m = parcelRequire("dAx5m");





var $dAx5m = parcelRequire("dAx5m");


var $dAx5m = parcelRequire("dAx5m");
var $85e232228bb3a8ca$var$_excluded = [
    "children"
];
function $85e232228bb3a8ca$export$25d302a5b900a763(defaultGetTokens) {
    var emptyThemeFn = function emptyThemeFn(getTokens, props) {
        return getTokens(props);
    };
    /**
   * Internally, Theme uses React Context, with internal providers and consumers.
   * The React Context passes only a function that gets props, and turns them into tokens. This
   * function gets mixed as more Providers with their own themes are added. This mixed function
   * is ultimately picked up by Consumers, which implement a context consumer internally to fetch
   * the theme.
   */ var ThemeContext = /*#__PURE__*/ (0, $dAx5m.createContext)(defaultGetTokens);
    function useTheme(themeProps) {
        var theme = (0, $dAx5m.useContext)(ThemeContext);
        var themeFn = theme || emptyThemeFn;
        var tokens = themeFn(themeProps);
        return tokens;
    }
    // The Theme Consumer takes a function as its child - this function takes tokens, and the
    // return value is generally a set of nodes with the tokens applied appropriately.
    function Consumer(props) {
        var children = props.children, themeProps = (0, (/*@__PURE__*/$parcel$interopDefault($74ed1cba0d5551e3$exports)))(props, $85e232228bb3a8ca$var$_excluded);
        // @ts-ignore See issue for more info: https://github.com/Microsoft/TypeScript/issues/10727
        // Argument of type 'Pick<ThemeProps & { children: (tokens: ThemeTokens) => ReactNode; }, Exclude<keyof ThemeProps, "children">>' is not assignable to parameter of type 'ThemeProps'.ts(2345)
        var tokens = useTheme(themeProps);
        // We add a fragment to ensure we don't break people upgrading.
        // Previously they may have been able to pass in undefined without things blowing up.
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).Fragment, null, children(tokens));
    }
    /**
   * The Theme Provider takes regular nodes as its children, but also takes a *theme function*
   * - The theme function takes a set of props, as well as a function (getTokens) that can turn props into tokens.
   * - The getTokens function isn't called immediately - instead the props are passed
   *    through a mix of parent theming functions
   * Children of this provider will receive this mixed theme
   */ function Provider(props) {
        var themeFn = (0, $dAx5m.useContext)(ThemeContext);
        var valueFn = props.value || emptyThemeFn;
        var mixedFn = (0, $dAx5m.useCallback)(function(themeProps) {
            return valueFn(themeFn, themeProps);
        }, [
            themeFn,
            valueFn
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement(ThemeContext.Provider, {
            value: mixedFn
        }, props.children);
    }
    return {
        Consumer: Consumer,
        Provider: Provider,
        useTheme: useTheme
    };
}


// Create default global light theme
var $9134e79d86294f0e$var$_createTheme = (0, $85e232228bb3a8ca$export$25d302a5b900a763)(function() {
    return {
        mode: "light"
    };
}), $9134e79d86294f0e$var$Provider = $9134e79d86294f0e$var$_createTheme.Provider, $9134e79d86294f0e$var$Consumer = $9134e79d86294f0e$var$_createTheme.Consumer, $9134e79d86294f0e$export$7692396083754928 = $9134e79d86294f0e$var$_createTheme.useTheme;
var $9134e79d86294f0e$var$Theme = {
    Provider: $9134e79d86294f0e$var$Provider,
    Consumer: $9134e79d86294f0e$var$Consumer
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$9134e79d86294f0e$export$2e2bcd8739ae039 = $9134e79d86294f0e$var$Theme;





var $dAx5m = parcelRequire("dAx5m");

var $jVTBW = parcelRequire("jVTBW");


var $dAx5m = parcelRequire("dAx5m");


var $dAx5m = parcelRequire("dAx5m");
var $0ddd60ae48921ba1$export$1d27a74659855e44 = function useTrackedRef(value) {
    var ref = (0, $dAx5m.useRef)(value);
    ref.current = value;
    return ref;
};


function $931ed1ff12a9e285$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $931ed1ff12a9e285$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $931ed1ff12a9e285$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($c3ec97511ae1ed64$exports)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $931ed1ff12a9e285$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $931ed1ff12a9e285$export$a4687b0234b40e28(_ref) {
    var fn = _ref.fn, action = _ref.action, componentName = _ref.componentName, actionSubject = _ref.actionSubject, packageName = _ref.packageName, packageVersion = _ref.packageVersion, analyticsData = _ref.analyticsData;
    var _useAnalyticsEvents = (0, $2d5fdfa21a1e72e4$export$5bf35293e545f20c)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    // We put analyticsData and fn in a ref so that we don't need to break
    // memoization.
    // Generally these could be defined by consumers inline
    // and so we do this to avoid breaking memoization of useCallback
    var dataRef = (0, $0ddd60ae48921ba1$export$1d27a74659855e44)(analyticsData);
    var fnRef = (0, $0ddd60ae48921ba1$export$1d27a74659855e44)(fn);
    var handler = (0, $dAx5m.useCallback)(function(value) {
        var analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: actionSubject || componentName,
            attributes: {
                componentName: componentName,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
        // To avoid wrapping this component in AnalyticsContext we manually
        // push the parent context's meta data into the context.
        // Note: this new 'context'
        var context = $931ed1ff12a9e285$var$_objectSpread({
            componentName: componentName,
            packageName: packageName,
            packageVersion: packageVersion
        }, dataRef.current);
        analyticsEvent.context.push(context);
        // fire an event on the atlaskit channel
        var clone = analyticsEvent.clone();
        if (clone) clone.fire("atlaskit");
        fnRef.current(value, analyticsEvent);
    }, [
        // These are strings and won't change
        action,
        componentName,
        actionSubject,
        packageName,
        packageVersion,
        // This function is memoized in the context
        createAnalyticsEvent,
        // these are a stable ref because of the useTrackedRef hook
        dataRef,
        fnRef
    ]);
    return handler;
}



var $Bb0he = parcelRequire("Bb0he");

var $gMIYi = parcelRequire("gMIYi");

var $iAyBE = parcelRequire("iAyBE");

var $kqsmh = parcelRequire("kqsmh");

function $566d1569f272cc49$var$abort(event) {
    event.preventDefault();
    event.stopPropagation();
}
var $566d1569f272cc49$var$tabKeyCode = 9;
function $566d1569f272cc49$var$onKey(event) {
    // Allowing tab so that a user can move focus away
    if (event.keyCode === $566d1569f272cc49$var$tabKeyCode) return;
    $566d1569f272cc49$var$abort(event);
}
var $566d1569f272cc49$var$block = {
    onMouseDownCapture: $566d1569f272cc49$var$abort,
    onMouseUpCapture: $566d1569f272cc49$var$abort,
    // because we have tabIndex = -1 when disabled,
    // keyboard events can only occur when there is an overlay
    onKeyDownCapture: $566d1569f272cc49$var$onKey,
    onKeyUpCapture: $566d1569f272cc49$var$onKey,
    onTouchStartCapture: $566d1569f272cc49$var$abort,
    onTouchEndCapture: $566d1569f272cc49$var$abort,
    onPointerDownCapture: $566d1569f272cc49$var$abort,
    onPointerUpCapture: $566d1569f272cc49$var$abort,
    onClickCapture: $566d1569f272cc49$var$abort,
    // Just smashing the existing onClick for good measure
    onClick: $566d1569f272cc49$var$abort
};
var $566d1569f272cc49$var$doNotBlock = {};
function $566d1569f272cc49$export$2e2bcd8739ae039(_ref) {
    var isInteractive = _ref.isInteractive;
    return isInteractive ? $566d1569f272cc49$var$doNotBlock : $566d1569f272cc49$var$block;
}




var $jVTBW = parcelRequire("jVTBW");

var $jAmv0 = parcelRequire("jAmv0");


// Hard coding the active rgba color value rather than using a helper to convert it
// With helper it would be: hex2rgba(colors.B75, 0.6)
var $ef1ded8600d16419$var$fadedB75 = "rgba(179, 212, 255, 0.6)";
var $ef1ded8600d16419$var$values = {
    // Default appearance
    background: {
        default: {
            default: {
                light: "var(--ds-background-neutral, ".concat($e996865a8c4821b6$export$8d43898f60b96a82, ")"),
                dark: "var(--ds-background-neutral, ".concat($e996865a8c4821b6$export$d281fbfe3cff2df6, ")")
            },
            hover: {
                light: "var(--ds-background-neutral-hovered, ".concat($e996865a8c4821b6$export$920c0d5c49070351, ")"),
                dark: "var(--ds-background-neutral-hovered, ".concat($e996865a8c4821b6$export$3902c91d8b98a753, ")")
            },
            active: {
                light: "var(--ds-background-neutral-pressed, ".concat($ef1ded8600d16419$var$fadedB75, ")"),
                dark: "var(--ds-background-neutral-pressed, ".concat($e996865a8c4821b6$export$8c13c2ee36917869, ")")
            },
            disabled: {
                light: "var(--ds-background-disabled, ".concat($e996865a8c4821b6$export$8d43898f60b96a82, ")"),
                dark: "var(--ds-background-disabled, ".concat($e996865a8c4821b6$export$d281fbfe3cff2df6, ")")
            },
            selected: {
                light: "var(--ds-background-selected, ".concat($e996865a8c4821b6$export$ad0bacf983b7ddaa, ")"),
                dark: "var(--ds-background-selected, ".concat($e996865a8c4821b6$export$3d4f271a500072a, ")")
            },
            focusSelected: {
                light: "var(--ds-background-selected, ".concat($e996865a8c4821b6$export$ad0bacf983b7ddaa, ")"),
                dark: "var(--ds-background-selected, ".concat($e996865a8c4821b6$export$3d4f271a500072a, ")")
            }
        },
        primary: {
            default: {
                light: "var(--ds-background-brand-bold, ".concat($e996865a8c4821b6$export$b3de0ae08da2ce64, ")"),
                dark: "var(--ds-background-brand-bold, ".concat($e996865a8c4821b6$export$ecfc1dff386a3e7a, ")")
            },
            hover: {
                light: "var(--ds-background-brand-bold-hovered, ".concat($e996865a8c4821b6$export$e62e8919cca44969, ")"),
                dark: "var(--ds-background-brand-bold-hovered, ".concat($e996865a8c4821b6$export$8c13c2ee36917869, ")")
            },
            active: {
                light: "var(--ds-background-brand-bold-pressed, ".concat($e996865a8c4821b6$export$a6ee3d71bc067634, ")"),
                dark: "var(--ds-background-brand-bold-pressed, ".concat($e996865a8c4821b6$export$215b7063051591f1, ")")
            },
            disabled: {
                light: "var(--ds-background-disabled, ".concat($e996865a8c4821b6$export$8d43898f60b96a82, ")"),
                dark: "var(--ds-background-disabled, ".concat($e996865a8c4821b6$export$d281fbfe3cff2df6, ")")
            },
            selected: {
                light: "var(--ds-background-selected, ".concat($e996865a8c4821b6$export$ad0bacf983b7ddaa, ")"),
                dark: "var(--ds-background-selected, ".concat($e996865a8c4821b6$export$3d4f271a500072a, ")")
            },
            focusSelected: {
                light: "var(--ds-background-selected, ".concat($e996865a8c4821b6$export$ad0bacf983b7ddaa, ")"),
                dark: "var(--ds-background-selected, ".concat($e996865a8c4821b6$export$3d4f271a500072a, ")")
            }
        },
        warning: {
            default: {
                light: "var(--ds-background-warning-bold, ".concat($e996865a8c4821b6$export$c6930421db9fa514, ")"),
                dark: "var(--ds-background-warning-bold, ".concat($e996865a8c4821b6$export$c6930421db9fa514, ")")
            },
            hover: {
                light: "var(--ds-background-warning-bold-hovered, ".concat($e996865a8c4821b6$export$5aae31392d72caaa, ")"),
                dark: "var(--ds-background-warning-bold-hovered, ".concat($e996865a8c4821b6$export$5aae31392d72caaa, ")")
            },
            active: {
                light: "var(--ds-background-warning-bold-pressed, ".concat($e996865a8c4821b6$export$59619663aa6500fb, ")"),
                dark: "var(--ds-background-warning-bold-pressed, ".concat($e996865a8c4821b6$export$59619663aa6500fb, ")")
            },
            disabled: {
                light: "var(--ds-background-disabled, ".concat($e996865a8c4821b6$export$8d43898f60b96a82, ")"),
                dark: "var(--ds-background-disabled, ".concat($e996865a8c4821b6$export$d281fbfe3cff2df6, ")")
            },
            selected: {
                light: "var(--ds-background-selected, ".concat($e996865a8c4821b6$export$59619663aa6500fb, ")"),
                dark: "var(--ds-background-selected, ".concat($e996865a8c4821b6$export$59619663aa6500fb, ")")
            },
            focusSelected: {
                light: "var(--ds-background-selected, ".concat($e996865a8c4821b6$export$59619663aa6500fb, ")"),
                dark: "var(--ds-background-selected, ".concat($e996865a8c4821b6$export$59619663aa6500fb, ")")
            }
        },
        danger: {
            default: {
                light: "var(--ds-background-danger-bold, ".concat($e996865a8c4821b6$export$2010d0fb4295b346, ")"),
                dark: "var(--ds-background-danger-bold, ".concat($e996865a8c4821b6$export$2010d0fb4295b346, ")")
            },
            hover: {
                light: "var(--ds-background-danger-bold-hovered, ".concat($e996865a8c4821b6$export$4a7404f376229999, ")"),
                dark: "var(--ds-background-danger-bold-hovered, ".concat($e996865a8c4821b6$export$4a7404f376229999, ")")
            },
            active: {
                light: "var(--ds-background-danger-bold-pressed, ".concat($e996865a8c4821b6$export$2837b5a1a71d5c02, ")"),
                dark: "var(--ds-background-danger-bold-pressed, ".concat($e996865a8c4821b6$export$2837b5a1a71d5c02, ")")
            },
            disabled: {
                light: "var(--ds-background-disabled, ".concat($e996865a8c4821b6$export$8d43898f60b96a82, ")"),
                dark: "var(--ds-background-disabled, ".concat($e996865a8c4821b6$export$d281fbfe3cff2df6, ")")
            },
            selected: {
                light: "var(--ds-background-selected, ".concat($e996865a8c4821b6$export$2837b5a1a71d5c02, ")"),
                dark: "var(--ds-background-selected, ".concat($e996865a8c4821b6$export$2837b5a1a71d5c02, ")")
            },
            focusSelected: {
                light: "var(--ds-background-selected, ".concat($e996865a8c4821b6$export$2837b5a1a71d5c02, ")"),
                dark: "var(--ds-background-selected, ".concat($e996865a8c4821b6$export$2837b5a1a71d5c02, ")")
            }
        },
        link: {
            default: {
                light: "var(--ds-background-neutral-subtle, none)",
                dark: "var(--ds-background-neutral-subtle, none)"
            },
            selected: {
                light: "var(--ds-background-selected, ".concat($e996865a8c4821b6$export$ad0bacf983b7ddaa, ")"),
                dark: "var(--ds-background-selected, ".concat($e996865a8c4821b6$export$9fdfb749e33cdf97, ")")
            },
            focusSelected: {
                light: "var(--ds-background-selected, ".concat($e996865a8c4821b6$export$ad0bacf983b7ddaa, ")"),
                dark: "var(--ds-background-selected, ".concat($e996865a8c4821b6$export$9fdfb749e33cdf97, ")")
            }
        },
        subtle: {
            default: {
                light: "var(--ds-background-neutral-subtle, none)",
                dark: "var(--ds-background-neutral-subtle, none)"
            },
            hover: {
                light: "var(--ds-background-neutral-subtle-hovered, ".concat($e996865a8c4821b6$export$920c0d5c49070351, ")"),
                dark: "var(--ds-background-neutral-subtle-hovered, ".concat($e996865a8c4821b6$export$3902c91d8b98a753, ")")
            },
            active: {
                light: "var(--ds-background-neutral-subtle-pressed, ".concat($ef1ded8600d16419$var$fadedB75, ")"),
                dark: "var(--ds-background-neutral-subtle-pressed, ".concat($e996865a8c4821b6$export$8c13c2ee36917869, ")")
            },
            disabled: {
                light: "var(--ds-background-neutral-subtle, none)",
                dark: "var(--ds-background-neutral-subtle, none)"
            },
            selected: {
                light: "var(--ds-background-selected, ".concat($e996865a8c4821b6$export$ad0bacf983b7ddaa, ")"),
                dark: "var(--ds-background-selected, ".concat($e996865a8c4821b6$export$3d4f271a500072a, ")")
            },
            focusSelected: {
                light: "var(--ds-background-selected, ".concat($e996865a8c4821b6$export$ad0bacf983b7ddaa, ")"),
                dark: "var(--ds-background-selected, ".concat($e996865a8c4821b6$export$3d4f271a500072a, ")")
            }
        },
        "subtle-link": {
            default: {
                light: "var(--ds-background-neutral-subtle, none)",
                dark: "var(--ds-background-neutral-subtle, none)"
            },
            selected: {
                light: "var(--ds-background-selected, ".concat($e996865a8c4821b6$export$ad0bacf983b7ddaa, ")"),
                dark: "var(--ds-background-selected, ".concat($e996865a8c4821b6$export$9fdfb749e33cdf97, ")")
            },
            focusSelected: {
                light: "var(--ds-background-selected, ".concat($e996865a8c4821b6$export$ad0bacf983b7ddaa, ")"),
                dark: "var(--ds-background-selected, ".concat($e996865a8c4821b6$export$9fdfb749e33cdf97, ")")
            }
        }
    },
    color: {
        default: {
            default: {
                light: "var(--ds-text, ".concat($e996865a8c4821b6$export$c39c0fe0f26207ae, ")"),
                dark: "var(--ds-text, ".concat($e996865a8c4821b6$export$abcf8c38338b4aa5, ")")
            },
            active: {
                light: "var(--ds-text, ".concat($e996865a8c4821b6$export$b3de0ae08da2ce64, ")"),
                dark: "var(--ds-text, ".concat($e996865a8c4821b6$export$b3de0ae08da2ce64, ")")
            },
            disabled: {
                light: "var(--ds-text-disabled, ".concat($e996865a8c4821b6$export$5f71e19f3a7ad9de, ")"),
                dark: "var(--ds-text-disabled, ".concat($e996865a8c4821b6$export$633847cf062b69e0, ")")
            },
            selected: {
                light: "var(--ds-text-selected, ".concat($e996865a8c4821b6$export$9fdfb749e33cdf97, ")"),
                dark: "var(--ds-text-selected, ".concat($e996865a8c4821b6$export$abcf8c38338b4aa5, ")")
            },
            focusSelected: {
                light: "var(--ds-text-selected, ".concat($e996865a8c4821b6$export$9fdfb749e33cdf97, ")"),
                dark: "var(--ds-text-selected, ".concat($e996865a8c4821b6$export$abcf8c38338b4aa5, ")")
            }
        },
        primary: {
            default: {
                light: "var(--ds-text-inverse, ".concat($e996865a8c4821b6$export$29a4f05edc054374, ")"),
                dark: "var(--ds-text-inverse, ".concat($e996865a8c4821b6$export$633847cf062b69e0, ")")
            },
            disabled: {
                light: "var(--ds-text-disabled, ".concat($e996865a8c4821b6$export$5f71e19f3a7ad9de, ")"),
                dark: "var(--ds-text-disabled, ".concat($e996865a8c4821b6$export$633847cf062b69e0, ")")
            },
            selected: {
                light: "var(--ds-text-selected, ".concat($e996865a8c4821b6$export$9fdfb749e33cdf97, ")"),
                dark: "var(--ds-text-selected, ".concat($e996865a8c4821b6$export$abcf8c38338b4aa5, ")")
            },
            focusSelected: {
                light: "var(--ds-text-selected, ".concat($e996865a8c4821b6$export$9fdfb749e33cdf97, ")"),
                dark: "var(--ds-text-selected, ".concat($e996865a8c4821b6$export$abcf8c38338b4aa5, ")")
            }
        },
        warning: {
            default: {
                light: "var(--ds-text-warning-inverse, ".concat($e996865a8c4821b6$export$7d61b15e0da132af, ")"),
                dark: "var(--ds-text-warning-inverse, ".concat($e996865a8c4821b6$export$7d61b15e0da132af, ")")
            },
            disabled: {
                light: "var(--ds-text-disabled, ".concat($e996865a8c4821b6$export$5f71e19f3a7ad9de, ")"),
                dark: "var(--ds-text-disabled, ".concat($e996865a8c4821b6$export$633847cf062b69e0, ")")
            },
            selected: {
                light: "var(--ds-text-selected, ".concat($e996865a8c4821b6$export$7d61b15e0da132af, ")"),
                dark: "var(--ds-text-selected, ".concat($e996865a8c4821b6$export$7d61b15e0da132af, ")")
            },
            focusSelected: {
                light: "var(--ds-text-selected, ".concat($e996865a8c4821b6$export$7d61b15e0da132af, ")"),
                dark: "var(--ds-text-selected, ".concat($e996865a8c4821b6$export$7d61b15e0da132af, ")")
            }
        },
        danger: {
            default: {
                light: "var(--ds-text-inverse, ".concat($e996865a8c4821b6$export$29a4f05edc054374, ")"),
                dark: "var(--ds-text-inverse, ".concat($e996865a8c4821b6$export$29a4f05edc054374, ")")
            },
            disabled: {
                light: "var(--ds-text-disabled, ".concat($e996865a8c4821b6$export$5f71e19f3a7ad9de, ")"),
                dark: "var(--ds-text-disabled, ".concat($e996865a8c4821b6$export$633847cf062b69e0, ")")
            },
            selected: {
                light: "var(--ds-text-selected, ".concat($e996865a8c4821b6$export$29a4f05edc054374, ")"),
                dark: "var(--ds-text-selected, ".concat($e996865a8c4821b6$export$29a4f05edc054374, ")")
            },
            focusSelected: {
                light: "var(--ds-text-selected, ".concat($e996865a8c4821b6$export$29a4f05edc054374, ")"),
                dark: "var(--ds-text-selected, ".concat($e996865a8c4821b6$export$29a4f05edc054374, ")")
            }
        },
        link: {
            default: {
                light: "var(--ds-link, ".concat($e996865a8c4821b6$export$b3de0ae08da2ce64, ")"),
                dark: "var(--ds-link, ".concat($e996865a8c4821b6$export$ecfc1dff386a3e7a, ")")
            },
            hover: {
                light: "var(--ds-link, ".concat($e996865a8c4821b6$export$e62e8919cca44969, ")"),
                dark: "var(--ds-link, ".concat($e996865a8c4821b6$export$8c13c2ee36917869, ")")
            },
            active: {
                light: "var(--ds-link-pressed, ".concat($e996865a8c4821b6$export$a6ee3d71bc067634, ")"),
                dark: "var(--ds-link-pressed, ".concat($e996865a8c4821b6$export$215b7063051591f1, ")")
            },
            disabled: {
                light: "var(--ds-text-disabled, ".concat($e996865a8c4821b6$export$5f71e19f3a7ad9de, ")"),
                dark: "var(--ds-text-disabled, ".concat($e996865a8c4821b6$export$ee82aa2ea6a1558, ")")
            },
            selected: {
                light: "var(--ds-text-selected, ".concat($e996865a8c4821b6$export$9fdfb749e33cdf97, ")"),
                dark: "var(--ds-text-selected, ".concat($e996865a8c4821b6$export$ad0bacf983b7ddaa, ")")
            },
            focusSelected: {
                light: "var(--ds-text-selected, ".concat($e996865a8c4821b6$export$9fdfb749e33cdf97, ")"),
                dark: "var(--ds-text-selected, ".concat($e996865a8c4821b6$export$ad0bacf983b7ddaa, ")")
            }
        },
        subtle: {
            default: {
                light: "var(--ds-text, ".concat($e996865a8c4821b6$export$c39c0fe0f26207ae, ")"),
                dark: "var(--ds-text, ".concat($e996865a8c4821b6$export$abcf8c38338b4aa5, ")")
            },
            active: {
                light: "var(--ds-text, ".concat($e996865a8c4821b6$export$b3de0ae08da2ce64, ")"),
                dark: "var(--ds-text, ".concat($e996865a8c4821b6$export$b3de0ae08da2ce64, ")")
            },
            disabled: {
                light: "var(--ds-text-disabled, ".concat($e996865a8c4821b6$export$5f71e19f3a7ad9de, ")"),
                dark: "var(--ds-text-disabled, ".concat($e996865a8c4821b6$export$ee82aa2ea6a1558, ")")
            },
            selected: {
                light: "var(--ds-text-selected, ".concat($e996865a8c4821b6$export$9fdfb749e33cdf97, ")"),
                dark: "var(--ds-text-selected, ".concat($e996865a8c4821b6$export$abcf8c38338b4aa5, ")")
            },
            focusSelected: {
                light: "var(--ds-text-selected, ".concat($e996865a8c4821b6$export$9fdfb749e33cdf97, ")"),
                dark: "var(--ds-text-selected, ".concat($e996865a8c4821b6$export$abcf8c38338b4aa5, ")")
            }
        },
        "subtle-link": {
            default: {
                light: "var(--ds-text-subtle, ".concat($e996865a8c4821b6$export$f563ee71e9ee74cd, ")"),
                dark: "var(--ds-text-subtle, ".concat($e996865a8c4821b6$export$abcf8c38338b4aa5, ")")
            },
            hover: {
                light: "var(--ds-text-subtle, ".concat($e996865a8c4821b6$export$7c87d337fb91a97d, ")"),
                dark: "var(--ds-text-subtle, ".concat($e996865a8c4821b6$export$226de0355ed012f8, ")")
            },
            active: {
                light: "var(--ds-text, ".concat($e996865a8c4821b6$export$eece5f492e429f08, ")"),
                dark: "var(--ds-text, ".concat($e996865a8c4821b6$export$97e81faa16a182c7, ")")
            },
            disabled: {
                light: "var(--ds-text-disabled, ".concat($e996865a8c4821b6$export$5f71e19f3a7ad9de, ")"),
                dark: "var(--ds-text-disabled, ".concat($e996865a8c4821b6$export$ee82aa2ea6a1558, ")")
            },
            selected: {
                light: "var(--ds-text-selected, ".concat($e996865a8c4821b6$export$9fdfb749e33cdf97, ")"),
                dark: "var(--ds-text-selected, ".concat($e996865a8c4821b6$export$abcf8c38338b4aa5, ")")
            },
            focusSelected: {
                light: "var(--ds-text-selected, ".concat($e996865a8c4821b6$export$9fdfb749e33cdf97, ")"),
                dark: "var(--ds-text-selected, ".concat($e996865a8c4821b6$export$abcf8c38338b4aa5, ")")
            }
        }
    }
};
var $ef1ded8600d16419$export$2e2bcd8739ae039 = $ef1ded8600d16419$var$values;


function $0242c627a1d67f43$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $0242c627a1d67f43$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $0242c627a1d67f43$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($c3ec97511ae1ed64$exports)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $0242c627a1d67f43$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $0242c627a1d67f43$var$gridSize = (0, $fadf80e9637982ea$export$6d8204c2cb2e06b8)();
var $0242c627a1d67f43$var$HAS_DISABLED_BACKGROUND = [
    "default",
    "primary",
    "danger",
    "warning"
];
// ## Button layout
//
// /------------------------------------------------------------------------------------------------------------------\
// |       →  |  ←      |          |      →  |  ←      |           |      →  |  ←      |         |      →  |  ←       |
// |  10px →  |  ← 2px  |   icon   |  2px →  |  ← 2px  |           |  2px →  |  ← 2px  |  icon   |  2px →  |  ← 10px  |
// |  padding |  margin |  before  |  margin |  margin |  content  |  margin |  margin |  after  |  margin |  padding |
// |    (12px total)    |          |    (4px total)    |           |    (4px total)    |         |    (12px total)    |
// |       →  |  ←      |          |      →  |  ←      |           |      →  |  ←      |         |      →  |  ←       |
// \------------------------------------------------------------------------------------------------------------------/
//                                           ↑                               ↑
//                                        Margins don't collapse with inline-flex
//
var $0242c627a1d67f43$var$heights = {
    default: "".concat(32 / 14, "em"),
    // 32px
    compact: "".concat(24 / 14, "em"),
    none: "auto"
};
var $0242c627a1d67f43$var$lineHeights = {
    default: $0242c627a1d67f43$var$heights.default,
    compact: $0242c627a1d67f43$var$heights.compact,
    none: "inherit"
};
var $0242c627a1d67f43$var$padding = {
    // 10px gutter
    default: "0 ".concat($0242c627a1d67f43$var$gridSize + $0242c627a1d67f43$var$gridSize / 4, "px"),
    compact: "0 ".concat($0242c627a1d67f43$var$gridSize + $0242c627a1d67f43$var$gridSize / 4, "px"),
    none: "0"
};
var $0242c627a1d67f43$var$singleIconPadding = {
    // 2px gutter
    compact: "0 ".concat($0242c627a1d67f43$var$gridSize / 4, "px"),
    default: "0 ".concat($0242c627a1d67f43$var$gridSize / 4, "px"),
    none: "0"
};
var $0242c627a1d67f43$var$verticalAlign = {
    default: "middle",
    compact: "middle",
    none: "baseline"
};
var $0242c627a1d67f43$var$innerMargin = {
    content: "0 ".concat($0242c627a1d67f43$var$gridSize / 4, "px"),
    icon: "0 ".concat($0242c627a1d67f43$var$gridSize / 4, "px")
};
var $0242c627a1d67f43$var$defaultAfterStyles = {
    borderRadius: "inherit",
    inset: "var(--ds-space-0, 0px)",
    borderStyle: "solid",
    borderWidth: "var(--ds-border-width, 1px)",
    pointerEvents: "none",
    position: "absolute"
};
var $0242c627a1d67f43$var$defaultStyles = {
    background: "var(--ds-background-neutral-subtle, #00000000)",
    color: "var(--ds-text, #172B4D)",
    "&:not([disabled])::after": $0242c627a1d67f43$var$_objectSpread($0242c627a1d67f43$var$_objectSpread({}, $0242c627a1d67f43$var$defaultAfterStyles), {}, {
        content: '""',
        borderColor: "var(--ds-border, #091E4224)"
    }),
    "&:hover": {
        background: "var(--ds-background-neutral-hovered, #091E4224)"
    },
    "&:active": {
        background: "var(--ds-background-neutral-pressed, #091E424F)"
    }
};
var $0242c627a1d67f43$var$primaryStyles = {
    background: "var(--ds-background-brand-bold, #0C66E4)",
    color: "var(--ds-text-inverse, #FFFFFF)",
    "&:hover": {
        background: "var(--ds-background-brand-bold-hovered, #0055CC)"
    },
    "&:active": {
        background: "var(--ds-background-brand-bold-pressed, #09326C)"
    }
};
var $0242c627a1d67f43$var$linkStyles = {
    background: "transparent",
    color: "var(--ds-link, #0C66E4)",
    "&:hover": {
        color: "var(--ds-link, #0C66E4)",
        textDecoration: "underline"
    },
    "&:active": {
        color: "var(--ds-link-pressed, #0055CC)",
        textDecoration: "underline"
    }
};
var $0242c627a1d67f43$var$subtleStyles = {
    background: "transparent",
    color: "var(--ds-text-subtle, #44546F)",
    "&:hover": {
        background: "var(--ds-background-neutral-subtle-hovered, #091E420F)"
    },
    "&:active": {
        background: "var(--ds-background-neutral-subtle-pressed, #091E4224)"
    }
};
var $0242c627a1d67f43$var$subtleLinkStyles = {
    background: "transparent",
    color: "var(--ds-text-subtle, #44546F)",
    "&:hover": {
        background: "transparent",
        color: "var(--ds-text-subtle, #44546F)",
        textDecoration: "underline"
    },
    "&:active": {
        background: "transparent",
        color: "var(--ds-text, #172B4D)",
        textDecoration: "underline"
    }
};
var $0242c627a1d67f43$var$warningStyles = {
    background: "var(--ds-background-warning-bold, #F5CD47)",
    color: "var(--ds-text-warning-inverse, #172B4D)",
    "&:hover": {
        background: "var(--ds-background-warning-bold-hovered, #E2B203)"
    },
    "&:active": {
        background: "var(--ds-background-warning-bold-pressed, #CF9F02)"
    }
};
var $0242c627a1d67f43$var$dangerStyles = {
    background: "var(--ds-background-danger-bold, #C9372C)",
    color: "var(--ds-text-inverse, #FFFFFF)",
    "&:hover": {
        background: "var(--ds-background-danger-bold-hovered, #AE2E24)"
    },
    "&:active": {
        background: "var(--ds-background-danger-bold-pressed, #5D1F1A)"
    }
};
var $0242c627a1d67f43$var$selectedStyles = {
    background: "var(--ds-background-selected, #E9F2FF)",
    color: "var(--ds-text-selected, #0C66E4)",
    "&:not([disabled])::after": $0242c627a1d67f43$var$_objectSpread($0242c627a1d67f43$var$_objectSpread({}, $0242c627a1d67f43$var$defaultAfterStyles), {}, {
        content: '""',
        borderColor: "var(--ds-border-selected, #0C66E4)"
    })
};
var $0242c627a1d67f43$var$hasOverlayStyles = {
    '&[data-has-overlay="true"]': {
        cursor: "default",
        textDecoration: "none"
    }
};
function $0242c627a1d67f43$var$getColor(_ref) {
    var group = _ref.group, key = _ref.key, mode = _ref.mode;
    var rule = group[key] || group.default;
    return rule[mode];
}
function $0242c627a1d67f43$var$getColors(_ref2) {
    var appearance = _ref2.appearance, key = _ref2.key, mode = _ref2.mode;
    return {
        background: $0242c627a1d67f43$var$getColor({
            group: (0, $ef1ded8600d16419$export$2e2bcd8739ae039).background[appearance],
            key: key,
            mode: mode
        }),
        // Needing to add !important to overcome specificity issue caused by deprecated AtlaskitThemeProvider
        color: "".concat($0242c627a1d67f43$var$getColor({
            group: (0, $ef1ded8600d16419$export$2e2bcd8739ae039).color[appearance],
            key: key,
            mode: mode
        }), " !important")
    };
}
function $0242c627a1d67f43$export$955358618f994a11(_ref3) {
    var appearance = _ref3.appearance, spacing = _ref3.spacing, mode = _ref3.mode, isSelected = _ref3.isSelected, shouldFitContainer = _ref3.shouldFitContainer, isOnlySingleIcon = _ref3.isOnlySingleIcon;
    var baseColors = $0242c627a1d67f43$var$getColors({
        appearance: appearance,
        key: isSelected ? "selected" : "default",
        mode: mode
    });
    return $0242c627a1d67f43$var$_objectSpread($0242c627a1d67f43$var$_objectSpread($0242c627a1d67f43$var$_objectSpread($0242c627a1d67f43$var$_objectSpread({
        // 0px margin added to css-reset
        alignItems: "baseline",
        borderWidth: 0,
        borderRadius: "var(--ds-border-radius, 3px)",
        boxSizing: "border-box",
        display: "inline-flex",
        fontSize: "inherit",
        fontStyle: "normal",
        // Chrome recently changed button so that they use 'arial' as the font family
        fontFamily: "inherit",
        fontWeight: 500,
        // margin for button has been applied to css reset
        maxWidth: "100%",
        // Needed to position overlay
        position: "relative",
        textAlign: "center",
        textDecoration: "none",
        transition: "background 0.1s ease-out, box-shadow 0.15s cubic-bezier(0.47, 0.03, 0.49, 1.38)",
        whiteSpace: "nowrap"
    }, !(0, $jAmv0.fg)("platform.design-system-team.component-visual-refresh_t8zbo") && baseColors), {}, {
        cursor: "pointer",
        height: $0242c627a1d67f43$var$heights[spacing],
        lineHeight: $0242c627a1d67f43$var$lineHeights[spacing],
        padding: isOnlySingleIcon ? $0242c627a1d67f43$var$singleIconPadding[spacing] : $0242c627a1d67f43$var$padding[spacing],
        verticalAlign: $0242c627a1d67f43$var$verticalAlign[spacing],
        width: shouldFitContainer ? "100%" : "auto",
        // justifyContent required for shouldFitContainer buttons with an icon inside
        justifyContent: "center"
    }, !(0, $jAmv0.fg)("platform.design-system-team.component-visual-refresh_t8zbo") && $0242c627a1d67f43$var$_objectSpread($0242c627a1d67f43$var$_objectSpread({
        // Disabling visited styles (just using the base colors)
        "&:visited": $0242c627a1d67f43$var$_objectSpread({}, baseColors),
        "&:hover": $0242c627a1d67f43$var$_objectSpread($0242c627a1d67f43$var$_objectSpread({}, $0242c627a1d67f43$var$getColors({
            appearance: appearance,
            key: isSelected ? "selected" : "hover",
            mode: mode
        })), {}, {
            textDecoration: !isSelected && (appearance === "link" || appearance === "subtle-link") ? "underline" : "inherit",
            // background, box-shadow
            transitionDuration: "0s, 0.15s"
        }),
        // giving active styles preference by listing them after focus
        "&:active": $0242c627a1d67f43$var$_objectSpread($0242c627a1d67f43$var$_objectSpread({}, $0242c627a1d67f43$var$getColors({
            appearance: appearance,
            key: isSelected ? "selected" : "active",
            mode: mode
        })), {}, {
            // background, box-shadow
            transitionDuration: "0s, 0s"
        }),
        // preventDefault prevents regular active styles from applying in Firefox
        '&[data-firefox-is-active="true"]': $0242c627a1d67f43$var$_objectSpread($0242c627a1d67f43$var$_objectSpread({}, $0242c627a1d67f43$var$getColors({
            appearance: appearance,
            key: isSelected ? "selected" : "active",
            mode: mode
        })), {}, {
            // background, box-shadow
            transitionDuration: "0s, 0s"
        }),
        // Giving disabled styles preference over active by listing them after.
        // Not using '&:disabled' because :disabled is not a valid state for all element types
        // so we are targeting the attribute
        // Attributes have the same specificity a pseudo classes so we are overriding :disabled here
        "&[disabled]": $0242c627a1d67f43$var$_objectSpread($0242c627a1d67f43$var$_objectSpread({}, $0242c627a1d67f43$var$getColors({
            appearance: appearance,
            key: "disabled",
            mode: mode
        })), {}, {
            cursor: "not-allowed",
            textDecoration: "none"
        })
    }, $0242c627a1d67f43$var$hasOverlayStyles), {}, {
        // disabling hover and active color changes when there is an overlay, but the button is not disabled
        '&[data-has-overlay="true"]:not([disabled]):hover, &[data-has-overlay="true"]:not([disabled]):active': $0242c627a1d67f43$var$_objectSpread({}, $0242c627a1d67f43$var$getColors({
            appearance: appearance,
            key: isSelected ? "selected" : "default",
            mode: mode
        }))
    })), (0, $jAmv0.fg)("platform.design-system-team.component-visual-refresh_t8zbo") && (isSelected ? $0242c627a1d67f43$var$selectedStyles : $0242c627a1d67f43$var$_objectSpread($0242c627a1d67f43$var$_objectSpread($0242c627a1d67f43$var$_objectSpread($0242c627a1d67f43$var$_objectSpread($0242c627a1d67f43$var$_objectSpread($0242c627a1d67f43$var$_objectSpread($0242c627a1d67f43$var$_objectSpread($0242c627a1d67f43$var$_objectSpread($0242c627a1d67f43$var$_objectSpread({}, appearance === "default" && $0242c627a1d67f43$var$defaultStyles), appearance === "primary" && $0242c627a1d67f43$var$primaryStyles), appearance === "link" && $0242c627a1d67f43$var$linkStyles), appearance === "subtle" && $0242c627a1d67f43$var$subtleStyles), appearance === "subtle-link" && $0242c627a1d67f43$var$subtleLinkStyles), appearance === "warning" && $0242c627a1d67f43$var$warningStyles), appearance === "danger" && $0242c627a1d67f43$var$dangerStyles), {}, {
        "&[disabled]": {
            color: "var(--ds-text-disabled, #091E424F)",
            backgroundColor: $0242c627a1d67f43$var$HAS_DISABLED_BACKGROUND.includes(appearance) ? "var(--ds-background-disabled, #091E4208)" : "transparent",
            cursor: "not-allowed",
            textDecoration: "none",
            "&:hovered": {
                backgroundColor: $0242c627a1d67f43$var$HAS_DISABLED_BACKGROUND.includes(appearance) ? "var(--ds-background-disabled, #091E4208)" : "transparent"
            },
            "&:active": {
                backgroundColor: $0242c627a1d67f43$var$HAS_DISABLED_BACKGROUND.includes(appearance) ? "var(--ds-background-disabled, #091E4208)" : "transparent"
            }
        }
    }, $0242c627a1d67f43$var$hasOverlayStyles), {}, {
        // disabling hover and active color changes when there is an overlay, but the button is not disabled
        '&[data-has-overlay="true"]:not([disabled]):hover, &[data-has-overlay="true"]:not([disabled]):active': {
            background: "inherit"
        }
    }))), {}, {
        "&::-moz-focus-inner": {
            border: 0,
            margin: 0,
            padding: 0
        }
    });
}
function $0242c627a1d67f43$export$864eea3f4ec3368f(_ref4) {
    var spacing = _ref4.spacing;
    return (0, $jVTBW.css)({
        display: "flex",
        // icon size cannot grow and shrink
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        margin: spacing === "none" ? 0 : $0242c627a1d67f43$var$innerMargin.icon,
        flexGrow: 0,
        flexShrink: 0,
        alignSelf: "center",
        fontSize: 0,
        lineHeight: 0,
        userSelect: "none"
    });
}
function $0242c627a1d67f43$export$7ad0316cc0dd65a(_ref5) {
    var spacing = _ref5.spacing;
    return (0, $jVTBW.css)({
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        margin: spacing === "none" ? 0 : $0242c627a1d67f43$var$innerMargin.content,
        // content can grow and shrink
        flexGrow: 1,
        flexShrink: 1,
        // ellipsis for overflow text
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap"
    });
}
function $0242c627a1d67f43$export$1b5827d324e945b1(_ref6) {
    var hasOverlay = _ref6.hasOverlay;
    return (0, $jVTBW.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        opacity: hasOverlay ? 0 : 1,
        transition: "opacity 0.3s"
    });
}
var $0242c627a1d67f43$export$1a9fe1b84c876bb5 = {
    // stretching to full width / height of button
    // this is important as we need it to still block
    // event if clicking in the button's own padding
    position: "absolute",
    left: 0,
    top: 0,
    right: 0,
    bottom: 0,
    // Putting all children in the center
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
};



var $dAx5m = parcelRequire("dAx5m");

var $ez4n6 = parcelRequire("ez4n6");
var $2d888c62845e4cdd$export$20bbd2efb0d734c4 = function getIfVisuallyHiddenChildren(children) {
    return children && /*#__PURE__*/ (0, $dAx5m.isValidElement)(children) && children.type === (0, $ez4n6.default);
};


var $f208e57bf81014d3$var$_excluded = [
    "analyticsContext",
    "appearance",
    "autoFocus",
    "buttonCss",
    "children",
    "className",
    "href",
    "component",
    "iconAfter",
    "iconBefore",
    "interactionName",
    "isDisabled",
    "isSelected",
    "onBlur",
    "onClick",
    "onFocus",
    "onMouseDown",
    "overlay",
    "shouldFitContainer",
    "spacing",
    "tabIndex",
    "type",
    "testId"
];
// Disabled buttons will still publish events for nested elements in webkit.
// We are disabling pointer events on child elements so that
// the button will always be the target of events
// Note: firefox does not have this behaviour for child elements
var $f208e57bf81014d3$var$noPointerEventsOnChildrenCss = {
    "> *": {
        pointerEvents: "none"
    }
};
/**
 * These CSS variables consumed by the new icons, to allow them to have appropriate
 * padding inside Button while also maintaining spacing for the existing icons.
 *
 * These styles can be removed once the new icons are fully rolled out, feature flag
 * platform.design-system-team.enable-new-icons is cleaned up,
 * and we bump Button to set padding based on the new icons.
 */ var $f208e57bf81014d3$var$iconBeforeSpacingFixStyle = (0, $jVTBW.css)({
    "--ds--button--new-icon-padding-end": "var(--ds-space-025, 2px)",
    "--ds--button--new-icon-padding-start": "var(--ds-space-050, 4px)",
    marginInlineStart: "var(--ds-space-negative-025, -2px)"
});
var $f208e57bf81014d3$var$iconAfterSpacingFixStyle = (0, $jVTBW.css)({
    "--ds--button--new-icon-padding-end": "var(--ds-space-050, 4px)",
    "--ds--button--new-icon-padding-start": "var(--ds-space-025, 2px)",
    marginInlineEnd: "var(--ds-space-negative-025, -2px)"
});
var $f208e57bf81014d3$var$getSpacingFix = function getSpacingFix(children, spacingStyles) {
    if (!children || (0, $2d888c62845e4cdd$export$20bbd2efb0d734c4)(children)) return null;
    return spacingStyles;
};
var $f208e57bf81014d3$var$getChildren = function getChildren(children, childrenStyles) {
    if ((0, $2d888c62845e4cdd$export$20bbd2efb0d734c4)(children)) return children;
    return children ? (0, $jVTBW.jsx)("span", {
        css: childrenStyles
    }, children) : null;
};
var $f208e57bf81014d3$var$ButtonBase = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).forwardRef(function ButtonBase(props, ref) {
    var analyticsContext = props.analyticsContext, _props$appearance = props.appearance, appearance = _props$appearance === void 0 ? "default" : _props$appearance, _props$autoFocus = props.autoFocus, autoFocus = _props$autoFocus === void 0 ? false : _props$autoFocus, buttonCss = props.buttonCss, children = props.children, className = props.className, href = props.href, _props$component = props.component, Component = _props$component === void 0 ? href ? "a" : "button" : _props$component, iconAfter = props.iconAfter, iconBefore = props.iconBefore, interactionName = props.interactionName, _props$isDisabled = props.isDisabled, isDisabled = _props$isDisabled === void 0 ? false : _props$isDisabled, _props$isSelected = props.isSelected, isSelected = _props$isSelected === void 0 ? false : _props$isSelected, onBlur = props.onBlur, _props$onClick = props.onClick, providedOnClick = _props$onClick === void 0 ? (0, $Bb0he.default) : _props$onClick, onFocus = props.onFocus, _props$onMouseDown = props.onMouseDown, providedOnMouseDown = _props$onMouseDown === void 0 ? (0, $Bb0he.default) : _props$onMouseDown, overlay = props.overlay, shouldFitContainer = props.shouldFitContainer, _props$spacing = props.spacing, spacing = _props$spacing === void 0 ? "default" : _props$spacing, _props$tabIndex = props.tabIndex, tabIndex = _props$tabIndex === void 0 ? 0 : _props$tabIndex, _props$type = props.type, type = _props$type === void 0 ? !href ? "button" : undefined : _props$type, testId = props.testId, rest = (0, (/*@__PURE__*/$parcel$interopDefault($74ed1cba0d5551e3$exports)))(props, $f208e57bf81014d3$var$_excluded);
    var ourRef = (0, $dAx5m.useRef)();
    var setRef = (0, $dAx5m.useCallback)(function(node) {
        ourRef.current = node;
        if (ref == null) return;
        if (typeof ref === "function") {
            ref(node);
            return;
        }
        // We can write to ref's `current` property, but Typescript does not like it.
        // @ts-ignore
        ref.current = node;
    }, [
        ourRef,
        ref
    ]);
    // Cross browser auto focusing is pretty broken, so we are doing it ourselves
    (0, $gMIYi.default)(ourRef, autoFocus);
    var interactionContext = (0, $dAx5m.useContext)((0, $kqsmh.default));
    var handleClick = (0, $dAx5m.useCallback)(function(e, analyticsEvent) {
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    var onClick = (0, $931ed1ff12a9e285$export$a4687b0234b40e28)({
        fn: handleClick,
        action: "clicked",
        componentName: "button",
        packageName: "@atlaskit/button",
        packageVersion: "18.4.1",
        analyticsData: analyticsContext
    });
    // Button currently calls preventDefault, which is not standard button behaviour
    var onMouseDown = (0, $dAx5m.useCallback)(function(event) {
        event.preventDefault();
        providedOnMouseDown(event);
    }, [
        providedOnMouseDown
    ]);
    // Lose focus when becoming disabled (standard button behaviour)
    (0, $dAx5m.useEffect)(function() {
        var el = ourRef.current;
        if (isDisabled && el && el === document.activeElement) el.blur();
    }, [
        isDisabled
    ]);
    // we are 'disabling' input with a button when there is an overlay
    var hasOverlay = Boolean(overlay);
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    var fadeStyles = (0, $jVTBW.css)((0, $0242c627a1d67f43$export$1b5827d324e945b1)({
        hasOverlay: hasOverlay
    }));
    var isInteractive = !isDisabled && !hasOverlay;
    /**
   * HACK: Spinner needs to have different colours in the "new" tokens design compared to the old design.
   * For now, while we support both, these styles reach into Spinner when a theme is set, applies the right color.
   * Ticket to remove: https://product-fabric.atlassian.net/browse/DSP-2067.
   */ var spinnerHackCss = {};
    if (isSelected || isDisabled || appearance === "warning") spinnerHackCss = {
        "[data-theme] & circle": {
            stroke: "".concat(isSelected || isDisabled ? "var(--ds-icon-subtle, ".concat((0, $e996865a8c4821b6$export$c39c0fe0f26207ae), ")") : "var(--ds-icon-warning-inverse, ".concat((0, $e996865a8c4821b6$export$c39c0fe0f26207ae), ")"), " !important")
        }
    };
    return (0, $jVTBW.jsx)((0, $iAyBE.default), null, (0, $jVTBW.jsx)(Component, (0, (/*@__PURE__*/$parcel$interopDefault($5fb336a98f9116b4$exports)))({}, rest, {
        ref: setRef,
        className: className,
        css: [
            buttonCss,
            isInteractive ? null : $f208e57bf81014d3$var$noPointerEventsOnChildrenCss
        ],
        "data-has-overlay": hasOverlay ? true : undefined,
        "data-testid": testId,
        disabled: isDisabled,
        href: isInteractive ? href : undefined,
        onBlur: onBlur,
        onClick: onClick,
        onFocus: onFocus,
        onMouseDown: onMouseDown,
        tabIndex: isDisabled ? -1 : tabIndex,
        type: type
    }, (0, $566d1569f272cc49$export$2e2bcd8739ae039)({
        isInteractive: isInteractive
    })), iconBefore ? (0, $jVTBW.jsx)("span", {
        css: [
            fadeStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $0242c627a1d67f43$export$864eea3f4ec3368f)({
                spacing: spacing
            }),
            $f208e57bf81014d3$var$getSpacingFix(children, $f208e57bf81014d3$var$iconBeforeSpacingFixStyle)
        ]
    }, iconBefore) : null, $f208e57bf81014d3$var$getChildren(children, [
        fadeStyles,
        (0, $0242c627a1d67f43$export$7ad0316cc0dd65a)({
            spacing: spacing
        })
    ]), iconAfter ? (0, $jVTBW.jsx)("span", {
        css: [
            fadeStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $0242c627a1d67f43$export$864eea3f4ec3368f)({
                spacing: spacing
            }),
            $f208e57bf81014d3$var$getSpacingFix(children, $f208e57bf81014d3$var$iconAfterSpacingFixStyle)
        ]
    }, iconAfter) : null, overlay ? (0, $jVTBW.jsx)("span", {
        css: [
            (0, $0242c627a1d67f43$export$1a9fe1b84c876bb5),
            spinnerHackCss
        ]
    }, overlay) : null));
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$f208e57bf81014d3$export$2e2bcd8739ae039 = $f208e57bf81014d3$var$ButtonBase;



function $c07e0748421fb8da$export$2e2bcd8739ae039(_ref) {
    var children = _ref.children, iconBefore = _ref.iconBefore, iconAfter = _ref.iconAfter;
    if ((0, $2d888c62845e4cdd$export$20bbd2efb0d734c4)(children)) return true;
    if (children) return false;
    if (iconBefore && !iconAfter) return true;
    if (!iconBefore && iconAfter) return true;
    return false;
}



var $dAx5m = parcelRequire("dAx5m");

function $4d05c868cc8e2aba$var$getSpinnerAppearance(_ref) {
    var appearance = _ref.appearance, isDisabled = _ref.isDisabled, isSelected = _ref.isSelected;
    if (isDisabled) return "inherit";
    if (isSelected) return "invert";
    if (appearance === "primary" || appearance === "danger") return "invert";
    return "inherit";
}
function $4d05c868cc8e2aba$export$2e2bcd8739ae039(_ref2) {
    var appearance = _ref2.appearance, isDisabled = _ref2.isDisabled, isSelected = _ref2.isSelected, _ref2$spacing = _ref2.spacing, spacing = _ref2$spacing === void 0 ? "default" : _ref2$spacing;
    var size = spacing === "default" ? "medium" : "small";
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $917ea1ded1dd2c62$export$2e2bcd8739ae039), {
        size: size,
        label: ", Loading",
        appearance: $4d05c868cc8e2aba$var$getSpinnerAppearance({
            appearance: appearance,
            isDisabled: isDisabled,
            isSelected: isSelected
        })
    });
}





function $de29fc1666827b2b$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $de29fc1666827b2b$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $de29fc1666827b2b$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($c3ec97511ae1ed64$exports)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $de29fc1666827b2b$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $de29fc1666827b2b$var$stateToSelectorMap = {
    focus: "&:focus",
    focusSelected: "&:focus",
    hover: "&:hover",
    active: "&:active",
    disabled: "&[disabled]"
};
function $de29fc1666827b2b$export$31512de7fa606fa4(_ref) {
    var _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "default" : _ref$appearance, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? "default" : _ref$spacing, _ref$mode = _ref.mode, mode = _ref$mode === void 0 ? "light" : _ref$mode, _ref$isSelected = _ref.isSelected, isSelected = _ref$isSelected === void 0 ? false : _ref$isSelected, _ref$shouldFitContain = _ref.shouldFitContainer, shouldFitContainer = _ref$shouldFitContain === void 0 ? false : _ref$shouldFitContain, _ref$iconIsOnlyChild = _ref.iconIsOnlyChild, iconIsOnlyChild = _ref$iconIsOnlyChild === void 0 ? false : _ref$iconIsOnlyChild, _ref$isLoading = _ref.isLoading, isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading, state = _ref.state;
    var result = (0, $0242c627a1d67f43$export$955358618f994a11)({
        appearance: appearance,
        spacing: spacing,
        mode: mode,
        isSelected: isSelected,
        shouldFitContainer: shouldFitContainer,
        isOnlySingleIcon: iconIsOnlyChild
    });
    // we need to disable the default browser focus styles always
    // this is because we are not expressing that we can have two pseudo states at a time
    result.outline = "none";
    // Pulling relevant styles up to the top level
    var selector = $de29fc1666827b2b$var$stateToSelectorMap[state];
    if (selector) result = $de29fc1666827b2b$var$_objectSpread($de29fc1666827b2b$var$_objectSpread({}, result), result[selector]);
    if (isLoading) result = $de29fc1666827b2b$var$_objectSpread($de29fc1666827b2b$var$_objectSpread({}, result), result['&[data-has-overlay="true"]']);
    // Delete all selectors and just keep root styles
    Object.keys(result).forEach(function(key) {
        // want to keep this one
        if (key === "&::-moz-focus-inner") return;
        // Not using .startsWith for ie11
        if (key.indexOf("&") === 0) delete result[key];
    });
    return result;
}
function $de29fc1666827b2b$export$643db0b8d8778e(styles) {
    return {
        "&, &:hover, &:active, &:focus, &:focus-visible, &:visited, &:disabled, &[disabled]": styles
    };
}
function $de29fc1666827b2b$export$437a7f77d13d7916(current, values) {
    return current(values);
}
var $de29fc1666827b2b$var$Theme = (0, $85e232228bb3a8ca$export$25d302a5b900a763)(function(themeProps) {
    return {
        buttonStyles: $de29fc1666827b2b$export$31512de7fa606fa4(themeProps),
        // No styles being applied directly to spinner by default
        // Keeping this for legacy compat. We could remove it, but given
        // that we are changing theme soon there is no point
        spinnerStyles: {}
    };
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$de29fc1666827b2b$export$2e2bcd8739ae039 = $de29fc1666827b2b$var$Theme;


var $2aaf423c0bf8d712$var$_excluded = [
    "appearance",
    "autoFocus",
    "isDisabled",
    "isSelected",
    "shouldFitContainer",
    "spacing",
    "isLoading",
    "onMouseEnter",
    "onMouseLeave",
    "onMouseDown",
    "onMouseUp",
    "onFocus",
    "onBlur",
    "theme"
];
function $2aaf423c0bf8d712$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $2aaf423c0bf8d712$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $2aaf423c0bf8d712$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($c3ec97511ae1ed64$exports)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $2aaf423c0bf8d712$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $2aaf423c0bf8d712$var$getInteractionState(_ref) {
    var _ref$isDisabled = _ref.isDisabled, isDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled, _ref$isActive = _ref.isActive, isActive = _ref$isActive === void 0 ? false : _ref$isActive, _ref$isFocus = _ref.isFocus, isFocus = _ref$isFocus === void 0 ? false : _ref$isFocus, _ref$isHover = _ref.isHover, isHover = _ref$isHover === void 0 ? false : _ref$isHover, _ref$isSelected = _ref.isSelected, isSelected = _ref$isSelected === void 0 ? false : _ref$isSelected, _ref$isLoading = _ref.isLoading, isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading;
    if (isDisabled) return "disabled";
    if (isSelected && isFocus) return "focusSelected";
    if (isSelected) return "selected";
    // not allowing active or focus style changes while loading
    if (!isLoading && isActive) return "active";
    if (!isLoading && isHover) return "hover";
    if (isFocus) return "focus";
    return "default";
}
var $2aaf423c0bf8d712$var$initial = {
    isHover: false,
    isActive: false,
    isFocus: false
};
/**
 * __Custom theme button__
 *
 * A custom theme button. Avoid using this component. It exists for those already using custom theming, which is hard to use and has performance issues.
 *
 * - [Examples](https://atlassian.design/components/button/examples#custom-theme-button)
 */ var $2aaf423c0bf8d712$var$CustomThemeButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).forwardRef(function CustomThemeButton(_ref2, ref) {
    var _ref2$appearance = _ref2.appearance, appearance = _ref2$appearance === void 0 ? "default" : _ref2$appearance, _ref2$autoFocus = _ref2.autoFocus, autoFocus = _ref2$autoFocus === void 0 ? false : _ref2$autoFocus, _ref2$isDisabled = _ref2.isDisabled, isDisabled = _ref2$isDisabled === void 0 ? false : _ref2$isDisabled, _ref2$isSelected = _ref2.isSelected, isSelected = _ref2$isSelected === void 0 ? false : _ref2$isSelected, _ref2$shouldFitContai = _ref2.shouldFitContainer, shouldFitContainer = _ref2$shouldFitContai === void 0 ? false : _ref2$shouldFitContai, _ref2$spacing = _ref2.spacing, spacing = _ref2$spacing === void 0 ? "default" : _ref2$spacing, _ref2$isLoading = _ref2.isLoading, isLoading = _ref2$isLoading === void 0 ? false : _ref2$isLoading, providedOnMouseEnter = _ref2.onMouseEnter, providedOnMouseLeave = _ref2.onMouseLeave, providedOnMouseDown = _ref2.onMouseDown, providedOnMouseUp = _ref2.onMouseUp, providedOnFocus = _ref2.onFocus, providedOnBlur = _ref2.onBlur, _ref2$theme = _ref2.theme, theme = _ref2$theme === void 0 ? (0, $de29fc1666827b2b$export$437a7f77d13d7916) : _ref2$theme, rest = (0, (/*@__PURE__*/$parcel$interopDefault($74ed1cba0d5551e3$exports)))(_ref2, $2aaf423c0bf8d712$var$_excluded);
    // TODO is there a nicer way to do this?
    // Add default props back into object for spreading
    var restProps = $2aaf423c0bf8d712$var$_objectSpread({
        appearance: appearance,
        autoFocus: autoFocus,
        isDisabled: isDisabled,
        isSelected: isSelected,
        shouldFitContainer: shouldFitContainer,
        spacing: spacing
    }, rest);
    var _useState = (0, $dAx5m.useState)($2aaf423c0bf8d712$var$initial), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($6f4c9344050d46f7$exports)))(_useState, 2), state = _useState2[0], setState = _useState2[1];
    var onMouseEnter = (0, $dAx5m.useCallback)(function(event) {
        setState(function(current) {
            return $2aaf423c0bf8d712$var$_objectSpread($2aaf423c0bf8d712$var$_objectSpread({}, current), {}, {
                isHover: true
            });
        });
        if (providedOnMouseEnter) providedOnMouseEnter(event);
    }, [
        providedOnMouseEnter
    ]);
    var onMouseLeave = (0, $dAx5m.useCallback)(function(event) {
        setState(function(current) {
            return $2aaf423c0bf8d712$var$_objectSpread($2aaf423c0bf8d712$var$_objectSpread({}, current), {}, {
                isHover: false,
                isActive: false
            });
        });
        if (providedOnMouseLeave) providedOnMouseLeave(event);
    }, [
        providedOnMouseLeave
    ]);
    var onMouseDown = (0, $dAx5m.useCallback)(function(event) {
        setState(function(current) {
            return $2aaf423c0bf8d712$var$_objectSpread($2aaf423c0bf8d712$var$_objectSpread({}, current), {}, {
                isActive: true
            });
        });
        if (providedOnMouseDown) providedOnMouseDown(event);
    }, [
        providedOnMouseDown
    ]);
    var onMouseUp = (0, $dAx5m.useCallback)(function(event) {
        setState(function(current) {
            return $2aaf423c0bf8d712$var$_objectSpread($2aaf423c0bf8d712$var$_objectSpread({}, current), {}, {
                isActive: false
            });
        });
        if (providedOnMouseUp) providedOnMouseUp(event);
    }, [
        providedOnMouseUp
    ]);
    var onFocus = (0, $dAx5m.useCallback)(function(event) {
        setState(function(current) {
            return $2aaf423c0bf8d712$var$_objectSpread($2aaf423c0bf8d712$var$_objectSpread({}, current), {}, {
                isFocus: true
            });
        });
        if (providedOnFocus) providedOnFocus(event);
    }, [
        providedOnFocus
    ]);
    var onBlur = (0, $dAx5m.useCallback)(function(event) {
        setState(function(current) {
            return $2aaf423c0bf8d712$var$_objectSpread($2aaf423c0bf8d712$var$_objectSpread({}, current), {}, {
                isFocus: false
            });
        });
        if (providedOnBlur) providedOnBlur(event);
    }, [
        providedOnBlur
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $de29fc1666827b2b$export$2e2bcd8739ae039).Provider, {
        value: theme
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $9134e79d86294f0e$export$2e2bcd8739ae039).Consumer, null, function(_ref3) {
        var mode = _ref3.mode;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $de29fc1666827b2b$export$2e2bcd8739ae039).Consumer, (0, (/*@__PURE__*/$parcel$interopDefault($5fb336a98f9116b4$exports)))({
            mode: mode,
            state: $2aaf423c0bf8d712$var$getInteractionState($2aaf423c0bf8d712$var$_objectSpread($2aaf423c0bf8d712$var$_objectSpread({}, state), {}, {
                isLoading: isLoading,
                isSelected: restProps.isSelected,
                isDisabled: restProps.isDisabled
            })),
            iconIsOnlyChild: (0, $c07e0748421fb8da$export$2e2bcd8739ae039)(restProps),
            isLoading: isLoading
        }, restProps), function(_ref4) {
            var buttonStyles = _ref4.buttonStyles;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $f208e57bf81014d3$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($5fb336a98f9116b4$exports)))({}, restProps, {
                ref: ref,
                overlay: isLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $4d05c868cc8e2aba$export$2e2bcd8739ae039), restProps) : null,
                "aria-disabled": isLoading || restProps["aria-disabled"],
                onMouseEnter: onMouseEnter,
                onMouseLeave: onMouseLeave,
                onMouseDown: onMouseDown,
                onMouseUp: onMouseUp,
                onFocus: onFocus,
                onBlur: onBlur,
                buttonCss: (0, $de29fc1666827b2b$export$643db0b8d8778e)(buttonStyles)
            }));
        });
    }));
}));
// Tools including enzyme rely on components having a display name
$2aaf423c0bf8d712$var$CustomThemeButton.displayName = "CustomThemeButton";
var $2aaf423c0bf8d712$export$2e2bcd8739ae039 = $2aaf423c0bf8d712$var$CustomThemeButton;






var $dAx5m = parcelRequire("dAx5m");

var $dd4sf = parcelRequire("dd4sf");


var $dAx5m = parcelRequire("dAx5m");

var $tWuif = parcelRequire("tWuif");










var $6J7ZY = parcelRequire("6J7ZY");



function $ea8615174a590a83$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $ea8615174a590a83$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $ea8615174a590a83$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($c3ec97511ae1ed64$exports)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $ea8615174a590a83$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $ea8615174a590a83$export$ad4be5c2ec28cecf = function isAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $ea8615174a590a83$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === "AnalyticsEvent";
};
var $ea8615174a590a83$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function AnalyticsEvent(props) {
        var _this = this;
        (0, (/*@__PURE__*/$parcel$interopDefault($338b26f50ccea2d2$exports)))(this, AnalyticsEvent);
        (0, (/*@__PURE__*/$parcel$interopDefault($c3ec97511ae1ed64$exports)))(this, "_isAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($c3ec97511ae1ed64$exports)))(this, "clone", function() {
            // just a shallow clone, don't change sub refs unless you want to
            // affect the original's too
            var payload = $ea8615174a590a83$var$_objectSpread({}, _this.payload);
            return new AnalyticsEvent({
                payload: payload
            });
        });
        this.payload = props.payload;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($f6825da5cb87797f$exports)))(AnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (typeof updater === "function") this.payload = updater(this.payload);
                if ((0, (/*@__PURE__*/$parcel$interopDefault($6J7ZY)))(updater) === "object") this.payload = $ea8615174a590a83$var$_objectSpread($ea8615174a590a83$var$_objectSpread({}, this.payload), updater);
                return this;
            }
        }
    ]);
    return AnalyticsEvent;
}();


function $967a1e476d4580e4$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $967a1e476d4580e4$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, (/*@__PURE__*/$parcel$interopDefault($6c6f88cd7dc38741$exports)))(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, (/*@__PURE__*/$parcel$interopDefault($6c6f88cd7dc38741$exports)))(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, (/*@__PURE__*/$parcel$interopDefault($b7c8bb6ce7659b75$exports)))(this, result);
    };
}
function $967a1e476d4580e4$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($967a1e476d4580e4$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $967a1e476d4580e4$export$35f8383928ba8d7 = function isUIAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $967a1e476d4580e4$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isUIAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === "UIAnalyticsEvent";
};
var $967a1e476d4580e4$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_AnalyticsEvent) {
    (0, (/*@__PURE__*/$parcel$interopDefault($66c319fc06465227$exports)))(UIAnalyticsEvent, _AnalyticsEvent);
    var _super = $967a1e476d4580e4$var$_createSuper(UIAnalyticsEvent);
    function UIAnalyticsEvent(props) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($338b26f50ccea2d2$exports)))(this, UIAnalyticsEvent);
        _this = _super.call(this, props);
        (0, (/*@__PURE__*/$parcel$interopDefault($c3ec97511ae1ed64$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($a652a3a6cb45a7cf$exports)))(_this), "_isUIAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($c3ec97511ae1ed64$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($a652a3a6cb45a7cf$exports)))(_this), "clone", function() {
            if (_this.hasFired) return null;
            var context = (0, (/*@__PURE__*/$parcel$interopDefault($d5f3651f1c5ee1c2$exports)))(_this.context);
            var handlers = (0, (/*@__PURE__*/$parcel$interopDefault($d5f3651f1c5ee1c2$exports)))(_this.handlers);
            /**
       * A hacky "deep clone" of the object. This is limited in that it wont
       * support functions, regexs, Maps, Sets, etc, but none of those need to
       * be represented in our payload.
       */ var payload = JSON.parse(JSON.stringify(_this.payload));
            return new UIAnalyticsEvent({
                context: context,
                handlers: handlers,
                payload: payload
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($c3ec97511ae1ed64$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($a652a3a6cb45a7cf$exports)))(_this), "fire", function(channel) {
            if (_this.hasFired) return;
            _this.handlers.forEach(function(handler) {
                return handler((0, (/*@__PURE__*/$parcel$interopDefault($a652a3a6cb45a7cf$exports)))(_this), channel);
            });
            _this.hasFired = true;
        });
        _this.context = props.context || [];
        _this.handlers = props.handlers || [];
        _this.hasFired = false;
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($f6825da5cb87797f$exports)))(UIAnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (this.hasFired) return this;
                return (0, (/*@__PURE__*/$parcel$interopDefault($d1582149da161cd6$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($6c6f88cd7dc38741$exports)))(UIAnalyticsEvent.prototype), "update", this).call(this, updater);
            }
        }
    ]);
    return UIAnalyticsEvent;
}((0, $ea8615174a590a83$export$2e2bcd8739ae039));



var $dAx5m = parcelRequire("dAx5m");

var $h0bf1 = parcelRequire("h0bf1");
var $36c481b0ea6ebe28$export$d1f587f82ad51c4 = function useAnalyticsContext() {
    return (0, $dAx5m.useContext)((0, $h0bf1.default));
};


function $31583be94be8aa5b$export$5bf35293e545f20c() {
    var analyticsContext = (0, $36c481b0ea6ebe28$export$d1f587f82ad51c4)();
    var createAnalyticsEvent = (0, $tWuif.useCallbackOne)(function(payload) {
        return new (0, $967a1e476d4580e4$export$2e2bcd8739ae039)({
            context: analyticsContext.getAtlaskitAnalyticsContext(),
            handlers: analyticsContext.getAtlaskitAnalyticsEventHandlers(),
            payload: payload
        });
    }, [
        analyticsContext
    ]);
    return {
        createAnalyticsEvent: createAnalyticsEvent
    };
}



var $dAx5m = parcelRequire("dAx5m");
var $367b2bd2850524a3$export$1d27a74659855e44 = function useTrackedRef(value) {
    var ref = (0, $dAx5m.useRef)(value);
    ref.current = value;
    return ref;
};


function $a0f3daa697df11cd$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $a0f3daa697df11cd$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $a0f3daa697df11cd$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($c3ec97511ae1ed64$exports)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $a0f3daa697df11cd$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $a0f3daa697df11cd$export$1a04351537078b55(_ref) {
    var fn = _ref.fn, action = _ref.action, componentName = _ref.componentName, packageName = _ref.packageName, packageVersion = _ref.packageVersion, analyticsData = _ref.analyticsData;
    var _useAnalyticsEvents = (0, $31583be94be8aa5b$export$5bf35293e545f20c)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    // We put analyticsData and fn in a ref so that we don't need to break
    // memoization.
    // Generally these could be defined by consumers inline
    // and so we do this to avoid breaking memoization of useCallback
    var dataRef = (0, $367b2bd2850524a3$export$1d27a74659855e44)(analyticsData);
    var fnRef = (0, $367b2bd2850524a3$export$1d27a74659855e44)(fn);
    var handler = (0, $dAx5m.useCallback)(function() {
        var analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: componentName,
            attributes: {
                componentName: componentName,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
        // To avoid wrapping this component in AnalyticsContext we manually
        // push the parent context's meta data into the context.
        // Note: this new 'context'
        var context = $a0f3daa697df11cd$var$_objectSpread({
            componentName: componentName,
            packageName: packageName,
            packageVersion: packageVersion
        }, dataRef.current);
        analyticsEvent.context.push(context);
        // fire an event on the atlaskit channel
        var clone = analyticsEvent.clone();
        if (clone) clone.fire("atlaskit");
        fnRef.current(analyticsEvent);
    }, [
        // These are strings and won't change
        action,
        componentName,
        packageName,
        packageVersion,
        // This function is memoized in the context
        createAnalyticsEvent,
        // these are a stable ref because of the useTrackedRef hook
        dataRef,
        fnRef
    ]);
    return handler;
}



var $Bb0he = parcelRequire("Bb0he");

var $6Oq6X = parcelRequire("6Oq6X");


var $dAx5m = parcelRequire("dAx5m");


var $dAx5m = parcelRequire("dAx5m");

var $dd4sf = parcelRequire("dd4sf");
var $37b57ac5503eb7b3$var$isMatchMediaAvailable = function isMatchMediaAvailable() {
    return typeof window !== "undefined" && "matchMedia" in window;
};
var $37b57ac5503eb7b3$export$b7baf7667a68d87c = function isReducedMotion() {
    if (!$37b57ac5503eb7b3$var$isMatchMediaAvailable()) return false;
    var _window$matchMedia = window.matchMedia("(prefers-reduced-motion: reduce)"), matches = _window$matchMedia.matches;
    return matches;
};
var $37b57ac5503eb7b3$export$c537e63161742ce3 = function useIsReducedMotion() {
    var _useState = (0, $dAx5m.useState)($37b57ac5503eb7b3$export$b7baf7667a68d87c), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($6f4c9344050d46f7$exports)))(_useState, 2), prefersReducedMotion = _useState2[0], setPrefersReducedMotion = _useState2[1];
    (0, $dAx5m.useEffect)(function() {
        if (!$37b57ac5503eb7b3$var$isMatchMediaAvailable()) return;
        var mediaQueryList = window.matchMedia("(prefers-reduced-motion: reduce)");
        var onChange = function onChange(event) {
            return setPrefersReducedMotion(event.matches);
        };
        return (0, $dd4sf.bind)(mediaQueryList, {
            type: "change",
            listener: onChange
        });
    }, []);
    return prefersReducedMotion;
};
var $37b57ac5503eb7b3$export$f0f789643ba5a83c = {
    "@media (prefers-reduced-motion: reduce)": {
        animation: "none",
        transition: "none"
    }
};
var $37b57ac5503eb7b3$export$ff7706047246b98b = function prefersReducedMotion() {
    return $37b57ac5503eb7b3$export$f0f789643ba5a83c;
};


var $d21c73d755841d01$export$d1e013d71d2e2121 = {
    // Motions will always appear if not inside a exiting persistence component.
    appear: true,
    isExiting: false
};
var $d21c73d755841d01$export$b9c4904d7a6929e6 = /*#__PURE__*/ (0, $dAx5m.createContext)($d21c73d755841d01$export$d1e013d71d2e2121);
var $d21c73d755841d01$export$e4c4c45693c3a7c = function wrapChildWithContextProvider(child) {
    var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $d21c73d755841d01$export$d1e013d71d2e2121;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement($d21c73d755841d01$export$b9c4904d7a6929e6.Provider, {
        key: "".concat(child.key, "-provider"),
        value: value
    }, child);
};
var $d21c73d755841d01$export$7032ae6d9d98bedd = function childrenToArray(children) {
    var childrenAsArray = [];
    // We convert children to an array using this helper method as it will add keys to children that do not
    // have them, such as when we have hardcoded children that are conditionally rendered.
    (0, $dAx5m.Children).toArray(children).forEach(function(child) {
        // We ignore any boolean children to make our code a little more simple later on,
        // and also filter out any falsies (empty strings, nulls, and undefined).
        if (typeof child !== "boolean" && Boolean(child)) // Children WILL have a key after being forced into an array using the React.Children helper.
        childrenAsArray.push(child);
    });
    return childrenAsArray;
};
var $d21c73d755841d01$export$2ccbe4ff092af328 = function spliceNewElementsIntoPrevious(current, previous) {
    var splicedChildren = previous.concat([]);
    var previousMap = $d21c73d755841d01$export$1d8c49f95a162a41(previous);
    for(var i = 0; i < current.length; i++){
        var child = current[i];
        var childIsNew = !previousMap[child.key];
        if (childIsNew) // This will insert the new element after the previous element.
        splicedChildren.splice(i + 1, 0, child);
    }
    return splicedChildren;
};
var $d21c73d755841d01$export$1d8c49f95a162a41 = function childrenToObj(children) {
    return children.reduce(function(acc, child) {
        acc[child.key] = child;
        return acc;
    }, {});
};
var $d21c73d755841d01$var$getMissingKeys = function getMissingKeys(current, previous) {
    var currentMapKeys = new Set(current.map(function(child) {
        return child.key;
    }));
    var missing = new Set();
    for(var i = 0; i < previous.length; i++){
        var element = previous[i];
        var _key = element.key;
        if (!currentMapKeys.has(_key)) missing.add(_key);
    }
    return missing;
};
/**
 * __ExitingPersistence__
 *
 * Useful for enabling elements to persist and animate away when they are removed from the DOM.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motions)
 */ var $d21c73d755841d01$var$ExitingPersistence = /*#__PURE__*/ (0, $dAx5m.memo)(function(_ref) {
    var _ref$appear = _ref.appear, appear = _ref$appear === void 0 ? false : _ref$appear, children = _ref.children, exitThenEnter = _ref.exitThenEnter;
    var _useState = (0, $dAx5m.useState)([
        null,
        children
    ]), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($6f4c9344050d46f7$exports)))(_useState, 2), stateChildren = _useState2[0], setChildren = _useState2[1];
    var _useState3 = (0, $dAx5m.useState)([]), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($6f4c9344050d46f7$exports)))(_useState3, 2), exitingChildren = _useState4[0], setExitingChildren = _useState4[1];
    var _useState5 = (0, $dAx5m.useState)(function() {
        return {
            appear: appear,
            isExiting: false
        };
    }), _useState6 = (0, (/*@__PURE__*/$parcel$interopDefault($6f4c9344050d46f7$exports)))(_useState5, 2), defaultContext = _useState6[0], setDefaultContext = _useState6[1];
    (0, $dAx5m.useEffect)(function() {
        if (!defaultContext.appear) setDefaultContext({
            appear: true,
            isExiting: false
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    if ((0, $37b57ac5503eb7b3$export$b7baf7667a68d87c)()) return children;
    /**
   * NOTE: This is a workaround for the test case written in Jira where the stateChildren is a boolean value because
   * useState is mocked to return a boolean value.
   */ if (typeof stateChildren === "boolean") return children;
    var _stateChildren = (0, (/*@__PURE__*/$parcel$interopDefault($6f4c9344050d46f7$exports)))(stateChildren, 2), previousChildren = _stateChildren[0], currentChildren = _stateChildren[1];
    var previous = $d21c73d755841d01$export$7032ae6d9d98bedd(previousChildren);
    var current = $d21c73d755841d01$export$7032ae6d9d98bedd(currentChildren);
    if (currentChildren !== children) setChildren([
        currentChildren,
        children
    ]);
    var missingKeys = $d21c73d755841d01$var$getMissingKeys(current, previous);
    var isSomeChildRemoved = !!missingKeys.size;
    var visibleChildren = current;
    if (isSomeChildRemoved) visibleChildren = $d21c73d755841d01$export$2ccbe4ff092af328(current, previous);
    if (exitThenEnter) {
        if (exitingChildren.length) visibleChildren = exitingChildren;
        else {
            var nextExitingChildren = visibleChildren.filter(function(child) {
                return missingKeys.has(child.key);
            });
            if (nextExitingChildren.length) setExitingChildren(nextExitingChildren);
        }
    }
    if (missingKeys.size) visibleChildren = visibleChildren.map(function(child) {
        var isExiting = missingKeys.has(child.key);
        return $d21c73d755841d01$export$e4c4c45693c3a7c(child, {
            appear: true,
            isExiting: isExiting,
            onFinish: isExiting ? function() {
                missingKeys.delete(child.key);
                if (missingKeys.size === 0) {
                    setChildren([
                        null,
                        children
                    ]);
                    setExitingChildren([]);
                }
            } : undefined
        });
    });
    else visibleChildren = visibleChildren.map(function(child) {
        return $d21c73d755841d01$export$e4c4c45693c3a7c(child, defaultContext);
    });
    return visibleChildren;
});
var $d21c73d755841d01$export$3b6f38abbdcbd000 = function useExitingPersistence() {
    return (0, $dAx5m.useContext)($d21c73d755841d01$export$b9c4904d7a6929e6);
};
$d21c73d755841d01$var$ExitingPersistence.displayName = "ExitingPersistence";
var $d21c73d755841d01$export$2e2bcd8739ae039 = $d21c73d755841d01$var$ExitingPersistence;



var $dAx5m = parcelRequire("dAx5m");
var $ab1e9e3c089ac9c0$export$c07234257a03d5e9 = "cubic-bezier(0.15,1,0.3,1)";
var $ab1e9e3c089ac9c0$export$57636bb43b1ccbb0 = "cubic-bezier(0.2,0,0,1)";
var $ab1e9e3c089ac9c0$export$929e5a82286172a6 = "cubic-bezier(0.8,0,0,0.8)";


/**
 * Think of this as the motion equivalent of the @atlaskit/theme `grid()`.
 */ var $316c2e4385c9646e$export$368bacef0dacbe05 = 25;
var $316c2e4385c9646e$export$2023a81c8547415f = $316c2e4385c9646e$export$368bacef0dacbe05 * 4;
var $316c2e4385c9646e$export$6fa259be09e118a7 = $316c2e4385c9646e$export$368bacef0dacbe05 * 14;
var $316c2e4385c9646e$export$9424640c29bc466d = $316c2e4385c9646e$export$368bacef0dacbe05 * 28;





var $dAx5m = parcelRequire("dAx5m");

var $jVTBW = parcelRequire("jVTBW");



var $dAx5m = parcelRequire("dAx5m");
var $c9a868db6c92b422$var$getHookDeps = function getHookDeps(opts) {
    switch(opts.cleanup){
        case "next-effect":
            return undefined;
        case "unmount":
        default:
            return [];
    }
};
var $c9a868db6c92b422$export$1775f27e7c8051ca = function useRequestAnimationFrame() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        cleanup: "unmount"
    };
    var frames = (0, $dAx5m.useRef)([]);
    (0, $dAx5m.useEffect)(function() {
        return function() {
            if (frames.current.length) {
                frames.current.forEach(function(id) {
                    return cancelAnimationFrame(id);
                });
                frames.current = [];
            }
        };
    // We dynamically set this so we either clean up on the next effect - or on unmount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, $c9a868db6c92b422$var$getHookDeps(opts));
    return (0, $dAx5m.useCallback)(function(handler) {
        var id = requestAnimationFrame(function(time) {
            frames.current = frames.current.filter(function(frameId) {
                return frameId !== id;
            });
            handler(time);
        });
        frames.current.push(id);
    }, []);
};
var $c9a868db6c92b422$export$4f34107a2b00f39c = function useSetTimeout() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        cleanup: "unmount"
    };
    var timeouts = (0, $dAx5m.useRef)([]);
    (0, $dAx5m.useEffect)(function() {
        return function() {
            if (timeouts.current.length) {
                timeouts.current.forEach(function(id) {
                    return clearTimeout(id);
                });
                timeouts.current = [];
            }
        };
    // We dynamically set this so we either clean up on the next effect - or on unmount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, $c9a868db6c92b422$var$getHookDeps(opts));
    return (0, $dAx5m.useCallback)(function(handler, timeout) {
        for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
        var id = setTimeout.apply(void 0, [
            function() {
                timeouts.current = timeouts.current.filter(function(timeoutId) {
                    return timeoutId !== id;
                });
                handler();
            },
            timeout
        ].concat(args));
        timeouts.current.push(id);
    }, []);
};





var $dAx5m = parcelRequire("dAx5m");

var $Bb0he = parcelRequire("Bb0he");

var $dAx5m = parcelRequire("dAx5m");
var $a66918b6006b011e$export$e5c5a5f917a5871c = typeof window === "undefined" ? (0, $dAx5m.useEffect) : (0, $dAx5m.useLayoutEffect);


/* eslint-disable @repo/internal/react/disallow-unstable-values */ 
var $dAx5m = parcelRequire("dAx5m");
function $680d3d5042d5f0e4$export$c485849f2e393253() {
    var identifier = (0, $dAx5m.useRef)("");
    if (!identifier.current) identifier.current = "_" + (Number(String(Math.random()).slice(2)) + Date.now() + Math.round(performance.now())).toString(36);
    return identifier.current;
}


var $4d5351b3c71165fc$var$StaggeredEntranceContext = /*#__PURE__*/ (0, $dAx5m.createContext)(function() {
    return {
        isReady: true,
        delay: 0,
        ref: (0, $Bb0he.default)
    };
});
var $4d5351b3c71165fc$export$25c7213fc07ec080 = function useStaggeredEntrance() {
    var indentifier = (0, $680d3d5042d5f0e4$export$c485849f2e393253)();
    var context = (0, $dAx5m.useContext)($4d5351b3c71165fc$var$StaggeredEntranceContext);
    return context(indentifier);
};
/**
 * For a list of elements that need to animate in,
 * this should be used in conjunction with entering components.
 * This does not need Javascript to execute so it will run immediately for any SSR rendered React apps before the JS has executed.
 *
 * Will dynamically add delay to each child entering component.
 * Unfortunately all entering components _NEED_ to be a direct descendant.
 */ var $4d5351b3c71165fc$var$StaggeredEntrance = function StaggeredEntrance(_ref) {
    var children = _ref.children, column = _ref.column, _ref$columns = _ref.columns, columns = _ref$columns === void 0 ? "responsive" : _ref$columns, _ref$delayStep = _ref.delayStep, delayStep = _ref$delayStep === void 0 ? 50 : _ref$delayStep;
    var elementRefs = (0, $dAx5m.useRef)([]);
    var indexes = [];
    var _useState = (0, $dAx5m.useState)(function() {
        if (typeof columns === "number") // A hardcoded columns is set so bail out and set it to that!
        return columns;
        if (typeof column === "number") // A hardcoded column is set so we will set actualColumns to be 1.
        return 1;
        // We are in "responsive" mode.
        // So we will be calculating when the Javascript executes on the client how many columns there will be.
        return 0;
    }), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($6f4c9344050d46f7$exports)))(_useState, 2), actualColumns = _useState2[0], setActualColumns = _useState2[1];
    (0, $a66918b6006b011e$export$e5c5a5f917a5871c)(function() {
        // We want to only run this code when we are in "responsive" mode.
        // It is assumed we are in responsive mode if `columns` is "responsive",
        // we have children element refs ready to be read (i.e. if there are no children this won't run as well)
        // and finally that `actualColumns` is `0` - this is because for the first render cycle `actualColumns` will be `0` (set above)
        // and then after this layout effect runs the value for `actualColumns` will then be calculated and set.
        if (columns === "responsive" && elementRefs.current.length && actualColumns === 0) {
            var currentTop = 0;
            var numberColumns = 0;
            if (elementRefs.current.length <= 1) {
                setActualColumns(1);
                return;
            }
            // We set the current top to the first elements.
            // We will be comparing this and incrementing the column count
            // until we hit an element that has a different offset top (or we run out of elements).
            currentTop = elementRefs.current[0] ? elementRefs.current[0].offsetTop : 0;
            for(var i = 0; i < elementRefs.current.length; i++){
                var child = elementRefs.current[i];
                if (!child) break;
                if (currentTop === child.offsetTop) {
                    numberColumns += 1;
                    if (elementRefs.current.length - 1 === i) setActualColumns(numberColumns);
                    continue;
                }
                setActualColumns(numberColumns);
                break;
            }
        }
    // We only want this effect to run once - on initial mount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement($4d5351b3c71165fc$var$StaggeredEntranceContext.Provider, {
        value: function value(id) {
            if (!indexes.includes(id)) indexes.push(id);
            var isReady = actualColumns > 0;
            var index = indexes.indexOf(id);
            var currentColumn = column || index % actualColumns;
            var currentRow = Math.floor(index / actualColumns);
            var distanceFromTopLeftElement = currentRow + currentColumn;
            // We don't want loads of elements to have the same staggered delay as it ends up looking slow for users.
            // To get around that we calculate the logarithm using `distanceFromTopLeftElement` which ends making
            // elements appear faster the further away from the top left element.
            var delay = Math.ceil(Math.log(distanceFromTopLeftElement + 1) * delayStep * 1.5) || 0;
            return {
                delay: delay,
                isReady: isReady,
                ref: function ref(element) {
                    return elementRefs.current[index] = element;
                }
            };
        }
    }, children);
};
var $4d5351b3c71165fc$export$2e2bcd8739ae039 = $4d5351b3c71165fc$var$StaggeredEntrance;


function $0f5d0c446ef9f2e4$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $0f5d0c446ef9f2e4$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $0f5d0c446ef9f2e4$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($c3ec97511ae1ed64$exports)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $0f5d0c446ef9f2e4$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
/**
 * These are props that motions should use as their external props for consumers.
 * See [FadeIn](packages/helpers/motion/src/entering/fade-in.tsx) for an example usage.
 */ /**
 * Used to multiply the initial duration for exiting motions.
 */ var $0f5d0c446ef9f2e4$var$EXITING_MOTION_MULTIPLIER = 0.5;
/**
 * This is the base INTERNAL component used for all other entering motions.
 * This does not need Javascript to execute on the client so it will run immediately
 * for any SSR rendered React apps before the JS has executed.
 */ var $0f5d0c446ef9f2e4$var$EnteringMotion = function EnteringMotion(_ref) {
    var children = _ref.children, animationTimingFunction = _ref.animationTimingFunction, enteringAnimation = _ref.enteringAnimation, exitingAnimation = _ref.exitingAnimation, isPaused = _ref.isPaused, onFinishMotion = _ref.onFinish, _ref$duration = _ref.duration, duration = _ref$duration === void 0 ? (0, $316c2e4385c9646e$export$9424640c29bc466d) : _ref$duration;
    var staggered = (0, $4d5351b3c71165fc$export$25c7213fc07ec080)();
    var _useExitingPersistenc = (0, $d21c73d755841d01$export$3b6f38abbdcbd000)(), isExiting = _useExitingPersistenc.isExiting, onExitFinished = _useExitingPersistenc.onFinish, appear = _useExitingPersistenc.appear;
    var setTimeout = (0, $c9a868db6c92b422$export$4f34107a2b00f39c)();
    var paused = isPaused || !staggered.isReady;
    var delay = isExiting ? 0 : staggered.delay;
    var state = isExiting ? "exiting" : "entering";
    var _useState = (0, $dAx5m.useState)(appear), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($6f4c9344050d46f7$exports)))(_useState, 2), hasAnimationStyles = _useState2[0], setHasAnimationStyles = _useState2[1];
    (0, $dAx5m.useEffect)(function() {
        // Tracking this to prevent changing state on an unmounted component
        var isCancelled = false;
        if (paused) return;
        // On initial mount if elements aren't set to animate on appear, we return early and callback
        if (!appear) {
            onFinishMotion && onFinishMotion(state);
            return;
        }
        // Elements may need animation styles back after initial mount (they could animate out)
        setHasAnimationStyles(true);
        setTimeout(function() {
            if (state === "exiting") onExitFinished && onExitFinished();
            if (!isCancelled) setHasAnimationStyles(false);
            onFinishMotion && onFinishMotion(state);
        }, isExiting ? duration * $0f5d0c446ef9f2e4$var$EXITING_MOTION_MULTIPLIER : duration + delay);
        return function() {
            isCancelled = true;
        };
    // We ignore this for onFinishMotion as consumers could potentially inline the function
    // which would then trigger this effect every re-render.
    // We want to make it easier for consumers so we go down this path unfortunately.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        onExitFinished,
        state,
        isExiting,
        duration,
        delay,
        paused,
        setTimeout
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $jVTBW.ClassNames), null, function(_ref2) {
        var css = _ref2.css;
        return children({
            ref: staggered.ref,
            className: hasAnimationStyles ? css($0f5d0c446ef9f2e4$var$_objectSpread($0f5d0c446ef9f2e4$var$_objectSpread({}, (0, $37b57ac5503eb7b3$export$f0f789643ba5a83c)), {}, {
                animationDelay: "".concat(delay, "ms"),
                animationDuration: "".concat(isExiting ? duration * $0f5d0c446ef9f2e4$var$EXITING_MOTION_MULTIPLIER : duration, "ms"),
                animationFillMode: isExiting ? "forwards" : "backwards",
                animationName: "".concat((0, $jVTBW.keyframes)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                isExiting ? exitingAnimation || enteringAnimation : enteringAnimation)),
                animationPlayState: paused ? "paused" : "running",
                animationTimingFunction: animationTimingFunction(state)
            })) : ""
        }, state);
    });
};
var $0f5d0c446ef9f2e4$export$2e2bcd8739ae039 = $0f5d0c446ef9f2e4$var$EnteringMotion;


function $fb095636241fc7ae$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $fb095636241fc7ae$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $fb095636241fc7ae$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($c3ec97511ae1ed64$exports)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $fb095636241fc7ae$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $fb095636241fc7ae$var$directionMotions = {
    proportional: {
        bottom: "translate3d(0, calc(5% + 4px), 0)",
        left: "translate3d(calc(-5% - 4px), 0, 0)",
        right: "translate3d(calc(5% + 4px), 0, 0)",
        top: "translate3d(0, calc(-5% - 4px), 0)"
    },
    constant: {
        bottom: "translate3d(0, 4px, 0)",
        left: "translate3d(-4px, 0, 0)",
        right: "translate3d(4px, 0, 0)",
        top: "translate3d(0, -4px, 0)"
    }
};
var $fb095636241fc7ae$var$invertedDirection = {
    top: "bottom",
    bottom: "top",
    left: "right",
    right: "left"
};
var $fb095636241fc7ae$export$8497679fcaaeceb = function fadeInAnimation(direction) {
    var distance = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "proportional";
    return {
        from: $fb095636241fc7ae$var$_objectSpread({
            opacity: 0
        }, direction !== undefined && {
            transform: $fb095636241fc7ae$var$directionMotions[distance][direction]
        }),
        "50%": {
            opacity: 1
        },
        to: {
            transform: direction !== undefined ? "none" : undefined
        }
    };
};
var $fb095636241fc7ae$export$c9190c6659ea755b = function fadeOutAnimation(direction) {
    var distance = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "proportional";
    return {
        from: {
            opacity: 1,
            transform: direction !== undefined ? "translate3d(0, 0, 0)" : undefined
        },
        to: $fb095636241fc7ae$var$_objectSpread({
            opacity: 0
        }, direction !== undefined && {
            transform: $fb095636241fc7ae$var$directionMotions[distance][direction]
        })
    };
};
/**
 * Props for controlling the behavior of the FadeIn animation
 */ /**
 * __FadeIn__
 *
 * Useful for fading in one or more elements.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motions)
 */ var $fb095636241fc7ae$var$FadeIn = function FadeIn(_ref) {
    var children = _ref.children, _ref$duration = _ref.duration, duration = _ref$duration === void 0 ? (0, $316c2e4385c9646e$export$9424640c29bc466d) : _ref$duration, entranceDirection = _ref.entranceDirection, exitDirection = _ref.exitDirection, _ref$distance = _ref.distance, distance = _ref$distance === void 0 ? "proportional" : _ref$distance, onFinish = _ref.onFinish, isPaused = _ref.isPaused;
    var invertedEntranceDirection = entranceDirection && $fb095636241fc7ae$var$invertedDirection[entranceDirection];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $0f5d0c446ef9f2e4$export$2e2bcd8739ae039), {
        duration: duration,
        enteringAnimation: $fb095636241fc7ae$export$8497679fcaaeceb(entranceDirection, distance),
        exitingAnimation: $fb095636241fc7ae$export$c9190c6659ea755b(exitDirection || invertedEntranceDirection, distance),
        animationTimingFunction: function animationTimingFunction() {
            return 0, $ab1e9e3c089ac9c0$export$c07234257a03d5e9;
        },
        onFinish: onFinish,
        isPaused: isPaused
    }, children);
};
var $fb095636241fc7ae$export$2e2bcd8739ae039 = $fb095636241fc7ae$var$FadeIn;






var $dAx5m = parcelRequire("dAx5m");

var $2BQLr = parcelRequire("2BQLr");

// Export types from PopperJS / React Popper
var $f68ea3a56f7d868d$var$constantModifiers = [
    {
        name: "flip",
        options: {
            flipVariations: false,
            padding: 5,
            boundary: "clippingParents",
            rootBoundary: "viewport"
        }
    },
    {
        name: "preventOverflow",
        options: {
            padding: 5,
            rootBoundary: "document"
        }
    }
];
function $f68ea3a56f7d868d$var$defaultChildrenFn() {
    return null;
}
var $f68ea3a56f7d868d$var$defaultOffset = [
    0,
    8
];
function $f68ea3a56f7d868d$export$badac9ada3a0bdf9(_ref) {
    var _ref$children = _ref.children, children = _ref$children === void 0 ? $f68ea3a56f7d868d$var$defaultChildrenFn : _ref$children, _ref$offset = _ref.offset, offset = _ref$offset === void 0 ? $f68ea3a56f7d868d$var$defaultOffset : _ref$offset, _ref$placement = _ref.placement, placement = _ref$placement === void 0 ? "bottom-start" : _ref$placement, _ref$referenceElement = _ref.referenceElement, referenceElement = _ref$referenceElement === void 0 ? undefined : _ref$referenceElement, modifiers = _ref.modifiers, _ref$strategy = _ref.strategy, strategy = _ref$strategy === void 0 ? "fixed" : _ref$strategy;
    var _offset = (0, (/*@__PURE__*/$parcel$interopDefault($6f4c9344050d46f7$exports)))(offset, 2), offsetX = _offset[0], offsetY = _offset[1];
    // Merge a new offset modifier only if new offset values passed in
    var internalModifiers = (0, $dAx5m.useMemo)(function() {
        var offsetModifier = {
            name: "offset",
            options: {
                offset: [
                    offsetX,
                    offsetY
                ]
            }
        };
        return [].concat($f68ea3a56f7d868d$var$constantModifiers, [
            offsetModifier
        ]);
    }, [
        offsetX,
        offsetY
    ]);
    // Merge custom props and memoize
    var mergedModifiers = (0, $dAx5m.useMemo)(function() {
        if (modifiers == null) return internalModifiers;
        return [].concat((0, (/*@__PURE__*/$parcel$interopDefault($d5f3651f1c5ee1c2$exports)))(internalModifiers), (0, (/*@__PURE__*/$parcel$interopDefault($d5f3651f1c5ee1c2$exports)))(modifiers));
    }, [
        internalModifiers,
        modifiers
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $2BQLr.Popper), {
        modifiers: mergedModifiers,
        placement: placement,
        strategy: strategy,
        referenceElement: referenceElement
    }, children);
}



var $dAx5m = parcelRequire("dAx5m");

var $jAmv0 = parcelRequire("jAmv0");

var $dAx5m = parcelRequire("dAx5m");

var $1MpXQ = parcelRequire("1MpXQ");
var $0bdc3197d4c8e0f6$export$e4c79eb95c23a0da = "atlaskit-portal-container";
var $0bdc3197d4c8e0f6$export$72f415121273627e = "body > .atlaskit-portal-container";
var $0bdc3197d4c8e0f6$export$13f57c02915787b3 = "atlaskit-portal";


var $453ee6e5dac79954$export$26ae5ca175b4ec5a = function createContainer(zIndex) {
    var container = document.createElement("div");
    container.className = (0, $0bdc3197d4c8e0f6$export$13f57c02915787b3);
    container.style.zIndex = "".concat(zIndex);
    return container;
};
/**
 * Returns document body element
 * @return {number} - The document body element
 */ var $453ee6e5dac79954$var$getBody = function getBody() {
    return document.body;
};
/**
 * Returns portal parent container. If no container exists already then it creates a new container with class name 'atlaskit-portal-container'
 * @return {Element} - The portal parent container div element
 */ var $453ee6e5dac79954$var$getPortalParent = function getPortalParent() {
    var parentElement = document.querySelector((0, $0bdc3197d4c8e0f6$export$72f415121273627e));
    if (!parentElement) {
        var _getBody;
        var parent = document.createElement("div");
        parent.className = (0, $0bdc3197d4c8e0f6$export$e4c79eb95c23a0da);
        // we are setting display to flex because we want each portal to create a new stacking context
        // See https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Positioning/Understanding_z_index/The_stacking_context
        parent.style.display = "flex";
        (_getBody = $453ee6e5dac79954$var$getBody()) === null || _getBody === void 0 || _getBody.appendChild(parent);
        return parent;
    }
    return parentElement;
};
var $453ee6e5dac79954$export$da99f98bf3fe55b3 = function removePortalContainer(container) {
    $453ee6e5dac79954$var$getPortalParent().removeChild(container);
};
var $453ee6e5dac79954$export$c582005add11e141 = function appendPortalContainerIfNotAppended(container) {
    if (!container.parentElement) $453ee6e5dac79954$var$getPortalParent().appendChild(container);
};
var $453ee6e5dac79954$export$842dfe7a9f24298 = function isDocumentDefined() {
    return document !== undefined;
};
var $453ee6e5dac79954$export$fef014d7cef9e543 = function createAtlaskitPortal(zIndex) {
    //atlaskit-portal div
    if ($453ee6e5dac79954$export$842dfe7a9f24298()) {
        var atlaskitportal = document.createElement("div");
        atlaskitportal.className = (0, $0bdc3197d4c8e0f6$export$13f57c02915787b3);
        atlaskitportal.style.zIndex = "".concat(zIndex);
        return atlaskitportal;
    }
};
var $453ee6e5dac79954$export$95029ca7aca2989e = function createPortalParent() {
    //atlaskit-portal-container div
    if ($453ee6e5dac79954$export$842dfe7a9f24298()) {
        var parentElement = document.querySelector((0, $0bdc3197d4c8e0f6$export$72f415121273627e));
        if (!parentElement) {
            var _getBody2;
            var parent = document.createElement("div");
            parent.className = (0, $0bdc3197d4c8e0f6$export$e4c79eb95c23a0da);
            parent.style.display = "flex";
            (_getBody2 = $453ee6e5dac79954$var$getBody()) === null || _getBody2 === void 0 || _getBody2.appendChild(parent);
            return parent;
        }
        return parentElement;
    }
};


function $cfb3b5ec42c03ead$export$2e2bcd8739ae039(props) {
    var zIndex = props.zIndex, children = props.children;
    var container = (0, $dAx5m.useMemo)(function() {
        return (0, $453ee6e5dac79954$export$26ae5ca175b4ec5a)(zIndex);
    }, [
        zIndex
    ]);
    // This is in the render method instead of useEffect so that
    // the portal will be added to the DOM before the children render.
    // For any further changes, ensure that the container does not have a
    // parent besides the portal parent.
    (0, $453ee6e5dac79954$export$c582005add11e141)(container);
    (0, $dAx5m.useEffect)(function() {
        return function() {
            (0, $453ee6e5dac79954$export$da99f98bf3fe55b3)(container);
        };
    }, [
        container
    ]);
    return /*#__PURE__*/ (0, $1MpXQ.createPortal)(children, container);
}




var $dAx5m = parcelRequire("dAx5m");

var $1MpXQ = parcelRequire("1MpXQ");

var $dAx5m = parcelRequire("dAx5m");
var $83b22d9d47cb9c00$export$700979bc83e7db82 = typeof window !== "undefined" ? (0, $dAx5m.useLayoutEffect) : (0, $dAx5m.useEffect);



function $31f01da06142cfea$export$2e2bcd8739ae039(props) {
    var zIndex = props.zIndex, children = props.children;
    var _useState = (0, $dAx5m.useState)(null), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($6f4c9344050d46f7$exports)))(_useState, 2), atlaskitPortal = _useState2[0], setAtlaskitPortal = _useState2[1];
    (0, $83b22d9d47cb9c00$export$700979bc83e7db82)(function() {
        var tempPortalContainer = (0, $453ee6e5dac79954$export$fef014d7cef9e543)(zIndex);
        setAtlaskitPortal(tempPortalContainer);
        var portalParent = (0, $453ee6e5dac79954$export$95029ca7aca2989e)();
        if (!tempPortalContainer || !portalParent) return;
        portalParent.appendChild(tempPortalContainer);
        return function() {
            if (tempPortalContainer) portalParent.removeChild(tempPortalContainer);
            setAtlaskitPortal(null);
        };
    }, [
        zIndex
    ]);
    return atlaskitPortal ? /*#__PURE__*/ (0, $1MpXQ.createPortal)(children, atlaskitPortal) : null;
}




var $dAx5m = parcelRequire("dAx5m");

var $f583fa02d512730d$var$useIsSubsequentRender = function useIsSubsequentRender(mountStrategy) {
    var _useState = (0, $dAx5m.useState)(false), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($6f4c9344050d46f7$exports)))(_useState, 2), isSubsequentRender = _useState2[0], setIsSubsequentRender = _useState2[1];
    var _useState3 = (0, $dAx5m.useState)(function() {
        return mountStrategy === "layoutEffect" ? (0, $83b22d9d47cb9c00$export$700979bc83e7db82) : (0, $dAx5m.useEffect);
    }), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($6f4c9344050d46f7$exports)))(_useState3, 1), useMountEffect = _useState4[0];
    useMountEffect(function() {
        setIsSubsequentRender(true);
    }, []);
    return isSubsequentRender;
};
var $f583fa02d512730d$export$2e2bcd8739ae039 = $f583fa02d512730d$var$useIsSubsequentRender;



var $dAx5m = parcelRequire("dAx5m");
var $271e6d8f9a85ae4d$export$ed5835cc67e87f72 = "akPortalMount";
var $271e6d8f9a85ae4d$export$80816bd900e5bd00 = "akPortalUnmount";


var $1367559dab7c5ab9$var$zIndexToName = {
    100: "card",
    200: "navigation",
    300: "dialog",
    400: "layer",
    500: "blanket",
    510: "modal",
    600: "flag",
    700: "spotlight",
    9999: "tooltip"
};
/**
 * return layer name in Atlassian design system corresponding to given z-index
 * @param {number} zIndex - z-index value for which layer name is needed
 * @returns {LayerName | null} - The layer name for given z-index. If layer name is not found then null is returned
 */ var $1367559dab7c5ab9$var$getLayerName = function getLayerName(zIndex) {
    return $1367559dab7c5ab9$var$zIndexToName.hasOwnProperty(zIndex) ? $1367559dab7c5ab9$var$zIndexToName[zIndex] : null;
};
/**
 * Creates a PortalEvent object with given eventName, given zIndex and corresponding layer
 * @param {string} eventName - either of Mount or Unmount event name
 * @param {number} zIndex - z-index value which will be included in the event to be dispatched
 * @returns {PortalEvent} - The newly created PortalEvent object
 */ var $1367559dab7c5ab9$var$getEvent = function getEvent(eventName, zIndex) {
    var detail = {
        layer: $1367559dab7c5ab9$var$getLayerName(Number(zIndex)),
        zIndex: zIndex
    };
    return new CustomEvent(eventName, {
        detail: detail
    });
};
function $1367559dab7c5ab9$export$2e2bcd8739ae039(eventName, zIndex) {
    var event = $1367559dab7c5ab9$var$getEvent(eventName, zIndex);
    window.dispatchEvent(event);
}


var $e540bc41ce89d0f0$var$useFirePortalEvent = function useFirePortalEvent(zIndex) {
    var zIndexNumber = Number(zIndex);
    (0, $dAx5m.useEffect)(function() {
        (0, $1367559dab7c5ab9$export$2e2bcd8739ae039)((0, $271e6d8f9a85ae4d$export$ed5835cc67e87f72), zIndexNumber);
        return function() {
            (0, $1367559dab7c5ab9$export$2e2bcd8739ae039)((0, $271e6d8f9a85ae4d$export$80816bd900e5bd00), zIndexNumber);
        };
    }, [
        zIndexNumber
    ]);
};
var $e540bc41ce89d0f0$export$2e2bcd8739ae039 = $e540bc41ce89d0f0$var$useFirePortalEvent;


function $07879cb15ebdf8a5$export$2e2bcd8739ae039(_ref) {
    var _ref$zIndex = _ref.zIndex, zIndex = _ref$zIndex === void 0 ? 0 : _ref$zIndex, children = _ref.children, _ref$mountStrategy = _ref.mountStrategy, mountStrategy = _ref$mountStrategy === void 0 ? "effect" : _ref$mountStrategy;
    var isSubsequentRender = (0, $f583fa02d512730d$export$2e2bcd8739ae039)(mountStrategy);
    (0, $e540bc41ce89d0f0$export$2e2bcd8739ae039)(zIndex);
    // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
    return !(0, $jAmv0.fg)("dsp-19516-design-system-portal-logic-update") ? isSubsequentRender ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $cfb3b5ec42c03ead$export$2e2bcd8739ae039), {
        zIndex: zIndex
    }, children) : null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $31f01da06142cfea$export$2e2bcd8739ae039), {
        zIndex: zIndex
    }, children);
}



var $e2xkU = parcelRequire("e2xkU");
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // Reds
var $9ebab1f06de887cb$export$4b84fd0e2c617bd = "#FFEBE6";
var $9ebab1f06de887cb$export$b34b069eff244586 = "#FFBDAD";
var $9ebab1f06de887cb$export$be802dd0d8b57f35 = "#FF8F73";
var $9ebab1f06de887cb$export$60847d42f9da92a6 = "#FF7452";
var $9ebab1f06de887cb$export$4a7404f376229999 = "#FF5630";
var $9ebab1f06de887cb$export$2010d0fb4295b346 = "#DE350B";
var $9ebab1f06de887cb$export$2837b5a1a71d5c02 = "#BF2600";
var $9ebab1f06de887cb$export$8d9596b529bbb9cf = "#FFFAE6";
var $9ebab1f06de887cb$export$41060a744ab0b7ae = "#FFF0B3";
var $9ebab1f06de887cb$export$1cc05bbbf340e559 = "#FFE380";
var $9ebab1f06de887cb$export$5aae31392d72caaa = "#FFC400";
var $9ebab1f06de887cb$export$c6930421db9fa514 = "#FFAB00";
var $9ebab1f06de887cb$export$59619663aa6500fb = "#FF991F";
var $9ebab1f06de887cb$export$874739ea9e379ab6 = "#FF8B00";
var $9ebab1f06de887cb$export$8a6341c32b6a3ee6 = "#E3FCEF";
var $9ebab1f06de887cb$export$69a3bf21b9686c2b = "#ABF5D1";
var $9ebab1f06de887cb$export$afbce1382ec95f73 = "#79F2C0";
var $9ebab1f06de887cb$export$747d86715d4175de = "#57D9A3";
var $9ebab1f06de887cb$export$940e1f69e873f202 = "#36B37E";
var $9ebab1f06de887cb$export$a49394138f7b8e85 = "#00875A";
var $9ebab1f06de887cb$export$6fa04827ac68a4fb = "#006644";
var $9ebab1f06de887cb$export$226de0355ed012f8 = "#DEEBFF";
var $9ebab1f06de887cb$export$8c13c2ee36917869 = "#B3D4FF";
var $9ebab1f06de887cb$export$ecfc1dff386a3e7a = "#4C9AFF";
var $9ebab1f06de887cb$export$215b7063051591f1 = "#2684FF";
var $9ebab1f06de887cb$export$e62e8919cca44969 = "#0065FF";
var $9ebab1f06de887cb$export$b3de0ae08da2ce64 = "#0052CC";
var $9ebab1f06de887cb$export$a6ee3d71bc067634 = "#0747A6";
var $9ebab1f06de887cb$export$363e4475840015bb = "#EAE6FF";
var $9ebab1f06de887cb$export$4b0a4417ed59760f = "#C0B6F2";
var $9ebab1f06de887cb$export$6011520a64d9a187 = "#998DD9";
var $9ebab1f06de887cb$export$a7175d4e9206bc80 = "#8777D9";
var $9ebab1f06de887cb$export$b48405b95304b5a1 = "#6554C0";
var $9ebab1f06de887cb$export$c71e4279dd54a18d = "#5243AA";
var $9ebab1f06de887cb$export$147899de772240ec = "#403294";
var $9ebab1f06de887cb$export$2cf711fe14c66f06 = "#E6FCFF";
var $9ebab1f06de887cb$export$7a8f4d33f6f9772c = "#B3F5FF";
var $9ebab1f06de887cb$export$776c9c497ef08533 = "#79E2F2";
var $9ebab1f06de887cb$export$69cb3ca10c1e330e = "#00C7E6";
var $9ebab1f06de887cb$export$9dc1ef0f3f48059b = "#00B8D9";
var $9ebab1f06de887cb$export$7c835c78b6fcdef8 = "#00A3BF";
var $9ebab1f06de887cb$export$6036577f95c3877e = "#008DA6";
var $9ebab1f06de887cb$export$29a4f05edc054374 = "#FFFFFF";
var $9ebab1f06de887cb$export$e655ef011c4aa1a2 = "#FAFBFC";
var $9ebab1f06de887cb$export$9fdfb749e33cdf97 = "#F4F5F7";
var $9ebab1f06de887cb$export$3e51e8f1440314ba = "#EBECF0";
var $9ebab1f06de887cb$export$1ce2d1575d444ceb = "#DFE1E6";
var $9ebab1f06de887cb$export$8754fc7e6d8b3000 = "#C1C7D0";
var $9ebab1f06de887cb$export$c2e91cbeada39b8b = "#B3BAC5";
var $9ebab1f06de887cb$export$5f71e19f3a7ad9de = "#A5ADBA";
var $9ebab1f06de887cb$export$eaa8c8a70ac22806 = "#97A0AF";
var $9ebab1f06de887cb$export$7c87d337fb91a97d = "#8993A4";
var $9ebab1f06de887cb$export$d6447c357493214f = "#7A869A";
var $9ebab1f06de887cb$export$f563ee71e9ee74cd = "#6B778C";
var $9ebab1f06de887cb$export$e2ef2124cf4024b1 = "#5E6C84";
var $9ebab1f06de887cb$export$eece5f492e429f08 = "#505F79";
var $9ebab1f06de887cb$export$c39c0fe0f26207ae = "#42526E";
var $9ebab1f06de887cb$export$7090862dc3038a9f = "#344563";
var $9ebab1f06de887cb$export$ad0bacf983b7ddaa = "#253858";
var $9ebab1f06de887cb$export$7d61b15e0da132af = "#172B4D";
var $9ebab1f06de887cb$export$fbda843f0a27fe96 = "#091E42";
var $9ebab1f06de887cb$export$791e57b27ca738ef = "rgba(9, 30, 66, 0.02)";
var $9ebab1f06de887cb$export$8d43898f60b96a82 = "rgba(9, 30, 66, 0.04)";
var $9ebab1f06de887cb$export$920c0d5c49070351 = "rgba(9, 30, 66, 0.08)";
var $9ebab1f06de887cb$export$46987b49aab6d1a8 = "rgba(9, 30, 66, 0.13)";
var $9ebab1f06de887cb$export$7d3359664e8bb0e5 = "rgba(9, 30, 66, 0.25)";
var $9ebab1f06de887cb$export$d2d3bedfb276cac0 = "rgba(9, 30, 66, 0.31)";
var $9ebab1f06de887cb$export$6e5e7499ff054f6d = "rgba(9, 30, 66, 0.36)";
var $9ebab1f06de887cb$export$59264b346c877fa7 = "rgba(9, 30, 66, 0.42)";
var $9ebab1f06de887cb$export$d092757d7c64925c = "rgba(9, 30, 66, 0.48)";
var $9ebab1f06de887cb$export$486ab785e4bac3c6 = "rgba(9, 30, 66, 0.54)";
var $9ebab1f06de887cb$export$fba592bbc6419fea = "rgba(9, 30, 66, 0.60)";
var $9ebab1f06de887cb$export$13609db0e6812ab8 = "rgba(9, 30, 66, 0.66)";
var $9ebab1f06de887cb$export$fbae4efaa892d883 = "rgba(9, 30, 66, 0.71)";
var $9ebab1f06de887cb$export$f13946d26f440ce6 = "rgba(9, 30, 66, 0.77)";
var $9ebab1f06de887cb$export$19f58225ac52a306 = "rgba(9, 30, 66, 0.82)";
var $9ebab1f06de887cb$export$6384f09da70e7b62 = "rgba(9, 30, 66, 0.89)";
var $9ebab1f06de887cb$export$d0dccc730683edc2 = "rgba(9, 30, 66, 0.95)";
var $9ebab1f06de887cb$export$2f6319cf7d736c2a = "#E6EDFA";
var $9ebab1f06de887cb$export$95126bc8884d6634 = "#DCE5F5";
var $9ebab1f06de887cb$export$8338d8c35d44ff1 = "#CED9EB";
var $9ebab1f06de887cb$export$5368d76ae4fbbda7 = "#B8C7E0";
var $9ebab1f06de887cb$export$9f0a771d16ec8d36 = "#ABBBD6";
var $9ebab1f06de887cb$export$abcf8c38338b4aa5 = "#9FB0CC";
var $9ebab1f06de887cb$export$97e81faa16a182c7 = "#8C9CB8";
var $9ebab1f06de887cb$export$bfe21c59123ecf33 = "#7988A3";
var $9ebab1f06de887cb$export$ee82aa2ea6a1558 = "#67758F";
var $9ebab1f06de887cb$export$682927c6ed76be02 = "#56637A";
var $9ebab1f06de887cb$export$91fd9994c5be9757 = "#455166";
var $9ebab1f06de887cb$export$d281fbfe3cff2df6 = "#3B475C";
var $9ebab1f06de887cb$export$3902c91d8b98a753 = "#313D52";
var $9ebab1f06de887cb$export$8e8133c1ba5845b5 = "#283447";
var $9ebab1f06de887cb$export$33ff357f6620b39 = "#202B3D";
var $9ebab1f06de887cb$export$633847cf062b69e0 = "#1B2638";
var $9ebab1f06de887cb$export$9776a6e503bdbf76 = "#121A29";
var $9ebab1f06de887cb$export$6c813d5160dff5db = "#0E1624";
var $9ebab1f06de887cb$export$3d4f271a500072a = "#0D1424";
var $9ebab1f06de887cb$export$fe151285c22759ec = "rgba(13, 20, 36, 0.06)";
var $9ebab1f06de887cb$export$a101c6190d0da34 = "rgba(13, 20, 36, 0.14)";
var $9ebab1f06de887cb$export$4b16f52932fda51 = "rgba(13, 20, 36, 0.18)";
var $9ebab1f06de887cb$export$a74bcd7b9845b0d8 = "rgba(13, 20, 36, 0.29)";
var $9ebab1f06de887cb$export$9209c179316d1751 = "rgba(13, 20, 36, 0.36)";
var $9ebab1f06de887cb$export$88f55133f636c8dd = "rgba(13, 20, 36, 0.40)";
var $9ebab1f06de887cb$export$51126f85d1009512 = "rgba(13, 20, 36, 0.47)";
var $9ebab1f06de887cb$export$a069b547bd23af78 = "rgba(13, 20, 36, 0.53)";
var $9ebab1f06de887cb$export$40cce05af3b2600a = "rgba(13, 20, 36, 0.63)";
var $9ebab1f06de887cb$export$b78942185925a0d = "rgba(13, 20, 36, 0.73)";
var $9ebab1f06de887cb$export$e058fb44b8eaafca = "rgba(13, 20, 36, 0.78)";
var $9ebab1f06de887cb$export$92b0b8de26920c18 = "rgba(13, 20, 36, 0.81)";
var $9ebab1f06de887cb$export$67564f7459d3fc9e = "rgba(13, 20, 36, 0.85)";
var $9ebab1f06de887cb$export$77868e1ca884ffa3 = "rgba(13, 20, 36, 0.89)";
var $9ebab1f06de887cb$export$2afd71d7d3ea2cd5 = "rgba(13, 20, 36, 0.92)";
var $9ebab1f06de887cb$export$f2a0acaab9972c70 = "rgba(13, 20, 36, 0.95)";
var $9ebab1f06de887cb$export$9ab70e67d6475361 = "rgba(13, 20, 36, 0.97)";


var $92e8426bf109a871$export$44ffba16bd48dac6 = "__ATLASKIT_THEME__";
var $92e8426bf109a871$export$c93026a968943f95 = "light";
var $92e8426bf109a871$export$6ba72c8346b4c57e = [
    "light",
    "dark"
];
var $92e8426bf109a871$export$7a57f79000377ca2 = function borderRadius() {
    return 3;
};
var $92e8426bf109a871$export$6d8204c2cb2e06b8 = function gridSize() {
    return 8;
};
var $92e8426bf109a871$export$85e3c3ca0c6fb93 = function fontSize() {
    return 14;
};
var $92e8426bf109a871$export$6746fe0d9c9fab54 = function fontSizeSmall() {
    return 11;
};
var $92e8426bf109a871$export$a5975749f0374264 = function fontFamily() {
    return "-apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif";
};
var $92e8426bf109a871$export$356129969ee49c55 = function codeFontFamily() {
    return "'SFMono-Medium', 'SF Mono', 'Segoe UI Mono', 'Roboto Mono', 'Ubuntu Mono', Menlo, Consolas, Courier, monospace";
};
var $92e8426bf109a871$export$8e24544ddba725ee = function focusRing() {
    var color = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "var(--ds-border-focused, ".concat((0, $9ebab1f06de887cb$export$215b7063051591f1), ")");
    var outlineWidth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $92e8426bf109a871$export$6d8204c2cb2e06b8() / 4;
    (0, $e2xkU.default)("@atlaskit/theme", "focus ring mixin", "Please use `@atlaskit/focus-ring` instead.");
    return "\n  &:focus {\n    outline: none;\n    box-shadow: 0px 0px 0px ".concat(outlineWidth, "px ").concat(color, ";\n  }\n");
};
var $92e8426bf109a871$export$c0dd343266bc3261 = function noFocusRing() {
    return "\n  box-shadow: none;\n";
};
var $92e8426bf109a871$export$7be255094ccdc533 = {
    card: function card() {
        return 100;
    },
    navigation: function navigation() {
        return 200;
    },
    dialog: function dialog() {
        return 300;
    },
    layer: function layer() {
        return 400;
    },
    blanket: function blanket() {
        return 500;
    },
    modal: function modal() {
        return 510;
    },
    flag: function flag() {
        return 600;
    },
    spotlight: function spotlight() {
        return 700;
    },
    tooltip: function tooltip() {
        return 9999;
    }
};
var $92e8426bf109a871$export$a1b3edb637fb4f35 = function visuallyHidden() {
    (0, $e2xkU.default)("@atlaskit/theme", "visually hidden mixin", "Please use `@atlaskit/visually-hidden` instead.");
    return {
        border: "0 !important",
        clip: "rect(1px, 1px, 1px, 1px) !important",
        height: "1px !important",
        overflow: "hidden !important",
        padding: "0 !important",
        position: "absolute !important",
        width: "1px !important",
        whiteSpace: "nowrap !important"
    };
};
var $92e8426bf109a871$export$ba1d834b86d72a09 = $92e8426bf109a871$export$a1b3edb637fb4f35;
var $92e8426bf109a871$export$e497e856b4f89fcd = function skeletonShimmer() {
    return {
        css: {
            backgroundColor: "var(--ds-skeleton, ".concat((0, $9ebab1f06de887cb$export$8d43898f60b96a82), ")"),
            animationDuration: "1.5s",
            animationIterationCount: "infinite",
            animationTimingFunction: "linear",
            animationDirection: "alternate"
        },
        keyframes: {
            from: {
                backgroundColor: "var(--ds-skeleton, ".concat((0, $9ebab1f06de887cb$export$8d43898f60b96a82), ")")
            },
            to: {
                backgroundColor: "var(--ds-skeleton-subtle, ".concat((0, $9ebab1f06de887cb$export$920c0d5c49070351), ")")
            }
        }
    };
};


/* eslint-disable @atlaskit/design-system/no-direct-use-of-web-platform-drag-and-drop */ /**
 * We are listening directly to drag events instead of using a monitor from
 * `@atlaskit/pragmatic-drag-and-drop` to avoid the bundle size cost, as it
 * would affect almost every view in every product.
 *
 * We can reconsider this choice in the future.
 */ 
var $dd4sf = parcelRequire("dd4sf");
var $7b7b1e249322bef5$var$registrations = new Set();
var $7b7b1e249322bef5$var$cleanupEndEventListeners = null;
function $7b7b1e249322bef5$var$onDragStart() {
    if ($7b7b1e249322bef5$var$cleanupEndEventListeners) // If the cleanup function exists then we've already run this
    return;
    $7b7b1e249322bef5$var$cleanupEndEventListeners = (0, $dd4sf.bindAll)(window, [
        {
            type: "dragend",
            listener: $7b7b1e249322bef5$var$onDragEnd
        },
        {
            type: "pointerdown",
            listener: $7b7b1e249322bef5$var$onDragEnd
        },
        {
            type: "pointermove",
            listener: function() {
                var callCount = 0;
                return function listener() {
                    // Using 20 as it is far bigger than the most observed (3)
                    if (callCount < 20) {
                        callCount++;
                        return;
                    }
                    $7b7b1e249322bef5$var$onDragEnd();
                };
            }()
        }
    ]);
    var clone = Array.from($7b7b1e249322bef5$var$registrations);
    clone.forEach(function(subscriber) {
        subscriber.onDragStart();
    });
}
function $7b7b1e249322bef5$var$onDragEnd() {
    var _cleanupEndEventListe;
    (_cleanupEndEventListe = $7b7b1e249322bef5$var$cleanupEndEventListeners) === null || _cleanupEndEventListe === void 0 || _cleanupEndEventListe();
    $7b7b1e249322bef5$var$cleanupEndEventListeners = null;
    var clone = Array.from($7b7b1e249322bef5$var$registrations);
    clone.forEach(function(subscriber) {
        subscriber.onDragEnd();
    });
}
function $7b7b1e249322bef5$var$bindStartEvents() {
    return (0, $dd4sf.bindAll)(window, [
        {
            type: "dragstart",
            listener: $7b7b1e249322bef5$var$onDragStart
        },
        {
            type: "dragenter",
            listener: $7b7b1e249322bef5$var$onDragStart
        }
    ]);
}
var $7b7b1e249322bef5$var$cleanupStartEventListeners = null;
function $7b7b1e249322bef5$export$6503ec6e8aabbaf(registration) {
    // if first registration, bind event listeners
    if (!$7b7b1e249322bef5$var$cleanupStartEventListeners) // note: currently never unbinding these event listeners
    $7b7b1e249322bef5$var$cleanupStartEventListeners = $7b7b1e249322bef5$var$bindStartEvents();
    $7b7b1e249322bef5$var$registrations.add(registration);
    /**
   * The reasoning for this behavior is so that if a tooltip mounts during
   * a drag it can still be suppressed.
   *
   * We use a separate callback instead of onDragStart to avoid infinite loops.
   */ registration.onRegister({
        isDragging: $7b7b1e249322bef5$var$cleanupEndEventListeners !== null
    });
    return function unregister() {
        $7b7b1e249322bef5$var$registrations.delete(registration);
        if ($7b7b1e249322bef5$var$registrations.size === 0) {
            var _cleanupStartEventLis;
            (_cleanupStartEventLis = $7b7b1e249322bef5$var$cleanupStartEventListeners) === null || _cleanupStartEventLis === void 0 || _cleanupStartEventLis();
            $7b7b1e249322bef5$var$cleanupStartEventListeners = null;
        }
    };
}


var $1da8b5d95ab33fcf$var$delayId = null;
function $1da8b5d95ab33fcf$export$eaf678f6f93f5250() {
    if ($1da8b5d95ab33fcf$var$delayId != null) {
        window.clearTimeout($1da8b5d95ab33fcf$var$delayId);
        $1da8b5d95ab33fcf$var$delayId = null;
    }
}
function $1da8b5d95ab33fcf$export$5f4d6617421d489b(fn, delay) {
    $1da8b5d95ab33fcf$export$eaf678f6f93f5250();
    $1da8b5d95ab33fcf$var$delayId = window.setTimeout(function() {
        $1da8b5d95ab33fcf$var$delayId = null;
        fn();
    }, delay);
}


// This file is a singleton for managing tooltips
var $bd3255bc37101c24$var$active = null;
function $bd3255bc37101c24$export$57bf213be019eeb0(entry) {
    var phase = "waiting-to-show";
    function isActive() {
        return Boolean($bd3255bc37101c24$var$active && $bd3255bc37101c24$var$active.entry === entry);
    }
    function cleanup() {
        if (isActive()) {
            (0, $1da8b5d95ab33fcf$export$eaf678f6f93f5250)();
            $bd3255bc37101c24$var$active = null;
        }
    }
    function done() {
        if (isActive()) entry.done();
        phase = "done";
        cleanup();
    }
    function immediatelyHideAndDone() {
        if (isActive()) entry.hide({
            isImmediate: true
        });
        done();
    }
    function keep() {
        if (!isActive()) return;
        // aborting a wait to hide
        if (phase === "waiting-to-hide") {
            phase = "shown";
            (0, $1da8b5d95ab33fcf$export$eaf678f6f93f5250)();
            return;
        }
        // aborting hide animation
        if (phase === "hide-animating") {
            phase = "shown";
            (0, $1da8b5d95ab33fcf$export$eaf678f6f93f5250)();
            entry.show({
                isImmediate: false
            });
            return;
        }
    }
    function requestHide(_ref) {
        var isImmediate = _ref.isImmediate;
        if (!isActive()) return;
        // If we were not showing yet anyway; finish straight away
        if (phase === "waiting-to-show") {
            immediatelyHideAndDone();
            return;
        }
        // already waiting to hide
        if (phase === "waiting-to-hide") return;
        if (isImmediate) {
            immediatelyHideAndDone();
            return;
        }
        phase = "waiting-to-hide";
        (0, $1da8b5d95ab33fcf$export$5f4d6617421d489b)(function() {
            phase = "hide-animating";
            entry.hide({
                isImmediate: false
            });
        }, entry.delay);
    }
    function finishHideAnimation() {
        if (isActive() && phase === "hide-animating") done();
    }
    function isVisible() {
        return phase === "shown" || phase === "waiting-to-hide" || phase === "hide-animating";
    }
    function getInitialMouse() {
        if (entry.source.type === "mouse") return entry.source.mouse;
        return null;
    }
    function start() {
        var showImmediately = Boolean($bd3255bc37101c24$var$active && $bd3255bc37101c24$var$active.isVisible());
        // If there was an active tooltip; we tell it to remove itself at once!
        if ($bd3255bc37101c24$var$active) {
            (0, $1da8b5d95ab33fcf$export$eaf678f6f93f5250)();
            $bd3255bc37101c24$var$active.entry.hide({
                isImmediate: true
            });
            $bd3255bc37101c24$var$active.entry.done();
            $bd3255bc37101c24$var$active = null;
        }
        // this tooltip is now the active tooltip
        $bd3255bc37101c24$var$active = {
            entry: entry,
            isVisible: isVisible
        };
        function show() {
            phase = "shown";
            entry.show({
                isImmediate: showImmediately
            });
        }
        if (showImmediately) {
            show();
            return;
        }
        phase = "waiting-to-show";
        (0, $1da8b5d95ab33fcf$export$5f4d6617421d489b)(show, entry.delay);
    }
    // let's get started!
    start();
    var result = {
        keep: keep,
        abort: cleanup,
        isActive: isActive,
        requestHide: requestHide,
        finishHideAnimation: finishHideAnimation,
        mousePosition: getInitialMouse()
    };
    return result;
}



var $lyB4O = parcelRequire("lyB4O");
function $666be62a53f2ec2a$export$2e2bcd8739ae039(prefix, shouldRenderId) {
    var seed = (0, $lyB4O.useIdSeed)();
    return shouldRenderId ? "".concat(seed(prefix)) : undefined;
}


/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $dAx5m = parcelRequire("dAx5m");

var $jVTBW = parcelRequire("jVTBW");



var $dAx5m = parcelRequire("dAx5m");

var $jVTBW = parcelRequire("jVTBW");

function $3d36538482e48fa3$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $3d36538482e48fa3$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $3d36538482e48fa3$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($c3ec97511ae1ed64$exports)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $3d36538482e48fa3$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $3d36538482e48fa3$var$VAR_PRIMITIVE_ZINDEX = "tooltipPrimitiveZindex";
var $3d36538482e48fa3$var$primitiveStyles = (0, $jVTBW.css)({
    zindex: "var(".concat($3d36538482e48fa3$var$VAR_PRIMITIVE_ZINDEX, ")"),
    cursor: "default"
});
var $3d36538482e48fa3$var$TooltipPrimitive = /*#__PURE__*/ (0, $dAx5m.forwardRef)(function TooltipPrimitive(_ref, ref) {
    var style = _ref.style, className = _ref.className, children = _ref.children, placement = _ref.placement, testId = _ref.testId, onMouseOut = _ref.onMouseOut, onMouseOver = _ref.onMouseOver, id = _ref.id;
    var styleWithZIndex = $3d36538482e48fa3$var$_objectSpread($3d36538482e48fa3$var$_objectSpread({}, style), {}, (0, (/*@__PURE__*/$parcel$interopDefault($c3ec97511ae1ed64$exports)))({}, $3d36538482e48fa3$var$VAR_PRIMITIVE_ZINDEX, (0, $92e8426bf109a871$export$7be255094ccdc533).tooltip()));
    return (0, $jVTBW.jsx)("div", {
        ref: ref,
        style: styleWithZIndex,
        "data-testid": testId ? "".concat(testId, "--wrapper") : undefined
    }, (0, $jVTBW.jsx)("div", {
        role: "tooltip",
        className: className,
        onMouseOut: onMouseOut,
        onMouseOver: onMouseOver,
        css: $3d36538482e48fa3$var$primitiveStyles,
        "data-placement": placement,
        "data-testid": testId,
        id: id
    }, children));
});
$3d36538482e48fa3$var$TooltipPrimitive.displayName = "TooltipPrimitive";
var $3d36538482e48fa3$export$2e2bcd8739ae039 = $3d36538482e48fa3$var$TooltipPrimitive;


var $7fe1ff951f62f0cf$var$baseStyles = (0, $jVTBW.css)({
    boxSizing: "border-box",
    maxWidth: "240px",
    padding: "var(--ds-space-025, 2px)".concat(" ", "var(--ds-space-075, 6px)"),
    insetBlockStart: "var(--ds-space-0, 0px)",
    insetInlineStart: "var(--ds-space-0, 0px)",
    borderRadius: "var(--ds-border-radius, 3px)",
    font: 'var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    overflowWrap: "break-word",
    wordWrap: "break-word",
    backgroundColor: "var(--ds-background-neutral-bold, ".concat((0, $9ebab1f06de887cb$export$7d61b15e0da132af), ")"),
    color: "var(--ds-text-inverse, ".concat((0, $9ebab1f06de887cb$export$29a4f05edc054374), ")")
});
var $7fe1ff951f62f0cf$var$truncateStyles = (0, $jVTBW.css)({
    maxWidth: "420px",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap"
});
var $7fe1ff951f62f0cf$var$TooltipContainer = /*#__PURE__*/ (0, $dAx5m.forwardRef)(function TooltipContainer(_ref, ref) {
    var style = _ref.style, className = _ref.className, children = _ref.children, truncate = _ref.truncate, placement = _ref.placement, testId = _ref.testId, onMouseOut = _ref.onMouseOut, onMouseOver = _ref.onMouseOver, id = _ref.id;
    return (0, $jVTBW.jsx)((0, $3d36538482e48fa3$export$2e2bcd8739ae039), {
        ref: ref,
        style: style,
        className: className,
        placement: placement,
        testId: testId,
        id: id,
        onMouseOut: onMouseOut,
        onMouseOver: onMouseOver,
        css: [
            $7fe1ff951f62f0cf$var$baseStyles,
            truncate ? $7fe1ff951f62f0cf$var$truncateStyles : null
        ]
    }, children);
});
$7fe1ff951f62f0cf$var$TooltipContainer.displayName = "TooltipContainer";
var $7fe1ff951f62f0cf$export$2e2bcd8739ae039 = $7fe1ff951f62f0cf$var$TooltipContainer;


function $5ed8792c848e45b5$export$642213d516a9b928(mouseCoordinates) {
    var safeMouse = mouseCoordinates || {
        top: 0,
        left: 0
    };
    var getBoundingClientRect = function getBoundingClientRect() {
        return {
            top: safeMouse.top,
            left: safeMouse.left,
            bottom: safeMouse.top,
            right: safeMouse.left,
            width: 0,
            height: 0
        };
    };
    return {
        getBoundingClientRect: getBoundingClientRect,
        clientWidth: 0,
        clientHeight: 0
    };
}


function $d8648a6b782cd782$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $d8648a6b782cd782$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $d8648a6b782cd782$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($c3ec97511ae1ed64$exports)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $d8648a6b782cd782$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $d8648a6b782cd782$var$tooltipZIndex = (0, $92e8426bf109a871$export$7be255094ccdc533).tooltip();
var $d8648a6b782cd782$var$analyticsAttributes = {
    componentName: "tooltip",
    packageName: "@atlaskit/tooltip",
    packageVersion: "18.7.2"
};
// Inverts motion direction
var $d8648a6b782cd782$var$invertedDirection = {
    top: "bottom",
    bottom: "top",
    left: "right",
    right: "left"
};
/**
 * Converts a Popper placement to it's general direction.
 *
 * @param placement - Popper Placement value, e.g. 'top-start'
 * @returns Popper Direction, e.g. 'top'
 */ var $d8648a6b782cd782$var$getDirectionFromPlacement = function getDirectionFromPlacement(placement) {
    return placement.split("-")[0];
};
function $d8648a6b782cd782$var$Tooltip(_ref) {
    var children = _ref.children, _ref$position = _ref.position, position = _ref$position === void 0 ? "bottom" : _ref$position, _ref$mousePosition = _ref.mousePosition, mousePosition = _ref$mousePosition === void 0 ? "bottom" : _ref$mousePosition, content = _ref.content, _ref$truncate = _ref.truncate, truncate = _ref$truncate === void 0 ? false : _ref$truncate, _ref$component = _ref.component, Container = _ref$component === void 0 ? (0, $7fe1ff951f62f0cf$export$2e2bcd8739ae039) : _ref$component, _ref$tag = _ref.tag, TargetContainer = _ref$tag === void 0 ? "div" : _ref$tag, testId = _ref.testId, _ref$delay = _ref.delay, delay = _ref$delay === void 0 ? 300 : _ref$delay, _ref$onShow = _ref.onShow, onShow = _ref$onShow === void 0 ? (0, $Bb0he.default) : _ref$onShow, _ref$onHide = _ref.onHide, onHide = _ref$onHide === void 0 ? (0, $Bb0he.default) : _ref$onHide, _ref$hideTooltipOnCli = _ref.hideTooltipOnClick, hideTooltipOnClick = _ref$hideTooltipOnCli === void 0 ? false : _ref$hideTooltipOnCli, _ref$hideTooltipOnMou = _ref.hideTooltipOnMouseDown, hideTooltipOnMouseDown = _ref$hideTooltipOnMou === void 0 ? false : _ref$hideTooltipOnMou, analyticsContext = _ref.analyticsContext, _ref$strategy = _ref.strategy, strategy = _ref$strategy === void 0 ? "fixed" : _ref$strategy, _ref$ignoreTooltipPoi = _ref.ignoreTooltipPointerEvents, ignoreTooltipPointerEvents = _ref$ignoreTooltipPoi === void 0 ? false : _ref$ignoreTooltipPoi;
    var tooltipPosition = position === "mouse" ? mousePosition : position;
    var onShowHandler = (0, $a0f3daa697df11cd$export$1a04351537078b55)($d8648a6b782cd782$var$_objectSpread({
        fn: onShow,
        action: "displayed",
        analyticsData: analyticsContext
    }, $d8648a6b782cd782$var$analyticsAttributes));
    var onHideHandler = (0, $a0f3daa697df11cd$export$1a04351537078b55)($d8648a6b782cd782$var$_objectSpread({
        fn: onHide,
        action: "hidden",
        analyticsData: analyticsContext
    }, $d8648a6b782cd782$var$analyticsAttributes));
    var apiRef = (0, $dAx5m.useRef)(null);
    var _useState = (0, $dAx5m.useState)("hide"), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($6f4c9344050d46f7$exports)))(_useState, 2), state = _useState2[0], setState = _useState2[1];
    var targetRef = (0, $dAx5m.useRef)(null);
    var containerRef = (0, $dAx5m.useRef)(null);
    // This function is deliberately _not_ memoized as it needs to re-run every render
    // to pick up any child ref changes. If you use render props you don't have this issue.
    var setImplicitRefFromChildren = function setImplicitRefFromChildren(node) {
        containerRef.current = node;
        targetRef.current = node ? node.firstElementChild : null;
    };
    // This is memoized and passed into the render props callback.
    var setDirectRef = (0, $dAx5m.useCallback)(function(node) {
        targetRef.current = node;
    }, []);
    // Putting a few things into refs so that we don't have to break memoization
    var lastState = (0, $dAx5m.useRef)(state);
    var lastDelay = (0, $dAx5m.useRef)(delay);
    var lastHandlers = (0, $dAx5m.useRef)({
        onShowHandler: onShowHandler,
        onHideHandler: onHideHandler
    });
    var hasCalledShowHandler = (0, $dAx5m.useRef)(false);
    (0, $dAx5m.useEffect)(function() {
        lastState.current = state;
        lastDelay.current = delay;
        lastHandlers.current = {
            onShowHandler: onShowHandler,
            onHideHandler: onHideHandler
        };
    }, [
        delay,
        onHideHandler,
        onShowHandler,
        state
    ]);
    var start = (0, $dAx5m.useCallback)(function(api) {
        // @ts-ignore
        apiRef.current = api;
        hasCalledShowHandler.current = false;
    }, []);
    var done = (0, $dAx5m.useCallback)(function() {
        if (!apiRef.current) return;
        // Only call onHideHandler if we have called onShowHandler
        if (hasCalledShowHandler.current) lastHandlers.current.onHideHandler();
        // @ts-ignore
        apiRef.current = null;
        // @ts-ignore
        hasCalledShowHandler.current = false;
        // just in case
        setState("hide");
    }, []);
    var abort = (0, $dAx5m.useCallback)(function() {
        if (!apiRef.current) return;
        apiRef.current.abort();
        // Only call onHideHandler if we have called onShowHandler
        if (hasCalledShowHandler.current) lastHandlers.current.onHideHandler();
        // @ts-ignore
        apiRef.current = null;
    }, []);
    (0, $dAx5m.useEffect)(function mount() {
        return function unmount() {
            if (apiRef.current) abort();
        };
    }, [
        abort
    ]);
    var isDraggingRef = (0, $dAx5m.useRef)(false);
    (0, $dAx5m.useEffect)(function() {
        return (0, $7b7b1e249322bef5$export$6503ec6e8aabbaf)({
            onRegister: function onRegister(_ref2) {
                var isDragging = _ref2.isDragging;
                isDraggingRef.current = isDragging;
            },
            onDragStart: function onDragStart() {
                var _apiRef$current;
                /**
         * Hiding any visible tooltips when a drag starts because otherwise it
         * looks janky (disappears and reappears), and is not required.
         */ (_apiRef$current = apiRef.current) === null || _apiRef$current === void 0 || _apiRef$current.requestHide({
                    isImmediate: true
                });
                isDraggingRef.current = true;
            },
            onDragEnd: function onDragEnd() {
                isDraggingRef.current = false;
            }
        });
    }, []);
    var showTooltip = (0, $dAx5m.useCallback)(function(source) {
        /**
     * Prevent tooltips from being shown during a drag. This can occur with
     * the native drag and drop API, where some pointer events can fire
     * when they should not and lead to jank with tooltips.
     */ if (isDraggingRef.current) return;
        if (apiRef.current && !apiRef.current.isActive()) abort();
        // Tell the tooltip to keep showing
        if (apiRef.current && apiRef.current.isActive()) {
            apiRef.current.keep();
            return;
        }
        var entry = {
            source: source,
            delay: lastDelay.current,
            show: function show(_ref3) {
                var isImmediate = _ref3.isImmediate;
                // Call the onShow handler if it hasn't been called yet
                if (!hasCalledShowHandler.current) {
                    hasCalledShowHandler.current = true;
                    lastHandlers.current.onShowHandler();
                }
                setState(isImmediate ? "show-immediate" : "fade-in");
            },
            hide: function hide(_ref4) {
                var isImmediate = _ref4.isImmediate;
                if (isImmediate) setState("hide");
                else setState("before-fade-out");
            },
            done: done
        };
        var api = (0, $bd3255bc37101c24$export$57bf213be019eeb0)(entry);
        start(api);
    }, [
        abort,
        done,
        start
    ]);
    var hideTooltipOnEsc = (0, $dAx5m.useCallback)(function() {
        var _apiRef$current2;
        (_apiRef$current2 = apiRef.current) === null || _apiRef$current2 === void 0 || _apiRef$current2.requestHide({
            isImmediate: true
        });
    }, [
        apiRef
    ]);
    (0, $6Oq6X.default)({
        onClose: hideTooltipOnEsc,
        isDisabled: state === "hide" || state === "fade-out"
    });
    (0, $dAx5m.useEffect)(function() {
        if (state === "hide") return 0, $Bb0he.default;
        if (state === "before-fade-out") setState("fade-out");
        var unbind = (0, $dd4sf.bind)(window, {
            type: "scroll",
            listener: function listener() {
                if (apiRef.current) apiRef.current.requestHide({
                    isImmediate: true
                });
            },
            options: {
                capture: true,
                passive: true,
                once: true
            }
        });
        return unbind;
    }, [
        state
    ]);
    var onMouseDown = (0, $dAx5m.useCallback)(function() {
        if (hideTooltipOnMouseDown && apiRef.current) apiRef.current.requestHide({
            isImmediate: true
        });
    }, [
        hideTooltipOnMouseDown
    ]);
    var onClick = (0, $dAx5m.useCallback)(function() {
        if (hideTooltipOnClick && apiRef.current) apiRef.current.requestHide({
            isImmediate: true
        });
    }, [
        hideTooltipOnClick
    ]);
    // Ideally we would be using onMouseEnter here, but
    // because we are binding the event to the target parent
    // we need to listen for the mouseover of all sub elements
    // This means when moving along a tooltip we are quickly toggling
    // between api.requestHide and api.keep. This it not ideal
    var onMouseOver = (0, $dAx5m.useCallback)(function(event) {
        // Ignoring events from the container ref
        if (containerRef.current && event.target === containerRef.current) return;
        // Using prevent default as a signal that parent tooltips
        if (event.defaultPrevented) return;
        event.preventDefault();
        var source = position === "mouse" ? {
            type: "mouse",
            // TODO: ideally not recalculating this object each time
            mouse: (0, $5ed8792c848e45b5$export$642213d516a9b928)({
                left: event.clientX,
                top: event.clientY
            })
        } : {
            type: "keyboard"
        };
        showTooltip(source);
    }, [
        position,
        showTooltip
    ]);
    // Ideally we would be using onMouseEnter here, but
    // because we are binding the event to the target parent
    // we need to listen for the mouseout of all sub elements
    // This means when moving along a tooltip we are quickly toggling
    // between api.requestHide and api.keep. This it not ideal
    var onMouseOut = (0, $dAx5m.useCallback)(function(event) {
        // Ignoring events from the container ref
        if (containerRef.current && event.target === containerRef.current) return;
        // Using prevent default as a signal that parent tooltips
        if (event.defaultPrevented) return;
        event.preventDefault();
        if (apiRef.current) apiRef.current.requestHide({
            isImmediate: false
        });
    }, []);
    var onMouseMove = position === "mouse" ? function(event) {
        var _apiRef$current3;
        if ((_apiRef$current3 = apiRef.current) !== null && _apiRef$current3 !== void 0 && _apiRef$current3.isActive()) apiRef.current.mousePosition = (0, $5ed8792c848e45b5$export$642213d516a9b928)({
            left: event.clientX,
            top: event.clientY
        });
    } : undefined;
    var onMouseOverTooltip = (0, $dAx5m.useCallback)(function() {
        if (apiRef.current && apiRef.current.isActive()) {
            apiRef.current.keep();
            return;
        }
    }, []);
    var onFocus = (0, $dAx5m.useCallback)(function() {
        showTooltip({
            type: "keyboard"
        });
    }, [
        showTooltip
    ]);
    var onBlur = (0, $dAx5m.useCallback)(function() {
        if (apiRef.current) apiRef.current.requestHide({
            isImmediate: false
        });
    }, []);
    var onAnimationFinished = (0, $dAx5m.useCallback)(function(transition) {
        // Using lastState here because motion is not picking up the latest value
        if (transition === "exiting" && lastState.current === "fade-out" && apiRef.current) // @ts-ignore: refs are writeable
        apiRef.current.finishHideAnimation();
    }, []);
    // Doing a cast because typescript is struggling to narrow the type
    var CastTargetContainer = TargetContainer;
    var shouldRenderTooltipContainer = state !== "hide" && Boolean(content);
    var shouldRenderTooltipChildren = state !== "hide" && state !== "fade-out";
    var getReferenceElement = function getReferenceElement() {
        var _apiRef$current4;
        if (position === "mouse" && (_apiRef$current4 = apiRef.current) !== null && _apiRef$current4 !== void 0 && _apiRef$current4.mousePosition) {
            var _apiRef$current5;
            return (_apiRef$current5 = apiRef.current) === null || _apiRef$current5 === void 0 ? void 0 : _apiRef$current5.mousePosition;
        }
        return targetRef.current || undefined;
    };
    var tooltipId = (0, $666be62a53f2ec2a$export$2e2bcd8739ae039)("tooltip", shouldRenderTooltipContainer);
    var tooltipTriggerProps = {
        onMouseOver: onMouseOver,
        onMouseOut: onMouseOut,
        onMouseMove: onMouseMove,
        onMouseDown: onMouseDown,
        onClick: onClick,
        onFocus: onFocus,
        onBlur: onBlur
    };
    // Don't set `data-testid` unless it's defined, as it's not in the interface.
    if (testId) // @ts-expect-error - Adding `data-testid` to the TriggerProps interface breaks Buttons.
    tooltipTriggerProps["data-testid"] = "".concat(testId, "--container");
    // This useEffect is purely for managing the aria attribute when using the
    // wrapped children approach.
    (0, $dAx5m.useEffect)(function() {
        // If there is no container element, we should exit early, because that
        // means they are using the render prop API, and that is implemented in a
        // different way. If there is no target element yet or tooltipId, we also
        // shouldn't do anything because there is nothing to operate on or with.
        if (!containerRef.current || !targetRef.current || !tooltipId) return;
        var target = targetRef.current;
        if (shouldRenderTooltipContainer) target.setAttribute("aria-describedby", tooltipId);
        else target.removeAttribute("aria-describedby");
    }, [
        shouldRenderTooltipContainer,
        tooltipId
    ]);
    var hiddenContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement("span", {
        "data-testid": testId ? "".concat(testId, "-hidden") : undefined,
        hidden: true,
        id: tooltipId
    }, typeof content === "function" ? content({}) : content);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).Fragment, null, typeof children === "function" ? /*#__PURE__*/ // once we deprecate the wrapped approach, we can put the aria
    // attribute back into the tooltipTriggerProps and make it required
    // instead of optional in `types`
    (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).Fragment, null, children($d8648a6b782cd782$var$_objectSpread($d8648a6b782cd782$var$_objectSpread({}, tooltipTriggerProps), {}, {
        "aria-describedby": tooltipId,
        ref: setDirectRef
    })), shouldRenderTooltipContainer && hiddenContent) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement(CastTargetContainer, (0, (/*@__PURE__*/$parcel$interopDefault($5fb336a98f9116b4$exports)))({}, tooltipTriggerProps, {
        ref: setImplicitRefFromChildren,
        role: "presentation"
    }), children, shouldRenderTooltipContainer && hiddenContent), shouldRenderTooltipContainer ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $07879cb15ebdf8a5$export$2e2bcd8739ae039), {
        zIndex: $d8648a6b782cd782$var$tooltipZIndex
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $f68ea3a56f7d868d$export$badac9ada3a0bdf9), {
        placement: tooltipPosition,
        referenceElement: getReferenceElement(),
        strategy: strategy
    }, function(_ref5) {
        var ref = _ref5.ref, style = _ref5.style, update = _ref5.update, placement = _ref5.placement;
        // Invert the entrance and exit directions.
        // E.g. a tooltip's position is on the 'right', it should enter from and exit to the 'left'
        // This gives the effect the tooltip is appearing from the target
        var direction = position === "mouse" ? undefined : $d8648a6b782cd782$var$invertedDirection[$d8648a6b782cd782$var$getDirectionFromPlacement(placement)];
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $d21c73d755841d01$export$2e2bcd8739ae039), {
            appear: true
        }, shouldRenderTooltipChildren && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $fb095636241fc7ae$export$2e2bcd8739ae039), {
            distance: "constant",
            entranceDirection: direction,
            exitDirection: direction,
            onFinish: onAnimationFinished,
            duration: state === "show-immediate" ? 0 : (0, $316c2e4385c9646e$export$6fa259be09e118a7)
        }, function(_ref6) {
            var className = _ref6.className;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement(Container, {
                ref: ref,
                className: "Tooltip ".concat(className),
                style: $d8648a6b782cd782$var$_objectSpread($d8648a6b782cd782$var$_objectSpread({}, style), ignoreTooltipPointerEvents && {
                    pointerEvents: "none"
                }),
                truncate: truncate,
                placement: tooltipPosition,
                testId: getReferenceElement() ? testId : testId && "".concat(testId, "--unresolved"),
                onMouseOut: onMouseOut,
                onMouseOver: onMouseOverTooltip
            }, typeof content === "function" ? content({
                update: update
            }) : content);
        }));
    })) : null);
}
$d8648a6b782cd782$var$Tooltip.displayName = "Tooltip";
var $d8648a6b782cd782$export$2e2bcd8739ae039 = $d8648a6b782cd782$var$Tooltip;



var $dAx5m = parcelRequire("dAx5m");

var $dAx5m = parcelRequire("dAx5m");





function $c3a66df4803f8c22$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $c3a66df4803f8c22$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $c3a66df4803f8c22$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($c3ec97511ae1ed64$exports)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $c3a66df4803f8c22$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $c3a66df4803f8c22$export$7229be6d7219ee6a = function hexToRGBA(hex) {
    var opacity = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
    var rgba = $c3a66df4803f8c22$var$_objectSpread($c3a66df4803f8c22$var$_objectSpread({}, (0, $d49ba35090ee3f46$export$2e2bcd8739ae039).convert(hex).rgb), {
        a: opacity
    });
    return "rgba(".concat(Object.values(rgba).join(", "), ")");
};
var $c3a66df4803f8c22$export$bba5a971afe05444 = function getBoxShadow(color) {
    return "0 0 0 2px ".concat(color);
};
var $c3a66df4803f8c22$var$hex = "[a-z0-9]";
var $c3a66df4803f8c22$var$shortHandHexColorPattern = new RegExp("#(".concat($c3a66df4803f8c22$var$hex, ")(").concat($c3a66df4803f8c22$var$hex, ")(").concat($c3a66df4803f8c22$var$hex, ")"), "i");
var $c3a66df4803f8c22$var$repeat = function repeat(str, times) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($d5f3651f1c5ee1c2$exports)))(Array(times)).map(function() {
        return str;
    }).join("");
};
var $c3a66df4803f8c22$var$isShortHexColor = function isShortHexColor(color) {
    return color && color.length === 4;
};
var $c3a66df4803f8c22$var$completeHexColor = function completeHexColor(colors) {
    var hex = colors.map(function(color) {
        return $c3a66df4803f8c22$var$repeat(color, 2);
    }).join("");
    return "#".concat(hex);
};
var $c3a66df4803f8c22$var$completeTriplet = function completeTriplet(colors) {
    return "#".concat($c3a66df4803f8c22$var$repeat(colors[1], 6));
};
var $c3a66df4803f8c22$var$isTriplet = function isTriplet(colors) {
    return colors[0] === colors[1] && colors[1] === colors[2];
};
var $c3a66df4803f8c22$export$db8d2130677f868c = function convertHexShorthand(color) {
    if ($c3a66df4803f8c22$var$isShortHexColor(color)) {
        // when color = '#ccc', matches is structured as ['#ccc', 'c', 'c', 'c', ...]
        var matches = color.match($c3a66df4803f8c22$var$shortHandHexColorPattern);
        if (matches) {
            var colors = matches.slice(1, 4);
            if ($c3a66df4803f8c22$var$isTriplet(colors)) return $c3a66df4803f8c22$var$completeTriplet(colors);
            else return $c3a66df4803f8c22$var$completeHexColor(colors);
        }
    }
    // return the color as is when it's not hex color shorthand
    return color;
};
var $c3a66df4803f8c22$export$10a10e7cd1193377 = function generateTextColor(color) {
    var converted = $c3a66df4803f8c22$export$db8d2130677f868c(color);
    return (0, $d49ba35090ee3f46$export$2e2bcd8739ae039).contrastRatio(converted).hex;
};
var $c3a66df4803f8c22$export$77a1051494882576 = function getContrastColor(contrastValue, opacityValue, color) {
    return $c3a66df4803f8c22$export$7229be6d7219ee6a((0, $d49ba35090ee3f46$export$2e2bcd8739ae039).contrast(contrastValue, color).hex, opacityValue);
};


var $56e94060bbf22ff5$var$defaultTheme = {
    mode: {
        create: {
            active: {
                color: "var(--ds-text-inverse, ".concat((0, $e996865a8c4821b6$export$29a4f05edc054374), ")"),
                backgroundColor: "var(--ds-background-brand-bold-pressed, ".concat((0, $c3a66df4803f8c22$export$7229be6d7219ee6a)((0, $e996865a8c4821b6$export$b3de0ae08da2ce64), 0.8), ")"),
                boxShadow: ""
            },
            default: {
                color: "var(--ds-text-inverse, ".concat((0, $e996865a8c4821b6$export$29a4f05edc054374), ")"),
                backgroundColor: "var(--ds-background-brand-bold, ".concat((0, $e996865a8c4821b6$export$b3de0ae08da2ce64), ")"),
                boxShadow: ""
            },
            focus: {
                color: "var(--ds-text-inverse, ".concat((0, $e996865a8c4821b6$export$29a4f05edc054374), ")"),
                backgroundColor: "",
                boxShadow: ""
            },
            hover: {
                color: "var(--ds-text-inverse, ".concat((0, $e996865a8c4821b6$export$29a4f05edc054374), ")"),
                backgroundColor: "var(--ds-background-brand-bold-hovered, ".concat((0, $c3a66df4803f8c22$export$7229be6d7219ee6a)((0, $e996865a8c4821b6$export$b3de0ae08da2ce64), 0.9), ")"),
                boxShadow: ""
            },
            selected: {
                color: "",
                backgroundColor: "",
                boxShadow: ""
            }
        },
        iconButton: {
            active: {
                color: "var(--ds-text-subtle, ".concat((0, $e996865a8c4821b6$export$b3de0ae08da2ce64), ")"),
                backgroundColor: "var(--ds-background-neutral-pressed, ".concat((0, $c3a66df4803f8c22$export$7229be6d7219ee6a)((0, $e996865a8c4821b6$export$226de0355ed012f8), 0.6), ")"),
                boxShadow: ""
            },
            default: {
                color: "var(--ds-text-subtle, ".concat((0, $e996865a8c4821b6$export$7090862dc3038a9f), ")"),
                backgroundColor: "transparent",
                boxShadow: ""
            },
            focus: {
                color: "var(--ds-text-subtle, ".concat((0, $e996865a8c4821b6$export$7090862dc3038a9f), ")"),
                backgroundColor: "",
                boxShadow: ""
            },
            hover: {
                color: "var(--ds-text-subtle, ".concat((0, $e996865a8c4821b6$export$b3de0ae08da2ce64), ")"),
                backgroundColor: "var(--ds-background-neutral-hovered, ".concat((0, $c3a66df4803f8c22$export$7229be6d7219ee6a)((0, $e996865a8c4821b6$export$226de0355ed012f8), 0.9), ")"),
                boxShadow: ""
            },
            selected: {
                color: "var(--ds-text-selected, ".concat((0, $e996865a8c4821b6$export$b3de0ae08da2ce64), ")"),
                backgroundColor: "var(--ds-background-selected, ".concat((0, $c3a66df4803f8c22$export$7229be6d7219ee6a)((0, $e996865a8c4821b6$export$226de0355ed012f8), 0.6), ")"),
                boxShadow: ""
            },
            selectedHover: {
                color: "var(--ds-text-selected, ".concat((0, $e996865a8c4821b6$export$b3de0ae08da2ce64), ")"),
                backgroundColor: "var(--ds-background-selected-hovered, ".concat((0, $c3a66df4803f8c22$export$7229be6d7219ee6a)((0, $e996865a8c4821b6$export$226de0355ed012f8), 0.6), ")"),
                boxShadow: ""
            }
        },
        navigation: {
            backgroundColor: "var(--ds-surface, ".concat((0, $e996865a8c4821b6$export$29a4f05edc054374), ")"),
            color: "var(--ds-text-subtlest, ".concat((0, $e996865a8c4821b6$export$f563ee71e9ee74cd), ")")
        },
        productHome: {
            backgroundColor: "var(--ds-text-brand, ".concat((0, $e996865a8c4821b6$export$b3de0ae08da2ce64), ")"),
            color: "var(--ds-text, ".concat((0, $e996865a8c4821b6$export$ad0bacf983b7ddaa), ")"),
            borderRight: "1px solid ".concat("var(--ds-border, ".concat((0, $c3a66df4803f8c22$export$7229be6d7219ee6a)((0, $e996865a8c4821b6$export$f563ee71e9ee74cd), 0.3), ")")),
            // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
            iconColor: "#357DE8" // TODO: replace with token after brand refresh
        },
        primaryButton: {
            active: {
                color: "var(--ds-text-subtle, ".concat((0, $e996865a8c4821b6$export$b3de0ae08da2ce64), ")"),
                backgroundColor: "var(--ds-background-neutral-pressed, ".concat((0, $c3a66df4803f8c22$export$7229be6d7219ee6a)((0, $e996865a8c4821b6$export$226de0355ed012f8), 0.7), ")"),
                boxShadow: ""
            },
            default: {
                color: "var(--ds-text-subtle, ".concat((0, $e996865a8c4821b6$export$7090862dc3038a9f), ")"),
                backgroundColor: "transparent",
                boxShadow: ""
            },
            focus: {
                color: "var(--ds-text-subtle, ".concat((0, $e996865a8c4821b6$export$7090862dc3038a9f), ")"),
                backgroundColor: "",
                boxShadow: ""
            },
            hover: {
                color: "var(--ds-text-subtle, ".concat((0, $e996865a8c4821b6$export$b3de0ae08da2ce64), ")"),
                backgroundColor: "var(--ds-background-neutral-hovered, ".concat((0, $c3a66df4803f8c22$export$7229be6d7219ee6a)((0, $e996865a8c4821b6$export$226de0355ed012f8), 0.9), ")"),
                boxShadow: ""
            },
            selected: {
                color: "var(--ds-text-selected, ".concat((0, $e996865a8c4821b6$export$b3de0ae08da2ce64), ")"),
                backgroundColor: "var(--ds-background-selected, ".concat((0, $c3a66df4803f8c22$export$7229be6d7219ee6a)((0, $e996865a8c4821b6$export$226de0355ed012f8), 0.7), ")"),
                boxShadow: "",
                borderColor: "var(--ds-border-selected, ".concat((0, $e996865a8c4821b6$export$b3de0ae08da2ce64), ")")
            },
            selectedHover: {
                color: "var(--ds-text-selected, ".concat((0, $e996865a8c4821b6$export$b3de0ae08da2ce64), ")"),
                backgroundColor: "var(--ds-background-selected-hovered, ".concat((0, $c3a66df4803f8c22$export$7229be6d7219ee6a)((0, $e996865a8c4821b6$export$226de0355ed012f8), 0.6), ")"),
                boxShadow: "",
                borderColor: "var(--ds-border-selected, ".concat((0, $e996865a8c4821b6$export$b3de0ae08da2ce64), ")")
            }
        },
        search: {
            default: {
                backgroundColor: "var(--ds-background-input, ".concat((0, $e996865a8c4821b6$export$29a4f05edc054374), ")"),
                color: "var(--ds-text-subtlest, ".concat((0, $e996865a8c4821b6$export$f563ee71e9ee74cd), ")"),
                borderColor: "var(--ds-border-input, ".concat((0, $e996865a8c4821b6$export$d6447c357493214f), ")")
            },
            focus: {
                borderColor: "var(--ds-border-focused, ".concat((0, $e996865a8c4821b6$export$215b7063051591f1), ")")
            },
            hover: {
                backgroundColor: "var(--ds-background-input-hovered, ".concat((0, $e996865a8c4821b6$export$29a4f05edc054374), ")")
            }
        },
        skeleton: {
            backgroundColor: "var(--ds-background-neutral, ".concat((0, $e996865a8c4821b6$export$9fdfb749e33cdf97), ")"),
            opacity: 1
        }
    }
};
var $56e94060bbf22ff5$export$2491e13b198e597d = "atlassian";
var $56e94060bbf22ff5$export$2e2bcd8739ae039 = $56e94060bbf22ff5$var$defaultTheme;





function $ec0f5c5baaeed6d9$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $ec0f5c5baaeed6d9$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $ec0f5c5baaeed6d9$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($c3ec97511ae1ed64$exports)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $ec0f5c5baaeed6d9$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $ec0f5c5baaeed6d9$var$generateOpacityValue = function generateOpacityValue(color) {
    return color === "#000000" ? 0.3 : 0.6;
};
// eslint-disable-next-line @repo/internal/react/consistent-types-definitions
var $ec0f5c5baaeed6d9$var$generateButtonCSSStates = function generateButtonCSSStates(colors, buttonType) {
    var backgroundColor = colors.backgroundColor, color = colors.color, highlightColor = colors.highlightColor;
    // Add less opacity for white text so it is still legible.
    var opacityValue = $ec0f5c5baaeed6d9$var$generateOpacityValue(color);
    var isCreateButton = buttonType === "create";
    return {
        active: {
            backgroundColor: isCreateButton ? (0, $c3a66df4803f8c22$export$7229be6d7219ee6a)(backgroundColor, 0.65) : (0, $c3a66df4803f8c22$export$77a1051494882576)(0.3, opacityValue, backgroundColor),
            boxShadow: (0, $c3a66df4803f8c22$export$bba5a971afe05444)("transparent"),
            color: color
        },
        default: {
            backgroundColor: backgroundColor,
            boxShadow: (0, $c3a66df4803f8c22$export$bba5a971afe05444)("transparent"),
            color: color
        },
        focus: {
            boxShadow: "none",
            color: color,
            backgroundColor: backgroundColor
        },
        hover: {
            backgroundColor: isCreateButton ? (0, $c3a66df4803f8c22$export$7229be6d7219ee6a)(backgroundColor, 0.8) : (0, $c3a66df4803f8c22$export$77a1051494882576)(0.1, opacityValue, backgroundColor),
            boxShadow: (0, $c3a66df4803f8c22$export$bba5a971afe05444)("transparent"),
            color: color
        },
        selected: {
            color: color,
            backgroundColor: (0, $c3a66df4803f8c22$export$77a1051494882576)(0.3, opacityValue, backgroundColor),
            borderColor: highlightColor,
            boxShadow: (0, $c3a66df4803f8c22$export$bba5a971afe05444)("transparent")
        },
        selectedHover: {
            color: color,
            backgroundColor: (0, $c3a66df4803f8c22$export$77a1051494882576)(0.3, opacityValue, backgroundColor),
            borderColor: highlightColor,
            boxShadow: (0, $c3a66df4803f8c22$export$bba5a971afe05444)("transparent")
        }
    };
};
var $ec0f5c5baaeed6d9$var$generateCreateButtonColors = function generateCreateButtonColors(themeBackground, themeHighlight) {
    return {
        backgroundColor: themeHighlight,
        color: (0, $c3a66df4803f8c22$export$10a10e7cd1193377)(themeHighlight),
        highlightColor: themeHighlight
    };
};
var $ec0f5c5baaeed6d9$export$2e4ecffaca289a18 = function generateTheme(themeColors) {
    var backgroundColor = themeColors.backgroundColor, highlightColor = themeColors.highlightColor, name = themeColors.name;
    var color = (0, $c3a66df4803f8c22$export$10a10e7cd1193377)(backgroundColor);
    var colors = $ec0f5c5baaeed6d9$var$_objectSpread($ec0f5c5baaeed6d9$var$_objectSpread({}, themeColors), {}, {
        color: color
    });
    if (name === (0, $56e94060bbf22ff5$export$2491e13b198e597d)) return 0, $56e94060bbf22ff5$export$2e2bcd8739ae039;
    return {
        mode: {
            create: $ec0f5c5baaeed6d9$var$generateButtonCSSStates($ec0f5c5baaeed6d9$var$generateCreateButtonColors(backgroundColor, highlightColor), "create"),
            iconButton: $ec0f5c5baaeed6d9$var$generateButtonCSSStates(colors, "iconButton"),
            primaryButton: $ec0f5c5baaeed6d9$var$generateButtonCSSStates(colors, "primaryButton"),
            navigation: {
                backgroundColor: backgroundColor,
                color: color
            },
            productHome: {
                color: color,
                backgroundColor: highlightColor,
                borderRight: "1px solid ".concat((0, $c3a66df4803f8c22$export$7229be6d7219ee6a)(color, 0.5))
            },
            search: {
                default: {
                    backgroundColor: backgroundColor,
                    color: color,
                    borderColor: (0, $c3a66df4803f8c22$export$7229be6d7219ee6a)(color, 0.5)
                },
                focus: {
                    borderColor: (0, $c3a66df4803f8c22$export$7229be6d7219ee6a)(highlightColor, 0.8),
                    boxShadow: (0, $c3a66df4803f8c22$export$bba5a971afe05444)((0, $c3a66df4803f8c22$export$7229be6d7219ee6a)(highlightColor, 0.5))
                },
                hover: {
                    backgroundColor: (0, $c3a66df4803f8c22$export$77a1051494882576)(0.1, $ec0f5c5baaeed6d9$var$generateOpacityValue(color), backgroundColor),
                    color: color
                }
            },
            skeleton: {
                backgroundColor: color,
                opacity: 0.08
            }
        }
    };
};
var $ec0f5c5baaeed6d9$export$2e2bcd8739ae039 = $ec0f5c5baaeed6d9$export$2e4ecffaca289a18;


var $bb9e168fde28f06e$export$eeee8619e1b91cb0 = (0, $ec0f5c5baaeed6d9$export$2e4ecffaca289a18)({
    name: (0, $56e94060bbf22ff5$export$2491e13b198e597d),
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
    backgroundColor: (0, $e996865a8c4821b6$export$29a4f05edc054374),
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
    highlightColor: (0, $e996865a8c4821b6$export$b3de0ae08da2ce64)
});
var $bb9e168fde28f06e$export$164de7ab8df77ef0 = $bb9e168fde28f06e$export$eeee8619e1b91cb0;


var $02bad4ee2f54e08e$export$2c657da244d00bd6 = /*#__PURE__*/ (0, $dAx5m.createContext)((0, $bb9e168fde28f06e$export$164de7ab8df77ef0));
var $02bad4ee2f54e08e$export$d8964aec282183a3 = $02bad4ee2f54e08e$export$2c657da244d00bd6.Provider;


var $2855163d66f71155$export$93d4e7f90805808f = function useTheme() {
    return (0, $dAx5m.useContext)((0, $02bad4ee2f54e08e$export$2c657da244d00bd6));
};



function $6bf53fbc91242961$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $6bf53fbc91242961$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $6bf53fbc91242961$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($c3ec97511ae1ed64$exports)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $6bf53fbc91242961$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $6bf53fbc91242961$export$f32bddcb857301f3 = function getIconButtonTheme(_ref) {
    var iconButton = _ref.mode.iconButton;
    return function(current, props) {
        var _current = current(props), buttonStyles = _current.buttonStyles, spinnerStyles = _current.spinnerStyles;
        return {
            buttonStyles: $6bf53fbc91242961$var$_objectSpread($6bf53fbc91242961$var$_objectSpread($6bf53fbc91242961$var$_objectSpread($6bf53fbc91242961$var$_objectSpread({}, buttonStyles), {}, {
                borderRadius: "var(--ds-border-radius-circle, 100%)",
                display: "flex",
                margin: "0 ".concat("var(--ds-space-025, 2px)"),
                // TODO Delete this comment after verifying space token -> previous value `4`
                padding: "var(--ds-space-050, 4px)",
                height: "auto",
                fontWeight: "var(--ds-font-weight-medium, 500)"
            }, iconButton.default), {}, {
                ":hover": iconButton.hover,
                ":focus": iconButton.focus,
                // :active doesn't work in FF, because we do a
                // e.preventDefault() on mouse down in Button.
                // '&&' is required to add more CSS specificity
                // && it not a valid CSSObject property
                // @ts-ignore
                "&&": $6bf53fbc91242961$var$_objectSpread({}, props.state === "active" && iconButton.active)
            }, props.state === "selected" && iconButton.selected), {}, {
                "> span": {
                    margin: 0
                }
            }),
            spinnerStyles: spinnerStyles
        };
    };
};


var $4098863f16eda438$var$_excluded = [
    "icon",
    "label",
    "testId",
    "tooltip"
];
var $4098863f16eda438$export$c25acd513dcc8062 = /*#__PURE__*/ (0, $dAx5m.forwardRef)(function(props, ref) {
    var icon = props.icon, label = props.label, testId = props.testId, tooltip = props.tooltip, buttonProps = (0, (/*@__PURE__*/$parcel$interopDefault($74ed1cba0d5551e3$exports)))(props, $4098863f16eda438$var$_excluded);
    var theme = (0, $2855163d66f71155$export$93d4e7f90805808f)();
    var button = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $2aaf423c0bf8d712$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($5fb336a98f9116b4$exports)))({
        appearance: "primary",
        "aria-label": label,
        testId: testId,
        iconBefore: icon,
        ref: ref,
        theme: (0, $6bf53fbc91242961$export$f32bddcb857301f3)(theme)
    }, buttonProps));
    if (tooltip) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $d8648a6b782cd782$export$2e2bcd8739ae039), {
        content: tooltip,
        hideTooltipOnClick: true
    }, button);
    return button;
});


var $5fb0acd6c890f2f8$export$5120f2d0b8d4cab8 = /*#__PURE__*/ (0, $dAx5m.forwardRef)(function(props, ref) {
    var labelProp = props.label, tooltip = props.tooltip;
    var label = labelProp || (typeof tooltip === "string" ? tooltip : "Your profile and settings");
    // All other implementations of IconButton within the components are using spread props, so
    // to use explicit props could cause regressions.
    // TODO: Remove these spread props for better static analysis
    // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement("div", {
        role: "listitem"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $4098863f16eda438$export$c25acd513dcc8062), (0, (/*@__PURE__*/$parcel$interopDefault($5fb336a98f9116b4$exports)))({
        label: label,
        ref: ref
    }, props)));
});
var // This exists only to extract props.
// eslint-disable-next-line @repo/internal/react/use-noop
$5fb0acd6c890f2f8$export$2e2bcd8739ae039 = function(props) {};





var $dAx5m = parcelRequire("dAx5m");

var $c0cef459f23f8d22$export$805c9516e5ba1e65 = function SignInGlyph(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement("svg", (0, (/*@__PURE__*/$parcel$interopDefault($5fb336a98f9116b4$exports)))({
        width: "24",
        height: "24",
        viewBox: "0 0 24 24"
    }, props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement("path", {
        fill: "currentColor",
        d: "M18.0234 4.29985L18.1727 4.30534C19.2076 4.38169 20.0234 5.24549 20.0234 6.29985V18.2999L20.018 18.4491C19.9416 19.484 19.0778 20.2999 18.0234 20.2999H13.0234L12.9068 20.2931C12.4095 20.2354 12.0234 19.8127 12.0234 19.2999C12.0234 18.7476 12.4712 18.2999 13.0234 18.2999H18.0234V6.29985H13.0234L12.9068 6.29312C12.4095 6.23536 12.0234 5.81269 12.0234 5.29985C12.0234 4.74757 12.4712 4.29985 13.0234 4.29985H18.0234ZM16.0193 12.3935L16.0135 12.4412C16.0104 12.4655 16.006 12.4902 16.0006 12.5148L15.9929 12.5461C15.9872 12.5704 15.9801 12.5951 15.9719 12.6194L15.9543 12.6658C15.9471 12.6865 15.9382 12.7072 15.9286 12.7276C15.922 12.7394 15.9161 12.7512 15.91 12.7629C15.8993 12.7857 15.8866 12.808 15.8729 12.8299C15.8685 12.8348 15.865 12.8402 15.8615 12.8456C15.8473 12.8696 15.831 12.8926 15.8135 12.9151L15.7303 13.0092L12.7303 16.0072C12.3396 16.3976 11.7065 16.3974 11.3161 16.0067C10.9557 15.6461 10.9282 15.0789 11.2334 14.6867L11.3166 14.5925L12.6114 13.2999H5.02344C4.47115 13.2999 4.02344 12.8521 4.02344 12.2999C4.02344 11.79 4.40492 11.3693 4.898 11.3076L5.02344 11.2999H12.6094L11.3161 10.0067C10.9557 9.64611 10.9282 9.07887 11.2334 8.68668L11.3166 8.5925C11.6772 8.23214 12.2444 8.20461 12.6366 8.50976L12.7308 8.59298L15.7046 11.5677C15.801 11.6574 15.8797 11.766 15.9348 11.8876C15.9383 11.8974 15.9424 11.9067 15.9463 11.916C15.9583 11.9428 15.9685 11.9706 15.9774 11.999L15.9846 12.0253C15.9928 12.0515 15.9993 12.0786 16.0047 12.106C16.007 12.1202 16.0094 12.1339 16.0115 12.1476L16.0199 12.215C16.0216 12.2369 16.0227 12.2585 16.0232 12.2802C16.0234 12.2869 16.0234 12.2934 16.0234 12.2999L16.0224 12.3179L16.0193 12.3935Z"
    }));
};
function $c0cef459f23f8d22$export$10cdd1f3e51de455(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $30d9f30932301ff5$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($5fb336a98f9116b4$exports)))({}, props, {
        glyph: $c0cef459f23f8d22$export$805c9516e5ba1e65
    }));
}


var $5d44385adbb38692$export$904b79312c8d6122 = function AccountMenuLoggedOutState(_ref) {
    var testId = _ref.testId, logInLink = _ref.logInLink;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $5fb0acd6c890f2f8$export$5120f2d0b8d4cab8), {
        testId: testId,
        href: logInLink,
        onClick: function onClick(event, analytics) {
            analytics.update({
                actionSubjectId: "logInLink"
            }).fire((0, $40ee9209af546b3a$export$515664faa1398f37));
        },
        tooltip: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $55TWT.default), {
            id: "identity.account-menu.account-menu-logged-out-state.log-in",
            defaultMessage: "Log in",
            description: "Tooltip for log in button when user is logged out"
        }),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $c0cef459f23f8d22$export$10cdd1f3e51de455), {
            label: "",
            size: "medium"
        })
    });
};






var $dAx5m = parcelRequire("dAx5m");

var $jVTBW = parcelRequire("jVTBW");

var $lKhJJ = parcelRequire("lKhJJ");
var $dZHnD = parcelRequire("dZHnD");

var $3FJlW = parcelRequire("3FJlW");

var $dAx5m = parcelRequire("dAx5m");


var $afc8f98ecb6ec6b5$export$53c2b9c37c40e0d8 = function useCallbackWithAnalytics(method, payload, channel) {
    var _useAnalyticsEvents = (0, $2d5fdfa21a1e72e4$export$5bf35293e545f20c)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    var methodRef = (0, $0ddd60ae48921ba1$export$1d27a74659855e44)(method);
    var payloadRef = (0, $0ddd60ae48921ba1$export$1d27a74659855e44)(payload);
    return (0, $dAx5m.useCallback)(function() {
        var pload = typeof payloadRef.current === "function" ? payloadRef.current.apply(payloadRef, arguments) : payloadRef.current;
        createAnalyticsEvent(pload).fire(channel);
        methodRef.current.apply(methodRef, arguments);
    }, [
        createAnalyticsEvent,
        methodRef,
        payloadRef,
        channel
    ]);
};







var $931be20c47fdff80$var$_excluded = [
    "picture",
    "email"
];
var $931be20c47fdff80$export$473cb05bf335b0e1 = function AccountMenuPopup(_ref) {
    var testId = _ref.testId, picture = _ref.picture, email = _ref.email, content = _ref.content;
    var _useState = (0, $dAx5m.useState)(false), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($6f4c9344050d46f7$exports)))(_useState, 2), isOpen = _useState2[0], setIsOpen = _useState2[1];
    var close = (0, $afc8f98ecb6ec6b5$export$53c2b9c37c40e0d8)(function() {
        return setIsOpen(false);
    }, {
        eventType: (0, $3FJlW.UI_EVENT_TYPE),
        action: "closed",
        actionSubject: "popup",
        actionSubjectId: "accountMenu"
    }, (0, $40ee9209af546b3a$export$515664faa1398f37));
    var open = (0, $afc8f98ecb6ec6b5$export$53c2b9c37c40e0d8)(function() {
        return setIsOpen(true);
    }, {
        eventType: (0, $3FJlW.UI_EVENT_TYPE),
        action: "opened",
        actionSubject: "popup",
        actionSubjectId: "accountMenu"
    }, (0, $40ee9209af546b3a$export$515664faa1398f37));
    return (0, $jVTBW.jsx)((0, $bb6c61bca55f38e4$export$2e2bcd8739ae039), {
        isOpen: isOpen,
        onClose: close,
        testId: testId,
        placement: "bottom",
        trigger: function trigger(triggerProps) {
            return (0, $jVTBW.jsx)($931be20c47fdff80$var$AccountMenuTrigger, (0, (/*@__PURE__*/$parcel$interopDefault($5fb336a98f9116b4$exports)))({
                onClick: isOpen ? close : open,
                testId: testId && "".concat(testId, "--trigger"),
                picture: picture,
                email: email
            }, triggerProps));
        },
        content: content
    });
};
var $931be20c47fdff80$var$imgStyles = (0, $jVTBW.css)({
    borderRadius: "50%",
    width: "var(--ds-space-300, 24px)",
    height: "var(--ds-space-300, 24px)"
});
var $931be20c47fdff80$var$AccountMenuTrigger = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).forwardRef(function(_ref2, ref) {
    var picture = _ref2.picture, email = _ref2.email, props = (0, (/*@__PURE__*/$parcel$interopDefault($74ed1cba0d5551e3$exports)))(_ref2, $931be20c47fdff80$var$_excluded);
    var intl = (0, $dZHnD.default)();
    var state = (0, $2440faa8ae7a7605$export$2c1df3428fc3264c)(picture || "");
    var tooltip = intl.formatMessage($931be20c47fdff80$var$messages.triggerTooltip);
    return (0, $jVTBW.jsx)((0, $5fb0acd6c890f2f8$export$5120f2d0b8d4cab8), (0, (/*@__PURE__*/$parcel$interopDefault($5fb336a98f9116b4$exports)))({}, props, {
        ref: ref,
        tooltip: email || tooltip,
        icon: picture && state === "loaded" ? (0, $jVTBW.jsx)("img", {
            css: $931be20c47fdff80$var$imgStyles,
            src: picture,
            alt: tooltip
        }) : (0, $jVTBW.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($fe6f2addda36a5da$exports))), {
            label: tooltip,
            size: "medium"
        })
    }));
});
var $931be20c47fdff80$var$messages = (0, $lKhJJ.defineMessages)({
    triggerTooltip: {
        id: "identity.account-menu.account-menu-popup.skeleton.tooltip",
        defaultMessage: "Account",
        description: "Tooltip and alt-text for the account menu item"
    }
});


var $727ad21037dc87f5$export$ff20d75d5eda4388 = function AccountMenu(_ref) {
    var testId = _ref.testId, name = _ref.name, picture = _ref.picture, email = _ref.email, managedBy = _ref.managedBy, manageProfileLink = _ref.manageProfileLink, viewProfileLink = _ref.viewProfileLink, onViewProfileClick = _ref.onViewProfileClick, switchAccountLink = _ref.switchAccountLink, logOutLink = _ref.logOutLink, logInLink = _ref.logInLink, onThemeChange = _ref.onThemeChange, currentTheme = _ref.currentTheme;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $d543f8437edc6f97$export$d0a82da1a0b94929), {
        data: (0, $40ee9209af546b3a$export$3cbe56a0cabcff38)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $4dcdcf79f1936c12$export$6c1f1571e3dd1b34), null, logInLink ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $5d44385adbb38692$export$904b79312c8d6122), {
        testId: testId && "".concat(testId, "--logged-out-state"),
        logInLink: logInLink
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $931be20c47fdff80$export$473cb05bf335b0e1), {
        testId: testId,
        picture: picture,
        email: email,
        content: function content(_ref2) {
            var closePopup = _ref2.onClose;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $b94349345da8b714$export$49c2771125e1e9f1), {
                testId: testId && "".concat(testId, "--content"),
                closePopup: closePopup,
                name: name,
                picture: picture,
                email: email,
                managedBy: managedBy,
                manageProfileLink: manageProfileLink,
                viewProfileLink: viewProfileLink,
                onViewProfileClick: onViewProfileClick,
                switchAccountLink: switchAccountLink,
                logOutLink: logOutLink,
                onThemeChange: onThemeChange,
                currentTheme: currentTheme
            });
        }
    })));
};


/**
 * An Identity environment to integrate with. Either a `"dev"`, `"staging"` or
 * `"prod"` for real Identity environments, or an `EnvironmentConfig` object for
 * using a fake environment (e.g. for local dev).
 */ const $6e88713b7dd70bb1$var$environmentConfigs = {
    dev: {
        baseUrl: "https://id.dev.internal.atlassian.com"
    },
    staging: {
        baseUrl: "https://id.stg.internal.atlassian.com"
    },
    prod: {
        baseUrl: "https://id.atlassian.com"
    }
};
function $6e88713b7dd70bb1$export$eabfcea451f48b90(identityEnvironment) {
    if (typeof identityEnvironment === "string") return $6e88713b7dd70bb1$var$environmentConfigs[identityEnvironment];
    else return identityEnvironment;
}




function $76989c0b6d88084a$export$2afde6c526be23b9({ email: email, identityEnvironment: identityEnvironment, application: application, continueUrl: continueUrl, logOutContinueUrl: logOutContinueUrl, isLoggedOut: isLoggedOut, disableSwitchAccountLink: disableSwitchAccountLink }) {
    const { baseUrl: baseUrl } = (0, $6e88713b7dd70bb1$export$eabfcea451f48b90)(identityEnvironment);
    const applicationParam = `application=${encodeURIComponent(application)}`;
    const continueParam = `continue=${encodeURIComponent(continueUrl)}`;
    const logOutContinueParam = logOutContinueUrl ? `continue=${encodeURIComponent(logOutContinueUrl)}` : continueParam;
    const manageProfileUrl = `${baseUrl}/manage-profile`;
    const manageProfileLink = email ? `${baseUrl}/login?${applicationParam}&continue=${encodeURIComponent(manageProfileUrl)}&prompt=none&login_hint=${encodeURIComponent(email)}` : manageProfileUrl;
    return {
        manageProfileLink: manageProfileLink,
        switchAccountLink: disableSwitchAccountLink ? undefined : `${baseUrl}/login?${applicationParam}&${continueParam}&prompt=select_account`,
        logOutLink: `${baseUrl}/logout?${applicationParam}&${logOutContinueParam}` + (disableSwitchAccountLink ? "" : "&prompt=none"),
        logInLink: isLoggedOut ? `${baseUrl}/login?${applicationParam}&${continueParam}` : undefined
    };
}



var $dAx5m = parcelRequire("dAx5m");

var $bibO8 = parcelRequire("bibO8");

var $dAx5m = parcelRequire("dAx5m");
const $154121f230ec2ebd$var$AccountClientContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createContext(undefined);
const $154121f230ec2ebd$export$9c573e05c0f57a89 = ({ client: client, children: children })=>/*#__PURE__*/ (0, $bibO8.jsx)($154121f230ec2ebd$var$AccountClientContext.Provider, {
        value: client,
        children: children
    });
const $154121f230ec2ebd$export$46db560d0f65f4ac = ()=>{
    const client = (0, $dAx5m.useContext)($154121f230ec2ebd$var$AccountClientContext);
    if (!client) throw new Error("Must provide an AccountClient with <AccountClientProvider>");
    return client;
};


function $88cf1d43997d02d4$export$f3fdc91289d1e14() {
    const client = (0, $154121f230ec2ebd$export$46db560d0f65f4ac)();
    const [asscociatedSessions, setAsscociatedSessions] = (0, $dAx5m.useState)([]);
    (0, $dAx5m.useEffect)(()=>{
        client.getRecentAssociatedSessions().then(setAsscociatedSessions);
    }, [
        client
    ]);
    return asscociatedSessions;
}



var $dAx5m = parcelRequire("dAx5m");

const $baa3e70e1fb20afe$export$22760cf86f49300b = ()=>{
    const client = (0, $154121f230ec2ebd$export$46db560d0f65f4ac)();
    return (0, $dAx5m.useCallback)((accountId)=>{
        client.switchAccount(accountId);
    }, [
        client
    ]);
};



var $dAx5m = parcelRequire("dAx5m");


var $dAx5m = parcelRequire("dAx5m");

const $cd516da2b65b22a6$export$23bbbc4533528f03 = ()=>{
    const client = (0, $154121f230ec2ebd$export$46db560d0f65f4ac)();
    const [user, setUser] = (0, $dAx5m.useState)(client.currentUser);
    (0, $dAx5m.useLayoutEffect)(()=>client.addUserListener(setUser), [
        client
    ]);
    return user;
};


const $f394bc210f9c5627$var$useDocumentVisibility = ()=>{
    const [documentVisibility, setDocumentVisibility] = (0, $dAx5m.useState)(document.visibilityState);
    (0, $dAx5m.useEffect)(()=>{
        const onVisibilityChange = ()=>{
            setDocumentVisibility(document.visibilityState);
        };
        document.addEventListener("visibilitychange", onVisibilityChange);
        return function cleanup() {
            document.removeEventListener("visibilitychange", onVisibilityChange);
        };
    }, []);
    return documentVisibility;
};
const $f394bc210f9c5627$export$cb3b96331337ab3c = ({ onAccountChange: onAccountChange, onError: onError })=>{
    const accountClient = (0, $154121f230ec2ebd$export$46db560d0f65f4ac)();
    const user = (0, $cd516da2b65b22a6$export$23bbbc4533528f03)();
    const previousUser = $f394bc210f9c5627$var$usePrevious(user);
    const documentVisibility = $f394bc210f9c5627$var$useDocumentVisibility();
    const [hasAccountChanged, setHasAccountChanged] = (0, $dAx5m.useState)(false);
    (0, $dAx5m.useEffect)(()=>{
        if (!user) return;
        window.localStorage.setItem("aaid", user.account_id);
    }, [
        user
    ]);
    (0, $dAx5m.useEffect)(()=>{
        const onStorageChange = ()=>{
            const newAaid = window.localStorage.getItem("aaid");
            if (previousUser && newAaid !== previousUser.account_id) setHasAccountChanged(true);
        };
        window.addEventListener("storage", onStorageChange);
        return function cleanup() {
            window.removeEventListener("storage", onStorageChange);
        };
    }, [
        previousUser
    ]);
    (0, $dAx5m.useEffect)(()=>{
        if (hasAccountChanged && previousUser && documentVisibility === "visible") accountClient.switchAccount(previousUser.account_id).then(()=>{
            window.localStorage.setItem("aaid", previousUser.account_id);
            onAccountChange({
                prevAaid: previousUser.account_id,
                prevEmail: previousUser.email
            });
            setHasAccountChanged(false);
        }).catch((error)=>{
            onError?.(error);
            const previousUserSessionSyncUrl = accountClient.getSessionSyncLink(window.location.href, previousUser.email);
            window.location.replace(previousUserSessionSyncUrl);
        });
    }, [
        hasAccountChanged,
        previousUser,
        documentVisibility,
        accountClient,
        onAccountChange,
        onError
    ]);
};
function $f394bc210f9c5627$var$usePrevious(value) {
    const ref = (0, $dAx5m.useRef)(value);
    (0, $dAx5m.useEffect)(()=>{
        ref.current = value;
    }, [
        value
    ]);
    return ref.current;
}





const $8055470c0723710d$export$1ed4b10e4aba04a7 = ({ identityEnvironment: identityEnvironment, application: application, continueUrl: continueUrl, logOutContinueUrl: logOutContinueUrl, isLoggedOut: isLoggedOut, disableSwitchAccountLink: disableSwitchAccountLink, ...props })=>{
    const links = (0, $76989c0b6d88084a$export$2afde6c526be23b9)({
        email: props.email,
        identityEnvironment: identityEnvironment,
        application: application,
        continueUrl: continueUrl,
        logOutContinueUrl: logOutContinueUrl,
        isLoggedOut: isLoggedOut,
        disableSwitchAccountLink: disableSwitchAccountLink
    });
    return /*#__PURE__*/ (0, $bibO8.jsx)((0, $727ad21037dc87f5$export$ff20d75d5eda4388), {
        ...props,
        ...links
    });
};



var $bibO8 = parcelRequire("bibO8");

var $dAx5m = parcelRequire("dAx5m");


var $bibO8 = parcelRequire("bibO8");
parcelRequire("dAx5m");
var $7e71d0aad26f90bd$exports = {};
function $7e71d0aad26f90bd$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $7e71d0aad26f90bd$exports = $7e71d0aad26f90bd$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $7e71d0aad26f90bd$exports.__esModule = true, $7e71d0aad26f90bd$exports["default"] = $7e71d0aad26f90bd$exports, $7e71d0aad26f90bd$var$_typeof(o);
}
$7e71d0aad26f90bd$exports = $7e71d0aad26f90bd$var$_typeof, $7e71d0aad26f90bd$exports.__esModule = true, $7e71d0aad26f90bd$exports["default"] = $7e71d0aad26f90bd$exports;



var $dAx5m = parcelRequire("dAx5m");

var $jVTBW = parcelRequire("jVTBW");
var $d402285a12758595$export$c07234257a03d5e9 = "cubic-bezier(0.15,1,0.3,1)";
var $d402285a12758595$export$57636bb43b1ccbb0 = "cubic-bezier(0.2,0,0,1)";
var $d402285a12758595$export$929e5a82286172a6 = "cubic-bezier(0.8,0,0,0.8)";

var $5fdc9222475a2456$exports = {};
var $5de19270f1f7b57b$exports = {};
function $5de19270f1f7b57b$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
$5de19270f1f7b57b$exports = $5de19270f1f7b57b$var$_arrayWithHoles, $5de19270f1f7b57b$exports.__esModule = true, $5de19270f1f7b57b$exports["default"] = $5de19270f1f7b57b$exports;


var $18ad39dc59fb1c63$exports = {};
function $18ad39dc59fb1c63$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
$18ad39dc59fb1c63$exports = $18ad39dc59fb1c63$var$_iterableToArrayLimit, $18ad39dc59fb1c63$exports.__esModule = true, $18ad39dc59fb1c63$exports["default"] = $18ad39dc59fb1c63$exports;


var $bf0b328db35db279$exports = {};
var $b02585b2a72fa69b$exports = {};
function $b02585b2a72fa69b$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
$b02585b2a72fa69b$exports = $b02585b2a72fa69b$var$_arrayLikeToArray, $b02585b2a72fa69b$exports.__esModule = true, $b02585b2a72fa69b$exports["default"] = $b02585b2a72fa69b$exports;


function $bf0b328db35db279$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $b02585b2a72fa69b$exports(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $b02585b2a72fa69b$exports(r, a) : void 0;
    }
}
$bf0b328db35db279$exports = $bf0b328db35db279$var$_unsupportedIterableToArray, $bf0b328db35db279$exports.__esModule = true, $bf0b328db35db279$exports["default"] = $bf0b328db35db279$exports;


var $689553eec75b606e$exports = {};
function $689553eec75b606e$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
$689553eec75b606e$exports = $689553eec75b606e$var$_nonIterableRest, $689553eec75b606e$exports.__esModule = true, $689553eec75b606e$exports["default"] = $689553eec75b606e$exports;


function $5fdc9222475a2456$var$_slicedToArray(r, e) {
    return $5de19270f1f7b57b$exports(r) || $18ad39dc59fb1c63$exports(r, e) || $bf0b328db35db279$exports(r, e) || $689553eec75b606e$exports();
}
$5fdc9222475a2456$exports = $5fdc9222475a2456$var$_slicedToArray, $5fdc9222475a2456$exports.__esModule = true, $5fdc9222475a2456$exports["default"] = $5fdc9222475a2456$exports;



var $dAx5m = parcelRequire("dAx5m");


var $dAx5m = parcelRequire("dAx5m");

var $dd4sf = parcelRequire("dd4sf");
var $b0c8cc775a82a112$var$isMatchMediaAvailable = function isMatchMediaAvailable() {
    return typeof window !== "undefined" && "matchMedia" in window;
};
var $b0c8cc775a82a112$export$b7baf7667a68d87c = function isReducedMotion() {
    if (!$b0c8cc775a82a112$var$isMatchMediaAvailable()) return false;
    var _window$matchMedia = window.matchMedia("(prefers-reduced-motion: reduce)"), matches = _window$matchMedia.matches;
    return matches;
};
var $b0c8cc775a82a112$export$c537e63161742ce3 = function useIsReducedMotion() {
    var _useState = (0, $dAx5m.useState)($b0c8cc775a82a112$export$b7baf7667a68d87c), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($5fdc9222475a2456$exports)))(_useState, 2), prefersReducedMotion = _useState2[0], setPrefersReducedMotion = _useState2[1];
    (0, $dAx5m.useEffect)(function() {
        if (!$b0c8cc775a82a112$var$isMatchMediaAvailable()) return;
        var mediaQueryList = window.matchMedia("(prefers-reduced-motion: reduce)");
        var onChange = function onChange(event) {
            return setPrefersReducedMotion(event.matches);
        };
        return (0, $dd4sf.bind)(mediaQueryList, {
            type: "change",
            listener: onChange
        });
    }, []);
    return prefersReducedMotion;
};
var $b0c8cc775a82a112$export$f0f789643ba5a83c = {
    "@media (prefers-reduced-motion: reduce)": {
        animation: "none",
        transition: "none"
    }
};
var $b0c8cc775a82a112$export$ff7706047246b98b = function prefersReducedMotion() {
    return $b0c8cc775a82a112$export$f0f789643ba5a83c;
};


var $b85a8e496ffe66d2$export$d1e013d71d2e2121 = {
    // Motions will always appear if not inside a exiting persistence component.
    appear: true,
    isExiting: false
};
var $b85a8e496ffe66d2$export$b9c4904d7a6929e6 = /*#__PURE__*/ (0, $dAx5m.createContext)($b85a8e496ffe66d2$export$d1e013d71d2e2121);
var $b85a8e496ffe66d2$export$e4c4c45693c3a7c = function wrapChildWithContextProvider(child) {
    var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $b85a8e496ffe66d2$export$d1e013d71d2e2121;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement($b85a8e496ffe66d2$export$b9c4904d7a6929e6.Provider, {
        key: "".concat(child.key, "-provider"),
        value: value
    }, child);
};
var $b85a8e496ffe66d2$export$7032ae6d9d98bedd = function childrenToArray(children) {
    var childrenAsArray = [];
    // We convert children to an array using this helper method as it will add keys to children that do not
    // have them, such as when we have hardcoded children that are conditionally rendered.
    (0, $dAx5m.Children).toArray(children).forEach(function(child) {
        // We ignore any boolean children to make our code a little more simple later on,
        // and also filter out any falsies (empty strings, nulls, and undefined).
        if (typeof child !== "boolean" && Boolean(child)) // Children WILL have a key after being forced into an array using the React.Children helper.
        childrenAsArray.push(child);
    });
    return childrenAsArray;
};
var $b85a8e496ffe66d2$export$2ccbe4ff092af328 = function spliceNewElementsIntoPrevious(current, previous) {
    var splicedChildren = previous.concat([]);
    var previousMap = $b85a8e496ffe66d2$export$1d8c49f95a162a41(previous);
    for(var i = 0; i < current.length; i++){
        var child = current[i];
        var childIsNew = !previousMap[child.key];
        if (childIsNew) // This will insert the new element after the previous element.
        splicedChildren.splice(i + 1, 0, child);
    }
    return splicedChildren;
};
var $b85a8e496ffe66d2$export$1d8c49f95a162a41 = function childrenToObj(children) {
    return children.reduce(function(acc, child) {
        acc[child.key] = child;
        return acc;
    }, {});
};
var $b85a8e496ffe66d2$var$getMissingKeys = function getMissingKeys(current, previous) {
    var currentMapKeys = new Set(current.map(function(child) {
        return child.key;
    }));
    var missing = new Set();
    for(var i = 0; i < previous.length; i++){
        var element = previous[i];
        var _key = element.key;
        if (!currentMapKeys.has(_key)) missing.add(_key);
    }
    return missing;
};
/**
 * __ExitingPersistence__
 *
 * Useful for enabling elements to persist and animate away when they are removed from the DOM.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motions)
 */ var $b85a8e496ffe66d2$var$ExitingPersistence = /*#__PURE__*/ (0, $dAx5m.memo)(function(_ref) {
    var _ref$appear = _ref.appear, appear = _ref$appear === void 0 ? false : _ref$appear, children = _ref.children, exitThenEnter = _ref.exitThenEnter;
    var _useState = (0, $dAx5m.useState)([
        null,
        children
    ]), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($5fdc9222475a2456$exports)))(_useState, 2), stateChildren = _useState2[0], setChildren = _useState2[1];
    var _useState3 = (0, $dAx5m.useState)([]), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($5fdc9222475a2456$exports)))(_useState3, 2), exitingChildren = _useState4[0], setExitingChildren = _useState4[1];
    var _useState5 = (0, $dAx5m.useState)(function() {
        return {
            appear: appear,
            isExiting: false
        };
    }), _useState6 = (0, (/*@__PURE__*/$parcel$interopDefault($5fdc9222475a2456$exports)))(_useState5, 2), defaultContext = _useState6[0], setDefaultContext = _useState6[1];
    (0, $dAx5m.useEffect)(function() {
        if (!defaultContext.appear) setDefaultContext({
            appear: true,
            isExiting: false
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    if ((0, $b0c8cc775a82a112$export$b7baf7667a68d87c)()) return children;
    /**
   * NOTE: This is a workaround for the test case written in Jira where the stateChildren is a boolean value because
   * useState is mocked to return a boolean value.
   */ if (typeof stateChildren === "boolean") return children;
    var _stateChildren = (0, (/*@__PURE__*/$parcel$interopDefault($5fdc9222475a2456$exports)))(stateChildren, 2), previousChildren = _stateChildren[0], currentChildren = _stateChildren[1];
    var previous = $b85a8e496ffe66d2$export$7032ae6d9d98bedd(previousChildren);
    var current = $b85a8e496ffe66d2$export$7032ae6d9d98bedd(currentChildren);
    if (currentChildren !== children) setChildren([
        currentChildren,
        children
    ]);
    var missingKeys = $b85a8e496ffe66d2$var$getMissingKeys(current, previous);
    var isSomeChildRemoved = !!missingKeys.size;
    var visibleChildren = current;
    if (isSomeChildRemoved) visibleChildren = $b85a8e496ffe66d2$export$2ccbe4ff092af328(current, previous);
    if (exitThenEnter) {
        if (exitingChildren.length) visibleChildren = exitingChildren;
        else {
            var nextExitingChildren = visibleChildren.filter(function(child) {
                return missingKeys.has(child.key);
            });
            if (nextExitingChildren.length) setExitingChildren(nextExitingChildren);
        }
    }
    if (missingKeys.size) visibleChildren = visibleChildren.map(function(child) {
        var isExiting = missingKeys.has(child.key);
        return $b85a8e496ffe66d2$export$e4c4c45693c3a7c(child, {
            appear: true,
            isExiting: isExiting,
            onFinish: isExiting ? function() {
                missingKeys.delete(child.key);
                if (missingKeys.size === 0) {
                    setChildren([
                        null,
                        children
                    ]);
                    setExitingChildren([]);
                }
            } : undefined
        });
    });
    else visibleChildren = visibleChildren.map(function(child) {
        return $b85a8e496ffe66d2$export$e4c4c45693c3a7c(child, defaultContext);
    });
    return visibleChildren;
});
var $b85a8e496ffe66d2$export$3b6f38abbdcbd000 = function useExitingPersistence() {
    return (0, $dAx5m.useContext)($b85a8e496ffe66d2$export$b9c4904d7a6929e6);
};
$b85a8e496ffe66d2$var$ExitingPersistence.displayName = "ExitingPersistence";
var $b85a8e496ffe66d2$export$2e2bcd8739ae039 = $b85a8e496ffe66d2$var$ExitingPersistence;

var $010d27b02d402655$exports = {};
var $4fc0dfbcbbac1698$exports = {};

var $4fc0dfbcbbac1698$var$_typeof = $7e71d0aad26f90bd$exports.default;
var $ded6d418aec975a0$exports = {};

var $ded6d418aec975a0$var$_typeof = $7e71d0aad26f90bd$exports.default;
function $ded6d418aec975a0$var$toPrimitive(t, r) {
    if ("object" != $ded6d418aec975a0$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $ded6d418aec975a0$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
$ded6d418aec975a0$exports = $ded6d418aec975a0$var$toPrimitive, $ded6d418aec975a0$exports.__esModule = true, $ded6d418aec975a0$exports["default"] = $ded6d418aec975a0$exports;


function $4fc0dfbcbbac1698$var$toPropertyKey(t) {
    var i = $ded6d418aec975a0$exports(t, "string");
    return "symbol" == $4fc0dfbcbbac1698$var$_typeof(i) ? i : i + "";
}
$4fc0dfbcbbac1698$exports = $4fc0dfbcbbac1698$var$toPropertyKey, $4fc0dfbcbbac1698$exports.__esModule = true, $4fc0dfbcbbac1698$exports["default"] = $4fc0dfbcbbac1698$exports;


function $010d27b02d402655$var$_defineProperty(e, r, t) {
    return (r = $4fc0dfbcbbac1698$exports(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
$010d27b02d402655$exports = $010d27b02d402655$var$_defineProperty, $010d27b02d402655$exports.__esModule = true, $010d27b02d402655$exports["default"] = $010d27b02d402655$exports;



var $dAx5m = parcelRequire("dAx5m");

/**
 * Think of this as the motion equivalent of the @atlaskit/theme `grid()`.
 */ var $c98b76627f60066f$export$368bacef0dacbe05 = 25;
var $c98b76627f60066f$export$2023a81c8547415f = $c98b76627f60066f$export$368bacef0dacbe05 * 4;
var $c98b76627f60066f$export$6fa259be09e118a7 = $c98b76627f60066f$export$368bacef0dacbe05 * 14;
var $c98b76627f60066f$export$9424640c29bc466d = $c98b76627f60066f$export$368bacef0dacbe05 * 28;





var $dAx5m = parcelRequire("dAx5m");

var $jVTBW = parcelRequire("jVTBW");



var $dAx5m = parcelRequire("dAx5m");
var $2e6068ae22bf4c40$var$getHookDeps = function getHookDeps(opts) {
    switch(opts.cleanup){
        case "next-effect":
            return undefined;
        case "unmount":
        default:
            return [];
    }
};
var $2e6068ae22bf4c40$export$1775f27e7c8051ca = function useRequestAnimationFrame() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        cleanup: "unmount"
    };
    var frames = (0, $dAx5m.useRef)([]);
    (0, $dAx5m.useEffect)(function() {
        return function() {
            if (frames.current.length) {
                frames.current.forEach(function(id) {
                    return cancelAnimationFrame(id);
                });
                frames.current = [];
            }
        };
    // We dynamically set this so we either clean up on the next effect - or on unmount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, $2e6068ae22bf4c40$var$getHookDeps(opts));
    return (0, $dAx5m.useCallback)(function(handler) {
        var id = requestAnimationFrame(function(time) {
            frames.current = frames.current.filter(function(frameId) {
                return frameId !== id;
            });
            handler(time);
        });
        frames.current.push(id);
    }, []);
};
var $2e6068ae22bf4c40$export$4f34107a2b00f39c = function useSetTimeout() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        cleanup: "unmount"
    };
    var timeouts = (0, $dAx5m.useRef)([]);
    (0, $dAx5m.useEffect)(function() {
        return function() {
            if (timeouts.current.length) {
                timeouts.current.forEach(function(id) {
                    return clearTimeout(id);
                });
                timeouts.current = [];
            }
        };
    // We dynamically set this so we either clean up on the next effect - or on unmount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, $2e6068ae22bf4c40$var$getHookDeps(opts));
    return (0, $dAx5m.useCallback)(function(handler, timeout) {
        for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
        var id = setTimeout.apply(void 0, [
            function() {
                timeouts.current = timeouts.current.filter(function(timeoutId) {
                    return timeoutId !== id;
                });
                handler();
            },
            timeout
        ].concat(args));
        timeouts.current.push(id);
    }, []);
};





var $dAx5m = parcelRequire("dAx5m");

var $Bb0he = parcelRequire("Bb0he");

var $dAx5m = parcelRequire("dAx5m");
var $6cb18f9234ab862b$export$e5c5a5f917a5871c = typeof window === "undefined" ? (0, $dAx5m.useEffect) : (0, $dAx5m.useLayoutEffect);


/* eslint-disable @repo/internal/react/disallow-unstable-values */ 
var $dAx5m = parcelRequire("dAx5m");
function $da9af6f6e6b50b14$export$c485849f2e393253() {
    var identifier = (0, $dAx5m.useRef)("");
    if (!identifier.current) identifier.current = "_" + (Number(String(Math.random()).slice(2)) + Date.now() + Math.round(performance.now())).toString(36);
    return identifier.current;
}


var $ead7f9f8ac5923d0$var$StaggeredEntranceContext = /*#__PURE__*/ (0, $dAx5m.createContext)(function() {
    return {
        isReady: true,
        delay: 0,
        ref: (0, $Bb0he.default)
    };
});
var $ead7f9f8ac5923d0$export$25c7213fc07ec080 = function useStaggeredEntrance() {
    var indentifier = (0, $da9af6f6e6b50b14$export$c485849f2e393253)();
    var context = (0, $dAx5m.useContext)($ead7f9f8ac5923d0$var$StaggeredEntranceContext);
    return context(indentifier);
};
/**
 * For a list of elements that need to animate in,
 * this should be used in conjunction with entering components.
 * This does not need Javascript to execute so it will run immediately for any SSR rendered React apps before the JS has executed.
 *
 * Will dynamically add delay to each child entering component.
 * Unfortunately all entering components _NEED_ to be a direct descendant.
 */ var $ead7f9f8ac5923d0$var$StaggeredEntrance = function StaggeredEntrance(_ref) {
    var children = _ref.children, column = _ref.column, _ref$columns = _ref.columns, columns = _ref$columns === void 0 ? "responsive" : _ref$columns, _ref$delayStep = _ref.delayStep, delayStep = _ref$delayStep === void 0 ? 50 : _ref$delayStep;
    var elementRefs = (0, $dAx5m.useRef)([]);
    var indexes = [];
    var _useState = (0, $dAx5m.useState)(function() {
        if (typeof columns === "number") // A hardcoded columns is set so bail out and set it to that!
        return columns;
        if (typeof column === "number") // A hardcoded column is set so we will set actualColumns to be 1.
        return 1;
        // We are in "responsive" mode.
        // So we will be calculating when the Javascript executes on the client how many columns there will be.
        return 0;
    }), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($5fdc9222475a2456$exports)))(_useState, 2), actualColumns = _useState2[0], setActualColumns = _useState2[1];
    (0, $6cb18f9234ab862b$export$e5c5a5f917a5871c)(function() {
        // We want to only run this code when we are in "responsive" mode.
        // It is assumed we are in responsive mode if `columns` is "responsive",
        // we have children element refs ready to be read (i.e. if there are no children this won't run as well)
        // and finally that `actualColumns` is `0` - this is because for the first render cycle `actualColumns` will be `0` (set above)
        // and then after this layout effect runs the value for `actualColumns` will then be calculated and set.
        if (columns === "responsive" && elementRefs.current.length && actualColumns === 0) {
            var currentTop = 0;
            var numberColumns = 0;
            if (elementRefs.current.length <= 1) {
                setActualColumns(1);
                return;
            }
            // We set the current top to the first elements.
            // We will be comparing this and incrementing the column count
            // until we hit an element that has a different offset top (or we run out of elements).
            currentTop = elementRefs.current[0] ? elementRefs.current[0].offsetTop : 0;
            for(var i = 0; i < elementRefs.current.length; i++){
                var child = elementRefs.current[i];
                if (!child) break;
                if (currentTop === child.offsetTop) {
                    numberColumns += 1;
                    if (elementRefs.current.length - 1 === i) setActualColumns(numberColumns);
                    continue;
                }
                setActualColumns(numberColumns);
                break;
            }
        }
    // We only want this effect to run once - on initial mount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement($ead7f9f8ac5923d0$var$StaggeredEntranceContext.Provider, {
        value: function value(id) {
            if (!indexes.includes(id)) indexes.push(id);
            var isReady = actualColumns > 0;
            var index = indexes.indexOf(id);
            var currentColumn = column || index % actualColumns;
            var currentRow = Math.floor(index / actualColumns);
            var distanceFromTopLeftElement = currentRow + currentColumn;
            // We don't want loads of elements to have the same staggered delay as it ends up looking slow for users.
            // To get around that we calculate the logarithm using `distanceFromTopLeftElement` which ends making
            // elements appear faster the further away from the top left element.
            var delay = Math.ceil(Math.log(distanceFromTopLeftElement + 1) * delayStep * 1.5) || 0;
            return {
                delay: delay,
                isReady: isReady,
                ref: function ref(element) {
                    return elementRefs.current[index] = element;
                }
            };
        }
    }, children);
};
var $ead7f9f8ac5923d0$export$2e2bcd8739ae039 = $ead7f9f8ac5923d0$var$StaggeredEntrance;


function $9ccf1f0750782710$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $9ccf1f0750782710$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $9ccf1f0750782710$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($010d27b02d402655$exports)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $9ccf1f0750782710$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
/**
 * These are props that motions should use as their external props for consumers.
 * See [FadeIn](packages/helpers/motion/src/entering/fade-in.tsx) for an example usage.
 */ /**
 * Used to multiply the initial duration for exiting motions.
 */ var $9ccf1f0750782710$var$EXITING_MOTION_MULTIPLIER = 0.5;
/**
 * This is the base INTERNAL component used for all other entering motions.
 * This does not need Javascript to execute on the client so it will run immediately
 * for any SSR rendered React apps before the JS has executed.
 */ var $9ccf1f0750782710$var$EnteringMotion = function EnteringMotion(_ref) {
    var children = _ref.children, animationTimingFunction = _ref.animationTimingFunction, enteringAnimation = _ref.enteringAnimation, exitingAnimation = _ref.exitingAnimation, isPaused = _ref.isPaused, onFinishMotion = _ref.onFinish, _ref$duration = _ref.duration, duration = _ref$duration === void 0 ? (0, $c98b76627f60066f$export$9424640c29bc466d) : _ref$duration;
    var staggered = (0, $ead7f9f8ac5923d0$export$25c7213fc07ec080)();
    var _useExitingPersistenc = (0, $b85a8e496ffe66d2$export$3b6f38abbdcbd000)(), isExiting = _useExitingPersistenc.isExiting, onExitFinished = _useExitingPersistenc.onFinish, appear = _useExitingPersistenc.appear;
    var setTimeout = (0, $2e6068ae22bf4c40$export$4f34107a2b00f39c)();
    var paused = isPaused || !staggered.isReady;
    var delay = isExiting ? 0 : staggered.delay;
    var state = isExiting ? "exiting" : "entering";
    var _useState = (0, $dAx5m.useState)(appear), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($5fdc9222475a2456$exports)))(_useState, 2), hasAnimationStyles = _useState2[0], setHasAnimationStyles = _useState2[1];
    (0, $dAx5m.useEffect)(function() {
        // Tracking this to prevent changing state on an unmounted component
        var isCancelled = false;
        if (paused) return;
        // On initial mount if elements aren't set to animate on appear, we return early and callback
        if (!appear) {
            onFinishMotion && onFinishMotion(state);
            return;
        }
        // Elements may need animation styles back after initial mount (they could animate out)
        setHasAnimationStyles(true);
        setTimeout(function() {
            if (state === "exiting") onExitFinished && onExitFinished();
            if (!isCancelled) setHasAnimationStyles(false);
            onFinishMotion && onFinishMotion(state);
        }, isExiting ? duration * $9ccf1f0750782710$var$EXITING_MOTION_MULTIPLIER : duration + delay);
        return function() {
            isCancelled = true;
        };
    // We ignore this for onFinishMotion as consumers could potentially inline the function
    // which would then trigger this effect every re-render.
    // We want to make it easier for consumers so we go down this path unfortunately.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        onExitFinished,
        state,
        isExiting,
        duration,
        delay,
        paused,
        setTimeout
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $jVTBW.ClassNames), null, function(_ref2) {
        var css = _ref2.css;
        return children({
            ref: staggered.ref,
            className: hasAnimationStyles ? css($9ccf1f0750782710$var$_objectSpread($9ccf1f0750782710$var$_objectSpread({}, (0, $b0c8cc775a82a112$export$f0f789643ba5a83c)), {}, {
                animationDelay: "".concat(delay, "ms"),
                animationDuration: "".concat(isExiting ? duration * $9ccf1f0750782710$var$EXITING_MOTION_MULTIPLIER : duration, "ms"),
                animationFillMode: isExiting ? "forwards" : "backwards",
                animationName: "".concat((0, $jVTBW.keyframes)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                isExiting ? exitingAnimation || enteringAnimation : enteringAnimation)),
                animationPlayState: paused ? "paused" : "running",
                animationTimingFunction: animationTimingFunction(state)
            })) : ""
        }, state);
    });
};
var $9ccf1f0750782710$export$2e2bcd8739ae039 = $9ccf1f0750782710$var$EnteringMotion;


var $7036c0a9a7047a9a$export$97192c8fa0d5e26b = function slideInAnimation(from, state, fade) {
    var _ref;
    var initial = state === "entering" ? "0%" : "100%";
    var end = state === "entering" ? "100%" : "0%";
    var fromMap = {
        top: "translate3d(0, -100%, 0)",
        right: "translate3d(100%, 0, 0)",
        bottom: "translate3d(0, 100%, 0)",
        left: "translate3d(-100%, 0, 0)"
    };
    var animateOpacity = fade === "inout" || fade === "in" && state === "entering" || fade === "out" && state === "exiting";
    return _ref = {}, (0, (/*@__PURE__*/$parcel$interopDefault($010d27b02d402655$exports)))(_ref, initial, {
        transform: fromMap[from],
        opacity: animateOpacity ? 0 : 1
    }), (0, (/*@__PURE__*/$parcel$interopDefault($010d27b02d402655$exports)))(_ref, end, {
        transform: "none",
        opacity: 1
    }), _ref;
};
/**
 * __SlideIn__
 *
 * Will slide an element into position, generally used for things that appear from outside of the viewport into view.
 *
 * See [examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motions).
 */ var $7036c0a9a7047a9a$var$SlideIn = function SlideIn(_ref2) {
    var children = _ref2.children, enterFrom = _ref2.enterFrom, exitTo = _ref2.exitTo, _ref2$fade = _ref2.fade, fade = _ref2$fade === void 0 ? "none" : _ref2$fade, _ref2$duration = _ref2.duration, duration = _ref2$duration === void 0 ? (0, $c98b76627f60066f$export$6fa259be09e118a7) : _ref2$duration, isPaused = _ref2.isPaused, onFinish = _ref2.onFinish, _ref2$animationTiming = _ref2.animationTimingFunction, animationTimingFunction = _ref2$animationTiming === void 0 ? function(state) {
        return state === "entering" ? (0, $d402285a12758595$export$57636bb43b1ccbb0) : (0, $d402285a12758595$export$929e5a82286172a6);
    } : _ref2$animationTiming;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $9ccf1f0750782710$export$2e2bcd8739ae039), {
        duration: duration,
        enteringAnimation: $7036c0a9a7047a9a$export$97192c8fa0d5e26b(enterFrom, "entering", fade),
        exitingAnimation: $7036c0a9a7047a9a$export$97192c8fa0d5e26b(exitTo || enterFrom, "exiting", fade),
        animationTimingFunction: animationTimingFunction,
        isPaused: isPaused,
        onFinish: onFinish
    }, children);
};
var $7036c0a9a7047a9a$export$2e2bcd8739ae039 = $7036c0a9a7047a9a$var$SlideIn;



var $ez4n6 = parcelRequire("ez4n6");

var $Bb0he = parcelRequire("Bb0he");

var $k4dMs = parcelRequire("k4dMs");

var $e2xkU = parcelRequire("e2xkU");
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ /* eslint-disable prefer-rest-params */ 
function $a5a700a6d7a1b052$export$2e2bcd8739ae039(props) {
    if (props && props.theme) {
        // Theme is the global Atlaskit theme
        if ((0, $7ed61b2292e1f49b$export$44ffba16bd48dac6) in props.theme) return props.theme[0, $7ed61b2292e1f49b$export$44ffba16bd48dac6];
        else if ("mode" in props.theme && (0, $7ed61b2292e1f49b$export$6ba72c8346b4c57e).includes(props.theme.mode)) return props.theme;
    }
    // If format not supported (or no theme provided), return standard theme
    return {
        mode: (0, $7ed61b2292e1f49b$export$c93026a968943f95)
    };
}


// Unpack custom variants, and get correct value for the current theme
function $eb079294212be146$var$themedVariants(variantProp, variants) {
    return function(props) {
        var theme = (0, $a5a700a6d7a1b052$export$2e2bcd8739ae039)(props);
        if (props && props[variantProp] && variants) {
            var modes = variants[props[variantProp]];
            if (modes && modes[theme.mode]) {
                var value = modes[theme.mode];
                if (value) return value;
                 // TS believes value can be undefined
            }
        }
        return "";
    };
}
function $eb079294212be146$export$2e2bcd8739ae039(modesOrVariant, variantModes) {
    if (typeof modesOrVariant === "string") return $eb079294212be146$var$themedVariants(modesOrVariant, variantModes);
    var modes = modesOrVariant;
    return function(props) {
        // Get theme from the user's props
        var theme = (0, $a5a700a6d7a1b052$export$2e2bcd8739ae039)(props);
        // User isn't required to provide both light and dark values
        if (theme.mode in modes) {
            var value = modes[theme.mode]; // TS believes value can be undefined
            if (value) return value;
        }
        return "";
    };
}


var $96af0d22e233ee32$export$4b84fd0e2c617bd = "#FFEBE6";
var $96af0d22e233ee32$export$b34b069eff244586 = "#FFBDAD";
var $96af0d22e233ee32$export$be802dd0d8b57f35 = "#FF8F73";
var $96af0d22e233ee32$export$60847d42f9da92a6 = "#FF7452";
var $96af0d22e233ee32$export$4a7404f376229999 = "#FF5630";
var $96af0d22e233ee32$export$2010d0fb4295b346 = "#DE350B";
var $96af0d22e233ee32$export$2837b5a1a71d5c02 = "#BF2600";
var $96af0d22e233ee32$export$8d9596b529bbb9cf = "#FFFAE6";
var $96af0d22e233ee32$export$41060a744ab0b7ae = "#FFF0B3";
var $96af0d22e233ee32$export$1cc05bbbf340e559 = "#FFE380";
var $96af0d22e233ee32$export$5aae31392d72caaa = "#FFC400";
var $96af0d22e233ee32$export$c6930421db9fa514 = "#FFAB00";
var $96af0d22e233ee32$export$59619663aa6500fb = "#FF991F";
var $96af0d22e233ee32$export$874739ea9e379ab6 = "#FF8B00";
var $96af0d22e233ee32$export$8a6341c32b6a3ee6 = "#E3FCEF";
var $96af0d22e233ee32$export$69a3bf21b9686c2b = "#ABF5D1";
var $96af0d22e233ee32$export$afbce1382ec95f73 = "#79F2C0";
var $96af0d22e233ee32$export$747d86715d4175de = "#57D9A3";
var $96af0d22e233ee32$export$940e1f69e873f202 = "#36B37E";
var $96af0d22e233ee32$export$a49394138f7b8e85 = "#00875A";
var $96af0d22e233ee32$export$6fa04827ac68a4fb = "#006644";
var $96af0d22e233ee32$export$226de0355ed012f8 = "#DEEBFF";
var $96af0d22e233ee32$export$8c13c2ee36917869 = "#B3D4FF";
var $96af0d22e233ee32$export$ecfc1dff386a3e7a = "#4C9AFF";
var $96af0d22e233ee32$export$215b7063051591f1 = "#2684FF";
var $96af0d22e233ee32$export$e62e8919cca44969 = "#0065FF";
var $96af0d22e233ee32$export$b3de0ae08da2ce64 = "#0052CC";
var $96af0d22e233ee32$export$a6ee3d71bc067634 = "#0747A6";
var $96af0d22e233ee32$export$363e4475840015bb = "#EAE6FF";
var $96af0d22e233ee32$export$4b0a4417ed59760f = "#C0B6F2";
var $96af0d22e233ee32$export$6011520a64d9a187 = "#998DD9";
var $96af0d22e233ee32$export$a7175d4e9206bc80 = "#8777D9";
var $96af0d22e233ee32$export$b48405b95304b5a1 = "#6554C0";
var $96af0d22e233ee32$export$c71e4279dd54a18d = "#5243AA";
var $96af0d22e233ee32$export$147899de772240ec = "#403294";
var $96af0d22e233ee32$export$2cf711fe14c66f06 = "#E6FCFF";
var $96af0d22e233ee32$export$7a8f4d33f6f9772c = "#B3F5FF";
var $96af0d22e233ee32$export$776c9c497ef08533 = "#79E2F2";
var $96af0d22e233ee32$export$69cb3ca10c1e330e = "#00C7E6";
var $96af0d22e233ee32$export$9dc1ef0f3f48059b = "#00B8D9";
var $96af0d22e233ee32$export$7c835c78b6fcdef8 = "#00A3BF";
var $96af0d22e233ee32$export$6036577f95c3877e = "#008DA6";
var $96af0d22e233ee32$export$29a4f05edc054374 = "#FFFFFF";
var $96af0d22e233ee32$export$e655ef011c4aa1a2 = "#FAFBFC";
var $96af0d22e233ee32$export$9fdfb749e33cdf97 = "#F4F5F7";
var $96af0d22e233ee32$export$3e51e8f1440314ba = "#EBECF0";
var $96af0d22e233ee32$export$1ce2d1575d444ceb = "#DFE1E6";
var $96af0d22e233ee32$export$8754fc7e6d8b3000 = "#C1C7D0";
var $96af0d22e233ee32$export$c2e91cbeada39b8b = "#B3BAC5";
var $96af0d22e233ee32$export$5f71e19f3a7ad9de = "#A5ADBA";
var $96af0d22e233ee32$export$eaa8c8a70ac22806 = "#97A0AF";
var $96af0d22e233ee32$export$7c87d337fb91a97d = "#8993A4";
var $96af0d22e233ee32$export$d6447c357493214f = "#7A869A";
var $96af0d22e233ee32$export$f563ee71e9ee74cd = "#6B778C";
var $96af0d22e233ee32$export$e2ef2124cf4024b1 = "#5E6C84";
var $96af0d22e233ee32$export$eece5f492e429f08 = "#505F79";
var $96af0d22e233ee32$export$c39c0fe0f26207ae = "#42526E";
var $96af0d22e233ee32$export$7090862dc3038a9f = "#344563";
var $96af0d22e233ee32$export$ad0bacf983b7ddaa = "#253858";
var $96af0d22e233ee32$export$7d61b15e0da132af = "#172B4D";
var $96af0d22e233ee32$export$fbda843f0a27fe96 = "#091E42";
var $96af0d22e233ee32$export$791e57b27ca738ef = "rgba(9, 30, 66, 0.02)";
var $96af0d22e233ee32$export$8d43898f60b96a82 = "rgba(9, 30, 66, 0.04)";
var $96af0d22e233ee32$export$920c0d5c49070351 = "rgba(9, 30, 66, 0.08)";
var $96af0d22e233ee32$export$46987b49aab6d1a8 = "rgba(9, 30, 66, 0.13)";
var $96af0d22e233ee32$export$7d3359664e8bb0e5 = "rgba(9, 30, 66, 0.25)";
var $96af0d22e233ee32$export$d2d3bedfb276cac0 = "rgba(9, 30, 66, 0.31)";
var $96af0d22e233ee32$export$6e5e7499ff054f6d = "rgba(9, 30, 66, 0.36)";
var $96af0d22e233ee32$export$59264b346c877fa7 = "rgba(9, 30, 66, 0.42)";
var $96af0d22e233ee32$export$d092757d7c64925c = "rgba(9, 30, 66, 0.48)";
var $96af0d22e233ee32$export$486ab785e4bac3c6 = "rgba(9, 30, 66, 0.54)";
var $96af0d22e233ee32$export$fba592bbc6419fea = "rgba(9, 30, 66, 0.60)";
var $96af0d22e233ee32$export$13609db0e6812ab8 = "rgba(9, 30, 66, 0.66)";
var $96af0d22e233ee32$export$fbae4efaa892d883 = "rgba(9, 30, 66, 0.71)";
var $96af0d22e233ee32$export$f13946d26f440ce6 = "rgba(9, 30, 66, 0.77)";
var $96af0d22e233ee32$export$19f58225ac52a306 = "rgba(9, 30, 66, 0.82)";
var $96af0d22e233ee32$export$6384f09da70e7b62 = "rgba(9, 30, 66, 0.89)";
var $96af0d22e233ee32$export$d0dccc730683edc2 = "rgba(9, 30, 66, 0.95)";
var $96af0d22e233ee32$export$2f6319cf7d736c2a = "#E6EDFA";
var $96af0d22e233ee32$export$95126bc8884d6634 = "#DCE5F5";
var $96af0d22e233ee32$export$8338d8c35d44ff1 = "#CED9EB";
var $96af0d22e233ee32$export$5368d76ae4fbbda7 = "#B8C7E0";
var $96af0d22e233ee32$export$9f0a771d16ec8d36 = "#ABBBD6";
var $96af0d22e233ee32$export$abcf8c38338b4aa5 = "#9FB0CC";
var $96af0d22e233ee32$export$97e81faa16a182c7 = "#8C9CB8";
var $96af0d22e233ee32$export$bfe21c59123ecf33 = "#7988A3";
var $96af0d22e233ee32$export$ee82aa2ea6a1558 = "#67758F";
var $96af0d22e233ee32$export$682927c6ed76be02 = "#56637A";
var $96af0d22e233ee32$export$91fd9994c5be9757 = "#455166";
var $96af0d22e233ee32$export$d281fbfe3cff2df6 = "#3B475C";
var $96af0d22e233ee32$export$3902c91d8b98a753 = "#313D52";
var $96af0d22e233ee32$export$8e8133c1ba5845b5 = "#283447";
var $96af0d22e233ee32$export$33ff357f6620b39 = "#202B3D";
var $96af0d22e233ee32$export$633847cf062b69e0 = "#1B2638";
var $96af0d22e233ee32$export$9776a6e503bdbf76 = "#121A29";
var $96af0d22e233ee32$export$6c813d5160dff5db = "#0E1624";
var $96af0d22e233ee32$export$3d4f271a500072a = "#0D1424";
var $96af0d22e233ee32$export$fe151285c22759ec = "rgba(13, 20, 36, 0.06)";
var $96af0d22e233ee32$export$a101c6190d0da34 = "rgba(13, 20, 36, 0.14)";
var $96af0d22e233ee32$export$4b16f52932fda51 = "rgba(13, 20, 36, 0.18)";
var $96af0d22e233ee32$export$a74bcd7b9845b0d8 = "rgba(13, 20, 36, 0.29)";
var $96af0d22e233ee32$export$9209c179316d1751 = "rgba(13, 20, 36, 0.36)";
var $96af0d22e233ee32$export$88f55133f636c8dd = "rgba(13, 20, 36, 0.40)";
var $96af0d22e233ee32$export$51126f85d1009512 = "rgba(13, 20, 36, 0.47)";
var $96af0d22e233ee32$export$a069b547bd23af78 = "rgba(13, 20, 36, 0.53)";
var $96af0d22e233ee32$export$40cce05af3b2600a = "rgba(13, 20, 36, 0.63)";
var $96af0d22e233ee32$export$b78942185925a0d = "rgba(13, 20, 36, 0.73)";
var $96af0d22e233ee32$export$e058fb44b8eaafca = "rgba(13, 20, 36, 0.78)";
var $96af0d22e233ee32$export$92b0b8de26920c18 = "rgba(13, 20, 36, 0.81)";
var $96af0d22e233ee32$export$67564f7459d3fc9e = "rgba(13, 20, 36, 0.85)";
var $96af0d22e233ee32$export$77868e1ca884ffa3 = "rgba(13, 20, 36, 0.89)";
var $96af0d22e233ee32$export$2afd71d7d3ea2cd5 = "rgba(13, 20, 36, 0.92)";
var $96af0d22e233ee32$export$f2a0acaab9972c70 = "rgba(13, 20, 36, 0.95)";
var $96af0d22e233ee32$export$9ab70e67d6475361 = "rgba(13, 20, 36, 0.97)";
var $96af0d22e233ee32$export$8ce1fd94bee2f412 = (0, $eb079294212be146$export$2e2bcd8739ae039)({
    light: "var(--ds-surface, ".concat($96af0d22e233ee32$export$29a4f05edc054374, ")"),
    dark: "var(--ds-surface, ".concat($96af0d22e233ee32$export$633847cf062b69e0, ")")
});
var $96af0d22e233ee32$export$b861914ea877b580 = (0, $eb079294212be146$export$2e2bcd8739ae039)({
    light: "var(--ds-background-selected, ".concat($96af0d22e233ee32$export$226de0355ed012f8, ")"),
    dark: "var(--ds-background-selected, ".concat($96af0d22e233ee32$export$8c13c2ee36917869, ")")
});
var $96af0d22e233ee32$export$3f1b020df94387af = (0, $eb079294212be146$export$2e2bcd8739ae039)({
    light: "var(--ds-background-neutral-hovered, ".concat($96af0d22e233ee32$export$3e51e8f1440314ba, ")"),
    dark: "var(--ds-background-neutral-hovered, ".concat($96af0d22e233ee32$export$d281fbfe3cff2df6, ")")
});
var $96af0d22e233ee32$export$c0183dbab98ca63e = (0, $eb079294212be146$export$2e2bcd8739ae039)({
    light: "var(--ds-surface-overlay, ".concat($96af0d22e233ee32$export$29a4f05edc054374, ")"),
    dark: "var(--ds-surface-overlay, ".concat($96af0d22e233ee32$export$8e8133c1ba5845b5, ")")
});
var $96af0d22e233ee32$export$6f093cfa640b7166 = (0, $eb079294212be146$export$2e2bcd8739ae039)({
    light: "var(--ds-text, ".concat($96af0d22e233ee32$export$fbda843f0a27fe96, ")"),
    dark: "var(--ds-text, ".concat($96af0d22e233ee32$export$5368d76ae4fbbda7, ")")
});
var $96af0d22e233ee32$export$42f8e9c698766e7a = (0, $eb079294212be146$export$2e2bcd8739ae039)({
    light: "var(--ds-text, ".concat($96af0d22e233ee32$export$7d61b15e0da132af, ")"),
    dark: "var(--ds-text, ".concat($96af0d22e233ee32$export$5368d76ae4fbbda7, ")")
});
var $96af0d22e233ee32$export$c2d157ca1c34b6e3 = (0, $eb079294212be146$export$2e2bcd8739ae039)({
    light: "var(--ds-text-selected, ".concat($96af0d22e233ee32$export$b3de0ae08da2ce64, ")"),
    dark: "var(--ds-text-selected, ".concat($96af0d22e233ee32$export$b3de0ae08da2ce64, ")")
});
var $96af0d22e233ee32$export$1905ba28d7cf066f = (0, $eb079294212be146$export$2e2bcd8739ae039)({
    light: "var(--ds-text-subtlest, ".concat($96af0d22e233ee32$export$f563ee71e9ee74cd, ")"),
    dark: "var(--ds-text-subtlest, ".concat($96af0d22e233ee32$export$97e81faa16a182c7, ")")
});
var $96af0d22e233ee32$export$bd9002130d306d39 = (0, $eb079294212be146$export$2e2bcd8739ae039)({
    light: "var(--ds-text-subtlest, ".concat($96af0d22e233ee32$export$f563ee71e9ee74cd, ")"),
    dark: "var(--ds-text-subtlest, ".concat($96af0d22e233ee32$export$bfe21c59123ecf33, ")")
});
var $96af0d22e233ee32$export$46e4a324ac90507f = (0, $eb079294212be146$export$2e2bcd8739ae039)({
    light: "var(--ds-text, ".concat($96af0d22e233ee32$export$7d61b15e0da132af, ")"),
    dark: "var(--ds-text, ".concat($96af0d22e233ee32$export$5368d76ae4fbbda7, ")")
});
var $96af0d22e233ee32$export$79f3f2b82beb0d36 = (0, $eb079294212be146$export$2e2bcd8739ae039)({
    light: "var(--ds-text-subtlest, ".concat($96af0d22e233ee32$export$f563ee71e9ee74cd, ")"),
    dark: "var(--ds-text-subtlest, ".concat($96af0d22e233ee32$export$97e81faa16a182c7, ")")
});
var $96af0d22e233ee32$export$7bb0d5c671655cc4 = (0, $eb079294212be146$export$2e2bcd8739ae039)({
    light: $96af0d22e233ee32$export$9fdfb749e33cdf97,
    dark: $96af0d22e233ee32$export$8e8133c1ba5845b5
});
var $96af0d22e233ee32$export$9c30223ca0a664fb = (0, $eb079294212be146$export$2e2bcd8739ae039)({
    light: "var(--ds-link, ".concat($96af0d22e233ee32$export$b3de0ae08da2ce64, ")"),
    dark: "var(--ds-link, ".concat($96af0d22e233ee32$export$ecfc1dff386a3e7a, ")")
});
var $96af0d22e233ee32$export$7ed258b0728b004b = (0, $eb079294212be146$export$2e2bcd8739ae039)({
    light: "var(--ds-link-pressed, ".concat($96af0d22e233ee32$export$e62e8919cca44969, ")"),
    dark: "var(--ds-link-pressed, ".concat($96af0d22e233ee32$export$215b7063051591f1, ")")
});
var $96af0d22e233ee32$export$dfa920d8decc8a59 = (0, $eb079294212be146$export$2e2bcd8739ae039)({
    light: "var(--ds-link-pressed, ".concat($96af0d22e233ee32$export$a6ee3d71bc067634, ")"),
    dark: "var(--ds-link-pressed, ".concat($96af0d22e233ee32$export$ecfc1dff386a3e7a, ")")
});
var $96af0d22e233ee32$export$6069e6ad5c78f632 = (0, $eb079294212be146$export$2e2bcd8739ae039)({
    light: "var(--ds-border-focused, ".concat($96af0d22e233ee32$export$215b7063051591f1, ")"),
    dark: "var(--ds-border-focused, ".concat($96af0d22e233ee32$export$215b7063051591f1, ")")
});
var $96af0d22e233ee32$export$9ad721cf3b3debe0 = (0, $eb079294212be146$export$2e2bcd8739ae039)({
    light: "var(--ds-background-brand-bold, ".concat($96af0d22e233ee32$export$b3de0ae08da2ce64, ")"),
    dark: "var(--ds-background-brand-bold, ".concat($96af0d22e233ee32$export$ecfc1dff386a3e7a, ")")
});
var $96af0d22e233ee32$export$2aa0182783e7e9de = (0, $eb079294212be146$export$2e2bcd8739ae039)({
    light: $96af0d22e233ee32$export$b3de0ae08da2ce64,
    dark: $96af0d22e233ee32$export$ecfc1dff386a3e7a
});
var $96af0d22e233ee32$export$8bf7dff220b82b4a = (0, $eb079294212be146$export$2e2bcd8739ae039)({
    light: $96af0d22e233ee32$export$9dc1ef0f3f48059b,
    dark: $96af0d22e233ee32$export$69cb3ca10c1e330e
});
var $96af0d22e233ee32$export$e13cce2a2d16a9d4 = (0, $eb079294212be146$export$2e2bcd8739ae039)({
    light: $96af0d22e233ee32$export$b48405b95304b5a1,
    dark: $96af0d22e233ee32$export$6011520a64d9a187
});
var $96af0d22e233ee32$export$a90204d1394caf30 = (0, $eb079294212be146$export$2e2bcd8739ae039)({
    light: $96af0d22e233ee32$export$4a7404f376229999,
    dark: $96af0d22e233ee32$export$4a7404f376229999
});
var $96af0d22e233ee32$export$594c5a8758200c32 = (0, $eb079294212be146$export$2e2bcd8739ae039)({
    light: $96af0d22e233ee32$export$c6930421db9fa514,
    dark: $96af0d22e233ee32$export$c6930421db9fa514
});
var $96af0d22e233ee32$export$955a2ebd2fb142ae = (0, $eb079294212be146$export$2e2bcd8739ae039)({
    light: $96af0d22e233ee32$export$940e1f69e873f202,
    dark: $96af0d22e233ee32$export$940e1f69e873f202
});
var $96af0d22e233ee32$export$2a0674ff2eb10214 = function skeleton() {
    return "var(--ds-skeleton, ".concat($96af0d22e233ee32$export$8d43898f60b96a82, ")");
};


var $7ed61b2292e1f49b$export$44ffba16bd48dac6 = "__ATLASKIT_THEME__";
var $7ed61b2292e1f49b$export$c93026a968943f95 = "light";
var $7ed61b2292e1f49b$export$6ba72c8346b4c57e = [
    "light",
    "dark"
];
var $7ed61b2292e1f49b$export$7a57f79000377ca2 = function borderRadius() {
    return 3;
};
var $7ed61b2292e1f49b$export$6d8204c2cb2e06b8 = function gridSize() {
    return 8;
};
var $7ed61b2292e1f49b$export$85e3c3ca0c6fb93 = function fontSize() {
    return 14;
};
var $7ed61b2292e1f49b$export$6746fe0d9c9fab54 = function fontSizeSmall() {
    return 11;
};
var $7ed61b2292e1f49b$export$a5975749f0374264 = function fontFamily() {
    return "-apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif";
};
var $7ed61b2292e1f49b$export$356129969ee49c55 = function codeFontFamily() {
    return "'SFMono-Medium', 'SF Mono', 'Segoe UI Mono', 'Roboto Mono', 'Ubuntu Mono', Menlo, Consolas, Courier, monospace";
};
var $7ed61b2292e1f49b$export$8e24544ddba725ee = function focusRing() {
    var color = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "var(--ds-border-focused, ".concat((0, $96af0d22e233ee32$export$215b7063051591f1), ")");
    var outlineWidth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $7ed61b2292e1f49b$export$6d8204c2cb2e06b8() / 4;
    (0, $e2xkU.default)("@atlaskit/theme", "focus ring mixin", "Please use `@atlaskit/focus-ring` instead.");
    return "\n  &:focus {\n    outline: none;\n    box-shadow: 0px 0px 0px ".concat(outlineWidth, "px ").concat(color, ";\n  }\n");
};
var $7ed61b2292e1f49b$export$c0dd343266bc3261 = function noFocusRing() {
    return "\n  box-shadow: none;\n";
};
var $7ed61b2292e1f49b$export$7be255094ccdc533 = {
    card: function card() {
        return 100;
    },
    navigation: function navigation() {
        return 200;
    },
    dialog: function dialog() {
        return 300;
    },
    layer: function layer() {
        return 400;
    },
    blanket: function blanket() {
        return 500;
    },
    modal: function modal() {
        return 510;
    },
    flag: function flag() {
        return 600;
    },
    spotlight: function spotlight() {
        return 700;
    },
    tooltip: function tooltip() {
        return 9999;
    }
};
var $7ed61b2292e1f49b$export$a1b3edb637fb4f35 = function visuallyHidden() {
    (0, $e2xkU.default)("@atlaskit/theme", "visually hidden mixin", "Please use `@atlaskit/visually-hidden` instead.");
    return {
        border: "0 !important",
        clip: "rect(1px, 1px, 1px, 1px) !important",
        height: "1px !important",
        overflow: "hidden !important",
        padding: "0 !important",
        position: "absolute !important",
        width: "1px !important",
        whiteSpace: "nowrap !important"
    };
};
var $7ed61b2292e1f49b$export$ba1d834b86d72a09 = $7ed61b2292e1f49b$export$a1b3edb637fb4f35;
var $7ed61b2292e1f49b$export$e497e856b4f89fcd = function skeletonShimmer() {
    return {
        css: {
            backgroundColor: "var(--ds-skeleton, ".concat((0, $96af0d22e233ee32$export$2a0674ff2eb10214)(), ")"),
            animationDuration: "1.5s",
            animationIterationCount: "infinite",
            animationTimingFunction: "linear",
            animationDirection: "alternate"
        },
        keyframes: {
            from: {
                backgroundColor: "var(--ds-skeleton, ".concat((0, $96af0d22e233ee32$export$2a0674ff2eb10214)(), ")")
            },
            to: {
                backgroundColor: "var(--ds-skeleton-subtle, ".concat((0, $96af0d22e233ee32$export$920c0d5c49070351), ")")
            }
        }
    };
};


var $6982668358d0e196$var$gridSize = (0, $7ed61b2292e1f49b$export$6d8204c2cb2e06b8)();
var $6982668358d0e196$export$1eee5ddc4f6d41c5 = $6982668358d0e196$var$gridSize * 50;
var $6982668358d0e196$export$a56455a41666bb2a = 400;
var $6982668358d0e196$var$defaultFlagGroupContext = {
    onDismissed: (0, $Bb0he.default),
    isDismissAllowed: false
};
var $6982668358d0e196$export$c57ba665aaa722be = /*#__PURE__*/ (0, $dAx5m.createContext)($6982668358d0e196$var$defaultFlagGroupContext);
function $6982668358d0e196$export$e91ea202abb66350() {
    return (0, $dAx5m.useContext)($6982668358d0e196$export$c57ba665aaa722be);
}
// transition: none is set on first-of-type to prevent a bug in Firefox
// that causes a broken transition
var $6982668358d0e196$var$baseStyles = (0, $jVTBW.css)({
    width: $6982668358d0e196$export$1eee5ddc4f6d41c5,
    position: "absolute",
    insetBlockEnd: 0,
    transition: "transform ".concat($6982668358d0e196$export$a56455a41666bb2a, "ms ease-in-out"),
    // TODO: Use new breakpoints
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
    "@media (max-width: 560px)": {
        width: "100vw"
    },
    ":first-of-type": {
        transform: "translate(0,0)",
        transition: "none"
    },
    ":nth-of-type(n + 2)": {
        animationDuration: "0ms",
        transform: "translateX(0) translateY(100%) translateY(".concat(2 * $6982668358d0e196$var$gridSize, "px)")
    },
    ":nth-of-type(1)": {
        zIndex: 5
    },
    ":nth-of-type(2)": {
        zIndex: 4
    },
    "&:nth-of-type(n + 4)": {
        visibility: "hidden"
    }
});
// Transform needed to push up while 1st flag is leaving
// Exiting time should match the exiting time of motion so is halved
var $6982668358d0e196$var$dismissAllowedStyles = (0, $jVTBW.css)({
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
    "&& + *": {
        transform: "translate(0, 0)",
        transitionDuration: "".concat($6982668358d0e196$export$a56455a41666bb2a / 2, "ms")
    }
});
var $6982668358d0e196$var$flagGroupContainerStyles = (0, $jVTBW.css)({
    position: "fixed",
    zIndex: "flag",
    insetBlockEnd: "var(--ds-space-600, 48px)",
    insetInlineStart: "var(--ds-space-1000, 80px)",
    // TODO: Use new breakpoints
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
    "@media (max-width: 560px)": {
        insetBlockEnd: 0,
        insetInlineStart: 0
    }
});
/**
 * __Flag group__
 *
 * A flag group is used to group a set of related flags, with entry and exit animations.
 *
 * - [Examples](https://atlassian.design/components/flag/flag-group/examples)
 * - [Code](https://atlassian.design/components/flag/flag-group/code)
 */ var $6982668358d0e196$var$FlagGroup = function FlagGroup(props) {
    var id = props.id, _props$label = props.label, label = _props$label === void 0 ? "Flag notifications" : _props$label, _props$labelTag = props.labelTag, LabelTag = _props$labelTag === void 0 ? "h2" : _props$labelTag, _props$shouldRenderTo = props.shouldRenderToParent, shouldRenderToParent = _props$shouldRenderTo === void 0 ? false : _props$shouldRenderTo, children = props.children, _props$onDismissed = props.onDismissed, onDismissed = _props$onDismissed === void 0 ? (0, $Bb0he.default) : _props$onDismissed;
    var hasFlags = Array.isArray(children) ? children.length > 0 : Boolean(children);
    var dismissFlagContext = (0, $dAx5m.useMemo)(function() {
        return {
            onDismissed: onDismissed,
            isDismissAllowed: true
        };
    }, [
        onDismissed
    ]);
    var renderChildren = function renderChildren() {
        return children && (0, (/*@__PURE__*/$parcel$interopDefault($7e71d0aad26f90bd$exports)))(children) === "object" ? (0, $dAx5m.Children).map(children, function(flag, index) {
            var isDismissAllowed = index === 0;
            return (0, $jVTBW.jsx)((0, $7036c0a9a7047a9a$export$2e2bcd8739ae039), {
                enterFrom: "left",
                fade: "inout",
                duration: $6982668358d0e196$export$a56455a41666bb2a,
                animationTimingFunction: function animationTimingFunction() {
                    return 0, $d402285a12758595$export$929e5a82286172a6;
                }
            }, function(_ref) {
                var className = _ref.className, ref = _ref.ref;
                return (0, $jVTBW.jsx)("div", {
                    css: [
                        $6982668358d0e196$var$baseStyles,
                        isDismissAllowed && $6982668358d0e196$var$dismissAllowedStyles
                    ],
                    className: className,
                    ref: ref
                }, (0, $jVTBW.jsx)($6982668358d0e196$export$c57ba665aaa722be.Provider, {
                    value: // Only the first flag should be able to be dismissed.
                    isDismissAllowed ? dismissFlagContext : $6982668358d0e196$var$defaultFlagGroupContext
                }, flag));
            });
        }) : false;
    };
    var flags = (0, $jVTBW.jsx)("div", {
        id: id,
        css: $6982668358d0e196$var$flagGroupContainerStyles
    }, hasFlags ? (0, $jVTBW.jsx)((0, $ez4n6.default), null, (0, $jVTBW.jsx)(LabelTag, null, label)) : null, (0, $jVTBW.jsx)((0, $b85a8e496ffe66d2$export$2e2bcd8739ae039), {
        appear: false
    }, renderChildren()));
    return shouldRenderToParent ? flags : (0, $jVTBW.jsx)((0, $k4dMs.default), {
        zIndex: (0, $7ed61b2292e1f49b$export$7be255094ccdc533).flag()
    }, flags);
};
var $6982668358d0e196$export$2e2bcd8739ae039 = $6982668358d0e196$var$FlagGroup;



var $ku6eE = parcelRequire("ku6eE");
const $13163be6d8b111c8$var$Card = (0, $ku6eE.default).div`
  display: relative;
  font-size: 1.4rem;
  display: flex;
  min-width: 400px;
  max-width: 400px;
  padding: 0.5rem;
  flex-direction: column;
  overflow: auto;
  display: block;
  box-sizing: border-box;
  z-index: 400;
  flex: 1 1 auto;
  background-color: var(--ds-surface-overlay, #ffffff);
  border-radius: var(--ds-border-radius, 3px);
  box-shadow: var(
    --ds-shadow-overlay,
    0 4px 8px -2px rgba(9, 30, 66, 0.25),
    0 0 1px rgba(9, 30, 66, 0.31)
  );
  --ds-elevation-surface-current: var(--ds-surface-overlay, #ffffff);
  overflow: auto;
}`;
const $13163be6d8b111c8$var$CardContent = (0, $ku6eE.default).div`
  display: flex;
  flex-direction: row;
  background: var(--ds-surface-sunken, rgba(9, 30, 66, 0.04));
  border-radius: 3px;
  padding: 1rem;
  overflow: hidden;
`;
const $13163be6d8b111c8$var$CardText = (0, $ku6eE.default).div`
  display: flex;
  flex-direction: column;
  justify-content: start;
  align-items: start;
  padding: 0.5rem;
  overflow: hidden;
  margin: auto 0 auto var(--ds-space-200, 8px);

  p {
    margin: 0;
    font-size: 0.8em;
    font-style: inherit;
    line-height: 1.2;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 100%;
  }
`;
const $13163be6d8b111c8$var$Title = (0, $ku6eE.default).p`
  font-weight: 500;
`;
const $13163be6d8b111c8$var$Subtitle = (0, $ku6eE.default).p`
  margin-top: var(--ds-space-025, 2px);
  color: var(--ds-text-subtlest, #626f86);
  font-weight: 400;
  font-size: 0.7em;
`;
const $13163be6d8b111c8$var$Avatar = (0, $ku6eE.default).img`
  width: 64px;
  height: 64px;
  border-radius: 50%;
  display: 'block';
`;
const $13163be6d8b111c8$var$Close = (0, $ku6eE.default).div`
  font-size: 0.6em;
  z-index: 500;
  color: #626f86;
  position: absolute;
  right: 18px;
  top: 18px;
  cursor: pointer;
  opacity: 0.8;

  &:hover {
   opacity: 1;
`;
const $13163be6d8b111c8$export$d639bdc25f9f17fb = ({ setShowFlag: setShowFlag, user: user, showFlag: showFlag })=>{
    return /*#__PURE__*/ (0, $bibO8.jsx)((0, $6982668358d0e196$export$2e2bcd8739ae039), {
        children: showFlag && /*#__PURE__*/ (0, $bibO8.jsxs)($13163be6d8b111c8$var$Card, {
            children: [
                /*#__PURE__*/ (0, $bibO8.jsxs)($13163be6d8b111c8$var$CardContent, {
                    children: [
                        /*#__PURE__*/ (0, $bibO8.jsx)($13163be6d8b111c8$var$Avatar, {
                            src: user.picture
                        }),
                        /*#__PURE__*/ (0, $bibO8.jsxs)($13163be6d8b111c8$var$CardText, {
                            children: [
                                /*#__PURE__*/ (0, $bibO8.jsx)($13163be6d8b111c8$var$Title, {
                                    children: user.name
                                }),
                                /*#__PURE__*/ (0, $bibO8.jsx)($13163be6d8b111c8$var$Subtitle, {
                                    children: user.email
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $bibO8.jsx)($13163be6d8b111c8$var$Close, {
                    onClick: ()=>setShowFlag(false),
                    children: "X"
                })
            ]
        })
    });
};


const $41455c10cf74c841$export$8ba4cf5ae331dcf6 = ()=>{
    const [showFlag, setShowFlag] = (0, $dAx5m.useState)(false);
    const user = (0, $cd516da2b65b22a6$export$23bbbc4533528f03)();
    const onAccountChange = (0, $dAx5m.useCallback)(()=>{
        setShowFlag(true);
        setTimeout(()=>setShowFlag(false), 3000);
    }, []);
    (0, $f394bc210f9c5627$export$cb3b96331337ab3c)({
        onAccountChange: onAccountChange
    });
    if (!user) return null;
    // We can replace AccountSwitchFlag with AccountSwitchProfileTracker when we are ready to move to the new top-right flag.
    return /*#__PURE__*/ (0, $bibO8.jsx)((0, $13163be6d8b111c8$export$d639bdc25f9f17fb), {
        showFlag: showFlag,
        setShowFlag: setShowFlag,
        user: user
    });
};








parcelRequire("bXDKf");
var $9MaY0 = parcelRequire("9MaY0");


var $4ffTz = parcelRequire("4ffTz");
const $d70703cec31080f1$var$mapStateToProps = ({ user: user })=>{
    return {
        accountId: user.data.accountId || "",
        name: user.data.fullName ?? undefined,
        email: user.data.email ?? undefined,
        switchAccountLink: `/login?application=manage-profile&prompt=select_account&continue=${encodeURIComponent((0, $1Bj4T.getConfig)().atlassianAccountUrl + (0, $3B7Hp.getManageProfileAppRootPath)())}`,
        logOutLink: `/logout?application=manage-profile&prompt=none&continue=${encodeURIComponent((0, $1Bj4T.getConfig)().atlassianAccountUrl + (0, $3B7Hp.getManageProfileAppRootPath)())}`
    };
};
const $d70703cec31080f1$var$AccountMenuContainerWithAccountSwitcher = ({ accountId: accountId, ...props })=>{
    const client = (0, $154121f230ec2ebd$export$46db560d0f65f4ac)();
    const associatedSessions = (0, $88cf1d43997d02d4$export$f3fdc91289d1e14)();
    const { avatarByAccountIdData: avatarByAccountIdData } = (0, $9MaY0.useAvatarByAccountIdQuery)(accountId, 96);
    const [themeState, setThemeState] = (0, $dAx5m.useState)(()=>{
        const currentTheme = window.localStorage.getItem("theme");
        if (currentTheme === "light" || currentTheme === "dark" || currentTheme === "auto") return currentTheme;
        return "auto";
    });
    const analytics = (0, $grRLU.default)();
    const isActive = (theme)=>themeState === theme;
    const toggleTheme = (theme)=>{
        if (isActive(theme)) return;
        setThemeState(theme);
        window.localStorage.setItem("theme", theme);
        (0, $1b86c45d2581ee88$export$2e2bcd8739ae039)({
            colorMode: theme,
            spacing: "spacing",
            shape: "shape"
        });
        analytics.pushTrackEvent({
            source: (0, $fjOHq.AnalyticsEventSource).THEME_SWITCHER,
            actionSubject: (0, $fjOHq.AnalyticsEventSubjects).THEME_STATE,
            action: (0, $fjOHq.AnalyticsEventActions).CHANGED_THEME,
            actionSubjectId: `${theme}-theme`
        });
    };
    const isThemeSwitcherEnabled = (0, $4ffTz.checkFeatureGate)((0, $4ffTz.FeatureGate).ENABLE_SETTINGS_MENU_AND_COLOR_THEMES);
    return /*#__PURE__*/ (0, $bibO8.jsx)((0, $034f75f59f2e1b15$export$ff20d75d5eda4388), {
        ...props,
        picture: avatarByAccountIdData?.avatarUrl,
        onThemeChange: isThemeSwitcherEnabled ? toggleTheme : undefined,
        currentTheme: isThemeSwitcherEnabled ? themeState : undefined,
        getAccountSwitchLink: (destination, email)=>client.getSessionSyncLink(destination, email),
        associatedSessions: associatedSessions
    });
};
const $d70703cec31080f1$export$11142a039024a491 = ({ accountId: accountId, ...props })=>{
    const { avatarByAccountIdData: avatarByAccountIdData } = (0, $9MaY0.useAvatarByAccountIdQuery)(accountId, 96);
    const [themeState, setThemeState] = (0, $dAx5m.useState)(()=>{
        const currentTheme = window.localStorage.getItem("theme");
        if (currentTheme === "light" || currentTheme === "dark" || currentTheme === "auto") return currentTheme;
        return "auto";
    });
    const analytics = (0, $grRLU.default)();
    const isActive = (theme)=>themeState === theme;
    const toggleTheme = (theme)=>{
        if (isActive(theme)) return;
        setThemeState(theme);
        window.localStorage.setItem("theme", theme);
        (0, $1b86c45d2581ee88$export$2e2bcd8739ae039)({
            colorMode: theme,
            spacing: "spacing",
            shape: "shape"
        });
        analytics.pushTrackEvent({
            source: (0, $fjOHq.AnalyticsEventSource).THEME_SWITCHER,
            actionSubject: (0, $fjOHq.AnalyticsEventSubjects).THEME_STATE,
            action: (0, $fjOHq.AnalyticsEventActions).CHANGED_THEME,
            actionSubjectId: `${theme}-theme`
        });
    };
    const isThemeSwitcherEnabled = (0, $4ffTz.checkFeatureGate)((0, $4ffTz.FeatureGate).ENABLE_SETTINGS_MENU_AND_COLOR_THEMES);
    return /*#__PURE__*/ (0, $bibO8.jsx)((0, $034f75f59f2e1b15$export$ff20d75d5eda4388), {
        ...props,
        picture: avatarByAccountIdData?.avatarUrl,
        onThemeChange: isThemeSwitcherEnabled ? toggleTheme : undefined,
        currentTheme: isThemeSwitcherEnabled ? themeState : undefined
    });
};
const $d70703cec31080f1$var$AccountSwitcherFeatureFlag = (props)=>{
    const isInProductAccountSwitchingEnabled = (0, $4ffTz.checkFeatureGate)((0, $4ffTz.FeatureGate).ENABLE_IN_PRODUCT_ACCOUNT_SWITCHER);
    return isInProductAccountSwitchingEnabled ? /*#__PURE__*/ (0, $bibO8.jsx)($d70703cec31080f1$var$AccountMenuContainerWithAccountSwitcher, {
        ...props
    }) : /*#__PURE__*/ (0, $bibO8.jsx)($d70703cec31080f1$export$11142a039024a491, {
        ...props
    });
};
var $d70703cec31080f1$export$2e2bcd8739ae039 = (0, $7PWYP.default)($d70703cec31080f1$var$mapStateToProps)($d70703cec31080f1$var$AccountSwitcherFeatureFlag);


parcelRequire("jQGCp");
var $7PWYP = parcelRequire("7PWYP");

var $bibO8 = parcelRequire("bibO8");
parcelRequire("dAx5m");
var $00d53520b6c62aef$exports = {};
function $00d53520b6c62aef$var$_extends() {
    return $00d53520b6c62aef$exports = $00d53520b6c62aef$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $00d53520b6c62aef$exports.__esModule = true, $00d53520b6c62aef$exports["default"] = $00d53520b6c62aef$exports, $00d53520b6c62aef$var$_extends.apply(null, arguments);
}
$00d53520b6c62aef$exports = $00d53520b6c62aef$var$_extends, $00d53520b6c62aef$exports.__esModule = true, $00d53520b6c62aef$exports["default"] = $00d53520b6c62aef$exports;



var $dAx5m = parcelRequire("dAx5m");


var $dAx5m = parcelRequire("dAx5m");

var $tWuif = parcelRequire("tWuif");
var $2087e80a80355736$exports = {};
var $384bcb2442727db0$exports = {};

function $384bcb2442727db0$var$_arrayWithoutHoles(r) {
    if (Array.isArray(r)) return $b02585b2a72fa69b$exports(r);
}
$384bcb2442727db0$exports = $384bcb2442727db0$var$_arrayWithoutHoles, $384bcb2442727db0$exports.__esModule = true, $384bcb2442727db0$exports["default"] = $384bcb2442727db0$exports;


var $71ad39e429e89b57$exports = {};
function $71ad39e429e89b57$var$_iterableToArray(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
$71ad39e429e89b57$exports = $71ad39e429e89b57$var$_iterableToArray, $71ad39e429e89b57$exports.__esModule = true, $71ad39e429e89b57$exports["default"] = $71ad39e429e89b57$exports;



var $755e06d8c8c7d111$exports = {};
function $755e06d8c8c7d111$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
$755e06d8c8c7d111$exports = $755e06d8c8c7d111$var$_nonIterableSpread, $755e06d8c8c7d111$exports.__esModule = true, $755e06d8c8c7d111$exports["default"] = $755e06d8c8c7d111$exports;


function $2087e80a80355736$var$_toConsumableArray(r) {
    return $384bcb2442727db0$exports(r) || $71ad39e429e89b57$exports(r) || $bf0b328db35db279$exports(r) || $755e06d8c8c7d111$exports();
}
$2087e80a80355736$exports = $2087e80a80355736$var$_toConsumableArray, $2087e80a80355736$exports.__esModule = true, $2087e80a80355736$exports["default"] = $2087e80a80355736$exports;


var $2e78e32f6aa437fc$exports = {};
function $2e78e32f6aa437fc$var$_classCallCheck(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
$2e78e32f6aa437fc$exports = $2e78e32f6aa437fc$var$_classCallCheck, $2e78e32f6aa437fc$exports.__esModule = true, $2e78e32f6aa437fc$exports["default"] = $2e78e32f6aa437fc$exports;


var $84fbf1cc3c2bb754$exports = {};

function $84fbf1cc3c2bb754$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, $4fc0dfbcbbac1698$exports(o.key), o);
    }
}
function $84fbf1cc3c2bb754$var$_createClass(e, r, t) {
    return r && $84fbf1cc3c2bb754$var$_defineProperties(e.prototype, r), t && $84fbf1cc3c2bb754$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}
$84fbf1cc3c2bb754$exports = $84fbf1cc3c2bb754$var$_createClass, $84fbf1cc3c2bb754$exports.__esModule = true, $84fbf1cc3c2bb754$exports["default"] = $84fbf1cc3c2bb754$exports;


var $69140c71ae59ad81$exports = {};
function $69140c71ae59ad81$var$_assertThisInitialized(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}
$69140c71ae59ad81$exports = $69140c71ae59ad81$var$_assertThisInitialized, $69140c71ae59ad81$exports.__esModule = true, $69140c71ae59ad81$exports["default"] = $69140c71ae59ad81$exports;


var $5cebe7c4cd4d2277$exports = {};
var $bbb8068577206d11$exports = {};
var $bdd7c384e4e1cdf1$exports = {};
function $bdd7c384e4e1cdf1$var$_getPrototypeOf(t) {
    return $bdd7c384e4e1cdf1$exports = $bdd7c384e4e1cdf1$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, $bdd7c384e4e1cdf1$exports.__esModule = true, $bdd7c384e4e1cdf1$exports["default"] = $bdd7c384e4e1cdf1$exports, $bdd7c384e4e1cdf1$var$_getPrototypeOf(t);
}
$bdd7c384e4e1cdf1$exports = $bdd7c384e4e1cdf1$var$_getPrototypeOf, $bdd7c384e4e1cdf1$exports.__esModule = true, $bdd7c384e4e1cdf1$exports["default"] = $bdd7c384e4e1cdf1$exports;


function $bbb8068577206d11$var$_superPropBase(t, o) {
    for(; !({}).hasOwnProperty.call(t, o) && null !== (t = $bdd7c384e4e1cdf1$exports(t)););
    return t;
}
$bbb8068577206d11$exports = $bbb8068577206d11$var$_superPropBase, $bbb8068577206d11$exports.__esModule = true, $bbb8068577206d11$exports["default"] = $bbb8068577206d11$exports;


function $5cebe7c4cd4d2277$var$_get() {
    return $5cebe7c4cd4d2277$exports = $5cebe7c4cd4d2277$var$_get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function(e, t, r) {
        var p = $bbb8068577206d11$exports(e, t);
        if (p) {
            var n = Object.getOwnPropertyDescriptor(p, t);
            return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value;
        }
    }, $5cebe7c4cd4d2277$exports.__esModule = true, $5cebe7c4cd4d2277$exports["default"] = $5cebe7c4cd4d2277$exports, $5cebe7c4cd4d2277$var$_get.apply(null, arguments);
}
$5cebe7c4cd4d2277$exports = $5cebe7c4cd4d2277$var$_get, $5cebe7c4cd4d2277$exports.__esModule = true, $5cebe7c4cd4d2277$exports["default"] = $5cebe7c4cd4d2277$exports;


var $1ed4679a2e2a2ac1$exports = {};
var $b47956c431c1a9e3$exports = {};
function $b47956c431c1a9e3$var$_setPrototypeOf(t, e) {
    return $b47956c431c1a9e3$exports = $b47956c431c1a9e3$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $b47956c431c1a9e3$exports.__esModule = true, $b47956c431c1a9e3$exports["default"] = $b47956c431c1a9e3$exports, $b47956c431c1a9e3$var$_setPrototypeOf(t, e);
}
$b47956c431c1a9e3$exports = $b47956c431c1a9e3$var$_setPrototypeOf, $b47956c431c1a9e3$exports.__esModule = true, $b47956c431c1a9e3$exports["default"] = $b47956c431c1a9e3$exports;


function $1ed4679a2e2a2ac1$var$_inherits(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && $b47956c431c1a9e3$exports(t, e);
}
$1ed4679a2e2a2ac1$exports = $1ed4679a2e2a2ac1$var$_inherits, $1ed4679a2e2a2ac1$exports.__esModule = true, $1ed4679a2e2a2ac1$exports["default"] = $1ed4679a2e2a2ac1$exports;


var $b796fc8f98e3e576$exports = {};

var $b796fc8f98e3e576$var$_typeof = $7e71d0aad26f90bd$exports.default;

function $b796fc8f98e3e576$var$_possibleConstructorReturn(t, e) {
    if (e && ("object" == $b796fc8f98e3e576$var$_typeof(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return $69140c71ae59ad81$exports(t);
}
$b796fc8f98e3e576$exports = $b796fc8f98e3e576$var$_possibleConstructorReturn, $b796fc8f98e3e576$exports.__esModule = true, $b796fc8f98e3e576$exports["default"] = $b796fc8f98e3e576$exports;








function $eb9d4479001bdd1a$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $eb9d4479001bdd1a$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $eb9d4479001bdd1a$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($010d27b02d402655$exports)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $eb9d4479001bdd1a$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $eb9d4479001bdd1a$export$ad4be5c2ec28cecf = function isAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $eb9d4479001bdd1a$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === "AnalyticsEvent";
};
var $eb9d4479001bdd1a$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function AnalyticsEvent(props) {
        var _this = this;
        (0, (/*@__PURE__*/$parcel$interopDefault($2e78e32f6aa437fc$exports)))(this, AnalyticsEvent);
        (0, (/*@__PURE__*/$parcel$interopDefault($010d27b02d402655$exports)))(this, "_isAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($010d27b02d402655$exports)))(this, "clone", function() {
            // just a shallow clone, don't change sub refs unless you want to
            // affect the original's too
            var payload = $eb9d4479001bdd1a$var$_objectSpread({}, _this.payload);
            return new AnalyticsEvent({
                payload: payload
            });
        });
        this.payload = props.payload;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($84fbf1cc3c2bb754$exports)))(AnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (typeof updater === "function") this.payload = updater(this.payload);
                if ((0, (/*@__PURE__*/$parcel$interopDefault($7e71d0aad26f90bd$exports)))(updater) === "object") this.payload = $eb9d4479001bdd1a$var$_objectSpread($eb9d4479001bdd1a$var$_objectSpread({}, this.payload), updater);
                return this;
            }
        }
    ]);
    return AnalyticsEvent;
}();


function $2ab6fb90e5f721cd$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $2ab6fb90e5f721cd$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, (/*@__PURE__*/$parcel$interopDefault($bdd7c384e4e1cdf1$exports)))(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, (/*@__PURE__*/$parcel$interopDefault($bdd7c384e4e1cdf1$exports)))(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, (/*@__PURE__*/$parcel$interopDefault($b796fc8f98e3e576$exports)))(this, result);
    };
}
function $2ab6fb90e5f721cd$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($2ab6fb90e5f721cd$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $2ab6fb90e5f721cd$export$35f8383928ba8d7 = function isUIAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $2ab6fb90e5f721cd$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isUIAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === "UIAnalyticsEvent";
};
var $2ab6fb90e5f721cd$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_AnalyticsEvent) {
    (0, (/*@__PURE__*/$parcel$interopDefault($1ed4679a2e2a2ac1$exports)))(UIAnalyticsEvent, _AnalyticsEvent);
    var _super = $2ab6fb90e5f721cd$var$_createSuper(UIAnalyticsEvent);
    function UIAnalyticsEvent(props) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($2e78e32f6aa437fc$exports)))(this, UIAnalyticsEvent);
        _this = _super.call(this, props);
        (0, (/*@__PURE__*/$parcel$interopDefault($010d27b02d402655$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($69140c71ae59ad81$exports)))(_this), "_isUIAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($010d27b02d402655$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($69140c71ae59ad81$exports)))(_this), "clone", function() {
            if (_this.hasFired) return null;
            var context = (0, (/*@__PURE__*/$parcel$interopDefault($2087e80a80355736$exports)))(_this.context);
            var handlers = (0, (/*@__PURE__*/$parcel$interopDefault($2087e80a80355736$exports)))(_this.handlers);
            /**
       * A hacky "deep clone" of the object. This is limited in that it wont
       * support functions, regexs, Maps, Sets, etc, but none of those need to
       * be represented in our payload.
       */ var payload = JSON.parse(JSON.stringify(_this.payload));
            return new UIAnalyticsEvent({
                context: context,
                handlers: handlers,
                payload: payload
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($010d27b02d402655$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($69140c71ae59ad81$exports)))(_this), "fire", function(channel) {
            if (_this.hasFired) return;
            _this.handlers.forEach(function(handler) {
                return handler((0, (/*@__PURE__*/$parcel$interopDefault($69140c71ae59ad81$exports)))(_this), channel);
            });
            _this.hasFired = true;
        });
        _this.context = props.context || [];
        _this.handlers = props.handlers || [];
        _this.hasFired = false;
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($84fbf1cc3c2bb754$exports)))(UIAnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (this.hasFired) return this;
                return (0, (/*@__PURE__*/$parcel$interopDefault($5cebe7c4cd4d2277$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($bdd7c384e4e1cdf1$exports)))(UIAnalyticsEvent.prototype), "update", this).call(this, updater);
            }
        }
    ]);
    return UIAnalyticsEvent;
}((0, $eb9d4479001bdd1a$export$2e2bcd8739ae039));



var $dAx5m = parcelRequire("dAx5m");

var $h0bf1 = parcelRequire("h0bf1");
var $fc3a88f3fa3344bc$export$d1f587f82ad51c4 = function useAnalyticsContext() {
    return (0, $dAx5m.useContext)((0, $h0bf1.default));
};


function $739034111f6d40c6$export$5bf35293e545f20c() {
    var analyticsContext = (0, $fc3a88f3fa3344bc$export$d1f587f82ad51c4)();
    var createAnalyticsEvent = (0, $tWuif.useCallbackOne)(function(payload) {
        return new (0, $2ab6fb90e5f721cd$export$2e2bcd8739ae039)({
            context: analyticsContext.getAtlaskitAnalyticsContext(),
            handlers: analyticsContext.getAtlaskitAnalyticsEventHandlers(),
            payload: payload
        });
    }, [
        analyticsContext
    ]);
    return {
        createAnalyticsEvent: createAnalyticsEvent
    };
}



var $dAx5m = parcelRequire("dAx5m");
var $b04d0e0a4e71520b$export$1d27a74659855e44 = function useTrackedRef(value) {
    var ref = (0, $dAx5m.useRef)(value);
    ref.current = value;
    return ref;
};


function $d0cbd00f83880f1b$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $d0cbd00f83880f1b$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $d0cbd00f83880f1b$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($010d27b02d402655$exports)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $d0cbd00f83880f1b$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $d0cbd00f83880f1b$export$a4687b0234b40e28(_ref) {
    var fn = _ref.fn, action = _ref.action, componentName = _ref.componentName, actionSubject = _ref.actionSubject, packageName = _ref.packageName, packageVersion = _ref.packageVersion, analyticsData = _ref.analyticsData;
    var _useAnalyticsEvents = (0, $739034111f6d40c6$export$5bf35293e545f20c)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    // We put analyticsData and fn in a ref so that we don't need to break
    // memoization.
    // Generally these could be defined by consumers inline
    // and so we do this to avoid breaking memoization of useCallback
    var dataRef = (0, $b04d0e0a4e71520b$export$1d27a74659855e44)(analyticsData);
    var fnRef = (0, $b04d0e0a4e71520b$export$1d27a74659855e44)(fn);
    var handler = (0, $dAx5m.useCallback)(function(value) {
        var analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: actionSubject || componentName,
            attributes: {
                componentName: componentName,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
        // To avoid wrapping this component in AnalyticsContext we manually
        // push the parent context's meta data into the context.
        // Note: this new 'context'
        var context = $d0cbd00f83880f1b$var$_objectSpread({
            componentName: componentName,
            packageName: packageName,
            packageVersion: packageVersion
        }, dataRef.current);
        analyticsEvent.context.push(context);
        // fire an event on the atlaskit channel
        var clone = analyticsEvent.clone();
        if (clone) clone.fire("atlaskit");
        fnRef.current(value, analyticsEvent);
    }, [
        // These are strings and won't change
        action,
        componentName,
        actionSubject,
        packageName,
        packageVersion,
        // This function is memoized in the context
        createAnalyticsEvent,
        // these are a stable ref because of the useTrackedRef hook
        dataRef,
        fnRef
    ]);
    return handler;
}



var $Bb0he = parcelRequire("Bb0he");




var $dAx5m = parcelRequire("dAx5m");

var $jVTBW = parcelRequire("jVTBW");

var $e0a9c9aa3fdb10fc$exports = {};
var $e56edc159db8fb3c$exports = {};
function $e56edc159db8fb3c$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.includes(n)) continue;
        t[n] = r[n];
    }
    return t;
}
$e56edc159db8fb3c$exports = $e56edc159db8fb3c$var$_objectWithoutPropertiesLoose, $e56edc159db8fb3c$exports.__esModule = true, $e56edc159db8fb3c$exports["default"] = $e56edc159db8fb3c$exports;


function $e0a9c9aa3fdb10fc$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $e56edc159db8fb3c$exports(e, t);
    if (Object.getOwnPropertySymbols) {
        var s = Object.getOwnPropertySymbols(e);
        for(r = 0; r < s.length; r++)o = s[r], t.includes(o) || ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
$e0a9c9aa3fdb10fc$exports = $e0a9c9aa3fdb10fc$var$_objectWithoutProperties, $e0a9c9aa3fdb10fc$exports.__esModule = true, $e0a9c9aa3fdb10fc$exports["default"] = $e0a9c9aa3fdb10fc$exports;



var $dAx5m = parcelRequire("dAx5m");

var $jVTBW = parcelRequire("jVTBW");


var $jVTBW = parcelRequire("jVTBW");
var $f41dc5627bc5821e$export$4ef52930e33717cd = "data-theme";
var $f41dc5627bc5821e$export$a00eac3f8684bcd0 = "data-color-mode";
var $f41dc5627bc5821e$export$2112803007239c61 = "data-contrast-mode";
var $f41dc5627bc5821e$export$352e418ed5b6193a = "data-custom-theme";
var $f41dc5627bc5821e$export$2faeed762aac6741 = "light";
var $f41dc5627bc5821e$export$6f0c6fb8c80fcc92 = "ds";
var $f41dc5627bc5821e$export$4d0c7bbf80185957 = [
    "opacity",
    "font",
    "space",
    "border"
];
var $f41dc5627bc5821e$export$dddac1532e822863 = "--".concat($f41dc5627bc5821e$export$6f0c6fb8c80fcc92, "-token-not-found");
var $f41dc5627bc5821e$export$9d7b58831ae93caa = "--".concat($f41dc5627bc5821e$export$6f0c6fb8c80fcc92, "-elevation-surface-current");


function $84ed774427a93b60$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $84ed774427a93b60$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $84ed774427a93b60$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($010d27b02d402655$exports)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $84ed774427a93b60$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $84ed774427a93b60$export$6ccdbebca2ee545f = {
    "100%": "100%",
    "size.100": "1rem",
    "size.200": "1.5rem",
    "size.300": "2rem",
    "size.400": "2.5rem",
    "size.500": "3rem",
    "size.600": "6rem",
    "size.1000": "12rem"
};
var $84ed774427a93b60$export$958d0ae7f2977ae4 = {
    "space.0": "var(--ds-space-0, 0px)",
    "space.025": "var(--ds-space-025, 2px)",
    "space.050": "var(--ds-space-050, 4px)",
    "space.075": "var(--ds-space-075, 6px)",
    "space.100": "var(--ds-space-100, 8px)",
    "space.150": "var(--ds-space-150, 12px)",
    "space.200": "var(--ds-space-200, 16px)",
    "space.250": "var(--ds-space-250, 20px)",
    "space.300": "var(--ds-space-300, 24px)",
    "space.400": "var(--ds-space-400, 32px)",
    "space.500": "var(--ds-space-500, 40px)",
    "space.600": "var(--ds-space-600, 48px)",
    "space.800": "var(--ds-space-800, 64px)",
    "space.1000": "var(--ds-space-1000, 80px)"
};
var $84ed774427a93b60$export$d2dc61f58390201c = {
    "space.negative.025": "var(--ds-space-negative-025, -2px)",
    "space.negative.050": "var(--ds-space-negative-050, -4px)",
    "space.negative.075": "var(--ds-space-negative-075, -6px)",
    "space.negative.100": "var(--ds-space-negative-100, -8px)",
    "space.negative.150": "var(--ds-space-negative-150, -12px)",
    "space.negative.200": "var(--ds-space-negative-200, -16px)",
    "space.negative.250": "var(--ds-space-negative-250, -20px)",
    "space.negative.300": "var(--ds-space-negative-300, -24px)",
    "space.negative.400": "var(--ds-space-negative-400, -32px)"
};
var $84ed774427a93b60$export$632685d741f3dbbf = $84ed774427a93b60$var$_objectSpread($84ed774427a93b60$var$_objectSpread({}, $84ed774427a93b60$export$958d0ae7f2977ae4), $84ed774427a93b60$export$d2dc61f58390201c);
var $84ed774427a93b60$export$2185ce37f9bdd963 = {
    "color.background.neutral.bold": "color.text.inverse",
    "color.background.neutral.bold.hovered": "color.text.inverse",
    "color.background.neutral.bold.pressed": "color.text.inverse",
    "color.background.selected.bold": "color.text.inverse",
    "color.background.selected.bold.hovered": "color.text.inverse",
    "color.background.selected.bold.pressed": "color.text.inverse",
    "color.background.brand.bold": "color.text.inverse",
    "color.background.brand.bold.hovered": "color.text.inverse",
    "color.background.brand.bold.pressed": "color.text.inverse",
    "color.background.brand.boldest": "color.text.inverse",
    "color.background.brand.boldest.hovered": "color.text.inverse",
    "color.background.brand.boldest.pressed": "color.text.inverse",
    "color.background.danger.bold": "color.text.inverse",
    "color.background.danger.bold.hovered": "color.text.inverse",
    "color.background.danger.bold.pressed": "color.text.inverse",
    "color.background.warning.bold": "color.text.warning.inverse",
    "color.background.warning.bold.hovered": "color.text.warning.inverse",
    "color.background.warning.bold.pressed": "color.text.warning.inverse",
    "color.background.success.bold": "color.text.inverse",
    "color.background.success.bold.hovered": "color.text.inverse",
    "color.background.success.bold.pressed": "color.text.inverse",
    "color.background.discovery.bold": "color.text.inverse",
    "color.background.discovery.bold.hovered": "color.text.inverse",
    "color.background.discovery.bold.pressed": "color.text.inverse",
    "color.background.information.bold": "color.text.inverse",
    "color.background.information.bold.hovered": "color.text.inverse",
    "color.background.information.bold.pressed": "color.text.inverse"
};
var $84ed774427a93b60$export$daf94a976c798b4f = {
    "opacity.disabled": "var(--ds-opacity-disabled, 0.4)",
    "opacity.loading": "var(--ds-opacity-loading, 0.2)"
};
var $84ed774427a93b60$export$7aff6e7ba39bb774 = {
    "elevation.shadow.overflow": "var(--ds-shadow-overflow, 0px 0px 8px #091e423f, 0px 0px 1px #091e424f)",
    "elevation.shadow.overflow.perimeter": "var(--ds-shadow-overflow-perimeter, #091e421f)",
    "elevation.shadow.overflow.spread": "var(--ds-shadow-overflow-spread, #091e4229)",
    "elevation.shadow.overlay": "var(--ds-shadow-overlay, 0px 8px 12px #091e423f, 0px 0px 1px #091e424f)",
    "elevation.shadow.raised": "var(--ds-shadow-raised, 0px 1px 1px #091e423f, 0px 0px 1px #091e4221)"
};
var $84ed774427a93b60$export$41a358c9c2356760 = {
    "elevation.surface": "var(--ds-surface, #FFFFFF)",
    "elevation.surface.hovered": "var(--ds-surface-hovered, #FAFBFC)",
    "elevation.surface.pressed": "var(--ds-surface-pressed, #F4F5F7)",
    "elevation.surface.overlay": "var(--ds-surface-overlay, #FFFFFF)",
    "elevation.surface.overlay.hovered": "var(--ds-surface-overlay-hovered, #FAFBFC)",
    "elevation.surface.overlay.pressed": "var(--ds-surface-overlay-pressed, #F4F5F7)",
    "elevation.surface.raised": "var(--ds-surface-raised, #FFFFFF)",
    "elevation.surface.raised.hovered": "var(--ds-surface-raised-hovered, #FAFBFC)",
    "elevation.surface.raised.pressed": "var(--ds-surface-raised-pressed, #F4F5F7)",
    "elevation.surface.sunken": "var(--ds-surface-sunken, #F4F5F7)"
};
var $84ed774427a93b60$export$1531ad5bb3fbedac = {
    "color.border": "var(--ds-border, #091e4221)",
    "color.border.accent.lime": "var(--ds-border-accent-lime, #6A9A23)",
    "color.border.accent.red": "var(--ds-border-accent-red, #FF5630)",
    "color.border.accent.orange": "var(--ds-border-accent-orange, #D94008)",
    "color.border.accent.yellow": "var(--ds-border-accent-yellow, #FFAB00)",
    "color.border.accent.green": "var(--ds-border-accent-green, #36B37E)",
    "color.border.accent.teal": "var(--ds-border-accent-teal, #00B8D9)",
    "color.border.accent.blue": "var(--ds-border-accent-blue, #0065FF)",
    "color.border.accent.purple": "var(--ds-border-accent-purple, #6554C0)",
    "color.border.accent.magenta": "var(--ds-border-accent-magenta, #CD519D)",
    "color.border.accent.gray": "var(--ds-border-accent-gray, #5E6C84)",
    "color.border.disabled": "var(--ds-border-disabled, #FAFBFC)",
    "color.border.focused": "var(--ds-border-focused, #2684FF)",
    "color.border.input": "var(--ds-border-input, #FAFBFC)",
    "color.border.inverse": "var(--ds-border-inverse, #FFFFFF)",
    "color.border.selected": "var(--ds-border-selected, #0052CC)",
    "color.border.brand": "var(--ds-border-brand, #0052CC)",
    "color.border.danger": "var(--ds-border-danger, #FF5630)",
    "color.border.warning": "var(--ds-border-warning, #FFC400)",
    "color.border.success": "var(--ds-border-success, #00875A)",
    "color.border.discovery": "var(--ds-border-discovery, #998DD9)",
    "color.border.information": "var(--ds-border-information, #0065FF)",
    "color.border.bold": "var(--ds-border-bold, #344563)"
};
var $84ed774427a93b60$export$d1d79bf68ac056bd = {
    "color.background.accent.lime.subtlest": "var(--ds-background-accent-lime-subtlest, #EEFBDA)",
    "color.background.accent.lime.subtlest.hovered": "var(--ds-background-accent-lime-subtlest-hovered, #D3F1A7)",
    "color.background.accent.lime.subtlest.pressed": "var(--ds-background-accent-lime-subtlest-pressed, #B3DF72)",
    "color.background.accent.lime.subtler": "var(--ds-background-accent-lime-subtler, #D3F1A7)",
    "color.background.accent.lime.subtler.hovered": "var(--ds-background-accent-lime-subtler-hovered, #B3DF72)",
    "color.background.accent.lime.subtler.pressed": "var(--ds-background-accent-lime-subtler-pressed, #94C748)",
    "color.background.accent.lime.subtle": "var(--ds-background-accent-lime-subtle, #94C748)",
    "color.background.accent.lime.subtle.hovered": "var(--ds-background-accent-lime-subtle-hovered, #B3DF72)",
    "color.background.accent.lime.subtle.pressed": "var(--ds-background-accent-lime-subtle-pressed, #D3F1A7)",
    "color.background.accent.lime.bolder": "var(--ds-background-accent-lime-bolder, #5B7F24)",
    "color.background.accent.lime.bolder.hovered": "var(--ds-background-accent-lime-bolder-hovered, #37471F)",
    "color.background.accent.lime.bolder.pressed": "var(--ds-background-accent-lime-bolder-pressed, #37471F)",
    "color.background.accent.red.subtlest": "var(--ds-background-accent-red-subtlest, #FF8F73)",
    "color.background.accent.red.subtlest.hovered": "var(--ds-background-accent-red-subtlest-hovered, #FF7452)",
    "color.background.accent.red.subtlest.pressed": "var(--ds-background-accent-red-subtlest-pressed, #FF5630)",
    "color.background.accent.red.subtler": "var(--ds-background-accent-red-subtler, #FF7452)",
    "color.background.accent.red.subtler.hovered": "var(--ds-background-accent-red-subtler-hovered, #FF5630)",
    "color.background.accent.red.subtler.pressed": "var(--ds-background-accent-red-subtler-pressed, #DE350B)",
    "color.background.accent.red.subtle": "var(--ds-background-accent-red-subtle, #DE350B)",
    "color.background.accent.red.subtle.hovered": "var(--ds-background-accent-red-subtle-hovered, #FF5630)",
    "color.background.accent.red.subtle.pressed": "var(--ds-background-accent-red-subtle-pressed, #FF7452)",
    "color.background.accent.red.bolder": "var(--ds-background-accent-red-bolder, #DE350B)",
    "color.background.accent.red.bolder.hovered": "var(--ds-background-accent-red-bolder-hovered, #FF5630)",
    "color.background.accent.red.bolder.pressed": "var(--ds-background-accent-red-bolder-pressed, #FF7452)",
    "color.background.accent.orange.subtlest": "var(--ds-background-accent-orange-subtlest, #F18D13)",
    "color.background.accent.orange.subtlest.hovered": "var(--ds-background-accent-orange-subtlest-hovered, #FEC57B)",
    "color.background.accent.orange.subtlest.pressed": "var(--ds-background-accent-orange-subtlest-pressed, #FFE2BD)",
    "color.background.accent.orange.subtler": "var(--ds-background-accent-orange-subtler, #B65C02)",
    "color.background.accent.orange.subtler.hovered": "var(--ds-background-accent-orange-subtler-hovered, #F18D13)",
    "color.background.accent.orange.subtler.pressed": "var(--ds-background-accent-orange-subtler-pressed, #FEC57B)",
    "color.background.accent.orange.subtle": "var(--ds-background-accent-orange-subtle, #5F3811)",
    "color.background.accent.orange.subtle.hovered": "var(--ds-background-accent-orange-subtle-hovered, #974F0C)",
    "color.background.accent.orange.subtle.pressed": "var(--ds-background-accent-orange-subtle-pressed, #B65C02)",
    "color.background.accent.orange.bolder": "var(--ds-background-accent-orange-bolder, #43290F)",
    "color.background.accent.orange.bolder.hovered": "var(--ds-background-accent-orange-bolder-hovered, #5F3811)",
    "color.background.accent.orange.bolder.pressed": "var(--ds-background-accent-orange-bolder-pressed, #974F0C)",
    "color.background.accent.yellow.subtlest": "var(--ds-background-accent-yellow-subtlest, #FFE380)",
    "color.background.accent.yellow.subtlest.hovered": "var(--ds-background-accent-yellow-subtlest-hovered, #FFC400)",
    "color.background.accent.yellow.subtlest.pressed": "var(--ds-background-accent-yellow-subtlest-pressed, #FFAB00)",
    "color.background.accent.yellow.subtler": "var(--ds-background-accent-yellow-subtler, #FFC400)",
    "color.background.accent.yellow.subtler.hovered": "var(--ds-background-accent-yellow-subtler-hovered, #FFAB00)",
    "color.background.accent.yellow.subtler.pressed": "var(--ds-background-accent-yellow-subtler-pressed, #FF991F)",
    "color.background.accent.yellow.subtle": "var(--ds-background-accent-yellow-subtle, #FF991F)",
    "color.background.accent.yellow.subtle.hovered": "var(--ds-background-accent-yellow-subtle-hovered, #FFAB00)",
    "color.background.accent.yellow.subtle.pressed": "var(--ds-background-accent-yellow-subtle-pressed, #FFC400)",
    "color.background.accent.yellow.bolder": "var(--ds-background-accent-yellow-bolder, #FF991F)",
    "color.background.accent.yellow.bolder.hovered": "var(--ds-background-accent-yellow-bolder-hovered, #FFAB00)",
    "color.background.accent.yellow.bolder.pressed": "var(--ds-background-accent-yellow-bolder-pressed, #FFC400)",
    "color.background.accent.green.subtlest": "var(--ds-background-accent-green-subtlest, #79F2C0)",
    "color.background.accent.green.subtlest.hovered": "var(--ds-background-accent-green-subtlest-hovered, #57D9A3)",
    "color.background.accent.green.subtlest.pressed": "var(--ds-background-accent-green-subtlest-pressed, #36B37E)",
    "color.background.accent.green.subtler": "var(--ds-background-accent-green-subtler, #57D9A3)",
    "color.background.accent.green.subtler.hovered": "var(--ds-background-accent-green-subtler-hovered, #36B37E)",
    "color.background.accent.green.subtler.pressed": "var(--ds-background-accent-green-subtler-pressed, #00875A)",
    "color.background.accent.green.subtle": "var(--ds-background-accent-green-subtle, #00875A)",
    "color.background.accent.green.subtle.hovered": "var(--ds-background-accent-green-subtle-hovered, #36B37E)",
    "color.background.accent.green.subtle.pressed": "var(--ds-background-accent-green-subtle-pressed, #57D9A3)",
    "color.background.accent.green.bolder": "var(--ds-background-accent-green-bolder, #00875A)",
    "color.background.accent.green.bolder.hovered": "var(--ds-background-accent-green-bolder-hovered, #36B37E)",
    "color.background.accent.green.bolder.pressed": "var(--ds-background-accent-green-bolder-pressed, #57D9A3)",
    "color.background.accent.teal.subtlest": "var(--ds-background-accent-teal-subtlest, #79E2F2)",
    "color.background.accent.teal.subtlest.hovered": "var(--ds-background-accent-teal-subtlest-hovered, #00C7E6)",
    "color.background.accent.teal.subtlest.pressed": "var(--ds-background-accent-teal-subtlest-pressed, #00B8D9)",
    "color.background.accent.teal.subtler": "var(--ds-background-accent-teal-subtler, #00C7E6)",
    "color.background.accent.teal.subtler.hovered": "var(--ds-background-accent-teal-subtler-hovered, #00B8D9)",
    "color.background.accent.teal.subtler.pressed": "var(--ds-background-accent-teal-subtler-pressed, #00A3BF)",
    "color.background.accent.teal.subtle": "var(--ds-background-accent-teal-subtle, #00A3BF)",
    "color.background.accent.teal.subtle.hovered": "var(--ds-background-accent-teal-subtle-hovered, #00B8D9)",
    "color.background.accent.teal.subtle.pressed": "var(--ds-background-accent-teal-subtle-pressed, #00C7E6)",
    "color.background.accent.teal.bolder": "var(--ds-background-accent-teal-bolder, #00A3BF)",
    "color.background.accent.teal.bolder.hovered": "var(--ds-background-accent-teal-bolder-hovered, #00B8D9)",
    "color.background.accent.teal.bolder.pressed": "var(--ds-background-accent-teal-bolder-pressed, #00C7E6)",
    "color.background.accent.blue.subtlest": "var(--ds-background-accent-blue-subtlest, #4C9AFF)",
    "color.background.accent.blue.subtlest.hovered": "var(--ds-background-accent-blue-subtlest-hovered, #2684FF)",
    "color.background.accent.blue.subtlest.pressed": "var(--ds-background-accent-blue-subtlest-pressed, #0065FF)",
    "color.background.accent.blue.subtler": "var(--ds-background-accent-blue-subtler, #2684FF)",
    "color.background.accent.blue.subtler.hovered": "var(--ds-background-accent-blue-subtler-hovered, #0065FF)",
    "color.background.accent.blue.subtler.pressed": "var(--ds-background-accent-blue-subtler-pressed, #0052CC)",
    "color.background.accent.blue.subtle": "var(--ds-background-accent-blue-subtle, #0052CC)",
    "color.background.accent.blue.subtle.hovered": "var(--ds-background-accent-blue-subtle-hovered, #0065FF)",
    "color.background.accent.blue.subtle.pressed": "var(--ds-background-accent-blue-subtle-pressed, #2684FF)",
    "color.background.accent.blue.bolder": "var(--ds-background-accent-blue-bolder, #0052CC)",
    "color.background.accent.blue.bolder.hovered": "var(--ds-background-accent-blue-bolder-hovered, #0065FF)",
    "color.background.accent.blue.bolder.pressed": "var(--ds-background-accent-blue-bolder-pressed, #2684FF)",
    "color.background.accent.purple.subtlest": "var(--ds-background-accent-purple-subtlest, #998DD9)",
    "color.background.accent.purple.subtlest.hovered": "var(--ds-background-accent-purple-subtlest-hovered, #8777D9)",
    "color.background.accent.purple.subtlest.pressed": "var(--ds-background-accent-purple-subtlest-pressed, #6554C0)",
    "color.background.accent.purple.subtler": "var(--ds-background-accent-purple-subtler, #8777D9)",
    "color.background.accent.purple.subtler.hovered": "var(--ds-background-accent-purple-subtler-hovered, #6554C0)",
    "color.background.accent.purple.subtler.pressed": "var(--ds-background-accent-purple-subtler-pressed, #5243AA)",
    "color.background.accent.purple.subtle": "var(--ds-background-accent-purple-subtle, #5243AA)",
    "color.background.accent.purple.subtle.hovered": "var(--ds-background-accent-purple-subtle-hovered, #6554C0)",
    "color.background.accent.purple.subtle.pressed": "var(--ds-background-accent-purple-subtle-pressed, #8777D9)",
    "color.background.accent.purple.bolder": "var(--ds-background-accent-purple-bolder, #5243AA)",
    "color.background.accent.purple.bolder.hovered": "var(--ds-background-accent-purple-bolder-hovered, #6554C0)",
    "color.background.accent.purple.bolder.pressed": "var(--ds-background-accent-purple-bolder-pressed, #8777D9)",
    "color.background.accent.magenta.subtlest": "var(--ds-background-accent-magenta-subtlest, #FFECF8)",
    "color.background.accent.magenta.subtlest.hovered": "var(--ds-background-accent-magenta-subtlest-hovered, #FDD0EC)",
    "color.background.accent.magenta.subtlest.pressed": "var(--ds-background-accent-magenta-subtlest-pressed, #F797D2)",
    "color.background.accent.magenta.subtler": "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
    "color.background.accent.magenta.subtler.hovered": "var(--ds-background-accent-magenta-subtler-hovered, #F797D2)",
    "color.background.accent.magenta.subtler.pressed": "var(--ds-background-accent-magenta-subtler-pressed, #E774BB)",
    "color.background.accent.magenta.subtle": "var(--ds-background-accent-magenta-subtle, #E774BB)",
    "color.background.accent.magenta.subtle.hovered": "var(--ds-background-accent-magenta-subtle-hovered, #F797D2)",
    "color.background.accent.magenta.subtle.pressed": "var(--ds-background-accent-magenta-subtle-pressed, #FDD0EC)",
    "color.background.accent.magenta.bolder": "var(--ds-background-accent-magenta-bolder, #AE4787)",
    "color.background.accent.magenta.bolder.hovered": "var(--ds-background-accent-magenta-bolder-hovered, #943D73)",
    "color.background.accent.magenta.bolder.pressed": "var(--ds-background-accent-magenta-bolder-pressed, #50253F)",
    "color.background.accent.gray.subtlest": "var(--ds-background-accent-gray-subtlest, #6B778C)",
    "color.background.accent.gray.subtlest.hovered": "var(--ds-background-accent-gray-subtlest-hovered, #5E6C84)",
    "color.background.accent.gray.subtlest.pressed": "var(--ds-background-accent-gray-subtlest-pressed, #505F79)",
    "color.background.accent.gray.subtler": "var(--ds-background-accent-gray-subtler, #5E6C84)",
    "color.background.accent.gray.subtler.hovered": "var(--ds-background-accent-gray-subtler-hovered, #505F79)",
    "color.background.accent.gray.subtler.pressed": "var(--ds-background-accent-gray-subtler-pressed, #42526E)",
    "color.background.accent.gray.subtle": "var(--ds-background-accent-gray-subtle, #505F79)",
    "color.background.accent.gray.subtle.hovered": "var(--ds-background-accent-gray-subtle-hovered, #5E6C84)",
    "color.background.accent.gray.subtle.pressed": "var(--ds-background-accent-gray-subtle-pressed, #6B778C)",
    "color.background.accent.gray.bolder": "var(--ds-background-accent-gray-bolder, #42526E)",
    "color.background.accent.gray.bolder.hovered": "var(--ds-background-accent-gray-bolder-hovered, #344563)",
    "color.background.accent.gray.bolder.pressed": "var(--ds-background-accent-gray-bolder-pressed, #253858)",
    "color.background.disabled": "var(--ds-background-disabled, #091e4289)",
    "color.background.input": "var(--ds-background-input, #FAFBFC)",
    "color.background.input.hovered": "var(--ds-background-input-hovered, #EBECF0)",
    "color.background.input.pressed": "var(--ds-background-input-pressed, #FFFFFF)",
    "color.background.inverse.subtle": "var(--ds-background-inverse-subtle, #00000029)",
    "color.background.inverse.subtle.hovered": "var(--ds-background-inverse-subtle-hovered, #0000003D)",
    "color.background.inverse.subtle.pressed": "var(--ds-background-inverse-subtle-pressed, #00000052)",
    "color.background.neutral": "var(--ds-background-neutral, #DFE1E6)",
    "color.background.neutral.hovered": "var(--ds-background-neutral-hovered, #091e4214)",
    "color.background.neutral.pressed": "var(--ds-background-neutral-pressed, #B3D4FF)",
    "color.background.neutral.subtle": "var(--ds-background-neutral-subtle, transparent)",
    "color.background.neutral.subtle.hovered": "var(--ds-background-neutral-subtle-hovered, #091e4214)",
    "color.background.neutral.subtle.pressed": "var(--ds-background-neutral-subtle-pressed, #B3D4FF)",
    "color.background.neutral.bold": "var(--ds-background-neutral-bold, #42526E)",
    "color.background.neutral.bold.hovered": "var(--ds-background-neutral-bold-hovered, #505F79)",
    "color.background.neutral.bold.pressed": "var(--ds-background-neutral-bold-pressed, #344563)",
    "color.background.selected": "var(--ds-background-selected, #DEEBFF)",
    "color.background.selected.hovered": "var(--ds-background-selected-hovered, #B3D4FF)",
    "color.background.selected.pressed": "var(--ds-background-selected-pressed, #4C9AFF)",
    "color.background.selected.bold": "var(--ds-background-selected-bold, #0052CC)",
    "color.background.selected.bold.hovered": "var(--ds-background-selected-bold-hovered, #2684FF)",
    "color.background.selected.bold.pressed": "var(--ds-background-selected-bold-pressed, #0052CC)",
    "color.background.brand.subtlest": "var(--ds-background-brand-subtlest, #B3D4FF)",
    "color.background.brand.subtlest.hovered": "var(--ds-background-brand-subtlest-hovered, #DEEBFF)",
    "color.background.brand.subtlest.pressed": "var(--ds-background-brand-subtlest-pressed, #4C9AFF)",
    "color.background.brand.bold": "var(--ds-background-brand-bold, #0052CC)",
    "color.background.brand.bold.hovered": "var(--ds-background-brand-bold-hovered, #0065FF)",
    "color.background.brand.bold.pressed": "var(--ds-background-brand-bold-pressed, #0747A6)",
    "color.background.brand.boldest": "var(--ds-background-brand-boldest, #0747A6)",
    "color.background.brand.boldest.hovered": "var(--ds-background-brand-boldest-hovered, #0052CC)",
    "color.background.brand.boldest.pressed": "var(--ds-background-brand-boldest-pressed, #0747A6)",
    "color.background.danger": "var(--ds-background-danger, #FFEBE6)",
    "color.background.danger.hovered": "var(--ds-background-danger-hovered, #FFBDAD)",
    "color.background.danger.pressed": "var(--ds-background-danger-pressed, #FF8F73)",
    "color.background.danger.bold": "var(--ds-background-danger-bold, #DE350B)",
    "color.background.danger.bold.hovered": "var(--ds-background-danger-bold-hovered, #FF5630)",
    "color.background.danger.bold.pressed": "var(--ds-background-danger-bold-pressed, #BF2600)",
    "color.background.warning": "var(--ds-background-warning, #FFFAE6)",
    "color.background.warning.hovered": "var(--ds-background-warning-hovered, #FFF0B3)",
    "color.background.warning.pressed": "var(--ds-background-warning-pressed, #FFE380)",
    "color.background.warning.bold": "var(--ds-background-warning-bold, #FFAB00)",
    "color.background.warning.bold.hovered": "var(--ds-background-warning-bold-hovered, #FFC400)",
    "color.background.warning.bold.pressed": "var(--ds-background-warning-bold-pressed, #FF991F)",
    "color.background.success": "var(--ds-background-success, #E3FCEF)",
    "color.background.success.hovered": "var(--ds-background-success-hovered, #ABF5D1)",
    "color.background.success.pressed": "var(--ds-background-success-pressed, #79F2C0)",
    "color.background.success.bold": "var(--ds-background-success-bold, #00875A)",
    "color.background.success.bold.hovered": "var(--ds-background-success-bold-hovered, #57D9A3)",
    "color.background.success.bold.pressed": "var(--ds-background-success-bold-pressed, #00875A)",
    "color.background.discovery": "var(--ds-background-discovery, #EAE6FF)",
    "color.background.discovery.hovered": "var(--ds-background-discovery-hovered, #C0B6F2)",
    "color.background.discovery.pressed": "var(--ds-background-discovery-pressed, #998DD9)",
    "color.background.discovery.bold": "var(--ds-background-discovery-bold, #5243AA)",
    "color.background.discovery.bold.hovered": "var(--ds-background-discovery-bold-hovered, #8777D9)",
    "color.background.discovery.bold.pressed": "var(--ds-background-discovery-bold-pressed, #5243AA)",
    "color.background.information": "var(--ds-background-information, #DEEBFF)",
    "color.background.information.hovered": "var(--ds-background-information-hovered, #B3D4FF)",
    "color.background.information.pressed": "var(--ds-background-information-pressed, #4C9AFF)",
    "color.background.information.bold": "var(--ds-background-information-bold, #0052CC)",
    "color.background.information.bold.hovered": "var(--ds-background-information-bold-hovered, #2684FF)",
    "color.background.information.bold.pressed": "var(--ds-background-information-bold-pressed, #0052CC)",
    "color.blanket": "var(--ds-blanket, #091e4289)",
    "color.blanket.selected": "var(--ds-blanket-selected, #388BFF14)",
    "color.blanket.danger": "var(--ds-blanket-danger, #EF5C4814)",
    "elevation.surface": "var(--ds-surface, #FFFFFF)",
    "elevation.surface.hovered": "var(--ds-surface-hovered, #FAFBFC)",
    "elevation.surface.pressed": "var(--ds-surface-pressed, #F4F5F7)",
    "elevation.surface.overlay": "var(--ds-surface-overlay, #FFFFFF)",
    "elevation.surface.overlay.hovered": "var(--ds-surface-overlay-hovered, #FAFBFC)",
    "elevation.surface.overlay.pressed": "var(--ds-surface-overlay-pressed, #F4F5F7)",
    "elevation.surface.raised": "var(--ds-surface-raised, #FFFFFF)",
    "elevation.surface.raised.hovered": "var(--ds-surface-raised-hovered, #FAFBFC)",
    "elevation.surface.raised.pressed": "var(--ds-surface-raised-pressed, #F4F5F7)",
    "elevation.surface.sunken": "var(--ds-surface-sunken, #F4F5F7)",
    "utility.elevation.surface.current": "var(--ds-elevation-surface-current, #FFFFFF)"
};
var $84ed774427a93b60$export$8473307aa00d6ea1 = {
    "color.text": "var(--ds-text, #172B4D)",
    "color.text.accent.lime": "var(--ds-text-accent-lime, #4C6B1F)",
    "color.text.accent.lime.bolder": "var(--ds-text-accent-lime-bolder, #37471F)",
    "color.text.accent.red": "var(--ds-text-accent-red, #DE350B)",
    "color.text.accent.red.bolder": "var(--ds-text-accent-red-bolder, #BF2600)",
    "color.text.accent.orange": "var(--ds-text-accent-orange, #F18D13)",
    "color.text.accent.orange.bolder": "var(--ds-text-accent-orange-bolder, #B65C02)",
    "color.text.accent.yellow": "var(--ds-text-accent-yellow, #FF991F)",
    "color.text.accent.yellow.bolder": "var(--ds-text-accent-yellow-bolder, #FF8B00)",
    "color.text.accent.green": "var(--ds-text-accent-green, #00875A)",
    "color.text.accent.green.bolder": "var(--ds-text-accent-green-bolder, #006644)",
    "color.text.accent.teal": "var(--ds-text-accent-teal, #00A3BF)",
    "color.text.accent.teal.bolder": "var(--ds-text-accent-teal-bolder, #008DA6)",
    "color.text.accent.blue": "var(--ds-text-accent-blue, #0052CC)",
    "color.text.accent.blue.bolder": "var(--ds-text-accent-blue-bolder, #0747A6)",
    "color.text.accent.purple": "var(--ds-text-accent-purple, #5243AA)",
    "color.text.accent.purple.bolder": "var(--ds-text-accent-purple-bolder, #403294)",
    "color.text.accent.magenta": "var(--ds-text-accent-magenta, #E774BB)",
    "color.text.accent.magenta.bolder": "var(--ds-text-accent-magenta-bolder, #DA62AC)",
    "color.text.accent.gray": "var(--ds-text-accent-gray, #505F79)",
    "color.text.accent.gray.bolder": "var(--ds-text-accent-gray-bolder, #172B4D)",
    "color.text.disabled": "var(--ds-text-disabled, #A5ADBA)",
    "color.text.inverse": "var(--ds-text-inverse, #FFFFFF)",
    "color.text.selected": "var(--ds-text-selected, #0052CC)",
    "color.text.brand": "var(--ds-text-brand, #0065FF)",
    "color.text.danger": "var(--ds-text-danger, #DE350B)",
    "color.text.warning": "var(--ds-text-warning, #974F0C)",
    "color.text.warning.inverse": "var(--ds-text-warning-inverse, #172B4D)",
    "color.text.success": "var(--ds-text-success, #006644)",
    "color.text.discovery": "var(--ds-text-discovery, #403294)",
    "color.text.information": "var(--ds-text-information, #0052CC)",
    "color.text.subtlest": "var(--ds-text-subtlest, #7A869A)",
    "color.text.subtle": "var(--ds-text-subtle, #42526E)",
    "color.link": "var(--ds-link, #0052CC)",
    "color.link.pressed": "var(--ds-link-pressed, #0747A6)",
    "color.link.visited": "var(--ds-link-visited, #403294)",
    "color.link.visited.pressed": "var(--ds-link-visited-pressed, #403294)"
};
var $84ed774427a93b60$export$498780f74be9af68 = {
    "color.icon": "var(--ds-icon, #505F79)",
    "color.icon.accent.lime": "var(--ds-icon-accent-lime, #6A9A23)",
    "color.icon.accent.red": "var(--ds-icon-accent-red, #FF5630)",
    "color.icon.accent.orange": "var(--ds-icon-accent-orange, #D94008)",
    "color.icon.accent.yellow": "var(--ds-icon-accent-yellow, #FFAB00)",
    "color.icon.accent.green": "var(--ds-icon-accent-green, #36B37E)",
    "color.icon.accent.teal": "var(--ds-icon-accent-teal, #00B8D9)",
    "color.icon.accent.blue": "var(--ds-icon-accent-blue, #0065FF)",
    "color.icon.accent.purple": "var(--ds-icon-accent-purple, #6554C0)",
    "color.icon.accent.magenta": "var(--ds-icon-accent-magenta, #CD519D)",
    "color.icon.accent.gray": "var(--ds-icon-accent-gray, #5E6C84)",
    "color.icon.disabled": "var(--ds-icon-disabled, #8993A4)",
    "color.icon.inverse": "var(--ds-icon-inverse, #FFFFFF)",
    "color.icon.selected": "var(--ds-icon-selected, #0052CC)",
    "color.icon.brand": "var(--ds-icon-brand, #0065FF)",
    "color.icon.danger": "var(--ds-icon-danger, #DE350B)",
    "color.icon.warning": "var(--ds-icon-warning, #FFC400)",
    "color.icon.warning.inverse": "var(--ds-icon-warning-inverse, #253858)",
    "color.icon.success": "var(--ds-icon-success, #00875A)",
    "color.icon.discovery": "var(--ds-icon-discovery, #8777D9)",
    "color.icon.information": "var(--ds-icon-information, #0747A6)",
    "color.icon.subtle": "var(--ds-icon-subtle, #6B778C)"
};
var $84ed774427a93b60$export$b5f31a7e431d2eab = {
    card: 100,
    navigation: 200,
    dialog: 300,
    layer: 400,
    blanket: 500,
    modal: 510,
    flag: 600,
    spotlight: 700,
    tooltip: 800
};
var $84ed774427a93b60$export$e1b83c5210c471b8 = {
    "border.width": "var(--ds-border-width, 1px)",
    "border.width.0": "var(--ds-border-width-0, 0px)",
    "border.width.indicator": "var(--ds-border-width-indicator, 3px)",
    "border.width.outline": "var(--ds-border-width-outline, 2px)"
};
var $84ed774427a93b60$export$3c0a6c3e64bb180d = {
    "border.radius.050": "var(--ds-border-radius-050, 2px)",
    "border.radius": "var(--ds-border-radius, 3px)",
    "border.radius.100": "var(--ds-border-radius-100, 3px)",
    "border.radius.200": "var(--ds-border-radius-200, 8px)",
    "border.radius.300": "var(--ds-border-radius-300, 12px)",
    "border.radius.400": "var(--ds-border-radius-400, 16px)",
    "border.radius.circle": "var(--ds-border-radius-circle, 32032px)"
};
var $84ed774427a93b60$export$6cc560b4dedf3816 = {
    medium: 'var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    UNSAFE_small: 'var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    large: 'var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    small: 'var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)'
};
var $84ed774427a93b60$export$303e322c6b1ed114 = {
    bold: "var(--ds-font-weight-bold, 700)",
    medium: "var(--ds-font-weight-medium, 500)",
    regular: "var(--ds-font-weight-regular, 400)",
    semibold: "var(--ds-font-weight-semibold, 600)"
};
var $84ed774427a93b60$export$3c7e9587132614b4 = {
    "font.family.body": 'var(--ds-font-family-body, ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.family.brand.body": 'var(--ds-font-family-brand-body, "Charlie Text", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.family.brand.heading": 'var(--ds-font-family-brand-heading, "Charlie Display", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.family.code": 'var(--ds-font-family-code, ui-monospace, Menlo, "Segoe UI Mono", "Ubuntu Mono", monospace)',
    "font.family.heading": 'var(--ds-font-family-heading, ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)'
};
/**
 * @codegenEnd
 */ // Generate maps for Box props. backgroundColor, padding, etc
var $84ed774427a93b60$var$spacingProperties = [
    // Used by Box
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    // Used by Inline and Stack
    "gap",
    "rowGap",
    "columnGap"
];
var $84ed774427a93b60$var$getSerializedStylesMap = function getSerializedStylesMap(cssProperty, tokenMap) {
    return Object.keys(tokenMap).reduce(function(emotionSpacingMap, token) {
        emotionSpacingMap[token] = (0, $jVTBW.css)((0, (/*@__PURE__*/$parcel$interopDefault($010d27b02d402655$exports)))({}, cssProperty, tokenMap[token]));
        return emotionSpacingMap;
    }, {});
};
var $84ed774427a93b60$export$e615f061ca585a6c = $84ed774427a93b60$var$spacingProperties.reduce(function(styleMap, spacingProperty) {
    styleMap[spacingProperty] = $84ed774427a93b60$var$getSerializedStylesMap(spacingProperty, $84ed774427a93b60$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
var $84ed774427a93b60$export$bf46c3f9eeafc71f = $84ed774427a93b60$var$spacingProperties.reduce(function(styleMap, spacingProperty) {
    styleMap[spacingProperty] = $84ed774427a93b60$var$getSerializedStylesMap(spacingProperty, $84ed774427a93b60$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
var $84ed774427a93b60$export$e7af83bafe7f9e63 = $84ed774427a93b60$var$getSerializedStylesMap("backgroundColor", $84ed774427a93b60$export$d1d79bf68ac056bd);
var $84ed774427a93b60$export$3a1bcba60b23d7f0 = $84ed774427a93b60$var$getSerializedStylesMap("color", $84ed774427a93b60$export$8473307aa00d6ea1);
var $84ed774427a93b60$export$45f3f4fe16f9f7d5 = $84ed774427a93b60$var$getSerializedStylesMap("fontWeight", $84ed774427a93b60$export$303e322c6b1ed114);
var $84ed774427a93b60$export$68cc305da27dbaa4 = $84ed774427a93b60$var$getSerializedStylesMap("fontFamily", $84ed774427a93b60$export$3c7e9587132614b4);
var $84ed774427a93b60$export$128f10c238242f83 = $84ed774427a93b60$var$getSerializedStylesMap("font", $84ed774427a93b60$export$6cc560b4dedf3816);
var $84ed774427a93b60$export$ff257d957d48c421 = $84ed774427a93b60$var$getSerializedStylesMap((0, $f41dc5627bc5821e$export$9d7b58831ae93caa), $84ed774427a93b60$export$41a358c9c2356760);
var $84ed774427a93b60$export$5e65a44e5b6ecadb = function isSurfaceColorToken(color) {
    return $84ed774427a93b60$export$41a358c9c2356760[color] !== undefined;
};







var $jVTBW = parcelRequire("jVTBW");


var $ahJoN = parcelRequire("ahJoN");
function $e54127128664e945$var$_createForOfIteratorHelper(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (!it) {
        if (Array.isArray(o) || (it = $e54127128664e945$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
            if (it) o = it;
            var i = 0;
            var F = function F() {};
            return {
                s: F,
                n: function n() {
                    if (i >= o.length) return {
                        done: true
                    };
                    return {
                        done: false,
                        value: o[i++]
                    };
                },
                e: function e(_e) {
                    throw _e;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var normalCompletion = true, didErr = false, err;
    return {
        s: function s() {
            it = it.call(o);
        },
        n: function n() {
            var step = it.next();
            normalCompletion = step.done;
            return step;
        },
        e: function e(_e2) {
            didErr = true;
            err = _e2;
        },
        f: function f() {
            try {
                if (!normalCompletion && it.return != null) it.return();
            } finally{
                if (didErr) throw err;
            }
        }
    };
}
function $e54127128664e945$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $e54127128664e945$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $e54127128664e945$var$_arrayLikeToArray(o, minLen);
}
function $e54127128664e945$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $e54127128664e945$export$9a199fbafee0014e = {
    backgroundColor: (0, $84ed774427a93b60$export$d1d79bf68ac056bd),
    blockSize: (0, $84ed774427a93b60$export$6ccdbebca2ee545f),
    borderBlockColor: (0, $84ed774427a93b60$export$1531ad5bb3fbedac),
    borderBlockEndColor: (0, $84ed774427a93b60$export$1531ad5bb3fbedac),
    borderBlockEndWidth: (0, $84ed774427a93b60$export$e1b83c5210c471b8),
    borderBlockStartColor: (0, $84ed774427a93b60$export$1531ad5bb3fbedac),
    borderBlockStartWidth: (0, $84ed774427a93b60$export$e1b83c5210c471b8),
    borderBlockWidth: (0, $84ed774427a93b60$export$e1b83c5210c471b8),
    borderBottomColor: (0, $84ed774427a93b60$export$1531ad5bb3fbedac),
    borderBottomLeftRadius: (0, $84ed774427a93b60$export$3c0a6c3e64bb180d),
    borderBottomRightRadius: (0, $84ed774427a93b60$export$3c0a6c3e64bb180d),
    borderBottomWidth: (0, $84ed774427a93b60$export$e1b83c5210c471b8),
    borderColor: (0, $84ed774427a93b60$export$1531ad5bb3fbedac),
    borderEndEndRadius: (0, $84ed774427a93b60$export$3c0a6c3e64bb180d),
    borderEndStartRadius: (0, $84ed774427a93b60$export$3c0a6c3e64bb180d),
    borderInlineColor: (0, $84ed774427a93b60$export$1531ad5bb3fbedac),
    borderInlineEndColor: (0, $84ed774427a93b60$export$1531ad5bb3fbedac),
    borderInlineEndWidth: (0, $84ed774427a93b60$export$e1b83c5210c471b8),
    borderInlineStartColor: (0, $84ed774427a93b60$export$1531ad5bb3fbedac),
    borderInlineStartWidth: (0, $84ed774427a93b60$export$e1b83c5210c471b8),
    borderInlineWidth: (0, $84ed774427a93b60$export$e1b83c5210c471b8),
    borderLeftColor: (0, $84ed774427a93b60$export$1531ad5bb3fbedac),
    borderLeftWidth: (0, $84ed774427a93b60$export$e1b83c5210c471b8),
    borderRadius: (0, $84ed774427a93b60$export$3c0a6c3e64bb180d),
    borderRightColor: (0, $84ed774427a93b60$export$1531ad5bb3fbedac),
    borderRightWidth: (0, $84ed774427a93b60$export$e1b83c5210c471b8),
    borderStartEndRadius: (0, $84ed774427a93b60$export$3c0a6c3e64bb180d),
    borderStartStartRadius: (0, $84ed774427a93b60$export$3c0a6c3e64bb180d),
    borderTopColor: (0, $84ed774427a93b60$export$1531ad5bb3fbedac),
    borderTopLeftRadius: (0, $84ed774427a93b60$export$3c0a6c3e64bb180d),
    borderTopRightRadius: (0, $84ed774427a93b60$export$3c0a6c3e64bb180d),
    borderTopWidth: (0, $84ed774427a93b60$export$e1b83c5210c471b8),
    borderWidth: (0, $84ed774427a93b60$export$e1b83c5210c471b8),
    bottom: (0, $84ed774427a93b60$export$632685d741f3dbbf),
    boxShadow: (0, $84ed774427a93b60$export$7aff6e7ba39bb774),
    color: (0, $84ed774427a93b60$export$8473307aa00d6ea1),
    columnGap: (0, $84ed774427a93b60$export$958d0ae7f2977ae4),
    gap: (0, $84ed774427a93b60$export$958d0ae7f2977ae4),
    height: (0, $84ed774427a93b60$export$6ccdbebca2ee545f),
    inlineSize: (0, $84ed774427a93b60$export$6ccdbebca2ee545f),
    inset: (0, $84ed774427a93b60$export$632685d741f3dbbf),
    insetBlock: (0, $84ed774427a93b60$export$632685d741f3dbbf),
    insetBlockEnd: (0, $84ed774427a93b60$export$632685d741f3dbbf),
    insetBlockStart: (0, $84ed774427a93b60$export$632685d741f3dbbf),
    insetInline: (0, $84ed774427a93b60$export$632685d741f3dbbf),
    insetInlineEnd: (0, $84ed774427a93b60$export$632685d741f3dbbf),
    insetInlineStart: (0, $84ed774427a93b60$export$632685d741f3dbbf),
    left: (0, $84ed774427a93b60$export$632685d741f3dbbf),
    margin: (0, $84ed774427a93b60$export$632685d741f3dbbf),
    marginBlock: (0, $84ed774427a93b60$export$632685d741f3dbbf),
    marginBlockEnd: (0, $84ed774427a93b60$export$632685d741f3dbbf),
    marginBlockStart: (0, $84ed774427a93b60$export$632685d741f3dbbf),
    marginBottom: (0, $84ed774427a93b60$export$632685d741f3dbbf),
    marginInline: (0, $84ed774427a93b60$export$632685d741f3dbbf),
    marginInlineEnd: (0, $84ed774427a93b60$export$632685d741f3dbbf),
    marginInlineStart: (0, $84ed774427a93b60$export$632685d741f3dbbf),
    marginLeft: (0, $84ed774427a93b60$export$632685d741f3dbbf),
    marginRight: (0, $84ed774427a93b60$export$632685d741f3dbbf),
    marginTop: (0, $84ed774427a93b60$export$632685d741f3dbbf),
    maxBlockSize: (0, $84ed774427a93b60$export$6ccdbebca2ee545f),
    maxHeight: (0, $84ed774427a93b60$export$6ccdbebca2ee545f),
    maxInlineSize: (0, $84ed774427a93b60$export$6ccdbebca2ee545f),
    maxWidth: (0, $84ed774427a93b60$export$6ccdbebca2ee545f),
    minBlockSize: (0, $84ed774427a93b60$export$6ccdbebca2ee545f),
    minHeight: (0, $84ed774427a93b60$export$6ccdbebca2ee545f),
    minInlineSize: (0, $84ed774427a93b60$export$6ccdbebca2ee545f),
    minWidth: (0, $84ed774427a93b60$export$6ccdbebca2ee545f),
    opacity: (0, $84ed774427a93b60$export$daf94a976c798b4f),
    outlineColor: (0, $84ed774427a93b60$export$1531ad5bb3fbedac),
    outlineOffset: (0, $84ed774427a93b60$export$958d0ae7f2977ae4),
    outlineWidth: (0, $84ed774427a93b60$export$e1b83c5210c471b8),
    padding: (0, $84ed774427a93b60$export$958d0ae7f2977ae4),
    paddingBlock: (0, $84ed774427a93b60$export$958d0ae7f2977ae4),
    paddingBlockEnd: (0, $84ed774427a93b60$export$958d0ae7f2977ae4),
    paddingBlockStart: (0, $84ed774427a93b60$export$958d0ae7f2977ae4),
    paddingBottom: (0, $84ed774427a93b60$export$958d0ae7f2977ae4),
    paddingInline: (0, $84ed774427a93b60$export$958d0ae7f2977ae4),
    paddingInlineEnd: (0, $84ed774427a93b60$export$958d0ae7f2977ae4),
    paddingInlineStart: (0, $84ed774427a93b60$export$958d0ae7f2977ae4),
    paddingLeft: (0, $84ed774427a93b60$export$958d0ae7f2977ae4),
    paddingRight: (0, $84ed774427a93b60$export$958d0ae7f2977ae4),
    paddingTop: (0, $84ed774427a93b60$export$958d0ae7f2977ae4),
    right: (0, $84ed774427a93b60$export$632685d741f3dbbf),
    rowGap: (0, $84ed774427a93b60$export$958d0ae7f2977ae4),
    top: (0, $84ed774427a93b60$export$632685d741f3dbbf),
    width: (0, $84ed774427a93b60$export$6ccdbebca2ee545f),
    zIndex: (0, $84ed774427a93b60$export$b5f31a7e431d2eab)
};
var $e54127128664e945$var$uniqueSymbol = Symbol("UNSAFE_INTERNAL_styles");
var $e54127128664e945$var$isSafeEnvToThrow = function isSafeEnvToThrow() {
    return (typeof $ahJoN === "undefined" ? "undefined" : (0, (/*@__PURE__*/$parcel$interopDefault($7e71d0aad26f90bd$exports)))($ahJoN)) === "object" && (0, (/*@__PURE__*/$parcel$interopDefault($7e71d0aad26f90bd$exports)))($ahJoN.env) === "object" && false;
};
var $e54127128664e945$var$reNestedSelectors = /(\.|\s|&+|\*\>|#|\[.*\])/;
var $e54127128664e945$var$safeSelectors = /^@media .*$|^::?.*$|^@supports .*$/;
var $e54127128664e945$var$transformStyles = function transformStyles(styleObj) {
    if (!styleObj || (0, (/*@__PURE__*/$parcel$interopDefault($7e71d0aad26f90bd$exports)))(styleObj) !== "object") return styleObj;
    // If styles are defined as a CSSObject[], recursively call on each element until we reach CSSObject
    if (Array.isArray(styleObj)) return styleObj.map(transformStyles);
    // Modifies styleObj in place. Be careful.
    Object.entries(styleObj).forEach(function(_ref) {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($5fdc9222475a2456$exports)))(_ref, 2), key = _ref2[0], value = _ref2[1];
        // If key is a pseudo class or a pseudo element, then value should be an object.
        // So, call transformStyles on the value
        if ((0, (/*@__PURE__*/$parcel$interopDefault($7e71d0aad26f90bd$exports)))(value) === "object" && $e54127128664e945$var$safeSelectors.test(key)) {
            styleObj[key] = transformStyles(value);
            return;
        }
        if ($e54127128664e945$var$isSafeEnvToThrow()) {
            // We don't support `.class`, `[data-testid]`, `> *`, `#some-id`
            if ($e54127128664e945$var$reNestedSelectors.test(key)) throw new Error("Styles not supported for key '".concat(key, "'."));
        }
        // We have now dealt with all the special cases, so,
        // check whether what remains is a style property
        // that can be transformed.
        if (!(key in $e54127128664e945$export$9a199fbafee0014e)) return;
        var tokenValue = $e54127128664e945$export$9a199fbafee0014e[key][value];
        styleObj[key] = tokenValue !== null && tokenValue !== void 0 ? tokenValue : value;
    });
    return styleObj;
};
var $e54127128664e945$var$baseXcss = function baseXcss(style) {
    var transformedStyles = $e54127128664e945$var$transformStyles(style);
    return (0, (/*@__PURE__*/$parcel$interopDefault($010d27b02d402655$exports)))({}, $e54127128664e945$var$uniqueSymbol, (0, $jVTBW.css)(transformedStyles));
};
var $e54127128664e945$export$a9c84988c8f81f2d = function parseXcss(args) {
    if (Array.isArray(args)) {
        var emotion = [];
        var staticArr = [];
        var _iterator = $e54127128664e945$var$_createForOfIteratorHelper(args), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var arg = _step.value;
                var result = parseXcss(arg);
                if (result.emotion) emotion.push.apply(emotion, (0, (/*@__PURE__*/$parcel$interopDefault($2087e80a80355736$exports)))(result.emotion));
                if (result.static) staticArr.push(result.static);
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        return {
            emotion: emotion,
            static: staticArr.join(" ")
        };
    }
    var objArgs = args;
    var _ref4 = objArgs || {}, styles = _ref4[$e54127128664e945$var$uniqueSymbol];
    if (styles) return {
        emotion: [
            styles
        ]
    };
    if (args) {
        // We use string interpolation here instead of .toString() just
        // in case the resulting object doesn't have the method available.
        var stringifiedArgs = "".concat(args);
        if (stringifiedArgs) return {
            static: stringifiedArgs
        };
    }
    return {};
};
function $e54127128664e945$export$f6c783d06584602c(style) {
    return $e54127128664e945$var$baseXcss(style);
}



var $dAx5m = parcelRequire("dAx5m");
var $e7a68fb03404bc50$export$1ca2a26fecb070ae = /*#__PURE__*/ (0, $dAx5m.createContext)("elevation.surface");
var $e7a68fb03404bc50$export$1aeb4f6b93c4540d = function useSurface() {
    return (0, $dAx5m.useContext)($e7a68fb03404bc50$export$1ca2a26fecb070ae);
};
$e7a68fb03404bc50$export$1ca2a26fecb070ae.displayName = "SurfaceProvider";


var $9258da2743650ae3$var$_excluded = [
    "as",
    "children",
    "backgroundColor",
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    "style",
    "testId",
    "xcss"
], $9258da2743650ae3$var$_excluded2 = [
    "className"
];
var $9258da2743650ae3$export$e71c4d32a2263218 = /*#__PURE__*/ (0, $dAx5m.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? "div" : _ref$as, children = _ref.children, backgroundColor = _ref.backgroundColor, padding = _ref.padding, paddingBlock = _ref.paddingBlock, paddingBlockStart = _ref.paddingBlockStart, paddingBlockEnd = _ref.paddingBlockEnd, paddingInline = _ref.paddingInline, paddingInlineStart = _ref.paddingInlineStart, paddingInlineEnd = _ref.paddingInlineEnd, style = _ref.style, testId = _ref.testId, xcss = _ref.xcss, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($e0a9c9aa3fdb10fc$exports)))(_ref, $9258da2743650ae3$var$_excluded);
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($e0a9c9aa3fdb10fc$exports)))(htmlAttributes, $9258da2743650ae3$var$_excluded2);
    var resolvedStyles = (0, $e54127128664e945$export$a9c84988c8f81f2d)(xcss);
    var node = // @ts-expect-error Expression produces a union type that is too complex to represent. I think this is unavoidable
    (0, $jVTBW.jsx)(Component, (0, (/*@__PURE__*/$parcel$interopDefault($00d53520b6c62aef$exports)))({
        style: style,
        ref: ref,
        className: resolvedStyles.static
    }, safeHtmlAttributes, {
        css: [
            $9258da2743650ae3$var$baseStyles,
            backgroundColor && (0, $84ed774427a93b60$export$e7af83bafe7f9e63)[backgroundColor],
            (0, $84ed774427a93b60$export$5e65a44e5b6ecadb)(backgroundColor) && (0, $84ed774427a93b60$export$ff257d957d48c421)[backgroundColor],
            padding && (0, $84ed774427a93b60$export$e615f061ca585a6c).padding[padding],
            paddingBlock && (0, $84ed774427a93b60$export$e615f061ca585a6c).paddingBlock[paddingBlock],
            paddingBlockStart && (0, $84ed774427a93b60$export$e615f061ca585a6c).paddingBlockStart[paddingBlockStart],
            paddingBlockEnd && (0, $84ed774427a93b60$export$e615f061ca585a6c).paddingBlockEnd[paddingBlockEnd],
            paddingInline && (0, $84ed774427a93b60$export$e615f061ca585a6c).paddingInline[paddingInline],
            paddingInlineStart && (0, $84ed774427a93b60$export$e615f061ca585a6c).paddingInlineStart[paddingInlineStart],
            paddingInlineEnd && (0, $84ed774427a93b60$export$e615f061ca585a6c).paddingInlineEnd[paddingInlineEnd],
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
            resolvedStyles.emotion
        ],
        "data-testid": testId
    }), children);
    return backgroundColor ? (0, $jVTBW.jsx)((0, $e7a68fb03404bc50$export$1ca2a26fecb070ae).Provider, {
        value: backgroundColor
    }, node) : node;
});
var $9258da2743650ae3$export$2e2bcd8739ae039 = $9258da2743650ae3$export$e71c4d32a2263218;
var $9258da2743650ae3$var$baseStyles = (0, $jVTBW.css)({
    boxSizing: "border-box",
    appearance: "none",
    border: "none"
});



var $dAx5m = parcelRequire("dAx5m");

var $jVTBW = parcelRequire("jVTBW");

/** @jsx jsx */ 
var $dAx5m = parcelRequire("dAx5m");

var $jVTBW = parcelRequire("jVTBW");


var $b2f14aa3f60e32fd$var$justifyContentMap = {
    start: (0, $jVTBW.css)({
        justifyContent: "start"
    }),
    center: (0, $jVTBW.css)({
        justifyContent: "center"
    }),
    end: (0, $jVTBW.css)({
        justifyContent: "end"
    }),
    "space-between": (0, $jVTBW.css)({
        justifyContent: "space-between"
    }),
    "space-around": (0, $jVTBW.css)({
        justifyContent: "space-around"
    }),
    "space-evenly": (0, $jVTBW.css)({
        justifyContent: "space-evenly"
    }),
    stretch: (0, $jVTBW.css)({
        justifyContent: "stretch"
    })
};
var $b2f14aa3f60e32fd$var$flexDirectionMap = {
    column: (0, $jVTBW.css)({
        flexDirection: "column"
    }),
    row: (0, $jVTBW.css)({
        flexDirection: "row"
    })
};
var $b2f14aa3f60e32fd$var$flexWrapMap = {
    wrap: (0, $jVTBW.css)({
        flexWrap: "wrap"
    }),
    nowrap: (0, $jVTBW.css)({
        flexWrap: "nowrap"
    })
};
var $b2f14aa3f60e32fd$var$alignItemsMap = {
    start: (0, $jVTBW.css)({
        alignItems: "start"
    }),
    center: (0, $jVTBW.css)({
        alignItems: "center"
    }),
    baseline: (0, $jVTBW.css)({
        alignItems: "baseline"
    }),
    end: (0, $jVTBW.css)({
        alignItems: "end"
    }),
    stretch: (0, $jVTBW.css)({
        alignItems: "stretch"
    })
};
var $b2f14aa3f60e32fd$var$baseStyles = (0, $jVTBW.css)({
    display: "flex",
    boxSizing: "border-box"
});
/**
 * __Flex__
 *
 * `Flex` is a primitive component that implements the CSS Flexbox API.
 *
 * - [Examples](https://atlassian.design/components/primitives/flex/examples)
 * - [Code](https://atlassian.design/components/primitives/flex/code)
 *
 * @example
 * ```tsx
 * import { Flex, Box } from '@atlaskit/primitives'
 *
 * const Component = () => (
 *   <Flex direction="column">
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *   </Flex>
 * )
 * ```
 */ var $b2f14aa3f60e32fd$var$Flex = /*#__PURE__*/ (0, $dAx5m.memo)(/*#__PURE__*/ (0, $dAx5m.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? "div" : _ref$as, role = _ref.role, alignItems = _ref.alignItems, justifyContent = _ref.justifyContent, gap = _ref.gap, columnGap = _ref.columnGap, rowGap = _ref.rowGap, children = _ref.children, testId = _ref.testId, direction = _ref.direction, wrap = _ref.wrap, xcss = _ref.xcss;
    var resolvedStyles = (0, $e54127128664e945$export$a9c84988c8f81f2d)(xcss);
    return (0, $jVTBW.jsx)(Component, {
        role: role,
        className: resolvedStyles.static,
        css: [
            $b2f14aa3f60e32fd$var$baseStyles,
            gap && (0, $84ed774427a93b60$export$bf46c3f9eeafc71f).gap[gap],
            columnGap && (0, $84ed774427a93b60$export$bf46c3f9eeafc71f).columnGap[columnGap],
            rowGap && (0, $84ed774427a93b60$export$bf46c3f9eeafc71f).rowGap[rowGap],
            alignItems && $b2f14aa3f60e32fd$var$alignItemsMap[alignItems],
            direction && $b2f14aa3f60e32fd$var$flexDirectionMap[direction],
            justifyContent && $b2f14aa3f60e32fd$var$justifyContentMap[justifyContent],
            wrap && $b2f14aa3f60e32fd$var$flexWrapMap[wrap],
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
            resolvedStyles.emotion
        ],
        "data-testid": testId,
        ref: ref
    }, children);
}));
$b2f14aa3f60e32fd$var$Flex.displayName = "Flex";
var $b2f14aa3f60e32fd$export$2e2bcd8739ae039 = $b2f14aa3f60e32fd$var$Flex;


var $6e025698fb99d187$var$flexGrowMap = {
    hug: (0, $e54127128664e945$export$f6c783d06584602c)({
        flexGrow: 0
    }),
    fill: (0, $e54127128664e945$export$f6c783d06584602c)({
        width: "100%",
        flexGrow: 1
    })
};
var $6e025698fb99d187$var$separatorStyles = (0, $jVTBW.css)({
    color: "var(--ds-text-subtle, #42526E)",
    marginBlock: "var(--ds-space-0, 0px)",
    marginInline: "var(--ds-space-negative-025, -2px)",
    pointerEvents: "none",
    userSelect: "none"
});
var $6e025698fb99d187$var$Separator = function Separator(_ref) {
    var children = _ref.children;
    return (0, $jVTBW.jsx)("span", {
        css: $6e025698fb99d187$var$separatorStyles
    }, children);
};
/**
 * __Inline__
 *
 * Inline is a primitive component based on CSS Flexbox that manages the horizontal layout of direct children.
 *
 * @example
 * ```tsx
 *  <Inline>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *  </Inline>
 * ```
 *
 */ var $6e025698fb99d187$var$Inline = /*#__PURE__*/ (0, $dAx5m.memo)(/*#__PURE__*/ (0, $dAx5m.forwardRef)(function(_ref2, ref) {
    var as = _ref2.as, alignInline = _ref2.alignInline, _ref2$alignBlock = _ref2.alignBlock, alignItems = _ref2$alignBlock === void 0 ? "start" : _ref2$alignBlock, _ref2$shouldWrap = _ref2.shouldWrap, shouldWrap = _ref2$shouldWrap === void 0 ? false : _ref2$shouldWrap, spread = _ref2.spread, grow = _ref2.grow, space = _ref2.space, rowSpace = _ref2.rowSpace, separator = _ref2.separator, xcss = _ref2.xcss, testId = _ref2.testId, role = _ref2.role, rawChildren = _ref2.children;
    var separatorComponent = typeof separator === "string" ? (0, $jVTBW.jsx)($6e025698fb99d187$var$Separator, null, separator) : separator;
    var children = separatorComponent ? (0, $dAx5m.Children).toArray(rawChildren).filter(Boolean).map(function(child, index) {
        return (0, $jVTBW.jsx)((0, $dAx5m.Fragment), {
            key: index
        }, separator && index > 0 ? separatorComponent : null, child);
    }) : rawChildren;
    var justifyContent = spread || alignInline;
    // We're type coercing this as Compiled styles in an array isn't supported by the types
    // But the runtime accepts it none-the-wiser. We can remove this entire block and replace
    // it with cx(defaultStyles, focusRingStyles, xcssStyles) when we've moved away from Emotion.
    var styles = grow ? [
        $6e025698fb99d187$var$flexGrowMap[grow]
    ].concat((0, (/*@__PURE__*/$parcel$interopDefault($2087e80a80355736$exports)))(Array.isArray(xcss) ? xcss : [
        xcss
    ])) : xcss;
    return (0, $jVTBW.jsx)((0, $b2f14aa3f60e32fd$export$2e2bcd8739ae039), {
        as: as,
        role: role,
        alignItems: alignItems,
        justifyContent: justifyContent,
        direction: "row",
        gap: space,
        rowGap: rowSpace,
        wrap: shouldWrap ? "wrap" : undefined,
        xcss: styles,
        testId: testId,
        ref: ref
    }, children);
}));
$6e025698fb99d187$var$Inline.displayName = "Inline";
var $6e025698fb99d187$export$2e2bcd8739ae039 = $6e025698fb99d187$var$Inline;



var $dAx5m = parcelRequire("dAx5m");

var $jVTBW = parcelRequire("jVTBW");


var $64b70e9dc33fefe6$var$flexGrowMap = {
    hug: (0, $e54127128664e945$export$f6c783d06584602c)({
        flexGrow: 0
    }),
    fill: (0, $e54127128664e945$export$f6c783d06584602c)({
        width: "100%",
        flexGrow: 1
    })
};
/**
 * __Stack__
 *
 * Stack is a primitive component based on flexbox that manages the block layout of direct children.
 *
 * @example
 * ```tsx
 *  <Stack>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *  </Stack>
 * ```
 *
 */ var $64b70e9dc33fefe6$var$Stack = /*#__PURE__*/ (0, $dAx5m.memo)(/*#__PURE__*/ (0, $dAx5m.forwardRef)(function(_ref, ref) {
    var as = _ref.as, alignItems = _ref.alignInline, _ref$alignBlock = _ref.alignBlock, alignBlock = _ref$alignBlock === void 0 ? "stretch" : _ref$alignBlock, spread = _ref.spread, grow = _ref.grow, space = _ref.space, children = _ref.children, testId = _ref.testId, xcss = _ref.xcss, role = _ref.role;
    var justifyContent = spread || alignBlock;
    // We're type coercing this as Compiled styles in an array isn't supported by the types
    // But the runtime accepts it none-the-wiser. We can remove this entire block and replace
    // it with cx(defaultStyles, focusRingStyles, xcssStyles) when we've moved away from Emotion.
    var styles = grow ? [
        $64b70e9dc33fefe6$var$flexGrowMap[grow]
    ].concat((0, (/*@__PURE__*/$parcel$interopDefault($2087e80a80355736$exports)))(Array.isArray(xcss) ? xcss : [
        xcss
    ])) : xcss;
    return (0, $jVTBW.jsx)((0, $b2f14aa3f60e32fd$export$2e2bcd8739ae039), {
        as: as,
        role: role,
        gap: space,
        direction: "column",
        alignItems: alignItems,
        justifyContent: justifyContent,
        xcss: styles,
        testId: testId,
        ref: ref
    }, children);
}));
$64b70e9dc33fefe6$var$Stack.displayName = "Stack";
var $64b70e9dc33fefe6$export$2e2bcd8739ae039 = $64b70e9dc33fefe6$var$Stack;

/** @jsx jsx */ 
var $dAx5m = parcelRequire("dAx5m");

var $jVTBW = parcelRequire("jVTBW");

var $3P18c = parcelRequire("3P18c");


var $d0445bd79201244a$var$asAllowlist = [
    "span",
    "p",
    "strong",
    "em"
];
// We're doing this because our CSS reset can add top margins to elements such as `p` which is totally insane.
// Long term we should remove those instances from the reset - it should be a reset to 0.
// For now, at least we know <Text> will be unaffected by this.
var $d0445bd79201244a$var$resetStyles = (0, $jVTBW.css)({
    margin: 0
});
var $d0445bd79201244a$var$strongStyles = (0, $jVTBW.css)({
    fontWeight: "bold"
});
var $d0445bd79201244a$var$emStyles = (0, $jVTBW.css)({
    fontStyle: "italic"
});
var $d0445bd79201244a$var$textAlignMap = {
    center: (0, $jVTBW.css)({
        textAlign: "center"
    }),
    end: (0, $jVTBW.css)({
        textAlign: "end"
    }),
    start: (0, $jVTBW.css)({
        textAlign: "start"
    })
};
var $d0445bd79201244a$var$truncationStyles = (0, $jVTBW.css)({
    display: "-webkit-box",
    overflow: "hidden",
    WebkitBoxOrient: "vertical"
});
var $d0445bd79201244a$var$wordBreakMap = {
    breakAll: (0, $jVTBW.css)({
        wordBreak: "break-all"
    })
};
var $d0445bd79201244a$var$HasTextAncestorContext = /*#__PURE__*/ (0, $dAx5m.createContext)(false);
var $d0445bd79201244a$var$useHasTextAncestor = function useHasTextAncestor() {
    return (0, $dAx5m.useContext)($d0445bd79201244a$var$HasTextAncestorContext);
};
/**
 * Custom hook designed to abstract the parsing of the color props and make it clearer in the future how color is reconciled between themes and tokens.
 */ var $d0445bd79201244a$var$useColor = function useColor(colorProp, hasTextAncestor) {
    var surface = (0, $e7a68fb03404bc50$export$1aeb4f6b93c4540d)();
    /**
   * Where the color of the surface is inverted we always override the color
   * as there is no valid choice that is not covered by the override.
   */ if ((0, $84ed774427a93b60$export$2185ce37f9bdd963).hasOwnProperty(surface)) return (0, $84ed774427a93b60$export$2185ce37f9bdd963)[surface];
    if (colorProp === "inherit") return undefined;
    if (!colorProp && hasTextAncestor) return undefined;
    return colorProp || "color.text";
};
/**
 * __Text__
 *
 * Text is a primitive component that has the Atlassian Design System's design guidelines baked in.
 * This includes considerations for text attributes such as color, font size, font weight, and line height.
 * It renders a `span` by default.
 *
 * @internal
 */ var $d0445bd79201244a$var$Text = /*#__PURE__*/ (0, $dAx5m.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? "span" : _ref$as, colorProp = _ref.color, align = _ref.align, testId = _ref.testId, id = _ref.id, _ref$size = _ref.size, size = _ref$size === void 0 ? "medium" : _ref$size, weight = _ref.weight, maxLines = _ref.maxLines, children = _ref.children;
    (0, $3P18c.default)($d0445bd79201244a$var$asAllowlist.includes(Component), '@atlaskit/primitives: Text received an invalid "as" value of "'.concat(Component, '"'));
    var hasTextAncestor = $d0445bd79201244a$var$useHasTextAncestor();
    var color = $d0445bd79201244a$var$useColor(colorProp, hasTextAncestor);
    var component = (0, $jVTBW.jsx)(Component, {
        ref: ref,
        css: [
            $d0445bd79201244a$var$resetStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $84ed774427a93b60$export$128f10c238242f83)[size],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            color && (0, $84ed774427a93b60$export$3a1bcba60b23d7f0)[color],
            maxLines && $d0445bd79201244a$var$truncationStyles,
            maxLines === 1 && $d0445bd79201244a$var$wordBreakMap.breakAll,
            align && $d0445bd79201244a$var$textAlignMap[align],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            weight && (0, $84ed774427a93b60$export$45f3f4fe16f9f7d5)[weight],
            Component === "em" && $d0445bd79201244a$var$emStyles,
            Component === "strong" && $d0445bd79201244a$var$strongStyles
        ],
        style: {
            WebkitLineClamp: maxLines
        },
        "data-testid": testId,
        id: id
    }, children);
    return hasTextAncestor ? // no need to re-apply context if the text is already wrapped
    component : (0, $jVTBW.jsx)($d0445bd79201244a$var$HasTextAncestorContext.Provider, {
        value: true
    }, component);
});
var $d0445bd79201244a$export$2e2bcd8739ae039 = $d0445bd79201244a$var$Text;




var $Bb0he = parcelRequire("Bb0he");
var $df3e57924e92b86f$export$d6830277b06edd6 = "normal";
var $df3e57924e92b86f$export$4f8f13a66ae77bdd = "--color";
var $df3e57924e92b86f$export$e9244ec13bd422b5 = "--bg-color";
var $df3e57924e92b86f$export$97e78d9745006c11 = "--bg-color-hover";
var $df3e57924e92b86f$export$291d63757828f290 = "--bg-color-active";


/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ 
var $79243b2679dffa0d$export$59e42969c95d314 = {
    error: "color.background.danger.bold",
    info: "color.background.neutral.bold",
    normal: "elevation.surface.overlay",
    success: "color.background.success.bold",
    warning: "color.background.warning.bold"
};
var $79243b2679dffa0d$export$7f70afe2167f8235 = {
    error: "var(--ds-icon-inverse, ".concat((0, $96af0d22e233ee32$export$29a4f05edc054374), ")"),
    info: "var(--ds-icon-inverse, ".concat((0, $96af0d22e233ee32$export$29a4f05edc054374), ")"),
    normal: "var(--ds-icon-subtle, ".concat((0, $96af0d22e233ee32$export$c39c0fe0f26207ae), ")"),
    success: "var(--ds-icon-inverse, ".concat((0, $96af0d22e233ee32$export$29a4f05edc054374), ")"),
    warning: "var(--ds-icon-warning-inverse, ".concat((0, $96af0d22e233ee32$export$ad0bacf983b7ddaa), ")")
};
var $79243b2679dffa0d$export$f50075b2584087f = {
    error: "color.text.inverse",
    info: "color.text.inverse",
    normal: "color.text.subtle",
    success: "color.text.inverse",
    warning: "color.text.warning.inverse"
};
var $79243b2679dffa0d$export$13b42cd9d596bfe0 = {
    error: "var(--ds-text-inverse, ".concat((0, $96af0d22e233ee32$export$29a4f05edc054374), ")"),
    info: "var(--ds-text-inverse, ".concat((0, $96af0d22e233ee32$export$29a4f05edc054374), ")"),
    normal: "var(--ds-text-subtle, ".concat((0, $96af0d22e233ee32$export$c39c0fe0f26207ae), ")"),
    success: "var(--ds-text-inverse, ".concat((0, $96af0d22e233ee32$export$29a4f05edc054374), ")"),
    warning: "var(--ds-text-warning-inverse, ".concat((0, $96af0d22e233ee32$export$ad0bacf983b7ddaa), ")")
};
var $79243b2679dffa0d$export$81ba6b63eedb299f = {
    success: {
        default: "var(--ds-background-inverse-subtle, ".concat((0, $96af0d22e233ee32$export$920c0d5c49070351), ")"),
        active: "var(--ds-background-inverse-subtle-pressed, ".concat((0, $96af0d22e233ee32$export$920c0d5c49070351), ")"),
        pressed: "var(--ds-background-inverse-subtle-hovered, ".concat((0, $96af0d22e233ee32$export$920c0d5c49070351), ")")
    },
    info: {
        default: "var(--ds-background-inverse-subtle, ".concat((0, $96af0d22e233ee32$export$920c0d5c49070351), ")"),
        active: "var(--ds-background-inverse-subtle-pressed, ".concat((0, $96af0d22e233ee32$export$920c0d5c49070351), ")"),
        pressed: "var(--ds-background-inverse-subtle-hovered, ".concat((0, $96af0d22e233ee32$export$920c0d5c49070351), ")")
    },
    error: {
        default: "var(--ds-background-inverse-subtle, ".concat((0, $96af0d22e233ee32$export$920c0d5c49070351), ")"),
        active: "var(--ds-background-inverse-subtle-pressed, ".concat((0, $96af0d22e233ee32$export$920c0d5c49070351), ")"),
        pressed: "var(--ds-background-inverse-subtle-hovered, ".concat((0, $96af0d22e233ee32$export$920c0d5c49070351), ")")
    },
    warning: {
        default: "var(--ds-background-inverse-subtle, ".concat((0, $96af0d22e233ee32$export$920c0d5c49070351), ")"),
        active: "var(--ds-background-inverse-subtle-pressed, ".concat((0, $96af0d22e233ee32$export$920c0d5c49070351), ")"),
        pressed: "var(--ds-background-inverse-subtle-hovered, ".concat((0, $96af0d22e233ee32$export$920c0d5c49070351), ")")
    },
    normal: {
        default: "none",
        active: "none",
        pressed: "none"
    }
};
var $79243b2679dffa0d$export$7bcfe3cca4dd78b6 = {
    success: "var(--ds-text-inverse, ".concat((0, $96af0d22e233ee32$export$29a4f05edc054374), ")"),
    info: "var(--ds-text-inverse, ".concat((0, $96af0d22e233ee32$export$29a4f05edc054374), ")"),
    error: "var(--ds-text-inverse, ".concat((0, $96af0d22e233ee32$export$29a4f05edc054374), ")"),
    warning: "var(--ds-text-warning-inverse, ".concat((0, $96af0d22e233ee32$export$ad0bacf983b7ddaa), ")"),
    normal: "var(--ds-link, ".concat((0, $96af0d22e233ee32$export$b3de0ae08da2ce64), ")")
};




var $jVTBW = parcelRequire("jVTBW");





var $dAx5m = parcelRequire("dAx5m");


var $dAx5m = parcelRequire("dAx5m");
var $97420dade8819a74$var$_excluded = [
    "children"
];
function $97420dade8819a74$export$25d302a5b900a763(defaultGetTokens) {
    var emptyThemeFn = function emptyThemeFn(getTokens, props) {
        return getTokens(props);
    };
    /**
   * Internally, Theme uses React Context, with internal providers and consumers.
   * The React Context passes only a function that gets props, and turns them into tokens. This
   * function gets mixed as more Providers with their own themes are added. This mixed function
   * is ultimately picked up by Consumers, which implement a context consumer internally to fetch
   * the theme.
   */ var ThemeContext = /*#__PURE__*/ (0, $dAx5m.createContext)(defaultGetTokens);
    function useTheme(themeProps) {
        var theme = (0, $dAx5m.useContext)(ThemeContext);
        var themeFn = theme || emptyThemeFn;
        var tokens = themeFn(themeProps);
        return tokens;
    }
    // The Theme Consumer takes a function as its child - this function takes tokens, and the
    // return value is generally a set of nodes with the tokens applied appropriately.
    function Consumer(props) {
        var children = props.children, themeProps = (0, (/*@__PURE__*/$parcel$interopDefault($e0a9c9aa3fdb10fc$exports)))(props, $97420dade8819a74$var$_excluded);
        // @ts-ignore See issue for more info: https://github.com/Microsoft/TypeScript/issues/10727
        // Argument of type 'Pick<ThemeProps & { children: (tokens: ThemeTokens) => ReactNode; }, Exclude<keyof ThemeProps, "children">>' is not assignable to parameter of type 'ThemeProps'.ts(2345)
        var tokens = useTheme(themeProps);
        // We add a fragment to ensure we don't break people upgrading.
        // Previously they may have been able to pass in undefined without things blowing up.
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).Fragment, null, children(tokens));
    }
    /**
   * The Theme Provider takes regular nodes as its children, but also takes a *theme function*
   * - The theme function takes a set of props, as well as a function (getTokens) that can turn props into tokens.
   * - The getTokens function isn't called immediately - instead the props are passed
   *    through a mix of parent theming functions
   * Children of this provider will receive this mixed theme
   */ function Provider(props) {
        var themeFn = (0, $dAx5m.useContext)(ThemeContext);
        var valueFn = props.value || emptyThemeFn;
        var mixedFn = (0, $dAx5m.useCallback)(function(themeProps) {
            return valueFn(themeFn, themeProps);
        }, [
            themeFn,
            valueFn
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement(ThemeContext.Provider, {
            value: mixedFn
        }, props.children);
    }
    return {
        Consumer: Consumer,
        Provider: Provider,
        useTheme: useTheme
    };
}


// Create default global light theme
var $3ba3980154d893b4$var$_createTheme = (0, $97420dade8819a74$export$25d302a5b900a763)(function() {
    return {
        mode: "light"
    };
}), $3ba3980154d893b4$var$Provider = $3ba3980154d893b4$var$_createTheme.Provider, $3ba3980154d893b4$var$Consumer = $3ba3980154d893b4$var$_createTheme.Consumer, $3ba3980154d893b4$export$7692396083754928 = $3ba3980154d893b4$var$_createTheme.useTheme;
var $3ba3980154d893b4$var$Theme = {
    Provider: $3ba3980154d893b4$var$Provider,
    Consumer: $3ba3980154d893b4$var$Consumer
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$3ba3980154d893b4$export$2e2bcd8739ae039 = $3ba3980154d893b4$var$Theme;





var $dAx5m = parcelRequire("dAx5m");

var $jVTBW = parcelRequire("jVTBW");


var $Bb0he = parcelRequire("Bb0he");

var $gMIYi = parcelRequire("gMIYi");

var $iAyBE = parcelRequire("iAyBE");

var $kqsmh = parcelRequire("kqsmh");

function $29a75133aa80766e$var$abort(event) {
    event.preventDefault();
    event.stopPropagation();
}
var $29a75133aa80766e$var$tabKeyCode = 9;
function $29a75133aa80766e$var$onKey(event) {
    // Allowing tab so that a user can move focus away
    if (event.keyCode === $29a75133aa80766e$var$tabKeyCode) return;
    $29a75133aa80766e$var$abort(event);
}
var $29a75133aa80766e$var$block = {
    onMouseDownCapture: $29a75133aa80766e$var$abort,
    onMouseUpCapture: $29a75133aa80766e$var$abort,
    // because we have tabIndex = -1 when disabled,
    // keyboard events can only occur when there is an overlay
    onKeyDownCapture: $29a75133aa80766e$var$onKey,
    onKeyUpCapture: $29a75133aa80766e$var$onKey,
    onTouchStartCapture: $29a75133aa80766e$var$abort,
    onTouchEndCapture: $29a75133aa80766e$var$abort,
    onPointerDownCapture: $29a75133aa80766e$var$abort,
    onPointerUpCapture: $29a75133aa80766e$var$abort,
    onClickCapture: $29a75133aa80766e$var$abort,
    // Just smashing the existing onClick for good measure
    onClick: $29a75133aa80766e$var$abort
};
var $29a75133aa80766e$var$doNotBlock = {};
function $29a75133aa80766e$export$2e2bcd8739ae039(_ref) {
    var isInteractive = _ref.isInteractive;
    return isInteractive ? $29a75133aa80766e$var$doNotBlock : $29a75133aa80766e$var$block;
}




var $jVTBW = parcelRequire("jVTBW");


// Hard coding the active rgba color value rather than using a helper to convert it
// With helper it would be: hex2rgba(colors.B75, 0.6)
var $f2f87f8d74f74518$var$fadedB75 = "rgba(179, 212, 255, 0.6)";
var $f2f87f8d74f74518$var$values = {
    // Default appearance
    background: {
        default: {
            default: {
                light: "var(--ds-background-neutral, ".concat($96af0d22e233ee32$export$8d43898f60b96a82, ")"),
                dark: "var(--ds-background-neutral, ".concat($96af0d22e233ee32$export$d281fbfe3cff2df6, ")")
            },
            hover: {
                light: "var(--ds-background-neutral-hovered, ".concat($96af0d22e233ee32$export$920c0d5c49070351, ")"),
                dark: "var(--ds-background-neutral-hovered, ".concat($96af0d22e233ee32$export$3902c91d8b98a753, ")")
            },
            active: {
                light: "var(--ds-background-neutral-pressed, ".concat($f2f87f8d74f74518$var$fadedB75, ")"),
                dark: "var(--ds-background-neutral-pressed, ".concat($96af0d22e233ee32$export$8c13c2ee36917869, ")")
            },
            disabled: {
                light: "var(--ds-background-disabled, ".concat($96af0d22e233ee32$export$8d43898f60b96a82, ")"),
                dark: "var(--ds-background-disabled, ".concat($96af0d22e233ee32$export$d281fbfe3cff2df6, ")")
            },
            selected: {
                light: "var(--ds-background-selected, ".concat($96af0d22e233ee32$export$ad0bacf983b7ddaa, ")"),
                dark: "var(--ds-background-selected, ".concat($96af0d22e233ee32$export$3d4f271a500072a, ")")
            },
            focusSelected: {
                light: "var(--ds-background-selected, ".concat($96af0d22e233ee32$export$ad0bacf983b7ddaa, ")"),
                dark: "var(--ds-background-selected, ".concat($96af0d22e233ee32$export$3d4f271a500072a, ")")
            }
        },
        primary: {
            default: {
                light: "var(--ds-background-brand-bold, ".concat($96af0d22e233ee32$export$b3de0ae08da2ce64, ")"),
                dark: "var(--ds-background-brand-bold, ".concat($96af0d22e233ee32$export$ecfc1dff386a3e7a, ")")
            },
            hover: {
                light: "var(--ds-background-brand-bold-hovered, ".concat($96af0d22e233ee32$export$e62e8919cca44969, ")"),
                dark: "var(--ds-background-brand-bold-hovered, ".concat($96af0d22e233ee32$export$8c13c2ee36917869, ")")
            },
            active: {
                light: "var(--ds-background-brand-bold-pressed, ".concat($96af0d22e233ee32$export$a6ee3d71bc067634, ")"),
                dark: "var(--ds-background-brand-bold-pressed, ".concat($96af0d22e233ee32$export$215b7063051591f1, ")")
            },
            disabled: {
                light: "var(--ds-background-disabled, ".concat($96af0d22e233ee32$export$8d43898f60b96a82, ")"),
                dark: "var(--ds-background-disabled, ".concat($96af0d22e233ee32$export$d281fbfe3cff2df6, ")")
            },
            selected: {
                light: "var(--ds-background-selected, ".concat($96af0d22e233ee32$export$ad0bacf983b7ddaa, ")"),
                dark: "var(--ds-background-selected, ".concat($96af0d22e233ee32$export$3d4f271a500072a, ")")
            },
            focusSelected: {
                light: "var(--ds-background-selected, ".concat($96af0d22e233ee32$export$ad0bacf983b7ddaa, ")"),
                dark: "var(--ds-background-selected, ".concat($96af0d22e233ee32$export$3d4f271a500072a, ")")
            }
        },
        warning: {
            default: {
                light: "var(--ds-background-warning-bold, ".concat($96af0d22e233ee32$export$c6930421db9fa514, ")"),
                dark: "var(--ds-background-warning-bold, ".concat($96af0d22e233ee32$export$c6930421db9fa514, ")")
            },
            hover: {
                light: "var(--ds-background-warning-bold-hovered, ".concat($96af0d22e233ee32$export$5aae31392d72caaa, ")"),
                dark: "var(--ds-background-warning-bold-hovered, ".concat($96af0d22e233ee32$export$5aae31392d72caaa, ")")
            },
            active: {
                light: "var(--ds-background-warning-bold-pressed, ".concat($96af0d22e233ee32$export$59619663aa6500fb, ")"),
                dark: "var(--ds-background-warning-bold-pressed, ".concat($96af0d22e233ee32$export$59619663aa6500fb, ")")
            },
            disabled: {
                light: "var(--ds-background-disabled, ".concat($96af0d22e233ee32$export$8d43898f60b96a82, ")"),
                dark: "var(--ds-background-disabled, ".concat($96af0d22e233ee32$export$d281fbfe3cff2df6, ")")
            },
            selected: {
                light: "var(--ds-background-selected, ".concat($96af0d22e233ee32$export$59619663aa6500fb, ")"),
                dark: "var(--ds-background-selected, ".concat($96af0d22e233ee32$export$59619663aa6500fb, ")")
            },
            focusSelected: {
                light: "var(--ds-background-selected, ".concat($96af0d22e233ee32$export$59619663aa6500fb, ")"),
                dark: "var(--ds-background-selected, ".concat($96af0d22e233ee32$export$59619663aa6500fb, ")")
            }
        },
        danger: {
            default: {
                light: "var(--ds-background-danger-bold, ".concat($96af0d22e233ee32$export$2010d0fb4295b346, ")"),
                dark: "var(--ds-background-danger-bold, ".concat($96af0d22e233ee32$export$2010d0fb4295b346, ")")
            },
            hover: {
                light: "var(--ds-background-danger-bold-hovered, ".concat($96af0d22e233ee32$export$4a7404f376229999, ")"),
                dark: "var(--ds-background-danger-bold-hovered, ".concat($96af0d22e233ee32$export$4a7404f376229999, ")")
            },
            active: {
                light: "var(--ds-background-danger-bold-pressed, ".concat($96af0d22e233ee32$export$2837b5a1a71d5c02, ")"),
                dark: "var(--ds-background-danger-bold-pressed, ".concat($96af0d22e233ee32$export$2837b5a1a71d5c02, ")")
            },
            disabled: {
                light: "var(--ds-background-disabled, ".concat($96af0d22e233ee32$export$8d43898f60b96a82, ")"),
                dark: "var(--ds-background-disabled, ".concat($96af0d22e233ee32$export$d281fbfe3cff2df6, ")")
            },
            selected: {
                light: "var(--ds-background-selected, ".concat($96af0d22e233ee32$export$2837b5a1a71d5c02, ")"),
                dark: "var(--ds-background-selected, ".concat($96af0d22e233ee32$export$2837b5a1a71d5c02, ")")
            },
            focusSelected: {
                light: "var(--ds-background-selected, ".concat($96af0d22e233ee32$export$2837b5a1a71d5c02, ")"),
                dark: "var(--ds-background-selected, ".concat($96af0d22e233ee32$export$2837b5a1a71d5c02, ")")
            }
        },
        link: {
            default: {
                light: "var(--ds-background-neutral-subtle, none)",
                dark: "var(--ds-background-neutral-subtle, none)"
            },
            selected: {
                light: "var(--ds-background-selected, ".concat($96af0d22e233ee32$export$ad0bacf983b7ddaa, ")"),
                dark: "var(--ds-background-selected, ".concat($96af0d22e233ee32$export$9fdfb749e33cdf97, ")")
            },
            focusSelected: {
                light: "var(--ds-background-selected, ".concat($96af0d22e233ee32$export$ad0bacf983b7ddaa, ")"),
                dark: "var(--ds-background-selected, ".concat($96af0d22e233ee32$export$9fdfb749e33cdf97, ")")
            }
        },
        subtle: {
            default: {
                light: "var(--ds-background-neutral-subtle, none)",
                dark: "var(--ds-background-neutral-subtle, none)"
            },
            hover: {
                light: "var(--ds-background-neutral-subtle-hovered, ".concat($96af0d22e233ee32$export$920c0d5c49070351, ")"),
                dark: "var(--ds-background-neutral-subtle-hovered, ".concat($96af0d22e233ee32$export$3902c91d8b98a753, ")")
            },
            active: {
                light: "var(--ds-background-neutral-subtle-pressed, ".concat($f2f87f8d74f74518$var$fadedB75, ")"),
                dark: "var(--ds-background-neutral-subtle-pressed, ".concat($96af0d22e233ee32$export$8c13c2ee36917869, ")")
            },
            disabled: {
                light: "var(--ds-background-neutral-subtle, none)",
                dark: "var(--ds-background-neutral-subtle, none)"
            },
            selected: {
                light: "var(--ds-background-selected, ".concat($96af0d22e233ee32$export$ad0bacf983b7ddaa, ")"),
                dark: "var(--ds-background-selected, ".concat($96af0d22e233ee32$export$3d4f271a500072a, ")")
            },
            focusSelected: {
                light: "var(--ds-background-selected, ".concat($96af0d22e233ee32$export$ad0bacf983b7ddaa, ")"),
                dark: "var(--ds-background-selected, ".concat($96af0d22e233ee32$export$3d4f271a500072a, ")")
            }
        },
        "subtle-link": {
            default: {
                light: "var(--ds-background-neutral-subtle, none)",
                dark: "var(--ds-background-neutral-subtle, none)"
            },
            selected: {
                light: "var(--ds-background-selected, ".concat($96af0d22e233ee32$export$ad0bacf983b7ddaa, ")"),
                dark: "var(--ds-background-selected, ".concat($96af0d22e233ee32$export$9fdfb749e33cdf97, ")")
            },
            focusSelected: {
                light: "var(--ds-background-selected, ".concat($96af0d22e233ee32$export$ad0bacf983b7ddaa, ")"),
                dark: "var(--ds-background-selected, ".concat($96af0d22e233ee32$export$9fdfb749e33cdf97, ")")
            }
        }
    },
    color: {
        default: {
            default: {
                light: "var(--ds-text, ".concat($96af0d22e233ee32$export$c39c0fe0f26207ae, ")"),
                dark: "var(--ds-text, ".concat($96af0d22e233ee32$export$abcf8c38338b4aa5, ")")
            },
            active: {
                light: "var(--ds-text, ".concat($96af0d22e233ee32$export$b3de0ae08da2ce64, ")"),
                dark: "var(--ds-text, ".concat($96af0d22e233ee32$export$b3de0ae08da2ce64, ")")
            },
            disabled: {
                light: "var(--ds-text-disabled, ".concat($96af0d22e233ee32$export$5f71e19f3a7ad9de, ")"),
                dark: "var(--ds-text-disabled, ".concat($96af0d22e233ee32$export$633847cf062b69e0, ")")
            },
            selected: {
                light: "var(--ds-text-selected, ".concat($96af0d22e233ee32$export$9fdfb749e33cdf97, ")"),
                dark: "var(--ds-text-selected, ".concat($96af0d22e233ee32$export$abcf8c38338b4aa5, ")")
            },
            focusSelected: {
                light: "var(--ds-text-selected, ".concat($96af0d22e233ee32$export$9fdfb749e33cdf97, ")"),
                dark: "var(--ds-text-selected, ".concat($96af0d22e233ee32$export$abcf8c38338b4aa5, ")")
            }
        },
        primary: {
            default: {
                light: "var(--ds-text-inverse, ".concat($96af0d22e233ee32$export$29a4f05edc054374, ")"),
                dark: "var(--ds-text-inverse, ".concat($96af0d22e233ee32$export$633847cf062b69e0, ")")
            },
            disabled: {
                light: "var(--ds-text-disabled, ".concat($96af0d22e233ee32$export$5f71e19f3a7ad9de, ")"),
                dark: "var(--ds-text-disabled, ".concat($96af0d22e233ee32$export$633847cf062b69e0, ")")
            },
            selected: {
                light: "var(--ds-text-selected, ".concat($96af0d22e233ee32$export$9fdfb749e33cdf97, ")"),
                dark: "var(--ds-text-selected, ".concat($96af0d22e233ee32$export$abcf8c38338b4aa5, ")")
            },
            focusSelected: {
                light: "var(--ds-text-selected, ".concat($96af0d22e233ee32$export$9fdfb749e33cdf97, ")"),
                dark: "var(--ds-text-selected, ".concat($96af0d22e233ee32$export$abcf8c38338b4aa5, ")")
            }
        },
        warning: {
            default: {
                light: "var(--ds-text-warning-inverse, ".concat($96af0d22e233ee32$export$7d61b15e0da132af, ")"),
                dark: "var(--ds-text-warning-inverse, ".concat($96af0d22e233ee32$export$7d61b15e0da132af, ")")
            },
            disabled: {
                light: "var(--ds-text-disabled, ".concat($96af0d22e233ee32$export$5f71e19f3a7ad9de, ")"),
                dark: "var(--ds-text-disabled, ".concat($96af0d22e233ee32$export$633847cf062b69e0, ")")
            },
            selected: {
                light: "var(--ds-text-selected, ".concat($96af0d22e233ee32$export$7d61b15e0da132af, ")"),
                dark: "var(--ds-text-selected, ".concat($96af0d22e233ee32$export$7d61b15e0da132af, ")")
            },
            focusSelected: {
                light: "var(--ds-text-selected, ".concat($96af0d22e233ee32$export$7d61b15e0da132af, ")"),
                dark: "var(--ds-text-selected, ".concat($96af0d22e233ee32$export$7d61b15e0da132af, ")")
            }
        },
        danger: {
            default: {
                light: "var(--ds-text-inverse, ".concat($96af0d22e233ee32$export$29a4f05edc054374, ")"),
                dark: "var(--ds-text-inverse, ".concat($96af0d22e233ee32$export$29a4f05edc054374, ")")
            },
            disabled: {
                light: "var(--ds-text-disabled, ".concat($96af0d22e233ee32$export$5f71e19f3a7ad9de, ")"),
                dark: "var(--ds-text-disabled, ".concat($96af0d22e233ee32$export$633847cf062b69e0, ")")
            },
            selected: {
                light: "var(--ds-text-selected, ".concat($96af0d22e233ee32$export$29a4f05edc054374, ")"),
                dark: "var(--ds-text-selected, ".concat($96af0d22e233ee32$export$29a4f05edc054374, ")")
            },
            focusSelected: {
                light: "var(--ds-text-selected, ".concat($96af0d22e233ee32$export$29a4f05edc054374, ")"),
                dark: "var(--ds-text-selected, ".concat($96af0d22e233ee32$export$29a4f05edc054374, ")")
            }
        },
        link: {
            default: {
                light: "var(--ds-link, ".concat($96af0d22e233ee32$export$b3de0ae08da2ce64, ")"),
                dark: "var(--ds-link, ".concat($96af0d22e233ee32$export$ecfc1dff386a3e7a, ")")
            },
            hover: {
                light: "var(--ds-link, ".concat($96af0d22e233ee32$export$e62e8919cca44969, ")"),
                dark: "var(--ds-link, ".concat($96af0d22e233ee32$export$8c13c2ee36917869, ")")
            },
            active: {
                light: "var(--ds-link-pressed, ".concat($96af0d22e233ee32$export$a6ee3d71bc067634, ")"),
                dark: "var(--ds-link-pressed, ".concat($96af0d22e233ee32$export$215b7063051591f1, ")")
            },
            disabled: {
                light: "var(--ds-text-disabled, ".concat($96af0d22e233ee32$export$5f71e19f3a7ad9de, ")"),
                dark: "var(--ds-text-disabled, ".concat($96af0d22e233ee32$export$ee82aa2ea6a1558, ")")
            },
            selected: {
                light: "var(--ds-text-selected, ".concat($96af0d22e233ee32$export$9fdfb749e33cdf97, ")"),
                dark: "var(--ds-text-selected, ".concat($96af0d22e233ee32$export$ad0bacf983b7ddaa, ")")
            },
            focusSelected: {
                light: "var(--ds-text-selected, ".concat($96af0d22e233ee32$export$9fdfb749e33cdf97, ")"),
                dark: "var(--ds-text-selected, ".concat($96af0d22e233ee32$export$ad0bacf983b7ddaa, ")")
            }
        },
        subtle: {
            default: {
                light: "var(--ds-text, ".concat($96af0d22e233ee32$export$c39c0fe0f26207ae, ")"),
                dark: "var(--ds-text, ".concat($96af0d22e233ee32$export$abcf8c38338b4aa5, ")")
            },
            active: {
                light: "var(--ds-text, ".concat($96af0d22e233ee32$export$b3de0ae08da2ce64, ")"),
                dark: "var(--ds-text, ".concat($96af0d22e233ee32$export$b3de0ae08da2ce64, ")")
            },
            disabled: {
                light: "var(--ds-text-disabled, ".concat($96af0d22e233ee32$export$5f71e19f3a7ad9de, ")"),
                dark: "var(--ds-text-disabled, ".concat($96af0d22e233ee32$export$ee82aa2ea6a1558, ")")
            },
            selected: {
                light: "var(--ds-text-selected, ".concat($96af0d22e233ee32$export$9fdfb749e33cdf97, ")"),
                dark: "var(--ds-text-selected, ".concat($96af0d22e233ee32$export$abcf8c38338b4aa5, ")")
            },
            focusSelected: {
                light: "var(--ds-text-selected, ".concat($96af0d22e233ee32$export$9fdfb749e33cdf97, ")"),
                dark: "var(--ds-text-selected, ".concat($96af0d22e233ee32$export$abcf8c38338b4aa5, ")")
            }
        },
        "subtle-link": {
            default: {
                light: "var(--ds-text-subtle, ".concat($96af0d22e233ee32$export$f563ee71e9ee74cd, ")"),
                dark: "var(--ds-text-subtle, ".concat($96af0d22e233ee32$export$abcf8c38338b4aa5, ")")
            },
            hover: {
                light: "var(--ds-text-subtle, ".concat($96af0d22e233ee32$export$7c87d337fb91a97d, ")"),
                dark: "var(--ds-text-subtle, ".concat($96af0d22e233ee32$export$226de0355ed012f8, ")")
            },
            active: {
                light: "var(--ds-text, ".concat($96af0d22e233ee32$export$eece5f492e429f08, ")"),
                dark: "var(--ds-text, ".concat($96af0d22e233ee32$export$97e81faa16a182c7, ")")
            },
            disabled: {
                light: "var(--ds-text-disabled, ".concat($96af0d22e233ee32$export$5f71e19f3a7ad9de, ")"),
                dark: "var(--ds-text-disabled, ".concat($96af0d22e233ee32$export$ee82aa2ea6a1558, ")")
            },
            selected: {
                light: "var(--ds-text-selected, ".concat($96af0d22e233ee32$export$9fdfb749e33cdf97, ")"),
                dark: "var(--ds-text-selected, ".concat($96af0d22e233ee32$export$abcf8c38338b4aa5, ")")
            },
            focusSelected: {
                light: "var(--ds-text-selected, ".concat($96af0d22e233ee32$export$9fdfb749e33cdf97, ")"),
                dark: "var(--ds-text-selected, ".concat($96af0d22e233ee32$export$abcf8c38338b4aa5, ")")
            }
        }
    }
};
var $f2f87f8d74f74518$export$2e2bcd8739ae039 = $f2f87f8d74f74518$var$values;


function $5a6f23a5f9888f6f$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $5a6f23a5f9888f6f$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $5a6f23a5f9888f6f$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($010d27b02d402655$exports)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $5a6f23a5f9888f6f$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $5a6f23a5f9888f6f$var$gridSize = (0, $7ed61b2292e1f49b$export$6d8204c2cb2e06b8)();
// ## Button layout
//
// /------------------------------------------------------------------------------------------------------------------\
// |       →  |  ←      |          |      →  |  ←      |           |      →  |  ←      |         |      →  |  ←       |
// |  10px →  |  ← 2px  |   icon   |  2px →  |  ← 2px  |           |  2px →  |  ← 2px  |  icon   |  2px →  |  ← 10px  |
// |  padding |  margin |  before  |  margin |  margin |  content  |  margin |  margin |  after  |  margin |  padding |
// |    (12px total)    |          |    (4px total)    |           |    (4px total)    |         |    (12px total)    |
// |       →  |  ←      |          |      →  |  ←      |           |      →  |  ←      |         |      →  |  ←       |
// \------------------------------------------------------------------------------------------------------------------/
//                                           ↑                               ↑
//                                        Margins don't collapse with inline-flex
//
var $5a6f23a5f9888f6f$var$heights = {
    default: "".concat(32 / 14, "em"),
    // 32px
    compact: "".concat(24 / 14, "em"),
    none: "auto"
};
var $5a6f23a5f9888f6f$var$lineHeights = {
    default: $5a6f23a5f9888f6f$var$heights.default,
    compact: $5a6f23a5f9888f6f$var$heights.compact,
    none: "inherit"
};
var $5a6f23a5f9888f6f$var$padding = {
    // 10px gutter
    default: "0 ".concat($5a6f23a5f9888f6f$var$gridSize + $5a6f23a5f9888f6f$var$gridSize / 4, "px"),
    compact: "0 ".concat($5a6f23a5f9888f6f$var$gridSize + $5a6f23a5f9888f6f$var$gridSize / 4, "px"),
    none: "0"
};
var $5a6f23a5f9888f6f$var$singleIconPadding = {
    // 2px gutter
    compact: "0 ".concat($5a6f23a5f9888f6f$var$gridSize / 4, "px"),
    default: "0 ".concat($5a6f23a5f9888f6f$var$gridSize / 4, "px"),
    none: "0"
};
var $5a6f23a5f9888f6f$var$verticalAlign = {
    default: "middle",
    compact: "middle",
    none: "baseline"
};
var $5a6f23a5f9888f6f$var$innerMargin = {
    content: "0 ".concat($5a6f23a5f9888f6f$var$gridSize / 4, "px"),
    icon: "0 ".concat($5a6f23a5f9888f6f$var$gridSize / 4, "px")
};
function $5a6f23a5f9888f6f$var$getColor(_ref) {
    var group = _ref.group, key = _ref.key, mode = _ref.mode;
    var rule = group[key] || group.default;
    return rule[mode];
}
function $5a6f23a5f9888f6f$var$getColors(_ref2) {
    var appearance = _ref2.appearance, key = _ref2.key, mode = _ref2.mode;
    return {
        background: $5a6f23a5f9888f6f$var$getColor({
            group: (0, $f2f87f8d74f74518$export$2e2bcd8739ae039).background[appearance],
            key: key,
            mode: mode
        }),
        // Needing to add !important to overcome specificity issue caused by deprecated AtlaskitThemeProvider
        color: "".concat($5a6f23a5f9888f6f$var$getColor({
            group: (0, $f2f87f8d74f74518$export$2e2bcd8739ae039).color[appearance],
            key: key,
            mode: mode
        }), " !important")
    };
}
function $5a6f23a5f9888f6f$export$955358618f994a11(_ref3) {
    var appearance = _ref3.appearance, spacing = _ref3.spacing, mode = _ref3.mode, isSelected = _ref3.isSelected, shouldFitContainer = _ref3.shouldFitContainer, isOnlySingleIcon = _ref3.isOnlySingleIcon;
    var baseColors = $5a6f23a5f9888f6f$var$getColors({
        appearance: appearance,
        key: isSelected ? "selected" : "default",
        mode: mode
    });
    return $5a6f23a5f9888f6f$var$_objectSpread($5a6f23a5f9888f6f$var$_objectSpread({
        // 0px margin added to css-reset
        alignItems: "baseline",
        borderWidth: 0,
        borderRadius: "var(--ds-border-radius, 3px)",
        boxSizing: "border-box",
        display: "inline-flex",
        fontSize: "inherit",
        fontStyle: "normal",
        // Chrome recently changed button so that they use 'arial' as the font family
        fontFamily: "inherit",
        fontWeight: 500,
        // margin for button has been applied to css reset
        maxWidth: "100%",
        // Needed to position overlay
        position: "relative",
        textAlign: "center",
        textDecoration: "none",
        transition: "background 0.1s ease-out, box-shadow 0.15s cubic-bezier(0.47, 0.03, 0.49, 1.38)",
        whiteSpace: "nowrap"
    }, baseColors), {}, {
        cursor: "pointer",
        height: $5a6f23a5f9888f6f$var$heights[spacing],
        lineHeight: $5a6f23a5f9888f6f$var$lineHeights[spacing],
        padding: isOnlySingleIcon ? $5a6f23a5f9888f6f$var$singleIconPadding[spacing] : $5a6f23a5f9888f6f$var$padding[spacing],
        verticalAlign: $5a6f23a5f9888f6f$var$verticalAlign[spacing],
        width: shouldFitContainer ? "100%" : "auto",
        // justifyContent required for shouldFitContainer buttons with an icon inside
        justifyContent: "center",
        // Note: we cannot disable pointer events when there is an overlay.
        // That would be easy for styling, but it would start letting events through on disabled buttons
        // Disabling visited styles (just using the base colors)
        "&:visited": $5a6f23a5f9888f6f$var$_objectSpread({}, baseColors),
        "&:hover": $5a6f23a5f9888f6f$var$_objectSpread($5a6f23a5f9888f6f$var$_objectSpread({}, $5a6f23a5f9888f6f$var$getColors({
            appearance: appearance,
            key: isSelected ? "selected" : "hover",
            mode: mode
        })), {}, {
            textDecoration: !isSelected && (appearance === "link" || appearance === "subtle-link") ? "underline" : "inherit",
            // background, box-shadow
            transitionDuration: "0s, 0.15s"
        }),
        // giving active styles preference by listing them after focus
        "&:active": $5a6f23a5f9888f6f$var$_objectSpread($5a6f23a5f9888f6f$var$_objectSpread({}, $5a6f23a5f9888f6f$var$getColors({
            appearance: appearance,
            key: isSelected ? "selected" : "active",
            mode: mode
        })), {}, {
            // background, box-shadow
            transitionDuration: "0s, 0s"
        }),
        // preventDefault prevents regular active styles from applying in Firefox
        '&[data-firefox-is-active="true"]': $5a6f23a5f9888f6f$var$_objectSpread($5a6f23a5f9888f6f$var$_objectSpread({}, $5a6f23a5f9888f6f$var$getColors({
            appearance: appearance,
            key: isSelected ? "selected" : "active",
            mode: mode
        })), {}, {
            // background, box-shadow
            transitionDuration: "0s, 0s"
        }),
        // Giving disabled styles preference over active by listing them after.
        // Not using '&:disabled' because :disabled is not a valid state for all element types
        // so we are targeting the attribute
        // Attributes have the same specificity a pseudo classes so we are overriding :disabled here
        "&[disabled]": $5a6f23a5f9888f6f$var$_objectSpread($5a6f23a5f9888f6f$var$_objectSpread({}, $5a6f23a5f9888f6f$var$getColors({
            appearance: appearance,
            key: "disabled",
            mode: mode
        })), {}, {
            cursor: "not-allowed",
            textDecoration: "none"
        }),
        '&[data-has-overlay="true"]': {
            cursor: "default",
            textDecoration: "none"
        },
        // disabling hover and active color changes when there is an overlay, but the button is not disabled
        '&[data-has-overlay="true"]:not([disabled]):hover, &[data-has-overlay="true"]:not([disabled]):active': $5a6f23a5f9888f6f$var$_objectSpread({}, $5a6f23a5f9888f6f$var$getColors({
            appearance: appearance,
            key: isSelected ? "selected" : "default",
            mode: mode
        })),
        "&::-moz-focus-inner": {
            border: 0,
            margin: 0,
            padding: 0
        }
    });
}
function $5a6f23a5f9888f6f$export$864eea3f4ec3368f(_ref4) {
    var spacing = _ref4.spacing;
    return (0, $jVTBW.css)({
        display: "flex",
        // icon size cannot grow and shrink
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        margin: spacing === "none" ? 0 : $5a6f23a5f9888f6f$var$innerMargin.icon,
        flexGrow: 0,
        flexShrink: 0,
        alignSelf: "center",
        fontSize: 0,
        lineHeight: 0,
        userSelect: "none"
    });
}
function $5a6f23a5f9888f6f$export$7ad0316cc0dd65a(_ref5) {
    var spacing = _ref5.spacing;
    return (0, $jVTBW.css)({
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        margin: spacing === "none" ? 0 : $5a6f23a5f9888f6f$var$innerMargin.content,
        // content can grow and shrink
        flexGrow: 1,
        flexShrink: 1,
        // ellipsis for overflow text
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap"
    });
}
function $5a6f23a5f9888f6f$export$1b5827d324e945b1(_ref6) {
    var hasOverlay = _ref6.hasOverlay;
    return (0, $jVTBW.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        opacity: hasOverlay ? 0 : 1,
        transition: "opacity 0.3s"
    });
}
var $5a6f23a5f9888f6f$export$1a9fe1b84c876bb5 = {
    // stretching to full width / height of button
    // this is important as we need it to still block
    // event if clicking in the button's own padding
    position: "absolute",
    left: 0,
    top: 0,
    right: 0,
    bottom: 0,
    // Putting all children in the center
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
};



var $dAx5m = parcelRequire("dAx5m");

var $ez4n6 = parcelRequire("ez4n6");
var $eb8314806c2ef62d$export$20bbd2efb0d734c4 = function getIfVisuallyHiddenChildren(children) {
    return children && /*#__PURE__*/ (0, $dAx5m.isValidElement)(children) && children.type === (0, $ez4n6.default);
};


var $3d328d60195e26b2$var$_excluded = [
    "analyticsContext",
    "appearance",
    "autoFocus",
    "buttonCss",
    "children",
    "className",
    "href",
    "component",
    "iconAfter",
    "iconBefore",
    "interactionName",
    "isDisabled",
    "isSelected",
    "onBlur",
    "onClick",
    "onFocus",
    "onMouseDown",
    "overlay",
    "shouldFitContainer",
    "spacing",
    "tabIndex",
    "type",
    "testId"
];
// Disabled buttons will still publish events for nested elements in webkit.
// We are disabling pointer events on child elements so that
// the button will always be the target of events
// Note: firefox does not have this behaviour for child elements
var $3d328d60195e26b2$var$noPointerEventsOnChildrenCss = {
    "> *": {
        pointerEvents: "none"
    }
};
/**
 * These CSS variables consumed by the new icons, to allow them to have appropriate
 * padding inside Button while also maintaining spacing for the existing icons.
 *
 * These styles can be removed once the new icons are fully rolled out, feature flag
 * platform.design-system-team.enable-new-icons is cleaned up,
 * and we bump Button to set padding based on the new icons.
 */ var $3d328d60195e26b2$var$iconBeforeSpacingFixStyle = (0, $jVTBW.css)({
    "--ds--button--new-icon-padding-end": "var(--ds-space-025, 2px)",
    "--ds--button--new-icon-padding-start": "var(--ds-space-050, 4px)",
    marginInlineStart: "var(--ds-space-negative-025, -2px)"
});
var $3d328d60195e26b2$var$iconAfterSpacingFixStyle = (0, $jVTBW.css)({
    "--ds--button--new-icon-padding-end": "var(--ds-space-050, 4px)",
    "--ds--button--new-icon-padding-start": "var(--ds-space-025, 2px)",
    marginInlineEnd: "var(--ds-space-negative-025, -2px)"
});
var $3d328d60195e26b2$var$getSpacingFix = function getSpacingFix(children, spacingStyles) {
    if (!children || (0, $eb8314806c2ef62d$export$20bbd2efb0d734c4)(children)) return null;
    return spacingStyles;
};
var $3d328d60195e26b2$var$getChildren = function getChildren(children, childrenStyles) {
    if ((0, $eb8314806c2ef62d$export$20bbd2efb0d734c4)(children)) return children;
    return children ? (0, $jVTBW.jsx)("span", {
        css: childrenStyles
    }, children) : null;
};
var $3d328d60195e26b2$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).forwardRef(function ButtonBase(props, ref) {
    var analyticsContext = props.analyticsContext, _props$appearance = props.appearance, appearance = _props$appearance === void 0 ? "default" : _props$appearance, _props$autoFocus = props.autoFocus, autoFocus = _props$autoFocus === void 0 ? false : _props$autoFocus, buttonCss = props.buttonCss, children = props.children, className = props.className, href = props.href, _props$component = props.component, Component = _props$component === void 0 ? href ? "a" : "button" : _props$component, iconAfter = props.iconAfter, iconBefore = props.iconBefore, interactionName = props.interactionName, _props$isDisabled = props.isDisabled, isDisabled = _props$isDisabled === void 0 ? false : _props$isDisabled, _props$isSelected = props.isSelected, isSelected = _props$isSelected === void 0 ? false : _props$isSelected, onBlur = props.onBlur, _props$onClick = props.onClick, providedOnClick = _props$onClick === void 0 ? (0, $Bb0he.default) : _props$onClick, onFocus = props.onFocus, _props$onMouseDown = props.onMouseDown, providedOnMouseDown = _props$onMouseDown === void 0 ? (0, $Bb0he.default) : _props$onMouseDown, overlay = props.overlay, shouldFitContainer = props.shouldFitContainer, _props$spacing = props.spacing, spacing = _props$spacing === void 0 ? "default" : _props$spacing, _props$tabIndex = props.tabIndex, tabIndex = _props$tabIndex === void 0 ? 0 : _props$tabIndex, _props$type = props.type, type = _props$type === void 0 ? !href ? "button" : undefined : _props$type, testId = props.testId, rest = (0, (/*@__PURE__*/$parcel$interopDefault($e0a9c9aa3fdb10fc$exports)))(props, $3d328d60195e26b2$var$_excluded);
    var ourRef = (0, $dAx5m.useRef)();
    var setRef = (0, $dAx5m.useCallback)(function(node) {
        ourRef.current = node;
        if (ref == null) return;
        if (typeof ref === "function") {
            ref(node);
            return;
        }
        // We can write to ref's `current` property, but Typescript does not like it.
        // @ts-ignore
        ref.current = node;
    }, [
        ourRef,
        ref
    ]);
    // Cross browser auto focusing is pretty broken, so we are doing it ourselves
    (0, $gMIYi.default)(ourRef, autoFocus);
    var interactionContext = (0, $dAx5m.useContext)((0, $kqsmh.default));
    var handleClick = (0, $dAx5m.useCallback)(function(e, analyticsEvent) {
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    var onClick = (0, $d0cbd00f83880f1b$export$a4687b0234b40e28)({
        fn: handleClick,
        action: "clicked",
        componentName: "button",
        packageName: "@atlaskit/button",
        packageVersion: "17.23.0",
        analyticsData: analyticsContext
    });
    // Button currently calls preventDefault, which is not standard button behaviour
    var onMouseDown = (0, $dAx5m.useCallback)(function(event) {
        event.preventDefault();
        providedOnMouseDown(event);
    }, [
        providedOnMouseDown
    ]);
    // Lose focus when becoming disabled (standard button behaviour)
    (0, $dAx5m.useEffect)(function() {
        var el = ourRef.current;
        if (isDisabled && el && el === document.activeElement) el.blur();
    }, [
        isDisabled
    ]);
    // we are 'disabling' input with a button when there is an overlay
    var hasOverlay = Boolean(overlay);
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    var fadeStyles = (0, $jVTBW.css)((0, $5a6f23a5f9888f6f$export$1b5827d324e945b1)({
        hasOverlay: hasOverlay
    }));
    var isInteractive = !isDisabled && !hasOverlay;
    /**
   * HACK: Spinner needs to have different colours in the "new" tokens design compared to the old design.
   * For now, while we support both, these styles reach into Spinner when a theme is set, applies the right color.
   * Ticket to remove: https://product-fabric.atlassian.net/browse/DSP-2067.
   */ var spinnerHackCss = {};
    if (isSelected || isDisabled || appearance === "warning") spinnerHackCss = {
        "[data-theme] & circle": {
            stroke: "".concat(isSelected || isDisabled ? "var(--ds-icon-subtle, ".concat((0, $96af0d22e233ee32$export$c39c0fe0f26207ae), ")") : "var(--ds-icon-warning-inverse, ".concat((0, $96af0d22e233ee32$export$c39c0fe0f26207ae), ")"), " !important")
        }
    };
    return (0, $jVTBW.jsx)((0, $iAyBE.default), null, (0, $jVTBW.jsx)(Component, (0, (/*@__PURE__*/$parcel$interopDefault($00d53520b6c62aef$exports)))({}, rest, {
        ref: setRef,
        className: className,
        css: [
            buttonCss,
            isInteractive ? null : $3d328d60195e26b2$var$noPointerEventsOnChildrenCss
        ],
        "data-has-overlay": hasOverlay ? true : undefined,
        "data-testid": testId,
        disabled: isDisabled,
        href: isInteractive ? href : undefined,
        onBlur: onBlur,
        onClick: onClick,
        onFocus: onFocus,
        onMouseDown: onMouseDown,
        tabIndex: isDisabled ? -1 : tabIndex,
        type: type
    }, (0, $29a75133aa80766e$export$2e2bcd8739ae039)({
        isInteractive: isInteractive
    })), iconBefore ? (0, $jVTBW.jsx)("span", {
        css: [
            fadeStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $5a6f23a5f9888f6f$export$864eea3f4ec3368f)({
                spacing: spacing
            }),
            $3d328d60195e26b2$var$getSpacingFix(children, $3d328d60195e26b2$var$iconBeforeSpacingFixStyle)
        ]
    }, iconBefore) : null, $3d328d60195e26b2$var$getChildren(children, [
        fadeStyles,
        (0, $5a6f23a5f9888f6f$export$7ad0316cc0dd65a)({
            spacing: spacing
        })
    ]), iconAfter ? (0, $jVTBW.jsx)("span", {
        css: [
            fadeStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $5a6f23a5f9888f6f$export$864eea3f4ec3368f)({
                spacing: spacing
            }),
            $3d328d60195e26b2$var$getSpacingFix(children, $3d328d60195e26b2$var$iconAfterSpacingFixStyle)
        ]
    }, iconAfter) : null, overlay ? (0, $jVTBW.jsx)("span", {
        css: [
            (0, $5a6f23a5f9888f6f$export$1a9fe1b84c876bb5),
            spinnerHackCss
        ]
    }, overlay) : null));
});



function $454d3314eda28364$export$2e2bcd8739ae039(_ref) {
    var children = _ref.children, iconBefore = _ref.iconBefore, iconAfter = _ref.iconAfter;
    if ((0, $eb8314806c2ef62d$export$20bbd2efb0d734c4)(children)) return true;
    if (children) return false;
    if (iconBefore && !iconAfter) return true;
    if (!iconBefore && iconAfter) return true;
    return false;
}



var $dAx5m = parcelRequire("dAx5m");
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $dAx5m = parcelRequire("dAx5m");

var $jVTBW = parcelRequire("jVTBW");

var $kqsmh = parcelRequire("kqsmh");
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // Reds
var $0a9c9a36176af2f2$export$4b84fd0e2c617bd = "#FFEBE6";
var $0a9c9a36176af2f2$export$b34b069eff244586 = "#FFBDAD";
var $0a9c9a36176af2f2$export$be802dd0d8b57f35 = "#FF8F73";
var $0a9c9a36176af2f2$export$60847d42f9da92a6 = "#FF7452";
var $0a9c9a36176af2f2$export$4a7404f376229999 = "#FF5630";
var $0a9c9a36176af2f2$export$2010d0fb4295b346 = "#DE350B";
var $0a9c9a36176af2f2$export$2837b5a1a71d5c02 = "#BF2600";
var $0a9c9a36176af2f2$export$8d9596b529bbb9cf = "#FFFAE6";
var $0a9c9a36176af2f2$export$41060a744ab0b7ae = "#FFF0B3";
var $0a9c9a36176af2f2$export$1cc05bbbf340e559 = "#FFE380";
var $0a9c9a36176af2f2$export$5aae31392d72caaa = "#FFC400";
var $0a9c9a36176af2f2$export$c6930421db9fa514 = "#FFAB00";
var $0a9c9a36176af2f2$export$59619663aa6500fb = "#FF991F";
var $0a9c9a36176af2f2$export$874739ea9e379ab6 = "#FF8B00";
var $0a9c9a36176af2f2$export$8a6341c32b6a3ee6 = "#E3FCEF";
var $0a9c9a36176af2f2$export$69a3bf21b9686c2b = "#ABF5D1";
var $0a9c9a36176af2f2$export$afbce1382ec95f73 = "#79F2C0";
var $0a9c9a36176af2f2$export$747d86715d4175de = "#57D9A3";
var $0a9c9a36176af2f2$export$940e1f69e873f202 = "#36B37E";
var $0a9c9a36176af2f2$export$a49394138f7b8e85 = "#00875A";
var $0a9c9a36176af2f2$export$6fa04827ac68a4fb = "#006644";
var $0a9c9a36176af2f2$export$226de0355ed012f8 = "#DEEBFF";
var $0a9c9a36176af2f2$export$8c13c2ee36917869 = "#B3D4FF";
var $0a9c9a36176af2f2$export$ecfc1dff386a3e7a = "#4C9AFF";
var $0a9c9a36176af2f2$export$215b7063051591f1 = "#2684FF";
var $0a9c9a36176af2f2$export$e62e8919cca44969 = "#0065FF";
var $0a9c9a36176af2f2$export$b3de0ae08da2ce64 = "#0052CC";
var $0a9c9a36176af2f2$export$a6ee3d71bc067634 = "#0747A6";
var $0a9c9a36176af2f2$export$363e4475840015bb = "#EAE6FF";
var $0a9c9a36176af2f2$export$4b0a4417ed59760f = "#C0B6F2";
var $0a9c9a36176af2f2$export$6011520a64d9a187 = "#998DD9";
var $0a9c9a36176af2f2$export$a7175d4e9206bc80 = "#8777D9";
var $0a9c9a36176af2f2$export$b48405b95304b5a1 = "#6554C0";
var $0a9c9a36176af2f2$export$c71e4279dd54a18d = "#5243AA";
var $0a9c9a36176af2f2$export$147899de772240ec = "#403294";
var $0a9c9a36176af2f2$export$2cf711fe14c66f06 = "#E6FCFF";
var $0a9c9a36176af2f2$export$7a8f4d33f6f9772c = "#B3F5FF";
var $0a9c9a36176af2f2$export$776c9c497ef08533 = "#79E2F2";
var $0a9c9a36176af2f2$export$69cb3ca10c1e330e = "#00C7E6";
var $0a9c9a36176af2f2$export$9dc1ef0f3f48059b = "#00B8D9";
var $0a9c9a36176af2f2$export$7c835c78b6fcdef8 = "#00A3BF";
var $0a9c9a36176af2f2$export$6036577f95c3877e = "#008DA6";
var $0a9c9a36176af2f2$export$29a4f05edc054374 = "#FFFFFF";
var $0a9c9a36176af2f2$export$e655ef011c4aa1a2 = "#FAFBFC";
var $0a9c9a36176af2f2$export$9fdfb749e33cdf97 = "#F4F5F7";
var $0a9c9a36176af2f2$export$3e51e8f1440314ba = "#EBECF0";
var $0a9c9a36176af2f2$export$1ce2d1575d444ceb = "#DFE1E6";
var $0a9c9a36176af2f2$export$8754fc7e6d8b3000 = "#C1C7D0";
var $0a9c9a36176af2f2$export$c2e91cbeada39b8b = "#B3BAC5";
var $0a9c9a36176af2f2$export$5f71e19f3a7ad9de = "#A5ADBA";
var $0a9c9a36176af2f2$export$eaa8c8a70ac22806 = "#97A0AF";
var $0a9c9a36176af2f2$export$7c87d337fb91a97d = "#8993A4";
var $0a9c9a36176af2f2$export$d6447c357493214f = "#7A869A";
var $0a9c9a36176af2f2$export$f563ee71e9ee74cd = "#6B778C";
var $0a9c9a36176af2f2$export$e2ef2124cf4024b1 = "#5E6C84";
var $0a9c9a36176af2f2$export$eece5f492e429f08 = "#505F79";
var $0a9c9a36176af2f2$export$c39c0fe0f26207ae = "#42526E";
var $0a9c9a36176af2f2$export$7090862dc3038a9f = "#344563";
var $0a9c9a36176af2f2$export$ad0bacf983b7ddaa = "#253858";
var $0a9c9a36176af2f2$export$7d61b15e0da132af = "#172B4D";
var $0a9c9a36176af2f2$export$fbda843f0a27fe96 = "#091E42";
var $0a9c9a36176af2f2$export$791e57b27ca738ef = "rgba(9, 30, 66, 0.02)";
var $0a9c9a36176af2f2$export$8d43898f60b96a82 = "rgba(9, 30, 66, 0.04)";
var $0a9c9a36176af2f2$export$920c0d5c49070351 = "rgba(9, 30, 66, 0.08)";
var $0a9c9a36176af2f2$export$46987b49aab6d1a8 = "rgba(9, 30, 66, 0.13)";
var $0a9c9a36176af2f2$export$7d3359664e8bb0e5 = "rgba(9, 30, 66, 0.25)";
var $0a9c9a36176af2f2$export$d2d3bedfb276cac0 = "rgba(9, 30, 66, 0.31)";
var $0a9c9a36176af2f2$export$6e5e7499ff054f6d = "rgba(9, 30, 66, 0.36)";
var $0a9c9a36176af2f2$export$59264b346c877fa7 = "rgba(9, 30, 66, 0.42)";
var $0a9c9a36176af2f2$export$d092757d7c64925c = "rgba(9, 30, 66, 0.48)";
var $0a9c9a36176af2f2$export$486ab785e4bac3c6 = "rgba(9, 30, 66, 0.54)";
var $0a9c9a36176af2f2$export$fba592bbc6419fea = "rgba(9, 30, 66, 0.60)";
var $0a9c9a36176af2f2$export$13609db0e6812ab8 = "rgba(9, 30, 66, 0.66)";
var $0a9c9a36176af2f2$export$fbae4efaa892d883 = "rgba(9, 30, 66, 0.71)";
var $0a9c9a36176af2f2$export$f13946d26f440ce6 = "rgba(9, 30, 66, 0.77)";
var $0a9c9a36176af2f2$export$19f58225ac52a306 = "rgba(9, 30, 66, 0.82)";
var $0a9c9a36176af2f2$export$6384f09da70e7b62 = "rgba(9, 30, 66, 0.89)";
var $0a9c9a36176af2f2$export$d0dccc730683edc2 = "rgba(9, 30, 66, 0.95)";
var $0a9c9a36176af2f2$export$2f6319cf7d736c2a = "#E6EDFA";
var $0a9c9a36176af2f2$export$95126bc8884d6634 = "#DCE5F5";
var $0a9c9a36176af2f2$export$8338d8c35d44ff1 = "#CED9EB";
var $0a9c9a36176af2f2$export$5368d76ae4fbbda7 = "#B8C7E0";
var $0a9c9a36176af2f2$export$9f0a771d16ec8d36 = "#ABBBD6";
var $0a9c9a36176af2f2$export$abcf8c38338b4aa5 = "#9FB0CC";
var $0a9c9a36176af2f2$export$97e81faa16a182c7 = "#8C9CB8";
var $0a9c9a36176af2f2$export$bfe21c59123ecf33 = "#7988A3";
var $0a9c9a36176af2f2$export$ee82aa2ea6a1558 = "#67758F";
var $0a9c9a36176af2f2$export$682927c6ed76be02 = "#56637A";
var $0a9c9a36176af2f2$export$91fd9994c5be9757 = "#455166";
var $0a9c9a36176af2f2$export$d281fbfe3cff2df6 = "#3B475C";
var $0a9c9a36176af2f2$export$3902c91d8b98a753 = "#313D52";
var $0a9c9a36176af2f2$export$8e8133c1ba5845b5 = "#283447";
var $0a9c9a36176af2f2$export$33ff357f6620b39 = "#202B3D";
var $0a9c9a36176af2f2$export$633847cf062b69e0 = "#1B2638";
var $0a9c9a36176af2f2$export$9776a6e503bdbf76 = "#121A29";
var $0a9c9a36176af2f2$export$6c813d5160dff5db = "#0E1624";
var $0a9c9a36176af2f2$export$3d4f271a500072a = "#0D1424";
var $0a9c9a36176af2f2$export$fe151285c22759ec = "rgba(13, 20, 36, 0.06)";
var $0a9c9a36176af2f2$export$a101c6190d0da34 = "rgba(13, 20, 36, 0.14)";
var $0a9c9a36176af2f2$export$4b16f52932fda51 = "rgba(13, 20, 36, 0.18)";
var $0a9c9a36176af2f2$export$a74bcd7b9845b0d8 = "rgba(13, 20, 36, 0.29)";
var $0a9c9a36176af2f2$export$9209c179316d1751 = "rgba(13, 20, 36, 0.36)";
var $0a9c9a36176af2f2$export$88f55133f636c8dd = "rgba(13, 20, 36, 0.40)";
var $0a9c9a36176af2f2$export$51126f85d1009512 = "rgba(13, 20, 36, 0.47)";
var $0a9c9a36176af2f2$export$a069b547bd23af78 = "rgba(13, 20, 36, 0.53)";
var $0a9c9a36176af2f2$export$40cce05af3b2600a = "rgba(13, 20, 36, 0.63)";
var $0a9c9a36176af2f2$export$b78942185925a0d = "rgba(13, 20, 36, 0.73)";
var $0a9c9a36176af2f2$export$e058fb44b8eaafca = "rgba(13, 20, 36, 0.78)";
var $0a9c9a36176af2f2$export$92b0b8de26920c18 = "rgba(13, 20, 36, 0.81)";
var $0a9c9a36176af2f2$export$67564f7459d3fc9e = "rgba(13, 20, 36, 0.85)";
var $0a9c9a36176af2f2$export$77868e1ca884ffa3 = "rgba(13, 20, 36, 0.89)";
var $0a9c9a36176af2f2$export$2afd71d7d3ea2cd5 = "rgba(13, 20, 36, 0.92)";
var $0a9c9a36176af2f2$export$f2a0acaab9972c70 = "rgba(13, 20, 36, 0.95)";
var $0a9c9a36176af2f2$export$9ab70e67d6475361 = "rgba(13, 20, 36, 0.97)";


var $0c095c0a1ed45d42$export$4e9f1640bbe7a1a8 = {
    xsmall: 8,
    small: 16,
    medium: 24,
    large: 48,
    xlarge: 96
};


/**
 * Returns the appropriate circle stroke color.
 */ function $51bf82b0da6a7e6e$var$getStrokeColor(appearance) {
    return appearance === "inherit" ? "var(--ds-icon-subtle, ".concat((0, $0a9c9a36176af2f2$export$c39c0fe0f26207ae), ")") : "var(--ds-icon-inverse, ".concat((0, $0a9c9a36176af2f2$export$29a4f05edc054374), ")");
}
var $51bf82b0da6a7e6e$var$rotate = (0, $jVTBW.keyframes)({
    to: {
        transform: "rotate(360deg)"
    }
});
var $51bf82b0da6a7e6e$var$rotateStyles = (0, $jVTBW.css)({
    animation: "".concat($51bf82b0da6a7e6e$var$rotate, " 0.86s infinite"),
    animationTimingFunction: "cubic-bezier(0.4, 0.15, 0.6, 0.85)",
    transformOrigin: "center"
});
/**
 * There are three parts to the load in animation:
 * 1. Fade in
 * 2. Accelerated spin
 * 3. Stretch the spinner line
 */ var $51bf82b0da6a7e6e$var$loadIn = (0, $jVTBW.keyframes)({
    from: {
        transform: "rotate(50deg)",
        opacity: 0,
        strokeDashoffset: 60
    },
    to: {
        transform: "rotate(230deg)",
        opacity: 1,
        strokeDashoffset: 50
    }
});
var $51bf82b0da6a7e6e$var$loadInStyles = (0, $jVTBW.css)({
    animation: "".concat($51bf82b0da6a7e6e$var$loadIn, " 1s ease-in-out"),
    /**
   * When the animation completes, stay at the last frame of the animation.
   */ animationFillMode: "forwards",
    /**
   * We are going to animate this in.
   */ opacity: 0
});
var $51bf82b0da6a7e6e$var$wrapperStyles = (0, $jVTBW.css)({
    display: "inline-flex",
    /**
   * Align better inline with text.
   */ verticalAlign: "middle"
});
var $51bf82b0da6a7e6e$var$circleStyles = (0, $jVTBW.css)({
    fill: "none",
    strokeDasharray: 60,
    strokeDashoffset: "inherit",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    "@media screen and (forced-colors: active)": {
        filter: "grayscale(100%)",
        stroke: "CanvasText"
    }
});
/**
 * `useLayoutEffect` is being used in SSR safe form. On the server, this work doesn’t need to run.
 * `useEffect` is used in-place, because `useEffect` is not run on the server and it matches types
 * which makes things simpler than doing an `isServer` check or a `null` check.
 *
 * @see https://hello.atlassian.net/wiki/spaces/DST/pages/2081696628/DSTDACI-010+-+Interaction+Tracing+hooks+in+DS+components
 */ var $51bf82b0da6a7e6e$var$useLayoutEffect = typeof window === "undefined" ? (0, $dAx5m.useEffect) : (0, $dAx5m.useLayoutEffect);
/**
 * __Spinner__
 *
 * A spinner is an animated spinning icon that lets users know content is being loaded.
 *
 * - [Examples](https://atlassian.design/components/spinner/examples)
 * - [Code](https://atlassian.design/components/spinner/code)
 * - [Usage](https://atlassian.design/components/spinner/usage)
 */ var $51bf82b0da6a7e6e$var$Spinner = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).forwardRef(function Spinner(_ref, ref) {
    var _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "inherit" : _ref$appearance, _ref$delay = _ref.delay, delay = _ref$delay === void 0 ? 0 : _ref$delay, interactionName = _ref.interactionName, label = _ref.label, _ref$size = _ref.size, providedSize = _ref$size === void 0 ? "medium" : _ref$size, testId = _ref.testId;
    var size = typeof providedSize === "number" ? providedSize : (0, $0c095c0a1ed45d42$export$4e9f1640bbe7a1a8)[providedSize];
    var animationDelay = "".concat(delay, "ms");
    var stroke = $51bf82b0da6a7e6e$var$getStrokeColor(appearance);
    var context = (0, $dAx5m.useContext)((0, $kqsmh.default));
    $51bf82b0da6a7e6e$var$useLayoutEffect(function() {
        if (context != null) return context.hold(interactionName);
    }, [
        context,
        interactionName
    ]);
    /**
   * The Spinner animation uses a combination of two
   * css animations on two separate elements.
   */ return (0, $jVTBW.jsx)("span", {
        /**
     * This span exists to off-load animations from the circle element,
     * which were causing performance issues (style recalculations)
     * on Safari and older versions of Chrome.
     *
     * This can be removed and styles placed back on the circle element once
     * Safari fixes this bug and off-loads rendering to the GPU from the CPU.
     */ css: [
            $51bf82b0da6a7e6e$var$wrapperStyles,
            $51bf82b0da6a7e6e$var$rotateStyles
        ],
        "data-testid": testId && "".concat(testId, "-wrapper"),
        style: {
            animationDelay: animationDelay,
            width: size,
            height: size
        }
    }, (0, $jVTBW.jsx)("svg", {
        height: size,
        width: size,
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        "data-testid": testId,
        ref: ref,
        "aria-label": label || undefined,
        css: $51bf82b0da6a7e6e$var$loadInStyles,
        style: {
            animationDelay: animationDelay
        },
        role: label ? "img" : "none"
    }, (0, $jVTBW.jsx)("circle", {
        cx: "8",
        cy: "8",
        r: "7",
        css: $51bf82b0da6a7e6e$var$circleStyles,
        style: {
            stroke: stroke
        }
    })));
}));
var $51bf82b0da6a7e6e$export$2e2bcd8739ae039 = $51bf82b0da6a7e6e$var$Spinner;


function $3430253489eac4b1$var$getSpinnerAppearance(_ref) {
    var appearance = _ref.appearance, isDisabled = _ref.isDisabled, isSelected = _ref.isSelected;
    if (isDisabled) return "inherit";
    if (isSelected) return "invert";
    if (appearance === "primary" || appearance === "danger") return "invert";
    return "inherit";
}
function $3430253489eac4b1$export$2e2bcd8739ae039(_ref2) {
    var appearance = _ref2.appearance, isDisabled = _ref2.isDisabled, isSelected = _ref2.isSelected, _ref2$spacing = _ref2.spacing, spacing = _ref2$spacing === void 0 ? "default" : _ref2$spacing;
    var size = spacing === "default" ? "medium" : "small";
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $51bf82b0da6a7e6e$export$2e2bcd8739ae039), {
        size: size,
        label: ", Loading",
        appearance: $3430253489eac4b1$var$getSpinnerAppearance({
            appearance: appearance,
            isDisabled: isDisabled,
            isSelected: isSelected
        })
    });
}





function $1a7ca37cfdc94b9c$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $1a7ca37cfdc94b9c$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $1a7ca37cfdc94b9c$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($010d27b02d402655$exports)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $1a7ca37cfdc94b9c$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $1a7ca37cfdc94b9c$var$stateToSelectorMap = {
    focus: "&:focus",
    focusSelected: "&:focus",
    hover: "&:hover",
    active: "&:active",
    disabled: "&[disabled]"
};
function $1a7ca37cfdc94b9c$export$31512de7fa606fa4(_ref) {
    var _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "default" : _ref$appearance, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? "default" : _ref$spacing, _ref$mode = _ref.mode, mode = _ref$mode === void 0 ? "light" : _ref$mode, _ref$isSelected = _ref.isSelected, isSelected = _ref$isSelected === void 0 ? false : _ref$isSelected, _ref$shouldFitContain = _ref.shouldFitContainer, shouldFitContainer = _ref$shouldFitContain === void 0 ? false : _ref$shouldFitContain, _ref$iconIsOnlyChild = _ref.iconIsOnlyChild, iconIsOnlyChild = _ref$iconIsOnlyChild === void 0 ? false : _ref$iconIsOnlyChild, _ref$isLoading = _ref.isLoading, isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading, state = _ref.state;
    var result = (0, $5a6f23a5f9888f6f$export$955358618f994a11)({
        appearance: appearance,
        spacing: spacing,
        mode: mode,
        isSelected: isSelected,
        shouldFitContainer: shouldFitContainer,
        isOnlySingleIcon: iconIsOnlyChild
    });
    // we need to disable the default browser focus styles always
    // this is because we are not expressing that we can have two pseudo states at a time
    result.outline = "none";
    // Pulling relevant styles up to the top level
    var selector = $1a7ca37cfdc94b9c$var$stateToSelectorMap[state];
    if (selector) result = $1a7ca37cfdc94b9c$var$_objectSpread($1a7ca37cfdc94b9c$var$_objectSpread({}, result), result[selector]);
    if (isLoading) result = $1a7ca37cfdc94b9c$var$_objectSpread($1a7ca37cfdc94b9c$var$_objectSpread({}, result), result['&[data-has-overlay="true"]']);
    // Delete all selectors and just keep root styles
    Object.keys(result).forEach(function(key) {
        // want to keep this one
        if (key === "&::-moz-focus-inner") return;
        // Not using .startsWith for ie11
        if (key.indexOf("&") === 0) delete result[key];
    });
    return result;
}
function $1a7ca37cfdc94b9c$export$643db0b8d8778e(styles) {
    return {
        "&, &:hover, &:active, &:focus, &:focus-visible, &:visited, &:disabled, &[disabled]": styles
    };
}
function $1a7ca37cfdc94b9c$export$437a7f77d13d7916(current, values) {
    return current(values);
}
var $1a7ca37cfdc94b9c$var$Theme = (0, $97420dade8819a74$export$25d302a5b900a763)(function(themeProps) {
    return {
        buttonStyles: $1a7ca37cfdc94b9c$export$31512de7fa606fa4(themeProps),
        // No styles being applied directly to spinner by default
        // Keeping this for legacy compat. We could remove it, but given
        // that we are changing theme soon there is no point
        spinnerStyles: {}
    };
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$1a7ca37cfdc94b9c$export$2e2bcd8739ae039 = $1a7ca37cfdc94b9c$var$Theme;


var $5c6b5dbb65e304f5$var$_excluded = [
    "appearance",
    "autoFocus",
    "isDisabled",
    "isSelected",
    "shouldFitContainer",
    "spacing",
    "isLoading",
    "onMouseEnter",
    "onMouseLeave",
    "onMouseDown",
    "onMouseUp",
    "onFocus",
    "onBlur",
    "theme"
];
function $5c6b5dbb65e304f5$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $5c6b5dbb65e304f5$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $5c6b5dbb65e304f5$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($010d27b02d402655$exports)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $5c6b5dbb65e304f5$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $5c6b5dbb65e304f5$var$getInteractionState(_ref) {
    var _ref$isDisabled = _ref.isDisabled, isDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled, _ref$isActive = _ref.isActive, isActive = _ref$isActive === void 0 ? false : _ref$isActive, _ref$isFocus = _ref.isFocus, isFocus = _ref$isFocus === void 0 ? false : _ref$isFocus, _ref$isHover = _ref.isHover, isHover = _ref$isHover === void 0 ? false : _ref$isHover, _ref$isSelected = _ref.isSelected, isSelected = _ref$isSelected === void 0 ? false : _ref$isSelected, _ref$isLoading = _ref.isLoading, isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading;
    if (isDisabled) return "disabled";
    if (isSelected && isFocus) return "focusSelected";
    if (isSelected) return "selected";
    // not allowing active or focus style changes while loading
    if (!isLoading && isActive) return "active";
    if (!isLoading && isHover) return "hover";
    if (isFocus) return "focus";
    return "default";
}
var $5c6b5dbb65e304f5$var$initial = {
    isHover: false,
    isActive: false,
    isFocus: false
};
/**
 * __Custom theme button__
 *
 * A custom theme button. Avoid using this component. It exists for those already using custom theming, which is hard to use and has performance issues.
 *
 * - [Examples](https://atlassian.design/components/button/examples#custom-theme-button)
 */ var $5c6b5dbb65e304f5$var$CustomThemeButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).forwardRef(function CustomThemeButton(_ref2, ref) {
    var _ref2$appearance = _ref2.appearance, appearance = _ref2$appearance === void 0 ? "default" : _ref2$appearance, _ref2$autoFocus = _ref2.autoFocus, autoFocus = _ref2$autoFocus === void 0 ? false : _ref2$autoFocus, _ref2$isDisabled = _ref2.isDisabled, isDisabled = _ref2$isDisabled === void 0 ? false : _ref2$isDisabled, _ref2$isSelected = _ref2.isSelected, isSelected = _ref2$isSelected === void 0 ? false : _ref2$isSelected, _ref2$shouldFitContai = _ref2.shouldFitContainer, shouldFitContainer = _ref2$shouldFitContai === void 0 ? false : _ref2$shouldFitContai, _ref2$spacing = _ref2.spacing, spacing = _ref2$spacing === void 0 ? "default" : _ref2$spacing, _ref2$isLoading = _ref2.isLoading, isLoading = _ref2$isLoading === void 0 ? false : _ref2$isLoading, providedOnMouseEnter = _ref2.onMouseEnter, providedOnMouseLeave = _ref2.onMouseLeave, providedOnMouseDown = _ref2.onMouseDown, providedOnMouseUp = _ref2.onMouseUp, providedOnFocus = _ref2.onFocus, providedOnBlur = _ref2.onBlur, _ref2$theme = _ref2.theme, theme = _ref2$theme === void 0 ? (0, $1a7ca37cfdc94b9c$export$437a7f77d13d7916) : _ref2$theme, rest = (0, (/*@__PURE__*/$parcel$interopDefault($e0a9c9aa3fdb10fc$exports)))(_ref2, $5c6b5dbb65e304f5$var$_excluded);
    // TODO is there a nicer way to do this?
    // Add default props back into object for spreading
    var restProps = $5c6b5dbb65e304f5$var$_objectSpread({
        appearance: appearance,
        autoFocus: autoFocus,
        isDisabled: isDisabled,
        isSelected: isSelected,
        shouldFitContainer: shouldFitContainer,
        spacing: spacing
    }, rest);
    var _useState = (0, $dAx5m.useState)($5c6b5dbb65e304f5$var$initial), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($5fdc9222475a2456$exports)))(_useState, 2), state = _useState2[0], setState = _useState2[1];
    var onMouseEnter = (0, $dAx5m.useCallback)(function(event) {
        setState(function(current) {
            return $5c6b5dbb65e304f5$var$_objectSpread($5c6b5dbb65e304f5$var$_objectSpread({}, current), {}, {
                isHover: true
            });
        });
        if (providedOnMouseEnter) providedOnMouseEnter(event);
    }, [
        providedOnMouseEnter
    ]);
    var onMouseLeave = (0, $dAx5m.useCallback)(function(event) {
        setState(function(current) {
            return $5c6b5dbb65e304f5$var$_objectSpread($5c6b5dbb65e304f5$var$_objectSpread({}, current), {}, {
                isHover: false,
                isActive: false
            });
        });
        if (providedOnMouseLeave) providedOnMouseLeave(event);
    }, [
        providedOnMouseLeave
    ]);
    var onMouseDown = (0, $dAx5m.useCallback)(function(event) {
        setState(function(current) {
            return $5c6b5dbb65e304f5$var$_objectSpread($5c6b5dbb65e304f5$var$_objectSpread({}, current), {}, {
                isActive: true
            });
        });
        if (providedOnMouseDown) providedOnMouseDown(event);
    }, [
        providedOnMouseDown
    ]);
    var onMouseUp = (0, $dAx5m.useCallback)(function(event) {
        setState(function(current) {
            return $5c6b5dbb65e304f5$var$_objectSpread($5c6b5dbb65e304f5$var$_objectSpread({}, current), {}, {
                isActive: false
            });
        });
        if (providedOnMouseUp) providedOnMouseUp(event);
    }, [
        providedOnMouseUp
    ]);
    var onFocus = (0, $dAx5m.useCallback)(function(event) {
        setState(function(current) {
            return $5c6b5dbb65e304f5$var$_objectSpread($5c6b5dbb65e304f5$var$_objectSpread({}, current), {}, {
                isFocus: true
            });
        });
        if (providedOnFocus) providedOnFocus(event);
    }, [
        providedOnFocus
    ]);
    var onBlur = (0, $dAx5m.useCallback)(function(event) {
        setState(function(current) {
            return $5c6b5dbb65e304f5$var$_objectSpread($5c6b5dbb65e304f5$var$_objectSpread({}, current), {}, {
                isFocus: false
            });
        });
        if (providedOnBlur) providedOnBlur(event);
    }, [
        providedOnBlur
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $1a7ca37cfdc94b9c$export$2e2bcd8739ae039).Provider, {
        value: theme
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $3ba3980154d893b4$export$2e2bcd8739ae039).Consumer, null, function(_ref3) {
        var mode = _ref3.mode;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $1a7ca37cfdc94b9c$export$2e2bcd8739ae039).Consumer, (0, (/*@__PURE__*/$parcel$interopDefault($00d53520b6c62aef$exports)))({
            mode: mode,
            state: $5c6b5dbb65e304f5$var$getInteractionState($5c6b5dbb65e304f5$var$_objectSpread($5c6b5dbb65e304f5$var$_objectSpread({}, state), {}, {
                isLoading: isLoading,
                isSelected: restProps.isSelected,
                isDisabled: restProps.isDisabled
            })),
            iconIsOnlyChild: (0, $454d3314eda28364$export$2e2bcd8739ae039)(restProps),
            isLoading: isLoading
        }, restProps), function(_ref4) {
            var buttonStyles = _ref4.buttonStyles;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $3d328d60195e26b2$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($00d53520b6c62aef$exports)))({}, restProps, {
                ref: ref,
                overlay: isLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $3430253489eac4b1$export$2e2bcd8739ae039), restProps) : null,
                "aria-disabled": isLoading || restProps["aria-disabled"],
                onMouseEnter: onMouseEnter,
                onMouseLeave: onMouseLeave,
                onMouseDown: onMouseDown,
                onMouseUp: onMouseUp,
                onFocus: onFocus,
                onBlur: onBlur,
                buttonCss: (0, $1a7ca37cfdc94b9c$export$643db0b8d8778e)(buttonStyles)
            }));
        });
    }));
}));
// Tools including enzyme rely on components having a display name
$5c6b5dbb65e304f5$var$CustomThemeButton.displayName = "CustomThemeButton";
var $5c6b5dbb65e304f5$export$2e2bcd8739ae039 = $5c6b5dbb65e304f5$var$CustomThemeButton;





var $bf9550c5df68dc91$var$buttonStyles = (0, $jVTBW.css)({
    "&&, a&&": {
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
        padding: "0 ".concat("var(--ds-space-100, 8px)", " !important"),
        background: "var(".concat((0, $df3e57924e92b86f$export$e9244ec13bd422b5), ")"),
        color: "var(".concat((0, $df3e57924e92b86f$export$4f8f13a66ae77bdd), ") !important"),
        fontWeight: "var(--ds-font-weight-medium, 500)"
    },
    "&&:hover, &&:active, a&&:hover, a&&:active": {
        textDecoration: "underline"
    },
    "&&:hover": {
        backgroundColor: "var(".concat((0, $df3e57924e92b86f$export$97e78d9745006c11), ")")
    },
    "&&:active": {
        backgroundColor: "var(".concat((0, $df3e57924e92b86f$export$291d63757828f290), ")")
    }
});
var $bf9550c5df68dc91$var$appearanceNormalButtonStyles = (0, $jVTBW.css)({
    "&&, a&&": {
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
        padding: "0 !important"
    }
});
var $bf9550c5df68dc91$var$appearanceNormalActionsContainerStyles = (0, $jVTBW.css)({
    "&&, a&&": {
        transform: "translateX(-2px)"
    }
});
var $bf9550c5df68dc91$var$FlagActions = function FlagActions(props) {
    var _props$appearance = props.appearance, appearance = _props$appearance === void 0 ? (0, $df3e57924e92b86f$export$d6830277b06edd6) : _props$appearance, _props$actions = props.actions, actions = _props$actions === void 0 ? [] : _props$actions, linkComponent = props.linkComponent, testId = props.testId;
    if (!actions.length) return null;
    var isBold = appearance !== (0, $df3e57924e92b86f$export$d6830277b06edd6);
    return (0, $jVTBW.jsx)("span", {
        css: !isBold && $bf9550c5df68dc91$var$appearanceNormalActionsContainerStyles
    }, (0, $jVTBW.jsx)((0, $6e025698fb99d187$export$2e2bcd8739ae039), {
        space: "space.100",
        shouldWrap: true,
        alignBlock: "center",
        separator: isBold ? undefined : "\xb7",
        testId: testId && "".concat(testId, "-actions")
    }, actions.map(function(action, index) {
        var _ref;
        return (0, $jVTBW.jsx)((0, $5c6b5dbb65e304f5$export$2e2bcd8739ae039), {
            onClick: action.onClick,
            href: action.href,
            target: action.target,
            appearance: isBold ? "default" : "link",
            component: linkComponent,
            spacing: "compact",
            testId: action.testId,
            key: index,
            style: (_ref = {}, (0, (/*@__PURE__*/$parcel$interopDefault($010d27b02d402655$exports)))(_ref, (0, $df3e57924e92b86f$export$4f8f13a66ae77bdd), (0, $79243b2679dffa0d$export$7bcfe3cca4dd78b6)[appearance]), (0, (/*@__PURE__*/$parcel$interopDefault($010d27b02d402655$exports)))(_ref, (0, $df3e57924e92b86f$export$e9244ec13bd422b5), (0, $79243b2679dffa0d$export$81ba6b63eedb299f)[appearance].default), (0, (/*@__PURE__*/$parcel$interopDefault($010d27b02d402655$exports)))(_ref, (0, $df3e57924e92b86f$export$97e78d9745006c11), (0, $79243b2679dffa0d$export$81ba6b63eedb299f)[appearance].pressed), (0, (/*@__PURE__*/$parcel$interopDefault($010d27b02d402655$exports)))(_ref, (0, $df3e57924e92b86f$export$291d63757828f290), (0, $79243b2679dffa0d$export$81ba6b63eedb299f)[appearance].active), _ref),
            css: [
                $bf9550c5df68dc91$var$buttonStyles,
                appearance === (0, $df3e57924e92b86f$export$d6830277b06edd6) && $bf9550c5df68dc91$var$appearanceNormalButtonStyles
            ]
        }, action.content);
    })));
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$bf9550c5df68dc91$export$2e2bcd8739ae039 = $bf9550c5df68dc91$var$FlagActions;




var $dAx5m = parcelRequire("dAx5m");
var $5b291e9643c5c137$exports = {};
"use strict";
Object.defineProperty($5b291e9643c5c137$exports, "__esModule", {
    value: true
});
$5b291e9643c5c137$exports.default = void 0;

var $5b291e9643c5c137$var$_react = $5b291e9643c5c137$var$_interopRequireDefault((parcelRequire("dAx5m")));



var $dAx5m = parcelRequire("dAx5m");

var $jVTBW = parcelRequire("jVTBW");
var $e5bb4a7cad184201$export$18cb9425622d4e06 = function getBackground() {
    return "var(--ds-surface, #FFFFFF)";
};


var $82dbaa95309a32f1$export$c647cb0ee6e282fe = {
    small: "16px",
    medium: "24px",
    large: "32px",
    xlarge: "48px"
};
var $82dbaa95309a32f1$export$7bd66fc94c81bf84 = {
    small: "small",
    medium: "medium",
    large: "large",
    xlarge: "xlarge"
};
var $82dbaa95309a32f1$export$62ad7b0c781000e9 = {
    small: {
        width: $82dbaa95309a32f1$export$c647cb0ee6e282fe.small,
        height: $82dbaa95309a32f1$export$c647cb0ee6e282fe.small
    },
    medium: {
        width: $82dbaa95309a32f1$export$c647cb0ee6e282fe.medium,
        height: $82dbaa95309a32f1$export$c647cb0ee6e282fe.medium
    },
    large: {
        width: $82dbaa95309a32f1$export$c647cb0ee6e282fe.large,
        height: $82dbaa95309a32f1$export$c647cb0ee6e282fe.large
    },
    xlarge: {
        width: $82dbaa95309a32f1$export$c647cb0ee6e282fe.xlarge,
        height: $82dbaa95309a32f1$export$c647cb0ee6e282fe.xlarge
    }
};



var $jVTBW = parcelRequire("jVTBW");
var $d5f232721a393c1b$export$16374db1c3e6dfba = {
    overflow: "hidden",
    pointerEvents: "none",
    /**
   * Stop-color doesn't properly apply in chrome when the inherited/current color changes.
   * We have to initially set stop-color to inherit (either via DOM attribute or an initial CSS
   * rule) and then override it with currentColor for the color changes to be picked up.
   */ stop: {
        stopColor: "currentColor"
    }
};
var $d5f232721a393c1b$var$smallStyles = (0, $jVTBW.css)((0, $82dbaa95309a32f1$export$62ad7b0c781000e9).small);
var $d5f232721a393c1b$var$mediumStyles = (0, $jVTBW.css)((0, $82dbaa95309a32f1$export$62ad7b0c781000e9).medium);
var $d5f232721a393c1b$var$largeStyles = (0, $jVTBW.css)((0, $82dbaa95309a32f1$export$62ad7b0c781000e9).large);
var $d5f232721a393c1b$var$xlargeStyles = (0, $jVTBW.css)((0, $82dbaa95309a32f1$export$62ad7b0c781000e9).xlarge);
var $d5f232721a393c1b$export$ef0ad74202575b64 = {
    small: $d5f232721a393c1b$var$smallStyles,
    medium: $d5f232721a393c1b$var$mediumStyles,
    large: $d5f232721a393c1b$var$largeStyles,
    xlarge: $d5f232721a393c1b$var$xlargeStyles
};
var $d5f232721a393c1b$export$3eb7d6130acfda37 = function getIconSize(_ref) {
    var width = _ref.width, height = _ref.height, size = _ref.size;
    if (width && height) return {
        width: width,
        height: height
    };
    if (size) return (0, $82dbaa95309a32f1$export$62ad7b0c781000e9)[size];
    return undefined;
};


function $e3cba53a6e961ebd$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $e3cba53a6e961ebd$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $e3cba53a6e961ebd$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($010d27b02d402655$exports)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $e3cba53a6e961ebd$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
/**
 * We are hiding these props from consumers as they're used to
 * hack around icon sizing specifically for icon-file-type.
 */ var $e3cba53a6e961ebd$var$iconStyles = (0, $jVTBW.css)({
    display: "inline-block",
    flexShrink: 0,
    lineHeight: 1,
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
    "> svg": $e3cba53a6e961ebd$var$_objectSpread($e3cba53a6e961ebd$var$_objectSpread({}, (0, $d5f232721a393c1b$export$16374db1c3e6dfba)), {}, {
        maxWidth: "100%",
        maxHeight: "100%",
        color: "var(--icon-primary-color)",
        fill: "var(--icon-secondary-color)",
        verticalAlign: "bottom"
    })
});
/**
 * For windows high contrast mode
 */ var $e3cba53a6e961ebd$var$baseHcmStyles = (0, $jVTBW.css)({
    "@media screen and (forced-colors: active)": {
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
        "> svg": {
            filter: "grayscale(1)",
            "--icon-primary-color": "CanvasText",
            // foreground
            "--icon-secondary-color": "Canvas" // background
        }
    }
});
var $e3cba53a6e961ebd$var$primaryEqualsSecondaryHcmStyles = (0, $jVTBW.css)({
    "@media screen and (forced-colors: active)": {
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
        "> svg": {
            // if the primaryColor is the same as the secondaryColor we
            // set the --icon-primary-color to Canvas
            // this is usually to convey state i.e. Checkbox checked -> not checked
            "--icon-primary-color": "Canvas" // foreground
        }
    }
});
var $e3cba53a6e961ebd$var$secondaryTransparentHcmStyles = (0, $jVTBW.css)({
    "@media screen and (forced-colors: active)": {
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
        "> svg": {
            "--icon-secondary-color": "transparent" // background
        }
    }
});
var $e3cba53a6e961ebd$export$f04a61298a47a40f = /*#__PURE__*/ (0, $dAx5m.memo)(function Icon(props) {
    var _ref = props, Glyph = _ref.glyph, dangerouslySetGlyph = _ref.dangerouslySetGlyph, _ref$primaryColor = _ref.primaryColor, primaryColor = _ref$primaryColor === void 0 ? "currentColor" : _ref$primaryColor, secondaryColor = _ref.secondaryColor, size = _ref.size, testId = _ref.testId, label = _ref.label, width = _ref.width, height = _ref.height;
    var glyphProps = dangerouslySetGlyph ? {
        dangerouslySetInnerHTML: {
            __html: dangerouslySetGlyph
        }
    } : {
        children: Glyph ? (0, $jVTBW.jsx)(Glyph, {
            role: "presentation"
        }) : null
    };
    var dimensions = (0, $d5f232721a393c1b$export$3eb7d6130acfda37)({
        width: width,
        height: height,
        size: size
    });
    return (0, $jVTBW.jsx)("span", (0, (/*@__PURE__*/$parcel$interopDefault($00d53520b6c62aef$exports)))({
        "data-testid": testId,
        role: label ? "img" : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: {
            "--icon-primary-color": primaryColor,
            "--icon-secondary-color": secondaryColor || (0, $e5bb4a7cad184201$export$18cb9425622d4e06)()
        }
    }, glyphProps, {
        css: [
            $e3cba53a6e961ebd$var$iconStyles,
            $e3cba53a6e961ebd$var$baseHcmStyles,
            primaryColor === secondaryColor && $e3cba53a6e961ebd$var$primaryEqualsSecondaryHcmStyles,
            secondaryColor === "transparent" && $e3cba53a6e961ebd$var$secondaryTransparentHcmStyles,
            // NB: This can be resolved if this component, composes base SVG / and/or skeleton
            // We could then simplify how common styles are dealt with simply by encapsualting them
            // at their appropriate level and/or having a singular approach to css variables in the package
            dimensions && // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
            (0, $jVTBW.css)({
                width: dimensions.width,
                height: dimensions.height,
                "> svg": dimensions
            })
        ]
    }));
});
var $e3cba53a6e961ebd$export$2e2bcd8739ae039 = $e3cba53a6e961ebd$export$f04a61298a47a40f;


function $5b291e9643c5c137$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $5b291e9643c5c137$var$HipchatChevronDownIcon = (props)=>/*#__PURE__*/ $5b291e9643c5c137$var$_react.default.createElement($e3cba53a6e961ebd$export$f04a61298a47a40f, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path d="M6.744 8.744a1.053 1.053 0 000 1.49l4.547 4.557a1 1 0 001.416 0l4.55-4.558a1.051 1.051 0 10-1.488-1.488l-3.77 3.776-3.768-3.776a1.051 1.051 0 00-1.487 0z" fill="currentColor"/></svg>`
    }, props));
$5b291e9643c5c137$var$HipchatChevronDownIcon.displayName = "HipchatChevronDownIcon";
var $5b291e9643c5c137$var$_default = $5b291e9643c5c137$var$HipchatChevronDownIcon;
$5b291e9643c5c137$exports.default = $5b291e9643c5c137$var$_default;


var $d8253da1599d59ca$exports = {};
"use strict";
Object.defineProperty($d8253da1599d59ca$exports, "__esModule", {
    value: true
});
$d8253da1599d59ca$exports.default = void 0;

var $d8253da1599d59ca$var$_react = $d8253da1599d59ca$var$_interopRequireDefault((parcelRequire("dAx5m")));

function $d8253da1599d59ca$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $d8253da1599d59ca$var$HipchatChevronUpIcon = (props)=>/*#__PURE__*/ $d8253da1599d59ca$var$_react.default.createElement($e3cba53a6e961ebd$export$f04a61298a47a40f, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path d="M11.294 8.708l-.001.001-4.549 4.559a1.051 1.051 0 101.486 1.488l.001-.001 3.77-3.776 3.768 3.776a1.05 1.05 0 001.486.001h.001a1.054 1.054 0 00.001-1.489l-4.548-4.558a1 1 0 00-1.415-.001z" fill="currentColor" fill-rule="evenodd"/></svg>`
    }, props));
$d8253da1599d59ca$var$HipchatChevronUpIcon.displayName = "HipchatChevronUpIcon";
var $d8253da1599d59ca$var$_default = $d8253da1599d59ca$var$HipchatChevronUpIcon;
$d8253da1599d59ca$exports.default = $d8253da1599d59ca$var$_default;


var $4779a16045cf7e83$exports = {};
"use strict";
Object.defineProperty($4779a16045cf7e83$exports, "__esModule", {
    value: true
});
$4779a16045cf7e83$exports.default = void 0;

var $4779a16045cf7e83$var$_react = $4779a16045cf7e83$var$_interopRequireDefault((parcelRequire("dAx5m")));

function $4779a16045cf7e83$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $4779a16045cf7e83$var$CrossIcon = (props)=>/*#__PURE__*/ $4779a16045cf7e83$var$_react.default.createElement($e3cba53a6e961ebd$export$f04a61298a47a40f, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path d="M12 10.586L6.707 5.293a1 1 0 00-1.414 1.414L10.586 12l-5.293 5.293a1 1 0 001.414 1.414L12 13.414l5.293 5.293a1 1 0 001.414-1.414L13.414 12l5.293-5.293a1 1 0 10-1.414-1.414L12 10.586z" fill="currentColor"/></svg>`
    }, props));
$4779a16045cf7e83$var$CrossIcon.displayName = "CrossIcon";
var $4779a16045cf7e83$var$_default = $4779a16045cf7e83$var$CrossIcon;
$4779a16045cf7e83$exports.default = $4779a16045cf7e83$var$_default;






var $dAx5m = parcelRequire("dAx5m");


var $Bb0he = parcelRequire("Bb0he");

var $kqsmh = parcelRequire("kqsmh");


var $999e662cb1878434$var$_excluded = [
    "children",
    "backgroundColor",
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    "isDisabled",
    "type",
    "testId",
    "xcss",
    "onClick",
    "interactionName",
    "componentName",
    "analyticsContext"
];
// TODO: Duplicated FocusRing styles due to lack of `xcss` support
// and to prevent additional dependency
var $999e662cb1878434$var$baseFocusRingStyles = {
    outlineColor: "color.border.focused",
    outlineWidth: "border.width.outline",
    outlineStyle: "solid",
    outlineOffset: "space.025"
};
var $999e662cb1878434$var$focusRingStyles = (0, $e54127128664e945$export$f6c783d06584602c)({
    ":focus-visible": $999e662cb1878434$var$baseFocusRingStyles,
    "@supports not selector(*:focus-visible)": {
        ":focus": $999e662cb1878434$var$baseFocusRingStyles
    },
    "@media screen and (forced-colors: active), screen and (-ms-high-contrast: active)": {
        ":focus-visible": {
            outline: "1px solid"
        }
    }
});
/**
 * __Pressable__
 *
 * A primitive for building custom buttons.
 *
 * - [Examples](https://atlassian.design/components/primitives/pressable/examples)
 * - [Code](https://atlassian.design/components/primitives/pressable/code)
 * - [Usage](https://atlassian.design/components/primitives/pressable/usage)
 */ var $999e662cb1878434$var$Pressable = /*#__PURE__*/ (0, $dAx5m.forwardRef)(function(_ref, ref) {
    var children = _ref.children, backgroundColor = _ref.backgroundColor, padding = _ref.padding, paddingBlock = _ref.paddingBlock, paddingBlockStart = _ref.paddingBlockStart, paddingBlockEnd = _ref.paddingBlockEnd, paddingInline = _ref.paddingInline, paddingInlineStart = _ref.paddingInlineStart, paddingInlineEnd = _ref.paddingInlineEnd, isDisabled = _ref.isDisabled, _ref$type = _ref.type, type = _ref$type === void 0 ? "button" : _ref$type, testId = _ref.testId, xcssStyles = _ref.xcss, _ref$onClick = _ref.onClick, providedOnClick = _ref$onClick === void 0 ? (0, $Bb0he.default) : _ref$onClick, interactionName = _ref.interactionName, componentName = _ref.componentName, analyticsContext = _ref.analyticsContext, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($e0a9c9aa3fdb10fc$exports)))(_ref, $999e662cb1878434$var$_excluded);
    var interactionContext = (0, $dAx5m.useContext)((0, $kqsmh.default));
    var handleClick = (0, $dAx5m.useCallback)(function(e, analyticsEvent) {
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    var onClick = (0, $d0cbd00f83880f1b$export$a4687b0234b40e28)({
        fn: handleClick,
        action: "clicked",
        componentName: componentName || "Pressable",
        packageName: "@atlaskit/primitives",
        packageVersion: "6.3.0",
        analyticsData: analyticsContext,
        actionSubject: "button"
    });
    // Combine default styles with supplied styles. XCSS does not support deep nested arrays
    var styles = [
        (0, $e54127128664e945$export$f6c783d06584602c)({
            cursor: isDisabled ? "not-allowed" : "pointer"
        }),
        $999e662cb1878434$var$focusRingStyles
    ];
    // We're type coercing this as Compiled styles in an array isn't supported by the types
    // But the runtime accepts it none-the-wiser. We can remove this entire block and replace
    // it with cx(defaultStyles, focusRingStyles, xcssStyles) when we've moved away from Emotion.
    styles = Array.isArray(xcssStyles) ? [].concat((0, (/*@__PURE__*/$parcel$interopDefault($2087e80a80355736$exports)))(styles), (0, (/*@__PURE__*/$parcel$interopDefault($2087e80a80355736$exports)))(xcssStyles)) : [].concat((0, (/*@__PURE__*/$parcel$interopDefault($2087e80a80355736$exports)))(styles), [
        xcssStyles
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $9258da2743650ae3$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($00d53520b6c62aef$exports)))({}, htmlAttributes, {
        as: "button",
        ref: ref,
        testId: testId,
        type: type,
        onClick: onClick,
        backgroundColor: backgroundColor,
        padding: padding,
        paddingBlock: paddingBlock,
        paddingBlockStart: paddingBlockStart,
        paddingBlockEnd: paddingBlockEnd,
        paddingInline: paddingInline,
        paddingInlineStart: paddingInlineStart,
        paddingInlineEnd: paddingInlineEnd,
        xcss: styles,
        disabled: isDisabled
    }), children);
});
var $999e662cb1878434$export$2e2bcd8739ae039 = $999e662cb1878434$var$Pressable;



var $49fa855cea4cf8bb$var$buttonStyles = (0, $e54127128664e945$export$f6c783d06584602c)({
    display: "flex",
    width: "24px",
    height: "24px",
    padding: "space.0",
    alignItems: "center",
    justifyContent: "center",
    flex: "0 0 auto",
    background: "none",
    borderStyle: "none",
    cursor: "pointer",
    whiteSpace: "nowrap"
});
var $49fa855cea4cf8bb$var$DismissButton = function DismissButton(_ref) {
    var appearance = _ref.appearance, onClick = _ref.onClick, isBold = _ref.isBold, isExpanded = _ref.isExpanded, testId = _ref.testId;
    var ButtonIcon = (0, (/*@__PURE__*/$parcel$interopDefault($4779a16045cf7e83$exports)));
    var buttonLabel = "Dismiss";
    var size = "small";
    var buttonTestId = testId && "".concat(testId, "-dismiss");
    if (isBold) {
        ButtonIcon = isExpanded ? (0, (/*@__PURE__*/$parcel$interopDefault($d8253da1599d59ca$exports))) : (0, (/*@__PURE__*/$parcel$interopDefault($5b291e9643c5c137$exports)));
        buttonLabel = isExpanded ? "Collapse" : "Expand";
        size = "medium";
        buttonTestId = testId && "".concat(testId, "-toggle");
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $999e662cb1878434$export$2e2bcd8739ae039), {
        xcss: $49fa855cea4cf8bb$var$buttonStyles,
        onClick: onClick,
        "aria-expanded": isBold ? isExpanded : undefined,
        testId: buttonTestId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement(ButtonIcon, {
        label: buttonLabel,
        size: size,
        primaryColor: (0, $79243b2679dffa0d$export$13b42cd9d596bfe0)[appearance]
    }));
};
var $49fa855cea4cf8bb$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $dAx5m.memo)($49fa855cea4cf8bb$var$DismissButton);



var $dAx5m = parcelRequire("dAx5m");



var $dAx5m = parcelRequire("dAx5m");



function $8b05c18af5a94c0d$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $8b05c18af5a94c0d$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $8b05c18af5a94c0d$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($010d27b02d402655$exports)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $8b05c18af5a94c0d$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $8b05c18af5a94c0d$var$directionMotions = {
    proportional: {
        bottom: "translate3d(0, calc(5% + 4px), 0)",
        left: "translate3d(calc(-5% - 4px), 0, 0)",
        right: "translate3d(calc(5% + 4px), 0, 0)",
        top: "translate3d(0, calc(-5% - 4px), 0)"
    },
    constant: {
        bottom: "translate3d(0, 4px, 0)",
        left: "translate3d(-4px, 0, 0)",
        right: "translate3d(4px, 0, 0)",
        top: "translate3d(0, -4px, 0)"
    }
};
var $8b05c18af5a94c0d$var$invertedDirection = {
    top: "bottom",
    bottom: "top",
    left: "right",
    right: "left"
};
var $8b05c18af5a94c0d$export$8497679fcaaeceb = function fadeInAnimation(direction) {
    var distance = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "proportional";
    return {
        from: $8b05c18af5a94c0d$var$_objectSpread({
            opacity: 0
        }, direction !== undefined && {
            transform: $8b05c18af5a94c0d$var$directionMotions[distance][direction]
        }),
        "50%": {
            opacity: 1
        },
        to: {
            transform: direction !== undefined ? "none" : undefined
        }
    };
};
var $8b05c18af5a94c0d$export$c9190c6659ea755b = function fadeOutAnimation(direction) {
    var distance = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "proportional";
    return {
        from: {
            opacity: 1,
            transform: direction !== undefined ? "translate3d(0, 0, 0)" : undefined
        },
        to: $8b05c18af5a94c0d$var$_objectSpread({
            opacity: 0
        }, direction !== undefined && {
            transform: $8b05c18af5a94c0d$var$directionMotions[distance][direction]
        })
    };
};
/**
 * Props for controlling the behavior of the FadeIn animation
 */ /**
 * __FadeIn__
 *
 * Useful for fading in one or more elements.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motions)
 */ var $8b05c18af5a94c0d$var$FadeIn = function FadeIn(_ref) {
    var children = _ref.children, _ref$duration = _ref.duration, duration = _ref$duration === void 0 ? (0, $c98b76627f60066f$export$9424640c29bc466d) : _ref$duration, entranceDirection = _ref.entranceDirection, exitDirection = _ref.exitDirection, _ref$distance = _ref.distance, distance = _ref$distance === void 0 ? "proportional" : _ref$distance, onFinish = _ref.onFinish, isPaused = _ref.isPaused;
    var invertedEntranceDirection = entranceDirection && $8b05c18af5a94c0d$var$invertedDirection[entranceDirection];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $9ccf1f0750782710$export$2e2bcd8739ae039), {
        duration: duration,
        enteringAnimation: $8b05c18af5a94c0d$export$8497679fcaaeceb(entranceDirection, distance),
        exitingAnimation: $8b05c18af5a94c0d$export$c9190c6659ea755b(exitDirection || invertedEntranceDirection, distance),
        animationTimingFunction: function animationTimingFunction() {
            return 0, $d402285a12758595$export$c07234257a03d5e9;
        },
        onFinish: onFinish,
        isPaused: isPaused
    }, children);
};
var $8b05c18af5a94c0d$export$2e2bcd8739ae039 = $8b05c18af5a94c0d$var$FadeIn;


var $4f40fa92e92a9d11$var$expanderStyles = (0, $e54127128664e945$export$f6c783d06584602c)({
    width: "100%"
});
var $4f40fa92e92a9d11$var$containerStyles = (0, $e54127128664e945$export$f6c783d06584602c)({
    transition: "max-height 0.3s"
});
var $4f40fa92e92a9d11$var$Expander = function Expander(_ref) {
    var children = _ref.children, isExpanded = _ref.isExpanded, testId = _ref.testId;
    // Need to always render the ExpanderInternal otherwise the
    // reveal transition doesn't happen. We can't use CSS animation for
    // the the reveal because we don't know the height of the content.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $9258da2743650ae3$export$2e2bcd8739ae039), {
        xcss: $4f40fa92e92a9d11$var$containerStyles,
        style: {
            maxHeight: isExpanded ? 150 : 0,
            flex: "1 1 100%",
            minWidth: 0
        },
        "aria-hidden": !isExpanded,
        testId: testId && "".concat(testId, "-expander")
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $b85a8e496ffe66d2$export$2e2bcd8739ae039), {
        appear: true
    }, isExpanded && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $8b05c18af5a94c0d$export$2e2bcd8739ae039), null, function(props) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $9258da2743650ae3$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($00d53520b6c62aef$exports)))({
            xcss: $4f40fa92e92a9d11$var$expanderStyles
        }, props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $64b70e9dc33fefe6$export$2e2bcd8739ae039), {
            space: "space.100"
        }, children));
    })));
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$4f40fa92e92a9d11$export$2e2bcd8739ae039 = $4f40fa92e92a9d11$var$Expander;


function $958fd00e97ab6fd7$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $958fd00e97ab6fd7$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $958fd00e97ab6fd7$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($010d27b02d402655$exports)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $958fd00e97ab6fd7$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $958fd00e97ab6fd7$var$CSS_VAR_ICON_COLOR = "--flag-icon-color";
// For cases where a single word is longer than the container (e.g. filenames)
var $958fd00e97ab6fd7$var$overflowWrapStyles = (0, $e54127128664e945$export$f6c783d06584602c)({
    overflowWrap: "anywhere"
});
var $958fd00e97ab6fd7$var$descriptionStyles = (0, $jVTBW.css)({
    maxHeight: 100,
    // height is defined as 5 lines maximum by design
    overflow: "auto",
    overflowWrap: "anywhere" // For cases where a single word is longer than the container (e.g. filenames)
});
var $958fd00e97ab6fd7$var$iconWrapperStyles = (0, $jVTBW.css)({
    display: "flex",
    alignItems: "start",
    flexShrink: 0,
    color: "var(".concat($958fd00e97ab6fd7$var$CSS_VAR_ICON_COLOR, ")")
});
var $958fd00e97ab6fd7$var$flagStyles = (0, $e54127128664e945$export$f6c783d06584602c)({
    boxShadow: "elevation.shadow.overlay",
    borderRadius: "border.radius.100",
    overflow: "hidden",
    zIndex: "flag",
    width: "100%",
    transition: "background-color 200ms"
});
var $958fd00e97ab6fd7$var$flagWrapperStyles = (0, $jVTBW.css)({
    width: "100%"
});
var $958fd00e97ab6fd7$var$analyticsAttributes = {
    componentName: "flag",
    packageName: "@atlaskit/flag",
    packageVersion: "15.5.2"
};
var $958fd00e97ab6fd7$var$transitionStyles = (0, $jVTBW.css)({
    flexGrow: 1,
    transition: "gap 0.3s"
});
/**
 * __Flag__
 *
 * A flag is used for confirmations, alerts, and acknowledgments that require minimal user interaction,
 * often displayed using a flag group.
 *
 * - [Examples](https://atlassian.design/components/flag/examples)
 * - [Code](https://atlassian.design/components/flag/code)
 * - [Usage](https://atlassian.design/components/flag/usage)
 */ var $958fd00e97ab6fd7$var$Flag = function Flag(props) {
    var _props$actions = props.actions, actions = _props$actions === void 0 ? [] : _props$actions, _props$appearance = props.appearance, appearance = _props$appearance === void 0 ? (0, $df3e57924e92b86f$export$d6830277b06edd6) : _props$appearance, icon = props.icon, title = props.title, description = props.description, linkComponent = props.linkComponent, onMouseOver = props.onMouseOver, _props$onFocus = props.onFocus, onFocus = _props$onFocus === void 0 ? (0, $Bb0he.default) : _props$onFocus, onMouseOut = props.onMouseOut, _props$onBlur = props.onBlur, onBlur = _props$onBlur === void 0 ? (0, $Bb0he.default) : _props$onBlur, _props$onDismissed = props.onDismissed, onDismissedProp = _props$onDismissed === void 0 ? (0, $Bb0he.default) : _props$onDismissed, testId = props.testId, id = props.id, analyticsContext = props.analyticsContext;
    var _useFlagGroup = (0, $6982668358d0e196$export$e91ea202abb66350)(), onDismissedFromFlagGroup = _useFlagGroup.onDismissed, isDismissAllowed = _useFlagGroup.isDismissAllowed;
    var onDismissed = (0, $dAx5m.useCallback)(function(id, analyticsEvent) {
        onDismissedProp(id, analyticsEvent);
        onDismissedFromFlagGroup(id, analyticsEvent);
    }, [
        onDismissedProp,
        onDismissedFromFlagGroup
    ]);
    var _useState = (0, $dAx5m.useState)(false), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($5fdc9222475a2456$exports)))(_useState, 2), isExpanded = _useState2[0], setIsExpanded = _useState2[1];
    var onDismissedAnalytics = (0, $d0cbd00f83880f1b$export$a4687b0234b40e28)($958fd00e97ab6fd7$var$_objectSpread({
        fn: onDismissed,
        action: "dismissed",
        analyticsData: analyticsContext
    }, $958fd00e97ab6fd7$var$analyticsAttributes));
    var isBold = appearance !== (0, $df3e57924e92b86f$export$d6830277b06edd6);
    var toggleExpand = (0, $dAx5m.useCallback)(function() {
        setIsExpanded(function(previous) {
            return !previous;
        });
    }, []);
    var buttonActionCallback = (0, $dAx5m.useCallback)(function() {
        if (isDismissAllowed) onDismissedAnalytics(id);
    }, [
        onDismissedAnalytics,
        id,
        isDismissAllowed
    ]);
    (0, $dAx5m.useEffect)(function() {
        // If buttons are removed as a prop, update isExpanded to be false
        if (isBold && isExpanded && !description && !actions.length) setIsExpanded(false);
    }, [
        actions.length,
        description,
        isBold,
        isExpanded
    ]);
    var onFocusAnalytics = (0, $d0cbd00f83880f1b$export$a4687b0234b40e28)($958fd00e97ab6fd7$var$_objectSpread({
        fn: onFocus,
        action: "focused",
        analyticsData: analyticsContext
    }, $958fd00e97ab6fd7$var$analyticsAttributes));
    var onBlurAnalytics = (0, $d0cbd00f83880f1b$export$a4687b0234b40e28)($958fd00e97ab6fd7$var$_objectSpread({
        fn: onBlur,
        action: "blurred",
        analyticsData: analyticsContext
    }, $958fd00e97ab6fd7$var$analyticsAttributes));
    var autoDismissProps = {
        onMouseOver: onMouseOver,
        onFocus: onFocusAnalytics,
        onMouseOut: onMouseOut,
        onBlur: onBlurAnalytics
    };
    var textColor = (0, $79243b2679dffa0d$export$f50075b2584087f)[appearance];
    var iconColor = (0, $79243b2679dffa0d$export$7f70afe2167f8235)[appearance];
    var isDismissable = isBold || isDismissAllowed;
    var shouldRenderGap = !isBold && (description || actions.length) || isExpanded;
    return (0, $jVTBW.jsx)("div", (0, (/*@__PURE__*/$parcel$interopDefault($00d53520b6c62aef$exports)))({
        role: "alert",
        css: $958fd00e97ab6fd7$var$flagWrapperStyles,
        "data-testid": testId
    }, autoDismissProps), (0, $jVTBW.jsx)((0, $9258da2743650ae3$export$2e2bcd8739ae039), {
        backgroundColor: (0, $79243b2679dffa0d$export$59e42969c95d314)[appearance],
        padding: "space.200",
        xcss: $958fd00e97ab6fd7$var$flagStyles
    }, (0, $jVTBW.jsx)((0, $6e025698fb99d187$export$2e2bcd8739ae039), {
        alignBlock: "stretch",
        space: "space.200"
    }, (0, $jVTBW.jsx)("div", {
        css: $958fd00e97ab6fd7$var$iconWrapperStyles,
        style: (0, (/*@__PURE__*/$parcel$interopDefault($010d27b02d402655$exports)))({}, $958fd00e97ab6fd7$var$CSS_VAR_ICON_COLOR, iconColor)
    }, icon), (0, $jVTBW.jsx)("span", {
        css: $958fd00e97ab6fd7$var$transitionStyles
    }, (0, $jVTBW.jsx)((0, $64b70e9dc33fefe6$export$2e2bcd8739ae039), {
        space: shouldRenderGap ? "space.100" : "space.0" // Gap exists even when not expanded due to Expander internals always being in the DOM
    }, (0, $jVTBW.jsx)((0, $6e025698fb99d187$export$2e2bcd8739ae039), {
        alignBlock: "stretch",
        space: "space.100",
        spread: "space-between"
    }, (0, $jVTBW.jsx)((0, $9258da2743650ae3$export$2e2bcd8739ae039), {
        paddingBlockStart: "space.025",
        xcss: $958fd00e97ab6fd7$var$overflowWrapStyles
    }, (0, $jVTBW.jsx)((0, $d0445bd79201244a$export$2e2bcd8739ae039), {
        color: textColor,
        weight: "semibold"
    }, title)), isDismissable ? !(isBold && !description && !actions.length) && (0, $jVTBW.jsx)((0, $49fa855cea4cf8bb$export$2e2bcd8739ae039), {
        testId: testId,
        appearance: appearance,
        isBold: isBold,
        isExpanded: isExpanded,
        onClick: isBold ? toggleExpand : buttonActionCallback
    }) : null), (0, $jVTBW.jsx)((0, $4f40fa92e92a9d11$export$2e2bcd8739ae039), {
        isExpanded: !isBold || isExpanded,
        testId: testId
    }, description && (0, $jVTBW.jsx)("div", {
        style: {
            color: (0, $79243b2679dffa0d$export$13b42cd9d596bfe0)[appearance]
        },
        css: $958fd00e97ab6fd7$var$descriptionStyles,
        "data-testid": testId && "".concat(testId, "-description")
    }, description), (0, $jVTBW.jsx)((0, $bf9550c5df68dc91$export$2e2bcd8739ae039), {
        actions: actions,
        appearance: appearance,
        linkComponent: linkComponent,
        testId: testId
    })))))));
};
var $958fd00e97ab6fd7$export$2e2bcd8739ae039 = $958fd00e97ab6fd7$var$Flag;



var $6abb62d18d6f976d$var$packageName = "@atlaskit/flag";
var $6abb62d18d6f976d$var$packageVersion = "15.5.2";
var $6abb62d18d6f976d$export$66c3d409977b5615 = 8;
/**
 * __Auto dismiss flag__
 *
 * An auto dismiss flag is dismissed automatically after eight seconds.
 *
 * - [Examples](https://atlassian.design/components/flag/auto-dismiss-flag/examples)
 * - [Code](https://atlassian.design/components/flag/auto-dismiss-flag/code)
 */ var $6abb62d18d6f976d$var$AutoDismissFlag = function AutoDismissFlag(props) {
    var id = props.id, analyticsContext = props.analyticsContext, _props$onDismissed = props.onDismissed, onDismissedProp = _props$onDismissed === void 0 ? (0, $Bb0he.default) : _props$onDismissed;
    var autoDismissTimer = (0, $dAx5m.useRef)(null);
    var _useFlagGroup = (0, $6982668358d0e196$export$e91ea202abb66350)(), onDismissedFromFlagGroup = _useFlagGroup.onDismissed, isDismissAllowed = _useFlagGroup.isDismissAllowed;
    var onDismissed = (0, $dAx5m.useCallback)(function(id, analyticsEvent) {
        onDismissedProp(id, analyticsEvent);
        onDismissedFromFlagGroup(id, analyticsEvent);
    }, [
        onDismissedProp,
        onDismissedFromFlagGroup
    ]);
    var onDismissedAnalytics = (0, $d0cbd00f83880f1b$export$a4687b0234b40e28)({
        fn: onDismissed,
        action: "dismissed",
        analyticsData: analyticsContext,
        componentName: "flag",
        packageName: $6abb62d18d6f976d$var$packageName,
        packageVersion: $6abb62d18d6f976d$var$packageVersion
    });
    var isAutoDismissAllowed = isDismissAllowed && onDismissed;
    var dismissFlag = (0, $dAx5m.useCallback)(function() {
        if (isAutoDismissAllowed) onDismissedAnalytics(id);
    }, [
        id,
        onDismissedAnalytics,
        isAutoDismissAllowed
    ]);
    var stopAutoDismissTimer = (0, $dAx5m.useCallback)(function() {
        if (autoDismissTimer.current) {
            clearTimeout(autoDismissTimer.current);
            autoDismissTimer.current = null;
        }
    }, []);
    var startAutoDismissTimer = (0, $dAx5m.useCallback)(function() {
        if (!isAutoDismissAllowed) return;
        stopAutoDismissTimer();
        autoDismissTimer.current = window.setTimeout(dismissFlag, $6abb62d18d6f976d$export$66c3d409977b5615 * 1000);
    }, [
        dismissFlag,
        stopAutoDismissTimer,
        isAutoDismissAllowed
    ]);
    (0, $dAx5m.useEffect)(function() {
        startAutoDismissTimer();
        return stopAutoDismissTimer;
    }, [
        startAutoDismissTimer,
        stopAutoDismissTimer
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $958fd00e97ab6fd7$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($00d53520b6c62aef$exports)))({}, props, {
        onMouseOver: stopAutoDismissTimer,
        onFocus: stopAutoDismissTimer,
        onMouseOut: startAutoDismissTimer,
        onBlur: startAutoDismissTimer
    }));
};
var $6abb62d18d6f976d$export$2e2bcd8739ae039 = $6abb62d18d6f976d$var$AutoDismissFlag;


parcelRequire("jShba");
var $1UxEK = parcelRequire("1UxEK");

var $bibO8 = parcelRequire("bibO8");
parcelRequire("dAx5m");

var $5MUVm = parcelRequire("5MUVm");
var $069c2152ce62a1ae$exports = {};
"use strict";
Object.defineProperty($069c2152ce62a1ae$exports, "__esModule", {
    value: true
});
$069c2152ce62a1ae$exports.default = void 0;

var $069c2152ce62a1ae$var$_react = $069c2152ce62a1ae$var$_interopRequireDefault((parcelRequire("dAx5m")));

var $9eGJl = parcelRequire("9eGJl");
function $069c2152ce62a1ae$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $069c2152ce62a1ae$var$CheckCircleIcon = (props)=>/*#__PURE__*/ $069c2152ce62a1ae$var$_react.default.createElement($9eGJl.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle fill="currentColor" cx="12" cy="12" r="10"/><path d="M9.707 11.293a1 1 0 10-1.414 1.414l2 2a1 1 0 001.414 0l4-4a1 1 0 10-1.414-1.414L11 12.586l-1.293-1.293z" fill="inherit"/></g></svg>`
    }, props));
$069c2152ce62a1ae$var$CheckCircleIcon.displayName = "CheckCircleIcon";
var $069c2152ce62a1ae$var$_default = $069c2152ce62a1ae$var$CheckCircleIcon;
$069c2152ce62a1ae$exports.default = $069c2152ce62a1ae$var$_default;


var $3b2f2975d7be5c99$exports = {};
"use strict";
Object.defineProperty($3b2f2975d7be5c99$exports, "__esModule", {
    value: true
});
$3b2f2975d7be5c99$exports.default = void 0;

var $3b2f2975d7be5c99$var$_react = $3b2f2975d7be5c99$var$_interopRequireDefault((parcelRequire("dAx5m")));

var $9eGJl = parcelRequire("9eGJl");
function $3b2f2975d7be5c99$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $3b2f2975d7be5c99$var$WarningIcon = (props)=>/*#__PURE__*/ $3b2f2975d7be5c99$var$_react.default.createElement($9eGJl.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><path d="M12.938 4.967c-.518-.978-1.36-.974-1.876 0L3.938 18.425c-.518.978-.045 1.771 1.057 1.771h14.01c1.102 0 1.573-.797 1.057-1.771L12.938 4.967z" fill="currentColor"/><path d="M12 15a1 1 0 01-1-1V9a1 1 0 012 0v5a1 1 0 01-1 1m0 3a1 1 0 010-2 1 1 0 010 2" fill="inherit"/></g></svg>`
    }, props));
$3b2f2975d7be5c99$var$WarningIcon.displayName = "WarningIcon";
var $3b2f2975d7be5c99$var$_default = $3b2f2975d7be5c99$var$WarningIcon;
$3b2f2975d7be5c99$exports.default = $3b2f2975d7be5c99$var$_default;


var $8757f515a157a951$exports = {};
"use strict";
Object.defineProperty($8757f515a157a951$exports, "__esModule", {
    value: true
});
$8757f515a157a951$exports.default = void 0;

var $8757f515a157a951$var$_react = $8757f515a157a951$var$_interopRequireDefault((parcelRequire("dAx5m")));

var $9eGJl = parcelRequire("9eGJl");
function $8757f515a157a951$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $8757f515a157a951$var$ErrorIcon = (props)=>/*#__PURE__*/ $8757f515a157a951$var$_react.default.createElement($9eGJl.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><path d="M13.416 4.417a2.002 2.002 0 00-2.832 0l-6.168 6.167a2.002 2.002 0 000 2.833l6.168 6.167a2.002 2.002 0 002.832 0l6.168-6.167a2.002 2.002 0 000-2.833l-6.168-6.167z" fill="currentColor"/><path d="M12 14a1 1 0 01-1-1V8a1 1 0 012 0v5a1 1 0 01-1 1m0 3a1 1 0 010-2 1 1 0 010 2" fill="inherit"/></g></svg>`
    }, props));
$8757f515a157a951$var$ErrorIcon.displayName = "ErrorIcon";
var $8757f515a157a951$var$_default = $8757f515a157a951$var$ErrorIcon;
$8757f515a157a951$exports.default = $8757f515a157a951$var$_default;



var $gbKg7 = parcelRequire("gbKg7");
const $fd176724596f3fbf$export$cf4ca2421201805b = {
    error: /*#__PURE__*/ (0, $bibO8.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8757f515a157a951$exports))), {
        label: "",
        primaryColor: (0, $gbKg7.default)("color.icon.danger", (0, $5MUVm).R300)
    }),
    warning: /*#__PURE__*/ (0, $bibO8.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3b2f2975d7be5c99$exports))), {
        label: "",
        primaryColor: (0, $gbKg7.default)("color.icon.warning", (0, $5MUVm).Y300)
    }),
    default: /*#__PURE__*/ (0, $bibO8.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($069c2152ce62a1ae$exports))), {
        label: "",
        primaryColor: (0, $gbKg7.default)("color.icon.success", (0, $5MUVm).G300)
    })
};
const $fd176724596f3fbf$export$672f92b0d52b7cfe = (type = "normal")=>$fd176724596f3fbf$export$cf4ca2421201805b[type] || $fd176724596f3fbf$export$cf4ca2421201805b.default;



var $8fyf0 = parcelRequire("8fyf0");

var $bibO8 = parcelRequire("bibO8");
parcelRequire("dAx5m");

var $55TWT = parcelRequire("55TWT");

parcelRequire("jShba");
var $1UxEK = parcelRequire("1UxEK");

const $fcf30d599bafd063$var$GenericErrorFlag = (props)=>/*#__PURE__*/ (0, $bibO8.jsx)((0, $6abb62d18d6f976d$export$2e2bcd8739ae039), {
        ...props,
        icon: (0, $fd176724596f3fbf$export$cf4ca2421201805b).error,
        title: /*#__PURE__*/ (0, $bibO8.jsx)((0, $55TWT.default), {
            id: "ptc-directory.profile.flags.generic-error-flag.title",
            defaultMessage: "Something went wrong",
            description: "Title of flag shown when there was a generic error"
        }),
        description: /*#__PURE__*/ (0, $bibO8.jsx)((0, $55TWT.default), {
            id: "ptc-directory.profile.flags.generic-error-flag.description",
            defaultMessage: "Refresh the page and try again. If this keeps happening, let us know using the link below.",
            description: "Body of flag shown when there was a generic error"
        }),
        actions: [
            {
                content: /*#__PURE__*/ (0, $bibO8.jsx)((0, $1UxEK.default), {
                    href: "https://getsupport.atlassian.com/",
                    target: "_blank",
                    children: /*#__PURE__*/ (0, $bibO8.jsx)((0, $55TWT.default), {
                        id: "ptc-directory.profile.flags.generic-error-flag.link",
                        defaultMessage: "Visit Atlassian support",
                        description: "Link text in flag shown when there was a generic error"
                    })
                })
            }
        ]
    });
var $fcf30d599bafd063$export$2e2bcd8739ae039 = $fcf30d599bafd063$var$GenericErrorFlag;


const $cca71db056699a23$var$Flags = ({ flags: flags, removeFlag: removeFlag })=>{
    const flagsInGroup = flags.map((flagProps, index)=>{
        const { id: id, type: type, icon: icon, appearance: appearance, title: title, description: description, links: links = [], actions: actions } = flagProps;
        // id alone doesn't guarantee uniqueness, as 'flags'/notifications with the same id
        // may be added multiple times
        const key = `${id}_${index}`;
        if (typeof id === "string" && id.startsWith((0, $8fyf0.GENERIC_ERROR_FLAG_ID))) return /*#__PURE__*/ (0, $bibO8.jsx)((0, $fcf30d599bafd063$export$2e2bcd8739ae039), {
            id: id
        }, key + "_GENERIC");
        // we cannot get props type of AutoDismissFlag so we have to use any here
        // tslint:disable-next-line:no-any
        const flagComponentProps = {
            id: id,
            icon: icon || (0, $fd176724596f3fbf$export$672f92b0d52b7cfe)(type || appearance),
            title: title,
            description: description,
            appearance: appearance,
            actions: actions || links.map(({ text: text, ...props })=>({
                    content: /*#__PURE__*/ (0, $bibO8.jsx)((0, $1UxEK.default), {
                        ...props,
                        children: text
                    })
                }))
        };
        return /*#__PURE__*/ (0, $bibO8.jsx)((0, $6abb62d18d6f976d$export$2e2bcd8739ae039), {
            ...flagComponentProps
        }, key);
    });
    return /*#__PURE__*/ (0, $bibO8.jsx)((0, $6982668358d0e196$export$2e2bcd8739ae039), {
        onDismissed: removeFlag,
        children: flagsInGroup
    });
};
var $cca71db056699a23$export$2e2bcd8739ae039 = $cca71db056699a23$var$Flags;


parcelRequire("jShba");
var $3kXiv = parcelRequire("3kXiv");
const $e09f8ba83d2b30a4$var$mapActionCreators = {
    removeFlag: $3kXiv.removeFlag
};
const $e09f8ba83d2b30a4$var$mapStateToProps = ({ flags: flags })=>({
        flags: flags.flags
    });
var $e09f8ba83d2b30a4$export$2e2bcd8739ae039 = (0, $7PWYP.default)($e09f8ba83d2b30a4$var$mapStateToProps, $e09f8ba83d2b30a4$var$mapActionCreators)((0, $cca71db056699a23$export$2e2bcd8739ae039));





var $bibO8 = parcelRequire("bibO8");

var $dAx5m = parcelRequire("dAx5m");

var $55TWT = parcelRequire("55TWT");
var $dZHnD = parcelRequire("dZHnD");



var $dAx5m = parcelRequire("dAx5m");
var $aa901ea360f5d73e$exports = {};
"use strict";
Object.defineProperty($aa901ea360f5d73e$exports, "__esModule", {
    value: true
});
$aa901ea360f5d73e$exports.default = void 0;

var $aa901ea360f5d73e$var$_react = $aa901ea360f5d73e$var$_interopRequireDefault((parcelRequire("dAx5m")));


var $aa901ea360f5d73e$var$_questionCircle = $aa901ea360f5d73e$var$_interopRequireDefault((parcelRequire("kDlRl")));
function $aa901ea360f5d73e$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $aa901ea360f5d73e$var$QuestionCircleIcon = (props)=>/*#__PURE__*/ $aa901ea360f5d73e$var$_react.default.createElement($2894c4a395f277dd$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="10" fill="currentcolor"/><circle cx="12" cy="18" r="1" fill="inherit"/><path fill="inherit" d="M15.89 9.05a3.98 3.98 0 0 0-2.957-2.942C10.321 5.514 8.017 7.446 8 9.95l.005.147a.99.99 0 0 0 .982.904c.552 0 1-.447 1.002-.998a2.004 2.004 0 0 1 4.007-.002c0 1.102-.898 2-2.003 2H12a1 1 0 0 0-1 .987v2.014a1.001 1.001 0 0 0 2.004 0v-.782c0-.217.145-.399.35-.472A3.99 3.99 0 0 0 15.89 9.05"/></g></svg>`
    }, props, {
        newIcon: $aa901ea360f5d73e$var$_questionCircle.default
    }));
$aa901ea360f5d73e$var$QuestionCircleIcon.displayName = "QuestionCircleIcon";
var $aa901ea360f5d73e$var$_default = $aa901ea360f5d73e$exports.default = $aa901ea360f5d73e$var$QuestionCircleIcon;



/** @jsx jsx */ 
var $jVTBW = parcelRequire("jVTBW");
var $c52a2d79485eca14$var$badgeContainerStyles = (0, $jVTBW.css)({
    position: "absolute",
    insetBlockStart: "var(--ds-space-negative-050, -4px)",
    insetInlineEnd: "var(--ds-space-negative-025, -2px)",
    pointerEvents: "none"
});
var $c52a2d79485eca14$var$containerStyles = (0, $jVTBW.css)({
    position: "relative"
});
var $c52a2d79485eca14$export$f710265eb5a003da = function BadgeContainer(props) {
    var badgeId = props.id, Badge = props.badge, children = props.children, role = props.role;
    return (0, $jVTBW.jsx)("div", {
        css: $c52a2d79485eca14$var$containerStyles,
        role: role
    }, children, (0, $jVTBW.jsx)("div", {
        css: $c52a2d79485eca14$var$badgeContainerStyles,
        id: badgeId,
        "aria-hidden": true
    }, (0, $jVTBW.jsx)(Badge, null)));
};



var $01f2354b4aa48c4d$var$_excluded = [
    "badge",
    "tooltip"
];
var $01f2354b4aa48c4d$var$HELP_NOTIFICATION_BADGE_ID = "atlassian-navigation-help-notification-count";
var $01f2354b4aa48c4d$export$1be7516c0280bee8 = /*#__PURE__*/ (0, $dAx5m.forwardRef)(function(props, ref) {
    var badge = props.badge, tooltip = props.tooltip, iconButtonProps = (0, (/*@__PURE__*/$parcel$interopDefault($cada364311d44bd0$exports)))(props, $01f2354b4aa48c4d$var$_excluded);
    var _useTheme = (0, $9afc2d28bb10b801$export$93d4e7f90805808f)(), navigation = _useTheme.mode.navigation;
    var button = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $3f2c48a613a1b8b8$export$c25acd513dcc8062), (0, (/*@__PURE__*/$parcel$interopDefault($147dc3434bd55d1d$exports)))({
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aa901ea360f5d73e$exports))), {
            label: typeof tooltip === "string" ? tooltip : "Help Icon",
            secondaryColor: navigation.backgroundColor
        }),
        ref: ref,
        tooltip: tooltip
    }, iconButtonProps));
    return badge ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $c52a2d79485eca14$export$f710265eb5a003da), {
        id: $01f2354b4aa48c4d$var$HELP_NOTIFICATION_BADGE_ID,
        badge: badge,
        role: "listitem"
    }, button) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement("div", {
        role: "listitem"
    }, button);
});
var $01f2354b4aa48c4d$export$2e2bcd8739ae039 = $01f2354b4aa48c4d$export$1be7516c0280bee8;



var $g061O = parcelRequire("g061O");
var $10AFn = parcelRequire("10AFn");
var $alMln = parcelRequire("alMln");

var $7vqkt = parcelRequire("7vqkt");

var $3B7Hp = parcelRequire("3B7Hp");
parcelRequire("jShba");
var $fjOHq = parcelRequire("fjOHq");
var $grRLU = parcelRequire("grRLU");
const $fd766a90368731bc$var$HelpMenuPopup = (props)=>{
    const { formatMessage: formatMessage } = (0, $dZHnD.default)();
    const analytics = (0, $grRLU.default)();
    const [isHelpOpen, setHelpOpen] = (0, $dAx5m.useState)(false);
    const closeHelpMenu = ()=>setHelpOpen(false);
    const toggleHelpOpen = ()=>{
        setHelpOpen(!isHelpOpen);
        if (!isHelpOpen) analytics.pushTrackEvent({
            source: (0, $fjOHq.AnalyticsEventSource).USER_MENU,
            actionSubject: (0, $fjOHq.AnalyticsEventSubjects).MENU,
            action: (0, $fjOHq.AnalyticsEventActions).OPENED,
            actionSubjectId: "helpMenu"
        });
    };
    return /*#__PURE__*/ (0, $bibO8.jsx)((0, $7vqkt.default), {
        placement: "bottom-end",
        rootBoundary: "document",
        onClose: closeHelpMenu,
        trigger: (triggerProps)=>/*#__PURE__*/ (0, $bibO8.jsx)((0, $01f2354b4aa48c4d$export$1be7516c0280bee8), {
                tooltip: formatMessage({
                    id: "ptc-directory.help-menu.title.help",
                    defaultMessage: "Help",
                    description: "Title for the HELP menu item group incl. link to help and support documentation"
                }),
                onClick: toggleHelpOpen,
                ...triggerProps
            }),
        content: ()=>/*#__PURE__*/ (0, $bibO8.jsx)($fd766a90368731bc$var$HelpMenuContent, {
                ...props
            }),
        isOpen: isHelpOpen
    });
};
const $fd766a90368731bc$var$HelpMenuContent = ()=>{
    const { formatMessage: formatMessage } = (0, $dZHnD.default)();
    return /*#__PURE__*/ (0, $bibO8.jsx)("div", {
        "data-testid": "help-menu-content",
        children: /*#__PURE__*/ (0, $bibO8.jsxs)((0, $10AFn.default), {
            children: [
                /*#__PURE__*/ (0, $bibO8.jsx)((0, $alMln.default), {
                    title: formatMessage({
                        id: "ptc-directory.help-menu.title.help",
                        defaultMessage: "Help",
                        description: "Title for the HELP menu item group incl. link to help and support documentation"
                    }),
                    children: /*#__PURE__*/ (0, $bibO8.jsx)((0, $g061O.default), {
                        href: "https://support.atlassian.com",
                        target: "_blank",
                        rel: "noopener",
                        children: /*#__PURE__*/ (0, $bibO8.jsx)((0, $55TWT.default), {
                            id: "ptc-directory.help-menu.item.support.user.settings.app",
                            defaultMessage: "Support",
                            description: "Link to the support page"
                        })
                    })
                }),
                /*#__PURE__*/ (0, $bibO8.jsx)((0, $alMln.default), {
                    title: formatMessage({
                        id: "ptc-directory.help-menu.title.legal",
                        defaultMessage: "Legal",
                        description: "Title for the LEGAL menu item group incl. Terms of service and Privacy policy"
                    }),
                    children: /*#__PURE__*/ (0, $bibO8.jsxs)((0, $alMln.default), {
                        children: [
                            /*#__PURE__*/ (0, $bibO8.jsx)((0, $g061O.default), {
                                href: (0, $3B7Hp.getWACLinks)().cloudTermsOfService,
                                target: "_blank",
                                rel: "noopener",
                                children: /*#__PURE__*/ (0, $bibO8.jsx)((0, $55TWT.default), {
                                    id: "ptc-directory.help-menu.item.terms-of-service",
                                    defaultMessage: "Terms of service",
                                    description: "Link that opens the Atlassian Customer Agreement"
                                })
                            }),
                            /*#__PURE__*/ (0, $bibO8.jsx)((0, $g061O.default), {
                                href: (0, $3B7Hp.getWACLinks)().privacyPolicy,
                                target: "_blank",
                                rel: "noopener",
                                children: /*#__PURE__*/ (0, $bibO8.jsx)((0, $55TWT.default), {
                                    id: "ptc-directory.help-menu.item.privacy-policy",
                                    defaultMessage: "Privacy policy",
                                    description: "Link that opens the Atlassian Privacy Policy"
                                })
                            }),
                            /*#__PURE__*/ (0, $bibO8.jsx)((0, $g061O.default), {
                                href: (0, $3B7Hp.getWACLinks)().userNotice,
                                target: "_blank",
                                rel: "noopener",
                                children: /*#__PURE__*/ (0, $bibO8.jsx)((0, $55TWT.default), {
                                    id: "ptc-directory.help-menu.item.user-notice",
                                    defaultMessage: "User notice",
                                    description: "Link that opens the Atlassian User Notice"
                                })
                            })
                        ]
                    })
                })
            ]
        })
    });
};
var $fd766a90368731bc$export$2e2bcd8739ae039 = $fd766a90368731bc$var$HelpMenuPopup;




parcelRequire("fYdPZ");
var $cZlBJ = parcelRequire("cZlBJ");

var $bibO8 = parcelRequire("bibO8");

var $dAx5m = parcelRequire("dAx5m");

var $dZHnD = parcelRequire("dZHnD");

var $ku6eE = parcelRequire("ku6eE");

var $1xtOA = parcelRequire("1xtOA");

var $kVYWy = parcelRequire("kVYWy");

var $c2AoJ = parcelRequire("c2AoJ");

var $e3Gk1 = parcelRequire("e3Gk1");

var $4huf8 = parcelRequire("4huf8");

var $9HWAT = parcelRequire("9HWAT");

var $dAx5m = parcelRequire("dAx5m");


var $2nkDG = parcelRequire("2nkDG");

var $8KgLq = parcelRequire("8KgLq");

var $bCfF5 = parcelRequire("bCfF5");

var $jXZjr = parcelRequire("jXZjr");

var $3R0Tv = parcelRequire("3R0Tv");
var $77692fee204da9b8$export$2e2bcd8739ae039 = function(product) {
    (0, $3R0Tv.loadAtlassianSwitcher)();
    if (product === (0, $jXZjr.Product).JIRA) return (0, $3R0Tv.loadJiraSwitcher)();
    if (product === (0, $jXZjr.Product).CONFLUENCE) return (0, $3R0Tv.loadConfluenceSwitcher)();
    return (0, $3R0Tv.loadGenericSwitcher)();
};


var $e1f7918cca43a3d0$export$f003ab04b0b3c00e = function prefetch(props) {
    var cloudId = props.cloudId, product = props.product;
    (0, $77692fee204da9b8$export$2e2bcd8739ae039)(product);
    (0, $8KgLq.prefetchAvailableProducts)({
        cloudId: cloudId,
        product: product
    });
    (0, $bCfF5.prefetchJoinableSites)(props.joinableSitesDataProvider);
    if (cloudId) (0, $2nkDG.prefetchAll)({
        cloudId: cloudId
    });
};



var $4vSc6 = parcelRequire("4vSc6");

var $5QmqT = parcelRequire("5QmqT");
var $i8FXL = parcelRequire("i8FXL");
var $3FJlW = parcelRequire("3FJlW");
var $kyTiB = parcelRequire("kyTiB");

var $22ND8 = parcelRequire("22ND8");
function $df0c41c95bca5417$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($e3Gk1)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($c2AoJ)))(t, $df0c41c95bca5417$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($e3Gk1)))(t).constructor) : o.apply(t, e));
}
function $df0c41c95bca5417$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($df0c41c95bca5417$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $df0c41c95bca5417$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $df0c41c95bca5417$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $df0c41c95bca5417$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($9HWAT)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $df0c41c95bca5417$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $df0c41c95bca5417$var$THROTTLE_EXPIRES = 60000; // 60 seconds
var $df0c41c95bca5417$var$THROTTLE_OPTIONS = {
    leading: true,
    trailing: false
};
var $df0c41c95bca5417$var$TRIGGER_CONTEXT = $df0c41c95bca5417$var$_objectSpread({
    componentName: (0, $5QmqT.TRIGGER_COMPONENT)
}, (0, $22ND8.default));
var $df0c41c95bca5417$var$PrefetchTrigger = /*#__PURE__*/ function(_React$Component) {
    function PrefetchTrigger() {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($1xtOA)))(this, PrefetchTrigger);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = $df0c41c95bca5417$var$_callSuper(this, PrefetchTrigger, [].concat(args));
        (0, (/*@__PURE__*/$parcel$interopDefault($9HWAT)))(_this, "fireOperationalEvent", function(payload) {
            if (_this.props.createAnalyticsEvent) _this.props.createAnalyticsEvent($df0c41c95bca5417$var$_objectSpread({
                eventType: (0, $3FJlW.OPERATIONAL_EVENT_TYPE),
                actionSubject: (0, $5QmqT.TRIGGER_SUBJECT)
            }, payload)).fire((0, $5QmqT.NAVIGATION_CHANNEL));
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($9HWAT)))(_this, "triggerPrefetch", (0, (/*@__PURE__*/$parcel$interopDefault($30c0045f222c0b2e$exports)))(function() {
            (0, $e1f7918cca43a3d0$export$f003ab04b0b3c00e)(_this.props);
            _this.fireOperationalEvent({
                action: "triggered"
            });
        }, $df0c41c95bca5417$var$THROTTLE_EXPIRES, $df0c41c95bca5417$var$THROTTLE_OPTIONS));
        (0, (/*@__PURE__*/$parcel$interopDefault($9HWAT)))(_this, "handleMouseEnter", function() {
            _this.triggerPrefetch();
            _this.lastEnteredAt = (0, $4vSc6.performanceNow)();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($9HWAT)))(_this, "handleMouseClick", function() {
            if (_this.lastEnteredAt) {
                var hoverToClick = Math.round((0, $4vSc6.performanceNow)() - _this.lastEnteredAt);
                _this.fireOperationalEvent({
                    action: "clicked",
                    attributes: {
                        hoverToClick: hoverToClick
                    }
                });
            }
        });
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($4huf8)))(PrefetchTrigger, _React$Component);
    return (0, (/*@__PURE__*/$parcel$interopDefault($kVYWy)))(PrefetchTrigger, [
        {
            key: "render",
            value: function render() {
                var _this$props = this.props, children = _this$props.children, _this$props$Container = _this$props.Container, Container = _this$props$Container === void 0 ? "div" : _this$props$Container;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement(Container, {
                    onFocus: this.handleMouseEnter,
                    onMouseEnter: this.handleMouseEnter,
                    onClick: this.handleMouseClick
                }, children);
            }
        }
    ]);
}((0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).Component);
var $df0c41c95bca5417$var$PrefetchTriggerWithEvents = (0, $kyTiB.default)()($df0c41c95bca5417$var$PrefetchTrigger);
var $df0c41c95bca5417$export$2e2bcd8739ae039 = function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $i8FXL.NavigationAnalyticsContext), {
        data: $df0c41c95bca5417$var$TRIGGER_CONTEXT
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement($df0c41c95bca5417$var$PrefetchTriggerWithEvents, props));
};


var $3R0Tv = parcelRequire("3R0Tv");



var $dAx5m = parcelRequire("dAx5m");
var $43580b1f41443228$exports = {};
"use strict";
Object.defineProperty($43580b1f41443228$exports, "__esModule", {
    value: true
});
$43580b1f41443228$exports.default = void 0;

var $43580b1f41443228$var$_react = $43580b1f41443228$var$_interopRequireDefault((parcelRequire("dAx5m")));


var $43580b1f41443228$var$_appSwitcher = $43580b1f41443228$var$_interopRequireDefault((parcelRequire("3VCTs")));
function $43580b1f41443228$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $43580b1f41443228$var$AppSwitcherIcon = (props)=>/*#__PURE__*/ $43580b1f41443228$var$_react.default.createElement($2894c4a395f277dd$export$3cfb73f70dfca966, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M4 5.01C4 4.451 4.443 4 5.01 4h1.98C7.549 4 8 4.443 8 5.01v1.98C8 7.549 7.557 8 6.99 8H5.01C4.451 8 4 7.557 4 6.99zm0 6c0-.558.443-1.01 1.01-1.01h1.98c.558 0 1.01.443 1.01 1.01v1.98C8 13.549 7.557 14 6.99 14H5.01C4.451 14 4 13.557 4 12.99zm6-6c0-.558.443-1.01 1.01-1.01h1.98c.558 0 1.01.443 1.01 1.01v1.98C14 7.549 13.557 8 12.99 8h-1.98C10.451 8 10 7.557 10 6.99zm0 6c0-.558.443-1.01 1.01-1.01h1.98c.558 0 1.01.443 1.01 1.01v1.98c0 .558-.443 1.01-1.01 1.01h-1.98c-.558 0-1.01-.443-1.01-1.01zm6-6c0-.558.443-1.01 1.01-1.01h1.98c.558 0 1.01.443 1.01 1.01v1.98C20 7.549 19.557 8 18.99 8h-1.98C16.451 8 16 7.557 16 6.99zm0 6c0-.558.443-1.01 1.01-1.01h1.98c.558 0 1.01.443 1.01 1.01v1.98c0 .558-.443 1.01-1.01 1.01h-1.98c-.558 0-1.01-.443-1.01-1.01zm-12 6c0-.558.443-1.01 1.01-1.01h1.98c.558 0 1.01.443 1.01 1.01v1.98C8 19.549 7.557 20 6.99 20H5.01C4.451 20 4 19.557 4 18.99zm6 0c0-.558.443-1.01 1.01-1.01h1.98c.558 0 1.01.443 1.01 1.01v1.98c0 .558-.443 1.01-1.01 1.01h-1.98c-.558 0-1.01-.443-1.01-1.01zm6 0c0-.558.443-1.01 1.01-1.01h1.98c.558 0 1.01.443 1.01 1.01v1.98c0 .558-.443 1.01-1.01 1.01h-1.98c-.558 0-1.01-.443-1.01-1.01z"/></svg>`
    }, props, {
        newIcon: $43580b1f41443228$var$_appSwitcher.default
    }));
$43580b1f41443228$var$AppSwitcherIcon.displayName = "AppSwitcherIcon";
var $43580b1f41443228$var$_default = $43580b1f41443228$exports.default = $43580b1f41443228$var$AppSwitcherIcon;



var $8c830ea895f999ba$var$_excluded = [
    "tooltip"
];
var $8c830ea895f999ba$export$9923361bd43fa030 = /*#__PURE__*/ (0, $dAx5m.forwardRef)(function(props, ref) {
    var tooltip = props.tooltip, iconButtonProps = (0, (/*@__PURE__*/$parcel$interopDefault($cada364311d44bd0$exports)))(props, $8c830ea895f999ba$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $3f2c48a613a1b8b8$export$c25acd513dcc8062), (0, (/*@__PURE__*/$parcel$interopDefault($147dc3434bd55d1d$exports)))({
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($43580b1f41443228$exports))), {
            label: typeof tooltip === "string" ? tooltip : "Appswitcher Icon"
        }),
        tooltip: tooltip,
        ref: ref
    }, iconButtonProps));
});
var // exists only to extract props
// eslint-disable-next-line @repo/internal/react/use-noop
$8c830ea895f999ba$export$2e2bcd8739ae039 = function(props) {};



var $7vqkt = parcelRequire("7vqkt");

var $9nAUV = parcelRequire("9nAUV");

var $2c9To = parcelRequire("2c9To");

var $7hJEL = parcelRequire("7hJEL");

var $dAx5m = parcelRequire("dAx5m");

var $dHPoE = parcelRequire("dHPoE");
var $7215130d741fbd54$export$beeb0b96f7122efa = /*#__PURE__*/ function(ExternalModuleName) {
    ExternalModuleName["React"] = "react";
    ExternalModuleName["ReactDOM"] = "react-dom";
    ExternalModuleName["ReactIntlNext"] = "react-intl-next";
    ExternalModuleName["EmotionReact"] = "@emotion/react";
    ExternalModuleName["FeatureGateJsClientPublic"] = "@atlaskit/feature-gate-js-client";
    ExternalModuleName["AnalyticsContext"] = "@atlaskit/analytics-next-stable-react-context";
    return ExternalModuleName;
}({});
var $7215130d741fbd54$export$a80387b071fd4173 = /*#__PURE__*/ function(PluginName) {
    PluginName["AppSwitcher"] = "app-switcher";
    PluginName["PostOffice"] = "post-office";
    return PluginName;
}({}); /** The importmap standard is defined here: https://github.com/WICG/import-maps */ 


var $50503f5ef640dbae$export$5672934650c3eabe = [
    "latest",
    "stable"
];
var $50503f5ef640dbae$export$f843c3d9ea97ac7a = [
    {
        name: (0, $7215130d741fbd54$export$beeb0b96f7122efa).React
    },
    {
        name: (0, $7215130d741fbd54$export$beeb0b96f7122efa).ReactDOM
    },
    {
        name: (0, $7215130d741fbd54$export$beeb0b96f7122efa).ReactIntlNext
    },
    {
        name: (0, $7215130d741fbd54$export$beeb0b96f7122efa).EmotionReact
    }
];



var $95c1a5f2fa2f5ceb$var$MODULE_NAME = "@atlassian/app-switcher-remote-module";
var $95c1a5f2fa2f5ceb$var$MODULE_URI_STG = "https://remote-app-switcher.stg-east.frontend.public.atl-paas.net/";
var $95c1a5f2fa2f5ceb$var$MODULE_URI_PROD = "https://remote-app-switcher.prod-east.frontend.public.atl-paas.net/";
var $95c1a5f2fa2f5ceb$var$MODULE_URI_STG_FEDM_EAST = "https://remote-app-switcher.stg.frontend.cdn.atlassian-us-gov-mod.com/";
var $95c1a5f2fa2f5ceb$var$MODULE_URI_PROD_FEDM_EAST = "https://remote-app-switcher.frontend.cdn.atlassian-us-gov-mod.com/";
var $95c1a5f2fa2f5ceb$var$RemoteSwitcherPlugin = /*#__PURE__*/ function() {
    function RemoteSwitcherPlugin(dimensions, config) {
        var _this = this;
        (0, (/*@__PURE__*/$parcel$interopDefault($9nAUV)))(this, RemoteSwitcherPlugin);
        (0, (/*@__PURE__*/$parcel$interopDefault($7hJEL)))(this, "_manifestMap", new Map([
            [
                "local",
                new Map([
                    [
                        "latest",
                        {
                            moduleName: $95c1a5f2fa2f5ceb$var$MODULE_NAME,
                            moduleUri: "http://localhost:9001/",
                            externals: (0, $50503f5ef640dbae$export$f843c3d9ea97ac7a)
                        }
                    ]
                ])
            ],
            [
                "staging",
                new Map([
                    [
                        "latest",
                        {
                            moduleName: $95c1a5f2fa2f5ceb$var$MODULE_NAME,
                            moduleUri: $95c1a5f2fa2f5ceb$var$MODULE_URI_STG,
                            externals: (0, $50503f5ef640dbae$export$f843c3d9ea97ac7a)
                        }
                    ],
                    [
                        "stable",
                        {
                            moduleName: $95c1a5f2fa2f5ceb$var$MODULE_NAME,
                            moduleUri: $95c1a5f2fa2f5ceb$var$MODULE_URI_STG,
                            externals: (0, $50503f5ef640dbae$export$f843c3d9ea97ac7a)
                        }
                    ]
                ])
            ],
            [
                "production",
                new Map([
                    [
                        "latest",
                        {
                            moduleName: $95c1a5f2fa2f5ceb$var$MODULE_NAME,
                            moduleUri: $95c1a5f2fa2f5ceb$var$MODULE_URI_PROD,
                            externals: (0, $50503f5ef640dbae$export$f843c3d9ea97ac7a)
                        }
                    ],
                    [
                        "stable",
                        {
                            moduleName: $95c1a5f2fa2f5ceb$var$MODULE_NAME,
                            moduleUri: $95c1a5f2fa2f5ceb$var$MODULE_URI_PROD,
                            externals: (0, $50503f5ef640dbae$export$f843c3d9ea97ac7a)
                        }
                    ]
                ])
            ],
            [
                "stg-fedm-east",
                new Map([
                    [
                        "latest",
                        {
                            moduleName: $95c1a5f2fa2f5ceb$var$MODULE_NAME,
                            moduleUri: $95c1a5f2fa2f5ceb$var$MODULE_URI_STG_FEDM_EAST,
                            externals: (0, $50503f5ef640dbae$export$f843c3d9ea97ac7a)
                        }
                    ],
                    [
                        "stable",
                        {
                            moduleName: $95c1a5f2fa2f5ceb$var$MODULE_NAME,
                            moduleUri: $95c1a5f2fa2f5ceb$var$MODULE_URI_STG_FEDM_EAST,
                            externals: (0, $50503f5ef640dbae$export$f843c3d9ea97ac7a)
                        }
                    ]
                ])
            ],
            [
                "prod-fedm-east",
                new Map([
                    [
                        "latest",
                        {
                            moduleName: $95c1a5f2fa2f5ceb$var$MODULE_NAME,
                            moduleUri: $95c1a5f2fa2f5ceb$var$MODULE_URI_PROD_FEDM_EAST,
                            externals: (0, $50503f5ef640dbae$export$f843c3d9ea97ac7a)
                        }
                    ],
                    [
                        "stable",
                        {
                            moduleName: $95c1a5f2fa2f5ceb$var$MODULE_NAME,
                            moduleUri: $95c1a5f2fa2f5ceb$var$MODULE_URI_PROD_FEDM_EAST,
                            externals: (0, $50503f5ef640dbae$export$f843c3d9ea97ac7a)
                        }
                    ]
                ])
            ]
        ]));
        /**
     * This is optional and when defined can be used to override the logic for creating the moduleUri.
     * If it isn't defined or passed in then we will use the moduleUri from the manifestMap as per the defined dimensions.
     *
     * @param uri
     * @param variant
     * @param computeHash
     */ (0, (/*@__PURE__*/$parcel$interopDefault($7hJEL)))(this, "moduleUriMapper", (0, $dHPoE.default)(function(uri) {
            var variant = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "latest";
            var computeHash = arguments.length > 2 ? arguments[2] : undefined;
            // We want to hash the major version of React installed, alongside the chosen variant
            var hashedDependencies = [
                "react",
                "react-dom"
            ];
            var hashedValues = hashedDependencies.reduce(function(acc, dep) {
                return acc.concat([
                    {
                        name: dep,
                        version: (0, $dAx5m.version).split(".")[0]
                    }
                ]);
            }, []);
            var hash = computeHash(variant, hashedValues);
            return "".concat(uri).concat(hash, ".js");
        }));
        this._dimensions = dimensions;
        // allow either of these config options to be overridden
        if (config) {
            if (config.manifestMap) this._manifestMap = config.manifestMap;
            if ("moduleUriMapper" in config) this.moduleUriMapper = config.moduleUriMapper;
        }
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($2c9To)))(RemoteSwitcherPlugin, [
        {
            key: "bifrostOverrideKey",
            get: function get() {
                return "remote-app-switcher-bifrost-override";
            }
        },
        {
            key: "dimensions",
            get: function get() {
                return this._dimensions;
            }
        },
        {
            key: "manifestMap",
            get: function get() {
                return this._manifestMap;
            }
        },
        {
            key: "name",
            get: function get() {
                return (0, $7215130d741fbd54$export$a80387b071fd4173).AppSwitcher;
            }
        }
    ]);
}();
var $95c1a5f2fa2f5ceb$export$2e2bcd8739ae039 = $95c1a5f2fa2f5ceb$var$RemoteSwitcherPlugin;


var $e4a0920c6cdbec99$exports = {};
function $e4a0920c6cdbec99$var$_extends() {
    return $e4a0920c6cdbec99$exports = $e4a0920c6cdbec99$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $e4a0920c6cdbec99$exports.__esModule = true, $e4a0920c6cdbec99$exports["default"] = $e4a0920c6cdbec99$exports, $e4a0920c6cdbec99$var$_extends.apply(null, arguments);
}
$e4a0920c6cdbec99$exports = $e4a0920c6cdbec99$var$_extends, $e4a0920c6cdbec99$exports.__esModule = true, $e4a0920c6cdbec99$exports["default"] = $e4a0920c6cdbec99$exports;



var $907WG = parcelRequire("907WG");

var $ldcUZ = parcelRequire("ldcUZ");

var $dAx5m = parcelRequire("dAx5m");

var $tWuif = parcelRequire("tWuif");
var $cdd13f37d92964d6$exports = {};
var $23ecd6aaf5e2d853$exports = {};

var $8qimH = parcelRequire("8qimH");
function $23ecd6aaf5e2d853$var$_arrayWithoutHoles(r) {
    if (Array.isArray(r)) return $8qimH(r);
}
$23ecd6aaf5e2d853$exports = $23ecd6aaf5e2d853$var$_arrayWithoutHoles, $23ecd6aaf5e2d853$exports.__esModule = true, $23ecd6aaf5e2d853$exports["default"] = $23ecd6aaf5e2d853$exports;


var $804224c7a65a7d35$exports = {};
function $804224c7a65a7d35$var$_iterableToArray(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
$804224c7a65a7d35$exports = $804224c7a65a7d35$var$_iterableToArray, $804224c7a65a7d35$exports.__esModule = true, $804224c7a65a7d35$exports["default"] = $804224c7a65a7d35$exports;



var $4TVTA = parcelRequire("4TVTA");
var $44fe2c8589e8ea21$exports = {};
function $44fe2c8589e8ea21$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
$44fe2c8589e8ea21$exports = $44fe2c8589e8ea21$var$_nonIterableSpread, $44fe2c8589e8ea21$exports.__esModule = true, $44fe2c8589e8ea21$exports["default"] = $44fe2c8589e8ea21$exports;


function $cdd13f37d92964d6$var$_toConsumableArray(r) {
    return $23ecd6aaf5e2d853$exports(r) || $804224c7a65a7d35$exports(r) || $4TVTA(r) || $44fe2c8589e8ea21$exports();
}
$cdd13f37d92964d6$exports = $cdd13f37d92964d6$var$_toConsumableArray, $cdd13f37d92964d6$exports.__esModule = true, $cdd13f37d92964d6$exports["default"] = $cdd13f37d92964d6$exports;



var $9nAUV = parcelRequire("9nAUV");

var $2c9To = parcelRequire("2c9To");

var $4hWn5 = parcelRequire("4hWn5");

var $bSTwW = parcelRequire("bSTwW");
var $743d984bcf7e680b$exports = {};
var $e6c11d6d1b4ae032$exports = {};

var $bSTwW = parcelRequire("bSTwW");
function $e6c11d6d1b4ae032$var$_superPropBase(t, o) {
    for(; !({}).hasOwnProperty.call(t, o) && null !== (t = $bSTwW(t)););
    return t;
}
$e6c11d6d1b4ae032$exports = $e6c11d6d1b4ae032$var$_superPropBase, $e6c11d6d1b4ae032$exports.__esModule = true, $e6c11d6d1b4ae032$exports["default"] = $e6c11d6d1b4ae032$exports;


function $743d984bcf7e680b$var$_get() {
    return $743d984bcf7e680b$exports = $743d984bcf7e680b$var$_get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function(e, t, r) {
        var p = $e6c11d6d1b4ae032$exports(e, t);
        if (p) {
            var n = Object.getOwnPropertyDescriptor(p, t);
            return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value;
        }
    }, $743d984bcf7e680b$exports.__esModule = true, $743d984bcf7e680b$exports["default"] = $743d984bcf7e680b$exports, $743d984bcf7e680b$var$_get.apply(null, arguments);
}
$743d984bcf7e680b$exports = $743d984bcf7e680b$var$_get, $743d984bcf7e680b$exports.__esModule = true, $743d984bcf7e680b$exports["default"] = $743d984bcf7e680b$exports;



var $keLsu = parcelRequire("keLsu");

var $7hJEL = parcelRequire("7hJEL");

var $gLgUI = parcelRequire("gLgUI");

var $9nAUV = parcelRequire("9nAUV");

var $2c9To = parcelRequire("2c9To");

var $7hJEL = parcelRequire("7hJEL");
function $24655ca3b2e3f5b8$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $24655ca3b2e3f5b8$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $24655ca3b2e3f5b8$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($7hJEL)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $24655ca3b2e3f5b8$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $24655ca3b2e3f5b8$export$ad4be5c2ec28cecf = function isAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $24655ca3b2e3f5b8$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === "AnalyticsEvent";
};
var $24655ca3b2e3f5b8$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function AnalyticsEvent(props) {
        var _this = this;
        (0, (/*@__PURE__*/$parcel$interopDefault($9nAUV)))(this, AnalyticsEvent);
        (0, (/*@__PURE__*/$parcel$interopDefault($7hJEL)))(this, "_isAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($7hJEL)))(this, "clone", function() {
            // just a shallow clone, don't change sub refs unless you want to
            // affect the original's too
            var payload = $24655ca3b2e3f5b8$var$_objectSpread({}, _this.payload);
            return new AnalyticsEvent({
                payload: payload
            });
        });
        this.payload = props.payload;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($2c9To)))(AnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (typeof updater === "function") this.payload = updater(this.payload);
                if ((0, (/*@__PURE__*/$parcel$interopDefault($gLgUI)))(updater) === "object") this.payload = $24655ca3b2e3f5b8$var$_objectSpread($24655ca3b2e3f5b8$var$_objectSpread({}, this.payload), updater);
                return this;
            }
        }
    ]);
}();


function $de1722fe054942a2$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($bSTwW)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($4hWn5)))(t, $de1722fe054942a2$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($bSTwW)))(t).constructor) : o.apply(t, e));
}
function $de1722fe054942a2$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($de1722fe054942a2$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $de1722fe054942a2$var$_superPropGet(t, o, e, r) {
    var p = (0, (/*@__PURE__*/$parcel$interopDefault($743d984bcf7e680b$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($bSTwW)))(1 & r ? t.prototype : t), o, e);
    return 2 & r && "function" == typeof p ? function(t) {
        return p.apply(e, t);
    } : p;
}
var $de1722fe054942a2$export$35f8383928ba8d7 = function isUIAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $de1722fe054942a2$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isUIAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === "UIAnalyticsEvent";
};
var $de1722fe054942a2$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_AnalyticsEvent) {
    function UIAnalyticsEvent(props) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($9nAUV)))(this, UIAnalyticsEvent);
        _this = $de1722fe054942a2$var$_callSuper(this, UIAnalyticsEvent, [
            props
        ]);
        (0, (/*@__PURE__*/$parcel$interopDefault($7hJEL)))(_this, "_isUIAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($7hJEL)))(_this, "clone", function() {
            if (_this.hasFired) return null;
            var context = (0, (/*@__PURE__*/$parcel$interopDefault($cdd13f37d92964d6$exports)))(_this.context);
            var handlers = (0, (/*@__PURE__*/$parcel$interopDefault($cdd13f37d92964d6$exports)))(_this.handlers);
            /**
       * A hacky "deep clone" of the object. This is limited in that it wont
       * support functions, regexs, Maps, Sets, etc, but none of those need to
       * be represented in our payload.
       */ var payload = JSON.parse(JSON.stringify(_this.payload));
            return new UIAnalyticsEvent({
                context: context,
                handlers: handlers,
                payload: payload
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($7hJEL)))(_this, "fire", function(channel) {
            if (_this.hasFired) return;
            _this.handlers.forEach(function(handler) {
                return handler(_this, channel);
            });
            _this.hasFired = true;
        });
        _this.context = props.context || [];
        _this.handlers = props.handlers || [];
        _this.hasFired = false;
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($keLsu)))(UIAnalyticsEvent, _AnalyticsEvent);
    return (0, (/*@__PURE__*/$parcel$interopDefault($2c9To)))(UIAnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (this.hasFired) return this;
                return $de1722fe054942a2$var$_superPropGet(UIAnalyticsEvent, "update", this, 3)([
                    updater
                ]);
            }
        }
    ]);
}((0, $24655ca3b2e3f5b8$export$2e2bcd8739ae039));



var $dAx5m = parcelRequire("dAx5m");

var $h0bf1 = parcelRequire("h0bf1");
var $30f51e563cc219a3$export$d1f587f82ad51c4 = function useAnalyticsContext() {
    return (0, $dAx5m.useContext)((0, $h0bf1.default));
};


function $77c630021457167b$export$5bf35293e545f20c() {
    var analyticsContext = (0, $30f51e563cc219a3$export$d1f587f82ad51c4)();
    var createAnalyticsEvent = (0, $tWuif.useCallbackOne)(function(payload) {
        return new (0, $de1722fe054942a2$export$2e2bcd8739ae039)({
            context: analyticsContext.getAtlaskitAnalyticsContext(),
            handlers: analyticsContext.getAtlaskitAnalyticsEventHandlers(),
            payload: payload
        });
    }, [
        analyticsContext
    ]);
    return {
        createAnalyticsEvent: createAnalyticsEvent
    };
}




var $9nAUV = parcelRequire("9nAUV");

var $2c9To = parcelRequire("2c9To");

var $4hWn5 = parcelRequire("4hWn5");

var $bSTwW = parcelRequire("bSTwW");

var $keLsu = parcelRequire("keLsu");

var $dAx5m = parcelRequire("dAx5m");


var $dAx5m = parcelRequire("dAx5m");


var $7hJEL = parcelRequire("7hJEL");

var $gLgUI = parcelRequire("gLgUI");

var $dAx5m = parcelRequire("dAx5m");

function $42f5a9bb1f20291f$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $42f5a9bb1f20291f$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $42f5a9bb1f20291f$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($7hJEL)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $42f5a9bb1f20291f$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $42f5a9bb1f20291f$export$9ebb5a84d17e5d18() {
    var createEventMap = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var wrappedComponentProps = arguments.length > 1 ? arguments[1] : undefined;
    var _useAnalyticsEvents = (0, $77c630021457167b$export$5bf35293e545f20c)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    var handlerCache = (0, $dAx5m.useRef)({});
    var patchedProps = (0, $dAx5m.useMemo)(function() {
        var cache = handlerCache.current;
        // Clean up no longer used handlers in cache
        Object.keys(cache).filter(function(key) {
            return !(key in createEventMap);
        }).forEach(function(key) {
            return delete cache[key];
        });
        return Object.keys(createEventMap).reduce(function(p, k) {
            var eventCreator = createEventMap[k];
            if (![
                "object",
                "function"
            ].includes((0, (/*@__PURE__*/$parcel$interopDefault($gLgUI)))(eventCreator))) return p;
            var propValue = wrappedComponentProps[k];
            if (k in cache && cache[k].eventCreator === eventCreator && cache[k].propValue === propValue) return $42f5a9bb1f20291f$var$_objectSpread($42f5a9bb1f20291f$var$_objectSpread({}, p), {}, (0, (/*@__PURE__*/$parcel$interopDefault($7hJEL)))({}, k, cache[k].wrappedCallback));
            var wrappedCallback = function wrappedCallback() {
                var analyticsEvent = typeof eventCreator === "function" ? eventCreator(createAnalyticsEvent, wrappedComponentProps) : createAnalyticsEvent(eventCreator);
                if (propValue && typeof propValue === "function") {
                    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                    propValue.apply(void 0, args.concat([
                        analyticsEvent
                    ]));
                }
            };
            cache[k] = {
                eventCreator: eventCreator,
                wrappedCallback: wrappedCallback,
                propValue: propValue
            };
            return $42f5a9bb1f20291f$var$_objectSpread($42f5a9bb1f20291f$var$_objectSpread({}, p), {}, (0, (/*@__PURE__*/$parcel$interopDefault($7hJEL)))({}, k, wrappedCallback));
        }, {});
    }, [
        createEventMap,
        wrappedComponentProps,
        createAnalyticsEvent,
        handlerCache
    ]);
    return {
        patchedEventProps: patchedProps
    };
}


var $67f7b12190c04faf$var$withAnalyticsEvents = function withAnalyticsEvents() {
    var createEventMap = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return function(WrappedComponent) {
        var WithAnalyticsEvents = /*#__PURE__*/ (0, $dAx5m.forwardRef)(function(props, ref) {
            var _usePatchedProps = (0, $42f5a9bb1f20291f$export$9ebb5a84d17e5d18)(createEventMap, props), patchedEventProps = _usePatchedProps.patchedEventProps;
            var _useAnalyticsEvents = (0, $77c630021457167b$export$5bf35293e545f20c)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement(WrappedComponent, (0, (/*@__PURE__*/$parcel$interopDefault($e4a0920c6cdbec99$exports)))({}, props, patchedEventProps, {
                createAnalyticsEvent: createAnalyticsEvent,
                ref: ref
            }));
        });
        WithAnalyticsEvents.displayName = "WithAnalyticsEvents(".concat(WrappedComponent.displayName || WrappedComponent.name, ")");
        return WithAnalyticsEvents;
    };
};
var $67f7b12190c04faf$export$2e2bcd8739ae039 = $67f7b12190c04faf$var$withAnalyticsEvents;


function $44cf895ce6ebfc4f$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($bSTwW)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($4hWn5)))(t, $44cf895ce6ebfc4f$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($bSTwW)))(t).constructor) : o.apply(t, e));
}
function $44cf895ce6ebfc4f$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($44cf895ce6ebfc4f$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $44cf895ce6ebfc4f$var$ErrorBoundary = /*#__PURE__*/ function(_React$Component) {
    function ErrorBoundary(props) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($9nAUV)))(this, ErrorBoundary);
        _this = $44cf895ce6ebfc4f$var$_callSuper(this, ErrorBoundary, [
            props
        ]);
        _this.state = {
            hasError: false
        };
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($keLsu)))(ErrorBoundary, _React$Component);
    return (0, (/*@__PURE__*/$parcel$interopDefault($2c9To)))(ErrorBoundary, [
        {
            key: "componentDidCatch",
            value: function componentDidCatch(error, errorInfo) {
                var analyticsEvent = this.props.createAnalyticsEvent({
                    action: "handled",
                    actionSubject: "error",
                    actionSubjectId: "remoteModuleErrorBoundary",
                    attributes: {
                        error: error === null || error === void 0 ? void 0 : error.message,
                        errorInfo: errorInfo,
                        dimensions: this.props.remotePlugin.dimensions,
                        plugin: this.props.remotePlugin.constructor.name
                    }
                });
                analyticsEvent.fire(this.props.analyticsChannel);
                if (this.props.onError) this.props.onError(error, errorInfo);
                this.setState({
                    hasError: true
                });
            }
        },
        {
            key: "render",
            value: function render() {
                if (this.state.hasError) return this.props.fallback ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).Fragment, null, this.props.fallback) : null;
                return this.props.children;
            }
        }
    ]);
}((0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).Component);
var $44cf895ce6ebfc4f$export$2e2bcd8739ae039 = (0, $67f7b12190c04faf$export$2e2bcd8739ae039)()($44cf895ce6ebfc4f$var$ErrorBoundary);



var $5mLfW = parcelRequire("5mLfW");

var $3rY0i = parcelRequire("3rY0i");
var $ecf01f3d46e8c943$export$1117267eb6098dcd = /*#__PURE__*/ function() {
    var _ref = (0, (/*@__PURE__*/$parcel$interopDefault($5mLfW)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3rY0i))).mark(function _callee(moduleName) {
        var res;
        return (0, (/*@__PURE__*/$parcel$interopDefault($3rY0i))).wrap(function _callee$(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    _context.next = 2;
                    return System.import(moduleName);
                case 2:
                    res = _context.sent;
                    return _context.abrupt("return", res);
                case 4:
                case "end":
                    return _context.stop();
            }
        }, _callee);
    }));
    return function remoteImport(_x) {
        return _ref.apply(this, arguments);
    };
}();
var $ecf01f3d46e8c943$export$ca96bc7645ad7951 = function NO_OP() {};
var $ecf01f3d46e8c943$export$b972f8ca633eb047 = {};



var $7hJEL = parcelRequire("7hJEL");

var $dAx5m = parcelRequire("dAx5m");



var $5mLfW = parcelRequire("5mLfW");

var $9nAUV = parcelRequire("9nAUV");

var $2c9To = parcelRequire("2c9To");

var $7hJEL = parcelRequire("7hJEL");

var $3rY0i = parcelRequire("3rY0i");

var $dAx5m = parcelRequire("dAx5m");

var $9nAUV = parcelRequire("9nAUV");

var $2c9To = parcelRequire("2c9To");

var $7hJEL = parcelRequire("7hJEL");

var $7hJEL = parcelRequire("7hJEL");
function $577bcd420ba2a694$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $577bcd420ba2a694$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $577bcd420ba2a694$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($7hJEL)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $577bcd420ba2a694$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $577bcd420ba2a694$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $577bcd420ba2a694$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $577bcd420ba2a694$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $577bcd420ba2a694$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $577bcd420ba2a694$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $577bcd420ba2a694$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
var $577bcd420ba2a694$export$c65e688d8b365035 = {
    _data: {},
    length: 0,
    setItem: function setItem(id, val) {
        return this._data[id] = String(val);
    },
    getItem: function getItem(id) {
        return this._data.hasOwnProperty(id) ? this._data[id] : undefined;
    },
    removeItem: function removeItem(id) {
        return delete this._data[id];
    },
    clear: function clear() {
        return this._data = {};
    },
    key: function key(index) {
        return Object.keys(this._data)[index];
    }
};
var $577bcd420ba2a694$export$efebfe7859cae3c7 = function mockWindowStorage() {
    var storageToMock = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [
        "localStorage",
        "sessionStorage"
    ];
    var _iterator = $577bcd420ba2a694$var$_createForOfIteratorHelper(storageToMock), _step;
    try {
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var storageToMockElement = _step.value;
            Object.defineProperty(window, storageToMockElement, {
                value: $577bcd420ba2a694$var$_objectSpread({}, $577bcd420ba2a694$export$c65e688d8b365035),
                configurable: true
            });
        }
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
};


var $21f5e7ed4d2a3a0a$var$DEFAULT_STORAGE_ENGINE = "localStorage";
var $21f5e7ed4d2a3a0a$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function StorageClient(clientKey, options) {
        var _this = this;
        (0, (/*@__PURE__*/$parcel$interopDefault($9nAUV)))(this, StorageClient);
        (0, (/*@__PURE__*/$parcel$interopDefault($7hJEL)))(this, "getItem", function(key) {
            var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
                useExpiredItem: false
            }, useExpiredItem = _ref.useExpiredItem;
            var item = _this.client.getItem(_this.itemKey(key));
            if (item) try {
                var parsedItem = JSON.parse(item);
                // item is expired
                if (parsedItem.expires && new Date(parsedItem.expires) < new Date()) {
                    /**
             * Commented out removing this item, as it is a slightly different state
             * to the item not existing that we may want to preserve.
             *  this.client.removeItem(this.itemKey(key));
             */ if (!useExpiredItem) return undefined;
                }
                return parsedItem.value;
            } catch (e) {
                _this.captureException(e);
            }
            return undefined;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($7hJEL)))(this, "removeItem", function(key) {
            try {
                _this.client.removeItem(_this.itemKey(key));
            } catch (e) {
                _this.captureException(e);
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($7hJEL)))(this, "setItemWithExpiry", function(key, value, expireInMS) {
            var itemWithExpiry = {
                value: value,
                expires: typeof expireInMS === "number" ? Date.now() + expireInMS : undefined
            };
            try {
                _this.client.setItem(_this.itemKey(key), JSON.stringify(itemWithExpiry));
            } catch (e) {
                _this.captureException(e);
            }
        });
        this.clientKey = clientKey;
        this.handlers = options === null || options === void 0 ? void 0 : options.handlers;
        var storageEngine = (options === null || options === void 0 ? void 0 : options.storageEngine) || $21f5e7ed4d2a3a0a$var$DEFAULT_STORAGE_ENGINE;
        if (!Object.prototype.hasOwnProperty.call(window, storageEngine)) (0, $577bcd420ba2a694$export$efebfe7859cae3c7)([
            storageEngine
        ]);
        this.client = window[storageEngine];
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($2c9To)))(StorageClient, [
        {
            key: "captureException",
            value: function captureException(e, tags) {
                var _this$handlers;
                if ((_this$handlers = this.handlers) !== null && _this$handlers !== void 0 && _this$handlers.captureException) {
                    var _this$handlers2;
                    (_this$handlers2 = this.handlers) === null || _this$handlers2 === void 0 || _this$handlers2.captureException(e, tags);
                }
            }
        },
        {
            key: "itemKey",
            value: function itemKey(key) {
                return "".concat(this.clientKey, "_").concat(key);
            }
        }
    ]);
}();





var $42689d8a74bb2b07$export$b211ce59c0ea1cfb = function simpleHash(str) {
    var hash = 0;
    for(var i = 0; i < str.length; i++){
        var char = str.charCodeAt(i);
        hash = (hash << 5) - hash + char;
        hash &= hash; // Convert to 32bit integer
    }
    return new Uint32Array([
        hash
    ])[0].toString(36);
};


/**
 * We generate a hash from a specified name, and optional list of dependencies
 * to be used for a computed filename.
 *
 * This is done so that a specific bundle can be hashed according to specific dependencies so that when they
 * are updated. We deliver a specific file for that combination.
 *
 * @param name
 * @param dependencyMap
 */ var $6f8c05a54031a4ab$var$generateHash = function generateHash(name) {
    var dependencyMap = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var stringToHash = name + JSON.stringify(dependencyMap.sort(function(a, b) {
        return (a.name + a.version).localeCompare(b.name + b.version);
    }));
    return (0, $42689d8a74bb2b07$export$b211ce59c0ea1cfb)(stringToHash);
};
var $6f8c05a54031a4ab$export$2e2bcd8739ae039 = $6f8c05a54031a4ab$var$generateHash;




var $7hJEL = parcelRequire("7hJEL");

function $9f94303df14dd8b8$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $9f94303df14dd8b8$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $9f94303df14dd8b8$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($7hJEL)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $9f94303df14dd8b8$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}






var $9f94303df14dd8b8$export$d9f7d3a038462a5 = function getExternalModuleConfiguration(moduleName) {
    try {
        switch(moduleName){
            case (0, $7215130d741fbd54$export$beeb0b96f7122efa).React:
                return {
                    isDefault: true,
                    import: (parcelRequire("dAx5m"))
                };
            case (0, $7215130d741fbd54$export$beeb0b96f7122efa).ReactDOM:
                return {
                    isDefault: true,
                    import: (parcelRequire("1MpXQ"))
                };
            case (0, $7215130d741fbd54$export$beeb0b96f7122efa).ReactIntlNext:
                return {
                    isDefault: true,
                    import: (parcelRequire("lKhJJ"))
                };
            case (0, $7215130d741fbd54$export$beeb0b96f7122efa).EmotionReact:
                return {
                    isDefault: false,
                    import: (parcelRequire("jVTBW"))
                };
            case (0, $7215130d741fbd54$export$beeb0b96f7122efa).FeatureGateJsClientPublic:
                return {
                    isDefault: false,
                    import: (parcelRequire("agI6a"))
                };
            case (0, $7215130d741fbd54$export$beeb0b96f7122efa).AnalyticsContext:
                return {
                    isDefault: true,
                    import: (parcelRequire("h0bf1"))
                };
            default:
                return;
        }
    } catch (error) {
        console.error("Module [".concat(moduleName, "] is possibly not installed."));
        return;
    }
};
var $9f94303df14dd8b8$export$af105514c7aa6b9e = function getModuleToLoad(module) {
    if ("module" in module) return module;
    var fallbackModule = {
        module: module.name,
        import: undefined,
        isDefault: false
    };
    var isValidExternalModule = Object.values((0, $7215130d741fbd54$export$beeb0b96f7122efa)).find(function(moduleName) {
        return moduleName === module.name;
    });
    if (!isValidExternalModule) {
        console.error("Excluded system module [".concat(module.name, "] must be setup inside '/remote-setup/config.ts'. Modules cannot be excluded and required dynamically."));
        return fallbackModule;
    }
    var config = $9f94303df14dd8b8$export$d9f7d3a038462a5(module.name);
    if (!config) return fallbackModule;
    var excludedSystemModule = $9f94303df14dd8b8$var$_objectSpread({
        module: module.name
    }, config);
    return excludedSystemModule;
};
var $9f94303df14dd8b8$export$5598593a72c56694 = function getSystemModule(entry, source) {
    if (entry.isDefault) return {
        module: entry.module,
        import: $9f94303df14dd8b8$var$_objectSpread($9f94303df14dd8b8$var$_objectSpread({}, entry.import), {}, {
            default: entry.import,
            __useDefault: true
        }),
        scopedModuleId: "".concat(source, ":").concat(entry.module)
    };
    return {
        module: entry.module,
        import: entry.import,
        scopedModuleId: "".concat(source, ":").concat(entry.module)
    };
};
var $9f94303df14dd8b8$export$5cefda643f4fb70c = function getScopedModules(entries) {
    try {
        var scopedModules = entries.map(function(entry) {
            return entry.import && (0, (/*@__PURE__*/$parcel$interopDefault($7hJEL)))({}, entry.module, entry.scopedModuleId);
        });
        return Object.assign.apply(Object, [
            {}
        ].concat((0, (/*@__PURE__*/$parcel$interopDefault($cdd13f37d92964d6$exports)))(scopedModules)));
    } catch (error) {
        console.error("Could not set scoped modules with error message: ".concat(error));
        return null;
    }
};


/*!
 * SystemJS 6.15.1
 */ (function() {
    function errMsg(errCode, msg) {
        return (msg || "") + " (SystemJS Error#" + errCode + " " + "https://github.com/systemjs/systemjs/blob/main/docs/errors.md#" + errCode + ")";
    }
    var hasSymbol = typeof Symbol !== "undefined";
    var hasSelf = typeof self !== "undefined";
    var hasDocument = typeof document !== "undefined";
    var envGlobal = hasSelf ? self : $parcel$global;
    var baseUrl;
    if (hasDocument) {
        var baseEl = document.querySelector("base[href]");
        if (baseEl) baseUrl = baseEl.href;
    }
    if (!baseUrl && typeof location !== "undefined") {
        baseUrl = location.href.split("#")[0].split("?")[0];
        var lastSepIndex = baseUrl.lastIndexOf("/");
        if (lastSepIndex !== -1) baseUrl = baseUrl.slice(0, lastSepIndex + 1);
    }
    var backslashRegEx = /\\/g;
    function resolveIfNotPlainOrUrl(relUrl, parentUrl) {
        if (relUrl.indexOf("\\") !== -1) relUrl = relUrl.replace(backslashRegEx, "/");
        // protocol-relative
        if (relUrl[0] === "/" && relUrl[1] === "/") return parentUrl.slice(0, parentUrl.indexOf(":") + 1) + relUrl;
        else if (relUrl[0] === "." && (relUrl[1] === "/" || relUrl[1] === "." && (relUrl[2] === "/" || relUrl.length === 2 && (relUrl += "/")) || relUrl.length === 1 && (relUrl += "/")) || relUrl[0] === "/") {
            var parentProtocol = parentUrl.slice(0, parentUrl.indexOf(":") + 1);
            // Disabled, but these cases will give inconsistent results for deep backtracking
            //if (parentUrl[parentProtocol.length] !== '/')
            //  throw Error('Cannot resolve');
            // read pathname from parent URL
            // pathname taken to be part after leading "/"
            var pathname;
            if (parentUrl[parentProtocol.length + 1] === "/") {
                // resolving to a :// so we need to read out the auth and host
                if (parentProtocol !== "file:") {
                    pathname = parentUrl.slice(parentProtocol.length + 2);
                    pathname = pathname.slice(pathname.indexOf("/") + 1);
                } else pathname = parentUrl.slice(8);
            } else // resolving to :/ so pathname is the /... part
            pathname = parentUrl.slice(parentProtocol.length + (parentUrl[parentProtocol.length] === "/"));
            if (relUrl[0] === "/") return parentUrl.slice(0, parentUrl.length - pathname.length - 1) + relUrl;
            // join together and split for removal of .. and . segments
            // looping the string instead of anything fancy for perf reasons
            // '../../../../../z' resolved to 'x/y' is just 'z'
            var segmented = pathname.slice(0, pathname.lastIndexOf("/") + 1) + relUrl;
            var output = [];
            var segmentIndex = -1;
            for(var i = 0; i < segmented.length; i++){
                // busy reading a segment - only terminate on '/'
                if (segmentIndex !== -1) {
                    if (segmented[i] === "/") {
                        output.push(segmented.slice(segmentIndex, i + 1));
                        segmentIndex = -1;
                    }
                } else if (segmented[i] === ".") {
                    // ../ segment
                    if (segmented[i + 1] === "." && (segmented[i + 2] === "/" || i + 2 === segmented.length)) {
                        output.pop();
                        i += 2;
                    } else if (segmented[i + 1] === "/" || i + 1 === segmented.length) i += 1;
                    else // the start of a new segment as below
                    segmentIndex = i;
                } else segmentIndex = i;
            }
            // finish reading out the last segment
            if (segmentIndex !== -1) output.push(segmented.slice(segmentIndex));
            return parentUrl.slice(0, parentUrl.length - pathname.length) + output.join("");
        }
    }
    /*
   * Import maps implementation
   *
   * To make lookups fast we pre-resolve the entire import map
   * and then match based on backtracked hash lookups
   *
   */ function resolveUrl(relUrl, parentUrl) {
        return resolveIfNotPlainOrUrl(relUrl, parentUrl) || (relUrl.indexOf(":") !== -1 ? relUrl : resolveIfNotPlainOrUrl("./" + relUrl, parentUrl));
    }
    function resolveAndComposePackages(packages, outPackages, baseUrl, parentMap, parentUrl) {
        for(var p in packages){
            var resolvedLhs = resolveIfNotPlainOrUrl(p, baseUrl) || p;
            var rhs = packages[p];
            // package fallbacks not currently supported
            if (typeof rhs !== "string") continue;
            var mapped = resolveImportMap(parentMap, resolveIfNotPlainOrUrl(rhs, baseUrl) || rhs, parentUrl);
            if (!mapped) targetWarning("W1", p, rhs, "bare specifier did not resolve");
            else outPackages[resolvedLhs] = mapped;
        }
    }
    function resolveAndComposeImportMap(json, baseUrl, outMap) {
        if (json.imports) resolveAndComposePackages(json.imports, outMap.imports, baseUrl, outMap, null);
        var u;
        for(u in json.scopes || {}){
            var resolvedScope = resolveUrl(u, baseUrl);
            resolveAndComposePackages(json.scopes[u], outMap.scopes[resolvedScope] || (outMap.scopes[resolvedScope] = {}), baseUrl, outMap, resolvedScope);
        }
        for(u in json.depcache || {})outMap.depcache[resolveUrl(u, baseUrl)] = json.depcache[u];
        for(u in json.integrity || {})outMap.integrity[resolveUrl(u, baseUrl)] = json.integrity[u];
    }
    function getMatch(path, matchObj) {
        if (matchObj[path]) return path;
        var sepIndex = path.length;
        do {
            var segment = path.slice(0, sepIndex + 1);
            if (segment in matchObj) return segment;
        }while ((sepIndex = path.lastIndexOf("/", sepIndex - 1)) !== -1);
    }
    function applyPackages(id, packages) {
        var pkgName = getMatch(id, packages);
        if (pkgName) {
            var pkg = packages[pkgName];
            if (pkg === null) return;
            if (id.length > pkgName.length && pkg[pkg.length - 1] !== "/") targetWarning("W2", pkgName, pkg, "should have a trailing '/'");
            else return pkg + id.slice(pkgName.length);
        }
    }
    function targetWarning(code, match, target, msg) {
        console.warn(errMsg(code, "Package target " + msg + ", resolving target '" + target + "' for " + match));
    }
    function resolveImportMap(importMap, resolvedOrPlain, parentUrl) {
        var scopes = importMap.scopes;
        var scopeUrl = parentUrl && getMatch(parentUrl, scopes);
        while(scopeUrl){
            var packageResolution = applyPackages(resolvedOrPlain, scopes[scopeUrl]);
            if (packageResolution) return packageResolution;
            scopeUrl = getMatch(scopeUrl.slice(0, scopeUrl.lastIndexOf("/")), scopes);
        }
        return applyPackages(resolvedOrPlain, importMap.imports) || resolvedOrPlain.indexOf(":") !== -1 && resolvedOrPlain;
    }
    /*
   * SystemJS Core
   *
   * Provides
   * - System.import
   * - System.register support for
   *     live bindings, function hoisting through circular references,
   *     reexports, dynamic import, import.meta.url, top-level await
   * - System.getRegister to get the registration
   * - Symbol.toStringTag support in Module objects
   * - Hookable System.createContext to customize import.meta
   * - System.onload(err, id, deps) handler for tracing / hot-reloading
   *
   * Core comes with no System.prototype.resolve or
   * System.prototype.instantiate implementations
   */ var toStringTag$1 = hasSymbol && Symbol.toStringTag;
    var REGISTRY = hasSymbol ? Symbol() : "@";
    function SystemJS() {
        this[REGISTRY] = {};
    }
    var systemJSPrototype = SystemJS.prototype;
    systemJSPrototype.import = function(id, parentUrl, meta) {
        var loader = this;
        parentUrl && typeof parentUrl === "object" && (meta = parentUrl, parentUrl = undefined);
        return Promise.resolve(loader.prepareImport()).then(function() {
            return loader.resolve(id, parentUrl, meta);
        }).then(function(id) {
            var load = getOrCreateLoad(loader, id, undefined, meta);
            return load.C || topLevelLoad(loader, load);
        });
    };
    // Hookable createContext function -> allowing eg custom import meta
    systemJSPrototype.createContext = function(parentId) {
        var loader = this;
        return {
            url: parentId,
            resolve: function(id, parentUrl) {
                return Promise.resolve(loader.resolve(id, parentUrl || parentId));
            }
        };
    };
    // onLoad(err, id, deps) provided for tracing / hot-reloading
    systemJSPrototype.onload = function() {};
    function loadToId(load) {
        return load.id;
    }
    function triggerOnload(loader, load, err, isErrSource) {
        loader.onload(err, load.id, load.d && load.d.map(loadToId), !!isErrSource);
        if (err) throw err;
    }
    var lastRegister;
    systemJSPrototype.register = function(deps, declare, metas) {
        lastRegister = [
            deps,
            declare,
            metas
        ];
    };
    /*
   * getRegister provides the last anonymous System.register call
   */ systemJSPrototype.getRegister = function() {
        var _lastRegister = lastRegister;
        lastRegister = undefined;
        return _lastRegister;
    };
    function getOrCreateLoad(loader, id, firstParentUrl, meta) {
        var load = loader[REGISTRY][id];
        if (load) return load;
        var importerSetters = [];
        var ns = Object.create(null);
        if (toStringTag$1) Object.defineProperty(ns, toStringTag$1, {
            value: "Module"
        });
        var instantiatePromise = Promise.resolve().then(function() {
            return loader.instantiate(id, firstParentUrl, meta);
        }).then(function(registration) {
            if (!registration) throw Error(errMsg(2, "Module " + id + " did not instantiate"));
            function _export(name, value) {
                // note if we have hoisted exports (including reexports)
                load.h = true;
                var changed = false;
                if (typeof name === "string") {
                    if (!(name in ns) || ns[name] !== value) {
                        ns[name] = value;
                        changed = true;
                    }
                } else {
                    for(var p in name){
                        var value = name[p];
                        if (!(p in ns) || ns[p] !== value) {
                            ns[p] = value;
                            changed = true;
                        }
                    }
                    if (name && name.__esModule) ns.__esModule = name.__esModule;
                }
                if (changed) for(var i = 0; i < importerSetters.length; i++){
                    var setter = importerSetters[i];
                    if (setter) setter(ns);
                }
                return value;
            }
            var declared = registration[1](_export, registration[1].length === 2 ? {
                import: function(importId, meta) {
                    return loader.import(importId, id, meta);
                },
                meta: loader.createContext(id)
            } : undefined);
            load.e = declared.execute || function() {};
            return [
                registration[0],
                declared.setters || [],
                registration[2] || []
            ];
        }, function(err) {
            load.e = null;
            load.er = err;
            triggerOnload(loader, load, err, true);
            throw err;
        });
        var linkPromise = instantiatePromise.then(function(instantiation) {
            return Promise.all(instantiation[0].map(function(dep, i) {
                var setter = instantiation[1][i];
                var meta = instantiation[2][i];
                return Promise.resolve(loader.resolve(dep, id)).then(function(depId) {
                    var depLoad = getOrCreateLoad(loader, depId, id, meta);
                    // depLoad.I may be undefined for already-evaluated
                    return Promise.resolve(depLoad.I).then(function() {
                        if (setter) {
                            depLoad.i.push(setter);
                            // only run early setters when there are hoisted exports of that module
                            // the timing works here as pending hoisted export calls will trigger through importerSetters
                            if (depLoad.h || !depLoad.I) setter(depLoad.n);
                        }
                        return depLoad;
                    });
                });
            })).then(function(depLoads) {
                load.d = depLoads;
            });
        });
        // Capital letter = a promise function
        return load = loader[REGISTRY][id] = {
            id: id,
            // importerSetters, the setters functions registered to this dependency
            // we retain this to add more later
            i: importerSetters,
            // module namespace object
            n: ns,
            // extra module information for import assertion
            // shape like: { assert: { type: 'xyz' } }
            m: meta,
            // instantiate
            I: instantiatePromise,
            // link
            L: linkPromise,
            // whether it has hoisted exports
            h: false,
            // On instantiate completion we have populated:
            // dependency load records
            d: undefined,
            // execution function
            e: undefined,
            // On execution we have populated:
            // the execution error if any
            er: undefined,
            // in the case of TLA, the execution promise
            E: undefined,
            // On execution, L, I, E cleared
            // Promise for top-level completion
            C: undefined,
            // parent instantiator / executor
            p: undefined
        };
    }
    function instantiateAll(loader, load, parent, loaded) {
        if (!loaded[load.id]) {
            loaded[load.id] = true;
            // load.L may be undefined for already-instantiated
            return Promise.resolve(load.L).then(function() {
                if (!load.p || load.p.e === null) load.p = parent;
                return Promise.all(load.d.map(function(dep) {
                    return instantiateAll(loader, dep, parent, loaded);
                }));
            }).catch(function(err) {
                if (load.er) throw err;
                load.e = null;
                triggerOnload(loader, load, err, false);
                throw err;
            });
        }
    }
    function topLevelLoad(loader, load) {
        return load.C = instantiateAll(loader, load, load, {}).then(function() {
            return postOrderExec(loader, load, {});
        }).then(function() {
            return load.n;
        });
    }
    // the closest we can get to call(undefined)
    var nullContext = Object.freeze(Object.create(null));
    // returns a promise if and only if a top-level await subgraph
    // throws on sync errors
    function postOrderExec(loader, load, seen) {
        if (seen[load.id]) return;
        seen[load.id] = true;
        if (!load.e) {
            if (load.er) throw load.er;
            if (load.E) return load.E;
            return;
        }
        // From here we're about to execute the load.
        // Because the execution may be async, we pop the `load.e` first.
        // So `load.e === null` always means the load has been executed or is executing.
        // To inspect the state:
        // - If `load.er` is truthy, the execution has threw or has been rejected;
        // - otherwise, either the `load.E` is a promise, means it's under async execution, or
        // - the `load.E` is null, means the load has completed the execution or has been async resolved.
        var exec = load.e;
        load.e = null;
        // deps execute first, unless circular
        var depLoadPromises;
        load.d.forEach(function(depLoad) {
            try {
                var depLoadPromise = postOrderExec(loader, depLoad, seen);
                if (depLoadPromise) (depLoadPromises = depLoadPromises || []).push(depLoadPromise);
            } catch (err) {
                load.er = err;
                triggerOnload(loader, load, err, false);
                throw err;
            }
        });
        if (depLoadPromises) return Promise.all(depLoadPromises).then(doExec);
        return doExec();
        function doExec() {
            try {
                var execPromise = exec.call(nullContext);
                if (execPromise) {
                    execPromise = execPromise.then(function() {
                        load.C = load.n;
                        load.E = null; // indicates completion
                        triggerOnload(loader, load, null, true);
                    }, function(err) {
                        load.er = err;
                        load.E = null;
                        triggerOnload(loader, load, err, true);
                        throw err;
                    });
                    return load.E = execPromise;
                }
                // (should be a promise, but a minify optimization to leave out Promise.resolve)
                load.C = load.n;
                load.L = load.I = undefined;
            } catch (err) {
                load.er = err;
                throw err;
            } finally{
                triggerOnload(loader, load, load.er, true);
            }
        }
    }
    envGlobal.System = new SystemJS();
    /*
   * SystemJS browser attachments for script and import map processing
   */ var importMapPromise = Promise.resolve();
    var importMap = {
        imports: {},
        scopes: {},
        depcache: {},
        integrity: {}
    };
    // Scripts are processed immediately, on the first System.import, and on DOMReady.
    // Import map scripts are processed only once (by being marked) and in order for each phase.
    // This is to avoid using DOM mutation observers in core, although that would be an alternative.
    var processFirst = hasDocument;
    systemJSPrototype.prepareImport = function(doProcessScripts) {
        if (processFirst || doProcessScripts) {
            processScripts();
            processFirst = false;
        }
        return importMapPromise;
    };
    systemJSPrototype.getImportMap = function() {
        return JSON.parse(JSON.stringify(importMap));
    };
    if (hasDocument) {
        processScripts();
        window.addEventListener("DOMContentLoaded", processScripts);
    }
    systemJSPrototype.addImportMap = function(newMap, mapBase) {
        resolveAndComposeImportMap(newMap, mapBase || baseUrl, importMap);
    };
    function processScripts() {
        [].forEach.call(document.querySelectorAll("script"), function(script) {
            if (script.sp) return;
            // TODO: deprecate systemjs-module in next major now that we have auto import
            if (script.type === "systemjs-module") {
                script.sp = true;
                if (!script.src) return;
                System.import(script.src.slice(0, 7) === "import:" ? script.src.slice(7) : resolveUrl(script.src, baseUrl)).catch(function(e) {
                    // if there is a script load error, dispatch an "error" event
                    // on the script tag.
                    if (e.message.indexOf("https://github.com/systemjs/systemjs/blob/main/docs/errors.md#3") > -1) {
                        var event = document.createEvent("Event");
                        event.initEvent("error", false, false);
                        script.dispatchEvent(event);
                    }
                    return Promise.reject(e);
                });
            } else if (script.type === "systemjs-importmap") {
                script.sp = true;
                // The passThrough property is for letting the module types fetch implementation know that this is not a SystemJS module.
                var fetchPromise = script.src ? (System.fetch || fetch)(script.src, {
                    integrity: script.integrity,
                    priority: script.fetchPriority,
                    passThrough: true
                }).then(function(res) {
                    if (!res.ok) throw Error("Invalid status code: " + res.status);
                    return res.text();
                }).catch(function(err) {
                    err.message = errMsg("W4", "Error fetching systemjs-import map " + script.src) + "\n" + err.message;
                    console.warn(err);
                    if (typeof script.onerror === "function") script.onerror();
                    return "{}";
                }) : script.innerHTML;
                importMapPromise = importMapPromise.then(function() {
                    return fetchPromise;
                }).then(function(text) {
                    extendImportMap(importMap, text, script.src || baseUrl);
                });
            }
        });
    }
    function extendImportMap(importMap, newMapText, newMapUrl) {
        var newMap = {};
        try {
            newMap = JSON.parse(newMapText);
        } catch (err) {
            console.warn(Error(errMsg("W5", "systemjs-importmap contains invalid JSON") + "\n\n" + newMapText + "\n"));
        }
        resolveAndComposeImportMap(newMap, newMapUrl, importMap);
    }
    /*
   * Script instantiation loading
   */ if (hasDocument) {
        window.addEventListener("error", function(evt) {
            lastWindowErrorUrl = evt.filename;
            lastWindowError = evt.error;
        });
        var baseOrigin = location.origin;
    }
    systemJSPrototype.createScript = function(url) {
        var script = document.createElement("script");
        script.async = true;
        // Only add cross origin for actual cross origin
        // this is because Safari triggers for all
        // - https://bugs.webkit.org/show_bug.cgi?id=171566
        if (url.indexOf(baseOrigin + "/")) script.crossOrigin = "anonymous";
        var integrity = importMap.integrity[url];
        if (integrity) script.integrity = integrity;
        script.src = url;
        return script;
    };
    // Auto imports -> script tags can be inlined directly for load phase
    var lastAutoImportDeps, lastAutoImportTimeout;
    var autoImportCandidates = {};
    var systemRegister = systemJSPrototype.register;
    systemJSPrototype.register = function(deps, declare) {
        if (hasDocument && document.readyState === "loading" && typeof deps !== "string") {
            var scripts = document.querySelectorAll("script[src]");
            var lastScript = scripts[scripts.length - 1];
            if (lastScript) {
                lastScript.src;
                lastAutoImportDeps = deps;
                // if this is already a System load, then the instantiate has already begun
                // so this re-import has no consequence
                var loader = this;
                lastAutoImportTimeout = setTimeout(function() {
                    autoImportCandidates[lastScript.src] = [
                        deps,
                        declare
                    ];
                    loader.import(lastScript.src);
                });
            }
        } else lastAutoImportDeps = undefined;
        return systemRegister.call(this, deps, declare);
    };
    var lastWindowErrorUrl, lastWindowError;
    systemJSPrototype.instantiate = function(url, firstParentUrl) {
        var autoImportRegistration = autoImportCandidates[url];
        if (autoImportRegistration) {
            delete autoImportCandidates[url];
            return autoImportRegistration;
        }
        var loader = this;
        return Promise.resolve(systemJSPrototype.createScript(url)).then(function(script) {
            return new Promise(function(resolve, reject) {
                script.addEventListener("error", function() {
                    reject(Error(errMsg(3, "Error loading " + url + (firstParentUrl ? " from " + firstParentUrl : ""))));
                });
                script.addEventListener("load", function() {
                    document.head.removeChild(script);
                    // Note that if an error occurs that isn't caught by this if statement,
                    // that getRegister will return null and a "did not instantiate" error will be thrown.
                    if (lastWindowErrorUrl === url) reject(lastWindowError);
                    else {
                        var register = loader.getRegister(url);
                        // Clear any auto import registration for dynamic import scripts during load
                        if (register && register[0] === lastAutoImportDeps) clearTimeout(lastAutoImportTimeout);
                        resolve(register);
                    }
                });
                document.head.appendChild(script);
            });
        });
    };
    /*
   * Fetch loader, sets up shouldFetch and fetch hooks
   */ systemJSPrototype.shouldFetch = function() {
        return false;
    };
    if (typeof fetch !== "undefined") systemJSPrototype.fetch = fetch;
    var instantiate = systemJSPrototype.instantiate;
    var jsContentTypeRegEx = /^(text|application)\/(x-)?javascript(;|$)/;
    systemJSPrototype.instantiate = function(url, parent, meta) {
        var loader = this;
        if (!this.shouldFetch(url, parent, meta)) return instantiate.apply(this, arguments);
        return this.fetch(url, {
            credentials: "same-origin",
            integrity: importMap.integrity[url],
            meta: meta
        }).then(function(res) {
            if (!res.ok) throw Error(errMsg(7, res.status + " " + res.statusText + ", loading " + url + (parent ? " from " + parent : "")));
            var contentType = res.headers.get("content-type");
            if (!contentType || !jsContentTypeRegEx.test(contentType)) throw Error(errMsg(4, 'Unknown Content-Type "' + contentType + '", loading ' + url + (parent ? " from " + parent : "")));
            return res.text().then(function(source) {
                if (source.indexOf("//# sourceURL=") < 0) source += "\n//# sourceURL=" + url;
                (0, eval)(source);
                return loader.getRegister(url);
            });
        });
    };
    systemJSPrototype.resolve = function(id, parentUrl) {
        parentUrl = parentUrl || false || baseUrl;
        return resolveImportMap(importMap, resolveIfNotPlainOrUrl(id, parentUrl) || id, parentUrl) || throwUnresolved(id, parentUrl);
    };
    function throwUnresolved(id, parentUrl) {
        throw Error(errMsg(8, "Unable to resolve bare specifier '" + id + (parentUrl ? "' from " + parentUrl : "'")));
    }
    var systemInstantiate = systemJSPrototype.instantiate;
    systemJSPrototype.instantiate = function(url, firstParentUrl, meta) {
        var preloads = importMap.depcache[url];
        if (preloads) for(var i = 0; i < preloads.length; i++)getOrCreateLoad(this, this.resolve(preloads[i], url), url);
        return systemInstantiate.call(this, url, firstParentUrl, meta);
    };
    /*
   * Supports loading System.register in workers
   */ if (hasSelf && typeof importScripts === "function") systemJSPrototype.instantiate = function(url) {
        var loader = this;
        return Promise.resolve().then(function() {
            importScripts(url);
            return loader.getRegister(url);
        });
    };
    /*
   * SystemJS global script loading support
   * Extra for the s.js build only
   * (Included by default in system.js build)
   */ (function(global1) {
        var systemJSPrototype = global1.System.constructor.prototype;
        // safari unpredictably lists some new globals first or second in object order
        var firstGlobalProp, secondGlobalProp, lastGlobalProp;
        function getGlobalProp(useFirstGlobalProp) {
            var cnt = 0;
            var foundLastProp, result;
            for(var p in global1){
                // do not check frames cause it could be removed during import
                if (shouldSkipProperty(p)) continue;
                if (cnt === 0 && p !== firstGlobalProp || cnt === 1 && p !== secondGlobalProp) return p;
                if (foundLastProp) {
                    lastGlobalProp = p;
                    result = useFirstGlobalProp && result || p;
                } else foundLastProp = p === lastGlobalProp;
                cnt++;
            }
            return result;
        }
        function noteGlobalProps() {
            // alternatively Object.keys(global).pop()
            // but this may be faster (pending benchmarks)
            firstGlobalProp = secondGlobalProp = undefined;
            for(var p in global1){
                // do not check frames cause it could be removed during import
                if (shouldSkipProperty(p)) continue;
                if (!firstGlobalProp) firstGlobalProp = p;
                else if (!secondGlobalProp) secondGlobalProp = p;
                lastGlobalProp = p;
            }
            return lastGlobalProp;
        }
        var impt = systemJSPrototype.import;
        systemJSPrototype.import = function(id, parentUrl, meta) {
            noteGlobalProps();
            return impt.call(this, id, parentUrl, meta);
        };
        var emptyInstantiation = [
            [],
            function() {
                return {};
            }
        ];
        var getRegister = systemJSPrototype.getRegister;
        systemJSPrototype.getRegister = function() {
            var lastRegister = getRegister.call(this);
            if (lastRegister) return lastRegister;
            // no registration -> attempt a global detection as difference from snapshot
            // when multiple globals, we take the global value to be the last defined new global object property
            // for performance, this will not support multi-version / global collisions as previous SystemJS versions did
            // note in Edge, deleting and re-adding a global does not change its ordering
            var globalProp = getGlobalProp(this.firstGlobalProp);
            if (!globalProp) return emptyInstantiation;
            var globalExport;
            try {
                globalExport = global1[globalProp];
            } catch (e) {
                return emptyInstantiation;
            }
            return [
                [],
                function(_export) {
                    return {
                        execute: function() {
                            _export(globalExport);
                            _export({
                                default: globalExport,
                                __useDefault: true
                            });
                        }
                    };
                }
            ];
        };
        var isIE11 = typeof navigator !== "undefined" && navigator.userAgent.indexOf("Trident") !== -1;
        function shouldSkipProperty(p) {
            return !global1.hasOwnProperty(p) || !isNaN(p) && p < global1.length || isIE11 && global1[p] && typeof window !== "undefined" && global1[p].parent === window;
        }
    })(typeof self !== "undefined" ? self : $parcel$global);
    /*
   * Loads JSON, CSS, Wasm module types based on file extension
   * filters and content type verifications
   */ (function(global1) {
        var systemJSPrototype = global1.System.constructor.prototype;
        var moduleTypesRegEx = /^[^#?]+\.(css|html|json|wasm)([?#].*)?$/;
        var _shouldFetch = systemJSPrototype.shouldFetch.bind(systemJSPrototype);
        systemJSPrototype.shouldFetch = function(url) {
            return _shouldFetch(url) || moduleTypesRegEx.test(url);
        };
        var jsonContentType = /^application\/json(;|$)/;
        var cssContentType = /^text\/css(;|$)/;
        var wasmContentType = /^application\/wasm(;|$)/;
        var fetch1 = systemJSPrototype.fetch;
        systemJSPrototype.fetch = function(url, options) {
            return fetch1(url, options).then(function(res) {
                if (options.passThrough) return res;
                if (!res.ok) return res;
                var contentType = res.headers.get("content-type");
                if (jsonContentType.test(contentType)) return res.json().then(function(json) {
                    return new Response(new Blob([
                        'System.register([],function(e){return{execute:function(){e("default",' + JSON.stringify(json) + ")}}})"
                    ], {
                        type: "application/javascript"
                    }));
                });
                if (cssContentType.test(contentType)) return res.text().then(function(source) {
                    source = source.replace(/url\(\s*(?:(["'])((?:\\.|[^\n\\"'])+)\1|((?:\\.|[^\s,"'()\\])+))\s*\)/g, function(match, quotes, relUrl1, relUrl2) {
                        return [
                            "url(",
                            quotes,
                            resolveUrl(relUrl1 || relUrl2, url),
                            quotes,
                            ")"
                        ].join("");
                    });
                    return new Response(new Blob([
                        "System.register([],function(e){return{execute:function(){var s=new CSSStyleSheet();s.replaceSync(" + JSON.stringify(source) + ');e("default",s)}}})'
                    ], {
                        type: "application/javascript"
                    }));
                });
                if (wasmContentType.test(contentType)) return (WebAssembly.compileStreaming ? WebAssembly.compileStreaming(res) : res.arrayBuffer().then(WebAssembly.compile)).then(function(module) {
                    if (!global1.System.wasmModules) global1.System.wasmModules = Object.create(null);
                    global1.System.wasmModules[url] = module;
                    // we can only set imports if supported (eg early Safari doesnt support)
                    var deps = [];
                    var setterSources = [];
                    if (WebAssembly.Module.imports) WebAssembly.Module.imports(module).forEach(function(impt) {
                        var key = JSON.stringify(impt.module);
                        if (deps.indexOf(key) === -1) {
                            deps.push(key);
                            setterSources.push("function(m){i[" + key + "]=m}");
                        }
                    });
                    return new Response(new Blob([
                        "System.register([" + deps.join(",") + "],function(e){var i={};return{setters:[" + setterSources.join(",") + "],execute:function(){return WebAssembly.instantiate(System.wasmModules[" + JSON.stringify(url) + "],i).then(function(m){e(m.exports)})}}})"
                    ], {
                        type: "application/javascript"
                    }));
                });
                return res;
            });
        };
    })(typeof self !== "undefined" ? self : $parcel$global);
    var toStringTag = typeof Symbol !== "undefined" && Symbol.toStringTag;
    systemJSPrototype.get = function(id) {
        var load = this[REGISTRY][id];
        if (load && load.e === null && !load.E) {
            if (load.er) return null;
            return load.n;
        }
    };
    systemJSPrototype.set = function(id, module) {
        try {
            // No page-relative URLs allowed
            new URL(id);
        } catch (err) {
            console.warn(Error(errMsg("W3", '"' + id + '" is not a valid URL to set in the module registry')));
        }
        var ns;
        if (toStringTag && module[toStringTag] === "Module") ns = module;
        else {
            ns = Object.assign(Object.create(null), module);
            if (toStringTag) Object.defineProperty(ns, toStringTag, {
                value: "Module"
            });
        }
        var done = Promise.resolve(ns);
        var load = this[REGISTRY][id] || (this[REGISTRY][id] = {
            id: id,
            i: [],
            h: false,
            d: [],
            e: null,
            er: undefined,
            E: undefined
        });
        if (load.e || load.E) return false;
        Object.assign(load, {
            n: ns,
            I: undefined,
            L: undefined,
            C: done
        });
        return ns;
    };
    systemJSPrototype.has = function(id) {
        var load = this[REGISTRY][id];
        return !!load;
    };
    // Delete function provided for hot-reloading use cases
    systemJSPrototype.delete = function(id) {
        var registry = this[REGISTRY];
        var load = registry[id];
        // in future we can support load.E case by failing load first
        // but that will require TLA callbacks to be implemented
        if (!load || load.p && load.p.e !== null || load.E) return false;
        var importerSetters = load.i;
        // remove from importerSetters
        // (release for gc)
        if (load.d) load.d.forEach(function(depLoad) {
            var importerIndex = depLoad.i.indexOf(load);
            if (importerIndex !== -1) depLoad.i.splice(importerIndex, 1);
        });
        delete registry[id];
        return function() {
            var load = registry[id];
            if (!load || !importerSetters || load.e !== null || load.E) return false;
            // add back the old setters
            importerSetters.forEach(function(setter) {
                load.i.push(setter);
                setter(load.n);
            });
            importerSetters = null;
        };
    };
    var iterator = typeof Symbol !== "undefined" && Symbol.iterator;
    systemJSPrototype.entries = function() {
        var loader = this, keys = Object.keys(loader[REGISTRY]);
        var index = 0, ns, key;
        var result = {
            next: function() {
                while((key = keys[index++]) !== undefined && (ns = loader.get(key)) === undefined);
                return {
                    done: key === undefined,
                    value: key !== undefined && [
                        key,
                        ns
                    ]
                };
            }
        };
        result[iterator] = function() {
            return this;
        };
        return result;
    };
})();


var $3a937228d996db9e$export$5d60344e1be8d663 = function setupSystemModules(modulesToLoad, pluginName) {
    if (!modulesToLoad || modulesToLoad.length === 0) {
        console.error("No modules found to set in System registry");
        return null;
    }
    var systemModulesToSet = modulesToLoad.map((0, $9f94303df14dd8b8$export$af105514c7aa6b9e));
    var systemModules = systemModulesToSet.map(function(module) {
        return (0, $9f94303df14dd8b8$export$5598593a72c56694)(module, pluginName);
    });
    systemModules.forEach(function(entry) {
        if (!entry.import) {
            console.error("Unable to set import for module [".concat(entry.module, "]. Please ensure it has been installed and is available."));
            return;
        }
        System.set(entry.scopedModuleId, entry.import);
    });
    return (0, $9f94303df14dd8b8$export$5cefda643f4fb70c)(systemModules);
};


var $1a9c5935e5bd21ea$export$994164cf3ae1cc9a = /*#__PURE__*/ function(ExperienceTypes) {
    ExperienceTypes["Load"] = "load";
    ExperienceTypes["Experience"] = "experience";
    ExperienceTypes["Operation"] = "operation";
    return ExperienceTypes;
}({});
var $1a9c5935e5bd21ea$export$cc26007c03242fff = /*#__PURE__*/ function(ExperiencePerformanceTypes) {
    ExperiencePerformanceTypes["PageLoad"] = "page-load";
    ExperiencePerformanceTypes["PageSegmentLoad"] = "page-segment-load";
    ExperiencePerformanceTypes["InlineResult"] = "inline-result";
    ExperiencePerformanceTypes["Custom"] = "custom";
    return ExperiencePerformanceTypes;
}({});


var $2c9To = parcelRequire("2c9To");

var $9nAUV = parcelRequire("9nAUV");

var $keLsu = parcelRequire("keLsu");

var $4hWn5 = parcelRequire("4hWn5");

var $bSTwW = parcelRequire("bSTwW");


var $5mLfW = parcelRequire("5mLfW");

var $9nAUV = parcelRequire("9nAUV");

var $2c9To = parcelRequire("2c9To");

var $7hJEL = parcelRequire("7hJEL");

var $3rY0i = parcelRequire("3rY0i");

var $816lv = parcelRequire("816lv");
// temp solution until we can get it automated
var $5fcd8a7ce83b2a21$export$2295b861f318254a = "0.1.5";


var $b0a6e7767848d0ef$export$15e172712955e18f = function isWindowObjectAvailable() {
    return typeof window !== "undefined";
};



var $9nAUV = parcelRequire("9nAUV");

var $2c9To = parcelRequire("2c9To");

var $7hJEL = parcelRequire("7hJEL");
var $3e9eb738655b0fdf$var$UFOLogger = /*#__PURE__*/ function() {
    function UFOLogger() {
        (0, (/*@__PURE__*/$parcel$interopDefault($9nAUV)))(this, UFOLogger);
        (0, (/*@__PURE__*/$parcel$interopDefault($7hJEL)))(this, "enabled", false);
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($2c9To)))(UFOLogger, [
        {
            key: "log",
            value: function log() {
                var _console;
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                // eslint-disable-next-line no-console
                this.enabled && (_console = console).log.apply(_console, [
                    UFOLogger.UFOprefix
                ].concat(args));
            }
        },
        {
            key: "warn",
            value: function warn() {
                var _console2;
                for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
                // eslint-disable-next-line no-console
                this.enabled && (_console2 = console).warn.apply(_console2, [
                    UFOLogger.UFOprefix
                ].concat(args));
            }
        },
        {
            key: "enable",
            value: function enable() {
                this.enabled = true;
            }
        },
        {
            key: "disable",
            value: function disable() {
                this.enabled = false;
            }
        }
    ]);
    return UFOLogger;
}();
(0, (/*@__PURE__*/$parcel$interopDefault($7hJEL)))($3e9eb738655b0fdf$var$UFOLogger, "UFOprefix", "[ufo\uD83D\uDEF8]");
var $3e9eb738655b0fdf$export$4ab84f6f04f6566d = new $3e9eb738655b0fdf$var$UFOLogger();
var $3e9eb738655b0fdf$export$b4958caff08a0960 = function ufolog() {
    $3e9eb738655b0fdf$export$4ab84f6f04f6566d.log.apply($3e9eb738655b0fdf$export$4ab84f6f04f6566d, arguments);
};
var $3e9eb738655b0fdf$export$d53d07b6034c4560 = function ufowarn() {
    $3e9eb738655b0fdf$export$4ab84f6f04f6566d.warn.apply($3e9eb738655b0fdf$export$4ab84f6f04f6566d, arguments);
};


var $2d5891ef20441e70$export$96253c35c37cf96b = /*#__PURE__*/ function(UFOGlobalEventStreamEventType) {
    UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["EXPERIENCE_PAYLOAD"] = 0] = "EXPERIENCE_PAYLOAD";
    UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["SUBSCRIBE"] = 1] = "SUBSCRIBE";
    UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["UNSUBSCRIBE"] = 2] = "UNSUBSCRIBE";
    return UFOGlobalEventStreamEventType;
}({});
var $2d5891ef20441e70$export$a12c67b37a306b13 = /*#__PURE__*/ function(PageVisibleState) {
    PageVisibleState["VISIBLE"] = "visible";
    PageVisibleState["HIDDEN"] = "hidden";
    PageVisibleState["MIXED"] = "mixed";
    return PageVisibleState;
}({});
var $2d5891ef20441e70$export$66b33c055cbb625e = /*#__PURE__*/ function(PageLoadMetrics) {
    PageLoadMetrics["fmp"] = "fmp";
    PageLoadMetrics["tti"] = "tti";
    return PageLoadMetrics;
}({});
var $2d5891ef20441e70$export$3ce489cbe02dc21b = /*#__PURE__*/ function(PageSegmentLoadMetrics) {
    PageSegmentLoadMetrics["fmp"] = "fmp";
    PageSegmentLoadMetrics["tti"] = "tti";
    return PageSegmentLoadMetrics;
}({});
var $2d5891ef20441e70$export$341b330828bd3906 = /*#__PURE__*/ function(InteractionMetrics) {
    InteractionMetrics["response"] = "response";
    InteractionMetrics["result"] = "result";
    return InteractionMetrics;
}({});
var $2d5891ef20441e70$export$b9b20160f581e4f8 = /*#__PURE__*/ function(CustomMetrics) {
    CustomMetrics["duration"] = "duration";
    return CustomMetrics;
}({});
var $2d5891ef20441e70$export$79bf131685ad41d7 = "__SUBSCRIBE_ALL__";
var $2d5891ef20441e70$export$9f2bf58999404c75 = "fmp";
var $2d5891ef20441e70$export$837e0f79a8056912 = "inline-response";


var $023f43dc856f6264$var$MAX_EARLY_QUEUE_LENGTH = 250;
var $023f43dc856f6264$export$6123a44dc2384540 = function getGlobalEventStream() {
    if (!globalThis.__UFO_GLOBAL_EVENT_STREAM__) {
        var earlyStream = function() {
            var stream = [];
            return {
                __buffer_only__: true,
                push: function push(event) {
                    if (stream.length < $023f43dc856f6264$var$MAX_EARLY_QUEUE_LENGTH) stream.push(event);
                },
                getStream: function getStream() {
                    return stream;
                }
            };
        }();
        globalThis.__UFO_GLOBAL_EVENT_STREAM__ = earlyStream;
    }
    return globalThis.__UFO_GLOBAL_EVENT_STREAM__;
};
var $023f43dc856f6264$export$c1522520b417b066 = function setGlobalEventStream(eventStream) {
    var _globalThis$__UFO_GLO, _globalThis$__UFO_GLO2;
    if (globalThis.__UFO_GLOBAL_EVENT_STREAM__ && !((_globalThis$__UFO_GLO = globalThis.__UFO_GLOBAL_EVENT_STREAM__) !== null && _globalThis$__UFO_GLO !== void 0 && _globalThis$__UFO_GLO.__buffer_only__)) {
        (0, $3e9eb738655b0fdf$export$d53d07b6034c4560)("Global Event Stream already initialised. Ignoring new event stream setup");
        return;
    }
    if ((_globalThis$__UFO_GLO2 = globalThis.__UFO_GLOBAL_EVENT_STREAM__) !== null && _globalThis$__UFO_GLO2 !== void 0 && _globalThis$__UFO_GLO2.__buffer_only__) globalThis.__UFO_GLOBAL_EVENT_STREAM__.getStream().forEach(eventStream.push.bind(eventStream));
    globalThis.__UFO_GLOBAL_EVENT_STREAM__ = eventStream;
};
var $023f43dc856f6264$export$37863216db4b714d = function subscribeEvent(experienceId, callback) {
    return {
        type: (0, $2d5891ef20441e70$export$96253c35c37cf96b).SUBSCRIBE,
        payload: {
            experienceId: experienceId,
            callback: callback
        }
    };
};
var $023f43dc856f6264$export$ee1a7bd1fc9ea85e = function unsubscribeEvent(experienceId, callback) {
    return {
        type: (0, $2d5891ef20441e70$export$96253c35c37cf96b).UNSUBSCRIBE,
        payload: {
            experienceId: experienceId,
            callback: callback
        }
    };
};
var $023f43dc856f6264$export$7c957416596ca127 = function experiencePayloadEvent(data) {
    return {
        type: (0, $2d5891ef20441e70$export$96253c35c37cf96b).EXPERIENCE_PAYLOAD,
        payload: data
    };
};




var $9nAUV = parcelRequire("9nAUV");

var $2c9To = parcelRequire("2c9To");

var $7hJEL = parcelRequire("7hJEL");

var $6893333a1cb1d806$var$VisibilityChangeObserver = /*#__PURE__*/ function() {
    function VisibilityChangeObserver() {
        var _this = this;
        (0, (/*@__PURE__*/$parcel$interopDefault($9nAUV)))(this, VisibilityChangeObserver);
        (0, (/*@__PURE__*/$parcel$interopDefault($7hJEL)))(this, "started", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($7hJEL)))(this, "observers", []);
        (0, (/*@__PURE__*/$parcel$interopDefault($7hJEL)))(this, "broadcast", function() {
            _this.observers.forEach(function(fn) {
                return fn();
            });
            _this.observers = [];
        });
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($2c9To)))(VisibilityChangeObserver, [
        {
            key: "start",
            value: function start() {
                if (this.started) return;
                this.started = true;
                document.addEventListener("visibilitychange", this.broadcast);
                /**
       * According to https://developer.mozilla.org/en-US/docs/Web/API/Document/visibilitychange_event
       * Safari doesn’t fire visibilitychange as expected when the value of the visibilityState property transitions to hidden;
       * so for that case, you need to also include code to listen for the pagehide event.
       */ if ((0, $b0a6e7767848d0ef$export$15e172712955e18f)()) window.addEventListener("pagehide", this.broadcast);
            }
        },
        {
            key: "subscribe",
            value: function subscribe(callback) {
                this.observers.push(callback);
            }
        },
        {
            key: "unsubscribe",
            value: function unsubscribe(callback) {
                this.observers = this.observers.filter(function(fn) {
                    return fn !== callback;
                });
            }
        }
    ]);
    return VisibilityChangeObserver;
}();
var $6893333a1cb1d806$export$13e680397ec8f3eb = new $6893333a1cb1d806$var$VisibilityChangeObserver();



var $d59cb6d250faacac$export$5f490af6b2b115cf = function roundPerfNow() {
    return ~~performance.now();
};


var $14e4916a25efdb1b$export$81b70111112841a0 = {
    NOT_STARTED: {
        id: "NOT_STARTED",
        final: true
    },
    STARTED: {
        id: "STARTED"
    },
    IN_PROGRESS: {
        id: "IN_PROGRESS"
    },
    BLOCKED: {
        id: "BLOCKED"
    },
    RECOVERED: {
        id: "RECOVERED"
    },
    // isn't recovered IN_PROGRESS?
    SUCCEEDED: {
        id: "SUCCEEDED",
        final: true,
        success: true
    },
    SUCCEEDED_WAITING_FOR_DEPS: {
        id: "SUCCEEDED_WAITING_FOR_DEPS"
    },
    FAILED: {
        id: "FAILED",
        final: true
    },
    ABORTED: {
        id: "ABORTED",
        final: true
    }
};



var $7hJEL = parcelRequire("7hJEL");

var $5ad9187f97d33fcc$var$_UFOStateAvailableTra;
var $5ad9187f97d33fcc$var$UFOStateAvailableTransitions = ($5ad9187f97d33fcc$var$_UFOStateAvailableTra = {}, (0, (/*@__PURE__*/$parcel$interopDefault($7hJEL)))($5ad9187f97d33fcc$var$_UFOStateAvailableTra, (0, $14e4916a25efdb1b$export$81b70111112841a0).NOT_STARTED.id, [
    (0, $14e4916a25efdb1b$export$81b70111112841a0).STARTED.id
]), (0, (/*@__PURE__*/$parcel$interopDefault($7hJEL)))($5ad9187f97d33fcc$var$_UFOStateAvailableTra, (0, $14e4916a25efdb1b$export$81b70111112841a0).STARTED.id, [
    (0, $14e4916a25efdb1b$export$81b70111112841a0).IN_PROGRESS.id,
    (0, $14e4916a25efdb1b$export$81b70111112841a0).BLOCKED.id,
    (0, $14e4916a25efdb1b$export$81b70111112841a0).SUCCEEDED.id,
    (0, $14e4916a25efdb1b$export$81b70111112841a0).SUCCEEDED_WAITING_FOR_DEPS.id,
    (0, $14e4916a25efdb1b$export$81b70111112841a0).FAILED.id,
    (0, $14e4916a25efdb1b$export$81b70111112841a0).ABORTED.id
]), (0, (/*@__PURE__*/$parcel$interopDefault($7hJEL)))($5ad9187f97d33fcc$var$_UFOStateAvailableTra, (0, $14e4916a25efdb1b$export$81b70111112841a0).IN_PROGRESS.id, [
    (0, $14e4916a25efdb1b$export$81b70111112841a0).BLOCKED.id,
    (0, $14e4916a25efdb1b$export$81b70111112841a0).SUCCEEDED.id,
    (0, $14e4916a25efdb1b$export$81b70111112841a0).SUCCEEDED_WAITING_FOR_DEPS.id,
    (0, $14e4916a25efdb1b$export$81b70111112841a0).FAILED.id,
    (0, $14e4916a25efdb1b$export$81b70111112841a0).ABORTED.id
]), (0, (/*@__PURE__*/$parcel$interopDefault($7hJEL)))($5ad9187f97d33fcc$var$_UFOStateAvailableTra, (0, $14e4916a25efdb1b$export$81b70111112841a0).BLOCKED.id, [
    (0, $14e4916a25efdb1b$export$81b70111112841a0).RECOVERED.id,
    (0, $14e4916a25efdb1b$export$81b70111112841a0).ABORTED.id
]), (0, (/*@__PURE__*/$parcel$interopDefault($7hJEL)))($5ad9187f97d33fcc$var$_UFOStateAvailableTra, (0, $14e4916a25efdb1b$export$81b70111112841a0).RECOVERED.id, [
    (0, $14e4916a25efdb1b$export$81b70111112841a0).STARTED.id,
    (0, $14e4916a25efdb1b$export$81b70111112841a0).SUCCEEDED.id,
    (0, $14e4916a25efdb1b$export$81b70111112841a0).SUCCEEDED_WAITING_FOR_DEPS.id,
    (0, $14e4916a25efdb1b$export$81b70111112841a0).FAILED.id,
    (0, $14e4916a25efdb1b$export$81b70111112841a0).ABORTED.id
]), (0, (/*@__PURE__*/$parcel$interopDefault($7hJEL)))($5ad9187f97d33fcc$var$_UFOStateAvailableTra, (0, $14e4916a25efdb1b$export$81b70111112841a0).SUCCEEDED.id, [
    (0, $14e4916a25efdb1b$export$81b70111112841a0).STARTED.id
]), (0, (/*@__PURE__*/$parcel$interopDefault($7hJEL)))($5ad9187f97d33fcc$var$_UFOStateAvailableTra, (0, $14e4916a25efdb1b$export$81b70111112841a0).SUCCEEDED_WAITING_FOR_DEPS.id, [
    (0, $14e4916a25efdb1b$export$81b70111112841a0).SUCCEEDED.id,
    (0, $14e4916a25efdb1b$export$81b70111112841a0).FAILED.id,
    (0, $14e4916a25efdb1b$export$81b70111112841a0).ABORTED.id
]), (0, (/*@__PURE__*/$parcel$interopDefault($7hJEL)))($5ad9187f97d33fcc$var$_UFOStateAvailableTra, (0, $14e4916a25efdb1b$export$81b70111112841a0).FAILED.id, [
    (0, $14e4916a25efdb1b$export$81b70111112841a0).STARTED.id
]), (0, (/*@__PURE__*/$parcel$interopDefault($7hJEL)))($5ad9187f97d33fcc$var$_UFOStateAvailableTra, (0, $14e4916a25efdb1b$export$81b70111112841a0).ABORTED.id, [
    (0, $14e4916a25efdb1b$export$81b70111112841a0).STARTED.id
]), $5ad9187f97d33fcc$var$_UFOStateAvailableTra);
var $5ad9187f97d33fcc$export$178881f329fdb81f = function canTransition(state1, state2) {
    return $5ad9187f97d33fcc$var$UFOStateAvailableTransitions[state1.id] && $5ad9187f97d33fcc$var$UFOStateAvailableTransitions[state1.id].includes(state2.id);
};



function $fc12bd3e4b1db22a$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $fc12bd3e4b1db22a$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $fc12bd3e4b1db22a$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($7hJEL)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $fc12bd3e4b1db22a$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $fc12bd3e4b1db22a$var$getPageVisibleState = function getPageVisibleState() {
    return !(0, $b0a6e7767848d0ef$export$15e172712955e18f)() || !window.document || window.document.visibilityState === "visible" ? (0, $2d5891ef20441e70$export$a12c67b37a306b13).VISIBLE : (0, $2d5891ef20441e70$export$a12c67b37a306b13).HIDDEN;
};
var $fc12bd3e4b1db22a$export$c753e8669d30c8ad = function perfNowOrTimestamp(timestamp) {
    if (timestamp !== undefined) return ~~timestamp;
    return (0, $d59cb6d250faacac$export$5f490af6b2b115cf)();
};
var $fc12bd3e4b1db22a$export$d31c89db257648c = /*#__PURE__*/ function() {
    function UFOAbstractExperience(id, config) {
        var _this = this;
        var instanceId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
        (0, (/*@__PURE__*/$parcel$interopDefault($9nAUV)))(this, UFOAbstractExperience);
        (0, (/*@__PURE__*/$parcel$interopDefault($7hJEL)))(this, "state", (0, $14e4916a25efdb1b$export$81b70111112841a0).NOT_STARTED);
        (0, (/*@__PURE__*/$parcel$interopDefault($7hJEL)))(this, "instanceId", null);
        // for concurrent
        (0, (/*@__PURE__*/$parcel$interopDefault($7hJEL)))(this, "parent", null);
        (0, (/*@__PURE__*/$parcel$interopDefault($7hJEL)))(this, "category", null);
        (0, (/*@__PURE__*/$parcel$interopDefault($7hJEL)))(this, "metadata", {});
        (0, (/*@__PURE__*/$parcel$interopDefault($7hJEL)))(this, "onDoneCallbacks", []);
        (0, (/*@__PURE__*/$parcel$interopDefault($7hJEL)))(this, "childExperiences", []);
        (0, (/*@__PURE__*/$parcel$interopDefault($7hJEL)))(this, "explicitTimings", {});
        // @todo move to page load experience when proper classes/inheritance prepared
        (0, (/*@__PURE__*/$parcel$interopDefault($7hJEL)))(this, "isSSROutputAsFMP", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($7hJEL)))(this, "uuid", null);
        (0, (/*@__PURE__*/$parcel$interopDefault($7hJEL)))(this, "_until", null);
        (0, (/*@__PURE__*/$parcel$interopDefault($7hJEL)))(this, "metrics", {
            startTime: null,
            endTime: null,
            marks: []
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($7hJEL)))(this, "performanceConfig", {});
        (0, (/*@__PURE__*/$parcel$interopDefault($7hJEL)))(this, "setPageVisibleStateToMixed", function() {
            _this.pageVisibleState = (0, $2d5891ef20441e70$export$a12c67b37a306b13).MIXED;
            (0, $6893333a1cb1d806$export$13e680397ec8f3eb).unsubscribe(_this.setPageVisibleStateToMixed);
        });
        this.id = id;
        this.category = (config === null || config === void 0 ? void 0 : config.category) || null;
        this.until = (config === null || config === void 0 ? void 0 : config.until) || null;
        this.instanceId = instanceId;
        this.handleDoneBind = this._handleDoneExperience.bind(this);
        this.type = config.type;
        this.performanceType = config.performanceType;
        this.performanceConfig = config.performanceConfig || {};
        this.config = config;
        this.pageVisibleState = $fc12bd3e4b1db22a$var$getPageVisibleState();
        this.featureFlags = config.featureFlags || [];
        this.timings = config.timings || [];
        if (config.performanceType === (0, $1a9c5935e5bd21ea$export$cc26007c03242fff).PageLoad || config.performanceType === (0, $1a9c5935e5bd21ea$export$cc26007c03242fff).PageSegmentLoad) this.isSSROutputAsFMP = config.isSSROutputAsFMP || false;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($2c9To)))(UFOAbstractExperience, [
        {
            key: "transition",
            value: function() {
                var _transition = (0, (/*@__PURE__*/$parcel$interopDefault($5mLfW)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3rY0i))).mark(function _callee(newState, timestamp) {
                    var data;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($3rY0i))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                (0, $3e9eb738655b0fdf$export$b4958caff08a0960)("async transition", this.id, this.state.id, newState.id);
                                if (!(0, $5ad9187f97d33fcc$export$178881f329fdb81f)(this.state, newState)) {
                                    _context.next = 15;
                                    break;
                                }
                                (0, $3e9eb738655b0fdf$export$b4958caff08a0960)("TRANSITION: ".concat(this.id, " from ").concat(this.state.id, " to ").concat(newState.id, " successful"), this.state.final, !newState.final);
                                if (newState === (0, $14e4916a25efdb1b$export$81b70111112841a0).STARTED) this._reset();
                                if (this.state.final && !newState.final) {
                                    this.metrics.startTime = $fc12bd3e4b1db22a$export$c753e8669d30c8ad(timestamp);
                                    this.uuid = (0, $816lv.v4)();
                                }
                                this.state = newState;
                                if (!newState.final) {
                                    _context.next = 14;
                                    break;
                                }
                                this.metrics.endTime = $fc12bd3e4b1db22a$export$c753e8669d30c8ad(timestamp);
                                if (!this._isManualStateEnabled()) (0, $023f43dc856f6264$export$6123a44dc2384540)().push((0, $023f43dc856f6264$export$ee1a7bd1fc9ea85e)((0, $2d5891ef20441e70$export$79bf131685ad41d7), this.handleDoneBind));
                                _context.next = 11;
                                return this.exportData();
                            case 11:
                                data = _context.sent;
                                (0, $3e9eb738655b0fdf$export$b4958caff08a0960)("this.parent", this.parent);
                                (0, $023f43dc856f6264$export$6123a44dc2384540)().push((0, $023f43dc856f6264$export$7c957416596ca127)(data));
                            case 14:
                                return _context.abrupt("return", true);
                            case 15:
                                (0, $3e9eb738655b0fdf$export$b4958caff08a0960)("TRANSITION: ".concat(this.id, " from ").concat(this.state.id, " to ").concat(newState.id, " unsuccessful"));
                                (0, $3e9eb738655b0fdf$export$d53d07b6034c4560)("transition of ".concat(this.id, " from ").concat(this.state, " to ").concat(newState, " is not possible"));
                                return _context.abrupt("return", false);
                            case 18:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this);
                }));
                function transition(_x, _x2) {
                    return _transition.apply(this, arguments);
                }
                return transition;
            }()
        },
        {
            key: "start",
            value: function() {
                var _start = (0, (/*@__PURE__*/$parcel$interopDefault($5mLfW)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3rY0i))).mark(function _callee2(startTime) {
                    var transitionSuccessful;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($3rY0i))).wrap(function _callee2$(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                _context2.next = 2;
                                return this.transition((0, $14e4916a25efdb1b$export$81b70111112841a0).STARTED, startTime);
                            case 2:
                                transitionSuccessful = _context2.sent;
                                if (transitionSuccessful) {
                                    this.pageVisibleState = $fc12bd3e4b1db22a$var$getPageVisibleState();
                                    (0, $6893333a1cb1d806$export$13e680397ec8f3eb).subscribe(this.setPageVisibleStateToMixed);
                                    if (!this._isManualStateEnabled()) {
                                        (0, $3e9eb738655b0fdf$export$b4958caff08a0960)("subscribed", this.id);
                                        (0, $023f43dc856f6264$export$6123a44dc2384540)().push((0, $023f43dc856f6264$export$37863216db4b714d)((0, $2d5891ef20441e70$export$79bf131685ad41d7), this.handleDoneBind));
                                    }
                                }
                            case 4:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this);
                }));
                function start(_x3) {
                    return _start.apply(this, arguments);
                }
                return start;
            }()
        },
        {
            key: "mark",
            value: function mark(name, timestamp) {
                if (name !== (0, $2d5891ef20441e70$export$9f2bf58999404c75) && name !== (0, $2d5891ef20441e70$export$837e0f79a8056912)) this._mark(name, timestamp);
                else (0, $3e9eb738655b0fdf$export$d53d07b6034c4560)("please use markFMP or markInlineResponse for specialised marks");
            }
        },
        {
            key: "_mark",
            value: function _mark(name, timestamp) {
                this.metrics.marks.push({
                    name: name,
                    time: $fc12bd3e4b1db22a$export$c753e8669d30c8ad(timestamp)
                });
                this.transition((0, $14e4916a25efdb1b$export$81b70111112841a0).IN_PROGRESS);
            }
        },
        {
            key: "markFMP",
            value: function markFMP(timestamp) {
                this._mark((0, $2d5891ef20441e70$export$9f2bf58999404c75), timestamp);
            }
        },
        {
            key: "markInlineResponse",
            value: function markInlineResponse(timestamp) {
                this._mark((0, $2d5891ef20441e70$export$837e0f79a8056912), timestamp);
            }
        },
        {
            key: "_isManualStateEnabled",
            value: function _isManualStateEnabled() {
                return this.until === null;
            }
        },
        {
            key: "_validateManualState",
            value: function _validateManualState() {
                if (!this._isManualStateEnabled()) {
                    (0, $3e9eb738655b0fdf$export$d53d07b6034c4560)('manual change of state not allowed as "until" is defined');
                    return false;
                }
                return true;
            }
        },
        {
            key: "switchToEndState",
            value: function switchToEndState(state, config) {
                if (!(config !== null && config !== void 0 && config.force) && !this._validateManualState()) return null;
                if (config !== null && config !== void 0 && config.metadata) this.addMetadata(config.metadata);
                (0, $6893333a1cb1d806$export$13e680397ec8f3eb).unsubscribe(this.setPageVisibleStateToMixed);
                return this.transition(state);
            }
        },
        {
            key: "success",
            value: function() {
                var _success = (0, (/*@__PURE__*/$parcel$interopDefault($5mLfW)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3rY0i))).mark(function _callee3(config) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($3rY0i))).wrap(function _callee3$(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                return _context3.abrupt("return", this.switchToEndState((0, $14e4916a25efdb1b$export$81b70111112841a0).SUCCEEDED, config));
                            case 1:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3, this);
                }));
                function success(_x4) {
                    return _success.apply(this, arguments);
                }
                return success;
            }()
        },
        {
            key: "failure",
            value: function() {
                var _failure = (0, (/*@__PURE__*/$parcel$interopDefault($5mLfW)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3rY0i))).mark(function _callee4(config) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($3rY0i))).wrap(function _callee4$(_context4) {
                        while(true)switch(_context4.prev = _context4.next){
                            case 0:
                                return _context4.abrupt("return", this.switchToEndState((0, $14e4916a25efdb1b$export$81b70111112841a0).FAILED, config));
                            case 1:
                            case "end":
                                return _context4.stop();
                        }
                    }, _callee4, this);
                }));
                function failure(_x5) {
                    return _failure.apply(this, arguments);
                }
                return failure;
            }()
        },
        {
            key: "abort",
            value: function() {
                var _abort = (0, (/*@__PURE__*/$parcel$interopDefault($5mLfW)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3rY0i))).mark(function _callee5(config) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($3rY0i))).wrap(function _callee5$(_context5) {
                        while(true)switch(_context5.prev = _context5.next){
                            case 0:
                                return _context5.abrupt("return", this.switchToEndState((0, $14e4916a25efdb1b$export$81b70111112841a0).ABORTED, config));
                            case 1:
                            case "end":
                                return _context5.stop();
                        }
                    }, _callee5, this);
                }));
                function abort(_x6) {
                    return _abort.apply(this, arguments);
                }
                return abort;
            }()
        },
        {
            key: "addMetadata",
            value: function addMetadata(data) {
                Object.assign(this.metadata, data);
            }
        },
        {
            key: "_handleDoneExperience",
            value: function _handleDoneExperience(data) {
                (0, $3e9eb738655b0fdf$export$b4958caff08a0960)("_handleDoneExperience in", this.id, data.state, data, this._until);
                if (data.state.final) {
                    if (this._until !== null) {
                        var _this$_until = this._until(data), done = _this$_until.done, state = _this$_until.state;
                        if (done && !this.state.final) this.transition(state);
                    }
                }
            }
        },
        {
            key: "getId",
            value: function() {
                var _getId = (0, (/*@__PURE__*/$parcel$interopDefault($5mLfW)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3rY0i))).mark(function _callee6() {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($3rY0i))).wrap(function _callee6$(_context6) {
                        while(true)switch(_context6.prev = _context6.next){
                            case 0:
                                return _context6.abrupt("return", this.id);
                            case 1:
                            case "end":
                                return _context6.stop();
                        }
                    }, _callee6, this);
                }));
                function getId() {
                    return _getId.apply(this, arguments);
                }
                return getId;
            }()
        },
        {
            key: "exportData",
            value: function() {
                var _exportData = (0, (/*@__PURE__*/$parcel$interopDefault($5mLfW)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3rY0i))).mark(function _callee7() {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($3rY0i))).wrap(function _callee7$(_context7) {
                        while(true)switch(_context7.prev = _context7.next){
                            case 0:
                                _context7.next = 2;
                                return this.getId();
                            case 2:
                                _context7.t0 = _context7.sent;
                                _context7.t1 = this.uuid;
                                _context7.t2 = this.type;
                                _context7.t3 = (0, $5fcd8a7ce83b2a21$export$2295b861f318254a) || "unknown";
                                _context7.t4 = this.performanceType;
                                _context7.t5 = this.category;
                                _context7.t6 = this.state;
                                _context7.t7 = $fc12bd3e4b1db22a$var$_objectSpread({}, this.metadata);
                                _context7.t8 = $fc12bd3e4b1db22a$var$_objectSpread({}, this.metrics);
                                _context7.t9 = (0, (/*@__PURE__*/$parcel$interopDefault($cdd13f37d92964d6$exports)))(this.childExperiences);
                                _context7.t10 = {
                                    success: !!this.state.success,
                                    startTime: this.metrics.startTime,
                                    duration: (this.metrics.endTime || 0) - (this.metrics.startTime || 0)
                                };
                                _context7.t11 = this.config.platform || null;
                                _context7.t12 = this.pageVisibleState;
                                _context7.t13 = this.featureFlags;
                                _context7.t14 = this.isSSROutputAsFMP;
                                _context7.t15 = this.timings;
                                _context7.t16 = this.explicitTimings;
                                _context7.t17 = this.performanceConfig;
                                return _context7.abrupt("return", {
                                    id: _context7.t0,
                                    uuid: _context7.t1,
                                    type: _context7.t2,
                                    schemaVersion: _context7.t3,
                                    performanceType: _context7.t4,
                                    category: _context7.t5,
                                    state: _context7.t6,
                                    metadata: _context7.t7,
                                    metrics: _context7.t8,
                                    children: _context7.t9,
                                    result: _context7.t10,
                                    platform: _context7.t11,
                                    pageVisibleState: _context7.t12,
                                    featureFlags: _context7.t13,
                                    isSSROutputAsFMP: _context7.t14,
                                    timings: _context7.t15,
                                    explicitTimings: _context7.t16,
                                    performanceConfig: _context7.t17
                                });
                            case 21:
                            case "end":
                                return _context7.stop();
                        }
                    }, _callee7, this);
                }));
                function exportData() {
                    return _exportData.apply(this, arguments);
                }
                return exportData;
            }()
        },
        {
            key: "_reset",
            value: function _reset() {
                this.parent = null;
                this.metadata = {};
                this.onDoneCallbacks = [];
                this.childExperiences = [];
                this.metrics = {
                    startTime: null,
                    endTime: null,
                    marks: []
                };
                this._until = this.until ? this.until() : null;
            }
        }
    ]);
    return UFOAbstractExperience;
}();


function $f70b881a8606f907$var$_createSuper(t) {
    var r = $f70b881a8606f907$var$_isNativeReflectConstruct();
    return function() {
        var e, o = (0, (/*@__PURE__*/$parcel$interopDefault($bSTwW)))(t);
        if (r) {
            var s = (0, (/*@__PURE__*/$parcel$interopDefault($bSTwW)))(this).constructor;
            e = Reflect.construct(o, arguments, s);
        } else e = o.apply(this, arguments);
        return (0, (/*@__PURE__*/$parcel$interopDefault($4hWn5)))(this, e);
    };
}
function $f70b881a8606f907$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($f70b881a8606f907$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $f70b881a8606f907$export$c00d22927c60484a = /*#__PURE__*/ function(_UFOAbstractExperienc) {
    (0, (/*@__PURE__*/$parcel$interopDefault($keLsu)))(UFOExperience, _UFOAbstractExperienc);
    var _super = $f70b881a8606f907$var$_createSuper(UFOExperience);
    function UFOExperience() {
        (0, (/*@__PURE__*/$parcel$interopDefault($9nAUV)))(this, UFOExperience);
        return _super.apply(this, arguments);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($2c9To)))(UFOExperience);
}((0, $fc12bd3e4b1db22a$export$d31c89db257648c));


var $7b872a53f039eaa4$export$a9bc342436c1b7b3 = function getUfoExperience(moduleName, name) {
    var componentSuffix = $7b872a53f039eaa4$export$c019a7e50ba82b2a(moduleName) ? ".".concat($7b872a53f039eaa4$export$da0bad02a511a377(moduleName)) : "";
    return new (0, $f70b881a8606f907$export$c00d22927c60484a)(name, {
        type: (0, $1a9c5935e5bd21ea$export$994164cf3ae1cc9a).Load,
        performanceType: (0, $1a9c5935e5bd21ea$export$cc26007c03242fff).Custom,
        platform: {
            component: "remote-module-loader".concat(componentSuffix)
        }
    });
};
var $7b872a53f039eaa4$export$da0bad02a511a377 = function formatModuleName(moduleName) {
    return moduleName.replace(/\//g, "-").replace(/[^a-zA-Z0-9-.]/g, "");
};
var $7b872a53f039eaa4$export$c019a7e50ba82b2a = function shouldAppendComponentSuffix(moduleName) {
    return moduleName !== "" && moduleName !== "@atlassian/app-switcher-remote-module";
};


function $69a45819fff8e706$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $69a45819fff8e706$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $69a45819fff8e706$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $69a45819fff8e706$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $69a45819fff8e706$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $69a45819fff8e706$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
var $69a45819fff8e706$var$isRemoteModuleConfig = function isRemoteModuleConfig(config) {
    return (config === null || config === void 0 ? void 0 : config.moduleUri) !== undefined;
};
var $69a45819fff8e706$var$AtlassianSystemRemoteFrontendSdk = /*#__PURE__*/ function() {
    function AtlassianSystemRemoteFrontendSdk(plugin) {
        (0, (/*@__PURE__*/$parcel$interopDefault($9nAUV)))(this, AtlassianSystemRemoteFrontendSdk);
        // list of remote modules to be imported
        // map of the above modules
        // map of the remote modules that have been fetched
        (0, (/*@__PURE__*/$parcel$interopDefault($7hJEL)))(this, "resolvedModuleMap", new Map());
        (0, (/*@__PURE__*/$parcel$interopDefault($7hJEL)))(this, "storageClient", new (0, $21f5e7ed4d2a3a0a$export$2e2bcd8739ae039)("remote-module-loader-bifrost-override", {
            storageEngine: "sessionStorage"
        }));
        this.plugin = plugin;
        this.importMap = this.findPluginManifest(plugin);
        this.setImportMaps([
            this.importMap
        ]);
        this.renderUfoExperience = (0, $7b872a53f039eaa4$export$a9bc342436c1b7b3)(this.getModuleName(), "render");
    }
    /**
   * Using the dimensions defined in the plugin, search through the manifest and find the most applicable one
   *
   * @param plugin
   * @private
   */ return (0, (/*@__PURE__*/$parcel$interopDefault($2c9To)))(AtlassianSystemRemoteFrontendSdk, [
        {
            key: "findPluginManifest",
            value: function findPluginManifest(plugin) {
                if (plugin) {
                    var manifestMap = plugin.manifestMap, dimensions = plugin.dimensions;
                    var manifestEnv = manifestMap.get(dimensions.env);
                    if (manifestEnv) {
                        // This is not currently allowed in the types but is an escape hatch for not defining any variants
                        if ($69a45819fff8e706$var$isRemoteModuleConfig(manifestEnv)) return manifestEnv;
                        /**
           * If we request a `latest` dimension, but only have `stable` in our map then we use it.
           * If we request a `stable` dimension, but only have `latest` an error will be thrown due to the variant order.
           */ var variantIndex = (0, $50503f5ef640dbae$export$5672934650c3eabe).indexOf(dimensions.variant);
                        if (variantIndex > -1) {
                            for(var i = variantIndex; i < (0, $50503f5ef640dbae$export$5672934650c3eabe).length; i++){
                                var manifestVariant = manifestEnv.get((0, $50503f5ef640dbae$export$5672934650c3eabe)[i]);
                                if ($69a45819fff8e706$var$isRemoteModuleConfig(manifestVariant)) {
                                    this.variant = (0, $50503f5ef640dbae$export$5672934650c3eabe)[i]; // set the variant applied for use later
                                    return manifestVariant;
                                }
                            }
                            throw new Error('No valid "variant" dimensions defined in plugin for ['.concat(dimensions.variant, "]."));
                        }
                        throw new Error('Invalid "variant" dimension defined in plugin for ['.concat(dimensions.variant, "]."));
                    }
                    throw new Error('No "env" dimension defined in plugin for ['.concat(dimensions.env, "]."));
                }
                throw new Error('Invalid "plugin" provided to SDK.');
            }
        },
        {
            key: "getModuleName",
            value: function getModuleName() {
                var importMap = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.importMap;
                if (importMap) return importMap.moduleName;
                return "";
            }
        },
        {
            key: "loadFromQueryAndSaveToSession",
            value: function loadFromQueryAndSaveToSession(key) {
                try {
                    var params = new URLSearchParams(window.location.search);
                    if (params.has("".concat(key, "-clear"))) {
                        this.storageClient.removeItem(key);
                        return undefined;
                    }
                    if (params.has(key)) {
                        var value = params.get(key);
                        this.storageClient.setItemWithExpiry(key, value, 10800000); // 3 hours in ms
                        return value;
                    } else {
                        var itemStr = this.storageClient.getItem(key);
                        if (!itemStr) return undefined;
                        return itemStr;
                    }
                } catch (error) {
                    console.error("Error loading value from query or sessionStorage: ".concat(error));
                    return undefined;
                }
            }
        },
        {
            key: "addBifrostOverride",
            value: function addBifrostOverride(url) {
                try {
                    var _this$plugin, _this$plugin2;
                    if (!((_this$plugin = this.plugin) !== null && _this$plugin !== void 0 && _this$plugin.bifrostOverrideKey)) return url;
                    var bifrostOverrideValue = this.loadFromQueryAndSaveToSession((_this$plugin2 = this.plugin) === null || _this$plugin2 === void 0 ? void 0 : _this$plugin2.bifrostOverrideKey);
                    if (!bifrostOverrideValue) return url;
                    var urlToUpdate = new URL(url);
                    if (urlToUpdate.protocol === "https:" || urlToUpdate.protocol === "http:") {
                        var inputParams = new URLSearchParams(urlToUpdate.search);
                        inputParams.set("bifrost-override", bifrostOverrideValue);
                        urlToUpdate.search = inputParams.toString();
                    }
                    return urlToUpdate.toString();
                } catch (e) {
                    console.error("Error adding bifrost override to url. Falling back to original url.");
                    return url;
                }
            }
        },
        {
            key: "getModuleUri",
            value: function getModuleUri() {
                var importMap = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.importMap;
                if (importMap) {
                    var _this$plugin3, _this$plugin4;
                    var moduleUri = importMap.moduleUri;
                    if ((_this$plugin3 = this.plugin) !== null && _this$plugin3 !== void 0 && _this$plugin3.moduleUriMapper) moduleUri = this.plugin.moduleUriMapper(importMap.moduleUri, this.variant, (0, $6f8c05a54031a4ab$export$2e2bcd8739ae039));
                    if ((_this$plugin4 = this.plugin) !== null && _this$plugin4 !== void 0 && _this$plugin4.bifrostOverrideKey) moduleUri = this.addBifrostOverride(moduleUri);
                    return moduleUri;
                }
                return "";
            }
        },
        {
            key: "getResolvedModule",
            value: function getResolvedModule() {
                return this.resolvedModuleMap.get(this.getModuleName());
            }
        },
        {
            key: "isModuleRegisteredAndValid",
            value: function isModuleRegisteredAndValid() {
                // a module can appear in the registry as `null` if it fails to load
                return System.has(this.getModuleUri()) && !!System.get(this.getModuleUri()) && !!this.getResolvedModule();
            }
        },
        {
            key: "setImportMaps",
            value: function setImportMaps(importMaps) {
                var _this = this;
                var scopedModules = null;
                try {
                    var _this$plugin5;
                    // Set the external packages into the System registry using the locally resolved (from the Product) packages
                    scopedModules = (0, $3a937228d996db9e$export$5d60344e1be8d663)(importMaps.flatMap(function(item) {
                        return item.externals;
                    }), ((_this$plugin5 = this.plugin) === null || _this$plugin5 === void 0 ? void 0 : _this$plugin5.name) || (0, $7215130d741fbd54$export$a80387b071fd4173).AppSwitcher);
                } catch (e) {
                    // TODO add logger
                    console.error(e);
                }
                System.addImportMap(importMaps.reduce(function(acc, item) {
                    var moduleUri = _this.getModuleUri(item);
                    acc.imports[item.moduleName] = moduleUri;
                    if (scopedModules && item.externals.length) {
                        acc.scopes[moduleUri] = {};
                        var _iterator = $69a45819fff8e706$var$_createForOfIteratorHelper(item.externals), _step;
                        try {
                            for(_iterator.s(); !(_step = _iterator.n()).done;){
                                var external = _step.value;
                                var externalModuleIdentifier = "name" in external ? external.name : external.module;
                                acc.scopes[moduleUri][externalModuleIdentifier] = scopedModules[externalModuleIdentifier];
                            }
                        } catch (err) {
                            _iterator.e(err);
                        } finally{
                            _iterator.f();
                        }
                    }
                    return acc;
                }, {
                    imports: {},
                    scopes: {}
                }));
            }
        },
        {
            key: "fetchModule",
            value: function() {
                var _fetchModule = (0, (/*@__PURE__*/$parcel$interopDefault($5mLfW)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3rY0i))).mark(function _callee() {
                    var moduleName, module;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($3rY0i))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                if (!this.importMap) {
                                    _context.next = 7;
                                    break;
                                }
                                moduleName = this.importMap.moduleName;
                                _context.next = 4;
                                return (0, $ecf01f3d46e8c943$export$1117267eb6098dcd)(moduleName);
                            case 4:
                                module = _context.sent;
                                this.resolvedModuleMap.set(moduleName, module);
                                return _context.abrupt("return", module);
                            case 7:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this);
                }));
                function fetchModule() {
                    return _fetchModule.apply(this, arguments);
                }
                return fetchModule;
            }()
        },
        {
            key: "resolveExport",
            value: function resolveExport(exportName) {
                var resolvedModule = this.getResolvedModule();
                if (resolvedModule) {
                    if (exportName) return resolvedModule[exportName];
                    return resolvedModule;
                }
            }
        },
        {
            key: "renderComponent",
            value: function renderComponent() {
                var exportName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "default";
                var props = arguments.length > 1 ? arguments[1] : undefined;
                var fallback = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
                var children = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
                var experience = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
                var onEvent = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : (0, $ecf01f3d46e8c943$export$ca96bc7645ad7951);
                var component = this.resolveExport(exportName);
                if (component) {
                    var componentToRender;
                    if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).isValidElement(component)) componentToRender = props ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).cloneElement(component, props, children) : component;
                    else componentToRender = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement(component, props, children);
                    onEvent({
                        type: "render-complete"
                    });
                    experience === null || experience === void 0 || experience.success({
                        metadata: {
                            moduleName: this.getModuleName()
                        }
                    });
                    return componentToRender;
                }
                return fallback;
            }
        }
    ]);
}();
var $69a45819fff8e706$export$2e2bcd8739ae039 = $69a45819fff8e706$var$AtlassianSystemRemoteFrontendSdk;



var $907WG = parcelRequire("907WG");

var $dAx5m = parcelRequire("dAx5m");


/**
 * This hook is responsible for fetching the module from it's remote address.
 * Note it won't reload if it is already in the registry.
 *
 * @param remoteFrontendSdk
 * @param options
 */ var $d58962a5b15a04e6$var$useRemoteModuleLoader = function useRemoteModuleLoader(remoteFrontendSdk) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, $ecf01f3d46e8c943$export$b972f8ca633eb047);
    var _useState = (0, $dAx5m.useState)({
        status: remoteFrontendSdk.isModuleRegisteredAndValid() ? "done" : "initial"
    }), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($907WG)))(_useState, 2), state = _useState2[0], setStatus = _useState2[1];
    var status = state.status, error = state.error;
    var onError = options.onError, onEvent = options.onEvent;
    var moduleName = remoteFrontendSdk.getModuleName();
    var experience = (0, $dAx5m.useMemo)(function() {
        return (0, $7b872a53f039eaa4$export$a9bc342436c1b7b3)(moduleName, "fetch");
    }, [
        moduleName
    ]);
    (0, $dAx5m.useEffect)(function() {
        return function() {
            experience.abort({
                metadata: {
                    moduleName: moduleName
                }
            });
        };
    }, [
        experience,
        moduleName
    ]);
    (0, $dAx5m.useEffect)(function() {
        if (status === "error" && typeof onError === "function") onError(error);
    }, [
        error,
        status,
        onError
    ]);
    (0, $dAx5m.useEffect)(function() {
        // we don't want to re-run the experience if the module is already in the registry and has been loaded
        if (status === "initial") {
            experience.start();
            setStatus({
                status: "loading"
            });
            remoteFrontendSdk.fetchModule().then(function() {
                onEvent === null || onEvent === void 0 || onEvent({
                    type: "fetch-complete"
                });
                experience.success({
                    metadata: {
                        moduleName: moduleName
                    }
                });
                setStatus({
                    status: "done"
                });
            }).catch(function(error) {
                onEvent === null || onEvent === void 0 || onEvent({
                    type: "fetch-error"
                });
                experience.failure({
                    metadata: {
                        error: error,
                        moduleName: moduleName
                    }
                });
                setStatus({
                    error: error,
                    status: "error"
                });
            });
        }
    }, [
        status,
        remoteFrontendSdk,
        onError,
        experience,
        moduleName,
        onEvent
    ]);
    return state;
};
var $d58962a5b15a04e6$export$2e2bcd8739ae039 = $d58962a5b15a04e6$var$useRemoteModuleLoader;


function $b4fa85adcec6b9c2$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $b4fa85adcec6b9c2$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $b4fa85adcec6b9c2$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($7hJEL)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $b4fa85adcec6b9c2$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $b4fa85adcec6b9c2$var$preloadedModuleMap = new WeakMap();
/**
 * Create an SDK instance for a given plugin aand cache it in the WeakMap so that if a plugin is no longer referenced
 * we clean up the sdk from the cache
 *
 * @param remotePlugin
 */ var $b4fa85adcec6b9c2$var$cacheAndGetSdkForPlugin = function cacheAndGetSdkForPlugin(remotePlugin) {
    var cachedSdk = $b4fa85adcec6b9c2$var$preloadedModuleMap.get(remotePlugin);
    if (cachedSdk) return cachedSdk;
    var sdk = new (0, $69a45819fff8e706$export$2e2bcd8739ae039)(remotePlugin);
    $b4fa85adcec6b9c2$var$preloadedModuleMap.set(remotePlugin, sdk);
    return sdk;
};
/**
 * Preload a plugin by instantiating it and firing off the request for the module in the registry
 *
 * @param remotePlugin
 * @param options
 */ var $b4fa85adcec6b9c2$var$useRemoteModule = function useRemoteModule(remotePlugin) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, $ecf01f3d46e8c943$export$b972f8ca633eb047);
    var remoteFrontendSdk = $b4fa85adcec6b9c2$var$cacheAndGetSdkForPlugin(remotePlugin);
    var experience = remoteFrontendSdk.renderUfoExperience;
    var moduleName = remoteFrontendSdk.getModuleName();
    (0, $dAx5m.useEffect)(function() {
        if (experience.state.id === "NOT_STARTED") experience.start();
    }, [
        experience
    ]);
    var _useAnalyticsEvents = (0, $77c630021457167b$export$5bf35293e545f20c)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    (0, $dAx5m.useEffect)(function() {
        var analyticsEvent = createAnalyticsEvent({
            action: "rendered",
            actionSubject: "remoteModule",
            actionSubjectId: "useRemoteModule",
            attributes: {
                dimensions: remotePlugin.dimensions,
                plugin: remotePlugin.constructor.name
            }
        });
        analyticsEvent.fire(options === null || options === void 0 ? void 0 : options.analyticsChannel);
    }, [
        createAnalyticsEvent,
        remotePlugin,
        options.analyticsChannel
    ]);
    var optionsWithError = (0, $dAx5m.useMemo)(function() {
        var onError = function onError(error) {
            var _options$onError;
            experience.failure({
                metadata: {
                    moduleName: moduleName
                }
            });
            options === null || options === void 0 || (_options$onError = options.onError) === null || _options$onError === void 0 || _options$onError.call(options, error);
        };
        return $b4fa85adcec6b9c2$var$_objectSpread($b4fa85adcec6b9c2$var$_objectSpread({}, options), {}, {
            onError: onError
        });
    }, [
        experience,
        moduleName,
        options
    ]);
    (0, $d58962a5b15a04e6$export$2e2bcd8739ae039)(remoteFrontendSdk, optionsWithError);
    return remoteFrontendSdk;
};
var $b4fa85adcec6b9c2$export$2e2bcd8739ae039 = $b4fa85adcec6b9c2$var$useRemoteModule;


var $8ad0d9ac8e6fa9ee$var$_excluded = [
    "analyticsChannel",
    "remotePlugin",
    "exportName",
    "children",
    "Fallback"
], $8ad0d9ac8e6fa9ee$var$_excluded2 = [
    "analyticsChannel",
    "remotePlugin",
    "ErrorFallback",
    "onEvent"
];
var $8ad0d9ac8e6fa9ee$var$InternalRemoteComponent = function InternalRemoteComponent(_ref) {
    var analyticsChannel = _ref.analyticsChannel, remotePlugin = _ref.remotePlugin, _ref$exportName = _ref.exportName, exportName = _ref$exportName === void 0 ? "default" : _ref$exportName, _ref$children = _ref.children, children = _ref$children === void 0 ? null : _ref$children, _ref$Fallback = _ref.Fallback, Fallback = _ref$Fallback === void 0 ? null : _ref$Fallback, componentProps = (0, (/*@__PURE__*/$parcel$interopDefault($ldcUZ)))(_ref, $8ad0d9ac8e6fa9ee$var$_excluded);
    var _useState = (0, $dAx5m.useState)(), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($907WG)))(_useState, 2), setError = _useState2[1];
    var _useAnalyticsEvents = (0, $77c630021457167b$export$5bf35293e545f20c)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    (0, $dAx5m.useEffect)(function() {
        var analyticsEvent = createAnalyticsEvent({
            action: "rendered",
            actionSubject: "remoteModule",
            actionSubjectId: "remoteComponent",
            attributes: {
                exportName: exportName,
                dimensions: remotePlugin.dimensions,
                plugin: remotePlugin.constructor.name
            }
        });
        analyticsEvent.fire(analyticsChannel);
    }, [
        analyticsChannel,
        createAnalyticsEvent,
        exportName,
        remotePlugin
    ]);
    var onError = (0, $dAx5m.useCallback)(function(error) {
        // this is a workaround to throw an error from an async function
        setError(function() {
            throw error;
        });
    }, []);
    var remoteFrontendSdk = (0, $b4fa85adcec6b9c2$export$2e2bcd8739ae039)(remotePlugin, {
        analyticsChannel: analyticsChannel,
        onError: onError,
        onEvent: componentProps.onEvent
    });
    (0, $dAx5m.useEffect)(function() {
        return function() {
            remoteFrontendSdk.renderUfoExperience.abort({
                metadata: {
                    moduleName: remoteFrontendSdk.getModuleName()
                }
            });
        };
    }, [
        remoteFrontendSdk
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).Fragment, null, remoteFrontendSdk.renderComponent(exportName, componentProps, Fallback, children, remoteFrontendSdk.renderUfoExperience, componentProps.onEvent));
};
var $8ad0d9ac8e6fa9ee$var$RemoteComponent = function RemoteComponent(_ref2) {
    var analyticsChannel = _ref2.analyticsChannel, remotePlugin = _ref2.remotePlugin, _ref2$ErrorFallback = _ref2.ErrorFallback, ErrorFallback = _ref2$ErrorFallback === void 0 ? null : _ref2$ErrorFallback, _ref2$onEvent = _ref2.onEvent, onEvent = _ref2$onEvent === void 0 ? (0, $ecf01f3d46e8c943$export$ca96bc7645ad7951) : _ref2$onEvent, props = (0, (/*@__PURE__*/$parcel$interopDefault($ldcUZ)))(_ref2, $8ad0d9ac8e6fa9ee$var$_excluded2);
    (0, $dAx5m.useEffect)(function() {
        return function() {
            onEvent({
                type: "unmount"
            });
        };
    }, [
        onEvent
    ]);
    var onError = (0, $dAx5m.useCallback)(function(error) {
        onEvent({
            error: error,
            type: "render-error"
        });
    }, [
        onEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $44cf895ce6ebfc4f$export$2e2bcd8739ae039), {
        analyticsChannel: analyticsChannel,
        remotePlugin: remotePlugin,
        onError: onError,
        fallback: ErrorFallback
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement($8ad0d9ac8e6fa9ee$var$InternalRemoteComponent, (0, (/*@__PURE__*/$parcel$interopDefault($e4a0920c6cdbec99$exports)))({
        analyticsChannel: analyticsChannel,
        remotePlugin: remotePlugin,
        onEvent: onEvent
    }, props)));
};
var $8ad0d9ac8e6fa9ee$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $dAx5m.memo)($8ad0d9ac8e6fa9ee$var$RemoteComponent);



var $djcZD = parcelRequire("djcZD");
const $74c8ea88f09411d2$export$e80f27629a985915 = (0, $ku6eE.default).div`
  padding: 0;
  max-height: 80vh;
`;
const $74c8ea88f09411d2$var$remoteSwitcherPlugin = new (0, $95c1a5f2fa2f5ceb$export$2e2bcd8739ae039)({
    env: (0, $djcZD.getEnv)() == "prod" ? "production" : "staging",
    variant: "latest"
});
const $74c8ea88f09411d2$var$AtlassianSwitcherPopup = ()=>{
    const { formatMessage: formatMessage } = (0, $dZHnD.default)();
    const [isAppSwitcherOpen, setIsAppSwitcherOpen] = (0, $dAx5m.useState)(false);
    const toggleAppSwitcherOpen = (0, $dAx5m.useCallback)(()=>setIsAppSwitcherOpen((isOpen)=>!isOpen), []);
    const closeAppSwitcher = (0, $dAx5m.useCallback)(()=>setIsAppSwitcherOpen(false), []);
    return /*#__PURE__*/ (0, $bibO8.jsx)((0, $7vqkt.default), {
        placement: "bottom-start",
        rootBoundary: "document",
        onClose: closeAppSwitcher,
        isOpen: isAppSwitcherOpen,
        content: ()=>/*#__PURE__*/ (0, $bibO8.jsx)($74c8ea88f09411d2$export$e80f27629a985915, {
                children: /*#__PURE__*/ (0, $bibO8.jsx)((0, $8ad0d9ac8e6fa9ee$export$2e2bcd8739ae039), {
                    remotePlugin: $74c8ea88f09411d2$var$remoteSwitcherPlugin,
                    analyticsChannel: "navigation",
                    ErrorFallback: /*#__PURE__*/ (0, $bibO8.jsx)((0, $3R0Tv.AtlassianSwitcherLoader), {
                        appearance: "standalone",
                        product: "manage-profile"
                    }),
                    appearance: "standalone",
                    product: "manage-profile"
                })
            }),
        trigger: (triggerProps)=>/*#__PURE__*/ (0, $bibO8.jsx)((0, $df0c41c95bca5417$export$2e2bcd8739ae039), {
                product: "manage-profile",
                children: /*#__PURE__*/ (0, $bibO8.jsx)((0, $8c830ea895f999ba$export$9923361bd43fa030), {
                    tooltip: formatMessage({
                        id: "ptc-directory.app-switcher-popup.tooltip",
                        defaultMessage: "Switch to...",
                        description: "Tooltip for the app switcher"
                    }),
                    onClick: toggleAppSwitcherOpen,
                    ...triggerProps
                })
            })
    });
};
var $74c8ea88f09411d2$export$2e2bcd8739ae039 = $74c8ea88f09411d2$var$AtlassianSwitcherPopup;




parcelRequire("jShba");
var $grRLU = parcelRequire("grRLU");
var $58n8k = parcelRequire("58n8k");

var $bibO8 = parcelRequire("bibO8");
parcelRequire("dAx5m");
const $2990ea8d7d8a8d03$var$AtlassianAccountLogo = ({ textColor: textColor })=>{
    return /*#__PURE__*/ (0, $bibO8.jsxs)("svg", {
        height: 24,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 315 32",
        children: [
            /*#__PURE__*/ (0, $bibO8.jsx)("path", {
                fill: "#fff",
                fillOpacity: 0,
                d: "M0 0h315v32H0z"
            }),
            /*#__PURE__*/ (0, $bibO8.jsx)("path", {
                d: "M213.18 21.594c1.696 0 3.328-.192 5.216-.576l1.76 4.768h3.232L215.1 4.762h-3.648l-8.288 21.024h3.232l1.76-4.736c1.792.352 3.424.544 5.024.544Zm0-2.56c-1.28 0-2.592-.128-4.16-.384l4.256-11.552 4.256 11.52c-1.632.256-3.008.416-4.352.416ZM236.607 22.906c-.992.352-2.016.576-3.648.576-4.192 0-5.92-2.624-5.92-5.728 0-3.104 1.696-5.728 5.856-5.728 1.504 0 2.592.288 3.616.768v-2.56c-1.248-.576-2.368-.768-3.808-.768-5.696 0-8.352 3.456-8.352 8.288 0 4.896 2.656 8.352 8.352 8.352 1.472 0 2.944-.224 3.904-.736v-2.464ZM251.044 22.906c-.992.352-2.016.576-3.648.576-4.192 0-5.92-2.624-5.92-5.728 0-3.104 1.696-5.728 5.856-5.728 1.504 0 2.592.288 3.616.768v-2.56c-1.248-.576-2.368-.768-3.808-.768-5.696 0-8.352 3.456-8.352 8.288 0 4.896 2.656 8.352 8.352 8.352 1.472 0 2.944-.224 3.904-.736v-2.464ZM260.842 26.106c4.768 0 7.552-3.552 7.552-8.352 0-4.8-2.784-8.288-7.552-8.288-4.8 0-7.616 3.488-7.616 8.288 0 4.8 2.816 8.352 7.616 8.352Zm0-14.08c3.392 0 4.864 2.688 4.864 5.728 0 3.04-1.472 5.792-4.864 5.792-3.424 0-4.928-2.752-4.928-5.792s1.504-5.728 4.928-5.728ZM271.272 19.162c0 4.416 2.112 6.944 5.792 6.944 2.144 0 4.032-1.056 5.056-2.944v2.624h2.752v-16h-2.752v8.896c0 3.232-1.76 4.928-4.32 4.928-2.624 0-3.776-1.28-3.776-4.16V9.786h-2.752v9.376ZM302.629 16.41c0-4.416-2.112-6.944-5.792-6.944-2.144 0-4.032 1.056-5.056 2.944V9.786h-2.752v16h2.752V16.89c0-3.232 1.76-4.928 4.32-4.928 2.624 0 3.776 1.28 3.776 4.16v9.664h2.752V16.41ZM310.275 20.826v-8.48h4.256v-2.56h-4.256V6.394h-2.688v3.392h-2.592v2.56h2.592v8.544c0 2.976 1.664 4.992 5.088 4.992.832 0 1.376-.128 1.856-.256V22.97c-.48.096-1.088.224-1.728.224-1.696 0-2.528-.96-2.528-2.368Z",
                fill: textColor
            }),
            /*#__PURE__*/ (0, $bibO8.jsx)("path", {
                d: "M106.571 11.723c0 2.888 1.34 5.18 6.578 6.19 3.125.653 3.779 1.16 3.779 2.202 0 1.013-.654 1.667-2.856 1.667-2.562 0-5.597-.863-7.591-2.055v4.703c1.577.772 3.661 1.638 7.53 1.638 5.479 0 7.652-2.44 7.652-6.072 0-3.423-1.814-5.03-6.937-6.132-2.828-.626-3.514-1.25-3.514-2.145 0-1.132 1.013-1.606 2.889-1.606 2.263 0 4.494.686 6.61 1.638V7.257c-1.487-.744-3.779-1.34-6.459-1.34-5.059 0-7.681 2.206-7.681 5.806ZM176.942 6.215v19.558h4.168V10.86l1.757 3.96 5.895 10.953H194V6.215h-4.167v12.624l-1.578-3.664-4.735-8.96h-6.578ZM150.436 6.215h-4.555v19.558h4.555V6.215ZM140.625 20c0-3.424-1.814-5.03-6.937-6.133-2.828-.625-3.514-1.25-3.514-2.145 0-1.131 1.013-1.605 2.888-1.605 2.264 0 4.495.686 6.611 1.638V7.257c-1.488-.744-3.78-1.34-6.46-1.34-5.062 0-7.681 2.202-7.681 5.806 0 2.888 1.34 5.18 6.578 6.19 3.126.653 3.78 1.16 3.78 2.202 0 1.013-.654 1.667-2.856 1.667-2.562 0-5.598-.863-7.591-2.055v4.702c1.577.773 3.66 1.639 7.53 1.639 5.478.003 7.652-2.436 7.652-6.068ZM71.19 6.215v19.558h9.363l1.473-4.225h-6.251V6.215H71.19ZM52.693 6.215v4.229h5.062v15.33h4.584v-15.33h5.417V6.215H52.693ZM46.046 6.215H40.04l-6.822 19.558h5.21l.966-3.294c1.157.337 2.382.524 3.646.524 1.268 0 2.49-.187 3.647-.524l.966 3.294h5.21L46.045 6.215Zm-3.003 12.74c-.87 0-1.71-.126-2.508-.36l2.508-8.54 2.507 8.54a8.908 8.908 0 0 1-2.507.36ZM96.691 6.215h-6.007l-6.819 19.558h5.21l.966-3.294c1.157.337 2.382.524 3.647.524 1.268 0 2.49-.187 3.646-.524l.966 3.294h5.21L96.691 6.215Zm-3.003 12.74c-.87 0-1.71-.126-2.508-.36l2.508-8.54 2.507 8.54a8.907 8.907 0 0 1-2.507.36ZM166.847 6.215h-6.007l-6.818 19.558h5.209l.966-3.294c1.157.337 2.382.524 3.647.524 1.268 0 2.489-.187 3.646-.524l.967 3.294h5.209l-6.819-19.558Zm-3.003 12.74a8.91 8.91 0 0 1-2.508-.36l2.508-8.54 2.507 8.54a8.903 8.903 0 0 1-2.507.36Z",
                fill: "#0052CC"
            }),
            /*#__PURE__*/ (0, $bibO8.jsx)("path", {
                d: "M7.056 12.98c-.356-.381-.91-.36-1.15.126L.076 24.764a.698.698 0 0 0 .624 1.01h8.12c.266 0 .5-.134.625-.385 1.746-3.622.686-9.125-2.39-12.41Z",
                fill: "url(#a)"
            }),
            /*#__PURE__*/ (0, $bibO8.jsx)("path", {
                d: "M11.335 2.375c-3.263 5.166-3.047 10.889-.899 15.182 2.149 4.293 3.798 7.595 3.916 7.828.119.237.36.384.625.384h8.12a.7.7 0 0 0 .625-1.009L12.524 2.364c-.252-.485-.873-.489-1.19.01Z",
                fill: "#2684FF"
            }),
            /*#__PURE__*/ (0, $bibO8.jsx)("defs", {
                children: /*#__PURE__*/ (0, $bibO8.jsxs)("linearGradient", {
                    id: "a",
                    x1: 10.252,
                    y1: 14.779,
                    x2: 4.097,
                    y2: 25.439,
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0, $bibO8.jsx)("stop", {
                            stopColor: "#0052CC"
                        }),
                        /*#__PURE__*/ (0, $bibO8.jsx)("stop", {
                            offset: 0.923,
                            stopColor: "#2684FF"
                        })
                    ]
                })
            })
        ]
    });
};
var $2990ea8d7d8a8d03$export$2e2bcd8739ae039 = $2990ea8d7d8a8d03$var$AtlassianAccountLogo;




const $e9f239bd53c5ef83$var$AtlassianAccountProductHome = ()=>{
    const navigate = (0, $lairn.useNavigate)();
    const rootPath = (0, $3B7Hp.getManageProfileAppRootPath)();
    return /*#__PURE__*/ (0, $bibO8.jsx)($a658dd997fa974ff$export$f77ec19837119c86, {
        icon: (0, $dViVv.AtlassianIcon),
        logo: (0, $2990ea8d7d8a8d03$export$2e2bcd8739ae039),
        onClick: (event)=>{
            event.preventDefault();
            navigate(rootPath);
        },
        href: rootPath
    });
};
const $e9f239bd53c5ef83$var$getHorizontalNavItems = ()=>{
    const rootPath = (0, $3B7Hp.getManageProfileAppRootPath)();
    const tabs = [
        {
            message: $e9f239bd53c5ef83$var$messages.profileAndVisibility,
            path: `${rootPath}/profile-and-visibility`
        },
        {
            message: $e9f239bd53c5ef83$var$messages.email,
            path: `${rootPath}/email`
        },
        {
            message: $e9f239bd53c5ef83$var$messages.security,
            path: `${rootPath}/security`,
            dropdownAriaLabel: $e9f239bd53c5ef83$var$messages.securityDropdownLabel
        },
        {
            message: $e9f239bd53c5ef83$var$messages.privacy,
            path: `${rootPath}/privacy`
        },
        {
            message: $e9f239bd53c5ef83$var$messages.accountPreferences,
            path: `${rootPath}/account-preferences`
        },
        {
            message: $e9f239bd53c5ef83$var$messages.apps,
            path: `${rootPath}/apps`
        },
        {
            message: $e9f239bd53c5ef83$var$messages.linkPreferences,
            path: `${rootPath}/link-preferences`
        },
        {
            message: $e9f239bd53c5ef83$var$messages.products,
            path: `${rootPath}/products`
        }
    ];
    return tabs;
};
const $e9f239bd53c5ef83$var$TabLink = ({ tab: tab })=>{
    const { isVisible: isHorizontalVisible, closeOverflowMenu: closeOverflowMenu } = (0, $23c1a26819a49d2a$export$3fcfc71fab3314f2)();
    if (!isHorizontalVisible) return tab.children ? /*#__PURE__*/ (0, $bibO8.jsx)($e9f239bd53c5ef83$var$SubMenuNavTab, {
        tab: tab,
        closeOverflow: closeOverflowMenu
    }) : /*#__PURE__*/ (0, $bibO8.jsx)((0, $5Xjg2.default), {
        onClick: ()=>closeOverflowMenu(),
        to: String(tab.path),
        component: (0, $5Zreo.Link),
        children: /*#__PURE__*/ (0, $bibO8.jsx)((0, $55TWT.default), {
            ...tab.message
        })
    }, tab.path);
    else return tab.children ? /*#__PURE__*/ (0, $bibO8.jsx)($e9f239bd53c5ef83$var$DropDownNavTab, {
        tab: tab
    }) : /*#__PURE__*/ (0, $bibO8.jsx)($a658dd997fa974ff$export$2d5d2ba3c7c8c40b, {
        href: String(tab.path),
        component: $e9f239bd53c5ef83$var$RouterLink,
        isHighlighted: (0, (/*@__PURE__*/$parcel$interopDefault($6qH56))).location.pathname.startsWith(tab.path),
        children: /*#__PURE__*/ (0, $bibO8.jsx)((0, $55TWT.default), {
            ...tab.message
        })
    }, tab.path);
};
const $e9f239bd53c5ef83$var$RouterLink = /*#__PURE__*/ (0, $dAx5m.forwardRef)(function Component({ href: href = "", ...rest }, ref) {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore-next-line
    return /*#__PURE__*/ (0, $bibO8.jsx)((0, $5Zreo.Link), {
        ...rest,
        to: href,
        ref: ref
    });
});
const $e9f239bd53c5ef83$var$SubMenuNavTab = ({ tab: tab, closeOverflow: closeOverflow })=>{
    const [isOpen, setIsOpen] = (0, $dAx5m.useState)(false);
    const DropDownItems = tab.children?.map((child)=>{
        return /*#__PURE__*/ (0, $bibO8.jsx)((0, $5Xjg2.default), {
            to: String(child.path),
            component: (0, $5Zreo.Link),
            onClick: ()=>closeOverflow(),
            children: /*#__PURE__*/ (0, $bibO8.jsx)((0, $55TWT.default), {
                ...child.message
            })
        }, child.path);
    });
    return /*#__PURE__*/ (0, $bibO8.jsx)((0, $7vqkt.default), {
        placement: "bottom",
        content: ()=>DropDownItems,
        isOpen: isOpen,
        onClose: ()=>setIsOpen(false),
        trigger: ({ ref: ref, ...otherTriggerProps })=>{
            return /*#__PURE__*/ (0, $bibO8.jsxs)($a658dd997fa974ff$export$9362d48db9369c0f, {
                children: [
                    /*#__PURE__*/ (0, $bibO8.jsx)((0, $5Xjg2.default), {
                        onClick: ()=>closeOverflow(),
                        to: String(tab.path),
                        component: (0, $5Zreo.Link),
                        children: /*#__PURE__*/ (0, $bibO8.jsx)((0, $55TWT.default), {
                            ...tab.message
                        })
                    }, tab.path),
                    /*#__PURE__*/ (0, $bibO8.jsx)($a658dd997fa974ff$export$a7decb6e86733638, {
                        ...otherTriggerProps,
                        onClick: ()=>setIsOpen((prevIsOpen)=>!prevIsOpen),
                        ref: ref
                    })
                ]
            });
        }
    });
};
const $e9f239bd53c5ef83$var$DropDownNavTab = ({ tab: tab })=>{
    const { formatMessage: formatMessage } = (0, $dZHnD.default)();
    const [isOpen, setIsOpen] = (0, $dAx5m.useState)(false);
    const isHighlighted = (0, (/*@__PURE__*/$parcel$interopDefault($6qH56))).location.pathname.includes(tab.path);
    const DropDownItems = tab.children?.map((child)=>{
        return /*#__PURE__*/ (0, $bibO8.jsx)((0, $5Xjg2.default), {
            onClick: ()=>{
                setIsOpen((prevIsOpen)=>{
                    return !prevIsOpen;
                });
            },
            to: String(child.path),
            component: (0, $5Zreo.Link),
            children: /*#__PURE__*/ (0, $bibO8.jsx)((0, $55TWT.default), {
                ...child.message
            })
        }, child.path);
    });
    return /*#__PURE__*/ (0, $bibO8.jsx)((0, $7vqkt.default), {
        content: ()=>DropDownItems,
        isOpen: isOpen,
        onClose: ()=>setIsOpen(false),
        placement: "top-start",
        trigger: ({ ref: ref, ...triggerProps })=>{
            return /*#__PURE__*/ (0, $bibO8.jsxs)($a658dd997fa974ff$export$12da5b7dd1435002, {
                ref: ref,
                isOpen: isOpen,
                isHighlighted: isHighlighted,
                children: [
                    /*#__PURE__*/ (0, $bibO8.jsx)($a658dd997fa974ff$export$f1f3f49a698e2b09, {
                        href: String(tab.path),
                        component: $e9f239bd53c5ef83$var$RouterLink,
                        children: /*#__PURE__*/ (0, $bibO8.jsx)((0, $55TWT.default), {
                            ...tab.message
                        })
                    }),
                    /*#__PURE__*/ (0, $bibO8.jsx)($a658dd997fa974ff$export$f0536fb13b75c0c, {
                        "aria-label": tab.dropdownAriaLabel ? formatMessage(tab.dropdownAriaLabel) : "Dropdown menu",
                        onClick: ()=>setIsOpen((prevIsOpen)=>!prevIsOpen),
                        ...triggerProps
                    }),
                    isHighlighted && /*#__PURE__*/ (0, $bibO8.jsx)($a658dd997fa974ff$export$1a662afb46f800e2, {})
                ]
            });
        }
    });
};
const $e9f239bd53c5ef83$var$HorizontalNav = ({ children: children, isMobile: isMobile })=>{
    const { formatMessage: formatMessage } = (0, $dZHnD.default)();
    const tabs = $e9f239bd53c5ef83$var$getHorizontalNavItems();
    return /*#__PURE__*/ (0, $bibO8.jsxs)((0, $bibO8.Fragment), {
        children: [
            /*#__PURE__*/ (0, $bibO8.jsx)((0, $eb154661c545c745$export$f66ccb39f60980e5), {
                testId: "HorizontalNavTopNavigation",
                label: formatMessage({
                    id: "ptc-directory-ui.account-settings.horizontal.navigation.label",
                    defaultMessage: "manage profile menu",
                    description: "Horizontal navigation label."
                }),
                primaryItems: tabs.map((tab)=>/*#__PURE__*/ (0, $bibO8.jsx)($e9f239bd53c5ef83$var$TabLink, {
                        tab: tab
                    }, tab.path)),
                renderProductHome: $e9f239bd53c5ef83$var$AtlassianAccountProductHome,
                renderAppSwitcher: (0, $74c8ea88f09411d2$export$2e2bcd8739ae039),
                renderHelp: (0, $fd766a90368731bc$export$2e2bcd8739ae039),
                renderProfile: (0, $d70703cec31080f1$export$2e2bcd8739ae039),
                moreLabel: isMobile ? /*#__PURE__*/ (0, $bibO8.jsx)((0, $55TWT.default), {
                    id: "ptc-directory-ui.account-settings.navigation.mobile.label",
                    defaultMessage: "Menu",
                    description: "Horizontal navigation label, when all menu items are hidden."
                }) : /*#__PURE__*/ (0, $bibO8.jsx)((0, $55TWT.default), {
                    id: "ptc-directory-ui.account-settings.navigation.label",
                    defaultMessage: "More",
                    description: "Horizontal navigation label, when some menu items are hidden."
                })
            }),
            /*#__PURE__*/ (0, $bibO8.jsx)((0, $aec8c280efcaa306$export$2e2bcd8739ae039), {
                testId: "content",
                children: /*#__PURE__*/ (0, $bibO8.jsx)((0, $6186749b3e08b3b8$export$2e2bcd8739ae039), {
                    testId: "main",
                    children: /*#__PURE__*/ (0, $bibO8.jsx)($a658dd997fa974ff$export$7fd01d24c9175e32, {
                        children: children
                    })
                })
            })
        ]
    });
};
const $e9f239bd53c5ef83$export$f955239c37143e64 = ({ children: children, getCurrentUser: getCurrentUser })=>{
    const { formatMessage: formatMessage } = (0, $dZHnD.default)();
    const analytics = (0, $grRLU.default)();
    (0, $dAx5m.useEffect)(()=>{
        // start to fetch user info as soon as possible and store data in redux-store
        getCurrentUser();
        // Initialize analytics client. Required for events to start sending.
        analytics.startUIViewedEvent();
    }, [
        getCurrentUser,
        analytics
    ]);
    return /*#__PURE__*/ (0, $bibO8.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($26bb7fa76339df09$exports))), {
        title: formatMessage({
            id: "ptc-directory-ui.siteless-page-title",
            defaultMessage: "Atlassian account",
            description: "Title of the Atlassian account product."
        }),
        children: /*#__PURE__*/ (0, $bibO8.jsx)((0, $cZlBJ.DeviceContextProvider), {
            mobileWidthThreshold: 472,
            children: /*#__PURE__*/ (0, $bibO8.jsxs)($a658dd997fa974ff$export$6955bcca4cd3539f, {
                children: [
                    /*#__PURE__*/ (0, $bibO8.jsx)((0, $cZlBJ.DeviceContextConsumer), {
                        children: ({ isMobile: isMobile })=>{
                            return /*#__PURE__*/ (0, $bibO8.jsx)($e9f239bd53c5ef83$var$HorizontalNav, {
                                isMobile: Boolean(isMobile),
                                children: children
                            });
                        }
                    }),
                    /*#__PURE__*/ (0, $bibO8.jsx)((0, $e09f8ba83d2b30a4$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $bibO8.jsx)((0, $f9232.default), {})
                ]
            })
        })
    });
};
const $e9f239bd53c5ef83$var$messages = (0, $lKhJJ.defineMessages)({
    email: {
        id: "ptc-directory-ui.account-settings.item.email",
        defaultMessage: "Email",
        description: "Navigation item label in the left side navigation bar that leads to the email settings screen"
    },
    profileAndVisibility: {
        id: "ptc-directory-ui.account-settings.item.profile-and-visibility",
        defaultMessage: "Profile and visibility",
        description: "Navigation item label in the left side navigation bar that leads to the profile and visibility settings screen"
    },
    products: {
        id: "ptc-directory-ui.account-settings.item.product-settings",
        defaultMessage: "Product settings",
        description: "Navigation item label in the left side navigation bar that leads to the products settings screen"
    },
    security: {
        id: "ptc-directory-ui.account-settings.item.security",
        defaultMessage: "Security",
        description: "Navigation item label in the left side navigation bar that leads to the security settings screen"
    },
    securityDropdownLabel: {
        id: "ptc-directory-ui.account-settings.item.security-dropdown-label",
        defaultMessage: "Security dropdown",
        description: "Navigation item label in the navigation bar that opens the dropdown menu to show more security settings"
    },
    securityBack: {
        id: "ptc-directory-ui.account-settings.item.security.back",
        defaultMessage: "Account settings",
        description: "Navigation back item label in the left side navigation bar that leads back to the security settings screen from a child page"
    },
    securityHeading: {
        id: "ptc-directory-ui.account-settings.item.security.heading",
        defaultMessage: "Security settings",
        description: "Heading for the left side navigation bar when on the security settings screen"
    },
    twoStepVerification: {
        id: "ptc-directory-ui.account-settings.item.security.two-step-verification",
        defaultMessage: "Two-step verification",
        description: "Navigation item label in the left side navigation bar that leads to the two step verification settings screen"
    },
    apiTokens: {
        id: "ptc-directory-ui.account-settings.item.security.api-tokens",
        defaultMessage: "API tokens",
        description: "Navigation item label in the left side navigation bar that leads to the two step verification settings screen"
    },
    recentDevices: {
        id: "ptc-directory-ui.account-settings.item.security.recent-devices",
        defaultMessage: "Recent devices",
        description: "Navigation item label in the left side navigation bar that leads to the two step verification settings screen"
    },
    privacy: {
        id: "ptc-directory-ui.account-settings.item.privacy",
        defaultMessage: "Privacy",
        description: "Navigation item label in the left side navigation bar that leads to the privacy settings screen"
    },
    accountPreferences: {
        id: "ptc-directory-ui.account-settings.item.account-preferences.preferences",
        defaultMessage: "Account preferences",
        description: "Navigation item label in the left side navigation bar that leads to the account preferences settings screen"
    },
    apps: {
        id: "ptc-directory-ui.account-settings.item.apps",
        defaultMessage: "Connected apps",
        description: "Navigation item label in the left side navigation bar that leads to the connected apps settings screen"
    },
    linkPreferences: {
        id: "ptc-directory-ui.account-settings.item.link-preferences",
        defaultMessage: "Link preferences",
        description: "Navigation item label in the left side navigation bar that leads to the link preferences settings screen"
    }
});
var $e9f239bd53c5ef83$export$2e2bcd8739ae039 = (0, $58n8k.default)($e9f239bd53c5ef83$export$f955239c37143e64);


parcelRequire("jShba");
var $h1RRU = parcelRequire("h1RRU");
const $246e8413300e0573$var$mapDispatchToProps = {
    getCurrentUser: $h1RRU.getCurrentUser
};
const $246e8413300e0573$var$mapStateToProps = ({ user: user })=>{
    return {
        userId: user.data.accountId,
        name: user.data.fullName,
        email: user.data.email,
        picture: user.data.picture
    };
};
var $246e8413300e0573$export$2e2bcd8739ae039 = (0, $7PWYP.default)($246e8413300e0573$var$mapStateToProps, $246e8413300e0573$var$mapDispatchToProps)((0, $e9f239bd53c5ef83$export$2e2bcd8739ae039));





var $bibO8 = parcelRequire("bibO8");
parcelRequire("dAx5m");

var $cUsaH = parcelRequire("cUsaH");

const $d644d926b4c837c8$var$LazyEmailSettings = (0, (/*@__PURE__*/$parcel$interopDefault($cUsaH)))({
    loader: ()=>(parcelRequire("bBele")),
    loading: ()=>null
});
$d644d926b4c837c8$var$LazyEmailSettings.displayName = "lazy(EmailSettings)";
var $d644d926b4c837c8$export$2e2bcd8739ae039 = $d644d926b4c837c8$var$LazyEmailSettings;


parcelRequire("jShba");
var $53PE4 = parcelRequire("53PE4");
var $7dUzb = parcelRequire("7dUzb");
var $6e62a = parcelRequire("6e62a");
const $0ad42f9537fa8997$var$SettingsEmailRoute = ()=>/*#__PURE__*/ (0, $bibO8.jsxs)((0, $bibO8.Fragment), {
        children: [
            /*#__PURE__*/ (0, $bibO8.jsx)((0, $53PE4.default), {
                task: (0, $7dUzb.ApdexTasks).VIEW_EMAIL_SETTINGS
            }),
            /*#__PURE__*/ (0, $bibO8.jsx)((0, $6e62a.default), {}),
            /*#__PURE__*/ (0, $bibO8.jsx)((0, $d644d926b4c837c8$export$2e2bcd8739ae039), {})
        ]
    });
var $0ad42f9537fa8997$export$2e2bcd8739ae039 = $0ad42f9537fa8997$var$SettingsEmailRoute;



var $bibO8 = parcelRequire("bibO8");
parcelRequire("dAx5m");

var $cUsaH = parcelRequire("cUsaH");

const $70afd4766826c8c7$var$LazySecuritySettings = (0, (/*@__PURE__*/$parcel$interopDefault($cUsaH)))({
    loader: ()=>(parcelRequire("d5C4u")),
    loading: ()=>null
});
$70afd4766826c8c7$var$LazySecuritySettings.displayName = "lazy(SecuritySettings)";
var $70afd4766826c8c7$export$2e2bcd8739ae039 = $70afd4766826c8c7$var$LazySecuritySettings;


parcelRequire("jShba");
var $53PE4 = parcelRequire("53PE4");
var $7dUzb = parcelRequire("7dUzb");
var $6e62a = parcelRequire("6e62a");
const $b247a9b30ddb4489$var$SettingsSecurityRoute = ()=>/*#__PURE__*/ (0, $bibO8.jsxs)((0, $bibO8.Fragment), {
        children: [
            /*#__PURE__*/ (0, $bibO8.jsx)((0, $53PE4.default), {
                task: (0, $7dUzb.ApdexTasks).VIEW_SECURITY_SETTINGS
            }),
            /*#__PURE__*/ (0, $bibO8.jsx)((0, $6e62a.default), {}),
            /*#__PURE__*/ (0, $bibO8.jsx)((0, $70afd4766826c8c7$export$2e2bcd8739ae039), {})
        ]
    });
var $b247a9b30ddb4489$export$2e2bcd8739ae039 = $b247a9b30ddb4489$var$SettingsSecurityRoute;



var $bibO8 = parcelRequire("bibO8");
parcelRequire("dAx5m");

var $cUsaH = parcelRequire("cUsaH");

const $6b89e49fe613a1e2$var$LazyTwoStepVerification = (0, (/*@__PURE__*/$parcel$interopDefault($cUsaH)))({
    loader: ()=>(parcelRequire("8DKk6")),
    loading: ()=>null
});
$6b89e49fe613a1e2$var$LazyTwoStepVerification.displayName = "lazy(TwoStepVerification)";
var $6b89e49fe613a1e2$export$2e2bcd8739ae039 = $6b89e49fe613a1e2$var$LazyTwoStepVerification;


parcelRequire("jShba");
var $53PE4 = parcelRequire("53PE4");
var $7dUzb = parcelRequire("7dUzb");
var $6e62a = parcelRequire("6e62a");
const $ef126aab1af83bed$var$TwoStepVerificationRoute = ()=>/*#__PURE__*/ (0, $bibO8.jsxs)((0, $bibO8.Fragment), {
        children: [
            /*#__PURE__*/ (0, $bibO8.jsx)((0, $53PE4.default), {
                task: (0, $7dUzb.ApdexTasks).VIEW_TWO_STEP_VERIFICATION
            }),
            /*#__PURE__*/ (0, $bibO8.jsx)((0, $6e62a.default), {}),
            /*#__PURE__*/ (0, $bibO8.jsx)((0, $6b89e49fe613a1e2$export$2e2bcd8739ae039), {})
        ]
    });
var $ef126aab1af83bed$export$2e2bcd8739ae039 = $ef126aab1af83bed$var$TwoStepVerificationRoute;



var $bibO8 = parcelRequire("bibO8");
parcelRequire("dAx5m");

var $cUsaH = parcelRequire("cUsaH");

const $4a1f43d35f742799$var$LazyApiTokens = (0, (/*@__PURE__*/$parcel$interopDefault($cUsaH)))({
    loader: ()=>(parcelRequire("iJPyN")),
    loading: ()=>null
});
$4a1f43d35f742799$var$LazyApiTokens.displayName = "lazy(ApiTokens)";
var $4a1f43d35f742799$export$2e2bcd8739ae039 = $4a1f43d35f742799$var$LazyApiTokens;


parcelRequire("jShba");
var $53PE4 = parcelRequire("53PE4");
var $7dUzb = parcelRequire("7dUzb");
var $6e62a = parcelRequire("6e62a");
const $8c1076b6398079c8$var$ApiTokensRoute = ()=>/*#__PURE__*/ (0, $bibO8.jsxs)((0, $bibO8.Fragment), {
        children: [
            /*#__PURE__*/ (0, $bibO8.jsx)((0, $53PE4.default), {
                task: (0, $7dUzb.ApdexTasks).VIEW_API_TOKENS
            }),
            /*#__PURE__*/ (0, $bibO8.jsx)((0, $6e62a.default), {}),
            /*#__PURE__*/ (0, $bibO8.jsx)((0, $4a1f43d35f742799$export$2e2bcd8739ae039), {})
        ]
    });
var $8c1076b6398079c8$export$2e2bcd8739ae039 = $8c1076b6398079c8$var$ApiTokensRoute;



var $bibO8 = parcelRequire("bibO8");
parcelRequire("dAx5m");

var $cUsaH = parcelRequire("cUsaH");

const $6807c2d574fbfb77$var$LazyRecentDevices = (0, (/*@__PURE__*/$parcel$interopDefault($cUsaH)))({
    loader: ()=>(parcelRequire("hPirZ")),
    loading: ()=>null
});
$6807c2d574fbfb77$var$LazyRecentDevices.displayName = "lazy(RecentDevices)";
var $6807c2d574fbfb77$export$2e2bcd8739ae039 = $6807c2d574fbfb77$var$LazyRecentDevices;


parcelRequire("jShba");
var $53PE4 = parcelRequire("53PE4");
var $7dUzb = parcelRequire("7dUzb");
var $6e62a = parcelRequire("6e62a");
const $050897fcd648e93c$var$RecentDevicesRoute = ()=>/*#__PURE__*/ (0, $bibO8.jsxs)((0, $bibO8.Fragment), {
        children: [
            /*#__PURE__*/ (0, $bibO8.jsx)((0, $53PE4.default), {
                task: (0, $7dUzb.ApdexTasks).VIEW_RECENT_DEVICES
            }),
            /*#__PURE__*/ (0, $bibO8.jsx)((0, $6e62a.default), {}),
            /*#__PURE__*/ (0, $bibO8.jsx)((0, $6807c2d574fbfb77$export$2e2bcd8739ae039), {})
        ]
    });
var $050897fcd648e93c$export$2e2bcd8739ae039 = $050897fcd648e93c$var$RecentDevicesRoute;



var $bibO8 = parcelRequire("bibO8");
parcelRequire("dAx5m");
parcelRequire("jShba");
var $53PE4 = parcelRequire("53PE4");
var $7dUzb = parcelRequire("7dUzb");
var $6e62a = parcelRequire("6e62a");

var $cUsaH = parcelRequire("cUsaH");

const $e15137ae6f21e6c1$var$LazyPrivacySettings = (0, (/*@__PURE__*/$parcel$interopDefault($cUsaH)))({
    loader: ()=>(parcelRequire("jXhle")),
    loading: ()=>null
});
$e15137ae6f21e6c1$var$LazyPrivacySettings.displayName = "lazy(PrivacySettings)";
var $e15137ae6f21e6c1$export$2e2bcd8739ae039 = $e15137ae6f21e6c1$var$LazyPrivacySettings;


const $48034f65b5c62e9f$var$SettingsPrivacyRoute = ()=>/*#__PURE__*/ (0, $bibO8.jsxs)((0, $bibO8.Fragment), {
        children: [
            /*#__PURE__*/ (0, $bibO8.jsx)((0, $53PE4.default), {
                task: (0, $7dUzb.ApdexTasks).VIEW_PRIVACY_SETTINGS
            }),
            /*#__PURE__*/ (0, $bibO8.jsx)((0, $6e62a.default), {}),
            /*#__PURE__*/ (0, $bibO8.jsx)((0, $e15137ae6f21e6c1$export$2e2bcd8739ae039), {})
        ]
    });
var $48034f65b5c62e9f$export$2e2bcd8739ae039 = $48034f65b5c62e9f$var$SettingsPrivacyRoute;


parcelRequire("jQGCp");
var $7PWYP = parcelRequire("7PWYP");

var $bibO8 = parcelRequire("bibO8");

var $dAx5m = parcelRequire("dAx5m");

var $lKhJJ = parcelRequire("lKhJJ");
var $55TWT = parcelRequire("55TWT");
var $dZHnD = parcelRequire("dZHnD");

var $6bOZI = parcelRequire("6bOZI");

var $hb374 = parcelRequire("hb374");

var $3B7Hp = parcelRequire("3B7Hp");
parcelRequire("jShba");
var $zFJ4O = parcelRequire("zFJ4O");
var $7dUzb = parcelRequire("7dUzb");

var $ku6eE = parcelRequire("ku6eE");

var $5MUVm = parcelRequire("5MUVm");

var $gbKg7 = parcelRequire("gbKg7");

var $hxi5h = parcelRequire("hxi5h");
const $c53b8e29f0dfe605$export$8b251419efc915eb = (0, $ku6eE.default).div`
  margin-bottom: ${(0, $gbKg7.default)("space.150", "12px")};
`;
const $c53b8e29f0dfe605$export$147422f7450ccfac = (0, $ku6eE.default).div`
  margin-top: 20px;
`;
const $c53b8e29f0dfe605$export$305cd396b3ffc5e2 = (0, $ku6eE.default).div`
  margin-top: ${(0, $gbKg7.default)("space.100", "8px")};
  margin-left: -${(0, $gbKg7.default)("space.100", "8px")};
`;
const $c53b8e29f0dfe605$export$edaca75100fc443c = (0, $ku6eE.default).div`
  margin-left: -${(0, $gbKg7.default)("space.100", "8px")};
`;
const $c53b8e29f0dfe605$export$5f7211d21bfdae05 = (0, $ku6eE.default).div`
  max-width: 360px;
  height: ${(0, $gbKg7.default)("space.500", "40px")};
`;
const $c53b8e29f0dfe605$export$a093dca7d0282216 = (0, $ku6eE.default).div`
  height: 100%;
  width: 100%;
  color: ${(0, $gbKg7.default)("color.text.subtlest", (0, $5MUVm).N90)};
  display: inline-flex;
  align-items: center;
`;
const $c53b8e29f0dfe605$export$dbf56bbc3407fe85 = (0, $ku6eE.default).div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;
const $c53b8e29f0dfe605$export$94391c949d55601d = (0, $ku6eE.default).span`
  display: inline-block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;
const $c53b8e29f0dfe605$export$10896e23c75fe9a6 = (0, $ku6eE.default).span`
  background: ${(0, $gbKg7.default)("color.background.accent.blue.bolder", (0, $5MUVm).B400)};
  border-radius: 3px;
  font-size: 10px;
  padding: 2px 4px;
  display: inline-block;
  margin-left: 8px;
  min-width: 48px;
  text-align: center;
  line-height: 14px;
  color: ${(0, $gbKg7.default)("color.text.inverse", (0, $5MUVm).B50)};
`;


var $hxi5h = parcelRequire("hxi5h");

var $bibO8 = parcelRequire("bibO8");

var $dAx5m = parcelRequire("dAx5m");

var $2QbFH = parcelRequire("2QbFH");

var $55TWT = parcelRequire("55TWT");

parcelRequire("lU1oo");
var $2pRqv = parcelRequire("2pRqv");
parcelRequire("jShba");
var $fjOHq = parcelRequire("fjOHq");
var $grRLU = parcelRequire("grRLU");

var $ak3Un = parcelRequire("ak3Un");
const $13a016ace271c826$export$426b2759ec8c8bc6 = (propPath, userId)=>{
    const { isError: isError, isLoading: isLoading, user: user } = (0, $ak3Un.useManageProfileUser)(userId);
    return {
        defaultValue: user && user[propPath],
        isLoading: isLoading,
        isError: isError
    };
};



var $atFkq = parcelRequire("atFkq");
var $132jP = parcelRequire("132jP");

var $5Tbmh = parcelRequire("5Tbmh");
parcelRequire("jShba");
var $1Bj4T = parcelRequire("1Bj4T");

var $ak3Un = parcelRequire("ak3Un");

var $iDL5l = parcelRequire("iDL5l");
const $1ff7ae0ebc51ff87$var$updateUser = async (userId, newUserInfo)=>{
    const { stargateRoot: stargateRoot } = (0, $1Bj4T.getConfig)();
    const url = `${stargateRoot}/users/${userId}/manage/profile`;
    const body = JSON.stringify($5Tbmh.toManageAPIInput(newUserInfo));
    const response = await (0, $iDL5l.fetchApi)(url, {
        method: "PATCH",
        body: body
    });
    const data = await response.json();
    return $5Tbmh.fromManageAPIResponse(data);
};
const $1ff7ae0ebc51ff87$export$76936a29374a0363 = ({ userId: userId, onMutationError: onMutationError, onMutationSuccess: onMutationSuccess })=>{
    const queryClient = (0, $132jP.useQueryClient)();
    const queryKey = [
        (0, $ak3Un.ManageProfileUserQueryKey),
        userId
    ];
    const { mutateAsync: mutateAsync, mutate: mutate } = (0, $atFkq.useMutation)({
        onSuccess: onMutationSuccess,
        onError: onMutationError,
        mutationFn: async (newUserInfo)=>{
            // Cancel any outgoing refetches (so they don't overwrite our optimistic update)
            await queryClient.cancelQueries({
                queryKey: queryKey
            });
            // Optimistically update to the new state
            queryClient.setQueryData(queryKey, (old)=>{
                return {
                    ...old,
                    ...newUserInfo
                };
            });
            await $1ff7ae0ebc51ff87$var$updateUser(userId, newUserInfo);
        },
        onSettled: ()=>{
            // Always refetch after error or success
            queryClient.invalidateQueries(queryKey);
        }
    });
    return {
        mutateAsync: mutateAsync,
        mutate: mutate
    };
};


/**
 * List of languages supported in Unified Profile according to the following page + comment
 * 2019-03-12
 * https://product-fabric.atlassian.net/wiki/spaces/PTD/pages/747538300?focusedCommentId=881656746#comment-881656746
 */ // TODO: PTC-2088 - simplify list of locales
// - key (left side) is used in code
// - value (right side) is used for API endpoints of Identity
var $98c17fa9b1f2b52c$export$f4ef9dc5efe1d215;
(function(LanguageTag) {
    LanguageTag["ZH_CN"] = "zh-CN";
    LanguageTag["ZH_TW"] = "zh-TW";
    LanguageTag["CS"] = "cs";
    LanguageTag["DA"] = "da";
    LanguageTag["NL"] = "nl";
    LanguageTag["EN_US"] = "en-US";
    LanguageTag["EN_UK"] = "en-GB";
    // Used by i18n team in staging to capture visual context
    LanguageTag["EN_ZZ"] = "en-ZZ";
    LanguageTag["ET"] = "et";
    LanguageTag["FI"] = "fi";
    LanguageTag["FR"] = "fr";
    LanguageTag["DE"] = "de";
    LanguageTag["HU"] = "hu";
    LanguageTag["IS"] = "is";
    LanguageTag["IT"] = "it";
    LanguageTag["JA"] = "ja";
    LanguageTag["KO"] = "ko";
    LanguageTag["NB"] = "nb";
    LanguageTag["PL"] = "pl";
    LanguageTag["PT_BR"] = "pt-BR";
    LanguageTag["PT_PT"] = "pt-PT";
    LanguageTag["RO"] = "ro";
    LanguageTag["RU"] = "ru";
    LanguageTag["SK"] = "sk";
    LanguageTag["TH"] = "th";
    LanguageTag["TR"] = "tr";
    LanguageTag["ES"] = "es";
    LanguageTag["UK"] = "uk";
    LanguageTag["VI"] = "vi";
    LanguageTag["SV"] = "sv";
})($98c17fa9b1f2b52c$export$f4ef9dc5efe1d215 || ($98c17fa9b1f2b52c$export$f4ef9dc5efe1d215 = {}));
const $98c17fa9b1f2b52c$export$1c2c8674a5fbafd = {
    // this hardcoding is approved by Melanie Heighway
    // Approved list of languages for the dropdown are sourced from this spreadsheet;
    // https://drive.google.com/file/d/15IZhDfqX7MZFHL3sq7bSsCE0p6WO3Mdz/view
    ["zh-CN"]: "\u4E2D\u6587 (\u7B80\u4F53)",
    ["zh-TW"]: "\u4E2D\u6587 (\u7E41\u9AD4)",
    ["cs"]: "\u010Ce\u0161tina",
    ["da"]: "Dansk",
    ["nl"]: "Nederlands",
    ["en-US"]: "English (US)",
    ["en-GB"]: "English (UK)",
    ["et"]: "Eesti",
    ["fi"]: "Suomi",
    ["fr"]: "Fran\xe7ais",
    ["de"]: "Deutsch",
    ["hu"]: "Magyar",
    ["is"]: "\xcdslenska",
    ["it"]: "Italiano",
    ["ja"]: "\u65E5\u672C\u8A9E",
    ["ko"]: "\uD55C\uAD6D\uC5B4",
    // this hardcoding is approved by Melanie Heighway
    ["nb"]: "Norsk",
    ["pl"]: "Polski",
    ["pt-BR"]: "Portugu\xeas (Brasil)",
    ["pt-PT"]: "Portugu\xeas (Portugal)",
    ["ro"]: "Rom\xe2n\u0103",
    ["ru"]: "\u0420\u0443\u0441\u0441\u043A\u0438\u0439",
    ["sk"]: "Sloven\u010Dina",
    // this hardcoding is approved by Melanie Heighway
    ["th"]: "\u0E20\u0E32\u0E29\u0E32\u0E44\u0E17\u0E22\u200E",
    ["tr"]: "T\xfcrk\xe7e",
    ["es"]: "Espa\xf1ol",
    ["uk"]: "\u0423\u043A\u0440\u0430\u0457\u043D\u0441\u044C\u043A\u0430",
    ["vi"]: "Ti\u1EBFng Vi\u1EC7t",
    ["sv"]: "Svenska"
};
const $98c17fa9b1f2b52c$export$540bda68e6aeaf58 = "English (ZZ)";



var $4ffTz = parcelRequire("4ffTz");
/**
 * Check if the feature gate is enabled, if so, add the English (ZZ) language to the list of
 * supported languages. Permanent feature gate targeting i18n team in staging used
 * to provide visual context to translators.
 * https://hello.atlassian.net/wiki/spaces/DST/pages/3954737195/RFC+Enabling+en-ZZ+for+Identity
 */ const $39d99fe53f9294dd$var$getEnabledLanguages = ()=>{
    return (0, $4ffTz.checkFeatureGate)((0, $4ffTz.FeatureGate).ENABLE_EN_ZZ_I18N_LOCALE) ? {
        ...(0, $98c17fa9b1f2b52c$export$1c2c8674a5fbafd),
        [(0, $98c17fa9b1f2b52c$export$f4ef9dc5efe1d215).EN_ZZ]: (0, $98c17fa9b1f2b52c$export$540bda68e6aeaf58)
    } : (0, $98c17fa9b1f2b52c$export$1c2c8674a5fbafd);
};
/**
 * Convert object format from format of `enabledLanguages` (i.e. { [tag]: nameOfLang }) to `Options`
 */ const $39d99fe53f9294dd$var$getLanguageOptions = (enabledLanguages)=>{
    return Object.keys(enabledLanguages).map((languageTag)=>({
            label: enabledLanguages[languageTag],
            value: languageTag
        }));
};
const $39d99fe53f9294dd$export$f397a346e9b493ee = ({ userId: userId, inputId: inputId, onMutationSuccess: onMutationSuccess, onMutationError: onMutationError })=>{
    const analytics = (0, $grRLU.default)();
    const { defaultValue: defaultValue, isError: isError, isLoading: isLoading } = (0, $13a016ace271c826$export$426b2759ec8c8bc6)("locale", userId);
    const { mutate: onChange } = (0, $1ff7ae0ebc51ff87$export$76936a29374a0363)({
        userId: userId,
        onMutationSuccess: onMutationSuccess,
        onMutationError: onMutationError
    });
    const placeHolderOption = {
        label: /*#__PURE__*/ (0, $bibO8.jsx)((0, $55TWT.default), {
            id: "ptc-directory-ui.account-settings.language.placeholder.label",
            defaultMessage: "Set your language",
            description: "A placeholder entry for when the user has not set their language"
        }),
        value: ""
    };
    const enabledLanguages = $39d99fe53f9294dd$var$getEnabledLanguages();
    const languageOptions = (0, $dAx5m.useMemo)(()=>$39d99fe53f9294dd$var$getLanguageOptions(enabledLanguages), [
        enabledLanguages
    ]);
    const defaultLanguage = (0, $dAx5m.useMemo)(()=>languageOptions.find((option)=>option.value === defaultValue), [
        defaultValue,
        languageOptions
    ]);
    (0, $dAx5m.useEffect)(()=>{
        // failed to show language of current user because our UI does not support that user's locale
        if (defaultValue && !enabledLanguages[defaultValue]) analytics.pushOperationalEvent({
            source: (0, $fjOHq.AnalyticsEventSource).MANAGE_ACCOUNT_CLOSE_ACCOUNT_TAB,
            actionSubject: "languageDropDown",
            action: (0, $fjOHq.AnalyticsEventActions).FAILED,
            attributes: {
                language: defaultValue
            }
        });
    }, [
        analytics,
        defaultValue,
        enabledLanguages
    ]);
    const handleChangeLanguage = (language)=>{
        analytics.pushTrackEvent({
            action: (0, $fjOHq.AnalyticsEventActions).EDITED,
            actionSubject: "languageDropDown",
            source: (0, $fjOHq.AnalyticsEventSource).MANAGE_ACCOUNT_PREFERENCES_TAB,
            attributes: {
                language: language.value
            }
        });
        onChange({
            locale: language.value
        });
    };
    return /*#__PURE__*/ (0, $bibO8.jsxs)($c53b8e29f0dfe605$export$5f7211d21bfdae05, {
        children: [
            isError && /*#__PURE__*/ (0, $bibO8.jsx)($c53b8e29f0dfe605$export$a093dca7d0282216, {
                children: /*#__PURE__*/ (0, $bibO8.jsx)((0, $55TWT.default), {
                    id: "ptc-directory-ui.account-settings.language.error",
                    defaultMessage: "Unable to load your language.",
                    description: "An error message is showing when cannot load languages to show in a language dropdown"
                })
            }),
            isLoading && /*#__PURE__*/ (0, $bibO8.jsx)((0, $2pRqv.LoadingPlaceHolder), {
                "data-testid": "LanguageDropdownLoader"
            }),
            !isError && !isLoading && /*#__PURE__*/ (0, $bibO8.jsx)((0, $2QbFH.default), {
                inputId: inputId,
                placeHolder: placeHolderOption,
                options: languageOptions,
                onChange: (lang)=>lang && handleChangeLanguage(lang),
                defaultValue: defaultLanguage
            })
        ]
    });
};
var $39d99fe53f9294dd$export$2e2bcd8739ae039 = $39d99fe53f9294dd$export$f397a346e9b493ee;


parcelRequire("kil2v");
var $dggvN = parcelRequire("dggvN");
const $12b9e50fb1d3a731$var$StrongConsistentLanguageDropdown = (0, $dggvN.default)((0, $39d99fe53f9294dd$export$2e2bcd8739ae039));
var $12b9e50fb1d3a731$export$2e2bcd8739ae039 = $12b9e50fb1d3a731$var$StrongConsistentLanguageDropdown;



var $eN1Wl = parcelRequire("eN1Wl");

var $bibO8 = parcelRequire("bibO8");

var $dAx5m = parcelRequire("dAx5m");

var $55TWT = parcelRequire("55TWT");

var $fc2pq = parcelRequire("fc2pq");
var $2QbFH = parcelRequire("2QbFH");

parcelRequire("lU1oo");
var $2pRqv = parcelRequire("2pRqv");
var $49586f21c72f668e$exports = {};

//! moment-timezone.js
//! version : 0.5.45
//! Copyright (c) JS Foundation and other contributors
//! license : MIT
//! github.com/moment/moment-timezone
(function(root, factory) {
    "use strict";
    /*global define*/ if (0, $49586f21c72f668e$exports) $49586f21c72f668e$exports = factory((parcelRequire("gH4MD"))); // Node
    else if (typeof define === "function" && define.amd) define([
        "moment"
    ], factory); // AMD
    else factory(root.moment); // Browser
})($49586f21c72f668e$exports, function(moment) {
    "use strict";
    // Resolves es6 module loading issue
    if (moment.version === undefined && moment.default) moment = moment.default;
    // Do not load moment-timezone a second time.
    // if (moment.tz !== undefined) {
    // 	logError('Moment Timezone ' + moment.tz.version + ' was already loaded ' + (moment.tz.dataVersion ? 'with data from ' : 'without any data') + moment.tz.dataVersion);
    // 	return moment;
    // }
    var VERSION = "0.5.45", zones = {}, links = {}, countries = {}, names = {}, guesses = {}, cachedGuess;
    if (!moment || typeof moment.version !== "string") logError("Moment Timezone requires Moment.js. See https://momentjs.com/timezone/docs/#/use-it/browser/");
    var momentVersion = moment.version.split("."), major = +momentVersion[0], minor = +momentVersion[1];
    // Moment.js version check
    if (major < 2 || major === 2 && minor < 6) logError("Moment Timezone requires Moment.js >= 2.6.0. You are using Moment.js " + moment.version + ". See momentjs.com");
    /************************************
		Unpacking
	************************************/ function charCodeToInt(charCode) {
        if (charCode > 96) return charCode - 87;
        else if (charCode > 64) return charCode - 29;
        return charCode - 48;
    }
    function unpackBase60(string) {
        var i = 0, parts = string.split("."), whole = parts[0], fractional = parts[1] || "", multiplier = 1, num, out = 0, sign = 1;
        // handle negative numbers
        if (string.charCodeAt(0) === 45) {
            i = 1;
            sign = -1;
        }
        // handle digits before the decimal
        for(i; i < whole.length; i++){
            num = charCodeToInt(whole.charCodeAt(i));
            out = 60 * out + num;
        }
        // handle digits after the decimal
        for(i = 0; i < fractional.length; i++){
            multiplier = multiplier / 60;
            num = charCodeToInt(fractional.charCodeAt(i));
            out += num * multiplier;
        }
        return out * sign;
    }
    function arrayToInt(array) {
        for(var i = 0; i < array.length; i++)array[i] = unpackBase60(array[i]);
    }
    function intToUntil(array, length) {
        for(var i = 0; i < length; i++)array[i] = Math.round((array[i - 1] || 0) + array[i] * 60000); // minutes to milliseconds
        array[length - 1] = Infinity;
    }
    function mapIndices(source, indices) {
        var out = [], i;
        for(i = 0; i < indices.length; i++)out[i] = source[indices[i]];
        return out;
    }
    function unpack(string) {
        var data = string.split("|"), offsets = data[2].split(" "), indices = data[3].split(""), untils = data[4].split(" ");
        arrayToInt(offsets);
        arrayToInt(indices);
        arrayToInt(untils);
        intToUntil(untils, indices.length);
        return {
            name: data[0],
            abbrs: mapIndices(data[1].split(" "), indices),
            offsets: mapIndices(offsets, indices),
            untils: untils,
            population: data[5] | 0
        };
    }
    /************************************
		Zone object
	************************************/ function Zone(packedString) {
        if (packedString) this._set(unpack(packedString));
    }
    function closest(num, arr) {
        var len = arr.length;
        if (num < arr[0]) return 0;
        else if (len > 1 && arr[len - 1] === Infinity && num >= arr[len - 2]) return len - 1;
        else if (num >= arr[len - 1]) return -1;
        var mid;
        var lo = 0;
        var hi = len - 1;
        while(hi - lo > 1){
            mid = Math.floor((lo + hi) / 2);
            if (arr[mid] <= num) lo = mid;
            else hi = mid;
        }
        return hi;
    }
    Zone.prototype = {
        _set: function(unpacked) {
            this.name = unpacked.name;
            this.abbrs = unpacked.abbrs;
            this.untils = unpacked.untils;
            this.offsets = unpacked.offsets;
            this.population = unpacked.population;
        },
        _index: function(timestamp) {
            var target = +timestamp, untils = this.untils, i;
            i = closest(target, untils);
            if (i >= 0) return i;
        },
        countries: function() {
            var zone_name = this.name;
            return Object.keys(countries).filter(function(country_code) {
                return countries[country_code].zones.indexOf(zone_name) !== -1;
            });
        },
        parse: function(timestamp) {
            var target = +timestamp, offsets = this.offsets, untils = this.untils, max = untils.length - 1, offset, offsetNext, offsetPrev, i;
            for(i = 0; i < max; i++){
                offset = offsets[i];
                offsetNext = offsets[i + 1];
                offsetPrev = offsets[i ? i - 1 : i];
                if (offset < offsetNext && tz.moveAmbiguousForward) offset = offsetNext;
                else if (offset > offsetPrev && tz.moveInvalidForward) offset = offsetPrev;
                if (target < untils[i] - offset * 60000) return offsets[i];
            }
            return offsets[max];
        },
        abbr: function(mom) {
            return this.abbrs[this._index(mom)];
        },
        offset: function(mom) {
            logError("zone.offset has been deprecated in favor of zone.utcOffset");
            return this.offsets[this._index(mom)];
        },
        utcOffset: function(mom) {
            return this.offsets[this._index(mom)];
        }
    };
    /************************************
		Country object
	************************************/ function Country(country_name, zone_names) {
        this.name = country_name;
        this.zones = zone_names;
    }
    /************************************
		Current Timezone
	************************************/ function OffsetAt(at) {
        var timeString = at.toTimeString();
        var abbr = timeString.match(/\([a-z ]+\)/i);
        if (abbr && abbr[0]) {
            // 17:56:31 GMT-0600 (CST)
            // 17:56:31 GMT-0600 (Central Standard Time)
            abbr = abbr[0].match(/[A-Z]/g);
            abbr = abbr ? abbr.join("") : undefined;
        } else {
            // 17:56:31 CST
            // 17:56:31 GMT+0800 (台北標準時間)
            abbr = timeString.match(/[A-Z]{3,5}/g);
            abbr = abbr ? abbr[0] : undefined;
        }
        if (abbr === "GMT") abbr = undefined;
        this.at = +at;
        this.abbr = abbr;
        this.offset = at.getTimezoneOffset();
    }
    function ZoneScore(zone) {
        this.zone = zone;
        this.offsetScore = 0;
        this.abbrScore = 0;
    }
    ZoneScore.prototype.scoreOffsetAt = function(offsetAt) {
        this.offsetScore += Math.abs(this.zone.utcOffset(offsetAt.at) - offsetAt.offset);
        if (this.zone.abbr(offsetAt.at).replace(/[^A-Z]/g, "") !== offsetAt.abbr) this.abbrScore++;
    };
    function findChange(low, high) {
        var mid, diff;
        while(diff = ((high.at - low.at) / 12e4 | 0) * 6e4){
            mid = new OffsetAt(new Date(low.at + diff));
            if (mid.offset === low.offset) low = mid;
            else high = mid;
        }
        return low;
    }
    function userOffsets() {
        var startYear = new Date().getFullYear() - 2, last = new OffsetAt(new Date(startYear, 0, 1)), lastOffset = last.offset, offsets = [
            last
        ], change, next, nextOffset, i;
        for(i = 1; i < 48; i++){
            nextOffset = new Date(startYear, i, 1).getTimezoneOffset();
            if (nextOffset !== lastOffset) {
                // Create OffsetAt here to avoid unnecessary abbr parsing before checking offsets
                next = new OffsetAt(new Date(startYear, i, 1));
                change = findChange(last, next);
                offsets.push(change);
                offsets.push(new OffsetAt(new Date(change.at + 6e4)));
                last = next;
                lastOffset = nextOffset;
            }
        }
        for(i = 0; i < 4; i++){
            offsets.push(new OffsetAt(new Date(startYear + i, 0, 1)));
            offsets.push(new OffsetAt(new Date(startYear + i, 6, 1)));
        }
        return offsets;
    }
    function sortZoneScores(a, b) {
        if (a.offsetScore !== b.offsetScore) return a.offsetScore - b.offsetScore;
        if (a.abbrScore !== b.abbrScore) return a.abbrScore - b.abbrScore;
        if (a.zone.population !== b.zone.population) return b.zone.population - a.zone.population;
        return b.zone.name.localeCompare(a.zone.name);
    }
    function addToGuesses(name, offsets) {
        var i, offset;
        arrayToInt(offsets);
        for(i = 0; i < offsets.length; i++){
            offset = offsets[i];
            guesses[offset] = guesses[offset] || {};
            guesses[offset][name] = true;
        }
    }
    function guessesForUserOffsets(offsets) {
        var offsetsLength = offsets.length, filteredGuesses = {}, out = [], checkedOffsets = {}, i, j, offset, guessesOffset;
        for(i = 0; i < offsetsLength; i++){
            offset = offsets[i].offset;
            if (checkedOffsets.hasOwnProperty(offset)) continue;
            guessesOffset = guesses[offset] || {};
            for(j in guessesOffset)if (guessesOffset.hasOwnProperty(j)) filteredGuesses[j] = true;
            checkedOffsets[offset] = true;
        }
        for(i in filteredGuesses)if (filteredGuesses.hasOwnProperty(i)) out.push(names[i]);
        return out;
    }
    function rebuildGuess() {
        // use Intl API when available and returning valid time zone
        try {
            var intlName = Intl.DateTimeFormat().resolvedOptions().timeZone;
            if (intlName && intlName.length > 3) {
                var name = names[normalizeName(intlName)];
                if (name) return name;
                logError("Moment Timezone found " + intlName + " from the Intl api, but did not have that data loaded.");
            }
        } catch (e) {
        // Intl unavailable, fall back to manual guessing.
        }
        var offsets = userOffsets(), offsetsLength = offsets.length, guesses = guessesForUserOffsets(offsets), zoneScores = [], zoneScore, i, j;
        for(i = 0; i < guesses.length; i++){
            zoneScore = new ZoneScore(getZone(guesses[i]), offsetsLength);
            for(j = 0; j < offsetsLength; j++)zoneScore.scoreOffsetAt(offsets[j]);
            zoneScores.push(zoneScore);
        }
        zoneScores.sort(sortZoneScores);
        return zoneScores.length > 0 ? zoneScores[0].zone.name : undefined;
    }
    function guess(ignoreCache) {
        if (!cachedGuess || ignoreCache) cachedGuess = rebuildGuess();
        return cachedGuess;
    }
    /************************************
		Global Methods
	************************************/ function normalizeName(name) {
        return (name || "").toLowerCase().replace(/\//g, "_");
    }
    function addZone(packed) {
        var i, name, split, normalized;
        if (typeof packed === "string") packed = [
            packed
        ];
        for(i = 0; i < packed.length; i++){
            split = packed[i].split("|");
            name = split[0];
            normalized = normalizeName(name);
            zones[normalized] = packed[i];
            names[normalized] = name;
            addToGuesses(normalized, split[2].split(" "));
        }
    }
    function getZone(name, caller) {
        name = normalizeName(name);
        var zone = zones[name];
        var link;
        if (zone instanceof Zone) return zone;
        if (typeof zone === "string") {
            zone = new Zone(zone);
            zones[name] = zone;
            return zone;
        }
        // Pass getZone to prevent recursion more than 1 level deep
        if (links[name] && caller !== getZone && (link = getZone(links[name], getZone))) {
            zone = zones[name] = new Zone();
            zone._set(link);
            zone.name = names[name];
            return zone;
        }
        return null;
    }
    function getNames() {
        var i, out = [];
        for(i in names)if (names.hasOwnProperty(i) && (zones[i] || zones[links[i]]) && names[i]) out.push(names[i]);
        return out.sort();
    }
    function getCountryNames() {
        return Object.keys(countries);
    }
    function addLink(aliases) {
        var i, alias, normal0, normal1;
        if (typeof aliases === "string") aliases = [
            aliases
        ];
        for(i = 0; i < aliases.length; i++){
            alias = aliases[i].split("|");
            normal0 = normalizeName(alias[0]);
            normal1 = normalizeName(alias[1]);
            links[normal0] = normal1;
            names[normal0] = alias[0];
            links[normal1] = normal0;
            names[normal1] = alias[1];
        }
    }
    function addCountries(data) {
        var i, country_code, country_zones, split;
        if (!data || !data.length) return;
        for(i = 0; i < data.length; i++){
            split = data[i].split("|");
            country_code = split[0].toUpperCase();
            country_zones = split[1].split(" ");
            countries[country_code] = new Country(country_code, country_zones);
        }
    }
    function getCountry(name) {
        name = name.toUpperCase();
        return countries[name] || null;
    }
    function zonesForCountry(country, with_offset) {
        country = getCountry(country);
        if (!country) return null;
        var zones = country.zones.sort();
        if (with_offset) return zones.map(function(zone_name) {
            var zone = getZone(zone_name);
            return {
                name: zone_name,
                offset: zone.utcOffset(new Date())
            };
        });
        return zones;
    }
    function loadData(data) {
        addZone(data.zones);
        addLink(data.links);
        addCountries(data.countries);
        tz.dataVersion = data.version;
    }
    function zoneExists(name) {
        if (!zoneExists.didShowError) {
            zoneExists.didShowError = true;
            logError("moment.tz.zoneExists('" + name + "') has been deprecated in favor of !moment.tz.zone('" + name + "')");
        }
        return !!getZone(name);
    }
    function needsOffset(m) {
        var isUnixTimestamp = m._f === "X" || m._f === "x";
        return !!(m._a && m._tzm === undefined && !isUnixTimestamp);
    }
    function logError(message) {
        if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
    }
    /************************************
		moment.tz namespace
	************************************/ function tz(input) {
        var args = Array.prototype.slice.call(arguments, 0, -1), name = arguments[arguments.length - 1], out = moment.utc.apply(null, args), zone;
        if (!moment.isMoment(input) && needsOffset(out) && (zone = getZone(name))) out.add(zone.parse(out), "minutes");
        out.tz(name);
        return out;
    }
    tz.version = VERSION;
    tz.dataVersion = "";
    tz._zones = zones;
    tz._links = links;
    tz._names = names;
    tz._countries = countries;
    tz.add = addZone;
    tz.link = addLink;
    tz.load = loadData;
    tz.zone = getZone;
    tz.zoneExists = zoneExists; // deprecated in 0.1.0
    tz.guess = guess;
    tz.names = getNames;
    tz.Zone = Zone;
    tz.unpack = unpack;
    tz.unpackBase60 = unpackBase60;
    tz.needsOffset = needsOffset;
    tz.moveInvalidForward = true;
    tz.moveAmbiguousForward = false;
    tz.countries = getCountryNames;
    tz.zonesForCountry = zonesForCountry;
    /************************************
		Interface with Moment.js
	************************************/ var fn = moment.fn;
    moment.tz = tz;
    moment.defaultZone = null;
    moment.updateOffset = function(mom, keepTime) {
        var zone = moment.defaultZone, offset;
        if (mom._z === undefined) {
            if (zone && needsOffset(mom) && !mom._isUTC && mom.isValid()) {
                mom._d = moment.utc(mom._a)._d;
                mom.utc().add(zone.parse(mom), "minutes");
            }
            mom._z = zone;
        }
        if (mom._z) {
            offset = mom._z.utcOffset(mom);
            if (Math.abs(offset) < 16) offset = offset / 60;
            if (mom.utcOffset !== undefined) {
                var z = mom._z;
                mom.utcOffset(-offset, keepTime);
                mom._z = z;
            } else mom.zone(offset, keepTime);
        }
    };
    fn.tz = function(name, keepTime) {
        if (name) {
            if (typeof name !== "string") throw new Error("Time zone name must be a string, got " + name + " [" + typeof name + "]");
            this._z = getZone(name);
            if (this._z) moment.updateOffset(this, keepTime);
            else logError("Moment Timezone has no data for " + name + ". See http://momentjs.com/timezone/docs/#/data-loading/.");
            return this;
        }
        if (this._z) return this._z.name;
    };
    function abbrWrap(old) {
        return function() {
            if (this._z) return this._z.abbr(this);
            return old.call(this);
        };
    }
    function resetZoneWrap(old) {
        return function() {
            this._z = null;
            return old.apply(this, arguments);
        };
    }
    function resetZoneWrap2(old) {
        return function() {
            if (arguments.length > 0) this._z = null;
            return old.apply(this, arguments);
        };
    }
    fn.zoneName = abbrWrap(fn.zoneName);
    fn.zoneAbbr = abbrWrap(fn.zoneAbbr);
    fn.utc = resetZoneWrap(fn.utc);
    fn.local = resetZoneWrap(fn.local);
    fn.utcOffset = resetZoneWrap2(fn.utcOffset);
    moment.tz.setDefault = function(name) {
        if (major < 2 || major === 2 && minor < 9) logError("Moment Timezone setDefault() requires Moment.js >= 2.9.0. You are using Moment.js " + moment.version + ".");
        moment.defaultZone = name ? getZone(name) : null;
        return moment;
    };
    // Cloning a moment should include the _z property.
    var momentProperties = moment.momentProperties;
    if (Object.prototype.toString.call(momentProperties) === "[object Array]") {
        // moment 2.8.1+
        momentProperties.push("_z");
        momentProperties.push("_a");
    } else if (momentProperties) // moment 2.7.0
    momentProperties._z = null;
    loadData({
        "version": "2024a",
        "zones": [
            "Africa/Abidjan|GMT|0|0||48e5",
            "Africa/Nairobi|EAT|-30|0||47e5",
            "Africa/Algiers|CET|-10|0||26e5",
            "Africa/Lagos|WAT|-10|0||17e6",
            "Africa/Khartoum|CAT|-20|0||51e5",
            "Africa/Cairo|EET EEST|-20 -30|010101010101010|29NW0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0|15e6",
            "Africa/Casablanca|+01 +00|-10 0|010101010101010101010101|208q0 e00 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600|32e5",
            "Europe/Paris|CET CEST|-10 -20|01010101010101010101010|1XSp0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0|11e6",
            "Africa/Johannesburg|SAST|-20|0||84e5",
            "Africa/Juba|EAT CAT|-30 -20|01|24nx0|",
            "Africa/Sao_Tome|WAT GMT|-10 0|01|1XiN0|",
            "Africa/Tripoli|EET|-20|0||11e5",
            "America/Adak|HST HDT|a0 90|01010101010101010101010|1XKc0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0|326",
            "America/Anchorage|AKST AKDT|90 80|01010101010101010101010|1XKb0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0|30e4",
            "America/Santo_Domingo|AST|40|0||29e5",
            "America/Fortaleza|-03|30|0||34e5",
            "America/Asuncion|-03 -04|30 40|01010101010101010101010|1XPD0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0|28e5",
            "America/Panama|EST|50|0||15e5",
            "America/Mexico_City|CST CDT|60 50|010101010|1XVk0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0|20e6",
            "America/Managua|CST|60|0||22e5",
            "America/Caracas|-04|40|0||29e5",
            "America/Lima|-05|50|0||11e6",
            "America/Denver|MST MDT|70 60|01010101010101010101010|1XK90 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0|26e5",
            "America/Campo_Grande|-03 -04|30 40|01|1XBD0|77e4",
            "America/Chicago|CST CDT|60 50|01010101010101010101010|1XK80 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0|92e5",
            "America/Chihuahua|MST MDT CST|70 60 60|010101012|1XVl0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0|81e4",
            "America/Ciudad_Juarez|MST MDT CST|70 60 60|010101012010101010101010|1XK90 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1wn0 cm0 EP0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0|",
            "America/Phoenix|MST|70|0||42e5",
            "America/Whitehorse|PST PDT MST|80 70 70|01012|1XKa0 1zb0 Op0 1z90|23e3",
            "America/New_York|EST EDT|50 40|01010101010101010101010|1XK70 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0|21e6",
            "America/Los_Angeles|PST PDT|80 70|01010101010101010101010|1XKa0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0|15e6",
            "America/Halifax|AST ADT|40 30|01010101010101010101010|1XK60 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0|39e4",
            "America/Godthab|-03 -02 -01|30 20 10|0101010101212121212121|1XSp0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 2so0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0|17e3",
            "America/Havana|CST CDT|50 40|01010101010101010101010|1XK50 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0|21e5",
            "America/Mazatlan|MST MDT|70 60|010101010|1XVl0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0|44e4",
            "America/Metlakatla|PST AKST AKDT|80 90 80|012121212121212121212121|1Xqy0 jB0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0|14e2",
            "America/Miquelon|-03 -02|30 20|01010101010101010101010|1XK50 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0|61e2",
            "America/Noronha|-02|20|0||30e2",
            "America/Ojinaga|MST MDT CST CDT|70 60 60 50|01010101232323232323232|1XK90 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1wn0 Rc0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0|23e3",
            "America/Santiago|-03 -04|30 40|01010101010101010101010|1XVf0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0|62e5",
            "America/Sao_Paulo|-02 -03|20 30|01|1XBC0|20e6",
            "America/Scoresbysund|-01 +00 -02|10 0 20|0101010101020202020202|1XSp0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 2pA0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0|452",
            "America/St_Johns|NST NDT|3u 2u|01010101010101010101010|1XK5u 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0|11e4",
            "Antarctica/Casey|+11 +08|-b0 -80|0101010101|1XME0 1kr0 12l0 1o01 14kX 1lf1 14kX 1lf1 13bX|10",
            "Asia/Bangkok|+07|-70|0||15e6",
            "Asia/Vladivostok|+10|-a0|0||60e4",
            "Australia/Sydney|AEDT AEST|-b0 -a0|01010101010101010101010|1XV40 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0|40e5",
            "Asia/Tashkent|+05|-50|0||23e5",
            "Pacific/Auckland|NZDT NZST|-d0 -c0|01010101010101010101010|1XV20 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0|14e5",
            "Europe/Istanbul|+03|-30|0||13e6",
            "Antarctica/Troll|+00 +02|0 -20|01010101010101010101010|1XSp0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0|40",
            "Antarctica/Vostok|+07 +05|-70 -50|01|2bnv0|25",
            "Asia/Almaty|+06 +05|-60 -50|01|2bR60|15e5",
            "Asia/Amman|EET EEST +03|-20 -30 -30|010101012|1XRy0 1o00 11A0 1qM0 WM0 1qM0 LA0 1C00|25e5",
            "Asia/Kamchatka|+12|-c0|0||18e4",
            "Asia/Dubai|+04|-40|0||39e5",
            "Asia/Beirut|EET EEST|-20 -30|01010101010101010101010|1XSm0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0|22e5",
            "Asia/Dhaka|+06|-60|0||16e6",
            "Asia/Kuala_Lumpur|+08|-80|0||71e5",
            "Asia/Kolkata|IST|-5u|0||15e6",
            "Asia/Chita|+09|-90|0||33e4",
            "Asia/Shanghai|CST|-80|0||23e6",
            "Asia/Colombo|+0530|-5u|0||22e5",
            "Asia/Damascus|EET EEST +03|-20 -30 -30|010101012|1XRy0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0|26e5",
            "Europe/Athens|EET EEST|-20 -30|01010101010101010101010|1XSp0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0|35e5",
            "Asia/Gaza|EET EEST|-20 -30|01010101010101010101010|1XRy0 1on0 11B0 1o00 11A0 1qo0 XA0 1qp0 1cN0 1cL0 1a10 1fz0 17d0 1in0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0|18e5",
            "Asia/Hong_Kong|HKT|-80|0||73e5",
            "Asia/Jakarta|WIB|-70|0||31e6",
            "Asia/Jayapura|WIT|-90|0||26e4",
            "Asia/Jerusalem|IST IDT|-20 -30|01010101010101010101010|1XRA0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0|81e4",
            "Asia/Kabul|+0430|-4u|0||46e5",
            "Asia/Karachi|PKT|-50|0||24e6",
            "Asia/Kathmandu|+0545|-5J|0||12e5",
            "Asia/Sakhalin|+11|-b0|0||58e4",
            "Asia/Makassar|WITA|-80|0||15e5",
            "Asia/Manila|PST|-80|0||24e6",
            "Asia/Seoul|KST|-90|0||23e6",
            "Asia/Rangoon|+0630|-6u|0||48e5",
            "Asia/Tehran|+0330 +0430|-3u -4u|010101010|1XOIu 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0|14e6",
            "Asia/Tokyo|JST|-90|0||38e6",
            "Atlantic/Azores|-01 +00|10 0|01010101010101010101010|1XSp0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0|25e4",
            "Europe/Lisbon|WET WEST|0 -10|01010101010101010101010|1XSp0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0|27e5",
            "Atlantic/Cape_Verde|-01|10|0||50e4",
            "Australia/Adelaide|ACDT ACST|-au -9u|01010101010101010101010|1XV4u 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0|11e5",
            "Australia/Brisbane|AEST|-a0|0||20e5",
            "Australia/Darwin|ACST|-9u|0||12e4",
            "Australia/Eucla|+0845|-8J|0||368",
            "Australia/Lord_Howe|+11 +1030|-b0 -au|01010101010101010101010|1XV30 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu|347",
            "Australia/Perth|AWST|-80|0||18e5",
            "Pacific/Easter|-05 -06|50 60|01010101010101010101010|1XVf0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0|30e2",
            "Europe/Dublin|GMT IST|0 -10|01010101010101010101010|1XSp0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0|12e5",
            "Etc/GMT-1|+01|-10|0||",
            "Pacific/Tongatapu|+13|-d0|0||75e3",
            "Pacific/Kiritimati|+14|-e0|0||51e2",
            "Etc/GMT-2|+02|-20|0||",
            "Pacific/Tahiti|-10|a0|0||18e4",
            "Pacific/Niue|-11|b0|0||12e2",
            "Etc/GMT+12|-12|c0|0||",
            "Pacific/Galapagos|-06|60|0||25e3",
            "Etc/GMT+7|-07|70|0||",
            "Pacific/Pitcairn|-08|80|0||56",
            "Pacific/Gambier|-09|90|0||125",
            "Etc/UTC|UTC|0|0||",
            "Europe/London|GMT BST|0 -10|01010101010101010101010|1XSp0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0|10e6",
            "Europe/Chisinau|EET EEST|-20 -30|01010101010101010101010|1XSo0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0|67e4",
            "Europe/Moscow|MSK|-30|0||16e6",
            "Europe/Volgograd|+04 MSK|-40 -30|01|249a0|10e5",
            "Pacific/Honolulu|HST|a0|0||37e4",
            "MET|MET MEST|-10 -20|01010101010101010101010|1XSp0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0|",
            "Pacific/Chatham|+1345 +1245|-dJ -cJ|01010101010101010101010|1XV20 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0|600",
            "Pacific/Apia|+14 +13|-e0 -d0|010101|1XV20 1a00 1fA0 1a00 1fA0|37e3",
            "Pacific/Fiji|+13 +12|-d0 -c0|010101|1Xnq0 20o0 pc0 2hc0 bc0|88e4",
            "Pacific/Guam|ChST|-a0|0||17e4",
            "Pacific/Marquesas|-0930|9u|0||86e2",
            "Pacific/Pago_Pago|SST|b0|0||37e2",
            "Pacific/Norfolk|+11 +12|-b0 -c0|0101010101010101010101|219P0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0|25e4"
        ],
        "links": [
            "Africa/Abidjan|Africa/Accra",
            "Africa/Abidjan|Africa/Bamako",
            "Africa/Abidjan|Africa/Banjul",
            "Africa/Abidjan|Africa/Bissau",
            "Africa/Abidjan|Africa/Conakry",
            "Africa/Abidjan|Africa/Dakar",
            "Africa/Abidjan|Africa/Freetown",
            "Africa/Abidjan|Africa/Lome",
            "Africa/Abidjan|Africa/Monrovia",
            "Africa/Abidjan|Africa/Nouakchott",
            "Africa/Abidjan|Africa/Ouagadougou",
            "Africa/Abidjan|Africa/Timbuktu",
            "Africa/Abidjan|America/Danmarkshavn",
            "Africa/Abidjan|Atlantic/Reykjavik",
            "Africa/Abidjan|Atlantic/St_Helena",
            "Africa/Abidjan|Etc/GMT",
            "Africa/Abidjan|Etc/GMT+0",
            "Africa/Abidjan|Etc/GMT-0",
            "Africa/Abidjan|Etc/GMT0",
            "Africa/Abidjan|Etc/Greenwich",
            "Africa/Abidjan|GMT",
            "Africa/Abidjan|GMT+0",
            "Africa/Abidjan|GMT-0",
            "Africa/Abidjan|GMT0",
            "Africa/Abidjan|Greenwich",
            "Africa/Abidjan|Iceland",
            "Africa/Algiers|Africa/Tunis",
            "Africa/Cairo|Egypt",
            "Africa/Casablanca|Africa/El_Aaiun",
            "Africa/Johannesburg|Africa/Maseru",
            "Africa/Johannesburg|Africa/Mbabane",
            "Africa/Khartoum|Africa/Blantyre",
            "Africa/Khartoum|Africa/Bujumbura",
            "Africa/Khartoum|Africa/Gaborone",
            "Africa/Khartoum|Africa/Harare",
            "Africa/Khartoum|Africa/Kigali",
            "Africa/Khartoum|Africa/Lubumbashi",
            "Africa/Khartoum|Africa/Lusaka",
            "Africa/Khartoum|Africa/Maputo",
            "Africa/Khartoum|Africa/Windhoek",
            "Africa/Lagos|Africa/Bangui",
            "Africa/Lagos|Africa/Brazzaville",
            "Africa/Lagos|Africa/Douala",
            "Africa/Lagos|Africa/Kinshasa",
            "Africa/Lagos|Africa/Libreville",
            "Africa/Lagos|Africa/Luanda",
            "Africa/Lagos|Africa/Malabo",
            "Africa/Lagos|Africa/Ndjamena",
            "Africa/Lagos|Africa/Niamey",
            "Africa/Lagos|Africa/Porto-Novo",
            "Africa/Nairobi|Africa/Addis_Ababa",
            "Africa/Nairobi|Africa/Asmara",
            "Africa/Nairobi|Africa/Asmera",
            "Africa/Nairobi|Africa/Dar_es_Salaam",
            "Africa/Nairobi|Africa/Djibouti",
            "Africa/Nairobi|Africa/Kampala",
            "Africa/Nairobi|Africa/Mogadishu",
            "Africa/Nairobi|Indian/Antananarivo",
            "Africa/Nairobi|Indian/Comoro",
            "Africa/Nairobi|Indian/Mayotte",
            "Africa/Tripoli|Europe/Kaliningrad",
            "Africa/Tripoli|Libya",
            "America/Adak|America/Atka",
            "America/Adak|US/Aleutian",
            "America/Anchorage|America/Juneau",
            "America/Anchorage|America/Nome",
            "America/Anchorage|America/Sitka",
            "America/Anchorage|America/Yakutat",
            "America/Anchorage|US/Alaska",
            "America/Campo_Grande|America/Cuiaba",
            "America/Caracas|America/Boa_Vista",
            "America/Caracas|America/Guyana",
            "America/Caracas|America/La_Paz",
            "America/Caracas|America/Manaus",
            "America/Caracas|America/Porto_Velho",
            "America/Caracas|Brazil/West",
            "America/Caracas|Etc/GMT+4",
            "America/Chicago|America/Indiana/Knox",
            "America/Chicago|America/Indiana/Tell_City",
            "America/Chicago|America/Knox_IN",
            "America/Chicago|America/Matamoros",
            "America/Chicago|America/Menominee",
            "America/Chicago|America/North_Dakota/Beulah",
            "America/Chicago|America/North_Dakota/Center",
            "America/Chicago|America/North_Dakota/New_Salem",
            "America/Chicago|America/Rainy_River",
            "America/Chicago|America/Rankin_Inlet",
            "America/Chicago|America/Resolute",
            "America/Chicago|America/Winnipeg",
            "America/Chicago|CST6CDT",
            "America/Chicago|Canada/Central",
            "America/Chicago|US/Central",
            "America/Chicago|US/Indiana-Starke",
            "America/Denver|America/Boise",
            "America/Denver|America/Cambridge_Bay",
            "America/Denver|America/Edmonton",
            "America/Denver|America/Inuvik",
            "America/Denver|America/Shiprock",
            "America/Denver|America/Yellowknife",
            "America/Denver|Canada/Mountain",
            "America/Denver|MST7MDT",
            "America/Denver|Navajo",
            "America/Denver|US/Mountain",
            "America/Fortaleza|America/Araguaina",
            "America/Fortaleza|America/Argentina/Buenos_Aires",
            "America/Fortaleza|America/Argentina/Catamarca",
            "America/Fortaleza|America/Argentina/ComodRivadavia",
            "America/Fortaleza|America/Argentina/Cordoba",
            "America/Fortaleza|America/Argentina/Jujuy",
            "America/Fortaleza|America/Argentina/La_Rioja",
            "America/Fortaleza|America/Argentina/Mendoza",
            "America/Fortaleza|America/Argentina/Rio_Gallegos",
            "America/Fortaleza|America/Argentina/Salta",
            "America/Fortaleza|America/Argentina/San_Juan",
            "America/Fortaleza|America/Argentina/San_Luis",
            "America/Fortaleza|America/Argentina/Tucuman",
            "America/Fortaleza|America/Argentina/Ushuaia",
            "America/Fortaleza|America/Bahia",
            "America/Fortaleza|America/Belem",
            "America/Fortaleza|America/Buenos_Aires",
            "America/Fortaleza|America/Catamarca",
            "America/Fortaleza|America/Cayenne",
            "America/Fortaleza|America/Cordoba",
            "America/Fortaleza|America/Jujuy",
            "America/Fortaleza|America/Maceio",
            "America/Fortaleza|America/Mendoza",
            "America/Fortaleza|America/Montevideo",
            "America/Fortaleza|America/Paramaribo",
            "America/Fortaleza|America/Punta_Arenas",
            "America/Fortaleza|America/Recife",
            "America/Fortaleza|America/Rosario",
            "America/Fortaleza|America/Santarem",
            "America/Fortaleza|Antarctica/Palmer",
            "America/Fortaleza|Antarctica/Rothera",
            "America/Fortaleza|Atlantic/Stanley",
            "America/Fortaleza|Etc/GMT+3",
            "America/Godthab|America/Nuuk",
            "America/Halifax|America/Glace_Bay",
            "America/Halifax|America/Goose_Bay",
            "America/Halifax|America/Moncton",
            "America/Halifax|America/Thule",
            "America/Halifax|Atlantic/Bermuda",
            "America/Halifax|Canada/Atlantic",
            "America/Havana|Cuba",
            "America/Lima|America/Bogota",
            "America/Lima|America/Eirunepe",
            "America/Lima|America/Guayaquil",
            "America/Lima|America/Porto_Acre",
            "America/Lima|America/Rio_Branco",
            "America/Lima|Brazil/Acre",
            "America/Lima|Etc/GMT+5",
            "America/Los_Angeles|America/Ensenada",
            "America/Los_Angeles|America/Santa_Isabel",
            "America/Los_Angeles|America/Tijuana",
            "America/Los_Angeles|America/Vancouver",
            "America/Los_Angeles|Canada/Pacific",
            "America/Los_Angeles|Mexico/BajaNorte",
            "America/Los_Angeles|PST8PDT",
            "America/Los_Angeles|US/Pacific",
            "America/Managua|America/Belize",
            "America/Managua|America/Costa_Rica",
            "America/Managua|America/El_Salvador",
            "America/Managua|America/Guatemala",
            "America/Managua|America/Regina",
            "America/Managua|America/Swift_Current",
            "America/Managua|America/Tegucigalpa",
            "America/Managua|Canada/Saskatchewan",
            "America/Mazatlan|Mexico/BajaSur",
            "America/Mexico_City|America/Bahia_Banderas",
            "America/Mexico_City|America/Merida",
            "America/Mexico_City|America/Monterrey",
            "America/Mexico_City|Mexico/General",
            "America/New_York|America/Detroit",
            "America/New_York|America/Fort_Wayne",
            "America/New_York|America/Grand_Turk",
            "America/New_York|America/Indiana/Indianapolis",
            "America/New_York|America/Indiana/Marengo",
            "America/New_York|America/Indiana/Petersburg",
            "America/New_York|America/Indiana/Vevay",
            "America/New_York|America/Indiana/Vincennes",
            "America/New_York|America/Indiana/Winamac",
            "America/New_York|America/Indianapolis",
            "America/New_York|America/Iqaluit",
            "America/New_York|America/Kentucky/Louisville",
            "America/New_York|America/Kentucky/Monticello",
            "America/New_York|America/Louisville",
            "America/New_York|America/Montreal",
            "America/New_York|America/Nassau",
            "America/New_York|America/Nipigon",
            "America/New_York|America/Pangnirtung",
            "America/New_York|America/Port-au-Prince",
            "America/New_York|America/Thunder_Bay",
            "America/New_York|America/Toronto",
            "America/New_York|Canada/Eastern",
            "America/New_York|EST5EDT",
            "America/New_York|US/East-Indiana",
            "America/New_York|US/Eastern",
            "America/New_York|US/Michigan",
            "America/Noronha|Atlantic/South_Georgia",
            "America/Noronha|Brazil/DeNoronha",
            "America/Noronha|Etc/GMT+2",
            "America/Panama|America/Atikokan",
            "America/Panama|America/Cancun",
            "America/Panama|America/Cayman",
            "America/Panama|America/Coral_Harbour",
            "America/Panama|America/Jamaica",
            "America/Panama|EST",
            "America/Panama|Jamaica",
            "America/Phoenix|America/Creston",
            "America/Phoenix|America/Dawson_Creek",
            "America/Phoenix|America/Fort_Nelson",
            "America/Phoenix|America/Hermosillo",
            "America/Phoenix|MST",
            "America/Phoenix|US/Arizona",
            "America/Santiago|Chile/Continental",
            "America/Santo_Domingo|America/Anguilla",
            "America/Santo_Domingo|America/Antigua",
            "America/Santo_Domingo|America/Aruba",
            "America/Santo_Domingo|America/Barbados",
            "America/Santo_Domingo|America/Blanc-Sablon",
            "America/Santo_Domingo|America/Curacao",
            "America/Santo_Domingo|America/Dominica",
            "America/Santo_Domingo|America/Grenada",
            "America/Santo_Domingo|America/Guadeloupe",
            "America/Santo_Domingo|America/Kralendijk",
            "America/Santo_Domingo|America/Lower_Princes",
            "America/Santo_Domingo|America/Marigot",
            "America/Santo_Domingo|America/Martinique",
            "America/Santo_Domingo|America/Montserrat",
            "America/Santo_Domingo|America/Port_of_Spain",
            "America/Santo_Domingo|America/Puerto_Rico",
            "America/Santo_Domingo|America/St_Barthelemy",
            "America/Santo_Domingo|America/St_Kitts",
            "America/Santo_Domingo|America/St_Lucia",
            "America/Santo_Domingo|America/St_Thomas",
            "America/Santo_Domingo|America/St_Vincent",
            "America/Santo_Domingo|America/Tortola",
            "America/Santo_Domingo|America/Virgin",
            "America/Sao_Paulo|Brazil/East",
            "America/St_Johns|Canada/Newfoundland",
            "America/Whitehorse|America/Dawson",
            "America/Whitehorse|Canada/Yukon",
            "Asia/Almaty|Asia/Qostanay",
            "Asia/Bangkok|Antarctica/Davis",
            "Asia/Bangkok|Asia/Barnaul",
            "Asia/Bangkok|Asia/Ho_Chi_Minh",
            "Asia/Bangkok|Asia/Hovd",
            "Asia/Bangkok|Asia/Krasnoyarsk",
            "Asia/Bangkok|Asia/Novokuznetsk",
            "Asia/Bangkok|Asia/Novosibirsk",
            "Asia/Bangkok|Asia/Phnom_Penh",
            "Asia/Bangkok|Asia/Saigon",
            "Asia/Bangkok|Asia/Tomsk",
            "Asia/Bangkok|Asia/Vientiane",
            "Asia/Bangkok|Etc/GMT-7",
            "Asia/Bangkok|Indian/Christmas",
            "Asia/Chita|Asia/Dili",
            "Asia/Chita|Asia/Khandyga",
            "Asia/Chita|Asia/Yakutsk",
            "Asia/Chita|Etc/GMT-9",
            "Asia/Chita|Pacific/Palau",
            "Asia/Dhaka|Asia/Bishkek",
            "Asia/Dhaka|Asia/Dacca",
            "Asia/Dhaka|Asia/Kashgar",
            "Asia/Dhaka|Asia/Omsk",
            "Asia/Dhaka|Asia/Thimbu",
            "Asia/Dhaka|Asia/Thimphu",
            "Asia/Dhaka|Asia/Urumqi",
            "Asia/Dhaka|Etc/GMT-6",
            "Asia/Dhaka|Indian/Chagos",
            "Asia/Dubai|Asia/Baku",
            "Asia/Dubai|Asia/Muscat",
            "Asia/Dubai|Asia/Tbilisi",
            "Asia/Dubai|Asia/Yerevan",
            "Asia/Dubai|Etc/GMT-4",
            "Asia/Dubai|Europe/Astrakhan",
            "Asia/Dubai|Europe/Samara",
            "Asia/Dubai|Europe/Saratov",
            "Asia/Dubai|Europe/Ulyanovsk",
            "Asia/Dubai|Indian/Mahe",
            "Asia/Dubai|Indian/Mauritius",
            "Asia/Dubai|Indian/Reunion",
            "Asia/Gaza|Asia/Hebron",
            "Asia/Hong_Kong|Hongkong",
            "Asia/Jakarta|Asia/Pontianak",
            "Asia/Jerusalem|Asia/Tel_Aviv",
            "Asia/Jerusalem|Israel",
            "Asia/Kamchatka|Asia/Anadyr",
            "Asia/Kamchatka|Etc/GMT-12",
            "Asia/Kamchatka|Kwajalein",
            "Asia/Kamchatka|Pacific/Funafuti",
            "Asia/Kamchatka|Pacific/Kwajalein",
            "Asia/Kamchatka|Pacific/Majuro",
            "Asia/Kamchatka|Pacific/Nauru",
            "Asia/Kamchatka|Pacific/Tarawa",
            "Asia/Kamchatka|Pacific/Wake",
            "Asia/Kamchatka|Pacific/Wallis",
            "Asia/Kathmandu|Asia/Katmandu",
            "Asia/Kolkata|Asia/Calcutta",
            "Asia/Kuala_Lumpur|Asia/Brunei",
            "Asia/Kuala_Lumpur|Asia/Choibalsan",
            "Asia/Kuala_Lumpur|Asia/Irkutsk",
            "Asia/Kuala_Lumpur|Asia/Kuching",
            "Asia/Kuala_Lumpur|Asia/Singapore",
            "Asia/Kuala_Lumpur|Asia/Ulaanbaatar",
            "Asia/Kuala_Lumpur|Asia/Ulan_Bator",
            "Asia/Kuala_Lumpur|Etc/GMT-8",
            "Asia/Kuala_Lumpur|Singapore",
            "Asia/Makassar|Asia/Ujung_Pandang",
            "Asia/Rangoon|Asia/Yangon",
            "Asia/Rangoon|Indian/Cocos",
            "Asia/Sakhalin|Asia/Magadan",
            "Asia/Sakhalin|Asia/Srednekolymsk",
            "Asia/Sakhalin|Etc/GMT-11",
            "Asia/Sakhalin|Pacific/Bougainville",
            "Asia/Sakhalin|Pacific/Efate",
            "Asia/Sakhalin|Pacific/Guadalcanal",
            "Asia/Sakhalin|Pacific/Kosrae",
            "Asia/Sakhalin|Pacific/Noumea",
            "Asia/Sakhalin|Pacific/Pohnpei",
            "Asia/Sakhalin|Pacific/Ponape",
            "Asia/Seoul|Asia/Pyongyang",
            "Asia/Seoul|ROK",
            "Asia/Shanghai|Asia/Chongqing",
            "Asia/Shanghai|Asia/Chungking",
            "Asia/Shanghai|Asia/Harbin",
            "Asia/Shanghai|Asia/Macao",
            "Asia/Shanghai|Asia/Macau",
            "Asia/Shanghai|Asia/Taipei",
            "Asia/Shanghai|PRC",
            "Asia/Shanghai|ROC",
            "Asia/Tashkent|Antarctica/Mawson",
            "Asia/Tashkent|Asia/Aqtau",
            "Asia/Tashkent|Asia/Aqtobe",
            "Asia/Tashkent|Asia/Ashgabat",
            "Asia/Tashkent|Asia/Ashkhabad",
            "Asia/Tashkent|Asia/Atyrau",
            "Asia/Tashkent|Asia/Dushanbe",
            "Asia/Tashkent|Asia/Oral",
            "Asia/Tashkent|Asia/Qyzylorda",
            "Asia/Tashkent|Asia/Samarkand",
            "Asia/Tashkent|Asia/Yekaterinburg",
            "Asia/Tashkent|Etc/GMT-5",
            "Asia/Tashkent|Indian/Kerguelen",
            "Asia/Tashkent|Indian/Maldives",
            "Asia/Tehran|Iran",
            "Asia/Tokyo|Japan",
            "Asia/Vladivostok|Antarctica/DumontDUrville",
            "Asia/Vladivostok|Asia/Ust-Nera",
            "Asia/Vladivostok|Etc/GMT-10",
            "Asia/Vladivostok|Pacific/Chuuk",
            "Asia/Vladivostok|Pacific/Port_Moresby",
            "Asia/Vladivostok|Pacific/Truk",
            "Asia/Vladivostok|Pacific/Yap",
            "Atlantic/Cape_Verde|Etc/GMT+1",
            "Australia/Adelaide|Australia/Broken_Hill",
            "Australia/Adelaide|Australia/South",
            "Australia/Adelaide|Australia/Yancowinna",
            "Australia/Brisbane|Australia/Lindeman",
            "Australia/Brisbane|Australia/Queensland",
            "Australia/Darwin|Australia/North",
            "Australia/Lord_Howe|Australia/LHI",
            "Australia/Perth|Australia/West",
            "Australia/Sydney|Antarctica/Macquarie",
            "Australia/Sydney|Australia/ACT",
            "Australia/Sydney|Australia/Canberra",
            "Australia/Sydney|Australia/Currie",
            "Australia/Sydney|Australia/Hobart",
            "Australia/Sydney|Australia/Melbourne",
            "Australia/Sydney|Australia/NSW",
            "Australia/Sydney|Australia/Tasmania",
            "Australia/Sydney|Australia/Victoria",
            "Etc/UTC|Etc/UCT",
            "Etc/UTC|Etc/Universal",
            "Etc/UTC|Etc/Zulu",
            "Etc/UTC|UCT",
            "Etc/UTC|UTC",
            "Etc/UTC|Universal",
            "Etc/UTC|Zulu",
            "Europe/Athens|Asia/Famagusta",
            "Europe/Athens|Asia/Nicosia",
            "Europe/Athens|EET",
            "Europe/Athens|Europe/Bucharest",
            "Europe/Athens|Europe/Helsinki",
            "Europe/Athens|Europe/Kiev",
            "Europe/Athens|Europe/Kyiv",
            "Europe/Athens|Europe/Mariehamn",
            "Europe/Athens|Europe/Nicosia",
            "Europe/Athens|Europe/Riga",
            "Europe/Athens|Europe/Sofia",
            "Europe/Athens|Europe/Tallinn",
            "Europe/Athens|Europe/Uzhgorod",
            "Europe/Athens|Europe/Vilnius",
            "Europe/Athens|Europe/Zaporozhye",
            "Europe/Chisinau|Europe/Tiraspol",
            "Europe/Dublin|Eire",
            "Europe/Istanbul|Antarctica/Syowa",
            "Europe/Istanbul|Asia/Aden",
            "Europe/Istanbul|Asia/Baghdad",
            "Europe/Istanbul|Asia/Bahrain",
            "Europe/Istanbul|Asia/Istanbul",
            "Europe/Istanbul|Asia/Kuwait",
            "Europe/Istanbul|Asia/Qatar",
            "Europe/Istanbul|Asia/Riyadh",
            "Europe/Istanbul|Etc/GMT-3",
            "Europe/Istanbul|Europe/Minsk",
            "Europe/Istanbul|Turkey",
            "Europe/Lisbon|Atlantic/Canary",
            "Europe/Lisbon|Atlantic/Faeroe",
            "Europe/Lisbon|Atlantic/Faroe",
            "Europe/Lisbon|Atlantic/Madeira",
            "Europe/Lisbon|Portugal",
            "Europe/Lisbon|WET",
            "Europe/London|Europe/Belfast",
            "Europe/London|Europe/Guernsey",
            "Europe/London|Europe/Isle_of_Man",
            "Europe/London|Europe/Jersey",
            "Europe/London|GB",
            "Europe/London|GB-Eire",
            "Europe/Moscow|Europe/Kirov",
            "Europe/Moscow|Europe/Simferopol",
            "Europe/Moscow|W-SU",
            "Europe/Paris|Africa/Ceuta",
            "Europe/Paris|Arctic/Longyearbyen",
            "Europe/Paris|Atlantic/Jan_Mayen",
            "Europe/Paris|CET",
            "Europe/Paris|Europe/Amsterdam",
            "Europe/Paris|Europe/Andorra",
            "Europe/Paris|Europe/Belgrade",
            "Europe/Paris|Europe/Berlin",
            "Europe/Paris|Europe/Bratislava",
            "Europe/Paris|Europe/Brussels",
            "Europe/Paris|Europe/Budapest",
            "Europe/Paris|Europe/Busingen",
            "Europe/Paris|Europe/Copenhagen",
            "Europe/Paris|Europe/Gibraltar",
            "Europe/Paris|Europe/Ljubljana",
            "Europe/Paris|Europe/Luxembourg",
            "Europe/Paris|Europe/Madrid",
            "Europe/Paris|Europe/Malta",
            "Europe/Paris|Europe/Monaco",
            "Europe/Paris|Europe/Oslo",
            "Europe/Paris|Europe/Podgorica",
            "Europe/Paris|Europe/Prague",
            "Europe/Paris|Europe/Rome",
            "Europe/Paris|Europe/San_Marino",
            "Europe/Paris|Europe/Sarajevo",
            "Europe/Paris|Europe/Skopje",
            "Europe/Paris|Europe/Stockholm",
            "Europe/Paris|Europe/Tirane",
            "Europe/Paris|Europe/Vaduz",
            "Europe/Paris|Europe/Vatican",
            "Europe/Paris|Europe/Vienna",
            "Europe/Paris|Europe/Warsaw",
            "Europe/Paris|Europe/Zagreb",
            "Europe/Paris|Europe/Zurich",
            "Europe/Paris|Poland",
            "Pacific/Auckland|Antarctica/McMurdo",
            "Pacific/Auckland|Antarctica/South_Pole",
            "Pacific/Auckland|NZ",
            "Pacific/Chatham|NZ-CHAT",
            "Pacific/Easter|Chile/EasterIsland",
            "Pacific/Galapagos|Etc/GMT+6",
            "Pacific/Gambier|Etc/GMT+9",
            "Pacific/Guam|Pacific/Saipan",
            "Pacific/Honolulu|HST",
            "Pacific/Honolulu|Pacific/Johnston",
            "Pacific/Honolulu|US/Hawaii",
            "Pacific/Kiritimati|Etc/GMT-14",
            "Pacific/Niue|Etc/GMT+11",
            "Pacific/Pago_Pago|Pacific/Midway",
            "Pacific/Pago_Pago|Pacific/Samoa",
            "Pacific/Pago_Pago|US/Samoa",
            "Pacific/Pitcairn|Etc/GMT+8",
            "Pacific/Tahiti|Etc/GMT+10",
            "Pacific/Tahiti|Pacific/Rarotonga",
            "Pacific/Tongatapu|Etc/GMT-13",
            "Pacific/Tongatapu|Pacific/Enderbury",
            "Pacific/Tongatapu|Pacific/Fakaofo",
            "Pacific/Tongatapu|Pacific/Kanton"
        ],
        "countries": [
            "AD|Europe/Andorra",
            "AE|Asia/Dubai",
            "AF|Asia/Kabul",
            "AG|America/Puerto_Rico America/Antigua",
            "AI|America/Puerto_Rico America/Anguilla",
            "AL|Europe/Tirane",
            "AM|Asia/Yerevan",
            "AO|Africa/Lagos Africa/Luanda",
            "AQ|Antarctica/Casey Antarctica/Davis Antarctica/Mawson Antarctica/Palmer Antarctica/Rothera Antarctica/Troll Antarctica/Vostok Pacific/Auckland Pacific/Port_Moresby Asia/Riyadh Antarctica/McMurdo Antarctica/DumontDUrville Antarctica/Syowa",
            "AR|America/Argentina/Buenos_Aires America/Argentina/Cordoba America/Argentina/Salta America/Argentina/Jujuy America/Argentina/Tucuman America/Argentina/Catamarca America/Argentina/La_Rioja America/Argentina/San_Juan America/Argentina/Mendoza America/Argentina/San_Luis America/Argentina/Rio_Gallegos America/Argentina/Ushuaia",
            "AS|Pacific/Pago_Pago",
            "AT|Europe/Vienna",
            "AU|Australia/Lord_Howe Antarctica/Macquarie Australia/Hobart Australia/Melbourne Australia/Sydney Australia/Broken_Hill Australia/Brisbane Australia/Lindeman Australia/Adelaide Australia/Darwin Australia/Perth Australia/Eucla",
            "AW|America/Puerto_Rico America/Aruba",
            "AX|Europe/Helsinki Europe/Mariehamn",
            "AZ|Asia/Baku",
            "BA|Europe/Belgrade Europe/Sarajevo",
            "BB|America/Barbados",
            "BD|Asia/Dhaka",
            "BE|Europe/Brussels",
            "BF|Africa/Abidjan Africa/Ouagadougou",
            "BG|Europe/Sofia",
            "BH|Asia/Qatar Asia/Bahrain",
            "BI|Africa/Maputo Africa/Bujumbura",
            "BJ|Africa/Lagos Africa/Porto-Novo",
            "BL|America/Puerto_Rico America/St_Barthelemy",
            "BM|Atlantic/Bermuda",
            "BN|Asia/Kuching Asia/Brunei",
            "BO|America/La_Paz",
            "BQ|America/Puerto_Rico America/Kralendijk",
            "BR|America/Noronha America/Belem America/Fortaleza America/Recife America/Araguaina America/Maceio America/Bahia America/Sao_Paulo America/Campo_Grande America/Cuiaba America/Santarem America/Porto_Velho America/Boa_Vista America/Manaus America/Eirunepe America/Rio_Branco",
            "BS|America/Toronto America/Nassau",
            "BT|Asia/Thimphu",
            "BW|Africa/Maputo Africa/Gaborone",
            "BY|Europe/Minsk",
            "BZ|America/Belize",
            "CA|America/St_Johns America/Halifax America/Glace_Bay America/Moncton America/Goose_Bay America/Toronto America/Iqaluit America/Winnipeg America/Resolute America/Rankin_Inlet America/Regina America/Swift_Current America/Edmonton America/Cambridge_Bay America/Inuvik America/Dawson_Creek America/Fort_Nelson America/Whitehorse America/Dawson America/Vancouver America/Panama America/Puerto_Rico America/Phoenix America/Blanc-Sablon America/Atikokan America/Creston",
            "CC|Asia/Yangon Indian/Cocos",
            "CD|Africa/Maputo Africa/Lagos Africa/Kinshasa Africa/Lubumbashi",
            "CF|Africa/Lagos Africa/Bangui",
            "CG|Africa/Lagos Africa/Brazzaville",
            "CH|Europe/Zurich",
            "CI|Africa/Abidjan",
            "CK|Pacific/Rarotonga",
            "CL|America/Santiago America/Punta_Arenas Pacific/Easter",
            "CM|Africa/Lagos Africa/Douala",
            "CN|Asia/Shanghai Asia/Urumqi",
            "CO|America/Bogota",
            "CR|America/Costa_Rica",
            "CU|America/Havana",
            "CV|Atlantic/Cape_Verde",
            "CW|America/Puerto_Rico America/Curacao",
            "CX|Asia/Bangkok Indian/Christmas",
            "CY|Asia/Nicosia Asia/Famagusta",
            "CZ|Europe/Prague",
            "DE|Europe/Zurich Europe/Berlin Europe/Busingen",
            "DJ|Africa/Nairobi Africa/Djibouti",
            "DK|Europe/Berlin Europe/Copenhagen",
            "DM|America/Puerto_Rico America/Dominica",
            "DO|America/Santo_Domingo",
            "DZ|Africa/Algiers",
            "EC|America/Guayaquil Pacific/Galapagos",
            "EE|Europe/Tallinn",
            "EG|Africa/Cairo",
            "EH|Africa/El_Aaiun",
            "ER|Africa/Nairobi Africa/Asmara",
            "ES|Europe/Madrid Africa/Ceuta Atlantic/Canary",
            "ET|Africa/Nairobi Africa/Addis_Ababa",
            "FI|Europe/Helsinki",
            "FJ|Pacific/Fiji",
            "FK|Atlantic/Stanley",
            "FM|Pacific/Kosrae Pacific/Port_Moresby Pacific/Guadalcanal Pacific/Chuuk Pacific/Pohnpei",
            "FO|Atlantic/Faroe",
            "FR|Europe/Paris",
            "GA|Africa/Lagos Africa/Libreville",
            "GB|Europe/London",
            "GD|America/Puerto_Rico America/Grenada",
            "GE|Asia/Tbilisi",
            "GF|America/Cayenne",
            "GG|Europe/London Europe/Guernsey",
            "GH|Africa/Abidjan Africa/Accra",
            "GI|Europe/Gibraltar",
            "GL|America/Nuuk America/Danmarkshavn America/Scoresbysund America/Thule",
            "GM|Africa/Abidjan Africa/Banjul",
            "GN|Africa/Abidjan Africa/Conakry",
            "GP|America/Puerto_Rico America/Guadeloupe",
            "GQ|Africa/Lagos Africa/Malabo",
            "GR|Europe/Athens",
            "GS|Atlantic/South_Georgia",
            "GT|America/Guatemala",
            "GU|Pacific/Guam",
            "GW|Africa/Bissau",
            "GY|America/Guyana",
            "HK|Asia/Hong_Kong",
            "HN|America/Tegucigalpa",
            "HR|Europe/Belgrade Europe/Zagreb",
            "HT|America/Port-au-Prince",
            "HU|Europe/Budapest",
            "ID|Asia/Jakarta Asia/Pontianak Asia/Makassar Asia/Jayapura",
            "IE|Europe/Dublin",
            "IL|Asia/Jerusalem",
            "IM|Europe/London Europe/Isle_of_Man",
            "IN|Asia/Kolkata",
            "IO|Indian/Chagos",
            "IQ|Asia/Baghdad",
            "IR|Asia/Tehran",
            "IS|Africa/Abidjan Atlantic/Reykjavik",
            "IT|Europe/Rome",
            "JE|Europe/London Europe/Jersey",
            "JM|America/Jamaica",
            "JO|Asia/Amman",
            "JP|Asia/Tokyo",
            "KE|Africa/Nairobi",
            "KG|Asia/Bishkek",
            "KH|Asia/Bangkok Asia/Phnom_Penh",
            "KI|Pacific/Tarawa Pacific/Kanton Pacific/Kiritimati",
            "KM|Africa/Nairobi Indian/Comoro",
            "KN|America/Puerto_Rico America/St_Kitts",
            "KP|Asia/Pyongyang",
            "KR|Asia/Seoul",
            "KW|Asia/Riyadh Asia/Kuwait",
            "KY|America/Panama America/Cayman",
            "KZ|Asia/Almaty Asia/Qyzylorda Asia/Qostanay Asia/Aqtobe Asia/Aqtau Asia/Atyrau Asia/Oral",
            "LA|Asia/Bangkok Asia/Vientiane",
            "LB|Asia/Beirut",
            "LC|America/Puerto_Rico America/St_Lucia",
            "LI|Europe/Zurich Europe/Vaduz",
            "LK|Asia/Colombo",
            "LR|Africa/Monrovia",
            "LS|Africa/Johannesburg Africa/Maseru",
            "LT|Europe/Vilnius",
            "LU|Europe/Brussels Europe/Luxembourg",
            "LV|Europe/Riga",
            "LY|Africa/Tripoli",
            "MA|Africa/Casablanca",
            "MC|Europe/Paris Europe/Monaco",
            "MD|Europe/Chisinau",
            "ME|Europe/Belgrade Europe/Podgorica",
            "MF|America/Puerto_Rico America/Marigot",
            "MG|Africa/Nairobi Indian/Antananarivo",
            "MH|Pacific/Tarawa Pacific/Kwajalein Pacific/Majuro",
            "MK|Europe/Belgrade Europe/Skopje",
            "ML|Africa/Abidjan Africa/Bamako",
            "MM|Asia/Yangon",
            "MN|Asia/Ulaanbaatar Asia/Hovd Asia/Choibalsan",
            "MO|Asia/Macau",
            "MP|Pacific/Guam Pacific/Saipan",
            "MQ|America/Martinique",
            "MR|Africa/Abidjan Africa/Nouakchott",
            "MS|America/Puerto_Rico America/Montserrat",
            "MT|Europe/Malta",
            "MU|Indian/Mauritius",
            "MV|Indian/Maldives",
            "MW|Africa/Maputo Africa/Blantyre",
            "MX|America/Mexico_City America/Cancun America/Merida America/Monterrey America/Matamoros America/Chihuahua America/Ciudad_Juarez America/Ojinaga America/Mazatlan America/Bahia_Banderas America/Hermosillo America/Tijuana",
            "MY|Asia/Kuching Asia/Singapore Asia/Kuala_Lumpur",
            "MZ|Africa/Maputo",
            "NA|Africa/Windhoek",
            "NC|Pacific/Noumea",
            "NE|Africa/Lagos Africa/Niamey",
            "NF|Pacific/Norfolk",
            "NG|Africa/Lagos",
            "NI|America/Managua",
            "NL|Europe/Brussels Europe/Amsterdam",
            "NO|Europe/Berlin Europe/Oslo",
            "NP|Asia/Kathmandu",
            "NR|Pacific/Nauru",
            "NU|Pacific/Niue",
            "NZ|Pacific/Auckland Pacific/Chatham",
            "OM|Asia/Dubai Asia/Muscat",
            "PA|America/Panama",
            "PE|America/Lima",
            "PF|Pacific/Tahiti Pacific/Marquesas Pacific/Gambier",
            "PG|Pacific/Port_Moresby Pacific/Bougainville",
            "PH|Asia/Manila",
            "PK|Asia/Karachi",
            "PL|Europe/Warsaw",
            "PM|America/Miquelon",
            "PN|Pacific/Pitcairn",
            "PR|America/Puerto_Rico",
            "PS|Asia/Gaza Asia/Hebron",
            "PT|Europe/Lisbon Atlantic/Madeira Atlantic/Azores",
            "PW|Pacific/Palau",
            "PY|America/Asuncion",
            "QA|Asia/Qatar",
            "RE|Asia/Dubai Indian/Reunion",
            "RO|Europe/Bucharest",
            "RS|Europe/Belgrade",
            "RU|Europe/Kaliningrad Europe/Moscow Europe/Simferopol Europe/Kirov Europe/Volgograd Europe/Astrakhan Europe/Saratov Europe/Ulyanovsk Europe/Samara Asia/Yekaterinburg Asia/Omsk Asia/Novosibirsk Asia/Barnaul Asia/Tomsk Asia/Novokuznetsk Asia/Krasnoyarsk Asia/Irkutsk Asia/Chita Asia/Yakutsk Asia/Khandyga Asia/Vladivostok Asia/Ust-Nera Asia/Magadan Asia/Sakhalin Asia/Srednekolymsk Asia/Kamchatka Asia/Anadyr",
            "RW|Africa/Maputo Africa/Kigali",
            "SA|Asia/Riyadh",
            "SB|Pacific/Guadalcanal",
            "SC|Asia/Dubai Indian/Mahe",
            "SD|Africa/Khartoum",
            "SE|Europe/Berlin Europe/Stockholm",
            "SG|Asia/Singapore",
            "SH|Africa/Abidjan Atlantic/St_Helena",
            "SI|Europe/Belgrade Europe/Ljubljana",
            "SJ|Europe/Berlin Arctic/Longyearbyen",
            "SK|Europe/Prague Europe/Bratislava",
            "SL|Africa/Abidjan Africa/Freetown",
            "SM|Europe/Rome Europe/San_Marino",
            "SN|Africa/Abidjan Africa/Dakar",
            "SO|Africa/Nairobi Africa/Mogadishu",
            "SR|America/Paramaribo",
            "SS|Africa/Juba",
            "ST|Africa/Sao_Tome",
            "SV|America/El_Salvador",
            "SX|America/Puerto_Rico America/Lower_Princes",
            "SY|Asia/Damascus",
            "SZ|Africa/Johannesburg Africa/Mbabane",
            "TC|America/Grand_Turk",
            "TD|Africa/Ndjamena",
            "TF|Asia/Dubai Indian/Maldives Indian/Kerguelen",
            "TG|Africa/Abidjan Africa/Lome",
            "TH|Asia/Bangkok",
            "TJ|Asia/Dushanbe",
            "TK|Pacific/Fakaofo",
            "TL|Asia/Dili",
            "TM|Asia/Ashgabat",
            "TN|Africa/Tunis",
            "TO|Pacific/Tongatapu",
            "TR|Europe/Istanbul",
            "TT|America/Puerto_Rico America/Port_of_Spain",
            "TV|Pacific/Tarawa Pacific/Funafuti",
            "TW|Asia/Taipei",
            "TZ|Africa/Nairobi Africa/Dar_es_Salaam",
            "UA|Europe/Simferopol Europe/Kyiv",
            "UG|Africa/Nairobi Africa/Kampala",
            "UM|Pacific/Pago_Pago Pacific/Tarawa Pacific/Midway Pacific/Wake",
            "US|America/New_York America/Detroit America/Kentucky/Louisville America/Kentucky/Monticello America/Indiana/Indianapolis America/Indiana/Vincennes America/Indiana/Winamac America/Indiana/Marengo America/Indiana/Petersburg America/Indiana/Vevay America/Chicago America/Indiana/Tell_City America/Indiana/Knox America/Menominee America/North_Dakota/Center America/North_Dakota/New_Salem America/North_Dakota/Beulah America/Denver America/Boise America/Phoenix America/Los_Angeles America/Anchorage America/Juneau America/Sitka America/Metlakatla America/Yakutat America/Nome America/Adak Pacific/Honolulu",
            "UY|America/Montevideo",
            "UZ|Asia/Samarkand Asia/Tashkent",
            "VA|Europe/Rome Europe/Vatican",
            "VC|America/Puerto_Rico America/St_Vincent",
            "VE|America/Caracas",
            "VG|America/Puerto_Rico America/Tortola",
            "VI|America/Puerto_Rico America/St_Thomas",
            "VN|Asia/Bangkok Asia/Ho_Chi_Minh",
            "VU|Pacific/Efate",
            "WF|Pacific/Tarawa Pacific/Wallis",
            "WS|Pacific/Apia",
            "YE|Asia/Riyadh Asia/Aden",
            "YT|Africa/Nairobi Indian/Mayotte",
            "ZA|Africa/Johannesburg",
            "ZM|Africa/Maputo Africa/Lusaka",
            "ZW|Africa/Maputo Africa/Harare"
        ]
    });
    return moment;
});


const $771e08fe9e4dca76$var$reformatTimezoneToOption = (zone)=>{
    const momentOffset = (0, (/*@__PURE__*/$parcel$interopDefault($49586f21c72f668e$exports))).tz(new Date(), zone).format("Z");
    return {
        label: zone.replace(/_/g, " ").replace(/\bKiev\b/g, "Kyiv"),
        value: {
            offset: momentOffset,
            zone: zone
        }
    };
};
const $771e08fe9e4dca76$export$83b7d32c1ffb9ac7 = (0, (/*@__PURE__*/$parcel$interopDefault($49586f21c72f668e$exports))).tz.names().filter((zone)=>{
    const lowerZone = zone.toLowerCase();
    return !([
        "est",
        "mst",
        "hst",
        "roc"
    ].includes(lowerZone) || // We replace Europe/Kiev with Europe/Kyiv in the UI because backends don't support Europ/Kyiv yet
    lowerZone === "europe/kyiv" || lowerZone.startsWith("etc/") || lowerZone.startsWith("gmt"));
}).map((zone)=>$771e08fe9e4dca76$var$reformatTimezoneToOption(zone));




const $12c1a304a2d27a0d$var$Option = (props)=>/*#__PURE__*/ (0, $bibO8.jsx)((0, $fc2pq.c).Option, {
        ...props,
        children: /*#__PURE__*/ (0, $bibO8.jsxs)($c53b8e29f0dfe605$export$dbf56bbc3407fe85, {
            children: [
                /*#__PURE__*/ (0, $bibO8.jsx)($c53b8e29f0dfe605$export$94391c949d55601d, {
                    children: props.label
                }),
                /*#__PURE__*/ (0, $bibO8.jsx)($c53b8e29f0dfe605$export$10896e23c75fe9a6, {
                    children: props.value.offset
                })
            ]
        })
    });
const $12c1a304a2d27a0d$export$1c454477c31e667c = ({ inputId: inputId, userId: userId, onMutationSuccess: onMutationSuccess, onMutationError: onMutationError })=>{
    const { defaultValue: defaultValue, isError: isError, isLoading: isLoading } = (0, $13a016ace271c826$export$426b2759ec8c8bc6)("timezone", userId);
    const { mutate: onChange } = (0, $1ff7ae0ebc51ff87$export$76936a29374a0363)({
        userId: userId,
        onMutationSuccess: onMutationSuccess,
        onMutationError: onMutationError
    });
    const defaultTimezone = (0, $dAx5m.useMemo)(()=>(0, $771e08fe9e4dca76$export$83b7d32c1ffb9ac7).find((option)=>option.value.zone === defaultValue), [
        defaultValue
    ]);
    return /*#__PURE__*/ (0, $bibO8.jsxs)($c53b8e29f0dfe605$export$5f7211d21bfdae05, {
        children: [
            isError && /*#__PURE__*/ (0, $bibO8.jsx)($c53b8e29f0dfe605$export$a093dca7d0282216, {
                children: /*#__PURE__*/ (0, $bibO8.jsx)((0, $55TWT.default), {
                    id: "ptc-directory.manage-account.account-preferences.location.timezone.error",
                    defaultMessage: "Unable to load your time zone.",
                    description: "An error message shows when cannot load timezone in Account Preferences page"
                })
            }),
            isLoading && /*#__PURE__*/ (0, $bibO8.jsx)((0, $2pRqv.LoadingPlaceHolder), {
                "data-testid": "TimezoneDropdownLoader"
            }),
            !isError && !isLoading && /*#__PURE__*/ (0, $bibO8.jsx)((0, $2QbFH.default), {
                inputId: inputId,
                placeholder: /*#__PURE__*/ (0, $bibO8.jsx)((0, $55TWT.default), {
                    id: "pf-home.profile-page.timezone.placeholder",
                    defaultMessage: "Your time zone",
                    description: "Placeholder text to display in the time zone input when it is empty"
                }),
                options: (0, $771e08fe9e4dca76$export$83b7d32c1ffb9ac7),
                onChange: (option)=>option && onChange({
                        timezone: option.value.zone
                    }),
                components: {
                    Option: $12c1a304a2d27a0d$var$Option
                },
                defaultValue: defaultTimezone
            })
        ]
    });
};
var $12c1a304a2d27a0d$export$2e2bcd8739ae039 = $12c1a304a2d27a0d$export$1c454477c31e667c;


parcelRequire("kil2v");
var $dggvN = parcelRequire("dggvN");
const $04e2046eef91e029$var$TimezoneDropdownContainer = (0, $dggvN.default)((0, $12c1a304a2d27a0d$export$2e2bcd8739ae039));
var $04e2046eef91e029$export$2e2bcd8739ae039 = $04e2046eef91e029$var$TimezoneDropdownContainer;



var $h1Uju = parcelRequire("h1Uju");

var $87zUj = parcelRequire("87zUj");
const $5e791a873042001a$var$MANAGE_PROFILE_SETTINGS_LANGUAGE = "MANAGE_PROFILE_SETTINGS_LANGUAGE";
const $5e791a873042001a$export$93e0405fb939a7fc = ({ addFlag: addFlag, isManaged: isManaged })=>{
    /**
   * Calculates whether to send the Apdex event to say the page is ready for user interaction.
   */ const isPageReady = ()=>{
        // FIXME: PTC-1407 - we must ensure ApdexStop only renders once all relevant data is loaded
        return true;
    };
    const { formatMessage: formatMessage } = (0, $dZHnD.default)();
    const handleChangeSuccess = (0, $dAx5m.useCallback)((filedType, shouldAutoReloadPage)=>{
        return ()=>{
            addFlag({
                type: "success",
                title: formatMessage($5e791a873042001a$var$messages[`${filedType}_changeSuccessFlagTitle`]),
                description: formatMessage({
                    id: "ptc-directory.manage-account.account-preferences.change-propagation-takes-time",
                    defaultMessage: "Your change might take a while to show everywhere",
                    description: "The message description shown after a user info is edited, mostly about changes not being visible everywhere immediately"
                }),
                id: $5e791a873042001a$var$MANAGE_PROFILE_SETTINGS_LANGUAGE
            });
            if (shouldAutoReloadPage) // give some time for the flag to show
            // PTC-2051: there is a bug which locale value in dropdown does not update
            setTimeout((0, $eN1Wl.reload), 500);
        };
    }, [
        addFlag,
        formatMessage
    ]);
    const handleChangeError = (0, $dAx5m.useCallback)((filedType)=>{
        return ()=>{
            addFlag({
                type: "error",
                title: formatMessage($5e791a873042001a$var$messages[`${filedType}_changeErrorFlagTitle`]),
                description: formatMessage({
                    id: "ptc-directory.manage-account.account-preferences.language.change.error.description",
                    defaultMessage: "Try again later.",
                    description: "Body of error flag that appears when we fail to update the user\u2019s preferred language"
                }),
                id: $5e791a873042001a$var$MANAGE_PROFILE_SETTINGS_LANGUAGE
            });
        };
    }, [
        addFlag,
        formatMessage
    ]);
    return /*#__PURE__*/ (0, $bibO8.jsxs)((0, $bibO8.Fragment), {
        children: [
            /*#__PURE__*/ (0, $bibO8.jsxs)($c53b8e29f0dfe605$export$8b251419efc915eb, {
                children: [
                    /*#__PURE__*/ (0, $bibO8.jsx)((0, $6bOZI.default), {
                        children: formatMessage({
                            id: "ptc-directory.manage-account.account-preferences.page-header-title",
                            defaultMessage: "Account preferences",
                            description: "Title for the settings page for controlling preferences to do with how a user interacts with Atlassian products"
                        })
                    }),
                    /*#__PURE__*/ (0, $bibO8.jsx)((0, $55TWT.default), {
                        id: "ptc-directory.manage-account.account-preferences.page-summary",
                        defaultMessage: "Control settings related to your account.",
                        description: "A short description for this settings page"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $bibO8.jsxs)($hxi5h.SettingsSection, {
                children: [
                    /*#__PURE__*/ (0, $bibO8.jsxs)($hxi5h.SettingsDescription, {
                        children: [
                            /*#__PURE__*/ (0, $bibO8.jsx)((0, $55TWT.default), {
                                id: "ptc-directory.manage-account.account-preferences.language.timezone",
                                defaultMessage: "Language & Region",
                                description: "A heading for the language & region section",
                                tagName: "h3"
                            }),
                            /*#__PURE__*/ (0, $bibO8.jsx)((0, $55TWT.default), {
                                id: "ptc-directory.manage-account.account-preferences.language.description.unified.xml",
                                defaultMessage: "Changes to your language and timezone will be reflected across Jira, Confluence, Trello, Bitbucket and directory. Update your language and timezone for other products from your <product-settings-link>product settings.</product-settings-link>",
                                description: "Describes the scope of what the language setting. This message is used when unified language and timezone of Confluence feature and Jira turns on",
                                tagName: "p",
                                values: {
                                    // eslint-disable-next-line react/display-name
                                    "product-settings-link": (chunks)=>/*#__PURE__*/ (0, $bibO8.jsx)("a", {
                                            href: `${(0, $3B7Hp.getManageProfileAppRootPath)()}/products`,
                                            children: chunks
                                        })
                                }
                            }),
                            /*#__PURE__*/ (0, $bibO8.jsx)($c53b8e29f0dfe605$export$147422f7450ccfac, {
                                children: /*#__PURE__*/ (0, $bibO8.jsx)((0, $hb374.Label), {
                                    htmlFor: "language-dropdown",
                                    children: formatMessage({
                                        id: "ptc-directory.manage-account.account-preferences.language",
                                        defaultMessage: "Language",
                                        description: "A heading for the language section"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $bibO8.jsx)($c53b8e29f0dfe605$export$305cd396b3ffc5e2, {
                                "data-testid": "language-settings",
                                children: /*#__PURE__*/ (0, $bibO8.jsx)((0, $12b9e50fb1d3a731$export$2e2bcd8739ae039), {
                                    inputId: "language-dropdown",
                                    onMutationSuccess: handleChangeSuccess((0, $h1Uju.FieldType).Language, true),
                                    onMutationError: handleChangeError((0, $h1Uju.FieldType).Language)
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $bibO8.jsxs)($hxi5h.SettingsDescription, {
                        children: [
                            /*#__PURE__*/ (0, $bibO8.jsx)($c53b8e29f0dfe605$export$147422f7450ccfac, {
                                children: /*#__PURE__*/ (0, $bibO8.jsx)((0, $hb374.Label), {
                                    htmlFor: "timezone-dropdown",
                                    children: formatMessage({
                                        id: "ptc-directory.manage-account.account-preferences.timezone",
                                        defaultMessage: "Time zone",
                                        description: "Label for the input field for the users time zone"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $bibO8.jsx)($c53b8e29f0dfe605$export$edaca75100fc443c, {
                                "data-testid": "timezone-settings",
                                children: /*#__PURE__*/ (0, $bibO8.jsx)((0, $04e2046eef91e029$export$2e2bcd8739ae039), {
                                    inputId: "timezone-dropdown",
                                    onMutationSuccess: handleChangeSuccess((0, $h1Uju.FieldType).Timezone),
                                    onMutationError: handleChangeError((0, $h1Uju.FieldType).Timezone)
                                })
                            })
                        ]
                    })
                ]
            }),
            isPageReady() && /*#__PURE__*/ (0, $bibO8.jsx)((0, $zFJ4O.default), {
                task: (0, $7dUzb.ApdexTasks).VIEW_ACCOUNT_PREFERENCES_SETTINGS
            }),
            /*#__PURE__*/ (0, $bibO8.jsx)((0, $87zUj.default), {
                isManaged: isManaged
            })
        ]
    });
};
const $5e791a873042001a$var$messages = (0, $lKhJJ.defineMessages)({
    language_changeSuccessFlagTitle: {
        id: "ptc-directory.manage-account.account-preferences.language.change.success.title",
        defaultMessage: "You\u2019ve updated your language. ",
        description: "Success flag that appears when the user has successfully updated their preferred language"
    },
    language_changeErrorFlagTitle: {
        id: "ptc-directory.manage-account.account-preferences.language.change.error.title",
        defaultMessage: "We couldn\u2019t update your language. ",
        description: "Title of error flag that appears when we fail to update the user\u2019s preferred language"
    },
    timezone_changeSuccessFlagTitle: {
        id: "ptc-directory.manage-account.account-preferences.timezone.change.success.title",
        defaultMessage: "We\u2019re updating your time zone",
        description: "The success message title for when editing the timezone succeeded. Appears at the title of the notification flag upon a successful save."
    },
    timezone_changeErrorFlagTitle: {
        id: "ptc-directory.manage-account.account-preferences.timezone.change.error.title",
        defaultMessage: "We couldn\u2019t update your time zone",
        description: "The error message title for when editing the time zone fails. Appears in a notification flag upon failure to save new value."
    }
});
var $5e791a873042001a$export$2e2bcd8739ae039 = $5e791a873042001a$export$93e0405fb939a7fc;


parcelRequire("jShba");
var $3kXiv = parcelRequire("3kXiv");
const $7b6ffbc1ec6149d0$var$mapStateToProps = ({ user: user })=>({
        isManaged: user.data.isManaged
    });
const $7b6ffbc1ec6149d0$var$mapDispatchToProps = {
    addFlag: $3kXiv.addFlag
};
var $7b6ffbc1ec6149d0$export$2e2bcd8739ae039 = (0, $7PWYP.default)($7b6ffbc1ec6149d0$var$mapStateToProps, $7b6ffbc1ec6149d0$var$mapDispatchToProps)((0, $5e791a873042001a$export$2e2bcd8739ae039));





var $bibO8 = parcelRequire("bibO8");
parcelRequire("dAx5m");

var $cUsaH = parcelRequire("cUsaH");

const $a0e9a4ceeea34446$var$LazyConnectedAppsSettings = (0, (/*@__PURE__*/$parcel$interopDefault($cUsaH)))({
    loader: ()=>(parcelRequire("kA6jR")),
    loading: ()=>null
});
$a0e9a4ceeea34446$var$LazyConnectedAppsSettings.displayName = "lazy(ConnectedAppsSettings)";
var $a0e9a4ceeea34446$export$2e2bcd8739ae039 = $a0e9a4ceeea34446$var$LazyConnectedAppsSettings;






parcelRequire("jShba");
var $53PE4 = parcelRequire("53PE4");
var $7dUzb = parcelRequire("7dUzb");
var $6e62a = parcelRequire("6e62a");
const $fc35749ea2d02931$var$SettingsConnectedAppsRoute = ()=>/*#__PURE__*/ (0, $bibO8.jsxs)((0, $bibO8.Fragment), {
        children: [
            /*#__PURE__*/ (0, $bibO8.jsx)((0, $53PE4.default), {
                task: (0, $7dUzb.ApdexTasks).VIEW_APPS_SETTINGS
            }),
            /*#__PURE__*/ (0, $bibO8.jsx)((0, $6e62a.default), {}),
            /*#__PURE__*/ (0, $bibO8.jsx)((0, $a0e9a4ceeea34446$export$2e2bcd8739ae039), {})
        ]
    });
var $fc35749ea2d02931$export$2e2bcd8739ae039 = $fc35749ea2d02931$var$SettingsConnectedAppsRoute;



var $bibO8 = parcelRequire("bibO8");
parcelRequire("dAx5m");

var $cUsaH = parcelRequire("cUsaH");

const $9b18daffb00689f0$var$LazyLinkPreferencesSettings = (0, (/*@__PURE__*/$parcel$interopDefault($cUsaH)))({
    loader: ()=>(parcelRequire("cTT9B")),
    loading: ()=>null
});
$9b18daffb00689f0$var$LazyLinkPreferencesSettings.displayName = "lazy(LinkPreferencesSettings)";
var $9b18daffb00689f0$export$2e2bcd8739ae039 = $9b18daffb00689f0$var$LazyLinkPreferencesSettings;


parcelRequire("jShba");
var $53PE4 = parcelRequire("53PE4");
var $7dUzb = parcelRequire("7dUzb");
var $6e62a = parcelRequire("6e62a");
const $a207c9463029025d$var$LinkPreferencesRoute = ()=>/*#__PURE__*/ (0, $bibO8.jsxs)((0, $bibO8.Fragment), {
        children: [
            /*#__PURE__*/ (0, $bibO8.jsx)((0, $53PE4.default), {
                task: (0, $7dUzb.ApdexTasks).VIEW_LINK_PREFERENCES_SETTINGS
            }),
            /*#__PURE__*/ (0, $bibO8.jsx)((0, $6e62a.default), {}),
            /*#__PURE__*/ (0, $bibO8.jsx)((0, $9b18daffb00689f0$export$2e2bcd8739ae039), {})
        ]
    });
var $a207c9463029025d$export$2e2bcd8739ae039 = $a207c9463029025d$var$LinkPreferencesRoute;



var $bibO8 = parcelRequire("bibO8");
parcelRequire("dAx5m");

var $cUsaH = parcelRequire("cUsaH");

const $42028604acd252bb$var$LazyCloseAccountSettingTab = (0, (/*@__PURE__*/$parcel$interopDefault($cUsaH)))({
    loader: ()=>(parcelRequire("hYSeX")),
    loading: ()=>null
});
$42028604acd252bb$var$LazyCloseAccountSettingTab.displayName = "lazy(CloseAccountSettingTab)";
var $42028604acd252bb$export$2e2bcd8739ae039 = $42028604acd252bb$var$LazyCloseAccountSettingTab;


parcelRequire("jShba");
var $53PE4 = parcelRequire("53PE4");
var $7dUzb = parcelRequire("7dUzb");
var $6e62a = parcelRequire("6e62a");
const $72272c371acc936d$var$SettingsCloseAccountRoute = ()=>/*#__PURE__*/ (0, $bibO8.jsxs)((0, $bibO8.Fragment), {
        children: [
            /*#__PURE__*/ (0, $bibO8.jsx)((0, $53PE4.default), {
                task: (0, $7dUzb.ApdexTasks).VIEW_CLOSE_ACCOUNT_SETTINGS
            }),
            /*#__PURE__*/ (0, $bibO8.jsx)((0, $6e62a.default), {}),
            /*#__PURE__*/ (0, $bibO8.jsx)((0, $42028604acd252bb$export$2e2bcd8739ae039), {})
        ]
    });
var $72272c371acc936d$export$2e2bcd8739ae039 = $72272c371acc936d$var$SettingsCloseAccountRoute;



var $bibO8 = parcelRequire("bibO8");
parcelRequire("dAx5m");
parcelRequire("jQGCp");
var $7PWYP = parcelRequire("7PWYP");
parcelRequire("jShba");
var $3kXiv = parcelRequire("3kXiv");

var $bibO8 = parcelRequire("bibO8");

var $dAx5m = parcelRequire("dAx5m");

var $55TWT = parcelRequire("55TWT");
var $dZHnD = parcelRequire("dZHnD");

var $6bOZI = parcelRequire("6bOZI");
parcelRequire("jShba");
var $fjOHq = parcelRequire("fjOHq");
var $1UxEK = parcelRequire("1UxEK");
var $zFJ4O = parcelRequire("zFJ4O");
var $7dUzb = parcelRequire("7dUzb");
var $7pLec = parcelRequire("7pLec");
var $77YRX = parcelRequire("77YRX");
var $1QRhz = parcelRequire("1QRhz");
var $grRLU = parcelRequire("grRLU");
parcelRequire("jShba");
var $h1Uju = parcelRequire("h1Uju");


var $h1Uju = parcelRequire("h1Uju");

var $ku6eE = parcelRequire("ku6eE");

var $9HXRO = parcelRequire("9HXRO");

var $gbKg7 = parcelRequire("gbKg7");

var $hxi5h = parcelRequire("hxi5h");
const $0c5cedf3c4dbc22e$export$6955bcca4cd3539f = (0, $ku6eE.default).div`
  padding-bottom: ${(0, $gbKg7.default)("space.1000", "80px")};
`;
const $0c5cedf3c4dbc22e$export$16c26ca3b4cdb2a4 = (0, $ku6eE.default).div`
  margin-top: ${(0, $gbKg7.default)("space.400", "32px")};
`;
const $0c5cedf3c4dbc22e$export$a8a3e93435678ff9 = (0, $ku6eE.default).h1``;
const $0c5cedf3c4dbc22e$export$210dc657affc8afd = (0, $ku6eE.default).h3`
  ${(0, $9HXRO).h500};
  margin-top: ${(0, $gbKg7.default)("space.400", "32px")};
  margin-bottom: ${(0, $gbKg7.default)("space.200", "16px")};
`;


var $hxi5h = parcelRequire("hxi5h");

var $lKhJJ = parcelRequire("lKhJJ");
const $a63a81b6caa9ac0d$export$5afb1a429e5a7f8c = (0, $lKhJJ.defineMessages)({
    /*
   * Field specific messages for success flag
   * key of the message equals = `PrivacyItemType-PrivacyLevel`
   * where:
   *   - PrivacyItemType = is user details privacy field type
   *   - PrivacyLevel = is user details visibility level
   */ fullName_organisation: {
        id: "ptc-directory.settings.profile-and-visibility.privacy.name-organisation-success",
        defaultMessage: "Your full name will be visible to people who belong to your organization."
    },
    fullName_public: {
        id: "ptc-directory.settings.profile-and-visibility.privacy.name-public-success",
        defaultMessage: "Your full name will be visible to anyone who can view your content, including people outside of your organization. It\u2019s also accessible by installed apps."
    },
    title_organisation: {
        id: "ptc-directory.settings.profile-and-visibility.privacy.jobTitle-organisation-success",
        defaultMessage: "Your job title will be visible to people who belong to your organization."
    },
    title_public: {
        id: "ptc-directory.settings.profile-and-visibility.privacy.jobTitle-public-success",
        defaultMessage: "Your job title will be visible to anyone who can view your content, including people outside of your organization. It\u2019s also accessible by installed apps."
    },
    department_organisation: {
        id: "ptc-directory.settings.profile-and-visibility.privacy.department-organisation-success",
        defaultMessage: "Your department will be visible to people who belong to your organization."
    },
    department_public: {
        id: "ptc-directory.settings.profile-and-visibility.privacy.department-public-success",
        defaultMessage: "Your department will be visible to anyone who can view your content, including people outside of your organization. It\u2019s also accessible by installed apps."
    },
    department_private: {
        id: "ptc-directory.settings.profile-and-visibility.privacy.department-private-success",
        defaultMessage: "Your department will only be visible to you."
    },
    companyName_organisation: {
        id: "ptc-directory.settings.profile-and-visibility.privacy.organization-organisation-success",
        defaultMessage: "Your organization will be visible to people who belong to your organization."
    },
    companyName_public: {
        id: "ptc-directory.settings.profile-and-visibility.privacy.organization-public-success",
        defaultMessage: "Your organization will be visible to anyone who can view your content, including people outside of your organization. It\u2019s also accessible by installed apps."
    },
    location_organisation: {
        id: "ptc-directory.settings.profile-and-visibility.privacy.location-organisation-success",
        defaultMessage: "Your location will be visible to people who belong to your organization."
    },
    location_public: {
        id: "ptc-directory.settings.profile-and-visibility.privacy.location-public-success",
        defaultMessage: "Your location will be visible to anyone who can view your content, including people outside of your organization. It\u2019s also accessible by installed apps."
    },
    location_private: {
        id: "ptc-directory.settings.profile-and-visibility.privacy.location-private-success",
        defaultMessage: "Your location will only be visible to you."
    },
    timezone_organisation: {
        id: "ptc-directory.settings.profile-and-visibility.privacy.timezone-organisation-success",
        defaultMessage: "Your time zone will be visible to people who belong to your organization."
    },
    timezone_public: {
        id: "ptc-directory.settings.profile-and-visibility.privacy.timezone-public-success",
        defaultMessage: "Your time zone will be visible to anyone who can view your content, including people outside of your organization. It\u2019s also accessible by installed apps."
    },
    timezone_private: {
        id: "ptc-directory.settings.profile-and-visibility.privacy.timezone-private-success",
        defaultMessage: "Your time zone will only be visible to you."
    },
    localTime_organisation: {
        id: "ptc-directory.settings.profile-and-visibility.privacy.local-time-organisation-success",
        defaultMessage: "Your local time will be visible to people who belong to your organization."
    },
    localTime_public: {
        id: "ptc-directory.settings.profile-and-visibility.privacy.local-time-public-success",
        defaultMessage: "Your local time will be visible to anyone who can view your content, including people outside of your organization. It\u2019s also accessible by installed apps."
    },
    localTime_private: {
        id: "ptc-directory.settings.profile-and-visibility.privacy.local-time-private-success",
        defaultMessage: "Your local time will only be visible to you."
    },
    email_organisation: {
        id: "ptc-directory.settings.profile-and-visibility.privacy.email-organisation-success",
        defaultMessage: "Your email will be visible to people who belong to your organization."
    },
    email_public: {
        id: "ptc-directory.settings.profile-and-visibility.privacy.email-public-success",
        defaultMessage: "Your email will be visible to anyone who can view your content, including people outside of your organization. It\u2019s also accessible by installed apps."
    },
    email_private: {
        id: "ptc-directory.settings.profile-and-visibility.privacy.email-private-success",
        defaultMessage: "Your email will only be visible to you and admins."
    },
    phone_organisation: {
        id: "ptc-directory.settings.profile-and-visibility.privacy.phone-organisation-success",
        defaultMessage: "Your phone number will be visible to people who belong to your organization."
    },
    phone_public: {
        id: "ptc-directory.settings.profile-and-visibility.privacy.phone-public-success",
        defaultMessage: "Your phone number will be visible to anyone who can view your content, including people outside of your organization. It\u2019s also accessible by installed apps."
    },
    phone_private: {
        id: "ptc-directory.settings.profile-and-visibility.privacy.phone-private-success",
        defaultMessage: "Your phone number will only be visible to you."
    },
    picture_organisation: {
        id: "ptc-directory.settings.profile-and-visibility.privacy.picture-organisation-success",
        defaultMessage: "Your profile picture will be visible to people who belong to your organization."
    },
    picture_public: {
        id: "ptc-directory.settings.profile-and-visibility.privacy.picture-public-success",
        defaultMessage: "Your profile picture will be visible to anyone who can view your content, including people outside of your organization. It\u2019s also accessible by installed apps."
    },
    picture_private: {
        id: "ptc-directory.settings.profile-and-visibility.privacy.picture-private-success",
        defaultMessage: "Your profile picture will only be visible to you."
    }
});


parcelRequire("jQGCp");
var $7PWYP = parcelRequire("7PWYP");
parcelRequire("jShba");
var $3kXiv = parcelRequire("3kXiv");

var $bibO8 = parcelRequire("bibO8");
parcelRequire("dAx5m");

var $55TWT = parcelRequire("55TWT");
parcelRequire("jShba");
var $aocz5 = parcelRequire("aocz5");
var $8zYsB = parcelRequire("8zYsB");

var $bibO8 = parcelRequire("bibO8");
parcelRequire("dAx5m");



var $bibO8 = parcelRequire("bibO8");

var $dAx5m = parcelRequire("dAx5m");

var $757qr = parcelRequire("757qr");
var $cRCIP = parcelRequire("cRCIP");
var $bEokL = parcelRequire("bEokL");

var $4FNod = parcelRequire("4FNod");

var $7Eyf8 = parcelRequire("7Eyf8");

var $ku6eE = parcelRequire("ku6eE");

var $5MUVm = parcelRequire("5MUVm");

var $gbKg7 = parcelRequire("gbKg7");
// Color taken from atlaskit/button theme defintions
const $ff0e03467ca10df7$var$focusOutlineColor = "rgba(38, 132, 255, 0.6)";
const $ff0e03467ca10df7$export$be92b6f5f03c0fe9 = (0, $ku6eE.default).div`
  height: ${(0, $gbKg7.default)("space.500", "40px")};
`;
const $ff0e03467ca10df7$export$5ae13d7b92c081da = (0, $ku6eE.default).div`
  width: ${(0, $gbKg7.default)("space.300", "24px")};
  height: ${(0, $gbKg7.default)("space.300", "24px")};
`;
const $ff0e03467ca10df7$export$2e263ceb4c50e6c8 = (0, $ku6eE.default).div`
  outline: none;
  border-radius: ${(0, $gbKg7.default)("border.radius.100", "3px")};
  border-width: 0px;
  width: 200px;
  display: inline-flex;
  user-select: none;
  cursor: not-allowed;
  box-shadow: transparent 0px 0px 0px ${(0, $gbKg7.default)("space.025", "2px")};
  color: ${(0, $gbKg7.default)("color.text.subtlest", (0, $5MUVm).N70)};

  &:focus {
    box-shadow: ${(0, $gbKg7.default)("elevation.surface.overlay.hovered", $ff0e03467ca10df7$var$focusOutlineColor)}
      0px 0px 0px ${(0, $gbKg7.default)("space.025", "2px")};
  }
`;
const $ff0e03467ca10df7$export$c1ed4f415b9e7023 = (0, $ku6eE.default).div`
  margin: 0 ${(0, $gbKg7.default)("space.200", "16px")};
  height: ${(0, $gbKg7.default)("space.500", "40px")};
  width: 100%;
  color: ${(0, $gbKg7.default)("color.text.subtlest", (0, $5MUVm).N90)};
  display: inline-flex;
  align-items: center;
`;
const $ff0e03467ca10df7$export$e7e587afb03aa2f3 = (0, $ku6eE.default).div`
  display: flex;
  align-items: center;
  /* Need to account for 32px icon-after.*/
  width: ${(props)=>props.appearance === "default" ? 328 : 168}px;
  height: ${(0, $gbKg7.default)("space.500", "40px")};
  padding: 0 ${(0, $gbKg7.default)("space.100", "8px")};
`;
const $ff0e03467ca10df7$export$179a710dc744d554 = (0, $ku6eE.default).div`
  font-size: 14px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  min-width: 0;
  max-width: 120px;

  &:not(:first-child) {
    margin-left: ${(0, $gbKg7.default)("space.050", "4px")};
  }
`;
const $ff0e03467ca10df7$export$bf5c162b1b585704 = (0, $ku6eE.default).span`
  padding: 0 8px 0 0;
`;
const $ff0e03467ca10df7$export$1b0263cccbb9d139 = (0, $ku6eE.default).h5`
  margin: 0;
`;
const $ff0e03467ca10df7$export$c94bf20373c0569c = (0, $ku6eE.default).p`
  margin-top: ${(0, $gbKg7.default)("space.150", "12px")};
`;


parcelRequire("lU1oo");
var $2pRqv = parcelRequire("2pRqv");

var $fhHY5 = parcelRequire("fhHY5");
const $cd01e6e9a4b0e50c$export$f140de477fde7649 = ({ appearance: appearance = "default", customComponents: customComponents = {}, disabledMessage: disabledMessage = null, errorMessage: errorMessage, isLoading: isLoading, onChange: onChange, options: options, placeHolderOption: placeHolderOption, position: position = "bottom-end", value: value })=>{
    const [isHovered, setIsHovered] = (0, $dAx5m.useState)(false);
    const [isMenuOpen, setIsMenuOpen] = (0, $dAx5m.useState)(false);
    const [isInlineDialogOpen, setIsInlineDialogOpen] = (0, $dAx5m.useState)(false);
    const handleShowInlineDialog = ()=>{
        setIsInlineDialogOpen(true);
    };
    const handleHideInlineDialog = ()=>{
        setIsInlineDialogOpen(false);
    };
    const handleDropdownItemClick = (value)=>()=>onChange(value);
    const handleMouseEnter = ()=>{
        setIsHovered(true);
    };
    const handleMouseLeave = ()=>{
        setIsHovered(false);
    };
    const handleOpenChange = ({ isOpen: isOpen })=>{
        setIsMenuOpen(isOpen);
    };
    const preventFocusWhenClicked = (e)=>{
        e.preventDefault();
    };
    const getIconAfterElement = ()=>{
        const Icon = isHovered || isMenuOpen ? (0, (/*@__PURE__*/$parcel$interopDefault($7Eyf8))) : $ff0e03467ca10df7$export$5ae13d7b92c081da;
        return /*#__PURE__*/ (0, $bibO8.jsx)($ff0e03467ca10df7$export$bf5c162b1b585704, {
            children: /*#__PURE__*/ (0, $bibO8.jsx)(Icon, {
                label: ""
            })
        });
    };
    const renderWrapInlineDialog = (component)=>{
        if (!disabledMessage) return component;
        return /*#__PURE__*/ (0, $bibO8.jsx)((0, $4FNod.default), {
            content: disabledMessage,
            placement: position,
            isOpen: isInlineDialogOpen,
            children: component
        });
    };
    const renderDisabledTrigger = ()=>{
        return renderWrapInlineDialog(/*#__PURE__*/ (0, $bibO8.jsx)($ff0e03467ca10df7$export$2e263ceb4c50e6c8, {
            "data-testid": "disabled-trigger",
            tabIndex: 0,
            onMouseDown: preventFocusWhenClicked,
            onMouseEnter: handleShowInlineDialog,
            onMouseLeave: handleHideInlineDialog,
            onFocus: handleShowInlineDialog,
            onBlur: handleHideInlineDialog,
            children: renderTrigger()
        }));
    };
    const renderErrorMessage = ()=>{
        return /*#__PURE__*/ (0, $bibO8.jsx)($ff0e03467ca10df7$export$c1ed4f415b9e7023, {
            children: errorMessage
        });
    };
    const renderTrigger = ()=>{
        let currentOption = value ? options[value] : null;
        if (!currentOption) {
            // use placeholderOption as current option
            if (placeHolderOption) currentOption = placeHolderOption;
            else return null;
        }
        return /*#__PURE__*/ (0, $bibO8.jsxs)($ff0e03467ca10df7$export$e7e587afb03aa2f3, {
            appearance: appearance,
            children: [
                currentOption.icon,
                /*#__PURE__*/ (0, $bibO8.jsx)($ff0e03467ca10df7$export$179a710dc744d554, {
                    children: currentOption.label
                })
            ]
        });
    };
    const renderItem = (value)=>{
        const { Item: Item } = customComponents;
        const currentOption = options[value];
        if (!currentOption) return null;
        // Use custom Item view component if provided
        if (Item) return /*#__PURE__*/ (0, $bibO8.jsx)((0, $cRCIP.default), {
            onClick: handleDropdownItemClick(value),
            children: /*#__PURE__*/ (0, $bibO8.jsx)(Item, {
                ...currentOption
            })
        }, value);
        return /*#__PURE__*/ (0, $bibO8.jsx)((0, $cRCIP.default), {
            elemBefore: currentOption.icon,
            description: /*#__PURE__*/ (0, $bibO8.jsx)((0, $bibO8.Fragment), {
                children: currentOption.description
            }),
            onClick: handleDropdownItemClick(value),
            children: currentOption.label
        }, value);
    };
    if (isLoading) return /*#__PURE__*/ (0, $bibO8.jsx)((0, $2pRqv.LoadingPlaceHolder), {
        style: {
            margin: "0 8px"
        },
        "data-testid": "loading-placeholder"
    });
    if (disabledMessage) return renderDisabledTrigger();
    if (errorMessage) return renderErrorMessage();
    return /*#__PURE__*/ (0, $bibO8.jsx)($ff0e03467ca10df7$export$be92b6f5f03c0fe9, {
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave,
        onFocus: handleMouseEnter,
        onBlur: handleMouseLeave,
        "data-test-selector": "subtle-dropdown",
        children: /*#__PURE__*/ (0, $bibO8.jsx)((0, $757qr.default), {
            onOpenChange: handleOpenChange,
            appearance: appearance,
            trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ (0, $bibO8.jsx)((0, $fhHY5.default), {
                    ...props,
                    iconAfter: getIconAfterElement(),
                    ref: triggerRef,
                    appearance: "subtle",
                    spacing: "none",
                    children: renderTrigger()
                }),
            children: /*#__PURE__*/ (0, $bibO8.jsx)("div", {
                style: {
                    maxWidth: 300
                },
                children: /*#__PURE__*/ (0, $bibO8.jsx)((0, $bEokL.default), {
                    children: Object.keys(options).map((key)=>renderItem(key))
                })
            })
        })
    });
};
var $cd01e6e9a4b0e50c$export$2e2bcd8739ae039 = $cd01e6e9a4b0e50c$export$f140de477fde7649;





var $ku6eE = parcelRequire("ku6eE");

var $5MUVm = parcelRequire("5MUVm");

var $gbKg7 = parcelRequire("gbKg7");
const $117eede8f7e7b5a3$var$dropDownWidth = 360;
// 360 dropDownWidth - 2 border - 24 padding - 24 icon - 8 icon margin
const $117eede8f7e7b5a3$var$dropDownLabelWidth = 304;
const $117eede8f7e7b5a3$export$49166591ec160d97 = (0, $ku6eE.default).div`
  max-width: ${$117eede8f7e7b5a3$var$dropDownWidth}px;
`;
const $117eede8f7e7b5a3$export$6d08773d2e66f8f2 = (0, $ku6eE.default).div`
  display: flex;
`;
const $117eede8f7e7b5a3$export$fe32840a055e175b = (0, $ku6eE.default).div`
  color: ${(0, $gbKg7.default)("color.text.subtlest", (0, $5MUVm).N200)};
  margin-right: ${(0, $gbKg7.default)("space.100", "8px")};
`;
const $117eede8f7e7b5a3$export$deed4c77ad8d8dc5 = (0, $ku6eE.default).div`
  min-width: 0;
`;
const $117eede8f7e7b5a3$export$cddb8b7ba9e8674e = (0, $ku6eE.default).div`
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: ${$117eede8f7e7b5a3$var$dropDownLabelWidth}px;
  line-height: ${(0, $gbKg7.default)("space.300", "24px")};
`;
const $117eede8f7e7b5a3$export$bf220ed4520663e8 = (0, $ku6eE.default).div`
  color: ${(0, $gbKg7.default)("color.text.subtlest", (0, $5MUVm).N200)};
  white-space: normal;
  font-size: 12px;
  overflow: hidden;
  text-overflow: ellipsis;
  min-width: 0;
`;


const $2213fcb3c9178097$export$46a95cac18ec36cd = ({ disabledMessage: disabledMessage, onChange: onChange, options: options, privacyLevel: privacyLevel })=>{
    const Item = ({ description: description, icon: icon, label: label })=>/*#__PURE__*/ (0, $bibO8.jsxs)($117eede8f7e7b5a3$export$6d08773d2e66f8f2, {
            children: [
                /*#__PURE__*/ (0, $bibO8.jsx)($117eede8f7e7b5a3$export$fe32840a055e175b, {
                    children: icon
                }),
                /*#__PURE__*/ (0, $bibO8.jsxs)($117eede8f7e7b5a3$export$deed4c77ad8d8dc5, {
                    children: [
                        /*#__PURE__*/ (0, $bibO8.jsx)($117eede8f7e7b5a3$export$cddb8b7ba9e8674e, {
                            children: label
                        }),
                        /*#__PURE__*/ (0, $bibO8.jsx)($117eede8f7e7b5a3$export$bf220ed4520663e8, {
                            children: description
                        })
                    ]
                })
            ]
        });
    if (!privacyLevel) // Without a current privacy level we can't render anything
    // as there are no reasonable generic fall back / default values
    return null;
    return /*#__PURE__*/ (0, $bibO8.jsx)($117eede8f7e7b5a3$export$49166591ec160d97, {
        children: /*#__PURE__*/ (0, $bibO8.jsx)((0, $cd01e6e9a4b0e50c$export$2e2bcd8739ae039), {
            appearance: "tall",
            // Destructuring here is a workaround for TS not recognising certain types (PrivacyLevelOptions) as specific cases of more general types (Options from SubtleDropdown)
            options: {
                ...options
            },
            value: privacyLevel,
            onChange: onChange,
            disabledMessage: disabledMessage,
            customComponents: {
                Item: Item
            }
        })
    });
};
var $2213fcb3c9178097$export$2e2bcd8739ae039 = $2213fcb3c9178097$export$46a95cac18ec36cd;


var $1ea2b1c5db3c4b56$export$598b17d3c675a75;
(function(PrivacyLevel) {
    PrivacyLevel["PUBLIC"] = "public";
    PrivacyLevel["ORGANISATION"] = "organisation";
    PrivacyLevel["PRIVATE"] = "private";
})($1ea2b1c5db3c4b56$export$598b17d3c675a75 || ($1ea2b1c5db3c4b56$export$598b17d3c675a75 = {}));



var $bibO8 = parcelRequire("bibO8");
parcelRequire("dAx5m");

var $55TWT = parcelRequire("55TWT");
var $04a2d979c7d60294$exports = {};
"use strict";
Object.defineProperty($04a2d979c7d60294$exports, "__esModule", {
    value: true
});
$04a2d979c7d60294$exports.default = void 0;

var $04a2d979c7d60294$var$_react = $04a2d979c7d60294$var$_interopRequireDefault((parcelRequire("dAx5m")));

var $9eGJl = parcelRequire("9eGJl");
function $04a2d979c7d60294$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $04a2d979c7d60294$var$WorldIcon = (props)=>/*#__PURE__*/ $04a2d979c7d60294$var$_react.default.createElement($9eGJl.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path d="M12 21a9 9 0 100-18 9 9 0 000 18zm-.9-1.863A7.19 7.19 0 014.8 12c0-.558.072-1.089.189-1.611L9.3 14.7v.9c0 .99.81 1.8 1.8 1.8v1.737zm6.21-2.286A1.786 1.786 0 0015.6 15.6h-.9v-2.7c0-.495-.405-.9-.9-.9H8.4v-1.8h1.8c.495 0 .9-.405.9-.9V7.5h1.8c.99 0 1.8-.81 1.8-1.8v-.369c2.637 1.071 4.5 3.654 4.5 6.669 0 1.872-.72 3.573-1.89 4.851z" fill="currentColor" fill-rule="evenodd"/></svg>`
    }, props));
$04a2d979c7d60294$var$WorldIcon.displayName = "WorldIcon";
var $04a2d979c7d60294$var$_default = $04a2d979c7d60294$var$WorldIcon;
$04a2d979c7d60294$exports.default = $04a2d979c7d60294$var$_default;


var $5b9770d66e507435$exports = {};
"use strict";
Object.defineProperty($5b9770d66e507435$exports, "__esModule", {
    value: true
});
$5b9770d66e507435$exports.default = void 0;

var $5b9770d66e507435$var$_react = $5b9770d66e507435$var$_interopRequireDefault((parcelRequire("dAx5m")));

var $9eGJl = parcelRequire("9eGJl");
function $5b9770d66e507435$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $5b9770d66e507435$var$OfficeBuildingIcon = (props)=>/*#__PURE__*/ $5b9770d66e507435$var$_react.default.createElement($9eGJl.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentColor" fill-rule="evenodd"><path d="M8 6H5.009C3.902 6 3 6.962 3 8.15v10.7C3 20.04 3.9 21 5.009 21h5.487H8v-2.145c-1.616-.001-3-.003-3-.004 0 0 .005-10.708.009-10.708L8 8.144V6z" fill-rule="nonzero"/><path d="M12 7h2v2h-2zm-6 3h2v2H6zm0 3h2v2H6zm6-3h2v2h-2zm0 3h2v2h-2zm2 3h2v3h-2zm2-9h2v2h-2zm0 3h2v2h-2zm0 3h2v2h-2z"/><path d="M18.991 19C18.998 19 19 4.995 19 4.995c0 .006-7.991.005-7.991.005C11.002 5 11 19 11 19h7.991zM9 4.995C9 3.893 9.902 3 11.009 3h7.982C20.101 3 21 3.893 21 4.995v14.01A2.004 2.004 0 0118.991 21H9V4.995z" fill-rule="nonzero"/></g></svg>`
    }, props));
$5b9770d66e507435$var$OfficeBuildingIcon.displayName = "OfficeBuildingIcon";
var $5b9770d66e507435$var$_default = $5b9770d66e507435$var$OfficeBuildingIcon;
$5b9770d66e507435$exports.default = $5b9770d66e507435$var$_default;


var $03cc3a93374136d4$exports = {};
"use strict";
Object.defineProperty($03cc3a93374136d4$exports, "__esModule", {
    value: true
});
$03cc3a93374136d4$exports.default = void 0;

var $03cc3a93374136d4$var$_react = $03cc3a93374136d4$var$_interopRequireDefault((parcelRequire("dAx5m")));

var $9eGJl = parcelRequire("9eGJl");
function $03cc3a93374136d4$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $03cc3a93374136d4$var$LockIcon = (props)=>/*#__PURE__*/ $03cc3a93374136d4$var$_react.default.createElement($9eGJl.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentColor"><path d="M16 11V9h-2V7.002A2.001 2.001 0 0012 5c-1.102 0-2 .898-2 2.002V9H8v2H7v8h10v-8h-1zm-2 0h-4V9h4v2zM8 9V7.002A4.004 4.004 0 0112 3a4 4 0 014 4.002V9h.994A2.01 2.01 0 0119 11.009v7.982c0 1.11-.897 2.009-2.006 2.009H7.006A2.009 2.009 0 015 18.991V11.01C5 9.899 5.897 9 7.006 9H8zm0 0h2v2H8V9zm6 0h2v2h-2V9z"/><circle cx="12" cy="15" r="2"/></g></svg>`
    }, props));
$03cc3a93374136d4$var$LockIcon.displayName = "LockIcon";
var $03cc3a93374136d4$var$_default = $03cc3a93374136d4$var$LockIcon;
$03cc3a93374136d4$exports.default = $03cc3a93374136d4$var$_default;




var $lKhJJ = parcelRequire("lKhJJ");

const $e2721668de6ce5a1$export$a238cb463698c900 = {
    default: (0, $lKhJJ.defineMessages)({
        public: {
            id: "ptc-directory.settings.profile-and-visibility.visibility-level.public",
            defaultMessage: "Anyone",
            description: "A text on visibility option of profile visibility dropdown. Means that particular profile information will be visible to anyone who can view content, including people outside the organization. Accessible by installed apps."
        },
        organisation: {
            id: "ptc-directory.settings.profile-and-visibility.visibility-level.organisation.generic",
            defaultMessage: "Your organization",
            description: "A text on visibility option of profile visibility dropdown. Means that particular profile information will be visible to people who belongs to the organization. This is used when the actual name of the organization is not known."
        },
        private: {
            id: "ptc-directory.settings.profile-and-visibility.visibility-level.private",
            defaultMessage: "Only you",
            description: "A text on visibility option of profile visibility dropdown. Means that particular profile information will be visible only to the user himself"
        }
    }),
    email: (0, $lKhJJ.defineMessages)({
        private: {
            id: "ptc-directory.settings.profile-and-visibility.visibility-level.email.private",
            defaultMessage: "Only you and admins",
            description: "A text on visibility option of profile visibility dropdown. Means that particular profile information will be visible only to the user themself and admins of the site"
        }
    })
};
const $e2721668de6ce5a1$export$236350842f3cd9bc = (fieldType, level)=>{
    const labelKey = level.toString();
    if ($e2721668de6ce5a1$export$a238cb463698c900[fieldType] && $e2721668de6ce5a1$export$a238cb463698c900[fieldType][labelKey]) return $e2721668de6ce5a1$export$a238cb463698c900[fieldType][labelKey];
    return $e2721668de6ce5a1$export$a238cb463698c900.default[labelKey];
};
const $e2721668de6ce5a1$export$74c9c0e93f0c6c14 = {
    default: (0, $lKhJJ.defineMessages)({
        public_named: {
            id: "ptc-directory.settings.profile-and-visibility.visibility-level.public.description",
            defaultMessage: "Visible to anyone who can view your content, including people outside of the {organizationName} organization. Accessible by installed apps.",
            description: "Description of the profile visibility dropdown option that will make particular profile information visible publicly"
        },
        public_unmanaged: {
            id: "ptc-directory.settings.profile-and-visibility.visibility-level.public.unmanaged.description",
            defaultMessage: "Visible to anyone who can view your content. Accessible by installed apps.",
            description: 'Description of the profile visibility dropdown option that will make particular profile information visible publicly. Context: "apps" are referring to the apps described in ptc-directory.settings.profile-and-visibility.description-p1'
        },
        public: {
            id: "ptc-directory.settings.profile-and-visibility.visibility-level.public.generic.description",
            defaultMessage: "Visible to anyone who can view your content, including people outside of your organization. Accessible by installed apps.",
            description: "Description of the profile visibility dropdown option that will make particular profile information visible publicly"
        },
        organisation_named: {
            id: "ptc-directory.settings.profile-and-visibility.visibility-level.organisation.description",
            defaultMessage: "Only visible to people who have access to the {organizationName} organization.",
            description: "Description of the profile visibility dropdown option that will make particular profile information visible only to users in the same organisation `{organizationName}`, where `{organizationName}` will be replaced with the actual name of the organization."
        },
        organisation: {
            id: "ptc-directory.settings.profile-and-visibility.visibility-level.organisation.generic.description",
            defaultMessage: "Only visible to people who belong to your organization.",
            description: "Description of the profile visibility dropdown option that will make particular profile information visible only to users in the same organisation. This is used when the actual name of the organization is not known."
        },
        private: {
            id: "ptc-directory.settings.profile-and-visibility.visibility-level.private.description",
            defaultMessage: "Only visible to you.",
            description: "Description of the profile visibility dropdown option that will make particular profile information visible only to the user himself"
        }
    }),
    email: (0, $lKhJJ.defineMessages)({
        private: {
            id: "ptc-directory.settings.profile-and-visibility.visibility-level.email.private.description",
            defaultMessage: "Only visible to you and admins. To manage access to Atlassian products and services, admins need to view your email address too.",
            description: "Description of the profile visibility dropdown option that will make particular profile information visible only to the user themself and admins of the site."
        }
    })
};
const $e2721668de6ce5a1$export$67580b1c13935958 = (fieldType, level, options = {})=>{
    const { orgName: orgName, isManaged: isManaged } = options;
    let descriptionKey = level.toString();
    if (level === (0, $1ea2b1c5db3c4b56$export$598b17d3c675a75).ORGANISATION && orgName) descriptionKey = "organisation_named";
    else if (level === (0, $1ea2b1c5db3c4b56$export$598b17d3c675a75).PUBLIC && orgName) descriptionKey = "public_named";
    else if (level === (0, $1ea2b1c5db3c4b56$export$598b17d3c675a75).PUBLIC && !isManaged) descriptionKey = "public_unmanaged";
    if ($e2721668de6ce5a1$export$74c9c0e93f0c6c14[fieldType] && $e2721668de6ce5a1$export$74c9c0e93f0c6c14[fieldType][descriptionKey]) return $e2721668de6ce5a1$export$74c9c0e93f0c6c14[fieldType][descriptionKey];
    return $e2721668de6ce5a1$export$74c9c0e93f0c6c14.default[descriptionKey];
};


const $423263b1288ad8f8$var$ALL_PRIVACY_LEVELS = [
    (0, $1ea2b1c5db3c4b56$export$598b17d3c675a75).PUBLIC,
    (0, $1ea2b1c5db3c4b56$export$598b17d3c675a75).ORGANISATION,
    (0, $1ea2b1c5db3c4b56$export$598b17d3c675a75).PRIVATE
];
const $423263b1288ad8f8$export$abc9c3081c48e7ff = (fieldType, privacyLevels = $423263b1288ad8f8$var$ALL_PRIVACY_LEVELS, options)=>{
    // Ensure `orgName` is always a string from here on.
    // So we do not have to modify anything beyond this point to handle `null`.
    const orgName = options.orgName || "";
    const isManaged = Boolean(options.isManaged);
    const privacyOptions = {
        [(0, $1ea2b1c5db3c4b56$export$598b17d3c675a75).PUBLIC]: {
            icon: /*#__PURE__*/ (0, $bibO8.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($04a2d979c7d60294$exports))), {
                size: "medium",
                label: ""
            }),
            label: /*#__PURE__*/ (0, $bibO8.jsx)((0, $55TWT.default), {
                ...(0, $e2721668de6ce5a1$export$236350842f3cd9bc)(fieldType, (0, $1ea2b1c5db3c4b56$export$598b17d3c675a75).PUBLIC)
            }),
            description: /*#__PURE__*/ (0, $bibO8.jsx)((0, $55TWT.default), {
                ...(0, $e2721668de6ce5a1$export$67580b1c13935958)(fieldType, (0, $1ea2b1c5db3c4b56$export$598b17d3c675a75).PUBLIC, {
                    orgName: orgName,
                    isManaged: isManaged
                }),
                values: {
                    organizationName: orgName
                }
            }),
            value: (0, $1ea2b1c5db3c4b56$export$598b17d3c675a75).PUBLIC
        }
    };
    if (privacyLevels.includes((0, $1ea2b1c5db3c4b56$export$598b17d3c675a75).ORGANISATION)) privacyOptions[(0, $1ea2b1c5db3c4b56$export$598b17d3c675a75).ORGANISATION] = {
        icon: /*#__PURE__*/ (0, $bibO8.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5b9770d66e507435$exports))), {
            size: "medium",
            label: ""
        }),
        label: orgName ? orgName : /*#__PURE__*/ (0, $bibO8.jsx)((0, $55TWT.default), {
            ...(0, $e2721668de6ce5a1$export$236350842f3cd9bc)(fieldType, (0, $1ea2b1c5db3c4b56$export$598b17d3c675a75).ORGANISATION)
        }),
        description: /*#__PURE__*/ (0, $bibO8.jsx)((0, $55TWT.default), {
            ...(0, $e2721668de6ce5a1$export$67580b1c13935958)(fieldType, (0, $1ea2b1c5db3c4b56$export$598b17d3c675a75).ORGANISATION, {
                orgName: orgName,
                isManaged: isManaged
            }),
            values: {
                organizationName: orgName
            }
        }),
        value: (0, $1ea2b1c5db3c4b56$export$598b17d3c675a75).ORGANISATION
    };
    if (privacyLevels.includes((0, $1ea2b1c5db3c4b56$export$598b17d3c675a75).PRIVATE)) privacyOptions[(0, $1ea2b1c5db3c4b56$export$598b17d3c675a75).PRIVATE] = {
        icon: /*#__PURE__*/ (0, $bibO8.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($03cc3a93374136d4$exports))), {
            size: "medium",
            label: ""
        }),
        label: /*#__PURE__*/ (0, $bibO8.jsx)((0, $55TWT.default), {
            ...(0, $e2721668de6ce5a1$export$236350842f3cd9bc)(fieldType, (0, $1ea2b1c5db3c4b56$export$598b17d3c675a75).PRIVATE)
        }),
        description: /*#__PURE__*/ (0, $bibO8.jsx)((0, $55TWT.default), {
            ...(0, $e2721668de6ce5a1$export$67580b1c13935958)(fieldType, (0, $1ea2b1c5db3c4b56$export$598b17d3c675a75).PRIVATE)
        }),
        value: (0, $1ea2b1c5db3c4b56$export$598b17d3c675a75).PRIVATE
    };
    return privacyOptions;
};


var $53f3c3d3af589157$export$2e2bcd8739ae039 = (0, $2213fcb3c9178097$export$2e2bcd8739ae039);
const $53f3c3d3af589157$export$52a249bf80a4235b = {
    PUBLIC: (0, $1ea2b1c5db3c4b56$export$598b17d3c675a75).PUBLIC,
    COLLABORATOR: (0, $1ea2b1c5db3c4b56$export$598b17d3c675a75).ORGANISATION,
    PRIVATE: (0, $1ea2b1c5db3c4b56$export$598b17d3c675a75).PRIVATE
};




var $ku6eE = parcelRequire("ku6eE");

var $gbKg7 = parcelRequire("gbKg7");

var $5MUVm = parcelRequire("5MUVm");
const $46749c245b4fca20$export$331c6cd8ec3669f5 = (0, $ku6eE.default).div`
  position: relative;
  display: flex;
  justify-content: space-between;
  padding: 0;
  width: 100%;
  border-radius: ${(0, $gbKg7.default)("border.radius.100", "3px")};
  box-shadow: ${(0, $gbKg7.default)("elevation.shadow.raised", "0px 1px 1px #091E4240, 0px 0px 1px #091E424F")};
  background: ${(0, $gbKg7.default)("elevation.surface.raised", (0, $5MUVm).N0)};
`;
const $46749c245b4fca20$export$85bb4e680e162cd4 = (0, $ku6eE.default).div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 112px;
  border-radius: ${(0, $gbKg7.default)("border.radius.100", "3px")}
    ${(0, $gbKg7.default)("border.radius.100", "3px")} 0 0;
`;
const $46749c245b4fca20$export$f7513421c53ce141 = (0, $ku6eE.default).div`
  margin-top: 38px;
  margin-left: ${(0, $gbKg7.default)("space.600", "48px")};
`;
const $46749c245b4fca20$export$6ce170286acaa8d3 = (0, $ku6eE.default).div`
  margin-top: 112px;
  padding: 0 ${(0, $gbKg7.default)("space.200", "16px")} ${(0, $gbKg7.default)("space.200", "16px")};
`;
const $46749c245b4fca20$export$4bb0b7f9b6c7db0e = (0, $ku6eE.default).small`
  font-size: 11px;
  line-height: ${(0, $gbKg7.default)("space.200", "16px")};
  margin-bottom: ${(0, $gbKg7.default)("space.100", "8px")};
  padding-left: ${(0, $gbKg7.default)("space.100", "8px")};
  width: 100%;
`;
const $46749c245b4fca20$export$bf637fea4836207d = (0, $ku6eE.default).div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  width: 200px;
`;



var $bibO8 = parcelRequire("bibO8");

var $dAx5m = parcelRequire("dAx5m");

var $55TWT = parcelRequire("55TWT");
var $dZHnD = parcelRequire("dZHnD");

var $757qr = parcelRequire("757qr");
var $cRCIP = parcelRequire("cRCIP");
var $7967255dc3264633$exports = {};
"use strict";
Object.defineProperty($7967255dc3264633$exports, "__esModule", {
    value: true
});
$7967255dc3264633$exports.default = void 0;

var $7967255dc3264633$var$_react = $7967255dc3264633$var$_interopRequireDefault((parcelRequire("dAx5m")));

var $9eGJl = parcelRequire("9eGJl");
function $7967255dc3264633$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $7967255dc3264633$var$ImageIcon = (props)=>/*#__PURE__*/ $7967255dc3264633$var$_react.default.createElement($9eGJl.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path d="M3 4.995C3 3.893 3.893 3 4.995 3h14.01C20.107 3 21 3.893 21 4.995v14.01A1.995 1.995 0 0119.005 21H4.995A1.995 1.995 0 013 19.005V4.995zM10.5 16.5L9 15l-3 3h12v-2.7L15 12l-4.5 4.5zM8 10a2 2 0 100-4 2 2 0 000 4z" fill="currentColor" fill-rule="evenodd"/></svg>`
    }, props));
$7967255dc3264633$var$ImageIcon.displayName = "ImageIcon";
var $7967255dc3264633$var$_default = $7967255dc3264633$var$ImageIcon;
$7967255dc3264633$exports.default = $7967255dc3264633$var$_default;



var $77YRX = parcelRequire("77YRX");
parcelRequire("adUiG");
var $fjOHq = parcelRequire("fjOHq");
var $grRLU = parcelRequire("grRLU");

var $ku6eE = parcelRequire("ku6eE");

var $jVTBW = parcelRequire("jVTBW");

var $5MUVm = parcelRequire("5MUVm");

var $gbKg7 = parcelRequire("gbKg7");
const $6f4cb0cf4c6bfbcd$var$roundTopCorners = (0, $jVTBW.css)({
    borderRadius: `${(0, $gbKg7.default)("border.radius.100", "3px")} ${(0, $gbKg7.default)("border.radius.100", "3px")} 0 0`
});
const $6f4cb0cf4c6bfbcd$export$8b251419efc915eb = (0, $ku6eE.default).header`
  height: ${({ height: height })=>height}px;
  display: flex;
  justify-content: center;
  align-items: center;
  user-select: none;
`;
const $6f4cb0cf4c6bfbcd$export$b08b517936747730 = (0, $ku6eE.default).div`
  position: absolute;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;
const $6f4cb0cf4c6bfbcd$export$e7eb525bc415b4b4 = (0, $ku6eE.default).div`
  display: flex;

  &:focus {
    height: ${(0, $gbKg7.default)("space.400", "32px")};
    outline: none;
    box-shadow: 0 0 0 2px ${(0, $gbKg7.default)("color.border.focused", (0, $5MUVm).B100)};
    border-radius: ${(0, $gbKg7.default)("border.radius.100", "3px")};
  }
`;
const $6f4cb0cf4c6bfbcd$export$698223c589197ab7 = (0, $ku6eE.default).div`
  width: 100%;
  height: ${({ height: height })=>height}px;
  background: ${(0, $gbKg7.default)("color.background.accent.gray.subtlest", (0, $5MUVm).N20)};
  outline: none;

  position: absolute;
  top: 0;
  left: 0;

  &:after {
    content: '';
    display: block;
    position: absolute;
    bottom: 0;
    width: 100%;
    height: 4px;
    background: linear-gradient(
      to top,
      rgba(9, 30, 66, 0.2) 0px,
      rgba(9, 30, 66, 0.05) 1px,
      rgba(9, 30, 66, 0.02) 2px,
      rgba(0, 0, 0, 0) 3px
    );
  }
`;
const $6f4cb0cf4c6bfbcd$var$fadeIn = (0, $jVTBW.keyframes)`
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
`;
const $6f4cb0cf4c6bfbcd$export$3e431a229df88919 = (0, $ku6eE.default).img`
  width: 100%;
  height: ${({ height: height })=>height}px;
  object-fit: cover;
  vertical-align: top;

  animation-name: ${$6f4cb0cf4c6bfbcd$var$fadeIn};
  animation-timing-function: ease-in-out;
  animation-duration: 0.5s;

  ${(props)=>props.hasRoundCorners && $6f4cb0cf4c6bfbcd$var$roundTopCorners};

  ${(props)=>props.isUploading && (0, $jVTBW.css)`
      filter: opacity(50%);
    `};
`;
const $6f4cb0cf4c6bfbcd$export$5b7e6a421a3df3e3 = (0, $ku6eE.default).div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: ${({ height: height })=>height}px;
  background: ${(0, $gbKg7.default)("color.background.accent.gray.bolder", (0, $5MUVm).N100A)};
  color: ${(0, $gbKg7.default)("color.text.inverse", (0, $5MUVm).N0)};
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  transition: opacity 0.25s ease-in-out;

  ${(props)=>props.hasRoundCorners && $6f4cb0cf4c6bfbcd$var$roundTopCorners}
  ${(props)=>props.isVisible ? (0, $jVTBW.css)`
          opacity: 1;
          pointer-events: unset;
        ` : (0, $jVTBW.css)`
          opacity: 0;
          pointer-events: none;
        `};
`;



var $bibO8 = parcelRequire("bibO8");
parcelRequire("dAx5m");

var $fL9T3 = parcelRequire("fL9T3");
var $b985f02f43d5bb38$exports = {};
var $11e63dfb24aab454$exports = {};
var $040bcc4afc60edc0$exports = {};
function $040bcc4afc60edc0$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
$040bcc4afc60edc0$exports = $040bcc4afc60edc0$var$_arrayLikeToArray, $040bcc4afc60edc0$exports.__esModule = true, $040bcc4afc60edc0$exports["default"] = $040bcc4afc60edc0$exports;


function $11e63dfb24aab454$var$_arrayWithoutHoles(r) {
    if (Array.isArray(r)) return $040bcc4afc60edc0$exports(r);
}
$11e63dfb24aab454$exports = $11e63dfb24aab454$var$_arrayWithoutHoles, $11e63dfb24aab454$exports.__esModule = true, $11e63dfb24aab454$exports["default"] = $11e63dfb24aab454$exports;


var $171fee1a30813e7a$exports = {};
function $171fee1a30813e7a$var$_iterableToArray(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
$171fee1a30813e7a$exports = $171fee1a30813e7a$var$_iterableToArray, $171fee1a30813e7a$exports.__esModule = true, $171fee1a30813e7a$exports["default"] = $171fee1a30813e7a$exports;


var $0b2a6ee8c8b45107$exports = {};

function $0b2a6ee8c8b45107$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $040bcc4afc60edc0$exports(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $040bcc4afc60edc0$exports(r, a) : void 0;
    }
}
$0b2a6ee8c8b45107$exports = $0b2a6ee8c8b45107$var$_unsupportedIterableToArray, $0b2a6ee8c8b45107$exports.__esModule = true, $0b2a6ee8c8b45107$exports["default"] = $0b2a6ee8c8b45107$exports;


var $05763c0d9428674e$exports = {};
function $05763c0d9428674e$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
$05763c0d9428674e$exports = $05763c0d9428674e$var$_nonIterableSpread, $05763c0d9428674e$exports.__esModule = true, $05763c0d9428674e$exports["default"] = $05763c0d9428674e$exports;


function $b985f02f43d5bb38$var$_toConsumableArray(r) {
    return $11e63dfb24aab454$exports(r) || $171fee1a30813e7a$exports(r) || $0b2a6ee8c8b45107$exports(r) || $05763c0d9428674e$exports();
}
$b985f02f43d5bb38$exports = $b985f02f43d5bb38$var$_toConsumableArray, $b985f02f43d5bb38$exports.__esModule = true, $b985f02f43d5bb38$exports["default"] = $b985f02f43d5bb38$exports;



var $dAx5m = parcelRequire("dAx5m");
var $a715ace8101e0d2f$exports = {};
function $a715ace8101e0d2f$var$_extends() {
    return $a715ace8101e0d2f$exports = $a715ace8101e0d2f$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $a715ace8101e0d2f$exports.__esModule = true, $a715ace8101e0d2f$exports["default"] = $a715ace8101e0d2f$exports, $a715ace8101e0d2f$var$_extends.apply(null, arguments);
}
$a715ace8101e0d2f$exports = $a715ace8101e0d2f$var$_extends, $a715ace8101e0d2f$exports.__esModule = true, $a715ace8101e0d2f$exports["default"] = $a715ace8101e0d2f$exports;


var $a5a711648b8fac27$exports = {};
var $ee467f0d75f1d09e$exports = {};
function $ee467f0d75f1d09e$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.includes(n)) continue;
        t[n] = r[n];
    }
    return t;
}
$ee467f0d75f1d09e$exports = $ee467f0d75f1d09e$var$_objectWithoutPropertiesLoose, $ee467f0d75f1d09e$exports.__esModule = true, $ee467f0d75f1d09e$exports["default"] = $ee467f0d75f1d09e$exports;


function $a5a711648b8fac27$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $ee467f0d75f1d09e$exports(e, t);
    if (Object.getOwnPropertySymbols) {
        var s = Object.getOwnPropertySymbols(e);
        for(r = 0; r < s.length; r++)o = s[r], t.includes(o) || ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
$a5a711648b8fac27$exports = $a5a711648b8fac27$var$_objectWithoutProperties, $a5a711648b8fac27$exports.__esModule = true, $a5a711648b8fac27$exports["default"] = $a5a711648b8fac27$exports;



var $dAx5m = parcelRequire("dAx5m");

var $jVTBW = parcelRequire("jVTBW");
var $4787457db3f2db36$exports = {};
var $83b208d701bc8fd1$exports = {};
var $c71c76e04a3512b2$exports = {};
function $c71c76e04a3512b2$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $c71c76e04a3512b2$exports = $c71c76e04a3512b2$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $c71c76e04a3512b2$exports.__esModule = true, $c71c76e04a3512b2$exports["default"] = $c71c76e04a3512b2$exports, $c71c76e04a3512b2$var$_typeof(o);
}
$c71c76e04a3512b2$exports = $c71c76e04a3512b2$var$_typeof, $c71c76e04a3512b2$exports.__esModule = true, $c71c76e04a3512b2$exports["default"] = $c71c76e04a3512b2$exports;


var $83b208d701bc8fd1$var$_typeof = $c71c76e04a3512b2$exports.default;
var $524cedae11d8b207$exports = {};

var $524cedae11d8b207$var$_typeof = $c71c76e04a3512b2$exports.default;
function $524cedae11d8b207$var$toPrimitive(t, r) {
    if ("object" != $524cedae11d8b207$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $524cedae11d8b207$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
$524cedae11d8b207$exports = $524cedae11d8b207$var$toPrimitive, $524cedae11d8b207$exports.__esModule = true, $524cedae11d8b207$exports["default"] = $524cedae11d8b207$exports;


function $83b208d701bc8fd1$var$toPropertyKey(t) {
    var i = $524cedae11d8b207$exports(t, "string");
    return "symbol" == $83b208d701bc8fd1$var$_typeof(i) ? i : i + "";
}
$83b208d701bc8fd1$exports = $83b208d701bc8fd1$var$toPropertyKey, $83b208d701bc8fd1$exports.__esModule = true, $83b208d701bc8fd1$exports["default"] = $83b208d701bc8fd1$exports;


function $4787457db3f2db36$var$_defineProperty(e, r, t) {
    return (r = $83b208d701bc8fd1$exports(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
$4787457db3f2db36$exports = $4787457db3f2db36$var$_defineProperty, $4787457db3f2db36$exports.__esModule = true, $4787457db3f2db36$exports["default"] = $4787457db3f2db36$exports;



var $jVTBW = parcelRequire("jVTBW");
var $ae9201354a3e5eb1$export$4ef52930e33717cd = "data-theme";
var $ae9201354a3e5eb1$export$a00eac3f8684bcd0 = "data-color-mode";
var $ae9201354a3e5eb1$export$2112803007239c61 = "data-contrast-mode";
var $ae9201354a3e5eb1$export$352e418ed5b6193a = "data-custom-theme";
var $ae9201354a3e5eb1$export$2faeed762aac6741 = "light";
var $ae9201354a3e5eb1$export$6f0c6fb8c80fcc92 = "ds";
var $ae9201354a3e5eb1$export$4d0c7bbf80185957 = [
    "opacity",
    "font",
    "space",
    "border"
];
var $ae9201354a3e5eb1$export$dddac1532e822863 = "--".concat($ae9201354a3e5eb1$export$6f0c6fb8c80fcc92, "-token-not-found");
var $ae9201354a3e5eb1$export$9d7b58831ae93caa = "--".concat($ae9201354a3e5eb1$export$6f0c6fb8c80fcc92, "-elevation-surface-current");


function $c04cd6140c1ab4cf$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $c04cd6140c1ab4cf$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $c04cd6140c1ab4cf$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($4787457db3f2db36$exports)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $c04cd6140c1ab4cf$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $c04cd6140c1ab4cf$export$6ccdbebca2ee545f = {
    "100%": "100%",
    "size.100": "1rem",
    "size.200": "1.5rem",
    "size.300": "2rem",
    "size.400": "2.5rem",
    "size.500": "3rem",
    "size.600": "6rem",
    "size.1000": "12rem"
};
var $c04cd6140c1ab4cf$export$958d0ae7f2977ae4 = {
    "space.0": "var(--ds-space-0, 0px)",
    "space.025": "var(--ds-space-025, 2px)",
    "space.050": "var(--ds-space-050, 4px)",
    "space.075": "var(--ds-space-075, 6px)",
    "space.100": "var(--ds-space-100, 8px)",
    "space.150": "var(--ds-space-150, 12px)",
    "space.200": "var(--ds-space-200, 16px)",
    "space.250": "var(--ds-space-250, 20px)",
    "space.300": "var(--ds-space-300, 24px)",
    "space.400": "var(--ds-space-400, 32px)",
    "space.500": "var(--ds-space-500, 40px)",
    "space.600": "var(--ds-space-600, 48px)",
    "space.800": "var(--ds-space-800, 64px)",
    "space.1000": "var(--ds-space-1000, 80px)"
};
var $c04cd6140c1ab4cf$export$d2dc61f58390201c = {
    "space.negative.025": "var(--ds-space-negative-025, -2px)",
    "space.negative.050": "var(--ds-space-negative-050, -4px)",
    "space.negative.075": "var(--ds-space-negative-075, -6px)",
    "space.negative.100": "var(--ds-space-negative-100, -8px)",
    "space.negative.150": "var(--ds-space-negative-150, -12px)",
    "space.negative.200": "var(--ds-space-negative-200, -16px)",
    "space.negative.250": "var(--ds-space-negative-250, -20px)",
    "space.negative.300": "var(--ds-space-negative-300, -24px)",
    "space.negative.400": "var(--ds-space-negative-400, -32px)"
};
var $c04cd6140c1ab4cf$export$632685d741f3dbbf = $c04cd6140c1ab4cf$var$_objectSpread($c04cd6140c1ab4cf$var$_objectSpread({}, $c04cd6140c1ab4cf$export$958d0ae7f2977ae4), $c04cd6140c1ab4cf$export$d2dc61f58390201c);
var $c04cd6140c1ab4cf$export$2185ce37f9bdd963 = {
    "color.background.neutral.bold": "color.text.inverse",
    "color.background.neutral.bold.hovered": "color.text.inverse",
    "color.background.neutral.bold.pressed": "color.text.inverse",
    "color.background.selected.bold": "color.text.inverse",
    "color.background.selected.bold.hovered": "color.text.inverse",
    "color.background.selected.bold.pressed": "color.text.inverse",
    "color.background.brand.bold": "color.text.inverse",
    "color.background.brand.bold.hovered": "color.text.inverse",
    "color.background.brand.bold.pressed": "color.text.inverse",
    "color.background.brand.boldest": "color.text.inverse",
    "color.background.brand.boldest.hovered": "color.text.inverse",
    "color.background.brand.boldest.pressed": "color.text.inverse",
    "color.background.danger.bold": "color.text.inverse",
    "color.background.danger.bold.hovered": "color.text.inverse",
    "color.background.danger.bold.pressed": "color.text.inverse",
    "color.background.warning.bold": "color.text.warning.inverse",
    "color.background.warning.bold.hovered": "color.text.warning.inverse",
    "color.background.warning.bold.pressed": "color.text.warning.inverse",
    "color.background.success.bold": "color.text.inverse",
    "color.background.success.bold.hovered": "color.text.inverse",
    "color.background.success.bold.pressed": "color.text.inverse",
    "color.background.discovery.bold": "color.text.inverse",
    "color.background.discovery.bold.hovered": "color.text.inverse",
    "color.background.discovery.bold.pressed": "color.text.inverse",
    "color.background.information.bold": "color.text.inverse",
    "color.background.information.bold.hovered": "color.text.inverse",
    "color.background.information.bold.pressed": "color.text.inverse"
};
var $c04cd6140c1ab4cf$export$daf94a976c798b4f = {
    "opacity.disabled": "var(--ds-opacity-disabled, 0.4)",
    "opacity.loading": "var(--ds-opacity-loading, 0.2)"
};
var $c04cd6140c1ab4cf$export$7aff6e7ba39bb774 = {
    "elevation.shadow.overflow": "var(--ds-shadow-overflow, 0px 0px 8px #091e423f, 0px 0px 1px #091e424f)",
    "elevation.shadow.overflow.perimeter": "var(--ds-shadow-overflow-perimeter, #091e421f)",
    "elevation.shadow.overflow.spread": "var(--ds-shadow-overflow-spread, #091e4229)",
    "elevation.shadow.overlay": "var(--ds-shadow-overlay, 0px 8px 12px #091e423f, 0px 0px 1px #091e424f)",
    "elevation.shadow.raised": "var(--ds-shadow-raised, 0px 1px 1px #091e423f, 0px 0px 1px #091e4221)"
};
var $c04cd6140c1ab4cf$export$41a358c9c2356760 = {
    "elevation.surface": "var(--ds-surface, #FFFFFF)",
    "elevation.surface.hovered": "var(--ds-surface-hovered, #FAFBFC)",
    "elevation.surface.pressed": "var(--ds-surface-pressed, #F4F5F7)",
    "elevation.surface.overlay": "var(--ds-surface-overlay, #FFFFFF)",
    "elevation.surface.overlay.hovered": "var(--ds-surface-overlay-hovered, #FAFBFC)",
    "elevation.surface.overlay.pressed": "var(--ds-surface-overlay-pressed, #F4F5F7)",
    "elevation.surface.raised": "var(--ds-surface-raised, #FFFFFF)",
    "elevation.surface.raised.hovered": "var(--ds-surface-raised-hovered, #FAFBFC)",
    "elevation.surface.raised.pressed": "var(--ds-surface-raised-pressed, #F4F5F7)",
    "elevation.surface.sunken": "var(--ds-surface-sunken, #F4F5F7)"
};
var $c04cd6140c1ab4cf$export$1531ad5bb3fbedac = {
    "color.border": "var(--ds-border, #091e4221)",
    "color.border.accent.lime": "var(--ds-border-accent-lime, #6A9A23)",
    "color.border.accent.red": "var(--ds-border-accent-red, #FF5630)",
    "color.border.accent.orange": "var(--ds-border-accent-orange, #D94008)",
    "color.border.accent.yellow": "var(--ds-border-accent-yellow, #FFAB00)",
    "color.border.accent.green": "var(--ds-border-accent-green, #36B37E)",
    "color.border.accent.teal": "var(--ds-border-accent-teal, #00B8D9)",
    "color.border.accent.blue": "var(--ds-border-accent-blue, #0065FF)",
    "color.border.accent.purple": "var(--ds-border-accent-purple, #6554C0)",
    "color.border.accent.magenta": "var(--ds-border-accent-magenta, #CD519D)",
    "color.border.accent.gray": "var(--ds-border-accent-gray, #5E6C84)",
    "color.border.disabled": "var(--ds-border-disabled, #FAFBFC)",
    "color.border.focused": "var(--ds-border-focused, #2684FF)",
    "color.border.input": "var(--ds-border-input, #FAFBFC)",
    "color.border.inverse": "var(--ds-border-inverse, #FFFFFF)",
    "color.border.selected": "var(--ds-border-selected, #0052CC)",
    "color.border.brand": "var(--ds-border-brand, #0052CC)",
    "color.border.danger": "var(--ds-border-danger, #FF5630)",
    "color.border.warning": "var(--ds-border-warning, #FFC400)",
    "color.border.success": "var(--ds-border-success, #00875A)",
    "color.border.discovery": "var(--ds-border-discovery, #998DD9)",
    "color.border.information": "var(--ds-border-information, #0065FF)",
    "color.border.bold": "var(--ds-border-bold, #344563)"
};
var $c04cd6140c1ab4cf$export$d1d79bf68ac056bd = {
    "color.background.accent.lime.subtlest": "var(--ds-background-accent-lime-subtlest, #EEFBDA)",
    "color.background.accent.lime.subtlest.hovered": "var(--ds-background-accent-lime-subtlest-hovered, #D3F1A7)",
    "color.background.accent.lime.subtlest.pressed": "var(--ds-background-accent-lime-subtlest-pressed, #B3DF72)",
    "color.background.accent.lime.subtler": "var(--ds-background-accent-lime-subtler, #D3F1A7)",
    "color.background.accent.lime.subtler.hovered": "var(--ds-background-accent-lime-subtler-hovered, #B3DF72)",
    "color.background.accent.lime.subtler.pressed": "var(--ds-background-accent-lime-subtler-pressed, #94C748)",
    "color.background.accent.lime.subtle": "var(--ds-background-accent-lime-subtle, #94C748)",
    "color.background.accent.lime.subtle.hovered": "var(--ds-background-accent-lime-subtle-hovered, #B3DF72)",
    "color.background.accent.lime.subtle.pressed": "var(--ds-background-accent-lime-subtle-pressed, #D3F1A7)",
    "color.background.accent.lime.bolder": "var(--ds-background-accent-lime-bolder, #5B7F24)",
    "color.background.accent.lime.bolder.hovered": "var(--ds-background-accent-lime-bolder-hovered, #37471F)",
    "color.background.accent.lime.bolder.pressed": "var(--ds-background-accent-lime-bolder-pressed, #37471F)",
    "color.background.accent.red.subtlest": "var(--ds-background-accent-red-subtlest, #FF8F73)",
    "color.background.accent.red.subtlest.hovered": "var(--ds-background-accent-red-subtlest-hovered, #FF7452)",
    "color.background.accent.red.subtlest.pressed": "var(--ds-background-accent-red-subtlest-pressed, #FF5630)",
    "color.background.accent.red.subtler": "var(--ds-background-accent-red-subtler, #FF7452)",
    "color.background.accent.red.subtler.hovered": "var(--ds-background-accent-red-subtler-hovered, #FF5630)",
    "color.background.accent.red.subtler.pressed": "var(--ds-background-accent-red-subtler-pressed, #DE350B)",
    "color.background.accent.red.subtle": "var(--ds-background-accent-red-subtle, #DE350B)",
    "color.background.accent.red.subtle.hovered": "var(--ds-background-accent-red-subtle-hovered, #FF5630)",
    "color.background.accent.red.subtle.pressed": "var(--ds-background-accent-red-subtle-pressed, #FF7452)",
    "color.background.accent.red.bolder": "var(--ds-background-accent-red-bolder, #DE350B)",
    "color.background.accent.red.bolder.hovered": "var(--ds-background-accent-red-bolder-hovered, #FF5630)",
    "color.background.accent.red.bolder.pressed": "var(--ds-background-accent-red-bolder-pressed, #FF7452)",
    "color.background.accent.orange.subtlest": "var(--ds-background-accent-orange-subtlest, #F18D13)",
    "color.background.accent.orange.subtlest.hovered": "var(--ds-background-accent-orange-subtlest-hovered, #FEC57B)",
    "color.background.accent.orange.subtlest.pressed": "var(--ds-background-accent-orange-subtlest-pressed, #FFE2BD)",
    "color.background.accent.orange.subtler": "var(--ds-background-accent-orange-subtler, #B65C02)",
    "color.background.accent.orange.subtler.hovered": "var(--ds-background-accent-orange-subtler-hovered, #F18D13)",
    "color.background.accent.orange.subtler.pressed": "var(--ds-background-accent-orange-subtler-pressed, #FEC57B)",
    "color.background.accent.orange.subtle": "var(--ds-background-accent-orange-subtle, #5F3811)",
    "color.background.accent.orange.subtle.hovered": "var(--ds-background-accent-orange-subtle-hovered, #974F0C)",
    "color.background.accent.orange.subtle.pressed": "var(--ds-background-accent-orange-subtle-pressed, #B65C02)",
    "color.background.accent.orange.bolder": "var(--ds-background-accent-orange-bolder, #43290F)",
    "color.background.accent.orange.bolder.hovered": "var(--ds-background-accent-orange-bolder-hovered, #5F3811)",
    "color.background.accent.orange.bolder.pressed": "var(--ds-background-accent-orange-bolder-pressed, #974F0C)",
    "color.background.accent.yellow.subtlest": "var(--ds-background-accent-yellow-subtlest, #FFE380)",
    "color.background.accent.yellow.subtlest.hovered": "var(--ds-background-accent-yellow-subtlest-hovered, #FFC400)",
    "color.background.accent.yellow.subtlest.pressed": "var(--ds-background-accent-yellow-subtlest-pressed, #FFAB00)",
    "color.background.accent.yellow.subtler": "var(--ds-background-accent-yellow-subtler, #FFC400)",
    "color.background.accent.yellow.subtler.hovered": "var(--ds-background-accent-yellow-subtler-hovered, #FFAB00)",
    "color.background.accent.yellow.subtler.pressed": "var(--ds-background-accent-yellow-subtler-pressed, #FF991F)",
    "color.background.accent.yellow.subtle": "var(--ds-background-accent-yellow-subtle, #FF991F)",
    "color.background.accent.yellow.subtle.hovered": "var(--ds-background-accent-yellow-subtle-hovered, #FFAB00)",
    "color.background.accent.yellow.subtle.pressed": "var(--ds-background-accent-yellow-subtle-pressed, #FFC400)",
    "color.background.accent.yellow.bolder": "var(--ds-background-accent-yellow-bolder, #FF991F)",
    "color.background.accent.yellow.bolder.hovered": "var(--ds-background-accent-yellow-bolder-hovered, #FFAB00)",
    "color.background.accent.yellow.bolder.pressed": "var(--ds-background-accent-yellow-bolder-pressed, #FFC400)",
    "color.background.accent.green.subtlest": "var(--ds-background-accent-green-subtlest, #79F2C0)",
    "color.background.accent.green.subtlest.hovered": "var(--ds-background-accent-green-subtlest-hovered, #57D9A3)",
    "color.background.accent.green.subtlest.pressed": "var(--ds-background-accent-green-subtlest-pressed, #36B37E)",
    "color.background.accent.green.subtler": "var(--ds-background-accent-green-subtler, #57D9A3)",
    "color.background.accent.green.subtler.hovered": "var(--ds-background-accent-green-subtler-hovered, #36B37E)",
    "color.background.accent.green.subtler.pressed": "var(--ds-background-accent-green-subtler-pressed, #00875A)",
    "color.background.accent.green.subtle": "var(--ds-background-accent-green-subtle, #00875A)",
    "color.background.accent.green.subtle.hovered": "var(--ds-background-accent-green-subtle-hovered, #36B37E)",
    "color.background.accent.green.subtle.pressed": "var(--ds-background-accent-green-subtle-pressed, #57D9A3)",
    "color.background.accent.green.bolder": "var(--ds-background-accent-green-bolder, #00875A)",
    "color.background.accent.green.bolder.hovered": "var(--ds-background-accent-green-bolder-hovered, #36B37E)",
    "color.background.accent.green.bolder.pressed": "var(--ds-background-accent-green-bolder-pressed, #57D9A3)",
    "color.background.accent.teal.subtlest": "var(--ds-background-accent-teal-subtlest, #79E2F2)",
    "color.background.accent.teal.subtlest.hovered": "var(--ds-background-accent-teal-subtlest-hovered, #00C7E6)",
    "color.background.accent.teal.subtlest.pressed": "var(--ds-background-accent-teal-subtlest-pressed, #00B8D9)",
    "color.background.accent.teal.subtler": "var(--ds-background-accent-teal-subtler, #00C7E6)",
    "color.background.accent.teal.subtler.hovered": "var(--ds-background-accent-teal-subtler-hovered, #00B8D9)",
    "color.background.accent.teal.subtler.pressed": "var(--ds-background-accent-teal-subtler-pressed, #00A3BF)",
    "color.background.accent.teal.subtle": "var(--ds-background-accent-teal-subtle, #00A3BF)",
    "color.background.accent.teal.subtle.hovered": "var(--ds-background-accent-teal-subtle-hovered, #00B8D9)",
    "color.background.accent.teal.subtle.pressed": "var(--ds-background-accent-teal-subtle-pressed, #00C7E6)",
    "color.background.accent.teal.bolder": "var(--ds-background-accent-teal-bolder, #00A3BF)",
    "color.background.accent.teal.bolder.hovered": "var(--ds-background-accent-teal-bolder-hovered, #00B8D9)",
    "color.background.accent.teal.bolder.pressed": "var(--ds-background-accent-teal-bolder-pressed, #00C7E6)",
    "color.background.accent.blue.subtlest": "var(--ds-background-accent-blue-subtlest, #4C9AFF)",
    "color.background.accent.blue.subtlest.hovered": "var(--ds-background-accent-blue-subtlest-hovered, #2684FF)",
    "color.background.accent.blue.subtlest.pressed": "var(--ds-background-accent-blue-subtlest-pressed, #0065FF)",
    "color.background.accent.blue.subtler": "var(--ds-background-accent-blue-subtler, #2684FF)",
    "color.background.accent.blue.subtler.hovered": "var(--ds-background-accent-blue-subtler-hovered, #0065FF)",
    "color.background.accent.blue.subtler.pressed": "var(--ds-background-accent-blue-subtler-pressed, #0052CC)",
    "color.background.accent.blue.subtle": "var(--ds-background-accent-blue-subtle, #0052CC)",
    "color.background.accent.blue.subtle.hovered": "var(--ds-background-accent-blue-subtle-hovered, #0065FF)",
    "color.background.accent.blue.subtle.pressed": "var(--ds-background-accent-blue-subtle-pressed, #2684FF)",
    "color.background.accent.blue.bolder": "var(--ds-background-accent-blue-bolder, #0052CC)",
    "color.background.accent.blue.bolder.hovered": "var(--ds-background-accent-blue-bolder-hovered, #0065FF)",
    "color.background.accent.blue.bolder.pressed": "var(--ds-background-accent-blue-bolder-pressed, #2684FF)",
    "color.background.accent.purple.subtlest": "var(--ds-background-accent-purple-subtlest, #998DD9)",
    "color.background.accent.purple.subtlest.hovered": "var(--ds-background-accent-purple-subtlest-hovered, #8777D9)",
    "color.background.accent.purple.subtlest.pressed": "var(--ds-background-accent-purple-subtlest-pressed, #6554C0)",
    "color.background.accent.purple.subtler": "var(--ds-background-accent-purple-subtler, #8777D9)",
    "color.background.accent.purple.subtler.hovered": "var(--ds-background-accent-purple-subtler-hovered, #6554C0)",
    "color.background.accent.purple.subtler.pressed": "var(--ds-background-accent-purple-subtler-pressed, #5243AA)",
    "color.background.accent.purple.subtle": "var(--ds-background-accent-purple-subtle, #5243AA)",
    "color.background.accent.purple.subtle.hovered": "var(--ds-background-accent-purple-subtle-hovered, #6554C0)",
    "color.background.accent.purple.subtle.pressed": "var(--ds-background-accent-purple-subtle-pressed, #8777D9)",
    "color.background.accent.purple.bolder": "var(--ds-background-accent-purple-bolder, #5243AA)",
    "color.background.accent.purple.bolder.hovered": "var(--ds-background-accent-purple-bolder-hovered, #6554C0)",
    "color.background.accent.purple.bolder.pressed": "var(--ds-background-accent-purple-bolder-pressed, #8777D9)",
    "color.background.accent.magenta.subtlest": "var(--ds-background-accent-magenta-subtlest, #FFECF8)",
    "color.background.accent.magenta.subtlest.hovered": "var(--ds-background-accent-magenta-subtlest-hovered, #FDD0EC)",
    "color.background.accent.magenta.subtlest.pressed": "var(--ds-background-accent-magenta-subtlest-pressed, #F797D2)",
    "color.background.accent.magenta.subtler": "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
    "color.background.accent.magenta.subtler.hovered": "var(--ds-background-accent-magenta-subtler-hovered, #F797D2)",
    "color.background.accent.magenta.subtler.pressed": "var(--ds-background-accent-magenta-subtler-pressed, #E774BB)",
    "color.background.accent.magenta.subtle": "var(--ds-background-accent-magenta-subtle, #E774BB)",
    "color.background.accent.magenta.subtle.hovered": "var(--ds-background-accent-magenta-subtle-hovered, #F797D2)",
    "color.background.accent.magenta.subtle.pressed": "var(--ds-background-accent-magenta-subtle-pressed, #FDD0EC)",
    "color.background.accent.magenta.bolder": "var(--ds-background-accent-magenta-bolder, #AE4787)",
    "color.background.accent.magenta.bolder.hovered": "var(--ds-background-accent-magenta-bolder-hovered, #943D73)",
    "color.background.accent.magenta.bolder.pressed": "var(--ds-background-accent-magenta-bolder-pressed, #50253F)",
    "color.background.accent.gray.subtlest": "var(--ds-background-accent-gray-subtlest, #6B778C)",
    "color.background.accent.gray.subtlest.hovered": "var(--ds-background-accent-gray-subtlest-hovered, #5E6C84)",
    "color.background.accent.gray.subtlest.pressed": "var(--ds-background-accent-gray-subtlest-pressed, #505F79)",
    "color.background.accent.gray.subtler": "var(--ds-background-accent-gray-subtler, #5E6C84)",
    "color.background.accent.gray.subtler.hovered": "var(--ds-background-accent-gray-subtler-hovered, #505F79)",
    "color.background.accent.gray.subtler.pressed": "var(--ds-background-accent-gray-subtler-pressed, #42526E)",
    "color.background.accent.gray.subtle": "var(--ds-background-accent-gray-subtle, #505F79)",
    "color.background.accent.gray.subtle.hovered": "var(--ds-background-accent-gray-subtle-hovered, #5E6C84)",
    "color.background.accent.gray.subtle.pressed": "var(--ds-background-accent-gray-subtle-pressed, #6B778C)",
    "color.background.accent.gray.bolder": "var(--ds-background-accent-gray-bolder, #42526E)",
    "color.background.accent.gray.bolder.hovered": "var(--ds-background-accent-gray-bolder-hovered, #344563)",
    "color.background.accent.gray.bolder.pressed": "var(--ds-background-accent-gray-bolder-pressed, #253858)",
    "color.background.disabled": "var(--ds-background-disabled, #091e4289)",
    "color.background.input": "var(--ds-background-input, #FAFBFC)",
    "color.background.input.hovered": "var(--ds-background-input-hovered, #EBECF0)",
    "color.background.input.pressed": "var(--ds-background-input-pressed, #FFFFFF)",
    "color.background.inverse.subtle": "var(--ds-background-inverse-subtle, #00000029)",
    "color.background.inverse.subtle.hovered": "var(--ds-background-inverse-subtle-hovered, #0000003D)",
    "color.background.inverse.subtle.pressed": "var(--ds-background-inverse-subtle-pressed, #00000052)",
    "color.background.neutral": "var(--ds-background-neutral, #DFE1E6)",
    "color.background.neutral.hovered": "var(--ds-background-neutral-hovered, #091e4214)",
    "color.background.neutral.pressed": "var(--ds-background-neutral-pressed, #B3D4FF)",
    "color.background.neutral.subtle": "var(--ds-background-neutral-subtle, transparent)",
    "color.background.neutral.subtle.hovered": "var(--ds-background-neutral-subtle-hovered, #091e4214)",
    "color.background.neutral.subtle.pressed": "var(--ds-background-neutral-subtle-pressed, #B3D4FF)",
    "color.background.neutral.bold": "var(--ds-background-neutral-bold, #42526E)",
    "color.background.neutral.bold.hovered": "var(--ds-background-neutral-bold-hovered, #505F79)",
    "color.background.neutral.bold.pressed": "var(--ds-background-neutral-bold-pressed, #344563)",
    "color.background.selected": "var(--ds-background-selected, #DEEBFF)",
    "color.background.selected.hovered": "var(--ds-background-selected-hovered, #B3D4FF)",
    "color.background.selected.pressed": "var(--ds-background-selected-pressed, #4C9AFF)",
    "color.background.selected.bold": "var(--ds-background-selected-bold, #0052CC)",
    "color.background.selected.bold.hovered": "var(--ds-background-selected-bold-hovered, #2684FF)",
    "color.background.selected.bold.pressed": "var(--ds-background-selected-bold-pressed, #0052CC)",
    "color.background.brand.subtlest": "var(--ds-background-brand-subtlest, #B3D4FF)",
    "color.background.brand.subtlest.hovered": "var(--ds-background-brand-subtlest-hovered, #DEEBFF)",
    "color.background.brand.subtlest.pressed": "var(--ds-background-brand-subtlest-pressed, #4C9AFF)",
    "color.background.brand.bold": "var(--ds-background-brand-bold, #0052CC)",
    "color.background.brand.bold.hovered": "var(--ds-background-brand-bold-hovered, #0065FF)",
    "color.background.brand.bold.pressed": "var(--ds-background-brand-bold-pressed, #0747A6)",
    "color.background.brand.boldest": "var(--ds-background-brand-boldest, #0747A6)",
    "color.background.brand.boldest.hovered": "var(--ds-background-brand-boldest-hovered, #0052CC)",
    "color.background.brand.boldest.pressed": "var(--ds-background-brand-boldest-pressed, #0747A6)",
    "color.background.danger": "var(--ds-background-danger, #FFEBE6)",
    "color.background.danger.hovered": "var(--ds-background-danger-hovered, #FFBDAD)",
    "color.background.danger.pressed": "var(--ds-background-danger-pressed, #FF8F73)",
    "color.background.danger.bold": "var(--ds-background-danger-bold, #DE350B)",
    "color.background.danger.bold.hovered": "var(--ds-background-danger-bold-hovered, #FF5630)",
    "color.background.danger.bold.pressed": "var(--ds-background-danger-bold-pressed, #BF2600)",
    "color.background.warning": "var(--ds-background-warning, #FFFAE6)",
    "color.background.warning.hovered": "var(--ds-background-warning-hovered, #FFF0B3)",
    "color.background.warning.pressed": "var(--ds-background-warning-pressed, #FFE380)",
    "color.background.warning.bold": "var(--ds-background-warning-bold, #FFAB00)",
    "color.background.warning.bold.hovered": "var(--ds-background-warning-bold-hovered, #FFC400)",
    "color.background.warning.bold.pressed": "var(--ds-background-warning-bold-pressed, #FF991F)",
    "color.background.success": "var(--ds-background-success, #E3FCEF)",
    "color.background.success.hovered": "var(--ds-background-success-hovered, #ABF5D1)",
    "color.background.success.pressed": "var(--ds-background-success-pressed, #79F2C0)",
    "color.background.success.bold": "var(--ds-background-success-bold, #00875A)",
    "color.background.success.bold.hovered": "var(--ds-background-success-bold-hovered, #57D9A3)",
    "color.background.success.bold.pressed": "var(--ds-background-success-bold-pressed, #00875A)",
    "color.background.discovery": "var(--ds-background-discovery, #EAE6FF)",
    "color.background.discovery.hovered": "var(--ds-background-discovery-hovered, #C0B6F2)",
    "color.background.discovery.pressed": "var(--ds-background-discovery-pressed, #998DD9)",
    "color.background.discovery.bold": "var(--ds-background-discovery-bold, #5243AA)",
    "color.background.discovery.bold.hovered": "var(--ds-background-discovery-bold-hovered, #8777D9)",
    "color.background.discovery.bold.pressed": "var(--ds-background-discovery-bold-pressed, #5243AA)",
    "color.background.information": "var(--ds-background-information, #DEEBFF)",
    "color.background.information.hovered": "var(--ds-background-information-hovered, #B3D4FF)",
    "color.background.information.pressed": "var(--ds-background-information-pressed, #4C9AFF)",
    "color.background.information.bold": "var(--ds-background-information-bold, #0052CC)",
    "color.background.information.bold.hovered": "var(--ds-background-information-bold-hovered, #2684FF)",
    "color.background.information.bold.pressed": "var(--ds-background-information-bold-pressed, #0052CC)",
    "color.blanket": "var(--ds-blanket, #091e4289)",
    "color.blanket.selected": "var(--ds-blanket-selected, #388BFF14)",
    "color.blanket.danger": "var(--ds-blanket-danger, #EF5C4814)",
    "color.skeleton": "var(--ds-skeleton, #F4F5F7)",
    "color.skeleton.subtle": "var(--ds-skeleton-subtle, #091e420a)",
    "elevation.surface": "var(--ds-surface, #FFFFFF)",
    "elevation.surface.hovered": "var(--ds-surface-hovered, #FAFBFC)",
    "elevation.surface.pressed": "var(--ds-surface-pressed, #F4F5F7)",
    "elevation.surface.overlay": "var(--ds-surface-overlay, #FFFFFF)",
    "elevation.surface.overlay.hovered": "var(--ds-surface-overlay-hovered, #FAFBFC)",
    "elevation.surface.overlay.pressed": "var(--ds-surface-overlay-pressed, #F4F5F7)",
    "elevation.surface.raised": "var(--ds-surface-raised, #FFFFFF)",
    "elevation.surface.raised.hovered": "var(--ds-surface-raised-hovered, #FAFBFC)",
    "elevation.surface.raised.pressed": "var(--ds-surface-raised-pressed, #F4F5F7)",
    "elevation.surface.sunken": "var(--ds-surface-sunken, #F4F5F7)",
    "utility.elevation.surface.current": "var(--ds-elevation-surface-current, #FFFFFF)"
};
var $c04cd6140c1ab4cf$export$8473307aa00d6ea1 = {
    "color.text": "var(--ds-text, #172B4D)",
    "color.text.accent.lime": "var(--ds-text-accent-lime, #4C6B1F)",
    "color.text.accent.lime.bolder": "var(--ds-text-accent-lime-bolder, #37471F)",
    "color.text.accent.red": "var(--ds-text-accent-red, #DE350B)",
    "color.text.accent.red.bolder": "var(--ds-text-accent-red-bolder, #BF2600)",
    "color.text.accent.orange": "var(--ds-text-accent-orange, #F18D13)",
    "color.text.accent.orange.bolder": "var(--ds-text-accent-orange-bolder, #B65C02)",
    "color.text.accent.yellow": "var(--ds-text-accent-yellow, #FF991F)",
    "color.text.accent.yellow.bolder": "var(--ds-text-accent-yellow-bolder, #FF8B00)",
    "color.text.accent.green": "var(--ds-text-accent-green, #00875A)",
    "color.text.accent.green.bolder": "var(--ds-text-accent-green-bolder, #006644)",
    "color.text.accent.teal": "var(--ds-text-accent-teal, #00A3BF)",
    "color.text.accent.teal.bolder": "var(--ds-text-accent-teal-bolder, #008DA6)",
    "color.text.accent.blue": "var(--ds-text-accent-blue, #0052CC)",
    "color.text.accent.blue.bolder": "var(--ds-text-accent-blue-bolder, #0747A6)",
    "color.text.accent.purple": "var(--ds-text-accent-purple, #5243AA)",
    "color.text.accent.purple.bolder": "var(--ds-text-accent-purple-bolder, #403294)",
    "color.text.accent.magenta": "var(--ds-text-accent-magenta, #E774BB)",
    "color.text.accent.magenta.bolder": "var(--ds-text-accent-magenta-bolder, #DA62AC)",
    "color.text.accent.gray": "var(--ds-text-accent-gray, #505F79)",
    "color.text.accent.gray.bolder": "var(--ds-text-accent-gray-bolder, #172B4D)",
    "color.text.disabled": "var(--ds-text-disabled, #A5ADBA)",
    "color.text.inverse": "var(--ds-text-inverse, #FFFFFF)",
    "color.text.selected": "var(--ds-text-selected, #0052CC)",
    "color.text.brand": "var(--ds-text-brand, #0065FF)",
    "color.text.danger": "var(--ds-text-danger, #DE350B)",
    "color.text.warning": "var(--ds-text-warning, #974F0C)",
    "color.text.warning.inverse": "var(--ds-text-warning-inverse, #172B4D)",
    "color.text.success": "var(--ds-text-success, #006644)",
    "color.text.discovery": "var(--ds-text-discovery, #403294)",
    "color.text.information": "var(--ds-text-information, #0052CC)",
    "color.text.subtlest": "var(--ds-text-subtlest, #7A869A)",
    "color.text.subtle": "var(--ds-text-subtle, #42526E)",
    "color.link": "var(--ds-link, #0052CC)",
    "color.link.pressed": "var(--ds-link-pressed, #0747A6)",
    "color.link.visited": "var(--ds-link-visited, #403294)",
    "color.link.visited.pressed": "var(--ds-link-visited-pressed, #403294)"
};
var $c04cd6140c1ab4cf$export$498780f74be9af68 = {
    "color.icon": "var(--ds-icon, #505F79)",
    "color.icon.accent.lime": "var(--ds-icon-accent-lime, #6A9A23)",
    "color.icon.accent.red": "var(--ds-icon-accent-red, #FF5630)",
    "color.icon.accent.orange": "var(--ds-icon-accent-orange, #D94008)",
    "color.icon.accent.yellow": "var(--ds-icon-accent-yellow, #FFAB00)",
    "color.icon.accent.green": "var(--ds-icon-accent-green, #36B37E)",
    "color.icon.accent.teal": "var(--ds-icon-accent-teal, #00B8D9)",
    "color.icon.accent.blue": "var(--ds-icon-accent-blue, #0065FF)",
    "color.icon.accent.purple": "var(--ds-icon-accent-purple, #6554C0)",
    "color.icon.accent.magenta": "var(--ds-icon-accent-magenta, #CD519D)",
    "color.icon.accent.gray": "var(--ds-icon-accent-gray, #5E6C84)",
    "color.icon.disabled": "var(--ds-icon-disabled, #8993A4)",
    "color.icon.inverse": "var(--ds-icon-inverse, #FFFFFF)",
    "color.icon.selected": "var(--ds-icon-selected, #0052CC)",
    "color.icon.brand": "var(--ds-icon-brand, #0065FF)",
    "color.icon.danger": "var(--ds-icon-danger, #DE350B)",
    "color.icon.warning": "var(--ds-icon-warning, #FFC400)",
    "color.icon.warning.inverse": "var(--ds-icon-warning-inverse, #253858)",
    "color.icon.success": "var(--ds-icon-success, #00875A)",
    "color.icon.discovery": "var(--ds-icon-discovery, #8777D9)",
    "color.icon.information": "var(--ds-icon-information, #0747A6)",
    "color.icon.subtle": "var(--ds-icon-subtle, #6B778C)"
};
var $c04cd6140c1ab4cf$export$b5f31a7e431d2eab = {
    card: 100,
    navigation: 200,
    dialog: 300,
    layer: 400,
    blanket: 500,
    modal: 510,
    flag: 600,
    spotlight: 700,
    tooltip: 800
};
var $c04cd6140c1ab4cf$export$e1b83c5210c471b8 = {
    "border.width": "var(--ds-border-width, 1px)",
    "border.width.0": "var(--ds-border-width-0, 0px)",
    "border.width.indicator": "var(--ds-border-width-indicator, 3px)",
    "border.width.outline": "var(--ds-border-width-outline, 2px)"
};
var $c04cd6140c1ab4cf$export$3c0a6c3e64bb180d = {
    "border.radius.050": "var(--ds-border-radius-050, 2px)",
    "border.radius": "var(--ds-border-radius, 3px)",
    "border.radius.100": "var(--ds-border-radius-100, 3px)",
    "border.radius.200": "var(--ds-border-radius-200, 8px)",
    "border.radius.300": "var(--ds-border-radius-300, 12px)",
    "border.radius.400": "var(--ds-border-radius-400, 16px)",
    "border.radius.circle": "var(--ds-border-radius-circle, 32032px)"
};
var $c04cd6140c1ab4cf$export$6cc560b4dedf3816 = {
    medium: 'var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    UNSAFE_small: 'var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    large: 'var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    small: 'var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)'
};
var $c04cd6140c1ab4cf$export$303e322c6b1ed114 = {
    bold: "var(--ds-font-weight-bold, 700)",
    medium: "var(--ds-font-weight-medium, 500)",
    regular: "var(--ds-font-weight-regular, 400)",
    semibold: "var(--ds-font-weight-semibold, 600)"
};
var $c04cd6140c1ab4cf$export$3c7e9587132614b4 = {
    "font.family.body": 'var(--ds-font-family-body, ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.family.brand.body": 'var(--ds-font-family-brand-body, "Charlie Text", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.family.brand.heading": 'var(--ds-font-family-brand-heading, "Charlie Display", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.family.code": 'var(--ds-font-family-code, ui-monospace, Menlo, "Segoe UI Mono", "Ubuntu Mono", monospace)',
    "font.family.heading": 'var(--ds-font-family-heading, ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)'
};
/**
 * @codegenEnd
 */ // Margin needs some bespoke types: https://atlassian.slack.com/archives/CKRHB23K8/p1712623192772909
// Generate maps for Box props. backgroundColor, padding, etc
var $c04cd6140c1ab4cf$var$spacingProperties = [
    // Used by Box
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    // Used by Inline and Stack
    "gap",
    "rowGap",
    "columnGap"
];
var $c04cd6140c1ab4cf$var$getSerializedStylesMap = function getSerializedStylesMap(cssProperty, tokenMap) {
    return Object.keys(tokenMap).reduce(function(emotionSpacingMap, token) {
        emotionSpacingMap[token] = (0, $jVTBW.css)((0, (/*@__PURE__*/$parcel$interopDefault($4787457db3f2db36$exports)))({}, cssProperty, tokenMap[token]));
        return emotionSpacingMap;
    }, {});
};
var $c04cd6140c1ab4cf$export$e615f061ca585a6c = $c04cd6140c1ab4cf$var$spacingProperties.reduce(function(styleMap, spacingProperty) {
    styleMap[spacingProperty] = $c04cd6140c1ab4cf$var$getSerializedStylesMap(spacingProperty, $c04cd6140c1ab4cf$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
var $c04cd6140c1ab4cf$export$bf46c3f9eeafc71f = $c04cd6140c1ab4cf$var$spacingProperties.reduce(function(styleMap, spacingProperty) {
    styleMap[spacingProperty] = $c04cd6140c1ab4cf$var$getSerializedStylesMap(spacingProperty, $c04cd6140c1ab4cf$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
var $c04cd6140c1ab4cf$export$e7af83bafe7f9e63 = $c04cd6140c1ab4cf$var$getSerializedStylesMap("backgroundColor", $c04cd6140c1ab4cf$export$d1d79bf68ac056bd);
var $c04cd6140c1ab4cf$export$3a1bcba60b23d7f0 = $c04cd6140c1ab4cf$var$getSerializedStylesMap("color", $c04cd6140c1ab4cf$export$8473307aa00d6ea1);
var $c04cd6140c1ab4cf$export$45f3f4fe16f9f7d5 = $c04cd6140c1ab4cf$var$getSerializedStylesMap("fontWeight", $c04cd6140c1ab4cf$export$303e322c6b1ed114);
var $c04cd6140c1ab4cf$export$68cc305da27dbaa4 = $c04cd6140c1ab4cf$var$getSerializedStylesMap("fontFamily", $c04cd6140c1ab4cf$export$3c7e9587132614b4);
var $c04cd6140c1ab4cf$export$128f10c238242f83 = $c04cd6140c1ab4cf$var$getSerializedStylesMap("font", $c04cd6140c1ab4cf$export$6cc560b4dedf3816);
var $c04cd6140c1ab4cf$export$ff257d957d48c421 = $c04cd6140c1ab4cf$var$getSerializedStylesMap((0, $ae9201354a3e5eb1$export$9d7b58831ae93caa), $c04cd6140c1ab4cf$export$41a358c9c2356760);
var $c04cd6140c1ab4cf$export$5e65a44e5b6ecadb = function isSurfaceColorToken(color) {
    return $c04cd6140c1ab4cf$export$41a358c9c2356760[color] !== undefined;
};




var $335cea68709f203e$exports = {};
var $2cae3ca8cb630f4d$exports = {};
function $2cae3ca8cb630f4d$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
$2cae3ca8cb630f4d$exports = $2cae3ca8cb630f4d$var$_arrayWithHoles, $2cae3ca8cb630f4d$exports.__esModule = true, $2cae3ca8cb630f4d$exports["default"] = $2cae3ca8cb630f4d$exports;


var $99a01122a9ce5d56$exports = {};
function $99a01122a9ce5d56$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
$99a01122a9ce5d56$exports = $99a01122a9ce5d56$var$_iterableToArrayLimit, $99a01122a9ce5d56$exports.__esModule = true, $99a01122a9ce5d56$exports["default"] = $99a01122a9ce5d56$exports;



var $0dc247364f2c85d7$exports = {};
function $0dc247364f2c85d7$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
$0dc247364f2c85d7$exports = $0dc247364f2c85d7$var$_nonIterableRest, $0dc247364f2c85d7$exports.__esModule = true, $0dc247364f2c85d7$exports["default"] = $0dc247364f2c85d7$exports;


function $335cea68709f203e$var$_slicedToArray(r, e) {
    return $2cae3ca8cb630f4d$exports(r) || $99a01122a9ce5d56$exports(r, e) || $0b2a6ee8c8b45107$exports(r, e) || $0dc247364f2c85d7$exports();
}
$335cea68709f203e$exports = $335cea68709f203e$var$_slicedToArray, $335cea68709f203e$exports.__esModule = true, $335cea68709f203e$exports["default"] = $335cea68709f203e$exports;




var $jVTBW = parcelRequire("jVTBW");


var $ahJoN = parcelRequire("ahJoN");
function $c5ccc779e549efe9$var$_createForOfIteratorHelper(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (!it) {
        if (Array.isArray(o) || (it = $c5ccc779e549efe9$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
            if (it) o = it;
            var i = 0;
            var F = function F() {};
            return {
                s: F,
                n: function n() {
                    if (i >= o.length) return {
                        done: true
                    };
                    return {
                        done: false,
                        value: o[i++]
                    };
                },
                e: function e(_e) {
                    throw _e;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var normalCompletion = true, didErr = false, err;
    return {
        s: function s() {
            it = it.call(o);
        },
        n: function n() {
            var step = it.next();
            normalCompletion = step.done;
            return step;
        },
        e: function e(_e2) {
            didErr = true;
            err = _e2;
        },
        f: function f() {
            try {
                if (!normalCompletion && it.return != null) it.return();
            } finally{
                if (didErr) throw err;
            }
        }
    };
}
function $c5ccc779e549efe9$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $c5ccc779e549efe9$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $c5ccc779e549efe9$var$_arrayLikeToArray(o, minLen);
}
function $c5ccc779e549efe9$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $c5ccc779e549efe9$export$9a199fbafee0014e = {
    backgroundColor: (0, $c04cd6140c1ab4cf$export$d1d79bf68ac056bd),
    blockSize: (0, $c04cd6140c1ab4cf$export$6ccdbebca2ee545f),
    borderBlockColor: (0, $c04cd6140c1ab4cf$export$1531ad5bb3fbedac),
    borderBlockEndColor: (0, $c04cd6140c1ab4cf$export$1531ad5bb3fbedac),
    borderBlockEndWidth: (0, $c04cd6140c1ab4cf$export$e1b83c5210c471b8),
    borderBlockStartColor: (0, $c04cd6140c1ab4cf$export$1531ad5bb3fbedac),
    borderBlockStartWidth: (0, $c04cd6140c1ab4cf$export$e1b83c5210c471b8),
    borderBlockWidth: (0, $c04cd6140c1ab4cf$export$e1b83c5210c471b8),
    borderBottomColor: (0, $c04cd6140c1ab4cf$export$1531ad5bb3fbedac),
    borderBottomLeftRadius: (0, $c04cd6140c1ab4cf$export$3c0a6c3e64bb180d),
    borderBottomRightRadius: (0, $c04cd6140c1ab4cf$export$3c0a6c3e64bb180d),
    borderBottomWidth: (0, $c04cd6140c1ab4cf$export$e1b83c5210c471b8),
    borderColor: (0, $c04cd6140c1ab4cf$export$1531ad5bb3fbedac),
    borderEndEndRadius: (0, $c04cd6140c1ab4cf$export$3c0a6c3e64bb180d),
    borderEndStartRadius: (0, $c04cd6140c1ab4cf$export$3c0a6c3e64bb180d),
    borderInlineColor: (0, $c04cd6140c1ab4cf$export$1531ad5bb3fbedac),
    borderInlineEndColor: (0, $c04cd6140c1ab4cf$export$1531ad5bb3fbedac),
    borderInlineEndWidth: (0, $c04cd6140c1ab4cf$export$e1b83c5210c471b8),
    borderInlineStartColor: (0, $c04cd6140c1ab4cf$export$1531ad5bb3fbedac),
    borderInlineStartWidth: (0, $c04cd6140c1ab4cf$export$e1b83c5210c471b8),
    borderInlineWidth: (0, $c04cd6140c1ab4cf$export$e1b83c5210c471b8),
    borderLeftColor: (0, $c04cd6140c1ab4cf$export$1531ad5bb3fbedac),
    borderLeftWidth: (0, $c04cd6140c1ab4cf$export$e1b83c5210c471b8),
    borderRadius: (0, $c04cd6140c1ab4cf$export$3c0a6c3e64bb180d),
    borderRightColor: (0, $c04cd6140c1ab4cf$export$1531ad5bb3fbedac),
    borderRightWidth: (0, $c04cd6140c1ab4cf$export$e1b83c5210c471b8),
    borderStartEndRadius: (0, $c04cd6140c1ab4cf$export$3c0a6c3e64bb180d),
    borderStartStartRadius: (0, $c04cd6140c1ab4cf$export$3c0a6c3e64bb180d),
    borderTopColor: (0, $c04cd6140c1ab4cf$export$1531ad5bb3fbedac),
    borderTopLeftRadius: (0, $c04cd6140c1ab4cf$export$3c0a6c3e64bb180d),
    borderTopRightRadius: (0, $c04cd6140c1ab4cf$export$3c0a6c3e64bb180d),
    borderTopWidth: (0, $c04cd6140c1ab4cf$export$e1b83c5210c471b8),
    borderWidth: (0, $c04cd6140c1ab4cf$export$e1b83c5210c471b8),
    bottom: (0, $c04cd6140c1ab4cf$export$632685d741f3dbbf),
    boxShadow: (0, $c04cd6140c1ab4cf$export$7aff6e7ba39bb774),
    color: (0, $c04cd6140c1ab4cf$export$8473307aa00d6ea1),
    columnGap: (0, $c04cd6140c1ab4cf$export$958d0ae7f2977ae4),
    gap: (0, $c04cd6140c1ab4cf$export$958d0ae7f2977ae4),
    height: (0, $c04cd6140c1ab4cf$export$6ccdbebca2ee545f),
    inlineSize: (0, $c04cd6140c1ab4cf$export$6ccdbebca2ee545f),
    inset: (0, $c04cd6140c1ab4cf$export$632685d741f3dbbf),
    insetBlock: (0, $c04cd6140c1ab4cf$export$632685d741f3dbbf),
    insetBlockEnd: (0, $c04cd6140c1ab4cf$export$632685d741f3dbbf),
    insetBlockStart: (0, $c04cd6140c1ab4cf$export$632685d741f3dbbf),
    insetInline: (0, $c04cd6140c1ab4cf$export$632685d741f3dbbf),
    insetInlineEnd: (0, $c04cd6140c1ab4cf$export$632685d741f3dbbf),
    insetInlineStart: (0, $c04cd6140c1ab4cf$export$632685d741f3dbbf),
    left: (0, $c04cd6140c1ab4cf$export$632685d741f3dbbf),
    margin: (0, $c04cd6140c1ab4cf$export$632685d741f3dbbf),
    marginBlock: (0, $c04cd6140c1ab4cf$export$632685d741f3dbbf),
    marginBlockEnd: (0, $c04cd6140c1ab4cf$export$632685d741f3dbbf),
    marginBlockStart: (0, $c04cd6140c1ab4cf$export$632685d741f3dbbf),
    marginBottom: (0, $c04cd6140c1ab4cf$export$632685d741f3dbbf),
    marginInline: (0, $c04cd6140c1ab4cf$export$632685d741f3dbbf),
    marginInlineEnd: (0, $c04cd6140c1ab4cf$export$632685d741f3dbbf),
    marginInlineStart: (0, $c04cd6140c1ab4cf$export$632685d741f3dbbf),
    marginLeft: (0, $c04cd6140c1ab4cf$export$632685d741f3dbbf),
    marginRight: (0, $c04cd6140c1ab4cf$export$632685d741f3dbbf),
    marginTop: (0, $c04cd6140c1ab4cf$export$632685d741f3dbbf),
    maxBlockSize: (0, $c04cd6140c1ab4cf$export$6ccdbebca2ee545f),
    maxHeight: (0, $c04cd6140c1ab4cf$export$6ccdbebca2ee545f),
    maxInlineSize: (0, $c04cd6140c1ab4cf$export$6ccdbebca2ee545f),
    maxWidth: (0, $c04cd6140c1ab4cf$export$6ccdbebca2ee545f),
    minBlockSize: (0, $c04cd6140c1ab4cf$export$6ccdbebca2ee545f),
    minHeight: (0, $c04cd6140c1ab4cf$export$6ccdbebca2ee545f),
    minInlineSize: (0, $c04cd6140c1ab4cf$export$6ccdbebca2ee545f),
    minWidth: (0, $c04cd6140c1ab4cf$export$6ccdbebca2ee545f),
    opacity: (0, $c04cd6140c1ab4cf$export$daf94a976c798b4f),
    outlineColor: (0, $c04cd6140c1ab4cf$export$1531ad5bb3fbedac),
    outlineOffset: (0, $c04cd6140c1ab4cf$export$958d0ae7f2977ae4),
    outlineWidth: (0, $c04cd6140c1ab4cf$export$e1b83c5210c471b8),
    padding: (0, $c04cd6140c1ab4cf$export$958d0ae7f2977ae4),
    paddingBlock: (0, $c04cd6140c1ab4cf$export$958d0ae7f2977ae4),
    paddingBlockEnd: (0, $c04cd6140c1ab4cf$export$958d0ae7f2977ae4),
    paddingBlockStart: (0, $c04cd6140c1ab4cf$export$958d0ae7f2977ae4),
    paddingBottom: (0, $c04cd6140c1ab4cf$export$958d0ae7f2977ae4),
    paddingInline: (0, $c04cd6140c1ab4cf$export$958d0ae7f2977ae4),
    paddingInlineEnd: (0, $c04cd6140c1ab4cf$export$958d0ae7f2977ae4),
    paddingInlineStart: (0, $c04cd6140c1ab4cf$export$958d0ae7f2977ae4),
    paddingLeft: (0, $c04cd6140c1ab4cf$export$958d0ae7f2977ae4),
    paddingRight: (0, $c04cd6140c1ab4cf$export$958d0ae7f2977ae4),
    paddingTop: (0, $c04cd6140c1ab4cf$export$958d0ae7f2977ae4),
    right: (0, $c04cd6140c1ab4cf$export$632685d741f3dbbf),
    rowGap: (0, $c04cd6140c1ab4cf$export$958d0ae7f2977ae4),
    top: (0, $c04cd6140c1ab4cf$export$632685d741f3dbbf),
    width: (0, $c04cd6140c1ab4cf$export$6ccdbebca2ee545f),
    zIndex: (0, $c04cd6140c1ab4cf$export$b5f31a7e431d2eab)
};
var $c5ccc779e549efe9$var$uniqueSymbol = Symbol("UNSAFE_INTERNAL_styles");
var $c5ccc779e549efe9$var$isSafeEnvToThrow = function isSafeEnvToThrow() {
    return (typeof $ahJoN === "undefined" ? "undefined" : (0, (/*@__PURE__*/$parcel$interopDefault($c71c76e04a3512b2$exports)))($ahJoN)) === "object" && (0, (/*@__PURE__*/$parcel$interopDefault($c71c76e04a3512b2$exports)))($ahJoN.env) === "object" && false;
};
var $c5ccc779e549efe9$var$reNestedSelectors = /(\.|\s|&+|\*\>|#|\[.*\])/;
var $c5ccc779e549efe9$var$safeSelectors = /^@media .*$|^::?.*$|^@supports .*$/;
var $c5ccc779e549efe9$var$transformStyles = function transformStyles(styleObj) {
    if (!styleObj || (0, (/*@__PURE__*/$parcel$interopDefault($c71c76e04a3512b2$exports)))(styleObj) !== "object") return styleObj;
    // If styles are defined as a CSSObject[], recursively call on each element until we reach CSSObject
    if (Array.isArray(styleObj)) return styleObj.map(transformStyles);
    // Modifies styleObj in place. Be careful.
    Object.entries(styleObj).forEach(function(_ref) {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($335cea68709f203e$exports)))(_ref, 2), key = _ref2[0], value = _ref2[1];
        // If key is a pseudo class or a pseudo element, then value should be an object.
        // So, call transformStyles on the value
        if ((0, (/*@__PURE__*/$parcel$interopDefault($c71c76e04a3512b2$exports)))(value) === "object" && $c5ccc779e549efe9$var$safeSelectors.test(key)) {
            styleObj[key] = transformStyles(value);
            return;
        }
        if ($c5ccc779e549efe9$var$isSafeEnvToThrow()) {
            // We don't support `.class`, `[data-testid]`, `> *`, `#some-id`
            if ($c5ccc779e549efe9$var$reNestedSelectors.test(key)) throw new Error("Styles not supported for key '".concat(key, "'."));
        }
        // We have now dealt with all the special cases, so,
        // check whether what remains is a style property
        // that can be transformed.
        if (!(key in $c5ccc779e549efe9$export$9a199fbafee0014e)) return;
        var tokenValue = $c5ccc779e549efe9$export$9a199fbafee0014e[key][value];
        styleObj[key] = tokenValue !== null && tokenValue !== void 0 ? tokenValue : value;
    });
    return styleObj;
};
var $c5ccc779e549efe9$var$baseXcss = function baseXcss(style) {
    var transformedStyles = $c5ccc779e549efe9$var$transformStyles(style);
    return (0, (/*@__PURE__*/$parcel$interopDefault($4787457db3f2db36$exports)))({}, $c5ccc779e549efe9$var$uniqueSymbol, (0, $jVTBW.css)(transformedStyles));
};
var $c5ccc779e549efe9$export$a9c84988c8f81f2d = function parseXcss(args) {
    if (Array.isArray(args)) {
        var emotion = [];
        var staticArr = [];
        var _iterator = $c5ccc779e549efe9$var$_createForOfIteratorHelper(args), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var arg = _step.value;
                var result = parseXcss(arg);
                if (result.emotion) emotion.push.apply(emotion, (0, (/*@__PURE__*/$parcel$interopDefault($b985f02f43d5bb38$exports)))(result.emotion));
                if (result.static) staticArr.push(result.static);
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        return {
            emotion: emotion,
            static: staticArr.join(" ")
        };
    }
    var objArgs = args;
    var _ref4 = objArgs || {}, styles = _ref4[$c5ccc779e549efe9$var$uniqueSymbol];
    if (styles) return {
        emotion: [
            styles
        ]
    };
    if (args) {
        // We use string interpolation here instead of .toString() just
        // in case the resulting object doesn't have the method available.
        var stringifiedArgs = "".concat(args);
        if (stringifiedArgs) return {
            static: stringifiedArgs
        };
    }
    return {};
};
function $c5ccc779e549efe9$export$f6c783d06584602c(style) {
    return $c5ccc779e549efe9$var$baseXcss(style);
}



var $dAx5m = parcelRequire("dAx5m");
var $2d55fd3c6ff076c7$export$1ca2a26fecb070ae = /*#__PURE__*/ (0, $dAx5m.createContext)("elevation.surface");
var $2d55fd3c6ff076c7$export$1aeb4f6b93c4540d = function useSurface() {
    return (0, $dAx5m.useContext)($2d55fd3c6ff076c7$export$1ca2a26fecb070ae);
};
$2d55fd3c6ff076c7$export$1ca2a26fecb070ae.displayName = "SurfaceProvider";


var $17ed5770e0d4b299$var$_excluded = [
    "as",
    "children",
    "backgroundColor",
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    "style",
    "testId",
    "xcss"
], $17ed5770e0d4b299$var$_excluded2 = [
    "className"
];
var $17ed5770e0d4b299$export$e71c4d32a2263218 = /*#__PURE__*/ (0, $dAx5m.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? "div" : _ref$as, children = _ref.children, backgroundColor = _ref.backgroundColor, padding = _ref.padding, paddingBlock = _ref.paddingBlock, paddingBlockStart = _ref.paddingBlockStart, paddingBlockEnd = _ref.paddingBlockEnd, paddingInline = _ref.paddingInline, paddingInlineStart = _ref.paddingInlineStart, paddingInlineEnd = _ref.paddingInlineEnd, style = _ref.style, testId = _ref.testId, xcss = _ref.xcss, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($a5a711648b8fac27$exports)))(_ref, $17ed5770e0d4b299$var$_excluded);
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($a5a711648b8fac27$exports)))(htmlAttributes, $17ed5770e0d4b299$var$_excluded2);
    var resolvedStyles = (0, $c5ccc779e549efe9$export$a9c84988c8f81f2d)(xcss);
    var node = // @ts-expect-error Expression produces a union type that is too complex to represent. I think this is unavoidable
    (0, $jVTBW.jsx)(Component, (0, (/*@__PURE__*/$parcel$interopDefault($a715ace8101e0d2f$exports)))({
        style: style,
        ref: ref,
        className: resolvedStyles.static
    }, safeHtmlAttributes, {
        css: [
            $17ed5770e0d4b299$var$baseStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            backgroundColor && (0, $c04cd6140c1ab4cf$export$e7af83bafe7f9e63)[backgroundColor],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $c04cd6140c1ab4cf$export$5e65a44e5b6ecadb)(backgroundColor) && (0, $c04cd6140c1ab4cf$export$ff257d957d48c421)[backgroundColor],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            padding && (0, $c04cd6140c1ab4cf$export$e615f061ca585a6c).padding[padding],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlock && (0, $c04cd6140c1ab4cf$export$e615f061ca585a6c).paddingBlock[paddingBlock],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockStart && (0, $c04cd6140c1ab4cf$export$e615f061ca585a6c).paddingBlockStart[paddingBlockStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockEnd && (0, $c04cd6140c1ab4cf$export$e615f061ca585a6c).paddingBlockEnd[paddingBlockEnd],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInline && (0, $c04cd6140c1ab4cf$export$e615f061ca585a6c).paddingInline[paddingInline],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineStart && (0, $c04cd6140c1ab4cf$export$e615f061ca585a6c).paddingInlineStart[paddingInlineStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineEnd && (0, $c04cd6140c1ab4cf$export$e615f061ca585a6c).paddingInlineEnd[paddingInlineEnd],
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            resolvedStyles.emotion
        ],
        "data-testid": testId
    }), children);
    return backgroundColor ? (0, $jVTBW.jsx)((0, $2d55fd3c6ff076c7$export$1ca2a26fecb070ae).Provider, {
        value: backgroundColor
    }, node) : node;
});
var $17ed5770e0d4b299$export$2e2bcd8739ae039 = $17ed5770e0d4b299$export$e71c4d32a2263218;
var $17ed5770e0d4b299$var$baseStyles = (0, $jVTBW.css)({
    boxSizing: "border-box",
    appearance: "none",
    border: "none"
});


/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ /* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // Reds
var $52db4ed54bce6bc7$export$4b84fd0e2c617bd = "#FFEBE6";
var $52db4ed54bce6bc7$export$b34b069eff244586 = "#FFBDAD";
var $52db4ed54bce6bc7$export$be802dd0d8b57f35 = "#FF8F73";
var $52db4ed54bce6bc7$export$60847d42f9da92a6 = "#FF7452";
var $52db4ed54bce6bc7$export$4a7404f376229999 = "#FF5630";
var $52db4ed54bce6bc7$export$2010d0fb4295b346 = "#DE350B";
var $52db4ed54bce6bc7$export$2837b5a1a71d5c02 = "#BF2600";
var $52db4ed54bce6bc7$export$8d9596b529bbb9cf = "#FFFAE6";
var $52db4ed54bce6bc7$export$41060a744ab0b7ae = "#FFF0B3";
var $52db4ed54bce6bc7$export$1cc05bbbf340e559 = "#FFE380";
var $52db4ed54bce6bc7$export$5aae31392d72caaa = "#FFC400";
var $52db4ed54bce6bc7$export$c6930421db9fa514 = "#FFAB00";
var $52db4ed54bce6bc7$export$59619663aa6500fb = "#FF991F";
var $52db4ed54bce6bc7$export$874739ea9e379ab6 = "#FF8B00";
var $52db4ed54bce6bc7$export$8a6341c32b6a3ee6 = "#E3FCEF";
var $52db4ed54bce6bc7$export$69a3bf21b9686c2b = "#ABF5D1";
var $52db4ed54bce6bc7$export$afbce1382ec95f73 = "#79F2C0";
var $52db4ed54bce6bc7$export$747d86715d4175de = "#57D9A3";
var $52db4ed54bce6bc7$export$940e1f69e873f202 = "#36B37E";
var $52db4ed54bce6bc7$export$a49394138f7b8e85 = "#00875A";
var $52db4ed54bce6bc7$export$6fa04827ac68a4fb = "#006644";
var $52db4ed54bce6bc7$export$226de0355ed012f8 = "#DEEBFF";
var $52db4ed54bce6bc7$export$8c13c2ee36917869 = "#B3D4FF";
var $52db4ed54bce6bc7$export$ecfc1dff386a3e7a = "#4C9AFF";
var $52db4ed54bce6bc7$export$215b7063051591f1 = "#2684FF";
var $52db4ed54bce6bc7$export$e62e8919cca44969 = "#0065FF";
var $52db4ed54bce6bc7$export$b3de0ae08da2ce64 = "#0052CC";
var $52db4ed54bce6bc7$export$a6ee3d71bc067634 = "#0747A6";
var $52db4ed54bce6bc7$export$363e4475840015bb = "#EAE6FF";
var $52db4ed54bce6bc7$export$4b0a4417ed59760f = "#C0B6F2";
var $52db4ed54bce6bc7$export$6011520a64d9a187 = "#998DD9";
var $52db4ed54bce6bc7$export$a7175d4e9206bc80 = "#8777D9";
var $52db4ed54bce6bc7$export$b48405b95304b5a1 = "#6554C0";
var $52db4ed54bce6bc7$export$c71e4279dd54a18d = "#5243AA";
var $52db4ed54bce6bc7$export$147899de772240ec = "#403294";
var $52db4ed54bce6bc7$export$2cf711fe14c66f06 = "#E6FCFF";
var $52db4ed54bce6bc7$export$7a8f4d33f6f9772c = "#B3F5FF";
var $52db4ed54bce6bc7$export$776c9c497ef08533 = "#79E2F2";
var $52db4ed54bce6bc7$export$69cb3ca10c1e330e = "#00C7E6";
var $52db4ed54bce6bc7$export$9dc1ef0f3f48059b = "#00B8D9";
var $52db4ed54bce6bc7$export$7c835c78b6fcdef8 = "#00A3BF";
var $52db4ed54bce6bc7$export$6036577f95c3877e = "#008DA6";
var $52db4ed54bce6bc7$export$29a4f05edc054374 = "#FFFFFF";
var $52db4ed54bce6bc7$export$e655ef011c4aa1a2 = "#FAFBFC";
var $52db4ed54bce6bc7$export$9fdfb749e33cdf97 = "#F4F5F7";
var $52db4ed54bce6bc7$export$3e51e8f1440314ba = "#EBECF0";
var $52db4ed54bce6bc7$export$1ce2d1575d444ceb = "#DFE1E6";
var $52db4ed54bce6bc7$export$8754fc7e6d8b3000 = "#C1C7D0";
var $52db4ed54bce6bc7$export$c2e91cbeada39b8b = "#B3BAC5";
var $52db4ed54bce6bc7$export$5f71e19f3a7ad9de = "#A5ADBA";
var $52db4ed54bce6bc7$export$eaa8c8a70ac22806 = "#97A0AF";
var $52db4ed54bce6bc7$export$7c87d337fb91a97d = "#8993A4";
var $52db4ed54bce6bc7$export$d6447c357493214f = "#7A869A";
var $52db4ed54bce6bc7$export$f563ee71e9ee74cd = "#6B778C";
var $52db4ed54bce6bc7$export$e2ef2124cf4024b1 = "#5E6C84";
var $52db4ed54bce6bc7$export$eece5f492e429f08 = "#505F79";
var $52db4ed54bce6bc7$export$c39c0fe0f26207ae = "#42526E";
var $52db4ed54bce6bc7$export$7090862dc3038a9f = "#344563";
var $52db4ed54bce6bc7$export$ad0bacf983b7ddaa = "#253858";
var $52db4ed54bce6bc7$export$7d61b15e0da132af = "#172B4D";
var $52db4ed54bce6bc7$export$fbda843f0a27fe96 = "#091E42";
var $52db4ed54bce6bc7$export$791e57b27ca738ef = "rgba(9, 30, 66, 0.02)";
var $52db4ed54bce6bc7$export$8d43898f60b96a82 = "rgba(9, 30, 66, 0.04)";
var $52db4ed54bce6bc7$export$920c0d5c49070351 = "rgba(9, 30, 66, 0.08)";
var $52db4ed54bce6bc7$export$46987b49aab6d1a8 = "rgba(9, 30, 66, 0.13)";
var $52db4ed54bce6bc7$export$7d3359664e8bb0e5 = "rgba(9, 30, 66, 0.25)";
var $52db4ed54bce6bc7$export$d2d3bedfb276cac0 = "rgba(9, 30, 66, 0.31)";
var $52db4ed54bce6bc7$export$6e5e7499ff054f6d = "rgba(9, 30, 66, 0.36)";
var $52db4ed54bce6bc7$export$59264b346c877fa7 = "rgba(9, 30, 66, 0.42)";
var $52db4ed54bce6bc7$export$d092757d7c64925c = "rgba(9, 30, 66, 0.48)";
var $52db4ed54bce6bc7$export$486ab785e4bac3c6 = "rgba(9, 30, 66, 0.54)";
var $52db4ed54bce6bc7$export$fba592bbc6419fea = "rgba(9, 30, 66, 0.60)";
var $52db4ed54bce6bc7$export$13609db0e6812ab8 = "rgba(9, 30, 66, 0.66)";
var $52db4ed54bce6bc7$export$fbae4efaa892d883 = "rgba(9, 30, 66, 0.71)";
var $52db4ed54bce6bc7$export$f13946d26f440ce6 = "rgba(9, 30, 66, 0.77)";
var $52db4ed54bce6bc7$export$19f58225ac52a306 = "rgba(9, 30, 66, 0.82)";
var $52db4ed54bce6bc7$export$6384f09da70e7b62 = "rgba(9, 30, 66, 0.89)";
var $52db4ed54bce6bc7$export$d0dccc730683edc2 = "rgba(9, 30, 66, 0.95)";
var $52db4ed54bce6bc7$export$2f6319cf7d736c2a = "#E6EDFA";
var $52db4ed54bce6bc7$export$95126bc8884d6634 = "#DCE5F5";
var $52db4ed54bce6bc7$export$8338d8c35d44ff1 = "#CED9EB";
var $52db4ed54bce6bc7$export$5368d76ae4fbbda7 = "#B8C7E0";
var $52db4ed54bce6bc7$export$9f0a771d16ec8d36 = "#ABBBD6";
var $52db4ed54bce6bc7$export$abcf8c38338b4aa5 = "#9FB0CC";
var $52db4ed54bce6bc7$export$97e81faa16a182c7 = "#8C9CB8";
var $52db4ed54bce6bc7$export$bfe21c59123ecf33 = "#7988A3";
var $52db4ed54bce6bc7$export$ee82aa2ea6a1558 = "#67758F";
var $52db4ed54bce6bc7$export$682927c6ed76be02 = "#56637A";
var $52db4ed54bce6bc7$export$91fd9994c5be9757 = "#455166";
var $52db4ed54bce6bc7$export$d281fbfe3cff2df6 = "#3B475C";
var $52db4ed54bce6bc7$export$3902c91d8b98a753 = "#313D52";
var $52db4ed54bce6bc7$export$8e8133c1ba5845b5 = "#283447";
var $52db4ed54bce6bc7$export$33ff357f6620b39 = "#202B3D";
var $52db4ed54bce6bc7$export$633847cf062b69e0 = "#1B2638";
var $52db4ed54bce6bc7$export$9776a6e503bdbf76 = "#121A29";
var $52db4ed54bce6bc7$export$6c813d5160dff5db = "#0E1624";
var $52db4ed54bce6bc7$export$3d4f271a500072a = "#0D1424";
var $52db4ed54bce6bc7$export$fe151285c22759ec = "rgba(13, 20, 36, 0.06)";
var $52db4ed54bce6bc7$export$a101c6190d0da34 = "rgba(13, 20, 36, 0.14)";
var $52db4ed54bce6bc7$export$4b16f52932fda51 = "rgba(13, 20, 36, 0.18)";
var $52db4ed54bce6bc7$export$a74bcd7b9845b0d8 = "rgba(13, 20, 36, 0.29)";
var $52db4ed54bce6bc7$export$9209c179316d1751 = "rgba(13, 20, 36, 0.36)";
var $52db4ed54bce6bc7$export$88f55133f636c8dd = "rgba(13, 20, 36, 0.40)";
var $52db4ed54bce6bc7$export$51126f85d1009512 = "rgba(13, 20, 36, 0.47)";
var $52db4ed54bce6bc7$export$a069b547bd23af78 = "rgba(13, 20, 36, 0.53)";
var $52db4ed54bce6bc7$export$40cce05af3b2600a = "rgba(13, 20, 36, 0.63)";
var $52db4ed54bce6bc7$export$b78942185925a0d = "rgba(13, 20, 36, 0.73)";
var $52db4ed54bce6bc7$export$e058fb44b8eaafca = "rgba(13, 20, 36, 0.78)";
var $52db4ed54bce6bc7$export$92b0b8de26920c18 = "rgba(13, 20, 36, 0.81)";
var $52db4ed54bce6bc7$export$67564f7459d3fc9e = "rgba(13, 20, 36, 0.85)";
var $52db4ed54bce6bc7$export$77868e1ca884ffa3 = "rgba(13, 20, 36, 0.89)";
var $52db4ed54bce6bc7$export$2afd71d7d3ea2cd5 = "rgba(13, 20, 36, 0.92)";
var $52db4ed54bce6bc7$export$f2a0acaab9972c70 = "rgba(13, 20, 36, 0.95)";
var $52db4ed54bce6bc7$export$9ab70e67d6475361 = "rgba(13, 20, 36, 0.97)";


var $a33aee08a44d0d0a$export$fc5727d09955ec17 = [
    "270deg, ".concat((0, $52db4ed54bce6bc7$export$1ce2d1575d444ceb), " 0%, ").concat((0, $52db4ed54bce6bc7$export$5f71e19f3a7ad9de), " 100%"),
    "270deg, ".concat((0, $52db4ed54bce6bc7$export$4b84fd0e2c617bd), " 0%, ").concat((0, $52db4ed54bce6bc7$export$be802dd0d8b57f35), " 100%"),
    "270deg, ".concat((0, $52db4ed54bce6bc7$export$363e4475840015bb), " 0%, ").concat((0, $52db4ed54bce6bc7$export$4b0a4417ed59760f), " 100%"),
    "270deg, ".concat((0, $52db4ed54bce6bc7$export$226de0355ed012f8), " 0%, ").concat((0, $52db4ed54bce6bc7$export$ecfc1dff386a3e7a), " 100%"),
    "270deg, ".concat((0, $52db4ed54bce6bc7$export$7a8f4d33f6f9772c), " 0%, ").concat((0, $52db4ed54bce6bc7$export$776c9c497ef08533), " 100%"),
    "270deg, ".concat((0, $52db4ed54bce6bc7$export$8a6341c32b6a3ee6), " 0%, ").concat((0, $52db4ed54bce6bc7$export$afbce1382ec95f73), " 100%"),
    "270deg, ".concat((0, $52db4ed54bce6bc7$export$41060a744ab0b7ae), " 0%, ").concat((0, $52db4ed54bce6bc7$export$5aae31392d72caaa), " 100%")
];



// Code to generate index number from ids is taken from:
// src/master/src/static/gradients/README.md
/**
 * Generate 32bit integer from given string
 */ var $fe64f68a4fea83c2$var$hashCode = function hashCode(str) {
    var hash = 0;
    var chr;
    var i;
    for(i = 0; i < str.length; i++){
        chr = str.charCodeAt(i);
        hash = (hash << 5) - hash + chr;
        hash = hash & hash; // Convert to 32bit integer
    }
    return hash;
};
var $fe64f68a4fea83c2$export$47d4d34461987b5d = function getGradientIndexByString(id) {
    if (!id) return 0;
    var ordinal = ($fe64f68a4fea83c2$var$hashCode(id) % 50).toString()// split string into character array
    .split("")// map to array of charCodes of each character
    .map(function(chr) {
        return chr.charCodeAt(0);
    })// add up all charCodes in the array
    .reduce(function(a, b) {
        return a + b;
    }, 0);
    return ordinal % (0, $a33aee08a44d0d0a$export$fc5727d09955ec17).length;
};
var $fe64f68a4fea83c2$export$137ec5185b12f5a2 = function getColorFromString(str) {
    var index = $fe64f68a4fea83c2$export$47d4d34461987b5d(str);
    return (0, $a33aee08a44d0d0a$export$fc5727d09955ec17)[index];
};


var $a355194521128ff6$var$styles = (0, $c5ccc779e549efe9$export$f6c783d06584602c)({
    width: "100%",
    height: "100%",
    backgroundSize: "cover",
    backgroundPosition: "center",
    overflow: "hidden"
});
var $a355194521128ff6$var$gradientStyles = (0, $a33aee08a44d0d0a$export$fc5727d09955ec17).map(function(gradient) {
    return (0, $c5ccc779e549efe9$export$f6c783d06584602c)({
        backgroundImage: "linear-gradient(".concat(gradient, ")")
    });
});
function $a355194521128ff6$export$358466f81685c10c(props) {
    var gradientIndex = (0, $dAx5m.useMemo)(function() {
        return (0, $fe64f68a4fea83c2$export$47d4d34461987b5d)(props.stringToHash);
    }, [
        props.stringToHash
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement((0, $17ed5770e0d4b299$export$2e2bcd8739ae039), {
        xcss: [
            $a355194521128ff6$var$styles,
            $a355194521128ff6$var$gradientStyles[gradientIndex]
        ].concat((0, (/*@__PURE__*/$parcel$interopDefault($b985f02f43d5bb38$exports)))(Array.isArray(props.customStyles) ? props.customStyles : [
            props.customStyles
        ]))
    }, props.children);
}




var $7bo29 = parcelRequire("7bo29");
var $ca8LS = parcelRequire("ca8LS");
const $eac5bcc1cba7cde9$var$DEFAULT_HEADER_IMAGE_HEIGHT = 192;
const $eac5bcc1cba7cde9$var$wrapperStyles = (0, $ca8LS.xcss)({
    height: "100%"
});
function $eac5bcc1cba7cde9$export$2e2bcd8739ae039(props) {
    const { hasRoundCorners: hasRoundCorners = false, height: height = $eac5bcc1cba7cde9$var$DEFAULT_HEADER_IMAGE_HEIGHT, imgSrc: imgSrc, isUploading: isUploading } = props;
    return /*#__PURE__*/ (0, $bibO8.jsxs)((0, $7bo29.default), {
        xcss: $eac5bcc1cba7cde9$var$wrapperStyles,
        children: [
            isUploading && /*#__PURE__*/ (0, $bibO8.jsx)($6f4cb0cf4c6bfbcd$export$b08b517936747730, {
                "data-testid": "spinner",
                children: /*#__PURE__*/ (0, $bibO8.jsx)((0, $fL9T3.default), {
                    size: "medium"
                })
            }),
            imgSrc === null ? /*#__PURE__*/ (0, $bibO8.jsx)((0, $a355194521128ff6$export$358466f81685c10c), {
                stringToHash: props.userId
            }) : imgSrc && /*#__PURE__*/ (0, $bibO8.jsx)($6f4cb0cf4c6bfbcd$export$3e431a229df88919, {
                height: height,
                hasRoundCorners: hasRoundCorners,
                "data-testid": "profile-header-image",
                isUploading: isUploading,
                src: imgSrc
            })
        ]
    });
}



var $bibO8 = parcelRequire("bibO8");

var $dAx5m = parcelRequire("dAx5m");
var $51dadecb4eebc77f$export$5fe5572478566289 = function isImagePreview(preview) {
    return !!preview.dimensions;
};



var $4R5hd = parcelRequire("4R5hd");

var $hhJNI = parcelRequire("hhJNI");

var $14yZW = parcelRequire("14yZW");

var $7wq2F = parcelRequire("7wq2F");

var $bxoWL = parcelRequire("bxoWL");

var $jHNYu = parcelRequire("jHNYu");

var $eNVL5 = parcelRequire("eNVL5");

var $8mDaf = parcelRequire("8mDaf");

var $56sX4 = parcelRequire("56sX4");

var $jNWd4 = parcelRequire("jNWd4");

var $dAx5m = parcelRequire("dAx5m");
function $ac8429d373adb1cc$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $ac8429d373adb1cc$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, (/*@__PURE__*/$parcel$interopDefault($8mDaf)))(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, (/*@__PURE__*/$parcel$interopDefault($8mDaf)))(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, (/*@__PURE__*/$parcel$interopDefault($eNVL5)))(this, result);
    };
}
function $ac8429d373adb1cc$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($ac8429d373adb1cc$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}



var $ac8429d373adb1cc$export$66201d263cd6342 = /*#__PURE__*/ function(_React$PureComponent) {
    (0, (/*@__PURE__*/$parcel$interopDefault($jHNYu)))(DropzoneLoader, _React$PureComponent);
    var _super = $ac8429d373adb1cc$var$_createSuper(DropzoneLoader);
    function DropzoneLoader() {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($14yZW)))(this, DropzoneLoader);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, (/*@__PURE__*/$parcel$interopDefault($56sX4)))((0, (/*@__PURE__*/$parcel$interopDefault($bxoWL)))(_this), "state", {
            Dropzone: DropzoneLoader.Dropzone,
            MediaPickerErrorBoundary: DropzoneLoader.MediaPickerErrorBoundary
        });
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($7wq2F)))(DropzoneLoader, [
        {
            key: "UNSAFE_componentWillMount",
            value: function() {
                var _UNSAFE_componentWillMount = (0, (/*@__PURE__*/$parcel$interopDefault($hhJNI)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jNWd4))).mark(function _callee() {
                    var _yield$Promise$all, _yield$Promise$all2, mediaClient, dropzoneModule, mediaPickerErrorBoundaryModule;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($jNWd4))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                if (!(!this.state.Dropzone || !this.state.MediaPickerErrorBoundary)) {
                                    _context.next = 16;
                                    break;
                                }
                                _context.prev = 1;
                                _context.next = 4;
                                return Promise.all([
                                    (parcelRequire("c8xEF")),
                                    (parcelRequire("4AXoV")),
                                    (parcelRequire("fVPP0"))
                                ]);
                            case 4:
                                _yield$Promise$all = _context.sent;
                                _yield$Promise$all2 = (0, (/*@__PURE__*/$parcel$interopDefault($4R5hd)))(_yield$Promise$all, 3);
                                mediaClient = _yield$Promise$all2[0];
                                dropzoneModule = _yield$Promise$all2[1];
                                mediaPickerErrorBoundaryModule = _yield$Promise$all2[2];
                                // @ts-ignore: [PIT-1685] Fails in post-office due to backwards incompatibility issue with React 18
                                DropzoneLoader.Dropzone = mediaClient.withMediaClient(dropzoneModule.Dropzone);
                                DropzoneLoader.MediaPickerErrorBoundary = mediaPickerErrorBoundaryModule.default;
                                this.setState({
                                    Dropzone: DropzoneLoader.Dropzone,
                                    MediaPickerErrorBoundary: DropzoneLoader.MediaPickerErrorBoundary
                                });
                                _context.next = 16;
                                break;
                            case 14:
                                _context.prev = 14;
                                _context.t0 = _context["catch"](1);
                            case 16:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this, [
                        [
                            1,
                            14
                        ]
                    ]);
                }));
                function UNSAFE_componentWillMount() {
                    return _UNSAFE_componentWillMount.apply(this, arguments);
                }
                return UNSAFE_componentWillMount;
            }()
        },
        {
            key: "render",
            value: function render() {
                var _this$state = this.state, Dropzone = _this$state.Dropzone, MediaPickerErrorBoundary = _this$state.MediaPickerErrorBoundary;
                if (!Dropzone || !MediaPickerErrorBoundary) return null;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement(MediaPickerErrorBoundary, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement(Dropzone, this.props));
            }
        }
    ]);
    return DropzoneLoader;
}((0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).PureComponent);
(0, (/*@__PURE__*/$parcel$interopDefault($56sX4)))($ac8429d373adb1cc$export$66201d263cd6342, "displayName", "AsyncDropzone");



var $4R5hd = parcelRequire("4R5hd");

var $hhJNI = parcelRequire("hhJNI");

var $14yZW = parcelRequire("14yZW");

var $7wq2F = parcelRequire("7wq2F");

var $bxoWL = parcelRequire("bxoWL");

var $jHNYu = parcelRequire("jHNYu");

var $eNVL5 = parcelRequire("eNVL5");

var $8mDaf = parcelRequire("8mDaf");

var $56sX4 = parcelRequire("56sX4");

var $jNWd4 = parcelRequire("jNWd4");

var $dAx5m = parcelRequire("dAx5m");
function $9e8b2bec114d3195$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $9e8b2bec114d3195$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, (/*@__PURE__*/$parcel$interopDefault($8mDaf)))(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, (/*@__PURE__*/$parcel$interopDefault($8mDaf)))(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, (/*@__PURE__*/$parcel$interopDefault($eNVL5)))(this, result);
    };
}
function $9e8b2bec114d3195$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($9e8b2bec114d3195$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}


var $9e8b2bec114d3195$export$d7936799bf32b554 = /*#__PURE__*/ function(_React$PureComponent) {
    (0, (/*@__PURE__*/$parcel$interopDefault($jHNYu)))(ClipboardLoader, _React$PureComponent);
    var _super = $9e8b2bec114d3195$var$_createSuper(ClipboardLoader);
    function ClipboardLoader() {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($14yZW)))(this, ClipboardLoader);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, (/*@__PURE__*/$parcel$interopDefault($56sX4)))((0, (/*@__PURE__*/$parcel$interopDefault($bxoWL)))(_this), "state", {
            Clipboard: ClipboardLoader.Clipboard
        });
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($7wq2F)))(ClipboardLoader, [
        {
            key: "UNSAFE_componentWillMount",
            value: function() {
                var _UNSAFE_componentWillMount = (0, (/*@__PURE__*/$parcel$interopDefault($hhJNI)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jNWd4))).mark(function _callee() {
                    var _yield$Promise$all, _yield$Promise$all2, mediaClient, clipboardModule;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($jNWd4))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                if (this.state.Clipboard) {
                                    _context.next = 9;
                                    break;
                                }
                                _context.next = 3;
                                return Promise.all([
                                    (parcelRequire("c8xEF")),
                                    (parcelRequire("3kwhV"))
                                ]);
                            case 3:
                                _yield$Promise$all = _context.sent;
                                _yield$Promise$all2 = (0, (/*@__PURE__*/$parcel$interopDefault($4R5hd)))(_yield$Promise$all, 2);
                                mediaClient = _yield$Promise$all2[0];
                                clipboardModule = _yield$Promise$all2[1];
                                // @ts-ignore: [PIT-1685] Fails in post-office due to backwards incompatibility issue with React 18
                                ClipboardLoader.Clipboard = mediaClient.withMediaClient(clipboardModule.Clipboard);
                                this.setState({
                                    Clipboard: ClipboardLoader.Clipboard
                                });
                            case 9:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this);
                }));
                function UNSAFE_componentWillMount() {
                    return _UNSAFE_componentWillMount.apply(this, arguments);
                }
                return UNSAFE_componentWillMount;
            }()
        },
        {
            key: "render",
            value: function render() {
                if (!this.state.Clipboard) return null;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement(this.state.Clipboard, this.props);
            }
        }
    ]);
    return ClipboardLoader;
}((0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).PureComponent);
(0, (/*@__PURE__*/$parcel$interopDefault($56sX4)))($9e8b2bec114d3195$export$d7936799bf32b554, "displayName", "AsyncClipboard");



var $4R5hd = parcelRequire("4R5hd");

var $hhJNI = parcelRequire("hhJNI");

var $14yZW = parcelRequire("14yZW");

var $7wq2F = parcelRequire("7wq2F");

var $bxoWL = parcelRequire("bxoWL");

var $jHNYu = parcelRequire("jHNYu");

var $eNVL5 = parcelRequire("eNVL5");

var $8mDaf = parcelRequire("8mDaf");

var $56sX4 = parcelRequire("56sX4");

var $jNWd4 = parcelRequire("jNWd4");

var $dAx5m = parcelRequire("dAx5m");
function $5ddd23bfb0293a7b$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $5ddd23bfb0293a7b$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, (/*@__PURE__*/$parcel$interopDefault($8mDaf)))(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, (/*@__PURE__*/$parcel$interopDefault($8mDaf)))(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, (/*@__PURE__*/$parcel$interopDefault($eNVL5)))(this, result);
    };
}
function $5ddd23bfb0293a7b$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($5ddd23bfb0293a7b$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}


var $5ddd23bfb0293a7b$export$3ce634ac4a869e2c = /*#__PURE__*/ function(_React$PureComponent) {
    (0, (/*@__PURE__*/$parcel$interopDefault($jHNYu)))(BrowserLoader, _React$PureComponent);
    var _super = $5ddd23bfb0293a7b$var$_createSuper(BrowserLoader);
    function BrowserLoader() {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($14yZW)))(this, BrowserLoader);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, (/*@__PURE__*/$parcel$interopDefault($56sX4)))((0, (/*@__PURE__*/$parcel$interopDefault($bxoWL)))(_this), "mounted", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($56sX4)))((0, (/*@__PURE__*/$parcel$interopDefault($bxoWL)))(_this), "state", {
            Browser: BrowserLoader.Browser
        });
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($7wq2F)))(BrowserLoader, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.mounted = true;
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.mounted = false;
            }
        },
        {
            key: "UNSAFE_componentWillMount",
            value: function() {
                var _UNSAFE_componentWillMount = (0, (/*@__PURE__*/$parcel$interopDefault($hhJNI)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jNWd4))).mark(function _callee() {
                    var _yield$Promise$all, _yield$Promise$all2, mediaClient, browserModule;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($jNWd4))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                if (this.state.Browser) {
                                    _context.next = 9;
                                    break;
                                }
                                _context.next = 3;
                                return Promise.all([
                                    (parcelRequire("c8xEF")),
                                    (parcelRequire("lhTtx"))
                                ]);
                            case 3:
                                _yield$Promise$all = _context.sent;
                                _yield$Promise$all2 = (0, (/*@__PURE__*/$parcel$interopDefault($4R5hd)))(_yield$Promise$all, 2);
                                mediaClient = _yield$Promise$all2[0];
                                browserModule = _yield$Promise$all2[1];
                                // @ts-ignore: [PIT-1685] Fails in post-office due to backwards incompatibility issue with React 18
                                BrowserLoader.Browser = mediaClient.withMediaClient(browserModule.Browser);
                                if (this.mounted) this.setState({
                                    Browser: BrowserLoader.Browser
                                });
                            case 9:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this);
                }));
                function UNSAFE_componentWillMount() {
                    return _UNSAFE_componentWillMount.apply(this, arguments);
                }
                return UNSAFE_componentWillMount;
            }()
        },
        {
            key: "render",
            value: function render() {
                if (!this.state.Browser) return null;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).createElement(this.state.Browser, this.props);
            }
        }
    ]);
    return BrowserLoader;
}((0, (/*@__PURE__*/$parcel$interopDefault($dAx5m))).PureComponent);
(0, (/*@__PURE__*/$parcel$interopDefault($56sX4)))($5ddd23bfb0293a7b$export$3ce634ac4a869e2c, "displayName", "AsyncBrowser");





var $dAx5m = parcelRequire("dAx5m");

var $iDL5l = parcelRequire("iDL5l");

var $1Bj4T = parcelRequire("1Bj4T");

var $djcZD = parcelRequire("djcZD");
const $0c1bc6c3dbf14138$var$getWriteTokenResultPlaceholder = Symbol("getWriteTokenResultPlaceholder");
function $0c1bc6c3dbf14138$export$2e2bcd8739ae039() {
    const [state, setState] = (0, $dAx5m.useState)({
        headerImageId: ""
    });
    const refQueryPromise = (0, $dAx5m.useRef)(Promise.resolve($0c1bc6c3dbf14138$var$getWriteTokenResultPlaceholder));
    // we want to start to fetch Write Token when File Dialog open, instead of on page loading.
    const startGetWriteToken = (0, $dAx5m.useCallback)(async ()=>{
        // MediaApi is disabled in FedRamp
        if ((0, $djcZD.isFedRamp)()) return new Promise((resolve)=>resolve({
                MediaToken: {
                    token: "",
                    baseUrl: ""
                }
            }));
        const { stargateRoot: stargateRoot } = (0, $1Bj4T.getConfig)();
        const url = `${stargateRoot}/api/user-image/header-image/write`;
        const data = await (0, $iDL5l.fetchApi)(url, {
            method: "GET"
        }).then((response)=>response.json()).then((data)=>({
                MediaToken: {
                    ...data
                }
            }));
        refQueryPromise.current = Promise.resolve(data);
        setState({
            headerImageId: data?.MediaToken?.headerImageId
        });
        return data;
    }, []);
    return {
        mediaClientConfig: {
            authProvider: async ()=>{
                // there is `headerImageId` in the new query
                let data = await refQueryPromise.current;
                // prevent race-condition
                if (!data.MediaToken || data === $0c1bc6c3dbf14138$var$getWriteTokenResultPlaceholder) data = await startGetWriteToken();
                return {
                    token: data.MediaToken?.token,
                    baseUrl: data?.MediaToken?.baseUrl,
                    clientId: (0, $1Bj4T.getConfig)().mediaApiClientId
                };
            },
            useSha256ForUploads: true
        },
        headerImageId: state.headerImageId,
        startGetWriteToken: startGetWriteToken
    };
}


const $37810c44f9801406$var$browserConfig = {
    multiple: false,
    fileExtensions: [
        ".jpg",
        ".png"
    ],
    uploadParams: {}
};
function $37810c44f9801406$export$2e2bcd8739ae039(props) {
    const { isOpen: isOpen, onStart: onStart, onEnd: onEnd, onClose: onClose, onError: onError } = props;
    const { mediaClientConfig: mediaClientConfig, headerImageId: headerImageId, startGetWriteToken: startGetWriteToken } = (0, $0c1bc6c3dbf14138$export$2e2bcd8739ae039)();
    const memoizedBrowserConfig = (0, $dAx5m.useMemo)(()=>{
        if (headerImageId) return {
            ...$37810c44f9801406$var$browserConfig,
            replaceFileId: headerImageId
        };
        return $37810c44f9801406$var$browserConfig;
    }, [
        headerImageId
    ]);
    // start fetching write token when the browser dialog opens.
    (0, $dAx5m.useEffect)(()=>{
        if (isOpen) startGetWriteToken();
    }, [
        isOpen,
        startGetWriteToken
    ]);
    return /*#__PURE__*/ (0, $bibO8.jsx)((0, $5ddd23bfb0293a7b$export$3ce634ac4a869e2c), {
        mediaClientConfig: mediaClientConfig,
        config: memoizedBrowserConfig,
        onUploadsStart: onStart,
        onEnd: onEnd,
        onClose: onClose,
        onError: onError,
        isOpen: isOpen
    });
}



var $4MHck = parcelRequire("4MHck");

var $iDL5l = parcelRequire("iDL5l");

var $1Bj4T = parcelRequire("1Bj4T");
const $605ea8121f1a9347$var$buildHeaderImageUrl = async (accountId)=>{
    const { stargateRoot: stargateRoot } = (0, $1Bj4T.getConfig)();
    const getUserHeaderImageToken = `${stargateRoot}/api/user-image/${accountId}/header-image/read`;
    const response = await (0, $iDL5l.fetchApi)(getUserHeaderImageToken, {
        method: "GET"
    });
    const { baseUrl: baseUrl, clientId: clientId, headerImageId: headerImageId, token: token } = await response.json();
    if (!headerImageId || !baseUrl || !clientId || !token) return null;
    const params = new URLSearchParams({
        allowAnimated: "false",
        width: "1500",
        mode: "fit",
        upscale: "false",
        token: token,
        client: clientId
    });
    return `${baseUrl}/file/${headerImageId}/image?${params.toString()}`;
};
var $605ea8121f1a9347$export$2e2bcd8739ae039 = $605ea8121f1a9347$var$buildHeaderImageUrl;


const $0bce8d34af332ae5$export$e72e825e7bcf3bd6 = "profileHeaderUserQueryKey";
const $0bce8d34af332ae5$var$profileHeaderUserQuery = async (userId)=>{
    const headerImageUrl = await (0, $605ea8121f1a9347$export$2e2bcd8739ae039)(userId);
    return {
        id: userId,
        headerImageUrl: headerImageUrl
    };
};
const $0bce8d34af332ae5$export$1c9f2b5dca0e3e1a = (userId)=>{
    const { data: data, isLoading: isLoading, isError: isError } = (0, $4MHck.useQuery)({
        queryKey: [
            $0bce8d34af332ae5$export$e72e825e7bcf3bd6,
            userId
        ],
        queryFn: ()=>$0bce8d34af332ae5$var$profileHeaderUserQuery(userId)
    });
    return {
        data: data,
        isLoading: isLoading,
        isError: isError
    };
};



var $atFkq = parcelRequire("atFkq");
var $132jP = parcelRequire("132jP");


var $iDL5l = parcelRequire("iDL5l");

var $1Bj4T = parcelRequire("1Bj4T");

var $djcZD = parcelRequire("djcZD");

const $cc0f1ca7f59eeb84$var$updateHeaderImageWithUserPrefCall = async ({ userId: userId, fields: fields })=>{
    // MediaApi is disabled in FedRamp
    if ((0, $djcZD.isFedRamp)()) return undefined;
    const { stargateRoot: stargateRoot } = (0, $1Bj4T.getConfig)();
    const updateUserHeaderImageUrl = `${stargateRoot}/api/user-image/self/header-image`;
    await (0, $iDL5l.fetchApi)(updateUserHeaderImageUrl, {
        method: "PUT",
        body: JSON.stringify({
            headerImageId: fields.headerImageId
        })
    });
    const headerImageUrl = await (0, $605ea8121f1a9347$export$2e2bcd8739ae039)(userId);
    return {
        data: {
            User: {
                id: userId,
                headerImageUrl: headerImageUrl
            }
        }
    };
};
var $cc0f1ca7f59eeb84$export$2e2bcd8739ae039 = $cc0f1ca7f59eeb84$var$updateHeaderImageWithUserPrefCall;


const $844a490d8816081d$var$updateUserProfileHeaderMutationFn = async (userId, fields)=>{
    return (0, $cc0f1ca7f59eeb84$export$2e2bcd8739ae039)({
        userId: userId,
        fields: fields
    });
};
const $844a490d8816081d$export$7c1278bdefa61c98 = (userId)=>{
    const queryClient = (0, $132jP.useQueryClient)();
    const queryKey = [
        (0, $0bce8d34af332ae5$export$e72e825e7bcf3bd6),
        userId
    ];
    const { isError: isError, isLoading: isLoading, mutateAsync: mutateAsync } = (0, $atFkq.useMutation)({
        onSuccess: async (data)=>{
            await queryClient.cancelQueries({
                queryKey: queryKey
            });
            // Optimistically update to the new state
            if (data) queryClient.setQueryData(queryKey, (old)=>({
                    ...old,
                    headerImageUrl: data.data.User.headerImageUrl
                }));
        },
        mutationFn: async (input)=>$844a490d8816081d$var$updateUserProfileHeaderMutationFn(userId, input)
    });
    return {
        isError: isError,
        isLoading: isLoading,
        mutateAsync: mutateAsync
    };
};



var $djcZD = parcelRequire("djcZD");
const $da5c8d4e2f06e8b4$var$REMOVE_IMAGE_ACTION = "removeHeaderImage";
const $da5c8d4e2f06e8b4$var$UPLOAD_IMAGE_ACTION = "uploadHeaderImage";
const $da5c8d4e2f06e8b4$export$fc19a6a35dec3265 = ({ addFlag: addFlag, hasRoundCorners: hasRoundCorners = false, height: height = 192, userId: userId, isEditable: isEditable = false })=>{
    const analytics = (0, $grRLU.default)();
    const { formatMessage: formatMessage } = (0, $dZHnD.default)();
    const { data: data, isLoading: isLoading, isError: isError } = (0, $0bce8d34af332ae5$export$1c9f2b5dca0e3e1a)(userId);
    const imgSrc = isLoading || isError ? "" : data?.headerImageUrl;
    const [isHovered, setIsHovered] = (0, $dAx5m.useState)(false);
    const [isMediaBrowserOpen, setIsMediaBrowserOpen] = (0, $dAx5m.useState)(false);
    const [isUploading, setIsUploading] = (0, $dAx5m.useState)(false);
    const [isDropdownOpen, setIsDropdownOpen] = (0, $dAx5m.useState)(false);
    const backdropComponentRef = (0, $dAx5m.useRef)(null);
    const { mutateAsync: updateUserProfile } = (0, $844a490d8816081d$export$7c1278bdefa61c98)(userId);
    const triggerOperationalEvents = (0, $dAx5m.useCallback)((action, attrs = {})=>{
        analytics.pushOperationalEvent({
            action: action,
            source: (0, $fjOHq.AnalyticsEventSource).MANAGE_ACCOUNT_PROFILE_AND_VISIBILITY_TAB,
            actionSubject: "headerImage",
            attributes: {
                ...attrs
            }
        });
    }, [
        analytics
    ]);
    const handleDropdownOpenChange = (0, $dAx5m.useCallback)(({ event: event, isOpen: isOpen })=>{
        setIsDropdownOpen(isOpen);
        if (backdropComponentRef.current && event.target instanceof Node && backdropComponentRef.current.contains(event.target)) setIsHovered(false);
    }, []);
    const handleUploadStart = (0, $dAx5m.useCallback)((event)=>{
        analytics.pushUIEvent({
            source: (0, $fjOHq.AnalyticsEventSource).MANAGE_ACCOUNT_PROFILE_AND_VISIBILITY_TAB,
            action: (0, $fjOHq.AnalyticsEventActions).CLICKED,
            actionSubject: "button",
            actionSubjectId: "profileHeaderMediaPickerUpload"
        });
        triggerOperationalEvents((0, $fjOHq.AnalyticsEventActions).STARTED, {
            actionType: $da5c8d4e2f06e8b4$var$UPLOAD_IMAGE_ACTION
        });
        setIsHovered(false);
        setIsUploading(true);
    }, [
        analytics,
        triggerOperationalEvents
    ]);
    /**
   * Uploading header image has 3 steps:
   * 1. Upload an actual image to media services via Browser of "@atlaskit/media-picker"
   * 2. Browser component returns an image id for us via "handleUploadEnd"
   * 3. We store the image id into our service via "pf-directory" service.
   * This function "handleUploadError" will handle errors for step 1 and step 3.
   */ const handleUploadError = (0, $dAx5m.useCallback)((event)=>{
        triggerOperationalEvents((0, $fjOHq.AnalyticsEventActions).FAILED, {
            actionType: $da5c8d4e2f06e8b4$var$UPLOAD_IMAGE_ACTION
        });
        // log info because we already tracked this error by above operational event.
        (0, $77YRX.logInfoMessage)("ProfileHeaderUploadError", {
            error: event.error
        });
        setIsUploading(false);
        addFlag({
            title: formatMessage({
                id: "ptc-directory.profile-header.error.title",
                defaultMessage: "Oops, something went wrong",
                description: "Title of an error notifcation. Notifies the user that saving their header image failed. Appears in the bottom/left corner."
            }),
            description: formatMessage({
                id: "ptc-directory.profile-header.error.message",
                defaultMessage: "We couldn\u2018t update your header image",
                description: "Message of an error notifcation. Notifies the user that saving their header image failed. Appears in the bottom/left corner."
            }),
            type: "error",
            id: "profile-header.upload.error"
        });
    }, [
        addFlag,
        formatMessage,
        triggerOperationalEvents
    ]);
    const handleUploadEnd = (0, $dAx5m.useCallback)(async (event)=>{
        // Checking for both file.id and public.id to make it work
        // for all media-picker versions in our peer dependency range
        const eventFileId = event && event.file && event.file.id;
        // @ts-ignore
        const eventPublicId = event && event.public && event.public.id;
        const uploadedFileId = eventFileId || eventPublicId;
        if (!uploadedFileId) (0, $77YRX.logErrorMessage)("ProfileHeaderUploadMissingIDError", {
            event: event
        });
        else try {
            await updateUserProfile({
                headerImageId: uploadedFileId
            });
            triggerOperationalEvents((0, $fjOHq.AnalyticsEventActions).SUCCEEDED, {
                actionType: $da5c8d4e2f06e8b4$var$UPLOAD_IMAGE_ACTION
            });
            setIsUploading(false);
        } catch (e) {
            handleUploadError({
                fileId: uploadedFileId,
                error: {
                    name: "upload_fail",
                    description: "failed to upload header image in profile and visibility page"
                }
            });
        }
    }, [
        handleUploadError,
        triggerOperationalEvents,
        updateUserProfile
    ]);
    const onRemoveImage = async ()=>{
        triggerOperationalEvents((0, $fjOHq.AnalyticsEventActions).STARTED, {
            actionType: $da5c8d4e2f06e8b4$var$REMOVE_IMAGE_ACTION
        });
        try {
            await updateUserProfile({
                headerImageId: null
            });
            triggerOperationalEvents((0, $fjOHq.AnalyticsEventActions).REMOVED, {
                actionType: $da5c8d4e2f06e8b4$var$REMOVE_IMAGE_ACTION
            });
        } catch (e) {
            triggerOperationalEvents((0, $fjOHq.AnalyticsEventActions).FAILED, {
                actionType: $da5c8d4e2f06e8b4$var$REMOVE_IMAGE_ACTION
            });
        }
        analytics.pushUIEvent({
            source: (0, $fjOHq.AnalyticsEventSource).MANAGE_ACCOUNT_PROFILE_AND_VISIBILITY_TAB,
            action: (0, $fjOHq.AnalyticsEventActions).CLICKED,
            actionSubject: "button",
            actionSubjectId: "profileHeaderRemove"
        });
        setIsHovered(false);
    };
    const onMouseEnter = ()=>{
        setIsHovered(true);
    };
    const onMouseLeave = (event)=>{
        /**
     * For mouseleave events, event.relatedTarget points to the element you
     * moved your mouse to. Browsers trigger mouseleave on-click with a null
     * relatedTarget for some reason. Each browser does it in its own selection
     * of weird scenarios.
     */ if (event.relatedTarget !== null) setIsHovered(isDropdownOpen);
    };
    const renderHoverOverlay = ()=>{
        const showHoverOverlay = isHovered && !isUploading && !(0, $djcZD.isFedRamp)();
        return /*#__PURE__*/ (0, $bibO8.jsxs)((0, $757qr.default), {
            onOpenChange: handleDropdownOpenChange,
            placement: "bottom",
            trigger: ({ triggerRef: triggerRef, ...triggerProps })=>/*#__PURE__*/ (0, $bibO8.jsxs)($6f4cb0cf4c6bfbcd$export$5b7e6a421a3df3e3, {
                    "data-testid": "hover-overlay",
                    isVisible: showHoverOverlay,
                    height: height,
                    hasRoundCorners: hasRoundCorners,
                    ...triggerProps,
                    children: [
                        /*#__PURE__*/ (0, $bibO8.jsx)($6f4cb0cf4c6bfbcd$export$e7eb525bc415b4b4, {
                            ref: triggerRef,
                            tabIndex: 0,
                            children: /*#__PURE__*/ (0, $bibO8.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7967255dc3264633$exports))), {
                                size: "large",
                                label: ""
                            })
                        }),
                        /*#__PURE__*/ (0, $bibO8.jsx)((0, $55TWT.default), {
                            ...imgSrc ? {
                                id: "ptc-directory.profile-header.action.update-image",
                                defaultMessage: "Update your header image",
                                description: "Call-to-action text to change the header image to the user profile. Shown to the user when they already have a header image set. Appears in the hover state of the header image on a person profile page."
                            } : {
                                id: "ptc-directory.profile-header.action.add-image",
                                defaultMessage: "Add your header image",
                                description: "Call-to-action text to add an header image to the user profile. Shown to the user when they do no have a current header image set. Appears in the hover state of the header image on a person profile page."
                            },
                            tagName: "p"
                        })
                    ]
                }),
            children: [
                /*#__PURE__*/ (0, $bibO8.jsx)((0, $cRCIP.default), {
                    onClick: ()=>setIsMediaBrowserOpen(true),
                    children: /*#__PURE__*/ (0, $bibO8.jsx)((0, $55TWT.default), {
                        id: "ptc-directory.profile-header.dropdown.add-image",
                        defaultMessage: "Upload an image",
                        description: "Dropmenu item text that when selected will let the user upload an image file to use as their new header image. Appears in the dropdown-menu that opens when the header image hover overlay is clicked."
                    })
                }),
                /*#__PURE__*/ (0, $bibO8.jsx)((0, $cRCIP.default), {
                    isDisabled: !imgSrc,
                    onClick: onRemoveImage,
                    children: /*#__PURE__*/ (0, $bibO8.jsx)((0, $55TWT.default), {
                        id: "ptc-directory.profile-header.dropdown.remove-image",
                        defaultMessage: "Remove image",
                        description: "Dropmenu item text that when selected will remove the users current header image. Appears in the dropdown-menu that opens when the header image hover overlay is clicked."
                    })
                })
            ]
        });
    };
    const getBackdropProps = ()=>{
        if (!isEditable) return {};
        return {
            onMouseEnter: onMouseEnter,
            onFocus: onMouseEnter,
            onMouseLeave: onMouseLeave,
            onBlur: onMouseLeave
        };
    };
    return /*#__PURE__*/ (0, $bibO8.jsxs)($6f4cb0cf4c6bfbcd$export$8b251419efc915eb, {
        height: height,
        children: [
            /*#__PURE__*/ (0, $bibO8.jsxs)($6f4cb0cf4c6bfbcd$export$698223c589197ab7, {
                ...getBackdropProps(),
                height: height,
                ref: backdropComponentRef,
                children: [
                    /*#__PURE__*/ (0, $bibO8.jsx)((0, $eac5bcc1cba7cde9$export$2e2bcd8739ae039), {
                        hasRoundCorners: hasRoundCorners,
                        height: height,
                        imgSrc: imgSrc,
                        isUploading: isUploading || isLoading,
                        userId: userId
                    }),
                    renderHoverOverlay()
                ]
            }),
            isEditable && /*#__PURE__*/ (0, $bibO8.jsx)((0, $37810c44f9801406$export$2e2bcd8739ae039), {
                onError: handleUploadError,
                onStart: handleUploadStart,
                onEnd: handleUploadEnd,
                onClose: ()=>{
                    setIsMediaBrowserOpen(false);
                },
                isOpen: isMediaBrowserOpen
            })
        ]
    });
};





var $dnae4 = parcelRequire("dnae4");

var $84bHK = parcelRequire("84bHK");
const $35a8ad5fe1a3bec9$export$82a6f3ee677bdbfe = ({ addFlag: addFlag, onPrivacyLevelChange: onPrivacyLevelChange, privacyLevel: privacyLevel, privacyLevelOptions: privacyLevelOptions, userId: userId })=>{
    const { myAvatar: myAvatar, isLoading: myAvatarIsLoading, isError: myAvatarIsError } = (0, $84bHK.useMyAvatar)(userId);
    const definitelyNoPicture = myAvatar?.uploaded === false;
    const disabled = !myAvatarIsLoading && !myAvatarIsError && definitelyNoPicture;
    return /*#__PURE__*/ (0, $bibO8.jsxs)($46749c245b4fca20$export$331c6cd8ec3669f5, {
        children: [
            /*#__PURE__*/ (0, $bibO8.jsx)($46749c245b4fca20$export$85bb4e680e162cd4, {
                children: /*#__PURE__*/ (0, $bibO8.jsx)((0, $da5c8d4e2f06e8b4$export$fc19a6a35dec3265), {
                    userId: userId,
                    height: 112,
                    addFlag: addFlag,
                    hasRoundCorners: true,
                    isEditable: true
                })
            }),
            /*#__PURE__*/ (0, $bibO8.jsx)($46749c245b4fca20$export$f7513421c53ce141, {
                children: /*#__PURE__*/ (0, $bibO8.jsx)((0, $8zYsB.default), {
                    size: (0, $dnae4.AvatarSize).xlarge,
                    userId: userId,
                    addFlag: addFlag
                })
            }),
            /*#__PURE__*/ (0, $bibO8.jsx)($46749c245b4fca20$export$6ce170286acaa8d3, {
                children: /*#__PURE__*/ (0, $bibO8.jsxs)($46749c245b4fca20$export$bf637fea4836207d, {
                    children: [
                        /*#__PURE__*/ (0, $bibO8.jsxs)($46749c245b4fca20$export$4bb0b7f9b6c7db0e, {
                            children: [
                                /*#__PURE__*/ (0, $bibO8.jsx)((0, $55TWT.default), {
                                    id: "ptc-directory.profile-and-privacy-settings.avatar-and-header-image.who-can-see-your-profile-photo",
                                    defaultMessage: "Who can see your profile photo?",
                                    description: "A description for the dropdown that controls the privacy level of the user\u02BCs avatar"
                                }),
                                /*#__PURE__*/ (0, $bibO8.jsx)((0, $aocz5.default), {
                                    appearance: "dark",
                                    message: /*#__PURE__*/ (0, $bibO8.jsx)((0, $55TWT.default), {
                                        id: "ptc-directory.profile-and-privacy-settings.avatar-and-header-image.help-info",
                                        defaultMessage: "Your visibility setting only applies to your profile photo. Your header image is always visible to anyone.",
                                        description: "Pop up information to ensure the user is aware that the privacy level does not affect their header image"
                                    }),
                                    position: "bottom-end"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $bibO8.jsx)((0, $53f3c3d3af589157$export$2e2bcd8739ae039), {
                            disabledMessage: disabled && /*#__PURE__*/ (0, $bibO8.jsx)((0, $55TWT.default), {
                                id: "ptc-directory.profile-and-privacy-settings.avatar-and-header-image.disabled",
                                defaultMessage: "If you upload a profile picture, you\u2019ll be able to select who can see it.",
                                description: "Pop up information to inform user that they cannot change the visibility of their profile picture as they do not have one uploaded"
                            }),
                            options: privacyLevelOptions,
                            privacyLevel: disabled ? (0, $1ea2b1c5db3c4b56$export$598b17d3c675a75).PUBLIC : privacyLevel,
                            onChange: onPrivacyLevelChange
                        })
                    ]
                })
            })
        ]
    });
};
var $35a8ad5fe1a3bec9$export$2e2bcd8739ae039 = $35a8ad5fe1a3bec9$export$82a6f3ee677bdbfe;


const $abfebf73c75bae2c$var$mapDispatchToProps = (dispatch)=>({
        addFlag: (flag)=>dispatch((0, $3kXiv.addFlag)(flag))
    });
var $abfebf73c75bae2c$export$2e2bcd8739ae039 = (0, $7PWYP.default)(undefined, $abfebf73c75bae2c$var$mapDispatchToProps)((0, $35a8ad5fe1a3bec9$export$2e2bcd8739ae039));




parcelRequire("jQGCp");
var $7PWYP = parcelRequire("7PWYP");

var $bibO8 = parcelRequire("bibO8");

var $dAx5m = parcelRequire("dAx5m");

var $lKhJJ = parcelRequire("lKhJJ");
var $55TWT = parcelRequire("55TWT");
var $dZHnD = parcelRequire("dZHnD");
parcelRequire("jShba");
var $fjOHq = parcelRequire("fjOHq");
var $52IGI = parcelRequire("52IGI");
var $77YRX = parcelRequire("77YRX");
var $8hGiD = parcelRequire("8hGiD");
var $58n8k = parcelRequire("58n8k");


var $bibO8 = parcelRequire("bibO8");
parcelRequire("dAx5m");

var $55TWT = parcelRequire("55TWT");

var $h1Uju = parcelRequire("h1Uju");


var $h1Uju = parcelRequire("h1Uju");

var $jXcEr = parcelRequire("jXcEr");
parcelRequire("jShba");
var $1UxEK = parcelRequire("1UxEK");
var $52IGI = parcelRequire("52IGI");
var $1Bj4T = parcelRequire("1Bj4T");
const $71f6d1a7732aad6b$var$getAnchorProps = (endPoint, { isSPA: isSPA } = {
    isSPA: true
})=>{
    const url = isSPA ? endPoint : `${(0, $1Bj4T.getConfig)().atlassianAccountUrl}${endPoint}`;
    return isSPA ? {
        to: url
    } : {
        target: "_blank",
        href: url
    };
};
const $71f6d1a7732aad6b$export$831975966e6543c3 = (formatMessage, { isSPA: isSPA } = {
    isSPA: true
})=>{
    const anchorProps = $71f6d1a7732aad6b$var$getAnchorProps("/manage-profile/account-preferences", {
        isSPA: isSPA
    });
    return /*#__PURE__*/ (0, $bibO8.jsx)((0, $52IGI.default), {
        message: /*#__PURE__*/ (0, $bibO8.jsxs)((0, $bibO8.Fragment), {
            children: [
                /*#__PURE__*/ (0, $bibO8.jsx)((0, $55TWT.default), {
                    id: "ptc-directory.settings.profile-and-visibility.details.local.time",
                    defaultMessage: "Go to the Account preferences tab to manage your time zone.",
                    description: "A message displayed when user is hovering a field to edit their local time value that can not be edited"
                }),
                /*#__PURE__*/ (0, $bibO8.jsx)("p", {
                    children: /*#__PURE__*/ (0, $bibO8.jsx)((0, $1UxEK.default), {
                        ...anchorProps,
                        children: /*#__PURE__*/ (0, $bibO8.jsx)((0, $55TWT.default), {
                            id: "ptc-directory.settings.profile-and-visibility.details.manage.time.zone",
                            defaultMessage: "Manage your time zone",
                            description: 'A link name which points to Account preferences: "/manage-profile/account-preferences" to edit timezone'
                        })
                    })
                })
            ]
        })
    });
};
const $71f6d1a7732aad6b$var$isManagedNextMessage = ()=>{
    return /*#__PURE__*/ (0, $bibO8.jsx)((0, $55TWT.default), {
        id: "ptc-directory.settings.profile-and-visibility.details.managed-account.nickname.info.xml",
        defaultMessage: "Your display name on Atlassian public forums, such as Atlassian Community. {br} Also used if you restrict the visibility of <strong>Full name</strong>.",
        description: "Detailed explanation to a managed user's public name field",
        tagName: "span",
        values: {
            // eslint-disable-next-line react/display-name
            strong: (chunks)=>/*#__PURE__*/ (0, $bibO8.jsx)("strong", {
                    children: chunks
                }),
            br: /*#__PURE__*/ (0, $bibO8.jsx)("br", {})
        }
    });
};
const $71f6d1a7732aad6b$export$5e097831852eb087 = ({ formatMessage: formatMessage, isManaged: isManaged })=>{
    return {
        [(0, $h1Uju.FieldType).FullName]: {
            label: formatMessage({
                id: "pf-home.profile-edit-form.label.fullName",
                defaultMessage: "Full name",
                description: "Label for the input field for the users full name"
            }),
            placeholder: formatMessage({
                id: "pf-home.profile-edit-form.placeholder.fullName",
                defaultMessage: "Your name",
                description: "Placeholder text displayed in an empty input field for the users full name"
            }),
            disabled: /*#__PURE__*/ (0, $bibO8.jsx)((0, $52IGI.default), {
                message: formatMessage({
                    id: "ptc-directory.settings.profile-and-visibility.details.full-name.disabled-eading",
                    defaultMessage: "Full name is set by your admin.",
                    description: "A message displayed when user is hovering a field to edit full name value that can not be edited"
                })
            }),
            privacy: {
                key: "name"
            },
            isRequired: true,
            requiredInvalidMessage: formatMessage({
                id: "pf-home.profile-edit-form.required.invalid.fullName",
                defaultMessage: "Full name is required",
                description: "A message when full name field is empty"
            })
        },
        [(0, $h1Uju.FieldType).Nickname]: {
            label: formatMessage({
                id: "pf-home.profile-edit-form.label.nickname",
                defaultMessage: "Public name",
                description: "Label for the input field for the users nickname (now called Public name)"
            }),
            placeholder: formatMessage({
                id: "pf-home.profile-edit-form.placeholder.nickname",
                defaultMessage: "Your public name",
                description: "Placeholder text displayed in an empty input field for the users nickname (now called Public name)"
            }),
            info: isManaged ? $71f6d1a7732aad6b$var$isManagedNextMessage() : /*#__PURE__*/ (0, $bibO8.jsx)((0, $55TWT.default), {
                id: "ptc-directory.settings.profile-and-visibility.details.unmanaged-account.nickname.info",
                defaultMessage: "Your display name on Atlassian public forums, such as Atlassian Community.",
                description: "Detailed explanation to a unmanaged user's public name field",
                tagName: "span"
            }),
            privacy: {
                key: "nickname"
            },
            isRequired: true,
            requiredInvalidMessage: formatMessage({
                id: "pf-home.profile-edit-form.required.invalid.nickname",
                defaultMessage: "Public name is required",
                description: "A message when public name field is empty"
            })
        },
        [(0, $h1Uju.FieldType).Title]: {
            label: formatMessage({
                id: "pf-home.profile-edit-form.label.title",
                defaultMessage: "Job title",
                description: "Label for the input field for the users job title/occupation"
            }),
            placeholder: formatMessage({
                id: "pf-home.profile-edit-form.placeholder.title",
                defaultMessage: "Your job title",
                description: "Placeholder text displayed in an empty input field for the users job title/occupation"
            }),
            disabled: /*#__PURE__*/ (0, $bibO8.jsx)((0, $52IGI.default), {
                message: formatMessage({
                    id: "ptc-directory.settings.profile-and-visibility.details.title.managed",
                    defaultMessage: "Job title is set by your admin.",
                    description: "A message displayed when user is hovering a field to edit their job title value that can not be edited"
                })
            }),
            privacy: {
                key: "jobTitle"
            }
        },
        [(0, $h1Uju.FieldType).Department]: {
            label: formatMessage({
                id: "pf-home.profile-edit-form.label.department",
                defaultMessage: "Department",
                description: "Label for the input field describing the department/division a user is a member of"
            }),
            placeholder: formatMessage({
                id: "pf-home.profile-edit-form.placeholder.department",
                defaultMessage: "Your department",
                description: "Placeholder text displayed in an empty input field for the users department/division"
            }),
            disabled: /*#__PURE__*/ (0, $bibO8.jsx)((0, $52IGI.default), {
                message: formatMessage({
                    id: "ptc-directory.settings.profile-and-visibility.details.department.managed",
                    defaultMessage: "Department is set by your admin.",
                    description: "A message displayed when user is hovering a field to edit the deparment value that can not be edited"
                })
            }),
            privacy: {
                key: "department"
            }
        },
        [(0, $h1Uju.FieldType).CompanyName]: {
            label: formatMessage({
                id: "pf-home.profile-edit-form.label.companyName",
                defaultMessage: "Organization",
                description: "Label for the input field describing the company/business a user is a member of"
            }),
            placeholder: formatMessage({
                id: "pf-home.profile-edit-form.placeholder.companyName",
                defaultMessage: "Your organization",
                description: "Placeholder text displayed in an empty input field for the users company"
            }),
            disabled: /*#__PURE__*/ (0, $bibO8.jsx)((0, $52IGI.default), {
                message: formatMessage({
                    id: "ptc-directory.settings.profile-and-visibility.details.organisation.managed",
                    defaultMessage: "Organization is set by your admin.",
                    description: "A message displayed when user is hovering a field to edit their organisation value that can not be edited"
                })
            }),
            privacy: {
                key: "organization"
            }
        },
        [(0, $h1Uju.FieldType).Location]: {
            label: formatMessage({
                id: "pf-home.profile-edit-form.label.location",
                defaultMessage: "Based in",
                description: `Label name to for the field representing the user's domicile.
          The location can be both a city and/or country.
          E.g. "Based in Sydney, Australia" or "Based in Australia"`
            }),
            placeholder: formatMessage({
                id: "pf-home.profile-edit-form.placeholder.location",
                defaultMessage: "Your location",
                description: `Placeholder text displayed in an empty input field for the users location.
        The location can be both a city and/or country.
        E.g. "Based in Sydney, Australia" or "Based in Australia"`
            }),
            privacy: {
                key: "location"
            }
        },
        [(0, $h1Uju.FieldType).Timezone]: {
            label: formatMessage({
                id: "pf-home.profile-edit-form.label.timezone",
                defaultMessage: "Time zone",
                description: "Label for the input field for the users time zone"
            }),
            placeholder: formatMessage({
                id: "pf-home.profile-edit-form.placeholder.timezone",
                defaultMessage: "Your time zone",
                description: "Placeholder text displayed in an empty input field for the users time zone"
            }),
            inputType: (0, $jXcEr.FieldInputType).Timezone,
            privacy: {
                key: "zoneinfo"
            }
        },
        [(0, $h1Uju.FieldType).LocalTime]: {
            label: formatMessage({
                id: "pf-home.profile-edit-form.label.localTime",
                defaultMessage: "Local time",
                description: "Label for the input field for the users local time"
            }),
            placeholder: formatMessage({
                id: "pf-home.profile-edit-form.placeholder.localTime",
                defaultMessage: "You have not set your time zone yet",
                description: ""
            }),
            // this is read-ony field
            disabled: $71f6d1a7732aad6b$export$831975966e6543c3(formatMessage),
            // this is same as above timezone field so that user still can change visibility of timezone here.
            privacy: {
                key: "zoneinfo"
            }
        },
        [(0, $h1Uju.FieldType).Email]: {
            label: formatMessage({
                id: "pf-home.profile-edit-form.label.email",
                defaultMessage: "Email address",
                description: "Label for the input field for the users email address"
            }),
            placeholder: formatMessage({
                id: "pf-home.profile-edit-form.placeholder.email",
                defaultMessage: "Your email address",
                description: "Placeholder text displayed in an empty input field for the users email address"
            }),
            managed: /*#__PURE__*/ (0, $bibO8.jsx)((0, $52IGI.default), {
                message: formatMessage({
                    id: "ptc-directory.settings.profile-and-visibility.details.email.managed",
                    defaultMessage: "Email address is set by your admin",
                    description: "Message displayed in the inline dialog in case users email is readonly as it is managed by administrator"
                })
            }),
            disabled: /*#__PURE__*/ (0, $bibO8.jsx)((0, $52IGI.default), {
                message: /*#__PURE__*/ (0, $bibO8.jsxs)((0, $bibO8.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $bibO8.jsx)((0, $55TWT.default), {
                            id: "ptc-directory.settings.profile-and-visibility.details.email.disabled-body",
                            defaultMessage: "Go to the Email tab to manage your email address.",
                            description: "A message displayed when user is hovering a field to edit an email value that can not be edited"
                        }),
                        /*#__PURE__*/ (0, $bibO8.jsx)("p", {
                            children: /*#__PURE__*/ (0, $bibO8.jsx)((0, $1UxEK.default), {
                                ...$71f6d1a7732aad6b$var$getAnchorProps("/manage-profile/email"),
                                children: /*#__PURE__*/ (0, $bibO8.jsx)((0, $55TWT.default), {
                                    id: "ptc-directory.settings.profile-and-visibility.details.manage.email",
                                    defaultMessage: "Manage your email address",
                                    description: 'A link name which points to Email preferences: "/manage-profile/email" to edit the email address'
                                })
                            })
                        })
                    ]
                })
            }),
            privacy: {
                key: "email"
            }
        },
        [(0, $h1Uju.FieldType).PhoneNumber]: {
            label: formatMessage({
                id: "pf-home.profile-edit-form.label.phone",
                defaultMessage: "Phone number",
                description: "Label for the input field for the users phone number"
            }),
            placeholder: formatMessage({
                id: "pf-home.profile-edit-form.placeholder.phone",
                defaultMessage: "Your phone number",
                description: "Placeholder text displayed in an empty input field for the users phone number"
            }),
            privacy: {
                key: "phoneNumber"
            }
        }
    };
};



var $ku6eE = parcelRequire("ku6eE");

var $5MUVm = parcelRequire("5MUVm");
var $9HXRO = parcelRequire("9HXRO");

var $gbKg7 = parcelRequire("gbKg7");
const $015d5f3538fef5ed$export$48dfc27bd5e0db48 = (0, $ku6eE.default).p`
  ${(0, $9HXRO).h500};
  margin: 0 ${(0, $gbKg7.default)("space.200", "16px")} ${(0, $gbKg7.default)("space.250", "20px")};
`;
const $015d5f3538fef5ed$export$11154b700737b45e = (0, $ku6eE.default).div`
  padding: ${(0, $gbKg7.default)("space.250", "20px")} ${(0, $gbKg7.default)("space.200", "16px")};
  border-radius: ${(0, $gbKg7.default)("border.radius.100", "3px")};

  box-shadow: ${(0, $gbKg7.default)("elevation.shadow.raised", "0px 1px 1px #091E4240, 0px 0px 1px #091E424F")};
  background: ${(0, $gbKg7.default)("elevation.surface.raised", (0, $5MUVm).N0)};
`;
const $015d5f3538fef5ed$export$125d0b248abd3e88 = (0, $ku6eE.default).div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;
const $015d5f3538fef5ed$export$5332de0fc8541e26 = (0, $ku6eE.default).div`
  font-size: 11px;
  padding-left: ${(0, $gbKg7.default)("space.100", "8px")};
  margin-bottom: -${(0, $gbKg7.default)("space.250", "20px")};
  color: ${(0, $gbKg7.default)("color.text.subtlest", (0, $5MUVm).N200)};
  line-height: ${(0, $gbKg7.default)("space.200", "16px")};
  width: 200px;
  float: right;
`;
const $015d5f3538fef5ed$export$b59bdbef9ce70de2 = (0, $ku6eE.default).div`
  display: flex;
  & + & {
    margin-top: ${(0, $gbKg7.default)("space.300", "24px")};
  }
`;
const $015d5f3538fef5ed$export$a455218a85c89869 = (0, $ku6eE.default).div`
  flex-grow: 1;
  margin-left: ${(0, $gbKg7.default)("space.100", "8px")};
`;
const $015d5f3538fef5ed$export$4116d2d68d556877 = (0, $ku6eE.default).div`
  width: 200px;
  margin-left: ${(0, $gbKg7.default)("space.400", "32px")};
  align-self: flex-end;
`;



var $h1Uju = parcelRequire("h1Uju");

var $lKhJJ = parcelRequire("lKhJJ");
const $cb943aca4e923589$export$2c4debe2420ba3a5 = (0, $lKhJJ.defineMessages)({
    fullName: {
        id: "ptc-directory.settings.profile-and-visibility.privacy-dropdown.full-name.disabled",
        defaultMessage: "The full name you provide is visible to anyone who can view your content, including people outside of your organization. Accessible by installed apps.",
        description: "Message shown on hover of disabled visibility selector explaining that the users full name will be available publicly if the user provides it"
    },
    nickname_managed: {
        id: "ptc-directory.settings.profile-and-visibility.privacy-dropdown.nickname.disabled.managed-account.xml",
        defaultMessage: "Always visible on Atlassian public forums, such as Atlassian Community. {br}If you restrict the visibility of <strong>Full name</strong>, people who can\u2019t view your full name see your public name instead. (This also applies to apps when they can\u2019t access your full name.)",
        description: "Message shown on hover of disabled visibility selector explaining that the users public name will be available publicly if the user provides it"
    },
    nickname_unmanaged: {
        id: "ptc-directory.settings.profile-and-visibility.privacy-dropdown.nickname.disabled.unmanaged-account",
        defaultMessage: "The public name you provide is visible on Atlassian public forums, such as Atlassian Community.",
        description: "Message shown on hover of disabled visibility selector explaining that the users public name will be available publicly if the user provides it"
    },
    title: {
        id: "ptc-directory.settings.profile-and-visibility.privacy-dropdown.title.disabled",
        defaultMessage: "If you provide a job title, it will be visible to anyone who can view your content, including people outside of your organization. Accessible by installed apps.",
        description: "Message shown on hover of disabled visibility selector explaining that the users job title will be available publicly if the user provides it"
    },
    department: {
        id: "ptc-directory.settings.profile-and-visibility.privacy-dropdown.department.disabled",
        defaultMessage: "If you provide a department, it will be visible to anyone who can view your content, including people outside of your organization. Accessible by installed apps.",
        description: "Message shown on hover of disabled visibility selector explaining that the users department will be available publicly if the user provides it"
    },
    companyName: {
        id: "ptc-directory.settings.profile-and-visibility.privacy-dropdown.company-name.disabled",
        defaultMessage: "If you provide an organization, it will be visible to anyone who can view your content, including people outside of your organization. Accessible by installed apps.",
        description: "Message shown on hover of disabled visibility selector explaining that the users company name will be available publicly if the user provides it"
    }
});



var $awtnL = parcelRequire("awtnL");
const $dab36eb65b250ef1$var$managedFields = [
    (0, $h1Uju.FieldType).Email,
    (0, $h1Uju.FieldType).FullName,
    (0, $h1Uju.FieldType).Title,
    (0, $h1Uju.FieldType).Department,
    (0, $h1Uju.FieldType).CompanyName
];
const $dab36eb65b250ef1$export$ee2bfabdcc1fad1d = [
    // users cannot update local time in UI
    (0, $h1Uju.FieldType).LocalTime
];
const $dab36eb65b250ef1$export$210df1bbf71b0cd1 = [
    // users cannot update local time in UI
    (0, $h1Uju.FieldType).LocalTime,
    (0, $h1Uju.FieldType).Email
];
const $dab36eb65b250ef1$var$PROFILE_DETAILS_SUBMIT_ERROR_FLAG = "PROFILE_DETAILS_SUBMIT_ERROR_FLAG";
const $dab36eb65b250ef1$var$PROFILE_DETAILS_SUBMIT_SUCCESS_FLAG = "PROFILE_DETAILS_SUBMIT_SUCCESS_FLAG";
const $dab36eb65b250ef1$var$ProfileDetailsForm = ({ addFlag: addFlag, analytics: analytics, fieldTypes: fieldTypes, isManaged: isManaged, onPrivacyLevelChange: onPrivacyLevelChange, onSubmit: onSubmit, privacyOptions: privacyOptions, privacyValues: privacyValues, usersOrg: usersOrg, values: values, userId: userId })=>{
    const { data: data, isError: isError, isLoading: isLoading } = (0, $awtnL.useProfileDetailsMutabilityConstraints)(userId);
    const { formatMessage: formatMessage } = (0, $dZHnD.default)();
    const externallyManagedFields = (0, $dAx5m.useMemo)(()=>data?.map((constraint)=>constraint?.field), [
        data
    ]);
    const formFields = (0, $dAx5m.useMemo)(()=>(0, $71f6d1a7732aad6b$export$5e097831852eb087)({
            formatMessage: formatMessage,
            isManaged: isManaged
        }), [
        formatMessage,
        isManaged
    ]);
    const getPrivacyLevelChangeHandler = (fieldKey)=>(value)=>onPrivacyLevelChange(fieldKey, value);
    const getSubmitHandler = (0, $dAx5m.useCallback)((fieldKey)=>async (value)=>{
            try {
                await onSubmit({
                    [fieldKey]: value
                });
                analytics.pushTrackEvent({
                    source: (0, $fjOHq.AnalyticsEventSource).MANAGE_ACCOUNT_PROFILE_AND_VISIBILITY_TAB,
                    actionSubject: "profileAboutItem",
                    action: (0, $fjOHq.AnalyticsEventActions).EDITED,
                    attributes: {
                        fieldKey: fieldKey
                    }
                });
                addFlag({
                    type: "success",
                    title: formatMessage($dab36eb65b250ef1$export$ffdda8067b36a26d[fieldKey]),
                    description: formatMessage({
                        id: "ptc-directory.user-profile-page.about.error-flag.change-propagation-takes-time",
                        defaultMessage: "Your change might take a while to show everywhere",
                        description: "The error message description shown after a user info is edited, mostly about changes not being visible everywhere immediately"
                    }),
                    id: $dab36eb65b250ef1$var$PROFILE_DETAILS_SUBMIT_SUCCESS_FLAG
                });
            } catch (err) {
                (0, $77YRX.logException)(err, "Submission failed in ProfileDetailsForm");
                addFlag({
                    type: "error",
                    title: formatMessage($dab36eb65b250ef1$export$b9a7f1ebeaa76953[fieldKey]),
                    description: formatMessage({
                        id: "ptc-directory.settings.profile-and-visibility.details.try-again-later",
                        defaultMessage: "Try again later",
                        description: "The error message description for when a field edit fails. Appears under the title in a notification flag when a field edit fails."
                    }),
                    id: $dab36eb65b250ef1$var$PROFILE_DETAILS_SUBMIT_ERROR_FLAG
                });
            }
        }, [
        addFlag,
        analytics,
        formatMessage,
        onSubmit
    ]);
    const renderPrivacyDropdown = (type)=>{
        // When rendering visibility dropdown for local time field,
        // we want to render visibility dropdown for time zone instead
        const fieldType = type === (0, $h1Uju.FieldType).LocalTime ? (0, $h1Uju.FieldType).Timezone : type;
        const fieldData = formFields[fieldType];
        const privacyLevels = privacyOptions[fieldData.privacy.key];
        const privacyLevelValue = (0, $53f3c3d3af589157$export$52a249bf80a4235b)[privacyValues[fieldData.privacy.key]];
        const isDisabled = !privacyLevels || privacyLevels.length === 1;
        return /*#__PURE__*/ (0, $bibO8.jsx)((0, $53f3c3d3af589157$export$2e2bcd8739ae039), {
            disabledMessage: isDisabled ? renderDisabledMessageForPrivacyDropdown(fieldType) : null,
            options: (0, $423263b1288ad8f8$export$abc9c3081c48e7ff)(fieldType, privacyLevels || undefined, {
                orgName: usersOrg,
                isManaged: isManaged
            }),
            privacyLevel: privacyLevelValue,
            onChange: getPrivacyLevelChangeHandler(fieldType)
        });
    };
    const renderFormRow = (type, idx)=>{
        const value = values[type];
        const fieldData = formFields[type];
        const canBeEmpty = $dab36eb65b250ef1$export$ee2bfabdcc1fad1d.includes(type);
        const cantUpdateYet = $dab36eb65b250ef1$export$210df1bbf71b0cd1.includes(type);
        const isFieldManaged = externallyManagedFields && externallyManagedFields.includes(type) || // Based on actual data from Identity
        isManaged && $dab36eb65b250ef1$var$managedFields.includes(type); // Based on our best guess during initial render
        const isReadOnly = isFieldManaged || cantUpdateYet || isLoading || isError;
        if (value && cantUpdateYet && !canBeEmpty && !value.edit) return null;
        return /*#__PURE__*/ (0, $bibO8.jsxs)($015d5f3538fef5ed$export$b59bdbef9ce70de2, {
            children: [
                /*#__PURE__*/ (0, $bibO8.jsx)($015d5f3538fef5ed$export$a455218a85c89869, {
                    children: /*#__PURE__*/ (0, $bibO8.jsx)((0, $8hGiD.default), {
                        "data-testid": `testId_${type}`,
                        isReadOnly: isReadOnly,
                        label: fieldData.label,
                        placeholder: fieldData.placeholder,
                        value: value?.edit || "",
                        readValue: value?.read || "",
                        onSubmit: getSubmitHandler(type),
                        inputType: fieldData.inputType,
                        infoHelperMessage: fieldData.info,
                        inlineDialogContent: isManaged && isFieldManaged && fieldData.managed || isReadOnly && fieldData.disabled,
                        inlineDialogContentPosition: "bottom-start",
                        isRequired: fieldData.isRequired,
                        requiredInvalidMessage: fieldData.requiredInvalidMessage
                    })
                }),
                /*#__PURE__*/ (0, $bibO8.jsx)($015d5f3538fef5ed$export$4116d2d68d556877, {
                    "data-test-selector": `visibility-wrapper-${type.toLowerCase()}`,
                    children: renderPrivacyDropdown(type)
                })
            ]
        }, idx);
    };
    const renderDisabledMessageForPrivacyDropdown = (fieldType)=>{
        const message = (0, $cb943aca4e923589$export$2c4debe2420ba3a5)[fieldType] || (0, $cb943aca4e923589$export$2c4debe2420ba3a5)[`${fieldType}_${isManaged ? "managed" : "unmanaged"}`];
        if (!message) return null;
        return /*#__PURE__*/ (0, $bibO8.jsx)((0, $52IGI.default), {
            message: /*#__PURE__*/ (0, $bibO8.jsx)((0, $55TWT.default), {
                ...message,
                values: {
                    br: /*#__PURE__*/ (0, $bibO8.jsx)("br", {}),
                    strong: (chunks)=>/*#__PURE__*/ (0, $bibO8.jsx)("strong", {
                            children: chunks
                        })
                }
            })
        });
    };
    return /*#__PURE__*/ (0, $bibO8.jsxs)($015d5f3538fef5ed$export$11154b700737b45e, {
        children: [
            /*#__PURE__*/ (0, $bibO8.jsx)($015d5f3538fef5ed$export$5332de0fc8541e26, {
                children: /*#__PURE__*/ (0, $bibO8.jsx)((0, $55TWT.default), {
                    id: "ptc-directory.settings.profile-and-visibility.details.form-label",
                    defaultMessage: "Who can see this?",
                    description: "A text of a label above the visibility dropdowns"
                })
            }),
            /*#__PURE__*/ (0, $bibO8.jsx)($015d5f3538fef5ed$export$125d0b248abd3e88, {
                children: fieldTypes.map((type, idx)=>renderFormRow(type, idx))
            })
        ]
    });
};
var $dab36eb65b250ef1$export$2e2bcd8739ae039 = (0, $58n8k.default)($dab36eb65b250ef1$var$ProfileDetailsForm);
const $dab36eb65b250ef1$export$ffdda8067b36a26d = (0, $lKhJJ.defineMessages)({
    nickname: {
        id: "ptc-directory.user-profile-page.about.success-flag.nickname.title",
        defaultMessage: "You\u2019ve updated your public name",
        description: "The success message title for when editing the public name succeeded. Appears at the title of the notification flag upon a successful save."
    },
    fullName: {
        id: "ptc-directory.user-profile-page.about.success-flag.fullName.title",
        defaultMessage: "You\u2019ve updated your full name",
        description: "The success message title for when editing the full name succeeded. Appears at the title of the notification flag upon a successful save."
    },
    title: {
        id: "ptc-directory.user-profile-page.about.success-flag.title.title",
        defaultMessage: "You\u2019ve updated your job title",
        description: "The success message title for when editing the description succeeded. Appears at the title of the notification flag upon a successful save."
    },
    department: {
        id: "ptc-directory.user-profile-page.about.success-flag.department.title",
        defaultMessage: "You\u2019ve updated your department",
        description: "The success message title for when editing the department succeeded. Appears at the title of the notification flag upon a successful save."
    },
    companyName: {
        id: "ptc-directory.user-profile-page.about.success-flag.companyName.title",
        defaultMessage: "You\u2019ve updated your organization",
        description: "The success message title for when editing the organization succeeded. Appears at the title of the notification flag upon a successful save."
    },
    location: {
        id: "ptc-directory.user-profile-page.about.success-flag.location.title",
        defaultMessage: "You\u2019ve updated your location",
        description: "The success message title for when editing the location succeeded. Appears at the title of the notification flag upon a successful save."
    },
    timezone: {
        id: "ptc-directory.user-profile-page.about.success-flag.timezone.title",
        defaultMessage: "You\u2019ve updated your time zone",
        description: "The success message title for when editing the timezone succeeded. Appears at the title of the notification flag upon a successful save."
    },
    email: {
        id: "ptc-directory.user-profile-page.about.success-flag.email.title",
        defaultMessage: "You\u2019ve updated your email address",
        description: "The success message title for when editing the email address succeeded. Appears at the title of the notification flag upon a successful save."
    },
    phoneNumber: {
        id: "ptc-directory.user-profile-page.about.success-flag.phone.title",
        defaultMessage: "You\u2019ve updated your phone number",
        description: "The success message title for when editing the phone number succeeded. Appears at the title of the notification flag upon a successful save."
    }
});
const $dab36eb65b250ef1$export$b9a7f1ebeaa76953 = (0, $lKhJJ.defineMessages)({
    nickname: {
        id: "ptc-directory.user-profile-page.about.error-flag.nickname.title",
        defaultMessage: "We couldn\u2019t update your public name",
        description: "The error message title for when editing the public name fails. Appears in a notification flag upon failure to save new value."
    },
    fullName: {
        id: "ptc-directory.user-profile-page.about.error-flag.fullName.title",
        defaultMessage: "We couldn\u2019t update your full name",
        description: "The error message title for when editing the full name fails. Appears in a notification flag upon failure to save new value."
    },
    title: {
        id: "ptc-directory.user-profile-page.about.error-flag.title.title",
        defaultMessage: "We couldn\u2019t update your job title",
        description: "The error message title for when editing the job title fails. Appears in a notification flag upon failure to save new value."
    },
    department: {
        id: "ptc-directory.user-profile-page.about.error-flag.department.title",
        defaultMessage: "We couldn\u2019t update your department",
        description: "The error message title for when editing the department fails. Appears in a notification flag upon failure to save new value."
    },
    companyName: {
        id: "ptc-directory.user-profile-page.about.error-flag.companyName.title",
        defaultMessage: "We couldn\u2019t update your organization",
        description: "The error message title for when editing the organization fails. Appears in a notification flag upon failure to save new value."
    },
    location: {
        id: "ptc-directory.user-profile-page.about.error-flag.location.title",
        defaultMessage: "We couldn\u2019t update your location",
        description: "The error message title for when editing the location fails. Appears in a notification flag upon failure to save new value."
    },
    timezone: {
        id: "ptc-directory.user-profile-page.about.error-flag.timezone.title",
        defaultMessage: "We couldn\u2019t update your time zone",
        description: "The error message title for when editing the time zone fails. Appears in a notification flag upon failure to save new value."
    },
    email: {
        id: "ptc-directory.user-profile-page.about.error-flag.email.title",
        defaultMessage: "We couldn\u2019t update your email address",
        description: "The error message title for when editing the email address fails. Appears in a notification flag upon failure to save new value."
    },
    phoneNumber: {
        id: "ptc-directory.user-profile-page.about.error-flag.phone.title",
        defaultMessage: "We couldn\u2019t update your phone number",
        description: "The error message title for when editing the phone number fails. Appears in a notification flag upon failure to save new value."
    }
});


parcelRequire("jShba");
var $3kXiv = parcelRequire("3kXiv");
const $a6efe9ce758ac994$var$mapStateToProps = ({ user: user })=>({
        userId: user.data.accountId,
        isManaged: user.data.isManaged,
        managedBy: user.data.managedBy
    });
const $a6efe9ce758ac994$var$mapDispatchToProps = {
    addFlag: $3kXiv.addFlag
};
var $a6efe9ce758ac994$export$2e2bcd8739ae039 = (0, $7PWYP.default)($a6efe9ce758ac994$var$mapStateToProps, $a6efe9ce758ac994$var$mapDispatchToProps)((0, $dab36eb65b250ef1$export$2e2bcd8739ae039));



var $h1Uju = parcelRequire("h1Uju");



parcelRequire("jQGCp");
var $7PWYP = parcelRequire("7PWYP");

var $bibO8 = parcelRequire("bibO8");

var $dAx5m = parcelRequire("dAx5m");

var $55TWT = parcelRequire("55TWT");
var $b8f99f249084ff94$exports = {};
"use strict";
Object.defineProperty($b8f99f249084ff94$exports, "__esModule", {
    value: true
});
$b8f99f249084ff94$exports.default = void 0;

var $b8f99f249084ff94$var$_react = $b8f99f249084ff94$var$_interopRequireDefault((parcelRequire("dAx5m")));

var $9eGJl = parcelRequire("9eGJl");
function $b8f99f249084ff94$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $b8f99f249084ff94$var$InfoIcon = (props)=>/*#__PURE__*/ $b8f99f249084ff94$var$_react.default.createElement($9eGJl.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><path d="M2 12c0 5.523 4.477 10 10 10s10-4.477 10-10S17.523 2 12 2 2 6.477 2 12z" fill="currentColor"/><rect fill="inherit" x="11" y="10" width="2" height="7" rx="1"/><circle fill="inherit" cx="12" cy="8" r="1"/></g></svg>`
    }, props));
$b8f99f249084ff94$var$InfoIcon.displayName = "InfoIcon";
var $b8f99f249084ff94$var$_default = $b8f99f249084ff94$var$InfoIcon;
$b8f99f249084ff94$exports.default = $b8f99f249084ff94$var$_default;



var $5MUVm = parcelRequire("5MUVm");

var $gbKg7 = parcelRequire("gbKg7");
parcelRequire("jShba");
var $fjOHq = parcelRequire("fjOHq");
var $1UxEK = parcelRequire("1UxEK");
var $gzP7h = parcelRequire("gzP7h");
var $grRLU = parcelRequire("grRLU");
const $63f533253a9ddfa0$export$f4702f36510d3412 = "admin-manages-account-banner";
const $63f533253a9ddfa0$export$3dfe9ec606e85e82 = "2021-04-29T00:00:00.000Z";



var $4MHck = parcelRequire("4MHck");

var $iDL5l = parcelRequire("iDL5l");
parcelRequire("jShba");
var $1Bj4T = parcelRequire("1Bj4T");

const $dc7a23bf943f57aa$var$dismissedAdminManagersAccountBannerKey = "dismissedAdminManagersAccountBannerKey";
const $dc7a23bf943f57aa$var$dismissedAdminManagesAccountBannerQueryFn = async ()=>{
    const { stargateRoot: stargateRoot } = (0, $1Bj4T.getConfig)();
    const url = `${stargateRoot}/flag/my?flagKey=manage.profile.have-i-seen-it.${encodeURIComponent((0, $63f533253a9ddfa0$export$f4702f36510d3412))}`;
    try {
        const response = await (0, $iDL5l.fetchApi)(url);
        const data = await response.json();
        return {
            id: (0, $63f533253a9ddfa0$export$f4702f36510d3412),
            ...data
        };
    } catch (error) {
        return {
            id: (0, $63f533253a9ddfa0$export$f4702f36510d3412),
            lastSeenDate: null,
            status: true
        };
    }
};
const $dc7a23bf943f57aa$export$b560eb31f2c9f10f = (enabled = false)=>{
    const { data: data, isLoading: isLoading, isError: isError } = (0, $4MHck.useQuery)({
        queryKey: [
            $dc7a23bf943f57aa$var$dismissedAdminManagersAccountBannerKey
        ],
        queryFn: ()=>$dc7a23bf943f57aa$var$dismissedAdminManagesAccountBannerQueryFn(),
        enabled: enabled
    });
    return {
        data: data,
        isLoading: isLoading,
        isError: isError
    };
};



var $atFkq = parcelRequire("atFkq");

var $iDL5l = parcelRequire("iDL5l");


var $1Bj4T = parcelRequire("1Bj4T");
const $edf0ab8dc77e3a23$var$dismissHaveSeenIt = async ()=>{
    const { stargateRoot: stargateRoot } = (0, $1Bj4T.getConfig)();
    try {
        await (0, $iDL5l.fetchApi)(`${stargateRoot}/flag/my`, {
            method: "POST",
            body: JSON.stringify({
                flagKey: `manage.profile.have-i-seen-it.${(0, $63f533253a9ddfa0$export$f4702f36510d3412)}`
            })
        });
    } catch (e) {
    // nothing to do here, fail silently
    }
};
const $edf0ab8dc77e3a23$export$8efe41dfc286bc12 = ()=>{
    const { isLoading: isLoading, isError: isError, mutate: mutate } = (0, $atFkq.useMutation)({
        mutationFn: ()=>$edf0ab8dc77e3a23$var$dismissHaveSeenIt()
    });
    return {
        isLoading: isLoading,
        isError: isError,
        mutate: mutate
    };
};




const $8caa6f201b0ee8e0$var$AdminManagesAccountBannerImpl = ()=>{
    const analytics = (0, $grRLU.default)();
    const { mutate: dismissBanner } = (0, $edf0ab8dc77e3a23$export$8efe41dfc286bc12)();
    (0, $dAx5m.useEffect)(()=>{
        analytics.pushUIEvent({
            source: (0, $fjOHq.AnalyticsEventSource).MANAGE_ACCOUNT_PROFILE_AND_VISIBILITY_TAB,
            action: (0, $fjOHq.AnalyticsEventActions).SHOWN,
            actionSubject: (0, $fjOHq.AnalyticsEventSubjects).NOTIFICATION,
            actionSubjectId: "domainClaimNotification"
        });
    }, [
        analytics
    ]);
    const MessageContent = /*#__PURE__*/ (0, $bibO8.jsxs)((0, $bibO8.Fragment), {
        children: [
            /*#__PURE__*/ (0, $bibO8.jsx)("strong", {
                children: /*#__PURE__*/ (0, $bibO8.jsx)((0, $55TWT.default), {
                    id: "ptc-directory.settings.profile-and-visibility.admin-manages-account-message.title",
                    defaultMessage: "Your admin now manages your account.",
                    description: "Title text for the notice message informing the user that their account now manages by admin"
                })
            }),
            /*#__PURE__*/ (0, $bibO8.jsx)("span", {
                children: "\xa0"
            }),
            /*#__PURE__*/ (0, $bibO8.jsx)((0, $55TWT.default), {
                id: "ptc-directory.settings.profile-and-visibility.admin-manages-account-message.body",
                defaultMessage: "Contact your admin to change your account details.",
                description: "Body text for the notice message informing the user that their account now manages by admin"
            })
        ]
    });
    const onDismiss = ()=>{
        dismissBanner();
        analytics.pushUIEvent({
            source: (0, $fjOHq.AnalyticsEventSource).MANAGE_ACCOUNT_PROFILE_AND_VISIBILITY_TAB,
            action: (0, $fjOHq.AnalyticsEventActions).CLICKED,
            actionSubject: (0, $fjOHq.AnalyticsEventSubjects).BUTTON,
            actionSubjectId: "dismissDomainClaimNotification"
        });
    };
    const onAnchorClick = ()=>{
        analytics.pushUIEvent({
            source: (0, $fjOHq.AnalyticsEventSource).MANAGE_ACCOUNT_PROFILE_AND_VISIBILITY_TAB,
            action: (0, $fjOHq.AnalyticsEventActions).CLICKED,
            actionSubject: (0, $fjOHq.AnalyticsEventSubjects).LINK,
            actionSubjectId: "learnMoreAboutManagedAccounts"
        });
    };
    return /*#__PURE__*/ (0, $bibO8.jsx)((0, $gzP7h.DismissibleSectionMessage), {
        testId: "managedAccountBanner",
        message: MessageContent,
        actions: [
            /*#__PURE__*/ (0, $bibO8.jsx)((0, $1UxEK.default), {
                href: "https://confluence.atlassian.com/x/kQkvOg",
                target: "_blank",
                onClick: onAnchorClick,
                children: /*#__PURE__*/ (0, $bibO8.jsx)((0, $55TWT.default), {
                    id: "ptc-directory.settings.profile-and-visibility.admin-manages-account-message.link-text",
                    defaultMessage: "Learn more about managed accounts",
                    description: "Text of link to learn more about managed accounts"
                })
            }, "adminManageAccountBannerLinkText")
        ],
        icon: /*#__PURE__*/ (0, $bibO8.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($b8f99f249084ff94$exports))), {
            size: "medium",
            primaryColor: (0, $gbKg7.default)("color.icon.accent.purple", (0, $5MUVm).P500),
            label: "info block"
        }),
        onDismiss: onDismiss
    });
};
const $8caa6f201b0ee8e0$export$437ab663fb2c403a = ({ isUserLoading: isUserLoading, isManaged: isManaged, timestamp: timestamp = "" })=>{
    const enabled = !isUserLoading && isManaged;
    const { data: data, isLoading: isLoading } = (0, $dc7a23bf943f57aa$export$b560eb31f2c9f10f)(enabled);
    const dismissed = data?.status;
    const lastSeenDate = data?.lastSeenDate;
    if (isUserLoading || !isManaged || isLoading) return null;
    const managedByDate = new Date(timestamp).getTime();
    if (new Date((0, $63f533253a9ddfa0$export$3dfe9ec606e85e82)).getTime() > managedByDate) return null;
    if (dismissed && lastSeenDate && new Date(lastSeenDate).getTime() > managedByDate) return null;
    return /*#__PURE__*/ (0, $bibO8.jsx)($8caa6f201b0ee8e0$var$AdminManagesAccountBannerImpl, {});
};
var $8caa6f201b0ee8e0$export$2e2bcd8739ae039 = $8caa6f201b0ee8e0$export$437ab663fb2c403a;


const $ac82056966648256$var$mapStateToProps = ({ user: user })=>({
        isUserLoading: user.isLoading,
        isManaged: user.data.isManaged,
        timestamp: user.data.manageStartedTimestamp
    });
var $ac82056966648256$export$2e2bcd8739ae039 = (0, $7PWYP.default)($ac82056966648256$var$mapStateToProps)((0, $8caa6f201b0ee8e0$export$2e2bcd8739ae039));





var $h1Uju = parcelRequire("h1Uju");
var $52e7012ae7ff1d18$export$3cf39d14b1b94686;
(function(UserProfilePrivacySetting) {
    UserProfilePrivacySetting["COLLABORATOR"] = "COLLABORATOR";
    UserProfilePrivacySetting["PRIVATE"] = "PRIVATE";
    UserProfilePrivacySetting["PUBLIC"] = "PUBLIC";
})($52e7012ae7ff1d18$export$3cf39d14b1b94686 || ($52e7012ae7ff1d18$export$3cf39d14b1b94686 = {}));
var $52e7012ae7ff1d18$export$49d9b4f17a0f6317;
(function(PrivacyItemType) {
    PrivacyItemType["FullName"] = "name";
    PrivacyItemType["Timezone"] = "zoneinfo";
    PrivacyItemType["CompanyName"] = "organization";
    PrivacyItemType["Title"] = "jobTitle";
})($52e7012ae7ff1d18$export$49d9b4f17a0f6317 || ($52e7012ae7ff1d18$export$49d9b4f17a0f6317 = {}));
const $52e7012ae7ff1d18$export$7d3573617ce50774 = Object.keys((0, $h1Uju.FieldType)).reduce((memo, key)=>{
    memo[(0, $h1Uju.FieldType)[key]] = $52e7012ae7ff1d18$export$49d9b4f17a0f6317[key] || (0, $h1Uju.FieldType)[key];
    return memo;
}, {});


parcelRequire("fYdPZ");
var $cZlBJ = parcelRequire("cZlBJ");

var $ak3Un = parcelRequire("ak3Un");
parcelRequire("jShba");
var $h1Uju = parcelRequire("h1Uju");
const $bc75c36462cc80f0$export$9c71e9aab6e308b5 = ({ remoteWeekdayIndex: remoteWeekdayIndex, remoteWeekdayString: remoteWeekdayString, remoteTimeString: remoteTimeString })=>{
    if (!remoteWeekdayIndex || !remoteWeekdayString || !remoteTimeString) return;
    const localWeekdayIndex = new Date().getDay().toString();
    if (remoteWeekdayIndex === localWeekdayIndex) return remoteTimeString;
    else return `${remoteWeekdayString} ${remoteTimeString}`;
};
function $bc75c36462cc80f0$export$32cbb79d8a520e48(onSubmit) {
    return (fieldType, value)=>{
        let transformedValue;
        switch(fieldType){
            case (0, $h1Uju.FieldType).Timezone:
                // The server expects `America/Los_Angeles` etc., but we use spaces
                transformedValue = value.replace(/ /g, "_");
                break;
            default:
                transformedValue = value;
                break;
        }
        return onSubmit(fieldType, transformedValue);
    };
}
const $bc75c36462cc80f0$export$c1612263ba46405f = (userData)=>({
        [(0, $h1Uju.FieldType).Title]: {
            edit: userData[(0, $h1Uju.FieldType).Title]
        },
        [(0, $h1Uju.FieldType).FullName]: {
            edit: userData[(0, $h1Uju.FieldType).FullName]
        },
        [(0, $h1Uju.FieldType).Nickname]: {
            edit: userData[(0, $h1Uju.FieldType).Nickname]
        },
        [(0, $h1Uju.FieldType).Department]: {
            edit: userData[(0, $h1Uju.FieldType).Department]
        },
        [(0, $h1Uju.FieldType).CompanyName]: {
            edit: userData[(0, $h1Uju.FieldType).CompanyName]
        },
        [(0, $h1Uju.FieldType).Location]: {
            edit: userData[(0, $h1Uju.FieldType).Location]
        },
        [(0, $h1Uju.FieldType).Timezone]: {
            read: $bc75c36462cc80f0$export$9c71e9aab6e308b5(userData),
            edit: // The server sends `America/Los_Angeles` etc., but we use spaces
            userData[(0, $h1Uju.FieldType).Timezone] && userData[(0, $h1Uju.FieldType).Timezone].replace(/_/g, " ")
        },
        [(0, $h1Uju.FieldType).LocalTime]: {
            edit: $bc75c36462cc80f0$export$9c71e9aab6e308b5(userData) || "",
            read: $bc75c36462cc80f0$export$9c71e9aab6e308b5(userData) || ""
        },
        [(0, $h1Uju.FieldType).Email]: {
            edit: userData[(0, $h1Uju.FieldType).Email]
        },
        [(0, $h1Uju.FieldType).PhoneNumber]: {
            edit: userData[(0, $h1Uju.FieldType).PhoneNumber]
        }
    });



var $4MHck = parcelRequire("4MHck");

var $iDL5l = parcelRequire("iDL5l");

var $1Bj4T = parcelRequire("1Bj4T");
const $0360ee6ed11468fc$var$schemaKeys = {
    name: "name",
    nickname: "nickname",
    zoneinfo: "zoneinfo",
    picture: "picture",
    email: "email",
    phoneNumber: "phoneNumber",
    jobTitle: "jobTitle",
    organization: "organization",
    department: "department",
    location: "location"
};
const $0360ee6ed11468fc$var$apiKeys = {
    name: "name",
    nickname: "nickname",
    zoneinfo: "zoneinfo",
    picture: "picture",
    email: "email",
    phoneNumber: "extended_profile.phone_number",
    jobTitle: "extended_profile.job_title",
    organization: "extended_profile.organization",
    department: "extended_profile.department",
    location: "extended_profile.location"
};
const $0360ee6ed11468fc$export$4154b9b275895abf = {
    [$0360ee6ed11468fc$var$schemaKeys.name]: $0360ee6ed11468fc$var$apiKeys.name,
    [$0360ee6ed11468fc$var$schemaKeys.nickname]: $0360ee6ed11468fc$var$apiKeys.nickname,
    [$0360ee6ed11468fc$var$schemaKeys.zoneinfo]: $0360ee6ed11468fc$var$apiKeys.zoneinfo,
    [$0360ee6ed11468fc$var$schemaKeys.picture]: $0360ee6ed11468fc$var$apiKeys.picture,
    [$0360ee6ed11468fc$var$schemaKeys.email]: $0360ee6ed11468fc$var$apiKeys.email,
    [$0360ee6ed11468fc$var$schemaKeys.phoneNumber]: $0360ee6ed11468fc$var$apiKeys.phoneNumber,
    // extended profile
    [$0360ee6ed11468fc$var$schemaKeys.jobTitle]: $0360ee6ed11468fc$var$apiKeys.jobTitle,
    [$0360ee6ed11468fc$var$schemaKeys.organization]: $0360ee6ed11468fc$var$apiKeys.organization,
    [$0360ee6ed11468fc$var$schemaKeys.department]: $0360ee6ed11468fc$var$apiKeys.department,
    [$0360ee6ed11468fc$var$schemaKeys.location]: $0360ee6ed11468fc$var$apiKeys.location
};
const $0360ee6ed11468fc$var$toUpperCase = (input)=>{
    if (typeof input === "string") return input.toUpperCase();
    return null;
};
const $0360ee6ed11468fc$export$bfc3808f21c9d49d = (data)=>Object.entries($0360ee6ed11468fc$export$4154b9b275895abf).reduce((memo, [schemaKey, apiResponseKey])=>{
        const privacySetting = data[apiResponseKey];
        memo[schemaKey] = $0360ee6ed11468fc$var$toUpperCase(privacySetting);
        return memo;
    }, {});
const $0360ee6ed11468fc$export$64774399daaaf8ff = {
    [$0360ee6ed11468fc$var$apiKeys.name]: $0360ee6ed11468fc$var$schemaKeys.name,
    [$0360ee6ed11468fc$var$apiKeys.nickname]: $0360ee6ed11468fc$var$schemaKeys.nickname,
    [$0360ee6ed11468fc$var$apiKeys.zoneinfo]: $0360ee6ed11468fc$var$schemaKeys.zoneinfo,
    [$0360ee6ed11468fc$var$apiKeys.picture]: $0360ee6ed11468fc$var$schemaKeys.picture,
    [$0360ee6ed11468fc$var$apiKeys.email]: $0360ee6ed11468fc$var$schemaKeys.email,
    [$0360ee6ed11468fc$var$apiKeys.phoneNumber]: $0360ee6ed11468fc$var$schemaKeys.phoneNumber,
    // extended profile
    [$0360ee6ed11468fc$var$apiKeys.jobTitle]: $0360ee6ed11468fc$var$schemaKeys.jobTitle,
    [$0360ee6ed11468fc$var$apiKeys.organization]: $0360ee6ed11468fc$var$schemaKeys.organization,
    [$0360ee6ed11468fc$var$apiKeys.department]: $0360ee6ed11468fc$var$schemaKeys.department,
    [$0360ee6ed11468fc$var$apiKeys.location]: $0360ee6ed11468fc$var$schemaKeys.location
};
const $0360ee6ed11468fc$export$f5a6643bba95b2d0 = (data)=>Object.keys($0360ee6ed11468fc$export$64774399daaaf8ff).reduce((memo, apiKey)=>{
        const apiResponseKey = $0360ee6ed11468fc$export$64774399daaaf8ff[apiKey];
        const privacySetting = data[apiResponseKey];
        if (privacySetting) memo[apiKey] = privacySetting.toLowerCase();
        return memo;
    }, {});


const $5a3eeb78eea3c8a3$export$5593b37ac0ade90b = "UserManagePrivacySettings";
const $5a3eeb78eea3c8a3$var$userManagePrivacySettingsQueryFn = async (userId)=>{
    const { stargateRoot: stargateRoot } = (0, $1Bj4T.getConfig)();
    const url = `${stargateRoot}/users/${userId}/manage/privacy-settings`;
    const response = await (0, $iDL5l.fetchApi)(url);
    const data = await response.json();
    const transformedData = (0, $0360ee6ed11468fc$export$bfc3808f21c9d49d)(data);
    return {
        ...transformedData,
        userId: userId
    };
};
const $5a3eeb78eea3c8a3$export$d3857b566797313c = (userId)=>{
    const { data: data, isLoading: isLoading, isError: isError } = (0, $4MHck.useQuery)({
        queryKey: [
            $5a3eeb78eea3c8a3$export$5593b37ac0ade90b,
            userId
        ],
        queryFn: ()=>$5a3eeb78eea3c8a3$var$userManagePrivacySettingsQueryFn(userId),
        enabled: !!userId
    });
    return {
        userPrivacySettings: data,
        isLoading: isLoading,
        isError: isError
    };
};



var $4MHck = parcelRequire("4MHck");

var $iDL5l = parcelRequire("iDL5l");

var $1Bj4T = parcelRequire("1Bj4T");


const $c0577a0136de58db$export$88e4593a3b1e4235 = "UserAllowedPrivacySettings";
const $c0577a0136de58db$var$getAllowedPrivacySettingsFor = (apiData, apiResponseKey)=>{
    const allowedPrivacySettings = apiData[apiResponseKey];
    if (!allowedPrivacySettings || !allowedPrivacySettings.length) return null;
    return allowedPrivacySettings.map((privacyLevel)=>{
        switch(privacyLevel){
            case "public":
                return (0, $1ea2b1c5db3c4b56$export$598b17d3c675a75).PUBLIC;
            case "private":
                return (0, $1ea2b1c5db3c4b56$export$598b17d3c675a75).PRIVATE;
            case "collaborator":
                return (0, $1ea2b1c5db3c4b56$export$598b17d3c675a75).ORGANISATION;
            default:
                return null;
        }
    }).filter((entry)=>entry !== null);
};
const $c0577a0136de58db$var$transformUserManagePrivacySettingsAllowed = (data)=>{
    // warning: this reducer is NOT type safe
    return Object.entries((0, $0360ee6ed11468fc$export$4154b9b275895abf)).reduce((memo, [schemaKey, apiResponseKey])=>{
        memo[schemaKey] = $c0577a0136de58db$var$getAllowedPrivacySettingsFor(data, apiResponseKey);
        return memo;
    }, {});
};
const $c0577a0136de58db$var$userAllowedPrivacySettingsQueryFn = async (userId)=>{
    const { stargateRoot: stargateRoot } = (0, $1Bj4T.getConfig)();
    const url = `${stargateRoot}/users/${userId}/manage/privacy-settings/allowed`;
    const response = await (0, $iDL5l.fetchApi)(url);
    const data = await response.json();
    return $c0577a0136de58db$var$transformUserManagePrivacySettingsAllowed(data);
};
const $c0577a0136de58db$export$e3e0ef6dd0705415 = (userId)=>{
    const { data: data, isLoading: isLoading, isError: isError } = (0, $4MHck.useQuery)({
        queryKey: [
            $c0577a0136de58db$export$88e4593a3b1e4235,
            userId
        ],
        queryFn: ()=>$c0577a0136de58db$var$userAllowedPrivacySettingsQueryFn(userId),
        enabled: !!userId
    });
    return {
        userAllowedPrivacySettings: data,
        isLoading: isLoading,
        isError: isError
    };
};



var $atFkq = parcelRequire("atFkq");
var $132jP = parcelRequire("132jP");


parcelRequire("jShba");
var $1Bj4T = parcelRequire("1Bj4T");
const $8702291caca285c9$var$mapValuesToCC = {
    public: "PUBLIC",
    private: "PRIVATE",
    organisation: "COLLABORATOR"
};
const $8702291caca285c9$var$updateProfilePrivacy = async (userId, newPrivacySetting)=>{
    const url = `${(0, $1Bj4T.getConfig)().stargateRoot}/users/${userId}/manage/privacy-settings`;
    const response = await fetch(url, {
        method: "PATCH",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify((0, $0360ee6ed11468fc$export$f5a6643bba95b2d0)(newPrivacySetting))
    });
    const data = await response.json();
    const transformedData = (0, $0360ee6ed11468fc$export$bfc3808f21c9d49d)(data);
    return {
        ...transformedData,
        userId: userId
    };
};
const $8702291caca285c9$export$dba518a46d2834ef = (userId)=>{
    const queryClient = (0, $132jP.useQueryClient)();
    const queryKey = [
        (0, $5a3eeb78eea3c8a3$export$5593b37ac0ade90b),
        userId
    ];
    const { mutateAsync: mutateAsync } = (0, $atFkq.useMutation)({
        mutationFn: async ({ privacyKey: privacyKey, value: value })=>{
            const newPrivacyLevel = {
                [privacyKey]: $8702291caca285c9$var$mapValuesToCC[value]
            };
            await queryClient.cancelQueries({
                queryKey: queryKey
            });
            // Optimistically update to the new state
            queryClient.setQueryData(queryKey, (old)=>({
                    ...old,
                    ...newPrivacyLevel
                }));
            return $8702291caca285c9$var$updateProfilePrivacy(userId, newPrivacyLevel);
        },
        onSettled: ()=>{
            // Always refetch after error or success
            queryClient.invalidateQueries(queryKey);
        }
    });
    return {
        mutateAsync: mutateAsync
    };
};



parcelRequire("ggxSz");
var $6Q4AU = parcelRequire("6Q4AU");
var $50fb87393b83172c$var$Sections;
(function(Sections) {
    Sections["PRIVACY_POLICY"] = "privacyPolicy";
    Sections["PROFILE_VISIBILITY"] = "profileVisibility";
})($50fb87393b83172c$var$Sections || ($50fb87393b83172c$var$Sections = {}));
const $50fb87393b83172c$var$MAP_UI_TO_PRS_PRIVACY_VALUES = {
    public: "PUBLIC",
    organisation: "COLLABORATOR",
    private: "PRIVATE"
};
const $50fb87393b83172c$var$FIELD_TYPES_DETAILS = [
    (0, $h1Uju.FieldType).FullName,
    (0, $h1Uju.FieldType).Nickname,
    (0, $h1Uju.FieldType).Title,
    (0, $h1Uju.FieldType).Department,
    (0, $h1Uju.FieldType).CompanyName,
    (0, $h1Uju.FieldType).Location,
    (0, $h1Uju.FieldType).LocalTime
];
const $50fb87393b83172c$var$FIELD_TYPES_CONTACT = [
    (0, $h1Uju.FieldType).Email
];
const $50fb87393b83172c$export$87e27da4bfd88fb8 = ({ addFlag: addFlag, isManaged: isManaged, userId: userId, managedByOrgName: managedByOrgName })=>{
    const { formatMessage: formatMessage } = (0, $dZHnD.default)();
    const analytics = (0, $grRLU.default)();
    const { userPrivacySettings: privacyValues, isError: isUserManagePrivacySettingsError, isLoading: isLoadingUserManagePrivacySettings } = (0, $5a3eeb78eea3c8a3$export$d3857b566797313c)(userId);
    const { userAllowedPrivacySettings: privacyOptions, isLoading: isAllowedPrivacySettingsLoading, isError: isAllowedPrivacySettingsError } = (0, $c0577a0136de58db$export$e3e0ef6dd0705415)(userId);
    const { mutateAsync: onSubmit } = (0, $1ff7ae0ebc51ff87$export$76936a29374a0363)({
        userId: userId
    });
    const { mutateAsync: onPrivacyLevelChange } = (0, $8702291caca285c9$export$dba518a46d2834ef)(userId);
    const { user: userDetails, isLoading: isLoadingManageProfileUser, isError: isManageProfileUserError } = (0, $ak3Un.useManageProfileUser)(userId);
    const usersOrgName = managedByOrgName || "";
    const userDetailsEditValues = (0, $dAx5m.useMemo)(()=>userDetails && (0, $bc75c36462cc80f0$export$c1612263ba46405f)(userDetails), [
        userDetails
    ]);
    (0, $dAx5m.useEffect)(()=>{
        analytics.pushScreenEvent({
            name: (0, $fjOHq.AnalyticsEventSource).MANAGE_ACCOUNT_PROFILE_AND_VISIBILITY_TAB
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0, $6Q4AU.useOnceWhen)(!!isManaged && !managedByOrgName, ()=>{
        analytics.pushTrackEvent({
            source: (0, $fjOHq.AnalyticsEventSource).MANAGE_ACCOUNT_PROFILE_AND_VISIBILITY_TAB,
            actionSubject: "missingManagedByOrgName",
            action: (0, $fjOHq.AnalyticsEventActions).FAILED
        });
    });
    const getPrivacyLevelChangeHandler = (fieldKey)=>async (value)=>await privacyLevelChangeHandler(fieldKey, value);
    const privacyLevelChangeHandler = (0, $dAx5m.useCallback)(async (fieldKey, value)=>{
        const privacyKey = (0, $52e7012ae7ff1d18$export$7d3573617ce50774)[fieldKey] || fieldKey;
        try {
            const oldValue = privacyValues?.[privacyKey];
            const newValue = $50fb87393b83172c$var$MAP_UI_TO_PRS_PRIVACY_VALUES[value];
            // Do not update if the new level is the same as the old level
            if (oldValue === newValue) return;
            await onPrivacyLevelChange({
                privacyKey: privacyKey,
                value: value
            });
            analytics.pushTrackEvent({
                source: (0, $fjOHq.AnalyticsEventSource).MANAGE_ACCOUNT_PROFILE_AND_VISIBILITY_TAB,
                actionSubject: "profilePrivacyItem",
                action: (0, $fjOHq.AnalyticsEventActions).EDITED,
                attributes: {
                    fieldKey: fieldKey,
                    isManaged: isManaged,
                    oldValue: oldValue,
                    newValue: newValue
                }
            });
            // In term of UI, user is updating visibility of local time.
            // in term of calling our API, user is updating visibility of time zone.
            // So that is the reason, prop name is `timezone_xxxx`, but message has local time.
            let flagMessage = (0, $a63a81b6caa9ac0d$export$5afb1a429e5a7f8c)[`${fieldKey}_${value}`];
            if (fieldKey === (0, $h1Uju.FieldType).Timezone) flagMessage = (0, $a63a81b6caa9ac0d$export$5afb1a429e5a7f8c)[`${(0, $h1Uju.FieldType).LocalTime}_${value}`];
            addFlag({
                type: "success",
                title: formatMessage({
                    id: "ptc-directory.settings.profile-and-visibility.privacy.success-heading",
                    defaultMessage: "We\u2019re updating your visibility",
                    description: "The success notification flag title for when a field visibility modification succeeded."
                }),
                description: flagMessage && formatMessage(flagMessage),
                id: "PRIVACY_LEVEL_CHANGE_SUCCESS"
            });
        } catch (error) {
            (0, $77YRX.logException)(error, "Failed to change privacy level in UPAVS");
            addFlag({
                type: "error",
                title: formatMessage({
                    id: "ptc-directory.settings.profile-and-visibility.privacy.error-heading",
                    defaultMessage: "We couldn\u2019t update your visibility.",
                    description: "The error notification title for when a field visibility modification fails."
                }),
                description: formatMessage({
                    id: "ptc-directory.settings.profile-and-visibility.try-again-later",
                    defaultMessage: "Try again later",
                    description: "The error message description for when a field edit fails. Appears under the title in a notification flag when a field edit fails."
                }),
                id: "PRIVACY_LEVEL_CHANGE_ERROR"
            });
        }
    }, [
        addFlag,
        analytics,
        formatMessage,
        isManaged,
        onPrivacyLevelChange,
        privacyValues
    ]);
    const handleLearnMoreClick = (section)=>()=>{
            analytics.pushTrackEvent({
                source: (0, $fjOHq.AnalyticsEventSource).MANAGE_ACCOUNT_PROFILE_AND_VISIBILITY_TAB,
                actionSubject: `${section}LearnMore`,
                action: (0, $fjOHq.AnalyticsEventActions).CLICKED
            });
        };
    const renderAvatarAndHeader = ()=>{
        if (!privacyValues?.picture) return null;
        const privacyDropdownOptions = privacyOptions && privacyOptions.picture;
        return /*#__PURE__*/ (0, $bibO8.jsx)((0, $abfebf73c75bae2c$export$2e2bcd8739ae039), {
            privacyLevelOptions: (0, $423263b1288ad8f8$export$abc9c3081c48e7ff)((0, $h1Uju.FieldType).Avatar, privacyDropdownOptions || undefined, {
                orgName: usersOrgName,
                isManaged: isManaged
            }),
            privacyLevel: (0, $53f3c3d3af589157$export$52a249bf80a4235b)[privacyValues.picture],
            onPrivacyLevelChange: getPrivacyLevelChangeHandler((0, $h1Uju.FieldType).Avatar),
            userId: userId
        });
    };
    const renderHeader = ()=>/*#__PURE__*/ (0, $bibO8.jsx)((0, $6bOZI.default), {
            children: /*#__PURE__*/ (0, $bibO8.jsx)((0, $55TWT.default), {
                id: "ptc-directory.settings.profile-and-visibility.title",
                defaultMessage: "Profile and visibility",
                description: "Page title shown at the top of the page"
            })
        });
    if (isLoadingManageProfileUser || isLoadingUserManagePrivacySettings || isAllowedPrivacySettingsLoading) return /*#__PURE__*/ (0, $bibO8.jsx)((0, $1QRhz.default), {
        wrapperHeight: 256
    });
    const loadedWithoutData = !privacyValues || !privacyOptions;
    if (loadedWithoutData || isManageProfileUserError || isUserManagePrivacySettingsError || isAllowedPrivacySettingsError) return /*#__PURE__*/ (0, $bibO8.jsxs)((0, $bibO8.Fragment), {
        children: [
            /*#__PURE__*/ (0, $bibO8.jsx)((0, $7pLec.GenericErrorPage), {}),
            /*#__PURE__*/ (0, $bibO8.jsx)((0, $zFJ4O.default), {
                task: (0, $7dUzb.ApdexTasks).VIEW_PROFILE_AND_VISIBILITY_SETTINGS
            })
        ]
    });
    return /*#__PURE__*/ (0, $bibO8.jsxs)($0c5cedf3c4dbc22e$export$6955bcca4cd3539f, {
        children: [
            /*#__PURE__*/ (0, $bibO8.jsx)((0, $cZlBJ.DeviceContextConsumer), {
                children: ({ isMobile: isMobile })=>// DeviceContextConsumer is needed here to allow
                    // put banner under header on mobiles to prevent
                    // UI issues
                    /*#__PURE__*/ (0, $bibO8.jsxs)((0, $bibO8.Fragment), {
                        children: [
                            isMobile && renderHeader(),
                            isManaged && /*#__PURE__*/ (0, $bibO8.jsx)($0c5cedf3c4dbc22e$export$16c26ca3b4cdb2a4, {
                                children: /*#__PURE__*/ (0, $bibO8.jsx)((0, $ac82056966648256$export$2e2bcd8739ae039), {})
                            }),
                            !isMobile && renderHeader()
                        ]
                    })
            }),
            /*#__PURE__*/ (0, $bibO8.jsxs)($hxi5h.SettingsDescription, {
                children: [
                    /*#__PURE__*/ (0, $bibO8.jsx)((0, $55TWT.default), {
                        id: "ptc-directory.settings.profile-and-visibility.description-p1",
                        defaultMessage: "Manage your personal information, and control which information other people see and apps may access.",
                        description: 'First paragraph of "Profile and visibility" settings page description',
                        tagName: "p"
                    }),
                    /*#__PURE__*/ (0, $bibO8.jsx)((0, $55TWT.default), {
                        id: "ptc-directory.settings.profile-and-visibility.description-p2.xml",
                        defaultMessage: "<learn-more-link>Learn more about your profile and visibility</learn-more-link> or <privacy-policy-link>view our privacy policy</privacy-policy-link>.",
                        description: 'Second paragraph of "Profile and visibility" settings page description, containing two links',
                        values: {
                            // eslint-disable-next-line react/display-name
                            "learn-more-link": (chunks)=>/*#__PURE__*/ (0, $bibO8.jsx)((0, $1UxEK.default), {
                                    href: "https://confluence.atlassian.com/x/6IS8OQ",
                                    target: "_blank",
                                    onClick: handleLearnMoreClick("profileVisibility"),
                                    children: chunks
                                }),
                            // eslint-disable-next-line react/display-name
                            "privacy-policy-link": (chunks)=>/*#__PURE__*/ (0, $bibO8.jsx)((0, $1UxEK.default), {
                                    href: "https://www.atlassian.com/legal/privacy-policy",
                                    target: "_blank",
                                    onClick: handleLearnMoreClick("privacyPolicy"),
                                    children: chunks
                                })
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0, $bibO8.jsx)($0c5cedf3c4dbc22e$export$210dc657affc8afd, {
                children: /*#__PURE__*/ (0, $bibO8.jsx)((0, $55TWT.default), {
                    id: "ptc-directory.settings.profile-and-visibility.profile-header-title",
                    defaultMessage: "Profile photo and header image",
                    description: "Title of a section that contains profile photo and header image settings"
                })
            }),
            renderAvatarAndHeader(),
            /*#__PURE__*/ (0, $bibO8.jsx)($0c5cedf3c4dbc22e$export$210dc657affc8afd, {
                children: /*#__PURE__*/ (0, $bibO8.jsx)((0, $55TWT.default), {
                    id: "ptc-directory.settings.profile-and-visibility.profile-about-title",
                    defaultMessage: "About you",
                    description: "Title of a section that contains profile details settings"
                })
            }),
            userDetailsEditValues && /*#__PURE__*/ (0, $bibO8.jsx)((0, $a6efe9ce758ac994$export$2e2bcd8739ae039), {
                fieldTypes: $50fb87393b83172c$var$FIELD_TYPES_DETAILS,
                values: userDetailsEditValues,
                privacyValues: privacyValues,
                privacyOptions: privacyOptions,
                usersOrg: usersOrgName,
                onPrivacyLevelChange: privacyLevelChangeHandler,
                onSubmit: onSubmit
            }),
            /*#__PURE__*/ (0, $bibO8.jsx)($0c5cedf3c4dbc22e$export$210dc657affc8afd, {
                children: /*#__PURE__*/ (0, $bibO8.jsx)((0, $55TWT.default), {
                    id: "ptc-directory.settings.profile-and-visibility.profile-contact-title",
                    defaultMessage: "Contact",
                    description: "Title of a section that contains profile contact details settings"
                })
            }),
            userDetailsEditValues && /*#__PURE__*/ (0, $bibO8.jsx)((0, $a6efe9ce758ac994$export$2e2bcd8739ae039), {
                fieldTypes: $50fb87393b83172c$var$FIELD_TYPES_CONTACT,
                values: userDetailsEditValues,
                privacyValues: privacyValues,
                privacyOptions: privacyOptions,
                usersOrg: usersOrgName,
                onSubmit: onSubmit,
                onPrivacyLevelChange: privacyLevelChangeHandler
            }),
            userDetailsEditValues && /*#__PURE__*/ (0, $bibO8.jsx)((0, $zFJ4O.default), {
                task: (0, $7dUzb.ApdexTasks).VIEW_PROFILE_AND_VISIBILITY_SETTINGS
            })
        ]
    });
};
var $50fb87393b83172c$export$2e2bcd8739ae039 = $50fb87393b83172c$export$87e27da4bfd88fb8;


const $c2e88b3f3bcf6ba4$var$mapStateToProps = ({ user: user })=>({
        userId: user.data.accountId,
        isManaged: user.data.isManaged,
        managedByOrgName: user.data.managedByOrgName
    });
const $c2e88b3f3bcf6ba4$var$mapDispatchToProps = (dispatch)=>({
        addFlag: (flag)=>dispatch((0, $3kXiv.addFlag)(flag))
    });
const $c2e88b3f3bcf6ba4$var$ProfileAndVisibilitySettings = (0, $7PWYP.default)($c2e88b3f3bcf6ba4$var$mapStateToProps, $c2e88b3f3bcf6ba4$var$mapDispatchToProps)((0, $50fb87393b83172c$export$2e2bcd8739ae039));
var $c2e88b3f3bcf6ba4$export$2e2bcd8739ae039 = $c2e88b3f3bcf6ba4$var$ProfileAndVisibilitySettings;




parcelRequire("jShba");
var $53PE4 = parcelRequire("53PE4");
var $7dUzb = parcelRequire("7dUzb");
var $6e62a = parcelRequire("6e62a");
const $f59fe842ba85a97c$var$SettingsProfileAndPrivacyRoute = ()=>/*#__PURE__*/ (0, $bibO8.jsxs)((0, $bibO8.Fragment), {
        children: [
            /*#__PURE__*/ (0, $bibO8.jsx)((0, $53PE4.default), {
                task: (0, $7dUzb.ApdexTasks).VIEW_PROFILE_AND_VISIBILITY_SETTINGS
            }),
            /*#__PURE__*/ (0, $bibO8.jsx)((0, $6e62a.default), {}),
            /*#__PURE__*/ (0, $bibO8.jsx)((0, $c2e88b3f3bcf6ba4$export$2e2bcd8739ae039), {})
        ]
    });
var $f59fe842ba85a97c$export$2e2bcd8739ae039 = $f59fe842ba85a97c$var$SettingsProfileAndPrivacyRoute;



var $bibO8 = parcelRequire("bibO8");
parcelRequire("dAx5m");

var $cUsaH = parcelRequire("cUsaH");

const $06bef3ca13465cd6$var$LazyProductsSettings = (0, (/*@__PURE__*/$parcel$interopDefault($cUsaH)))({
    loader: ()=>(parcelRequire("jJ5hV")),
    loading: ()=>null
});
$06bef3ca13465cd6$var$LazyProductsSettings.displayName = "lazy(ProductsSettings)";
var $06bef3ca13465cd6$export$2e2bcd8739ae039 = $06bef3ca13465cd6$var$LazyProductsSettings;


parcelRequire("jShba");
var $53PE4 = parcelRequire("53PE4");
var $7dUzb = parcelRequire("7dUzb");
var $6e62a = parcelRequire("6e62a");
const $7d4aedb3fa4bae7c$var$SettingsProductsRoute = ()=>/*#__PURE__*/ (0, $bibO8.jsxs)((0, $bibO8.Fragment), {
        children: [
            /*#__PURE__*/ (0, $bibO8.jsx)((0, $53PE4.default), {
                task: (0, $7dUzb.ApdexTasks).VIEW_PRODUCT_SETTINGS
            }),
            /*#__PURE__*/ (0, $bibO8.jsx)((0, $6e62a.default), {}),
            /*#__PURE__*/ (0, $bibO8.jsx)((0, $06bef3ca13465cd6$export$2e2bcd8739ae039), {})
        ]
    });
var $7d4aedb3fa4bae7c$export$2e2bcd8739ae039 = $7d4aedb3fa4bae7c$var$SettingsProductsRoute;


const $caabdc77a4649b11$var$getLocationHashAndSearch = ({ hash: hash, search: search })=>`${hash}${search}`;
const $caabdc77a4649b11$var$PATH_ROOT = "/manage-profile";
const $caabdc77a4649b11$var$RedirectUnknownSettings = ()=>/*#__PURE__*/ (0, $bibO8.jsx)((0, $lairn.Navigate), {
        to: $caabdc77a4649b11$var$PATH_ROOT
    });
const $caabdc77a4649b11$var$RootSettingsRedirect = ()=>{
    const location = (0, $lairn.useLocation)();
    const hashAndSearch = $caabdc77a4649b11$var$getLocationHashAndSearch(location);
    return /*#__PURE__*/ (0, $bibO8.jsx)((0, $lairn.Navigate), {
        to: `${$caabdc77a4649b11$var$PATH_ROOT}/profile-and-visibility${hashAndSearch}`
    });
};
const $caabdc77a4649b11$export$e0be12ab605e08f8 = ()=>{
    const location = (0, $lairn.useLocation)();
    const previousPathnameRef = (0, $dAx5m.useRef)(location.pathname);
    (0, $dAx5m.useEffect)(()=>{
        if (location.pathname !== previousPathnameRef.current) {
            window.scrollTo(0, 0);
            previousPathnameRef.current = location.pathname;
        }
    }, [
        location.pathname
    ]);
};
const $caabdc77a4649b11$export$45bdb8ff4d1d3a71 = ()=>{
    $caabdc77a4649b11$export$e0be12ab605e08f8();
    return /*#__PURE__*/ (0, $bibO8.jsx)((0, $246e8413300e0573$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $bibO8.jsxs)((0, $lairn.Routes), {
            children: [
                /*#__PURE__*/ (0, $bibO8.jsx)((0, $lairn.Route), {
                    path: $caabdc77a4649b11$var$PATH_ROOT,
                    element: /*#__PURE__*/ (0, $bibO8.jsx)($caabdc77a4649b11$var$RootSettingsRedirect, {})
                }),
                /*#__PURE__*/ (0, $bibO8.jsx)((0, $lairn.Route), {
                    path: `${$caabdc77a4649b11$var$PATH_ROOT}/profile-and-visibility`,
                    element: /*#__PURE__*/ (0, $bibO8.jsx)((0, $f59fe842ba85a97c$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $bibO8.jsx)((0, $lairn.Route), {
                    path: `${$caabdc77a4649b11$var$PATH_ROOT}/email`,
                    element: /*#__PURE__*/ (0, $bibO8.jsx)((0, $0ad42f9537fa8997$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $bibO8.jsx)((0, $lairn.Route), {
                    path: `${$caabdc77a4649b11$var$PATH_ROOT}/security/two-step-verification`,
                    element: /*#__PURE__*/ (0, $bibO8.jsx)((0, $ef126aab1af83bed$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $bibO8.jsx)((0, $lairn.Route), {
                    path: `${$caabdc77a4649b11$var$PATH_ROOT}/security/api-tokens`,
                    element: /*#__PURE__*/ (0, $bibO8.jsx)((0, $8c1076b6398079c8$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $bibO8.jsx)((0, $lairn.Route), {
                    path: `${$caabdc77a4649b11$var$PATH_ROOT}/security/recent-devices`,
                    element: /*#__PURE__*/ (0, $bibO8.jsx)((0, $050897fcd648e93c$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $bibO8.jsx)((0, $lairn.Route), {
                    path: `${$caabdc77a4649b11$var$PATH_ROOT}/security`,
                    element: /*#__PURE__*/ (0, $bibO8.jsx)((0, $b247a9b30ddb4489$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $bibO8.jsx)((0, $lairn.Route), {
                    path: `${$caabdc77a4649b11$var$PATH_ROOT}/privacy`,
                    element: /*#__PURE__*/ (0, $bibO8.jsx)((0, $48034f65b5c62e9f$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $bibO8.jsx)((0, $lairn.Route), {
                    path: `${$caabdc77a4649b11$var$PATH_ROOT}/account-preferences`,
                    element: /*#__PURE__*/ (0, $bibO8.jsx)((0, $7b6ffbc1ec6149d0$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $bibO8.jsx)((0, $lairn.Route), {
                    path: `${$caabdc77a4649b11$var$PATH_ROOT}/apps`,
                    element: /*#__PURE__*/ (0, $bibO8.jsx)((0, $fc35749ea2d02931$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $bibO8.jsx)((0, $lairn.Route), {
                    path: `${$caabdc77a4649b11$var$PATH_ROOT}/link-preferences`,
                    element: /*#__PURE__*/ (0, $bibO8.jsx)((0, $a207c9463029025d$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $bibO8.jsx)((0, $lairn.Route), {
                    path: `${$caabdc77a4649b11$var$PATH_ROOT}/products`,
                    element: /*#__PURE__*/ (0, $bibO8.jsx)((0, $7d4aedb3fa4bae7c$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $bibO8.jsx)((0, $lairn.Route), {
                    path: `${$caabdc77a4649b11$var$PATH_ROOT}/close-account`,
                    element: /*#__PURE__*/ (0, $bibO8.jsx)((0, $72272c371acc936d$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $bibO8.jsx)((0, $lairn.Route), {
                    path: `${$caabdc77a4649b11$var$PATH_ROOT}/*`,
                    element: /*#__PURE__*/ (0, $bibO8.jsx)($caabdc77a4649b11$var$RedirectUnknownSettings, {})
                })
            ]
        })
    });
};
var $caabdc77a4649b11$export$2e2bcd8739ae039 = $caabdc77a4649b11$export$45bdb8ff4d1d3a71;


// TODO: PTC-2088 - simplify list of locales
// TODO: after @atlassian/ptc-embeddable-directory can load mesages by itself we can stop load AK profilecard messages in root src





























const $f4905cdb01e57c84$var$messagesConfig = [
    // Czech
    {
        locales: [
            "cs",
            "cs-CZ"
        ],
        loader: ()=>(parcelRequire("7NOng"))
    },
    // Danish
    {
        locales: [
            "da",
            "da-DK"
        ],
        loader: ()=>(parcelRequire("cYdtN"))
    },
    // German
    {
        locales: [
            "de",
            "de-DE"
        ],
        loader: ()=>(parcelRequire("hBDFq"))
    },
    // English (UK)
    {
        locales: [
            "en-GB"
        ],
        loader: ()=>(parcelRequire("lNy2N"))
    },
    // English (ZZ) - Used by i18n team in staging to upload visual context
    {
        locales: [
            "en-ZZ"
        ],
        loader: ()=>(parcelRequire("9rJaf"))
    },
    // Spain
    {
        locales: [
            "es",
            "es-ES"
        ],
        loader: ()=>(parcelRequire("9YMcj"))
    },
    // Estonian
    {
        locales: [
            "et",
            "et-EE"
        ],
        loader: ()=>(parcelRequire("kcKcT"))
    },
    // Finnish
    {
        locales: [
            "fi",
            "fi-FI"
        ],
        loader: ()=>(parcelRequire("1ufeS"))
    },
    // French
    {
        locales: [
            "fr",
            "fr-FR"
        ],
        loader: ()=>(parcelRequire("9hLrj"))
    },
    // Hungarian
    {
        locales: [
            "hu",
            "hu-HU"
        ],
        loader: ()=>(parcelRequire("Ot4RZ"))
    },
    // Icelandic
    {
        locales: [
            "is",
            "is-IS"
        ],
        loader: ()=>(parcelRequire("kpItI"))
    },
    // Italian
    {
        locales: [
            "it",
            "it-IT"
        ],
        loader: ()=>(parcelRequire("aOmuX"))
    },
    // Japanese
    {
        locales: [
            "ja",
            "ja-JP"
        ],
        loader: ()=>(parcelRequire("2rlJ6"))
    },
    // Korean
    {
        locales: [
            "ko",
            "ko-KR"
        ],
        loader: ()=>(parcelRequire("ar9IB"))
    },
    // Dutch
    {
        locales: [
            "nl",
            "nl-NL"
        ],
        loader: ()=>(parcelRequire("7FcXi"))
    },
    // Norwegian (Norway)
    {
        locales: [
            "nb",
            "nb-NO"
        ],
        loader: ()=>(parcelRequire("lWDom"))
    },
    // Polish
    {
        locales: [
            "pl",
            "pl-PL"
        ],
        loader: ()=>(parcelRequire("lgJbm"))
    },
    // Portuguese
    {
        locales: [
            "pt",
            "pt-PT"
        ],
        loader: ()=>(parcelRequire("gLtaN"))
    },
    // Portuguese -
    {
        locales: [
            "pt-BR"
        ],
        loader: ()=>(parcelRequire("5ZOAV"))
    },
    // Romanian
    {
        locales: [
            "ro",
            "ro-RO"
        ],
        loader: ()=>(parcelRequire("76gVk"))
    },
    // Russian
    {
        locales: [
            "ru",
            "ru-RU"
        ],
        loader: ()=>(parcelRequire("80lCc"))
    },
    // Slovakian
    {
        locales: [
            "sk",
            "sk-SK"
        ],
        loader: ()=>(parcelRequire("2EQ59"))
    },
    // Swedish
    {
        locales: [
            "sv",
            "sv-SE"
        ],
        loader: ()=>(parcelRequire("dRz54"))
    },
    // China uses Chinese (Simplified)
    {
        locales: [
            "zh",
            "zh-CN",
            "zh-Hans"
        ],
        loader: ()=>(parcelRequire("7BvRj"))
    },
    // Taiwan or Hong Kong uses Chinese (Traditional)
    {
        locales: [
            "zh-TW",
            "zh-HK",
            "zh-Hant"
        ],
        loader: ()=>(parcelRequire("lu27I"))
    },
    // Turkish
    {
        locales: [
            "tr",
            "tr-TR"
        ],
        loader: ()=>(parcelRequire("a9NoB"))
    },
    // Thai
    {
        locales: [
            "th",
            "th-TH"
        ],
        loader: ()=>(parcelRequire("dO3xV"))
    },
    // Ukrainian
    {
        locales: [
            "uk",
            "uk-UA"
        ],
        loader: ()=>(parcelRequire("1ueaC"))
    },
    // Vietnamese
    {
        locales: [
            "vi",
            "vi-VN"
        ],
        loader: ()=>(parcelRequire("4tA0t"))
    }
];
var $f4905cdb01e57c84$export$2e2bcd8739ae039 = $f4905cdb01e57c84$var$messagesConfig;



var $gPvnh = parcelRequire("gPvnh");
function $53046f2e0d5e1cc8$export$7eca4ea16d4c8343(config) {
    return {
        ...config,
        identityEnvironment: typeof config.identityEnvironment === "string" ? $53046f2e0d5e1cc8$var$environments[config.identityEnvironment] : {
            ...config.identityEnvironment
        },
        defaultLogoutContinueUrl: config.defaultLogoutContinueUrl || config.defaultContinueUrl
    };
}
const $53046f2e0d5e1cc8$var$environments = {
    dev: {
        baseUrl: "https://id.dev.internal.atlassian.com"
    },
    stg: {
        baseUrl: "https://id.stg.internal.atlassian.com"
    },
    prod: {
        baseUrl: "https://id.atlassian.com"
    }
};


class $78853da838d1e021$export$b8a928589413ca97 {
    constructor(config){
        this._config = (0, $53046f2e0d5e1cc8$export$7eca4ea16d4c8343)(config);
    }
    /** @override */ getManageProfileLink(user) {
        return this.getSessionSyncLink(`${this._config.identityEnvironment.baseUrl}/manage-profile`, user?.email);
    }
    /** @override */ getSessionSyncLink(destination, email) {
        if (email) {
            const url = this._createLink(destination);
            url.pathname = "/login";
            url.searchParams.append("prompt", "none");
            url.searchParams.append("login_hint", email);
            return url.toString();
        } else return destination;
    }
    /** @override */ getLoginLink(continueUrl = this._config.defaultContinueUrl) {
        const url = this._createLink(continueUrl);
        url.pathname = "/login";
        return url.toString();
    }
    /** @override */ getSwitchAccountLink(continueUrl = this._config.defaultContinueUrl) {
        const url = this._createLink(continueUrl);
        url.pathname = "/login";
        url.searchParams.append("prompt", "select_account");
        return url.toString();
    }
    /** @override */ getLogoutLink(continueUrl = this._config.defaultLogoutContinueUrl) {
        const url = this._createLink(continueUrl);
        url.pathname = "/logout";
        url.searchParams.append("prompt", "none");
        return url.toString();
    }
    _createLink(continueUrl) {
        const url = new URL(this._config.identityEnvironment.baseUrl);
        if (this._config.application) url.searchParams.append("application", this._config.application);
        url.searchParams.append("continue", continueUrl);
        return url;
    }
}


parcelRequire("jShba");
var $1Bj4T = parcelRequire("1Bj4T");
const $bc67cb7158847227$var$retryOptions = {
    minTimeout: 1000,
    retries: 4,
    factor: 2
};
/**
 * The retry npm package has become incompatible due to Parcel 2 scope-hoisting and retry not correctly exporting.
 *
 * Since the maintainer of the retry package seems to have abandoned the project, moving toward an internal
 * retry library.
 *
 * The following recreates the previous settings for retry; see for formula https://www.npmjs.com/package/retry
 */ const $bc67cb7158847227$var$intervalsMS = new Array($bc67cb7158847227$var$retryOptions.retries).fill(0).map((_, attempt)=>Math.max(1, $bc67cb7158847227$var$retryOptions.minTimeout) * Math.pow($bc67cb7158847227$var$retryOptions.factor, attempt), Infinity);
class $bc67cb7158847227$export$1582a199dfd557d7 extends (0, $78853da838d1e021$export$b8a928589413ca97) {
    constructor(config){
        super(config);
        this._listeners = [];
        this.recentAccountStorage = config.recentAccountStorage || window.localStorage;
        this._load();
    }
    /** @override */ addUserListener(callback) {
        this._listeners.push(callback);
        return ()=>{
            this._listeners = this._listeners.filter((listener)=>listener !== callback);
        };
    }
    /** @override */ async switchAccount(accountId) {
        const response = await fetch("/SetCST/switch", {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                accountId: accountId
            })
        });
        if (response.status !== 200) throw Object.assign(new Error(`Unexpected response from /SetCST/switch: ${response.status}`), {
            response: response
        });
    }
    /** @override */ async getRecentAssociatedSessions() {
        return (0, $gPvnh.retryOnException)(async ()=>{
            const response = await fetch("/SetCST/list");
            if (response.status === 200) {
                const sessions = await response.json();
                const recentAccounts = this._getRecentAccounts();
                const recentAccountIds = new Set(recentAccounts.map(({ userId: userId })=>userId));
                return sessions.associations.filter((session)=>recentAccountIds.has(session.accountId));
            } else throw Object.assign(new Error(`Unexpected response from /SetCST/list: ${response.status}`), {
                response: response
            });
        }, {
            intervalsMS: $bc67cb7158847227$var$intervalsMS
        });
    }
    _load() {
        (0, $gPvnh.retryOnException)(async ()=>{
            const response = await fetch(`${(0, $1Bj4T.getConfig)().stargateRoot}/me`, {
                mode: "cors",
                credentials: "include",
                headers: {
                    "Content-Type": "application/json"
                }
            });
            if (response.status === 200) {
                const user = await response.json();
                this._saveRecentAccount(user);
                return user;
            } else if (response.status === 401) return null;
            else throw Object.assign(new Error(`Unexpected response from /gateway/api/me: ${response.status}`), {
                response: response
            });
        }, {
            intervalsMS: $bc67cb7158847227$var$intervalsMS
        }).then((user)=>{
            this.currentUser = user;
            this._listeners.forEach((listener)=>listener(user));
        }, (error)=>{
            this.currentUser = null;
            this._listeners.forEach((listener)=>listener(null, error));
        });
    }
    _saveRecentAccount(user) {
        try {
            const recentAccounts = JSON.parse(this.recentAccountStorage.getItem("identity.recent.accounts") || "[]");
            const recentAccountIds = new Set(recentAccounts.map(({ userId: userId })=>userId));
            if (recentAccountIds.has(user.account_id)) return;
            this.recentAccountStorage.setItem("identity.recent.accounts", JSON.stringify([
                ...recentAccounts,
                {
                    userId: user.account_id,
                    lastUsed: Date.now()
                }
            ]));
        } catch (error) {}
    }
    _getRecentAccounts() {
        try {
            const recentAccounts = JSON.parse(this.recentAccountStorage.getItem("identity.recent.accounts") || "[]");
            return recentAccounts;
        } catch (error) {
            return [];
        }
    }
}



const $a3c4ad3cdfae1a46$export$7d5a1ca8914a19c4 = {
    account_id: "000000000000000000000000",
    email: "user@email.com",
    name: "User Name",
    picture: "https://avatar-management--avatars.us-west-2.prod.public.atl-paas.net/initials/AA-0.png",
    nickname: "Nickname",
    zoneinfo: "UTC",
    locale: "en-GB"
};
class $a3c4ad3cdfae1a46$export$67965021264ba822 extends (0, $78853da838d1e021$export$b8a928589413ca97) {
    constructor(config, user){
        super(config);
        this._listeners = [];
        this.currentUser = user;
    }
    /** @override */ addUserListener(callback) {
        this._listeners.push(callback);
        return ()=>{
            this._listeners = this._listeners.filter((listener)=>listener !== callback);
        };
    }
    /** @override */ async switchAccount() {}
    /** @override */ async getRecentAssociatedSessions() {
        return [];
    }
    setUser(user) {
        this.currentUser = user;
        this._listeners.forEach((listener)=>listener(user));
    }
}



class $673e778fc8841b04$export$b0129776ffdd5086 extends (0, $78853da838d1e021$export$b8a928589413ca97) {
    constructor(config, user){
        super(config);
        this.currentUser = user;
    }
    /** @override */ addUserListener(callback) {
        // Doesn't do anything yet
        return ()=>{};
    }
    /** @override */ async switchAccount() {}
    /** @override */ async getRecentAssociatedSessions() {
        return [];
    }
}






var $bibO8 = parcelRequire("bibO8");

var $dAx5m = parcelRequire("dAx5m");

parcelRequire("5Zreo");
var $lairn = parcelRequire("lairn");
const $7b3f00aad65df824$export$e338054fa926c14d = ({ children: children })=>{
    const { pathname: pathname } = (0, $lairn.useLocation)();
    (0, $dAx5m.useLayoutEffect)(()=>{
        (0, $35d0d19dac5ccba7$export$c08e7affcf78b064).startPageLoad();
    }, [
        pathname
    ]);
    return /*#__PURE__*/ (0, $bibO8.jsx)((0, $bibO8.Fragment), {
        children: children
    });
};



var $bibO8 = parcelRequire("bibO8");
parcelRequire("fWbo7");
var $kvFVg = parcelRequire("kvFVg");
var $920e9c57cee17876$exports = {};
"use strict";
var $920e9c57cee17876$var$__createBinding = $920e9c57cee17876$exports && $920e9c57cee17876$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $920e9c57cee17876$var$__exportStar = $920e9c57cee17876$exports && $920e9c57cee17876$exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $920e9c57cee17876$var$__createBinding(exports1, m, p);
};
Object.defineProperty($920e9c57cee17876$exports, "__esModule", {
    value: true
});

$920e9c57cee17876$var$__exportStar((parcelRequire("av9lC")), $920e9c57cee17876$exports);

$920e9c57cee17876$var$__exportStar((parcelRequire("gyREU")), $920e9c57cee17876$exports);

$920e9c57cee17876$var$__exportStar((parcelRequire("agmYQ")), $920e9c57cee17876$exports);



var $dAx5m = parcelRequire("dAx5m");

var $bibO8 = parcelRequire("bibO8");
var $4a5a3ca53b70a7da$exports = {};
function $4a5a3ca53b70a7da$var$asyncGeneratorStep(n, t, e, r, o, a, c) {
    try {
        var i = n[a](c), u = i.value;
    } catch (n) {
        return void e(n);
    }
    i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function $4a5a3ca53b70a7da$var$_asyncToGenerator(n) {
    return function() {
        var t = this, e = arguments;
        return new Promise(function(r, o) {
            var a = n.apply(t, e);
            function _next(n) {
                $4a5a3ca53b70a7da$var$asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
            }
            function _throw(n) {
                $4a5a3ca53b70a7da$var$asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
            }
            _next(void 0);
        });
    };
}
$4a5a3ca53b70a7da$exports = $4a5a3ca53b70a7da$var$_asyncToGenerator, $4a5a3ca53b70a7da$exports.__esModule = true, $4a5a3ca53b70a7da$exports["default"] = $4a5a3ca53b70a7da$exports;


var $18b530a0d79543fa$exports = {};
function $18b530a0d79543fa$var$_classCallCheck(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
$18b530a0d79543fa$exports = $18b530a0d79543fa$var$_classCallCheck, $18b530a0d79543fa$exports.__esModule = true, $18b530a0d79543fa$exports["default"] = $18b530a0d79543fa$exports;


var $f5eba97906508148$exports = {};
var $7922516817ec6a3f$exports = {};

var $9iRWr = parcelRequire("9iRWr");
var $7922516817ec6a3f$var$_typeof = $9iRWr.default;
var $8fe4d9a7c635cced$exports = {};

var $9iRWr = parcelRequire("9iRWr");
var $8fe4d9a7c635cced$var$_typeof = $9iRWr.default;
function $8fe4d9a7c635cced$var$toPrimitive(t, r) {
    if ("object" != $8fe4d9a7c635cced$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $8fe4d9a7c635cced$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
$8fe4d9a7c635cced$exports = $8fe4d9a7c635cced$var$toPrimitive, $8fe4d9a7c635cced$exports.__esModule = true, $8fe4d9a7c635cced$exports["default"] = $8fe4d9a7c635cced$exports;


function $7922516817ec6a3f$var$toPropertyKey(t) {
    var i = $8fe4d9a7c635cced$exports(t, "string");
    return "symbol" == $7922516817ec6a3f$var$_typeof(i) ? i : i + "";
}
$7922516817ec6a3f$exports = $7922516817ec6a3f$var$toPropertyKey, $7922516817ec6a3f$exports.__esModule = true, $7922516817ec6a3f$exports["default"] = $7922516817ec6a3f$exports;


function $f5eba97906508148$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, $7922516817ec6a3f$exports(o.key), o);
    }
}
function $f5eba97906508148$var$_createClass(e, r, t) {
    return r && $f5eba97906508148$var$_defineProperties(e.prototype, r), t && $f5eba97906508148$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}
$f5eba97906508148$exports = $f5eba97906508148$var$_createClass, $f5eba97906508148$exports.__esModule = true, $f5eba97906508148$exports["default"] = $f5eba97906508148$exports;


var $0b87255f9982dffe$exports = {};
// TODO(Babel 8): Remove this file.

var $0b87255f9982dffe$var$runtime = (parcelRequire("bzBux"))();
$0b87255f9982dffe$exports = $0b87255f9982dffe$var$runtime;
// Copied from https://github.com/facebook/regenerator/blob/main/packages/runtime/runtime.js#L736=
try {
    regeneratorRuntime = $0b87255f9982dffe$var$runtime;
} catch (accidentalStrictMode) {
    if (typeof globalThis === "object") globalThis.regeneratorRuntime = $0b87255f9982dffe$var$runtime;
    else Function("r", "regeneratorRuntime = r")($0b87255f9982dffe$var$runtime);
}


var $44507362edb10008$exports = {};
var $77a7e09c962294da$exports = {};
var $0be79738b2d86ef2$exports = {};
function $0be79738b2d86ef2$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $0be79738b2d86ef2$exports = $0be79738b2d86ef2$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $0be79738b2d86ef2$exports.__esModule = true, $0be79738b2d86ef2$exports["default"] = $0be79738b2d86ef2$exports, $0be79738b2d86ef2$var$_typeof(o);
}
$0be79738b2d86ef2$exports = $0be79738b2d86ef2$var$_typeof, $0be79738b2d86ef2$exports.__esModule = true, $0be79738b2d86ef2$exports["default"] = $0be79738b2d86ef2$exports;


var $77a7e09c962294da$var$_typeof = $0be79738b2d86ef2$exports.default;
var $55958b04fe961229$exports = {};

var $55958b04fe961229$var$_typeof = $0be79738b2d86ef2$exports.default;
function $55958b04fe961229$var$toPrimitive(t, r) {
    if ("object" != $55958b04fe961229$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $55958b04fe961229$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
$55958b04fe961229$exports = $55958b04fe961229$var$toPrimitive, $55958b04fe961229$exports.__esModule = true, $55958b04fe961229$exports["default"] = $55958b04fe961229$exports;


function $77a7e09c962294da$var$toPropertyKey(t) {
    var i = $55958b04fe961229$exports(t, "string");
    return "symbol" == $77a7e09c962294da$var$_typeof(i) ? i : i + "";
}
$77a7e09c962294da$exports = $77a7e09c962294da$var$toPropertyKey, $77a7e09c962294da$exports.__esModule = true, $77a7e09c962294da$exports["default"] = $77a7e09c962294da$exports;


function $44507362edb10008$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, $77a7e09c962294da$exports(o.key), o);
    }
}
function $44507362edb10008$var$_createClass(e, r, t) {
    return r && $44507362edb10008$var$_defineProperties(e.prototype, r), t && $44507362edb10008$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}
$44507362edb10008$exports = $44507362edb10008$var$_createClass, $44507362edb10008$exports.__esModule = true, $44507362edb10008$exports["default"] = $44507362edb10008$exports;


var $e2fb4f5d98a7c0f0$exports = {};
function $e2fb4f5d98a7c0f0$var$_classCallCheck(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
$e2fb4f5d98a7c0f0$exports = $e2fb4f5d98a7c0f0$var$_classCallCheck, $e2fb4f5d98a7c0f0$exports.__esModule = true, $e2fb4f5d98a7c0f0$exports["default"] = $e2fb4f5d98a7c0f0$exports;


var $bd3dcb1d661fde0b$exports = {};
var $83f85da8e5afcfbd$exports = {};
function $83f85da8e5afcfbd$var$_setPrototypeOf(t, e) {
    return $83f85da8e5afcfbd$exports = $83f85da8e5afcfbd$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $83f85da8e5afcfbd$exports.__esModule = true, $83f85da8e5afcfbd$exports["default"] = $83f85da8e5afcfbd$exports, $83f85da8e5afcfbd$var$_setPrototypeOf(t, e);
}
$83f85da8e5afcfbd$exports = $83f85da8e5afcfbd$var$_setPrototypeOf, $83f85da8e5afcfbd$exports.__esModule = true, $83f85da8e5afcfbd$exports["default"] = $83f85da8e5afcfbd$exports;


function $bd3dcb1d661fde0b$var$_inherits(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && $83f85da8e5afcfbd$exports(t, e);
}
$bd3dcb1d661fde0b$exports = $bd3dcb1d661fde0b$var$_inherits, $bd3dcb1d661fde0b$exports.__esModule = true, $bd3dcb1d661fde0b$exports["default"] = $bd3dcb1d661fde0b$exports;


var $0dcaef442910aebf$exports = {};

var $0dcaef442910aebf$var$_typeof = $0be79738b2d86ef2$exports.default;
var $c3f7be93f2c594c5$exports = {};
function $c3f7be93f2c594c5$var$_assertThisInitialized(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}
$c3f7be93f2c594c5$exports = $c3f7be93f2c594c5$var$_assertThisInitialized, $c3f7be93f2c594c5$exports.__esModule = true, $c3f7be93f2c594c5$exports["default"] = $c3f7be93f2c594c5$exports;


function $0dcaef442910aebf$var$_possibleConstructorReturn(t, e) {
    if (e && ("object" == $0dcaef442910aebf$var$_typeof(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return $c3f7be93f2c594c5$exports(t);
}
$0dcaef442910aebf$exports = $0dcaef442910aebf$var$_possibleConstructorReturn, $0dcaef442910aebf$exports.__esModule = true, $0dcaef442910aebf$exports["default"] = $0dcaef442910aebf$exports;


var $73b8372fdfde52ef$exports = {};
function $73b8372fdfde52ef$var$_getPrototypeOf(t) {
    return $73b8372fdfde52ef$exports = $73b8372fdfde52ef$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, $73b8372fdfde52ef$exports.__esModule = true, $73b8372fdfde52ef$exports["default"] = $73b8372fdfde52ef$exports, $73b8372fdfde52ef$var$_getPrototypeOf(t);
}
$73b8372fdfde52ef$exports = $73b8372fdfde52ef$var$_getPrototypeOf, $73b8372fdfde52ef$exports.__esModule = true, $73b8372fdfde52ef$exports["default"] = $73b8372fdfde52ef$exports;


var $d10ae151327fc24f$exports = {};


var $96674ee0d30145a0$exports = {};
function $96674ee0d30145a0$var$_isNativeFunction(t) {
    try {
        return -1 !== Function.toString.call(t).indexOf("[native code]");
    } catch (n) {
        return "function" == typeof t;
    }
}
$96674ee0d30145a0$exports = $96674ee0d30145a0$var$_isNativeFunction, $96674ee0d30145a0$exports.__esModule = true, $96674ee0d30145a0$exports["default"] = $96674ee0d30145a0$exports;


var $7ac3c41189c07685$exports = {};
var $dbb64f39b39d4c87$exports = {};
function $dbb64f39b39d4c87$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($dbb64f39b39d4c87$exports = $dbb64f39b39d4c87$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    }, $dbb64f39b39d4c87$exports.__esModule = true, $dbb64f39b39d4c87$exports["default"] = $dbb64f39b39d4c87$exports)();
}
$dbb64f39b39d4c87$exports = $dbb64f39b39d4c87$var$_isNativeReflectConstruct, $dbb64f39b39d4c87$exports.__esModule = true, $dbb64f39b39d4c87$exports["default"] = $dbb64f39b39d4c87$exports;



function $7ac3c41189c07685$var$_construct(t, e, r) {
    if ($dbb64f39b39d4c87$exports()) return Reflect.construct.apply(null, arguments);
    var o = [
        null
    ];
    o.push.apply(o, e);
    var p = new (t.bind.apply(t, o))();
    return r && $83f85da8e5afcfbd$exports(p, r.prototype), p;
}
$7ac3c41189c07685$exports = $7ac3c41189c07685$var$_construct, $7ac3c41189c07685$exports.__esModule = true, $7ac3c41189c07685$exports["default"] = $7ac3c41189c07685$exports;


function $d10ae151327fc24f$var$_wrapNativeSuper(t) {
    var r = "function" == typeof Map ? new Map() : void 0;
    return $d10ae151327fc24f$exports = $d10ae151327fc24f$var$_wrapNativeSuper = function _wrapNativeSuper(t) {
        if (null === t || !$96674ee0d30145a0$exports(t)) return t;
        if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function");
        if (void 0 !== r) {
            if (r.has(t)) return r.get(t);
            r.set(t, Wrapper);
        }
        function Wrapper() {
            return $7ac3c41189c07685$exports(t, arguments, $73b8372fdfde52ef$exports(this).constructor);
        }
        return Wrapper.prototype = Object.create(t.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: !1,
                writable: !0,
                configurable: !0
            }
        }), $83f85da8e5afcfbd$exports(Wrapper, t);
    }, $d10ae151327fc24f$exports.__esModule = true, $d10ae151327fc24f$exports["default"] = $d10ae151327fc24f$exports, $d10ae151327fc24f$var$_wrapNativeSuper(t);
}
$d10ae151327fc24f$exports = $d10ae151327fc24f$var$_wrapNativeSuper, $d10ae151327fc24f$exports.__esModule = true, $d10ae151327fc24f$exports["default"] = $d10ae151327fc24f$exports;



var $b3fa812ee964a518$exports = {};
var $1100298e5092eaa7$exports = {};
function $1100298e5092eaa7$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
$1100298e5092eaa7$exports = $1100298e5092eaa7$var$_arrayWithHoles, $1100298e5092eaa7$exports.__esModule = true, $1100298e5092eaa7$exports["default"] = $1100298e5092eaa7$exports;


var $7e7f3ea699d626b7$exports = {};
function $7e7f3ea699d626b7$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
$7e7f3ea699d626b7$exports = $7e7f3ea699d626b7$var$_iterableToArrayLimit, $7e7f3ea699d626b7$exports.__esModule = true, $7e7f3ea699d626b7$exports["default"] = $7e7f3ea699d626b7$exports;


var $707d17030bb83ad5$exports = {};
var $9526ccb66dc5cb7d$exports = {};
function $9526ccb66dc5cb7d$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
$9526ccb66dc5cb7d$exports = $9526ccb66dc5cb7d$var$_arrayLikeToArray, $9526ccb66dc5cb7d$exports.__esModule = true, $9526ccb66dc5cb7d$exports["default"] = $9526ccb66dc5cb7d$exports;


function $707d17030bb83ad5$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $9526ccb66dc5cb7d$exports(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $9526ccb66dc5cb7d$exports(r, a) : void 0;
    }
}
$707d17030bb83ad5$exports = $707d17030bb83ad5$var$_unsupportedIterableToArray, $707d17030bb83ad5$exports.__esModule = true, $707d17030bb83ad5$exports["default"] = $707d17030bb83ad5$exports;


var $86ddde427a2d1057$exports = {};
function $86ddde427a2d1057$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
$86ddde427a2d1057$exports = $86ddde427a2d1057$var$_nonIterableRest, $86ddde427a2d1057$exports.__esModule = true, $86ddde427a2d1057$exports["default"] = $86ddde427a2d1057$exports;


function $b3fa812ee964a518$var$_slicedToArray(r, e) {
    return $1100298e5092eaa7$exports(r) || $7e7f3ea699d626b7$exports(r, e) || $707d17030bb83ad5$exports(r, e) || $86ddde427a2d1057$exports();
}
$b3fa812ee964a518$exports = $b3fa812ee964a518$var$_slicedToArray, $b3fa812ee964a518$exports.__esModule = true, $b3fa812ee964a518$exports["default"] = $b3fa812ee964a518$exports;


var $8d7dfc0884542f0c$export$7debb50ef11d5e0b;
(function(util) {
    util.assertEqual = (val)=>val;
    function assertIs(_arg) {}
    util.assertIs = assertIs;
    function assertNever(_x) {
        throw new Error();
    }
    util.assertNever = assertNever;
    util.arrayToEnum = (items)=>{
        const obj = {};
        for (const item of items)obj[item] = item;
        return obj;
    };
    util.getValidEnumValues = (obj)=>{
        const validKeys = util.objectKeys(obj).filter((k)=>typeof obj[obj[k]] !== "number");
        const filtered = {};
        for (const k of validKeys)filtered[k] = obj[k];
        return util.objectValues(filtered);
    };
    util.objectValues = (obj)=>{
        return util.objectKeys(obj).map(function(e) {
            return obj[e];
        });
    };
    util.objectKeys = typeof Object.keys === "function" // eslint-disable-line ban/ban
     ? (obj)=>Object.keys(obj) // eslint-disable-line ban/ban
     : (object)=>{
        const keys = [];
        for(const key in object)if (Object.prototype.hasOwnProperty.call(object, key)) keys.push(key);
        return keys;
    };
    util.find = (arr, checker)=>{
        for (const item of arr){
            if (checker(item)) return item;
        }
        return undefined;
    };
    util.isInteger = typeof Number.isInteger === "function" ? (val)=>Number.isInteger(val) // eslint-disable-line ban/ban
     : (val)=>typeof val === "number" && isFinite(val) && Math.floor(val) === val;
    function joinValues(array, separator = " | ") {
        return array.map((val)=>typeof val === "string" ? `'${val}'` : val).join(separator);
    }
    util.joinValues = joinValues;
    util.jsonStringifyReplacer = (_, value)=>{
        if (typeof value === "bigint") return value.toString();
        return value;
    };
})($8d7dfc0884542f0c$export$7debb50ef11d5e0b || ($8d7dfc0884542f0c$export$7debb50ef11d5e0b = {}));
var $8d7dfc0884542f0c$export$4aa2142c225fd5c7;
(function(objectUtil) {
    objectUtil.mergeShapes = (first, second)=>{
        return {
            ...first,
            ...second
        };
    };
})($8d7dfc0884542f0c$export$4aa2142c225fd5c7 || ($8d7dfc0884542f0c$export$4aa2142c225fd5c7 = {}));
const $8d7dfc0884542f0c$export$5716da67bfaa244d = $8d7dfc0884542f0c$export$7debb50ef11d5e0b.arrayToEnum([
    "string",
    "nan",
    "number",
    "integer",
    "float",
    "boolean",
    "date",
    "bigint",
    "symbol",
    "function",
    "undefined",
    "null",
    "array",
    "object",
    "unknown",
    "promise",
    "void",
    "never",
    "map",
    "set"
]);
const $8d7dfc0884542f0c$export$3e9057828ebd5c7a = (data)=>{
    const t = typeof data;
    switch(t){
        case "undefined":
            return $8d7dfc0884542f0c$export$5716da67bfaa244d.undefined;
        case "string":
            return $8d7dfc0884542f0c$export$5716da67bfaa244d.string;
        case "number":
            return isNaN(data) ? $8d7dfc0884542f0c$export$5716da67bfaa244d.nan : $8d7dfc0884542f0c$export$5716da67bfaa244d.number;
        case "boolean":
            return $8d7dfc0884542f0c$export$5716da67bfaa244d.boolean;
        case "function":
            return $8d7dfc0884542f0c$export$5716da67bfaa244d.function;
        case "bigint":
            return $8d7dfc0884542f0c$export$5716da67bfaa244d.bigint;
        case "symbol":
            return $8d7dfc0884542f0c$export$5716da67bfaa244d.symbol;
        case "object":
            if (Array.isArray(data)) return $8d7dfc0884542f0c$export$5716da67bfaa244d.array;
            if (data === null) return $8d7dfc0884542f0c$export$5716da67bfaa244d.null;
            if (data.then && typeof data.then === "function" && data.catch && typeof data.catch === "function") return $8d7dfc0884542f0c$export$5716da67bfaa244d.promise;
            if (typeof Map !== "undefined" && data instanceof Map) return $8d7dfc0884542f0c$export$5716da67bfaa244d.map;
            if (typeof Set !== "undefined" && data instanceof Set) return $8d7dfc0884542f0c$export$5716da67bfaa244d.set;
            if (typeof Date !== "undefined" && data instanceof Date) return $8d7dfc0884542f0c$export$5716da67bfaa244d.date;
            return $8d7dfc0884542f0c$export$5716da67bfaa244d.object;
        default:
            return $8d7dfc0884542f0c$export$5716da67bfaa244d.unknown;
    }
};
const $8d7dfc0884542f0c$export$5ba560653e4a1035 = $8d7dfc0884542f0c$export$7debb50ef11d5e0b.arrayToEnum([
    "invalid_type",
    "invalid_literal",
    "custom",
    "invalid_union",
    "invalid_union_discriminator",
    "invalid_enum_value",
    "unrecognized_keys",
    "invalid_arguments",
    "invalid_return_type",
    "invalid_date",
    "invalid_string",
    "too_small",
    "too_big",
    "invalid_intersection_types",
    "not_multiple_of",
    "not_finite"
]);
const $8d7dfc0884542f0c$export$913eddeaf297cfea = (obj)=>{
    const json = JSON.stringify(obj, null, 2);
    return json.replace(/"([^"]+)":/g, "$1:");
};
class $8d7dfc0884542f0c$export$f98dac4b251ab333 extends Error {
    get errors() {
        return this.issues;
    }
    constructor(issues){
        super();
        this.issues = [];
        this.addIssue = (sub)=>{
            this.issues = [
                ...this.issues,
                sub
            ];
        };
        this.addIssues = (subs = [])=>{
            this.issues = [
                ...this.issues,
                ...subs
            ];
        };
        const actualProto = new.target.prototype;
        if (Object.setPrototypeOf) // eslint-disable-next-line ban/ban
        Object.setPrototypeOf(this, actualProto);
        else this.__proto__ = actualProto;
        this.name = "ZodError";
        this.issues = issues;
    }
    format(_mapper) {
        const mapper = _mapper || function(issue) {
            return issue.message;
        };
        const fieldErrors = {
            _errors: []
        };
        const processError = (error)=>{
            for (const issue of error.issues){
                if (issue.code === "invalid_union") issue.unionErrors.map(processError);
                else if (issue.code === "invalid_return_type") processError(issue.returnTypeError);
                else if (issue.code === "invalid_arguments") processError(issue.argumentsError);
                else if (issue.path.length === 0) fieldErrors._errors.push(mapper(issue));
                else {
                    let curr = fieldErrors;
                    let i = 0;
                    while(i < issue.path.length){
                        const el = issue.path[i];
                        const terminal = i === issue.path.length - 1;
                        if (!terminal) curr[el] = curr[el] || {
                            _errors: []
                        };
                        else {
                            curr[el] = curr[el] || {
                                _errors: []
                            };
                            curr[el]._errors.push(mapper(issue));
                        }
                        curr = curr[el];
                        i++;
                    }
                }
            }
        };
        processError(this);
        return fieldErrors;
    }
    static assert(value) {
        if (!(value instanceof $8d7dfc0884542f0c$export$f98dac4b251ab333)) throw new Error(`Not a ZodError: ${value}`);
    }
    toString() {
        return this.message;
    }
    get message() {
        return JSON.stringify(this.issues, $8d7dfc0884542f0c$export$7debb50ef11d5e0b.jsonStringifyReplacer, 2);
    }
    get isEmpty() {
        return this.issues.length === 0;
    }
    flatten(mapper = (issue)=>issue.message) {
        const fieldErrors = {};
        const formErrors = [];
        for (const sub of this.issues)if (sub.path.length > 0) {
            fieldErrors[sub.path[0]] = fieldErrors[sub.path[0]] || [];
            fieldErrors[sub.path[0]].push(mapper(sub));
        } else formErrors.push(mapper(sub));
        return {
            formErrors: formErrors,
            fieldErrors: fieldErrors
        };
    }
    get formErrors() {
        return this.flatten();
    }
}
$8d7dfc0884542f0c$export$f98dac4b251ab333.create = (issues)=>{
    const error = new $8d7dfc0884542f0c$export$f98dac4b251ab333(issues);
    return error;
};
const $8d7dfc0884542f0c$export$341b0b6e0a6f5099 = (issue, _ctx)=>{
    let message;
    switch(issue.code){
        case $8d7dfc0884542f0c$export$5ba560653e4a1035.invalid_type:
            if (issue.received === $8d7dfc0884542f0c$export$5716da67bfaa244d.undefined) message = "Required";
            else message = `Expected ${issue.expected}, received ${issue.received}`;
            break;
        case $8d7dfc0884542f0c$export$5ba560653e4a1035.invalid_literal:
            message = `Invalid literal value, expected ${JSON.stringify(issue.expected, $8d7dfc0884542f0c$export$7debb50ef11d5e0b.jsonStringifyReplacer)}`;
            break;
        case $8d7dfc0884542f0c$export$5ba560653e4a1035.unrecognized_keys:
            message = `Unrecognized key(s) in object: ${$8d7dfc0884542f0c$export$7debb50ef11d5e0b.joinValues(issue.keys, ", ")}`;
            break;
        case $8d7dfc0884542f0c$export$5ba560653e4a1035.invalid_union:
            message = `Invalid input`;
            break;
        case $8d7dfc0884542f0c$export$5ba560653e4a1035.invalid_union_discriminator:
            message = `Invalid discriminator value. Expected ${$8d7dfc0884542f0c$export$7debb50ef11d5e0b.joinValues(issue.options)}`;
            break;
        case $8d7dfc0884542f0c$export$5ba560653e4a1035.invalid_enum_value:
            message = `Invalid enum value. Expected ${$8d7dfc0884542f0c$export$7debb50ef11d5e0b.joinValues(issue.options)}, received '${issue.received}'`;
            break;
        case $8d7dfc0884542f0c$export$5ba560653e4a1035.invalid_arguments:
            message = `Invalid function arguments`;
            break;
        case $8d7dfc0884542f0c$export$5ba560653e4a1035.invalid_return_type:
            message = `Invalid function return type`;
            break;
        case $8d7dfc0884542f0c$export$5ba560653e4a1035.invalid_date:
            message = `Invalid date`;
            break;
        case $8d7dfc0884542f0c$export$5ba560653e4a1035.invalid_string:
            if (typeof issue.validation === "object") {
                if ("includes" in issue.validation) {
                    message = `Invalid input: must include "${issue.validation.includes}"`;
                    if (typeof issue.validation.position === "number") message = `${message} at one or more positions greater than or equal to ${issue.validation.position}`;
                } else if ("startsWith" in issue.validation) message = `Invalid input: must start with "${issue.validation.startsWith}"`;
                else if ("endsWith" in issue.validation) message = `Invalid input: must end with "${issue.validation.endsWith}"`;
                else $8d7dfc0884542f0c$export$7debb50ef11d5e0b.assertNever(issue.validation);
            } else if (issue.validation !== "regex") message = `Invalid ${issue.validation}`;
            else message = "Invalid";
            break;
        case $8d7dfc0884542f0c$export$5ba560653e4a1035.too_small:
            if (issue.type === "array") message = `Array must contain ${issue.exact ? "exactly" : issue.inclusive ? `at least` : `more than`} ${issue.minimum} element(s)`;
            else if (issue.type === "string") message = `String must contain ${issue.exact ? "exactly" : issue.inclusive ? `at least` : `over`} ${issue.minimum} character(s)`;
            else if (issue.type === "number") message = `Number must be ${issue.exact ? `exactly equal to ` : issue.inclusive ? `greater than or equal to ` : `greater than `}${issue.minimum}`;
            else if (issue.type === "date") message = `Date must be ${issue.exact ? `exactly equal to ` : issue.inclusive ? `greater than or equal to ` : `greater than `}${new Date(Number(issue.minimum))}`;
            else message = "Invalid input";
            break;
        case $8d7dfc0884542f0c$export$5ba560653e4a1035.too_big:
            if (issue.type === "array") message = `Array must contain ${issue.exact ? `exactly` : issue.inclusive ? `at most` : `less than`} ${issue.maximum} element(s)`;
            else if (issue.type === "string") message = `String must contain ${issue.exact ? `exactly` : issue.inclusive ? `at most` : `under`} ${issue.maximum} character(s)`;
            else if (issue.type === "number") message = `Number must be ${issue.exact ? `exactly` : issue.inclusive ? `less than or equal to` : `less than`} ${issue.maximum}`;
            else if (issue.type === "bigint") message = `BigInt must be ${issue.exact ? `exactly` : issue.inclusive ? `less than or equal to` : `less than`} ${issue.maximum}`;
            else if (issue.type === "date") message = `Date must be ${issue.exact ? `exactly` : issue.inclusive ? `smaller than or equal to` : `smaller than`} ${new Date(Number(issue.maximum))}`;
            else message = "Invalid input";
            break;
        case $8d7dfc0884542f0c$export$5ba560653e4a1035.custom:
            message = `Invalid input`;
            break;
        case $8d7dfc0884542f0c$export$5ba560653e4a1035.invalid_intersection_types:
            message = `Intersection results could not be merged`;
            break;
        case $8d7dfc0884542f0c$export$5ba560653e4a1035.not_multiple_of:
            message = `Number must be a multiple of ${issue.multipleOf}`;
            break;
        case $8d7dfc0884542f0c$export$5ba560653e4a1035.not_finite:
            message = "Number must be finite";
            break;
        default:
            message = _ctx.defaultError;
            $8d7dfc0884542f0c$export$7debb50ef11d5e0b.assertNever(issue);
    }
    return {
        message: message
    };
};
let $8d7dfc0884542f0c$var$overrideErrorMap = $8d7dfc0884542f0c$export$341b0b6e0a6f5099;
function $8d7dfc0884542f0c$export$1097a8289cfd22d7(map) {
    $8d7dfc0884542f0c$var$overrideErrorMap = map;
}
function $8d7dfc0884542f0c$export$32f27c719778d4c4() {
    return $8d7dfc0884542f0c$var$overrideErrorMap;
}
const $8d7dfc0884542f0c$export$244a85fde9c419ed = (params)=>{
    const { data: data, path: path, errorMaps: errorMaps, issueData: issueData } = params;
    const fullPath = [
        ...path,
        ...issueData.path || []
    ];
    const fullIssue = {
        ...issueData,
        path: fullPath
    };
    if (issueData.message !== undefined) return {
        ...issueData,
        path: fullPath,
        message: issueData.message
    };
    let errorMessage = "";
    const maps = errorMaps.filter((m)=>!!m).slice().reverse();
    for (const map of maps)errorMessage = map(fullIssue, {
        data: data,
        defaultError: errorMessage
    }).message;
    return {
        ...issueData,
        path: fullPath,
        message: errorMessage
    };
};
const $8d7dfc0884542f0c$export$1526d2e05f74572 = [];
function $8d7dfc0884542f0c$export$db7caee60e5d514d(ctx, issueData) {
    const overrideMap = $8d7dfc0884542f0c$export$32f27c719778d4c4();
    const issue = $8d7dfc0884542f0c$export$244a85fde9c419ed({
        issueData: issueData,
        data: ctx.data,
        path: ctx.path,
        errorMaps: [
            ctx.common.contextualErrorMap,
            ctx.schemaErrorMap,
            overrideMap,
            overrideMap === $8d7dfc0884542f0c$export$341b0b6e0a6f5099 ? undefined : $8d7dfc0884542f0c$export$341b0b6e0a6f5099
        ].filter((x)=>!!x)
    });
    ctx.common.issues.push(issue);
}
class $8d7dfc0884542f0c$export$5b20a5c3d05c1f6f {
    constructor(){
        this.value = "valid";
    }
    dirty() {
        if (this.value === "valid") this.value = "dirty";
    }
    abort() {
        if (this.value !== "aborted") this.value = "aborted";
    }
    static mergeArray(status, results) {
        const arrayValue = [];
        for (const s of results){
            if (s.status === "aborted") return $8d7dfc0884542f0c$export$9a105a556e65c2c0;
            if (s.status === "dirty") status.dirty();
            arrayValue.push(s.value);
        }
        return {
            status: status.value,
            value: arrayValue
        };
    }
    static async mergeObjectAsync(status, pairs) {
        const syncPairs = [];
        for (const pair of pairs){
            const key = await pair.key;
            const value = await pair.value;
            syncPairs.push({
                key: key,
                value: value
            });
        }
        return $8d7dfc0884542f0c$export$5b20a5c3d05c1f6f.mergeObjectSync(status, syncPairs);
    }
    static mergeObjectSync(status, pairs) {
        const finalObject = {};
        for (const pair of pairs){
            const { key: key, value: value } = pair;
            if (key.status === "aborted") return $8d7dfc0884542f0c$export$9a105a556e65c2c0;
            if (value.status === "aborted") return $8d7dfc0884542f0c$export$9a105a556e65c2c0;
            if (key.status === "dirty") status.dirty();
            if (value.status === "dirty") status.dirty();
            if (key.value !== "__proto__" && (typeof value.value !== "undefined" || pair.alwaysSet)) finalObject[key.value] = value.value;
        }
        return {
            status: status.value,
            value: finalObject
        };
    }
}
const $8d7dfc0884542f0c$export$9a105a556e65c2c0 = Object.freeze({
    status: "aborted"
});
const $8d7dfc0884542f0c$export$325a211da9693fcf = (value)=>({
        status: "dirty",
        value: value
    });
const $8d7dfc0884542f0c$export$c6813a8d51f77eaf = (value)=>({
        status: "valid",
        value: value
    });
const $8d7dfc0884542f0c$export$afa861e3c5730743 = (x)=>x.status === "aborted";
const $8d7dfc0884542f0c$export$910b6cdd390341b3 = (x)=>x.status === "dirty";
const $8d7dfc0884542f0c$export$1ea939691cdc45b8 = (x)=>x.status === "valid";
const $8d7dfc0884542f0c$export$aefee5ebe1dcfd9e = (x)=>typeof Promise !== "undefined" && x instanceof Promise;
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ function $8d7dfc0884542f0c$var$__classPrivateFieldGet(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $8d7dfc0884542f0c$var$__classPrivateFieldSet(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
typeof SuppressedError === "function" && SuppressedError;
var $8d7dfc0884542f0c$var$errorUtil;
(function(errorUtil) {
    errorUtil.errToObj = (message)=>typeof message === "string" ? {
            message: message
        } : message || {};
    errorUtil.toString = (message)=>typeof message === "string" ? message : message === null || message === void 0 ? void 0 : message.message;
})($8d7dfc0884542f0c$var$errorUtil || ($8d7dfc0884542f0c$var$errorUtil = {}));
var $8d7dfc0884542f0c$var$_ZodEnum_cache, $8d7dfc0884542f0c$var$_ZodNativeEnum_cache;
class $8d7dfc0884542f0c$var$ParseInputLazyPath {
    constructor(parent, value, path, key){
        this._cachedPath = [];
        this.parent = parent;
        this.data = value;
        this._path = path;
        this._key = key;
    }
    get path() {
        if (!this._cachedPath.length) {
            if (this._key instanceof Array) this._cachedPath.push(...this._path, ...this._key);
            else this._cachedPath.push(...this._path, this._key);
        }
        return this._cachedPath;
    }
}
const $8d7dfc0884542f0c$var$handleResult = (ctx, result)=>{
    if ($8d7dfc0884542f0c$export$1ea939691cdc45b8(result)) return {
        success: true,
        data: result.value
    };
    else {
        if (!ctx.common.issues.length) throw new Error("Validation failed but no issues detected.");
        return {
            success: false,
            get error () {
                if (this._error) return this._error;
                const error = new $8d7dfc0884542f0c$export$f98dac4b251ab333(ctx.common.issues);
                this._error = error;
                return this._error;
            }
        };
    }
};
function $8d7dfc0884542f0c$var$processCreateParams(params) {
    if (!params) return {};
    const { errorMap: errorMap, invalid_type_error: invalid_type_error, required_error: required_error, description: description } = params;
    if (errorMap && (invalid_type_error || required_error)) throw new Error(`Can't use "invalid_type_error" or "required_error" in conjunction with custom error map.`);
    if (errorMap) return {
        errorMap: errorMap,
        description: description
    };
    const customMap = (iss, ctx)=>{
        var _a, _b;
        const { message: message } = params;
        if (iss.code === "invalid_enum_value") return {
            message: message !== null && message !== void 0 ? message : ctx.defaultError
        };
        if (typeof ctx.data === "undefined") return {
            message: (_a = message !== null && message !== void 0 ? message : required_error) !== null && _a !== void 0 ? _a : ctx.defaultError
        };
        if (iss.code !== "invalid_type") return {
            message: ctx.defaultError
        };
        return {
            message: (_b = message !== null && message !== void 0 ? message : invalid_type_error) !== null && _b !== void 0 ? _b : ctx.defaultError
        };
    };
    return {
        errorMap: customMap,
        description: description
    };
}
class $8d7dfc0884542f0c$export$19342e026b58ebb7 {
    get description() {
        return this._def.description;
    }
    _getType(input) {
        return $8d7dfc0884542f0c$export$3e9057828ebd5c7a(input.data);
    }
    _getOrReturnCtx(input, ctx) {
        return ctx || {
            common: input.parent.common,
            data: input.data,
            parsedType: $8d7dfc0884542f0c$export$3e9057828ebd5c7a(input.data),
            schemaErrorMap: this._def.errorMap,
            path: input.path,
            parent: input.parent
        };
    }
    _processInputParams(input) {
        return {
            status: new $8d7dfc0884542f0c$export$5b20a5c3d05c1f6f(),
            ctx: {
                common: input.parent.common,
                data: input.data,
                parsedType: $8d7dfc0884542f0c$export$3e9057828ebd5c7a(input.data),
                schemaErrorMap: this._def.errorMap,
                path: input.path,
                parent: input.parent
            }
        };
    }
    _parseSync(input) {
        const result = this._parse(input);
        if ($8d7dfc0884542f0c$export$aefee5ebe1dcfd9e(result)) throw new Error("Synchronous parse encountered promise.");
        return result;
    }
    _parseAsync(input) {
        const result = this._parse(input);
        return Promise.resolve(result);
    }
    parse(data, params) {
        const result = this.safeParse(data, params);
        if (result.success) return result.data;
        throw result.error;
    }
    safeParse(data, params) {
        var _a;
        const ctx = {
            common: {
                issues: [],
                async: (_a = params === null || params === void 0 ? void 0 : params.async) !== null && _a !== void 0 ? _a : false,
                contextualErrorMap: params === null || params === void 0 ? void 0 : params.errorMap
            },
            path: (params === null || params === void 0 ? void 0 : params.path) || [],
            schemaErrorMap: this._def.errorMap,
            parent: null,
            data: data,
            parsedType: $8d7dfc0884542f0c$export$3e9057828ebd5c7a(data)
        };
        const result = this._parseSync({
            data: data,
            path: ctx.path,
            parent: ctx
        });
        return $8d7dfc0884542f0c$var$handleResult(ctx, result);
    }
    "~validate"(data) {
        var _a, _b;
        const ctx = {
            common: {
                issues: [],
                async: !!this["~standard"].async
            },
            path: [],
            schemaErrorMap: this._def.errorMap,
            parent: null,
            data: data,
            parsedType: $8d7dfc0884542f0c$export$3e9057828ebd5c7a(data)
        };
        if (!this["~standard"].async) try {
            const result = this._parseSync({
                data: data,
                path: [],
                parent: ctx
            });
            return $8d7dfc0884542f0c$export$1ea939691cdc45b8(result) ? {
                value: result.value
            } : {
                issues: ctx.common.issues
            };
        } catch (err) {
            if ((_b = (_a = err === null || err === void 0 ? void 0 : err.message) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === null || _b === void 0 ? void 0 : _b.includes("encountered")) this["~standard"].async = true;
            ctx.common = {
                issues: [],
                async: true
            };
        }
        return this._parseAsync({
            data: data,
            path: [],
            parent: ctx
        }).then((result)=>$8d7dfc0884542f0c$export$1ea939691cdc45b8(result) ? {
                value: result.value
            } : {
                issues: ctx.common.issues
            });
    }
    async parseAsync(data, params) {
        const result = await this.safeParseAsync(data, params);
        if (result.success) return result.data;
        throw result.error;
    }
    async safeParseAsync(data, params) {
        const ctx = {
            common: {
                issues: [],
                contextualErrorMap: params === null || params === void 0 ? void 0 : params.errorMap,
                async: true
            },
            path: (params === null || params === void 0 ? void 0 : params.path) || [],
            schemaErrorMap: this._def.errorMap,
            parent: null,
            data: data,
            parsedType: $8d7dfc0884542f0c$export$3e9057828ebd5c7a(data)
        };
        const maybeAsyncResult = this._parse({
            data: data,
            path: ctx.path,
            parent: ctx
        });
        const result = await ($8d7dfc0884542f0c$export$aefee5ebe1dcfd9e(maybeAsyncResult) ? maybeAsyncResult : Promise.resolve(maybeAsyncResult));
        return $8d7dfc0884542f0c$var$handleResult(ctx, result);
    }
    refine(check, message) {
        const getIssueProperties = (val)=>{
            if (typeof message === "string" || typeof message === "undefined") return {
                message: message
            };
            else if (typeof message === "function") return message(val);
            else return message;
        };
        return this._refinement((val, ctx)=>{
            const result = check(val);
            const setError = ()=>ctx.addIssue({
                    code: $8d7dfc0884542f0c$export$5ba560653e4a1035.custom,
                    ...getIssueProperties(val)
                });
            if (typeof Promise !== "undefined" && result instanceof Promise) return result.then((data)=>{
                if (!data) {
                    setError();
                    return false;
                } else return true;
            });
            if (!result) {
                setError();
                return false;
            } else return true;
        });
    }
    refinement(check, refinementData) {
        return this._refinement((val, ctx)=>{
            if (!check(val)) {
                ctx.addIssue(typeof refinementData === "function" ? refinementData(val, ctx) : refinementData);
                return false;
            } else return true;
        });
    }
    _refinement(refinement) {
        return new $8d7dfc0884542f0c$export$a60af00cc0ce2582({
            schema: this,
            typeName: $8d7dfc0884542f0c$export$558106ce543bd011.ZodEffects,
            effect: {
                type: "refinement",
                refinement: refinement
            }
        });
    }
    superRefine(refinement) {
        return this._refinement(refinement);
    }
    constructor(def){
        /** Alias of safeParseAsync */ this.spa = this.safeParseAsync;
        this._def = def;
        this.parse = this.parse.bind(this);
        this.safeParse = this.safeParse.bind(this);
        this.parseAsync = this.parseAsync.bind(this);
        this.safeParseAsync = this.safeParseAsync.bind(this);
        this.spa = this.spa.bind(this);
        this.refine = this.refine.bind(this);
        this.refinement = this.refinement.bind(this);
        this.superRefine = this.superRefine.bind(this);
        this.optional = this.optional.bind(this);
        this.nullable = this.nullable.bind(this);
        this.nullish = this.nullish.bind(this);
        this.array = this.array.bind(this);
        this.promise = this.promise.bind(this);
        this.or = this.or.bind(this);
        this.and = this.and.bind(this);
        this.transform = this.transform.bind(this);
        this.brand = this.brand.bind(this);
        this.default = this.default.bind(this);
        this.catch = this.catch.bind(this);
        this.describe = this.describe.bind(this);
        this.pipe = this.pipe.bind(this);
        this.readonly = this.readonly.bind(this);
        this.isNullable = this.isNullable.bind(this);
        this.isOptional = this.isOptional.bind(this);
        this["~standard"] = {
            version: 1,
            vendor: "zod",
            validate: (data)=>this["~validate"](data)
        };
    }
    optional() {
        return $8d7dfc0884542f0c$export$aa56fec1e9d629b8.create(this, this._def);
    }
    nullable() {
        return $8d7dfc0884542f0c$export$aaac0b8b429cef5.create(this, this._def);
    }
    nullish() {
        return this.nullable().optional();
    }
    array() {
        return $8d7dfc0884542f0c$export$7acfc3e64785411.create(this);
    }
    promise() {
        return $8d7dfc0884542f0c$export$3f196b0127d6e50a.create(this, this._def);
    }
    or(option) {
        return $8d7dfc0884542f0c$export$a8b236cb5070a311.create([
            this,
            option
        ], this._def);
    }
    and(incoming) {
        return $8d7dfc0884542f0c$export$c02deaf0bb5203d4.create(this, incoming, this._def);
    }
    transform(transform) {
        return new $8d7dfc0884542f0c$export$a60af00cc0ce2582({
            ...$8d7dfc0884542f0c$var$processCreateParams(this._def),
            schema: this,
            typeName: $8d7dfc0884542f0c$export$558106ce543bd011.ZodEffects,
            effect: {
                type: "transform",
                transform: transform
            }
        });
    }
    default(def) {
        const defaultValueFunc = typeof def === "function" ? def : ()=>def;
        return new $8d7dfc0884542f0c$export$bb19b37874861e7e({
            ...$8d7dfc0884542f0c$var$processCreateParams(this._def),
            innerType: this,
            defaultValue: defaultValueFunc,
            typeName: $8d7dfc0884542f0c$export$558106ce543bd011.ZodDefault
        });
    }
    brand() {
        return new $8d7dfc0884542f0c$export$66b0c798a395271f({
            typeName: $8d7dfc0884542f0c$export$558106ce543bd011.ZodBranded,
            type: this,
            ...$8d7dfc0884542f0c$var$processCreateParams(this._def)
        });
    }
    catch(def) {
        const catchValueFunc = typeof def === "function" ? def : ()=>def;
        return new $8d7dfc0884542f0c$export$75a44ec6249ac76b({
            ...$8d7dfc0884542f0c$var$processCreateParams(this._def),
            innerType: this,
            catchValue: catchValueFunc,
            typeName: $8d7dfc0884542f0c$export$558106ce543bd011.ZodCatch
        });
    }
    describe(description) {
        const This = this.constructor;
        return new This({
            ...this._def,
            description: description
        });
    }
    pipe(target) {
        return $8d7dfc0884542f0c$export$a3c3ef8a0e95c6da.create(this, target);
    }
    readonly() {
        return $8d7dfc0884542f0c$export$5d1f7ef05c4e493a.create(this);
    }
    isOptional() {
        return this.safeParse(undefined).success;
    }
    isNullable() {
        return this.safeParse(null).success;
    }
}
const $8d7dfc0884542f0c$var$cuidRegex = /^c[^\s-]{8,}$/i;
const $8d7dfc0884542f0c$var$cuid2Regex = /^[0-9a-z]+$/;
const $8d7dfc0884542f0c$var$ulidRegex = /^[0-9A-HJKMNP-TV-Z]{26}$/i;
// const uuidRegex =
//   /^([a-f0-9]{8}-[a-f0-9]{4}-[1-5][a-f0-9]{3}-[a-f0-9]{4}-[a-f0-9]{12}|00000000-0000-0000-0000-000000000000)$/i;
const $8d7dfc0884542f0c$var$uuidRegex = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/i;
const $8d7dfc0884542f0c$var$nanoidRegex = /^[a-z0-9_-]{21}$/i;
const $8d7dfc0884542f0c$var$jwtRegex = /^[A-Za-z0-9-_]+\.[A-Za-z0-9-_]+\.[A-Za-z0-9-_]*$/;
const $8d7dfc0884542f0c$var$durationRegex = /^[-+]?P(?!$)(?:(?:[-+]?\d+Y)|(?:[-+]?\d+[.,]\d+Y$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:(?:[-+]?\d+W)|(?:[-+]?\d+[.,]\d+W$))?(?:(?:[-+]?\d+D)|(?:[-+]?\d+[.,]\d+D$))?(?:T(?=[\d+-])(?:(?:[-+]?\d+H)|(?:[-+]?\d+[.,]\d+H$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:[-+]?\d+(?:[.,]\d+)?S)?)??$/;
// from https://stackoverflow.com/a/46181/1550155
// old version: too slow, didn't support unicode
// const emailRegex = /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i;
//old email regex
// const emailRegex = /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@((?!-)([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{1,})[^-<>()[\].,;:\s@"]$/i;
// eslint-disable-next-line
// const emailRegex =
//   /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\])|(\[IPv6:(([a-f0-9]{1,4}:){7}|::([a-f0-9]{1,4}:){0,6}|([a-f0-9]{1,4}:){1}:([a-f0-9]{1,4}:){0,5}|([a-f0-9]{1,4}:){2}:([a-f0-9]{1,4}:){0,4}|([a-f0-9]{1,4}:){3}:([a-f0-9]{1,4}:){0,3}|([a-f0-9]{1,4}:){4}:([a-f0-9]{1,4}:){0,2}|([a-f0-9]{1,4}:){5}:([a-f0-9]{1,4}:){0,1})([a-f0-9]{1,4}|(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2})))\])|([A-Za-z0-9]([A-Za-z0-9-]*[A-Za-z0-9])*(\.[A-Za-z]{2,})+))$/;
// const emailRegex =
//   /^[a-zA-Z0-9\.\!\#\$\%\&\'\*\+\/\=\?\^\_\`\{\|\}\~\-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
// const emailRegex =
//   /^(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/i;
const $8d7dfc0884542f0c$var$emailRegex = /^(?!\.)(?!.*\.\.)([A-Z0-9_'+\-\.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$/i;
// const emailRegex =
//   /^[a-z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-z0-9-]+(?:\.[a-z0-9\-]+)*$/i;
// from https://thekevinscott.com/emojis-in-javascript/#writing-a-regular-expression
const $8d7dfc0884542f0c$var$_emojiRegex = `^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$`;
let $8d7dfc0884542f0c$var$emojiRegex;
// faster, simpler, safer
const $8d7dfc0884542f0c$var$ipv4Regex = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])$/;
const $8d7dfc0884542f0c$var$ipv4CidrRegex = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\/(3[0-2]|[12]?[0-9])$/;
// const ipv6Regex =
// /^(([a-f0-9]{1,4}:){7}|::([a-f0-9]{1,4}:){0,6}|([a-f0-9]{1,4}:){1}:([a-f0-9]{1,4}:){0,5}|([a-f0-9]{1,4}:){2}:([a-f0-9]{1,4}:){0,4}|([a-f0-9]{1,4}:){3}:([a-f0-9]{1,4}:){0,3}|([a-f0-9]{1,4}:){4}:([a-f0-9]{1,4}:){0,2}|([a-f0-9]{1,4}:){5}:([a-f0-9]{1,4}:){0,1})([a-f0-9]{1,4}|(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2})))$/;
const $8d7dfc0884542f0c$var$ipv6Regex = /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))$/;
const $8d7dfc0884542f0c$var$ipv6CidrRegex = /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))\/(12[0-8]|1[01][0-9]|[1-9]?[0-9])$/;
// https://stackoverflow.com/questions/7860392/determine-if-string-is-in-base64-using-javascript
const $8d7dfc0884542f0c$var$base64Regex = /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/;
// https://base64.guru/standards/base64url
const $8d7dfc0884542f0c$var$base64urlRegex = /^([0-9a-zA-Z-_]{4})*(([0-9a-zA-Z-_]{2}(==)?)|([0-9a-zA-Z-_]{3}(=)?))?$/;
// simple
// const dateRegexSource = `\\d{4}-\\d{2}-\\d{2}`;
// no leap year validation
// const dateRegexSource = `\\d{4}-((0[13578]|10|12)-31|(0[13-9]|1[0-2])-30|(0[1-9]|1[0-2])-(0[1-9]|1\\d|2\\d))`;
// with leap year validation
const $8d7dfc0884542f0c$var$dateRegexSource = `((\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-((0[13578]|1[02])-(0[1-9]|[12]\\d|3[01])|(0[469]|11)-(0[1-9]|[12]\\d|30)|(02)-(0[1-9]|1\\d|2[0-8])))`;
const $8d7dfc0884542f0c$var$dateRegex = new RegExp(`^${$8d7dfc0884542f0c$var$dateRegexSource}$`);
function $8d7dfc0884542f0c$var$timeRegexSource(args) {
    // let regex = `\\d{2}:\\d{2}:\\d{2}`;
    let regex = `([01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d`;
    if (args.precision) regex = `${regex}\\.\\d{${args.precision}}`;
    else if (args.precision == null) regex = `${regex}(\\.\\d+)?`;
    return regex;
}
function $8d7dfc0884542f0c$var$timeRegex(args) {
    return new RegExp(`^${$8d7dfc0884542f0c$var$timeRegexSource(args)}$`);
}
// Adapted from https://stackoverflow.com/a/3143231
function $8d7dfc0884542f0c$export$a4b563879add27a(args) {
    let regex = `${$8d7dfc0884542f0c$var$dateRegexSource}T${$8d7dfc0884542f0c$var$timeRegexSource(args)}`;
    const opts = [];
    opts.push(args.local ? `Z?` : `Z`);
    if (args.offset) opts.push(`([+-]\\d{2}:?\\d{2})`);
    regex = `${regex}(${opts.join("|")})`;
    return new RegExp(`^${regex}$`);
}
function $8d7dfc0884542f0c$var$isValidIP(ip, version) {
    if ((version === "v4" || !version) && $8d7dfc0884542f0c$var$ipv4Regex.test(ip)) return true;
    if ((version === "v6" || !version) && $8d7dfc0884542f0c$var$ipv6Regex.test(ip)) return true;
    return false;
}
function $8d7dfc0884542f0c$var$isValidJWT(jwt, alg) {
    if (!$8d7dfc0884542f0c$var$jwtRegex.test(jwt)) return false;
    try {
        const [header] = jwt.split(".");
        // Convert base64url to base64
        const base64 = header.replace(/-/g, "+").replace(/_/g, "/").padEnd(header.length + (4 - header.length % 4) % 4, "=");
        const decoded = JSON.parse(atob(base64));
        if (typeof decoded !== "object" || decoded === null) return false;
        if (!decoded.typ || !decoded.alg) return false;
        if (alg && decoded.alg !== alg) return false;
        return true;
    } catch (_a) {
        return false;
    }
}
function $8d7dfc0884542f0c$var$isValidCidr(ip, version) {
    if ((version === "v4" || !version) && $8d7dfc0884542f0c$var$ipv4CidrRegex.test(ip)) return true;
    if ((version === "v6" || !version) && $8d7dfc0884542f0c$var$ipv6CidrRegex.test(ip)) return true;
    return false;
}
class $8d7dfc0884542f0c$export$1230eb29b8d3b502 extends $8d7dfc0884542f0c$export$19342e026b58ebb7 {
    _parse(input) {
        if (this._def.coerce) input.data = String(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== $8d7dfc0884542f0c$export$5716da67bfaa244d.string) {
            const ctx = this._getOrReturnCtx(input);
            $8d7dfc0884542f0c$export$db7caee60e5d514d(ctx, {
                code: $8d7dfc0884542f0c$export$5ba560653e4a1035.invalid_type,
                expected: $8d7dfc0884542f0c$export$5716da67bfaa244d.string,
                received: ctx.parsedType
            });
            return $8d7dfc0884542f0c$export$9a105a556e65c2c0;
        }
        const status = new $8d7dfc0884542f0c$export$5b20a5c3d05c1f6f();
        let ctx = undefined;
        for (const check of this._def.checks){
            if (check.kind === "min") {
                if (input.data.length < check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $8d7dfc0884542f0c$export$db7caee60e5d514d(ctx, {
                        code: $8d7dfc0884542f0c$export$5ba560653e4a1035.too_small,
                        minimum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: false,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "max") {
                if (input.data.length > check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $8d7dfc0884542f0c$export$db7caee60e5d514d(ctx, {
                        code: $8d7dfc0884542f0c$export$5ba560653e4a1035.too_big,
                        maximum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: false,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "length") {
                const tooBig = input.data.length > check.value;
                const tooSmall = input.data.length < check.value;
                if (tooBig || tooSmall) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    if (tooBig) $8d7dfc0884542f0c$export$db7caee60e5d514d(ctx, {
                        code: $8d7dfc0884542f0c$export$5ba560653e4a1035.too_big,
                        maximum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: true,
                        message: check.message
                    });
                    else if (tooSmall) $8d7dfc0884542f0c$export$db7caee60e5d514d(ctx, {
                        code: $8d7dfc0884542f0c$export$5ba560653e4a1035.too_small,
                        minimum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: true,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "email") {
                if (!$8d7dfc0884542f0c$var$emailRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $8d7dfc0884542f0c$export$db7caee60e5d514d(ctx, {
                        validation: "email",
                        code: $8d7dfc0884542f0c$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "emoji") {
                if (!$8d7dfc0884542f0c$var$emojiRegex) $8d7dfc0884542f0c$var$emojiRegex = new RegExp($8d7dfc0884542f0c$var$_emojiRegex, "u");
                if (!$8d7dfc0884542f0c$var$emojiRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $8d7dfc0884542f0c$export$db7caee60e5d514d(ctx, {
                        validation: "emoji",
                        code: $8d7dfc0884542f0c$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "uuid") {
                if (!$8d7dfc0884542f0c$var$uuidRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $8d7dfc0884542f0c$export$db7caee60e5d514d(ctx, {
                        validation: "uuid",
                        code: $8d7dfc0884542f0c$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "nanoid") {
                if (!$8d7dfc0884542f0c$var$nanoidRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $8d7dfc0884542f0c$export$db7caee60e5d514d(ctx, {
                        validation: "nanoid",
                        code: $8d7dfc0884542f0c$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "cuid") {
                if (!$8d7dfc0884542f0c$var$cuidRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $8d7dfc0884542f0c$export$db7caee60e5d514d(ctx, {
                        validation: "cuid",
                        code: $8d7dfc0884542f0c$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "cuid2") {
                if (!$8d7dfc0884542f0c$var$cuid2Regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $8d7dfc0884542f0c$export$db7caee60e5d514d(ctx, {
                        validation: "cuid2",
                        code: $8d7dfc0884542f0c$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "ulid") {
                if (!$8d7dfc0884542f0c$var$ulidRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $8d7dfc0884542f0c$export$db7caee60e5d514d(ctx, {
                        validation: "ulid",
                        code: $8d7dfc0884542f0c$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "url") try {
                new URL(input.data);
            } catch (_a) {
                ctx = this._getOrReturnCtx(input, ctx);
                $8d7dfc0884542f0c$export$db7caee60e5d514d(ctx, {
                    validation: "url",
                    code: $8d7dfc0884542f0c$export$5ba560653e4a1035.invalid_string,
                    message: check.message
                });
                status.dirty();
            }
            else if (check.kind === "regex") {
                check.regex.lastIndex = 0;
                const testResult = check.regex.test(input.data);
                if (!testResult) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $8d7dfc0884542f0c$export$db7caee60e5d514d(ctx, {
                        validation: "regex",
                        code: $8d7dfc0884542f0c$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "trim") input.data = input.data.trim();
            else if (check.kind === "includes") {
                if (!input.data.includes(check.value, check.position)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $8d7dfc0884542f0c$export$db7caee60e5d514d(ctx, {
                        code: $8d7dfc0884542f0c$export$5ba560653e4a1035.invalid_string,
                        validation: {
                            includes: check.value,
                            position: check.position
                        },
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "toLowerCase") input.data = input.data.toLowerCase();
            else if (check.kind === "toUpperCase") input.data = input.data.toUpperCase();
            else if (check.kind === "startsWith") {
                if (!input.data.startsWith(check.value)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $8d7dfc0884542f0c$export$db7caee60e5d514d(ctx, {
                        code: $8d7dfc0884542f0c$export$5ba560653e4a1035.invalid_string,
                        validation: {
                            startsWith: check.value
                        },
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "endsWith") {
                if (!input.data.endsWith(check.value)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $8d7dfc0884542f0c$export$db7caee60e5d514d(ctx, {
                        code: $8d7dfc0884542f0c$export$5ba560653e4a1035.invalid_string,
                        validation: {
                            endsWith: check.value
                        },
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "datetime") {
                const regex = $8d7dfc0884542f0c$export$a4b563879add27a(check);
                if (!regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $8d7dfc0884542f0c$export$db7caee60e5d514d(ctx, {
                        code: $8d7dfc0884542f0c$export$5ba560653e4a1035.invalid_string,
                        validation: "datetime",
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "date") {
                const regex = $8d7dfc0884542f0c$var$dateRegex;
                if (!regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $8d7dfc0884542f0c$export$db7caee60e5d514d(ctx, {
                        code: $8d7dfc0884542f0c$export$5ba560653e4a1035.invalid_string,
                        validation: "date",
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "time") {
                const regex = $8d7dfc0884542f0c$var$timeRegex(check);
                if (!regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $8d7dfc0884542f0c$export$db7caee60e5d514d(ctx, {
                        code: $8d7dfc0884542f0c$export$5ba560653e4a1035.invalid_string,
                        validation: "time",
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "duration") {
                if (!$8d7dfc0884542f0c$var$durationRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $8d7dfc0884542f0c$export$db7caee60e5d514d(ctx, {
                        validation: "duration",
                        code: $8d7dfc0884542f0c$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "ip") {
                if (!$8d7dfc0884542f0c$var$isValidIP(input.data, check.version)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $8d7dfc0884542f0c$export$db7caee60e5d514d(ctx, {
                        validation: "ip",
                        code: $8d7dfc0884542f0c$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "jwt") {
                if (!$8d7dfc0884542f0c$var$isValidJWT(input.data, check.alg)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $8d7dfc0884542f0c$export$db7caee60e5d514d(ctx, {
                        validation: "jwt",
                        code: $8d7dfc0884542f0c$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "cidr") {
                if (!$8d7dfc0884542f0c$var$isValidCidr(input.data, check.version)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $8d7dfc0884542f0c$export$db7caee60e5d514d(ctx, {
                        validation: "cidr",
                        code: $8d7dfc0884542f0c$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "base64") {
                if (!$8d7dfc0884542f0c$var$base64Regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $8d7dfc0884542f0c$export$db7caee60e5d514d(ctx, {
                        validation: "base64",
                        code: $8d7dfc0884542f0c$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "base64url") {
                if (!$8d7dfc0884542f0c$var$base64urlRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $8d7dfc0884542f0c$export$db7caee60e5d514d(ctx, {
                        validation: "base64url",
                        code: $8d7dfc0884542f0c$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else $8d7dfc0884542f0c$export$7debb50ef11d5e0b.assertNever(check);
        }
        return {
            status: status.value,
            value: input.data
        };
    }
    _regex(regex, validation, message) {
        return this.refinement((data)=>regex.test(data), {
            validation: validation,
            code: $8d7dfc0884542f0c$export$5ba560653e4a1035.invalid_string,
            ...$8d7dfc0884542f0c$var$errorUtil.errToObj(message)
        });
    }
    _addCheck(check) {
        return new $8d7dfc0884542f0c$export$1230eb29b8d3b502({
            ...this._def,
            checks: [
                ...this._def.checks,
                check
            ]
        });
    }
    email(message) {
        return this._addCheck({
            kind: "email",
            ...$8d7dfc0884542f0c$var$errorUtil.errToObj(message)
        });
    }
    url(message) {
        return this._addCheck({
            kind: "url",
            ...$8d7dfc0884542f0c$var$errorUtil.errToObj(message)
        });
    }
    emoji(message) {
        return this._addCheck({
            kind: "emoji",
            ...$8d7dfc0884542f0c$var$errorUtil.errToObj(message)
        });
    }
    uuid(message) {
        return this._addCheck({
            kind: "uuid",
            ...$8d7dfc0884542f0c$var$errorUtil.errToObj(message)
        });
    }
    nanoid(message) {
        return this._addCheck({
            kind: "nanoid",
            ...$8d7dfc0884542f0c$var$errorUtil.errToObj(message)
        });
    }
    cuid(message) {
        return this._addCheck({
            kind: "cuid",
            ...$8d7dfc0884542f0c$var$errorUtil.errToObj(message)
        });
    }
    cuid2(message) {
        return this._addCheck({
            kind: "cuid2",
            ...$8d7dfc0884542f0c$var$errorUtil.errToObj(message)
        });
    }
    ulid(message) {
        return this._addCheck({
            kind: "ulid",
            ...$8d7dfc0884542f0c$var$errorUtil.errToObj(message)
        });
    }
    base64(message) {
        return this._addCheck({
            kind: "base64",
            ...$8d7dfc0884542f0c$var$errorUtil.errToObj(message)
        });
    }
    base64url(message) {
        // base64url encoding is a modification of base64 that can safely be used in URLs and filenames
        return this._addCheck({
            kind: "base64url",
            ...$8d7dfc0884542f0c$var$errorUtil.errToObj(message)
        });
    }
    jwt(options) {
        return this._addCheck({
            kind: "jwt",
            ...$8d7dfc0884542f0c$var$errorUtil.errToObj(options)
        });
    }
    ip(options) {
        return this._addCheck({
            kind: "ip",
            ...$8d7dfc0884542f0c$var$errorUtil.errToObj(options)
        });
    }
    cidr(options) {
        return this._addCheck({
            kind: "cidr",
            ...$8d7dfc0884542f0c$var$errorUtil.errToObj(options)
        });
    }
    datetime(options) {
        var _a, _b;
        if (typeof options === "string") return this._addCheck({
            kind: "datetime",
            precision: null,
            offset: false,
            local: false,
            message: options
        });
        return this._addCheck({
            kind: "datetime",
            precision: typeof (options === null || options === void 0 ? void 0 : options.precision) === "undefined" ? null : options === null || options === void 0 ? void 0 : options.precision,
            offset: (_a = options === null || options === void 0 ? void 0 : options.offset) !== null && _a !== void 0 ? _a : false,
            local: (_b = options === null || options === void 0 ? void 0 : options.local) !== null && _b !== void 0 ? _b : false,
            ...$8d7dfc0884542f0c$var$errorUtil.errToObj(options === null || options === void 0 ? void 0 : options.message)
        });
    }
    date(message) {
        return this._addCheck({
            kind: "date",
            message: message
        });
    }
    time(options) {
        if (typeof options === "string") return this._addCheck({
            kind: "time",
            precision: null,
            message: options
        });
        return this._addCheck({
            kind: "time",
            precision: typeof (options === null || options === void 0 ? void 0 : options.precision) === "undefined" ? null : options === null || options === void 0 ? void 0 : options.precision,
            ...$8d7dfc0884542f0c$var$errorUtil.errToObj(options === null || options === void 0 ? void 0 : options.message)
        });
    }
    duration(message) {
        return this._addCheck({
            kind: "duration",
            ...$8d7dfc0884542f0c$var$errorUtil.errToObj(message)
        });
    }
    regex(regex, message) {
        return this._addCheck({
            kind: "regex",
            regex: regex,
            ...$8d7dfc0884542f0c$var$errorUtil.errToObj(message)
        });
    }
    includes(value, options) {
        return this._addCheck({
            kind: "includes",
            value: value,
            position: options === null || options === void 0 ? void 0 : options.position,
            ...$8d7dfc0884542f0c$var$errorUtil.errToObj(options === null || options === void 0 ? void 0 : options.message)
        });
    }
    startsWith(value, message) {
        return this._addCheck({
            kind: "startsWith",
            value: value,
            ...$8d7dfc0884542f0c$var$errorUtil.errToObj(message)
        });
    }
    endsWith(value, message) {
        return this._addCheck({
            kind: "endsWith",
            value: value,
            ...$8d7dfc0884542f0c$var$errorUtil.errToObj(message)
        });
    }
    min(minLength, message) {
        return this._addCheck({
            kind: "min",
            value: minLength,
            ...$8d7dfc0884542f0c$var$errorUtil.errToObj(message)
        });
    }
    max(maxLength, message) {
        return this._addCheck({
            kind: "max",
            value: maxLength,
            ...$8d7dfc0884542f0c$var$errorUtil.errToObj(message)
        });
    }
    length(len, message) {
        return this._addCheck({
            kind: "length",
            value: len,
            ...$8d7dfc0884542f0c$var$errorUtil.errToObj(message)
        });
    }
    /**
     * Equivalent to `.min(1)`
     */ nonempty(message) {
        return this.min(1, $8d7dfc0884542f0c$var$errorUtil.errToObj(message));
    }
    trim() {
        return new $8d7dfc0884542f0c$export$1230eb29b8d3b502({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind: "trim"
                }
            ]
        });
    }
    toLowerCase() {
        return new $8d7dfc0884542f0c$export$1230eb29b8d3b502({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind: "toLowerCase"
                }
            ]
        });
    }
    toUpperCase() {
        return new $8d7dfc0884542f0c$export$1230eb29b8d3b502({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind: "toUpperCase"
                }
            ]
        });
    }
    get isDatetime() {
        return !!this._def.checks.find((ch)=>ch.kind === "datetime");
    }
    get isDate() {
        return !!this._def.checks.find((ch)=>ch.kind === "date");
    }
    get isTime() {
        return !!this._def.checks.find((ch)=>ch.kind === "time");
    }
    get isDuration() {
        return !!this._def.checks.find((ch)=>ch.kind === "duration");
    }
    get isEmail() {
        return !!this._def.checks.find((ch)=>ch.kind === "email");
    }
    get isURL() {
        return !!this._def.checks.find((ch)=>ch.kind === "url");
    }
    get isEmoji() {
        return !!this._def.checks.find((ch)=>ch.kind === "emoji");
    }
    get isUUID() {
        return !!this._def.checks.find((ch)=>ch.kind === "uuid");
    }
    get isNANOID() {
        return !!this._def.checks.find((ch)=>ch.kind === "nanoid");
    }
    get isCUID() {
        return !!this._def.checks.find((ch)=>ch.kind === "cuid");
    }
    get isCUID2() {
        return !!this._def.checks.find((ch)=>ch.kind === "cuid2");
    }
    get isULID() {
        return !!this._def.checks.find((ch)=>ch.kind === "ulid");
    }
    get isIP() {
        return !!this._def.checks.find((ch)=>ch.kind === "ip");
    }
    get isCIDR() {
        return !!this._def.checks.find((ch)=>ch.kind === "cidr");
    }
    get isBase64() {
        return !!this._def.checks.find((ch)=>ch.kind === "base64");
    }
    get isBase64url() {
        // base64url encoding is a modification of base64 that can safely be used in URLs and filenames
        return !!this._def.checks.find((ch)=>ch.kind === "base64url");
    }
    get minLength() {
        let min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            }
        }
        return min;
    }
    get maxLength() {
        let max = null;
        for (const ch of this._def.checks){
            if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return max;
    }
}
$8d7dfc0884542f0c$export$1230eb29b8d3b502.create = (params)=>{
    var _a;
    return new $8d7dfc0884542f0c$export$1230eb29b8d3b502({
        checks: [],
        typeName: $8d7dfc0884542f0c$export$558106ce543bd011.ZodString,
        coerce: (_a = params === null || params === void 0 ? void 0 : params.coerce) !== null && _a !== void 0 ? _a : false,
        ...$8d7dfc0884542f0c$var$processCreateParams(params)
    });
};
// https://stackoverflow.com/questions/3966484/why-does-modulus-operator-return-fractional-number-in-javascript/31711034#31711034
function $8d7dfc0884542f0c$var$floatSafeRemainder(val, step) {
    const valDecCount = (val.toString().split(".")[1] || "").length;
    const stepDecCount = (step.toString().split(".")[1] || "").length;
    const decCount = valDecCount > stepDecCount ? valDecCount : stepDecCount;
    const valInt = parseInt(val.toFixed(decCount).replace(".", ""));
    const stepInt = parseInt(step.toFixed(decCount).replace(".", ""));
    return valInt % stepInt / Math.pow(10, decCount);
}
class $8d7dfc0884542f0c$export$5b070a55c0c43e09 extends $8d7dfc0884542f0c$export$19342e026b58ebb7 {
    constructor(){
        super(...arguments);
        this.min = this.gte;
        this.max = this.lte;
        this.step = this.multipleOf;
    }
    _parse(input) {
        if (this._def.coerce) input.data = Number(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== $8d7dfc0884542f0c$export$5716da67bfaa244d.number) {
            const ctx = this._getOrReturnCtx(input);
            $8d7dfc0884542f0c$export$db7caee60e5d514d(ctx, {
                code: $8d7dfc0884542f0c$export$5ba560653e4a1035.invalid_type,
                expected: $8d7dfc0884542f0c$export$5716da67bfaa244d.number,
                received: ctx.parsedType
            });
            return $8d7dfc0884542f0c$export$9a105a556e65c2c0;
        }
        let ctx = undefined;
        const status = new $8d7dfc0884542f0c$export$5b20a5c3d05c1f6f();
        for (const check of this._def.checks){
            if (check.kind === "int") {
                if (!$8d7dfc0884542f0c$export$7debb50ef11d5e0b.isInteger(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $8d7dfc0884542f0c$export$db7caee60e5d514d(ctx, {
                        code: $8d7dfc0884542f0c$export$5ba560653e4a1035.invalid_type,
                        expected: "integer",
                        received: "float",
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "min") {
                const tooSmall = check.inclusive ? input.data < check.value : input.data <= check.value;
                if (tooSmall) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $8d7dfc0884542f0c$export$db7caee60e5d514d(ctx, {
                        code: $8d7dfc0884542f0c$export$5ba560653e4a1035.too_small,
                        minimum: check.value,
                        type: "number",
                        inclusive: check.inclusive,
                        exact: false,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "max") {
                const tooBig = check.inclusive ? input.data > check.value : input.data >= check.value;
                if (tooBig) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $8d7dfc0884542f0c$export$db7caee60e5d514d(ctx, {
                        code: $8d7dfc0884542f0c$export$5ba560653e4a1035.too_big,
                        maximum: check.value,
                        type: "number",
                        inclusive: check.inclusive,
                        exact: false,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "multipleOf") {
                if ($8d7dfc0884542f0c$var$floatSafeRemainder(input.data, check.value) !== 0) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $8d7dfc0884542f0c$export$db7caee60e5d514d(ctx, {
                        code: $8d7dfc0884542f0c$export$5ba560653e4a1035.not_multiple_of,
                        multipleOf: check.value,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "finite") {
                if (!Number.isFinite(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $8d7dfc0884542f0c$export$db7caee60e5d514d(ctx, {
                        code: $8d7dfc0884542f0c$export$5ba560653e4a1035.not_finite,
                        message: check.message
                    });
                    status.dirty();
                }
            } else $8d7dfc0884542f0c$export$7debb50ef11d5e0b.assertNever(check);
        }
        return {
            status: status.value,
            value: input.data
        };
    }
    gte(value, message) {
        return this.setLimit("min", value, true, $8d7dfc0884542f0c$var$errorUtil.toString(message));
    }
    gt(value, message) {
        return this.setLimit("min", value, false, $8d7dfc0884542f0c$var$errorUtil.toString(message));
    }
    lte(value, message) {
        return this.setLimit("max", value, true, $8d7dfc0884542f0c$var$errorUtil.toString(message));
    }
    lt(value, message) {
        return this.setLimit("max", value, false, $8d7dfc0884542f0c$var$errorUtil.toString(message));
    }
    setLimit(kind, value, inclusive, message) {
        return new $8d7dfc0884542f0c$export$5b070a55c0c43e09({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind: kind,
                    value: value,
                    inclusive: inclusive,
                    message: $8d7dfc0884542f0c$var$errorUtil.toString(message)
                }
            ]
        });
    }
    _addCheck(check) {
        return new $8d7dfc0884542f0c$export$5b070a55c0c43e09({
            ...this._def,
            checks: [
                ...this._def.checks,
                check
            ]
        });
    }
    int(message) {
        return this._addCheck({
            kind: "int",
            message: $8d7dfc0884542f0c$var$errorUtil.toString(message)
        });
    }
    positive(message) {
        return this._addCheck({
            kind: "min",
            value: 0,
            inclusive: false,
            message: $8d7dfc0884542f0c$var$errorUtil.toString(message)
        });
    }
    negative(message) {
        return this._addCheck({
            kind: "max",
            value: 0,
            inclusive: false,
            message: $8d7dfc0884542f0c$var$errorUtil.toString(message)
        });
    }
    nonpositive(message) {
        return this._addCheck({
            kind: "max",
            value: 0,
            inclusive: true,
            message: $8d7dfc0884542f0c$var$errorUtil.toString(message)
        });
    }
    nonnegative(message) {
        return this._addCheck({
            kind: "min",
            value: 0,
            inclusive: true,
            message: $8d7dfc0884542f0c$var$errorUtil.toString(message)
        });
    }
    multipleOf(value, message) {
        return this._addCheck({
            kind: "multipleOf",
            value: value,
            message: $8d7dfc0884542f0c$var$errorUtil.toString(message)
        });
    }
    finite(message) {
        return this._addCheck({
            kind: "finite",
            message: $8d7dfc0884542f0c$var$errorUtil.toString(message)
        });
    }
    safe(message) {
        return this._addCheck({
            kind: "min",
            inclusive: true,
            value: Number.MIN_SAFE_INTEGER,
            message: $8d7dfc0884542f0c$var$errorUtil.toString(message)
        })._addCheck({
            kind: "max",
            inclusive: true,
            value: Number.MAX_SAFE_INTEGER,
            message: $8d7dfc0884542f0c$var$errorUtil.toString(message)
        });
    }
    get minValue() {
        let min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            }
        }
        return min;
    }
    get maxValue() {
        let max = null;
        for (const ch of this._def.checks){
            if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return max;
    }
    get isInt() {
        return !!this._def.checks.find((ch)=>ch.kind === "int" || ch.kind === "multipleOf" && $8d7dfc0884542f0c$export$7debb50ef11d5e0b.isInteger(ch.value));
    }
    get isFinite() {
        let max = null, min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "finite" || ch.kind === "int" || ch.kind === "multipleOf") return true;
            else if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            } else if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return Number.isFinite(min) && Number.isFinite(max);
    }
}
$8d7dfc0884542f0c$export$5b070a55c0c43e09.create = (params)=>{
    return new $8d7dfc0884542f0c$export$5b070a55c0c43e09({
        checks: [],
        typeName: $8d7dfc0884542f0c$export$558106ce543bd011.ZodNumber,
        coerce: (params === null || params === void 0 ? void 0 : params.coerce) || false,
        ...$8d7dfc0884542f0c$var$processCreateParams(params)
    });
};
class $8d7dfc0884542f0c$export$67d741fd70ff98f4 extends $8d7dfc0884542f0c$export$19342e026b58ebb7 {
    constructor(){
        super(...arguments);
        this.min = this.gte;
        this.max = this.lte;
    }
    _parse(input) {
        if (this._def.coerce) try {
            input.data = BigInt(input.data);
        } catch (_a) {
            return this._getInvalidInput(input);
        }
        const parsedType = this._getType(input);
        if (parsedType !== $8d7dfc0884542f0c$export$5716da67bfaa244d.bigint) return this._getInvalidInput(input);
        let ctx = undefined;
        const status = new $8d7dfc0884542f0c$export$5b20a5c3d05c1f6f();
        for (const check of this._def.checks){
            if (check.kind === "min") {
                const tooSmall = check.inclusive ? input.data < check.value : input.data <= check.value;
                if (tooSmall) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $8d7dfc0884542f0c$export$db7caee60e5d514d(ctx, {
                        code: $8d7dfc0884542f0c$export$5ba560653e4a1035.too_small,
                        type: "bigint",
                        minimum: check.value,
                        inclusive: check.inclusive,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "max") {
                const tooBig = check.inclusive ? input.data > check.value : input.data >= check.value;
                if (tooBig) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $8d7dfc0884542f0c$export$db7caee60e5d514d(ctx, {
                        code: $8d7dfc0884542f0c$export$5ba560653e4a1035.too_big,
                        type: "bigint",
                        maximum: check.value,
                        inclusive: check.inclusive,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "multipleOf") {
                if (input.data % check.value !== BigInt(0)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $8d7dfc0884542f0c$export$db7caee60e5d514d(ctx, {
                        code: $8d7dfc0884542f0c$export$5ba560653e4a1035.not_multiple_of,
                        multipleOf: check.value,
                        message: check.message
                    });
                    status.dirty();
                }
            } else $8d7dfc0884542f0c$export$7debb50ef11d5e0b.assertNever(check);
        }
        return {
            status: status.value,
            value: input.data
        };
    }
    _getInvalidInput(input) {
        const ctx = this._getOrReturnCtx(input);
        $8d7dfc0884542f0c$export$db7caee60e5d514d(ctx, {
            code: $8d7dfc0884542f0c$export$5ba560653e4a1035.invalid_type,
            expected: $8d7dfc0884542f0c$export$5716da67bfaa244d.bigint,
            received: ctx.parsedType
        });
        return $8d7dfc0884542f0c$export$9a105a556e65c2c0;
    }
    gte(value, message) {
        return this.setLimit("min", value, true, $8d7dfc0884542f0c$var$errorUtil.toString(message));
    }
    gt(value, message) {
        return this.setLimit("min", value, false, $8d7dfc0884542f0c$var$errorUtil.toString(message));
    }
    lte(value, message) {
        return this.setLimit("max", value, true, $8d7dfc0884542f0c$var$errorUtil.toString(message));
    }
    lt(value, message) {
        return this.setLimit("max", value, false, $8d7dfc0884542f0c$var$errorUtil.toString(message));
    }
    setLimit(kind, value, inclusive, message) {
        return new $8d7dfc0884542f0c$export$67d741fd70ff98f4({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind: kind,
                    value: value,
                    inclusive: inclusive,
                    message: $8d7dfc0884542f0c$var$errorUtil.toString(message)
                }
            ]
        });
    }
    _addCheck(check) {
        return new $8d7dfc0884542f0c$export$67d741fd70ff98f4({
            ...this._def,
            checks: [
                ...this._def.checks,
                check
            ]
        });
    }
    positive(message) {
        return this._addCheck({
            kind: "min",
            value: BigInt(0),
            inclusive: false,
            message: $8d7dfc0884542f0c$var$errorUtil.toString(message)
        });
    }
    negative(message) {
        return this._addCheck({
            kind: "max",
            value: BigInt(0),
            inclusive: false,
            message: $8d7dfc0884542f0c$var$errorUtil.toString(message)
        });
    }
    nonpositive(message) {
        return this._addCheck({
            kind: "max",
            value: BigInt(0),
            inclusive: true,
            message: $8d7dfc0884542f0c$var$errorUtil.toString(message)
        });
    }
    nonnegative(message) {
        return this._addCheck({
            kind: "min",
            value: BigInt(0),
            inclusive: true,
            message: $8d7dfc0884542f0c$var$errorUtil.toString(message)
        });
    }
    multipleOf(value, message) {
        return this._addCheck({
            kind: "multipleOf",
            value: value,
            message: $8d7dfc0884542f0c$var$errorUtil.toString(message)
        });
    }
    get minValue() {
        let min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            }
        }
        return min;
    }
    get maxValue() {
        let max = null;
        for (const ch of this._def.checks){
            if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return max;
    }
}
$8d7dfc0884542f0c$export$67d741fd70ff98f4.create = (params)=>{
    var _a;
    return new $8d7dfc0884542f0c$export$67d741fd70ff98f4({
        checks: [],
        typeName: $8d7dfc0884542f0c$export$558106ce543bd011.ZodBigInt,
        coerce: (_a = params === null || params === void 0 ? void 0 : params.coerce) !== null && _a !== void 0 ? _a : false,
        ...$8d7dfc0884542f0c$var$processCreateParams(params)
    });
};
class $8d7dfc0884542f0c$export$723d146f80596191 extends $8d7dfc0884542f0c$export$19342e026b58ebb7 {
    _parse(input) {
        if (this._def.coerce) input.data = Boolean(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== $8d7dfc0884542f0c$export$5716da67bfaa244d.boolean) {
            const ctx = this._getOrReturnCtx(input);
            $8d7dfc0884542f0c$export$db7caee60e5d514d(ctx, {
                code: $8d7dfc0884542f0c$export$5ba560653e4a1035.invalid_type,
                expected: $8d7dfc0884542f0c$export$5716da67bfaa244d.boolean,
                received: ctx.parsedType
            });
            return $8d7dfc0884542f0c$export$9a105a556e65c2c0;
        }
        return $8d7dfc0884542f0c$export$c6813a8d51f77eaf(input.data);
    }
}
$8d7dfc0884542f0c$export$723d146f80596191.create = (params)=>{
    return new $8d7dfc0884542f0c$export$723d146f80596191({
        typeName: $8d7dfc0884542f0c$export$558106ce543bd011.ZodBoolean,
        coerce: (params === null || params === void 0 ? void 0 : params.coerce) || false,
        ...$8d7dfc0884542f0c$var$processCreateParams(params)
    });
};
class $8d7dfc0884542f0c$export$e974be33bdc55521 extends $8d7dfc0884542f0c$export$19342e026b58ebb7 {
    _parse(input) {
        if (this._def.coerce) input.data = new Date(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== $8d7dfc0884542f0c$export$5716da67bfaa244d.date) {
            const ctx = this._getOrReturnCtx(input);
            $8d7dfc0884542f0c$export$db7caee60e5d514d(ctx, {
                code: $8d7dfc0884542f0c$export$5ba560653e4a1035.invalid_type,
                expected: $8d7dfc0884542f0c$export$5716da67bfaa244d.date,
                received: ctx.parsedType
            });
            return $8d7dfc0884542f0c$export$9a105a556e65c2c0;
        }
        if (isNaN(input.data.getTime())) {
            const ctx = this._getOrReturnCtx(input);
            $8d7dfc0884542f0c$export$db7caee60e5d514d(ctx, {
                code: $8d7dfc0884542f0c$export$5ba560653e4a1035.invalid_date
            });
            return $8d7dfc0884542f0c$export$9a105a556e65c2c0;
        }
        const status = new $8d7dfc0884542f0c$export$5b20a5c3d05c1f6f();
        let ctx = undefined;
        for (const check of this._def.checks){
            if (check.kind === "min") {
                if (input.data.getTime() < check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $8d7dfc0884542f0c$export$db7caee60e5d514d(ctx, {
                        code: $8d7dfc0884542f0c$export$5ba560653e4a1035.too_small,
                        message: check.message,
                        inclusive: true,
                        exact: false,
                        minimum: check.value,
                        type: "date"
                    });
                    status.dirty();
                }
            } else if (check.kind === "max") {
                if (input.data.getTime() > check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $8d7dfc0884542f0c$export$db7caee60e5d514d(ctx, {
                        code: $8d7dfc0884542f0c$export$5ba560653e4a1035.too_big,
                        message: check.message,
                        inclusive: true,
                        exact: false,
                        maximum: check.value,
                        type: "date"
                    });
                    status.dirty();
                }
            } else $8d7dfc0884542f0c$export$7debb50ef11d5e0b.assertNever(check);
        }
        return {
            status: status.value,
            value: new Date(input.data.getTime())
        };
    }
    _addCheck(check) {
        return new $8d7dfc0884542f0c$export$e974be33bdc55521({
            ...this._def,
            checks: [
                ...this._def.checks,
                check
            ]
        });
    }
    min(minDate, message) {
        return this._addCheck({
            kind: "min",
            value: minDate.getTime(),
            message: $8d7dfc0884542f0c$var$errorUtil.toString(message)
        });
    }
    max(maxDate, message) {
        return this._addCheck({
            kind: "max",
            value: maxDate.getTime(),
            message: $8d7dfc0884542f0c$var$errorUtil.toString(message)
        });
    }
    get minDate() {
        let min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            }
        }
        return min != null ? new Date(min) : null;
    }
    get maxDate() {
        let max = null;
        for (const ch of this._def.checks){
            if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return max != null ? new Date(max) : null;
    }
}
$8d7dfc0884542f0c$export$e974be33bdc55521.create = (params)=>{
    return new $8d7dfc0884542f0c$export$e974be33bdc55521({
        checks: [],
        coerce: (params === null || params === void 0 ? void 0 : params.coerce) || false,
        typeName: $8d7dfc0884542f0c$export$558106ce543bd011.ZodDate,
        ...$8d7dfc0884542f0c$var$processCreateParams(params)
    });
};
class $8d7dfc0884542f0c$export$bcc3b40f6b638044 extends $8d7dfc0884542f0c$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== $8d7dfc0884542f0c$export$5716da67bfaa244d.symbol) {
            const ctx = this._getOrReturnCtx(input);
            $8d7dfc0884542f0c$export$db7caee60e5d514d(ctx, {
                code: $8d7dfc0884542f0c$export$5ba560653e4a1035.invalid_type,
                expected: $8d7dfc0884542f0c$export$5716da67bfaa244d.symbol,
                received: ctx.parsedType
            });
            return $8d7dfc0884542f0c$export$9a105a556e65c2c0;
        }
        return $8d7dfc0884542f0c$export$c6813a8d51f77eaf(input.data);
    }
}
$8d7dfc0884542f0c$export$bcc3b40f6b638044.create = (params)=>{
    return new $8d7dfc0884542f0c$export$bcc3b40f6b638044({
        typeName: $8d7dfc0884542f0c$export$558106ce543bd011.ZodSymbol,
        ...$8d7dfc0884542f0c$var$processCreateParams(params)
    });
};
class $8d7dfc0884542f0c$export$4e780e961c30340d extends $8d7dfc0884542f0c$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== $8d7dfc0884542f0c$export$5716da67bfaa244d.undefined) {
            const ctx = this._getOrReturnCtx(input);
            $8d7dfc0884542f0c$export$db7caee60e5d514d(ctx, {
                code: $8d7dfc0884542f0c$export$5ba560653e4a1035.invalid_type,
                expected: $8d7dfc0884542f0c$export$5716da67bfaa244d.undefined,
                received: ctx.parsedType
            });
            return $8d7dfc0884542f0c$export$9a105a556e65c2c0;
        }
        return $8d7dfc0884542f0c$export$c6813a8d51f77eaf(input.data);
    }
}
$8d7dfc0884542f0c$export$4e780e961c30340d.create = (params)=>{
    return new $8d7dfc0884542f0c$export$4e780e961c30340d({
        typeName: $8d7dfc0884542f0c$export$558106ce543bd011.ZodUndefined,
        ...$8d7dfc0884542f0c$var$processCreateParams(params)
    });
};
class $8d7dfc0884542f0c$export$a96281f914484f2d extends $8d7dfc0884542f0c$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== $8d7dfc0884542f0c$export$5716da67bfaa244d.null) {
            const ctx = this._getOrReturnCtx(input);
            $8d7dfc0884542f0c$export$db7caee60e5d514d(ctx, {
                code: $8d7dfc0884542f0c$export$5ba560653e4a1035.invalid_type,
                expected: $8d7dfc0884542f0c$export$5716da67bfaa244d.null,
                received: ctx.parsedType
            });
            return $8d7dfc0884542f0c$export$9a105a556e65c2c0;
        }
        return $8d7dfc0884542f0c$export$c6813a8d51f77eaf(input.data);
    }
}
$8d7dfc0884542f0c$export$a96281f914484f2d.create = (params)=>{
    return new $8d7dfc0884542f0c$export$a96281f914484f2d({
        typeName: $8d7dfc0884542f0c$export$558106ce543bd011.ZodNull,
        ...$8d7dfc0884542f0c$var$processCreateParams(params)
    });
};
class $8d7dfc0884542f0c$export$b9d1edb536b4e4eb extends $8d7dfc0884542f0c$export$19342e026b58ebb7 {
    constructor(){
        super(...arguments);
        // to prevent instances of other classes from extending ZodAny. this causes issues with catchall in ZodObject.
        this._any = true;
    }
    _parse(input) {
        return $8d7dfc0884542f0c$export$c6813a8d51f77eaf(input.data);
    }
}
$8d7dfc0884542f0c$export$b9d1edb536b4e4eb.create = (params)=>{
    return new $8d7dfc0884542f0c$export$b9d1edb536b4e4eb({
        typeName: $8d7dfc0884542f0c$export$558106ce543bd011.ZodAny,
        ...$8d7dfc0884542f0c$var$processCreateParams(params)
    });
};
class $8d7dfc0884542f0c$export$ef3b1bb1630977ae extends $8d7dfc0884542f0c$export$19342e026b58ebb7 {
    constructor(){
        super(...arguments);
        // required
        this._unknown = true;
    }
    _parse(input) {
        return $8d7dfc0884542f0c$export$c6813a8d51f77eaf(input.data);
    }
}
$8d7dfc0884542f0c$export$ef3b1bb1630977ae.create = (params)=>{
    return new $8d7dfc0884542f0c$export$ef3b1bb1630977ae({
        typeName: $8d7dfc0884542f0c$export$558106ce543bd011.ZodUnknown,
        ...$8d7dfc0884542f0c$var$processCreateParams(params)
    });
};
class $8d7dfc0884542f0c$export$1e576a20c3ce9fb5 extends $8d7dfc0884542f0c$export$19342e026b58ebb7 {
    _parse(input) {
        const ctx = this._getOrReturnCtx(input);
        $8d7dfc0884542f0c$export$db7caee60e5d514d(ctx, {
            code: $8d7dfc0884542f0c$export$5ba560653e4a1035.invalid_type,
            expected: $8d7dfc0884542f0c$export$5716da67bfaa244d.never,
            received: ctx.parsedType
        });
        return $8d7dfc0884542f0c$export$9a105a556e65c2c0;
    }
}
$8d7dfc0884542f0c$export$1e576a20c3ce9fb5.create = (params)=>{
    return new $8d7dfc0884542f0c$export$1e576a20c3ce9fb5({
        typeName: $8d7dfc0884542f0c$export$558106ce543bd011.ZodNever,
        ...$8d7dfc0884542f0c$var$processCreateParams(params)
    });
};
class $8d7dfc0884542f0c$export$7d39f5df85f21031 extends $8d7dfc0884542f0c$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== $8d7dfc0884542f0c$export$5716da67bfaa244d.undefined) {
            const ctx = this._getOrReturnCtx(input);
            $8d7dfc0884542f0c$export$db7caee60e5d514d(ctx, {
                code: $8d7dfc0884542f0c$export$5ba560653e4a1035.invalid_type,
                expected: $8d7dfc0884542f0c$export$5716da67bfaa244d.void,
                received: ctx.parsedType
            });
            return $8d7dfc0884542f0c$export$9a105a556e65c2c0;
        }
        return $8d7dfc0884542f0c$export$c6813a8d51f77eaf(input.data);
    }
}
$8d7dfc0884542f0c$export$7d39f5df85f21031.create = (params)=>{
    return new $8d7dfc0884542f0c$export$7d39f5df85f21031({
        typeName: $8d7dfc0884542f0c$export$558106ce543bd011.ZodVoid,
        ...$8d7dfc0884542f0c$var$processCreateParams(params)
    });
};
class $8d7dfc0884542f0c$export$7acfc3e64785411 extends $8d7dfc0884542f0c$export$19342e026b58ebb7 {
    _parse(input) {
        const { ctx: ctx, status: status } = this._processInputParams(input);
        const def = this._def;
        if (ctx.parsedType !== $8d7dfc0884542f0c$export$5716da67bfaa244d.array) {
            $8d7dfc0884542f0c$export$db7caee60e5d514d(ctx, {
                code: $8d7dfc0884542f0c$export$5ba560653e4a1035.invalid_type,
                expected: $8d7dfc0884542f0c$export$5716da67bfaa244d.array,
                received: ctx.parsedType
            });
            return $8d7dfc0884542f0c$export$9a105a556e65c2c0;
        }
        if (def.exactLength !== null) {
            const tooBig = ctx.data.length > def.exactLength.value;
            const tooSmall = ctx.data.length < def.exactLength.value;
            if (tooBig || tooSmall) {
                $8d7dfc0884542f0c$export$db7caee60e5d514d(ctx, {
                    code: tooBig ? $8d7dfc0884542f0c$export$5ba560653e4a1035.too_big : $8d7dfc0884542f0c$export$5ba560653e4a1035.too_small,
                    minimum: tooSmall ? def.exactLength.value : undefined,
                    maximum: tooBig ? def.exactLength.value : undefined,
                    type: "array",
                    inclusive: true,
                    exact: true,
                    message: def.exactLength.message
                });
                status.dirty();
            }
        }
        if (def.minLength !== null) {
            if (ctx.data.length < def.minLength.value) {
                $8d7dfc0884542f0c$export$db7caee60e5d514d(ctx, {
                    code: $8d7dfc0884542f0c$export$5ba560653e4a1035.too_small,
                    minimum: def.minLength.value,
                    type: "array",
                    inclusive: true,
                    exact: false,
                    message: def.minLength.message
                });
                status.dirty();
            }
        }
        if (def.maxLength !== null) {
            if (ctx.data.length > def.maxLength.value) {
                $8d7dfc0884542f0c$export$db7caee60e5d514d(ctx, {
                    code: $8d7dfc0884542f0c$export$5ba560653e4a1035.too_big,
                    maximum: def.maxLength.value,
                    type: "array",
                    inclusive: true,
                    exact: false,
                    message: def.maxLength.message
                });
                status.dirty();
            }
        }
        if (ctx.common.async) return Promise.all([
            ...ctx.data
        ].map((item, i)=>{
            return def.type._parseAsync(new $8d7dfc0884542f0c$var$ParseInputLazyPath(ctx, item, ctx.path, i));
        })).then((result)=>{
            return $8d7dfc0884542f0c$export$5b20a5c3d05c1f6f.mergeArray(status, result);
        });
        const result = [
            ...ctx.data
        ].map((item, i)=>{
            return def.type._parseSync(new $8d7dfc0884542f0c$var$ParseInputLazyPath(ctx, item, ctx.path, i));
        });
        return $8d7dfc0884542f0c$export$5b20a5c3d05c1f6f.mergeArray(status, result);
    }
    get element() {
        return this._def.type;
    }
    min(minLength, message) {
        return new $8d7dfc0884542f0c$export$7acfc3e64785411({
            ...this._def,
            minLength: {
                value: minLength,
                message: $8d7dfc0884542f0c$var$errorUtil.toString(message)
            }
        });
    }
    max(maxLength, message) {
        return new $8d7dfc0884542f0c$export$7acfc3e64785411({
            ...this._def,
            maxLength: {
                value: maxLength,
                message: $8d7dfc0884542f0c$var$errorUtil.toString(message)
            }
        });
    }
    length(len, message) {
        return new $8d7dfc0884542f0c$export$7acfc3e64785411({
            ...this._def,
            exactLength: {
                value: len,
                message: $8d7dfc0884542f0c$var$errorUtil.toString(message)
            }
        });
    }
    nonempty(message) {
        return this.min(1, message);
    }
}
$8d7dfc0884542f0c$export$7acfc3e64785411.create = (schema, params)=>{
    return new $8d7dfc0884542f0c$export$7acfc3e64785411({
        type: schema,
        minLength: null,
        maxLength: null,
        exactLength: null,
        typeName: $8d7dfc0884542f0c$export$558106ce543bd011.ZodArray,
        ...$8d7dfc0884542f0c$var$processCreateParams(params)
    });
};
function $8d7dfc0884542f0c$var$deepPartialify(schema) {
    if (schema instanceof $8d7dfc0884542f0c$export$736315c5b55efbad) {
        const newShape = {};
        for(const key in schema.shape){
            const fieldSchema = schema.shape[key];
            newShape[key] = $8d7dfc0884542f0c$export$aa56fec1e9d629b8.create($8d7dfc0884542f0c$var$deepPartialify(fieldSchema));
        }
        return new $8d7dfc0884542f0c$export$736315c5b55efbad({
            ...schema._def,
            shape: ()=>newShape
        });
    } else if (schema instanceof $8d7dfc0884542f0c$export$7acfc3e64785411) return new $8d7dfc0884542f0c$export$7acfc3e64785411({
        ...schema._def,
        type: $8d7dfc0884542f0c$var$deepPartialify(schema.element)
    });
    else if (schema instanceof $8d7dfc0884542f0c$export$aa56fec1e9d629b8) return $8d7dfc0884542f0c$export$aa56fec1e9d629b8.create($8d7dfc0884542f0c$var$deepPartialify(schema.unwrap()));
    else if (schema instanceof $8d7dfc0884542f0c$export$aaac0b8b429cef5) return $8d7dfc0884542f0c$export$aaac0b8b429cef5.create($8d7dfc0884542f0c$var$deepPartialify(schema.unwrap()));
    else if (schema instanceof $8d7dfc0884542f0c$export$e2a18bb771d8e6a3) return $8d7dfc0884542f0c$export$e2a18bb771d8e6a3.create(schema.items.map((item)=>$8d7dfc0884542f0c$var$deepPartialify(item)));
    else return schema;
}
class $8d7dfc0884542f0c$export$736315c5b55efbad extends $8d7dfc0884542f0c$export$19342e026b58ebb7 {
    constructor(){
        super(...arguments);
        this._cached = null;
        /**
         * @deprecated In most cases, this is no longer needed - unknown properties are now silently stripped.
         * If you want to pass through unknown properties, use `.passthrough()` instead.
         */ this.nonstrict = this.passthrough;
        // extend<
        //   Augmentation extends ZodRawShape,
        //   NewOutput extends util.flatten<{
        //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
        //       ? Augmentation[k]["_output"]
        //       : k extends keyof Output
        //       ? Output[k]
        //       : never;
        //   }>,
        //   NewInput extends util.flatten<{
        //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
        //       ? Augmentation[k]["_input"]
        //       : k extends keyof Input
        //       ? Input[k]
        //       : never;
        //   }>
        // >(
        //   augmentation: Augmentation
        // ): ZodObject<
        //   extendShape<T, Augmentation>,
        //   UnknownKeys,
        //   Catchall,
        //   NewOutput,
        //   NewInput
        // > {
        //   return new ZodObject({
        //     ...this._def,
        //     shape: () => ({
        //       ...this._def.shape(),
        //       ...augmentation,
        //     }),
        //   }) as any;
        // }
        /**
         * @deprecated Use `.extend` instead
         *  */ this.augment = this.extend;
    }
    _getCached() {
        if (this._cached !== null) return this._cached;
        const shape = this._def.shape();
        const keys = $8d7dfc0884542f0c$export$7debb50ef11d5e0b.objectKeys(shape);
        return this._cached = {
            shape: shape,
            keys: keys
        };
    }
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== $8d7dfc0884542f0c$export$5716da67bfaa244d.object) {
            const ctx = this._getOrReturnCtx(input);
            $8d7dfc0884542f0c$export$db7caee60e5d514d(ctx, {
                code: $8d7dfc0884542f0c$export$5ba560653e4a1035.invalid_type,
                expected: $8d7dfc0884542f0c$export$5716da67bfaa244d.object,
                received: ctx.parsedType
            });
            return $8d7dfc0884542f0c$export$9a105a556e65c2c0;
        }
        const { status: status, ctx: ctx } = this._processInputParams(input);
        const { shape: shape, keys: shapeKeys } = this._getCached();
        const extraKeys = [];
        if (!(this._def.catchall instanceof $8d7dfc0884542f0c$export$1e576a20c3ce9fb5 && this._def.unknownKeys === "strip")) {
            for(const key in ctx.data)if (!shapeKeys.includes(key)) extraKeys.push(key);
        }
        const pairs = [];
        for (const key of shapeKeys){
            const keyValidator = shape[key];
            const value = ctx.data[key];
            pairs.push({
                key: {
                    status: "valid",
                    value: key
                },
                value: keyValidator._parse(new $8d7dfc0884542f0c$var$ParseInputLazyPath(ctx, value, ctx.path, key)),
                alwaysSet: key in ctx.data
            });
        }
        if (this._def.catchall instanceof $8d7dfc0884542f0c$export$1e576a20c3ce9fb5) {
            const unknownKeys = this._def.unknownKeys;
            if (unknownKeys === "passthrough") for (const key of extraKeys)pairs.push({
                key: {
                    status: "valid",
                    value: key
                },
                value: {
                    status: "valid",
                    value: ctx.data[key]
                }
            });
            else if (unknownKeys === "strict") {
                if (extraKeys.length > 0) {
                    $8d7dfc0884542f0c$export$db7caee60e5d514d(ctx, {
                        code: $8d7dfc0884542f0c$export$5ba560653e4a1035.unrecognized_keys,
                        keys: extraKeys
                    });
                    status.dirty();
                }
            } else if (unknownKeys === "strip") ;
            else throw new Error(`Internal ZodObject error: invalid unknownKeys value.`);
        } else {
            // run catchall validation
            const catchall = this._def.catchall;
            for (const key of extraKeys){
                const value = ctx.data[key];
                pairs.push({
                    key: {
                        status: "valid",
                        value: key
                    },
                    value: catchall._parse(new $8d7dfc0884542f0c$var$ParseInputLazyPath(ctx, value, ctx.path, key) //, ctx.child(key), value, getParsedType(value)
                    ),
                    alwaysSet: key in ctx.data
                });
            }
        }
        if (ctx.common.async) return Promise.resolve().then(async ()=>{
            const syncPairs = [];
            for (const pair of pairs){
                const key = await pair.key;
                const value = await pair.value;
                syncPairs.push({
                    key: key,
                    value: value,
                    alwaysSet: pair.alwaysSet
                });
            }
            return syncPairs;
        }).then((syncPairs)=>{
            return $8d7dfc0884542f0c$export$5b20a5c3d05c1f6f.mergeObjectSync(status, syncPairs);
        });
        else return $8d7dfc0884542f0c$export$5b20a5c3d05c1f6f.mergeObjectSync(status, pairs);
    }
    get shape() {
        return this._def.shape();
    }
    strict(message) {
        $8d7dfc0884542f0c$var$errorUtil.errToObj;
        return new $8d7dfc0884542f0c$export$736315c5b55efbad({
            ...this._def,
            unknownKeys: "strict",
            ...message !== undefined ? {
                errorMap: (issue, ctx)=>{
                    var _a, _b, _c, _d;
                    const defaultError = (_c = (_b = (_a = this._def).errorMap) === null || _b === void 0 ? void 0 : _b.call(_a, issue, ctx).message) !== null && _c !== void 0 ? _c : ctx.defaultError;
                    if (issue.code === "unrecognized_keys") return {
                        message: (_d = $8d7dfc0884542f0c$var$errorUtil.errToObj(message).message) !== null && _d !== void 0 ? _d : defaultError
                    };
                    return {
                        message: defaultError
                    };
                }
            } : {}
        });
    }
    strip() {
        return new $8d7dfc0884542f0c$export$736315c5b55efbad({
            ...this._def,
            unknownKeys: "strip"
        });
    }
    passthrough() {
        return new $8d7dfc0884542f0c$export$736315c5b55efbad({
            ...this._def,
            unknownKeys: "passthrough"
        });
    }
    // const AugmentFactory =
    //   <Def extends ZodObjectDef>(def: Def) =>
    //   <Augmentation extends ZodRawShape>(
    //     augmentation: Augmentation
    //   ): ZodObject<
    //     extendShape<ReturnType<Def["shape"]>, Augmentation>,
    //     Def["unknownKeys"],
    //     Def["catchall"]
    //   > => {
    //     return new ZodObject({
    //       ...def,
    //       shape: () => ({
    //         ...def.shape(),
    //         ...augmentation,
    //       }),
    //     }) as any;
    //   };
    extend(augmentation) {
        return new $8d7dfc0884542f0c$export$736315c5b55efbad({
            ...this._def,
            shape: ()=>({
                    ...this._def.shape(),
                    ...augmentation
                })
        });
    }
    /**
     * Prior to zod@1.0.12 there was a bug in the
     * inferred type of merged objects. Please
     * upgrade if you are experiencing issues.
     */ merge(merging) {
        const merged = new $8d7dfc0884542f0c$export$736315c5b55efbad({
            unknownKeys: merging._def.unknownKeys,
            catchall: merging._def.catchall,
            shape: ()=>({
                    ...this._def.shape(),
                    ...merging._def.shape()
                }),
            typeName: $8d7dfc0884542f0c$export$558106ce543bd011.ZodObject
        });
        return merged;
    }
    // merge<
    //   Incoming extends AnyZodObject,
    //   Augmentation extends Incoming["shape"],
    //   NewOutput extends {
    //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
    //       ? Augmentation[k]["_output"]
    //       : k extends keyof Output
    //       ? Output[k]
    //       : never;
    //   },
    //   NewInput extends {
    //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
    //       ? Augmentation[k]["_input"]
    //       : k extends keyof Input
    //       ? Input[k]
    //       : never;
    //   }
    // >(
    //   merging: Incoming
    // ): ZodObject<
    //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
    //   Incoming["_def"]["unknownKeys"],
    //   Incoming["_def"]["catchall"],
    //   NewOutput,
    //   NewInput
    // > {
    //   const merged: any = new ZodObject({
    //     unknownKeys: merging._def.unknownKeys,
    //     catchall: merging._def.catchall,
    //     shape: () =>
    //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
    //     typeName: ZodFirstPartyTypeKind.ZodObject,
    //   }) as any;
    //   return merged;
    // }
    setKey(key, schema) {
        return this.augment({
            [key]: schema
        });
    }
    // merge<Incoming extends AnyZodObject>(
    //   merging: Incoming
    // ): //ZodObject<T & Incoming["_shape"], UnknownKeys, Catchall> = (merging) => {
    // ZodObject<
    //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
    //   Incoming["_def"]["unknownKeys"],
    //   Incoming["_def"]["catchall"]
    // > {
    //   // const mergedShape = objectUtil.mergeShapes(
    //   //   this._def.shape(),
    //   //   merging._def.shape()
    //   // );
    //   const merged: any = new ZodObject({
    //     unknownKeys: merging._def.unknownKeys,
    //     catchall: merging._def.catchall,
    //     shape: () =>
    //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
    //     typeName: ZodFirstPartyTypeKind.ZodObject,
    //   }) as any;
    //   return merged;
    // }
    catchall(index) {
        return new $8d7dfc0884542f0c$export$736315c5b55efbad({
            ...this._def,
            catchall: index
        });
    }
    pick(mask) {
        const shape = {};
        $8d7dfc0884542f0c$export$7debb50ef11d5e0b.objectKeys(mask).forEach((key)=>{
            if (mask[key] && this.shape[key]) shape[key] = this.shape[key];
        });
        return new $8d7dfc0884542f0c$export$736315c5b55efbad({
            ...this._def,
            shape: ()=>shape
        });
    }
    omit(mask) {
        const shape = {};
        $8d7dfc0884542f0c$export$7debb50ef11d5e0b.objectKeys(this.shape).forEach((key)=>{
            if (!mask[key]) shape[key] = this.shape[key];
        });
        return new $8d7dfc0884542f0c$export$736315c5b55efbad({
            ...this._def,
            shape: ()=>shape
        });
    }
    /**
     * @deprecated
     */ deepPartial() {
        return $8d7dfc0884542f0c$var$deepPartialify(this);
    }
    partial(mask) {
        const newShape = {};
        $8d7dfc0884542f0c$export$7debb50ef11d5e0b.objectKeys(this.shape).forEach((key)=>{
            const fieldSchema = this.shape[key];
            if (mask && !mask[key]) newShape[key] = fieldSchema;
            else newShape[key] = fieldSchema.optional();
        });
        return new $8d7dfc0884542f0c$export$736315c5b55efbad({
            ...this._def,
            shape: ()=>newShape
        });
    }
    required(mask) {
        const newShape = {};
        $8d7dfc0884542f0c$export$7debb50ef11d5e0b.objectKeys(this.shape).forEach((key)=>{
            if (mask && !mask[key]) newShape[key] = this.shape[key];
            else {
                const fieldSchema = this.shape[key];
                let newField = fieldSchema;
                while(newField instanceof $8d7dfc0884542f0c$export$aa56fec1e9d629b8)newField = newField._def.innerType;
                newShape[key] = newField;
            }
        });
        return new $8d7dfc0884542f0c$export$736315c5b55efbad({
            ...this._def,
            shape: ()=>newShape
        });
    }
    keyof() {
        return $8d7dfc0884542f0c$var$createZodEnum($8d7dfc0884542f0c$export$7debb50ef11d5e0b.objectKeys(this.shape));
    }
}
$8d7dfc0884542f0c$export$736315c5b55efbad.create = (shape, params)=>{
    return new $8d7dfc0884542f0c$export$736315c5b55efbad({
        shape: ()=>shape,
        unknownKeys: "strip",
        catchall: $8d7dfc0884542f0c$export$1e576a20c3ce9fb5.create(),
        typeName: $8d7dfc0884542f0c$export$558106ce543bd011.ZodObject,
        ...$8d7dfc0884542f0c$var$processCreateParams(params)
    });
};
$8d7dfc0884542f0c$export$736315c5b55efbad.strictCreate = (shape, params)=>{
    return new $8d7dfc0884542f0c$export$736315c5b55efbad({
        shape: ()=>shape,
        unknownKeys: "strict",
        catchall: $8d7dfc0884542f0c$export$1e576a20c3ce9fb5.create(),
        typeName: $8d7dfc0884542f0c$export$558106ce543bd011.ZodObject,
        ...$8d7dfc0884542f0c$var$processCreateParams(params)
    });
};
$8d7dfc0884542f0c$export$736315c5b55efbad.lazycreate = (shape, params)=>{
    return new $8d7dfc0884542f0c$export$736315c5b55efbad({
        shape: shape,
        unknownKeys: "strip",
        catchall: $8d7dfc0884542f0c$export$1e576a20c3ce9fb5.create(),
        typeName: $8d7dfc0884542f0c$export$558106ce543bd011.ZodObject,
        ...$8d7dfc0884542f0c$var$processCreateParams(params)
    });
};
class $8d7dfc0884542f0c$export$a8b236cb5070a311 extends $8d7dfc0884542f0c$export$19342e026b58ebb7 {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        const options = this._def.options;
        function handleResults(results) {
            // return first issue-free validation if it exists
            for (const result of results){
                if (result.result.status === "valid") return result.result;
            }
            for (const result of results)if (result.result.status === "dirty") {
                // add issues from dirty option
                ctx.common.issues.push(...result.ctx.common.issues);
                return result.result;
            }
            // return invalid
            const unionErrors = results.map((result)=>new $8d7dfc0884542f0c$export$f98dac4b251ab333(result.ctx.common.issues));
            $8d7dfc0884542f0c$export$db7caee60e5d514d(ctx, {
                code: $8d7dfc0884542f0c$export$5ba560653e4a1035.invalid_union,
                unionErrors: unionErrors
            });
            return $8d7dfc0884542f0c$export$9a105a556e65c2c0;
        }
        if (ctx.common.async) return Promise.all(options.map(async (option)=>{
            const childCtx = {
                ...ctx,
                common: {
                    ...ctx.common,
                    issues: []
                },
                parent: null
            };
            return {
                result: await option._parseAsync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: childCtx
                }),
                ctx: childCtx
            };
        })).then(handleResults);
        else {
            let dirty = undefined;
            const issues = [];
            for (const option of options){
                const childCtx = {
                    ...ctx,
                    common: {
                        ...ctx.common,
                        issues: []
                    },
                    parent: null
                };
                const result = option._parseSync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: childCtx
                });
                if (result.status === "valid") return result;
                else if (result.status === "dirty" && !dirty) dirty = {
                    result: result,
                    ctx: childCtx
                };
                if (childCtx.common.issues.length) issues.push(childCtx.common.issues);
            }
            if (dirty) {
                ctx.common.issues.push(...dirty.ctx.common.issues);
                return dirty.result;
            }
            const unionErrors = issues.map((issues)=>new $8d7dfc0884542f0c$export$f98dac4b251ab333(issues));
            $8d7dfc0884542f0c$export$db7caee60e5d514d(ctx, {
                code: $8d7dfc0884542f0c$export$5ba560653e4a1035.invalid_union,
                unionErrors: unionErrors
            });
            return $8d7dfc0884542f0c$export$9a105a556e65c2c0;
        }
    }
    get options() {
        return this._def.options;
    }
}
$8d7dfc0884542f0c$export$a8b236cb5070a311.create = (types, params)=>{
    return new $8d7dfc0884542f0c$export$a8b236cb5070a311({
        options: types,
        typeName: $8d7dfc0884542f0c$export$558106ce543bd011.ZodUnion,
        ...$8d7dfc0884542f0c$var$processCreateParams(params)
    });
};
/////////////////////////////////////////////////////
/////////////////////////////////////////////////////
//////////                                 //////////
//////////      ZodDiscriminatedUnion      //////////
//////////                                 //////////
/////////////////////////////////////////////////////
/////////////////////////////////////////////////////
const $8d7dfc0884542f0c$var$getDiscriminator = (type)=>{
    if (type instanceof $8d7dfc0884542f0c$export$378d0cfce37406e6) return $8d7dfc0884542f0c$var$getDiscriminator(type.schema);
    else if (type instanceof $8d7dfc0884542f0c$export$a60af00cc0ce2582) return $8d7dfc0884542f0c$var$getDiscriminator(type.innerType());
    else if (type instanceof $8d7dfc0884542f0c$export$7e44096782a165d3) return [
        type.value
    ];
    else if (type instanceof $8d7dfc0884542f0c$export$d325d1f0e1c20179) return type.options;
    else if (type instanceof $8d7dfc0884542f0c$export$370b2e8d6d6f5c56) // eslint-disable-next-line ban/ban
    return $8d7dfc0884542f0c$export$7debb50ef11d5e0b.objectValues(type.enum);
    else if (type instanceof $8d7dfc0884542f0c$export$bb19b37874861e7e) return $8d7dfc0884542f0c$var$getDiscriminator(type._def.innerType);
    else if (type instanceof $8d7dfc0884542f0c$export$4e780e961c30340d) return [
        undefined
    ];
    else if (type instanceof $8d7dfc0884542f0c$export$a96281f914484f2d) return [
        null
    ];
    else if (type instanceof $8d7dfc0884542f0c$export$aa56fec1e9d629b8) return [
        undefined,
        ...$8d7dfc0884542f0c$var$getDiscriminator(type.unwrap())
    ];
    else if (type instanceof $8d7dfc0884542f0c$export$aaac0b8b429cef5) return [
        null,
        ...$8d7dfc0884542f0c$var$getDiscriminator(type.unwrap())
    ];
    else if (type instanceof $8d7dfc0884542f0c$export$66b0c798a395271f) return $8d7dfc0884542f0c$var$getDiscriminator(type.unwrap());
    else if (type instanceof $8d7dfc0884542f0c$export$5d1f7ef05c4e493a) return $8d7dfc0884542f0c$var$getDiscriminator(type.unwrap());
    else if (type instanceof $8d7dfc0884542f0c$export$75a44ec6249ac76b) return $8d7dfc0884542f0c$var$getDiscriminator(type._def.innerType);
    else return [];
};
class $8d7dfc0884542f0c$export$5ef2424805ac76a3 extends $8d7dfc0884542f0c$export$19342e026b58ebb7 {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $8d7dfc0884542f0c$export$5716da67bfaa244d.object) {
            $8d7dfc0884542f0c$export$db7caee60e5d514d(ctx, {
                code: $8d7dfc0884542f0c$export$5ba560653e4a1035.invalid_type,
                expected: $8d7dfc0884542f0c$export$5716da67bfaa244d.object,
                received: ctx.parsedType
            });
            return $8d7dfc0884542f0c$export$9a105a556e65c2c0;
        }
        const discriminator = this.discriminator;
        const discriminatorValue = ctx.data[discriminator];
        const option = this.optionsMap.get(discriminatorValue);
        if (!option) {
            $8d7dfc0884542f0c$export$db7caee60e5d514d(ctx, {
                code: $8d7dfc0884542f0c$export$5ba560653e4a1035.invalid_union_discriminator,
                options: Array.from(this.optionsMap.keys()),
                path: [
                    discriminator
                ]
            });
            return $8d7dfc0884542f0c$export$9a105a556e65c2c0;
        }
        if (ctx.common.async) return option._parseAsync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        });
        else return option._parseSync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        });
    }
    get discriminator() {
        return this._def.discriminator;
    }
    get options() {
        return this._def.options;
    }
    get optionsMap() {
        return this._def.optionsMap;
    }
    /**
     * The constructor of the discriminated union schema. Its behaviour is very similar to that of the normal z.union() constructor.
     * However, it only allows a union of objects, all of which need to share a discriminator property. This property must
     * have a different value for each object in the union.
     * @param discriminator the name of the discriminator property
     * @param types an array of object schemas
     * @param params
     */ static create(discriminator, options, params) {
        // Get all the valid discriminator values
        const optionsMap = new Map();
        // try {
        for (const type of options){
            const discriminatorValues = $8d7dfc0884542f0c$var$getDiscriminator(type.shape[discriminator]);
            if (!discriminatorValues.length) throw new Error(`A discriminator value for key \`${discriminator}\` could not be extracted from all schema options`);
            for (const value of discriminatorValues){
                if (optionsMap.has(value)) throw new Error(`Discriminator property ${String(discriminator)} has duplicate value ${String(value)}`);
                optionsMap.set(value, type);
            }
        }
        return new $8d7dfc0884542f0c$export$5ef2424805ac76a3({
            typeName: $8d7dfc0884542f0c$export$558106ce543bd011.ZodDiscriminatedUnion,
            discriminator: discriminator,
            options: options,
            optionsMap: optionsMap,
            ...$8d7dfc0884542f0c$var$processCreateParams(params)
        });
    }
}
function $8d7dfc0884542f0c$var$mergeValues(a, b) {
    const aType = $8d7dfc0884542f0c$export$3e9057828ebd5c7a(a);
    const bType = $8d7dfc0884542f0c$export$3e9057828ebd5c7a(b);
    if (a === b) return {
        valid: true,
        data: a
    };
    else if (aType === $8d7dfc0884542f0c$export$5716da67bfaa244d.object && bType === $8d7dfc0884542f0c$export$5716da67bfaa244d.object) {
        const bKeys = $8d7dfc0884542f0c$export$7debb50ef11d5e0b.objectKeys(b);
        const sharedKeys = $8d7dfc0884542f0c$export$7debb50ef11d5e0b.objectKeys(a).filter((key)=>bKeys.indexOf(key) !== -1);
        const newObj = {
            ...a,
            ...b
        };
        for (const key of sharedKeys){
            const sharedValue = $8d7dfc0884542f0c$var$mergeValues(a[key], b[key]);
            if (!sharedValue.valid) return {
                valid: false
            };
            newObj[key] = sharedValue.data;
        }
        return {
            valid: true,
            data: newObj
        };
    } else if (aType === $8d7dfc0884542f0c$export$5716da67bfaa244d.array && bType === $8d7dfc0884542f0c$export$5716da67bfaa244d.array) {
        if (a.length !== b.length) return {
            valid: false
        };
        const newArray = [];
        for(let index = 0; index < a.length; index++){
            const itemA = a[index];
            const itemB = b[index];
            const sharedValue = $8d7dfc0884542f0c$var$mergeValues(itemA, itemB);
            if (!sharedValue.valid) return {
                valid: false
            };
            newArray.push(sharedValue.data);
        }
        return {
            valid: true,
            data: newArray
        };
    } else if (aType === $8d7dfc0884542f0c$export$5716da67bfaa244d.date && bType === $8d7dfc0884542f0c$export$5716da67bfaa244d.date && +a === +b) return {
        valid: true,
        data: a
    };
    else return {
        valid: false
    };
}
class $8d7dfc0884542f0c$export$c02deaf0bb5203d4 extends $8d7dfc0884542f0c$export$19342e026b58ebb7 {
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        const handleParsed = (parsedLeft, parsedRight)=>{
            if ($8d7dfc0884542f0c$export$afa861e3c5730743(parsedLeft) || $8d7dfc0884542f0c$export$afa861e3c5730743(parsedRight)) return $8d7dfc0884542f0c$export$9a105a556e65c2c0;
            const merged = $8d7dfc0884542f0c$var$mergeValues(parsedLeft.value, parsedRight.value);
            if (!merged.valid) {
                $8d7dfc0884542f0c$export$db7caee60e5d514d(ctx, {
                    code: $8d7dfc0884542f0c$export$5ba560653e4a1035.invalid_intersection_types
                });
                return $8d7dfc0884542f0c$export$9a105a556e65c2c0;
            }
            if ($8d7dfc0884542f0c$export$910b6cdd390341b3(parsedLeft) || $8d7dfc0884542f0c$export$910b6cdd390341b3(parsedRight)) status.dirty();
            return {
                status: status.value,
                value: merged.data
            };
        };
        if (ctx.common.async) return Promise.all([
            this._def.left._parseAsync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            }),
            this._def.right._parseAsync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            })
        ]).then(([left, right])=>handleParsed(left, right));
        else return handleParsed(this._def.left._parseSync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        }), this._def.right._parseSync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        }));
    }
}
$8d7dfc0884542f0c$export$c02deaf0bb5203d4.create = (left, right, params)=>{
    return new $8d7dfc0884542f0c$export$c02deaf0bb5203d4({
        left: left,
        right: right,
        typeName: $8d7dfc0884542f0c$export$558106ce543bd011.ZodIntersection,
        ...$8d7dfc0884542f0c$var$processCreateParams(params)
    });
};
class $8d7dfc0884542f0c$export$e2a18bb771d8e6a3 extends $8d7dfc0884542f0c$export$19342e026b58ebb7 {
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $8d7dfc0884542f0c$export$5716da67bfaa244d.array) {
            $8d7dfc0884542f0c$export$db7caee60e5d514d(ctx, {
                code: $8d7dfc0884542f0c$export$5ba560653e4a1035.invalid_type,
                expected: $8d7dfc0884542f0c$export$5716da67bfaa244d.array,
                received: ctx.parsedType
            });
            return $8d7dfc0884542f0c$export$9a105a556e65c2c0;
        }
        if (ctx.data.length < this._def.items.length) {
            $8d7dfc0884542f0c$export$db7caee60e5d514d(ctx, {
                code: $8d7dfc0884542f0c$export$5ba560653e4a1035.too_small,
                minimum: this._def.items.length,
                inclusive: true,
                exact: false,
                type: "array"
            });
            return $8d7dfc0884542f0c$export$9a105a556e65c2c0;
        }
        const rest = this._def.rest;
        if (!rest && ctx.data.length > this._def.items.length) {
            $8d7dfc0884542f0c$export$db7caee60e5d514d(ctx, {
                code: $8d7dfc0884542f0c$export$5ba560653e4a1035.too_big,
                maximum: this._def.items.length,
                inclusive: true,
                exact: false,
                type: "array"
            });
            status.dirty();
        }
        const items = [
            ...ctx.data
        ].map((item, itemIndex)=>{
            const schema = this._def.items[itemIndex] || this._def.rest;
            if (!schema) return null;
            return schema._parse(new $8d7dfc0884542f0c$var$ParseInputLazyPath(ctx, item, ctx.path, itemIndex));
        }).filter((x)=>!!x); // filter nulls
        if (ctx.common.async) return Promise.all(items).then((results)=>{
            return $8d7dfc0884542f0c$export$5b20a5c3d05c1f6f.mergeArray(status, results);
        });
        else return $8d7dfc0884542f0c$export$5b20a5c3d05c1f6f.mergeArray(status, items);
    }
    get items() {
        return this._def.items;
    }
    rest(rest) {
        return new $8d7dfc0884542f0c$export$e2a18bb771d8e6a3({
            ...this._def,
            rest: rest
        });
    }
}
$8d7dfc0884542f0c$export$e2a18bb771d8e6a3.create = (schemas, params)=>{
    if (!Array.isArray(schemas)) throw new Error("You must pass an array of schemas to z.tuple([ ... ])");
    return new $8d7dfc0884542f0c$export$e2a18bb771d8e6a3({
        items: schemas,
        typeName: $8d7dfc0884542f0c$export$558106ce543bd011.ZodTuple,
        rest: null,
        ...$8d7dfc0884542f0c$var$processCreateParams(params)
    });
};
class $8d7dfc0884542f0c$export$a2acc09968cb4b7f extends $8d7dfc0884542f0c$export$19342e026b58ebb7 {
    get keySchema() {
        return this._def.keyType;
    }
    get valueSchema() {
        return this._def.valueType;
    }
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $8d7dfc0884542f0c$export$5716da67bfaa244d.object) {
            $8d7dfc0884542f0c$export$db7caee60e5d514d(ctx, {
                code: $8d7dfc0884542f0c$export$5ba560653e4a1035.invalid_type,
                expected: $8d7dfc0884542f0c$export$5716da67bfaa244d.object,
                received: ctx.parsedType
            });
            return $8d7dfc0884542f0c$export$9a105a556e65c2c0;
        }
        const pairs = [];
        const keyType = this._def.keyType;
        const valueType = this._def.valueType;
        for(const key in ctx.data)pairs.push({
            key: keyType._parse(new $8d7dfc0884542f0c$var$ParseInputLazyPath(ctx, key, ctx.path, key)),
            value: valueType._parse(new $8d7dfc0884542f0c$var$ParseInputLazyPath(ctx, ctx.data[key], ctx.path, key)),
            alwaysSet: key in ctx.data
        });
        if (ctx.common.async) return $8d7dfc0884542f0c$export$5b20a5c3d05c1f6f.mergeObjectAsync(status, pairs);
        else return $8d7dfc0884542f0c$export$5b20a5c3d05c1f6f.mergeObjectSync(status, pairs);
    }
    get element() {
        return this._def.valueType;
    }
    static create(first, second, third) {
        if (second instanceof $8d7dfc0884542f0c$export$19342e026b58ebb7) return new $8d7dfc0884542f0c$export$a2acc09968cb4b7f({
            keyType: first,
            valueType: second,
            typeName: $8d7dfc0884542f0c$export$558106ce543bd011.ZodRecord,
            ...$8d7dfc0884542f0c$var$processCreateParams(third)
        });
        return new $8d7dfc0884542f0c$export$a2acc09968cb4b7f({
            keyType: $8d7dfc0884542f0c$export$1230eb29b8d3b502.create(),
            valueType: first,
            typeName: $8d7dfc0884542f0c$export$558106ce543bd011.ZodRecord,
            ...$8d7dfc0884542f0c$var$processCreateParams(second)
        });
    }
}
class $8d7dfc0884542f0c$export$163b6a2b712d9542 extends $8d7dfc0884542f0c$export$19342e026b58ebb7 {
    get keySchema() {
        return this._def.keyType;
    }
    get valueSchema() {
        return this._def.valueType;
    }
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $8d7dfc0884542f0c$export$5716da67bfaa244d.map) {
            $8d7dfc0884542f0c$export$db7caee60e5d514d(ctx, {
                code: $8d7dfc0884542f0c$export$5ba560653e4a1035.invalid_type,
                expected: $8d7dfc0884542f0c$export$5716da67bfaa244d.map,
                received: ctx.parsedType
            });
            return $8d7dfc0884542f0c$export$9a105a556e65c2c0;
        }
        const keyType = this._def.keyType;
        const valueType = this._def.valueType;
        const pairs = [
            ...ctx.data.entries()
        ].map(([key, value], index)=>{
            return {
                key: keyType._parse(new $8d7dfc0884542f0c$var$ParseInputLazyPath(ctx, key, ctx.path, [
                    index,
                    "key"
                ])),
                value: valueType._parse(new $8d7dfc0884542f0c$var$ParseInputLazyPath(ctx, value, ctx.path, [
                    index,
                    "value"
                ]))
            };
        });
        if (ctx.common.async) {
            const finalMap = new Map();
            return Promise.resolve().then(async ()=>{
                for (const pair of pairs){
                    const key = await pair.key;
                    const value = await pair.value;
                    if (key.status === "aborted" || value.status === "aborted") return $8d7dfc0884542f0c$export$9a105a556e65c2c0;
                    if (key.status === "dirty" || value.status === "dirty") status.dirty();
                    finalMap.set(key.value, value.value);
                }
                return {
                    status: status.value,
                    value: finalMap
                };
            });
        } else {
            const finalMap = new Map();
            for (const pair of pairs){
                const key = pair.key;
                const value = pair.value;
                if (key.status === "aborted" || value.status === "aborted") return $8d7dfc0884542f0c$export$9a105a556e65c2c0;
                if (key.status === "dirty" || value.status === "dirty") status.dirty();
                finalMap.set(key.value, value.value);
            }
            return {
                status: status.value,
                value: finalMap
            };
        }
    }
}
$8d7dfc0884542f0c$export$163b6a2b712d9542.create = (keyType, valueType, params)=>{
    return new $8d7dfc0884542f0c$export$163b6a2b712d9542({
        valueType: valueType,
        keyType: keyType,
        typeName: $8d7dfc0884542f0c$export$558106ce543bd011.ZodMap,
        ...$8d7dfc0884542f0c$var$processCreateParams(params)
    });
};
class $8d7dfc0884542f0c$export$977057706f816712 extends $8d7dfc0884542f0c$export$19342e026b58ebb7 {
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $8d7dfc0884542f0c$export$5716da67bfaa244d.set) {
            $8d7dfc0884542f0c$export$db7caee60e5d514d(ctx, {
                code: $8d7dfc0884542f0c$export$5ba560653e4a1035.invalid_type,
                expected: $8d7dfc0884542f0c$export$5716da67bfaa244d.set,
                received: ctx.parsedType
            });
            return $8d7dfc0884542f0c$export$9a105a556e65c2c0;
        }
        const def = this._def;
        if (def.minSize !== null) {
            if (ctx.data.size < def.minSize.value) {
                $8d7dfc0884542f0c$export$db7caee60e5d514d(ctx, {
                    code: $8d7dfc0884542f0c$export$5ba560653e4a1035.too_small,
                    minimum: def.minSize.value,
                    type: "set",
                    inclusive: true,
                    exact: false,
                    message: def.minSize.message
                });
                status.dirty();
            }
        }
        if (def.maxSize !== null) {
            if (ctx.data.size > def.maxSize.value) {
                $8d7dfc0884542f0c$export$db7caee60e5d514d(ctx, {
                    code: $8d7dfc0884542f0c$export$5ba560653e4a1035.too_big,
                    maximum: def.maxSize.value,
                    type: "set",
                    inclusive: true,
                    exact: false,
                    message: def.maxSize.message
                });
                status.dirty();
            }
        }
        const valueType = this._def.valueType;
        function finalizeSet(elements) {
            const parsedSet = new Set();
            for (const element of elements){
                if (element.status === "aborted") return $8d7dfc0884542f0c$export$9a105a556e65c2c0;
                if (element.status === "dirty") status.dirty();
                parsedSet.add(element.value);
            }
            return {
                status: status.value,
                value: parsedSet
            };
        }
        const elements = [
            ...ctx.data.values()
        ].map((item, i)=>valueType._parse(new $8d7dfc0884542f0c$var$ParseInputLazyPath(ctx, item, ctx.path, i)));
        if (ctx.common.async) return Promise.all(elements).then((elements)=>finalizeSet(elements));
        else return finalizeSet(elements);
    }
    min(minSize, message) {
        return new $8d7dfc0884542f0c$export$977057706f816712({
            ...this._def,
            minSize: {
                value: minSize,
                message: $8d7dfc0884542f0c$var$errorUtil.toString(message)
            }
        });
    }
    max(maxSize, message) {
        return new $8d7dfc0884542f0c$export$977057706f816712({
            ...this._def,
            maxSize: {
                value: maxSize,
                message: $8d7dfc0884542f0c$var$errorUtil.toString(message)
            }
        });
    }
    size(size, message) {
        return this.min(size, message).max(size, message);
    }
    nonempty(message) {
        return this.min(1, message);
    }
}
$8d7dfc0884542f0c$export$977057706f816712.create = (valueType, params)=>{
    return new $8d7dfc0884542f0c$export$977057706f816712({
        valueType: valueType,
        minSize: null,
        maxSize: null,
        typeName: $8d7dfc0884542f0c$export$558106ce543bd011.ZodSet,
        ...$8d7dfc0884542f0c$var$processCreateParams(params)
    });
};
class $8d7dfc0884542f0c$export$d4602ba55673f53c extends $8d7dfc0884542f0c$export$19342e026b58ebb7 {
    constructor(){
        super(...arguments);
        this.validate = this.implement;
    }
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $8d7dfc0884542f0c$export$5716da67bfaa244d.function) {
            $8d7dfc0884542f0c$export$db7caee60e5d514d(ctx, {
                code: $8d7dfc0884542f0c$export$5ba560653e4a1035.invalid_type,
                expected: $8d7dfc0884542f0c$export$5716da67bfaa244d.function,
                received: ctx.parsedType
            });
            return $8d7dfc0884542f0c$export$9a105a556e65c2c0;
        }
        function makeArgsIssue(args, error) {
            return $8d7dfc0884542f0c$export$244a85fde9c419ed({
                data: args,
                path: ctx.path,
                errorMaps: [
                    ctx.common.contextualErrorMap,
                    ctx.schemaErrorMap,
                    $8d7dfc0884542f0c$export$32f27c719778d4c4(),
                    $8d7dfc0884542f0c$export$341b0b6e0a6f5099
                ].filter((x)=>!!x),
                issueData: {
                    code: $8d7dfc0884542f0c$export$5ba560653e4a1035.invalid_arguments,
                    argumentsError: error
                }
            });
        }
        function makeReturnsIssue(returns, error) {
            return $8d7dfc0884542f0c$export$244a85fde9c419ed({
                data: returns,
                path: ctx.path,
                errorMaps: [
                    ctx.common.contextualErrorMap,
                    ctx.schemaErrorMap,
                    $8d7dfc0884542f0c$export$32f27c719778d4c4(),
                    $8d7dfc0884542f0c$export$341b0b6e0a6f5099
                ].filter((x)=>!!x),
                issueData: {
                    code: $8d7dfc0884542f0c$export$5ba560653e4a1035.invalid_return_type,
                    returnTypeError: error
                }
            });
        }
        const params = {
            errorMap: ctx.common.contextualErrorMap
        };
        const fn = ctx.data;
        if (this._def.returns instanceof $8d7dfc0884542f0c$export$3f196b0127d6e50a) {
            // Would love a way to avoid disabling this rule, but we need
            // an alias (using an arrow function was what caused 2651).
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            const me = this;
            return $8d7dfc0884542f0c$export$c6813a8d51f77eaf(async function(...args) {
                const error = new $8d7dfc0884542f0c$export$f98dac4b251ab333([]);
                const parsedArgs = await me._def.args.parseAsync(args, params).catch((e)=>{
                    error.addIssue(makeArgsIssue(args, e));
                    throw error;
                });
                const result = await Reflect.apply(fn, this, parsedArgs);
                const parsedReturns = await me._def.returns._def.type.parseAsync(result, params).catch((e)=>{
                    error.addIssue(makeReturnsIssue(result, e));
                    throw error;
                });
                return parsedReturns;
            });
        } else {
            // Would love a way to avoid disabling this rule, but we need
            // an alias (using an arrow function was what caused 2651).
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            const me = this;
            return $8d7dfc0884542f0c$export$c6813a8d51f77eaf(function(...args) {
                const parsedArgs = me._def.args.safeParse(args, params);
                if (!parsedArgs.success) throw new $8d7dfc0884542f0c$export$f98dac4b251ab333([
                    makeArgsIssue(args, parsedArgs.error)
                ]);
                const result = Reflect.apply(fn, this, parsedArgs.data);
                const parsedReturns = me._def.returns.safeParse(result, params);
                if (!parsedReturns.success) throw new $8d7dfc0884542f0c$export$f98dac4b251ab333([
                    makeReturnsIssue(result, parsedReturns.error)
                ]);
                return parsedReturns.data;
            });
        }
    }
    parameters() {
        return this._def.args;
    }
    returnType() {
        return this._def.returns;
    }
    args(...items) {
        return new $8d7dfc0884542f0c$export$d4602ba55673f53c({
            ...this._def,
            args: $8d7dfc0884542f0c$export$e2a18bb771d8e6a3.create(items).rest($8d7dfc0884542f0c$export$ef3b1bb1630977ae.create())
        });
    }
    returns(returnType) {
        return new $8d7dfc0884542f0c$export$d4602ba55673f53c({
            ...this._def,
            returns: returnType
        });
    }
    implement(func) {
        const validatedFunc = this.parse(func);
        return validatedFunc;
    }
    strictImplement(func) {
        const validatedFunc = this.parse(func);
        return validatedFunc;
    }
    static create(args, returns, params) {
        return new $8d7dfc0884542f0c$export$d4602ba55673f53c({
            args: args ? args : $8d7dfc0884542f0c$export$e2a18bb771d8e6a3.create([]).rest($8d7dfc0884542f0c$export$ef3b1bb1630977ae.create()),
            returns: returns || $8d7dfc0884542f0c$export$ef3b1bb1630977ae.create(),
            typeName: $8d7dfc0884542f0c$export$558106ce543bd011.ZodFunction,
            ...$8d7dfc0884542f0c$var$processCreateParams(params)
        });
    }
}
class $8d7dfc0884542f0c$export$378d0cfce37406e6 extends $8d7dfc0884542f0c$export$19342e026b58ebb7 {
    get schema() {
        return this._def.getter();
    }
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        const lazySchema = this._def.getter();
        return lazySchema._parse({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        });
    }
}
$8d7dfc0884542f0c$export$378d0cfce37406e6.create = (getter, params)=>{
    return new $8d7dfc0884542f0c$export$378d0cfce37406e6({
        getter: getter,
        typeName: $8d7dfc0884542f0c$export$558106ce543bd011.ZodLazy,
        ...$8d7dfc0884542f0c$var$processCreateParams(params)
    });
};
class $8d7dfc0884542f0c$export$7e44096782a165d3 extends $8d7dfc0884542f0c$export$19342e026b58ebb7 {
    _parse(input) {
        if (input.data !== this._def.value) {
            const ctx = this._getOrReturnCtx(input);
            $8d7dfc0884542f0c$export$db7caee60e5d514d(ctx, {
                received: ctx.data,
                code: $8d7dfc0884542f0c$export$5ba560653e4a1035.invalid_literal,
                expected: this._def.value
            });
            return $8d7dfc0884542f0c$export$9a105a556e65c2c0;
        }
        return {
            status: "valid",
            value: input.data
        };
    }
    get value() {
        return this._def.value;
    }
}
$8d7dfc0884542f0c$export$7e44096782a165d3.create = (value, params)=>{
    return new $8d7dfc0884542f0c$export$7e44096782a165d3({
        value: value,
        typeName: $8d7dfc0884542f0c$export$558106ce543bd011.ZodLiteral,
        ...$8d7dfc0884542f0c$var$processCreateParams(params)
    });
};
function $8d7dfc0884542f0c$var$createZodEnum(values, params) {
    return new $8d7dfc0884542f0c$export$d325d1f0e1c20179({
        values: values,
        typeName: $8d7dfc0884542f0c$export$558106ce543bd011.ZodEnum,
        ...$8d7dfc0884542f0c$var$processCreateParams(params)
    });
}
class $8d7dfc0884542f0c$export$d325d1f0e1c20179 extends $8d7dfc0884542f0c$export$19342e026b58ebb7 {
    constructor(){
        super(...arguments);
        $8d7dfc0884542f0c$var$_ZodEnum_cache.set(this, void 0);
    }
    _parse(input) {
        if (typeof input.data !== "string") {
            const ctx = this._getOrReturnCtx(input);
            const expectedValues = this._def.values;
            $8d7dfc0884542f0c$export$db7caee60e5d514d(ctx, {
                expected: $8d7dfc0884542f0c$export$7debb50ef11d5e0b.joinValues(expectedValues),
                received: ctx.parsedType,
                code: $8d7dfc0884542f0c$export$5ba560653e4a1035.invalid_type
            });
            return $8d7dfc0884542f0c$export$9a105a556e65c2c0;
        }
        if (!$8d7dfc0884542f0c$var$__classPrivateFieldGet(this, $8d7dfc0884542f0c$var$_ZodEnum_cache, "f")) $8d7dfc0884542f0c$var$__classPrivateFieldSet(this, $8d7dfc0884542f0c$var$_ZodEnum_cache, new Set(this._def.values), "f");
        if (!$8d7dfc0884542f0c$var$__classPrivateFieldGet(this, $8d7dfc0884542f0c$var$_ZodEnum_cache, "f").has(input.data)) {
            const ctx = this._getOrReturnCtx(input);
            const expectedValues = this._def.values;
            $8d7dfc0884542f0c$export$db7caee60e5d514d(ctx, {
                received: ctx.data,
                code: $8d7dfc0884542f0c$export$5ba560653e4a1035.invalid_enum_value,
                options: expectedValues
            });
            return $8d7dfc0884542f0c$export$9a105a556e65c2c0;
        }
        return $8d7dfc0884542f0c$export$c6813a8d51f77eaf(input.data);
    }
    get options() {
        return this._def.values;
    }
    get enum() {
        const enumValues = {};
        for (const val of this._def.values)enumValues[val] = val;
        return enumValues;
    }
    get Values() {
        const enumValues = {};
        for (const val of this._def.values)enumValues[val] = val;
        return enumValues;
    }
    get Enum() {
        const enumValues = {};
        for (const val of this._def.values)enumValues[val] = val;
        return enumValues;
    }
    extract(values, newDef = this._def) {
        return $8d7dfc0884542f0c$export$d325d1f0e1c20179.create(values, {
            ...this._def,
            ...newDef
        });
    }
    exclude(values, newDef = this._def) {
        return $8d7dfc0884542f0c$export$d325d1f0e1c20179.create(this.options.filter((opt)=>!values.includes(opt)), {
            ...this._def,
            ...newDef
        });
    }
}
$8d7dfc0884542f0c$var$_ZodEnum_cache = new WeakMap();
$8d7dfc0884542f0c$export$d325d1f0e1c20179.create = $8d7dfc0884542f0c$var$createZodEnum;
class $8d7dfc0884542f0c$export$370b2e8d6d6f5c56 extends $8d7dfc0884542f0c$export$19342e026b58ebb7 {
    constructor(){
        super(...arguments);
        $8d7dfc0884542f0c$var$_ZodNativeEnum_cache.set(this, void 0);
    }
    _parse(input) {
        const nativeEnumValues = $8d7dfc0884542f0c$export$7debb50ef11d5e0b.getValidEnumValues(this._def.values);
        const ctx = this._getOrReturnCtx(input);
        if (ctx.parsedType !== $8d7dfc0884542f0c$export$5716da67bfaa244d.string && ctx.parsedType !== $8d7dfc0884542f0c$export$5716da67bfaa244d.number) {
            const expectedValues = $8d7dfc0884542f0c$export$7debb50ef11d5e0b.objectValues(nativeEnumValues);
            $8d7dfc0884542f0c$export$db7caee60e5d514d(ctx, {
                expected: $8d7dfc0884542f0c$export$7debb50ef11d5e0b.joinValues(expectedValues),
                received: ctx.parsedType,
                code: $8d7dfc0884542f0c$export$5ba560653e4a1035.invalid_type
            });
            return $8d7dfc0884542f0c$export$9a105a556e65c2c0;
        }
        if (!$8d7dfc0884542f0c$var$__classPrivateFieldGet(this, $8d7dfc0884542f0c$var$_ZodNativeEnum_cache, "f")) $8d7dfc0884542f0c$var$__classPrivateFieldSet(this, $8d7dfc0884542f0c$var$_ZodNativeEnum_cache, new Set($8d7dfc0884542f0c$export$7debb50ef11d5e0b.getValidEnumValues(this._def.values)), "f");
        if (!$8d7dfc0884542f0c$var$__classPrivateFieldGet(this, $8d7dfc0884542f0c$var$_ZodNativeEnum_cache, "f").has(input.data)) {
            const expectedValues = $8d7dfc0884542f0c$export$7debb50ef11d5e0b.objectValues(nativeEnumValues);
            $8d7dfc0884542f0c$export$db7caee60e5d514d(ctx, {
                received: ctx.data,
                code: $8d7dfc0884542f0c$export$5ba560653e4a1035.invalid_enum_value,
                options: expectedValues
            });
            return $8d7dfc0884542f0c$export$9a105a556e65c2c0;
        }
        return $8d7dfc0884542f0c$export$c6813a8d51f77eaf(input.data);
    }
    get enum() {
        return this._def.values;
    }
}
$8d7dfc0884542f0c$var$_ZodNativeEnum_cache = new WeakMap();
$8d7dfc0884542f0c$export$370b2e8d6d6f5c56.create = (values, params)=>{
    return new $8d7dfc0884542f0c$export$370b2e8d6d6f5c56({
        values: values,
        typeName: $8d7dfc0884542f0c$export$558106ce543bd011.ZodNativeEnum,
        ...$8d7dfc0884542f0c$var$processCreateParams(params)
    });
};
class $8d7dfc0884542f0c$export$3f196b0127d6e50a extends $8d7dfc0884542f0c$export$19342e026b58ebb7 {
    unwrap() {
        return this._def.type;
    }
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $8d7dfc0884542f0c$export$5716da67bfaa244d.promise && ctx.common.async === false) {
            $8d7dfc0884542f0c$export$db7caee60e5d514d(ctx, {
                code: $8d7dfc0884542f0c$export$5ba560653e4a1035.invalid_type,
                expected: $8d7dfc0884542f0c$export$5716da67bfaa244d.promise,
                received: ctx.parsedType
            });
            return $8d7dfc0884542f0c$export$9a105a556e65c2c0;
        }
        const promisified = ctx.parsedType === $8d7dfc0884542f0c$export$5716da67bfaa244d.promise ? ctx.data : Promise.resolve(ctx.data);
        return $8d7dfc0884542f0c$export$c6813a8d51f77eaf(promisified.then((data)=>{
            return this._def.type.parseAsync(data, {
                path: ctx.path,
                errorMap: ctx.common.contextualErrorMap
            });
        }));
    }
}
$8d7dfc0884542f0c$export$3f196b0127d6e50a.create = (schema, params)=>{
    return new $8d7dfc0884542f0c$export$3f196b0127d6e50a({
        type: schema,
        typeName: $8d7dfc0884542f0c$export$558106ce543bd011.ZodPromise,
        ...$8d7dfc0884542f0c$var$processCreateParams(params)
    });
};
class $8d7dfc0884542f0c$export$a60af00cc0ce2582 extends $8d7dfc0884542f0c$export$19342e026b58ebb7 {
    innerType() {
        return this._def.schema;
    }
    sourceType() {
        return this._def.schema._def.typeName === $8d7dfc0884542f0c$export$558106ce543bd011.ZodEffects ? this._def.schema.sourceType() : this._def.schema;
    }
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        const effect = this._def.effect || null;
        const checkCtx = {
            addIssue: (arg)=>{
                $8d7dfc0884542f0c$export$db7caee60e5d514d(ctx, arg);
                if (arg.fatal) status.abort();
                else status.dirty();
            },
            get path () {
                return ctx.path;
            }
        };
        checkCtx.addIssue = checkCtx.addIssue.bind(checkCtx);
        if (effect.type === "preprocess") {
            const processed = effect.transform(ctx.data, checkCtx);
            if (ctx.common.async) return Promise.resolve(processed).then(async (processed)=>{
                if (status.value === "aborted") return $8d7dfc0884542f0c$export$9a105a556e65c2c0;
                const result = await this._def.schema._parseAsync({
                    data: processed,
                    path: ctx.path,
                    parent: ctx
                });
                if (result.status === "aborted") return $8d7dfc0884542f0c$export$9a105a556e65c2c0;
                if (result.status === "dirty") return $8d7dfc0884542f0c$export$325a211da9693fcf(result.value);
                if (status.value === "dirty") return $8d7dfc0884542f0c$export$325a211da9693fcf(result.value);
                return result;
            });
            else {
                if (status.value === "aborted") return $8d7dfc0884542f0c$export$9a105a556e65c2c0;
                const result = this._def.schema._parseSync({
                    data: processed,
                    path: ctx.path,
                    parent: ctx
                });
                if (result.status === "aborted") return $8d7dfc0884542f0c$export$9a105a556e65c2c0;
                if (result.status === "dirty") return $8d7dfc0884542f0c$export$325a211da9693fcf(result.value);
                if (status.value === "dirty") return $8d7dfc0884542f0c$export$325a211da9693fcf(result.value);
                return result;
            }
        }
        if (effect.type === "refinement") {
            const executeRefinement = (acc)=>{
                const result = effect.refinement(acc, checkCtx);
                if (ctx.common.async) return Promise.resolve(result);
                if (result instanceof Promise) throw new Error("Async refinement encountered during synchronous parse operation. Use .parseAsync instead.");
                return acc;
            };
            if (ctx.common.async === false) {
                const inner = this._def.schema._parseSync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx
                });
                if (inner.status === "aborted") return $8d7dfc0884542f0c$export$9a105a556e65c2c0;
                if (inner.status === "dirty") status.dirty();
                // return value is ignored
                executeRefinement(inner.value);
                return {
                    status: status.value,
                    value: inner.value
                };
            } else return this._def.schema._parseAsync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            }).then((inner)=>{
                if (inner.status === "aborted") return $8d7dfc0884542f0c$export$9a105a556e65c2c0;
                if (inner.status === "dirty") status.dirty();
                return executeRefinement(inner.value).then(()=>{
                    return {
                        status: status.value,
                        value: inner.value
                    };
                });
            });
        }
        if (effect.type === "transform") {
            if (ctx.common.async === false) {
                const base = this._def.schema._parseSync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx
                });
                if (!$8d7dfc0884542f0c$export$1ea939691cdc45b8(base)) return base;
                const result = effect.transform(base.value, checkCtx);
                if (result instanceof Promise) throw new Error(`Asynchronous transform encountered during synchronous parse operation. Use .parseAsync instead.`);
                return {
                    status: status.value,
                    value: result
                };
            } else return this._def.schema._parseAsync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            }).then((base)=>{
                if (!$8d7dfc0884542f0c$export$1ea939691cdc45b8(base)) return base;
                return Promise.resolve(effect.transform(base.value, checkCtx)).then((result)=>({
                        status: status.value,
                        value: result
                    }));
            });
        }
        $8d7dfc0884542f0c$export$7debb50ef11d5e0b.assertNever(effect);
    }
}
$8d7dfc0884542f0c$export$a60af00cc0ce2582.create = (schema, effect, params)=>{
    return new $8d7dfc0884542f0c$export$a60af00cc0ce2582({
        schema: schema,
        typeName: $8d7dfc0884542f0c$export$558106ce543bd011.ZodEffects,
        effect: effect,
        ...$8d7dfc0884542f0c$var$processCreateParams(params)
    });
};
$8d7dfc0884542f0c$export$a60af00cc0ce2582.createWithPreprocess = (preprocess, schema, params)=>{
    return new $8d7dfc0884542f0c$export$a60af00cc0ce2582({
        schema: schema,
        effect: {
            type: "preprocess",
            transform: preprocess
        },
        typeName: $8d7dfc0884542f0c$export$558106ce543bd011.ZodEffects,
        ...$8d7dfc0884542f0c$var$processCreateParams(params)
    });
};
class $8d7dfc0884542f0c$export$aa56fec1e9d629b8 extends $8d7dfc0884542f0c$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType === $8d7dfc0884542f0c$export$5716da67bfaa244d.undefined) return $8d7dfc0884542f0c$export$c6813a8d51f77eaf(undefined);
        return this._def.innerType._parse(input);
    }
    unwrap() {
        return this._def.innerType;
    }
}
$8d7dfc0884542f0c$export$aa56fec1e9d629b8.create = (type, params)=>{
    return new $8d7dfc0884542f0c$export$aa56fec1e9d629b8({
        innerType: type,
        typeName: $8d7dfc0884542f0c$export$558106ce543bd011.ZodOptional,
        ...$8d7dfc0884542f0c$var$processCreateParams(params)
    });
};
class $8d7dfc0884542f0c$export$aaac0b8b429cef5 extends $8d7dfc0884542f0c$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType === $8d7dfc0884542f0c$export$5716da67bfaa244d.null) return $8d7dfc0884542f0c$export$c6813a8d51f77eaf(null);
        return this._def.innerType._parse(input);
    }
    unwrap() {
        return this._def.innerType;
    }
}
$8d7dfc0884542f0c$export$aaac0b8b429cef5.create = (type, params)=>{
    return new $8d7dfc0884542f0c$export$aaac0b8b429cef5({
        innerType: type,
        typeName: $8d7dfc0884542f0c$export$558106ce543bd011.ZodNullable,
        ...$8d7dfc0884542f0c$var$processCreateParams(params)
    });
};
class $8d7dfc0884542f0c$export$bb19b37874861e7e extends $8d7dfc0884542f0c$export$19342e026b58ebb7 {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        let data = ctx.data;
        if (ctx.parsedType === $8d7dfc0884542f0c$export$5716da67bfaa244d.undefined) data = this._def.defaultValue();
        return this._def.innerType._parse({
            data: data,
            path: ctx.path,
            parent: ctx
        });
    }
    removeDefault() {
        return this._def.innerType;
    }
}
$8d7dfc0884542f0c$export$bb19b37874861e7e.create = (type, params)=>{
    return new $8d7dfc0884542f0c$export$bb19b37874861e7e({
        innerType: type,
        typeName: $8d7dfc0884542f0c$export$558106ce543bd011.ZodDefault,
        defaultValue: typeof params.default === "function" ? params.default : ()=>params.default,
        ...$8d7dfc0884542f0c$var$processCreateParams(params)
    });
};
class $8d7dfc0884542f0c$export$75a44ec6249ac76b extends $8d7dfc0884542f0c$export$19342e026b58ebb7 {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        // newCtx is used to not collect issues from inner types in ctx
        const newCtx = {
            ...ctx,
            common: {
                ...ctx.common,
                issues: []
            }
        };
        const result = this._def.innerType._parse({
            data: newCtx.data,
            path: newCtx.path,
            parent: {
                ...newCtx
            }
        });
        if ($8d7dfc0884542f0c$export$aefee5ebe1dcfd9e(result)) return result.then((result)=>{
            return {
                status: "valid",
                value: result.status === "valid" ? result.value : this._def.catchValue({
                    get error () {
                        return new $8d7dfc0884542f0c$export$f98dac4b251ab333(newCtx.common.issues);
                    },
                    input: newCtx.data
                })
            };
        });
        else return {
            status: "valid",
            value: result.status === "valid" ? result.value : this._def.catchValue({
                get error () {
                    return new $8d7dfc0884542f0c$export$f98dac4b251ab333(newCtx.common.issues);
                },
                input: newCtx.data
            })
        };
    }
    removeCatch() {
        return this._def.innerType;
    }
}
$8d7dfc0884542f0c$export$75a44ec6249ac76b.create = (type, params)=>{
    return new $8d7dfc0884542f0c$export$75a44ec6249ac76b({
        innerType: type,
        typeName: $8d7dfc0884542f0c$export$558106ce543bd011.ZodCatch,
        catchValue: typeof params.catch === "function" ? params.catch : ()=>params.catch,
        ...$8d7dfc0884542f0c$var$processCreateParams(params)
    });
};
class $8d7dfc0884542f0c$export$26ccfa0145e8511f extends $8d7dfc0884542f0c$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== $8d7dfc0884542f0c$export$5716da67bfaa244d.nan) {
            const ctx = this._getOrReturnCtx(input);
            $8d7dfc0884542f0c$export$db7caee60e5d514d(ctx, {
                code: $8d7dfc0884542f0c$export$5ba560653e4a1035.invalid_type,
                expected: $8d7dfc0884542f0c$export$5716da67bfaa244d.nan,
                received: ctx.parsedType
            });
            return $8d7dfc0884542f0c$export$9a105a556e65c2c0;
        }
        return {
            status: "valid",
            value: input.data
        };
    }
}
$8d7dfc0884542f0c$export$26ccfa0145e8511f.create = (params)=>{
    return new $8d7dfc0884542f0c$export$26ccfa0145e8511f({
        typeName: $8d7dfc0884542f0c$export$558106ce543bd011.ZodNaN,
        ...$8d7dfc0884542f0c$var$processCreateParams(params)
    });
};
const $8d7dfc0884542f0c$export$cf2deea74cde46b4 = Symbol("zod_brand");
class $8d7dfc0884542f0c$export$66b0c798a395271f extends $8d7dfc0884542f0c$export$19342e026b58ebb7 {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        const data = ctx.data;
        return this._def.type._parse({
            data: data,
            path: ctx.path,
            parent: ctx
        });
    }
    unwrap() {
        return this._def.type;
    }
}
class $8d7dfc0884542f0c$export$a3c3ef8a0e95c6da extends $8d7dfc0884542f0c$export$19342e026b58ebb7 {
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        if (ctx.common.async) {
            const handleAsync = async ()=>{
                const inResult = await this._def.in._parseAsync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx
                });
                if (inResult.status === "aborted") return $8d7dfc0884542f0c$export$9a105a556e65c2c0;
                if (inResult.status === "dirty") {
                    status.dirty();
                    return $8d7dfc0884542f0c$export$325a211da9693fcf(inResult.value);
                } else return this._def.out._parseAsync({
                    data: inResult.value,
                    path: ctx.path,
                    parent: ctx
                });
            };
            return handleAsync();
        } else {
            const inResult = this._def.in._parseSync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            });
            if (inResult.status === "aborted") return $8d7dfc0884542f0c$export$9a105a556e65c2c0;
            if (inResult.status === "dirty") {
                status.dirty();
                return {
                    status: "dirty",
                    value: inResult.value
                };
            } else return this._def.out._parseSync({
                data: inResult.value,
                path: ctx.path,
                parent: ctx
            });
        }
    }
    static create(a, b) {
        return new $8d7dfc0884542f0c$export$a3c3ef8a0e95c6da({
            in: a,
            out: b,
            typeName: $8d7dfc0884542f0c$export$558106ce543bd011.ZodPipeline
        });
    }
}
class $8d7dfc0884542f0c$export$5d1f7ef05c4e493a extends $8d7dfc0884542f0c$export$19342e026b58ebb7 {
    _parse(input) {
        const result = this._def.innerType._parse(input);
        const freeze = (data)=>{
            if ($8d7dfc0884542f0c$export$1ea939691cdc45b8(data)) data.value = Object.freeze(data.value);
            return data;
        };
        return $8d7dfc0884542f0c$export$aefee5ebe1dcfd9e(result) ? result.then((data)=>freeze(data)) : freeze(result);
    }
    unwrap() {
        return this._def.innerType;
    }
}
$8d7dfc0884542f0c$export$5d1f7ef05c4e493a.create = (type, params)=>{
    return new $8d7dfc0884542f0c$export$5d1f7ef05c4e493a({
        innerType: type,
        typeName: $8d7dfc0884542f0c$export$558106ce543bd011.ZodReadonly,
        ...$8d7dfc0884542f0c$var$processCreateParams(params)
    });
};
function $8d7dfc0884542f0c$export$4c00f665f0d4b443(check, params = {}, /**
 * @deprecated
 *
 * Pass `fatal` into the params object instead:
 *
 * ```ts
 * z.string().custom((val) => val.length > 5, { fatal: false })
 * ```
 *
 */ fatal) {
    if (check) return $8d7dfc0884542f0c$export$b9d1edb536b4e4eb.create().superRefine((data, ctx)=>{
        var _a, _b;
        if (!check(data)) {
            const p = typeof params === "function" ? params(data) : typeof params === "string" ? {
                message: params
            } : params;
            const _fatal = (_b = (_a = p.fatal) !== null && _a !== void 0 ? _a : fatal) !== null && _b !== void 0 ? _b : true;
            const p2 = typeof p === "string" ? {
                message: p
            } : p;
            ctx.addIssue({
                code: "custom",
                ...p2,
                fatal: _fatal
            });
        }
    });
    return $8d7dfc0884542f0c$export$b9d1edb536b4e4eb.create();
}
const $8d7dfc0884542f0c$export$1ee8ee30835eab8b = {
    object: $8d7dfc0884542f0c$export$736315c5b55efbad.lazycreate
};
var $8d7dfc0884542f0c$export$558106ce543bd011;
(function(ZodFirstPartyTypeKind) {
    ZodFirstPartyTypeKind["ZodString"] = "ZodString";
    ZodFirstPartyTypeKind["ZodNumber"] = "ZodNumber";
    ZodFirstPartyTypeKind["ZodNaN"] = "ZodNaN";
    ZodFirstPartyTypeKind["ZodBigInt"] = "ZodBigInt";
    ZodFirstPartyTypeKind["ZodBoolean"] = "ZodBoolean";
    ZodFirstPartyTypeKind["ZodDate"] = "ZodDate";
    ZodFirstPartyTypeKind["ZodSymbol"] = "ZodSymbol";
    ZodFirstPartyTypeKind["ZodUndefined"] = "ZodUndefined";
    ZodFirstPartyTypeKind["ZodNull"] = "ZodNull";
    ZodFirstPartyTypeKind["ZodAny"] = "ZodAny";
    ZodFirstPartyTypeKind["ZodUnknown"] = "ZodUnknown";
    ZodFirstPartyTypeKind["ZodNever"] = "ZodNever";
    ZodFirstPartyTypeKind["ZodVoid"] = "ZodVoid";
    ZodFirstPartyTypeKind["ZodArray"] = "ZodArray";
    ZodFirstPartyTypeKind["ZodObject"] = "ZodObject";
    ZodFirstPartyTypeKind["ZodUnion"] = "ZodUnion";
    ZodFirstPartyTypeKind["ZodDiscriminatedUnion"] = "ZodDiscriminatedUnion";
    ZodFirstPartyTypeKind["ZodIntersection"] = "ZodIntersection";
    ZodFirstPartyTypeKind["ZodTuple"] = "ZodTuple";
    ZodFirstPartyTypeKind["ZodRecord"] = "ZodRecord";
    ZodFirstPartyTypeKind["ZodMap"] = "ZodMap";
    ZodFirstPartyTypeKind["ZodSet"] = "ZodSet";
    ZodFirstPartyTypeKind["ZodFunction"] = "ZodFunction";
    ZodFirstPartyTypeKind["ZodLazy"] = "ZodLazy";
    ZodFirstPartyTypeKind["ZodLiteral"] = "ZodLiteral";
    ZodFirstPartyTypeKind["ZodEnum"] = "ZodEnum";
    ZodFirstPartyTypeKind["ZodEffects"] = "ZodEffects";
    ZodFirstPartyTypeKind["ZodNativeEnum"] = "ZodNativeEnum";
    ZodFirstPartyTypeKind["ZodOptional"] = "ZodOptional";
    ZodFirstPartyTypeKind["ZodNullable"] = "ZodNullable";
    ZodFirstPartyTypeKind["ZodDefault"] = "ZodDefault";
    ZodFirstPartyTypeKind["ZodCatch"] = "ZodCatch";
    ZodFirstPartyTypeKind["ZodPromise"] = "ZodPromise";
    ZodFirstPartyTypeKind["ZodBranded"] = "ZodBranded";
    ZodFirstPartyTypeKind["ZodPipeline"] = "ZodPipeline";
    ZodFirstPartyTypeKind["ZodReadonly"] = "ZodReadonly";
})($8d7dfc0884542f0c$export$558106ce543bd011 || ($8d7dfc0884542f0c$export$558106ce543bd011 = {}));
const $8d7dfc0884542f0c$export$3d916e7c22dbd8b5 = (// const instanceOfType = <T extends new (...args: any[]) => any>(
cls, params = {
    message: `Input not instance of ${cls.name}`
})=>$8d7dfc0884542f0c$export$4c00f665f0d4b443((data)=>data instanceof cls, params);
const $8d7dfc0884542f0c$export$22b082955e083ec3 = $8d7dfc0884542f0c$export$1230eb29b8d3b502.create;
const $8d7dfc0884542f0c$export$98e628dec113755e = $8d7dfc0884542f0c$export$5b070a55c0c43e09.create;
const $8d7dfc0884542f0c$export$9e06de0973666692 = $8d7dfc0884542f0c$export$26ccfa0145e8511f.create;
const $8d7dfc0884542f0c$export$a0f65b52274bcc00 = $8d7dfc0884542f0c$export$67d741fd70ff98f4.create;
const $8d7dfc0884542f0c$export$4a21f16c33752377 = $8d7dfc0884542f0c$export$723d146f80596191.create;
const $8d7dfc0884542f0c$export$324d90190a8b822a = $8d7dfc0884542f0c$export$e974be33bdc55521.create;
const $8d7dfc0884542f0c$export$8f701197936bc2a6 = $8d7dfc0884542f0c$export$bcc3b40f6b638044.create;
const $8d7dfc0884542f0c$export$1db45310990710a5 = $8d7dfc0884542f0c$export$4e780e961c30340d.create;
const $8d7dfc0884542f0c$export$7b1b591b262c240 = $8d7dfc0884542f0c$export$a96281f914484f2d.create;
const $8d7dfc0884542f0c$export$4154a199d7d90455 = $8d7dfc0884542f0c$export$b9d1edb536b4e4eb.create;
const $8d7dfc0884542f0c$export$19282c40b967aec6 = $8d7dfc0884542f0c$export$ef3b1bb1630977ae.create;
const $8d7dfc0884542f0c$export$b3e22bcfd64c1022 = $8d7dfc0884542f0c$export$1e576a20c3ce9fb5.create;
const $8d7dfc0884542f0c$export$490e536ee7389aeb = $8d7dfc0884542f0c$export$7d39f5df85f21031.create;
const $8d7dfc0884542f0c$export$2f23118c22fb2630 = $8d7dfc0884542f0c$export$7acfc3e64785411.create;
const $8d7dfc0884542f0c$export$be5493f9613cbbe = $8d7dfc0884542f0c$export$736315c5b55efbad.create;
const $8d7dfc0884542f0c$export$8fb0df5f40d0b477 = $8d7dfc0884542f0c$export$736315c5b55efbad.strictCreate;
const $8d7dfc0884542f0c$export$971dd5b0dfd021b6 = $8d7dfc0884542f0c$export$a8b236cb5070a311.create;
const $8d7dfc0884542f0c$export$4b888e40c4ee26dd = $8d7dfc0884542f0c$export$5ef2424805ac76a3.create;
const $8d7dfc0884542f0c$export$bc86dfbf7795668c = $8d7dfc0884542f0c$export$c02deaf0bb5203d4.create;
const $8d7dfc0884542f0c$export$65e3907585753458 = $8d7dfc0884542f0c$export$e2a18bb771d8e6a3.create;
const $8d7dfc0884542f0c$export$e5185e241753e543 = $8d7dfc0884542f0c$export$a2acc09968cb4b7f.create;
const $8d7dfc0884542f0c$export$871de8747c9eaa88 = $8d7dfc0884542f0c$export$163b6a2b712d9542.create;
const $8d7dfc0884542f0c$export$adaa4cf7ef1b65be = $8d7dfc0884542f0c$export$977057706f816712.create;
const $8d7dfc0884542f0c$export$44e51c8aac7c2deb = $8d7dfc0884542f0c$export$d4602ba55673f53c.create;
const $8d7dfc0884542f0c$export$488013bae63b21da = $8d7dfc0884542f0c$export$378d0cfce37406e6.create;
const $8d7dfc0884542f0c$export$c8ec6e1ec9fefcb0 = $8d7dfc0884542f0c$export$7e44096782a165d3.create;
const $8d7dfc0884542f0c$export$78a99c8d44d72635 = $8d7dfc0884542f0c$export$d325d1f0e1c20179.create;
const $8d7dfc0884542f0c$export$6fe7eca19ebe5199 = $8d7dfc0884542f0c$export$370b2e8d6d6f5c56.create;
const $8d7dfc0884542f0c$export$c957ef27a0ebfd4 = $8d7dfc0884542f0c$export$3f196b0127d6e50a.create;
const $8d7dfc0884542f0c$export$dc573d8a6576cdb3 = $8d7dfc0884542f0c$export$a60af00cc0ce2582.create;
const $8d7dfc0884542f0c$export$516e28dec6a4b6d4 = $8d7dfc0884542f0c$export$aa56fec1e9d629b8.create;
const $8d7dfc0884542f0c$export$133fc36489ac9add = $8d7dfc0884542f0c$export$aaac0b8b429cef5.create;
const $8d7dfc0884542f0c$export$fc37fe19dfda43ee = $8d7dfc0884542f0c$export$a60af00cc0ce2582.createWithPreprocess;
const $8d7dfc0884542f0c$export$43f28b24e1eb8181 = $8d7dfc0884542f0c$export$a3c3ef8a0e95c6da.create;
const $8d7dfc0884542f0c$export$3b3d07727c5b702c = ()=>$8d7dfc0884542f0c$export$22b082955e083ec3().optional();
const $8d7dfc0884542f0c$export$eb150471a61fced6 = ()=>$8d7dfc0884542f0c$export$98e628dec113755e().optional();
const $8d7dfc0884542f0c$export$269251733cdcbbf1 = ()=>$8d7dfc0884542f0c$export$4a21f16c33752377().optional();
const $8d7dfc0884542f0c$export$8c14e57e778d3873 = {
    string: (arg)=>$8d7dfc0884542f0c$export$1230eb29b8d3b502.create({
            ...arg,
            coerce: true
        }),
    number: (arg)=>$8d7dfc0884542f0c$export$5b070a55c0c43e09.create({
            ...arg,
            coerce: true
        }),
    boolean: (arg)=>$8d7dfc0884542f0c$export$723d146f80596191.create({
            ...arg,
            coerce: true
        }),
    bigint: (arg)=>$8d7dfc0884542f0c$export$67d741fd70ff98f4.create({
            ...arg,
            coerce: true
        }),
    date: (arg)=>$8d7dfc0884542f0c$export$e974be33bdc55521.create({
            ...arg,
            coerce: true
        })
};
const $8d7dfc0884542f0c$export$96c94437c95d7862 = $8d7dfc0884542f0c$export$9a105a556e65c2c0;
var $8d7dfc0884542f0c$export$2e2bcd8739ae039 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    defaultErrorMap: $8d7dfc0884542f0c$export$341b0b6e0a6f5099,
    setErrorMap: $8d7dfc0884542f0c$export$1097a8289cfd22d7,
    getErrorMap: $8d7dfc0884542f0c$export$32f27c719778d4c4,
    makeIssue: $8d7dfc0884542f0c$export$244a85fde9c419ed,
    EMPTY_PATH: $8d7dfc0884542f0c$export$1526d2e05f74572,
    addIssueToContext: $8d7dfc0884542f0c$export$db7caee60e5d514d,
    ParseStatus: $8d7dfc0884542f0c$export$5b20a5c3d05c1f6f,
    INVALID: $8d7dfc0884542f0c$export$9a105a556e65c2c0,
    DIRTY: $8d7dfc0884542f0c$export$325a211da9693fcf,
    OK: $8d7dfc0884542f0c$export$c6813a8d51f77eaf,
    isAborted: $8d7dfc0884542f0c$export$afa861e3c5730743,
    isDirty: $8d7dfc0884542f0c$export$910b6cdd390341b3,
    isValid: $8d7dfc0884542f0c$export$1ea939691cdc45b8,
    isAsync: $8d7dfc0884542f0c$export$aefee5ebe1dcfd9e,
    get util () {
        return $8d7dfc0884542f0c$export$7debb50ef11d5e0b;
    },
    get objectUtil () {
        return $8d7dfc0884542f0c$export$4aa2142c225fd5c7;
    },
    ZodParsedType: $8d7dfc0884542f0c$export$5716da67bfaa244d,
    getParsedType: $8d7dfc0884542f0c$export$3e9057828ebd5c7a,
    ZodType: $8d7dfc0884542f0c$export$19342e026b58ebb7,
    datetimeRegex: $8d7dfc0884542f0c$export$a4b563879add27a,
    ZodString: $8d7dfc0884542f0c$export$1230eb29b8d3b502,
    ZodNumber: $8d7dfc0884542f0c$export$5b070a55c0c43e09,
    ZodBigInt: $8d7dfc0884542f0c$export$67d741fd70ff98f4,
    ZodBoolean: $8d7dfc0884542f0c$export$723d146f80596191,
    ZodDate: $8d7dfc0884542f0c$export$e974be33bdc55521,
    ZodSymbol: $8d7dfc0884542f0c$export$bcc3b40f6b638044,
    ZodUndefined: $8d7dfc0884542f0c$export$4e780e961c30340d,
    ZodNull: $8d7dfc0884542f0c$export$a96281f914484f2d,
    ZodAny: $8d7dfc0884542f0c$export$b9d1edb536b4e4eb,
    ZodUnknown: $8d7dfc0884542f0c$export$ef3b1bb1630977ae,
    ZodNever: $8d7dfc0884542f0c$export$1e576a20c3ce9fb5,
    ZodVoid: $8d7dfc0884542f0c$export$7d39f5df85f21031,
    ZodArray: $8d7dfc0884542f0c$export$7acfc3e64785411,
    ZodObject: $8d7dfc0884542f0c$export$736315c5b55efbad,
    ZodUnion: $8d7dfc0884542f0c$export$a8b236cb5070a311,
    ZodDiscriminatedUnion: $8d7dfc0884542f0c$export$5ef2424805ac76a3,
    ZodIntersection: $8d7dfc0884542f0c$export$c02deaf0bb5203d4,
    ZodTuple: $8d7dfc0884542f0c$export$e2a18bb771d8e6a3,
    ZodRecord: $8d7dfc0884542f0c$export$a2acc09968cb4b7f,
    ZodMap: $8d7dfc0884542f0c$export$163b6a2b712d9542,
    ZodSet: $8d7dfc0884542f0c$export$977057706f816712,
    ZodFunction: $8d7dfc0884542f0c$export$d4602ba55673f53c,
    ZodLazy: $8d7dfc0884542f0c$export$378d0cfce37406e6,
    ZodLiteral: $8d7dfc0884542f0c$export$7e44096782a165d3,
    ZodEnum: $8d7dfc0884542f0c$export$d325d1f0e1c20179,
    ZodNativeEnum: $8d7dfc0884542f0c$export$370b2e8d6d6f5c56,
    ZodPromise: $8d7dfc0884542f0c$export$3f196b0127d6e50a,
    ZodEffects: $8d7dfc0884542f0c$export$a60af00cc0ce2582,
    ZodTransformer: $8d7dfc0884542f0c$export$a60af00cc0ce2582,
    ZodOptional: $8d7dfc0884542f0c$export$aa56fec1e9d629b8,
    ZodNullable: $8d7dfc0884542f0c$export$aaac0b8b429cef5,
    ZodDefault: $8d7dfc0884542f0c$export$bb19b37874861e7e,
    ZodCatch: $8d7dfc0884542f0c$export$75a44ec6249ac76b,
    ZodNaN: $8d7dfc0884542f0c$export$26ccfa0145e8511f,
    BRAND: $8d7dfc0884542f0c$export$cf2deea74cde46b4,
    ZodBranded: $8d7dfc0884542f0c$export$66b0c798a395271f,
    ZodPipeline: $8d7dfc0884542f0c$export$a3c3ef8a0e95c6da,
    ZodReadonly: $8d7dfc0884542f0c$export$5d1f7ef05c4e493a,
    custom: $8d7dfc0884542f0c$export$4c00f665f0d4b443,
    Schema: $8d7dfc0884542f0c$export$19342e026b58ebb7,
    ZodSchema: $8d7dfc0884542f0c$export$19342e026b58ebb7,
    late: $8d7dfc0884542f0c$export$1ee8ee30835eab8b,
    get ZodFirstPartyTypeKind () {
        return $8d7dfc0884542f0c$export$558106ce543bd011;
    },
    coerce: $8d7dfc0884542f0c$export$8c14e57e778d3873,
    any: $8d7dfc0884542f0c$export$4154a199d7d90455,
    array: $8d7dfc0884542f0c$export$2f23118c22fb2630,
    bigint: $8d7dfc0884542f0c$export$a0f65b52274bcc00,
    boolean: $8d7dfc0884542f0c$export$4a21f16c33752377,
    date: $8d7dfc0884542f0c$export$324d90190a8b822a,
    discriminatedUnion: $8d7dfc0884542f0c$export$4b888e40c4ee26dd,
    effect: $8d7dfc0884542f0c$export$dc573d8a6576cdb3,
    "enum": $8d7dfc0884542f0c$export$78a99c8d44d72635,
    "function": $8d7dfc0884542f0c$export$44e51c8aac7c2deb,
    "instanceof": $8d7dfc0884542f0c$export$3d916e7c22dbd8b5,
    intersection: $8d7dfc0884542f0c$export$bc86dfbf7795668c,
    lazy: $8d7dfc0884542f0c$export$488013bae63b21da,
    literal: $8d7dfc0884542f0c$export$c8ec6e1ec9fefcb0,
    map: $8d7dfc0884542f0c$export$871de8747c9eaa88,
    nan: $8d7dfc0884542f0c$export$9e06de0973666692,
    nativeEnum: $8d7dfc0884542f0c$export$6fe7eca19ebe5199,
    never: $8d7dfc0884542f0c$export$b3e22bcfd64c1022,
    "null": $8d7dfc0884542f0c$export$7b1b591b262c240,
    nullable: $8d7dfc0884542f0c$export$133fc36489ac9add,
    number: $8d7dfc0884542f0c$export$98e628dec113755e,
    object: $8d7dfc0884542f0c$export$be5493f9613cbbe,
    oboolean: $8d7dfc0884542f0c$export$269251733cdcbbf1,
    onumber: $8d7dfc0884542f0c$export$eb150471a61fced6,
    optional: $8d7dfc0884542f0c$export$516e28dec6a4b6d4,
    ostring: $8d7dfc0884542f0c$export$3b3d07727c5b702c,
    pipeline: $8d7dfc0884542f0c$export$43f28b24e1eb8181,
    preprocess: $8d7dfc0884542f0c$export$fc37fe19dfda43ee,
    promise: $8d7dfc0884542f0c$export$c957ef27a0ebfd4,
    record: $8d7dfc0884542f0c$export$e5185e241753e543,
    set: $8d7dfc0884542f0c$export$adaa4cf7ef1b65be,
    strictObject: $8d7dfc0884542f0c$export$8fb0df5f40d0b477,
    string: $8d7dfc0884542f0c$export$22b082955e083ec3,
    symbol: $8d7dfc0884542f0c$export$8f701197936bc2a6,
    transformer: $8d7dfc0884542f0c$export$dc573d8a6576cdb3,
    tuple: $8d7dfc0884542f0c$export$65e3907585753458,
    "undefined": $8d7dfc0884542f0c$export$1db45310990710a5,
    union: $8d7dfc0884542f0c$export$971dd5b0dfd021b6,
    unknown: $8d7dfc0884542f0c$export$19282c40b967aec6,
    "void": $8d7dfc0884542f0c$export$490e536ee7389aeb,
    NEVER: $8d7dfc0884542f0c$export$96c94437c95d7862,
    ZodIssueCode: $8d7dfc0884542f0c$export$5ba560653e4a1035,
    quotelessJson: $8d7dfc0884542f0c$export$913eddeaf297cfea,
    ZodError: $8d7dfc0884542f0c$export$f98dac4b251ab333
});


function $34262aad722a911a$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $34262aad722a911a$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $34262aad722a911a$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $34262aad722a911a$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $34262aad722a911a$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $34262aad722a911a$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
var $34262aad722a911a$export$c5fb415882705cf4 = /*#__PURE__*/ function(ConfigError) {
    ConfigError["NotFound"] = "not_found";
    ConfigError["InvalidState"] = "state_invalid";
    ConfigError["IncorrectType"] = "incorrect_type";
    return ConfigError;
}({});
var $34262aad722a911a$export$e94ee64b2671e155 = (0, $8d7dfc0884542f0c$export$2e2bcd8739ae039).record((0, $8d7dfc0884542f0c$export$2e2bcd8739ae039).string(), (0, $8d7dfc0884542f0c$export$2e2bcd8739ae039).object({
    value: (0, $8d7dfc0884542f0c$export$2e2bcd8739ae039).union([
        (0, $8d7dfc0884542f0c$export$2e2bcd8739ae039).boolean(),
        (0, $8d7dfc0884542f0c$export$2e2bcd8739ae039).string(),
        (0, $8d7dfc0884542f0c$export$2e2bcd8739ae039).number(),
        (0, $8d7dfc0884542f0c$export$2e2bcd8739ae039).string().array(),
        (0, $8d7dfc0884542f0c$export$2e2bcd8739ae039).number().array()
    ])
}));
var $34262aad722a911a$export$e38f7b10db0e126a = (0, $8d7dfc0884542f0c$export$2e2bcd8739ae039).tuple([
    // list of boolean configs which are on
    (0, $8d7dfc0884542f0c$export$2e2bcd8739ae039).string().array(),
    // list of string config tuples
    (0, $8d7dfc0884542f0c$export$2e2bcd8739ae039).array((0, $8d7dfc0884542f0c$export$2e2bcd8739ae039).string()).refine(function(arr) {
        return arr.length % 2 === 0;
    }),
    // list of number config tuples
    (0, $8d7dfc0884542f0c$export$2e2bcd8739ae039).array((0, $8d7dfc0884542f0c$export$2e2bcd8739ae039).union([
        (0, $8d7dfc0884542f0c$export$2e2bcd8739ae039).string(),
        (0, $8d7dfc0884542f0c$export$2e2bcd8739ae039).number()
    ])).refine(function(arr) {
        if (arr.length % 2 !== 0) return false;
        for(var i = 0; i < arr.length; i += 2){
            if (typeof arr[i] !== "string") return false;
            if (typeof arr[i + 1] !== "number") return false;
        }
        return true;
    }),
    // list of string list config tuples
    (0, $8d7dfc0884542f0c$export$2e2bcd8739ae039).array((0, $8d7dfc0884542f0c$export$2e2bcd8739ae039).union([
        (0, $8d7dfc0884542f0c$export$2e2bcd8739ae039).string(),
        (0, $8d7dfc0884542f0c$export$2e2bcd8739ae039).string().array()
    ])).refine(function(arr) {
        if (arr.length % 2 !== 0) return false;
        for(var i = 0; i < arr.length; i += 2){
            var key = arr[i];
            var val = arr[i + 1];
            if (typeof key !== "string") return false;
            if (!Array.isArray(val) || !val.every(function(x) {
                return typeof x === "string";
            })) return false;
        }
        return true;
    }),
    // list of number list config tuples
    (0, $8d7dfc0884542f0c$export$2e2bcd8739ae039).array((0, $8d7dfc0884542f0c$export$2e2bcd8739ae039).union([
        (0, $8d7dfc0884542f0c$export$2e2bcd8739ae039).string(),
        (0, $8d7dfc0884542f0c$export$2e2bcd8739ae039).number().array()
    ])).refine(function(arr) {
        if (arr.length % 2 !== 0) return false;
        for(var i = 0; i < arr.length; i += 2){
            var key = arr[i];
            var val = arr[i + 1];
            if (typeof key !== "string") return false;
            if (!Array.isArray(val) || !val.every(function(x) {
                return typeof x === "number";
            })) return false;
        }
        return true;
    })
]);
var $34262aad722a911a$export$960d45de79bd7d81 = (0, $8d7dfc0884542f0c$export$2e2bcd8739ae039).union([
    $34262aad722a911a$export$e94ee64b2671e155,
    $34262aad722a911a$export$e38f7b10db0e126a
]);
var $34262aad722a911a$export$ac2e9c88ba5d7cbb = (0, $8d7dfc0884542f0c$export$2e2bcd8739ae039).map((0, $8d7dfc0884542f0c$export$2e2bcd8739ae039).string(), (0, $8d7dfc0884542f0c$export$2e2bcd8739ae039).object({
    value: (0, $8d7dfc0884542f0c$export$2e2bcd8739ae039).union([
        (0, $8d7dfc0884542f0c$export$2e2bcd8739ae039).boolean(),
        (0, $8d7dfc0884542f0c$export$2e2bcd8739ae039).string(),
        (0, $8d7dfc0884542f0c$export$2e2bcd8739ae039).number(),
        (0, $8d7dfc0884542f0c$export$2e2bcd8739ae039).string().array(),
        (0, $8d7dfc0884542f0c$export$2e2bcd8739ae039).number().array()
    ])
}));
function $34262aad722a911a$var$pairs(arr, fn) {
    for(var i = 0; i < arr.length; i += 2){
        var key = arr[i];
        var val = arr[i + 1];
        if (typeof key !== "string") throw new Error("Expected a string while iterating pairs, got: ".concat(arr[i]));
        fn(key, val);
    }
}
function $34262aad722a911a$export$c29ba52779f58587(minimal) {
    var map = new Map();
    minimal[0].forEach(function(boolean) {
        return map.set(boolean, {
            value: true
        });
    });
    $34262aad722a911a$var$pairs(minimal[1], function(a, b) {
        return map.set(a, {
            value: b
        });
    });
    $34262aad722a911a$var$pairs(minimal[2], function(a, b) {
        return map.set(a, {
            value: b
        });
    });
    $34262aad722a911a$var$pairs(minimal[3], function(a, b) {
        return map.set(a, {
            value: b
        });
    });
    $34262aad722a911a$var$pairs(minimal[4], function(a, b) {
        return map.set(a, {
            value: b
        });
    });
    return map;
}
function $34262aad722a911a$export$be5b69ecb011d7cc(standard) {
    var map = new Map();
    Object.entries(standard).forEach(function(_ref) {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($b3fa812ee964a518$exports)))(_ref, 2), key = _ref2[0], value = _ref2[1];
        return map.set(key, value);
    });
    return map;
}
function $34262aad722a911a$export$460f06addafd9f86(map) {
    var minimal = [
        [],
        [],
        [],
        [],
        []
    ];
    var _iterator = $34262aad722a911a$var$_createForOfIteratorHelper(map.entries()), _step;
    try {
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var _step$value = (0, (/*@__PURE__*/$parcel$interopDefault($b3fa812ee964a518$exports)))(_step.value, 2), key = _step$value[0], value = _step$value[1].value;
            switch((0, (/*@__PURE__*/$parcel$interopDefault($0be79738b2d86ef2$exports)))(value)){
                case "boolean":
                    if (value) minimal[0].push(key);
                    break;
                case "string":
                    minimal[1].push(key, value);
                    break;
                case "number":
                    minimal[2].push(key, value);
                    break;
                default:
                    if (!Array.isArray(value)) throw new Error("Unexpected configuration value: ".concat(value));
                    var allStrings = value.every(function(x) {
                        return typeof x === "string";
                    });
                    if (allStrings) {
                        minimal[3].push(key, value);
                        break;
                    }
                    var allNumbers = value.every(function(x) {
                        return typeof x === "number";
                    });
                    if (allNumbers) {
                        minimal[4].push(key, value);
                        break;
                    }
                    throw new Error("Unexpected configuration value: ".concat(value));
            }
        }
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
    return minimal;
}
function $34262aad722a911a$export$9d0101ad8235e092(map) {
    return Object.fromEntries(map.entries());
}


function $3223ca50272fa44e$var$_createSuper(t) {
    var r = $3223ca50272fa44e$var$_isNativeReflectConstruct();
    return function() {
        var e, o = (0, (/*@__PURE__*/$parcel$interopDefault($73b8372fdfde52ef$exports)))(t);
        if (r) {
            var s = (0, (/*@__PURE__*/$parcel$interopDefault($73b8372fdfde52ef$exports)))(this).constructor;
            e = Reflect.construct(o, arguments, s);
        } else e = o.apply(this, arguments);
        return (0, (/*@__PURE__*/$parcel$interopDefault($0dcaef442910aebf$exports)))(this, e);
    };
}
function $3223ca50272fa44e$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($3223ca50272fa44e$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $3223ca50272fa44e$export$f9c837a54db411d = /*#__PURE__*/ function(_Error) {
    (0, (/*@__PURE__*/$parcel$interopDefault($bd3dcb1d661fde0b$exports)))(ParseError, _Error);
    var _super = $3223ca50272fa44e$var$_createSuper(ParseError);
    function ParseError(message, cause) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($e2fb4f5d98a7c0f0$exports)))(this, ParseError);
        _this = _super.call(this, message);
        _this.cause = cause;
        return _this;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($44507362edb10008$exports)))(ParseError);
}(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($d10ae151327fc24f$exports)))(Error));
function $3223ca50272fa44e$var$safeParse(json) {
    try {
        return {
            data: (0, $34262aad722a911a$export$960d45de79bd7d81).parse(JSON.parse(json)),
            success: true
        };
    } catch (error) {
        if (error instanceof Error) return {
            success: false,
            error: error
        };
        return {
            success: false,
            error: new $3223ca50272fa44e$export$f9c837a54db411d("An unknown error occurred during parsing", error)
        };
    }
}
var $3223ca50272fa44e$export$2be5653e4dada0a3 = /*#__PURE__*/ function() {
    function ConfigCollection(config) {
        (0, (/*@__PURE__*/$parcel$interopDefault($e2fb4f5d98a7c0f0$exports)))(this, ConfigCollection);
        this.config = config;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($44507362edb10008$exports)))(ConfigCollection, [
        {
            key: "toJson",
            value: function toJson(format) {
                switch(format){
                    case "standard":
                        return JSON.stringify((0, $34262aad722a911a$export$9d0101ad8235e092)(this.config));
                    case "minimal":
                        return JSON.stringify((0, $34262aad722a911a$export$460f06addafd9f86)(this.config));
                }
            }
        },
        {
            key: "getBoolean",
            value: function getBoolean(configName) {
                var config = this.config.get(configName);
                if (!config) return {
                    error: (0, $34262aad722a911a$export$c5fb415882705cf4).NotFound
                };
                var value = config.value;
                if (typeof value !== "boolean") return {
                    error: (0, $34262aad722a911a$export$c5fb415882705cf4).IncorrectType,
                    received: value
                };
                return {
                    value: value
                };
            }
        },
        {
            key: "getString",
            value: function getString(configName) {
                var config = this.config.get(configName);
                if (!config) return {
                    error: (0, $34262aad722a911a$export$c5fb415882705cf4).NotFound
                };
                var value = config.value;
                if (typeof value !== "string") return {
                    error: (0, $34262aad722a911a$export$c5fb415882705cf4).IncorrectType,
                    received: value
                };
                return {
                    value: value
                };
            }
        },
        {
            key: "getNumber",
            value: function getNumber(configName) {
                var config = this.config.get(configName);
                if (!config) return {
                    error: (0, $34262aad722a911a$export$c5fb415882705cf4).NotFound
                };
                var value = config.value;
                if (typeof value !== "number") return {
                    error: (0, $34262aad722a911a$export$c5fb415882705cf4).IncorrectType,
                    received: value
                };
                return {
                    value: value
                };
            }
        },
        {
            key: "getStringList",
            value: function getStringList(configName) {
                var config = this.config.get(configName);
                if (!config) return {
                    error: (0, $34262aad722a911a$export$c5fb415882705cf4).NotFound
                };
                var value = config.value;
                if (!Array.isArray(value) || !value.every(function(x) {
                    return typeof x === "string";
                })) return {
                    error: (0, $34262aad722a911a$export$c5fb415882705cf4).IncorrectType,
                    received: value
                };
                return {
                    value: value
                };
            }
        },
        {
            key: "getNumberList",
            value: function getNumberList(configName) {
                var config = this.config.get(configName);
                if (!config) return {
                    error: (0, $34262aad722a911a$export$c5fb415882705cf4).NotFound
                };
                var value = config.value;
                if (!Array.isArray(value) || !value.every(function(x) {
                    return typeof x === "number";
                })) return {
                    error: (0, $34262aad722a911a$export$c5fb415882705cf4).IncorrectType,
                    received: value
                };
                return {
                    value: value
                };
            }
        }
    ], [
        {
            key: "fromValues",
            value: function fromValues(values, options) {
                var result = $3223ca50272fa44e$var$safeParse(values);
                if (!result.success) {
                    var parseError = new $3223ca50272fa44e$export$f9c837a54db411d("Failed to deserialize config", result.error);
                    if (options !== null && options !== void 0 && options.throw) throw parseError;
                    // eslint-disable-next-line no-console
                    console.error(parseError);
                    return ConfigCollection.empty();
                }
                return new ConfigCollection(Array.isArray(result.data) ? (0, $34262aad722a911a$export$c29ba52779f58587)(result.data) : (0, $34262aad722a911a$export$be5b69ecb011d7cc)(result.data));
            }
        },
        {
            key: "empty",
            value: function empty() {
                return new ConfigCollection(new Map());
            }
        }
    ]);
    return ConfigCollection;
}();


var $be049c13332593fb$export$8489e2f039bfcc4c = /*#__PURE__*/ function() {
    function ConfigClient() {
        (0, (/*@__PURE__*/$parcel$interopDefault($18b530a0d79543fa$exports)))(this, ConfigClient);
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($f5eba97906508148$exports)))(ConfigClient, null, [
        {
            key: "fetch",
            value: function() {
                var _fetch = (0, (/*@__PURE__*/$parcel$interopDefault($4a5a3ca53b70a7da$exports)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($0b87255f9982dffe$exports))).mark(function _callee(options) {
                    var _options$fetch;
                    var fetch, response, valuesPayload;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($0b87255f9982dffe$exports))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                fetch = (_options$fetch = options.fetch) !== null && _options$fetch !== void 0 ? _options$fetch : globalThis.fetch;
                                _context.next = 3;
                                return fetch("".concat(options.ffsBaseUrl, "/api/v2/configurations"), {
                                    method: "POST",
                                    body: JSON.stringify(options.context),
                                    headers: {
                                        "content-type": "application/json",
                                        "x-api-key": options.ffsApiKey
                                    }
                                });
                            case 3:
                                response = _context.sent;
                                if (response.ok) {
                                    _context.next = 12;
                                    break;
                                }
                                _context.t0 = Error;
                                _context.t1 = "Unexpected response ".concat(response.status, ": ");
                                _context.next = 9;
                                return response.text();
                            case 9:
                                _context.t2 = _context.sent;
                                _context.t3 = _context.t1.concat.call(_context.t1, _context.t2);
                                throw new _context.t0(_context.t3);
                            case 12:
                                _context.next = 14;
                                return response.text();
                            case 14:
                                valuesPayload = _context.sent;
                                return _context.abrupt("return", (0, $3223ca50272fa44e$export$2be5653e4dada0a3).fromValues(valuesPayload));
                            case 16:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee);
                }));
                function fetch(_x) {
                    return _fetch.apply(this, arguments);
                }
                return fetch;
            }()
        }
    ]);
    return ConfigClient;
}();



var $dAx5m = parcelRequire("dAx5m");

var $1Bj4T = parcelRequire("1Bj4T");

var $77YRX = parcelRequire("77YRX");
const $d53e15acfde58a53$var$FETCH_TIMEOUT_MS = 10000;
const { statsigApiKey: $d53e15acfde58a53$var$statsigApiKey, statsigDynConfigUrl: $d53e15acfde58a53$var$statsigDynConfigUrl } = (0, $1Bj4T.getConfig)();
const $d53e15acfde58a53$var$defaultState = {
    isInitialised: false,
    config: undefined
};
const $d53e15acfde58a53$export$6b86a5aa6ee85bb2 = /*#__PURE__*/ (0, $dAx5m.createContext)($d53e15acfde58a53$var$defaultState);
const $d53e15acfde58a53$export$5463e9bc411d65ca = ({ children: children, userId: userId, onReady: onReady })=>{
    const [isInitialised, setIsInitialised] = (0, $dAx5m.useState)(false);
    const [config, setConfig] = (0, $dAx5m.useState)(undefined);
    (0, $dAx5m.useEffect)(()=>{
        if (!userId) // React v18 require us to return clean-up function
        return ()=>{};
        (0, $be049c13332593fb$export$8489e2f039bfcc4c).fetch({
            ffsApiKey: $d53e15acfde58a53$var$statsigApiKey,
            ffsBaseUrl: $d53e15acfde58a53$var$statsigDynConfigUrl,
            context: {
                namespace: "manage-profile-ui_web",
                identifiers: {
                    atlassianAccountId: userId
                },
                metadata: {}
            },
            fetch: (input, init)=>fetch(input, {
                    ...init,
                    signal: AbortSignal?.timeout?.($d53e15acfde58a53$var$FETCH_TIMEOUT_MS)
                })
        }).then((configCollection)=>{
            setConfig(configCollection);
            setIsInitialised(true);
            if (onReady) onReady();
        }).catch((error)=>{
            (0, $77YRX.logErrorMessage)("Statsig dynamicConfig failed to be initialised", {
                error: error
            });
            setIsInitialised(false);
            setConfig((0, $3223ca50272fa44e$export$2be5653e4dada0a3).empty());
            if (onReady) onReady(error);
        });
    }, [
        userId,
        onReady
    ]);
    return /*#__PURE__*/ (0, $bibO8.jsx)($d53e15acfde58a53$export$6b86a5aa6ee85bb2.Provider, {
        value: {
            isInitialised: isInitialised,
            config: config
        },
        children: children
    });
};
const $d53e15acfde58a53$export$9512b38e36dd2811 = ()=>{
    const context = (0, $dAx5m.useContext)($d53e15acfde58a53$export$6b86a5aa6ee85bb2);
    if (!context) throw new Error("useDynamicConfigClient used outside of DynamicConfigProvider.");
    return context;
};



var $djcZD = parcelRequire("djcZD");

var $1Bj4T = parcelRequire("1Bj4T");

var $fCHnn = parcelRequire("fCHnn");
const { statsigApiKey: $a2ca159e2f6e1426$var$statsigApiKey } = (0, $1Bj4T.getConfig)();
const $a2ca159e2f6e1426$var$environment = (0, $djcZD.getEnv)() !== "prod" ? (0, $kvFVg.FeatureGateEnvironment).Staging : (0, $kvFVg.FeatureGateEnvironment).Production;
const $a2ca159e2f6e1426$var$featureGatesOptions = {
    targetApp: "manage-profile-ui_web",
    apiKey: $a2ca159e2f6e1426$var$statsigApiKey,
    environment: $a2ca159e2f6e1426$var$environment
};
const $a2ca159e2f6e1426$var$StatSigInit = ({ children: children })=>{
    const [userId, setUserId] = (0, $dAx5m.useState)(null);
    const [isDynConfigReady, setIsDynConfigReady] = (0, $dAx5m.useState)(false);
    const [isStatsigClientReady, setIsStatsigClientReady] = (0, $dAx5m.useState)(false);
    const onFeatureGatesReady = (0, $dAx5m.useCallback)(()=>setIsStatsigClientReady(true), []);
    const onDynamicConfigReady = (0, $dAx5m.useCallback)(()=>setIsDynConfigReady(true), []);
    // This allows us to render children only after both statsig feature gate and dynamic config client are ready
    // Note for both onReady, they will be fired if there's an issue with statsig as fallback as we don't want to render blank UI
    const allStatsigSystemReady = isDynConfigReady && isStatsigClientReady;
    (0, $dAx5m.useEffect)(()=>{
        (0, $fCHnn.userInfoProvider).get().then(({ userId: accountId })=>{
            setUserId(accountId);
        }).catch(()=>{
            // If we cannot load the user, then continue render the app without Statsig able to target the user.
            setUserId(undefined);
        });
    }, []);
    // We're still loading the user, so we can't render the app yet.
    if (userId === null) return null;
    return /*#__PURE__*/ (0, $bibO8.jsxs)((0, $bibO8.Fragment), {
        children: [
            /*#__PURE__*/ (0, $bibO8.jsx)((0, $920e9c57cee17876$exports.FeatureGatesInitialization), {
                enabled: true,
                options: $a2ca159e2f6e1426$var$featureGatesOptions,
                identifiers: {
                    atlassianAccountId: userId
                },
                onReady: onFeatureGatesReady
            }),
            /*#__PURE__*/ (0, $bibO8.jsx)((0, $d53e15acfde58a53$export$5463e9bc411d65ca), {
                userId: userId,
                onReady: onDynamicConfigReady,
                children: allStatsigSystemReady && children
            })
        ]
    });
};
var $a2ca159e2f6e1426$export$2e2bcd8739ae039 = $a2ca159e2f6e1426$var$StatSigInit;





var $bibO8 = parcelRequire("bibO8");
parcelRequire("dAx5m");

var $iqz0v = parcelRequire("iqz0v");

var $iqz0v = parcelRequire("iqz0v");

var $iqz0v = parcelRequire("iqz0v");

var $bgWTi = parcelRequire("bgWTi");

var $QaI8V = parcelRequire("QaI8V");

var $gbAXU = parcelRequire("gbAXU");

var $ejGTl = parcelRequire("ejGTl");
// CLASS
class $636b3a640a19b984$export$62297b13309008b2 extends (0, $ejGTl.Removable) {
    constructor(config){
        super();
        this.abortSignalConsumed = false;
        this.defaultOptions = config.defaultOptions;
        this.setOptions(config.options);
        this.observers = [];
        this.cache = config.cache;
        this.logger = config.logger || (0, $bgWTi.defaultLogger);
        this.queryKey = config.queryKey;
        this.queryHash = config.queryHash;
        this.initialState = config.state || $636b3a640a19b984$var$getDefaultState(this.options);
        this.state = this.initialState;
        this.scheduleGc();
    }
    get meta() {
        return this.options.meta;
    }
    setOptions(options) {
        this.options = {
            ...this.defaultOptions,
            ...options
        };
        this.updateCacheTime(this.options.cacheTime);
    }
    optionalRemove() {
        if (!this.observers.length && this.state.fetchStatus === "idle") this.cache.remove(this);
    }
    setData(newData, options) {
        const data = (0, $iqz0v.replaceData)(this.state.data, newData, this.options); // Set data and mark it as cached
        this.dispatch({
            data: data,
            type: "success",
            dataUpdatedAt: options == null ? void 0 : options.updatedAt,
            manual: options == null ? void 0 : options.manual
        });
        return data;
    }
    setState(state, setStateOptions) {
        this.dispatch({
            type: "setState",
            state: state,
            setStateOptions: setStateOptions
        });
    }
    cancel(options) {
        var _this$retryer;
        const promise = this.promise;
        (_this$retryer = this.retryer) == null || _this$retryer.cancel(options);
        return promise ? promise.then((0, $iqz0v.noop)).catch((0, $iqz0v.noop)) : Promise.resolve();
    }
    destroy() {
        super.destroy();
        this.cancel({
            silent: true
        });
    }
    reset() {
        this.destroy();
        this.setState(this.initialState);
    }
    isActive() {
        return this.observers.some((observer)=>observer.options.enabled !== false);
    }
    isDisabled() {
        return this.getObserversCount() > 0 && !this.isActive();
    }
    isStale() {
        return this.state.isInvalidated || !this.state.dataUpdatedAt || this.observers.some((observer)=>observer.getCurrentResult().isStale);
    }
    isStaleByTime(staleTime = 0) {
        return this.state.isInvalidated || !this.state.dataUpdatedAt || !(0, $iqz0v.timeUntilStale)(this.state.dataUpdatedAt, staleTime);
    }
    onFocus() {
        var _this$retryer2;
        const observer = this.observers.find((x)=>x.shouldFetchOnWindowFocus());
        if (observer) observer.refetch({
            cancelRefetch: false
        });
         // Continue fetch if currently paused
        (_this$retryer2 = this.retryer) == null || _this$retryer2.continue();
    }
    onOnline() {
        var _this$retryer3;
        const observer = this.observers.find((x)=>x.shouldFetchOnReconnect());
        if (observer) observer.refetch({
            cancelRefetch: false
        });
         // Continue fetch if currently paused
        (_this$retryer3 = this.retryer) == null || _this$retryer3.continue();
    }
    addObserver(observer) {
        if (!this.observers.includes(observer)) {
            this.observers.push(observer); // Stop the query from being garbage collected
            this.clearGcTimeout();
            this.cache.notify({
                type: "observerAdded",
                query: this,
                observer: observer
            });
        }
    }
    removeObserver(observer) {
        if (this.observers.includes(observer)) {
            this.observers = this.observers.filter((x)=>x !== observer);
            if (!this.observers.length) {
                // If the transport layer does not support cancellation
                // we'll let the query continue so the result can be cached
                if (this.retryer) {
                    if (this.abortSignalConsumed) this.retryer.cancel({
                        revert: true
                    });
                    else this.retryer.cancelRetry();
                }
                this.scheduleGc();
            }
            this.cache.notify({
                type: "observerRemoved",
                query: this,
                observer: observer
            });
        }
    }
    getObserversCount() {
        return this.observers.length;
    }
    invalidate() {
        if (!this.state.isInvalidated) this.dispatch({
            type: "invalidate"
        });
    }
    fetch(options, fetchOptions) {
        var _this$options$behavio, _context$fetchOptions;
        if (this.state.fetchStatus !== "idle") {
            if (this.state.dataUpdatedAt && fetchOptions != null && fetchOptions.cancelRefetch) // Silently cancel current fetch if the user wants to cancel refetches
            this.cancel({
                silent: true
            });
            else if (this.promise) {
                var _this$retryer4;
                // make sure that retries that were potentially cancelled due to unmounts can continue
                (_this$retryer4 = this.retryer) == null || _this$retryer4.continueRetry(); // Return current promise if we are already fetching
                return this.promise;
            }
        } // Update config if passed, otherwise the config from the last execution is used
        if (options) this.setOptions(options);
         // Use the options from the first observer with a query function if no function is found.
        // This can happen when the query is hydrated or created with setQueryData.
        if (!this.options.queryFn) {
            const observer = this.observers.find((x)=>x.options.queryFn);
            if (observer) this.setOptions(observer.options);
        }
        const abortController = (0, $iqz0v.getAbortController)(); // Create query function context
        const queryFnContext = {
            queryKey: this.queryKey,
            pageParam: undefined,
            meta: this.meta
        }; // Adds an enumerable signal property to the object that
        // which sets abortSignalConsumed to true when the signal
        // is read.
        const addSignalProperty = (object)=>{
            Object.defineProperty(object, "signal", {
                enumerable: true,
                get: ()=>{
                    if (abortController) {
                        this.abortSignalConsumed = true;
                        return abortController.signal;
                    }
                    return undefined;
                }
            });
        };
        addSignalProperty(queryFnContext); // Create fetch function
        const fetchFn = ()=>{
            if (!this.options.queryFn) return Promise.reject("Missing queryFn for queryKey '" + this.options.queryHash + "'");
            this.abortSignalConsumed = false;
            return this.options.queryFn(queryFnContext);
        }; // Trigger behavior hook
        const context = {
            fetchOptions: fetchOptions,
            options: this.options,
            queryKey: this.queryKey,
            state: this.state,
            fetchFn: fetchFn
        };
        addSignalProperty(context);
        (_this$options$behavio = this.options.behavior) == null || _this$options$behavio.onFetch(context); // Store state in case the current fetch needs to be reverted
        this.revertState = this.state; // Set to fetching state if not already in it
        if (this.state.fetchStatus === "idle" || this.state.fetchMeta !== ((_context$fetchOptions = context.fetchOptions) == null ? void 0 : _context$fetchOptions.meta)) {
            var _context$fetchOptions2;
            this.dispatch({
                type: "fetch",
                meta: (_context$fetchOptions2 = context.fetchOptions) == null ? void 0 : _context$fetchOptions2.meta
            });
        }
        const onError = (error)=>{
            // Optimistically update state if needed
            if (!((0, $gbAXU.isCancelledError)(error) && error.silent)) this.dispatch({
                type: "error",
                error: error
            });
            if (!(0, $gbAXU.isCancelledError)(error)) {
                var _this$cache$config$on, _this$cache$config, _this$cache$config$on2, _this$cache$config2;
                // Notify cache callback
                (_this$cache$config$on = (_this$cache$config = this.cache.config).onError) == null || _this$cache$config$on.call(_this$cache$config, error, this);
                (_this$cache$config$on2 = (_this$cache$config2 = this.cache.config).onSettled) == null || _this$cache$config$on2.call(_this$cache$config2, this.state.data, error, this);
            }
            if (!this.isFetchingOptimistic) // Schedule query gc after fetching
            this.scheduleGc();
            this.isFetchingOptimistic = false;
        }; // Try to fetch the data
        this.retryer = (0, $gbAXU.createRetryer)({
            fn: context.fetchFn,
            abort: abortController == null ? void 0 : abortController.abort.bind(abortController),
            onSuccess: (data)=>{
                var _this$cache$config$on3, _this$cache$config3, _this$cache$config$on4, _this$cache$config4;
                if (typeof data === "undefined") {
                    onError(new Error(this.queryHash + " data is undefined"));
                    return;
                }
                this.setData(data); // Notify cache callback
                (_this$cache$config$on3 = (_this$cache$config3 = this.cache.config).onSuccess) == null || _this$cache$config$on3.call(_this$cache$config3, data, this);
                (_this$cache$config$on4 = (_this$cache$config4 = this.cache.config).onSettled) == null || _this$cache$config$on4.call(_this$cache$config4, data, this.state.error, this);
                if (!this.isFetchingOptimistic) // Schedule query gc after fetching
                this.scheduleGc();
                this.isFetchingOptimistic = false;
            },
            onError: onError,
            onFail: (failureCount, error)=>{
                this.dispatch({
                    type: "failed",
                    failureCount: failureCount,
                    error: error
                });
            },
            onPause: ()=>{
                this.dispatch({
                    type: "pause"
                });
            },
            onContinue: ()=>{
                this.dispatch({
                    type: "continue"
                });
            },
            retry: context.options.retry,
            retryDelay: context.options.retryDelay,
            networkMode: context.options.networkMode
        });
        this.promise = this.retryer.promise;
        return this.promise;
    }
    dispatch(action) {
        const reducer = (state)=>{
            var _action$meta, _action$dataUpdatedAt;
            switch(action.type){
                case "failed":
                    return {
                        ...state,
                        fetchFailureCount: action.failureCount,
                        fetchFailureReason: action.error
                    };
                case "pause":
                    return {
                        ...state,
                        fetchStatus: "paused"
                    };
                case "continue":
                    return {
                        ...state,
                        fetchStatus: "fetching"
                    };
                case "fetch":
                    return {
                        ...state,
                        fetchFailureCount: 0,
                        fetchFailureReason: null,
                        fetchMeta: (_action$meta = action.meta) != null ? _action$meta : null,
                        fetchStatus: (0, $gbAXU.canFetch)(this.options.networkMode) ? "fetching" : "paused",
                        ...!state.dataUpdatedAt && {
                            error: null,
                            status: "loading"
                        }
                    };
                case "success":
                    return {
                        ...state,
                        data: action.data,
                        dataUpdateCount: state.dataUpdateCount + 1,
                        dataUpdatedAt: (_action$dataUpdatedAt = action.dataUpdatedAt) != null ? _action$dataUpdatedAt : Date.now(),
                        error: null,
                        isInvalidated: false,
                        status: "success",
                        ...!action.manual && {
                            fetchStatus: "idle",
                            fetchFailureCount: 0,
                            fetchFailureReason: null
                        }
                    };
                case "error":
                    const error = action.error;
                    if ((0, $gbAXU.isCancelledError)(error) && error.revert && this.revertState) return {
                        ...this.revertState,
                        fetchStatus: "idle"
                    };
                    return {
                        ...state,
                        error: error,
                        errorUpdateCount: state.errorUpdateCount + 1,
                        errorUpdatedAt: Date.now(),
                        fetchFailureCount: state.fetchFailureCount + 1,
                        fetchFailureReason: error,
                        fetchStatus: "idle",
                        status: "error"
                    };
                case "invalidate":
                    return {
                        ...state,
                        isInvalidated: true
                    };
                case "setState":
                    return {
                        ...state,
                        ...action.state
                    };
            }
        };
        this.state = reducer(this.state);
        (0, $QaI8V.notifyManager).batch(()=>{
            this.observers.forEach((observer)=>{
                observer.onQueryUpdate(action);
            });
            this.cache.notify({
                query: this,
                type: "updated",
                action: action
            });
        });
    }
}
function $636b3a640a19b984$var$getDefaultState(options) {
    const data = typeof options.initialData === "function" ? options.initialData() : options.initialData;
    const hasData = typeof data !== "undefined";
    const initialDataUpdatedAt = hasData ? typeof options.initialDataUpdatedAt === "function" ? options.initialDataUpdatedAt() : options.initialDataUpdatedAt : 0;
    return {
        data: data,
        dataUpdateCount: 0,
        dataUpdatedAt: hasData ? initialDataUpdatedAt != null ? initialDataUpdatedAt : Date.now() : 0,
        error: null,
        errorUpdateCount: 0,
        errorUpdatedAt: 0,
        fetchFailureCount: 0,
        fetchFailureReason: null,
        fetchMeta: null,
        isInvalidated: false,
        status: hasData ? "success" : "loading",
        fetchStatus: "idle"
    };
}



var $QaI8V = parcelRequire("QaI8V");

var $1RjI5 = parcelRequire("1RjI5");
// CLASS
class $8fed3291c6fa8766$export$5dde0cd941da8468 extends (0, $1RjI5.Subscribable) {
    constructor(config){
        super();
        this.config = config || {};
        this.queries = [];
        this.queriesMap = {};
    }
    build(client, options, state) {
        var _options$queryHash;
        const queryKey = options.queryKey;
        const queryHash = (_options$queryHash = options.queryHash) != null ? _options$queryHash : (0, $iqz0v.hashQueryKeyByOptions)(queryKey, options);
        let query = this.get(queryHash);
        if (!query) {
            query = new (0, $636b3a640a19b984$export$62297b13309008b2)({
                cache: this,
                logger: client.getLogger(),
                queryKey: queryKey,
                queryHash: queryHash,
                options: client.defaultQueryOptions(options),
                state: state,
                defaultOptions: client.getQueryDefaults(queryKey)
            });
            this.add(query);
        }
        return query;
    }
    add(query) {
        if (!this.queriesMap[query.queryHash]) {
            this.queriesMap[query.queryHash] = query;
            this.queries.push(query);
            this.notify({
                type: "added",
                query: query
            });
        }
    }
    remove(query) {
        const queryInMap = this.queriesMap[query.queryHash];
        if (queryInMap) {
            query.destroy();
            this.queries = this.queries.filter((x)=>x !== query);
            if (queryInMap === query) delete this.queriesMap[query.queryHash];
            this.notify({
                type: "removed",
                query: query
            });
        }
    }
    clear() {
        (0, $QaI8V.notifyManager).batch(()=>{
            this.queries.forEach((query)=>{
                this.remove(query);
            });
        });
    }
    get(queryHash) {
        return this.queriesMap[queryHash];
    }
    getAll() {
        return this.queries;
    }
    find(arg1, arg2) {
        const [filters] = (0, $iqz0v.parseFilterArgs)(arg1, arg2);
        if (typeof filters.exact === "undefined") filters.exact = true;
        return this.queries.find((query)=>(0, $iqz0v.matchQuery)(filters, query));
    }
    findAll(arg1, arg2) {
        const [filters] = (0, $iqz0v.parseFilterArgs)(arg1, arg2);
        return Object.keys(filters).length > 0 ? this.queries.filter((query)=>(0, $iqz0v.matchQuery)(filters, query)) : this.queries;
    }
    notify(event) {
        (0, $QaI8V.notifyManager).batch(()=>{
            this.listeners.forEach(({ listener: listener })=>{
                listener(event);
            });
        });
    }
    onFocus() {
        (0, $QaI8V.notifyManager).batch(()=>{
            this.queries.forEach((query)=>{
                query.onFocus();
            });
        });
    }
    onOnline() {
        (0, $QaI8V.notifyManager).batch(()=>{
            this.queries.forEach((query)=>{
                query.onOnline();
            });
        });
    }
}



var $QaI8V = parcelRequire("QaI8V");

var $a3KTB = parcelRequire("a3KTB");

var $iqz0v = parcelRequire("iqz0v");

var $1RjI5 = parcelRequire("1RjI5");
// CLASS
class $c065eab83fc38c24$export$1fcfd9a244434844 extends (0, $1RjI5.Subscribable) {
    constructor(config){
        super();
        this.config = config || {};
        this.mutations = [];
        this.mutationId = 0;
    }
    build(client, options, state) {
        const mutation = new (0, $a3KTB.Mutation)({
            mutationCache: this,
            logger: client.getLogger(),
            mutationId: ++this.mutationId,
            options: client.defaultMutationOptions(options),
            state: state,
            defaultOptions: options.mutationKey ? client.getMutationDefaults(options.mutationKey) : undefined
        });
        this.add(mutation);
        return mutation;
    }
    add(mutation) {
        this.mutations.push(mutation);
        this.notify({
            type: "added",
            mutation: mutation
        });
    }
    remove(mutation) {
        this.mutations = this.mutations.filter((x)=>x !== mutation);
        this.notify({
            type: "removed",
            mutation: mutation
        });
    }
    clear() {
        (0, $QaI8V.notifyManager).batch(()=>{
            this.mutations.forEach((mutation)=>{
                this.remove(mutation);
            });
        });
    }
    getAll() {
        return this.mutations;
    }
    find(filters) {
        if (typeof filters.exact === "undefined") filters.exact = true;
        return this.mutations.find((mutation)=>(0, $iqz0v.matchMutation)(filters, mutation));
    }
    findAll(filters) {
        return this.mutations.filter((mutation)=>(0, $iqz0v.matchMutation)(filters, mutation));
    }
    notify(event) {
        (0, $QaI8V.notifyManager).batch(()=>{
            this.listeners.forEach(({ listener: listener })=>{
                listener(event);
            });
        });
    }
    resumePausedMutations() {
        var _this$resuming;
        this.resuming = ((_this$resuming = this.resuming) != null ? _this$resuming : Promise.resolve()).then(()=>{
            const pausedMutations = this.mutations.filter((x)=>x.state.isPaused);
            return (0, $QaI8V.notifyManager).batch(()=>pausedMutations.reduce((promise, mutation)=>promise.then(()=>mutation.continue().catch((0, $iqz0v.noop))), Promise.resolve()));
        }).then(()=>{
            this.resuming = undefined;
        });
        return this.resuming;
    }
}



var $bzUDw = parcelRequire("bzUDw");

var $2YnrV = parcelRequire("2YnrV");

var $QaI8V = parcelRequire("QaI8V");
function $70915238bab68d30$export$84470d1367601e8d() {
    return {
        onFetch: (context)=>{
            context.fetchFn = ()=>{
                var _context$fetchOptions, _context$fetchOptions2, _context$fetchOptions3, _context$fetchOptions4, _context$state$data, _context$state$data2;
                const refetchPage = (_context$fetchOptions = context.fetchOptions) == null ? void 0 : (_context$fetchOptions2 = _context$fetchOptions.meta) == null ? void 0 : _context$fetchOptions2.refetchPage;
                const fetchMore = (_context$fetchOptions3 = context.fetchOptions) == null ? void 0 : (_context$fetchOptions4 = _context$fetchOptions3.meta) == null ? void 0 : _context$fetchOptions4.fetchMore;
                const pageParam = fetchMore == null ? void 0 : fetchMore.pageParam;
                const isFetchingNextPage = (fetchMore == null ? void 0 : fetchMore.direction) === "forward";
                const isFetchingPreviousPage = (fetchMore == null ? void 0 : fetchMore.direction) === "backward";
                const oldPages = ((_context$state$data = context.state.data) == null ? void 0 : _context$state$data.pages) || [];
                const oldPageParams = ((_context$state$data2 = context.state.data) == null ? void 0 : _context$state$data2.pageParams) || [];
                let newPageParams = oldPageParams;
                let cancelled = false;
                const addSignalProperty = (object)=>{
                    Object.defineProperty(object, "signal", {
                        enumerable: true,
                        get: ()=>{
                            var _context$signal;
                            if ((_context$signal = context.signal) != null && _context$signal.aborted) cancelled = true;
                            else {
                                var _context$signal2;
                                (_context$signal2 = context.signal) == null || _context$signal2.addEventListener("abort", ()=>{
                                    cancelled = true;
                                });
                            }
                            return context.signal;
                        }
                    });
                }; // Get query function
                const queryFn = context.options.queryFn || (()=>Promise.reject("Missing queryFn for queryKey '" + context.options.queryHash + "'"));
                const buildNewPages = (pages, param, page, previous)=>{
                    newPageParams = previous ? [
                        param,
                        ...newPageParams
                    ] : [
                        ...newPageParams,
                        param
                    ];
                    return previous ? [
                        page,
                        ...pages
                    ] : [
                        ...pages,
                        page
                    ];
                }; // Create function to fetch a page
                const fetchPage = (pages, manual, param, previous)=>{
                    if (cancelled) return Promise.reject("Cancelled");
                    if (typeof param === "undefined" && !manual && pages.length) return Promise.resolve(pages);
                    const queryFnContext = {
                        queryKey: context.queryKey,
                        pageParam: param,
                        meta: context.options.meta
                    };
                    addSignalProperty(queryFnContext);
                    const queryFnResult = queryFn(queryFnContext);
                    const promise = Promise.resolve(queryFnResult).then((page)=>buildNewPages(pages, param, page, previous));
                    return promise;
                };
                let promise; // Fetch first page?
                if (!oldPages.length) promise = fetchPage([]);
                else if (isFetchingNextPage) {
                    const manual = typeof pageParam !== "undefined";
                    const param = manual ? pageParam : $70915238bab68d30$export$1186159d57de7255(context.options, oldPages);
                    promise = fetchPage(oldPages, manual, param);
                } else if (isFetchingPreviousPage) {
                    const manual = typeof pageParam !== "undefined";
                    const param = manual ? pageParam : $70915238bab68d30$export$48efda17d8ac7ac7(context.options, oldPages);
                    promise = fetchPage(oldPages, manual, param, true);
                } else {
                    newPageParams = [];
                    const manual = typeof context.options.getNextPageParam === "undefined";
                    const shouldFetchFirstPage = refetchPage && oldPages[0] ? refetchPage(oldPages[0], 0, oldPages) : true; // Fetch first page
                    promise = shouldFetchFirstPage ? fetchPage([], manual, oldPageParams[0]) : Promise.resolve(buildNewPages([], oldPageParams[0], oldPages[0])); // Fetch remaining pages
                    for(let i = 1; i < oldPages.length; i++)promise = promise.then((pages)=>{
                        const shouldFetchNextPage = refetchPage && oldPages[i] ? refetchPage(oldPages[i], i, oldPages) : true;
                        if (shouldFetchNextPage) {
                            const param = manual ? oldPageParams[i] : $70915238bab68d30$export$1186159d57de7255(context.options, pages);
                            return fetchPage(pages, manual, param);
                        }
                        return Promise.resolve(buildNewPages(pages, oldPageParams[i], oldPages[i]));
                    });
                }
                const finalPromise = promise.then((pages)=>({
                        pages: pages,
                        pageParams: newPageParams
                    }));
                return finalPromise;
            };
        }
    };
}
function $70915238bab68d30$export$1186159d57de7255(options, pages) {
    return options.getNextPageParam == null ? void 0 : options.getNextPageParam(pages[pages.length - 1], pages);
}
function $70915238bab68d30$export$48efda17d8ac7ac7(options, pages) {
    return options.getPreviousPageParam == null ? void 0 : options.getPreviousPageParam(pages[0], pages);
}
/**
 * Checks if there is a next page.
 * Returns `undefined` if it cannot be determined.
 */ function $70915238bab68d30$export$b9c88add8b8b5e6a(options, pages) {
    if (options.getNextPageParam && Array.isArray(pages)) {
        const nextPageParam = $70915238bab68d30$export$1186159d57de7255(options, pages);
        return typeof nextPageParam !== "undefined" && nextPageParam !== null && nextPageParam !== false;
    }
    return;
}
/**
 * Checks if there is a previous page.
 * Returns `undefined` if it cannot be determined.
 */ function $70915238bab68d30$export$db1663b730a8e6e4(options, pages) {
    if (options.getPreviousPageParam && Array.isArray(pages)) {
        const previousPageParam = $70915238bab68d30$export$48efda17d8ac7ac7(options, pages);
        return typeof previousPageParam !== "undefined" && previousPageParam !== null && previousPageParam !== false;
    }
    return;
}



var $bgWTi = parcelRequire("bgWTi");
// CLASS
class $e7a199e7d5aa71a2$export$405d0624ed55a03f {
    constructor(config = {}){
        this.queryCache = config.queryCache || new (0, $8fed3291c6fa8766$export$5dde0cd941da8468)();
        this.mutationCache = config.mutationCache || new (0, $c065eab83fc38c24$export$1fcfd9a244434844)();
        this.logger = config.logger || (0, $bgWTi.defaultLogger);
        this.defaultOptions = config.defaultOptions || {};
        this.queryDefaults = [];
        this.mutationDefaults = [];
        this.mountCount = 0;
    }
    mount() {
        this.mountCount++;
        if (this.mountCount !== 1) return;
        this.unsubscribeFocus = (0, $bzUDw.focusManager).subscribe(()=>{
            if ((0, $bzUDw.focusManager).isFocused()) {
                this.resumePausedMutations();
                this.queryCache.onFocus();
            }
        });
        this.unsubscribeOnline = (0, $2YnrV.onlineManager).subscribe(()=>{
            if ((0, $2YnrV.onlineManager).isOnline()) {
                this.resumePausedMutations();
                this.queryCache.onOnline();
            }
        });
    }
    unmount() {
        var _this$unsubscribeFocu, _this$unsubscribeOnli;
        this.mountCount--;
        if (this.mountCount !== 0) return;
        (_this$unsubscribeFocu = this.unsubscribeFocus) == null || _this$unsubscribeFocu.call(this);
        this.unsubscribeFocus = undefined;
        (_this$unsubscribeOnli = this.unsubscribeOnline) == null || _this$unsubscribeOnli.call(this);
        this.unsubscribeOnline = undefined;
    }
    isFetching(arg1, arg2) {
        const [filters] = (0, $iqz0v.parseFilterArgs)(arg1, arg2);
        filters.fetchStatus = "fetching";
        return this.queryCache.findAll(filters).length;
    }
    isMutating(filters) {
        return this.mutationCache.findAll({
            ...filters,
            fetching: true
        }).length;
    }
    getQueryData(queryKey, filters) {
        var _this$queryCache$find;
        return (_this$queryCache$find = this.queryCache.find(queryKey, filters)) == null ? void 0 : _this$queryCache$find.state.data;
    }
    ensureQueryData(arg1, arg2, arg3) {
        const parsedOptions = (0, $iqz0v.parseQueryArgs)(arg1, arg2, arg3);
        const cachedData = this.getQueryData(parsedOptions.queryKey);
        return cachedData ? Promise.resolve(cachedData) : this.fetchQuery(parsedOptions);
    }
    getQueriesData(queryKeyOrFilters) {
        return this.getQueryCache().findAll(queryKeyOrFilters).map(({ queryKey: queryKey, state: state })=>{
            const data = state.data;
            return [
                queryKey,
                data
            ];
        });
    }
    setQueryData(queryKey, updater, options) {
        const query = this.queryCache.find(queryKey);
        const prevData = query == null ? void 0 : query.state.data;
        const data = (0, $iqz0v.functionalUpdate)(updater, prevData);
        if (typeof data === "undefined") return undefined;
        const parsedOptions = (0, $iqz0v.parseQueryArgs)(queryKey);
        const defaultedOptions = this.defaultQueryOptions(parsedOptions);
        return this.queryCache.build(this, defaultedOptions).setData(data, {
            ...options,
            manual: true
        });
    }
    setQueriesData(queryKeyOrFilters, updater, options) {
        return (0, $QaI8V.notifyManager).batch(()=>this.getQueryCache().findAll(queryKeyOrFilters).map(({ queryKey: queryKey })=>[
                    queryKey,
                    this.setQueryData(queryKey, updater, options)
                ]));
    }
    getQueryState(queryKey, filters) {
        var _this$queryCache$find2;
        return (_this$queryCache$find2 = this.queryCache.find(queryKey, filters)) == null ? void 0 : _this$queryCache$find2.state;
    }
    removeQueries(arg1, arg2) {
        const [filters] = (0, $iqz0v.parseFilterArgs)(arg1, arg2);
        const queryCache = this.queryCache;
        (0, $QaI8V.notifyManager).batch(()=>{
            queryCache.findAll(filters).forEach((query)=>{
                queryCache.remove(query);
            });
        });
    }
    resetQueries(arg1, arg2, arg3) {
        const [filters, options] = (0, $iqz0v.parseFilterArgs)(arg1, arg2, arg3);
        const queryCache = this.queryCache;
        const refetchFilters = {
            type: "active",
            ...filters
        };
        return (0, $QaI8V.notifyManager).batch(()=>{
            queryCache.findAll(filters).forEach((query)=>{
                query.reset();
            });
            return this.refetchQueries(refetchFilters, options);
        });
    }
    cancelQueries(arg1, arg2, arg3) {
        const [filters, cancelOptions = {}] = (0, $iqz0v.parseFilterArgs)(arg1, arg2, arg3);
        if (typeof cancelOptions.revert === "undefined") cancelOptions.revert = true;
        const promises = (0, $QaI8V.notifyManager).batch(()=>this.queryCache.findAll(filters).map((query)=>query.cancel(cancelOptions)));
        return Promise.all(promises).then((0, $iqz0v.noop)).catch((0, $iqz0v.noop));
    }
    invalidateQueries(arg1, arg2, arg3) {
        const [filters, options] = (0, $iqz0v.parseFilterArgs)(arg1, arg2, arg3);
        return (0, $QaI8V.notifyManager).batch(()=>{
            var _ref, _filters$refetchType;
            this.queryCache.findAll(filters).forEach((query)=>{
                query.invalidate();
            });
            if (filters.refetchType === "none") return Promise.resolve();
            const refetchFilters = {
                ...filters,
                type: (_ref = (_filters$refetchType = filters.refetchType) != null ? _filters$refetchType : filters.type) != null ? _ref : "active"
            };
            return this.refetchQueries(refetchFilters, options);
        });
    }
    refetchQueries(arg1, arg2, arg3) {
        const [filters, options] = (0, $iqz0v.parseFilterArgs)(arg1, arg2, arg3);
        const promises = (0, $QaI8V.notifyManager).batch(()=>this.queryCache.findAll(filters).filter((query)=>!query.isDisabled()).map((query)=>{
                var _options$cancelRefetc;
                return query.fetch(undefined, {
                    ...options,
                    cancelRefetch: (_options$cancelRefetc = options == null ? void 0 : options.cancelRefetch) != null ? _options$cancelRefetc : true,
                    meta: {
                        refetchPage: filters.refetchPage
                    }
                });
            }));
        let promise = Promise.all(promises).then((0, $iqz0v.noop));
        if (!(options != null && options.throwOnError)) promise = promise.catch((0, $iqz0v.noop));
        return promise;
    }
    fetchQuery(arg1, arg2, arg3) {
        const parsedOptions = (0, $iqz0v.parseQueryArgs)(arg1, arg2, arg3);
        const defaultedOptions = this.defaultQueryOptions(parsedOptions); // https://github.com/tannerlinsley/react-query/issues/652
        if (typeof defaultedOptions.retry === "undefined") defaultedOptions.retry = false;
        const query = this.queryCache.build(this, defaultedOptions);
        return query.isStaleByTime(defaultedOptions.staleTime) ? query.fetch(defaultedOptions) : Promise.resolve(query.state.data);
    }
    prefetchQuery(arg1, arg2, arg3) {
        return this.fetchQuery(arg1, arg2, arg3).then((0, $iqz0v.noop)).catch((0, $iqz0v.noop));
    }
    fetchInfiniteQuery(arg1, arg2, arg3) {
        const parsedOptions = (0, $iqz0v.parseQueryArgs)(arg1, arg2, arg3);
        parsedOptions.behavior = (0, $70915238bab68d30$export$84470d1367601e8d)();
        return this.fetchQuery(parsedOptions);
    }
    prefetchInfiniteQuery(arg1, arg2, arg3) {
        return this.fetchInfiniteQuery(arg1, arg2, arg3).then((0, $iqz0v.noop)).catch((0, $iqz0v.noop));
    }
    resumePausedMutations() {
        return this.mutationCache.resumePausedMutations();
    }
    getQueryCache() {
        return this.queryCache;
    }
    getMutationCache() {
        return this.mutationCache;
    }
    getLogger() {
        return this.logger;
    }
    getDefaultOptions() {
        return this.defaultOptions;
    }
    setDefaultOptions(options) {
        this.defaultOptions = options;
    }
    setQueryDefaults(queryKey, options) {
        const result = this.queryDefaults.find((x)=>(0, $iqz0v.hashQueryKey)(queryKey) === (0, $iqz0v.hashQueryKey)(x.queryKey));
        if (result) result.defaultOptions = options;
        else this.queryDefaults.push({
            queryKey: queryKey,
            defaultOptions: options
        });
    }
    getQueryDefaults(queryKey) {
        if (!queryKey) return undefined;
         // Get the first matching defaults
        const firstMatchingDefaults = this.queryDefaults.find((x)=>(0, $iqz0v.partialMatchKey)(queryKey, x.queryKey)); // Additional checks and error in dev mode
        return firstMatchingDefaults == null ? void 0 : firstMatchingDefaults.defaultOptions;
    }
    setMutationDefaults(mutationKey, options) {
        const result = this.mutationDefaults.find((x)=>(0, $iqz0v.hashQueryKey)(mutationKey) === (0, $iqz0v.hashQueryKey)(x.mutationKey));
        if (result) result.defaultOptions = options;
        else this.mutationDefaults.push({
            mutationKey: mutationKey,
            defaultOptions: options
        });
    }
    getMutationDefaults(mutationKey) {
        if (!mutationKey) return undefined;
         // Get the first matching defaults
        const firstMatchingDefaults = this.mutationDefaults.find((x)=>(0, $iqz0v.partialMatchKey)(mutationKey, x.mutationKey)); // Additional checks and error in dev mode
        return firstMatchingDefaults == null ? void 0 : firstMatchingDefaults.defaultOptions;
    }
    defaultQueryOptions(options) {
        if (options != null && options._defaulted) return options;
        const defaultedOptions = {
            ...this.defaultOptions.queries,
            ...this.getQueryDefaults(options == null ? void 0 : options.queryKey),
            ...options,
            _defaulted: true
        };
        if (!defaultedOptions.queryHash && defaultedOptions.queryKey) defaultedOptions.queryHash = (0, $iqz0v.hashQueryKeyByOptions)(defaultedOptions.queryKey, defaultedOptions);
         // dependent default values
        if (typeof defaultedOptions.refetchOnReconnect === "undefined") defaultedOptions.refetchOnReconnect = defaultedOptions.networkMode !== "always";
        if (typeof defaultedOptions.useErrorBoundary === "undefined") defaultedOptions.useErrorBoundary = !!defaultedOptions.suspense;
        return defaultedOptions;
    }
    defaultMutationOptions(options) {
        if (options != null && options._defaulted) return options;
        return {
            ...this.defaultOptions.mutations,
            ...this.getMutationDefaults(options == null ? void 0 : options.mutationKey),
            ...options,
            _defaulted: true
        };
    }
    clear() {
        this.queryCache.clear();
        this.mutationCache.clear();
    }
}


var $132jP = parcelRequire("132jP");
const $dbbaaaa9776b5bc0$var$QueryClientProviderInit = ({ children: children })=>{
    const queryClient = new (0, $e7a199e7d5aa71a2$export$405d0624ed55a03f)({
        defaultOptions: {
            queries: {
                retry: false,
                refetchOnWindowFocus: false
            }
        }
    });
    return /*#__PURE__*/ (0, $bibO8.jsx)((0, $132jP.QueryClientProvider), {
        client: queryClient,
        children: children
    });
};
var $dbbaaaa9776b5bc0$export$2e2bcd8739ae039 = $dbbaaaa9776b5bc0$var$QueryClientProviderInit;





var $4ffTz = parcelRequire("4ffTz");

const $a17ad7c83d142c5c$var$identityEnv = ()=>{
    const env = (0, $djcZD.getEnv)();
    switch(env){
        case "ddev":
            return "dev";
        case "stg":
            return "stg";
        case "prod":
            return "prod";
        default:
            return "dev";
    }
};
const $a17ad7c83d142c5c$var$accountClient = new (0, $bc67cb7158847227$export$1582a199dfd557d7)({
    identityEnvironment: $a17ad7c83d142c5c$var$identityEnv(),
    defaultContinueUrl: location.href,
    application: "manage-profile"
});
/**
 * This is a rendering entry point for siteless manage-profile app (aka new user settings).
 */ const $a17ad7c83d142c5c$var$UserSettingsAppContainer = (props)=>{
    (0, $1b86c45d2581ee88$export$2e2bcd8739ae039)({
        colorMode: "auto",
        spacing: "spacing",
        shape: "shape"
    });
    (0, $5b1e29b530174d83$export$2db4d14f7453cf8e)();
    const { analytics: analytics, store: store } = props;
    return /*#__PURE__*/ (0, $bibO8.jsx)((0, $l5OgO.default), {
        messagesConfig: (0, $f4905cdb01e57c84$export$2e2bcd8739ae039),
        children: /*#__PURE__*/ (0, $bibO8.jsx)((0, $98e49059712ea403$export$2e2bcd8739ae039), {
            analytics: analytics,
            children: /*#__PURE__*/ (0, $bibO8.jsx)((0, $hYcP6.default), {
                analytics: analytics,
                children: /*#__PURE__*/ (0, $bibO8.jsx)((0, $72LdD.default), {
                    store: store,
                    children: /*#__PURE__*/ (0, $bibO8.jsx)((0, $a2ca159e2f6e1426$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $bibO8.jsx)((0, $dbbaaaa9776b5bc0$export$2e2bcd8739ae039), {
                            children: /*#__PURE__*/ (0, $bibO8.jsx)((0, $9Rq8g.default), {
                                children: /*#__PURE__*/ (0, $bibO8.jsx)((0, $9lQ50.default), {
                                    children: /*#__PURE__*/ (0, $bibO8.jsx)((0, $cZlBJ.DeviceContextProvider), {
                                        children: /*#__PURE__*/ (0, $bibO8.jsx)($a17ad7c83d142c5c$var$NewAccountSwitchingExperienceProvider, {
                                            children: /*#__PURE__*/ (0, $bibO8.jsx)((0, $5Zreo.BrowserRouter), {
                                                children: /*#__PURE__*/ (0, $bibO8.jsx)((0, $7b3f00aad65df824$export$e338054fa926c14d), {
                                                    children: /*#__PURE__*/ (0, $bibO8.jsx)((0, $caabdc77a4649b11$export$2e2bcd8739ae039), {})
                                                })
                                            })
                                        })
                                    })
                                })
                            })
                        })
                    })
                })
            })
        })
    });
};
const $a17ad7c83d142c5c$var$NewAccountSwitchingExperienceProvider = ({ children: children })=>{
    const isJustInTimeSwitchingEnabled = (0, $4ffTz.checkFeatureGate)((0, $4ffTz.FeatureGate).ENABLE_JUST_IN_TIME_ACCOUNT_SWITCHER);
    return /*#__PURE__*/ (0, $bibO8.jsxs)((0, $154121f230ec2ebd$export$9c573e05c0f57a89), {
        client: $a17ad7c83d142c5c$var$accountClient,
        children: [
            isJustInTimeSwitchingEnabled && /*#__PURE__*/ (0, $bibO8.jsx)((0, $41455c10cf74c841$export$8ba4cf5ae331dcf6), {}),
            children
        ]
    });
};
var $a17ad7c83d142c5c$export$2e2bcd8739ae039 = $a17ad7c83d142c5c$var$UserSettingsAppContainer;





var $6plgC = parcelRequire("6plgC");
var $878e824edc615800$export$1e511d4a378977f5;
var $878e824edc615800$export$2e2bcd8739ae039;
"use strict";
$878e824edc615800$export$1e511d4a378977f5 = true;
function $878e824edc615800$var$createThunkMiddleware(extraArgument) {
    return function(_ref) {
        var dispatch = _ref.dispatch, getState = _ref.getState;
        return function(next) {
            return function(action) {
                if (typeof action === "function") return action(dispatch, getState, extraArgument);
                return next(action);
            };
        };
    };
}
var $878e824edc615800$var$thunk = $878e824edc615800$var$createThunkMiddleware();
$878e824edc615800$var$thunk.withExtraArgument = $878e824edc615800$var$createThunkMiddleware;
$878e824edc615800$export$2e2bcd8739ae039 = $878e824edc615800$var$thunk;


var $02faba4267f21aae$var$_typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
    return typeof obj;
} : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
function $02faba4267f21aae$export$2e2bcd8739ae039(value) {
    if (value !== null && (typeof value === "undefined" ? "undefined" : $02faba4267f21aae$var$_typeof(value)) === "object") return value && typeof value.then === "function";
    return false;
}


var $636186eb4234a8e8$var$_typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
    return typeof obj;
} : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
var $636186eb4234a8e8$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $636186eb4234a8e8$var$_slicedToArray = function() {
    function sliceIterator(arr, i) {
        var _arr = [];
        var _n = true;
        var _d = false;
        var _e = undefined;
        try {
            for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
                _arr.push(_s.value);
                if (i && _arr.length === i) break;
            }
        } catch (err) {
            _d = true;
            _e = err;
        } finally{
            try {
                if (!_n && _i["return"]) _i["return"]();
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
    return function(arr, i) {
        if (Array.isArray(arr)) return arr;
        else if (Symbol.iterator in Object(arr)) return sliceIterator(arr, i);
        else throw new TypeError("Invalid attempt to destructure non-iterable instance");
    };
}();
var $636186eb4234a8e8$export$aebb42912407fb2d = "PENDING";
var $636186eb4234a8e8$export$db6da4f66a5dc93d = "FULFILLED";
var $636186eb4234a8e8$export$83d3e3ad3e63df9c = "REJECTED";
var $636186eb4234a8e8$var$defaultTypes = [
    $636186eb4234a8e8$export$aebb42912407fb2d,
    $636186eb4234a8e8$export$db6da4f66a5dc93d,
    $636186eb4234a8e8$export$83d3e3ad3e63df9c
];
function $636186eb4234a8e8$export$2e2bcd8739ae039() {
    var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var promiseTypeSuffixes = config.promiseTypeSuffixes || $636186eb4234a8e8$var$defaultTypes;
    var promiseTypeSeparator = config.promiseTypeSeparator || "_";
    return function(ref) {
        var dispatch = ref.dispatch;
        return function(next) {
            return function(action) {
                if (action.payload) {
                    if (!(0, $02faba4267f21aae$export$2e2bcd8739ae039)(action.payload) && !(0, $02faba4267f21aae$export$2e2bcd8739ae039)(action.payload.promise)) return next(action);
                } else return next(action);
                // Deconstruct the properties of the original action object to constants
                var type = action.type, payload = action.payload, meta = action.meta;
                // Assign values for promise type suffixes
                var _promiseTypeSuffixes = $636186eb4234a8e8$var$_slicedToArray(promiseTypeSuffixes, 3), _PENDING = _promiseTypeSuffixes[0], _FULFILLED = _promiseTypeSuffixes[1], _REJECTED = _promiseTypeSuffixes[2];
                /**
         * @function getAction
         * @description Utility function for creating a rejected or fulfilled
         * flux standard action object.
         * @param {boolean} Is the action rejected?
         * @returns {object} action
         */ var getAction = function getAction(newPayload, isRejected) {
                    return $636186eb4234a8e8$var$_extends({
                        type: [
                            type,
                            isRejected ? _REJECTED : _FULFILLED
                        ].join(promiseTypeSeparator)
                    }, newPayload === null || typeof newPayload === "undefined" ? {} : {
                        payload: newPayload
                    }, meta !== undefined ? {
                        meta: meta
                    } : {}, isRejected ? {
                        error: true
                    } : {});
                };
                /**
         * Assign values for promise and data variables. In the case the payload
         * is an object with a `promise` and `data` property, the values of those
         * properties will be used. In the case the payload is a promise, the
         * value of the payload will be used and data will be null.
         */ var promise = void 0;
                var data = void 0;
                if (!(0, $02faba4267f21aae$export$2e2bcd8739ae039)(action.payload) && $636186eb4234a8e8$var$_typeof(action.payload) === "object") {
                    promise = payload.promise;
                    data = payload.data;
                } else {
                    promise = payload;
                    data = undefined;
                }
                /**
         * First, dispatch the pending action. This flux standard action object
         * describes the pending state of a promise and will include any data
         * (for optimistic updates) and/or meta from the original action.
         */ next($636186eb4234a8e8$var$_extends({
                    type: [
                        type,
                        _PENDING
                    ].join(promiseTypeSeparator)
                }, data !== undefined ? {
                    payload: data
                } : {}, meta !== undefined ? {
                    meta: meta
                } : {}));
                /*
         * @function handleReject
         * @description Dispatch the rejected action and return
         * an error object. The error object is the original error
         * that was thrown. The user of the library is responsible for
         * best practices in ensure that they are throwing an Error object.
         * @params reason The reason the promise was rejected
         * @returns {object}
         */ var handleReject = function handleReject(reason) {
                    var rejectedAction = getAction(reason, true);
                    dispatch(rejectedAction);
                    throw reason;
                };
                /*
         * @function handleFulfill
         * @description Dispatch the fulfilled action and
         * return the success object. The success object should
         * contain the value and the dispatched action.
         * @param value The value the promise was resloved with
         * @returns {object}
         */ var handleFulfill = function handleFulfill() {
                    var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
                    var resolvedAction = getAction(value, false);
                    dispatch(resolvedAction);
                    return {
                        value: value,
                        action: resolvedAction
                    };
                };
                /**
         * Second, dispatch a rejected or fulfilled action. This flux standard
         * action object will describe the resolved state of the promise. In
         * the case of a rejected promise, it will include an `error` property.
         *
         * In order to allow proper chaining of actions using `then`, a new
         * promise is constructed and returned. This promise will resolve
         * with two properties: (1) the value (if fulfilled) or reason
         * (if rejected) and (2) the flux standard action.
         *
         * Rejected object:
         * {
         *   reason: ...
         *   action: {
         *     error: true,
         *     type: 'ACTION_REJECTED',
         *     payload: ...
         *   }
         * }
         *
         * Fulfilled object:
         * {
         *   value: ...
         *   action: {
         *     type: 'ACTION_FULFILLED',
         *     payload: ...
         *   }
         * }
         */ return promise.then(handleFulfill, handleReject);
            };
        };
    };
}


var $f3a74e8019f98387$export$1e511d4a378977f5;
var $f3a74e8019f98387$export$d32324a03b6bde1b;
var $f3a74e8019f98387$export$321b1ffcca858b2b;
"use strict";

var $6plgC = parcelRequire("6plgC");
var $f3a74e8019f98387$require$compose = $6plgC.compose;
$f3a74e8019f98387$export$1e511d4a378977f5 = true;
$f3a74e8019f98387$export$d32324a03b6bde1b = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : function() {
    if (arguments.length === 0) return undefined;
    if (typeof arguments[0] === "object") return $f3a74e8019f98387$require$compose;
    return $f3a74e8019f98387$require$compose.apply(null, arguments);
};
$f3a74e8019f98387$export$321b1ffcca858b2b = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__ : function() {
    return function(noop) {
        return noop;
    };
};



var $6plgC = parcelRequire("6plgC");

var $h1RRU = parcelRequire("h1RRU");

var $3kXiv = parcelRequire("3kXiv");

var $4rjyH = parcelRequire("4rjyH");

var $9b2OC = parcelRequire("9b2OC");
const $9944915457036097$var$intialState = {
    isSaving: false,
    errors: {}
};
function $9944915457036097$var$extractFieldErrorsFromMessage(message) {
    const errors = {};
    Object.keys(message.fieldErrors).forEach((key)=>{
        errors[key] = message.fieldErrors[key][0];
    });
    if (message.formErrors) errors.form = message.formErrors[0];
    return errors;
}
var $9944915457036097$export$2e2bcd8739ae039 = (state = $9944915457036097$var$intialState, action)=>{
    switch(action.type){
        case `${0, $9b2OC.UPDATE_PASSWORD}_PENDING`:
            return {
                ...state,
                isSaving: true,
                errors: {}
            };
        case `${0, $9b2OC.UPDATE_PASSWORD}_FULFILLED`:
            return {
                ...state,
                isSaving: false
            };
        case `${0, $9b2OC.UPDATE_PASSWORD}_REJECTED`:
            return {
                ...state,
                isSaving: false,
                errors: $9944915457036097$var$extractFieldErrorsFromMessage(action.payload)
            };
        default:
            return state;
    }
};



var $eDBap = parcelRequire("eDBap");

var $9JXtK = parcelRequire("9JXtK");
const $a2bebfa28fa7bb46$export$370c541e8c4358a6 = ()=>{
    return (0, $6plgC.combineReducers)({
        user: (0, $h1RRU.default),
        flags: (0, $3kXiv.default),
        // Profile settings
        profileEmail: (0, $4rjyH.default),
        profileSettingsPassword: (0, $9944915457036097$export$2e2bcd8739ae039),
        connectedApps: (0, $eDBap.default),
        lpUserPreferences: (0, $9JXtK.default)
    });
};
var $a2bebfa28fa7bb46$export$2e2bcd8739ae039 = $a2bebfa28fa7bb46$export$370c541e8c4358a6;


var $a06d536959cb86af$export$2e2bcd8739ae039 = ()=>{
    // ======================================================
    // Middleware Configuration
    // ======================================================
    const middleware = [
        (0, $878e824edc615800$export$2e2bcd8739ae039),
        (0, $636186eb4234a8e8$export$2e2bcd8739ae039)()
    ];
    // ======================================================
    // Store Instantiation and HMR Setup
    // ======================================================
    const store = (0, $6plgC.createStore)((0, $a2bebfa28fa7bb46$export$2e2bcd8739ae039)(), {}, (0, $f3a74e8019f98387$export$d32324a03b6bde1b)((0, $6plgC.applyMiddleware)(...middleware)));
    return store;
};



var $djcZD = parcelRequire("djcZD");
const $40141866e6ecdb95$var$env = (0, $djcZD.getEnv)();
if ($40141866e6ecdb95$var$env === "prod" || $40141866e6ecdb95$var$env === "stg") {
    const SENTRY_PROJECT_KEY = "0f1ab734a2224e33bd8d1710e9eb5aaa";
    const SENTRY_PROJECT_ID = "6717816";
    (0, $77YRX.installSentry)({
        dsn: `https://${SENTRY_PROJECT_KEY}@o55978.ingest.sentry.io/${SENTRY_PROJECT_ID}`,
        version: "404bf65f795e7e45c518f46bdeb15a0d8d3a6a3f-6179-2025-04-28",
        env: $40141866e6ecdb95$var$env
    });
} else if ((0, $djcZD.isFedRamp)()) {
    const SENTRY_PROJECT_KEY = "e9f88d5249c97aadd98a08a48a7fa50b";
    const SENTRY_PROJECT_ID = "21";
    (0, $77YRX.installSentry)({
        // https://hello.atlassian.net/wiki/spaces/OBSERVABILITY/pages/3370131692/Sentry+FedRAMP+-+Getting+Started#Sentry-DSN-in-FedRAMP
        dsn: `https://${SENTRY_PROJECT_KEY}@sentry.atlassian-us-gov-mod.com/${SENTRY_PROJECT_ID}`,
        version: "404bf65f795e7e45c518f46bdeb15a0d8d3a6a3f-6179-2025-04-28",
        env: $40141866e6ecdb95$var$env
    });
}
const $40141866e6ecdb95$var$store = (0, $a06d536959cb86af$export$2e2bcd8739ae039)();
const $40141866e6ecdb95$var$analytics = (0, $jLJT8.getAnalyticsClient)($40141866e6ecdb95$var$store);
const $40141866e6ecdb95$var$MOUNT_NODE = document.getElementById("root");
if ($40141866e6ecdb95$var$MOUNT_NODE === null) throw new Error("Could not find HTMLElement to mount react app");
const $40141866e6ecdb95$var$root = (0, $e2247254f7ec34f2$export$882461b6382ed46c)($40141866e6ecdb95$var$MOUNT_NODE);
const $40141866e6ecdb95$var$render = (App = (0, $a17ad7c83d142c5c$export$2e2bcd8739ae039))=>{
    $40141866e6ecdb95$var$root.render(/*#__PURE__*/ (0, $bibO8.jsx)(App, {
        store: $40141866e6ecdb95$var$store,
        analytics: $40141866e6ecdb95$var$analytics
    }));
    (0, $ae2108313eafd9b1$export$7cf313435eb9a801)($40141866e6ecdb95$var$analytics);
};
const $40141866e6ecdb95$var$onLoginCheckOrRedirectSuccess = ({ redirectToLogin: redirectToLogin })=>{
    if (redirectToLogin) redirectToLogin();
    else $40141866e6ecdb95$var$render();
};
const $40141866e6ecdb95$var$renderErrorPage = (error)=>{
    if (error.response && error.response.status !== 401) (0, $77YRX.logException)(error, "Error fetching user info early (IDAC).");
    $40141866e6ecdb95$var$root.render(/*#__PURE__*/ (0, $bibO8.jsx)((0, $7pLec.GenericErrorPage), {}));
};
(0, $iyr2L.requestLoginCheckOrRedirect)((0, $fCHnn.userInfoProvider).get()).then($40141866e6ecdb95$var$onLoginCheckOrRedirectSuccess).catch((error)=>$40141866e6ecdb95$var$renderErrorPage(error));
$40141866e6ecdb95$var$render();


//# sourceMappingURL=index.31f4f8f9.js.map
